function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}
var $parcel$global =
typeof globalThis !== 'undefined'
  ? globalThis
  : typeof self !== 'undefined'
  ? self
  : typeof window !== 'undefined'
  ? window
  : typeof global !== 'undefined'
  ? global
  : {};
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}
function $parcel$exportWildcard(dest, source) {
  Object.keys(source).forEach(function(key) {
    if (key === 'default' || key === '__esModule' || dest.hasOwnProperty(key)) {
      return;
    }

    Object.defineProperty(dest, key, {
      enumerable: true,
      get: function get() {
        return source[key];
      }
    });
  });

  return dest;
}
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequireb723"];
if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequireb723"] = parcelRequire;
}
parcelRequire.register("0qhf8", function(module, exports) {

$parcel$export(module.exports, "Fragment", function () { return $0014624a040e5105$export$ffb0004e005737fa; }, function (v) { return $0014624a040e5105$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "jsx", function () { return $0014624a040e5105$export$34b9dba7ce09269b; }, function (v) { return $0014624a040e5105$export$34b9dba7ce09269b = v; });
$parcel$export(module.exports, "jsxs", function () { return $0014624a040e5105$export$25062201e9e25d76; }, function (v) { return $0014624a040e5105$export$25062201e9e25d76 = v; });
/** @license React v17.0.2
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $0014624a040e5105$export$ffb0004e005737fa;
var $0014624a040e5105$export$34b9dba7ce09269b;
var $0014624a040e5105$export$25062201e9e25d76;
"use strict";
parcelRequire("4yvvI");

var $bh6RR = parcelRequire("bh6RR");
var $0014624a040e5105$var$g = 60103;
$0014624a040e5105$export$ffb0004e005737fa = 60107;
if ("function" === typeof Symbol && Symbol.for) {
    var $0014624a040e5105$var$h = Symbol.for;
    $0014624a040e5105$var$g = $0014624a040e5105$var$h("react.element");
    $0014624a040e5105$export$ffb0004e005737fa = $0014624a040e5105$var$h("react.fragment");
}
var $0014624a040e5105$var$m = $bh6RR.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, $0014624a040e5105$var$n = Object.prototype.hasOwnProperty, $0014624a040e5105$var$p = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $0014624a040e5105$var$q(c, a, k) {
    var b, d = {}, e = null, l = null;
    void 0 !== k && (e = "" + k);
    void 0 !== a.key && (e = "" + a.key);
    void 0 !== a.ref && (l = a.ref);
    for(b in a)$0014624a040e5105$var$n.call(a, b) && !$0014624a040e5105$var$p.hasOwnProperty(b) && (d[b] = a[b]);
    if (c && c.defaultProps) for(b in a = c.defaultProps, a)void 0 === d[b] && (d[b] = a[b]);
    return {
        $$typeof: $0014624a040e5105$var$g,
        type: c,
        key: e,
        ref: l,
        props: d,
        _owner: $0014624a040e5105$var$m.current
    };
}
$0014624a040e5105$export$34b9dba7ce09269b = $0014624a040e5105$var$q;
$0014624a040e5105$export$25062201e9e25d76 = $0014624a040e5105$var$q;

});
parcelRequire.register("4yvvI", function(module, exports) {
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/ "use strict";
/* eslint-disable no-unused-vars */ var $3512c7c00a4083d8$var$getOwnPropertySymbols = Object.getOwnPropertySymbols;
var $3512c7c00a4083d8$var$hasOwnProperty = Object.prototype.hasOwnProperty;
var $3512c7c00a4083d8$var$propIsEnumerable = Object.prototype.propertyIsEnumerable;
function $3512c7c00a4083d8$var$toObject(val) {
    if (val === null || val === undefined) throw new TypeError("Object.assign cannot be called with null or undefined");
    return Object(val);
}
function $3512c7c00a4083d8$var$shouldUseNative() {
    try {
        if (!Object.assign) return false;
        // Detect buggy property enumeration order in older V8 versions.
        // https://bugs.chromium.org/p/v8/issues/detail?id=4118
        var test1 = new String("abc"); // eslint-disable-line no-new-wrappers
        test1[5] = "de";
        if (Object.getOwnPropertyNames(test1)[0] === "5") return false;
        // https://bugs.chromium.org/p/v8/issues/detail?id=3056
        var test2 = {};
        for(var i = 0; i < 10; i++)test2["_" + String.fromCharCode(i)] = i;
        var order2 = Object.getOwnPropertyNames(test2).map(function(n) {
            return test2[n];
        });
        if (order2.join("") !== "0123456789") return false;
        // https://bugs.chromium.org/p/v8/issues/detail?id=3056
        var test3 = {};
        "abcdefghijklmnopqrst".split("").forEach(function(letter) {
            test3[letter] = letter;
        });
        if (Object.keys(Object.assign({}, test3)).join("") !== "abcdefghijklmnopqrst") return false;
        return true;
    } catch (err) {
        // We don't expect any of the above to throw, but better to be safe.
        return false;
    }
}
module.exports = $3512c7c00a4083d8$var$shouldUseNative() ? Object.assign : function(target, source) {
    var from;
    var to = $3512c7c00a4083d8$var$toObject(target);
    var symbols;
    for(var s = 1; s < arguments.length; s++){
        from = Object(arguments[s]);
        for(var key in from)if ($3512c7c00a4083d8$var$hasOwnProperty.call(from, key)) to[key] = from[key];
        if ($3512c7c00a4083d8$var$getOwnPropertySymbols) {
            symbols = $3512c7c00a4083d8$var$getOwnPropertySymbols(from);
            for(var i = 0; i < symbols.length; i++)if ($3512c7c00a4083d8$var$propIsEnumerable.call(from, symbols[i])) to[symbols[i]] = from[symbols[i]];
        }
    }
    return to;
};

});

parcelRequire.register("bh6RR", function(module, exports) {
"use strict";

module.exports = (parcelRequire("cCfq4"));

});
parcelRequire.register("cCfq4", function(module, exports) {

$parcel$export(module.exports, "Fragment", function () { return $92f4fea5bc247620$export$ffb0004e005737fa; }, function (v) { return $92f4fea5bc247620$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "StrictMode", function () { return $92f4fea5bc247620$export$5f8d39834fd61797; }, function (v) { return $92f4fea5bc247620$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Profiler", function () { return $92f4fea5bc247620$export$e2c29f18771995cb; }, function (v) { return $92f4fea5bc247620$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "Suspense", function () { return $92f4fea5bc247620$export$74bf444e3cd11ea5; }, function (v) { return $92f4fea5bc247620$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "Children", function () { return $92f4fea5bc247620$export$dca3b0875bd9a954; }, function (v) { return $92f4fea5bc247620$export$dca3b0875bd9a954 = v; });
$parcel$export(module.exports, "Component", function () { return $92f4fea5bc247620$export$16fa2f45be04daa8; }, function (v) { return $92f4fea5bc247620$export$16fa2f45be04daa8 = v; });
$parcel$export(module.exports, "PureComponent", function () { return $92f4fea5bc247620$export$221d75b3f55bb0bd; }, function (v) { return $92f4fea5bc247620$export$221d75b3f55bb0bd = v; });
$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", function () { return $92f4fea5bc247620$export$ae55be85d98224ed; }, function (v) { return $92f4fea5bc247620$export$ae55be85d98224ed = v; });
$parcel$export(module.exports, "cloneElement", function () { return $92f4fea5bc247620$export$e530037191fcd5d7; }, function (v) { return $92f4fea5bc247620$export$e530037191fcd5d7 = v; });
$parcel$export(module.exports, "createContext", function () { return $92f4fea5bc247620$export$fd42f52fd3ae1109; }, function (v) { return $92f4fea5bc247620$export$fd42f52fd3ae1109 = v; });
$parcel$export(module.exports, "createElement", function () { return $92f4fea5bc247620$export$c8a8987d4410bf2d; }, function (v) { return $92f4fea5bc247620$export$c8a8987d4410bf2d = v; });
$parcel$export(module.exports, "createFactory", function () { return $92f4fea5bc247620$export$d38cd72104c1f0e9; }, function (v) { return $92f4fea5bc247620$export$d38cd72104c1f0e9 = v; });
$parcel$export(module.exports, "createRef", function () { return $92f4fea5bc247620$export$7d1e3a5e95ceca43; }, function (v) { return $92f4fea5bc247620$export$7d1e3a5e95ceca43 = v; });
$parcel$export(module.exports, "forwardRef", function () { return $92f4fea5bc247620$export$257a8862b851cb5b; }, function (v) { return $92f4fea5bc247620$export$257a8862b851cb5b = v; });
$parcel$export(module.exports, "isValidElement", function () { return $92f4fea5bc247620$export$a8257692ac88316c; }, function (v) { return $92f4fea5bc247620$export$a8257692ac88316c = v; });
$parcel$export(module.exports, "lazy", function () { return $92f4fea5bc247620$export$488013bae63b21da; }, function (v) { return $92f4fea5bc247620$export$488013bae63b21da = v; });
$parcel$export(module.exports, "memo", function () { return $92f4fea5bc247620$export$7c73462e0d25e514; }, function (v) { return $92f4fea5bc247620$export$7c73462e0d25e514 = v; });
$parcel$export(module.exports, "useCallback", function () { return $92f4fea5bc247620$export$35808ee640e87ca7; }, function (v) { return $92f4fea5bc247620$export$35808ee640e87ca7 = v; });
$parcel$export(module.exports, "useContext", function () { return $92f4fea5bc247620$export$fae74005e78b1a27; }, function (v) { return $92f4fea5bc247620$export$fae74005e78b1a27 = v; });
$parcel$export(module.exports, "useDebugValue", function () { return $92f4fea5bc247620$export$dc8fbce3eb94dc1e; }, function (v) { return $92f4fea5bc247620$export$dc8fbce3eb94dc1e = v; });
$parcel$export(module.exports, "useEffect", function () { return $92f4fea5bc247620$export$6d9c69b0de29b591; }, function (v) { return $92f4fea5bc247620$export$6d9c69b0de29b591 = v; });
$parcel$export(module.exports, "useImperativeHandle", function () { return $92f4fea5bc247620$export$d5a552a76deda3c2; }, function (v) { return $92f4fea5bc247620$export$d5a552a76deda3c2 = v; });
$parcel$export(module.exports, "useLayoutEffect", function () { return $92f4fea5bc247620$export$e5c5a5f917a5871c; }, function (v) { return $92f4fea5bc247620$export$e5c5a5f917a5871c = v; });
$parcel$export(module.exports, "useMemo", function () { return $92f4fea5bc247620$export$1538c33de8887b59; }, function (v) { return $92f4fea5bc247620$export$1538c33de8887b59 = v; });
$parcel$export(module.exports, "useReducer", function () { return $92f4fea5bc247620$export$13e3392192263954; }, function (v) { return $92f4fea5bc247620$export$13e3392192263954 = v; });
$parcel$export(module.exports, "useRef", function () { return $92f4fea5bc247620$export$b8f5890fc79d6aca; }, function (v) { return $92f4fea5bc247620$export$b8f5890fc79d6aca = v; });
$parcel$export(module.exports, "useState", function () { return $92f4fea5bc247620$export$60241385465d0a34; }, function (v) { return $92f4fea5bc247620$export$60241385465d0a34 = v; });
$parcel$export(module.exports, "version", function () { return $92f4fea5bc247620$export$83d89fbfd8236492; }, function (v) { return $92f4fea5bc247620$export$83d89fbfd8236492 = v; });
/** @license React v17.0.2
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $92f4fea5bc247620$export$ffb0004e005737fa;
var $92f4fea5bc247620$export$5f8d39834fd61797;
var $92f4fea5bc247620$export$e2c29f18771995cb;
var $92f4fea5bc247620$export$74bf444e3cd11ea5;
var $92f4fea5bc247620$export$dca3b0875bd9a954;
var $92f4fea5bc247620$export$16fa2f45be04daa8;
var $92f4fea5bc247620$export$221d75b3f55bb0bd;
var $92f4fea5bc247620$export$ae55be85d98224ed;
var $92f4fea5bc247620$export$e530037191fcd5d7;
var $92f4fea5bc247620$export$fd42f52fd3ae1109;
var $92f4fea5bc247620$export$c8a8987d4410bf2d;
var $92f4fea5bc247620$export$d38cd72104c1f0e9;
var $92f4fea5bc247620$export$7d1e3a5e95ceca43;
var $92f4fea5bc247620$export$257a8862b851cb5b;
var $92f4fea5bc247620$export$a8257692ac88316c;
var $92f4fea5bc247620$export$488013bae63b21da;
var $92f4fea5bc247620$export$7c73462e0d25e514;
var $92f4fea5bc247620$export$35808ee640e87ca7;
var $92f4fea5bc247620$export$fae74005e78b1a27;
var $92f4fea5bc247620$export$dc8fbce3eb94dc1e;
var $92f4fea5bc247620$export$6d9c69b0de29b591;
var $92f4fea5bc247620$export$d5a552a76deda3c2;
var $92f4fea5bc247620$export$e5c5a5f917a5871c;
var $92f4fea5bc247620$export$1538c33de8887b59;
var $92f4fea5bc247620$export$13e3392192263954;
var $92f4fea5bc247620$export$b8f5890fc79d6aca;
var $92f4fea5bc247620$export$60241385465d0a34;
var $92f4fea5bc247620$export$83d89fbfd8236492;
"use strict";

var $4yvvI = parcelRequire("4yvvI");
var $92f4fea5bc247620$var$n = 60103, $92f4fea5bc247620$var$p = 60106;
$92f4fea5bc247620$export$ffb0004e005737fa = 60107;
$92f4fea5bc247620$export$5f8d39834fd61797 = 60108;
$92f4fea5bc247620$export$e2c29f18771995cb = 60114;
var $92f4fea5bc247620$var$q = 60109, $92f4fea5bc247620$var$r = 60110, $92f4fea5bc247620$var$t = 60112;
$92f4fea5bc247620$export$74bf444e3cd11ea5 = 60113;
var $92f4fea5bc247620$var$u = 60115, $92f4fea5bc247620$var$v = 60116;
if ("function" === typeof Symbol && Symbol.for) {
    var $92f4fea5bc247620$var$w = Symbol.for;
    $92f4fea5bc247620$var$n = $92f4fea5bc247620$var$w("react.element");
    $92f4fea5bc247620$var$p = $92f4fea5bc247620$var$w("react.portal");
    $92f4fea5bc247620$export$ffb0004e005737fa = $92f4fea5bc247620$var$w("react.fragment");
    $92f4fea5bc247620$export$5f8d39834fd61797 = $92f4fea5bc247620$var$w("react.strict_mode");
    $92f4fea5bc247620$export$e2c29f18771995cb = $92f4fea5bc247620$var$w("react.profiler");
    $92f4fea5bc247620$var$q = $92f4fea5bc247620$var$w("react.provider");
    $92f4fea5bc247620$var$r = $92f4fea5bc247620$var$w("react.context");
    $92f4fea5bc247620$var$t = $92f4fea5bc247620$var$w("react.forward_ref");
    $92f4fea5bc247620$export$74bf444e3cd11ea5 = $92f4fea5bc247620$var$w("react.suspense");
    $92f4fea5bc247620$var$u = $92f4fea5bc247620$var$w("react.memo");
    $92f4fea5bc247620$var$v = $92f4fea5bc247620$var$w("react.lazy");
}
var $92f4fea5bc247620$var$x = "function" === typeof Symbol && Symbol.iterator;
function $92f4fea5bc247620$var$y(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $92f4fea5bc247620$var$x && a[$92f4fea5bc247620$var$x] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
function $92f4fea5bc247620$var$z(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var $92f4fea5bc247620$var$A = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, $92f4fea5bc247620$var$B = {};
function $92f4fea5bc247620$var$C(a, b, c) {
    this.props = a;
    this.context = b;
    this.refs = $92f4fea5bc247620$var$B;
    this.updater = c || $92f4fea5bc247620$var$A;
}
$92f4fea5bc247620$var$C.prototype.isReactComponent = {};
$92f4fea5bc247620$var$C.prototype.setState = function(a, b) {
    if ("object" !== typeof a && "function" !== typeof a && null != a) throw Error($92f4fea5bc247620$var$z(85));
    this.updater.enqueueSetState(this, a, b, "setState");
};
$92f4fea5bc247620$var$C.prototype.forceUpdate = function(a) {
    this.updater.enqueueForceUpdate(this, a, "forceUpdate");
};
function $92f4fea5bc247620$var$D() {}
$92f4fea5bc247620$var$D.prototype = $92f4fea5bc247620$var$C.prototype;
function $92f4fea5bc247620$var$E(a, b, c) {
    this.props = a;
    this.context = b;
    this.refs = $92f4fea5bc247620$var$B;
    this.updater = c || $92f4fea5bc247620$var$A;
}
var $92f4fea5bc247620$var$F = $92f4fea5bc247620$var$E.prototype = new $92f4fea5bc247620$var$D;
$92f4fea5bc247620$var$F.constructor = $92f4fea5bc247620$var$E;
$4yvvI($92f4fea5bc247620$var$F, $92f4fea5bc247620$var$C.prototype);
$92f4fea5bc247620$var$F.isPureReactComponent = !0;
var $92f4fea5bc247620$var$G = {
    current: null
}, $92f4fea5bc247620$var$H = Object.prototype.hasOwnProperty, $92f4fea5bc247620$var$I = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $92f4fea5bc247620$var$J(a, b, c) {
    var e, d = {}, k = null, h = null;
    if (null != b) for(e in void 0 !== b.ref && (h = b.ref), void 0 !== b.key && (k = "" + b.key), b)$92f4fea5bc247620$var$H.call(b, e) && !$92f4fea5bc247620$var$I.hasOwnProperty(e) && (d[e] = b[e]);
    var g = arguments.length - 2;
    if (1 === g) d.children = c;
    else if (1 < g) {
        for(var f = Array(g), m = 0; m < g; m++)f[m] = arguments[m + 2];
        d.children = f;
    }
    if (a && a.defaultProps) for(e in g = a.defaultProps, g)void 0 === d[e] && (d[e] = g[e]);
    return {
        $$typeof: $92f4fea5bc247620$var$n,
        type: a,
        key: k,
        ref: h,
        props: d,
        _owner: $92f4fea5bc247620$var$G.current
    };
}
function $92f4fea5bc247620$var$K(a, b) {
    return {
        $$typeof: $92f4fea5bc247620$var$n,
        type: a.type,
        key: b,
        ref: a.ref,
        props: a.props,
        _owner: a._owner
    };
}
function $92f4fea5bc247620$var$L(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $92f4fea5bc247620$var$n;
}
function $92f4fea5bc247620$var$escape(a) {
    var b = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + a.replace(/[=:]/g, function(a) {
        return b[a];
    });
}
var $92f4fea5bc247620$var$M = /\/+/g;
function $92f4fea5bc247620$var$N(a, b) {
    return "object" === typeof a && null !== a && null != a.key ? $92f4fea5bc247620$var$escape("" + a.key) : b.toString(36);
}
function $92f4fea5bc247620$var$O(a, b, c, e, d) {
    var k = typeof a;
    if ("undefined" === k || "boolean" === k) a = null;
    var h = !1;
    if (null === a) h = !0;
    else switch(k){
        case "string":
        case "number":
            h = !0;
            break;
        case "object":
            switch(a.$$typeof){
                case $92f4fea5bc247620$var$n:
                case $92f4fea5bc247620$var$p:
                    h = !0;
            }
    }
    if (h) return h = a, d = d(h), a = "" === e ? "." + $92f4fea5bc247620$var$N(h, 0) : e, Array.isArray(d) ? (c = "", null != a && (c = a.replace($92f4fea5bc247620$var$M, "$&/") + "/"), $92f4fea5bc247620$var$O(d, b, c, "", function(a) {
        return a;
    })) : null != d && ($92f4fea5bc247620$var$L(d) && (d = $92f4fea5bc247620$var$K(d, c + (!d.key || h && h.key === d.key ? "" : ("" + d.key).replace($92f4fea5bc247620$var$M, "$&/") + "/") + a)), b.push(d)), 1;
    h = 0;
    e = "" === e ? "." : e + ":";
    if (Array.isArray(a)) for(var g = 0; g < a.length; g++){
        k = a[g];
        var f = e + $92f4fea5bc247620$var$N(k, g);
        h += $92f4fea5bc247620$var$O(k, b, c, f, d);
    }
    else if (f = $92f4fea5bc247620$var$y(a), "function" === typeof f) for(a = f.call(a), g = 0; !(k = a.next()).done;)k = k.value, f = e + $92f4fea5bc247620$var$N(k, g++), h += $92f4fea5bc247620$var$O(k, b, c, f, d);
    else if ("object" === k) throw b = "" + a, Error($92f4fea5bc247620$var$z(31, "[object Object]" === b ? "object with keys {" + Object.keys(a).join(", ") + "}" : b));
    return h;
}
function $92f4fea5bc247620$var$P(a, b, c) {
    if (null == a) return a;
    var e = [], d = 0;
    $92f4fea5bc247620$var$O(a, e, "", "", function(a) {
        return b.call(c, a, d++);
    });
    return e;
}
function $92f4fea5bc247620$var$Q(a) {
    if (-1 === a._status) {
        var b = a._result;
        b = b();
        a._status = 0;
        a._result = b;
        b.then(function(b) {
            0 === a._status && (b = b.default, a._status = 1, a._result = b);
        }, function(b) {
            0 === a._status && (a._status = 2, a._result = b);
        });
    }
    if (1 === a._status) return a._result;
    throw a._result;
}
var $92f4fea5bc247620$var$R = {
    current: null
};
function $92f4fea5bc247620$var$S() {
    var a = $92f4fea5bc247620$var$R.current;
    if (null === a) throw Error($92f4fea5bc247620$var$z(321));
    return a;
}
var $92f4fea5bc247620$var$T = {
    ReactCurrentDispatcher: $92f4fea5bc247620$var$R,
    ReactCurrentBatchConfig: {
        transition: 0
    },
    ReactCurrentOwner: $92f4fea5bc247620$var$G,
    IsSomeRendererActing: {
        current: !1
    },
    assign: $4yvvI
};
$92f4fea5bc247620$export$dca3b0875bd9a954 = {
    map: $92f4fea5bc247620$var$P,
    forEach: function(a, b, c) {
        $92f4fea5bc247620$var$P(a, function() {
            b.apply(this, arguments);
        }, c);
    },
    count: function(a) {
        var b = 0;
        $92f4fea5bc247620$var$P(a, function() {
            b++;
        });
        return b;
    },
    toArray: function(a) {
        return $92f4fea5bc247620$var$P(a, function(a) {
            return a;
        }) || [];
    },
    only: function(a) {
        if (!$92f4fea5bc247620$var$L(a)) throw Error($92f4fea5bc247620$var$z(143));
        return a;
    }
};
$92f4fea5bc247620$export$16fa2f45be04daa8 = $92f4fea5bc247620$var$C;
$92f4fea5bc247620$export$221d75b3f55bb0bd = $92f4fea5bc247620$var$E;
$92f4fea5bc247620$export$ae55be85d98224ed = $92f4fea5bc247620$var$T;
$92f4fea5bc247620$export$e530037191fcd5d7 = function(a, b, c) {
    if (null === a || void 0 === a) throw Error($92f4fea5bc247620$var$z(267, a));
    var e = $4yvvI({}, a.props), d = a.key, k = a.ref, h = a._owner;
    if (null != b) {
        void 0 !== b.ref && (k = b.ref, h = $92f4fea5bc247620$var$G.current);
        void 0 !== b.key && (d = "" + b.key);
        if (a.type && a.type.defaultProps) var g = a.type.defaultProps;
        for(f in b)$92f4fea5bc247620$var$H.call(b, f) && !$92f4fea5bc247620$var$I.hasOwnProperty(f) && (e[f] = void 0 === b[f] && void 0 !== g ? g[f] : b[f]);
    }
    var f = arguments.length - 2;
    if (1 === f) e.children = c;
    else if (1 < f) {
        g = Array(f);
        for(var m = 0; m < f; m++)g[m] = arguments[m + 2];
        e.children = g;
    }
    return {
        $$typeof: $92f4fea5bc247620$var$n,
        type: a.type,
        key: d,
        ref: k,
        props: e,
        _owner: h
    };
};
$92f4fea5bc247620$export$fd42f52fd3ae1109 = function(a, b) {
    void 0 === b && (b = null);
    a = {
        $$typeof: $92f4fea5bc247620$var$r,
        _calculateChangedBits: b,
        _currentValue: a,
        _currentValue2: a,
        _threadCount: 0,
        Provider: null,
        Consumer: null
    };
    a.Provider = {
        $$typeof: $92f4fea5bc247620$var$q,
        _context: a
    };
    return a.Consumer = a;
};
$92f4fea5bc247620$export$c8a8987d4410bf2d = $92f4fea5bc247620$var$J;
$92f4fea5bc247620$export$d38cd72104c1f0e9 = function(a) {
    var b = $92f4fea5bc247620$var$J.bind(null, a);
    b.type = a;
    return b;
};
$92f4fea5bc247620$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$92f4fea5bc247620$export$257a8862b851cb5b = function(a) {
    return {
        $$typeof: $92f4fea5bc247620$var$t,
        render: a
    };
};
$92f4fea5bc247620$export$a8257692ac88316c = $92f4fea5bc247620$var$L;
$92f4fea5bc247620$export$488013bae63b21da = function(a) {
    return {
        $$typeof: $92f4fea5bc247620$var$v,
        _payload: {
            _status: -1,
            _result: a
        },
        _init: $92f4fea5bc247620$var$Q
    };
};
$92f4fea5bc247620$export$7c73462e0d25e514 = function(a, b) {
    return {
        $$typeof: $92f4fea5bc247620$var$u,
        type: a,
        compare: void 0 === b ? null : b
    };
};
$92f4fea5bc247620$export$35808ee640e87ca7 = function(a, b) {
    return $92f4fea5bc247620$var$S().useCallback(a, b);
};
$92f4fea5bc247620$export$fae74005e78b1a27 = function(a, b) {
    return $92f4fea5bc247620$var$S().useContext(a, b);
};
$92f4fea5bc247620$export$dc8fbce3eb94dc1e = function() {};
$92f4fea5bc247620$export$6d9c69b0de29b591 = function(a, b) {
    return $92f4fea5bc247620$var$S().useEffect(a, b);
};
$92f4fea5bc247620$export$d5a552a76deda3c2 = function(a, b, c) {
    return $92f4fea5bc247620$var$S().useImperativeHandle(a, b, c);
};
$92f4fea5bc247620$export$e5c5a5f917a5871c = function(a, b) {
    return $92f4fea5bc247620$var$S().useLayoutEffect(a, b);
};
$92f4fea5bc247620$export$1538c33de8887b59 = function(a, b) {
    return $92f4fea5bc247620$var$S().useMemo(a, b);
};
$92f4fea5bc247620$export$13e3392192263954 = function(a, b, c) {
    return $92f4fea5bc247620$var$S().useReducer(a, b, c);
};
$92f4fea5bc247620$export$b8f5890fc79d6aca = function(a) {
    return $92f4fea5bc247620$var$S().useRef(a);
};
$92f4fea5bc247620$export$60241385465d0a34 = function(a) {
    return $92f4fea5bc247620$var$S().useState(a);
};
$92f4fea5bc247620$export$83d89fbfd8236492 = "17.0.2";

});



parcelRequire.register("foRq4", function(module, exports) {

$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", function () { return $b36288e2db101ba3$export$ae55be85d98224ed; }, function (v) { return $b36288e2db101ba3$export$ae55be85d98224ed = v; });
$parcel$export(module.exports, "createPortal", function () { return $b36288e2db101ba3$export$d39a5bbd09211389; }, function (v) { return $b36288e2db101ba3$export$d39a5bbd09211389 = v; });
$parcel$export(module.exports, "findDOMNode", function () { return $b36288e2db101ba3$export$466bfc07425424d5; }, function (v) { return $b36288e2db101ba3$export$466bfc07425424d5 = v; });
$parcel$export(module.exports, "flushSync", function () { return $b36288e2db101ba3$export$cd75ccfd720a3cd4; }, function (v) { return $b36288e2db101ba3$export$cd75ccfd720a3cd4 = v; });
$parcel$export(module.exports, "hydrate", function () { return $b36288e2db101ba3$export$fa8d919ba61d84db; }, function (v) { return $b36288e2db101ba3$export$fa8d919ba61d84db = v; });
$parcel$export(module.exports, "render", function () { return $b36288e2db101ba3$export$b3890eb0ae9dca99; }, function (v) { return $b36288e2db101ba3$export$b3890eb0ae9dca99 = v; });
$parcel$export(module.exports, "unmountComponentAtNode", function () { return $b36288e2db101ba3$export$502457920280e6be; }, function (v) { return $b36288e2db101ba3$export$502457920280e6be = v; });
$parcel$export(module.exports, "unstable_batchedUpdates", function () { return $b36288e2db101ba3$export$c78a37762a8d58e1; }, function (v) { return $b36288e2db101ba3$export$c78a37762a8d58e1 = v; });
$parcel$export(module.exports, "unstable_createPortal", function () { return $b36288e2db101ba3$export$2577ef5d2565d52f; }, function (v) { return $b36288e2db101ba3$export$2577ef5d2565d52f = v; });
$parcel$export(module.exports, "unstable_renderSubtreeIntoContainer", function () { return $b36288e2db101ba3$export$dc54d992c10e8a18; }, function (v) { return $b36288e2db101ba3$export$dc54d992c10e8a18 = v; });
$parcel$export(module.exports, "version", function () { return $b36288e2db101ba3$export$83d89fbfd8236492; }, function (v) { return $b36288e2db101ba3$export$83d89fbfd8236492 = v; });
/** @license React v17.0.2
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ var $b36288e2db101ba3$export$ae55be85d98224ed;
var $b36288e2db101ba3$export$d39a5bbd09211389;
var $b36288e2db101ba3$export$466bfc07425424d5;
var $b36288e2db101ba3$export$cd75ccfd720a3cd4;
var $b36288e2db101ba3$export$fa8d919ba61d84db;
var $b36288e2db101ba3$export$b3890eb0ae9dca99;
var $b36288e2db101ba3$export$502457920280e6be;
var $b36288e2db101ba3$export$c78a37762a8d58e1;
var $b36288e2db101ba3$export$2577ef5d2565d52f;
var $b36288e2db101ba3$export$dc54d992c10e8a18;
var $b36288e2db101ba3$export$83d89fbfd8236492;
"use strict";

var $bh6RR = parcelRequire("bh6RR");

var $4yvvI = parcelRequire("4yvvI");

var $4LCdk = parcelRequire("4LCdk");
function $b36288e2db101ba3$var$y(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
if (!$bh6RR) throw Error($b36288e2db101ba3$var$y(227));
var $b36288e2db101ba3$var$ba = new Set, $b36288e2db101ba3$var$ca = {};
function $b36288e2db101ba3$var$da(a, b) {
    $b36288e2db101ba3$var$ea(a, b);
    $b36288e2db101ba3$var$ea(a + "Capture", b);
}
function $b36288e2db101ba3$var$ea(a, b) {
    $b36288e2db101ba3$var$ca[a] = b;
    for(a = 0; a < b.length; a++)$b36288e2db101ba3$var$ba.add(b[a]);
}
var $b36288e2db101ba3$var$fa = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), $b36288e2db101ba3$var$ha = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, $b36288e2db101ba3$var$ia = Object.prototype.hasOwnProperty, $b36288e2db101ba3$var$ja = {}, $b36288e2db101ba3$var$ka = {};
function $b36288e2db101ba3$var$la(a) {
    if ($b36288e2db101ba3$var$ia.call($b36288e2db101ba3$var$ka, a)) return !0;
    if ($b36288e2db101ba3$var$ia.call($b36288e2db101ba3$var$ja, a)) return !1;
    if ($b36288e2db101ba3$var$ha.test(a)) return $b36288e2db101ba3$var$ka[a] = !0;
    $b36288e2db101ba3$var$ja[a] = !0;
    return !1;
}
function $b36288e2db101ba3$var$ma(a, b, c, d) {
    if (null !== c && 0 === c.type) return !1;
    switch(typeof b){
        case "function":
        case "symbol":
            return !0;
        case "boolean":
            if (d) return !1;
            if (null !== c) return !c.acceptsBooleans;
            a = a.toLowerCase().slice(0, 5);
            return "data-" !== a && "aria-" !== a;
        default:
            return !1;
    }
}
function $b36288e2db101ba3$var$na(a, b, c, d) {
    if (null === b || "undefined" === typeof b || $b36288e2db101ba3$var$ma(a, b, c, d)) return !0;
    if (d) return !1;
    if (null !== c) switch(c.type){
        case 3:
            return !b;
        case 4:
            return !1 === b;
        case 5:
            return isNaN(b);
        case 6:
            return isNaN(b) || 1 > b;
    }
    return !1;
}
function $b36288e2db101ba3$var$B(a, b, c, d, e, f, g) {
    this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
    this.attributeName = d;
    this.attributeNamespace = e;
    this.mustUseProperty = c;
    this.propertyName = a;
    this.type = b;
    this.sanitizeURL = f;
    this.removeEmptyString = g;
}
var $b36288e2db101ba3$var$D = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a) {
    $b36288e2db101ba3$var$D[a] = new $b36288e2db101ba3$var$B(a, 0, !1, a, null, !1, !1);
});
[
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "className",
        "class"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ]
].forEach(function(a) {
    var b = a[0];
    $b36288e2db101ba3$var$D[b] = new $b36288e2db101ba3$var$B(b, 1, !1, a[1], null, !1, !1);
});
[
    "contentEditable",
    "draggable",
    "spellCheck",
    "value"
].forEach(function(a) {
    $b36288e2db101ba3$var$D[a] = new $b36288e2db101ba3$var$B(a, 2, !1, a.toLowerCase(), null, !1, !1);
});
[
    "autoReverse",
    "externalResourcesRequired",
    "focusable",
    "preserveAlpha"
].forEach(function(a) {
    $b36288e2db101ba3$var$D[a] = new $b36288e2db101ba3$var$B(a, 2, !1, a, null, !1, !1);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a) {
    $b36288e2db101ba3$var$D[a] = new $b36288e2db101ba3$var$B(a, 3, !1, a.toLowerCase(), null, !1, !1);
});
[
    "checked",
    "multiple",
    "muted",
    "selected"
].forEach(function(a) {
    $b36288e2db101ba3$var$D[a] = new $b36288e2db101ba3$var$B(a, 3, !0, a, null, !1, !1);
});
[
    "capture",
    "download"
].forEach(function(a) {
    $b36288e2db101ba3$var$D[a] = new $b36288e2db101ba3$var$B(a, 4, !1, a, null, !1, !1);
});
[
    "cols",
    "rows",
    "size",
    "span"
].forEach(function(a) {
    $b36288e2db101ba3$var$D[a] = new $b36288e2db101ba3$var$B(a, 6, !1, a, null, !1, !1);
});
[
    "rowSpan",
    "start"
].forEach(function(a) {
    $b36288e2db101ba3$var$D[a] = new $b36288e2db101ba3$var$B(a, 5, !1, a.toLowerCase(), null, !1, !1);
});
var $b36288e2db101ba3$var$oa = /[\-:]([a-z])/g;
function $b36288e2db101ba3$var$pa(a) {
    return a[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a) {
    var b = a.replace($b36288e2db101ba3$var$oa, $b36288e2db101ba3$var$pa);
    $b36288e2db101ba3$var$D[b] = new $b36288e2db101ba3$var$B(b, 1, !1, a, null, !1, !1);
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a) {
    var b = a.replace($b36288e2db101ba3$var$oa, $b36288e2db101ba3$var$pa);
    $b36288e2db101ba3$var$D[b] = new $b36288e2db101ba3$var$B(b, 1, !1, a, "http://www.w3.org/1999/xlink", !1, !1);
});
[
    "xml:base",
    "xml:lang",
    "xml:space"
].forEach(function(a) {
    var b = a.replace($b36288e2db101ba3$var$oa, $b36288e2db101ba3$var$pa);
    $b36288e2db101ba3$var$D[b] = new $b36288e2db101ba3$var$B(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace", !1, !1);
});
[
    "tabIndex",
    "crossOrigin"
].forEach(function(a) {
    $b36288e2db101ba3$var$D[a] = new $b36288e2db101ba3$var$B(a, 1, !1, a.toLowerCase(), null, !1, !1);
});
$b36288e2db101ba3$var$D.xlinkHref = new $b36288e2db101ba3$var$B("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1);
[
    "src",
    "href",
    "action",
    "formAction"
].forEach(function(a) {
    $b36288e2db101ba3$var$D[a] = new $b36288e2db101ba3$var$B(a, 1, !1, a.toLowerCase(), null, !0, !0);
});
function $b36288e2db101ba3$var$qa(a, b, c, d) {
    var e = $b36288e2db101ba3$var$D.hasOwnProperty(b) ? $b36288e2db101ba3$var$D[b] : null;
    var f = null !== e ? 0 === e.type : d ? !1 : !(2 < b.length) || "o" !== b[0] && "O" !== b[0] || "n" !== b[1] && "N" !== b[1] ? !1 : !0;
    f || ($b36288e2db101ba3$var$na(b, c, e, d) && (c = null), d || null === e ? $b36288e2db101ba3$var$la(b) && (null === c ? a.removeAttribute(b) : a.setAttribute(b, "" + c)) : e.mustUseProperty ? a[e.propertyName] = null === c ? 3 === e.type ? !1 : "" : c : (b = e.attributeName, d = e.attributeNamespace, null === c ? a.removeAttribute(b) : (e = e.type, c = 3 === e || 4 === e && !0 === c ? "" : "" + c, d ? a.setAttributeNS(d, b, c) : a.setAttribute(b, c))));
}
var $b36288e2db101ba3$var$ra = $bh6RR.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, $b36288e2db101ba3$var$sa = 60103, $b36288e2db101ba3$var$ta = 60106, $b36288e2db101ba3$var$ua = 60107, $b36288e2db101ba3$var$wa = 60108, $b36288e2db101ba3$var$xa = 60114, $b36288e2db101ba3$var$ya = 60109, $b36288e2db101ba3$var$za = 60110, $b36288e2db101ba3$var$Aa = 60112, $b36288e2db101ba3$var$Ba = 60113, $b36288e2db101ba3$var$Ca = 60120, $b36288e2db101ba3$var$Da = 60115, $b36288e2db101ba3$var$Ea = 60116, $b36288e2db101ba3$var$Fa = 60121, $b36288e2db101ba3$var$Ga = 60128, $b36288e2db101ba3$var$Ha = 60129, $b36288e2db101ba3$var$Ia = 60130, $b36288e2db101ba3$var$Ja = 60131;
if ("function" === typeof Symbol && Symbol.for) {
    var $b36288e2db101ba3$var$E = Symbol.for;
    $b36288e2db101ba3$var$sa = $b36288e2db101ba3$var$E("react.element");
    $b36288e2db101ba3$var$ta = $b36288e2db101ba3$var$E("react.portal");
    $b36288e2db101ba3$var$ua = $b36288e2db101ba3$var$E("react.fragment");
    $b36288e2db101ba3$var$wa = $b36288e2db101ba3$var$E("react.strict_mode");
    $b36288e2db101ba3$var$xa = $b36288e2db101ba3$var$E("react.profiler");
    $b36288e2db101ba3$var$ya = $b36288e2db101ba3$var$E("react.provider");
    $b36288e2db101ba3$var$za = $b36288e2db101ba3$var$E("react.context");
    $b36288e2db101ba3$var$Aa = $b36288e2db101ba3$var$E("react.forward_ref");
    $b36288e2db101ba3$var$Ba = $b36288e2db101ba3$var$E("react.suspense");
    $b36288e2db101ba3$var$Ca = $b36288e2db101ba3$var$E("react.suspense_list");
    $b36288e2db101ba3$var$Da = $b36288e2db101ba3$var$E("react.memo");
    $b36288e2db101ba3$var$Ea = $b36288e2db101ba3$var$E("react.lazy");
    $b36288e2db101ba3$var$Fa = $b36288e2db101ba3$var$E("react.block");
    $b36288e2db101ba3$var$E("react.scope");
    $b36288e2db101ba3$var$Ga = $b36288e2db101ba3$var$E("react.opaque.id");
    $b36288e2db101ba3$var$Ha = $b36288e2db101ba3$var$E("react.debug_trace_mode");
    $b36288e2db101ba3$var$Ia = $b36288e2db101ba3$var$E("react.offscreen");
    $b36288e2db101ba3$var$Ja = $b36288e2db101ba3$var$E("react.legacy_hidden");
}
var $b36288e2db101ba3$var$Ka = "function" === typeof Symbol && Symbol.iterator;
function $b36288e2db101ba3$var$La(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $b36288e2db101ba3$var$Ka && a[$b36288e2db101ba3$var$Ka] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $b36288e2db101ba3$var$Ma;
function $b36288e2db101ba3$var$Na(a) {
    if (void 0 === $b36288e2db101ba3$var$Ma) try {
        throw Error();
    } catch (c) {
        var b = c.stack.trim().match(/\n( *(at )?)/);
        $b36288e2db101ba3$var$Ma = b && b[1] || "";
    }
    return "\n" + $b36288e2db101ba3$var$Ma + a;
}
var $b36288e2db101ba3$var$Oa = !1;
function $b36288e2db101ba3$var$Pa(a, b) {
    if (!a || $b36288e2db101ba3$var$Oa) return "";
    $b36288e2db101ba3$var$Oa = !0;
    var c = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        if (b) {
            if (b = function() {
                throw Error();
            }, Object.defineProperty(b.prototype, "props", {
                set: function() {
                    throw Error();
                }
            }), "object" === typeof Reflect && Reflect.construct) {
                try {
                    Reflect.construct(b, []);
                } catch (k) {
                    var d = k;
                }
                Reflect.construct(a, [], b);
            } else {
                try {
                    b.call();
                } catch (k) {
                    d = k;
                }
                a.call(b.prototype);
            }
        } else {
            try {
                throw Error();
            } catch (k) {
                d = k;
            }
            a();
        }
    } catch (k) {
        if (k && d && "string" === typeof k.stack) {
            for(var e = k.stack.split("\n"), f = d.stack.split("\n"), g = e.length - 1, h = f.length - 1; 1 <= g && 0 <= h && e[g] !== f[h];)h--;
            for(; 1 <= g && 0 <= h; g--, h--)if (e[g] !== f[h]) {
                if (1 !== g || 1 !== h) {
                    do if (g--, h--, 0 > h || e[g] !== f[h]) return "\n" + e[g].replace(" at new ", " at ");
                    while (1 <= g && 0 <= h);
                }
                break;
            }
        }
    } finally{
        $b36288e2db101ba3$var$Oa = !1, Error.prepareStackTrace = c;
    }
    return (a = a ? a.displayName || a.name : "") ? $b36288e2db101ba3$var$Na(a) : "";
}
function $b36288e2db101ba3$var$Qa(a) {
    switch(a.tag){
        case 5:
            return $b36288e2db101ba3$var$Na(a.type);
        case 16:
            return $b36288e2db101ba3$var$Na("Lazy");
        case 13:
            return $b36288e2db101ba3$var$Na("Suspense");
        case 19:
            return $b36288e2db101ba3$var$Na("SuspenseList");
        case 0:
        case 2:
        case 15:
            return a = $b36288e2db101ba3$var$Pa(a.type, !1), a;
        case 11:
            return a = $b36288e2db101ba3$var$Pa(a.type.render, !1), a;
        case 22:
            return a = $b36288e2db101ba3$var$Pa(a.type._render, !1), a;
        case 1:
            return a = $b36288e2db101ba3$var$Pa(a.type, !0), a;
        default:
            return "";
    }
}
function $b36288e2db101ba3$var$Ra(a) {
    if (null == a) return null;
    if ("function" === typeof a) return a.displayName || a.name || null;
    if ("string" === typeof a) return a;
    switch(a){
        case $b36288e2db101ba3$var$ua:
            return "Fragment";
        case $b36288e2db101ba3$var$ta:
            return "Portal";
        case $b36288e2db101ba3$var$xa:
            return "Profiler";
        case $b36288e2db101ba3$var$wa:
            return "StrictMode";
        case $b36288e2db101ba3$var$Ba:
            return "Suspense";
        case $b36288e2db101ba3$var$Ca:
            return "SuspenseList";
    }
    if ("object" === typeof a) switch(a.$$typeof){
        case $b36288e2db101ba3$var$za:
            return (a.displayName || "Context") + ".Consumer";
        case $b36288e2db101ba3$var$ya:
            return (a._context.displayName || "Context") + ".Provider";
        case $b36288e2db101ba3$var$Aa:
            var b = a.render;
            b = b.displayName || b.name || "";
            return a.displayName || ("" !== b ? "ForwardRef(" + b + ")" : "ForwardRef");
        case $b36288e2db101ba3$var$Da:
            return $b36288e2db101ba3$var$Ra(a.type);
        case $b36288e2db101ba3$var$Fa:
            return $b36288e2db101ba3$var$Ra(a._render);
        case $b36288e2db101ba3$var$Ea:
            b = a._payload;
            a = a._init;
            try {
                return $b36288e2db101ba3$var$Ra(a(b));
            } catch (c) {}
    }
    return null;
}
function $b36288e2db101ba3$var$Sa(a) {
    switch(typeof a){
        case "boolean":
        case "number":
        case "object":
        case "string":
        case "undefined":
            return a;
        default:
            return "";
    }
}
function $b36288e2db101ba3$var$Ta(a) {
    var b = a.type;
    return (a = a.nodeName) && "input" === a.toLowerCase() && ("checkbox" === b || "radio" === b);
}
function $b36288e2db101ba3$var$Ua(a) {
    var b = $b36288e2db101ba3$var$Ta(a) ? "checked" : "value", c = Object.getOwnPropertyDescriptor(a.constructor.prototype, b), d = "" + a[b];
    if (!a.hasOwnProperty(b) && "undefined" !== typeof c && "function" === typeof c.get && "function" === typeof c.set) {
        var e = c.get, f = c.set;
        Object.defineProperty(a, b, {
            configurable: !0,
            get: function() {
                return e.call(this);
            },
            set: function(a) {
                d = "" + a;
                f.call(this, a);
            }
        });
        Object.defineProperty(a, b, {
            enumerable: c.enumerable
        });
        return {
            getValue: function() {
                return d;
            },
            setValue: function(a) {
                d = "" + a;
            },
            stopTracking: function() {
                a._valueTracker = null;
                delete a[b];
            }
        };
    }
}
function $b36288e2db101ba3$var$Va(a) {
    a._valueTracker || (a._valueTracker = $b36288e2db101ba3$var$Ua(a));
}
function $b36288e2db101ba3$var$Wa(a) {
    if (!a) return !1;
    var b = a._valueTracker;
    if (!b) return !0;
    var c = b.getValue();
    var d = "";
    a && (d = $b36288e2db101ba3$var$Ta(a) ? a.checked ? "true" : "false" : a.value);
    a = d;
    return a !== c ? (b.setValue(a), !0) : !1;
}
function $b36288e2db101ba3$var$Xa(a) {
    a = a || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof a) return null;
    try {
        return a.activeElement || a.body;
    } catch (b) {
        return a.body;
    }
}
function $b36288e2db101ba3$var$Ya(a, b) {
    var c = b.checked;
    return $4yvvI({}, b, {
        defaultChecked: void 0,
        defaultValue: void 0,
        value: void 0,
        checked: null != c ? c : a._wrapperState.initialChecked
    });
}
function $b36288e2db101ba3$var$Za(a, b) {
    var c = null == b.defaultValue ? "" : b.defaultValue, d = null != b.checked ? b.checked : b.defaultChecked;
    c = $b36288e2db101ba3$var$Sa(null != b.value ? b.value : c);
    a._wrapperState = {
        initialChecked: d,
        initialValue: c,
        controlled: "checkbox" === b.type || "radio" === b.type ? null != b.checked : null != b.value
    };
}
function $b36288e2db101ba3$var$$a(a, b) {
    b = b.checked;
    null != b && $b36288e2db101ba3$var$qa(a, "checked", b, !1);
}
function $b36288e2db101ba3$var$ab(a, b) {
    $b36288e2db101ba3$var$$a(a, b);
    var c = $b36288e2db101ba3$var$Sa(b.value), d = b.type;
    if (null != c) {
        if ("number" === d) {
            if (0 === c && "" === a.value || a.value != c) a.value = "" + c;
        } else a.value !== "" + c && (a.value = "" + c);
    } else if ("submit" === d || "reset" === d) {
        a.removeAttribute("value");
        return;
    }
    b.hasOwnProperty("value") ? $b36288e2db101ba3$var$bb(a, b.type, c) : b.hasOwnProperty("defaultValue") && $b36288e2db101ba3$var$bb(a, b.type, $b36288e2db101ba3$var$Sa(b.defaultValue));
    null == b.checked && null != b.defaultChecked && (a.defaultChecked = !!b.defaultChecked);
}
function $b36288e2db101ba3$var$cb(a, b, c) {
    if (b.hasOwnProperty("value") || b.hasOwnProperty("defaultValue")) {
        var d = b.type;
        if (!("submit" !== d && "reset" !== d || void 0 !== b.value && null !== b.value)) return;
        b = "" + a._wrapperState.initialValue;
        c || b === a.value || (a.value = b);
        a.defaultValue = b;
    }
    c = a.name;
    "" !== c && (a.name = "");
    a.defaultChecked = !!a._wrapperState.initialChecked;
    "" !== c && (a.name = c);
}
function $b36288e2db101ba3$var$bb(a, b, c) {
    if ("number" !== b || $b36288e2db101ba3$var$Xa(a.ownerDocument) !== a) null == c ? a.defaultValue = "" + a._wrapperState.initialValue : a.defaultValue !== "" + c && (a.defaultValue = "" + c);
}
function $b36288e2db101ba3$var$db(a) {
    var b = "";
    $bh6RR.Children.forEach(a, function(a) {
        null != a && (b += a);
    });
    return b;
}
function $b36288e2db101ba3$var$eb(a, b) {
    a = $4yvvI({
        children: void 0
    }, b);
    if (b = $b36288e2db101ba3$var$db(b.children)) a.children = b;
    return a;
}
function $b36288e2db101ba3$var$fb(a, b, c, d) {
    a = a.options;
    if (b) {
        b = {};
        for(var e = 0; e < c.length; e++)b["$" + c[e]] = !0;
        for(c = 0; c < a.length; c++)e = b.hasOwnProperty("$" + a[c].value), a[c].selected !== e && (a[c].selected = e), e && d && (a[c].defaultSelected = !0);
    } else {
        c = "" + $b36288e2db101ba3$var$Sa(c);
        b = null;
        for(e = 0; e < a.length; e++){
            if (a[e].value === c) {
                a[e].selected = !0;
                d && (a[e].defaultSelected = !0);
                return;
            }
            null !== b || a[e].disabled || (b = a[e]);
        }
        null !== b && (b.selected = !0);
    }
}
function $b36288e2db101ba3$var$gb(a, b) {
    if (null != b.dangerouslySetInnerHTML) throw Error($b36288e2db101ba3$var$y(91));
    return $4yvvI({}, b, {
        value: void 0,
        defaultValue: void 0,
        children: "" + a._wrapperState.initialValue
    });
}
function $b36288e2db101ba3$var$hb(a, b) {
    var c = b.value;
    if (null == c) {
        c = b.children;
        b = b.defaultValue;
        if (null != c) {
            if (null != b) throw Error($b36288e2db101ba3$var$y(92));
            if (Array.isArray(c)) {
                if (!(1 >= c.length)) throw Error($b36288e2db101ba3$var$y(93));
                c = c[0];
            }
            b = c;
        }
        null == b && (b = "");
        c = b;
    }
    a._wrapperState = {
        initialValue: $b36288e2db101ba3$var$Sa(c)
    };
}
function $b36288e2db101ba3$var$ib(a, b) {
    var c = $b36288e2db101ba3$var$Sa(b.value), d = $b36288e2db101ba3$var$Sa(b.defaultValue);
    null != c && (c = "" + c, c !== a.value && (a.value = c), null == b.defaultValue && a.defaultValue !== c && (a.defaultValue = c));
    null != d && (a.defaultValue = "" + d);
}
function $b36288e2db101ba3$var$jb(a) {
    var b = a.textContent;
    b === a._wrapperState.initialValue && "" !== b && null !== b && (a.value = b);
}
var $b36288e2db101ba3$var$kb = {
    html: "http://www.w3.org/1999/xhtml",
    mathml: "http://www.w3.org/1998/Math/MathML",
    svg: "http://www.w3.org/2000/svg"
};
function $b36288e2db101ba3$var$lb(a) {
    switch(a){
        case "svg":
            return "http://www.w3.org/2000/svg";
        case "math":
            return "http://www.w3.org/1998/Math/MathML";
        default:
            return "http://www.w3.org/1999/xhtml";
    }
}
function $b36288e2db101ba3$var$mb(a, b) {
    return null == a || "http://www.w3.org/1999/xhtml" === a ? $b36288e2db101ba3$var$lb(b) : "http://www.w3.org/2000/svg" === a && "foreignObject" === b ? "http://www.w3.org/1999/xhtml" : a;
}
var $b36288e2db101ba3$var$nb, $b36288e2db101ba3$var$ob = function(a) {
    return "undefined" !== typeof MSApp && MSApp.execUnsafeLocalFunction ? function(b, c, d, e) {
        MSApp.execUnsafeLocalFunction(function() {
            return a(b, c, d, e);
        });
    } : a;
}(function(a, b) {
    if (a.namespaceURI !== $b36288e2db101ba3$var$kb.svg || "innerHTML" in a) a.innerHTML = b;
    else {
        $b36288e2db101ba3$var$nb = $b36288e2db101ba3$var$nb || document.createElement("div");
        $b36288e2db101ba3$var$nb.innerHTML = "<svg>" + b.valueOf().toString() + "</svg>";
        for(b = $b36288e2db101ba3$var$nb.firstChild; a.firstChild;)a.removeChild(a.firstChild);
        for(; b.firstChild;)a.appendChild(b.firstChild);
    }
});
function $b36288e2db101ba3$var$pb(a, b) {
    if (b) {
        var c = a.firstChild;
        if (c && c === a.lastChild && 3 === c.nodeType) {
            c.nodeValue = b;
            return;
        }
    }
    a.textContent = b;
}
var $b36288e2db101ba3$var$qb = {
    animationIterationCount: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
}, $b36288e2db101ba3$var$rb = [
    "Webkit",
    "ms",
    "Moz",
    "O"
];
Object.keys($b36288e2db101ba3$var$qb).forEach(function(a) {
    $b36288e2db101ba3$var$rb.forEach(function(b) {
        b = b + a.charAt(0).toUpperCase() + a.substring(1);
        $b36288e2db101ba3$var$qb[b] = $b36288e2db101ba3$var$qb[a];
    });
});
function $b36288e2db101ba3$var$sb(a, b, c) {
    return null == b || "boolean" === typeof b || "" === b ? "" : c || "number" !== typeof b || 0 === b || $b36288e2db101ba3$var$qb.hasOwnProperty(a) && $b36288e2db101ba3$var$qb[a] ? ("" + b).trim() : b + "px";
}
function $b36288e2db101ba3$var$tb(a, b) {
    a = a.style;
    for(var c in b)if (b.hasOwnProperty(c)) {
        var d = 0 === c.indexOf("--"), e = $b36288e2db101ba3$var$sb(c, b[c], d);
        "float" === c && (c = "cssFloat");
        d ? a.setProperty(c, e) : a[c] = e;
    }
}
var $b36288e2db101ba3$var$ub = $4yvvI({
    menuitem: !0
}, {
    area: !0,
    base: !0,
    br: !0,
    col: !0,
    embed: !0,
    hr: !0,
    img: !0,
    input: !0,
    keygen: !0,
    link: !0,
    meta: !0,
    param: !0,
    source: !0,
    track: !0,
    wbr: !0
});
function $b36288e2db101ba3$var$vb(a, b) {
    if (b) {
        if ($b36288e2db101ba3$var$ub[a] && (null != b.children || null != b.dangerouslySetInnerHTML)) throw Error($b36288e2db101ba3$var$y(137, a));
        if (null != b.dangerouslySetInnerHTML) {
            if (null != b.children) throw Error($b36288e2db101ba3$var$y(60));
            if (!("object" === typeof b.dangerouslySetInnerHTML && "__html" in b.dangerouslySetInnerHTML)) throw Error($b36288e2db101ba3$var$y(61));
        }
        if (null != b.style && "object" !== typeof b.style) throw Error($b36288e2db101ba3$var$y(62));
    }
}
function $b36288e2db101ba3$var$wb(a, b) {
    if (-1 === a.indexOf("-")) return "string" === typeof b.is;
    switch(a){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
function $b36288e2db101ba3$var$xb(a) {
    a = a.target || a.srcElement || window;
    a.correspondingUseElement && (a = a.correspondingUseElement);
    return 3 === a.nodeType ? a.parentNode : a;
}
var $b36288e2db101ba3$var$yb = null, $b36288e2db101ba3$var$zb = null, $b36288e2db101ba3$var$Ab = null;
function $b36288e2db101ba3$var$Bb(a) {
    if (a = $b36288e2db101ba3$var$Cb(a)) {
        if ("function" !== typeof $b36288e2db101ba3$var$yb) throw Error($b36288e2db101ba3$var$y(280));
        var b = a.stateNode;
        b && (b = $b36288e2db101ba3$var$Db(b), $b36288e2db101ba3$var$yb(a.stateNode, a.type, b));
    }
}
function $b36288e2db101ba3$var$Eb(a) {
    $b36288e2db101ba3$var$zb ? $b36288e2db101ba3$var$Ab ? $b36288e2db101ba3$var$Ab.push(a) : $b36288e2db101ba3$var$Ab = [
        a
    ] : $b36288e2db101ba3$var$zb = a;
}
function $b36288e2db101ba3$var$Fb() {
    if ($b36288e2db101ba3$var$zb) {
        var a = $b36288e2db101ba3$var$zb, b = $b36288e2db101ba3$var$Ab;
        $b36288e2db101ba3$var$Ab = $b36288e2db101ba3$var$zb = null;
        $b36288e2db101ba3$var$Bb(a);
        if (b) for(a = 0; a < b.length; a++)$b36288e2db101ba3$var$Bb(b[a]);
    }
}
function $b36288e2db101ba3$var$Gb(a, b) {
    return a(b);
}
function $b36288e2db101ba3$var$Hb(a, b, c, d, e) {
    return a(b, c, d, e);
}
function $b36288e2db101ba3$var$Ib() {}
var $b36288e2db101ba3$var$Jb = $b36288e2db101ba3$var$Gb, $b36288e2db101ba3$var$Kb = !1, $b36288e2db101ba3$var$Lb = !1;
function $b36288e2db101ba3$var$Mb() {
    if (null !== $b36288e2db101ba3$var$zb || null !== $b36288e2db101ba3$var$Ab) $b36288e2db101ba3$var$Ib(), $b36288e2db101ba3$var$Fb();
}
function $b36288e2db101ba3$var$Nb(a, b, c) {
    if ($b36288e2db101ba3$var$Lb) return a(b, c);
    $b36288e2db101ba3$var$Lb = !0;
    try {
        return $b36288e2db101ba3$var$Jb(a, b, c);
    } finally{
        $b36288e2db101ba3$var$Lb = !1, $b36288e2db101ba3$var$Mb();
    }
}
function $b36288e2db101ba3$var$Ob(a, b) {
    var c = a.stateNode;
    if (null === c) return null;
    var d = $b36288e2db101ba3$var$Db(c);
    if (null === d) return null;
    c = d[b];
    a: switch(b){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (d = !d.disabled) || (a = a.type, d = !("button" === a || "input" === a || "select" === a || "textarea" === a));
            a = !d;
            break a;
        default:
            a = !1;
    }
    if (a) return null;
    if (c && "function" !== typeof c) throw Error($b36288e2db101ba3$var$y(231, b, typeof c));
    return c;
}
var $b36288e2db101ba3$var$Pb = !1;
if ($b36288e2db101ba3$var$fa) try {
    var $b36288e2db101ba3$var$Qb = {};
    Object.defineProperty($b36288e2db101ba3$var$Qb, "passive", {
        get: function() {
            $b36288e2db101ba3$var$Pb = !0;
        }
    });
    window.addEventListener("test", $b36288e2db101ba3$var$Qb, $b36288e2db101ba3$var$Qb);
    window.removeEventListener("test", $b36288e2db101ba3$var$Qb, $b36288e2db101ba3$var$Qb);
} catch (a) {
    $b36288e2db101ba3$var$Pb = !1;
}
function $b36288e2db101ba3$var$Rb(a, b, c, d, e, f, g, h, k) {
    var l = Array.prototype.slice.call(arguments, 3);
    try {
        b.apply(c, l);
    } catch (n) {
        this.onError(n);
    }
}
var $b36288e2db101ba3$var$Sb = !1, $b36288e2db101ba3$var$Tb = null, $b36288e2db101ba3$var$Ub = !1, $b36288e2db101ba3$var$Vb = null, $b36288e2db101ba3$var$Wb = {
    onError: function(a) {
        $b36288e2db101ba3$var$Sb = !0;
        $b36288e2db101ba3$var$Tb = a;
    }
};
function $b36288e2db101ba3$var$Xb(a, b, c, d, e, f, g, h, k) {
    $b36288e2db101ba3$var$Sb = !1;
    $b36288e2db101ba3$var$Tb = null;
    $b36288e2db101ba3$var$Rb.apply($b36288e2db101ba3$var$Wb, arguments);
}
function $b36288e2db101ba3$var$Yb(a, b, c, d, e, f, g, h, k) {
    $b36288e2db101ba3$var$Xb.apply(this, arguments);
    if ($b36288e2db101ba3$var$Sb) {
        if ($b36288e2db101ba3$var$Sb) {
            var l = $b36288e2db101ba3$var$Tb;
            $b36288e2db101ba3$var$Sb = !1;
            $b36288e2db101ba3$var$Tb = null;
        } else throw Error($b36288e2db101ba3$var$y(198));
        $b36288e2db101ba3$var$Ub || ($b36288e2db101ba3$var$Ub = !0, $b36288e2db101ba3$var$Vb = l);
    }
}
function $b36288e2db101ba3$var$Zb(a) {
    var b = a, c = a;
    if (a.alternate) for(; b.return;)b = b.return;
    else {
        a = b;
        do b = a, 0 !== (b.flags & 1026) && (c = b.return), a = b.return;
        while (a);
    }
    return 3 === b.tag ? c : null;
}
function $b36288e2db101ba3$var$$b(a) {
    if (13 === a.tag) {
        var b = a.memoizedState;
        null === b && (a = a.alternate, null !== a && (b = a.memoizedState));
        if (null !== b) return b.dehydrated;
    }
    return null;
}
function $b36288e2db101ba3$var$ac(a) {
    if ($b36288e2db101ba3$var$Zb(a) !== a) throw Error($b36288e2db101ba3$var$y(188));
}
function $b36288e2db101ba3$var$bc(a) {
    var b = a.alternate;
    if (!b) {
        b = $b36288e2db101ba3$var$Zb(a);
        if (null === b) throw Error($b36288e2db101ba3$var$y(188));
        return b !== a ? null : a;
    }
    for(var c = a, d = b;;){
        var e = c.return;
        if (null === e) break;
        var f = e.alternate;
        if (null === f) {
            d = e.return;
            if (null !== d) {
                c = d;
                continue;
            }
            break;
        }
        if (e.child === f.child) {
            for(f = e.child; f;){
                if (f === c) return $b36288e2db101ba3$var$ac(e), a;
                if (f === d) return $b36288e2db101ba3$var$ac(e), b;
                f = f.sibling;
            }
            throw Error($b36288e2db101ba3$var$y(188));
        }
        if (c.return !== d.return) c = e, d = f;
        else {
            for(var g = !1, h = e.child; h;){
                if (h === c) {
                    g = !0;
                    c = e;
                    d = f;
                    break;
                }
                if (h === d) {
                    g = !0;
                    d = e;
                    c = f;
                    break;
                }
                h = h.sibling;
            }
            if (!g) {
                for(h = f.child; h;){
                    if (h === c) {
                        g = !0;
                        c = f;
                        d = e;
                        break;
                    }
                    if (h === d) {
                        g = !0;
                        d = f;
                        c = e;
                        break;
                    }
                    h = h.sibling;
                }
                if (!g) throw Error($b36288e2db101ba3$var$y(189));
            }
        }
        if (c.alternate !== d) throw Error($b36288e2db101ba3$var$y(190));
    }
    if (3 !== c.tag) throw Error($b36288e2db101ba3$var$y(188));
    return c.stateNode.current === c ? a : b;
}
function $b36288e2db101ba3$var$cc(a) {
    a = $b36288e2db101ba3$var$bc(a);
    if (!a) return null;
    for(var b = a;;){
        if (5 === b.tag || 6 === b.tag) return b;
        if (b.child) b.child.return = b, b = b.child;
        else {
            if (b === a) break;
            for(; !b.sibling;){
                if (!b.return || b.return === a) return null;
                b = b.return;
            }
            b.sibling.return = b.return;
            b = b.sibling;
        }
    }
    return null;
}
function $b36288e2db101ba3$var$dc(a, b) {
    for(var c = a.alternate; null !== b;){
        if (b === a || b === c) return !0;
        b = b.return;
    }
    return !1;
}
var $b36288e2db101ba3$var$ec, $b36288e2db101ba3$var$fc, $b36288e2db101ba3$var$gc, $b36288e2db101ba3$var$hc, $b36288e2db101ba3$var$ic = !1, $b36288e2db101ba3$var$jc = [], $b36288e2db101ba3$var$kc = null, $b36288e2db101ba3$var$lc = null, $b36288e2db101ba3$var$mc = null, $b36288e2db101ba3$var$nc = new Map, $b36288e2db101ba3$var$oc = new Map, $b36288e2db101ba3$var$pc = [], $b36288e2db101ba3$var$qc = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(" ");
function $b36288e2db101ba3$var$rc(a, b, c, d, e) {
    return {
        blockedOn: a,
        domEventName: b,
        eventSystemFlags: c | 16,
        nativeEvent: e,
        targetContainers: [
            d
        ]
    };
}
function $b36288e2db101ba3$var$sc(a, b) {
    switch(a){
        case "focusin":
        case "focusout":
            $b36288e2db101ba3$var$kc = null;
            break;
        case "dragenter":
        case "dragleave":
            $b36288e2db101ba3$var$lc = null;
            break;
        case "mouseover":
        case "mouseout":
            $b36288e2db101ba3$var$mc = null;
            break;
        case "pointerover":
        case "pointerout":
            $b36288e2db101ba3$var$nc.delete(b.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            $b36288e2db101ba3$var$oc.delete(b.pointerId);
    }
}
function $b36288e2db101ba3$var$tc(a, b, c, d, e, f) {
    if (null === a || a.nativeEvent !== f) return a = $b36288e2db101ba3$var$rc(b, c, d, e, f), null !== b && (b = $b36288e2db101ba3$var$Cb(b), null !== b && $b36288e2db101ba3$var$fc(b)), a;
    a.eventSystemFlags |= d;
    b = a.targetContainers;
    null !== e && -1 === b.indexOf(e) && b.push(e);
    return a;
}
function $b36288e2db101ba3$var$uc(a, b, c, d, e) {
    switch(b){
        case "focusin":
            return $b36288e2db101ba3$var$kc = $b36288e2db101ba3$var$tc($b36288e2db101ba3$var$kc, a, b, c, d, e), !0;
        case "dragenter":
            return $b36288e2db101ba3$var$lc = $b36288e2db101ba3$var$tc($b36288e2db101ba3$var$lc, a, b, c, d, e), !0;
        case "mouseover":
            return $b36288e2db101ba3$var$mc = $b36288e2db101ba3$var$tc($b36288e2db101ba3$var$mc, a, b, c, d, e), !0;
        case "pointerover":
            var f = e.pointerId;
            $b36288e2db101ba3$var$nc.set(f, $b36288e2db101ba3$var$tc($b36288e2db101ba3$var$nc.get(f) || null, a, b, c, d, e));
            return !0;
        case "gotpointercapture":
            return f = e.pointerId, $b36288e2db101ba3$var$oc.set(f, $b36288e2db101ba3$var$tc($b36288e2db101ba3$var$oc.get(f) || null, a, b, c, d, e)), !0;
    }
    return !1;
}
function $b36288e2db101ba3$var$vc(a) {
    var b = $b36288e2db101ba3$var$wc(a.target);
    if (null !== b) {
        var c = $b36288e2db101ba3$var$Zb(b);
        if (null !== c) {
            if (b = c.tag, 13 === b) {
                if (b = $b36288e2db101ba3$var$$b(c), null !== b) {
                    a.blockedOn = b;
                    $b36288e2db101ba3$var$hc(a.lanePriority, function() {
                        $4LCdk.unstable_runWithPriority(a.priority, function() {
                            $b36288e2db101ba3$var$gc(c);
                        });
                    });
                    return;
                }
            } else if (3 === b && c.stateNode.hydrate) {
                a.blockedOn = 3 === c.tag ? c.stateNode.containerInfo : null;
                return;
            }
        }
    }
    a.blockedOn = null;
}
function $b36288e2db101ba3$var$xc(a) {
    if (null !== a.blockedOn) return !1;
    for(var b = a.targetContainers; 0 < b.length;){
        var c = $b36288e2db101ba3$var$yc(a.domEventName, a.eventSystemFlags, b[0], a.nativeEvent);
        if (null !== c) return b = $b36288e2db101ba3$var$Cb(c), null !== b && $b36288e2db101ba3$var$fc(b), a.blockedOn = c, !1;
        b.shift();
    }
    return !0;
}
function $b36288e2db101ba3$var$zc(a, b, c) {
    $b36288e2db101ba3$var$xc(a) && c.delete(b);
}
function $b36288e2db101ba3$var$Ac() {
    for($b36288e2db101ba3$var$ic = !1; 0 < $b36288e2db101ba3$var$jc.length;){
        var a = $b36288e2db101ba3$var$jc[0];
        if (null !== a.blockedOn) {
            a = $b36288e2db101ba3$var$Cb(a.blockedOn);
            null !== a && $b36288e2db101ba3$var$ec(a);
            break;
        }
        for(var b = a.targetContainers; 0 < b.length;){
            var c = $b36288e2db101ba3$var$yc(a.domEventName, a.eventSystemFlags, b[0], a.nativeEvent);
            if (null !== c) {
                a.blockedOn = c;
                break;
            }
            b.shift();
        }
        null === a.blockedOn && $b36288e2db101ba3$var$jc.shift();
    }
    null !== $b36288e2db101ba3$var$kc && $b36288e2db101ba3$var$xc($b36288e2db101ba3$var$kc) && ($b36288e2db101ba3$var$kc = null);
    null !== $b36288e2db101ba3$var$lc && $b36288e2db101ba3$var$xc($b36288e2db101ba3$var$lc) && ($b36288e2db101ba3$var$lc = null);
    null !== $b36288e2db101ba3$var$mc && $b36288e2db101ba3$var$xc($b36288e2db101ba3$var$mc) && ($b36288e2db101ba3$var$mc = null);
    $b36288e2db101ba3$var$nc.forEach($b36288e2db101ba3$var$zc);
    $b36288e2db101ba3$var$oc.forEach($b36288e2db101ba3$var$zc);
}
function $b36288e2db101ba3$var$Bc(a, b) {
    a.blockedOn === b && (a.blockedOn = null, $b36288e2db101ba3$var$ic || ($b36288e2db101ba3$var$ic = !0, $4LCdk.unstable_scheduleCallback($4LCdk.unstable_NormalPriority, $b36288e2db101ba3$var$Ac)));
}
function $b36288e2db101ba3$var$Cc(a) {
    function b(b) {
        return $b36288e2db101ba3$var$Bc(b, a);
    }
    if (0 < $b36288e2db101ba3$var$jc.length) {
        $b36288e2db101ba3$var$Bc($b36288e2db101ba3$var$jc[0], a);
        for(var c = 1; c < $b36288e2db101ba3$var$jc.length; c++){
            var d = $b36288e2db101ba3$var$jc[c];
            d.blockedOn === a && (d.blockedOn = null);
        }
    }
    null !== $b36288e2db101ba3$var$kc && $b36288e2db101ba3$var$Bc($b36288e2db101ba3$var$kc, a);
    null !== $b36288e2db101ba3$var$lc && $b36288e2db101ba3$var$Bc($b36288e2db101ba3$var$lc, a);
    null !== $b36288e2db101ba3$var$mc && $b36288e2db101ba3$var$Bc($b36288e2db101ba3$var$mc, a);
    $b36288e2db101ba3$var$nc.forEach(b);
    $b36288e2db101ba3$var$oc.forEach(b);
    for(c = 0; c < $b36288e2db101ba3$var$pc.length; c++)d = $b36288e2db101ba3$var$pc[c], d.blockedOn === a && (d.blockedOn = null);
    for(; 0 < $b36288e2db101ba3$var$pc.length && (c = $b36288e2db101ba3$var$pc[0], null === c.blockedOn);)$b36288e2db101ba3$var$vc(c), null === c.blockedOn && $b36288e2db101ba3$var$pc.shift();
}
function $b36288e2db101ba3$var$Dc(a, b) {
    var c = {};
    c[a.toLowerCase()] = b.toLowerCase();
    c["Webkit" + a] = "webkit" + b;
    c["Moz" + a] = "moz" + b;
    return c;
}
var $b36288e2db101ba3$var$Ec = {
    animationend: $b36288e2db101ba3$var$Dc("Animation", "AnimationEnd"),
    animationiteration: $b36288e2db101ba3$var$Dc("Animation", "AnimationIteration"),
    animationstart: $b36288e2db101ba3$var$Dc("Animation", "AnimationStart"),
    transitionend: $b36288e2db101ba3$var$Dc("Transition", "TransitionEnd")
}, $b36288e2db101ba3$var$Fc = {}, $b36288e2db101ba3$var$Gc = {};
$b36288e2db101ba3$var$fa && ($b36288e2db101ba3$var$Gc = document.createElement("div").style, "AnimationEvent" in window || (delete $b36288e2db101ba3$var$Ec.animationend.animation, delete $b36288e2db101ba3$var$Ec.animationiteration.animation, delete $b36288e2db101ba3$var$Ec.animationstart.animation), "TransitionEvent" in window || delete $b36288e2db101ba3$var$Ec.transitionend.transition);
function $b36288e2db101ba3$var$Hc(a) {
    if ($b36288e2db101ba3$var$Fc[a]) return $b36288e2db101ba3$var$Fc[a];
    if (!$b36288e2db101ba3$var$Ec[a]) return a;
    var b = $b36288e2db101ba3$var$Ec[a], c;
    for(c in b)if (b.hasOwnProperty(c) && c in $b36288e2db101ba3$var$Gc) return $b36288e2db101ba3$var$Fc[a] = b[c];
    return a;
}
var $b36288e2db101ba3$var$Ic = $b36288e2db101ba3$var$Hc("animationend"), $b36288e2db101ba3$var$Jc = $b36288e2db101ba3$var$Hc("animationiteration"), $b36288e2db101ba3$var$Kc = $b36288e2db101ba3$var$Hc("animationstart"), $b36288e2db101ba3$var$Lc = $b36288e2db101ba3$var$Hc("transitionend"), $b36288e2db101ba3$var$Mc = new Map, $b36288e2db101ba3$var$Nc = new Map, $b36288e2db101ba3$var$Oc = [
    "abort",
    "abort",
    $b36288e2db101ba3$var$Ic,
    "animationEnd",
    $b36288e2db101ba3$var$Jc,
    "animationIteration",
    $b36288e2db101ba3$var$Kc,
    "animationStart",
    "canplay",
    "canPlay",
    "canplaythrough",
    "canPlayThrough",
    "durationchange",
    "durationChange",
    "emptied",
    "emptied",
    "encrypted",
    "encrypted",
    "ended",
    "ended",
    "error",
    "error",
    "gotpointercapture",
    "gotPointerCapture",
    "load",
    "load",
    "loadeddata",
    "loadedData",
    "loadedmetadata",
    "loadedMetadata",
    "loadstart",
    "loadStart",
    "lostpointercapture",
    "lostPointerCapture",
    "playing",
    "playing",
    "progress",
    "progress",
    "seeking",
    "seeking",
    "stalled",
    "stalled",
    "suspend",
    "suspend",
    "timeupdate",
    "timeUpdate",
    $b36288e2db101ba3$var$Lc,
    "transitionEnd",
    "waiting",
    "waiting"
];
function $b36288e2db101ba3$var$Pc(a, b) {
    for(var c = 0; c < a.length; c += 2){
        var d = a[c], e = a[c + 1];
        e = "on" + (e[0].toUpperCase() + e.slice(1));
        $b36288e2db101ba3$var$Nc.set(d, b);
        $b36288e2db101ba3$var$Mc.set(d, e);
        $b36288e2db101ba3$var$da(e, [
            d
        ]);
    }
}
var $b36288e2db101ba3$var$Qc = $4LCdk.unstable_now;
$b36288e2db101ba3$var$Qc();
var $b36288e2db101ba3$var$F = 8;
function $b36288e2db101ba3$var$Rc(a) {
    if (0 !== (1 & a)) return $b36288e2db101ba3$var$F = 15, 1;
    if (0 !== (2 & a)) return $b36288e2db101ba3$var$F = 14, 2;
    if (0 !== (4 & a)) return $b36288e2db101ba3$var$F = 13, 4;
    var b = 24 & a;
    if (0 !== b) return $b36288e2db101ba3$var$F = 12, b;
    if (0 !== (a & 32)) return $b36288e2db101ba3$var$F = 11, 32;
    b = 192 & a;
    if (0 !== b) return $b36288e2db101ba3$var$F = 10, b;
    if (0 !== (a & 256)) return $b36288e2db101ba3$var$F = 9, 256;
    b = 3584 & a;
    if (0 !== b) return $b36288e2db101ba3$var$F = 8, b;
    if (0 !== (a & 4096)) return $b36288e2db101ba3$var$F = 7, 4096;
    b = 4186112 & a;
    if (0 !== b) return $b36288e2db101ba3$var$F = 6, b;
    b = 62914560 & a;
    if (0 !== b) return $b36288e2db101ba3$var$F = 5, b;
    if (a & 67108864) return $b36288e2db101ba3$var$F = 4, 67108864;
    if (0 !== (a & 134217728)) return $b36288e2db101ba3$var$F = 3, 134217728;
    b = 805306368 & a;
    if (0 !== b) return $b36288e2db101ba3$var$F = 2, b;
    if (0 !== (1073741824 & a)) return $b36288e2db101ba3$var$F = 1, 1073741824;
    $b36288e2db101ba3$var$F = 8;
    return a;
}
function $b36288e2db101ba3$var$Sc(a) {
    switch(a){
        case 99:
            return 15;
        case 98:
            return 10;
        case 97:
        case 96:
            return 8;
        case 95:
            return 2;
        default:
            return 0;
    }
}
function $b36288e2db101ba3$var$Tc(a) {
    switch(a){
        case 15:
        case 14:
            return 99;
        case 13:
        case 12:
        case 11:
        case 10:
            return 98;
        case 9:
        case 8:
        case 7:
        case 6:
        case 4:
        case 5:
            return 97;
        case 3:
        case 2:
        case 1:
            return 95;
        case 0:
            return 90;
        default:
            throw Error($b36288e2db101ba3$var$y(358, a));
    }
}
function $b36288e2db101ba3$var$Uc(a, b) {
    var c = a.pendingLanes;
    if (0 === c) return $b36288e2db101ba3$var$F = 0;
    var d = 0, e = 0, f = a.expiredLanes, g = a.suspendedLanes, h = a.pingedLanes;
    if (0 !== f) d = f, e = $b36288e2db101ba3$var$F = 15;
    else if (f = c & 134217727, 0 !== f) {
        var k = f & ~g;
        0 !== k ? (d = $b36288e2db101ba3$var$Rc(k), e = $b36288e2db101ba3$var$F) : (h &= f, 0 !== h && (d = $b36288e2db101ba3$var$Rc(h), e = $b36288e2db101ba3$var$F));
    } else f = c & ~g, 0 !== f ? (d = $b36288e2db101ba3$var$Rc(f), e = $b36288e2db101ba3$var$F) : 0 !== h && (d = $b36288e2db101ba3$var$Rc(h), e = $b36288e2db101ba3$var$F);
    if (0 === d) return 0;
    d = 31 - $b36288e2db101ba3$var$Vc(d);
    d = c & ((0 > d ? 0 : 1 << d) << 1) - 1;
    if (0 !== b && b !== d && 0 === (b & g)) {
        $b36288e2db101ba3$var$Rc(b);
        if (e <= $b36288e2db101ba3$var$F) return b;
        $b36288e2db101ba3$var$F = e;
    }
    b = a.entangledLanes;
    if (0 !== b) for(a = a.entanglements, b &= d; 0 < b;)c = 31 - $b36288e2db101ba3$var$Vc(b), e = 1 << c, d |= a[c], b &= ~e;
    return d;
}
function $b36288e2db101ba3$var$Wc(a) {
    a = a.pendingLanes & -1073741825;
    return 0 !== a ? a : a & 1073741824 ? 1073741824 : 0;
}
function $b36288e2db101ba3$var$Xc(a, b) {
    switch(a){
        case 15:
            return 1;
        case 14:
            return 2;
        case 12:
            return a = $b36288e2db101ba3$var$Yc(24 & ~b), 0 === a ? $b36288e2db101ba3$var$Xc(10, b) : a;
        case 10:
            return a = $b36288e2db101ba3$var$Yc(192 & ~b), 0 === a ? $b36288e2db101ba3$var$Xc(8, b) : a;
        case 8:
            return a = $b36288e2db101ba3$var$Yc(3584 & ~b), 0 === a && (a = $b36288e2db101ba3$var$Yc(4186112 & ~b), 0 === a && (a = 512)), a;
        case 2:
            return b = $b36288e2db101ba3$var$Yc(805306368 & ~b), 0 === b && (b = 268435456), b;
    }
    throw Error($b36288e2db101ba3$var$y(358, a));
}
function $b36288e2db101ba3$var$Yc(a) {
    return a & -a;
}
function $b36288e2db101ba3$var$Zc(a) {
    for(var b = [], c = 0; 31 > c; c++)b.push(a);
    return b;
}
function $b36288e2db101ba3$var$$c(a, b, c) {
    a.pendingLanes |= b;
    var d = b - 1;
    a.suspendedLanes &= d;
    a.pingedLanes &= d;
    a = a.eventTimes;
    b = 31 - $b36288e2db101ba3$var$Vc(b);
    a[b] = c;
}
var $b36288e2db101ba3$var$Vc = Math.clz32 ? Math.clz32 : $b36288e2db101ba3$var$ad, $b36288e2db101ba3$var$bd = Math.log, $b36288e2db101ba3$var$cd = Math.LN2;
function $b36288e2db101ba3$var$ad(a) {
    return 0 === a ? 32 : 31 - ($b36288e2db101ba3$var$bd(a) / $b36288e2db101ba3$var$cd | 0) | 0;
}
var $b36288e2db101ba3$var$dd = $4LCdk.unstable_UserBlockingPriority, $b36288e2db101ba3$var$ed = $4LCdk.unstable_runWithPriority, $b36288e2db101ba3$var$fd = !0;
function $b36288e2db101ba3$var$gd(a, b, c, d) {
    $b36288e2db101ba3$var$Kb || $b36288e2db101ba3$var$Ib();
    var e = $b36288e2db101ba3$var$hd, f = $b36288e2db101ba3$var$Kb;
    $b36288e2db101ba3$var$Kb = !0;
    try {
        $b36288e2db101ba3$var$Hb(e, a, b, c, d);
    } finally{
        ($b36288e2db101ba3$var$Kb = f) || $b36288e2db101ba3$var$Mb();
    }
}
function $b36288e2db101ba3$var$id(a, b, c, d) {
    $b36288e2db101ba3$var$ed($b36288e2db101ba3$var$dd, $b36288e2db101ba3$var$hd.bind(null, a, b, c, d));
}
function $b36288e2db101ba3$var$hd(a, b, c, d) {
    if ($b36288e2db101ba3$var$fd) {
        var e;
        if ((e = 0 === (b & 4)) && 0 < $b36288e2db101ba3$var$jc.length && -1 < $b36288e2db101ba3$var$qc.indexOf(a)) a = $b36288e2db101ba3$var$rc(null, a, b, c, d), $b36288e2db101ba3$var$jc.push(a);
        else {
            var f = $b36288e2db101ba3$var$yc(a, b, c, d);
            if (null === f) e && $b36288e2db101ba3$var$sc(a, d);
            else {
                if (e) {
                    if (-1 < $b36288e2db101ba3$var$qc.indexOf(a)) {
                        a = $b36288e2db101ba3$var$rc(f, a, b, c, d);
                        $b36288e2db101ba3$var$jc.push(a);
                        return;
                    }
                    if ($b36288e2db101ba3$var$uc(f, a, b, c, d)) return;
                    $b36288e2db101ba3$var$sc(a, d);
                }
                $b36288e2db101ba3$var$jd(a, b, d, null, c);
            }
        }
    }
}
function $b36288e2db101ba3$var$yc(a, b, c, d) {
    var e = $b36288e2db101ba3$var$xb(d);
    e = $b36288e2db101ba3$var$wc(e);
    if (null !== e) {
        var f = $b36288e2db101ba3$var$Zb(e);
        if (null === f) e = null;
        else {
            var g = f.tag;
            if (13 === g) {
                e = $b36288e2db101ba3$var$$b(f);
                if (null !== e) return e;
                e = null;
            } else if (3 === g) {
                if (f.stateNode.hydrate) return 3 === f.tag ? f.stateNode.containerInfo : null;
                e = null;
            } else f !== e && (e = null);
        }
    }
    $b36288e2db101ba3$var$jd(a, b, d, e, c);
    return null;
}
var $b36288e2db101ba3$var$kd = null, $b36288e2db101ba3$var$ld = null, $b36288e2db101ba3$var$md = null;
function $b36288e2db101ba3$var$nd() {
    if ($b36288e2db101ba3$var$md) return $b36288e2db101ba3$var$md;
    var a, b = $b36288e2db101ba3$var$ld, c = b.length, d, e = "value" in $b36288e2db101ba3$var$kd ? $b36288e2db101ba3$var$kd.value : $b36288e2db101ba3$var$kd.textContent, f = e.length;
    for(a = 0; a < c && b[a] === e[a]; a++);
    var g = c - a;
    for(d = 1; d <= g && b[c - d] === e[f - d]; d++);
    return $b36288e2db101ba3$var$md = e.slice(a, 1 < d ? 1 - d : void 0);
}
function $b36288e2db101ba3$var$od(a) {
    var b = a.keyCode;
    "charCode" in a ? (a = a.charCode, 0 === a && 13 === b && (a = 13)) : a = b;
    10 === a && (a = 13);
    return 32 <= a || 13 === a ? a : 0;
}
function $b36288e2db101ba3$var$pd() {
    return !0;
}
function $b36288e2db101ba3$var$qd() {
    return !1;
}
function $b36288e2db101ba3$var$rd(a) {
    function b(b, d, e, f, g) {
        this._reactName = b;
        this._targetInst = e;
        this.type = d;
        this.nativeEvent = f;
        this.target = g;
        this.currentTarget = null;
        for(var c in a)a.hasOwnProperty(c) && (b = a[c], this[c] = b ? b(f) : f[c]);
        this.isDefaultPrevented = (null != f.defaultPrevented ? f.defaultPrevented : !1 === f.returnValue) ? $b36288e2db101ba3$var$pd : $b36288e2db101ba3$var$qd;
        this.isPropagationStopped = $b36288e2db101ba3$var$qd;
        return this;
    }
    $4yvvI(b.prototype, {
        preventDefault: function() {
            this.defaultPrevented = !0;
            var a = this.nativeEvent;
            a && (a.preventDefault ? a.preventDefault() : "unknown" !== typeof a.returnValue && (a.returnValue = !1), this.isDefaultPrevented = $b36288e2db101ba3$var$pd);
        },
        stopPropagation: function() {
            var a = this.nativeEvent;
            a && (a.stopPropagation ? a.stopPropagation() : "unknown" !== typeof a.cancelBubble && (a.cancelBubble = !0), this.isPropagationStopped = $b36288e2db101ba3$var$pd);
        },
        persist: function() {},
        isPersistent: $b36288e2db101ba3$var$pd
    });
    return b;
}
var $b36288e2db101ba3$var$sd = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(a) {
        return a.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, $b36288e2db101ba3$var$td = $b36288e2db101ba3$var$rd($b36288e2db101ba3$var$sd), $b36288e2db101ba3$var$ud = $4yvvI({}, $b36288e2db101ba3$var$sd, {
    view: 0,
    detail: 0
}), $b36288e2db101ba3$var$vd = $b36288e2db101ba3$var$rd($b36288e2db101ba3$var$ud), $b36288e2db101ba3$var$wd, $b36288e2db101ba3$var$xd, $b36288e2db101ba3$var$yd, $b36288e2db101ba3$var$Ad = $4yvvI({}, $b36288e2db101ba3$var$ud, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: $b36288e2db101ba3$var$zd,
    button: 0,
    buttons: 0,
    relatedTarget: function(a) {
        return void 0 === a.relatedTarget ? a.fromElement === a.srcElement ? a.toElement : a.fromElement : a.relatedTarget;
    },
    movementX: function(a) {
        if ("movementX" in a) return a.movementX;
        a !== $b36288e2db101ba3$var$yd && ($b36288e2db101ba3$var$yd && "mousemove" === a.type ? ($b36288e2db101ba3$var$wd = a.screenX - $b36288e2db101ba3$var$yd.screenX, $b36288e2db101ba3$var$xd = a.screenY - $b36288e2db101ba3$var$yd.screenY) : $b36288e2db101ba3$var$xd = $b36288e2db101ba3$var$wd = 0, $b36288e2db101ba3$var$yd = a);
        return $b36288e2db101ba3$var$wd;
    },
    movementY: function(a) {
        return "movementY" in a ? a.movementY : $b36288e2db101ba3$var$xd;
    }
}), $b36288e2db101ba3$var$Bd = $b36288e2db101ba3$var$rd($b36288e2db101ba3$var$Ad), $b36288e2db101ba3$var$Cd = $4yvvI({}, $b36288e2db101ba3$var$Ad, {
    dataTransfer: 0
}), $b36288e2db101ba3$var$Dd = $b36288e2db101ba3$var$rd($b36288e2db101ba3$var$Cd), $b36288e2db101ba3$var$Ed = $4yvvI({}, $b36288e2db101ba3$var$ud, {
    relatedTarget: 0
}), $b36288e2db101ba3$var$Fd = $b36288e2db101ba3$var$rd($b36288e2db101ba3$var$Ed), $b36288e2db101ba3$var$Gd = $4yvvI({}, $b36288e2db101ba3$var$sd, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $b36288e2db101ba3$var$Hd = $b36288e2db101ba3$var$rd($b36288e2db101ba3$var$Gd), $b36288e2db101ba3$var$Id = $4yvvI({}, $b36288e2db101ba3$var$sd, {
    clipboardData: function(a) {
        return "clipboardData" in a ? a.clipboardData : window.clipboardData;
    }
}), $b36288e2db101ba3$var$Jd = $b36288e2db101ba3$var$rd($b36288e2db101ba3$var$Id), $b36288e2db101ba3$var$Kd = $4yvvI({}, $b36288e2db101ba3$var$sd, {
    data: 0
}), $b36288e2db101ba3$var$Ld = $b36288e2db101ba3$var$rd($b36288e2db101ba3$var$Kd), $b36288e2db101ba3$var$Md = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, $b36288e2db101ba3$var$Nd = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, $b36288e2db101ba3$var$Od = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function $b36288e2db101ba3$var$Pd(a) {
    var b = this.nativeEvent;
    return b.getModifierState ? b.getModifierState(a) : (a = $b36288e2db101ba3$var$Od[a]) ? !!b[a] : !1;
}
function $b36288e2db101ba3$var$zd() {
    return $b36288e2db101ba3$var$Pd;
}
var $b36288e2db101ba3$var$Qd = $4yvvI({}, $b36288e2db101ba3$var$ud, {
    key: function(a) {
        if (a.key) {
            var b = $b36288e2db101ba3$var$Md[a.key] || a.key;
            if ("Unidentified" !== b) return b;
        }
        return "keypress" === a.type ? (a = $b36288e2db101ba3$var$od(a), 13 === a ? "Enter" : String.fromCharCode(a)) : "keydown" === a.type || "keyup" === a.type ? $b36288e2db101ba3$var$Nd[a.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: $b36288e2db101ba3$var$zd,
    charCode: function(a) {
        return "keypress" === a.type ? $b36288e2db101ba3$var$od(a) : 0;
    },
    keyCode: function(a) {
        return "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    },
    which: function(a) {
        return "keypress" === a.type ? $b36288e2db101ba3$var$od(a) : "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    }
}), $b36288e2db101ba3$var$Rd = $b36288e2db101ba3$var$rd($b36288e2db101ba3$var$Qd), $b36288e2db101ba3$var$Sd = $4yvvI({}, $b36288e2db101ba3$var$Ad, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), $b36288e2db101ba3$var$Td = $b36288e2db101ba3$var$rd($b36288e2db101ba3$var$Sd), $b36288e2db101ba3$var$Ud = $4yvvI({}, $b36288e2db101ba3$var$ud, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: $b36288e2db101ba3$var$zd
}), $b36288e2db101ba3$var$Vd = $b36288e2db101ba3$var$rd($b36288e2db101ba3$var$Ud), $b36288e2db101ba3$var$Wd = $4yvvI({}, $b36288e2db101ba3$var$sd, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $b36288e2db101ba3$var$Xd = $b36288e2db101ba3$var$rd($b36288e2db101ba3$var$Wd), $b36288e2db101ba3$var$Yd = $4yvvI({}, $b36288e2db101ba3$var$Ad, {
    deltaX: function(a) {
        return "deltaX" in a ? a.deltaX : "wheelDeltaX" in a ? -a.wheelDeltaX : 0;
    },
    deltaY: function(a) {
        return "deltaY" in a ? a.deltaY : "wheelDeltaY" in a ? -a.wheelDeltaY : "wheelDelta" in a ? -a.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), $b36288e2db101ba3$var$Zd = $b36288e2db101ba3$var$rd($b36288e2db101ba3$var$Yd), $b36288e2db101ba3$var$$d = [
    9,
    13,
    27,
    32
], $b36288e2db101ba3$var$ae = $b36288e2db101ba3$var$fa && "CompositionEvent" in window, $b36288e2db101ba3$var$be = null;
$b36288e2db101ba3$var$fa && "documentMode" in document && ($b36288e2db101ba3$var$be = document.documentMode);
var $b36288e2db101ba3$var$ce = $b36288e2db101ba3$var$fa && "TextEvent" in window && !$b36288e2db101ba3$var$be, $b36288e2db101ba3$var$de = $b36288e2db101ba3$var$fa && (!$b36288e2db101ba3$var$ae || $b36288e2db101ba3$var$be && 8 < $b36288e2db101ba3$var$be && 11 >= $b36288e2db101ba3$var$be), $b36288e2db101ba3$var$ee = String.fromCharCode(32), $b36288e2db101ba3$var$fe = !1;
function $b36288e2db101ba3$var$ge(a, b) {
    switch(a){
        case "keyup":
            return -1 !== $b36288e2db101ba3$var$$d.indexOf(b.keyCode);
        case "keydown":
            return 229 !== b.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function $b36288e2db101ba3$var$he(a) {
    a = a.detail;
    return "object" === typeof a && "data" in a ? a.data : null;
}
var $b36288e2db101ba3$var$ie = !1;
function $b36288e2db101ba3$var$je(a, b) {
    switch(a){
        case "compositionend":
            return $b36288e2db101ba3$var$he(b);
        case "keypress":
            if (32 !== b.which) return null;
            $b36288e2db101ba3$var$fe = !0;
            return $b36288e2db101ba3$var$ee;
        case "textInput":
            return a = b.data, a === $b36288e2db101ba3$var$ee && $b36288e2db101ba3$var$fe ? null : a;
        default:
            return null;
    }
}
function $b36288e2db101ba3$var$ke(a, b) {
    if ($b36288e2db101ba3$var$ie) return "compositionend" === a || !$b36288e2db101ba3$var$ae && $b36288e2db101ba3$var$ge(a, b) ? (a = $b36288e2db101ba3$var$nd(), $b36288e2db101ba3$var$md = $b36288e2db101ba3$var$ld = $b36288e2db101ba3$var$kd = null, $b36288e2db101ba3$var$ie = !1, a) : null;
    switch(a){
        case "paste":
            return null;
        case "keypress":
            if (!(b.ctrlKey || b.altKey || b.metaKey) || b.ctrlKey && b.altKey) {
                if (b.char && 1 < b.char.length) return b.char;
                if (b.which) return String.fromCharCode(b.which);
            }
            return null;
        case "compositionend":
            return $b36288e2db101ba3$var$de && "ko" !== b.locale ? null : b.data;
        default:
            return null;
    }
}
var $b36288e2db101ba3$var$le = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function $b36288e2db101ba3$var$me(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return "input" === b ? !!$b36288e2db101ba3$var$le[a.type] : "textarea" === b ? !0 : !1;
}
function $b36288e2db101ba3$var$ne(a, b, c, d) {
    $b36288e2db101ba3$var$Eb(d);
    b = $b36288e2db101ba3$var$oe(b, "onChange");
    0 < b.length && (c = new $b36288e2db101ba3$var$td("onChange", "change", null, c, d), a.push({
        event: c,
        listeners: b
    }));
}
var $b36288e2db101ba3$var$pe = null, $b36288e2db101ba3$var$qe = null;
function $b36288e2db101ba3$var$re(a) {
    $b36288e2db101ba3$var$se(a, 0);
}
function $b36288e2db101ba3$var$te(a) {
    var b = $b36288e2db101ba3$var$ue(a);
    if ($b36288e2db101ba3$var$Wa(b)) return a;
}
function $b36288e2db101ba3$var$ve(a, b) {
    if ("change" === a) return b;
}
var $b36288e2db101ba3$var$we = !1;
if ($b36288e2db101ba3$var$fa) {
    var $b36288e2db101ba3$var$xe;
    if ($b36288e2db101ba3$var$fa) {
        var $b36288e2db101ba3$var$ye = "oninput" in document;
        if (!$b36288e2db101ba3$var$ye) {
            var $b36288e2db101ba3$var$ze = document.createElement("div");
            $b36288e2db101ba3$var$ze.setAttribute("oninput", "return;");
            $b36288e2db101ba3$var$ye = "function" === typeof $b36288e2db101ba3$var$ze.oninput;
        }
        $b36288e2db101ba3$var$xe = $b36288e2db101ba3$var$ye;
    } else $b36288e2db101ba3$var$xe = !1;
    $b36288e2db101ba3$var$we = $b36288e2db101ba3$var$xe && (!document.documentMode || 9 < document.documentMode);
}
function $b36288e2db101ba3$var$Ae() {
    $b36288e2db101ba3$var$pe && ($b36288e2db101ba3$var$pe.detachEvent("onpropertychange", $b36288e2db101ba3$var$Be), $b36288e2db101ba3$var$qe = $b36288e2db101ba3$var$pe = null);
}
function $b36288e2db101ba3$var$Be(a) {
    if ("value" === a.propertyName && $b36288e2db101ba3$var$te($b36288e2db101ba3$var$qe)) {
        var b = [];
        $b36288e2db101ba3$var$ne(b, $b36288e2db101ba3$var$qe, a, $b36288e2db101ba3$var$xb(a));
        a = $b36288e2db101ba3$var$re;
        if ($b36288e2db101ba3$var$Kb) a(b);
        else {
            $b36288e2db101ba3$var$Kb = !0;
            try {
                $b36288e2db101ba3$var$Gb(a, b);
            } finally{
                $b36288e2db101ba3$var$Kb = !1, $b36288e2db101ba3$var$Mb();
            }
        }
    }
}
function $b36288e2db101ba3$var$Ce(a, b, c) {
    "focusin" === a ? ($b36288e2db101ba3$var$Ae(), $b36288e2db101ba3$var$pe = b, $b36288e2db101ba3$var$qe = c, $b36288e2db101ba3$var$pe.attachEvent("onpropertychange", $b36288e2db101ba3$var$Be)) : "focusout" === a && $b36288e2db101ba3$var$Ae();
}
function $b36288e2db101ba3$var$De(a) {
    if ("selectionchange" === a || "keyup" === a || "keydown" === a) return $b36288e2db101ba3$var$te($b36288e2db101ba3$var$qe);
}
function $b36288e2db101ba3$var$Ee(a, b) {
    if ("click" === a) return $b36288e2db101ba3$var$te(b);
}
function $b36288e2db101ba3$var$Fe(a, b) {
    if ("input" === a || "change" === a) return $b36288e2db101ba3$var$te(b);
}
function $b36288e2db101ba3$var$Ge(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $b36288e2db101ba3$var$He = "function" === typeof Object.is ? Object.is : $b36288e2db101ba3$var$Ge, $b36288e2db101ba3$var$Ie = Object.prototype.hasOwnProperty;
function $b36288e2db101ba3$var$Je(a, b) {
    if ($b36288e2db101ba3$var$He(a, b)) return !0;
    if ("object" !== typeof a || null === a || "object" !== typeof b || null === b) return !1;
    var c = Object.keys(a), d = Object.keys(b);
    if (c.length !== d.length) return !1;
    for(d = 0; d < c.length; d++)if (!$b36288e2db101ba3$var$Ie.call(b, c[d]) || !$b36288e2db101ba3$var$He(a[c[d]], b[c[d]])) return !1;
    return !0;
}
function $b36288e2db101ba3$var$Ke(a) {
    for(; a && a.firstChild;)a = a.firstChild;
    return a;
}
function $b36288e2db101ba3$var$Le(a, b) {
    var c = $b36288e2db101ba3$var$Ke(a);
    a = 0;
    for(var d; c;){
        if (3 === c.nodeType) {
            d = a + c.textContent.length;
            if (a <= b && d >= b) return {
                node: c,
                offset: b - a
            };
            a = d;
        }
        a: {
            for(; c;){
                if (c.nextSibling) {
                    c = c.nextSibling;
                    break a;
                }
                c = c.parentNode;
            }
            c = void 0;
        }
        c = $b36288e2db101ba3$var$Ke(c);
    }
}
function $b36288e2db101ba3$var$Me(a, b) {
    return a && b ? a === b ? !0 : a && 3 === a.nodeType ? !1 : b && 3 === b.nodeType ? $b36288e2db101ba3$var$Me(a, b.parentNode) : "contains" in a ? a.contains(b) : a.compareDocumentPosition ? !!(a.compareDocumentPosition(b) & 16) : !1 : !1;
}
function $b36288e2db101ba3$var$Ne() {
    for(var a = window, b = $b36288e2db101ba3$var$Xa(); b instanceof a.HTMLIFrameElement;){
        try {
            var c = "string" === typeof b.contentWindow.location.href;
        } catch (d) {
            c = !1;
        }
        if (c) a = b.contentWindow;
        else break;
        b = $b36288e2db101ba3$var$Xa(a.document);
    }
    return b;
}
function $b36288e2db101ba3$var$Oe(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return b && ("input" === b && ("text" === a.type || "search" === a.type || "tel" === a.type || "url" === a.type || "password" === a.type) || "textarea" === b || "true" === a.contentEditable);
}
var $b36288e2db101ba3$var$Pe = $b36288e2db101ba3$var$fa && "documentMode" in document && 11 >= document.documentMode, $b36288e2db101ba3$var$Qe = null, $b36288e2db101ba3$var$Re = null, $b36288e2db101ba3$var$Se = null, $b36288e2db101ba3$var$Te = !1;
function $b36288e2db101ba3$var$Ue(a, b, c) {
    var d = c.window === c ? c.document : 9 === c.nodeType ? c : c.ownerDocument;
    $b36288e2db101ba3$var$Te || null == $b36288e2db101ba3$var$Qe || $b36288e2db101ba3$var$Qe !== $b36288e2db101ba3$var$Xa(d) || (d = $b36288e2db101ba3$var$Qe, "selectionStart" in d && $b36288e2db101ba3$var$Oe(d) ? d = {
        start: d.selectionStart,
        end: d.selectionEnd
    } : (d = (d.ownerDocument && d.ownerDocument.defaultView || window).getSelection(), d = {
        anchorNode: d.anchorNode,
        anchorOffset: d.anchorOffset,
        focusNode: d.focusNode,
        focusOffset: d.focusOffset
    }), $b36288e2db101ba3$var$Se && $b36288e2db101ba3$var$Je($b36288e2db101ba3$var$Se, d) || ($b36288e2db101ba3$var$Se = d, d = $b36288e2db101ba3$var$oe($b36288e2db101ba3$var$Re, "onSelect"), 0 < d.length && (b = new $b36288e2db101ba3$var$td("onSelect", "select", null, b, c), a.push({
        event: b,
        listeners: d
    }), b.target = $b36288e2db101ba3$var$Qe)));
}
$b36288e2db101ba3$var$Pc("cancel cancel click click close close contextmenu contextMenu copy copy cut cut auxclick auxClick dblclick doubleClick dragend dragEnd dragstart dragStart drop drop focusin focus focusout blur input input invalid invalid keydown keyDown keypress keyPress keyup keyUp mousedown mouseDown mouseup mouseUp paste paste pause pause play play pointercancel pointerCancel pointerdown pointerDown pointerup pointerUp ratechange rateChange reset reset seeked seeked submit submit touchcancel touchCancel touchend touchEnd touchstart touchStart volumechange volumeChange".split(" "), 0);
$b36288e2db101ba3$var$Pc("drag drag dragenter dragEnter dragexit dragExit dragleave dragLeave dragover dragOver mousemove mouseMove mouseout mouseOut mouseover mouseOver pointermove pointerMove pointerout pointerOut pointerover pointerOver scroll scroll toggle toggle touchmove touchMove wheel wheel".split(" "), 1);
$b36288e2db101ba3$var$Pc($b36288e2db101ba3$var$Oc, 2);
for(var $b36288e2db101ba3$var$Ve = "change selectionchange textInput compositionstart compositionend compositionupdate".split(" "), $b36288e2db101ba3$var$We = 0; $b36288e2db101ba3$var$We < $b36288e2db101ba3$var$Ve.length; $b36288e2db101ba3$var$We++)$b36288e2db101ba3$var$Nc.set($b36288e2db101ba3$var$Ve[$b36288e2db101ba3$var$We], 0);
$b36288e2db101ba3$var$ea("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
$b36288e2db101ba3$var$ea("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
$b36288e2db101ba3$var$ea("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
$b36288e2db101ba3$var$ea("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
$b36288e2db101ba3$var$da("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
$b36288e2db101ba3$var$da("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
$b36288e2db101ba3$var$da("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
$b36288e2db101ba3$var$da("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
$b36288e2db101ba3$var$da("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
$b36288e2db101ba3$var$da("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var $b36288e2db101ba3$var$Xe = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), $b36288e2db101ba3$var$Ye = new Set("cancel close invalid load scroll toggle".split(" ").concat($b36288e2db101ba3$var$Xe));
function $b36288e2db101ba3$var$Ze(a, b, c) {
    var d = a.type || "unknown-event";
    a.currentTarget = c;
    $b36288e2db101ba3$var$Yb(d, b, void 0, a);
    a.currentTarget = null;
}
function $b36288e2db101ba3$var$se(a, b) {
    b = 0 !== (b & 4);
    for(var c = 0; c < a.length; c++){
        var d = a[c], e = d.event;
        d = d.listeners;
        a: {
            var f = void 0;
            if (b) for(var g = d.length - 1; 0 <= g; g--){
                var h = d[g], k = h.instance, l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $b36288e2db101ba3$var$Ze(e, h, l);
                f = k;
            }
            else for(g = 0; g < d.length; g++){
                h = d[g];
                k = h.instance;
                l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $b36288e2db101ba3$var$Ze(e, h, l);
                f = k;
            }
        }
    }
    if ($b36288e2db101ba3$var$Ub) throw a = $b36288e2db101ba3$var$Vb, $b36288e2db101ba3$var$Ub = !1, $b36288e2db101ba3$var$Vb = null, a;
}
function $b36288e2db101ba3$var$G(a, b) {
    var c = $b36288e2db101ba3$var$$e(b), d = a + "__bubble";
    c.has(d) || ($b36288e2db101ba3$var$af(b, a, 2, !1), c.add(d));
}
var $b36288e2db101ba3$var$bf = "_reactListening" + Math.random().toString(36).slice(2);
function $b36288e2db101ba3$var$cf(a) {
    a[$b36288e2db101ba3$var$bf] || (a[$b36288e2db101ba3$var$bf] = !0, $b36288e2db101ba3$var$ba.forEach(function(b) {
        $b36288e2db101ba3$var$Ye.has(b) || $b36288e2db101ba3$var$df(b, !1, a, null);
        $b36288e2db101ba3$var$df(b, !0, a, null);
    }));
}
function $b36288e2db101ba3$var$df(a, b, c, d) {
    var e = 4 < arguments.length && void 0 !== arguments[4] ? arguments[4] : 0, f = c;
    "selectionchange" === a && 9 !== c.nodeType && (f = c.ownerDocument);
    if (null !== d && !b && $b36288e2db101ba3$var$Ye.has(a)) {
        if ("scroll" !== a) return;
        e |= 2;
        f = d;
    }
    var g = $b36288e2db101ba3$var$$e(f), h = a + "__" + (b ? "capture" : "bubble");
    g.has(h) || (b && (e |= 4), $b36288e2db101ba3$var$af(f, a, e, b), g.add(h));
}
function $b36288e2db101ba3$var$af(a, b, c, d) {
    var e = $b36288e2db101ba3$var$Nc.get(b);
    switch(void 0 === e ? 2 : e){
        case 0:
            e = $b36288e2db101ba3$var$gd;
            break;
        case 1:
            e = $b36288e2db101ba3$var$id;
            break;
        default:
            e = $b36288e2db101ba3$var$hd;
    }
    c = e.bind(null, b, c, a);
    e = void 0;
    !$b36288e2db101ba3$var$Pb || "touchstart" !== b && "touchmove" !== b && "wheel" !== b || (e = !0);
    d ? void 0 !== e ? a.addEventListener(b, c, {
        capture: !0,
        passive: e
    }) : a.addEventListener(b, c, !0) : void 0 !== e ? a.addEventListener(b, c, {
        passive: e
    }) : a.addEventListener(b, c, !1);
}
function $b36288e2db101ba3$var$jd(a, b, c, d, e) {
    var f = d;
    if (0 === (b & 1) && 0 === (b & 2) && null !== d) a: for(;;){
        if (null === d) return;
        var g = d.tag;
        if (3 === g || 4 === g) {
            var h = d.stateNode.containerInfo;
            if (h === e || 8 === h.nodeType && h.parentNode === e) break;
            if (4 === g) for(g = d.return; null !== g;){
                var k = g.tag;
                if (3 === k || 4 === k) {
                    if (k = g.stateNode.containerInfo, k === e || 8 === k.nodeType && k.parentNode === e) return;
                }
                g = g.return;
            }
            for(; null !== h;){
                g = $b36288e2db101ba3$var$wc(h);
                if (null === g) return;
                k = g.tag;
                if (5 === k || 6 === k) {
                    d = f = g;
                    continue a;
                }
                h = h.parentNode;
            }
        }
        d = d.return;
    }
    $b36288e2db101ba3$var$Nb(function() {
        var d = f, e = $b36288e2db101ba3$var$xb(c), g = [];
        a: {
            var h = $b36288e2db101ba3$var$Mc.get(a);
            if (void 0 !== h) {
                var k = $b36288e2db101ba3$var$td, x = a;
                switch(a){
                    case "keypress":
                        if (0 === $b36288e2db101ba3$var$od(c)) break a;
                    case "keydown":
                    case "keyup":
                        k = $b36288e2db101ba3$var$Rd;
                        break;
                    case "focusin":
                        x = "focus";
                        k = $b36288e2db101ba3$var$Fd;
                        break;
                    case "focusout":
                        x = "blur";
                        k = $b36288e2db101ba3$var$Fd;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        k = $b36288e2db101ba3$var$Fd;
                        break;
                    case "click":
                        if (2 === c.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        k = $b36288e2db101ba3$var$Bd;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        k = $b36288e2db101ba3$var$Dd;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        k = $b36288e2db101ba3$var$Vd;
                        break;
                    case $b36288e2db101ba3$var$Ic:
                    case $b36288e2db101ba3$var$Jc:
                    case $b36288e2db101ba3$var$Kc:
                        k = $b36288e2db101ba3$var$Hd;
                        break;
                    case $b36288e2db101ba3$var$Lc:
                        k = $b36288e2db101ba3$var$Xd;
                        break;
                    case "scroll":
                        k = $b36288e2db101ba3$var$vd;
                        break;
                    case "wheel":
                        k = $b36288e2db101ba3$var$Zd;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        k = $b36288e2db101ba3$var$Jd;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        k = $b36288e2db101ba3$var$Td;
                }
                var w = 0 !== (b & 4), z = !w && "scroll" === a, u = w ? null !== h ? h + "Capture" : null : h;
                w = [];
                for(var t = d, q; null !== t;){
                    q = t;
                    var v = q.stateNode;
                    5 === q.tag && null !== v && (q = v, null !== u && (v = $b36288e2db101ba3$var$Ob(t, u), null != v && w.push($b36288e2db101ba3$var$ef(t, v, q))));
                    if (z) break;
                    t = t.return;
                }
                0 < w.length && (h = new k(h, x, null, c, e), g.push({
                    event: h,
                    listeners: w
                }));
            }
        }
        if (0 === (b & 7)) {
            a: {
                h = "mouseover" === a || "pointerover" === a;
                k = "mouseout" === a || "pointerout" === a;
                if (h && 0 === (b & 16) && (x = c.relatedTarget || c.fromElement) && ($b36288e2db101ba3$var$wc(x) || x[$b36288e2db101ba3$var$ff])) break a;
                if (k || h) {
                    h = e.window === e ? e : (h = e.ownerDocument) ? h.defaultView || h.parentWindow : window;
                    if (k) {
                        if (x = c.relatedTarget || c.toElement, k = d, x = x ? $b36288e2db101ba3$var$wc(x) : null, null !== x && (z = $b36288e2db101ba3$var$Zb(x), x !== z || 5 !== x.tag && 6 !== x.tag)) x = null;
                    } else k = null, x = d;
                    if (k !== x) {
                        w = $b36288e2db101ba3$var$Bd;
                        v = "onMouseLeave";
                        u = "onMouseEnter";
                        t = "mouse";
                        if ("pointerout" === a || "pointerover" === a) w = $b36288e2db101ba3$var$Td, v = "onPointerLeave", u = "onPointerEnter", t = "pointer";
                        z = null == k ? h : $b36288e2db101ba3$var$ue(k);
                        q = null == x ? h : $b36288e2db101ba3$var$ue(x);
                        h = new w(v, t + "leave", k, c, e);
                        h.target = z;
                        h.relatedTarget = q;
                        v = null;
                        $b36288e2db101ba3$var$wc(e) === d && (w = new w(u, t + "enter", x, c, e), w.target = q, w.relatedTarget = z, v = w);
                        z = v;
                        if (k && x) b: {
                            w = k;
                            u = x;
                            t = 0;
                            for(q = w; q; q = $b36288e2db101ba3$var$gf(q))t++;
                            q = 0;
                            for(v = u; v; v = $b36288e2db101ba3$var$gf(v))q++;
                            for(; 0 < t - q;)w = $b36288e2db101ba3$var$gf(w), t--;
                            for(; 0 < q - t;)u = $b36288e2db101ba3$var$gf(u), q--;
                            for(; t--;){
                                if (w === u || null !== u && w === u.alternate) break b;
                                w = $b36288e2db101ba3$var$gf(w);
                                u = $b36288e2db101ba3$var$gf(u);
                            }
                            w = null;
                        }
                        else w = null;
                        null !== k && $b36288e2db101ba3$var$hf(g, h, k, w, !1);
                        null !== x && null !== z && $b36288e2db101ba3$var$hf(g, z, x, w, !0);
                    }
                }
            }
            a: {
                h = d ? $b36288e2db101ba3$var$ue(d) : window;
                k = h.nodeName && h.nodeName.toLowerCase();
                if ("select" === k || "input" === k && "file" === h.type) var J = $b36288e2db101ba3$var$ve;
                else if ($b36288e2db101ba3$var$me(h)) {
                    if ($b36288e2db101ba3$var$we) J = $b36288e2db101ba3$var$Fe;
                    else {
                        J = $b36288e2db101ba3$var$De;
                        var K = $b36288e2db101ba3$var$Ce;
                    }
                } else (k = h.nodeName) && "input" === k.toLowerCase() && ("checkbox" === h.type || "radio" === h.type) && (J = $b36288e2db101ba3$var$Ee);
                if (J && (J = J(a, d))) {
                    $b36288e2db101ba3$var$ne(g, J, c, e);
                    break a;
                }
                K && K(a, h, d);
                "focusout" === a && (K = h._wrapperState) && K.controlled && "number" === h.type && $b36288e2db101ba3$var$bb(h, "number", h.value);
            }
            K = d ? $b36288e2db101ba3$var$ue(d) : window;
            switch(a){
                case "focusin":
                    if ($b36288e2db101ba3$var$me(K) || "true" === K.contentEditable) $b36288e2db101ba3$var$Qe = K, $b36288e2db101ba3$var$Re = d, $b36288e2db101ba3$var$Se = null;
                    break;
                case "focusout":
                    $b36288e2db101ba3$var$Se = $b36288e2db101ba3$var$Re = $b36288e2db101ba3$var$Qe = null;
                    break;
                case "mousedown":
                    $b36288e2db101ba3$var$Te = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    $b36288e2db101ba3$var$Te = !1;
                    $b36288e2db101ba3$var$Ue(g, c, e);
                    break;
                case "selectionchange":
                    if ($b36288e2db101ba3$var$Pe) break;
                case "keydown":
                case "keyup":
                    $b36288e2db101ba3$var$Ue(g, c, e);
            }
            var Q;
            if ($b36288e2db101ba3$var$ae) b: {
                switch(a){
                    case "compositionstart":
                        var L = "onCompositionStart";
                        break b;
                    case "compositionend":
                        L = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        L = "onCompositionUpdate";
                        break b;
                }
                L = void 0;
            }
            else $b36288e2db101ba3$var$ie ? $b36288e2db101ba3$var$ge(a, c) && (L = "onCompositionEnd") : "keydown" === a && 229 === c.keyCode && (L = "onCompositionStart");
            L && ($b36288e2db101ba3$var$de && "ko" !== c.locale && ($b36288e2db101ba3$var$ie || "onCompositionStart" !== L ? "onCompositionEnd" === L && $b36288e2db101ba3$var$ie && (Q = $b36288e2db101ba3$var$nd()) : ($b36288e2db101ba3$var$kd = e, $b36288e2db101ba3$var$ld = "value" in $b36288e2db101ba3$var$kd ? $b36288e2db101ba3$var$kd.value : $b36288e2db101ba3$var$kd.textContent, $b36288e2db101ba3$var$ie = !0)), K = $b36288e2db101ba3$var$oe(d, L), 0 < K.length && (L = new $b36288e2db101ba3$var$Ld(L, a, null, c, e), g.push({
                event: L,
                listeners: K
            }), Q ? L.data = Q : (Q = $b36288e2db101ba3$var$he(c), null !== Q && (L.data = Q))));
            if (Q = $b36288e2db101ba3$var$ce ? $b36288e2db101ba3$var$je(a, c) : $b36288e2db101ba3$var$ke(a, c)) d = $b36288e2db101ba3$var$oe(d, "onBeforeInput"), 0 < d.length && (e = new $b36288e2db101ba3$var$Ld("onBeforeInput", "beforeinput", null, c, e), g.push({
                event: e,
                listeners: d
            }), e.data = Q);
        }
        $b36288e2db101ba3$var$se(g, b);
    });
}
function $b36288e2db101ba3$var$ef(a, b, c) {
    return {
        instance: a,
        listener: b,
        currentTarget: c
    };
}
function $b36288e2db101ba3$var$oe(a, b) {
    for(var c = b + "Capture", d = []; null !== a;){
        var e = a, f = e.stateNode;
        5 === e.tag && null !== f && (e = f, f = $b36288e2db101ba3$var$Ob(a, c), null != f && d.unshift($b36288e2db101ba3$var$ef(a, f, e)), f = $b36288e2db101ba3$var$Ob(a, b), null != f && d.push($b36288e2db101ba3$var$ef(a, f, e)));
        a = a.return;
    }
    return d;
}
function $b36288e2db101ba3$var$gf(a) {
    if (null === a) return null;
    do a = a.return;
    while (a && 5 !== a.tag);
    return a ? a : null;
}
function $b36288e2db101ba3$var$hf(a, b, c, d, e) {
    for(var f = b._reactName, g = []; null !== c && c !== d;){
        var h = c, k = h.alternate, l = h.stateNode;
        if (null !== k && k === d) break;
        5 === h.tag && null !== l && (h = l, e ? (k = $b36288e2db101ba3$var$Ob(c, f), null != k && g.unshift($b36288e2db101ba3$var$ef(c, k, h))) : e || (k = $b36288e2db101ba3$var$Ob(c, f), null != k && g.push($b36288e2db101ba3$var$ef(c, k, h))));
        c = c.return;
    }
    0 !== g.length && a.push({
        event: b,
        listeners: g
    });
}
function $b36288e2db101ba3$var$jf() {}
var $b36288e2db101ba3$var$kf = null, $b36288e2db101ba3$var$lf = null;
function $b36288e2db101ba3$var$mf(a, b) {
    switch(a){
        case "button":
        case "input":
        case "select":
        case "textarea":
            return !!b.autoFocus;
    }
    return !1;
}
function $b36288e2db101ba3$var$nf(a, b) {
    return "textarea" === a || "option" === a || "noscript" === a || "string" === typeof b.children || "number" === typeof b.children || "object" === typeof b.dangerouslySetInnerHTML && null !== b.dangerouslySetInnerHTML && null != b.dangerouslySetInnerHTML.__html;
}
var $b36288e2db101ba3$var$of = "function" === typeof setTimeout ? setTimeout : void 0, $b36288e2db101ba3$var$pf = "function" === typeof clearTimeout ? clearTimeout : void 0;
function $b36288e2db101ba3$var$qf(a) {
    1 === a.nodeType ? a.textContent = "" : 9 === a.nodeType && (a = a.body, null != a && (a.textContent = ""));
}
function $b36288e2db101ba3$var$rf(a) {
    for(; null != a; a = a.nextSibling){
        var b = a.nodeType;
        if (1 === b || 3 === b) break;
    }
    return a;
}
function $b36288e2db101ba3$var$sf(a) {
    a = a.previousSibling;
    for(var b = 0; a;){
        if (8 === a.nodeType) {
            var c = a.data;
            if ("$" === c || "$!" === c || "$?" === c) {
                if (0 === b) return a;
                b--;
            } else "/$" === c && b++;
        }
        a = a.previousSibling;
    }
    return null;
}
var $b36288e2db101ba3$var$tf = 0;
function $b36288e2db101ba3$var$uf(a) {
    return {
        $$typeof: $b36288e2db101ba3$var$Ga,
        toString: a,
        valueOf: a
    };
}
var $b36288e2db101ba3$var$vf = Math.random().toString(36).slice(2), $b36288e2db101ba3$var$wf = "__reactFiber$" + $b36288e2db101ba3$var$vf, $b36288e2db101ba3$var$xf = "__reactProps$" + $b36288e2db101ba3$var$vf, $b36288e2db101ba3$var$ff = "__reactContainer$" + $b36288e2db101ba3$var$vf, $b36288e2db101ba3$var$yf = "__reactEvents$" + $b36288e2db101ba3$var$vf;
function $b36288e2db101ba3$var$wc(a) {
    var b = a[$b36288e2db101ba3$var$wf];
    if (b) return b;
    for(var c = a.parentNode; c;){
        if (b = c[$b36288e2db101ba3$var$ff] || c[$b36288e2db101ba3$var$wf]) {
            c = b.alternate;
            if (null !== b.child || null !== c && null !== c.child) for(a = $b36288e2db101ba3$var$sf(a); null !== a;){
                if (c = a[$b36288e2db101ba3$var$wf]) return c;
                a = $b36288e2db101ba3$var$sf(a);
            }
            return b;
        }
        a = c;
        c = a.parentNode;
    }
    return null;
}
function $b36288e2db101ba3$var$Cb(a) {
    a = a[$b36288e2db101ba3$var$wf] || a[$b36288e2db101ba3$var$ff];
    return !a || 5 !== a.tag && 6 !== a.tag && 13 !== a.tag && 3 !== a.tag ? null : a;
}
function $b36288e2db101ba3$var$ue(a) {
    if (5 === a.tag || 6 === a.tag) return a.stateNode;
    throw Error($b36288e2db101ba3$var$y(33));
}
function $b36288e2db101ba3$var$Db(a) {
    return a[$b36288e2db101ba3$var$xf] || null;
}
function $b36288e2db101ba3$var$$e(a) {
    var b = a[$b36288e2db101ba3$var$yf];
    void 0 === b && (b = a[$b36288e2db101ba3$var$yf] = new Set);
    return b;
}
var $b36288e2db101ba3$var$zf = [], $b36288e2db101ba3$var$Af = -1;
function $b36288e2db101ba3$var$Bf(a) {
    return {
        current: a
    };
}
function $b36288e2db101ba3$var$H(a) {
    0 > $b36288e2db101ba3$var$Af || (a.current = $b36288e2db101ba3$var$zf[$b36288e2db101ba3$var$Af], $b36288e2db101ba3$var$zf[$b36288e2db101ba3$var$Af] = null, $b36288e2db101ba3$var$Af--);
}
function $b36288e2db101ba3$var$I(a, b) {
    $b36288e2db101ba3$var$Af++;
    $b36288e2db101ba3$var$zf[$b36288e2db101ba3$var$Af] = a.current;
    a.current = b;
}
var $b36288e2db101ba3$var$Cf = {}, $b36288e2db101ba3$var$M = $b36288e2db101ba3$var$Bf($b36288e2db101ba3$var$Cf), $b36288e2db101ba3$var$N = $b36288e2db101ba3$var$Bf(!1), $b36288e2db101ba3$var$Df = $b36288e2db101ba3$var$Cf;
function $b36288e2db101ba3$var$Ef(a, b) {
    var c = a.type.contextTypes;
    if (!c) return $b36288e2db101ba3$var$Cf;
    var d = a.stateNode;
    if (d && d.__reactInternalMemoizedUnmaskedChildContext === b) return d.__reactInternalMemoizedMaskedChildContext;
    var e = {}, f;
    for(f in c)e[f] = b[f];
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = b, a.__reactInternalMemoizedMaskedChildContext = e);
    return e;
}
function $b36288e2db101ba3$var$Ff(a) {
    a = a.childContextTypes;
    return null !== a && void 0 !== a;
}
function $b36288e2db101ba3$var$Gf() {
    $b36288e2db101ba3$var$H($b36288e2db101ba3$var$N);
    $b36288e2db101ba3$var$H($b36288e2db101ba3$var$M);
}
function $b36288e2db101ba3$var$Hf(a, b, c) {
    if ($b36288e2db101ba3$var$M.current !== $b36288e2db101ba3$var$Cf) throw Error($b36288e2db101ba3$var$y(168));
    $b36288e2db101ba3$var$I($b36288e2db101ba3$var$M, b);
    $b36288e2db101ba3$var$I($b36288e2db101ba3$var$N, c);
}
function $b36288e2db101ba3$var$If(a, b, c) {
    var d = a.stateNode;
    a = b.childContextTypes;
    if ("function" !== typeof d.getChildContext) return c;
    d = d.getChildContext();
    for(var e in d)if (!(e in a)) throw Error($b36288e2db101ba3$var$y(108, $b36288e2db101ba3$var$Ra(b) || "Unknown", e));
    return $4yvvI({}, c, d);
}
function $b36288e2db101ba3$var$Jf(a) {
    a = (a = a.stateNode) && a.__reactInternalMemoizedMergedChildContext || $b36288e2db101ba3$var$Cf;
    $b36288e2db101ba3$var$Df = $b36288e2db101ba3$var$M.current;
    $b36288e2db101ba3$var$I($b36288e2db101ba3$var$M, a);
    $b36288e2db101ba3$var$I($b36288e2db101ba3$var$N, $b36288e2db101ba3$var$N.current);
    return !0;
}
function $b36288e2db101ba3$var$Kf(a, b, c) {
    var d = a.stateNode;
    if (!d) throw Error($b36288e2db101ba3$var$y(169));
    c ? (a = $b36288e2db101ba3$var$If(a, b, $b36288e2db101ba3$var$Df), d.__reactInternalMemoizedMergedChildContext = a, $b36288e2db101ba3$var$H($b36288e2db101ba3$var$N), $b36288e2db101ba3$var$H($b36288e2db101ba3$var$M), $b36288e2db101ba3$var$I($b36288e2db101ba3$var$M, a)) : $b36288e2db101ba3$var$H($b36288e2db101ba3$var$N);
    $b36288e2db101ba3$var$I($b36288e2db101ba3$var$N, c);
}
var $b36288e2db101ba3$var$Lf = null, $b36288e2db101ba3$var$Mf = null, $b36288e2db101ba3$var$Nf = $4LCdk.unstable_runWithPriority, $b36288e2db101ba3$var$Of = $4LCdk.unstable_scheduleCallback, $b36288e2db101ba3$var$Pf = $4LCdk.unstable_cancelCallback, $b36288e2db101ba3$var$Qf = $4LCdk.unstable_shouldYield, $b36288e2db101ba3$var$Rf = $4LCdk.unstable_requestPaint, $b36288e2db101ba3$var$Sf = $4LCdk.unstable_now, $b36288e2db101ba3$var$Tf = $4LCdk.unstable_getCurrentPriorityLevel, $b36288e2db101ba3$var$Uf = $4LCdk.unstable_ImmediatePriority, $b36288e2db101ba3$var$Vf = $4LCdk.unstable_UserBlockingPriority, $b36288e2db101ba3$var$Wf = $4LCdk.unstable_NormalPriority, $b36288e2db101ba3$var$Xf = $4LCdk.unstable_LowPriority, $b36288e2db101ba3$var$Yf = $4LCdk.unstable_IdlePriority, $b36288e2db101ba3$var$Zf = {}, $b36288e2db101ba3$var$$f = void 0 !== $b36288e2db101ba3$var$Rf ? $b36288e2db101ba3$var$Rf : function() {}, $b36288e2db101ba3$var$ag = null, $b36288e2db101ba3$var$bg = null, $b36288e2db101ba3$var$cg = !1, $b36288e2db101ba3$var$dg = $b36288e2db101ba3$var$Sf(), $b36288e2db101ba3$var$O = 1E4 > $b36288e2db101ba3$var$dg ? $b36288e2db101ba3$var$Sf : function() {
    return $b36288e2db101ba3$var$Sf() - $b36288e2db101ba3$var$dg;
};
function $b36288e2db101ba3$var$eg() {
    switch($b36288e2db101ba3$var$Tf()){
        case $b36288e2db101ba3$var$Uf:
            return 99;
        case $b36288e2db101ba3$var$Vf:
            return 98;
        case $b36288e2db101ba3$var$Wf:
            return 97;
        case $b36288e2db101ba3$var$Xf:
            return 96;
        case $b36288e2db101ba3$var$Yf:
            return 95;
        default:
            throw Error($b36288e2db101ba3$var$y(332));
    }
}
function $b36288e2db101ba3$var$fg(a) {
    switch(a){
        case 99:
            return $b36288e2db101ba3$var$Uf;
        case 98:
            return $b36288e2db101ba3$var$Vf;
        case 97:
            return $b36288e2db101ba3$var$Wf;
        case 96:
            return $b36288e2db101ba3$var$Xf;
        case 95:
            return $b36288e2db101ba3$var$Yf;
        default:
            throw Error($b36288e2db101ba3$var$y(332));
    }
}
function $b36288e2db101ba3$var$gg(a, b) {
    a = $b36288e2db101ba3$var$fg(a);
    return $b36288e2db101ba3$var$Nf(a, b);
}
function $b36288e2db101ba3$var$hg(a, b, c) {
    a = $b36288e2db101ba3$var$fg(a);
    return $b36288e2db101ba3$var$Of(a, b, c);
}
function $b36288e2db101ba3$var$ig() {
    if (null !== $b36288e2db101ba3$var$bg) {
        var a = $b36288e2db101ba3$var$bg;
        $b36288e2db101ba3$var$bg = null;
        $b36288e2db101ba3$var$Pf(a);
    }
    $b36288e2db101ba3$var$jg();
}
function $b36288e2db101ba3$var$jg() {
    if (!$b36288e2db101ba3$var$cg && null !== $b36288e2db101ba3$var$ag) {
        $b36288e2db101ba3$var$cg = !0;
        var a = 0;
        try {
            var b = $b36288e2db101ba3$var$ag;
            $b36288e2db101ba3$var$gg(99, function() {
                for(; a < b.length; a++){
                    var c = b[a];
                    do c = c(!0);
                    while (null !== c);
                }
            });
            $b36288e2db101ba3$var$ag = null;
        } catch (c) {
            throw null !== $b36288e2db101ba3$var$ag && ($b36288e2db101ba3$var$ag = $b36288e2db101ba3$var$ag.slice(a + 1)), $b36288e2db101ba3$var$Of($b36288e2db101ba3$var$Uf, $b36288e2db101ba3$var$ig), c;
        } finally{
            $b36288e2db101ba3$var$cg = !1;
        }
    }
}
var $b36288e2db101ba3$var$kg = $b36288e2db101ba3$var$ra.ReactCurrentBatchConfig;
function $b36288e2db101ba3$var$lg(a, b) {
    if (a && a.defaultProps) {
        b = $4yvvI({}, b);
        a = a.defaultProps;
        for(var c in a)void 0 === b[c] && (b[c] = a[c]);
        return b;
    }
    return b;
}
var $b36288e2db101ba3$var$mg = $b36288e2db101ba3$var$Bf(null), $b36288e2db101ba3$var$ng = null, $b36288e2db101ba3$var$og = null, $b36288e2db101ba3$var$pg = null;
function $b36288e2db101ba3$var$qg() {
    $b36288e2db101ba3$var$pg = $b36288e2db101ba3$var$og = $b36288e2db101ba3$var$ng = null;
}
function $b36288e2db101ba3$var$rg(a) {
    var b = $b36288e2db101ba3$var$mg.current;
    $b36288e2db101ba3$var$H($b36288e2db101ba3$var$mg);
    a.type._context._currentValue = b;
}
function $b36288e2db101ba3$var$sg(a, b) {
    for(; null !== a;){
        var c = a.alternate;
        if ((a.childLanes & b) === b) {
            if (null === c || (c.childLanes & b) === b) break;
            else c.childLanes |= b;
        } else a.childLanes |= b, null !== c && (c.childLanes |= b);
        a = a.return;
    }
}
function $b36288e2db101ba3$var$tg(a, b) {
    $b36288e2db101ba3$var$ng = a;
    $b36288e2db101ba3$var$pg = $b36288e2db101ba3$var$og = null;
    a = a.dependencies;
    null !== a && null !== a.firstContext && (0 !== (a.lanes & b) && ($b36288e2db101ba3$var$ug = !0), a.firstContext = null);
}
function $b36288e2db101ba3$var$vg(a, b) {
    if ($b36288e2db101ba3$var$pg !== a && !1 !== b && 0 !== b) {
        if ("number" !== typeof b || 1073741823 === b) $b36288e2db101ba3$var$pg = a, b = 1073741823;
        b = {
            context: a,
            observedBits: b,
            next: null
        };
        if (null === $b36288e2db101ba3$var$og) {
            if (null === $b36288e2db101ba3$var$ng) throw Error($b36288e2db101ba3$var$y(308));
            $b36288e2db101ba3$var$og = b;
            $b36288e2db101ba3$var$ng.dependencies = {
                lanes: 0,
                firstContext: b,
                responders: null
            };
        } else $b36288e2db101ba3$var$og = $b36288e2db101ba3$var$og.next = b;
    }
    return a._currentValue;
}
var $b36288e2db101ba3$var$wg = !1;
function $b36288e2db101ba3$var$xg(a) {
    a.updateQueue = {
        baseState: a.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null
        },
        effects: null
    };
}
function $b36288e2db101ba3$var$yg(a, b) {
    a = a.updateQueue;
    b.updateQueue === a && (b.updateQueue = {
        baseState: a.baseState,
        firstBaseUpdate: a.firstBaseUpdate,
        lastBaseUpdate: a.lastBaseUpdate,
        shared: a.shared,
        effects: a.effects
    });
}
function $b36288e2db101ba3$var$zg(a, b) {
    return {
        eventTime: a,
        lane: b,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function $b36288e2db101ba3$var$Ag(a, b) {
    a = a.updateQueue;
    if (null !== a) {
        a = a.shared;
        var c = a.pending;
        null === c ? b.next = b : (b.next = c.next, c.next = b);
        a.pending = b;
    }
}
function $b36288e2db101ba3$var$Bg(a, b) {
    var c = a.updateQueue, d = a.alternate;
    if (null !== d && (d = d.updateQueue, c === d)) {
        var e = null, f = null;
        c = c.firstBaseUpdate;
        if (null !== c) {
            do {
                var g = {
                    eventTime: c.eventTime,
                    lane: c.lane,
                    tag: c.tag,
                    payload: c.payload,
                    callback: c.callback,
                    next: null
                };
                null === f ? e = f = g : f = f.next = g;
                c = c.next;
            }while (null !== c);
            null === f ? e = f = b : f = f.next = b;
        } else e = f = b;
        c = {
            baseState: d.baseState,
            firstBaseUpdate: e,
            lastBaseUpdate: f,
            shared: d.shared,
            effects: d.effects
        };
        a.updateQueue = c;
        return;
    }
    a = c.lastBaseUpdate;
    null === a ? c.firstBaseUpdate = b : a.next = b;
    c.lastBaseUpdate = b;
}
function $b36288e2db101ba3$var$Cg(a, b, c, d) {
    var e = a.updateQueue;
    $b36288e2db101ba3$var$wg = !1;
    var f = e.firstBaseUpdate, g = e.lastBaseUpdate, h = e.shared.pending;
    if (null !== h) {
        e.shared.pending = null;
        var k = h, l = k.next;
        k.next = null;
        null === g ? f = l : g.next = l;
        g = k;
        var n = a.alternate;
        if (null !== n) {
            n = n.updateQueue;
            var A = n.lastBaseUpdate;
            A !== g && (null === A ? n.firstBaseUpdate = l : A.next = l, n.lastBaseUpdate = k);
        }
    }
    if (null !== f) {
        A = e.baseState;
        g = 0;
        n = l = k = null;
        do {
            h = f.lane;
            var p = f.eventTime;
            if ((d & h) === h) {
                null !== n && (n = n.next = {
                    eventTime: p,
                    lane: 0,
                    tag: f.tag,
                    payload: f.payload,
                    callback: f.callback,
                    next: null
                });
                a: {
                    var C = a, x = f;
                    h = b;
                    p = c;
                    switch(x.tag){
                        case 1:
                            C = x.payload;
                            if ("function" === typeof C) {
                                A = C.call(p, A, h);
                                break a;
                            }
                            A = C;
                            break a;
                        case 3:
                            C.flags = C.flags & -4097 | 64;
                        case 0:
                            C = x.payload;
                            h = "function" === typeof C ? C.call(p, A, h) : C;
                            if (null === h || void 0 === h) break a;
                            A = $4yvvI({}, A, h);
                            break a;
                        case 2:
                            $b36288e2db101ba3$var$wg = !0;
                    }
                }
                null !== f.callback && (a.flags |= 32, h = e.effects, null === h ? e.effects = [
                    f
                ] : h.push(f));
            } else p = {
                eventTime: p,
                lane: h,
                tag: f.tag,
                payload: f.payload,
                callback: f.callback,
                next: null
            }, null === n ? (l = n = p, k = A) : n = n.next = p, g |= h;
            f = f.next;
            if (null === f) {
                if (h = e.shared.pending, null === h) break;
                else f = h.next, h.next = null, e.lastBaseUpdate = h, e.shared.pending = null;
            }
        }while (1);
        null === n && (k = A);
        e.baseState = k;
        e.firstBaseUpdate = l;
        e.lastBaseUpdate = n;
        $b36288e2db101ba3$var$Dg |= g;
        a.lanes = g;
        a.memoizedState = A;
    }
}
function $b36288e2db101ba3$var$Eg(a, b, c) {
    a = b.effects;
    b.effects = null;
    if (null !== a) for(b = 0; b < a.length; b++){
        var d = a[b], e = d.callback;
        if (null !== e) {
            d.callback = null;
            d = c;
            if ("function" !== typeof e) throw Error($b36288e2db101ba3$var$y(191, e));
            e.call(d);
        }
    }
}
var $b36288e2db101ba3$var$Fg = (new $bh6RR.Component).refs;
function $b36288e2db101ba3$var$Gg(a, b, c, d) {
    b = a.memoizedState;
    c = c(d, b);
    c = null === c || void 0 === c ? b : $4yvvI({}, b, c);
    a.memoizedState = c;
    0 === a.lanes && (a.updateQueue.baseState = c);
}
var $b36288e2db101ba3$var$Kg = {
    isMounted: function(a) {
        return (a = a._reactInternals) ? $b36288e2db101ba3$var$Zb(a) === a : !1;
    },
    enqueueSetState: function(a, b, c) {
        a = a._reactInternals;
        var d = $b36288e2db101ba3$var$Hg(), e = $b36288e2db101ba3$var$Ig(a), f = $b36288e2db101ba3$var$zg(d, e);
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        $b36288e2db101ba3$var$Ag(a, f);
        $b36288e2db101ba3$var$Jg(a, e, d);
    },
    enqueueReplaceState: function(a, b, c) {
        a = a._reactInternals;
        var d = $b36288e2db101ba3$var$Hg(), e = $b36288e2db101ba3$var$Ig(a), f = $b36288e2db101ba3$var$zg(d, e);
        f.tag = 1;
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        $b36288e2db101ba3$var$Ag(a, f);
        $b36288e2db101ba3$var$Jg(a, e, d);
    },
    enqueueForceUpdate: function(a, b) {
        a = a._reactInternals;
        var c = $b36288e2db101ba3$var$Hg(), d = $b36288e2db101ba3$var$Ig(a), e = $b36288e2db101ba3$var$zg(c, d);
        e.tag = 2;
        void 0 !== b && null !== b && (e.callback = b);
        $b36288e2db101ba3$var$Ag(a, e);
        $b36288e2db101ba3$var$Jg(a, d, c);
    }
};
function $b36288e2db101ba3$var$Lg(a, b, c, d, e, f, g) {
    a = a.stateNode;
    return "function" === typeof a.shouldComponentUpdate ? a.shouldComponentUpdate(d, f, g) : b.prototype && b.prototype.isPureReactComponent ? !$b36288e2db101ba3$var$Je(c, d) || !$b36288e2db101ba3$var$Je(e, f) : !0;
}
function $b36288e2db101ba3$var$Mg(a, b, c) {
    var d = !1, e = $b36288e2db101ba3$var$Cf;
    var f = b.contextType;
    "object" === typeof f && null !== f ? f = $b36288e2db101ba3$var$vg(f) : (e = $b36288e2db101ba3$var$Ff(b) ? $b36288e2db101ba3$var$Df : $b36288e2db101ba3$var$M.current, d = b.contextTypes, f = (d = null !== d && void 0 !== d) ? $b36288e2db101ba3$var$Ef(a, e) : $b36288e2db101ba3$var$Cf);
    b = new b(c, f);
    a.memoizedState = null !== b.state && void 0 !== b.state ? b.state : null;
    b.updater = $b36288e2db101ba3$var$Kg;
    a.stateNode = b;
    b._reactInternals = a;
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = e, a.__reactInternalMemoizedMaskedChildContext = f);
    return b;
}
function $b36288e2db101ba3$var$Ng(a, b, c, d) {
    a = b.state;
    "function" === typeof b.componentWillReceiveProps && b.componentWillReceiveProps(c, d);
    "function" === typeof b.UNSAFE_componentWillReceiveProps && b.UNSAFE_componentWillReceiveProps(c, d);
    b.state !== a && $b36288e2db101ba3$var$Kg.enqueueReplaceState(b, b.state, null);
}
function $b36288e2db101ba3$var$Og(a, b, c, d) {
    var e = a.stateNode;
    e.props = c;
    e.state = a.memoizedState;
    e.refs = $b36288e2db101ba3$var$Fg;
    $b36288e2db101ba3$var$xg(a);
    var f = b.contextType;
    "object" === typeof f && null !== f ? e.context = $b36288e2db101ba3$var$vg(f) : (f = $b36288e2db101ba3$var$Ff(b) ? $b36288e2db101ba3$var$Df : $b36288e2db101ba3$var$M.current, e.context = $b36288e2db101ba3$var$Ef(a, f));
    $b36288e2db101ba3$var$Cg(a, c, e, d);
    e.state = a.memoizedState;
    f = b.getDerivedStateFromProps;
    "function" === typeof f && ($b36288e2db101ba3$var$Gg(a, b, f, c), e.state = a.memoizedState);
    "function" === typeof b.getDerivedStateFromProps || "function" === typeof e.getSnapshotBeforeUpdate || "function" !== typeof e.UNSAFE_componentWillMount && "function" !== typeof e.componentWillMount || (b = e.state, "function" === typeof e.componentWillMount && e.componentWillMount(), "function" === typeof e.UNSAFE_componentWillMount && e.UNSAFE_componentWillMount(), b !== e.state && $b36288e2db101ba3$var$Kg.enqueueReplaceState(e, e.state, null), $b36288e2db101ba3$var$Cg(a, c, e, d), e.state = a.memoizedState);
    "function" === typeof e.componentDidMount && (a.flags |= 4);
}
var $b36288e2db101ba3$var$Pg = Array.isArray;
function $b36288e2db101ba3$var$Qg(a, b, c) {
    a = c.ref;
    if (null !== a && "function" !== typeof a && "object" !== typeof a) {
        if (c._owner) {
            c = c._owner;
            if (c) {
                if (1 !== c.tag) throw Error($b36288e2db101ba3$var$y(309));
                var d = c.stateNode;
            }
            if (!d) throw Error($b36288e2db101ba3$var$y(147, a));
            var e = "" + a;
            if (null !== b && null !== b.ref && "function" === typeof b.ref && b.ref._stringRef === e) return b.ref;
            b = function(a) {
                var b = d.refs;
                b === $b36288e2db101ba3$var$Fg && (b = d.refs = {});
                null === a ? delete b[e] : b[e] = a;
            };
            b._stringRef = e;
            return b;
        }
        if ("string" !== typeof a) throw Error($b36288e2db101ba3$var$y(284));
        if (!c._owner) throw Error($b36288e2db101ba3$var$y(290, a));
    }
    return a;
}
function $b36288e2db101ba3$var$Rg(a, b) {
    if ("textarea" !== a.type) throw Error($b36288e2db101ba3$var$y(31, "[object Object]" === Object.prototype.toString.call(b) ? "object with keys {" + Object.keys(b).join(", ") + "}" : b));
}
function $b36288e2db101ba3$var$Sg(a) {
    function b(b, c) {
        if (a) {
            var d = b.lastEffect;
            null !== d ? (d.nextEffect = c, b.lastEffect = c) : b.firstEffect = b.lastEffect = c;
            c.nextEffect = null;
            c.flags = 8;
        }
    }
    function c(c, d) {
        if (!a) return null;
        for(; null !== d;)b(c, d), d = d.sibling;
        return null;
    }
    function d(a, b) {
        for(a = new Map; null !== b;)null !== b.key ? a.set(b.key, b) : a.set(b.index, b), b = b.sibling;
        return a;
    }
    function e(a, b) {
        a = $b36288e2db101ba3$var$Tg(a, b);
        a.index = 0;
        a.sibling = null;
        return a;
    }
    function f(b, c, d) {
        b.index = d;
        if (!a) return c;
        d = b.alternate;
        if (null !== d) return d = d.index, d < c ? (b.flags = 2, c) : d;
        b.flags = 2;
        return c;
    }
    function g(b) {
        a && null === b.alternate && (b.flags = 2);
        return b;
    }
    function h(a, b, c, d) {
        if (null === b || 6 !== b.tag) return b = $b36288e2db101ba3$var$Ug(c, a.mode, d), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function k(a, b, c, d) {
        if (null !== b && b.elementType === c.type) return d = e(b, c.props), d.ref = $b36288e2db101ba3$var$Qg(a, b, c), d.return = a, d;
        d = $b36288e2db101ba3$var$Vg(c.type, c.key, c.props, null, a.mode, d);
        d.ref = $b36288e2db101ba3$var$Qg(a, b, c);
        d.return = a;
        return d;
    }
    function l(a, b, c, d) {
        if (null === b || 4 !== b.tag || b.stateNode.containerInfo !== c.containerInfo || b.stateNode.implementation !== c.implementation) return b = $b36288e2db101ba3$var$Wg(c, a.mode, d), b.return = a, b;
        b = e(b, c.children || []);
        b.return = a;
        return b;
    }
    function n(a, b, c, d, f) {
        if (null === b || 7 !== b.tag) return b = $b36288e2db101ba3$var$Xg(c, a.mode, d, f), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function A(a, b, c) {
        if ("string" === typeof b || "number" === typeof b) return b = $b36288e2db101ba3$var$Ug("" + b, a.mode, c), b.return = a, b;
        if ("object" === typeof b && null !== b) {
            switch(b.$$typeof){
                case $b36288e2db101ba3$var$sa:
                    return c = $b36288e2db101ba3$var$Vg(b.type, b.key, b.props, null, a.mode, c), c.ref = $b36288e2db101ba3$var$Qg(a, null, b), c.return = a, c;
                case $b36288e2db101ba3$var$ta:
                    return b = $b36288e2db101ba3$var$Wg(b, a.mode, c), b.return = a, b;
            }
            if ($b36288e2db101ba3$var$Pg(b) || $b36288e2db101ba3$var$La(b)) return b = $b36288e2db101ba3$var$Xg(b, a.mode, c, null), b.return = a, b;
            $b36288e2db101ba3$var$Rg(a, b);
        }
        return null;
    }
    function p(a, b, c, d) {
        var e = null !== b ? b.key : null;
        if ("string" === typeof c || "number" === typeof c) return null !== e ? null : h(a, b, "" + c, d);
        if ("object" === typeof c && null !== c) {
            switch(c.$$typeof){
                case $b36288e2db101ba3$var$sa:
                    return c.key === e ? c.type === $b36288e2db101ba3$var$ua ? n(a, b, c.props.children, d, e) : k(a, b, c, d) : null;
                case $b36288e2db101ba3$var$ta:
                    return c.key === e ? l(a, b, c, d) : null;
            }
            if ($b36288e2db101ba3$var$Pg(c) || $b36288e2db101ba3$var$La(c)) return null !== e ? null : n(a, b, c, d, null);
            $b36288e2db101ba3$var$Rg(a, c);
        }
        return null;
    }
    function C(a, b, c, d, e) {
        if ("string" === typeof d || "number" === typeof d) return a = a.get(c) || null, h(b, a, "" + d, e);
        if ("object" === typeof d && null !== d) {
            switch(d.$$typeof){
                case $b36288e2db101ba3$var$sa:
                    return a = a.get(null === d.key ? c : d.key) || null, d.type === $b36288e2db101ba3$var$ua ? n(b, a, d.props.children, e, d.key) : k(b, a, d, e);
                case $b36288e2db101ba3$var$ta:
                    return a = a.get(null === d.key ? c : d.key) || null, l(b, a, d, e);
            }
            if ($b36288e2db101ba3$var$Pg(d) || $b36288e2db101ba3$var$La(d)) return a = a.get(c) || null, n(b, a, d, e, null);
            $b36288e2db101ba3$var$Rg(b, d);
        }
        return null;
    }
    function x(e, g, h, k) {
        for(var l = null, t = null, u = g, z = g = 0, q = null; null !== u && z < h.length; z++){
            u.index > z ? (q = u, u = null) : q = u.sibling;
            var n = p(e, u, h[z], k);
            if (null === n) {
                null === u && (u = q);
                break;
            }
            a && u && null === n.alternate && b(e, u);
            g = f(n, g, z);
            null === t ? l = n : t.sibling = n;
            t = n;
            u = q;
        }
        if (z === h.length) return c(e, u), l;
        if (null === u) {
            for(; z < h.length; z++)u = A(e, h[z], k), null !== u && (g = f(u, g, z), null === t ? l = u : t.sibling = u, t = u);
            return l;
        }
        for(u = d(e, u); z < h.length; z++)q = C(u, e, z, h[z], k), null !== q && (a && null !== q.alternate && u.delete(null === q.key ? z : q.key), g = f(q, g, z), null === t ? l = q : t.sibling = q, t = q);
        a && u.forEach(function(a) {
            return b(e, a);
        });
        return l;
    }
    function w(e, g, h, k) {
        var l = $b36288e2db101ba3$var$La(h);
        if ("function" !== typeof l) throw Error($b36288e2db101ba3$var$y(150));
        h = l.call(h);
        if (null == h) throw Error($b36288e2db101ba3$var$y(151));
        for(var t = l = null, u = g, z = g = 0, q = null, n = h.next(); null !== u && !n.done; z++, n = h.next()){
            u.index > z ? (q = u, u = null) : q = u.sibling;
            var w = p(e, u, n.value, k);
            if (null === w) {
                null === u && (u = q);
                break;
            }
            a && u && null === w.alternate && b(e, u);
            g = f(w, g, z);
            null === t ? l = w : t.sibling = w;
            t = w;
            u = q;
        }
        if (n.done) return c(e, u), l;
        if (null === u) {
            for(; !n.done; z++, n = h.next())n = A(e, n.value, k), null !== n && (g = f(n, g, z), null === t ? l = n : t.sibling = n, t = n);
            return l;
        }
        for(u = d(e, u); !n.done; z++, n = h.next())n = C(u, e, z, n.value, k), null !== n && (a && null !== n.alternate && u.delete(null === n.key ? z : n.key), g = f(n, g, z), null === t ? l = n : t.sibling = n, t = n);
        a && u.forEach(function(a) {
            return b(e, a);
        });
        return l;
    }
    return function(a, d, f, h) {
        var k = "object" === typeof f && null !== f && f.type === $b36288e2db101ba3$var$ua && null === f.key;
        k && (f = f.props.children);
        var l = "object" === typeof f && null !== f;
        if (l) switch(f.$$typeof){
            case $b36288e2db101ba3$var$sa:
                a: {
                    l = f.key;
                    for(k = d; null !== k;){
                        if (k.key === l) {
                            switch(k.tag){
                                case 7:
                                    if (f.type === $b36288e2db101ba3$var$ua) {
                                        c(a, k.sibling);
                                        d = e(k, f.props.children);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    }
                                    break;
                                default:
                                    if (k.elementType === f.type) {
                                        c(a, k.sibling);
                                        d = e(k, f.props);
                                        d.ref = $b36288e2db101ba3$var$Qg(a, k, f);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    }
                            }
                            c(a, k);
                            break;
                        } else b(a, k);
                        k = k.sibling;
                    }
                    f.type === $b36288e2db101ba3$var$ua ? (d = $b36288e2db101ba3$var$Xg(f.props.children, a.mode, h, f.key), d.return = a, a = d) : (h = $b36288e2db101ba3$var$Vg(f.type, f.key, f.props, null, a.mode, h), h.ref = $b36288e2db101ba3$var$Qg(a, d, f), h.return = a, a = h);
                }
                return g(a);
            case $b36288e2db101ba3$var$ta:
                a: {
                    for(k = f.key; null !== d;){
                        if (d.key === k) {
                            if (4 === d.tag && d.stateNode.containerInfo === f.containerInfo && d.stateNode.implementation === f.implementation) {
                                c(a, d.sibling);
                                d = e(d, f.children || []);
                                d.return = a;
                                a = d;
                                break a;
                            } else {
                                c(a, d);
                                break;
                            }
                        } else b(a, d);
                        d = d.sibling;
                    }
                    d = $b36288e2db101ba3$var$Wg(f, a.mode, h);
                    d.return = a;
                    a = d;
                }
                return g(a);
        }
        if ("string" === typeof f || "number" === typeof f) return f = "" + f, null !== d && 6 === d.tag ? (c(a, d.sibling), d = e(d, f), d.return = a, a = d) : (c(a, d), d = $b36288e2db101ba3$var$Ug(f, a.mode, h), d.return = a, a = d), g(a);
        if ($b36288e2db101ba3$var$Pg(f)) return x(a, d, f, h);
        if ($b36288e2db101ba3$var$La(f)) return w(a, d, f, h);
        l && $b36288e2db101ba3$var$Rg(a, f);
        if ("undefined" === typeof f && !k) switch(a.tag){
            case 1:
            case 22:
            case 0:
            case 11:
            case 15:
                throw Error($b36288e2db101ba3$var$y(152, $b36288e2db101ba3$var$Ra(a.type) || "Component"));
        }
        return c(a, d);
    };
}
var $b36288e2db101ba3$var$Yg = $b36288e2db101ba3$var$Sg(!0), $b36288e2db101ba3$var$Zg = $b36288e2db101ba3$var$Sg(!1), $b36288e2db101ba3$var$$g = {}, $b36288e2db101ba3$var$ah = $b36288e2db101ba3$var$Bf($b36288e2db101ba3$var$$g), $b36288e2db101ba3$var$bh = $b36288e2db101ba3$var$Bf($b36288e2db101ba3$var$$g), $b36288e2db101ba3$var$ch = $b36288e2db101ba3$var$Bf($b36288e2db101ba3$var$$g);
function $b36288e2db101ba3$var$dh(a) {
    if (a === $b36288e2db101ba3$var$$g) throw Error($b36288e2db101ba3$var$y(174));
    return a;
}
function $b36288e2db101ba3$var$eh(a, b) {
    $b36288e2db101ba3$var$I($b36288e2db101ba3$var$ch, b);
    $b36288e2db101ba3$var$I($b36288e2db101ba3$var$bh, a);
    $b36288e2db101ba3$var$I($b36288e2db101ba3$var$ah, $b36288e2db101ba3$var$$g);
    a = b.nodeType;
    switch(a){
        case 9:
        case 11:
            b = (b = b.documentElement) ? b.namespaceURI : $b36288e2db101ba3$var$mb(null, "");
            break;
        default:
            a = 8 === a ? b.parentNode : b, b = a.namespaceURI || null, a = a.tagName, b = $b36288e2db101ba3$var$mb(b, a);
    }
    $b36288e2db101ba3$var$H($b36288e2db101ba3$var$ah);
    $b36288e2db101ba3$var$I($b36288e2db101ba3$var$ah, b);
}
function $b36288e2db101ba3$var$fh() {
    $b36288e2db101ba3$var$H($b36288e2db101ba3$var$ah);
    $b36288e2db101ba3$var$H($b36288e2db101ba3$var$bh);
    $b36288e2db101ba3$var$H($b36288e2db101ba3$var$ch);
}
function $b36288e2db101ba3$var$gh(a) {
    $b36288e2db101ba3$var$dh($b36288e2db101ba3$var$ch.current);
    var b = $b36288e2db101ba3$var$dh($b36288e2db101ba3$var$ah.current);
    var c = $b36288e2db101ba3$var$mb(b, a.type);
    b !== c && ($b36288e2db101ba3$var$I($b36288e2db101ba3$var$bh, a), $b36288e2db101ba3$var$I($b36288e2db101ba3$var$ah, c));
}
function $b36288e2db101ba3$var$hh(a) {
    $b36288e2db101ba3$var$bh.current === a && ($b36288e2db101ba3$var$H($b36288e2db101ba3$var$ah), $b36288e2db101ba3$var$H($b36288e2db101ba3$var$bh));
}
var $b36288e2db101ba3$var$P = $b36288e2db101ba3$var$Bf(0);
function $b36288e2db101ba3$var$ih(a) {
    for(var b = a; null !== b;){
        if (13 === b.tag) {
            var c = b.memoizedState;
            if (null !== c && (c = c.dehydrated, null === c || "$?" === c.data || "$!" === c.data)) return b;
        } else if (19 === b.tag && void 0 !== b.memoizedProps.revealOrder) {
            if (0 !== (b.flags & 64)) return b;
        } else if (null !== b.child) {
            b.child.return = b;
            b = b.child;
            continue;
        }
        if (b === a) break;
        for(; null === b.sibling;){
            if (null === b.return || b.return === a) return null;
            b = b.return;
        }
        b.sibling.return = b.return;
        b = b.sibling;
    }
    return null;
}
var $b36288e2db101ba3$var$jh = null, $b36288e2db101ba3$var$kh = null, $b36288e2db101ba3$var$lh = !1;
function $b36288e2db101ba3$var$mh(a, b) {
    var c = $b36288e2db101ba3$var$nh(5, null, null, 0);
    c.elementType = "DELETED";
    c.type = "DELETED";
    c.stateNode = b;
    c.return = a;
    c.flags = 8;
    null !== a.lastEffect ? (a.lastEffect.nextEffect = c, a.lastEffect = c) : a.firstEffect = a.lastEffect = c;
}
function $b36288e2db101ba3$var$oh(a, b) {
    switch(a.tag){
        case 5:
            var c = a.type;
            b = 1 !== b.nodeType || c.toLowerCase() !== b.nodeName.toLowerCase() ? null : b;
            return null !== b ? (a.stateNode = b, !0) : !1;
        case 6:
            return b = "" === a.pendingProps || 3 !== b.nodeType ? null : b, null !== b ? (a.stateNode = b, !0) : !1;
        case 13:
            return !1;
        default:
            return !1;
    }
}
function $b36288e2db101ba3$var$ph(a) {
    if ($b36288e2db101ba3$var$lh) {
        var b = $b36288e2db101ba3$var$kh;
        if (b) {
            var c = b;
            if (!$b36288e2db101ba3$var$oh(a, b)) {
                b = $b36288e2db101ba3$var$rf(c.nextSibling);
                if (!b || !$b36288e2db101ba3$var$oh(a, b)) {
                    a.flags = a.flags & -1025 | 2;
                    $b36288e2db101ba3$var$lh = !1;
                    $b36288e2db101ba3$var$jh = a;
                    return;
                }
                $b36288e2db101ba3$var$mh($b36288e2db101ba3$var$jh, c);
            }
            $b36288e2db101ba3$var$jh = a;
            $b36288e2db101ba3$var$kh = $b36288e2db101ba3$var$rf(b.firstChild);
        } else a.flags = a.flags & -1025 | 2, $b36288e2db101ba3$var$lh = !1, $b36288e2db101ba3$var$jh = a;
    }
}
function $b36288e2db101ba3$var$qh(a) {
    for(a = a.return; null !== a && 5 !== a.tag && 3 !== a.tag && 13 !== a.tag;)a = a.return;
    $b36288e2db101ba3$var$jh = a;
}
function $b36288e2db101ba3$var$rh(a) {
    if (a !== $b36288e2db101ba3$var$jh) return !1;
    if (!$b36288e2db101ba3$var$lh) return $b36288e2db101ba3$var$qh(a), $b36288e2db101ba3$var$lh = !0, !1;
    var b = a.type;
    if (5 !== a.tag || "head" !== b && "body" !== b && !$b36288e2db101ba3$var$nf(b, a.memoizedProps)) for(b = $b36288e2db101ba3$var$kh; b;)$b36288e2db101ba3$var$mh(a, b), b = $b36288e2db101ba3$var$rf(b.nextSibling);
    $b36288e2db101ba3$var$qh(a);
    if (13 === a.tag) {
        a = a.memoizedState;
        a = null !== a ? a.dehydrated : null;
        if (!a) throw Error($b36288e2db101ba3$var$y(317));
        a: {
            a = a.nextSibling;
            for(b = 0; a;){
                if (8 === a.nodeType) {
                    var c = a.data;
                    if ("/$" === c) {
                        if (0 === b) {
                            $b36288e2db101ba3$var$kh = $b36288e2db101ba3$var$rf(a.nextSibling);
                            break a;
                        }
                        b--;
                    } else "$" !== c && "$!" !== c && "$?" !== c || b++;
                }
                a = a.nextSibling;
            }
            $b36288e2db101ba3$var$kh = null;
        }
    } else $b36288e2db101ba3$var$kh = $b36288e2db101ba3$var$jh ? $b36288e2db101ba3$var$rf(a.stateNode.nextSibling) : null;
    return !0;
}
function $b36288e2db101ba3$var$sh() {
    $b36288e2db101ba3$var$kh = $b36288e2db101ba3$var$jh = null;
    $b36288e2db101ba3$var$lh = !1;
}
var $b36288e2db101ba3$var$th = [];
function $b36288e2db101ba3$var$uh() {
    for(var a = 0; a < $b36288e2db101ba3$var$th.length; a++)$b36288e2db101ba3$var$th[a]._workInProgressVersionPrimary = null;
    $b36288e2db101ba3$var$th.length = 0;
}
var $b36288e2db101ba3$var$vh = $b36288e2db101ba3$var$ra.ReactCurrentDispatcher, $b36288e2db101ba3$var$wh = $b36288e2db101ba3$var$ra.ReactCurrentBatchConfig, $b36288e2db101ba3$var$xh = 0, $b36288e2db101ba3$var$R = null, $b36288e2db101ba3$var$S = null, $b36288e2db101ba3$var$T = null, $b36288e2db101ba3$var$yh = !1, $b36288e2db101ba3$var$zh = !1;
function $b36288e2db101ba3$var$Ah() {
    throw Error($b36288e2db101ba3$var$y(321));
}
function $b36288e2db101ba3$var$Bh(a, b) {
    if (null === b) return !1;
    for(var c = 0; c < b.length && c < a.length; c++)if (!$b36288e2db101ba3$var$He(a[c], b[c])) return !1;
    return !0;
}
function $b36288e2db101ba3$var$Ch(a, b, c, d, e, f) {
    $b36288e2db101ba3$var$xh = f;
    $b36288e2db101ba3$var$R = b;
    b.memoizedState = null;
    b.updateQueue = null;
    b.lanes = 0;
    $b36288e2db101ba3$var$vh.current = null === a || null === a.memoizedState ? $b36288e2db101ba3$var$Dh : $b36288e2db101ba3$var$Eh;
    a = c(d, e);
    if ($b36288e2db101ba3$var$zh) {
        f = 0;
        do {
            $b36288e2db101ba3$var$zh = !1;
            if (!(25 > f)) throw Error($b36288e2db101ba3$var$y(301));
            f += 1;
            $b36288e2db101ba3$var$T = $b36288e2db101ba3$var$S = null;
            b.updateQueue = null;
            $b36288e2db101ba3$var$vh.current = $b36288e2db101ba3$var$Fh;
            a = c(d, e);
        }while ($b36288e2db101ba3$var$zh);
    }
    $b36288e2db101ba3$var$vh.current = $b36288e2db101ba3$var$Gh;
    b = null !== $b36288e2db101ba3$var$S && null !== $b36288e2db101ba3$var$S.next;
    $b36288e2db101ba3$var$xh = 0;
    $b36288e2db101ba3$var$T = $b36288e2db101ba3$var$S = $b36288e2db101ba3$var$R = null;
    $b36288e2db101ba3$var$yh = !1;
    if (b) throw Error($b36288e2db101ba3$var$y(300));
    return a;
}
function $b36288e2db101ba3$var$Hh() {
    var a = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === $b36288e2db101ba3$var$T ? $b36288e2db101ba3$var$R.memoizedState = $b36288e2db101ba3$var$T = a : $b36288e2db101ba3$var$T = $b36288e2db101ba3$var$T.next = a;
    return $b36288e2db101ba3$var$T;
}
function $b36288e2db101ba3$var$Ih() {
    if (null === $b36288e2db101ba3$var$S) {
        var a = $b36288e2db101ba3$var$R.alternate;
        a = null !== a ? a.memoizedState : null;
    } else a = $b36288e2db101ba3$var$S.next;
    var b = null === $b36288e2db101ba3$var$T ? $b36288e2db101ba3$var$R.memoizedState : $b36288e2db101ba3$var$T.next;
    if (null !== b) $b36288e2db101ba3$var$T = b, $b36288e2db101ba3$var$S = a;
    else {
        if (null === a) throw Error($b36288e2db101ba3$var$y(310));
        $b36288e2db101ba3$var$S = a;
        a = {
            memoizedState: $b36288e2db101ba3$var$S.memoizedState,
            baseState: $b36288e2db101ba3$var$S.baseState,
            baseQueue: $b36288e2db101ba3$var$S.baseQueue,
            queue: $b36288e2db101ba3$var$S.queue,
            next: null
        };
        null === $b36288e2db101ba3$var$T ? $b36288e2db101ba3$var$R.memoizedState = $b36288e2db101ba3$var$T = a : $b36288e2db101ba3$var$T = $b36288e2db101ba3$var$T.next = a;
    }
    return $b36288e2db101ba3$var$T;
}
function $b36288e2db101ba3$var$Jh(a, b) {
    return "function" === typeof b ? b(a) : b;
}
function $b36288e2db101ba3$var$Kh(a) {
    var b = $b36288e2db101ba3$var$Ih(), c = b.queue;
    if (null === c) throw Error($b36288e2db101ba3$var$y(311));
    c.lastRenderedReducer = a;
    var d = $b36288e2db101ba3$var$S, e = d.baseQueue, f = c.pending;
    if (null !== f) {
        if (null !== e) {
            var g = e.next;
            e.next = f.next;
            f.next = g;
        }
        d.baseQueue = e = f;
        c.pending = null;
    }
    if (null !== e) {
        e = e.next;
        d = d.baseState;
        var h = g = f = null, k = e;
        do {
            var l = k.lane;
            if (($b36288e2db101ba3$var$xh & l) === l) null !== h && (h = h.next = {
                lane: 0,
                action: k.action,
                eagerReducer: k.eagerReducer,
                eagerState: k.eagerState,
                next: null
            }), d = k.eagerReducer === a ? k.eagerState : a(d, k.action);
            else {
                var n = {
                    lane: l,
                    action: k.action,
                    eagerReducer: k.eagerReducer,
                    eagerState: k.eagerState,
                    next: null
                };
                null === h ? (g = h = n, f = d) : h = h.next = n;
                $b36288e2db101ba3$var$R.lanes |= l;
                $b36288e2db101ba3$var$Dg |= l;
            }
            k = k.next;
        }while (null !== k && k !== e);
        null === h ? f = d : h.next = g;
        $b36288e2db101ba3$var$He(d, b.memoizedState) || ($b36288e2db101ba3$var$ug = !0);
        b.memoizedState = d;
        b.baseState = f;
        b.baseQueue = h;
        c.lastRenderedState = d;
    }
    return [
        b.memoizedState,
        c.dispatch
    ];
}
function $b36288e2db101ba3$var$Lh(a) {
    var b = $b36288e2db101ba3$var$Ih(), c = b.queue;
    if (null === c) throw Error($b36288e2db101ba3$var$y(311));
    c.lastRenderedReducer = a;
    var d = c.dispatch, e = c.pending, f = b.memoizedState;
    if (null !== e) {
        c.pending = null;
        var g = e = e.next;
        do f = a(f, g.action), g = g.next;
        while (g !== e);
        $b36288e2db101ba3$var$He(f, b.memoizedState) || ($b36288e2db101ba3$var$ug = !0);
        b.memoizedState = f;
        null === b.baseQueue && (b.baseState = f);
        c.lastRenderedState = f;
    }
    return [
        f,
        d
    ];
}
function $b36288e2db101ba3$var$Mh(a, b, c) {
    var d = b._getVersion;
    d = d(b._source);
    var e = b._workInProgressVersionPrimary;
    if (null !== e) a = e === d;
    else if (a = a.mutableReadLanes, a = ($b36288e2db101ba3$var$xh & a) === a) b._workInProgressVersionPrimary = d, $b36288e2db101ba3$var$th.push(b);
    if (a) return c(b._source);
    $b36288e2db101ba3$var$th.push(b);
    throw Error($b36288e2db101ba3$var$y(350));
}
function $b36288e2db101ba3$var$Nh(a, b, c, d) {
    var e = $b36288e2db101ba3$var$U;
    if (null === e) throw Error($b36288e2db101ba3$var$y(349));
    var f = b._getVersion, g = f(b._source), h = $b36288e2db101ba3$var$vh.current, k = h.useState(function() {
        return $b36288e2db101ba3$var$Mh(e, b, c);
    }), l = k[1], n = k[0];
    k = $b36288e2db101ba3$var$T;
    var A = a.memoizedState, p = A.refs, C = p.getSnapshot, x = A.source;
    A = A.subscribe;
    var w = $b36288e2db101ba3$var$R;
    a.memoizedState = {
        refs: p,
        source: b,
        subscribe: d
    };
    h.useEffect(function() {
        p.getSnapshot = c;
        p.setSnapshot = l;
        var a = f(b._source);
        if (!$b36288e2db101ba3$var$He(g, a)) {
            a = c(b._source);
            $b36288e2db101ba3$var$He(n, a) || (l(a), a = $b36288e2db101ba3$var$Ig(w), e.mutableReadLanes |= a & e.pendingLanes);
            a = e.mutableReadLanes;
            e.entangledLanes |= a;
            for(var d = e.entanglements, h = a; 0 < h;){
                var k = 31 - $b36288e2db101ba3$var$Vc(h), v = 1 << k;
                d[k] |= a;
                h &= ~v;
            }
        }
    }, [
        c,
        b,
        d
    ]);
    h.useEffect(function() {
        return d(b._source, function() {
            var a = p.getSnapshot, c = p.setSnapshot;
            try {
                c(a(b._source));
                var d = $b36288e2db101ba3$var$Ig(w);
                e.mutableReadLanes |= d & e.pendingLanes;
            } catch (q) {
                c(function() {
                    throw q;
                });
            }
        });
    }, [
        b,
        d
    ]);
    $b36288e2db101ba3$var$He(C, c) && $b36288e2db101ba3$var$He(x, b) && $b36288e2db101ba3$var$He(A, d) || (a = {
        pending: null,
        dispatch: null,
        lastRenderedReducer: $b36288e2db101ba3$var$Jh,
        lastRenderedState: n
    }, a.dispatch = l = $b36288e2db101ba3$var$Oh.bind(null, $b36288e2db101ba3$var$R, a), k.queue = a, k.baseQueue = null, n = $b36288e2db101ba3$var$Mh(e, b, c), k.memoizedState = k.baseState = n);
    return n;
}
function $b36288e2db101ba3$var$Ph(a, b, c) {
    var d = $b36288e2db101ba3$var$Ih();
    return $b36288e2db101ba3$var$Nh(d, a, b, c);
}
function $b36288e2db101ba3$var$Qh(a) {
    var b = $b36288e2db101ba3$var$Hh();
    "function" === typeof a && (a = a());
    b.memoizedState = b.baseState = a;
    a = b.queue = {
        pending: null,
        dispatch: null,
        lastRenderedReducer: $b36288e2db101ba3$var$Jh,
        lastRenderedState: a
    };
    a = a.dispatch = $b36288e2db101ba3$var$Oh.bind(null, $b36288e2db101ba3$var$R, a);
    return [
        b.memoizedState,
        a
    ];
}
function $b36288e2db101ba3$var$Rh(a, b, c, d) {
    a = {
        tag: a,
        create: b,
        destroy: c,
        deps: d,
        next: null
    };
    b = $b36288e2db101ba3$var$R.updateQueue;
    null === b ? (b = {
        lastEffect: null
    }, $b36288e2db101ba3$var$R.updateQueue = b, b.lastEffect = a.next = a) : (c = b.lastEffect, null === c ? b.lastEffect = a.next = a : (d = c.next, c.next = a, a.next = d, b.lastEffect = a));
    return a;
}
function $b36288e2db101ba3$var$Sh(a) {
    var b = $b36288e2db101ba3$var$Hh();
    a = {
        current: a
    };
    return b.memoizedState = a;
}
function $b36288e2db101ba3$var$Th() {
    return $b36288e2db101ba3$var$Ih().memoizedState;
}
function $b36288e2db101ba3$var$Uh(a, b, c, d) {
    var e = $b36288e2db101ba3$var$Hh();
    $b36288e2db101ba3$var$R.flags |= a;
    e.memoizedState = $b36288e2db101ba3$var$Rh(1 | b, c, void 0, void 0 === d ? null : d);
}
function $b36288e2db101ba3$var$Vh(a, b, c, d) {
    var e = $b36288e2db101ba3$var$Ih();
    d = void 0 === d ? null : d;
    var f = void 0;
    if (null !== $b36288e2db101ba3$var$S) {
        var g = $b36288e2db101ba3$var$S.memoizedState;
        f = g.destroy;
        if (null !== d && $b36288e2db101ba3$var$Bh(d, g.deps)) {
            $b36288e2db101ba3$var$Rh(b, c, f, d);
            return;
        }
    }
    $b36288e2db101ba3$var$R.flags |= a;
    e.memoizedState = $b36288e2db101ba3$var$Rh(1 | b, c, f, d);
}
function $b36288e2db101ba3$var$Wh(a, b) {
    return $b36288e2db101ba3$var$Uh(516, 4, a, b);
}
function $b36288e2db101ba3$var$Xh(a, b) {
    return $b36288e2db101ba3$var$Vh(516, 4, a, b);
}
function $b36288e2db101ba3$var$Yh(a, b) {
    return $b36288e2db101ba3$var$Vh(4, 2, a, b);
}
function $b36288e2db101ba3$var$Zh(a, b) {
    if ("function" === typeof b) return a = a(), b(a), function() {
        b(null);
    };
    if (null !== b && void 0 !== b) return a = a(), b.current = a, function() {
        b.current = null;
    };
}
function $b36288e2db101ba3$var$$h(a, b, c) {
    c = null !== c && void 0 !== c ? c.concat([
        a
    ]) : null;
    return $b36288e2db101ba3$var$Vh(4, 2, $b36288e2db101ba3$var$Zh.bind(null, b, a), c);
}
function $b36288e2db101ba3$var$ai() {}
function $b36288e2db101ba3$var$bi(a, b) {
    var c = $b36288e2db101ba3$var$Ih();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $b36288e2db101ba3$var$Bh(b, d[1])) return d[0];
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $b36288e2db101ba3$var$ci(a, b) {
    var c = $b36288e2db101ba3$var$Ih();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $b36288e2db101ba3$var$Bh(b, d[1])) return d[0];
    a = a();
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $b36288e2db101ba3$var$di(a, b) {
    var c = $b36288e2db101ba3$var$eg();
    $b36288e2db101ba3$var$gg(98 > c ? 98 : c, function() {
        a(!0);
    });
    $b36288e2db101ba3$var$gg(97 < c ? 97 : c, function() {
        var c = $b36288e2db101ba3$var$wh.transition;
        $b36288e2db101ba3$var$wh.transition = 1;
        try {
            a(!1), b();
        } finally{
            $b36288e2db101ba3$var$wh.transition = c;
        }
    });
}
function $b36288e2db101ba3$var$Oh(a, b, c) {
    var d = $b36288e2db101ba3$var$Hg(), e = $b36288e2db101ba3$var$Ig(a), f = {
        lane: e,
        action: c,
        eagerReducer: null,
        eagerState: null,
        next: null
    }, g = b.pending;
    null === g ? f.next = f : (f.next = g.next, g.next = f);
    b.pending = f;
    g = a.alternate;
    if (a === $b36288e2db101ba3$var$R || null !== g && g === $b36288e2db101ba3$var$R) $b36288e2db101ba3$var$zh = $b36288e2db101ba3$var$yh = !0;
    else {
        if (0 === a.lanes && (null === g || 0 === g.lanes) && (g = b.lastRenderedReducer, null !== g)) try {
            var h = b.lastRenderedState, k = g(h, c);
            f.eagerReducer = g;
            f.eagerState = k;
            if ($b36288e2db101ba3$var$He(k, h)) return;
        } catch (l) {} finally{}
        $b36288e2db101ba3$var$Jg(a, e, d);
    }
}
var $b36288e2db101ba3$var$Gh = {
    readContext: $b36288e2db101ba3$var$vg,
    useCallback: $b36288e2db101ba3$var$Ah,
    useContext: $b36288e2db101ba3$var$Ah,
    useEffect: $b36288e2db101ba3$var$Ah,
    useImperativeHandle: $b36288e2db101ba3$var$Ah,
    useLayoutEffect: $b36288e2db101ba3$var$Ah,
    useMemo: $b36288e2db101ba3$var$Ah,
    useReducer: $b36288e2db101ba3$var$Ah,
    useRef: $b36288e2db101ba3$var$Ah,
    useState: $b36288e2db101ba3$var$Ah,
    useDebugValue: $b36288e2db101ba3$var$Ah,
    useDeferredValue: $b36288e2db101ba3$var$Ah,
    useTransition: $b36288e2db101ba3$var$Ah,
    useMutableSource: $b36288e2db101ba3$var$Ah,
    useOpaqueIdentifier: $b36288e2db101ba3$var$Ah,
    unstable_isNewReconciler: !1
}, $b36288e2db101ba3$var$Dh = {
    readContext: $b36288e2db101ba3$var$vg,
    useCallback: function(a, b) {
        $b36288e2db101ba3$var$Hh().memoizedState = [
            a,
            void 0 === b ? null : b
        ];
        return a;
    },
    useContext: $b36288e2db101ba3$var$vg,
    useEffect: $b36288e2db101ba3$var$Wh,
    useImperativeHandle: function(a, b, c) {
        c = null !== c && void 0 !== c ? c.concat([
            a
        ]) : null;
        return $b36288e2db101ba3$var$Uh(4, 2, $b36288e2db101ba3$var$Zh.bind(null, b, a), c);
    },
    useLayoutEffect: function(a, b) {
        return $b36288e2db101ba3$var$Uh(4, 2, a, b);
    },
    useMemo: function(a, b) {
        var c = $b36288e2db101ba3$var$Hh();
        b = void 0 === b ? null : b;
        a = a();
        c.memoizedState = [
            a,
            b
        ];
        return a;
    },
    useReducer: function(a, b, c) {
        var d = $b36288e2db101ba3$var$Hh();
        b = void 0 !== c ? c(b) : b;
        d.memoizedState = d.baseState = b;
        a = d.queue = {
            pending: null,
            dispatch: null,
            lastRenderedReducer: a,
            lastRenderedState: b
        };
        a = a.dispatch = $b36288e2db101ba3$var$Oh.bind(null, $b36288e2db101ba3$var$R, a);
        return [
            d.memoizedState,
            a
        ];
    },
    useRef: $b36288e2db101ba3$var$Sh,
    useState: $b36288e2db101ba3$var$Qh,
    useDebugValue: $b36288e2db101ba3$var$ai,
    useDeferredValue: function(a) {
        var b = $b36288e2db101ba3$var$Qh(a), c = b[0], d = b[1];
        $b36288e2db101ba3$var$Wh(function() {
            var b = $b36288e2db101ba3$var$wh.transition;
            $b36288e2db101ba3$var$wh.transition = 1;
            try {
                d(a);
            } finally{
                $b36288e2db101ba3$var$wh.transition = b;
            }
        }, [
            a
        ]);
        return c;
    },
    useTransition: function() {
        var a = $b36288e2db101ba3$var$Qh(!1), b = a[0];
        a = $b36288e2db101ba3$var$di.bind(null, a[1]);
        $b36288e2db101ba3$var$Sh(a);
        return [
            a,
            b
        ];
    },
    useMutableSource: function(a, b, c) {
        var d = $b36288e2db101ba3$var$Hh();
        d.memoizedState = {
            refs: {
                getSnapshot: b,
                setSnapshot: null
            },
            source: a,
            subscribe: c
        };
        return $b36288e2db101ba3$var$Nh(d, a, b, c);
    },
    useOpaqueIdentifier: function() {
        if ($b36288e2db101ba3$var$lh) {
            var a = !1, b = $b36288e2db101ba3$var$uf(function() {
                a || (a = !0, c("r:" + ($b36288e2db101ba3$var$tf++).toString(36)));
                throw Error($b36288e2db101ba3$var$y(355));
            }), c = $b36288e2db101ba3$var$Qh(b)[1];
            0 === ($b36288e2db101ba3$var$R.mode & 2) && ($b36288e2db101ba3$var$R.flags |= 516, $b36288e2db101ba3$var$Rh(5, function() {
                c("r:" + ($b36288e2db101ba3$var$tf++).toString(36));
            }, void 0, null));
            return b;
        }
        b = "r:" + ($b36288e2db101ba3$var$tf++).toString(36);
        $b36288e2db101ba3$var$Qh(b);
        return b;
    },
    unstable_isNewReconciler: !1
}, $b36288e2db101ba3$var$Eh = {
    readContext: $b36288e2db101ba3$var$vg,
    useCallback: $b36288e2db101ba3$var$bi,
    useContext: $b36288e2db101ba3$var$vg,
    useEffect: $b36288e2db101ba3$var$Xh,
    useImperativeHandle: $b36288e2db101ba3$var$$h,
    useLayoutEffect: $b36288e2db101ba3$var$Yh,
    useMemo: $b36288e2db101ba3$var$ci,
    useReducer: $b36288e2db101ba3$var$Kh,
    useRef: $b36288e2db101ba3$var$Th,
    useState: function() {
        return $b36288e2db101ba3$var$Kh($b36288e2db101ba3$var$Jh);
    },
    useDebugValue: $b36288e2db101ba3$var$ai,
    useDeferredValue: function(a) {
        var b = $b36288e2db101ba3$var$Kh($b36288e2db101ba3$var$Jh), c = b[0], d = b[1];
        $b36288e2db101ba3$var$Xh(function() {
            var b = $b36288e2db101ba3$var$wh.transition;
            $b36288e2db101ba3$var$wh.transition = 1;
            try {
                d(a);
            } finally{
                $b36288e2db101ba3$var$wh.transition = b;
            }
        }, [
            a
        ]);
        return c;
    },
    useTransition: function() {
        var a = $b36288e2db101ba3$var$Kh($b36288e2db101ba3$var$Jh)[0];
        return [
            $b36288e2db101ba3$var$Th().current,
            a
        ];
    },
    useMutableSource: $b36288e2db101ba3$var$Ph,
    useOpaqueIdentifier: function() {
        return $b36288e2db101ba3$var$Kh($b36288e2db101ba3$var$Jh)[0];
    },
    unstable_isNewReconciler: !1
}, $b36288e2db101ba3$var$Fh = {
    readContext: $b36288e2db101ba3$var$vg,
    useCallback: $b36288e2db101ba3$var$bi,
    useContext: $b36288e2db101ba3$var$vg,
    useEffect: $b36288e2db101ba3$var$Xh,
    useImperativeHandle: $b36288e2db101ba3$var$$h,
    useLayoutEffect: $b36288e2db101ba3$var$Yh,
    useMemo: $b36288e2db101ba3$var$ci,
    useReducer: $b36288e2db101ba3$var$Lh,
    useRef: $b36288e2db101ba3$var$Th,
    useState: function() {
        return $b36288e2db101ba3$var$Lh($b36288e2db101ba3$var$Jh);
    },
    useDebugValue: $b36288e2db101ba3$var$ai,
    useDeferredValue: function(a) {
        var b = $b36288e2db101ba3$var$Lh($b36288e2db101ba3$var$Jh), c = b[0], d = b[1];
        $b36288e2db101ba3$var$Xh(function() {
            var b = $b36288e2db101ba3$var$wh.transition;
            $b36288e2db101ba3$var$wh.transition = 1;
            try {
                d(a);
            } finally{
                $b36288e2db101ba3$var$wh.transition = b;
            }
        }, [
            a
        ]);
        return c;
    },
    useTransition: function() {
        var a = $b36288e2db101ba3$var$Lh($b36288e2db101ba3$var$Jh)[0];
        return [
            $b36288e2db101ba3$var$Th().current,
            a
        ];
    },
    useMutableSource: $b36288e2db101ba3$var$Ph,
    useOpaqueIdentifier: function() {
        return $b36288e2db101ba3$var$Lh($b36288e2db101ba3$var$Jh)[0];
    },
    unstable_isNewReconciler: !1
}, $b36288e2db101ba3$var$ei = $b36288e2db101ba3$var$ra.ReactCurrentOwner, $b36288e2db101ba3$var$ug = !1;
function $b36288e2db101ba3$var$fi(a, b, c, d) {
    b.child = null === a ? $b36288e2db101ba3$var$Zg(b, null, c, d) : $b36288e2db101ba3$var$Yg(b, a.child, c, d);
}
function $b36288e2db101ba3$var$gi(a, b, c, d, e) {
    c = c.render;
    var f = b.ref;
    $b36288e2db101ba3$var$tg(b, e);
    d = $b36288e2db101ba3$var$Ch(a, b, c, d, f, e);
    if (null !== a && !$b36288e2db101ba3$var$ug) return b.updateQueue = a.updateQueue, b.flags &= -517, a.lanes &= ~e, $b36288e2db101ba3$var$hi(a, b, e);
    b.flags |= 1;
    $b36288e2db101ba3$var$fi(a, b, d, e);
    return b.child;
}
function $b36288e2db101ba3$var$ii(a, b, c, d, e, f) {
    if (null === a) {
        var g = c.type;
        if ("function" === typeof g && !$b36288e2db101ba3$var$ji(g) && void 0 === g.defaultProps && null === c.compare && void 0 === c.defaultProps) return b.tag = 15, b.type = g, $b36288e2db101ba3$var$ki(a, b, g, d, e, f);
        a = $b36288e2db101ba3$var$Vg(c.type, null, d, b, b.mode, f);
        a.ref = b.ref;
        a.return = b;
        return b.child = a;
    }
    g = a.child;
    if (0 === (e & f) && (e = g.memoizedProps, c = c.compare, c = null !== c ? c : $b36288e2db101ba3$var$Je, c(e, d) && a.ref === b.ref)) return $b36288e2db101ba3$var$hi(a, b, f);
    b.flags |= 1;
    a = $b36288e2db101ba3$var$Tg(g, d);
    a.ref = b.ref;
    a.return = b;
    return b.child = a;
}
function $b36288e2db101ba3$var$ki(a, b, c, d, e, f) {
    if (null !== a && $b36288e2db101ba3$var$Je(a.memoizedProps, d) && a.ref === b.ref) {
        if ($b36288e2db101ba3$var$ug = !1, 0 !== (f & e)) 0 !== (a.flags & 16384) && ($b36288e2db101ba3$var$ug = !0);
        else return b.lanes = a.lanes, $b36288e2db101ba3$var$hi(a, b, f);
    }
    return $b36288e2db101ba3$var$li(a, b, c, d, f);
}
function $b36288e2db101ba3$var$mi(a, b, c) {
    var d = b.pendingProps, e = d.children, f = null !== a ? a.memoizedState : null;
    if ("hidden" === d.mode || "unstable-defer-without-hiding" === d.mode) {
        if (0 === (b.mode & 4)) b.memoizedState = {
            baseLanes: 0
        }, $b36288e2db101ba3$var$ni(b, c);
        else if (0 !== (c & 1073741824)) b.memoizedState = {
            baseLanes: 0
        }, $b36288e2db101ba3$var$ni(b, null !== f ? f.baseLanes : c);
        else return a = null !== f ? f.baseLanes | c : c, b.lanes = b.childLanes = 1073741824, b.memoizedState = {
            baseLanes: a
        }, $b36288e2db101ba3$var$ni(b, a), null;
    } else null !== f ? (d = f.baseLanes | c, b.memoizedState = null) : d = c, $b36288e2db101ba3$var$ni(b, d);
    $b36288e2db101ba3$var$fi(a, b, e, c);
    return b.child;
}
function $b36288e2db101ba3$var$oi(a, b) {
    var c = b.ref;
    if (null === a && null !== c || null !== a && a.ref !== c) b.flags |= 128;
}
function $b36288e2db101ba3$var$li(a, b, c, d, e) {
    var f = $b36288e2db101ba3$var$Ff(c) ? $b36288e2db101ba3$var$Df : $b36288e2db101ba3$var$M.current;
    f = $b36288e2db101ba3$var$Ef(b, f);
    $b36288e2db101ba3$var$tg(b, e);
    c = $b36288e2db101ba3$var$Ch(a, b, c, d, f, e);
    if (null !== a && !$b36288e2db101ba3$var$ug) return b.updateQueue = a.updateQueue, b.flags &= -517, a.lanes &= ~e, $b36288e2db101ba3$var$hi(a, b, e);
    b.flags |= 1;
    $b36288e2db101ba3$var$fi(a, b, c, e);
    return b.child;
}
function $b36288e2db101ba3$var$pi(a, b, c, d, e) {
    if ($b36288e2db101ba3$var$Ff(c)) {
        var f = !0;
        $b36288e2db101ba3$var$Jf(b);
    } else f = !1;
    $b36288e2db101ba3$var$tg(b, e);
    if (null === b.stateNode) null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2), $b36288e2db101ba3$var$Mg(b, c, d), $b36288e2db101ba3$var$Og(b, c, d, e), d = !0;
    else if (null === a) {
        var g = b.stateNode, h = b.memoizedProps;
        g.props = h;
        var k = g.context, l = c.contextType;
        "object" === typeof l && null !== l ? l = $b36288e2db101ba3$var$vg(l) : (l = $b36288e2db101ba3$var$Ff(c) ? $b36288e2db101ba3$var$Df : $b36288e2db101ba3$var$M.current, l = $b36288e2db101ba3$var$Ef(b, l));
        var n = c.getDerivedStateFromProps, A = "function" === typeof n || "function" === typeof g.getSnapshotBeforeUpdate;
        A || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== d || k !== l) && $b36288e2db101ba3$var$Ng(b, g, d, l);
        $b36288e2db101ba3$var$wg = !1;
        var p = b.memoizedState;
        g.state = p;
        $b36288e2db101ba3$var$Cg(b, d, g, e);
        k = b.memoizedState;
        h !== d || p !== k || $b36288e2db101ba3$var$N.current || $b36288e2db101ba3$var$wg ? ("function" === typeof n && ($b36288e2db101ba3$var$Gg(b, c, n, d), k = b.memoizedState), (h = $b36288e2db101ba3$var$wg || $b36288e2db101ba3$var$Lg(b, c, h, d, p, k, l)) ? (A || "function" !== typeof g.UNSAFE_componentWillMount && "function" !== typeof g.componentWillMount || ("function" === typeof g.componentWillMount && g.componentWillMount(), "function" === typeof g.UNSAFE_componentWillMount && g.UNSAFE_componentWillMount()), "function" === typeof g.componentDidMount && (b.flags |= 4)) : ("function" === typeof g.componentDidMount && (b.flags |= 4), b.memoizedProps = d, b.memoizedState = k), g.props = d, g.state = k, g.context = l, d = h) : ("function" === typeof g.componentDidMount && (b.flags |= 4), d = !1);
    } else {
        g = b.stateNode;
        $b36288e2db101ba3$var$yg(a, b);
        h = b.memoizedProps;
        l = b.type === b.elementType ? h : $b36288e2db101ba3$var$lg(b.type, h);
        g.props = l;
        A = b.pendingProps;
        p = g.context;
        k = c.contextType;
        "object" === typeof k && null !== k ? k = $b36288e2db101ba3$var$vg(k) : (k = $b36288e2db101ba3$var$Ff(c) ? $b36288e2db101ba3$var$Df : $b36288e2db101ba3$var$M.current, k = $b36288e2db101ba3$var$Ef(b, k));
        var C = c.getDerivedStateFromProps;
        (n = "function" === typeof C || "function" === typeof g.getSnapshotBeforeUpdate) || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== A || p !== k) && $b36288e2db101ba3$var$Ng(b, g, d, k);
        $b36288e2db101ba3$var$wg = !1;
        p = b.memoizedState;
        g.state = p;
        $b36288e2db101ba3$var$Cg(b, d, g, e);
        var x = b.memoizedState;
        h !== A || p !== x || $b36288e2db101ba3$var$N.current || $b36288e2db101ba3$var$wg ? ("function" === typeof C && ($b36288e2db101ba3$var$Gg(b, c, C, d), x = b.memoizedState), (l = $b36288e2db101ba3$var$wg || $b36288e2db101ba3$var$Lg(b, c, l, d, p, x, k)) ? (n || "function" !== typeof g.UNSAFE_componentWillUpdate && "function" !== typeof g.componentWillUpdate || ("function" === typeof g.componentWillUpdate && g.componentWillUpdate(d, x, k), "function" === typeof g.UNSAFE_componentWillUpdate && g.UNSAFE_componentWillUpdate(d, x, k)), "function" === typeof g.componentDidUpdate && (b.flags |= 4), "function" === typeof g.getSnapshotBeforeUpdate && (b.flags |= 256)) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && p === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && p === a.memoizedState || (b.flags |= 256), b.memoizedProps = d, b.memoizedState = x), g.props = d, g.state = x, g.context = k, d = l) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && p === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && p === a.memoizedState || (b.flags |= 256), d = !1);
    }
    return $b36288e2db101ba3$var$qi(a, b, c, d, f, e);
}
function $b36288e2db101ba3$var$qi(a, b, c, d, e, f) {
    $b36288e2db101ba3$var$oi(a, b);
    var g = 0 !== (b.flags & 64);
    if (!d && !g) return e && $b36288e2db101ba3$var$Kf(b, c, !1), $b36288e2db101ba3$var$hi(a, b, f);
    d = b.stateNode;
    $b36288e2db101ba3$var$ei.current = b;
    var h = g && "function" !== typeof c.getDerivedStateFromError ? null : d.render();
    b.flags |= 1;
    null !== a && g ? (b.child = $b36288e2db101ba3$var$Yg(b, a.child, null, f), b.child = $b36288e2db101ba3$var$Yg(b, null, h, f)) : $b36288e2db101ba3$var$fi(a, b, h, f);
    b.memoizedState = d.state;
    e && $b36288e2db101ba3$var$Kf(b, c, !0);
    return b.child;
}
function $b36288e2db101ba3$var$ri(a) {
    var b = a.stateNode;
    b.pendingContext ? $b36288e2db101ba3$var$Hf(a, b.pendingContext, b.pendingContext !== b.context) : b.context && $b36288e2db101ba3$var$Hf(a, b.context, !1);
    $b36288e2db101ba3$var$eh(a, b.containerInfo);
}
var $b36288e2db101ba3$var$si = {
    dehydrated: null,
    retryLane: 0
};
function $b36288e2db101ba3$var$ti(a, b, c) {
    var d = b.pendingProps, e = $b36288e2db101ba3$var$P.current, f = !1, g;
    (g = 0 !== (b.flags & 64)) || (g = null !== a && null === a.memoizedState ? !1 : 0 !== (e & 2));
    g ? (f = !0, b.flags &= -65) : null !== a && null === a.memoizedState || void 0 === d.fallback || !0 === d.unstable_avoidThisFallback || (e |= 1);
    $b36288e2db101ba3$var$I($b36288e2db101ba3$var$P, e & 1);
    if (null === a) {
        void 0 !== d.fallback && $b36288e2db101ba3$var$ph(b);
        a = d.children;
        e = d.fallback;
        if (f) return a = $b36288e2db101ba3$var$ui(b, a, e, c), b.child.memoizedState = {
            baseLanes: c
        }, b.memoizedState = $b36288e2db101ba3$var$si, a;
        if ("number" === typeof d.unstable_expectedLoadTime) return a = $b36288e2db101ba3$var$ui(b, a, e, c), b.child.memoizedState = {
            baseLanes: c
        }, b.memoizedState = $b36288e2db101ba3$var$si, b.lanes = 33554432, a;
        c = $b36288e2db101ba3$var$vi({
            mode: "visible",
            children: a
        }, b.mode, c, null);
        c.return = b;
        return b.child = c;
    }
    if (null !== a.memoizedState) {
        if (f) return d = $b36288e2db101ba3$var$wi(a, b, d.children, d.fallback, c), f = b.child, e = a.child.memoizedState, f.memoizedState = null === e ? {
            baseLanes: c
        } : {
            baseLanes: e.baseLanes | c
        }, f.childLanes = a.childLanes & ~c, b.memoizedState = $b36288e2db101ba3$var$si, d;
        c = $b36288e2db101ba3$var$xi(a, b, d.children, c);
        b.memoizedState = null;
        return c;
    }
    if (f) return d = $b36288e2db101ba3$var$wi(a, b, d.children, d.fallback, c), f = b.child, e = a.child.memoizedState, f.memoizedState = null === e ? {
        baseLanes: c
    } : {
        baseLanes: e.baseLanes | c
    }, f.childLanes = a.childLanes & ~c, b.memoizedState = $b36288e2db101ba3$var$si, d;
    c = $b36288e2db101ba3$var$xi(a, b, d.children, c);
    b.memoizedState = null;
    return c;
}
function $b36288e2db101ba3$var$ui(a, b, c, d) {
    var e = a.mode, f = a.child;
    b = {
        mode: "hidden",
        children: b
    };
    0 === (e & 2) && null !== f ? (f.childLanes = 0, f.pendingProps = b) : f = $b36288e2db101ba3$var$vi(b, e, 0, null);
    c = $b36288e2db101ba3$var$Xg(c, e, d, null);
    f.return = a;
    c.return = a;
    f.sibling = c;
    a.child = f;
    return c;
}
function $b36288e2db101ba3$var$xi(a, b, c, d) {
    var e = a.child;
    a = e.sibling;
    c = $b36288e2db101ba3$var$Tg(e, {
        mode: "visible",
        children: c
    });
    0 === (b.mode & 2) && (c.lanes = d);
    c.return = b;
    c.sibling = null;
    null !== a && (a.nextEffect = null, a.flags = 8, b.firstEffect = b.lastEffect = a);
    return b.child = c;
}
function $b36288e2db101ba3$var$wi(a, b, c, d, e) {
    var f = b.mode, g = a.child;
    a = g.sibling;
    var h = {
        mode: "hidden",
        children: c
    };
    0 === (f & 2) && b.child !== g ? (c = b.child, c.childLanes = 0, c.pendingProps = h, g = c.lastEffect, null !== g ? (b.firstEffect = c.firstEffect, b.lastEffect = g, g.nextEffect = null) : b.firstEffect = b.lastEffect = null) : c = $b36288e2db101ba3$var$Tg(g, h);
    null !== a ? d = $b36288e2db101ba3$var$Tg(a, d) : (d = $b36288e2db101ba3$var$Xg(d, f, e, null), d.flags |= 2);
    d.return = b;
    c.return = b;
    c.sibling = d;
    b.child = c;
    return d;
}
function $b36288e2db101ba3$var$yi(a, b) {
    a.lanes |= b;
    var c = a.alternate;
    null !== c && (c.lanes |= b);
    $b36288e2db101ba3$var$sg(a.return, b);
}
function $b36288e2db101ba3$var$zi(a, b, c, d, e, f) {
    var g = a.memoizedState;
    null === g ? a.memoizedState = {
        isBackwards: b,
        rendering: null,
        renderingStartTime: 0,
        last: d,
        tail: c,
        tailMode: e,
        lastEffect: f
    } : (g.isBackwards = b, g.rendering = null, g.renderingStartTime = 0, g.last = d, g.tail = c, g.tailMode = e, g.lastEffect = f);
}
function $b36288e2db101ba3$var$Ai(a, b, c) {
    var d = b.pendingProps, e = d.revealOrder, f = d.tail;
    $b36288e2db101ba3$var$fi(a, b, d.children, c);
    d = $b36288e2db101ba3$var$P.current;
    if (0 !== (d & 2)) d = d & 1 | 2, b.flags |= 64;
    else {
        if (null !== a && 0 !== (a.flags & 64)) a: for(a = b.child; null !== a;){
            if (13 === a.tag) null !== a.memoizedState && $b36288e2db101ba3$var$yi(a, c);
            else if (19 === a.tag) $b36288e2db101ba3$var$yi(a, c);
            else if (null !== a.child) {
                a.child.return = a;
                a = a.child;
                continue;
            }
            if (a === b) break a;
            for(; null === a.sibling;){
                if (null === a.return || a.return === b) break a;
                a = a.return;
            }
            a.sibling.return = a.return;
            a = a.sibling;
        }
        d &= 1;
    }
    $b36288e2db101ba3$var$I($b36288e2db101ba3$var$P, d);
    if (0 === (b.mode & 2)) b.memoizedState = null;
    else switch(e){
        case "forwards":
            c = b.child;
            for(e = null; null !== c;)a = c.alternate, null !== a && null === $b36288e2db101ba3$var$ih(a) && (e = c), c = c.sibling;
            c = e;
            null === c ? (e = b.child, b.child = null) : (e = c.sibling, c.sibling = null);
            $b36288e2db101ba3$var$zi(b, !1, e, c, f, b.lastEffect);
            break;
        case "backwards":
            c = null;
            e = b.child;
            for(b.child = null; null !== e;){
                a = e.alternate;
                if (null !== a && null === $b36288e2db101ba3$var$ih(a)) {
                    b.child = e;
                    break;
                }
                a = e.sibling;
                e.sibling = c;
                c = e;
                e = a;
            }
            $b36288e2db101ba3$var$zi(b, !0, c, null, f, b.lastEffect);
            break;
        case "together":
            $b36288e2db101ba3$var$zi(b, !1, null, null, void 0, b.lastEffect);
            break;
        default:
            b.memoizedState = null;
    }
    return b.child;
}
function $b36288e2db101ba3$var$hi(a, b, c) {
    null !== a && (b.dependencies = a.dependencies);
    $b36288e2db101ba3$var$Dg |= b.lanes;
    if (0 !== (c & b.childLanes)) {
        if (null !== a && b.child !== a.child) throw Error($b36288e2db101ba3$var$y(153));
        if (null !== b.child) {
            a = b.child;
            c = $b36288e2db101ba3$var$Tg(a, a.pendingProps);
            b.child = c;
            for(c.return = b; null !== a.sibling;)a = a.sibling, c = c.sibling = $b36288e2db101ba3$var$Tg(a, a.pendingProps), c.return = b;
            c.sibling = null;
        }
        return b.child;
    }
    return null;
}
var $b36288e2db101ba3$var$Bi, $b36288e2db101ba3$var$Ci, $b36288e2db101ba3$var$Di, $b36288e2db101ba3$var$Ei;
$b36288e2db101ba3$var$Bi = function(a, b) {
    for(var c = b.child; null !== c;){
        if (5 === c.tag || 6 === c.tag) a.appendChild(c.stateNode);
        else if (4 !== c.tag && null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === b) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === b) return;
            c = c.return;
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
};
$b36288e2db101ba3$var$Ci = function() {};
$b36288e2db101ba3$var$Di = function(a, b, c, d) {
    var e = a.memoizedProps;
    if (e !== d) {
        a = b.stateNode;
        $b36288e2db101ba3$var$dh($b36288e2db101ba3$var$ah.current);
        var f = null;
        switch(c){
            case "input":
                e = $b36288e2db101ba3$var$Ya(a, e);
                d = $b36288e2db101ba3$var$Ya(a, d);
                f = [];
                break;
            case "option":
                e = $b36288e2db101ba3$var$eb(a, e);
                d = $b36288e2db101ba3$var$eb(a, d);
                f = [];
                break;
            case "select":
                e = $4yvvI({}, e, {
                    value: void 0
                });
                d = $4yvvI({}, d, {
                    value: void 0
                });
                f = [];
                break;
            case "textarea":
                e = $b36288e2db101ba3$var$gb(a, e);
                d = $b36288e2db101ba3$var$gb(a, d);
                f = [];
                break;
            default:
                "function" !== typeof e.onClick && "function" === typeof d.onClick && (a.onclick = $b36288e2db101ba3$var$jf);
        }
        $b36288e2db101ba3$var$vb(c, d);
        var g;
        c = null;
        for(l in e)if (!d.hasOwnProperty(l) && e.hasOwnProperty(l) && null != e[l]) {
            if ("style" === l) {
                var h = e[l];
                for(g in h)h.hasOwnProperty(g) && (c || (c = {}), c[g] = "");
            } else "dangerouslySetInnerHTML" !== l && "children" !== l && "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && "autoFocus" !== l && ($b36288e2db101ba3$var$ca.hasOwnProperty(l) ? f || (f = []) : (f = f || []).push(l, null));
        }
        for(l in d){
            var k = d[l];
            h = null != e ? e[l] : void 0;
            if (d.hasOwnProperty(l) && k !== h && (null != k || null != h)) {
                if ("style" === l) {
                    if (h) {
                        for(g in h)!h.hasOwnProperty(g) || k && k.hasOwnProperty(g) || (c || (c = {}), c[g] = "");
                        for(g in k)k.hasOwnProperty(g) && h[g] !== k[g] && (c || (c = {}), c[g] = k[g]);
                    } else c || (f || (f = []), f.push(l, c)), c = k;
                } else "dangerouslySetInnerHTML" === l ? (k = k ? k.__html : void 0, h = h ? h.__html : void 0, null != k && h !== k && (f = f || []).push(l, k)) : "children" === l ? "string" !== typeof k && "number" !== typeof k || (f = f || []).push(l, "" + k) : "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && ($b36288e2db101ba3$var$ca.hasOwnProperty(l) ? (null != k && "onScroll" === l && $b36288e2db101ba3$var$G("scroll", a), f || h === k || (f = [])) : "object" === typeof k && null !== k && k.$$typeof === $b36288e2db101ba3$var$Ga ? k.toString() : (f = f || []).push(l, k));
            }
        }
        c && (f = f || []).push("style", c);
        var l = f;
        if (b.updateQueue = l) b.flags |= 4;
    }
};
$b36288e2db101ba3$var$Ei = function(a, b, c, d) {
    c !== d && (b.flags |= 4);
};
function $b36288e2db101ba3$var$Fi(a, b) {
    if (!$b36288e2db101ba3$var$lh) switch(a.tailMode){
        case "hidden":
            b = a.tail;
            for(var c = null; null !== b;)null !== b.alternate && (c = b), b = b.sibling;
            null === c ? a.tail = null : c.sibling = null;
            break;
        case "collapsed":
            c = a.tail;
            for(var d = null; null !== c;)null !== c.alternate && (d = c), c = c.sibling;
            null === d ? b || null === a.tail ? a.tail = null : a.tail.sibling = null : d.sibling = null;
    }
}
function $b36288e2db101ba3$var$Gi(a, b, c) {
    var d = b.pendingProps;
    switch(b.tag){
        case 2:
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return null;
        case 1:
            return $b36288e2db101ba3$var$Ff(b.type) && $b36288e2db101ba3$var$Gf(), null;
        case 3:
            $b36288e2db101ba3$var$fh();
            $b36288e2db101ba3$var$H($b36288e2db101ba3$var$N);
            $b36288e2db101ba3$var$H($b36288e2db101ba3$var$M);
            $b36288e2db101ba3$var$uh();
            d = b.stateNode;
            d.pendingContext && (d.context = d.pendingContext, d.pendingContext = null);
            if (null === a || null === a.child) $b36288e2db101ba3$var$rh(b) ? b.flags |= 4 : d.hydrate || (b.flags |= 256);
            $b36288e2db101ba3$var$Ci(b);
            return null;
        case 5:
            $b36288e2db101ba3$var$hh(b);
            var e = $b36288e2db101ba3$var$dh($b36288e2db101ba3$var$ch.current);
            c = b.type;
            if (null !== a && null != b.stateNode) $b36288e2db101ba3$var$Di(a, b, c, d, e), a.ref !== b.ref && (b.flags |= 128);
            else {
                if (!d) {
                    if (null === b.stateNode) throw Error($b36288e2db101ba3$var$y(166));
                    return null;
                }
                a = $b36288e2db101ba3$var$dh($b36288e2db101ba3$var$ah.current);
                if ($b36288e2db101ba3$var$rh(b)) {
                    d = b.stateNode;
                    c = b.type;
                    var f = b.memoizedProps;
                    d[$b36288e2db101ba3$var$wf] = b;
                    d[$b36288e2db101ba3$var$xf] = f;
                    switch(c){
                        case "dialog":
                            $b36288e2db101ba3$var$G("cancel", d);
                            $b36288e2db101ba3$var$G("close", d);
                            break;
                        case "iframe":
                        case "object":
                        case "embed":
                            $b36288e2db101ba3$var$G("load", d);
                            break;
                        case "video":
                        case "audio":
                            for(a = 0; a < $b36288e2db101ba3$var$Xe.length; a++)$b36288e2db101ba3$var$G($b36288e2db101ba3$var$Xe[a], d);
                            break;
                        case "source":
                            $b36288e2db101ba3$var$G("error", d);
                            break;
                        case "img":
                        case "image":
                        case "link":
                            $b36288e2db101ba3$var$G("error", d);
                            $b36288e2db101ba3$var$G("load", d);
                            break;
                        case "details":
                            $b36288e2db101ba3$var$G("toggle", d);
                            break;
                        case "input":
                            $b36288e2db101ba3$var$Za(d, f);
                            $b36288e2db101ba3$var$G("invalid", d);
                            break;
                        case "select":
                            d._wrapperState = {
                                wasMultiple: !!f.multiple
                            };
                            $b36288e2db101ba3$var$G("invalid", d);
                            break;
                        case "textarea":
                            $b36288e2db101ba3$var$hb(d, f), $b36288e2db101ba3$var$G("invalid", d);
                    }
                    $b36288e2db101ba3$var$vb(c, f);
                    a = null;
                    for(var g in f)f.hasOwnProperty(g) && (e = f[g], "children" === g ? "string" === typeof e ? d.textContent !== e && (a = [
                        "children",
                        e
                    ]) : "number" === typeof e && d.textContent !== "" + e && (a = [
                        "children",
                        "" + e
                    ]) : $b36288e2db101ba3$var$ca.hasOwnProperty(g) && null != e && "onScroll" === g && $b36288e2db101ba3$var$G("scroll", d));
                    switch(c){
                        case "input":
                            $b36288e2db101ba3$var$Va(d);
                            $b36288e2db101ba3$var$cb(d, f, !0);
                            break;
                        case "textarea":
                            $b36288e2db101ba3$var$Va(d);
                            $b36288e2db101ba3$var$jb(d);
                            break;
                        case "select":
                        case "option":
                            break;
                        default:
                            "function" === typeof f.onClick && (d.onclick = $b36288e2db101ba3$var$jf);
                    }
                    d = a;
                    b.updateQueue = d;
                    null !== d && (b.flags |= 4);
                } else {
                    g = 9 === e.nodeType ? e : e.ownerDocument;
                    a === $b36288e2db101ba3$var$kb.html && (a = $b36288e2db101ba3$var$lb(c));
                    a === $b36288e2db101ba3$var$kb.html ? "script" === c ? (a = g.createElement("div"), a.innerHTML = "<script></script>", a = a.removeChild(a.firstChild)) : "string" === typeof d.is ? a = g.createElement(c, {
                        is: d.is
                    }) : (a = g.createElement(c), "select" === c && (g = a, d.multiple ? g.multiple = !0 : d.size && (g.size = d.size))) : a = g.createElementNS(a, c);
                    a[$b36288e2db101ba3$var$wf] = b;
                    a[$b36288e2db101ba3$var$xf] = d;
                    $b36288e2db101ba3$var$Bi(a, b, !1, !1);
                    b.stateNode = a;
                    g = $b36288e2db101ba3$var$wb(c, d);
                    switch(c){
                        case "dialog":
                            $b36288e2db101ba3$var$G("cancel", a);
                            $b36288e2db101ba3$var$G("close", a);
                            e = d;
                            break;
                        case "iframe":
                        case "object":
                        case "embed":
                            $b36288e2db101ba3$var$G("load", a);
                            e = d;
                            break;
                        case "video":
                        case "audio":
                            for(e = 0; e < $b36288e2db101ba3$var$Xe.length; e++)$b36288e2db101ba3$var$G($b36288e2db101ba3$var$Xe[e], a);
                            e = d;
                            break;
                        case "source":
                            $b36288e2db101ba3$var$G("error", a);
                            e = d;
                            break;
                        case "img":
                        case "image":
                        case "link":
                            $b36288e2db101ba3$var$G("error", a);
                            $b36288e2db101ba3$var$G("load", a);
                            e = d;
                            break;
                        case "details":
                            $b36288e2db101ba3$var$G("toggle", a);
                            e = d;
                            break;
                        case "input":
                            $b36288e2db101ba3$var$Za(a, d);
                            e = $b36288e2db101ba3$var$Ya(a, d);
                            $b36288e2db101ba3$var$G("invalid", a);
                            break;
                        case "option":
                            e = $b36288e2db101ba3$var$eb(a, d);
                            break;
                        case "select":
                            a._wrapperState = {
                                wasMultiple: !!d.multiple
                            };
                            e = $4yvvI({}, d, {
                                value: void 0
                            });
                            $b36288e2db101ba3$var$G("invalid", a);
                            break;
                        case "textarea":
                            $b36288e2db101ba3$var$hb(a, d);
                            e = $b36288e2db101ba3$var$gb(a, d);
                            $b36288e2db101ba3$var$G("invalid", a);
                            break;
                        default:
                            e = d;
                    }
                    $b36288e2db101ba3$var$vb(c, e);
                    var h = e;
                    for(f in h)if (h.hasOwnProperty(f)) {
                        var k = h[f];
                        "style" === f ? $b36288e2db101ba3$var$tb(a, k) : "dangerouslySetInnerHTML" === f ? (k = k ? k.__html : void 0, null != k && $b36288e2db101ba3$var$ob(a, k)) : "children" === f ? "string" === typeof k ? ("textarea" !== c || "" !== k) && $b36288e2db101ba3$var$pb(a, k) : "number" === typeof k && $b36288e2db101ba3$var$pb(a, "" + k) : "suppressContentEditableWarning" !== f && "suppressHydrationWarning" !== f && "autoFocus" !== f && ($b36288e2db101ba3$var$ca.hasOwnProperty(f) ? null != k && "onScroll" === f && $b36288e2db101ba3$var$G("scroll", a) : null != k && $b36288e2db101ba3$var$qa(a, f, k, g));
                    }
                    switch(c){
                        case "input":
                            $b36288e2db101ba3$var$Va(a);
                            $b36288e2db101ba3$var$cb(a, d, !1);
                            break;
                        case "textarea":
                            $b36288e2db101ba3$var$Va(a);
                            $b36288e2db101ba3$var$jb(a);
                            break;
                        case "option":
                            null != d.value && a.setAttribute("value", "" + $b36288e2db101ba3$var$Sa(d.value));
                            break;
                        case "select":
                            a.multiple = !!d.multiple;
                            f = d.value;
                            null != f ? $b36288e2db101ba3$var$fb(a, !!d.multiple, f, !1) : null != d.defaultValue && $b36288e2db101ba3$var$fb(a, !!d.multiple, d.defaultValue, !0);
                            break;
                        default:
                            "function" === typeof e.onClick && (a.onclick = $b36288e2db101ba3$var$jf);
                    }
                    $b36288e2db101ba3$var$mf(c, d) && (b.flags |= 4);
                }
                null !== b.ref && (b.flags |= 128);
            }
            return null;
        case 6:
            if (a && null != b.stateNode) $b36288e2db101ba3$var$Ei(a, b, a.memoizedProps, d);
            else {
                if ("string" !== typeof d && null === b.stateNode) throw Error($b36288e2db101ba3$var$y(166));
                c = $b36288e2db101ba3$var$dh($b36288e2db101ba3$var$ch.current);
                $b36288e2db101ba3$var$dh($b36288e2db101ba3$var$ah.current);
                $b36288e2db101ba3$var$rh(b) ? (d = b.stateNode, c = b.memoizedProps, d[$b36288e2db101ba3$var$wf] = b, d.nodeValue !== c && (b.flags |= 4)) : (d = (9 === c.nodeType ? c : c.ownerDocument).createTextNode(d), d[$b36288e2db101ba3$var$wf] = b, b.stateNode = d);
            }
            return null;
        case 13:
            $b36288e2db101ba3$var$H($b36288e2db101ba3$var$P);
            d = b.memoizedState;
            if (0 !== (b.flags & 64)) return b.lanes = c, b;
            d = null !== d;
            c = !1;
            null === a ? void 0 !== b.memoizedProps.fallback && $b36288e2db101ba3$var$rh(b) : c = null !== a.memoizedState;
            if (d && !c && 0 !== (b.mode & 2)) {
                if (null === a && !0 !== b.memoizedProps.unstable_avoidThisFallback || 0 !== ($b36288e2db101ba3$var$P.current & 1)) 0 === $b36288e2db101ba3$var$V && ($b36288e2db101ba3$var$V = 3);
                else {
                    if (0 === $b36288e2db101ba3$var$V || 3 === $b36288e2db101ba3$var$V) $b36288e2db101ba3$var$V = 4;
                    null === $b36288e2db101ba3$var$U || 0 === ($b36288e2db101ba3$var$Dg & 134217727) && 0 === ($b36288e2db101ba3$var$Hi & 134217727) || $b36288e2db101ba3$var$Ii($b36288e2db101ba3$var$U, $b36288e2db101ba3$var$W);
                }
            }
            if (d || c) b.flags |= 4;
            return null;
        case 4:
            return $b36288e2db101ba3$var$fh(), $b36288e2db101ba3$var$Ci(b), null === a && $b36288e2db101ba3$var$cf(b.stateNode.containerInfo), null;
        case 10:
            return $b36288e2db101ba3$var$rg(b), null;
        case 17:
            return $b36288e2db101ba3$var$Ff(b.type) && $b36288e2db101ba3$var$Gf(), null;
        case 19:
            $b36288e2db101ba3$var$H($b36288e2db101ba3$var$P);
            d = b.memoizedState;
            if (null === d) return null;
            f = 0 !== (b.flags & 64);
            g = d.rendering;
            if (null === g) {
                if (f) $b36288e2db101ba3$var$Fi(d, !1);
                else {
                    if (0 !== $b36288e2db101ba3$var$V || null !== a && 0 !== (a.flags & 64)) for(a = b.child; null !== a;){
                        g = $b36288e2db101ba3$var$ih(a);
                        if (null !== g) {
                            b.flags |= 64;
                            $b36288e2db101ba3$var$Fi(d, !1);
                            f = g.updateQueue;
                            null !== f && (b.updateQueue = f, b.flags |= 4);
                            null === d.lastEffect && (b.firstEffect = null);
                            b.lastEffect = d.lastEffect;
                            d = c;
                            for(c = b.child; null !== c;)f = c, a = d, f.flags &= 2, f.nextEffect = null, f.firstEffect = null, f.lastEffect = null, g = f.alternate, null === g ? (f.childLanes = 0, f.lanes = a, f.child = null, f.memoizedProps = null, f.memoizedState = null, f.updateQueue = null, f.dependencies = null, f.stateNode = null) : (f.childLanes = g.childLanes, f.lanes = g.lanes, f.child = g.child, f.memoizedProps = g.memoizedProps, f.memoizedState = g.memoizedState, f.updateQueue = g.updateQueue, f.type = g.type, a = g.dependencies, f.dependencies = null === a ? null : {
                                lanes: a.lanes,
                                firstContext: a.firstContext
                            }), c = c.sibling;
                            $b36288e2db101ba3$var$I($b36288e2db101ba3$var$P, $b36288e2db101ba3$var$P.current & 1 | 2);
                            return b.child;
                        }
                        a = a.sibling;
                    }
                    null !== d.tail && $b36288e2db101ba3$var$O() > $b36288e2db101ba3$var$Ji && (b.flags |= 64, f = !0, $b36288e2db101ba3$var$Fi(d, !1), b.lanes = 33554432);
                }
            } else {
                if (!f) {
                    if (a = $b36288e2db101ba3$var$ih(g), null !== a) {
                        if (b.flags |= 64, f = !0, c = a.updateQueue, null !== c && (b.updateQueue = c, b.flags |= 4), $b36288e2db101ba3$var$Fi(d, !0), null === d.tail && "hidden" === d.tailMode && !g.alternate && !$b36288e2db101ba3$var$lh) return b = b.lastEffect = d.lastEffect, null !== b && (b.nextEffect = null), null;
                    } else 2 * $b36288e2db101ba3$var$O() - d.renderingStartTime > $b36288e2db101ba3$var$Ji && 1073741824 !== c && (b.flags |= 64, f = !0, $b36288e2db101ba3$var$Fi(d, !1), b.lanes = 33554432);
                }
                d.isBackwards ? (g.sibling = b.child, b.child = g) : (c = d.last, null !== c ? c.sibling = g : b.child = g, d.last = g);
            }
            return null !== d.tail ? (c = d.tail, d.rendering = c, d.tail = c.sibling, d.lastEffect = b.lastEffect, d.renderingStartTime = $b36288e2db101ba3$var$O(), c.sibling = null, b = $b36288e2db101ba3$var$P.current, $b36288e2db101ba3$var$I($b36288e2db101ba3$var$P, f ? b & 1 | 2 : b & 1), c) : null;
        case 23:
        case 24:
            return $b36288e2db101ba3$var$Ki(), null !== a && null !== a.memoizedState !== (null !== b.memoizedState) && "unstable-defer-without-hiding" !== d.mode && (b.flags |= 4), null;
    }
    throw Error($b36288e2db101ba3$var$y(156, b.tag));
}
function $b36288e2db101ba3$var$Li(a) {
    switch(a.tag){
        case 1:
            $b36288e2db101ba3$var$Ff(a.type) && $b36288e2db101ba3$var$Gf();
            var b = a.flags;
            return b & 4096 ? (a.flags = b & -4097 | 64, a) : null;
        case 3:
            $b36288e2db101ba3$var$fh();
            $b36288e2db101ba3$var$H($b36288e2db101ba3$var$N);
            $b36288e2db101ba3$var$H($b36288e2db101ba3$var$M);
            $b36288e2db101ba3$var$uh();
            b = a.flags;
            if (0 !== (b & 64)) throw Error($b36288e2db101ba3$var$y(285));
            a.flags = b & -4097 | 64;
            return a;
        case 5:
            return $b36288e2db101ba3$var$hh(a), null;
        case 13:
            return $b36288e2db101ba3$var$H($b36288e2db101ba3$var$P), b = a.flags, b & 4096 ? (a.flags = b & -4097 | 64, a) : null;
        case 19:
            return $b36288e2db101ba3$var$H($b36288e2db101ba3$var$P), null;
        case 4:
            return $b36288e2db101ba3$var$fh(), null;
        case 10:
            return $b36288e2db101ba3$var$rg(a), null;
        case 23:
        case 24:
            return $b36288e2db101ba3$var$Ki(), null;
        default:
            return null;
    }
}
function $b36288e2db101ba3$var$Mi(a, b) {
    try {
        var c = "", d = b;
        do c += $b36288e2db101ba3$var$Qa(d), d = d.return;
        while (d);
        var e = c;
    } catch (f) {
        e = "\nError generating stack: " + f.message + "\n" + f.stack;
    }
    return {
        value: a,
        source: b,
        stack: e
    };
}
function $b36288e2db101ba3$var$Ni(a, b) {
    try {
        console.error(b.value);
    } catch (c) {
        setTimeout(function() {
            throw c;
        });
    }
}
var $b36288e2db101ba3$var$Oi = "function" === typeof WeakMap ? WeakMap : Map;
function $b36288e2db101ba3$var$Pi(a, b, c) {
    c = $b36288e2db101ba3$var$zg(-1, c);
    c.tag = 3;
    c.payload = {
        element: null
    };
    var d = b.value;
    c.callback = function() {
        $b36288e2db101ba3$var$Qi || ($b36288e2db101ba3$var$Qi = !0, $b36288e2db101ba3$var$Ri = d);
        $b36288e2db101ba3$var$Ni(a, b);
    };
    return c;
}
function $b36288e2db101ba3$var$Si(a, b, c) {
    c = $b36288e2db101ba3$var$zg(-1, c);
    c.tag = 3;
    var d = a.type.getDerivedStateFromError;
    if ("function" === typeof d) {
        var e = b.value;
        c.payload = function() {
            $b36288e2db101ba3$var$Ni(a, b);
            return d(e);
        };
    }
    var f = a.stateNode;
    null !== f && "function" === typeof f.componentDidCatch && (c.callback = function() {
        "function" !== typeof d && (null === $b36288e2db101ba3$var$Ti ? $b36288e2db101ba3$var$Ti = new Set([
            this
        ]) : $b36288e2db101ba3$var$Ti.add(this), $b36288e2db101ba3$var$Ni(a, b));
        var c = b.stack;
        this.componentDidCatch(b.value, {
            componentStack: null !== c ? c : ""
        });
    });
    return c;
}
var $b36288e2db101ba3$var$Ui = "function" === typeof WeakSet ? WeakSet : Set;
function $b36288e2db101ba3$var$Vi(a) {
    var b = a.ref;
    if (null !== b) {
        if ("function" === typeof b) try {
            b(null);
        } catch (c) {
            $b36288e2db101ba3$var$Wi(a, c);
        }
        else b.current = null;
    }
}
function $b36288e2db101ba3$var$Xi(a, b) {
    switch(b.tag){
        case 0:
        case 11:
        case 15:
        case 22:
            return;
        case 1:
            if (b.flags & 256 && null !== a) {
                var c = a.memoizedProps, d = a.memoizedState;
                a = b.stateNode;
                b = a.getSnapshotBeforeUpdate(b.elementType === b.type ? c : $b36288e2db101ba3$var$lg(b.type, c), d);
                a.__reactInternalSnapshotBeforeUpdate = b;
            }
            return;
        case 3:
            b.flags & 256 && $b36288e2db101ba3$var$qf(b.stateNode.containerInfo);
            return;
        case 5:
        case 6:
        case 4:
        case 17:
            return;
    }
    throw Error($b36288e2db101ba3$var$y(163));
}
function $b36288e2db101ba3$var$Yi(a, b, c) {
    switch(c.tag){
        case 0:
        case 11:
        case 15:
        case 22:
            b = c.updateQueue;
            b = null !== b ? b.lastEffect : null;
            if (null !== b) {
                a = b = b.next;
                do {
                    if (3 === (a.tag & 3)) {
                        var d = a.create;
                        a.destroy = d();
                    }
                    a = a.next;
                }while (a !== b);
            }
            b = c.updateQueue;
            b = null !== b ? b.lastEffect : null;
            if (null !== b) {
                a = b = b.next;
                do {
                    var e = a;
                    d = e.next;
                    e = e.tag;
                    0 !== (e & 4) && 0 !== (e & 1) && ($b36288e2db101ba3$var$Zi(c, a), $b36288e2db101ba3$var$$i(c, a));
                    a = d;
                }while (a !== b);
            }
            return;
        case 1:
            a = c.stateNode;
            c.flags & 4 && (null === b ? a.componentDidMount() : (d = c.elementType === c.type ? b.memoizedProps : $b36288e2db101ba3$var$lg(c.type, b.memoizedProps), a.componentDidUpdate(d, b.memoizedState, a.__reactInternalSnapshotBeforeUpdate)));
            b = c.updateQueue;
            null !== b && $b36288e2db101ba3$var$Eg(c, b, a);
            return;
        case 3:
            b = c.updateQueue;
            if (null !== b) {
                a = null;
                if (null !== c.child) switch(c.child.tag){
                    case 5:
                        a = c.child.stateNode;
                        break;
                    case 1:
                        a = c.child.stateNode;
                }
                $b36288e2db101ba3$var$Eg(c, b, a);
            }
            return;
        case 5:
            a = c.stateNode;
            null === b && c.flags & 4 && $b36288e2db101ba3$var$mf(c.type, c.memoizedProps) && a.focus();
            return;
        case 6:
            return;
        case 4:
            return;
        case 12:
            return;
        case 13:
            null === c.memoizedState && (c = c.alternate, null !== c && (c = c.memoizedState, null !== c && (c = c.dehydrated, null !== c && $b36288e2db101ba3$var$Cc(c))));
            return;
        case 19:
        case 17:
        case 20:
        case 21:
        case 23:
        case 24:
            return;
    }
    throw Error($b36288e2db101ba3$var$y(163));
}
function $b36288e2db101ba3$var$aj(a, b) {
    for(var c = a;;){
        if (5 === c.tag) {
            var d = c.stateNode;
            if (b) d = d.style, "function" === typeof d.setProperty ? d.setProperty("display", "none", "important") : d.display = "none";
            else {
                d = c.stateNode;
                var e = c.memoizedProps.style;
                e = void 0 !== e && null !== e && e.hasOwnProperty("display") ? e.display : null;
                d.style.display = $b36288e2db101ba3$var$sb("display", e);
            }
        } else if (6 === c.tag) c.stateNode.nodeValue = b ? "" : c.memoizedProps;
        else if ((23 !== c.tag && 24 !== c.tag || null === c.memoizedState || c === a) && null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === a) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === a) return;
            c = c.return;
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
}
function $b36288e2db101ba3$var$bj(a, b) {
    if ($b36288e2db101ba3$var$Mf && "function" === typeof $b36288e2db101ba3$var$Mf.onCommitFiberUnmount) try {
        $b36288e2db101ba3$var$Mf.onCommitFiberUnmount($b36288e2db101ba3$var$Lf, b);
    } catch (f) {}
    switch(b.tag){
        case 0:
        case 11:
        case 14:
        case 15:
        case 22:
            a = b.updateQueue;
            if (null !== a && (a = a.lastEffect, null !== a)) {
                var c = a = a.next;
                do {
                    var d = c, e = d.destroy;
                    d = d.tag;
                    if (void 0 !== e) {
                        if (0 !== (d & 4)) $b36288e2db101ba3$var$Zi(b, c);
                        else {
                            d = b;
                            try {
                                e();
                            } catch (f) {
                                $b36288e2db101ba3$var$Wi(d, f);
                            }
                        }
                    }
                    c = c.next;
                }while (c !== a);
            }
            break;
        case 1:
            $b36288e2db101ba3$var$Vi(b);
            a = b.stateNode;
            if ("function" === typeof a.componentWillUnmount) try {
                a.props = b.memoizedProps, a.state = b.memoizedState, a.componentWillUnmount();
            } catch (f) {
                $b36288e2db101ba3$var$Wi(b, f);
            }
            break;
        case 5:
            $b36288e2db101ba3$var$Vi(b);
            break;
        case 4:
            $b36288e2db101ba3$var$cj(a, b);
    }
}
function $b36288e2db101ba3$var$dj(a) {
    a.alternate = null;
    a.child = null;
    a.dependencies = null;
    a.firstEffect = null;
    a.lastEffect = null;
    a.memoizedProps = null;
    a.memoizedState = null;
    a.pendingProps = null;
    a.return = null;
    a.updateQueue = null;
}
function $b36288e2db101ba3$var$ej(a) {
    return 5 === a.tag || 3 === a.tag || 4 === a.tag;
}
function $b36288e2db101ba3$var$fj(a) {
    a: {
        for(var b = a.return; null !== b;){
            if ($b36288e2db101ba3$var$ej(b)) break a;
            b = b.return;
        }
        throw Error($b36288e2db101ba3$var$y(160));
    }
    var c = b;
    b = c.stateNode;
    switch(c.tag){
        case 5:
            var d = !1;
            break;
        case 3:
            b = b.containerInfo;
            d = !0;
            break;
        case 4:
            b = b.containerInfo;
            d = !0;
            break;
        default:
            throw Error($b36288e2db101ba3$var$y(161));
    }
    c.flags & 16 && ($b36288e2db101ba3$var$pb(b, ""), c.flags &= -17);
    a: b: for(c = a;;){
        for(; null === c.sibling;){
            if (null === c.return || $b36288e2db101ba3$var$ej(c.return)) {
                c = null;
                break a;
            }
            c = c.return;
        }
        c.sibling.return = c.return;
        for(c = c.sibling; 5 !== c.tag && 6 !== c.tag && 18 !== c.tag;){
            if (c.flags & 2) continue b;
            if (null === c.child || 4 === c.tag) continue b;
            else c.child.return = c, c = c.child;
        }
        if (!(c.flags & 2)) {
            c = c.stateNode;
            break a;
        }
    }
    d ? $b36288e2db101ba3$var$gj(a, c, b) : $b36288e2db101ba3$var$hj(a, c, b);
}
function $b36288e2db101ba3$var$gj(a, b, c) {
    var d = a.tag, e = 5 === d || 6 === d;
    if (e) a = e ? a.stateNode : a.stateNode.instance, b ? 8 === c.nodeType ? c.parentNode.insertBefore(a, b) : c.insertBefore(a, b) : (8 === c.nodeType ? (b = c.parentNode, b.insertBefore(a, c)) : (b = c, b.appendChild(a)), c = c._reactRootContainer, null !== c && void 0 !== c || null !== b.onclick || (b.onclick = $b36288e2db101ba3$var$jf));
    else if (4 !== d && (a = a.child, null !== a)) for($b36288e2db101ba3$var$gj(a, b, c), a = a.sibling; null !== a;)$b36288e2db101ba3$var$gj(a, b, c), a = a.sibling;
}
function $b36288e2db101ba3$var$hj(a, b, c) {
    var d = a.tag, e = 5 === d || 6 === d;
    if (e) a = e ? a.stateNode : a.stateNode.instance, b ? c.insertBefore(a, b) : c.appendChild(a);
    else if (4 !== d && (a = a.child, null !== a)) for($b36288e2db101ba3$var$hj(a, b, c), a = a.sibling; null !== a;)$b36288e2db101ba3$var$hj(a, b, c), a = a.sibling;
}
function $b36288e2db101ba3$var$cj(a, b) {
    for(var c = b, d = !1, e, f;;){
        if (!d) {
            d = c.return;
            a: for(;;){
                if (null === d) throw Error($b36288e2db101ba3$var$y(160));
                e = d.stateNode;
                switch(d.tag){
                    case 5:
                        f = !1;
                        break a;
                    case 3:
                        e = e.containerInfo;
                        f = !0;
                        break a;
                    case 4:
                        e = e.containerInfo;
                        f = !0;
                        break a;
                }
                d = d.return;
            }
            d = !0;
        }
        if (5 === c.tag || 6 === c.tag) {
            a: for(var g = a, h = c, k = h;;)if ($b36288e2db101ba3$var$bj(g, k), null !== k.child && 4 !== k.tag) k.child.return = k, k = k.child;
            else {
                if (k === h) break a;
                for(; null === k.sibling;){
                    if (null === k.return || k.return === h) break a;
                    k = k.return;
                }
                k.sibling.return = k.return;
                k = k.sibling;
            }
            f ? (g = e, h = c.stateNode, 8 === g.nodeType ? g.parentNode.removeChild(h) : g.removeChild(h)) : e.removeChild(c.stateNode);
        } else if (4 === c.tag) {
            if (null !== c.child) {
                e = c.stateNode.containerInfo;
                f = !0;
                c.child.return = c;
                c = c.child;
                continue;
            }
        } else if ($b36288e2db101ba3$var$bj(a, c), null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === b) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === b) return;
            c = c.return;
            4 === c.tag && (d = !1);
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
}
function $b36288e2db101ba3$var$ij(a, b) {
    switch(b.tag){
        case 0:
        case 11:
        case 14:
        case 15:
        case 22:
            var c = b.updateQueue;
            c = null !== c ? c.lastEffect : null;
            if (null !== c) {
                var d = c = c.next;
                do 3 === (d.tag & 3) && (a = d.destroy, d.destroy = void 0, void 0 !== a && a()), d = d.next;
                while (d !== c);
            }
            return;
        case 1:
            return;
        case 5:
            c = b.stateNode;
            if (null != c) {
                d = b.memoizedProps;
                var e = null !== a ? a.memoizedProps : d;
                a = b.type;
                var f = b.updateQueue;
                b.updateQueue = null;
                if (null !== f) {
                    c[$b36288e2db101ba3$var$xf] = d;
                    "input" === a && "radio" === d.type && null != d.name && $b36288e2db101ba3$var$$a(c, d);
                    $b36288e2db101ba3$var$wb(a, e);
                    b = $b36288e2db101ba3$var$wb(a, d);
                    for(e = 0; e < f.length; e += 2){
                        var g = f[e], h = f[e + 1];
                        "style" === g ? $b36288e2db101ba3$var$tb(c, h) : "dangerouslySetInnerHTML" === g ? $b36288e2db101ba3$var$ob(c, h) : "children" === g ? $b36288e2db101ba3$var$pb(c, h) : $b36288e2db101ba3$var$qa(c, g, h, b);
                    }
                    switch(a){
                        case "input":
                            $b36288e2db101ba3$var$ab(c, d);
                            break;
                        case "textarea":
                            $b36288e2db101ba3$var$ib(c, d);
                            break;
                        case "select":
                            a = c._wrapperState.wasMultiple, c._wrapperState.wasMultiple = !!d.multiple, f = d.value, null != f ? $b36288e2db101ba3$var$fb(c, !!d.multiple, f, !1) : a !== !!d.multiple && (null != d.defaultValue ? $b36288e2db101ba3$var$fb(c, !!d.multiple, d.defaultValue, !0) : $b36288e2db101ba3$var$fb(c, !!d.multiple, d.multiple ? [] : "", !1));
                    }
                }
            }
            return;
        case 6:
            if (null === b.stateNode) throw Error($b36288e2db101ba3$var$y(162));
            b.stateNode.nodeValue = b.memoizedProps;
            return;
        case 3:
            c = b.stateNode;
            c.hydrate && (c.hydrate = !1, $b36288e2db101ba3$var$Cc(c.containerInfo));
            return;
        case 12:
            return;
        case 13:
            null !== b.memoizedState && ($b36288e2db101ba3$var$jj = $b36288e2db101ba3$var$O(), $b36288e2db101ba3$var$aj(b.child, !0));
            $b36288e2db101ba3$var$kj(b);
            return;
        case 19:
            $b36288e2db101ba3$var$kj(b);
            return;
        case 17:
            return;
        case 23:
        case 24:
            $b36288e2db101ba3$var$aj(b, null !== b.memoizedState);
            return;
    }
    throw Error($b36288e2db101ba3$var$y(163));
}
function $b36288e2db101ba3$var$kj(a) {
    var b = a.updateQueue;
    if (null !== b) {
        a.updateQueue = null;
        var c = a.stateNode;
        null === c && (c = a.stateNode = new $b36288e2db101ba3$var$Ui);
        b.forEach(function(b) {
            var d = $b36288e2db101ba3$var$lj.bind(null, a, b);
            c.has(b) || (c.add(b), b.then(d, d));
        });
    }
}
function $b36288e2db101ba3$var$mj(a, b) {
    return null !== a && (a = a.memoizedState, null === a || null !== a.dehydrated) ? (b = b.memoizedState, null !== b && null === b.dehydrated) : !1;
}
var $b36288e2db101ba3$var$nj = Math.ceil, $b36288e2db101ba3$var$oj = $b36288e2db101ba3$var$ra.ReactCurrentDispatcher, $b36288e2db101ba3$var$pj = $b36288e2db101ba3$var$ra.ReactCurrentOwner, $b36288e2db101ba3$var$X = 0, $b36288e2db101ba3$var$U = null, $b36288e2db101ba3$var$Y = null, $b36288e2db101ba3$var$W = 0, $b36288e2db101ba3$var$qj = 0, $b36288e2db101ba3$var$rj = $b36288e2db101ba3$var$Bf(0), $b36288e2db101ba3$var$V = 0, $b36288e2db101ba3$var$sj = null, $b36288e2db101ba3$var$tj = 0, $b36288e2db101ba3$var$Dg = 0, $b36288e2db101ba3$var$Hi = 0, $b36288e2db101ba3$var$uj = 0, $b36288e2db101ba3$var$vj = null, $b36288e2db101ba3$var$jj = 0, $b36288e2db101ba3$var$Ji = Infinity;
function $b36288e2db101ba3$var$wj() {
    $b36288e2db101ba3$var$Ji = $b36288e2db101ba3$var$O() + 500;
}
var $b36288e2db101ba3$var$Z = null, $b36288e2db101ba3$var$Qi = !1, $b36288e2db101ba3$var$Ri = null, $b36288e2db101ba3$var$Ti = null, $b36288e2db101ba3$var$xj = !1, $b36288e2db101ba3$var$yj = null, $b36288e2db101ba3$var$zj = 90, $b36288e2db101ba3$var$Aj = [], $b36288e2db101ba3$var$Bj = [], $b36288e2db101ba3$var$Cj = null, $b36288e2db101ba3$var$Dj = 0, $b36288e2db101ba3$var$Ej = null, $b36288e2db101ba3$var$Fj = -1, $b36288e2db101ba3$var$Gj = 0, $b36288e2db101ba3$var$Hj = 0, $b36288e2db101ba3$var$Ij = null, $b36288e2db101ba3$var$Jj = !1;
function $b36288e2db101ba3$var$Hg() {
    return 0 !== ($b36288e2db101ba3$var$X & 48) ? $b36288e2db101ba3$var$O() : -1 !== $b36288e2db101ba3$var$Fj ? $b36288e2db101ba3$var$Fj : $b36288e2db101ba3$var$Fj = $b36288e2db101ba3$var$O();
}
function $b36288e2db101ba3$var$Ig(a) {
    a = a.mode;
    if (0 === (a & 2)) return 1;
    if (0 === (a & 4)) return 99 === $b36288e2db101ba3$var$eg() ? 1 : 2;
    0 === $b36288e2db101ba3$var$Gj && ($b36288e2db101ba3$var$Gj = $b36288e2db101ba3$var$tj);
    if (0 !== $b36288e2db101ba3$var$kg.transition) {
        0 !== $b36288e2db101ba3$var$Hj && ($b36288e2db101ba3$var$Hj = null !== $b36288e2db101ba3$var$vj ? $b36288e2db101ba3$var$vj.pendingLanes : 0);
        a = $b36288e2db101ba3$var$Gj;
        var b = 4186112 & ~$b36288e2db101ba3$var$Hj;
        b &= -b;
        0 === b && (a = 4186112 & ~a, b = a & -a, 0 === b && (b = 8192));
        return b;
    }
    a = $b36288e2db101ba3$var$eg();
    0 !== ($b36288e2db101ba3$var$X & 4) && 98 === a ? a = $b36288e2db101ba3$var$Xc(12, $b36288e2db101ba3$var$Gj) : (a = $b36288e2db101ba3$var$Sc(a), a = $b36288e2db101ba3$var$Xc(a, $b36288e2db101ba3$var$Gj));
    return a;
}
function $b36288e2db101ba3$var$Jg(a, b, c) {
    if (50 < $b36288e2db101ba3$var$Dj) throw $b36288e2db101ba3$var$Dj = 0, $b36288e2db101ba3$var$Ej = null, Error($b36288e2db101ba3$var$y(185));
    a = $b36288e2db101ba3$var$Kj(a, b);
    if (null === a) return null;
    $b36288e2db101ba3$var$$c(a, b, c);
    a === $b36288e2db101ba3$var$U && ($b36288e2db101ba3$var$Hi |= b, 4 === $b36288e2db101ba3$var$V && $b36288e2db101ba3$var$Ii(a, $b36288e2db101ba3$var$W));
    var d = $b36288e2db101ba3$var$eg();
    1 === b ? 0 !== ($b36288e2db101ba3$var$X & 8) && 0 === ($b36288e2db101ba3$var$X & 48) ? $b36288e2db101ba3$var$Lj(a) : ($b36288e2db101ba3$var$Mj(a, c), 0 === $b36288e2db101ba3$var$X && ($b36288e2db101ba3$var$wj(), $b36288e2db101ba3$var$ig())) : (0 === ($b36288e2db101ba3$var$X & 4) || 98 !== d && 99 !== d || (null === $b36288e2db101ba3$var$Cj ? $b36288e2db101ba3$var$Cj = new Set([
        a
    ]) : $b36288e2db101ba3$var$Cj.add(a)), $b36288e2db101ba3$var$Mj(a, c));
    $b36288e2db101ba3$var$vj = a;
}
function $b36288e2db101ba3$var$Kj(a, b) {
    a.lanes |= b;
    var c = a.alternate;
    null !== c && (c.lanes |= b);
    c = a;
    for(a = a.return; null !== a;)a.childLanes |= b, c = a.alternate, null !== c && (c.childLanes |= b), c = a, a = a.return;
    return 3 === c.tag ? c.stateNode : null;
}
function $b36288e2db101ba3$var$Mj(a, b) {
    for(var c = a.callbackNode, d = a.suspendedLanes, e = a.pingedLanes, f = a.expirationTimes, g = a.pendingLanes; 0 < g;){
        var h = 31 - $b36288e2db101ba3$var$Vc(g), k = 1 << h, l = f[h];
        if (-1 === l) {
            if (0 === (k & d) || 0 !== (k & e)) {
                l = b;
                $b36288e2db101ba3$var$Rc(k);
                var n = $b36288e2db101ba3$var$F;
                f[h] = 10 <= n ? l + 250 : 6 <= n ? l + 5E3 : -1;
            }
        } else l <= b && (a.expiredLanes |= k);
        g &= ~k;
    }
    d = $b36288e2db101ba3$var$Uc(a, a === $b36288e2db101ba3$var$U ? $b36288e2db101ba3$var$W : 0);
    b = $b36288e2db101ba3$var$F;
    if (0 === d) null !== c && (c !== $b36288e2db101ba3$var$Zf && $b36288e2db101ba3$var$Pf(c), a.callbackNode = null, a.callbackPriority = 0);
    else {
        if (null !== c) {
            if (a.callbackPriority === b) return;
            c !== $b36288e2db101ba3$var$Zf && $b36288e2db101ba3$var$Pf(c);
        }
        15 === b ? (c = $b36288e2db101ba3$var$Lj.bind(null, a), null === $b36288e2db101ba3$var$ag ? ($b36288e2db101ba3$var$ag = [
            c
        ], $b36288e2db101ba3$var$bg = $b36288e2db101ba3$var$Of($b36288e2db101ba3$var$Uf, $b36288e2db101ba3$var$jg)) : $b36288e2db101ba3$var$ag.push(c), c = $b36288e2db101ba3$var$Zf) : 14 === b ? c = $b36288e2db101ba3$var$hg(99, $b36288e2db101ba3$var$Lj.bind(null, a)) : (c = $b36288e2db101ba3$var$Tc(b), c = $b36288e2db101ba3$var$hg(c, $b36288e2db101ba3$var$Nj.bind(null, a)));
        a.callbackPriority = b;
        a.callbackNode = c;
    }
}
function $b36288e2db101ba3$var$Nj(a) {
    $b36288e2db101ba3$var$Fj = -1;
    $b36288e2db101ba3$var$Hj = $b36288e2db101ba3$var$Gj = 0;
    if (0 !== ($b36288e2db101ba3$var$X & 48)) throw Error($b36288e2db101ba3$var$y(327));
    var b = a.callbackNode;
    if ($b36288e2db101ba3$var$Oj() && a.callbackNode !== b) return null;
    var c = $b36288e2db101ba3$var$Uc(a, a === $b36288e2db101ba3$var$U ? $b36288e2db101ba3$var$W : 0);
    if (0 === c) return null;
    var d = c;
    var e = $b36288e2db101ba3$var$X;
    $b36288e2db101ba3$var$X |= 16;
    var f = $b36288e2db101ba3$var$Pj();
    if ($b36288e2db101ba3$var$U !== a || $b36288e2db101ba3$var$W !== d) $b36288e2db101ba3$var$wj(), $b36288e2db101ba3$var$Qj(a, d);
    for(;;)try {
        $b36288e2db101ba3$var$Rj();
        break;
    } catch (h) {
        $b36288e2db101ba3$var$Sj(a, h);
    }
    $b36288e2db101ba3$var$qg();
    $b36288e2db101ba3$var$oj.current = f;
    $b36288e2db101ba3$var$X = e;
    null !== $b36288e2db101ba3$var$Y ? d = 0 : ($b36288e2db101ba3$var$U = null, $b36288e2db101ba3$var$W = 0, d = $b36288e2db101ba3$var$V);
    if (0 !== ($b36288e2db101ba3$var$tj & $b36288e2db101ba3$var$Hi)) $b36288e2db101ba3$var$Qj(a, 0);
    else if (0 !== d) {
        2 === d && ($b36288e2db101ba3$var$X |= 64, a.hydrate && (a.hydrate = !1, $b36288e2db101ba3$var$qf(a.containerInfo)), c = $b36288e2db101ba3$var$Wc(a), 0 !== c && (d = $b36288e2db101ba3$var$Tj(a, c)));
        if (1 === d) throw b = $b36288e2db101ba3$var$sj, $b36288e2db101ba3$var$Qj(a, 0), $b36288e2db101ba3$var$Ii(a, c), $b36288e2db101ba3$var$Mj(a, $b36288e2db101ba3$var$O()), b;
        a.finishedWork = a.current.alternate;
        a.finishedLanes = c;
        switch(d){
            case 0:
            case 1:
                throw Error($b36288e2db101ba3$var$y(345));
            case 2:
                $b36288e2db101ba3$var$Uj(a);
                break;
            case 3:
                $b36288e2db101ba3$var$Ii(a, c);
                if ((c & 62914560) === c && (d = $b36288e2db101ba3$var$jj + 500 - $b36288e2db101ba3$var$O(), 10 < d)) {
                    if (0 !== $b36288e2db101ba3$var$Uc(a, 0)) break;
                    e = a.suspendedLanes;
                    if ((e & c) !== c) {
                        $b36288e2db101ba3$var$Hg();
                        a.pingedLanes |= a.suspendedLanes & e;
                        break;
                    }
                    a.timeoutHandle = $b36288e2db101ba3$var$of($b36288e2db101ba3$var$Uj.bind(null, a), d);
                    break;
                }
                $b36288e2db101ba3$var$Uj(a);
                break;
            case 4:
                $b36288e2db101ba3$var$Ii(a, c);
                if ((c & 4186112) === c) break;
                d = a.eventTimes;
                for(e = -1; 0 < c;){
                    var g = 31 - $b36288e2db101ba3$var$Vc(c);
                    f = 1 << g;
                    g = d[g];
                    g > e && (e = g);
                    c &= ~f;
                }
                c = e;
                c = $b36288e2db101ba3$var$O() - c;
                c = (120 > c ? 120 : 480 > c ? 480 : 1080 > c ? 1080 : 1920 > c ? 1920 : 3E3 > c ? 3E3 : 4320 > c ? 4320 : 1960 * $b36288e2db101ba3$var$nj(c / 1960)) - c;
                if (10 < c) {
                    a.timeoutHandle = $b36288e2db101ba3$var$of($b36288e2db101ba3$var$Uj.bind(null, a), c);
                    break;
                }
                $b36288e2db101ba3$var$Uj(a);
                break;
            case 5:
                $b36288e2db101ba3$var$Uj(a);
                break;
            default:
                throw Error($b36288e2db101ba3$var$y(329));
        }
    }
    $b36288e2db101ba3$var$Mj(a, $b36288e2db101ba3$var$O());
    return a.callbackNode === b ? $b36288e2db101ba3$var$Nj.bind(null, a) : null;
}
function $b36288e2db101ba3$var$Ii(a, b) {
    b &= ~$b36288e2db101ba3$var$uj;
    b &= ~$b36288e2db101ba3$var$Hi;
    a.suspendedLanes |= b;
    a.pingedLanes &= ~b;
    for(a = a.expirationTimes; 0 < b;){
        var c = 31 - $b36288e2db101ba3$var$Vc(b), d = 1 << c;
        a[c] = -1;
        b &= ~d;
    }
}
function $b36288e2db101ba3$var$Lj(a) {
    if (0 !== ($b36288e2db101ba3$var$X & 48)) throw Error($b36288e2db101ba3$var$y(327));
    $b36288e2db101ba3$var$Oj();
    if (a === $b36288e2db101ba3$var$U && 0 !== (a.expiredLanes & $b36288e2db101ba3$var$W)) {
        var b = $b36288e2db101ba3$var$W;
        var c = $b36288e2db101ba3$var$Tj(a, b);
        0 !== ($b36288e2db101ba3$var$tj & $b36288e2db101ba3$var$Hi) && (b = $b36288e2db101ba3$var$Uc(a, b), c = $b36288e2db101ba3$var$Tj(a, b));
    } else b = $b36288e2db101ba3$var$Uc(a, 0), c = $b36288e2db101ba3$var$Tj(a, b);
    0 !== a.tag && 2 === c && ($b36288e2db101ba3$var$X |= 64, a.hydrate && (a.hydrate = !1, $b36288e2db101ba3$var$qf(a.containerInfo)), b = $b36288e2db101ba3$var$Wc(a), 0 !== b && (c = $b36288e2db101ba3$var$Tj(a, b)));
    if (1 === c) throw c = $b36288e2db101ba3$var$sj, $b36288e2db101ba3$var$Qj(a, 0), $b36288e2db101ba3$var$Ii(a, b), $b36288e2db101ba3$var$Mj(a, $b36288e2db101ba3$var$O()), c;
    a.finishedWork = a.current.alternate;
    a.finishedLanes = b;
    $b36288e2db101ba3$var$Uj(a);
    $b36288e2db101ba3$var$Mj(a, $b36288e2db101ba3$var$O());
    return null;
}
function $b36288e2db101ba3$var$Vj() {
    if (null !== $b36288e2db101ba3$var$Cj) {
        var a = $b36288e2db101ba3$var$Cj;
        $b36288e2db101ba3$var$Cj = null;
        a.forEach(function(a) {
            a.expiredLanes |= 24 & a.pendingLanes;
            $b36288e2db101ba3$var$Mj(a, $b36288e2db101ba3$var$O());
        });
    }
    $b36288e2db101ba3$var$ig();
}
function $b36288e2db101ba3$var$Wj(a, b) {
    var c = $b36288e2db101ba3$var$X;
    $b36288e2db101ba3$var$X |= 1;
    try {
        return a(b);
    } finally{
        $b36288e2db101ba3$var$X = c, 0 === $b36288e2db101ba3$var$X && ($b36288e2db101ba3$var$wj(), $b36288e2db101ba3$var$ig());
    }
}
function $b36288e2db101ba3$var$Xj(a, b) {
    var c = $b36288e2db101ba3$var$X;
    $b36288e2db101ba3$var$X &= -2;
    $b36288e2db101ba3$var$X |= 8;
    try {
        return a(b);
    } finally{
        $b36288e2db101ba3$var$X = c, 0 === $b36288e2db101ba3$var$X && ($b36288e2db101ba3$var$wj(), $b36288e2db101ba3$var$ig());
    }
}
function $b36288e2db101ba3$var$ni(a, b) {
    $b36288e2db101ba3$var$I($b36288e2db101ba3$var$rj, $b36288e2db101ba3$var$qj);
    $b36288e2db101ba3$var$qj |= b;
    $b36288e2db101ba3$var$tj |= b;
}
function $b36288e2db101ba3$var$Ki() {
    $b36288e2db101ba3$var$qj = $b36288e2db101ba3$var$rj.current;
    $b36288e2db101ba3$var$H($b36288e2db101ba3$var$rj);
}
function $b36288e2db101ba3$var$Qj(a, b) {
    a.finishedWork = null;
    a.finishedLanes = 0;
    var c = a.timeoutHandle;
    -1 !== c && (a.timeoutHandle = -1, $b36288e2db101ba3$var$pf(c));
    if (null !== $b36288e2db101ba3$var$Y) for(c = $b36288e2db101ba3$var$Y.return; null !== c;){
        var d = c;
        switch(d.tag){
            case 1:
                d = d.type.childContextTypes;
                null !== d && void 0 !== d && $b36288e2db101ba3$var$Gf();
                break;
            case 3:
                $b36288e2db101ba3$var$fh();
                $b36288e2db101ba3$var$H($b36288e2db101ba3$var$N);
                $b36288e2db101ba3$var$H($b36288e2db101ba3$var$M);
                $b36288e2db101ba3$var$uh();
                break;
            case 5:
                $b36288e2db101ba3$var$hh(d);
                break;
            case 4:
                $b36288e2db101ba3$var$fh();
                break;
            case 13:
                $b36288e2db101ba3$var$H($b36288e2db101ba3$var$P);
                break;
            case 19:
                $b36288e2db101ba3$var$H($b36288e2db101ba3$var$P);
                break;
            case 10:
                $b36288e2db101ba3$var$rg(d);
                break;
            case 23:
            case 24:
                $b36288e2db101ba3$var$Ki();
        }
        c = c.return;
    }
    $b36288e2db101ba3$var$U = a;
    $b36288e2db101ba3$var$Y = $b36288e2db101ba3$var$Tg(a.current, null);
    $b36288e2db101ba3$var$W = $b36288e2db101ba3$var$qj = $b36288e2db101ba3$var$tj = b;
    $b36288e2db101ba3$var$V = 0;
    $b36288e2db101ba3$var$sj = null;
    $b36288e2db101ba3$var$uj = $b36288e2db101ba3$var$Hi = $b36288e2db101ba3$var$Dg = 0;
}
function $b36288e2db101ba3$var$Sj(a, b) {
    do {
        var c = $b36288e2db101ba3$var$Y;
        try {
            $b36288e2db101ba3$var$qg();
            $b36288e2db101ba3$var$vh.current = $b36288e2db101ba3$var$Gh;
            if ($b36288e2db101ba3$var$yh) {
                for(var d = $b36288e2db101ba3$var$R.memoizedState; null !== d;){
                    var e = d.queue;
                    null !== e && (e.pending = null);
                    d = d.next;
                }
                $b36288e2db101ba3$var$yh = !1;
            }
            $b36288e2db101ba3$var$xh = 0;
            $b36288e2db101ba3$var$T = $b36288e2db101ba3$var$S = $b36288e2db101ba3$var$R = null;
            $b36288e2db101ba3$var$zh = !1;
            $b36288e2db101ba3$var$pj.current = null;
            if (null === c || null === c.return) {
                $b36288e2db101ba3$var$V = 1;
                $b36288e2db101ba3$var$sj = b;
                $b36288e2db101ba3$var$Y = null;
                break;
            }
            a: {
                var f = a, g = c.return, h = c, k = b;
                b = $b36288e2db101ba3$var$W;
                h.flags |= 2048;
                h.firstEffect = h.lastEffect = null;
                if (null !== k && "object" === typeof k && "function" === typeof k.then) {
                    var l = k;
                    if (0 === (h.mode & 2)) {
                        var n = h.alternate;
                        n ? (h.updateQueue = n.updateQueue, h.memoizedState = n.memoizedState, h.lanes = n.lanes) : (h.updateQueue = null, h.memoizedState = null);
                    }
                    var A = 0 !== ($b36288e2db101ba3$var$P.current & 1), p = g;
                    do {
                        var C;
                        if (C = 13 === p.tag) {
                            var x = p.memoizedState;
                            if (null !== x) C = null !== x.dehydrated ? !0 : !1;
                            else {
                                var w = p.memoizedProps;
                                C = void 0 === w.fallback ? !1 : !0 !== w.unstable_avoidThisFallback ? !0 : A ? !1 : !0;
                            }
                        }
                        if (C) {
                            var z = p.updateQueue;
                            if (null === z) {
                                var u = new Set;
                                u.add(l);
                                p.updateQueue = u;
                            } else z.add(l);
                            if (0 === (p.mode & 2)) {
                                p.flags |= 64;
                                h.flags |= 16384;
                                h.flags &= -2981;
                                if (1 === h.tag) {
                                    if (null === h.alternate) h.tag = 17;
                                    else {
                                        var t = $b36288e2db101ba3$var$zg(-1, 1);
                                        t.tag = 2;
                                        $b36288e2db101ba3$var$Ag(h, t);
                                    }
                                }
                                h.lanes |= 1;
                                break a;
                            }
                            k = void 0;
                            h = b;
                            var q = f.pingCache;
                            null === q ? (q = f.pingCache = new $b36288e2db101ba3$var$Oi, k = new Set, q.set(l, k)) : (k = q.get(l), void 0 === k && (k = new Set, q.set(l, k)));
                            if (!k.has(h)) {
                                k.add(h);
                                var v = $b36288e2db101ba3$var$Yj.bind(null, f, l, h);
                                l.then(v, v);
                            }
                            p.flags |= 4096;
                            p.lanes = b;
                            break a;
                        }
                        p = p.return;
                    }while (null !== p);
                    k = Error(($b36288e2db101ba3$var$Ra(h.type) || "A React component") + " suspended while rendering, but no fallback UI was specified.\n\nAdd a <Suspense fallback=...> component higher in the tree to provide a loading indicator or placeholder to display.");
                }
                5 !== $b36288e2db101ba3$var$V && ($b36288e2db101ba3$var$V = 2);
                k = $b36288e2db101ba3$var$Mi(k, h);
                p = g;
                do {
                    switch(p.tag){
                        case 3:
                            f = k;
                            p.flags |= 4096;
                            b &= -b;
                            p.lanes |= b;
                            var J = $b36288e2db101ba3$var$Pi(p, f, b);
                            $b36288e2db101ba3$var$Bg(p, J);
                            break a;
                        case 1:
                            f = k;
                            var K = p.type, Q = p.stateNode;
                            if (0 === (p.flags & 64) && ("function" === typeof K.getDerivedStateFromError || null !== Q && "function" === typeof Q.componentDidCatch && (null === $b36288e2db101ba3$var$Ti || !$b36288e2db101ba3$var$Ti.has(Q)))) {
                                p.flags |= 4096;
                                b &= -b;
                                p.lanes |= b;
                                var L = $b36288e2db101ba3$var$Si(p, f, b);
                                $b36288e2db101ba3$var$Bg(p, L);
                                break a;
                            }
                    }
                    p = p.return;
                }while (null !== p);
            }
            $b36288e2db101ba3$var$Zj(c);
        } catch (va) {
            b = va;
            $b36288e2db101ba3$var$Y === c && null !== c && ($b36288e2db101ba3$var$Y = c = c.return);
            continue;
        }
        break;
    }while (1);
}
function $b36288e2db101ba3$var$Pj() {
    var a = $b36288e2db101ba3$var$oj.current;
    $b36288e2db101ba3$var$oj.current = $b36288e2db101ba3$var$Gh;
    return null === a ? $b36288e2db101ba3$var$Gh : a;
}
function $b36288e2db101ba3$var$Tj(a, b) {
    var c = $b36288e2db101ba3$var$X;
    $b36288e2db101ba3$var$X |= 16;
    var d = $b36288e2db101ba3$var$Pj();
    $b36288e2db101ba3$var$U === a && $b36288e2db101ba3$var$W === b || $b36288e2db101ba3$var$Qj(a, b);
    for(;;)try {
        $b36288e2db101ba3$var$ak();
        break;
    } catch (e) {
        $b36288e2db101ba3$var$Sj(a, e);
    }
    $b36288e2db101ba3$var$qg();
    $b36288e2db101ba3$var$X = c;
    $b36288e2db101ba3$var$oj.current = d;
    if (null !== $b36288e2db101ba3$var$Y) throw Error($b36288e2db101ba3$var$y(261));
    $b36288e2db101ba3$var$U = null;
    $b36288e2db101ba3$var$W = 0;
    return $b36288e2db101ba3$var$V;
}
function $b36288e2db101ba3$var$ak() {
    for(; null !== $b36288e2db101ba3$var$Y;)$b36288e2db101ba3$var$bk($b36288e2db101ba3$var$Y);
}
function $b36288e2db101ba3$var$Rj() {
    for(; null !== $b36288e2db101ba3$var$Y && !$b36288e2db101ba3$var$Qf();)$b36288e2db101ba3$var$bk($b36288e2db101ba3$var$Y);
}
function $b36288e2db101ba3$var$bk(a) {
    var b = $b36288e2db101ba3$var$ck(a.alternate, a, $b36288e2db101ba3$var$qj);
    a.memoizedProps = a.pendingProps;
    null === b ? $b36288e2db101ba3$var$Zj(a) : $b36288e2db101ba3$var$Y = b;
    $b36288e2db101ba3$var$pj.current = null;
}
function $b36288e2db101ba3$var$Zj(a) {
    var b = a;
    do {
        var c = b.alternate;
        a = b.return;
        if (0 === (b.flags & 2048)) {
            c = $b36288e2db101ba3$var$Gi(c, b, $b36288e2db101ba3$var$qj);
            if (null !== c) {
                $b36288e2db101ba3$var$Y = c;
                return;
            }
            c = b;
            if (24 !== c.tag && 23 !== c.tag || null === c.memoizedState || 0 !== ($b36288e2db101ba3$var$qj & 1073741824) || 0 === (c.mode & 4)) {
                for(var d = 0, e = c.child; null !== e;)d |= e.lanes | e.childLanes, e = e.sibling;
                c.childLanes = d;
            }
            null !== a && 0 === (a.flags & 2048) && (null === a.firstEffect && (a.firstEffect = b.firstEffect), null !== b.lastEffect && (null !== a.lastEffect && (a.lastEffect.nextEffect = b.firstEffect), a.lastEffect = b.lastEffect), 1 < b.flags && (null !== a.lastEffect ? a.lastEffect.nextEffect = b : a.firstEffect = b, a.lastEffect = b));
        } else {
            c = $b36288e2db101ba3$var$Li(b);
            if (null !== c) {
                c.flags &= 2047;
                $b36288e2db101ba3$var$Y = c;
                return;
            }
            null !== a && (a.firstEffect = a.lastEffect = null, a.flags |= 2048);
        }
        b = b.sibling;
        if (null !== b) {
            $b36288e2db101ba3$var$Y = b;
            return;
        }
        $b36288e2db101ba3$var$Y = b = a;
    }while (null !== b);
    0 === $b36288e2db101ba3$var$V && ($b36288e2db101ba3$var$V = 5);
}
function $b36288e2db101ba3$var$Uj(a) {
    var b = $b36288e2db101ba3$var$eg();
    $b36288e2db101ba3$var$gg(99, $b36288e2db101ba3$var$dk.bind(null, a, b));
    return null;
}
function $b36288e2db101ba3$var$dk(a, b) {
    do $b36288e2db101ba3$var$Oj();
    while (null !== $b36288e2db101ba3$var$yj);
    if (0 !== ($b36288e2db101ba3$var$X & 48)) throw Error($b36288e2db101ba3$var$y(327));
    var c = a.finishedWork;
    if (null === c) return null;
    a.finishedWork = null;
    a.finishedLanes = 0;
    if (c === a.current) throw Error($b36288e2db101ba3$var$y(177));
    a.callbackNode = null;
    var d = c.lanes | c.childLanes, e = d, f = a.pendingLanes & ~e;
    a.pendingLanes = e;
    a.suspendedLanes = 0;
    a.pingedLanes = 0;
    a.expiredLanes &= e;
    a.mutableReadLanes &= e;
    a.entangledLanes &= e;
    e = a.entanglements;
    for(var g = a.eventTimes, h = a.expirationTimes; 0 < f;){
        var k = 31 - $b36288e2db101ba3$var$Vc(f), l = 1 << k;
        e[k] = 0;
        g[k] = -1;
        h[k] = -1;
        f &= ~l;
    }
    null !== $b36288e2db101ba3$var$Cj && 0 === (d & 24) && $b36288e2db101ba3$var$Cj.has(a) && $b36288e2db101ba3$var$Cj.delete(a);
    a === $b36288e2db101ba3$var$U && ($b36288e2db101ba3$var$Y = $b36288e2db101ba3$var$U = null, $b36288e2db101ba3$var$W = 0);
    1 < c.flags ? null !== c.lastEffect ? (c.lastEffect.nextEffect = c, d = c.firstEffect) : d = c : d = c.firstEffect;
    if (null !== d) {
        e = $b36288e2db101ba3$var$X;
        $b36288e2db101ba3$var$X |= 32;
        $b36288e2db101ba3$var$pj.current = null;
        $b36288e2db101ba3$var$kf = $b36288e2db101ba3$var$fd;
        g = $b36288e2db101ba3$var$Ne();
        if ($b36288e2db101ba3$var$Oe(g)) {
            if ("selectionStart" in g) h = {
                start: g.selectionStart,
                end: g.selectionEnd
            };
            else a: if (h = (h = g.ownerDocument) && h.defaultView || window, (l = h.getSelection && h.getSelection()) && 0 !== l.rangeCount) {
                h = l.anchorNode;
                f = l.anchorOffset;
                k = l.focusNode;
                l = l.focusOffset;
                try {
                    h.nodeType, k.nodeType;
                } catch (va) {
                    h = null;
                    break a;
                }
                var n = 0, A = -1, p = -1, C = 0, x = 0, w = g, z = null;
                b: for(;;){
                    for(var u;;){
                        w !== h || 0 !== f && 3 !== w.nodeType || (A = n + f);
                        w !== k || 0 !== l && 3 !== w.nodeType || (p = n + l);
                        3 === w.nodeType && (n += w.nodeValue.length);
                        if (null === (u = w.firstChild)) break;
                        z = w;
                        w = u;
                    }
                    for(;;){
                        if (w === g) break b;
                        z === h && ++C === f && (A = n);
                        z === k && ++x === l && (p = n);
                        if (null !== (u = w.nextSibling)) break;
                        w = z;
                        z = w.parentNode;
                    }
                    w = u;
                }
                h = -1 === A || -1 === p ? null : {
                    start: A,
                    end: p
                };
            } else h = null;
            h = h || {
                start: 0,
                end: 0
            };
        } else h = null;
        $b36288e2db101ba3$var$lf = {
            focusedElem: g,
            selectionRange: h
        };
        $b36288e2db101ba3$var$fd = !1;
        $b36288e2db101ba3$var$Ij = null;
        $b36288e2db101ba3$var$Jj = !1;
        $b36288e2db101ba3$var$Z = d;
        do try {
            $b36288e2db101ba3$var$ek();
        } catch (va) {
            if (null === $b36288e2db101ba3$var$Z) throw Error($b36288e2db101ba3$var$y(330));
            $b36288e2db101ba3$var$Wi($b36288e2db101ba3$var$Z, va);
            $b36288e2db101ba3$var$Z = $b36288e2db101ba3$var$Z.nextEffect;
        }
        while (null !== $b36288e2db101ba3$var$Z);
        $b36288e2db101ba3$var$Ij = null;
        $b36288e2db101ba3$var$Z = d;
        do try {
            for(g = a; null !== $b36288e2db101ba3$var$Z;){
                var t = $b36288e2db101ba3$var$Z.flags;
                t & 16 && $b36288e2db101ba3$var$pb($b36288e2db101ba3$var$Z.stateNode, "");
                if (t & 128) {
                    var q = $b36288e2db101ba3$var$Z.alternate;
                    if (null !== q) {
                        var v = q.ref;
                        null !== v && ("function" === typeof v ? v(null) : v.current = null);
                    }
                }
                switch(t & 1038){
                    case 2:
                        $b36288e2db101ba3$var$fj($b36288e2db101ba3$var$Z);
                        $b36288e2db101ba3$var$Z.flags &= -3;
                        break;
                    case 6:
                        $b36288e2db101ba3$var$fj($b36288e2db101ba3$var$Z);
                        $b36288e2db101ba3$var$Z.flags &= -3;
                        $b36288e2db101ba3$var$ij($b36288e2db101ba3$var$Z.alternate, $b36288e2db101ba3$var$Z);
                        break;
                    case 1024:
                        $b36288e2db101ba3$var$Z.flags &= -1025;
                        break;
                    case 1028:
                        $b36288e2db101ba3$var$Z.flags &= -1025;
                        $b36288e2db101ba3$var$ij($b36288e2db101ba3$var$Z.alternate, $b36288e2db101ba3$var$Z);
                        break;
                    case 4:
                        $b36288e2db101ba3$var$ij($b36288e2db101ba3$var$Z.alternate, $b36288e2db101ba3$var$Z);
                        break;
                    case 8:
                        h = $b36288e2db101ba3$var$Z;
                        $b36288e2db101ba3$var$cj(g, h);
                        var J = h.alternate;
                        $b36288e2db101ba3$var$dj(h);
                        null !== J && $b36288e2db101ba3$var$dj(J);
                }
                $b36288e2db101ba3$var$Z = $b36288e2db101ba3$var$Z.nextEffect;
            }
        } catch (va) {
            if (null === $b36288e2db101ba3$var$Z) throw Error($b36288e2db101ba3$var$y(330));
            $b36288e2db101ba3$var$Wi($b36288e2db101ba3$var$Z, va);
            $b36288e2db101ba3$var$Z = $b36288e2db101ba3$var$Z.nextEffect;
        }
        while (null !== $b36288e2db101ba3$var$Z);
        v = $b36288e2db101ba3$var$lf;
        q = $b36288e2db101ba3$var$Ne();
        t = v.focusedElem;
        g = v.selectionRange;
        if (q !== t && t && t.ownerDocument && $b36288e2db101ba3$var$Me(t.ownerDocument.documentElement, t)) {
            null !== g && $b36288e2db101ba3$var$Oe(t) && (q = g.start, v = g.end, void 0 === v && (v = q), "selectionStart" in t ? (t.selectionStart = q, t.selectionEnd = Math.min(v, t.value.length)) : (v = (q = t.ownerDocument || document) && q.defaultView || window, v.getSelection && (v = v.getSelection(), h = t.textContent.length, J = Math.min(g.start, h), g = void 0 === g.end ? J : Math.min(g.end, h), !v.extend && J > g && (h = g, g = J, J = h), h = $b36288e2db101ba3$var$Le(t, J), f = $b36288e2db101ba3$var$Le(t, g), h && f && (1 !== v.rangeCount || v.anchorNode !== h.node || v.anchorOffset !== h.offset || v.focusNode !== f.node || v.focusOffset !== f.offset) && (q = q.createRange(), q.setStart(h.node, h.offset), v.removeAllRanges(), J > g ? (v.addRange(q), v.extend(f.node, f.offset)) : (q.setEnd(f.node, f.offset), v.addRange(q))))));
            q = [];
            for(v = t; v = v.parentNode;)1 === v.nodeType && q.push({
                element: v,
                left: v.scrollLeft,
                top: v.scrollTop
            });
            "function" === typeof t.focus && t.focus();
            for(t = 0; t < q.length; t++)v = q[t], v.element.scrollLeft = v.left, v.element.scrollTop = v.top;
        }
        $b36288e2db101ba3$var$fd = !!$b36288e2db101ba3$var$kf;
        $b36288e2db101ba3$var$lf = $b36288e2db101ba3$var$kf = null;
        a.current = c;
        $b36288e2db101ba3$var$Z = d;
        do try {
            for(t = a; null !== $b36288e2db101ba3$var$Z;){
                var K = $b36288e2db101ba3$var$Z.flags;
                K & 36 && $b36288e2db101ba3$var$Yi(t, $b36288e2db101ba3$var$Z.alternate, $b36288e2db101ba3$var$Z);
                if (K & 128) {
                    q = void 0;
                    var Q = $b36288e2db101ba3$var$Z.ref;
                    if (null !== Q) {
                        var L = $b36288e2db101ba3$var$Z.stateNode;
                        switch($b36288e2db101ba3$var$Z.tag){
                            case 5:
                                q = L;
                                break;
                            default:
                                q = L;
                        }
                        "function" === typeof Q ? Q(q) : Q.current = q;
                    }
                }
                $b36288e2db101ba3$var$Z = $b36288e2db101ba3$var$Z.nextEffect;
            }
        } catch (va) {
            if (null === $b36288e2db101ba3$var$Z) throw Error($b36288e2db101ba3$var$y(330));
            $b36288e2db101ba3$var$Wi($b36288e2db101ba3$var$Z, va);
            $b36288e2db101ba3$var$Z = $b36288e2db101ba3$var$Z.nextEffect;
        }
        while (null !== $b36288e2db101ba3$var$Z);
        $b36288e2db101ba3$var$Z = null;
        $b36288e2db101ba3$var$$f();
        $b36288e2db101ba3$var$X = e;
    } else a.current = c;
    if ($b36288e2db101ba3$var$xj) $b36288e2db101ba3$var$xj = !1, $b36288e2db101ba3$var$yj = a, $b36288e2db101ba3$var$zj = b;
    else for($b36288e2db101ba3$var$Z = d; null !== $b36288e2db101ba3$var$Z;)b = $b36288e2db101ba3$var$Z.nextEffect, $b36288e2db101ba3$var$Z.nextEffect = null, $b36288e2db101ba3$var$Z.flags & 8 && (K = $b36288e2db101ba3$var$Z, K.sibling = null, K.stateNode = null), $b36288e2db101ba3$var$Z = b;
    d = a.pendingLanes;
    0 === d && ($b36288e2db101ba3$var$Ti = null);
    1 === d ? a === $b36288e2db101ba3$var$Ej ? $b36288e2db101ba3$var$Dj++ : ($b36288e2db101ba3$var$Dj = 0, $b36288e2db101ba3$var$Ej = a) : $b36288e2db101ba3$var$Dj = 0;
    c = c.stateNode;
    if ($b36288e2db101ba3$var$Mf && "function" === typeof $b36288e2db101ba3$var$Mf.onCommitFiberRoot) try {
        $b36288e2db101ba3$var$Mf.onCommitFiberRoot($b36288e2db101ba3$var$Lf, c, void 0, 64 === (c.current.flags & 64));
    } catch (va) {}
    $b36288e2db101ba3$var$Mj(a, $b36288e2db101ba3$var$O());
    if ($b36288e2db101ba3$var$Qi) throw $b36288e2db101ba3$var$Qi = !1, a = $b36288e2db101ba3$var$Ri, $b36288e2db101ba3$var$Ri = null, a;
    if (0 !== ($b36288e2db101ba3$var$X & 8)) return null;
    $b36288e2db101ba3$var$ig();
    return null;
}
function $b36288e2db101ba3$var$ek() {
    for(; null !== $b36288e2db101ba3$var$Z;){
        var a = $b36288e2db101ba3$var$Z.alternate;
        $b36288e2db101ba3$var$Jj || null === $b36288e2db101ba3$var$Ij || (0 !== ($b36288e2db101ba3$var$Z.flags & 8) ? $b36288e2db101ba3$var$dc($b36288e2db101ba3$var$Z, $b36288e2db101ba3$var$Ij) && ($b36288e2db101ba3$var$Jj = !0) : 13 === $b36288e2db101ba3$var$Z.tag && $b36288e2db101ba3$var$mj(a, $b36288e2db101ba3$var$Z) && $b36288e2db101ba3$var$dc($b36288e2db101ba3$var$Z, $b36288e2db101ba3$var$Ij) && ($b36288e2db101ba3$var$Jj = !0));
        var b = $b36288e2db101ba3$var$Z.flags;
        0 !== (b & 256) && $b36288e2db101ba3$var$Xi(a, $b36288e2db101ba3$var$Z);
        0 === (b & 512) || $b36288e2db101ba3$var$xj || ($b36288e2db101ba3$var$xj = !0, $b36288e2db101ba3$var$hg(97, function() {
            $b36288e2db101ba3$var$Oj();
            return null;
        }));
        $b36288e2db101ba3$var$Z = $b36288e2db101ba3$var$Z.nextEffect;
    }
}
function $b36288e2db101ba3$var$Oj() {
    if (90 !== $b36288e2db101ba3$var$zj) {
        var a = 97 < $b36288e2db101ba3$var$zj ? 97 : $b36288e2db101ba3$var$zj;
        $b36288e2db101ba3$var$zj = 90;
        return $b36288e2db101ba3$var$gg(a, $b36288e2db101ba3$var$fk);
    }
    return !1;
}
function $b36288e2db101ba3$var$$i(a, b) {
    $b36288e2db101ba3$var$Aj.push(b, a);
    $b36288e2db101ba3$var$xj || ($b36288e2db101ba3$var$xj = !0, $b36288e2db101ba3$var$hg(97, function() {
        $b36288e2db101ba3$var$Oj();
        return null;
    }));
}
function $b36288e2db101ba3$var$Zi(a, b) {
    $b36288e2db101ba3$var$Bj.push(b, a);
    $b36288e2db101ba3$var$xj || ($b36288e2db101ba3$var$xj = !0, $b36288e2db101ba3$var$hg(97, function() {
        $b36288e2db101ba3$var$Oj();
        return null;
    }));
}
function $b36288e2db101ba3$var$fk() {
    if (null === $b36288e2db101ba3$var$yj) return !1;
    var a = $b36288e2db101ba3$var$yj;
    $b36288e2db101ba3$var$yj = null;
    if (0 !== ($b36288e2db101ba3$var$X & 48)) throw Error($b36288e2db101ba3$var$y(331));
    var b = $b36288e2db101ba3$var$X;
    $b36288e2db101ba3$var$X |= 32;
    var c = $b36288e2db101ba3$var$Bj;
    $b36288e2db101ba3$var$Bj = [];
    for(var d = 0; d < c.length; d += 2){
        var e = c[d], f = c[d + 1], g = e.destroy;
        e.destroy = void 0;
        if ("function" === typeof g) try {
            g();
        } catch (k) {
            if (null === f) throw Error($b36288e2db101ba3$var$y(330));
            $b36288e2db101ba3$var$Wi(f, k);
        }
    }
    c = $b36288e2db101ba3$var$Aj;
    $b36288e2db101ba3$var$Aj = [];
    for(d = 0; d < c.length; d += 2){
        e = c[d];
        f = c[d + 1];
        try {
            var h = e.create;
            e.destroy = h();
        } catch (k) {
            if (null === f) throw Error($b36288e2db101ba3$var$y(330));
            $b36288e2db101ba3$var$Wi(f, k);
        }
    }
    for(h = a.current.firstEffect; null !== h;)a = h.nextEffect, h.nextEffect = null, h.flags & 8 && (h.sibling = null, h.stateNode = null), h = a;
    $b36288e2db101ba3$var$X = b;
    $b36288e2db101ba3$var$ig();
    return !0;
}
function $b36288e2db101ba3$var$gk(a, b, c) {
    b = $b36288e2db101ba3$var$Mi(c, b);
    b = $b36288e2db101ba3$var$Pi(a, b, 1);
    $b36288e2db101ba3$var$Ag(a, b);
    b = $b36288e2db101ba3$var$Hg();
    a = $b36288e2db101ba3$var$Kj(a, 1);
    null !== a && ($b36288e2db101ba3$var$$c(a, 1, b), $b36288e2db101ba3$var$Mj(a, b));
}
function $b36288e2db101ba3$var$Wi(a, b) {
    if (3 === a.tag) $b36288e2db101ba3$var$gk(a, a, b);
    else for(var c = a.return; null !== c;){
        if (3 === c.tag) {
            $b36288e2db101ba3$var$gk(c, a, b);
            break;
        } else if (1 === c.tag) {
            var d = c.stateNode;
            if ("function" === typeof c.type.getDerivedStateFromError || "function" === typeof d.componentDidCatch && (null === $b36288e2db101ba3$var$Ti || !$b36288e2db101ba3$var$Ti.has(d))) {
                a = $b36288e2db101ba3$var$Mi(b, a);
                var e = $b36288e2db101ba3$var$Si(c, a, 1);
                $b36288e2db101ba3$var$Ag(c, e);
                e = $b36288e2db101ba3$var$Hg();
                c = $b36288e2db101ba3$var$Kj(c, 1);
                if (null !== c) $b36288e2db101ba3$var$$c(c, 1, e), $b36288e2db101ba3$var$Mj(c, e);
                else if ("function" === typeof d.componentDidCatch && (null === $b36288e2db101ba3$var$Ti || !$b36288e2db101ba3$var$Ti.has(d))) try {
                    d.componentDidCatch(b, a);
                } catch (f) {}
                break;
            }
        }
        c = c.return;
    }
}
function $b36288e2db101ba3$var$Yj(a, b, c) {
    var d = a.pingCache;
    null !== d && d.delete(b);
    b = $b36288e2db101ba3$var$Hg();
    a.pingedLanes |= a.suspendedLanes & c;
    $b36288e2db101ba3$var$U === a && ($b36288e2db101ba3$var$W & c) === c && (4 === $b36288e2db101ba3$var$V || 3 === $b36288e2db101ba3$var$V && ($b36288e2db101ba3$var$W & 62914560) === $b36288e2db101ba3$var$W && 500 > $b36288e2db101ba3$var$O() - $b36288e2db101ba3$var$jj ? $b36288e2db101ba3$var$Qj(a, 0) : $b36288e2db101ba3$var$uj |= c);
    $b36288e2db101ba3$var$Mj(a, b);
}
function $b36288e2db101ba3$var$lj(a, b) {
    var c = a.stateNode;
    null !== c && c.delete(b);
    b = 0;
    0 === b && (b = a.mode, 0 === (b & 2) ? b = 1 : 0 === (b & 4) ? b = 99 === $b36288e2db101ba3$var$eg() ? 1 : 2 : (0 === $b36288e2db101ba3$var$Gj && ($b36288e2db101ba3$var$Gj = $b36288e2db101ba3$var$tj), b = $b36288e2db101ba3$var$Yc(62914560 & ~$b36288e2db101ba3$var$Gj), 0 === b && (b = 4194304)));
    c = $b36288e2db101ba3$var$Hg();
    a = $b36288e2db101ba3$var$Kj(a, b);
    null !== a && ($b36288e2db101ba3$var$$c(a, b, c), $b36288e2db101ba3$var$Mj(a, c));
}
var $b36288e2db101ba3$var$ck;
$b36288e2db101ba3$var$ck = function(a, b, c) {
    var d = b.lanes;
    if (null !== a) {
        if (a.memoizedProps !== b.pendingProps || $b36288e2db101ba3$var$N.current) $b36288e2db101ba3$var$ug = !0;
        else if (0 !== (c & d)) $b36288e2db101ba3$var$ug = 0 !== (a.flags & 16384) ? !0 : !1;
        else {
            $b36288e2db101ba3$var$ug = !1;
            switch(b.tag){
                case 3:
                    $b36288e2db101ba3$var$ri(b);
                    $b36288e2db101ba3$var$sh();
                    break;
                case 5:
                    $b36288e2db101ba3$var$gh(b);
                    break;
                case 1:
                    $b36288e2db101ba3$var$Ff(b.type) && $b36288e2db101ba3$var$Jf(b);
                    break;
                case 4:
                    $b36288e2db101ba3$var$eh(b, b.stateNode.containerInfo);
                    break;
                case 10:
                    d = b.memoizedProps.value;
                    var e = b.type._context;
                    $b36288e2db101ba3$var$I($b36288e2db101ba3$var$mg, e._currentValue);
                    e._currentValue = d;
                    break;
                case 13:
                    if (null !== b.memoizedState) {
                        if (0 !== (c & b.child.childLanes)) return $b36288e2db101ba3$var$ti(a, b, c);
                        $b36288e2db101ba3$var$I($b36288e2db101ba3$var$P, $b36288e2db101ba3$var$P.current & 1);
                        b = $b36288e2db101ba3$var$hi(a, b, c);
                        return null !== b ? b.sibling : null;
                    }
                    $b36288e2db101ba3$var$I($b36288e2db101ba3$var$P, $b36288e2db101ba3$var$P.current & 1);
                    break;
                case 19:
                    d = 0 !== (c & b.childLanes);
                    if (0 !== (a.flags & 64)) {
                        if (d) return $b36288e2db101ba3$var$Ai(a, b, c);
                        b.flags |= 64;
                    }
                    e = b.memoizedState;
                    null !== e && (e.rendering = null, e.tail = null, e.lastEffect = null);
                    $b36288e2db101ba3$var$I($b36288e2db101ba3$var$P, $b36288e2db101ba3$var$P.current);
                    if (d) break;
                    else return null;
                case 23:
                case 24:
                    return b.lanes = 0, $b36288e2db101ba3$var$mi(a, b, c);
            }
            return $b36288e2db101ba3$var$hi(a, b, c);
        }
    } else $b36288e2db101ba3$var$ug = !1;
    b.lanes = 0;
    switch(b.tag){
        case 2:
            d = b.type;
            null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2);
            a = b.pendingProps;
            e = $b36288e2db101ba3$var$Ef(b, $b36288e2db101ba3$var$M.current);
            $b36288e2db101ba3$var$tg(b, c);
            e = $b36288e2db101ba3$var$Ch(null, b, d, a, e, c);
            b.flags |= 1;
            if ("object" === typeof e && null !== e && "function" === typeof e.render && void 0 === e.$$typeof) {
                b.tag = 1;
                b.memoizedState = null;
                b.updateQueue = null;
                if ($b36288e2db101ba3$var$Ff(d)) {
                    var f = !0;
                    $b36288e2db101ba3$var$Jf(b);
                } else f = !1;
                b.memoizedState = null !== e.state && void 0 !== e.state ? e.state : null;
                $b36288e2db101ba3$var$xg(b);
                var g = d.getDerivedStateFromProps;
                "function" === typeof g && $b36288e2db101ba3$var$Gg(b, d, g, a);
                e.updater = $b36288e2db101ba3$var$Kg;
                b.stateNode = e;
                e._reactInternals = b;
                $b36288e2db101ba3$var$Og(b, d, a, c);
                b = $b36288e2db101ba3$var$qi(null, b, d, !0, f, c);
            } else b.tag = 0, $b36288e2db101ba3$var$fi(null, b, e, c), b = b.child;
            return b;
        case 16:
            e = b.elementType;
            a: {
                null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2);
                a = b.pendingProps;
                f = e._init;
                e = f(e._payload);
                b.type = e;
                f = b.tag = $b36288e2db101ba3$var$hk(e);
                a = $b36288e2db101ba3$var$lg(e, a);
                switch(f){
                    case 0:
                        b = $b36288e2db101ba3$var$li(null, b, e, a, c);
                        break a;
                    case 1:
                        b = $b36288e2db101ba3$var$pi(null, b, e, a, c);
                        break a;
                    case 11:
                        b = $b36288e2db101ba3$var$gi(null, b, e, a, c);
                        break a;
                    case 14:
                        b = $b36288e2db101ba3$var$ii(null, b, e, $b36288e2db101ba3$var$lg(e.type, a), d, c);
                        break a;
                }
                throw Error($b36288e2db101ba3$var$y(306, e, ""));
            }
            return b;
        case 0:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $b36288e2db101ba3$var$lg(d, e), $b36288e2db101ba3$var$li(a, b, d, e, c);
        case 1:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $b36288e2db101ba3$var$lg(d, e), $b36288e2db101ba3$var$pi(a, b, d, e, c);
        case 3:
            $b36288e2db101ba3$var$ri(b);
            d = b.updateQueue;
            if (null === a || null === d) throw Error($b36288e2db101ba3$var$y(282));
            d = b.pendingProps;
            e = b.memoizedState;
            e = null !== e ? e.element : null;
            $b36288e2db101ba3$var$yg(a, b);
            $b36288e2db101ba3$var$Cg(b, d, null, c);
            d = b.memoizedState.element;
            if (d === e) $b36288e2db101ba3$var$sh(), b = $b36288e2db101ba3$var$hi(a, b, c);
            else {
                e = b.stateNode;
                if (f = e.hydrate) $b36288e2db101ba3$var$kh = $b36288e2db101ba3$var$rf(b.stateNode.containerInfo.firstChild), $b36288e2db101ba3$var$jh = b, f = $b36288e2db101ba3$var$lh = !0;
                if (f) {
                    a = e.mutableSourceEagerHydrationData;
                    if (null != a) for(e = 0; e < a.length; e += 2)f = a[e], f._workInProgressVersionPrimary = a[e + 1], $b36288e2db101ba3$var$th.push(f);
                    c = $b36288e2db101ba3$var$Zg(b, null, d, c);
                    for(b.child = c; c;)c.flags = c.flags & -3 | 1024, c = c.sibling;
                } else $b36288e2db101ba3$var$fi(a, b, d, c), $b36288e2db101ba3$var$sh();
                b = b.child;
            }
            return b;
        case 5:
            return $b36288e2db101ba3$var$gh(b), null === a && $b36288e2db101ba3$var$ph(b), d = b.type, e = b.pendingProps, f = null !== a ? a.memoizedProps : null, g = e.children, $b36288e2db101ba3$var$nf(d, e) ? g = null : null !== f && $b36288e2db101ba3$var$nf(d, f) && (b.flags |= 16), $b36288e2db101ba3$var$oi(a, b), $b36288e2db101ba3$var$fi(a, b, g, c), b.child;
        case 6:
            return null === a && $b36288e2db101ba3$var$ph(b), null;
        case 13:
            return $b36288e2db101ba3$var$ti(a, b, c);
        case 4:
            return $b36288e2db101ba3$var$eh(b, b.stateNode.containerInfo), d = b.pendingProps, null === a ? b.child = $b36288e2db101ba3$var$Yg(b, null, d, c) : $b36288e2db101ba3$var$fi(a, b, d, c), b.child;
        case 11:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $b36288e2db101ba3$var$lg(d, e), $b36288e2db101ba3$var$gi(a, b, d, e, c);
        case 7:
            return $b36288e2db101ba3$var$fi(a, b, b.pendingProps, c), b.child;
        case 8:
            return $b36288e2db101ba3$var$fi(a, b, b.pendingProps.children, c), b.child;
        case 12:
            return $b36288e2db101ba3$var$fi(a, b, b.pendingProps.children, c), b.child;
        case 10:
            a: {
                d = b.type._context;
                e = b.pendingProps;
                g = b.memoizedProps;
                f = e.value;
                var h = b.type._context;
                $b36288e2db101ba3$var$I($b36288e2db101ba3$var$mg, h._currentValue);
                h._currentValue = f;
                if (null !== g) {
                    if (h = g.value, f = $b36288e2db101ba3$var$He(h, f) ? 0 : ("function" === typeof d._calculateChangedBits ? d._calculateChangedBits(h, f) : 1073741823) | 0, 0 === f) {
                        if (g.children === e.children && !$b36288e2db101ba3$var$N.current) {
                            b = $b36288e2db101ba3$var$hi(a, b, c);
                            break a;
                        }
                    } else for(h = b.child, null !== h && (h.return = b); null !== h;){
                        var k = h.dependencies;
                        if (null !== k) {
                            g = h.child;
                            for(var l = k.firstContext; null !== l;){
                                if (l.context === d && 0 !== (l.observedBits & f)) {
                                    1 === h.tag && (l = $b36288e2db101ba3$var$zg(-1, c & -c), l.tag = 2, $b36288e2db101ba3$var$Ag(h, l));
                                    h.lanes |= c;
                                    l = h.alternate;
                                    null !== l && (l.lanes |= c);
                                    $b36288e2db101ba3$var$sg(h.return, c);
                                    k.lanes |= c;
                                    break;
                                }
                                l = l.next;
                            }
                        } else g = 10 === h.tag ? h.type === b.type ? null : h.child : h.child;
                        if (null !== g) g.return = h;
                        else for(g = h; null !== g;){
                            if (g === b) {
                                g = null;
                                break;
                            }
                            h = g.sibling;
                            if (null !== h) {
                                h.return = g.return;
                                g = h;
                                break;
                            }
                            g = g.return;
                        }
                        h = g;
                    }
                }
                $b36288e2db101ba3$var$fi(a, b, e.children, c);
                b = b.child;
            }
            return b;
        case 9:
            return e = b.type, f = b.pendingProps, d = f.children, $b36288e2db101ba3$var$tg(b, c), e = $b36288e2db101ba3$var$vg(e, f.unstable_observedBits), d = d(e), b.flags |= 1, $b36288e2db101ba3$var$fi(a, b, d, c), b.child;
        case 14:
            return e = b.type, f = $b36288e2db101ba3$var$lg(e, b.pendingProps), f = $b36288e2db101ba3$var$lg(e.type, f), $b36288e2db101ba3$var$ii(a, b, e, f, d, c);
        case 15:
            return $b36288e2db101ba3$var$ki(a, b, b.type, b.pendingProps, d, c);
        case 17:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $b36288e2db101ba3$var$lg(d, e), null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2), b.tag = 1, $b36288e2db101ba3$var$Ff(d) ? (a = !0, $b36288e2db101ba3$var$Jf(b)) : a = !1, $b36288e2db101ba3$var$tg(b, c), $b36288e2db101ba3$var$Mg(b, d, e), $b36288e2db101ba3$var$Og(b, d, e, c), $b36288e2db101ba3$var$qi(null, b, d, !0, a, c);
        case 19:
            return $b36288e2db101ba3$var$Ai(a, b, c);
        case 23:
            return $b36288e2db101ba3$var$mi(a, b, c);
        case 24:
            return $b36288e2db101ba3$var$mi(a, b, c);
    }
    throw Error($b36288e2db101ba3$var$y(156, b.tag));
};
function $b36288e2db101ba3$var$ik(a, b, c, d) {
    this.tag = a;
    this.key = c;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.ref = null;
    this.pendingProps = b;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = d;
    this.flags = 0;
    this.lastEffect = this.firstEffect = this.nextEffect = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function $b36288e2db101ba3$var$nh(a, b, c, d) {
    return new $b36288e2db101ba3$var$ik(a, b, c, d);
}
function $b36288e2db101ba3$var$ji(a) {
    a = a.prototype;
    return !(!a || !a.isReactComponent);
}
function $b36288e2db101ba3$var$hk(a) {
    if ("function" === typeof a) return $b36288e2db101ba3$var$ji(a) ? 1 : 0;
    if (void 0 !== a && null !== a) {
        a = a.$$typeof;
        if (a === $b36288e2db101ba3$var$Aa) return 11;
        if (a === $b36288e2db101ba3$var$Da) return 14;
    }
    return 2;
}
function $b36288e2db101ba3$var$Tg(a, b) {
    var c = a.alternate;
    null === c ? (c = $b36288e2db101ba3$var$nh(a.tag, b, a.key, a.mode), c.elementType = a.elementType, c.type = a.type, c.stateNode = a.stateNode, c.alternate = a, a.alternate = c) : (c.pendingProps = b, c.type = a.type, c.flags = 0, c.nextEffect = null, c.firstEffect = null, c.lastEffect = null);
    c.childLanes = a.childLanes;
    c.lanes = a.lanes;
    c.child = a.child;
    c.memoizedProps = a.memoizedProps;
    c.memoizedState = a.memoizedState;
    c.updateQueue = a.updateQueue;
    b = a.dependencies;
    c.dependencies = null === b ? null : {
        lanes: b.lanes,
        firstContext: b.firstContext
    };
    c.sibling = a.sibling;
    c.index = a.index;
    c.ref = a.ref;
    return c;
}
function $b36288e2db101ba3$var$Vg(a, b, c, d, e, f) {
    var g = 2;
    d = a;
    if ("function" === typeof a) $b36288e2db101ba3$var$ji(a) && (g = 1);
    else if ("string" === typeof a) g = 5;
    else a: switch(a){
        case $b36288e2db101ba3$var$ua:
            return $b36288e2db101ba3$var$Xg(c.children, e, f, b);
        case $b36288e2db101ba3$var$Ha:
            g = 8;
            e |= 16;
            break;
        case $b36288e2db101ba3$var$wa:
            g = 8;
            e |= 1;
            break;
        case $b36288e2db101ba3$var$xa:
            return a = $b36288e2db101ba3$var$nh(12, c, b, e | 8), a.elementType = $b36288e2db101ba3$var$xa, a.type = $b36288e2db101ba3$var$xa, a.lanes = f, a;
        case $b36288e2db101ba3$var$Ba:
            return a = $b36288e2db101ba3$var$nh(13, c, b, e), a.type = $b36288e2db101ba3$var$Ba, a.elementType = $b36288e2db101ba3$var$Ba, a.lanes = f, a;
        case $b36288e2db101ba3$var$Ca:
            return a = $b36288e2db101ba3$var$nh(19, c, b, e), a.elementType = $b36288e2db101ba3$var$Ca, a.lanes = f, a;
        case $b36288e2db101ba3$var$Ia:
            return $b36288e2db101ba3$var$vi(c, e, f, b);
        case $b36288e2db101ba3$var$Ja:
            return a = $b36288e2db101ba3$var$nh(24, c, b, e), a.elementType = $b36288e2db101ba3$var$Ja, a.lanes = f, a;
        default:
            if ("object" === typeof a && null !== a) switch(a.$$typeof){
                case $b36288e2db101ba3$var$ya:
                    g = 10;
                    break a;
                case $b36288e2db101ba3$var$za:
                    g = 9;
                    break a;
                case $b36288e2db101ba3$var$Aa:
                    g = 11;
                    break a;
                case $b36288e2db101ba3$var$Da:
                    g = 14;
                    break a;
                case $b36288e2db101ba3$var$Ea:
                    g = 16;
                    d = null;
                    break a;
                case $b36288e2db101ba3$var$Fa:
                    g = 22;
                    break a;
            }
            throw Error($b36288e2db101ba3$var$y(130, null == a ? a : typeof a, ""));
    }
    b = $b36288e2db101ba3$var$nh(g, c, b, e);
    b.elementType = a;
    b.type = d;
    b.lanes = f;
    return b;
}
function $b36288e2db101ba3$var$Xg(a, b, c, d) {
    a = $b36288e2db101ba3$var$nh(7, a, d, b);
    a.lanes = c;
    return a;
}
function $b36288e2db101ba3$var$vi(a, b, c, d) {
    a = $b36288e2db101ba3$var$nh(23, a, d, b);
    a.elementType = $b36288e2db101ba3$var$Ia;
    a.lanes = c;
    return a;
}
function $b36288e2db101ba3$var$Ug(a, b, c) {
    a = $b36288e2db101ba3$var$nh(6, a, null, b);
    a.lanes = c;
    return a;
}
function $b36288e2db101ba3$var$Wg(a, b, c) {
    b = $b36288e2db101ba3$var$nh(4, null !== a.children ? a.children : [], a.key, b);
    b.lanes = c;
    b.stateNode = {
        containerInfo: a.containerInfo,
        pendingChildren: null,
        implementation: a.implementation
    };
    return b;
}
function $b36288e2db101ba3$var$jk(a, b, c) {
    this.tag = b;
    this.containerInfo = a;
    this.finishedWork = this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.pendingContext = this.context = null;
    this.hydrate = c;
    this.callbackNode = null;
    this.callbackPriority = 0;
    this.eventTimes = $b36288e2db101ba3$var$Zc(0);
    this.expirationTimes = $b36288e2db101ba3$var$Zc(-1);
    this.entangledLanes = this.finishedLanes = this.mutableReadLanes = this.expiredLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = $b36288e2db101ba3$var$Zc(0);
    this.mutableSourceEagerHydrationData = null;
}
function $b36288e2db101ba3$var$kk(a, b, c) {
    var d = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: $b36288e2db101ba3$var$ta,
        key: null == d ? null : "" + d,
        children: a,
        containerInfo: b,
        implementation: c
    };
}
function $b36288e2db101ba3$var$lk(a, b, c, d) {
    var e = b.current, f = $b36288e2db101ba3$var$Hg(), g = $b36288e2db101ba3$var$Ig(e);
    a: if (c) {
        c = c._reactInternals;
        b: {
            if ($b36288e2db101ba3$var$Zb(c) !== c || 1 !== c.tag) throw Error($b36288e2db101ba3$var$y(170));
            var h = c;
            do {
                switch(h.tag){
                    case 3:
                        h = h.stateNode.context;
                        break b;
                    case 1:
                        if ($b36288e2db101ba3$var$Ff(h.type)) {
                            h = h.stateNode.__reactInternalMemoizedMergedChildContext;
                            break b;
                        }
                }
                h = h.return;
            }while (null !== h);
            throw Error($b36288e2db101ba3$var$y(171));
        }
        if (1 === c.tag) {
            var k = c.type;
            if ($b36288e2db101ba3$var$Ff(k)) {
                c = $b36288e2db101ba3$var$If(c, k, h);
                break a;
            }
        }
        c = h;
    } else c = $b36288e2db101ba3$var$Cf;
    null === b.context ? b.context = c : b.pendingContext = c;
    b = $b36288e2db101ba3$var$zg(f, g);
    b.payload = {
        element: a
    };
    d = void 0 === d ? null : d;
    null !== d && (b.callback = d);
    $b36288e2db101ba3$var$Ag(e, b);
    $b36288e2db101ba3$var$Jg(e, g, f);
    return g;
}
function $b36288e2db101ba3$var$mk(a) {
    a = a.current;
    if (!a.child) return null;
    switch(a.child.tag){
        case 5:
            return a.child.stateNode;
        default:
            return a.child.stateNode;
    }
}
function $b36288e2db101ba3$var$nk(a, b) {
    a = a.memoizedState;
    if (null !== a && null !== a.dehydrated) {
        var c = a.retryLane;
        a.retryLane = 0 !== c && c < b ? c : b;
    }
}
function $b36288e2db101ba3$var$ok(a, b) {
    $b36288e2db101ba3$var$nk(a, b);
    (a = a.alternate) && $b36288e2db101ba3$var$nk(a, b);
}
function $b36288e2db101ba3$var$pk() {
    return null;
}
function $b36288e2db101ba3$var$qk(a, b, c) {
    var d = null != c && null != c.hydrationOptions && c.hydrationOptions.mutableSources || null;
    c = new $b36288e2db101ba3$var$jk(a, b, null != c && !0 === c.hydrate);
    b = $b36288e2db101ba3$var$nh(3, null, null, 2 === b ? 7 : 1 === b ? 3 : 0);
    c.current = b;
    b.stateNode = c;
    $b36288e2db101ba3$var$xg(b);
    a[$b36288e2db101ba3$var$ff] = c.current;
    $b36288e2db101ba3$var$cf(8 === a.nodeType ? a.parentNode : a);
    if (d) for(a = 0; a < d.length; a++){
        b = d[a];
        var e = b._getVersion;
        e = e(b._source);
        null == c.mutableSourceEagerHydrationData ? c.mutableSourceEagerHydrationData = [
            b,
            e
        ] : c.mutableSourceEagerHydrationData.push(b, e);
    }
    this._internalRoot = c;
}
$b36288e2db101ba3$var$qk.prototype.render = function(a) {
    $b36288e2db101ba3$var$lk(a, this._internalRoot, null, null);
};
$b36288e2db101ba3$var$qk.prototype.unmount = function() {
    var a = this._internalRoot, b = a.containerInfo;
    $b36288e2db101ba3$var$lk(null, a, null, function() {
        b[$b36288e2db101ba3$var$ff] = null;
    });
};
function $b36288e2db101ba3$var$rk(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType && (8 !== a.nodeType || " react-mount-point-unstable " !== a.nodeValue));
}
function $b36288e2db101ba3$var$sk(a, b) {
    b || (b = a ? 9 === a.nodeType ? a.documentElement : a.firstChild : null, b = !(!b || 1 !== b.nodeType || !b.hasAttribute("data-reactroot")));
    if (!b) for(var c; c = a.lastChild;)a.removeChild(c);
    return new $b36288e2db101ba3$var$qk(a, 0, b ? {
        hydrate: !0
    } : void 0);
}
function $b36288e2db101ba3$var$tk(a, b, c, d, e) {
    var f = c._reactRootContainer;
    if (f) {
        var g = f._internalRoot;
        if ("function" === typeof e) {
            var h = e;
            e = function() {
                var a = $b36288e2db101ba3$var$mk(g);
                h.call(a);
            };
        }
        $b36288e2db101ba3$var$lk(b, g, a, e);
    } else {
        f = c._reactRootContainer = $b36288e2db101ba3$var$sk(c, d);
        g = f._internalRoot;
        if ("function" === typeof e) {
            var k = e;
            e = function() {
                var a = $b36288e2db101ba3$var$mk(g);
                k.call(a);
            };
        }
        $b36288e2db101ba3$var$Xj(function() {
            $b36288e2db101ba3$var$lk(b, g, a, e);
        });
    }
    return $b36288e2db101ba3$var$mk(g);
}
$b36288e2db101ba3$var$ec = function(a) {
    if (13 === a.tag) {
        var b = $b36288e2db101ba3$var$Hg();
        $b36288e2db101ba3$var$Jg(a, 4, b);
        $b36288e2db101ba3$var$ok(a, 4);
    }
};
$b36288e2db101ba3$var$fc = function(a) {
    if (13 === a.tag) {
        var b = $b36288e2db101ba3$var$Hg();
        $b36288e2db101ba3$var$Jg(a, 67108864, b);
        $b36288e2db101ba3$var$ok(a, 67108864);
    }
};
$b36288e2db101ba3$var$gc = function(a) {
    if (13 === a.tag) {
        var b = $b36288e2db101ba3$var$Hg(), c = $b36288e2db101ba3$var$Ig(a);
        $b36288e2db101ba3$var$Jg(a, c, b);
        $b36288e2db101ba3$var$ok(a, c);
    }
};
$b36288e2db101ba3$var$hc = function(a, b) {
    return b();
};
$b36288e2db101ba3$var$yb = function(a, b, c) {
    switch(b){
        case "input":
            $b36288e2db101ba3$var$ab(a, c);
            b = c.name;
            if ("radio" === c.type && null != b) {
                for(c = a; c.parentNode;)c = c.parentNode;
                c = c.querySelectorAll("input[name=" + JSON.stringify("" + b) + '][type="radio"]');
                for(b = 0; b < c.length; b++){
                    var d = c[b];
                    if (d !== a && d.form === a.form) {
                        var e = $b36288e2db101ba3$var$Db(d);
                        if (!e) throw Error($b36288e2db101ba3$var$y(90));
                        $b36288e2db101ba3$var$Wa(d);
                        $b36288e2db101ba3$var$ab(d, e);
                    }
                }
            }
            break;
        case "textarea":
            $b36288e2db101ba3$var$ib(a, c);
            break;
        case "select":
            b = c.value, null != b && $b36288e2db101ba3$var$fb(a, !!c.multiple, b, !1);
    }
};
$b36288e2db101ba3$var$Gb = $b36288e2db101ba3$var$Wj;
$b36288e2db101ba3$var$Hb = function(a, b, c, d, e) {
    var f = $b36288e2db101ba3$var$X;
    $b36288e2db101ba3$var$X |= 4;
    try {
        return $b36288e2db101ba3$var$gg(98, a.bind(null, b, c, d, e));
    } finally{
        $b36288e2db101ba3$var$X = f, 0 === $b36288e2db101ba3$var$X && ($b36288e2db101ba3$var$wj(), $b36288e2db101ba3$var$ig());
    }
};
$b36288e2db101ba3$var$Ib = function() {
    0 === ($b36288e2db101ba3$var$X & 49) && ($b36288e2db101ba3$var$Vj(), $b36288e2db101ba3$var$Oj());
};
$b36288e2db101ba3$var$Jb = function(a, b) {
    var c = $b36288e2db101ba3$var$X;
    $b36288e2db101ba3$var$X |= 2;
    try {
        return a(b);
    } finally{
        $b36288e2db101ba3$var$X = c, 0 === $b36288e2db101ba3$var$X && ($b36288e2db101ba3$var$wj(), $b36288e2db101ba3$var$ig());
    }
};
function $b36288e2db101ba3$var$uk(a, b) {
    var c = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!$b36288e2db101ba3$var$rk(b)) throw Error($b36288e2db101ba3$var$y(200));
    return $b36288e2db101ba3$var$kk(a, b, null, c);
}
var $b36288e2db101ba3$var$vk = {
    Events: [
        $b36288e2db101ba3$var$Cb,
        $b36288e2db101ba3$var$ue,
        $b36288e2db101ba3$var$Db,
        $b36288e2db101ba3$var$Eb,
        $b36288e2db101ba3$var$Fb,
        $b36288e2db101ba3$var$Oj,
        {
            current: !1
        }
    ]
}, $b36288e2db101ba3$var$wk = {
    findFiberByHostInstance: $b36288e2db101ba3$var$wc,
    bundleType: 0,
    version: "17.0.2",
    rendererPackageName: "react-dom"
};
var $b36288e2db101ba3$var$xk = {
    bundleType: $b36288e2db101ba3$var$wk.bundleType,
    version: $b36288e2db101ba3$var$wk.version,
    rendererPackageName: $b36288e2db101ba3$var$wk.rendererPackageName,
    rendererConfig: $b36288e2db101ba3$var$wk.rendererConfig,
    overrideHookState: null,
    overrideHookStateDeletePath: null,
    overrideHookStateRenamePath: null,
    overrideProps: null,
    overridePropsDeletePath: null,
    overridePropsRenamePath: null,
    setSuspenseHandler: null,
    scheduleUpdate: null,
    currentDispatcherRef: $b36288e2db101ba3$var$ra.ReactCurrentDispatcher,
    findHostInstanceByFiber: function(a) {
        a = $b36288e2db101ba3$var$cc(a);
        return null === a ? null : a.stateNode;
    },
    findFiberByHostInstance: $b36288e2db101ba3$var$wk.findFiberByHostInstance || $b36288e2db101ba3$var$pk,
    findHostInstancesForRefresh: null,
    scheduleRefresh: null,
    scheduleRoot: null,
    setRefreshHandler: null,
    getCurrentFiber: null
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var $b36288e2db101ba3$var$yk = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!$b36288e2db101ba3$var$yk.isDisabled && $b36288e2db101ba3$var$yk.supportsFiber) try {
        $b36288e2db101ba3$var$Lf = $b36288e2db101ba3$var$yk.inject($b36288e2db101ba3$var$xk), $b36288e2db101ba3$var$Mf = $b36288e2db101ba3$var$yk;
    } catch (a) {}
}
$b36288e2db101ba3$export$ae55be85d98224ed = $b36288e2db101ba3$var$vk;
$b36288e2db101ba3$export$d39a5bbd09211389 = $b36288e2db101ba3$var$uk;
$b36288e2db101ba3$export$466bfc07425424d5 = function(a) {
    if (null == a) return null;
    if (1 === a.nodeType) return a;
    var b = a._reactInternals;
    if (void 0 === b) {
        if ("function" === typeof a.render) throw Error($b36288e2db101ba3$var$y(188));
        throw Error($b36288e2db101ba3$var$y(268, Object.keys(a)));
    }
    a = $b36288e2db101ba3$var$cc(b);
    a = null === a ? null : a.stateNode;
    return a;
};
$b36288e2db101ba3$export$cd75ccfd720a3cd4 = function(a, b) {
    var c = $b36288e2db101ba3$var$X;
    if (0 !== (c & 48)) return a(b);
    $b36288e2db101ba3$var$X |= 1;
    try {
        if (a) return $b36288e2db101ba3$var$gg(99, a.bind(null, b));
    } finally{
        $b36288e2db101ba3$var$X = c, $b36288e2db101ba3$var$ig();
    }
};
$b36288e2db101ba3$export$fa8d919ba61d84db = function(a, b, c) {
    if (!$b36288e2db101ba3$var$rk(b)) throw Error($b36288e2db101ba3$var$y(200));
    return $b36288e2db101ba3$var$tk(null, a, b, !0, c);
};
$b36288e2db101ba3$export$b3890eb0ae9dca99 = function(a, b, c) {
    if (!$b36288e2db101ba3$var$rk(b)) throw Error($b36288e2db101ba3$var$y(200));
    return $b36288e2db101ba3$var$tk(null, a, b, !1, c);
};
$b36288e2db101ba3$export$502457920280e6be = function(a) {
    if (!$b36288e2db101ba3$var$rk(a)) throw Error($b36288e2db101ba3$var$y(40));
    return a._reactRootContainer ? ($b36288e2db101ba3$var$Xj(function() {
        $b36288e2db101ba3$var$tk(null, null, a, !1, function() {
            a._reactRootContainer = null;
            a[$b36288e2db101ba3$var$ff] = null;
        });
    }), !0) : !1;
};
$b36288e2db101ba3$export$c78a37762a8d58e1 = $b36288e2db101ba3$var$Wj;
$b36288e2db101ba3$export$2577ef5d2565d52f = function(a, b) {
    return $b36288e2db101ba3$var$uk(a, b, 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null);
};
$b36288e2db101ba3$export$dc54d992c10e8a18 = function(a, b, c, d) {
    if (!$b36288e2db101ba3$var$rk(c)) throw Error($b36288e2db101ba3$var$y(200));
    if (null == a || void 0 === a._reactInternals) throw Error($b36288e2db101ba3$var$y(38));
    return $b36288e2db101ba3$var$tk(a, b, c, !1, d);
};
$b36288e2db101ba3$export$83d89fbfd8236492 = "17.0.2";

});
parcelRequire.register("4LCdk", function(module, exports) {
"use strict";

module.exports = (parcelRequire("8BKFp"));

});
parcelRequire.register("8BKFp", function(module, exports) {

$parcel$export(module.exports, "unstable_now", function () { return $6445fa7f31ec0ca5$export$c4744153514ff05d; }, function (v) { return $6445fa7f31ec0ca5$export$c4744153514ff05d = v; });
$parcel$export(module.exports, "unstable_shouldYield", function () { return $6445fa7f31ec0ca5$export$b5836b71941fa3ed; }, function (v) { return $6445fa7f31ec0ca5$export$b5836b71941fa3ed = v; });
$parcel$export(module.exports, "unstable_forceFrameRate", function () { return $6445fa7f31ec0ca5$export$d66a1c1c77bd778b; }, function (v) { return $6445fa7f31ec0ca5$export$d66a1c1c77bd778b = v; });
$parcel$export(module.exports, "unstable_IdlePriority", function () { return $6445fa7f31ec0ca5$export$3e506c1ccc9cc1a7; }, function (v) { return $6445fa7f31ec0ca5$export$3e506c1ccc9cc1a7 = v; });
$parcel$export(module.exports, "unstable_ImmediatePriority", function () { return $6445fa7f31ec0ca5$export$e26fe2ed2fa76875; }, function (v) { return $6445fa7f31ec0ca5$export$e26fe2ed2fa76875 = v; });
$parcel$export(module.exports, "unstable_LowPriority", function () { return $6445fa7f31ec0ca5$export$502329bbf4b505b1; }, function (v) { return $6445fa7f31ec0ca5$export$502329bbf4b505b1 = v; });
$parcel$export(module.exports, "unstable_NormalPriority", function () { return $6445fa7f31ec0ca5$export$6e3807111c4874c4; }, function (v) { return $6445fa7f31ec0ca5$export$6e3807111c4874c4 = v; });
$parcel$export(module.exports, "unstable_Profiling", function () { return $6445fa7f31ec0ca5$export$c27134553091fb3a; }, function (v) { return $6445fa7f31ec0ca5$export$c27134553091fb3a = v; });
$parcel$export(module.exports, "unstable_UserBlockingPriority", function () { return $6445fa7f31ec0ca5$export$33ee1acdc04fd2a2; }, function (v) { return $6445fa7f31ec0ca5$export$33ee1acdc04fd2a2 = v; });
$parcel$export(module.exports, "unstable_cancelCallback", function () { return $6445fa7f31ec0ca5$export$b00a404bbd5edef2; }, function (v) { return $6445fa7f31ec0ca5$export$b00a404bbd5edef2 = v; });
$parcel$export(module.exports, "unstable_continueExecution", function () { return $6445fa7f31ec0ca5$export$8352ce38b91d0c62; }, function (v) { return $6445fa7f31ec0ca5$export$8352ce38b91d0c62 = v; });
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", function () { return $6445fa7f31ec0ca5$export$d3dfb8e4810cb555; }, function (v) { return $6445fa7f31ec0ca5$export$d3dfb8e4810cb555 = v; });
$parcel$export(module.exports, "unstable_getFirstCallbackNode", function () { return $6445fa7f31ec0ca5$export$839f9183b0465a69; }, function (v) { return $6445fa7f31ec0ca5$export$839f9183b0465a69 = v; });
$parcel$export(module.exports, "unstable_next", function () { return $6445fa7f31ec0ca5$export$72fdf0e06517287b; }, function (v) { return $6445fa7f31ec0ca5$export$72fdf0e06517287b = v; });
$parcel$export(module.exports, "unstable_pauseExecution", function () { return $6445fa7f31ec0ca5$export$4b844e58a3e414b4; }, function (v) { return $6445fa7f31ec0ca5$export$4b844e58a3e414b4 = v; });
$parcel$export(module.exports, "unstable_requestPaint", function () { return $6445fa7f31ec0ca5$export$816d2913ae6b83b1; }, function (v) { return $6445fa7f31ec0ca5$export$816d2913ae6b83b1 = v; });
$parcel$export(module.exports, "unstable_runWithPriority", function () { return $6445fa7f31ec0ca5$export$61bcfe829111a1d0; }, function (v) { return $6445fa7f31ec0ca5$export$61bcfe829111a1d0 = v; });
$parcel$export(module.exports, "unstable_scheduleCallback", function () { return $6445fa7f31ec0ca5$export$7ee8c9beb337bc3f; }, function (v) { return $6445fa7f31ec0ca5$export$7ee8c9beb337bc3f = v; });
$parcel$export(module.exports, "unstable_wrapCallback", function () { return $6445fa7f31ec0ca5$export$cf845f2c119da08a; }, function (v) { return $6445fa7f31ec0ca5$export$cf845f2c119da08a = v; });
/** @license React v0.20.2
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $6445fa7f31ec0ca5$export$c4744153514ff05d;
var $6445fa7f31ec0ca5$export$b5836b71941fa3ed;
var $6445fa7f31ec0ca5$export$d66a1c1c77bd778b;
var $6445fa7f31ec0ca5$export$3e506c1ccc9cc1a7;
var $6445fa7f31ec0ca5$export$e26fe2ed2fa76875;
var $6445fa7f31ec0ca5$export$502329bbf4b505b1;
var $6445fa7f31ec0ca5$export$6e3807111c4874c4;
var $6445fa7f31ec0ca5$export$c27134553091fb3a;
var $6445fa7f31ec0ca5$export$33ee1acdc04fd2a2;
var $6445fa7f31ec0ca5$export$b00a404bbd5edef2;
var $6445fa7f31ec0ca5$export$8352ce38b91d0c62;
var $6445fa7f31ec0ca5$export$d3dfb8e4810cb555;
var $6445fa7f31ec0ca5$export$839f9183b0465a69;
var $6445fa7f31ec0ca5$export$72fdf0e06517287b;
var $6445fa7f31ec0ca5$export$4b844e58a3e414b4;
var $6445fa7f31ec0ca5$export$816d2913ae6b83b1;
var $6445fa7f31ec0ca5$export$61bcfe829111a1d0;
var $6445fa7f31ec0ca5$export$7ee8c9beb337bc3f;
var $6445fa7f31ec0ca5$export$cf845f2c119da08a;
"use strict";
var $6445fa7f31ec0ca5$var$f, $6445fa7f31ec0ca5$var$g, $6445fa7f31ec0ca5$var$h, $6445fa7f31ec0ca5$var$k;
if ("object" === typeof performance && "function" === typeof performance.now) {
    var $6445fa7f31ec0ca5$var$l = performance;
    $6445fa7f31ec0ca5$export$c4744153514ff05d = function() {
        return $6445fa7f31ec0ca5$var$l.now();
    };
} else {
    var $6445fa7f31ec0ca5$var$p = Date, $6445fa7f31ec0ca5$var$q = $6445fa7f31ec0ca5$var$p.now();
    $6445fa7f31ec0ca5$export$c4744153514ff05d = function() {
        return $6445fa7f31ec0ca5$var$p.now() - $6445fa7f31ec0ca5$var$q;
    };
}
if ("undefined" === typeof window || "function" !== typeof MessageChannel) {
    var $6445fa7f31ec0ca5$var$t = null, $6445fa7f31ec0ca5$var$u = null, $6445fa7f31ec0ca5$var$w = function() {
        if (null !== $6445fa7f31ec0ca5$var$t) try {
            var a = $6445fa7f31ec0ca5$export$c4744153514ff05d();
            $6445fa7f31ec0ca5$var$t(!0, a);
            $6445fa7f31ec0ca5$var$t = null;
        } catch (b) {
            throw setTimeout($6445fa7f31ec0ca5$var$w, 0), b;
        }
    };
    $6445fa7f31ec0ca5$var$f = function(a) {
        null !== $6445fa7f31ec0ca5$var$t ? setTimeout($6445fa7f31ec0ca5$var$f, 0, a) : ($6445fa7f31ec0ca5$var$t = a, setTimeout($6445fa7f31ec0ca5$var$w, 0));
    };
    $6445fa7f31ec0ca5$var$g = function(a, b) {
        $6445fa7f31ec0ca5$var$u = setTimeout(a, b);
    };
    $6445fa7f31ec0ca5$var$h = function() {
        clearTimeout($6445fa7f31ec0ca5$var$u);
    };
    $6445fa7f31ec0ca5$export$b5836b71941fa3ed = function() {
        return !1;
    };
    $6445fa7f31ec0ca5$var$k = $6445fa7f31ec0ca5$export$d66a1c1c77bd778b = function() {};
} else {
    var $6445fa7f31ec0ca5$var$x = window.setTimeout, $6445fa7f31ec0ca5$var$y = window.clearTimeout;
    if ("undefined" !== typeof console) {
        var $6445fa7f31ec0ca5$var$z = window.cancelAnimationFrame;
        "function" !== typeof window.requestAnimationFrame && console.error("This browser doesn't support requestAnimationFrame. Make sure that you load a polyfill in older browsers. https://reactjs.org/link/react-polyfills");
        "function" !== typeof $6445fa7f31ec0ca5$var$z && console.error("This browser doesn't support cancelAnimationFrame. Make sure that you load a polyfill in older browsers. https://reactjs.org/link/react-polyfills");
    }
    var $6445fa7f31ec0ca5$var$A = !1, $6445fa7f31ec0ca5$var$B = null, $6445fa7f31ec0ca5$var$C = -1, $6445fa7f31ec0ca5$var$D = 5, $6445fa7f31ec0ca5$var$E = 0;
    $6445fa7f31ec0ca5$export$b5836b71941fa3ed = function() {
        return $6445fa7f31ec0ca5$export$c4744153514ff05d() >= $6445fa7f31ec0ca5$var$E;
    };
    $6445fa7f31ec0ca5$var$k = function() {};
    $6445fa7f31ec0ca5$export$d66a1c1c77bd778b = function(a) {
        0 > a || 125 < a ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $6445fa7f31ec0ca5$var$D = 0 < a ? Math.floor(1E3 / a) : 5;
    };
    var $6445fa7f31ec0ca5$var$F = new MessageChannel, $6445fa7f31ec0ca5$var$G = $6445fa7f31ec0ca5$var$F.port2;
    $6445fa7f31ec0ca5$var$F.port1.onmessage = function() {
        if (null !== $6445fa7f31ec0ca5$var$B) {
            var a = $6445fa7f31ec0ca5$export$c4744153514ff05d();
            $6445fa7f31ec0ca5$var$E = a + $6445fa7f31ec0ca5$var$D;
            try {
                $6445fa7f31ec0ca5$var$B(!0, a) ? $6445fa7f31ec0ca5$var$G.postMessage(null) : ($6445fa7f31ec0ca5$var$A = !1, $6445fa7f31ec0ca5$var$B = null);
            } catch (b) {
                throw $6445fa7f31ec0ca5$var$G.postMessage(null), b;
            }
        } else $6445fa7f31ec0ca5$var$A = !1;
    };
    $6445fa7f31ec0ca5$var$f = function(a) {
        $6445fa7f31ec0ca5$var$B = a;
        $6445fa7f31ec0ca5$var$A || ($6445fa7f31ec0ca5$var$A = !0, $6445fa7f31ec0ca5$var$G.postMessage(null));
    };
    $6445fa7f31ec0ca5$var$g = function(a, b) {
        $6445fa7f31ec0ca5$var$C = $6445fa7f31ec0ca5$var$x(function() {
            a($6445fa7f31ec0ca5$export$c4744153514ff05d());
        }, b);
    };
    $6445fa7f31ec0ca5$var$h = function() {
        $6445fa7f31ec0ca5$var$y($6445fa7f31ec0ca5$var$C);
        $6445fa7f31ec0ca5$var$C = -1;
    };
}
function $6445fa7f31ec0ca5$var$H(a, b) {
    var c = a.length;
    a.push(b);
    a: for(;;){
        var d = c - 1 >>> 1, e = a[d];
        if (void 0 !== e && 0 < $6445fa7f31ec0ca5$var$I(e, b)) a[d] = b, a[c] = e, c = d;
        else break a;
    }
}
function $6445fa7f31ec0ca5$var$J(a) {
    a = a[0];
    return void 0 === a ? null : a;
}
function $6445fa7f31ec0ca5$var$K(a) {
    var b = a[0];
    if (void 0 !== b) {
        var c = a.pop();
        if (c !== b) {
            a[0] = c;
            a: for(var d = 0, e = a.length; d < e;){
                var m = 2 * (d + 1) - 1, n = a[m], v = m + 1, r = a[v];
                if (void 0 !== n && 0 > $6445fa7f31ec0ca5$var$I(n, c)) void 0 !== r && 0 > $6445fa7f31ec0ca5$var$I(r, n) ? (a[d] = r, a[v] = c, d = v) : (a[d] = n, a[m] = c, d = m);
                else if (void 0 !== r && 0 > $6445fa7f31ec0ca5$var$I(r, c)) a[d] = r, a[v] = c, d = v;
                else break a;
            }
        }
        return b;
    }
    return null;
}
function $6445fa7f31ec0ca5$var$I(a, b) {
    var c = a.sortIndex - b.sortIndex;
    return 0 !== c ? c : a.id - b.id;
}
var $6445fa7f31ec0ca5$var$L = [], $6445fa7f31ec0ca5$var$M = [], $6445fa7f31ec0ca5$var$N = 1, $6445fa7f31ec0ca5$var$O = null, $6445fa7f31ec0ca5$var$P = 3, $6445fa7f31ec0ca5$var$Q = !1, $6445fa7f31ec0ca5$var$R = !1, $6445fa7f31ec0ca5$var$S = !1;
function $6445fa7f31ec0ca5$var$T(a) {
    for(var b = $6445fa7f31ec0ca5$var$J($6445fa7f31ec0ca5$var$M); null !== b;){
        if (null === b.callback) $6445fa7f31ec0ca5$var$K($6445fa7f31ec0ca5$var$M);
        else if (b.startTime <= a) $6445fa7f31ec0ca5$var$K($6445fa7f31ec0ca5$var$M), b.sortIndex = b.expirationTime, $6445fa7f31ec0ca5$var$H($6445fa7f31ec0ca5$var$L, b);
        else break;
        b = $6445fa7f31ec0ca5$var$J($6445fa7f31ec0ca5$var$M);
    }
}
function $6445fa7f31ec0ca5$var$U(a) {
    $6445fa7f31ec0ca5$var$S = !1;
    $6445fa7f31ec0ca5$var$T(a);
    if (!$6445fa7f31ec0ca5$var$R) {
        if (null !== $6445fa7f31ec0ca5$var$J($6445fa7f31ec0ca5$var$L)) $6445fa7f31ec0ca5$var$R = !0, $6445fa7f31ec0ca5$var$f($6445fa7f31ec0ca5$var$V);
        else {
            var b = $6445fa7f31ec0ca5$var$J($6445fa7f31ec0ca5$var$M);
            null !== b && $6445fa7f31ec0ca5$var$g($6445fa7f31ec0ca5$var$U, b.startTime - a);
        }
    }
}
function $6445fa7f31ec0ca5$var$V(a, b) {
    $6445fa7f31ec0ca5$var$R = !1;
    $6445fa7f31ec0ca5$var$S && ($6445fa7f31ec0ca5$var$S = !1, $6445fa7f31ec0ca5$var$h());
    $6445fa7f31ec0ca5$var$Q = !0;
    var c = $6445fa7f31ec0ca5$var$P;
    try {
        $6445fa7f31ec0ca5$var$T(b);
        for($6445fa7f31ec0ca5$var$O = $6445fa7f31ec0ca5$var$J($6445fa7f31ec0ca5$var$L); null !== $6445fa7f31ec0ca5$var$O && (!($6445fa7f31ec0ca5$var$O.expirationTime > b) || a && !$6445fa7f31ec0ca5$export$b5836b71941fa3ed());){
            var d = $6445fa7f31ec0ca5$var$O.callback;
            if ("function" === typeof d) {
                $6445fa7f31ec0ca5$var$O.callback = null;
                $6445fa7f31ec0ca5$var$P = $6445fa7f31ec0ca5$var$O.priorityLevel;
                var e = d($6445fa7f31ec0ca5$var$O.expirationTime <= b);
                b = $6445fa7f31ec0ca5$export$c4744153514ff05d();
                "function" === typeof e ? $6445fa7f31ec0ca5$var$O.callback = e : $6445fa7f31ec0ca5$var$O === $6445fa7f31ec0ca5$var$J($6445fa7f31ec0ca5$var$L) && $6445fa7f31ec0ca5$var$K($6445fa7f31ec0ca5$var$L);
                $6445fa7f31ec0ca5$var$T(b);
            } else $6445fa7f31ec0ca5$var$K($6445fa7f31ec0ca5$var$L);
            $6445fa7f31ec0ca5$var$O = $6445fa7f31ec0ca5$var$J($6445fa7f31ec0ca5$var$L);
        }
        if (null !== $6445fa7f31ec0ca5$var$O) var m = !0;
        else {
            var n = $6445fa7f31ec0ca5$var$J($6445fa7f31ec0ca5$var$M);
            null !== n && $6445fa7f31ec0ca5$var$g($6445fa7f31ec0ca5$var$U, n.startTime - b);
            m = !1;
        }
        return m;
    } finally{
        $6445fa7f31ec0ca5$var$O = null, $6445fa7f31ec0ca5$var$P = c, $6445fa7f31ec0ca5$var$Q = !1;
    }
}
var $6445fa7f31ec0ca5$var$W = $6445fa7f31ec0ca5$var$k;
$6445fa7f31ec0ca5$export$3e506c1ccc9cc1a7 = 5;
$6445fa7f31ec0ca5$export$e26fe2ed2fa76875 = 1;
$6445fa7f31ec0ca5$export$502329bbf4b505b1 = 4;
$6445fa7f31ec0ca5$export$6e3807111c4874c4 = 3;
$6445fa7f31ec0ca5$export$c27134553091fb3a = null;
$6445fa7f31ec0ca5$export$33ee1acdc04fd2a2 = 2;
$6445fa7f31ec0ca5$export$b00a404bbd5edef2 = function(a) {
    a.callback = null;
};
$6445fa7f31ec0ca5$export$8352ce38b91d0c62 = function() {
    $6445fa7f31ec0ca5$var$R || $6445fa7f31ec0ca5$var$Q || ($6445fa7f31ec0ca5$var$R = !0, $6445fa7f31ec0ca5$var$f($6445fa7f31ec0ca5$var$V));
};
$6445fa7f31ec0ca5$export$d3dfb8e4810cb555 = function() {
    return $6445fa7f31ec0ca5$var$P;
};
$6445fa7f31ec0ca5$export$839f9183b0465a69 = function() {
    return $6445fa7f31ec0ca5$var$J($6445fa7f31ec0ca5$var$L);
};
$6445fa7f31ec0ca5$export$72fdf0e06517287b = function(a) {
    switch($6445fa7f31ec0ca5$var$P){
        case 1:
        case 2:
        case 3:
            var b = 3;
            break;
        default:
            b = $6445fa7f31ec0ca5$var$P;
    }
    var c = $6445fa7f31ec0ca5$var$P;
    $6445fa7f31ec0ca5$var$P = b;
    try {
        return a();
    } finally{
        $6445fa7f31ec0ca5$var$P = c;
    }
};
$6445fa7f31ec0ca5$export$4b844e58a3e414b4 = function() {};
$6445fa7f31ec0ca5$export$816d2913ae6b83b1 = $6445fa7f31ec0ca5$var$W;
$6445fa7f31ec0ca5$export$61bcfe829111a1d0 = function(a, b) {
    switch(a){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            a = 3;
    }
    var c = $6445fa7f31ec0ca5$var$P;
    $6445fa7f31ec0ca5$var$P = a;
    try {
        return b();
    } finally{
        $6445fa7f31ec0ca5$var$P = c;
    }
};
$6445fa7f31ec0ca5$export$7ee8c9beb337bc3f = function(a, b, c) {
    var d = $6445fa7f31ec0ca5$export$c4744153514ff05d();
    "object" === typeof c && null !== c ? (c = c.delay, c = "number" === typeof c && 0 < c ? d + c : d) : c = d;
    switch(a){
        case 1:
            var e = -1;
            break;
        case 2:
            e = 250;
            break;
        case 5:
            e = 1073741823;
            break;
        case 4:
            e = 1E4;
            break;
        default:
            e = 5E3;
    }
    e = c + e;
    a = {
        id: $6445fa7f31ec0ca5$var$N++,
        callback: b,
        priorityLevel: a,
        startTime: c,
        expirationTime: e,
        sortIndex: -1
    };
    c > d ? (a.sortIndex = c, $6445fa7f31ec0ca5$var$H($6445fa7f31ec0ca5$var$M, a), null === $6445fa7f31ec0ca5$var$J($6445fa7f31ec0ca5$var$L) && a === $6445fa7f31ec0ca5$var$J($6445fa7f31ec0ca5$var$M) && ($6445fa7f31ec0ca5$var$S ? $6445fa7f31ec0ca5$var$h() : $6445fa7f31ec0ca5$var$S = !0, $6445fa7f31ec0ca5$var$g($6445fa7f31ec0ca5$var$U, c - d))) : (a.sortIndex = e, $6445fa7f31ec0ca5$var$H($6445fa7f31ec0ca5$var$L, a), $6445fa7f31ec0ca5$var$R || $6445fa7f31ec0ca5$var$Q || ($6445fa7f31ec0ca5$var$R = !0, $6445fa7f31ec0ca5$var$f($6445fa7f31ec0ca5$var$V)));
    return a;
};
$6445fa7f31ec0ca5$export$cf845f2c119da08a = function(a) {
    var b = $6445fa7f31ec0ca5$var$P;
    return function() {
        var c = $6445fa7f31ec0ca5$var$P;
        $6445fa7f31ec0ca5$var$P = b;
        try {
            return a.apply(this, arguments);
        } finally{
            $6445fa7f31ec0ca5$var$P = c;
        }
    };
};

});



parcelRequire.register("hqZtu", function(module, exports) {

$parcel$export(module.exports, "byteLength", function () { return $034686670a8a195b$export$a48f0734ac7c2329; }, function (v) { return $034686670a8a195b$export$a48f0734ac7c2329 = v; });
$parcel$export(module.exports, "toByteArray", function () { return $034686670a8a195b$export$d622b2ad8d90c771; }, function (v) { return $034686670a8a195b$export$d622b2ad8d90c771 = v; });
$parcel$export(module.exports, "fromByteArray", function () { return $034686670a8a195b$export$6100ba28696e12de; }, function (v) { return $034686670a8a195b$export$6100ba28696e12de = v; });
var $034686670a8a195b$export$a48f0734ac7c2329;
var $034686670a8a195b$export$d622b2ad8d90c771;
var $034686670a8a195b$export$6100ba28696e12de;
"use strict";
$034686670a8a195b$export$a48f0734ac7c2329 = $034686670a8a195b$var$byteLength;
$034686670a8a195b$export$d622b2ad8d90c771 = $034686670a8a195b$var$toByteArray;
$034686670a8a195b$export$6100ba28696e12de = $034686670a8a195b$var$fromByteArray;
var $034686670a8a195b$var$lookup = [];
var $034686670a8a195b$var$revLookup = [];
var $034686670a8a195b$var$Arr = typeof Uint8Array !== "undefined" ? Uint8Array : Array;
var $034686670a8a195b$var$code = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
for(var $034686670a8a195b$var$i = 0, $034686670a8a195b$var$len = $034686670a8a195b$var$code.length; $034686670a8a195b$var$i < $034686670a8a195b$var$len; ++$034686670a8a195b$var$i){
    $034686670a8a195b$var$lookup[$034686670a8a195b$var$i] = $034686670a8a195b$var$code[$034686670a8a195b$var$i];
    $034686670a8a195b$var$revLookup[$034686670a8a195b$var$code.charCodeAt($034686670a8a195b$var$i)] = $034686670a8a195b$var$i;
}
// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
$034686670a8a195b$var$revLookup["-".charCodeAt(0)] = 62;
$034686670a8a195b$var$revLookup["_".charCodeAt(0)] = 63;
function $034686670a8a195b$var$getLens(b64) {
    var len = b64.length;
    if (len % 4 > 0) throw new Error("Invalid string. Length must be a multiple of 4");
    // Trim off extra bytes after placeholder bytes are found
    // See: https://github.com/beatgammit/base64-js/issues/42
    var validLen = b64.indexOf("=");
    if (validLen === -1) validLen = len;
    var placeHoldersLen = validLen === len ? 0 : 4 - validLen % 4;
    return [
        validLen,
        placeHoldersLen
    ];
}
// base64 is 4/3 + up to two characters of the original data
function $034686670a8a195b$var$byteLength(b64) {
    var lens = $034686670a8a195b$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $034686670a8a195b$var$_byteLength(b64, validLen, placeHoldersLen) {
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $034686670a8a195b$var$toByteArray(b64) {
    var tmp;
    var lens = $034686670a8a195b$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    var arr = new $034686670a8a195b$var$Arr($034686670a8a195b$var$_byteLength(b64, validLen, placeHoldersLen));
    var curByte = 0;
    // if there are placeholders, only get up to the last complete 4 chars
    var len = placeHoldersLen > 0 ? validLen - 4 : validLen;
    var i;
    for(i = 0; i < len; i += 4){
        tmp = $034686670a8a195b$var$revLookup[b64.charCodeAt(i)] << 18 | $034686670a8a195b$var$revLookup[b64.charCodeAt(i + 1)] << 12 | $034686670a8a195b$var$revLookup[b64.charCodeAt(i + 2)] << 6 | $034686670a8a195b$var$revLookup[b64.charCodeAt(i + 3)];
        arr[curByte++] = tmp >> 16 & 0xFF;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 2) {
        tmp = $034686670a8a195b$var$revLookup[b64.charCodeAt(i)] << 2 | $034686670a8a195b$var$revLookup[b64.charCodeAt(i + 1)] >> 4;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 1) {
        tmp = $034686670a8a195b$var$revLookup[b64.charCodeAt(i)] << 10 | $034686670a8a195b$var$revLookup[b64.charCodeAt(i + 1)] << 4 | $034686670a8a195b$var$revLookup[b64.charCodeAt(i + 2)] >> 2;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    return arr;
}
function $034686670a8a195b$var$tripletToBase64(num) {
    return $034686670a8a195b$var$lookup[num >> 18 & 0x3F] + $034686670a8a195b$var$lookup[num >> 12 & 0x3F] + $034686670a8a195b$var$lookup[num >> 6 & 0x3F] + $034686670a8a195b$var$lookup[num & 0x3F];
}
function $034686670a8a195b$var$encodeChunk(uint8, start, end) {
    var tmp;
    var output = [];
    for(var i = start; i < end; i += 3){
        tmp = (uint8[i] << 16 & 0xFF0000) + (uint8[i + 1] << 8 & 0xFF00) + (uint8[i + 2] & 0xFF);
        output.push($034686670a8a195b$var$tripletToBase64(tmp));
    }
    return output.join("");
}
function $034686670a8a195b$var$fromByteArray(uint8) {
    var tmp;
    var len = uint8.length;
    var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
    ;
    var parts = [];
    var maxChunkLength = 16383 // must be multiple of 3
    ;
    // go through the array every three bytes, we'll deal with trailing stuff later
    for(var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength)parts.push($034686670a8a195b$var$encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
    // pad the end with zeros, but make sure to not forget the extra bytes
    if (extraBytes === 1) {
        tmp = uint8[len - 1];
        parts.push($034686670a8a195b$var$lookup[tmp >> 2] + $034686670a8a195b$var$lookup[tmp << 4 & 0x3F] + "==");
    } else if (extraBytes === 2) {
        tmp = (uint8[len - 2] << 8) + uint8[len - 1];
        parts.push($034686670a8a195b$var$lookup[tmp >> 10] + $034686670a8a195b$var$lookup[tmp >> 4 & 0x3F] + $034686670a8a195b$var$lookup[tmp << 2 & 0x3F] + "=");
    }
    return parts.join("");
}

});

parcelRequire.register("iA132", function(module, exports) {

(function(module1, exports) {
    "use strict";
    // Utils
    function assert(val, msg) {
        if (!val) throw new Error(msg || "Assertion failed");
    }
    // Could use `inherits` module, but don't want to move from single file
    // architecture yet.
    function inherits(ctor, superCtor) {
        ctor.super_ = superCtor;
        var TempCtor = function() {};
        TempCtor.prototype = superCtor.prototype;
        ctor.prototype = new TempCtor();
        ctor.prototype.constructor = ctor;
    }
    // BN
    function BN(number, base, endian) {
        if (BN.isBN(number)) return number;
        this.negative = 0;
        this.words = null;
        this.length = 0;
        // Reduction context
        this.red = null;
        if (number !== null) {
            if (base === "le" || base === "be") {
                endian = base;
                base = 10;
            }
            this._init(number || 0, base || 10, endian || "be");
        }
    }
    if (typeof module1 === "object") module1.exports = BN;
    else exports.BN = BN;
    BN.BN = BN;
    BN.wordSize = 26;
    var Buffer;
    try {
        if (typeof window !== "undefined" && typeof window.Buffer !== "undefined") Buffer = window.Buffer;
        else Buffer = (parcelRequire("5Io6y")).Buffer;
    } catch (e) {}
    BN.isBN = function isBN(num) {
        if (num instanceof BN) return true;
        return num !== null && typeof num === "object" && num.constructor.wordSize === BN.wordSize && Array.isArray(num.words);
    };
    BN.max = function max(left, right) {
        if (left.cmp(right) > 0) return left;
        return right;
    };
    BN.min = function min(left, right) {
        if (left.cmp(right) < 0) return left;
        return right;
    };
    BN.prototype._init = function init(number, base, endian) {
        if (typeof number === "number") return this._initNumber(number, base, endian);
        if (typeof number === "object") return this._initArray(number, base, endian);
        if (base === "hex") base = 16;
        assert(base === (base | 0) && base >= 2 && base <= 36);
        number = number.toString().replace(/\s+/g, "");
        var start = 0;
        if (number[0] === "-") {
            start++;
            this.negative = 1;
        }
        if (start < number.length) {
            if (base === 16) this._parseHex(number, start, endian);
            else {
                this._parseBase(number, base, start);
                if (endian === "le") this._initArray(this.toArray(), base, endian);
            }
        }
    };
    BN.prototype._initNumber = function _initNumber(number, base, endian) {
        if (number < 0) {
            this.negative = 1;
            number = -number;
        }
        if (number < 0x4000000) {
            this.words = [
                number & 0x3ffffff
            ];
            this.length = 1;
        } else if (number < 0x10000000000000) {
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff
            ];
            this.length = 2;
        } else {
            assert(number < 0x20000000000000); // 2 ^ 53 (unsafe)
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff,
                1
            ];
            this.length = 3;
        }
        if (endian !== "le") return;
        // Reverse the bytes
        this._initArray(this.toArray(), base, endian);
    };
    BN.prototype._initArray = function _initArray(number, base, endian) {
        // Perhaps a Uint8Array
        assert(typeof number.length === "number");
        if (number.length <= 0) {
            this.words = [
                0
            ];
            this.length = 1;
            return this;
        }
        this.length = Math.ceil(number.length / 3);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        var j, w;
        var off = 0;
        if (endian === "be") for(i = number.length - 1, j = 0; i >= 0; i -= 3){
            w = number[i] | number[i - 1] << 8 | number[i - 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        else if (endian === "le") for(i = 0, j = 0; i < number.length; i += 3){
            w = number[i] | number[i + 1] << 8 | number[i + 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        return this._strip();
    };
    function parseHex4Bits(string, index) {
        var c = string.charCodeAt(index);
        // '0' - '9'
        if (c >= 48 && c <= 57) return c - 48;
        else if (c >= 65 && c <= 70) return c - 55;
        else if (c >= 97 && c <= 102) return c - 87;
        else assert(false, "Invalid character in " + string);
    }
    function parseHexByte(string, lowerBound, index) {
        var r = parseHex4Bits(string, index);
        if (index - 1 >= lowerBound) r |= parseHex4Bits(string, index - 1) << 4;
        return r;
    }
    BN.prototype._parseHex = function _parseHex(number, start, endian) {
        // Create possibly bigger array to ensure that it fits the number
        this.length = Math.ceil((number.length - start) / 6);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        // 24-bits chunks
        var off = 0;
        var j = 0;
        var w;
        if (endian === "be") for(i = number.length - 1; i >= start; i -= 2){
            w = parseHexByte(number, start, i) << off;
            this.words[j] |= w & 0x3ffffff;
            if (off >= 18) {
                off -= 18;
                j += 1;
                this.words[j] |= w >>> 26;
            } else off += 8;
        }
        else {
            var parseLength = number.length - start;
            for(i = parseLength % 2 === 0 ? start + 1 : start; i < number.length; i += 2){
                w = parseHexByte(number, start, i) << off;
                this.words[j] |= w & 0x3ffffff;
                if (off >= 18) {
                    off -= 18;
                    j += 1;
                    this.words[j] |= w >>> 26;
                } else off += 8;
            }
        }
        this._strip();
    };
    function parseBase(str, start, end, mul) {
        var r = 0;
        var b = 0;
        var len = Math.min(str.length, end);
        for(var i = start; i < len; i++){
            var c = str.charCodeAt(i) - 48;
            r *= mul;
            // 'a'
            if (c >= 49) b = c - 49 + 0xa;
            else if (c >= 17) b = c - 17 + 0xa;
            else b = c;
            assert(c >= 0 && b < mul, "Invalid character");
            r += b;
        }
        return r;
    }
    BN.prototype._parseBase = function _parseBase(number, base, start) {
        // Initialize as zero
        this.words = [
            0
        ];
        this.length = 1;
        // Find length of limb in base
        for(var limbLen = 0, limbPow = 1; limbPow <= 0x3ffffff; limbPow *= base)limbLen++;
        limbLen--;
        limbPow = limbPow / base | 0;
        var total = number.length - start;
        var mod = total % limbLen;
        var end = Math.min(total, total - mod) + start;
        var word = 0;
        for(var i = start; i < end; i += limbLen){
            word = parseBase(number, i, i + limbLen, base);
            this.imuln(limbPow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        if (mod !== 0) {
            var pow = 1;
            word = parseBase(number, i, number.length, base);
            for(i = 0; i < mod; i++)pow *= base;
            this.imuln(pow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        this._strip();
    };
    BN.prototype.copy = function copy(dest) {
        dest.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)dest.words[i] = this.words[i];
        dest.length = this.length;
        dest.negative = this.negative;
        dest.red = this.red;
    };
    function move(dest, src) {
        dest.words = src.words;
        dest.length = src.length;
        dest.negative = src.negative;
        dest.red = src.red;
    }
    BN.prototype._move = function _move(dest) {
        move(dest, this);
    };
    BN.prototype.clone = function clone() {
        var r = new BN(null);
        this.copy(r);
        return r;
    };
    BN.prototype._expand = function _expand(size) {
        while(this.length < size)this.words[this.length++] = 0;
        return this;
    };
    // Remove leading `0` from `this`
    BN.prototype._strip = function strip() {
        while(this.length > 1 && this.words[this.length - 1] === 0)this.length--;
        return this._normSign();
    };
    BN.prototype._normSign = function _normSign() {
        // -0 = 0
        if (this.length === 1 && this.words[0] === 0) this.negative = 0;
        return this;
    };
    // Check Symbol.for because not everywhere where Symbol defined
    // See https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Symbol#Browser_compatibility
    if (typeof Symbol !== "undefined" && typeof Symbol.for === "function") try {
        BN.prototype[Symbol.for("nodejs.util.inspect.custom")] = inspect;
    } catch (e) {
        BN.prototype.inspect = inspect;
    }
    else BN.prototype.inspect = inspect;
    function inspect() {
        return (this.red ? "<BN-R: " : "<BN: ") + this.toString(16) + ">";
    }
    /*

  var zeros = [];
  var groupSizes = [];
  var groupBases = [];

  var s = '';
  var i = -1;
  while (++i < BN.wordSize) {
    zeros[i] = s;
    s += '0';
  }
  groupSizes[0] = 0;
  groupSizes[1] = 0;
  groupBases[0] = 0;
  groupBases[1] = 0;
  var base = 2 - 1;
  while (++base < 36 + 1) {
    var groupSize = 0;
    var groupBase = 1;
    while (groupBase < (1 << BN.wordSize) / base) {
      groupBase *= base;
      groupSize += 1;
    }
    groupSizes[base] = groupSize;
    groupBases[base] = groupBase;
  }

  */ var zeros = [
        "",
        "0",
        "00",
        "000",
        "0000",
        "00000",
        "000000",
        "0000000",
        "00000000",
        "000000000",
        "0000000000",
        "00000000000",
        "000000000000",
        "0000000000000",
        "00000000000000",
        "000000000000000",
        "0000000000000000",
        "00000000000000000",
        "000000000000000000",
        "0000000000000000000",
        "00000000000000000000",
        "000000000000000000000",
        "0000000000000000000000",
        "00000000000000000000000",
        "000000000000000000000000",
        "0000000000000000000000000"
    ];
    var groupSizes = [
        0,
        0,
        25,
        16,
        12,
        11,
        10,
        9,
        8,
        8,
        7,
        7,
        7,
        7,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5
    ];
    var groupBases = [
        0,
        0,
        33554432,
        43046721,
        16777216,
        48828125,
        60466176,
        40353607,
        16777216,
        43046721,
        10000000,
        19487171,
        35831808,
        62748517,
        7529536,
        11390625,
        16777216,
        24137569,
        34012224,
        47045881,
        64000000,
        4084101,
        5153632,
        6436343,
        7962624,
        9765625,
        11881376,
        14348907,
        17210368,
        20511149,
        24300000,
        28629151,
        33554432,
        39135393,
        45435424,
        52521875,
        60466176
    ];
    BN.prototype.toString = function toString(base, padding) {
        base = base || 10;
        padding = padding | 0 || 1;
        var out;
        if (base === 16 || base === "hex") {
            out = "";
            var off = 0;
            var carry = 0;
            for(var i = 0; i < this.length; i++){
                var w = this.words[i];
                var word = ((w << off | carry) & 0xffffff).toString(16);
                carry = w >>> 24 - off & 0xffffff;
                off += 2;
                if (off >= 26) {
                    off -= 26;
                    i--;
                }
                if (carry !== 0 || i !== this.length - 1) out = zeros[6 - word.length] + word + out;
                else out = word + out;
            }
            if (carry !== 0) out = carry.toString(16) + out;
            while(out.length % padding !== 0)out = "0" + out;
            if (this.negative !== 0) out = "-" + out;
            return out;
        }
        if (base === (base | 0) && base >= 2 && base <= 36) {
            // var groupSize = Math.floor(BN.wordSize * Math.LN2 / Math.log(base));
            var groupSize = groupSizes[base];
            // var groupBase = Math.pow(base, groupSize);
            var groupBase = groupBases[base];
            out = "";
            var c = this.clone();
            c.negative = 0;
            while(!c.isZero()){
                var r = c.modrn(groupBase).toString(base);
                c = c.idivn(groupBase);
                if (!c.isZero()) out = zeros[groupSize - r.length] + r + out;
                else out = r + out;
            }
            if (this.isZero()) out = "0" + out;
            while(out.length % padding !== 0)out = "0" + out;
            if (this.negative !== 0) out = "-" + out;
            return out;
        }
        assert(false, "Base should be between 2 and 36");
    };
    BN.prototype.toNumber = function toNumber() {
        var ret = this.words[0];
        if (this.length === 2) ret += this.words[1] * 0x4000000;
        else if (this.length === 3 && this.words[2] === 0x01) // NOTE: at this stage it is known that the top bit is set
        ret += 0x10000000000000 + this.words[1] * 0x4000000;
        else if (this.length > 2) assert(false, "Number can only safely store up to 53 bits");
        return this.negative !== 0 ? -ret : ret;
    };
    BN.prototype.toJSON = function toJSON() {
        return this.toString(16, 2);
    };
    if (Buffer) BN.prototype.toBuffer = function toBuffer(endian, length) {
        return this.toArrayLike(Buffer, endian, length);
    };
    BN.prototype.toArray = function toArray(endian, length) {
        return this.toArrayLike(Array, endian, length);
    };
    var allocate = function allocate(ArrayType, size) {
        if (ArrayType.allocUnsafe) return ArrayType.allocUnsafe(size);
        return new ArrayType(size);
    };
    BN.prototype.toArrayLike = function toArrayLike(ArrayType, endian, length) {
        this._strip();
        var byteLength = this.byteLength();
        var reqLength = length || Math.max(1, byteLength);
        assert(byteLength <= reqLength, "byte array longer than desired length");
        assert(reqLength > 0, "Requested array length <= 0");
        var res = allocate(ArrayType, reqLength);
        var postfix = endian === "le" ? "LE" : "BE";
        this["_toArrayLike" + postfix](res, byteLength);
        return res;
    };
    BN.prototype._toArrayLikeLE = function _toArrayLikeLE(res, byteLength) {
        var position = 0;
        var carry = 0;
        for(var i = 0, shift = 0; i < this.length; i++){
            var word = this.words[i] << shift | carry;
            res[position++] = word & 0xff;
            if (position < res.length) res[position++] = word >> 8 & 0xff;
            if (position < res.length) res[position++] = word >> 16 & 0xff;
            if (shift === 6) {
                if (position < res.length) res[position++] = word >> 24 & 0xff;
                carry = 0;
                shift = 0;
            } else {
                carry = word >>> 24;
                shift += 2;
            }
        }
        if (position < res.length) {
            res[position++] = carry;
            while(position < res.length)res[position++] = 0;
        }
    };
    BN.prototype._toArrayLikeBE = function _toArrayLikeBE(res, byteLength) {
        var position = res.length - 1;
        var carry = 0;
        for(var i = 0, shift = 0; i < this.length; i++){
            var word = this.words[i] << shift | carry;
            res[position--] = word & 0xff;
            if (position >= 0) res[position--] = word >> 8 & 0xff;
            if (position >= 0) res[position--] = word >> 16 & 0xff;
            if (shift === 6) {
                if (position >= 0) res[position--] = word >> 24 & 0xff;
                carry = 0;
                shift = 0;
            } else {
                carry = word >>> 24;
                shift += 2;
            }
        }
        if (position >= 0) {
            res[position--] = carry;
            while(position >= 0)res[position--] = 0;
        }
    };
    if (Math.clz32) BN.prototype._countBits = function _countBits(w) {
        return 32 - Math.clz32(w);
    };
    else BN.prototype._countBits = function _countBits(w) {
        var t = w;
        var r = 0;
        if (t >= 0x1000) {
            r += 13;
            t >>>= 13;
        }
        if (t >= 0x40) {
            r += 7;
            t >>>= 7;
        }
        if (t >= 0x8) {
            r += 4;
            t >>>= 4;
        }
        if (t >= 0x02) {
            r += 2;
            t >>>= 2;
        }
        return r + t;
    };
    BN.prototype._zeroBits = function _zeroBits(w) {
        // Short-cut
        if (w === 0) return 26;
        var t = w;
        var r = 0;
        if ((t & 0x1fff) === 0) {
            r += 13;
            t >>>= 13;
        }
        if ((t & 0x7f) === 0) {
            r += 7;
            t >>>= 7;
        }
        if ((t & 0xf) === 0) {
            r += 4;
            t >>>= 4;
        }
        if ((t & 0x3) === 0) {
            r += 2;
            t >>>= 2;
        }
        if ((t & 0x1) === 0) r++;
        return r;
    };
    // Return number of used bits in a BN
    BN.prototype.bitLength = function bitLength() {
        var w = this.words[this.length - 1];
        var hi = this._countBits(w);
        return (this.length - 1) * 26 + hi;
    };
    function toBitArray(num) {
        var w = new Array(num.bitLength());
        for(var bit = 0; bit < w.length; bit++){
            var off = bit / 26 | 0;
            var wbit = bit % 26;
            w[bit] = num.words[off] >>> wbit & 0x01;
        }
        return w;
    }
    // Number of trailing zero bits
    BN.prototype.zeroBits = function zeroBits() {
        if (this.isZero()) return 0;
        var r = 0;
        for(var i = 0; i < this.length; i++){
            var b = this._zeroBits(this.words[i]);
            r += b;
            if (b !== 26) break;
        }
        return r;
    };
    BN.prototype.byteLength = function byteLength() {
        return Math.ceil(this.bitLength() / 8);
    };
    BN.prototype.toTwos = function toTwos(width) {
        if (this.negative !== 0) return this.abs().inotn(width).iaddn(1);
        return this.clone();
    };
    BN.prototype.fromTwos = function fromTwos(width) {
        if (this.testn(width - 1)) return this.notn(width).iaddn(1).ineg();
        return this.clone();
    };
    BN.prototype.isNeg = function isNeg() {
        return this.negative !== 0;
    };
    // Return negative clone of `this`
    BN.prototype.neg = function neg() {
        return this.clone().ineg();
    };
    BN.prototype.ineg = function ineg() {
        if (!this.isZero()) this.negative ^= 1;
        return this;
    };
    // Or `num` with `this` in-place
    BN.prototype.iuor = function iuor(num) {
        while(this.length < num.length)this.words[this.length++] = 0;
        for(var i = 0; i < num.length; i++)this.words[i] = this.words[i] | num.words[i];
        return this._strip();
    };
    BN.prototype.ior = function ior(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuor(num);
    };
    // Or `num` with `this`
    BN.prototype.or = function or(num) {
        if (this.length > num.length) return this.clone().ior(num);
        return num.clone().ior(this);
    };
    BN.prototype.uor = function uor(num) {
        if (this.length > num.length) return this.clone().iuor(num);
        return num.clone().iuor(this);
    };
    // And `num` with `this` in-place
    BN.prototype.iuand = function iuand(num) {
        // b = min-length(num, this)
        var b;
        if (this.length > num.length) b = num;
        else b = this;
        for(var i = 0; i < b.length; i++)this.words[i] = this.words[i] & num.words[i];
        this.length = b.length;
        return this._strip();
    };
    BN.prototype.iand = function iand(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuand(num);
    };
    // And `num` with `this`
    BN.prototype.and = function and(num) {
        if (this.length > num.length) return this.clone().iand(num);
        return num.clone().iand(this);
    };
    BN.prototype.uand = function uand(num) {
        if (this.length > num.length) return this.clone().iuand(num);
        return num.clone().iuand(this);
    };
    // Xor `num` with `this` in-place
    BN.prototype.iuxor = function iuxor(num) {
        // a.length > b.length
        var a;
        var b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        for(var i = 0; i < b.length; i++)this.words[i] = a.words[i] ^ b.words[i];
        if (this !== a) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = a.length;
        return this._strip();
    };
    BN.prototype.ixor = function ixor(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuxor(num);
    };
    // Xor `num` with `this`
    BN.prototype.xor = function xor(num) {
        if (this.length > num.length) return this.clone().ixor(num);
        return num.clone().ixor(this);
    };
    BN.prototype.uxor = function uxor(num) {
        if (this.length > num.length) return this.clone().iuxor(num);
        return num.clone().iuxor(this);
    };
    // Not ``this`` with ``width`` bitwidth
    BN.prototype.inotn = function inotn(width) {
        assert(typeof width === "number" && width >= 0);
        var bytesNeeded = Math.ceil(width / 26) | 0;
        var bitsLeft = width % 26;
        // Extend the buffer with leading zeroes
        this._expand(bytesNeeded);
        if (bitsLeft > 0) bytesNeeded--;
        // Handle complete words
        for(var i = 0; i < bytesNeeded; i++)this.words[i] = ~this.words[i] & 0x3ffffff;
        // Handle the residue
        if (bitsLeft > 0) this.words[i] = ~this.words[i] & 0x3ffffff >> 26 - bitsLeft;
        // And remove leading zeroes
        return this._strip();
    };
    BN.prototype.notn = function notn(width) {
        return this.clone().inotn(width);
    };
    // Set `bit` of `this`
    BN.prototype.setn = function setn(bit, val) {
        assert(typeof bit === "number" && bit >= 0);
        var off = bit / 26 | 0;
        var wbit = bit % 26;
        this._expand(off + 1);
        if (val) this.words[off] = this.words[off] | 1 << wbit;
        else this.words[off] = this.words[off] & ~(1 << wbit);
        return this._strip();
    };
    // Add `num` to `this` in-place
    BN.prototype.iadd = function iadd(num) {
        var r;
        // negative + positive
        if (this.negative !== 0 && num.negative === 0) {
            this.negative = 0;
            r = this.isub(num);
            this.negative ^= 1;
            return this._normSign();
        // positive + negative
        } else if (this.negative === 0 && num.negative !== 0) {
            num.negative = 0;
            r = this.isub(num);
            num.negative = 1;
            return r._normSign();
        }
        // a.length > b.length
        var a, b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) + (b.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        this.length = a.length;
        if (carry !== 0) {
            this.words[this.length] = carry;
            this.length++;
        // Copy the rest of the words
        } else if (a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        return this;
    };
    // Add `num` to `this`
    BN.prototype.add = function add(num) {
        var res;
        if (num.negative !== 0 && this.negative === 0) {
            num.negative = 0;
            res = this.sub(num);
            num.negative ^= 1;
            return res;
        } else if (num.negative === 0 && this.negative !== 0) {
            this.negative = 0;
            res = num.sub(this);
            this.negative = 1;
            return res;
        }
        if (this.length > num.length) return this.clone().iadd(num);
        return num.clone().iadd(this);
    };
    // Subtract `num` from `this` in-place
    BN.prototype.isub = function isub(num) {
        // this - (-num) = this + num
        if (num.negative !== 0) {
            num.negative = 0;
            var r = this.iadd(num);
            num.negative = 1;
            return r._normSign();
        // -this - num = -(this + num)
        } else if (this.negative !== 0) {
            this.negative = 0;
            this.iadd(num);
            this.negative = 1;
            return this._normSign();
        }
        // At this point both numbers are positive
        var cmp = this.cmp(num);
        // Optimization - zeroify
        if (cmp === 0) {
            this.negative = 0;
            this.length = 1;
            this.words[0] = 0;
            return this;
        }
        // a > b
        var a, b;
        if (cmp > 0) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) - (b.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        // Copy rest of the words
        if (carry === 0 && i < a.length && a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = Math.max(this.length, i);
        if (a !== this) this.negative = 1;
        return this._strip();
    };
    // Subtract `num` from `this`
    BN.prototype.sub = function sub(num) {
        return this.clone().isub(num);
    };
    function smallMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        var len = self.length + num.length | 0;
        out.length = len;
        len = len - 1 | 0;
        // Peel one iteration (compiler can't do it, because of code complexity)
        var a = self.words[0] | 0;
        var b = num.words[0] | 0;
        var r = a * b;
        var lo = r & 0x3ffffff;
        var carry = r / 0x4000000 | 0;
        out.words[0] = lo;
        for(var k = 1; k < len; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = carry >>> 26;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j | 0;
                a = self.words[i] | 0;
                b = num.words[j] | 0;
                r = a * b + rword;
                ncarry += r / 0x4000000 | 0;
                rword = r & 0x3ffffff;
            }
            out.words[k] = rword | 0;
            carry = ncarry | 0;
        }
        if (carry !== 0) out.words[k] = carry | 0;
        else out.length--;
        return out._strip();
    }
    // TODO(indutny): it may be reasonable to omit it for users who don't need
    // to work with 256-bit numbers, otherwise it gives 20% improvement for 256-bit
    // multiplication (like elliptic secp256k1).
    var comb10MulTo = function comb10MulTo(self, num, out) {
        var a = self.words;
        var b = num.words;
        var o = out.words;
        var c = 0;
        var lo;
        var mid;
        var hi;
        var a0 = a[0] | 0;
        var al0 = a0 & 0x1fff;
        var ah0 = a0 >>> 13;
        var a1 = a[1] | 0;
        var al1 = a1 & 0x1fff;
        var ah1 = a1 >>> 13;
        var a2 = a[2] | 0;
        var al2 = a2 & 0x1fff;
        var ah2 = a2 >>> 13;
        var a3 = a[3] | 0;
        var al3 = a3 & 0x1fff;
        var ah3 = a3 >>> 13;
        var a4 = a[4] | 0;
        var al4 = a4 & 0x1fff;
        var ah4 = a4 >>> 13;
        var a5 = a[5] | 0;
        var al5 = a5 & 0x1fff;
        var ah5 = a5 >>> 13;
        var a6 = a[6] | 0;
        var al6 = a6 & 0x1fff;
        var ah6 = a6 >>> 13;
        var a7 = a[7] | 0;
        var al7 = a7 & 0x1fff;
        var ah7 = a7 >>> 13;
        var a8 = a[8] | 0;
        var al8 = a8 & 0x1fff;
        var ah8 = a8 >>> 13;
        var a9 = a[9] | 0;
        var al9 = a9 & 0x1fff;
        var ah9 = a9 >>> 13;
        var b0 = b[0] | 0;
        var bl0 = b0 & 0x1fff;
        var bh0 = b0 >>> 13;
        var b1 = b[1] | 0;
        var bl1 = b1 & 0x1fff;
        var bh1 = b1 >>> 13;
        var b2 = b[2] | 0;
        var bl2 = b2 & 0x1fff;
        var bh2 = b2 >>> 13;
        var b3 = b[3] | 0;
        var bl3 = b3 & 0x1fff;
        var bh3 = b3 >>> 13;
        var b4 = b[4] | 0;
        var bl4 = b4 & 0x1fff;
        var bh4 = b4 >>> 13;
        var b5 = b[5] | 0;
        var bl5 = b5 & 0x1fff;
        var bh5 = b5 >>> 13;
        var b6 = b[6] | 0;
        var bl6 = b6 & 0x1fff;
        var bh6 = b6 >>> 13;
        var b7 = b[7] | 0;
        var bl7 = b7 & 0x1fff;
        var bh7 = b7 >>> 13;
        var b8 = b[8] | 0;
        var bl8 = b8 & 0x1fff;
        var bh8 = b8 >>> 13;
        var b9 = b[9] | 0;
        var bl9 = b9 & 0x1fff;
        var bh9 = b9 >>> 13;
        out.negative = self.negative ^ num.negative;
        out.length = 19;
        /* k = 0 */ lo = Math.imul(al0, bl0);
        mid = Math.imul(al0, bh0);
        mid = mid + Math.imul(ah0, bl0) | 0;
        hi = Math.imul(ah0, bh0);
        var w0 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w0 >>> 26) | 0;
        w0 &= 0x3ffffff;
        /* k = 1 */ lo = Math.imul(al1, bl0);
        mid = Math.imul(al1, bh0);
        mid = mid + Math.imul(ah1, bl0) | 0;
        hi = Math.imul(ah1, bh0);
        lo = lo + Math.imul(al0, bl1) | 0;
        mid = mid + Math.imul(al0, bh1) | 0;
        mid = mid + Math.imul(ah0, bl1) | 0;
        hi = hi + Math.imul(ah0, bh1) | 0;
        var w1 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w1 >>> 26) | 0;
        w1 &= 0x3ffffff;
        /* k = 2 */ lo = Math.imul(al2, bl0);
        mid = Math.imul(al2, bh0);
        mid = mid + Math.imul(ah2, bl0) | 0;
        hi = Math.imul(ah2, bh0);
        lo = lo + Math.imul(al1, bl1) | 0;
        mid = mid + Math.imul(al1, bh1) | 0;
        mid = mid + Math.imul(ah1, bl1) | 0;
        hi = hi + Math.imul(ah1, bh1) | 0;
        lo = lo + Math.imul(al0, bl2) | 0;
        mid = mid + Math.imul(al0, bh2) | 0;
        mid = mid + Math.imul(ah0, bl2) | 0;
        hi = hi + Math.imul(ah0, bh2) | 0;
        var w2 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w2 >>> 26) | 0;
        w2 &= 0x3ffffff;
        /* k = 3 */ lo = Math.imul(al3, bl0);
        mid = Math.imul(al3, bh0);
        mid = mid + Math.imul(ah3, bl0) | 0;
        hi = Math.imul(ah3, bh0);
        lo = lo + Math.imul(al2, bl1) | 0;
        mid = mid + Math.imul(al2, bh1) | 0;
        mid = mid + Math.imul(ah2, bl1) | 0;
        hi = hi + Math.imul(ah2, bh1) | 0;
        lo = lo + Math.imul(al1, bl2) | 0;
        mid = mid + Math.imul(al1, bh2) | 0;
        mid = mid + Math.imul(ah1, bl2) | 0;
        hi = hi + Math.imul(ah1, bh2) | 0;
        lo = lo + Math.imul(al0, bl3) | 0;
        mid = mid + Math.imul(al0, bh3) | 0;
        mid = mid + Math.imul(ah0, bl3) | 0;
        hi = hi + Math.imul(ah0, bh3) | 0;
        var w3 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w3 >>> 26) | 0;
        w3 &= 0x3ffffff;
        /* k = 4 */ lo = Math.imul(al4, bl0);
        mid = Math.imul(al4, bh0);
        mid = mid + Math.imul(ah4, bl0) | 0;
        hi = Math.imul(ah4, bh0);
        lo = lo + Math.imul(al3, bl1) | 0;
        mid = mid + Math.imul(al3, bh1) | 0;
        mid = mid + Math.imul(ah3, bl1) | 0;
        hi = hi + Math.imul(ah3, bh1) | 0;
        lo = lo + Math.imul(al2, bl2) | 0;
        mid = mid + Math.imul(al2, bh2) | 0;
        mid = mid + Math.imul(ah2, bl2) | 0;
        hi = hi + Math.imul(ah2, bh2) | 0;
        lo = lo + Math.imul(al1, bl3) | 0;
        mid = mid + Math.imul(al1, bh3) | 0;
        mid = mid + Math.imul(ah1, bl3) | 0;
        hi = hi + Math.imul(ah1, bh3) | 0;
        lo = lo + Math.imul(al0, bl4) | 0;
        mid = mid + Math.imul(al0, bh4) | 0;
        mid = mid + Math.imul(ah0, bl4) | 0;
        hi = hi + Math.imul(ah0, bh4) | 0;
        var w4 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w4 >>> 26) | 0;
        w4 &= 0x3ffffff;
        /* k = 5 */ lo = Math.imul(al5, bl0);
        mid = Math.imul(al5, bh0);
        mid = mid + Math.imul(ah5, bl0) | 0;
        hi = Math.imul(ah5, bh0);
        lo = lo + Math.imul(al4, bl1) | 0;
        mid = mid + Math.imul(al4, bh1) | 0;
        mid = mid + Math.imul(ah4, bl1) | 0;
        hi = hi + Math.imul(ah4, bh1) | 0;
        lo = lo + Math.imul(al3, bl2) | 0;
        mid = mid + Math.imul(al3, bh2) | 0;
        mid = mid + Math.imul(ah3, bl2) | 0;
        hi = hi + Math.imul(ah3, bh2) | 0;
        lo = lo + Math.imul(al2, bl3) | 0;
        mid = mid + Math.imul(al2, bh3) | 0;
        mid = mid + Math.imul(ah2, bl3) | 0;
        hi = hi + Math.imul(ah2, bh3) | 0;
        lo = lo + Math.imul(al1, bl4) | 0;
        mid = mid + Math.imul(al1, bh4) | 0;
        mid = mid + Math.imul(ah1, bl4) | 0;
        hi = hi + Math.imul(ah1, bh4) | 0;
        lo = lo + Math.imul(al0, bl5) | 0;
        mid = mid + Math.imul(al0, bh5) | 0;
        mid = mid + Math.imul(ah0, bl5) | 0;
        hi = hi + Math.imul(ah0, bh5) | 0;
        var w5 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w5 >>> 26) | 0;
        w5 &= 0x3ffffff;
        /* k = 6 */ lo = Math.imul(al6, bl0);
        mid = Math.imul(al6, bh0);
        mid = mid + Math.imul(ah6, bl0) | 0;
        hi = Math.imul(ah6, bh0);
        lo = lo + Math.imul(al5, bl1) | 0;
        mid = mid + Math.imul(al5, bh1) | 0;
        mid = mid + Math.imul(ah5, bl1) | 0;
        hi = hi + Math.imul(ah5, bh1) | 0;
        lo = lo + Math.imul(al4, bl2) | 0;
        mid = mid + Math.imul(al4, bh2) | 0;
        mid = mid + Math.imul(ah4, bl2) | 0;
        hi = hi + Math.imul(ah4, bh2) | 0;
        lo = lo + Math.imul(al3, bl3) | 0;
        mid = mid + Math.imul(al3, bh3) | 0;
        mid = mid + Math.imul(ah3, bl3) | 0;
        hi = hi + Math.imul(ah3, bh3) | 0;
        lo = lo + Math.imul(al2, bl4) | 0;
        mid = mid + Math.imul(al2, bh4) | 0;
        mid = mid + Math.imul(ah2, bl4) | 0;
        hi = hi + Math.imul(ah2, bh4) | 0;
        lo = lo + Math.imul(al1, bl5) | 0;
        mid = mid + Math.imul(al1, bh5) | 0;
        mid = mid + Math.imul(ah1, bl5) | 0;
        hi = hi + Math.imul(ah1, bh5) | 0;
        lo = lo + Math.imul(al0, bl6) | 0;
        mid = mid + Math.imul(al0, bh6) | 0;
        mid = mid + Math.imul(ah0, bl6) | 0;
        hi = hi + Math.imul(ah0, bh6) | 0;
        var w6 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w6 >>> 26) | 0;
        w6 &= 0x3ffffff;
        /* k = 7 */ lo = Math.imul(al7, bl0);
        mid = Math.imul(al7, bh0);
        mid = mid + Math.imul(ah7, bl0) | 0;
        hi = Math.imul(ah7, bh0);
        lo = lo + Math.imul(al6, bl1) | 0;
        mid = mid + Math.imul(al6, bh1) | 0;
        mid = mid + Math.imul(ah6, bl1) | 0;
        hi = hi + Math.imul(ah6, bh1) | 0;
        lo = lo + Math.imul(al5, bl2) | 0;
        mid = mid + Math.imul(al5, bh2) | 0;
        mid = mid + Math.imul(ah5, bl2) | 0;
        hi = hi + Math.imul(ah5, bh2) | 0;
        lo = lo + Math.imul(al4, bl3) | 0;
        mid = mid + Math.imul(al4, bh3) | 0;
        mid = mid + Math.imul(ah4, bl3) | 0;
        hi = hi + Math.imul(ah4, bh3) | 0;
        lo = lo + Math.imul(al3, bl4) | 0;
        mid = mid + Math.imul(al3, bh4) | 0;
        mid = mid + Math.imul(ah3, bl4) | 0;
        hi = hi + Math.imul(ah3, bh4) | 0;
        lo = lo + Math.imul(al2, bl5) | 0;
        mid = mid + Math.imul(al2, bh5) | 0;
        mid = mid + Math.imul(ah2, bl5) | 0;
        hi = hi + Math.imul(ah2, bh5) | 0;
        lo = lo + Math.imul(al1, bl6) | 0;
        mid = mid + Math.imul(al1, bh6) | 0;
        mid = mid + Math.imul(ah1, bl6) | 0;
        hi = hi + Math.imul(ah1, bh6) | 0;
        lo = lo + Math.imul(al0, bl7) | 0;
        mid = mid + Math.imul(al0, bh7) | 0;
        mid = mid + Math.imul(ah0, bl7) | 0;
        hi = hi + Math.imul(ah0, bh7) | 0;
        var w7 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w7 >>> 26) | 0;
        w7 &= 0x3ffffff;
        /* k = 8 */ lo = Math.imul(al8, bl0);
        mid = Math.imul(al8, bh0);
        mid = mid + Math.imul(ah8, bl0) | 0;
        hi = Math.imul(ah8, bh0);
        lo = lo + Math.imul(al7, bl1) | 0;
        mid = mid + Math.imul(al7, bh1) | 0;
        mid = mid + Math.imul(ah7, bl1) | 0;
        hi = hi + Math.imul(ah7, bh1) | 0;
        lo = lo + Math.imul(al6, bl2) | 0;
        mid = mid + Math.imul(al6, bh2) | 0;
        mid = mid + Math.imul(ah6, bl2) | 0;
        hi = hi + Math.imul(ah6, bh2) | 0;
        lo = lo + Math.imul(al5, bl3) | 0;
        mid = mid + Math.imul(al5, bh3) | 0;
        mid = mid + Math.imul(ah5, bl3) | 0;
        hi = hi + Math.imul(ah5, bh3) | 0;
        lo = lo + Math.imul(al4, bl4) | 0;
        mid = mid + Math.imul(al4, bh4) | 0;
        mid = mid + Math.imul(ah4, bl4) | 0;
        hi = hi + Math.imul(ah4, bh4) | 0;
        lo = lo + Math.imul(al3, bl5) | 0;
        mid = mid + Math.imul(al3, bh5) | 0;
        mid = mid + Math.imul(ah3, bl5) | 0;
        hi = hi + Math.imul(ah3, bh5) | 0;
        lo = lo + Math.imul(al2, bl6) | 0;
        mid = mid + Math.imul(al2, bh6) | 0;
        mid = mid + Math.imul(ah2, bl6) | 0;
        hi = hi + Math.imul(ah2, bh6) | 0;
        lo = lo + Math.imul(al1, bl7) | 0;
        mid = mid + Math.imul(al1, bh7) | 0;
        mid = mid + Math.imul(ah1, bl7) | 0;
        hi = hi + Math.imul(ah1, bh7) | 0;
        lo = lo + Math.imul(al0, bl8) | 0;
        mid = mid + Math.imul(al0, bh8) | 0;
        mid = mid + Math.imul(ah0, bl8) | 0;
        hi = hi + Math.imul(ah0, bh8) | 0;
        var w8 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w8 >>> 26) | 0;
        w8 &= 0x3ffffff;
        /* k = 9 */ lo = Math.imul(al9, bl0);
        mid = Math.imul(al9, bh0);
        mid = mid + Math.imul(ah9, bl0) | 0;
        hi = Math.imul(ah9, bh0);
        lo = lo + Math.imul(al8, bl1) | 0;
        mid = mid + Math.imul(al8, bh1) | 0;
        mid = mid + Math.imul(ah8, bl1) | 0;
        hi = hi + Math.imul(ah8, bh1) | 0;
        lo = lo + Math.imul(al7, bl2) | 0;
        mid = mid + Math.imul(al7, bh2) | 0;
        mid = mid + Math.imul(ah7, bl2) | 0;
        hi = hi + Math.imul(ah7, bh2) | 0;
        lo = lo + Math.imul(al6, bl3) | 0;
        mid = mid + Math.imul(al6, bh3) | 0;
        mid = mid + Math.imul(ah6, bl3) | 0;
        hi = hi + Math.imul(ah6, bh3) | 0;
        lo = lo + Math.imul(al5, bl4) | 0;
        mid = mid + Math.imul(al5, bh4) | 0;
        mid = mid + Math.imul(ah5, bl4) | 0;
        hi = hi + Math.imul(ah5, bh4) | 0;
        lo = lo + Math.imul(al4, bl5) | 0;
        mid = mid + Math.imul(al4, bh5) | 0;
        mid = mid + Math.imul(ah4, bl5) | 0;
        hi = hi + Math.imul(ah4, bh5) | 0;
        lo = lo + Math.imul(al3, bl6) | 0;
        mid = mid + Math.imul(al3, bh6) | 0;
        mid = mid + Math.imul(ah3, bl6) | 0;
        hi = hi + Math.imul(ah3, bh6) | 0;
        lo = lo + Math.imul(al2, bl7) | 0;
        mid = mid + Math.imul(al2, bh7) | 0;
        mid = mid + Math.imul(ah2, bl7) | 0;
        hi = hi + Math.imul(ah2, bh7) | 0;
        lo = lo + Math.imul(al1, bl8) | 0;
        mid = mid + Math.imul(al1, bh8) | 0;
        mid = mid + Math.imul(ah1, bl8) | 0;
        hi = hi + Math.imul(ah1, bh8) | 0;
        lo = lo + Math.imul(al0, bl9) | 0;
        mid = mid + Math.imul(al0, bh9) | 0;
        mid = mid + Math.imul(ah0, bl9) | 0;
        hi = hi + Math.imul(ah0, bh9) | 0;
        var w9 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w9 >>> 26) | 0;
        w9 &= 0x3ffffff;
        /* k = 10 */ lo = Math.imul(al9, bl1);
        mid = Math.imul(al9, bh1);
        mid = mid + Math.imul(ah9, bl1) | 0;
        hi = Math.imul(ah9, bh1);
        lo = lo + Math.imul(al8, bl2) | 0;
        mid = mid + Math.imul(al8, bh2) | 0;
        mid = mid + Math.imul(ah8, bl2) | 0;
        hi = hi + Math.imul(ah8, bh2) | 0;
        lo = lo + Math.imul(al7, bl3) | 0;
        mid = mid + Math.imul(al7, bh3) | 0;
        mid = mid + Math.imul(ah7, bl3) | 0;
        hi = hi + Math.imul(ah7, bh3) | 0;
        lo = lo + Math.imul(al6, bl4) | 0;
        mid = mid + Math.imul(al6, bh4) | 0;
        mid = mid + Math.imul(ah6, bl4) | 0;
        hi = hi + Math.imul(ah6, bh4) | 0;
        lo = lo + Math.imul(al5, bl5) | 0;
        mid = mid + Math.imul(al5, bh5) | 0;
        mid = mid + Math.imul(ah5, bl5) | 0;
        hi = hi + Math.imul(ah5, bh5) | 0;
        lo = lo + Math.imul(al4, bl6) | 0;
        mid = mid + Math.imul(al4, bh6) | 0;
        mid = mid + Math.imul(ah4, bl6) | 0;
        hi = hi + Math.imul(ah4, bh6) | 0;
        lo = lo + Math.imul(al3, bl7) | 0;
        mid = mid + Math.imul(al3, bh7) | 0;
        mid = mid + Math.imul(ah3, bl7) | 0;
        hi = hi + Math.imul(ah3, bh7) | 0;
        lo = lo + Math.imul(al2, bl8) | 0;
        mid = mid + Math.imul(al2, bh8) | 0;
        mid = mid + Math.imul(ah2, bl8) | 0;
        hi = hi + Math.imul(ah2, bh8) | 0;
        lo = lo + Math.imul(al1, bl9) | 0;
        mid = mid + Math.imul(al1, bh9) | 0;
        mid = mid + Math.imul(ah1, bl9) | 0;
        hi = hi + Math.imul(ah1, bh9) | 0;
        var w10 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w10 >>> 26) | 0;
        w10 &= 0x3ffffff;
        /* k = 11 */ lo = Math.imul(al9, bl2);
        mid = Math.imul(al9, bh2);
        mid = mid + Math.imul(ah9, bl2) | 0;
        hi = Math.imul(ah9, bh2);
        lo = lo + Math.imul(al8, bl3) | 0;
        mid = mid + Math.imul(al8, bh3) | 0;
        mid = mid + Math.imul(ah8, bl3) | 0;
        hi = hi + Math.imul(ah8, bh3) | 0;
        lo = lo + Math.imul(al7, bl4) | 0;
        mid = mid + Math.imul(al7, bh4) | 0;
        mid = mid + Math.imul(ah7, bl4) | 0;
        hi = hi + Math.imul(ah7, bh4) | 0;
        lo = lo + Math.imul(al6, bl5) | 0;
        mid = mid + Math.imul(al6, bh5) | 0;
        mid = mid + Math.imul(ah6, bl5) | 0;
        hi = hi + Math.imul(ah6, bh5) | 0;
        lo = lo + Math.imul(al5, bl6) | 0;
        mid = mid + Math.imul(al5, bh6) | 0;
        mid = mid + Math.imul(ah5, bl6) | 0;
        hi = hi + Math.imul(ah5, bh6) | 0;
        lo = lo + Math.imul(al4, bl7) | 0;
        mid = mid + Math.imul(al4, bh7) | 0;
        mid = mid + Math.imul(ah4, bl7) | 0;
        hi = hi + Math.imul(ah4, bh7) | 0;
        lo = lo + Math.imul(al3, bl8) | 0;
        mid = mid + Math.imul(al3, bh8) | 0;
        mid = mid + Math.imul(ah3, bl8) | 0;
        hi = hi + Math.imul(ah3, bh8) | 0;
        lo = lo + Math.imul(al2, bl9) | 0;
        mid = mid + Math.imul(al2, bh9) | 0;
        mid = mid + Math.imul(ah2, bl9) | 0;
        hi = hi + Math.imul(ah2, bh9) | 0;
        var w11 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w11 >>> 26) | 0;
        w11 &= 0x3ffffff;
        /* k = 12 */ lo = Math.imul(al9, bl3);
        mid = Math.imul(al9, bh3);
        mid = mid + Math.imul(ah9, bl3) | 0;
        hi = Math.imul(ah9, bh3);
        lo = lo + Math.imul(al8, bl4) | 0;
        mid = mid + Math.imul(al8, bh4) | 0;
        mid = mid + Math.imul(ah8, bl4) | 0;
        hi = hi + Math.imul(ah8, bh4) | 0;
        lo = lo + Math.imul(al7, bl5) | 0;
        mid = mid + Math.imul(al7, bh5) | 0;
        mid = mid + Math.imul(ah7, bl5) | 0;
        hi = hi + Math.imul(ah7, bh5) | 0;
        lo = lo + Math.imul(al6, bl6) | 0;
        mid = mid + Math.imul(al6, bh6) | 0;
        mid = mid + Math.imul(ah6, bl6) | 0;
        hi = hi + Math.imul(ah6, bh6) | 0;
        lo = lo + Math.imul(al5, bl7) | 0;
        mid = mid + Math.imul(al5, bh7) | 0;
        mid = mid + Math.imul(ah5, bl7) | 0;
        hi = hi + Math.imul(ah5, bh7) | 0;
        lo = lo + Math.imul(al4, bl8) | 0;
        mid = mid + Math.imul(al4, bh8) | 0;
        mid = mid + Math.imul(ah4, bl8) | 0;
        hi = hi + Math.imul(ah4, bh8) | 0;
        lo = lo + Math.imul(al3, bl9) | 0;
        mid = mid + Math.imul(al3, bh9) | 0;
        mid = mid + Math.imul(ah3, bl9) | 0;
        hi = hi + Math.imul(ah3, bh9) | 0;
        var w12 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w12 >>> 26) | 0;
        w12 &= 0x3ffffff;
        /* k = 13 */ lo = Math.imul(al9, bl4);
        mid = Math.imul(al9, bh4);
        mid = mid + Math.imul(ah9, bl4) | 0;
        hi = Math.imul(ah9, bh4);
        lo = lo + Math.imul(al8, bl5) | 0;
        mid = mid + Math.imul(al8, bh5) | 0;
        mid = mid + Math.imul(ah8, bl5) | 0;
        hi = hi + Math.imul(ah8, bh5) | 0;
        lo = lo + Math.imul(al7, bl6) | 0;
        mid = mid + Math.imul(al7, bh6) | 0;
        mid = mid + Math.imul(ah7, bl6) | 0;
        hi = hi + Math.imul(ah7, bh6) | 0;
        lo = lo + Math.imul(al6, bl7) | 0;
        mid = mid + Math.imul(al6, bh7) | 0;
        mid = mid + Math.imul(ah6, bl7) | 0;
        hi = hi + Math.imul(ah6, bh7) | 0;
        lo = lo + Math.imul(al5, bl8) | 0;
        mid = mid + Math.imul(al5, bh8) | 0;
        mid = mid + Math.imul(ah5, bl8) | 0;
        hi = hi + Math.imul(ah5, bh8) | 0;
        lo = lo + Math.imul(al4, bl9) | 0;
        mid = mid + Math.imul(al4, bh9) | 0;
        mid = mid + Math.imul(ah4, bl9) | 0;
        hi = hi + Math.imul(ah4, bh9) | 0;
        var w13 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w13 >>> 26) | 0;
        w13 &= 0x3ffffff;
        /* k = 14 */ lo = Math.imul(al9, bl5);
        mid = Math.imul(al9, bh5);
        mid = mid + Math.imul(ah9, bl5) | 0;
        hi = Math.imul(ah9, bh5);
        lo = lo + Math.imul(al8, bl6) | 0;
        mid = mid + Math.imul(al8, bh6) | 0;
        mid = mid + Math.imul(ah8, bl6) | 0;
        hi = hi + Math.imul(ah8, bh6) | 0;
        lo = lo + Math.imul(al7, bl7) | 0;
        mid = mid + Math.imul(al7, bh7) | 0;
        mid = mid + Math.imul(ah7, bl7) | 0;
        hi = hi + Math.imul(ah7, bh7) | 0;
        lo = lo + Math.imul(al6, bl8) | 0;
        mid = mid + Math.imul(al6, bh8) | 0;
        mid = mid + Math.imul(ah6, bl8) | 0;
        hi = hi + Math.imul(ah6, bh8) | 0;
        lo = lo + Math.imul(al5, bl9) | 0;
        mid = mid + Math.imul(al5, bh9) | 0;
        mid = mid + Math.imul(ah5, bl9) | 0;
        hi = hi + Math.imul(ah5, bh9) | 0;
        var w14 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w14 >>> 26) | 0;
        w14 &= 0x3ffffff;
        /* k = 15 */ lo = Math.imul(al9, bl6);
        mid = Math.imul(al9, bh6);
        mid = mid + Math.imul(ah9, bl6) | 0;
        hi = Math.imul(ah9, bh6);
        lo = lo + Math.imul(al8, bl7) | 0;
        mid = mid + Math.imul(al8, bh7) | 0;
        mid = mid + Math.imul(ah8, bl7) | 0;
        hi = hi + Math.imul(ah8, bh7) | 0;
        lo = lo + Math.imul(al7, bl8) | 0;
        mid = mid + Math.imul(al7, bh8) | 0;
        mid = mid + Math.imul(ah7, bl8) | 0;
        hi = hi + Math.imul(ah7, bh8) | 0;
        lo = lo + Math.imul(al6, bl9) | 0;
        mid = mid + Math.imul(al6, bh9) | 0;
        mid = mid + Math.imul(ah6, bl9) | 0;
        hi = hi + Math.imul(ah6, bh9) | 0;
        var w15 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w15 >>> 26) | 0;
        w15 &= 0x3ffffff;
        /* k = 16 */ lo = Math.imul(al9, bl7);
        mid = Math.imul(al9, bh7);
        mid = mid + Math.imul(ah9, bl7) | 0;
        hi = Math.imul(ah9, bh7);
        lo = lo + Math.imul(al8, bl8) | 0;
        mid = mid + Math.imul(al8, bh8) | 0;
        mid = mid + Math.imul(ah8, bl8) | 0;
        hi = hi + Math.imul(ah8, bh8) | 0;
        lo = lo + Math.imul(al7, bl9) | 0;
        mid = mid + Math.imul(al7, bh9) | 0;
        mid = mid + Math.imul(ah7, bl9) | 0;
        hi = hi + Math.imul(ah7, bh9) | 0;
        var w16 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w16 >>> 26) | 0;
        w16 &= 0x3ffffff;
        /* k = 17 */ lo = Math.imul(al9, bl8);
        mid = Math.imul(al9, bh8);
        mid = mid + Math.imul(ah9, bl8) | 0;
        hi = Math.imul(ah9, bh8);
        lo = lo + Math.imul(al8, bl9) | 0;
        mid = mid + Math.imul(al8, bh9) | 0;
        mid = mid + Math.imul(ah8, bl9) | 0;
        hi = hi + Math.imul(ah8, bh9) | 0;
        var w17 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w17 >>> 26) | 0;
        w17 &= 0x3ffffff;
        /* k = 18 */ lo = Math.imul(al9, bl9);
        mid = Math.imul(al9, bh9);
        mid = mid + Math.imul(ah9, bl9) | 0;
        hi = Math.imul(ah9, bh9);
        var w18 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w18 >>> 26) | 0;
        w18 &= 0x3ffffff;
        o[0] = w0;
        o[1] = w1;
        o[2] = w2;
        o[3] = w3;
        o[4] = w4;
        o[5] = w5;
        o[6] = w6;
        o[7] = w7;
        o[8] = w8;
        o[9] = w9;
        o[10] = w10;
        o[11] = w11;
        o[12] = w12;
        o[13] = w13;
        o[14] = w14;
        o[15] = w15;
        o[16] = w16;
        o[17] = w17;
        o[18] = w18;
        if (c !== 0) {
            o[19] = c;
            out.length++;
        }
        return out;
    };
    // Polyfill comb
    if (!Math.imul) comb10MulTo = smallMulTo;
    function bigMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        out.length = self.length + num.length;
        var carry = 0;
        var hncarry = 0;
        for(var k = 0; k < out.length - 1; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = hncarry;
            hncarry = 0;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j;
                var a = self.words[i] | 0;
                var b = num.words[j] | 0;
                var r = a * b;
                var lo = r & 0x3ffffff;
                ncarry = ncarry + (r / 0x4000000 | 0) | 0;
                lo = lo + rword | 0;
                rword = lo & 0x3ffffff;
                ncarry = ncarry + (lo >>> 26) | 0;
                hncarry += ncarry >>> 26;
                ncarry &= 0x3ffffff;
            }
            out.words[k] = rword;
            carry = ncarry;
            ncarry = hncarry;
        }
        if (carry !== 0) out.words[k] = carry;
        else out.length--;
        return out._strip();
    }
    function jumboMulTo(self, num, out) {
        // Temporary disable, see https://github.com/indutny/bn.js/issues/211
        // var fftm = new FFTM();
        // return fftm.mulp(self, num, out);
        return bigMulTo(self, num, out);
    }
    BN.prototype.mulTo = function mulTo(num, out) {
        var res;
        var len = this.length + num.length;
        if (this.length === 10 && num.length === 10) res = comb10MulTo(this, num, out);
        else if (len < 63) res = smallMulTo(this, num, out);
        else if (len < 1024) res = bigMulTo(this, num, out);
        else res = jumboMulTo(this, num, out);
        return res;
    };
    // Cooley-Tukey algorithm for FFT
    // slightly revisited to rely on looping instead of recursion
    function FFTM(x, y) {
        this.x = x;
        this.y = y;
    }
    FFTM.prototype.makeRBT = function makeRBT(N) {
        var t = new Array(N);
        var l = BN.prototype._countBits(N) - 1;
        for(var i = 0; i < N; i++)t[i] = this.revBin(i, l, N);
        return t;
    };
    // Returns binary-reversed representation of `x`
    FFTM.prototype.revBin = function revBin(x, l, N) {
        if (x === 0 || x === N - 1) return x;
        var rb = 0;
        for(var i = 0; i < l; i++){
            rb |= (x & 1) << l - i - 1;
            x >>= 1;
        }
        return rb;
    };
    // Performs "tweedling" phase, therefore 'emulating'
    // behaviour of the recursive algorithm
    FFTM.prototype.permute = function permute(rbt, rws, iws, rtws, itws, N) {
        for(var i = 0; i < N; i++){
            rtws[i] = rws[rbt[i]];
            itws[i] = iws[rbt[i]];
        }
    };
    FFTM.prototype.transform = function transform(rws, iws, rtws, itws, N, rbt) {
        this.permute(rbt, rws, iws, rtws, itws, N);
        for(var s = 1; s < N; s <<= 1){
            var l = s << 1;
            var rtwdf = Math.cos(2 * Math.PI / l);
            var itwdf = Math.sin(2 * Math.PI / l);
            for(var p = 0; p < N; p += l){
                var rtwdf_ = rtwdf;
                var itwdf_ = itwdf;
                for(var j = 0; j < s; j++){
                    var re = rtws[p + j];
                    var ie = itws[p + j];
                    var ro = rtws[p + j + s];
                    var io = itws[p + j + s];
                    var rx = rtwdf_ * ro - itwdf_ * io;
                    io = rtwdf_ * io + itwdf_ * ro;
                    ro = rx;
                    rtws[p + j] = re + ro;
                    itws[p + j] = ie + io;
                    rtws[p + j + s] = re - ro;
                    itws[p + j + s] = ie - io;
                    /* jshint maxdepth : false */ if (j !== l) {
                        rx = rtwdf * rtwdf_ - itwdf * itwdf_;
                        itwdf_ = rtwdf * itwdf_ + itwdf * rtwdf_;
                        rtwdf_ = rx;
                    }
                }
            }
        }
    };
    FFTM.prototype.guessLen13b = function guessLen13b(n, m) {
        var N = Math.max(m, n) | 1;
        var odd = N & 1;
        var i = 0;
        for(N = N / 2 | 0; N; N = N >>> 1)i++;
        return 1 << i + 1 + odd;
    };
    FFTM.prototype.conjugate = function conjugate(rws, iws, N) {
        if (N <= 1) return;
        for(var i = 0; i < N / 2; i++){
            var t = rws[i];
            rws[i] = rws[N - i - 1];
            rws[N - i - 1] = t;
            t = iws[i];
            iws[i] = -iws[N - i - 1];
            iws[N - i - 1] = -t;
        }
    };
    FFTM.prototype.normalize13b = function normalize13b(ws, N) {
        var carry = 0;
        for(var i = 0; i < N / 2; i++){
            var w = Math.round(ws[2 * i + 1] / N) * 0x2000 + Math.round(ws[2 * i] / N) + carry;
            ws[i] = w & 0x3ffffff;
            if (w < 0x4000000) carry = 0;
            else carry = w / 0x4000000 | 0;
        }
        return ws;
    };
    FFTM.prototype.convert13b = function convert13b(ws, len, rws, N) {
        var carry = 0;
        for(var i = 0; i < len; i++){
            carry = carry + (ws[i] | 0);
            rws[2 * i] = carry & 0x1fff;
            carry = carry >>> 13;
            rws[2 * i + 1] = carry & 0x1fff;
            carry = carry >>> 13;
        }
        // Pad with zeroes
        for(i = 2 * len; i < N; ++i)rws[i] = 0;
        assert(carry === 0);
        assert((carry & -8192) === 0);
    };
    FFTM.prototype.stub = function stub(N) {
        var ph = new Array(N);
        for(var i = 0; i < N; i++)ph[i] = 0;
        return ph;
    };
    FFTM.prototype.mulp = function mulp(x, y, out) {
        var N = 2 * this.guessLen13b(x.length, y.length);
        var rbt = this.makeRBT(N);
        var _ = this.stub(N);
        var rws = new Array(N);
        var rwst = new Array(N);
        var iwst = new Array(N);
        var nrws = new Array(N);
        var nrwst = new Array(N);
        var niwst = new Array(N);
        var rmws = out.words;
        rmws.length = N;
        this.convert13b(x.words, x.length, rws, N);
        this.convert13b(y.words, y.length, nrws, N);
        this.transform(rws, _, rwst, iwst, N, rbt);
        this.transform(nrws, _, nrwst, niwst, N, rbt);
        for(var i = 0; i < N; i++){
            var rx = rwst[i] * nrwst[i] - iwst[i] * niwst[i];
            iwst[i] = rwst[i] * niwst[i] + iwst[i] * nrwst[i];
            rwst[i] = rx;
        }
        this.conjugate(rwst, iwst, N);
        this.transform(rwst, iwst, rmws, _, N, rbt);
        this.conjugate(rmws, _, N);
        this.normalize13b(rmws, N);
        out.negative = x.negative ^ y.negative;
        out.length = x.length + y.length;
        return out._strip();
    };
    // Multiply `this` by `num`
    BN.prototype.mul = function mul(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return this.mulTo(num, out);
    };
    // Multiply employing FFT
    BN.prototype.mulf = function mulf(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return jumboMulTo(this, num, out);
    };
    // In-place Multiplication
    BN.prototype.imul = function imul(num) {
        return this.clone().mulTo(num, this);
    };
    BN.prototype.imuln = function imuln(num) {
        var isNegNum = num < 0;
        if (isNegNum) num = -num;
        assert(typeof num === "number");
        assert(num < 0x4000000);
        // Carry
        var carry = 0;
        for(var i = 0; i < this.length; i++){
            var w = (this.words[i] | 0) * num;
            var lo = (w & 0x3ffffff) + (carry & 0x3ffffff);
            carry >>= 26;
            carry += w / 0x4000000 | 0;
            // NOTE: lo is 27bit maximum
            carry += lo >>> 26;
            this.words[i] = lo & 0x3ffffff;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return isNegNum ? this.ineg() : this;
    };
    BN.prototype.muln = function muln(num) {
        return this.clone().imuln(num);
    };
    // `this` * `this`
    BN.prototype.sqr = function sqr() {
        return this.mul(this);
    };
    // `this` * `this` in-place
    BN.prototype.isqr = function isqr() {
        return this.imul(this.clone());
    };
    // Math.pow(`this`, `num`)
    BN.prototype.pow = function pow(num) {
        var w = toBitArray(num);
        if (w.length === 0) return new BN(1);
        // Skip leading zeroes
        var res = this;
        for(var i = 0; i < w.length; i++, res = res.sqr()){
            if (w[i] !== 0) break;
        }
        if (++i < w.length) for(var q = res.sqr(); i < w.length; i++, q = q.sqr()){
            if (w[i] === 0) continue;
            res = res.mul(q);
        }
        return res;
    };
    // Shift-left in-place
    BN.prototype.iushln = function iushln(bits) {
        assert(typeof bits === "number" && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        var carryMask = 0x3ffffff >>> 26 - r << 26 - r;
        var i;
        if (r !== 0) {
            var carry = 0;
            for(i = 0; i < this.length; i++){
                var newCarry = this.words[i] & carryMask;
                var c = (this.words[i] | 0) - newCarry << r;
                this.words[i] = c | carry;
                carry = newCarry >>> 26 - r;
            }
            if (carry) {
                this.words[i] = carry;
                this.length++;
            }
        }
        if (s !== 0) {
            for(i = this.length - 1; i >= 0; i--)this.words[i + s] = this.words[i];
            for(i = 0; i < s; i++)this.words[i] = 0;
            this.length += s;
        }
        return this._strip();
    };
    BN.prototype.ishln = function ishln(bits) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushln(bits);
    };
    // Shift-right in-place
    // NOTE: `hint` is a lowest bit before trailing zeroes
    // NOTE: if `extended` is present - it will be filled with destroyed bits
    BN.prototype.iushrn = function iushrn(bits, hint, extended) {
        assert(typeof bits === "number" && bits >= 0);
        var h;
        if (hint) h = (hint - hint % 26) / 26;
        else h = 0;
        var r = bits % 26;
        var s = Math.min((bits - r) / 26, this.length);
        var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
        var maskedWords = extended;
        h -= s;
        h = Math.max(0, h);
        // Extended mode, copy masked part
        if (maskedWords) {
            for(var i = 0; i < s; i++)maskedWords.words[i] = this.words[i];
            maskedWords.length = s;
        }
        if (s === 0) ;
        else if (this.length > s) {
            this.length -= s;
            for(i = 0; i < this.length; i++)this.words[i] = this.words[i + s];
        } else {
            this.words[0] = 0;
            this.length = 1;
        }
        var carry = 0;
        for(i = this.length - 1; i >= 0 && (carry !== 0 || i >= h); i--){
            var word = this.words[i] | 0;
            this.words[i] = carry << 26 - r | word >>> r;
            carry = word & mask;
        }
        // Push carried bits as a mask
        if (maskedWords && carry !== 0) maskedWords.words[maskedWords.length++] = carry;
        if (this.length === 0) {
            this.words[0] = 0;
            this.length = 1;
        }
        return this._strip();
    };
    BN.prototype.ishrn = function ishrn(bits, hint, extended) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushrn(bits, hint, extended);
    };
    // Shift-left
    BN.prototype.shln = function shln(bits) {
        return this.clone().ishln(bits);
    };
    BN.prototype.ushln = function ushln(bits) {
        return this.clone().iushln(bits);
    };
    // Shift-right
    BN.prototype.shrn = function shrn(bits) {
        return this.clone().ishrn(bits);
    };
    BN.prototype.ushrn = function ushrn(bits) {
        return this.clone().iushrn(bits);
    };
    // Test if n bit is set
    BN.prototype.testn = function testn(bit) {
        assert(typeof bit === "number" && bit >= 0);
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) return false;
        // Check bit and return
        var w = this.words[s];
        return !!(w & q);
    };
    // Return only lowers bits of number (in-place)
    BN.prototype.imaskn = function imaskn(bits) {
        assert(typeof bits === "number" && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        assert(this.negative === 0, "imaskn works only with positive numbers");
        if (this.length <= s) return this;
        if (r !== 0) s++;
        this.length = Math.min(s, this.length);
        if (r !== 0) {
            var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
            this.words[this.length - 1] &= mask;
        }
        return this._strip();
    };
    // Return only lowers bits of number
    BN.prototype.maskn = function maskn(bits) {
        return this.clone().imaskn(bits);
    };
    // Add plain number `num` to `this`
    BN.prototype.iaddn = function iaddn(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        if (num < 0) return this.isubn(-num);
        // Possible sign change
        if (this.negative !== 0) {
            if (this.length === 1 && (this.words[0] | 0) <= num) {
                this.words[0] = num - (this.words[0] | 0);
                this.negative = 0;
                return this;
            }
            this.negative = 0;
            this.isubn(num);
            this.negative = 1;
            return this;
        }
        // Add without checks
        return this._iaddn(num);
    };
    BN.prototype._iaddn = function _iaddn(num) {
        this.words[0] += num;
        // Carry
        for(var i = 0; i < this.length && this.words[i] >= 0x4000000; i++){
            this.words[i] -= 0x4000000;
            if (i === this.length - 1) this.words[i + 1] = 1;
            else this.words[i + 1]++;
        }
        this.length = Math.max(this.length, i + 1);
        return this;
    };
    // Subtract plain number `num` from `this`
    BN.prototype.isubn = function isubn(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        if (num < 0) return this.iaddn(-num);
        if (this.negative !== 0) {
            this.negative = 0;
            this.iaddn(num);
            this.negative = 1;
            return this;
        }
        this.words[0] -= num;
        if (this.length === 1 && this.words[0] < 0) {
            this.words[0] = -this.words[0];
            this.negative = 1;
        } else // Carry
        for(var i = 0; i < this.length && this.words[i] < 0; i++){
            this.words[i] += 0x4000000;
            this.words[i + 1] -= 1;
        }
        return this._strip();
    };
    BN.prototype.addn = function addn(num) {
        return this.clone().iaddn(num);
    };
    BN.prototype.subn = function subn(num) {
        return this.clone().isubn(num);
    };
    BN.prototype.iabs = function iabs() {
        this.negative = 0;
        return this;
    };
    BN.prototype.abs = function abs() {
        return this.clone().iabs();
    };
    BN.prototype._ishlnsubmul = function _ishlnsubmul(num, mul, shift) {
        var len = num.length + shift;
        var i;
        this._expand(len);
        var w;
        var carry = 0;
        for(i = 0; i < num.length; i++){
            w = (this.words[i + shift] | 0) + carry;
            var right = (num.words[i] | 0) * mul;
            w -= right & 0x3ffffff;
            carry = (w >> 26) - (right / 0x4000000 | 0);
            this.words[i + shift] = w & 0x3ffffff;
        }
        for(; i < this.length - shift; i++){
            w = (this.words[i + shift] | 0) + carry;
            carry = w >> 26;
            this.words[i + shift] = w & 0x3ffffff;
        }
        if (carry === 0) return this._strip();
        // Subtraction overflow
        assert(carry === -1);
        carry = 0;
        for(i = 0; i < this.length; i++){
            w = -(this.words[i] | 0) + carry;
            carry = w >> 26;
            this.words[i] = w & 0x3ffffff;
        }
        this.negative = 1;
        return this._strip();
    };
    BN.prototype._wordDiv = function _wordDiv(num, mode) {
        var shift = this.length - num.length;
        var a = this.clone();
        var b = num;
        // Normalize
        var bhi = b.words[b.length - 1] | 0;
        var bhiBits = this._countBits(bhi);
        shift = 26 - bhiBits;
        if (shift !== 0) {
            b = b.ushln(shift);
            a.iushln(shift);
            bhi = b.words[b.length - 1] | 0;
        }
        // Initialize quotient
        var m = a.length - b.length;
        var q;
        if (mode !== "mod") {
            q = new BN(null);
            q.length = m + 1;
            q.words = new Array(q.length);
            for(var i = 0; i < q.length; i++)q.words[i] = 0;
        }
        var diff = a.clone()._ishlnsubmul(b, 1, m);
        if (diff.negative === 0) {
            a = diff;
            if (q) q.words[m] = 1;
        }
        for(var j = m - 1; j >= 0; j--){
            var qj = (a.words[b.length + j] | 0) * 0x4000000 + (a.words[b.length + j - 1] | 0);
            // NOTE: (qj / bhi) is (0x3ffffff * 0x4000000 + 0x3ffffff) / 0x2000000 max
            // (0x7ffffff)
            qj = Math.min(qj / bhi | 0, 0x3ffffff);
            a._ishlnsubmul(b, qj, j);
            while(a.negative !== 0){
                qj--;
                a.negative = 0;
                a._ishlnsubmul(b, 1, j);
                if (!a.isZero()) a.negative ^= 1;
            }
            if (q) q.words[j] = qj;
        }
        if (q) q._strip();
        a._strip();
        // Denormalize
        if (mode !== "div" && shift !== 0) a.iushrn(shift);
        return {
            div: q || null,
            mod: a
        };
    };
    // NOTE: 1) `mode` can be set to `mod` to request mod only,
    //       to `div` to request div only, or be absent to
    //       request both div & mod
    //       2) `positive` is true if unsigned mod is requested
    BN.prototype.divmod = function divmod(num, mode, positive) {
        assert(!num.isZero());
        if (this.isZero()) return {
            div: new BN(0),
            mod: new BN(0)
        };
        var div, mod, res;
        if (this.negative !== 0 && num.negative === 0) {
            res = this.neg().divmod(num, mode);
            if (mode !== "mod") div = res.div.neg();
            if (mode !== "div") {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.iadd(num);
            }
            return {
                div: div,
                mod: mod
            };
        }
        if (this.negative === 0 && num.negative !== 0) {
            res = this.divmod(num.neg(), mode);
            if (mode !== "mod") div = res.div.neg();
            return {
                div: div,
                mod: res.mod
            };
        }
        if ((this.negative & num.negative) !== 0) {
            res = this.neg().divmod(num.neg(), mode);
            if (mode !== "div") {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.isub(num);
            }
            return {
                div: res.div,
                mod: mod
            };
        }
        // Both numbers are positive at this point
        // Strip both numbers to approximate shift value
        if (num.length > this.length || this.cmp(num) < 0) return {
            div: new BN(0),
            mod: this
        };
        // Very short reduction
        if (num.length === 1) {
            if (mode === "div") return {
                div: this.divn(num.words[0]),
                mod: null
            };
            if (mode === "mod") return {
                div: null,
                mod: new BN(this.modrn(num.words[0]))
            };
            return {
                div: this.divn(num.words[0]),
                mod: new BN(this.modrn(num.words[0]))
            };
        }
        return this._wordDiv(num, mode);
    };
    // Find `this` / `num`
    BN.prototype.div = function div(num) {
        return this.divmod(num, "div", false).div;
    };
    // Find `this` % `num`
    BN.prototype.mod = function mod(num) {
        return this.divmod(num, "mod", false).mod;
    };
    BN.prototype.umod = function umod(num) {
        return this.divmod(num, "mod", true).mod;
    };
    // Find Round(`this` / `num`)
    BN.prototype.divRound = function divRound(num) {
        var dm = this.divmod(num);
        // Fast case - exact division
        if (dm.mod.isZero()) return dm.div;
        var mod = dm.div.negative !== 0 ? dm.mod.isub(num) : dm.mod;
        var half = num.ushrn(1);
        var r2 = num.andln(1);
        var cmp = mod.cmp(half);
        // Round down
        if (cmp < 0 || r2 === 1 && cmp === 0) return dm.div;
        // Round up
        return dm.div.negative !== 0 ? dm.div.isubn(1) : dm.div.iaddn(1);
    };
    BN.prototype.modrn = function modrn(num) {
        var isNegNum = num < 0;
        if (isNegNum) num = -num;
        assert(num <= 0x3ffffff);
        var p = 67108864 % num;
        var acc = 0;
        for(var i = this.length - 1; i >= 0; i--)acc = (p * acc + (this.words[i] | 0)) % num;
        return isNegNum ? -acc : acc;
    };
    // WARNING: DEPRECATED
    BN.prototype.modn = function modn(num) {
        return this.modrn(num);
    };
    // In-place division by number
    BN.prototype.idivn = function idivn(num) {
        var isNegNum = num < 0;
        if (isNegNum) num = -num;
        assert(num <= 0x3ffffff);
        var carry = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var w = (this.words[i] | 0) + carry * 0x4000000;
            this.words[i] = w / num | 0;
            carry = w % num;
        }
        this._strip();
        return isNegNum ? this.ineg() : this;
    };
    BN.prototype.divn = function divn(num) {
        return this.clone().idivn(num);
    };
    BN.prototype.egcd = function egcd(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var x = this;
        var y = p.clone();
        if (x.negative !== 0) x = x.umod(p);
        else x = x.clone();
        // A * x + B * y = x
        var A = new BN(1);
        var B = new BN(0);
        // C * x + D * y = y
        var C = new BN(0);
        var D = new BN(1);
        var g = 0;
        while(x.isEven() && y.isEven()){
            x.iushrn(1);
            y.iushrn(1);
            ++g;
        }
        var yp = y.clone();
        var xp = x.clone();
        while(!x.isZero()){
            for(var i = 0, im = 1; (x.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                x.iushrn(i);
                while(i-- > 0){
                    if (A.isOdd() || B.isOdd()) {
                        A.iadd(yp);
                        B.isub(xp);
                    }
                    A.iushrn(1);
                    B.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (y.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                y.iushrn(j);
                while(j-- > 0){
                    if (C.isOdd() || D.isOdd()) {
                        C.iadd(yp);
                        D.isub(xp);
                    }
                    C.iushrn(1);
                    D.iushrn(1);
                }
            }
            if (x.cmp(y) >= 0) {
                x.isub(y);
                A.isub(C);
                B.isub(D);
            } else {
                y.isub(x);
                C.isub(A);
                D.isub(B);
            }
        }
        return {
            a: C,
            b: D,
            gcd: y.iushln(g)
        };
    };
    // This is reduced incarnation of the binary EEA
    // above, designated to invert members of the
    // _prime_ fields F(p) at a maximal speed
    BN.prototype._invmp = function _invmp(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var a = this;
        var b = p.clone();
        if (a.negative !== 0) a = a.umod(p);
        else a = a.clone();
        var x1 = new BN(1);
        var x2 = new BN(0);
        var delta = b.clone();
        while(a.cmpn(1) > 0 && b.cmpn(1) > 0){
            for(var i = 0, im = 1; (a.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                a.iushrn(i);
                while(i-- > 0){
                    if (x1.isOdd()) x1.iadd(delta);
                    x1.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (b.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                b.iushrn(j);
                while(j-- > 0){
                    if (x2.isOdd()) x2.iadd(delta);
                    x2.iushrn(1);
                }
            }
            if (a.cmp(b) >= 0) {
                a.isub(b);
                x1.isub(x2);
            } else {
                b.isub(a);
                x2.isub(x1);
            }
        }
        var res;
        if (a.cmpn(1) === 0) res = x1;
        else res = x2;
        if (res.cmpn(0) < 0) res.iadd(p);
        return res;
    };
    BN.prototype.gcd = function gcd(num) {
        if (this.isZero()) return num.abs();
        if (num.isZero()) return this.abs();
        var a = this.clone();
        var b = num.clone();
        a.negative = 0;
        b.negative = 0;
        // Remove common factor of two
        for(var shift = 0; a.isEven() && b.isEven(); shift++){
            a.iushrn(1);
            b.iushrn(1);
        }
        do {
            while(a.isEven())a.iushrn(1);
            while(b.isEven())b.iushrn(1);
            var r = a.cmp(b);
            if (r < 0) {
                // Swap `a` and `b` to make `a` always bigger than `b`
                var t = a;
                a = b;
                b = t;
            } else if (r === 0 || b.cmpn(1) === 0) break;
            a.isub(b);
        }while (true);
        return b.iushln(shift);
    };
    // Invert number in the field F(num)
    BN.prototype.invm = function invm(num) {
        return this.egcd(num).a.umod(num);
    };
    BN.prototype.isEven = function isEven() {
        return (this.words[0] & 1) === 0;
    };
    BN.prototype.isOdd = function isOdd() {
        return (this.words[0] & 1) === 1;
    };
    // And first word and num
    BN.prototype.andln = function andln(num) {
        return this.words[0] & num;
    };
    // Increment at the bit position in-line
    BN.prototype.bincn = function bincn(bit) {
        assert(typeof bit === "number");
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) {
            this._expand(s + 1);
            this.words[s] |= q;
            return this;
        }
        // Add bit and propagate, if needed
        var carry = q;
        for(var i = s; carry !== 0 && i < this.length; i++){
            var w = this.words[i] | 0;
            w += carry;
            carry = w >>> 26;
            w &= 0x3ffffff;
            this.words[i] = w;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return this;
    };
    BN.prototype.isZero = function isZero() {
        return this.length === 1 && this.words[0] === 0;
    };
    BN.prototype.cmpn = function cmpn(num) {
        var negative = num < 0;
        if (this.negative !== 0 && !negative) return -1;
        if (this.negative === 0 && negative) return 1;
        this._strip();
        var res;
        if (this.length > 1) res = 1;
        else {
            if (negative) num = -num;
            assert(num <= 0x3ffffff, "Number is too big");
            var w = this.words[0] | 0;
            res = w === num ? 0 : w < num ? -1 : 1;
        }
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Compare two numbers and return:
    // 1 - if `this` > `num`
    // 0 - if `this` == `num`
    // -1 - if `this` < `num`
    BN.prototype.cmp = function cmp(num) {
        if (this.negative !== 0 && num.negative === 0) return -1;
        if (this.negative === 0 && num.negative !== 0) return 1;
        var res = this.ucmp(num);
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Unsigned comparison
    BN.prototype.ucmp = function ucmp(num) {
        // At this point both numbers have the same sign
        if (this.length > num.length) return 1;
        if (this.length < num.length) return -1;
        var res = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var a = this.words[i] | 0;
            var b = num.words[i] | 0;
            if (a === b) continue;
            if (a < b) res = -1;
            else if (a > b) res = 1;
            break;
        }
        return res;
    };
    BN.prototype.gtn = function gtn(num) {
        return this.cmpn(num) === 1;
    };
    BN.prototype.gt = function gt(num) {
        return this.cmp(num) === 1;
    };
    BN.prototype.gten = function gten(num) {
        return this.cmpn(num) >= 0;
    };
    BN.prototype.gte = function gte(num) {
        return this.cmp(num) >= 0;
    };
    BN.prototype.ltn = function ltn(num) {
        return this.cmpn(num) === -1;
    };
    BN.prototype.lt = function lt(num) {
        return this.cmp(num) === -1;
    };
    BN.prototype.lten = function lten(num) {
        return this.cmpn(num) <= 0;
    };
    BN.prototype.lte = function lte(num) {
        return this.cmp(num) <= 0;
    };
    BN.prototype.eqn = function eqn(num) {
        return this.cmpn(num) === 0;
    };
    BN.prototype.eq = function eq(num) {
        return this.cmp(num) === 0;
    };
    //
    // A reduce context, could be using montgomery or something better, depending
    // on the `m` itself.
    //
    BN.red = function red(num) {
        return new Red(num);
    };
    BN.prototype.toRed = function toRed(ctx) {
        assert(!this.red, "Already a number in reduction context");
        assert(this.negative === 0, "red works only with positives");
        return ctx.convertTo(this)._forceRed(ctx);
    };
    BN.prototype.fromRed = function fromRed() {
        assert(this.red, "fromRed works only with numbers in reduction context");
        return this.red.convertFrom(this);
    };
    BN.prototype._forceRed = function _forceRed(ctx) {
        this.red = ctx;
        return this;
    };
    BN.prototype.forceRed = function forceRed(ctx) {
        assert(!this.red, "Already a number in reduction context");
        return this._forceRed(ctx);
    };
    BN.prototype.redAdd = function redAdd(num) {
        assert(this.red, "redAdd works only with red numbers");
        return this.red.add(this, num);
    };
    BN.prototype.redIAdd = function redIAdd(num) {
        assert(this.red, "redIAdd works only with red numbers");
        return this.red.iadd(this, num);
    };
    BN.prototype.redSub = function redSub(num) {
        assert(this.red, "redSub works only with red numbers");
        return this.red.sub(this, num);
    };
    BN.prototype.redISub = function redISub(num) {
        assert(this.red, "redISub works only with red numbers");
        return this.red.isub(this, num);
    };
    BN.prototype.redShl = function redShl(num) {
        assert(this.red, "redShl works only with red numbers");
        return this.red.shl(this, num);
    };
    BN.prototype.redMul = function redMul(num) {
        assert(this.red, "redMul works only with red numbers");
        this.red._verify2(this, num);
        return this.red.mul(this, num);
    };
    BN.prototype.redIMul = function redIMul(num) {
        assert(this.red, "redMul works only with red numbers");
        this.red._verify2(this, num);
        return this.red.imul(this, num);
    };
    BN.prototype.redSqr = function redSqr() {
        assert(this.red, "redSqr works only with red numbers");
        this.red._verify1(this);
        return this.red.sqr(this);
    };
    BN.prototype.redISqr = function redISqr() {
        assert(this.red, "redISqr works only with red numbers");
        this.red._verify1(this);
        return this.red.isqr(this);
    };
    // Square root over p
    BN.prototype.redSqrt = function redSqrt() {
        assert(this.red, "redSqrt works only with red numbers");
        this.red._verify1(this);
        return this.red.sqrt(this);
    };
    BN.prototype.redInvm = function redInvm() {
        assert(this.red, "redInvm works only with red numbers");
        this.red._verify1(this);
        return this.red.invm(this);
    };
    // Return negative clone of `this` % `red modulo`
    BN.prototype.redNeg = function redNeg() {
        assert(this.red, "redNeg works only with red numbers");
        this.red._verify1(this);
        return this.red.neg(this);
    };
    BN.prototype.redPow = function redPow(num) {
        assert(this.red && !num.red, "redPow(normalNum)");
        this.red._verify1(this);
        return this.red.pow(this, num);
    };
    // Prime numbers with efficient reduction
    var primes = {
        k256: null,
        p224: null,
        p192: null,
        p25519: null
    };
    // Pseudo-Mersenne prime
    function MPrime(name, p) {
        // P = 2 ^ N - K
        this.name = name;
        this.p = new BN(p, 16);
        this.n = this.p.bitLength();
        this.k = new BN(1).iushln(this.n).isub(this.p);
        this.tmp = this._tmp();
    }
    MPrime.prototype._tmp = function _tmp() {
        var tmp = new BN(null);
        tmp.words = new Array(Math.ceil(this.n / 13));
        return tmp;
    };
    MPrime.prototype.ireduce = function ireduce(num) {
        // Assumes that `num` is less than `P^2`
        // num = HI * (2 ^ N - K) + HI * K + LO = HI * K + LO (mod P)
        var r = num;
        var rlen;
        do {
            this.split(r, this.tmp);
            r = this.imulK(r);
            r = r.iadd(this.tmp);
            rlen = r.bitLength();
        }while (rlen > this.n);
        var cmp = rlen < this.n ? -1 : r.ucmp(this.p);
        if (cmp === 0) {
            r.words[0] = 0;
            r.length = 1;
        } else if (cmp > 0) r.isub(this.p);
        else if (r.strip !== undefined) // r is a BN v4 instance
        r.strip();
        else // r is a BN v5 instance
        r._strip();
        return r;
    };
    MPrime.prototype.split = function split(input, out) {
        input.iushrn(this.n, 0, out);
    };
    MPrime.prototype.imulK = function imulK(num) {
        return num.imul(this.k);
    };
    function K256() {
        MPrime.call(this, "k256", "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f");
    }
    inherits(K256, MPrime);
    K256.prototype.split = function split(input, output) {
        // 256 = 9 * 26 + 22
        var mask = 0x3fffff;
        var outLen = Math.min(input.length, 9);
        for(var i = 0; i < outLen; i++)output.words[i] = input.words[i];
        output.length = outLen;
        if (input.length <= 9) {
            input.words[0] = 0;
            input.length = 1;
            return;
        }
        // Shift by 9 limbs
        var prev = input.words[9];
        output.words[output.length++] = prev & mask;
        for(i = 10; i < input.length; i++){
            var next = input.words[i] | 0;
            input.words[i - 10] = (next & mask) << 4 | prev >>> 22;
            prev = next;
        }
        prev >>>= 22;
        input.words[i - 10] = prev;
        if (prev === 0 && input.length > 10) input.length -= 10;
        else input.length -= 9;
    };
    K256.prototype.imulK = function imulK(num) {
        // K = 0x1000003d1 = [ 0x40, 0x3d1 ]
        num.words[num.length] = 0;
        num.words[num.length + 1] = 0;
        num.length += 2;
        // bounded at: 0x40 * 0x3ffffff + 0x3d0 = 0x100000390
        var lo = 0;
        for(var i = 0; i < num.length; i++){
            var w = num.words[i] | 0;
            lo += w * 0x3d1;
            num.words[i] = lo & 0x3ffffff;
            lo = w * 0x40 + (lo / 0x4000000 | 0);
        }
        // Fast length reduction
        if (num.words[num.length - 1] === 0) {
            num.length--;
            if (num.words[num.length - 1] === 0) num.length--;
        }
        return num;
    };
    function P224() {
        MPrime.call(this, "p224", "ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001");
    }
    inherits(P224, MPrime);
    function P192() {
        MPrime.call(this, "p192", "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff");
    }
    inherits(P192, MPrime);
    function P25519() {
        // 2 ^ 255 - 19
        MPrime.call(this, "25519", "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed");
    }
    inherits(P25519, MPrime);
    P25519.prototype.imulK = function imulK(num) {
        // K = 0x13
        var carry = 0;
        for(var i = 0; i < num.length; i++){
            var hi = (num.words[i] | 0) * 0x13 + carry;
            var lo = hi & 0x3ffffff;
            hi >>>= 26;
            num.words[i] = lo;
            carry = hi;
        }
        if (carry !== 0) num.words[num.length++] = carry;
        return num;
    };
    // Exported mostly for testing purposes, use plain name instead
    BN._prime = function prime(name) {
        // Cached version of prime
        if (primes[name]) return primes[name];
        var prime;
        if (name === "k256") prime = new K256();
        else if (name === "p224") prime = new P224();
        else if (name === "p192") prime = new P192();
        else if (name === "p25519") prime = new P25519();
        else throw new Error("Unknown prime " + name);
        primes[name] = prime;
        return prime;
    };
    //
    // Base reduction engine
    //
    function Red(m) {
        if (typeof m === "string") {
            var prime = BN._prime(m);
            this.m = prime.p;
            this.prime = prime;
        } else {
            assert(m.gtn(1), "modulus must be greater than 1");
            this.m = m;
            this.prime = null;
        }
    }
    Red.prototype._verify1 = function _verify1(a) {
        assert(a.negative === 0, "red works only with positives");
        assert(a.red, "red works only with red numbers");
    };
    Red.prototype._verify2 = function _verify2(a, b) {
        assert((a.negative | b.negative) === 0, "red works only with positives");
        assert(a.red && a.red === b.red, "red works only with red numbers");
    };
    Red.prototype.imod = function imod(a) {
        if (this.prime) return this.prime.ireduce(a)._forceRed(this);
        move(a, a.umod(this.m)._forceRed(this));
        return a;
    };
    Red.prototype.neg = function neg(a) {
        if (a.isZero()) return a.clone();
        return this.m.sub(a)._forceRed(this);
    };
    Red.prototype.add = function add(a, b) {
        this._verify2(a, b);
        var res = a.add(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res._forceRed(this);
    };
    Red.prototype.iadd = function iadd(a, b) {
        this._verify2(a, b);
        var res = a.iadd(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res;
    };
    Red.prototype.sub = function sub(a, b) {
        this._verify2(a, b);
        var res = a.sub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res._forceRed(this);
    };
    Red.prototype.isub = function isub(a, b) {
        this._verify2(a, b);
        var res = a.isub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res;
    };
    Red.prototype.shl = function shl(a, num) {
        this._verify1(a);
        return this.imod(a.ushln(num));
    };
    Red.prototype.imul = function imul(a, b) {
        this._verify2(a, b);
        return this.imod(a.imul(b));
    };
    Red.prototype.mul = function mul(a, b) {
        this._verify2(a, b);
        return this.imod(a.mul(b));
    };
    Red.prototype.isqr = function isqr(a) {
        return this.imul(a, a.clone());
    };
    Red.prototype.sqr = function sqr(a) {
        return this.mul(a, a);
    };
    Red.prototype.sqrt = function sqrt(a) {
        if (a.isZero()) return a.clone();
        var mod3 = this.m.andln(3);
        assert(mod3 % 2 === 1);
        // Fast case
        if (mod3 === 3) {
            var pow = this.m.add(new BN(1)).iushrn(2);
            return this.pow(a, pow);
        }
        // Tonelli-Shanks algorithm (Totally unoptimized and slow)
        //
        // Find Q and S, that Q * 2 ^ S = (P - 1)
        var q = this.m.subn(1);
        var s = 0;
        while(!q.isZero() && q.andln(1) === 0){
            s++;
            q.iushrn(1);
        }
        assert(!q.isZero());
        var one = new BN(1).toRed(this);
        var nOne = one.redNeg();
        // Find quadratic non-residue
        // NOTE: Max is such because of generalized Riemann hypothesis.
        var lpow = this.m.subn(1).iushrn(1);
        var z = this.m.bitLength();
        z = new BN(2 * z * z).toRed(this);
        while(this.pow(z, lpow).cmp(nOne) !== 0)z.redIAdd(nOne);
        var c = this.pow(z, q);
        var r = this.pow(a, q.addn(1).iushrn(1));
        var t = this.pow(a, q);
        var m = s;
        while(t.cmp(one) !== 0){
            var tmp = t;
            for(var i = 0; tmp.cmp(one) !== 0; i++)tmp = tmp.redSqr();
            assert(i < m);
            var b = this.pow(c, new BN(1).iushln(m - i - 1));
            r = r.redMul(b);
            c = b.redSqr();
            t = t.redMul(c);
            m = i;
        }
        return r;
    };
    Red.prototype.invm = function invm(a) {
        var inv = a._invmp(this.m);
        if (inv.negative !== 0) {
            inv.negative = 0;
            return this.imod(inv).redNeg();
        } else return this.imod(inv);
    };
    Red.prototype.pow = function pow(a, num) {
        if (num.isZero()) return new BN(1).toRed(this);
        if (num.cmpn(1) === 0) return a.clone();
        var windowSize = 4;
        var wnd = new Array(1 << windowSize);
        wnd[0] = new BN(1).toRed(this);
        wnd[1] = a;
        for(var i = 2; i < wnd.length; i++)wnd[i] = this.mul(wnd[i - 1], a);
        var res = wnd[0];
        var current = 0;
        var currentLen = 0;
        var start = num.bitLength() % 26;
        if (start === 0) start = 26;
        for(i = num.length - 1; i >= 0; i--){
            var word = num.words[i];
            for(var j = start - 1; j >= 0; j--){
                var bit = word >> j & 1;
                if (res !== wnd[0]) res = this.sqr(res);
                if (bit === 0 && current === 0) {
                    currentLen = 0;
                    continue;
                }
                current <<= 1;
                current |= bit;
                currentLen++;
                if (currentLen !== windowSize && (i !== 0 || j !== 0)) continue;
                res = this.mul(res, wnd[current]);
                currentLen = 0;
                current = 0;
            }
            start = 26;
        }
        return res;
    };
    Red.prototype.convertTo = function convertTo(num) {
        var r = num.umod(this.m);
        return r === num ? r.clone() : r;
    };
    Red.prototype.convertFrom = function convertFrom(num) {
        var res = num.clone();
        res.red = null;
        return res;
    };
    //
    // Montgomery method engine
    //
    BN.mont = function mont(num) {
        return new Mont(num);
    };
    function Mont(m) {
        Red.call(this, m);
        this.shift = this.m.bitLength();
        if (this.shift % 26 !== 0) this.shift += 26 - this.shift % 26;
        this.r = new BN(1).iushln(this.shift);
        this.r2 = this.imod(this.r.sqr());
        this.rinv = this.r._invmp(this.m);
        this.minv = this.rinv.mul(this.r).isubn(1).div(this.m);
        this.minv = this.minv.umod(this.r);
        this.minv = this.r.sub(this.minv);
    }
    inherits(Mont, Red);
    Mont.prototype.convertTo = function convertTo(num) {
        return this.imod(num.ushln(this.shift));
    };
    Mont.prototype.convertFrom = function convertFrom(num) {
        var r = this.imod(num.mul(this.rinv));
        r.red = null;
        return r;
    };
    Mont.prototype.imul = function imul(a, b) {
        if (a.isZero() || b.isZero()) {
            a.words[0] = 0;
            a.length = 1;
            return a;
        }
        var t = a.imul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.mul = function mul(a, b) {
        if (a.isZero() || b.isZero()) return new BN(0)._forceRed(this);
        var t = a.mul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.invm = function invm(a) {
        // (AR)^-1 * R^2 = (A^-1 * R^-1) * R^2 = A^-1 * R
        var res = this.imod(a._invmp(this.m).mul(this.r2));
        return res._forceRed(this);
    };
})(module, this);

});
parcelRequire.register("5Io6y", function(module, exports) {
"use strict";

});


parcelRequire.register("baOVG", function(module, exports) {

var $4TNnu = parcelRequire("4TNnu");
/**
 * [js-sha3]{@link https://github.com/emn178/js-sha3}
 *
 * @version 0.8.0
 * @author Chen, Yi-Cyuan [emn178@gmail.com]
 * @copyright Chen, Yi-Cyuan 2015-2018
 * @license MIT
 */ /*jslint bitwise: true */ (function() {
    "use strict";
    var INPUT_ERROR = "input is invalid type";
    var FINALIZE_ERROR = "finalize already called";
    var WINDOW = typeof window === "object";
    var root = WINDOW ? window : {};
    if (root.JS_SHA3_NO_WINDOW) WINDOW = false;
    var WEB_WORKER = !WINDOW && typeof self === "object";
    var NODE_JS = !root.JS_SHA3_NO_NODE_JS && typeof $4TNnu === "object" && $4TNnu.versions && $4TNnu.versions.node;
    if (NODE_JS) root = $parcel$global;
    else if (WEB_WORKER) root = self;
    var COMMON_JS = !root.JS_SHA3_NO_COMMON_JS && true && module.exports;
    var AMD = typeof define === "function" && define.amd;
    var ARRAY_BUFFER = !root.JS_SHA3_NO_ARRAY_BUFFER && typeof ArrayBuffer !== "undefined";
    var HEX_CHARS = "0123456789abcdef".split("");
    var SHAKE_PADDING = [
        31,
        7936,
        2031616,
        520093696
    ];
    var CSHAKE_PADDING = [
        4,
        1024,
        262144,
        67108864
    ];
    var KECCAK_PADDING = [
        1,
        256,
        65536,
        16777216
    ];
    var PADDING = [
        6,
        1536,
        393216,
        100663296
    ];
    var SHIFT = [
        0,
        8,
        16,
        24
    ];
    var RC = [
        1,
        0,
        32898,
        0,
        32906,
        2147483648,
        2147516416,
        2147483648,
        32907,
        0,
        2147483649,
        0,
        2147516545,
        2147483648,
        32777,
        2147483648,
        138,
        0,
        136,
        0,
        2147516425,
        0,
        2147483658,
        0,
        2147516555,
        0,
        139,
        2147483648,
        32905,
        2147483648,
        32771,
        2147483648,
        32770,
        2147483648,
        128,
        2147483648,
        32778,
        0,
        2147483658,
        2147483648,
        2147516545,
        2147483648,
        32896,
        2147483648,
        2147483649,
        0,
        2147516424,
        2147483648
    ];
    var BITS = [
        224,
        256,
        384,
        512
    ];
    var SHAKE_BITS = [
        128,
        256
    ];
    var OUTPUT_TYPES = [
        "hex",
        "buffer",
        "arrayBuffer",
        "array",
        "digest"
    ];
    var CSHAKE_BYTEPAD = {
        "128": 168,
        "256": 136
    };
    if (root.JS_SHA3_NO_NODE_JS || !Array.isArray) Array.isArray = function(obj) {
        return Object.prototype.toString.call(obj) === "[object Array]";
    };
    if (ARRAY_BUFFER && (root.JS_SHA3_NO_ARRAY_BUFFER_IS_VIEW || !ArrayBuffer.isView)) ArrayBuffer.isView = function(obj) {
        return typeof obj === "object" && obj.buffer && obj.buffer.constructor === ArrayBuffer;
    };
    var createOutputMethod = function(bits, padding, outputType) {
        return function(message) {
            return new Keccak(bits, padding, bits).update(message)[outputType]();
        };
    };
    var createShakeOutputMethod = function(bits, padding, outputType) {
        return function(message, outputBits) {
            return new Keccak(bits, padding, outputBits).update(message)[outputType]();
        };
    };
    var createCshakeOutputMethod = function(bits, padding, outputType) {
        return function(message, outputBits, n, s) {
            return methods["cshake" + bits].update(message, outputBits, n, s)[outputType]();
        };
    };
    var createKmacOutputMethod = function(bits, padding, outputType) {
        return function(key, message, outputBits, s) {
            return methods["kmac" + bits].update(key, message, outputBits, s)[outputType]();
        };
    };
    var createOutputMethods = function(method, createMethod, bits, padding) {
        for(var i = 0; i < OUTPUT_TYPES.length; ++i){
            var type = OUTPUT_TYPES[i];
            method[type] = createMethod(bits, padding, type);
        }
        return method;
    };
    var createMethod = function(bits, padding) {
        var method = createOutputMethod(bits, padding, "hex");
        method.create = function() {
            return new Keccak(bits, padding, bits);
        };
        method.update = function(message) {
            return method.create().update(message);
        };
        return createOutputMethods(method, createOutputMethod, bits, padding);
    };
    var createShakeMethod = function(bits, padding) {
        var method = createShakeOutputMethod(bits, padding, "hex");
        method.create = function(outputBits) {
            return new Keccak(bits, padding, outputBits);
        };
        method.update = function(message, outputBits) {
            return method.create(outputBits).update(message);
        };
        return createOutputMethods(method, createShakeOutputMethod, bits, padding);
    };
    var createCshakeMethod = function(bits, padding) {
        var w = CSHAKE_BYTEPAD[bits];
        var method = createCshakeOutputMethod(bits, padding, "hex");
        method.create = function(outputBits, n, s) {
            if (!n && !s) return methods["shake" + bits].create(outputBits);
            else return new Keccak(bits, padding, outputBits).bytepad([
                n,
                s
            ], w);
        };
        method.update = function(message, outputBits, n, s) {
            return method.create(outputBits, n, s).update(message);
        };
        return createOutputMethods(method, createCshakeOutputMethod, bits, padding);
    };
    var createKmacMethod = function(bits, padding) {
        var w = CSHAKE_BYTEPAD[bits];
        var method = createKmacOutputMethod(bits, padding, "hex");
        method.create = function(key, outputBits, s) {
            return new Kmac(bits, padding, outputBits).bytepad([
                "KMAC",
                s
            ], w).bytepad([
                key
            ], w);
        };
        method.update = function(key, message, outputBits, s) {
            return method.create(key, outputBits, s).update(message);
        };
        return createOutputMethods(method, createKmacOutputMethod, bits, padding);
    };
    var algorithms = [
        {
            name: "keccak",
            padding: KECCAK_PADDING,
            bits: BITS,
            createMethod: createMethod
        },
        {
            name: "sha3",
            padding: PADDING,
            bits: BITS,
            createMethod: createMethod
        },
        {
            name: "shake",
            padding: SHAKE_PADDING,
            bits: SHAKE_BITS,
            createMethod: createShakeMethod
        },
        {
            name: "cshake",
            padding: CSHAKE_PADDING,
            bits: SHAKE_BITS,
            createMethod: createCshakeMethod
        },
        {
            name: "kmac",
            padding: CSHAKE_PADDING,
            bits: SHAKE_BITS,
            createMethod: createKmacMethod
        }
    ];
    var methods = {}, methodNames = [];
    for(var i = 0; i < algorithms.length; ++i){
        var algorithm = algorithms[i];
        var bits = algorithm.bits;
        for(var j = 0; j < bits.length; ++j){
            var methodName = algorithm.name + "_" + bits[j];
            methodNames.push(methodName);
            methods[methodName] = algorithm.createMethod(bits[j], algorithm.padding);
            if (algorithm.name !== "sha3") {
                var newMethodName = algorithm.name + bits[j];
                methodNames.push(newMethodName);
                methods[newMethodName] = methods[methodName];
            }
        }
    }
    function Keccak(bits, padding, outputBits) {
        this.blocks = [];
        this.s = [];
        this.padding = padding;
        this.outputBits = outputBits;
        this.reset = true;
        this.finalized = false;
        this.block = 0;
        this.start = 0;
        this.blockCount = 1600 - (bits << 1) >> 5;
        this.byteCount = this.blockCount << 2;
        this.outputBlocks = outputBits >> 5;
        this.extraBytes = (outputBits & 31) >> 3;
        for(var i = 0; i < 50; ++i)this.s[i] = 0;
    }
    Keccak.prototype.update = function(message) {
        if (this.finalized) throw new Error(FINALIZE_ERROR);
        var notString, type = typeof message;
        if (type !== "string") {
            if (type === "object") {
                if (message === null) throw new Error(INPUT_ERROR);
                else if (ARRAY_BUFFER && message.constructor === ArrayBuffer) message = new Uint8Array(message);
                else if (!Array.isArray(message)) {
                    if (!ARRAY_BUFFER || !ArrayBuffer.isView(message)) throw new Error(INPUT_ERROR);
                }
            } else throw new Error(INPUT_ERROR);
            notString = true;
        }
        var blocks = this.blocks, byteCount = this.byteCount, length = message.length, blockCount = this.blockCount, index = 0, s = this.s, i, code;
        while(index < length){
            if (this.reset) {
                this.reset = false;
                blocks[0] = this.block;
                for(i = 1; i < blockCount + 1; ++i)blocks[i] = 0;
            }
            if (notString) for(i = this.start; index < length && i < byteCount; ++index)blocks[i >> 2] |= message[index] << SHIFT[i++ & 3];
            else for(i = this.start; index < length && i < byteCount; ++index){
                code = message.charCodeAt(index);
                if (code < 0x80) blocks[i >> 2] |= code << SHIFT[i++ & 3];
                else if (code < 0x800) {
                    blocks[i >> 2] |= (0xc0 | code >> 6) << SHIFT[i++ & 3];
                    blocks[i >> 2] |= (0x80 | code & 0x3f) << SHIFT[i++ & 3];
                } else if (code < 0xd800 || code >= 0xe000) {
                    blocks[i >> 2] |= (0xe0 | code >> 12) << SHIFT[i++ & 3];
                    blocks[i >> 2] |= (0x80 | code >> 6 & 0x3f) << SHIFT[i++ & 3];
                    blocks[i >> 2] |= (0x80 | code & 0x3f) << SHIFT[i++ & 3];
                } else {
                    code = 0x10000 + ((code & 0x3ff) << 10 | message.charCodeAt(++index) & 0x3ff);
                    blocks[i >> 2] |= (0xf0 | code >> 18) << SHIFT[i++ & 3];
                    blocks[i >> 2] |= (0x80 | code >> 12 & 0x3f) << SHIFT[i++ & 3];
                    blocks[i >> 2] |= (0x80 | code >> 6 & 0x3f) << SHIFT[i++ & 3];
                    blocks[i >> 2] |= (0x80 | code & 0x3f) << SHIFT[i++ & 3];
                }
            }
            this.lastByteIndex = i;
            if (i >= byteCount) {
                this.start = i - byteCount;
                this.block = blocks[blockCount];
                for(i = 0; i < blockCount; ++i)s[i] ^= blocks[i];
                f(s);
                this.reset = true;
            } else this.start = i;
        }
        return this;
    };
    Keccak.prototype.encode = function(x, right) {
        var o = x & 255, n = 1;
        var bytes = [
            o
        ];
        x = x >> 8;
        o = x & 255;
        while(o > 0){
            bytes.unshift(o);
            x = x >> 8;
            o = x & 255;
            ++n;
        }
        if (right) bytes.push(n);
        else bytes.unshift(n);
        this.update(bytes);
        return bytes.length;
    };
    Keccak.prototype.encodeString = function(str) {
        var notString, type = typeof str;
        if (type !== "string") {
            if (type === "object") {
                if (str === null) throw new Error(INPUT_ERROR);
                else if (ARRAY_BUFFER && str.constructor === ArrayBuffer) str = new Uint8Array(str);
                else if (!Array.isArray(str)) {
                    if (!ARRAY_BUFFER || !ArrayBuffer.isView(str)) throw new Error(INPUT_ERROR);
                }
            } else throw new Error(INPUT_ERROR);
            notString = true;
        }
        var bytes = 0, length = str.length;
        if (notString) bytes = length;
        else for(var i = 0; i < str.length; ++i){
            var code = str.charCodeAt(i);
            if (code < 0x80) bytes += 1;
            else if (code < 0x800) bytes += 2;
            else if (code < 0xd800 || code >= 0xe000) bytes += 3;
            else {
                code = 0x10000 + ((code & 0x3ff) << 10 | str.charCodeAt(++i) & 0x3ff);
                bytes += 4;
            }
        }
        bytes += this.encode(bytes * 8);
        this.update(str);
        return bytes;
    };
    Keccak.prototype.bytepad = function(strs, w) {
        var bytes = this.encode(w);
        for(var i = 0; i < strs.length; ++i)bytes += this.encodeString(strs[i]);
        var paddingBytes = w - bytes % w;
        var zeros = [];
        zeros.length = paddingBytes;
        this.update(zeros);
        return this;
    };
    Keccak.prototype.finalize = function() {
        if (this.finalized) return;
        this.finalized = true;
        var blocks = this.blocks, i = this.lastByteIndex, blockCount = this.blockCount, s = this.s;
        blocks[i >> 2] |= this.padding[i & 3];
        if (this.lastByteIndex === this.byteCount) {
            blocks[0] = blocks[blockCount];
            for(i = 1; i < blockCount + 1; ++i)blocks[i] = 0;
        }
        blocks[blockCount - 1] |= 0x80000000;
        for(i = 0; i < blockCount; ++i)s[i] ^= blocks[i];
        f(s);
    };
    Keccak.prototype.toString = Keccak.prototype.hex = function() {
        this.finalize();
        var blockCount = this.blockCount, s = this.s, outputBlocks = this.outputBlocks, extraBytes = this.extraBytes, i = 0, j = 0;
        var hex = "", block;
        while(j < outputBlocks){
            for(i = 0; i < blockCount && j < outputBlocks; ++i, ++j){
                block = s[i];
                hex += HEX_CHARS[block >> 4 & 0x0F] + HEX_CHARS[block & 0x0F] + HEX_CHARS[block >> 12 & 0x0F] + HEX_CHARS[block >> 8 & 0x0F] + HEX_CHARS[block >> 20 & 0x0F] + HEX_CHARS[block >> 16 & 0x0F] + HEX_CHARS[block >> 28 & 0x0F] + HEX_CHARS[block >> 24 & 0x0F];
            }
            if (j % blockCount === 0) {
                f(s);
                i = 0;
            }
        }
        if (extraBytes) {
            block = s[i];
            hex += HEX_CHARS[block >> 4 & 0x0F] + HEX_CHARS[block & 0x0F];
            if (extraBytes > 1) hex += HEX_CHARS[block >> 12 & 0x0F] + HEX_CHARS[block >> 8 & 0x0F];
            if (extraBytes > 2) hex += HEX_CHARS[block >> 20 & 0x0F] + HEX_CHARS[block >> 16 & 0x0F];
        }
        return hex;
    };
    Keccak.prototype.arrayBuffer = function() {
        this.finalize();
        var blockCount = this.blockCount, s = this.s, outputBlocks = this.outputBlocks, extraBytes = this.extraBytes, i = 0, j = 0;
        var bytes = this.outputBits >> 3;
        var buffer;
        if (extraBytes) buffer = new ArrayBuffer(outputBlocks + 1 << 2);
        else buffer = new ArrayBuffer(bytes);
        var array = new Uint32Array(buffer);
        while(j < outputBlocks){
            for(i = 0; i < blockCount && j < outputBlocks; ++i, ++j)array[j] = s[i];
            if (j % blockCount === 0) f(s);
        }
        if (extraBytes) {
            array[i] = s[i];
            buffer = buffer.slice(0, bytes);
        }
        return buffer;
    };
    Keccak.prototype.buffer = Keccak.prototype.arrayBuffer;
    Keccak.prototype.digest = Keccak.prototype.array = function() {
        this.finalize();
        var blockCount = this.blockCount, s = this.s, outputBlocks = this.outputBlocks, extraBytes = this.extraBytes, i = 0, j = 0;
        var array = [], offset, block;
        while(j < outputBlocks){
            for(i = 0; i < blockCount && j < outputBlocks; ++i, ++j){
                offset = j << 2;
                block = s[i];
                array[offset] = block & 0xFF;
                array[offset + 1] = block >> 8 & 0xFF;
                array[offset + 2] = block >> 16 & 0xFF;
                array[offset + 3] = block >> 24 & 0xFF;
            }
            if (j % blockCount === 0) f(s);
        }
        if (extraBytes) {
            offset = j << 2;
            block = s[i];
            array[offset] = block & 0xFF;
            if (extraBytes > 1) array[offset + 1] = block >> 8 & 0xFF;
            if (extraBytes > 2) array[offset + 2] = block >> 16 & 0xFF;
        }
        return array;
    };
    function Kmac(bits, padding, outputBits) {
        Keccak.call(this, bits, padding, outputBits);
    }
    Kmac.prototype = new Keccak();
    Kmac.prototype.finalize = function() {
        this.encode(this.outputBits, true);
        return Keccak.prototype.finalize.call(this);
    };
    var f = function(s) {
        var h, l, n, c0, c1, c2, c3, c4, c5, c6, c7, c8, c9, b0, b1, b2, b3, b4, b5, b6, b7, b8, b9, b10, b11, b12, b13, b14, b15, b16, b17, b18, b19, b20, b21, b22, b23, b24, b25, b26, b27, b28, b29, b30, b31, b32, b33, b34, b35, b36, b37, b38, b39, b40, b41, b42, b43, b44, b45, b46, b47, b48, b49;
        for(n = 0; n < 48; n += 2){
            c0 = s[0] ^ s[10] ^ s[20] ^ s[30] ^ s[40];
            c1 = s[1] ^ s[11] ^ s[21] ^ s[31] ^ s[41];
            c2 = s[2] ^ s[12] ^ s[22] ^ s[32] ^ s[42];
            c3 = s[3] ^ s[13] ^ s[23] ^ s[33] ^ s[43];
            c4 = s[4] ^ s[14] ^ s[24] ^ s[34] ^ s[44];
            c5 = s[5] ^ s[15] ^ s[25] ^ s[35] ^ s[45];
            c6 = s[6] ^ s[16] ^ s[26] ^ s[36] ^ s[46];
            c7 = s[7] ^ s[17] ^ s[27] ^ s[37] ^ s[47];
            c8 = s[8] ^ s[18] ^ s[28] ^ s[38] ^ s[48];
            c9 = s[9] ^ s[19] ^ s[29] ^ s[39] ^ s[49];
            h = c8 ^ (c2 << 1 | c3 >>> 31);
            l = c9 ^ (c3 << 1 | c2 >>> 31);
            s[0] ^= h;
            s[1] ^= l;
            s[10] ^= h;
            s[11] ^= l;
            s[20] ^= h;
            s[21] ^= l;
            s[30] ^= h;
            s[31] ^= l;
            s[40] ^= h;
            s[41] ^= l;
            h = c0 ^ (c4 << 1 | c5 >>> 31);
            l = c1 ^ (c5 << 1 | c4 >>> 31);
            s[2] ^= h;
            s[3] ^= l;
            s[12] ^= h;
            s[13] ^= l;
            s[22] ^= h;
            s[23] ^= l;
            s[32] ^= h;
            s[33] ^= l;
            s[42] ^= h;
            s[43] ^= l;
            h = c2 ^ (c6 << 1 | c7 >>> 31);
            l = c3 ^ (c7 << 1 | c6 >>> 31);
            s[4] ^= h;
            s[5] ^= l;
            s[14] ^= h;
            s[15] ^= l;
            s[24] ^= h;
            s[25] ^= l;
            s[34] ^= h;
            s[35] ^= l;
            s[44] ^= h;
            s[45] ^= l;
            h = c4 ^ (c8 << 1 | c9 >>> 31);
            l = c5 ^ (c9 << 1 | c8 >>> 31);
            s[6] ^= h;
            s[7] ^= l;
            s[16] ^= h;
            s[17] ^= l;
            s[26] ^= h;
            s[27] ^= l;
            s[36] ^= h;
            s[37] ^= l;
            s[46] ^= h;
            s[47] ^= l;
            h = c6 ^ (c0 << 1 | c1 >>> 31);
            l = c7 ^ (c1 << 1 | c0 >>> 31);
            s[8] ^= h;
            s[9] ^= l;
            s[18] ^= h;
            s[19] ^= l;
            s[28] ^= h;
            s[29] ^= l;
            s[38] ^= h;
            s[39] ^= l;
            s[48] ^= h;
            s[49] ^= l;
            b0 = s[0];
            b1 = s[1];
            b32 = s[11] << 4 | s[10] >>> 28;
            b33 = s[10] << 4 | s[11] >>> 28;
            b14 = s[20] << 3 | s[21] >>> 29;
            b15 = s[21] << 3 | s[20] >>> 29;
            b46 = s[31] << 9 | s[30] >>> 23;
            b47 = s[30] << 9 | s[31] >>> 23;
            b28 = s[40] << 18 | s[41] >>> 14;
            b29 = s[41] << 18 | s[40] >>> 14;
            b20 = s[2] << 1 | s[3] >>> 31;
            b21 = s[3] << 1 | s[2] >>> 31;
            b2 = s[13] << 12 | s[12] >>> 20;
            b3 = s[12] << 12 | s[13] >>> 20;
            b34 = s[22] << 10 | s[23] >>> 22;
            b35 = s[23] << 10 | s[22] >>> 22;
            b16 = s[33] << 13 | s[32] >>> 19;
            b17 = s[32] << 13 | s[33] >>> 19;
            b48 = s[42] << 2 | s[43] >>> 30;
            b49 = s[43] << 2 | s[42] >>> 30;
            b40 = s[5] << 30 | s[4] >>> 2;
            b41 = s[4] << 30 | s[5] >>> 2;
            b22 = s[14] << 6 | s[15] >>> 26;
            b23 = s[15] << 6 | s[14] >>> 26;
            b4 = s[25] << 11 | s[24] >>> 21;
            b5 = s[24] << 11 | s[25] >>> 21;
            b36 = s[34] << 15 | s[35] >>> 17;
            b37 = s[35] << 15 | s[34] >>> 17;
            b18 = s[45] << 29 | s[44] >>> 3;
            b19 = s[44] << 29 | s[45] >>> 3;
            b10 = s[6] << 28 | s[7] >>> 4;
            b11 = s[7] << 28 | s[6] >>> 4;
            b42 = s[17] << 23 | s[16] >>> 9;
            b43 = s[16] << 23 | s[17] >>> 9;
            b24 = s[26] << 25 | s[27] >>> 7;
            b25 = s[27] << 25 | s[26] >>> 7;
            b6 = s[36] << 21 | s[37] >>> 11;
            b7 = s[37] << 21 | s[36] >>> 11;
            b38 = s[47] << 24 | s[46] >>> 8;
            b39 = s[46] << 24 | s[47] >>> 8;
            b30 = s[8] << 27 | s[9] >>> 5;
            b31 = s[9] << 27 | s[8] >>> 5;
            b12 = s[18] << 20 | s[19] >>> 12;
            b13 = s[19] << 20 | s[18] >>> 12;
            b44 = s[29] << 7 | s[28] >>> 25;
            b45 = s[28] << 7 | s[29] >>> 25;
            b26 = s[38] << 8 | s[39] >>> 24;
            b27 = s[39] << 8 | s[38] >>> 24;
            b8 = s[48] << 14 | s[49] >>> 18;
            b9 = s[49] << 14 | s[48] >>> 18;
            s[0] = b0 ^ ~b2 & b4;
            s[1] = b1 ^ ~b3 & b5;
            s[10] = b10 ^ ~b12 & b14;
            s[11] = b11 ^ ~b13 & b15;
            s[20] = b20 ^ ~b22 & b24;
            s[21] = b21 ^ ~b23 & b25;
            s[30] = b30 ^ ~b32 & b34;
            s[31] = b31 ^ ~b33 & b35;
            s[40] = b40 ^ ~b42 & b44;
            s[41] = b41 ^ ~b43 & b45;
            s[2] = b2 ^ ~b4 & b6;
            s[3] = b3 ^ ~b5 & b7;
            s[12] = b12 ^ ~b14 & b16;
            s[13] = b13 ^ ~b15 & b17;
            s[22] = b22 ^ ~b24 & b26;
            s[23] = b23 ^ ~b25 & b27;
            s[32] = b32 ^ ~b34 & b36;
            s[33] = b33 ^ ~b35 & b37;
            s[42] = b42 ^ ~b44 & b46;
            s[43] = b43 ^ ~b45 & b47;
            s[4] = b4 ^ ~b6 & b8;
            s[5] = b5 ^ ~b7 & b9;
            s[14] = b14 ^ ~b16 & b18;
            s[15] = b15 ^ ~b17 & b19;
            s[24] = b24 ^ ~b26 & b28;
            s[25] = b25 ^ ~b27 & b29;
            s[34] = b34 ^ ~b36 & b38;
            s[35] = b35 ^ ~b37 & b39;
            s[44] = b44 ^ ~b46 & b48;
            s[45] = b45 ^ ~b47 & b49;
            s[6] = b6 ^ ~b8 & b0;
            s[7] = b7 ^ ~b9 & b1;
            s[16] = b16 ^ ~b18 & b10;
            s[17] = b17 ^ ~b19 & b11;
            s[26] = b26 ^ ~b28 & b20;
            s[27] = b27 ^ ~b29 & b21;
            s[36] = b36 ^ ~b38 & b30;
            s[37] = b37 ^ ~b39 & b31;
            s[46] = b46 ^ ~b48 & b40;
            s[47] = b47 ^ ~b49 & b41;
            s[8] = b8 ^ ~b0 & b2;
            s[9] = b9 ^ ~b1 & b3;
            s[18] = b18 ^ ~b10 & b12;
            s[19] = b19 ^ ~b11 & b13;
            s[28] = b28 ^ ~b20 & b22;
            s[29] = b29 ^ ~b21 & b23;
            s[38] = b38 ^ ~b30 & b32;
            s[39] = b39 ^ ~b31 & b33;
            s[48] = b48 ^ ~b40 & b42;
            s[49] = b49 ^ ~b41 & b43;
            s[0] ^= RC[n];
            s[1] ^= RC[n + 1];
        }
    };
    if (COMMON_JS) module.exports = methods;
    else {
        for(i = 0; i < methodNames.length; ++i)root[methodNames[i]] = methods[methodNames[i]];
        if (AMD) define(function() {
            return methods;
        });
    }
})();

});
parcelRequire.register("4TNnu", function(module, exports) {
// shim for using process in browser
var $391299e0893a3dfa$var$process = module.exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var $391299e0893a3dfa$var$cachedSetTimeout;
var $391299e0893a3dfa$var$cachedClearTimeout;
function $391299e0893a3dfa$var$defaultSetTimout() {
    throw new Error("setTimeout has not been defined");
}
function $391299e0893a3dfa$var$defaultClearTimeout() {
    throw new Error("clearTimeout has not been defined");
}
(function() {
    try {
        if (typeof setTimeout === "function") $391299e0893a3dfa$var$cachedSetTimeout = setTimeout;
        else $391299e0893a3dfa$var$cachedSetTimeout = $391299e0893a3dfa$var$defaultSetTimout;
    } catch (e) {
        $391299e0893a3dfa$var$cachedSetTimeout = $391299e0893a3dfa$var$defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === "function") $391299e0893a3dfa$var$cachedClearTimeout = clearTimeout;
        else $391299e0893a3dfa$var$cachedClearTimeout = $391299e0893a3dfa$var$defaultClearTimeout;
    } catch (e) {
        $391299e0893a3dfa$var$cachedClearTimeout = $391299e0893a3dfa$var$defaultClearTimeout;
    }
})();
function $391299e0893a3dfa$var$runTimeout(fun) {
    if ($391299e0893a3dfa$var$cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if (($391299e0893a3dfa$var$cachedSetTimeout === $391299e0893a3dfa$var$defaultSetTimout || !$391299e0893a3dfa$var$cachedSetTimeout) && setTimeout) {
        $391299e0893a3dfa$var$cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $391299e0893a3dfa$var$cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return $391299e0893a3dfa$var$cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return $391299e0893a3dfa$var$cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function $391299e0893a3dfa$var$runClearTimeout(marker) {
    if ($391299e0893a3dfa$var$cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if (($391299e0893a3dfa$var$cachedClearTimeout === $391299e0893a3dfa$var$defaultClearTimeout || !$391299e0893a3dfa$var$cachedClearTimeout) && clearTimeout) {
        $391299e0893a3dfa$var$cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $391299e0893a3dfa$var$cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return $391299e0893a3dfa$var$cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return $391299e0893a3dfa$var$cachedClearTimeout.call(this, marker);
        }
    }
}
var $391299e0893a3dfa$var$queue = [];
var $391299e0893a3dfa$var$draining = false;
var $391299e0893a3dfa$var$currentQueue;
var $391299e0893a3dfa$var$queueIndex = -1;
function $391299e0893a3dfa$var$cleanUpNextTick() {
    if (!$391299e0893a3dfa$var$draining || !$391299e0893a3dfa$var$currentQueue) return;
    $391299e0893a3dfa$var$draining = false;
    if ($391299e0893a3dfa$var$currentQueue.length) $391299e0893a3dfa$var$queue = $391299e0893a3dfa$var$currentQueue.concat($391299e0893a3dfa$var$queue);
    else $391299e0893a3dfa$var$queueIndex = -1;
    if ($391299e0893a3dfa$var$queue.length) $391299e0893a3dfa$var$drainQueue();
}
function $391299e0893a3dfa$var$drainQueue() {
    if ($391299e0893a3dfa$var$draining) return;
    var timeout = $391299e0893a3dfa$var$runTimeout($391299e0893a3dfa$var$cleanUpNextTick);
    $391299e0893a3dfa$var$draining = true;
    var len = $391299e0893a3dfa$var$queue.length;
    while(len){
        $391299e0893a3dfa$var$currentQueue = $391299e0893a3dfa$var$queue;
        $391299e0893a3dfa$var$queue = [];
        while(++$391299e0893a3dfa$var$queueIndex < len)if ($391299e0893a3dfa$var$currentQueue) $391299e0893a3dfa$var$currentQueue[$391299e0893a3dfa$var$queueIndex].run();
        $391299e0893a3dfa$var$queueIndex = -1;
        len = $391299e0893a3dfa$var$queue.length;
    }
    $391299e0893a3dfa$var$currentQueue = null;
    $391299e0893a3dfa$var$draining = false;
    $391299e0893a3dfa$var$runClearTimeout(timeout);
}
$391299e0893a3dfa$var$process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    $391299e0893a3dfa$var$queue.push(new $391299e0893a3dfa$var$Item(fun, args));
    if ($391299e0893a3dfa$var$queue.length === 1 && !$391299e0893a3dfa$var$draining) $391299e0893a3dfa$var$runTimeout($391299e0893a3dfa$var$drainQueue);
};
// v8 likes predictible objects
function $391299e0893a3dfa$var$Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
$391299e0893a3dfa$var$Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
$391299e0893a3dfa$var$process.title = "browser";
$391299e0893a3dfa$var$process.browser = true;
$391299e0893a3dfa$var$process.env = {};
$391299e0893a3dfa$var$process.argv = [];
$391299e0893a3dfa$var$process.version = ""; // empty string to avoid regexp issues
$391299e0893a3dfa$var$process.versions = {};
function $391299e0893a3dfa$var$noop() {}
$391299e0893a3dfa$var$process.on = $391299e0893a3dfa$var$noop;
$391299e0893a3dfa$var$process.addListener = $391299e0893a3dfa$var$noop;
$391299e0893a3dfa$var$process.once = $391299e0893a3dfa$var$noop;
$391299e0893a3dfa$var$process.off = $391299e0893a3dfa$var$noop;
$391299e0893a3dfa$var$process.removeListener = $391299e0893a3dfa$var$noop;
$391299e0893a3dfa$var$process.removeAllListeners = $391299e0893a3dfa$var$noop;
$391299e0893a3dfa$var$process.emit = $391299e0893a3dfa$var$noop;
$391299e0893a3dfa$var$process.prependListener = $391299e0893a3dfa$var$noop;
$391299e0893a3dfa$var$process.prependOnceListener = $391299e0893a3dfa$var$noop;
$391299e0893a3dfa$var$process.listeners = function(name) {
    return [];
};
$391299e0893a3dfa$var$process.binding = function(name) {
    throw new Error("process.binding is not supported");
};
$391299e0893a3dfa$var$process.cwd = function() {
    return "/";
};
$391299e0893a3dfa$var$process.chdir = function(dir) {
    throw new Error("process.chdir is not supported");
};
$391299e0893a3dfa$var$process.umask = function() {
    return 0;
};

});


parcelRequire.register("3vltz", function(module, exports) {

$parcel$export(module.exports, "inherits", function () { return $28d4ed0635aac004$export$69f1b2dcda23c5f8; }, function (v) { return $28d4ed0635aac004$export$69f1b2dcda23c5f8 = v; });
$parcel$export(module.exports, "toArray", function () { return $28d4ed0635aac004$export$45b10814cc054894; }, function (v) { return $28d4ed0635aac004$export$45b10814cc054894 = v; });
$parcel$export(module.exports, "toHex", function () { return $28d4ed0635aac004$export$7ea66e3774a60b67; }, function (v) { return $28d4ed0635aac004$export$7ea66e3774a60b67 = v; });
$parcel$export(module.exports, "htonl", function () { return $28d4ed0635aac004$export$34a52f00f601f6f1; }, function (v) { return $28d4ed0635aac004$export$34a52f00f601f6f1 = v; });
$parcel$export(module.exports, "toHex32", function () { return $28d4ed0635aac004$export$812b0cbd5e8a72ab; }, function (v) { return $28d4ed0635aac004$export$812b0cbd5e8a72ab = v; });
$parcel$export(module.exports, "zero2", function () { return $28d4ed0635aac004$export$f24f9e11d63bb314; }, function (v) { return $28d4ed0635aac004$export$f24f9e11d63bb314 = v; });
$parcel$export(module.exports, "zero8", function () { return $28d4ed0635aac004$export$b71357c7e07ca1f1; }, function (v) { return $28d4ed0635aac004$export$b71357c7e07ca1f1 = v; });
$parcel$export(module.exports, "join32", function () { return $28d4ed0635aac004$export$2e58a4b541fdcbe8; }, function (v) { return $28d4ed0635aac004$export$2e58a4b541fdcbe8 = v; });
$parcel$export(module.exports, "split32", function () { return $28d4ed0635aac004$export$183b950bde9faab8; }, function (v) { return $28d4ed0635aac004$export$183b950bde9faab8 = v; });
$parcel$export(module.exports, "rotr32", function () { return $28d4ed0635aac004$export$4785c77169fea59e; }, function (v) { return $28d4ed0635aac004$export$4785c77169fea59e = v; });
$parcel$export(module.exports, "rotl32", function () { return $28d4ed0635aac004$export$242a185dfcffac5b; }, function (v) { return $28d4ed0635aac004$export$242a185dfcffac5b = v; });
$parcel$export(module.exports, "sum32", function () { return $28d4ed0635aac004$export$58c04ae0ae31877d; }, function (v) { return $28d4ed0635aac004$export$58c04ae0ae31877d = v; });
$parcel$export(module.exports, "sum32_3", function () { return $28d4ed0635aac004$export$d058ca695f8c6f11; }, function (v) { return $28d4ed0635aac004$export$d058ca695f8c6f11 = v; });
$parcel$export(module.exports, "sum32_4", function () { return $28d4ed0635aac004$export$a1efd7fc3e986367; }, function (v) { return $28d4ed0635aac004$export$a1efd7fc3e986367 = v; });
$parcel$export(module.exports, "sum32_5", function () { return $28d4ed0635aac004$export$bbfea4a2b5abaab4; }, function (v) { return $28d4ed0635aac004$export$bbfea4a2b5abaab4 = v; });
$parcel$export(module.exports, "sum64", function () { return $28d4ed0635aac004$export$97ad4afc7de86152; }, function (v) { return $28d4ed0635aac004$export$97ad4afc7de86152 = v; });
$parcel$export(module.exports, "sum64_hi", function () { return $28d4ed0635aac004$export$ce4673d9a79f6a4b; }, function (v) { return $28d4ed0635aac004$export$ce4673d9a79f6a4b = v; });
$parcel$export(module.exports, "sum64_lo", function () { return $28d4ed0635aac004$export$786cc99fc6eedc0b; }, function (v) { return $28d4ed0635aac004$export$786cc99fc6eedc0b = v; });
$parcel$export(module.exports, "sum64_4_hi", function () { return $28d4ed0635aac004$export$45c59b9a1848dd0; }, function (v) { return $28d4ed0635aac004$export$45c59b9a1848dd0 = v; });
$parcel$export(module.exports, "sum64_4_lo", function () { return $28d4ed0635aac004$export$50d8f613e76d3034; }, function (v) { return $28d4ed0635aac004$export$50d8f613e76d3034 = v; });
$parcel$export(module.exports, "sum64_5_hi", function () { return $28d4ed0635aac004$export$b8e83683c60ee162; }, function (v) { return $28d4ed0635aac004$export$b8e83683c60ee162 = v; });
$parcel$export(module.exports, "sum64_5_lo", function () { return $28d4ed0635aac004$export$aeeb51790d1bcc4a; }, function (v) { return $28d4ed0635aac004$export$aeeb51790d1bcc4a = v; });
$parcel$export(module.exports, "rotr64_hi", function () { return $28d4ed0635aac004$export$bb7c616f719ad9c; }, function (v) { return $28d4ed0635aac004$export$bb7c616f719ad9c = v; });
$parcel$export(module.exports, "rotr64_lo", function () { return $28d4ed0635aac004$export$4d63290824f9d7df; }, function (v) { return $28d4ed0635aac004$export$4d63290824f9d7df = v; });
$parcel$export(module.exports, "shr64_hi", function () { return $28d4ed0635aac004$export$2f64ceb90ef28ea1; }, function (v) { return $28d4ed0635aac004$export$2f64ceb90ef28ea1 = v; });
$parcel$export(module.exports, "shr64_lo", function () { return $28d4ed0635aac004$export$8d2089d465f6d10d; }, function (v) { return $28d4ed0635aac004$export$8d2089d465f6d10d = v; });
var $28d4ed0635aac004$export$69f1b2dcda23c5f8;
var $28d4ed0635aac004$export$45b10814cc054894;
var $28d4ed0635aac004$export$7ea66e3774a60b67;
var $28d4ed0635aac004$export$34a52f00f601f6f1;
var $28d4ed0635aac004$export$812b0cbd5e8a72ab;
var $28d4ed0635aac004$export$f24f9e11d63bb314;
var $28d4ed0635aac004$export$b71357c7e07ca1f1;
var $28d4ed0635aac004$export$2e58a4b541fdcbe8;
var $28d4ed0635aac004$export$183b950bde9faab8;
var $28d4ed0635aac004$export$4785c77169fea59e;
var $28d4ed0635aac004$export$242a185dfcffac5b;
var $28d4ed0635aac004$export$58c04ae0ae31877d;
var $28d4ed0635aac004$export$d058ca695f8c6f11;
var $28d4ed0635aac004$export$a1efd7fc3e986367;
var $28d4ed0635aac004$export$bbfea4a2b5abaab4;
var $28d4ed0635aac004$export$97ad4afc7de86152;
var $28d4ed0635aac004$export$ce4673d9a79f6a4b;
var $28d4ed0635aac004$export$786cc99fc6eedc0b;
var $28d4ed0635aac004$export$45c59b9a1848dd0;
var $28d4ed0635aac004$export$50d8f613e76d3034;
var $28d4ed0635aac004$export$b8e83683c60ee162;
var $28d4ed0635aac004$export$aeeb51790d1bcc4a;
var $28d4ed0635aac004$export$bb7c616f719ad9c;
var $28d4ed0635aac004$export$4d63290824f9d7df;
var $28d4ed0635aac004$export$2f64ceb90ef28ea1;
var $28d4ed0635aac004$export$8d2089d465f6d10d;
"use strict";

var $aJt1P = parcelRequire("aJt1P");

var $eSHUL = parcelRequire("eSHUL");
$28d4ed0635aac004$export$69f1b2dcda23c5f8 = $eSHUL;
function $28d4ed0635aac004$var$isSurrogatePair(msg, i) {
    if ((msg.charCodeAt(i) & 0xFC00) !== 0xD800) return false;
    if (i < 0 || i + 1 >= msg.length) return false;
    return (msg.charCodeAt(i + 1) & 0xFC00) === 0xDC00;
}
function $28d4ed0635aac004$var$toArray(msg, enc) {
    if (Array.isArray(msg)) return msg.slice();
    if (!msg) return [];
    var res = [];
    if (typeof msg === "string") {
        if (!enc) {
            // Inspired by stringToUtf8ByteArray() in closure-library by Google
            // https://github.com/google/closure-library/blob/8598d87242af59aac233270742c8984e2b2bdbe0/closure/goog/crypt/crypt.js#L117-L143
            // Apache License 2.0
            // https://github.com/google/closure-library/blob/master/LICENSE
            var p = 0;
            for(var i = 0; i < msg.length; i++){
                var c = msg.charCodeAt(i);
                if (c < 128) res[p++] = c;
                else if (c < 2048) {
                    res[p++] = c >> 6 | 192;
                    res[p++] = c & 63 | 128;
                } else if ($28d4ed0635aac004$var$isSurrogatePair(msg, i)) {
                    c = 0x10000 + ((c & 0x03FF) << 10) + (msg.charCodeAt(++i) & 0x03FF);
                    res[p++] = c >> 18 | 240;
                    res[p++] = c >> 12 & 63 | 128;
                    res[p++] = c >> 6 & 63 | 128;
                    res[p++] = c & 63 | 128;
                } else {
                    res[p++] = c >> 12 | 224;
                    res[p++] = c >> 6 & 63 | 128;
                    res[p++] = c & 63 | 128;
                }
            }
        } else if (enc === "hex") {
            msg = msg.replace(/[^a-z0-9]+/ig, "");
            if (msg.length % 2 !== 0) msg = "0" + msg;
            for(i = 0; i < msg.length; i += 2)res.push(parseInt(msg[i] + msg[i + 1], 16));
        }
    } else for(i = 0; i < msg.length; i++)res[i] = msg[i] | 0;
    return res;
}
$28d4ed0635aac004$export$45b10814cc054894 = $28d4ed0635aac004$var$toArray;
function $28d4ed0635aac004$var$toHex(msg) {
    var res = "";
    for(var i = 0; i < msg.length; i++)res += $28d4ed0635aac004$var$zero2(msg[i].toString(16));
    return res;
}
$28d4ed0635aac004$export$7ea66e3774a60b67 = $28d4ed0635aac004$var$toHex;
function $28d4ed0635aac004$var$htonl(w) {
    var res = w >>> 24 | w >>> 8 & 0xff00 | w << 8 & 0xff0000 | (w & 0xff) << 24;
    return res >>> 0;
}
$28d4ed0635aac004$export$34a52f00f601f6f1 = $28d4ed0635aac004$var$htonl;
function $28d4ed0635aac004$var$toHex32(msg, endian) {
    var res = "";
    for(var i = 0; i < msg.length; i++){
        var w = msg[i];
        if (endian === "little") w = $28d4ed0635aac004$var$htonl(w);
        res += $28d4ed0635aac004$var$zero8(w.toString(16));
    }
    return res;
}
$28d4ed0635aac004$export$812b0cbd5e8a72ab = $28d4ed0635aac004$var$toHex32;
function $28d4ed0635aac004$var$zero2(word) {
    if (word.length === 1) return "0" + word;
    else return word;
}
$28d4ed0635aac004$export$f24f9e11d63bb314 = $28d4ed0635aac004$var$zero2;
function $28d4ed0635aac004$var$zero8(word) {
    if (word.length === 7) return "0" + word;
    else if (word.length === 6) return "00" + word;
    else if (word.length === 5) return "000" + word;
    else if (word.length === 4) return "0000" + word;
    else if (word.length === 3) return "00000" + word;
    else if (word.length === 2) return "000000" + word;
    else if (word.length === 1) return "0000000" + word;
    else return word;
}
$28d4ed0635aac004$export$b71357c7e07ca1f1 = $28d4ed0635aac004$var$zero8;
function $28d4ed0635aac004$var$join32(msg, start, end, endian) {
    var len = end - start;
    $aJt1P(len % 4 === 0);
    var res = new Array(len / 4);
    for(var i = 0, k = start; i < res.length; i++, k += 4){
        var w;
        if (endian === "big") w = msg[k] << 24 | msg[k + 1] << 16 | msg[k + 2] << 8 | msg[k + 3];
        else w = msg[k + 3] << 24 | msg[k + 2] << 16 | msg[k + 1] << 8 | msg[k];
        res[i] = w >>> 0;
    }
    return res;
}
$28d4ed0635aac004$export$2e58a4b541fdcbe8 = $28d4ed0635aac004$var$join32;
function $28d4ed0635aac004$var$split32(msg, endian) {
    var res = new Array(msg.length * 4);
    for(var i = 0, k = 0; i < msg.length; i++, k += 4){
        var m = msg[i];
        if (endian === "big") {
            res[k] = m >>> 24;
            res[k + 1] = m >>> 16 & 0xff;
            res[k + 2] = m >>> 8 & 0xff;
            res[k + 3] = m & 0xff;
        } else {
            res[k + 3] = m >>> 24;
            res[k + 2] = m >>> 16 & 0xff;
            res[k + 1] = m >>> 8 & 0xff;
            res[k] = m & 0xff;
        }
    }
    return res;
}
$28d4ed0635aac004$export$183b950bde9faab8 = $28d4ed0635aac004$var$split32;
function $28d4ed0635aac004$var$rotr32(w, b) {
    return w >>> b | w << 32 - b;
}
$28d4ed0635aac004$export$4785c77169fea59e = $28d4ed0635aac004$var$rotr32;
function $28d4ed0635aac004$var$rotl32(w, b) {
    return w << b | w >>> 32 - b;
}
$28d4ed0635aac004$export$242a185dfcffac5b = $28d4ed0635aac004$var$rotl32;
function $28d4ed0635aac004$var$sum32(a, b) {
    return a + b >>> 0;
}
$28d4ed0635aac004$export$58c04ae0ae31877d = $28d4ed0635aac004$var$sum32;
function $28d4ed0635aac004$var$sum32_3(a, b, c) {
    return a + b + c >>> 0;
}
$28d4ed0635aac004$export$d058ca695f8c6f11 = $28d4ed0635aac004$var$sum32_3;
function $28d4ed0635aac004$var$sum32_4(a, b, c, d) {
    return a + b + c + d >>> 0;
}
$28d4ed0635aac004$export$a1efd7fc3e986367 = $28d4ed0635aac004$var$sum32_4;
function $28d4ed0635aac004$var$sum32_5(a, b, c, d, e) {
    return a + b + c + d + e >>> 0;
}
$28d4ed0635aac004$export$bbfea4a2b5abaab4 = $28d4ed0635aac004$var$sum32_5;
function $28d4ed0635aac004$var$sum64(buf, pos, ah, al) {
    var bh = buf[pos];
    var bl = buf[pos + 1];
    var lo = al + bl >>> 0;
    var hi = (lo < al ? 1 : 0) + ah + bh;
    buf[pos] = hi >>> 0;
    buf[pos + 1] = lo;
}
$28d4ed0635aac004$export$97ad4afc7de86152 = $28d4ed0635aac004$var$sum64;
function $28d4ed0635aac004$var$sum64_hi(ah, al, bh, bl) {
    var lo = al + bl >>> 0;
    var hi = (lo < al ? 1 : 0) + ah + bh;
    return hi >>> 0;
}
$28d4ed0635aac004$export$ce4673d9a79f6a4b = $28d4ed0635aac004$var$sum64_hi;
function $28d4ed0635aac004$var$sum64_lo(ah, al, bh, bl) {
    var lo = al + bl;
    return lo >>> 0;
}
$28d4ed0635aac004$export$786cc99fc6eedc0b = $28d4ed0635aac004$var$sum64_lo;
function $28d4ed0635aac004$var$sum64_4_hi(ah, al, bh, bl, ch, cl, dh, dl) {
    var carry = 0;
    var lo = al;
    lo = lo + bl >>> 0;
    carry += lo < al ? 1 : 0;
    lo = lo + cl >>> 0;
    carry += lo < cl ? 1 : 0;
    lo = lo + dl >>> 0;
    carry += lo < dl ? 1 : 0;
    var hi = ah + bh + ch + dh + carry;
    return hi >>> 0;
}
$28d4ed0635aac004$export$45c59b9a1848dd0 = $28d4ed0635aac004$var$sum64_4_hi;
function $28d4ed0635aac004$var$sum64_4_lo(ah, al, bh, bl, ch, cl, dh, dl) {
    var lo = al + bl + cl + dl;
    return lo >>> 0;
}
$28d4ed0635aac004$export$50d8f613e76d3034 = $28d4ed0635aac004$var$sum64_4_lo;
function $28d4ed0635aac004$var$sum64_5_hi(ah, al, bh, bl, ch, cl, dh, dl, eh, el) {
    var carry = 0;
    var lo = al;
    lo = lo + bl >>> 0;
    carry += lo < al ? 1 : 0;
    lo = lo + cl >>> 0;
    carry += lo < cl ? 1 : 0;
    lo = lo + dl >>> 0;
    carry += lo < dl ? 1 : 0;
    lo = lo + el >>> 0;
    carry += lo < el ? 1 : 0;
    var hi = ah + bh + ch + dh + eh + carry;
    return hi >>> 0;
}
$28d4ed0635aac004$export$b8e83683c60ee162 = $28d4ed0635aac004$var$sum64_5_hi;
function $28d4ed0635aac004$var$sum64_5_lo(ah, al, bh, bl, ch, cl, dh, dl, eh, el) {
    var lo = al + bl + cl + dl + el;
    return lo >>> 0;
}
$28d4ed0635aac004$export$aeeb51790d1bcc4a = $28d4ed0635aac004$var$sum64_5_lo;
function $28d4ed0635aac004$var$rotr64_hi(ah, al, num) {
    var r = al << 32 - num | ah >>> num;
    return r >>> 0;
}
$28d4ed0635aac004$export$bb7c616f719ad9c = $28d4ed0635aac004$var$rotr64_hi;
function $28d4ed0635aac004$var$rotr64_lo(ah, al, num) {
    var r = ah << 32 - num | al >>> num;
    return r >>> 0;
}
$28d4ed0635aac004$export$4d63290824f9d7df = $28d4ed0635aac004$var$rotr64_lo;
function $28d4ed0635aac004$var$shr64_hi(ah, al, num) {
    return ah >>> num;
}
$28d4ed0635aac004$export$2f64ceb90ef28ea1 = $28d4ed0635aac004$var$shr64_hi;
function $28d4ed0635aac004$var$shr64_lo(ah, al, num) {
    var r = ah << 32 - num | al >>> num;
    return r >>> 0;
}
$28d4ed0635aac004$export$8d2089d465f6d10d = $28d4ed0635aac004$var$shr64_lo;

});
parcelRequire.register("aJt1P", function(module, exports) {
module.exports = $7d049fca35679f9f$var$assert;
function $7d049fca35679f9f$var$assert(val, msg) {
    if (!val) throw new Error(msg || "Assertion failed");
}
$7d049fca35679f9f$var$assert.equal = function assertEqual(l, r, msg) {
    if (l != r) throw new Error(msg || "Assertion failed: " + l + " != " + r);
};

});

parcelRequire.register("eSHUL", function(module, exports) {
if (typeof Object.create === "function") // implementation from standard node.js 'util' module
module.exports = function inherits(ctor, superCtor) {
    if (superCtor) {
        ctor.super_ = superCtor;
        ctor.prototype = Object.create(superCtor.prototype, {
            constructor: {
                value: ctor,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
    }
};
else // old school shim for old browsers
module.exports = function inherits(ctor, superCtor) {
    if (superCtor) {
        ctor.super_ = superCtor;
        var TempCtor = function() {};
        TempCtor.prototype = superCtor.prototype;
        ctor.prototype = new TempCtor();
        ctor.prototype.constructor = ctor;
    }
};

});


parcelRequire.register("hoO3s", function(module, exports) {

$parcel$export(module.exports, "BlockHash", function () { return $caab81610dd48e7b$export$8687658379b577e6; }, function (v) { return $caab81610dd48e7b$export$8687658379b577e6 = v; });
var $caab81610dd48e7b$export$8687658379b577e6;
"use strict";

var $3vltz = parcelRequire("3vltz");

var $aJt1P = parcelRequire("aJt1P");
function $caab81610dd48e7b$var$BlockHash() {
    this.pending = null;
    this.pendingTotal = 0;
    this.blockSize = this.constructor.blockSize;
    this.outSize = this.constructor.outSize;
    this.hmacStrength = this.constructor.hmacStrength;
    this.padLength = this.constructor.padLength / 8;
    this.endian = "big";
    this._delta8 = this.blockSize / 8;
    this._delta32 = this.blockSize / 32;
}
$caab81610dd48e7b$export$8687658379b577e6 = $caab81610dd48e7b$var$BlockHash;
$caab81610dd48e7b$var$BlockHash.prototype.update = function update(msg, enc) {
    // Convert message to array, pad it, and join into 32bit blocks
    msg = $3vltz.toArray(msg, enc);
    if (!this.pending) this.pending = msg;
    else this.pending = this.pending.concat(msg);
    this.pendingTotal += msg.length;
    // Enough data, try updating
    if (this.pending.length >= this._delta8) {
        msg = this.pending;
        // Process pending data in blocks
        var r = msg.length % this._delta8;
        this.pending = msg.slice(msg.length - r, msg.length);
        if (this.pending.length === 0) this.pending = null;
        msg = $3vltz.join32(msg, 0, msg.length - r, this.endian);
        for(var i = 0; i < msg.length; i += this._delta32)this._update(msg, i, i + this._delta32);
    }
    return this;
};
$caab81610dd48e7b$var$BlockHash.prototype.digest = function digest(enc) {
    this.update(this._pad());
    $aJt1P(this.pending === null);
    return this._digest(enc);
};
$caab81610dd48e7b$var$BlockHash.prototype._pad = function pad() {
    var len = this.pendingTotal;
    var bytes = this._delta8;
    var k = bytes - (len + this.padLength) % bytes;
    var res = new Array(k + this.padLength);
    res[0] = 0x80;
    for(var i = 1; i < k; i++)res[i] = 0;
    // Append length
    len <<= 3;
    if (this.endian === "big") {
        for(var t = 8; t < this.padLength; t++)res[i++] = 0;
        res[i++] = 0;
        res[i++] = 0;
        res[i++] = 0;
        res[i++] = 0;
        res[i++] = len >>> 24 & 0xff;
        res[i++] = len >>> 16 & 0xff;
        res[i++] = len >>> 8 & 0xff;
        res[i++] = len & 0xff;
    } else {
        res[i++] = len & 0xff;
        res[i++] = len >>> 8 & 0xff;
        res[i++] = len >>> 16 & 0xff;
        res[i++] = len >>> 24 & 0xff;
        res[i++] = 0;
        res[i++] = 0;
        res[i++] = 0;
        res[i++] = 0;
        for(t = 8; t < this.padLength; t++)res[i++] = 0;
    }
    return res;
};

});

parcelRequire.register("esJCG", function(module, exports) {

$parcel$export(module.exports, "sha1", function () { return $a87711fd35b0090f$export$5091bdda49ba90f5; }, function (v) { return $a87711fd35b0090f$export$5091bdda49ba90f5 = v; });
$parcel$export(module.exports, "sha224", function () { return $a87711fd35b0090f$export$97b70509d4e397ea; }, function (v) { return $a87711fd35b0090f$export$97b70509d4e397ea = v; });
$parcel$export(module.exports, "sha256", function () { return $a87711fd35b0090f$export$bced8d2aada2d1c9; }, function (v) { return $a87711fd35b0090f$export$bced8d2aada2d1c9 = v; });
$parcel$export(module.exports, "sha384", function () { return $a87711fd35b0090f$export$612d47d55dedde45; }, function (v) { return $a87711fd35b0090f$export$612d47d55dedde45 = v; });
$parcel$export(module.exports, "sha512", function () { return $a87711fd35b0090f$export$a888d2532e6dc7bb; }, function (v) { return $a87711fd35b0090f$export$a888d2532e6dc7bb = v; });
var $a87711fd35b0090f$export$5091bdda49ba90f5;
var $a87711fd35b0090f$export$97b70509d4e397ea;
var $a87711fd35b0090f$export$bced8d2aada2d1c9;
var $a87711fd35b0090f$export$612d47d55dedde45;
var $a87711fd35b0090f$export$a888d2532e6dc7bb;
"use strict";

$a87711fd35b0090f$export$5091bdda49ba90f5 = (parcelRequire("4n9Qi"));

$a87711fd35b0090f$export$97b70509d4e397ea = (parcelRequire("2w2RS"));

$a87711fd35b0090f$export$bced8d2aada2d1c9 = (parcelRequire("6tl9X"));

$a87711fd35b0090f$export$612d47d55dedde45 = (parcelRequire("1zFKP"));

$a87711fd35b0090f$export$a888d2532e6dc7bb = (parcelRequire("b8Cnj"));

});
parcelRequire.register("4n9Qi", function(module, exports) {
"use strict";

var $3vltz = parcelRequire("3vltz");

var $hoO3s = parcelRequire("hoO3s");

var $7pXSD = parcelRequire("7pXSD");
var $32f0f1f12aa851fd$var$rotl32 = $3vltz.rotl32;
var $32f0f1f12aa851fd$var$sum32 = $3vltz.sum32;
var $32f0f1f12aa851fd$var$sum32_5 = $3vltz.sum32_5;
var $32f0f1f12aa851fd$var$ft_1 = $7pXSD.ft_1;
var $32f0f1f12aa851fd$var$BlockHash = $hoO3s.BlockHash;
var $32f0f1f12aa851fd$var$sha1_K = [
    0x5A827999,
    0x6ED9EBA1,
    0x8F1BBCDC,
    0xCA62C1D6
];
function $32f0f1f12aa851fd$var$SHA1() {
    if (!(this instanceof $32f0f1f12aa851fd$var$SHA1)) return new $32f0f1f12aa851fd$var$SHA1();
    $32f0f1f12aa851fd$var$BlockHash.call(this);
    this.h = [
        0x67452301,
        0xefcdab89,
        0x98badcfe,
        0x10325476,
        0xc3d2e1f0
    ];
    this.W = new Array(80);
}
$3vltz.inherits($32f0f1f12aa851fd$var$SHA1, $32f0f1f12aa851fd$var$BlockHash);
module.exports = $32f0f1f12aa851fd$var$SHA1;
$32f0f1f12aa851fd$var$SHA1.blockSize = 512;
$32f0f1f12aa851fd$var$SHA1.outSize = 160;
$32f0f1f12aa851fd$var$SHA1.hmacStrength = 80;
$32f0f1f12aa851fd$var$SHA1.padLength = 64;
$32f0f1f12aa851fd$var$SHA1.prototype._update = function _update(msg, start) {
    var W = this.W;
    for(var i = 0; i < 16; i++)W[i] = msg[start + i];
    for(; i < W.length; i++)W[i] = $32f0f1f12aa851fd$var$rotl32(W[i - 3] ^ W[i - 8] ^ W[i - 14] ^ W[i - 16], 1);
    var a = this.h[0];
    var b = this.h[1];
    var c = this.h[2];
    var d = this.h[3];
    var e = this.h[4];
    for(i = 0; i < W.length; i++){
        var s = ~~(i / 20);
        var t = $32f0f1f12aa851fd$var$sum32_5($32f0f1f12aa851fd$var$rotl32(a, 5), $32f0f1f12aa851fd$var$ft_1(s, b, c, d), e, W[i], $32f0f1f12aa851fd$var$sha1_K[s]);
        e = d;
        d = c;
        c = $32f0f1f12aa851fd$var$rotl32(b, 30);
        b = a;
        a = t;
    }
    this.h[0] = $32f0f1f12aa851fd$var$sum32(this.h[0], a);
    this.h[1] = $32f0f1f12aa851fd$var$sum32(this.h[1], b);
    this.h[2] = $32f0f1f12aa851fd$var$sum32(this.h[2], c);
    this.h[3] = $32f0f1f12aa851fd$var$sum32(this.h[3], d);
    this.h[4] = $32f0f1f12aa851fd$var$sum32(this.h[4], e);
};
$32f0f1f12aa851fd$var$SHA1.prototype._digest = function digest(enc) {
    if (enc === "hex") return $3vltz.toHex32(this.h, "big");
    else return $3vltz.split32(this.h, "big");
};

});
parcelRequire.register("7pXSD", function(module, exports) {

$parcel$export(module.exports, "ft_1", function () { return $5669512b21aa6962$export$5a92649d7ddb9f63; }, function (v) { return $5669512b21aa6962$export$5a92649d7ddb9f63 = v; });
$parcel$export(module.exports, "ch32", function () { return $5669512b21aa6962$export$c6d0d020c3a6269; }, function (v) { return $5669512b21aa6962$export$c6d0d020c3a6269 = v; });
$parcel$export(module.exports, "maj32", function () { return $5669512b21aa6962$export$eb90c27fca05f956; }, function (v) { return $5669512b21aa6962$export$eb90c27fca05f956 = v; });
$parcel$export(module.exports, "s0_256", function () { return $5669512b21aa6962$export$14a4a98e063b1999; }, function (v) { return $5669512b21aa6962$export$14a4a98e063b1999 = v; });
$parcel$export(module.exports, "s1_256", function () { return $5669512b21aa6962$export$d20cecfa1564c686; }, function (v) { return $5669512b21aa6962$export$d20cecfa1564c686 = v; });
$parcel$export(module.exports, "g0_256", function () { return $5669512b21aa6962$export$44fd472a12fc6db; }, function (v) { return $5669512b21aa6962$export$44fd472a12fc6db = v; });
$parcel$export(module.exports, "g1_256", function () { return $5669512b21aa6962$export$1ed238bb6ea1dd47; }, function (v) { return $5669512b21aa6962$export$1ed238bb6ea1dd47 = v; });
var $5669512b21aa6962$export$5a92649d7ddb9f63;
var $5669512b21aa6962$export$c6d0d020c3a6269;
var $5669512b21aa6962$export$eb90c27fca05f956;
var $5669512b21aa6962$export$cc992891a14496a1;
var $5669512b21aa6962$export$14a4a98e063b1999;
var $5669512b21aa6962$export$d20cecfa1564c686;
var $5669512b21aa6962$export$44fd472a12fc6db;
var $5669512b21aa6962$export$1ed238bb6ea1dd47;
"use strict";

var $3vltz = parcelRequire("3vltz");
var $5669512b21aa6962$var$rotr32 = $3vltz.rotr32;
function $5669512b21aa6962$var$ft_1(s, x, y, z) {
    if (s === 0) return $5669512b21aa6962$var$ch32(x, y, z);
    if (s === 1 || s === 3) return $5669512b21aa6962$var$p32(x, y, z);
    if (s === 2) return $5669512b21aa6962$var$maj32(x, y, z);
}
$5669512b21aa6962$export$5a92649d7ddb9f63 = $5669512b21aa6962$var$ft_1;
function $5669512b21aa6962$var$ch32(x, y, z) {
    return x & y ^ ~x & z;
}
$5669512b21aa6962$export$c6d0d020c3a6269 = $5669512b21aa6962$var$ch32;
function $5669512b21aa6962$var$maj32(x, y, z) {
    return x & y ^ x & z ^ y & z;
}
$5669512b21aa6962$export$eb90c27fca05f956 = $5669512b21aa6962$var$maj32;
function $5669512b21aa6962$var$p32(x, y, z) {
    return x ^ y ^ z;
}
$5669512b21aa6962$export$cc992891a14496a1 = $5669512b21aa6962$var$p32;
function $5669512b21aa6962$var$s0_256(x) {
    return $5669512b21aa6962$var$rotr32(x, 2) ^ $5669512b21aa6962$var$rotr32(x, 13) ^ $5669512b21aa6962$var$rotr32(x, 22);
}
$5669512b21aa6962$export$14a4a98e063b1999 = $5669512b21aa6962$var$s0_256;
function $5669512b21aa6962$var$s1_256(x) {
    return $5669512b21aa6962$var$rotr32(x, 6) ^ $5669512b21aa6962$var$rotr32(x, 11) ^ $5669512b21aa6962$var$rotr32(x, 25);
}
$5669512b21aa6962$export$d20cecfa1564c686 = $5669512b21aa6962$var$s1_256;
function $5669512b21aa6962$var$g0_256(x) {
    return $5669512b21aa6962$var$rotr32(x, 7) ^ $5669512b21aa6962$var$rotr32(x, 18) ^ x >>> 3;
}
$5669512b21aa6962$export$44fd472a12fc6db = $5669512b21aa6962$var$g0_256;
function $5669512b21aa6962$var$g1_256(x) {
    return $5669512b21aa6962$var$rotr32(x, 17) ^ $5669512b21aa6962$var$rotr32(x, 19) ^ x >>> 10;
}
$5669512b21aa6962$export$1ed238bb6ea1dd47 = $5669512b21aa6962$var$g1_256;

});


parcelRequire.register("2w2RS", function(module, exports) {
"use strict";

var $3vltz = parcelRequire("3vltz");

var $6tl9X = parcelRequire("6tl9X");
function $1d50cb6dff0ac7e1$var$SHA224() {
    if (!(this instanceof $1d50cb6dff0ac7e1$var$SHA224)) return new $1d50cb6dff0ac7e1$var$SHA224();
    $6tl9X.call(this);
    this.h = [
        0xc1059ed8,
        0x367cd507,
        0x3070dd17,
        0xf70e5939,
        0xffc00b31,
        0x68581511,
        0x64f98fa7,
        0xbefa4fa4
    ];
}
$3vltz.inherits($1d50cb6dff0ac7e1$var$SHA224, $6tl9X);
module.exports = $1d50cb6dff0ac7e1$var$SHA224;
$1d50cb6dff0ac7e1$var$SHA224.blockSize = 512;
$1d50cb6dff0ac7e1$var$SHA224.outSize = 224;
$1d50cb6dff0ac7e1$var$SHA224.hmacStrength = 192;
$1d50cb6dff0ac7e1$var$SHA224.padLength = 64;
$1d50cb6dff0ac7e1$var$SHA224.prototype._digest = function digest(enc) {
    // Just truncate output
    if (enc === "hex") return $3vltz.toHex32(this.h.slice(0, 7), "big");
    else return $3vltz.split32(this.h.slice(0, 7), "big");
};

});
parcelRequire.register("6tl9X", function(module, exports) {
"use strict";

var $3vltz = parcelRequire("3vltz");

var $hoO3s = parcelRequire("hoO3s");

var $7pXSD = parcelRequire("7pXSD");

var $aJt1P = parcelRequire("aJt1P");
var $4b65dd591dedf929$var$sum32 = $3vltz.sum32;
var $4b65dd591dedf929$var$sum32_4 = $3vltz.sum32_4;
var $4b65dd591dedf929$var$sum32_5 = $3vltz.sum32_5;
var $4b65dd591dedf929$var$ch32 = $7pXSD.ch32;
var $4b65dd591dedf929$var$maj32 = $7pXSD.maj32;
var $4b65dd591dedf929$var$s0_256 = $7pXSD.s0_256;
var $4b65dd591dedf929$var$s1_256 = $7pXSD.s1_256;
var $4b65dd591dedf929$var$g0_256 = $7pXSD.g0_256;
var $4b65dd591dedf929$var$g1_256 = $7pXSD.g1_256;
var $4b65dd591dedf929$var$BlockHash = $hoO3s.BlockHash;
var $4b65dd591dedf929$var$sha256_K = [
    0x428a2f98,
    0x71374491,
    0xb5c0fbcf,
    0xe9b5dba5,
    0x3956c25b,
    0x59f111f1,
    0x923f82a4,
    0xab1c5ed5,
    0xd807aa98,
    0x12835b01,
    0x243185be,
    0x550c7dc3,
    0x72be5d74,
    0x80deb1fe,
    0x9bdc06a7,
    0xc19bf174,
    0xe49b69c1,
    0xefbe4786,
    0x0fc19dc6,
    0x240ca1cc,
    0x2de92c6f,
    0x4a7484aa,
    0x5cb0a9dc,
    0x76f988da,
    0x983e5152,
    0xa831c66d,
    0xb00327c8,
    0xbf597fc7,
    0xc6e00bf3,
    0xd5a79147,
    0x06ca6351,
    0x14292967,
    0x27b70a85,
    0x2e1b2138,
    0x4d2c6dfc,
    0x53380d13,
    0x650a7354,
    0x766a0abb,
    0x81c2c92e,
    0x92722c85,
    0xa2bfe8a1,
    0xa81a664b,
    0xc24b8b70,
    0xc76c51a3,
    0xd192e819,
    0xd6990624,
    0xf40e3585,
    0x106aa070,
    0x19a4c116,
    0x1e376c08,
    0x2748774c,
    0x34b0bcb5,
    0x391c0cb3,
    0x4ed8aa4a,
    0x5b9cca4f,
    0x682e6ff3,
    0x748f82ee,
    0x78a5636f,
    0x84c87814,
    0x8cc70208,
    0x90befffa,
    0xa4506ceb,
    0xbef9a3f7,
    0xc67178f2
];
function $4b65dd591dedf929$var$SHA256() {
    if (!(this instanceof $4b65dd591dedf929$var$SHA256)) return new $4b65dd591dedf929$var$SHA256();
    $4b65dd591dedf929$var$BlockHash.call(this);
    this.h = [
        0x6a09e667,
        0xbb67ae85,
        0x3c6ef372,
        0xa54ff53a,
        0x510e527f,
        0x9b05688c,
        0x1f83d9ab,
        0x5be0cd19
    ];
    this.k = $4b65dd591dedf929$var$sha256_K;
    this.W = new Array(64);
}
$3vltz.inherits($4b65dd591dedf929$var$SHA256, $4b65dd591dedf929$var$BlockHash);
module.exports = $4b65dd591dedf929$var$SHA256;
$4b65dd591dedf929$var$SHA256.blockSize = 512;
$4b65dd591dedf929$var$SHA256.outSize = 256;
$4b65dd591dedf929$var$SHA256.hmacStrength = 192;
$4b65dd591dedf929$var$SHA256.padLength = 64;
$4b65dd591dedf929$var$SHA256.prototype._update = function _update(msg, start) {
    var W = this.W;
    for(var i = 0; i < 16; i++)W[i] = msg[start + i];
    for(; i < W.length; i++)W[i] = $4b65dd591dedf929$var$sum32_4($4b65dd591dedf929$var$g1_256(W[i - 2]), W[i - 7], $4b65dd591dedf929$var$g0_256(W[i - 15]), W[i - 16]);
    var a = this.h[0];
    var b = this.h[1];
    var c = this.h[2];
    var d = this.h[3];
    var e = this.h[4];
    var f = this.h[5];
    var g = this.h[6];
    var h = this.h[7];
    $aJt1P(this.k.length === W.length);
    for(i = 0; i < W.length; i++){
        var T1 = $4b65dd591dedf929$var$sum32_5(h, $4b65dd591dedf929$var$s1_256(e), $4b65dd591dedf929$var$ch32(e, f, g), this.k[i], W[i]);
        var T2 = $4b65dd591dedf929$var$sum32($4b65dd591dedf929$var$s0_256(a), $4b65dd591dedf929$var$maj32(a, b, c));
        h = g;
        g = f;
        f = e;
        e = $4b65dd591dedf929$var$sum32(d, T1);
        d = c;
        c = b;
        b = a;
        a = $4b65dd591dedf929$var$sum32(T1, T2);
    }
    this.h[0] = $4b65dd591dedf929$var$sum32(this.h[0], a);
    this.h[1] = $4b65dd591dedf929$var$sum32(this.h[1], b);
    this.h[2] = $4b65dd591dedf929$var$sum32(this.h[2], c);
    this.h[3] = $4b65dd591dedf929$var$sum32(this.h[3], d);
    this.h[4] = $4b65dd591dedf929$var$sum32(this.h[4], e);
    this.h[5] = $4b65dd591dedf929$var$sum32(this.h[5], f);
    this.h[6] = $4b65dd591dedf929$var$sum32(this.h[6], g);
    this.h[7] = $4b65dd591dedf929$var$sum32(this.h[7], h);
};
$4b65dd591dedf929$var$SHA256.prototype._digest = function digest(enc) {
    if (enc === "hex") return $3vltz.toHex32(this.h, "big");
    else return $3vltz.split32(this.h, "big");
};

});


parcelRequire.register("1zFKP", function(module, exports) {
"use strict";

var $3vltz = parcelRequire("3vltz");

var $b8Cnj = parcelRequire("b8Cnj");
function $125972e0f41acdab$var$SHA384() {
    if (!(this instanceof $125972e0f41acdab$var$SHA384)) return new $125972e0f41acdab$var$SHA384();
    $b8Cnj.call(this);
    this.h = [
        0xcbbb9d5d,
        0xc1059ed8,
        0x629a292a,
        0x367cd507,
        0x9159015a,
        0x3070dd17,
        0x152fecd8,
        0xf70e5939,
        0x67332667,
        0xffc00b31,
        0x8eb44a87,
        0x68581511,
        0xdb0c2e0d,
        0x64f98fa7,
        0x47b5481d,
        0xbefa4fa4
    ];
}
$3vltz.inherits($125972e0f41acdab$var$SHA384, $b8Cnj);
module.exports = $125972e0f41acdab$var$SHA384;
$125972e0f41acdab$var$SHA384.blockSize = 1024;
$125972e0f41acdab$var$SHA384.outSize = 384;
$125972e0f41acdab$var$SHA384.hmacStrength = 192;
$125972e0f41acdab$var$SHA384.padLength = 128;
$125972e0f41acdab$var$SHA384.prototype._digest = function digest(enc) {
    if (enc === "hex") return $3vltz.toHex32(this.h.slice(0, 12), "big");
    else return $3vltz.split32(this.h.slice(0, 12), "big");
};

});
parcelRequire.register("b8Cnj", function(module, exports) {
"use strict";

var $3vltz = parcelRequire("3vltz");

var $hoO3s = parcelRequire("hoO3s");

var $aJt1P = parcelRequire("aJt1P");
var $81be358d8f6abcff$var$rotr64_hi = $3vltz.rotr64_hi;
var $81be358d8f6abcff$var$rotr64_lo = $3vltz.rotr64_lo;
var $81be358d8f6abcff$var$shr64_hi = $3vltz.shr64_hi;
var $81be358d8f6abcff$var$shr64_lo = $3vltz.shr64_lo;
var $81be358d8f6abcff$var$sum64 = $3vltz.sum64;
var $81be358d8f6abcff$var$sum64_hi = $3vltz.sum64_hi;
var $81be358d8f6abcff$var$sum64_lo = $3vltz.sum64_lo;
var $81be358d8f6abcff$var$sum64_4_hi = $3vltz.sum64_4_hi;
var $81be358d8f6abcff$var$sum64_4_lo = $3vltz.sum64_4_lo;
var $81be358d8f6abcff$var$sum64_5_hi = $3vltz.sum64_5_hi;
var $81be358d8f6abcff$var$sum64_5_lo = $3vltz.sum64_5_lo;
var $81be358d8f6abcff$var$BlockHash = $hoO3s.BlockHash;
var $81be358d8f6abcff$var$sha512_K = [
    0x428a2f98,
    0xd728ae22,
    0x71374491,
    0x23ef65cd,
    0xb5c0fbcf,
    0xec4d3b2f,
    0xe9b5dba5,
    0x8189dbbc,
    0x3956c25b,
    0xf348b538,
    0x59f111f1,
    0xb605d019,
    0x923f82a4,
    0xaf194f9b,
    0xab1c5ed5,
    0xda6d8118,
    0xd807aa98,
    0xa3030242,
    0x12835b01,
    0x45706fbe,
    0x243185be,
    0x4ee4b28c,
    0x550c7dc3,
    0xd5ffb4e2,
    0x72be5d74,
    0xf27b896f,
    0x80deb1fe,
    0x3b1696b1,
    0x9bdc06a7,
    0x25c71235,
    0xc19bf174,
    0xcf692694,
    0xe49b69c1,
    0x9ef14ad2,
    0xefbe4786,
    0x384f25e3,
    0x0fc19dc6,
    0x8b8cd5b5,
    0x240ca1cc,
    0x77ac9c65,
    0x2de92c6f,
    0x592b0275,
    0x4a7484aa,
    0x6ea6e483,
    0x5cb0a9dc,
    0xbd41fbd4,
    0x76f988da,
    0x831153b5,
    0x983e5152,
    0xee66dfab,
    0xa831c66d,
    0x2db43210,
    0xb00327c8,
    0x98fb213f,
    0xbf597fc7,
    0xbeef0ee4,
    0xc6e00bf3,
    0x3da88fc2,
    0xd5a79147,
    0x930aa725,
    0x06ca6351,
    0xe003826f,
    0x14292967,
    0x0a0e6e70,
    0x27b70a85,
    0x46d22ffc,
    0x2e1b2138,
    0x5c26c926,
    0x4d2c6dfc,
    0x5ac42aed,
    0x53380d13,
    0x9d95b3df,
    0x650a7354,
    0x8baf63de,
    0x766a0abb,
    0x3c77b2a8,
    0x81c2c92e,
    0x47edaee6,
    0x92722c85,
    0x1482353b,
    0xa2bfe8a1,
    0x4cf10364,
    0xa81a664b,
    0xbc423001,
    0xc24b8b70,
    0xd0f89791,
    0xc76c51a3,
    0x0654be30,
    0xd192e819,
    0xd6ef5218,
    0xd6990624,
    0x5565a910,
    0xf40e3585,
    0x5771202a,
    0x106aa070,
    0x32bbd1b8,
    0x19a4c116,
    0xb8d2d0c8,
    0x1e376c08,
    0x5141ab53,
    0x2748774c,
    0xdf8eeb99,
    0x34b0bcb5,
    0xe19b48a8,
    0x391c0cb3,
    0xc5c95a63,
    0x4ed8aa4a,
    0xe3418acb,
    0x5b9cca4f,
    0x7763e373,
    0x682e6ff3,
    0xd6b2b8a3,
    0x748f82ee,
    0x5defb2fc,
    0x78a5636f,
    0x43172f60,
    0x84c87814,
    0xa1f0ab72,
    0x8cc70208,
    0x1a6439ec,
    0x90befffa,
    0x23631e28,
    0xa4506ceb,
    0xde82bde9,
    0xbef9a3f7,
    0xb2c67915,
    0xc67178f2,
    0xe372532b,
    0xca273ece,
    0xea26619c,
    0xd186b8c7,
    0x21c0c207,
    0xeada7dd6,
    0xcde0eb1e,
    0xf57d4f7f,
    0xee6ed178,
    0x06f067aa,
    0x72176fba,
    0x0a637dc5,
    0xa2c898a6,
    0x113f9804,
    0xbef90dae,
    0x1b710b35,
    0x131c471b,
    0x28db77f5,
    0x23047d84,
    0x32caab7b,
    0x40c72493,
    0x3c9ebe0a,
    0x15c9bebc,
    0x431d67c4,
    0x9c100d4c,
    0x4cc5d4be,
    0xcb3e42b6,
    0x597f299c,
    0xfc657e2a,
    0x5fcb6fab,
    0x3ad6faec,
    0x6c44198c,
    0x4a475817
];
function $81be358d8f6abcff$var$SHA512() {
    if (!(this instanceof $81be358d8f6abcff$var$SHA512)) return new $81be358d8f6abcff$var$SHA512();
    $81be358d8f6abcff$var$BlockHash.call(this);
    this.h = [
        0x6a09e667,
        0xf3bcc908,
        0xbb67ae85,
        0x84caa73b,
        0x3c6ef372,
        0xfe94f82b,
        0xa54ff53a,
        0x5f1d36f1,
        0x510e527f,
        0xade682d1,
        0x9b05688c,
        0x2b3e6c1f,
        0x1f83d9ab,
        0xfb41bd6b,
        0x5be0cd19,
        0x137e2179
    ];
    this.k = $81be358d8f6abcff$var$sha512_K;
    this.W = new Array(160);
}
$3vltz.inherits($81be358d8f6abcff$var$SHA512, $81be358d8f6abcff$var$BlockHash);
module.exports = $81be358d8f6abcff$var$SHA512;
$81be358d8f6abcff$var$SHA512.blockSize = 1024;
$81be358d8f6abcff$var$SHA512.outSize = 512;
$81be358d8f6abcff$var$SHA512.hmacStrength = 192;
$81be358d8f6abcff$var$SHA512.padLength = 128;
$81be358d8f6abcff$var$SHA512.prototype._prepareBlock = function _prepareBlock(msg, start) {
    var W = this.W;
    // 32 x 32bit words
    for(var i = 0; i < 32; i++)W[i] = msg[start + i];
    for(; i < W.length; i += 2){
        var c0_hi = $81be358d8f6abcff$var$g1_512_hi(W[i - 4], W[i - 3]); // i - 2
        var c0_lo = $81be358d8f6abcff$var$g1_512_lo(W[i - 4], W[i - 3]);
        var c1_hi = W[i - 14]; // i - 7
        var c1_lo = W[i - 13];
        var c2_hi = $81be358d8f6abcff$var$g0_512_hi(W[i - 30], W[i - 29]); // i - 15
        var c2_lo = $81be358d8f6abcff$var$g0_512_lo(W[i - 30], W[i - 29]);
        var c3_hi = W[i - 32]; // i - 16
        var c3_lo = W[i - 31];
        W[i] = $81be358d8f6abcff$var$sum64_4_hi(c0_hi, c0_lo, c1_hi, c1_lo, c2_hi, c2_lo, c3_hi, c3_lo);
        W[i + 1] = $81be358d8f6abcff$var$sum64_4_lo(c0_hi, c0_lo, c1_hi, c1_lo, c2_hi, c2_lo, c3_hi, c3_lo);
    }
};
$81be358d8f6abcff$var$SHA512.prototype._update = function _update(msg, start) {
    this._prepareBlock(msg, start);
    var W = this.W;
    var ah = this.h[0];
    var al = this.h[1];
    var bh = this.h[2];
    var bl = this.h[3];
    var ch = this.h[4];
    var cl = this.h[5];
    var dh = this.h[6];
    var dl = this.h[7];
    var eh = this.h[8];
    var el = this.h[9];
    var fh = this.h[10];
    var fl = this.h[11];
    var gh = this.h[12];
    var gl = this.h[13];
    var hh = this.h[14];
    var hl = this.h[15];
    $aJt1P(this.k.length === W.length);
    for(var i = 0; i < W.length; i += 2){
        var c0_hi = hh;
        var c0_lo = hl;
        var c1_hi = $81be358d8f6abcff$var$s1_512_hi(eh, el);
        var c1_lo = $81be358d8f6abcff$var$s1_512_lo(eh, el);
        var c2_hi = $81be358d8f6abcff$var$ch64_hi(eh, el, fh, fl, gh, gl);
        var c2_lo = $81be358d8f6abcff$var$ch64_lo(eh, el, fh, fl, gh, gl);
        var c3_hi = this.k[i];
        var c3_lo = this.k[i + 1];
        var c4_hi = W[i];
        var c4_lo = W[i + 1];
        var T1_hi = $81be358d8f6abcff$var$sum64_5_hi(c0_hi, c0_lo, c1_hi, c1_lo, c2_hi, c2_lo, c3_hi, c3_lo, c4_hi, c4_lo);
        var T1_lo = $81be358d8f6abcff$var$sum64_5_lo(c0_hi, c0_lo, c1_hi, c1_lo, c2_hi, c2_lo, c3_hi, c3_lo, c4_hi, c4_lo);
        c0_hi = $81be358d8f6abcff$var$s0_512_hi(ah, al);
        c0_lo = $81be358d8f6abcff$var$s0_512_lo(ah, al);
        c1_hi = $81be358d8f6abcff$var$maj64_hi(ah, al, bh, bl, ch, cl);
        c1_lo = $81be358d8f6abcff$var$maj64_lo(ah, al, bh, bl, ch, cl);
        var T2_hi = $81be358d8f6abcff$var$sum64_hi(c0_hi, c0_lo, c1_hi, c1_lo);
        var T2_lo = $81be358d8f6abcff$var$sum64_lo(c0_hi, c0_lo, c1_hi, c1_lo);
        hh = gh;
        hl = gl;
        gh = fh;
        gl = fl;
        fh = eh;
        fl = el;
        eh = $81be358d8f6abcff$var$sum64_hi(dh, dl, T1_hi, T1_lo);
        el = $81be358d8f6abcff$var$sum64_lo(dl, dl, T1_hi, T1_lo);
        dh = ch;
        dl = cl;
        ch = bh;
        cl = bl;
        bh = ah;
        bl = al;
        ah = $81be358d8f6abcff$var$sum64_hi(T1_hi, T1_lo, T2_hi, T2_lo);
        al = $81be358d8f6abcff$var$sum64_lo(T1_hi, T1_lo, T2_hi, T2_lo);
    }
    $81be358d8f6abcff$var$sum64(this.h, 0, ah, al);
    $81be358d8f6abcff$var$sum64(this.h, 2, bh, bl);
    $81be358d8f6abcff$var$sum64(this.h, 4, ch, cl);
    $81be358d8f6abcff$var$sum64(this.h, 6, dh, dl);
    $81be358d8f6abcff$var$sum64(this.h, 8, eh, el);
    $81be358d8f6abcff$var$sum64(this.h, 10, fh, fl);
    $81be358d8f6abcff$var$sum64(this.h, 12, gh, gl);
    $81be358d8f6abcff$var$sum64(this.h, 14, hh, hl);
};
$81be358d8f6abcff$var$SHA512.prototype._digest = function digest(enc) {
    if (enc === "hex") return $3vltz.toHex32(this.h, "big");
    else return $3vltz.split32(this.h, "big");
};
function $81be358d8f6abcff$var$ch64_hi(xh, xl, yh, yl, zh) {
    var r = xh & yh ^ ~xh & zh;
    if (r < 0) r += 0x100000000;
    return r;
}
function $81be358d8f6abcff$var$ch64_lo(xh, xl, yh, yl, zh, zl) {
    var r = xl & yl ^ ~xl & zl;
    if (r < 0) r += 0x100000000;
    return r;
}
function $81be358d8f6abcff$var$maj64_hi(xh, xl, yh, yl, zh) {
    var r = xh & yh ^ xh & zh ^ yh & zh;
    if (r < 0) r += 0x100000000;
    return r;
}
function $81be358d8f6abcff$var$maj64_lo(xh, xl, yh, yl, zh, zl) {
    var r = xl & yl ^ xl & zl ^ yl & zl;
    if (r < 0) r += 0x100000000;
    return r;
}
function $81be358d8f6abcff$var$s0_512_hi(xh, xl) {
    var c0_hi = $81be358d8f6abcff$var$rotr64_hi(xh, xl, 28);
    var c1_hi = $81be358d8f6abcff$var$rotr64_hi(xl, xh, 2); // 34
    var c2_hi = $81be358d8f6abcff$var$rotr64_hi(xl, xh, 7); // 39
    var r = c0_hi ^ c1_hi ^ c2_hi;
    if (r < 0) r += 0x100000000;
    return r;
}
function $81be358d8f6abcff$var$s0_512_lo(xh, xl) {
    var c0_lo = $81be358d8f6abcff$var$rotr64_lo(xh, xl, 28);
    var c1_lo = $81be358d8f6abcff$var$rotr64_lo(xl, xh, 2); // 34
    var c2_lo = $81be358d8f6abcff$var$rotr64_lo(xl, xh, 7); // 39
    var r = c0_lo ^ c1_lo ^ c2_lo;
    if (r < 0) r += 0x100000000;
    return r;
}
function $81be358d8f6abcff$var$s1_512_hi(xh, xl) {
    var c0_hi = $81be358d8f6abcff$var$rotr64_hi(xh, xl, 14);
    var c1_hi = $81be358d8f6abcff$var$rotr64_hi(xh, xl, 18);
    var c2_hi = $81be358d8f6abcff$var$rotr64_hi(xl, xh, 9); // 41
    var r = c0_hi ^ c1_hi ^ c2_hi;
    if (r < 0) r += 0x100000000;
    return r;
}
function $81be358d8f6abcff$var$s1_512_lo(xh, xl) {
    var c0_lo = $81be358d8f6abcff$var$rotr64_lo(xh, xl, 14);
    var c1_lo = $81be358d8f6abcff$var$rotr64_lo(xh, xl, 18);
    var c2_lo = $81be358d8f6abcff$var$rotr64_lo(xl, xh, 9); // 41
    var r = c0_lo ^ c1_lo ^ c2_lo;
    if (r < 0) r += 0x100000000;
    return r;
}
function $81be358d8f6abcff$var$g0_512_hi(xh, xl) {
    var c0_hi = $81be358d8f6abcff$var$rotr64_hi(xh, xl, 1);
    var c1_hi = $81be358d8f6abcff$var$rotr64_hi(xh, xl, 8);
    var c2_hi = $81be358d8f6abcff$var$shr64_hi(xh, xl, 7);
    var r = c0_hi ^ c1_hi ^ c2_hi;
    if (r < 0) r += 0x100000000;
    return r;
}
function $81be358d8f6abcff$var$g0_512_lo(xh, xl) {
    var c0_lo = $81be358d8f6abcff$var$rotr64_lo(xh, xl, 1);
    var c1_lo = $81be358d8f6abcff$var$rotr64_lo(xh, xl, 8);
    var c2_lo = $81be358d8f6abcff$var$shr64_lo(xh, xl, 7);
    var r = c0_lo ^ c1_lo ^ c2_lo;
    if (r < 0) r += 0x100000000;
    return r;
}
function $81be358d8f6abcff$var$g1_512_hi(xh, xl) {
    var c0_hi = $81be358d8f6abcff$var$rotr64_hi(xh, xl, 19);
    var c1_hi = $81be358d8f6abcff$var$rotr64_hi(xl, xh, 29); // 61
    var c2_hi = $81be358d8f6abcff$var$shr64_hi(xh, xl, 6);
    var r = c0_hi ^ c1_hi ^ c2_hi;
    if (r < 0) r += 0x100000000;
    return r;
}
function $81be358d8f6abcff$var$g1_512_lo(xh, xl) {
    var c0_lo = $81be358d8f6abcff$var$rotr64_lo(xh, xl, 19);
    var c1_lo = $81be358d8f6abcff$var$rotr64_lo(xl, xh, 29); // 61
    var c2_lo = $81be358d8f6abcff$var$shr64_lo(xh, xl, 6);
    var r = c0_lo ^ c1_lo ^ c2_lo;
    if (r < 0) r += 0x100000000;
    return r;
}

});



parcelRequire.register("ak1PH", function(module, exports) {

$parcel$export(module.exports, "ripemd160", function () { return $783d3195a6b3253e$export$d1cea0ee4e3f0d3e; }, function (v) { return $783d3195a6b3253e$export$d1cea0ee4e3f0d3e = v; });
var $783d3195a6b3253e$export$d1cea0ee4e3f0d3e;
"use strict";

var $3vltz = parcelRequire("3vltz");

var $hoO3s = parcelRequire("hoO3s");
var $783d3195a6b3253e$var$rotl32 = $3vltz.rotl32;
var $783d3195a6b3253e$var$sum32 = $3vltz.sum32;
var $783d3195a6b3253e$var$sum32_3 = $3vltz.sum32_3;
var $783d3195a6b3253e$var$sum32_4 = $3vltz.sum32_4;
var $783d3195a6b3253e$var$BlockHash = $hoO3s.BlockHash;
function $783d3195a6b3253e$var$RIPEMD160() {
    if (!(this instanceof $783d3195a6b3253e$var$RIPEMD160)) return new $783d3195a6b3253e$var$RIPEMD160();
    $783d3195a6b3253e$var$BlockHash.call(this);
    this.h = [
        0x67452301,
        0xefcdab89,
        0x98badcfe,
        0x10325476,
        0xc3d2e1f0
    ];
    this.endian = "little";
}
$3vltz.inherits($783d3195a6b3253e$var$RIPEMD160, $783d3195a6b3253e$var$BlockHash);
$783d3195a6b3253e$export$d1cea0ee4e3f0d3e = $783d3195a6b3253e$var$RIPEMD160;
$783d3195a6b3253e$var$RIPEMD160.blockSize = 512;
$783d3195a6b3253e$var$RIPEMD160.outSize = 160;
$783d3195a6b3253e$var$RIPEMD160.hmacStrength = 192;
$783d3195a6b3253e$var$RIPEMD160.padLength = 64;
$783d3195a6b3253e$var$RIPEMD160.prototype._update = function update(msg, start) {
    var A = this.h[0];
    var B = this.h[1];
    var C = this.h[2];
    var D = this.h[3];
    var E = this.h[4];
    var Ah = A;
    var Bh = B;
    var Ch = C;
    var Dh = D;
    var Eh = E;
    for(var j = 0; j < 80; j++){
        var T = $783d3195a6b3253e$var$sum32($783d3195a6b3253e$var$rotl32($783d3195a6b3253e$var$sum32_4(A, $783d3195a6b3253e$var$f(j, B, C, D), msg[$783d3195a6b3253e$var$r[j] + start], $783d3195a6b3253e$var$K(j)), $783d3195a6b3253e$var$s[j]), E);
        A = E;
        E = D;
        D = $783d3195a6b3253e$var$rotl32(C, 10);
        C = B;
        B = T;
        T = $783d3195a6b3253e$var$sum32($783d3195a6b3253e$var$rotl32($783d3195a6b3253e$var$sum32_4(Ah, $783d3195a6b3253e$var$f(79 - j, Bh, Ch, Dh), msg[$783d3195a6b3253e$var$rh[j] + start], $783d3195a6b3253e$var$Kh(j)), $783d3195a6b3253e$var$sh[j]), Eh);
        Ah = Eh;
        Eh = Dh;
        Dh = $783d3195a6b3253e$var$rotl32(Ch, 10);
        Ch = Bh;
        Bh = T;
    }
    T = $783d3195a6b3253e$var$sum32_3(this.h[1], C, Dh);
    this.h[1] = $783d3195a6b3253e$var$sum32_3(this.h[2], D, Eh);
    this.h[2] = $783d3195a6b3253e$var$sum32_3(this.h[3], E, Ah);
    this.h[3] = $783d3195a6b3253e$var$sum32_3(this.h[4], A, Bh);
    this.h[4] = $783d3195a6b3253e$var$sum32_3(this.h[0], B, Ch);
    this.h[0] = T;
};
$783d3195a6b3253e$var$RIPEMD160.prototype._digest = function digest(enc) {
    if (enc === "hex") return $3vltz.toHex32(this.h, "little");
    else return $3vltz.split32(this.h, "little");
};
function $783d3195a6b3253e$var$f(j, x, y, z) {
    if (j <= 15) return x ^ y ^ z;
    else if (j <= 31) return x & y | ~x & z;
    else if (j <= 47) return (x | ~y) ^ z;
    else if (j <= 63) return x & z | y & ~z;
    else return x ^ (y | ~z);
}
function $783d3195a6b3253e$var$K(j) {
    if (j <= 15) return 0x00000000;
    else if (j <= 31) return 0x5a827999;
    else if (j <= 47) return 0x6ed9eba1;
    else if (j <= 63) return 0x8f1bbcdc;
    else return 0xa953fd4e;
}
function $783d3195a6b3253e$var$Kh(j) {
    if (j <= 15) return 0x50a28be6;
    else if (j <= 31) return 0x5c4dd124;
    else if (j <= 47) return 0x6d703ef3;
    else if (j <= 63) return 0x7a6d76e9;
    else return 0x00000000;
}
var $783d3195a6b3253e$var$r = [
    0,
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10,
    11,
    12,
    13,
    14,
    15,
    7,
    4,
    13,
    1,
    10,
    6,
    15,
    3,
    12,
    0,
    9,
    5,
    2,
    14,
    11,
    8,
    3,
    10,
    14,
    4,
    9,
    15,
    8,
    1,
    2,
    7,
    0,
    6,
    13,
    11,
    5,
    12,
    1,
    9,
    11,
    10,
    0,
    8,
    12,
    4,
    13,
    3,
    7,
    15,
    14,
    5,
    6,
    2,
    4,
    0,
    5,
    9,
    7,
    12,
    2,
    10,
    14,
    1,
    3,
    8,
    11,
    6,
    15,
    13
];
var $783d3195a6b3253e$var$rh = [
    5,
    14,
    7,
    0,
    9,
    2,
    11,
    4,
    13,
    6,
    15,
    8,
    1,
    10,
    3,
    12,
    6,
    11,
    3,
    7,
    0,
    13,
    5,
    10,
    14,
    15,
    8,
    12,
    4,
    9,
    1,
    2,
    15,
    5,
    1,
    3,
    7,
    14,
    6,
    9,
    11,
    8,
    12,
    2,
    10,
    0,
    4,
    13,
    8,
    6,
    4,
    1,
    3,
    11,
    15,
    0,
    5,
    12,
    2,
    13,
    9,
    7,
    10,
    14,
    12,
    15,
    10,
    4,
    1,
    5,
    8,
    7,
    6,
    2,
    13,
    14,
    0,
    3,
    9,
    11
];
var $783d3195a6b3253e$var$s = [
    11,
    14,
    15,
    12,
    5,
    8,
    7,
    9,
    11,
    13,
    14,
    15,
    6,
    7,
    9,
    8,
    7,
    6,
    8,
    13,
    11,
    9,
    7,
    15,
    7,
    12,
    15,
    9,
    11,
    7,
    13,
    12,
    11,
    13,
    6,
    7,
    14,
    9,
    13,
    15,
    14,
    8,
    13,
    6,
    5,
    12,
    7,
    5,
    11,
    12,
    14,
    15,
    14,
    15,
    9,
    8,
    9,
    14,
    5,
    6,
    8,
    6,
    5,
    12,
    9,
    15,
    5,
    11,
    6,
    8,
    13,
    12,
    5,
    12,
    13,
    14,
    11,
    8,
    5,
    6
];
var $783d3195a6b3253e$var$sh = [
    8,
    9,
    9,
    11,
    13,
    15,
    15,
    5,
    7,
    7,
    8,
    11,
    14,
    14,
    12,
    6,
    9,
    13,
    15,
    7,
    12,
    8,
    9,
    11,
    7,
    7,
    12,
    7,
    6,
    15,
    13,
    11,
    9,
    7,
    15,
    11,
    8,
    6,
    6,
    14,
    12,
    13,
    5,
    14,
    13,
    13,
    7,
    5,
    15,
    5,
    8,
    11,
    14,
    14,
    6,
    14,
    6,
    9,
    12,
    9,
    12,
    5,
    15,
    8,
    8,
    5,
    12,
    9,
    12,
    5,
    14,
    6,
    8,
    13,
    6,
    5,
    15,
    13,
    11,
    11
];

});

parcelRequire.register("X5z30", function(module, exports) {
"use strict";

var $3vltz = parcelRequire("3vltz");

var $aJt1P = parcelRequire("aJt1P");
function $0b19d3c0f7d555a6$var$Hmac(hash, key, enc) {
    if (!(this instanceof $0b19d3c0f7d555a6$var$Hmac)) return new $0b19d3c0f7d555a6$var$Hmac(hash, key, enc);
    this.Hash = hash;
    this.blockSize = hash.blockSize / 8;
    this.outSize = hash.outSize / 8;
    this.inner = null;
    this.outer = null;
    this._init($3vltz.toArray(key, enc));
}
module.exports = $0b19d3c0f7d555a6$var$Hmac;
$0b19d3c0f7d555a6$var$Hmac.prototype._init = function init(key) {
    // Shorten key, if needed
    if (key.length > this.blockSize) key = new this.Hash().update(key).digest();
    $aJt1P(key.length <= this.blockSize);
    // Add padding to key
    for(var i = key.length; i < this.blockSize; i++)key.push(0);
    for(i = 0; i < key.length; i++)key[i] ^= 0x36;
    this.inner = new this.Hash().update(key);
    // 0x36 ^ 0x5c = 0x6a
    for(i = 0; i < key.length; i++)key[i] ^= 0x6a;
    this.outer = new this.Hash().update(key);
};
$0b19d3c0f7d555a6$var$Hmac.prototype.update = function update(msg, enc) {
    this.inner.update(msg, enc);
    return this;
};
$0b19d3c0f7d555a6$var$Hmac.prototype.digest = function digest(enc) {
    this.outer.update(this.inner.digest());
    return this.outer.digest(enc);
};

});

parcelRequire.register("5wgCY", function(module, exports) {
"use strict";
var $404cd6cca7e8755b$var$ALPHABET = "qpzry9x8gf2tvdw0s3jn54khce6mua7l";
// pre-compute lookup table
var $404cd6cca7e8755b$var$ALPHABET_MAP = {};
for(var $404cd6cca7e8755b$var$z = 0; $404cd6cca7e8755b$var$z < $404cd6cca7e8755b$var$ALPHABET.length; $404cd6cca7e8755b$var$z++){
    var $404cd6cca7e8755b$var$x = $404cd6cca7e8755b$var$ALPHABET.charAt($404cd6cca7e8755b$var$z);
    if ($404cd6cca7e8755b$var$ALPHABET_MAP[$404cd6cca7e8755b$var$x] !== undefined) throw new TypeError($404cd6cca7e8755b$var$x + " is ambiguous");
    $404cd6cca7e8755b$var$ALPHABET_MAP[$404cd6cca7e8755b$var$x] = $404cd6cca7e8755b$var$z;
}
function $404cd6cca7e8755b$var$polymodStep(pre) {
    var b = pre >> 25;
    return (pre & 0x1FFFFFF) << 5 ^ -(b >> 0 & 1) & 0x3b6a57b2 ^ -(b >> 1 & 1) & 0x26508e6d ^ -(b >> 2 & 1) & 0x1ea119fa ^ -(b >> 3 & 1) & 0x3d4233dd ^ -(b >> 4 & 1) & 0x2a1462b3;
}
function $404cd6cca7e8755b$var$prefixChk(prefix) {
    var chk = 1;
    for(var i = 0; i < prefix.length; ++i){
        var c = prefix.charCodeAt(i);
        if (c < 33 || c > 126) return "Invalid prefix (" + prefix + ")";
        chk = $404cd6cca7e8755b$var$polymodStep(chk) ^ c >> 5;
    }
    chk = $404cd6cca7e8755b$var$polymodStep(chk);
    for(i = 0; i < prefix.length; ++i){
        var v = prefix.charCodeAt(i);
        chk = $404cd6cca7e8755b$var$polymodStep(chk) ^ v & 0x1f;
    }
    return chk;
}
function $404cd6cca7e8755b$var$encode(prefix, words, LIMIT) {
    LIMIT = LIMIT || 90;
    if (prefix.length + 7 + words.length > LIMIT) throw new TypeError("Exceeds length limit");
    prefix = prefix.toLowerCase();
    // determine chk mod
    var chk = $404cd6cca7e8755b$var$prefixChk(prefix);
    if (typeof chk === "string") throw new Error(chk);
    var result = prefix + "1";
    for(var i = 0; i < words.length; ++i){
        var x = words[i];
        if (x >> 5 !== 0) throw new Error("Non 5-bit word");
        chk = $404cd6cca7e8755b$var$polymodStep(chk) ^ x;
        result += $404cd6cca7e8755b$var$ALPHABET.charAt(x);
    }
    for(i = 0; i < 6; ++i)chk = $404cd6cca7e8755b$var$polymodStep(chk);
    chk ^= 1;
    for(i = 0; i < 6; ++i){
        var v = chk >> (5 - i) * 5 & 0x1f;
        result += $404cd6cca7e8755b$var$ALPHABET.charAt(v);
    }
    return result;
}
function $404cd6cca7e8755b$var$__decode(str, LIMIT) {
    LIMIT = LIMIT || 90;
    if (str.length < 8) return str + " too short";
    if (str.length > LIMIT) return "Exceeds length limit";
    // don't allow mixed case
    var lowered = str.toLowerCase();
    var uppered = str.toUpperCase();
    if (str !== lowered && str !== uppered) return "Mixed-case string " + str;
    str = lowered;
    var split = str.lastIndexOf("1");
    if (split === -1) return "No separator character for " + str;
    if (split === 0) return "Missing prefix for " + str;
    var prefix = str.slice(0, split);
    var wordChars = str.slice(split + 1);
    if (wordChars.length < 6) return "Data too short";
    var chk = $404cd6cca7e8755b$var$prefixChk(prefix);
    if (typeof chk === "string") return chk;
    var words = [];
    for(var i = 0; i < wordChars.length; ++i){
        var c = wordChars.charAt(i);
        var v = $404cd6cca7e8755b$var$ALPHABET_MAP[c];
        if (v === undefined) return "Unknown character " + c;
        chk = $404cd6cca7e8755b$var$polymodStep(chk) ^ v;
        // not in the checksum?
        if (i + 6 >= wordChars.length) continue;
        words.push(v);
    }
    if (chk !== 1) return "Invalid checksum for " + str;
    return {
        prefix: prefix,
        words: words
    };
}
function $404cd6cca7e8755b$var$decodeUnsafe() {
    var res = $404cd6cca7e8755b$var$__decode.apply(null, arguments);
    if (typeof res === "object") return res;
}
function $404cd6cca7e8755b$var$decode(str) {
    var res = $404cd6cca7e8755b$var$__decode.apply(null, arguments);
    if (typeof res === "object") return res;
    throw new Error(res);
}
function $404cd6cca7e8755b$var$convert(data, inBits, outBits, pad) {
    var value = 0;
    var bits = 0;
    var maxV = (1 << outBits) - 1;
    var result = [];
    for(var i = 0; i < data.length; ++i){
        value = value << inBits | data[i];
        bits += inBits;
        while(bits >= outBits){
            bits -= outBits;
            result.push(value >> bits & maxV);
        }
    }
    if (pad) {
        if (bits > 0) result.push(value << outBits - bits & maxV);
    } else {
        if (bits >= inBits) return "Excess padding";
        if (value << outBits - bits & maxV) return "Non-zero padding";
    }
    return result;
}
function $404cd6cca7e8755b$var$toWordsUnsafe(bytes) {
    var res = $404cd6cca7e8755b$var$convert(bytes, 8, 5, true);
    if (Array.isArray(res)) return res;
}
function $404cd6cca7e8755b$var$toWords(bytes) {
    var res = $404cd6cca7e8755b$var$convert(bytes, 8, 5, true);
    if (Array.isArray(res)) return res;
    throw new Error(res);
}
function $404cd6cca7e8755b$var$fromWordsUnsafe(words) {
    var res = $404cd6cca7e8755b$var$convert(words, 5, 8, false);
    if (Array.isArray(res)) return res;
}
function $404cd6cca7e8755b$var$fromWords(words) {
    var res = $404cd6cca7e8755b$var$convert(words, 5, 8, false);
    if (Array.isArray(res)) return res;
    throw new Error(res);
}
module.exports = {
    decodeUnsafe: $404cd6cca7e8755b$var$decodeUnsafe,
    decode: $404cd6cca7e8755b$var$decode,
    encode: $404cd6cca7e8755b$var$encode,
    toWordsUnsafe: $404cd6cca7e8755b$var$toWordsUnsafe,
    toWords: $404cd6cca7e8755b$var$toWords,
    fromWordsUnsafe: $404cd6cca7e8755b$var$fromWordsUnsafe,
    fromWords: $404cd6cca7e8755b$var$fromWords
};

});

parcelRequire.register("9we9E", function(module, exports) {

(function(module1, exports) {
    "use strict";
    // Utils
    function assert(val, msg) {
        if (!val) throw new Error(msg || "Assertion failed");
    }
    // Could use `inherits` module, but don't want to move from single file
    // architecture yet.
    function inherits(ctor, superCtor) {
        ctor.super_ = superCtor;
        var TempCtor = function() {};
        TempCtor.prototype = superCtor.prototype;
        ctor.prototype = new TempCtor();
        ctor.prototype.constructor = ctor;
    }
    // BN
    function BN(number, base, endian) {
        if (BN.isBN(number)) return number;
        this.negative = 0;
        this.words = null;
        this.length = 0;
        // Reduction context
        this.red = null;
        if (number !== null) {
            if (base === "le" || base === "be") {
                endian = base;
                base = 10;
            }
            this._init(number || 0, base || 10, endian || "be");
        }
    }
    if (typeof module1 === "object") module1.exports = BN;
    else exports.BN = BN;
    BN.BN = BN;
    BN.wordSize = 26;
    var Buffer;
    try {
        if (typeof window !== "undefined" && typeof window.Buffer !== "undefined") Buffer = window.Buffer;
        else Buffer = (parcelRequire("5Io6y")).Buffer;
    } catch (e) {}
    BN.isBN = function isBN(num) {
        if (num instanceof BN) return true;
        return num !== null && typeof num === "object" && num.constructor.wordSize === BN.wordSize && Array.isArray(num.words);
    };
    BN.max = function max(left, right) {
        if (left.cmp(right) > 0) return left;
        return right;
    };
    BN.min = function min(left, right) {
        if (left.cmp(right) < 0) return left;
        return right;
    };
    BN.prototype._init = function init(number, base, endian) {
        if (typeof number === "number") return this._initNumber(number, base, endian);
        if (typeof number === "object") return this._initArray(number, base, endian);
        if (base === "hex") base = 16;
        assert(base === (base | 0) && base >= 2 && base <= 36);
        number = number.toString().replace(/\s+/g, "");
        var start = 0;
        if (number[0] === "-") {
            start++;
            this.negative = 1;
        }
        if (start < number.length) {
            if (base === 16) this._parseHex(number, start, endian);
            else {
                this._parseBase(number, base, start);
                if (endian === "le") this._initArray(this.toArray(), base, endian);
            }
        }
    };
    BN.prototype._initNumber = function _initNumber(number, base, endian) {
        if (number < 0) {
            this.negative = 1;
            number = -number;
        }
        if (number < 0x4000000) {
            this.words = [
                number & 0x3ffffff
            ];
            this.length = 1;
        } else if (number < 0x10000000000000) {
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff
            ];
            this.length = 2;
        } else {
            assert(number < 0x20000000000000); // 2 ^ 53 (unsafe)
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff,
                1
            ];
            this.length = 3;
        }
        if (endian !== "le") return;
        // Reverse the bytes
        this._initArray(this.toArray(), base, endian);
    };
    BN.prototype._initArray = function _initArray(number, base, endian) {
        // Perhaps a Uint8Array
        assert(typeof number.length === "number");
        if (number.length <= 0) {
            this.words = [
                0
            ];
            this.length = 1;
            return this;
        }
        this.length = Math.ceil(number.length / 3);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        var j, w;
        var off = 0;
        if (endian === "be") for(i = number.length - 1, j = 0; i >= 0; i -= 3){
            w = number[i] | number[i - 1] << 8 | number[i - 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        else if (endian === "le") for(i = 0, j = 0; i < number.length; i += 3){
            w = number[i] | number[i + 1] << 8 | number[i + 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        return this._strip();
    };
    function parseHex4Bits(string, index) {
        var c = string.charCodeAt(index);
        // '0' - '9'
        if (c >= 48 && c <= 57) return c - 48;
        else if (c >= 65 && c <= 70) return c - 55;
        else if (c >= 97 && c <= 102) return c - 87;
        else assert(false, "Invalid character in " + string);
    }
    function parseHexByte(string, lowerBound, index) {
        var r = parseHex4Bits(string, index);
        if (index - 1 >= lowerBound) r |= parseHex4Bits(string, index - 1) << 4;
        return r;
    }
    BN.prototype._parseHex = function _parseHex(number, start, endian) {
        // Create possibly bigger array to ensure that it fits the number
        this.length = Math.ceil((number.length - start) / 6);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        // 24-bits chunks
        var off = 0;
        var j = 0;
        var w;
        if (endian === "be") for(i = number.length - 1; i >= start; i -= 2){
            w = parseHexByte(number, start, i) << off;
            this.words[j] |= w & 0x3ffffff;
            if (off >= 18) {
                off -= 18;
                j += 1;
                this.words[j] |= w >>> 26;
            } else off += 8;
        }
        else {
            var parseLength = number.length - start;
            for(i = parseLength % 2 === 0 ? start + 1 : start; i < number.length; i += 2){
                w = parseHexByte(number, start, i) << off;
                this.words[j] |= w & 0x3ffffff;
                if (off >= 18) {
                    off -= 18;
                    j += 1;
                    this.words[j] |= w >>> 26;
                } else off += 8;
            }
        }
        this._strip();
    };
    function parseBase(str, start, end, mul) {
        var r = 0;
        var b = 0;
        var len = Math.min(str.length, end);
        for(var i = start; i < len; i++){
            var c = str.charCodeAt(i) - 48;
            r *= mul;
            // 'a'
            if (c >= 49) b = c - 49 + 0xa;
            else if (c >= 17) b = c - 17 + 0xa;
            else b = c;
            assert(c >= 0 && b < mul, "Invalid character");
            r += b;
        }
        return r;
    }
    BN.prototype._parseBase = function _parseBase(number, base, start) {
        // Initialize as zero
        this.words = [
            0
        ];
        this.length = 1;
        // Find length of limb in base
        for(var limbLen = 0, limbPow = 1; limbPow <= 0x3ffffff; limbPow *= base)limbLen++;
        limbLen--;
        limbPow = limbPow / base | 0;
        var total = number.length - start;
        var mod = total % limbLen;
        var end = Math.min(total, total - mod) + start;
        var word = 0;
        for(var i = start; i < end; i += limbLen){
            word = parseBase(number, i, i + limbLen, base);
            this.imuln(limbPow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        if (mod !== 0) {
            var pow = 1;
            word = parseBase(number, i, number.length, base);
            for(i = 0; i < mod; i++)pow *= base;
            this.imuln(pow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        this._strip();
    };
    BN.prototype.copy = function copy(dest) {
        dest.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)dest.words[i] = this.words[i];
        dest.length = this.length;
        dest.negative = this.negative;
        dest.red = this.red;
    };
    function move(dest, src) {
        dest.words = src.words;
        dest.length = src.length;
        dest.negative = src.negative;
        dest.red = src.red;
    }
    BN.prototype._move = function _move(dest) {
        move(dest, this);
    };
    BN.prototype.clone = function clone() {
        var r = new BN(null);
        this.copy(r);
        return r;
    };
    BN.prototype._expand = function _expand(size) {
        while(this.length < size)this.words[this.length++] = 0;
        return this;
    };
    // Remove leading `0` from `this`
    BN.prototype._strip = function strip() {
        while(this.length > 1 && this.words[this.length - 1] === 0)this.length--;
        return this._normSign();
    };
    BN.prototype._normSign = function _normSign() {
        // -0 = 0
        if (this.length === 1 && this.words[0] === 0) this.negative = 0;
        return this;
    };
    // Check Symbol.for because not everywhere where Symbol defined
    // See https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Symbol#Browser_compatibility
    if (typeof Symbol !== "undefined" && typeof Symbol.for === "function") try {
        BN.prototype[Symbol.for("nodejs.util.inspect.custom")] = inspect;
    } catch (e) {
        BN.prototype.inspect = inspect;
    }
    else BN.prototype.inspect = inspect;
    function inspect() {
        return (this.red ? "<BN-R: " : "<BN: ") + this.toString(16) + ">";
    }
    /*

  var zeros = [];
  var groupSizes = [];
  var groupBases = [];

  var s = '';
  var i = -1;
  while (++i < BN.wordSize) {
    zeros[i] = s;
    s += '0';
  }
  groupSizes[0] = 0;
  groupSizes[1] = 0;
  groupBases[0] = 0;
  groupBases[1] = 0;
  var base = 2 - 1;
  while (++base < 36 + 1) {
    var groupSize = 0;
    var groupBase = 1;
    while (groupBase < (1 << BN.wordSize) / base) {
      groupBase *= base;
      groupSize += 1;
    }
    groupSizes[base] = groupSize;
    groupBases[base] = groupBase;
  }

  */ var zeros = [
        "",
        "0",
        "00",
        "000",
        "0000",
        "00000",
        "000000",
        "0000000",
        "00000000",
        "000000000",
        "0000000000",
        "00000000000",
        "000000000000",
        "0000000000000",
        "00000000000000",
        "000000000000000",
        "0000000000000000",
        "00000000000000000",
        "000000000000000000",
        "0000000000000000000",
        "00000000000000000000",
        "000000000000000000000",
        "0000000000000000000000",
        "00000000000000000000000",
        "000000000000000000000000",
        "0000000000000000000000000"
    ];
    var groupSizes = [
        0,
        0,
        25,
        16,
        12,
        11,
        10,
        9,
        8,
        8,
        7,
        7,
        7,
        7,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5
    ];
    var groupBases = [
        0,
        0,
        33554432,
        43046721,
        16777216,
        48828125,
        60466176,
        40353607,
        16777216,
        43046721,
        10000000,
        19487171,
        35831808,
        62748517,
        7529536,
        11390625,
        16777216,
        24137569,
        34012224,
        47045881,
        64000000,
        4084101,
        5153632,
        6436343,
        7962624,
        9765625,
        11881376,
        14348907,
        17210368,
        20511149,
        24300000,
        28629151,
        33554432,
        39135393,
        45435424,
        52521875,
        60466176
    ];
    BN.prototype.toString = function toString(base, padding) {
        base = base || 10;
        padding = padding | 0 || 1;
        var out;
        if (base === 16 || base === "hex") {
            out = "";
            var off = 0;
            var carry = 0;
            for(var i = 0; i < this.length; i++){
                var w = this.words[i];
                var word = ((w << off | carry) & 0xffffff).toString(16);
                carry = w >>> 24 - off & 0xffffff;
                off += 2;
                if (off >= 26) {
                    off -= 26;
                    i--;
                }
                if (carry !== 0 || i !== this.length - 1) out = zeros[6 - word.length] + word + out;
                else out = word + out;
            }
            if (carry !== 0) out = carry.toString(16) + out;
            while(out.length % padding !== 0)out = "0" + out;
            if (this.negative !== 0) out = "-" + out;
            return out;
        }
        if (base === (base | 0) && base >= 2 && base <= 36) {
            // var groupSize = Math.floor(BN.wordSize * Math.LN2 / Math.log(base));
            var groupSize = groupSizes[base];
            // var groupBase = Math.pow(base, groupSize);
            var groupBase = groupBases[base];
            out = "";
            var c = this.clone();
            c.negative = 0;
            while(!c.isZero()){
                var r = c.modrn(groupBase).toString(base);
                c = c.idivn(groupBase);
                if (!c.isZero()) out = zeros[groupSize - r.length] + r + out;
                else out = r + out;
            }
            if (this.isZero()) out = "0" + out;
            while(out.length % padding !== 0)out = "0" + out;
            if (this.negative !== 0) out = "-" + out;
            return out;
        }
        assert(false, "Base should be between 2 and 36");
    };
    BN.prototype.toNumber = function toNumber() {
        var ret = this.words[0];
        if (this.length === 2) ret += this.words[1] * 0x4000000;
        else if (this.length === 3 && this.words[2] === 0x01) // NOTE: at this stage it is known that the top bit is set
        ret += 0x10000000000000 + this.words[1] * 0x4000000;
        else if (this.length > 2) assert(false, "Number can only safely store up to 53 bits");
        return this.negative !== 0 ? -ret : ret;
    };
    BN.prototype.toJSON = function toJSON() {
        return this.toString(16, 2);
    };
    if (Buffer) BN.prototype.toBuffer = function toBuffer(endian, length) {
        return this.toArrayLike(Buffer, endian, length);
    };
    BN.prototype.toArray = function toArray(endian, length) {
        return this.toArrayLike(Array, endian, length);
    };
    var allocate = function allocate(ArrayType, size) {
        if (ArrayType.allocUnsafe) return ArrayType.allocUnsafe(size);
        return new ArrayType(size);
    };
    BN.prototype.toArrayLike = function toArrayLike(ArrayType, endian, length) {
        this._strip();
        var byteLength = this.byteLength();
        var reqLength = length || Math.max(1, byteLength);
        assert(byteLength <= reqLength, "byte array longer than desired length");
        assert(reqLength > 0, "Requested array length <= 0");
        var res = allocate(ArrayType, reqLength);
        var postfix = endian === "le" ? "LE" : "BE";
        this["_toArrayLike" + postfix](res, byteLength);
        return res;
    };
    BN.prototype._toArrayLikeLE = function _toArrayLikeLE(res, byteLength) {
        var position = 0;
        var carry = 0;
        for(var i = 0, shift = 0; i < this.length; i++){
            var word = this.words[i] << shift | carry;
            res[position++] = word & 0xff;
            if (position < res.length) res[position++] = word >> 8 & 0xff;
            if (position < res.length) res[position++] = word >> 16 & 0xff;
            if (shift === 6) {
                if (position < res.length) res[position++] = word >> 24 & 0xff;
                carry = 0;
                shift = 0;
            } else {
                carry = word >>> 24;
                shift += 2;
            }
        }
        if (position < res.length) {
            res[position++] = carry;
            while(position < res.length)res[position++] = 0;
        }
    };
    BN.prototype._toArrayLikeBE = function _toArrayLikeBE(res, byteLength) {
        var position = res.length - 1;
        var carry = 0;
        for(var i = 0, shift = 0; i < this.length; i++){
            var word = this.words[i] << shift | carry;
            res[position--] = word & 0xff;
            if (position >= 0) res[position--] = word >> 8 & 0xff;
            if (position >= 0) res[position--] = word >> 16 & 0xff;
            if (shift === 6) {
                if (position >= 0) res[position--] = word >> 24 & 0xff;
                carry = 0;
                shift = 0;
            } else {
                carry = word >>> 24;
                shift += 2;
            }
        }
        if (position >= 0) {
            res[position--] = carry;
            while(position >= 0)res[position--] = 0;
        }
    };
    if (Math.clz32) BN.prototype._countBits = function _countBits(w) {
        return 32 - Math.clz32(w);
    };
    else BN.prototype._countBits = function _countBits(w) {
        var t = w;
        var r = 0;
        if (t >= 0x1000) {
            r += 13;
            t >>>= 13;
        }
        if (t >= 0x40) {
            r += 7;
            t >>>= 7;
        }
        if (t >= 0x8) {
            r += 4;
            t >>>= 4;
        }
        if (t >= 0x02) {
            r += 2;
            t >>>= 2;
        }
        return r + t;
    };
    BN.prototype._zeroBits = function _zeroBits(w) {
        // Short-cut
        if (w === 0) return 26;
        var t = w;
        var r = 0;
        if ((t & 0x1fff) === 0) {
            r += 13;
            t >>>= 13;
        }
        if ((t & 0x7f) === 0) {
            r += 7;
            t >>>= 7;
        }
        if ((t & 0xf) === 0) {
            r += 4;
            t >>>= 4;
        }
        if ((t & 0x3) === 0) {
            r += 2;
            t >>>= 2;
        }
        if ((t & 0x1) === 0) r++;
        return r;
    };
    // Return number of used bits in a BN
    BN.prototype.bitLength = function bitLength() {
        var w = this.words[this.length - 1];
        var hi = this._countBits(w);
        return (this.length - 1) * 26 + hi;
    };
    function toBitArray(num) {
        var w = new Array(num.bitLength());
        for(var bit = 0; bit < w.length; bit++){
            var off = bit / 26 | 0;
            var wbit = bit % 26;
            w[bit] = num.words[off] >>> wbit & 0x01;
        }
        return w;
    }
    // Number of trailing zero bits
    BN.prototype.zeroBits = function zeroBits() {
        if (this.isZero()) return 0;
        var r = 0;
        for(var i = 0; i < this.length; i++){
            var b = this._zeroBits(this.words[i]);
            r += b;
            if (b !== 26) break;
        }
        return r;
    };
    BN.prototype.byteLength = function byteLength() {
        return Math.ceil(this.bitLength() / 8);
    };
    BN.prototype.toTwos = function toTwos(width) {
        if (this.negative !== 0) return this.abs().inotn(width).iaddn(1);
        return this.clone();
    };
    BN.prototype.fromTwos = function fromTwos(width) {
        if (this.testn(width - 1)) return this.notn(width).iaddn(1).ineg();
        return this.clone();
    };
    BN.prototype.isNeg = function isNeg() {
        return this.negative !== 0;
    };
    // Return negative clone of `this`
    BN.prototype.neg = function neg() {
        return this.clone().ineg();
    };
    BN.prototype.ineg = function ineg() {
        if (!this.isZero()) this.negative ^= 1;
        return this;
    };
    // Or `num` with `this` in-place
    BN.prototype.iuor = function iuor(num) {
        while(this.length < num.length)this.words[this.length++] = 0;
        for(var i = 0; i < num.length; i++)this.words[i] = this.words[i] | num.words[i];
        return this._strip();
    };
    BN.prototype.ior = function ior(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuor(num);
    };
    // Or `num` with `this`
    BN.prototype.or = function or(num) {
        if (this.length > num.length) return this.clone().ior(num);
        return num.clone().ior(this);
    };
    BN.prototype.uor = function uor(num) {
        if (this.length > num.length) return this.clone().iuor(num);
        return num.clone().iuor(this);
    };
    // And `num` with `this` in-place
    BN.prototype.iuand = function iuand(num) {
        // b = min-length(num, this)
        var b;
        if (this.length > num.length) b = num;
        else b = this;
        for(var i = 0; i < b.length; i++)this.words[i] = this.words[i] & num.words[i];
        this.length = b.length;
        return this._strip();
    };
    BN.prototype.iand = function iand(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuand(num);
    };
    // And `num` with `this`
    BN.prototype.and = function and(num) {
        if (this.length > num.length) return this.clone().iand(num);
        return num.clone().iand(this);
    };
    BN.prototype.uand = function uand(num) {
        if (this.length > num.length) return this.clone().iuand(num);
        return num.clone().iuand(this);
    };
    // Xor `num` with `this` in-place
    BN.prototype.iuxor = function iuxor(num) {
        // a.length > b.length
        var a;
        var b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        for(var i = 0; i < b.length; i++)this.words[i] = a.words[i] ^ b.words[i];
        if (this !== a) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = a.length;
        return this._strip();
    };
    BN.prototype.ixor = function ixor(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuxor(num);
    };
    // Xor `num` with `this`
    BN.prototype.xor = function xor(num) {
        if (this.length > num.length) return this.clone().ixor(num);
        return num.clone().ixor(this);
    };
    BN.prototype.uxor = function uxor(num) {
        if (this.length > num.length) return this.clone().iuxor(num);
        return num.clone().iuxor(this);
    };
    // Not ``this`` with ``width`` bitwidth
    BN.prototype.inotn = function inotn(width) {
        assert(typeof width === "number" && width >= 0);
        var bytesNeeded = Math.ceil(width / 26) | 0;
        var bitsLeft = width % 26;
        // Extend the buffer with leading zeroes
        this._expand(bytesNeeded);
        if (bitsLeft > 0) bytesNeeded--;
        // Handle complete words
        for(var i = 0; i < bytesNeeded; i++)this.words[i] = ~this.words[i] & 0x3ffffff;
        // Handle the residue
        if (bitsLeft > 0) this.words[i] = ~this.words[i] & 0x3ffffff >> 26 - bitsLeft;
        // And remove leading zeroes
        return this._strip();
    };
    BN.prototype.notn = function notn(width) {
        return this.clone().inotn(width);
    };
    // Set `bit` of `this`
    BN.prototype.setn = function setn(bit, val) {
        assert(typeof bit === "number" && bit >= 0);
        var off = bit / 26 | 0;
        var wbit = bit % 26;
        this._expand(off + 1);
        if (val) this.words[off] = this.words[off] | 1 << wbit;
        else this.words[off] = this.words[off] & ~(1 << wbit);
        return this._strip();
    };
    // Add `num` to `this` in-place
    BN.prototype.iadd = function iadd(num) {
        var r;
        // negative + positive
        if (this.negative !== 0 && num.negative === 0) {
            this.negative = 0;
            r = this.isub(num);
            this.negative ^= 1;
            return this._normSign();
        // positive + negative
        } else if (this.negative === 0 && num.negative !== 0) {
            num.negative = 0;
            r = this.isub(num);
            num.negative = 1;
            return r._normSign();
        }
        // a.length > b.length
        var a, b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) + (b.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        this.length = a.length;
        if (carry !== 0) {
            this.words[this.length] = carry;
            this.length++;
        // Copy the rest of the words
        } else if (a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        return this;
    };
    // Add `num` to `this`
    BN.prototype.add = function add(num) {
        var res;
        if (num.negative !== 0 && this.negative === 0) {
            num.negative = 0;
            res = this.sub(num);
            num.negative ^= 1;
            return res;
        } else if (num.negative === 0 && this.negative !== 0) {
            this.negative = 0;
            res = num.sub(this);
            this.negative = 1;
            return res;
        }
        if (this.length > num.length) return this.clone().iadd(num);
        return num.clone().iadd(this);
    };
    // Subtract `num` from `this` in-place
    BN.prototype.isub = function isub(num) {
        // this - (-num) = this + num
        if (num.negative !== 0) {
            num.negative = 0;
            var r = this.iadd(num);
            num.negative = 1;
            return r._normSign();
        // -this - num = -(this + num)
        } else if (this.negative !== 0) {
            this.negative = 0;
            this.iadd(num);
            this.negative = 1;
            return this._normSign();
        }
        // At this point both numbers are positive
        var cmp = this.cmp(num);
        // Optimization - zeroify
        if (cmp === 0) {
            this.negative = 0;
            this.length = 1;
            this.words[0] = 0;
            return this;
        }
        // a > b
        var a, b;
        if (cmp > 0) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) - (b.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        // Copy rest of the words
        if (carry === 0 && i < a.length && a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = Math.max(this.length, i);
        if (a !== this) this.negative = 1;
        return this._strip();
    };
    // Subtract `num` from `this`
    BN.prototype.sub = function sub(num) {
        return this.clone().isub(num);
    };
    function smallMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        var len = self.length + num.length | 0;
        out.length = len;
        len = len - 1 | 0;
        // Peel one iteration (compiler can't do it, because of code complexity)
        var a = self.words[0] | 0;
        var b = num.words[0] | 0;
        var r = a * b;
        var lo = r & 0x3ffffff;
        var carry = r / 0x4000000 | 0;
        out.words[0] = lo;
        for(var k = 1; k < len; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = carry >>> 26;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j | 0;
                a = self.words[i] | 0;
                b = num.words[j] | 0;
                r = a * b + rword;
                ncarry += r / 0x4000000 | 0;
                rword = r & 0x3ffffff;
            }
            out.words[k] = rword | 0;
            carry = ncarry | 0;
        }
        if (carry !== 0) out.words[k] = carry | 0;
        else out.length--;
        return out._strip();
    }
    // TODO(indutny): it may be reasonable to omit it for users who don't need
    // to work with 256-bit numbers, otherwise it gives 20% improvement for 256-bit
    // multiplication (like elliptic secp256k1).
    var comb10MulTo = function comb10MulTo(self, num, out) {
        var a = self.words;
        var b = num.words;
        var o = out.words;
        var c = 0;
        var lo;
        var mid;
        var hi;
        var a0 = a[0] | 0;
        var al0 = a0 & 0x1fff;
        var ah0 = a0 >>> 13;
        var a1 = a[1] | 0;
        var al1 = a1 & 0x1fff;
        var ah1 = a1 >>> 13;
        var a2 = a[2] | 0;
        var al2 = a2 & 0x1fff;
        var ah2 = a2 >>> 13;
        var a3 = a[3] | 0;
        var al3 = a3 & 0x1fff;
        var ah3 = a3 >>> 13;
        var a4 = a[4] | 0;
        var al4 = a4 & 0x1fff;
        var ah4 = a4 >>> 13;
        var a5 = a[5] | 0;
        var al5 = a5 & 0x1fff;
        var ah5 = a5 >>> 13;
        var a6 = a[6] | 0;
        var al6 = a6 & 0x1fff;
        var ah6 = a6 >>> 13;
        var a7 = a[7] | 0;
        var al7 = a7 & 0x1fff;
        var ah7 = a7 >>> 13;
        var a8 = a[8] | 0;
        var al8 = a8 & 0x1fff;
        var ah8 = a8 >>> 13;
        var a9 = a[9] | 0;
        var al9 = a9 & 0x1fff;
        var ah9 = a9 >>> 13;
        var b0 = b[0] | 0;
        var bl0 = b0 & 0x1fff;
        var bh0 = b0 >>> 13;
        var b1 = b[1] | 0;
        var bl1 = b1 & 0x1fff;
        var bh1 = b1 >>> 13;
        var b2 = b[2] | 0;
        var bl2 = b2 & 0x1fff;
        var bh2 = b2 >>> 13;
        var b3 = b[3] | 0;
        var bl3 = b3 & 0x1fff;
        var bh3 = b3 >>> 13;
        var b4 = b[4] | 0;
        var bl4 = b4 & 0x1fff;
        var bh4 = b4 >>> 13;
        var b5 = b[5] | 0;
        var bl5 = b5 & 0x1fff;
        var bh5 = b5 >>> 13;
        var b6 = b[6] | 0;
        var bl6 = b6 & 0x1fff;
        var bh6 = b6 >>> 13;
        var b7 = b[7] | 0;
        var bl7 = b7 & 0x1fff;
        var bh7 = b7 >>> 13;
        var b8 = b[8] | 0;
        var bl8 = b8 & 0x1fff;
        var bh8 = b8 >>> 13;
        var b9 = b[9] | 0;
        var bl9 = b9 & 0x1fff;
        var bh9 = b9 >>> 13;
        out.negative = self.negative ^ num.negative;
        out.length = 19;
        /* k = 0 */ lo = Math.imul(al0, bl0);
        mid = Math.imul(al0, bh0);
        mid = mid + Math.imul(ah0, bl0) | 0;
        hi = Math.imul(ah0, bh0);
        var w0 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w0 >>> 26) | 0;
        w0 &= 0x3ffffff;
        /* k = 1 */ lo = Math.imul(al1, bl0);
        mid = Math.imul(al1, bh0);
        mid = mid + Math.imul(ah1, bl0) | 0;
        hi = Math.imul(ah1, bh0);
        lo = lo + Math.imul(al0, bl1) | 0;
        mid = mid + Math.imul(al0, bh1) | 0;
        mid = mid + Math.imul(ah0, bl1) | 0;
        hi = hi + Math.imul(ah0, bh1) | 0;
        var w1 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w1 >>> 26) | 0;
        w1 &= 0x3ffffff;
        /* k = 2 */ lo = Math.imul(al2, bl0);
        mid = Math.imul(al2, bh0);
        mid = mid + Math.imul(ah2, bl0) | 0;
        hi = Math.imul(ah2, bh0);
        lo = lo + Math.imul(al1, bl1) | 0;
        mid = mid + Math.imul(al1, bh1) | 0;
        mid = mid + Math.imul(ah1, bl1) | 0;
        hi = hi + Math.imul(ah1, bh1) | 0;
        lo = lo + Math.imul(al0, bl2) | 0;
        mid = mid + Math.imul(al0, bh2) | 0;
        mid = mid + Math.imul(ah0, bl2) | 0;
        hi = hi + Math.imul(ah0, bh2) | 0;
        var w2 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w2 >>> 26) | 0;
        w2 &= 0x3ffffff;
        /* k = 3 */ lo = Math.imul(al3, bl0);
        mid = Math.imul(al3, bh0);
        mid = mid + Math.imul(ah3, bl0) | 0;
        hi = Math.imul(ah3, bh0);
        lo = lo + Math.imul(al2, bl1) | 0;
        mid = mid + Math.imul(al2, bh1) | 0;
        mid = mid + Math.imul(ah2, bl1) | 0;
        hi = hi + Math.imul(ah2, bh1) | 0;
        lo = lo + Math.imul(al1, bl2) | 0;
        mid = mid + Math.imul(al1, bh2) | 0;
        mid = mid + Math.imul(ah1, bl2) | 0;
        hi = hi + Math.imul(ah1, bh2) | 0;
        lo = lo + Math.imul(al0, bl3) | 0;
        mid = mid + Math.imul(al0, bh3) | 0;
        mid = mid + Math.imul(ah0, bl3) | 0;
        hi = hi + Math.imul(ah0, bh3) | 0;
        var w3 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w3 >>> 26) | 0;
        w3 &= 0x3ffffff;
        /* k = 4 */ lo = Math.imul(al4, bl0);
        mid = Math.imul(al4, bh0);
        mid = mid + Math.imul(ah4, bl0) | 0;
        hi = Math.imul(ah4, bh0);
        lo = lo + Math.imul(al3, bl1) | 0;
        mid = mid + Math.imul(al3, bh1) | 0;
        mid = mid + Math.imul(ah3, bl1) | 0;
        hi = hi + Math.imul(ah3, bh1) | 0;
        lo = lo + Math.imul(al2, bl2) | 0;
        mid = mid + Math.imul(al2, bh2) | 0;
        mid = mid + Math.imul(ah2, bl2) | 0;
        hi = hi + Math.imul(ah2, bh2) | 0;
        lo = lo + Math.imul(al1, bl3) | 0;
        mid = mid + Math.imul(al1, bh3) | 0;
        mid = mid + Math.imul(ah1, bl3) | 0;
        hi = hi + Math.imul(ah1, bh3) | 0;
        lo = lo + Math.imul(al0, bl4) | 0;
        mid = mid + Math.imul(al0, bh4) | 0;
        mid = mid + Math.imul(ah0, bl4) | 0;
        hi = hi + Math.imul(ah0, bh4) | 0;
        var w4 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w4 >>> 26) | 0;
        w4 &= 0x3ffffff;
        /* k = 5 */ lo = Math.imul(al5, bl0);
        mid = Math.imul(al5, bh0);
        mid = mid + Math.imul(ah5, bl0) | 0;
        hi = Math.imul(ah5, bh0);
        lo = lo + Math.imul(al4, bl1) | 0;
        mid = mid + Math.imul(al4, bh1) | 0;
        mid = mid + Math.imul(ah4, bl1) | 0;
        hi = hi + Math.imul(ah4, bh1) | 0;
        lo = lo + Math.imul(al3, bl2) | 0;
        mid = mid + Math.imul(al3, bh2) | 0;
        mid = mid + Math.imul(ah3, bl2) | 0;
        hi = hi + Math.imul(ah3, bh2) | 0;
        lo = lo + Math.imul(al2, bl3) | 0;
        mid = mid + Math.imul(al2, bh3) | 0;
        mid = mid + Math.imul(ah2, bl3) | 0;
        hi = hi + Math.imul(ah2, bh3) | 0;
        lo = lo + Math.imul(al1, bl4) | 0;
        mid = mid + Math.imul(al1, bh4) | 0;
        mid = mid + Math.imul(ah1, bl4) | 0;
        hi = hi + Math.imul(ah1, bh4) | 0;
        lo = lo + Math.imul(al0, bl5) | 0;
        mid = mid + Math.imul(al0, bh5) | 0;
        mid = mid + Math.imul(ah0, bl5) | 0;
        hi = hi + Math.imul(ah0, bh5) | 0;
        var w5 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w5 >>> 26) | 0;
        w5 &= 0x3ffffff;
        /* k = 6 */ lo = Math.imul(al6, bl0);
        mid = Math.imul(al6, bh0);
        mid = mid + Math.imul(ah6, bl0) | 0;
        hi = Math.imul(ah6, bh0);
        lo = lo + Math.imul(al5, bl1) | 0;
        mid = mid + Math.imul(al5, bh1) | 0;
        mid = mid + Math.imul(ah5, bl1) | 0;
        hi = hi + Math.imul(ah5, bh1) | 0;
        lo = lo + Math.imul(al4, bl2) | 0;
        mid = mid + Math.imul(al4, bh2) | 0;
        mid = mid + Math.imul(ah4, bl2) | 0;
        hi = hi + Math.imul(ah4, bh2) | 0;
        lo = lo + Math.imul(al3, bl3) | 0;
        mid = mid + Math.imul(al3, bh3) | 0;
        mid = mid + Math.imul(ah3, bl3) | 0;
        hi = hi + Math.imul(ah3, bh3) | 0;
        lo = lo + Math.imul(al2, bl4) | 0;
        mid = mid + Math.imul(al2, bh4) | 0;
        mid = mid + Math.imul(ah2, bl4) | 0;
        hi = hi + Math.imul(ah2, bh4) | 0;
        lo = lo + Math.imul(al1, bl5) | 0;
        mid = mid + Math.imul(al1, bh5) | 0;
        mid = mid + Math.imul(ah1, bl5) | 0;
        hi = hi + Math.imul(ah1, bh5) | 0;
        lo = lo + Math.imul(al0, bl6) | 0;
        mid = mid + Math.imul(al0, bh6) | 0;
        mid = mid + Math.imul(ah0, bl6) | 0;
        hi = hi + Math.imul(ah0, bh6) | 0;
        var w6 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w6 >>> 26) | 0;
        w6 &= 0x3ffffff;
        /* k = 7 */ lo = Math.imul(al7, bl0);
        mid = Math.imul(al7, bh0);
        mid = mid + Math.imul(ah7, bl0) | 0;
        hi = Math.imul(ah7, bh0);
        lo = lo + Math.imul(al6, bl1) | 0;
        mid = mid + Math.imul(al6, bh1) | 0;
        mid = mid + Math.imul(ah6, bl1) | 0;
        hi = hi + Math.imul(ah6, bh1) | 0;
        lo = lo + Math.imul(al5, bl2) | 0;
        mid = mid + Math.imul(al5, bh2) | 0;
        mid = mid + Math.imul(ah5, bl2) | 0;
        hi = hi + Math.imul(ah5, bh2) | 0;
        lo = lo + Math.imul(al4, bl3) | 0;
        mid = mid + Math.imul(al4, bh3) | 0;
        mid = mid + Math.imul(ah4, bl3) | 0;
        hi = hi + Math.imul(ah4, bh3) | 0;
        lo = lo + Math.imul(al3, bl4) | 0;
        mid = mid + Math.imul(al3, bh4) | 0;
        mid = mid + Math.imul(ah3, bl4) | 0;
        hi = hi + Math.imul(ah3, bh4) | 0;
        lo = lo + Math.imul(al2, bl5) | 0;
        mid = mid + Math.imul(al2, bh5) | 0;
        mid = mid + Math.imul(ah2, bl5) | 0;
        hi = hi + Math.imul(ah2, bh5) | 0;
        lo = lo + Math.imul(al1, bl6) | 0;
        mid = mid + Math.imul(al1, bh6) | 0;
        mid = mid + Math.imul(ah1, bl6) | 0;
        hi = hi + Math.imul(ah1, bh6) | 0;
        lo = lo + Math.imul(al0, bl7) | 0;
        mid = mid + Math.imul(al0, bh7) | 0;
        mid = mid + Math.imul(ah0, bl7) | 0;
        hi = hi + Math.imul(ah0, bh7) | 0;
        var w7 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w7 >>> 26) | 0;
        w7 &= 0x3ffffff;
        /* k = 8 */ lo = Math.imul(al8, bl0);
        mid = Math.imul(al8, bh0);
        mid = mid + Math.imul(ah8, bl0) | 0;
        hi = Math.imul(ah8, bh0);
        lo = lo + Math.imul(al7, bl1) | 0;
        mid = mid + Math.imul(al7, bh1) | 0;
        mid = mid + Math.imul(ah7, bl1) | 0;
        hi = hi + Math.imul(ah7, bh1) | 0;
        lo = lo + Math.imul(al6, bl2) | 0;
        mid = mid + Math.imul(al6, bh2) | 0;
        mid = mid + Math.imul(ah6, bl2) | 0;
        hi = hi + Math.imul(ah6, bh2) | 0;
        lo = lo + Math.imul(al5, bl3) | 0;
        mid = mid + Math.imul(al5, bh3) | 0;
        mid = mid + Math.imul(ah5, bl3) | 0;
        hi = hi + Math.imul(ah5, bh3) | 0;
        lo = lo + Math.imul(al4, bl4) | 0;
        mid = mid + Math.imul(al4, bh4) | 0;
        mid = mid + Math.imul(ah4, bl4) | 0;
        hi = hi + Math.imul(ah4, bh4) | 0;
        lo = lo + Math.imul(al3, bl5) | 0;
        mid = mid + Math.imul(al3, bh5) | 0;
        mid = mid + Math.imul(ah3, bl5) | 0;
        hi = hi + Math.imul(ah3, bh5) | 0;
        lo = lo + Math.imul(al2, bl6) | 0;
        mid = mid + Math.imul(al2, bh6) | 0;
        mid = mid + Math.imul(ah2, bl6) | 0;
        hi = hi + Math.imul(ah2, bh6) | 0;
        lo = lo + Math.imul(al1, bl7) | 0;
        mid = mid + Math.imul(al1, bh7) | 0;
        mid = mid + Math.imul(ah1, bl7) | 0;
        hi = hi + Math.imul(ah1, bh7) | 0;
        lo = lo + Math.imul(al0, bl8) | 0;
        mid = mid + Math.imul(al0, bh8) | 0;
        mid = mid + Math.imul(ah0, bl8) | 0;
        hi = hi + Math.imul(ah0, bh8) | 0;
        var w8 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w8 >>> 26) | 0;
        w8 &= 0x3ffffff;
        /* k = 9 */ lo = Math.imul(al9, bl0);
        mid = Math.imul(al9, bh0);
        mid = mid + Math.imul(ah9, bl0) | 0;
        hi = Math.imul(ah9, bh0);
        lo = lo + Math.imul(al8, bl1) | 0;
        mid = mid + Math.imul(al8, bh1) | 0;
        mid = mid + Math.imul(ah8, bl1) | 0;
        hi = hi + Math.imul(ah8, bh1) | 0;
        lo = lo + Math.imul(al7, bl2) | 0;
        mid = mid + Math.imul(al7, bh2) | 0;
        mid = mid + Math.imul(ah7, bl2) | 0;
        hi = hi + Math.imul(ah7, bh2) | 0;
        lo = lo + Math.imul(al6, bl3) | 0;
        mid = mid + Math.imul(al6, bh3) | 0;
        mid = mid + Math.imul(ah6, bl3) | 0;
        hi = hi + Math.imul(ah6, bh3) | 0;
        lo = lo + Math.imul(al5, bl4) | 0;
        mid = mid + Math.imul(al5, bh4) | 0;
        mid = mid + Math.imul(ah5, bl4) | 0;
        hi = hi + Math.imul(ah5, bh4) | 0;
        lo = lo + Math.imul(al4, bl5) | 0;
        mid = mid + Math.imul(al4, bh5) | 0;
        mid = mid + Math.imul(ah4, bl5) | 0;
        hi = hi + Math.imul(ah4, bh5) | 0;
        lo = lo + Math.imul(al3, bl6) | 0;
        mid = mid + Math.imul(al3, bh6) | 0;
        mid = mid + Math.imul(ah3, bl6) | 0;
        hi = hi + Math.imul(ah3, bh6) | 0;
        lo = lo + Math.imul(al2, bl7) | 0;
        mid = mid + Math.imul(al2, bh7) | 0;
        mid = mid + Math.imul(ah2, bl7) | 0;
        hi = hi + Math.imul(ah2, bh7) | 0;
        lo = lo + Math.imul(al1, bl8) | 0;
        mid = mid + Math.imul(al1, bh8) | 0;
        mid = mid + Math.imul(ah1, bl8) | 0;
        hi = hi + Math.imul(ah1, bh8) | 0;
        lo = lo + Math.imul(al0, bl9) | 0;
        mid = mid + Math.imul(al0, bh9) | 0;
        mid = mid + Math.imul(ah0, bl9) | 0;
        hi = hi + Math.imul(ah0, bh9) | 0;
        var w9 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w9 >>> 26) | 0;
        w9 &= 0x3ffffff;
        /* k = 10 */ lo = Math.imul(al9, bl1);
        mid = Math.imul(al9, bh1);
        mid = mid + Math.imul(ah9, bl1) | 0;
        hi = Math.imul(ah9, bh1);
        lo = lo + Math.imul(al8, bl2) | 0;
        mid = mid + Math.imul(al8, bh2) | 0;
        mid = mid + Math.imul(ah8, bl2) | 0;
        hi = hi + Math.imul(ah8, bh2) | 0;
        lo = lo + Math.imul(al7, bl3) | 0;
        mid = mid + Math.imul(al7, bh3) | 0;
        mid = mid + Math.imul(ah7, bl3) | 0;
        hi = hi + Math.imul(ah7, bh3) | 0;
        lo = lo + Math.imul(al6, bl4) | 0;
        mid = mid + Math.imul(al6, bh4) | 0;
        mid = mid + Math.imul(ah6, bl4) | 0;
        hi = hi + Math.imul(ah6, bh4) | 0;
        lo = lo + Math.imul(al5, bl5) | 0;
        mid = mid + Math.imul(al5, bh5) | 0;
        mid = mid + Math.imul(ah5, bl5) | 0;
        hi = hi + Math.imul(ah5, bh5) | 0;
        lo = lo + Math.imul(al4, bl6) | 0;
        mid = mid + Math.imul(al4, bh6) | 0;
        mid = mid + Math.imul(ah4, bl6) | 0;
        hi = hi + Math.imul(ah4, bh6) | 0;
        lo = lo + Math.imul(al3, bl7) | 0;
        mid = mid + Math.imul(al3, bh7) | 0;
        mid = mid + Math.imul(ah3, bl7) | 0;
        hi = hi + Math.imul(ah3, bh7) | 0;
        lo = lo + Math.imul(al2, bl8) | 0;
        mid = mid + Math.imul(al2, bh8) | 0;
        mid = mid + Math.imul(ah2, bl8) | 0;
        hi = hi + Math.imul(ah2, bh8) | 0;
        lo = lo + Math.imul(al1, bl9) | 0;
        mid = mid + Math.imul(al1, bh9) | 0;
        mid = mid + Math.imul(ah1, bl9) | 0;
        hi = hi + Math.imul(ah1, bh9) | 0;
        var w10 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w10 >>> 26) | 0;
        w10 &= 0x3ffffff;
        /* k = 11 */ lo = Math.imul(al9, bl2);
        mid = Math.imul(al9, bh2);
        mid = mid + Math.imul(ah9, bl2) | 0;
        hi = Math.imul(ah9, bh2);
        lo = lo + Math.imul(al8, bl3) | 0;
        mid = mid + Math.imul(al8, bh3) | 0;
        mid = mid + Math.imul(ah8, bl3) | 0;
        hi = hi + Math.imul(ah8, bh3) | 0;
        lo = lo + Math.imul(al7, bl4) | 0;
        mid = mid + Math.imul(al7, bh4) | 0;
        mid = mid + Math.imul(ah7, bl4) | 0;
        hi = hi + Math.imul(ah7, bh4) | 0;
        lo = lo + Math.imul(al6, bl5) | 0;
        mid = mid + Math.imul(al6, bh5) | 0;
        mid = mid + Math.imul(ah6, bl5) | 0;
        hi = hi + Math.imul(ah6, bh5) | 0;
        lo = lo + Math.imul(al5, bl6) | 0;
        mid = mid + Math.imul(al5, bh6) | 0;
        mid = mid + Math.imul(ah5, bl6) | 0;
        hi = hi + Math.imul(ah5, bh6) | 0;
        lo = lo + Math.imul(al4, bl7) | 0;
        mid = mid + Math.imul(al4, bh7) | 0;
        mid = mid + Math.imul(ah4, bl7) | 0;
        hi = hi + Math.imul(ah4, bh7) | 0;
        lo = lo + Math.imul(al3, bl8) | 0;
        mid = mid + Math.imul(al3, bh8) | 0;
        mid = mid + Math.imul(ah3, bl8) | 0;
        hi = hi + Math.imul(ah3, bh8) | 0;
        lo = lo + Math.imul(al2, bl9) | 0;
        mid = mid + Math.imul(al2, bh9) | 0;
        mid = mid + Math.imul(ah2, bl9) | 0;
        hi = hi + Math.imul(ah2, bh9) | 0;
        var w11 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w11 >>> 26) | 0;
        w11 &= 0x3ffffff;
        /* k = 12 */ lo = Math.imul(al9, bl3);
        mid = Math.imul(al9, bh3);
        mid = mid + Math.imul(ah9, bl3) | 0;
        hi = Math.imul(ah9, bh3);
        lo = lo + Math.imul(al8, bl4) | 0;
        mid = mid + Math.imul(al8, bh4) | 0;
        mid = mid + Math.imul(ah8, bl4) | 0;
        hi = hi + Math.imul(ah8, bh4) | 0;
        lo = lo + Math.imul(al7, bl5) | 0;
        mid = mid + Math.imul(al7, bh5) | 0;
        mid = mid + Math.imul(ah7, bl5) | 0;
        hi = hi + Math.imul(ah7, bh5) | 0;
        lo = lo + Math.imul(al6, bl6) | 0;
        mid = mid + Math.imul(al6, bh6) | 0;
        mid = mid + Math.imul(ah6, bl6) | 0;
        hi = hi + Math.imul(ah6, bh6) | 0;
        lo = lo + Math.imul(al5, bl7) | 0;
        mid = mid + Math.imul(al5, bh7) | 0;
        mid = mid + Math.imul(ah5, bl7) | 0;
        hi = hi + Math.imul(ah5, bh7) | 0;
        lo = lo + Math.imul(al4, bl8) | 0;
        mid = mid + Math.imul(al4, bh8) | 0;
        mid = mid + Math.imul(ah4, bl8) | 0;
        hi = hi + Math.imul(ah4, bh8) | 0;
        lo = lo + Math.imul(al3, bl9) | 0;
        mid = mid + Math.imul(al3, bh9) | 0;
        mid = mid + Math.imul(ah3, bl9) | 0;
        hi = hi + Math.imul(ah3, bh9) | 0;
        var w12 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w12 >>> 26) | 0;
        w12 &= 0x3ffffff;
        /* k = 13 */ lo = Math.imul(al9, bl4);
        mid = Math.imul(al9, bh4);
        mid = mid + Math.imul(ah9, bl4) | 0;
        hi = Math.imul(ah9, bh4);
        lo = lo + Math.imul(al8, bl5) | 0;
        mid = mid + Math.imul(al8, bh5) | 0;
        mid = mid + Math.imul(ah8, bl5) | 0;
        hi = hi + Math.imul(ah8, bh5) | 0;
        lo = lo + Math.imul(al7, bl6) | 0;
        mid = mid + Math.imul(al7, bh6) | 0;
        mid = mid + Math.imul(ah7, bl6) | 0;
        hi = hi + Math.imul(ah7, bh6) | 0;
        lo = lo + Math.imul(al6, bl7) | 0;
        mid = mid + Math.imul(al6, bh7) | 0;
        mid = mid + Math.imul(ah6, bl7) | 0;
        hi = hi + Math.imul(ah6, bh7) | 0;
        lo = lo + Math.imul(al5, bl8) | 0;
        mid = mid + Math.imul(al5, bh8) | 0;
        mid = mid + Math.imul(ah5, bl8) | 0;
        hi = hi + Math.imul(ah5, bh8) | 0;
        lo = lo + Math.imul(al4, bl9) | 0;
        mid = mid + Math.imul(al4, bh9) | 0;
        mid = mid + Math.imul(ah4, bl9) | 0;
        hi = hi + Math.imul(ah4, bh9) | 0;
        var w13 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w13 >>> 26) | 0;
        w13 &= 0x3ffffff;
        /* k = 14 */ lo = Math.imul(al9, bl5);
        mid = Math.imul(al9, bh5);
        mid = mid + Math.imul(ah9, bl5) | 0;
        hi = Math.imul(ah9, bh5);
        lo = lo + Math.imul(al8, bl6) | 0;
        mid = mid + Math.imul(al8, bh6) | 0;
        mid = mid + Math.imul(ah8, bl6) | 0;
        hi = hi + Math.imul(ah8, bh6) | 0;
        lo = lo + Math.imul(al7, bl7) | 0;
        mid = mid + Math.imul(al7, bh7) | 0;
        mid = mid + Math.imul(ah7, bl7) | 0;
        hi = hi + Math.imul(ah7, bh7) | 0;
        lo = lo + Math.imul(al6, bl8) | 0;
        mid = mid + Math.imul(al6, bh8) | 0;
        mid = mid + Math.imul(ah6, bl8) | 0;
        hi = hi + Math.imul(ah6, bh8) | 0;
        lo = lo + Math.imul(al5, bl9) | 0;
        mid = mid + Math.imul(al5, bh9) | 0;
        mid = mid + Math.imul(ah5, bl9) | 0;
        hi = hi + Math.imul(ah5, bh9) | 0;
        var w14 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w14 >>> 26) | 0;
        w14 &= 0x3ffffff;
        /* k = 15 */ lo = Math.imul(al9, bl6);
        mid = Math.imul(al9, bh6);
        mid = mid + Math.imul(ah9, bl6) | 0;
        hi = Math.imul(ah9, bh6);
        lo = lo + Math.imul(al8, bl7) | 0;
        mid = mid + Math.imul(al8, bh7) | 0;
        mid = mid + Math.imul(ah8, bl7) | 0;
        hi = hi + Math.imul(ah8, bh7) | 0;
        lo = lo + Math.imul(al7, bl8) | 0;
        mid = mid + Math.imul(al7, bh8) | 0;
        mid = mid + Math.imul(ah7, bl8) | 0;
        hi = hi + Math.imul(ah7, bh8) | 0;
        lo = lo + Math.imul(al6, bl9) | 0;
        mid = mid + Math.imul(al6, bh9) | 0;
        mid = mid + Math.imul(ah6, bl9) | 0;
        hi = hi + Math.imul(ah6, bh9) | 0;
        var w15 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w15 >>> 26) | 0;
        w15 &= 0x3ffffff;
        /* k = 16 */ lo = Math.imul(al9, bl7);
        mid = Math.imul(al9, bh7);
        mid = mid + Math.imul(ah9, bl7) | 0;
        hi = Math.imul(ah9, bh7);
        lo = lo + Math.imul(al8, bl8) | 0;
        mid = mid + Math.imul(al8, bh8) | 0;
        mid = mid + Math.imul(ah8, bl8) | 0;
        hi = hi + Math.imul(ah8, bh8) | 0;
        lo = lo + Math.imul(al7, bl9) | 0;
        mid = mid + Math.imul(al7, bh9) | 0;
        mid = mid + Math.imul(ah7, bl9) | 0;
        hi = hi + Math.imul(ah7, bh9) | 0;
        var w16 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w16 >>> 26) | 0;
        w16 &= 0x3ffffff;
        /* k = 17 */ lo = Math.imul(al9, bl8);
        mid = Math.imul(al9, bh8);
        mid = mid + Math.imul(ah9, bl8) | 0;
        hi = Math.imul(ah9, bh8);
        lo = lo + Math.imul(al8, bl9) | 0;
        mid = mid + Math.imul(al8, bh9) | 0;
        mid = mid + Math.imul(ah8, bl9) | 0;
        hi = hi + Math.imul(ah8, bh9) | 0;
        var w17 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w17 >>> 26) | 0;
        w17 &= 0x3ffffff;
        /* k = 18 */ lo = Math.imul(al9, bl9);
        mid = Math.imul(al9, bh9);
        mid = mid + Math.imul(ah9, bl9) | 0;
        hi = Math.imul(ah9, bh9);
        var w18 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w18 >>> 26) | 0;
        w18 &= 0x3ffffff;
        o[0] = w0;
        o[1] = w1;
        o[2] = w2;
        o[3] = w3;
        o[4] = w4;
        o[5] = w5;
        o[6] = w6;
        o[7] = w7;
        o[8] = w8;
        o[9] = w9;
        o[10] = w10;
        o[11] = w11;
        o[12] = w12;
        o[13] = w13;
        o[14] = w14;
        o[15] = w15;
        o[16] = w16;
        o[17] = w17;
        o[18] = w18;
        if (c !== 0) {
            o[19] = c;
            out.length++;
        }
        return out;
    };
    // Polyfill comb
    if (!Math.imul) comb10MulTo = smallMulTo;
    function bigMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        out.length = self.length + num.length;
        var carry = 0;
        var hncarry = 0;
        for(var k = 0; k < out.length - 1; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = hncarry;
            hncarry = 0;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j;
                var a = self.words[i] | 0;
                var b = num.words[j] | 0;
                var r = a * b;
                var lo = r & 0x3ffffff;
                ncarry = ncarry + (r / 0x4000000 | 0) | 0;
                lo = lo + rword | 0;
                rword = lo & 0x3ffffff;
                ncarry = ncarry + (lo >>> 26) | 0;
                hncarry += ncarry >>> 26;
                ncarry &= 0x3ffffff;
            }
            out.words[k] = rword;
            carry = ncarry;
            ncarry = hncarry;
        }
        if (carry !== 0) out.words[k] = carry;
        else out.length--;
        return out._strip();
    }
    function jumboMulTo(self, num, out) {
        // Temporary disable, see https://github.com/indutny/bn.js/issues/211
        // var fftm = new FFTM();
        // return fftm.mulp(self, num, out);
        return bigMulTo(self, num, out);
    }
    BN.prototype.mulTo = function mulTo(num, out) {
        var res;
        var len = this.length + num.length;
        if (this.length === 10 && num.length === 10) res = comb10MulTo(this, num, out);
        else if (len < 63) res = smallMulTo(this, num, out);
        else if (len < 1024) res = bigMulTo(this, num, out);
        else res = jumboMulTo(this, num, out);
        return res;
    };
    // Cooley-Tukey algorithm for FFT
    // slightly revisited to rely on looping instead of recursion
    function FFTM(x, y) {
        this.x = x;
        this.y = y;
    }
    FFTM.prototype.makeRBT = function makeRBT(N) {
        var t = new Array(N);
        var l = BN.prototype._countBits(N) - 1;
        for(var i = 0; i < N; i++)t[i] = this.revBin(i, l, N);
        return t;
    };
    // Returns binary-reversed representation of `x`
    FFTM.prototype.revBin = function revBin(x, l, N) {
        if (x === 0 || x === N - 1) return x;
        var rb = 0;
        for(var i = 0; i < l; i++){
            rb |= (x & 1) << l - i - 1;
            x >>= 1;
        }
        return rb;
    };
    // Performs "tweedling" phase, therefore 'emulating'
    // behaviour of the recursive algorithm
    FFTM.prototype.permute = function permute(rbt, rws, iws, rtws, itws, N) {
        for(var i = 0; i < N; i++){
            rtws[i] = rws[rbt[i]];
            itws[i] = iws[rbt[i]];
        }
    };
    FFTM.prototype.transform = function transform(rws, iws, rtws, itws, N, rbt) {
        this.permute(rbt, rws, iws, rtws, itws, N);
        for(var s = 1; s < N; s <<= 1){
            var l = s << 1;
            var rtwdf = Math.cos(2 * Math.PI / l);
            var itwdf = Math.sin(2 * Math.PI / l);
            for(var p = 0; p < N; p += l){
                var rtwdf_ = rtwdf;
                var itwdf_ = itwdf;
                for(var j = 0; j < s; j++){
                    var re = rtws[p + j];
                    var ie = itws[p + j];
                    var ro = rtws[p + j + s];
                    var io = itws[p + j + s];
                    var rx = rtwdf_ * ro - itwdf_ * io;
                    io = rtwdf_ * io + itwdf_ * ro;
                    ro = rx;
                    rtws[p + j] = re + ro;
                    itws[p + j] = ie + io;
                    rtws[p + j + s] = re - ro;
                    itws[p + j + s] = ie - io;
                    /* jshint maxdepth : false */ if (j !== l) {
                        rx = rtwdf * rtwdf_ - itwdf * itwdf_;
                        itwdf_ = rtwdf * itwdf_ + itwdf * rtwdf_;
                        rtwdf_ = rx;
                    }
                }
            }
        }
    };
    FFTM.prototype.guessLen13b = function guessLen13b(n, m) {
        var N = Math.max(m, n) | 1;
        var odd = N & 1;
        var i = 0;
        for(N = N / 2 | 0; N; N = N >>> 1)i++;
        return 1 << i + 1 + odd;
    };
    FFTM.prototype.conjugate = function conjugate(rws, iws, N) {
        if (N <= 1) return;
        for(var i = 0; i < N / 2; i++){
            var t = rws[i];
            rws[i] = rws[N - i - 1];
            rws[N - i - 1] = t;
            t = iws[i];
            iws[i] = -iws[N - i - 1];
            iws[N - i - 1] = -t;
        }
    };
    FFTM.prototype.normalize13b = function normalize13b(ws, N) {
        var carry = 0;
        for(var i = 0; i < N / 2; i++){
            var w = Math.round(ws[2 * i + 1] / N) * 0x2000 + Math.round(ws[2 * i] / N) + carry;
            ws[i] = w & 0x3ffffff;
            if (w < 0x4000000) carry = 0;
            else carry = w / 0x4000000 | 0;
        }
        return ws;
    };
    FFTM.prototype.convert13b = function convert13b(ws, len, rws, N) {
        var carry = 0;
        for(var i = 0; i < len; i++){
            carry = carry + (ws[i] | 0);
            rws[2 * i] = carry & 0x1fff;
            carry = carry >>> 13;
            rws[2 * i + 1] = carry & 0x1fff;
            carry = carry >>> 13;
        }
        // Pad with zeroes
        for(i = 2 * len; i < N; ++i)rws[i] = 0;
        assert(carry === 0);
        assert((carry & -8192) === 0);
    };
    FFTM.prototype.stub = function stub(N) {
        var ph = new Array(N);
        for(var i = 0; i < N; i++)ph[i] = 0;
        return ph;
    };
    FFTM.prototype.mulp = function mulp(x, y, out) {
        var N = 2 * this.guessLen13b(x.length, y.length);
        var rbt = this.makeRBT(N);
        var _ = this.stub(N);
        var rws = new Array(N);
        var rwst = new Array(N);
        var iwst = new Array(N);
        var nrws = new Array(N);
        var nrwst = new Array(N);
        var niwst = new Array(N);
        var rmws = out.words;
        rmws.length = N;
        this.convert13b(x.words, x.length, rws, N);
        this.convert13b(y.words, y.length, nrws, N);
        this.transform(rws, _, rwst, iwst, N, rbt);
        this.transform(nrws, _, nrwst, niwst, N, rbt);
        for(var i = 0; i < N; i++){
            var rx = rwst[i] * nrwst[i] - iwst[i] * niwst[i];
            iwst[i] = rwst[i] * niwst[i] + iwst[i] * nrwst[i];
            rwst[i] = rx;
        }
        this.conjugate(rwst, iwst, N);
        this.transform(rwst, iwst, rmws, _, N, rbt);
        this.conjugate(rmws, _, N);
        this.normalize13b(rmws, N);
        out.negative = x.negative ^ y.negative;
        out.length = x.length + y.length;
        return out._strip();
    };
    // Multiply `this` by `num`
    BN.prototype.mul = function mul(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return this.mulTo(num, out);
    };
    // Multiply employing FFT
    BN.prototype.mulf = function mulf(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return jumboMulTo(this, num, out);
    };
    // In-place Multiplication
    BN.prototype.imul = function imul(num) {
        return this.clone().mulTo(num, this);
    };
    BN.prototype.imuln = function imuln(num) {
        var isNegNum = num < 0;
        if (isNegNum) num = -num;
        assert(typeof num === "number");
        assert(num < 0x4000000);
        // Carry
        var carry = 0;
        for(var i = 0; i < this.length; i++){
            var w = (this.words[i] | 0) * num;
            var lo = (w & 0x3ffffff) + (carry & 0x3ffffff);
            carry >>= 26;
            carry += w / 0x4000000 | 0;
            // NOTE: lo is 27bit maximum
            carry += lo >>> 26;
            this.words[i] = lo & 0x3ffffff;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return isNegNum ? this.ineg() : this;
    };
    BN.prototype.muln = function muln(num) {
        return this.clone().imuln(num);
    };
    // `this` * `this`
    BN.prototype.sqr = function sqr() {
        return this.mul(this);
    };
    // `this` * `this` in-place
    BN.prototype.isqr = function isqr() {
        return this.imul(this.clone());
    };
    // Math.pow(`this`, `num`)
    BN.prototype.pow = function pow(num) {
        var w = toBitArray(num);
        if (w.length === 0) return new BN(1);
        // Skip leading zeroes
        var res = this;
        for(var i = 0; i < w.length; i++, res = res.sqr()){
            if (w[i] !== 0) break;
        }
        if (++i < w.length) for(var q = res.sqr(); i < w.length; i++, q = q.sqr()){
            if (w[i] === 0) continue;
            res = res.mul(q);
        }
        return res;
    };
    // Shift-left in-place
    BN.prototype.iushln = function iushln(bits) {
        assert(typeof bits === "number" && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        var carryMask = 0x3ffffff >>> 26 - r << 26 - r;
        var i;
        if (r !== 0) {
            var carry = 0;
            for(i = 0; i < this.length; i++){
                var newCarry = this.words[i] & carryMask;
                var c = (this.words[i] | 0) - newCarry << r;
                this.words[i] = c | carry;
                carry = newCarry >>> 26 - r;
            }
            if (carry) {
                this.words[i] = carry;
                this.length++;
            }
        }
        if (s !== 0) {
            for(i = this.length - 1; i >= 0; i--)this.words[i + s] = this.words[i];
            for(i = 0; i < s; i++)this.words[i] = 0;
            this.length += s;
        }
        return this._strip();
    };
    BN.prototype.ishln = function ishln(bits) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushln(bits);
    };
    // Shift-right in-place
    // NOTE: `hint` is a lowest bit before trailing zeroes
    // NOTE: if `extended` is present - it will be filled with destroyed bits
    BN.prototype.iushrn = function iushrn(bits, hint, extended) {
        assert(typeof bits === "number" && bits >= 0);
        var h;
        if (hint) h = (hint - hint % 26) / 26;
        else h = 0;
        var r = bits % 26;
        var s = Math.min((bits - r) / 26, this.length);
        var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
        var maskedWords = extended;
        h -= s;
        h = Math.max(0, h);
        // Extended mode, copy masked part
        if (maskedWords) {
            for(var i = 0; i < s; i++)maskedWords.words[i] = this.words[i];
            maskedWords.length = s;
        }
        if (s === 0) ;
        else if (this.length > s) {
            this.length -= s;
            for(i = 0; i < this.length; i++)this.words[i] = this.words[i + s];
        } else {
            this.words[0] = 0;
            this.length = 1;
        }
        var carry = 0;
        for(i = this.length - 1; i >= 0 && (carry !== 0 || i >= h); i--){
            var word = this.words[i] | 0;
            this.words[i] = carry << 26 - r | word >>> r;
            carry = word & mask;
        }
        // Push carried bits as a mask
        if (maskedWords && carry !== 0) maskedWords.words[maskedWords.length++] = carry;
        if (this.length === 0) {
            this.words[0] = 0;
            this.length = 1;
        }
        return this._strip();
    };
    BN.prototype.ishrn = function ishrn(bits, hint, extended) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushrn(bits, hint, extended);
    };
    // Shift-left
    BN.prototype.shln = function shln(bits) {
        return this.clone().ishln(bits);
    };
    BN.prototype.ushln = function ushln(bits) {
        return this.clone().iushln(bits);
    };
    // Shift-right
    BN.prototype.shrn = function shrn(bits) {
        return this.clone().ishrn(bits);
    };
    BN.prototype.ushrn = function ushrn(bits) {
        return this.clone().iushrn(bits);
    };
    // Test if n bit is set
    BN.prototype.testn = function testn(bit) {
        assert(typeof bit === "number" && bit >= 0);
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) return false;
        // Check bit and return
        var w = this.words[s];
        return !!(w & q);
    };
    // Return only lowers bits of number (in-place)
    BN.prototype.imaskn = function imaskn(bits) {
        assert(typeof bits === "number" && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        assert(this.negative === 0, "imaskn works only with positive numbers");
        if (this.length <= s) return this;
        if (r !== 0) s++;
        this.length = Math.min(s, this.length);
        if (r !== 0) {
            var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
            this.words[this.length - 1] &= mask;
        }
        return this._strip();
    };
    // Return only lowers bits of number
    BN.prototype.maskn = function maskn(bits) {
        return this.clone().imaskn(bits);
    };
    // Add plain number `num` to `this`
    BN.prototype.iaddn = function iaddn(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        if (num < 0) return this.isubn(-num);
        // Possible sign change
        if (this.negative !== 0) {
            if (this.length === 1 && (this.words[0] | 0) <= num) {
                this.words[0] = num - (this.words[0] | 0);
                this.negative = 0;
                return this;
            }
            this.negative = 0;
            this.isubn(num);
            this.negative = 1;
            return this;
        }
        // Add without checks
        return this._iaddn(num);
    };
    BN.prototype._iaddn = function _iaddn(num) {
        this.words[0] += num;
        // Carry
        for(var i = 0; i < this.length && this.words[i] >= 0x4000000; i++){
            this.words[i] -= 0x4000000;
            if (i === this.length - 1) this.words[i + 1] = 1;
            else this.words[i + 1]++;
        }
        this.length = Math.max(this.length, i + 1);
        return this;
    };
    // Subtract plain number `num` from `this`
    BN.prototype.isubn = function isubn(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        if (num < 0) return this.iaddn(-num);
        if (this.negative !== 0) {
            this.negative = 0;
            this.iaddn(num);
            this.negative = 1;
            return this;
        }
        this.words[0] -= num;
        if (this.length === 1 && this.words[0] < 0) {
            this.words[0] = -this.words[0];
            this.negative = 1;
        } else // Carry
        for(var i = 0; i < this.length && this.words[i] < 0; i++){
            this.words[i] += 0x4000000;
            this.words[i + 1] -= 1;
        }
        return this._strip();
    };
    BN.prototype.addn = function addn(num) {
        return this.clone().iaddn(num);
    };
    BN.prototype.subn = function subn(num) {
        return this.clone().isubn(num);
    };
    BN.prototype.iabs = function iabs() {
        this.negative = 0;
        return this;
    };
    BN.prototype.abs = function abs() {
        return this.clone().iabs();
    };
    BN.prototype._ishlnsubmul = function _ishlnsubmul(num, mul, shift) {
        var len = num.length + shift;
        var i;
        this._expand(len);
        var w;
        var carry = 0;
        for(i = 0; i < num.length; i++){
            w = (this.words[i + shift] | 0) + carry;
            var right = (num.words[i] | 0) * mul;
            w -= right & 0x3ffffff;
            carry = (w >> 26) - (right / 0x4000000 | 0);
            this.words[i + shift] = w & 0x3ffffff;
        }
        for(; i < this.length - shift; i++){
            w = (this.words[i + shift] | 0) + carry;
            carry = w >> 26;
            this.words[i + shift] = w & 0x3ffffff;
        }
        if (carry === 0) return this._strip();
        // Subtraction overflow
        assert(carry === -1);
        carry = 0;
        for(i = 0; i < this.length; i++){
            w = -(this.words[i] | 0) + carry;
            carry = w >> 26;
            this.words[i] = w & 0x3ffffff;
        }
        this.negative = 1;
        return this._strip();
    };
    BN.prototype._wordDiv = function _wordDiv(num, mode) {
        var shift = this.length - num.length;
        var a = this.clone();
        var b = num;
        // Normalize
        var bhi = b.words[b.length - 1] | 0;
        var bhiBits = this._countBits(bhi);
        shift = 26 - bhiBits;
        if (shift !== 0) {
            b = b.ushln(shift);
            a.iushln(shift);
            bhi = b.words[b.length - 1] | 0;
        }
        // Initialize quotient
        var m = a.length - b.length;
        var q;
        if (mode !== "mod") {
            q = new BN(null);
            q.length = m + 1;
            q.words = new Array(q.length);
            for(var i = 0; i < q.length; i++)q.words[i] = 0;
        }
        var diff = a.clone()._ishlnsubmul(b, 1, m);
        if (diff.negative === 0) {
            a = diff;
            if (q) q.words[m] = 1;
        }
        for(var j = m - 1; j >= 0; j--){
            var qj = (a.words[b.length + j] | 0) * 0x4000000 + (a.words[b.length + j - 1] | 0);
            // NOTE: (qj / bhi) is (0x3ffffff * 0x4000000 + 0x3ffffff) / 0x2000000 max
            // (0x7ffffff)
            qj = Math.min(qj / bhi | 0, 0x3ffffff);
            a._ishlnsubmul(b, qj, j);
            while(a.negative !== 0){
                qj--;
                a.negative = 0;
                a._ishlnsubmul(b, 1, j);
                if (!a.isZero()) a.negative ^= 1;
            }
            if (q) q.words[j] = qj;
        }
        if (q) q._strip();
        a._strip();
        // Denormalize
        if (mode !== "div" && shift !== 0) a.iushrn(shift);
        return {
            div: q || null,
            mod: a
        };
    };
    // NOTE: 1) `mode` can be set to `mod` to request mod only,
    //       to `div` to request div only, or be absent to
    //       request both div & mod
    //       2) `positive` is true if unsigned mod is requested
    BN.prototype.divmod = function divmod(num, mode, positive) {
        assert(!num.isZero());
        if (this.isZero()) return {
            div: new BN(0),
            mod: new BN(0)
        };
        var div, mod, res;
        if (this.negative !== 0 && num.negative === 0) {
            res = this.neg().divmod(num, mode);
            if (mode !== "mod") div = res.div.neg();
            if (mode !== "div") {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.iadd(num);
            }
            return {
                div: div,
                mod: mod
            };
        }
        if (this.negative === 0 && num.negative !== 0) {
            res = this.divmod(num.neg(), mode);
            if (mode !== "mod") div = res.div.neg();
            return {
                div: div,
                mod: res.mod
            };
        }
        if ((this.negative & num.negative) !== 0) {
            res = this.neg().divmod(num.neg(), mode);
            if (mode !== "div") {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.isub(num);
            }
            return {
                div: res.div,
                mod: mod
            };
        }
        // Both numbers are positive at this point
        // Strip both numbers to approximate shift value
        if (num.length > this.length || this.cmp(num) < 0) return {
            div: new BN(0),
            mod: this
        };
        // Very short reduction
        if (num.length === 1) {
            if (mode === "div") return {
                div: this.divn(num.words[0]),
                mod: null
            };
            if (mode === "mod") return {
                div: null,
                mod: new BN(this.modrn(num.words[0]))
            };
            return {
                div: this.divn(num.words[0]),
                mod: new BN(this.modrn(num.words[0]))
            };
        }
        return this._wordDiv(num, mode);
    };
    // Find `this` / `num`
    BN.prototype.div = function div(num) {
        return this.divmod(num, "div", false).div;
    };
    // Find `this` % `num`
    BN.prototype.mod = function mod(num) {
        return this.divmod(num, "mod", false).mod;
    };
    BN.prototype.umod = function umod(num) {
        return this.divmod(num, "mod", true).mod;
    };
    // Find Round(`this` / `num`)
    BN.prototype.divRound = function divRound(num) {
        var dm = this.divmod(num);
        // Fast case - exact division
        if (dm.mod.isZero()) return dm.div;
        var mod = dm.div.negative !== 0 ? dm.mod.isub(num) : dm.mod;
        var half = num.ushrn(1);
        var r2 = num.andln(1);
        var cmp = mod.cmp(half);
        // Round down
        if (cmp < 0 || r2 === 1 && cmp === 0) return dm.div;
        // Round up
        return dm.div.negative !== 0 ? dm.div.isubn(1) : dm.div.iaddn(1);
    };
    BN.prototype.modrn = function modrn(num) {
        var isNegNum = num < 0;
        if (isNegNum) num = -num;
        assert(num <= 0x3ffffff);
        var p = 67108864 % num;
        var acc = 0;
        for(var i = this.length - 1; i >= 0; i--)acc = (p * acc + (this.words[i] | 0)) % num;
        return isNegNum ? -acc : acc;
    };
    // WARNING: DEPRECATED
    BN.prototype.modn = function modn(num) {
        return this.modrn(num);
    };
    // In-place division by number
    BN.prototype.idivn = function idivn(num) {
        var isNegNum = num < 0;
        if (isNegNum) num = -num;
        assert(num <= 0x3ffffff);
        var carry = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var w = (this.words[i] | 0) + carry * 0x4000000;
            this.words[i] = w / num | 0;
            carry = w % num;
        }
        this._strip();
        return isNegNum ? this.ineg() : this;
    };
    BN.prototype.divn = function divn(num) {
        return this.clone().idivn(num);
    };
    BN.prototype.egcd = function egcd(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var x = this;
        var y = p.clone();
        if (x.negative !== 0) x = x.umod(p);
        else x = x.clone();
        // A * x + B * y = x
        var A = new BN(1);
        var B = new BN(0);
        // C * x + D * y = y
        var C = new BN(0);
        var D = new BN(1);
        var g = 0;
        while(x.isEven() && y.isEven()){
            x.iushrn(1);
            y.iushrn(1);
            ++g;
        }
        var yp = y.clone();
        var xp = x.clone();
        while(!x.isZero()){
            for(var i = 0, im = 1; (x.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                x.iushrn(i);
                while(i-- > 0){
                    if (A.isOdd() || B.isOdd()) {
                        A.iadd(yp);
                        B.isub(xp);
                    }
                    A.iushrn(1);
                    B.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (y.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                y.iushrn(j);
                while(j-- > 0){
                    if (C.isOdd() || D.isOdd()) {
                        C.iadd(yp);
                        D.isub(xp);
                    }
                    C.iushrn(1);
                    D.iushrn(1);
                }
            }
            if (x.cmp(y) >= 0) {
                x.isub(y);
                A.isub(C);
                B.isub(D);
            } else {
                y.isub(x);
                C.isub(A);
                D.isub(B);
            }
        }
        return {
            a: C,
            b: D,
            gcd: y.iushln(g)
        };
    };
    // This is reduced incarnation of the binary EEA
    // above, designated to invert members of the
    // _prime_ fields F(p) at a maximal speed
    BN.prototype._invmp = function _invmp(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var a = this;
        var b = p.clone();
        if (a.negative !== 0) a = a.umod(p);
        else a = a.clone();
        var x1 = new BN(1);
        var x2 = new BN(0);
        var delta = b.clone();
        while(a.cmpn(1) > 0 && b.cmpn(1) > 0){
            for(var i = 0, im = 1; (a.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                a.iushrn(i);
                while(i-- > 0){
                    if (x1.isOdd()) x1.iadd(delta);
                    x1.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (b.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                b.iushrn(j);
                while(j-- > 0){
                    if (x2.isOdd()) x2.iadd(delta);
                    x2.iushrn(1);
                }
            }
            if (a.cmp(b) >= 0) {
                a.isub(b);
                x1.isub(x2);
            } else {
                b.isub(a);
                x2.isub(x1);
            }
        }
        var res;
        if (a.cmpn(1) === 0) res = x1;
        else res = x2;
        if (res.cmpn(0) < 0) res.iadd(p);
        return res;
    };
    BN.prototype.gcd = function gcd(num) {
        if (this.isZero()) return num.abs();
        if (num.isZero()) return this.abs();
        var a = this.clone();
        var b = num.clone();
        a.negative = 0;
        b.negative = 0;
        // Remove common factor of two
        for(var shift = 0; a.isEven() && b.isEven(); shift++){
            a.iushrn(1);
            b.iushrn(1);
        }
        do {
            while(a.isEven())a.iushrn(1);
            while(b.isEven())b.iushrn(1);
            var r = a.cmp(b);
            if (r < 0) {
                // Swap `a` and `b` to make `a` always bigger than `b`
                var t = a;
                a = b;
                b = t;
            } else if (r === 0 || b.cmpn(1) === 0) break;
            a.isub(b);
        }while (true);
        return b.iushln(shift);
    };
    // Invert number in the field F(num)
    BN.prototype.invm = function invm(num) {
        return this.egcd(num).a.umod(num);
    };
    BN.prototype.isEven = function isEven() {
        return (this.words[0] & 1) === 0;
    };
    BN.prototype.isOdd = function isOdd() {
        return (this.words[0] & 1) === 1;
    };
    // And first word and num
    BN.prototype.andln = function andln(num) {
        return this.words[0] & num;
    };
    // Increment at the bit position in-line
    BN.prototype.bincn = function bincn(bit) {
        assert(typeof bit === "number");
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) {
            this._expand(s + 1);
            this.words[s] |= q;
            return this;
        }
        // Add bit and propagate, if needed
        var carry = q;
        for(var i = s; carry !== 0 && i < this.length; i++){
            var w = this.words[i] | 0;
            w += carry;
            carry = w >>> 26;
            w &= 0x3ffffff;
            this.words[i] = w;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return this;
    };
    BN.prototype.isZero = function isZero() {
        return this.length === 1 && this.words[0] === 0;
    };
    BN.prototype.cmpn = function cmpn(num) {
        var negative = num < 0;
        if (this.negative !== 0 && !negative) return -1;
        if (this.negative === 0 && negative) return 1;
        this._strip();
        var res;
        if (this.length > 1) res = 1;
        else {
            if (negative) num = -num;
            assert(num <= 0x3ffffff, "Number is too big");
            var w = this.words[0] | 0;
            res = w === num ? 0 : w < num ? -1 : 1;
        }
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Compare two numbers and return:
    // 1 - if `this` > `num`
    // 0 - if `this` == `num`
    // -1 - if `this` < `num`
    BN.prototype.cmp = function cmp(num) {
        if (this.negative !== 0 && num.negative === 0) return -1;
        if (this.negative === 0 && num.negative !== 0) return 1;
        var res = this.ucmp(num);
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Unsigned comparison
    BN.prototype.ucmp = function ucmp(num) {
        // At this point both numbers have the same sign
        if (this.length > num.length) return 1;
        if (this.length < num.length) return -1;
        var res = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var a = this.words[i] | 0;
            var b = num.words[i] | 0;
            if (a === b) continue;
            if (a < b) res = -1;
            else if (a > b) res = 1;
            break;
        }
        return res;
    };
    BN.prototype.gtn = function gtn(num) {
        return this.cmpn(num) === 1;
    };
    BN.prototype.gt = function gt(num) {
        return this.cmp(num) === 1;
    };
    BN.prototype.gten = function gten(num) {
        return this.cmpn(num) >= 0;
    };
    BN.prototype.gte = function gte(num) {
        return this.cmp(num) >= 0;
    };
    BN.prototype.ltn = function ltn(num) {
        return this.cmpn(num) === -1;
    };
    BN.prototype.lt = function lt(num) {
        return this.cmp(num) === -1;
    };
    BN.prototype.lten = function lten(num) {
        return this.cmpn(num) <= 0;
    };
    BN.prototype.lte = function lte(num) {
        return this.cmp(num) <= 0;
    };
    BN.prototype.eqn = function eqn(num) {
        return this.cmpn(num) === 0;
    };
    BN.prototype.eq = function eq(num) {
        return this.cmp(num) === 0;
    };
    //
    // A reduce context, could be using montgomery or something better, depending
    // on the `m` itself.
    //
    BN.red = function red(num) {
        return new Red(num);
    };
    BN.prototype.toRed = function toRed(ctx) {
        assert(!this.red, "Already a number in reduction context");
        assert(this.negative === 0, "red works only with positives");
        return ctx.convertTo(this)._forceRed(ctx);
    };
    BN.prototype.fromRed = function fromRed() {
        assert(this.red, "fromRed works only with numbers in reduction context");
        return this.red.convertFrom(this);
    };
    BN.prototype._forceRed = function _forceRed(ctx) {
        this.red = ctx;
        return this;
    };
    BN.prototype.forceRed = function forceRed(ctx) {
        assert(!this.red, "Already a number in reduction context");
        return this._forceRed(ctx);
    };
    BN.prototype.redAdd = function redAdd(num) {
        assert(this.red, "redAdd works only with red numbers");
        return this.red.add(this, num);
    };
    BN.prototype.redIAdd = function redIAdd(num) {
        assert(this.red, "redIAdd works only with red numbers");
        return this.red.iadd(this, num);
    };
    BN.prototype.redSub = function redSub(num) {
        assert(this.red, "redSub works only with red numbers");
        return this.red.sub(this, num);
    };
    BN.prototype.redISub = function redISub(num) {
        assert(this.red, "redISub works only with red numbers");
        return this.red.isub(this, num);
    };
    BN.prototype.redShl = function redShl(num) {
        assert(this.red, "redShl works only with red numbers");
        return this.red.shl(this, num);
    };
    BN.prototype.redMul = function redMul(num) {
        assert(this.red, "redMul works only with red numbers");
        this.red._verify2(this, num);
        return this.red.mul(this, num);
    };
    BN.prototype.redIMul = function redIMul(num) {
        assert(this.red, "redMul works only with red numbers");
        this.red._verify2(this, num);
        return this.red.imul(this, num);
    };
    BN.prototype.redSqr = function redSqr() {
        assert(this.red, "redSqr works only with red numbers");
        this.red._verify1(this);
        return this.red.sqr(this);
    };
    BN.prototype.redISqr = function redISqr() {
        assert(this.red, "redISqr works only with red numbers");
        this.red._verify1(this);
        return this.red.isqr(this);
    };
    // Square root over p
    BN.prototype.redSqrt = function redSqrt() {
        assert(this.red, "redSqrt works only with red numbers");
        this.red._verify1(this);
        return this.red.sqrt(this);
    };
    BN.prototype.redInvm = function redInvm() {
        assert(this.red, "redInvm works only with red numbers");
        this.red._verify1(this);
        return this.red.invm(this);
    };
    // Return negative clone of `this` % `red modulo`
    BN.prototype.redNeg = function redNeg() {
        assert(this.red, "redNeg works only with red numbers");
        this.red._verify1(this);
        return this.red.neg(this);
    };
    BN.prototype.redPow = function redPow(num) {
        assert(this.red && !num.red, "redPow(normalNum)");
        this.red._verify1(this);
        return this.red.pow(this, num);
    };
    // Prime numbers with efficient reduction
    var primes = {
        k256: null,
        p224: null,
        p192: null,
        p25519: null
    };
    // Pseudo-Mersenne prime
    function MPrime(name, p) {
        // P = 2 ^ N - K
        this.name = name;
        this.p = new BN(p, 16);
        this.n = this.p.bitLength();
        this.k = new BN(1).iushln(this.n).isub(this.p);
        this.tmp = this._tmp();
    }
    MPrime.prototype._tmp = function _tmp() {
        var tmp = new BN(null);
        tmp.words = new Array(Math.ceil(this.n / 13));
        return tmp;
    };
    MPrime.prototype.ireduce = function ireduce(num) {
        // Assumes that `num` is less than `P^2`
        // num = HI * (2 ^ N - K) + HI * K + LO = HI * K + LO (mod P)
        var r = num;
        var rlen;
        do {
            this.split(r, this.tmp);
            r = this.imulK(r);
            r = r.iadd(this.tmp);
            rlen = r.bitLength();
        }while (rlen > this.n);
        var cmp = rlen < this.n ? -1 : r.ucmp(this.p);
        if (cmp === 0) {
            r.words[0] = 0;
            r.length = 1;
        } else if (cmp > 0) r.isub(this.p);
        else if (r.strip !== undefined) // r is a BN v4 instance
        r.strip();
        else // r is a BN v5 instance
        r._strip();
        return r;
    };
    MPrime.prototype.split = function split(input, out) {
        input.iushrn(this.n, 0, out);
    };
    MPrime.prototype.imulK = function imulK(num) {
        return num.imul(this.k);
    };
    function K256() {
        MPrime.call(this, "k256", "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f");
    }
    inherits(K256, MPrime);
    K256.prototype.split = function split(input, output) {
        // 256 = 9 * 26 + 22
        var mask = 0x3fffff;
        var outLen = Math.min(input.length, 9);
        for(var i = 0; i < outLen; i++)output.words[i] = input.words[i];
        output.length = outLen;
        if (input.length <= 9) {
            input.words[0] = 0;
            input.length = 1;
            return;
        }
        // Shift by 9 limbs
        var prev = input.words[9];
        output.words[output.length++] = prev & mask;
        for(i = 10; i < input.length; i++){
            var next = input.words[i] | 0;
            input.words[i - 10] = (next & mask) << 4 | prev >>> 22;
            prev = next;
        }
        prev >>>= 22;
        input.words[i - 10] = prev;
        if (prev === 0 && input.length > 10) input.length -= 10;
        else input.length -= 9;
    };
    K256.prototype.imulK = function imulK(num) {
        // K = 0x1000003d1 = [ 0x40, 0x3d1 ]
        num.words[num.length] = 0;
        num.words[num.length + 1] = 0;
        num.length += 2;
        // bounded at: 0x40 * 0x3ffffff + 0x3d0 = 0x100000390
        var lo = 0;
        for(var i = 0; i < num.length; i++){
            var w = num.words[i] | 0;
            lo += w * 0x3d1;
            num.words[i] = lo & 0x3ffffff;
            lo = w * 0x40 + (lo / 0x4000000 | 0);
        }
        // Fast length reduction
        if (num.words[num.length - 1] === 0) {
            num.length--;
            if (num.words[num.length - 1] === 0) num.length--;
        }
        return num;
    };
    function P224() {
        MPrime.call(this, "p224", "ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001");
    }
    inherits(P224, MPrime);
    function P192() {
        MPrime.call(this, "p192", "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff");
    }
    inherits(P192, MPrime);
    function P25519() {
        // 2 ^ 255 - 19
        MPrime.call(this, "25519", "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed");
    }
    inherits(P25519, MPrime);
    P25519.prototype.imulK = function imulK(num) {
        // K = 0x13
        var carry = 0;
        for(var i = 0; i < num.length; i++){
            var hi = (num.words[i] | 0) * 0x13 + carry;
            var lo = hi & 0x3ffffff;
            hi >>>= 26;
            num.words[i] = lo;
            carry = hi;
        }
        if (carry !== 0) num.words[num.length++] = carry;
        return num;
    };
    // Exported mostly for testing purposes, use plain name instead
    BN._prime = function prime(name) {
        // Cached version of prime
        if (primes[name]) return primes[name];
        var prime;
        if (name === "k256") prime = new K256();
        else if (name === "p224") prime = new P224();
        else if (name === "p192") prime = new P192();
        else if (name === "p25519") prime = new P25519();
        else throw new Error("Unknown prime " + name);
        primes[name] = prime;
        return prime;
    };
    //
    // Base reduction engine
    //
    function Red(m) {
        if (typeof m === "string") {
            var prime = BN._prime(m);
            this.m = prime.p;
            this.prime = prime;
        } else {
            assert(m.gtn(1), "modulus must be greater than 1");
            this.m = m;
            this.prime = null;
        }
    }
    Red.prototype._verify1 = function _verify1(a) {
        assert(a.negative === 0, "red works only with positives");
        assert(a.red, "red works only with red numbers");
    };
    Red.prototype._verify2 = function _verify2(a, b) {
        assert((a.negative | b.negative) === 0, "red works only with positives");
        assert(a.red && a.red === b.red, "red works only with red numbers");
    };
    Red.prototype.imod = function imod(a) {
        if (this.prime) return this.prime.ireduce(a)._forceRed(this);
        move(a, a.umod(this.m)._forceRed(this));
        return a;
    };
    Red.prototype.neg = function neg(a) {
        if (a.isZero()) return a.clone();
        return this.m.sub(a)._forceRed(this);
    };
    Red.prototype.add = function add(a, b) {
        this._verify2(a, b);
        var res = a.add(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res._forceRed(this);
    };
    Red.prototype.iadd = function iadd(a, b) {
        this._verify2(a, b);
        var res = a.iadd(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res;
    };
    Red.prototype.sub = function sub(a, b) {
        this._verify2(a, b);
        var res = a.sub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res._forceRed(this);
    };
    Red.prototype.isub = function isub(a, b) {
        this._verify2(a, b);
        var res = a.isub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res;
    };
    Red.prototype.shl = function shl(a, num) {
        this._verify1(a);
        return this.imod(a.ushln(num));
    };
    Red.prototype.imul = function imul(a, b) {
        this._verify2(a, b);
        return this.imod(a.imul(b));
    };
    Red.prototype.mul = function mul(a, b) {
        this._verify2(a, b);
        return this.imod(a.mul(b));
    };
    Red.prototype.isqr = function isqr(a) {
        return this.imul(a, a.clone());
    };
    Red.prototype.sqr = function sqr(a) {
        return this.mul(a, a);
    };
    Red.prototype.sqrt = function sqrt(a) {
        if (a.isZero()) return a.clone();
        var mod3 = this.m.andln(3);
        assert(mod3 % 2 === 1);
        // Fast case
        if (mod3 === 3) {
            var pow = this.m.add(new BN(1)).iushrn(2);
            return this.pow(a, pow);
        }
        // Tonelli-Shanks algorithm (Totally unoptimized and slow)
        //
        // Find Q and S, that Q * 2 ^ S = (P - 1)
        var q = this.m.subn(1);
        var s = 0;
        while(!q.isZero() && q.andln(1) === 0){
            s++;
            q.iushrn(1);
        }
        assert(!q.isZero());
        var one = new BN(1).toRed(this);
        var nOne = one.redNeg();
        // Find quadratic non-residue
        // NOTE: Max is such because of generalized Riemann hypothesis.
        var lpow = this.m.subn(1).iushrn(1);
        var z = this.m.bitLength();
        z = new BN(2 * z * z).toRed(this);
        while(this.pow(z, lpow).cmp(nOne) !== 0)z.redIAdd(nOne);
        var c = this.pow(z, q);
        var r = this.pow(a, q.addn(1).iushrn(1));
        var t = this.pow(a, q);
        var m = s;
        while(t.cmp(one) !== 0){
            var tmp = t;
            for(var i = 0; tmp.cmp(one) !== 0; i++)tmp = tmp.redSqr();
            assert(i < m);
            var b = this.pow(c, new BN(1).iushln(m - i - 1));
            r = r.redMul(b);
            c = b.redSqr();
            t = t.redMul(c);
            m = i;
        }
        return r;
    };
    Red.prototype.invm = function invm(a) {
        var inv = a._invmp(this.m);
        if (inv.negative !== 0) {
            inv.negative = 0;
            return this.imod(inv).redNeg();
        } else return this.imod(inv);
    };
    Red.prototype.pow = function pow(a, num) {
        if (num.isZero()) return new BN(1).toRed(this);
        if (num.cmpn(1) === 0) return a.clone();
        var windowSize = 4;
        var wnd = new Array(1 << windowSize);
        wnd[0] = new BN(1).toRed(this);
        wnd[1] = a;
        for(var i = 2; i < wnd.length; i++)wnd[i] = this.mul(wnd[i - 1], a);
        var res = wnd[0];
        var current = 0;
        var currentLen = 0;
        var start = num.bitLength() % 26;
        if (start === 0) start = 26;
        for(i = num.length - 1; i >= 0; i--){
            var word = num.words[i];
            for(var j = start - 1; j >= 0; j--){
                var bit = word >> j & 1;
                if (res !== wnd[0]) res = this.sqr(res);
                if (bit === 0 && current === 0) {
                    currentLen = 0;
                    continue;
                }
                current <<= 1;
                current |= bit;
                currentLen++;
                if (currentLen !== windowSize && (i !== 0 || j !== 0)) continue;
                res = this.mul(res, wnd[current]);
                currentLen = 0;
                current = 0;
            }
            start = 26;
        }
        return res;
    };
    Red.prototype.convertTo = function convertTo(num) {
        var r = num.umod(this.m);
        return r === num ? r.clone() : r;
    };
    Red.prototype.convertFrom = function convertFrom(num) {
        var res = num.clone();
        res.red = null;
        return res;
    };
    //
    // Montgomery method engine
    //
    BN.mont = function mont(num) {
        return new Mont(num);
    };
    function Mont(m) {
        Red.call(this, m);
        this.shift = this.m.bitLength();
        if (this.shift % 26 !== 0) this.shift += 26 - this.shift % 26;
        this.r = new BN(1).iushln(this.shift);
        this.r2 = this.imod(this.r.sqr());
        this.rinv = this.r._invmp(this.m);
        this.minv = this.rinv.mul(this.r).isubn(1).div(this.m);
        this.minv = this.minv.umod(this.r);
        this.minv = this.r.sub(this.minv);
    }
    inherits(Mont, Red);
    Mont.prototype.convertTo = function convertTo(num) {
        return this.imod(num.ushln(this.shift));
    };
    Mont.prototype.convertFrom = function convertFrom(num) {
        var r = this.imod(num.mul(this.rinv));
        r.red = null;
        return r;
    };
    Mont.prototype.imul = function imul(a, b) {
        if (a.isZero() || b.isZero()) {
            a.words[0] = 0;
            a.length = 1;
            return a;
        }
        var t = a.imul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.mul = function mul(a, b) {
        if (a.isZero() || b.isZero()) return new BN(0)._forceRed(this);
        var t = a.mul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.invm = function invm(a) {
        // (AR)^-1 * R^2 = (A^-1 * R^-1) * R^2 = A^-1 * R
        var res = this.imod(a._invmp(this.m).mul(this.r2));
        return res._forceRed(this);
    };
})(module, this);

});

parcelRequire.register("5qnT8", function(module, exports) {

var $ihoyg = parcelRequire("ihoyg");
var $3f31e9298802700a$require$Buffer = $ihoyg.Buffer;
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $lrsL3 = parcelRequire("lrsL3");

var $fJ9Lg = parcelRequire("fJ9Lg");

var $bQlVj = parcelRequire("bQlVj");

var $ebEok = parcelRequire("ebEok");

var $guT51 = parcelRequire("guT51");
let $3f31e9298802700a$var$DEFAULT_WORDLIST = $guT51._default;
const $3f31e9298802700a$var$INVALID_MNEMONIC = "Invalid mnemonic";
const $3f31e9298802700a$var$INVALID_ENTROPY = "Invalid entropy";
const $3f31e9298802700a$var$INVALID_CHECKSUM = "Invalid mnemonic checksum";
const $3f31e9298802700a$var$WORDLIST_REQUIRED = "A wordlist is required but a default could not be found.\nPlease pass a 2048 word array explicitly.";
function $3f31e9298802700a$var$normalize(str) {
    return (str || "").normalize("NFKD");
}
function $3f31e9298802700a$var$lpad(str, padString, length) {
    while(str.length < length)str = padString + str;
    return str;
}
function $3f31e9298802700a$var$binaryToByte(bin) {
    return parseInt(bin, 2);
}
function $3f31e9298802700a$var$bytesToBinary(bytes) {
    return bytes.map((x)=>$3f31e9298802700a$var$lpad(x.toString(2), "0", 8)).join("");
}
function $3f31e9298802700a$var$deriveChecksumBits(entropyBuffer) {
    const ENT = entropyBuffer.length * 8;
    const CS = ENT / 32;
    const hash = $lrsL3.sha256(Uint8Array.from(entropyBuffer));
    return $3f31e9298802700a$var$bytesToBinary(Array.from(hash)).slice(0, CS);
}
function $3f31e9298802700a$var$salt(password) {
    return "mnemonic" + (password || "");
}
function $3f31e9298802700a$var$mnemonicToSeedSync(mnemonic, password) {
    const mnemonicBuffer = Uint8Array.from($3f31e9298802700a$require$Buffer.from($3f31e9298802700a$var$normalize(mnemonic), "utf8"));
    const saltBuffer = Uint8Array.from($3f31e9298802700a$require$Buffer.from($3f31e9298802700a$var$salt($3f31e9298802700a$var$normalize(password)), "utf8"));
    const res = $bQlVj.pbkdf2($fJ9Lg.sha512, mnemonicBuffer, saltBuffer, {
        c: 2048,
        dkLen: 64
    });
    return $3f31e9298802700a$require$Buffer.from(res);
}
module.exports.mnemonicToSeedSync = $3f31e9298802700a$var$mnemonicToSeedSync;
function $3f31e9298802700a$var$mnemonicToSeed(mnemonic, password) {
    const mnemonicBuffer = Uint8Array.from($3f31e9298802700a$require$Buffer.from($3f31e9298802700a$var$normalize(mnemonic), "utf8"));
    const saltBuffer = Uint8Array.from($3f31e9298802700a$require$Buffer.from($3f31e9298802700a$var$salt($3f31e9298802700a$var$normalize(password)), "utf8"));
    return $bQlVj.pbkdf2Async($fJ9Lg.sha512, mnemonicBuffer, saltBuffer, {
        c: 2048,
        dkLen: 64
    }).then((res)=>$3f31e9298802700a$require$Buffer.from(res));
}
module.exports.mnemonicToSeed = $3f31e9298802700a$var$mnemonicToSeed;
function $3f31e9298802700a$var$mnemonicToEntropy(mnemonic, wordlist) {
    wordlist = wordlist || $3f31e9298802700a$var$DEFAULT_WORDLIST;
    if (!wordlist) throw new Error($3f31e9298802700a$var$WORDLIST_REQUIRED);
    const words = $3f31e9298802700a$var$normalize(mnemonic).split(" ");
    if (words.length % 3 !== 0) throw new Error($3f31e9298802700a$var$INVALID_MNEMONIC);
    // convert word indices to 11 bit binary strings
    const bits = words.map((word)=>{
        const index = wordlist.indexOf(word);
        if (index === -1) throw new Error($3f31e9298802700a$var$INVALID_MNEMONIC);
        return $3f31e9298802700a$var$lpad(index.toString(2), "0", 11);
    }).join("");
    // split the binary string into ENT/CS
    const dividerIndex = Math.floor(bits.length / 33) * 32;
    const entropyBits = bits.slice(0, dividerIndex);
    const checksumBits = bits.slice(dividerIndex);
    // calculate the checksum and compare
    const entropyBytes = entropyBits.match(/(.{1,8})/g).map($3f31e9298802700a$var$binaryToByte);
    if (entropyBytes.length < 16) throw new Error($3f31e9298802700a$var$INVALID_ENTROPY);
    if (entropyBytes.length > 32) throw new Error($3f31e9298802700a$var$INVALID_ENTROPY);
    if (entropyBytes.length % 4 !== 0) throw new Error($3f31e9298802700a$var$INVALID_ENTROPY);
    const entropy = $3f31e9298802700a$require$Buffer.from(entropyBytes);
    const newChecksum = $3f31e9298802700a$var$deriveChecksumBits(entropy);
    if (newChecksum !== checksumBits) throw new Error($3f31e9298802700a$var$INVALID_CHECKSUM);
    return entropy.toString("hex");
}
module.exports.mnemonicToEntropy = $3f31e9298802700a$var$mnemonicToEntropy;
function $3f31e9298802700a$var$entropyToMnemonic(entropy, wordlist) {
    if (!$3f31e9298802700a$require$Buffer.isBuffer(entropy)) entropy = $3f31e9298802700a$require$Buffer.from(entropy, "hex");
    wordlist = wordlist || $3f31e9298802700a$var$DEFAULT_WORDLIST;
    if (!wordlist) throw new Error($3f31e9298802700a$var$WORDLIST_REQUIRED);
    // 128 <= ENT <= 256
    if (entropy.length < 16) throw new TypeError($3f31e9298802700a$var$INVALID_ENTROPY);
    if (entropy.length > 32) throw new TypeError($3f31e9298802700a$var$INVALID_ENTROPY);
    if (entropy.length % 4 !== 0) throw new TypeError($3f31e9298802700a$var$INVALID_ENTROPY);
    const entropyBits = $3f31e9298802700a$var$bytesToBinary(Array.from(entropy));
    const checksumBits = $3f31e9298802700a$var$deriveChecksumBits(entropy);
    const bits = entropyBits + checksumBits;
    const chunks = bits.match(/(.{1,11})/g);
    const words = chunks.map((binary)=>{
        const index = $3f31e9298802700a$var$binaryToByte(binary);
        return wordlist[index];
    });
    return wordlist[0] === "あいこくしん" // Japanese wordlist
     ? words.join("　") : words.join(" ");
}
module.exports.entropyToMnemonic = $3f31e9298802700a$var$entropyToMnemonic;
function $3f31e9298802700a$var$generateMnemonic(strength, rng, wordlist) {
    strength = strength || 128;
    if (strength % 32 !== 0) throw new TypeError($3f31e9298802700a$var$INVALID_ENTROPY);
    rng = rng || ((size)=>$3f31e9298802700a$require$Buffer.from($ebEok.randomBytes(size)));
    return $3f31e9298802700a$var$entropyToMnemonic(rng(strength / 8), wordlist);
}
module.exports.generateMnemonic = $3f31e9298802700a$var$generateMnemonic;
function $3f31e9298802700a$var$validateMnemonic(mnemonic, wordlist) {
    try {
        $3f31e9298802700a$var$mnemonicToEntropy(mnemonic, wordlist);
    } catch (e) {
        return false;
    }
    return true;
}
module.exports.validateMnemonic = $3f31e9298802700a$var$validateMnemonic;
function $3f31e9298802700a$var$setDefaultWordlist(language) {
    const result = $guT51.wordlists[language];
    if (result) $3f31e9298802700a$var$DEFAULT_WORDLIST = result;
    else throw new Error('Could not find wordlist for language "' + language + '"');
}
module.exports.setDefaultWordlist = $3f31e9298802700a$var$setDefaultWordlist;
function $3f31e9298802700a$var$getDefaultWordlist() {
    if (!$3f31e9298802700a$var$DEFAULT_WORDLIST) throw new Error("No Default Wordlist set");
    return Object.keys($guT51.wordlists).filter((lang)=>{
        if (lang === "JA" || lang === "EN") return false;
        return $guT51.wordlists[lang].every((word, index)=>word === $3f31e9298802700a$var$DEFAULT_WORDLIST[index]);
    })[0];
}
module.exports.getDefaultWordlist = $3f31e9298802700a$var$getDefaultWordlist;

var $guT51 = parcelRequire("guT51");
module.exports.wordlists = $guT51.wordlists;

});
parcelRequire.register("ihoyg", function(module, exports) {

$parcel$export(module.exports, "Buffer", function () { return $d4ecdbf520e63dca$export$a143d493d941bafc; }, function (v) { return $d4ecdbf520e63dca$export$a143d493d941bafc = v; });
$parcel$export(module.exports, "SlowBuffer", function () { return $d4ecdbf520e63dca$export$e4cf37d7f6fb9e0a; }, function (v) { return $d4ecdbf520e63dca$export$e4cf37d7f6fb9e0a = v; });
$parcel$export(module.exports, "INSPECT_MAX_BYTES", function () { return $d4ecdbf520e63dca$export$f99ded8fe4b79145; }, function (v) { return $d4ecdbf520e63dca$export$f99ded8fe4b79145 = v; });
$parcel$export(module.exports, "kMaxLength", function () { return $d4ecdbf520e63dca$export$599f31c3813fae4d; }, function (v) { return $d4ecdbf520e63dca$export$599f31c3813fae4d = v; });
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ var $d4ecdbf520e63dca$export$a143d493d941bafc;
var $d4ecdbf520e63dca$export$e4cf37d7f6fb9e0a;
var $d4ecdbf520e63dca$export$f99ded8fe4b79145;
var $d4ecdbf520e63dca$export$599f31c3813fae4d;
"use strict";

var $hqZtu = parcelRequire("hqZtu");

var $5WQj6 = parcelRequire("5WQj6");
var $d4ecdbf520e63dca$var$customInspectSymbol = typeof Symbol === "function" && typeof Symbol["for"] === "function" // eslint-disable-line dot-notation
 ? Symbol["for"]("nodejs.util.inspect.custom") // eslint-disable-line dot-notation
 : null;
$d4ecdbf520e63dca$export$a143d493d941bafc = $d4ecdbf520e63dca$var$Buffer;
$d4ecdbf520e63dca$export$e4cf37d7f6fb9e0a = $d4ecdbf520e63dca$var$SlowBuffer;
$d4ecdbf520e63dca$export$f99ded8fe4b79145 = 50;
var $d4ecdbf520e63dca$var$K_MAX_LENGTH = 0x7fffffff;
$d4ecdbf520e63dca$export$599f31c3813fae4d = $d4ecdbf520e63dca$var$K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ $d4ecdbf520e63dca$var$Buffer.TYPED_ARRAY_SUPPORT = $d4ecdbf520e63dca$var$typedArraySupport();
if (!$d4ecdbf520e63dca$var$Buffer.TYPED_ARRAY_SUPPORT && typeof console !== "undefined" && typeof console.error === "function") console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function $d4ecdbf520e63dca$var$typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        var arr = new Uint8Array(1);
        var proto = {
            foo: function() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty($d4ecdbf520e63dca$var$Buffer.prototype, "parent", {
    enumerable: true,
    get: function() {
        if (!$d4ecdbf520e63dca$var$Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty($d4ecdbf520e63dca$var$Buffer.prototype, "offset", {
    enumerable: true,
    get: function() {
        if (!$d4ecdbf520e63dca$var$Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function $d4ecdbf520e63dca$var$createBuffer(length) {
    if (length > $d4ecdbf520e63dca$var$K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    var buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, $d4ecdbf520e63dca$var$Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $d4ecdbf520e63dca$var$Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === "number") {
        if (typeof encodingOrOffset === "string") throw new TypeError('The "string" argument must be of type string. Received type number');
        return $d4ecdbf520e63dca$var$allocUnsafe(arg);
    }
    return $d4ecdbf520e63dca$var$from(arg, encodingOrOffset, length);
}
$d4ecdbf520e63dca$var$Buffer.poolSize = 8192 // not used by this implementation
;
function $d4ecdbf520e63dca$var$from(value, encodingOrOffset, length) {
    if (typeof value === "string") return $d4ecdbf520e63dca$var$fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return $d4ecdbf520e63dca$var$fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
    if ($d4ecdbf520e63dca$var$isInstance(value, ArrayBuffer) || value && $d4ecdbf520e63dca$var$isInstance(value.buffer, ArrayBuffer)) return $d4ecdbf520e63dca$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== "undefined" && ($d4ecdbf520e63dca$var$isInstance(value, SharedArrayBuffer) || value && $d4ecdbf520e63dca$var$isInstance(value.buffer, SharedArrayBuffer))) return $d4ecdbf520e63dca$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === "number") throw new TypeError('The "value" argument must not be of type number. Received type number');
    var valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return $d4ecdbf520e63dca$var$Buffer.from(valueOf, encodingOrOffset, length);
    var b = $d4ecdbf520e63dca$var$fromObject(value);
    if (b) return b;
    if (typeof Symbol !== "undefined" && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === "function") return $d4ecdbf520e63dca$var$Buffer.from(value[Symbol.toPrimitive]("string"), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $d4ecdbf520e63dca$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $d4ecdbf520e63dca$var$from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf($d4ecdbf520e63dca$var$Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf($d4ecdbf520e63dca$var$Buffer, Uint8Array);
function $d4ecdbf520e63dca$var$assertSize(size) {
    if (typeof size !== "number") throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function $d4ecdbf520e63dca$var$alloc(size, fill, encoding) {
    $d4ecdbf520e63dca$var$assertSize(size);
    if (size <= 0) return $d4ecdbf520e63dca$var$createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === "string" ? $d4ecdbf520e63dca$var$createBuffer(size).fill(fill, encoding) : $d4ecdbf520e63dca$var$createBuffer(size).fill(fill);
    return $d4ecdbf520e63dca$var$createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $d4ecdbf520e63dca$var$Buffer.alloc = function(size, fill, encoding) {
    return $d4ecdbf520e63dca$var$alloc(size, fill, encoding);
};
function $d4ecdbf520e63dca$var$allocUnsafe(size) {
    $d4ecdbf520e63dca$var$assertSize(size);
    return $d4ecdbf520e63dca$var$createBuffer(size < 0 ? 0 : $d4ecdbf520e63dca$var$checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $d4ecdbf520e63dca$var$Buffer.allocUnsafe = function(size) {
    return $d4ecdbf520e63dca$var$allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $d4ecdbf520e63dca$var$Buffer.allocUnsafeSlow = function(size) {
    return $d4ecdbf520e63dca$var$allocUnsafe(size);
};
function $d4ecdbf520e63dca$var$fromString(string, encoding) {
    if (typeof encoding !== "string" || encoding === "") encoding = "utf8";
    if (!$d4ecdbf520e63dca$var$Buffer.isEncoding(encoding)) throw new TypeError("Unknown encoding: " + encoding);
    var length = $d4ecdbf520e63dca$var$byteLength(string, encoding) | 0;
    var buf = $d4ecdbf520e63dca$var$createBuffer(length);
    var actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function $d4ecdbf520e63dca$var$fromArrayLike(array) {
    var length = array.length < 0 ? 0 : $d4ecdbf520e63dca$var$checked(array.length) | 0;
    var buf = $d4ecdbf520e63dca$var$createBuffer(length);
    for(var i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function $d4ecdbf520e63dca$var$fromArrayView(arrayView) {
    if ($d4ecdbf520e63dca$var$isInstance(arrayView, Uint8Array)) {
        var copy = new Uint8Array(arrayView);
        return $d4ecdbf520e63dca$var$fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return $d4ecdbf520e63dca$var$fromArrayLike(arrayView);
}
function $d4ecdbf520e63dca$var$fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    var buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, $d4ecdbf520e63dca$var$Buffer.prototype);
    return buf;
}
function $d4ecdbf520e63dca$var$fromObject(obj) {
    if ($d4ecdbf520e63dca$var$Buffer.isBuffer(obj)) {
        var len = $d4ecdbf520e63dca$var$checked(obj.length) | 0;
        var buf = $d4ecdbf520e63dca$var$createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== "number" || $d4ecdbf520e63dca$var$numberIsNaN(obj.length)) return $d4ecdbf520e63dca$var$createBuffer(0);
        return $d4ecdbf520e63dca$var$fromArrayLike(obj);
    }
    if (obj.type === "Buffer" && Array.isArray(obj.data)) return $d4ecdbf520e63dca$var$fromArrayLike(obj.data);
}
function $d4ecdbf520e63dca$var$checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $d4ecdbf520e63dca$var$K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $d4ecdbf520e63dca$var$K_MAX_LENGTH.toString(16) + " bytes");
    return length | 0;
}
function $d4ecdbf520e63dca$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $d4ecdbf520e63dca$var$Buffer.alloc(+length);
}
$d4ecdbf520e63dca$var$Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== $d4ecdbf520e63dca$var$Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
$d4ecdbf520e63dca$var$Buffer.compare = function compare(a, b) {
    if ($d4ecdbf520e63dca$var$isInstance(a, Uint8Array)) a = $d4ecdbf520e63dca$var$Buffer.from(a, a.offset, a.byteLength);
    if ($d4ecdbf520e63dca$var$isInstance(b, Uint8Array)) b = $d4ecdbf520e63dca$var$Buffer.from(b, b.offset, b.byteLength);
    if (!$d4ecdbf520e63dca$var$Buffer.isBuffer(a) || !$d4ecdbf520e63dca$var$Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    var x = a.length;
    var y = b.length;
    for(var i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$d4ecdbf520e63dca$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case "hex":
        case "utf8":
        case "utf-8":
        case "ascii":
        case "latin1":
        case "binary":
        case "base64":
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return true;
        default:
            return false;
    }
};
$d4ecdbf520e63dca$var$Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $d4ecdbf520e63dca$var$Buffer.alloc(0);
    var i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    var buffer = $d4ecdbf520e63dca$var$Buffer.allocUnsafe(length);
    var pos = 0;
    for(i = 0; i < list.length; ++i){
        var buf = list[i];
        if ($d4ecdbf520e63dca$var$isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) $d4ecdbf520e63dca$var$Buffer.from(buf).copy(buffer, pos);
            else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!$d4ecdbf520e63dca$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $d4ecdbf520e63dca$var$byteLength(string, encoding) {
    if ($d4ecdbf520e63dca$var$Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || $d4ecdbf520e63dca$var$isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== "string") throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string);
    var len = string.length;
    var mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    var loweredCase = false;
    for(;;)switch(encoding){
        case "ascii":
        case "latin1":
        case "binary":
            return len;
        case "utf8":
        case "utf-8":
            return $d4ecdbf520e63dca$var$utf8ToBytes(string).length;
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return len * 2;
        case "hex":
            return len >>> 1;
        case "base64":
            return $d4ecdbf520e63dca$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : $d4ecdbf520e63dca$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ("" + encoding).toLowerCase();
            loweredCase = true;
    }
}
$d4ecdbf520e63dca$var$Buffer.byteLength = $d4ecdbf520e63dca$var$byteLength;
function $d4ecdbf520e63dca$var$slowToString(encoding, start, end) {
    var loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return "";
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return "";
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return "";
    if (!encoding) encoding = "utf8";
    while(true)switch(encoding){
        case "hex":
            return $d4ecdbf520e63dca$var$hexSlice(this, start, end);
        case "utf8":
        case "utf-8":
            return $d4ecdbf520e63dca$var$utf8Slice(this, start, end);
        case "ascii":
            return $d4ecdbf520e63dca$var$asciiSlice(this, start, end);
        case "latin1":
        case "binary":
            return $d4ecdbf520e63dca$var$latin1Slice(this, start, end);
        case "base64":
            return $d4ecdbf520e63dca$var$base64Slice(this, start, end);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return $d4ecdbf520e63dca$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
            encoding = (encoding + "").toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
$d4ecdbf520e63dca$var$Buffer.prototype._isBuffer = true;
function $d4ecdbf520e63dca$var$swap(b, n, m) {
    var i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$d4ecdbf520e63dca$var$Buffer.prototype.swap16 = function swap16() {
    var len = this.length;
    if (len % 2 !== 0) throw new RangeError("Buffer size must be a multiple of 16-bits");
    for(var i = 0; i < len; i += 2)$d4ecdbf520e63dca$var$swap(this, i, i + 1);
    return this;
};
$d4ecdbf520e63dca$var$Buffer.prototype.swap32 = function swap32() {
    var len = this.length;
    if (len % 4 !== 0) throw new RangeError("Buffer size must be a multiple of 32-bits");
    for(var i = 0; i < len; i += 4){
        $d4ecdbf520e63dca$var$swap(this, i, i + 3);
        $d4ecdbf520e63dca$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$d4ecdbf520e63dca$var$Buffer.prototype.swap64 = function swap64() {
    var len = this.length;
    if (len % 8 !== 0) throw new RangeError("Buffer size must be a multiple of 64-bits");
    for(var i = 0; i < len; i += 8){
        $d4ecdbf520e63dca$var$swap(this, i, i + 7);
        $d4ecdbf520e63dca$var$swap(this, i + 1, i + 6);
        $d4ecdbf520e63dca$var$swap(this, i + 2, i + 5);
        $d4ecdbf520e63dca$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$d4ecdbf520e63dca$var$Buffer.prototype.toString = function toString() {
    var length = this.length;
    if (length === 0) return "";
    if (arguments.length === 0) return $d4ecdbf520e63dca$var$utf8Slice(this, 0, length);
    return $d4ecdbf520e63dca$var$slowToString.apply(this, arguments);
};
$d4ecdbf520e63dca$var$Buffer.prototype.toLocaleString = $d4ecdbf520e63dca$var$Buffer.prototype.toString;
$d4ecdbf520e63dca$var$Buffer.prototype.equals = function equals(b) {
    if (!$d4ecdbf520e63dca$var$Buffer.isBuffer(b)) throw new TypeError("Argument must be a Buffer");
    if (this === b) return true;
    return $d4ecdbf520e63dca$var$Buffer.compare(this, b) === 0;
};
$d4ecdbf520e63dca$var$Buffer.prototype.inspect = function inspect() {
    var str = "";
    var max = $d4ecdbf520e63dca$export$f99ded8fe4b79145;
    str = this.toString("hex", 0, max).replace(/(.{2})/g, "$1 ").trim();
    if (this.length > max) str += " ... ";
    return "<Buffer " + str + ">";
};
if ($d4ecdbf520e63dca$var$customInspectSymbol) $d4ecdbf520e63dca$var$Buffer.prototype[$d4ecdbf520e63dca$var$customInspectSymbol] = $d4ecdbf520e63dca$var$Buffer.prototype.inspect;
$d4ecdbf520e63dca$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if ($d4ecdbf520e63dca$var$isInstance(target, Uint8Array)) target = $d4ecdbf520e63dca$var$Buffer.from(target, target.offset, target.byteLength);
    if (!$d4ecdbf520e63dca$var$Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target);
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError("out of range index");
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    var x = thisEnd - thisStart;
    var y = end - start;
    var len = Math.min(x, y);
    var thisCopy = this.slice(thisStart, thisEnd);
    var targetCopy = target.slice(start, end);
    for(var i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $d4ecdbf520e63dca$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === "string") {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if ($d4ecdbf520e63dca$var$numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === "string") val = $d4ecdbf520e63dca$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($d4ecdbf520e63dca$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $d4ecdbf520e63dca$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === "number") {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === "function") {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $d4ecdbf520e63dca$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError("val must be string, number or Buffer");
}
function $d4ecdbf520e63dca$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    var indexSize = 1;
    var arrLength = arr.length;
    var valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === "ucs2" || encoding === "ucs-2" || encoding === "utf16le" || encoding === "utf-16le") {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    var i;
    if (dir) {
        var foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            var found = true;
            for(var j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$d4ecdbf520e63dca$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$d4ecdbf520e63dca$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $d4ecdbf520e63dca$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$d4ecdbf520e63dca$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $d4ecdbf520e63dca$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $d4ecdbf520e63dca$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    var remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    var strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    for(var i = 0; i < length; ++i){
        var parsed = parseInt(string.substr(i * 2, 2), 16);
        if ($d4ecdbf520e63dca$var$numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $d4ecdbf520e63dca$var$utf8Write(buf, string, offset, length) {
    return $d4ecdbf520e63dca$var$blitBuffer($d4ecdbf520e63dca$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $d4ecdbf520e63dca$var$asciiWrite(buf, string, offset, length) {
    return $d4ecdbf520e63dca$var$blitBuffer($d4ecdbf520e63dca$var$asciiToBytes(string), buf, offset, length);
}
function $d4ecdbf520e63dca$var$base64Write(buf, string, offset, length) {
    return $d4ecdbf520e63dca$var$blitBuffer($d4ecdbf520e63dca$var$base64ToBytes(string), buf, offset, length);
}
function $d4ecdbf520e63dca$var$ucs2Write(buf, string, offset, length) {
    return $d4ecdbf520e63dca$var$blitBuffer($d4ecdbf520e63dca$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$d4ecdbf520e63dca$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = "utf8";
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === "string") {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = "utf8";
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error("Buffer.write(string, encoding, offset[, length]) is no longer supported");
    var remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError("Attempt to write outside buffer bounds");
    if (!encoding) encoding = "utf8";
    var loweredCase = false;
    for(;;)switch(encoding){
        case "hex":
            return $d4ecdbf520e63dca$var$hexWrite(this, string, offset, length);
        case "utf8":
        case "utf-8":
            return $d4ecdbf520e63dca$var$utf8Write(this, string, offset, length);
        case "ascii":
        case "latin1":
        case "binary":
            return $d4ecdbf520e63dca$var$asciiWrite(this, string, offset, length);
        case "base64":
            // Warning: maxLength not taken into account in base64Write
            return $d4ecdbf520e63dca$var$base64Write(this, string, offset, length);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return $d4ecdbf520e63dca$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
            encoding = ("" + encoding).toLowerCase();
            loweredCase = true;
    }
};
$d4ecdbf520e63dca$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: "Buffer",
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $d4ecdbf520e63dca$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $hqZtu.fromByteArray(buf);
    else return $hqZtu.fromByteArray(buf.slice(start, end));
}
function $d4ecdbf520e63dca$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    var res = [];
    var i = start;
    while(i < end){
        var firstByte = buf[i];
        var codePoint = null;
        var bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            var secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $d4ecdbf520e63dca$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
var $d4ecdbf520e63dca$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $d4ecdbf520e63dca$var$decodeCodePointsArray(codePoints) {
    var len = codePoints.length;
    if (len <= $d4ecdbf520e63dca$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    var res = "";
    var i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $d4ecdbf520e63dca$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $d4ecdbf520e63dca$var$asciiSlice(buf, start, end) {
    var ret = "";
    end = Math.min(buf.length, end);
    for(var i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $d4ecdbf520e63dca$var$latin1Slice(buf, start, end) {
    var ret = "";
    end = Math.min(buf.length, end);
    for(var i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $d4ecdbf520e63dca$var$hexSlice(buf, start, end) {
    var len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    var out = "";
    for(var i = start; i < end; ++i)out += $d4ecdbf520e63dca$var$hexSliceLookupTable[buf[i]];
    return out;
}
function $d4ecdbf520e63dca$var$utf16leSlice(buf, start, end) {
    var bytes = buf.slice(start, end);
    var res = "";
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(var i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$d4ecdbf520e63dca$var$Buffer.prototype.slice = function slice(start, end) {
    var len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    var newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, $d4ecdbf520e63dca$var$Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $d4ecdbf520e63dca$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError("offset is not uint");
    if (offset + ext > length) throw new RangeError("Trying to access beyond buffer length");
}
$d4ecdbf520e63dca$var$Buffer.prototype.readUintLE = $d4ecdbf520e63dca$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $d4ecdbf520e63dca$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset];
    var mul = 1;
    var i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$d4ecdbf520e63dca$var$Buffer.prototype.readUintBE = $d4ecdbf520e63dca$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $d4ecdbf520e63dca$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset + --byteLength];
    var mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$d4ecdbf520e63dca$var$Buffer.prototype.readUint8 = $d4ecdbf520e63dca$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $d4ecdbf520e63dca$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$d4ecdbf520e63dca$var$Buffer.prototype.readUint16LE = $d4ecdbf520e63dca$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $d4ecdbf520e63dca$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$d4ecdbf520e63dca$var$Buffer.prototype.readUint16BE = $d4ecdbf520e63dca$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $d4ecdbf520e63dca$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$d4ecdbf520e63dca$var$Buffer.prototype.readUint32LE = $d4ecdbf520e63dca$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $d4ecdbf520e63dca$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$d4ecdbf520e63dca$var$Buffer.prototype.readUint32BE = $d4ecdbf520e63dca$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $d4ecdbf520e63dca$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$d4ecdbf520e63dca$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $d4ecdbf520e63dca$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset];
    var mul = 1;
    var i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$d4ecdbf520e63dca$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $d4ecdbf520e63dca$var$checkOffset(offset, byteLength, this.length);
    var i = byteLength;
    var mul = 1;
    var val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$d4ecdbf520e63dca$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $d4ecdbf520e63dca$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$d4ecdbf520e63dca$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $d4ecdbf520e63dca$var$checkOffset(offset, 2, this.length);
    var val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$d4ecdbf520e63dca$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $d4ecdbf520e63dca$var$checkOffset(offset, 2, this.length);
    var val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$d4ecdbf520e63dca$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $d4ecdbf520e63dca$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$d4ecdbf520e63dca$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $d4ecdbf520e63dca$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$d4ecdbf520e63dca$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $d4ecdbf520e63dca$var$checkOffset(offset, 4, this.length);
    return $5WQj6.read(this, offset, true, 23, 4);
};
$d4ecdbf520e63dca$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $d4ecdbf520e63dca$var$checkOffset(offset, 4, this.length);
    return $5WQj6.read(this, offset, false, 23, 4);
};
$d4ecdbf520e63dca$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $d4ecdbf520e63dca$var$checkOffset(offset, 8, this.length);
    return $5WQj6.read(this, offset, true, 52, 8);
};
$d4ecdbf520e63dca$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $d4ecdbf520e63dca$var$checkOffset(offset, 8, this.length);
    return $5WQj6.read(this, offset, false, 52, 8);
};
function $d4ecdbf520e63dca$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$d4ecdbf520e63dca$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError("Index out of range");
}
$d4ecdbf520e63dca$var$Buffer.prototype.writeUintLE = $d4ecdbf520e63dca$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        var maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $d4ecdbf520e63dca$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    var mul = 1;
    var i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$d4ecdbf520e63dca$var$Buffer.prototype.writeUintBE = $d4ecdbf520e63dca$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        var maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $d4ecdbf520e63dca$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    var i = byteLength - 1;
    var mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$d4ecdbf520e63dca$var$Buffer.prototype.writeUint8 = $d4ecdbf520e63dca$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $d4ecdbf520e63dca$var$checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
$d4ecdbf520e63dca$var$Buffer.prototype.writeUint16LE = $d4ecdbf520e63dca$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $d4ecdbf520e63dca$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$d4ecdbf520e63dca$var$Buffer.prototype.writeUint16BE = $d4ecdbf520e63dca$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $d4ecdbf520e63dca$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$d4ecdbf520e63dca$var$Buffer.prototype.writeUint32LE = $d4ecdbf520e63dca$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $d4ecdbf520e63dca$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
$d4ecdbf520e63dca$var$Buffer.prototype.writeUint32BE = $d4ecdbf520e63dca$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $d4ecdbf520e63dca$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
$d4ecdbf520e63dca$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        var limit = Math.pow(2, 8 * byteLength - 1);
        $d4ecdbf520e63dca$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    var i = 0;
    var mul = 1;
    var sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$d4ecdbf520e63dca$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        var limit = Math.pow(2, 8 * byteLength - 1);
        $d4ecdbf520e63dca$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    var i = byteLength - 1;
    var mul = 1;
    var sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$d4ecdbf520e63dca$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $d4ecdbf520e63dca$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$d4ecdbf520e63dca$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $d4ecdbf520e63dca$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$d4ecdbf520e63dca$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $d4ecdbf520e63dca$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$d4ecdbf520e63dca$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $d4ecdbf520e63dca$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
$d4ecdbf520e63dca$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $d4ecdbf520e63dca$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function $d4ecdbf520e63dca$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError("Index out of range");
    if (offset < 0) throw new RangeError("Index out of range");
}
function $d4ecdbf520e63dca$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $d4ecdbf520e63dca$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $5WQj6.write(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$d4ecdbf520e63dca$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $d4ecdbf520e63dca$var$writeFloat(this, value, offset, true, noAssert);
};
$d4ecdbf520e63dca$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $d4ecdbf520e63dca$var$writeFloat(this, value, offset, false, noAssert);
};
function $d4ecdbf520e63dca$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $d4ecdbf520e63dca$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $5WQj6.write(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$d4ecdbf520e63dca$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $d4ecdbf520e63dca$var$writeDouble(this, value, offset, true, noAssert);
};
$d4ecdbf520e63dca$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $d4ecdbf520e63dca$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$d4ecdbf520e63dca$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!$d4ecdbf520e63dca$var$Buffer.isBuffer(target)) throw new TypeError("argument should be a Buffer");
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError("targetStart out of bounds");
    if (start < 0 || start >= this.length) throw new RangeError("Index out of range");
    if (end < 0) throw new RangeError("sourceEnd out of bounds");
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    var len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === "function") // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$d4ecdbf520e63dca$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === "string") {
        if (typeof start === "string") {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === "string") {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== "string") throw new TypeError("encoding must be a string");
        if (typeof encoding === "string" && !$d4ecdbf520e63dca$var$Buffer.isEncoding(encoding)) throw new TypeError("Unknown encoding: " + encoding);
        if (val.length === 1) {
            var code = val.charCodeAt(0);
            if (encoding === "utf8" && code < 128 || encoding === "latin1") // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === "number") val = val & 255;
    else if (typeof val === "boolean") val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError("Out of range index");
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    var i;
    if (typeof val === "number") for(i = start; i < end; ++i)this[i] = val;
    else {
        var bytes = $d4ecdbf520e63dca$var$Buffer.isBuffer(val) ? val : $d4ecdbf520e63dca$var$Buffer.from(val, encoding);
        var len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// HELPER FUNCTIONS
// ================
var $d4ecdbf520e63dca$var$INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function $d4ecdbf520e63dca$var$base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split("=")[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace($d4ecdbf520e63dca$var$INVALID_BASE64_RE, "");
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return "";
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + "=";
    return str;
}
function $d4ecdbf520e63dca$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    var codePoint;
    var length = string.length;
    var leadSurrogate = null;
    var bytes = [];
    for(var i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error("Invalid code point");
    }
    return bytes;
}
function $d4ecdbf520e63dca$var$asciiToBytes(str) {
    var byteArray = [];
    for(var i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $d4ecdbf520e63dca$var$utf16leToBytes(str, units) {
    var c, hi, lo;
    var byteArray = [];
    for(var i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $d4ecdbf520e63dca$var$base64ToBytes(str) {
    return $hqZtu.toByteArray($d4ecdbf520e63dca$var$base64clean(str));
}
function $d4ecdbf520e63dca$var$blitBuffer(src, dst, offset, length) {
    for(var i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function $d4ecdbf520e63dca$var$isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function $d4ecdbf520e63dca$var$numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
var $d4ecdbf520e63dca$var$hexSliceLookupTable = function() {
    var alphabet = "0123456789abcdef";
    var table = new Array(256);
    for(var i = 0; i < 16; ++i){
        var i16 = i * 16;
        for(var j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();

});
parcelRequire.register("5WQj6", function(module, exports) {

$parcel$export(module.exports, "read", function () { return $454af19f7384844b$export$aafa59e2e03f2942; }, function (v) { return $454af19f7384844b$export$aafa59e2e03f2942 = v; });
$parcel$export(module.exports, "write", function () { return $454af19f7384844b$export$68d8715fc104d294; }, function (v) { return $454af19f7384844b$export$68d8715fc104d294 = v; });
/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */ var $454af19f7384844b$export$aafa59e2e03f2942;
var $454af19f7384844b$export$68d8715fc104d294;
$454af19f7384844b$export$aafa59e2e03f2942 = function(buffer, offset, isLE, mLen, nBytes) {
    var e, m;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var nBits = -7;
    var i = isLE ? nBytes - 1 : 0;
    var d = isLE ? -1 : 1;
    var s = buffer[offset + i];
    i += d;
    e = s & (1 << -nBits) - 1;
    s >>= -nBits;
    nBits += eLen;
    for(; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8);
    m = e & (1 << -nBits) - 1;
    e >>= -nBits;
    nBits += mLen;
    for(; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8);
    if (e === 0) e = 1 - eBias;
    else if (e === eMax) return m ? NaN : (s ? -1 : 1) * Infinity;
    else {
        m = m + Math.pow(2, mLen);
        e = e - eBias;
    }
    return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
};
$454af19f7384844b$export$68d8715fc104d294 = function(buffer, value, offset, isLE, mLen, nBytes) {
    var e, m, c;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
    var i = isLE ? 0 : nBytes - 1;
    var d = isLE ? 1 : -1;
    var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
    value = Math.abs(value);
    if (isNaN(value) || value === Infinity) {
        m = isNaN(value) ? 1 : 0;
        e = eMax;
    } else {
        e = Math.floor(Math.log(value) / Math.LN2);
        if (value * (c = Math.pow(2, -e)) < 1) {
            e--;
            c *= 2;
        }
        if (e + eBias >= 1) value += rt / c;
        else value += rt * Math.pow(2, 1 - eBias);
        if (value * c >= 2) {
            e++;
            c /= 2;
        }
        if (e + eBias >= eMax) {
            m = 0;
            e = eMax;
        } else if (e + eBias >= 1) {
            m = (value * c - 1) * Math.pow(2, mLen);
            e = e + eBias;
        } else {
            m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
            e = 0;
        }
    }
    for(; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8);
    e = e << mLen | m;
    eLen += mLen;
    for(; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8);
    buffer[offset + i - d] |= s * 128;
};

});


parcelRequire.register("lrsL3", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.sha224 = module.exports.sha256 = void 0;

var $lQ6Zm = parcelRequire("lQ6Zm");

var $ebEok = parcelRequire("ebEok");
// SHA2-256 need to try 2^128 hashes to execute birthday attack.
// BTC network is doing 2^67 hashes/sec as per early 2023.
// Choice: a ? b : c
const $f9c26d55b725e95d$var$Chi = (a, b, c)=>a & b ^ ~a & c;
// Majority function, true if any two inpust is true
const $f9c26d55b725e95d$var$Maj = (a, b, c)=>a & b ^ a & c ^ b & c;
// Round constants:
// first 32 bits of the fractional parts of the cube roots of the first 64 primes 2..311)
// prettier-ignore
const $f9c26d55b725e95d$var$SHA256_K = /* @__PURE__ */ new Uint32Array([
    0x428a2f98,
    0x71374491,
    0xb5c0fbcf,
    0xe9b5dba5,
    0x3956c25b,
    0x59f111f1,
    0x923f82a4,
    0xab1c5ed5,
    0xd807aa98,
    0x12835b01,
    0x243185be,
    0x550c7dc3,
    0x72be5d74,
    0x80deb1fe,
    0x9bdc06a7,
    0xc19bf174,
    0xe49b69c1,
    0xefbe4786,
    0x0fc19dc6,
    0x240ca1cc,
    0x2de92c6f,
    0x4a7484aa,
    0x5cb0a9dc,
    0x76f988da,
    0x983e5152,
    0xa831c66d,
    0xb00327c8,
    0xbf597fc7,
    0xc6e00bf3,
    0xd5a79147,
    0x06ca6351,
    0x14292967,
    0x27b70a85,
    0x2e1b2138,
    0x4d2c6dfc,
    0x53380d13,
    0x650a7354,
    0x766a0abb,
    0x81c2c92e,
    0x92722c85,
    0xa2bfe8a1,
    0xa81a664b,
    0xc24b8b70,
    0xc76c51a3,
    0xd192e819,
    0xd6990624,
    0xf40e3585,
    0x106aa070,
    0x19a4c116,
    0x1e376c08,
    0x2748774c,
    0x34b0bcb5,
    0x391c0cb3,
    0x4ed8aa4a,
    0x5b9cca4f,
    0x682e6ff3,
    0x748f82ee,
    0x78a5636f,
    0x84c87814,
    0x8cc70208,
    0x90befffa,
    0xa4506ceb,
    0xbef9a3f7,
    0xc67178f2
]);
// Initial state (first 32 bits of the fractional parts of the square roots of the first 8 primes 2..19):
// prettier-ignore
const $f9c26d55b725e95d$var$IV = /* @__PURE__ */ new Uint32Array([
    0x6a09e667,
    0xbb67ae85,
    0x3c6ef372,
    0xa54ff53a,
    0x510e527f,
    0x9b05688c,
    0x1f83d9ab,
    0x5be0cd19
]);
// Temporary buffer, not used to store anything between runs
// Named this way because it matches specification.
const $f9c26d55b725e95d$var$SHA256_W = /* @__PURE__ */ new Uint32Array(64);
class $f9c26d55b725e95d$var$SHA256 extends $lQ6Zm.SHA2 {
    constructor(){
        super(64, 32, 8, false);
        // We cannot use array here since array allows indexing by variable
        // which means optimizer/compiler cannot use registers.
        this.A = $f9c26d55b725e95d$var$IV[0] | 0;
        this.B = $f9c26d55b725e95d$var$IV[1] | 0;
        this.C = $f9c26d55b725e95d$var$IV[2] | 0;
        this.D = $f9c26d55b725e95d$var$IV[3] | 0;
        this.E = $f9c26d55b725e95d$var$IV[4] | 0;
        this.F = $f9c26d55b725e95d$var$IV[5] | 0;
        this.G = $f9c26d55b725e95d$var$IV[6] | 0;
        this.H = $f9c26d55b725e95d$var$IV[7] | 0;
    }
    get() {
        const { A: A, B: B, C: C, D: D, E: E, F: F, G: G, H: H } = this;
        return [
            A,
            B,
            C,
            D,
            E,
            F,
            G,
            H
        ];
    }
    // prettier-ignore
    set(A, B, C, D, E, F, G, H) {
        this.A = A | 0;
        this.B = B | 0;
        this.C = C | 0;
        this.D = D | 0;
        this.E = E | 0;
        this.F = F | 0;
        this.G = G | 0;
        this.H = H | 0;
    }
    process(view, offset) {
        // Extend the first 16 words into the remaining 48 words w[16..63] of the message schedule array
        for(let i = 0; i < 16; i++, offset += 4)$f9c26d55b725e95d$var$SHA256_W[i] = view.getUint32(offset, false);
        for(let i = 16; i < 64; i++){
            const W15 = $f9c26d55b725e95d$var$SHA256_W[i - 15];
            const W2 = $f9c26d55b725e95d$var$SHA256_W[i - 2];
            const s0 = (0, $ebEok.rotr)(W15, 7) ^ (0, $ebEok.rotr)(W15, 18) ^ W15 >>> 3;
            const s1 = (0, $ebEok.rotr)(W2, 17) ^ (0, $ebEok.rotr)(W2, 19) ^ W2 >>> 10;
            $f9c26d55b725e95d$var$SHA256_W[i] = s1 + $f9c26d55b725e95d$var$SHA256_W[i - 7] + s0 + $f9c26d55b725e95d$var$SHA256_W[i - 16] | 0;
        }
        // Compression function main loop, 64 rounds
        let { A: A, B: B, C: C, D: D, E: E, F: F, G: G, H: H } = this;
        for(let i = 0; i < 64; i++){
            const sigma1 = (0, $ebEok.rotr)(E, 6) ^ (0, $ebEok.rotr)(E, 11) ^ (0, $ebEok.rotr)(E, 25);
            const T1 = H + sigma1 + $f9c26d55b725e95d$var$Chi(E, F, G) + $f9c26d55b725e95d$var$SHA256_K[i] + $f9c26d55b725e95d$var$SHA256_W[i] | 0;
            const sigma0 = (0, $ebEok.rotr)(A, 2) ^ (0, $ebEok.rotr)(A, 13) ^ (0, $ebEok.rotr)(A, 22);
            const T2 = sigma0 + $f9c26d55b725e95d$var$Maj(A, B, C) | 0;
            H = G;
            G = F;
            F = E;
            E = D + T1 | 0;
            D = C;
            C = B;
            B = A;
            A = T1 + T2 | 0;
        }
        // Add the compressed chunk to the current hash value
        A = A + this.A | 0;
        B = B + this.B | 0;
        C = C + this.C | 0;
        D = D + this.D | 0;
        E = E + this.E | 0;
        F = F + this.F | 0;
        G = G + this.G | 0;
        H = H + this.H | 0;
        this.set(A, B, C, D, E, F, G, H);
    }
    roundClean() {
        $f9c26d55b725e95d$var$SHA256_W.fill(0);
    }
    destroy() {
        this.set(0, 0, 0, 0, 0, 0, 0, 0);
        this.buffer.fill(0);
    }
}
// Constants from https://nvlpubs.nist.gov/nistpubs/FIPS/NIST.FIPS.180-4.pdf
class $f9c26d55b725e95d$var$SHA224 extends $f9c26d55b725e95d$var$SHA256 {
    constructor(){
        super();
        this.A = -1056596264;
        this.B = 914150663;
        this.C = 812702999;
        this.D = -150054599;
        this.E = -4191439;
        this.F = 1750603025;
        this.G = 1694076839;
        this.H = -1090891868;
        this.outputLen = 28;
    }
}
/**
 * SHA2-256 hash function
 * @param message - data that would be hashed
 */ module.exports.sha256 = (0, $ebEok.wrapConstructor)(()=>new $f9c26d55b725e95d$var$SHA256());
module.exports.sha224 = (0, $ebEok.wrapConstructor)(()=>new $f9c26d55b725e95d$var$SHA224());

});
parcelRequire.register("lQ6Zm", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SHA2 = void 0;

var $kjkVj = parcelRequire("kjkVj");

var $ebEok = parcelRequire("ebEok");
// Polyfill for Safari 14
function $fe63e01cd6f9f765$var$setBigUint64(view, byteOffset, value, isLE) {
    if (typeof view.setBigUint64 === "function") return view.setBigUint64(byteOffset, value, isLE);
    const _32n = BigInt(32);
    const _u32_max = BigInt(0xffffffff);
    const wh = Number(value >> _32n & _u32_max);
    const wl = Number(value & _u32_max);
    const h = isLE ? 4 : 0;
    const l = isLE ? 0 : 4;
    view.setUint32(byteOffset + h, wh, isLE);
    view.setUint32(byteOffset + l, wl, isLE);
}
// Base SHA2 class (RFC 6234)
class $fe63e01cd6f9f765$var$SHA2 extends $ebEok.Hash {
    constructor(blockLen, outputLen, padOffset, isLE){
        super();
        this.blockLen = blockLen;
        this.outputLen = outputLen;
        this.padOffset = padOffset;
        this.isLE = isLE;
        this.finished = false;
        this.length = 0;
        this.pos = 0;
        this.destroyed = false;
        this.buffer = new Uint8Array(blockLen);
        this.view = (0, $ebEok.createView)(this.buffer);
    }
    update(data) {
        (0, $kjkVj.exists)(this);
        const { view: view, buffer: buffer, blockLen: blockLen } = this;
        data = (0, $ebEok.toBytes)(data);
        const len = data.length;
        for(let pos = 0; pos < len;){
            const take = Math.min(blockLen - this.pos, len - pos);
            // Fast path: we have at least one block in input, cast it to view and process
            if (take === blockLen) {
                const dataView = (0, $ebEok.createView)(data);
                for(; blockLen <= len - pos; pos += blockLen)this.process(dataView, pos);
                continue;
            }
            buffer.set(data.subarray(pos, pos + take), this.pos);
            this.pos += take;
            pos += take;
            if (this.pos === blockLen) {
                this.process(view, 0);
                this.pos = 0;
            }
        }
        this.length += data.length;
        this.roundClean();
        return this;
    }
    digestInto(out) {
        (0, $kjkVj.exists)(this);
        (0, $kjkVj.output)(out, this);
        this.finished = true;
        // Padding
        // We can avoid allocation of buffer for padding completely if it
        // was previously not allocated here. But it won't change performance.
        const { buffer: buffer, view: view, blockLen: blockLen, isLE: isLE } = this;
        let { pos: pos } = this;
        // append the bit '1' to the message
        buffer[pos++] = 128;
        this.buffer.subarray(pos).fill(0);
        // we have less than padOffset left in buffer, so we cannot put length in current block, need process it and pad again
        if (this.padOffset > blockLen - pos) {
            this.process(view, 0);
            pos = 0;
        }
        // Pad until full block byte with zeros
        for(let i = pos; i < blockLen; i++)buffer[i] = 0;
        // Note: sha512 requires length to be 128bit integer, but length in JS will overflow before that
        // You need to write around 2 exabytes (u64_max / 8 / (1024**6)) for this to happen.
        // So we just write lowest 64 bits of that value.
        $fe63e01cd6f9f765$var$setBigUint64(view, blockLen - 8, BigInt(this.length * 8), isLE);
        this.process(view, 0);
        const oview = (0, $ebEok.createView)(out);
        const len = this.outputLen;
        // NOTE: we do division by 4 later, which should be fused in single op with modulo by JIT
        if (len % 4) throw new Error("_sha2: outputLen should be aligned to 32bit");
        const outLen = len / 4;
        const state = this.get();
        if (outLen > state.length) throw new Error("_sha2: outputLen bigger than state");
        for(let i = 0; i < outLen; i++)oview.setUint32(4 * i, state[i], isLE);
    }
    digest() {
        const { buffer: buffer, outputLen: outputLen } = this;
        this.digestInto(buffer);
        const res = buffer.slice(0, outputLen);
        this.destroy();
        return res;
    }
    _cloneInto(to) {
        to || (to = new this.constructor());
        to.set(...this.get());
        const { blockLen: blockLen, buffer: buffer, length: length, finished: finished, destroyed: destroyed, pos: pos } = this;
        to.length = length;
        to.pos = pos;
        to.finished = finished;
        to.destroyed = destroyed;
        if (length % blockLen) to.buffer.set(buffer);
        return to;
    }
}
module.exports.SHA2 = $fe63e01cd6f9f765$var$SHA2;

});
parcelRequire.register("kjkVj", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.output = module.exports.exists = module.exports.hash = module.exports.bytes = module.exports.bool = module.exports.number = void 0;
function $ec95cfedc1b0632e$var$number(n) {
    if (!Number.isSafeInteger(n) || n < 0) throw new Error(`Wrong positive integer: ${n}`);
}
module.exports.number = $ec95cfedc1b0632e$var$number;
function $ec95cfedc1b0632e$var$bool(b) {
    if (typeof b !== "boolean") throw new Error(`Expected boolean, not ${b}`);
}
module.exports.bool = $ec95cfedc1b0632e$var$bool;
// copied from utils
function $ec95cfedc1b0632e$var$isBytes(a) {
    return a instanceof Uint8Array || a != null && typeof a === "object" && a.constructor.name === "Uint8Array";
}
function $ec95cfedc1b0632e$var$bytes(b, ...lengths) {
    if (!$ec95cfedc1b0632e$var$isBytes(b)) throw new Error("Expected Uint8Array");
    if (lengths.length > 0 && !lengths.includes(b.length)) throw new Error(`Expected Uint8Array of length ${lengths}, not of length=${b.length}`);
}
module.exports.bytes = $ec95cfedc1b0632e$var$bytes;
function $ec95cfedc1b0632e$var$hash(hash) {
    if (typeof hash !== "function" || typeof hash.create !== "function") throw new Error("Hash should be wrapped by utils.wrapConstructor");
    $ec95cfedc1b0632e$var$number(hash.outputLen);
    $ec95cfedc1b0632e$var$number(hash.blockLen);
}
module.exports.hash = $ec95cfedc1b0632e$var$hash;
function $ec95cfedc1b0632e$var$exists(instance, checkFinished = true) {
    if (instance.destroyed) throw new Error("Hash instance has been destroyed");
    if (checkFinished && instance.finished) throw new Error("Hash#digest() has already been called");
}
module.exports.exists = $ec95cfedc1b0632e$var$exists;
function $ec95cfedc1b0632e$var$output(out, instance) {
    $ec95cfedc1b0632e$var$bytes(out);
    const min = instance.outputLen;
    if (out.length < min) throw new Error(`digestInto() expects output buffer of length at least ${min}`);
}
module.exports.output = $ec95cfedc1b0632e$var$output;
const $ec95cfedc1b0632e$var$assert = {
    number: $ec95cfedc1b0632e$var$number,
    bool: $ec95cfedc1b0632e$var$bool,
    bytes: $ec95cfedc1b0632e$var$bytes,
    hash: $ec95cfedc1b0632e$var$hash,
    exists: $ec95cfedc1b0632e$var$exists,
    output: $ec95cfedc1b0632e$var$output
};
module.exports.default = $ec95cfedc1b0632e$var$assert;

});

parcelRequire.register("ebEok", function(module, exports) {
"use strict";
/*! noble-hashes - MIT License (c) 2022 Paul Miller (paulmillr.com) */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.randomBytes = module.exports.wrapXOFConstructorWithOpts = module.exports.wrapConstructorWithOpts = module.exports.wrapConstructor = module.exports.checkOpts = module.exports.Hash = module.exports.concatBytes = module.exports.toBytes = module.exports.utf8ToBytes = module.exports.asyncLoop = module.exports.nextTick = module.exports.hexToBytes = module.exports.bytesToHex = module.exports.isLE = module.exports.rotr = module.exports.createView = module.exports.u32 = module.exports.u8 = void 0;

var $iHiEG = parcelRequire("iHiEG");
// Cast array to different type
const $a5416cad94001a40$var$u8 = (arr)=>new Uint8Array(arr.buffer, arr.byteOffset, arr.byteLength);
module.exports.u8 = $a5416cad94001a40$var$u8;
const $a5416cad94001a40$var$u32 = (arr)=>new Uint32Array(arr.buffer, arr.byteOffset, Math.floor(arr.byteLength / 4));
module.exports.u32 = $a5416cad94001a40$var$u32;
function $a5416cad94001a40$var$isBytes(a) {
    return a instanceof Uint8Array || a != null && typeof a === "object" && a.constructor.name === "Uint8Array";
}
// Cast array to view
const $a5416cad94001a40$var$createView = (arr)=>new DataView(arr.buffer, arr.byteOffset, arr.byteLength);
module.exports.createView = $a5416cad94001a40$var$createView;
// The rotate right (circular right shift) operation for uint32
const $a5416cad94001a40$var$rotr = (word, shift)=>word << 32 - shift | word >>> shift;
module.exports.rotr = $a5416cad94001a40$var$rotr;
// big-endian hardware is rare. Just in case someone still decides to run hashes:
// early-throw an error because we don't support BE yet.
// Other libraries would silently corrupt the data instead of throwing an error,
// when they don't support it.
module.exports.isLE = new Uint8Array(new Uint32Array([
    0x11223344
]).buffer)[0] === 0x44;
if (!module.exports.isLE) throw new Error("Non little-endian hardware is not supported");
// Array where index 0xf0 (240) is mapped to string 'f0'
const $a5416cad94001a40$var$hexes = /* @__PURE__ */ Array.from({
    length: 256
}, (_, i)=>i.toString(16).padStart(2, "0"));
/**
 * @example bytesToHex(Uint8Array.from([0xca, 0xfe, 0x01, 0x23])) // 'cafe0123'
 */ function $a5416cad94001a40$var$bytesToHex(bytes) {
    if (!$a5416cad94001a40$var$isBytes(bytes)) throw new Error("Uint8Array expected");
    // pre-caching improves the speed 6x
    let hex = "";
    for(let i = 0; i < bytes.length; i++)hex += $a5416cad94001a40$var$hexes[bytes[i]];
    return hex;
}
module.exports.bytesToHex = $a5416cad94001a40$var$bytesToHex;
// We use optimized technique to convert hex string to byte array
const $a5416cad94001a40$var$asciis = {
    _0: 48,
    _9: 57,
    _A: 65,
    _F: 70,
    _a: 97,
    _f: 102
};
function $a5416cad94001a40$var$asciiToBase16(char) {
    if (char >= $a5416cad94001a40$var$asciis._0 && char <= $a5416cad94001a40$var$asciis._9) return char - $a5416cad94001a40$var$asciis._0;
    if (char >= $a5416cad94001a40$var$asciis._A && char <= $a5416cad94001a40$var$asciis._F) return char - ($a5416cad94001a40$var$asciis._A - 10);
    if (char >= $a5416cad94001a40$var$asciis._a && char <= $a5416cad94001a40$var$asciis._f) return char - ($a5416cad94001a40$var$asciis._a - 10);
    return;
}
/**
 * @example hexToBytes('cafe0123') // Uint8Array.from([0xca, 0xfe, 0x01, 0x23])
 */ function $a5416cad94001a40$var$hexToBytes(hex) {
    if (typeof hex !== "string") throw new Error("hex string expected, got " + typeof hex);
    const hl = hex.length;
    const al = hl / 2;
    if (hl % 2) throw new Error("padded hex string expected, got unpadded hex of length " + hl);
    const array = new Uint8Array(al);
    for(let ai = 0, hi = 0; ai < al; ai++, hi += 2){
        const n1 = $a5416cad94001a40$var$asciiToBase16(hex.charCodeAt(hi));
        const n2 = $a5416cad94001a40$var$asciiToBase16(hex.charCodeAt(hi + 1));
        if (n1 === undefined || n2 === undefined) {
            const char = hex[hi] + hex[hi + 1];
            throw new Error('hex string expected, got non-hex character "' + char + '" at index ' + hi);
        }
        array[ai] = n1 * 16 + n2;
    }
    return array;
}
module.exports.hexToBytes = $a5416cad94001a40$var$hexToBytes;
// There is no setImmediate in browser and setTimeout is slow.
// call of async fn will return Promise, which will be fullfiled only on
// next scheduler queue processing step and this is exactly what we need.
const $a5416cad94001a40$var$nextTick = async ()=>{};
module.exports.nextTick = $a5416cad94001a40$var$nextTick;
// Returns control to thread each 'tick' ms to avoid blocking
async function $a5416cad94001a40$var$asyncLoop(iters, tick, cb) {
    let ts = Date.now();
    for(let i = 0; i < iters; i++){
        cb(i);
        // Date.now() is not monotonic, so in case if clock goes backwards we return return control too
        const diff = Date.now() - ts;
        if (diff >= 0 && diff < tick) continue;
        await (0, module.exports.nextTick)();
        ts += diff;
    }
}
module.exports.asyncLoop = $a5416cad94001a40$var$asyncLoop;
/**
 * @example utf8ToBytes('abc') // new Uint8Array([97, 98, 99])
 */ function $a5416cad94001a40$var$utf8ToBytes(str) {
    if (typeof str !== "string") throw new Error(`utf8ToBytes expected string, got ${typeof str}`);
    return new Uint8Array(new TextEncoder().encode(str)); // https://bugzil.la/1681809
}
module.exports.utf8ToBytes = $a5416cad94001a40$var$utf8ToBytes;
/**
 * Normalizes (non-hex) string or Uint8Array to Uint8Array.
 * Warning: when Uint8Array is passed, it would NOT get copied.
 * Keep in mind for future mutable operations.
 */ function $a5416cad94001a40$var$toBytes(data) {
    if (typeof data === "string") data = $a5416cad94001a40$var$utf8ToBytes(data);
    if (!$a5416cad94001a40$var$isBytes(data)) throw new Error(`expected Uint8Array, got ${typeof data}`);
    return data;
}
module.exports.toBytes = $a5416cad94001a40$var$toBytes;
/**
 * Copies several Uint8Arrays into one.
 */ function $a5416cad94001a40$var$concatBytes(...arrays) {
    let sum = 0;
    for(let i = 0; i < arrays.length; i++){
        const a = arrays[i];
        if (!$a5416cad94001a40$var$isBytes(a)) throw new Error("Uint8Array expected");
        sum += a.length;
    }
    const res = new Uint8Array(sum);
    for(let i = 0, pad = 0; i < arrays.length; i++){
        const a = arrays[i];
        res.set(a, pad);
        pad += a.length;
    }
    return res;
}
module.exports.concatBytes = $a5416cad94001a40$var$concatBytes;
// For runtime check if class implements interface
class $a5416cad94001a40$var$Hash {
    // Safe version that clones internal state
    clone() {
        return this._cloneInto();
    }
}
module.exports.Hash = $a5416cad94001a40$var$Hash;
const $a5416cad94001a40$var$toStr = {}.toString;
function $a5416cad94001a40$var$checkOpts(defaults, opts) {
    if (opts !== undefined && $a5416cad94001a40$var$toStr.call(opts) !== "[object Object]") throw new Error("Options should be object or undefined");
    const merged = Object.assign(defaults, opts);
    return merged;
}
module.exports.checkOpts = $a5416cad94001a40$var$checkOpts;
function $a5416cad94001a40$var$wrapConstructor(hashCons) {
    const hashC = (msg)=>hashCons().update($a5416cad94001a40$var$toBytes(msg)).digest();
    const tmp = hashCons();
    hashC.outputLen = tmp.outputLen;
    hashC.blockLen = tmp.blockLen;
    hashC.create = ()=>hashCons();
    return hashC;
}
module.exports.wrapConstructor = $a5416cad94001a40$var$wrapConstructor;
function $a5416cad94001a40$var$wrapConstructorWithOpts(hashCons) {
    const hashC = (msg, opts)=>hashCons(opts).update($a5416cad94001a40$var$toBytes(msg)).digest();
    const tmp = hashCons({});
    hashC.outputLen = tmp.outputLen;
    hashC.blockLen = tmp.blockLen;
    hashC.create = (opts)=>hashCons(opts);
    return hashC;
}
module.exports.wrapConstructorWithOpts = $a5416cad94001a40$var$wrapConstructorWithOpts;
function $a5416cad94001a40$var$wrapXOFConstructorWithOpts(hashCons) {
    const hashC = (msg, opts)=>hashCons(opts).update($a5416cad94001a40$var$toBytes(msg)).digest();
    const tmp = hashCons({});
    hashC.outputLen = tmp.outputLen;
    hashC.blockLen = tmp.blockLen;
    hashC.create = (opts)=>hashCons(opts);
    return hashC;
}
module.exports.wrapXOFConstructorWithOpts = $a5416cad94001a40$var$wrapXOFConstructorWithOpts;
/**
 * Secure PRNG. Uses `crypto.getRandomValues`, which defers to OS.
 */ function $a5416cad94001a40$var$randomBytes(bytesLength = 32) {
    if ($iHiEG.crypto && typeof $iHiEG.crypto.getRandomValues === "function") return $iHiEG.crypto.getRandomValues(new Uint8Array(bytesLength));
    throw new Error("crypto.getRandomValues must be defined");
}
module.exports.randomBytes = $a5416cad94001a40$var$randomBytes;

});
parcelRequire.register("iHiEG", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.crypto = void 0;
module.exports.crypto = typeof globalThis === "object" && "crypto" in globalThis ? globalThis.crypto : undefined;

});




parcelRequire.register("fJ9Lg", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.sha384 = module.exports.sha512_256 = module.exports.sha512_224 = module.exports.sha512 = module.exports.SHA512 = void 0;

var $lQ6Zm = parcelRequire("lQ6Zm");

var $gXXaj = parcelRequire("gXXaj");

var $ebEok = parcelRequire("ebEok");
// Round contants (first 32 bits of the fractional parts of the cube roots of the first 80 primes 2..409):
// prettier-ignore
const [$b732a15ea3159c68$var$SHA512_Kh, $b732a15ea3159c68$var$SHA512_Kl] = /* @__PURE__ */ (()=>$gXXaj.default.split([
        "0x428a2f98d728ae22",
        "0x7137449123ef65cd",
        "0xb5c0fbcfec4d3b2f",
        "0xe9b5dba58189dbbc",
        "0x3956c25bf348b538",
        "0x59f111f1b605d019",
        "0x923f82a4af194f9b",
        "0xab1c5ed5da6d8118",
        "0xd807aa98a3030242",
        "0x12835b0145706fbe",
        "0x243185be4ee4b28c",
        "0x550c7dc3d5ffb4e2",
        "0x72be5d74f27b896f",
        "0x80deb1fe3b1696b1",
        "0x9bdc06a725c71235",
        "0xc19bf174cf692694",
        "0xe49b69c19ef14ad2",
        "0xefbe4786384f25e3",
        "0x0fc19dc68b8cd5b5",
        "0x240ca1cc77ac9c65",
        "0x2de92c6f592b0275",
        "0x4a7484aa6ea6e483",
        "0x5cb0a9dcbd41fbd4",
        "0x76f988da831153b5",
        "0x983e5152ee66dfab",
        "0xa831c66d2db43210",
        "0xb00327c898fb213f",
        "0xbf597fc7beef0ee4",
        "0xc6e00bf33da88fc2",
        "0xd5a79147930aa725",
        "0x06ca6351e003826f",
        "0x142929670a0e6e70",
        "0x27b70a8546d22ffc",
        "0x2e1b21385c26c926",
        "0x4d2c6dfc5ac42aed",
        "0x53380d139d95b3df",
        "0x650a73548baf63de",
        "0x766a0abb3c77b2a8",
        "0x81c2c92e47edaee6",
        "0x92722c851482353b",
        "0xa2bfe8a14cf10364",
        "0xa81a664bbc423001",
        "0xc24b8b70d0f89791",
        "0xc76c51a30654be30",
        "0xd192e819d6ef5218",
        "0xd69906245565a910",
        "0xf40e35855771202a",
        "0x106aa07032bbd1b8",
        "0x19a4c116b8d2d0c8",
        "0x1e376c085141ab53",
        "0x2748774cdf8eeb99",
        "0x34b0bcb5e19b48a8",
        "0x391c0cb3c5c95a63",
        "0x4ed8aa4ae3418acb",
        "0x5b9cca4f7763e373",
        "0x682e6ff3d6b2b8a3",
        "0x748f82ee5defb2fc",
        "0x78a5636f43172f60",
        "0x84c87814a1f0ab72",
        "0x8cc702081a6439ec",
        "0x90befffa23631e28",
        "0xa4506cebde82bde9",
        "0xbef9a3f7b2c67915",
        "0xc67178f2e372532b",
        "0xca273eceea26619c",
        "0xd186b8c721c0c207",
        "0xeada7dd6cde0eb1e",
        "0xf57d4f7fee6ed178",
        "0x06f067aa72176fba",
        "0x0a637dc5a2c898a6",
        "0x113f9804bef90dae",
        "0x1b710b35131c471b",
        "0x28db77f523047d84",
        "0x32caab7b40c72493",
        "0x3c9ebe0a15c9bebc",
        "0x431d67c49c100d4c",
        "0x4cc5d4becb3e42b6",
        "0x597f299cfc657e2a",
        "0x5fcb6fab3ad6faec",
        "0x6c44198c4a475817"
    ].map((n)=>BigInt(n))))();
// Temporary buffer, not used to store anything between runs
const $b732a15ea3159c68$var$SHA512_W_H = /* @__PURE__ */ new Uint32Array(80);
const $b732a15ea3159c68$var$SHA512_W_L = /* @__PURE__ */ new Uint32Array(80);
class $b732a15ea3159c68$var$SHA512 extends $lQ6Zm.SHA2 {
    constructor(){
        super(128, 64, 16, false);
        // We cannot use array here since array allows indexing by variable which means optimizer/compiler cannot use registers.
        // Also looks cleaner and easier to verify with spec.
        // Initial state (first 32 bits of the fractional parts of the square roots of the first 8 primes 2..19):
        // h -- high 32 bits, l -- low 32 bits
        this.Ah = 1779033703;
        this.Al = -205731576;
        this.Bh = -1150833019;
        this.Bl = -2067093701;
        this.Ch = 1013904242;
        this.Cl = -23791573;
        this.Dh = -1521486534;
        this.Dl = 1595750129;
        this.Eh = 1359893119;
        this.El = -1377402159;
        this.Fh = -1694144372;
        this.Fl = 725511199;
        this.Gh = 528734635;
        this.Gl = -79577749;
        this.Hh = 1541459225;
        this.Hl = 327033209;
    }
    // prettier-ignore
    get() {
        const { Ah: Ah, Al: Al, Bh: Bh, Bl: Bl, Ch: Ch, Cl: Cl, Dh: Dh, Dl: Dl, Eh: Eh, El: El, Fh: Fh, Fl: Fl, Gh: Gh, Gl: Gl, Hh: Hh, Hl: Hl } = this;
        return [
            Ah,
            Al,
            Bh,
            Bl,
            Ch,
            Cl,
            Dh,
            Dl,
            Eh,
            El,
            Fh,
            Fl,
            Gh,
            Gl,
            Hh,
            Hl
        ];
    }
    // prettier-ignore
    set(Ah, Al, Bh, Bl, Ch, Cl, Dh, Dl, Eh, El, Fh, Fl, Gh, Gl, Hh, Hl) {
        this.Ah = Ah | 0;
        this.Al = Al | 0;
        this.Bh = Bh | 0;
        this.Bl = Bl | 0;
        this.Ch = Ch | 0;
        this.Cl = Cl | 0;
        this.Dh = Dh | 0;
        this.Dl = Dl | 0;
        this.Eh = Eh | 0;
        this.El = El | 0;
        this.Fh = Fh | 0;
        this.Fl = Fl | 0;
        this.Gh = Gh | 0;
        this.Gl = Gl | 0;
        this.Hh = Hh | 0;
        this.Hl = Hl | 0;
    }
    process(view, offset) {
        // Extend the first 16 words into the remaining 64 words w[16..79] of the message schedule array
        for(let i = 0; i < 16; i++, offset += 4){
            $b732a15ea3159c68$var$SHA512_W_H[i] = view.getUint32(offset);
            $b732a15ea3159c68$var$SHA512_W_L[i] = view.getUint32(offset += 4);
        }
        for(let i = 16; i < 80; i++){
            // s0 := (w[i-15] rightrotate 1) xor (w[i-15] rightrotate 8) xor (w[i-15] rightshift 7)
            const W15h = $b732a15ea3159c68$var$SHA512_W_H[i - 15] | 0;
            const W15l = $b732a15ea3159c68$var$SHA512_W_L[i - 15] | 0;
            const s0h = $gXXaj.default.rotrSH(W15h, W15l, 1) ^ $gXXaj.default.rotrSH(W15h, W15l, 8) ^ $gXXaj.default.shrSH(W15h, W15l, 7);
            const s0l = $gXXaj.default.rotrSL(W15h, W15l, 1) ^ $gXXaj.default.rotrSL(W15h, W15l, 8) ^ $gXXaj.default.shrSL(W15h, W15l, 7);
            // s1 := (w[i-2] rightrotate 19) xor (w[i-2] rightrotate 61) xor (w[i-2] rightshift 6)
            const W2h = $b732a15ea3159c68$var$SHA512_W_H[i - 2] | 0;
            const W2l = $b732a15ea3159c68$var$SHA512_W_L[i - 2] | 0;
            const s1h = $gXXaj.default.rotrSH(W2h, W2l, 19) ^ $gXXaj.default.rotrBH(W2h, W2l, 61) ^ $gXXaj.default.shrSH(W2h, W2l, 6);
            const s1l = $gXXaj.default.rotrSL(W2h, W2l, 19) ^ $gXXaj.default.rotrBL(W2h, W2l, 61) ^ $gXXaj.default.shrSL(W2h, W2l, 6);
            // SHA256_W[i] = s0 + s1 + SHA256_W[i - 7] + SHA256_W[i - 16];
            const SUMl = $gXXaj.default.add4L(s0l, s1l, $b732a15ea3159c68$var$SHA512_W_L[i - 7], $b732a15ea3159c68$var$SHA512_W_L[i - 16]);
            const SUMh = $gXXaj.default.add4H(SUMl, s0h, s1h, $b732a15ea3159c68$var$SHA512_W_H[i - 7], $b732a15ea3159c68$var$SHA512_W_H[i - 16]);
            $b732a15ea3159c68$var$SHA512_W_H[i] = SUMh | 0;
            $b732a15ea3159c68$var$SHA512_W_L[i] = SUMl | 0;
        }
        let { Ah: Ah, Al: Al, Bh: Bh, Bl: Bl, Ch: Ch, Cl: Cl, Dh: Dh, Dl: Dl, Eh: Eh, El: El, Fh: Fh, Fl: Fl, Gh: Gh, Gl: Gl, Hh: Hh, Hl: Hl } = this;
        // Compression function main loop, 80 rounds
        for(let i = 0; i < 80; i++){
            // S1 := (e rightrotate 14) xor (e rightrotate 18) xor (e rightrotate 41)
            const sigma1h = $gXXaj.default.rotrSH(Eh, El, 14) ^ $gXXaj.default.rotrSH(Eh, El, 18) ^ $gXXaj.default.rotrBH(Eh, El, 41);
            const sigma1l = $gXXaj.default.rotrSL(Eh, El, 14) ^ $gXXaj.default.rotrSL(Eh, El, 18) ^ $gXXaj.default.rotrBL(Eh, El, 41);
            //const T1 = (H + sigma1 + Chi(E, F, G) + SHA256_K[i] + SHA256_W[i]) | 0;
            const CHIh = Eh & Fh ^ ~Eh & Gh;
            const CHIl = El & Fl ^ ~El & Gl;
            // T1 = H + sigma1 + Chi(E, F, G) + SHA512_K[i] + SHA512_W[i]
            // prettier-ignore
            const T1ll = $gXXaj.default.add5L(Hl, sigma1l, CHIl, $b732a15ea3159c68$var$SHA512_Kl[i], $b732a15ea3159c68$var$SHA512_W_L[i]);
            const T1h = $gXXaj.default.add5H(T1ll, Hh, sigma1h, CHIh, $b732a15ea3159c68$var$SHA512_Kh[i], $b732a15ea3159c68$var$SHA512_W_H[i]);
            const T1l = T1ll | 0;
            // S0 := (a rightrotate 28) xor (a rightrotate 34) xor (a rightrotate 39)
            const sigma0h = $gXXaj.default.rotrSH(Ah, Al, 28) ^ $gXXaj.default.rotrBH(Ah, Al, 34) ^ $gXXaj.default.rotrBH(Ah, Al, 39);
            const sigma0l = $gXXaj.default.rotrSL(Ah, Al, 28) ^ $gXXaj.default.rotrBL(Ah, Al, 34) ^ $gXXaj.default.rotrBL(Ah, Al, 39);
            const MAJh = Ah & Bh ^ Ah & Ch ^ Bh & Ch;
            const MAJl = Al & Bl ^ Al & Cl ^ Bl & Cl;
            Hh = Gh | 0;
            Hl = Gl | 0;
            Gh = Fh | 0;
            Gl = Fl | 0;
            Fh = Eh | 0;
            Fl = El | 0;
            ({ h: Eh, l: El } = $gXXaj.default.add(Dh | 0, Dl | 0, T1h | 0, T1l | 0));
            Dh = Ch | 0;
            Dl = Cl | 0;
            Ch = Bh | 0;
            Cl = Bl | 0;
            Bh = Ah | 0;
            Bl = Al | 0;
            const All = $gXXaj.default.add3L(T1l, sigma0l, MAJl);
            Ah = $gXXaj.default.add3H(All, T1h, sigma0h, MAJh);
            Al = All | 0;
        }
        // Add the compressed chunk to the current hash value
        ({ h: Ah, l: Al } = $gXXaj.default.add(this.Ah | 0, this.Al | 0, Ah | 0, Al | 0));
        ({ h: Bh, l: Bl } = $gXXaj.default.add(this.Bh | 0, this.Bl | 0, Bh | 0, Bl | 0));
        ({ h: Ch, l: Cl } = $gXXaj.default.add(this.Ch | 0, this.Cl | 0, Ch | 0, Cl | 0));
        ({ h: Dh, l: Dl } = $gXXaj.default.add(this.Dh | 0, this.Dl | 0, Dh | 0, Dl | 0));
        ({ h: Eh, l: El } = $gXXaj.default.add(this.Eh | 0, this.El | 0, Eh | 0, El | 0));
        ({ h: Fh, l: Fl } = $gXXaj.default.add(this.Fh | 0, this.Fl | 0, Fh | 0, Fl | 0));
        ({ h: Gh, l: Gl } = $gXXaj.default.add(this.Gh | 0, this.Gl | 0, Gh | 0, Gl | 0));
        ({ h: Hh, l: Hl } = $gXXaj.default.add(this.Hh | 0, this.Hl | 0, Hh | 0, Hl | 0));
        this.set(Ah, Al, Bh, Bl, Ch, Cl, Dh, Dl, Eh, El, Fh, Fl, Gh, Gl, Hh, Hl);
    }
    roundClean() {
        $b732a15ea3159c68$var$SHA512_W_H.fill(0);
        $b732a15ea3159c68$var$SHA512_W_L.fill(0);
    }
    destroy() {
        this.buffer.fill(0);
        this.set(0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0);
    }
}
module.exports.SHA512 = $b732a15ea3159c68$var$SHA512;
class $b732a15ea3159c68$var$SHA512_224 extends $b732a15ea3159c68$var$SHA512 {
    constructor(){
        super();
        // h -- high 32 bits, l -- low 32 bits
        this.Ah = -1942145080;
        this.Al = 424955298;
        this.Bh = 1944164710;
        this.Bl = -1982016298;
        this.Ch = 502970286;
        this.Cl = 855612546;
        this.Dh = 1738396948;
        this.Dl = 1479516111;
        this.Eh = 258812777;
        this.El = 2077511080;
        this.Fh = 2011393907;
        this.Fl = 79989058;
        this.Gh = 1067287976;
        this.Gl = 1780299464;
        this.Hh = 286451373;
        this.Hl = -1848208735;
        this.outputLen = 28;
    }
}
class $b732a15ea3159c68$var$SHA512_256 extends $b732a15ea3159c68$var$SHA512 {
    constructor(){
        super();
        // h -- high 32 bits, l -- low 32 bits
        this.Ah = 573645204;
        this.Al = -64227540;
        this.Bh = -1621794909;
        this.Bl = -934517566;
        this.Ch = 596883563;
        this.Cl = 1867755857;
        this.Dh = -1774684391;
        this.Dl = 1497426621;
        this.Eh = -1775747358;
        this.El = -1467023389;
        this.Fh = -1101128155;
        this.Fl = 1401305490;
        this.Gh = 721525244;
        this.Gl = 746961066;
        this.Hh = 246885852;
        this.Hl = -2117784414;
        this.outputLen = 32;
    }
}
class $b732a15ea3159c68$var$SHA384 extends $b732a15ea3159c68$var$SHA512 {
    constructor(){
        super();
        // h -- high 32 bits, l -- low 32 bits
        this.Ah = -876896931;
        this.Al = -1056596264;
        this.Bh = 1654270250;
        this.Bl = 914150663;
        this.Ch = -1856437926;
        this.Cl = 812702999;
        this.Dh = 355462360;
        this.Dl = -150054599;
        this.Eh = 1731405415;
        this.El = -4191439;
        this.Fh = -1900787065;
        this.Fl = 1750603025;
        this.Gh = -619958771;
        this.Gl = 1694076839;
        this.Hh = 1203062813;
        this.Hl = -1090891868;
        this.outputLen = 48;
    }
}
module.exports.sha512 = (0, $ebEok.wrapConstructor)(()=>new $b732a15ea3159c68$var$SHA512());
module.exports.sha512_224 = (0, $ebEok.wrapConstructor)(()=>new $b732a15ea3159c68$var$SHA512_224());
module.exports.sha512_256 = (0, $ebEok.wrapConstructor)(()=>new $b732a15ea3159c68$var$SHA512_256());
module.exports.sha384 = (0, $ebEok.wrapConstructor)(()=>new $b732a15ea3159c68$var$SHA384());

});
parcelRequire.register("gXXaj", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.add5L = module.exports.add5H = module.exports.add4H = module.exports.add4L = module.exports.add3H = module.exports.add3L = module.exports.add = module.exports.rotlBL = module.exports.rotlBH = module.exports.rotlSL = module.exports.rotlSH = module.exports.rotr32L = module.exports.rotr32H = module.exports.rotrBL = module.exports.rotrBH = module.exports.rotrSL = module.exports.rotrSH = module.exports.shrSL = module.exports.shrSH = module.exports.toBig = module.exports.split = module.exports.fromBig = void 0;
const $c5a00d09d36d1ee1$var$U32_MASK64 = /* @__PURE__ */ BigInt(2 ** 32 - 1);
const $c5a00d09d36d1ee1$var$_32n = /* @__PURE__ */ BigInt(32);
// We are not using BigUint64Array, because they are extremely slow as per 2022
function $c5a00d09d36d1ee1$var$fromBig(n, le = false) {
    if (le) return {
        h: Number(n & $c5a00d09d36d1ee1$var$U32_MASK64),
        l: Number(n >> $c5a00d09d36d1ee1$var$_32n & $c5a00d09d36d1ee1$var$U32_MASK64)
    };
    return {
        h: Number(n >> $c5a00d09d36d1ee1$var$_32n & $c5a00d09d36d1ee1$var$U32_MASK64) | 0,
        l: Number(n & $c5a00d09d36d1ee1$var$U32_MASK64) | 0
    };
}
module.exports.fromBig = $c5a00d09d36d1ee1$var$fromBig;
function $c5a00d09d36d1ee1$var$split(lst, le = false) {
    let Ah = new Uint32Array(lst.length);
    let Al = new Uint32Array(lst.length);
    for(let i = 0; i < lst.length; i++){
        const { h: h, l: l } = $c5a00d09d36d1ee1$var$fromBig(lst[i], le);
        [Ah[i], Al[i]] = [
            h,
            l
        ];
    }
    return [
        Ah,
        Al
    ];
}
module.exports.split = $c5a00d09d36d1ee1$var$split;
const $c5a00d09d36d1ee1$var$toBig = (h, l)=>BigInt(h >>> 0) << $c5a00d09d36d1ee1$var$_32n | BigInt(l >>> 0);
module.exports.toBig = $c5a00d09d36d1ee1$var$toBig;
// for Shift in [0, 32)
const $c5a00d09d36d1ee1$var$shrSH = (h, _l, s)=>h >>> s;
module.exports.shrSH = $c5a00d09d36d1ee1$var$shrSH;
const $c5a00d09d36d1ee1$var$shrSL = (h, l, s)=>h << 32 - s | l >>> s;
module.exports.shrSL = $c5a00d09d36d1ee1$var$shrSL;
// Right rotate for Shift in [1, 32)
const $c5a00d09d36d1ee1$var$rotrSH = (h, l, s)=>h >>> s | l << 32 - s;
module.exports.rotrSH = $c5a00d09d36d1ee1$var$rotrSH;
const $c5a00d09d36d1ee1$var$rotrSL = (h, l, s)=>h << 32 - s | l >>> s;
module.exports.rotrSL = $c5a00d09d36d1ee1$var$rotrSL;
// Right rotate for Shift in (32, 64), NOTE: 32 is special case.
const $c5a00d09d36d1ee1$var$rotrBH = (h, l, s)=>h << 64 - s | l >>> s - 32;
module.exports.rotrBH = $c5a00d09d36d1ee1$var$rotrBH;
const $c5a00d09d36d1ee1$var$rotrBL = (h, l, s)=>h >>> s - 32 | l << 64 - s;
module.exports.rotrBL = $c5a00d09d36d1ee1$var$rotrBL;
// Right rotate for shift===32 (just swaps l&h)
const $c5a00d09d36d1ee1$var$rotr32H = (_h, l)=>l;
module.exports.rotr32H = $c5a00d09d36d1ee1$var$rotr32H;
const $c5a00d09d36d1ee1$var$rotr32L = (h, _l)=>h;
module.exports.rotr32L = $c5a00d09d36d1ee1$var$rotr32L;
// Left rotate for Shift in [1, 32)
const $c5a00d09d36d1ee1$var$rotlSH = (h, l, s)=>h << s | l >>> 32 - s;
module.exports.rotlSH = $c5a00d09d36d1ee1$var$rotlSH;
const $c5a00d09d36d1ee1$var$rotlSL = (h, l, s)=>l << s | h >>> 32 - s;
module.exports.rotlSL = $c5a00d09d36d1ee1$var$rotlSL;
// Left rotate for Shift in (32, 64), NOTE: 32 is special case.
const $c5a00d09d36d1ee1$var$rotlBH = (h, l, s)=>l << s - 32 | h >>> 64 - s;
module.exports.rotlBH = $c5a00d09d36d1ee1$var$rotlBH;
const $c5a00d09d36d1ee1$var$rotlBL = (h, l, s)=>h << s - 32 | l >>> 64 - s;
module.exports.rotlBL = $c5a00d09d36d1ee1$var$rotlBL;
// JS uses 32-bit signed integers for bitwise operations which means we cannot
// simple take carry out of low bit sum by shift, we need to use division.
function $c5a00d09d36d1ee1$var$add(Ah, Al, Bh, Bl) {
    const l = (Al >>> 0) + (Bl >>> 0);
    return {
        h: Ah + Bh + (l / 2 ** 32 | 0) | 0,
        l: l | 0
    };
}
module.exports.add = $c5a00d09d36d1ee1$var$add;
// Addition with more than 2 elements
const $c5a00d09d36d1ee1$var$add3L = (Al, Bl, Cl)=>(Al >>> 0) + (Bl >>> 0) + (Cl >>> 0);
module.exports.add3L = $c5a00d09d36d1ee1$var$add3L;
const $c5a00d09d36d1ee1$var$add3H = (low, Ah, Bh, Ch)=>Ah + Bh + Ch + (low / 2 ** 32 | 0) | 0;
module.exports.add3H = $c5a00d09d36d1ee1$var$add3H;
const $c5a00d09d36d1ee1$var$add4L = (Al, Bl, Cl, Dl)=>(Al >>> 0) + (Bl >>> 0) + (Cl >>> 0) + (Dl >>> 0);
module.exports.add4L = $c5a00d09d36d1ee1$var$add4L;
const $c5a00d09d36d1ee1$var$add4H = (low, Ah, Bh, Ch, Dh)=>Ah + Bh + Ch + Dh + (low / 2 ** 32 | 0) | 0;
module.exports.add4H = $c5a00d09d36d1ee1$var$add4H;
const $c5a00d09d36d1ee1$var$add5L = (Al, Bl, Cl, Dl, El)=>(Al >>> 0) + (Bl >>> 0) + (Cl >>> 0) + (Dl >>> 0) + (El >>> 0);
module.exports.add5L = $c5a00d09d36d1ee1$var$add5L;
const $c5a00d09d36d1ee1$var$add5H = (low, Ah, Bh, Ch, Dh, Eh)=>Ah + Bh + Ch + Dh + Eh + (low / 2 ** 32 | 0) | 0;
module.exports.add5H = $c5a00d09d36d1ee1$var$add5H;
// prettier-ignore
const $c5a00d09d36d1ee1$var$u64 = {
    fromBig: $c5a00d09d36d1ee1$var$fromBig,
    split: $c5a00d09d36d1ee1$var$split,
    toBig: $c5a00d09d36d1ee1$var$toBig,
    shrSH: $c5a00d09d36d1ee1$var$shrSH,
    shrSL: $c5a00d09d36d1ee1$var$shrSL,
    rotrSH: $c5a00d09d36d1ee1$var$rotrSH,
    rotrSL: $c5a00d09d36d1ee1$var$rotrSL,
    rotrBH: $c5a00d09d36d1ee1$var$rotrBH,
    rotrBL: $c5a00d09d36d1ee1$var$rotrBL,
    rotr32H: $c5a00d09d36d1ee1$var$rotr32H,
    rotr32L: $c5a00d09d36d1ee1$var$rotr32L,
    rotlSH: $c5a00d09d36d1ee1$var$rotlSH,
    rotlSL: $c5a00d09d36d1ee1$var$rotlSL,
    rotlBH: $c5a00d09d36d1ee1$var$rotlBH,
    rotlBL: $c5a00d09d36d1ee1$var$rotlBL,
    add: $c5a00d09d36d1ee1$var$add,
    add3L: $c5a00d09d36d1ee1$var$add3L,
    add3H: $c5a00d09d36d1ee1$var$add3H,
    add4L: $c5a00d09d36d1ee1$var$add4L,
    add4H: $c5a00d09d36d1ee1$var$add4H,
    add5H: $c5a00d09d36d1ee1$var$add5H,
    add5L: $c5a00d09d36d1ee1$var$add5L
};
module.exports.default = $c5a00d09d36d1ee1$var$u64;

});


parcelRequire.register("bQlVj", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.pbkdf2Async = module.exports.pbkdf2 = void 0;

var $kjkVj = parcelRequire("kjkVj");

var $63hPu = parcelRequire("63hPu");

var $ebEok = parcelRequire("ebEok");
// Common prologue and epilogue for sync/async functions
function $89f58e9713408a6c$var$pbkdf2Init(hash, _password, _salt, _opts) {
    (0, $kjkVj.hash)(hash);
    const opts = (0, $ebEok.checkOpts)({
        dkLen: 32,
        asyncTick: 10
    }, _opts);
    const { c: c, dkLen: dkLen, asyncTick: asyncTick } = opts;
    (0, $kjkVj.number)(c);
    (0, $kjkVj.number)(dkLen);
    (0, $kjkVj.number)(asyncTick);
    if (c < 1) throw new Error("PBKDF2: iterations (c) should be >= 1");
    const password = (0, $ebEok.toBytes)(_password);
    const salt = (0, $ebEok.toBytes)(_salt);
    // DK = PBKDF2(PRF, Password, Salt, c, dkLen);
    const DK = new Uint8Array(dkLen);
    // U1 = PRF(Password, Salt + INT_32_BE(i))
    const PRF = $63hPu.hmac.create(hash, password);
    const PRFSalt = PRF._cloneInto().update(salt);
    return {
        c: c,
        dkLen: dkLen,
        asyncTick: asyncTick,
        DK: DK,
        PRF: PRF,
        PRFSalt: PRFSalt
    };
}
function $89f58e9713408a6c$var$pbkdf2Output(PRF, PRFSalt, DK, prfW, u) {
    PRF.destroy();
    PRFSalt.destroy();
    if (prfW) prfW.destroy();
    u.fill(0);
    return DK;
}
/**
 * PBKDF2-HMAC: RFC 2898 key derivation function
 * @param hash - hash function that would be used e.g. sha256
 * @param password - password from which a derived key is generated
 * @param salt - cryptographic salt
 * @param opts - {c, dkLen} where c is work factor and dkLen is output message size
 */ function $89f58e9713408a6c$var$pbkdf2(hash, password, salt, opts) {
    const { c: c, dkLen: dkLen, DK: DK, PRF: PRF, PRFSalt: PRFSalt } = $89f58e9713408a6c$var$pbkdf2Init(hash, password, salt, opts);
    let prfW; // Working copy
    const arr = new Uint8Array(4);
    const view = (0, $ebEok.createView)(arr);
    const u = new Uint8Array(PRF.outputLen);
    // DK = T1 + T2 + ⋯ + Tdklen/hlen
    for(let ti = 1, pos = 0; pos < dkLen; ti++, pos += PRF.outputLen){
        // Ti = F(Password, Salt, c, i)
        const Ti = DK.subarray(pos, pos + PRF.outputLen);
        view.setInt32(0, ti, false);
        // F(Password, Salt, c, i) = U1 ^ U2 ^ ⋯ ^ Uc
        // U1 = PRF(Password, Salt + INT_32_BE(i))
        (prfW = PRFSalt._cloneInto(prfW)).update(arr).digestInto(u);
        Ti.set(u.subarray(0, Ti.length));
        for(let ui = 1; ui < c; ui++){
            // Uc = PRF(Password, Uc−1)
            PRF._cloneInto(prfW).update(u).digestInto(u);
            for(let i = 0; i < Ti.length; i++)Ti[i] ^= u[i];
        }
    }
    return $89f58e9713408a6c$var$pbkdf2Output(PRF, PRFSalt, DK, prfW, u);
}
module.exports.pbkdf2 = $89f58e9713408a6c$var$pbkdf2;
async function $89f58e9713408a6c$var$pbkdf2Async(hash, password, salt, opts) {
    const { c: c, dkLen: dkLen, asyncTick: asyncTick, DK: DK, PRF: PRF, PRFSalt: PRFSalt } = $89f58e9713408a6c$var$pbkdf2Init(hash, password, salt, opts);
    let prfW; // Working copy
    const arr = new Uint8Array(4);
    const view = (0, $ebEok.createView)(arr);
    const u = new Uint8Array(PRF.outputLen);
    // DK = T1 + T2 + ⋯ + Tdklen/hlen
    for(let ti = 1, pos = 0; pos < dkLen; ti++, pos += PRF.outputLen){
        // Ti = F(Password, Salt, c, i)
        const Ti = DK.subarray(pos, pos + PRF.outputLen);
        view.setInt32(0, ti, false);
        // F(Password, Salt, c, i) = U1 ^ U2 ^ ⋯ ^ Uc
        // U1 = PRF(Password, Salt + INT_32_BE(i))
        (prfW = PRFSalt._cloneInto(prfW)).update(arr).digestInto(u);
        Ti.set(u.subarray(0, Ti.length));
        await (0, $ebEok.asyncLoop)(c - 1, asyncTick, ()=>{
            // Uc = PRF(Password, Uc−1)
            PRF._cloneInto(prfW).update(u).digestInto(u);
            for(let i = 0; i < Ti.length; i++)Ti[i] ^= u[i];
        });
    }
    return $89f58e9713408a6c$var$pbkdf2Output(PRF, PRFSalt, DK, prfW, u);
}
module.exports.pbkdf2Async = $89f58e9713408a6c$var$pbkdf2Async;

});
parcelRequire.register("63hPu", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.hmac = module.exports.HMAC = void 0;

var $kjkVj = parcelRequire("kjkVj");

var $ebEok = parcelRequire("ebEok");
// HMAC (RFC 2104)
class $4680da7360be1f5f$var$HMAC extends $ebEok.Hash {
    constructor(hash, _key){
        super();
        this.finished = false;
        this.destroyed = false;
        (0, $kjkVj.hash)(hash);
        const key = (0, $ebEok.toBytes)(_key);
        this.iHash = hash.create();
        if (typeof this.iHash.update !== "function") throw new Error("Expected instance of class which extends utils.Hash");
        this.blockLen = this.iHash.blockLen;
        this.outputLen = this.iHash.outputLen;
        const blockLen = this.blockLen;
        const pad = new Uint8Array(blockLen);
        // blockLen can be bigger than outputLen
        pad.set(key.length > blockLen ? hash.create().update(key).digest() : key);
        for(let i = 0; i < pad.length; i++)pad[i] ^= 0x36;
        this.iHash.update(pad);
        // By doing update (processing of first block) of outer hash here we can re-use it between multiple calls via clone
        this.oHash = hash.create();
        // Undo internal XOR && apply outer XOR
        for(let i = 0; i < pad.length; i++)pad[i] ^= 106;
        this.oHash.update(pad);
        pad.fill(0);
    }
    update(buf) {
        (0, $kjkVj.exists)(this);
        this.iHash.update(buf);
        return this;
    }
    digestInto(out) {
        (0, $kjkVj.exists)(this);
        (0, $kjkVj.bytes)(out, this.outputLen);
        this.finished = true;
        this.iHash.digestInto(out);
        this.oHash.update(out);
        this.oHash.digestInto(out);
        this.destroy();
    }
    digest() {
        const out = new Uint8Array(this.oHash.outputLen);
        this.digestInto(out);
        return out;
    }
    _cloneInto(to) {
        // Create new instance without calling constructor since key already in state and we don't know it.
        to || (to = Object.create(Object.getPrototypeOf(this), {}));
        const { oHash: oHash, iHash: iHash, finished: finished, destroyed: destroyed, blockLen: blockLen, outputLen: outputLen } = this;
        to;
        to.finished = finished;
        to.destroyed = destroyed;
        to.blockLen = blockLen;
        to.outputLen = outputLen;
        to.oHash = oHash._cloneInto(to.oHash);
        to.iHash = iHash._cloneInto(to.iHash);
        return to;
    }
    destroy() {
        this.destroyed = true;
        this.oHash.destroy();
        this.iHash.destroy();
    }
}
module.exports.HMAC = $4680da7360be1f5f$var$HMAC;
/**
 * HMAC: RFC2104 message authentication code.
 * @param hash - function that would be used e.g. sha256
 * @param key - message key
 * @param message - message data
 */ const $4680da7360be1f5f$var$hmac = (hash, key, message)=>new $4680da7360be1f5f$var$HMAC(hash, key).update(message).digest();
module.exports.hmac = $4680da7360be1f5f$var$hmac;
module.exports.hmac.create = (hash, key)=>new $4680da7360be1f5f$var$HMAC(hash, key);

});


parcelRequire.register("guT51", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
// browserify by default only pulls in files that are hard coded in requires
// In order of last to first in this file, the default wordlist will be chosen
// based on what is present. (Bundles may remove wordlists they don't need)
const $c02a2c711f53a649$var$wordlists = {};
module.exports.wordlists = $c02a2c711f53a649$var$wordlists;
let $c02a2c711f53a649$var$_default;
module.exports._default = $c02a2c711f53a649$var$_default;

try {
    module.exports._default = $c02a2c711f53a649$var$_default = (parcelRequire("4YRZc"));
    $c02a2c711f53a649$var$wordlists.czech = $c02a2c711f53a649$var$_default;
} catch (err) {}

try {
    module.exports._default = $c02a2c711f53a649$var$_default = (parcelRequire("gmhgI"));
    $c02a2c711f53a649$var$wordlists.chinese_simplified = $c02a2c711f53a649$var$_default;
} catch (err) {}

try {
    module.exports._default = $c02a2c711f53a649$var$_default = (parcelRequire("9FVoO"));
    $c02a2c711f53a649$var$wordlists.chinese_traditional = $c02a2c711f53a649$var$_default;
} catch (err) {}

try {
    module.exports._default = $c02a2c711f53a649$var$_default = (parcelRequire("4M2Fv"));
    $c02a2c711f53a649$var$wordlists.korean = $c02a2c711f53a649$var$_default;
} catch (err) {}

try {
    module.exports._default = $c02a2c711f53a649$var$_default = (parcelRequire("eFCbz"));
    $c02a2c711f53a649$var$wordlists.french = $c02a2c711f53a649$var$_default;
} catch (err) {}

try {
    module.exports._default = $c02a2c711f53a649$var$_default = (parcelRequire("hrLhZ"));
    $c02a2c711f53a649$var$wordlists.italian = $c02a2c711f53a649$var$_default;
} catch (err) {}

try {
    module.exports._default = $c02a2c711f53a649$var$_default = (parcelRequire("911oV"));
    $c02a2c711f53a649$var$wordlists.spanish = $c02a2c711f53a649$var$_default;
} catch (err) {}

try {
    module.exports._default = $c02a2c711f53a649$var$_default = (parcelRequire("lW32h"));
    $c02a2c711f53a649$var$wordlists.japanese = $c02a2c711f53a649$var$_default;
    $c02a2c711f53a649$var$wordlists.JA = $c02a2c711f53a649$var$_default;
} catch (err) {}

try {
    module.exports._default = $c02a2c711f53a649$var$_default = (parcelRequire("g6Pks"));
    $c02a2c711f53a649$var$wordlists.portuguese = $c02a2c711f53a649$var$_default;
} catch (err) {}

try {
    module.exports._default = $c02a2c711f53a649$var$_default = (parcelRequire("ml96a"));
    $c02a2c711f53a649$var$wordlists.english = $c02a2c711f53a649$var$_default;
    $c02a2c711f53a649$var$wordlists.EN = $c02a2c711f53a649$var$_default;
} catch (err) {}

});
parcelRequire.register("4YRZc", function(module, exports) {
module.exports = JSON.parse('["abdikace","abeceda","adresa","agrese","akce","aktovka","alej","alkohol","amputace","ananas","andulka","anekdota","anketa","antika","anulovat","archa","arogance","asfalt","asistent","aspirace","astma","astronom","atlas","atletika","atol","autobus","azyl","babka","bachor","bacil","baculka","badatel","bageta","bagr","bahno","bakterie","balada","baletka","balkon","balonek","balvan","balza","bambus","bankomat","barbar","baret","barman","baroko","barva","baterka","batoh","bavlna","bazalka","bazilika","bazuka","bedna","beran","beseda","bestie","beton","bezinka","bezmoc","beztak","bicykl","bidlo","biftek","bikiny","bilance","biograf","biolog","bitva","bizon","blahobyt","blatouch","blecha","bledule","blesk","blikat","blizna","blokovat","bloudit","blud","bobek","bobr","bodlina","bodnout","bohatost","bojkot","bojovat","bokorys","bolest","borec","borovice","bota","boubel","bouchat","bouda","boule","bourat","boxer","bradavka","brambora","branka","bratr","brepta","briketa","brko","brloh","bronz","broskev","brunetka","brusinka","brzda","brzy","bublina","bubnovat","buchta","buditel","budka","budova","bufet","bujarost","bukvice","buldok","bulva","bunda","bunkr","burza","butik","buvol","buzola","bydlet","bylina","bytovka","bzukot","capart","carevna","cedr","cedule","cejch","cejn","cela","celer","celkem","celnice","cenina","cennost","cenovka","centrum","cenzor","cestopis","cetka","chalupa","chapadlo","charita","chata","chechtat","chemie","chichot","chirurg","chlad","chleba","chlubit","chmel","chmura","chobot","chochol","chodba","cholera","chomout","chopit","choroba","chov","chrapot","chrlit","chrt","chrup","chtivost","chudina","chutnat","chvat","chvilka","chvost","chyba","chystat","chytit","cibule","cigareta","cihelna","cihla","cinkot","cirkus","cisterna","citace","citrus","cizinec","cizost","clona","cokoliv","couvat","ctitel","ctnost","cudnost","cuketa","cukr","cupot","cvaknout","cval","cvik","cvrkot","cyklista","daleko","dareba","datel","datum","dcera","debata","dechovka","decibel","deficit","deflace","dekl","dekret","demokrat","deprese","derby","deska","detektiv","dikobraz","diktovat","dioda","diplom","disk","displej","divadlo","divoch","dlaha","dlouho","dluhopis","dnes","dobro","dobytek","docent","dochutit","dodnes","dohled","dohoda","dohra","dojem","dojnice","doklad","dokola","doktor","dokument","dolar","doleva","dolina","doma","dominant","domluvit","domov","donutit","dopad","dopis","doplnit","doposud","doprovod","dopustit","dorazit","dorost","dort","dosah","doslov","dostatek","dosud","dosyta","dotaz","dotek","dotknout","doufat","doutnat","dovozce","dozadu","doznat","dozorce","drahota","drak","dramatik","dravec","draze","drdol","drobnost","drogerie","drozd","drsnost","drtit","drzost","duben","duchovno","dudek","duha","duhovka","dusit","dusno","dutost","dvojice","dvorec","dynamit","ekolog","ekonomie","elektron","elipsa","email","emise","emoce","empatie","epizoda","epocha","epopej","epos","esej","esence","eskorta","eskymo","etiketa","euforie","evoluce","exekuce","exkurze","expedice","exploze","export","extrakt","facka","fajfka","fakulta","fanatik","fantazie","farmacie","favorit","fazole","federace","fejeton","fenka","fialka","figurant","filozof","filtr","finance","finta","fixace","fjord","flanel","flirt","flotila","fond","fosfor","fotbal","fotka","foton","frakce","freska","fronta","fukar","funkce","fyzika","galeje","garant","genetika","geolog","gilotina","glazura","glejt","golem","golfista","gotika","graf","gramofon","granule","grep","gril","grog","groteska","guma","hadice","hadr","hala","halenka","hanba","hanopis","harfa","harpuna","havran","hebkost","hejkal","hejno","hejtman","hektar","helma","hematom","herec","herna","heslo","hezky","historik","hladovka","hlasivky","hlava","hledat","hlen","hlodavec","hloh","hloupost","hltat","hlubina","hluchota","hmat","hmota","hmyz","hnis","hnojivo","hnout","hoblina","hoboj","hoch","hodiny","hodlat","hodnota","hodovat","hojnost","hokej","holinka","holka","holub","homole","honitba","honorace","horal","horda","horizont","horko","horlivec","hormon","hornina","horoskop","horstvo","hospoda","hostina","hotovost","houba","houf","houpat","houska","hovor","hradba","hranice","hravost","hrazda","hrbolek","hrdina","hrdlo","hrdost","hrnek","hrobka","hromada","hrot","hrouda","hrozen","hrstka","hrubost","hryzat","hubenost","hubnout","hudba","hukot","humr","husita","hustota","hvozd","hybnost","hydrant","hygiena","hymna","hysterik","idylka","ihned","ikona","iluze","imunita","infekce","inflace","inkaso","inovace","inspekce","internet","invalida","investor","inzerce","ironie","jablko","jachta","jahoda","jakmile","jakost","jalovec","jantar","jarmark","jaro","jasan","jasno","jatka","javor","jazyk","jedinec","jedle","jednatel","jehlan","jekot","jelen","jelito","jemnost","jenom","jepice","jeseter","jevit","jezdec","jezero","jinak","jindy","jinoch","jiskra","jistota","jitrnice","jizva","jmenovat","jogurt","jurta","kabaret","kabel","kabinet","kachna","kadet","kadidlo","kahan","kajak","kajuta","kakao","kaktus","kalamita","kalhoty","kalibr","kalnost","kamera","kamkoliv","kamna","kanibal","kanoe","kantor","kapalina","kapela","kapitola","kapka","kaple","kapota","kapr","kapusta","kapybara","karamel","karotka","karton","kasa","katalog","katedra","kauce","kauza","kavalec","kazajka","kazeta","kazivost","kdekoliv","kdesi","kedluben","kemp","keramika","kino","klacek","kladivo","klam","klapot","klasika","klaun","klec","klenba","klepat","klesnout","klid","klima","klisna","klobouk","klokan","klopa","kloub","klubovna","klusat","kluzkost","kmen","kmitat","kmotr","kniha","knot","koalice","koberec","kobka","kobliha","kobyla","kocour","kohout","kojenec","kokos","koktejl","kolaps","koleda","kolize","kolo","komando","kometa","komik","komnata","komora","kompas","komunita","konat","koncept","kondice","konec","konfese","kongres","konina","konkurs","kontakt","konzerva","kopanec","kopie","kopnout","koprovka","korbel","korektor","kormidlo","koroptev","korpus","koruna","koryto","korzet","kosatec","kostka","kotel","kotleta","kotoul","koukat","koupelna","kousek","kouzlo","kovboj","koza","kozoroh","krabice","krach","krajina","kralovat","krasopis","kravata","kredit","krejcar","kresba","kreveta","kriket","kritik","krize","krkavec","krmelec","krmivo","krocan","krok","kronika","kropit","kroupa","krovka","krtek","kruhadlo","krupice","krutost","krvinka","krychle","krypta","krystal","kryt","kudlanka","kufr","kujnost","kukla","kulajda","kulich","kulka","kulomet","kultura","kuna","kupodivu","kurt","kurzor","kutil","kvalita","kvasinka","kvestor","kynolog","kyselina","kytara","kytice","kytka","kytovec","kyvadlo","labrador","lachtan","ladnost","laik","lakomec","lamela","lampa","lanovka","lasice","laso","lastura","latinka","lavina","lebka","leckdy","leden","lednice","ledovka","ledvina","legenda","legie","legrace","lehce","lehkost","lehnout","lektvar","lenochod","lentilka","lepenka","lepidlo","letadlo","letec","letmo","letokruh","levhart","levitace","levobok","libra","lichotka","lidojed","lidskost","lihovina","lijavec","lilek","limetka","linie","linka","linoleum","listopad","litina","litovat","lobista","lodivod","logika","logoped","lokalita","loket","lomcovat","lopata","lopuch","lord","losos","lotr","loudal","louh","louka","louskat","lovec","lstivost","lucerna","lucifer","lump","lusk","lustrace","lvice","lyra","lyrika","lysina","madam","madlo","magistr","mahagon","majetek","majitel","majorita","makak","makovice","makrela","malba","malina","malovat","malvice","maminka","mandle","manko","marnost","masakr","maskot","masopust","matice","matrika","maturita","mazanec","mazivo","mazlit","mazurka","mdloba","mechanik","meditace","medovina","melasa","meloun","mentolka","metla","metoda","metr","mezera","migrace","mihnout","mihule","mikina","mikrofon","milenec","milimetr","milost","mimika","mincovna","minibar","minomet","minulost","miska","mistr","mixovat","mladost","mlha","mlhovina","mlok","mlsat","mluvit","mnich","mnohem","mobil","mocnost","modelka","modlitba","mohyla","mokro","molekula","momentka","monarcha","monokl","monstrum","montovat","monzun","mosaz","moskyt","most","motivace","motorka","motyka","moucha","moudrost","mozaika","mozek","mozol","mramor","mravenec","mrkev","mrtvola","mrzet","mrzutost","mstitel","mudrc","muflon","mulat","mumie","munice","muset","mutace","muzeum","muzikant","myslivec","mzda","nabourat","nachytat","nadace","nadbytek","nadhoz","nadobro","nadpis","nahlas","nahnat","nahodile","nahradit","naivita","najednou","najisto","najmout","naklonit","nakonec","nakrmit","nalevo","namazat","namluvit","nanometr","naoko","naopak","naostro","napadat","napevno","naplnit","napnout","naposled","naprosto","narodit","naruby","narychlo","nasadit","nasekat","naslepo","nastat","natolik","navenek","navrch","navzdory","nazvat","nebe","nechat","necky","nedaleko","nedbat","neduh","negace","nehet","nehoda","nejen","nejprve","neklid","nelibost","nemilost","nemoc","neochota","neonka","nepokoj","nerost","nerv","nesmysl","nesoulad","netvor","neuron","nevina","nezvykle","nicota","nijak","nikam","nikdy","nikl","nikterak","nitro","nocleh","nohavice","nominace","nora","norek","nositel","nosnost","nouze","noviny","novota","nozdra","nuda","nudle","nuget","nutit","nutnost","nutrie","nymfa","obal","obarvit","obava","obdiv","obec","obehnat","obejmout","obezita","obhajoba","obilnice","objasnit","objekt","obklopit","oblast","oblek","obliba","obloha","obluda","obnos","obohatit","obojek","obout","obrazec","obrna","obruba","obrys","obsah","obsluha","obstarat","obuv","obvaz","obvinit","obvod","obvykle","obyvatel","obzor","ocas","ocel","ocenit","ochladit","ochota","ochrana","ocitnout","odboj","odbyt","odchod","odcizit","odebrat","odeslat","odevzdat","odezva","odhadce","odhodit","odjet","odjinud","odkaz","odkoupit","odliv","odluka","odmlka","odolnost","odpad","odpis","odplout","odpor","odpustit","odpykat","odrazka","odsoudit","odstup","odsun","odtok","odtud","odvaha","odveta","odvolat","odvracet","odznak","ofina","ofsajd","ohlas","ohnisko","ohrada","ohrozit","ohryzek","okap","okenice","oklika","okno","okouzlit","okovy","okrasa","okres","okrsek","okruh","okupant","okurka","okusit","olejnina","olizovat","omak","omeleta","omezit","omladina","omlouvat","omluva","omyl","onehdy","opakovat","opasek","operace","opice","opilost","opisovat","opora","opozice","opravdu","oproti","orbital","orchestr","orgie","orlice","orloj","ortel","osada","oschnout","osika","osivo","oslava","oslepit","oslnit","oslovit","osnova","osoba","osolit","ospalec","osten","ostraha","ostuda","ostych","osvojit","oteplit","otisk","otop","otrhat","otrlost","otrok","otruby","otvor","ovanout","ovar","oves","ovlivnit","ovoce","oxid","ozdoba","pachatel","pacient","padouch","pahorek","pakt","palanda","palec","palivo","paluba","pamflet","pamlsek","panenka","panika","panna","panovat","panstvo","pantofle","paprika","parketa","parodie","parta","paruka","paryba","paseka","pasivita","pastelka","patent","patrona","pavouk","pazneht","pazourek","pecka","pedagog","pejsek","peklo","peloton","penalta","pendrek","penze","periskop","pero","pestrost","petarda","petice","petrolej","pevnina","pexeso","pianista","piha","pijavice","pikle","piknik","pilina","pilnost","pilulka","pinzeta","pipeta","pisatel","pistole","pitevna","pivnice","pivovar","placenta","plakat","plamen","planeta","plastika","platit","plavidlo","plaz","plech","plemeno","plenta","ples","pletivo","plevel","plivat","plnit","plno","plocha","plodina","plomba","plout","pluk","plyn","pobavit","pobyt","pochod","pocit","poctivec","podat","podcenit","podepsat","podhled","podivit","podklad","podmanit","podnik","podoba","podpora","podraz","podstata","podvod","podzim","poezie","pohanka","pohnutka","pohovor","pohroma","pohyb","pointa","pojistka","pojmout","pokazit","pokles","pokoj","pokrok","pokuta","pokyn","poledne","polibek","polknout","poloha","polynom","pomalu","pominout","pomlka","pomoc","pomsta","pomyslet","ponechat","ponorka","ponurost","popadat","popel","popisek","poplach","poprosit","popsat","popud","poradce","porce","porod","porucha","poryv","posadit","posed","posila","poskok","poslanec","posoudit","pospolu","postava","posudek","posyp","potah","potkan","potlesk","potomek","potrava","potupa","potvora","poukaz","pouto","pouzdro","povaha","povidla","povlak","povoz","povrch","povstat","povyk","povzdech","pozdrav","pozemek","poznatek","pozor","pozvat","pracovat","prahory","praktika","prales","praotec","praporek","prase","pravda","princip","prkno","probudit","procento","prodej","profese","prohra","projekt","prolomit","promile","pronikat","propad","prorok","prosba","proton","proutek","provaz","prskavka","prsten","prudkost","prut","prvek","prvohory","psanec","psovod","pstruh","ptactvo","puberta","puch","pudl","pukavec","puklina","pukrle","pult","pumpa","punc","pupen","pusa","pusinka","pustina","putovat","putyka","pyramida","pysk","pytel","racek","rachot","radiace","radnice","radon","raft","ragby","raketa","rakovina","rameno","rampouch","rande","rarach","rarita","rasovna","rastr","ratolest","razance","razidlo","reagovat","reakce","recept","redaktor","referent","reflex","rejnok","reklama","rekord","rekrut","rektor","reputace","revize","revma","revolver","rezerva","riskovat","riziko","robotika","rodokmen","rohovka","rokle","rokoko","romaneto","ropovod","ropucha","rorejs","rosol","rostlina","rotmistr","rotoped","rotunda","roubenka","roucho","roup","roura","rovina","rovnice","rozbor","rozchod","rozdat","rozeznat","rozhodce","rozinka","rozjezd","rozkaz","rozloha","rozmar","rozpad","rozruch","rozsah","roztok","rozum","rozvod","rubrika","ruchadlo","rukavice","rukopis","ryba","rybolov","rychlost","rydlo","rypadlo","rytina","ryzost","sadista","sahat","sako","samec","samizdat","samota","sanitka","sardinka","sasanka","satelit","sazba","sazenice","sbor","schovat","sebranka","secese","sedadlo","sediment","sedlo","sehnat","sejmout","sekera","sekta","sekunda","sekvoje","semeno","seno","servis","sesadit","seshora","seskok","seslat","sestra","sesuv","sesypat","setba","setina","setkat","setnout","setrvat","sever","seznam","shoda","shrnout","sifon","silnice","sirka","sirotek","sirup","situace","skafandr","skalisko","skanzen","skaut","skeptik","skica","skladba","sklenice","sklo","skluz","skoba","skokan","skoro","skripta","skrz","skupina","skvost","skvrna","slabika","sladidlo","slanina","slast","slavnost","sledovat","slepec","sleva","slezina","slib","slina","sliznice","slon","sloupek","slovo","sluch","sluha","slunce","slupka","slza","smaragd","smetana","smilstvo","smlouva","smog","smrad","smrk","smrtka","smutek","smysl","snad","snaha","snob","sobota","socha","sodovka","sokol","sopka","sotva","souboj","soucit","soudce","souhlas","soulad","soumrak","souprava","soused","soutok","souviset","spalovna","spasitel","spis","splav","spodek","spojenec","spolu","sponzor","spornost","spousta","sprcha","spustit","sranda","sraz","srdce","srna","srnec","srovnat","srpen","srst","srub","stanice","starosta","statika","stavba","stehno","stezka","stodola","stolek","stopa","storno","stoupat","strach","stres","strhnout","strom","struna","studna","stupnice","stvol","styk","subjekt","subtropy","suchar","sudost","sukno","sundat","sunout","surikata","surovina","svah","svalstvo","svetr","svatba","svazek","svisle","svitek","svoboda","svodidlo","svorka","svrab","sykavka","sykot","synek","synovec","sypat","sypkost","syrovost","sysel","sytost","tabletka","tabule","tahoun","tajemno","tajfun","tajga","tajit","tajnost","taktika","tamhle","tampon","tancovat","tanec","tanker","tapeta","tavenina","tazatel","technika","tehdy","tekutina","telefon","temnota","tendence","tenista","tenor","teplota","tepna","teprve","terapie","termoska","textil","ticho","tiskopis","titulek","tkadlec","tkanina","tlapka","tleskat","tlukot","tlupa","tmel","toaleta","topinka","topol","torzo","touha","toulec","tradice","traktor","tramp","trasa","traverza","trefit","trest","trezor","trhavina","trhlina","trochu","trojice","troska","trouba","trpce","trpitel","trpkost","trubec","truchlit","truhlice","trus","trvat","tudy","tuhnout","tuhost","tundra","turista","turnaj","tuzemsko","tvaroh","tvorba","tvrdost","tvrz","tygr","tykev","ubohost","uboze","ubrat","ubrousek","ubrus","ubytovna","ucho","uctivost","udivit","uhradit","ujednat","ujistit","ujmout","ukazatel","uklidnit","uklonit","ukotvit","ukrojit","ulice","ulita","ulovit","umyvadlo","unavit","uniforma","uniknout","upadnout","uplatnit","uplynout","upoutat","upravit","uran","urazit","usednout","usilovat","usmrtit","usnadnit","usnout","usoudit","ustlat","ustrnout","utahovat","utkat","utlumit","utonout","utopenec","utrousit","uvalit","uvolnit","uvozovka","uzdravit","uzel","uzenina","uzlina","uznat","vagon","valcha","valoun","vana","vandal","vanilka","varan","varhany","varovat","vcelku","vchod","vdova","vedro","vegetace","vejce","velbloud","veletrh","velitel","velmoc","velryba","venkov","veranda","verze","veselka","veskrze","vesnice","vespodu","vesta","veterina","veverka","vibrace","vichr","videohra","vidina","vidle","vila","vinice","viset","vitalita","vize","vizitka","vjezd","vklad","vkus","vlajka","vlak","vlasec","vlevo","vlhkost","vliv","vlnovka","vloupat","vnucovat","vnuk","voda","vodivost","vodoznak","vodstvo","vojensky","vojna","vojsko","volant","volba","volit","volno","voskovka","vozidlo","vozovna","vpravo","vrabec","vracet","vrah","vrata","vrba","vrcholek","vrhat","vrstva","vrtule","vsadit","vstoupit","vstup","vtip","vybavit","vybrat","vychovat","vydat","vydra","vyfotit","vyhledat","vyhnout","vyhodit","vyhradit","vyhubit","vyjasnit","vyjet","vyjmout","vyklopit","vykonat","vylekat","vymazat","vymezit","vymizet","vymyslet","vynechat","vynikat","vynutit","vypadat","vyplatit","vypravit","vypustit","vyrazit","vyrovnat","vyrvat","vyslovit","vysoko","vystavit","vysunout","vysypat","vytasit","vytesat","vytratit","vyvinout","vyvolat","vyvrhel","vyzdobit","vyznat","vzadu","vzbudit","vzchopit","vzdor","vzduch","vzdychat","vzestup","vzhledem","vzkaz","vzlykat","vznik","vzorek","vzpoura","vztah","vztek","xylofon","zabrat","zabydlet","zachovat","zadarmo","zadusit","zafoukat","zahltit","zahodit","zahrada","zahynout","zajatec","zajet","zajistit","zaklepat","zakoupit","zalepit","zamezit","zamotat","zamyslet","zanechat","zanikat","zaplatit","zapojit","zapsat","zarazit","zastavit","zasunout","zatajit","zatemnit","zatknout","zaujmout","zavalit","zavelet","zavinit","zavolat","zavrtat","zazvonit","zbavit","zbrusu","zbudovat","zbytek","zdaleka","zdarma","zdatnost","zdivo","zdobit","zdroj","zdvih","zdymadlo","zelenina","zeman","zemina","zeptat","zezadu","zezdola","zhatit","zhltnout","zhluboka","zhotovit","zhruba","zima","zimnice","zjemnit","zklamat","zkoumat","zkratka","zkumavka","zlato","zlehka","zloba","zlom","zlost","zlozvyk","zmapovat","zmar","zmatek","zmije","zmizet","zmocnit","zmodrat","zmrzlina","zmutovat","znak","znalost","znamenat","znovu","zobrazit","zotavit","zoubek","zoufale","zplodit","zpomalit","zprava","zprostit","zprudka","zprvu","zrada","zranit","zrcadlo","zrnitost","zrno","zrovna","zrychlit","zrzavost","zticha","ztratit","zubovina","zubr","zvednout","zvenku","zvesela","zvon","zvrat","zvukovod","zvyk"]');

});

parcelRequire.register("gmhgI", function(module, exports) {
module.exports = JSON.parse('["的","一","是","在","不","了","有","和","人","这","中","大","为","上","个","国","我","以","要","他","时","来","用","们","生","到","作","地","于","出","就","分","对","成","会","可","主","发","年","动","同","工","也","能","下","过","子","说","产","种","面","而","方","后","多","定","行","学","法","所","民","得","经","十","三","之","进","着","等","部","度","家","电","力","里","如","水","化","高","自","二","理","起","小","物","现","实","加","量","都","两","体","制","机","当","使","点","从","业","本","去","把","性","好","应","开","它","合","还","因","由","其","些","然","前","外","天","政","四","日","那","社","义","事","平","形","相","全","表","间","样","与","关","各","重","新","线","内","数","正","心","反","你","明","看","原","又","么","利","比","或","但","质","气","第","向","道","命","此","变","条","只","没","结","解","问","意","建","月","公","无","系","军","很","情","者","最","立","代","想","已","通","并","提","直","题","党","程","展","五","果","料","象","员","革","位","入","常","文","总","次","品","式","活","设","及","管","特","件","长","求","老","头","基","资","边","流","路","级","少","图","山","统","接","知","较","将","组","见","计","别","她","手","角","期","根","论","运","农","指","几","九","区","强","放","决","西","被","干","做","必","战","先","回","则","任","取","据","处","队","南","给","色","光","门","即","保","治","北","造","百","规","热","领","七","海","口","东","导","器","压","志","世","金","增","争","济","阶","油","思","术","极","交","受","联","什","认","六","共","权","收","证","改","清","美","再","采","转","更","单","风","切","打","白","教","速","花","带","安","场","身","车","例","真","务","具","万","每","目","至","达","走","积","示","议","声","报","斗","完","类","八","离","华","名","确","才","科","张","信","马","节","话","米","整","空","元","况","今","集","温","传","土","许","步","群","广","石","记","需","段","研","界","拉","林","律","叫","且","究","观","越","织","装","影","算","低","持","音","众","书","布","复","容","儿","须","际","商","非","验","连","断","深","难","近","矿","千","周","委","素","技","备","半","办","青","省","列","习","响","约","支","般","史","感","劳","便","团","往","酸","历","市","克","何","除","消","构","府","称","太","准","精","值","号","率","族","维","划","选","标","写","存","候","毛","亲","快","效","斯","院","查","江","型","眼","王","按","格","养","易","置","派","层","片","始","却","专","状","育","厂","京","识","适","属","圆","包","火","住","调","满","县","局","照","参","红","细","引","听","该","铁","价","严","首","底","液","官","德","随","病","苏","失","尔","死","讲","配","女","黄","推","显","谈","罪","神","艺","呢","席","含","企","望","密","批","营","项","防","举","球","英","氧","势","告","李","台","落","木","帮","轮","破","亚","师","围","注","远","字","材","排","供","河","态","封","另","施","减","树","溶","怎","止","案","言","士","均","武","固","叶","鱼","波","视","仅","费","紧","爱","左","章","早","朝","害","续","轻","服","试","食","充","兵","源","判","护","司","足","某","练","差","致","板","田","降","黑","犯","负","击","范","继","兴","似","余","坚","曲","输","修","故","城","夫","够","送","笔","船","占","右","财","吃","富","春","职","觉","汉","画","功","巴","跟","虽","杂","飞","检","吸","助","升","阳","互","初","创","抗","考","投","坏","策","古","径","换","未","跑","留","钢","曾","端","责","站","简","述","钱","副","尽","帝","射","草","冲","承","独","令","限","阿","宣","环","双","请","超","微","让","控","州","良","轴","找","否","纪","益","依","优","顶","础","载","倒","房","突","坐","粉","敌","略","客","袁","冷","胜","绝","析","块","剂","测","丝","协","诉","念","陈","仍","罗","盐","友","洋","错","苦","夜","刑","移","频","逐","靠","混","母","短","皮","终","聚","汽","村","云","哪","既","距","卫","停","烈","央","察","烧","迅","境","若","印","洲","刻","括","激","孔","搞","甚","室","待","核","校","散","侵","吧","甲","游","久","菜","味","旧","模","湖","货","损","预","阻","毫","普","稳","乙","妈","植","息","扩","银","语","挥","酒","守","拿","序","纸","医","缺","雨","吗","针","刘","啊","急","唱","误","训","愿","审","附","获","茶","鲜","粮","斤","孩","脱","硫","肥","善","龙","演","父","渐","血","欢","械","掌","歌","沙","刚","攻","谓","盾","讨","晚","粒","乱","燃","矛","乎","杀","药","宁","鲁","贵","钟","煤","读","班","伯","香","介","迫","句","丰","培","握","兰","担","弦","蛋","沉","假","穿","执","答","乐","谁","顺","烟","缩","征","脸","喜","松","脚","困","异","免","背","星","福","买","染","井","概","慢","怕","磁","倍","祖","皇","促","静","补","评","翻","肉","践","尼","衣","宽","扬","棉","希","伤","操","垂","秋","宜","氢","套","督","振","架","亮","末","宪","庆","编","牛","触","映","雷","销","诗","座","居","抓","裂","胞","呼","娘","景","威","绿","晶","厚","盟","衡","鸡","孙","延","危","胶","屋","乡","临","陆","顾","掉","呀","灯","岁","措","束","耐","剧","玉","赵","跳","哥","季","课","凯","胡","额","款","绍","卷","齐","伟","蒸","殖","永","宗","苗","川","炉","岩","弱","零","杨","奏","沿","露","杆","探","滑","镇","饭","浓","航","怀","赶","库","夺","伊","灵","税","途","灭","赛","归","召","鼓","播","盘","裁","险","康","唯","录","菌","纯","借","糖","盖","横","符","私","努","堂","域","枪","润","幅","哈","竟","熟","虫","泽","脑","壤","碳","欧","遍","侧","寨","敢","彻","虑","斜","薄","庭","纳","弹","饲","伸","折","麦","湿","暗","荷","瓦","塞","床","筑","恶","户","访","塔","奇","透","梁","刀","旋","迹","卡","氯","遇","份","毒","泥","退","洗","摆","灰","彩","卖","耗","夏","择","忙","铜","献","硬","予","繁","圈","雪","函","亦","抽","篇","阵","阴","丁","尺","追","堆","雄","迎","泛","爸","楼","避","谋","吨","野","猪","旗","累","偏","典","馆","索","秦","脂","潮","爷","豆","忽","托","惊","塑","遗","愈","朱","替","纤","粗","倾","尚","痛","楚","谢","奋","购","磨","君","池","旁","碎","骨","监","捕","弟","暴","割","贯","殊","释","词","亡","壁","顿","宝","午","尘","闻","揭","炮","残","冬","桥","妇","警","综","招","吴","付","浮","遭","徐","您","摇","谷","赞","箱","隔","订","男","吹","园","纷","唐","败","宋","玻","巨","耕","坦","荣","闭","湾","键","凡","驻","锅","救","恩","剥","凝","碱","齿","截","炼","麻","纺","禁","废","盛","版","缓","净","睛","昌","婚","涉","筒","嘴","插","岸","朗","庄","街","藏","姑","贸","腐","奴","啦","惯","乘","伙","恢","匀","纱","扎","辩","耳","彪","臣","亿","璃","抵","脉","秀","萨","俄","网","舞","店","喷","纵","寸","汗","挂","洪","贺","闪","柬","爆","烯","津","稻","墙","软","勇","像","滚","厘","蒙","芳","肯","坡","柱","荡","腿","仪","旅","尾","轧","冰","贡","登","黎","削","钻","勒","逃","障","氨","郭","峰","币","港","伏","轨","亩","毕","擦","莫","刺","浪","秘","援","株","健","售","股","岛","甘","泡","睡","童","铸","汤","阀","休","汇","舍","牧","绕","炸","哲","磷","绩","朋","淡","尖","启","陷","柴","呈","徒","颜","泪","稍","忘","泵","蓝","拖","洞","授","镜","辛","壮","锋","贫","虚","弯","摩","泰","幼","廷","尊","窗","纲","弄","隶","疑","氏","宫","姐","震","瑞","怪","尤","琴","循","描","膜","违","夹","腰","缘","珠","穷","森","枝","竹","沟","催","绳","忆","邦","剩","幸","浆","栏","拥","牙","贮","礼","滤","钠","纹","罢","拍","咱","喊","袖","埃","勤","罚","焦","潜","伍","墨","欲","缝","姓","刊","饱","仿","奖","铝","鬼","丽","跨","默","挖","链","扫","喝","袋","炭","污","幕","诸","弧","励","梅","奶","洁","灾","舟","鉴","苯","讼","抱","毁","懂","寒","智","埔","寄","届","跃","渡","挑","丹","艰","贝","碰","拔","爹","戴","码","梦","芽","熔","赤","渔","哭","敬","颗","奔","铅","仲","虎","稀","妹","乏","珍","申","桌","遵","允","隆","螺","仓","魏","锐","晓","氮","兼","隐","碍","赫","拨","忠","肃","缸","牵","抢","博","巧","壳","兄","杜","讯","诚","碧","祥","柯","页","巡","矩","悲","灌","龄","伦","票","寻","桂","铺","圣","恐","恰","郑","趣","抬","荒","腾","贴","柔","滴","猛","阔","辆","妻","填","撤","储","签","闹","扰","紫","砂","递","戏","吊","陶","伐","喂","疗","瓶","婆","抚","臂","摸","忍","虾","蜡","邻","胸","巩","挤","偶","弃","槽","劲","乳","邓","吉","仁","烂","砖","租","乌","舰","伴","瓜","浅","丙","暂","燥","橡","柳","迷","暖","牌","秧","胆","详","簧","踏","瓷","谱","呆","宾","糊","洛","辉","愤","竞","隙","怒","粘","乃","绪","肩","籍","敏","涂","熙","皆","侦","悬","掘","享","纠","醒","狂","锁","淀","恨","牲","霸","爬","赏","逆","玩","陵","祝","秒","浙","貌","役","彼","悉","鸭","趋","凤","晨","畜","辈","秩","卵","署","梯","炎","滩","棋","驱","筛","峡","冒","啥","寿","译","浸","泉","帽","迟","硅","疆","贷","漏","稿","冠","嫩","胁","芯","牢","叛","蚀","奥","鸣","岭","羊","凭","串","塘","绘","酵","融","盆","锡","庙","筹","冻","辅","摄","袭","筋","拒","僚","旱","钾","鸟","漆","沈","眉","疏","添","棒","穗","硝","韩","逼","扭","侨","凉","挺","碗","栽","炒","杯","患","馏","劝","豪","辽","勃","鸿","旦","吏","拜","狗","埋","辊","掩","饮","搬","骂","辞","勾","扣","估","蒋","绒","雾","丈","朵","姆","拟","宇","辑","陕","雕","偿","蓄","崇","剪","倡","厅","咬","驶","薯","刷","斥","番","赋","奉","佛","浇","漫","曼","扇","钙","桃","扶","仔","返","俗","亏","腔","鞋","棱","覆","框","悄","叔","撞","骗","勘","旺","沸","孤","吐","孟","渠","屈","疾","妙","惜","仰","狠","胀","谐","抛","霉","桑","岗","嘛","衰","盗","渗","脏","赖","涌","甜","曹","阅","肌","哩","厉","烃","纬","毅","昨","伪","症","煮","叹","钉","搭","茎","笼","酷","偷","弓","锥","恒","杰","坑","鼻","翼","纶","叙","狱","逮","罐","络","棚","抑","膨","蔬","寺","骤","穆","冶","枯","册","尸","凸","绅","坯","牺","焰","轰","欣","晋","瘦","御","锭","锦","丧","旬","锻","垄","搜","扑","邀","亭","酯","迈","舒","脆","酶","闲","忧","酚","顽","羽","涨","卸","仗","陪","辟","惩","杭","姚","肚","捉","飘","漂","昆","欺","吾","郎","烷","汁","呵","饰","萧","雅","邮","迁","燕","撒","姻","赴","宴","烦","债","帐","斑","铃","旨","醇","董","饼","雏","姿","拌","傅","腹","妥","揉","贤","拆","歪","葡","胺","丢","浩","徽","昂","垫","挡","览","贪","慰","缴","汪","慌","冯","诺","姜","谊","凶","劣","诬","耀","昏","躺","盈","骑","乔","溪","丛","卢","抹","闷","咨","刮","驾","缆","悟","摘","铒","掷","颇","幻","柄","惠","惨","佳","仇","腊","窝","涤","剑","瞧","堡","泼","葱","罩","霍","捞","胎","苍","滨","俩","捅","湘","砍","霞","邵","萄","疯","淮","遂","熊","粪","烘","宿","档","戈","驳","嫂","裕","徙","箭","捐","肠","撑","晒","辨","殿","莲","摊","搅","酱","屏","疫","哀","蔡","堵","沫","皱","畅","叠","阁","莱","敲","辖","钩","痕","坝","巷","饿","祸","丘","玄","溜","曰","逻","彭","尝","卿","妨","艇","吞","韦","怨","矮","歇"]');

});

parcelRequire.register("9FVoO", function(module, exports) {
module.exports = JSON.parse('["的","一","是","在","不","了","有","和","人","這","中","大","為","上","個","國","我","以","要","他","時","來","用","們","生","到","作","地","於","出","就","分","對","成","會","可","主","發","年","動","同","工","也","能","下","過","子","說","產","種","面","而","方","後","多","定","行","學","法","所","民","得","經","十","三","之","進","著","等","部","度","家","電","力","裡","如","水","化","高","自","二","理","起","小","物","現","實","加","量","都","兩","體","制","機","當","使","點","從","業","本","去","把","性","好","應","開","它","合","還","因","由","其","些","然","前","外","天","政","四","日","那","社","義","事","平","形","相","全","表","間","樣","與","關","各","重","新","線","內","數","正","心","反","你","明","看","原","又","麼","利","比","或","但","質","氣","第","向","道","命","此","變","條","只","沒","結","解","問","意","建","月","公","無","系","軍","很","情","者","最","立","代","想","已","通","並","提","直","題","黨","程","展","五","果","料","象","員","革","位","入","常","文","總","次","品","式","活","設","及","管","特","件","長","求","老","頭","基","資","邊","流","路","級","少","圖","山","統","接","知","較","將","組","見","計","別","她","手","角","期","根","論","運","農","指","幾","九","區","強","放","決","西","被","幹","做","必","戰","先","回","則","任","取","據","處","隊","南","給","色","光","門","即","保","治","北","造","百","規","熱","領","七","海","口","東","導","器","壓","志","世","金","增","爭","濟","階","油","思","術","極","交","受","聯","什","認","六","共","權","收","證","改","清","美","再","採","轉","更","單","風","切","打","白","教","速","花","帶","安","場","身","車","例","真","務","具","萬","每","目","至","達","走","積","示","議","聲","報","鬥","完","類","八","離","華","名","確","才","科","張","信","馬","節","話","米","整","空","元","況","今","集","溫","傳","土","許","步","群","廣","石","記","需","段","研","界","拉","林","律","叫","且","究","觀","越","織","裝","影","算","低","持","音","眾","書","布","复","容","兒","須","際","商","非","驗","連","斷","深","難","近","礦","千","週","委","素","技","備","半","辦","青","省","列","習","響","約","支","般","史","感","勞","便","團","往","酸","歷","市","克","何","除","消","構","府","稱","太","準","精","值","號","率","族","維","劃","選","標","寫","存","候","毛","親","快","效","斯","院","查","江","型","眼","王","按","格","養","易","置","派","層","片","始","卻","專","狀","育","廠","京","識","適","屬","圓","包","火","住","調","滿","縣","局","照","參","紅","細","引","聽","該","鐵","價","嚴","首","底","液","官","德","隨","病","蘇","失","爾","死","講","配","女","黃","推","顯","談","罪","神","藝","呢","席","含","企","望","密","批","營","項","防","舉","球","英","氧","勢","告","李","台","落","木","幫","輪","破","亞","師","圍","注","遠","字","材","排","供","河","態","封","另","施","減","樹","溶","怎","止","案","言","士","均","武","固","葉","魚","波","視","僅","費","緊","愛","左","章","早","朝","害","續","輕","服","試","食","充","兵","源","判","護","司","足","某","練","差","致","板","田","降","黑","犯","負","擊","范","繼","興","似","餘","堅","曲","輸","修","故","城","夫","夠","送","筆","船","佔","右","財","吃","富","春","職","覺","漢","畫","功","巴","跟","雖","雜","飛","檢","吸","助","昇","陽","互","初","創","抗","考","投","壞","策","古","徑","換","未","跑","留","鋼","曾","端","責","站","簡","述","錢","副","盡","帝","射","草","衝","承","獨","令","限","阿","宣","環","雙","請","超","微","讓","控","州","良","軸","找","否","紀","益","依","優","頂","礎","載","倒","房","突","坐","粉","敵","略","客","袁","冷","勝","絕","析","塊","劑","測","絲","協","訴","念","陳","仍","羅","鹽","友","洋","錯","苦","夜","刑","移","頻","逐","靠","混","母","短","皮","終","聚","汽","村","雲","哪","既","距","衛","停","烈","央","察","燒","迅","境","若","印","洲","刻","括","激","孔","搞","甚","室","待","核","校","散","侵","吧","甲","遊","久","菜","味","舊","模","湖","貨","損","預","阻","毫","普","穩","乙","媽","植","息","擴","銀","語","揮","酒","守","拿","序","紙","醫","缺","雨","嗎","針","劉","啊","急","唱","誤","訓","願","審","附","獲","茶","鮮","糧","斤","孩","脫","硫","肥","善","龍","演","父","漸","血","歡","械","掌","歌","沙","剛","攻","謂","盾","討","晚","粒","亂","燃","矛","乎","殺","藥","寧","魯","貴","鐘","煤","讀","班","伯","香","介","迫","句","豐","培","握","蘭","擔","弦","蛋","沉","假","穿","執","答","樂","誰","順","煙","縮","徵","臉","喜","松","腳","困","異","免","背","星","福","買","染","井","概","慢","怕","磁","倍","祖","皇","促","靜","補","評","翻","肉","踐","尼","衣","寬","揚","棉","希","傷","操","垂","秋","宜","氫","套","督","振","架","亮","末","憲","慶","編","牛","觸","映","雷","銷","詩","座","居","抓","裂","胞","呼","娘","景","威","綠","晶","厚","盟","衡","雞","孫","延","危","膠","屋","鄉","臨","陸","顧","掉","呀","燈","歲","措","束","耐","劇","玉","趙","跳","哥","季","課","凱","胡","額","款","紹","卷","齊","偉","蒸","殖","永","宗","苗","川","爐","岩","弱","零","楊","奏","沿","露","桿","探","滑","鎮","飯","濃","航","懷","趕","庫","奪","伊","靈","稅","途","滅","賽","歸","召","鼓","播","盤","裁","險","康","唯","錄","菌","純","借","糖","蓋","橫","符","私","努","堂","域","槍","潤","幅","哈","竟","熟","蟲","澤","腦","壤","碳","歐","遍","側","寨","敢","徹","慮","斜","薄","庭","納","彈","飼","伸","折","麥","濕","暗","荷","瓦","塞","床","築","惡","戶","訪","塔","奇","透","梁","刀","旋","跡","卡","氯","遇","份","毒","泥","退","洗","擺","灰","彩","賣","耗","夏","擇","忙","銅","獻","硬","予","繁","圈","雪","函","亦","抽","篇","陣","陰","丁","尺","追","堆","雄","迎","泛","爸","樓","避","謀","噸","野","豬","旗","累","偏","典","館","索","秦","脂","潮","爺","豆","忽","托","驚","塑","遺","愈","朱","替","纖","粗","傾","尚","痛","楚","謝","奮","購","磨","君","池","旁","碎","骨","監","捕","弟","暴","割","貫","殊","釋","詞","亡","壁","頓","寶","午","塵","聞","揭","炮","殘","冬","橋","婦","警","綜","招","吳","付","浮","遭","徐","您","搖","谷","贊","箱","隔","訂","男","吹","園","紛","唐","敗","宋","玻","巨","耕","坦","榮","閉","灣","鍵","凡","駐","鍋","救","恩","剝","凝","鹼","齒","截","煉","麻","紡","禁","廢","盛","版","緩","淨","睛","昌","婚","涉","筒","嘴","插","岸","朗","莊","街","藏","姑","貿","腐","奴","啦","慣","乘","夥","恢","勻","紗","扎","辯","耳","彪","臣","億","璃","抵","脈","秀","薩","俄","網","舞","店","噴","縱","寸","汗","掛","洪","賀","閃","柬","爆","烯","津","稻","牆","軟","勇","像","滾","厘","蒙","芳","肯","坡","柱","盪","腿","儀","旅","尾","軋","冰","貢","登","黎","削","鑽","勒","逃","障","氨","郭","峰","幣","港","伏","軌","畝","畢","擦","莫","刺","浪","秘","援","株","健","售","股","島","甘","泡","睡","童","鑄","湯","閥","休","匯","舍","牧","繞","炸","哲","磷","績","朋","淡","尖","啟","陷","柴","呈","徒","顏","淚","稍","忘","泵","藍","拖","洞","授","鏡","辛","壯","鋒","貧","虛","彎","摩","泰","幼","廷","尊","窗","綱","弄","隸","疑","氏","宮","姐","震","瑞","怪","尤","琴","循","描","膜","違","夾","腰","緣","珠","窮","森","枝","竹","溝","催","繩","憶","邦","剩","幸","漿","欄","擁","牙","貯","禮","濾","鈉","紋","罷","拍","咱","喊","袖","埃","勤","罰","焦","潛","伍","墨","欲","縫","姓","刊","飽","仿","獎","鋁","鬼","麗","跨","默","挖","鏈","掃","喝","袋","炭","污","幕","諸","弧","勵","梅","奶","潔","災","舟","鑑","苯","訟","抱","毀","懂","寒","智","埔","寄","屆","躍","渡","挑","丹","艱","貝","碰","拔","爹","戴","碼","夢","芽","熔","赤","漁","哭","敬","顆","奔","鉛","仲","虎","稀","妹","乏","珍","申","桌","遵","允","隆","螺","倉","魏","銳","曉","氮","兼","隱","礙","赫","撥","忠","肅","缸","牽","搶","博","巧","殼","兄","杜","訊","誠","碧","祥","柯","頁","巡","矩","悲","灌","齡","倫","票","尋","桂","鋪","聖","恐","恰","鄭","趣","抬","荒","騰","貼","柔","滴","猛","闊","輛","妻","填","撤","儲","簽","鬧","擾","紫","砂","遞","戲","吊","陶","伐","餵","療","瓶","婆","撫","臂","摸","忍","蝦","蠟","鄰","胸","鞏","擠","偶","棄","槽","勁","乳","鄧","吉","仁","爛","磚","租","烏","艦","伴","瓜","淺","丙","暫","燥","橡","柳","迷","暖","牌","秧","膽","詳","簧","踏","瓷","譜","呆","賓","糊","洛","輝","憤","競","隙","怒","粘","乃","緒","肩","籍","敏","塗","熙","皆","偵","懸","掘","享","糾","醒","狂","鎖","淀","恨","牲","霸","爬","賞","逆","玩","陵","祝","秒","浙","貌","役","彼","悉","鴨","趨","鳳","晨","畜","輩","秩","卵","署","梯","炎","灘","棋","驅","篩","峽","冒","啥","壽","譯","浸","泉","帽","遲","矽","疆","貸","漏","稿","冠","嫩","脅","芯","牢","叛","蝕","奧","鳴","嶺","羊","憑","串","塘","繪","酵","融","盆","錫","廟","籌","凍","輔","攝","襲","筋","拒","僚","旱","鉀","鳥","漆","沈","眉","疏","添","棒","穗","硝","韓","逼","扭","僑","涼","挺","碗","栽","炒","杯","患","餾","勸","豪","遼","勃","鴻","旦","吏","拜","狗","埋","輥","掩","飲","搬","罵","辭","勾","扣","估","蔣","絨","霧","丈","朵","姆","擬","宇","輯","陝","雕","償","蓄","崇","剪","倡","廳","咬","駛","薯","刷","斥","番","賦","奉","佛","澆","漫","曼","扇","鈣","桃","扶","仔","返","俗","虧","腔","鞋","棱","覆","框","悄","叔","撞","騙","勘","旺","沸","孤","吐","孟","渠","屈","疾","妙","惜","仰","狠","脹","諧","拋","黴","桑","崗","嘛","衰","盜","滲","臟","賴","湧","甜","曹","閱","肌","哩","厲","烴","緯","毅","昨","偽","症","煮","嘆","釘","搭","莖","籠","酷","偷","弓","錐","恆","傑","坑","鼻","翼","綸","敘","獄","逮","罐","絡","棚","抑","膨","蔬","寺","驟","穆","冶","枯","冊","屍","凸","紳","坯","犧","焰","轟","欣","晉","瘦","禦","錠","錦","喪","旬","鍛","壟","搜","撲","邀","亭","酯","邁","舒","脆","酶","閒","憂","酚","頑","羽","漲","卸","仗","陪","闢","懲","杭","姚","肚","捉","飄","漂","昆","欺","吾","郎","烷","汁","呵","飾","蕭","雅","郵","遷","燕","撒","姻","赴","宴","煩","債","帳","斑","鈴","旨","醇","董","餅","雛","姿","拌","傅","腹","妥","揉","賢","拆","歪","葡","胺","丟","浩","徽","昂","墊","擋","覽","貪","慰","繳","汪","慌","馮","諾","姜","誼","兇","劣","誣","耀","昏","躺","盈","騎","喬","溪","叢","盧","抹","悶","諮","刮","駕","纜","悟","摘","鉺","擲","頗","幻","柄","惠","慘","佳","仇","臘","窩","滌","劍","瞧","堡","潑","蔥","罩","霍","撈","胎","蒼","濱","倆","捅","湘","砍","霞","邵","萄","瘋","淮","遂","熊","糞","烘","宿","檔","戈","駁","嫂","裕","徙","箭","捐","腸","撐","曬","辨","殿","蓮","攤","攪","醬","屏","疫","哀","蔡","堵","沫","皺","暢","疊","閣","萊","敲","轄","鉤","痕","壩","巷","餓","禍","丘","玄","溜","曰","邏","彭","嘗","卿","妨","艇","吞","韋","怨","矮","歇"]');

});

parcelRequire.register("4M2Fv", function(module, exports) {
module.exports = JSON.parse('["가격","가끔","가난","가능","가득","가르침","가뭄","가방","가상","가슴","가운데","가을","가이드","가입","가장","가정","가족","가죽","각오","각자","간격","간부","간섭","간장","간접","간판","갈등","갈비","갈색","갈증","감각","감기","감소","감수성","감자","감정","갑자기","강남","강당","강도","강력히","강변","강북","강사","강수량","강아지","강원도","강의","강제","강조","같이","개구리","개나리","개방","개별","개선","개성","개인","객관적","거실","거액","거울","거짓","거품","걱정","건강","건물","건설","건조","건축","걸음","검사","검토","게시판","게임","겨울","견해","결과","결국","결론","결석","결승","결심","결정","결혼","경계","경고","경기","경력","경복궁","경비","경상도","경영","경우","경쟁","경제","경주","경찰","경치","경향","경험","계곡","계단","계란","계산","계속","계약","계절","계층","계획","고객","고구려","고궁","고급","고등학생","고무신","고민","고양이","고장","고전","고집","고춧가루","고통","고향","곡식","골목","골짜기","골프","공간","공개","공격","공군","공급","공기","공동","공무원","공부","공사","공식","공업","공연","공원","공장","공짜","공책","공통","공포","공항","공휴일","과목","과일","과장","과정","과학","관객","관계","관광","관념","관람","관련","관리","관습","관심","관점","관찰","광경","광고","광장","광주","괴로움","굉장히","교과서","교문","교복","교실","교양","교육","교장","교직","교통","교환","교훈","구경","구름","구멍","구별","구분","구석","구성","구속","구역","구입","구청","구체적","국가","국기","국내","국립","국물","국민","국수","국어","국왕","국적","국제","국회","군대","군사","군인","궁극적","권리","권위","권투","귀국","귀신","규정","규칙","균형","그날","그냥","그늘","그러나","그룹","그릇","그림","그제서야","그토록","극복","극히","근거","근교","근래","근로","근무","근본","근원","근육","근처","글씨","글자","금강산","금고","금년","금메달","금액","금연","금요일","금지","긍정적","기간","기관","기념","기능","기독교","기둥","기록","기름","기법","기본","기분","기쁨","기숙사","기술","기억","기업","기온","기운","기원","기적","기준","기침","기혼","기획","긴급","긴장","길이","김밥","김치","김포공항","깍두기","깜빡","깨달음","깨소금","껍질","꼭대기","꽃잎","나들이","나란히","나머지","나물","나침반","나흘","낙엽","난방","날개","날씨","날짜","남녀","남대문","남매","남산","남자","남편","남학생","낭비","낱말","내년","내용","내일","냄비","냄새","냇물","냉동","냉면","냉방","냉장고","넥타이","넷째","노동","노란색","노력","노인","녹음","녹차","녹화","논리","논문","논쟁","놀이","농구","농담","농민","농부","농업","농장","농촌","높이","눈동자","눈물","눈썹","뉴욕","느낌","늑대","능동적","능력","다방","다양성","다음","다이어트","다행","단계","단골","단독","단맛","단순","단어","단위","단점","단체","단추","단편","단풍","달걀","달러","달력","달리","닭고기","담당","담배","담요","담임","답변","답장","당근","당분간","당연히","당장","대규모","대낮","대단히","대답","대도시","대략","대량","대륙","대문","대부분","대신","대응","대장","대전","대접","대중","대책","대출","대충","대통령","대학","대한민국","대합실","대형","덩어리","데이트","도대체","도덕","도둑","도망","도서관","도심","도움","도입","도자기","도저히","도전","도중","도착","독감","독립","독서","독일","독창적","동화책","뒷모습","뒷산","딸아이","마누라","마늘","마당","마라톤","마련","마무리","마사지","마약","마요네즈","마을","마음","마이크","마중","마지막","마찬가지","마찰","마흔","막걸리","막내","막상","만남","만두","만세","만약","만일","만점","만족","만화","많이","말기","말씀","말투","맘대로","망원경","매년","매달","매력","매번","매스컴","매일","매장","맥주","먹이","먼저","먼지","멀리","메일","며느리","며칠","면담","멸치","명단","명령","명예","명의","명절","명칭","명함","모금","모니터","모델","모든","모범","모습","모양","모임","모조리","모집","모퉁이","목걸이","목록","목사","목소리","목숨","목적","목표","몰래","몸매","몸무게","몸살","몸속","몸짓","몸통","몹시","무관심","무궁화","무더위","무덤","무릎","무슨","무엇","무역","무용","무조건","무지개","무척","문구","문득","문법","문서","문제","문학","문화","물가","물건","물결","물고기","물론","물리학","물음","물질","물체","미국","미디어","미사일","미술","미역","미용실","미움","미인","미팅","미혼","민간","민족","민주","믿음","밀가루","밀리미터","밑바닥","바가지","바구니","바나나","바늘","바닥","바닷가","바람","바이러스","바탕","박물관","박사","박수","반대","반드시","반말","반발","반성","반응","반장","반죽","반지","반찬","받침","발가락","발걸음","발견","발달","발레","발목","발바닥","발생","발음","발자국","발전","발톱","발표","밤하늘","밥그릇","밥맛","밥상","밥솥","방금","방면","방문","방바닥","방법","방송","방식","방안","방울","방지","방학","방해","방향","배경","배꼽","배달","배드민턴","백두산","백색","백성","백인","백제","백화점","버릇","버섯","버튼","번개","번역","번지","번호","벌금","벌레","벌써","범위","범인","범죄","법률","법원","법적","법칙","베이징","벨트","변경","변동","변명","변신","변호사","변화","별도","별명","별일","병실","병아리","병원","보관","보너스","보라색","보람","보름","보상","보안","보자기","보장","보전","보존","보통","보편적","보험","복도","복사","복숭아","복습","볶음","본격적","본래","본부","본사","본성","본인","본질","볼펜","봉사","봉지","봉투","부근","부끄러움","부담","부동산","부문","부분","부산","부상","부엌","부인","부작용","부장","부정","부족","부지런히","부친","부탁","부품","부회장","북부","북한","분노","분량","분리","분명","분석","분야","분위기","분필","분홍색","불고기","불과","불교","불꽃","불만","불법","불빛","불안","불이익","불행","브랜드","비극","비난","비닐","비둘기","비디오","비로소","비만","비명","비밀","비바람","비빔밥","비상","비용","비율","비중","비타민","비판","빌딩","빗물","빗방울","빗줄기","빛깔","빨간색","빨래","빨리","사건","사계절","사나이","사냥","사람","사랑","사립","사모님","사물","사방","사상","사생활","사설","사슴","사실","사업","사용","사월","사장","사전","사진","사촌","사춘기","사탕","사투리","사흘","산길","산부인과","산업","산책","살림","살인","살짝","삼계탕","삼국","삼십","삼월","삼촌","상관","상금","상대","상류","상반기","상상","상식","상업","상인","상자","상점","상처","상추","상태","상표","상품","상황","새벽","색깔","색연필","생각","생명","생물","생방송","생산","생선","생신","생일","생활","서랍","서른","서명","서민","서비스","서양","서울","서적","서점","서쪽","서클","석사","석유","선거","선물","선배","선생","선수","선원","선장","선전","선택","선풍기","설거지","설날","설렁탕","설명","설문","설사","설악산","설치","설탕","섭씨","성공","성당","성명","성별","성인","성장","성적","성질","성함","세금","세미나","세상","세월","세종대왕","세탁","센터","센티미터","셋째","소규모","소극적","소금","소나기","소년","소득","소망","소문","소설","소속","소아과","소용","소원","소음","소중히","소지품","소질","소풍","소형","속담","속도","속옷","손가락","손길","손녀","손님","손등","손목","손뼉","손실","손질","손톱","손해","솔직히","솜씨","송아지","송이","송편","쇠고기","쇼핑","수건","수년","수단","수돗물","수동적","수면","수명","수박","수상","수석","수술","수시로","수업","수염","수영","수입","수준","수집","수출","수컷","수필","수학","수험생","수화기","숙녀","숙소","숙제","순간","순서","순수","순식간","순위","숟가락","술병","술집","숫자","스님","스물","스스로","스승","스웨터","스위치","스케이트","스튜디오","스트레스","스포츠","슬쩍","슬픔","습관","습기","승객","승리","승부","승용차","승진","시각","시간","시골","시금치","시나리오","시댁","시리즈","시멘트","시민","시부모","시선","시설","시스템","시아버지","시어머니","시월","시인","시일","시작","시장","시절","시점","시중","시즌","시집","시청","시합","시험","식구","식기","식당","식량","식료품","식물","식빵","식사","식생활","식초","식탁","식품","신고","신규","신념","신문","신발","신비","신사","신세","신용","신제품","신청","신체","신화","실감","실내","실력","실례","실망","실수","실습","실시","실장","실정","실질적","실천","실체","실컷","실태","실패","실험","실현","심리","심부름","심사","심장","심정","심판","쌍둥이","씨름","씨앗","아가씨","아나운서","아드님","아들","아쉬움","아스팔트","아시아","아울러","아저씨","아줌마","아직","아침","아파트","아프리카","아픔","아홉","아흔","악기","악몽","악수","안개","안경","안과","안내","안녕","안동","안방","안부","안주","알루미늄","알코올","암시","암컷","압력","앞날","앞문","애인","애정","액수","앨범","야간","야단","야옹","약간","약국","약속","약수","약점","약품","약혼녀","양념","양력","양말","양배추","양주","양파","어둠","어려움","어른","어젯밤","어쨌든","어쩌다가","어쩐지","언니","언덕","언론","언어","얼굴","얼른","얼음","얼핏","엄마","업무","업종","업체","엉덩이","엉망","엉터리","엊그제","에너지","에어컨","엔진","여건","여고생","여관","여군","여권","여대생","여덟","여동생","여든","여론","여름","여섯","여성","여왕","여인","여전히","여직원","여학생","여행","역사","역시","역할","연결","연구","연극","연기","연락","연설","연세","연속","연습","연애","연예인","연인","연장","연주","연출","연필","연합","연휴","열기","열매","열쇠","열심히","열정","열차","열흘","염려","엽서","영국","영남","영상","영양","영역","영웅","영원히","영하","영향","영혼","영화","옆구리","옆방","옆집","예감","예금","예방","예산","예상","예선","예술","예습","예식장","예약","예전","예절","예정","예컨대","옛날","오늘","오락","오랫동안","오렌지","오로지","오른발","오븐","오십","오염","오월","오전","오직","오징어","오페라","오피스텔","오히려","옥상","옥수수","온갖","온라인","온몸","온종일","온통","올가을","올림픽","올해","옷차림","와이셔츠","와인","완성","완전","왕비","왕자","왜냐하면","왠지","외갓집","외국","외로움","외삼촌","외출","외침","외할머니","왼발","왼손","왼쪽","요금","요일","요즘","요청","용기","용서","용어","우산","우선","우승","우연히","우정","우체국","우편","운동","운명","운반","운전","운행","울산","울음","움직임","웃어른","웃음","워낙","원고","원래","원서","원숭이","원인","원장","원피스","월급","월드컵","월세","월요일","웨이터","위반","위법","위성","위원","위험","위협","윗사람","유난히","유럽","유명","유물","유산","유적","유치원","유학","유행","유형","육군","육상","육십","육체","은행","음력","음료","음반","음성","음식","음악","음주","의견","의논","의문","의복","의식","의심","의외로","의욕","의원","의학","이것","이곳","이념","이놈","이달","이대로","이동","이렇게","이력서","이론적","이름","이민","이발소","이별","이불","이빨","이상","이성","이슬","이야기","이용","이웃","이월","이윽고","이익","이전","이중","이튿날","이틀","이혼","인간","인격","인공","인구","인근","인기","인도","인류","인물","인생","인쇄","인연","인원","인재","인종","인천","인체","인터넷","인하","인형","일곱","일기","일단","일대","일등","일반","일본","일부","일상","일생","일손","일요일","일월","일정","일종","일주일","일찍","일체","일치","일행","일회용","임금","임무","입대","입력","입맛","입사","입술","입시","입원","입장","입학","자가용","자격","자극","자동","자랑","자부심","자식","자신","자연","자원","자율","자전거","자정","자존심","자판","작가","작년","작성","작업","작용","작은딸","작품","잔디","잔뜩","잔치","잘못","잠깐","잠수함","잠시","잠옷","잠자리","잡지","장관","장군","장기간","장래","장례","장르","장마","장면","장모","장미","장비","장사","장소","장식","장애인","장인","장점","장차","장학금","재능","재빨리","재산","재생","재작년","재정","재채기","재판","재학","재활용","저것","저고리","저곳","저녁","저런","저렇게","저번","저울","저절로","저축","적극","적당히","적성","적용","적응","전개","전공","전기","전달","전라도","전망","전문","전반","전부","전세","전시","전용","전자","전쟁","전주","전철","전체","전통","전혀","전후","절대","절망","절반","절약","절차","점검","점수","점심","점원","점점","점차","접근","접시","접촉","젓가락","정거장","정도","정류장","정리","정말","정면","정문","정반대","정보","정부","정비","정상","정성","정오","정원","정장","정지","정치","정확히","제공","제과점","제대로","제목","제발","제법","제삿날","제안","제일","제작","제주도","제출","제품","제한","조각","조건","조금","조깅","조명","조미료","조상","조선","조용히","조절","조정","조직","존댓말","존재","졸업","졸음","종교","종로","종류","종소리","종업원","종종","종합","좌석","죄인","주관적","주름","주말","주머니","주먹","주문","주민","주방","주변","주식","주인","주일","주장","주전자","주택","준비","줄거리","줄기","줄무늬","중간","중계방송","중국","중년","중단","중독","중반","중부","중세","중소기업","중순","중앙","중요","중학교","즉석","즉시","즐거움","증가","증거","증권","증상","증세","지각","지갑","지경","지극히","지금","지급","지능","지름길","지리산","지방","지붕","지식","지역","지우개","지원","지적","지점","지진","지출","직선","직업","직원","직장","진급","진동","진로","진료","진리","진짜","진찰","진출","진통","진행","질문","질병","질서","짐작","집단","집안","집중","짜증","찌꺼기","차남","차라리","차량","차림","차별","차선","차츰","착각","찬물","찬성","참가","참기름","참새","참석","참여","참외","참조","찻잔","창가","창고","창구","창문","창밖","창작","창조","채널","채점","책가방","책방","책상","책임","챔피언","처벌","처음","천국","천둥","천장","천재","천천히","철도","철저히","철학","첫날","첫째","청년","청바지","청소","청춘","체계","체력","체온","체육","체중","체험","초등학생","초반","초밥","초상화","초순","초여름","초원","초저녁","초점","초청","초콜릿","촛불","총각","총리","총장","촬영","최근","최상","최선","최신","최악","최종","추석","추억","추진","추천","추측","축구","축소","축제","축하","출근","출발","출산","출신","출연","출입","출장","출판","충격","충고","충돌","충분히","충청도","취업","취직","취향","치약","친구","친척","칠십","칠월","칠판","침대","침묵","침실","칫솔","칭찬","카메라","카운터","칼국수","캐릭터","캠퍼스","캠페인","커튼","컨디션","컬러","컴퓨터","코끼리","코미디","콘서트","콜라","콤플렉스","콩나물","쾌감","쿠데타","크림","큰길","큰딸","큰소리","큰아들","큰어머니","큰일","큰절","클래식","클럽","킬로","타입","타자기","탁구","탁자","탄생","태권도","태양","태풍","택시","탤런트","터널","터미널","테니스","테스트","테이블","텔레비전","토론","토마토","토요일","통계","통과","통로","통신","통역","통일","통장","통제","통증","통합","통화","퇴근","퇴원","퇴직금","튀김","트럭","특급","특별","특성","특수","특징","특히","튼튼히","티셔츠","파란색","파일","파출소","판결","판단","판매","판사","팔십","팔월","팝송","패션","팩스","팩시밀리","팬티","퍼센트","페인트","편견","편의","편지","편히","평가","평균","평생","평소","평양","평일","평화","포스터","포인트","포장","포함","표면","표정","표준","표현","품목","품질","풍경","풍속","풍습","프랑스","프린터","플라스틱","피곤","피망","피아노","필름","필수","필요","필자","필통","핑계","하느님","하늘","하드웨어","하룻밤","하반기","하숙집","하순","하여튼","하지만","하천","하품","하필","학과","학교","학급","학기","학년","학력","학번","학부모","학비","학생","학술","학습","학용품","학원","학위","학자","학점","한계","한글","한꺼번에","한낮","한눈","한동안","한때","한라산","한마디","한문","한번","한복","한식","한여름","한쪽","할머니","할아버지","할인","함께","함부로","합격","합리적","항공","항구","항상","항의","해결","해군","해답","해당","해물","해석","해설","해수욕장","해안","핵심","핸드백","햄버거","햇볕","햇살","행동","행복","행사","행운","행위","향기","향상","향수","허락","허용","헬기","현관","현금","현대","현상","현실","현장","현재","현지","혈액","협력","형부","형사","형수","형식","형제","형태","형편","혜택","호기심","호남","호랑이","호박","호텔","호흡","혹시","홀로","홈페이지","홍보","홍수","홍차","화면","화분","화살","화요일","화장","화학","확보","확인","확장","확정","환갑","환경","환영","환율","환자","활기","활동","활발히","활용","활짝","회견","회관","회복","회색","회원","회장","회전","횟수","횡단보도","효율적","후반","후춧가루","훈련","훨씬","휴식","휴일","흉내","흐름","흑백","흑인","흔적","흔히","흥미","흥분","희곡","희망","희생","흰색","힘껏"]');

});

parcelRequire.register("eFCbz", function(module, exports) {
module.exports = JSON.parse('["abaisser","abandon","abdiquer","abeille","abolir","aborder","aboutir","aboyer","abrasif","abreuver","abriter","abroger","abrupt","absence","absolu","absurde","abusif","abyssal","académie","acajou","acarien","accabler","accepter","acclamer","accolade","accroche","accuser","acerbe","achat","acheter","aciduler","acier","acompte","acquérir","acronyme","acteur","actif","actuel","adepte","adéquat","adhésif","adjectif","adjuger","admettre","admirer","adopter","adorer","adoucir","adresse","adroit","adulte","adverbe","aérer","aéronef","affaire","affecter","affiche","affreux","affubler","agacer","agencer","agile","agiter","agrafer","agréable","agrume","aider","aiguille","ailier","aimable","aisance","ajouter","ajuster","alarmer","alchimie","alerte","algèbre","algue","aliéner","aliment","alléger","alliage","allouer","allumer","alourdir","alpaga","altesse","alvéole","amateur","ambigu","ambre","aménager","amertume","amidon","amiral","amorcer","amour","amovible","amphibie","ampleur","amusant","analyse","anaphore","anarchie","anatomie","ancien","anéantir","angle","angoisse","anguleux","animal","annexer","annonce","annuel","anodin","anomalie","anonyme","anormal","antenne","antidote","anxieux","apaiser","apéritif","aplanir","apologie","appareil","appeler","apporter","appuyer","aquarium","aqueduc","arbitre","arbuste","ardeur","ardoise","argent","arlequin","armature","armement","armoire","armure","arpenter","arracher","arriver","arroser","arsenic","artériel","article","aspect","asphalte","aspirer","assaut","asservir","assiette","associer","assurer","asticot","astre","astuce","atelier","atome","atrium","atroce","attaque","attentif","attirer","attraper","aubaine","auberge","audace","audible","augurer","aurore","automne","autruche","avaler","avancer","avarice","avenir","averse","aveugle","aviateur","avide","avion","aviser","avoine","avouer","avril","axial","axiome","badge","bafouer","bagage","baguette","baignade","balancer","balcon","baleine","balisage","bambin","bancaire","bandage","banlieue","bannière","banquier","barbier","baril","baron","barque","barrage","bassin","bastion","bataille","bateau","batterie","baudrier","bavarder","belette","bélier","belote","bénéfice","berceau","berger","berline","bermuda","besace","besogne","bétail","beurre","biberon","bicycle","bidule","bijou","bilan","bilingue","billard","binaire","biologie","biopsie","biotype","biscuit","bison","bistouri","bitume","bizarre","blafard","blague","blanchir","blessant","blinder","blond","bloquer","blouson","bobard","bobine","boire","boiser","bolide","bonbon","bondir","bonheur","bonifier","bonus","bordure","borne","botte","boucle","boueux","bougie","boulon","bouquin","bourse","boussole","boutique","boxeur","branche","brasier","brave","brebis","brèche","breuvage","bricoler","brigade","brillant","brioche","brique","brochure","broder","bronzer","brousse","broyeur","brume","brusque","brutal","bruyant","buffle","buisson","bulletin","bureau","burin","bustier","butiner","butoir","buvable","buvette","cabanon","cabine","cachette","cadeau","cadre","caféine","caillou","caisson","calculer","calepin","calibre","calmer","calomnie","calvaire","camarade","caméra","camion","campagne","canal","caneton","canon","cantine","canular","capable","caporal","caprice","capsule","capter","capuche","carabine","carbone","caresser","caribou","carnage","carotte","carreau","carton","cascade","casier","casque","cassure","causer","caution","cavalier","caverne","caviar","cédille","ceinture","céleste","cellule","cendrier","censurer","central","cercle","cérébral","cerise","cerner","cerveau","cesser","chagrin","chaise","chaleur","chambre","chance","chapitre","charbon","chasseur","chaton","chausson","chavirer","chemise","chenille","chéquier","chercher","cheval","chien","chiffre","chignon","chimère","chiot","chlorure","chocolat","choisir","chose","chouette","chrome","chute","cigare","cigogne","cimenter","cinéma","cintrer","circuler","cirer","cirque","citerne","citoyen","citron","civil","clairon","clameur","claquer","classe","clavier","client","cligner","climat","clivage","cloche","clonage","cloporte","cobalt","cobra","cocasse","cocotier","coder","codifier","coffre","cogner","cohésion","coiffer","coincer","colère","colibri","colline","colmater","colonel","combat","comédie","commande","compact","concert","conduire","confier","congeler","connoter","consonne","contact","convexe","copain","copie","corail","corbeau","cordage","corniche","corpus","correct","cortège","cosmique","costume","coton","coude","coupure","courage","couteau","couvrir","coyote","crabe","crainte","cravate","crayon","créature","créditer","crémeux","creuser","crevette","cribler","crier","cristal","critère","croire","croquer","crotale","crucial","cruel","crypter","cubique","cueillir","cuillère","cuisine","cuivre","culminer","cultiver","cumuler","cupide","curatif","curseur","cyanure","cycle","cylindre","cynique","daigner","damier","danger","danseur","dauphin","débattre","débiter","déborder","débrider","débutant","décaler","décembre","déchirer","décider","déclarer","décorer","décrire","décupler","dédale","déductif","déesse","défensif","défiler","défrayer","dégager","dégivrer","déglutir","dégrafer","déjeuner","délice","déloger","demander","demeurer","démolir","dénicher","dénouer","dentelle","dénuder","départ","dépenser","déphaser","déplacer","déposer","déranger","dérober","désastre","descente","désert","désigner","désobéir","dessiner","destrier","détacher","détester","détourer","détresse","devancer","devenir","deviner","devoir","diable","dialogue","diamant","dicter","différer","digérer","digital","digne","diluer","dimanche","diminuer","dioxyde","directif","diriger","discuter","disposer","dissiper","distance","divertir","diviser","docile","docteur","dogme","doigt","domaine","domicile","dompter","donateur","donjon","donner","dopamine","dortoir","dorure","dosage","doseur","dossier","dotation","douanier","double","douceur","douter","doyen","dragon","draper","dresser","dribbler","droiture","duperie","duplexe","durable","durcir","dynastie","éblouir","écarter","écharpe","échelle","éclairer","éclipse","éclore","écluse","école","économie","écorce","écouter","écraser","écrémer","écrivain","écrou","écume","écureuil","édifier","éduquer","effacer","effectif","effigie","effort","effrayer","effusion","égaliser","égarer","éjecter","élaborer","élargir","électron","élégant","éléphant","élève","éligible","élitisme","éloge","élucider","éluder","emballer","embellir","embryon","émeraude","émission","emmener","émotion","émouvoir","empereur","employer","emporter","emprise","émulsion","encadrer","enchère","enclave","encoche","endiguer","endosser","endroit","enduire","énergie","enfance","enfermer","enfouir","engager","engin","englober","énigme","enjamber","enjeu","enlever","ennemi","ennuyeux","enrichir","enrobage","enseigne","entasser","entendre","entier","entourer","entraver","énumérer","envahir","enviable","envoyer","enzyme","éolien","épaissir","épargne","épatant","épaule","épicerie","épidémie","épier","épilogue","épine","épisode","épitaphe","époque","épreuve","éprouver","épuisant","équerre","équipe","ériger","érosion","erreur","éruption","escalier","espadon","espèce","espiègle","espoir","esprit","esquiver","essayer","essence","essieu","essorer","estime","estomac","estrade","étagère","étaler","étanche","étatique","éteindre","étendoir","éternel","éthanol","éthique","ethnie","étirer","étoffer","étoile","étonnant","étourdir","étrange","étroit","étude","euphorie","évaluer","évasion","éventail","évidence","éviter","évolutif","évoquer","exact","exagérer","exaucer","exceller","excitant","exclusif","excuse","exécuter","exemple","exercer","exhaler","exhorter","exigence","exiler","exister","exotique","expédier","explorer","exposer","exprimer","exquis","extensif","extraire","exulter","fable","fabuleux","facette","facile","facture","faiblir","falaise","fameux","famille","farceur","farfelu","farine","farouche","fasciner","fatal","fatigue","faucon","fautif","faveur","favori","fébrile","féconder","fédérer","félin","femme","fémur","fendoir","féodal","fermer","féroce","ferveur","festival","feuille","feutre","février","fiasco","ficeler","fictif","fidèle","figure","filature","filetage","filière","filleul","filmer","filou","filtrer","financer","finir","fiole","firme","fissure","fixer","flairer","flamme","flasque","flatteur","fléau","flèche","fleur","flexion","flocon","flore","fluctuer","fluide","fluvial","folie","fonderie","fongible","fontaine","forcer","forgeron","formuler","fortune","fossile","foudre","fougère","fouiller","foulure","fourmi","fragile","fraise","franchir","frapper","frayeur","frégate","freiner","frelon","frémir","frénésie","frère","friable","friction","frisson","frivole","froid","fromage","frontal","frotter","fruit","fugitif","fuite","fureur","furieux","furtif","fusion","futur","gagner","galaxie","galerie","gambader","garantir","gardien","garnir","garrigue","gazelle","gazon","géant","gélatine","gélule","gendarme","général","génie","genou","gentil","géologie","géomètre","géranium","germe","gestuel","geyser","gibier","gicler","girafe","givre","glace","glaive","glisser","globe","gloire","glorieux","golfeur","gomme","gonfler","gorge","gorille","goudron","gouffre","goulot","goupille","gourmand","goutte","graduel","graffiti","graine","grand","grappin","gratuit","gravir","grenat","griffure","griller","grimper","grogner","gronder","grotte","groupe","gruger","grutier","gruyère","guépard","guerrier","guide","guimauve","guitare","gustatif","gymnaste","gyrostat","habitude","hachoir","halte","hameau","hangar","hanneton","haricot","harmonie","harpon","hasard","hélium","hématome","herbe","hérisson","hermine","héron","hésiter","heureux","hiberner","hibou","hilarant","histoire","hiver","homard","hommage","homogène","honneur","honorer","honteux","horde","horizon","horloge","hormone","horrible","houleux","housse","hublot","huileux","humain","humble","humide","humour","hurler","hydromel","hygiène","hymne","hypnose","idylle","ignorer","iguane","illicite","illusion","image","imbiber","imiter","immense","immobile","immuable","impact","impérial","implorer","imposer","imprimer","imputer","incarner","incendie","incident","incliner","incolore","indexer","indice","inductif","inédit","ineptie","inexact","infini","infliger","informer","infusion","ingérer","inhaler","inhiber","injecter","injure","innocent","inoculer","inonder","inscrire","insecte","insigne","insolite","inspirer","instinct","insulter","intact","intense","intime","intrigue","intuitif","inutile","invasion","inventer","inviter","invoquer","ironique","irradier","irréel","irriter","isoler","ivoire","ivresse","jaguar","jaillir","jambe","janvier","jardin","jauger","jaune","javelot","jetable","jeton","jeudi","jeunesse","joindre","joncher","jongler","joueur","jouissif","journal","jovial","joyau","joyeux","jubiler","jugement","junior","jupon","juriste","justice","juteux","juvénile","kayak","kimono","kiosque","label","labial","labourer","lacérer","lactose","lagune","laine","laisser","laitier","lambeau","lamelle","lampe","lanceur","langage","lanterne","lapin","largeur","larme","laurier","lavabo","lavoir","lecture","légal","léger","légume","lessive","lettre","levier","lexique","lézard","liasse","libérer","libre","licence","licorne","liège","lièvre","ligature","ligoter","ligue","limer","limite","limonade","limpide","linéaire","lingot","lionceau","liquide","lisière","lister","lithium","litige","littoral","livreur","logique","lointain","loisir","lombric","loterie","louer","lourd","loutre","louve","loyal","lubie","lucide","lucratif","lueur","lugubre","luisant","lumière","lunaire","lundi","luron","lutter","luxueux","machine","magasin","magenta","magique","maigre","maillon","maintien","mairie","maison","majorer","malaxer","maléfice","malheur","malice","mallette","mammouth","mandater","maniable","manquant","manteau","manuel","marathon","marbre","marchand","mardi","maritime","marqueur","marron","marteler","mascotte","massif","matériel","matière","matraque","maudire","maussade","mauve","maximal","méchant","méconnu","médaille","médecin","méditer","méduse","meilleur","mélange","mélodie","membre","mémoire","menacer","mener","menhir","mensonge","mentor","mercredi","mérite","merle","messager","mesure","métal","météore","méthode","métier","meuble","miauler","microbe","miette","mignon","migrer","milieu","million","mimique","mince","minéral","minimal","minorer","minute","miracle","miroiter","missile","mixte","mobile","moderne","moelleux","mondial","moniteur","monnaie","monotone","monstre","montagne","monument","moqueur","morceau","morsure","mortier","moteur","motif","mouche","moufle","moulin","mousson","mouton","mouvant","multiple","munition","muraille","murène","murmure","muscle","muséum","musicien","mutation","muter","mutuel","myriade","myrtille","mystère","mythique","nageur","nappe","narquois","narrer","natation","nation","nature","naufrage","nautique","navire","nébuleux","nectar","néfaste","négation","négliger","négocier","neige","nerveux","nettoyer","neurone","neutron","neveu","niche","nickel","nitrate","niveau","noble","nocif","nocturne","noirceur","noisette","nomade","nombreux","nommer","normatif","notable","notifier","notoire","nourrir","nouveau","novateur","novembre","novice","nuage","nuancer","nuire","nuisible","numéro","nuptial","nuque","nutritif","obéir","objectif","obliger","obscur","observer","obstacle","obtenir","obturer","occasion","occuper","océan","octobre","octroyer","octupler","oculaire","odeur","odorant","offenser","officier","offrir","ogive","oiseau","oisillon","olfactif","olivier","ombrage","omettre","onctueux","onduler","onéreux","onirique","opale","opaque","opérer","opinion","opportun","opprimer","opter","optique","orageux","orange","orbite","ordonner","oreille","organe","orgueil","orifice","ornement","orque","ortie","osciller","osmose","ossature","otarie","ouragan","ourson","outil","outrager","ouvrage","ovation","oxyde","oxygène","ozone","paisible","palace","palmarès","palourde","palper","panache","panda","pangolin","paniquer","panneau","panorama","pantalon","papaye","papier","papoter","papyrus","paradoxe","parcelle","paresse","parfumer","parler","parole","parrain","parsemer","partager","parure","parvenir","passion","pastèque","paternel","patience","patron","pavillon","pavoiser","payer","paysage","peigne","peintre","pelage","pélican","pelle","pelouse","peluche","pendule","pénétrer","pénible","pensif","pénurie","pépite","péplum","perdrix","perforer","période","permuter","perplexe","persil","perte","peser","pétale","petit","pétrir","peuple","pharaon","phobie","phoque","photon","phrase","physique","piano","pictural","pièce","pierre","pieuvre","pilote","pinceau","pipette","piquer","pirogue","piscine","piston","pivoter","pixel","pizza","placard","plafond","plaisir","planer","plaque","plastron","plateau","pleurer","plexus","pliage","plomb","plonger","pluie","plumage","pochette","poésie","poète","pointe","poirier","poisson","poivre","polaire","policier","pollen","polygone","pommade","pompier","ponctuel","pondérer","poney","portique","position","posséder","posture","potager","poteau","potion","pouce","poulain","poumon","pourpre","poussin","pouvoir","prairie","pratique","précieux","prédire","préfixe","prélude","prénom","présence","prétexte","prévoir","primitif","prince","prison","priver","problème","procéder","prodige","profond","progrès","proie","projeter","prologue","promener","propre","prospère","protéger","prouesse","proverbe","prudence","pruneau","psychose","public","puceron","puiser","pulpe","pulsar","punaise","punitif","pupitre","purifier","puzzle","pyramide","quasar","querelle","question","quiétude","quitter","quotient","racine","raconter","radieux","ragondin","raideur","raisin","ralentir","rallonge","ramasser","rapide","rasage","ratisser","ravager","ravin","rayonner","réactif","réagir","réaliser","réanimer","recevoir","réciter","réclamer","récolter","recruter","reculer","recycler","rédiger","redouter","refaire","réflexe","réformer","refrain","refuge","régalien","région","réglage","régulier","réitérer","rejeter","rejouer","relatif","relever","relief","remarque","remède","remise","remonter","remplir","remuer","renard","renfort","renifler","renoncer","rentrer","renvoi","replier","reporter","reprise","reptile","requin","réserve","résineux","résoudre","respect","rester","résultat","rétablir","retenir","réticule","retomber","retracer","réunion","réussir","revanche","revivre","révolte","révulsif","richesse","rideau","rieur","rigide","rigoler","rincer","riposter","risible","risque","rituel","rival","rivière","rocheux","romance","rompre","ronce","rondin","roseau","rosier","rotatif","rotor","rotule","rouge","rouille","rouleau","routine","royaume","ruban","rubis","ruche","ruelle","rugueux","ruiner","ruisseau","ruser","rustique","rythme","sabler","saboter","sabre","sacoche","safari","sagesse","saisir","salade","salive","salon","saluer","samedi","sanction","sanglier","sarcasme","sardine","saturer","saugrenu","saumon","sauter","sauvage","savant","savonner","scalpel","scandale","scélérat","scénario","sceptre","schéma","science","scinder","score","scrutin","sculpter","séance","sécable","sécher","secouer","sécréter","sédatif","séduire","seigneur","séjour","sélectif","semaine","sembler","semence","séminal","sénateur","sensible","sentence","séparer","séquence","serein","sergent","sérieux","serrure","sérum","service","sésame","sévir","sevrage","sextuple","sidéral","siècle","siéger","siffler","sigle","signal","silence","silicium","simple","sincère","sinistre","siphon","sirop","sismique","situer","skier","social","socle","sodium","soigneux","soldat","soleil","solitude","soluble","sombre","sommeil","somnoler","sonde","songeur","sonnette","sonore","sorcier","sortir","sosie","sottise","soucieux","soudure","souffle","soulever","soupape","source","soutirer","souvenir","spacieux","spatial","spécial","sphère","spiral","stable","station","sternum","stimulus","stipuler","strict","studieux","stupeur","styliste","sublime","substrat","subtil","subvenir","succès","sucre","suffixe","suggérer","suiveur","sulfate","superbe","supplier","surface","suricate","surmener","surprise","sursaut","survie","suspect","syllabe","symbole","symétrie","synapse","syntaxe","système","tabac","tablier","tactile","tailler","talent","talisman","talonner","tambour","tamiser","tangible","tapis","taquiner","tarder","tarif","tartine","tasse","tatami","tatouage","taupe","taureau","taxer","témoin","temporel","tenaille","tendre","teneur","tenir","tension","terminer","terne","terrible","tétine","texte","thème","théorie","thérapie","thorax","tibia","tiède","timide","tirelire","tiroir","tissu","titane","titre","tituber","toboggan","tolérant","tomate","tonique","tonneau","toponyme","torche","tordre","tornade","torpille","torrent","torse","tortue","totem","toucher","tournage","tousser","toxine","traction","trafic","tragique","trahir","train","trancher","travail","trèfle","tremper","trésor","treuil","triage","tribunal","tricoter","trilogie","triomphe","tripler","triturer","trivial","trombone","tronc","tropical","troupeau","tuile","tulipe","tumulte","tunnel","turbine","tuteur","tutoyer","tuyau","tympan","typhon","typique","tyran","ubuesque","ultime","ultrason","unanime","unifier","union","unique","unitaire","univers","uranium","urbain","urticant","usage","usine","usuel","usure","utile","utopie","vacarme","vaccin","vagabond","vague","vaillant","vaincre","vaisseau","valable","valise","vallon","valve","vampire","vanille","vapeur","varier","vaseux","vassal","vaste","vecteur","vedette","végétal","véhicule","veinard","véloce","vendredi","vénérer","venger","venimeux","ventouse","verdure","vérin","vernir","verrou","verser","vertu","veston","vétéran","vétuste","vexant","vexer","viaduc","viande","victoire","vidange","vidéo","vignette","vigueur","vilain","village","vinaigre","violon","vipère","virement","virtuose","virus","visage","viseur","vision","visqueux","visuel","vital","vitesse","viticole","vitrine","vivace","vivipare","vocation","voguer","voile","voisin","voiture","volaille","volcan","voltiger","volume","vorace","vortex","voter","vouloir","voyage","voyelle","wagon","xénon","yacht","zèbre","zénith","zeste","zoologie"]');

});

parcelRequire.register("hrLhZ", function(module, exports) {
module.exports = JSON.parse('["abaco","abbaglio","abbinato","abete","abisso","abolire","abrasivo","abrogato","accadere","accenno","accusato","acetone","achille","acido","acqua","acre","acrilico","acrobata","acuto","adagio","addebito","addome","adeguato","aderire","adipe","adottare","adulare","affabile","affetto","affisso","affranto","aforisma","afoso","africano","agave","agente","agevole","aggancio","agire","agitare","agonismo","agricolo","agrumeto","aguzzo","alabarda","alato","albatro","alberato","albo","albume","alce","alcolico","alettone","alfa","algebra","aliante","alibi","alimento","allagato","allegro","allievo","allodola","allusivo","almeno","alogeno","alpaca","alpestre","altalena","alterno","alticcio","altrove","alunno","alveolo","alzare","amalgama","amanita","amarena","ambito","ambrato","ameba","america","ametista","amico","ammasso","ammenda","ammirare","ammonito","amore","ampio","ampliare","amuleto","anacardo","anagrafe","analista","anarchia","anatra","anca","ancella","ancora","andare","andrea","anello","angelo","angolare","angusto","anima","annegare","annidato","anno","annuncio","anonimo","anticipo","anzi","apatico","apertura","apode","apparire","appetito","appoggio","approdo","appunto","aprile","arabica","arachide","aragosta","araldica","arancio","aratura","arazzo","arbitro","archivio","ardito","arenile","argento","argine","arguto","aria","armonia","arnese","arredato","arringa","arrosto","arsenico","arso","artefice","arzillo","asciutto","ascolto","asepsi","asettico","asfalto","asino","asola","aspirato","aspro","assaggio","asse","assoluto","assurdo","asta","astenuto","astice","astratto","atavico","ateismo","atomico","atono","attesa","attivare","attorno","attrito","attuale","ausilio","austria","autista","autonomo","autunno","avanzato","avere","avvenire","avviso","avvolgere","azione","azoto","azzimo","azzurro","babele","baccano","bacino","baco","badessa","badilata","bagnato","baita","balcone","baldo","balena","ballata","balzano","bambino","bandire","baraonda","barbaro","barca","baritono","barlume","barocco","basilico","basso","batosta","battuto","baule","bava","bavosa","becco","beffa","belgio","belva","benda","benevole","benigno","benzina","bere","berlina","beta","bibita","bici","bidone","bifido","biga","bilancia","bimbo","binocolo","biologo","bipede","bipolare","birbante","birra","biscotto","bisesto","bisnonno","bisonte","bisturi","bizzarro","blando","blatta","bollito","bonifico","bordo","bosco","botanico","bottino","bozzolo","braccio","bradipo","brama","branca","bravura","bretella","brevetto","brezza","briglia","brillante","brindare","broccolo","brodo","bronzina","brullo","bruno","bubbone","buca","budino","buffone","buio","bulbo","buono","burlone","burrasca","bussola","busta","cadetto","caduco","calamaro","calcolo","calesse","calibro","calmo","caloria","cambusa","camerata","camicia","cammino","camola","campale","canapa","candela","cane","canino","canotto","cantina","capace","capello","capitolo","capogiro","cappero","capra","capsula","carapace","carcassa","cardo","carisma","carovana","carretto","cartolina","casaccio","cascata","caserma","caso","cassone","castello","casuale","catasta","catena","catrame","cauto","cavillo","cedibile","cedrata","cefalo","celebre","cellulare","cena","cenone","centesimo","ceramica","cercare","certo","cerume","cervello","cesoia","cespo","ceto","chela","chiaro","chicca","chiedere","chimera","china","chirurgo","chitarra","ciao","ciclismo","cifrare","cigno","cilindro","ciottolo","circa","cirrosi","citrico","cittadino","ciuffo","civetta","civile","classico","clinica","cloro","cocco","codardo","codice","coerente","cognome","collare","colmato","colore","colposo","coltivato","colza","coma","cometa","commando","comodo","computer","comune","conciso","condurre","conferma","congelare","coniuge","connesso","conoscere","consumo","continuo","convegno","coperto","copione","coppia","copricapo","corazza","cordata","coricato","cornice","corolla","corpo","corredo","corsia","cortese","cosmico","costante","cottura","covato","cratere","cravatta","creato","credere","cremoso","crescita","creta","criceto","crinale","crisi","critico","croce","cronaca","crostata","cruciale","crusca","cucire","cuculo","cugino","cullato","cupola","curatore","cursore","curvo","cuscino","custode","dado","daino","dalmata","damerino","daniela","dannoso","danzare","datato","davanti","davvero","debutto","decennio","deciso","declino","decollo","decreto","dedicato","definito","deforme","degno","delegare","delfino","delirio","delta","demenza","denotato","dentro","deposito","derapata","derivare","deroga","descritto","deserto","desiderio","desumere","detersivo","devoto","diametro","dicembre","diedro","difeso","diffuso","digerire","digitale","diluvio","dinamico","dinnanzi","dipinto","diploma","dipolo","diradare","dire","dirotto","dirupo","disagio","discreto","disfare","disgelo","disposto","distanza","disumano","dito","divano","divelto","dividere","divorato","doblone","docente","doganale","dogma","dolce","domato","domenica","dominare","dondolo","dono","dormire","dote","dottore","dovuto","dozzina","drago","druido","dubbio","dubitare","ducale","duna","duomo","duplice","duraturo","ebano","eccesso","ecco","eclissi","economia","edera","edicola","edile","editoria","educare","egemonia","egli","egoismo","egregio","elaborato","elargire","elegante","elencato","eletto","elevare","elfico","elica","elmo","elsa","eluso","emanato","emblema","emesso","emiro","emotivo","emozione","empirico","emulo","endemico","enduro","energia","enfasi","enoteca","entrare","enzima","epatite","epilogo","episodio","epocale","eppure","equatore","erario","erba","erboso","erede","eremita","erigere","ermetico","eroe","erosivo","errante","esagono","esame","esanime","esaudire","esca","esempio","esercito","esibito","esigente","esistere","esito","esofago","esortato","esoso","espanso","espresso","essenza","esso","esteso","estimare","estonia","estroso","esultare","etilico","etnico","etrusco","etto","euclideo","europa","evaso","evidenza","evitato","evoluto","evviva","fabbrica","faccenda","fachiro","falco","famiglia","fanale","fanfara","fango","fantasma","fare","farfalla","farinoso","farmaco","fascia","fastoso","fasullo","faticare","fato","favoloso","febbre","fecola","fede","fegato","felpa","feltro","femmina","fendere","fenomeno","fermento","ferro","fertile","fessura","festivo","fetta","feudo","fiaba","fiducia","fifa","figurato","filo","finanza","finestra","finire","fiore","fiscale","fisico","fiume","flacone","flamenco","flebo","flemma","florido","fluente","fluoro","fobico","focaccia","focoso","foderato","foglio","folata","folclore","folgore","fondente","fonetico","fonia","fontana","forbito","forchetta","foresta","formica","fornaio","foro","fortezza","forzare","fosfato","fosso","fracasso","frana","frassino","fratello","freccetta","frenata","fresco","frigo","frollino","fronde","frugale","frutta","fucilata","fucsia","fuggente","fulmine","fulvo","fumante","fumetto","fumoso","fune","funzione","fuoco","furbo","furgone","furore","fuso","futile","gabbiano","gaffe","galateo","gallina","galoppo","gambero","gamma","garanzia","garbo","garofano","garzone","gasdotto","gasolio","gastrico","gatto","gaudio","gazebo","gazzella","geco","gelatina","gelso","gemello","gemmato","gene","genitore","gennaio","genotipo","gergo","ghepardo","ghiaccio","ghisa","giallo","gilda","ginepro","giocare","gioiello","giorno","giove","girato","girone","gittata","giudizio","giurato","giusto","globulo","glutine","gnomo","gobba","golf","gomito","gommone","gonfio","gonna","governo","gracile","grado","grafico","grammo","grande","grattare","gravoso","grazia","greca","gregge","grifone","grigio","grinza","grotta","gruppo","guadagno","guaio","guanto","guardare","gufo","guidare","ibernato","icona","identico","idillio","idolo","idra","idrico","idrogeno","igiene","ignaro","ignorato","ilare","illeso","illogico","illudere","imballo","imbevuto","imbocco","imbuto","immane","immerso","immolato","impacco","impeto","impiego","importo","impronta","inalare","inarcare","inattivo","incanto","incendio","inchino","incisivo","incluso","incontro","incrocio","incubo","indagine","india","indole","inedito","infatti","infilare","inflitto","ingaggio","ingegno","inglese","ingordo","ingrosso","innesco","inodore","inoltrare","inondato","insano","insetto","insieme","insonnia","insulina","intasato","intero","intonaco","intuito","inumidire","invalido","invece","invito","iperbole","ipnotico","ipotesi","ippica","iride","irlanda","ironico","irrigato","irrorare","isolato","isotopo","isterico","istituto","istrice","italia","iterare","labbro","labirinto","lacca","lacerato","lacrima","lacuna","laddove","lago","lampo","lancetta","lanterna","lardoso","larga","laringe","lastra","latenza","latino","lattuga","lavagna","lavoro","legale","leggero","lembo","lentezza","lenza","leone","lepre","lesivo","lessato","lesto","letterale","leva","levigato","libero","lido","lievito","lilla","limatura","limitare","limpido","lineare","lingua","liquido","lira","lirica","lisca","lite","litigio","livrea","locanda","lode","logica","lombare","londra","longevo","loquace","lorenzo","loto","lotteria","luce","lucidato","lumaca","luminoso","lungo","lupo","luppolo","lusinga","lusso","lutto","macabro","macchina","macero","macinato","madama","magico","maglia","magnete","magro","maiolica","malafede","malgrado","malinteso","malsano","malto","malumore","mana","mancia","mandorla","mangiare","manifesto","mannaro","manovra","mansarda","mantide","manubrio","mappa","maratona","marcire","maretta","marmo","marsupio","maschera","massaia","mastino","materasso","matricola","mattone","maturo","mazurca","meandro","meccanico","mecenate","medesimo","meditare","mega","melassa","melis","melodia","meninge","meno","mensola","mercurio","merenda","merlo","meschino","mese","messere","mestolo","metallo","metodo","mettere","miagolare","mica","micelio","michele","microbo","midollo","miele","migliore","milano","milite","mimosa","minerale","mini","minore","mirino","mirtillo","miscela","missiva","misto","misurare","mitezza","mitigare","mitra","mittente","mnemonico","modello","modifica","modulo","mogano","mogio","mole","molosso","monastero","monco","mondina","monetario","monile","monotono","monsone","montato","monviso","mora","mordere","morsicato","mostro","motivato","motosega","motto","movenza","movimento","mozzo","mucca","mucosa","muffa","mughetto","mugnaio","mulatto","mulinello","multiplo","mummia","munto","muovere","murale","musa","muscolo","musica","mutevole","muto","nababbo","nafta","nanometro","narciso","narice","narrato","nascere","nastrare","naturale","nautica","naviglio","nebulosa","necrosi","negativo","negozio","nemmeno","neofita","neretto","nervo","nessuno","nettuno","neutrale","neve","nevrotico","nicchia","ninfa","nitido","nobile","nocivo","nodo","nome","nomina","nordico","normale","norvegese","nostrano","notare","notizia","notturno","novella","nucleo","nulla","numero","nuovo","nutrire","nuvola","nuziale","oasi","obbedire","obbligo","obelisco","oblio","obolo","obsoleto","occasione","occhio","occidente","occorrere","occultare","ocra","oculato","odierno","odorare","offerta","offrire","offuscato","oggetto","oggi","ognuno","olandese","olfatto","oliato","oliva","ologramma","oltre","omaggio","ombelico","ombra","omega","omissione","ondoso","onere","onice","onnivoro","onorevole","onta","operato","opinione","opposto","oracolo","orafo","ordine","orecchino","orefice","orfano","organico","origine","orizzonte","orma","ormeggio","ornativo","orologio","orrendo","orribile","ortensia","ortica","orzata","orzo","osare","oscurare","osmosi","ospedale","ospite","ossa","ossidare","ostacolo","oste","otite","otre","ottagono","ottimo","ottobre","ovale","ovest","ovino","oviparo","ovocito","ovunque","ovviare","ozio","pacchetto","pace","pacifico","padella","padrone","paese","paga","pagina","palazzina","palesare","pallido","palo","palude","pandoro","pannello","paolo","paonazzo","paprica","parabola","parcella","parere","pargolo","pari","parlato","parola","partire","parvenza","parziale","passivo","pasticca","patacca","patologia","pattume","pavone","peccato","pedalare","pedonale","peggio","peloso","penare","pendice","penisola","pennuto","penombra","pensare","pentola","pepe","pepita","perbene","percorso","perdonato","perforare","pergamena","periodo","permesso","perno","perplesso","persuaso","pertugio","pervaso","pesatore","pesista","peso","pestifero","petalo","pettine","petulante","pezzo","piacere","pianta","piattino","piccino","picozza","piega","pietra","piffero","pigiama","pigolio","pigro","pila","pilifero","pillola","pilota","pimpante","pineta","pinna","pinolo","pioggia","piombo","piramide","piretico","pirite","pirolisi","pitone","pizzico","placebo","planare","plasma","platano","plenario","pochezza","poderoso","podismo","poesia","poggiare","polenta","poligono","pollice","polmonite","polpetta","polso","poltrona","polvere","pomice","pomodoro","ponte","popoloso","porfido","poroso","porpora","porre","portata","posa","positivo","possesso","postulato","potassio","potere","pranzo","prassi","pratica","precluso","predica","prefisso","pregiato","prelievo","premere","prenotare","preparato","presenza","pretesto","prevalso","prima","principe","privato","problema","procura","produrre","profumo","progetto","prolunga","promessa","pronome","proposta","proroga","proteso","prova","prudente","prugna","prurito","psiche","pubblico","pudica","pugilato","pugno","pulce","pulito","pulsante","puntare","pupazzo","pupilla","puro","quadro","qualcosa","quasi","querela","quota","raccolto","raddoppio","radicale","radunato","raffica","ragazzo","ragione","ragno","ramarro","ramingo","ramo","randagio","rantolare","rapato","rapina","rappreso","rasatura","raschiato","rasente","rassegna","rastrello","rata","ravveduto","reale","recepire","recinto","recluta","recondito","recupero","reddito","redimere","regalato","registro","regola","regresso","relazione","remare","remoto","renna","replica","reprimere","reputare","resa","residente","responso","restauro","rete","retina","retorica","rettifica","revocato","riassunto","ribadire","ribelle","ribrezzo","ricarica","ricco","ricevere","riciclato","ricordo","ricreduto","ridicolo","ridurre","rifasare","riflesso","riforma","rifugio","rigare","rigettato","righello","rilassato","rilevato","rimanere","rimbalzo","rimedio","rimorchio","rinascita","rincaro","rinforzo","rinnovo","rinomato","rinsavito","rintocco","rinuncia","rinvenire","riparato","ripetuto","ripieno","riportare","ripresa","ripulire","risata","rischio","riserva","risibile","riso","rispetto","ristoro","risultato","risvolto","ritardo","ritegno","ritmico","ritrovo","riunione","riva","riverso","rivincita","rivolto","rizoma","roba","robotico","robusto","roccia","roco","rodaggio","rodere","roditore","rogito","rollio","romantico","rompere","ronzio","rosolare","rospo","rotante","rotondo","rotula","rovescio","rubizzo","rubrica","ruga","rullino","rumine","rumoroso","ruolo","rupe","russare","rustico","sabato","sabbiare","sabotato","sagoma","salasso","saldatura","salgemma","salivare","salmone","salone","saltare","saluto","salvo","sapere","sapido","saporito","saraceno","sarcasmo","sarto","sassoso","satellite","satira","satollo","saturno","savana","savio","saziato","sbadiglio","sbalzo","sbancato","sbarra","sbattere","sbavare","sbendare","sbirciare","sbloccato","sbocciato","sbrinare","sbruffone","sbuffare","scabroso","scadenza","scala","scambiare","scandalo","scapola","scarso","scatenare","scavato","scelto","scenico","scettro","scheda","schiena","sciarpa","scienza","scindere","scippo","sciroppo","scivolo","sclerare","scodella","scolpito","scomparto","sconforto","scoprire","scorta","scossone","scozzese","scriba","scrollare","scrutinio","scuderia","scultore","scuola","scuro","scusare","sdebitare","sdoganare","seccatura","secondo","sedano","seggiola","segnalato","segregato","seguito","selciato","selettivo","sella","selvaggio","semaforo","sembrare","seme","seminato","sempre","senso","sentire","sepolto","sequenza","serata","serbato","sereno","serio","serpente","serraglio","servire","sestina","setola","settimana","sfacelo","sfaldare","sfamato","sfarzoso","sfaticato","sfera","sfida","sfilato","sfinge","sfocato","sfoderare","sfogo","sfoltire","sforzato","sfratto","sfruttato","sfuggito","sfumare","sfuso","sgabello","sgarbato","sgonfiare","sgorbio","sgrassato","sguardo","sibilo","siccome","sierra","sigla","signore","silenzio","sillaba","simbolo","simpatico","simulato","sinfonia","singolo","sinistro","sino","sintesi","sinusoide","sipario","sisma","sistole","situato","slitta","slogatura","sloveno","smarrito","smemorato","smentito","smeraldo","smilzo","smontare","smottato","smussato","snellire","snervato","snodo","sobbalzo","sobrio","soccorso","sociale","sodale","soffitto","sogno","soldato","solenne","solido","sollazzo","solo","solubile","solvente","somatico","somma","sonda","sonetto","sonnifero","sopire","soppeso","sopra","sorgere","sorpasso","sorriso","sorso","sorteggio","sorvolato","sospiro","sosta","sottile","spada","spalla","spargere","spatola","spavento","spazzola","specie","spedire","spegnere","spelatura","speranza","spessore","spettrale","spezzato","spia","spigoloso","spillato","spinoso","spirale","splendido","sportivo","sposo","spranga","sprecare","spronato","spruzzo","spuntino","squillo","sradicare","srotolato","stabile","stacco","staffa","stagnare","stampato","stantio","starnuto","stasera","statuto","stelo","steppa","sterzo","stiletto","stima","stirpe","stivale","stizzoso","stonato","storico","strappo","stregato","stridulo","strozzare","strutto","stuccare","stufo","stupendo","subentro","succoso","sudore","suggerito","sugo","sultano","suonare","superbo","supporto","surgelato","surrogato","sussurro","sutura","svagare","svedese","sveglio","svelare","svenuto","svezia","sviluppo","svista","svizzera","svolta","svuotare","tabacco","tabulato","tacciare","taciturno","tale","talismano","tampone","tannino","tara","tardivo","targato","tariffa","tarpare","tartaruga","tasto","tattico","taverna","tavolata","tazza","teca","tecnico","telefono","temerario","tempo","temuto","tendone","tenero","tensione","tentacolo","teorema","terme","terrazzo","terzetto","tesi","tesserato","testato","tetro","tettoia","tifare","tigella","timbro","tinto","tipico","tipografo","tiraggio","tiro","titanio","titolo","titubante","tizio","tizzone","toccare","tollerare","tolto","tombola","tomo","tonfo","tonsilla","topazio","topologia","toppa","torba","tornare","torrone","tortora","toscano","tossire","tostatura","totano","trabocco","trachea","trafila","tragedia","tralcio","tramonto","transito","trapano","trarre","trasloco","trattato","trave","treccia","tremolio","trespolo","tributo","tricheco","trifoglio","trillo","trincea","trio","tristezza","triturato","trivella","tromba","trono","troppo","trottola","trovare","truccato","tubatura","tuffato","tulipano","tumulto","tunisia","turbare","turchino","tuta","tutela","ubicato","uccello","uccisore","udire","uditivo","uffa","ufficio","uguale","ulisse","ultimato","umano","umile","umorismo","uncinetto","ungere","ungherese","unicorno","unificato","unisono","unitario","unte","uovo","upupa","uragano","urgenza","urlo","usanza","usato","uscito","usignolo","usuraio","utensile","utilizzo","utopia","vacante","vaccinato","vagabondo","vagliato","valanga","valgo","valico","valletta","valoroso","valutare","valvola","vampata","vangare","vanitoso","vano","vantaggio","vanvera","vapore","varano","varcato","variante","vasca","vedetta","vedova","veduto","vegetale","veicolo","velcro","velina","velluto","veloce","venato","vendemmia","vento","verace","verbale","vergogna","verifica","vero","verruca","verticale","vescica","vessillo","vestale","veterano","vetrina","vetusto","viandante","vibrante","vicenda","vichingo","vicinanza","vidimare","vigilia","vigneto","vigore","vile","villano","vimini","vincitore","viola","vipera","virgola","virologo","virulento","viscoso","visione","vispo","vissuto","visura","vita","vitello","vittima","vivanda","vivido","viziare","voce","voga","volatile","volere","volpe","voragine","vulcano","zampogna","zanna","zappato","zattera","zavorra","zefiro","zelante","zelo","zenzero","zerbino","zibetto","zinco","zircone","zitto","zolla","zotico","zucchero","zufolo","zulu","zuppa"]');

});

parcelRequire.register("911oV", function(module, exports) {
module.exports = JSON.parse('["ábaco","abdomen","abeja","abierto","abogado","abono","aborto","abrazo","abrir","abuelo","abuso","acabar","academia","acceso","acción","aceite","acelga","acento","aceptar","ácido","aclarar","acné","acoger","acoso","activo","acto","actriz","actuar","acudir","acuerdo","acusar","adicto","admitir","adoptar","adorno","aduana","adulto","aéreo","afectar","afición","afinar","afirmar","ágil","agitar","agonía","agosto","agotar","agregar","agrio","agua","agudo","águila","aguja","ahogo","ahorro","aire","aislar","ajedrez","ajeno","ajuste","alacrán","alambre","alarma","alba","álbum","alcalde","aldea","alegre","alejar","alerta","aleta","alfiler","alga","algodón","aliado","aliento","alivio","alma","almeja","almíbar","altar","alteza","altivo","alto","altura","alumno","alzar","amable","amante","amapola","amargo","amasar","ámbar","ámbito","ameno","amigo","amistad","amor","amparo","amplio","ancho","anciano","ancla","andar","andén","anemia","ángulo","anillo","ánimo","anís","anotar","antena","antiguo","antojo","anual","anular","anuncio","añadir","añejo","año","apagar","aparato","apetito","apio","aplicar","apodo","aporte","apoyo","aprender","aprobar","apuesta","apuro","arado","araña","arar","árbitro","árbol","arbusto","archivo","arco","arder","ardilla","arduo","área","árido","aries","armonía","arnés","aroma","arpa","arpón","arreglo","arroz","arruga","arte","artista","asa","asado","asalto","ascenso","asegurar","aseo","asesor","asiento","asilo","asistir","asno","asombro","áspero","astilla","astro","astuto","asumir","asunto","atajo","ataque","atar","atento","ateo","ático","atleta","átomo","atraer","atroz","atún","audaz","audio","auge","aula","aumento","ausente","autor","aval","avance","avaro","ave","avellana","avena","avestruz","avión","aviso","ayer","ayuda","ayuno","azafrán","azar","azote","azúcar","azufre","azul","baba","babor","bache","bahía","baile","bajar","balanza","balcón","balde","bambú","banco","banda","baño","barba","barco","barniz","barro","báscula","bastón","basura","batalla","batería","batir","batuta","baúl","bazar","bebé","bebida","bello","besar","beso","bestia","bicho","bien","bingo","blanco","bloque","blusa","boa","bobina","bobo","boca","bocina","boda","bodega","boina","bola","bolero","bolsa","bomba","bondad","bonito","bono","bonsái","borde","borrar","bosque","bote","botín","bóveda","bozal","bravo","brazo","brecha","breve","brillo","brinco","brisa","broca","broma","bronce","brote","bruja","brusco","bruto","buceo","bucle","bueno","buey","bufanda","bufón","búho","buitre","bulto","burbuja","burla","burro","buscar","butaca","buzón","caballo","cabeza","cabina","cabra","cacao","cadáver","cadena","caer","café","caída","caimán","caja","cajón","cal","calamar","calcio","caldo","calidad","calle","calma","calor","calvo","cama","cambio","camello","camino","campo","cáncer","candil","canela","canguro","canica","canto","caña","cañón","caoba","caos","capaz","capitán","capote","captar","capucha","cara","carbón","cárcel","careta","carga","cariño","carne","carpeta","carro","carta","casa","casco","casero","caspa","castor","catorce","catre","caudal","causa","cazo","cebolla","ceder","cedro","celda","célebre","celoso","célula","cemento","ceniza","centro","cerca","cerdo","cereza","cero","cerrar","certeza","césped","cetro","chacal","chaleco","champú","chancla","chapa","charla","chico","chiste","chivo","choque","choza","chuleta","chupar","ciclón","ciego","cielo","cien","cierto","cifra","cigarro","cima","cinco","cine","cinta","ciprés","circo","ciruela","cisne","cita","ciudad","clamor","clan","claro","clase","clave","cliente","clima","clínica","cobre","cocción","cochino","cocina","coco","código","codo","cofre","coger","cohete","cojín","cojo","cola","colcha","colegio","colgar","colina","collar","colmo","columna","combate","comer","comida","cómodo","compra","conde","conejo","conga","conocer","consejo","contar","copa","copia","corazón","corbata","corcho","cordón","corona","correr","coser","cosmos","costa","cráneo","cráter","crear","crecer","creído","crema","cría","crimen","cripta","crisis","cromo","crónica","croqueta","crudo","cruz","cuadro","cuarto","cuatro","cubo","cubrir","cuchara","cuello","cuento","cuerda","cuesta","cueva","cuidar","culebra","culpa","culto","cumbre","cumplir","cuna","cuneta","cuota","cupón","cúpula","curar","curioso","curso","curva","cutis","dama","danza","dar","dardo","dátil","deber","débil","década","decir","dedo","defensa","definir","dejar","delfín","delgado","delito","demora","denso","dental","deporte","derecho","derrota","desayuno","deseo","desfile","desnudo","destino","desvío","detalle","detener","deuda","día","diablo","diadema","diamante","diana","diario","dibujo","dictar","diente","dieta","diez","difícil","digno","dilema","diluir","dinero","directo","dirigir","disco","diseño","disfraz","diva","divino","doble","doce","dolor","domingo","don","donar","dorado","dormir","dorso","dos","dosis","dragón","droga","ducha","duda","duelo","dueño","dulce","dúo","duque","durar","dureza","duro","ébano","ebrio","echar","eco","ecuador","edad","edición","edificio","editor","educar","efecto","eficaz","eje","ejemplo","elefante","elegir","elemento","elevar","elipse","élite","elixir","elogio","eludir","embudo","emitir","emoción","empate","empeño","empleo","empresa","enano","encargo","enchufe","encía","enemigo","enero","enfado","enfermo","engaño","enigma","enlace","enorme","enredo","ensayo","enseñar","entero","entrar","envase","envío","época","equipo","erizo","escala","escena","escolar","escribir","escudo","esencia","esfera","esfuerzo","espada","espejo","espía","esposa","espuma","esquí","estar","este","estilo","estufa","etapa","eterno","ética","etnia","evadir","evaluar","evento","evitar","exacto","examen","exceso","excusa","exento","exigir","exilio","existir","éxito","experto","explicar","exponer","extremo","fábrica","fábula","fachada","fácil","factor","faena","faja","falda","fallo","falso","faltar","fama","familia","famoso","faraón","farmacia","farol","farsa","fase","fatiga","fauna","favor","fax","febrero","fecha","feliz","feo","feria","feroz","fértil","fervor","festín","fiable","fianza","fiar","fibra","ficción","ficha","fideo","fiebre","fiel","fiera","fiesta","figura","fijar","fijo","fila","filete","filial","filtro","fin","finca","fingir","finito","firma","flaco","flauta","flecha","flor","flota","fluir","flujo","flúor","fobia","foca","fogata","fogón","folio","folleto","fondo","forma","forro","fortuna","forzar","fosa","foto","fracaso","frágil","franja","frase","fraude","freír","freno","fresa","frío","frito","fruta","fuego","fuente","fuerza","fuga","fumar","función","funda","furgón","furia","fusil","fútbol","futuro","gacela","gafas","gaita","gajo","gala","galería","gallo","gamba","ganar","gancho","ganga","ganso","garaje","garza","gasolina","gastar","gato","gavilán","gemelo","gemir","gen","género","genio","gente","geranio","gerente","germen","gesto","gigante","gimnasio","girar","giro","glaciar","globo","gloria","gol","golfo","goloso","golpe","goma","gordo","gorila","gorra","gota","goteo","gozar","grada","gráfico","grano","grasa","gratis","grave","grieta","grillo","gripe","gris","grito","grosor","grúa","grueso","grumo","grupo","guante","guapo","guardia","guerra","guía","guiño","guion","guiso","guitarra","gusano","gustar","haber","hábil","hablar","hacer","hacha","hada","hallar","hamaca","harina","haz","hazaña","hebilla","hebra","hecho","helado","helio","hembra","herir","hermano","héroe","hervir","hielo","hierro","hígado","higiene","hijo","himno","historia","hocico","hogar","hoguera","hoja","hombre","hongo","honor","honra","hora","hormiga","horno","hostil","hoyo","hueco","huelga","huerta","hueso","huevo","huida","huir","humano","húmedo","humilde","humo","hundir","huracán","hurto","icono","ideal","idioma","ídolo","iglesia","iglú","igual","ilegal","ilusión","imagen","imán","imitar","impar","imperio","imponer","impulso","incapaz","índice","inerte","infiel","informe","ingenio","inicio","inmenso","inmune","innato","insecto","instante","interés","íntimo","intuir","inútil","invierno","ira","iris","ironía","isla","islote","jabalí","jabón","jamón","jarabe","jardín","jarra","jaula","jazmín","jefe","jeringa","jinete","jornada","joroba","joven","joya","juerga","jueves","juez","jugador","jugo","juguete","juicio","junco","jungla","junio","juntar","júpiter","jurar","justo","juvenil","juzgar","kilo","koala","labio","lacio","lacra","lado","ladrón","lagarto","lágrima","laguna","laico","lamer","lámina","lámpara","lana","lancha","langosta","lanza","lápiz","largo","larva","lástima","lata","látex","latir","laurel","lavar","lazo","leal","lección","leche","lector","leer","legión","legumbre","lejano","lengua","lento","leña","león","leopardo","lesión","letal","letra","leve","leyenda","libertad","libro","licor","líder","lidiar","lienzo","liga","ligero","lima","límite","limón","limpio","lince","lindo","línea","lingote","lino","linterna","líquido","liso","lista","litera","litio","litro","llaga","llama","llanto","llave","llegar","llenar","llevar","llorar","llover","lluvia","lobo","loción","loco","locura","lógica","logro","lombriz","lomo","lonja","lote","lucha","lucir","lugar","lujo","luna","lunes","lupa","lustro","luto","luz","maceta","macho","madera","madre","maduro","maestro","mafia","magia","mago","maíz","maldad","maleta","malla","malo","mamá","mambo","mamut","manco","mando","manejar","manga","maniquí","manjar","mano","manso","manta","mañana","mapa","máquina","mar","marco","marea","marfil","margen","marido","mármol","marrón","martes","marzo","masa","máscara","masivo","matar","materia","matiz","matriz","máximo","mayor","mazorca","mecha","medalla","medio","médula","mejilla","mejor","melena","melón","memoria","menor","mensaje","mente","menú","mercado","merengue","mérito","mes","mesón","meta","meter","método","metro","mezcla","miedo","miel","miembro","miga","mil","milagro","militar","millón","mimo","mina","minero","mínimo","minuto","miope","mirar","misa","miseria","misil","mismo","mitad","mito","mochila","moción","moda","modelo","moho","mojar","molde","moler","molino","momento","momia","monarca","moneda","monja","monto","moño","morada","morder","moreno","morir","morro","morsa","mortal","mosca","mostrar","motivo","mover","móvil","mozo","mucho","mudar","mueble","muela","muerte","muestra","mugre","mujer","mula","muleta","multa","mundo","muñeca","mural","muro","músculo","museo","musgo","música","muslo","nácar","nación","nadar","naipe","naranja","nariz","narrar","nasal","natal","nativo","natural","náusea","naval","nave","navidad","necio","néctar","negar","negocio","negro","neón","nervio","neto","neutro","nevar","nevera","nicho","nido","niebla","nieto","niñez","niño","nítido","nivel","nobleza","noche","nómina","noria","norma","norte","nota","noticia","novato","novela","novio","nube","nuca","núcleo","nudillo","nudo","nuera","nueve","nuez","nulo","número","nutria","oasis","obeso","obispo","objeto","obra","obrero","observar","obtener","obvio","oca","ocaso","océano","ochenta","ocho","ocio","ocre","octavo","octubre","oculto","ocupar","ocurrir","odiar","odio","odisea","oeste","ofensa","oferta","oficio","ofrecer","ogro","oído","oír","ojo","ola","oleada","olfato","olivo","olla","olmo","olor","olvido","ombligo","onda","onza","opaco","opción","ópera","opinar","oponer","optar","óptica","opuesto","oración","orador","oral","órbita","orca","orden","oreja","órgano","orgía","orgullo","oriente","origen","orilla","oro","orquesta","oruga","osadía","oscuro","osezno","oso","ostra","otoño","otro","oveja","óvulo","óxido","oxígeno","oyente","ozono","pacto","padre","paella","página","pago","país","pájaro","palabra","palco","paleta","pálido","palma","paloma","palpar","pan","panal","pánico","pantera","pañuelo","papá","papel","papilla","paquete","parar","parcela","pared","parir","paro","párpado","parque","párrafo","parte","pasar","paseo","pasión","paso","pasta","pata","patio","patria","pausa","pauta","pavo","payaso","peatón","pecado","pecera","pecho","pedal","pedir","pegar","peine","pelar","peldaño","pelea","peligro","pellejo","pelo","peluca","pena","pensar","peñón","peón","peor","pepino","pequeño","pera","percha","perder","pereza","perfil","perico","perla","permiso","perro","persona","pesa","pesca","pésimo","pestaña","pétalo","petróleo","pez","pezuña","picar","pichón","pie","piedra","pierna","pieza","pijama","pilar","piloto","pimienta","pino","pintor","pinza","piña","piojo","pipa","pirata","pisar","piscina","piso","pista","pitón","pizca","placa","plan","plata","playa","plaza","pleito","pleno","plomo","pluma","plural","pobre","poco","poder","podio","poema","poesía","poeta","polen","policía","pollo","polvo","pomada","pomelo","pomo","pompa","poner","porción","portal","posada","poseer","posible","poste","potencia","potro","pozo","prado","precoz","pregunta","premio","prensa","preso","previo","primo","príncipe","prisión","privar","proa","probar","proceso","producto","proeza","profesor","programa","prole","promesa","pronto","propio","próximo","prueba","público","puchero","pudor","pueblo","puerta","puesto","pulga","pulir","pulmón","pulpo","pulso","puma","punto","puñal","puño","pupa","pupila","puré","quedar","queja","quemar","querer","queso","quieto","química","quince","quitar","rábano","rabia","rabo","ración","radical","raíz","rama","rampa","rancho","rango","rapaz","rápido","rapto","rasgo","raspa","rato","rayo","raza","razón","reacción","realidad","rebaño","rebote","recaer","receta","rechazo","recoger","recreo","recto","recurso","red","redondo","reducir","reflejo","reforma","refrán","refugio","regalo","regir","regla","regreso","rehén","reino","reír","reja","relato","relevo","relieve","relleno","reloj","remar","remedio","remo","rencor","rendir","renta","reparto","repetir","reposo","reptil","res","rescate","resina","respeto","resto","resumen","retiro","retorno","retrato","reunir","revés","revista","rey","rezar","rico","riego","rienda","riesgo","rifa","rígido","rigor","rincón","riñón","río","riqueza","risa","ritmo","rito","rizo","roble","roce","rociar","rodar","rodeo","rodilla","roer","rojizo","rojo","romero","romper","ron","ronco","ronda","ropa","ropero","rosa","rosca","rostro","rotar","rubí","rubor","rudo","rueda","rugir","ruido","ruina","ruleta","rulo","rumbo","rumor","ruptura","ruta","rutina","sábado","saber","sabio","sable","sacar","sagaz","sagrado","sala","saldo","salero","salir","salmón","salón","salsa","salto","salud","salvar","samba","sanción","sandía","sanear","sangre","sanidad","sano","santo","sapo","saque","sardina","sartén","sastre","satán","sauna","saxofón","sección","seco","secreto","secta","sed","seguir","seis","sello","selva","semana","semilla","senda","sensor","señal","señor","separar","sepia","sequía","ser","serie","sermón","servir","sesenta","sesión","seta","setenta","severo","sexo","sexto","sidra","siesta","siete","siglo","signo","sílaba","silbar","silencio","silla","símbolo","simio","sirena","sistema","sitio","situar","sobre","socio","sodio","sol","solapa","soldado","soledad","sólido","soltar","solución","sombra","sondeo","sonido","sonoro","sonrisa","sopa","soplar","soporte","sordo","sorpresa","sorteo","sostén","sótano","suave","subir","suceso","sudor","suegra","suelo","sueño","suerte","sufrir","sujeto","sultán","sumar","superar","suplir","suponer","supremo","sur","surco","sureño","surgir","susto","sutil","tabaco","tabique","tabla","tabú","taco","tacto","tajo","talar","talco","talento","talla","talón","tamaño","tambor","tango","tanque","tapa","tapete","tapia","tapón","taquilla","tarde","tarea","tarifa","tarjeta","tarot","tarro","tarta","tatuaje","tauro","taza","tazón","teatro","techo","tecla","técnica","tejado","tejer","tejido","tela","teléfono","tema","temor","templo","tenaz","tender","tener","tenis","tenso","teoría","terapia","terco","término","ternura","terror","tesis","tesoro","testigo","tetera","texto","tez","tibio","tiburón","tiempo","tienda","tierra","tieso","tigre","tijera","tilde","timbre","tímido","timo","tinta","tío","típico","tipo","tira","tirón","titán","títere","título","tiza","toalla","tobillo","tocar","tocino","todo","toga","toldo","tomar","tono","tonto","topar","tope","toque","tórax","torero","tormenta","torneo","toro","torpedo","torre","torso","tortuga","tos","tosco","toser","tóxico","trabajo","tractor","traer","tráfico","trago","traje","tramo","trance","trato","trauma","trazar","trébol","tregua","treinta","tren","trepar","tres","tribu","trigo","tripa","triste","triunfo","trofeo","trompa","tronco","tropa","trote","trozo","truco","trueno","trufa","tubería","tubo","tuerto","tumba","tumor","túnel","túnica","turbina","turismo","turno","tutor","ubicar","úlcera","umbral","unidad","unir","universo","uno","untar","uña","urbano","urbe","urgente","urna","usar","usuario","útil","utopía","uva","vaca","vacío","vacuna","vagar","vago","vaina","vajilla","vale","válido","valle","valor","válvula","vampiro","vara","variar","varón","vaso","vecino","vector","vehículo","veinte","vejez","vela","velero","veloz","vena","vencer","venda","veneno","vengar","venir","venta","venus","ver","verano","verbo","verde","vereda","verja","verso","verter","vía","viaje","vibrar","vicio","víctima","vida","vídeo","vidrio","viejo","viernes","vigor","vil","villa","vinagre","vino","viñedo","violín","viral","virgo","virtud","visor","víspera","vista","vitamina","viudo","vivaz","vivero","vivir","vivo","volcán","volumen","volver","voraz","votar","voto","voz","vuelo","vulgar","yacer","yate","yegua","yema","yerno","yeso","yodo","yoga","yogur","zafiro","zanja","zapato","zarza","zona","zorro","zumo","zurdo"]');

});

parcelRequire.register("lW32h", function(module, exports) {
module.exports = JSON.parse('["あいこくしん","あいさつ","あいだ","あおぞら","あかちゃん","あきる","あけがた","あける","あこがれる","あさい","あさひ","あしあと","あじわう","あずかる","あずき","あそぶ","あたえる","あたためる","あたりまえ","あたる","あつい","あつかう","あっしゅく","あつまり","あつめる","あてな","あてはまる","あひる","あぶら","あぶる","あふれる","あまい","あまど","あまやかす","あまり","あみもの","あめりか","あやまる","あゆむ","あらいぐま","あらし","あらすじ","あらためる","あらゆる","あらわす","ありがとう","あわせる","あわてる","あんい","あんがい","あんこ","あんぜん","あんてい","あんない","あんまり","いいだす","いおん","いがい","いがく","いきおい","いきなり","いきもの","いきる","いくじ","いくぶん","いけばな","いけん","いこう","いこく","いこつ","いさましい","いさん","いしき","いじゅう","いじょう","いじわる","いずみ","いずれ","いせい","いせえび","いせかい","いせき","いぜん","いそうろう","いそがしい","いだい","いだく","いたずら","いたみ","いたりあ","いちおう","いちじ","いちど","いちば","いちぶ","いちりゅう","いつか","いっしゅん","いっせい","いっそう","いったん","いっち","いってい","いっぽう","いてざ","いてん","いどう","いとこ","いない","いなか","いねむり","いのち","いのる","いはつ","いばる","いはん","いびき","いひん","いふく","いへん","いほう","いみん","いもうと","いもたれ","いもり","いやがる","いやす","いよかん","いよく","いらい","いらすと","いりぐち","いりょう","いれい","いれもの","いれる","いろえんぴつ","いわい","いわう","いわかん","いわば","いわゆる","いんげんまめ","いんさつ","いんしょう","いんよう","うえき","うえる","うおざ","うがい","うかぶ","うかべる","うきわ","うくらいな","うくれれ","うけたまわる","うけつけ","うけとる","うけもつ","うける","うごかす","うごく","うこん","うさぎ","うしなう","うしろがみ","うすい","うすぎ","うすぐらい","うすめる","うせつ","うちあわせ","うちがわ","うちき","うちゅう","うっかり","うつくしい","うったえる","うつる","うどん","うなぎ","うなじ","うなずく","うなる","うねる","うのう","うぶげ","うぶごえ","うまれる","うめる","うもう","うやまう","うよく","うらがえす","うらぐち","うらない","うりあげ","うりきれ","うるさい","うれしい","うれゆき","うれる","うろこ","うわき","うわさ","うんこう","うんちん","うんてん","うんどう","えいえん","えいが","えいきょう","えいご","えいせい","えいぶん","えいよう","えいわ","えおり","えがお","えがく","えきたい","えくせる","えしゃく","えすて","えつらん","えのぐ","えほうまき","えほん","えまき","えもじ","えもの","えらい","えらぶ","えりあ","えんえん","えんかい","えんぎ","えんげき","えんしゅう","えんぜつ","えんそく","えんちょう","えんとつ","おいかける","おいこす","おいしい","おいつく","おうえん","おうさま","おうじ","おうせつ","おうたい","おうふく","おうべい","おうよう","おえる","おおい","おおう","おおどおり","おおや","おおよそ","おかえり","おかず","おがむ","おかわり","おぎなう","おきる","おくさま","おくじょう","おくりがな","おくる","おくれる","おこす","おこなう","おこる","おさえる","おさない","おさめる","おしいれ","おしえる","おじぎ","おじさん","おしゃれ","おそらく","おそわる","おたがい","おたく","おだやか","おちつく","おっと","おつり","おでかけ","おとしもの","おとなしい","おどり","おどろかす","おばさん","おまいり","おめでとう","おもいで","おもう","おもたい","おもちゃ","おやつ","おやゆび","およぼす","おらんだ","おろす","おんがく","おんけい","おんしゃ","おんせん","おんだん","おんちゅう","おんどけい","かあつ","かいが","がいき","がいけん","がいこう","かいさつ","かいしゃ","かいすいよく","かいぜん","かいぞうど","かいつう","かいてん","かいとう","かいふく","がいへき","かいほう","かいよう","がいらい","かいわ","かえる","かおり","かかえる","かがく","かがし","かがみ","かくご","かくとく","かざる","がぞう","かたい","かたち","がちょう","がっきゅう","がっこう","がっさん","がっしょう","かなざわし","かのう","がはく","かぶか","かほう","かほご","かまう","かまぼこ","かめれおん","かゆい","かようび","からい","かるい","かろう","かわく","かわら","がんか","かんけい","かんこう","かんしゃ","かんそう","かんたん","かんち","がんばる","きあい","きあつ","きいろ","ぎいん","きうい","きうん","きえる","きおう","きおく","きおち","きおん","きかい","きかく","きかんしゃ","ききて","きくばり","きくらげ","きけんせい","きこう","きこえる","きこく","きさい","きさく","きさま","きさらぎ","ぎじかがく","ぎしき","ぎじたいけん","ぎじにってい","ぎじゅつしゃ","きすう","きせい","きせき","きせつ","きそう","きぞく","きぞん","きたえる","きちょう","きつえん","ぎっちり","きつつき","きつね","きてい","きどう","きどく","きない","きなが","きなこ","きぬごし","きねん","きのう","きのした","きはく","きびしい","きひん","きふく","きぶん","きぼう","きほん","きまる","きみつ","きむずかしい","きめる","きもだめし","きもち","きもの","きゃく","きやく","ぎゅうにく","きよう","きょうりゅう","きらい","きらく","きりん","きれい","きれつ","きろく","ぎろん","きわめる","ぎんいろ","きんかくじ","きんじょ","きんようび","ぐあい","くいず","くうかん","くうき","くうぐん","くうこう","ぐうせい","くうそう","ぐうたら","くうふく","くうぼ","くかん","くきょう","くげん","ぐこう","くさい","くさき","くさばな","くさる","くしゃみ","くしょう","くすのき","くすりゆび","くせげ","くせん","ぐたいてき","くださる","くたびれる","くちこみ","くちさき","くつした","ぐっすり","くつろぐ","くとうてん","くどく","くなん","くねくね","くのう","くふう","くみあわせ","くみたてる","くめる","くやくしょ","くらす","くらべる","くるま","くれる","くろう","くわしい","ぐんかん","ぐんしょく","ぐんたい","ぐんて","けあな","けいかく","けいけん","けいこ","けいさつ","げいじゅつ","けいたい","げいのうじん","けいれき","けいろ","けおとす","けおりもの","げきか","げきげん","げきだん","げきちん","げきとつ","げきは","げきやく","げこう","げこくじょう","げざい","けさき","げざん","けしき","けしごむ","けしょう","げすと","けたば","けちゃっぷ","けちらす","けつあつ","けつい","けつえき","けっこん","けつじょ","けっせき","けってい","けつまつ","げつようび","げつれい","けつろん","げどく","けとばす","けとる","けなげ","けなす","けなみ","けぬき","げねつ","けねん","けはい","げひん","けぶかい","げぼく","けまり","けみかる","けむし","けむり","けもの","けらい","けろけろ","けわしい","けんい","けんえつ","けんお","けんか","げんき","けんげん","けんこう","けんさく","けんしゅう","けんすう","げんそう","けんちく","けんてい","けんとう","けんない","けんにん","げんぶつ","けんま","けんみん","けんめい","けんらん","けんり","こあくま","こいぬ","こいびと","ごうい","こうえん","こうおん","こうかん","ごうきゅう","ごうけい","こうこう","こうさい","こうじ","こうすい","ごうせい","こうそく","こうたい","こうちゃ","こうつう","こうてい","こうどう","こうない","こうはい","ごうほう","ごうまん","こうもく","こうりつ","こえる","こおり","ごかい","ごがつ","ごかん","こくご","こくさい","こくとう","こくない","こくはく","こぐま","こけい","こける","ここのか","こころ","こさめ","こしつ","こすう","こせい","こせき","こぜん","こそだて","こたい","こたえる","こたつ","こちょう","こっか","こつこつ","こつばん","こつぶ","こてい","こてん","ことがら","ことし","ことば","ことり","こなごな","こねこね","このまま","このみ","このよ","ごはん","こひつじ","こふう","こふん","こぼれる","ごまあぶら","こまかい","ごますり","こまつな","こまる","こむぎこ","こもじ","こもち","こもの","こもん","こやく","こやま","こゆう","こゆび","こよい","こよう","こりる","これくしょん","ころっけ","こわもて","こわれる","こんいん","こんかい","こんき","こんしゅう","こんすい","こんだて","こんとん","こんなん","こんびに","こんぽん","こんまけ","こんや","こんれい","こんわく","ざいえき","さいかい","さいきん","ざいげん","ざいこ","さいしょ","さいせい","ざいたく","ざいちゅう","さいてき","ざいりょう","さうな","さかいし","さがす","さかな","さかみち","さがる","さぎょう","さくし","さくひん","さくら","さこく","さこつ","さずかる","ざせき","さたん","さつえい","ざつおん","ざっか","ざつがく","さっきょく","ざっし","さつじん","ざっそう","さつたば","さつまいも","さてい","さといも","さとう","さとおや","さとし","さとる","さのう","さばく","さびしい","さべつ","さほう","さほど","さます","さみしい","さみだれ","さむけ","さめる","さやえんどう","さゆう","さよう","さよく","さらだ","ざるそば","さわやか","さわる","さんいん","さんか","さんきゃく","さんこう","さんさい","ざんしょ","さんすう","さんせい","さんそ","さんち","さんま","さんみ","さんらん","しあい","しあげ","しあさって","しあわせ","しいく","しいん","しうち","しえい","しおけ","しかい","しかく","じかん","しごと","しすう","じだい","したうけ","したぎ","したて","したみ","しちょう","しちりん","しっかり","しつじ","しつもん","してい","してき","してつ","じてん","じどう","しなぎれ","しなもの","しなん","しねま","しねん","しのぐ","しのぶ","しはい","しばかり","しはつ","しはらい","しはん","しひょう","しふく","じぶん","しへい","しほう","しほん","しまう","しまる","しみん","しむける","じむしょ","しめい","しめる","しもん","しゃいん","しゃうん","しゃおん","じゃがいも","しやくしょ","しゃくほう","しゃけん","しゃこ","しゃざい","しゃしん","しゃせん","しゃそう","しゃたい","しゃちょう","しゃっきん","じゃま","しゃりん","しゃれい","じゆう","じゅうしょ","しゅくはく","じゅしん","しゅっせき","しゅみ","しゅらば","じゅんばん","しょうかい","しょくたく","しょっけん","しょどう","しょもつ","しらせる","しらべる","しんか","しんこう","じんじゃ","しんせいじ","しんちく","しんりん","すあげ","すあし","すあな","ずあん","すいえい","すいか","すいとう","ずいぶん","すいようび","すうがく","すうじつ","すうせん","すおどり","すきま","すくう","すくない","すける","すごい","すこし","ずさん","すずしい","すすむ","すすめる","すっかり","ずっしり","ずっと","すてき","すてる","すねる","すのこ","すはだ","すばらしい","ずひょう","ずぶぬれ","すぶり","すふれ","すべて","すべる","ずほう","すぼん","すまい","すめし","すもう","すやき","すらすら","するめ","すれちがう","すろっと","すわる","すんぜん","すんぽう","せあぶら","せいかつ","せいげん","せいじ","せいよう","せおう","せかいかん","せきにん","せきむ","せきゆ","せきらんうん","せけん","せこう","せすじ","せたい","せたけ","せっかく","せっきゃく","ぜっく","せっけん","せっこつ","せっさたくま","せつぞく","せつだん","せつでん","せっぱん","せつび","せつぶん","せつめい","せつりつ","せなか","せのび","せはば","せびろ","せぼね","せまい","せまる","せめる","せもたれ","せりふ","ぜんあく","せんい","せんえい","せんか","せんきょ","せんく","せんげん","ぜんご","せんさい","せんしゅ","せんすい","せんせい","せんぞ","せんたく","せんちょう","せんてい","せんとう","せんぬき","せんねん","せんぱい","ぜんぶ","ぜんぽう","せんむ","せんめんじょ","せんもん","せんやく","せんゆう","せんよう","ぜんら","ぜんりゃく","せんれい","せんろ","そあく","そいとげる","そいね","そうがんきょう","そうき","そうご","そうしん","そうだん","そうなん","そうび","そうめん","そうり","そえもの","そえん","そがい","そげき","そこう","そこそこ","そざい","そしな","そせい","そせん","そそぐ","そだてる","そつう","そつえん","そっかん","そつぎょう","そっけつ","そっこう","そっせん","そっと","そとがわ","そとづら","そなえる","そなた","そふぼ","そぼく","そぼろ","そまつ","そまる","そむく","そむりえ","そめる","そもそも","そよかぜ","そらまめ","そろう","そんかい","そんけい","そんざい","そんしつ","そんぞく","そんちょう","ぞんび","ぞんぶん","そんみん","たあい","たいいん","たいうん","たいえき","たいおう","だいがく","たいき","たいぐう","たいけん","たいこ","たいざい","だいじょうぶ","だいすき","たいせつ","たいそう","だいたい","たいちょう","たいてい","だいどころ","たいない","たいねつ","たいのう","たいはん","だいひょう","たいふう","たいへん","たいほ","たいまつばな","たいみんぐ","たいむ","たいめん","たいやき","たいよう","たいら","たいりょく","たいる","たいわん","たうえ","たえる","たおす","たおる","たおれる","たかい","たかね","たきび","たくさん","たこく","たこやき","たさい","たしざん","だじゃれ","たすける","たずさわる","たそがれ","たたかう","たたく","ただしい","たたみ","たちばな","だっかい","だっきゃく","だっこ","だっしゅつ","だったい","たてる","たとえる","たなばた","たにん","たぬき","たのしみ","たはつ","たぶん","たべる","たぼう","たまご","たまる","だむる","ためいき","ためす","ためる","たもつ","たやすい","たよる","たらす","たりきほんがん","たりょう","たりる","たると","たれる","たれんと","たろっと","たわむれる","だんあつ","たんい","たんおん","たんか","たんき","たんけん","たんご","たんさん","たんじょうび","だんせい","たんそく","たんたい","だんち","たんてい","たんとう","だんな","たんにん","だんねつ","たんのう","たんぴん","だんぼう","たんまつ","たんめい","だんれつ","だんろ","だんわ","ちあい","ちあん","ちいき","ちいさい","ちえん","ちかい","ちから","ちきゅう","ちきん","ちけいず","ちけん","ちこく","ちさい","ちしき","ちしりょう","ちせい","ちそう","ちたい","ちたん","ちちおや","ちつじょ","ちてき","ちてん","ちぬき","ちぬり","ちのう","ちひょう","ちへいせん","ちほう","ちまた","ちみつ","ちみどろ","ちめいど","ちゃんこなべ","ちゅうい","ちゆりょく","ちょうし","ちょさくけん","ちらし","ちらみ","ちりがみ","ちりょう","ちるど","ちわわ","ちんたい","ちんもく","ついか","ついたち","つうか","つうじょう","つうはん","つうわ","つかう","つかれる","つくね","つくる","つけね","つける","つごう","つたえる","つづく","つつじ","つつむ","つとめる","つながる","つなみ","つねづね","つのる","つぶす","つまらない","つまる","つみき","つめたい","つもり","つもる","つよい","つるぼ","つるみく","つわもの","つわり","てあし","てあて","てあみ","ていおん","ていか","ていき","ていけい","ていこく","ていさつ","ていし","ていせい","ていたい","ていど","ていねい","ていひょう","ていへん","ていぼう","てうち","ておくれ","てきとう","てくび","でこぼこ","てさぎょう","てさげ","てすり","てそう","てちがい","てちょう","てつがく","てつづき","でっぱ","てつぼう","てつや","でぬかえ","てぬき","てぬぐい","てのひら","てはい","てぶくろ","てふだ","てほどき","てほん","てまえ","てまきずし","てみじか","てみやげ","てらす","てれび","てわけ","てわたし","でんあつ","てんいん","てんかい","てんき","てんぐ","てんけん","てんごく","てんさい","てんし","てんすう","でんち","てんてき","てんとう","てんない","てんぷら","てんぼうだい","てんめつ","てんらんかい","でんりょく","でんわ","どあい","といれ","どうかん","とうきゅう","どうぐ","とうし","とうむぎ","とおい","とおか","とおく","とおす","とおる","とかい","とかす","ときおり","ときどき","とくい","とくしゅう","とくてん","とくに","とくべつ","とけい","とける","とこや","とさか","としょかん","とそう","とたん","とちゅう","とっきゅう","とっくん","とつぜん","とつにゅう","とどける","ととのえる","とない","となえる","となり","とのさま","とばす","どぶがわ","とほう","とまる","とめる","ともだち","ともる","どようび","とらえる","とんかつ","どんぶり","ないかく","ないこう","ないしょ","ないす","ないせん","ないそう","なおす","ながい","なくす","なげる","なこうど","なさけ","なたでここ","なっとう","なつやすみ","ななおし","なにごと","なにもの","なにわ","なのか","なふだ","なまいき","なまえ","なまみ","なみだ","なめらか","なめる","なやむ","ならう","ならび","ならぶ","なれる","なわとび","なわばり","にあう","にいがた","にうけ","におい","にかい","にがて","にきび","にくしみ","にくまん","にげる","にさんかたんそ","にしき","にせもの","にちじょう","にちようび","にっか","にっき","にっけい","にっこう","にっさん","にっしょく","にっすう","にっせき","にってい","になう","にほん","にまめ","にもつ","にやり","にゅういん","にりんしゃ","にわとり","にんい","にんか","にんき","にんげん","にんしき","にんずう","にんそう","にんたい","にんち","にんてい","にんにく","にんぷ","にんまり","にんむ","にんめい","にんよう","ぬいくぎ","ぬかす","ぬぐいとる","ぬぐう","ぬくもり","ぬすむ","ぬまえび","ぬめり","ぬらす","ぬんちゃく","ねあげ","ねいき","ねいる","ねいろ","ねぐせ","ねくたい","ねくら","ねこぜ","ねこむ","ねさげ","ねすごす","ねそべる","ねだん","ねつい","ねっしん","ねつぞう","ねったいぎょ","ねぶそく","ねふだ","ねぼう","ねほりはほり","ねまき","ねまわし","ねみみ","ねむい","ねむたい","ねもと","ねらう","ねわざ","ねんいり","ねんおし","ねんかん","ねんきん","ねんぐ","ねんざ","ねんし","ねんちゃく","ねんど","ねんぴ","ねんぶつ","ねんまつ","ねんりょう","ねんれい","のいず","のおづま","のがす","のきなみ","のこぎり","のこす","のこる","のせる","のぞく","のぞむ","のたまう","のちほど","のっく","のばす","のはら","のべる","のぼる","のみもの","のやま","のらいぬ","のらねこ","のりもの","のりゆき","のれん","のんき","ばあい","はあく","ばあさん","ばいか","ばいく","はいけん","はいご","はいしん","はいすい","はいせん","はいそう","はいち","ばいばい","はいれつ","はえる","はおる","はかい","ばかり","はかる","はくしゅ","はけん","はこぶ","はさみ","はさん","はしご","ばしょ","はしる","はせる","ぱそこん","はそん","はたん","はちみつ","はつおん","はっかく","はづき","はっきり","はっくつ","はっけん","はっこう","はっさん","はっしん","はったつ","はっちゅう","はってん","はっぴょう","はっぽう","はなす","はなび","はにかむ","はぶらし","はみがき","はむかう","はめつ","はやい","はやし","はらう","はろうぃん","はわい","はんい","はんえい","はんおん","はんかく","はんきょう","ばんぐみ","はんこ","はんしゃ","はんすう","はんだん","ぱんち","ぱんつ","はんてい","はんとし","はんのう","はんぱ","はんぶん","はんぺん","はんぼうき","はんめい","はんらん","はんろん","ひいき","ひうん","ひえる","ひかく","ひかり","ひかる","ひかん","ひくい","ひけつ","ひこうき","ひこく","ひさい","ひさしぶり","ひさん","びじゅつかん","ひしょ","ひそか","ひそむ","ひたむき","ひだり","ひたる","ひつぎ","ひっこし","ひっし","ひつじゅひん","ひっす","ひつぜん","ぴったり","ぴっちり","ひつよう","ひてい","ひとごみ","ひなまつり","ひなん","ひねる","ひはん","ひびく","ひひょう","ひほう","ひまわり","ひまん","ひみつ","ひめい","ひめじし","ひやけ","ひやす","ひよう","びょうき","ひらがな","ひらく","ひりつ","ひりょう","ひるま","ひるやすみ","ひれい","ひろい","ひろう","ひろき","ひろゆき","ひんかく","ひんけつ","ひんこん","ひんしゅ","ひんそう","ぴんち","ひんぱん","びんぼう","ふあん","ふいうち","ふうけい","ふうせん","ぷうたろう","ふうとう","ふうふ","ふえる","ふおん","ふかい","ふきん","ふくざつ","ふくぶくろ","ふこう","ふさい","ふしぎ","ふじみ","ふすま","ふせい","ふせぐ","ふそく","ぶたにく","ふたん","ふちょう","ふつう","ふつか","ふっかつ","ふっき","ふっこく","ぶどう","ふとる","ふとん","ふのう","ふはい","ふひょう","ふへん","ふまん","ふみん","ふめつ","ふめん","ふよう","ふりこ","ふりる","ふるい","ふんいき","ぶんがく","ぶんぐ","ふんしつ","ぶんせき","ふんそう","ぶんぽう","へいあん","へいおん","へいがい","へいき","へいげん","へいこう","へいさ","へいしゃ","へいせつ","へいそ","へいたく","へいてん","へいねつ","へいわ","へきが","へこむ","べにいろ","べにしょうが","へらす","へんかん","べんきょう","べんごし","へんさい","へんたい","べんり","ほあん","ほいく","ぼうぎょ","ほうこく","ほうそう","ほうほう","ほうもん","ほうりつ","ほえる","ほおん","ほかん","ほきょう","ぼきん","ほくろ","ほけつ","ほけん","ほこう","ほこる","ほしい","ほしつ","ほしゅ","ほしょう","ほせい","ほそい","ほそく","ほたて","ほたる","ぽちぶくろ","ほっきょく","ほっさ","ほったん","ほとんど","ほめる","ほんい","ほんき","ほんけ","ほんしつ","ほんやく","まいにち","まかい","まかせる","まがる","まける","まこと","まさつ","まじめ","ますく","まぜる","まつり","まとめ","まなぶ","まぬけ","まねく","まほう","まもる","まゆげ","まよう","まろやか","まわす","まわり","まわる","まんが","まんきつ","まんぞく","まんなか","みいら","みうち","みえる","みがく","みかた","みかん","みけん","みこん","みじかい","みすい","みすえる","みせる","みっか","みつかる","みつける","みてい","みとめる","みなと","みなみかさい","みねらる","みのう","みのがす","みほん","みもと","みやげ","みらい","みりょく","みわく","みんか","みんぞく","むいか","むえき","むえん","むかい","むかう","むかえ","むかし","むぎちゃ","むける","むげん","むさぼる","むしあつい","むしば","むじゅん","むしろ","むすう","むすこ","むすぶ","むすめ","むせる","むせん","むちゅう","むなしい","むのう","むやみ","むよう","むらさき","むりょう","むろん","めいあん","めいうん","めいえん","めいかく","めいきょく","めいさい","めいし","めいそう","めいぶつ","めいれい","めいわく","めぐまれる","めざす","めした","めずらしい","めだつ","めまい","めやす","めんきょ","めんせき","めんどう","もうしあげる","もうどうけん","もえる","もくし","もくてき","もくようび","もちろん","もどる","もらう","もんく","もんだい","やおや","やける","やさい","やさしい","やすい","やすたろう","やすみ","やせる","やそう","やたい","やちん","やっと","やっぱり","やぶる","やめる","ややこしい","やよい","やわらかい","ゆうき","ゆうびんきょく","ゆうべ","ゆうめい","ゆけつ","ゆしゅつ","ゆせん","ゆそう","ゆたか","ゆちゃく","ゆでる","ゆにゅう","ゆびわ","ゆらい","ゆれる","ようい","ようか","ようきゅう","ようじ","ようす","ようちえん","よかぜ","よかん","よきん","よくせい","よくぼう","よけい","よごれる","よさん","よしゅう","よそう","よそく","よっか","よてい","よどがわく","よねつ","よやく","よゆう","よろこぶ","よろしい","らいう","らくがき","らくご","らくさつ","らくだ","らしんばん","らせん","らぞく","らたい","らっか","られつ","りえき","りかい","りきさく","りきせつ","りくぐん","りくつ","りけん","りこう","りせい","りそう","りそく","りてん","りねん","りゆう","りゅうがく","りよう","りょうり","りょかん","りょくちゃ","りょこう","りりく","りれき","りろん","りんご","るいけい","るいさい","るいじ","るいせき","るすばん","るりがわら","れいかん","れいぎ","れいせい","れいぞうこ","れいとう","れいぼう","れきし","れきだい","れんあい","れんけい","れんこん","れんさい","れんしゅう","れんぞく","れんらく","ろうか","ろうご","ろうじん","ろうそく","ろくが","ろこつ","ろじうら","ろしゅつ","ろせん","ろてん","ろめん","ろれつ","ろんぎ","ろんぱ","ろんぶん","ろんり","わかす","わかめ","わかやま","わかれる","わしつ","わじまし","わすれもの","わらう","われる"]');

});

parcelRequire.register("g6Pks", function(module, exports) {
module.exports = JSON.parse('["abacate","abaixo","abalar","abater","abduzir","abelha","aberto","abismo","abotoar","abranger","abreviar","abrigar","abrupto","absinto","absoluto","absurdo","abutre","acabado","acalmar","acampar","acanhar","acaso","aceitar","acelerar","acenar","acervo","acessar","acetona","achatar","acidez","acima","acionado","acirrar","aclamar","aclive","acolhida","acomodar","acoplar","acordar","acumular","acusador","adaptar","adega","adentro","adepto","adequar","aderente","adesivo","adeus","adiante","aditivo","adjetivo","adjunto","admirar","adorar","adquirir","adubo","adverso","advogado","aeronave","afastar","aferir","afetivo","afinador","afivelar","aflito","afluente","afrontar","agachar","agarrar","agasalho","agenciar","agilizar","agiota","agitado","agora","agradar","agreste","agrupar","aguardar","agulha","ajoelhar","ajudar","ajustar","alameda","alarme","alastrar","alavanca","albergue","albino","alcatra","aldeia","alecrim","alegria","alertar","alface","alfinete","algum","alheio","aliar","alicate","alienar","alinhar","aliviar","almofada","alocar","alpiste","alterar","altitude","alucinar","alugar","aluno","alusivo","alvo","amaciar","amador","amarelo","amassar","ambas","ambiente","ameixa","amenizar","amido","amistoso","amizade","amolador","amontoar","amoroso","amostra","amparar","ampliar","ampola","anagrama","analisar","anarquia","anatomia","andaime","anel","anexo","angular","animar","anjo","anomalia","anotado","ansioso","anterior","anuidade","anunciar","anzol","apagador","apalpar","apanhado","apego","apelido","apertada","apesar","apetite","apito","aplauso","aplicada","apoio","apontar","aposta","aprendiz","aprovar","aquecer","arame","aranha","arara","arcada","ardente","areia","arejar","arenito","aresta","argiloso","argola","arma","arquivo","arraial","arrebate","arriscar","arroba","arrumar","arsenal","arterial","artigo","arvoredo","asfaltar","asilado","aspirar","assador","assinar","assoalho","assunto","astral","atacado","atadura","atalho","atarefar","atear","atender","aterro","ateu","atingir","atirador","ativo","atoleiro","atracar","atrevido","atriz","atual","atum","auditor","aumentar","aura","aurora","autismo","autoria","autuar","avaliar","avante","avaria","avental","avesso","aviador","avisar","avulso","axila","azarar","azedo","azeite","azulejo","babar","babosa","bacalhau","bacharel","bacia","bagagem","baiano","bailar","baioneta","bairro","baixista","bajular","baleia","baliza","balsa","banal","bandeira","banho","banir","banquete","barato","barbado","baronesa","barraca","barulho","baseado","bastante","batata","batedor","batida","batom","batucar","baunilha","beber","beijo","beirada","beisebol","beldade","beleza","belga","beliscar","bendito","bengala","benzer","berimbau","berlinda","berro","besouro","bexiga","bezerro","bico","bicudo","bienal","bifocal","bifurcar","bigorna","bilhete","bimestre","bimotor","biologia","biombo","biosfera","bipolar","birrento","biscoito","bisneto","bispo","bissexto","bitola","bizarro","blindado","bloco","bloquear","boato","bobagem","bocado","bocejo","bochecha","boicotar","bolada","boletim","bolha","bolo","bombeiro","bonde","boneco","bonita","borbulha","borda","boreal","borracha","bovino","boxeador","branco","brasa","braveza","breu","briga","brilho","brincar","broa","brochura","bronzear","broto","bruxo","bucha","budismo","bufar","bule","buraco","busca","busto","buzina","cabana","cabelo","cabide","cabo","cabrito","cacau","cacetada","cachorro","cacique","cadastro","cadeado","cafezal","caiaque","caipira","caixote","cajado","caju","calafrio","calcular","caldeira","calibrar","calmante","calota","camada","cambista","camisa","camomila","campanha","camuflar","canavial","cancelar","caneta","canguru","canhoto","canivete","canoa","cansado","cantar","canudo","capacho","capela","capinar","capotar","capricho","captador","capuz","caracol","carbono","cardeal","careca","carimbar","carneiro","carpete","carreira","cartaz","carvalho","casaco","casca","casebre","castelo","casulo","catarata","cativar","caule","causador","cautelar","cavalo","caverna","cebola","cedilha","cegonha","celebrar","celular","cenoura","censo","centeio","cercar","cerrado","certeiro","cerveja","cetim","cevada","chacota","chaleira","chamado","chapada","charme","chatice","chave","chefe","chegada","cheiro","cheque","chicote","chifre","chinelo","chocalho","chover","chumbo","chutar","chuva","cicatriz","ciclone","cidade","cidreira","ciente","cigana","cimento","cinto","cinza","ciranda","circuito","cirurgia","citar","clareza","clero","clicar","clone","clube","coado","coagir","cobaia","cobertor","cobrar","cocada","coelho","coentro","coeso","cogumelo","coibir","coifa","coiote","colar","coleira","colher","colidir","colmeia","colono","coluna","comando","combinar","comentar","comitiva","comover","complexo","comum","concha","condor","conectar","confuso","congelar","conhecer","conjugar","consumir","contrato","convite","cooperar","copeiro","copiador","copo","coquetel","coragem","cordial","corneta","coronha","corporal","correio","cortejo","coruja","corvo","cosseno","costela","cotonete","couro","couve","covil","cozinha","cratera","cravo","creche","credor","creme","crer","crespo","criada","criminal","crioulo","crise","criticar","crosta","crua","cruzeiro","cubano","cueca","cuidado","cujo","culatra","culminar","culpar","cultura","cumprir","cunhado","cupido","curativo","curral","cursar","curto","cuspir","custear","cutelo","damasco","datar","debater","debitar","deboche","debulhar","decalque","decimal","declive","decote","decretar","dedal","dedicado","deduzir","defesa","defumar","degelo","degrau","degustar","deitado","deixar","delator","delegado","delinear","delonga","demanda","demitir","demolido","dentista","depenado","depilar","depois","depressa","depurar","deriva","derramar","desafio","desbotar","descanso","desenho","desfiado","desgaste","desigual","deslize","desmamar","desova","despesa","destaque","desviar","detalhar","detentor","detonar","detrito","deusa","dever","devido","devotado","dezena","diagrama","dialeto","didata","difuso","digitar","dilatado","diluente","diminuir","dinastia","dinheiro","diocese","direto","discreta","disfarce","disparo","disquete","dissipar","distante","ditador","diurno","diverso","divisor","divulgar","dizer","dobrador","dolorido","domador","dominado","donativo","donzela","dormente","dorsal","dosagem","dourado","doutor","drenagem","drible","drogaria","duelar","duende","dueto","duplo","duquesa","durante","duvidoso","eclodir","ecoar","ecologia","edificar","edital","educado","efeito","efetivar","ejetar","elaborar","eleger","eleitor","elenco","elevador","eliminar","elogiar","embargo","embolado","embrulho","embutido","emenda","emergir","emissor","empatia","empenho","empinado","empolgar","emprego","empurrar","emulador","encaixe","encenado","enchente","encontro","endeusar","endossar","enfaixar","enfeite","enfim","engajado","engenho","englobar","engomado","engraxar","enguia","enjoar","enlatar","enquanto","enraizar","enrolado","enrugar","ensaio","enseada","ensino","ensopado","entanto","enteado","entidade","entortar","entrada","entulho","envergar","enviado","envolver","enxame","enxerto","enxofre","enxuto","epiderme","equipar","ereto","erguido","errata","erva","ervilha","esbanjar","esbelto","escama","escola","escrita","escuta","esfinge","esfolar","esfregar","esfumado","esgrima","esmalte","espanto","espelho","espiga","esponja","espreita","espumar","esquerda","estaca","esteira","esticar","estofado","estrela","estudo","esvaziar","etanol","etiqueta","euforia","europeu","evacuar","evaporar","evasivo","eventual","evidente","evoluir","exagero","exalar","examinar","exato","exausto","excesso","excitar","exclamar","executar","exemplo","exibir","exigente","exonerar","expandir","expelir","expirar","explanar","exposto","expresso","expulsar","externo","extinto","extrato","fabricar","fabuloso","faceta","facial","fada","fadiga","faixa","falar","falta","familiar","fandango","fanfarra","fantoche","fardado","farelo","farinha","farofa","farpa","fartura","fatia","fator","favorita","faxina","fazenda","fechado","feijoada","feirante","felino","feminino","fenda","feno","fera","feriado","ferrugem","ferver","festejar","fetal","feudal","fiapo","fibrose","ficar","ficheiro","figurado","fileira","filho","filme","filtrar","firmeza","fisgada","fissura","fita","fivela","fixador","fixo","flacidez","flamingo","flanela","flechada","flora","flutuar","fluxo","focal","focinho","fofocar","fogo","foguete","foice","folgado","folheto","forjar","formiga","forno","forte","fosco","fossa","fragata","fralda","frango","frasco","fraterno","freira","frente","fretar","frieza","friso","fritura","fronha","frustrar","fruteira","fugir","fulano","fuligem","fundar","fungo","funil","furador","furioso","futebol","gabarito","gabinete","gado","gaiato","gaiola","gaivota","galega","galho","galinha","galocha","ganhar","garagem","garfo","gargalo","garimpo","garoupa","garrafa","gasoduto","gasto","gata","gatilho","gaveta","gazela","gelado","geleia","gelo","gemada","gemer","gemido","generoso","gengiva","genial","genoma","genro","geologia","gerador","germinar","gesso","gestor","ginasta","gincana","gingado","girafa","girino","glacial","glicose","global","glorioso","goela","goiaba","golfe","golpear","gordura","gorjeta","gorro","gostoso","goteira","governar","gracejo","gradual","grafite","gralha","grampo","granada","gratuito","graveto","graxa","grego","grelhar","greve","grilo","grisalho","gritaria","grosso","grotesco","grudado","grunhido","gruta","guache","guarani","guaxinim","guerrear","guiar","guincho","guisado","gula","guloso","guru","habitar","harmonia","haste","haver","hectare","herdar","heresia","hesitar","hiato","hibernar","hidratar","hiena","hino","hipismo","hipnose","hipoteca","hoje","holofote","homem","honesto","honrado","hormonal","hospedar","humorado","iate","ideia","idoso","ignorado","igreja","iguana","ileso","ilha","iludido","iluminar","ilustrar","imagem","imediato","imenso","imersivo","iminente","imitador","imortal","impacto","impedir","implante","impor","imprensa","impune","imunizar","inalador","inapto","inativo","incenso","inchar","incidir","incluir","incolor","indeciso","indireto","indutor","ineficaz","inerente","infantil","infestar","infinito","inflamar","informal","infrator","ingerir","inibido","inicial","inimigo","injetar","inocente","inodoro","inovador","inox","inquieto","inscrito","inseto","insistir","inspetor","instalar","insulto","intacto","integral","intimar","intocado","intriga","invasor","inverno","invicto","invocar","iogurte","iraniano","ironizar","irreal","irritado","isca","isento","isolado","isqueiro","italiano","janeiro","jangada","janta","jararaca","jardim","jarro","jasmim","jato","javali","jazida","jejum","joaninha","joelhada","jogador","joia","jornal","jorrar","jovem","juba","judeu","judoca","juiz","julgador","julho","jurado","jurista","juro","justa","labareda","laboral","lacre","lactante","ladrilho","lagarta","lagoa","laje","lamber","lamentar","laminar","lampejo","lanche","lapidar","lapso","laranja","lareira","largura","lasanha","lastro","lateral","latido","lavanda","lavoura","lavrador","laxante","lazer","lealdade","lebre","legado","legendar","legista","leigo","leiloar","leitura","lembrete","leme","lenhador","lentilha","leoa","lesma","leste","letivo","letreiro","levar","leveza","levitar","liberal","libido","liderar","ligar","ligeiro","limitar","limoeiro","limpador","linda","linear","linhagem","liquidez","listagem","lisura","litoral","livro","lixa","lixeira","locador","locutor","lojista","lombo","lona","longe","lontra","lorde","lotado","loteria","loucura","lousa","louvar","luar","lucidez","lucro","luneta","lustre","lutador","luva","macaco","macete","machado","macio","madeira","madrinha","magnata","magreza","maior","mais","malandro","malha","malote","maluco","mamilo","mamoeiro","mamute","manada","mancha","mandato","manequim","manhoso","manivela","manobrar","mansa","manter","manusear","mapeado","maquinar","marcador","maresia","marfim","margem","marinho","marmita","maroto","marquise","marreco","martelo","marujo","mascote","masmorra","massagem","mastigar","matagal","materno","matinal","matutar","maxilar","medalha","medida","medusa","megafone","meiga","melancia","melhor","membro","memorial","menino","menos","mensagem","mental","merecer","mergulho","mesada","mesclar","mesmo","mesquita","mestre","metade","meteoro","metragem","mexer","mexicano","micro","migalha","migrar","milagre","milenar","milhar","mimado","minerar","minhoca","ministro","minoria","miolo","mirante","mirtilo","misturar","mocidade","moderno","modular","moeda","moer","moinho","moita","moldura","moleza","molho","molinete","molusco","montanha","moqueca","morango","morcego","mordomo","morena","mosaico","mosquete","mostarda","motel","motim","moto","motriz","muda","muito","mulata","mulher","multar","mundial","munido","muralha","murcho","muscular","museu","musical","nacional","nadador","naja","namoro","narina","narrado","nascer","nativa","natureza","navalha","navegar","navio","neblina","nebuloso","negativa","negociar","negrito","nervoso","neta","neural","nevasca","nevoeiro","ninar","ninho","nitidez","nivelar","nobreza","noite","noiva","nomear","nominal","nordeste","nortear","notar","noticiar","noturno","novelo","novilho","novo","nublado","nudez","numeral","nupcial","nutrir","nuvem","obcecado","obedecer","objetivo","obrigado","obscuro","obstetra","obter","obturar","ocidente","ocioso","ocorrer","oculista","ocupado","ofegante","ofensiva","oferenda","oficina","ofuscado","ogiva","olaria","oleoso","olhar","oliveira","ombro","omelete","omisso","omitir","ondulado","oneroso","ontem","opcional","operador","oponente","oportuno","oposto","orar","orbitar","ordem","ordinal","orfanato","orgasmo","orgulho","oriental","origem","oriundo","orla","ortodoxo","orvalho","oscilar","ossada","osso","ostentar","otimismo","ousadia","outono","outubro","ouvido","ovelha","ovular","oxidar","oxigenar","pacato","paciente","pacote","pactuar","padaria","padrinho","pagar","pagode","painel","pairar","paisagem","palavra","palestra","palheta","palito","palmada","palpitar","pancada","panela","panfleto","panqueca","pantanal","papagaio","papelada","papiro","parafina","parcial","pardal","parede","partida","pasmo","passado","pastel","patamar","patente","patinar","patrono","paulada","pausar","peculiar","pedalar","pedestre","pediatra","pedra","pegada","peitoral","peixe","pele","pelicano","penca","pendurar","peneira","penhasco","pensador","pente","perceber","perfeito","pergunta","perito","permitir","perna","perplexo","persiana","pertence","peruca","pescado","pesquisa","pessoa","petiscar","piada","picado","piedade","pigmento","pilastra","pilhado","pilotar","pimenta","pincel","pinguim","pinha","pinote","pintar","pioneiro","pipoca","piquete","piranha","pires","pirueta","piscar","pistola","pitanga","pivete","planta","plaqueta","platina","plebeu","plumagem","pluvial","pneu","poda","poeira","poetisa","polegada","policiar","poluente","polvilho","pomar","pomba","ponderar","pontaria","populoso","porta","possuir","postal","pote","poupar","pouso","povoar","praia","prancha","prato","praxe","prece","predador","prefeito","premiar","prensar","preparar","presilha","pretexto","prevenir","prezar","primata","princesa","prisma","privado","processo","produto","profeta","proibido","projeto","prometer","propagar","prosa","protetor","provador","publicar","pudim","pular","pulmonar","pulseira","punhal","punir","pupilo","pureza","puxador","quadra","quantia","quarto","quase","quebrar","queda","queijo","quente","querido","quimono","quina","quiosque","rabanada","rabisco","rachar","racionar","radial","raiar","rainha","raio","raiva","rajada","ralado","ramal","ranger","ranhura","rapadura","rapel","rapidez","raposa","raquete","raridade","rasante","rascunho","rasgar","raspador","rasteira","rasurar","ratazana","ratoeira","realeza","reanimar","reaver","rebaixar","rebelde","rebolar","recado","recente","recheio","recibo","recordar","recrutar","recuar","rede","redimir","redonda","reduzida","reenvio","refinar","refletir","refogar","refresco","refugiar","regalia","regime","regra","reinado","reitor","rejeitar","relativo","remador","remendo","remorso","renovado","reparo","repelir","repleto","repolho","represa","repudiar","requerer","resenha","resfriar","resgatar","residir","resolver","respeito","ressaca","restante","resumir","retalho","reter","retirar","retomada","retratar","revelar","revisor","revolta","riacho","rica","rigidez","rigoroso","rimar","ringue","risada","risco","risonho","robalo","rochedo","rodada","rodeio","rodovia","roedor","roleta","romano","roncar","rosado","roseira","rosto","rota","roteiro","rotina","rotular","rouco","roupa","roxo","rubro","rugido","rugoso","ruivo","rumo","rupestre","russo","sabor","saciar","sacola","sacudir","sadio","safira","saga","sagrada","saibro","salada","saleiro","salgado","saliva","salpicar","salsicha","saltar","salvador","sambar","samurai","sanar","sanfona","sangue","sanidade","sapato","sarda","sargento","sarjeta","saturar","saudade","saxofone","sazonal","secar","secular","seda","sedento","sediado","sedoso","sedutor","segmento","segredo","segundo","seiva","seleto","selvagem","semanal","semente","senador","senhor","sensual","sentado","separado","sereia","seringa","serra","servo","setembro","setor","sigilo","silhueta","silicone","simetria","simpatia","simular","sinal","sincero","singular","sinopse","sintonia","sirene","siri","situado","soberano","sobra","socorro","sogro","soja","solda","soletrar","solteiro","sombrio","sonata","sondar","sonegar","sonhador","sono","soprano","soquete","sorrir","sorteio","sossego","sotaque","soterrar","sovado","sozinho","suavizar","subida","submerso","subsolo","subtrair","sucata","sucesso","suco","sudeste","sufixo","sugador","sugerir","sujeito","sulfato","sumir","suor","superior","suplicar","suposto","suprimir","surdina","surfista","surpresa","surreal","surtir","suspiro","sustento","tabela","tablete","tabuada","tacho","tagarela","talher","talo","talvez","tamanho","tamborim","tampa","tangente","tanto","tapar","tapioca","tardio","tarefa","tarja","tarraxa","tatuagem","taurino","taxativo","taxista","teatral","tecer","tecido","teclado","tedioso","teia","teimar","telefone","telhado","tempero","tenente","tensor","tentar","termal","terno","terreno","tese","tesoura","testado","teto","textura","texugo","tiara","tigela","tijolo","timbrar","timidez","tingido","tinteiro","tiragem","titular","toalha","tocha","tolerar","tolice","tomada","tomilho","tonel","tontura","topete","tora","torcido","torneio","torque","torrada","torto","tostar","touca","toupeira","toxina","trabalho","tracejar","tradutor","trafegar","trajeto","trama","trancar","trapo","traseiro","tratador","travar","treino","tremer","trepidar","trevo","triagem","tribo","triciclo","tridente","trilogia","trindade","triplo","triturar","triunfal","trocar","trombeta","trova","trunfo","truque","tubular","tucano","tudo","tulipa","tupi","turbo","turma","turquesa","tutelar","tutorial","uivar","umbigo","unha","unidade","uniforme","urologia","urso","urtiga","urubu","usado","usina","usufruir","vacina","vadiar","vagaroso","vaidoso","vala","valente","validade","valores","vantagem","vaqueiro","varanda","vareta","varrer","vascular","vasilha","vassoura","vazar","vazio","veado","vedar","vegetar","veicular","veleiro","velhice","veludo","vencedor","vendaval","venerar","ventre","verbal","verdade","vereador","vergonha","vermelho","verniz","versar","vertente","vespa","vestido","vetorial","viaduto","viagem","viajar","viatura","vibrador","videira","vidraria","viela","viga","vigente","vigiar","vigorar","vilarejo","vinco","vinheta","vinil","violeta","virada","virtude","visitar","visto","vitral","viveiro","vizinho","voador","voar","vogal","volante","voleibol","voltagem","volumoso","vontade","vulto","vuvuzela","xadrez","xarope","xeque","xeretar","xerife","xingar","zangado","zarpar","zebu","zelador","zombar","zoologia","zumbido"]');

});

parcelRequire.register("ml96a", function(module, exports) {
module.exports = JSON.parse('["abandon","ability","able","about","above","absent","absorb","abstract","absurd","abuse","access","accident","account","accuse","achieve","acid","acoustic","acquire","across","act","action","actor","actress","actual","adapt","add","addict","address","adjust","admit","adult","advance","advice","aerobic","affair","afford","afraid","again","age","agent","agree","ahead","aim","air","airport","aisle","alarm","album","alcohol","alert","alien","all","alley","allow","almost","alone","alpha","already","also","alter","always","amateur","amazing","among","amount","amused","analyst","anchor","ancient","anger","angle","angry","animal","ankle","announce","annual","another","answer","antenna","antique","anxiety","any","apart","apology","appear","apple","approve","april","arch","arctic","area","arena","argue","arm","armed","armor","army","around","arrange","arrest","arrive","arrow","art","artefact","artist","artwork","ask","aspect","assault","asset","assist","assume","asthma","athlete","atom","attack","attend","attitude","attract","auction","audit","august","aunt","author","auto","autumn","average","avocado","avoid","awake","aware","away","awesome","awful","awkward","axis","baby","bachelor","bacon","badge","bag","balance","balcony","ball","bamboo","banana","banner","bar","barely","bargain","barrel","base","basic","basket","battle","beach","bean","beauty","because","become","beef","before","begin","behave","behind","believe","below","belt","bench","benefit","best","betray","better","between","beyond","bicycle","bid","bike","bind","biology","bird","birth","bitter","black","blade","blame","blanket","blast","bleak","bless","blind","blood","blossom","blouse","blue","blur","blush","board","boat","body","boil","bomb","bone","bonus","book","boost","border","boring","borrow","boss","bottom","bounce","box","boy","bracket","brain","brand","brass","brave","bread","breeze","brick","bridge","brief","bright","bring","brisk","broccoli","broken","bronze","broom","brother","brown","brush","bubble","buddy","budget","buffalo","build","bulb","bulk","bullet","bundle","bunker","burden","burger","burst","bus","business","busy","butter","buyer","buzz","cabbage","cabin","cable","cactus","cage","cake","call","calm","camera","camp","can","canal","cancel","candy","cannon","canoe","canvas","canyon","capable","capital","captain","car","carbon","card","cargo","carpet","carry","cart","case","cash","casino","castle","casual","cat","catalog","catch","category","cattle","caught","cause","caution","cave","ceiling","celery","cement","census","century","cereal","certain","chair","chalk","champion","change","chaos","chapter","charge","chase","chat","cheap","check","cheese","chef","cherry","chest","chicken","chief","child","chimney","choice","choose","chronic","chuckle","chunk","churn","cigar","cinnamon","circle","citizen","city","civil","claim","clap","clarify","claw","clay","clean","clerk","clever","click","client","cliff","climb","clinic","clip","clock","clog","close","cloth","cloud","clown","club","clump","cluster","clutch","coach","coast","coconut","code","coffee","coil","coin","collect","color","column","combine","come","comfort","comic","common","company","concert","conduct","confirm","congress","connect","consider","control","convince","cook","cool","copper","copy","coral","core","corn","correct","cost","cotton","couch","country","couple","course","cousin","cover","coyote","crack","cradle","craft","cram","crane","crash","crater","crawl","crazy","cream","credit","creek","crew","cricket","crime","crisp","critic","crop","cross","crouch","crowd","crucial","cruel","cruise","crumble","crunch","crush","cry","crystal","cube","culture","cup","cupboard","curious","current","curtain","curve","cushion","custom","cute","cycle","dad","damage","damp","dance","danger","daring","dash","daughter","dawn","day","deal","debate","debris","decade","december","decide","decline","decorate","decrease","deer","defense","define","defy","degree","delay","deliver","demand","demise","denial","dentist","deny","depart","depend","deposit","depth","deputy","derive","describe","desert","design","desk","despair","destroy","detail","detect","develop","device","devote","diagram","dial","diamond","diary","dice","diesel","diet","differ","digital","dignity","dilemma","dinner","dinosaur","direct","dirt","disagree","discover","disease","dish","dismiss","disorder","display","distance","divert","divide","divorce","dizzy","doctor","document","dog","doll","dolphin","domain","donate","donkey","donor","door","dose","double","dove","draft","dragon","drama","drastic","draw","dream","dress","drift","drill","drink","drip","drive","drop","drum","dry","duck","dumb","dune","during","dust","dutch","duty","dwarf","dynamic","eager","eagle","early","earn","earth","easily","east","easy","echo","ecology","economy","edge","edit","educate","effort","egg","eight","either","elbow","elder","electric","elegant","element","elephant","elevator","elite","else","embark","embody","embrace","emerge","emotion","employ","empower","empty","enable","enact","end","endless","endorse","enemy","energy","enforce","engage","engine","enhance","enjoy","enlist","enough","enrich","enroll","ensure","enter","entire","entry","envelope","episode","equal","equip","era","erase","erode","erosion","error","erupt","escape","essay","essence","estate","eternal","ethics","evidence","evil","evoke","evolve","exact","example","excess","exchange","excite","exclude","excuse","execute","exercise","exhaust","exhibit","exile","exist","exit","exotic","expand","expect","expire","explain","expose","express","extend","extra","eye","eyebrow","fabric","face","faculty","fade","faint","faith","fall","false","fame","family","famous","fan","fancy","fantasy","farm","fashion","fat","fatal","father","fatigue","fault","favorite","feature","february","federal","fee","feed","feel","female","fence","festival","fetch","fever","few","fiber","fiction","field","figure","file","film","filter","final","find","fine","finger","finish","fire","firm","first","fiscal","fish","fit","fitness","fix","flag","flame","flash","flat","flavor","flee","flight","flip","float","flock","floor","flower","fluid","flush","fly","foam","focus","fog","foil","fold","follow","food","foot","force","forest","forget","fork","fortune","forum","forward","fossil","foster","found","fox","fragile","frame","frequent","fresh","friend","fringe","frog","front","frost","frown","frozen","fruit","fuel","fun","funny","furnace","fury","future","gadget","gain","galaxy","gallery","game","gap","garage","garbage","garden","garlic","garment","gas","gasp","gate","gather","gauge","gaze","general","genius","genre","gentle","genuine","gesture","ghost","giant","gift","giggle","ginger","giraffe","girl","give","glad","glance","glare","glass","glide","glimpse","globe","gloom","glory","glove","glow","glue","goat","goddess","gold","good","goose","gorilla","gospel","gossip","govern","gown","grab","grace","grain","grant","grape","grass","gravity","great","green","grid","grief","grit","grocery","group","grow","grunt","guard","guess","guide","guilt","guitar","gun","gym","habit","hair","half","hammer","hamster","hand","happy","harbor","hard","harsh","harvest","hat","have","hawk","hazard","head","health","heart","heavy","hedgehog","height","hello","helmet","help","hen","hero","hidden","high","hill","hint","hip","hire","history","hobby","hockey","hold","hole","holiday","hollow","home","honey","hood","hope","horn","horror","horse","hospital","host","hotel","hour","hover","hub","huge","human","humble","humor","hundred","hungry","hunt","hurdle","hurry","hurt","husband","hybrid","ice","icon","idea","identify","idle","ignore","ill","illegal","illness","image","imitate","immense","immune","impact","impose","improve","impulse","inch","include","income","increase","index","indicate","indoor","industry","infant","inflict","inform","inhale","inherit","initial","inject","injury","inmate","inner","innocent","input","inquiry","insane","insect","inside","inspire","install","intact","interest","into","invest","invite","involve","iron","island","isolate","issue","item","ivory","jacket","jaguar","jar","jazz","jealous","jeans","jelly","jewel","job","join","joke","journey","joy","judge","juice","jump","jungle","junior","junk","just","kangaroo","keen","keep","ketchup","key","kick","kid","kidney","kind","kingdom","kiss","kit","kitchen","kite","kitten","kiwi","knee","knife","knock","know","lab","label","labor","ladder","lady","lake","lamp","language","laptop","large","later","latin","laugh","laundry","lava","law","lawn","lawsuit","layer","lazy","leader","leaf","learn","leave","lecture","left","leg","legal","legend","leisure","lemon","lend","length","lens","leopard","lesson","letter","level","liar","liberty","library","license","life","lift","light","like","limb","limit","link","lion","liquid","list","little","live","lizard","load","loan","lobster","local","lock","logic","lonely","long","loop","lottery","loud","lounge","love","loyal","lucky","luggage","lumber","lunar","lunch","luxury","lyrics","machine","mad","magic","magnet","maid","mail","main","major","make","mammal","man","manage","mandate","mango","mansion","manual","maple","marble","march","margin","marine","market","marriage","mask","mass","master","match","material","math","matrix","matter","maximum","maze","meadow","mean","measure","meat","mechanic","medal","media","melody","melt","member","memory","mention","menu","mercy","merge","merit","merry","mesh","message","metal","method","middle","midnight","milk","million","mimic","mind","minimum","minor","minute","miracle","mirror","misery","miss","mistake","mix","mixed","mixture","mobile","model","modify","mom","moment","monitor","monkey","monster","month","moon","moral","more","morning","mosquito","mother","motion","motor","mountain","mouse","move","movie","much","muffin","mule","multiply","muscle","museum","mushroom","music","must","mutual","myself","mystery","myth","naive","name","napkin","narrow","nasty","nation","nature","near","neck","need","negative","neglect","neither","nephew","nerve","nest","net","network","neutral","never","news","next","nice","night","noble","noise","nominee","noodle","normal","north","nose","notable","note","nothing","notice","novel","now","nuclear","number","nurse","nut","oak","obey","object","oblige","obscure","observe","obtain","obvious","occur","ocean","october","odor","off","offer","office","often","oil","okay","old","olive","olympic","omit","once","one","onion","online","only","open","opera","opinion","oppose","option","orange","orbit","orchard","order","ordinary","organ","orient","original","orphan","ostrich","other","outdoor","outer","output","outside","oval","oven","over","own","owner","oxygen","oyster","ozone","pact","paddle","page","pair","palace","palm","panda","panel","panic","panther","paper","parade","parent","park","parrot","party","pass","patch","path","patient","patrol","pattern","pause","pave","payment","peace","peanut","pear","peasant","pelican","pen","penalty","pencil","people","pepper","perfect","permit","person","pet","phone","photo","phrase","physical","piano","picnic","picture","piece","pig","pigeon","pill","pilot","pink","pioneer","pipe","pistol","pitch","pizza","place","planet","plastic","plate","play","please","pledge","pluck","plug","plunge","poem","poet","point","polar","pole","police","pond","pony","pool","popular","portion","position","possible","post","potato","pottery","poverty","powder","power","practice","praise","predict","prefer","prepare","present","pretty","prevent","price","pride","primary","print","priority","prison","private","prize","problem","process","produce","profit","program","project","promote","proof","property","prosper","protect","proud","provide","public","pudding","pull","pulp","pulse","pumpkin","punch","pupil","puppy","purchase","purity","purpose","purse","push","put","puzzle","pyramid","quality","quantum","quarter","question","quick","quit","quiz","quote","rabbit","raccoon","race","rack","radar","radio","rail","rain","raise","rally","ramp","ranch","random","range","rapid","rare","rate","rather","raven","raw","razor","ready","real","reason","rebel","rebuild","recall","receive","recipe","record","recycle","reduce","reflect","reform","refuse","region","regret","regular","reject","relax","release","relief","rely","remain","remember","remind","remove","render","renew","rent","reopen","repair","repeat","replace","report","require","rescue","resemble","resist","resource","response","result","retire","retreat","return","reunion","reveal","review","reward","rhythm","rib","ribbon","rice","rich","ride","ridge","rifle","right","rigid","ring","riot","ripple","risk","ritual","rival","river","road","roast","robot","robust","rocket","romance","roof","rookie","room","rose","rotate","rough","round","route","royal","rubber","rude","rug","rule","run","runway","rural","sad","saddle","sadness","safe","sail","salad","salmon","salon","salt","salute","same","sample","sand","satisfy","satoshi","sauce","sausage","save","say","scale","scan","scare","scatter","scene","scheme","school","science","scissors","scorpion","scout","scrap","screen","script","scrub","sea","search","season","seat","second","secret","section","security","seed","seek","segment","select","sell","seminar","senior","sense","sentence","series","service","session","settle","setup","seven","shadow","shaft","shallow","share","shed","shell","sheriff","shield","shift","shine","ship","shiver","shock","shoe","shoot","shop","short","shoulder","shove","shrimp","shrug","shuffle","shy","sibling","sick","side","siege","sight","sign","silent","silk","silly","silver","similar","simple","since","sing","siren","sister","situate","six","size","skate","sketch","ski","skill","skin","skirt","skull","slab","slam","sleep","slender","slice","slide","slight","slim","slogan","slot","slow","slush","small","smart","smile","smoke","smooth","snack","snake","snap","sniff","snow","soap","soccer","social","sock","soda","soft","solar","soldier","solid","solution","solve","someone","song","soon","sorry","sort","soul","sound","soup","source","south","space","spare","spatial","spawn","speak","special","speed","spell","spend","sphere","spice","spider","spike","spin","spirit","split","spoil","sponsor","spoon","sport","spot","spray","spread","spring","spy","square","squeeze","squirrel","stable","stadium","staff","stage","stairs","stamp","stand","start","state","stay","steak","steel","stem","step","stereo","stick","still","sting","stock","stomach","stone","stool","story","stove","strategy","street","strike","strong","struggle","student","stuff","stumble","style","subject","submit","subway","success","such","sudden","suffer","sugar","suggest","suit","summer","sun","sunny","sunset","super","supply","supreme","sure","surface","surge","surprise","surround","survey","suspect","sustain","swallow","swamp","swap","swarm","swear","sweet","swift","swim","swing","switch","sword","symbol","symptom","syrup","system","table","tackle","tag","tail","talent","talk","tank","tape","target","task","taste","tattoo","taxi","teach","team","tell","ten","tenant","tennis","tent","term","test","text","thank","that","theme","then","theory","there","they","thing","this","thought","three","thrive","throw","thumb","thunder","ticket","tide","tiger","tilt","timber","time","tiny","tip","tired","tissue","title","toast","tobacco","today","toddler","toe","together","toilet","token","tomato","tomorrow","tone","tongue","tonight","tool","tooth","top","topic","topple","torch","tornado","tortoise","toss","total","tourist","toward","tower","town","toy","track","trade","traffic","tragic","train","transfer","trap","trash","travel","tray","treat","tree","trend","trial","tribe","trick","trigger","trim","trip","trophy","trouble","truck","true","truly","trumpet","trust","truth","try","tube","tuition","tumble","tuna","tunnel","turkey","turn","turtle","twelve","twenty","twice","twin","twist","two","type","typical","ugly","umbrella","unable","unaware","uncle","uncover","under","undo","unfair","unfold","unhappy","uniform","unique","unit","universe","unknown","unlock","until","unusual","unveil","update","upgrade","uphold","upon","upper","upset","urban","urge","usage","use","used","useful","useless","usual","utility","vacant","vacuum","vague","valid","valley","valve","van","vanish","vapor","various","vast","vault","vehicle","velvet","vendor","venture","venue","verb","verify","version","very","vessel","veteran","viable","vibrant","vicious","victory","video","view","village","vintage","violin","virtual","virus","visa","visit","visual","vital","vivid","vocal","voice","void","volcano","volume","vote","voyage","wage","wagon","wait","walk","wall","walnut","want","warfare","warm","warrior","wash","wasp","waste","water","wave","way","wealth","weapon","wear","weasel","weather","web","wedding","weekend","weird","welcome","west","wet","whale","what","wheat","wheel","when","where","whip","whisper","wide","width","wife","wild","will","win","window","wine","wing","wink","winner","winter","wire","wisdom","wise","wish","witness","wolf","woman","wonder","wood","wool","word","work","world","worry","worth","wrap","wreck","wrestle","wrist","write","wrong","yard","year","yellow","you","young","youth","zebra","zero","zone","zoo"]');

});



parcelRequire.register("dFkC5", function(module, exports) {

!function(e) {
    function r(e, r) {
        "use strict";
        var t, a = "uint8array", _ = r.ready.then(function() {
            function a() {
                if (0 !== t._sodium_init()) throw new Error("libsodium was not correctly initialized.");
                for(var r = [
                    "crypto_aead_aegis128l_decrypt",
                    "crypto_aead_aegis128l_decrypt_detached",
                    "crypto_aead_aegis128l_encrypt",
                    "crypto_aead_aegis128l_encrypt_detached",
                    "crypto_aead_aegis128l_keygen",
                    "crypto_aead_aegis256_decrypt",
                    "crypto_aead_aegis256_decrypt_detached",
                    "crypto_aead_aegis256_encrypt",
                    "crypto_aead_aegis256_encrypt_detached",
                    "crypto_aead_aegis256_keygen",
                    "crypto_aead_chacha20poly1305_decrypt",
                    "crypto_aead_chacha20poly1305_decrypt_detached",
                    "crypto_aead_chacha20poly1305_encrypt",
                    "crypto_aead_chacha20poly1305_encrypt_detached",
                    "crypto_aead_chacha20poly1305_ietf_decrypt",
                    "crypto_aead_chacha20poly1305_ietf_decrypt_detached",
                    "crypto_aead_chacha20poly1305_ietf_encrypt",
                    "crypto_aead_chacha20poly1305_ietf_encrypt_detached",
                    "crypto_aead_chacha20poly1305_ietf_keygen",
                    "crypto_aead_chacha20poly1305_keygen",
                    "crypto_aead_xchacha20poly1305_ietf_decrypt",
                    "crypto_aead_xchacha20poly1305_ietf_decrypt_detached",
                    "crypto_aead_xchacha20poly1305_ietf_encrypt",
                    "crypto_aead_xchacha20poly1305_ietf_encrypt_detached",
                    "crypto_aead_xchacha20poly1305_ietf_keygen",
                    "crypto_auth",
                    "crypto_auth_hmacsha256",
                    "crypto_auth_hmacsha256_final",
                    "crypto_auth_hmacsha256_init",
                    "crypto_auth_hmacsha256_keygen",
                    "crypto_auth_hmacsha256_update",
                    "crypto_auth_hmacsha256_verify",
                    "crypto_auth_hmacsha512",
                    "crypto_auth_hmacsha512_final",
                    "crypto_auth_hmacsha512_init",
                    "crypto_auth_hmacsha512_keygen",
                    "crypto_auth_hmacsha512_update",
                    "crypto_auth_hmacsha512_verify",
                    "crypto_auth_keygen",
                    "crypto_auth_verify",
                    "crypto_box_beforenm",
                    "crypto_box_curve25519xchacha20poly1305_beforenm",
                    "crypto_box_curve25519xchacha20poly1305_detached",
                    "crypto_box_curve25519xchacha20poly1305_detached_afternm",
                    "crypto_box_curve25519xchacha20poly1305_easy",
                    "crypto_box_curve25519xchacha20poly1305_easy_afternm",
                    "crypto_box_curve25519xchacha20poly1305_keypair",
                    "crypto_box_curve25519xchacha20poly1305_open_detached",
                    "crypto_box_curve25519xchacha20poly1305_open_detached_afternm",
                    "crypto_box_curve25519xchacha20poly1305_open_easy",
                    "crypto_box_curve25519xchacha20poly1305_open_easy_afternm",
                    "crypto_box_curve25519xchacha20poly1305_seal",
                    "crypto_box_curve25519xchacha20poly1305_seal_open",
                    "crypto_box_curve25519xchacha20poly1305_seed_keypair",
                    "crypto_box_detached",
                    "crypto_box_easy",
                    "crypto_box_easy_afternm",
                    "crypto_box_keypair",
                    "crypto_box_open_detached",
                    "crypto_box_open_easy",
                    "crypto_box_open_easy_afternm",
                    "crypto_box_seal",
                    "crypto_box_seal_open",
                    "crypto_box_seed_keypair",
                    "crypto_core_ed25519_add",
                    "crypto_core_ed25519_from_hash",
                    "crypto_core_ed25519_from_uniform",
                    "crypto_core_ed25519_is_valid_point",
                    "crypto_core_ed25519_random",
                    "crypto_core_ed25519_scalar_add",
                    "crypto_core_ed25519_scalar_complement",
                    "crypto_core_ed25519_scalar_invert",
                    "crypto_core_ed25519_scalar_mul",
                    "crypto_core_ed25519_scalar_negate",
                    "crypto_core_ed25519_scalar_random",
                    "crypto_core_ed25519_scalar_reduce",
                    "crypto_core_ed25519_scalar_sub",
                    "crypto_core_ed25519_sub",
                    "crypto_core_hchacha20",
                    "crypto_core_hsalsa20",
                    "crypto_core_ristretto255_add",
                    "crypto_core_ristretto255_from_hash",
                    "crypto_core_ristretto255_is_valid_point",
                    "crypto_core_ristretto255_random",
                    "crypto_core_ristretto255_scalar_add",
                    "crypto_core_ristretto255_scalar_complement",
                    "crypto_core_ristretto255_scalar_invert",
                    "crypto_core_ristretto255_scalar_mul",
                    "crypto_core_ristretto255_scalar_negate",
                    "crypto_core_ristretto255_scalar_random",
                    "crypto_core_ristretto255_scalar_reduce",
                    "crypto_core_ristretto255_scalar_sub",
                    "crypto_core_ristretto255_sub",
                    "crypto_generichash",
                    "crypto_generichash_blake2b_salt_personal",
                    "crypto_generichash_final",
                    "crypto_generichash_init",
                    "crypto_generichash_keygen",
                    "crypto_generichash_update",
                    "crypto_hash",
                    "crypto_hash_sha256",
                    "crypto_hash_sha256_final",
                    "crypto_hash_sha256_init",
                    "crypto_hash_sha256_update",
                    "crypto_hash_sha512",
                    "crypto_hash_sha512_final",
                    "crypto_hash_sha512_init",
                    "crypto_hash_sha512_update",
                    "crypto_kdf_derive_from_key",
                    "crypto_kdf_keygen",
                    "crypto_kx_client_session_keys",
                    "crypto_kx_keypair",
                    "crypto_kx_seed_keypair",
                    "crypto_kx_server_session_keys",
                    "crypto_onetimeauth",
                    "crypto_onetimeauth_final",
                    "crypto_onetimeauth_init",
                    "crypto_onetimeauth_keygen",
                    "crypto_onetimeauth_update",
                    "crypto_onetimeauth_verify",
                    "crypto_pwhash",
                    "crypto_pwhash_scryptsalsa208sha256",
                    "crypto_pwhash_scryptsalsa208sha256_ll",
                    "crypto_pwhash_scryptsalsa208sha256_str",
                    "crypto_pwhash_scryptsalsa208sha256_str_verify",
                    "crypto_pwhash_str",
                    "crypto_pwhash_str_needs_rehash",
                    "crypto_pwhash_str_verify",
                    "crypto_scalarmult",
                    "crypto_scalarmult_base",
                    "crypto_scalarmult_ed25519",
                    "crypto_scalarmult_ed25519_base",
                    "crypto_scalarmult_ed25519_base_noclamp",
                    "crypto_scalarmult_ed25519_noclamp",
                    "crypto_scalarmult_ristretto255",
                    "crypto_scalarmult_ristretto255_base",
                    "crypto_secretbox_detached",
                    "crypto_secretbox_easy",
                    "crypto_secretbox_keygen",
                    "crypto_secretbox_open_detached",
                    "crypto_secretbox_open_easy",
                    "crypto_secretstream_xchacha20poly1305_init_pull",
                    "crypto_secretstream_xchacha20poly1305_init_push",
                    "crypto_secretstream_xchacha20poly1305_keygen",
                    "crypto_secretstream_xchacha20poly1305_pull",
                    "crypto_secretstream_xchacha20poly1305_push",
                    "crypto_secretstream_xchacha20poly1305_rekey",
                    "crypto_shorthash",
                    "crypto_shorthash_keygen",
                    "crypto_shorthash_siphashx24",
                    "crypto_sign",
                    "crypto_sign_detached",
                    "crypto_sign_ed25519_pk_to_curve25519",
                    "crypto_sign_ed25519_sk_to_curve25519",
                    "crypto_sign_ed25519_sk_to_pk",
                    "crypto_sign_ed25519_sk_to_seed",
                    "crypto_sign_final_create",
                    "crypto_sign_final_verify",
                    "crypto_sign_init",
                    "crypto_sign_keypair",
                    "crypto_sign_open",
                    "crypto_sign_seed_keypair",
                    "crypto_sign_update",
                    "crypto_sign_verify_detached",
                    "crypto_stream_chacha20",
                    "crypto_stream_chacha20_ietf_xor",
                    "crypto_stream_chacha20_ietf_xor_ic",
                    "crypto_stream_chacha20_keygen",
                    "crypto_stream_chacha20_xor",
                    "crypto_stream_chacha20_xor_ic",
                    "crypto_stream_keygen",
                    "crypto_stream_xchacha20_keygen",
                    "crypto_stream_xchacha20_xor",
                    "crypto_stream_xchacha20_xor_ic",
                    "randombytes_buf",
                    "randombytes_buf_deterministic",
                    "randombytes_close",
                    "randombytes_random",
                    "randombytes_set_implementation",
                    "randombytes_stir",
                    "randombytes_uniform",
                    "sodium_version_string"
                ], a = [
                    E,
                    k,
                    S,
                    T,
                    w,
                    Y,
                    B,
                    A,
                    K,
                    M,
                    I,
                    N,
                    L,
                    U,
                    O,
                    C,
                    R,
                    P,
                    G,
                    X,
                    D,
                    F,
                    V,
                    H,
                    q,
                    j,
                    z,
                    W,
                    J,
                    Q,
                    Z,
                    $,
                    ee,
                    re,
                    te,
                    ae,
                    _e,
                    ne,
                    se,
                    ce,
                    oe,
                    he,
                    pe,
                    ye,
                    ie,
                    le,
                    ue,
                    de,
                    ve,
                    ge,
                    be,
                    fe,
                    me,
                    xe,
                    Ee,
                    ke,
                    Se,
                    Te,
                    we,
                    Ye,
                    Be,
                    Ae,
                    Ke,
                    Me,
                    Ie,
                    Ne,
                    Le,
                    Ue,
                    Oe,
                    Ce,
                    Re,
                    Pe,
                    Ge,
                    Xe,
                    De,
                    Fe,
                    Ve,
                    He,
                    qe,
                    je,
                    ze,
                    We,
                    Je,
                    Qe,
                    Ze,
                    $e,
                    er,
                    rr,
                    tr,
                    ar,
                    _r,
                    nr,
                    sr,
                    cr,
                    or,
                    hr,
                    pr,
                    yr,
                    ir,
                    lr,
                    ur,
                    dr,
                    vr,
                    gr,
                    br,
                    fr,
                    mr,
                    xr,
                    Er,
                    kr,
                    Sr,
                    Tr,
                    wr,
                    Yr,
                    Br,
                    Ar,
                    Kr,
                    Mr,
                    Ir,
                    Nr,
                    Lr,
                    Ur,
                    Or,
                    Cr,
                    Rr,
                    Pr,
                    Gr,
                    Xr,
                    Dr,
                    Fr,
                    Vr,
                    Hr,
                    qr,
                    jr,
                    zr,
                    Wr,
                    Jr,
                    Qr,
                    Zr,
                    $r,
                    et,
                    rt,
                    tt,
                    at,
                    _t,
                    nt,
                    st,
                    ct,
                    ot,
                    ht,
                    pt,
                    yt,
                    it,
                    lt,
                    ut,
                    dt,
                    vt,
                    gt,
                    bt,
                    ft,
                    mt,
                    xt,
                    Et,
                    kt,
                    St,
                    Tt,
                    wt,
                    Yt,
                    Bt,
                    At,
                    Kt,
                    Mt,
                    It,
                    Nt,
                    Lt,
                    Ut,
                    Ot,
                    Ct,
                    Rt,
                    Pt,
                    Gt,
                    Xt
                ], _ = 0; _ < a.length; _++)"function" == typeof t["_" + r[_]] && (e[r[_]] = a[_]);
                var n = [
                    "SODIUM_LIBRARY_VERSION_MAJOR",
                    "SODIUM_LIBRARY_VERSION_MINOR",
                    "crypto_aead_chacha20poly1305_ABYTES",
                    "crypto_aead_chacha20poly1305_IETF_ABYTES",
                    "crypto_aead_chacha20poly1305_IETF_KEYBYTES",
                    "crypto_aead_chacha20poly1305_IETF_MESSAGEBYTES_MAX",
                    "crypto_aead_chacha20poly1305_IETF_NPUBBYTES",
                    "crypto_aead_chacha20poly1305_IETF_NSECBYTES",
                    "crypto_aead_chacha20poly1305_KEYBYTES",
                    "crypto_aead_chacha20poly1305_MESSAGEBYTES_MAX",
                    "crypto_aead_chacha20poly1305_NPUBBYTES",
                    "crypto_aead_chacha20poly1305_NSECBYTES",
                    "crypto_aead_chacha20poly1305_ietf_ABYTES",
                    "crypto_aead_chacha20poly1305_ietf_KEYBYTES",
                    "crypto_aead_chacha20poly1305_ietf_MESSAGEBYTES_MAX",
                    "crypto_aead_chacha20poly1305_ietf_NPUBBYTES",
                    "crypto_aead_chacha20poly1305_ietf_NSECBYTES",
                    "crypto_aead_xchacha20poly1305_IETF_ABYTES",
                    "crypto_aead_xchacha20poly1305_IETF_KEYBYTES",
                    "crypto_aead_xchacha20poly1305_IETF_MESSAGEBYTES_MAX",
                    "crypto_aead_xchacha20poly1305_IETF_NPUBBYTES",
                    "crypto_aead_xchacha20poly1305_IETF_NSECBYTES",
                    "crypto_aead_xchacha20poly1305_ietf_ABYTES",
                    "crypto_aead_xchacha20poly1305_ietf_KEYBYTES",
                    "crypto_aead_xchacha20poly1305_ietf_MESSAGEBYTES_MAX",
                    "crypto_aead_xchacha20poly1305_ietf_NPUBBYTES",
                    "crypto_aead_xchacha20poly1305_ietf_NSECBYTES",
                    "crypto_auth_BYTES",
                    "crypto_auth_KEYBYTES",
                    "crypto_auth_hmacsha256_BYTES",
                    "crypto_auth_hmacsha256_KEYBYTES",
                    "crypto_auth_hmacsha512256_BYTES",
                    "crypto_auth_hmacsha512256_KEYBYTES",
                    "crypto_auth_hmacsha512_BYTES",
                    "crypto_auth_hmacsha512_KEYBYTES",
                    "crypto_box_BEFORENMBYTES",
                    "crypto_box_MACBYTES",
                    "crypto_box_MESSAGEBYTES_MAX",
                    "crypto_box_NONCEBYTES",
                    "crypto_box_PUBLICKEYBYTES",
                    "crypto_box_SEALBYTES",
                    "crypto_box_SECRETKEYBYTES",
                    "crypto_box_SEEDBYTES",
                    "crypto_box_curve25519xchacha20poly1305_BEFORENMBYTES",
                    "crypto_box_curve25519xchacha20poly1305_MACBYTES",
                    "crypto_box_curve25519xchacha20poly1305_MESSAGEBYTES_MAX",
                    "crypto_box_curve25519xchacha20poly1305_NONCEBYTES",
                    "crypto_box_curve25519xchacha20poly1305_PUBLICKEYBYTES",
                    "crypto_box_curve25519xchacha20poly1305_SEALBYTES",
                    "crypto_box_curve25519xchacha20poly1305_SECRETKEYBYTES",
                    "crypto_box_curve25519xchacha20poly1305_SEEDBYTES",
                    "crypto_box_curve25519xsalsa20poly1305_BEFORENMBYTES",
                    "crypto_box_curve25519xsalsa20poly1305_MACBYTES",
                    "crypto_box_curve25519xsalsa20poly1305_MESSAGEBYTES_MAX",
                    "crypto_box_curve25519xsalsa20poly1305_NONCEBYTES",
                    "crypto_box_curve25519xsalsa20poly1305_PUBLICKEYBYTES",
                    "crypto_box_curve25519xsalsa20poly1305_SECRETKEYBYTES",
                    "crypto_box_curve25519xsalsa20poly1305_SEEDBYTES",
                    "crypto_core_ed25519_BYTES",
                    "crypto_core_ed25519_HASHBYTES",
                    "crypto_core_ed25519_NONREDUCEDSCALARBYTES",
                    "crypto_core_ed25519_SCALARBYTES",
                    "crypto_core_ed25519_UNIFORMBYTES",
                    "crypto_core_hchacha20_CONSTBYTES",
                    "crypto_core_hchacha20_INPUTBYTES",
                    "crypto_core_hchacha20_KEYBYTES",
                    "crypto_core_hchacha20_OUTPUTBYTES",
                    "crypto_core_hsalsa20_CONSTBYTES",
                    "crypto_core_hsalsa20_INPUTBYTES",
                    "crypto_core_hsalsa20_KEYBYTES",
                    "crypto_core_hsalsa20_OUTPUTBYTES",
                    "crypto_core_ristretto255_BYTES",
                    "crypto_core_ristretto255_HASHBYTES",
                    "crypto_core_ristretto255_NONREDUCEDSCALARBYTES",
                    "crypto_core_ristretto255_SCALARBYTES",
                    "crypto_core_salsa2012_CONSTBYTES",
                    "crypto_core_salsa2012_INPUTBYTES",
                    "crypto_core_salsa2012_KEYBYTES",
                    "crypto_core_salsa2012_OUTPUTBYTES",
                    "crypto_core_salsa20_CONSTBYTES",
                    "crypto_core_salsa20_INPUTBYTES",
                    "crypto_core_salsa20_KEYBYTES",
                    "crypto_core_salsa20_OUTPUTBYTES",
                    "crypto_generichash_BYTES",
                    "crypto_generichash_BYTES_MAX",
                    "crypto_generichash_BYTES_MIN",
                    "crypto_generichash_KEYBYTES",
                    "crypto_generichash_KEYBYTES_MAX",
                    "crypto_generichash_KEYBYTES_MIN",
                    "crypto_generichash_blake2b_BYTES",
                    "crypto_generichash_blake2b_BYTES_MAX",
                    "crypto_generichash_blake2b_BYTES_MIN",
                    "crypto_generichash_blake2b_KEYBYTES",
                    "crypto_generichash_blake2b_KEYBYTES_MAX",
                    "crypto_generichash_blake2b_KEYBYTES_MIN",
                    "crypto_generichash_blake2b_PERSONALBYTES",
                    "crypto_generichash_blake2b_SALTBYTES",
                    "crypto_hash_BYTES",
                    "crypto_hash_sha256_BYTES",
                    "crypto_hash_sha512_BYTES",
                    "crypto_kdf_BYTES_MAX",
                    "crypto_kdf_BYTES_MIN",
                    "crypto_kdf_CONTEXTBYTES",
                    "crypto_kdf_KEYBYTES",
                    "crypto_kdf_blake2b_BYTES_MAX",
                    "crypto_kdf_blake2b_BYTES_MIN",
                    "crypto_kdf_blake2b_CONTEXTBYTES",
                    "crypto_kdf_blake2b_KEYBYTES",
                    "crypto_kx_PUBLICKEYBYTES",
                    "crypto_kx_SECRETKEYBYTES",
                    "crypto_kx_SEEDBYTES",
                    "crypto_kx_SESSIONKEYBYTES",
                    "crypto_onetimeauth_BYTES",
                    "crypto_onetimeauth_KEYBYTES",
                    "crypto_onetimeauth_poly1305_BYTES",
                    "crypto_onetimeauth_poly1305_KEYBYTES",
                    "crypto_pwhash_ALG_ARGON2I13",
                    "crypto_pwhash_ALG_ARGON2ID13",
                    "crypto_pwhash_ALG_DEFAULT",
                    "crypto_pwhash_BYTES_MAX",
                    "crypto_pwhash_BYTES_MIN",
                    "crypto_pwhash_MEMLIMIT_INTERACTIVE",
                    "crypto_pwhash_MEMLIMIT_MAX",
                    "crypto_pwhash_MEMLIMIT_MIN",
                    "crypto_pwhash_MEMLIMIT_MODERATE",
                    "crypto_pwhash_MEMLIMIT_SENSITIVE",
                    "crypto_pwhash_OPSLIMIT_INTERACTIVE",
                    "crypto_pwhash_OPSLIMIT_MAX",
                    "crypto_pwhash_OPSLIMIT_MIN",
                    "crypto_pwhash_OPSLIMIT_MODERATE",
                    "crypto_pwhash_OPSLIMIT_SENSITIVE",
                    "crypto_pwhash_PASSWD_MAX",
                    "crypto_pwhash_PASSWD_MIN",
                    "crypto_pwhash_SALTBYTES",
                    "crypto_pwhash_STRBYTES",
                    "crypto_pwhash_argon2i_BYTES_MAX",
                    "crypto_pwhash_argon2i_BYTES_MIN",
                    "crypto_pwhash_argon2i_SALTBYTES",
                    "crypto_pwhash_argon2i_STRBYTES",
                    "crypto_pwhash_argon2id_BYTES_MAX",
                    "crypto_pwhash_argon2id_BYTES_MIN",
                    "crypto_pwhash_argon2id_SALTBYTES",
                    "crypto_pwhash_argon2id_STRBYTES",
                    "crypto_pwhash_scryptsalsa208sha256_BYTES_MAX",
                    "crypto_pwhash_scryptsalsa208sha256_BYTES_MIN",
                    "crypto_pwhash_scryptsalsa208sha256_MEMLIMIT_INTERACTIVE",
                    "crypto_pwhash_scryptsalsa208sha256_MEMLIMIT_MAX",
                    "crypto_pwhash_scryptsalsa208sha256_MEMLIMIT_MIN",
                    "crypto_pwhash_scryptsalsa208sha256_MEMLIMIT_SENSITIVE",
                    "crypto_pwhash_scryptsalsa208sha256_OPSLIMIT_INTERACTIVE",
                    "crypto_pwhash_scryptsalsa208sha256_OPSLIMIT_MAX",
                    "crypto_pwhash_scryptsalsa208sha256_OPSLIMIT_MIN",
                    "crypto_pwhash_scryptsalsa208sha256_OPSLIMIT_SENSITIVE",
                    "crypto_pwhash_scryptsalsa208sha256_SALTBYTES",
                    "crypto_pwhash_scryptsalsa208sha256_STRBYTES",
                    "crypto_scalarmult_BYTES",
                    "crypto_scalarmult_SCALARBYTES",
                    "crypto_scalarmult_curve25519_BYTES",
                    "crypto_scalarmult_curve25519_SCALARBYTES",
                    "crypto_scalarmult_ed25519_BYTES",
                    "crypto_scalarmult_ed25519_SCALARBYTES",
                    "crypto_scalarmult_ristretto255_BYTES",
                    "crypto_scalarmult_ristretto255_SCALARBYTES",
                    "crypto_secretbox_KEYBYTES",
                    "crypto_secretbox_MACBYTES",
                    "crypto_secretbox_MESSAGEBYTES_MAX",
                    "crypto_secretbox_NONCEBYTES",
                    "crypto_secretbox_xchacha20poly1305_KEYBYTES",
                    "crypto_secretbox_xchacha20poly1305_MACBYTES",
                    "crypto_secretbox_xchacha20poly1305_MESSAGEBYTES_MAX",
                    "crypto_secretbox_xchacha20poly1305_NONCEBYTES",
                    "crypto_secretbox_xsalsa20poly1305_KEYBYTES",
                    "crypto_secretbox_xsalsa20poly1305_MACBYTES",
                    "crypto_secretbox_xsalsa20poly1305_MESSAGEBYTES_MAX",
                    "crypto_secretbox_xsalsa20poly1305_NONCEBYTES",
                    "crypto_secretstream_xchacha20poly1305_ABYTES",
                    "crypto_secretstream_xchacha20poly1305_HEADERBYTES",
                    "crypto_secretstream_xchacha20poly1305_KEYBYTES",
                    "crypto_secretstream_xchacha20poly1305_MESSAGEBYTES_MAX",
                    "crypto_secretstream_xchacha20poly1305_TAG_FINAL",
                    "crypto_secretstream_xchacha20poly1305_TAG_MESSAGE",
                    "crypto_secretstream_xchacha20poly1305_TAG_PUSH",
                    "crypto_secretstream_xchacha20poly1305_TAG_REKEY",
                    "crypto_shorthash_BYTES",
                    "crypto_shorthash_KEYBYTES",
                    "crypto_shorthash_siphash24_BYTES",
                    "crypto_shorthash_siphash24_KEYBYTES",
                    "crypto_shorthash_siphashx24_BYTES",
                    "crypto_shorthash_siphashx24_KEYBYTES",
                    "crypto_sign_BYTES",
                    "crypto_sign_MESSAGEBYTES_MAX",
                    "crypto_sign_PUBLICKEYBYTES",
                    "crypto_sign_SECRETKEYBYTES",
                    "crypto_sign_SEEDBYTES",
                    "crypto_sign_ed25519_BYTES",
                    "crypto_sign_ed25519_MESSAGEBYTES_MAX",
                    "crypto_sign_ed25519_PUBLICKEYBYTES",
                    "crypto_sign_ed25519_SECRETKEYBYTES",
                    "crypto_sign_ed25519_SEEDBYTES",
                    "crypto_stream_KEYBYTES",
                    "crypto_stream_MESSAGEBYTES_MAX",
                    "crypto_stream_NONCEBYTES",
                    "crypto_stream_chacha20_IETF_KEYBYTES",
                    "crypto_stream_chacha20_IETF_MESSAGEBYTES_MAX",
                    "crypto_stream_chacha20_IETF_NONCEBYTES",
                    "crypto_stream_chacha20_KEYBYTES",
                    "crypto_stream_chacha20_MESSAGEBYTES_MAX",
                    "crypto_stream_chacha20_NONCEBYTES",
                    "crypto_stream_chacha20_ietf_KEYBYTES",
                    "crypto_stream_chacha20_ietf_MESSAGEBYTES_MAX",
                    "crypto_stream_chacha20_ietf_NONCEBYTES",
                    "crypto_stream_salsa2012_KEYBYTES",
                    "crypto_stream_salsa2012_MESSAGEBYTES_MAX",
                    "crypto_stream_salsa2012_NONCEBYTES",
                    "crypto_stream_salsa208_KEYBYTES",
                    "crypto_stream_salsa208_MESSAGEBYTES_MAX",
                    "crypto_stream_salsa208_NONCEBYTES",
                    "crypto_stream_salsa20_KEYBYTES",
                    "crypto_stream_salsa20_MESSAGEBYTES_MAX",
                    "crypto_stream_salsa20_NONCEBYTES",
                    "crypto_stream_xchacha20_KEYBYTES",
                    "crypto_stream_xchacha20_MESSAGEBYTES_MAX",
                    "crypto_stream_xchacha20_NONCEBYTES",
                    "crypto_stream_xsalsa20_KEYBYTES",
                    "crypto_stream_xsalsa20_MESSAGEBYTES_MAX",
                    "crypto_stream_xsalsa20_NONCEBYTES",
                    "crypto_verify_16_BYTES",
                    "crypto_verify_32_BYTES",
                    "crypto_verify_64_BYTES"
                ];
                for(_ = 0; _ < n.length; _++)"function" == typeof (c = t["_" + n[_].toLowerCase()]) && (e[n[_]] = c());
                var s = [
                    "SODIUM_VERSION_STRING",
                    "crypto_pwhash_STRPREFIX",
                    "crypto_pwhash_scryptsalsa208sha256_STRPREFIX"
                ];
                for(_ = 0; _ < s.length; _++){
                    var c;
                    "function" == typeof (c = t["_" + s[_].toLowerCase()]) && (e[s[_]] = t.UTF8ToString(c()));
                }
            }
            t = r;
            try {
                a();
                var _ = new Uint8Array([
                    98,
                    97,
                    108,
                    108,
                    115
                ]), n = e.randombytes_buf(e.crypto_secretbox_NONCEBYTES), s = e.randombytes_buf(e.crypto_secretbox_KEYBYTES), c = e.crypto_secretbox_easy(_, n, s), o = e.crypto_secretbox_open_easy(c, n, s);
                if (e.memcmp(_, o)) return;
            } catch (e) {
                if (null == t.useBackupModule) throw new Error("Both wasm and asm failed to load" + e);
            }
            t.useBackupModule(), a();
        });
        function n(e) {
            if ("function" == typeof TextEncoder) return (new TextEncoder).encode(e);
            e = unescape(encodeURIComponent(e));
            for(var r = new Uint8Array(e.length), t = 0, a = e.length; t < a; t++)r[t] = e.charCodeAt(t);
            return r;
        }
        function s(e) {
            if ("function" == typeof TextDecoder) return new TextDecoder("utf-8", {
                fatal: !0
            }).decode(e);
            var r = 8192, t = Math.ceil(e.length / r);
            if (t <= 1) try {
                return decodeURIComponent(escape(String.fromCharCode.apply(null, e)));
            } catch (e) {
                throw new TypeError("The encoded data was not valid.");
            }
            for(var a = "", _ = 0, n = 0; n < t; n++){
                var c = Array.prototype.slice.call(e, n * r + _, (n + 1) * r + _);
                if (0 != c.length) {
                    var o, h = c.length, p = 0;
                    do {
                        var y = c[--h];
                        y >= 240 ? (p = 4, o = !0) : y >= 224 ? (p = 3, o = !0) : y >= 192 ? (p = 2, o = !0) : y < 128 && (p = 1, o = !0);
                    }while (!o);
                    for(var i = p - (c.length - h), l = 0; l < i; l++)_--, c.pop();
                    a += s(c);
                }
            }
            return a;
        }
        function c(e) {
            e = x(null, e, "input");
            for(var r, t, a, _ = "", n = 0; n < e.length; n++)a = 87 + (t = 15 & e[n]) + (t - 10 >> 8 & -39) << 8 | 87 + (r = e[n] >>> 4) + (r - 10 >> 8 & -39), _ += String.fromCharCode(255 & a) + String.fromCharCode(a >>> 8);
            return _;
        }
        var o = {
            ORIGINAL: 1,
            ORIGINAL_NO_PADDING: 3,
            URLSAFE: 5,
            URLSAFE_NO_PADDING: 7
        };
        function h(e) {
            if (null == e) return o.URLSAFE_NO_PADDING;
            if (e !== o.ORIGINAL && e !== o.ORIGINAL_NO_PADDING && e !== o.URLSAFE && e != o.URLSAFE_NO_PADDING) throw new Error("unsupported base64 variant");
            return e;
        }
        function p(e, r) {
            r = h(r), e = x(_, e, "input");
            var a, _ = [], n = 0 | Math.floor(e.length / 3), c = e.length - 3 * n, o = 4 * n + (0 !== c ? 0 == (2 & r) ? 4 : 2 + (c >>> 1) : 0), p = new u(o + 1), y = d(e);
            return _.push(y), _.push(p.address), 0 === t._sodium_bin2base64(p.address, p.length, y, e.length, r) && b(_, "conversion failed"), p.length = o, a = s(p.to_Uint8Array()), g(_), a;
        }
        function y(e, r) {
            var t = r || a;
            if (!i(t)) throw new Error(t + " output format is not available");
            if (e instanceof u) {
                if ("uint8array" === t) return e.to_Uint8Array();
                if ("text" === t) return s(e.to_Uint8Array());
                if ("hex" === t) return c(e.to_Uint8Array());
                if ("base64" === t) return p(e.to_Uint8Array(), o.URLSAFE_NO_PADDING);
                throw new Error('What is output format "' + t + '"?');
            }
            if ("object" == typeof e) {
                for(var _ = Object.keys(e), n = {}, h = 0; h < _.length; h++)n[_[h]] = y(e[_[h]], t);
                return n;
            }
            if ("string" == typeof e) return e;
            throw new TypeError("Cannot format output");
        }
        function i(e) {
            for(var r = [
                "uint8array",
                "text",
                "hex",
                "base64"
            ], t = 0; t < r.length; t++)if (r[t] === e) return !0;
            return !1;
        }
        function l(e) {
            if (e) {
                if ("string" != typeof e) throw new TypeError("When defined, the output format must be a string");
                if (!i(e)) throw new Error(e + " is not a supported output format");
            }
        }
        function u(e) {
            this.length = e, this.address = v(e);
        }
        function d(e) {
            var r = v(e.length);
            return t.HEAPU8.set(e, r), r;
        }
        function v(e) {
            var r = t._malloc(e);
            if (0 === r) throw {
                message: "_malloc() failed",
                length: e
            };
            return r;
        }
        function g(e) {
            if (e) for(var r = 0; r < e.length; r++)a = e[r], t._free(a);
            var a;
        }
        function b(e, r) {
            throw g(e), new Error(r);
        }
        function f(e, r) {
            throw g(e), new TypeError(r);
        }
        function m(e, r, t) {
            null == r && f(e, t + " cannot be null or undefined");
        }
        function x(e, r, t) {
            return m(e, r, t), r instanceof Uint8Array ? r : "string" == typeof r ? n(r) : void f(e, "unsupported input type for " + t);
        }
        function E(e, r, a, _, n, s) {
            var c = [];
            l(s);
            var o = null;
            null != e && (o = d(e = x(c, e, "secret_nonce")), e.length, c.push(o)), r = x(c, r, "ciphertext");
            var h, p = t._crypto_aead_aegis128l_abytes(), i = r.length;
            i < p && f(c, "ciphertext is too short"), h = d(r), c.push(h);
            var v = null, m = 0;
            null != a && (v = d(a = x(c, a, "additional_data")), m = a.length, c.push(v)), _ = x(c, _, "public_nonce");
            var E, k = 0 | t._crypto_aead_aegis128l_npubbytes();
            _.length !== k && f(c, "invalid public_nonce length"), E = d(_), c.push(E), n = x(c, n, "key");
            var S, T = 0 | t._crypto_aead_aegis128l_keybytes();
            n.length !== T && f(c, "invalid key length"), S = d(n), c.push(S);
            var w = new u(i - t._crypto_aead_aegis128l_abytes() | 0), Y = w.address;
            if (c.push(Y), 0 === t._crypto_aead_aegis128l_decrypt(Y, null, o, h, i, 0, v, m, 0, E, S)) {
                var B = y(w, s);
                return g(c), B;
            }
            b(c, "ciphertext cannot be decrypted using that key");
        }
        function k(e, r, a, _, n, s, c) {
            var o = [];
            l(c);
            var h = null;
            null != e && (h = d(e = x(o, e, "secret_nonce")), e.length, o.push(h));
            var p = d(r = x(o, r, "ciphertext")), i = r.length;
            o.push(p), a = x(o, a, "mac");
            var v, m = 0 | t._crypto_box_macbytes();
            a.length !== m && f(o, "invalid mac length"), v = d(a), o.push(v);
            var E = null, k = 0;
            null != _ && (E = d(_ = x(o, _, "additional_data")), k = _.length, o.push(E)), n = x(o, n, "public_nonce");
            var S, T = 0 | t._crypto_aead_aegis128l_npubbytes();
            n.length !== T && f(o, "invalid public_nonce length"), S = d(n), o.push(S), s = x(o, s, "key");
            var w, Y = 0 | t._crypto_aead_aegis128l_keybytes();
            s.length !== Y && f(o, "invalid key length"), w = d(s), o.push(w);
            var B = new u(0 | i), A = B.address;
            if (o.push(A), 0 === t._crypto_aead_aegis128l_decrypt_detached(A, h, p, i, 0, v, E, k, 0, S, w)) {
                var K = y(B, c);
                return g(o), K;
            }
            b(o, "ciphertext cannot be decrypted using that key");
        }
        function S(e, r, a, _, n, s) {
            var c = [];
            l(s);
            var o = d(e = x(c, e, "message")), h = e.length;
            c.push(o);
            var p = null, i = 0;
            null != r && (p = d(r = x(c, r, "additional_data")), i = r.length, c.push(p));
            var v = null;
            null != a && (v = d(a = x(c, a, "secret_nonce")), a.length, c.push(v)), _ = x(c, _, "public_nonce");
            var m, E = 0 | t._crypto_aead_aegis128l_npubbytes();
            _.length !== E && f(c, "invalid public_nonce length"), m = d(_), c.push(m), n = x(c, n, "key");
            var k, S = 0 | t._crypto_aead_aegis128l_keybytes();
            n.length !== S && f(c, "invalid key length"), k = d(n), c.push(k);
            var T = new u(h + t._crypto_aead_aegis128l_abytes() | 0), w = T.address;
            if (c.push(w), 0 === t._crypto_aead_aegis128l_encrypt(w, null, o, h, 0, p, i, 0, v, m, k)) {
                var Y = y(T, s);
                return g(c), Y;
            }
            b(c, "invalid usage");
        }
        function T(e, r, a, _, n, s) {
            var c = [];
            l(s);
            var o = d(e = x(c, e, "message")), h = e.length;
            c.push(o);
            var p = null, i = 0;
            null != r && (p = d(r = x(c, r, "additional_data")), i = r.length, c.push(p));
            var v = null;
            null != a && (v = d(a = x(c, a, "secret_nonce")), a.length, c.push(v)), _ = x(c, _, "public_nonce");
            var m, E = 0 | t._crypto_aead_aegis128l_npubbytes();
            _.length !== E && f(c, "invalid public_nonce length"), m = d(_), c.push(m), n = x(c, n, "key");
            var k, S = 0 | t._crypto_aead_aegis128l_keybytes();
            n.length !== S && f(c, "invalid key length"), k = d(n), c.push(k);
            var T = new u(0 | h), w = T.address;
            c.push(w);
            var Y = new u(0 | t._crypto_aead_aegis128l_abytes()), B = Y.address;
            if (c.push(B), 0 === t._crypto_aead_aegis128l_encrypt_detached(w, B, null, o, h, 0, p, i, 0, v, m, k)) {
                var A = y({
                    ciphertext: T,
                    mac: Y
                }, s);
                return g(c), A;
            }
            b(c, "invalid usage");
        }
        function w(e) {
            var r = [];
            l(e);
            var a = new u(0 | t._crypto_aead_aegis128l_keybytes()), _ = a.address;
            r.push(_), t._crypto_aead_aegis128l_keygen(_);
            var n = y(a, e);
            return g(r), n;
        }
        function Y(e, r, a, _, n, s) {
            var c = [];
            l(s);
            var o = null;
            null != e && (o = d(e = x(c, e, "secret_nonce")), e.length, c.push(o)), r = x(c, r, "ciphertext");
            var h, p = t._crypto_aead_aegis256_abytes(), i = r.length;
            i < p && f(c, "ciphertext is too short"), h = d(r), c.push(h);
            var v = null, m = 0;
            null != a && (v = d(a = x(c, a, "additional_data")), m = a.length, c.push(v)), _ = x(c, _, "public_nonce");
            var E, k = 0 | t._crypto_aead_aegis256_npubbytes();
            _.length !== k && f(c, "invalid public_nonce length"), E = d(_), c.push(E), n = x(c, n, "key");
            var S, T = 0 | t._crypto_aead_aegis256_keybytes();
            n.length !== T && f(c, "invalid key length"), S = d(n), c.push(S);
            var w = new u(i - t._crypto_aead_aegis256_abytes() | 0), Y = w.address;
            if (c.push(Y), 0 === t._crypto_aead_aegis256_decrypt(Y, null, o, h, i, 0, v, m, 0, E, S)) {
                var B = y(w, s);
                return g(c), B;
            }
            b(c, "ciphertext cannot be decrypted using that key");
        }
        function B(e, r, a, _, n, s, c) {
            var o = [];
            l(c);
            var h = null;
            null != e && (h = d(e = x(o, e, "secret_nonce")), e.length, o.push(h));
            var p = d(r = x(o, r, "ciphertext")), i = r.length;
            o.push(p), a = x(o, a, "mac");
            var v, m = 0 | t._crypto_box_macbytes();
            a.length !== m && f(o, "invalid mac length"), v = d(a), o.push(v);
            var E = null, k = 0;
            null != _ && (E = d(_ = x(o, _, "additional_data")), k = _.length, o.push(E)), n = x(o, n, "public_nonce");
            var S, T = 0 | t._crypto_aead_aegis256_npubbytes();
            n.length !== T && f(o, "invalid public_nonce length"), S = d(n), o.push(S), s = x(o, s, "key");
            var w, Y = 0 | t._crypto_aead_aegis256_keybytes();
            s.length !== Y && f(o, "invalid key length"), w = d(s), o.push(w);
            var B = new u(0 | i), A = B.address;
            if (o.push(A), 0 === t._crypto_aead_aegis256_decrypt_detached(A, h, p, i, 0, v, E, k, 0, S, w)) {
                var K = y(B, c);
                return g(o), K;
            }
            b(o, "ciphertext cannot be decrypted using that key");
        }
        function A(e, r, a, _, n, s) {
            var c = [];
            l(s);
            var o = d(e = x(c, e, "message")), h = e.length;
            c.push(o);
            var p = null, i = 0;
            null != r && (p = d(r = x(c, r, "additional_data")), i = r.length, c.push(p));
            var v = null;
            null != a && (v = d(a = x(c, a, "secret_nonce")), a.length, c.push(v)), _ = x(c, _, "public_nonce");
            var m, E = 0 | t._crypto_aead_aegis256_npubbytes();
            _.length !== E && f(c, "invalid public_nonce length"), m = d(_), c.push(m), n = x(c, n, "key");
            var k, S = 0 | t._crypto_aead_aegis256_keybytes();
            n.length !== S && f(c, "invalid key length"), k = d(n), c.push(k);
            var T = new u(h + t._crypto_aead_aegis256_abytes() | 0), w = T.address;
            if (c.push(w), 0 === t._crypto_aead_aegis256_encrypt(w, null, o, h, 0, p, i, 0, v, m, k)) {
                var Y = y(T, s);
                return g(c), Y;
            }
            b(c, "invalid usage");
        }
        function K(e, r, a, _, n, s) {
            var c = [];
            l(s);
            var o = d(e = x(c, e, "message")), h = e.length;
            c.push(o);
            var p = null, i = 0;
            null != r && (p = d(r = x(c, r, "additional_data")), i = r.length, c.push(p));
            var v = null;
            null != a && (v = d(a = x(c, a, "secret_nonce")), a.length, c.push(v)), _ = x(c, _, "public_nonce");
            var m, E = 0 | t._crypto_aead_aegis256_npubbytes();
            _.length !== E && f(c, "invalid public_nonce length"), m = d(_), c.push(m), n = x(c, n, "key");
            var k, S = 0 | t._crypto_aead_aegis256_keybytes();
            n.length !== S && f(c, "invalid key length"), k = d(n), c.push(k);
            var T = new u(0 | h), w = T.address;
            c.push(w);
            var Y = new u(0 | t._crypto_aead_aegis256_abytes()), B = Y.address;
            if (c.push(B), 0 === t._crypto_aead_aegis256_encrypt_detached(w, B, null, o, h, 0, p, i, 0, v, m, k)) {
                var A = y({
                    ciphertext: T,
                    mac: Y
                }, s);
                return g(c), A;
            }
            b(c, "invalid usage");
        }
        function M(e) {
            var r = [];
            l(e);
            var a = new u(0 | t._crypto_aead_aegis256_keybytes()), _ = a.address;
            r.push(_), t._crypto_aead_aegis256_keygen(_);
            var n = y(a, e);
            return g(r), n;
        }
        function I(e, r, a, _, n, s) {
            var c = [];
            l(s);
            var o = null;
            null != e && (o = d(e = x(c, e, "secret_nonce")), e.length, c.push(o)), r = x(c, r, "ciphertext");
            var h, p = t._crypto_aead_chacha20poly1305_abytes(), i = r.length;
            i < p && f(c, "ciphertext is too short"), h = d(r), c.push(h);
            var v = null, m = 0;
            null != a && (v = d(a = x(c, a, "additional_data")), m = a.length, c.push(v)), _ = x(c, _, "public_nonce");
            var E, k = 0 | t._crypto_aead_chacha20poly1305_npubbytes();
            _.length !== k && f(c, "invalid public_nonce length"), E = d(_), c.push(E), n = x(c, n, "key");
            var S, T = 0 | t._crypto_aead_chacha20poly1305_keybytes();
            n.length !== T && f(c, "invalid key length"), S = d(n), c.push(S);
            var w = new u(i - t._crypto_aead_chacha20poly1305_abytes() | 0), Y = w.address;
            if (c.push(Y), 0 === t._crypto_aead_chacha20poly1305_decrypt(Y, null, o, h, i, 0, v, m, 0, E, S)) {
                var B = y(w, s);
                return g(c), B;
            }
            b(c, "ciphertext cannot be decrypted using that key");
        }
        function N(e, r, a, _, n, s, c) {
            var o = [];
            l(c);
            var h = null;
            null != e && (h = d(e = x(o, e, "secret_nonce")), e.length, o.push(h));
            var p = d(r = x(o, r, "ciphertext")), i = r.length;
            o.push(p), a = x(o, a, "mac");
            var v, m = 0 | t._crypto_box_macbytes();
            a.length !== m && f(o, "invalid mac length"), v = d(a), o.push(v);
            var E = null, k = 0;
            null != _ && (E = d(_ = x(o, _, "additional_data")), k = _.length, o.push(E)), n = x(o, n, "public_nonce");
            var S, T = 0 | t._crypto_aead_chacha20poly1305_npubbytes();
            n.length !== T && f(o, "invalid public_nonce length"), S = d(n), o.push(S), s = x(o, s, "key");
            var w, Y = 0 | t._crypto_aead_chacha20poly1305_keybytes();
            s.length !== Y && f(o, "invalid key length"), w = d(s), o.push(w);
            var B = new u(0 | i), A = B.address;
            if (o.push(A), 0 === t._crypto_aead_chacha20poly1305_decrypt_detached(A, h, p, i, 0, v, E, k, 0, S, w)) {
                var K = y(B, c);
                return g(o), K;
            }
            b(o, "ciphertext cannot be decrypted using that key");
        }
        function L(e, r, a, _, n, s) {
            var c = [];
            l(s);
            var o = d(e = x(c, e, "message")), h = e.length;
            c.push(o);
            var p = null, i = 0;
            null != r && (p = d(r = x(c, r, "additional_data")), i = r.length, c.push(p));
            var v = null;
            null != a && (v = d(a = x(c, a, "secret_nonce")), a.length, c.push(v)), _ = x(c, _, "public_nonce");
            var m, E = 0 | t._crypto_aead_chacha20poly1305_npubbytes();
            _.length !== E && f(c, "invalid public_nonce length"), m = d(_), c.push(m), n = x(c, n, "key");
            var k, S = 0 | t._crypto_aead_chacha20poly1305_keybytes();
            n.length !== S && f(c, "invalid key length"), k = d(n), c.push(k);
            var T = new u(h + t._crypto_aead_chacha20poly1305_abytes() | 0), w = T.address;
            if (c.push(w), 0 === t._crypto_aead_chacha20poly1305_encrypt(w, null, o, h, 0, p, i, 0, v, m, k)) {
                var Y = y(T, s);
                return g(c), Y;
            }
            b(c, "invalid usage");
        }
        function U(e, r, a, _, n, s) {
            var c = [];
            l(s);
            var o = d(e = x(c, e, "message")), h = e.length;
            c.push(o);
            var p = null, i = 0;
            null != r && (p = d(r = x(c, r, "additional_data")), i = r.length, c.push(p));
            var v = null;
            null != a && (v = d(a = x(c, a, "secret_nonce")), a.length, c.push(v)), _ = x(c, _, "public_nonce");
            var m, E = 0 | t._crypto_aead_chacha20poly1305_npubbytes();
            _.length !== E && f(c, "invalid public_nonce length"), m = d(_), c.push(m), n = x(c, n, "key");
            var k, S = 0 | t._crypto_aead_chacha20poly1305_keybytes();
            n.length !== S && f(c, "invalid key length"), k = d(n), c.push(k);
            var T = new u(0 | h), w = T.address;
            c.push(w);
            var Y = new u(0 | t._crypto_aead_chacha20poly1305_abytes()), B = Y.address;
            if (c.push(B), 0 === t._crypto_aead_chacha20poly1305_encrypt_detached(w, B, null, o, h, 0, p, i, 0, v, m, k)) {
                var A = y({
                    ciphertext: T,
                    mac: Y
                }, s);
                return g(c), A;
            }
            b(c, "invalid usage");
        }
        function O(e, r, a, _, n, s) {
            var c = [];
            l(s);
            var o = null;
            null != e && (o = d(e = x(c, e, "secret_nonce")), e.length, c.push(o)), r = x(c, r, "ciphertext");
            var h, p = t._crypto_aead_chacha20poly1305_ietf_abytes(), i = r.length;
            i < p && f(c, "ciphertext is too short"), h = d(r), c.push(h);
            var v = null, m = 0;
            null != a && (v = d(a = x(c, a, "additional_data")), m = a.length, c.push(v)), _ = x(c, _, "public_nonce");
            var E, k = 0 | t._crypto_aead_chacha20poly1305_ietf_npubbytes();
            _.length !== k && f(c, "invalid public_nonce length"), E = d(_), c.push(E), n = x(c, n, "key");
            var S, T = 0 | t._crypto_aead_chacha20poly1305_ietf_keybytes();
            n.length !== T && f(c, "invalid key length"), S = d(n), c.push(S);
            var w = new u(i - t._crypto_aead_chacha20poly1305_ietf_abytes() | 0), Y = w.address;
            if (c.push(Y), 0 === t._crypto_aead_chacha20poly1305_ietf_decrypt(Y, null, o, h, i, 0, v, m, 0, E, S)) {
                var B = y(w, s);
                return g(c), B;
            }
            b(c, "ciphertext cannot be decrypted using that key");
        }
        function C(e, r, a, _, n, s, c) {
            var o = [];
            l(c);
            var h = null;
            null != e && (h = d(e = x(o, e, "secret_nonce")), e.length, o.push(h));
            var p = d(r = x(o, r, "ciphertext")), i = r.length;
            o.push(p), a = x(o, a, "mac");
            var v, m = 0 | t._crypto_box_macbytes();
            a.length !== m && f(o, "invalid mac length"), v = d(a), o.push(v);
            var E = null, k = 0;
            null != _ && (E = d(_ = x(o, _, "additional_data")), k = _.length, o.push(E)), n = x(o, n, "public_nonce");
            var S, T = 0 | t._crypto_aead_chacha20poly1305_ietf_npubbytes();
            n.length !== T && f(o, "invalid public_nonce length"), S = d(n), o.push(S), s = x(o, s, "key");
            var w, Y = 0 | t._crypto_aead_chacha20poly1305_ietf_keybytes();
            s.length !== Y && f(o, "invalid key length"), w = d(s), o.push(w);
            var B = new u(0 | i), A = B.address;
            if (o.push(A), 0 === t._crypto_aead_chacha20poly1305_ietf_decrypt_detached(A, h, p, i, 0, v, E, k, 0, S, w)) {
                var K = y(B, c);
                return g(o), K;
            }
            b(o, "ciphertext cannot be decrypted using that key");
        }
        function R(e, r, a, _, n, s) {
            var c = [];
            l(s);
            var o = d(e = x(c, e, "message")), h = e.length;
            c.push(o);
            var p = null, i = 0;
            null != r && (p = d(r = x(c, r, "additional_data")), i = r.length, c.push(p));
            var v = null;
            null != a && (v = d(a = x(c, a, "secret_nonce")), a.length, c.push(v)), _ = x(c, _, "public_nonce");
            var m, E = 0 | t._crypto_aead_chacha20poly1305_ietf_npubbytes();
            _.length !== E && f(c, "invalid public_nonce length"), m = d(_), c.push(m), n = x(c, n, "key");
            var k, S = 0 | t._crypto_aead_chacha20poly1305_ietf_keybytes();
            n.length !== S && f(c, "invalid key length"), k = d(n), c.push(k);
            var T = new u(h + t._crypto_aead_chacha20poly1305_ietf_abytes() | 0), w = T.address;
            if (c.push(w), 0 === t._crypto_aead_chacha20poly1305_ietf_encrypt(w, null, o, h, 0, p, i, 0, v, m, k)) {
                var Y = y(T, s);
                return g(c), Y;
            }
            b(c, "invalid usage");
        }
        function P(e, r, a, _, n, s) {
            var c = [];
            l(s);
            var o = d(e = x(c, e, "message")), h = e.length;
            c.push(o);
            var p = null, i = 0;
            null != r && (p = d(r = x(c, r, "additional_data")), i = r.length, c.push(p));
            var v = null;
            null != a && (v = d(a = x(c, a, "secret_nonce")), a.length, c.push(v)), _ = x(c, _, "public_nonce");
            var m, E = 0 | t._crypto_aead_chacha20poly1305_ietf_npubbytes();
            _.length !== E && f(c, "invalid public_nonce length"), m = d(_), c.push(m), n = x(c, n, "key");
            var k, S = 0 | t._crypto_aead_chacha20poly1305_ietf_keybytes();
            n.length !== S && f(c, "invalid key length"), k = d(n), c.push(k);
            var T = new u(0 | h), w = T.address;
            c.push(w);
            var Y = new u(0 | t._crypto_aead_chacha20poly1305_ietf_abytes()), B = Y.address;
            if (c.push(B), 0 === t._crypto_aead_chacha20poly1305_ietf_encrypt_detached(w, B, null, o, h, 0, p, i, 0, v, m, k)) {
                var A = y({
                    ciphertext: T,
                    mac: Y
                }, s);
                return g(c), A;
            }
            b(c, "invalid usage");
        }
        function G(e) {
            var r = [];
            l(e);
            var a = new u(0 | t._crypto_aead_chacha20poly1305_ietf_keybytes()), _ = a.address;
            r.push(_), t._crypto_aead_chacha20poly1305_ietf_keygen(_);
            var n = y(a, e);
            return g(r), n;
        }
        function X(e) {
            var r = [];
            l(e);
            var a = new u(0 | t._crypto_aead_chacha20poly1305_keybytes()), _ = a.address;
            r.push(_), t._crypto_aead_chacha20poly1305_keygen(_);
            var n = y(a, e);
            return g(r), n;
        }
        function D(e, r, a, _, n, s) {
            var c = [];
            l(s);
            var o = null;
            null != e && (o = d(e = x(c, e, "secret_nonce")), e.length, c.push(o)), r = x(c, r, "ciphertext");
            var h, p = t._crypto_aead_xchacha20poly1305_ietf_abytes(), i = r.length;
            i < p && f(c, "ciphertext is too short"), h = d(r), c.push(h);
            var v = null, m = 0;
            null != a && (v = d(a = x(c, a, "additional_data")), m = a.length, c.push(v)), _ = x(c, _, "public_nonce");
            var E, k = 0 | t._crypto_aead_xchacha20poly1305_ietf_npubbytes();
            _.length !== k && f(c, "invalid public_nonce length"), E = d(_), c.push(E), n = x(c, n, "key");
            var S, T = 0 | t._crypto_aead_xchacha20poly1305_ietf_keybytes();
            n.length !== T && f(c, "invalid key length"), S = d(n), c.push(S);
            var w = new u(i - t._crypto_aead_xchacha20poly1305_ietf_abytes() | 0), Y = w.address;
            if (c.push(Y), 0 === t._crypto_aead_xchacha20poly1305_ietf_decrypt(Y, null, o, h, i, 0, v, m, 0, E, S)) {
                var B = y(w, s);
                return g(c), B;
            }
            b(c, "ciphertext cannot be decrypted using that key");
        }
        function F(e, r, a, _, n, s, c) {
            var o = [];
            l(c);
            var h = null;
            null != e && (h = d(e = x(o, e, "secret_nonce")), e.length, o.push(h));
            var p = d(r = x(o, r, "ciphertext")), i = r.length;
            o.push(p), a = x(o, a, "mac");
            var v, m = 0 | t._crypto_box_macbytes();
            a.length !== m && f(o, "invalid mac length"), v = d(a), o.push(v);
            var E = null, k = 0;
            null != _ && (E = d(_ = x(o, _, "additional_data")), k = _.length, o.push(E)), n = x(o, n, "public_nonce");
            var S, T = 0 | t._crypto_aead_xchacha20poly1305_ietf_npubbytes();
            n.length !== T && f(o, "invalid public_nonce length"), S = d(n), o.push(S), s = x(o, s, "key");
            var w, Y = 0 | t._crypto_aead_xchacha20poly1305_ietf_keybytes();
            s.length !== Y && f(o, "invalid key length"), w = d(s), o.push(w);
            var B = new u(0 | i), A = B.address;
            if (o.push(A), 0 === t._crypto_aead_xchacha20poly1305_ietf_decrypt_detached(A, h, p, i, 0, v, E, k, 0, S, w)) {
                var K = y(B, c);
                return g(o), K;
            }
            b(o, "ciphertext cannot be decrypted using that key");
        }
        function V(e, r, a, _, n, s) {
            var c = [];
            l(s);
            var o = d(e = x(c, e, "message")), h = e.length;
            c.push(o);
            var p = null, i = 0;
            null != r && (p = d(r = x(c, r, "additional_data")), i = r.length, c.push(p));
            var v = null;
            null != a && (v = d(a = x(c, a, "secret_nonce")), a.length, c.push(v)), _ = x(c, _, "public_nonce");
            var m, E = 0 | t._crypto_aead_xchacha20poly1305_ietf_npubbytes();
            _.length !== E && f(c, "invalid public_nonce length"), m = d(_), c.push(m), n = x(c, n, "key");
            var k, S = 0 | t._crypto_aead_xchacha20poly1305_ietf_keybytes();
            n.length !== S && f(c, "invalid key length"), k = d(n), c.push(k);
            var T = new u(h + t._crypto_aead_xchacha20poly1305_ietf_abytes() | 0), w = T.address;
            if (c.push(w), 0 === t._crypto_aead_xchacha20poly1305_ietf_encrypt(w, null, o, h, 0, p, i, 0, v, m, k)) {
                var Y = y(T, s);
                return g(c), Y;
            }
            b(c, "invalid usage");
        }
        function H(e, r, a, _, n, s) {
            var c = [];
            l(s);
            var o = d(e = x(c, e, "message")), h = e.length;
            c.push(o);
            var p = null, i = 0;
            null != r && (p = d(r = x(c, r, "additional_data")), i = r.length, c.push(p));
            var v = null;
            null != a && (v = d(a = x(c, a, "secret_nonce")), a.length, c.push(v)), _ = x(c, _, "public_nonce");
            var m, E = 0 | t._crypto_aead_xchacha20poly1305_ietf_npubbytes();
            _.length !== E && f(c, "invalid public_nonce length"), m = d(_), c.push(m), n = x(c, n, "key");
            var k, S = 0 | t._crypto_aead_xchacha20poly1305_ietf_keybytes();
            n.length !== S && f(c, "invalid key length"), k = d(n), c.push(k);
            var T = new u(0 | h), w = T.address;
            c.push(w);
            var Y = new u(0 | t._crypto_aead_xchacha20poly1305_ietf_abytes()), B = Y.address;
            if (c.push(B), 0 === t._crypto_aead_xchacha20poly1305_ietf_encrypt_detached(w, B, null, o, h, 0, p, i, 0, v, m, k)) {
                var A = y({
                    ciphertext: T,
                    mac: Y
                }, s);
                return g(c), A;
            }
            b(c, "invalid usage");
        }
        function q(e) {
            var r = [];
            l(e);
            var a = new u(0 | t._crypto_aead_xchacha20poly1305_ietf_keybytes()), _ = a.address;
            r.push(_), t._crypto_aead_xchacha20poly1305_ietf_keygen(_);
            var n = y(a, e);
            return g(r), n;
        }
        function j(e, r, a) {
            var _ = [];
            l(a);
            var n = d(e = x(_, e, "message")), s = e.length;
            _.push(n), r = x(_, r, "key");
            var c, o = 0 | t._crypto_auth_keybytes();
            r.length !== o && f(_, "invalid key length"), c = d(r), _.push(c);
            var h = new u(0 | t._crypto_auth_bytes()), p = h.address;
            if (_.push(p), 0 == (0 | t._crypto_auth(p, n, s, 0, c))) {
                var i = y(h, a);
                return g(_), i;
            }
            b(_, "invalid usage");
        }
        function z(e, r, a) {
            var _ = [];
            l(a);
            var n = d(e = x(_, e, "message")), s = e.length;
            _.push(n), r = x(_, r, "key");
            var c, o = 0 | t._crypto_auth_hmacsha256_keybytes();
            r.length !== o && f(_, "invalid key length"), c = d(r), _.push(c);
            var h = new u(0 | t._crypto_auth_hmacsha256_bytes()), p = h.address;
            if (_.push(p), 0 == (0 | t._crypto_auth_hmacsha256(p, n, s, 0, c))) {
                var i = y(h, a);
                return g(_), i;
            }
            b(_, "invalid usage");
        }
        function W(e, r) {
            var a = [];
            l(r), m(a, e, "state_address");
            var _ = new u(0 | t._crypto_auth_hmacsha256_bytes()), n = _.address;
            if (a.push(n), 0 == (0 | t._crypto_auth_hmacsha256_final(e, n))) {
                var s = (t._free(e), y(_, r));
                return g(a), s;
            }
            b(a, "invalid usage");
        }
        function J(e, r) {
            var a = [];
            l(r);
            var _ = null, n = 0;
            null != e && (_ = d(e = x(a, e, "key")), n = e.length, a.push(_));
            var s = new u(208).address;
            if (0 == (0 | t._crypto_auth_hmacsha256_init(s, _, n))) {
                var c = s;
                return g(a), c;
            }
            b(a, "invalid usage");
        }
        function Q(e) {
            var r = [];
            l(e);
            var a = new u(0 | t._crypto_auth_hmacsha256_keybytes()), _ = a.address;
            r.push(_), t._crypto_auth_hmacsha256_keygen(_);
            var n = y(a, e);
            return g(r), n;
        }
        function Z(e, r, a) {
            var _ = [];
            l(a), m(_, e, "state_address");
            var n = d(r = x(_, r, "message_chunk")), s = r.length;
            _.push(n), 0 != (0 | t._crypto_auth_hmacsha256_update(e, n, s)) && b(_, "invalid usage"), g(_);
        }
        function $(e, r, a) {
            var _ = [];
            e = x(_, e, "tag");
            var n, s = 0 | t._crypto_auth_hmacsha256_bytes();
            e.length !== s && f(_, "invalid tag length"), n = d(e), _.push(n);
            var c = d(r = x(_, r, "message")), o = r.length;
            _.push(c), a = x(_, a, "key");
            var h, p = 0 | t._crypto_auth_hmacsha256_keybytes();
            a.length !== p && f(_, "invalid key length"), h = d(a), _.push(h);
            var y = 0 == (0 | t._crypto_auth_hmacsha256_verify(n, c, o, 0, h));
            return g(_), y;
        }
        function ee(e, r, a) {
            var _ = [];
            l(a);
            var n = d(e = x(_, e, "message")), s = e.length;
            _.push(n), r = x(_, r, "key");
            var c, o = 0 | t._crypto_auth_hmacsha512_keybytes();
            r.length !== o && f(_, "invalid key length"), c = d(r), _.push(c);
            var h = new u(0 | t._crypto_auth_hmacsha512_bytes()), p = h.address;
            if (_.push(p), 0 == (0 | t._crypto_auth_hmacsha512(p, n, s, 0, c))) {
                var i = y(h, a);
                return g(_), i;
            }
            b(_, "invalid usage");
        }
        function re(e, r) {
            var a = [];
            l(r), m(a, e, "state_address");
            var _ = new u(0 | t._crypto_auth_hmacsha512_bytes()), n = _.address;
            if (a.push(n), 0 == (0 | t._crypto_auth_hmacsha512_final(e, n))) {
                var s = (t._free(e), y(_, r));
                return g(a), s;
            }
            b(a, "invalid usage");
        }
        function te(e, r) {
            var a = [];
            l(r);
            var _ = null, n = 0;
            null != e && (_ = d(e = x(a, e, "key")), n = e.length, a.push(_));
            var s = new u(416).address;
            if (0 == (0 | t._crypto_auth_hmacsha512_init(s, _, n))) {
                var c = s;
                return g(a), c;
            }
            b(a, "invalid usage");
        }
        function ae(e) {
            var r = [];
            l(e);
            var a = new u(0 | t._crypto_auth_hmacsha512_keybytes()), _ = a.address;
            r.push(_), t._crypto_auth_hmacsha512_keygen(_);
            var n = y(a, e);
            return g(r), n;
        }
        function _e(e, r, a) {
            var _ = [];
            l(a), m(_, e, "state_address");
            var n = d(r = x(_, r, "message_chunk")), s = r.length;
            _.push(n), 0 != (0 | t._crypto_auth_hmacsha512_update(e, n, s)) && b(_, "invalid usage"), g(_);
        }
        function ne(e, r, a) {
            var _ = [];
            e = x(_, e, "tag");
            var n, s = 0 | t._crypto_auth_hmacsha512_bytes();
            e.length !== s && f(_, "invalid tag length"), n = d(e), _.push(n);
            var c = d(r = x(_, r, "message")), o = r.length;
            _.push(c), a = x(_, a, "key");
            var h, p = 0 | t._crypto_auth_hmacsha512_keybytes();
            a.length !== p && f(_, "invalid key length"), h = d(a), _.push(h);
            var y = 0 == (0 | t._crypto_auth_hmacsha512_verify(n, c, o, 0, h));
            return g(_), y;
        }
        function se(e) {
            var r = [];
            l(e);
            var a = new u(0 | t._crypto_auth_keybytes()), _ = a.address;
            r.push(_), t._crypto_auth_keygen(_);
            var n = y(a, e);
            return g(r), n;
        }
        function ce(e, r, a) {
            var _ = [];
            e = x(_, e, "tag");
            var n, s = 0 | t._crypto_auth_bytes();
            e.length !== s && f(_, "invalid tag length"), n = d(e), _.push(n);
            var c = d(r = x(_, r, "message")), o = r.length;
            _.push(c), a = x(_, a, "key");
            var h, p = 0 | t._crypto_auth_keybytes();
            a.length !== p && f(_, "invalid key length"), h = d(a), _.push(h);
            var y = 0 == (0 | t._crypto_auth_verify(n, c, o, 0, h));
            return g(_), y;
        }
        function oe(e, r, a) {
            var _ = [];
            l(a), e = x(_, e, "publicKey");
            var n, s = 0 | t._crypto_box_publickeybytes();
            e.length !== s && f(_, "invalid publicKey length"), n = d(e), _.push(n), r = x(_, r, "privateKey");
            var c, o = 0 | t._crypto_box_secretkeybytes();
            r.length !== o && f(_, "invalid privateKey length"), c = d(r), _.push(c);
            var h = new u(0 | t._crypto_box_beforenmbytes()), p = h.address;
            if (_.push(p), 0 == (0 | t._crypto_box_beforenm(p, n, c))) {
                var i = y(h, a);
                return g(_), i;
            }
            b(_, "invalid usage");
        }
        function he(e, r, a) {
            var _ = [];
            l(a), e = x(_, e, "publicKey");
            var n, s = 0 | t._crypto_box_curve25519xchacha20poly1305_publickeybytes();
            e.length !== s && f(_, "invalid publicKey length"), n = d(e), _.push(n), r = x(_, r, "privateKey");
            var c, o = 0 | t._crypto_box_curve25519xchacha20poly1305_secretkeybytes();
            r.length !== o && f(_, "invalid privateKey length"), c = d(r), _.push(c);
            var h = new u(0 | t._crypto_box_curve25519xchacha20poly1305_beforenmbytes()), p = h.address;
            if (_.push(p), 0 == (0 | t._crypto_box_curve25519xchacha20poly1305_beforenm(p, n, c))) {
                var i = y(h, a);
                return g(_), i;
            }
            b(_, "invalid usage");
        }
        function pe(e, r, a, _, n) {
            var s = [];
            l(n);
            var c = d(e = x(s, e, "message")), o = e.length;
            s.push(c), r = x(s, r, "nonce");
            var h, p = 0 | t._crypto_box_curve25519xchacha20poly1305_noncebytes();
            r.length !== p && f(s, "invalid nonce length"), h = d(r), s.push(h), a = x(s, a, "publicKey");
            var i, v = 0 | t._crypto_box_curve25519xchacha20poly1305_publickeybytes();
            a.length !== v && f(s, "invalid publicKey length"), i = d(a), s.push(i), _ = x(s, _, "privateKey");
            var m, E = 0 | t._crypto_box_curve25519xchacha20poly1305_secretkeybytes();
            _.length !== E && f(s, "invalid privateKey length"), m = d(_), s.push(m);
            var k = new u(0 | o), S = k.address;
            s.push(S);
            var T = new u(0 | t._crypto_box_curve25519xchacha20poly1305_macbytes()), w = T.address;
            if (s.push(w), 0 == (0 | t._crypto_box_curve25519xchacha20poly1305_detached(S, w, c, o, 0, h, i, m))) {
                var Y = y({
                    ciphertext: k,
                    mac: T
                }, n);
                return g(s), Y;
            }
            b(s, "invalid usage");
        }
        function ye(e, r, a, _) {
            var n = [];
            l(_);
            var s = d(e = x(n, e, "message")), c = e.length;
            n.push(s), r = x(n, r, "nonce");
            var o, h = 0 | t._crypto_box_curve25519xchacha20poly1305_noncebytes();
            r.length !== h && f(n, "invalid nonce length"), o = d(r), n.push(o), a = x(n, a, "sharedKey");
            var p, i = 0 | t._crypto_box_curve25519xchacha20poly1305_beforenmbytes();
            a.length !== i && f(n, "invalid sharedKey length"), p = d(a), n.push(p);
            var v = new u(0 | c), m = v.address;
            n.push(m);
            var E = new u(0 | t._crypto_box_curve25519xchacha20poly1305_macbytes()), k = E.address;
            if (n.push(k), 0 == (0 | t._crypto_box_curve25519xchacha20poly1305_detached_afternm(m, k, s, c, 0, o, p))) {
                var S = y({
                    ciphertext: v,
                    mac: E
                }, _);
                return g(n), S;
            }
            b(n, "invalid usage");
        }
        function ie(e, r, a, _, n) {
            var s = [];
            l(n);
            var c = d(e = x(s, e, "message")), o = e.length;
            s.push(c), r = x(s, r, "nonce");
            var h, p = 0 | t._crypto_box_curve25519xchacha20poly1305_noncebytes();
            r.length !== p && f(s, "invalid nonce length"), h = d(r), s.push(h), a = x(s, a, "publicKey");
            var i, v = 0 | t._crypto_box_curve25519xchacha20poly1305_publickeybytes();
            a.length !== v && f(s, "invalid publicKey length"), i = d(a), s.push(i), _ = x(s, _, "privateKey");
            var m, E = 0 | t._crypto_box_curve25519xchacha20poly1305_secretkeybytes();
            _.length !== E && f(s, "invalid privateKey length"), m = d(_), s.push(m);
            var k = new u(o + t._crypto_box_curve25519xchacha20poly1305_macbytes() | 0), S = k.address;
            if (s.push(S), 0 == (0 | t._crypto_box_curve25519xchacha20poly1305_easy(S, c, o, 0, h, i, m))) {
                var T = y(k, n);
                return g(s), T;
            }
            b(s, "invalid usage");
        }
        function le(e, r, a, _) {
            var n = [];
            l(_);
            var s = d(e = x(n, e, "message")), c = e.length;
            n.push(s), r = x(n, r, "nonce");
            var o, h = 0 | t._crypto_box_curve25519xchacha20poly1305_noncebytes();
            r.length !== h && f(n, "invalid nonce length"), o = d(r), n.push(o), a = x(n, a, "sharedKey");
            var p, i = 0 | t._crypto_box_curve25519xchacha20poly1305_beforenmbytes();
            a.length !== i && f(n, "invalid sharedKey length"), p = d(a), n.push(p);
            var v = new u(c + t._crypto_box_curve25519xchacha20poly1305_macbytes() | 0), m = v.address;
            if (n.push(m), 0 == (0 | t._crypto_box_curve25519xchacha20poly1305_easy_afternm(m, s, c, 0, o, p))) {
                var E = y(v, _);
                return g(n), E;
            }
            b(n, "invalid usage");
        }
        function ue(e) {
            var r = [];
            l(e);
            var a = new u(0 | t._crypto_box_curve25519xchacha20poly1305_publickeybytes()), _ = a.address;
            r.push(_);
            var n = new u(0 | t._crypto_box_curve25519xchacha20poly1305_secretkeybytes()), s = n.address;
            r.push(s), t._crypto_box_curve25519xchacha20poly1305_keypair(_, s);
            var c = y({
                publicKey: a,
                privateKey: n,
                keyType: "curve25519"
            }, e);
            return g(r), c;
        }
        function de(e, r, a, _, n, s) {
            var c = [];
            l(s);
            var o = d(e = x(c, e, "ciphertext")), h = e.length;
            c.push(o), r = x(c, r, "mac");
            var p, i = 0 | t._crypto_box_curve25519xchacha20poly1305_macbytes();
            r.length !== i && f(c, "invalid mac length"), p = d(r), c.push(p), a = x(c, a, "nonce");
            var v, m = 0 | t._crypto_box_curve25519xchacha20poly1305_noncebytes();
            a.length !== m && f(c, "invalid nonce length"), v = d(a), c.push(v), _ = x(c, _, "publicKey");
            var E, k = 0 | t._crypto_box_curve25519xchacha20poly1305_publickeybytes();
            _.length !== k && f(c, "invalid publicKey length"), E = d(_), c.push(E), n = x(c, n, "privateKey");
            var S, T = 0 | t._crypto_box_curve25519xchacha20poly1305_secretkeybytes();
            n.length !== T && f(c, "invalid privateKey length"), S = d(n), c.push(S);
            var w = new u(0 | h), Y = w.address;
            if (c.push(Y), 0 == (0 | t._crypto_box_curve25519xchacha20poly1305_open_detached(Y, o, p, h, 0, v, E, S))) {
                var B = y(w, s);
                return g(c), B;
            }
            b(c, "incorrect key pair for the given ciphertext");
        }
        function ve(e, r, a, _, n) {
            var s = [];
            l(n);
            var c = d(e = x(s, e, "ciphertext")), o = e.length;
            s.push(c), r = x(s, r, "mac");
            var h, p = 0 | t._crypto_box_curve25519xchacha20poly1305_macbytes();
            r.length !== p && f(s, "invalid mac length"), h = d(r), s.push(h), a = x(s, a, "nonce");
            var i, v = 0 | t._crypto_box_curve25519xchacha20poly1305_noncebytes();
            a.length !== v && f(s, "invalid nonce length"), i = d(a), s.push(i), _ = x(s, _, "sharedKey");
            var m, E = 0 | t._crypto_box_curve25519xchacha20poly1305_beforenmbytes();
            _.length !== E && f(s, "invalid sharedKey length"), m = d(_), s.push(m);
            var k = new u(0 | o), S = k.address;
            if (s.push(S), 0 == (0 | t._crypto_box_curve25519xchacha20poly1305_open_detached_afternm(S, c, h, o, 0, i, m))) {
                var T = y(k, n);
                return g(s), T;
            }
            b(s, "incorrect secret key for the given ciphertext");
        }
        function ge(e, r, a, _, n) {
            var s = [];
            l(n), e = x(s, e, "ciphertext");
            var c, o = t._crypto_box_curve25519xchacha20poly1305_macbytes(), h = e.length;
            h < o && f(s, "ciphertext is too short"), c = d(e), s.push(c), r = x(s, r, "nonce");
            var p, i = 0 | t._crypto_box_curve25519xchacha20poly1305_noncebytes();
            r.length !== i && f(s, "invalid nonce length"), p = d(r), s.push(p), a = x(s, a, "publicKey");
            var v, m = 0 | t._crypto_box_curve25519xchacha20poly1305_publickeybytes();
            a.length !== m && f(s, "invalid publicKey length"), v = d(a), s.push(v), _ = x(s, _, "privateKey");
            var E, k = 0 | t._crypto_box_curve25519xchacha20poly1305_secretkeybytes();
            _.length !== k && f(s, "invalid privateKey length"), E = d(_), s.push(E);
            var S = new u(h - t._crypto_box_curve25519xchacha20poly1305_macbytes() | 0), T = S.address;
            if (s.push(T), 0 == (0 | t._crypto_box_curve25519xchacha20poly1305_open_easy(T, c, h, 0, p, v, E))) {
                var w = y(S, n);
                return g(s), w;
            }
            b(s, "incorrect key pair for the given ciphertext");
        }
        function be(e, r, a, _) {
            var n = [];
            l(_);
            var s = d(e = x(n, e, "ciphertext")), c = e.length;
            n.push(s), r = x(n, r, "nonce");
            var o, h = 0 | t._crypto_box_curve25519xchacha20poly1305_noncebytes();
            r.length !== h && f(n, "invalid nonce length"), o = d(r), n.push(o), a = x(n, a, "sharedKey");
            var p, i = 0 | t._crypto_box_curve25519xchacha20poly1305_beforenmbytes();
            a.length !== i && f(n, "invalid sharedKey length"), p = d(a), n.push(p);
            var v = new u(c - t._crypto_box_curve25519xchacha20poly1305_macbytes() | 0), m = v.address;
            if (n.push(m), 0 == (0 | t._crypto_box_curve25519xchacha20poly1305_open_easy_afternm(m, s, c, 0, o, p))) {
                var E = y(v, _);
                return g(n), E;
            }
            b(n, "incorrect secret key for the given ciphertext");
        }
        function fe(e, r, a) {
            var _ = [];
            l(a);
            var n = d(e = x(_, e, "message")), s = e.length;
            _.push(n), r = x(_, r, "publicKey");
            var c, o = 0 | t._crypto_box_curve25519xchacha20poly1305_publickeybytes();
            r.length !== o && f(_, "invalid publicKey length"), c = d(r), _.push(c);
            var h = new u(s + t._crypto_box_curve25519xchacha20poly1305_sealbytes() | 0), p = h.address;
            _.push(p), t._crypto_box_curve25519xchacha20poly1305_seal(p, n, s, 0, c);
            var i = y(h, a);
            return g(_), i;
        }
        function me(e, r, a, _) {
            var n = [];
            l(_), e = x(n, e, "ciphertext");
            var s, c = t._crypto_box_curve25519xchacha20poly1305_sealbytes(), o = e.length;
            o < c && f(n, "ciphertext is too short"), s = d(e), n.push(s), r = x(n, r, "publicKey");
            var h, p = 0 | t._crypto_box_curve25519xchacha20poly1305_publickeybytes();
            r.length !== p && f(n, "invalid publicKey length"), h = d(r), n.push(h), a = x(n, a, "secretKey");
            var i, v = 0 | t._crypto_box_curve25519xchacha20poly1305_secretkeybytes();
            a.length !== v && f(n, "invalid secretKey length"), i = d(a), n.push(i);
            var b = new u(o - t._crypto_box_curve25519xchacha20poly1305_sealbytes() | 0), m = b.address;
            n.push(m), t._crypto_box_curve25519xchacha20poly1305_seal_open(m, s, o, 0, h, i);
            var E = y(b, _);
            return g(n), E;
        }
        function xe(e, r) {
            var a = [];
            l(r), e = x(a, e, "seed");
            var _, n = 0 | t._crypto_box_curve25519xchacha20poly1305_seedbytes();
            e.length !== n && f(a, "invalid seed length"), _ = d(e), a.push(_);
            var s = new u(0 | t._crypto_box_curve25519xchacha20poly1305_publickeybytes()), c = s.address;
            a.push(c);
            var o = new u(0 | t._crypto_box_curve25519xchacha20poly1305_secretkeybytes()), h = o.address;
            if (a.push(h), 0 == (0 | t._crypto_box_curve25519xchacha20poly1305_seed_keypair(c, h, _))) {
                var p = {
                    publicKey: y(s, r),
                    privateKey: y(o, r),
                    keyType: "x25519"
                };
                return g(a), p;
            }
            b(a, "invalid usage");
        }
        function Ee(e, r, a, _, n) {
            var s = [];
            l(n);
            var c = d(e = x(s, e, "message")), o = e.length;
            s.push(c), r = x(s, r, "nonce");
            var h, p = 0 | t._crypto_box_noncebytes();
            r.length !== p && f(s, "invalid nonce length"), h = d(r), s.push(h), a = x(s, a, "publicKey");
            var i, v = 0 | t._crypto_box_publickeybytes();
            a.length !== v && f(s, "invalid publicKey length"), i = d(a), s.push(i), _ = x(s, _, "privateKey");
            var m, E = 0 | t._crypto_box_secretkeybytes();
            _.length !== E && f(s, "invalid privateKey length"), m = d(_), s.push(m);
            var k = new u(0 | o), S = k.address;
            s.push(S);
            var T = new u(0 | t._crypto_box_macbytes()), w = T.address;
            if (s.push(w), 0 == (0 | t._crypto_box_detached(S, w, c, o, 0, h, i, m))) {
                var Y = y({
                    ciphertext: k,
                    mac: T
                }, n);
                return g(s), Y;
            }
            b(s, "invalid usage");
        }
        function ke(e, r, a, _, n) {
            var s = [];
            l(n);
            var c = d(e = x(s, e, "message")), o = e.length;
            s.push(c), r = x(s, r, "nonce");
            var h, p = 0 | t._crypto_box_noncebytes();
            r.length !== p && f(s, "invalid nonce length"), h = d(r), s.push(h), a = x(s, a, "publicKey");
            var i, v = 0 | t._crypto_box_publickeybytes();
            a.length !== v && f(s, "invalid publicKey length"), i = d(a), s.push(i), _ = x(s, _, "privateKey");
            var m, E = 0 | t._crypto_box_secretkeybytes();
            _.length !== E && f(s, "invalid privateKey length"), m = d(_), s.push(m);
            var k = new u(o + t._crypto_box_macbytes() | 0), S = k.address;
            if (s.push(S), 0 == (0 | t._crypto_box_easy(S, c, o, 0, h, i, m))) {
                var T = y(k, n);
                return g(s), T;
            }
            b(s, "invalid usage");
        }
        function Se(e, r, a, _) {
            var n = [];
            l(_);
            var s = d(e = x(n, e, "message")), c = e.length;
            n.push(s), r = x(n, r, "nonce");
            var o, h = 0 | t._crypto_box_noncebytes();
            r.length !== h && f(n, "invalid nonce length"), o = d(r), n.push(o), a = x(n, a, "sharedKey");
            var p, i = 0 | t._crypto_box_beforenmbytes();
            a.length !== i && f(n, "invalid sharedKey length"), p = d(a), n.push(p);
            var v = new u(c + t._crypto_box_macbytes() | 0), m = v.address;
            if (n.push(m), 0 == (0 | t._crypto_box_easy_afternm(m, s, c, 0, o, p))) {
                var E = y(v, _);
                return g(n), E;
            }
            b(n, "invalid usage");
        }
        function Te(e) {
            var r = [];
            l(e);
            var a = new u(0 | t._crypto_box_publickeybytes()), _ = a.address;
            r.push(_);
            var n = new u(0 | t._crypto_box_secretkeybytes()), s = n.address;
            if (r.push(s), 0 == (0 | t._crypto_box_keypair(_, s))) {
                var c = {
                    publicKey: y(a, e),
                    privateKey: y(n, e),
                    keyType: "x25519"
                };
                return g(r), c;
            }
            b(r, "internal error");
        }
        function we(e, r, a, _, n, s) {
            var c = [];
            l(s);
            var o = d(e = x(c, e, "ciphertext")), h = e.length;
            c.push(o), r = x(c, r, "mac");
            var p, i = 0 | t._crypto_box_macbytes();
            r.length !== i && f(c, "invalid mac length"), p = d(r), c.push(p), a = x(c, a, "nonce");
            var v, m = 0 | t._crypto_box_noncebytes();
            a.length !== m && f(c, "invalid nonce length"), v = d(a), c.push(v), _ = x(c, _, "publicKey");
            var E, k = 0 | t._crypto_box_publickeybytes();
            _.length !== k && f(c, "invalid publicKey length"), E = d(_), c.push(E), n = x(c, n, "privateKey");
            var S, T = 0 | t._crypto_box_secretkeybytes();
            n.length !== T && f(c, "invalid privateKey length"), S = d(n), c.push(S);
            var w = new u(0 | h), Y = w.address;
            if (c.push(Y), 0 == (0 | t._crypto_box_open_detached(Y, o, p, h, 0, v, E, S))) {
                var B = y(w, s);
                return g(c), B;
            }
            b(c, "incorrect key pair for the given ciphertext");
        }
        function Ye(e, r, a, _, n) {
            var s = [];
            l(n), e = x(s, e, "ciphertext");
            var c, o = t._crypto_box_macbytes(), h = e.length;
            h < o && f(s, "ciphertext is too short"), c = d(e), s.push(c), r = x(s, r, "nonce");
            var p, i = 0 | t._crypto_box_noncebytes();
            r.length !== i && f(s, "invalid nonce length"), p = d(r), s.push(p), a = x(s, a, "publicKey");
            var v, m = 0 | t._crypto_box_publickeybytes();
            a.length !== m && f(s, "invalid publicKey length"), v = d(a), s.push(v), _ = x(s, _, "privateKey");
            var E, k = 0 | t._crypto_box_secretkeybytes();
            _.length !== k && f(s, "invalid privateKey length"), E = d(_), s.push(E);
            var S = new u(h - t._crypto_box_macbytes() | 0), T = S.address;
            if (s.push(T), 0 == (0 | t._crypto_box_open_easy(T, c, h, 0, p, v, E))) {
                var w = y(S, n);
                return g(s), w;
            }
            b(s, "incorrect key pair for the given ciphertext");
        }
        function Be(e, r, a, _) {
            var n = [];
            l(_);
            var s = d(e = x(n, e, "ciphertext")), c = e.length;
            n.push(s), r = x(n, r, "nonce");
            var o, h = 0 | t._crypto_box_noncebytes();
            r.length !== h && f(n, "invalid nonce length"), o = d(r), n.push(o), a = x(n, a, "sharedKey");
            var p, i = 0 | t._crypto_box_beforenmbytes();
            a.length !== i && f(n, "invalid sharedKey length"), p = d(a), n.push(p);
            var v = new u(c - t._crypto_box_macbytes() | 0), m = v.address;
            if (n.push(m), 0 == (0 | t._crypto_box_open_easy_afternm(m, s, c, 0, o, p))) {
                var E = y(v, _);
                return g(n), E;
            }
            b(n, "incorrect secret key for the given ciphertext");
        }
        function Ae(e, r, a) {
            var _ = [];
            l(a);
            var n = d(e = x(_, e, "message")), s = e.length;
            _.push(n), r = x(_, r, "publicKey");
            var c, o = 0 | t._crypto_box_publickeybytes();
            r.length !== o && f(_, "invalid publicKey length"), c = d(r), _.push(c);
            var h = new u(s + t._crypto_box_sealbytes() | 0), p = h.address;
            if (_.push(p), 0 == (0 | t._crypto_box_seal(p, n, s, 0, c))) {
                var i = y(h, a);
                return g(_), i;
            }
            b(_, "invalid usage");
        }
        function Ke(e, r, a, _) {
            var n = [];
            l(_), e = x(n, e, "ciphertext");
            var s, c = t._crypto_box_sealbytes(), o = e.length;
            o < c && f(n, "ciphertext is too short"), s = d(e), n.push(s), r = x(n, r, "publicKey");
            var h, p = 0 | t._crypto_box_publickeybytes();
            r.length !== p && f(n, "invalid publicKey length"), h = d(r), n.push(h), a = x(n, a, "privateKey");
            var i, v = 0 | t._crypto_box_secretkeybytes();
            a.length !== v && f(n, "invalid privateKey length"), i = d(a), n.push(i);
            var m = new u(o - t._crypto_box_sealbytes() | 0), E = m.address;
            if (n.push(E), 0 == (0 | t._crypto_box_seal_open(E, s, o, 0, h, i))) {
                var k = y(m, _);
                return g(n), k;
            }
            b(n, "incorrect key pair for the given ciphertext");
        }
        function Me(e, r) {
            var a = [];
            l(r), e = x(a, e, "seed");
            var _, n = 0 | t._crypto_box_seedbytes();
            e.length !== n && f(a, "invalid seed length"), _ = d(e), a.push(_);
            var s = new u(0 | t._crypto_box_publickeybytes()), c = s.address;
            a.push(c);
            var o = new u(0 | t._crypto_box_secretkeybytes()), h = o.address;
            if (a.push(h), 0 == (0 | t._crypto_box_seed_keypair(c, h, _))) {
                var p = {
                    publicKey: y(s, r),
                    privateKey: y(o, r),
                    keyType: "x25519"
                };
                return g(a), p;
            }
            b(a, "invalid usage");
        }
        function Ie(e, r, a) {
            var _ = [];
            l(a), e = x(_, e, "p");
            var n, s = 0 | t._crypto_core_ed25519_bytes();
            e.length !== s && f(_, "invalid p length"), n = d(e), _.push(n), r = x(_, r, "q");
            var c, o = 0 | t._crypto_core_ed25519_bytes();
            r.length !== o && f(_, "invalid q length"), c = d(r), _.push(c);
            var h = new u(0 | t._crypto_core_ed25519_bytes()), p = h.address;
            if (_.push(p), 0 == (0 | t._crypto_core_ed25519_add(p, n, c))) {
                var i = y(h, a);
                return g(_), i;
            }
            b(_, "input is an invalid element");
        }
        function Ne(e, r) {
            var a = [];
            l(r);
            var _ = d(e = x(a, e, "r"));
            e.length, a.push(_);
            var n = new u(0 | t._crypto_core_ed25519_bytes()), s = n.address;
            if (a.push(s), 0 == (0 | t._crypto_core_ed25519_from_hash(s, _))) {
                var c = y(n, r);
                return g(a), c;
            }
            b(a, "invalid usage");
        }
        function Le(e, r) {
            var a = [];
            l(r);
            var _ = d(e = x(a, e, "r"));
            e.length, a.push(_);
            var n = new u(0 | t._crypto_core_ed25519_bytes()), s = n.address;
            if (a.push(s), 0 == (0 | t._crypto_core_ed25519_from_uniform(s, _))) {
                var c = y(n, r);
                return g(a), c;
            }
            b(a, "invalid usage");
        }
        function Ue(e, r) {
            var a = [];
            l(r), e = x(a, e, "repr");
            var _, n = 0 | t._crypto_core_ed25519_bytes();
            e.length !== n && f(a, "invalid repr length"), _ = d(e), a.push(_);
            var s = 1 == (0 | t._crypto_core_ed25519_is_valid_point(_));
            return g(a), s;
        }
        function Oe(e) {
            var r = [];
            l(e);
            var a = new u(0 | t._crypto_core_ed25519_bytes()), _ = a.address;
            r.push(_), t._crypto_core_ed25519_random(_);
            var n = y(a, e);
            return g(r), n;
        }
        function Ce(e, r, a) {
            var _ = [];
            l(a), e = x(_, e, "x");
            var n, s = 0 | t._crypto_core_ed25519_scalarbytes();
            e.length !== s && f(_, "invalid x length"), n = d(e), _.push(n), r = x(_, r, "y");
            var c, o = 0 | t._crypto_core_ed25519_scalarbytes();
            r.length !== o && f(_, "invalid y length"), c = d(r), _.push(c);
            var h = new u(0 | t._crypto_core_ed25519_scalarbytes()), p = h.address;
            _.push(p), t._crypto_core_ed25519_scalar_add(p, n, c);
            var i = y(h, a);
            return g(_), i;
        }
        function Re(e, r) {
            var a = [];
            l(r), e = x(a, e, "s");
            var _, n = 0 | t._crypto_core_ed25519_scalarbytes();
            e.length !== n && f(a, "invalid s length"), _ = d(e), a.push(_);
            var s = new u(0 | t._crypto_core_ed25519_scalarbytes()), c = s.address;
            a.push(c), t._crypto_core_ed25519_scalar_complement(c, _);
            var o = y(s, r);
            return g(a), o;
        }
        function Pe(e, r) {
            var a = [];
            l(r), e = x(a, e, "s");
            var _, n = 0 | t._crypto_core_ed25519_scalarbytes();
            e.length !== n && f(a, "invalid s length"), _ = d(e), a.push(_);
            var s = new u(0 | t._crypto_core_ed25519_scalarbytes()), c = s.address;
            if (a.push(c), 0 == (0 | t._crypto_core_ed25519_scalar_invert(c, _))) {
                var o = y(s, r);
                return g(a), o;
            }
            b(a, "invalid reciprocate");
        }
        function Ge(e, r, a) {
            var _ = [];
            l(a), e = x(_, e, "x");
            var n, s = 0 | t._crypto_core_ed25519_scalarbytes();
            e.length !== s && f(_, "invalid x length"), n = d(e), _.push(n), r = x(_, r, "y");
            var c, o = 0 | t._crypto_core_ed25519_scalarbytes();
            r.length !== o && f(_, "invalid y length"), c = d(r), _.push(c);
            var h = new u(0 | t._crypto_core_ed25519_scalarbytes()), p = h.address;
            _.push(p), t._crypto_core_ed25519_scalar_mul(p, n, c);
            var i = y(h, a);
            return g(_), i;
        }
        function Xe(e, r) {
            var a = [];
            l(r), e = x(a, e, "s");
            var _, n = 0 | t._crypto_core_ed25519_scalarbytes();
            e.length !== n && f(a, "invalid s length"), _ = d(e), a.push(_);
            var s = new u(0 | t._crypto_core_ed25519_scalarbytes()), c = s.address;
            a.push(c), t._crypto_core_ed25519_scalar_negate(c, _);
            var o = y(s, r);
            return g(a), o;
        }
        function De(e) {
            var r = [];
            l(e);
            var a = new u(0 | t._crypto_core_ed25519_scalarbytes()), _ = a.address;
            r.push(_), t._crypto_core_ed25519_scalar_random(_);
            var n = y(a, e);
            return g(r), n;
        }
        function Fe(e, r) {
            var a = [];
            l(r), e = x(a, e, "sample");
            var _, n = 0 | t._crypto_core_ed25519_nonreducedscalarbytes();
            e.length !== n && f(a, "invalid sample length"), _ = d(e), a.push(_);
            var s = new u(0 | t._crypto_core_ed25519_scalarbytes()), c = s.address;
            a.push(c), t._crypto_core_ed25519_scalar_reduce(c, _);
            var o = y(s, r);
            return g(a), o;
        }
        function Ve(e, r, a) {
            var _ = [];
            l(a), e = x(_, e, "x");
            var n, s = 0 | t._crypto_core_ed25519_scalarbytes();
            e.length !== s && f(_, "invalid x length"), n = d(e), _.push(n), r = x(_, r, "y");
            var c, o = 0 | t._crypto_core_ed25519_scalarbytes();
            r.length !== o && f(_, "invalid y length"), c = d(r), _.push(c);
            var h = new u(0 | t._crypto_core_ed25519_scalarbytes()), p = h.address;
            _.push(p), t._crypto_core_ed25519_scalar_sub(p, n, c);
            var i = y(h, a);
            return g(_), i;
        }
        function He(e, r, a) {
            var _ = [];
            l(a), e = x(_, e, "p");
            var n, s = 0 | t._crypto_core_ed25519_bytes();
            e.length !== s && f(_, "invalid p length"), n = d(e), _.push(n), r = x(_, r, "q");
            var c, o = 0 | t._crypto_core_ed25519_bytes();
            r.length !== o && f(_, "invalid q length"), c = d(r), _.push(c);
            var h = new u(0 | t._crypto_core_ed25519_bytes()), p = h.address;
            if (_.push(p), 0 == (0 | t._crypto_core_ed25519_sub(p, n, c))) {
                var i = y(h, a);
                return g(_), i;
            }
            b(_, "input is an invalid element");
        }
        function qe(e, r, a, _) {
            var n = [];
            l(_), e = x(n, e, "input");
            var s, c = 0 | t._crypto_core_hchacha20_inputbytes();
            e.length !== c && f(n, "invalid input length"), s = d(e), n.push(s), r = x(n, r, "privateKey");
            var o, h = 0 | t._crypto_core_hchacha20_keybytes();
            r.length !== h && f(n, "invalid privateKey length"), o = d(r), n.push(o);
            var p = null;
            null != a && (p = d(a = x(n, a, "constant")), a.length, n.push(p));
            var i = new u(0 | t._crypto_core_hchacha20_outputbytes()), v = i.address;
            if (n.push(v), 0 == (0 | t._crypto_core_hchacha20(v, s, o, p))) {
                var m = y(i, _);
                return g(n), m;
            }
            b(n, "invalid usage");
        }
        function je(e, r, a, _) {
            var n = [];
            l(_), e = x(n, e, "input");
            var s, c = 0 | t._crypto_core_hsalsa20_inputbytes();
            e.length !== c && f(n, "invalid input length"), s = d(e), n.push(s), r = x(n, r, "privateKey");
            var o, h = 0 | t._crypto_core_hsalsa20_keybytes();
            r.length !== h && f(n, "invalid privateKey length"), o = d(r), n.push(o);
            var p = null;
            null != a && (p = d(a = x(n, a, "constant")), a.length, n.push(p));
            var i = new u(0 | t._crypto_core_hsalsa20_outputbytes()), v = i.address;
            if (n.push(v), 0 == (0 | t._crypto_core_hsalsa20(v, s, o, p))) {
                var m = y(i, _);
                return g(n), m;
            }
            b(n, "invalid usage");
        }
        function ze(e, r, a) {
            var _ = [];
            l(a), e = x(_, e, "p");
            var n, s = 0 | t._crypto_core_ristretto255_bytes();
            e.length !== s && f(_, "invalid p length"), n = d(e), _.push(n), r = x(_, r, "q");
            var c, o = 0 | t._crypto_core_ristretto255_bytes();
            r.length !== o && f(_, "invalid q length"), c = d(r), _.push(c);
            var h = new u(0 | t._crypto_core_ristretto255_bytes()), p = h.address;
            if (_.push(p), 0 == (0 | t._crypto_core_ristretto255_add(p, n, c))) {
                var i = y(h, a);
                return g(_), i;
            }
            b(_, "input is an invalid element");
        }
        function We(e, r) {
            var a = [];
            l(r);
            var _ = d(e = x(a, e, "r"));
            e.length, a.push(_);
            var n = new u(0 | t._crypto_core_ristretto255_bytes()), s = n.address;
            if (a.push(s), 0 == (0 | t._crypto_core_ristretto255_from_hash(s, _))) {
                var c = y(n, r);
                return g(a), c;
            }
            b(a, "invalid usage");
        }
        function Je(e, r) {
            var a = [];
            l(r), e = x(a, e, "repr");
            var _, n = 0 | t._crypto_core_ristretto255_bytes();
            e.length !== n && f(a, "invalid repr length"), _ = d(e), a.push(_);
            var s = 1 == (0 | t._crypto_core_ristretto255_is_valid_point(_));
            return g(a), s;
        }
        function Qe(e) {
            var r = [];
            l(e);
            var a = new u(0 | t._crypto_core_ristretto255_bytes()), _ = a.address;
            r.push(_), t._crypto_core_ristretto255_random(_);
            var n = y(a, e);
            return g(r), n;
        }
        function Ze(e, r, a) {
            var _ = [];
            l(a), e = x(_, e, "x");
            var n, s = 0 | t._crypto_core_ristretto255_scalarbytes();
            e.length !== s && f(_, "invalid x length"), n = d(e), _.push(n), r = x(_, r, "y");
            var c, o = 0 | t._crypto_core_ristretto255_scalarbytes();
            r.length !== o && f(_, "invalid y length"), c = d(r), _.push(c);
            var h = new u(0 | t._crypto_core_ristretto255_scalarbytes()), p = h.address;
            _.push(p), t._crypto_core_ristretto255_scalar_add(p, n, c);
            var i = y(h, a);
            return g(_), i;
        }
        function $e(e, r) {
            var a = [];
            l(r), e = x(a, e, "s");
            var _, n = 0 | t._crypto_core_ristretto255_scalarbytes();
            e.length !== n && f(a, "invalid s length"), _ = d(e), a.push(_);
            var s = new u(0 | t._crypto_core_ristretto255_scalarbytes()), c = s.address;
            a.push(c), t._crypto_core_ristretto255_scalar_complement(c, _);
            var o = y(s, r);
            return g(a), o;
        }
        function er(e, r) {
            var a = [];
            l(r), e = x(a, e, "s");
            var _, n = 0 | t._crypto_core_ristretto255_scalarbytes();
            e.length !== n && f(a, "invalid s length"), _ = d(e), a.push(_);
            var s = new u(0 | t._crypto_core_ristretto255_scalarbytes()), c = s.address;
            if (a.push(c), 0 == (0 | t._crypto_core_ristretto255_scalar_invert(c, _))) {
                var o = y(s, r);
                return g(a), o;
            }
            b(a, "invalid reciprocate");
        }
        function rr(e, r, a) {
            var _ = [];
            l(a), e = x(_, e, "x");
            var n, s = 0 | t._crypto_core_ristretto255_scalarbytes();
            e.length !== s && f(_, "invalid x length"), n = d(e), _.push(n), r = x(_, r, "y");
            var c, o = 0 | t._crypto_core_ristretto255_scalarbytes();
            r.length !== o && f(_, "invalid y length"), c = d(r), _.push(c);
            var h = new u(0 | t._crypto_core_ristretto255_scalarbytes()), p = h.address;
            _.push(p), t._crypto_core_ristretto255_scalar_mul(p, n, c);
            var i = y(h, a);
            return g(_), i;
        }
        function tr(e, r) {
            var a = [];
            l(r), e = x(a, e, "s");
            var _, n = 0 | t._crypto_core_ristretto255_scalarbytes();
            e.length !== n && f(a, "invalid s length"), _ = d(e), a.push(_);
            var s = new u(0 | t._crypto_core_ristretto255_scalarbytes()), c = s.address;
            a.push(c), t._crypto_core_ristretto255_scalar_negate(c, _);
            var o = y(s, r);
            return g(a), o;
        }
        function ar(e) {
            var r = [];
            l(e);
            var a = new u(0 | t._crypto_core_ristretto255_scalarbytes()), _ = a.address;
            r.push(_), t._crypto_core_ristretto255_scalar_random(_);
            var n = y(a, e);
            return g(r), n;
        }
        function _r(e, r) {
            var a = [];
            l(r), e = x(a, e, "sample");
            var _, n = 0 | t._crypto_core_ristretto255_nonreducedscalarbytes();
            e.length !== n && f(a, "invalid sample length"), _ = d(e), a.push(_);
            var s = new u(0 | t._crypto_core_ristretto255_scalarbytes()), c = s.address;
            a.push(c), t._crypto_core_ristretto255_scalar_reduce(c, _);
            var o = y(s, r);
            return g(a), o;
        }
        function nr(e, r, a) {
            var _ = [];
            l(a), e = x(_, e, "x");
            var n, s = 0 | t._crypto_core_ristretto255_scalarbytes();
            e.length !== s && f(_, "invalid x length"), n = d(e), _.push(n), r = x(_, r, "y");
            var c, o = 0 | t._crypto_core_ristretto255_scalarbytes();
            r.length !== o && f(_, "invalid y length"), c = d(r), _.push(c);
            var h = new u(0 | t._crypto_core_ristretto255_scalarbytes()), p = h.address;
            _.push(p), t._crypto_core_ristretto255_scalar_sub(p, n, c);
            var i = y(h, a);
            return g(_), i;
        }
        function sr(e, r, a) {
            var _ = [];
            l(a), e = x(_, e, "p");
            var n, s = 0 | t._crypto_core_ristretto255_bytes();
            e.length !== s && f(_, "invalid p length"), n = d(e), _.push(n), r = x(_, r, "q");
            var c, o = 0 | t._crypto_core_ristretto255_bytes();
            r.length !== o && f(_, "invalid q length"), c = d(r), _.push(c);
            var h = new u(0 | t._crypto_core_ristretto255_bytes()), p = h.address;
            if (_.push(p), 0 == (0 | t._crypto_core_ristretto255_sub(p, n, c))) {
                var i = y(h, a);
                return g(_), i;
            }
            b(_, "input is an invalid element");
        }
        function cr(e, r, a, _) {
            var n = [];
            l(_), m(n, e, "hash_length"), ("number" != typeof e || (0 | e) !== e || e < 0) && f(n, "hash_length must be an unsigned integer");
            var s = d(r = x(n, r, "message")), c = r.length;
            n.push(s);
            var o = null, h = 0;
            null != a && (o = d(a = x(n, a, "key")), h = a.length, n.push(o));
            var p = new u(e |= 0), i = p.address;
            if (n.push(i), 0 == (0 | t._crypto_generichash(i, e, s, c, 0, o, h))) {
                var v = y(p, _);
                return g(n), v;
            }
            b(n, "invalid usage");
        }
        function or(e, r, a, _, n) {
            var s = [];
            l(n), m(s, e, "subkey_len"), ("number" != typeof e || (0 | e) !== e || e < 0) && f(s, "subkey_len must be an unsigned integer");
            var c = null, o = 0;
            null != r && (c = d(r = x(s, r, "key")), o = r.length, s.push(c));
            var h = null, p = 0;
            null != a && (a = x(s, a, "id"), p = 0 | t._crypto_generichash_blake2b_saltbytes(), a.length !== p && f(s, "invalid id length"), h = d(a), s.push(h));
            var i = null, v = 0;
            null != _ && (_ = x(s, _, "ctx"), v = 0 | t._crypto_generichash_blake2b_personalbytes(), _.length !== v && f(s, "invalid ctx length"), i = d(_), s.push(i));
            var E = new u(0 | e), k = E.address;
            if (s.push(k), 0 == (0 | t._crypto_generichash_blake2b_salt_personal(k, e, null, 0, 0, c, o, h, i))) {
                var S = y(E, n);
                return g(s), S;
            }
            b(s, "invalid usage");
        }
        function hr(e, r, a) {
            var _ = [];
            l(a), m(_, e, "state_address"), m(_, r, "hash_length"), ("number" != typeof r || (0 | r) !== r || r < 0) && f(_, "hash_length must be an unsigned integer");
            var n = new u(r |= 0), s = n.address;
            if (_.push(s), 0 == (0 | t._crypto_generichash_final(e, s, r))) {
                var c = (t._free(e), y(n, a));
                return g(_), c;
            }
            b(_, "invalid usage");
        }
        function pr(e, r, a) {
            var _ = [];
            l(a);
            var n = null, s = 0;
            null != e && (n = d(e = x(_, e, "key")), s = e.length, _.push(n)), m(_, r, "hash_length"), ("number" != typeof r || (0 | r) !== r || r < 0) && f(_, "hash_length must be an unsigned integer");
            var c = new u(357).address;
            if (0 == (0 | t._crypto_generichash_init(c, n, s, r))) {
                var o = c;
                return g(_), o;
            }
            b(_, "invalid usage");
        }
        function yr(e) {
            var r = [];
            l(e);
            var a = new u(0 | t._crypto_generichash_keybytes()), _ = a.address;
            r.push(_), t._crypto_generichash_keygen(_);
            var n = y(a, e);
            return g(r), n;
        }
        function ir(e, r, a) {
            var _ = [];
            l(a), m(_, e, "state_address");
            var n = d(r = x(_, r, "message_chunk")), s = r.length;
            _.push(n), 0 != (0 | t._crypto_generichash_update(e, n, s)) && b(_, "invalid usage"), g(_);
        }
        function lr(e, r) {
            var a = [];
            l(r);
            var _ = d(e = x(a, e, "message")), n = e.length;
            a.push(_);
            var s = new u(0 | t._crypto_hash_bytes()), c = s.address;
            if (a.push(c), 0 == (0 | t._crypto_hash(c, _, n, 0))) {
                var o = y(s, r);
                return g(a), o;
            }
            b(a, "invalid usage");
        }
        function ur(e, r) {
            var a = [];
            l(r);
            var _ = d(e = x(a, e, "message")), n = e.length;
            a.push(_);
            var s = new u(0 | t._crypto_hash_sha256_bytes()), c = s.address;
            if (a.push(c), 0 == (0 | t._crypto_hash_sha256(c, _, n, 0))) {
                var o = y(s, r);
                return g(a), o;
            }
            b(a, "invalid usage");
        }
        function dr(e, r) {
            var a = [];
            l(r), m(a, e, "state_address");
            var _ = new u(0 | t._crypto_hash_sha256_bytes()), n = _.address;
            if (a.push(n), 0 == (0 | t._crypto_hash_sha256_final(e, n))) {
                var s = (t._free(e), y(_, r));
                return g(a), s;
            }
            b(a, "invalid usage");
        }
        function vr(e) {
            var r = [];
            l(e);
            var a = new u(104).address;
            if (0 == (0 | t._crypto_hash_sha256_init(a))) {
                var _ = a;
                return g(r), _;
            }
            b(r, "invalid usage");
        }
        function gr(e, r, a) {
            var _ = [];
            l(a), m(_, e, "state_address");
            var n = d(r = x(_, r, "message_chunk")), s = r.length;
            _.push(n), 0 != (0 | t._crypto_hash_sha256_update(e, n, s)) && b(_, "invalid usage"), g(_);
        }
        function br(e, r) {
            var a = [];
            l(r);
            var _ = d(e = x(a, e, "message")), n = e.length;
            a.push(_);
            var s = new u(0 | t._crypto_hash_sha512_bytes()), c = s.address;
            if (a.push(c), 0 == (0 | t._crypto_hash_sha512(c, _, n, 0))) {
                var o = y(s, r);
                return g(a), o;
            }
            b(a, "invalid usage");
        }
        function fr(e, r) {
            var a = [];
            l(r), m(a, e, "state_address");
            var _ = new u(0 | t._crypto_hash_sha512_bytes()), n = _.address;
            if (a.push(n), 0 == (0 | t._crypto_hash_sha512_final(e, n))) {
                var s = (t._free(e), y(_, r));
                return g(a), s;
            }
            b(a, "invalid usage");
        }
        function mr(e) {
            var r = [];
            l(e);
            var a = new u(208).address;
            if (0 == (0 | t._crypto_hash_sha512_init(a))) {
                var _ = a;
                return g(r), _;
            }
            b(r, "invalid usage");
        }
        function xr(e, r, a) {
            var _ = [];
            l(a), m(_, e, "state_address");
            var n = d(r = x(_, r, "message_chunk")), s = r.length;
            _.push(n), 0 != (0 | t._crypto_hash_sha512_update(e, n, s)) && b(_, "invalid usage"), g(_);
        }
        function Er(e, r, a, _, s) {
            var c = [];
            l(s), m(c, e, "subkey_len"), ("number" != typeof e || (0 | e) !== e || e < 0) && f(c, "subkey_len must be an unsigned integer"), m(c, r, "subkey_id"), ("number" != typeof r || (0 | r) !== r || r < 0) && f(c, "subkey_id must be an unsigned integer"), "string" != typeof a && f(c, "ctx must be a string"), a = n(a + "\x00"), null != h && a.length - 1 !== h && f(c, "invalid ctx length");
            var o = d(a), h = a.length - 1;
            c.push(o), _ = x(c, _, "key");
            var p, i = 0 | t._crypto_kdf_keybytes();
            _.length !== i && f(c, "invalid key length"), p = d(_), c.push(p);
            var v = new u(0 | e), b = v.address;
            c.push(b), t._crypto_kdf_derive_from_key(b, e, r, r >>> 24 >>> 8, o, p);
            var E = y(v, s);
            return g(c), E;
        }
        function kr(e) {
            var r = [];
            l(e);
            var a = new u(0 | t._crypto_kdf_keybytes()), _ = a.address;
            r.push(_), t._crypto_kdf_keygen(_);
            var n = y(a, e);
            return g(r), n;
        }
        function Sr(e, r, a, _) {
            var n = [];
            l(_), e = x(n, e, "clientPublicKey");
            var s, c = 0 | t._crypto_kx_publickeybytes();
            e.length !== c && f(n, "invalid clientPublicKey length"), s = d(e), n.push(s), r = x(n, r, "clientSecretKey");
            var o, h = 0 | t._crypto_kx_secretkeybytes();
            r.length !== h && f(n, "invalid clientSecretKey length"), o = d(r), n.push(o), a = x(n, a, "serverPublicKey");
            var p, i = 0 | t._crypto_kx_publickeybytes();
            a.length !== i && f(n, "invalid serverPublicKey length"), p = d(a), n.push(p);
            var v = new u(0 | t._crypto_kx_sessionkeybytes()), m = v.address;
            n.push(m);
            var E = new u(0 | t._crypto_kx_sessionkeybytes()), k = E.address;
            if (n.push(k), 0 == (0 | t._crypto_kx_client_session_keys(m, k, s, o, p))) {
                var S = y({
                    sharedRx: v,
                    sharedTx: E
                }, _);
                return g(n), S;
            }
            b(n, "invalid usage");
        }
        function Tr(e) {
            var r = [];
            l(e);
            var a = new u(0 | t._crypto_kx_publickeybytes()), _ = a.address;
            r.push(_);
            var n = new u(0 | t._crypto_kx_secretkeybytes()), s = n.address;
            if (r.push(s), 0 == (0 | t._crypto_kx_keypair(_, s))) {
                var c = {
                    publicKey: y(a, e),
                    privateKey: y(n, e),
                    keyType: "x25519"
                };
                return g(r), c;
            }
            b(r, "internal error");
        }
        function wr(e, r) {
            var a = [];
            l(r), e = x(a, e, "seed");
            var _, n = 0 | t._crypto_kx_seedbytes();
            e.length !== n && f(a, "invalid seed length"), _ = d(e), a.push(_);
            var s = new u(0 | t._crypto_kx_publickeybytes()), c = s.address;
            a.push(c);
            var o = new u(0 | t._crypto_kx_secretkeybytes()), h = o.address;
            if (a.push(h), 0 == (0 | t._crypto_kx_seed_keypair(c, h, _))) {
                var p = {
                    publicKey: y(s, r),
                    privateKey: y(o, r),
                    keyType: "x25519"
                };
                return g(a), p;
            }
            b(a, "internal error");
        }
        function Yr(e, r, a, _) {
            var n = [];
            l(_), e = x(n, e, "serverPublicKey");
            var s, c = 0 | t._crypto_kx_publickeybytes();
            e.length !== c && f(n, "invalid serverPublicKey length"), s = d(e), n.push(s), r = x(n, r, "serverSecretKey");
            var o, h = 0 | t._crypto_kx_secretkeybytes();
            r.length !== h && f(n, "invalid serverSecretKey length"), o = d(r), n.push(o), a = x(n, a, "clientPublicKey");
            var p, i = 0 | t._crypto_kx_publickeybytes();
            a.length !== i && f(n, "invalid clientPublicKey length"), p = d(a), n.push(p);
            var v = new u(0 | t._crypto_kx_sessionkeybytes()), m = v.address;
            n.push(m);
            var E = new u(0 | t._crypto_kx_sessionkeybytes()), k = E.address;
            if (n.push(k), 0 == (0 | t._crypto_kx_server_session_keys(m, k, s, o, p))) {
                var S = y({
                    sharedRx: v,
                    sharedTx: E
                }, _);
                return g(n), S;
            }
            b(n, "invalid usage");
        }
        function Br(e, r, a) {
            var _ = [];
            l(a);
            var n = d(e = x(_, e, "message")), s = e.length;
            _.push(n), r = x(_, r, "key");
            var c, o = 0 | t._crypto_onetimeauth_keybytes();
            r.length !== o && f(_, "invalid key length"), c = d(r), _.push(c);
            var h = new u(0 | t._crypto_onetimeauth_bytes()), p = h.address;
            if (_.push(p), 0 == (0 | t._crypto_onetimeauth(p, n, s, 0, c))) {
                var i = y(h, a);
                return g(_), i;
            }
            b(_, "invalid usage");
        }
        function Ar(e, r) {
            var a = [];
            l(r), m(a, e, "state_address");
            var _ = new u(0 | t._crypto_onetimeauth_bytes()), n = _.address;
            if (a.push(n), 0 == (0 | t._crypto_onetimeauth_final(e, n))) {
                var s = (t._free(e), y(_, r));
                return g(a), s;
            }
            b(a, "invalid usage");
        }
        function Kr(e, r) {
            var a = [];
            l(r);
            var _ = null;
            null != e && (_ = d(e = x(a, e, "key")), e.length, a.push(_));
            var n = new u(144).address;
            if (0 == (0 | t._crypto_onetimeauth_init(n, _))) {
                var s = n;
                return g(a), s;
            }
            b(a, "invalid usage");
        }
        function Mr(e) {
            var r = [];
            l(e);
            var a = new u(0 | t._crypto_onetimeauth_keybytes()), _ = a.address;
            r.push(_), t._crypto_onetimeauth_keygen(_);
            var n = y(a, e);
            return g(r), n;
        }
        function Ir(e, r, a) {
            var _ = [];
            l(a), m(_, e, "state_address");
            var n = d(r = x(_, r, "message_chunk")), s = r.length;
            _.push(n), 0 != (0 | t._crypto_onetimeauth_update(e, n, s)) && b(_, "invalid usage"), g(_);
        }
        function Nr(e, r, a) {
            var _ = [];
            e = x(_, e, "hash");
            var n, s = 0 | t._crypto_onetimeauth_bytes();
            e.length !== s && f(_, "invalid hash length"), n = d(e), _.push(n);
            var c = d(r = x(_, r, "message")), o = r.length;
            _.push(c), a = x(_, a, "key");
            var h, p = 0 | t._crypto_onetimeauth_keybytes();
            a.length !== p && f(_, "invalid key length"), h = d(a), _.push(h);
            var y = 0 == (0 | t._crypto_onetimeauth_verify(n, c, o, 0, h));
            return g(_), y;
        }
        function Lr(e, r, a, _, n, s, c) {
            var o = [];
            l(c), m(o, e, "keyLength"), ("number" != typeof e || (0 | e) !== e || e < 0) && f(o, "keyLength must be an unsigned integer");
            var h = d(r = x(o, r, "password")), p = r.length;
            o.push(h), a = x(o, a, "salt");
            var i, v = 0 | t._crypto_pwhash_saltbytes();
            a.length !== v && f(o, "invalid salt length"), i = d(a), o.push(i), m(o, _, "opsLimit"), ("number" != typeof _ || (0 | _) !== _ || _ < 0) && f(o, "opsLimit must be an unsigned integer"), m(o, n, "memLimit"), ("number" != typeof n || (0 | n) !== n || n < 0) && f(o, "memLimit must be an unsigned integer"), m(o, s, "algorithm"), ("number" != typeof s || (0 | s) !== s || s < 0) && f(o, "algorithm must be an unsigned integer");
            var E = new u(0 | e), k = E.address;
            if (o.push(k), 0 == (0 | t._crypto_pwhash(k, e, 0, h, p, 0, i, _, 0, n, s))) {
                var S = y(E, c);
                return g(o), S;
            }
            b(o, "invalid usage");
        }
        function Ur(e, r, a, _, n, s) {
            var c = [];
            l(s), m(c, e, "keyLength"), ("number" != typeof e || (0 | e) !== e || e < 0) && f(c, "keyLength must be an unsigned integer");
            var o = d(r = x(c, r, "password")), h = r.length;
            c.push(o), a = x(c, a, "salt");
            var p, i = 0 | t._crypto_pwhash_scryptsalsa208sha256_saltbytes();
            a.length !== i && f(c, "invalid salt length"), p = d(a), c.push(p), m(c, _, "opsLimit"), ("number" != typeof _ || (0 | _) !== _ || _ < 0) && f(c, "opsLimit must be an unsigned integer"), m(c, n, "memLimit"), ("number" != typeof n || (0 | n) !== n || n < 0) && f(c, "memLimit must be an unsigned integer");
            var v = new u(0 | e), E = v.address;
            if (c.push(E), 0 == (0 | t._crypto_pwhash_scryptsalsa208sha256(E, e, 0, o, h, 0, p, _, 0, n))) {
                var k = y(v, s);
                return g(c), k;
            }
            b(c, "invalid usage");
        }
        function Or(e, r, a, _, n, s, c) {
            var o = [];
            l(c);
            var h = d(e = x(o, e, "password")), p = e.length;
            o.push(h);
            var i = d(r = x(o, r, "salt")), v = r.length;
            o.push(i), m(o, a, "opsLimit"), ("number" != typeof a || (0 | a) !== a || a < 0) && f(o, "opsLimit must be an unsigned integer"), m(o, _, "r"), ("number" != typeof _ || (0 | _) !== _ || _ < 0) && f(o, "r must be an unsigned integer"), m(o, n, "p"), ("number" != typeof n || (0 | n) !== n || n < 0) && f(o, "p must be an unsigned integer"), m(o, s, "keyLength"), ("number" != typeof s || (0 | s) !== s || s < 0) && f(o, "keyLength must be an unsigned integer");
            var E = new u(0 | s), k = E.address;
            if (o.push(k), 0 == (0 | t._crypto_pwhash_scryptsalsa208sha256_ll(h, p, i, v, a, 0, _, n, k, s))) {
                var S = y(E, c);
                return g(o), S;
            }
            b(o, "invalid usage");
        }
        function Cr(e, r, a, _) {
            var n = [];
            l(_);
            var s = d(e = x(n, e, "password")), c = e.length;
            n.push(s), m(n, r, "opsLimit"), ("number" != typeof r || (0 | r) !== r || r < 0) && f(n, "opsLimit must be an unsigned integer"), m(n, a, "memLimit"), ("number" != typeof a || (0 | a) !== a || a < 0) && f(n, "memLimit must be an unsigned integer");
            var o = new u(0 | t._crypto_pwhash_scryptsalsa208sha256_strbytes()).address;
            if (n.push(o), 0 == (0 | t._crypto_pwhash_scryptsalsa208sha256_str(o, s, c, 0, r, 0, a))) {
                var h = t.UTF8ToString(o);
                return g(n), h;
            }
            b(n, "invalid usage");
        }
        function Rr(e, r, a) {
            var _ = [];
            l(a), "string" != typeof e && f(_, "hashed_password must be a string"), e = n(e + "\x00"), null != c && e.length - 1 !== c && f(_, "invalid hashed_password length");
            var s = d(e), c = e.length - 1;
            _.push(s);
            var o = d(r = x(_, r, "password")), h = r.length;
            _.push(o);
            var p = 0 == (0 | t._crypto_pwhash_scryptsalsa208sha256_str_verify(s, o, h, 0));
            return g(_), p;
        }
        function Pr(e, r, a, _) {
            var n = [];
            l(_);
            var s = d(e = x(n, e, "password")), c = e.length;
            n.push(s), m(n, r, "opsLimit"), ("number" != typeof r || (0 | r) !== r || r < 0) && f(n, "opsLimit must be an unsigned integer"), m(n, a, "memLimit"), ("number" != typeof a || (0 | a) !== a || a < 0) && f(n, "memLimit must be an unsigned integer");
            var o = new u(0 | t._crypto_pwhash_strbytes()).address;
            if (n.push(o), 0 == (0 | t._crypto_pwhash_str(o, s, c, 0, r, 0, a))) {
                var h = t.UTF8ToString(o);
                return g(n), h;
            }
            b(n, "invalid usage");
        }
        function Gr(e, r, a, _) {
            var s = [];
            l(_), "string" != typeof e && f(s, "hashed_password must be a string"), e = n(e + "\x00"), null != o && e.length - 1 !== o && f(s, "invalid hashed_password length");
            var c = d(e), o = e.length - 1;
            s.push(c), m(s, r, "opsLimit"), ("number" != typeof r || (0 | r) !== r || r < 0) && f(s, "opsLimit must be an unsigned integer"), m(s, a, "memLimit"), ("number" != typeof a || (0 | a) !== a || a < 0) && f(s, "memLimit must be an unsigned integer");
            var h = 0 != (0 | t._crypto_pwhash_str_needs_rehash(c, r, 0, a));
            return g(s), h;
        }
        function Xr(e, r, a) {
            var _ = [];
            l(a), "string" != typeof e && f(_, "hashed_password must be a string"), e = n(e + "\x00"), null != c && e.length - 1 !== c && f(_, "invalid hashed_password length");
            var s = d(e), c = e.length - 1;
            _.push(s);
            var o = d(r = x(_, r, "password")), h = r.length;
            _.push(o);
            var p = 0 == (0 | t._crypto_pwhash_str_verify(s, o, h, 0));
            return g(_), p;
        }
        function Dr(e, r, a) {
            var _ = [];
            l(a), e = x(_, e, "privateKey");
            var n, s = 0 | t._crypto_scalarmult_scalarbytes();
            e.length !== s && f(_, "invalid privateKey length"), n = d(e), _.push(n), r = x(_, r, "publicKey");
            var c, o = 0 | t._crypto_scalarmult_bytes();
            r.length !== o && f(_, "invalid publicKey length"), c = d(r), _.push(c);
            var h = new u(0 | t._crypto_scalarmult_bytes()), p = h.address;
            if (_.push(p), 0 == (0 | t._crypto_scalarmult(p, n, c))) {
                var i = y(h, a);
                return g(_), i;
            }
            b(_, "weak public key");
        }
        function Fr(e, r) {
            var a = [];
            l(r), e = x(a, e, "privateKey");
            var _, n = 0 | t._crypto_scalarmult_scalarbytes();
            e.length !== n && f(a, "invalid privateKey length"), _ = d(e), a.push(_);
            var s = new u(0 | t._crypto_scalarmult_bytes()), c = s.address;
            if (a.push(c), 0 == (0 | t._crypto_scalarmult_base(c, _))) {
                var o = y(s, r);
                return g(a), o;
            }
            b(a, "unknown error");
        }
        function Vr(e, r, a) {
            var _ = [];
            l(a), e = x(_, e, "n");
            var n, s = 0 | t._crypto_scalarmult_ed25519_scalarbytes();
            e.length !== s && f(_, "invalid n length"), n = d(e), _.push(n), r = x(_, r, "p");
            var c, o = 0 | t._crypto_scalarmult_ed25519_bytes();
            r.length !== o && f(_, "invalid p length"), c = d(r), _.push(c);
            var h = new u(0 | t._crypto_scalarmult_ed25519_bytes()), p = h.address;
            if (_.push(p), 0 == (0 | t._crypto_scalarmult_ed25519(p, n, c))) {
                var i = y(h, a);
                return g(_), i;
            }
            b(_, "invalid point or scalar is 0");
        }
        function Hr(e, r) {
            var a = [];
            l(r), e = x(a, e, "scalar");
            var _, n = 0 | t._crypto_scalarmult_ed25519_scalarbytes();
            e.length !== n && f(a, "invalid scalar length"), _ = d(e), a.push(_);
            var s = new u(0 | t._crypto_scalarmult_ed25519_bytes()), c = s.address;
            if (a.push(c), 0 == (0 | t._crypto_scalarmult_ed25519_base(c, _))) {
                var o = y(s, r);
                return g(a), o;
            }
            b(a, "scalar is 0");
        }
        function qr(e, r) {
            var a = [];
            l(r), e = x(a, e, "scalar");
            var _, n = 0 | t._crypto_scalarmult_ed25519_scalarbytes();
            e.length !== n && f(a, "invalid scalar length"), _ = d(e), a.push(_);
            var s = new u(0 | t._crypto_scalarmult_ed25519_bytes()), c = s.address;
            if (a.push(c), 0 == (0 | t._crypto_scalarmult_ed25519_base_noclamp(c, _))) {
                var o = y(s, r);
                return g(a), o;
            }
            b(a, "scalar is 0");
        }
        function jr(e, r, a) {
            var _ = [];
            l(a), e = x(_, e, "n");
            var n, s = 0 | t._crypto_scalarmult_ed25519_scalarbytes();
            e.length !== s && f(_, "invalid n length"), n = d(e), _.push(n), r = x(_, r, "p");
            var c, o = 0 | t._crypto_scalarmult_ed25519_bytes();
            r.length !== o && f(_, "invalid p length"), c = d(r), _.push(c);
            var h = new u(0 | t._crypto_scalarmult_ed25519_bytes()), p = h.address;
            if (_.push(p), 0 == (0 | t._crypto_scalarmult_ed25519_noclamp(p, n, c))) {
                var i = y(h, a);
                return g(_), i;
            }
            b(_, "invalid point or scalar is 0");
        }
        function zr(e, r, a) {
            var _ = [];
            l(a), e = x(_, e, "scalar");
            var n, s = 0 | t._crypto_scalarmult_ristretto255_scalarbytes();
            e.length !== s && f(_, "invalid scalar length"), n = d(e), _.push(n), r = x(_, r, "element");
            var c, o = 0 | t._crypto_scalarmult_ristretto255_bytes();
            r.length !== o && f(_, "invalid element length"), c = d(r), _.push(c);
            var h = new u(0 | t._crypto_scalarmult_ristretto255_bytes()), p = h.address;
            if (_.push(p), 0 == (0 | t._crypto_scalarmult_ristretto255(p, n, c))) {
                var i = y(h, a);
                return g(_), i;
            }
            b(_, "result is identity element");
        }
        function Wr(e, r) {
            var a = [];
            l(r), e = x(a, e, "scalar");
            var _, n = 0 | t._crypto_core_ristretto255_scalarbytes();
            e.length !== n && f(a, "invalid scalar length"), _ = d(e), a.push(_);
            var s = new u(0 | t._crypto_core_ristretto255_bytes()), c = s.address;
            if (a.push(c), 0 == (0 | t._crypto_scalarmult_ristretto255_base(c, _))) {
                var o = y(s, r);
                return g(a), o;
            }
            b(a, "scalar is 0");
        }
        function Jr(e, r, a, _) {
            var n = [];
            l(_);
            var s = d(e = x(n, e, "message")), c = e.length;
            n.push(s), r = x(n, r, "nonce");
            var o, h = 0 | t._crypto_secretbox_noncebytes();
            r.length !== h && f(n, "invalid nonce length"), o = d(r), n.push(o), a = x(n, a, "key");
            var p, i = 0 | t._crypto_secretbox_keybytes();
            a.length !== i && f(n, "invalid key length"), p = d(a), n.push(p);
            var v = new u(0 | c), m = v.address;
            n.push(m);
            var E = new u(0 | t._crypto_secretbox_macbytes()), k = E.address;
            if (n.push(k), 0 == (0 | t._crypto_secretbox_detached(m, k, s, c, 0, o, p))) {
                var S = y({
                    mac: E,
                    cipher: v
                }, _);
                return g(n), S;
            }
            b(n, "invalid usage");
        }
        function Qr(e, r, a, _) {
            var n = [];
            l(_);
            var s = d(e = x(n, e, "message")), c = e.length;
            n.push(s), r = x(n, r, "nonce");
            var o, h = 0 | t._crypto_secretbox_noncebytes();
            r.length !== h && f(n, "invalid nonce length"), o = d(r), n.push(o), a = x(n, a, "key");
            var p, i = 0 | t._crypto_secretbox_keybytes();
            a.length !== i && f(n, "invalid key length"), p = d(a), n.push(p);
            var v = new u(c + t._crypto_secretbox_macbytes() | 0), m = v.address;
            if (n.push(m), 0 == (0 | t._crypto_secretbox_easy(m, s, c, 0, o, p))) {
                var E = y(v, _);
                return g(n), E;
            }
            b(n, "invalid usage");
        }
        function Zr(e) {
            var r = [];
            l(e);
            var a = new u(0 | t._crypto_secretbox_keybytes()), _ = a.address;
            r.push(_), t._crypto_secretbox_keygen(_);
            var n = y(a, e);
            return g(r), n;
        }
        function $r(e, r, a, _, n) {
            var s = [];
            l(n);
            var c = d(e = x(s, e, "ciphertext")), o = e.length;
            s.push(c), r = x(s, r, "mac");
            var h, p = 0 | t._crypto_secretbox_macbytes();
            r.length !== p && f(s, "invalid mac length"), h = d(r), s.push(h), a = x(s, a, "nonce");
            var i, v = 0 | t._crypto_secretbox_noncebytes();
            a.length !== v && f(s, "invalid nonce length"), i = d(a), s.push(i), _ = x(s, _, "key");
            var m, E = 0 | t._crypto_secretbox_keybytes();
            _.length !== E && f(s, "invalid key length"), m = d(_), s.push(m);
            var k = new u(0 | o), S = k.address;
            if (s.push(S), 0 == (0 | t._crypto_secretbox_open_detached(S, c, h, o, 0, i, m))) {
                var T = y(k, n);
                return g(s), T;
            }
            b(s, "wrong secret key for the given ciphertext");
        }
        function et(e, r, a, _) {
            var n = [];
            l(_), e = x(n, e, "ciphertext");
            var s, c = t._crypto_secretbox_macbytes(), o = e.length;
            o < c && f(n, "ciphertext is too short"), s = d(e), n.push(s), r = x(n, r, "nonce");
            var h, p = 0 | t._crypto_secretbox_noncebytes();
            r.length !== p && f(n, "invalid nonce length"), h = d(r), n.push(h), a = x(n, a, "key");
            var i, v = 0 | t._crypto_secretbox_keybytes();
            a.length !== v && f(n, "invalid key length"), i = d(a), n.push(i);
            var m = new u(o - t._crypto_secretbox_macbytes() | 0), E = m.address;
            if (n.push(E), 0 == (0 | t._crypto_secretbox_open_easy(E, s, o, 0, h, i))) {
                var k = y(m, _);
                return g(n), k;
            }
            b(n, "wrong secret key for the given ciphertext");
        }
        function rt(e, r, a) {
            var _ = [];
            l(a), e = x(_, e, "header");
            var n, s = 0 | t._crypto_secretstream_xchacha20poly1305_headerbytes();
            e.length !== s && f(_, "invalid header length"), n = d(e), _.push(n), r = x(_, r, "key");
            var c, o = 0 | t._crypto_secretstream_xchacha20poly1305_keybytes();
            r.length !== o && f(_, "invalid key length"), c = d(r), _.push(c);
            var h = new u(52).address;
            if (0 == (0 | t._crypto_secretstream_xchacha20poly1305_init_pull(h, n, c))) {
                var p = h;
                return g(_), p;
            }
            b(_, "invalid usage");
        }
        function tt(e, r) {
            var a = [];
            l(r), e = x(a, e, "key");
            var _, n = 0 | t._crypto_secretstream_xchacha20poly1305_keybytes();
            e.length !== n && f(a, "invalid key length"), _ = d(e), a.push(_);
            var s = new u(52).address, c = new u(0 | t._crypto_secretstream_xchacha20poly1305_headerbytes()), o = c.address;
            if (a.push(o), 0 == (0 | t._crypto_secretstream_xchacha20poly1305_init_push(s, o, _))) {
                var h = {
                    state: s,
                    header: y(c, r)
                };
                return g(a), h;
            }
            b(a, "invalid usage");
        }
        function at(e) {
            var r = [];
            l(e);
            var a = new u(0 | t._crypto_secretstream_xchacha20poly1305_keybytes()), _ = a.address;
            r.push(_), t._crypto_secretstream_xchacha20poly1305_keygen(_);
            var n = y(a, e);
            return g(r), n;
        }
        function _t(e, r, a, _) {
            var n = [];
            l(_), m(n, e, "state_address"), r = x(n, r, "cipher");
            var s, c = t._crypto_secretstream_xchacha20poly1305_abytes(), o = r.length;
            o < c && f(n, "cipher is too short"), s = d(r), n.push(s);
            var h = null, p = 0;
            null != a && (h = d(a = x(n, a, "ad")), p = a.length, n.push(h));
            var i = new u(o - t._crypto_secretstream_xchacha20poly1305_abytes() | 0), b = i.address;
            n.push(b);
            var E, k = (E = v(1), n.push(E), (k = 0 === t._crypto_secretstream_xchacha20poly1305_pull(e, b, 0, E, s, o, 0, h, p) && {
                tag: t.HEAPU8[E],
                message: i
            }) && {
                message: y(k.message, _),
                tag: k.tag
            });
            return g(n), k;
        }
        function nt(e, r, a, _, n) {
            var s = [];
            l(n), m(s, e, "state_address");
            var c = d(r = x(s, r, "message_chunk")), o = r.length;
            s.push(c);
            var h = null, p = 0;
            null != a && (h = d(a = x(s, a, "ad")), p = a.length, s.push(h)), m(s, _, "tag"), ("number" != typeof _ || (0 | _) !== _ || _ < 0) && f(s, "tag must be an unsigned integer");
            var i = new u(o + t._crypto_secretstream_xchacha20poly1305_abytes() | 0), v = i.address;
            if (s.push(v), 0 == (0 | t._crypto_secretstream_xchacha20poly1305_push(e, v, 0, c, o, 0, h, p, 0, _))) {
                var E = y(i, n);
                return g(s), E;
            }
            b(s, "invalid usage");
        }
        function st(e, r) {
            var a = [];
            return l(r), m(a, e, "state_address"), t._crypto_secretstream_xchacha20poly1305_rekey(e), g(a), !0;
        }
        function ct(e, r, a) {
            var _ = [];
            l(a);
            var n = d(e = x(_, e, "message")), s = e.length;
            _.push(n), r = x(_, r, "key");
            var c, o = 0 | t._crypto_shorthash_keybytes();
            r.length !== o && f(_, "invalid key length"), c = d(r), _.push(c);
            var h = new u(0 | t._crypto_shorthash_bytes()), p = h.address;
            if (_.push(p), 0 == (0 | t._crypto_shorthash(p, n, s, 0, c))) {
                var i = y(h, a);
                return g(_), i;
            }
            b(_, "invalid usage");
        }
        function ot(e) {
            var r = [];
            l(e);
            var a = new u(0 | t._crypto_shorthash_keybytes()), _ = a.address;
            r.push(_), t._crypto_shorthash_keygen(_);
            var n = y(a, e);
            return g(r), n;
        }
        function ht(e, r, a) {
            var _ = [];
            l(a);
            var n = d(e = x(_, e, "message")), s = e.length;
            _.push(n), r = x(_, r, "key");
            var c, o = 0 | t._crypto_shorthash_siphashx24_keybytes();
            r.length !== o && f(_, "invalid key length"), c = d(r), _.push(c);
            var h = new u(0 | t._crypto_shorthash_siphashx24_bytes()), p = h.address;
            if (_.push(p), 0 == (0 | t._crypto_shorthash_siphashx24(p, n, s, 0, c))) {
                var i = y(h, a);
                return g(_), i;
            }
            b(_, "invalid usage");
        }
        function pt(e, r, a) {
            var _ = [];
            l(a);
            var n = d(e = x(_, e, "message")), s = e.length;
            _.push(n), r = x(_, r, "privateKey");
            var c, o = 0 | t._crypto_sign_secretkeybytes();
            r.length !== o && f(_, "invalid privateKey length"), c = d(r), _.push(c);
            var h = new u(e.length + t._crypto_sign_bytes() | 0), p = h.address;
            if (_.push(p), 0 == (0 | t._crypto_sign(p, null, n, s, 0, c))) {
                var i = y(h, a);
                return g(_), i;
            }
            b(_, "invalid usage");
        }
        function yt(e, r, a) {
            var _ = [];
            l(a);
            var n = d(e = x(_, e, "message")), s = e.length;
            _.push(n), r = x(_, r, "privateKey");
            var c, o = 0 | t._crypto_sign_secretkeybytes();
            r.length !== o && f(_, "invalid privateKey length"), c = d(r), _.push(c);
            var h = new u(0 | t._crypto_sign_bytes()), p = h.address;
            if (_.push(p), 0 == (0 | t._crypto_sign_detached(p, null, n, s, 0, c))) {
                var i = y(h, a);
                return g(_), i;
            }
            b(_, "invalid usage");
        }
        function it(e, r) {
            var a = [];
            l(r), e = x(a, e, "edPk");
            var _, n = 0 | t._crypto_sign_publickeybytes();
            e.length !== n && f(a, "invalid edPk length"), _ = d(e), a.push(_);
            var s = new u(0 | t._crypto_scalarmult_scalarbytes()), c = s.address;
            if (a.push(c), 0 == (0 | t._crypto_sign_ed25519_pk_to_curve25519(c, _))) {
                var o = y(s, r);
                return g(a), o;
            }
            b(a, "invalid key");
        }
        function lt(e, r) {
            var a = [];
            l(r), e = x(a, e, "edSk");
            var _, n = 0 | t._crypto_sign_secretkeybytes();
            e.length !== n && f(a, "invalid edSk length"), _ = d(e), a.push(_);
            var s = new u(0 | t._crypto_scalarmult_scalarbytes()), c = s.address;
            if (a.push(c), 0 == (0 | t._crypto_sign_ed25519_sk_to_curve25519(c, _))) {
                var o = y(s, r);
                return g(a), o;
            }
            b(a, "invalid key");
        }
        function ut(e, r) {
            var a = [];
            l(r), e = x(a, e, "privateKey");
            var _, n = 0 | t._crypto_sign_secretkeybytes();
            e.length !== n && f(a, "invalid privateKey length"), _ = d(e), a.push(_);
            var s = new u(0 | t._crypto_sign_publickeybytes()), c = s.address;
            if (a.push(c), 0 == (0 | t._crypto_sign_ed25519_sk_to_pk(c, _))) {
                var o = y(s, r);
                return g(a), o;
            }
            b(a, "invalid key");
        }
        function dt(e, r) {
            var a = [];
            l(r), e = x(a, e, "privateKey");
            var _, n = 0 | t._crypto_sign_secretkeybytes();
            e.length !== n && f(a, "invalid privateKey length"), _ = d(e), a.push(_);
            var s = new u(0 | t._crypto_sign_seedbytes()), c = s.address;
            if (a.push(c), 0 == (0 | t._crypto_sign_ed25519_sk_to_seed(c, _))) {
                var o = y(s, r);
                return g(a), o;
            }
            b(a, "invalid key");
        }
        function vt(e, r, a) {
            var _ = [];
            l(a), m(_, e, "state_address"), r = x(_, r, "privateKey");
            var n, s = 0 | t._crypto_sign_secretkeybytes();
            r.length !== s && f(_, "invalid privateKey length"), n = d(r), _.push(n);
            var c = new u(0 | t._crypto_sign_bytes()), o = c.address;
            if (_.push(o), 0 == (0 | t._crypto_sign_final_create(e, o, null, n))) {
                var h = (t._free(e), y(c, a));
                return g(_), h;
            }
            b(_, "invalid usage");
        }
        function gt(e, r, a, _) {
            var n = [];
            l(_), m(n, e, "state_address"), r = x(n, r, "signature");
            var s, c = 0 | t._crypto_sign_bytes();
            r.length !== c && f(n, "invalid signature length"), s = d(r), n.push(s), a = x(n, a, "publicKey");
            var o, h = 0 | t._crypto_sign_publickeybytes();
            a.length !== h && f(n, "invalid publicKey length"), o = d(a), n.push(o);
            var p = 0 == (0 | t._crypto_sign_final_verify(e, s, o));
            return g(n), p;
        }
        function bt(e) {
            var r = [];
            l(e);
            var a = new u(208).address;
            if (0 == (0 | t._crypto_sign_init(a))) {
                var _ = a;
                return g(r), _;
            }
            b(r, "internal error");
        }
        function ft(e) {
            var r = [];
            l(e);
            var a = new u(0 | t._crypto_sign_publickeybytes()), _ = a.address;
            r.push(_);
            var n = new u(0 | t._crypto_sign_secretkeybytes()), s = n.address;
            if (r.push(s), 0 == (0 | t._crypto_sign_keypair(_, s))) {
                var c = {
                    publicKey: y(a, e),
                    privateKey: y(n, e),
                    keyType: "ed25519"
                };
                return g(r), c;
            }
            b(r, "internal error");
        }
        function mt(e, r, a) {
            var _ = [];
            l(a), e = x(_, e, "signedMessage");
            var n, s = t._crypto_sign_bytes(), c = e.length;
            c < s && f(_, "signedMessage is too short"), n = d(e), _.push(n), r = x(_, r, "publicKey");
            var o, h = 0 | t._crypto_sign_publickeybytes();
            r.length !== h && f(_, "invalid publicKey length"), o = d(r), _.push(o);
            var p = new u(c - t._crypto_sign_bytes() | 0), i = p.address;
            if (_.push(i), 0 == (0 | t._crypto_sign_open(i, null, n, c, 0, o))) {
                var v = y(p, a);
                return g(_), v;
            }
            b(_, "incorrect signature for the given public key");
        }
        function xt(e, r) {
            var a = [];
            l(r), e = x(a, e, "seed");
            var _, n = 0 | t._crypto_sign_seedbytes();
            e.length !== n && f(a, "invalid seed length"), _ = d(e), a.push(_);
            var s = new u(0 | t._crypto_sign_publickeybytes()), c = s.address;
            a.push(c);
            var o = new u(0 | t._crypto_sign_secretkeybytes()), h = o.address;
            if (a.push(h), 0 == (0 | t._crypto_sign_seed_keypair(c, h, _))) {
                var p = {
                    publicKey: y(s, r),
                    privateKey: y(o, r),
                    keyType: "ed25519"
                };
                return g(a), p;
            }
            b(a, "invalid usage");
        }
        function Et(e, r, a) {
            var _ = [];
            l(a), m(_, e, "state_address");
            var n = d(r = x(_, r, "message_chunk")), s = r.length;
            _.push(n), 0 != (0 | t._crypto_sign_update(e, n, s, 0)) && b(_, "invalid usage"), g(_);
        }
        function kt(e, r, a) {
            var _ = [];
            e = x(_, e, "signature");
            var n, s = 0 | t._crypto_sign_bytes();
            e.length !== s && f(_, "invalid signature length"), n = d(e), _.push(n);
            var c = d(r = x(_, r, "message")), o = r.length;
            _.push(c), a = x(_, a, "publicKey");
            var h, p = 0 | t._crypto_sign_publickeybytes();
            a.length !== p && f(_, "invalid publicKey length"), h = d(a), _.push(h);
            var y = 0 == (0 | t._crypto_sign_verify_detached(n, c, o, 0, h));
            return g(_), y;
        }
        function St(e, r, a, _) {
            var n = [];
            l(_), m(n, e, "outLength"), ("number" != typeof e || (0 | e) !== e || e < 0) && f(n, "outLength must be an unsigned integer"), r = x(n, r, "key");
            var s, c = 0 | t._crypto_stream_chacha20_keybytes();
            r.length !== c && f(n, "invalid key length"), s = d(r), n.push(s), a = x(n, a, "nonce");
            var o, h = 0 | t._crypto_stream_chacha20_noncebytes();
            a.length !== h && f(n, "invalid nonce length"), o = d(a), n.push(o);
            var p = new u(0 | e), i = p.address;
            n.push(i), t._crypto_stream_chacha20(i, e, 0, o, s);
            var v = y(p, _);
            return g(n), v;
        }
        function Tt(e, r, a, _) {
            var n = [];
            l(_);
            var s = d(e = x(n, e, "input_message")), c = e.length;
            n.push(s), r = x(n, r, "nonce");
            var o, h = 0 | t._crypto_stream_chacha20_ietf_noncebytes();
            r.length !== h && f(n, "invalid nonce length"), o = d(r), n.push(o), a = x(n, a, "key");
            var p, i = 0 | t._crypto_stream_chacha20_ietf_keybytes();
            a.length !== i && f(n, "invalid key length"), p = d(a), n.push(p);
            var v = new u(0 | c), m = v.address;
            if (n.push(m), 0 === t._crypto_stream_chacha20_ietf_xor(m, s, c, 0, o, p)) {
                var E = y(v, _);
                return g(n), E;
            }
            b(n, "invalid usage");
        }
        function wt(e, r, a, _, n) {
            var s = [];
            l(n);
            var c = d(e = x(s, e, "input_message")), o = e.length;
            s.push(c), r = x(s, r, "nonce");
            var h, p = 0 | t._crypto_stream_chacha20_ietf_noncebytes();
            r.length !== p && f(s, "invalid nonce length"), h = d(r), s.push(h), m(s, a, "nonce_increment"), ("number" != typeof a || (0 | a) !== a || a < 0) && f(s, "nonce_increment must be an unsigned integer"), _ = x(s, _, "key");
            var i, v = 0 | t._crypto_stream_chacha20_ietf_keybytes();
            _.length !== v && f(s, "invalid key length"), i = d(_), s.push(i);
            var E = new u(0 | o), k = E.address;
            if (s.push(k), 0 === t._crypto_stream_chacha20_ietf_xor_ic(k, c, o, 0, h, a, i)) {
                var S = y(E, n);
                return g(s), S;
            }
            b(s, "invalid usage");
        }
        function Yt(e) {
            var r = [];
            l(e);
            var a = new u(0 | t._crypto_stream_chacha20_keybytes()), _ = a.address;
            r.push(_), t._crypto_stream_chacha20_keygen(_);
            var n = y(a, e);
            return g(r), n;
        }
        function Bt(e, r, a, _) {
            var n = [];
            l(_);
            var s = d(e = x(n, e, "input_message")), c = e.length;
            n.push(s), r = x(n, r, "nonce");
            var o, h = 0 | t._crypto_stream_chacha20_noncebytes();
            r.length !== h && f(n, "invalid nonce length"), o = d(r), n.push(o), a = x(n, a, "key");
            var p, i = 0 | t._crypto_stream_chacha20_keybytes();
            a.length !== i && f(n, "invalid key length"), p = d(a), n.push(p);
            var v = new u(0 | c), m = v.address;
            if (n.push(m), 0 === t._crypto_stream_chacha20_xor(m, s, c, 0, o, p)) {
                var E = y(v, _);
                return g(n), E;
            }
            b(n, "invalid usage");
        }
        function At(e, r, a, _, n) {
            var s = [];
            l(n);
            var c = d(e = x(s, e, "input_message")), o = e.length;
            s.push(c), r = x(s, r, "nonce");
            var h, p = 0 | t._crypto_stream_chacha20_noncebytes();
            r.length !== p && f(s, "invalid nonce length"), h = d(r), s.push(h), m(s, a, "nonce_increment"), ("number" != typeof a || (0 | a) !== a || a < 0) && f(s, "nonce_increment must be an unsigned integer"), _ = x(s, _, "key");
            var i, v = 0 | t._crypto_stream_chacha20_keybytes();
            _.length !== v && f(s, "invalid key length"), i = d(_), s.push(i);
            var E = new u(0 | o), k = E.address;
            if (s.push(k), 0 === t._crypto_stream_chacha20_xor_ic(k, c, o, 0, h, a, 0, i)) {
                var S = y(E, n);
                return g(s), S;
            }
            b(s, "invalid usage");
        }
        function Kt(e) {
            var r = [];
            l(e);
            var a = new u(0 | t._crypto_stream_keybytes()), _ = a.address;
            r.push(_), t._crypto_stream_keygen(_);
            var n = y(a, e);
            return g(r), n;
        }
        function Mt(e) {
            var r = [];
            l(e);
            var a = new u(0 | t._crypto_stream_xchacha20_keybytes()), _ = a.address;
            r.push(_), t._crypto_stream_xchacha20_keygen(_);
            var n = y(a, e);
            return g(r), n;
        }
        function It(e, r, a, _) {
            var n = [];
            l(_);
            var s = d(e = x(n, e, "input_message")), c = e.length;
            n.push(s), r = x(n, r, "nonce");
            var o, h = 0 | t._crypto_stream_xchacha20_noncebytes();
            r.length !== h && f(n, "invalid nonce length"), o = d(r), n.push(o), a = x(n, a, "key");
            var p, i = 0 | t._crypto_stream_xchacha20_keybytes();
            a.length !== i && f(n, "invalid key length"), p = d(a), n.push(p);
            var v = new u(0 | c), m = v.address;
            if (n.push(m), 0 === t._crypto_stream_xchacha20_xor(m, s, c, 0, o, p)) {
                var E = y(v, _);
                return g(n), E;
            }
            b(n, "invalid usage");
        }
        function Nt(e, r, a, _, n) {
            var s = [];
            l(n);
            var c = d(e = x(s, e, "input_message")), o = e.length;
            s.push(c), r = x(s, r, "nonce");
            var h, p = 0 | t._crypto_stream_xchacha20_noncebytes();
            r.length !== p && f(s, "invalid nonce length"), h = d(r), s.push(h), m(s, a, "nonce_increment"), ("number" != typeof a || (0 | a) !== a || a < 0) && f(s, "nonce_increment must be an unsigned integer"), _ = x(s, _, "key");
            var i, v = 0 | t._crypto_stream_xchacha20_keybytes();
            _.length !== v && f(s, "invalid key length"), i = d(_), s.push(i);
            var E = new u(0 | o), k = E.address;
            if (s.push(k), 0 === t._crypto_stream_xchacha20_xor_ic(k, c, o, 0, h, a, 0, i)) {
                var S = y(E, n);
                return g(s), S;
            }
            b(s, "invalid usage");
        }
        function Lt(e, r) {
            var a = [];
            l(r), m(a, e, "length"), ("number" != typeof e || (0 | e) !== e || e < 0) && f(a, "length must be an unsigned integer");
            var _ = new u(0 | e), n = _.address;
            a.push(n), t._randombytes_buf(n, e);
            var s = y(_, r);
            return g(a), s;
        }
        function Ut(e, r, a) {
            var _ = [];
            l(a), m(_, e, "length"), ("number" != typeof e || (0 | e) !== e || e < 0) && f(_, "length must be an unsigned integer"), r = x(_, r, "seed");
            var n, s = 0 | t._randombytes_seedbytes();
            r.length !== s && f(_, "invalid seed length"), n = d(r), _.push(n);
            var c = new u(0 | e), o = c.address;
            _.push(o), t._randombytes_buf_deterministic(o, e, n);
            var h = y(c, a);
            return g(_), h;
        }
        function Ot(e) {
            l(e), t._randombytes_close();
        }
        function Ct(e) {
            l(e);
            var r = t._randombytes_random() >>> 0;
            return g([]), r;
        }
        function Rt(e, r) {
            var a = [];
            l(r);
            for(var _ = t._malloc(24), n = 0; n < 6; n++)t.setValue(_ + 4 * n, t.Runtime.addFunction(e[[
                "implementation_name",
                "random",
                "stir",
                "uniform",
                "buf",
                "close"
            ][n]]), "i32");
            0 != (0 | t._randombytes_set_implementation(_)) && b(a, "unsupported implementation"), g(a);
        }
        function Pt(e) {
            l(e), t._randombytes_stir();
        }
        function Gt(e, r) {
            var a = [];
            l(r), m(a, e, "upper_bound"), ("number" != typeof e || (0 | e) !== e || e < 0) && f(a, "upper_bound must be an unsigned integer");
            var _ = t._randombytes_uniform(e) >>> 0;
            return g(a), _;
        }
        function Xt() {
            var e = t._sodium_version_string(), r = t.UTF8ToString(e);
            return g([]), r;
        }
        return u.prototype.to_Uint8Array = function() {
            var e = new Uint8Array(this.length);
            return e.set(t.HEAPU8.subarray(this.address, this.address + this.length)), e;
        }, e.add = function(e, r) {
            if (!(e instanceof Uint8Array && r instanceof Uint8Array)) throw new TypeError("Only Uint8Array instances can added");
            var t = e.length, a = 0, _ = 0;
            if (r.length != e.length) throw new TypeError("Arguments must have the same length");
            for(_ = 0; _ < t; _++)a >>= 8, a += e[_] + r[_], e[_] = 255 & a;
        }, e.base64_variants = o, e.compare = function(e, r) {
            if (!(e instanceof Uint8Array && r instanceof Uint8Array)) throw new TypeError("Only Uint8Array instances can be compared");
            if (e.length !== r.length) throw new TypeError("Only instances of identical length can be compared");
            for(var t = 0, a = 1, _ = e.length; _-- > 0;)t |= r[_] - e[_] >> 8 & a, a &= (r[_] ^ e[_]) - 1 >> 8;
            return t + t + a - 1;
        }, e.from_base64 = function(e, r) {
            r = h(r);
            var a, _ = [], n = new u(3 * (e = x(_, e, "input")).length / 4), s = d(e), c = v(4), o = v(4);
            return _.push(s), _.push(n.address), _.push(n.result_bin_len_p), _.push(n.b64_end_p), 0 !== t._sodium_base642bin(n.address, n.length, s, e.length, 0, c, o, r) && b(_, "invalid input"), t.getValue(o, "i32") - s !== e.length && b(_, "incomplete input"), n.length = t.getValue(c, "i32"), a = n.to_Uint8Array(), g(_), a;
        }, e.from_hex = function(e) {
            var r, a = [], _ = new u((e = x(a, e, "input")).length / 2), n = d(e), s = v(4);
            return a.push(n), a.push(_.address), a.push(_.hex_end_p), 0 !== t._sodium_hex2bin(_.address, _.length, n, e.length, 0, 0, s) && b(a, "invalid input"), t.getValue(s, "i32") - n !== e.length && b(a, "incomplete input"), r = _.to_Uint8Array(), g(a), r;
        }, e.from_string = n, e.increment = function(e) {
            if (!(e instanceof Uint8Array)) throw new TypeError("Only Uint8Array instances can be incremented");
            for(var r = 256, t = 0, a = e.length; t < a; t++)r >>= 8, r += e[t], e[t] = 255 & r;
        }, e.is_zero = function(e) {
            if (!(e instanceof Uint8Array)) throw new TypeError("Only Uint8Array instances can be checked");
            for(var r = 0, t = 0, a = e.length; t < a; t++)r |= e[t];
            return 0 === r;
        }, e.libsodium = r, e.memcmp = function(e, r) {
            if (!(e instanceof Uint8Array && r instanceof Uint8Array)) throw new TypeError("Only Uint8Array instances can be compared");
            if (e.length !== r.length) throw new TypeError("Only instances of identical length can be compared");
            for(var t = 0, a = 0, _ = e.length; a < _; a++)t |= e[a] ^ r[a];
            return 0 === t;
        }, e.memzero = function(e) {
            if (!(e instanceof Uint8Array)) throw new TypeError("Only Uint8Array instances can be wiped");
            for(var r = 0, t = e.length; r < t; r++)e[r] = 0;
        }, e.output_formats = function() {
            return [
                "uint8array",
                "text",
                "hex",
                "base64"
            ];
        }, e.pad = function(e, r) {
            if (!(e instanceof Uint8Array)) throw new TypeError("buffer must be a Uint8Array");
            if ((r |= 0) <= 0) throw new Error("block size must be > 0");
            var a, _ = [], n = v(4), s = 1, c = 0, o = 0 | e.length, h = new u(o + r);
            _.push(n), _.push(h.address);
            for(var p = h.address, y = h.address + o + r; p < y; p++)t.HEAPU8[p] = e[c], c += s = 1 & ~((65535 & ((o -= s) >>> 48 | o >>> 32 | o >>> 16 | o)) - 1 >> 16);
            return 0 !== t._sodium_pad(n, h.address, e.length, r, h.length) && b(_, "internal error"), h.length = t.getValue(n, "i32"), a = h.to_Uint8Array(), g(_), a;
        }, e.unpad = function(e, r) {
            if (!(e instanceof Uint8Array)) throw new TypeError("buffer must be a Uint8Array");
            if ((r |= 0) <= 0) throw new Error("block size must be > 0");
            var a = [], _ = d(e), n = v(4);
            return a.push(_), a.push(n), 0 !== t._sodium_unpad(n, _, e.length, r) && b(a, "unsupported/invalid padding"), e = (e = new Uint8Array(e)).subarray(0, t.getValue(n, "i32")), g(a), e;
        }, e.ready = _, e.symbols = function() {
            return Object.keys(e).sort();
        }, e.to_base64 = p, e.to_hex = c, e.to_string = s, e;
    }
    var t = "object" == typeof e.sodium && "function" == typeof e.sodium.onload ? e.sodium.onload : null;
    "function" == typeof define && define.amd ? define([
        "exports",
        "libsodium"
    ], r) : "string" != typeof module.exports.nodeName ? r(module.exports, (parcelRequire("9emBY"))) : e.sodium = r(e.commonJsStrict = {}, e.libsodium), t && e.sodium.ready.then(function() {
        t(e.sodium);
    });
}(module.exports);

});
parcelRequire.register("9emBY", function(module, exports) {

var $4TNnu = parcelRequire("4TNnu");
var $6b86f601ca43a026$var$__dirname = "node_modules/libsodium/dist/modules";

var $ihoyg = parcelRequire("ihoyg");
var $6b86f601ca43a026$require$Buffer = $ihoyg.Buffer;






!function(A) {
    function I(A) {
        "use strict";
        var I;
        void 0 === (I = A) && (I = {});
        var g = I;
        "object" != typeof g.sodium && ("object" == typeof $parcel$global ? g = $parcel$global : "object" == typeof window && (g = window));
        var C = I;
        return I.ready = new Promise(function(A, I) {
            (Q = C).onAbort = I, Q.print = function(A) {}, Q.printErr = function(A) {}, Q.onRuntimeInitialized = function() {
                try {
                    Q._crypto_secretbox_keybytes(), A();
                } catch (A) {
                    I(A);
                }
            }, Q.useBackupModule = function() {
                return new Promise(function(A, I) {
                    (Q = {}).onAbort = I, Q.onRuntimeInitialized = function() {
                        Object.keys(C).forEach(function(A) {
                            "getRandomValue" !== A && delete C[A];
                        }), Object.keys(Q).forEach(function(A) {
                            C[A] = Q[A];
                        }), A();
                    };
                    var g, B, Q = void 0 !== Q ? Q : {}, i = Object.assign({}, Q), E = "object" == typeof window, o = "function" == typeof importScripts, a = "object" == typeof $4TNnu && "object" == typeof $4TNnu.versions && "string" == typeof $4TNnu.versions.node, f = "";
                    if (a) {
                        var c = (parcelRequire("5Io6y")), e = (parcelRequire("5Io6y"));
                        f = o ? e.dirname(f) + "/" : $6b86f601ca43a026$var$__dirname + "/", g = (A, I)=>(A = function(A) {
                                return A.startsWith("file://");
                            }(A) ? new URL(A) : e.normalize(A), c.readFileSync(A, I ? void 0 : "utf8")), B = (A)=>{
                            var I = g(A, !0);
                            return I.buffer || (I = new Uint8Array(I)), I;
                        }, !Q.thisProgram && $4TNnu.argv.length > 1 && $4TNnu.argv[1].replace(/\\/g, "/"), $4TNnu.argv.slice(2), module.exports = Q, Q.inspect = ()=>"[Emscripten Module object]";
                    } else (E || o) && (o ? f = self.location.href : "undefined" != typeof document && document.currentScript && (f = document.currentScript.src), f = 0 !== f.indexOf("blob:") ? f.substr(0, f.replace(/[?#].*/, "").lastIndexOf("/") + 1) : "", g = (A)=>{
                        var I = new XMLHttpRequest;
                        return I.open("GET", A, !1), I.send(null), I.responseText;
                    }, o && (B = (A)=>{
                        var I = new XMLHttpRequest;
                        return I.open("GET", A, !1), I.responseType = "arraybuffer", I.send(null), new Uint8Array(I.response);
                    }));
                    Q.print;
                    var r, D = Q.printErr || void 0;
                    Object.assign(Q, i), i = null, Q.arguments && Q.arguments, Q.thisProgram && Q.thisProgram, Q.quit && Q.quit, Q.wasmBinary && (r = Q.wasmBinary), Q.noExitRuntime;
                    var t, y = {
                        Memory: function(A) {
                            this.buffer = new ArrayBuffer(65536 * A.initial);
                        },
                        Module: function(A) {},
                        Instance: function(A, I) {
                            this.exports = function(A) {
                                for(var I, g = new Uint8Array(123), C = 25; C >= 0; --C)g[48 + C] = 52 + C, g[65 + C] = C, g[97 + C] = 26 + C;
                                function B(A, I, C) {
                                    for(var B, Q, i = 0, E = I, o = C.length, a = I + (3 * o >> 2) - ("=" == C[o - 2]) - ("=" == C[o - 1]); i < o; i += 4)B = g[C.charCodeAt(i + 1)], Q = g[C.charCodeAt(i + 2)], A[E++] = g[C.charCodeAt(i)] << 2 | B >> 4, E < a && (A[E++] = B << 4 | Q >> 2), E < a && (A[E++] = Q << 6 | g[C.charCodeAt(i + 3)]);
                                }
                                function Q() {
                                    throw new Error("abort");
                                }
                                return g[43] = 62, g[47] = 63, function(A) {
                                    var g = A.a, C = g.a, i = C.buffer;
                                    C.grow = function(A) {
                                        A |= 0;
                                        var g = 0 | hI(), B = g + A | 0;
                                        if (g < B && B < 65536) {
                                            var Q = new ArrayBuffer(c(B, 65536));
                                            new Int8Array(Q).set(E), E = new Int8Array(Q), new Int16Array(Q), o = new Int32Array(Q), a = new Uint8Array(Q), new Uint16Array(Q), f = new Uint32Array(Q), new Float32Array(Q), new Float64Array(Q), i = Q, C.buffer = i, I = a;
                                        }
                                        return g;
                                    };
                                    var E = new Int8Array(i), o = (new Int16Array(i), new Int32Array(i)), a = new Uint8Array(i), f = (new Uint16Array(i), new Uint32Array(i)), c = (new Float32Array(i), new Float64Array(i), Math.imul), e = (Math.fround, Math.abs, Math.clz32), r = (Math.min, Math.max, Math.floor, Math.ceil, Math.trunc, Math.sqrt, g.b), D = g.c, t = g.d, y = g.e, w = 102096, h = 0;
                                    function n(A, I) {
                                        var g, C, B, Q, i, o = 0, f = 0, c = 0, e = 0, r = 0, D = 0, t = 0, y = 0, w = 0, n = 0, s = 0, k = 0, F = 0, S = 0, H = 0, G = 0, _ = 0, M = 0, p = 0, N = 0, J = 0, U = 0, Y = 0, d = 0, K = 0, b = 0, P = 0, v = 0, L = 0, R = 0, u = 0, x = 0, m = 0, l = 0, z = 0, q = 0, X = 0, j = 0, T = 0, O = 0, V = 0, Z = 0, W = 0, $ = 0, AA = 0, IA = 0, gA = 0, CA = 0, BA = 0, QA = 0, iA = 0, EA = 0, oA = 0, aA = 0, fA = 0, cA = 0, eA = 0, rA = 0, tA = 0, yA = 0, wA = 0, hA = 0, nA = 0, sA = 0, kA = 0, FA = 0, SA = 0, HA = 0, GA = 0, _A = 0, MA = 0, pA = 0, NA = 0, JA = 0;
                                        rA = a[I + 40 | 0] | a[I + 41 | 0] << 8 | a[I + 42 | 0] << 16 | a[I + 43 | 0] << 24, yA = o = a[I + 44 | 0] | a[I + 45 | 0] << 8 | a[I + 46 | 0] << 16 | a[I + 47 | 0] << 24, gA = a[I + 104 | 0] | a[I + 105 | 0] << 8 | a[I + 106 | 0] << 16 | a[I + 107 | 0] << 24, wA = o = a[I + 108 | 0] | a[I + 109 | 0] << 8 | a[I + 110 | 0] << 16 | a[I + 111 | 0] << 24, o = a[I + 68 | 0] | a[I + 69 | 0] << 8 | a[I + 70 | 0] << 16 | a[I + 71 | 0] << 24, X = a[I + 64 | 0] | a[I + 65 | 0] << 8 | a[I + 66 | 0] << 16 | a[I + 67 | 0] << 24, BA = o, MA = o = a[I + 36 | 0] | a[I + 37 | 0] << 8 | a[I + 38 | 0] << 16 | a[I + 39 | 0] << 24, _ = o, oA = a[I + 120 | 0] | a[I + 121 | 0] << 8 | a[I + 122 | 0] << 16 | a[I + 123 | 0] << 24, kA = o = a[I + 124 | 0] | a[I + 125 | 0] << 8 | a[I + 126 | 0] << 16 | a[I + 127 | 0] << 24, B = o = a[I + 92 | 0] | a[I + 93 | 0] << 8 | a[I + 94 | 0] << 16 | a[I + 95 | 0] << 24, g = a[I + 88 | 0] | a[I + 89 | 0] << 8 | a[I + 90 | 0] << 16 | a[I + 91 | 0] << 24, q = o, EA = a[I + 80 | 0] | a[I + 81 | 0] << 8 | a[I + 82 | 0] << 16 | a[I + 83 | 0] << 24, nA = o = a[I + 84 | 0] | a[I + 85 | 0] << 8 | a[I + 86 | 0] << 16 | a[I + 87 | 0] << 24, j = o, QA = a[A + 16 | 0] | a[A + 17 | 0] << 8 | a[A + 18 | 0] << 16 | a[A + 19 | 0] << 24, o = (fA = a[A + 52 | 0] | a[A + 53 | 0] << 8 | a[A + 54 | 0] << 16 | a[A + 55 | 0] << 24) + _ | 0, l = (aA = a[A + 48 | 0] | a[A + 49 | 0] << 8 | a[A + 50 | 0] << 16 | a[A + 51 | 0] << 24) + (cA = a[I + 32 | 0] | a[I + 33 | 0] << 8 | a[I + 34 | 0] << 16 | a[I + 35 | 0] << 24) | 0, o = (a[A + 20 | 0] | a[A + 21 | 0] << 8 | a[A + 22 | 0] << 16 | a[A + 23 | 0] << 24) + (aA >>> 0 > l >>> 0 ? o + 1 | 0 : o) | 0, o = (QA = (f = l) >>> 0 > (l = l + QA | 0) >>> 0 ? o + 1 | 0 : o) + yA | 0, iA = tA = l + rA | 0, tA = o = tA >>> 0 < l >>> 0 ? o + 1 | 0 : o, l = DA(l ^ (a[A + 80 | 0] | a[A + 81 | 0] << 8 | a[A + 82 | 0] << 16 | a[A + 83 | 0] << 24) ^ -79577749, QA ^ (a[A + 84 | 0] | a[A + 85 | 0] << 8 | a[A + 86 | 0] << 16 | a[A + 87 | 0] << 24) ^ 528734635, 32), HA = o = h, o = o + 1013904242 | 0, QA = l, V = o = (l = l - 23791573 | 0) >>> 0 < 4271175723 ? o + 1 | 0 : o, fA = DA(l ^ aA, o ^ fA, 40), o = (o = tA) + (tA = h) | 0, aA = DA(QA ^ (w = aA = fA + iA | 0), HA ^ (n = w >>> 0 < fA >>> 0 ? o + 1 | 0 : o), 48), o = V + (x = h) | 0, S = o = (aA = l + (s = aA) | 0) >>> 0 < l >>> 0 ? o + 1 | 0 : o, aA = o = DA(fA ^ (F = aA), tA ^ o, 1), V = l = h, tA = a[I + 24 | 0] | a[I + 25 | 0] << 8 | a[I + 26 | 0] << 16 | a[I + 27 | 0] << 24, HA = o = a[I + 28 | 0] | a[I + 29 | 0] << 8 | a[I + 30 | 0] << 16 | a[I + 31 | 0] << 24, eA = a[A + 8 | 0] | a[A + 9 | 0] << 8 | a[A + 10 | 0] << 16 | a[A + 11 | 0] << 24, l = (fA = a[I + 16 | 0] | a[I + 17 | 0] << 8 | a[I + 18 | 0] << 16 | a[I + 19 | 0] << 24) + (QA = a[A + 40 | 0] | a[A + 41 | 0] << 8 | a[A + 42 | 0] << 16 | a[A + 43 | 0] << 24) | 0, o = (pA = a[I + 20 | 0] | a[I + 21 | 0] << 8 | a[I + 22 | 0] << 16 | a[I + 23 | 0] << 24) + (JA = a[A + 44 | 0] | a[A + 45 | 0] << 8 | a[A + 46 | 0] << 16 | a[A + 47 | 0] << 24) | 0, o = (a[A + 12 | 0] | a[A + 13 | 0] << 8 | a[A + 14 | 0] << 16 | a[A + 15 | 0] << 24) + (l >>> 0 < QA >>> 0 ? o + 1 | 0 : o) | 0, o = HA + (iA = (f = l) >>> 0 > (l = l + eA | 0) >>> 0 ? o + 1 | 0 : o) | 0, o = (eA = l + tA | 0) >>> 0 < l >>> 0 ? o + 1 | 0 : o, f = DA(l ^ (a[A + 72 | 0] | a[A + 73 | 0] << 8 | a[A + 74 | 0] << 16 | a[A + 75 | 0] << 24) ^ 725511199, iA ^ (a[A + 76 | 0] | a[A + 77 | 0] << 8 | a[A + 78 | 0] << 16 | a[A + 79 | 0] << 24) ^ -1694144372, 32), D = DA(QA ^ (c = f - 2067093701 | 0), JA ^ (R = (K = l = h) - ((f >>> 0 < 2067093701) + 1150833018 | 0) | 0), 40), o = (m = h) + o | 0, o = (d = (H = l = D + eA | 0) >>> 0 < D >>> 0 ? o + 1 | 0 : o) + V | 0, o = (H >>> 0 > (l = H + aA | 0) >>> 0 ? o + 1 | 0 : o) + j | 0, o = (QA = (e = l) >>> 0 > (l = l + EA | 0) >>> 0 ? o + 1 | 0 : o) + q | 0, v = q = l + g | 0, y = o = q >>> 0 < l >>> 0 ? o + 1 | 0 : o, k = aA, FA = V, V = l, iA = QA, aA = a[I + 8 | 0] | a[I + 9 | 0] << 8 | a[I + 10 | 0] << 16 | a[I + 11 | 0] << 24, l = o = a[I + 12 | 0] | a[I + 13 | 0] << 8 | a[I + 14 | 0] << 16 | a[I + 15 | 0] << 24, JA = o = a[0 | A] | a[A + 1 | 0] << 8 | a[A + 2 | 0] << 16 | a[A + 3 | 0] << 24, Q = QA = a[A + 4 | 0] | a[A + 5 | 0] << 8 | a[A + 6 | 0] << 16 | a[A + 7 | 0] << 24, j = o, o = (GA = a[I + 4 | 0] | a[I + 5 | 0] << 8 | a[I + 6 | 0] << 16 | a[I + 7 | 0] << 24) + (r = a[A + 36 | 0] | a[A + 37 | 0] << 8 | a[A + 38 | 0] << 16 | a[A + 39 | 0] << 24) | 0, o = Q + ((q = a[A + 32 | 0] | a[A + 33 | 0] << 8 | a[A + 34 | 0] << 16 | a[A + 35 | 0] << 24) >>> 0 > (e = q + (QA = a[0 | I] | a[I + 1 | 0] << 8 | a[I + 2 | 0] << 16 | a[I + 3 | 0] << 24) | 0) >>> 0 ? o + 1 | 0 : o) | 0, o = (eA = (j = e + j | 0) >>> 0 < e >>> 0 ? o + 1 | 0 : o) + l | 0, sA = e = j + aA | 0, e = o = e >>> 0 < j >>> 0 ? o + 1 | 0 : o, t = q, q = DA(j ^ (a[0 | (o = A - -64 | 0)] | a[o + 1 | 0] << 8 | a[o + 2 | 0] << 16 | a[o + 3 | 0] << 24) ^ -1377402159, eA ^ (a[o + 4 | 0] | a[o + 5 | 0] << 8 | a[o + 6 | 0] << 16 | a[o + 7 | 0] << 24) ^ 1359893119, 32), eA = o = h, o = o + 1779033703 | 0, j = q, J = o = (q = q - 205731576 | 0) >>> 0 < 4089235720 ? o + 1 | 0 : o, r = DA(t ^ (G = q), o ^ r, 40), o = (P = h) + e | 0, t = DA(j ^ (e = q = r + sA | 0), eA ^ (M = r >>> 0 > e >>> 0 ? o + 1 | 0 : o), 48), o = DA(t ^ V, (W = h) ^ iA, 32), O = q = h, L = o, C = o = a[I + 60 | 0] | a[I + 61 | 0] << 8 | a[I + 62 | 0] << 16 | a[I + 63 | 0] << 24, eA = sA = a[I + 56 | 0] | a[I + 57 | 0] << 8 | a[I + 58 | 0] << 16 | a[I + 59 | 0] << 24, N = a[A + 24 | 0] | a[A + 25 | 0] << 8 | a[A + 26 | 0] << 16 | a[A + 27 | 0] << 24, q = (iA = a[I + 48 | 0] | a[I + 49 | 0] << 8 | a[I + 50 | 0] << 16 | a[I + 51 | 0] << 24) + (j = a[A + 56 | 0] | a[A + 57 | 0] << 8 | a[A + 58 | 0] << 16 | a[A + 59 | 0] << 24) | 0, o = (_A = a[I + 52 | 0] | a[I + 53 | 0] << 8 | a[I + 54 | 0] << 16 | a[I + 55 | 0] << 24) + (b = a[A + 60 | 0] | a[A + 61 | 0] << 8 | a[A + 62 | 0] << 16 | a[A + 63 | 0] << 24) | 0, o = (a[A + 28 | 0] | a[A + 29 | 0] << 8 | a[A + 30 | 0] << 16 | a[A + 31 | 0] << 24) + (q >>> 0 < j >>> 0 ? o + 1 | 0 : o) | 0, o = C + (V = (p = q) >>> 0 > (q = N + q | 0) >>> 0 ? o + 1 | 0 : o) | 0, o = (N = q + eA | 0) >>> 0 < q >>> 0 ? o + 1 | 0 : o, V = DA(q ^ (a[A + 88 | 0] | a[A + 89 | 0] << 8 | a[A + 90 | 0] << 16 | a[A + 91 | 0] << 24) ^ 327033209, V ^ (a[A + 92 | 0] | a[A + 93 | 0] << 8 | a[A + 94 | 0] << 16 | a[A + 95 | 0] << 24) ^ 1541459225, 32), j = DA(j ^ (eA = V + 1595750129 | 0), (p = b) ^ (b = (U = q = h) - ((V >>> 0 < 2699217167) + 1521486533 | 0) | 0), 40), o = (IA = h) + o | 0, q = DA((N = q = j + N | 0) ^ V, U ^ (p = N >>> 0 < j >>> 0 ? o + 1 | 0 : o), 48), o = b + ($ = h) | 0, Y = o = (q = eA + (b = q) | 0) >>> 0 < eA >>> 0 ? o + 1 | 0 : o, o = O + o | 0, T = k ^ (V = L + (U = q) | 0), k = o = V >>> 0 < U >>> 0 ? o + 1 | 0 : o, eA = DA(T, o ^ FA, 40), o = (FA = h) + y | 0, q = DA(v = L ^ (y = q = eA + v | 0), O ^ (L = y >>> 0 < eA >>> 0 ? o + 1 | 0 : o), 48), o = k + (CA = h) | 0, O = o = (k = V + (v = q) | 0) >>> 0 < V >>> 0 ? o + 1 | 0 : o, q = (u = DA(k ^ eA, FA ^ o, 1)) + (V = a[I + 72 | 0] | a[I + 73 | 0] << 8 | a[I + 74 | 0] << 16 | a[I + 75 | 0] << 24) | 0, o = (hA = h) + (FA = a[I + 76 | 0] | a[I + 77 | 0] << 8 | a[I + 78 | 0] << 16 | a[I + 79 | 0] << 24) | 0, SA = q, z = q >>> 0 < V >>> 0 ? o + 1 | 0 : o, Z = wA, q = a[I + 96 | 0] | a[I + 97 | 0] << 8 | a[I + 98 | 0] << 16 | a[I + 99 | 0] << 24, eA = o = a[I + 100 | 0] | a[I + 101 | 0] << 8 | a[I + 102 | 0] << 16 | a[I + 103 | 0] << 24, j = (o = w) + (w = DA(U ^ j, Y ^ IA, 1)) | 0, o = (U = h) + n | 0, o = (w >>> 0 > j >>> 0 ? o + 1 | 0 : o) + eA | 0, o = (n = (n = j) >>> 0 > (j = q + j | 0) >>> 0 ? o + 1 | 0 : o) + Z | 0, T = Y = j + gA | 0, Y = o = Y >>> 0 < j >>> 0 ? o + 1 | 0 : o, H = DA(f ^ H, d ^ K, 48), d = o = DA(H ^ j, (K = h) ^ n, 32), o = J + W | 0, o = (IA = j = h) + (G = (j = t + G | 0) >>> 0 < t >>> 0 ? o + 1 | 0 : o) | 0, J = o = (n = j) >>> 0 > (t = n + d | 0) >>> 0 ? o + 1 | 0 : o, w = DA(t ^ w, U ^ o, 40), o = (W = h) + Y | 0, o = (U = w >>> 0 > (Y = j = w + T | 0) >>> 0 ? o + 1 | 0 : o) + z | 0, o = (f = Y >>> 0 > (j = Y + SA | 0) >>> 0 ? o + 1 | 0 : o) + kA | 0, SA = z = j + oA | 0, z = o = z >>> 0 < j >>> 0 ? o + 1 | 0 : o, T = j, Z = f, j = a[I + 116 | 0] | a[I + 117 | 0] << 8 | a[I + 118 | 0] << 16 | a[I + 119 | 0] << 24, I = a[I + 112 | 0] | a[I + 113 | 0] << 8 | a[I + 114 | 0] << 16 | a[I + 115 | 0] << 24, r = DA(r ^ n, G ^ P, 1), o = (P = h) + p | 0, o = ((f = r + N | 0) >>> 0 < r >>> 0 ? o + 1 | 0 : o) + j | 0, o = (n = (G = f) >>> 0 > (f = I + f | 0) >>> 0 ? o + 1 | 0 : o) + kA | 0, NA = G = f + oA | 0, G = o = G >>> 0 < f >>> 0 ? o + 1 | 0 : o, o = DA(f ^ s, n ^ x, 32), AA = f = h, s = o, n = f, o = K + R | 0, H = f = c + H | 0, N = o = f >>> 0 < c >>> 0 ? o + 1 | 0 : o, o = o + n | 0, p = f = f + s | 0, x = o = H >>> 0 > f >>> 0 ? o + 1 | 0 : o, n = DA(f ^ r, P ^ o, 40), o = (P = h) + G | 0, s = DA((f = n + NA | 0) ^ s, AA ^ (c = f >>> 0 < n >>> 0 ? o + 1 | 0 : o), 48), o = DA(s ^ T, (NA = h) ^ Z, 32), AA = r = h, G = o, T = r, D = DA(D ^ H, N ^ m, 1), o = M + (H = h) | 0, o = ((r = e) >>> 0 > (e = e + D | 0) >>> 0 ? o + 1 | 0 : o) + BA | 0, o = (e = (r = e + X | 0) >>> 0 < e >>> 0 ? o + 1 | 0 : o) + FA | 0, Z = M = r + V | 0, M = o = M >>> 0 < r >>> 0 ? o + 1 | 0 : o, N = D, r = DA(r ^ b, e ^ $, 32), o = (b = h) + S | 0, F = DA(N ^ (e = D = r + F | 0), (S = r >>> 0 > e >>> 0 ? o + 1 | 0 : o) ^ H, 40), o = ($ = h) + M | 0, H = D = F + Z | 0, D = DA(r ^ D, b ^ (M = D >>> 0 < F >>> 0 ? o + 1 | 0 : o), 48), o = S + (i = h) | 0, S = D, b = o = (D = e + D | 0) >>> 0 < e >>> 0 ? o + 1 | 0 : o, o = o + T | 0, o = (N = D) >>> 0 > (D = D + G | 0) >>> 0 ? o + 1 | 0 : o, T = D, D ^= u, u = o, r = DA(D, hA ^ o, 40), o = (hA = h) + z | 0, z = D = r + SA | 0, o = B + (Z = r >>> 0 > D >>> 0 ? o + 1 | 0 : o) | 0, SA = D = D + g | 0, K = o = D >>> 0 < g >>> 0 ? o + 1 | 0 : o, D = f, R = gA, m = wA, f = DA(d ^ Y, U ^ IA, 48), o = J + (IA = h) | 0, d = f, J = o = (e = t + f | 0) >>> 0 < t >>> 0 ? o + 1 | 0 : o, f = DA(e ^ w, W ^ o, 1), o = (t = h) + m | 0, o = ((w = f + R | 0) >>> 0 < f >>> 0 ? o + 1 | 0 : o) + c | 0, o = _A + (D = (c = D + w | 0) >>> 0 < w >>> 0 ? o + 1 | 0 : o) | 0, Y = w = c + iA | 0, w = o = w >>> 0 < iA >>> 0 ? o + 1 | 0 : o, c = DA(c ^ S, D ^ i, 32), o = O + (U = h) | 0, S = c, k = o = (c = k + c | 0) >>> 0 < k >>> 0 ? o + 1 | 0 : o, D = DA(f ^ c, o ^ t, 40), o = (o = w) + (w = h) | 0, t = f = D + Y | 0, f = DA(f ^ S, U ^ (Y = f >>> 0 < D >>> 0 ? o + 1 | 0 : o), 48), o = k + (W = h) | 0, U = f, O = o = (k = c + f | 0) >>> 0 < c >>> 0 ? o + 1 | 0 : o, f = DA(D ^ k, w ^ o, 1), o = (w = h) + K | 0, o = C + (D = (c = f + SA | 0) >>> 0 < f >>> 0 ? o + 1 | 0 : o) | 0, SA = S = c + sA | 0, S = o = S >>> 0 < sA >>> 0 ? o + 1 | 0 : o, K = f, R = w, o = x + NA | 0, o = (f = s + p | 0) >>> 0 < s >>> 0 ? o + 1 | 0 : o, s = f, p = o, o = DA(f ^ n, P ^ o, 1), n = w = h, f = o, o = M + j | 0, o = ((H = I + H | 0) >>> 0 < I >>> 0 ? o + 1 | 0 : o) + w | 0, o = nA + (H = (w = f + H | 0) >>> 0 < H >>> 0 ? o + 1 | 0 : o) | 0, x = M = w + EA | 0, M = o = M >>> 0 < EA >>> 0 ? o + 1 | 0 : o, w = DA(w ^ v, H ^ CA, 32), o = J + (v = h) | 0, H = w, J = o = (J = e) >>> 0 > (e = e + w | 0) >>> 0 ? o + 1 | 0 : o, w = DA(f ^ e, o ^ n, 40), o = (P = h) + M | 0, n = f = w + x | 0, f = DA(M = f ^ H, v ^ (H = f >>> 0 < w >>> 0 ? o + 1 | 0 : o), 48), o = J + (CA = h) | 0, J = f, M = f = e + f | 0, v = o = f >>> 0 < e >>> 0 ? o + 1 | 0 : o, x = c, m = D, f = DA(F ^ N, b ^ $, 1), o = (e = h) + _ | 0, o = L + ((c = f + cA | 0) >>> 0 < f >>> 0 ? o + 1 | 0 : o) | 0, o = BA + (D = (c = c + y | 0) >>> 0 < y >>> 0 ? o + 1 | 0 : o) | 0, L = y = c + X | 0, y = o = y >>> 0 < c >>> 0 ? o + 1 | 0 : o, F = f, f = (c = DA(c ^ d, D ^ IA, 32)) + s | 0, o = (s = h) + p | 0, D = f, e = DA(f ^ F, (d = f >>> 0 < c >>> 0 ? o + 1 | 0 : o) ^ e, 40), o = (IA = h) + y | 0, y = f = e + L | 0, N = DA(f ^ c, s ^ (L = f >>> 0 < e >>> 0 ? o + 1 | 0 : o), 48), c = DA(N ^ x, (o = m) ^ (m = h), 32), o = (x = h) + v | 0, s = f = c + M | 0, F = DA(f ^ K, (p = f >>> 0 < c >>> 0 ? o + 1 | 0 : o) ^ R, 40), o = (K = h) + S | 0, S = f = F + SA | 0, f = DA(f ^ c, x ^ (b = f >>> 0 < F >>> 0 ? o + 1 | 0 : o), 48), o = p + ($ = h) | 0, p = f, x = o = (c = s) >>> 0 > (s = s + f | 0) >>> 0 ? o + 1 | 0 : o, f = DA(s ^ F, K ^ o, 1), o = kA + (SA = h) | 0, K = f, NA = f = oA + f | 0, F = o = f >>> 0 < oA >>> 0 ? o + 1 | 0 : o, c = rA, f = DA(w ^ M, P ^ v, 1), o = Y + (w = h) | 0, o = ((M = t) >>> 0 > (t = f + t | 0) >>> 0 ? o + 1 | 0 : o) + yA | 0, o = (M = (c = c + t | 0) >>> 0 < t >>> 0 ? o + 1 | 0 : o) + HA | 0, R = t = c + tA | 0, Y = o = t >>> 0 < c >>> 0 ? o + 1 | 0 : o, v = f, t = DA(G ^ z, Z ^ AA, 48), o = DA(t ^ c, (P = h) ^ M, 32), AA = f = h, G = o, c = f, o = d + m | 0, o = (f = D + N | 0) >>> 0 < D >>> 0 ? o + 1 | 0 : o, D = f, d = o, o = o + c | 0, M = f = f + G | 0, N = o = D >>> 0 > f >>> 0 ? o + 1 | 0 : o, c = DA(f ^ v, o ^ w, 40), o = (o = Y) + (Y = h) | 0, v = f = c + R | 0, z = o = f >>> 0 < c >>> 0 ? o + 1 | 0 : o, o = o + F | 0, Z = o = (w = f + NA | 0) >>> 0 < f >>> 0 ? o + 1 | 0 : o, F = o, f = DA(e ^ D, d ^ IA, 1), o = l + (e = h) | 0, o = H + ((D = f + aA | 0) >>> 0 < aA >>> 0 ? o + 1 | 0 : o) | 0, o = eA + (n = (D = D + n | 0) >>> 0 < n >>> 0 ? o + 1 | 0 : o) | 0, R = H = D + q | 0, H = o = H >>> 0 < q >>> 0 ? o + 1 | 0 : o, d = f, o = DA(D ^ U, n ^ W, 32), m = f = h, D = o, n = f, o = P + u | 0, U = f = t + T | 0, u = o = f >>> 0 < t >>> 0 ? o + 1 | 0 : o, o = o + n | 0, o = (t = f + D | 0) >>> 0 < f >>> 0 ? o + 1 | 0 : o, f = t ^ d, d = o, n = DA(f, o ^ e, 40), o = (W = h) + H | 0, e = f = n + R | 0, T = DA(f ^ D, m ^ (H = f >>> 0 < n >>> 0 ? o + 1 | 0 : o), 48), o = DA(T ^ w, (IA = h) ^ F, 32), NA = f = h, R = o, F = f, f = DA(r ^ U, u ^ hA, 1), o = L + (r = h) | 0, o = GA + ((D = f + y | 0) >>> 0 < y >>> 0 ? o + 1 | 0 : o) | 0, o = (y = (D = D + QA | 0) >>> 0 < QA >>> 0 ? o + 1 | 0 : o) + pA | 0, U = L = D + fA | 0, L = o = L >>> 0 < D >>> 0 ? o + 1 | 0 : o, D = DA(D ^ J, y ^ CA, 32), o = O + (u = h) | 0, J = D, y = r, r = o = (D = k + D | 0) >>> 0 < k >>> 0 ? o + 1 | 0 : o, y = DA(f ^ D, y ^ o, 40), o = (CA = h) + L | 0, k = f = y + U | 0, f = DA(U = f ^ J, u ^ (J = f >>> 0 < y >>> 0 ? o + 1 | 0 : o), 48), o = r + (P = h) | 0, r = f, L = f = D + f | 0, U = o = f >>> 0 < D >>> 0 ? o + 1 | 0 : o, o = o + F | 0, O = o = (F = f + R | 0) >>> 0 < f >>> 0 ? o + 1 | 0 : o, D = DA(F ^ K, SA ^ o, 40), o = Z + (u = h) | 0, o = ((f = D + w | 0) >>> 0 < w >>> 0 ? o + 1 | 0 : o) + wA | 0, w = f, Z = f = f + gA | 0, K = o = w >>> 0 > f >>> 0 ? o + 1 | 0 : o, m = BA, w = DA(G ^ v, z ^ AA, 48), o = (hA = h) + N | 0, G = f = w + M | 0, o = DA(f ^ c, (M = f >>> 0 < w >>> 0 ? o + 1 | 0 : o) ^ Y, 1), Y = c = h, f = o, o = H + B | 0, o = ((e = e + g | 0) >>> 0 < g >>> 0 ? o + 1 | 0 : o) + c | 0, o = (e = (c = f + e | 0) >>> 0 < e >>> 0 ? o + 1 | 0 : o) + m | 0, N = H = c + X | 0, H = o = H >>> 0 < c >>> 0 ? o + 1 | 0 : o, c = DA(c ^ r, e ^ P, 32), o = x + (v = h) | 0, s = o = (r = c + s | 0) >>> 0 < s >>> 0 ? o + 1 | 0 : o, e = DA(f ^ r, o ^ Y, 40), o = (z = h) + H | 0, H = f = e + N | 0, c = DA(f ^ c, v ^ (Y = f >>> 0 < e >>> 0 ? o + 1 | 0 : o), 48), o = s + (N = h) | 0, v = o = (s = c + r | 0) >>> 0 < r >>> 0 ? o + 1 | 0 : o, f = DA(e ^ s, z ^ o, 1), o = (z = h) + K | 0, o = FA + ((r = f + Z | 0) >>> 0 < f >>> 0 ? o + 1 | 0 : o) | 0, o = (e = (r = r + V | 0) >>> 0 < V >>> 0 ? o + 1 | 0 : o) + _ | 0, SA = _ = r + cA | 0, _ = o = _ >>> 0 < r >>> 0 ? o + 1 | 0 : o, x = f, m = r, P = e, r = rA, f = DA(y ^ L, U ^ CA, 1), o = b + (y = h) | 0, o = ((e = S) >>> 0 > (S = f + S | 0) >>> 0 ? o + 1 | 0 : o) + yA | 0, o = pA + (e = (r = r + S | 0) >>> 0 < S >>> 0 ? o + 1 | 0 : o) | 0, b = S = r + fA | 0, L = o = S >>> 0 < fA >>> 0 ? o + 1 | 0 : o, S = f, e = o = DA(r ^ w, e ^ hA, 32), o = d + IA | 0, o = (U = f = h) + (t = (f = t + T | 0) >>> 0 < t >>> 0 ? o + 1 | 0 : o) | 0, d = o = (w = f + e | 0) >>> 0 < f >>> 0 ? o + 1 | 0 : o, S = DA(w ^ S, o ^ y, 40), o = (IA = h) + L | 0, L = DA(b = (r = S + b | 0) ^ e, U ^ (e = r >>> 0 < S >>> 0 ? o + 1 | 0 : o), 48), o = DA(L ^ m, (CA = h) ^ P, 32), hA = y = h, b = o, U = y, f = DA(f ^ n, t ^ W, 1), o = eA + (y = h) | 0, o = J + ((t = f + q | 0) >>> 0 < q >>> 0 ? o + 1 | 0 : o) | 0, o = GA + (k = (t = t + k | 0) >>> 0 < k >>> 0 ? o + 1 | 0 : o) | 0, m = n = t + QA | 0, n = o = n >>> 0 < QA >>> 0 ? o + 1 | 0 : o, J = f, T = y, t = DA(t ^ p, k ^ $, 32), o = (p = h) + M | 0, y = f = t + G | 0, k = DA(f ^ J, (G = f >>> 0 < t >>> 0 ? o + 1 | 0 : o) ^ T, 40), o = (W = h) + n | 0, J = f = k + m | 0, f = DA(f ^ t, p ^ (M = f >>> 0 < k >>> 0 ? o + 1 | 0 : o), 48), o = G + (m = h) | 0, n = f, G = f = y + f | 0, p = o = f >>> 0 < y >>> 0 ? o + 1 | 0 : o, o = o + U | 0, U = f = f + b | 0, t = z, z = o = G >>> 0 > f >>> 0 ? o + 1 | 0 : o, t = DA(f ^ x, t ^ o, 40), o = (o = _) + (_ = h) | 0, T = f = t + SA | 0, x = o = f >>> 0 < t >>> 0 ? o + 1 | 0 : o, y = e, f = DA(R ^ Z, K ^ NA, 48), o = O + ($ = h) | 0, O = f, e = (f = F + f | 0) ^ D, D = o = f >>> 0 < F >>> 0 ? o + 1 | 0 : o, e = DA(e, o ^ u, 1), o = (u = h) + y | 0, o = C + ((r = e + r | 0) >>> 0 < e >>> 0 ? o + 1 | 0 : o) | 0, o = (y = (r = r + sA | 0) >>> 0 < sA >>> 0 ? o + 1 | 0 : o) + l | 0, Z = F = r + aA | 0, F = o = F >>> 0 < r >>> 0 ? o + 1 | 0 : o, r = DA(r ^ n, y ^ m, 32), o = v + (K = h) | 0, v = r, s = o = (y = s + r | 0) >>> 0 < s >>> 0 ? o + 1 | 0 : o, e = DA(e ^ y, u ^ o, 40), o = (o = F) + (F = h) | 0, n = r = e + Z | 0, r = DA(R = r ^ v, K ^ (v = r >>> 0 < e >>> 0 ? o + 1 | 0 : o), 48), o = s + (SA = h) | 0, u = r, Z = o = (s = y + r | 0) >>> 0 < y >>> 0 ? o + 1 | 0 : o, r = DA(e ^ s, F ^ o, 1), o = (F = h) + x | 0, o = B + ((e = r + T | 0) >>> 0 < r >>> 0 ? o + 1 | 0 : o) | 0, o = j + (y = (e = e + g | 0) >>> 0 < g >>> 0 ? o + 1 | 0 : o) | 0, NA = K = I + e | 0, K = o = K >>> 0 < I >>> 0 ? o + 1 | 0 : o, R = r, m = F, F = e, P = y, r = DA(k ^ G, p ^ W, 1), o = (y = h) + Y | 0, o = nA + ((e = r + H | 0) >>> 0 < r >>> 0 ? o + 1 | 0 : o) | 0, o = (k = (e = e + EA | 0) >>> 0 < EA >>> 0 ? o + 1 | 0 : o) + j | 0, Y = H = I + e | 0, H = o = H >>> 0 < e >>> 0 ? o + 1 | 0 : o, G = r, e = o = DA(e ^ O, k ^ $, 32), k = r = h, o = d + CA | 0, d = o = (r = w + L | 0) >>> 0 < w >>> 0 ? o + 1 | 0 : o, o = o + k | 0, o = (w = r) >>> 0 > (r = r + e | 0) >>> 0 ? o + 1 | 0 : o, L = r, r ^= G, G = o, y = DA(r, o ^ y, 40), o = (W = h) + H | 0, k = DA(H = (r = y + Y | 0) ^ e, k ^ (e = r >>> 0 < y >>> 0 ? o + 1 | 0 : o), 48), o = DA(k ^ F, (o = P) ^ (P = h), 32), $ = F = h, H = o, Y = D, D = c, o = DA(w ^ S, d ^ IA, 1), p = c = h, w = o, o = M + HA | 0, o = ((S = J + tA | 0) >>> 0 < tA >>> 0 ? o + 1 | 0 : o) + c | 0, S = o = (c = w + S | 0) >>> 0 < S >>> 0 ? o + 1 | 0 : o, D = DA(c ^ D, o ^ N, 32), o = (o = Y) + (Y = h) | 0, w = DA((f = D + f | 0) ^ w, p ^ (d = f >>> 0 < D >>> 0 ? o + 1 | 0 : o), 40), o = S + (IA = h) | 0, J = w, o = _A + ((M = c) >>> 0 > (c = c + w | 0) >>> 0 ? o + 1 | 0 : o) | 0, M = o = (w = c + iA | 0) >>> 0 < iA >>> 0 ? o + 1 | 0 : o, c = DA(D ^ w, Y ^ o, 48), o = d + (CA = h) | 0, N = f, D = c, d = f = f + c | 0, Y = o = N >>> 0 > f >>> 0 ? o + 1 | 0 : o, o = o + F | 0, N = o = (F = f + H | 0) >>> 0 < f >>> 0 ? o + 1 | 0 : o, f = (S = DA(F ^ R, o ^ m, 40)) + NA | 0, o = (NA = h) + K | 0, p = f, O = f >>> 0 < S >>> 0 ? o + 1 | 0 : o, f = DA(b ^ T, x ^ hA, 48), o = (b = h) + z | 0, U = c = f + U | 0, R = _, _ = o = c >>> 0 < f >>> 0 ? o + 1 | 0 : o, o = DA(c ^ t, R ^ o, 1), T = c = h, t = o, o = e + C | 0, o = ((r = r + sA | 0) >>> 0 < sA >>> 0 ? o + 1 | 0 : o) + c | 0, o = FA + (r = (c = r + t | 0) >>> 0 < r >>> 0 ? o + 1 | 0 : o) | 0, x = e = c + V | 0, e = o = e >>> 0 < V >>> 0 ? o + 1 | 0 : o, c = DA(c ^ D, r ^ CA, 32), o = Z + (K = h) | 0, z = c, c = (D = s + c | 0) ^ t, t = o = D >>> 0 < s >>> 0 ? o + 1 | 0 : o, r = DA(c, T ^ o, 40), o = (o = e) + (e = h) | 0, T = c = r + x | 0, c = DA(s = c ^ z, K ^ (z = c >>> 0 < r >>> 0 ? o + 1 | 0 : o), 48), o = t + (CA = h) | 0, Z = c, D = o = (c = D + c | 0) >>> 0 < D >>> 0 ? o + 1 | 0 : o, r = DA(c ^ r, e ^ o, 1), o = (s = h) + O | 0, o = kA + ((e = r + p | 0) >>> 0 < r >>> 0 ? o + 1 | 0 : o) | 0, o = (t = (e = e + oA | 0) >>> 0 < oA >>> 0 ? o + 1 | 0 : o) + BA | 0, AA = x = e + X | 0, x = o = x >>> 0 < e >>> 0 ? o + 1 | 0 : o, K = r, R = e, m = t, r = DA(J ^ d, Y ^ IA, 1), o = (Y = h) + wA | 0, o = v + (r >>> 0 > (e = r + gA | 0) >>> 0 ? o + 1 | 0 : o) | 0, t = o = (e = e + n | 0) >>> 0 < n >>> 0 ? o + 1 | 0 : o, o = DA(f ^ e, o ^ b, 32), b = f = h, n = o, o = G + P | 0, o = (f = k + L | 0) >>> 0 < k >>> 0 ? o + 1 | 0 : o, k = f, d = o, o = b + o | 0, G = f = f + n | 0, J = o = k >>> 0 > f >>> 0 ? o + 1 | 0 : o, f = DA(f ^ r, Y ^ o, 40), o = t + (P = h) | 0, L = f, o = eA + ((f = e + f | 0) >>> 0 < e >>> 0 ? o + 1 | 0 : o) | 0, o = (f = f + q | 0) >>> 0 < q >>> 0 ? o + 1 | 0 : o, Y = f, f ^= n, n = o, t = DA(f, b ^ o, 48), o = DA(t ^ R, (o = m) ^ (m = h), 32), IA = f = h, b = o, v = f, f = DA(y ^ k, d ^ W, 1), o = HA + (e = h) | 0, o = M + ((r = f + tA | 0) >>> 0 < tA >>> 0 ? o + 1 | 0 : o) | 0, o = (y = (r = r + w | 0) >>> 0 < w >>> 0 ? o + 1 | 0 : o) + l | 0, M = k = r + aA | 0, k = o = k >>> 0 < r >>> 0 ? o + 1 | 0 : o, w = f, d = e, f = (r = DA(r ^ u, y ^ SA, 32)) + U | 0, o = (U = h) + _ | 0, e = f, y = DA(y = f ^ w, (w = f >>> 0 < r >>> 0 ? o + 1 | 0 : o) ^ d, 40), o = (W = h) + k | 0, k = f = y + M | 0, r = DA(f ^ r, U ^ (_ = f >>> 0 < y >>> 0 ? o + 1 | 0 : o), 48), o = w + (d = h) | 0, M = f = r + e | 0, U = o = f >>> 0 < e >>> 0 ? o + 1 | 0 : o, o = o + v | 0, v = o = (w = f + b | 0) >>> 0 < f >>> 0 ? o + 1 | 0 : o, e = DA(w ^ K, o ^ s, 40), o = (u = h) + x | 0, x = f = e + AA | 0, K = o = f >>> 0 < e >>> 0 ? o + 1 | 0 : o, f = c, s = D, D = r, c = DA(H ^ p, O ^ $, 48), o = N + (AA = h) | 0, H = c, F = o = (r = F + c | 0) >>> 0 < F >>> 0 ? o + 1 | 0 : o, o = DA(r ^ S, NA ^ o, 1), N = c = h, S = o, o = n + MA | 0, o = ((n = Y + cA | 0) >>> 0 < cA >>> 0 ? o + 1 | 0 : o) + c | 0, n = o = (c = n + S | 0) >>> 0 < n >>> 0 ? o + 1 | 0 : o, D = DA(c ^ D, o ^ d, 32), o = (Y = h) + s | 0, S = DA((f = D + f | 0) ^ S, N ^ (s = f >>> 0 < D >>> 0 ? o + 1 | 0 : o), 40), o = n + (p = h) | 0, o = GA + ((n = c) >>> 0 > (c = c + S | 0) >>> 0 ? o + 1 | 0 : o) | 0, d = o = (n = c + QA | 0) >>> 0 < QA >>> 0 ? o + 1 | 0 : o, c = DA(D ^ n, Y ^ o, 48), o = s + ($ = h) | 0, Y = c, N = o = (s = f + c | 0) >>> 0 < f >>> 0 ? o + 1 | 0 : o, f = DA(s ^ S, p ^ o, 1), o = (S = h) + K | 0, o = nA + ((c = f + x | 0) >>> 0 < f >>> 0 ? o + 1 | 0 : o) | 0, o = kA + (D = (c = c + EA | 0) >>> 0 < EA >>> 0 ? o + 1 | 0 : o) | 0, hA = p = c + oA | 0, p = o = p >>> 0 < oA >>> 0 ? o + 1 | 0 : o, O = f, R = c, f = DA(y ^ M, U ^ W, 1), o = (y = h) + z | 0, o = pA + ((c = f + T | 0) >>> 0 < f >>> 0 ? o + 1 | 0 : o) | 0, o = _A + (M = (c = c + fA | 0) >>> 0 < fA >>> 0 ? o + 1 | 0 : o) | 0, T = U = c + iA | 0, U = o = U >>> 0 < iA >>> 0 ? o + 1 | 0 : o, z = f, o = DA(c ^ H, M ^ AA, 32), AA = f = h, c = o, o = J + m | 0, G = f = t + G | 0, H = o = f >>> 0 < t >>> 0 ? o + 1 | 0 : o, o = AA + o | 0, J = o = (t = f + c | 0) >>> 0 < f >>> 0 ? o + 1 | 0 : o, y = DA(t ^ z, o ^ y, 40), o = (m = h) + U | 0, M = f = y + T | 0, z = DA(f ^ c, AA ^ (U = f >>> 0 < y >>> 0 ? o + 1 | 0 : o), 48), o = DA(z ^ R, (AA = h) ^ D, 32), W = f = h, T = o, D = f, c = rA, f = DA(G ^ L, H ^ P, 1), o = _ + (H = h) | 0, o = ((G = k) >>> 0 > (k = f + k | 0) >>> 0 ? o + 1 | 0 : o) + yA | 0, o = nA + (k = (c = c + k | 0) >>> 0 < k >>> 0 ? o + 1 | 0 : o) | 0, G = _ = c + EA | 0, _ = o = _ >>> 0 < EA >>> 0 ? o + 1 | 0 : o, c = DA(c ^ Z, k ^ CA, 32), o = F + (L = h) | 0, F = c, o = (c = r + c | 0) >>> 0 < r >>> 0 ? o + 1 | 0 : o, r = H, H = o, r = DA(f ^ c, r ^ o, 40), o = (P = h) + _ | 0, k = f = r + G | 0, f = DA(f ^ F, L ^ (_ = f >>> 0 < r >>> 0 ? o + 1 | 0 : o), 48), o = H + (R = h) | 0, H = f, G = f = c + f | 0, L = o = f >>> 0 < c >>> 0 ? o + 1 | 0 : o, o = o + D | 0, o = (F = f + T | 0) >>> 0 < f >>> 0 ? o + 1 | 0 : o, f = F ^ O, O = o, S = DA(f, o ^ S, 40), o = (CA = h) + p | 0, p = f = S + hA | 0, Z = f >>> 0 < S >>> 0 ? o + 1 | 0 : o, f = DA(b ^ x, K ^ IA, 48), o = v + (IA = h) | 0, b = f, o = (f = w + f | 0) >>> 0 < w >>> 0 ? o + 1 | 0 : o, w = f, v = o, o = DA(f ^ e, o ^ u, 1), u = f = h, D = o, o = U + FA | 0, o = ((c = M + V | 0) >>> 0 < V >>> 0 ? o + 1 | 0 : o) + f | 0, o = GA + (c = (f = c + D | 0) >>> 0 < c >>> 0 ? o + 1 | 0 : o) | 0, M = e = f + QA | 0, e = o = e >>> 0 < QA >>> 0 ? o + 1 | 0 : o, f = DA(f ^ H, c ^ R, 32), o = N + (U = h) | 0, H = f, s = o = (c = s + f | 0) >>> 0 < s >>> 0 ? o + 1 | 0 : o, D = DA(c ^ D, u ^ o, 40), o = (u = h) + e | 0, M = f = D + M | 0, f = DA(e = f ^ H, U ^ (H = f >>> 0 < D >>> 0 ? o + 1 | 0 : o), 48), o = s + (hA = h) | 0, s = f, N = o = (e = c + f | 0) >>> 0 < c >>> 0 ? o + 1 | 0 : o, f = DA(e ^ D, u ^ o, 1), o = (U = h) + Z | 0, o = HA + ((c = f + p | 0) >>> 0 < f >>> 0 ? o + 1 | 0 : o) | 0, o = (D = (c = c + tA | 0) >>> 0 < tA >>> 0 ? o + 1 | 0 : o) + wA | 0, SA = u = c + gA | 0, u = o = u >>> 0 < c >>> 0 ? o + 1 | 0 : o, x = f, K = c, R = D, f = DA(r ^ G, P ^ L, 1), o = pA + (D = h) | 0, o = d + ((c = f + fA | 0) >>> 0 < fA >>> 0 ? o + 1 | 0 : o) | 0, o = MA + (r = (c = c + n | 0) >>> 0 < n >>> 0 ? o + 1 | 0 : o) | 0, L = n = c + cA | 0, n = o = n >>> 0 < cA >>> 0 ? o + 1 | 0 : o, d = f, G = D, o = DA(c ^ b, r ^ IA, 32), b = f = h, r = o, c = f, o = J + AA | 0, o = (f = t + z | 0) >>> 0 < t >>> 0 ? o + 1 | 0 : o, t = f, J = o, o = o + c | 0, o = (D = f + r | 0) >>> 0 < f >>> 0 ? o + 1 | 0 : o, f = D ^ d, d = o, f = DA(f, o ^ G, 40), o = (o = n) + (n = h) | 0, G = c = f + L | 0, L = o = c >>> 0 < f >>> 0 ? o + 1 | 0 : o, b = DA(c ^ r, b ^ o, 48), o = DA(b ^ K, (o = R) ^ (R = h), 32), P = c = h, z = o, c = DA(t ^ y, J ^ m, 1), o = (t = h) + yA | 0, o = _ + ((r = c + rA | 0) >>> 0 < c >>> 0 ? o + 1 | 0 : o) | 0, o = C + (y = (r = r + k | 0) >>> 0 < k >>> 0 ? o + 1 | 0 : o) | 0, m = k = r + sA | 0, k = o = k >>> 0 < sA >>> 0 ? o + 1 | 0 : o, _ = c, J = t, r = DA(r ^ Y, y ^ $, 32), o = (Y = h) + v | 0, t = c = r + w | 0, c = (y = DA(c ^ _, (w = c >>> 0 < r >>> 0 ? o + 1 | 0 : o) ^ J, 40)) + m | 0, o = (m = h) + k | 0, _ = c, c = DA(c ^ r, Y ^ (J = c >>> 0 < y >>> 0 ? o + 1 | 0 : o), 48), o = w + (AA = h) | 0, Y = c, v = c = t + c | 0, K = o = c >>> 0 < t >>> 0 ? o + 1 | 0 : o, o = P + o | 0, o = (r = c + z | 0) >>> 0 < c >>> 0 ? o + 1 | 0 : o, c = U, U = o, t = DA(r ^ x, c ^ o, 40), o = (IA = h) + u | 0, k = c = t + SA | 0, o = DA(c ^ z, P ^ (u = c >>> 0 < t >>> 0 ? o + 1 | 0 : o), 48), P = c = h, z = o, c = f, o = d + R | 0, d = f = D + b | 0, b = o = f >>> 0 < D >>> 0 ? o + 1 | 0 : o, o = DA(f ^ c, o ^ n, 1), D = c = h, f = o, o = J + B | 0, o = ((w = _ + g | 0) >>> 0 < g >>> 0 ? o + 1 | 0 : o) + c | 0, o = eA + (w = (c = f + w | 0) >>> 0 < w >>> 0 ? o + 1 | 0 : o) | 0, R = n = c + q | 0, n = o = n >>> 0 < q >>> 0 ? o + 1 | 0 : o, _ = f, J = D, f = DA(p ^ T, Z ^ W, 48), o = O + (W = h) | 0, p = f, o = (f = F + f | 0) >>> 0 < F >>> 0 ? o + 1 | 0 : o, F = f, c = DA(c ^ s, w ^ hA, 32), O = o, o = o + (T = h) | 0, D = f = c + f | 0, w = DA(f ^ _, (s = f >>> 0 < c >>> 0 ? o + 1 | 0 : o) ^ J, 40), o = (Z = h) + n | 0, n = f = w + R | 0, f = DA(f ^ c, T ^ (_ = f >>> 0 < w >>> 0 ? o + 1 | 0 : o), 48), o = s + ($ = h) | 0, J = f, T = o = (s = D + f | 0) >>> 0 < D >>> 0 ? o + 1 | 0 : o, f = DA(w ^ s, Z ^ o, 1), o = GA + (R = h) | 0, Z = f, hA = f = QA + f | 0, D = o = f >>> 0 < QA >>> 0 ? o + 1 | 0 : o, f = DA(S ^ F, O ^ CA, 1), o = (w = h) + L | 0, o = _A + ((c = f + G | 0) >>> 0 < f >>> 0 ? o + 1 | 0 : o) | 0, o = BA + (F = (c = c + iA | 0) >>> 0 < iA >>> 0 ? o + 1 | 0 : o) | 0, O = S = c + X | 0, S = o = S >>> 0 < X >>> 0 ? o + 1 | 0 : o, G = w, c = DA(c ^ Y, F ^ AA, 32), o = N + (AA = h) | 0, L = c, o = (w = e + c | 0) >>> 0 < e >>> 0 ? o + 1 | 0 : o, e = G, G = o, F = DA(f ^ w, e ^ o, 40), o = (CA = h) + S | 0, Y = f = F + O | 0, o = (N = f >>> 0 < F >>> 0 ? o + 1 | 0 : o) + D | 0, S = o = (D = f + hA | 0) >>> 0 < f >>> 0 ? o + 1 | 0 : o, O = o = DA(D ^ z, o ^ P, 32), x = f = h, f = DA(y ^ v, K ^ m, 1), o = (e = h) + H | 0, o = j + ((c = f + M | 0) >>> 0 < f >>> 0 ? o + 1 | 0 : o) | 0, o = (y = (c = I + c | 0) >>> 0 < I >>> 0 ? o + 1 | 0 : o) + l | 0, K = H = c + aA | 0, H = o = H >>> 0 < c >>> 0 ? o + 1 | 0 : o, M = f, v = e, c = DA(c ^ p, y ^ W, 32), o = (p = h) + b | 0, e = f = c + d | 0, f = (y = DA(f ^ M, (d = f >>> 0 < c >>> 0 ? o + 1 | 0 : o) ^ v, 40)) + K | 0, o = (K = h) + H | 0, H = f, f = DA(f ^ c, p ^ (M = f >>> 0 < y >>> 0 ? o + 1 | 0 : o), 48), o = d + (W = h) | 0, d = f, p = o = (f = e + f | 0) >>> 0 < e >>> 0 ? o + 1 | 0 : o, o = o + x | 0, b = o = (e = f) >>> 0 > (f = f + O | 0) >>> 0 ? o + 1 | 0 : o, c = DA(f ^ Z, R ^ o, 40), o = S + (R = h) | 0, v = c, o = B + ((c = D + c | 0) >>> 0 < D >>> 0 ? o + 1 | 0 : o) | 0, Z = c = c + g | 0, D = c ^ O, O = o = c >>> 0 < g >>> 0 ? o + 1 | 0 : o, c = DA(D, x ^ o, 48), o = b + (x = h) | 0, b = o = (S = f + c | 0) >>> 0 < f >>> 0 ? o + 1 | 0 : o, f = o = DA(S ^ v, R ^ o, 1), v = D = h, D = DA(e ^ y, p ^ K, 1), o = _ + (y = h) | 0, o = _A + ((e = D + n | 0) >>> 0 < n >>> 0 ? o + 1 | 0 : o) | 0, o = nA + (n = (e = e + iA | 0) >>> 0 < iA >>> 0 ? o + 1 | 0 : o) | 0, R = _ = e + EA | 0, _ = o = _ >>> 0 < EA >>> 0 ? o + 1 | 0 : o, p = D, K = y, o = U + P | 0, o = (D = r + z | 0) >>> 0 < r >>> 0 ? o + 1 | 0 : o, U = D, L = DA(Y ^ L, N ^ AA, 48), y = DA(e ^ L, n ^ (AA = h), 32), Y = o, o = o + (hA = h) | 0, n = D = y + D | 0, D = DA(D ^ p, (N = D >>> 0 < y >>> 0 ? o + 1 | 0 : o) ^ K, 40), o = (p = h) + _ | 0, K = o = (r = D + R | 0) >>> 0 < D >>> 0 ? o + 1 | 0 : o, o = o + v | 0, o = C + ((z = r) >>> 0 > (r = f + r | 0) >>> 0 ? o + 1 | 0 : o) | 0, o = (e = (r = r + sA | 0) >>> 0 < sA >>> 0 ? o + 1 | 0 : o) + yA | 0, SA = _ = r + rA | 0, R = o = _ >>> 0 < r >>> 0 ? o + 1 | 0 : o, m = f, P = r, o = DA(t ^ U, Y ^ IA, 1), t = r = h, f = o, o = M + pA | 0, o = ((_ = H + fA | 0) >>> 0 < fA >>> 0 ? o + 1 | 0 : o) + r | 0, o = eA + (_ = (r = f + _ | 0) >>> 0 < _ >>> 0 ? o + 1 | 0 : o) | 0, Y = H = r + q | 0, H = o = H >>> 0 < q >>> 0 ? o + 1 | 0 : o, M = f, o = DA(r ^ J, _ ^ $, 32), U = f = h, r = o, _ = f, o = G + AA | 0, G = f = w + L | 0, J = o = f >>> 0 < w >>> 0 ? o + 1 | 0 : o, o = o + _ | 0, o = (w = f + r | 0) >>> 0 < f >>> 0 ? o + 1 | 0 : o;
                                        f = w ^ M, M = o, _ = DA(f, o ^ t, 40), o = (AA = h) + H | 0, L = DA(H = (f = _ + Y | 0) ^ r, U ^ (r = f >>> 0 < _ >>> 0 ? o + 1 | 0 : o), 48), o = DA(o = L ^ P, (P = h) ^ e, 32), IA = e = h, Y = o, H = e, e = DA(F ^ G, J ^ CA, 1), o = BA + (F = h) | 0, o = u + ((t = e + X | 0) >>> 0 < X >>> 0 ? o + 1 | 0 : o) | 0, o = HA + (k = (t = t + k | 0) >>> 0 < k >>> 0 ? o + 1 | 0 : o) | 0, J = G = t + tA | 0, G = o = G >>> 0 < tA >>> 0 ? o + 1 | 0 : o, t = DA(t ^ d, k ^ W, 32), o = T + (U = h) | 0, d = t, s = o = (t = s + t | 0) >>> 0 < s >>> 0 ? o + 1 | 0 : o, k = DA(e ^ t, o ^ F, 40), o = (W = h) + G | 0, F = e = k + J | 0, e = DA(G = e ^ d, U ^ (d = e >>> 0 < k >>> 0 ? o + 1 | 0 : o), 48), o = s + ($ = h) | 0, G = e, J = e = t + e | 0, U = o = e >>> 0 < t >>> 0 ? o + 1 | 0 : o, o = o + H | 0, o = (t = e + Y | 0) >>> 0 < e >>> 0 ? o + 1 | 0 : o, e = v, v = o, s = DA(t ^ m, e ^ o, 40), o = (u = h) + R | 0, H = e = s + SA | 0, e = DA(R = e ^ Y, IA ^ (Y = e >>> 0 < s >>> 0 ? o + 1 | 0 : o), 48), o = v + (IA = h) | 0, v = e, t = o = (e = t + e | 0) >>> 0 < t >>> 0 ? o + 1 | 0 : o, u = o = DA(e ^ s, u ^ o, 1), CA = o, T = s = h, s = r, r = D, D = DA(y ^ z, K ^ hA, 48), o = N + (hA = h) | 0, N = D, o = (D = n + D | 0) >>> 0 < n >>> 0 ? o + 1 | 0 : o, n = f, f = r ^ D, r = o, f = DA(f, o ^ p, 1), o = (p = h) + s | 0, o = MA + (f >>> 0 > (y = n + f | 0) >>> 0 ? o + 1 | 0 : o) | 0, o = wA + (n = (y = y + cA | 0) >>> 0 < cA >>> 0 ? o + 1 | 0 : o) | 0, z = s = y + gA | 0, s = o = s >>> 0 < gA >>> 0 ? o + 1 | 0 : o, y = DA(y ^ G, n ^ $, 32), o = b + (K = h) | 0, G = o = (n = y + S | 0) >>> 0 < S >>> 0 ? o + 1 | 0 : o, S = DA(f ^ n, p ^ o, 40), o = ($ = h) + s | 0, p = f = S + z | 0, y = DA(f ^ y, K ^ (b = f >>> 0 < S >>> 0 ? o + 1 | 0 : o), 48), o = G + (z = h) | 0, K = f = y + n | 0, G = f, R = o = f >>> 0 < n >>> 0 ? o + 1 | 0 : o, n = D, s = r, o = M + P | 0, o = (f = w + L | 0) >>> 0 < w >>> 0 ? o + 1 | 0 : o, w = f, f ^= _, _ = o, o = DA(f, AA ^ o, 1), m = f = h, M = o, r = o, o = d + l | 0, o = ((D = F + aA | 0) >>> 0 < aA >>> 0 ? o + 1 | 0 : o) + f | 0, F = o = (f = D) >>> 0 > (D = r + D | 0) >>> 0 ? o + 1 | 0 : o, r = DA(c ^ D, o ^ x, 32), o = (o = s) + (s = h) | 0, L = f = r + n | 0, c = DA(c = f ^ M, m ^ (M = f >>> 0 < r >>> 0 ? o + 1 | 0 : o), 40), o = F + (x = h) | 0, o = FA + ((f = c + D | 0) >>> 0 < D >>> 0 ? o + 1 | 0 : o) | 0, m = o = (n = f + V | 0) >>> 0 < V >>> 0 ? o + 1 | 0 : o, s = DA(r ^ n, s ^ o, 48), SA = o = h, f = DA(k ^ J, U ^ W, 1), o = (r = h) + O | 0, o = kA + ((D = f + Z | 0) >>> 0 < f >>> 0 ? o + 1 | 0 : o) | 0, o = j + (k = (D = D + oA | 0) >>> 0 < oA >>> 0 ? o + 1 | 0 : o) | 0, O = F = I + D | 0, J = o = F >>> 0 < I >>> 0 ? o + 1 | 0 : o, U = f, F = DA(D ^ N, k ^ hA, 32), o = (W = h) + _ | 0, _ = f = F + w | 0, D = DA(f ^ U, (N = f >>> 0 < F >>> 0 ? o + 1 | 0 : o) ^ r, 40), o = (o = J) + (J = h) | 0, U = f = D + O | 0, O = o = f >>> 0 < D >>> 0 ? o + 1 | 0 : o, r = o, o = j + T | 0, o = ((k = I + u | 0) >>> 0 < I >>> 0 ? o + 1 | 0 : o) + r | 0, d = o = (r = f + k | 0) >>> 0 < k >>> 0 ? o + 1 | 0 : o, f = DA(r ^ s, SA ^ o, 32), o = (u = h) + R | 0, w = DA((k = f + G | 0) ^ CA, (o = k >>> 0 < f >>> 0 ? o + 1 | 0 : o) ^ T, 40), T = o, o = wA + (G = h) | 0, o = d + ((Z = w + gA | 0) >>> 0 < gA >>> 0 ? o + 1 | 0 : o) | 0, o = (d = r + Z | 0) >>> 0 < r >>> 0 ? o + 1 | 0 : o, r = u, u = o, r = DA(f ^ d, r ^ o, 48), o = (o = T) + (T = h) | 0, f = w ^ (k = r + k | 0), w = o = k >>> 0 < r >>> 0 ? o + 1 | 0 : o, Z = o = DA(f, o ^ G, 1), CA = o, P = f = h, G = e, AA = t, e = D, D = DA(F ^ U, O ^ W, 48), o = N + (U = h) | 0, F = f = D + _ | 0, _ = o = f >>> 0 < _ >>> 0 ? o + 1 | 0 : o, e = DA(f ^ e, o ^ J, 1), o = (O = h) + MA | 0, o = m + ((f = e + cA | 0) >>> 0 < e >>> 0 ? o + 1 | 0 : o) | 0, n = o = (t = f + n | 0) >>> 0 < n >>> 0 ? o + 1 | 0 : o, f = DA(t ^ y, o ^ z, 32), o = (J = h) + AA | 0, G = y = f + G | 0, N = o = y >>> 0 < f >>> 0 ? o + 1 | 0 : o, e = DA(e ^ y, o ^ O, 40), o = nA + (hA = h) | 0, O = e, o = n + ((e = EA + e | 0) >>> 0 < EA >>> 0 ? o + 1 | 0 : o) | 0, t = o = (e = e + t | 0) >>> 0 < t >>> 0 ? o + 1 | 0 : o, y = DA(f ^ e, o ^ J, 48), o = (o = N) + (N = h) | 0, z = f = y + G | 0, J = f, m = o = f >>> 0 < y >>> 0 ? o + 1 | 0 : o, o = M + SA | 0, G = (f = s + L | 0) ^ c, c = o = f >>> 0 < s >>> 0 ? o + 1 | 0 : o, o = DA(G, o ^ x, 1), x = n = h, G = o, o = b + eA | 0, o = ((s = p + q | 0) >>> 0 < q >>> 0 ? o + 1 | 0 : o) + n | 0, M = o = (M = s) >>> 0 > (s = s + G | 0) >>> 0 ? o + 1 | 0 : o, L = n = DA(s ^ v, IA ^ o, 32), p = o = h, o = o + _ | 0, b = n = n + F | 0, v = o = L >>> 0 > n >>> 0 ? o + 1 | 0 : o, n = DA(n ^ G, x ^ o, 40), o = yA + (x = h) | 0, o = M + ((F = n + rA | 0) >>> 0 < rA >>> 0 ? o + 1 | 0 : o) | 0, F = o = (G = s) >>> 0 > (s = s + F | 0) >>> 0 ? o + 1 | 0 : o, G = DA(s ^ L, o ^ p, 48), IA = o = h, _ = o, S = DA(S ^ K, R ^ $, 1), M = o = h, L = D, o = o + l | 0, o = Y + ((D = S + aA | 0) >>> 0 < aA >>> 0 ? o + 1 | 0 : o) | 0, o = (D = D + H | 0) >>> 0 < H >>> 0 ? o + 1 | 0 : o, H = D ^ L, L = o, H = DA(H, o ^ U, 32), o = ($ = h) + c | 0, Y = f = H + f | 0, c = DA(f ^ S, (c = M) ^ (M = f >>> 0 < H >>> 0 ? o + 1 | 0 : o), 40), o = kA + (p = h) | 0, o = L + ((f = c + oA | 0) >>> 0 < oA >>> 0 ? o + 1 | 0 : o) | 0, L = f = f + D | 0, U = o = f >>> 0 < D >>> 0 ? o + 1 | 0 : o, D = o, o = P + _A | 0, o = ((S = Z + iA | 0) >>> 0 < iA >>> 0 ? o + 1 | 0 : o) + D | 0, Z = o = (D = f + S | 0) >>> 0 < S >>> 0 ? o + 1 | 0 : o, f = DA(D ^ G, o ^ _, 32), o = (K = h) + m | 0, _ = DA((S = f + J | 0) ^ CA, (o = S >>> 0 < f >>> 0 ? o + 1 | 0 : o) ^ P, 40), R = J = h, P = o, o = J + HA | 0, o = Z + ((J = _ + tA | 0) >>> 0 < tA >>> 0 ? o + 1 | 0 : o) | 0, Z = o = (J = D + J | 0) >>> 0 < D >>> 0 ? o + 1 | 0 : o, D = DA(f ^ J, o ^ K, 48), o = (K = h) + P | 0, f = (S = D + S | 0) ^ _, _ = o = S >>> 0 < D >>> 0 ? o + 1 | 0 : o, R = o = DA(f, o ^ R, 1), P = f = h, AA = k, W = y, y = c, c = DA(H ^ L, U ^ $, 48), o = (H = h) + M | 0, M = f = c + Y | 0, L = o = f >>> 0 < c >>> 0 ? o + 1 | 0 : o, y = DA(f ^ y, o ^ p, 1), o = (p = h) + GA | 0, o = ((f = y + QA | 0) >>> 0 < y >>> 0 ? o + 1 | 0 : o) + F | 0, s = o = (k = f + s | 0) >>> 0 < f >>> 0 ? o + 1 | 0 : o, f = DA(k ^ W, o ^ N, 32), o = (F = h) + w | 0, Y = w = f + AA | 0, N = o = w >>> 0 < f >>> 0 ? o + 1 | 0 : o, y = DA(y ^ w, o ^ p, 40), o = C + (W = h) | 0, p = y, o = s + ((y = sA + y | 0) >>> 0 < sA >>> 0 ? o + 1 | 0 : o) | 0, U = o = (w = y + k | 0) >>> 0 < k >>> 0 ? o + 1 | 0 : o, y = DA(f ^ w, o ^ F, 48), o = (o = N) + (N = h) | 0, Y = f = y + Y | 0, AA = o = f >>> 0 < y >>> 0 ? o + 1 | 0 : o, s = r, k = e, o = v + IA | 0, r = o = (f = G + b | 0) >>> 0 < G >>> 0 ? o + 1 | 0 : o, e = DA(f ^ n, o ^ x, 1), o = (n = h) + BA | 0, o = ((F = e + X | 0) >>> 0 < e >>> 0 ? o + 1 | 0 : o) + t | 0, t = DA(s ^ (k = k + F | 0), (o = k >>> 0 < F >>> 0 ? o + 1 | 0 : o) ^ T, 32), F = o, G = e, o = (s = h) + L | 0, o = (e = t + M | 0) >>> 0 < t >>> 0 ? o + 1 | 0 : o, M = e, e ^= G, G = o, e = DA(e, o ^ n, 40), o = B + (L = h) | 0, o = ((n = e + g | 0) >>> 0 < g >>> 0 ? o + 1 | 0 : o) + F | 0, b = o = (F = n) >>> 0 > (n = n + k | 0) >>> 0 ? o + 1 | 0 : o, s = DA(t ^ n, o ^ s, 48), IA = o = h, k = o, t = DA(z ^ O, m ^ hA, 1), v = o = h, O = r, o = o + FA | 0, o = u + ((r = t + V | 0) >>> 0 < V >>> 0 ? o + 1 | 0 : o) | 0, F = H, H = o = (r = r + d | 0) >>> 0 < d >>> 0 ? o + 1 | 0 : o, F = DA(c ^ r, F ^ o, 32), o = ($ = h) + O | 0, d = f = F + f | 0, c = DA(f ^ t, (c = v) ^ (v = f >>> 0 < F >>> 0 ? o + 1 | 0 : o), 40), o = pA + (O = h) | 0, o = H + ((f = c + fA | 0) >>> 0 < fA >>> 0 ? o + 1 | 0 : o) | 0, u = f = f + r | 0, z = o = f >>> 0 < r >>> 0 ? o + 1 | 0 : o, r = o, o = P + eA | 0, o = ((t = q + R | 0) >>> 0 < q >>> 0 ? o + 1 | 0 : o) + r | 0, H = o = (r = f + t | 0) >>> 0 < t >>> 0 ? o + 1 | 0 : o, f = DA(r ^ s, o ^ k, 32), o = (T = h) + AA | 0, k = DA((t = f + Y | 0) ^ R, (o = t >>> 0 < f >>> 0 ? o + 1 | 0 : o) ^ P, 40), R = o, o = l + (x = h) | 0, o = H + ((m = k + aA | 0) >>> 0 < aA >>> 0 ? o + 1 | 0 : o) | 0, o = (H = r + m | 0) >>> 0 < r >>> 0 ? o + 1 | 0 : o, r = T, T = o, r = DA(f ^ H, r ^ o, 48), o = (o = R) + (R = h) | 0, f = (t = r + t | 0) ^ k, k = o = t >>> 0 < r >>> 0 ? o + 1 | 0 : o, x = o = DA(f, o ^ x, 1), m = f = h, P = y, y = c, c = DA(F ^ u, z ^ $, 48), o = (o = v) + (v = h) | 0, d = f = c + d | 0, F = O, O = o = f >>> 0 < c >>> 0 ? o + 1 | 0 : o, y = DA(f ^ y, F ^ o, 1), o = (u = h) + HA | 0, o = b + ((f = y + tA | 0) >>> 0 < y >>> 0 ? o + 1 | 0 : o) | 0, F = n, n = f + n | 0, f = N, N = o = F >>> 0 > n >>> 0 ? o + 1 | 0 : o, f = DA(n ^ P, f ^ o, 32), o = (o = _) + (_ = h) | 0, b = o = (F = f + S | 0) >>> 0 < f >>> 0 ? o + 1 | 0 : o, S = F, y = DA(y ^ F, o ^ u, 40), o = FA + ($ = h) | 0, u = y, o = N + ((y = V + y | 0) >>> 0 < V >>> 0 ? o + 1 | 0 : o) | 0, N = o = (F = y + n | 0) >>> 0 < n >>> 0 ? o + 1 | 0 : o, y = DA(f ^ F, o ^ _, 48), o = (o = b) + (b = h) | 0, z = f = y + S | 0, P = o = f >>> 0 < y >>> 0 ? o + 1 | 0 : o, S = D, o = G + IA | 0, D = o = (f = s + M | 0) >>> 0 < s >>> 0 ? o + 1 | 0 : o, e = DA(f ^ e, o ^ L, 1), o = wA + (s = h) | 0, o = U + ((n = e + gA | 0) >>> 0 < gA >>> 0 ? o + 1 | 0 : o) | 0, G = (n = w + n | 0) ^ S, S = o = n >>> 0 < w >>> 0 ? o + 1 | 0 : o, w = DA(G, o ^ K, 32), _ = o = h, G = e, o = o + O | 0, o = (e = w + d | 0) >>> 0 < w >>> 0 ? o + 1 | 0 : o, M = e, e ^= G, G = o, e = DA(e, o ^ s, 40), o = B + (L = h) | 0, o = S + ((s = e + g | 0) >>> 0 < g >>> 0 ? o + 1 | 0 : o) | 0, U = o = (s = n + s | 0) >>> 0 < n >>> 0 ? o + 1 | 0 : o, S = DA(w ^ s, o ^ _, 48), IA = o = h, n = o, w = DA(p ^ Y, W ^ AA, 1), d = o = h, Y = D, o = o + C | 0, o = Z + ((D = w + sA | 0) >>> 0 < sA >>> 0 ? o + 1 | 0 : o) | 0, J = o = (D = D + J | 0) >>> 0 < J >>> 0 ? o + 1 | 0 : o, _ = DA(c ^ D, o ^ v, 32), o = (CA = h) + Y | 0, Y = f = _ + f | 0, c = DA(f ^ w, (p = f >>> 0 < _ >>> 0 ? o + 1 | 0 : o) ^ d, 40), o = j + (v = h) | 0, o = J + ((f = I + c | 0) >>> 0 < I >>> 0 ? o + 1 | 0 : o) | 0, J = f = f + D | 0, O = o = f >>> 0 < D >>> 0 ? o + 1 | 0 : o, D = o, o = m + kA | 0, o = ((w = x + oA | 0) >>> 0 < oA >>> 0 ? o + 1 | 0 : o) + D | 0, d = o = (D = f + w | 0) >>> 0 < w >>> 0 ? o + 1 | 0 : o, f = DA(D ^ S, o ^ n, 32), o = (Z = h) + P | 0, n = DA((w = f + z | 0) ^ x, (o = w >>> 0 < f >>> 0 ? o + 1 | 0 : o) ^ m, 40), K = o, o = MA + (x = h) | 0, o = d + ((m = n + cA | 0) >>> 0 < cA >>> 0 ? o + 1 | 0 : o) | 0, o = (d = D + m | 0) >>> 0 < D >>> 0 ? o + 1 | 0 : o, D = Z, Z = o, D = DA(f ^ d, D ^ o, 48), o = (o = K) + (K = h) | 0, f = (w = D + w | 0) ^ n, n = o = w >>> 0 < D >>> 0 ? o + 1 | 0 : o, x = o = DA(f, o ^ x, 1), hA = o, m = f = h, AA = t, W = y, t = c, c = DA(_ ^ J, O ^ CA, 48), o = (_ = h) + p | 0, J = f = c + Y | 0, Y = o = f >>> 0 < c >>> 0 ? o + 1 | 0 : o, t = DA(f ^ t, o ^ v, 1), o = (v = h) + yA | 0, o = U + ((f = t + rA | 0) >>> 0 < t >>> 0 ? o + 1 | 0 : o) | 0, s = o = (y = f + s | 0) >>> 0 < s >>> 0 ? o + 1 | 0 : o, f = DA(y ^ W, o ^ b, 32), o = (p = h) + k | 0, b = o = (k = f + AA | 0) >>> 0 < f >>> 0 ? o + 1 | 0 : o, t = DA(t ^ k, o ^ v, 40), o = GA + (CA = h) | 0, U = t, o = s + ((t = QA + t | 0) >>> 0 < QA >>> 0 ? o + 1 | 0 : o) | 0, s = t + y | 0, t = p, p = o = s >>> 0 < y >>> 0 ? o + 1 | 0 : o, t = DA(f ^ s, t ^ o, 48), o = (o = b) + (b = h) | 0, v = f = t + k | 0, O = o = f >>> 0 < t >>> 0 ? o + 1 | 0 : o, y = r, o = G + IA | 0, r = o = (f = S + M | 0) >>> 0 < S >>> 0 ? o + 1 | 0 : o, e = DA(f ^ e, o ^ L, 1), o = (S = h) + pA | 0, o = N + ((k = e + fA | 0) >>> 0 < e >>> 0 ? o + 1 | 0 : o) | 0, y = DA(y ^ (k = k + F | 0), (o = k >>> 0 < F >>> 0 ? o + 1 | 0 : o) ^ R, 32), G = F = h, F = o, M = e, o = G + Y | 0, o = (e = y + J | 0) >>> 0 < y >>> 0 ? o + 1 | 0 : o, J = e, e ^= M, M = o, e = DA(e, o ^ S, 40), o = nA + (L = h) | 0, o = ((S = e + EA | 0) >>> 0 < EA >>> 0 ? o + 1 | 0 : o) + F | 0, N = G, G = o = (F = k + S | 0) >>> 0 < S >>> 0 ? o + 1 | 0 : o, S = DA(y ^ F, N ^ o, 48), IA = o = h, k = o, y = DA(z ^ u, P ^ $, 1), Y = o = h, N = r, o = o + BA | 0, o = T + ((r = y + X | 0) >>> 0 < X >>> 0 ? o + 1 | 0 : o) | 0, H = o = (r = r + H | 0) >>> 0 < H >>> 0 ? o + 1 | 0 : o, _ = DA(c ^ r, o ^ _, 32), o = ($ = h) + N | 0, N = f = _ + f | 0, c = DA(f ^ y, (c = Y) ^ (Y = f >>> 0 < _ >>> 0 ? o + 1 | 0 : o), 40), o = _A + (u = h) | 0, o = H + ((f = c + iA | 0) >>> 0 < iA >>> 0 ? o + 1 | 0 : o) | 0, z = f = f + r | 0, T = o = f >>> 0 < r >>> 0 ? o + 1 | 0 : o, r = o, o = m + B | 0, o = ((y = x + g | 0) >>> 0 < g >>> 0 ? o + 1 | 0 : o) + r | 0, H = o = (r = f + y | 0) >>> 0 < y >>> 0 ? o + 1 | 0 : o, f = DA(r ^ S, o ^ k, 32), o = (x = h) + O | 0, k = DA((y = f + v | 0) ^ hA, (o = y >>> 0 < f >>> 0 ? o + 1 | 0 : o) ^ m, 40), m = o, o = HA + (R = h) | 0, o = H + ((P = k + tA | 0) >>> 0 < tA >>> 0 ? o + 1 | 0 : o) | 0, o = (H = r + P | 0) >>> 0 < r >>> 0 ? o + 1 | 0 : o, r = x, x = o, r = DA(f ^ H, r ^ o, 48), o = (o = m) + (m = h) | 0, f = (y = r + y | 0) ^ k, k = o = y >>> 0 < r >>> 0 ? o + 1 | 0 : o, R = o = DA(f, o ^ R, 1), P = f = h, AA = w, W = t, t = c, c = DA(_ ^ z, T ^ $, 48), o = (_ = h) + Y | 0, Y = f = c + N | 0, N = o = f >>> 0 < c >>> 0 ? o + 1 | 0 : o, t = DA(f ^ t, o ^ u, 1), o = (u = h) + GA | 0, o = G + ((f = t + QA | 0) >>> 0 < t >>> 0 ? o + 1 | 0 : o) | 0, F = o = (w = f + F | 0) >>> 0 < F >>> 0 ? o + 1 | 0 : o, f = DA(w ^ W, o ^ b, 32), o = (G = h) + n | 0, b = o = (n = f + AA | 0) >>> 0 < f >>> 0 ? o + 1 | 0 : o, t = DA(t ^ n, o ^ u, 40), o = BA + ($ = h) | 0, u = t, o = F + ((t = X + t | 0) >>> 0 < X >>> 0 ? o + 1 | 0 : o) | 0, F = t + w | 0, t = G, G = o = F >>> 0 < w >>> 0 ? o + 1 | 0 : o, t = DA(f ^ F, t ^ o, 48), o = (o = b) + (b = h) | 0, z = f = t + n | 0, T = o = f >>> 0 < t >>> 0 ? o + 1 | 0 : o, w = D, o = M + IA | 0, D = o = (f = S + J | 0) >>> 0 < S >>> 0 ? o + 1 | 0 : o, e = DA(f ^ e, o ^ L, 1), o = _A + (S = h) | 0, o = p + ((n = e + iA | 0) >>> 0 < iA >>> 0 ? o + 1 | 0 : o) | 0, s = o = (n = n + s | 0) >>> 0 < s >>> 0 ? o + 1 | 0 : o, w = DA(w ^ n, o ^ K, 32), J = o = h, M = e, o = o + N | 0, o = (e = w + Y | 0) >>> 0 < w >>> 0 ? o + 1 | 0 : o, L = e, e ^= M, M = o, e = DA(e, o ^ S, 40), o = kA + (Y = h) | 0, o = s + ((S = e + oA | 0) >>> 0 < oA >>> 0 ? o + 1 | 0 : o) | 0, o = (s = n + S | 0) >>> 0 < n >>> 0 ? o + 1 | 0 : o, n = J, J = o, S = DA(w ^ s, n ^ o, 48), IA = o = h, n = o, w = DA(U ^ v, O ^ CA, 1), N = o = h, p = D, o = o + j | 0, o = Z + ((D = I + w | 0) >>> 0 < I >>> 0 ? o + 1 | 0 : o) | 0, d = o = (D = D + d | 0) >>> 0 < d >>> 0 ? o + 1 | 0 : o, _ = DA(c ^ D, o ^ _, 32), o = (CA = h) + p | 0, p = f = _ + f | 0, c = DA(f ^ w, (c = N) ^ (N = f >>> 0 < _ >>> 0 ? o + 1 | 0 : o), 40), o = FA + (U = h) | 0, o = d + ((f = c + V | 0) >>> 0 < V >>> 0 ? o + 1 | 0 : o) | 0, v = f = f + D | 0, O = o = f >>> 0 < D >>> 0 ? o + 1 | 0 : o, D = o, o = P + wA | 0, o = ((w = R + gA | 0) >>> 0 < gA >>> 0 ? o + 1 | 0 : o) + D | 0, d = o = (D = f + w | 0) >>> 0 < w >>> 0 ? o + 1 | 0 : o, f = DA(D ^ S, o ^ n, 32), o = (Z = h) + T | 0, n = DA((w = f + z | 0) ^ R, (o = w >>> 0 < f >>> 0 ? o + 1 | 0 : o) ^ P, 40), R = o, o = C + (K = h) | 0, o = d + ((P = n + sA | 0) >>> 0 < sA >>> 0 ? o + 1 | 0 : o) | 0, o = (d = D + P | 0) >>> 0 < D >>> 0 ? o + 1 | 0 : o, D = Z, Z = o, D = DA(f ^ d, D ^ o, 48), o = (o = R) + (R = h) | 0, f = (w = D + w | 0) ^ n, n = o = w >>> 0 < D >>> 0 ? o + 1 | 0 : o, K = o = DA(f, o ^ K, 1), P = f = h, AA = y, W = t, t = c, c = DA(_ ^ v, O ^ CA, 48), o = (_ = h) + N | 0, N = f = c + p | 0, p = o = f >>> 0 < c >>> 0 ? o + 1 | 0 : o, t = DA(f ^ t, o ^ U, 1), o = (U = h) + eA | 0, o = J + ((f = t + q | 0) >>> 0 < t >>> 0 ? o + 1 | 0 : o) | 0, s = o = (y = f + s | 0) >>> 0 < s >>> 0 ? o + 1 | 0 : o, f = DA(y ^ W, o ^ b, 32), o = (J = h) + k | 0, b = o = (k = f + AA | 0) >>> 0 < f >>> 0 ? o + 1 | 0 : o, t = DA(t ^ k, o ^ U, 40), o = pA + (CA = h) | 0, U = t, o = s + ((t = fA + t | 0) >>> 0 < fA >>> 0 ? o + 1 | 0 : o) | 0, s = t + y | 0, t = J, J = o = s >>> 0 < y >>> 0 ? o + 1 | 0 : o, t = DA(f ^ s, t ^ o, 48), o = (o = b) + (b = h) | 0, v = f = t + k | 0, O = o = f >>> 0 < t >>> 0 ? o + 1 | 0 : o, y = r, o = M + IA | 0, r = o = (f = S + L | 0) >>> 0 < S >>> 0 ? o + 1 | 0 : o, e = DA(f ^ e, o ^ Y, 1), o = (S = h) + nA | 0, o = G + ((k = e + EA | 0) >>> 0 < e >>> 0 ? o + 1 | 0 : o) | 0, F = o = (k = k + F | 0) >>> 0 < F >>> 0 ? o + 1 | 0 : o, y = DA(y ^ k, o ^ m, 32), G = o = h, M = e, o = o + p | 0, o = (e = y + N | 0) >>> 0 < y >>> 0 ? o + 1 | 0 : o, L = e, e ^= M, M = o, e = DA(e, o ^ S, 40), o = yA + (Y = h) | 0, o = F + ((S = e + rA | 0) >>> 0 < rA >>> 0 ? o + 1 | 0 : o) | 0, N = G, G = o = (F = k + S | 0) >>> 0 < k >>> 0 ? o + 1 | 0 : o, S = DA(y ^ F, N ^ o, 48), IA = o = h, k = o, y = DA(z ^ u, T ^ $, 1), N = o = h, p = r, o = o + l | 0, o = x + ((r = y + aA | 0) >>> 0 < aA >>> 0 ? o + 1 | 0 : o) | 0, H = o = (r = r + H | 0) >>> 0 < H >>> 0 ? o + 1 | 0 : o, _ = DA(c ^ r, o ^ _, 32), o = ($ = h) + p | 0, p = f = _ + f | 0, c = DA(f ^ y, (c = N) ^ (N = f >>> 0 < _ >>> 0 ? o + 1 | 0 : o), 40), o = MA + (u = h) | 0, o = H + ((f = c + cA | 0) >>> 0 < cA >>> 0 ? o + 1 | 0 : o) | 0, z = f = f + r | 0, T = o = f >>> 0 < r >>> 0 ? o + 1 | 0 : o, r = o, o = P + C | 0, o = ((y = K + sA | 0) >>> 0 < sA >>> 0 ? o + 1 | 0 : o) + r | 0, H = o = (r = f + y | 0) >>> 0 < y >>> 0 ? o + 1 | 0 : o, f = DA(r ^ S, o ^ k, 32), o = (x = h) + O | 0, k = DA((y = f + v | 0) ^ K, (o = y >>> 0 < f >>> 0 ? o + 1 | 0 : o) ^ P, 40), m = o, o = _A + (K = h) | 0, o = H + ((P = k + iA | 0) >>> 0 < iA >>> 0 ? o + 1 | 0 : o) | 0, o = (H = r + P | 0) >>> 0 < r >>> 0 ? o + 1 | 0 : o, r = x, x = o, r = DA(f ^ H, r ^ o, 48), o = (o = m) + (m = h) | 0, f = (y = r + y | 0) ^ k, k = o = y >>> 0 < r >>> 0 ? o + 1 | 0 : o, K = o = DA(f, o ^ K, 1), P = f = h, AA = w, W = t, t = c, c = DA(_ ^ z, T ^ $, 48), o = (_ = h) + N | 0, N = f = c + p | 0, p = o = f >>> 0 < c >>> 0 ? o + 1 | 0 : o, t = DA(f ^ t, o ^ u, 1), o = (u = h) + l | 0, o = G + ((f = t + aA | 0) >>> 0 < t >>> 0 ? o + 1 | 0 : o) | 0, F = o = (w = f + F | 0) >>> 0 < F >>> 0 ? o + 1 | 0 : o, f = DA(w ^ W, o ^ b, 32), o = (G = h) + n | 0, b = o = (n = f + AA | 0) >>> 0 < f >>> 0 ? o + 1 | 0 : o, t = DA(t ^ n, o ^ u, 40), o = yA + ($ = h) | 0, u = t, o = F + ((t = rA + t | 0) >>> 0 < rA >>> 0 ? o + 1 | 0 : o) | 0, F = t + w | 0, t = G, G = o = F >>> 0 < w >>> 0 ? o + 1 | 0 : o, t = DA(f ^ F, t ^ o, 48), o = (o = b) + (b = h) | 0, z = f = t + n | 0, T = o = f >>> 0 < t >>> 0 ? o + 1 | 0 : o, w = D, o = M + IA | 0, D = o = (f = S + L | 0) >>> 0 < S >>> 0 ? o + 1 | 0 : o, e = DA(f ^ e, o ^ Y, 1), o = nA + (S = h) | 0, o = J + ((n = e + EA | 0) >>> 0 < EA >>> 0 ? o + 1 | 0 : o) | 0, s = o = (n = n + s | 0) >>> 0 < s >>> 0 ? o + 1 | 0 : o, w = DA(w ^ n, o ^ R, 32), J = o = h, M = e, o = o + p | 0, o = (e = w + N | 0) >>> 0 < w >>> 0 ? o + 1 | 0 : o, L = e, e ^= M, M = o, e = DA(e, o ^ S, 40), o = pA + (Y = h) | 0, o = s + ((S = e + fA | 0) >>> 0 < fA >>> 0 ? o + 1 | 0 : o) | 0, o = (s = n + S | 0) >>> 0 < n >>> 0 ? o + 1 | 0 : o, n = J, J = o, S = DA(w ^ s, n ^ o, 48), IA = o = h, n = o, w = DA(U ^ v, O ^ CA, 1), N = o = h, p = D, o = o + BA | 0, o = Z + ((D = w + X | 0) >>> 0 < X >>> 0 ? o + 1 | 0 : o) | 0, d = o = (D = D + d | 0) >>> 0 < d >>> 0 ? o + 1 | 0 : o, _ = DA(c ^ D, o ^ _, 32), o = (CA = h) + p | 0, p = f = _ + f | 0, c = DA(f ^ w, (c = N) ^ (N = f >>> 0 < _ >>> 0 ? o + 1 | 0 : o), 40), o = MA + (U = h) | 0, o = d + ((f = c + cA | 0) >>> 0 < cA >>> 0 ? o + 1 | 0 : o) | 0, v = f = f + D | 0, O = o = f >>> 0 < D >>> 0 ? o + 1 | 0 : o, D = o, o = P + FA | 0, o = ((w = K + V | 0) >>> 0 < V >>> 0 ? o + 1 | 0 : o) + D | 0, d = o = (D = f + w | 0) >>> 0 < w >>> 0 ? o + 1 | 0 : o, f = DA(D ^ S, o ^ n, 32), o = (Z = h) + T | 0, n = DA((w = f + z | 0) ^ K, (o = w >>> 0 < f >>> 0 ? o + 1 | 0 : o) ^ P, 40), R = o, o = j + (K = h) | 0, o = d + ((P = I + n | 0) >>> 0 < I >>> 0 ? o + 1 | 0 : o) | 0, o = (d = D + P | 0) >>> 0 < D >>> 0 ? o + 1 | 0 : o, D = Z, Z = o, D = DA(f ^ d, D ^ o, 48), o = (o = R) + (R = h) | 0, f = (w = D + w | 0) ^ n, n = o = w >>> 0 < D >>> 0 ? o + 1 | 0 : o, K = o = DA(f, o ^ K, 1), P = f = h, AA = y, W = t, t = c, c = DA(_ ^ v, O ^ CA, 48), o = (_ = h) + N | 0, N = f = c + p | 0, p = o = f >>> 0 < c >>> 0 ? o + 1 | 0 : o, t = DA(f ^ t, o ^ U, 1), o = (U = h) + kA | 0, o = J + ((f = t + oA | 0) >>> 0 < t >>> 0 ? o + 1 | 0 : o) | 0, s = o = (y = f + s | 0) >>> 0 < s >>> 0 ? o + 1 | 0 : o, f = DA(y ^ W, o ^ b, 32), o = (J = h) + k | 0, b = o = (k = f + AA | 0) >>> 0 < f >>> 0 ? o + 1 | 0 : o, t = DA(t ^ k, o ^ U, 40), o = B + (CA = h) | 0, U = t, o = s + ((t = g + t | 0) >>> 0 < g >>> 0 ? o + 1 | 0 : o) | 0, s = t + y | 0, t = J, J = o = s >>> 0 < y >>> 0 ? o + 1 | 0 : o, t = DA(f ^ s, t ^ o, 48), o = (o = b) + (b = h) | 0, v = f = t + k | 0, O = o = f >>> 0 < t >>> 0 ? o + 1 | 0 : o, y = r, o = M + IA | 0, r = o = (f = S + L | 0) >>> 0 < S >>> 0 ? o + 1 | 0 : o, e = DA(f ^ e, o ^ Y, 1), o = (S = h) + wA | 0, o = G + ((k = e + gA | 0) >>> 0 < e >>> 0 ? o + 1 | 0 : o) | 0, F = o = (k = k + F | 0) >>> 0 < F >>> 0 ? o + 1 | 0 : o, y = DA(y ^ k, o ^ m, 32), G = o = h, M = e, o = o + p | 0, o = (e = y + N | 0) >>> 0 < y >>> 0 ? o + 1 | 0 : o, L = e, e ^= M, M = o, e = DA(e, o ^ S, 40), o = GA + (Y = h) | 0, o = F + ((S = e + QA | 0) >>> 0 < QA >>> 0 ? o + 1 | 0 : o) | 0, N = G, G = o = (F = k + S | 0) >>> 0 < k >>> 0 ? o + 1 | 0 : o, S = DA(y ^ F, N ^ o, 48), IA = o = h, k = o, y = DA(z ^ u, T ^ $, 1), N = o = h, p = r, o = o + HA | 0, o = x + ((r = y + tA | 0) >>> 0 < tA >>> 0 ? o + 1 | 0 : o) | 0, H = o = (r = r + H | 0) >>> 0 < H >>> 0 ? o + 1 | 0 : o, _ = DA(c ^ r, o ^ _, 32), o = ($ = h) + p | 0, p = f = _ + f | 0, c = DA(f ^ y, (c = N) ^ (N = f >>> 0 < _ >>> 0 ? o + 1 | 0 : o), 40), o = eA + (u = h) | 0, o = H + ((f = c + q | 0) >>> 0 < q >>> 0 ? o + 1 | 0 : o) | 0, z = f = f + r | 0, T = o = f >>> 0 < r >>> 0 ? o + 1 | 0 : o, r = o, o = P + MA | 0, o = ((y = K + cA | 0) >>> 0 < cA >>> 0 ? o + 1 | 0 : o) + r | 0, H = o = (r = f + y | 0) >>> 0 < y >>> 0 ? o + 1 | 0 : o, f = DA(r ^ S, o ^ k, 32), o = (x = h) + O | 0, k = DA((y = f + v | 0) ^ K, (o = y >>> 0 < f >>> 0 ? o + 1 | 0 : o) ^ P, 40), m = o, o = yA + (K = h) | 0, o = H + ((P = k + rA | 0) >>> 0 < rA >>> 0 ? o + 1 | 0 : o) | 0, o = (H = r + P | 0) >>> 0 < r >>> 0 ? o + 1 | 0 : o, r = x, x = o, r = DA(f ^ H, r ^ o, 48), o = (o = m) + (m = h) | 0, f = (y = r + y | 0) ^ k, k = o = y >>> 0 < r >>> 0 ? o + 1 | 0 : o, K = o = DA(f, o ^ K, 1), P = f = h, AA = w, W = t, t = c, c = DA(_ ^ z, T ^ $, 48), o = (_ = h) + N | 0, N = f = c + p | 0, p = o = f >>> 0 < c >>> 0 ? o + 1 | 0 : o, t = DA(f ^ t, o ^ u, 1), o = (u = h) + _A | 0, o = G + ((f = t + iA | 0) >>> 0 < t >>> 0 ? o + 1 | 0 : o) | 0, F = o = (w = f + F | 0) >>> 0 < F >>> 0 ? o + 1 | 0 : o, f = DA(w ^ W, o ^ b, 32), o = (G = h) + n | 0, b = o = (n = f + AA | 0) >>> 0 < f >>> 0 ? o + 1 | 0 : o, t = DA(t ^ n, o ^ u, 40), o = C + ($ = h) | 0, u = t, o = F + ((t = sA + t | 0) >>> 0 < sA >>> 0 ? o + 1 | 0 : o) | 0, F = t + w | 0, t = G, G = o = F >>> 0 < w >>> 0 ? o + 1 | 0 : o, t = DA(f ^ F, t ^ o, 48), o = (o = b) + (b = h) | 0, z = f = t + n | 0, T = o = f >>> 0 < t >>> 0 ? o + 1 | 0 : o, w = D, o = M + IA | 0, D = o = (f = S + L | 0) >>> 0 < S >>> 0 ? o + 1 | 0 : o, e = DA(f ^ e, o ^ Y, 1), o = GA + (S = h) | 0, o = J + ((n = e + QA | 0) >>> 0 < QA >>> 0 ? o + 1 | 0 : o) | 0, s = o = (n = n + s | 0) >>> 0 < s >>> 0 ? o + 1 | 0 : o, w = DA(w ^ n, o ^ R, 32), J = o = h, M = e, o = o + p | 0, o = (e = w + N | 0) >>> 0 < w >>> 0 ? o + 1 | 0 : o, L = e, e ^= M, M = o, e = DA(e, o ^ S, 40), o = l + (Y = h) | 0, o = s + ((S = e + aA | 0) >>> 0 < aA >>> 0 ? o + 1 | 0 : o) | 0, o = (s = n + S | 0) >>> 0 < n >>> 0 ? o + 1 | 0 : o, n = J, J = o, S = DA(w ^ s, n ^ o, 48), IA = o = h, n = o, w = DA(U ^ v, O ^ CA, 1), N = o = h, p = D, o = o + pA | 0, o = Z + ((D = w + fA | 0) >>> 0 < fA >>> 0 ? o + 1 | 0 : o) | 0, d = o = (D = D + d | 0) >>> 0 < d >>> 0 ? o + 1 | 0 : o, _ = DA(c ^ D, o ^ _, 32), o = (CA = h) + p | 0, p = f = _ + f | 0, c = DA(f ^ w, (c = N) ^ (N = f >>> 0 < _ >>> 0 ? o + 1 | 0 : o), 40), o = HA + (U = h) | 0, o = d + ((f = c + tA | 0) >>> 0 < tA >>> 0 ? o + 1 | 0 : o) | 0, v = f = f + D | 0, O = o = f >>> 0 < D >>> 0 ? o + 1 | 0 : o, D = o, o = P + nA | 0, o = ((w = K + EA | 0) >>> 0 < EA >>> 0 ? o + 1 | 0 : o) + D | 0, d = o = (D = f + w | 0) >>> 0 < w >>> 0 ? o + 1 | 0 : o, f = DA(D ^ S, o ^ n, 32), o = (Z = h) + T | 0, n = DA((w = f + z | 0) ^ K, (o = w >>> 0 < f >>> 0 ? o + 1 | 0 : o) ^ P, 40), R = o, o = B + (K = h) | 0, o = d + ((P = n + g | 0) >>> 0 < g >>> 0 ? o + 1 | 0 : o) | 0, o = (d = D + P | 0) >>> 0 < D >>> 0 ? o + 1 | 0 : o, D = Z, Z = o, D = DA(f ^ d, D ^ o, 48), o = (o = R) + (R = h) | 0, f = (w = D + w | 0) ^ n, n = o = w >>> 0 < D >>> 0 ? o + 1 | 0 : o, K = o = DA(f, o ^ K, 1), P = f = h, AA = y, W = t, t = c, c = DA(_ ^ v, O ^ CA, 48), o = (_ = h) + N | 0, N = f = c + p | 0, p = o = f >>> 0 < c >>> 0 ? o + 1 | 0 : o, t = DA(f ^ t, o ^ U, 1), o = (v = h) + BA | 0, o = J + ((f = t + X | 0) >>> 0 < t >>> 0 ? o + 1 | 0 : o) | 0, s = o = (y = f + s | 0) >>> 0 < s >>> 0 ? o + 1 | 0 : o, f = DA(y ^ W, o ^ b, 32), o = (J = h) + k | 0, b = k = f + AA | 0, U = o = k >>> 0 < f >>> 0 ? o + 1 | 0 : o, t = DA(t ^ k, o ^ v, 40), o = FA + (AA = h) | 0, v = t, o = s + ((t = V + t | 0) >>> 0 < V >>> 0 ? o + 1 | 0 : o) | 0, k = t + y | 0, t = J, J = o = k >>> 0 < y >>> 0 ? o + 1 | 0 : o, t = DA(f ^ k, t ^ o, 48), o = (o = U) + (U = h) | 0, b = f = t + b | 0, O = o = f >>> 0 < t >>> 0 ? o + 1 | 0 : o, y = r, o = M + IA | 0, r = o = (f = S + L | 0) >>> 0 < S >>> 0 ? o + 1 | 0 : o, e = DA(f ^ e, o ^ Y, 1), o = (S = h) + j | 0, o = G + ((s = I + e | 0) >>> 0 < e >>> 0 ? o + 1 | 0 : o) | 0, F = o = (s = s + F | 0) >>> 0 < F >>> 0 ? o + 1 | 0 : o, G = y = DA(y ^ s, o ^ m, 32), M = o = h, L = e, o = o + p | 0, o = (e = y + N | 0) >>> 0 < y >>> 0 ? o + 1 | 0 : o, Y = e, e ^= L, L = o, e = DA(e, o ^ S, 40), o = kA + (N = h) | 0, o = F + ((y = e + oA | 0) >>> 0 < oA >>> 0 ? o + 1 | 0 : o) | 0, p = (y = y + s | 0) ^ G, G = o = y >>> 0 < s >>> 0 ? o + 1 | 0 : o, s = DA(p, o ^ M, 48), m = o = h, S = o, M = F = DA(z ^ u, T ^ $, 1), p = o = h, u = r, o = o + eA | 0, o = x + ((r = F + q | 0) >>> 0 < q >>> 0 ? o + 1 | 0 : o) | 0, o = (r = r + H | 0) >>> 0 < H >>> 0 ? o + 1 | 0 : o, H = _, _ = o, F = DA(c ^ r, H ^ o, 32), o = (W = h) + u | 0, H = f = F + f | 0, c = DA(c = f ^ M, (M = f >>> 0 < F >>> 0 ? o + 1 | 0 : o) ^ p, 40), o = wA + (p = h) | 0, o = _ + ((f = c + gA | 0) >>> 0 < gA >>> 0 ? o + 1 | 0 : o) | 0, _ = f = f + r | 0, u = o = f >>> 0 < r >>> 0 ? o + 1 | 0 : o, r = o, o = P + FA | 0, o = ((x = V) >>> 0 > (V = K + V | 0) >>> 0 ? o + 1 | 0 : o) + r | 0, FA = o = (f = f + V | 0) >>> 0 < V >>> 0 ? o + 1 | 0 : o, V = DA(f ^ s, o ^ S, 32), o = (z = h) + O | 0, S = DA((r = b + V | 0) ^ K, (o = r >>> 0 < V >>> 0 ? o + 1 | 0 : o) ^ P, 40), x = o, o = kA + (T = h) | 0, o = FA + ((K = oA) >>> 0 > (oA = S + oA | 0) >>> 0 ? o + 1 | 0 : o) | 0, o = (oA = f + oA | 0) >>> 0 < f >>> 0 ? o + 1 | 0 : o, f = V ^ oA, V = o;
                                        kA = DA(f, o ^ z, 48), o = (FA = h) + x | 0, r = o = (f = r + kA | 0) >>> 0 < kA >>> 0 ? o + 1 | 0 : o, o = DA(f ^ S, o ^ T, 1), S = h, z = o, T = w, w = gA, x = wA, wA = DA(F ^ _, u ^ W, 48), o = (F = h) + M | 0, M = w, H = o = (gA = H + wA | 0) >>> 0 < wA >>> 0 ? o + 1 | 0 : o, w = DA(c ^ (_ = gA), o ^ p, 1), o = (p = h) + x | 0, o = G + (w >>> 0 > (gA = M + w | 0) >>> 0 ? o + 1 | 0 : o) | 0, c = o = (gA = y + gA | 0) >>> 0 < y >>> 0 ? o + 1 | 0 : o, t = DA(t ^ gA, o ^ U, 32), o = (o = n) + (n = h) | 0, G = y = t + T | 0, M = o = y >>> 0 < t >>> 0 ? o + 1 | 0 : o, y = DA(y ^ w, o ^ p, 40), o = (p = h) + _A | 0, o = (y >>> 0 > (iA = y + iA | 0) >>> 0 ? o + 1 | 0 : o) + c | 0, c = o = (c = iA) >>> 0 > (iA = gA + iA | 0) >>> 0 ? o + 1 | 0 : o, t = DA(t ^ iA, o ^ n, 48), o = (w = h) + M | 0, n = gA = t + G | 0, _A = o = gA >>> 0 < t >>> 0 ? o + 1 | 0 : o, G = I, M = j, o = L + m | 0, gA = o = (I = s + Y | 0) >>> 0 < s >>> 0 ? o + 1 | 0 : o, j = DA(I ^ e, o ^ N, 1), o = (s = h) + M | 0, o = J + ((e = G + j | 0) >>> 0 < j >>> 0 ? o + 1 | 0 : o) | 0, D = DA((e = e + k | 0) ^ D, (o = e >>> 0 < k >>> 0 ? o + 1 | 0 : o) ^ R, 32), G = o, J = EA, EA = j, o = (k = h) + H | 0, H = s, s = o = (j = D + _ | 0) >>> 0 < D >>> 0 ? o + 1 | 0 : o, EA = DA(j ^ EA, H ^ o, 40), o = (_ = h) + nA | 0, o = ((nA = J + EA | 0) >>> 0 < EA >>> 0 ? o + 1 | 0 : o) + G | 0, G = nA, e = D ^ (nA = e + nA | 0), D = o = G >>> 0 > nA >>> 0 ? o + 1 | 0 : o, o = DA(e, o ^ k, 48), L = e = h, k = o, H = X, G = BA, X = DA(b ^ v, O ^ AA, 1), M = o = h, o = o + MA | 0, o = Z + ((X = (J = X) + cA | 0) >>> 0 < cA >>> 0 ? o + 1 | 0 : o) | 0, cA = o = (X = d + X | 0) >>> 0 < d >>> 0 ? o + 1 | 0 : o, BA = DA(X ^ wA, o ^ F, 32), o = (d = h) + gA | 0, gA = I = BA + I | 0, wA = DA(I ^ J, (F = I >>> 0 < BA >>> 0 ? o + 1 | 0 : o) ^ M, 40), o = (o = G) + (G = h) | 0, o = cA + ((I = wA + H | 0) >>> 0 < wA >>> 0 ? o + 1 | 0 : o) | 0, cA = I = I + X | 0, MA = o = I >>> 0 < X >>> 0 ? o + 1 | 0 : o, X = o, o = S + GA | 0, o = ((J = QA) >>> 0 > (QA = z + QA | 0) >>> 0 ? o + 1 | 0 : o) + X | 0, GA = o = (X = I + QA | 0) >>> 0 < QA >>> 0 ? o + 1 | 0 : o, QA = DA(k ^ X, o ^ e, 32), o = (J = h) + _A | 0, e = I = QA + n | 0, I = DA(I ^ z, (H = S) ^ (S = I >>> 0 < QA >>> 0 ? o + 1 | 0 : o), 40), o = pA + (M = h) | 0, pA = I, o = GA + ((I = fA + I | 0) >>> 0 < fA >>> 0 ? o + 1 | 0 : o) | 0, o = (I = I + X | 0) >>> 0 < X >>> 0 ? o + 1 | 0 : o, GA = I, Y = (a[A + 8 | 0] | a[A + 9 | 0] << 8 | a[A + 10 | 0] << 16 | a[A + 11 | 0] << 24) ^ I, H = o, N = o ^ (a[A + 12 | 0] | a[A + 13 | 0] << 8 | a[A + 14 | 0] << 16 | a[A + 15 | 0] << 24), X = DA(BA ^ cA, d ^ MA, 48), o = (cA = h) + F | 0, F = I = X + gA | 0, MA = o = I >>> 0 < X >>> 0 ? o + 1 | 0 : o, BA = rA, o = s + L | 0, rA = o = (I = k + j | 0) >>> 0 < j >>> 0 ? o + 1 | 0 : o, EA = DA(I ^ EA, o ^ _, 1), o = (k = h) + yA | 0, o = ((BA = EA + BA | 0) >>> 0 < EA >>> 0 ? o + 1 | 0 : o) + c | 0, BA = o = (yA = BA + iA | 0) >>> 0 < BA >>> 0 ? o + 1 | 0 : o, gA = DA(yA ^ kA, o ^ FA, 32), o = (j = h) + MA | 0, iA = o = (fA = gA + F | 0) >>> 0 < gA >>> 0 ? o + 1 | 0 : o, kA = gA, gA = DA(EA ^ fA, o ^ k, 40), o = (c = h) + HA | 0, o = (gA >>> 0 > (EA = gA + tA | 0) >>> 0 ? o + 1 | 0 : o) + BA | 0, s = j, j = o = (yA = EA + yA | 0) >>> 0 < EA >>> 0 ? o + 1 | 0 : o, EA = DA(kA ^ (tA = yA), s ^ o, 48), o = (k = h) + iA | 0, o = (BA = EA + fA | 0) >>> 0 < EA >>> 0 ? o + 1 | 0 : o, fA = BA, BA ^= Y, E[A + 8 | 0] = BA, E[A + 9 | 0] = BA >>> 8, E[A + 10 | 0] = BA >>> 16, E[A + 11 | 0] = BA >>> 24, iA = o, o ^= N, E[A + 12 | 0] = o, E[A + 13 | 0] = o >>> 8, E[A + 14 | 0] = o >>> 16, E[A + 15 | 0] = o >>> 24, yA = I, BA = rA, I = X, X = DA(y ^ n, p ^ _A, 1), o = (HA = h) + B | 0, o = (X >>> 0 > (rA = X + g | 0) >>> 0 ? o + 1 | 0 : o) + V | 0, oA = o = (n = rA) >>> 0 > (rA = oA + rA | 0) >>> 0 ? o + 1 | 0 : o, I = DA(I ^ rA, o ^ cA, 32), o = (o = BA) + (BA = h) | 0, cA = o = (yA = I + yA | 0) >>> 0 < I >>> 0 ? o + 1 | 0 : o, kA = I, yA = DA(X ^ (V = yA), o ^ HA, 40), o = (y = h) + C | 0, o = oA + ((I = yA + sA | 0) >>> 0 < yA >>> 0 ? o + 1 | 0 : o) | 0, o = (I = I + rA | 0) >>> 0 < rA >>> 0 ? o + 1 | 0 : o, oA = I, I ^= kA, kA = o, rA = DA(I, o ^ BA, 48), o = (n = h) + cA | 0, V = I = rA + V | 0, cA = I >>> 0 < rA >>> 0 ? o + 1 | 0 : o, wA = I = DA(F ^ wA, G ^ MA, 1), HA = o = h, o = o + l | 0, o = D + ((I = I + aA | 0) >>> 0 < aA >>> 0 ? o + 1 | 0 : o) | 0, l = o = (X = I + nA | 0) >>> 0 < nA >>> 0 ? o + 1 | 0 : o, I = (BA = DA(t ^ X, o ^ w, 32)) + f | 0, o = (f = h) + r | 0, nA = I, I = (aA = DA(D = I ^ wA, (wA = I >>> 0 < BA >>> 0 ? o + 1 | 0 : o) ^ HA, 40)) + q | 0, o = (q = h) + eA | 0, o = l + (I >>> 0 < aA >>> 0 ? o + 1 | 0 : o) | 0, o = (l = I + X | 0) >>> 0 < X >>> 0 ? o + 1 | 0 : o, X = l ^ JA ^ V, E[0 | (I = A)] = X, E[I + 1 | 0] = X >>> 8, E[I + 2 | 0] = X >>> 16, E[I + 3 | 0] = X >>> 24, X = o ^ Q ^ cA, E[I + 4 | 0] = X, E[I + 5 | 0] = X >>> 8, E[I + 6 | 0] = X >>> 16, E[I + 7 | 0] = X >>> 24, X = (BA = DA(l ^ BA, o ^ f, 48)) + nA | 0, o = (nA = h) + wA | 0, o = (wA = X >>> 0 < BA >>> 0 ? o + 1 | 0 : o) ^ (a[I + 20 | 0] | a[I + 21 | 0] << 8 | a[I + 22 | 0] << 16 | a[I + 23 | 0] << 24) ^ kA, l = (a[I + 16 | 0] | a[I + 17 | 0] << 8 | a[I + 18 | 0] << 16 | a[I + 19 | 0] << 24) ^ oA ^ X, E[I + 16 | 0] = l, E[I + 17 | 0] = l >>> 8, E[I + 18 | 0] = l >>> 16, E[I + 19 | 0] = l >>> 24, E[I + 20 | 0] = o, E[I + 21 | 0] = o >>> 8, E[I + 22 | 0] = o >>> 16, E[I + 23 | 0] = o >>> 24, I = DA(QA ^ GA, H ^ J, 48), l = h, oA = a[A + 36 | 0] | a[A + 37 | 0] << 8 | a[A + 38 | 0] << 16 | a[A + 39 | 0] << 24, o = (a[A + 32 | 0] | a[A + 33 | 0] << 8 | a[A + 34 | 0] << 16 | a[A + 35 | 0] << 24) ^ DA(gA ^ fA, c ^ iA, 1) ^ I, E[A + 32 | 0] = o, E[A + 33 | 0] = o >>> 8, E[A + 34 | 0] = o >>> 16, E[A + 35 | 0] = o >>> 24, o = h ^ oA ^ l, E[A + 36 | 0] = o, E[A + 37 | 0] = o >>> 8, E[A + 38 | 0] = o >>> 16, E[A + 39 | 0] = o >>> 24, o = S + l | 0, o = (oA = I + e | 0) >>> 0 < I >>> 0 ? o + 1 | 0 : o, gA = (a[(I = A) + 28 | 0] | a[I + 29 | 0] << 8 | a[I + 30 | 0] << 16 | a[I + 31 | 0] << 24) ^ j ^ o, l = (a[I + 24 | 0] | a[I + 25 | 0] << 8 | a[I + 26 | 0] << 16 | a[I + 27 | 0] << 24) ^ tA ^ oA, E[I + 24 | 0] = l, E[I + 25 | 0] = l >>> 8, E[I + 26 | 0] = l >>> 16, E[I + 27 | 0] = l >>> 24, E[I + 28 | 0] = gA, E[I + 29 | 0] = gA >>> 8, E[I + 30 | 0] = gA >>> 16, E[I + 31 | 0] = gA >>> 24, gA = a[I + 44 | 0] | a[I + 45 | 0] << 8 | a[I + 46 | 0] << 16 | a[I + 47 | 0] << 24, I = rA ^ (a[I + 40 | 0] | a[I + 41 | 0] << 8 | a[I + 42 | 0] << 16 | a[I + 43 | 0] << 24) ^ DA(X ^ aA, q ^ wA, 1), E[A + 40 | 0] = I, E[A + 41 | 0] = I >>> 8, E[A + 42 | 0] = I >>> 16, E[A + 43 | 0] = I >>> 24, I = n ^ h ^ gA, E[A + 44 | 0] = I, E[A + 45 | 0] = I >>> 8, E[A + 46 | 0] = I >>> 16, E[A + 47 | 0] = I >>> 24, X = a[A + 60 | 0] | a[A + 61 | 0] << 8 | a[A + 62 | 0] << 16 | a[A + 63 | 0] << 24, I = BA ^ (a[A + 56 | 0] | a[A + 57 | 0] << 8 | a[A + 58 | 0] << 16 | a[A + 59 | 0] << 24) ^ DA(V ^ yA, y ^ cA, 1), E[A + 56 | 0] = I, E[A + 57 | 0] = I >>> 8, E[A + 58 | 0] = I >>> 16, E[A + 59 | 0] = I >>> 24, I = nA ^ h ^ X, E[A + 60 | 0] = I, E[A + 61 | 0] = I >>> 8, E[A + 62 | 0] = I >>> 16, E[A + 63 | 0] = I >>> 24, X = a[A + 52 | 0] | a[A + 53 | 0] << 8 | a[A + 54 | 0] << 16 | a[A + 55 | 0] << 24, I = EA ^ (a[A + 48 | 0] | a[A + 49 | 0] << 8 | a[A + 50 | 0] << 16 | a[A + 51 | 0] << 24) ^ DA(oA ^ pA, o ^ M, 1), E[A + 48 | 0] = I, E[A + 49 | 0] = I >>> 8, E[A + 50 | 0] = I >>> 16, E[A + 51 | 0] = I >>> 24, I = k ^ h ^ X, E[A + 52 | 0] = I, E[A + 53 | 0] = I >>> 8, E[A + 54 | 0] = I >>> 16, E[A + 55 | 0] = I >>> 24;
                                    }
                                    function s(A, I, g, C, B, Q, i) {
                                        var f, c, e, r, D, t, y, n, s, k, S, H, G, _, M, p, J, U, Y, d, K, b, P, v, L, x, m, l, z, q, X, j, T, O, V, Z, W, $, AA, IA, gA, CA, BA, QA, iA, EA, oA, fA, eA = 0, rA = 0, DA = 0, tA = 0, yA = 0, wA = 0, hA = 0, nA = 0, sA = 0, FA = 0, SA = 0, HA = 0, GA = 0, _A = 0, pA = 0, NA = 0, JA = 0, UA = 0, YA = 0, dA = 0, KA = 0, bA = 0, PA = 0, vA = 0, LA = 0, RA = 0, uA = 0, xA = 0, mA = 0, lA = 0, zA = 0, qA = 0, XA = 0, jA = 0, TA = 0, OA = 0, VA = 0, ZA = 0, WA = 0, $A = 0, AI = 0, II = 0, gI = 0, CI = 0, BI = 0, QI = 0;
                                        return w = e = w - 560 | 0, cA(DA = e + 352 | 0), i && R(DA, 35136, 34, 0), aA(e + 288 | 0, Q, 32, 0), R(tA = e + 352 | 0, e + 320 | 0, 32, 0), R(tA, g, C, B), N(tA, nA = e + 224 | 0), sA = a[(rA = Q) + 32 | 0] | a[rA + 33 | 0] << 8 | a[rA + 34 | 0] << 16 | a[rA + 35 | 0] << 24, SA = a[rA + 36 | 0] | a[rA + 37 | 0] << 8 | a[rA + 38 | 0] << 16 | a[rA + 39 | 0] << 24, yA = a[rA + 40 | 0] | a[rA + 41 | 0] << 8 | a[rA + 42 | 0] << 16 | a[rA + 43 | 0] << 24, eA = a[rA + 44 | 0] | a[rA + 45 | 0] << 8 | a[rA + 46 | 0] << 16 | a[rA + 47 | 0] << 24, DA = a[rA + 48 | 0] | a[rA + 49 | 0] << 8 | a[rA + 50 | 0] << 16 | a[rA + 51 | 0] << 24, Q = a[rA + 52 | 0] | a[rA + 53 | 0] << 8 | a[rA + 54 | 0] << 16 | a[rA + 55 | 0] << 24, wA = a[rA + 60 | 0] | a[rA + 61 | 0] << 8 | a[rA + 62 | 0] << 16 | a[rA + 63 | 0] << 24, rA = a[rA + 56 | 0] | a[rA + 57 | 0] << 8 | a[rA + 58 | 0] << 16 | a[rA + 59 | 0] << 24, E[A + 56 | 0] = rA, E[A + 57 | 0] = rA >>> 8, E[A + 58 | 0] = rA >>> 16, E[A + 59 | 0] = rA >>> 24, E[A + 60 | 0] = wA, E[A + 61 | 0] = wA >>> 8, E[A + 62 | 0] = wA >>> 16, E[A + 63 | 0] = wA >>> 24, E[A + 48 | 0] = DA, E[A + 49 | 0] = DA >>> 8, E[A + 50 | 0] = DA >>> 16, E[A + 51 | 0] = DA >>> 24, E[A + 52 | 0] = Q, E[A + 53 | 0] = Q >>> 8, E[A + 54 | 0] = Q >>> 16, E[A + 55 | 0] = Q >>> 24, E[A + 40 | 0] = yA, E[A + 41 | 0] = yA >>> 8, E[A + 42 | 0] = yA >>> 16, E[A + 43 | 0] = yA >>> 24, E[A + 44 | 0] = eA, E[A + 45 | 0] = eA >>> 8, E[A + 46 | 0] = eA >>> 16, E[A + 47 | 0] = eA >>> 24, E[0 | (Q = A + 32 | 0)] = sA, E[Q + 1 | 0] = sA >>> 8, E[Q + 2 | 0] = sA >>> 16, E[Q + 3 | 0] = sA >>> 24, E[Q + 4 | 0] = SA, E[Q + 5 | 0] = SA >>> 8, E[Q + 6 | 0] = SA >>> 16, E[Q + 7 | 0] = SA >>> 24, F(nA), u(e, nA), MA(A, e), cA(tA), i && R(tA, 35136, 34, 0), R(i = e + 352 | 0, A, 64, 0), R(i, g, C, B), N(i, hA = e + 160 | 0), F(hA), E[e + 288 | 0] = 248 & a[e + 288 | 0], E[e + 319 | 0] = 63 & a[e + 319 | 0] | 64, g = a[23 + (A = c = e + 288 | 0) | 0], yA = kA(r = a[A + 21 | 0] | a[A + 22 | 0] << 8 | g << 16 & 2031616, 0, D = (a[hA + 28 | 0] | a[hA + 29 | 0] << 8 | a[hA + 30 | 0] << 16 | a[hA + 31 | 0] << 24) >>> 7 | 0, 0), DA = h, g = (A = a[hA + 27 | 0]) >>> 24 | 0, B = A << 8 | (eA = a[hA + 23 | 0] | a[hA + 24 | 0] << 8 | a[hA + 25 | 0] << 16 | a[hA + 26 | 0] << 24) >>> 24, A = kA(t = 2097151 & ((3 & (SA = (A = (C = a[hA + 28 | 0]) >>> 16 | 0) | g)) << 30 | (g = (C <<= 16) | B) >>> 2), 0, y = (i = a[c + 23 | 0] | a[c + 24 | 0] << 8 | a[c + 25 | 0] << 16 | a[c + 26 | 0] << 24) >>> 5 & 2097151, 0), g = h + DA | 0, C = A >>> 0 > (B = A + yA | 0) >>> 0 ? g + 1 | 0 : g, A = kA(n = (g = a[hA + 23 | 0]) << 16 & 2031616 | a[hA + 21 | 0] | a[hA + 22 | 0] << 8, 0, s = (a[c + 28 | 0] | a[c + 29 | 0] << 8 | a[c + 30 | 0] << 16 | a[c + 31 | 0] << 24) >>> 7 | 0, 0), C = h + C | 0, DA = g = A + B | 0, B = A >>> 0 > g >>> 0 ? C + 1 | 0 : C, C = (A = a[c + 27 | 0]) >>> 24 | 0, i = A << 8 | i >>> 24, A = kA(k = 2097151 & ((3 & (C |= g = (A = a[c + 28 | 0]) >>> 16 | 0)) << 30 | (g = (A <<= 16) | i) >>> 2), 0, S = eA >>> 5 & 2097151, 0), g = h + B | 0, rA = C = A + DA | 0, B = A >>> 0 > C >>> 0 ? g + 1 | 0 : g, eA = kA(y, 0, S, 0), DA = h, g = (A = a[c + 19 | 0]) >>> 24 | 0, i = A << 8 | (JA = a[c + 15 | 0] | a[c + 16 | 0] << 8 | a[c + 17 | 0] << 16 | a[c + 18 | 0] << 24) >>> 24, C = g, g = kA(H = (7 & (C |= g = (A = a[c + 20 | 0]) >>> 16 | 0)) << 29 | (g = (A <<= 16) | i) >>> 3, SA = C >>> 3 | 0, D, 0), A = h + DA | 0, A = g >>> 0 > (C = g + eA | 0) >>> 0 ? A + 1 | 0 : A, i = (g = kA(r, 0, t, 0)) + C | 0, C = h + A | 0, g = g >>> 0 > (eA = i) >>> 0 ? C + 1 | 0 : C, C = (A = a[hA + 19 | 0]) >>> 24 | 0, DA = A << 8 | (NA = a[hA + 15 | 0] | a[hA + 16 | 0] << 8 | a[hA + 17 | 0] << 16 | a[hA + 18 | 0] << 24) >>> 24, A = kA(G = (7 & (yA = (A = (i = a[hA + 20 | 0]) >>> 16 | 0) | C)) << 29 | (C = (i <<= 16) | DA) >>> 3, _ = yA >>> 3 | 0, s, 0), g = h + g | 0, g = A >>> 0 > (C = A + eA | 0) >>> 0 ? g + 1 | 0 : g, A = kA(n, 0, k, 0), g = h + g | 0, sA = g = A >>> 0 > (nA = A + C | 0) >>> 0 ? g + 1 | 0 : g, HA = A = g - ((nA >>> 0 < 4293918720) - 1 | 0) | 0, C = (g = A >>> 21 | 0) + B | 0, eA = C = (A = (2097151 & A) << 11 | (yA = nA - -1048576 | 0) >>> 21) >>> 0 > (rA = A + rA | 0) >>> 0 ? C + 1 | 0 : C, _A = A = C - ((rA >>> 0 < 4293918720) - 1 | 0) | 0, wA = (2097151 & A) << 11 | (DA = rA - -1048576 | 0) >>> 21, i = A >>> 21 | 0, A = kA(s, 0, S, 0), g = h, C = A, A = kA(D, 0, y, 0), g = h + g | 0, g = A >>> 0 > (C = C + A | 0) >>> 0 ? g + 1 | 0 : g, GA = (A = C) + (C = kA(t, 0, k, 0)) | 0, A = h + g | 0, A = C >>> 0 > GA >>> 0 ? A + 1 | 0 : A, tA = GA - (g = -2097152 & (C = GA - -1048576 | 0)) | 0, g = (A - ((131071 & (B = A - ((GA >>> 0 < 4293918720) - 1 | 0) | 0)) + (g >>> 0 > GA >>> 0) | 0) | 0) + i | 0, z = g = (A = tA + wA | 0) >>> 0 < tA >>> 0 ? g + 1 | 0 : g, q = A, tA = kA(A, g, 470296, 0), wA = h, g = kA(D, 0, k, 0), A = h, i = g, g = kA(t, 0, s, 0), A = h + A | 0, g = g >>> 0 > (i = i + g | 0) >>> 0 ? A + 1 | 0 : A, A = B >>> 21 | 0, B = (2097151 & B) << 11 | C >>> 21, C = A + g | 0, bA = B = (C = B >>> 0 > (i = B + i | 0) >>> 0 ? C + 1 | 0 : C) - ((i >>> 0 < 4293918720) - 1 | 0) | 0, A = i - (g = -2097152 & (KA = i - -1048576 | 0)) | 0, X = i = C - ((131071 & B) + (g >>> 0 > i >>> 0) | 0) | 0, j = g = rA - (C = -2097152 & DA) | 0, T = B = eA - ((C >>> 0 > rA >>> 0) + _A | 0) | 0, O = A, C = kA(A, i, 666643, 0), A = h + wA | 0, A = C >>> 0 > (i = C + tA | 0) >>> 0 ? A + 1 | 0 : A, C = kA(g, B, 654183, 0), g = h + A | 0, FA = B = C + i | 0, DA = C >>> 0 > B >>> 0 ? g + 1 | 0 : g, GA = nA - (A = -2097152 & yA) | 0, HA = sA - ((A >>> 0 > nA >>> 0) + HA | 0) | 0, g = kA(t, 0, H, SA), C = h, B = (A = g) + (g = kA(M = JA >>> 6 & 2097151, 0, D, 0)) | 0, A = h + C | 0, A = g >>> 0 > B >>> 0 ? A + 1 | 0 : A, g = kA(y, 0, n, 0), C = h + A | 0, C = g >>> 0 > (B = g + B | 0) >>> 0 ? C + 1 | 0 : C, A = kA(r, 0, S, 0), g = h + C | 0, g = A >>> 0 > (B = A + B | 0) >>> 0 ? g + 1 | 0 : g, C = kA(s, 0, p = NA >>> 6 & 2097151, 0), A = h + g | 0, A = C >>> 0 > (B = C + B | 0) >>> 0 ? A + 1 | 0 : A, C = kA(k, 0, G, _), g = h + A | 0, nA = B = C + B | 0, i = C >>> 0 > B >>> 0 ? g + 1 | 0 : g, g = (A = a[c + 14 | 0]) >>> 24 | 0, B = A << 8 | (sA = a[c + 10 | 0] | a[c + 11 | 0] << 8 | a[c + 12 | 0] << 16 | a[c + 13 | 0] << 24) >>> 24, g = kA(J = 2097151 & ((1 & (g |= A = (C = a[c + 15 | 0]) >>> 16 | 0)) << 31 | (A = (C <<= 16) | B) >>> 1), 0, D, 0), A = h, C = g, g = kA(t, 0, M, 0), A = h + A | 0, A = g >>> 0 > (C = C + g | 0) >>> 0 ? A + 1 | 0 : A, B = (g = kA(S, 0, H, SA)) + C | 0, C = h + A | 0, C = g >>> 0 > B >>> 0 ? C + 1 | 0 : C, A = kA(y, 0, G, _), g = h + C | 0, g = A >>> 0 > (B = A + B | 0) >>> 0 ? g + 1 | 0 : g, A = kA(r, 0, n, 0), g = h + g | 0, yA = C = A + B | 0, B = A >>> 0 > C >>> 0 ? g + 1 | 0 : g, g = (A = a[hA + 14 | 0]) >>> 24 | 0, eA = A << 8 | (rA = a[hA + 10 | 0] | a[hA + 11 | 0] << 8 | a[hA + 12 | 0] << 16 | a[hA + 13 | 0] << 24) >>> 24, C = g, g = (A = a[hA + 15 | 0]) >>> 16 | 0, g = kA(U = 2097151 & ((1 & (g |= C)) << 31 | (A = A << 16 | eA) >>> 1), 0, s, 0), A = h + B | 0, A = g >>> 0 > (C = g + yA | 0) >>> 0 ? A + 1 | 0 : A, g = kA(k, 0, p, 0), A = h + A | 0, eA = A = g >>> 0 > (yA = g + C | 0) >>> 0 ? A + 1 | 0 : A, PA = g = A - ((yA >>> 0 < 4293918720) - 1 | 0) | 0, C = (A = g >>> 21 | 0) + i | 0, wA = C = (g = (2097151 & g) << 11 | (tA = yA - -1048576 | 0) >>> 21) >>> 0 > (_A = g + nA | 0) >>> 0 ? C + 1 | 0 : C, YA = g = C - ((_A >>> 0 < 4293918720) - 1 | 0) | 0, A = (A = g >>> 21 | 0) + HA | 0, V = A = (g = (C = (2097151 & g) << 11 | (nA = _A - -1048576 | 0) >>> 21) + GA | 0) >>> 0 < C >>> 0 ? A + 1 | 0 : A, Z = g, A = kA(g, A, -997805, -1), g = h + DA | 0, FA = C = A + FA | 0, DA = A >>> 0 > C >>> 0 ? g + 1 | 0 : g, GA = (RA = a[23 + (f = e + 224 | 0) | 0] | a[f + 24 | 0] << 8 | a[f + 25 | 0] << 16 | a[f + 26 | 0] << 24) >>> 5 & 2097151, C = kA(Y = (A = a[c + 2 | 0]) << 16 & 2031616 | a[0 | c] | a[c + 1 | 0] << 8, 0, S, 0), g = h, B = (A = kA(n, 0, d = (i = a[c + 2 | 0] | a[c + 3 | 0] << 8 | a[c + 4 | 0] << 16 | a[c + 5 | 0] << 24) >>> 5 & 2097151, 0)) + C | 0, C = h + g | 0, C = A >>> 0 > B >>> 0 ? C + 1 | 0 : C, A = kA(K = (a[c + 7 | 0] | a[c + 8 | 0] << 8 | a[c + 9 | 0] << 16 | a[c + 10 | 0] << 24) >>> 7 & 2097151, 0, p, 0), g = h + C | 0, g = A >>> 0 > (B = A + B | 0) >>> 0 ? g + 1 | 0 : g, C = kA(U, 0, b = sA >>> 4 & 2097151, 0), A = h + g | 0, sA = B = C + B | 0, B = C >>> 0 > B >>> 0 ? A + 1 | 0 : A, i = (g = a[c + 6 | 0]) << 8 | i >>> 24, C = A = g >>> 24 | 0, g = (A = a[c + 7 | 0]) >>> 16 | 0, g = kA(P = 2097151 & ((3 & (g |= C)) << 30 | (A = A << 16 | i) >>> 2), 0, G, _), A = h + B | 0, A = g >>> 0 > (C = g + sA | 0) >>> 0 ? A + 1 | 0 : A, B = (g = kA(M, 0, v = (a[hA + 7 | 0] | a[hA + 8 | 0] << 8 | a[hA + 9 | 0] << 16 | a[hA + 10 | 0] << 24) >>> 7 & 2097151, 0)) + C | 0, C = h + A | 0, C = g >>> 0 > B >>> 0 ? C + 1 | 0 : C, g = kA(J, 0, dA = rA >>> 4 & 2097151, 0), A = h + C | 0, i = g >>> 0 > (B = g + B | 0) >>> 0 ? A + 1 | 0 : A, A = (g = a[hA + 6 | 0]) >>> 24 | 0, sA = g << 8 | (rA = a[hA + 2 | 0] | a[hA + 3 | 0] << 8 | a[hA + 4 | 0] << 16 | a[hA + 5 | 0] << 24) >>> 24, g = A, A = kA(H, SA, L = 2097151 & ((3 & (g |= C = (A = a[hA + 7 | 0]) >>> 16 | 0)) << 30 | (A = A << 16 | sA) >>> 2), 0), g = h + i | 0, g = A >>> 0 > (C = A + B | 0) >>> 0 ? g + 1 | 0 : g, B = C, C = kA(x = (A = a[hA + 2 | 0]) << 16 & 2031616 | a[0 | hA] | a[hA + 1 | 0] << 8, 0, y, 0), A = h + g | 0, A = C >>> 0 > (B = B + C | 0) >>> 0 ? A + 1 | 0 : A, g = kA(r, 0, m = rA >>> 5 & 2097151, 0), A = h + A | 0, A = g >>> 0 > (C = g + B | 0) >>> 0 ? A + 1 | 0 : A, g = C, sA = C = C + GA | 0, i = g = g >>> 0 > C >>> 0 ? A + 1 | 0 : A, B = a[f + 21 | 0] | a[f + 22 | 0] << 8, A = kA(n, 0, Y, 0), g = h, rA = (C = A) + (A = kA(G, _, d, 0)) | 0, C = h + g | 0, C = A >>> 0 > rA >>> 0 ? C + 1 | 0 : C, A = kA(U, 0, K, 0), g = h + C | 0, g = A >>> 0 > (rA = A + rA | 0) >>> 0 ? g + 1 | 0 : g, A = kA(b, 0, dA, 0), g = h + g | 0, g = A >>> 0 > (C = A + rA | 0) >>> 0 ? g + 1 | 0 : g, rA = (A = C) + (C = kA(p, 0, P, 0)) | 0, A = h + g | 0, A = C >>> 0 > rA >>> 0 ? A + 1 | 0 : A, g = kA(M, 0, L, 0), A = h + A | 0, A = g >>> 0 > (C = g + rA | 0) >>> 0 ? A + 1 | 0 : A, rA = (g = kA(J, 0, v, 0)) + C | 0, C = h + A | 0, C = g >>> 0 > rA >>> 0 ? C + 1 | 0 : C, A = kA(H, SA, m, 0), g = h + C | 0, g = A >>> 0 > (rA = A + rA | 0) >>> 0 ? g + 1 | 0 : g, A = kA(r, 0, x, 0), g = h + g | 0, A = A >>> 0 > (C = A + rA | 0) >>> 0 ? g + 1 | 0 : g, g = (g = C) >>> 0 > (C = C + B | 0) >>> 0 ? A + 1 | 0 : A, B = C, C = (A = a[f + 23 | 0]) << 16 & 2031616, A = g, C = A = C >>> 0 > (B = B + C | 0) >>> 0 ? A + 1 | 0 : A, hA = A = A - ((B >>> 0 < 4293918720) - 1 | 0) | 0, g = (g = A >>> 21 | 0) + i | 0, A = (g = (i = sA = (A = (2097151 & A) << 11 | (rA = B - -1048576 | 0) >>> 21) + sA | 0) >>> 0 < A >>> 0 ? g + 1 | 0 : g) + DA | 0, A = (DA = i + FA | 0) >>> 0 < i >>> 0 ? A + 1 | 0 : A, JA = i - -1048576 | 0, pA = i = g - ((i >>> 0 < 4293918720) - 1 | 0) | 0, UA = DA - (g = -2097152 & JA) | 0, vA = A - ((g >>> 0 > DA >>> 0) + i | 0) | 0, sA = B, DA = C, A = kA(j, T, 470296, 0), g = h, C = A, A = kA(q, z, 666643, 0), g = h + g | 0, g = A >>> 0 > (C = C + A | 0) >>> 0 ? g + 1 | 0 : g, B = (A = C) + (C = kA(Z, V, 654183, 0)) | 0, A = h + g | 0, NA = B, i = C >>> 0 > B >>> 0 ? A + 1 | 0 : A, g = kA(G, _, Y, 0), A = h, C = g, g = kA(p, 0, d, 0), A = h + A | 0, A = g >>> 0 > (C = C + g | 0) >>> 0 ? A + 1 | 0 : A, B = (g = C) + (C = kA(K, 0, dA, 0)) | 0, g = h + A | 0, g = C >>> 0 > B >>> 0 ? g + 1 | 0 : g, A = kA(b, 0, v, 0), C = h + g | 0, C = A >>> 0 > (B = A + B | 0) >>> 0 ? C + 1 | 0 : C, A = kA(U, 0, P, 0), g = h + C | 0, g = A >>> 0 > (B = A + B | 0) >>> 0 ? g + 1 | 0 : g, C = kA(M, 0, m, 0), A = h + g | 0, A = C >>> 0 > (B = C + B | 0) >>> 0 ? A + 1 | 0 : A, g = kA(J, 0, L, 0), A = h + A | 0, A = g >>> 0 > (C = g + B | 0) >>> 0 ? A + 1 | 0 : A, B = (g = C) + (C = kA(H, SA, x, 0)) | 0, g = h + A | 0, GA = B, C = C >>> 0 > B >>> 0 ? g + 1 | 0 : g, g = (A = a[f + 19 | 0]) >>> 24 | 0, HA = A << 8 | (FA = a[f + 15 | 0] | a[f + 16 | 0] << 8 | a[f + 17 | 0] << 16 | a[f + 18 | 0] << 24) >>> 24, C = ((LA = (A = (B = a[f + 20 | 0]) >>> 16 | 0) | g) >>> 3 | 0) + C | 0, GA = B = (g = (7 & LA) << 29 | (g = (B <<= 16) | HA) >>> 3) + GA | 0, B = g >>> 0 > B >>> 0 ? C + 1 | 0 : C, HA = FA >>> 6 & 2097151, A = kA(p, 0, Y, 0), g = h, C = A, A = kA(U, 0, d, 0), g = h + g | 0, g = A >>> 0 > (C = C + A | 0) >>> 0 ? g + 1 | 0 : g, FA = (A = C) + (C = kA(K, 0, v, 0)) | 0, A = h + g | 0, A = C >>> 0 > FA >>> 0 ? A + 1 | 0 : A, C = kA(b, 0, L, 0), g = h + A | 0, g = C >>> 0 > (FA = C + FA | 0) >>> 0 ? g + 1 | 0 : g, C = kA(P, 0, dA, 0), A = h + g | 0, A = C >>> 0 > (FA = C + FA | 0) >>> 0 ? A + 1 | 0 : A, g = kA(M, 0, x, 0), C = h + A | 0, C = g >>> 0 > (FA = g + FA | 0) >>> 0 ? C + 1 | 0 : C, A = kA(J, 0, m, 0), g = h + C | 0, A = A >>> 0 > (FA = A + FA | 0) >>> 0 ? g + 1 | 0 : g, TA = A = (xA = FA + HA | 0) >>> 0 < FA >>> 0 ? A + 1 | 0 : A, II = A = A - ((xA >>> 0 < 4293918720) - 1 | 0) | 0, C = (2097151 & A) << 11 | (XA = xA - -1048576 | 0) >>> 21, A = (A >>> 21 | 0) + B | 0, VA = A = C >>> 0 > (OA = C + GA | 0) >>> 0 ? A + 1 | 0 : A, gI = A = A - ((OA >>> 0 < 4293918720) - 1 | 0) | 0, C = (2097151 & A) << 11 | (lA = OA - -1048576 | 0) >>> 21, A = (A >>> 21 | 0) + i | 0, g = (C >>> 0 > (B = C + NA | 0) >>> 0 ? A + 1 | 0 : A) + DA | 0, DA = (C = B + sA | 0) - (A = -2097152 & rA) | 0, hA = A = (g = C >>> 0 < B >>> 0 ? g + 1 | 0 : g) - ((A >>> 0 > C >>> 0) + hA | 0) | 0, CI = A = A - ((DA >>> 0 < 4293918720) - 1 | 0) | 0, C = (2097151 & A) << 11 | (zA = DA - -1048576 | 0) >>> 21, A = (A >> 21) + vA | 0, B = A = C >>> 0 > (i = C + UA | 0) >>> 0 ? A + 1 | 0 : A, AI = A = A - ((i >>> 0 < 4293918720) - 1 | 0) | 0, qA = (2097151 & A) << 11 | (NA = i - -1048576 | 0) >>> 21, sA = A >> 21, LA = _A - (A = -2097152 & nA) | 0, YA = wA - ((A >>> 0 > _A >>> 0) + YA | 0) | 0, A = kA(D, 0, s, 0), jA = g = h, UA = A, FA = A - -1048576 | 0, mA = g = g - ((A >>> 0 < 4293918720) - 1 | 0) | 0, W = A = g >>> 21 | 0, A = kA(l = (2097151 & g) << 11 | FA >>> 21, A, -683901, -1), g = h + eA | 0, g = A >>> 0 > (C = A + yA | 0) >>> 0 ? g + 1 | 0 : g, nA = C - (A = -2097152 & tA) | 0, rA = g - ((A >>> 0 > C >>> 0) + PA | 0) | 0, g = kA(S, 0, M, 0), A = h, C = g, g = kA(D, 0, b, 0), A = h + A | 0, A = g >>> 0 > (C = C + g | 0) >>> 0 ? A + 1 | 0 : A, g = kA(t, 0, J, 0), A = h + A | 0, A = g >>> 0 > (C = g + C | 0) >>> 0 ? A + 1 | 0 : A, eA = (g = C) + (C = kA(n, 0, H, SA)) | 0, g = h + A | 0, g = C >>> 0 > eA >>> 0 ? g + 1 | 0 : g, A = kA(y, 0, p, 0), C = h + g | 0, C = A >>> 0 > (eA = A + eA | 0) >>> 0 ? C + 1 | 0 : C, A = kA(r, 0, G, _), g = h + C | 0, g = A >>> 0 > (eA = A + eA | 0) >>> 0 ? g + 1 | 0 : g, C = kA(s, 0, dA, 0), A = h + g | 0, A = C >>> 0 > (eA = C + eA | 0) >>> 0 ? A + 1 | 0 : A, g = kA(k, 0, U, 0), A = h + A | 0, yA = C = g + eA | 0, eA = g >>> 0 > C >>> 0 ? A + 1 | 0 : A, A = kA(t, 0, b, 0), g = h, C = A, A = kA(D, 0, K, 0), g = h + g | 0, g = A >>> 0 > (C = C + A | 0) >>> 0 ? g + 1 | 0 : g, wA = (A = kA(n, 0, M, 0)) + C | 0, C = h + g | 0, C = A >>> 0 > wA >>> 0 ? C + 1 | 0 : C, A = kA(S, 0, J, 0), g = h + C | 0, g = A >>> 0 > (wA = A + wA | 0) >>> 0 ? g + 1 | 0 : g, C = kA(H, SA, G, _), A = h + g | 0, A = C >>> 0 > (wA = C + wA | 0) >>> 0 ? A + 1 | 0 : A, g = kA(y, 0, U, 0), A = h + A | 0, A = g >>> 0 > (C = g + wA | 0) >>> 0 ? A + 1 | 0 : A, wA = (g = C) + (C = kA(r, 0, p, 0)) | 0, g = h + A | 0, g = C >>> 0 > wA >>> 0 ? g + 1 | 0 : g, A = kA(s, 0, v, 0), C = h + g | 0, C = A >>> 0 > (wA = A + wA | 0) >>> 0 ? C + 1 | 0 : C, A = kA(k, 0, dA, 0), g = h + C | 0, HA = g = A >>> 0 > (GA = A + wA | 0) >>> 0 ? g + 1 | 0 : g, WA = A = g - ((GA >>> 0 < 4293918720) - 1 | 0) | 0, g = (2097151 & A) << 11 | (_A = GA - -1048576 | 0) >>> 21, A = (A >>> 21 | 0) + eA | 0, tA = A = g >>> 0 > (PA = g + yA | 0) >>> 0 ? A + 1 | 0 : A, uA = A = A - ((PA >>> 0 < 4293918720) - 1 | 0) | 0, g = (C = A >>> 21 | 0) + rA | 0, nA = g = (A = (2097151 & A) << 11 | (wA = PA - -1048576 | 0) >>> 21) >>> 0 > (vA = A + nA | 0) >>> 0 ? g + 1 | 0 : g, ZA = A = g - ((vA >>> 0 < 4293918720) - 1 | 0) | 0, eA = (2097151 & A) << 11 | (rA = vA - -1048576 | 0) >>> 21, A = (A >> 21) + YA | 0, $ = A = (g = eA + LA | 0) >>> 0 < eA >>> 0 ? A + 1 | 0 : A, AA = g, A = kA(g, A, -683901, -1), g = h + sA | 0, qA = C = A + qA | 0, sA = A >>> 0 > C >>> 0 ? g + 1 | 0 : g, A = kA(t, 0, Y, 0), g = h, C = A, A = kA(S, 0, d, 0), g = h + g | 0, g = A >>> 0 > (C = C + A | 0) >>> 0 ? g + 1 | 0 : g, eA = (A = C) + (C = kA(G, _, K, 0)) | 0, A = h + g | 0, A = C >>> 0 > eA >>> 0 ? A + 1 | 0 : A, g = kA(p, 0, b, 0), C = h + A | 0, C = g >>> 0 > (eA = g + eA | 0) >>> 0 ? C + 1 | 0 : C, g = kA(n, 0, P, 0), A = h + C | 0, A = g >>> 0 > (eA = g + eA | 0) >>> 0 ? A + 1 | 0 : A, C = kA(M, 0, dA, 0), g = h + A | 0, g = C >>> 0 > (eA = C + eA | 0) >>> 0 ? g + 1 | 0 : g, A = kA(J, 0, U, 0), g = h + g | 0, g = A >>> 0 > (C = A + eA | 0) >>> 0 ? g + 1 | 0 : g, eA = (A = C) + (C = kA(H, SA, v, 0)) | 0, A = h + g | 0, A = C >>> 0 > eA >>> 0 ? A + 1 | 0 : A, g = kA(y, 0, m, 0), C = h + A | 0, C = g >>> 0 > (eA = g + eA | 0) >>> 0 ? C + 1 | 0 : C, g = kA(r, 0, L, 0), A = h + C | 0, A = g >>> 0 > (eA = g + eA | 0) >>> 0 ? A + 1 | 0 : A, C = kA(k, 0, x, 0), g = h + A | 0, YA = eA = C + eA | 0, C = C >>> 0 > eA >>> 0 ? g + 1 | 0 : g, g = (A = a[f + 27 | 0]) >>> 24 | 0, yA = A << 8 | RA >>> 24, eA = 2097151 & ((3 & (g |= A = (eA = a[f + 28 | 0]) >>> 16 | 0)) << 30 | (A = (eA <<= 16) | yA) >>> 2), g = C, yA = A = eA + YA | 0, eA = A >>> 0 < eA >>> 0 ? g + 1 | 0 : g, LA = kA(O, X, 470296, 0), YA = h, A = (C = (2097151 & bA) << 11 | KA >>> 21) + (UA - (g = -2097152 & FA) | 0) | 0, g = jA - ((524287 & mA) + (g >>> 0 > UA >>> 0) | 0) + (bA >>> 21) | 0, IA = g = A >>> 0 < C >>> 0 ? g + 1 | 0 : g, gA = A, g = kA(A, g, 666643, 0), A = h + YA | 0, A = g >>> 0 > (C = g + LA | 0) >>> 0 ? A + 1 | 0 : A, FA = (g = kA(q, z, 654183, 0)) + C | 0, C = h + A | 0, C = g >>> 0 > FA >>> 0 ? C + 1 | 0 : C, g = kA(j, T, -997805, -1), A = h + C | 0, A = g >>> 0 > (FA = g + FA | 0) >>> 0 ? A + 1 | 0 : A, C = kA(Z, V, 136657, 0), g = h + A | 0, JA = (A = (2097151 & pA) << 11 | JA >>> 21) + (FA = C + FA | 0) | 0, g = (pA >>> 21 | 0) + (C >>> 0 > FA >>> 0 ? g + 1 | 0 : g) | 0, mA = FA = eA - ((yA >>> 0 < 4293918720) - 1 | 0) | 0, A = (A >>> 0 > JA >>> 0 ? g + 1 | 0 : g) + eA | 0, g = (eA = yA + JA | 0) - (C = -2097152 & (jA = yA - -1048576 | 0)) | 0, C = (A = (A = eA >>> 0 < JA >>> 0 ? A + 1 | 0 : A) - ((C >>> 0 > eA >>> 0) + FA | 0) | 0) + sA | 0, LA = eA = A - ((g >>> 0 < 4293918720) - 1 | 0) | 0, UA = (C = (yA = g + qA | 0) >>> 0 < g >>> 0 ? C + 1 | 0 : C) - (((g = -2097152 & (YA = g - -1048576 | 0)) >>> 0 > yA >>> 0) + eA | 0) | 0, RA = A = yA - g | 0, eA = i, i = B, $A = vA - (A = -2097152 & rA) | 0, FA = nA - ((A >>> 0 > vA >>> 0) + ZA | 0) | 0, A = kA(gA, IA, -683901, -1), g = h, B = (C = A) + (A = kA(l, W, 136657, 0)) | 0, C = h + g | 0, g = tA + (A >>> 0 > B >>> 0 ? C + 1 | 0 : C) | 0, wA = (C = B + PA | 0) - (A = -2097152 & wA) | 0, nA = (g = C >>> 0 < PA >>> 0 ? g + 1 | 0 : g) - ((A >>> 0 > C >>> 0) + uA | 0) | 0, g = kA(l, W, -997805, -1), A = h + HA | 0, A = g >>> 0 > (C = g + GA | 0) >>> 0 ? A + 1 | 0 : A, B = (g = kA(gA, IA, 136657, 0)) + C | 0, C = h + A | 0, C = g >>> 0 > B >>> 0 ? C + 1 | 0 : C, A = kA(O, X, -683901, -1), g = h + C | 0, g = A >>> 0 > (B = A + B | 0) >>> 0 ? g + 1 | 0 : g, rA = B - (A = -2097152 & _A) | 0, sA = g - ((A >>> 0 > B >>> 0) + WA | 0) | 0, g = kA(S, 0, b, 0), A = h, C = g, g = kA(t, 0, K, 0), A = h + A | 0, A = g >>> 0 > (C = C + g | 0) >>> 0 ? A + 1 | 0 : A, B = (g = kA(D, 0, P, 0)) + C | 0, C = h + A | 0, C = g >>> 0 > B >>> 0 ? C + 1 | 0 : C, A = kA(G, _, M, 0), g = h + C | 0, g = A >>> 0 > (B = A + B | 0) >>> 0 ? g + 1 | 0 : g, C = kA(n, 0, J, 0), A = h + g | 0, A = C >>> 0 > (B = C + B | 0) >>> 0 ? A + 1 | 0 : A, C = kA(H, SA, p, 0), g = h + A | 0, g = C >>> 0 > (B = C + B | 0) >>> 0 ? g + 1 | 0 : g, C = kA(y, 0, dA, 0), A = h + g | 0, A = C >>> 0 > (B = C + B | 0) >>> 0 ? A + 1 | 0 : A, g = kA(r, 0, U, 0), C = h + A | 0, C = g >>> 0 > (B = g + B | 0) >>> 0 ? C + 1 | 0 : C, A = kA(s, 0, L, 0), g = h + C | 0, g = A >>> 0 > (B = A + B | 0) >>> 0 ? g + 1 | 0 : g, C = kA(k, 0, v, 0), A = h + g | 0, yA = B = C + B | 0, B = C >>> 0 > B >>> 0 ? A + 1 | 0 : A, A = kA(S, 0, K, 0), g = h, C = A, A = kA(D, 0, d, 0), g = h + g | 0, g = A >>> 0 > (C = C + A | 0) >>> 0 ? g + 1 | 0 : g, tA = (A = C) + (C = kA(n, 0, b, 0)) | 0, A = h + g | 0, A = C >>> 0 > tA >>> 0 ? A + 1 | 0 : A, g = kA(t, 0, P, 0), C = h + A | 0, C = g >>> 0 > (tA = g + tA | 0) >>> 0 ? C + 1 | 0 : C, A = kA(M, 0, p, 0), g = h + C | 0, g = A >>> 0 > (tA = A + tA | 0) >>> 0 ? g + 1 | 0 : g, C = kA(G, _, J, 0), A = h + g | 0, A = C >>> 0 > (tA = C + tA | 0) >>> 0 ? A + 1 | 0 : A, C = kA(H, SA, U, 0), g = h + A | 0, g = C >>> 0 > (tA = C + tA | 0) >>> 0 ? g + 1 | 0 : g, C = kA(y, 0, v, 0), A = h + g | 0, A = C >>> 0 > (tA = C + tA | 0) >>> 0 ? A + 1 | 0 : A, g = kA(r, 0, dA, 0), C = h + A | 0, C = g >>> 0 > (tA = g + tA | 0) >>> 0 ? C + 1 | 0 : C, tA = (A = kA(s, 0, m, 0)) + tA | 0, g = h + C | 0, C = kA(k, 0, L, 0), A = h + (A >>> 0 > tA >>> 0 ? g + 1 | 0 : g) | 0, vA = A = C >>> 0 > (ZA = C + tA | 0) >>> 0 ? A + 1 | 0 : A, BA = A = A - ((ZA >>> 0 < 4293918720) - 1 | 0) | 0, C = (2097151 & A) << 11 | (bA = ZA - -1048576 | 0) >>> 21, A = (A >>> 21 | 0) + B | 0, KA = A = C >>> 0 > (qA = C + yA | 0) >>> 0 ? A + 1 | 0 : A, QA = A = A - ((qA >>> 0 < 4293918720) - 1 | 0) | 0, C = (2097151 & A) << 11 | (pA = qA - -1048576 | 0) >>> 21, A = (A >>> 21 | 0) + sA | 0, JA = A = C >>> 0 > (PA = C + rA | 0) >>> 0 ? A + 1 | 0 : A, iA = A = A - ((PA >>> 0 < 4293918720) - 1 | 0) | 0, C = (2097151 & A) << 11 | (HA = PA - -1048576 | 0) >>> 21, A = (A >> 21) + nA | 0, B = A = C >>> 0 > (rA = C + wA | 0) >>> 0 ? A + 1 | 0 : A, nA = A = A - ((rA >>> 0 < 4293918720) - 1 | 0) | 0, sA = (2097151 & A) << 11 | (C = rA - -1048576 | 0) >>> 21, A = (A >> 21) + FA | 0, WA = A = (yA = sA + $A | 0) >>> 0 < sA >>> 0 ? A + 1 | 0 : A, uA = yA, A = kA(yA, A, -683901, -1), g = h, yA = A, A = kA(AA, $, 136657, 0), g = h + g | 0, A = (A >>> 0 > (yA = yA + A | 0) >>> 0 ? g + 1 | 0 : g) + i | 0, BI = (i = eA + yA | 0) - (g = -2097152 & NA) | 0, QI = (A = i >>> 0 < yA >>> 0 ? A + 1 | 0 : A) - ((g >>> 0 > i >>> 0) + AI | 0) | 0, sA = DA, yA = hA, DA = kA(uA, WA, 136657, 0), i = h, $A = A = rA - (g = -2097152 & C) | 0, CA = B = B - ((g >>> 0 > rA >>> 0) + nA | 0) | 0, C = kA(AA, $, -997805, -1), g = h + i | 0, g = C >>> 0 > (DA = C + DA | 0) >>> 0 ? g + 1 | 0 : g, C = kA(A, B, -683901, -1), A = h + g | 0, AI = B = C + DA | 0, eA = C >>> 0 > B >>> 0 ? A + 1 | 0 : A, A = kA(Z, V, 470296, 0), g = h, B = (C = A) + (A = kA(j, T, 666643, 0)) | 0, C = h + g | 0, g = VA + (A >>> 0 > B >>> 0 ? C + 1 | 0 : C) | 0, FA = A = B + OA | 0, i = g = A >>> 0 < OA >>> 0 ? g + 1 | 0 : g, g = kA(Z, V, 666643, 0), A = h + TA | 0, A = g >>> 0 > (C = g + xA | 0) >>> 0 ? A + 1 | 0 : A, wA = C - (g = -2097152 & XA) | 0, GA = A - ((g >>> 0 > C >>> 0) + II | 0) | 0, g = kA(U, 0, Y, 0), A = h, C = g, g = kA(d, 0, dA, 0), A = h + A | 0, A = g >>> 0 > (C = C + g | 0) >>> 0 ? A + 1 | 0 : A, B = (g = C) + (C = kA(K, 0, L, 0)) | 0, g = h + A | 0, g = C >>> 0 > B >>> 0 ? g + 1 | 0 : g, C = kA(b, 0, m, 0), A = h + g | 0, A = C >>> 0 > (B = C + B | 0) >>> 0 ? A + 1 | 0 : A, g = kA(P, 0, v, 0), C = h + A | 0, C = g >>> 0 > (B = g + B | 0) >>> 0 ? C + 1 | 0 : C, A = kA(J, 0, x, 0), g = h + C | 0, rA = B = A + B | 0, B = A >>> 0 > B >>> 0 ? g + 1 | 0 : g, g = (A = a[f + 14 | 0]) >>> 24 | 0, DA = A << 8 | (nA = a[f + 10 | 0] | a[f + 11 | 0] << 8 | a[f + 12 | 0] << 16 | a[f + 13 | 0] << 24) >>> 24, g = 2097151 & ((1 & (g |= C = (A = a[f + 15 | 0]) >>> 16 | 0)) << 31 | (A = DA | A << 16) >>> 1), A = B, rA = C = g + rA | 0, B = g >>> 0 > C >>> 0 ? A + 1 | 0 : A, DA = nA >>> 4 & 2097151, A = kA(Y, 0, dA, 0), g = h, C = A, A = kA(d, 0, v, 0), g = h + g | 0, g = A >>> 0 > (C = C + A | 0) >>> 0 ? g + 1 | 0 : g, A = kA(K, 0, m, 0), g = h + g | 0, g = A >>> 0 > (C = A + C | 0) >>> 0 ? g + 1 | 0 : g, nA = (A = C) + (C = kA(b, 0, x, 0)) | 0, A = h + g | 0, A = C >>> 0 > nA >>> 0 ? A + 1 | 0 : A, g = kA(P, 0, L, 0), C = h + A | 0, A = g >>> 0 > (nA = g + nA | 0) >>> 0 ? C + 1 | 0 : C, hA = A = (XA = DA + nA | 0) >>> 0 < nA >>> 0 ? A + 1 | 0 : A, EA = A = A - ((XA >>> 0 < 4293918720) - 1 | 0) | 0, g = (C = A >>> 21 | 0) + B | 0, _A = g = (A = (2097151 & A) << 11 | (NA = XA - -1048576 | 0) >>> 21) >>> 0 > (VA = A + rA | 0) >>> 0 ? g + 1 | 0 : g, oA = A = g - ((VA >>> 0 < 4293918720) - 1 | 0) | 0, g = (2097151 & A) << 11 | (tA = VA - -1048576 | 0) >>> 21, A = (A >>> 21 | 0) + GA | 0, nA = A = g >>> 0 > (wA = g + wA | 0) >>> 0 ? A + 1 | 0 : A, fA = A = A - ((wA >>> 0 < 4293918720) - 1 | 0) | 0, g = (C = A >> 21) + i | 0, II = g = (g = (A = (2097151 & A) << 11 | (rA = wA - -1048576 | 0) >>> 21) >>> 0 > (B = A + FA | 0) >>> 0 ? g + 1 | 0 : g) - (((C = -2097152 & lA) >>> 0 > B >>> 0) + gI | 0) | 0, lA = A = B - C | 0, DA = A - -1048576 | 0, gI = A = g - ((A >>> 0 < 4293918720) - 1 | 0) | 0, C = (g = A >> 21) + eA | 0, g = ((A = (2097151 & A) << 11 | DA >>> 21) >>> 0 > (B = A + AI | 0) >>> 0 ? C + 1 | 0 : C) + yA | 0, xA = g = (g = (A = B) >>> 0 > (B = B + sA | 0) >>> 0 ? g + 1 | 0 : g) - (((C = -2097152 & zA) >>> 0 > B >>> 0) + CI | 0) | 0, yA = A = B - C | 0, i = A - -1048576 | 0, TA = A = g - ((A >>> 0 < 4293918720) - 1 | 0) | 0, C = (g = A >> 21) + QI | 0, zA = A = (C = (A = (2097151 & A) << 11 | i >>> 21) >>> 0 > (eA = A + BI | 0) >>> 0 ? C + 1 | 0 : C) - ((eA >>> 0 < 4293918720) - 1 | 0) | 0, FA = RA - -1048576 | 0, GA = UA - ((RA >>> 0 < 4293918720) - 1 | 0) | 0, sA = (2097151 & A) << 11 | (B = eA - -1048576 | 0) >>> 21, A = (A >> 21) + UA | 0, CI = (RA = sA + RA | 0) - (g = -2097152 & FA) | 0, BI = (sA >>> 0 > RA >>> 0 ? A + 1 | 0 : A) - ((g >>> 0 > RA >>> 0) + GA | 0) | 0, QI = eA - (A = -2097152 & B) | 0, AI = C - ((A >>> 0 > eA >>> 0) + zA | 0) | 0, OA = yA - (A = -2097152 & i) | 0, RA = xA - ((A >>> 0 > yA >>> 0) + TA | 0) | 0, A = kA(uA, WA, -997805, -1), g = h, C = A, A = kA(AA, $, 654183, 0), g = h + g | 0, g = A >>> 0 > (C = C + A | 0) >>> 0 ? g + 1 | 0 : g, B = (A = C) + (C = kA($A, CA, 136657, 0)) | 0, A = h + g | 0, g = II + (C >>> 0 > B >>> 0 ? A + 1 | 0 : A) | 0, xA = (C = B + lA | 0) - (A = -2097152 & DA) | 0, TA = (g = C >>> 0 < lA >>> 0 ? g + 1 | 0 : g) - ((A >>> 0 > C >>> 0) + gI | 0) | 0, lA = PA - (A = -2097152 & HA) | 0, UA = JA - ((A >>> 0 > PA >>> 0) + iA | 0) | 0, g = kA(gA, IA, -997805, -1), A = h, C = g, g = kA(l, W, 654183, 0), A = h + A | 0, A = g >>> 0 > (C = C + g | 0) >>> 0 ? A + 1 | 0 : A, B = (g = C) + (C = kA(O, X, 136657, 0)) | 0, g = h + A | 0, g = C >>> 0 > B >>> 0 ? g + 1 | 0 : g, A = kA(q, z, -683901, -1), C = h + g | 0, g = KA + (A >>> 0 > (B = A + B | 0) >>> 0 ? C + 1 | 0 : C) | 0, HA = (C = B + qA | 0) - (A = -2097152 & pA) | 0, JA = (g = C >>> 0 < qA >>> 0 ? g + 1 | 0 : g) - ((A >>> 0 > C >>> 0) + QA | 0) | 0, g = kA(gA, IA, 654183, 0), A = h, C = g, g = kA(l, W, 470296, 0), A = h + A | 0, A = g >>> 0 > (C = C + g | 0) >>> 0 ? A + 1 | 0 : A, B = (g = kA(O, X, -997805, -1)) + C | 0, C = h + A | 0, g = vA + (g >>> 0 > B >>> 0 ? C + 1 | 0 : C) | 0, g = (A = B + ZA | 0) >>> 0 < ZA >>> 0 ? g + 1 | 0 : g, C = A, A = kA(q, z, 136657, 0), g = h + g | 0, g = A >>> 0 > (C = C + A | 0) >>> 0 ? g + 1 | 0 : g, B = (A = C) + (C = kA(j, T, -683901, -1)) | 0, A = h + g | 0, DA = B - (g = -2097152 & bA) | 0, i = (C >>> 0 > B >>> 0 ? A + 1 | 0 : A) - ((g >>> 0 > B >>> 0) + BA | 0) | 0, B = (a[f + 28 | 0] | a[f + 29 | 0] << 8 | a[f + 30 | 0] << 16 | a[f + 31 | 0] << 24) >>> 7 | 0, A = kA(D, 0, Y, 0), g = h, eA = (C = A) + (A = kA(t, 0, d, 0)) | 0, C = h + g | 0, C = A >>> 0 > eA >>> 0 ? C + 1 | 0 : C, A = kA(n, 0, K, 0), g = h + C | 0, g = A >>> 0 > (eA = A + eA | 0) >>> 0 ? g + 1 | 0 : g, C = kA(G, _, b, 0), A = h + g | 0, A = C >>> 0 > (eA = C + eA | 0) >>> 0 ? A + 1 | 0 : A, C = kA(S, 0, P, 0), g = h + A | 0, g = C >>> 0 > (eA = C + eA | 0) >>> 0 ? g + 1 | 0 : g, C = kA(M, 0, U, 0), A = h + g | 0, A = C >>> 0 > (eA = C + eA | 0) >>> 0 ? A + 1 | 0 : A, g = kA(p, 0, J, 0), C = h + A | 0, C = g >>> 0 > (eA = g + eA | 0) >>> 0 ? C + 1 | 0 : C, A = kA(H, SA, dA, 0), g = h + C | 0, g = A >>> 0 > (eA = A + eA | 0) >>> 0 ? g + 1 | 0 : g, C = kA(y, 0, L, 0), A = h + g | 0, A = C >>> 0 > (eA = C + eA | 0) >>> 0 ? A + 1 | 0 : A, C = kA(r, 0, v, 0), g = h + A | 0, g = C >>> 0 > (eA = C + eA | 0) >>> 0 ? g + 1 | 0 : g, C = kA(s, 0, x, 0), A = h + g | 0, A = C >>> 0 > (eA = C + eA | 0) >>> 0 ? A + 1 | 0 : A, g = kA(k, 0, m, 0), C = h + A | 0, g = C = g >>> 0 > (eA = g + eA | 0) >>> 0 ? C + 1 | 0 : C, KA = (C = (2097151 & mA) << 11 | jA >>> 21) + (A = B + eA | 0) | 0, A = (mA >>> 21 | 0) + (g = A >>> 0 < eA >>> 0 ? g + 1 | 0 : g) | 0, sA = A = C >>> 0 > KA >>> 0 ? A + 1 | 0 : A, zA = g = A - ((KA >>> 0 < 4293918720) - 1 | 0) | 0, C = (A = g >>> 21 | 0) + i | 0, yA = C = (g = (2097151 & g) << 11 | (SA = KA - -1048576 | 0) >>> 21) >>> 0 > (pA = g + DA | 0) >>> 0 ? C + 1 | 0 : C, jA = g = C - ((pA >>> 0 < 4293918720) - 1 | 0) | 0, A = (A = g >> 21) + JA | 0, DA = A = (g = (2097151 & g) << 11 | (eA = pA - -1048576 | 0) >>> 21) >>> 0 > (HA = g + HA | 0) >>> 0 ? A + 1 | 0 : A, bA = g = A - ((HA >>> 0 < 4293918720) - 1 | 0) | 0, C = (A = g >> 21) + UA | 0, mA = C = (g = (B = (2097151 & g) << 11 | (i = HA - -1048576 | 0) >>> 21) + lA | 0) >>> 0 < B >>> 0 ? C + 1 | 0 : C, UA = g, A = kA(g, C, -683901, -1), g = h + TA | 0, JA = C = A + xA | 0, B = A >>> 0 > C >>> 0 ? g + 1 | 0 : g, g = kA(AA, $, 470296, 0), A = h + nA | 0, A = g >>> 0 > (wA = g + wA | 0) >>> 0 ? A + 1 | 0 : A, g = kA(uA, WA, 654183, 0), A = h + (A - (((C = -2097152 & rA) >>> 0 > wA >>> 0) + fA | 0) | 0) | 0, A = g >>> 0 > (rA = g + (wA - C | 0) | 0) >>> 0 ? A + 1 | 0 : A, C = kA($A, CA, -997805, -1), g = h + A | 0, g = C >>> 0 > (rA = C + rA | 0) >>> 0 ? g + 1 | 0 : g, vA = C = HA - (A = -2097152 & i) | 0, dA = DA = DA - ((A >>> 0 > HA >>> 0) + bA | 0) | 0, rA = (i = kA(UA, mA, 136657, 0)) + rA | 0, A = h + g | 0, C = kA(C, DA, -683901, -1), g = h + (i >>> 0 > rA >>> 0 ? A + 1 | 0 : A) | 0, DA = g = C >>> 0 > (nA = C + rA | 0) >>> 0 ? g + 1 | 0 : g, bA = A = g - ((nA >>> 0 < 4293918720) - 1 | 0) | 0, g = (2097151 & A) << 11 | (i = nA - -1048576 | 0) >>> 21, A = (A >> 21) + B | 0, HA = g = (A = g >>> 0 > (rA = g + JA | 0) >>> 0 ? A + 1 | 0 : A) - ((rA >>> 0 < 4293918720) - 1 | 0) | 0, wA = (2097151 & g) << 11 | (B = rA - -1048576 | 0) >>> 21, g = (g >> 21) + RA | 0, OA = JA = wA + OA | 0, JA = wA >>> 0 > JA >>> 0 ? g + 1 | 0 : g, RA = rA - (g = -2097152 & B) | 0, ZA = A - ((g >>> 0 > rA >>> 0) + HA | 0) | 0, xA = nA - (A = -2097152 & i) | 0, TA = DA - ((A >>> 0 > nA >>> 0) + bA | 0) | 0, A = kA(AA, $, 666643, 0), C = _A + h | 0, C = (i = A + VA | 0) >>> 0 < VA >>> 0 ? C + 1 | 0 : C, B = (A = kA(uA, WA, 470296, 0)) + (i - (g = -2097152 & tA) | 0) | 0, g = h + (C - ((g >>> 0 > i >>> 0) + oA | 0) | 0) | 0, g = A >>> 0 > B >>> 0 ? g + 1 | 0 : g, C = kA($A, CA, 654183, 0), A = h + g | 0, rA = B = C + B | 0, B = C >>> 0 > B >>> 0 ? A + 1 | 0 : A, i = pA - (A = -2097152 & eA) | 0, DA = yA - ((A >>> 0 > pA >>> 0) + jA | 0) | 0, A = kA(gA, IA, 470296, 0), g = h, C = A, A = kA(l, W, 666643, 0), g = h + g | 0, g = A >>> 0 > (C = C + A | 0) >>> 0 ? g + 1 | 0 : g, A = kA(O, X, 654183, 0), g = h + g | 0, g = A >>> 0 > (C = A + C | 0) >>> 0 ? g + 1 | 0 : g, eA = (A = C) + (C = kA(q, z, -997805, -1)) | 0, A = h + g | 0, A = C >>> 0 > eA >>> 0 ? A + 1 | 0 : A, g = kA(j, T, 136657, 0), A = h + A | 0, A = g >>> 0 > (C = g + eA | 0) >>> 0 ? A + 1 | 0 : A, eA = (g = kA(Z, V, -683901, -1)) + C | 0, C = h + A | 0, g = sA + (g >>> 0 > eA >>> 0 ? C + 1 | 0 : C) | 0, pA = (C = (2097151 & LA) << 11 | YA >>> 21) + ((eA = eA + KA | 0) - (A = -2097152 & SA) | 0) | 0, A = ((g = eA >>> 0 < KA >>> 0 ? g + 1 | 0 : g) - ((A >>> 0 > eA >>> 0) + zA | 0) | 0) + (LA >> 21) | 0, HA = A = C >>> 0 > pA >>> 0 ? A + 1 | 0 : A, lA = A = A - ((pA >>> 0 < 4293918720) - 1 | 0) | 0, g = i, i = (2097151 & A) << 11 | (tA = pA - -1048576 | 0) >>> 21, A = (A >> 21) + DA | 0, bA = A = (C = g + i | 0) >>> 0 < i >>> 0 ? A + 1 | 0 : A, KA = C, A = kA(C, A, -683901, -1), g = h + B | 0, g = A >>> 0 > (C = A + rA | 0) >>> 0 ? g + 1 | 0 : g, B = (A = C) + (C = kA(UA, mA, -997805, -1)) | 0, A = h + g | 0, A = C >>> 0 > B >>> 0 ? A + 1 | 0 : A, g = kA(vA, dA, 136657, 0), C = h + A | 0, YA = B = g + B | 0, yA = g >>> 0 > B >>> 0 ? C + 1 | 0 : C, rA = XA - (A = -2097152 & NA) | 0, sA = hA - ((A >>> 0 > XA >>> 0) + EA | 0) | 0, g = kA(Y, 0, v, 0), A = h, C = g, g = kA(d, 0, L, 0), A = h + A | 0, A = g >>> 0 > (C = C + g | 0) >>> 0 ? A + 1 | 0 : A, g = kA(K, 0, x, 0), A = h + A | 0, A = g >>> 0 > (C = g + C | 0) >>> 0 ? A + 1 | 0 : A, B = (g = kA(P, 0, m, 0)) + C | 0, C = h + A | 0, g = g >>> 0 > B >>> 0 ? C + 1 | 0 : C, SA = C = (A = (a[f + 7 | 0] | a[f + 8 | 0] << 8 | a[f + 9 | 0] << 16 | a[f + 10 | 0] << 24) >>> 7 & 2097151) + B | 0, eA = A >>> 0 > C >>> 0 ? g + 1 | 0 : g, A = kA(Y, 0, L, 0), g = h, C = A, A = kA(d, 0, m, 0), g = h + g | 0, g = A >>> 0 > (C = C + A | 0) >>> 0 ? g + 1 | 0 : g, B = (A = C) + (C = kA(P, 0, x, 0)) | 0, A = h + g | 0, DA = B, B = C >>> 0 > B >>> 0 ? A + 1 | 0 : A, A = (g = a[f + 6 | 0]) >>> 24 | 0, i = g << 8 | (zA = a[f + 2 | 0] | a[f + 3 | 0] << 8 | a[f + 4 | 0] << 16 | a[f + 5 | 0] << 24) >>> 24, C = A, g = (A = a[f + 7 | 0]) >>> 16 | 0, g |= C, C = B, i = C = (A = 2097151 & ((3 & g) << 30 | (A = A << 16 | i) >>> 2)) >>> 0 > (DA = A + DA | 0) >>> 0 ? C + 1 | 0 : C, qA = A = C - ((DA >>> 0 < 4293918720) - 1 | 0) | 0, C = (2097151 & A) << 11 | (_A = DA - -1048576 | 0) >>> 21, A = (A >>> 21 | 0) + eA | 0, wA = A = C >>> 0 > (hA = C + SA | 0) >>> 0 ? A + 1 | 0 : A, jA = A = A - ((hA >>> 0 < 4293918720) - 1 | 0) | 0, C = (g = A >>> 21 | 0) + sA | 0, C = (A = (2097151 & A) << 11 | (nA = hA - -1048576 | 0) >>> 21) >>> 0 > (B = A + rA | 0) >>> 0 ? C + 1 | 0 : C, g = kA(uA, WA, 666643, 0), A = h + C | 0, A = g >>> 0 > (B = g + B | 0) >>> 0 ? A + 1 | 0 : A, g = kA($A, CA, 470296, 0), A = h + A | 0, A = g >>> 0 > (C = g + B | 0) >>> 0 ? A + 1 | 0 : A, B = (g = C) + (C = kA(KA, bA, 136657, 0)) | 0, g = h + A | 0, g = C >>> 0 > B >>> 0 ? g + 1 | 0 : g, A = kA(UA, mA, 654183, 0), g = h + g | 0, g = A >>> 0 > (C = A + B | 0) >>> 0 ? g + 1 | 0 : g, rA = (A = kA(vA, dA, -997805, -1)) + C | 0, C = h + g | 0, sA = C = A >>> 0 > rA >>> 0 ? C + 1 | 0 : C, LA = A = C - ((rA >>> 0 < 4293918720) - 1 | 0) | 0, C = (2097151 & A) << 11 | (SA = rA - -1048576 | 0) >>> 21, A = (A >> 21) + yA | 0, YA = C = (A = C >>> 0 > (B = C + YA | 0) >>> 0 ? A + 1 | 0 : A) - ((B >>> 0 < 4293918720) - 1 | 0) | 0, eA = (2097151 & C) << 11 | (yA = B - -1048576 | 0) >>> 21, C = (C >> 21) + TA | 0, PA = NA = eA + xA | 0, NA = eA >>> 0 > NA >>> 0 ? C + 1 | 0 : C, eA = B, g = A, B = (pA - (A = -2097152 & tA) | 0) + (tA = (2097151 & GA) << 11 | FA >>> 21) | 0, A = (HA - ((A >>> 0 > pA >>> 0) + lA | 0) | 0) + (GA >> 21) | 0, FA = A = B >>> 0 < tA >>> 0 ? A + 1 | 0 : A, xA = A = A - ((B >>> 0 < 4293918720) - 1 | 0) | 0, pA = C = A >> 21, A = kA(uA = (2097151 & A) << 11 | (GA = B - -1048576 | 0) >>> 21, C, -683901, -1), g = h + g | 0, g = A >>> 0 > (C = A + eA | 0) >>> 0 ? g + 1 | 0 : g, TA = C - (A = -2097152 & yA) | 0, XA = g - ((A >>> 0 > C >>> 0) + YA | 0) | 0, g = kA(uA, pA, 136657, 0), A = h + sA | 0, A = g >>> 0 > (C = g + rA | 0) >>> 0 ? A + 1 | 0 : A, VA = C - (g = -2097152 & SA) | 0, LA = A - ((g >>> 0 > C >>> 0) + LA | 0) | 0, g = kA($A, CA, 666643, 0), A = h + (wA - (((C = -2097152 & nA) >>> 0 > hA >>> 0) + jA | 0) | 0) | 0, A = g >>> 0 > (eA = g + (hA - C | 0) | 0) >>> 0 ? A + 1 | 0 : A, C = kA(KA, bA, -997805, -1), g = h + A | 0, g = C >>> 0 > (eA = C + eA | 0) >>> 0 ? g + 1 | 0 : g, A = kA(UA, mA, 470296, 0), C = h + g | 0, C = A >>> 0 > (eA = A + eA | 0) >>> 0 ? C + 1 | 0 : C, g = kA(vA, dA, 654183, 0), A = h + C | 0, YA = eA = g + eA | 0, sA = g >>> 0 > eA >>> 0 ? A + 1 | 0 : A, C = zA >>> 5 & 2097151, A = kA(Y, 0, m, 0), g = h, yA = A, A = kA(d, 0, x, 0), g = h + g | 0, A = A >>> 0 > (eA = yA + A | 0) >>> 0 ? g + 1 | 0 : g, yA = g = C + eA | 0, C = A = g >>> 0 < eA >>> 0 ? A + 1 | 0 : A, hA = (g = kA(Y, 0, x, 0)) + (A = (A = a[f + 2 | 0]) << 16 & 2031616 | a[0 | f] | a[f + 1 | 0] << 8) | 0, g = h, tA = g = A >>> 0 > hA >>> 0 ? g + 1 | 0 : g, lA = g = g - ((hA >>> 0 < 4293918720) - 1 | 0) | 0, A = (A = g >>> 21 | 0) + C | 0, nA = A = (g = (2097151 & g) << 11 | (wA = hA - -1048576 | 0) >>> 21) >>> 0 > (HA = g + yA | 0) >>> 0 ? A + 1 | 0 : A, zA = g = A - ((HA >>> 0 < 4293918720) - 1 | 0) | 0, C = (2097151 & g) << 11 | (rA = HA - -1048576 | 0) >>> 21, g = (g >>> 21 | 0) + i | 0, g = C >>> 0 > (eA = C + DA | 0) >>> 0 ? g + 1 | 0 : g, C = kA(KA, bA, 654183, 0), A = h + (g - (((i = -2097152 & _A) >>> 0 > eA >>> 0) + qA | 0) | 0) | 0, A = C >>> 0 > (DA = C + (eA - i | 0) | 0) >>> 0 ? A + 1 | 0 : A, g = kA(UA, mA, 666643, 0), A = h + A | 0, A = g >>> 0 > (C = g + DA | 0) >>> 0 ? A + 1 | 0 : A, SA = (g = C) + (C = kA(vA, dA, 470296, 0)) | 0, g = h + A | 0, yA = g = C >>> 0 > SA >>> 0 ? g + 1 | 0 : g, jA = g = g - ((SA >>> 0 < 4293918720) - 1 | 0) | 0, C = (A = g >> 21) + sA | 0, _A = g = (C = (g = (2097151 & g) << 11 | (eA = SA - -1048576 | 0) >>> 21) >>> 0 > (DA = g + YA | 0) >>> 0 ? C + 1 | 0 : C) - ((DA >>> 0 < 4293918720) - 1 | 0) | 0, sA = (2097151 & g) << 11 | (i = DA - -1048576 | 0) >>> 21, g = (g >> 21) + LA | 0, mA = UA = sA + VA | 0, sA = sA >>> 0 > UA >>> 0 ? g + 1 | 0 : g, A = kA(uA, pA, -997805, -1), g = h + C | 0, g = A >>> 0 > (DA = A + DA | 0) >>> 0 ? g + 1 | 0 : g, LA = DA - (A = -2097152 & i) | 0, YA = g - ((A >>> 0 > DA >>> 0) + _A | 0) | 0, g = kA(uA, pA, 654183, 0), A = h + yA | 0, A = g >>> 0 > (C = g + SA | 0) >>> 0 ? A + 1 | 0 : A, UA = C - (g = -2097152 & eA) | 0, _A = A - ((g >>> 0 > C >>> 0) + jA | 0) | 0, A = kA(KA, bA, 470296, 0), C = h + (nA - (((g = -2097152 & rA) >>> 0 > HA >>> 0) + zA | 0) | 0) | 0, C = A >>> 0 > (i = A + (HA - g | 0) | 0) >>> 0 ? C + 1 | 0 : C, g = kA(vA, dA, 666643, 0), A = h + C | 0, DA = i = g + i | 0, C = g >>> 0 > i >>> 0 ? A + 1 | 0 : A, g = kA(KA, bA, 666643, 0), A = h + (tA - ((4095 & lA) + ((i = -2097152 & wA) >>> 0 > hA >>> 0) | 0) | 0) | 0, SA = A = g >>> 0 > (rA = g + (hA - i | 0) | 0) >>> 0 ? A + 1 | 0 : A, tA = A = A - ((rA >>> 0 < 4293918720) - 1 | 0) | 0, i = (2097151 & A) << 11 | (yA = rA - -1048576 | 0) >>> 21, A = (A >> 21) + C | 0, C = A = i >>> 0 > (eA = i + DA | 0) >>> 0 ? A + 1 | 0 : A, wA = A = A - ((eA >>> 0 < 4293918720) - 1 | 0) | 0, i = (2097151 & A) << 11 | (DA = eA - -1048576 | 0) >>> 21, A = (A >> 21) + _A | 0, i = i >>> 0 > (nA = i + UA | 0) >>> 0 ? A + 1 | 0 : A, A = kA(uA, pA, 470296, 0), C = h + C | 0, C = A >>> 0 > (g = A + eA | 0) >>> 0 ? C + 1 | 0 : C, eA = g - (A = -2097152 & DA) | 0, DA = C - ((A >>> 0 > g >>> 0) + wA | 0) | 0, g = kA(uA, pA, 666643, 0), A = h + (SA - (((C = -2097152 & yA) >>> 0 > rA >>> 0) + tA | 0) | 0) | 0, g = (C = (A = g >>> 0 > (HA = g + (rA - C | 0) | 0) >>> 0 ? A + 1 | 0 : A) >> 21) + DA | 0, A = (A = (g = (A = (2097151 & A) << 11 | HA >>> 21) >>> 0 > (_A = A + eA | 0) >>> 0 ? g + 1 | 0 : g) >> 21) + i | 0, g = (g = (A = (g = (2097151 & g) << 11 | _A >>> 21) >>> 0 > (tA = g + nA | 0) >>> 0 ? A + 1 | 0 : A) >> 21) + YA | 0, C = (A = (g = (A = (2097151 & A) << 11 | tA >>> 21) >>> 0 > (i = A + LA | 0) >>> 0 ? g + 1 | 0 : g) >> 21) + sA | 0, A = (g = (C = (g = (2097151 & g) << 11 | i >>> 21) >>> 0 > (wA = g + mA | 0) >>> 0 ? C + 1 | 0 : C) >> 21) + XA | 0, g = (C = (A = (C = (2097151 & C) << 11 | wA >>> 21) >>> 0 > (nA = C + TA | 0) >>> 0 ? A + 1 | 0 : A) >> 21) + NA | 0, A = (A = (g = (A = (2097151 & A) << 11 | nA >>> 21) >>> 0 > (rA = A + PA | 0) >>> 0 ? g + 1 | 0 : g) >> 21) + ZA | 0, g = (g = (A = (g = (2097151 & g) << 11 | rA >>> 21) >>> 0 > (sA = g + RA | 0) >>> 0 ? A + 1 | 0 : A) >> 21) + JA | 0, C = (A = (g = (A = (2097151 & A) << 11 | sA >>> 21) >>> 0 > (SA = A + OA | 0) >>> 0 ? g + 1 | 0 : g) >> 21) + AI | 0, A = (g = (C = (g = (2097151 & g) << 11 | SA >>> 21) >>> 0 > (yA = g + QI | 0) >>> 0 ? C + 1 | 0 : C) >> 21) + BI | 0, DA = (GA = B - (g = -2097152 & GA) | 0) + ((2097151 & (A = (C = (2097151 & C) << 11 | yA >>> 21) >>> 0 > (eA = C + CI | 0) >>> 0 ? A + 1 | 0 : A)) << 11 | eA >>> 21) | 0, A = (FA - ((g >>> 0 > B >>> 0) + xA | 0) | 0) + (A >> 21) | 0, GA = g = (A = DA >>> 0 < GA >>> 0 ? A + 1 | 0 : A) >> 21, HA = (A = kA(NA = (2097151 & A) << 11 | DA >>> 21, g, 666643, 0)) + (g = 2097151 & HA) | 0, A = h, B = A = g >>> 0 > HA >>> 0 ? A + 1 | 0 : A, E[0 | Q] = HA, E[Q + 1 | 0] = (255 & A) << 24 | HA >>> 8, A = 2097151 & _A, g = kA(NA, GA, 470296, 0) + A | 0, C = h, A = (B >> 21) + (A >>> 0 > g >>> 0 ? C + 1 | 0 : C) | 0, A = (FA = (2097151 & B) << 11 | HA >>> 21) >>> 0 > (_A = FA + g | 0) >>> 0 ? A + 1 | 0 : A, E[Q + 4 | 0] = (2047 & A) << 21 | _A >>> 11, g = A, C = _A, E[Q + 3 | 0] = (7 & A) << 29 | C >>> 3, E[Q + 2 | 0] = 31 & ((65535 & B) << 16 | HA >>> 16) | C << 5, B = 2097151 & tA, tA = kA(NA, GA, 654183, 0) + B | 0, A = h, _A = (2097151 & g) << 11 | C >>> 21, g = (g >> 21) + (B = B >>> 0 > tA >>> 0 ? A + 1 | 0 : A) | 0, A = g = (tA = _A + tA | 0) >>> 0 < _A >>> 0 ? g + 1 | 0 : g, E[Q + 6 | 0] = (63 & A) << 26 | tA >>> 6, B = tA, tA = 0, E[Q + 5 | 0] = tA << 13 | (1572864 & C) >>> 19 | B << 2, C = 2097151 & i, i = kA(NA, GA, -997805, -1) + C | 0, g = h, g = C >>> 0 > i >>> 0 ? g + 1 | 0 : g, tA = (2097151 & (C = A)) << 11 | B >>> 21, C = (A >>= 21) + g | 0, C = (i = tA + i | 0) >>> 0 < tA >>> 0 ? C + 1 | 0 : C, E[Q + 9 | 0] = (511 & C) << 23 | i >>> 9, E[Q + 8 | 0] = (1 & C) << 31 | i >>> 1, g = 0, E[Q + 7 | 0] = g << 18 | (2080768 & B) >>> 14 | i << 7, g = 2097151 & wA, B = kA(NA, GA, 136657, 0) + g | 0, A = h, A = g >>> 0 > B >>> 0 ? A + 1 | 0 : A, wA = (2097151 & (g = C)) << 11 | i >>> 21, g = A + (C = g >> 21) | 0, g = (B = wA + B | 0) >>> 0 < wA >>> 0 ? g + 1 | 0 : g, E[Q + 12 | 0] = (4095 & g) << 20 | B >>> 12, C = B, E[Q + 11 | 0] = (15 & g) << 28 | C >>> 4, B = 0, E[Q + 10 | 0] = B << 15 | (1966080 & i) >>> 17 | C << 4, B = 2097151 & nA, i = kA(NA, GA, -683901, -1) + B | 0, A = h, A = B >>> 0 > i >>> 0 ? A + 1 | 0 : A, B = g, g = A + (g >>= 21) | 0, g = (B = (nA = i) + (i = (2097151 & B) << 11 | C >>> 21) | 0) >>> 0 < i >>> 0 ? g + 1 | 0 : g, E[Q + 14 | 0] = (127 & g) << 25 | B >>> 7, i = 0, E[Q + 13 | 0] = i << 12 | (1048576 & C) >>> 20 | B << 1, A = g >> 21, C = (g = (2097151 & g) << 11 | B >>> 21) >>> 0 > (i = g + (2097151 & rA) | 0) >>> 0 ? A + 1 | 0 : A, E[Q + 17 | 0] = (1023 & C) << 22 | i >>> 10, E[Q + 16 | 0] = (3 & C) << 30 | i >>> 2, g = 0, E[Q + 15 | 0] = g << 17 | (2064384 & B) >>> 15 | i << 6, A = C >> 21, A = (g = (2097151 & C) << 11 | i >>> 21) >>> 0 > (C = g + (2097151 & sA) | 0) >>> 0 ? A + 1 | 0 : A, E[Q + 20 | 0] = (8191 & A) << 19 | C >>> 13, E[Q + 19 | 0] = (31 & A) << 27 | C >>> 5, B = (g = 2097151 & SA) + (SA = (2097151 & A) << 11 | C >>> 21) | 0, g = A >> 21, g = B >>> 0 < SA >>> 0 ? g + 1 | 0 : g, SA = B, E[Q + 21 | 0] = B, sA = 0, E[Q + 18 | 0] = sA << 14 | (1835008 & i) >>> 18 | C << 3, E[Q + 22 | 0] = (255 & g) << 24 | B >>> 8, C = g >> 21, C = (B = (i = (2097151 & g) << 11 | B >>> 21) + (2097151 & yA) | 0) >>> 0 < i >>> 0 ? C + 1 | 0 : C, E[Q + 25 | 0] = (2047 & C) << 21 | B >>> 11, E[Q + 24 | 0] = (7 & C) << 29 | B >>> 3, E[Q + 23 | 0] = 31 & ((65535 & g) << 16 | SA >>> 16) | B << 5, A = C >> 21, A = (g = (2097151 & C) << 11 | B >>> 21) >>> 0 > (C = g + (2097151 & eA) | 0) >>> 0 ? A + 1 | 0 : A, E[Q + 27 | 0] = (63 & A) << 26 | C >>> 6, i = 0, E[Q + 26 | 0] = i << 13 | (1572864 & B) >>> 19 | C << 2, g = A >> 21, g = (A = (B = (2097151 & A) << 11 | C >>> 21) + (2097151 & DA) | 0) >>> 0 < B >>> 0 ? g + 1 | 0 : g, E[Q + 31 | 0] = (131071 & g) << 15 | A >>> 17, E[Q + 30 | 0] = (511 & g) << 23 | A >>> 9, E[Q + 29 | 0] = (1 & g) << 31 | A >>> 1, B = 0, E[Q + 28 | 0] = B << 18 | (2080768 & C) >>> 14 | A << 7, iI(c, 64), iI(f, 64), I && (o[I >> 2] = 64, o[I + 4 >> 2] = 0), w = e + 560 | 0, 0;
                                    }
                                    function k(A, I, g, C) {
                                        for(var B = 0, Q = 0, i = 0, E = 0, f = 0, c = 0, e = 0, r = 0, D = 0, t = 0, y = 0, w = 0, n = 0, s = 0, k = 0, F = 0, S = 0, H = 0, G = 0, _ = 0, M = 0, p = 0, N = 0, J = 0, U = 0, Y = 0, d = 0, K = 0, b = 0, P = 0, v = 0, L = 0, R = 0, u = 0, x = 0, m = 0, l = 0; i = (B = f << 3) + g | 0, Q = a[0 | (B = I + B | 0)] | a[B + 1 | 0] << 8 | a[B + 2 | 0] << 16 | a[B + 3 | 0] << 24, M = a[B + 4 | 0] | a[B + 5 | 0] << 8 | a[B + 6 | 0] << 16 | a[B + 7 | 0] << 24, c = Q << 24 | (65280 & Q) << 8, e = (E = 16711680 & Q) << 24, E = E >>> 8 | 0, B = (D = -16777216 & Q) >>> 24 | 0, o[i >> 2] = e | D << 8 | -16777216 & ((255 & M) << 24 | Q >>> 8) | 16711680 & ((16777215 & M) << 8 | Q >>> 24) | M >>> 8 & 65280 | M >>> 24, Q = B | E | c, B = 0, o[i + 4 >> 2] = Q | B | B, 16 != (0 | (f = f + 1 | 0)););
                                        for(I = o[A + 4 >> 2], o[C >> 2] = o[A >> 2], o[C + 4 >> 2] = I, I = o[A + 60 >> 2], o[C + 56 >> 2] = o[A + 56 >> 2], o[C + 60 >> 2] = I, I = o[A + 52 >> 2], o[C + 48 >> 2] = o[A + 48 >> 2], o[C + 52 >> 2] = I, I = o[A + 44 >> 2], o[C + 40 >> 2] = o[A + 40 >> 2], o[C + 44 >> 2] = I, I = o[A + 36 >> 2], o[C + 32 >> 2] = o[A + 32 >> 2], o[C + 36 >> 2] = I, I = o[A + 28 >> 2], o[C + 24 >> 2] = o[A + 24 >> 2], o[C + 28 >> 2] = I, I = o[A + 20 >> 2], o[C + 16 >> 2] = o[A + 16 >> 2], o[C + 20 >> 2] = I, I = o[A + 12 >> 2], o[C + 8 >> 2] = o[A + 8 >> 2], o[C + 12 >> 2] = I; i = o[C + 56 >> 2], E = o[C + 60 >> 2], B = o[(I = M = (p = l << 3) + g | 0) >> 2], I = o[I + 4 >> 2], S = Q = o[C + 36 >> 2], Q = DA(s = o[C + 32 >> 2], Q, 50), f = h, Q = DA(s, S, 46) ^ Q, f ^= h, Q = DA(s, S, 23) ^ Q, I = (h ^ f) + I | 0, I = (B = Q + B | 0) >>> 0 < Q >>> 0 ? I + 1 | 0 : I, B = (f = o[(Q = p + 34368 | 0) >> 2]) + B | 0, I = o[Q + 4 >> 2] + I | 0, I = B >>> 0 < f >>> 0 ? I + 1 | 0 : I, Q = (f = ((e = o[C + 48 >> 2]) ^ (t = o[C + 40 >> 2])) & s ^ e) + B | 0, B = (((k = o[C + 52 >> 2]) ^ (H = o[C + 44 >> 2])) & S ^ k) + I | 0, I = (Q >>> 0 < f >>> 0 ? B + 1 | 0 : B) + E | 0, I = (i = Q + i | 0) >>> 0 < Q >>> 0 ? I + 1 | 0 : I, f = (Q = o[C + 24 >> 2]) + i | 0, B = o[C + 28 >> 2] + I | 0, y = B = Q >>> 0 > f >>> 0 ? B + 1 | 0 : B, o[C + 24 >> 2] = f, o[C + 28 >> 2] = B, F = B = o[C + 4 >> 2], B = DA(Q = o[C >> 2], B, 36), E = h, B = DA(Q, F, 30) ^ B, E ^= h, D = i + (DA(Q, F, 25) ^ B) | 0, B = I + (h ^ E) | 0, B = i >>> 0 > D >>> 0 ? B + 1 | 0 : B, c = (I = D) + (D = Q & ((E = o[C + 16 >> 2]) | (i = o[C + 8 >> 2])) | i & E) | 0, I = (I = B) + (F & ((B = o[C + 20 >> 2]) | (w = o[C + 12 >> 2])) | B & w) | 0, D = I = c >>> 0 < D >>> 0 ? I + 1 | 0 : I, o[C + 56 >> 2] = c, o[C + 60 >> 2] = I, r = E, n = B, _ = o[(I = v = (G = 8 | p) + g | 0) >> 2], J = o[I + 4 >> 2], B = ((S ^ H) & y ^ H) + k | 0, B = (I = (E = (t ^ s) & f ^ t) + e | 0) >>> 0 < E >>> 0 ? B + 1 | 0 : B, E = DA(f, y, 50), e = h, E = DA(f, y, 46) ^ E, e ^= h, E = (k = DA(f, y, 23) ^ E) + I | 0, I = (h ^ e) + B | 0, I = (E >>> 0 < k >>> 0 ? I + 1 | 0 : I) + J | 0, I = (B = E + _ | 0) >>> 0 < E >>> 0 ? I + 1 | 0 : I, E = (E = B) + (e = o[(B = G + 34368 | 0) >> 2]) | 0, B = o[B + 4 >> 2] + I | 0, B = (I = E >>> 0 < e >>> 0 ? B + 1 | 0 : B) + n | 0, k = B = (e = E + r | 0) >>> 0 < E >>> 0 ? B + 1 | 0 : B, o[C + 16 >> 2] = e, o[C + 20 >> 2] = B, I = I + ((w | F) & D | w & F) | 0, I = (B = E + ((Q | i) & c | Q & i) | 0) >>> 0 < E >>> 0 ? I + 1 | 0 : I, E = DA(c, D, 36), r = h, E = DA(c, D, 30) ^ E, r ^= h, n = B, B = DA(c, D, 25) ^ E, I = (h ^ r) + I | 0, r = I = B >>> 0 > (E = n + B | 0) >>> 0 ? I + 1 | 0 : I, o[C + 48 >> 2] = E, o[C + 52 >> 2] = I, n = i, G = w, I = (w = o[(B = d = (i = 16 | p) + g | 0) >> 2]) + t | 0, B = o[B + 4 >> 2] + H | 0, B = I >>> 0 < w >>> 0 ? B + 1 | 0 : B, i = (t = I) + (w = o[(I = i + 34368 | 0) >> 2]) | 0, I = o[I + 4 >> 2] + B | 0, I = ((y ^ S) & k ^ S) + (I = i >>> 0 < w >>> 0 ? I + 1 | 0 : I) | 0, I = (B = (B = i) + (i = (f ^ s) & e ^ s) | 0) >>> 0 < i >>> 0 ? I + 1 | 0 : I, i = DA(e, k, 50), w = h, i = DA(e, k, 46) ^ i, w ^= h, i = (t = DA(e, k, 23) ^ i) + B | 0, B = (h ^ w) + I | 0, B = (t = i >>> 0 < t >>> 0 ? B + 1 | 0 : B) + G | 0, G = B = (w = i) >>> 0 > (i = i + n | 0) >>> 0 ? B + 1 | 0 : B, o[C + 8 >> 2] = i, o[C + 12 >> 2] = B, I = DA(E, r, 36), B = h, I = DA(E, r, 30) ^ I, B ^= h, H = DA(E, r, 25) ^ I, I = ((D | F) & r | D & F) + (h ^ B) | 0, B = t + ((n = H + ((Q | c) & E | Q & c) | 0) >>> 0 < H >>> 0 ? I + 1 | 0 : I) | 0, w = B = (t = w + n | 0) >>> 0 < w >>> 0 ? B + 1 | 0 : B, o[C + 40 >> 2] = t, o[C + 44 >> 2] = B, n = Q, B = (B = s) + (s = o[(I = L = (Q = 24 | p) + g | 0) >> 2]) | 0, I = o[I + 4 >> 2] + S | 0, I = B >>> 0 < s >>> 0 ? I + 1 | 0 : I, Q = (H = B) + (s = o[(B = Q + 34368 | 0) >> 2]) | 0, B = o[B + 4 >> 2] + I | 0, B = (y ^ (y ^ k) & G) + (B = Q >>> 0 < s >>> 0 ? B + 1 | 0 : B) | 0, B = (I = (I = Q) + (Q = f ^ (f ^ e) & i) | 0) >>> 0 < Q >>> 0 ? B + 1 | 0 : B, Q = DA(i, G, 50), s = h, Q = DA(i, G, 46) ^ Q, s ^= h, Q = (S = DA(i, G, 23) ^ Q) + I | 0, I = (h ^ s) + B | 0, B = (I = Q >>> 0 < S >>> 0 ? I + 1 | 0 : I) + F | 0, S = B = (F = Q + n | 0) >>> 0 < Q >>> 0 ? B + 1 | 0 : B, o[C >> 2] = F, o[C + 4 >> 2] = B, B = DA(t, w, 36), s = h, B = DA(t, w, 30) ^ B, n = h ^ s, H = DA(t, w, 25) ^ B, B = ((D | r) & w | D & r) + (h ^ n) | 0, I = I + ((s = H + ((E | c) & t | E & c) | 0) >>> 0 < H >>> 0 ? B + 1 | 0 : B) | 0, s = I = (n = Q + s | 0) >>> 0 < Q >>> 0 ? I + 1 | 0 : I, o[C + 32 >> 2] = n, o[C + 36 >> 2] = I, Q = o[(B = P = (I = 32 | p) + g | 0) >> 2], B = y + o[B + 4 >> 2] | 0, B = (Q = Q + f | 0) >>> 0 < f >>> 0 ? B + 1 | 0 : B, Q = (f = o[(I = I + 34368 | 0) >> 2]) + Q | 0, I = o[I + 4 >> 2] + B | 0, I = (k ^ (k ^ G) & S) + (I = Q >>> 0 < f >>> 0 ? I + 1 | 0 : I) | 0, I = (B = (B = Q) + (Q = e ^ (i ^ e) & F) | 0) >>> 0 < Q >>> 0 ? I + 1 | 0 : I, Q = DA(F, S, 50), f = h, Q = DA(F, S, 46) ^ Q, f ^= h, Q = (y = DA(F, S, 23) ^ Q) + B | 0, B = (h ^ f) + I | 0, H = B = Q >>> 0 < y >>> 0 ? B + 1 | 0 : B, I = B, B = DA(n, s, 36), f = h, B = DA(n, s, 30) ^ B, y = h ^ f, _ = DA(n, s, 25) ^ B, B = ((r | w) & s | r & w) + (h ^ y) | 0, I = ((f = _ + ((E | t) & n | E & t) | 0) >>> 0 < _ >>> 0 ? B + 1 | 0 : B) + I | 0, f = I = (y = Q + f | 0) >>> 0 < f >>> 0 ? I + 1 | 0 : I, o[C + 24 >> 2] = y, o[C + 28 >> 2] = I, B = D + H | 0, H = B = (D = Q + c | 0) >>> 0 < Q >>> 0 ? B + 1 | 0 : B, o[C + 56 >> 2] = D, o[C + 60 >> 2] = B, Q = o[(I = K = (B = 40 | p) + g | 0) >> 2], I = k + o[I + 4 >> 2] | 0, I = (Q = Q + e | 0) >>> 0 < e >>> 0 ? I + 1 | 0 : I, Q = (c = o[(B = B + 34368 | 0) >> 2]) + Q | 0, B = o[B + 4 >> 2] + I | 0, B = (G ^ (S ^ G) & H) + (B = Q >>> 0 < c >>> 0 ? B + 1 | 0 : B) | 0, B = (I = (I = Q) + (Q = i ^ (i ^ F) & D) | 0) >>> 0 < Q >>> 0 ? B + 1 | 0 : B, Q = DA(D, H, 50), c = h, Q = DA(D, H, 46) ^ Q, c ^= h, Q = (e = DA(D, H, 23) ^ Q) + I | 0, I = (h ^ c) + B | 0, I = Q >>> 0 < e >>> 0 ? I + 1 | 0 : I, B = DA(y, f, 36), c = h, B = DA(y, f, 30) ^ B, e = h ^ c, k = DA(y, f, 25) ^ B, B = ((w | s) & f | w & s) + (h ^ e) | 0, B = ((c = k + ((t | n) & y | t & n) | 0) >>> 0 < k >>> 0 ? B + 1 | 0 : B) + I | 0, c = B = (e = Q + c | 0) >>> 0 < c >>> 0 ? B + 1 | 0 : B, o[C + 16 >> 2] = e, o[C + 20 >> 2] = B, I = I + r | 0, _ = I = (r = Q + E | 0) >>> 0 < E >>> 0 ? I + 1 | 0 : I, o[C + 48 >> 2] = r, o[C + 52 >> 2] = I, Q = o[(B = Y = (I = 48 | p) + g | 0) >> 2], B = G + o[B + 4 >> 2] | 0, B = (Q = Q + i | 0) >>> 0 < i >>> 0 ? B + 1 | 0 : B, Q = (i = o[(I = I + 34368 | 0) >> 2]) + Q | 0, I = o[I + 4 >> 2] + B | 0, I = (S ^ (S ^ H) & _) + (I = Q >>> 0 < i >>> 0 ? I + 1 | 0 : I) | 0, I = (B = (B = Q) + (Q = F ^ (D ^ F) & r) | 0) >>> 0 < Q >>> 0 ? I + 1 | 0 : I, Q = DA(r, _, 50), i = h, Q = DA(r, _, 46) ^ Q, i ^= h, Q = (E = DA(r, _, 23) ^ Q) + B | 0, B = (h ^ i) + I | 0, E = B = Q >>> 0 < E >>> 0 ? B + 1 | 0 : B, I = B, B = DA(e, c, 36), i = h, B = DA(e, c, 30) ^ B, k = h ^ i, G = DA(e, c, 25) ^ B, B = ((f | s) & c | f & s) + (h ^ k) | 0, I = ((i = G + ((y | n) & e | y & n) | 0) >>> 0 < G >>> 0 ? B + 1 | 0 : B) + I | 0, k = I = (B = i) >>> 0 > (i = Q + i | 0) >>> 0 ? I + 1 | 0 : I, o[C + 8 >> 2] = i, o[C + 12 >> 2] = I, B = E + w | 0, G = B = (J = Q + t | 0) >>> 0 < Q >>> 0 ? B + 1 | 0 : B, o[C + 40 >> 2] = J, o[C + 44 >> 2] = B, Q = o[(I = b = (B = 56 | p) + g | 0) >> 2], I = S + o[I + 4 >> 2] | 0, I = (Q = Q + F | 0) >>> 0 < F >>> 0 ? I + 1 | 0 : I, Q = (E = o[(B = B + 34368 | 0) >> 2]) + Q | 0, B = o[B + 4 >> 2] + I | 0, B = (H ^ (H ^ _) & G) + (B = Q >>> 0 < E >>> 0 ? B + 1 | 0 : B) | 0, B = (I = (I = Q) + (Q = D ^ (D ^ r) & J) | 0) >>> 0 < Q >>> 0 ? B + 1 | 0 : B, Q = DA(J, G, 50), E = h, Q = DA(J, G, 46) ^ Q, E ^= h, Q = (w = DA(J, G, 23) ^ Q) + I | 0, I = (h ^ E) + B | 0, I = Q >>> 0 < w >>> 0 ? I + 1 | 0 : I, B = DA(i, k, 36), E = h, B = DA(i, k, 30) ^ B, w = h ^ E, t = DA(i, k, 25) ^ B, B = ((f | c) & k | f & c) + (h ^ w) | 0, B = ((E = t + ((e | y) & i | e & y) | 0) >>> 0 < t >>> 0 ? B + 1 | 0 : B) + I | 0, w = B = (w = E) >>> 0 > (E = Q + E | 0) >>> 0 ? B + 1 | 0 : B, o[C >> 2] = E, o[C + 4 >> 2] = B, I = I + s | 0, S = I = (t = Q + n | 0) >>> 0 < Q >>> 0 ? I + 1 | 0 : I, o[C + 32 >> 2] = t, o[C + 36 >> 2] = I, Q = o[(B = R = (I = 64 | p) + g | 0) >> 2], B = H + o[B + 4 >> 2] | 0, B = (Q = Q + D | 0) >>> 0 < D >>> 0 ? B + 1 | 0 : B, Q = (D = o[(I = I + 34368 | 0) >> 2]) + Q | 0, I = o[I + 4 >> 2] + B | 0, I = (_ ^ (G ^ _) & S) + (I = Q >>> 0 < D >>> 0 ? I + 1 | 0 : I) | 0, I = (B = (B = Q) + (Q = r ^ (r ^ J) & t) | 0) >>> 0 < Q >>> 0 ? I + 1 | 0 : I, Q = DA(t, S, 50), D = h, Q = DA(t, S, 46) ^ Q, D ^= h, Q = (F = DA(t, S, 23) ^ Q) + B | 0, B = (h ^ D) + I | 0, s = B = Q >>> 0 < F >>> 0 ? B + 1 | 0 : B, I = B, B = DA(E, w, 36), D = h, B = DA(E, w, 30) ^ B, F = h ^ D, n = DA(E, w, 25) ^ B, B = ((c | k) & w | c & k) + (h ^ F) | 0, I = ((D = n + ((i | e) & E | i & e) | 0) >>> 0 < n >>> 0 ? B + 1 | 0 : B) + I | 0, D = I = (F = Q + D | 0) >>> 0 < D >>> 0 ? I + 1 | 0 : I, o[C + 56 >> 2] = F, o[C + 60 >> 2] = I, B = f + s | 0, H = B = (f = Q + y | 0) >>> 0 < Q >>> 0 ? B + 1 | 0 : B, o[C + 24 >> 2] = f, o[C + 28 >> 2] = B, Q = o[(I = U = (B = 72 | p) + g | 0) >> 2], I = _ + o[I + 4 >> 2] | 0, I = (Q = Q + r | 0) >>> 0 < r >>> 0 ? I + 1 | 0 : I, Q = (r = o[(B = B + 34368 | 0) >> 2]) + Q | 0, B = o[B + 4 >> 2] + I | 0, B = (G ^ (S ^ G) & H) + (B = Q >>> 0 < r >>> 0 ? B + 1 | 0 : B) | 0, B = (I = (I = Q) + (Q = J ^ (t ^ J) & f) | 0) >>> 0 < Q >>> 0 ? B + 1 | 0 : B, Q = DA(f, H, 50), r = h, Q = DA(f, H, 46) ^ Q, r ^= h, Q = (s = DA(f, H, 23) ^ Q) + I | 0, I = (h ^ r) + B | 0, I = Q >>> 0 < s >>> 0 ? I + 1 | 0 : I, B = DA(F, D, 36), r = h, B = DA(F, D, 30) ^ B, s = h ^ r, n = DA(F, D, 25) ^ B, B = ((w | k) & D | w & k) + (h ^ s) | 0, B = ((r = n + ((i | E) & F | i & E) | 0) >>> 0 < n >>> 0 ? B + 1 | 0 : B) + I | 0, r = B = (s = Q + r | 0) >>> 0 < r >>> 0 ? B + 1 | 0 : B, o[C + 48 >> 2] = s, o[C + 52 >> 2] = B, I = I + c | 0, _ = I = (c = Q + e | 0) >>> 0 < Q >>> 0 ? I + 1 | 0 : I, o[C + 16 >> 2] = c, o[C + 20 >> 2] = I, I = (I = J) + (e = o[(B = J = (Q = 80 | p) + g | 0) >> 2]) | 0, B = o[B + 4 >> 2] + G | 0, B = I >>> 0 < e >>> 0 ? B + 1 | 0 : B, Q = (y = I) + (e = o[(I = Q + 34368 | 0) >> 2]) | 0, I = o[I + 4 >> 2] + B | 0, I = (S ^ (S ^ H) & _) + (I = Q >>> 0 < e >>> 0 ? I + 1 | 0 : I) | 0, I = (B = (B = Q) + (Q = t ^ (f ^ t) & c) | 0) >>> 0 < Q >>> 0 ? I + 1 | 0 : I, Q = DA(c, _, 50), e = h, Q = DA(c, _, 46) ^ Q, e ^= h, Q = (n = DA(c, _, 23) ^ Q) + B | 0, B = (h ^ e) + I | 0, y = B = Q >>> 0 < n >>> 0 ? B + 1 | 0 : B, I = B, B = DA(s, r, 36), e = h, B = DA(s, r, 30) ^ B, n = h ^ e, G = DA(s, r, 25) ^ B, B = ((D | w) & r | D & w) + (h ^ n) | 0, I = ((e = G + ((E | F) & s | E & F) | 0) >>> 0 < G >>> 0 ? B + 1 | 0 : B) + I | 0, e = I = (n = Q + e | 0) >>> 0 < e >>> 0 ? I + 1 | 0 : I, o[C + 40 >> 2] = n, o[C + 44 >> 2] = I, B = y + k | 0, k = B = (y = Q + i | 0) >>> 0 < i >>> 0 ? B + 1 | 0 : B, o[C + 8 >> 2] = y, o[C + 12 >> 2] = B, B = 34368 + (I = 88 | p) | 0, i = o[(I = N = I + g | 0) >> 2], Q = o[B >> 2] + i | 0, I = o[B + 4 >> 2] + o[I + 4 >> 2] | 0, B = S + (Q >>> 0 < i >>> 0 ? I + 1 | 0 : I) | 0, B = (H ^ (H ^ _) & k) + (B = (I = Q + t | 0) >>> 0 < t >>> 0 ? B + 1 | 0 : B) | 0, B = (I = (Q = f ^ (f ^ c) & y) + I | 0) >>> 0 < Q >>> 0 ? B + 1 | 0 : B, Q = DA(y, k, 50), i = h, Q = DA(y, k, 46) ^ Q, i ^= h, Q = (t = DA(y, k, 23) ^ Q) + I | 0, I = (h ^ i) + B | 0, I = Q >>> 0 < t >>> 0 ? I + 1 | 0 : I, B = DA(n, e, 36), i = h, B = DA(n, e, 30) ^ B, t = h ^ i, G = DA(n, e, 25) ^ B, B = ((D | r) & e | D & r) + (h ^ t) | 0, B = ((i = G + ((s | F) & n | s & F) | 0) >>> 0 < G >>> 0 ? B + 1 | 0 : B) + I | 0, t = B = (t = i) >>> 0 > (i = Q + i | 0) >>> 0 ? B + 1 | 0 : B, o[C + 32 >> 2] = i, o[C + 36 >> 2] = B, I = I + w | 0, w = I = (B = E) >>> 0 > (E = Q + E | 0) >>> 0 ? I + 1 | 0 : I, o[C >> 2] = E, o[C + 4 >> 2] = I, B = 34368 + (I = 96 | p) | 0, G = o[(I = u = I + g | 0) >> 2], Q = o[B >> 2] + G | 0, B = o[B + 4 >> 2] + o[I + 4 >> 2] | 0, I = H + (Q >>> 0 < G >>> 0 ? B + 1 | 0 : B) | 0, I = (B = Q + f | 0) >>> 0 < f >>> 0 ? I + 1 | 0 : I, Q = (f = c ^ (c ^ y) & E) + B | 0, B = (_ ^ (k ^ _) & w) + I | 0, B = Q >>> 0 < f >>> 0 ? B + 1 | 0 : B, I = DA(E, w, 50), f = h, I = DA(E, w, 46) ^ I, f ^= h, H = Q, Q = DA(E, w, 23) ^ I, B = (h ^ f) + B | 0, S = B = (I = H + Q | 0) >>> 0 < Q >>> 0 ? B + 1 | 0 : B, Q = I, I = DA(i, t, 36), f = h, I = DA(i, t, 30) ^ I, G = h ^ f, H = DA(i, t, 25) ^ I, I = ((e | r) & t | e & r) + (h ^ G) | 0, B = ((f = H + ((s | n) & i | s & n) | 0) >>> 0 < H >>> 0 ? I + 1 | 0 : I) + B | 0, f = B = (G = Q + f | 0) >>> 0 < f >>> 0 ? B + 1 | 0 : B, o[C + 24 >> 2] = G, o[C + 28 >> 2] = B, B = D + S | 0, D = B = (F = Q + F | 0) >>> 0 < Q >>> 0 ? B + 1 | 0 : B, o[C + 56 >> 2] = F, o[C + 60 >> 2] = B, B = 34368 + (I = 104 | p) | 0, S = o[(I = m = I + g | 0) >> 2], Q = o[B >> 2] + S | 0, I = o[B + 4 >> 2] + o[I + 4 >> 2] | 0, B = _ + (Q >>> 0 < S >>> 0 ? I + 1 | 0 : I) | 0, B = (I = Q + c | 0) >>> 0 < c >>> 0 ? B + 1 | 0 : B, Q = (c = y ^ (E ^ y) & F) + I | 0, I = (k ^ (w ^ k) & D) + B | 0, I = Q >>> 0 < c >>> 0 ? I + 1 | 0 : I, B = DA(F, D, 50), c = h, B = DA(F, D, 46) ^ B, c ^= h, S = DA(F, D, 23) ^ B, B = (h ^ c) + I | 0, H = B = (Q = S + Q | 0) >>> 0 < S >>> 0 ? B + 1 | 0 : B, I = B, B = DA(G, f, 36), c = h, B = DA(G, f, 30) ^ B, S = h ^ c, _ = DA(G, f, 25) ^ B, B = ((e | t) & f | e & t) + (h ^ S) | 0, I = ((c = _ + ((i | n) & G | i & n) | 0) >>> 0 < _ >>> 0 ? B + 1 | 0 : B) + I | 0, c = I = (S = Q + c | 0) >>> 0 < c >>> 0 ? I + 1 | 0 : I, o[C + 16 >> 2] = S, o[C + 20 >> 2] = I, I = r + H | 0, r = I = (s = Q + s | 0) >>> 0 < Q >>> 0 ? I + 1 | 0 : I, o[C + 48 >> 2] = s, o[C + 52 >> 2] = I, B = 34368 + (I = 112 | p) | 0, H = o[(Q = _ = I + g | 0) >> 2], I = o[B >> 2] + H | 0, B = o[B + 4 >> 2] + o[Q + 4 >> 2] | 0, B = k + (I >>> 0 < H >>> 0 ? B + 1 | 0 : B) | 0, B = (w ^ (D ^ w) & r) + (B = (I = I + y | 0) >>> 0 < y >>> 0 ? B + 1 | 0 : B) | 0, B = (I = (Q = E ^ (E ^ F) & s) + I | 0) >>> 0 < Q >>> 0 ? B + 1 | 0 : B, Q = DA(s, r, 50), y = h, Q = DA(s, r, 46) ^ Q, y ^= h, Q = (k = DA(s, r, 23) ^ Q) + I | 0, I = (h ^ y) + B | 0, H = I = Q >>> 0 < k >>> 0 ? I + 1 | 0 : I, B = I, I = DA(S, c, 36), y = h, I = DA(S, c, 30) ^ I, k = h ^ y, x = DA(S, c, 25) ^ I, I = ((f | t) & c | f & t) + (h ^ k) | 0, B = ((y = x + ((i | G) & S | i & G) | 0) >>> 0 < x >>> 0 ? I + 1 | 0 : I) + B | 0, y = B = (k = Q + y | 0) >>> 0 < y >>> 0 ? B + 1 | 0 : B, o[C + 8 >> 2] = k, o[C + 12 >> 2] = B, B = e + H | 0, Q = B = (e = Q + n | 0) >>> 0 < Q >>> 0 ? B + 1 | 0 : B, o[C + 40 >> 2] = e, o[C + 44 >> 2] = B, B = 34368 + (I = 120 | p) | 0, p = o[(I = n = I + g | 0) >> 2], H = o[B >> 2] + p | 0, B = o[B + 4 >> 2] + o[I + 4 >> 2] | 0, I = w + (H >>> 0 < p >>> 0 ? B + 1 | 0 : B) | 0, I = (D ^ (D ^ r) & Q) + (I = (B = E + H | 0) >>> 0 < E >>> 0 ? I + 1 | 0 : I) | 0, I = (B = (E = F ^ (s ^ F) & e) + B | 0) >>> 0 < E >>> 0 ? I + 1 | 0 : I, E = DA(e, Q, 50), D = h, E = DA(e, Q, 46) ^ E, D ^= h, Q = (E = DA(e, Q, 23) ^ E) + B | 0, B = (h ^ D) + I | 0, B = Q >>> 0 < E >>> 0 ? B + 1 | 0 : B, E = Q, D = B, I = B, B = DA(k, y, 36), e = h, B = DA(k, y, 30) ^ B, r = h ^ e, w = DA(k, y, 25) ^ B, B = ((f | c) & y | f & c) + (h ^ r) | 0, I = ((e = w + ((S | G) & k | S & G) | 0) >>> 0 < w >>> 0 ? B + 1 | 0 : B) + I | 0, I = (Q = Q + e | 0) >>> 0 < e >>> 0 ? I + 1 | 0 : I, o[C >> 2] = Q, o[C + 4 >> 2] = I, B = D + t | 0, B = (r = i) >>> 0 > (i = i + E | 0) >>> 0 ? B + 1 | 0 : B, o[C + 32 >> 2] = i, o[C + 36 >> 2] = B, 64 != (0 | l);)c = ((l = l + 16 | 0) << 3) + g | 0, E = o[M >> 2], f = o[M + 4 >> 2], x = o[U >> 2], D = I = o[U + 4 >> 2], B = I, Q = I = o[_ + 4 >> 2], I = DA(G = o[_ >> 2], I, 45), i = h, r = ((63 & Q) << 26 | G >>> 6) ^ (I = DA(G, Q, 3) ^ I), I = (Q >>> 6 ^ (e = h ^ i)) + B | 0, B = ((i = r + x | 0) >>> 0 < r >>> 0 ? I + 1 | 0 : I) + f | 0, B = (I = i + E | 0) >>> 0 < i >>> 0 ? B + 1 | 0 : B, E = i = o[v + 4 >> 2], i = DA(f = o[v >> 2], i, 63), e = h, i = ((127 & E) << 25 | f >>> 7) ^ DA(f, E, 56) ^ i, B = (h ^ e ^ E >>> 7) + B | 0, i = B = i >>> 0 > (S = i + I | 0) >>> 0 ? B + 1 | 0 : B, o[c >> 2] = S, o[c + 4 >> 2] = B, f = (_ = o[J >> 2]) + f | 0, I = (c = o[J + 4 >> 2]) + E | 0, B = f >>> 0 < _ >>> 0 ? I + 1 | 0 : I, E = I = o[n + 4 >> 2], I = DA(H = o[n >> 2], I, 45), e = h, r = f, f = ((63 & E) << 26 | H >>> 6) ^ DA(H, E, 3) ^ I, B = (h ^ e ^ E >>> 6) + B | 0, f = f >>> 0 > (r = r + f | 0) >>> 0 ? B + 1 | 0 : B, B = DA(e = o[d >> 2], I = o[d + 4 >> 2], 63), w = h, y = r, r = ((127 & I) << 25 | e >>> 7) ^ DA(e, I, 56) ^ B, B = (h ^ w ^ I >>> 7) + f | 0, f = B = r >>> 0 > (k = y + r | 0) >>> 0 ? B + 1 | 0 : B, o[M + 136 >> 2] = k, o[M + 140 >> 2] = B, B = (J = o[N >> 2]) + e | 0, I = (e = o[N + 4 >> 2]) + I | 0, r = DA(S, i, 45), w = h, r = (t = ((63 & i) << 26 | S >>> 6) ^ DA(S, i, 3) ^ r) + B | 0, B = (h ^ w ^ i >>> 6) + (B >>> 0 < J >>> 0 ? I + 1 | 0 : I) | 0, B = r >>> 0 < t >>> 0 ? B + 1 | 0 : B, w = I = o[L + 4 >> 2], I = DA(t = o[L >> 2], I, 63), F = h, y = r, r = ((127 & w) << 25 | t >>> 7) ^ DA(t, w, 56) ^ I, B = (h ^ F ^ w >>> 7) + B | 0, r = B = r >>> 0 > (p = y + r | 0) >>> 0 ? B + 1 | 0 : B, o[M + 144 >> 2] = p, o[M + 148 >> 2] = B, t = (v = o[u >> 2]) + t | 0, I = (I = w) + (w = o[u + 4 >> 2]) | 0, B = t >>> 0 < v >>> 0 ? I + 1 | 0 : I, I = DA(k, f, 45), F = h, s = ((63 & f) << 26 | k >>> 6) ^ DA(k, f, 3) ^ I, B = (h ^ F ^ f >>> 6) + B | 0, B = (t = s + t | 0) >>> 0 < s >>> 0 ? B + 1 | 0 : B, F = I = o[P + 4 >> 2], I = DA(s = o[P >> 2], I, 63), n = h, y = t, t = ((127 & F) << 25 | s >>> 7) ^ DA(s, F, 56) ^ I, B = (h ^ n ^ F >>> 7) + B | 0, t = B = t >>> 0 > (d = y + t | 0) >>> 0 ? B + 1 | 0 : B, o[M + 152 >> 2] = d, o[M + 156 >> 2] = B, I = (L = o[m >> 2]) + s | 0, B = (B = F) + (F = o[m + 4 >> 2]) | 0, s = DA(p, r, 45), n = h, s = ((63 & r) << 26 | p >>> 6) ^ DA(p, r, 3) ^ s, B = (h ^ n ^ r >>> 6) + (I >>> 0 < L >>> 0 ? B + 1 | 0 : B) | 0, s = (y = s + I | 0) >>> 0 < s >>> 0 ? B + 1 | 0 : B, B = DA(n = o[K >> 2], I = o[K + 4 >> 2], 63), P = h, N = y, y = ((127 & I) << 25 | n >>> 7) ^ (B = DA(n, I, 56) ^ B), B = (I >>> 7 ^ (K = h ^ P)) + s | 0, s = B = y >>> 0 > (P = N + y | 0) >>> 0 ? B + 1 | 0 : B, o[M + 160 >> 2] = P, o[M + 164 >> 2] = B, I = I + Q | 0, I = (B = n + G | 0) >>> 0 < n >>> 0 ? I + 1 | 0 : I, n = DA(d, t, 45), y = h, n = (K = ((63 & t) << 26 | d >>> 6) ^ DA(d, t, 3) ^ n) + B | 0, B = (h ^ y ^ t >>> 6) + I | 0, B = n >>> 0 < K >>> 0 ? B + 1 | 0 : B, y = o[Y >> 2], Y = I = o[Y + 4 >> 2], I = DA(y, I, 63), K = h, I = DA(y, Y, 56) ^ I, N = n, B = (Y >>> 7 ^ (U = h ^ K)) + B | 0, n = B = (n = ((127 & Y) << 25 | y >>> 7) ^ I) >>> 0 > (K = N + n | 0) >>> 0 ? B + 1 | 0 : B, o[M + 168 >> 2] = K, o[M + 172 >> 2] = B, I = E + Y | 0, I = (B = y + H | 0) >>> 0 < y >>> 0 ? I + 1 | 0 : I, N = y = o[b + 4 >> 2], y = DA(U = o[b >> 2], y, 63), Y = h, y = (b = ((127 & N) << 25 | U >>> 7) ^ DA(U, N, 56) ^ y) + B | 0, B = (h ^ Y ^ N >>> 7) + I | 0, I = y >>> 0 < b >>> 0 ? B + 1 | 0 : B, B = DA(P, s, 45), Y = h, B = DA(P, s, 3) ^ B, b = h ^ Y, Y = y, I = (s >>> 6 ^ b) + I | 0, y = I = (y = ((63 & s) << 26 | P >>> 6) ^ B) >>> 0 > (Y = Y + y | 0) >>> 0 ? I + 1 | 0 : I, o[M + 176 >> 2] = Y, o[M + 180 >> 2] = I, u = o[R >> 2], R = I = o[R + 4 >> 2], b = I, I = DA(x, D, 63), B = h, m = ((127 & D) << 25 | x >>> 7) ^ DA(x, D, 56) ^ I, I = (h ^ B ^ D >>> 7) + f | 0, B = ((k = m + k | 0) >>> 0 < m >>> 0 ? I + 1 | 0 : I) + b | 0, B = (I = k + u | 0) >>> 0 < k >>> 0 ? B + 1 | 0 : B, f = DA(Y, y, 45), k = h, b = (f = ((63 & y) << 26 | Y >>> 6) ^ DA(Y, y, 3) ^ f) + I | 0, I = (h ^ k ^ y >>> 6) + B | 0, f = I = f >>> 0 > b >>> 0 ? I + 1 | 0 : I, o[M + 192 >> 2] = b, o[M + 196 >> 2] = I, B = i + N | 0, B = (I = S + U | 0) >>> 0 < U >>> 0 ? B + 1 | 0 : B, k = DA(u, R, 63), U = h, N = ((127 & R) << 25 | u >>> 7) ^ DA(u, R, 56) ^ k, B = (h ^ U ^ R >>> 7) + B | 0, I = (k = N + I | 0) >>> 0 < N >>> 0 ? B + 1 | 0 : B, B = DA(K, n, 45), U = h, B = DA(K, n, 3) ^ B, R = k, I = (n >>> 6 ^ (N = h ^ U)) + I | 0, k = I = (k = ((63 & n) << 26 | K >>> 6) ^ B) >>> 0 > (U = R + k | 0) >>> 0 ? I + 1 | 0 : I, o[M + 184 >> 2] = U, o[M + 188 >> 2] = I, I = DA(J, e, 63), B = h, I = ((127 & e) << 25 | J >>> 7) ^ DA(J, e, 56) ^ I, B = (h ^ B ^ e >>> 7) + c | 0, I = t + (I >>> 0 > (N = I + _ | 0) >>> 0 ? B + 1 | 0 : B) | 0, I = (B = d + N | 0) >>> 0 < d >>> 0 ? I + 1 | 0 : I, t = DA(b, f, 45), d = h, t = DA(b, f, 3) ^ t, N = h ^ d, d = (t ^= (63 & f) << 26 | b >>> 6) + B | 0, B = (f >>> 6 ^ N) + I | 0, t = B = t >>> 0 > d >>> 0 ? B + 1 | 0 : B, o[M + 208 >> 2] = d, o[M + 212 >> 2] = B, I = DA(_, c, 63), B = h, N = DA(_, c, 56) ^ I, B = ((I = c >>> 7 | 0) ^ h ^ B) + D | 0, I = r + ((c = (_ = N ^ ((127 & c) << 25 | _ >>> 7)) + x | 0) >>> 0 < _ >>> 0 ? B + 1 | 0 : B) | 0, I = (B = c + p | 0) >>> 0 < p >>> 0 ? I + 1 | 0 : I, D = DA(U, k, 45), c = h, r = (D = ((63 & k) << 26 | U >>> 6) ^ DA(U, k, 3) ^ D) + B | 0, B = (h ^ c ^ k >>> 6) + I | 0, D = B = D >>> 0 > r >>> 0 ? B + 1 | 0 : B, o[M + 200 >> 2] = r, o[M + 204 >> 2] = B, I = DA(L, F, 63), B = h, _ = ((127 & F) << 25 | L >>> 7) ^ DA(L, F, 56) ^ I, I = (h ^ B ^ F >>> 7) + w | 0, B = n + ((c = _ + v | 0) >>> 0 < _ >>> 0 ? I + 1 | 0 : I) | 0, B = (I = c + K | 0) >>> 0 < K >>> 0 ? B + 1 | 0 : B, c = DA(d, t, 45), n = h, _ = I, I = t >>> 6 | 0, c = ((63 & t) << 26 | d >>> 6) ^ DA(d, t, 3) ^ c, B = (I ^ h ^ n) + B | 0, c = B = c >>> 0 > (t = _ + c | 0) >>> 0 ? B + 1 | 0 : B, o[M + 224 >> 2] = t, o[M + 228 >> 2] = B, I = DA(v, w, 63), B = h, I = DA(v, w, 56) ^ I, n = h ^ B, _ = ((127 & w) << 25 | v >>> 7) ^ I, I = ((B = w >>> 7 | 0) ^ n) + e | 0, B = s + ((w = _ + J | 0) >>> 0 < _ >>> 0 ? I + 1 | 0 : I) | 0, B = (I = w + P | 0) >>> 0 < P >>> 0 ? B + 1 | 0 : B, e = DA(r, D, 45), w = h, n = I, I = D >>> 6 | 0, D = ((63 & D) << 26 | r >>> 6) ^ DA(r, D, 3) ^ e, I = (I ^ h ^ w) + B | 0, D = I = (e = n + D | 0) >>> 0 < D >>> 0 ? I + 1 | 0 : I, o[M + 216 >> 2] = e, o[M + 220 >> 2] = I, I = DA(H, E, 63), B = h, w = ((127 & E) << 25 | H >>> 7) ^ DA(H, E, 56) ^ I, B = (h ^ B ^ E >>> 7) + Q | 0, B = k + ((I = w + G | 0) >>> 0 < w >>> 0 ? B + 1 | 0 : B) | 0, I = (r = I + U | 0) >>> 0 < U >>> 0 ? B + 1 | 0 : B, B = DA(t, c, 45), w = h, n = r, r = DA(t, c, 3) ^ B, B = c >>> 6 | 0, c = n + (r ^= (63 & c) << 26 | t >>> 6) | 0, I = (B ^ h ^ w) + I | 0, o[M + 240 >> 2] = c, o[M + 244 >> 2] = c >>> 0 < r >>> 0 ? I + 1 | 0 : I, I = DA(G, Q, 63), B = h, I = DA(G, Q, 56) ^ I, c = h ^ B, B = ((B = Q >>> 7 | 0) ^ c) + F | 0, I = y + ((I ^= (127 & Q) << 25 | G >>> 7) >>> 0 > (Q = I + L | 0) >>> 0 ? B + 1 | 0 : B) | 0, I = (B = Q + Y | 0) >>> 0 < Y >>> 0 ? I + 1 | 0 : I, Q = DA(e, D, 45), c = h, r = B, B = D >>> 6 | 0, Q = ((63 & D) << 26 | e >>> 6) ^ DA(e, D, 3) ^ Q, B = (B ^ h ^ c) + I | 0, Q = B = Q >>> 0 > (D = r + Q | 0) >>> 0 ? B + 1 | 0 : B, o[M + 232 >> 2] = D, o[M + 236 >> 2] = B, I = DA(S, i, 63), B = h, r = DA(S, i, 56) ^ I, B = ((I = i >>> 7 | 0) ^ h ^ B) + E | 0, I = f + ((i = (c = r ^ ((127 & i) << 25 | S >>> 7)) + H | 0) >>> 0 < c >>> 0 ? B + 1 | 0 : B) | 0, I = (B = i + b | 0) >>> 0 < b >>> 0 ? I + 1 | 0 : I, i = DA(D, Q, 45), E = h, r = B, B = Q >>> 6 | 0, Q = r + (i = ((63 & Q) << 26 | D >>> 6) ^ DA(D, Q, 3) ^ i) | 0, B = (B ^ h ^ E) + I | 0, o[M + 248 >> 2] = Q, o[M + 252 >> 2] = Q >>> 0 < i >>> 0 ? B + 1 | 0 : B;
                                        I = I + o[A + 4 >> 2] | 0, I = (g = Q + o[A >> 2] | 0) >>> 0 < Q >>> 0 ? I + 1 | 0 : I, o[A >> 2] = g, o[A + 4 >> 2] = I, B = o[A + 12 >> 2] + o[C + 12 >> 2] | 0, I = (g = o[C + 8 >> 2]) + o[A + 8 >> 2] | 0, o[A + 8 >> 2] = I, o[A + 12 >> 2] = I >>> 0 < g >>> 0 ? B + 1 | 0 : B, B = o[A + 20 >> 2] + o[C + 20 >> 2] | 0, I = (g = o[C + 16 >> 2]) + o[A + 16 >> 2] | 0, o[A + 16 >> 2] = I, o[A + 20 >> 2] = I >>> 0 < g >>> 0 ? B + 1 | 0 : B, I = o[A + 28 >> 2] + o[C + 28 >> 2] | 0, g = (B = o[C + 24 >> 2]) + o[A + 24 >> 2] | 0, o[A + 24 >> 2] = g, o[A + 28 >> 2] = g >>> 0 < B >>> 0 ? I + 1 | 0 : I, B = o[A + 36 >> 2] + o[C + 36 >> 2] | 0, I = (g = o[C + 32 >> 2]) + o[A + 32 >> 2] | 0, o[A + 32 >> 2] = I, o[A + 36 >> 2] = I >>> 0 < g >>> 0 ? B + 1 | 0 : B, I = o[A + 44 >> 2] + o[C + 44 >> 2] | 0, g = (B = o[C + 40 >> 2]) + o[A + 40 >> 2] | 0, o[A + 40 >> 2] = g, o[A + 44 >> 2] = g >>> 0 < B >>> 0 ? I + 1 | 0 : I, B = o[A + 52 >> 2] + o[C + 52 >> 2] | 0, I = (g = o[C + 48 >> 2]) + o[A + 48 >> 2] | 0, o[A + 48 >> 2] = I, o[A + 52 >> 2] = I >>> 0 < g >>> 0 ? B + 1 | 0 : B, B = o[A + 60 >> 2] + o[C + 60 >> 2] | 0, I = (g = o[C + 56 >> 2]) + o[A + 56 >> 2] | 0, o[A + 56 >> 2] = I, o[A + 60 >> 2] = I >>> 0 < g >>> 0 ? B + 1 | 0 : B;
                                    }
                                    function F(A) {
                                        var I, g, C, B, Q, i, o, f, c, e, r = 0, D = 0, t = 0, y = 0, w = 0, n = 0, s = 0, k = 0, F = 0, S = 0, H = 0, G = 0, _ = 0, M = 0, p = 0, N = 0, J = 0, U = 0, Y = 0, d = 0, K = 0, b = 0, P = 0, v = 0, L = 0, R = 0, u = 0, x = 0, m = 0, l = 0, z = 0, q = 0, X = 0, j = 0, T = 0, O = 0, V = 0, Z = 0;
                                        y = (G = a[A + 44 | 0] | a[A + 45 | 0] << 8 | a[A + 46 | 0] << 16 | a[A + 47 | 0] << 24) >>> 5 & 2097151, t = kA(b = (a[A + 60 | 0] | a[A + 61 | 0] << 8 | a[A + 62 | 0] << 16 | a[A + 63 | 0] << 24) >>> 3 | 0, 0, -683901, -1), D = (r = a[A + 44 | 0]) << 16 & 2031616 | a[A + 42 | 0] | a[A + 43 | 0] << 8, r = h, k = r = D >>> 0 > (F = t + D | 0) >>> 0 ? r + 1 | 0 : r, N = r = r - ((F >>> 0 < 4293918720) - 1 | 0) | 0, t = r >> 21, r = (D = y) + (y = (2097151 & r) << 11 | (n = F - -1048576 | 0) >>> 21) | 0, D = t, l = D = r >>> 0 < y >>> 0 ? D + 1 | 0 : D, z = r, Y = kA(r, D, -683901, -1), S = h, s = kA(I = (a[A + 49 | 0] | a[A + 50 | 0] << 8 | a[A + 51 | 0] << 16 | a[A + 52 | 0] << 24) >>> 7 & 2097151, 0, -997805, -1), t = (r = a[A + 27 | 0]) >>> 24 | 0, y = r << 8 | (_ = a[A + 23 | 0] | a[A + 24 | 0] << 8 | a[A + 25 | 0] << 16 | a[A + 26 | 0] << 24) >>> 24, D = (r = a[A + 28 | 0]) >>> 16 | 0, D = 2097151 & ((3 & (D |= t)) << 30 | (r = y | r << 16) >>> 2), r = h, r = D >>> 0 > (t = D + s | 0) >>> 0 ? r + 1 | 0 : r, D = kA(u = (M = a[A + 52 | 0] | a[A + 53 | 0] << 8 | a[A + 54 | 0] << 16 | a[A + 55 | 0] << 24) >>> 4 & 2097151, 0, 654183, 0), r = h + r | 0, s = t = D + t | 0, t = D >>> 0 > t >>> 0 ? r + 1 | 0 : r, w = (D = a[A + 48 | 0]) << 8 | G >>> 24, D = r = D >>> 24 | 0, r = kA(g = 2097151 & ((3 & (G = (r = (y = a[A + 49 | 0]) >>> 16 | 0) | D)) << 30 | (D = (y <<= 16) | w) >>> 2), 0, 136657, 0), t = h + t | 0, t = r >>> 0 > (D = r + s | 0) >>> 0 ? t + 1 | 0 : t, y = (r = kA(C = (a[A + 57 | 0] | a[A + 58 | 0] << 8 | a[A + 59 | 0] << 16 | a[A + 60 | 0] << 24) >>> 6 & 2097151, 0, 666643, 0)) + D | 0, D = h + t | 0, s = y, t = r >>> 0 > y >>> 0 ? D + 1 | 0 : D, D = (r = a[A + 56 | 0]) >>> 24 | 0, w = r << 8 | M >>> 24, D = kA(B = 2097151 & ((1 & (M = (r = (y = a[A + 57 | 0]) >>> 16 | 0) | D)) << 31 | (D = (y <<= 16) | w) >>> 1), 0, 470296, 0), r = h + t | 0, D = (r = (t = y = D + s | 0) >>> 0 < D >>> 0 ? r + 1 | 0 : r) + S | 0, D = t >>> 0 > (y = t + Y | 0) >>> 0 ? D + 1 | 0 : D, J = t - -1048576 | 0, U = t = r - ((t >>> 0 < 4293918720) - 1 | 0) | 0, S = y - (r = -2097152 & J) | 0, Y = D - ((r >>> 0 > y >>> 0) + t | 0) | 0, D = kA(I, 0, 654183, 0), r = h, r = D >>> 0 > (t = D + (_ >>> 5 & 2097151) | 0) >>> 0 ? r + 1 | 0 : r, y = (D = t) + (t = kA(u, 0, 470296, 0)) | 0, D = h + r | 0, D = t >>> 0 > y >>> 0 ? D + 1 | 0 : D, r = kA(g, X, -997805, -1), D = h + D | 0, D = r >>> 0 > (t = r + y | 0) >>> 0 ? D + 1 | 0 : D, y = (r = t) + (t = kA(B, j, 666643, 0)) | 0, r = h + D | 0, w = y, y = t >>> 0 > y >>> 0 ? r + 1 | 0 : r, s = (t = kA(I, 0, 470296, 0)) + (r = (r = a[A + 23 | 0]) << 16 & 2031616 | a[A + 21 | 0] | a[A + 22 | 0] << 8) | 0, t = h, t = r >>> 0 > s >>> 0 ? t + 1 | 0 : t, s = (D = kA(u, 0, 666643, 0)) + s | 0, r = h + t | 0, t = kA(g, X, 654183, 0), D = h + (D >>> 0 > s >>> 0 ? r + 1 | 0 : r) | 0, M = D = t >>> 0 > (_ = t + s | 0) >>> 0 ? D + 1 | 0 : D, R = D = D - ((_ >>> 0 < 4293918720) - 1 | 0) | 0, r = (r = D >>> 21 | 0) + y | 0, t = r = (D = (2097151 & D) << 11 | (s = _ - -1048576 | 0) >>> 21) >>> 0 > (w = D + w | 0) >>> 0 ? r + 1 | 0 : r, H = D = r - ((w >>> 0 < 4293918720) - 1 | 0) | 0, r = S, S = (2097151 & D) << 11 | (y = w - -1048576 | 0) >>> 21, D = (D >> 21) + Y | 0, G = S = (D = S >>> 0 > (p = r + S | 0) >>> 0 ? D + 1 | 0 : D) - ((p >>> 0 < 4293918720) - 1 | 0) | 0, x = p - (r = -2097152 & (Y = p - -1048576 | 0)) | 0, T = D - ((r >>> 0 > p >>> 0) + S | 0) | 0, r = kA(z, l, 136657, 0), t = h + t | 0, t = r >>> 0 > (D = r + w | 0) >>> 0 ? t + 1 | 0 : t, K = D - (r = -2097152 & y) | 0, m = t - ((r >>> 0 > D >>> 0) + H | 0) | 0, p = F - (r = -2097152 & n) | 0, N = k - ((r >>> 0 > F >>> 0) + N | 0) | 0, k = kA(b, 0, 136657, 0), D = (r = a[A + 40 | 0]) >>> 24 | 0, y = r << 8 | (n = a[A + 36 | 0] | a[A + 37 | 0] << 8 | a[A + 38 | 0] << 16 | a[A + 39 | 0] << 24) >>> 24, t = (r = a[A + 41 | 0]) >>> 16 | 0, D = (t |= D) >>> 3 | 0, t = (7 & t) << 29 | (r = y | r << 16) >>> 3, r = D + h | 0, r = t >>> 0 > (y = t + k | 0) >>> 0 ? r + 1 | 0 : r, D = kA(C, 0, -683901, -1), r = h + r | 0, r = D >>> 0 > (t = D + y | 0) >>> 0 ? r + 1 | 0 : r, w = t, D = kA(b, 0, -997805, -1), t = h, t = D >>> 0 > (y = D + (n >>> 6 & 2097151) | 0) >>> 0 ? t + 1 | 0 : t, n = (D = y) + (y = kA(C, 0, 136657, 0)) | 0, D = h + t | 0, t = kA(B, j, -683901, -1), D = h + (y >>> 0 > n >>> 0 ? D + 1 | 0 : D) | 0, S = D = t >>> 0 > (P = t + n | 0) >>> 0 ? D + 1 | 0 : D, O = t = D - ((P >>> 0 < 4293918720) - 1 | 0) | 0, r = r + (D = t >> 21) | 0, n = r = (t = (2097151 & t) << 11 | (F = P - -1048576 | 0) >>> 21) >>> 0 > (H = t + w | 0) >>> 0 ? r + 1 | 0 : r, v = r = r - ((H >>> 0 < 4293918720) - 1 | 0) | 0, D = (D = r >> 21) + N | 0, q = D = (r = (t = (2097151 & r) << 11 | (w = H - -1048576 | 0) >>> 21) + p | 0) >>> 0 < t >>> 0 ? D + 1 | 0 : D, L = r, D = kA(r, D, -683901, -1), r = h + m | 0, d = t = D + K | 0, y = D >>> 0 > t >>> 0 ? r + 1 | 0 : r, m = _ - (r = -2097152 & s) | 0, N = M - ((4095 & R) + (r >>> 0 > _ >>> 0) | 0) | 0, _ = kA(I, 0, 666643, 0), r = (D = a[A + 19 | 0]) >>> 24 | 0, s = D << 8 | (M = a[A + 15 | 0] | a[A + 16 | 0] << 8 | a[A + 17 | 0] << 16 | a[A + 18 | 0] << 24) >>> 24, t = r, D = (7 & (t |= D = (r = a[A + 20 | 0]) >>> 16 | 0)) << 29 | (D = (r <<= 16) | s) >>> 3, t = h + (t >>> 3 | 0) | 0, t = D >>> 0 > (s = D + _ | 0) >>> 0 ? t + 1 | 0 : t, r = kA(g, X, 470296, 0), D = h + t | 0, r = r >>> 0 > (s = r + s | 0) >>> 0 ? D + 1 | 0 : D, t = kA(g, X, 666643, 0), D = h, _ = D = t >>> 0 > (K = t + (M >>> 6 & 2097151) | 0) >>> 0 ? D + 1 | 0 : D, V = t = D - ((K >>> 0 < 4293918720) - 1 | 0) | 0, r = r + (D = t >>> 21 | 0) | 0, M = r = (t = (2097151 & t) << 11 | (k = K - -1048576 | 0) >>> 21) >>> 0 > (p = t + s | 0) >>> 0 ? r + 1 | 0 : r, Z = r = r - ((p >>> 0 < 4293918720) - 1 | 0) | 0, D = (D = r >>> 21 | 0) + N | 0, D = (r = (2097151 & r) << 11 | (s = p - -1048576 | 0) >>> 21) >>> 0 > (t = r + m | 0) >>> 0 ? D + 1 | 0 : D, N = (r = t) + (t = kA(z, l, -997805, -1)) | 0, r = h + D | 0, r = t >>> 0 > N >>> 0 ? r + 1 | 0 : r, R = D = H - (t = -2097152 & w) | 0, Q = w = n - ((t >>> 0 > H >>> 0) + v | 0) | 0, t = kA(L, q, 136657, 0), r = h + r | 0, r = t >>> 0 > (n = t + N | 0) >>> 0 ? r + 1 | 0 : r, t = kA(D, w, -683901, -1), D = h + r | 0, n = D = t >>> 0 > (N = t + n | 0) >>> 0 ? D + 1 | 0 : D, v = r = D - ((N >>> 0 < 4293918720) - 1 | 0) | 0, D = (2097151 & r) << 11 | (w = N - -1048576 | 0) >>> 21, r = (r >> 21) + y | 0, d = D = (r = D >>> 0 > (H = D + d | 0) >>> 0 ? r + 1 | 0 : r) - ((H >>> 0 < 4293918720) - 1 | 0) | 0, m = (2097151 & D) << 11 | (y = H - -1048576 | 0) >>> 21, D = (D >> 21) + T | 0, o = x = m + x | 0, m = x >>> 0 < m >>> 0 ? D + 1 | 0 : D, f = H - (D = -2097152 & y) | 0, c = r - ((D >>> 0 > H >>> 0) + d | 0) | 0, x = N - (r = -2097152 & w) | 0, T = n - ((r >>> 0 > N >>> 0) + v | 0) | 0, t = (r = kA(z, l, 654183, 0)) + (p - (D = -2097152 & s) | 0) | 0, D = h + (M - ((2147483647 & Z) + (D >>> 0 > p >>> 0) | 0) | 0) | 0, D = r >>> 0 > t >>> 0 ? D + 1 | 0 : D, r = kA(L, q, -997805, -1), D = h + D | 0, D = r >>> 0 > (t = r + t | 0) >>> 0 ? D + 1 | 0 : D, y = (r = t) + (t = kA(R, Q, 136657, 0)) | 0, r = h + D | 0, d = y, n = t >>> 0 > y >>> 0 ? r + 1 | 0 : r, p = P - (r = -2097152 & F) | 0, H = S - ((r >>> 0 > P >>> 0) + O | 0) | 0, M = kA(u, 0, -683901, -1), r = (D = a[A + 35 | 0]) >>> 24 | 0, y = D << 8 | (s = a[A + 31 | 0] | a[A + 32 | 0] << 8 | a[A + 33 | 0] << 16 | a[A + 34 | 0] << 24) >>> 24, t = r, D = (r = a[A + 36 | 0]) >>> 16 | 0, D |= t, t = h, t = (r = 2097151 & ((1 & D) << 31 | (r = r << 16 | y) >>> 1)) >>> 0 > (D = r + M | 0) >>> 0 ? t + 1 | 0 : t, y = (r = kA(b, 0, 654183, 0)) + D | 0, D = h + t | 0, D = r >>> 0 > y >>> 0 ? D + 1 | 0 : D, t = kA(C, 0, -997805, -1), r = h + D | 0, r = t >>> 0 > (y = t + y | 0) >>> 0 ? r + 1 | 0 : r, D = kA(B, j, 136657, 0), r = h + r | 0, w = t = D + y | 0, y = D >>> 0 > t >>> 0 ? r + 1 | 0 : r, r = kA(I, 0, -683901, -1), D = h, D = r >>> 0 > (t = r + (s >>> 4 & 2097151) | 0) >>> 0 ? D + 1 | 0 : D, s = (r = kA(u, 0, 136657, 0)) + t | 0, t = h + D | 0, t = r >>> 0 > s >>> 0 ? t + 1 | 0 : t, r = kA(b, 0, 470296, 0), D = h + t | 0, D = r >>> 0 > (s = r + s | 0) >>> 0 ? D + 1 | 0 : D, s = (t = kA(C, 0, 654183, 0)) + s | 0, r = h + D | 0, D = kA(B, j, -997805, -1), r = h + (t >>> 0 > s >>> 0 ? r + 1 | 0 : r) | 0, M = r = D >>> 0 > (S = D + s | 0) >>> 0 ? r + 1 | 0 : r, e = D = r - ((S >>> 0 < 4293918720) - 1 | 0) | 0, t = (r = D >> 21) + y | 0, N = D = (t = (D = (2097151 & D) << 11 | (s = S - -1048576 | 0) >>> 21) >>> 0 > (F = D + w | 0) >>> 0 ? t + 1 | 0 : t) - ((F >>> 0 < 4293918720) - 1 | 0) | 0, r = (r = D >> 21) + H | 0, v = r = (D = (y = (2097151 & D) << 11 | (w = F - -1048576 | 0) >>> 21) + p | 0) >>> 0 < y >>> 0 ? r + 1 | 0 : r, y = d, d = D, r = kA(D, r, -683901, -1), D = h + n | 0, H = y = y + r | 0, y = r >>> 0 > y >>> 0 ? D + 1 | 0 : D, n = (r = kA(z, l, 470296, 0)) + (K - (D = -2097152 & k) | 0) | 0, D = h + (_ - ((2047 & V) + (D >>> 0 > K >>> 0) | 0) | 0) | 0, D = r >>> 0 > n >>> 0 ? D + 1 | 0 : D, k = (r = n) + (n = kA(L, q, 654183, 0)) | 0, r = h + D | 0, r = n >>> 0 > k >>> 0 ? r + 1 | 0 : r, n = kA(R, Q, -997805, -1), D = h + r | 0, D = n >>> 0 > (k = n + k | 0) >>> 0 ? D + 1 | 0 : D, P = w = F - (r = -2097152 & w) | 0, i = n = t - ((r >>> 0 > F >>> 0) + N | 0) | 0, t = kA(d, v, 136657, 0), r = h + D | 0, r = t >>> 0 > (k = t + k | 0) >>> 0 ? r + 1 | 0 : r, t = kA(w, n, -683901, -1), D = h + r | 0, n = D = t >>> 0 > (_ = t + k | 0) >>> 0 ? D + 1 | 0 : D, N = r = D - ((_ >>> 0 < 4293918720) - 1 | 0) | 0, D = (2097151 & r) << 11 | (w = _ - -1048576 | 0) >>> 21, r = (r >> 21) + y | 0, H = D = (r = D >>> 0 > (k = D + H | 0) >>> 0 ? r + 1 | 0 : r) - ((k >>> 0 < 4293918720) - 1 | 0) | 0, F = (2097151 & D) << 11 | (y = k - -1048576 | 0) >>> 21, D = (D >> 21) + T | 0, O = p = F + x | 0, p = F >>> 0 > p >>> 0 ? D + 1 | 0 : D, V = k - (D = -2097152 & y) | 0, Z = r - ((D >>> 0 > k >>> 0) + H | 0) | 0, x = _ - (r = -2097152 & w) | 0, T = n - ((r >>> 0 > _ >>> 0) + N | 0) | 0, n = kA(z, l, 666643, 0), r = (D = a[A + 14 | 0]) >>> 24 | 0, y = D << 8 | (N = a[A + 10 | 0] | a[A + 11 | 0] << 8 | a[A + 12 | 0] << 16 | a[A + 13 | 0] << 24) >>> 24, t = r, D = (r = a[A + 15 | 0]) >>> 16 | 0, D |= t, t = h, t = (r = 2097151 & ((1 & D) << 31 | (r = r << 16 | y) >>> 1)) >>> 0 > (D = r + n | 0) >>> 0 ? t + 1 | 0 : t, y = (r = D) + (D = kA(L, q, 470296, 0)) | 0, r = h + t | 0, r = D >>> 0 > y >>> 0 ? r + 1 | 0 : r, D = kA(R, Q, 654183, 0), r = h + r | 0, r = D >>> 0 > (t = D + y | 0) >>> 0 ? r + 1 | 0 : r, y = (D = t) + (t = kA(d, v, -997805, -1)) | 0, D = h + r | 0, D = t >>> 0 > y >>> 0 ? D + 1 | 0 : D, r = kA(P, i, 136657, 0), D = h + D | 0, _ = t = r + y | 0, y = r >>> 0 > t >>> 0 ? D + 1 | 0 : D, s = S - (r = -2097152 & s) | 0, n = M - ((r >>> 0 > S >>> 0) + e | 0) | 0, t = kA(I, 0, 136657, 0), r = h, r = (D = (a[A + 28 | 0] | a[A + 29 | 0] << 8 | a[A + 30 | 0] << 16 | a[A + 31 | 0] << 24) >>> 7 & 2097151) >>> 0 > (t = D + t | 0) >>> 0 ? r + 1 | 0 : r, w = (D = t) + (t = kA(u, 0, -997805, -1)) | 0, D = h + r | 0, D = t >>> 0 > w >>> 0 ? D + 1 | 0 : D, r = kA(g, X, -683901, -1), D = h + D | 0, D = r >>> 0 > (t = r + w | 0) >>> 0 ? D + 1 | 0 : D, w = (r = kA(b, 0, 666643, 0)) + t | 0, t = h + D | 0, t = r >>> 0 > w >>> 0 ? t + 1 | 0 : t, D = kA(C, 0, 470296, 0), r = h + t | 0, r = D >>> 0 > (w = D + w | 0) >>> 0 ? r + 1 | 0 : r, D = kA(B, j, 654183, 0), r = h + r | 0, D = (U >> 21) + (D >>> 0 > (t = D + w | 0) >>> 0 ? r + 1 | 0 : r) | 0, F = D = (w = (2097151 & U) << 11 | J >>> 21) >>> 0 > (J = w + t | 0) >>> 0 ? D + 1 | 0 : D, H = r = D - ((J >>> 0 < 4293918720) - 1 | 0) | 0, w = (2097151 & r) << 11 | (k = J - -1048576 | 0) >>> 21, r = (r >> 21) + n | 0, K = r = (D = w + s | 0) >>> 0 < w >>> 0 ? r + 1 | 0 : r, U = D, D = kA(D, r, -683901, -1), r = h + y | 0, w = t = D + _ | 0, y = D >>> 0 > t >>> 0 ? r + 1 | 0 : r, r = kA(L, q, 666643, 0), D = h, D = r >>> 0 > (t = r + (N >>> 4 & 2097151) | 0) >>> 0 ? D + 1 | 0 : D, r = kA(R, Q, 470296, 0), D = h + D | 0, D = r >>> 0 > (t = r + t | 0) >>> 0 ? D + 1 | 0 : D, n = (r = kA(d, v, 654183, 0)) + t | 0, t = h + D | 0, t = r >>> 0 > n >>> 0 ? t + 1 | 0 : t, D = kA(P, i, -997805, -1), r = h + t | 0, r = D >>> 0 > (n = D + n | 0) >>> 0 ? r + 1 | 0 : r, D = kA(U, K, 136657, 0), r = h + r | 0, M = r = D >>> 0 > (S = D + n | 0) >>> 0 ? r + 1 | 0 : r, l = D = r - ((S >>> 0 < 4293918720) - 1 | 0) | 0, r = w, w = (2097151 & D) << 11 | (s = S - -1048576 | 0) >>> 21, D = (D >> 21) + y | 0, L = y = (D = (t = r + w | 0) >>> 0 < w >>> 0 ? D + 1 | 0 : D) - ((t >>> 0 < 4293918720) - 1 | 0) | 0, r = (r = y >> 21) + T | 0, z = w = (y = (2097151 & y) << 11 | (n = t - -1048576 | 0) >>> 21) + x | 0, _ = y >>> 0 > w >>> 0 ? r + 1 | 0 : r, w = t, t = D, y = (J - (D = -2097152 & k) | 0) + (k = (2097151 & G) << 11 | Y >>> 21) | 0, D = (F - ((D >>> 0 > J >>> 0) + H | 0) | 0) + (G >> 21) | 0, N = D = y >>> 0 < k >>> 0 ? D + 1 | 0 : D, u = D = D - ((y >>> 0 < 4293918720) - 1 | 0) | 0, Y = r = D >> 21, r = kA(b = (2097151 & D) << 11 | (H = y - -1048576 | 0) >>> 21, r, -683901, -1), t = h + t | 0, t = r >>> 0 > (D = r + w | 0) >>> 0 ? t + 1 | 0 : t, X = D - (r = -2097152 & n) | 0, j = t - ((r >>> 0 > D >>> 0) + L | 0) | 0, r = kA(b, Y, 136657, 0), D = M + h | 0, q = (t = r + S | 0) - (r = -2097152 & s) | 0, L = (D = t >>> 0 < S >>> 0 ? D + 1 | 0 : D) - ((r >>> 0 > t >>> 0) + l | 0) | 0, D = kA(R, Q, 666643, 0), t = h, t = (r = (a[A + 7 | 0] | a[A + 8 | 0] << 8 | a[A + 9 | 0] << 16 | a[A + 10 | 0] << 24) >>> 7 & 2097151) >>> 0 > (D = r + D | 0) >>> 0 ? t + 1 | 0 : t, w = (r = kA(d, v, 470296, 0)) + D | 0, D = h + t | 0, D = r >>> 0 > w >>> 0 ? D + 1 | 0 : D, r = kA(P, i, 654183, 0), D = h + D | 0, D = r >>> 0 > (t = r + w | 0) >>> 0 ? D + 1 | 0 : D, w = (r = t) + (t = kA(U, K, -997805, -1)) | 0, r = h + D | 0, k = w, w = t >>> 0 > w >>> 0 ? r + 1 | 0 : r, M = kA(d, v, 666643, 0), r = (D = a[A + 6 | 0]) >>> 24 | 0, n = D << 8 | (J = a[A + 2 | 0] | a[A + 3 | 0] << 8 | a[A + 4 | 0] << 16 | a[A + 5 | 0] << 24) >>> 24, t = r, D = (r = a[A + 7 | 0]) >>> 16 | 0, D = 2097151 & ((3 & (D |= t)) << 30 | (r = r << 16 | n) >>> 2), r = h, r = D >>> 0 > (t = D + M | 0) >>> 0 ? r + 1 | 0 : r, n = (D = kA(P, i, 470296, 0)) + t | 0, t = h + r | 0, t = D >>> 0 > n >>> 0 ? t + 1 | 0 : t, D = kA(U, K, 654183, 0), r = h + t | 0, M = r = D >>> 0 > (F = D + n | 0) >>> 0 ? r + 1 | 0 : r, G = r = r - ((F >>> 0 < 4293918720) - 1 | 0) | 0, D = (t = r >> 21) + w | 0, S = r = (D = (r = (2097151 & r) << 11 | (s = F - -1048576 | 0) >>> 21) >>> 0 > (n = r + k | 0) >>> 0 ? D + 1 | 0 : D) - ((n >>> 0 < 4293918720) - 1 | 0) | 0, k = (2097151 & r) << 11 | (w = n - -1048576 | 0) >>> 21, r = (r >> 21) + L | 0, L = d = k + q | 0, k = k >>> 0 > d >>> 0 ? r + 1 | 0 : r, r = kA(b, Y, -997805, -1), D = h + D | 0, D = r >>> 0 > (t = r + n | 0) >>> 0 ? D + 1 | 0 : D, R = t - (r = -2097152 & w) | 0, v = D - ((r >>> 0 > t >>> 0) + S | 0) | 0, D = kA(b, Y, 654183, 0), r = M + h | 0, d = (t = D + F | 0) - (D = -2097152 & s) | 0, G = (r = t >>> 0 < F >>> 0 ? r + 1 | 0 : r) - ((D >>> 0 > t >>> 0) + G | 0) | 0, r = kA(P, i, 666643, 0), D = h, D = r >>> 0 > (t = r + (J >>> 5 & 2097151) | 0) >>> 0 ? D + 1 | 0 : D, r = kA(U, K, 470296, 0), D = h + D | 0, n = t = r + t | 0, t = r >>> 0 > t >>> 0 ? D + 1 | 0 : D, w = kA(U, K, 666643, 0), D = (r = a[A + 2 | 0]) << 16 & 2031616 | a[0 | A] | a[A + 1 | 0] << 8, r = h, M = r = D >>> 0 > (S = w + D | 0) >>> 0 ? r + 1 | 0 : r, K = r = r - ((S >>> 0 < 4293918720) - 1 | 0) | 0, w = (2097151 & r) << 11 | (s = S - -1048576 | 0) >>> 21, r = (r >> 21) + t | 0, t = r = w >>> 0 > (F = w + n | 0) >>> 0 ? r + 1 | 0 : r, J = r = r - ((F >>> 0 < 4293918720) - 1 | 0) | 0, w = (2097151 & r) << 11 | (n = F - -1048576 | 0) >>> 21, r = (r >> 21) + G | 0, w = w >>> 0 > (G = U = w + d | 0) >>> 0 ? r + 1 | 0 : r, r = kA(b, Y, 470296, 0), t = t + h | 0, t = (D = r + F | 0) >>> 0 < F >>> 0 ? t + 1 | 0 : t, F = D - (r = -2097152 & n) | 0, n = t - ((r >>> 0 > D >>> 0) + J | 0) | 0, D = kA(b, Y, 666643, 0), r = h + (M - (((t = -2097152 & s) >>> 0 > S >>> 0) + K | 0) | 0) | 0, D = (t = (r = D >>> 0 > (U = D + (S - t | 0) | 0) >>> 0 ? r + 1 | 0 : r) >> 21) + n | 0, r = (r = (D = (r = (2097151 & r) << 11 | U >>> 21) >>> 0 > (J = r + F | 0) >>> 0 ? D + 1 | 0 : D) >> 21) + w | 0, D = (D = (r = (D = (2097151 & D) << 11 | J >>> 21) >>> 0 > (G = D + G | 0) >>> 0 ? r + 1 | 0 : r) >> 21) + v | 0, t = (r = (D = (r = (2097151 & r) << 11 | G >>> 21) >>> 0 > (w = r + R | 0) >>> 0 ? D + 1 | 0 : D) >> 21) + k | 0, r = (D = (t = (D = (2097151 & D) << 11 | w >>> 21) >>> 0 > (Y = D + L | 0) >>> 0 ? t + 1 | 0 : t) >> 21) + j | 0, D = (t = (r = (t = (2097151 & t) << 11 | Y >>> 21) >>> 0 > (S = t + X | 0) >>> 0 ? r + 1 | 0 : r) >> 21) + _ | 0, r = (r = (D = (r = (2097151 & r) << 11 | S >>> 21) >>> 0 > (F = r + z | 0) >>> 0 ? D + 1 | 0 : D) >> 21) + Z | 0, D = (D = (r = (D = (2097151 & D) << 11 | F >>> 21) >>> 0 > (_ = D + V | 0) >>> 0 ? r + 1 | 0 : r) >> 21) + p | 0, t = (r = (D = (r = (2097151 & r) << 11 | _ >>> 21) >>> 0 > (k = r + O | 0) >>> 0 ? D + 1 | 0 : D) >> 21) + c | 0, r = (D = (t = (D = (2097151 & D) << 11 | k >>> 21) >>> 0 > (M = D + f | 0) >>> 0 ? t + 1 | 0 : t) >> 21) + m | 0, n = (H = y - (D = -2097152 & H) | 0) + ((2097151 & (r = (t = (2097151 & t) << 11 | M >>> 21) >>> 0 > (s = t + o | 0) >>> 0 ? r + 1 | 0 : r)) << 11 | s >>> 21) | 0, r = (N - ((D >>> 0 > y >>> 0) + u | 0) | 0) + (r >> 21) | 0, H = D = (r = n >>> 0 < H >>> 0 ? r + 1 | 0 : r) >> 21, U = (r = kA(p = (2097151 & r) << 11 | n >>> 21, D, 666643, 0)) + (D = 2097151 & U) | 0, r = h, y = r = D >>> 0 > U >>> 0 ? r + 1 | 0 : r, E[0 | A] = U, E[A + 1 | 0] = (255 & r) << 24 | U >>> 8, r = 2097151 & J, D = kA(p, H, 470296, 0) + r | 0, t = h, r = (y >> 21) + (r >>> 0 > D >>> 0 ? t + 1 | 0 : t) | 0, r = (N = (2097151 & y) << 11 | U >>> 21) >>> 0 > (J = N + D | 0) >>> 0 ? r + 1 | 0 : r, E[A + 4 | 0] = (2047 & r) << 21 | J >>> 11, D = r, t = J, E[A + 3 | 0] = (7 & r) << 29 | t >>> 3, E[A + 2 | 0] = 31 & ((65535 & y) << 16 | U >>> 16) | t << 5, y = 2097151 & G, G = kA(p, H, 654183, 0) + y | 0, r = h, J = (2097151 & D) << 11 | t >>> 21, D = (D >> 21) + (y = y >>> 0 > G >>> 0 ? r + 1 | 0 : r) | 0, r = D = (G = J + G | 0) >>> 0 < J >>> 0 ? D + 1 | 0 : D, E[A + 6 | 0] = (63 & r) << 26 | G >>> 6, y = G, G = 0, E[A + 5 | 0] = G << 13 | (1572864 & t) >>> 19 | y << 2, t = 2097151 & w, w = kA(p, H, -997805, -1) + t | 0, D = h, D = t >>> 0 > w >>> 0 ? D + 1 | 0 : D, G = (2097151 & (t = r)) << 11 | y >>> 21, t = (r >>= 21) + D | 0, t = (w = G + w | 0) >>> 0 < G >>> 0 ? t + 1 | 0 : t, E[A + 9 | 0] = (511 & t) << 23 | w >>> 9, E[A + 8 | 0] = (1 & t) << 31 | w >>> 1, D = 0, E[A + 7 | 0] = D << 18 | (2080768 & y) >>> 14 | w << 7, D = 2097151 & Y, y = kA(p, H, 136657, 0) + D | 0, r = h, r = D >>> 0 > y >>> 0 ? r + 1 | 0 : r, Y = (2097151 & (D = t)) << 11 | w >>> 21, D = r + (t = D >> 21) | 0, D = (y = Y + y | 0) >>> 0 < Y >>> 0 ? D + 1 | 0 : D, E[A + 12 | 0] = (4095 & D) << 20 | y >>> 12, t = y, E[A + 11 | 0] = (15 & D) << 28 | t >>> 4, y = 0, E[A + 10 | 0] = y << 15 | (1966080 & w) >>> 17 | t << 4, y = 2097151 & S, w = kA(p, H, -683901, -1) + y | 0, r = h, r = y >>> 0 > w >>> 0 ? r + 1 | 0 : r, y = D, D = r + (D >>= 21) | 0, D = (y = (d = w) + (w = (2097151 & y) << 11 | t >>> 21) | 0) >>> 0 < w >>> 0 ? D + 1 | 0 : D, E[A + 14 | 0] = (127 & D) << 25 | y >>> 7, w = 0, E[A + 13 | 0] = w << 12 | (1048576 & t) >>> 20 | y << 1, r = D >> 21, t = (D = (2097151 & D) << 11 | y >>> 21) >>> 0 > (w = D + (2097151 & F) | 0) >>> 0 ? r + 1 | 0 : r, E[A + 17 | 0] = (1023 & t) << 22 | w >>> 10, E[A + 16 | 0] = (3 & t) << 30 | w >>> 2, D = 0, E[A + 15 | 0] = D << 17 | (2064384 & y) >>> 15 | w << 6, r = t >> 21, r = (D = (2097151 & t) << 11 | w >>> 21) >>> 0 > (t = D + (2097151 & _) | 0) >>> 0 ? r + 1 | 0 : r, E[A + 20 | 0] = (8191 & r) << 19 | t >>> 13, E[A + 19 | 0] = (31 & r) << 27 | t >>> 5, y = (D = 2097151 & k) + (k = (2097151 & r) << 11 | t >>> 21) | 0, D = r >> 21, D = y >>> 0 < k >>> 0 ? D + 1 | 0 : D, k = y, E[A + 21 | 0] = y, _ = 0, E[A + 18 | 0] = _ << 14 | (1835008 & w) >>> 18 | t << 3, E[A + 22 | 0] = (255 & D) << 24 | y >>> 8, t = D >> 21, t = (y = (w = (2097151 & D) << 11 | y >>> 21) + (2097151 & M) | 0) >>> 0 < w >>> 0 ? t + 1 | 0 : t, E[A + 25 | 0] = (2047 & t) << 21 | y >>> 11, E[A + 24 | 0] = (7 & t) << 29 | y >>> 3, E[A + 23 | 0] = 31 & ((65535 & D) << 16 | k >>> 16) | y << 5, r = t >> 21, r = (D = (2097151 & t) << 11 | y >>> 21) >>> 0 > (t = D + (2097151 & s) | 0) >>> 0 ? r + 1 | 0 : r, E[A + 27 | 0] = (63 & r) << 26 | t >>> 6, w = 0, E[A + 26 | 0] = w << 13 | (1572864 & y) >>> 19 | t << 2, D = r >> 21, D = (r = (y = (2097151 & r) << 11 | t >>> 21) + (2097151 & n) | 0) >>> 0 < y >>> 0 ? D + 1 | 0 : D, E[A + 31 | 0] = (131071 & D) << 15 | r >>> 17, E[A + 30 | 0] = (511 & D) << 23 | r >>> 9, E[A + 29 | 0] = (1 & D) << 31 | r >>> 1, y = 0, E[A + 28 | 0] = y << 18 | (2080768 & t) >>> 14 | r << 7;
                                    }
                                    function S(A, I, g, C, B, Q) {
                                        var i, f = 0, e = 0, r = 0, D = 0, t = 0, y = 0, h = 0, n = 0, s = 0, k = 0, S = 0, _ = 0, M = 0, p = 0, J = 0, Y = 0, d = 0, K = 0, L = 0, u = 0, x = 0, m = 0, l = 0, z = 0, q = 0, X = 0, j = 0, T = 0, O = 0, V = 0, Z = 0, $ = 0, AA = 0, IA = 0, gA = 0, CA = 0, BA = 0, QA = 0;
                                        for(w = i = w - 592 | 0, p = -1, S = A + 32 | 0, k = 32, _ = 1; J = a[2672 + (t = k - 1 | 0) | 0], r = (t = ((e = a[t + S | 0]) ^ J) - 1 >> 8 & _) & (y = a[S + (k = k - 2 | 0) | 0]) - (D = a[k + 2672 | 0]) >> 8 | 255 & (e - J >>> 8 & _ | r), _ = t & (D ^ y) - 1 >> 8, k;);
                                        if (255 & r && !(rA(A) | !(((127 & (-1 ^ a[B + 31 | 0]) | a[B + 1 | 0] & a[B + 2 | 0] & a[B + 3 | 0] & a[B + 4 | 0] & a[B + 5 | 0] & a[B + 6 | 0] & a[B + 7 | 0] & a[B + 8 | 0] & a[B + 9 | 0] & a[B + 10 | 0] & a[B + 11 | 0] & a[B + 12 | 0] & a[B + 13 | 0] & a[B + 14 | 0] & a[B + 15 | 0] & a[B + 16 | 0] & a[B + 17 | 0] & a[B + 18 | 0] & a[B + 19 | 0] & a[B + 20 | 0] & a[B + 21 | 0] & a[B + 22 | 0] & a[B + 23 | 0] & a[B + 24 | 0] & a[B + 25 | 0] & a[B + 26 | 0] & a[B + 27 | 0] & a[B + 28 | 0] & a[B + 30 | 0] & a[B + 29 | 0] ^ 255) - 1 & 236 - a[0 | B] ^ -1) >>> 8 & 1) || rA(B) || U(t = i + 128 | 0, B))) {
                                            for(cA(e = i + 384 | 0), Q && R(e, 35136, 34, 0), R(e, A, 32, 0), R(e, B, 32, 0), R(e, I, g, C), N(e, g = i + 320 | 0), F(g), C = i + 8 | 0, B = 0, I = 0, w = f = w - 2272 | 0; e = g + (B >>> 3 | 0) | 0, E[(Q = f + 2016 | 0) + B | 0] = a[0 | e] >>> (6 & B) & 1, E[(r = Q) + (Q = 1 | B) | 0] = a[0 | e] >>> (7 & Q) & 1, 256 != (0 | (B = B + 2 | 0)););
                                            for(;;){
                                                I = (g = I) + 1 | 0;
                                                A: if (!(g >>> 0 > 254) && a[0 | (r = (B = f + 2016 | 0) + g | 0)]) {
                                                    I: if (B = E[0 | (D = I + B | 0)]) {
                                                        if ((0 | (B = (e = B << 1) + (Q = E[0 | r]) | 0)) <= 15) E[0 | r] = B, E[0 | D] = 0;
                                                        else {
                                                            if ((0 | (B = Q - e | 0)) < -15) break A;
                                                            for(E[0 | r] = B, B = I;;){
                                                                if (!a[0 | (Q = (f + 2016 | 0) + B | 0)]) {
                                                                    E[0 | Q] = 1;
                                                                    break I;
                                                                }
                                                                if (E[0 | Q] = 0, Q = B >>> 0 < 255, B = B + 1 | 0, !Q) break;
                                                            }
                                                        }
                                                    }
                                                    if (!(g >>> 0 > 253)) {
                                                        I: if (Q = E[0 | (y = (B = g + 2 | 0) + (f + 2016 | 0) | 0)]) {
                                                            if ((0 | (Q = (D = Q << 2) + (e = E[0 | r]) | 0)) >= 16) {
                                                                if ((0 | (Q = e - D | 0)) < -15) break A;
                                                                for(E[0 | r] = Q;;){
                                                                    if (a[0 | (Q = (f + 2016 | 0) + B | 0)]) {
                                                                        if (E[0 | Q] = 0, Q = B >>> 0 < 255, B = B + 1 | 0, Q) continue;
                                                                        break I;
                                                                    }
                                                                    break;
                                                                }
                                                                E[0 | Q] = 1;
                                                            } else E[0 | r] = Q, E[0 | y] = 0;
                                                        }
                                                        if (!(g >>> 0 > 252)) {
                                                            I: if (Q = E[0 | (y = (B = g + 3 | 0) + (f + 2016 | 0) | 0)]) {
                                                                if ((0 | (Q = (D = Q << 3) + (e = E[0 | r]) | 0)) >= 16) {
                                                                    if ((0 | (Q = e - D | 0)) < -15) break A;
                                                                    for(E[0 | r] = Q;;){
                                                                        if (a[0 | (Q = (f + 2016 | 0) + B | 0)]) {
                                                                            if (E[0 | Q] = 0, Q = B >>> 0 < 255, B = B + 1 | 0, Q) continue;
                                                                            break I;
                                                                        }
                                                                        break;
                                                                    }
                                                                    E[0 | Q] = 1;
                                                                } else E[0 | r] = Q, E[0 | y] = 0;
                                                            }
                                                            if (!(g >>> 0 > 251)) {
                                                                I: if (Q = E[0 | (y = (B = g + 4 | 0) + (f + 2016 | 0) | 0)]) {
                                                                    if ((0 | (Q = (D = Q << 4) + (e = E[0 | r]) | 0)) >= 16) {
                                                                        if ((0 | (Q = e - D | 0)) < -15) break A;
                                                                        for(E[0 | r] = Q;;){
                                                                            if (a[0 | (Q = (f + 2016 | 0) + B | 0)]) {
                                                                                if (E[0 | Q] = 0, Q = B >>> 0 < 255, B = B + 1 | 0, Q) continue;
                                                                                break I;
                                                                            }
                                                                            break;
                                                                        }
                                                                        E[0 | Q] = 1;
                                                                    } else E[0 | r] = Q, E[0 | y] = 0;
                                                                }
                                                                if (!(g >>> 0 > 250)) {
                                                                    I: if (Q = E[0 | (y = (B = g + 5 | 0) + (f + 2016 | 0) | 0)]) {
                                                                        if ((0 | (Q = (D = Q << 5) + (e = E[0 | r]) | 0)) >= 16) {
                                                                            if ((0 | (Q = e - D | 0)) < -15) break A;
                                                                            for(E[0 | r] = Q;;){
                                                                                if (a[0 | (Q = (f + 2016 | 0) + B | 0)]) {
                                                                                    if (E[0 | Q] = 0, Q = B >>> 0 < 255, B = B + 1 | 0, Q) continue;
                                                                                    break I;
                                                                                }
                                                                                break;
                                                                            }
                                                                            E[0 | Q] = 1;
                                                                        } else E[0 | r] = Q, E[0 | y] = 0;
                                                                    }
                                                                    if (!(g >>> 0 > 249) && (g = E[0 | (D = (B = g + 6 | 0) + (f + 2016 | 0) | 0)])) {
                                                                        if ((0 | (g = (e = g << 6) + (Q = E[0 | r]) | 0)) >= 16) {
                                                                            if ((0 | (g = Q - e | 0)) < -15) break A;
                                                                            for(E[0 | r] = g;;){
                                                                                if (a[0 | (g = (f + 2016 | 0) + B | 0)]) {
                                                                                    if (E[0 | g] = 0, g = B >>> 0 < 255, B = B + 1 | 0, g) continue;
                                                                                    break A;
                                                                                }
                                                                                break;
                                                                            }
                                                                            E[0 | g] = 1;
                                                                        } else E[0 | r] = g, E[0 | D] = 0;
                                                                    }
                                                                }
                                                            }
                                                        }
                                                    }
                                                }
                                                if (256 == (0 | I)) break;
                                            }
                                            for(B = 0; g = S + (B >>> 3 | 0) | 0, E[(I = f + 1760 | 0) + B | 0] = a[0 | g] >>> (6 & B) & 1, E[(Q = I) + (I = 1 | B) | 0] = a[0 | g] >>> (7 & I) & 1, 256 != (0 | (B = B + 2 | 0)););
                                            for(I = 0;;){
                                                I = (g = I) + 1 | 0;
                                                A: if (!(g >>> 0 > 254) && a[0 | (r = (B = f + 1760 | 0) + g | 0)]) {
                                                    I: if (B = E[0 | (D = I + B | 0)]) {
                                                        if ((0 | (B = (e = B << 1) + (Q = E[0 | r]) | 0)) <= 15) E[0 | r] = B, E[0 | D] = 0;
                                                        else {
                                                            if ((0 | (B = Q - e | 0)) < -15) break A;
                                                            for(E[0 | r] = B, B = I;;){
                                                                if (!a[0 | (Q = (f + 1760 | 0) + B | 0)]) {
                                                                    E[0 | Q] = 1;
                                                                    break I;
                                                                }
                                                                if (E[0 | Q] = 0, Q = B >>> 0 < 255, B = B + 1 | 0, !Q) break;
                                                            }
                                                        }
                                                    }
                                                    if (!(g >>> 0 > 253)) {
                                                        I: if (Q = E[0 | (y = (B = g + 2 | 0) + (f + 1760 | 0) | 0)]) {
                                                            if ((0 | (Q = (D = Q << 2) + (e = E[0 | r]) | 0)) >= 16) {
                                                                if ((0 | (Q = e - D | 0)) < -15) break A;
                                                                for(E[0 | r] = Q;;){
                                                                    if (a[0 | (Q = (f + 1760 | 0) + B | 0)]) {
                                                                        if (E[0 | Q] = 0, Q = B >>> 0 < 255, B = B + 1 | 0, Q) continue;
                                                                        break I;
                                                                    }
                                                                    break;
                                                                }
                                                                E[0 | Q] = 1;
                                                            } else E[0 | r] = Q, E[0 | y] = 0;
                                                        }
                                                        if (!(g >>> 0 > 252)) {
                                                            I: if (Q = E[0 | (y = (B = g + 3 | 0) + (f + 1760 | 0) | 0)]) {
                                                                if ((0 | (Q = (D = Q << 3) + (e = E[0 | r]) | 0)) >= 16) {
                                                                    if ((0 | (Q = e - D | 0)) < -15) break A;
                                                                    for(E[0 | r] = Q;;){
                                                                        if (a[0 | (Q = (f + 1760 | 0) + B | 0)]) {
                                                                            if (E[0 | Q] = 0, Q = B >>> 0 < 255, B = B + 1 | 0, Q) continue;
                                                                            break I;
                                                                        }
                                                                        break;
                                                                    }
                                                                    E[0 | Q] = 1;
                                                                } else E[0 | r] = Q, E[0 | y] = 0;
                                                            }
                                                            if (!(g >>> 0 > 251)) {
                                                                I: if (Q = E[0 | (y = (B = g + 4 | 0) + (f + 1760 | 0) | 0)]) {
                                                                    if ((0 | (Q = (D = Q << 4) + (e = E[0 | r]) | 0)) >= 16) {
                                                                        if ((0 | (Q = e - D | 0)) < -15) break A;
                                                                        for(E[0 | r] = Q;;){
                                                                            if (a[0 | (Q = (f + 1760 | 0) + B | 0)]) {
                                                                                if (E[0 | Q] = 0, Q = B >>> 0 < 255, B = B + 1 | 0, Q) continue;
                                                                                break I;
                                                                            }
                                                                            break;
                                                                        }
                                                                        E[0 | Q] = 1;
                                                                    } else E[0 | r] = Q, E[0 | y] = 0;
                                                                }
                                                                if (!(g >>> 0 > 250)) {
                                                                    I: if (Q = E[0 | (y = (B = g + 5 | 0) + (f + 1760 | 0) | 0)]) {
                                                                        if ((0 | (Q = (D = Q << 5) + (e = E[0 | r]) | 0)) >= 16) {
                                                                            if ((0 | (Q = e - D | 0)) < -15) break A;
                                                                            for(E[0 | r] = Q;;){
                                                                                if (a[0 | (Q = (f + 1760 | 0) + B | 0)]) {
                                                                                    if (E[0 | Q] = 0, Q = B >>> 0 < 255, B = B + 1 | 0, Q) continue;
                                                                                    break I;
                                                                                }
                                                                                break;
                                                                            }
                                                                            E[0 | Q] = 1;
                                                                        } else E[0 | r] = Q, E[0 | y] = 0;
                                                                    }
                                                                    if (!(g >>> 0 > 249) && (g = E[0 | (D = (B = g + 6 | 0) + (f + 1760 | 0) | 0)])) {
                                                                        if ((0 | (g = (e = g << 6) + (Q = E[0 | r]) | 0)) >= 16) {
                                                                            if ((0 | (g = Q - e | 0)) < -15) break A;
                                                                            for(E[0 | r] = g;;){
                                                                                if (a[0 | (g = (f + 1760 | 0) + B | 0)]) {
                                                                                    if (E[0 | g] = 0, g = B >>> 0 < 255, B = B + 1 | 0, g) continue;
                                                                                    break A;
                                                                                }
                                                                                break;
                                                                            }
                                                                            E[0 | g] = 1;
                                                                        } else E[0 | r] = g, E[0 | D] = 0;
                                                                    }
                                                                }
                                                            }
                                                        }
                                                    }
                                                }
                                                if (256 == (0 | I)) break;
                                            }
                                            for(W(B = f + 480 | 0, t), I = o[t + 36 >> 2], o[f + 192 >> 2] = o[t + 32 >> 2], o[f + 196 >> 2] = I, I = o[t + 28 >> 2], o[f + 184 >> 2] = o[t + 24 >> 2], o[f + 188 >> 2] = I, I = o[t + 20 >> 2], o[f + 176 >> 2] = o[t + 16 >> 2], o[f + 180 >> 2] = I, I = o[t + 12 >> 2], o[f + 168 >> 2] = o[t + 8 >> 2], o[f + 172 >> 2] = I, I = o[t + 4 >> 2], o[f + 160 >> 2] = o[t >> 2], o[f + 164 >> 2] = I, I = o[t + 52 >> 2], o[f + 208 >> 2] = o[t + 48 >> 2], o[f + 212 >> 2] = I, I = o[t + 60 >> 2], o[f + 216 >> 2] = o[t + 56 >> 2], o[f + 220 >> 2] = I, I = o[4 + (g = t - -64 | 0) >> 2], o[f + 224 >> 2] = o[g >> 2], o[f + 228 >> 2] = I, I = o[t + 76 >> 2], o[f + 232 >> 2] = o[t + 72 >> 2], o[f + 236 >> 2] = I, I = o[t + 44 >> 2], o[f + 200 >> 2] = o[t + 40 >> 2], o[f + 204 >> 2] = I, I = o[t + 92 >> 2], o[f + 248 >> 2] = o[t + 88 >> 2], o[f + 252 >> 2] = I, I = o[t + 100 >> 2], o[f + 256 >> 2] = o[t + 96 >> 2], o[f + 260 >> 2] = I, I = o[t + 108 >> 2], o[f + 264 >> 2] = o[t + 104 >> 2], o[f + 268 >> 2] = I, I = o[t + 116 >> 2], o[f + 272 >> 2] = o[t + 112 >> 2], o[f + 276 >> 2] = I, I = o[t + 84 >> 2], o[f + 240 >> 2] = o[t + 80 >> 2], o[f + 244 >> 2] = I, G(Q = f + 320 | 0, g = f + 160 | 0), H(f, Q, h = f + 440 | 0), H(f + 40 | 0, n = f + 360 | 0, s = f + 400 | 0), H(f + 80 | 0, s, h), H(f + 120 | 0, Q, n), b(Q, f, B), H(g, Q, h), H(Y = f + 200 | 0, n, s), H(d = f + 240 | 0, s, h), H(M = f + 280 | 0, Q, n), W(I = f + 640 | 0, g), b(Q, f, I), H(g, Q, h), H(Y, n, s), H(d, s, h), H(M, Q, n), W(I = f + 800 | 0, g), b(Q, f, I), H(g, Q, h), H(Y, n, s), H(d, s, h), H(M, Q, n), W(I = f + 960 | 0, g), b(Q, f, I), H(g, Q, h), H(Y, n, s), H(d, s, h), H(M, Q, n), W(I = f + 1120 | 0, g), b(Q, f, I), H(g, Q, h), H(Y, n, s), H(d, s, h), H(M, Q, n), W(I = f + 1280 | 0, g), b(Q, f, I), H(g, Q, h), H(Y, n, s), H(d, s, h), H(M, Q, n), W(I = f + 1440 | 0, g), b(Q, f, I), H(g, Q, h), H(Y, n, s), H(d, s, h), H(M, Q, n), W(f + 1600 | 0, g), o[C + 32 >> 2] = 0, o[C + 36 >> 2] = 0, o[C + 24 >> 2] = 0, o[C + 28 >> 2] = 0, o[C + 16 >> 2] = 0, o[C + 20 >> 2] = 0, o[C + 8 >> 2] = 0, o[C + 12 >> 2] = 0, o[C >> 2] = 0, o[C + 4 >> 2] = 0, o[C + 44 >> 2] = 0, o[C + 48 >> 2] = 0, o[(j = C + 40 | 0) >> 2] = 1, o[C + 52 >> 2] = 0, o[C + 56 >> 2] = 0, o[C + 60 >> 2] = 0, o[C + 64 >> 2] = 0, o[C + 68 >> 2] = 0, o[C + 72 >> 2] = 0, o[C + 84 >> 2] = 0, o[C + 88 >> 2] = 0, o[C + 76 >> 2] = 0, o[C + 80 >> 2] = 1, o[C + 92 >> 2] = 0, o[C + 96 >> 2] = 0, o[C + 100 >> 2] = 0, o[C + 104 >> 2] = 0, o[C + 108 >> 2] = 0, o[C + 112 >> 2] = 0, o[C + 116 >> 2] = 0, IA = C + 80 | 0, I = 255;;){
                                                A: {
                                                    I: {
                                                        if (!a[(g = f + 2016 | 0) + I | 0] && !a[(B = f + 1760 | 0) + I | 0]) {
                                                            if (!(a[(Q = g) + (g = I - 1 | 0) | 0] | a[g + B | 0])) break I;
                                                            I = g;
                                                        }
                                                        if ((0 | I) < 0) break A;
                                                        for(; G(B = f + 320 | 0, C), (0 | (Q = E[(g = I) + (f + 2016 | 0) | 0])) > 0 ? (H(I = f + 160 | 0, B, h), H(Y, n, s), H(d, s, h), H(M, B, n), b(B, I, (f + 480 | 0) + c((254 & Q) >>> 1 | 0, 160) | 0)) : (0 | Q) >= 0 || (H(I = f + 160 | 0, B = f + 320 | 0, h), H(Y, n, s), H(d, s, h), H(M, B, n), P(B, I, (f + 480 | 0) + c((0 - Q & 254) >>> 1 | 0, 160) | 0)), (0 | (q = E[g + (f + 1760 | 0) | 0])) > 0 ? (H(I = f + 160 | 0, B = f + 320 | 0, h), H(Y, n, s), H(d, s, h), H(M, B, n), v(B, I, c((254 & q) >>> 1 | 0, 120) + 1488 | 0)) : (0 | q) >= 0 || (H(f + 160 | 0, X = f + 320 | 0, h), H(Y, n, s), H(d, s, h), H(M, X, n), K = o[f + 160 >> 2], L = o[f + 200 >> 2], u = o[f + 164 >> 2], x = o[f + 204 >> 2], m = o[f + 168 >> 2], l = o[f + 208 >> 2], z = o[f + 172 >> 2], k = o[f + 212 >> 2], S = o[f + 176 >> 2], _ = o[f + 216 >> 2], p = o[f + 180 >> 2], J = o[f + 220 >> 2], r = o[f + 184 >> 2], y = o[f + 224 >> 2], D = o[f + 188 >> 2], e = o[f + 228 >> 2], t = o[f + 192 >> 2], Q = o[f + 232 >> 2], B = o[f + 236 >> 2], I = o[f + 196 >> 2], o[f + 396 >> 2] = B - I, o[f + 392 >> 2] = Q - t, o[f + 388 >> 2] = e - D, o[f + 384 >> 2] = y - r, o[f + 380 >> 2] = J - p, o[f + 376 >> 2] = _ - S, o[f + 372 >> 2] = k - z, o[f + 368 >> 2] = l - m, o[f + 364 >> 2] = x - u, o[f + 360 >> 2] = L - K, o[f + 356 >> 2] = I + B, o[f + 352 >> 2] = Q + t, o[f + 348 >> 2] = e + D, o[f + 344 >> 2] = r + y, o[f + 340 >> 2] = p + J, o[f + 336 >> 2] = S + _, o[f + 332 >> 2] = k + z, o[f + 328 >> 2] = m + l, o[f + 324 >> 2] = u + x, o[f + 320 >> 2] = K + L, H(s, X, 40 + (I = c((0 - q & 254) >>> 1 | 0, 120) + 1488 | 0) | 0), H(n, n, I), H(h, I + 80 | 0, M), gA = o[f + 276 >> 2], CA = o[f + 272 >> 2], q = o[f + 268 >> 2], X = o[f + 264 >> 2], r = o[f + 260 >> 2], y = o[f + 256 >> 2], D = o[f + 252 >> 2], e = o[f + 248 >> 2], t = o[f + 244 >> 2], Q = o[f + 240 >> 2], T = o[f + 360 >> 2], O = o[f + 400 >> 2], V = o[f + 364 >> 2], Z = o[f + 404 >> 2], $ = o[f + 368 >> 2], AA = o[f + 408 >> 2], K = o[f + 372 >> 2], L = o[f + 412 >> 2], u = o[f + 376 >> 2], x = o[f + 416 >> 2], m = o[f + 380 >> 2], l = o[f + 420 >> 2], z = o[f + 384 >> 2], k = o[f + 424 >> 2], S = o[f + 388 >> 2], _ = o[f + 428 >> 2], p = o[f + 392 >> 2], J = o[f + 432 >> 2], B = o[f + 396 >> 2], I = o[f + 436 >> 2], o[f + 396 >> 2] = B + I, o[f + 392 >> 2] = p + J, o[f + 388 >> 2] = S + _, o[f + 384 >> 2] = k + z, o[f + 380 >> 2] = m + l, o[f + 376 >> 2] = u + x, o[f + 372 >> 2] = K + L, o[f + 368 >> 2] = $ + AA, o[f + 364 >> 2] = V + Z, o[f + 360 >> 2] = T + O, o[f + 356 >> 2] = I - B, o[f + 352 >> 2] = J - p, o[f + 348 >> 2] = _ - S, o[f + 344 >> 2] = k - z, o[f + 340 >> 2] = l - m, o[f + 336 >> 2] = x - u, o[f + 332 >> 2] = L - K, o[f + 328 >> 2] = AA - $, o[f + 324 >> 2] = Z - V, o[f + 320 >> 2] = O - T, K = Q << 1, L = o[f + 440 >> 2], o[f + 400 >> 2] = K - L, u = t << 1, x = o[f + 444 >> 2], o[f + 404 >> 2] = u - x, m = e << 1, l = o[f + 448 >> 2], o[f + 408 >> 2] = m - l, z = D << 1, k = o[f + 452 >> 2], o[f + 412 >> 2] = z - k, S = y << 1, _ = o[f + 456 >> 2], o[f + 416 >> 2] = S - _, p = r << 1, J = o[f + 460 >> 2], o[f + 420 >> 2] = p - J, r = X << 1, y = o[f + 464 >> 2], o[f + 424 >> 2] = r - y, D = q << 1, e = o[f + 468 >> 2], o[f + 428 >> 2] = D - e, t = CA << 1, Q = o[f + 472 >> 2], o[f + 432 >> 2] = t - Q, B = gA << 1, I = o[f + 476 >> 2], o[f + 436 >> 2] = B - I, o[f + 440 >> 2] = K + L, o[f + 444 >> 2] = u + x, o[f + 448 >> 2] = m + l, o[f + 452 >> 2] = k + z, o[f + 456 >> 2] = S + _, o[f + 460 >> 2] = p + J, o[f + 464 >> 2] = r + y, o[f + 468 >> 2] = e + D, o[f + 472 >> 2] = Q + t, o[f + 476 >> 2] = I + B), H(C, f + 320 | 0, h), H(j, n, s), H(IA, s, h), I = g - 1 | 0, (0 | g) > 0;);
                                                        break A;
                                                    }
                                                    if (I = I - 2 | 0, g) continue;
                                                }
                                                break;
                                            }
                                            w = f + 2272 | 0, MA(I = i + 288 | 0, C), BA = -1, QA = nA(I, A), p = ((0 | A) == (0 | I) ? BA : QA) | eA(A, I, 32);
                                        }
                                        return w = i + 592 | 0, p;
                                    }
                                    function H(A, I, g) {
                                        var C, B, Q, i, E, a, f, e, r, D, t, y, w, n, s, k, F, S, H, G, _, M, p, N, J, U, Y, d, K, b, P, v, L, R, u, x, m, l, z, q, X, j, T, O, V, Z, W, $, AA, IA, gA, CA, BA, QA = 0, iA = 0, EA = 0, oA = 0, aA = 0, fA = 0, cA = 0, eA = 0, rA = 0, DA = 0, tA = 0, yA = 0, wA = 0, hA = 0, nA = 0, sA = 0, FA = 0, SA = 0, HA = 0, GA = 0, _A = 0, MA = 0, pA = 0, NA = 0, JA = 0;
                                        QA = kA(C = o[g + 4 >> 2], D = C >> 31, FA = (k = o[I + 20 >> 2]) << 1, P = FA >> 31), EA = h, iA = (wA = kA(nA = o[g >> 2], Q = nA >> 31, B = o[I + 24 >> 2], i = B >> 31)) + QA | 0, QA = h + EA | 0, QA = iA >>> 0 < wA >>> 0 ? QA + 1 | 0 : QA, rA = kA(E = o[g + 8 >> 2], w = E >> 31, wA = o[I + 16 >> 2], a = wA >> 31), EA = h + QA | 0, EA = (iA = rA + iA | 0) >>> 0 < rA >>> 0 ? EA + 1 | 0 : EA, QA = (rA = kA(t = o[g + 12 >> 2], F = t >> 31, N = (S = o[I + 12 >> 2]) << 1, v = N >> 31)) + iA | 0, iA = h + EA | 0, iA = QA >>> 0 < rA >>> 0 ? iA + 1 | 0 : iA, EA = (hA = kA(n = o[g + 16 >> 2], J = n >> 31, rA = o[I + 8 >> 2], f = rA >> 31)) + QA | 0, QA = h + iA | 0, QA = EA >>> 0 < hA >>> 0 ? QA + 1 | 0 : QA, iA = EA, EA = kA(H = o[g + 20 >> 2], L = H >> 31, U = (G = o[I + 4 >> 2]) << 1, R = U >> 31), QA = h + QA | 0, QA = (iA = iA + EA | 0) >>> 0 < EA >>> 0 ? QA + 1 | 0 : QA, Z = cA = o[g + 24 >> 2], EA = (DA = kA(cA, O = cA >> 31, hA = o[I >> 2], e = hA >> 31)) + iA | 0, iA = h + QA | 0, iA = EA >>> 0 < DA >>> 0 ? iA + 1 | 0 : iA, u = o[g + 28 >> 2], QA = (DA = kA(yA = c(u, 19), _ = yA >> 31, Y = (M = o[I + 36 >> 2]) << 1, x = Y >> 31)) + EA | 0, EA = h + iA | 0, EA = QA >>> 0 < DA >>> 0 ? EA + 1 | 0 : EA, _A = o[g + 32 >> 2], iA = (eA = kA(oA = c(_A, 19), s = oA >> 31, DA = o[I + 32 >> 2], r = DA >> 31)) + QA | 0, QA = h + EA | 0, QA = iA >>> 0 < eA >>> 0 ? QA + 1 | 0 : QA, W = o[g + 36 >> 2], g = kA(eA = c(W, 19), y = eA >> 31, d = (p = o[I + 28 >> 2]) << 1, m = d >> 31), QA = h + QA | 0, aA = I = g + iA | 0, g = I >>> 0 < g >>> 0 ? QA + 1 | 0 : QA, I = kA(wA, a, C, D), QA = h, iA = kA(nA, Q, k, l = k >> 31), EA = h + QA | 0, EA = (I = iA + I | 0) >>> 0 < iA >>> 0 ? EA + 1 | 0 : EA, QA = kA(E, w, S, z = S >> 31), iA = h + EA | 0, iA = (I = QA + I | 0) >>> 0 < QA >>> 0 ? iA + 1 | 0 : iA, EA = kA(rA, f, t, F), QA = h + iA | 0, QA = (I = EA + I | 0) >>> 0 < EA >>> 0 ? QA + 1 | 0 : QA, iA = kA(n, J, G, q = G >> 31), QA = h + QA | 0, QA = (I = iA + I | 0) >>> 0 < iA >>> 0 ? QA + 1 | 0 : QA, iA = kA(hA, e, H, L), QA = h + QA | 0, QA = (I = iA + I | 0) >>> 0 < iA >>> 0 ? QA + 1 | 0 : QA, iA = kA(cA = c(cA, 19), K = cA >> 31, M, X = M >> 31), EA = h + QA | 0, EA = (I = iA + I | 0) >>> 0 < iA >>> 0 ? EA + 1 | 0 : EA, QA = kA(DA, r, yA, _), iA = h + EA | 0, iA = (I = QA + I | 0) >>> 0 < QA >>> 0 ? iA + 1 | 0 : iA, EA = kA(oA, s, p, j = p >> 31), QA = h + iA | 0, QA = (I = EA + I | 0) >>> 0 < EA >>> 0 ? QA + 1 | 0 : QA, iA = kA(eA, y, B, i), QA = h + QA | 0, pA = I = iA + I | 0, SA = I >>> 0 < iA >>> 0 ? QA + 1 | 0 : QA, I = kA(C, D, N, v), QA = h, iA = kA(nA, Q, wA, a), QA = h + QA | 0, QA = (I = iA + I | 0) >>> 0 < iA >>> 0 ? QA + 1 | 0 : QA, iA = kA(rA, f, E, w), EA = h + QA | 0, EA = (I = iA + I | 0) >>> 0 < iA >>> 0 ? EA + 1 | 0 : EA, QA = kA(t, F, U, R), iA = h + EA | 0, iA = (I = QA + I | 0) >>> 0 < QA >>> 0 ? iA + 1 | 0 : iA, EA = kA(hA, e, n, J), QA = h + iA | 0, QA = (I = EA + I | 0) >>> 0 < EA >>> 0 ? QA + 1 | 0 : QA, iA = kA(b = c(H, 19), T = b >> 31, Y, x), QA = h + QA | 0, QA = (I = iA + I | 0) >>> 0 < iA >>> 0 ? QA + 1 | 0 : QA, iA = kA(DA, r, cA, K), QA = h + QA | 0, QA = (I = iA + I | 0) >>> 0 < iA >>> 0 ? QA + 1 | 0 : QA, iA = kA(yA, _, d, m), EA = h + QA | 0, EA = (I = iA + I | 0) >>> 0 < iA >>> 0 ? EA + 1 | 0 : EA, QA = kA(oA, s, B, i), iA = h + EA | 0, iA = (I = QA + I | 0) >>> 0 < QA >>> 0 ? iA + 1 | 0 : iA, EA = kA(eA, y, FA, P), QA = h + iA | 0, $ = I = EA + I | 0, AA = QA = I >>> 0 < EA >>> 0 ? QA + 1 | 0 : QA, IA = I = I + 33554432 | 0, gA = QA = I >>> 0 < 33554432 ? QA + 1 | 0 : QA, EA = (67108863 & QA) << 6 | I >>> 26, QA = (QA >> 26) + SA | 0, pA = I = EA + pA | 0, QA = I >>> 0 < EA >>> 0 ? QA + 1 | 0 : QA, CA = I = I + 16777216 | 0, QA = g + (iA = (EA = I >>> 0 < 16777216 ? QA + 1 | 0 : QA) >> 25) | 0, QA = (I = (EA = (33554431 & EA) << 7 | I >>> 25) + aA | 0) >>> 0 < EA >>> 0 ? QA + 1 | 0 : QA, HA = g = (iA = I) + 33554432 | 0, I = QA = g >>> 0 < 33554432 ? QA + 1 | 0 : QA, o[A + 24 >> 2] = iA - (-67108864 & g), g = kA(C, D, U, R), QA = h, iA = kA(nA, Q, rA, f), EA = h + QA | 0, EA = (g = iA + g | 0) >>> 0 < iA >>> 0 ? EA + 1 | 0 : EA, iA = (QA = g) + (g = kA(hA, e, E, w)) | 0, QA = h + EA | 0, QA = g >>> 0 > iA >>> 0 ? QA + 1 | 0 : QA, EA = kA(g = c(t, 19), GA = g >> 31, Y, x), QA = h + QA | 0, QA = (iA = EA + iA | 0) >>> 0 < EA >>> 0 ? QA + 1 | 0 : QA, EA = (aA = kA(DA, r, SA = c(n, 19), V = SA >> 31)) + iA | 0, iA = h + QA | 0, iA = EA >>> 0 < aA >>> 0 ? iA + 1 | 0 : iA, aA = kA(d, m, b, T), QA = h + iA | 0, QA = (EA = aA + EA | 0) >>> 0 < aA >>> 0 ? QA + 1 | 0 : QA, iA = (aA = kA(B, i, cA, K)) + EA | 0, EA = h + QA | 0, EA = iA >>> 0 < aA >>> 0 ? EA + 1 | 0 : EA, aA = kA(yA, _, FA, P), QA = h + EA | 0, QA = (iA = aA + iA | 0) >>> 0 < aA >>> 0 ? QA + 1 | 0 : QA, EA = kA(oA, s, wA, a), QA = h + QA | 0, QA = (iA = EA + iA | 0) >>> 0 < EA >>> 0 ? QA + 1 | 0 : QA, EA = (aA = kA(eA, y, N, v)) + iA | 0, iA = h + QA | 0, tA = EA, NA = EA >>> 0 < aA >>> 0 ? iA + 1 | 0 : iA, QA = kA(hA, e, C, D), iA = h, EA = (aA = kA(nA, Q, G, q)) + QA | 0, QA = h + iA | 0, QA = EA >>> 0 < aA >>> 0 ? QA + 1 | 0 : QA, aA = iA = c(E, 19), iA = (fA = kA(iA, MA = iA >> 31, M, X)) + EA | 0, EA = h + QA | 0, EA = iA >>> 0 < fA >>> 0 ? EA + 1 | 0 : EA, fA = kA(DA, r, g, GA), QA = h + EA | 0, QA = (iA = fA + iA | 0) >>> 0 < fA >>> 0 ? QA + 1 | 0 : QA, EA = kA(SA, V, p, j), QA = h + QA | 0, QA = (iA = EA + iA | 0) >>> 0 < EA >>> 0 ? QA + 1 | 0 : QA, EA = (fA = kA(B, i, b, T)) + iA | 0, iA = h + QA | 0, iA = EA >>> 0 < fA >>> 0 ? iA + 1 | 0 : iA, fA = kA(cA, K, k, l), QA = h + iA | 0, QA = (EA = fA + EA | 0) >>> 0 < fA >>> 0 ? QA + 1 | 0 : QA, iA = (fA = kA(wA, a, yA, _)) + EA | 0, EA = h + QA | 0, EA = iA >>> 0 < fA >>> 0 ? EA + 1 | 0 : EA, fA = kA(oA, s, S, z), QA = h + EA | 0, QA = (iA = fA + iA | 0) >>> 0 < fA >>> 0 ? QA + 1 | 0 : QA, EA = kA(eA, y, rA, f), QA = h + QA | 0, JA = iA = EA + iA | 0, fA = iA >>> 0 < EA >>> 0 ? QA + 1 | 0 : QA, QA = kA(QA = c(C, 19), QA >> 31, Y, x), iA = h, EA = kA(nA, Q, hA, e), iA = h + iA | 0, iA = (QA = EA + QA | 0) >>> 0 < EA >>> 0 ? iA + 1 | 0 : iA, EA = (aA = kA(DA, r, aA, MA)) + QA | 0, QA = h + iA | 0, g = (iA = kA(g, GA, d, m)) + EA | 0, EA = h + (EA >>> 0 < aA >>> 0 ? QA + 1 | 0 : QA) | 0, EA = g >>> 0 < iA >>> 0 ? EA + 1 | 0 : EA, iA = kA(B, i, SA, V), QA = h + EA | 0, QA = (g = iA + g | 0) >>> 0 < iA >>> 0 ? QA + 1 | 0 : QA, iA = kA(FA, P, b, T), QA = h + QA | 0, QA = (g = iA + g | 0) >>> 0 < iA >>> 0 ? QA + 1 | 0 : QA, EA = kA(wA, a, cA, K), iA = h + QA | 0, iA = (g = EA + g | 0) >>> 0 < EA >>> 0 ? iA + 1 | 0 : iA, EA = kA(yA, _, N, v), QA = h + iA | 0, QA = (g = EA + g | 0) >>> 0 < EA >>> 0 ? QA + 1 | 0 : QA, iA = kA(oA, s, rA, f), EA = h + QA | 0, EA = (g = iA + g | 0) >>> 0 < iA >>> 0 ? EA + 1 | 0 : EA, iA = kA(eA, y, U, R), QA = h + EA | 0, aA = g = iA + g | 0, GA = QA = g >>> 0 < iA >>> 0 ? QA + 1 | 0 : QA, MA = g = g + 33554432 | 0, BA = QA = g >>> 0 < 33554432 ? QA + 1 | 0 : QA, iA = (EA = QA >> 26) + fA | 0, fA = g = (QA = (67108863 & QA) << 6 | g >>> 26) + JA | 0, QA = g >>> 0 < QA >>> 0 ? iA + 1 | 0 : iA, JA = g = g + 16777216 | 0, iA = (33554431 & (QA = g >>> 0 < 16777216 ? QA + 1 | 0 : QA)) << 7 | g >>> 25, QA = (QA >> 25) + NA | 0, QA = (g = iA + tA | 0) >>> 0 < iA >>> 0 ? QA + 1 | 0 : QA, NA = iA = (EA = g) + 33554432 | 0, g = QA = iA >>> 0 < 33554432 ? QA + 1 | 0 : QA, o[A + 8 >> 2] = EA - (-67108864 & iA), QA = kA(B, i, C, D), EA = h, iA = (tA = kA(nA, Q, p, j)) + QA | 0, QA = h + EA | 0, QA = iA >>> 0 < tA >>> 0 ? QA + 1 | 0 : QA, EA = kA(E, w, k, l), QA = h + QA | 0, QA = (iA = EA + iA | 0) >>> 0 < EA >>> 0 ? QA + 1 | 0 : QA, EA = kA(wA, a, t, F), QA = h + QA | 0, QA = (iA = EA + iA | 0) >>> 0 < EA >>> 0 ? QA + 1 | 0 : QA, tA = kA(n, J, S, z), EA = h + QA | 0, EA = (iA = tA + iA | 0) >>> 0 < tA >>> 0 ? EA + 1 | 0 : EA, QA = (tA = kA(rA, f, H, L)) + iA | 0, iA = h + EA | 0, iA = QA >>> 0 < tA >>> 0 ? iA + 1 | 0 : iA, EA = (tA = kA(G, q, Z, O)) + QA | 0, QA = h + iA | 0, QA = EA >>> 0 < tA >>> 0 ? QA + 1 | 0 : QA, iA = EA, EA = kA(hA, e, u, tA = u >> 31), QA = h + QA | 0, QA = (iA = iA + EA | 0) >>> 0 < EA >>> 0 ? QA + 1 | 0 : QA, EA = kA(oA, s, M, X), QA = h + QA | 0, QA = (iA = EA + iA | 0) >>> 0 < EA >>> 0 ? QA + 1 | 0 : QA, sA = kA(eA, y, DA, r), EA = h + QA | 0, QA = I >> 26, I = (HA = (67108863 & I) << 6 | HA >>> 26) + (iA = sA + iA | 0) | 0, iA = QA + (iA >>> 0 < sA >>> 0 ? EA + 1 | 0 : EA) | 0, QA = (EA = I) >>> 0 < HA >>> 0 ? iA + 1 | 0 : iA, HA = iA = EA + 16777216 | 0, I = QA = iA >>> 0 < 16777216 ? QA + 1 | 0 : QA, o[A + 28 >> 2] = EA - (-33554432 & iA), QA = kA(rA, f, C, D), iA = h, sA = kA(nA, Q, S, z), EA = h + iA | 0, EA = (QA = sA + QA | 0) >>> 0 < sA >>> 0 ? EA + 1 | 0 : EA, sA = kA(E, w, G, q), iA = h + EA | 0, iA = (QA = sA + QA | 0) >>> 0 < sA >>> 0 ? iA + 1 | 0 : iA, EA = (sA = kA(hA, e, t, F)) + QA | 0, QA = h + iA | 0, QA = EA >>> 0 < sA >>> 0 ? QA + 1 | 0 : QA, iA = EA, EA = kA(SA, V, M, X), QA = h + QA | 0, QA = (iA = iA + EA | 0) >>> 0 < EA >>> 0 ? QA + 1 | 0 : QA, EA = kA(DA, r, b, T), QA = h + QA | 0, QA = (iA = EA + iA | 0) >>> 0 < EA >>> 0 ? QA + 1 | 0 : QA, iA = (cA = kA(cA, K, p, j)) + iA | 0, EA = h + QA | 0, QA = (yA = kA(B, i, yA, _)) + iA | 0, iA = h + (iA >>> 0 < cA >>> 0 ? EA + 1 | 0 : EA) | 0, EA = (oA = kA(oA, s, k, l)) + QA | 0, QA = h + (QA >>> 0 < yA >>> 0 ? iA + 1 | 0 : iA) | 0, QA = EA >>> 0 < oA >>> 0 ? QA + 1 | 0 : QA, iA = EA, EA = kA(eA, y, wA, a), QA = h + QA | 0, oA = iA = iA + EA | 0, QA = (QA = iA >>> 0 < EA >>> 0 ? QA + 1 | 0 : QA) + (iA = g >> 26) | 0, oA = g = oA + (EA = (67108863 & g) << 6 | NA >>> 26) | 0, QA = g >>> 0 < EA >>> 0 ? QA + 1 | 0 : QA, yA = iA = g + 16777216 | 0, g = EA = iA >>> 0 < 16777216 ? QA + 1 | 0 : QA, o[A + 12 >> 2] = oA - (-33554432 & iA), QA = kA(C, D, d, m), EA = h, iA = (oA = kA(nA, Q, DA, r)) + QA | 0, QA = h + EA | 0, QA = iA >>> 0 < oA >>> 0 ? QA + 1 | 0 : QA, EA = kA(B, i, E, w), QA = h + QA | 0, QA = (iA = EA + iA | 0) >>> 0 < EA >>> 0 ? QA + 1 | 0 : QA, oA = kA(t, F, FA, P), EA = h + QA | 0, EA = (iA = oA + iA | 0) >>> 0 < oA >>> 0 ? EA + 1 | 0 : EA, QA = (oA = kA(wA, a, n, J)) + iA | 0, iA = h + EA | 0, iA = QA >>> 0 < oA >>> 0 ? iA + 1 | 0 : iA, EA = (oA = kA(N, v, H, L)) + QA | 0, QA = h + iA | 0, QA = EA >>> 0 < oA >>> 0 ? QA + 1 | 0 : QA, iA = EA, EA = kA(rA, f, Z, O), QA = h + QA | 0, QA = (iA = iA + EA | 0) >>> 0 < EA >>> 0 ? QA + 1 | 0 : QA, EA = kA(u, tA, U, R), QA = h + QA | 0, QA = (iA = EA + iA | 0) >>> 0 < EA >>> 0 ? QA + 1 | 0 : QA, iA = (FA = kA(hA, e, oA = _A, cA = oA >> 31)) + iA | 0, EA = h + QA | 0, QA = (eA = kA(eA, y, Y, x)) + iA | 0, iA = h + (iA >>> 0 < FA >>> 0 ? EA + 1 | 0 : EA) | 0, iA = QA >>> 0 < eA >>> 0 ? iA + 1 | 0 : iA, _A = QA, QA = (QA = I >> 25) + iA | 0, QA = (I = _A + (EA = (33554431 & I) << 7 | HA >>> 25) | 0) >>> 0 < EA >>> 0 ? QA + 1 | 0 : QA, eA = iA = (EA = I) + 33554432 | 0, I = QA = iA >>> 0 < 33554432 ? QA + 1 | 0 : QA, o[A + 32 >> 2] = EA - (-67108864 & iA), iA = g >> 25, g = (yA = (33554431 & g) << 7 | yA >>> 25) + ($ - (QA = -67108864 & IA) | 0) | 0, QA = iA + (AA - ((QA >>> 0 > $ >>> 0) + gA | 0) | 0) | 0, QA = g >>> 0 < yA >>> 0 ? QA + 1 | 0 : QA, QA = ((67108863 & (QA = (g = (iA = g) + 33554432 | 0) >>> 0 < 33554432 ? QA + 1 | 0 : QA)) << 6 | g >>> 26) + (EA = pA - (-33554432 & CA) | 0) | 0, o[A + 20 >> 2] = QA, o[A + 16 >> 2] = iA - (-67108864 & g), g = kA(DA, r, C, D), QA = h, iA = kA(nA, Q, M, X), QA = h + QA | 0, QA = (g = iA + g | 0) >>> 0 < iA >>> 0 ? QA + 1 | 0 : QA, EA = kA(E, w, p, j), iA = h + QA | 0, iA = (g = EA + g | 0) >>> 0 < EA >>> 0 ? iA + 1 | 0 : iA, QA = kA(B, i, t, F), EA = h + iA | 0, EA = (g = QA + g | 0) >>> 0 < QA >>> 0 ? EA + 1 | 0 : EA, iA = kA(n, J, k, l), QA = h + EA | 0, QA = (g = iA + g | 0) >>> 0 < iA >>> 0 ? QA + 1 | 0 : QA, iA = kA(wA, a, H, L), QA = h + QA | 0, QA = (g = iA + g | 0) >>> 0 < iA >>> 0 ? QA + 1 | 0 : QA, iA = kA(S, z, Z, O), QA = h + QA | 0, QA = (g = iA + g | 0) >>> 0 < iA >>> 0 ? QA + 1 | 0 : QA, EA = kA(rA, f, u, tA), iA = h + QA | 0, iA = (g = EA + g | 0) >>> 0 < EA >>> 0 ? iA + 1 | 0 : iA, QA = kA(oA, cA, G, q), EA = h + iA | 0, EA = (g = QA + g | 0) >>> 0 < QA >>> 0 ? EA + 1 | 0 : EA, iA = kA(hA, e, W, W >> 31), QA = h + EA | 0, QA = (QA = (g = iA + g | 0) >>> 0 < iA >>> 0 ? QA + 1 | 0 : QA) + (iA = I >> 26) | 0, QA = (I = (EA = g) + (g = (67108863 & I) << 6 | eA >>> 26) | 0) >>> 0 < g >>> 0 ? QA + 1 | 0 : QA, QA = (I = (g = I) + 16777216 | 0) >>> 0 < 16777216 ? QA + 1 | 0 : QA, o[A + 36 >> 2] = g - (-33554432 & I), EA = fA - (-33554432 & JA) | 0, iA = aA - (g = -67108864 & MA) | 0, nA = GA - ((g >>> 0 > aA >>> 0) + BA | 0) | 0, I = (g = kA((33554431 & (g = QA)) << 7 | I >>> 25, QA >>= 25, 19, 0)) + iA | 0, iA = h + nA | 0, QA = I >>> 0 < g >>> 0 ? iA + 1 | 0 : iA, QA = ((67108863 & (QA = (I = (g = I) + 33554432 | 0) >>> 0 < 33554432 ? QA + 1 | 0 : QA)) << 6 | I >>> 26) + EA | 0, o[A + 4 >> 2] = QA, o[A >> 2] = g - (-67108864 & I);
                                    }
                                    function G(A, I) {
                                        var g, C, B, Q, i, E, a, f, e, r, D, t, y, n, s, k, F, S, H, G, _, p, N, J = 0, U = 0, Y = 0, d = 0, K = 0, b = 0, P = 0, v = 0, L = 0, R = 0, u = 0, x = 0, m = 0, l = 0, z = 0, q = 0, X = 0, j = 0, T = 0, O = 0, V = 0, Z = 0, W = 0, $ = 0, AA = 0, IA = 0, gA = 0, CA = 0, BA = 0, QA = 0, iA = 0, EA = 0, oA = 0, aA = 0, fA = 0, cA = 0;
                                        w = g = w - 48 | 0, M(A, I), M(A + 80 | 0, I + 40 | 0), J = kA(l = (W = o[I + 92 >> 2]) << 1, i = l >> 31, v = (d = o[I + 84 >> 2]) << 1, C = v >> 31), Y = h, CA = X = o[I + 88 >> 2], U = (u = kA(X, T = X >> 31, X, T)) + J | 0, J = h + Y | 0, J = U >>> 0 < u >>> 0 ? J + 1 | 0 : J, Y = kA(K = o[I + 96 >> 2], E = K >> 31, u = (L = o[I + 80 >> 2]) << 1, B = u >> 31), J = h + J | 0, J = (U = Y + U | 0) >>> 0 < Y >>> 0 ? J + 1 | 0 : J, gA = o[I + 108 >> 2], Y = kA(x = c(gA, 38), D = x >> 31, gA, n = gA >> 31), J = h + J | 0, J = (U = Y + U | 0) >>> 0 < Y >>> 0 ? J + 1 | 0 : J, Y = U, $ = o[I + 112 >> 2], R = kA(b = c($, 19), a = b >> 31, U = (O = o[I + 104 >> 2]) << 1, U >> 31), U = h + J | 0, U = (Y = Y + R | 0) >>> 0 < R >>> 0 ? U + 1 | 0 : U, iA = o[I + 116 >> 2], J = kA(R = c(iA, 38), Q = R >> 31, j = (V = o[I + 100 >> 2]) << 1, e = j >> 31), U = h + U | 0, EA = J = (J >>> 0 > (Y = J + Y | 0) >>> 0 ? U + 1 | 0 : U) << 1 | Y >>> 31, oA = Y = 33554432 + (s = Y << 1) | 0, aA = J = Y >>> 0 < 33554432 ? J + 1 | 0 : J, P = (67108863 & J) << 6 | Y >>> 26, Z = J >> 26, J = kA(v, C, K, E), Y = h, U = (AA = kA(X <<= 1, r = X >> 31, W, k = W >> 31)) + J | 0, J = h + Y | 0, J = U >>> 0 < AA >>> 0 ? J + 1 | 0 : J, Y = (AA = kA(V, t = V >> 31, u, B)) + U | 0, U = h + J | 0, U = Y >>> 0 < AA >>> 0 ? U + 1 | 0 : U, BA = kA(b, a, AA = gA << 1, F = AA >> 31), J = h + U | 0, J = (Y = BA + Y | 0) >>> 0 < BA >>> 0 ? J + 1 | 0 : J, U = kA(R, Q, O, f = O >> 31), J = h + J | 0, U = (U = (U >>> 0 > (Y = U + Y | 0) >>> 0 ? J + 1 | 0 : J) << 1 | Y >>> 31) + Z | 0, BA = Y = (J = Y << 1) + P | 0, J = U = J >>> 0 > Y >>> 0 ? U + 1 | 0 : U, fA = Y = Y + 16777216 | 0, P = (33554431 & (J = Y >>> 0 < 16777216 ? J + 1 | 0 : J)) << 7 | Y >>> 25, Z = J >> 25, J = kA(l, i, W, k), Y = h, U = (m = kA(K, E, X, r)) + J | 0, J = h + Y | 0, J = U >>> 0 < m >>> 0 ? J + 1 | 0 : J, Y = kA(v, C, j, e), J = h + J | 0, J = (U = Y + U | 0) >>> 0 < Y >>> 0 ? J + 1 | 0 : J, Y = (m = kA(u, B, O, f)) + U | 0, U = h + J | 0, U = Y >>> 0 < m >>> 0 ? U + 1 | 0 : U, m = kA(b, a, $, y = $ >> 31), J = h + U | 0, J = (Y = m + Y | 0) >>> 0 < m >>> 0 ? J + 1 | 0 : J, m = kA(R, Q, AA, F), U = h + J | 0, U = ((Y = m + Y | 0) >>> 0 < m >>> 0 ? U + 1 | 0 : U) << 1 | Y >>> 31, Y = (J = P) + (P = Y << 1) | 0, J = U + Z | 0, J = Y >>> 0 < P >>> 0 ? J + 1 | 0 : J, Z = Y, m = U = Y + 33554432 | 0, Y = J = U >>> 0 < 33554432 ? J + 1 | 0 : J, o[A + 144 >> 2] = Z - (-67108864 & U), Z = kA(J = c(V, 38), J >> 31, V, t), P = h, L = kA(J = L, U = J >> 31, J, U), U = h + P | 0, U = (J = L + Z | 0) >>> 0 < L >>> 0 ? U + 1 | 0 : U, P = (IA = kA(L = c(O, 19), S = L >> 31, Z = K << 1, H = Z >> 31)) + J | 0, J = h + U | 0, J = P >>> 0 < IA >>> 0 ? J + 1 | 0 : J, U = P, P = kA(l, i, x, D), J = h + J | 0, J = (U = U + P | 0) >>> 0 < P >>> 0 ? J + 1 | 0 : J, P = (IA = kA(b, a, X, r)) + U | 0, U = h + J | 0, U = P >>> 0 < IA >>> 0 ? U + 1 | 0 : U, IA = kA(v, C, R, Q), J = h + U | 0, IA = J = ((P = IA + P | 0) >>> 0 < IA >>> 0 ? J + 1 | 0 : J) << 1 | P >>> 31, p = U = (P = 33554432 + (G = P << 1) | 0) >>> 0 < 33554432 ? J + 1 | 0 : J, QA = (67108863 & U) << 6 | P >>> 26, cA = U >> 26, J = kA(L, S, j, e), z = h, q = d, U = (d = kA(u, B, d, _ = d >> 31)) + J | 0, J = h + z | 0, J = U >>> 0 < d >>> 0 ? J + 1 | 0 : J, d = (z = kA(K, E, x, D)) + U | 0, U = h + J | 0, U = d >>> 0 < z >>> 0 ? U + 1 | 0 : U, z = kA(b, a, l, i), J = h + U | 0, J = (d = z + d | 0) >>> 0 < z >>> 0 ? J + 1 | 0 : J, z = kA(R, Q, CA, T), U = h + J | 0, U = ((d = z + d | 0) >>> 0 < z >>> 0 ? U + 1 | 0 : U) << 1 | d >>> 31, d = (J = QA) + (QA = d << 1) | 0, J = U + cA | 0, J = d >>> 0 < QA >>> 0 ? J + 1 | 0 : J, cA = d, QA = d = d + 16777216 | 0, N = (33554431 & (J = d >>> 0 < 16777216 ? J + 1 | 0 : J)) << 7 | d >>> 25, z = J >> 25, J = kA(u, B, CA, T), d = h, U = (q = kA(v, C, q, _)) + J | 0, J = h + d | 0, d = (L = kA(L, S, O, f)) + U | 0, U = h + (U >>> 0 < q >>> 0 ? J + 1 | 0 : J) | 0, U = d >>> 0 < L >>> 0 ? U + 1 | 0 : U, L = kA(j, e, x, D), J = h + U | 0, J = (d = L + d | 0) >>> 0 < L >>> 0 ? J + 1 | 0 : J, U = d, d = kA(b, a, Z, H), J = h + J | 0, J = (U = U + d | 0) >>> 0 < d >>> 0 ? J + 1 | 0 : J, d = (L = kA(R, Q, l, i)) + U | 0, U = h + J | 0, J = (J = (d >>> 0 < L >>> 0 ? U + 1 | 0 : U) << 1 | d >>> 31) + z | 0, q = d = (U = d << 1) + N | 0, J = U >>> 0 > d >>> 0 ? J + 1 | 0 : J, d = (L = d + 33554432 | 0) >>> 0 < 33554432 ? J + 1 | 0 : J, o[A + 128 >> 2] = q - (-67108864 & L), J = kA(X, r, V, t), U = h, q = kA(K, E, l, i), U = h + U | 0, U = (J = q + J | 0) >>> 0 < q >>> 0 ? U + 1 | 0 : U, q = (z = kA(v, C, O, f)) + J | 0, J = h + U | 0, J = q >>> 0 < z >>> 0 ? J + 1 | 0 : J, z = kA(u, B, gA, n), U = h + J | 0, U = (q = z + q | 0) >>> 0 < z >>> 0 ? U + 1 | 0 : U, z = kA(R, Q, $, y), J = h + U | 0, J = (U = Y >> 26) + (((q = z + q | 0) >>> 0 < z >>> 0 ? J + 1 | 0 : J) << 1 | q >>> 31) | 0, J = (Y = (m = (67108863 & Y) << 6 | m >>> 26) + (q << 1) | 0) >>> 0 < m >>> 0 ? J + 1 | 0 : J, m = Y, U = J, q = J = Y + 16777216 | 0, Y = U = J >>> 0 < 16777216 ? U + 1 | 0 : U, o[A + 148 >> 2] = m - (-33554432 & J), J = kA(u, B, W, k), W = h, U = (T = kA(v, C, CA, T)) + J | 0, J = h + W | 0, J = U >>> 0 < T >>> 0 ? J + 1 | 0 : J, x = kA(O, f, x, D), J = h + J | 0, J = (U = x + U | 0) >>> 0 < x >>> 0 ? J + 1 | 0 : J, b = (x = kA(b, a, j, e)) + U | 0, U = h + J | 0, U = b >>> 0 < x >>> 0 ? U + 1 | 0 : U, J = b, b = kA(R, Q, K, E), U = h + U | 0, U = ((J = J + b | 0) >>> 0 < b >>> 0 ? U + 1 | 0 : U) << 1, b = J, J = (J = U | J >>> 31) + (U = d >> 26) | 0, J = (d = (m = b << 1) + (b = (67108863 & d) << 6 | L >>> 26) | 0) >>> 0 < b >>> 0 ? J + 1 | 0 : J, b = d, x = U = d + 16777216 | 0, d = J = U >>> 0 < 16777216 ? J + 1 | 0 : J, o[A + 132 >> 2] = b - (-33554432 & U), J = kA(O, f, X, r), b = h, U = (K = kA(K, E, K, E)) + J | 0, J = h + b | 0, J = U >>> 0 < K >>> 0 ? J + 1 | 0 : J, K = kA(l, i, j, e), J = h + J | 0, J = (U = K + U | 0) >>> 0 < K >>> 0 ? J + 1 | 0 : J, K = kA(v, C, AA, F), J = h + J | 0, J = (U = K + U | 0) >>> 0 < K >>> 0 ? J + 1 | 0 : J, K = (b = kA(u, B, $, y)) + U | 0, U = h + J | 0, U = K >>> 0 < b >>> 0 ? U + 1 | 0 : U, J = K, K = kA(K = R, Q, R = iA, j = R >> 31), U = h + U | 0, U = ((J = J + K | 0) >>> 0 < K >>> 0 ? U + 1 | 0 : U) << 1, K = J, J = (J = U | J >>> 31) + (U = Y >> 25) | 0, J = (Y = (b = K << 1) + (K = (33554431 & Y) << 7 | q >>> 25) | 0) >>> 0 < K >>> 0 ? J + 1 | 0 : J, K = Y, b = U = Y + 33554432 | 0, Y = J = U >>> 0 < 33554432 ? J + 1 | 0 : J, o[A + 152 >> 2] = K - (-67108864 & U), U = s - (J = -67108864 & oA) | 0, K = EA - ((J >>> 0 > s >>> 0) + aA | 0) | 0, J = d >> 25, d = (x = (33554431 & d) << 7 | x >>> 25) + U | 0, U = J + K | 0, K = d, J = U = d >>> 0 < x >>> 0 ? U + 1 | 0 : U, J = ((67108863 & (J = (d = d + 33554432 | 0) >>> 0 < 33554432 ? J + 1 | 0 : J)) << 6 | d >>> 26) + (T = BA - (-33554432 & fA) | 0) | 0, o[A + 140 >> 2] = J, o[A + 136 >> 2] = K - (-67108864 & d), J = kA(l, i, O, f), U = h, d = kA(V, t, Z, H), U = h + U | 0, U = (J = d + J | 0) >>> 0 < d >>> 0 ? U + 1 | 0 : U, d = (l = kA(X, r, gA, n)) + J | 0, J = h + U | 0, J = d >>> 0 < l >>> 0 ? J + 1 | 0 : J, v = kA(v, C, $, y), U = h + J | 0, U = (d = v + d | 0) >>> 0 < v >>> 0 ? U + 1 | 0 : U, v = kA(u, B, R, j), J = h + U | 0, J = (J = ((d = v + d | 0) >>> 0 < v >>> 0 ? J + 1 | 0 : J) << 1 | d >>> 31) + (U = Y >> 26) | 0, U = (Y = (K = d << 1) + (d = (67108863 & Y) << 6 | b >>> 26) | 0) >>> 0 < d >>> 0 ? J + 1 | 0 : J, U = (J = Y + 16777216 | 0) >>> 0 < 16777216 ? U + 1 | 0 : U, o[A + 156 >> 2] = Y - (-33554432 & J), d = cA - (-33554432 & QA) | 0, v = G - (Y = -67108864 & P) | 0, u = IA - ((Y >>> 0 > G >>> 0) + p | 0) | 0, Y = kA((33554431 & U) << 7 | J >>> 25, U >> 25, 19, 0), U = h + u | 0, U = (J = Y + v | 0) >>> 0 < Y >>> 0 ? U + 1 | 0 : U, Y = J, U = ((67108863 & (U = (J = J + 33554432 | 0) >>> 0 < 33554432 ? U + 1 | 0 : U)) << 6 | J >>> 26) + d | 0, o[A + 124 >> 2] = U, o[A + 120 >> 2] = Y - (-67108864 & J), J = o[I + 40 >> 2], U = o[I + 44 >> 2], Y = o[I + 4 >> 2], d = o[I + 48 >> 2], v = o[I + 8 >> 2], u = o[I + 52 >> 2], R = o[I + 12 >> 2], l = o[I + 56 >> 2], K = o[I + 16 >> 2], b = o[I + 60 >> 2], O = o[I + 20 >> 2], j = o[I - -64 >> 2], X = o[I + 24 >> 2], x = o[I + 68 >> 2], T = o[I + 28 >> 2], V = o[I + 72 >> 2], $ = o[I + 32 >> 2], CA = o[I >> 2], o[A + 76 >> 2] = o[I + 76 >> 2] + o[I + 36 >> 2], o[A + 72 >> 2] = V + $, o[A + 68 >> 2] = x + T, o[(gA = A - -64 | 0) >> 2] = X + j, o[A + 60 >> 2] = b + O, o[A + 56 >> 2] = K + l, o[A + 52 >> 2] = R + u, o[A + 48 >> 2] = d + v, o[A + 44 >> 2] = U + Y, o[(I = A + 40 | 0) >> 2] = J + CA, M(g, I), J = o[A + 80 >> 2], U = o[A + 4 >> 2], Y = o[A + 84 >> 2], d = o[A + 8 >> 2], v = o[A + 88 >> 2], u = o[A + 12 >> 2], R = o[A + 92 >> 2], l = o[A + 16 >> 2], K = o[A + 96 >> 2], b = o[A + 20 >> 2], O = o[A + 100 >> 2], j = o[A + 24 >> 2], X = o[A + 104 >> 2], x = o[A + 28 >> 2], T = o[A + 108 >> 2], V = o[A + 32 >> 2], $ = o[A + 112 >> 2], CA = o[A >> 2], L = (W = o[A + 116 >> 2]) - (AA = o[A + 36 >> 2]) | 0, o[A + 116 >> 2] = L, Z = $ - V | 0, o[A + 112 >> 2] = Z, P = T - x | 0, o[A + 108 >> 2] = P, iA = X - j | 0, o[A + 104 >> 2] = iA, EA = O - b | 0, o[A + 100 >> 2] = EA, oA = K - l | 0, o[A + 96 >> 2] = oA, aA = R - u | 0, o[A + 92 >> 2] = aA, BA = v - d | 0, o[A + 88 >> 2] = BA, fA = Y - U | 0, o[A + 84 >> 2] = fA, m = J - CA | 0, o[A + 80 >> 2] = m, W = W + AA | 0, o[A + 76 >> 2] = W, V = V + $ | 0, o[A + 72 >> 2] = V, x = x + T | 0, o[A + 68 >> 2] = x, j = X + j | 0, o[gA >> 2] = j, b = b + O | 0, o[A + 60 >> 2] = b, l = K + l | 0, o[A + 56 >> 2] = l, u = R + u | 0, o[A + 52 >> 2] = u, d = d + v | 0, o[A + 48 >> 2] = d, U = U + Y | 0, o[A + 44 >> 2] = U, Y = I, I = J + CA | 0, o[Y >> 2] = I, J = o[g >> 2], Y = o[g + 4 >> 2], v = o[g + 8 >> 2], R = o[g + 12 >> 2], K = o[g + 16 >> 2], O = o[g + 20 >> 2], X = o[g + 24 >> 2], T = o[g + 28 >> 2], $ = o[g + 32 >> 2], o[A + 36 >> 2] = o[g + 36 >> 2] - W, o[A + 32 >> 2] = $ - V, o[A + 28 >> 2] = T - x, o[A + 24 >> 2] = X - j, o[A + 20 >> 2] = O - b, o[A + 16 >> 2] = K - l, o[A + 12 >> 2] = R - u, o[A + 8 >> 2] = v - d, o[A + 4 >> 2] = Y - U, o[A >> 2] = J - I, I = o[A + 120 >> 2], J = o[A + 124 >> 2], U = o[A + 128 >> 2], Y = o[A + 132 >> 2], d = o[A + 136 >> 2], v = o[A + 140 >> 2], u = o[A + 144 >> 2], R = o[A + 148 >> 2], l = o[A + 152 >> 2], o[A + 156 >> 2] = o[A + 156 >> 2] - L, o[A + 152 >> 2] = l - Z, o[A + 148 >> 2] = R - P, o[A + 144 >> 2] = u - iA, o[A + 140 >> 2] = v - EA, o[A + 136 >> 2] = d - oA, o[A + 132 >> 2] = Y - aA, o[A + 128 >> 2] = U - BA, o[A + 124 >> 2] = J - fA, o[A + 120 >> 2] = I - m, w = g + 48 | 0;
                                    }
                                    function _(A, I, g, C) {
                                        var B = 0, Q = 0, i = 0, E = 0, f = 0, c = 0, e = 0, r = 0, D = 0, t = 0, y = 0, w = 0, h = 0, n = 0, s = 0, k = 0, F = 0, S = 0, H = 0, G = 0, _ = 0, M = 0, p = 0, N = 0, J = 0, U = 0, Y = 0;
                                        for(B = a[0 | I] | a[I + 1 | 0] << 8 | a[I + 2 | 0] << 16 | a[I + 3 | 0] << 24, o[g >> 2] = B << 24 | (65280 & B) << 8 | B >>> 8 & 65280 | B >>> 24, B = a[I + 4 | 0] | a[I + 5 | 0] << 8 | a[I + 6 | 0] << 16 | a[I + 7 | 0] << 24, o[g + 4 >> 2] = B << 24 | (65280 & B) << 8 | B >>> 8 & 65280 | B >>> 24, B = a[I + 8 | 0] | a[I + 9 | 0] << 8 | a[I + 10 | 0] << 16 | a[I + 11 | 0] << 24, o[g + 8 >> 2] = B << 24 | (65280 & B) << 8 | B >>> 8 & 65280 | B >>> 24, B = a[I + 12 | 0] | a[I + 13 | 0] << 8 | a[I + 14 | 0] << 16 | a[I + 15 | 0] << 24, o[g + 12 >> 2] = B << 24 | (65280 & B) << 8 | B >>> 8 & 65280 | B >>> 24, B = a[I + 16 | 0] | a[I + 17 | 0] << 8 | a[I + 18 | 0] << 16 | a[I + 19 | 0] << 24, o[g + 16 >> 2] = B << 24 | (65280 & B) << 8 | B >>> 8 & 65280 | B >>> 24, B = a[I + 20 | 0] | a[I + 21 | 0] << 8 | a[I + 22 | 0] << 16 | a[I + 23 | 0] << 24, o[g + 20 >> 2] = B << 24 | (65280 & B) << 8 | B >>> 8 & 65280 | B >>> 24, B = a[I + 24 | 0] | a[I + 25 | 0] << 8 | a[I + 26 | 0] << 16 | a[I + 27 | 0] << 24, o[g + 24 >> 2] = B << 24 | (65280 & B) << 8 | B >>> 8 & 65280 | B >>> 24, B = a[I + 28 | 0] | a[I + 29 | 0] << 8 | a[I + 30 | 0] << 16 | a[I + 31 | 0] << 24, o[g + 28 >> 2] = B << 24 | (65280 & B) << 8 | B >>> 8 & 65280 | B >>> 24, B = a[I + 32 | 0] | a[I + 33 | 0] << 8 | a[I + 34 | 0] << 16 | a[I + 35 | 0] << 24, o[g + 32 >> 2] = B << 24 | (65280 & B) << 8 | B >>> 8 & 65280 | B >>> 24, B = a[I + 36 | 0] | a[I + 37 | 0] << 8 | a[I + 38 | 0] << 16 | a[I + 39 | 0] << 24, o[g + 36 >> 2] = B << 24 | (65280 & B) << 8 | B >>> 8 & 65280 | B >>> 24, B = a[I + 40 | 0] | a[I + 41 | 0] << 8 | a[I + 42 | 0] << 16 | a[I + 43 | 0] << 24, o[g + 40 >> 2] = B << 24 | (65280 & B) << 8 | B >>> 8 & 65280 | B >>> 24, B = a[I + 44 | 0] | a[I + 45 | 0] << 8 | a[I + 46 | 0] << 16 | a[I + 47 | 0] << 24, o[g + 44 >> 2] = B << 24 | (65280 & B) << 8 | B >>> 8 & 65280 | B >>> 24, B = a[I + 48 | 0] | a[I + 49 | 0] << 8 | a[I + 50 | 0] << 16 | a[I + 51 | 0] << 24, o[g + 48 >> 2] = B << 24 | (65280 & B) << 8 | B >>> 8 & 65280 | B >>> 24, B = a[I + 52 | 0] | a[I + 53 | 0] << 8 | a[I + 54 | 0] << 16 | a[I + 55 | 0] << 24, o[g + 52 >> 2] = B << 24 | (65280 & B) << 8 | B >>> 8 & 65280 | B >>> 24, B = a[I + 56 | 0] | a[I + 57 | 0] << 8 | a[I + 58 | 0] << 16 | a[I + 59 | 0] << 24, o[g + 56 >> 2] = B << 24 | (65280 & B) << 8 | B >>> 8 & 65280 | B >>> 24, I = a[I + 60 | 0] | a[I + 61 | 0] << 8 | a[I + 62 | 0] << 16 | a[I + 63 | 0] << 24, o[g + 60 >> 2] = I << 24 | (65280 & I) << 8 | I >>> 8 & 65280 | I >>> 24, I = o[A + 28 >> 2], o[C + 24 >> 2] = o[A + 24 >> 2], o[C + 28 >> 2] = I, I = o[A + 20 >> 2], o[C + 16 >> 2] = o[A + 16 >> 2], o[C + 20 >> 2] = I, I = o[A + 12 >> 2], o[C + 8 >> 2] = o[A + 8 >> 2], o[C + 12 >> 2] = I, I = o[A + 4 >> 2], o[C >> 2] = o[A >> 2], o[C + 4 >> 2] = I; f = o[C + 28 >> 2], B = (I = F << 2) + g | 0, i = o[C + 16 >> 2], c = o[B >> 2] + (RA(i, 26) ^ RA(i, 21) ^ RA(i, 7)) | 0, r = (f = ((Q = o[I + 33968 >> 2] + c | 0) + (i & ((c = o[C + 24 >> 2]) ^ (D = o[C + 20 >> 2])) ^ c) | 0) + f | 0) + o[C + 12 >> 2] | 0, o[C + 12 >> 2] = r, f = (y = f + (RA(e = o[C >> 2], 30) ^ RA(e, 19) ^ RA(e, 10)) | 0) + (e & ((Q = o[C + 8 >> 2]) | (E = o[C + 4 >> 2])) | Q & E) | 0, o[C + 28 >> 2] = f, Q = (y = Q) + (c = (o[(h = (Q = 4 | I) + g | 0) >> 2] + ((c + (D ^ r & (i ^ D)) | 0) + (RA(r, 26) ^ RA(r, 21) ^ RA(r, 7)) | 0) | 0) + o[Q + 33968 >> 2] | 0) | 0, o[C + 8 >> 2] = Q, c = (c + (f & (E | e) | E & e) | 0) + (RA(f, 30) ^ RA(f, 19) ^ RA(f, 10)) | 0, o[C + 24 >> 2] = c, D = (y = E) + (E = (((D + o[(k = (E = 8 | I) + g | 0) >> 2] | 0) + o[E + 33968 >> 2] | 0) + (i ^ Q & (i ^ r)) | 0) + (RA(Q, 26) ^ RA(Q, 21) ^ RA(Q, 7)) | 0) | 0, o[C + 4 >> 2] = D, E = E + ((c & (f | e) | f & e) + (RA(c, 30) ^ RA(c, 19) ^ RA(c, 10)) | 0) | 0, o[C + 20 >> 2] = E, i = (y = e) + (e = (((i + o[(S = (e = 12 | I) + g | 0) >> 2] | 0) + o[e + 33968 >> 2] | 0) + (r ^ D & (Q ^ r)) | 0) + (RA(D, 26) ^ RA(D, 21) ^ RA(D, 7)) | 0) | 0, o[C >> 2] = i, e = e + ((E & (f | c) | f & c) + (RA(E, 30) ^ RA(E, 19) ^ RA(E, 10)) | 0) | 0, o[C + 16 >> 2] = e, r = (t = ((((y = r) + o[(H = (r = 16 | I) + g | 0) >> 2] | 0) + o[r + 33968 >> 2] | 0) + (Q ^ i & (Q ^ D)) | 0) + (RA(i, 26) ^ RA(i, 21) ^ RA(i, 7)) | 0) + ((e & (E | c) | E & c) + (RA(e, 30) ^ RA(e, 19) ^ RA(e, 10)) | 0) | 0, o[C + 12 >> 2] = r, t = f + t | 0, o[C + 28 >> 2] = t, f = (Q = (((Q + o[(G = (f = 20 | I) + g | 0) >> 2] | 0) + o[f + 33968 >> 2] | 0) + (D ^ t & (i ^ D)) | 0) + (RA(t, 26) ^ RA(t, 21) ^ RA(t, 7)) | 0) + ((r & (E | e) | E & e) + (RA(r, 30) ^ RA(r, 19) ^ RA(r, 10)) | 0) | 0, o[C + 8 >> 2] = f, Q = Q + c | 0, o[C + 24 >> 2] = Q, c = (D = (((D + o[(_ = (c = 24 | I) + g | 0) >> 2] | 0) + o[c + 33968 >> 2] | 0) + (i ^ Q & (i ^ t)) | 0) + (RA(Q, 26) ^ RA(Q, 21) ^ RA(Q, 7)) | 0) + ((f & (e | r) | e & r) + (RA(f, 30) ^ RA(f, 19) ^ RA(f, 10)) | 0) | 0, o[C + 4 >> 2] = c, D = E + D | 0, o[C + 20 >> 2] = D, E = (i = (((i + o[(M = (E = 28 | I) + g | 0) >> 2] | 0) + o[E + 33968 >> 2] | 0) + (t ^ D & (Q ^ t)) | 0) + (RA(D, 26) ^ RA(D, 21) ^ RA(D, 7)) | 0) + ((c & (f | r) | f & r) + (RA(c, 30) ^ RA(c, 19) ^ RA(c, 10)) | 0) | 0, o[C >> 2] = E, i = i + e | 0, o[C + 16 >> 2] = i, e = (t = (((t + o[(p = (e = 32 | I) + g | 0) >> 2] | 0) + o[e + 33968 >> 2] | 0) + (Q ^ i & (Q ^ D)) | 0) + (RA(i, 26) ^ RA(i, 21) ^ RA(i, 7)) | 0) + ((E & (f | c) | f & c) + (RA(E, 30) ^ RA(E, 19) ^ RA(E, 10)) | 0) | 0, o[C + 28 >> 2] = e, t = r + t | 0, o[C + 12 >> 2] = t, r = (Q = (((Q + o[(N = (r = 36 | I) + g | 0) >> 2] | 0) + o[r + 33968 >> 2] | 0) + (D ^ t & (i ^ D)) | 0) + (RA(t, 26) ^ RA(t, 21) ^ RA(t, 7)) | 0) + ((e & (E | c) | E & c) + (RA(e, 30) ^ RA(e, 19) ^ RA(e, 10)) | 0) | 0, o[C + 24 >> 2] = r, Q = Q + f | 0, o[C + 8 >> 2] = Q, f = (D = (((D + o[(J = (f = 40 | I) + g | 0) >> 2] | 0) + o[f + 33968 >> 2] | 0) + (i ^ Q & (i ^ t)) | 0) + (RA(Q, 26) ^ RA(Q, 21) ^ RA(Q, 7)) | 0) + ((r & (E | e) | E & e) + (RA(r, 30) ^ RA(r, 19) ^ RA(r, 10)) | 0) | 0, o[C + 20 >> 2] = f, D = c + D | 0, o[C + 4 >> 2] = D, y = (c = 44 | I) + g | 0, c = (i = ((i + (o[c + 33968 >> 2] + o[y >> 2] | 0) | 0) + (t ^ D & (Q ^ t)) | 0) + (RA(D, 26) ^ RA(D, 21) ^ RA(D, 7)) | 0) + ((f & (e | r) | e & r) + (RA(f, 30) ^ RA(f, 19) ^ RA(f, 10)) | 0) | 0, o[C + 16 >> 2] = c, E = E + i | 0, o[C >> 2] = E, s = (i = 48 | I) + g | 0, i = (t = ((t + (o[i + 33968 >> 2] + o[s >> 2] | 0) | 0) + (Q ^ E & (Q ^ D)) | 0) + (RA(E, 26) ^ RA(E, 21) ^ RA(E, 7)) | 0) + ((c & (f | r) | f & r) + (RA(c, 30) ^ RA(c, 19) ^ RA(c, 10)) | 0) | 0, o[C + 12 >> 2] = i, e = e + t | 0, o[C + 28 >> 2] = e, n = (t = 52 | I) + g | 0, Q = (t = (((o[t + 33968 >> 2] + o[n >> 2] | 0) + Q | 0) + (D ^ e & (E ^ D)) | 0) + (RA(e, 26) ^ RA(e, 21) ^ RA(e, 7)) | 0) + ((i & (f | c) | f & c) + (RA(i, 30) ^ RA(i, 19) ^ RA(i, 10)) | 0) | 0, o[C + 8 >> 2] = Q, r = r + t | 0, o[C + 24 >> 2] = r, t = (w = 56 | I) + g | 0, D = (w = (((o[w + 33968 >> 2] + o[t >> 2] | 0) + D | 0) + (E ^ r & (E ^ e)) | 0) + (RA(r, 26) ^ RA(r, 21) ^ RA(r, 7)) | 0) + ((Q & (c | i) | c & i) + (RA(Q, 30) ^ RA(Q, 19) ^ RA(Q, 10)) | 0) | 0, o[C + 4 >> 2] = D, f = f + w | 0, o[C + 20 >> 2] = f, w = (I |= 60) + g | 0, f = (I = ((E + (o[I + 33968 >> 2] + o[w >> 2] | 0) | 0) + (e ^ f & (e ^ r)) | 0) + (RA(f, 26) ^ RA(f, 21) ^ RA(f, 7)) | 0) + ((D & (Q | i) | Q & i) + (RA(D, 30) ^ RA(D, 19) ^ RA(D, 10)) | 0) | 0, o[C >> 2] = f, o[C + 16 >> 2] = I + c, 48 != (0 | F);)E = o[N >> 2], F = F + 16 | 0, I = o[t >> 2], f = (Q = o[B >> 2] + (E + (RA(I, 15) ^ RA(I, 13) ^ I >>> 10) | 0) | 0) + (RA(c = o[h >> 2], 25) ^ RA(c, 14) ^ c >>> 3) | 0, o[(F << 2) + g >> 2] = f, r = (i = (Q = (e = o[J >> 2]) + c | 0) + (RA(c = o[w >> 2], 15) ^ RA(c, 13) ^ c >>> 10) | 0) + (RA(Q = o[k >> 2], 25) ^ RA(Q, 14) ^ Q >>> 3) | 0, o[B + 68 >> 2] = r, D = (y = ((i = Q) + (Q = o[y >> 2]) | 0) + (RA(f, 15) ^ RA(f, 13) ^ f >>> 10) | 0) + (RA(i = o[S >> 2], 25) ^ RA(i, 14) ^ i >>> 3) | 0, o[B + 72 >> 2] = D, t = (w = ((y = i) + (i = o[s >> 2]) | 0) + (RA(r, 15) ^ RA(r, 13) ^ r >>> 10) | 0) + (RA(y = o[H >> 2], 25) ^ RA(y, 14) ^ y >>> 3) | 0, o[B + 76 >> 2] = t, s = (w = ((w = y) + (y = o[n >> 2]) | 0) + (RA(D, 15) ^ RA(D, 13) ^ D >>> 10) | 0) + (RA(n = o[G >> 2], 25) ^ RA(n, 14) ^ n >>> 3) | 0, o[B + 80 >> 2] = s, n = (h = (I + n | 0) + (RA(t, 15) ^ RA(t, 13) ^ t >>> 10) | 0) + (RA(w = o[_ >> 2], 25) ^ RA(w, 14) ^ w >>> 3) | 0, o[B + 84 >> 2] = n, w = ((c + w | 0) + (RA(k = o[M >> 2], 25) ^ RA(k, 14) ^ k >>> 3) | 0) + (RA(s, 15) ^ RA(s, 13) ^ s >>> 10) | 0, o[B + 88 >> 2] = w, r = ((h = o[p >> 2]) + (r + (RA(E, 25) ^ RA(E, 14) ^ E >>> 3) | 0) | 0) + (RA(w, 15) ^ RA(w, 13) ^ w >>> 10) | 0, o[B + 96 >> 2] = r, h = ((f + k | 0) + (RA(h, 25) ^ RA(h, 14) ^ h >>> 3) | 0) + (RA(n, 15) ^ RA(n, 13) ^ n >>> 10) | 0, o[B + 92 >> 2] = h, t = (t + (e + (RA(Q, 25) ^ RA(Q, 14) ^ Q >>> 3) | 0) | 0) + (RA(r, 15) ^ RA(r, 13) ^ r >>> 10) | 0, o[B + 104 >> 2] = t, E = (D + (E + (RA(e, 25) ^ RA(e, 14) ^ e >>> 3) | 0) | 0) + (RA(h, 15) ^ RA(h, 13) ^ h >>> 10) | 0, o[B + 100 >> 2] = E, e = (n + (i + (RA(y, 25) ^ RA(y, 14) ^ y >>> 3) | 0) | 0) + (RA(t, 15) ^ RA(t, 13) ^ t >>> 10) | 0, o[B + 112 >> 2] = e, E = (s + (Q + (RA(i, 25) ^ RA(i, 14) ^ i >>> 3) | 0) | 0) + (RA(E, 15) ^ RA(E, 13) ^ E >>> 10) | 0, o[B + 108 >> 2] = E, U = B, Y = (h + (I + (RA(c, 25) ^ RA(c, 14) ^ c >>> 3) | 0) | 0) + (RA(e, 15) ^ RA(e, 13) ^ e >>> 10) | 0, o[U + 120 >> 2] = Y, I = (w + (y + (RA(I, 25) ^ RA(I, 14) ^ I >>> 3) | 0) | 0) + (RA(E, 15) ^ RA(E, 13) ^ E >>> 10) | 0, o[B + 116 >> 2] = I, U = B, Y = (r + (c + (RA(f, 25) ^ RA(f, 14) ^ f >>> 3) | 0) | 0) + (RA(I, 15) ^ RA(I, 13) ^ I >>> 10) | 0, o[U + 124 >> 2] = Y;
                                        o[A >> 2] = f + o[A >> 2], o[A + 4 >> 2] = o[A + 4 >> 2] + o[C + 4 >> 2], o[A + 8 >> 2] = o[A + 8 >> 2] + o[C + 8 >> 2], o[A + 12 >> 2] = o[A + 12 >> 2] + o[C + 12 >> 2], o[A + 16 >> 2] = o[A + 16 >> 2] + o[C + 16 >> 2], o[A + 20 >> 2] = o[A + 20 >> 2] + o[C + 20 >> 2], o[A + 24 >> 2] = o[A + 24 >> 2] + o[C + 24 >> 2], o[A + 28 >> 2] = o[A + 28 >> 2] + o[C + 28 >> 2];
                                    }
                                    function M(A, I) {
                                        var g, C, B, Q, i, E, a, f, e, r, D, t, y, w, n, s, k, F, S, H, G, _, M, p, N, J, U, Y, d, K, b, P, v = 0, L = 0, R = 0, u = 0, x = 0, m = 0, l = 0, z = 0, q = 0, X = 0, j = 0, T = 0, O = 0, V = 0, Z = 0, W = 0, $ = 0, AA = 0, IA = 0, gA = 0, CA = 0, BA = 0;
                                        v = kA(C = (s = o[I + 12 >> 2]) << 1, E = C >> 31, s, G = s >> 31), R = h, L = (q = kA(x = o[I + 16 >> 2], a = x >> 31, f = (u = o[I + 8 >> 2]) << 1, t = f >> 31)) + v | 0, v = h + R | 0, v = L >>> 0 < q >>> 0 ? v + 1 | 0 : v, R = (X = kA(O = (e = o[I + 20 >> 2]) << 1, y = O >> 31, q = (m = o[I + 4 >> 2]) << 1, B = q >> 31)) + L | 0, L = h + v | 0, L = R >>> 0 < X >>> 0 ? L + 1 | 0 : L, l = kA(g = o[I + 24 >> 2], r = g >> 31, X = (W = o[I >> 2]) << 1, Q = X >> 31), v = h + L | 0, v = (R = l + R | 0) >>> 0 < l >>> 0 ? v + 1 | 0 : v, L = R, w = o[I + 32 >> 2], R = kA(j = c(w, 19), D = j >> 31, w, F = w >> 31), v = h + v | 0, v = (L = L + R | 0) >>> 0 < R >>> 0 ? v + 1 | 0 : v, J = o[I + 36 >> 2], R = kA(l = c(J, 38), i = l >> 31, S = (n = o[I + 28 >> 2]) << 1, _ = S >> 31), I = h + v | 0, Z = L = R + L | 0, R = L >>> 0 < R >>> 0 ? I + 1 | 0 : I, I = kA(q, B, x, a), v = h, L = kA(f, t, s, G), v = h + v | 0, v = (I = L + I | 0) >>> 0 < L >>> 0 ? v + 1 | 0 : v, z = kA(e, H = e >> 31, X, Q), L = h + v | 0, L = (I = z + I | 0) >>> 0 < z >>> 0 ? L + 1 | 0 : L, z = kA(j, D, S, _), v = h + L | 0, v = (I = z + I | 0) >>> 0 < z >>> 0 ? v + 1 | 0 : v, L = kA(l, i, g, r), v = h + v | 0, CA = I = L + I | 0, T = I >>> 0 < L >>> 0 ? v + 1 | 0 : v, v = kA(q, B, C, E), L = h, M = I = u, u = kA(I, V = I >> 31, I, V), I = h + L | 0, I = (v = u + v | 0) >>> 0 < u >>> 0 ? I + 1 | 0 : I, L = (u = kA(X, Q, x, a)) + v | 0, v = h + I | 0, v = L >>> 0 < u >>> 0 ? v + 1 | 0 : v, I = (u = kA(z = c(n, 38), k = z >> 31, n, p = n >> 31)) + L | 0, L = h + v | 0, L = I >>> 0 < u >>> 0 ? L + 1 | 0 : L, I = (v = I) + (u = kA(j, D, I = g << 1, I >> 31)) | 0, v = h + L | 0, v = I >>> 0 < u >>> 0 ? v + 1 | 0 : v, L = I, I = kA(l, i, O, y), v = h + v | 0, U = L = L + I | 0, Y = v = I >>> 0 > L >>> 0 ? v + 1 | 0 : v, I = v, d = L = L + 33554432 | 0, K = I = L >>> 0 < 33554432 ? I + 1 | 0 : I, v = (v = I >> 26) + T | 0, CA = I = (L = (67108863 & I) << 6 | L >>> 26) + CA | 0, v = I >>> 0 < L >>> 0 ? v + 1 | 0 : v, b = I = I + 16777216 | 0, v = (v = (L = I >>> 0 < 16777216 ? v + 1 | 0 : v) >> 25) + R | 0, I = (I = (33554431 & L) << 7 | I >>> 25) >>> 0 > (L = I + Z | 0) >>> 0 ? v + 1 | 0 : v, Z = v = L + 33554432 | 0, u = I = v >>> 0 < 33554432 ? I + 1 | 0 : I, o[A + 24 >> 2] = L - (-67108864 & v), I = kA(X, Q, M, V), v = h, R = kA(q, B, m, $ = m >> 31), L = h + v | 0, L = (I = R + I | 0) >>> 0 < R >>> 0 ? L + 1 | 0 : L, T = kA(R = c(g, 19), gA = R >> 31, g, r), v = h + L | 0, v = (I = T + I | 0) >>> 0 < T >>> 0 ? v + 1 | 0 : v, L = (T = kA(O, y, z, k)) + I | 0, I = h + v | 0, I = L >>> 0 < T >>> 0 ? I + 1 | 0 : I, AA = kA(j, D, T = x << 1, N = T >> 31), v = h + I | 0, v = (L = AA + L | 0) >>> 0 < AA >>> 0 ? v + 1 | 0 : v, I = L, L = kA(l, i, C, E), v = h + v | 0, IA = I = I + L | 0, AA = I >>> 0 < L >>> 0 ? v + 1 | 0 : v, I = kA(O, y, R, gA), v = h, m = kA(X, Q, m, $), L = h + v | 0, L = (I = m + I | 0) >>> 0 < m >>> 0 ? L + 1 | 0 : L, m = kA(x, a, z, k), v = h + L | 0, v = (I = m + I | 0) >>> 0 < m >>> 0 ? v + 1 | 0 : v, L = (m = kA(j, D, C, E)) + I | 0, I = h + v | 0, I = L >>> 0 < m >>> 0 ? I + 1 | 0 : I, m = kA(l, i, M, V), v = h + I | 0, BA = L = m + L | 0, $ = L >>> 0 < m >>> 0 ? v + 1 | 0 : v, L = kA(I = c(e, 38), I >> 31, e, H), m = h, I = W, W = L, L = kA(I, v = I >> 31, I, v), v = h + m | 0, v = (I = W + L | 0) >>> 0 < L >>> 0 ? v + 1 | 0 : v, R = kA(R, gA, T, N), L = h + v | 0, L = (I = R + I | 0) >>> 0 < R >>> 0 ? L + 1 | 0 : L, R = kA(C, E, z, k), v = h + L | 0, v = (I = R + I | 0) >>> 0 < R >>> 0 ? v + 1 | 0 : v, L = (R = kA(j, D, f, t)) + I | 0, I = h + v | 0, I = L >>> 0 < R >>> 0 ? I + 1 | 0 : I, R = kA(q, B, l, i), v = h + I | 0, m = L = R + L | 0, W = v = L >>> 0 < R >>> 0 ? v + 1 | 0 : v, gA = L = L + 33554432 | 0, P = v = L >>> 0 < 33554432 ? v + 1 | 0 : v, I = v >> 26, v = (67108863 & v) << 6 | L >>> 26, L = I + $ | 0, $ = R = v + BA | 0, v = v >>> 0 > R >>> 0 ? L + 1 | 0 : L, BA = L = R + 16777216 | 0, R = (33554431 & (v = L >>> 0 < 16777216 ? v + 1 | 0 : v)) << 7 | L >>> 25, v = (v >> 25) + AA | 0, v = (L = R + IA | 0) >>> 0 < R >>> 0 ? v + 1 | 0 : v, AA = I = L + 33554432 | 0, R = v = I >>> 0 < 33554432 ? v + 1 | 0 : v, o[A + 8 >> 2] = L - (-67108864 & I), I = kA(f, t, e, H), v = h, L = kA(x, a, C, E), v = h + v | 0, v = (I = L + I | 0) >>> 0 < L >>> 0 ? v + 1 | 0 : v, L = kA(q, B, g, r), v = h + v | 0, v = (I = L + I | 0) >>> 0 < L >>> 0 ? v + 1 | 0 : v, L = kA(X, Q, n, p), v = h + v | 0, v = (I = L + I | 0) >>> 0 < L >>> 0 ? v + 1 | 0 : v, IA = (L = kA(l, i, w, F)) + I | 0, I = h + v | 0, L = (v = u >> 26) + (L = L >>> 0 > IA >>> 0 ? I + 1 | 0 : I) | 0, Z = I = (u = (67108863 & u) << 6 | Z >>> 26) + IA | 0, v = I >>> 0 < u >>> 0 ? L + 1 | 0 : L, IA = I = I + 16777216 | 0, u = v = I >>> 0 < 16777216 ? v + 1 | 0 : v, o[A + 28 >> 2] = Z - (-33554432 & I), I = kA(X, Q, s, G), L = h, v = (V = kA(q, B, M, V)) + I | 0, I = h + L | 0, I = v >>> 0 < V >>> 0 ? I + 1 | 0 : I, v = (z = kA(g, r, z, k)) + v | 0, L = h + I | 0, I = (j = kA(j, D, O, y)) + v | 0, v = h + (v >>> 0 < z >>> 0 ? L + 1 | 0 : L) | 0, v = I >>> 0 < j >>> 0 ? v + 1 | 0 : v, L = kA(l, i, x, a), v = h + v | 0, v = (v = (I = L + I | 0) >>> 0 < L >>> 0 ? v + 1 | 0 : v) + (L = R >> 26) | 0, I = (L = R = (Z = I) + (I = (67108863 & R) << 6 | AA >>> 26) | 0) >>> 0 < I >>> 0 ? v + 1 | 0 : v, j = v = L + 16777216 | 0, R = I = v >>> 0 < 16777216 ? I + 1 | 0 : I, o[A + 12 >> 2] = L - (-33554432 & v), I = kA(g, r, f, t), v = h, L = kA(x, a, x, a), v = h + v | 0, v = (I = L + I | 0) >>> 0 < L >>> 0 ? v + 1 | 0 : v, L = kA(C, E, O, y), v = h + v | 0, v = (I = L + I | 0) >>> 0 < L >>> 0 ? v + 1 | 0 : v, L = (x = kA(q, B, S, _)) + I | 0, I = h + v | 0, I = L >>> 0 < x >>> 0 ? I + 1 | 0 : I, v = (x = kA(X, Q, w, F)) + L | 0, L = h + I | 0, L = v >>> 0 < x >>> 0 ? L + 1 | 0 : L, I = (x = kA(I = l, i, l = J, O = l >> 31)) + v | 0, v = h + L | 0, v = I >>> 0 < x >>> 0 ? v + 1 | 0 : v, L = I, v = (I = u >> 25) + v | 0, v = (L = L + (u = (33554431 & u) << 7 | IA >>> 25) | 0) >>> 0 < u >>> 0 ? v + 1 | 0 : v, x = I = L + 33554432 | 0, u = v = I >>> 0 < 33554432 ? v + 1 | 0 : v, o[A + 32 >> 2] = L - (-67108864 & I), v = R >> 25, L = (R = (33554431 & R) << 7 | j >>> 25) + (U - (I = -67108864 & d) | 0) | 0, I = v + (Y - ((I >>> 0 > U >>> 0) + K | 0) | 0) | 0, I = L >>> 0 < R >>> 0 ? I + 1 | 0 : I, R = L, I = ((67108863 & (v = (L = L + 33554432 | 0) >>> 0 < 33554432 ? I + 1 | 0 : I)) << 6 | L >>> 26) + (z = CA - (-33554432 & b) | 0) | 0, o[A + 20 >> 2] = I, o[A + 16 >> 2] = R - (-67108864 & L), I = kA(C, E, g, r), L = h, v = (R = kA(e, H, T, N)) + I | 0, I = h + L | 0, I = v >>> 0 < R >>> 0 ? I + 1 | 0 : I, L = (R = kA(f, t, n, p)) + v | 0, v = h + I | 0, v = L >>> 0 < R >>> 0 ? v + 1 | 0 : v, I = (R = kA(q, B, w, F)) + L | 0, L = h + v | 0, L = I >>> 0 < R >>> 0 ? L + 1 | 0 : L, R = (v = I) + (I = kA(X, Q, l, O)) | 0, v = h + L | 0, v = (I = I >>> 0 > R >>> 0 ? v + 1 | 0 : v) + (v = u >> 26) | 0, I = (L = (u = (67108863 & u) << 6 | x >>> 26) + R | 0) >>> 0 < u >>> 0 ? v + 1 | 0 : v, I = (v = L + 16777216 | 0) >>> 0 < 16777216 ? I + 1 | 0 : I, o[A + 36 >> 2] = L - (-33554432 & v), u = $ - (-33554432 & BA) | 0, R = m - (L = -67108864 & gA) | 0, q = W - ((L >>> 0 > m >>> 0) + P | 0) | 0, I = kA((33554431 & I) << 7 | v >>> 25, I >> 25, 19, 0), v = h + q | 0, I = I >>> 0 > (L = I + R | 0) >>> 0 ? v + 1 | 0 : v, I = ((67108863 & (I = (v = L + 33554432 | 0) >>> 0 < 33554432 ? I + 1 | 0 : I)) << 6 | v >>> 26) + u | 0, o[A + 4 >> 2] = I, o[A >> 2] = L - (-67108864 & v);
                                    }
                                    function p(A, I, g, C, B) {
                                        var Q, i, f, c, e, r, D, t, y, h, n, s, k, F, S, H = 0, G = 0, _ = 0, M = 0, p = 0, N = 0, J = 0, U = 0, Y = 0, d = 0, K = 0, b = 0, P = 0, v = 0, L = 0, R = 0, u = 0, x = 0, m = 0, l = 0, z = 0, q = 0, X = 0, j = 0, T = 0, O = 0, V = 0, Z = 0, W = 0, $ = 0, AA = 0, IA = 0, gA = 0, CA = 0;
                                        for(Q = w + -64 | 0, i = o[A + 60 >> 2], f = o[A + 56 >> 2], l = o[A + 52 >> 2], m = o[A + 48 >> 2], c = o[A + 44 >> 2], e = o[A + 40 >> 2], r = o[A + 36 >> 2], D = o[A + 32 >> 2], t = o[A + 28 >> 2], y = o[A + 24 >> 2], h = o[A + 20 >> 2], n = o[A + 16 >> 2], s = o[A + 12 >> 2], k = o[A + 8 >> 2], F = o[A + 4 >> 2], S = o[A >> 2];;){
                                            if (!B & C >>> 0 > 63 | B) H = g;
                                            else {
                                                if (o[Q + 56 >> 2] = 0, o[Q + 60 >> 2] = 0, o[Q + 48 >> 2] = 0, o[Q + 52 >> 2] = 0, o[Q + 40 >> 2] = 0, o[Q + 44 >> 2] = 0, o[Q + 32 >> 2] = 0, o[Q + 36 >> 2] = 0, o[Q + 24 >> 2] = 0, o[Q + 28 >> 2] = 0, o[Q + 16 >> 2] = 0, o[Q + 20 >> 2] = 0, o[Q + 8 >> 2] = 0, o[Q + 12 >> 2] = 0, o[Q >> 2] = 0, o[Q + 4 >> 2] = 0, _ = 0, C | B) for(; E[_ + Q | 0] = a[I + _ | 0], !B & (_ = _ + 1 | 0) >>> 0 < C >>> 0 | B;);
                                                I = H = Q, T = g;
                                            }
                                            for(z = 20, G = S, d = F, K = k, v = s, _ = n, g = h, p = y, N = t, J = D, R = r, b = e, M = i, u = f, L = l, P = m, U = c; Y = _, G = RA((_ = G + _ | 0) ^ P, 16), Y = P = RA(Y ^ (J = G + J | 0), 12), P = RA((x = _ + P | 0) ^ G, 8), _ = RA(Y ^ (J = P + J | 0), 7), M = RA((G = N + v | 0) ^ M, 16), N = RA((U = M + U | 0) ^ N, 12), v = RA((K = p + K | 0) ^ u, 16), p = RA((b = v + b | 0) ^ p, 12), u = (q = G + N | 0) + _ | 0, X = RA((K = p + K | 0) ^ v, 8), G = RA(u ^ X, 16), v = RA((d = g + d | 0) ^ L, 16), g = RA((R = v + R | 0) ^ g, 12), Y = _, L = RA((d = g + d | 0) ^ v, 8), Y = RA(Y ^ (_ = (j = L + R | 0) + G | 0), 12), u = RA(G ^ (v = Y + u | 0), 8), _ = RA((R = u + _ | 0) ^ Y, 7), Y = J, J = K, G = RA(M ^ q, 8), K = RA((M = G + U | 0) ^ N, 7), L = RA((J = J + K | 0) ^ L, 16), U = RA((N = Y + L | 0) ^ K, 12), L = RA(L ^ (K = U + J | 0), 8), N = RA((J = N + L | 0) ^ U, 7), U = M, M = d, d = RA((b = b + X | 0) ^ p, 7), p = U + (P = RA((M = M + d | 0) ^ P, 16)) | 0, U = M, M = RA(p ^ d, 12), P = RA(P ^ (d = U + M | 0), 8), p = RA((U = p + P | 0) ^ M, 7), Y = b, M = G, G = RA(g ^ j, 7), M = RA(M ^ (b = G + x | 0), 16), x = RA((g = Y + M | 0) ^ G, 12), M = RA(M ^ (G = x + b | 0), 8), g = RA((b = g + M | 0) ^ x, 7), z = z - 2 | 0;);
                                            if (z = a[I + 4 | 0] | a[I + 5 | 0] << 8 | a[I + 6 | 0] << 16 | a[I + 7 | 0] << 24, x = a[I + 8 | 0] | a[I + 9 | 0] << 8 | a[I + 10 | 0] << 16 | a[I + 11 | 0] << 24, q = a[I + 12 | 0] | a[I + 13 | 0] << 8 | a[I + 14 | 0] << 16 | a[I + 15 | 0] << 24, X = a[I + 16 | 0] | a[I + 17 | 0] << 8 | a[I + 18 | 0] << 16 | a[I + 19 | 0] << 24, j = a[I + 20 | 0] | a[I + 21 | 0] << 8 | a[I + 22 | 0] << 16 | a[I + 23 | 0] << 24, Y = a[I + 24 | 0] | a[I + 25 | 0] << 8 | a[I + 26 | 0] << 16 | a[I + 27 | 0] << 24, O = a[I + 28 | 0] | a[I + 29 | 0] << 8 | a[I + 30 | 0] << 16 | a[I + 31 | 0] << 24, V = a[I + 32 | 0] | a[I + 33 | 0] << 8 | a[I + 34 | 0] << 16 | a[I + 35 | 0] << 24, Z = a[I + 36 | 0] | a[I + 37 | 0] << 8 | a[I + 38 | 0] << 16 | a[I + 39 | 0] << 24, W = a[I + 40 | 0] | a[I + 41 | 0] << 8 | a[I + 42 | 0] << 16 | a[I + 43 | 0] << 24, $ = a[I + 44 | 0] | a[I + 45 | 0] << 8 | a[I + 46 | 0] << 16 | a[I + 47 | 0] << 24, AA = a[I + 48 | 0] | a[I + 49 | 0] << 8 | a[I + 50 | 0] << 16 | a[I + 51 | 0] << 24, IA = a[I + 52 | 0] | a[I + 53 | 0] << 8 | a[I + 54 | 0] << 16 | a[I + 55 | 0] << 24, gA = a[I + 56 | 0] | a[I + 57 | 0] << 8 | a[I + 58 | 0] << 16 | a[I + 59 | 0] << 24, CA = a[I + 60 | 0] | a[I + 61 | 0] << 8 | a[I + 62 | 0] << 16 | a[I + 63 | 0] << 24, G = G + S ^ (a[0 | I] | a[I + 1 | 0] << 8 | a[I + 2 | 0] << 16 | a[I + 3 | 0] << 24), E[0 | H] = G, E[H + 1 | 0] = G >>> 8, E[H + 2 | 0] = G >>> 16, E[H + 3 | 0] = G >>> 24, G = M + i ^ CA, E[H + 60 | 0] = G, E[H + 61 | 0] = G >>> 8, E[H + 62 | 0] = G >>> 16, E[H + 63 | 0] = G >>> 24, G = u + f ^ gA, E[H + 56 | 0] = G, E[H + 57 | 0] = G >>> 8, E[H + 58 | 0] = G >>> 16, E[H + 59 | 0] = G >>> 24, G = L + l ^ IA, E[H + 52 | 0] = G, E[H + 53 | 0] = G >>> 8, E[H + 54 | 0] = G >>> 16, E[H + 55 | 0] = G >>> 24, G = P + m ^ AA, E[H + 48 | 0] = G, E[H + 49 | 0] = G >>> 8, E[H + 50 | 0] = G >>> 16, E[H + 51 | 0] = G >>> 24, G = U + c ^ $, E[H + 44 | 0] = G, E[H + 45 | 0] = G >>> 8, E[H + 46 | 0] = G >>> 16, E[H + 47 | 0] = G >>> 24, G = b + e ^ W, E[H + 40 | 0] = G, E[H + 41 | 0] = G >>> 8, E[H + 42 | 0] = G >>> 16, E[H + 43 | 0] = G >>> 24, G = R + r ^ Z, E[H + 36 | 0] = G, E[H + 37 | 0] = G >>> 8, E[H + 38 | 0] = G >>> 16, E[H + 39 | 0] = G >>> 24, G = J + D ^ V, E[H + 32 | 0] = G, E[H + 33 | 0] = G >>> 8, E[H + 34 | 0] = G >>> 16, E[H + 35 | 0] = G >>> 24, N = N + t ^ O, E[H + 28 | 0] = N, E[H + 29 | 0] = N >>> 8, E[H + 30 | 0] = N >>> 16, E[H + 31 | 0] = N >>> 24, p = Y ^ p + y, E[H + 24 | 0] = p, E[H + 25 | 0] = p >>> 8, E[H + 26 | 0] = p >>> 16, E[H + 27 | 0] = p >>> 24, g = j ^ g + h, E[H + 20 | 0] = g, E[H + 21 | 0] = g >>> 8, E[H + 22 | 0] = g >>> 16, E[H + 23 | 0] = g >>> 24, g = X ^ _ + n, E[H + 16 | 0] = g, E[H + 17 | 0] = g >>> 8, E[H + 18 | 0] = g >>> 16, E[H + 19 | 0] = g >>> 24, g = q ^ v + s, E[H + 12 | 0] = g, E[H + 13 | 0] = g >>> 8, E[H + 14 | 0] = g >>> 16, E[H + 15 | 0] = g >>> 24, g = x ^ K + k, E[H + 8 | 0] = g, E[H + 9 | 0] = g >>> 8, E[H + 10 | 0] = g >>> 16, E[H + 11 | 0] = g >>> 24, g = z ^ d + F, E[H + 4 | 0] = g, E[H + 5 | 0] = g >>> 8, E[H + 6 | 0] = g >>> 16, E[H + 7 | 0] = g >>> 24, l = !(m = m + 1 | 0) + l | 0, !B & C >>> 0 <= 64) {
                                                if (!(!C | !B & C >>> 0 > 63 | 0 != (0 | B))) for(_ = 0; E[_ + T | 0] = a[H + _ | 0], C >>> 0 > (_ = _ + 1 | 0) >>> 0;);
                                                o[A + 52 >> 2] = l, o[A + 48 >> 2] = m;
                                                break;
                                            }
                                            I = I - -64 | 0, g = H - -64 | 0, B = B - 1 | 0, B = (C = C + -64 | 0) >>> 0 < 4294967232 ? B + 1 | 0 : B;
                                        }
                                    }
                                    function N(A, I) {
                                        var g, C = 0, B = 0, Q = 0, i = 0, a = 0, f = 0, c = 0;
                                        w = g = w - 704 | 0, C = 80 + ((B = o[A + 72 >> 2] >>> 3 & 127) + A | 0) | 0, B >>> 0 >= 112 ? (YA(C, 35008, 128 - B | 0), k(A, B = A + 80 | 0, g, g + 640 | 0), dA(B, 0, 112)) : YA(C, 35008, 112 - B | 0), f = (Q = o[A + 64 >> 2]) << 24 | (65280 & Q) << 8, B = (i = 16711680 & Q) >>> 8 | 0, c = i << 24, i = (a = -16777216 & Q) >>> 24 | 0, C = c | a << 8 | -16777216 & ((255 & (C = o[A + 68 >> 2])) << 24 | Q >>> 8) | 16711680 & ((16777215 & C) << 8 | Q >>> 24) | C >>> 8 & 65280 | C >>> 24, E[A + 192 | 0] = C, E[A + 193 | 0] = C >>> 8, E[A + 194 | 0] = C >>> 16, E[A + 195 | 0] = C >>> 24, B = (C = B | i | f) | (B = 0) | B | 0, E[A + 196 | 0] = B, E[A + 197 | 0] = B >>> 8, E[A + 198 | 0] = B >>> 16, E[A + 199 | 0] = B >>> 24, f = (Q = o[A + 72 >> 2]) << 24 | (65280 & Q) << 8, B = (i = 16711680 & Q) >>> 8 | 0, c = i << 24, i = (a = -16777216 & Q) >>> 24 | 0, C = c | a << 8 | -16777216 & ((255 & (C = o[A + 76 >> 2])) << 24 | Q >>> 8) | 16711680 & ((16777215 & C) << 8 | Q >>> 24) | C >>> 8 & 65280 | C >>> 24, E[A + 200 | 0] = C, E[A + 201 | 0] = C >>> 8, E[A + 202 | 0] = C >>> 16, E[A + 203 | 0] = C >>> 24, B = (C = B | i | f) | (B = 0) | B | 0, E[A + 204 | 0] = B, E[A + 205 | 0] = B >>> 8, E[A + 206 | 0] = B >>> 16, E[A + 207 | 0] = B >>> 24, k(A, A + 80 | 0, g, g + 640 | 0), f = (Q = o[A >> 2]) << 24 | (65280 & Q) << 8, B = (i = 16711680 & Q) >>> 8 | 0, c = i << 24, i = (a = -16777216 & Q) >>> 24 | 0, C = c | a << 8 | -16777216 & ((255 & (C = o[A + 4 >> 2])) << 24 | Q >>> 8) | 16711680 & ((16777215 & C) << 8 | Q >>> 24) | C >>> 8 & 65280 | C >>> 24, E[0 | I] = C, E[I + 1 | 0] = C >>> 8, E[I + 2 | 0] = C >>> 16, E[I + 3 | 0] = C >>> 24, B = (C = B | i | f) | (B = 0) | B | 0, E[I + 4 | 0] = B, E[I + 5 | 0] = B >>> 8, E[I + 6 | 0] = B >>> 16, E[I + 7 | 0] = B >>> 24, f = (Q = o[A + 8 >> 2]) << 24 | (65280 & Q) << 8, B = (i = 16711680 & Q) >>> 8 | 0, c = i << 24, i = (a = -16777216 & Q) >>> 24 | 0, C = c | a << 8 | -16777216 & ((255 & (C = o[A + 12 >> 2])) << 24 | Q >>> 8) | 16711680 & ((16777215 & C) << 8 | Q >>> 24) | C >>> 8 & 65280 | C >>> 24, E[I + 8 | 0] = C, E[I + 9 | 0] = C >>> 8, E[I + 10 | 0] = C >>> 16, E[I + 11 | 0] = C >>> 24, B = (C = B | i | f) | (B = 0) | B | 0, E[I + 12 | 0] = B, E[I + 13 | 0] = B >>> 8, E[I + 14 | 0] = B >>> 16, E[I + 15 | 0] = B >>> 24, f = (Q = o[A + 16 >> 2]) << 24 | (65280 & Q) << 8, B = (i = 16711680 & Q) >>> 8 | 0, c = i << 24, i = (a = -16777216 & Q) >>> 24 | 0, C = c | a << 8 | -16777216 & ((255 & (C = o[A + 20 >> 2])) << 24 | Q >>> 8) | 16711680 & ((16777215 & C) << 8 | Q >>> 24) | C >>> 8 & 65280 | C >>> 24, E[I + 16 | 0] = C, E[I + 17 | 0] = C >>> 8, E[I + 18 | 0] = C >>> 16, E[I + 19 | 0] = C >>> 24, B = (C = B | i | f) | (B = 0) | B | 0, E[I + 20 | 0] = B, E[I + 21 | 0] = B >>> 8, E[I + 22 | 0] = B >>> 16, E[I + 23 | 0] = B >>> 24, f = (Q = o[A + 24 >> 2]) << 24 | (65280 & Q) << 8, B = (i = 16711680 & Q) >>> 8 | 0, c = i << 24, i = (a = -16777216 & Q) >>> 24 | 0, C = c | a << 8 | -16777216 & ((255 & (C = o[A + 28 >> 2])) << 24 | Q >>> 8) | 16711680 & ((16777215 & C) << 8 | Q >>> 24) | C >>> 8 & 65280 | C >>> 24, E[I + 24 | 0] = C, E[I + 25 | 0] = C >>> 8, E[I + 26 | 0] = C >>> 16, E[I + 27 | 0] = C >>> 24, B = (C = B | i | f) | (B = 0) | B | 0, E[I + 28 | 0] = B, E[I + 29 | 0] = B >>> 8, E[I + 30 | 0] = B >>> 16, E[I + 31 | 0] = B >>> 24, f = (Q = o[A + 32 >> 2]) << 24 | (65280 & Q) << 8, B = (i = 16711680 & Q) >>> 8 | 0, c = i << 24, i = (a = -16777216 & Q) >>> 24 | 0, C = c | a << 8 | -16777216 & ((255 & (C = o[A + 36 >> 2])) << 24 | Q >>> 8) | 16711680 & ((16777215 & C) << 8 | Q >>> 24) | C >>> 8 & 65280 | C >>> 24, E[I + 32 | 0] = C, E[I + 33 | 0] = C >>> 8, E[I + 34 | 0] = C >>> 16, E[I + 35 | 0] = C >>> 24, B = (C = B | i | f) | (B = 0) | B | 0, E[I + 36 | 0] = B, E[I + 37 | 0] = B >>> 8, E[I + 38 | 0] = B >>> 16, E[I + 39 | 0] = B >>> 24, f = (Q = o[A + 40 >> 2]) << 24 | (65280 & Q) << 8, B = (i = 16711680 & Q) >>> 8 | 0, c = i << 24, i = (a = -16777216 & Q) >>> 24 | 0, C = c | a << 8 | -16777216 & ((255 & (C = o[A + 44 >> 2])) << 24 | Q >>> 8) | 16711680 & ((16777215 & C) << 8 | Q >>> 24) | C >>> 8 & 65280 | C >>> 24, E[I + 40 | 0] = C, E[I + 41 | 0] = C >>> 8, E[I + 42 | 0] = C >>> 16, E[I + 43 | 0] = C >>> 24, B = (C = B | i | f) | (B = 0) | B | 0, E[I + 44 | 0] = B, E[I + 45 | 0] = B >>> 8, E[I + 46 | 0] = B >>> 16, E[I + 47 | 0] = B >>> 24, f = (Q = o[A + 48 >> 2]) << 24 | (65280 & Q) << 8, B = (i = 16711680 & Q) >>> 8 | 0, c = i << 24, i = (a = -16777216 & Q) >>> 24 | 0, C = c | a << 8 | -16777216 & ((255 & (C = o[A + 52 >> 2])) << 24 | Q >>> 8) | 16711680 & ((16777215 & C) << 8 | Q >>> 24) | C >>> 8 & 65280 | C >>> 24, E[I + 48 | 0] = C, E[I + 49 | 0] = C >>> 8, E[I + 50 | 0] = C >>> 16, E[I + 51 | 0] = C >>> 24, B = (C = B | i | f) | (B = 0) | B | 0, E[I + 52 | 0] = B, E[I + 53 | 0] = B >>> 8, E[I + 54 | 0] = B >>> 16, E[I + 55 | 0] = B >>> 24, f = (Q = o[A + 56 >> 2]) << 24 | (65280 & Q) << 8, B = (i = 16711680 & Q) >>> 8 | 0, C = I, c = i << 24, i = (a = -16777216 & Q) >>> 24 | 0, I = c | a << 8 | -16777216 & ((255 & (I = o[A + 60 >> 2])) << 24 | Q >>> 8) | 16711680 & ((16777215 & I) << 8 | Q >>> 24) | I >>> 8 & 65280 | I >>> 24, E[C + 56 | 0] = I, E[C + 57 | 0] = I >>> 8, E[C + 58 | 0] = I >>> 16, E[C + 59 | 0] = I >>> 24, I = (I = B | i | f) | (B = 0) | B | 0, E[C + 60 | 0] = I, E[C + 61 | 0] = I >>> 8, E[C + 62 | 0] = I >>> 16, E[C + 63 | 0] = I >>> 24, iI(g, 704), iI(A, 208), w = g + 704 | 0;
                                    }
                                    function J(A, I, g) {
                                        var C, B = 0, i = 0, f = 0, c = 0, e = 0, r = 0;
                                        w = C = w + -64 | 0;
                                        A: {
                                            if ((g - 65 & 255) >>> 0 > 191) {
                                                if (B = -1, !(a[A + 80 | 0] | a[A + 81 | 0] << 8 | a[A + 82 | 0] << 16 | a[A + 83 | 0] << 24 | a[A + 84 | 0] | a[A + 85 | 0] << 8 | a[A + 86 | 0] << 16 | a[A + 87 | 0] << 24)) {
                                                    if ((c = a[A + 352 | 0] | a[A + 353 | 0] << 8 | a[A + 354 | 0] << 16 | a[A + 355 | 0] << 24) >>> 0 >= 129) {
                                                        if (f = a[0 | (B = A - -64 | 0)] | a[B + 1 | 0] << 8 | a[B + 2 | 0] << 16 | a[B + 3 | 0] << 24, e = i = a[B + 4 | 0] | a[B + 5 | 0] << 8 | a[B + 6 | 0] << 16 | a[B + 7 | 0] << 24, i = (c = f + 128 | 0) >>> 0 < 128 ? i + 1 | 0 : i, E[0 | B] = c, E[B + 1 | 0] = c >>> 8, E[B + 2 | 0] = c >>> 16, E[B + 3 | 0] = c >>> 24, E[B + 4 | 0] = i, E[B + 5 | 0] = i >>> 8, E[B + 6 | 0] = i >>> 16, E[B + 7 | 0] = i >>> 24, i = a[A + 76 | 0] | a[A + 77 | 0] << 8 | a[A + 78 | 0] << 16 | a[A + 79 | 0] << 24, i = (B = -1 == (0 | e) & f >>> 0 > 4294967167) >>> 0 > (f = B + (a[A + 72 | 0] | a[A + 73 | 0] << 8 | a[A + 74 | 0] << 16 | a[A + 75 | 0] << 24) | 0) >>> 0 ? i + 1 | 0 : i, E[A + 72 | 0] = f, E[A + 73 | 0] = f >>> 8, E[A + 74 | 0] = f >>> 16, E[A + 75 | 0] = f >>> 24, E[A + 76 | 0] = i, E[A + 77 | 0] = i >>> 8, E[A + 78 | 0] = i >>> 16, E[A + 79 | 0] = i >>> 24, n(A, i = A + 96 | 0), B = (a[A + 352 | 0] | a[A + 353 | 0] << 8 | a[A + 354 | 0] << 16 | a[A + 355 | 0] << 24) - 128 | 0, E[A + 352 | 0] = B, E[A + 353 | 0] = B >>> 8, E[A + 354 | 0] = B >>> 16, E[A + 355 | 0] = B >>> 24, B >>> 0 >= 129) break A;
                                                        YA(i, A + 224 | 0, B), c = a[A + 352 | 0] | a[A + 353 | 0] << 8 | a[A + 354 | 0] << 16 | a[A + 355 | 0] << 24;
                                                    }
                                                    i = a[0 | (B = A - -64 | 0)] | a[B + 1 | 0] << 8 | a[B + 2 | 0] << 16 | a[B + 3 | 0] << 24, f = r = a[B + 4 | 0] | a[B + 5 | 0] << 8 | a[B + 6 | 0] << 16 | a[B + 7 | 0] << 24, f = (e = i + c | 0) >>> 0 < c >>> 0 ? f + 1 | 0 : f, E[0 | B] = e, E[B + 1 | 0] = e >>> 8, E[B + 2 | 0] = e >>> 16, E[B + 3 | 0] = e >>> 24, E[B + 4 | 0] = f, E[B + 5 | 0] = f >>> 8, E[B + 6 | 0] = f >>> 16, E[B + 7 | 0] = f >>> 24, B = (0 | f) == (0 | r) & i >>> 0 > e >>> 0 | f >>> 0 < r >>> 0, i = a[A + 76 | 0] | a[A + 77 | 0] << 8 | a[A + 78 | 0] << 16 | a[A + 79 | 0] << 24, i = (f = B + (a[A + 72 | 0] | a[A + 73 | 0] << 8 | a[A + 74 | 0] << 16 | a[A + 75 | 0] << 24) | 0) >>> 0 < B >>> 0 ? i + 1 | 0 : i, E[A + 72 | 0] = f, E[A + 73 | 0] = f >>> 8, E[A + 74 | 0] = f >>> 16, E[A + 75 | 0] = f >>> 24, E[A + 76 | 0] = i, E[A + 77 | 0] = i >>> 8, E[A + 78 | 0] = i >>> 16, E[A + 79 | 0] = i >>> 24, a[A + 356 | 0] && (E[A + 88 | 0] = 255, E[A + 89 | 0] = 255, E[A + 90 | 0] = 255, E[A + 91 | 0] = 255, E[A + 92 | 0] = 255, E[A + 93 | 0] = 255, E[A + 94 | 0] = 255, E[A + 95 | 0] = 255), E[A + 80 | 0] = 255, E[A + 81 | 0] = 255, E[A + 82 | 0] = 255, E[A + 83 | 0] = 255, E[A + 84 | 0] = 255, E[A + 85 | 0] = 255, E[A + 86 | 0] = 255, E[A + 87 | 0] = 255, dA((B = A + 96 | 0) + c | 0, 0, 256 - c | 0), n(A, B), i = a[A + 4 | 0] | a[A + 5 | 0] << 8 | a[A + 6 | 0] << 16 | a[A + 7 | 0] << 24, o[C >> 2] = a[0 | A] | a[A + 1 | 0] << 8 | a[A + 2 | 0] << 16 | a[A + 3 | 0] << 24, o[C + 4 >> 2] = i, i = a[A + 12 | 0] | a[A + 13 | 0] << 8 | a[A + 14 | 0] << 16 | a[A + 15 | 0] << 24, o[C + 8 >> 2] = a[A + 8 | 0] | a[A + 9 | 0] << 8 | a[A + 10 | 0] << 16 | a[A + 11 | 0] << 24, o[C + 12 >> 2] = i, i = a[A + 20 | 0] | a[A + 21 | 0] << 8 | a[A + 22 | 0] << 16 | a[A + 23 | 0] << 24, o[C + 16 >> 2] = a[A + 16 | 0] | a[A + 17 | 0] << 8 | a[A + 18 | 0] << 16 | a[A + 19 | 0] << 24, o[C + 20 >> 2] = i, i = a[A + 28 | 0] | a[A + 29 | 0] << 8 | a[A + 30 | 0] << 16 | a[A + 31 | 0] << 24, o[C + 24 >> 2] = a[A + 24 | 0] | a[A + 25 | 0] << 8 | a[A + 26 | 0] << 16 | a[A + 27 | 0] << 24, o[C + 28 >> 2] = i, i = a[A + 36 | 0] | a[A + 37 | 0] << 8 | a[A + 38 | 0] << 16 | a[A + 39 | 0] << 24, o[C + 32 >> 2] = a[A + 32 | 0] | a[A + 33 | 0] << 8 | a[A + 34 | 0] << 16 | a[A + 35 | 0] << 24, o[C + 36 >> 2] = i, i = a[A + 44 | 0] | a[A + 45 | 0] << 8 | a[A + 46 | 0] << 16 | a[A + 47 | 0] << 24, o[C + 40 >> 2] = a[A + 40 | 0] | a[A + 41 | 0] << 8 | a[A + 42 | 0] << 16 | a[A + 43 | 0] << 24, o[C + 44 >> 2] = i, i = a[A + 52 | 0] | a[A + 53 | 0] << 8 | a[A + 54 | 0] << 16 | a[A + 55 | 0] << 24, o[C + 48 >> 2] = a[A + 48 | 0] | a[A + 49 | 0] << 8 | a[A + 50 | 0] << 16 | a[A + 51 | 0] << 24, o[C + 52 >> 2] = i, i = a[A + 60 | 0] | a[A + 61 | 0] << 8 | a[A + 62 | 0] << 16 | a[A + 63 | 0] << 24, o[C + 56 >> 2] = a[A + 56 | 0] | a[A + 57 | 0] << 8 | a[A + 58 | 0] << 16 | a[A + 59 | 0] << 24, o[C + 60 >> 2] = i, YA(I, C, g), iI(A, 64), iI(B, 256), B = 0;
                                                }
                                                return w = C - -64 | 0, B;
                                            }
                                            zA(), Q();
                                        }
                                        D(1280, 1142, 306, 1086), Q();
                                    }
                                    function U(A, I) {
                                        var g, C, B, Q, i, f, c, e, r, D, t, y, h, n, s, k, F = 0, S = 0, G = 0, _ = 0, p = 0, N = 0, J = 0;
                                        for(w = g = w - 320 | 0, L(C = A + 40 | 0, I), o[A + 84 >> 2] = 0, o[A + 88 >> 2] = 0, o[A + 80 >> 2] = 1, o[A + 92 >> 2] = 0, o[A + 96 >> 2] = 0, o[A + 100 >> 2] = 0, o[A + 104 >> 2] = 0, o[A + 108 >> 2] = 0, o[A + 112 >> 2] = 0, o[A + 116 >> 2] = 0, M(N = g + 240 | 0, C), H(_ = g + 192 | 0, N, 1344), J = -1, B = o[g + 240 >> 2] - 1 | 0, o[g + 240 >> 2] = B, o[g + 192 >> 2] = o[g + 192 >> 2] + 1, Q = o[g + 244 >> 2], i = o[g + 248 >> 2], f = o[g + 252 >> 2], c = o[g + 256 >> 2], e = o[g + 260 >> 2], r = o[g + 264 >> 2], D = o[g + 268 >> 2], t = o[g + 272 >> 2], y = o[g + 276 >> 2], M(p = g + 144 | 0, _), H(p, p, _), M(A, p), H(A, A, _), H(A, A, N), w = S = w - 144 | 0, M(G = S + 96 | 0, A), M(F = S + 48 | 0, G), M(F, F), H(F, A, F), H(G, G, F), M(G, G), H(G, F, G), M(F, G), M(F, F), M(F, F), M(F, F), M(F, F), H(G, F, G), M(F, G), M(F, F), M(F, F), M(F, F), M(F, F), M(F, F), M(F, F), M(F, F), M(F, F), M(F, F), H(F, F, G), M(S, F), M(S, S), M(S, S), M(S, S), M(S, S), M(S, S), M(S, S), M(S, S), M(S, S), M(S, S), M(S, S), M(S, S), M(S, S), M(S, S), M(S, S), M(S, S), M(S, S), M(S, S), M(S, S), M(S, S), H(F, S, F), M(F, F), M(F, F), M(F, F), M(F, F), M(F, F), M(F, F), M(F, F), M(F, F), M(F, F), M(F, F), H(G, F, G), M(F, G), M(F, F), M(F, F), M(F, F), M(F, F), M(F, F), M(F, F), M(F, F), M(F, F), M(F, F), M(F, F), M(F, F), M(F, F), M(F, F), M(F, F), M(F, F), M(F, F), M(F, F), M(F, F), M(F, F), M(F, F), M(F, F), M(F, F), M(F, F), M(F, F), M(F, F), M(F, F), M(F, F), M(F, F), M(F, F), M(F, F), M(F, F), M(F, F), M(F, F), M(F, F), M(F, F), M(F, F), M(F, F), M(F, F), M(F, F), M(F, F), M(F, F), M(F, F), M(F, F), M(F, F), M(F, F), M(F, F), M(F, F), M(F, F), M(F, F), H(F, F, G), M(S, F), F = 1; M(S, S), 100 != (0 | (F = F + 1 | 0)););
                                        H(F = S + 48 | 0, S, F), M(F, F), M(F, F), M(F, F), M(F, F), M(F, F), M(F, F), M(F, F), M(F, F), M(F, F), M(F, F), M(F, F), M(F, F), M(F, F), M(F, F), M(F, F), M(F, F), M(F, F), M(F, F), M(F, F), M(F, F), M(F, F), M(F, F), M(F, F), M(F, F), M(F, F), M(F, F), M(F, F), M(F, F), M(F, F), M(F, F), M(F, F), M(F, F), M(F, F), M(F, F), M(F, F), M(F, F), M(F, F), M(F, F), M(F, F), M(F, F), M(F, F), M(F, F), M(F, F), M(F, F), M(F, F), M(F, F), M(F, F), M(F, F), M(F, F), M(F, F), H(G = S + 96 | 0, F, G), M(G, G), M(G, G), H(A, G, A), w = S + 144 | 0, H(A, A, p), H(A, A, N), M(F = g + 96 | 0, A), H(F, F, _), F = o[g + 132 >> 2], o[g + 84 >> 2] = F - y, S = o[g + 128 >> 2], o[g + 80 >> 2] = S - t, G = o[g + 124 >> 2], o[g + 76 >> 2] = G - D, _ = o[g + 120 >> 2], o[g + 72 >> 2] = _ - r, p = o[g + 116 >> 2], o[g + 68 >> 2] = p - e, N = o[g + 112 >> 2], o[g + 64 >> 2] = N - c, h = o[g + 108 >> 2], o[g + 60 >> 2] = h - f, n = o[g + 104 >> 2], o[g + 56 >> 2] = n - i, s = o[g + 100 >> 2], o[g + 52 >> 2] = s - Q, k = o[g + 96 >> 2], o[g + 48 >> 2] = k - B, IA(g, g + 48 | 0);
                                        A: {
                                            if (!fA(g, 32)) {
                                                if (o[g + 36 >> 2] = F + y, o[g + 32 >> 2] = S + t, o[g + 28 >> 2] = G + D, o[g + 24 >> 2] = _ + r, o[g + 20 >> 2] = p + e, o[g + 16 >> 2] = N + c, o[g + 12 >> 2] = f + h, o[g + 8 >> 2] = i + n, o[g + 4 >> 2] = Q + s, o[g >> 2] = B + k, IA(F = g + 288 | 0, g), !fA(F, 32)) break A;
                                                H(A, A, 1392);
                                            }
                                            IA(g + 288 | 0, A), (1 & E[g + 288 | 0]) == (a[I + 31 | 0] >>> 7 | 0) && (o[A >> 2] = 0 - o[A >> 2], o[A + 36 >> 2] = 0 - o[A + 36 >> 2], o[A + 32 >> 2] = 0 - o[A + 32 >> 2], o[A + 28 >> 2] = 0 - o[A + 28 >> 2], o[A + 24 >> 2] = 0 - o[A + 24 >> 2], o[A + 20 >> 2] = 0 - o[A + 20 >> 2], o[A + 16 >> 2] = 0 - o[A + 16 >> 2], o[A + 12 >> 2] = 0 - o[A + 12 >> 2], o[A + 8 >> 2] = 0 - o[A + 8 >> 2], o[A + 4 >> 2] = 0 - o[A + 4 >> 2]), H(A + 120 | 0, A, C), J = 0;
                                        }
                                        return w = g + 320 | 0, J;
                                    }
                                    function Y(A, I, g) {
                                        var C, B, Q, i, o, f, c, e, r, D, t, y, w = 0, h = 0, n = 0, s = 0, k = 0, F = 0, S = 0, H = 0, G = 0, _ = 0, M = 0, p = 0, N = 0, J = 0, U = 0, Y = 0, d = 0, K = 0, b = 0, P = 0;
                                        for(k = 1634760805, h = C = a[0 | g] | a[g + 1 | 0] << 8 | a[g + 2 | 0] << 16 | a[g + 3 | 0] << 24, F = B = a[g + 4 | 0] | a[g + 5 | 0] << 8 | a[g + 6 | 0] << 16 | a[g + 7 | 0] << 24, S = Q = a[g + 8 | 0] | a[g + 9 | 0] << 8 | a[g + 10 | 0] << 16 | a[g + 11 | 0] << 24, H = i = a[g + 12 | 0] | a[g + 13 | 0] << 8 | a[g + 14 | 0] << 16 | a[g + 15 | 0] << 24, p = 857760878, G = o = a[0 | I] | a[I + 1 | 0] << 8 | a[I + 2 | 0] << 16 | a[I + 3 | 0] << 24, n = f = a[I + 4 | 0] | a[I + 5 | 0] << 8 | a[I + 6 | 0] << 16 | a[I + 7 | 0] << 24, M = c = a[I + 8 | 0] | a[I + 9 | 0] << 8 | a[I + 10 | 0] << 16 | a[I + 11 | 0] << 24, J = e = a[I + 12 | 0] | a[I + 13 | 0] << 8 | a[I + 14 | 0] << 16 | a[I + 15 | 0] << 24, I = 2036477234, s = r = a[g + 16 | 0] | a[g + 17 | 0] << 8 | a[g + 18 | 0] << 16 | a[g + 19 | 0] << 24, w = 1797285236, U = D = a[g + 28 | 0] | a[g + 29 | 0] << 8 | a[g + 30 | 0] << 16 | a[g + 31 | 0] << 24, N = t = a[g + 24 | 0] | a[g + 25 | 0] << 8 | a[g + 26 | 0] << 16 | a[g + 27 | 0] << 24, g = y = a[g + 20 | 0] | a[g + 21 | 0] << 8 | a[g + 22 | 0] << 16 | a[g + 23 | 0] << 24; _ = RA(h + p | 0, 7) ^ J, Y = RA(_ + p | 0, 9) ^ N, H = RA(g + k | 0, 7) ^ H, d = RA(H + k | 0, 9) ^ M, b = RA(d + H | 0, 13) ^ g, S = RA(w + s | 0, 7) ^ S, K = RA(S + w | 0, 9) ^ n, M = RA(S + K | 0, 13) ^ s, s = RA(K + M | 0, 18) ^ w, n = RA(I + G | 0, 7) ^ U, g = b ^ RA(s + n | 0, 7), N = Y ^ RA(g + s | 0, 9), U = RA(g + N | 0, 13) ^ n, w = RA(N + U | 0, 18) ^ s, F = RA(I + n | 0, 9) ^ F, G = RA(F + n | 0, 13) ^ G, I = RA(G + F | 0, 18) ^ I, s = RA(I + _ | 0, 7) ^ M, M = RA(s + I | 0, 9) ^ d, J = RA(s + M | 0, 13) ^ _, I = RA(M + J | 0, 18) ^ I, _ = RA(_ + Y | 0, 13) ^ h, h = RA(_ + Y | 0, 18) ^ p, G = RA(h + H | 0, 7) ^ G, n = RA(G + h | 0, 9) ^ K, H = RA(n + G | 0, 13) ^ H, p = RA(n + H | 0, 18) ^ h, k = RA(d + b | 0, 18) ^ k, h = RA(k + S | 0, 7) ^ _, F = RA(h + k | 0, 9) ^ F, S = RA(h + F | 0, 13) ^ S, k = RA(F + S | 0, 18) ^ k, _ = P >>> 0 < 18, P = P + 2 | 0, _;);
                                        w = w + 1797285236 | 0, E[A + 60 | 0] = w, E[A + 61 | 0] = w >>> 8, E[A + 62 | 0] = w >>> 16, E[A + 63 | 0] = w >>> 24, w = U + D | 0, E[A + 56 | 0] = w, E[A + 57 | 0] = w >>> 8, E[A + 58 | 0] = w >>> 16, E[A + 59 | 0] = w >>> 24, w = N + t | 0, E[A + 52 | 0] = w, E[A + 53 | 0] = w >>> 8, E[A + 54 | 0] = w >>> 16, E[A + 55 | 0] = w >>> 24, g = g + y | 0, E[A + 48 | 0] = g, E[A + 49 | 0] = g >>> 8, E[A + 50 | 0] = g >>> 16, E[A + 51 | 0] = g >>> 24, g = s + r | 0, E[A + 44 | 0] = g, E[A + 45 | 0] = g >>> 8, E[A + 46 | 0] = g >>> 16, E[A + 47 | 0] = g >>> 24, I = I + 2036477234 | 0, E[A + 40 | 0] = I, E[A + 41 | 0] = I >>> 8, E[A + 42 | 0] = I >>> 16, E[A + 43 | 0] = I >>> 24, I = J + e | 0, E[A + 36 | 0] = I, E[A + 37 | 0] = I >>> 8, E[A + 38 | 0] = I >>> 16, E[A + 39 | 0] = I >>> 24, I = M + c | 0, E[A + 32 | 0] = I, E[A + 33 | 0] = I >>> 8, E[A + 34 | 0] = I >>> 16, E[A + 35 | 0] = I >>> 24, I = n + f | 0, E[A + 28 | 0] = I, E[A + 29 | 0] = I >>> 8, E[A + 30 | 0] = I >>> 16, E[A + 31 | 0] = I >>> 24, I = G + o | 0, E[A + 24 | 0] = I, E[A + 25 | 0] = I >>> 8, E[A + 26 | 0] = I >>> 16, E[A + 27 | 0] = I >>> 24, I = p + 857760878 | 0, E[A + 20 | 0] = I, E[A + 21 | 0] = I >>> 8, E[A + 22 | 0] = I >>> 16, E[A + 23 | 0] = I >>> 24, I = H + i | 0, E[A + 16 | 0] = I, E[A + 17 | 0] = I >>> 8, E[A + 18 | 0] = I >>> 16, E[A + 19 | 0] = I >>> 24, I = S + Q | 0, E[A + 12 | 0] = I, E[A + 13 | 0] = I >>> 8, E[A + 14 | 0] = I >>> 16, E[A + 15 | 0] = I >>> 24, I = F + B | 0, E[A + 8 | 0] = I, E[A + 9 | 0] = I >>> 8, E[A + 10 | 0] = I >>> 16, E[A + 11 | 0] = I >>> 24, I = h + C | 0, E[A + 4 | 0] = I, E[A + 5 | 0] = I >>> 8, E[A + 6 | 0] = I >>> 16, E[A + 7 | 0] = I >>> 24, I = k + 1634760805 | 0, E[0 | A] = I, E[A + 1 | 0] = I >>> 8, E[A + 2 | 0] = I >>> 16, E[A + 3 | 0] = I >>> 24;
                                    }
                                    function d(A, I, g, C) {
                                        var B = 0, Q = 0, i = 0, E = 0, f = 0, e = 0, r = 0, D = 0, t = 0, y = 0, w = 0, n = 0, s = 0, k = 0, F = 0, S = 0, H = 0, G = 0, _ = 0, M = 0, p = 0, N = 0, J = 0, U = 0, Y = 0;
                                        if (w = o[A + 36 >> 2], t = o[A + 32 >> 2], y = o[A + 28 >> 2], r = o[A + 24 >> 2], D = o[A + 20 >> 2], !C & g >>> 0 >= 16 | C) for(p = !a[A + 80 | 0] << 24, s = o[A + 4 >> 2], N = c(s, 5), F = o[A + 8 >> 2], _ = c(F, 5), H = o[A + 12 >> 2], G = c(H, 5), M = o[A + 16 >> 2], S = c(M, 5), k = o[A >> 2]; B = kA(i = ((a[I + 3 | 0] | a[I + 4 | 0] << 8 | a[I + 5 | 0] << 16 | a[I + 6 | 0] << 24) >>> 2 & 67108863) + r | 0, 0, H, 0), f = h, D = (E = kA(r = (67108863 & (a[0 | I] | a[I + 1 | 0] << 8 | a[I + 2 | 0] << 16 | a[I + 3 | 0] << 24)) + D | 0, 0, M, 0)) + B | 0, B = h + f | 0, B = E >>> 0 > D >>> 0 ? B + 1 | 0 : B, f = kA(y = ((a[I + 6 | 0] | a[I + 7 | 0] << 8 | a[I + 8 | 0] << 16 | a[I + 9 | 0] << 24) >>> 4 & 67108863) + y | 0, 0, F, 0), B = h + B | 0, B = f >>> 0 > (D = f + D | 0) >>> 0 ? B + 1 | 0 : B, f = kA(t = ((a[I + 9 | 0] | a[I + 10 | 0] << 8 | a[I + 11 | 0] << 16 | a[I + 12 | 0] << 24) >>> 6 | 0) + t | 0, 0, s, 0), B = h + B | 0, B = f >>> 0 > (D = f + D | 0) >>> 0 ? B + 1 | 0 : B, f = kA(w = w + p + ((a[I + 12 | 0] | a[I + 13 | 0] << 8 | a[I + 14 | 0] << 16 | a[I + 15 | 0] << 24) >>> 8) | 0, 0, k, 0), B = h + B | 0, J = D = f + D | 0, D = f >>> 0 > D >>> 0 ? B + 1 | 0 : B, B = kA(i, 0, F, 0), f = h, E = kA(r, 0, H, 0), Q = h + f | 0, Q = (B = E + B | 0) >>> 0 < E >>> 0 ? Q + 1 | 0 : Q, f = (E = kA(y, 0, s, 0)) + B | 0, B = h + Q | 0, B = E >>> 0 > f >>> 0 ? B + 1 | 0 : B, E = kA(t, 0, k, 0), B = h + B | 0, B = E >>> 0 > (f = E + f | 0) >>> 0 ? B + 1 | 0 : B, E = kA(w, 0, S, 0), B = h + B | 0, U = f = E + f | 0, f = E >>> 0 > f >>> 0 ? B + 1 | 0 : B, B = kA(i, 0, s, 0), e = h, E = (Q = kA(r, 0, F, 0)) + B | 0, B = h + e | 0, B = Q >>> 0 > E >>> 0 ? B + 1 | 0 : B, e = kA(y, 0, k, 0), Q = h + B | 0, Q = (E = e + E | 0) >>> 0 < e >>> 0 ? Q + 1 | 0 : Q, e = kA(t, 0, S, 0), B = h + Q | 0, B = (E = e + E | 0) >>> 0 < e >>> 0 ? B + 1 | 0 : B, e = kA(w, 0, G, 0), B = h + B | 0, Y = E = e + E | 0, E = E >>> 0 < e >>> 0 ? B + 1 | 0 : B, B = kA(i, 0, k, 0), Q = h, e = (n = kA(r, 0, s, 0)) + B | 0, B = h + Q | 0, B = e >>> 0 < n >>> 0 ? B + 1 | 0 : B, Q = kA(y, 0, S, 0), B = h + B | 0, B = Q >>> 0 > (e = Q + e | 0) >>> 0 ? B + 1 | 0 : B, n = kA(t, 0, G, 0), Q = h + B | 0, Q = (e = n + e | 0) >>> 0 < n >>> 0 ? Q + 1 | 0 : Q, n = kA(w, 0, _, 0), B = h + Q | 0, B = (e = n + e | 0) >>> 0 < n >>> 0 ? B + 1 | 0 : B, n = e, e = B, B = kA(i, 0, S, 0), Q = h, i = (r = kA(r, 0, k, 0)) + B | 0, B = h + Q | 0, B = i >>> 0 < r >>> 0 ? B + 1 | 0 : B, r = kA(y, 0, G, 0), B = h + B | 0, B = (i = r + i | 0) >>> 0 < r >>> 0 ? B + 1 | 0 : B, r = kA(t, 0, _, 0), B = h + B | 0, B = (i = r + i | 0) >>> 0 < r >>> 0 ? B + 1 | 0 : B, r = kA(w, 0, N, 0), Q = h + B | 0, Q = (i = r + i | 0) >>> 0 < r >>> 0 ? Q + 1 | 0 : Q, r = i, B = e, B = (i = (y = (67108863 & Q) << 6 | i >>> 26) + n | 0) >>> 0 < y >>> 0 ? B + 1 | 0 : B, y = i, t = (67108863 & B) << 6 | i >>> 26, B = E, B = (i = t + Y | 0) >>> 0 < t >>> 0 ? B + 1 | 0 : B, t = i, Q = f, w = B = (i = (67108863 & B) << 6 | i >>> 26) + U | 0, f = (67108863 & (Q = B >>> 0 < i >>> 0 ? Q + 1 | 0 : Q)) << 6 | B >>> 26, B = D, r = (67108863 & y) + ((B = c((67108863 & ((i = f + J | 0) >>> 0 < f >>> 0 ? B + 1 | 0 : B)) << 6 | i >>> 26, 5) + (67108863 & r) | 0) >>> 26 | 0) | 0, y = 67108863 & t, t = 67108863 & w, w = 67108863 & i, D = 67108863 & B, I = I + 16 | 0, !(C = C - (g >>> 0 < 16) | 0) & (g = g - 16 | 0) >>> 0 > 15 | C;);
                                        o[A + 20 >> 2] = D, o[A + 36 >> 2] = w, o[A + 32 >> 2] = t, o[A + 28 >> 2] = y, o[A + 24 >> 2] = r;
                                    }
                                    function K(A, I, g, C) {
                                        A |= 0, I |= 0;
                                        var B = 0;
                                        return B = -1, (C |= 0) - 65 >>> 0 < 4294967232 | (g |= 0) >>> 0 > 64 || (g && I ? (w = B = w - 128 | 0, !I | ((C &= 255) - 65 & 255) >>> 0 <= 191 | ((g &= 255) - 65 & 255) >>> 0 <= 191 ? (zA(), Q()) : (dA(A - -64 | 0, 0, 293), E[A + 56 | 0] = 121, E[A + 57 | 0] = 33, E[A + 58 | 0] = 126, E[A + 59 | 0] = 19, E[A + 60 | 0] = 25, E[A + 61 | 0] = 205, E[A + 62 | 0] = 224, E[A + 63 | 0] = 91, E[A + 48 | 0] = 107, E[A + 49 | 0] = 189, E[A + 50 | 0] = 65, E[A + 51 | 0] = 251, E[A + 52 | 0] = 171, E[A + 53 | 0] = 217, E[A + 54 | 0] = 131, E[A + 55 | 0] = 31, E[A + 40 | 0] = 31, E[A + 41 | 0] = 108, E[A + 42 | 0] = 62, E[A + 43 | 0] = 43, E[A + 44 | 0] = 140, E[A + 45 | 0] = 104, E[A + 46 | 0] = 5, E[A + 47 | 0] = 155, E[A + 32 | 0] = 209, E[A + 33 | 0] = 130, E[A + 34 | 0] = 230, E[A + 35 | 0] = 173, E[A + 36 | 0] = 127, E[A + 37 | 0] = 82, E[A + 38 | 0] = 14, E[A + 39 | 0] = 81, E[A + 24 | 0] = 241, E[A + 25 | 0] = 54, E[A + 26 | 0] = 29, E[A + 27 | 0] = 95, E[A + 28 | 0] = 58, E[A + 29 | 0] = 245, E[A + 30 | 0] = 79, E[A + 31 | 0] = 165, E[A + 16 | 0] = 43, E[A + 17 | 0] = 248, E[A + 18 | 0] = 148, E[A + 19 | 0] = 254, E[A + 20 | 0] = 114, E[A + 21 | 0] = 243, E[A + 22 | 0] = 110, E[A + 23 | 0] = 60, E[A + 8 | 0] = 59, E[A + 9 | 0] = 167, E[A + 10 | 0] = 202, E[A + 11 | 0] = 132, E[A + 12 | 0] = 133, E[A + 13 | 0] = 174, E[A + 14 | 0] = 103, E[A + 15 | 0] = 187, C = -222443256 ^ (g << 8 | C), E[0 | A] = C, E[A + 1 | 0] = C >>> 8, E[A + 2 | 0] = C >>> 16, E[A + 3 | 0] = C >>> 24, C = g >>> 24 ^ 1779033703, E[A + 4 | 0] = C, E[A + 5 | 0] = C >>> 8, E[A + 6 | 0] = C >>> 16, E[A + 7 | 0] = C >>> 24, dA(g + B | 0, 0, g << 24 >> 24 >= 0 ? 128 - g | 0 : 0), g = YA(B, I, g), YA(A + 96 | 0, g, 128), I = 128 + (a[A + 352 | 0] | a[A + 353 | 0] << 8 | a[A + 354 | 0] << 16 | a[A + 355 | 0] << 24) | 0, E[A + 352 | 0] = I, E[A + 353 | 0] = I >>> 8, E[A + 354 | 0] = I >>> 16, E[A + 355 | 0] = I >>> 24, iI(g, 128), w = g + 128 | 0)) : (((I = 255 & C) - 65 & 255) >>> 0 <= 191 && (zA(), Q()), dA(A - -64 | 0, 0, 293), E[A + 56 | 0] = 121, E[A + 57 | 0] = 33, E[A + 58 | 0] = 126, E[A + 59 | 0] = 19, E[A + 60 | 0] = 25, E[A + 61 | 0] = 205, E[A + 62 | 0] = 224, E[A + 63 | 0] = 91, E[A + 48 | 0] = 107, E[A + 49 | 0] = 189, E[A + 50 | 0] = 65, E[A + 51 | 0] = 251, E[A + 52 | 0] = 171, E[A + 53 | 0] = 217, E[A + 54 | 0] = 131, E[A + 55 | 0] = 31, E[A + 40 | 0] = 31, E[A + 41 | 0] = 108, E[A + 42 | 0] = 62, E[A + 43 | 0] = 43, E[A + 44 | 0] = 140, E[A + 45 | 0] = 104, E[A + 46 | 0] = 5, E[A + 47 | 0] = 155, E[A + 32 | 0] = 209, E[A + 33 | 0] = 130, E[A + 34 | 0] = 230, E[A + 35 | 0] = 173, E[A + 36 | 0] = 127, E[A + 37 | 0] = 82, E[A + 38 | 0] = 14, E[A + 39 | 0] = 81, E[A + 24 | 0] = 241, E[A + 25 | 0] = 54, E[A + 26 | 0] = 29, E[A + 27 | 0] = 95, E[A + 28 | 0] = 58, E[A + 29 | 0] = 245, E[A + 30 | 0] = 79, E[A + 31 | 0] = 165, E[A + 16 | 0] = 43, E[A + 17 | 0] = 248, E[A + 18 | 0] = 148, E[A + 19 | 0] = 254, E[A + 20 | 0] = 114, E[A + 21 | 0] = 243, E[A + 22 | 0] = 110, E[A + 23 | 0] = 60, E[A + 8 | 0] = 59, E[A + 9 | 0] = 167, E[A + 10 | 0] = 202, E[A + 11 | 0] = 132, E[A + 12 | 0] = 133, E[A + 13 | 0] = 174, E[A + 14 | 0] = 103, E[A + 15 | 0] = 187, I ^= -222443256, E[0 | A] = I, E[A + 1 | 0] = I >>> 8, E[A + 2 | 0] = I >>> 16, E[A + 3 | 0] = I >>> 24, E[A + 4 | 0] = 103, E[A + 5 | 0] = 230, E[A + 6 | 0] = 9, E[A + 7 | 0] = 106), B = 0), 0 | B;
                                    }
                                    function b(A, I, g) {
                                        var C, B, Q, i, E, a, f, c, e, r, D, t = 0, y = 0, w = 0, h = 0, n = 0, s = 0, k = 0, F = 0, S = 0, G = 0, _ = 0, M = 0, p = 0, N = 0, J = 0, U = 0, Y = 0, d = 0, K = 0;
                                        t = o[I + 40 >> 2], y = o[I + 4 >> 2], h = o[I + 44 >> 2], n = o[I + 8 >> 2], s = o[I + 48 >> 2], k = o[I + 12 >> 2], F = o[I + 52 >> 2], S = o[I + 16 >> 2], G = o[I + 56 >> 2], _ = o[I + 20 >> 2], M = o[I + 60 >> 2], p = o[I + 24 >> 2], N = o[(w = I - -64 | 0) >> 2], J = o[I + 28 >> 2], U = o[I + 68 >> 2], Y = o[I + 32 >> 2], d = o[I + 72 >> 2], K = o[I >> 2], o[A + 36 >> 2] = o[I + 36 >> 2] + o[I + 76 >> 2], o[A + 32 >> 2] = Y + d, o[A + 28 >> 2] = J + U, o[A + 24 >> 2] = p + N, o[A + 20 >> 2] = _ + M, o[A + 16 >> 2] = S + G, o[A + 12 >> 2] = k + F, o[A + 8 >> 2] = n + s, o[A + 4 >> 2] = y + h, o[A >> 2] = t + K, h = o[I + 40 >> 2], t = o[I + 4 >> 2], n = o[I + 44 >> 2], s = o[I + 8 >> 2], k = o[I + 48 >> 2], F = o[I + 12 >> 2], S = o[I + 52 >> 2], G = o[I + 16 >> 2], _ = o[I + 56 >> 2], M = o[I + 20 >> 2], p = o[I + 60 >> 2], N = o[I + 24 >> 2], w = o[w >> 2], y = o[I + 28 >> 2], J = o[I + 68 >> 2], U = o[I + 32 >> 2], Y = o[I + 72 >> 2], d = o[I >> 2], o[A + 76 >> 2] = o[I + 76 >> 2] - o[I + 36 >> 2], o[A + 72 >> 2] = Y - U, o[A + 68 >> 2] = J - y, o[(y = A - -64 | 0) >> 2] = w - N, o[A + 60 >> 2] = p - M, o[A + 56 >> 2] = _ - G, o[A + 52 >> 2] = S - F, o[A + 48 >> 2] = k - s, o[A + 44 >> 2] = n - t, o[(t = A + 40 | 0) >> 2] = h - d, H(A + 80 | 0, A, g), H(t, t, g + 40 | 0), H(A + 120 | 0, g + 120 | 0, I + 120 | 0), H(A, I + 80 | 0, g + 80 | 0), K = o[A + 4 >> 2], Q = o[A + 8 >> 2], i = o[A + 12 >> 2], E = o[A + 16 >> 2], a = o[A + 20 >> 2], f = o[A + 24 >> 2], c = o[A + 28 >> 2], e = o[A + 32 >> 2], r = o[A + 36 >> 2], I = o[t >> 2], g = o[A + 80 >> 2], h = o[A + 44 >> 2], n = o[A + 84 >> 2], s = o[A + 48 >> 2], k = o[A + 88 >> 2], F = o[A + 52 >> 2], S = o[A + 92 >> 2], G = o[A + 56 >> 2], _ = o[A + 96 >> 2], M = o[A + 60 >> 2], p = o[A + 100 >> 2], w = o[y >> 2], N = o[A + 104 >> 2], J = o[A + 68 >> 2], U = o[A + 108 >> 2], Y = o[A + 72 >> 2], d = o[A + 112 >> 2], D = o[A >> 2], C = o[A + 76 >> 2], B = o[A + 116 >> 2], o[A + 76 >> 2] = C + B, o[A + 72 >> 2] = Y + d, o[A + 68 >> 2] = J + U, o[y >> 2] = w + N, o[A + 60 >> 2] = M + p, o[A + 56 >> 2] = G + _, o[A + 52 >> 2] = F + S, o[A + 48 >> 2] = s + k, o[A + 44 >> 2] = h + n, o[t >> 2] = I + g, o[A + 36 >> 2] = B - C, o[A + 32 >> 2] = d - Y, o[A + 28 >> 2] = U - J, o[A + 24 >> 2] = N - w, o[A + 20 >> 2] = p - M, o[A + 16 >> 2] = _ - G, o[A + 12 >> 2] = S - F, o[A + 8 >> 2] = k - s, o[A + 4 >> 2] = n - h, o[A >> 2] = g - I, I = r << 1, g = o[A + 156 >> 2], o[A + 156 >> 2] = I - g, t = e << 1, y = o[A + 152 >> 2], o[A + 152 >> 2] = t - y, h = c << 1, n = o[A + 148 >> 2], o[A + 148 >> 2] = h - n, s = f << 1, k = o[A + 144 >> 2], o[A + 144 >> 2] = s - k, F = a << 1, S = o[A + 140 >> 2], o[A + 140 >> 2] = F - S, G = E << 1, _ = o[A + 136 >> 2], o[A + 136 >> 2] = G - _, M = i << 1, p = o[A + 132 >> 2], o[A + 132 >> 2] = M - p, w = Q << 1, N = o[A + 128 >> 2], o[A + 128 >> 2] = w - N, J = K << 1, U = o[A + 124 >> 2], o[A + 124 >> 2] = J - U, Y = D << 1, d = o[A + 120 >> 2], o[A + 120 >> 2] = Y - d, o[A + 112 >> 2] = t + y, o[A + 108 >> 2] = h + n, o[A + 104 >> 2] = s + k, o[A + 100 >> 2] = F + S, o[A + 96 >> 2] = G + _, o[A + 92 >> 2] = M + p, o[A + 88 >> 2] = w + N, o[A + 84 >> 2] = J + U, o[A + 80 >> 2] = Y + d, o[A + 116 >> 2] = I + g;
                                    }
                                    function P(A, I, g) {
                                        var C, B, Q, i, E, a, f, c, e, r, D, t = 0, y = 0, w = 0, h = 0, n = 0, s = 0, k = 0, F = 0, S = 0, G = 0, _ = 0, M = 0, p = 0, N = 0, J = 0, U = 0, Y = 0, d = 0, K = 0;
                                        t = o[I + 40 >> 2], y = o[I + 4 >> 2], h = o[I + 44 >> 2], n = o[I + 8 >> 2], s = o[I + 48 >> 2], k = o[I + 12 >> 2], F = o[I + 52 >> 2], S = o[I + 16 >> 2], G = o[I + 56 >> 2], _ = o[I + 20 >> 2], M = o[I + 60 >> 2], p = o[I + 24 >> 2], N = o[(w = I - -64 | 0) >> 2], J = o[I + 28 >> 2], U = o[I + 68 >> 2], Y = o[I + 32 >> 2], d = o[I + 72 >> 2], K = o[I >> 2], o[A + 36 >> 2] = o[I + 36 >> 2] + o[I + 76 >> 2], o[A + 32 >> 2] = Y + d, o[A + 28 >> 2] = J + U, o[A + 24 >> 2] = p + N, o[A + 20 >> 2] = _ + M, o[A + 16 >> 2] = S + G, o[A + 12 >> 2] = k + F, o[A + 8 >> 2] = n + s, o[A + 4 >> 2] = y + h, o[A >> 2] = t + K, h = o[I + 40 >> 2], t = o[I + 4 >> 2], n = o[I + 44 >> 2], s = o[I + 8 >> 2], k = o[I + 48 >> 2], F = o[I + 12 >> 2], S = o[I + 52 >> 2], G = o[I + 16 >> 2], _ = o[I + 56 >> 2], M = o[I + 20 >> 2], p = o[I + 60 >> 2], N = o[I + 24 >> 2], w = o[w >> 2], y = o[I + 28 >> 2], J = o[I + 68 >> 2], U = o[I + 32 >> 2], Y = o[I + 72 >> 2], d = o[I >> 2], o[A + 76 >> 2] = o[I + 76 >> 2] - o[I + 36 >> 2], o[A + 72 >> 2] = Y - U, o[A + 68 >> 2] = J - y, o[(y = A - -64 | 0) >> 2] = w - N, o[A + 60 >> 2] = p - M, o[A + 56 >> 2] = _ - G, o[A + 52 >> 2] = S - F, o[A + 48 >> 2] = k - s, o[A + 44 >> 2] = n - t, o[(t = A + 40 | 0) >> 2] = h - d, H(A + 80 | 0, A, g + 40 | 0), H(t, t, g), H(A + 120 | 0, g + 120 | 0, I + 120 | 0), H(A, I + 80 | 0, g + 80 | 0), K = o[A + 4 >> 2], Q = o[A + 8 >> 2], i = o[A + 12 >> 2], E = o[A + 16 >> 2], a = o[A + 20 >> 2], f = o[A + 24 >> 2], c = o[A + 28 >> 2], e = o[A + 32 >> 2], r = o[A + 36 >> 2], I = o[t >> 2], g = o[A + 80 >> 2], h = o[A + 44 >> 2], n = o[A + 84 >> 2], s = o[A + 48 >> 2], k = o[A + 88 >> 2], F = o[A + 52 >> 2], S = o[A + 92 >> 2], G = o[A + 56 >> 2], _ = o[A + 96 >> 2], M = o[A + 60 >> 2], p = o[A + 100 >> 2], w = o[y >> 2], N = o[A + 104 >> 2], J = o[A + 68 >> 2], U = o[A + 108 >> 2], Y = o[A + 72 >> 2], d = o[A + 112 >> 2], D = o[A >> 2], C = o[A + 76 >> 2], B = o[A + 116 >> 2], o[A + 76 >> 2] = C + B, o[A + 72 >> 2] = Y + d, o[A + 68 >> 2] = J + U, o[y >> 2] = w + N, o[A + 60 >> 2] = M + p, o[A + 56 >> 2] = G + _, o[A + 52 >> 2] = F + S, o[A + 48 >> 2] = s + k, o[A + 44 >> 2] = h + n, o[t >> 2] = I + g, o[A + 36 >> 2] = B - C, o[A + 32 >> 2] = d - Y, o[A + 28 >> 2] = U - J, o[A + 24 >> 2] = N - w, o[A + 20 >> 2] = p - M, o[A + 16 >> 2] = _ - G, o[A + 12 >> 2] = S - F, o[A + 8 >> 2] = k - s, o[A + 4 >> 2] = n - h, o[A >> 2] = g - I, I = o[A + 156 >> 2], g = r << 1, o[A + 156 >> 2] = I + g, t = o[A + 152 >> 2], y = e << 1, o[A + 152 >> 2] = t + y, h = o[A + 148 >> 2], n = c << 1, o[A + 148 >> 2] = h + n, s = o[A + 144 >> 2], k = f << 1, o[A + 144 >> 2] = s + k, F = o[A + 140 >> 2], S = a << 1, o[A + 140 >> 2] = F + S, G = o[A + 136 >> 2], _ = E << 1, o[A + 136 >> 2] = G + _, M = o[A + 132 >> 2], p = i << 1, o[A + 132 >> 2] = M + p, w = o[A + 128 >> 2], N = Q << 1, o[A + 128 >> 2] = w + N, J = o[A + 124 >> 2], U = K << 1, o[A + 124 >> 2] = J + U, Y = o[A + 120 >> 2], d = D << 1, o[A + 120 >> 2] = Y + d, o[A + 112 >> 2] = y - t, o[A + 108 >> 2] = n - h, o[A + 104 >> 2] = k - s, o[A + 100 >> 2] = S - F, o[A + 96 >> 2] = _ - G, o[A + 92 >> 2] = p - M, o[A + 88 >> 2] = N - w, o[A + 84 >> 2] = U - J, o[A + 80 >> 2] = d - Y, o[A + 116 >> 2] = g - I;
                                    }
                                    function v(A, I, g) {
                                        var C, B, Q, i, E, a, f, c, e, r, D, t = 0, y = 0, w = 0, h = 0, n = 0, s = 0, k = 0, F = 0, S = 0, G = 0, _ = 0, M = 0, p = 0, N = 0, J = 0, U = 0, Y = 0, d = 0, K = 0;
                                        t = o[I + 40 >> 2], y = o[I + 4 >> 2], h = o[I + 44 >> 2], n = o[I + 8 >> 2], s = o[I + 48 >> 2], k = o[I + 12 >> 2], F = o[I + 52 >> 2], S = o[I + 16 >> 2], G = o[I + 56 >> 2], _ = o[I + 20 >> 2], M = o[I + 60 >> 2], p = o[I + 24 >> 2], N = o[(w = I - -64 | 0) >> 2], J = o[I + 28 >> 2], U = o[I + 68 >> 2], Y = o[I + 32 >> 2], d = o[I + 72 >> 2], K = o[I >> 2], o[A + 36 >> 2] = o[I + 36 >> 2] + o[I + 76 >> 2], o[A + 32 >> 2] = Y + d, o[A + 28 >> 2] = J + U, o[A + 24 >> 2] = p + N, o[A + 20 >> 2] = _ + M, o[A + 16 >> 2] = S + G, o[A + 12 >> 2] = k + F, o[A + 8 >> 2] = n + s, o[A + 4 >> 2] = y + h, o[A >> 2] = t + K, h = o[I + 40 >> 2], t = o[I + 4 >> 2], n = o[I + 44 >> 2], s = o[I + 8 >> 2], k = o[I + 48 >> 2], F = o[I + 12 >> 2], S = o[I + 52 >> 2], G = o[I + 16 >> 2], _ = o[I + 56 >> 2], M = o[I + 20 >> 2], p = o[I + 60 >> 2], N = o[I + 24 >> 2], w = o[w >> 2], y = o[I + 28 >> 2], J = o[I + 68 >> 2], U = o[I + 32 >> 2], Y = o[I + 72 >> 2], d = o[I >> 2], o[A + 76 >> 2] = o[I + 76 >> 2] - o[I + 36 >> 2], o[A + 72 >> 2] = Y - U, o[A + 68 >> 2] = J - y, o[(y = A - -64 | 0) >> 2] = w - N, o[A + 60 >> 2] = p - M, o[A + 56 >> 2] = _ - G, o[A + 52 >> 2] = S - F, o[A + 48 >> 2] = k - s, o[A + 44 >> 2] = n - t, o[(t = A + 40 | 0) >> 2] = h - d, H(A + 80 | 0, A, g), H(t, t, g + 40 | 0), H(A + 120 | 0, g + 80 | 0, I + 120 | 0), K = o[I + 80 >> 2], Q = o[I + 84 >> 2], i = o[I + 88 >> 2], E = o[I + 92 >> 2], a = o[I + 96 >> 2], f = o[I + 100 >> 2], c = o[I + 104 >> 2], e = o[I + 108 >> 2], r = o[I + 112 >> 2], D = o[I + 116 >> 2], I = o[t >> 2], g = o[A + 80 >> 2], h = o[A + 44 >> 2], n = o[A + 84 >> 2], s = o[A + 48 >> 2], k = o[A + 88 >> 2], F = o[A + 52 >> 2], S = o[A + 92 >> 2], G = o[A + 56 >> 2], _ = o[A + 96 >> 2], M = o[A + 60 >> 2], p = o[A + 100 >> 2], w = o[y >> 2], N = o[A + 104 >> 2], J = o[A + 68 >> 2], U = o[A + 108 >> 2], Y = o[A + 72 >> 2], d = o[A + 112 >> 2], C = o[A + 76 >> 2], B = o[A + 116 >> 2], o[A + 76 >> 2] = C + B, o[A + 72 >> 2] = Y + d, o[A + 68 >> 2] = J + U, o[y >> 2] = w + N, o[A + 60 >> 2] = M + p, o[A + 56 >> 2] = G + _, o[A + 52 >> 2] = F + S, o[A + 48 >> 2] = s + k, o[A + 44 >> 2] = h + n, o[t >> 2] = I + g, o[A + 36 >> 2] = B - C, o[A + 32 >> 2] = d - Y, o[A + 28 >> 2] = U - J, o[A + 24 >> 2] = N - w, o[A + 20 >> 2] = p - M, o[A + 16 >> 2] = _ - G, o[A + 12 >> 2] = S - F, o[A + 8 >> 2] = k - s, o[A + 4 >> 2] = n - h, o[A >> 2] = g - I, I = D << 1, g = o[A + 156 >> 2], o[A + 156 >> 2] = I - g, t = r << 1, y = o[A + 152 >> 2], o[A + 152 >> 2] = t - y, h = e << 1, n = o[A + 148 >> 2], o[A + 148 >> 2] = h - n, s = c << 1, k = o[A + 144 >> 2], o[A + 144 >> 2] = s - k, F = f << 1, S = o[A + 140 >> 2], o[A + 140 >> 2] = F - S, G = a << 1, _ = o[A + 136 >> 2], o[A + 136 >> 2] = G - _, M = E << 1, p = o[A + 132 >> 2], o[A + 132 >> 2] = M - p, w = i << 1, N = o[A + 128 >> 2], o[A + 128 >> 2] = w - N, J = Q << 1, U = o[A + 124 >> 2], o[A + 124 >> 2] = J - U, Y = K << 1, d = o[A + 120 >> 2], o[A + 120 >> 2] = Y - d, o[A + 112 >> 2] = t + y, o[A + 108 >> 2] = h + n, o[A + 104 >> 2] = s + k, o[A + 100 >> 2] = F + S, o[A + 96 >> 2] = G + _, o[A + 92 >> 2] = M + p, o[A + 88 >> 2] = w + N, o[A + 84 >> 2] = J + U, o[A + 80 >> 2] = Y + d, o[A + 116 >> 2] = I + g;
                                    }
                                    function L(A, I) {
                                        var g, C, B, Q, i, E, f, c, e, r, D, t, y, w, n = 0, s = 0, k = 0, F = 0, S = 0, H = 0, G = 0, _ = 0, M = 0, p = 0, N = 0, J = 0, U = 0;
                                        y = a[I + 31 | 0], g = a[I + 30 | 0], C = a[I + 29 | 0], B = a[I + 6 | 0], Q = a[I + 5 | 0], i = a[I + 4 | 0], E = a[I + 9 | 0], f = a[I + 8 | 0], c = a[I + 7 | 0], e = a[I + 12 | 0], N = a[I + 11 | 0], J = a[I + 10 | 0], r = a[I + 15 | 0], U = a[I + 14 | 0], D = a[I + 13 | 0], G = a[I + 28 | 0], p = a[I + 27 | 0], _ = a[I + 26 | 0], H = a[I + 25 | 0], F = a[I + 24 | 0], k = a[I + 23 | 0], w = a[0 | I] | a[I + 1 | 0] << 8 | a[I + 2 | 0] << 16 | a[I + 3 | 0] << 24, S = (s = a[I + 21 | 0]) << 15, s = n = s >>> 17 | 0, M = S, M |= (S = a[I + 20 | 0]) << 7, S = (n = S >>> 25 | 0) | s, s = (n = a[I + 22 | 0]) >>> 9 | 0, n = n << 23 | M, s |= S, t = a[I + 16 | 0] | a[I + 17 | 0] << 8 | a[I + 18 | 0] << 16 | a[I + 19 | 0] << 24, I = 0, S = n, n = (33554431 & (I = (M = t + 16777216 | 0) >>> 0 < 16777216 ? 1 : I)) << 7 | M >>> 25, I = (I >>> 25 | 0) + s | 0, n = (s = S = S + n | 0) >>> 0 < n >>> 0 ? I + 1 | 0 : I, I = (S = s + 33554432 | 0) >>> 0 < 33554432 ? n + 1 | 0 : n, o[A + 24 >> 2] = s - (-67108864 & S), n = (s = k >>> 27 | 0) | F >>> 19 | H >>> 11, s = k = (F = H << 21 | (k = F << 13 | k << 5)) + (s = (67108863 & (s = I)) << 6 | S >>> 26) | 0, I = n, n = (k = F + 16777216 | 0) >>> 0 < 16777216 ? I + 1 | 0 : I, o[A + 28 >> 2] = s - (1040187392 & k), s = (n = (I = n) >>> 25 | 0) + (s = p >>> 20 | _ >>> 28 | G >>> 12) | 0, I = s = (n = k = (I = (33554431 & I) << 7 | k >>> 25) + (p << 12 | _ << 4 | G << 20) | 0) >>> 0 < I >>> 0 ? s + 1 | 0 : s, k = (G = n + 33554432 | 0) >>> 0 < 33554432 ? I + 1 | 0 : I, o[A + 32 >> 2] = n - (-67108864 & G), s = e >>> 13 | (n = N >>> 21 | J >>> 29), I = (s = (p = 16777216 + (N = N << 11 | J << 3 | e << 19) | 0) >>> 0 < 16777216 ? s + 1 | 0 : s) >>> 25 | 0, s = (n = F = U << 10 | D << 2 | r << 18) + (F = (33554431 & s) << 7 | p >>> 25) | 0, n = I + (H = U >>> 22 | D >>> 30 | r >>> 14) | 0, I = n = s >>> 0 < F >>> 0 ? n + 1 | 0 : n, F = ((67108863 & (I = (F = s + 33554432 | 0) >>> 0 < 33554432 ? I + 1 | 0 : I)) << 6 | (n = F) >>> 26) + (_ = t - (-33554432 & M) | 0) | 0, o[A + 20 >> 2] = F, o[A + 16 >> 2] = s - (-67108864 & n), n = Q >>> 18 | i >>> 26 | B >>> 10, s = (n = (_ = 16777216 + (J = Q << 14 | i << 6 | B << 22) | 0) >>> 0 < 16777216 ? n + 1 | 0 : n) >>> 25 | 0, n = (I = F = f << 13 | c << 5 | E << 21) + (F = (33554431 & n) << 7 | _ >>> 25) | 0, I = s + (H = f >>> 19 | c >>> 27 | E >>> 11) | 0, I = n >>> 0 < F >>> 0 ? I + 1 | 0 : I, s = (H = n + 33554432 | 0) >>> 0 < 33554432 ? I + 1 | 0 : I, o[A + 8 >> 2] = n - (-67108864 & H), G = (k = (67108863 & k) << 6 | G >>> 26) + (U = y << 18 & 33292288 | g << 10 | C << 2) | 0, I = n = g >>> 22 | C >>> 30, n = (k = U + 16777216 | 0) >>> 0 < 16777216 ? I + 1 | 0 : I, o[A + 36 >> 2] = G - (33554432 & k), s = N + ((67108863 & s) << 6 | H >>> 26) | 0, o[A + 12 >> 2] = s - (234881024 & p), F = J - (2113929216 & _) | 0, s = kA((33554431 & (I = n)) << 7 | k >>> 25, n = I >>> 25 | 0, 19, 0), I = h, s = (n = s + w | 0) >>> 0 < s >>> 0 ? I + 1 | 0 : I, k = ((67108863 & (s = (I = n + 33554432 | 0) >>> 0 < 33554432 ? s + 1 | 0 : s)) << 6 | I >>> 26) + F | 0, o[A + 4 >> 2] = k, o[A >> 2] = n - (-67108864 & I);
                                    }
                                    function R(A, I, g, C) {
                                        var B, Q = 0, i = 0, f = 0, c = 0, e = 0, r = 0, D = 0, t = 0, y = 0, h = 0, n = 0, s = 0;
                                        if (w = B = w - 704 | 0, g | C) {
                                            if (Q = (C << 3 | g >>> 29) + (i = f = o[A + 76 >> 2]) | 0, e = (r = o[A + 72 >> 2]) + (c = g << 3) | 0, o[A + 72 >> 2] = e, Q = c >>> 0 > e >>> 0 ? Q + 1 | 0 : Q, o[A + 76 >> 2] = Q, f = o[4 + (c = A - -64 | 0) >> 2], f = (D = Q = (0 | Q) == (0 | i) & e >>> 0 < r >>> 0 | Q >>> 0 < i >>> 0) >>> 0 > (Q = Q + o[c >> 2] | 0) >>> 0 ? f + 1 | 0 : f, e = (D = C >>> 29 | 0) + Q | 0, Q = f, o[c >> 2] = e, o[c + 4 >> 2] = e >>> 0 < D >>> 0 ? Q + 1 | 0 : Q, (0 | C) == (0 | (f = D = 0 - ((Q = 0) + ((c = 127 & ((7 & i) << 29 | r >>> 3)) >>> 0 > 128) | 0) | 0)) & g >>> 0 >= (e = 128 - c | 0) >>> 0 | C >>> 0 > f >>> 0) {
                                                if (i = 0, f = 0, !Q & (127 ^ c) >>> 0 >= 3 | Q) for(s = 252 & e, r = A + 80 | 0; E[(Q = i + c | 0) + r | 0] = a[I + i | 0], E[r + (c + (Q = 1 | i) | 0) | 0] = a[I + Q | 0], E[r + (c + (Q = 2 | i) | 0) | 0] = a[I + Q | 0], E[r + (c + (Q = 3 | i) | 0) | 0] = a[I + Q | 0], Q = f, f = (i = i + 4 | 0) >>> 0 < 4 ? Q + 1 | 0 : Q, Q = y, y = Q = (h = h + 4 | 0) >>> 0 < 4 ? Q + 1 | 0 : Q, (0 | h) != (0 | s) | (0 | n) != (0 | Q););
                                                if (r = Q = 0, Q | (y = 3 & e)) for(; E[80 + (A + (Q = i + c | 0) | 0) | 0] = a[I + i | 0], Q = f, f = (i = i + 1 | 0) ? Q : Q + 1 | 0, Q = n, n = Q = (t = t + 1 | 0) ? Q : Q + 1 | 0, (0 | y) != (0 | t) | (0 | r) != (0 | Q););
                                                if (k(A, A + 80 | 0, B, i = B + 640 | 0), I = I + e | 0, !(C = C - ((g >>> 0 < e >>> 0) + D | 0) | 0) & (g = g - e | 0) >>> 0 > 127 | C) for(; k(A, I, B, i), I = I + 128 | 0, !(C = C - (g >>> 0 < 128) | 0) & (g = g - 128 | 0) >>> 0 > 127 | C;);
                                                if (g | C) {
                                                    if (h = 3 & g, e = 0, t = 0, n = 0, i = 0, f = 0, !C & g >>> 0 >= 4 | C) for(c = -4 & g, r = C, y = A + 80 | 0, g = 0, C = 0; E[i + y | 0] = a[I + i | 0], E[(Q = 1 | i) + y | 0] = a[I + Q | 0], E[(Q = 2 | i) + y | 0] = a[I + Q | 0], E[(Q = 3 | i) + y | 0] = a[I + Q | 0], Q = f, f = (i = i + 4 | 0) >>> 0 < 4 ? Q + 1 | 0 : Q, Q = C, C = Q = (g = g + 4 | 0) >>> 0 < 4 ? Q + 1 | 0 : Q, (0 | g) != (0 | c) | (0 | r) != (0 | Q););
                                                    if (e | h) for(; E[80 + (A + i | 0) | 0] = a[I + i | 0], f = (i = i + 1 | 0) ? f : f + 1 | 0, Q = n, n = Q = (t = t + 1 | 0) ? Q : Q + 1 | 0, (0 | t) != (0 | h) | (0 | e) != (0 | Q););
                                                }
                                                iI(B, 704);
                                            } else {
                                                if (i = 0, f = 0, !C & g >>> 0 >= 4 | C) for(e = -4 & g, r = C, C = A + 80 | 0; E[C + (Q = i + c | 0) | 0] = a[I + i | 0], E[C + (D = c + (Q = 1 | i) | 0) | 0] = a[I + Q | 0], E[C + (D = c + (Q = 2 | i) | 0) | 0] = a[I + Q | 0], E[C + (D = c + (Q = 3 | i) | 0) | 0] = a[I + Q | 0], Q = f, f = (i = i + 4 | 0) >>> 0 < 4 ? Q + 1 | 0 : Q, Q = y, y = Q = (h = h + 4 | 0) >>> 0 < 4 ? Q + 1 | 0 : Q, (0 | e) != (0 | h) | (0 | r) != (0 | Q););
                                                if ((g &= 3) | (C = 0)) for(; E[80 + (A + (Q = i + c | 0) | 0) | 0] = a[I + i | 0], f = (i = i + 1 | 0) ? f : f + 1 | 0, Q = n, n = Q = (t = t + 1 | 0) ? Q : Q + 1 | 0, (0 | g) != (0 | t) | (0 | C) != (0 | Q););
                                            }
                                        }
                                        return w = B + 704 | 0, 0;
                                    }
                                    function u(A, I) {
                                        var g, C, B, Q, i = 0, f = 0, c = 0, e = 0, r = 0, D = 0;
                                        for(w = g = w - 480 | 0; c = (f = g + 288 | 0) + (i << 1) | 0, e = a[I + i | 0], E[c + 1 | 0] = e >>> 4, E[0 | c] = 15 & e, f = f + ((c = 1 | i) << 1) | 0, c = a[I + c | 0], E[f + 1 | 0] = c >>> 4, E[0 | f] = 15 & c, 32 != (0 | (i = i + 2 | 0)););
                                        for(I = 0; i = 8 + (f = (i = I) + a[0 | (I = (g + 288 | 0) + r | 0)] | 0) | 0, E[0 | I] = f - (240 & i), i = 8 + (f = a[I + 1 | 0] + (i << 24 >> 24 >> 4) | 0) | 0, E[I + 1 | 0] = f - (240 & i), i = 8 + (f = a[I + 2 | 0] + (i << 24 >> 24 >> 4) | 0) | 0, E[I + 2 | 0] = f - (240 & i), I = i << 24 >> 24 >> 4, 63 != (0 | (r = r + 3 | 0)););
                                        for(E[g + 351 | 0] = a[g + 351 | 0] + I, o[A + 32 >> 2] = 0, o[A + 36 >> 2] = 0, o[A + 24 >> 2] = 0, o[A + 28 >> 2] = 0, o[A + 16 >> 2] = 0, o[A + 20 >> 2] = 0, o[A + 8 >> 2] = 0, o[A + 12 >> 2] = 0, o[A >> 2] = 0, o[A + 4 >> 2] = 0, o[A + 44 >> 2] = 0, o[A + 48 >> 2] = 0, o[(I = A + 40 | 0) >> 2] = 1, o[A + 52 >> 2] = 0, o[A + 56 >> 2] = 0, o[A + 60 >> 2] = 0, o[A + 64 >> 2] = 0, o[A + 68 >> 2] = 0, o[A + 72 >> 2] = 0, o[A + 76 >> 2] = 0, o[A + 80 >> 2] = 1, dA(A + 84 | 0, 0, 76), B = A + 120 | 0, r = A + 80 | 0, f = g + 208 | 0, C = g + 168 | 0, c = g + 248 | 0, i = 1; V(D = g + 8 | 0, i >>> 1 | 0, E[(g + 288 | 0) + i | 0]), v(e = g + 128 | 0, A, D), H(A, e, c), H(I, C, f), H(r, f, c), H(B, e, C), D = i >>> 0 < 62, i = i + 2 | 0, D;);
                                        for(i = o[A + 36 >> 2], o[g + 392 >> 2] = o[A + 32 >> 2], o[g + 396 >> 2] = i, i = o[A + 28 >> 2], o[g + 384 >> 2] = o[A + 24 >> 2], o[g + 388 >> 2] = i, i = o[A + 20 >> 2], o[g + 376 >> 2] = o[A + 16 >> 2], o[g + 380 >> 2] = i, i = o[A + 12 >> 2], o[g + 368 >> 2] = o[A + 8 >> 2], o[g + 372 >> 2] = i, i = o[A + 4 >> 2], o[g + 360 >> 2] = o[A >> 2], o[g + 364 >> 2] = i, i = o[I + 12 >> 2], o[g + 408 >> 2] = o[I + 8 >> 2], o[g + 412 >> 2] = i, i = o[I + 20 >> 2], o[g + 416 >> 2] = o[I + 16 >> 2], o[g + 420 >> 2] = i, i = o[I + 28 >> 2], o[g + 424 >> 2] = o[I + 24 >> 2], o[g + 428 >> 2] = i, i = o[I + 36 >> 2], o[g + 432 >> 2] = o[I + 32 >> 2], o[g + 436 >> 2] = i, i = o[I + 4 >> 2], o[g + 400 >> 2] = o[I >> 2], o[g + 404 >> 2] = i, i = o[r + 12 >> 2], o[g + 448 >> 2] = o[r + 8 >> 2], o[g + 452 >> 2] = i, i = o[r + 20 >> 2], o[g + 456 >> 2] = o[r + 16 >> 2], o[g + 460 >> 2] = i, i = o[r + 28 >> 2], o[g + 464 >> 2] = o[r + 24 >> 2], o[g + 468 >> 2] = i, i = o[r + 36 >> 2], o[g + 472 >> 2] = o[r + 32 >> 2], o[g + 476 >> 2] = i, i = o[r + 4 >> 2], o[g + 440 >> 2] = o[r >> 2], o[g + 444 >> 2] = i, G(e, i = g + 360 | 0), H(i, e, c), H(D = g + 400 | 0, C, f), H(Q = g + 440 | 0, f, c), G(e, i), H(i, e, c), H(D, C, f), H(Q, f, c), G(e, i), H(i, e, c), H(D, C, f), H(Q, f, c), G(e, i), H(A, e, c), H(I, C, f), H(r, f, c), H(B, e, C), i = 0; V(D = g + 8 | 0, i >>> 1 | 0, E[(g + 288 | 0) + i | 0]), v(e = g + 128 | 0, A, D), H(A, e, c), H(I, C, f), H(r, f, c), H(B, e, C), e = i >>> 0 < 62, i = i + 2 | 0, e;);
                                        w = g + 480 | 0;
                                    }
                                    function x(A, I, g) {
                                        var C = 0, B = 0, Q = 0, i = 0, o = 0, f = 0, c = 0, e = 0, r = 0, D = 0, t = 0, y = 0, w = 0, h = 0, n = 0, s = 0, k = 0, F = 0, S = 0, H = 0;
                                        for(B = 2036477234, i = 857760878, C = 1634760805, f = 1797285236, Q = a[I + 12 | 0] | a[I + 13 | 0] << 8 | a[I + 14 | 0] << 16 | a[I + 15 | 0] << 24, r = a[I + 8 | 0] | a[I + 9 | 0] << 8 | a[I + 10 | 0] << 16 | a[I + 11 | 0] << 24, o = a[I + 4 | 0] | a[I + 5 | 0] << 8 | a[I + 6 | 0] << 16 | a[I + 7 | 0] << 24, D = a[g + 28 | 0] | a[g + 29 | 0] << 8 | a[g + 30 | 0] << 16 | a[g + 31 | 0] << 24, c = a[g + 24 | 0] | a[g + 25 | 0] << 8 | a[g + 26 | 0] << 16 | a[g + 27 | 0] << 24, k = a[g + 20 | 0] | a[g + 21 | 0] << 8 | a[g + 22 | 0] << 16 | a[g + 23 | 0] << 24, t = a[g + 16 | 0] | a[g + 17 | 0] << 8 | a[g + 18 | 0] << 16 | a[g + 19 | 0] << 24, y = a[g + 12 | 0] | a[g + 13 | 0] << 8 | a[g + 14 | 0] << 16 | a[g + 15 | 0] << 24, w = a[g + 8 | 0] | a[g + 9 | 0] << 8 | a[g + 10 | 0] << 16 | a[g + 11 | 0] << 24, h = a[g + 4 | 0] | a[g + 5 | 0] << 8 | a[g + 6 | 0] << 16 | a[g + 7 | 0] << 24, I = a[0 | I] | a[I + 1 | 0] << 8 | a[I + 2 | 0] << 16 | a[I + 3 | 0] << 24, g = a[0 | g] | a[g + 1 | 0] << 8 | a[g + 2 | 0] << 16 | a[g + 3 | 0] << 24; e = g, g = RA((n = I) ^ (I = g + C | 0), 16), e = t = RA(e ^ (C = g + t | 0), 12), F = RA((n = I + t | 0) ^ g, 8), I = RA(e ^ (t = F + C | 0), 7), C = y, y = RA((g = f + y | 0) ^ Q, 16), C = RA(C ^ (D = y + D | 0), 12), Q = w, f = RA((B = B + w | 0) ^ r, 16), Q = RA(Q ^ (w = f + c | 0), 12), c = RA((B = Q + B | 0) ^ f, 8), g = RA(c ^ (f = I + (s = g + C | 0) | 0), 16), r = RA((i = i + h | 0) ^ o, 16), h = RA((o = r + k | 0) ^ h, 12), e = I, I = RA((i = i + h | 0) ^ r, 8), e = RA(e ^ (o = g + (S = I + o | 0) | 0), 12), r = RA(g ^ (f = e + f | 0), 8), g = RA((k = r + o | 0) ^ e, 7), e = B, B = C, s = RA(y ^ s, 8), B = RA(B ^ (C = s + D | 0), 7), y = RA((o = e + B | 0) ^ I, 16), D = RA((I = y + t | 0) ^ B, 12), o = RA(y ^ (B = D + o | 0), 8), y = RA((t = I + o | 0) ^ D, 7), I = RA((I = Q) ^ (Q = c + w | 0), 7), w = RA((i = I + i | 0) ^ F, 16), c = RA(I ^ (C = w + C | 0), 12), I = RA(w ^ (i = c + i | 0), 8), w = RA((D = C + I | 0) ^ c, 7), e = Q, C = RA(h ^ S, 7), c = RA((Q = C + n | 0) ^ s, 16), n = RA(C ^ (h = e + c | 0), 12), Q = RA(c ^ (C = n + Q | 0), 8), h = RA((c = h + Q | 0) ^ n, 7), 10 != (0 | (H = H + 1 | 0)););
                                        E[0 | A] = C, E[A + 1 | 0] = C >>> 8, E[A + 2 | 0] = C >>> 16, E[A + 3 | 0] = C >>> 24, E[A + 28 | 0] = Q, E[A + 29 | 0] = Q >>> 8, E[A + 30 | 0] = Q >>> 16, E[A + 31 | 0] = Q >>> 24, E[A + 24 | 0] = r, E[A + 25 | 0] = r >>> 8, E[A + 26 | 0] = r >>> 16, E[A + 27 | 0] = r >>> 24, E[A + 20 | 0] = o, E[A + 21 | 0] = o >>> 8, E[A + 22 | 0] = o >>> 16, E[A + 23 | 0] = o >>> 24, E[A + 16 | 0] = I, E[A + 17 | 0] = I >>> 8, E[A + 18 | 0] = I >>> 16, E[A + 19 | 0] = I >>> 24, E[A + 12 | 0] = f, E[A + 13 | 0] = f >>> 8, E[A + 14 | 0] = f >>> 16, E[A + 15 | 0] = f >>> 24, E[A + 8 | 0] = B, E[A + 9 | 0] = B >>> 8, E[A + 10 | 0] = B >>> 16, E[A + 11 | 0] = B >>> 24, E[A + 4 | 0] = i, E[A + 5 | 0] = i >>> 8, E[A + 6 | 0] = i >>> 16, E[A + 7 | 0] = i >>> 24;
                                    }
                                    function m(A, I, g) {
                                        var C = 0, B = 0, Q = 0, i = 0, o = 0, f = 0, c = 0, e = 0, r = 0, D = 0, t = 0, y = 0, w = 0, h = 0, n = 0, s = 0, k = 0, F = 0, S = 0, H = 0;
                                        for(C = 1797285236, c = 2036477234, e = 857760878, B = 1634760805, Q = a[I + 12 | 0] | a[I + 13 | 0] << 8 | a[I + 14 | 0] << 16 | a[I + 15 | 0] << 24, o = a[I + 8 | 0] | a[I + 9 | 0] << 8 | a[I + 10 | 0] << 16 | a[I + 11 | 0] << 24, i = a[I + 4 | 0] | a[I + 5 | 0] << 8 | a[I + 6 | 0] << 16 | a[I + 7 | 0] << 24, n = a[g + 28 | 0] | a[g + 29 | 0] << 8 | a[g + 30 | 0] << 16 | a[g + 31 | 0] << 24, h = a[g + 24 | 0] | a[g + 25 | 0] << 8 | a[g + 26 | 0] << 16 | a[g + 27 | 0] << 24, s = 20, y = a[g + 20 | 0] | a[g + 21 | 0] << 8 | a[g + 22 | 0] << 16 | a[g + 23 | 0] << 24, w = a[g + 16 | 0] | a[g + 17 | 0] << 8 | a[g + 18 | 0] << 16 | a[g + 19 | 0] << 24, r = a[g + 12 | 0] | a[g + 13 | 0] << 8 | a[g + 14 | 0] << 16 | a[g + 15 | 0] << 24, D = a[g + 8 | 0] | a[g + 9 | 0] << 8 | a[g + 10 | 0] << 16 | a[g + 11 | 0] << 24, t = a[g + 4 | 0] | a[g + 5 | 0] << 8 | a[g + 6 | 0] << 16 | a[g + 7 | 0] << 24, I = a[0 | I] | a[I + 1 | 0] << 8 | a[I + 2 | 0] << 16 | a[I + 3 | 0] << 24, g = a[0 | g] | a[g + 1 | 0] << 8 | a[g + 2 | 0] << 16 | a[g + 3 | 0] << 24; f = RA(g + e | 0, 7) ^ Q, k = RA(f + e | 0, 9) ^ h, r = RA(B + y | 0, 7) ^ r, F = RA(r + B | 0, 9) ^ o, S = RA(F + r | 0, 13) ^ y, D = RA(C + w | 0, 7) ^ D, i = RA(D + C | 0, 9) ^ i, o = RA(i + D | 0, 13) ^ w, C = RA(i + o | 0, 18) ^ C, Q = RA(I + c | 0, 7) ^ n, y = S ^ RA(C + Q | 0, 7), h = k ^ RA(y + C | 0, 9), n = RA(y + h | 0, 13) ^ Q, C = RA(h + n | 0, 18) ^ C, t = RA(Q + c | 0, 9) ^ t, H = RA(t + Q | 0, 13) ^ I, I = RA(H + t | 0, 18) ^ c, w = RA(I + f | 0, 7) ^ o, o = RA(w + I | 0, 9) ^ F, Q = RA(o + w | 0, 13) ^ f, c = RA(Q + o | 0, 18) ^ I, f = RA(f + k | 0, 13) ^ g, g = RA(f + k | 0, 18) ^ e, I = RA(g + r | 0, 7) ^ H, i = RA(I + g | 0, 9) ^ i, r = RA(I + i | 0, 13) ^ r, e = RA(i + r | 0, 18) ^ g, B = RA(F + S | 0, 18) ^ B, g = RA(B + D | 0, 7) ^ f, t = RA(g + B | 0, 9) ^ t, D = RA(g + t | 0, 13) ^ D, B = RA(t + D | 0, 18) ^ B, f = s >>> 0 > 2, s = s - 2 | 0, f;);
                                        return E[0 | A] = B, E[A + 1 | 0] = B >>> 8, E[A + 2 | 0] = B >>> 16, E[A + 3 | 0] = B >>> 24, E[A + 28 | 0] = Q, E[A + 29 | 0] = Q >>> 8, E[A + 30 | 0] = Q >>> 16, E[A + 31 | 0] = Q >>> 24, E[A + 24 | 0] = o, E[A + 25 | 0] = o >>> 8, E[A + 26 | 0] = o >>> 16, E[A + 27 | 0] = o >>> 24, E[A + 20 | 0] = i, E[A + 21 | 0] = i >>> 8, E[A + 22 | 0] = i >>> 16, E[A + 23 | 0] = i >>> 24, E[A + 16 | 0] = I, E[A + 17 | 0] = I >>> 8, E[A + 18 | 0] = I >>> 16, E[A + 19 | 0] = I >>> 24, E[A + 12 | 0] = C, E[A + 13 | 0] = C >>> 8, E[A + 14 | 0] = C >>> 16, E[A + 15 | 0] = C >>> 24, E[A + 8 | 0] = c, E[A + 9 | 0] = c >>> 8, E[A + 10 | 0] = c >>> 16, E[A + 11 | 0] = c >>> 24, E[A + 4 | 0] = e, E[A + 5 | 0] = e >>> 8, E[A + 6 | 0] = e >>> 16, E[A + 7 | 0] = e >>> 24, 0;
                                    }
                                    function l(A, I) {
                                        var g, C, B = 0, Q = 0, i = 0, a = 0;
                                        w = g = w - 288 | 0, Q = 40 + ((B = o[A + 32 >> 2] >>> 3 & 63) + A | 0) | 0, B >>> 0 >= 56 ? (YA(Q, 34224, 64 - B | 0), _(A, A + 40 | 0, g, g + 256 | 0), o[A + 88 >> 2] = 0, o[A + 92 >> 2] = 0, o[A + 80 >> 2] = 0, o[A + 84 >> 2] = 0, o[A + 72 >> 2] = 0, o[A + 76 >> 2] = 0, o[(B = A - -64 | 0) >> 2] = 0, o[B + 4 >> 2] = 0, o[A + 56 >> 2] = 0, o[A + 60 >> 2] = 0, o[A + 48 >> 2] = 0, o[A + 52 >> 2] = 0, o[A + 40 >> 2] = 0, o[A + 44 >> 2] = 0) : YA(Q, 34224, 56 - B | 0), i = (B = 16711680 & (Q = o[A + 32 >> 2])) >>> 8 | 0, a = B << 24, C = (B = -16777216 & Q) >>> 24 | 0, B = (a |= B << 8) | -16777216 & ((255 & (B = o[A + 36 >> 2])) << 24 | Q >>> 8) | 16711680 & ((16777215 & B) << 8 | Q >>> 24) | B >>> 8 & 65280 | B >>> 24, E[A + 96 | 0] = B, E[A + 97 | 0] = B >>> 8, E[A + 98 | 0] = B >>> 16, E[A + 99 | 0] = B >>> 24, B = (B = i | C | Q << 24 | (65280 & Q) << 8) | (i = 0) | i, E[A + 100 | 0] = B, E[A + 101 | 0] = B >>> 8, E[A + 102 | 0] = B >>> 16, E[A + 103 | 0] = B >>> 24, _(A, A + 40 | 0, g, g + 256 | 0), B = (B = o[A >> 2]) << 24 | (65280 & B) << 8 | B >>> 8 & 65280 | B >>> 24, E[0 | I] = B, E[I + 1 | 0] = B >>> 8, E[I + 2 | 0] = B >>> 16, E[I + 3 | 0] = B >>> 24, B = (B = o[A + 4 >> 2]) << 24 | (65280 & B) << 8 | B >>> 8 & 65280 | B >>> 24, E[I + 4 | 0] = B, E[I + 5 | 0] = B >>> 8, E[I + 6 | 0] = B >>> 16, E[I + 7 | 0] = B >>> 24, B = (B = o[A + 8 >> 2]) << 24 | (65280 & B) << 8 | B >>> 8 & 65280 | B >>> 24, E[I + 8 | 0] = B, E[I + 9 | 0] = B >>> 8, E[I + 10 | 0] = B >>> 16, E[I + 11 | 0] = B >>> 24, B = (B = o[A + 12 >> 2]) << 24 | (65280 & B) << 8 | B >>> 8 & 65280 | B >>> 24, E[I + 12 | 0] = B, E[I + 13 | 0] = B >>> 8, E[I + 14 | 0] = B >>> 16, E[I + 15 | 0] = B >>> 24, B = (B = o[A + 16 >> 2]) << 24 | (65280 & B) << 8 | B >>> 8 & 65280 | B >>> 24, E[I + 16 | 0] = B, E[I + 17 | 0] = B >>> 8, E[I + 18 | 0] = B >>> 16, E[I + 19 | 0] = B >>> 24, B = (B = o[A + 20 >> 2]) << 24 | (65280 & B) << 8 | B >>> 8 & 65280 | B >>> 24, E[I + 20 | 0] = B, E[I + 21 | 0] = B >>> 8, E[I + 22 | 0] = B >>> 16, E[I + 23 | 0] = B >>> 24, B = (B = o[A + 24 >> 2]) << 24 | (65280 & B) << 8 | B >>> 8 & 65280 | B >>> 24, E[I + 24 | 0] = B, E[I + 25 | 0] = B >>> 8, E[I + 26 | 0] = B >>> 16, E[I + 27 | 0] = B >>> 24, B = (B = o[A + 28 >> 2]) << 24 | (65280 & B) << 8 | B >>> 8 & 65280 | B >>> 24, E[I + 28 | 0] = B, E[I + 29 | 0] = B >>> 8, E[I + 30 | 0] = B >>> 16, E[I + 31 | 0] = B >>> 24, iI(g, 288), iI(A, 104), w = g + 288 | 0;
                                    }
                                    function z(A, I, g) {
                                        var C, B = 0, Q = 0, i = 0, f = 0, c = 0, e = 0, r = 0, D = 0, t = 0, y = 0, h = 0, n = 0;
                                        if (w = C = w - 288 | 0, g) {
                                            if (e = (B = o[A + 36 >> 2]) + (g >>> 29 | 0) | 0, t = (i = o[A + 32 >> 2]) + (f = g << 3) | 0, o[A + 32 >> 2] = t, o[A + 36 >> 2] = f >>> 0 > t >>> 0 ? e + 1 | 0 : e, !0 & (f = 64 - (e = 63 & ((7 & B) << 29 | i >>> 3)) | 0) >>> 0 <= g >>> 0) {
                                                if (B = 0, i = 0, (63 ^ e) >>> 0 >= 3) for(n = 124 & f, t = A + 40 | 0; E[(B + e | 0) + t | 0] = a[I + B | 0], E[(e + (h = 1 | B) | 0) + t | 0] = a[I + h | 0], E[(e + (h = 2 | B) | 0) + t | 0] = a[I + h | 0], E[(e + (h = 3 | B) | 0) + t | 0] = a[I + h | 0], i = (B = B + 4 | 0) >>> 0 < 4 ? i + 1 | 0 : i, (Q = (y = y + 4 | 0) >>> 0 < 4 ? Q + 1 | 0 : Q) | (0 | y) != (0 | n););
                                                if (Q = 3 & f) for(; E[40 + ((B + e | 0) + A | 0) | 0] = a[I + B | 0], i = (B = B + 1 | 0) ? i : i + 1 | 0, (r = (D = D + 1 | 0) ? r : r + 1 | 0) | (0 | Q) != (0 | D););
                                                if (_(A, A + 40 | 0, C, r = C + 256 | 0), I = I + f | 0, !(Q = 0 - ((g >>> 0 < f >>> 0) + c | 0) | 0) & (g = g - f | 0) >>> 0 > 63 | Q) for(; _(A, I, C, r), I = I - -64 | 0, Q = Q - 1 | 0, !(Q = (g = g + -64 | 0) >>> 0 < 4294967232 ? Q + 1 | 0 : Q) & g >>> 0 > 63 | Q;);
                                                if (g | Q) {
                                                    if (y = 3 & g, D = 0, r = 0, B = 0, i = 0, !Q & g >>> 0 >= 4 | Q) for(t = -4 & g, e = Q, f = A + 40 | 0, g = 0, Q = 0; E[B + f | 0] = a[I + B | 0], E[(c = 1 | B) + f | 0] = a[I + c | 0], E[(c = 2 | B) + f | 0] = a[I + c | 0], E[(c = 3 | B) + f | 0] = a[I + c | 0], i = (B = B + 4 | 0) >>> 0 < 4 ? i + 1 | 0 : i, (0 | (g = g + 4 | 0)) != (0 | t) | (0 | (Q = g >>> 0 < 4 ? Q + 1 | 0 : Q)) != (0 | e););
                                                    if (y) for(; E[40 + (A + B | 0) | 0] = a[I + B | 0], i = (B = B + 1 | 0) ? i : i + 1 | 0, (r = (D = D + 1 | 0) ? r : r + 1 | 0) | (0 | D) != (0 | y););
                                                }
                                                iI(C, 288);
                                            } else {
                                                if (B = 0, i = 0, g >>> 0 >= 4) for(t = -4 & g, f = A + 40 | 0; E[(B + e | 0) + f | 0] = a[I + B | 0], E[(e + (c = 1 | B) | 0) + f | 0] = a[I + c | 0], E[(e + (c = 2 | B) | 0) + f | 0] = a[I + c | 0], E[(e + (c = 3 | B) | 0) + f | 0] = a[I + c | 0], i = (B = B + 4 | 0) >>> 0 < 4 ? i + 1 | 0 : i, (Q = (y = y + 4 | 0) >>> 0 < 4 ? Q + 1 | 0 : Q) | (0 | t) != (0 | y););
                                                if (g &= 3) for(; E[40 + ((B + e | 0) + A | 0) | 0] = a[I + B | 0], i = (B = B + 1 | 0) ? i : i + 1 | 0, (r = (D = D + 1 | 0) ? r : r + 1 | 0) | (0 | g) != (0 | D););
                                            }
                                        }
                                        w = C + 288 | 0;
                                    }
                                    function q(A, I, g) {
                                        var C, B = 0, Q = 0, i = 0, f = 0, c = 0, e = 0, r = 0, D = 0;
                                        if (w = C = w - 96 | 0, g >>> 0 >= 65 && (SA(A), z(A, I, g), l(A, C), g = 32, I = C), SA(A), o[C + 88 >> 2] = 909522486, o[C + 92 >> 2] = 909522486, o[C + 80 >> 2] = 909522486, o[C + 84 >> 2] = 909522486, o[C + 72 >> 2] = 909522486, o[C + 76 >> 2] = 909522486, o[(i = r = C - -64 | 0) >> 2] = 909522486, o[i + 4 >> 2] = 909522486, o[C + 56 >> 2] = 909522486, o[C + 60 >> 2] = 909522486, o[C + 48 >> 2] = 909522486, o[C + 52 >> 2] = 909522486, o[C + 40 >> 2] = 909522486, o[C + 44 >> 2] = 909522486, o[C + 32 >> 2] = 909522486, o[C + 36 >> 2] = 909522486, g) {
                                            if (g >>> 0 >= 4) for(f = 124 & g; E[0 | (Q = (i = C + 32 | 0) + B | 0)] = a[0 | Q] ^ a[I + B | 0], E[0 | (D = (Q = 1 | B) + i | 0)] = a[0 | D] ^ a[I + Q | 0], E[0 | (D = (Q = 2 | B) + i | 0)] = a[0 | D] ^ a[I + Q | 0], E[0 | (Q = (Q = i) + (i = 3 | B) | 0)] = a[0 | Q] ^ a[I + i | 0], B = B + 4 | 0, (0 | f) != (0 | (c = c + 4 | 0)););
                                            if (c = 3 & g) for(; E[0 | (i = (C + 32 | 0) + B | 0)] = a[0 | i] ^ a[I + B | 0], B = B + 1 | 0, (0 | c) != (0 | (e = e + 1 | 0)););
                                        }
                                        if (z(A, C + 32 | 0, 64), SA(i = A + 104 | 0), o[C + 88 >> 2] = 1549556828, o[C + 92 >> 2] = 1549556828, o[C + 80 >> 2] = 1549556828, o[C + 84 >> 2] = 1549556828, o[C + 72 >> 2] = 1549556828, o[C + 76 >> 2] = 1549556828, o[r >> 2] = 1549556828, o[r + 4 >> 2] = 1549556828, o[C + 56 >> 2] = 1549556828, o[C + 60 >> 2] = 1549556828, o[C + 48 >> 2] = 1549556828, o[C + 52 >> 2] = 1549556828, o[C + 40 >> 2] = 1549556828, o[C + 44 >> 2] = 1549556828, o[C + 32 >> 2] = 1549556828, o[C + 36 >> 2] = 1549556828, g) {
                                            if (e = 0, B = 0, g >>> 0 >= 4) for(r = 124 & g, c = 0; E[0 | (f = (A = C + 32 | 0) + B | 0)] = a[0 | f] ^ a[I + B | 0], E[0 | (Q = (f = 1 | B) + A | 0)] = a[0 | Q] ^ a[I + f | 0], E[0 | (Q = (f = 2 | B) + A | 0)] = a[0 | Q] ^ a[I + f | 0], E[0 | (f = (Q = A) + (A = 3 | B) | 0)] = a[0 | f] ^ a[A + I | 0], B = B + 4 | 0, (0 | r) != (0 | (c = c + 4 | 0)););
                                            if (A = 3 & g) for(; E[0 | (g = (C + 32 | 0) + B | 0)] = a[0 | g] ^ a[I + B | 0], B = B + 1 | 0, (0 | A) != (0 | (e = e + 1 | 0)););
                                        }
                                        return z(i, A = C + 32 | 0, 64), iI(A, 64), iI(C, 32), w = C + 96 | 0, 0;
                                    }
                                    function X(A, I, g, C, B, i, E) {
                                        var a = 0, f = 0, c = 0, e = 0, r = 0, D = 0, t = 0;
                                        if (I - 65 >>> 0 < 4294967232 | E >>> 0 > 64) A = -1;
                                        else {
                                            D = a = w, w = a = a - 512 & -64;
                                            A: {
                                                I: if (!(!(!(C | B) | g) | !A | ((f = 255 & I) - 65 & 255) >>> 0 <= 191 | !(!(I = 255 & E) || i) | I >>> 0 >= 65)) {
                                                    if (I) {
                                                        if (!i) break I;
                                                        dA(a - -64 | 0, 0, 293), o[a + 56 >> 2] = 327033209, o[a + 60 >> 2] = 1541459225, o[a + 48 >> 2] = -79577749, o[a + 52 >> 2] = 528734635, o[a + 40 >> 2] = 725511199, o[a + 44 >> 2] = -1694144372, o[a + 32 >> 2] = -1377402159, o[a + 36 >> 2] = 1359893119, o[a + 24 >> 2] = 1595750129, o[a + 28 >> 2] = -1521486534, o[a + 16 >> 2] = -23791573, o[a + 20 >> 2] = 1013904242, o[a + 8 >> 2] = -2067093701, o[a + 12 >> 2] = -1150833019, o[a >> 2] = -222443256 ^ (I << 8 | f), o[a + 4 >> 2] = I >>> 24 ^ 1779033703, dA((E = a + 384 | 0) + I | 0, 0, 128 - I | 0), YA(E, i, I), YA(a + 96 | 0, E, 128), o[a + 352 >> 2] = 128, iI(E, 128), I = 128;
                                                    } else dA(a - -64 | 0, 0, 293), o[a + 56 >> 2] = 327033209, o[a + 60 >> 2] = 1541459225, o[a + 48 >> 2] = -79577749, o[a + 52 >> 2] = 528734635, o[a + 40 >> 2] = 725511199, o[a + 44 >> 2] = -1694144372, o[a + 32 >> 2] = -1377402159, o[a + 36 >> 2] = 1359893119, o[a + 24 >> 2] = 1595750129, o[a + 28 >> 2] = -1521486534, o[a + 16 >> 2] = -23791573, o[a + 20 >> 2] = 1013904242, o[a + 8 >> 2] = -2067093701, o[a + 12 >> 2] = -1150833019, o[a >> 2] = -222443256 ^ f, o[a + 4 >> 2] = 1779033703, I = 0;
                                                    g: if (C | B) for(t = a + 224 | 0, c = a + 96 | 0;;){
                                                        if (E = I + c | 0, !B & C >>> 0 <= (i = 256 - I | 0) >>> 0) {
                                                            YA(E, g, C), o[a + 352 >> 2] = C + o[a + 352 >> 2];
                                                            break g;
                                                        }
                                                        if (YA(E, g, i), o[a + 352 >> 2] = i + o[a + 352 >> 2], e = I = o[a + 68 >> 2], I = (r = (E = o[a + 64 >> 2]) + 128 | 0) >>> 0 < 128 ? I + 1 | 0 : I, o[a + 64 >> 2] = r, o[a + 68 >> 2] = I, I = o[a + 76 >> 2], I = (e = E = -1 == (0 | e) & E >>> 0 > 4294967167) >>> 0 > (E = E + o[a + 72 >> 2] | 0) >>> 0 ? I + 1 | 0 : I, o[a + 72 >> 2] = E, o[a + 76 >> 2] = I, n(a, c), YA(c, t, 128), I = o[a + 352 >> 2] - 128 | 0, o[a + 352 >> 2] = I, g = g + i | 0, !((B = B - (C >>> 0 < i >>> 0) | 0) | (C = C - i | 0))) break;
                                                    }
                                                    J(a, A, f), w = D;
                                                    break A;
                                                }
                                                zA(), Q();
                                            }
                                            A = 0;
                                        }
                                        return A;
                                    }
                                    function j(A, I, g, C) {
                                        var B = 0, Q = 0, i = 0, f = 0, c = 0, e = 0, r = 0, D = 0, t = 0, y = 0, w = 0, h = 0;
                                        A: {
                                            if ((i = o[A + 56 >> 2]) | (B = o[A + 60 >> 2])) {
                                                if (t = Q = 16 - i | 0, c = (Q = (0 | (f = 0 - ((i >>> 0 > 16) + B | 0) | 0)) == (0 | C) & g >>> 0 > Q >>> 0 | C >>> 0 > f >>> 0) ? t : g, t = Q = Q ? f : C, Q | c) {
                                                    if (Q = 0, i = 0, !t & c >>> 0 >= 4 | t) for(e = -4 & c, f = A - -64 | 0; B = Q + o[A + 56 >> 2] | 0, E[B + f | 0] = a[I + Q | 0], B = (y = 1 | Q) + o[A + 56 >> 2] | 0, E[B + f | 0] = a[I + y | 0], B = (y = 2 | Q) + o[A + 56 >> 2] | 0, E[B + f | 0] = a[I + y | 0], B = (y = 3 | Q) + o[A + 56 >> 2] | 0, E[B + f | 0] = a[I + y | 0], B = i, i = (Q = Q + 4 | 0) >>> 0 < 4 ? B + 1 | 0 : B, B = r, r = B = (D = D + 4 | 0) >>> 0 < 4 ? B + 1 | 0 : B, (0 | D) != (0 | e) | (0 | t) != (0 | B););
                                                    if (f = B = 0, B | (r = 3 & c)) for(; D = Q + o[A + 56 >> 2] | 0, E[(A + D | 0) - -64 | 0] = a[I + Q | 0], i = (Q = Q + 1 | 0) ? i : i + 1 | 0, B = h, h = B = (w = w + 1 | 0) ? B : B + 1 | 0, (0 | r) != (0 | w) | (0 | f) != (0 | B););
                                                    i = o[A + 56 >> 2], B = o[A + 60 >> 2];
                                                }
                                                if (B = B + t | 0, B = (i = i + c | 0) >>> 0 < c >>> 0 ? B + 1 | 0 : B, o[A + 56 >> 2] = i, o[A + 60 >> 2] = B, !B & i >>> 0 < 16) break A;
                                                d(A, A - -64 | 0, 16, 0), o[A + 56 >> 2] = 0, o[A + 60 >> 2] = 0, g = (i = g) - c | 0, C = C - ((i >>> 0 < c >>> 0) + t | 0) | 0, I = I + c | 0;
                                            }
                                            if (!C & g >>> 0 >= 16 | C && (d(A, I, i = -16 & g, C), g &= 15, C = 0, I = I + i | 0), g | C) {
                                                if (w = 0, h = 0, Q = 0, i = 0, !C & g >>> 0 >= 4 | C) for(c = 12 & g, t = 0, f = A - -64 | 0, D = 0, r = 0; B = Q + o[A + 56 >> 2] | 0, E[B + f | 0] = a[I + Q | 0], B = (e = 1 | Q) + o[A + 56 >> 2] | 0, E[B + f | 0] = a[I + e | 0], B = (e = 2 | Q) + o[A + 56 >> 2] | 0, E[B + f | 0] = a[I + e | 0], B = (e = 3 | Q) + o[A + 56 >> 2] | 0, E[B + f | 0] = a[I + e | 0], i = (Q = Q + 4 | 0) >>> 0 < 4 ? i + 1 | 0 : i, B = r, r = B = (D = D + 4 | 0) >>> 0 < 4 ? B + 1 | 0 : B, (0 | c) != (0 | D) | (0 | t) != (0 | B););
                                                if (f = B = 0, B | (r = 3 & g)) for(; B = Q + o[A + 56 >> 2] | 0, E[(A + B | 0) - -64 | 0] = a[I + Q | 0], i = (Q = Q + 1 | 0) ? i : i + 1 | 0, B = h, h = B = (w = w + 1 | 0) ? B : B + 1 | 0, (0 | r) != (0 | w) | (0 | f) != (0 | B););
                                                i = C + o[A + 60 >> 2] | 0, i = (I = g + o[A + 56 >> 2] | 0) >>> 0 < g >>> 0 ? i + 1 | 0 : i, o[A + 56 >> 2] = I, o[A + 60 >> 2] = i;
                                            }
                                        }
                                    }
                                    function T(A, I, g) {
                                        var C, B = 0, Q = 0, i = 0, E = 0, a = 0, f = 0, c = 0, e = 0, r = 0, D = 0, t = 0, y = 0, w = 0, h = 0, n = 0, s = 0, k = 0, F = 0, S = 0;
                                        y = o[I + 4 >> 2], B = o[A + 4 >> 2], w = o[I + 8 >> 2], Q = o[A + 8 >> 2], h = o[I + 12 >> 2], i = o[A + 12 >> 2], n = o[I + 16 >> 2], E = o[A + 16 >> 2], s = o[I + 20 >> 2], a = o[A + 20 >> 2], k = o[I + 24 >> 2], f = o[A + 24 >> 2], D = o[I + 28 >> 2], c = o[A + 28 >> 2], F = o[I + 32 >> 2], e = o[A + 32 >> 2], S = o[I + 36 >> 2], r = o[A + 36 >> 2], g = 0 - g | 0, t = o[A >> 2], o[A >> 2] = g & (t ^ o[I >> 2]) ^ t, o[A + 36 >> 2] = r ^ g & (r ^ S), o[A + 32 >> 2] = e ^ g & (e ^ F), o[A + 28 >> 2] = c ^ g & (c ^ D), o[A + 24 >> 2] = f ^ g & (f ^ k), o[A + 20 >> 2] = a ^ g & (a ^ s), o[A + 16 >> 2] = E ^ g & (E ^ n), o[A + 12 >> 2] = i ^ g & (i ^ h), o[A + 8 >> 2] = Q ^ g & (Q ^ w), o[A + 4 >> 2] = B ^ g & (B ^ y), B = o[A + 40 >> 2], y = o[I + 40 >> 2], Q = o[A + 44 >> 2], w = o[I + 44 >> 2], i = o[A + 48 >> 2], h = o[I + 48 >> 2], E = o[A + 52 >> 2], n = o[I + 52 >> 2], a = o[A + 56 >> 2], s = o[I + 56 >> 2], f = o[A + 60 >> 2], k = o[I + 60 >> 2], c = o[(D = A - -64 | 0) >> 2], F = o[I - -64 >> 2], e = o[A + 68 >> 2], S = o[I + 68 >> 2], r = o[A + 72 >> 2], t = o[I + 72 >> 2], C = o[A + 76 >> 2], o[A + 76 >> 2] = C ^ g & (o[I + 76 >> 2] ^ C), o[A + 72 >> 2] = r ^ g & (r ^ t), o[A + 68 >> 2] = e ^ g & (e ^ S), o[D >> 2] = c ^ g & (c ^ F), o[A + 60 >> 2] = f ^ g & (f ^ k), o[A + 56 >> 2] = a ^ g & (a ^ s), o[A + 52 >> 2] = E ^ g & (E ^ n), o[A + 48 >> 2] = i ^ g & (i ^ h), o[A + 44 >> 2] = Q ^ g & (Q ^ w), o[A + 40 >> 2] = B ^ g & (B ^ y), B = o[A + 80 >> 2], y = o[I + 80 >> 2], Q = o[A + 84 >> 2], w = o[I + 84 >> 2], i = o[A + 88 >> 2], h = o[I + 88 >> 2], E = o[A + 92 >> 2], n = o[I + 92 >> 2], a = o[A + 96 >> 2], s = o[I + 96 >> 2], f = o[A + 100 >> 2], k = o[I + 100 >> 2], c = o[A + 104 >> 2], D = o[I + 104 >> 2], e = o[A + 108 >> 2], F = o[I + 108 >> 2], r = o[A + 112 >> 2], S = o[I + 112 >> 2], t = o[I + 116 >> 2], I = o[A + 116 >> 2], o[A + 116 >> 2] = g & (t ^ I) ^ I, o[A + 112 >> 2] = r ^ g & (r ^ S), o[A + 108 >> 2] = e ^ g & (e ^ F), o[A + 104 >> 2] = c ^ g & (c ^ D), o[A + 100 >> 2] = f ^ g & (f ^ k), o[A + 96 >> 2] = a ^ g & (a ^ s), o[A + 92 >> 2] = E ^ g & (E ^ n), o[A + 88 >> 2] = i ^ g & (i ^ h), o[A + 84 >> 2] = Q ^ g & (Q ^ w), o[A + 80 >> 2] = B ^ g & (B ^ y);
                                    }
                                    function O(A, I) {
                                        var g, C, B = 0;
                                        for(w = g = w - 192 | 0, M(C = g + 144 | 0, I), M(B = g + 96 | 0, C), M(B, B), H(B, I, B), H(C, C, B), M(I = g + 48 | 0, C), H(B, B, I), M(I, B), M(I, I), M(I, I), M(I, I), M(I, I), H(B, I, B), M(I, B), M(I, I), M(I, I), M(I, I), M(I, I), M(I, I), M(I, I), M(I, I), M(I, I), M(I, I), H(I, I, B), M(g, I), M(g, g), M(g, g), M(g, g), M(g, g), M(g, g), M(g, g), M(g, g), M(g, g), M(g, g), M(g, g), M(g, g), M(g, g), M(g, g), M(g, g), M(g, g), M(g, g), M(g, g), M(g, g), M(g, g), H(I, g, I), M(I, I), M(I, I), M(I, I), M(I, I), M(I, I), M(I, I), M(I, I), M(I, I), M(I, I), M(I, I), H(B, I, B), M(I, B), M(I, I), M(I, I), M(I, I), M(I, I), M(I, I), M(I, I), M(I, I), M(I, I), M(I, I), M(I, I), M(I, I), M(I, I), M(I, I), M(I, I), M(I, I), M(I, I), M(I, I), M(I, I), M(I, I), M(I, I), M(I, I), M(I, I), M(I, I), M(I, I), M(I, I), M(I, I), M(I, I), M(I, I), M(I, I), M(I, I), M(I, I), M(I, I), M(I, I), M(I, I), M(I, I), M(I, I), M(I, I), M(I, I), M(I, I), M(I, I), M(I, I), M(I, I), M(I, I), M(I, I), M(I, I), M(I, I), M(I, I), M(I, I), M(I, I), H(I, I, B), M(g, I), I = 1; M(g, g), 100 != (0 | (I = I + 1 | 0)););
                                        H(I = g + 48 | 0, g, I), M(I, I), M(I, I), M(I, I), M(I, I), M(I, I), M(I, I), M(I, I), M(I, I), M(I, I), M(I, I), M(I, I), M(I, I), M(I, I), M(I, I), M(I, I), M(I, I), M(I, I), M(I, I), M(I, I), M(I, I), M(I, I), M(I, I), M(I, I), M(I, I), M(I, I), M(I, I), M(I, I), M(I, I), M(I, I), M(I, I), M(I, I), M(I, I), M(I, I), M(I, I), M(I, I), M(I, I), M(I, I), M(I, I), M(I, I), M(I, I), M(I, I), M(I, I), M(I, I), M(I, I), M(I, I), M(I, I), M(I, I), M(I, I), M(I, I), M(I, I), H(B = g + 96 | 0, I, B), M(B, B), M(B, B), M(B, B), M(B, B), M(B, B), H(A, B, g + 144 | 0), w = g + 192 | 0;
                                    }
                                    function V(A, I, g) {
                                        var C, B, Q, i, E, a, f, e, r = 0;
                                        w = C = w - 128 | 0, o[A >> 2] = 1, o[A + 4 >> 2] = 0, o[A + 8 >> 2] = 0, o[A + 12 >> 2] = 0, o[A + 16 >> 2] = 0, o[A + 20 >> 2] = 0, o[A + 24 >> 2] = 0, o[A + 28 >> 2] = 0, o[A + 32 >> 2] = 0, o[A + 36 >> 2] = 0, o[A + 40 >> 2] = 1, dA(A + 44 | 0, 0, 76), T(A, I = c(I, 960) + 2704 | 0, (255 & (1 ^ (r = g - ((g >> 31 & g) << 1) | 0))) - 1 >>> 31 | 0), T(A, I + 120 | 0, (255 & (2 ^ r)) - 1 >>> 31 | 0), T(A, I + 240 | 0, (255 & (3 ^ r)) - 1 >>> 31 | 0), T(A, I + 360 | 0, (255 & (4 ^ r)) - 1 >>> 31 | 0), T(A, I + 480 | 0, (255 & (5 ^ r)) - 1 >>> 31 | 0), T(A, I + 600 | 0, (255 & (6 ^ r)) - 1 >>> 31 | 0), T(A, I + 720 | 0, (255 & (7 ^ r)) - 1 >>> 31 | 0), T(A, I + 840 | 0, (255 & (8 ^ r)) - 1 >>> 31 | 0), I = o[A + 76 >> 2], o[C + 40 >> 2] = o[A + 72 >> 2], o[C + 44 >> 2] = I, r = o[4 + (I = A - -64 | 0) >> 2], o[C + 32 >> 2] = o[I >> 2], o[C + 36 >> 2] = r, I = o[A + 60 >> 2], o[C + 24 >> 2] = o[A + 56 >> 2], o[C + 28 >> 2] = I, I = o[A + 52 >> 2], o[C + 16 >> 2] = o[A + 48 >> 2], o[C + 20 >> 2] = I, I = o[A + 44 >> 2], o[C + 8 >> 2] = o[A + 40 >> 2], o[C + 12 >> 2] = I, I = o[A + 12 >> 2], o[C + 56 >> 2] = o[A + 8 >> 2], o[C + 60 >> 2] = I, r = o[A + 20 >> 2], o[(I = C - -64 | 0) >> 2] = o[A + 16 >> 2], o[I + 4 >> 2] = r, I = o[A + 28 >> 2], o[C + 72 >> 2] = o[A + 24 >> 2], o[C + 76 >> 2] = I, I = o[A + 36 >> 2], o[C + 80 >> 2] = o[A + 32 >> 2], o[C + 84 >> 2] = I, I = o[A + 4 >> 2], o[C + 48 >> 2] = o[A >> 2], o[C + 52 >> 2] = I, I = o[A + 80 >> 2], r = o[A + 84 >> 2], B = o[A + 88 >> 2], Q = o[A + 92 >> 2], i = o[A + 96 >> 2], E = o[A + 100 >> 2], a = o[A + 104 >> 2], f = o[A + 108 >> 2], e = o[A + 112 >> 2], o[C + 124 >> 2] = 0 - o[A + 116 >> 2], o[C + 120 >> 2] = 0 - e, o[C + 116 >> 2] = 0 - f, o[C + 112 >> 2] = 0 - a, o[C + 108 >> 2] = 0 - E, o[C + 104 >> 2] = 0 - i, o[C + 100 >> 2] = 0 - Q, o[C + 96 >> 2] = 0 - B, o[C + 92 >> 2] = 0 - r, o[C + 88 >> 2] = 0 - I, T(A, C + 8 | 0, (128 & g) >>> 7 | 0), w = C + 128 | 0;
                                    }
                                    function Z(A, I, g, C) {
                                        var B = 0, Q = 0, i = 0, o = 0, f = 0, c = 0, e = 0;
                                        if (g | C) A: for(e = A + 224 | 0, f = A + 96 | 0, Q = a[A + 352 | 0] | a[A + 353 | 0] << 8 | a[A + 354 | 0] << 16 | a[A + 355 | 0] << 24;;){
                                            if (B = Q + f | 0, !C & g >>> 0 <= (i = 256 - Q | 0) >>> 0) {
                                                YA(B, I, g), I = g + (a[A + 352 | 0] | a[A + 353 | 0] << 8 | a[A + 354 | 0] << 16 | a[A + 355 | 0] << 24) | 0, E[A + 352 | 0] = I, E[A + 353 | 0] = I >>> 8, E[A + 354 | 0] = I >>> 16, E[A + 355 | 0] = I >>> 24;
                                                break A;
                                            }
                                            if (YA(B, I, i), B = (a[A + 352 | 0] | a[A + 353 | 0] << 8 | a[A + 354 | 0] << 16 | a[A + 355 | 0] << 24) + i | 0, E[A + 352 | 0] = B, E[A + 353 | 0] = B >>> 8, E[A + 354 | 0] = B >>> 16, E[A + 355 | 0] = B >>> 24, c = Q = a[A + 68 | 0] | a[A + 69 | 0] << 8 | a[A + 70 | 0] << 16 | a[A + 71 | 0] << 24, Q = (o = 128 + (B = a[A + 64 | 0] | a[A + 65 | 0] << 8 | a[A + 66 | 0] << 16 | a[A + 67 | 0] << 24) | 0) >>> 0 < 128 ? Q + 1 | 0 : Q, E[A + 64 | 0] = o, E[A + 65 | 0] = o >>> 8, E[A + 66 | 0] = o >>> 16, E[A + 67 | 0] = o >>> 24, E[A + 68 | 0] = Q, E[A + 69 | 0] = Q >>> 8, E[A + 70 | 0] = Q >>> 16, E[A + 71 | 0] = Q >>> 24, Q = a[A + 76 | 0] | a[A + 77 | 0] << 8 | a[A + 78 | 0] << 16 | a[A + 79 | 0] << 24, Q = (c = B = -1 == (0 | c) & B >>> 0 > 4294967167) >>> 0 > (B = B + (a[A + 72 | 0] | a[A + 73 | 0] << 8 | a[A + 74 | 0] << 16 | a[A + 75 | 0] << 24) | 0) >>> 0 ? Q + 1 | 0 : Q, E[A + 72 | 0] = B, E[A + 73 | 0] = B >>> 8, E[A + 74 | 0] = B >>> 16, E[A + 75 | 0] = B >>> 24, E[A + 76 | 0] = Q, E[A + 77 | 0] = Q >>> 8, E[A + 78 | 0] = Q >>> 16, E[A + 79 | 0] = Q >>> 24, n(A, f), YA(f, e, 128), B = Q = (a[A + 352 | 0] | a[A + 353 | 0] << 8 | a[A + 354 | 0] << 16 | a[A + 355 | 0] << 24) - 128 | 0, E[A + 352 | 0] = B, E[A + 353 | 0] = B >>> 8, E[A + 354 | 0] = B >>> 16, E[A + 355 | 0] = B >>> 24, I = I + i | 0, !((C = C - (g >>> 0 < i >>> 0) | 0) | (g = g - i | 0))) break;
                                        }
                                        return 0;
                                    }
                                    function W(A, I) {
                                        var g, C = 0, B = 0, Q = 0, i = 0, E = 0, a = 0, f = 0, c = 0, e = 0, r = 0, D = 0, t = 0, y = 0, w = 0, h = 0, n = 0, s = 0, k = 0;
                                        C = o[I + 40 >> 2], Q = o[I + 4 >> 2], i = o[I + 44 >> 2], E = o[I + 8 >> 2], a = o[I + 48 >> 2], f = o[I + 12 >> 2], c = o[I + 52 >> 2], e = o[I + 16 >> 2], r = o[I + 56 >> 2], D = o[I + 20 >> 2], t = o[I + 60 >> 2], y = o[I + 24 >> 2], w = o[(B = I - -64 | 0) >> 2], h = o[I + 28 >> 2], n = o[I + 68 >> 2], s = o[I + 32 >> 2], k = o[I + 72 >> 2], g = o[I >> 2], o[A + 36 >> 2] = o[I + 36 >> 2] + o[I + 76 >> 2], o[A + 32 >> 2] = s + k, o[A + 28 >> 2] = h + n, o[A + 24 >> 2] = y + w, o[A + 20 >> 2] = D + t, o[A + 16 >> 2] = e + r, o[A + 12 >> 2] = f + c, o[A + 8 >> 2] = E + a, o[A + 4 >> 2] = Q + i, o[A >> 2] = C + g, C = o[I + 40 >> 2], Q = o[I + 4 >> 2], i = o[I + 44 >> 2], E = o[I + 8 >> 2], a = o[I + 48 >> 2], f = o[I + 12 >> 2], c = o[I + 52 >> 2], e = o[I + 16 >> 2], r = o[I + 56 >> 2], D = o[I + 20 >> 2], t = o[I + 60 >> 2], y = o[I + 24 >> 2], B = o[B >> 2], w = o[I + 28 >> 2], h = o[I + 68 >> 2], n = o[I + 32 >> 2], s = o[I + 72 >> 2], k = o[I >> 2], o[A + 76 >> 2] = o[I + 76 >> 2] - o[I + 36 >> 2], o[A + 72 >> 2] = s - n, o[A + 68 >> 2] = h - w, o[A - -64 >> 2] = B - y, o[A + 60 >> 2] = t - D, o[A + 56 >> 2] = r - e, o[A + 52 >> 2] = c - f, o[A + 48 >> 2] = a - E, o[A + 44 >> 2] = i - Q, o[A + 40 >> 2] = C - k, C = o[I + 84 >> 2], o[A + 80 >> 2] = o[I + 80 >> 2], o[A + 84 >> 2] = C, C = o[I + 92 >> 2], o[A + 88 >> 2] = o[I + 88 >> 2], o[A + 92 >> 2] = C, C = o[I + 100 >> 2], o[A + 96 >> 2] = o[I + 96 >> 2], o[A + 100 >> 2] = C, C = o[I + 108 >> 2], o[A + 104 >> 2] = o[I + 104 >> 2], o[A + 108 >> 2] = C, C = o[I + 116 >> 2], o[A + 112 >> 2] = o[I + 112 >> 2], o[A + 116 >> 2] = C, H(A + 120 | 0, I + 120 | 0, 1440);
                                    }
                                    function $(A, I) {
                                        var g, C, B, Q, i, a = 0, f = 0, e = 0, r = 0, D = 0, t = 0, y = 0, w = 0, h = 0, n = 0;
                                        (a = o[A + 56 >> 2]) | (f = o[A + 60 >> 2]) && (E[(r = A - -64 | 0) + a | 0] = 1, !((n = a + 1 | 0) ? f : f + 1 | 0) & n >>> 0 <= 15 && dA(65 + (A + a | 0) | 0, 0, 15 - a | 0), E[A + 80 | 0] = 1, d(A, r, 16, 0)), n = o[A + 52 >> 2], w = o[A + 48 >> 2], r = o[A + 44 >> 2], a = o[A + 24 >> 2], D = o[A + 28 >> 2] + (a >>> 26 | 0) | 0, e = o[A + 32 >> 2] + (D >>> 26 | 0) | 0, g = o[A + 36 >> 2] + (e >>> 26 | 0) | 0, f = (y = (a = (a = (67108863 & a) + ((t = o[A + 20 >> 2] + c(g >>> 26 | 0, 5) | 0) >>> 26 | 0) | 0) & (D = (e = (i = (67108863 & g) + ((Q = (C = 67108863 & e) + ((B = (h = 67108863 & D) + ((t = a + ((f = 5 + (y = 67108863 & t) | 0) >>> 26 | 0) | 0) >>> 26 | 0) | 0) >>> 26 | 0) | 0) >>> 26 | 0) | 0) - 67108864 | 0) >> 31) | t & (e = 67108863 & (t = (e >>> 31 | 0) - 1 | 0))) << 26 | f & e | D & y) + o[A + 40 >> 2] | 0, E[0 | I] = f, E[I + 1 | 0] = f >>> 8, E[I + 2 | 0] = f >>> 16, E[I + 3 | 0] = f >>> 24, y = f >>> 0 < y >>> 0, f = 0, f = (a = (h = D & h | e & B) << 20 | a >>> 6) >>> 0 > (a = a + r | 0) >>> 0 ? 1 : f, f = (r = a) >>> 0 > (a = a + y | 0) >>> 0 ? f + 1 | 0 : f, E[I + 4 | 0] = a, E[I + 5 | 0] = a >>> 8, E[I + 6 | 0] = a >>> 16, E[I + 7 | 0] = a >>> 24, a = 0, r = (r = (e = D & C | e & Q) << 14 | h >>> 12) >>> 0 > (w = r + w | 0) >>> 0 ? 1 : a, a = w, w = f, a = a + f | 0, f = r, f = a >>> 0 < w >>> 0 ? f + 1 | 0 : f, E[I + 8 | 0] = a, E[I + 9 | 0] = a >>> 8, E[I + 10 | 0] = a >>> 16, E[I + 11 | 0] = a >>> 24, f = (a = (a = (t & i | D & g) << 8 | e >>> 18) + n | 0) + f | 0, E[I + 12 | 0] = f, E[I + 13 | 0] = f >>> 8, E[I + 14 | 0] = f >>> 16, E[I + 15 | 0] = f >>> 24, iI(A, 88);
                                    }
                                    function AA(A, I, g) {
                                        var C, B = 0;
                                        return w = C = w - 16 | 0, E[C + 15 | 0] = 0, B = -1, 0 | wI[o[8806]](A, I, g) || (E[C + 15 | 0] = a[0 | A] | a[C + 15 | 0], E[C + 15 | 0] = a[A + 1 | 0] | a[C + 15 | 0], E[C + 15 | 0] = a[A + 2 | 0] | a[C + 15 | 0], E[C + 15 | 0] = a[A + 3 | 0] | a[C + 15 | 0], E[C + 15 | 0] = a[A + 4 | 0] | a[C + 15 | 0], E[C + 15 | 0] = a[A + 5 | 0] | a[C + 15 | 0], E[C + 15 | 0] = a[A + 6 | 0] | a[C + 15 | 0], E[C + 15 | 0] = a[A + 7 | 0] | a[C + 15 | 0], E[C + 15 | 0] = a[A + 8 | 0] | a[C + 15 | 0], E[C + 15 | 0] = a[A + 9 | 0] | a[C + 15 | 0], E[C + 15 | 0] = a[A + 10 | 0] | a[C + 15 | 0], E[C + 15 | 0] = a[A + 11 | 0] | a[C + 15 | 0], E[C + 15 | 0] = a[A + 12 | 0] | a[C + 15 | 0], E[C + 15 | 0] = a[A + 13 | 0] | a[C + 15 | 0], E[C + 15 | 0] = a[A + 14 | 0] | a[C + 15 | 0], E[C + 15 | 0] = a[A + 15 | 0] | a[C + 15 | 0], E[C + 15 | 0] = a[A + 16 | 0] | a[C + 15 | 0], E[C + 15 | 0] = a[A + 17 | 0] | a[C + 15 | 0], E[C + 15 | 0] = a[A + 18 | 0] | a[C + 15 | 0], E[C + 15 | 0] = a[A + 19 | 0] | a[C + 15 | 0], E[C + 15 | 0] = a[A + 20 | 0] | a[C + 15 | 0], E[C + 15 | 0] = a[A + 21 | 0] | a[C + 15 | 0], E[C + 15 | 0] = a[A + 22 | 0] | a[C + 15 | 0], E[C + 15 | 0] = a[A + 23 | 0] | a[C + 15 | 0], E[C + 15 | 0] = a[A + 24 | 0] | a[C + 15 | 0], E[C + 15 | 0] = a[A + 25 | 0] | a[C + 15 | 0], E[C + 15 | 0] = a[A + 26 | 0] | a[C + 15 | 0], E[C + 15 | 0] = a[A + 27 | 0] | a[C + 15 | 0], E[C + 15 | 0] = a[A + 28 | 0] | a[C + 15 | 0], E[C + 15 | 0] = a[A + 29 | 0] | a[C + 15 | 0], E[C + 15 | 0] = a[A + 30 | 0] | a[C + 15 | 0], E[C + 15 | 0] = a[A + 31 | 0] | a[C + 15 | 0], B = (a[C + 15 | 0] << 23) - 8388608 >> 31), w = C + 16 | 0, B;
                                    }
                                    function IA(A, I) {
                                        var g, C, B, Q, i, a, f, e = 0, r = 0;
                                        C = o[I + 32 >> 2], B = o[I + 28 >> 2], Q = o[I + 24 >> 2], i = o[I + 20 >> 2], a = o[I + 16 >> 2], f = o[I + 12 >> 2], e = o[I + 4 >> 2], r = o[I >> 2], g = o[I + 36 >> 2], I = o[I + 8 >> 2], r = c((C + (B + (Q + (i + (a + (f + ((e + (r + (c(g, 19) + 16777216 >>> 25 | 0) >> 26) >> 25) + I >> 26) >> 25) >> 26) >> 25) >> 26) >> 25) >> 26) + g >> 25, 19) + r | 0, E[0 | A] = r, E[A + 2 | 0] = r >>> 16, E[A + 1 | 0] = r >>> 8, e = e + (r >> 26) | 0, E[A + 5 | 0] = e >>> 14, E[A + 4 | 0] = e >>> 6, E[A + 3 | 0] = r >>> 24 & 3 | e << 2, I = I + (e >> 25) | 0, E[A + 8 | 0] = I >>> 13, E[A + 7 | 0] = I >>> 5, E[A + 6 | 0] = I << 3 | (29360128 & e) >>> 22, r = (I >> 26) + f | 0, E[A + 11 | 0] = r >>> 11, E[A + 10 | 0] = r >>> 3, E[A + 9 | 0] = r << 5 | (65011712 & I) >>> 21, e = (r >> 25) + a | 0, E[A + 15 | 0] = e >>> 18, E[A + 14 | 0] = e >>> 10, E[A + 13 | 0] = e >>> 2, I = (e >> 26) + i | 0, E[A + 16 | 0] = I, E[A + 12 | 0] = e << 6 | (33030144 & r) >>> 19, E[A + 18 | 0] = I >>> 16, E[A + 17 | 0] = I >>> 8, e = (I >> 25) + Q | 0, E[A + 21 | 0] = e >>> 15, E[A + 20 | 0] = e >>> 7, E[A + 19 | 0] = I >>> 24 & 1 | e << 1, I = (e >> 26) + B | 0, E[A + 24 | 0] = I >>> 13, E[A + 23 | 0] = I >>> 5, E[A + 22 | 0] = I << 3 | (58720256 & e) >>> 23, e = (I >> 25) + C | 0, E[A + 27 | 0] = e >>> 12, E[A + 26 | 0] = e >>> 4, E[A + 25 | 0] = e << 4 | (31457280 & I) >>> 21, I = g + (e >> 26) | 0, E[A + 30 | 0] = I >>> 10, E[A + 29 | 0] = I >>> 2, E[A + 31 | 0] = (33292288 & I) >>> 18, E[A + 28 | 0] = I << 6 | (66060288 & e) >>> 20;
                                    }
                                    function gA(A, I, g) {
                                        var C, B = 0, Q = 0, i = 0, o = 0, f = 0, c = 0, e = 0;
                                        if (w = C = w - 192 | 0, g >>> 0 >= 129 && (cA(A), R(A, I, g, 0), N(A, C), g = 64, I = C), cA(A), dA(C - -64 | 0, 54, 128), g) {
                                            if (g >>> 0 >= 4) for(e = 252 & g; E[0 | (B = (i = C - -64 | 0) + Q | 0)] = a[0 | B] ^ a[I + Q | 0], E[0 | (o = (B = 1 | Q) + i | 0)] = a[0 | o] ^ a[I + B | 0], E[0 | (o = (B = 2 | Q) + i | 0)] = a[0 | o] ^ a[I + B | 0], E[0 | (B = (B = i) + (i = 3 | Q) | 0)] = a[0 | B] ^ a[I + i | 0], Q = Q + 4 | 0, (0 | e) != (0 | (f = f + 4 | 0)););
                                            if (f = 3 & g) for(; E[0 | (i = (C - -64 | 0) + Q | 0)] = a[0 | i] ^ a[I + Q | 0], Q = Q + 1 | 0, (0 | f) != (0 | (c = c + 1 | 0)););
                                        }
                                        if (R(A, Q = C - -64 | 0, 128, 0), cA(i = A + 208 | 0), dA(Q, 92, 128), g) {
                                            if (c = 0, Q = 0, g >>> 0 >= 4) for(e = 252 & g, f = 0; E[0 | (B = (A = C - -64 | 0) + Q | 0)] = a[0 | B] ^ a[I + Q | 0], E[0 | (o = (B = 1 | Q) + A | 0)] = a[0 | o] ^ a[I + B | 0], E[0 | (o = (B = 2 | Q) + A | 0)] = a[0 | o] ^ a[I + B | 0], E[0 | (B = (B = A) + (A = 3 | Q) | 0)] = a[0 | B] ^ a[A + I | 0], Q = Q + 4 | 0, (0 | e) != (0 | (f = f + 4 | 0)););
                                            if (A = 3 & g) for(; E[0 | (g = (C - -64 | 0) + Q | 0)] = a[0 | g] ^ a[I + Q | 0], Q = Q + 1 | 0, (0 | A) != (0 | (c = c + 1 | 0)););
                                        }
                                        return R(i, A = C - -64 | 0, 128, 0), iI(A, 128), iI(C, 64), w = C + 192 | 0, 0;
                                    }
                                    function CA(A, I) {
                                        var g;
                                        return o[12 + (g = w - 16 | 0) >> 2] = A, o[g + 8 >> 2] = I, o[g + 4 >> 2] = 0, o[g + 4 >> 2] = o[g + 4 >> 2] | a[o[g + 12 >> 2]] ^ a[o[g + 8 >> 2]], o[g + 4 >> 2] = o[g + 4 >> 2] | a[o[g + 12 >> 2] + 1 | 0] ^ a[o[g + 8 >> 2] + 1 | 0], o[g + 4 >> 2] = o[g + 4 >> 2] | a[o[g + 12 >> 2] + 2 | 0] ^ a[o[g + 8 >> 2] + 2 | 0], o[g + 4 >> 2] = o[g + 4 >> 2] | a[o[g + 12 >> 2] + 3 | 0] ^ a[o[g + 8 >> 2] + 3 | 0], o[g + 4 >> 2] = o[g + 4 >> 2] | a[o[g + 12 >> 2] + 4 | 0] ^ a[o[g + 8 >> 2] + 4 | 0], o[g + 4 >> 2] = o[g + 4 >> 2] | a[o[g + 12 >> 2] + 5 | 0] ^ a[o[g + 8 >> 2] + 5 | 0], o[g + 4 >> 2] = o[g + 4 >> 2] | a[o[g + 12 >> 2] + 6 | 0] ^ a[o[g + 8 >> 2] + 6 | 0], o[g + 4 >> 2] = o[g + 4 >> 2] | a[o[g + 12 >> 2] + 7 | 0] ^ a[o[g + 8 >> 2] + 7 | 0], o[g + 4 >> 2] = o[g + 4 >> 2] | a[o[g + 12 >> 2] + 8 | 0] ^ a[o[g + 8 >> 2] + 8 | 0], o[g + 4 >> 2] = o[g + 4 >> 2] | a[o[g + 12 >> 2] + 9 | 0] ^ a[o[g + 8 >> 2] + 9 | 0], o[g + 4 >> 2] = o[g + 4 >> 2] | a[o[g + 12 >> 2] + 10 | 0] ^ a[o[g + 8 >> 2] + 10 | 0], o[g + 4 >> 2] = o[g + 4 >> 2] | a[o[g + 12 >> 2] + 11 | 0] ^ a[o[g + 8 >> 2] + 11 | 0], o[g + 4 >> 2] = o[g + 4 >> 2] | a[o[g + 12 >> 2] + 12 | 0] ^ a[o[g + 8 >> 2] + 12 | 0], o[g + 4 >> 2] = o[g + 4 >> 2] | a[o[g + 12 >> 2] + 13 | 0] ^ a[o[g + 8 >> 2] + 13 | 0], o[g + 4 >> 2] = o[g + 4 >> 2] | a[o[g + 12 >> 2] + 14 | 0] ^ a[o[g + 8 >> 2] + 14 | 0], o[g + 4 >> 2] = o[g + 4 >> 2] | a[o[g + 12 >> 2] + 15 | 0] ^ a[o[g + 8 >> 2] + 15 | 0], (o[g + 4 >> 2] - 1 >>> 8 & 1) - 1 | 0;
                                    }
                                    function BA(A, I) {
                                        var g, C = 0, B = 0;
                                        g = I;
                                        A: if (C = 255 & I) {
                                            if (3 & A) for(;;){
                                                if (!(I = a[0 | A]) | (0 | I) == (255 & g)) break A;
                                                if (!(3 & (A = A + 1 | 0))) break;
                                            }
                                            I: if (!((-1 ^ (I = o[A >> 2])) & I - 16843009 & -2139062144)) for(C = c(C, 16843009);;){
                                                if ((-1 ^ (I ^= C)) & I - 16843009 & -2139062144) break I;
                                                if (I = o[A + 4 >> 2], A = A + 4 | 0, I - 16843009 & (-1 ^ I) & -2139062144) break;
                                            }
                                            for(; I = A, (C = a[0 | A]) && (A = A + 1 | 0, (0 | C) != (255 & g)););
                                            A = I;
                                        } else {
                                            C = A;
                                            I: {
                                                g: {
                                                    C: if (3 & A) {
                                                        if (I = 0, !a[0 | A]) break I;
                                                        for(;;){
                                                            if (!(3 & (A = A + 1 | 0))) break C;
                                                            if (!a[0 | A]) break;
                                                        }
                                                        break g;
                                                    }
                                                    for(; I = A, A = A + 4 | 0, !((-1 ^ (B = o[I >> 2])) & B - 16843009 & -2139062144););
                                                    for(; I = (A = I) + 1 | 0, a[0 | A];);
                                                }
                                                I = A - C | 0;
                                            }
                                            A = I + C | 0;
                                        }
                                        return a[0 | A] == (255 & g) ? A : 0;
                                    }
                                    function QA(A, I, g, C, B, Q, i) {
                                        var E, a, f = 0, c = 0, e = 0;
                                        w = E = w - 96 | 0, m(E, Q, i), i = E + 32 | 0, a = Q + 16 | 0, wI[o[8808]](i, 32, 0, a, E), Q = -1;
                                        A: {
                                            if (!(0 | wI[o[8802]](g, I, C, B, i))) {
                                                if (Q = 0, !A) break A;
                                                !((!B & C >>> 0 > I - A >>> 0 | 0 != (0 | B)) & A >>> 0 < I >>> 0) & (!B & C >>> 0 <= A - I >>> 0 | A >>> 0 <= I >>> 0) || (I = pA(A, I, C)), c = i = (Q = !B & C >>> 0 >= 32 | 0 != (0 | B)) ? 0 : B, (g = Q ? 32 : C) | i ? (e = YA(E - -64 | 0, I, g), qA(Q = E + 32 | 0, Q, f = g + 32 | 0, i = f >>> 0 < 32 ? i + 1 | 0 : i, a, E), YA(A, e, g)) : qA(Q = E + 32 | 0, Q, f = g + 32 | 0, i = f >>> 0 < 32 ? i + 1 | 0 : i, a, E), iI(E + 32 | 0, 64), Q = 0, !B & C >>> 0 < 33 || jA(A + g | 0, I + g | 0, C - g | 0, B - (c + (g >>> 0 > C >>> 0) | 0) | 0, a, E);
                                            }
                                            iI(E, 32);
                                        }
                                        return w = E + 96 | 0, Q;
                                    }
                                    function iA(A, I, g, C, B, Q, i) {
                                        var E, a, f, c, e = 0;
                                        return w = E = w - 352 | 0, m(E, Q, i), !((!B & C >>> 0 > A - g >>> 0 | 0 != (0 | B)) & A >>> 0 > g >>> 0) & (!B & C >>> 0 <= g - A >>> 0 | A >>> 0 >= g >>> 0) || (g = pA(A, g, C)), o[E + 56 >> 2] = 0, o[E + 60 >> 2] = 0, o[E + 48 >> 2] = 0, o[E + 52 >> 2] = 0, o[E + 40 >> 2] = 0, o[E + 44 >> 2] = 0, o[E + 32 >> 2] = 0, o[E + 36 >> 2] = 0, (f = !((i = (e = !B & C >>> 0 >= 32 | 0 != (0 | B)) ? 32 : C) | (e = e ? 0 : B))) || YA(E - -64 | 0, g, i), qA(a = E + 32 | 0, a, c = i + 32 | 0, c >>> 0 < 32 ? e + 1 | 0 : e, Q = Q + 16 | 0, E), CI(E + 96 | 0, a), f || YA(A, E - -64 | 0, i), iI(E + 32 | 0, 64), !B & C >>> 0 >= 33 | B && jA(A + i | 0, g + i | 0, C - i | 0, B - (e + (C >>> 0 < i >>> 0) | 0) | 0, Q, E), iI(E, 32), $A(g = E + 96 | 0, A, C, B), BI(g, I), iI(g, 256), w = E + 352 | 0, 0;
                                    }
                                    function EA(A, I, g, C, B, Q, i, E, f, c) {
                                        var e, r;
                                        return w = e = w - 400 | 0, o[e + 4 >> 2] = 0, x(r = e + 16 | 0, f, c), c = a[f + 20 | 0] | a[f + 21 | 0] << 8 | a[f + 22 | 0] << 16 | a[f + 23 | 0] << 24, o[e + 8 >> 2] = a[f + 16 | 0] | a[f + 17 | 0] << 8 | a[f + 18 | 0] << 16 | a[f + 19 | 0] << 24, o[e + 12 >> 2] = c, ZA(c = e + 80 | 0, 64, e + 4 | 0, r), CI(f = e + 144 | 0, c), iI(c, 64), $A(f, Q, i, E), $A(f, 33904, 0 - i & 15, 0), $A(f, I, g, C), $A(f, 33904, 0 - g & 15, 0), o[e + 72 >> 2] = i, o[e + 76 >> 2] = E, $A(f, Q = e + 72 | 0, 8, 0), o[e + 72 >> 2] = g, o[e + 76 >> 2] = C, $A(f, Q, 8, 0), BI(f, Q = e + 48 | 0), iI(f, 256), f = CA(Q, B), iI(Q, 16), A && (f ? (dA(A, 0, g), f = -1) : (xA(A, I, g, C, e + 4 | 0, e + 16 | 0), f = 0)), iI(e + 16 | 0, 32), w = e + 400 | 0, f;
                                    }
                                    function oA(A, I, g, C, B, Q, i, E, f, c, e) {
                                        var r, D, t;
                                        return w = r = w - 384 | 0, o[r + 4 >> 2] = 0, x(D = r + 16 | 0, c, e), e = a[c + 20 | 0] | a[c + 21 | 0] << 8 | a[c + 22 | 0] << 16 | a[c + 23 | 0] << 24, o[r + 8 >> 2] = a[c + 16 | 0] | a[c + 17 | 0] << 8 | a[c + 18 | 0] << 16 | a[c + 19 | 0] << 24, o[r + 12 >> 2] = e, ZA(e = r - -64 | 0, 64, t = r + 4 | 0, D), CI(c = r + 128 | 0, e), iI(e, 64), $A(c, i, E, f), $A(c, 33904, 0 - E & 15, 0), xA(A, C, B, Q, t, D), $A(c, A, B, Q), $A(c, 33904, 0 - B & 15, 0), o[r + 56 >> 2] = E, o[r + 60 >> 2] = f, $A(c, A = r + 56 | 0, 8, 0), o[r + 56 >> 2] = B, o[r + 60 >> 2] = Q, $A(c, A, 8, 0), BI(c, I), iI(c, 256), g && (o[g >> 2] = 16, o[g + 4 >> 2] = 0), iI(r + 16 | 0, 32), w = r + 384 | 0, 0;
                                    }
                                    function aA(A, I, g, C) {
                                        var B, Q = 0;
                                        return w = B = w - 208 | 0, o[B + 72 >> 2] = 0, o[B + 76 >> 2] = 0, Q = o[8579], o[B + 8 >> 2] = o[8578], o[B + 12 >> 2] = Q, Q = o[8581], o[B + 16 >> 2] = o[8580], o[B + 20 >> 2] = Q, Q = o[8583], o[B + 24 >> 2] = o[8582], o[B + 28 >> 2] = Q, Q = o[8585], o[B + 32 >> 2] = o[8584], o[B + 36 >> 2] = Q, Q = o[8587], o[B + 40 >> 2] = o[8586], o[B + 44 >> 2] = Q, Q = o[8589], o[B + 48 >> 2] = o[8588], o[B + 52 >> 2] = Q, Q = o[8591], o[B + 56 >> 2] = o[8590], o[B + 60 >> 2] = Q, o[B + 64 >> 2] = 0, o[B + 68 >> 2] = 0, Q = o[8577], o[B >> 2] = o[8576], o[B + 4 >> 2] = Q, R(B, I, g, C), N(B, A), w = B + 208 | 0, 0;
                                    }
                                    function fA(A, I) {
                                        var g, C = 0, B = 0, Q = 0;
                                        if (E[15 + (g = w - 16 | 0) | 0] = 0, I) {
                                            if (B = 3 & I, I >>> 0 >= 4) for(Q = -4 & I, I = 0; E[g + 15 | 0] = a[A + C | 0] | a[g + 15 | 0], E[g + 15 | 0] = a[(1 | C) + A | 0] | a[g + 15 | 0], E[g + 15 | 0] = a[(2 | C) + A | 0] | a[g + 15 | 0], E[g + 15 | 0] = a[(3 | C) + A | 0] | a[g + 15 | 0], C = C + 4 | 0, (0 | Q) != (0 | (I = I + 4 | 0)););
                                            if (B) for(I = 0; E[g + 15 | 0] = a[A + C | 0] | a[g + 15 | 0], C = C + 1 | 0, (0 | B) != (0 | (I = I + 1 | 0)););
                                        }
                                        return a[g + 15 | 0] - 1 >>> 8 & 1;
                                    }
                                    function cA(A) {
                                        var I = 0;
                                        o[A + 64 >> 2] = 0, o[A + 68 >> 2] = 0, o[A + 72 >> 2] = 0, o[A + 76 >> 2] = 0, I = o[8577], o[A >> 2] = o[8576], o[A + 4 >> 2] = I, I = o[8579], o[A + 8 >> 2] = o[8578], o[A + 12 >> 2] = I, I = o[8581], o[A + 16 >> 2] = o[8580], o[A + 20 >> 2] = I, I = o[8583], o[A + 24 >> 2] = o[8582], o[A + 28 >> 2] = I, I = o[8585], o[A + 32 >> 2] = o[8584], o[A + 36 >> 2] = I, I = o[8587], o[A + 40 >> 2] = o[8586], o[A + 44 >> 2] = I, I = o[8589], o[A + 48 >> 2] = o[8588], o[A + 52 >> 2] = I, I = o[8591], o[A + 56 >> 2] = o[8590], o[A + 60 >> 2] = I;
                                    }
                                    function eA(A, I, g) {
                                        var C, B = 0, Q = 0;
                                        if (o[12 + (C = w - 16 | 0) >> 2] = A, o[C + 8 >> 2] = I, A = 0, E[C + 7 | 0] = 0, g) {
                                            if (I = 1 & g, 1 != (0 | g)) for(Q = -2 & g, g = 0; E[C + 7 | 0] = a[C + 7 | 0] | a[o[C + 12 >> 2] + A | 0] ^ a[o[C + 8 >> 2] + A | 0], B = 1 | A, E[C + 7 | 0] = a[C + 7 | 0] | a[B + o[C + 12 >> 2] | 0] ^ a[o[C + 8 >> 2] + B | 0], A = A + 2 | 0, (0 | Q) != (0 | (g = g + 2 | 0)););
                                            I && (E[C + 7 | 0] = a[C + 7 | 0] | a[o[C + 12 >> 2] + A | 0] ^ a[o[C + 8 >> 2] + A | 0]);
                                        }
                                        return (a[C + 7 | 0] - 1 >>> 8 & 1) - 1 | 0;
                                    }
                                    function rA(A) {
                                        for(var I = 0, g = 0, C = 0, B = 0, Q = 0, i = 0, E = 0, o = 0, f = 0, c = 0; B = (g = a[A + C | 0]) ^ a[0 | (I = C + 2448 | 0)] | B, Q = g ^ a[I + 192 | 0] | Q, i = g ^ a[I + 160 | 0] | i, E = g ^ a[I + 128 | 0] | E, o = g ^ a[I + 96 | 0] | o, f = g ^ a[I - -64 | 0] | f, c = g ^ a[I + 32 | 0] | c, 31 != (0 | (C = C + 1 | 0)););
                                        return ((255 & ((I = 127 ^ (A = 127 & a[A + 31 | 0])) | Q)) - 1 | (255 & (I | i)) - 1 | (255 & (I | E)) - 1 | (255 & (122 ^ A | o)) - 1 | (255 & (5 ^ A | f)) - 1 | (255 & (A | c)) - 1 | (255 & (A | B)) - 1) >>> 8 & 1;
                                    }
                                    function DA(A, I, g) {
                                        var C = 0, B = 0, Q = 0, i = 0;
                                        return B = 31 & (Q = i = 63 & g), Q = Q >>> 0 >= 32 ? -1 >>> B | 0 : (C = -1 >>> B | 0) | (1 << B) - 1 << 32 - B, Q &= A, C &= I, B = 31 & i, i >>> 0 >= 32 ? (C = Q << B, i = 0) : (C = (1 << B) - 1 & Q >>> 32 - B | C << B, i = Q << B), Q = C, C = 31 & (B = 0 - g & 63), B >>> 0 >= 32 ? (C = -1 << C, g = 0) : C = (g = -1 << C) | (1 << C) - 1 & -1 >>> 32 - C, A &= g, I &= C, C = 31 & B, B >>> 0 >= 32 ? (g = 0, A = I >>> C | 0) : (g = I >>> C | 0, A = ((1 << C) - 1 & I) << 32 - C | A >>> C), h = g | Q, A | i;
                                    }
                                    function tA(A, I, g, C, B, Q, i, E, a, f) {
                                        var c, e, r;
                                        return w = c = w - 352 | 0, ZA(r = c + 32 | 0, 64, a, f), CI(e = c + 96 | 0, r), iI(r, 64), $A(e, Q, i, E), $A(e, 33920, 0 - i & 15, 0), $A(e, I, g, C), $A(e, 33920, 0 - g & 15, 0), o[c + 24 >> 2] = i, o[c + 28 >> 2] = E, $A(e, Q = c + 24 | 0, 8, 0), o[c + 24 >> 2] = g, o[c + 28 >> 2] = C, $A(e, Q, 8, 0), BI(e, c), iI(e, 256), Q = CA(c, B), iI(c, 16), A && (Q ? (dA(A, 0, g), Q = -1) : (FA(A, I, g, C, a, 1, f), Q = 0)), w = c + 352 | 0, Q;
                                    }
                                    function yA(A, I, g, C, B, Q, i, E, a, f, c) {
                                        var e, r, D;
                                        return w = e = w - 336 | 0, ZA(D = e + 16 | 0, 64, f, c), CI(r = e + 80 | 0, D), iI(D, 64), $A(r, i, E, a), $A(r, 33920, 0 - E & 15, 0), FA(A, C, B, Q, f, 1, c), $A(r, A, B, Q), $A(r, 33920, 0 - B & 15, 0), o[e + 8 >> 2] = E, o[e + 12 >> 2] = a, $A(r, A = e + 8 | 0, 8, 0), o[e + 8 >> 2] = B, o[e + 12 >> 2] = Q, $A(r, A, 8, 0), BI(r, I), iI(r, 256), g && (o[g >> 2] = 16, o[g + 4 >> 2] = 0), w = e + 336 | 0, 0;
                                    }
                                    function wA(A, I, g, C, B, Q, i, E, a, f) {
                                        var c, e, r;
                                        return w = c = w - 352 | 0, WA(r = c + 32 | 0, a, f), CI(e = c + 96 | 0, r), iI(r, 64), $A(e, Q, i, E), o[c + 24 >> 2] = i, o[c + 28 >> 2] = E, $A(e, Q = c + 24 | 0, 8, 0), $A(e, I, g, C), o[c + 24 >> 2] = g, o[c + 28 >> 2] = C, $A(e, Q, 8, 0), BI(e, c), iI(e, 256), Q = CA(c, B), iI(c, 16), A && (Q ? (dA(A, 0, g), Q = -1) : (uA(A, I, g, C, a, f), Q = 0)), w = c + 352 | 0, Q;
                                    }
                                    function hA(A, I, g, C, B, Q, i, E, a, f, c) {
                                        var e, r, D;
                                        return w = e = w - 336 | 0, WA(D = e + 16 | 0, f, c), CI(r = e + 80 | 0, D), iI(D, 64), $A(r, i, E, a), o[e + 8 >> 2] = E, o[e + 12 >> 2] = a, $A(r, i = e + 8 | 0, 8, 0), uA(A, C, B, Q, f, c), $A(r, A, B, Q), o[e + 8 >> 2] = B, o[e + 12 >> 2] = Q, $A(r, i, 8, 0), BI(r, I), iI(r, 256), g && (o[g >> 2] = 16, o[g + 4 >> 2] = 0), w = e + 336 | 0, 0;
                                    }
                                    function nA(A, I) {
                                        var g;
                                        for(o[12 + (g = w - 16 | 0) >> 2] = A, o[g + 8 >> 2] = I, A = 0, o[g + 4 >> 2] = 0; o[g + 4 >> 2] = o[g + 4 >> 2] | a[o[g + 12 >> 2] + A | 0] ^ a[o[g + 8 >> 2] + A | 0], I = 1 | A, o[g + 4 >> 2] = o[g + 4 >> 2] | a[I + o[g + 12 >> 2] | 0] ^ a[I + o[g + 8 >> 2] | 0], 32 != (0 | (A = A + 2 | 0)););
                                        return (o[g + 4 >> 2] - 1 >>> 8 & 1) - 1 | 0;
                                    }
                                    function sA(A) {
                                        var I = 0, g = 0, C = 0, B = 0;
                                        for(I = 1; I = a[0 | (g = A + C | 0)] + I | 0, E[0 | g] = I, I = a[0 | (g = (1 | C) + A | 0)] + (I >>> 8 | 0) | 0, E[0 | g] = I, I = a[0 | (g = (2 | C) + A | 0)] + (I >>> 8 | 0) | 0, E[0 | g] = I, I = a[0 | (g = (3 | C) + A | 0)] + (I >>> 8 | 0) | 0, E[0 | g] = I, I = I >>> 8 | 0, C = C + 4 | 0, 4 != (0 | (B = B + 4 | 0)););
                                    }
                                    function kA(A, I, g, C) {
                                        var B, Q, i, E, o = 0, a = 0;
                                        return E = c(o = g >>> 16 | 0, a = A >>> 16 | 0), o = (65535 & (a = ((i = c(B = 65535 & g, Q = 65535 & A)) >>> 16 | 0) + c(a, B) | 0)) + c(o, Q) | 0, h = (c(I, g) + E | 0) + c(A, C) + (a >>> 16) + (o >>> 16) | 0, 65535 & i | o << 16;
                                    }
                                    function FA(A, I, g, C, B, i, E) {
                                        var a = 0, f = 0;
                                        a = C, 1 == (((a = (f = g + 63 | 0) >>> 0 < 63 ? a + 1 | 0 : a) >>> 6 | 0) + (0 != (0 | (a = (63 & a) << 26 | f >>> 6))) | 0) & i >>> 0 > (f = 0 - a | 0) >>> 0 | 1 == (0 | C) | C >>> 0 > 1 ? (zA(), Q()) : wI[o[8813]](A, I, g, C, B, i, E);
                                    }
                                    function SA(A) {
                                        var I = 0;
                                        o[A + 32 >> 2] = 0, o[A + 36 >> 2] = 0, I = o[8485], o[A >> 2] = o[8484], o[A + 4 >> 2] = I, I = o[8487], o[A + 8 >> 2] = o[8486], o[A + 12 >> 2] = I, I = o[8489], o[A + 16 >> 2] = o[8488], o[A + 20 >> 2] = I, I = o[8491], o[A + 24 >> 2] = o[8490], o[A + 28 >> 2] = I;
                                    }
                                    function HA(A, I) {
                                        A |= 0;
                                        var g, C = 0, B = 0, Q = 0;
                                        if (w = g = w - 16 | 0, I |= 0) for(; E[g + 15 | 0] = 0, B = A + C | 0, Q = 0 | r(35256, g + 15 | 0, 0), E[0 | B] = Q, (0 | (C = C + 1 | 0)) != (0 | I););
                                        w = g + 16 | 0;
                                    }
                                    function GA(A, I, g, C, B, Q, i) {
                                        var E, o, a = 0;
                                        return w = E = w - 32 | 0, a = -1, (o = g >>> 0 < 16) & !C || UA(E, Q, i) || (a = QA(A, I + 16 | 0, I, g - 16 | 0, C - o | 0, B, E), iI(E, 32)), w = E + 32 | 0, a;
                                    }
                                    function _A(A) {
                                        var I, g;
                                        return (A = (I = o[8800]) + (g = A + 7 & -8) | 0) >>> 0 <= I >>> 0 && g || A >>> 0 > hI() << 16 >>> 0 && !(0 | y(0 | A)) ? (o[9005] = 48, -1) : (o[8800] = A, I);
                                    }
                                    function MA(A, I) {
                                        var g, C, B;
                                        w = g = w - 176 | 0, O(C = g + 96 | 0, I + 80 | 0), H(B = g + 48 | 0, I, C), H(g, I + 40 | 0, C), IA(A, g), IA(g + 144 | 0, B), E[A + 31 | 0] = a[A + 31 | 0] ^ a[g + 144 | 0] << 7, w = g + 176 | 0;
                                    }
                                    function pA(A, I, g) {
                                        var C = 0;
                                        if (A >>> 0 < I >>> 0) return YA(A, I, g);
                                        if (g) for(C = A + g | 0, I = I + g | 0; I = I - 1 | 0, E[0 | (C = C - 1 | 0)] = a[0 | I], g = g - 1 | 0;);
                                        return A;
                                    }
                                    function NA(A, I, g, C, B, i, E) {
                                        var o, a = 0;
                                        if (w = o = w - 32 | 0, !C & g >>> 0 < 4294967280) return a = -1, UA(o, i, E) || (a = iA(A + 16 | 0, A, I, g, C, B, o), iI(o, 32)), w = o + 32 | 0, a;
                                        zA(), Q();
                                    }
                                    function JA(A, I, g, C, B, Q) {
                                        return I |= 0, 0 | (!(C |= 0) & (g |= 0) >>> 0 >= 16 | C ? QA(A |= 0, I + 16 | 0, I, g - 16 | 0, C - (g >>> 0 < 16) | 0, B |= 0, Q |= 0) : -1);
                                    }
                                    function UA(A, I, g) {
                                        A |= 0;
                                        var C, B = 0;
                                        return w = C = w - 32 | 0, B = -1, AA(C, g |= 0, I |= 0) || (B = m(A, 35184, C)), w = C + 32 | 0, 0 | B;
                                    }
                                    function YA(A, I, g) {
                                        var C = 0;
                                        if (g) for(C = A; E[0 | C] = a[0 | I], C = C + 1 | 0, I = I + 1 | 0, g = g - 1 | 0;);
                                        return A;
                                    }
                                    function dA(A, I, g) {
                                        var C = 0;
                                        if (g) for(C = A; E[0 | C] = I, C = C + 1 | 0, g = g - 1 | 0;);
                                        return A;
                                    }
                                    function KA(A, I, g) {
                                        return A |= 0, I |= 0, (g |= 0) >>> 0 >= 256 && (D(1260, 1187, 107, 1067), Q()), 0 | J(A, I, 255 & g);
                                    }
                                    function bA(A, I) {
                                        var g;
                                        w = g = w + -64 | 0, N(A, g), R(A = A + 208 | 0, g, 64, 0), N(A, I), iI(g, 64), w = g - -64 | 0;
                                    }
                                    function PA(A, I, g, C, B, Q, i) {
                                        return 0 | iA(A |= 0, I |= 0, g |= 0, C |= 0, B |= 0, Q |= 0, i |= 0);
                                    }
                                    function vA(A, I, g, C, B, Q, i) {
                                        return 0 | QA(A |= 0, I |= 0, g |= 0, C |= 0, B |= 0, Q |= 0, i |= 0);
                                    }
                                    function LA(A, I) {
                                        var g;
                                        w = g = w - 32 | 0, l(A, g), z(A = A + 104 | 0, g, 32), l(A, I), iI(g, 32), w = g + 32 | 0;
                                    }
                                    function RA(A, I) {
                                        var g = 0;
                                        return (-1 >>> (g = 31 & I) & A) << g | ((g = A) & -1 << (A = 0 - I & 31)) >>> A;
                                    }
                                    function uA(A, I, g, C, B, i) {
                                        1 == (0 | C) | C >>> 0 > 1 && (zA(), Q()), wI[o[8812]](A, I, g, C, B, 1, 0, i);
                                    }
                                    function xA(A, I, g, C, B, i) {
                                        1 == (0 | C) | C >>> 0 > 1 && (zA(), Q()), wI[o[8813]](A, I, g, C, B, 1, i);
                                    }
                                    function mA() {
                                        var A;
                                        w = A = w - 16 | 0, E[A + 15 | 0] = 0, r(35292, A + 15 | 0, 0), w = A + 16 | 0;
                                    }
                                    function lA(A, I, g) {
                                        return 0 | AA(A |= 0, I |= 0, g |= 0);
                                    }
                                    function zA() {
                                        var A;
                                        (A = o[9137]) && wI[0 | A](), t(), Q();
                                    }
                                    function qA(A, I, g, C, B, Q) {
                                        wI[o[8809]](A, I, g, C, B, 0, 0, Q);
                                    }
                                    function XA(A, I) {
                                        return A |= 0, HA(I |= 0, 32), 0 | II(A, I);
                                    }
                                    function jA(A, I, g, C, B, Q) {
                                        wI[o[8809]](A, I, g, C, B, 1, 0, Q);
                                    }
                                    function TA(A) {
                                        return A ? 31 - e(A - 1 ^ A) | 0 : 32;
                                    }
                                    function OA(A, I, g, C) {
                                        wI[o[8813]](A, I, 40, 0, g, 0, C);
                                    }
                                    function VA(A, I) {
                                        return 0 | II(A |= 0, I |= 0);
                                    }
                                    function ZA(A, I, g, C) {
                                        wI[o[8811]](A, I, 0, g, C);
                                    }
                                    function WA(A, I, g) {
                                        wI[o[8810]](A, 64, 0, I, g);
                                    }
                                    function $A(A, I, g, C) {
                                        wI[o[8804]](A, I, g, C);
                                    }
                                    function AI(A, I, g, C) {
                                        return R(A, I, g, C), 0;
                                    }
                                    function II(A, I) {
                                        return 0 | wI[o[8807]](A, I);
                                    }
                                    function gI(A, I, g) {
                                        return z(A, I, g), 0;
                                    }
                                    function CI(A, I) {
                                        wI[o[8803]](A, I);
                                    }
                                    function BI(A, I) {
                                        wI[o[8805]](A, I);
                                    }
                                    function QI(A) {
                                        HA(A |= 0, 32);
                                    }
                                    function iI(A, I) {
                                        dA(A, 0, I);
                                    }
                                    function EI() {
                                        return 208;
                                    }
                                    function oI() {
                                        return 16;
                                    }
                                    function aI() {
                                        return 32;
                                    }
                                    function fI() {
                                        return 24;
                                    }
                                    function cI() {
                                        return -17;
                                    }
                                    function eI() {
                                        return 64;
                                    }
                                    function rI() {
                                        return 1;
                                    }
                                    function DI() {
                                        return 8;
                                    }
                                    function tI() {
                                        return 0;
                                    }
                                    B(I = a, 1024, "TGlic29kaXVtRFJHcmFuZG9tYnl0ZXMAYjY0X3BvcyA8PSBiNjRfbGVuAGNyeXB0b19nZW5lcmljaGFzaF9ibGFrZTJiX2ZpbmFsAHJhbmRvbWJ5dGVzL3JhbmRvbWJ5dGVzLmMAc29kaXVtL2NvZGVjcy5jAGNyeXB0b19nZW5lcmljaGFzaC9ibGFrZTJiL3JlZi9ibGFrZTJiLXJlZi5jAGNyeXB0b19nZW5lcmljaGFzaC9ibGFrZTJiL3JlZi9nZW5lcmljaGFzaF9ibGFrZTJiLmMAYnVmX2xlbiA8PSBTSVpFX01BWABvdXRsZW4gPD0gVUlOVDhfTUFYAFMtPmJ1ZmxlbiA8PSBCTEFLRTJCX0JMT0NLQllURVMAMS4wLjE5AHNvZGl1bV9iaW4yYmFzZTY0AAAAAAAAAAC2eFn/hXLTAL1uFf8PCmoAKcABAJjoef+8PKD/mXHO/wC34v60DUj/AAAAAAAAAACwoA7+08mG/54YjwB/aTUAYAy9AKfX+/+fTID+amXh/x78BACSDK4="), B(I, 1440, "WfGy/grlpv973Sr+HhTUAFKAAwAw0fMAd3lA/zLjnP8AbsUBZxuQ"), B(I, 1488, "hTuMAb3xJP/4JcMBYNw3ALdMPv/DQj0AMkykAeGkTP9MPaP/dT4fAFGRQP92QQ4AonPW/waKLgB85vT/CoqPADQawgC49EwAgY8pAb70E/97qnr/YoFEAHnVkwBWZR7/oWebAIxZQ//v5b4BQwu1AMbwif7uRbz/Q5fuABMqbP/lVXEBMkSH/xFqCQAyZwH/UAGoASOYHv8QqLkBOFno/2XS/AAp+kcAzKpP/w4u7/9QTe8AvdZL/xGN+QAmUEz/vlV1AFbkqgCc2NABw8+k/5ZCTP+v4RD/jVBiAUzb8gDGonIALtqYAJsr8f6boGj/M7ulAAIRrwBCVKAB9zoeACNBNf5F7L8ALYb1AaN73QAgbhT/NBelALrWRwDpsGAA8u82ATlZigBTAFT/iKBkAFyOeP5ofL4AtbE+//opVQCYgioBYPz2AJeXP/7vhT4AIDicAC2nvf+OhbMBg1bTALuzlv76qg7/0qNOACU0lwBjTRoA7pzV/9XA0QFJLlQAFEEpATbOTwDJg5L+qm8Y/7EhMv6rJsv/Tvd0ANHdmQCFgLIBOiwZAMknOwG9E/wAMeXSAXW7dQC1s7gBAHLbADBekwD1KTgAfQ3M/vStdwAs3SD+VOoUAPmgxgHsfur/L2Oo/qrimf9ms9gA4o16/3pCmf629YYA4+QZAdY56//YrTj/tefSAHeAnf+BX4j/bn4zAAKpt/8HgmL+RbBe/3QE4wHZ8pH/yq0fAWkBJ/8ur0UA5C86/9fgRf7POEX/EP6L/xfP1P/KFH7/X9Vg/wmwIQDIBc//8SqA/iMhwP/45cQBgRF4APtnl/8HNHD/jDhC/yji9f/ZRiX+rNYJ/0hDhgGSwNb/LCZwAES4S//OWvsAleuNALWqOgB09O8AXJ0CAGatYgDpiWABfzHLAAWblAAXlAn/03oMACKGGv/bzIgAhggp/+BTK/5VGfcAbX8A/qmIMADud9v/563VAM4S/v4Iugf/fgkHAW8qSABvNOz+YD+NAJO/f/7NTsD/DmrtAbvbTACv87v+aVmtAFUZWQGi85QAAnbR/iGeCQCLoy7/XUYoAGwqjv5v/I7/m9+QADPlp/9J/Jv/XnQM/5ig2v+c7iX/s+rP/8UAs/+apI0A4cRoAAojGf7R1PL/Yf3e/rhl5QDeEn8BpIiH/x7PjP6SYfMAgcAa/slUIf9vCk7/k1Gy/wQEGACh7tf/Bo0hADXXDv8ptdD/54udALPL3f//uXEAveKs/3FC1v/KPi3/ZkAI/06uEP6FdUT/"), B(I, 2480, "AQ=="), B(I, 2512, "JuiVj8KyJ7BFw/SJ8u+Y8NXfrAXTxjM5sTgCiG1T/AXHF2pwPU3YT7o8C3YNEGcPKiBT+iw5zMZOx/13kqwDeuz///////////////////////////////////////9/7f///////////////////////////////////////3/u////////////////////////////////////////f+3T9VwaYxJY1pz3ot753hQ="), B(I, 2703, "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"), B(I, 33676, "AQ=="), B(I, 33712, "AQ=="), B(I, 33744, "4Ot6fDtBuK4WVuP68Z/EatoJjeucMrH9hmIFFl9JuABfnJW8o1CMJLHQsVWcg+9bBERcxFgcjobYIk7d0J8RV+z///////////////////////////////////////9/7f///////////////////////////////////////3/u////////////////////////////////////////fw=="), B(I, 33936, "Z+YJaoWuZ7ty8248OvVPpX9SDlGMaAWbq9mDHxnN4FuYL4pCkUQ3cc/7wLWl27XpW8JWOfER8Vmkgj+S1V4cq5iqB9gBW4MSvoUxJMN9DFV0Xb5y/rHegKcG3Jt08ZvBwWmb5IZHvu/GncEPzKEMJG8s6S2qhHRK3KmwXNqI+XZSUT6YbcYxqMgnA7DHf1m/8wvgxkeRp9VRY8oGZykpFIUKtyc4IRsu/G0sTRMNOFNUcwpluwpqdi7JwoGFLHKSoei/oktmGqhwi0vCo1FsxxnoktEkBpnWhTUO9HCgahAWwaQZCGw3Hkx3SCe1vLA0swwcOUqq2E5Pypxb828uaO6Cj3RvY6V4FHjIhAgCx4z6/76Q62xQpPej+b7yeHHGgA=="), B(I, 34304, "CMm882fmCWo7p8qEha5nuyv4lP5y82488TYdXzr1T6XRguatf1IOUR9sPiuMaAWba71B+6vZgx95IX4TGc3gWyKuKNeYL4pCzWXvI5FEN3EvO03sz/vAtbzbiYGl27XpOLVI81vCVjkZ0AW28RHxWZtPGa+kgj+SGIFt2tVeHKtCAgOjmKoH2L5vcEUBW4MSjLLkTr6FMSTitP/Vw30MVW+Je/J0Xb5ysZYWO/6x3oA1Esclpwbcm5Qmac908ZvB0krxnsFpm+TjJU84hke+77XVjIvGncEPZZysd8yhDCR1AitZbyzpLYPkpm6qhHRK1PtBvdypsFy1UxGD2oj5dqvfZu5SUT6YEDK0LW3GMag/IfuYyCcDsOQO777Hf1m/wo+oPfML4MYlpwqTR5Gn1W+CA+BRY8oGcG4OCmcpKRT8L9JGhQq3JybJJlw4IRsu7SrEWvxtLE3fs5WdEw04U95jr4tUcwplqLJ3PLsKanbmru1HLsnCgTs1ghSFLHKSZAPxTKHov6IBMEK8S2YaqJGX+NBwi0vCML5UBqNRbMcYUu/WGeiS0RCpZVUkBpnWKiBxV4U1DvS40bsycKBqEMjQ0rgWwaQZU6tBUQhsNx6Z647fTHdIJ6hIm+G1vLA0Y1rJxbMMHDnLikHjSqrYTnPjY3dPypxbo7iy1vNvLmj8su9d7oKPdGAvF0NvY6V4cqvwoRR4yITsOWQaCALHjCgeYyP6/76Q6b2C3utsUKQVecay96P5vitTcuPyeHHGnGEm6s4+J8oHwsAhx7iG0R7r4M3WfdrqeNFu7n9PffW6bxdyqmfwBqaYyKLFfWMKrg35vgSYPxEbRxwTNQtxG4R9BCP1d9sokyTHQHuryjK8vskVCr6ePEwNEJzEZx1DtkI+y77UxUwqfmX8nCl/Wez61jqrb8tfF1hHSowZRGyA"), B(I, 35136, "U2lnRWQyNTUxOSBubyBFZDI1NTE5IGNvbGxpc2lvbnMB"), B(I, 35200, "0I4BAAEAAAACAAAAAwAAAAQAAAAFAAAABgAAAAcAAAAIAAAACQAAAAoAAAALAAAADAAAAA0=");
                                    var yI, wI = (yI = [
                                        null,
                                        function(A, I, g, C, B) {
                                            var Q, i, f;
                                            return A |= 0, I |= 0, g |= 0, C |= 0, B |= 0, w = Q = (i = w) - 128 & -64, o[Q >> 2] = 67108863 & (a[0 | B] | a[B + 1 | 0] << 8 | a[B + 2 | 0] << 16 | a[B + 3 | 0] << 24), o[Q + 4 >> 2] = (a[B + 3 | 0] | a[B + 4 | 0] << 8 | a[B + 5 | 0] << 16 | a[B + 6 | 0] << 24) >>> 2 & 67108611, o[Q + 8 >> 2] = (a[B + 6 | 0] | a[B + 7 | 0] << 8 | a[B + 8 | 0] << 16 | a[B + 9 | 0] << 24) >>> 4 & 67092735, o[Q + 12 >> 2] = (a[B + 9 | 0] | a[B + 10 | 0] << 8 | a[B + 11 | 0] << 16 | a[B + 12 | 0] << 24) >>> 6 & 66076671, f = a[B + 12 | 0] | a[B + 13 | 0] << 8 | a[B + 14 | 0] << 16 | a[B + 15 | 0] << 24, o[Q + 20 >> 2] = 0, o[Q + 24 >> 2] = 0, o[Q + 28 >> 2] = 0, o[Q + 32 >> 2] = 0, o[Q + 36 >> 2] = 0, o[Q + 16 >> 2] = f >>> 8 & 1048575, o[Q + 40 >> 2] = a[B + 16 | 0] | a[B + 17 | 0] << 8 | a[B + 18 | 0] << 16 | a[B + 19 | 0] << 24, o[Q + 44 >> 2] = a[B + 20 | 0] | a[B + 21 | 0] << 8 | a[B + 22 | 0] << 16 | a[B + 23 | 0] << 24, o[Q + 48 >> 2] = a[B + 24 | 0] | a[B + 25 | 0] << 8 | a[B + 26 | 0] << 16 | a[B + 27 | 0] << 24, B = a[B + 28 | 0] | a[B + 29 | 0] << 8 | a[B + 30 | 0] << 16 | a[B + 31 | 0] << 24, E[Q + 80 | 0] = 0, o[Q + 56 >> 2] = 0, o[Q + 60 >> 2] = 0, o[Q + 52 >> 2] = B, j(Q, I, g, C), $(Q, A), w = i, 0;
                                        },
                                        function(A, I, g, C, B) {
                                            var Q, i, f;
                                            return A |= 0, I |= 0, g |= 0, C |= 0, B |= 0, w = Q = (i = w) - 192 & -64, o[Q + 64 >> 2] = 67108863 & (a[0 | B] | a[B + 1 | 0] << 8 | a[B + 2 | 0] << 16 | a[B + 3 | 0] << 24), o[Q + 68 >> 2] = (a[B + 3 | 0] | a[B + 4 | 0] << 8 | a[B + 5 | 0] << 16 | a[B + 6 | 0] << 24) >>> 2 & 67108611, o[Q + 72 >> 2] = (a[B + 6 | 0] | a[B + 7 | 0] << 8 | a[B + 8 | 0] << 16 | a[B + 9 | 0] << 24) >>> 4 & 67092735, o[Q + 76 >> 2] = (a[B + 9 | 0] | a[B + 10 | 0] << 8 | a[B + 11 | 0] << 16 | a[B + 12 | 0] << 24) >>> 6 & 66076671, f = a[B + 12 | 0] | a[B + 13 | 0] << 8 | a[B + 14 | 0] << 16 | a[B + 15 | 0] << 24, o[Q + 84 >> 2] = 0, o[Q + 88 >> 2] = 0, o[Q + 92 >> 2] = 0, o[Q + 96 >> 2] = 0, o[Q + 100 >> 2] = 0, o[Q + 80 >> 2] = f >>> 8 & 1048575, o[Q + 104 >> 2] = a[B + 16 | 0] | a[B + 17 | 0] << 8 | a[B + 18 | 0] << 16 | a[B + 19 | 0] << 24, o[Q + 108 >> 2] = a[B + 20 | 0] | a[B + 21 | 0] << 8 | a[B + 22 | 0] << 16 | a[B + 23 | 0] << 24, o[Q + 112 >> 2] = a[B + 24 | 0] | a[B + 25 | 0] << 8 | a[B + 26 | 0] << 16 | a[B + 27 | 0] << 24, B = a[B + 28 | 0] | a[B + 29 | 0] << 8 | a[B + 30 | 0] << 16 | a[B + 31 | 0] << 24, E[Q + 144 | 0] = 0, o[Q + 120 >> 2] = 0, o[Q + 124 >> 2] = 0, o[Q + 116 >> 2] = B, j(B = Q - -64 | 0, I, g, C), $(B, I = Q + 48 | 0), A = CA(A, I), w = i, 0 | A;
                                        },
                                        function(A, I) {
                                            var g;
                                            return I |= 0, o[(A |= 0) >> 2] = 67108863 & (a[0 | I] | a[I + 1 | 0] << 8 | a[I + 2 | 0] << 16 | a[I + 3 | 0] << 24), o[A + 4 >> 2] = (a[I + 3 | 0] | a[I + 4 | 0] << 8 | a[I + 5 | 0] << 16 | a[I + 6 | 0] << 24) >>> 2 & 67108611, o[A + 8 >> 2] = (a[I + 6 | 0] | a[I + 7 | 0] << 8 | a[I + 8 | 0] << 16 | a[I + 9 | 0] << 24) >>> 4 & 67092735, o[A + 12 >> 2] = (a[I + 9 | 0] | a[I + 10 | 0] << 8 | a[I + 11 | 0] << 16 | a[I + 12 | 0] << 24) >>> 6 & 66076671, g = a[I + 12 | 0] | a[I + 13 | 0] << 8 | a[I + 14 | 0] << 16 | a[I + 15 | 0] << 24, o[A + 20 >> 2] = 0, o[A + 24 >> 2] = 0, o[A + 28 >> 2] = 0, o[A + 32 >> 2] = 0, o[A + 36 >> 2] = 0, o[A + 16 >> 2] = g >>> 8 & 1048575, o[A + 40 >> 2] = a[I + 16 | 0] | a[I + 17 | 0] << 8 | a[I + 18 | 0] << 16 | a[I + 19 | 0] << 24, o[A + 44 >> 2] = a[I + 20 | 0] | a[I + 21 | 0] << 8 | a[I + 22 | 0] << 16 | a[I + 23 | 0] << 24, o[A + 48 >> 2] = a[I + 24 | 0] | a[I + 25 | 0] << 8 | a[I + 26 | 0] << 16 | a[I + 27 | 0] << 24, I = a[I + 28 | 0] | a[I + 29 | 0] << 8 | a[I + 30 | 0] << 16 | a[I + 31 | 0] << 24, E[A + 80 | 0] = 0, o[A + 56 >> 2] = 0, o[A + 60 >> 2] = 0, o[A + 52 >> 2] = I, 0;
                                        },
                                        function(A, I, g, C) {
                                            return j(A |= 0, I |= 0, g |= 0, C |= 0), 0;
                                        },
                                        function(A, I) {
                                            return $(A |= 0, I |= 0), 0;
                                        },
                                        function(A, I, g) {
                                            A |= 0, I |= 0, g |= 0;
                                            var C, B = 0, Q = 0, i = 0, f = 0, c = 0, e = 0, r = 0, D = 0, t = 0, y = 0, n = 0, s = 0, k = 0, F = 0, S = 0, G = 0, _ = 0, p = 0, N = 0, J = 0, U = 0, Y = 0, d = 0, K = 0, b = 0, P = 0, v = 0, R = 0, u = 0, x = 0, m = 0, l = 0, z = 0, q = 0, X = 0, j = 0, T = 0, V = 0, Z = 0, W = 0, $ = 0, AA = 0, gA = 0, CA = 0, BA = 0, QA = 0, iA = 0, EA = 0, oA = 0, aA = 0, fA = 0, cA = 0, eA = 0, rA = 0, DA = 0, tA = 0, yA = 0, wA = 0, hA = 0, nA = 0, sA = 0, FA = 0, SA = 0, HA = 0, GA = 0, _A = 0;
                                            for(w = C = w - 368 | 0; n = (i = a[g + B | 0]) ^ a[0 | (c = B + 33680 | 0)] | n, y = i ^ a[c + 192 | 0] | y, t = i ^ a[c + 160 | 0] | t, D = i ^ a[c + 128 | 0] | D, f = i ^ a[c + 96 | 0] | f, e = i ^ a[c - -64 | 0] | e, Q = i ^ a[c + 32 | 0] | Q, 31 != (0 | (B = B + 1 | 0)););
                                            if (B = -1, !(256 & ((255 & ((i = 127 ^ (c = 127 & a[g + 31 | 0])) | y)) - 1 | (255 & (i | t)) - 1 | (255 & (i | D)) - 1 | (255 & (87 ^ c | f)) - 1 | (255 & (e | c)) - 1 | (255 & (Q | c)) - 1 | (255 & (c | n)) - 1))) {
                                                for(B = I, I = a[I + 28 | 0] | a[I + 29 | 0] << 8 | a[I + 30 | 0] << 16 | a[I + 31 | 0] << 24, o[C + 360 >> 2] = a[B + 24 | 0] | a[B + 25 | 0] << 8 | a[B + 26 | 0] << 16 | a[B + 27 | 0] << 24, o[C + 364 >> 2] = I, I = a[B + 20 | 0] | a[B + 21 | 0] << 8 | a[B + 22 | 0] << 16 | a[B + 23 | 0] << 24, o[C + 352 >> 2] = a[B + 16 | 0] | a[B + 17 | 0] << 8 | a[B + 18 | 0] << 16 | a[B + 19 | 0] << 24, o[C + 356 >> 2] = I, Q = a[B + 4 | 0] | a[B + 5 | 0] << 8 | a[B + 6 | 0] << 16 | a[B + 7 | 0] << 24, I = a[0 | B] | a[B + 1 | 0] << 8 | a[B + 2 | 0] << 16 | a[B + 3 | 0] << 24, o[C + 336 >> 2] = I, o[C + 340 >> 2] = Q, Q = a[B + 12 | 0] | a[B + 13 | 0] << 8 | a[B + 14 | 0] << 16 | a[B + 15 | 0] << 24, o[C + 344 >> 2] = a[B + 8 | 0] | a[B + 9 | 0] << 8 | a[B + 10 | 0] << 16 | a[B + 11 | 0] << 24, o[C + 348 >> 2] = Q, E[C + 336 | 0] = 248 & I, E[C + 367 | 0] = 63 & a[C + 367 | 0] | 64, L(C + 288 | 0, g), o[C + 260 >> 2] = 0, o[C + 264 >> 2] = 0, o[C + 268 >> 2] = 0, o[C + 272 >> 2] = 0, o[C + 276 >> 2] = 0, o[C + 208 >> 2] = 0, o[C + 212 >> 2] = 0, o[C + 216 >> 2] = 0, o[C + 220 >> 2] = 0, o[C + 224 >> 2] = 0, o[C + 228 >> 2] = 0, I = o[C + 308 >> 2], o[C + 160 >> 2] = o[C + 304 >> 2], o[C + 164 >> 2] = I, I = o[C + 316 >> 2], o[C + 168 >> 2] = o[C + 312 >> 2], o[C + 172 >> 2] = I, I = o[C + 324 >> 2], o[C + 176 >> 2] = o[C + 320 >> 2], o[C + 180 >> 2] = I, o[C + 244 >> 2] = 0, o[C + 248 >> 2] = 0, o[C + 240 >> 2] = 1, o[C + 252 >> 2] = 0, o[C + 256 >> 2] = 0, o[C + 192 >> 2] = 0, o[C + 196 >> 2] = 0, o[C + 200 >> 2] = 0, o[C + 204 >> 2] = 0, I = o[C + 292 >> 2], o[C + 144 >> 2] = o[C + 288 >> 2], o[C + 148 >> 2] = I, I = o[C + 300 >> 2], o[C + 152 >> 2] = o[C + 296 >> 2], o[C + 156 >> 2] = I, o[C + 116 >> 2] = 0, o[C + 120 >> 2] = 0, o[C + 124 >> 2] = 0, o[C + 128 >> 2] = 0, o[C + 132 >> 2] = 0, o[C + 100 >> 2] = 0, o[C + 104 >> 2] = 0, o[C + 96 >> 2] = 1, o[C + 108 >> 2] = 0, o[C + 112 >> 2] = 0, g = 254; $ = o[C + 276 >> 2], i = o[C + 180 >> 2], AA = o[C + 96 >> 2], gA = o[C + 192 >> 2], CA = o[C + 144 >> 2], BA = o[C + 240 >> 2], QA = o[C + 100 >> 2], iA = o[C + 196 >> 2], EA = o[C + 148 >> 2], oA = o[C + 244 >> 2], Y = o[C + 104 >> 2], aA = o[C + 200 >> 2], d = o[C + 152 >> 2], fA = o[C + 248 >> 2], P = o[C + 108 >> 2], cA = o[C + 204 >> 2], v = o[C + 156 >> 2], eA = o[C + 252 >> 2], K = o[C + 112 >> 2], rA = o[C + 208 >> 2], J = o[C + 160 >> 2], DA = o[C + 256 >> 2], n = o[C + 116 >> 2], tA = o[C + 212 >> 2], r = o[C + 164 >> 2], yA = o[C + 260 >> 2], y = o[C + 120 >> 2], wA = o[C + 216 >> 2], t = o[C + 168 >> 2], hA = o[C + 264 >> 2], D = o[C + 124 >> 2], nA = o[C + 220 >> 2], f = o[C + 172 >> 2], sA = o[C + 268 >> 2], e = o[C + 128 >> 2], FA = o[C + 224 >> 2], Q = o[C + 176 >> 2], N = o[C + 272 >> 2], SA = g, U = (G = (I = 0 - ((I = W) ^ (W = a[(HA = C + 336 | 0) + (g >>> 3 | 0) | 0] >>> (7 & g) & 1)) | 0) & ((B = o[C + 132 >> 2]) ^ (j = o[C + 228 >> 2]))) ^ B, o[C + 132 >> 2] = U, T = i ^ (_ = I & (i ^ $)), o[C + 84 >> 2] = T - U, b = e ^ (k = I & (e ^ FA)), o[C + 128 >> 2] = b, V = (p = I & (Q ^ N)) ^ Q, o[C + 80 >> 2] = V - b, u = D ^ (F = I & (D ^ nA)), o[C + 124 >> 2] = u, GA = f ^ (S = I & (f ^ sA)), o[C + 76 >> 2] = GA - u, x = y ^ (s = I & (y ^ wA)), o[C + 120 >> 2] = x, _A = t ^ (c = I & (t ^ hA)), o[C + 72 >> 2] = _A - x, m = n ^ (i = I & (n ^ tA)), o[C + 116 >> 2] = m, l = r ^ (n = I & (r ^ yA)), o[C + 68 >> 2] = l - m, z = K ^ (y = I & (K ^ rA)), o[C + 112 >> 2] = z, R = J ^ (t = I & (J ^ DA)), o[C + 64 >> 2] = R - z, q = P ^ (D = I & (P ^ cA)), o[C + 108 >> 2] = q, Z = v ^ (f = I & (v ^ eA)), o[C + 60 >> 2] = Z - q, X = Y ^ (e = I & (Y ^ aA)), o[C + 104 >> 2] = X, P = d ^ (Q = I & (d ^ fA)), o[C + 56 >> 2] = P - X, Y = QA ^ (B = I & (QA ^ iA)), o[C + 100 >> 2] = Y, v = EA ^ (g = I & (EA ^ oA)), o[C + 52 >> 2] = v - Y, d = AA ^ (K = I & (AA ^ gA)), o[C + 96 >> 2] = d, J = (I &= CA ^ BA) ^ CA, o[C + 48 >> 2] = J - d, r = _ ^ $, G ^= j, o[C + 36 >> 2] = r - G, _ = p ^ N, k ^= FA, o[C + 32 >> 2] = _ - k, p = S ^ sA, F ^= nA, o[C + 28 >> 2] = p - F, S = c ^ hA, s ^= wA, o[C + 24 >> 2] = S - s, c = n ^ yA, i ^= tA, o[C + 20 >> 2] = c - i, n = t ^ DA, y ^= rA, o[C + 16 >> 2] = n - y, t = f ^ eA, D ^= cA, o[C + 12 >> 2] = t - D, f = Q ^ fA, e ^= aA, o[C + 8 >> 2] = f - e, Q = g ^ oA, B ^= iA, o[C + 4 >> 2] = Q - B, g = I ^ BA, I = K ^ gA, o[C >> 2] = g - I, o[C + 276 >> 2] = r + G, o[C + 272 >> 2] = _ + k, o[C + 268 >> 2] = F + p, o[C + 264 >> 2] = s + S, o[C + 260 >> 2] = i + c, o[C + 256 >> 2] = y + n, o[C + 248 >> 2] = f + e, o[C + 244 >> 2] = B + Q, o[C + 240 >> 2] = I + g, o[C + 252 >> 2] = D + t, o[C + 228 >> 2] = U + T, o[C + 224 >> 2] = b + V, o[C + 220 >> 2] = u + GA, o[C + 216 >> 2] = x + _A, o[C + 212 >> 2] = m + l, o[C + 208 >> 2] = R + z, o[C + 204 >> 2] = q + Z, o[C + 200 >> 2] = P + X, o[C + 196 >> 2] = Y + v, o[C + 192 >> 2] = J + d, H(T = C + 96 | 0, b = C + 48 | 0, U = C + 240 | 0), H(N = C + 192 | 0, N, C), M(b, C), M(C, U), r = o[C + 192 >> 2], G = o[C + 96 >> 2], _ = o[C + 196 >> 2], k = o[C + 100 >> 2], p = o[C + 200 >> 2], F = o[C + 104 >> 2], S = o[C + 204 >> 2], s = o[C + 108 >> 2], c = o[C + 208 >> 2], i = o[C + 112 >> 2], n = o[C + 212 >> 2], y = o[C + 116 >> 2], t = o[C + 216 >> 2], D = o[C + 120 >> 2], f = o[C + 220 >> 2], e = o[C + 124 >> 2], Q = o[C + 224 >> 2], B = o[C + 128 >> 2], g = o[C + 228 >> 2], I = o[C + 132 >> 2], o[C + 180 >> 2] = g + I, o[C + 176 >> 2] = B + Q, o[C + 172 >> 2] = f + e, o[C + 168 >> 2] = D + t, o[C + 164 >> 2] = y + n, o[C + 160 >> 2] = i + c, o[C + 156 >> 2] = s + S, o[C + 152 >> 2] = F + p, o[C + 148 >> 2] = _ + k, o[C + 144 >> 2] = r + G, o[C + 228 >> 2] = I - g, o[C + 224 >> 2] = B - Q, o[C + 220 >> 2] = e - f, o[C + 216 >> 2] = D - t, o[C + 212 >> 2] = y - n, o[C + 208 >> 2] = i - c, o[C + 204 >> 2] = s - S, o[C + 200 >> 2] = F - p, o[C + 196 >> 2] = k - _, o[C + 192 >> 2] = G - r, H(U, C, b), u = o[C + 52 >> 2], s = o[C + 4 >> 2], x = o[C + 56 >> 2], c = o[C + 8 >> 2], m = o[C + 64 >> 2], t = o[C + 16 >> 2], z = o[C + 60 >> 2], D = o[C + 12 >> 2], q = o[C + 72 >> 2], f = o[C + 24 >> 2], X = o[C + 68 >> 2], e = o[C + 20 >> 2], Y = o[C + 80 >> 2], Q = o[C + 32 >> 2], d = o[C + 76 >> 2], B = o[C + 28 >> 2], j = o[C + 84 >> 2], I = o[C + 36 >> 2], V = o[C + 48 >> 2], g = o[C >> 2] - V | 0, o[C >> 2] = g, I = I - j | 0, o[C + 36 >> 2] = I, K = B - d | 0, o[C + 28 >> 2] = K, J = Q - Y | 0, o[C + 32 >> 2] = J, i = e - X | 0, o[C + 20 >> 2] = i, n = f - q | 0, o[C + 24 >> 2] = n, y = D - z | 0, o[C + 12 >> 2] = y, t = t - m | 0, o[C + 16 >> 2] = t, D = c - x | 0, o[C + 8 >> 2] = D, Q = s - u | 0, o[C + 4 >> 2] = Q, M(N, N), I = kA(I, I >> 31, 121666, 0), B = h, Z = I, I = kA((33554431 & (B = (r = I + 16777216 | 0) >>> 0 < 16777216 ? B + 1 | 0 : B)) << 7 | r >>> 25, B >> 25, 19, 0), e = h, B = I, I = kA(g, g >> 31, 121666, 0), R = h + e | 0, I = I >>> 0 > (B = B + I | 0) >>> 0 ? R + 1 | 0 : R, g = (f = B + 33554432 | 0) >>> 0 < 33554432 ? I + 1 | 0 : I, G = B - (-67108864 & f) | 0, o[C + 96 >> 2] = G, e = kA(Q, Q >> 31, 121666, 0), B = h, B = (Q = e + 16777216 | 0) >>> 0 < 16777216 ? B + 1 | 0 : B, _ = (e - (-33554432 & Q) | 0) + ((67108863 & g) << 6 | f >>> 26) | 0, o[C + 100 >> 2] = _, R = (I = B) >> 25, B = (33554431 & I) << 7 | Q >>> 25, g = kA(D, D >> 31, 121666, 0) + B | 0, I = R + h | 0, I = g >>> 0 < B >>> 0 ? I + 1 | 0 : I, e = (k = g + 33554432 | 0) >>> 0 < 33554432 ? I + 1 | 0 : I, p = g - (-67108864 & k) | 0, o[C + 104 >> 2] = p, B = kA(t, t >> 31, 121666, 0), Q = h, g = kA(y, y >> 31, 121666, 0), I = h, l = B, P = g, B = (33554431 & (I = (F = g + 16777216 | 0) >>> 0 < 16777216 ? I + 1 | 0 : I)) << 7 | F >>> 25, I = (I >> 25) + Q | 0, I = (g = l + B | 0) >>> 0 < B >>> 0 ? I + 1 | 0 : I, Q = (S = g + 33554432 | 0) >>> 0 < 33554432 ? I + 1 | 0 : I, s = g - (-67108864 & S) | 0, o[C + 112 >> 2] = s, B = kA(n, n >> 31, 121666, 0), f = h, g = kA(i, i >> 31, 121666, 0), I = h, l = B, v = g, B = (33554431 & (I = (c = g + 16777216 | 0) >>> 0 < 16777216 ? I + 1 | 0 : I)) << 7 | c >>> 25, I = (I >> 25) + f | 0, I = (g = l + B | 0) >>> 0 < B >>> 0 ? I + 1 | 0 : I, B = (i = g + 33554432 | 0) >>> 0 < 33554432 ? I + 1 | 0 : I, n = g - (-67108864 & i) | 0, o[C + 120 >> 2] = n, f = kA(J, J >> 31, 121666, 0), D = h, g = kA(K, K >> 31, 121666, 0), I = h, J = g, g = (33554431 & (I = (y = g + 16777216 | 0) >>> 0 < 16777216 ? I + 1 | 0 : I)) << 7 | y >>> 25, I = (I >> 25) + D | 0, I = g >>> 0 > (f = g + f | 0) >>> 0 ? I + 1 | 0 : I, g = (t = f + 33554432 | 0) >>> 0 < 33554432 ? I + 1 | 0 : I, D = f - (-67108864 & t) | 0, o[C + 128 >> 2] = D, f = (e = P + ((67108863 & e) << 6 | k >>> 26) | 0) - (-33554432 & F) | 0, o[C + 108 >> 2] = f, e = (Q = v + ((67108863 & Q) << 6 | S >>> 26) | 0) - (-33554432 & c) | 0, o[C + 116 >> 2] = e, Q = (I = J + ((67108863 & B) << 6 | i >>> 26) | 0) - (-33554432 & y) | 0, o[C + 124 >> 2] = Q, g = (g = Z + ((67108863 & g) << 6 | t >>> 26) | 0) - (-33554432 & r) | 0, o[C + 132 >> 2] = g, M(I = C + 144 | 0, I), o[C + 84 >> 2] = g + j, o[C + 80 >> 2] = D + Y, o[C + 76 >> 2] = Q + d, o[C + 72 >> 2] = n + q, o[C + 68 >> 2] = e + X, o[C + 64 >> 2] = s + m, o[C + 60 >> 2] = f + z, o[C + 56 >> 2] = p + x, o[C + 52 >> 2] = _ + u, o[C + 48 >> 2] = G + V, g = SA - 1 | 0, H(T, C + 288 | 0, N), H(N, C, b), SA;);
                                                n = o[C + 144 >> 2], G = o[C + 240 >> 2], y = o[C + 148 >> 2], _ = o[C + 244 >> 2], t = o[C + 152 >> 2], k = o[C + 248 >> 2], D = o[C + 156 >> 2], p = o[C + 252 >> 2], f = o[C + 160 >> 2], F = o[C + 256 >> 2], e = o[C + 164 >> 2], S = o[C + 260 >> 2], Q = o[C + 168 >> 2], s = o[C + 264 >> 2], B = o[C + 172 >> 2], c = o[C + 268 >> 2], g = o[C + 176 >> 2], i = o[C + 272 >> 2], r = 0 - W | 0, I = o[C + 276 >> 2], o[C + 276 >> 2] = r & (I ^ o[C + 180 >> 2]) ^ I, o[C + 272 >> 2] = i ^ r & (g ^ i), o[C + 268 >> 2] = c ^ r & (B ^ c), o[C + 264 >> 2] = s ^ r & (Q ^ s), o[C + 260 >> 2] = S ^ r & (e ^ S), o[C + 256 >> 2] = F ^ r & (f ^ F), o[C + 252 >> 2] = p ^ r & (D ^ p), o[C + 248 >> 2] = k ^ r & (t ^ k), o[C + 244 >> 2] = _ ^ r & (y ^ _), o[C + 240 >> 2] = G ^ r & (n ^ G), G = o[C + 192 >> 2], n = o[C + 96 >> 2], _ = o[C + 196 >> 2], y = o[C + 100 >> 2], k = o[C + 200 >> 2], t = o[C + 104 >> 2], p = o[C + 204 >> 2], D = o[C + 108 >> 2], F = o[C + 208 >> 2], f = o[C + 112 >> 2], S = o[C + 212 >> 2], e = o[C + 116 >> 2], s = o[C + 216 >> 2], Q = o[C + 120 >> 2], c = o[C + 220 >> 2], B = o[C + 124 >> 2], i = o[C + 224 >> 2], g = o[C + 128 >> 2], I = o[C + 228 >> 2], o[C + 228 >> 2] = r & (I ^ o[C + 132 >> 2]) ^ I, o[C + 224 >> 2] = i ^ r & (g ^ i), o[C + 220 >> 2] = c ^ r & (B ^ c), o[C + 216 >> 2] = s ^ r & (Q ^ s), o[C + 212 >> 2] = S ^ r & (e ^ S), o[C + 208 >> 2] = F ^ r & (f ^ F), o[C + 204 >> 2] = p ^ r & (D ^ p), o[C + 200 >> 2] = k ^ r & (t ^ k), o[C + 196 >> 2] = _ ^ r & (y ^ _), o[C + 192 >> 2] = G ^ r & (n ^ G), O(N, N), H(U, U, N), IA(A, U), iI(HA, 32), B = 0;
                                            }
                                            return w = C + 368 | 0, 0 | B;
                                        },
                                        function(A, I) {
                                            var g, C, B, Q, i, f, c, e, r, D, t, y, h, n, s, k, F, S, G, _;
                                            return I |= 0, w = g = w - 304 | 0, E[0 | (A |= 0)] = a[0 | I], E[A + 1 | 0] = a[I + 1 | 0], E[A + 2 | 0] = a[I + 2 | 0], E[A + 3 | 0] = a[I + 3 | 0], E[A + 4 | 0] = a[I + 4 | 0], E[A + 5 | 0] = a[I + 5 | 0], E[A + 6 | 0] = a[I + 6 | 0], E[A + 7 | 0] = a[I + 7 | 0], E[A + 8 | 0] = a[I + 8 | 0], E[A + 9 | 0] = a[I + 9 | 0], E[A + 10 | 0] = a[I + 10 | 0], E[A + 11 | 0] = a[I + 11 | 0], E[A + 12 | 0] = a[I + 12 | 0], E[A + 13 | 0] = a[I + 13 | 0], E[A + 14 | 0] = a[I + 14 | 0], E[A + 15 | 0] = a[I + 15 | 0], E[A + 16 | 0] = a[I + 16 | 0], E[A + 17 | 0] = a[I + 17 | 0], E[A + 18 | 0] = a[I + 18 | 0], E[A + 19 | 0] = a[I + 19 | 0], E[A + 20 | 0] = a[I + 20 | 0], E[A + 21 | 0] = a[I + 21 | 0], E[A + 22 | 0] = a[I + 22 | 0], E[A + 23 | 0] = a[I + 23 | 0], E[A + 24 | 0] = a[I + 24 | 0], E[A + 25 | 0] = a[I + 25 | 0], E[A + 26 | 0] = a[I + 26 | 0], E[A + 27 | 0] = a[I + 27 | 0], E[A + 28 | 0] = a[I + 28 | 0], E[A + 29 | 0] = a[I + 29 | 0], E[A + 30 | 0] = a[I + 30 | 0], I = a[I + 31 | 0], E[0 | A] = 248 & a[0 | A], E[A + 31 | 0] = 63 & I | 64, u(g + 48 | 0, A), I = o[g + 132 >> 2], C = o[g + 92 >> 2], B = o[g + 136 >> 2], Q = o[g + 96 >> 2], i = o[g + 140 >> 2], f = o[g + 100 >> 2], c = o[g + 144 >> 2], e = o[g + 104 >> 2], r = o[g + 148 >> 2], D = o[g + 108 >> 2], t = o[g + 152 >> 2], y = o[g + 112 >> 2], h = o[g + 156 >> 2], n = o[g + 116 >> 2], s = o[g + 160 >> 2], k = o[g + 120 >> 2], F = o[g + 128 >> 2], S = o[g + 88 >> 2], G = o[g + 124 >> 2], _ = o[g + 164 >> 2], o[g + 292 >> 2] = G + _, o[g + 288 >> 2] = s + k, o[g + 284 >> 2] = h + n, o[g + 280 >> 2] = t + y, o[g + 276 >> 2] = r + D, o[g + 272 >> 2] = c + e, o[g + 268 >> 2] = i + f, o[g + 264 >> 2] = B + Q, o[g + 260 >> 2] = I + C, o[g + 256 >> 2] = F + S, o[g + 244 >> 2] = _ - G, o[g + 240 >> 2] = s - k, o[g + 236 >> 2] = h - n, o[g + 232 >> 2] = t - y, o[g + 228 >> 2] = r - D, o[g + 224 >> 2] = c - e, o[g + 220 >> 2] = i - f, o[g + 216 >> 2] = B - Q, o[g + 212 >> 2] = I - C, o[g + 208 >> 2] = F - S, O(I = g + 208 | 0, I), H(g, g + 256 | 0, I), IA(A, g), w = g + 304 | 0, 0;
                                        },
                                        function(A, I, g, C, B) {
                                            A |= 0, C |= 0, B |= 0;
                                            var Q, i = 0, f = 0, c = 0, e = 0;
                                            if (w = Q = w - 112 | 0, (I |= 0) | (g |= 0)) {
                                                i = a[B + 28 | 0] | a[B + 29 | 0] << 8 | a[B + 30 | 0] << 16 | a[B + 31 | 0] << 24, o[Q + 24 >> 2] = a[B + 24 | 0] | a[B + 25 | 0] << 8 | a[B + 26 | 0] << 16 | a[B + 27 | 0] << 24, o[Q + 28 >> 2] = i, i = a[B + 20 | 0] | a[B + 21 | 0] << 8 | a[B + 22 | 0] << 16 | a[B + 23 | 0] << 24, o[Q + 16 >> 2] = a[B + 16 | 0] | a[B + 17 | 0] << 8 | a[B + 18 | 0] << 16 | a[B + 19 | 0] << 24, o[Q + 20 >> 2] = i, i = a[B + 4 | 0] | a[B + 5 | 0] << 8 | a[B + 6 | 0] << 16 | a[B + 7 | 0] << 24, o[Q >> 2] = a[0 | B] | a[B + 1 | 0] << 8 | a[B + 2 | 0] << 16 | a[B + 3 | 0] << 24, o[Q + 4 >> 2] = i, i = a[B + 12 | 0] | a[B + 13 | 0] << 8 | a[B + 14 | 0] << 16 | a[B + 15 | 0] << 24, o[Q + 8 >> 2] = a[B + 8 | 0] | a[B + 9 | 0] << 8 | a[B + 10 | 0] << 16 | a[B + 11 | 0] << 24, o[Q + 12 >> 2] = i, B = a[0 | C] | a[C + 1 | 0] << 8 | a[C + 2 | 0] << 16 | a[C + 3 | 0] << 24, C = a[C + 4 | 0] | a[C + 5 | 0] << 8 | a[C + 6 | 0] << 16 | a[C + 7 | 0] << 24, o[Q + 104 >> 2] = 0, o[Q + 108 >> 2] = 0, o[Q + 96 >> 2] = B, o[Q + 100 >> 2] = C;
                                                A: {
                                                    if (!g & I >>> 0 >= 64 | g) {
                                                        for(; Y(A, Q + 96 | 0, Q), C = a[Q + 104 | 0] + 1 | 0, E[Q + 104 | 0] = C, C = a[Q + 105 | 0] + (C >>> 8 | 0) | 0, E[Q + 105 | 0] = C, C = a[Q + 106 | 0] + (C >>> 8 | 0) | 0, E[Q + 106 | 0] = C, C = a[Q + 107 | 0] + (C >>> 8 | 0) | 0, E[Q + 107 | 0] = C, C = a[Q + 108 | 0] + (C >>> 8 | 0) | 0, E[Q + 108 | 0] = C, C = a[Q + 109 | 0] + (C >>> 8 | 0) | 0, E[Q + 109 | 0] = C, C = a[Q + 110 | 0] + (C >>> 8 | 0) | 0, E[Q + 110 | 0] = C, E[Q + 111 | 0] = a[Q + 111 | 0] + (C >>> 8 | 0), A = A - -64 | 0, g = g - 1 | 0, !(g = (I = I + -64 | 0) >>> 0 < 4294967232 ? g + 1 | 0 : g) & I >>> 0 > 63 | g;);
                                                        if (!(I | g)) break A;
                                                    }
                                                    if (C = 0, Y(Q + 32 | 0, Q + 96 | 0, Q), g = 3 & I, B = 0, I - 1 >>> 0 >= 3) for(i = -4 & I, I = 0; f = c = Q + 32 | 0, E[A + B | 0] = a[f + B | 0], E[(e = 1 | B) + A | 0] = a[f + e | 0], E[(f = 2 | B) + A | 0] = a[f + c | 0], E[(f = 3 | B) + A | 0] = a[f + (Q + 32 | 0) | 0], B = B + 4 | 0, (0 | i) != (0 | (I = I + 4 | 0)););
                                                    if (g) for(; E[A + B | 0] = a[(Q + 32 | 0) + B | 0], B = B + 1 | 0, (0 | g) != (0 | (C = C + 1 | 0)););
                                                }
                                                iI(Q + 32 | 0, 64), iI(Q, 32);
                                            }
                                            return w = Q + 112 | 0, 0;
                                        },
                                        function(A, I, g, C, B, Q, i, f) {
                                            A |= 0, I |= 0, B |= 0, Q |= 0, i |= 0, f |= 0;
                                            var c, e = 0;
                                            if (w = c = w - 112 | 0, (g |= 0) | (C |= 0)) {
                                                e = a[f + 28 | 0] | a[f + 29 | 0] << 8 | a[f + 30 | 0] << 16 | a[f + 31 | 0] << 24, o[c + 24 >> 2] = a[f + 24 | 0] | a[f + 25 | 0] << 8 | a[f + 26 | 0] << 16 | a[f + 27 | 0] << 24, o[c + 28 >> 2] = e, e = a[f + 20 | 0] | a[f + 21 | 0] << 8 | a[f + 22 | 0] << 16 | a[f + 23 | 0] << 24, o[c + 16 >> 2] = a[f + 16 | 0] | a[f + 17 | 0] << 8 | a[f + 18 | 0] << 16 | a[f + 19 | 0] << 24, o[c + 20 >> 2] = e, e = a[f + 4 | 0] | a[f + 5 | 0] << 8 | a[f + 6 | 0] << 16 | a[f + 7 | 0] << 24, o[c >> 2] = a[0 | f] | a[f + 1 | 0] << 8 | a[f + 2 | 0] << 16 | a[f + 3 | 0] << 24, o[c + 4 >> 2] = e, e = a[f + 12 | 0] | a[f + 13 | 0] << 8 | a[f + 14 | 0] << 16 | a[f + 15 | 0] << 24, o[c + 8 >> 2] = a[f + 8 | 0] | a[f + 9 | 0] << 8 | a[f + 10 | 0] << 16 | a[f + 11 | 0] << 24, o[c + 12 >> 2] = e, f = a[B + 4 | 0] | a[B + 5 | 0] << 8 | a[B + 6 | 0] << 16 | a[B + 7 | 0] << 24, o[c + 96 >> 2] = a[0 | B] | a[B + 1 | 0] << 8 | a[B + 2 | 0] << 16 | a[B + 3 | 0] << 24, o[c + 100 >> 2] = f, E[c + 104 | 0] = Q, E[c + 111 | 0] = i >>> 24, E[c + 110 | 0] = i >>> 16, E[c + 109 | 0] = i >>> 8, E[c + 108 | 0] = i, E[c + 107 | 0] = (16777215 & i) << 8 | Q >>> 24, E[c + 106 | 0] = (65535 & i) << 16 | Q >>> 16, E[c + 105 | 0] = (255 & i) << 24 | Q >>> 8;
                                                A: {
                                                    if (!C & g >>> 0 >= 64 | C) {
                                                        for(;;){
                                                            for(f = 0, Y(c + 32 | 0, c + 96 | 0, c); Q = c + 32 | 0, E[A + f | 0] = a[Q + f | 0] ^ a[I + f | 0], E[(B = 1 | f) + A | 0] = a[B + Q | 0] ^ a[I + B | 0], 64 != (0 | (f = f + 2 | 0)););
                                                            if (B = a[c + 104 | 0] + 1 | 0, E[c + 104 | 0] = B, B = a[c + 105 | 0] + (B >>> 8 | 0) | 0, E[c + 105 | 0] = B, B = a[c + 106 | 0] + (B >>> 8 | 0) | 0, E[c + 106 | 0] = B, B = a[c + 107 | 0] + (B >>> 8 | 0) | 0, E[c + 107 | 0] = B, B = a[c + 108 | 0] + (B >>> 8 | 0) | 0, E[c + 108 | 0] = B, B = a[c + 109 | 0] + (B >>> 8 | 0) | 0, E[c + 109 | 0] = B, B = a[c + 110 | 0] + (B >>> 8 | 0) | 0, E[c + 110 | 0] = B, E[c + 111 | 0] = a[c + 111 | 0] + (B >>> 8 | 0), I = I - -64 | 0, A = A - -64 | 0, C = C - 1 | 0, !(!(C = (g = g + -64 | 0) >>> 0 < 4294967232 ? C + 1 | 0 : C) & g >>> 0 > 63 | C)) break;
                                                        }
                                                        if (!(g | C)) break A;
                                                    }
                                                    if (f = 0, Y(c + 32 | 0, c + 96 | 0, c), C = 1 & g, 1 != (0 | g)) for(Q = -2 & g, B = 0; i = c + 32 | 0, E[A + f | 0] = a[i + f | 0] ^ a[I + f | 0], E[(g = 1 | f) + A | 0] = a[g + i | 0] ^ a[I + g | 0], f = f + 2 | 0, (0 | Q) != (0 | (B = B + 2 | 0)););
                                                    C && (E[A + f | 0] = a[(c + 32 | 0) + f | 0] ^ a[I + f | 0]);
                                                }
                                                iI(c + 32 | 0, 64), iI(c, 32);
                                            }
                                            return w = c + 112 | 0, 0;
                                        },
                                        function(A, I, g, C, B) {
                                            var Q;
                                            return A |= 0, C |= 0, B |= 0, w = Q = w + -64 | 0, (I |= 0) | (g |= 0) && (o[Q + 8 >> 2] = 2036477234, o[Q + 12 >> 2] = 1797285236, o[Q >> 2] = 1634760805, o[Q + 4 >> 2] = 857760878, o[Q + 16 >> 2] = a[0 | B] | a[B + 1 | 0] << 8 | a[B + 2 | 0] << 16 | a[B + 3 | 0] << 24, o[Q + 20 >> 2] = a[B + 4 | 0] | a[B + 5 | 0] << 8 | a[B + 6 | 0] << 16 | a[B + 7 | 0] << 24, o[Q + 24 >> 2] = a[B + 8 | 0] | a[B + 9 | 0] << 8 | a[B + 10 | 0] << 16 | a[B + 11 | 0] << 24, o[Q + 28 >> 2] = a[B + 12 | 0] | a[B + 13 | 0] << 8 | a[B + 14 | 0] << 16 | a[B + 15 | 0] << 24, o[Q + 32 >> 2] = a[B + 16 | 0] | a[B + 17 | 0] << 8 | a[B + 18 | 0] << 16 | a[B + 19 | 0] << 24, o[Q + 36 >> 2] = a[B + 20 | 0] | a[B + 21 | 0] << 8 | a[B + 22 | 0] << 16 | a[B + 23 | 0] << 24, o[Q + 40 >> 2] = a[B + 24 | 0] | a[B + 25 | 0] << 8 | a[B + 26 | 0] << 16 | a[B + 27 | 0] << 24, B = a[B + 28 | 0] | a[B + 29 | 0] << 8 | a[B + 30 | 0] << 16 | a[B + 31 | 0] << 24, o[Q + 48 >> 2] = 0, o[Q + 52 >> 2] = 0, o[Q + 44 >> 2] = B, o[Q + 56 >> 2] = a[0 | C] | a[C + 1 | 0] << 8 | a[C + 2 | 0] << 16 | a[C + 3 | 0] << 24, o[Q + 60 >> 2] = a[C + 4 | 0] | a[C + 5 | 0] << 8 | a[C + 6 | 0] << 16 | a[C + 7 | 0] << 24, p(Q, A = dA(A, 0, I), A, I, g), iI(Q, 64)), w = Q - -64 | 0, 0;
                                        },
                                        function(A, I, g, C, B) {
                                            var Q;
                                            return A |= 0, C |= 0, B |= 0, w = Q = w + -64 | 0, (I |= 0) | (g |= 0) && (o[Q + 8 >> 2] = 2036477234, o[Q + 12 >> 2] = 1797285236, o[Q >> 2] = 1634760805, o[Q + 4 >> 2] = 857760878, o[Q + 16 >> 2] = a[0 | B] | a[B + 1 | 0] << 8 | a[B + 2 | 0] << 16 | a[B + 3 | 0] << 24, o[Q + 20 >> 2] = a[B + 4 | 0] | a[B + 5 | 0] << 8 | a[B + 6 | 0] << 16 | a[B + 7 | 0] << 24, o[Q + 24 >> 2] = a[B + 8 | 0] | a[B + 9 | 0] << 8 | a[B + 10 | 0] << 16 | a[B + 11 | 0] << 24, o[Q + 28 >> 2] = a[B + 12 | 0] | a[B + 13 | 0] << 8 | a[B + 14 | 0] << 16 | a[B + 15 | 0] << 24, o[Q + 32 >> 2] = a[B + 16 | 0] | a[B + 17 | 0] << 8 | a[B + 18 | 0] << 16 | a[B + 19 | 0] << 24, o[Q + 36 >> 2] = a[B + 20 | 0] | a[B + 21 | 0] << 8 | a[B + 22 | 0] << 16 | a[B + 23 | 0] << 24, o[Q + 40 >> 2] = a[B + 24 | 0] | a[B + 25 | 0] << 8 | a[B + 26 | 0] << 16 | a[B + 27 | 0] << 24, B = a[B + 28 | 0] | a[B + 29 | 0] << 8 | a[B + 30 | 0] << 16 | a[B + 31 | 0] << 24, o[Q + 48 >> 2] = 0, o[Q + 44 >> 2] = B, o[Q + 52 >> 2] = a[0 | C] | a[C + 1 | 0] << 8 | a[C + 2 | 0] << 16 | a[C + 3 | 0] << 24, o[Q + 56 >> 2] = a[C + 4 | 0] | a[C + 5 | 0] << 8 | a[C + 6 | 0] << 16 | a[C + 7 | 0] << 24, o[Q + 60 >> 2] = a[C + 8 | 0] | a[C + 9 | 0] << 8 | a[C + 10 | 0] << 16 | a[C + 11 | 0] << 24, p(Q, A = dA(A, 0, I), A, I, g), iI(Q, 64)), w = Q - -64 | 0, 0;
                                        },
                                        function(A, I, g, C, B, Q, i, E) {
                                            var f;
                                            return A |= 0, I |= 0, B |= 0, Q |= 0, i |= 0, E |= 0, w = f = w + -64 | 0, (g |= 0) | (C |= 0) && (o[f + 8 >> 2] = 2036477234, o[f + 12 >> 2] = 1797285236, o[f >> 2] = 1634760805, o[f + 4 >> 2] = 857760878, o[f + 16 >> 2] = a[0 | E] | a[E + 1 | 0] << 8 | a[E + 2 | 0] << 16 | a[E + 3 | 0] << 24, o[f + 20 >> 2] = a[E + 4 | 0] | a[E + 5 | 0] << 8 | a[E + 6 | 0] << 16 | a[E + 7 | 0] << 24, o[f + 24 >> 2] = a[E + 8 | 0] | a[E + 9 | 0] << 8 | a[E + 10 | 0] << 16 | a[E + 11 | 0] << 24, o[f + 28 >> 2] = a[E + 12 | 0] | a[E + 13 | 0] << 8 | a[E + 14 | 0] << 16 | a[E + 15 | 0] << 24, o[f + 32 >> 2] = a[E + 16 | 0] | a[E + 17 | 0] << 8 | a[E + 18 | 0] << 16 | a[E + 19 | 0] << 24, o[f + 36 >> 2] = a[E + 20 | 0] | a[E + 21 | 0] << 8 | a[E + 22 | 0] << 16 | a[E + 23 | 0] << 24, o[f + 40 >> 2] = a[E + 24 | 0] | a[E + 25 | 0] << 8 | a[E + 26 | 0] << 16 | a[E + 27 | 0] << 24, o[f + 44 >> 2] = a[E + 28 | 0] | a[E + 29 | 0] << 8 | a[E + 30 | 0] << 16 | a[E + 31 | 0] << 24, o[f + 48 >> 2] = Q, o[f + 52 >> 2] = i, o[f + 56 >> 2] = a[0 | B] | a[B + 1 | 0] << 8 | a[B + 2 | 0] << 16 | a[B + 3 | 0] << 24, o[f + 60 >> 2] = a[B + 4 | 0] | a[B + 5 | 0] << 8 | a[B + 6 | 0] << 16 | a[B + 7 | 0] << 24, p(f, I, A, g, C), iI(f, 64)), w = f - -64 | 0, 0;
                                        },
                                        function(A, I, g, C, B, Q, i) {
                                            var E;
                                            return A |= 0, I |= 0, B |= 0, Q |= 0, i |= 0, w = E = w + -64 | 0, (g |= 0) | (C |= 0) && (o[E + 8 >> 2] = 2036477234, o[E + 12 >> 2] = 1797285236, o[E >> 2] = 1634760805, o[E + 4 >> 2] = 857760878, o[E + 16 >> 2] = a[0 | i] | a[i + 1 | 0] << 8 | a[i + 2 | 0] << 16 | a[i + 3 | 0] << 24, o[E + 20 >> 2] = a[i + 4 | 0] | a[i + 5 | 0] << 8 | a[i + 6 | 0] << 16 | a[i + 7 | 0] << 24, o[E + 24 >> 2] = a[i + 8 | 0] | a[i + 9 | 0] << 8 | a[i + 10 | 0] << 16 | a[i + 11 | 0] << 24, o[E + 28 >> 2] = a[i + 12 | 0] | a[i + 13 | 0] << 8 | a[i + 14 | 0] << 16 | a[i + 15 | 0] << 24, o[E + 32 >> 2] = a[i + 16 | 0] | a[i + 17 | 0] << 8 | a[i + 18 | 0] << 16 | a[i + 19 | 0] << 24, o[E + 36 >> 2] = a[i + 20 | 0] | a[i + 21 | 0] << 8 | a[i + 22 | 0] << 16 | a[i + 23 | 0] << 24, o[E + 40 >> 2] = a[i + 24 | 0] | a[i + 25 | 0] << 8 | a[i + 26 | 0] << 16 | a[i + 27 | 0] << 24, i = a[i + 28 | 0] | a[i + 29 | 0] << 8 | a[i + 30 | 0] << 16 | a[i + 31 | 0] << 24, o[E + 48 >> 2] = Q, o[E + 44 >> 2] = i, o[E + 52 >> 2] = a[0 | B] | a[B + 1 | 0] << 8 | a[B + 2 | 0] << 16 | a[B + 3 | 0] << 24, o[E + 56 >> 2] = a[B + 4 | 0] | a[B + 5 | 0] << 8 | a[B + 6 | 0] << 16 | a[B + 7 | 0] << 24, o[E + 60 >> 2] = a[B + 8 | 0] | a[B + 9 | 0] << 8 | a[B + 10 | 0] << 16 | a[B + 11 | 0] << 24, p(E, I, A, g, C), iI(E, 64)), w = E - -64 | 0, 0;
                                        }
                                    ], yI.grow = function(A) {
                                        var I = this.length;
                                        return this.length = this.length + A, I;
                                    }, yI.set = function(A, I) {
                                        this[A] = I;
                                    }, yI.get = function(A) {
                                        return this[A];
                                    }, yI);
                                    function hI() {
                                        return i.byteLength / 65536 | 0;
                                    }
                                    return {
                                        f: function() {},
                                        g: function(A, I, g, C, B, Q, i, E, o, a, f, c) {
                                            return 0 | hA(A |= 0, I |= 0, g |= 0, C |= 0, (A = 0) | (B |= 0), Q |= 0, i |= 0, A | (E |= 0), o |= 0, f |= 0, c |= 0);
                                        },
                                        h: function(A, I, g, C, B, i, E, a, f, c, e) {
                                            return A |= 0, I |= 0, C |= 0, E |= 0, f |= 0, E |= f = 0, !(B |= 0) & (C |= f) >>> 0 < 4294967280 ? (hA(A, A + C | 0, 0, g |= 0, C, B, i |= 0, E, a |= 0, c |= 0, e |= 0), I && (B = (A = C + 16 | 0) >>> 0 < 16 ? B + 1 | 0 : B, o[I >> 2] = A, o[I + 4 >> 2] = B)) : (zA(), Q()), 0;
                                        },
                                        i: function(A, I, g, C, B, Q, i, E, o, a, f, c) {
                                            return 0 | yA(A |= 0, I |= 0, g |= 0, C |= 0, (A = 0) | (B |= 0), Q |= 0, i |= 0, A | (E |= 0), o |= 0, f |= 0, c |= 0);
                                        },
                                        j: function(A, I, g, C, B, i, E, a, f, c, e) {
                                            return A |= 0, I |= 0, C |= 0, E |= 0, f |= 0, E |= f = 0, !(B |= 0) & (C |= f) >>> 0 < 4294967280 ? (yA(A, A + C | 0, 0, g |= 0, C, B, i |= 0, E, a |= 0, c |= 0, e |= 0), I && (B = (A = C + 16 | 0) >>> 0 < 16 ? B + 1 | 0 : B, o[I >> 2] = A, o[I + 4 >> 2] = B)) : (zA(), Q()), 0;
                                        },
                                        k: function(A, I, g, C, B, Q, i, E, o, a, f) {
                                            return 0 | wA(A |= 0, g |= 0, (A = 0) | (C |= 0), B |= 0, Q |= 0, i |= 0, A | (E |= 0), o |= 0, a |= 0, f |= 0);
                                        },
                                        l: function(A, I, g, C, B, Q, i, E, a, f, c) {
                                            return I |= 0, g |= 0, C |= 0, B |= 0, E |= 0, E |= 0, g = -1, !(Q |= 0) & (B |= 0) >>> 0 >= 16 | Q && (g = wA(A |= 0, C, B - 16 | 0, Q - (B >>> 0 < 16) | 0, (C + B | 0) - 16 | 0, i |= 0, E, a |= 0, f |= 0, c |= 0)), I && (o[I >> 2] = g ? 0 : B - 16 | 0, o[I + 4 >> 2] = g ? 0 : Q - (B >>> 0 < 16) | 0), 0 | g;
                                        },
                                        m: function(A, I, g, C, B, Q, i, E, o, a, f) {
                                            return 0 | tA(A |= 0, g |= 0, (A = 0) | (C |= 0), B |= 0, Q |= 0, i |= 0, A | (E |= 0), o |= 0, a |= 0, f |= 0);
                                        },
                                        n: function(A, I, g, C, B, Q, i, E, a, f, c) {
                                            return I |= 0, g |= 0, C |= 0, B |= 0, E |= 0, E |= 0, g = -1, !(Q |= 0) & (B |= 0) >>> 0 >= 16 | Q && (g = tA(A |= 0, C, B - 16 | 0, Q - (B >>> 0 < 16) | 0, (C + B | 0) - 16 | 0, i |= 0, E, a |= 0, f |= 0, c |= 0)), I && (o[I >> 2] = g ? 0 : B - 16 | 0, o[I + 4 >> 2] = g ? 0 : Q - (B >>> 0 < 16) | 0), 0 | g;
                                        },
                                        o: aI,
                                        p: function() {
                                            return 12;
                                        },
                                        q: tI,
                                        r: oI,
                                        s: cI,
                                        t: QI,
                                        u: aI,
                                        v: DI,
                                        w: tI,
                                        x: oI,
                                        y: cI,
                                        z: QI,
                                        A: function(A, I, g, C, B, Q, i, E, o, a, f, c) {
                                            return 0 | oA(A |= 0, I |= 0, g |= 0, C |= 0, (A = 0) | (B |= 0), Q |= 0, i |= 0, A | (E |= 0), o |= 0, f |= 0, c |= 0);
                                        },
                                        B: function(A, I, g, C, B, i, E, a, f, c, e) {
                                            return A |= 0, I |= 0, C |= 0, E |= 0, f |= 0, E |= f = 0, !(B |= 0) & (C |= f) >>> 0 < 4294967280 ? (oA(A, A + C | 0, 0, g |= 0, C, B, i |= 0, E, a |= 0, c |= 0, e |= 0), I && (B = (A = C + 16 | 0) >>> 0 < 16 ? B + 1 | 0 : B, o[I >> 2] = A, o[I + 4 >> 2] = B)) : (zA(), Q()), 0;
                                        },
                                        C: function(A, I, g, C, B, Q, i, E, o, a, f) {
                                            return 0 | EA(A |= 0, g |= 0, (A = 0) | (C |= 0), B |= 0, Q |= 0, i |= 0, A | (E |= 0), o |= 0, a |= 0, f |= 0);
                                        },
                                        D: function(A, I, g, C, B, Q, i, E, a, f, c) {
                                            return I |= 0, g |= 0, C |= 0, B |= 0, E |= 0, E |= 0, g = -1, !(Q |= 0) & (B |= 0) >>> 0 >= 16 | Q && (g = EA(A |= 0, C, B - 16 | 0, Q - (B >>> 0 < 16) | 0, (C + B | 0) - 16 | 0, i |= 0, E, a |= 0, f |= 0, c |= 0)), I && (o[I >> 2] = g ? 0 : B - 16 | 0, o[I + 4 >> 2] = g ? 0 : Q - (B >>> 0 < 16) | 0), 0 | g;
                                        },
                                        E: aI,
                                        F: fI,
                                        G: tI,
                                        H: oI,
                                        I: cI,
                                        J: QI,
                                        K: aI,
                                        L: aI,
                                        M: function(A, I, g, C, B) {
                                            var Q;
                                            return A |= 0, I |= 0, g |= 0, C |= 0, w = Q = w - 480 | 0, gA(Q, B |= 0, 32), AI(Q, I, g, C), bA(Q, Q + 416 | 0), I = o[Q + 444 >> 2], g = o[Q + 440 >> 2], E[A + 24 | 0] = g, E[A + 25 | 0] = g >>> 8, E[A + 26 | 0] = g >>> 16, E[A + 27 | 0] = g >>> 24, E[A + 28 | 0] = I, E[A + 29 | 0] = I >>> 8, E[A + 30 | 0] = I >>> 16, E[A + 31 | 0] = I >>> 24, I = o[Q + 436 >> 2], g = o[Q + 432 >> 2], E[A + 16 | 0] = g, E[A + 17 | 0] = g >>> 8, E[A + 18 | 0] = g >>> 16, E[A + 19 | 0] = g >>> 24, E[A + 20 | 0] = I, E[A + 21 | 0] = I >>> 8, E[A + 22 | 0] = I >>> 16, E[A + 23 | 0] = I >>> 24, I = o[Q + 428 >> 2], g = o[Q + 424 >> 2], E[A + 8 | 0] = g, E[A + 9 | 0] = g >>> 8, E[A + 10 | 0] = g >>> 16, E[A + 11 | 0] = g >>> 24, E[A + 12 | 0] = I, E[A + 13 | 0] = I >>> 8, E[A + 14 | 0] = I >>> 16, E[A + 15 | 0] = I >>> 24, I = o[Q + 420 >> 2], g = o[Q + 416 >> 2], E[0 | A] = g, E[A + 1 | 0] = g >>> 8, E[A + 2 | 0] = g >>> 16, E[A + 3 | 0] = g >>> 24, E[A + 4 | 0] = I, E[A + 5 | 0] = I >>> 8, E[A + 6 | 0] = I >>> 16, E[A + 7 | 0] = I >>> 24, w = Q + 480 | 0, 0;
                                        },
                                        N: function(A, I, g, C, B) {
                                            var Q, i;
                                            return A |= 0, I |= 0, g |= 0, C |= 0, w = Q = w - 512 | 0, gA(i = Q + 32 | 0, B |= 0, 32), AI(i, I, g, C), bA(i, Q + 448 | 0), I = o[Q + 476 >> 2], o[Q + 24 >> 2] = o[Q + 472 >> 2], o[Q + 28 >> 2] = I, I = o[Q + 468 >> 2], o[Q + 16 >> 2] = o[Q + 464 >> 2], o[Q + 20 >> 2] = I, I = o[Q + 460 >> 2], o[Q + 8 >> 2] = o[Q + 456 >> 2], o[Q + 12 >> 2] = I, I = o[Q + 452 >> 2], o[Q >> 2] = o[Q + 448 >> 2], o[Q + 4 >> 2] = I, I = nA(A, Q), g = eA(Q, A, 32), w = Q + 512 | 0, ((0 | A) == (0 | Q) ? -1 : I) | g;
                                        },
                                        O: QI,
                                        P: aI,
                                        Q: aI,
                                        R: aI,
                                        S: aI,
                                        T: fI,
                                        U: oI,
                                        V: cI,
                                        W: function(A, I, g) {
                                            A |= 0, I |= 0;
                                            var C, B = 0;
                                            return w = C = w + -64 | 0, aA(C, g |= 0, 32, 0), g = o[C + 28 >> 2], B = o[C + 24 >> 2], E[I + 24 | 0] = B, E[I + 25 | 0] = B >>> 8, E[I + 26 | 0] = B >>> 16, E[I + 27 | 0] = B >>> 24, E[I + 28 | 0] = g, E[I + 29 | 0] = g >>> 8, E[I + 30 | 0] = g >>> 16, E[I + 31 | 0] = g >>> 24, g = o[C + 20 >> 2], B = o[C + 16 >> 2], E[I + 16 | 0] = B, E[I + 17 | 0] = B >>> 8, E[I + 18 | 0] = B >>> 16, E[I + 19 | 0] = B >>> 24, E[I + 20 | 0] = g, E[I + 21 | 0] = g >>> 8, E[I + 22 | 0] = g >>> 16, E[I + 23 | 0] = g >>> 24, g = o[C + 12 >> 2], B = o[C + 8 >> 2], E[I + 8 | 0] = B, E[I + 9 | 0] = B >>> 8, E[I + 10 | 0] = B >>> 16, E[I + 11 | 0] = B >>> 24, E[I + 12 | 0] = g, E[I + 13 | 0] = g >>> 8, E[I + 14 | 0] = g >>> 16, E[I + 15 | 0] = g >>> 24, g = o[C + 4 >> 2], B = o[C >> 2], E[0 | I] = B, E[I + 1 | 0] = B >>> 8, E[I + 2 | 0] = B >>> 16, E[I + 3 | 0] = B >>> 24, E[I + 4 | 0] = g, E[I + 5 | 0] = g >>> 8, E[I + 6 | 0] = g >>> 16, E[I + 7 | 0] = g >>> 24, iI(C, 64), A = II(A, I), w = C - -64 | 0, 0 | A;
                                        },
                                        X: XA,
                                        Y: UA,
                                        Z: PA,
                                        _: function(A, I, g, C, B, Q, i, E) {
                                            A |= 0, I |= 0, g |= 0, Q |= 0;
                                            var o, a = 0;
                                            return a = C |= 0, C = B |= 0, o = 0 | a, w = a = w - 32 | 0, B = -1, UA(a, i |= 0, E |= 0) || (B = iA(A, I, g, o, C, Q, a), iI(a, 32)), w = a + 32 | 0, 0 | B;
                                        },
                                        $: function(A, I, g, C, B, i) {
                                            return A |= 0, I |= 0, B |= 0, i |= 0, !(C |= 0) & (g |= 0) >>> 0 >= 4294967280 | C && (zA(), Q()), 0 | iA(A + 16 | 0, A, I, g, C, B, i);
                                        },
                                        aa: function(A, I, g, C, B, Q, i) {
                                            return 0 | NA(A |= 0, I |= 0, g |= 0, C |= 0, B |= 0, Q |= 0, i |= 0);
                                        },
                                        ba: vA,
                                        ca: function(A, I, g, C, B, Q, i, E) {
                                            A |= 0, I |= 0, g |= 0, Q |= 0;
                                            var o, a = 0;
                                            return a = C |= 0, C = B |= 0, o = 0 | a, w = a = w - 32 | 0, B = -1, UA(a, i |= 0, E |= 0) || (B = QA(A, I, g, o, C, Q, a), iI(a, 32)), w = a + 32 | 0, 0 | B;
                                        },
                                        da: JA,
                                        ea: function(A, I, g, C, B, Q, i) {
                                            return 0 | GA(A |= 0, I |= 0, g |= 0, C |= 0, B |= 0, Q |= 0, i |= 0);
                                        },
                                        fa: function(A, I, g, C, B) {
                                            A |= 0, I |= 0, B |= 0;
                                            var Q, i, a, f, c = 0, e = 0;
                                            return c = g |= 0, g = C |= 0, f = 0 | c, c = C = w, w = Q = C - 512 & -64, C = -1, XA(i = Q - -64 | 0, a = Q + 32 | 0) || (K(C = Q + 128 | 0, 0, 0, 24), Z(C, i, 32, 0), Z(C, B, 32, 0), KA(C, e = Q + 96 | 0, 24), C = NA(A + 32 | 0, I, f, g, e, B, a), I = o[Q + 92 >> 2], g = o[Q + 88 >> 2], E[A + 24 | 0] = g, E[A + 25 | 0] = g >>> 8, E[A + 26 | 0] = g >>> 16, E[A + 27 | 0] = g >>> 24, E[A + 28 | 0] = I, E[A + 29 | 0] = I >>> 8, E[A + 30 | 0] = I >>> 16, E[A + 31 | 0] = I >>> 24, I = o[Q + 84 >> 2], g = o[Q + 80 >> 2], E[A + 16 | 0] = g, E[A + 17 | 0] = g >>> 8, E[A + 18 | 0] = g >>> 16, E[A + 19 | 0] = g >>> 24, E[A + 20 | 0] = I, E[A + 21 | 0] = I >>> 8, E[A + 22 | 0] = I >>> 16, E[A + 23 | 0] = I >>> 24, I = o[Q + 76 >> 2], g = o[Q + 72 >> 2], E[A + 8 | 0] = g, E[A + 9 | 0] = g >>> 8, E[A + 10 | 0] = g >>> 16, E[A + 11 | 0] = g >>> 24, E[A + 12 | 0] = I, E[A + 13 | 0] = I >>> 8, E[A + 14 | 0] = I >>> 16, E[A + 15 | 0] = I >>> 24, I = o[Q + 68 >> 2], g = o[Q + 64 >> 2], E[0 | A] = g, E[A + 1 | 0] = g >>> 8, E[A + 2 | 0] = g >>> 16, E[A + 3 | 0] = g >>> 24, E[A + 4 | 0] = I, E[A + 5 | 0] = I >>> 8, E[A + 6 | 0] = I >>> 16, E[A + 7 | 0] = I >>> 24, iI(a, 32), iI(i, 32), iI(e, 24)), w = c, 0 | C;
                                        },
                                        ga: function(A, I, g, C, B, Q) {
                                            A |= 0, I |= 0, B |= 0, Q |= 0;
                                            var i, E, o = 0;
                                            return E = o = w, w = i = o - 448 & -64, o = -1, !(C |= 0) & (g |= 0) >>> 0 >= 48 | C && (K(o = i - -64 | 0, 0, 0, 24), Z(o, I, 32, 0), Z(o, B, 32, 0), KA(o, B = i + 32 | 0, 24), o = GA(A, I + 32 | 0, g - 32 | 0, C - (g >>> 0 < 32) | 0, B, I, Q)), w = E, 0 | o;
                                        },
                                        ha: function() {
                                            return 48;
                                        },
                                        ia: oI,
                                        ja: eI,
                                        ka: aI,
                                        la: oI,
                                        ma: eI,
                                        na: aI,
                                        oa: function() {
                                            return 384;
                                        },
                                        pa: function(A, I, g, C, B, Q, i) {
                                            return 0 | X(A |= 0, I |= 0, g |= 0, C |= 0, B |= 0, Q |= 0, i |= 0);
                                        },
                                        qa: K,
                                        ra: function(A, I, g, C) {
                                            return 0 | Z(A |= 0, I |= 0, g |= 0, C |= 0);
                                        },
                                        sa: KA,
                                        ta: QI,
                                        ua: eI,
                                        va: function(A, I, g, C) {
                                            return 0 | aA(A |= 0, I |= 0, g |= 0, C |= 0);
                                        },
                                        wa: oI,
                                        xa: eI,
                                        ya: DI,
                                        za: aI,
                                        Aa: function(A, I, g, C, B, i) {
                                            A |= 0, I |= 0, g |= 0, C |= 0, i |= 0;
                                            var E, f = 0, c = 0, e = 0, r = 0, D = 0, t = 0, y = 0;
                                            return w = E = w - 32 | 0, f = a[0 | (B |= 0)] | a[B + 1 | 0] << 8 | a[B + 2 | 0] << 16 | a[B + 3 | 0] << 24, B = a[B + 4 | 0] | a[B + 5 | 0] << 8 | a[B + 6 | 0] << 16 | a[B + 7 | 0] << 24, o[E + 24 >> 2] = 0, o[E + 28 >> 2] = 0, o[E + 16 >> 2] = f, o[E + 20 >> 2] = B, o[E + 8 >> 2] = 0, o[E + 12 >> 2] = 0, o[(B = E) >> 2] = g, o[B + 4 >> 2] = C, I - 65 >>> 0 <= 4294967246 ? (o[9005] = 28, A = -1) : I - 65 >>> 0 < 4294967232 ? A = -1 : (w = B = (e = w) - 512 & -64, !i | !A | ((c = 255 & I) - 65 & 255) >>> 0 <= 191 ? (zA(), Q()) : (C = E + 16 | 0, E ? (r = 725511199 ^ (a[E + 8 | 0] | a[E + 9 | 0] << 8 | a[E + 10 | 0] << 16 | a[E + 11 | 0] << 24), D = -1694144372 ^ (a[E + 12 | 0] | a[E + 13 | 0] << 8 | a[E + 14 | 0] << 16 | a[E + 15 | 0] << 24), g = -1377402159 ^ (a[0 | E] | a[E + 1 | 0] << 8 | a[E + 2 | 0] << 16 | a[E + 3 | 0] << 24), I = 1359893119 ^ (a[E + 4 | 0] | a[E + 5 | 0] << 8 | a[E + 6 | 0] << 16 | a[E + 7 | 0] << 24)) : (r = 725511199, D = -1694144372, g = -1377402159, I = 1359893119), C ? (t = 327033209 ^ (a[C + 8 | 0] | a[C + 9 | 0] << 8 | a[C + 10 | 0] << 16 | a[C + 11 | 0] << 24), y = 1541459225 ^ (a[C + 12 | 0] | a[C + 13 | 0] << 8 | a[C + 14 | 0] << 16 | a[C + 15 | 0] << 24), f = -79577749 ^ (a[0 | C] | a[C + 1 | 0] << 8 | a[C + 2 | 0] << 16 | a[C + 3 | 0] << 24), C = 528734635 ^ (a[C + 4 | 0] | a[C + 5 | 0] << 8 | a[C + 6 | 0] << 16 | a[C + 7 | 0] << 24)) : (t = 327033209, y = 1541459225, f = -79577749, C = 528734635), dA(B - -64 | 0, 0, 293), o[B + 56 >> 2] = t, o[B + 60 >> 2] = y, o[B + 48 >> 2] = f, o[B + 52 >> 2] = C, o[B + 40 >> 2] = r, o[B + 44 >> 2] = D, o[B + 32 >> 2] = g, o[B + 36 >> 2] = I, o[B + 24 >> 2] = 1595750129, o[B + 28 >> 2] = -1521486534, o[B + 16 >> 2] = -23791573, o[B + 20 >> 2] = 1013904242, o[B + 8 >> 2] = -2067093701, o[B + 12 >> 2] = -1150833019, o[B >> 2] = -222443256 ^ (8192 | c), o[B + 4 >> 2] = 1779033703, dA(32 + (I = B + 384 | 0) | 0, 0, 96), YA(I, i, 32), YA(B + 96 | 0, I, 128), o[B + 352 >> 2] = 128, iI(I, 128), J(B, A, c), w = e), A = 0), w = E + 32 | 0, 0 | A;
                                        },
                                        Ba: QI,
                                        Ca: function(A, I, g) {
                                            return 0 | q(A |= 0, I |= 0, g |= 0);
                                        },
                                        Da: function(A, I, g) {
                                            return 0 | gI(A |= 0, I |= 0, g |= 0);
                                        },
                                        Ea: function(A, I) {
                                            return LA(A |= 0, I |= 0), iI(A, 4), 0;
                                        },
                                        Fa: function(A, I, g, C, B) {
                                            var Q;
                                            return A |= 0, C |= 0, B |= 0, w = Q = w - 208 | 0, q(Q, I |= 0, g |= 0), gI(Q, C, B), LA(Q, A), iI(Q, 4), w = Q + 208 | 0, 0;
                                        },
                                        Ga: QI,
                                        Ha: function(A, I, g, C, B) {
                                            A |= 0, I |= 0, g |= 0, C |= 0, B |= 0;
                                            var Q, i = 0, f = 0, c = 0;
                                            if (w = Q = w - 256 | 0, E[Q + 15 | 0] = 1, I >>> 0 <= 8160) {
                                                if (I >>> 0 >= 32) for(i = 32; c = i, q(i = Q + 48 | 0, B, 32), f && gI(i, (A + f | 0) - 32 | 0, 32), gI(i = Q + 48 | 0, g, C), gI(i, Q + 15 | 0, 1), LA(i, A + f | 0), E[Q + 15 | 0] = a[Q + 15 | 0] + 1, (i = (f = c) + 32 | 0) >>> 0 <= I >>> 0;);
                                                (f = 31 & I) && (q(I = Q + 48 | 0, B, 32), c && gI(I, (A + c | 0) - 32 | 0, 32), gI(I = Q + 48 | 0, g, C), gI(I, Q + 15 | 0, 1), LA(g = I, I = Q + 16 | 0), YA(A + c | 0, I, f), iI(I, 32)), iI(Q + 48 | 0, 208), A = 0;
                                            } else o[9005] = 28, A = -1;
                                            return w = Q + 256 | 0, 0 | A;
                                        },
                                        Ia: aI,
                                        Ja: tI,
                                        Ka: function() {
                                            return 8160;
                                        },
                                        La: EI,
                                        Ma: function(A, I, g) {
                                            return 0 | gA(A |= 0, I |= 0, g |= 0);
                                        },
                                        Na: function(A, I, g) {
                                            return 0 | AI(A |= 0, I |= 0, g |= 0, 0);
                                        },
                                        Oa: function(A, I) {
                                            return bA(A |= 0, I |= 0), iI(A, 4), 0;
                                        },
                                        Pa: function(A, I, g, C, B) {
                                            var Q;
                                            return A |= 0, C |= 0, B |= 0, w = Q = w - 416 | 0, gA(Q, I |= 0, g |= 0), AI(Q, C, B, 0), bA(Q, A), iI(Q, 4), w = Q + 416 | 0, 0;
                                        },
                                        Qa: function(A) {
                                            HA(A |= 0, 64);
                                        },
                                        Ra: function(A, I, g, C, B) {
                                            A |= 0, I |= 0, g |= 0, C |= 0, B |= 0;
                                            var Q, i = 0, f = 0, c = 0;
                                            if (w = Q = w - 496 | 0, E[Q + 15 | 0] = 1, I >>> 0 <= 16320) {
                                                if (I >>> 0 >= 64) for(i = 64; c = i, gA(i = Q + 80 | 0, B, 64), f && AI(i, (A + f | 0) - 64 | 0, 64, 0), AI(i = Q + 80 | 0, g, C, 0), AI(i, Q + 15 | 0, 1, 0), bA(i, A + f | 0), E[Q + 15 | 0] = a[Q + 15 | 0] + 1, (i = (f = c) - -64 | 0) >>> 0 <= I >>> 0;);
                                                (f = 63 & I) && (gA(I = Q + 80 | 0, B, 64), c && AI(I, (A + c | 0) - 64 | 0, 64, 0), AI(I = Q + 80 | 0, g, C, 0), AI(I, Q + 15 | 0, 1, 0), bA(g = I, I = Q + 16 | 0), YA(A + c | 0, I, f), iI(I, 64)), iI(Q + 80 | 0, 416), A = 0;
                                            } else o[9005] = 28, A = -1;
                                            return w = Q + 496 | 0, 0 | A;
                                        },
                                        Sa: eI,
                                        Ta: tI,
                                        Ua: function() {
                                            return 16320;
                                        },
                                        Va: function(A, I, g) {
                                            return A |= 0, X(I |= 0, 32, g |= 0, 32, 0, 0, 0), 0 | VA(A, I);
                                        },
                                        Wa: function(A, I) {
                                            return A |= 0, HA(I |= 0, 32), 0 | VA(A, I);
                                        },
                                        Xa: function(A, I, g, C, B) {
                                            I |= 0, g |= 0, C |= 0, B |= 0;
                                            var i, o, f = 0, c = 0, e = 0;
                                            if (o = f = w, w = f = f - 512 & -64, i = (A |= 0) || I) {
                                                if (e = -1, !lA(c = f + 96 | 0, C, B)) {
                                                    for(C = I || A, A = 0, K(I = f + 128 | 0, 0, 0, 64), Z(I, c, 32, 0), iI(c, 32), Z(I, g, 32, 0), Z(I, B, 32, 0), KA(I, f + 32 | 0, 64), iI(I, 384); g = (I = f + 32 | 0) + A | 0, E[A + i | 0] = a[0 | g], E[A + C | 0] = a[g + 32 | 0], E[(B = 1 | A) + i | 0] = a[I + B | 0], E[C + B | 0] = a[g + 33 | 0], 32 != (0 | (A = A + 2 | 0)););
                                                    iI(I, 64), e = 0;
                                                }
                                                return w = o, 0 | e;
                                            }
                                            zA(), Q();
                                        },
                                        Ya: function(A, I, g, C, B) {
                                            I |= 0, g |= 0, C |= 0, B |= 0;
                                            var i, o, f = 0, c = 0, e = 0;
                                            if (o = f = w, w = f = f - 512 & -64, i = (A |= 0) || I) {
                                                if (e = -1, !lA(c = f + 96 | 0, C, B)) {
                                                    for(C = I || A, A = 0, K(I = f + 128 | 0, 0, 0, 64), Z(I, c, 32, 0), iI(c, 32), Z(I, B, 32, 0), Z(I, g, 32, 0), KA(I, f + 32 | 0, 64), iI(I, 384); g = (I = f + 32 | 0) + A | 0, E[A + C | 0] = a[0 | g], E[A + i | 0] = a[g + 32 | 0], E[(B = 1 | A) + C | 0] = a[I + B | 0], E[B + i | 0] = a[g + 33 | 0], 32 != (0 | (A = A + 2 | 0)););
                                                    iI(I, 64), e = 0;
                                                }
                                                return w = o, 0 | e;
                                            }
                                            zA(), Q();
                                        },
                                        Za: aI,
                                        _a: aI,
                                        $a: aI,
                                        ab: aI,
                                        bb: VA,
                                        cb: lA,
                                        db: aI,
                                        eb: aI,
                                        fb: aI,
                                        gb: fI,
                                        hb: oI,
                                        ib: cI,
                                        jb: QI,
                                        kb: PA,
                                        lb: function(A, I, g, C, B, i) {
                                            return A |= 0, I |= 0, B |= 0, i |= 0, !(C |= 0) & (g |= 0) >>> 0 >= 4294967280 | C && (zA(), Q()), iA(A + 16 | 0, A, I, g, C, B, i), 0;
                                        },
                                        mb: vA,
                                        nb: JA,
                                        ob: QI,
                                        pb: function(A, I, g) {
                                            return A |= 0, g |= 0, HA(I |= 0, 24), x(A, I, g), E[A + 32 | 0] = 1, E[A + 33 | 0] = 0, E[A + 34 | 0] = 0, E[A + 35 | 0] = 0, g = a[I + 16 | 0] | a[I + 17 | 0] << 8 | a[I + 18 | 0] << 16 | a[I + 19 | 0] << 24, I = a[I + 20 | 0] | a[I + 21 | 0] << 8 | a[I + 22 | 0] << 16 | a[I + 23 | 0] << 24, E[A + 44 | 0] = 0, E[A + 45 | 0] = 0, E[A + 46 | 0] = 0, E[A + 47 | 0] = 0, E[A + 48 | 0] = 0, E[A + 49 | 0] = 0, E[A + 50 | 0] = 0, E[A + 51 | 0] = 0, E[A + 36 | 0] = g, E[A + 37 | 0] = g >>> 8, E[A + 38 | 0] = g >>> 16, E[A + 39 | 0] = g >>> 24, E[A + 40 | 0] = I, E[A + 41 | 0] = I >>> 8, E[A + 42 | 0] = I >>> 16, E[A + 43 | 0] = I >>> 24, 0;
                                        },
                                        qb: function(A, I, g) {
                                            return x(A |= 0, I |= 0, g |= 0), E[A + 32 | 0] = 1, E[A + 33 | 0] = 0, E[A + 34 | 0] = 0, E[A + 35 | 0] = 0, g = a[I + 16 | 0] | a[I + 17 | 0] << 8 | a[I + 18 | 0] << 16 | a[I + 19 | 0] << 24, I = a[I + 20 | 0] | a[I + 21 | 0] << 8 | a[I + 22 | 0] << 16 | a[I + 23 | 0] << 24, E[A + 44 | 0] = 0, E[A + 45 | 0] = 0, E[A + 46 | 0] = 0, E[A + 47 | 0] = 0, E[A + 48 | 0] = 0, E[A + 49 | 0] = 0, E[A + 50 | 0] = 0, E[A + 51 | 0] = 0, E[A + 36 | 0] = g, E[A + 37 | 0] = g >>> 8, E[A + 38 | 0] = g >>> 16, E[A + 39 | 0] = g >>> 24, E[A + 40 | 0] = I, E[A + 41 | 0] = I >>> 8, E[A + 42 | 0] = I >>> 16, E[A + 43 | 0] = I >>> 24, 0;
                                        },
                                        rb: function(A) {
                                            var I, g = 0, C = 0;
                                            w = I = w - 48 | 0, g = a[28 + (A |= 0) | 0] | a[A + 29 | 0] << 8 | a[A + 30 | 0] << 16 | a[A + 31 | 0] << 24, o[I + 24 >> 2] = a[A + 24 | 0] | a[A + 25 | 0] << 8 | a[A + 26 | 0] << 16 | a[A + 27 | 0] << 24, o[I + 28 >> 2] = g, g = a[A + 20 | 0] | a[A + 21 | 0] << 8 | a[A + 22 | 0] << 16 | a[A + 23 | 0] << 24, o[I + 16 >> 2] = a[A + 16 | 0] | a[A + 17 | 0] << 8 | a[A + 18 | 0] << 16 | a[A + 19 | 0] << 24, o[I + 20 >> 2] = g, g = a[A + 4 | 0] | a[A + 5 | 0] << 8 | a[A + 6 | 0] << 16 | a[A + 7 | 0] << 24, o[I >> 2] = a[0 | A] | a[A + 1 | 0] << 8 | a[A + 2 | 0] << 16 | a[A + 3 | 0] << 24, o[I + 4 >> 2] = g, g = a[A + 12 | 0] | a[A + 13 | 0] << 8 | a[A + 14 | 0] << 16 | a[A + 15 | 0] << 24, o[I + 8 >> 2] = a[A + 8 | 0] | a[A + 9 | 0] << 8 | a[A + 10 | 0] << 16 | a[A + 11 | 0] << 24, o[I + 12 >> 2] = g, g = a[A + 40 | 0] | a[A + 41 | 0] << 8 | a[A + 42 | 0] << 16 | a[A + 43 | 0] << 24, o[I + 32 >> 2] = a[A + 36 | 0] | a[A + 37 | 0] << 8 | a[A + 38 | 0] << 16 | a[A + 39 | 0] << 24, o[I + 36 >> 2] = g, OA(I, I, A + 32 | 0, A), g = o[I + 28 >> 2], C = o[I + 24 >> 2], E[A + 24 | 0] = C, E[A + 25 | 0] = C >>> 8, E[A + 26 | 0] = C >>> 16, E[A + 27 | 0] = C >>> 24, E[A + 28 | 0] = g, E[A + 29 | 0] = g >>> 8, E[A + 30 | 0] = g >>> 16, E[A + 31 | 0] = g >>> 24, g = o[I + 20 >> 2], C = o[I + 16 >> 2], E[A + 16 | 0] = C, E[A + 17 | 0] = C >>> 8, E[A + 18 | 0] = C >>> 16, E[A + 19 | 0] = C >>> 24, E[A + 20 | 0] = g, E[A + 21 | 0] = g >>> 8, E[A + 22 | 0] = g >>> 16, E[A + 23 | 0] = g >>> 24, g = o[I + 12 >> 2], C = o[I + 8 >> 2], E[A + 8 | 0] = C, E[A + 9 | 0] = C >>> 8, E[A + 10 | 0] = C >>> 16, E[A + 11 | 0] = C >>> 24, E[A + 12 | 0] = g, E[A + 13 | 0] = g >>> 8, E[A + 14 | 0] = g >>> 16, E[A + 15 | 0] = g >>> 24, g = o[I + 4 >> 2], C = o[I >> 2], E[0 | A] = C, E[A + 1 | 0] = C >>> 8, E[A + 2 | 0] = C >>> 16, E[A + 3 | 0] = C >>> 24, E[A + 4 | 0] = g, E[A + 5 | 0] = g >>> 8, E[A + 6 | 0] = g >>> 16, E[A + 7 | 0] = g >>> 24, C = o[I + 36 >> 2], g = o[I + 32 >> 2], E[A + 32 | 0] = 1, E[A + 33 | 0] = 0, E[A + 34 | 0] = 0, E[A + 35 | 0] = 0, E[A + 36 | 0] = g, E[A + 37 | 0] = g >>> 8, E[A + 38 | 0] = g >>> 16, E[A + 39 | 0] = g >>> 24, E[A + 40 | 0] = C, E[A + 41 | 0] = C >>> 8, E[A + 42 | 0] = C >>> 16, E[A + 43 | 0] = C >>> 24, w = I + 48 | 0;
                                        },
                                        sb: function(A, I, g, C, B, i, f, c, e, r) {
                                            A |= 0, I |= 0, C |= 0, i |= 0, f |= 0, e |= 0, r |= 0;
                                            var D, t = 0, y = 0, h = 0;
                                            return t = B |= 0, t |= B = 0, D = B | (c |= 0), w = B = w - 384 | 0, (g |= 0) && (o[g >> 2] = 0, o[g + 4 >> 2] = 0), !i & t >>> 0 < 4294967279 ? (ZA(y = B + 16 | 0, 64, h = A + 32 | 0, A), CI(c = B + 80 | 0, y), iI(y, 64), $A(c, f, D, e), $A(c, 34288, 0 - D & 15, 0), o[B + 72 >> 2] = 0, o[B + 76 >> 2] = 0, o[(f = B - -64 | 0) >> 2] = 0, o[f + 4 >> 2] = 0, o[B + 56 >> 2] = 0, o[B + 60 >> 2] = 0, o[B + 48 >> 2] = 0, o[B + 52 >> 2] = 0, o[B + 40 >> 2] = 0, o[B + 44 >> 2] = 0, o[B + 32 >> 2] = 0, o[B + 36 >> 2] = 0, o[B + 16 >> 2] = 0, o[B + 20 >> 2] = 0, o[B + 24 >> 2] = 0, o[B + 28 >> 2] = 0, E[B + 16 | 0] = r, FA(y, y, 64, 0, h, 1, A), $A(c, y, 64, 0), E[0 | I] = a[B + 16 | 0], FA(I = I + 1 | 0, C, t, i, h, 2, A), $A(c, I, t, i), $A(c, 34288, 15 & t, 0), o[B + 8 >> 2] = D, o[B + 12 >> 2] = e, $A(c, C = B + 8 | 0, 8, 0), o[B + 8 >> 2] = t - -64, o[B + 12 >> 2] = i - ((t >>> 0 < 4294967232) - 1 | 0), $A(c, C, 8, 0), BI(c, I = I + t | 0), iI(c, 256), E[A + 36 | 0] = a[A + 36 | 0] ^ a[0 | I], E[A + 37 | 0] = a[A + 37 | 0] ^ a[I + 1 | 0], E[A + 38 | 0] = a[A + 38 | 0] ^ a[I + 2 | 0], E[A + 39 | 0] = a[A + 39 | 0] ^ a[I + 3 | 0], E[A + 40 | 0] = a[A + 40 | 0] ^ a[I + 4 | 0], E[A + 41 | 0] = a[A + 41 | 0] ^ a[I + 5 | 0], E[A + 42 | 0] = a[A + 42 | 0] ^ a[I + 6 | 0], E[A + 43 | 0] = a[A + 43 | 0] ^ a[I + 7 | 0], sA(h), (2 & r || fA(h, 4)) && (I = a[A + 28 | 0] | a[A + 29 | 0] << 8 | a[A + 30 | 0] << 16 | a[A + 31 | 0] << 24, o[B + 360 >> 2] = a[A + 24 | 0] | a[A + 25 | 0] << 8 | a[A + 26 | 0] << 16 | a[A + 27 | 0] << 24, o[B + 364 >> 2] = I, I = a[A + 20 | 0] | a[A + 21 | 0] << 8 | a[A + 22 | 0] << 16 | a[A + 23 | 0] << 24, o[B + 352 >> 2] = a[A + 16 | 0] | a[A + 17 | 0] << 8 | a[A + 18 | 0] << 16 | a[A + 19 | 0] << 24, o[B + 356 >> 2] = I, I = a[A + 4 | 0] | a[A + 5 | 0] << 8 | a[A + 6 | 0] << 16 | a[A + 7 | 0] << 24, o[B + 336 >> 2] = a[0 | A] | a[A + 1 | 0] << 8 | a[A + 2 | 0] << 16 | a[A + 3 | 0] << 24, o[B + 340 >> 2] = I, I = a[A + 12 | 0] | a[A + 13 | 0] << 8 | a[A + 14 | 0] << 16 | a[A + 15 | 0] << 24, o[B + 344 >> 2] = a[A + 8 | 0] | a[A + 9 | 0] << 8 | a[A + 10 | 0] << 16 | a[A + 11 | 0] << 24, o[B + 348 >> 2] = I, I = a[A + 40 | 0] | a[A + 41 | 0] << 8 | a[A + 42 | 0] << 16 | a[A + 43 | 0] << 24, o[B + 368 >> 2] = a[A + 36 | 0] | a[A + 37 | 0] << 8 | a[A + 38 | 0] << 16 | a[A + 39 | 0] << 24, o[B + 372 >> 2] = I, OA(I = B + 336 | 0, I, h, A), I = o[B + 364 >> 2], C = o[B + 360 >> 2], E[A + 24 | 0] = C, E[A + 25 | 0] = C >>> 8, E[A + 26 | 0] = C >>> 16, E[A + 27 | 0] = C >>> 24, E[A + 28 | 0] = I, E[A + 29 | 0] = I >>> 8, E[A + 30 | 0] = I >>> 16, E[A + 31 | 0] = I >>> 24, I = o[B + 356 >> 2], C = o[B + 352 >> 2], E[A + 16 | 0] = C, E[A + 17 | 0] = C >>> 8, E[A + 18 | 0] = C >>> 16, E[A + 19 | 0] = C >>> 24, E[A + 20 | 0] = I, E[A + 21 | 0] = I >>> 8, E[A + 22 | 0] = I >>> 16, E[A + 23 | 0] = I >>> 24, I = o[B + 348 >> 2], C = o[B + 344 >> 2], E[A + 8 | 0] = C, E[A + 9 | 0] = C >>> 8, E[A + 10 | 0] = C >>> 16, E[A + 11 | 0] = C >>> 24, E[A + 12 | 0] = I, E[A + 13 | 0] = I >>> 8, E[A + 14 | 0] = I >>> 16, E[A + 15 | 0] = I >>> 24, I = o[B + 340 >> 2], C = o[B + 336 >> 2], E[0 | A] = C, E[A + 1 | 0] = C >>> 8, E[A + 2 | 0] = C >>> 16, E[A + 3 | 0] = C >>> 24, E[A + 4 | 0] = I, E[A + 5 | 0] = I >>> 8, E[A + 6 | 0] = I >>> 16, E[A + 7 | 0] = I >>> 24, I = o[B + 368 >> 2], C = o[B + 372 >> 2], E[A + 32 | 0] = 1, E[A + 33 | 0] = 0, E[A + 34 | 0] = 0, E[A + 35 | 0] = 0, E[A + 36 | 0] = I, E[A + 37 | 0] = I >>> 8, E[A + 38 | 0] = I >>> 16, E[A + 39 | 0] = I >>> 24, E[A + 40 | 0] = C, E[A + 41 | 0] = C >>> 8, E[A + 42 | 0] = C >>> 16, E[A + 43 | 0] = C >>> 24), g && (i = (A = t + 17 | 0) >>> 0 < 17 ? i + 1 | 0 : i, o[g >> 2] = A, o[g + 4 >> 2] = i), w = B + 384 | 0) : (zA(), Q()), 0;
                                        },
                                        tb: function(A, I, g, C, B, i, f, c, e, r) {
                                            A |= 0, I |= 0, C |= 0, B |= 0, c |= 0, r |= 0;
                                            var D, t = 0, y = 0, h = 0, n = 0, s = 0, k = 0;
                                            t = i |= 0, i = f |= 0, y = 0 | t, D = e |= 0, w = f = w - 400 | 0, (g |= 0) && (o[g >> 2] = 0, o[g + 4 >> 2] = 0), C && (E[0 | C] = 255), k = -1;
                                            A: {
                                                I: {
                                                    if (!((e = y >>> 0 < 17) & !i)) {
                                                        if (s = t = i - e | 0, !t & (e = y - 17 | 0) >>> 0 >= 4294967279 | t) break I;
                                                        ZA(h = f + 32 | 0, 64, n = A + 32 | 0, A), CI(t = f + 96 | 0, h), iI(h, 64), $A(t, c, D, r), $A(t, 34288, 0 - D & 15, 0), o[f + 88 >> 2] = 0, o[f + 92 >> 2] = 0, o[f + 80 >> 2] = 0, o[f + 84 >> 2] = 0, o[f + 72 >> 2] = 0, o[f + 76 >> 2] = 0, o[(c = f - -64 | 0) >> 2] = 0, o[c + 4 >> 2] = 0, o[f + 56 >> 2] = 0, o[f + 60 >> 2] = 0, o[f + 48 >> 2] = 0, o[f + 52 >> 2] = 0, o[f + 40 >> 2] = 0, o[f + 44 >> 2] = 0, o[f + 32 >> 2] = 0, o[f + 36 >> 2] = 0, E[f + 32 | 0] = a[0 | B], FA(h, h, 64, 0, n, 1, A), c = a[f + 32 | 0], E[f + 32 | 0] = a[0 | B], $A(t, h, 64, 0), $A(t, B = B + 1 | 0, e, s), $A(t, 34288, y - 1 & 15, 0), o[f + 24 >> 2] = D, o[f + 28 >> 2] = r, $A(t, r = f + 24 | 0, 8, 0), i = (y = y + 47 | 0) >>> 0 < 47 ? i + 1 | 0 : i, o[f + 24 >> 2] = y, o[f + 28 >> 2] = i, $A(t, r, 8, 0), BI(t, f), iI(t, 256), eA(f, B + e | 0, 16) ? iI(f, 16) : (FA(I, B, e, s, n, 2, A), E[A + 36 | 0] = a[A + 36 | 0] ^ a[0 | f], E[A + 37 | 0] = a[A + 37 | 0] ^ a[f + 1 | 0], E[A + 38 | 0] = a[A + 38 | 0] ^ a[f + 2 | 0], E[A + 39 | 0] = a[A + 39 | 0] ^ a[f + 3 | 0], E[A + 40 | 0] = a[A + 40 | 0] ^ a[f + 4 | 0], E[A + 41 | 0] = a[A + 41 | 0] ^ a[f + 5 | 0], E[A + 42 | 0] = a[A + 42 | 0] ^ a[f + 6 | 0], E[A + 43 | 0] = a[A + 43 | 0] ^ a[f + 7 | 0], sA(n), (2 & c || fA(n, 4)) && (I = a[A + 28 | 0] | a[A + 29 | 0] << 8 | a[A + 30 | 0] << 16 | a[A + 31 | 0] << 24, o[f + 376 >> 2] = a[A + 24 | 0] | a[A + 25 | 0] << 8 | a[A + 26 | 0] << 16 | a[A + 27 | 0] << 24, o[f + 380 >> 2] = I, I = a[A + 20 | 0] | a[A + 21 | 0] << 8 | a[A + 22 | 0] << 16 | a[A + 23 | 0] << 24, o[f + 368 >> 2] = a[A + 16 | 0] | a[A + 17 | 0] << 8 | a[A + 18 | 0] << 16 | a[A + 19 | 0] << 24, o[f + 372 >> 2] = I, I = a[A + 4 | 0] | a[A + 5 | 0] << 8 | a[A + 6 | 0] << 16 | a[A + 7 | 0] << 24, o[f + 352 >> 2] = a[0 | A] | a[A + 1 | 0] << 8 | a[A + 2 | 0] << 16 | a[A + 3 | 0] << 24, o[f + 356 >> 2] = I, I = a[A + 12 | 0] | a[A + 13 | 0] << 8 | a[A + 14 | 0] << 16 | a[A + 15 | 0] << 24, o[f + 360 >> 2] = a[A + 8 | 0] | a[A + 9 | 0] << 8 | a[A + 10 | 0] << 16 | a[A + 11 | 0] << 24, o[f + 364 >> 2] = I, I = a[A + 40 | 0] | a[A + 41 | 0] << 8 | a[A + 42 | 0] << 16 | a[A + 43 | 0] << 24, o[f + 384 >> 2] = a[A + 36 | 0] | a[A + 37 | 0] << 8 | a[A + 38 | 0] << 16 | a[A + 39 | 0] << 24, o[f + 388 >> 2] = I, OA(I = f + 352 | 0, I, n, A), I = o[f + 380 >> 2], B = o[f + 376 >> 2], E[A + 24 | 0] = B, E[A + 25 | 0] = B >>> 8, E[A + 26 | 0] = B >>> 16, E[A + 27 | 0] = B >>> 24, E[A + 28 | 0] = I, E[A + 29 | 0] = I >>> 8, E[A + 30 | 0] = I >>> 16, E[A + 31 | 0] = I >>> 24, I = o[f + 372 >> 2], B = o[f + 368 >> 2], E[A + 16 | 0] = B, E[A + 17 | 0] = B >>> 8, E[A + 18 | 0] = B >>> 16, E[A + 19 | 0] = B >>> 24, E[A + 20 | 0] = I, E[A + 21 | 0] = I >>> 8, E[A + 22 | 0] = I >>> 16, E[A + 23 | 0] = I >>> 24, I = o[f + 364 >> 2], B = o[f + 360 >> 2], E[A + 8 | 0] = B, E[A + 9 | 0] = B >>> 8, E[A + 10 | 0] = B >>> 16, E[A + 11 | 0] = B >>> 24, E[A + 12 | 0] = I, E[A + 13 | 0] = I >>> 8, E[A + 14 | 0] = I >>> 16, E[A + 15 | 0] = I >>> 24, I = o[f + 356 >> 2], B = o[f + 352 >> 2], E[0 | A] = B, E[A + 1 | 0] = B >>> 8, E[A + 2 | 0] = B >>> 16, E[A + 3 | 0] = B >>> 24, E[A + 4 | 0] = I, E[A + 5 | 0] = I >>> 8, E[A + 6 | 0] = I >>> 16, E[A + 7 | 0] = I >>> 24, I = o[f + 384 >> 2], B = o[f + 388 >> 2], E[A + 32 | 0] = 1, E[A + 33 | 0] = 0, E[A + 34 | 0] = 0, E[A + 35 | 0] = 0, E[A + 36 | 0] = I, E[A + 37 | 0] = I >>> 8, E[A + 38 | 0] = I >>> 16, E[A + 39 | 0] = I >>> 24, E[A + 40 | 0] = B, E[A + 41 | 0] = B >>> 8, E[A + 42 | 0] = B >>> 16, E[A + 43 | 0] = B >>> 24), g && (o[g >> 2] = e, o[g + 4 >> 2] = s), k = 0, C && (E[0 | C] = c));
                                                    }
                                                    w = f + 400 | 0;
                                                    break A;
                                                }
                                                zA(), Q();
                                            }
                                            return 0 | k;
                                        },
                                        ub: function() {
                                            return 52;
                                        },
                                        vb: function() {
                                            return 17;
                                        },
                                        wb: fI,
                                        xb: aI,
                                        yb: function() {
                                            return -18;
                                        },
                                        zb: tI,
                                        Ab: rI,
                                        Bb: function() {
                                            return 2;
                                        },
                                        Cb: function() {
                                            return 3;
                                        },
                                        Db: DI,
                                        Eb: oI,
                                        Fb: function(A, I, g, C, B) {
                                            A |= 0, I |= 0, g |= 0, C |= 0;
                                            var Q, i = 0, o = 0, f = 0, c = 0, e = 0, r = 0, D = 0, t = 0, y = 0, w = 0, n = 0, s = 0, k = 0, F = 0, S = 0;
                                            if (k = 1886610805 ^ (i = a[0 | (B |= 0)] | a[B + 1 | 0] << 8 | a[B + 2 | 0] << 16 | a[B + 3 | 0] << 24), t = 1936682341 ^ (o = a[B + 4 | 0] | a[B + 5 | 0] << 8 | a[B + 6 | 0] << 16 | a[B + 7 | 0] << 24), i ^= 1852142177, f = 1819895653 ^ o, F = 1852075885 ^ (o = a[B + 8 | 0] | a[B + 9 | 0] << 8 | a[B + 10 | 0] << 16 | a[B + 11 | 0] << 24), S = 1685025377 ^ (B = a[B + 12 | 0] | a[B + 13 | 0] << 8 | a[B + 14 | 0] << 16 | a[B + 15 | 0] << 24), D = 2037671283 ^ o, o = 1952801890 ^ B, n = g, (0 | (w = (g + I | 0) - (Q = 7 & g) | 0)) != (0 | I)) {
                                                for(; g = (e = o ^ (s = a[I + 4 | 0] | a[I + 5 | 0] << 8 | a[I + 6 | 0] << 16 | a[I + 7 | 0] << 24)) + f | 0, D = C = i + (B = D ^ (y = a[0 | I] | a[I + 1 | 0] << 8 | a[I + 2 | 0] << 16 | a[I + 3 | 0] << 24)) | 0, r = g = C >>> 0 < B >>> 0 ? g + 1 | 0 : g, i = C, C = g, g = t + S | 0, g = (o = k + F | 0) >>> 0 < F >>> 0 ? g + 1 | 0 : g, c = (f = DA(F, S, 13) ^ o) + i | 0, C = (i = h ^ g) + C | 0, i = DA(f, i, 17) ^ c, k = DA(i, C = (f = f >>> 0 > c >>> 0 ? C + 1 | 0 : C) ^ h, 13), t = h, e = DA(B, e, 16), B = r ^ h, e ^= D, r = DA(o, g, 32), g = h + B | 0, g = (D = C) + (C = (o = e + r | 0) >>> 0 < r >>> 0 ? g + 1 | 0 : g) | 0, r = g = (D = i + o | 0) >>> 0 < o >>> 0 ? g + 1 | 0 : g, k = DA(i = D ^ k, g ^= t, 17), t = h, e = DA(e, B, 21), B = C ^ h, e ^= o, o = DA(c, f, 32), C = h + B | 0, g = (o = o >>> 0 > (f = e + o | 0) >>> 0 ? C + 1 | 0 : C) + g | 0, F = (i = i + f | 0) ^ k, C = g = i >>> 0 < f >>> 0 ? g + 1 | 0 : g, S = g ^ t, g = DA(e, B, 16), e = o ^= h, c = DA(g ^= f, o, 21), f = h, r = (o = DA(D, r, 32)) + g | 0, g = h + e | 0, D = c ^ r, o = (g = o >>> 0 > r >>> 0 ? g + 1 | 0 : g) ^ f, i = DA(i, C, 32), f = h, k = r ^ y, t = g ^ s, (0 | w) != (0 | (I = I + 8 | 0)););
                                                I = w;
                                            }
                                            switch(s = 0, c = n << 24, Q - 1 | 0){
                                                case 6:
                                                    c |= a[I + 6 | 0] << 16;
                                                case 5:
                                                    c |= a[I + 5 | 0] << 8;
                                                case 4:
                                                    c |= a[I + 4 | 0];
                                                case 3:
                                                    s |= (g = a[I + 3 | 0]) << 24, c |= C = g >>> 8 | 0;
                                                case 2:
                                                    s |= (C = a[I + 2 | 0]) << 16, c |= g = C >>> 16 | 0;
                                                case 1:
                                                    s |= (g = a[I + 1 | 0]) << 8, c |= C = g >>> 24 | 0;
                                                case 0:
                                                    s = a[0 | I] | s;
                                            }
                                            return I = A, C = DA(B = D ^ s, A = o ^ c, 16), A = A + f | 0, r = A = (D = B + i | 0) >>> 0 < i >>> 0 ? A + 1 | 0 : A, y = DA(B = C ^ D, A ^= g = h, 21), o = h, g = t + S | 0, C = g = (i = k + F | 0) >>> 0 < F >>> 0 ? g + 1 | 0 : g, w = B, B = DA(i, g, 32), g = h + A | 0, A = o, o = g = B >>> 0 > (f = w + B | 0) >>> 0 ? g + 1 | 0 : g, e = DA(B = f ^ y, A ^= g, 16), y = h, n = DA(F, S, 13) ^ i, C = (w = h ^ C) + r | 0, r = B, B = DA(g = (i = n) + D | 0, C = g >>> 0 < i >>> 0 ? C + 1 | 0 : C, 32), A = h + A | 0, t = DA(i = e ^ (D = r + B | 0), B = (r = B >>> 0 > D >>> 0 ? A + 1 | 0 : A) ^ y, 21), y = h, e = DA(n, w, 17) ^ g, g = (n = h ^ C) + o | 0, A = g = (C = f = (A = e) + f | 0) >>> 0 < A >>> 0 ? g + 1 | 0 : g, o = i, i = DA(C, g, 32), g = h + B | 0, w = g = (o = i >>> 0 > (f = o + i | 0) >>> 0 ? g + 1 | 0 : g) ^ y, y = DA(t ^= f, g, 16), i = h, e = DA(e, n, 13) ^ C, A = (n = A ^ h) + r | 0, C = A = (g = e) >>> 0 > (B = g + D | 0) >>> 0 ? A + 1 | 0 : A, A = DA(B, A, 32), g = w + h | 0, w = g = (r = i) ^ (i = (A = t + (255 ^ A) | 0) >>> 0 < t >>> 0 ? g + 1 | 0 : g), D = A, y = DA(t = y ^ A, g, 21), r = h, e = DA(e, n, 17) ^ B, g = (n = C ^ h) + (o ^ c) | 0, C = g = (A = f ^ s) >>> 0 > (B = e + A | 0) >>> 0 ? g + 1 | 0 : g, A = DA(B, g, 32), g = w + h | 0, w = g = (o = (A = A + t | 0) >>> 0 < t >>> 0 ? g + 1 | 0 : g) ^ r, r = A, y = DA(t = y ^ A, g, 16), f = h, e = DA(e, n, 13) ^ B, A = i + (c = h ^ C) | 0, A = DA(B = D + e | 0, g = A = B >>> 0 < D >>> 0 ? A + 1 | 0 : A, 32), C = w + h | 0, n = C = (i = (A = A + t | 0) >>> 0 < t >>> 0 ? C + 1 | 0 : C) ^ f, f = A, w = DA(t = y ^ A, C, 21), y = h, A = DA(e, c, 17), g = o + (c = g ^ h) | 0, C = g = (B = r + (D = A ^ B) | 0) >>> 0 < r >>> 0 ? g + 1 | 0 : g, A = DA(B, g, 32), g = n + h | 0, r = A = A + t | 0, o = g = A >>> 0 < t >>> 0 ? g + 1 | 0 : g, n = DA(e = w ^ A, g ^= y, 16), w = h, A = DA(D, c, 13), C = i + (y = C ^ h) | 0, A = DA(i = f + (c = A ^ B) | 0, C = i >>> 0 < f >>> 0 ? C + 1 | 0 : C, 32), g = g + h | 0, D = A = A + e | 0, f = g = A >>> 0 < e >>> 0 ? g + 1 | 0 : g, e = DA(B = n ^ A, A = g ^ w, 21), n = h, c = DA(c, y, 17), g = o + (w = C ^ h) | 0, y = i ^ c, i = B, B = DA(C = r + y | 0, g = C >>> 0 < r >>> 0 ? g + 1 | 0 : g, 32), A = h + A | 0, n = DA(i = e ^ (r = i + B | 0), B = (o = B >>> 0 > r >>> 0 ? A + 1 | 0 : A) ^ n, 16), c = h, A = DA(y, w, 13), g = f + (w = g ^ h) | 0, A = g = (C = D + (y = A ^ C) | 0) >>> 0 < D >>> 0 ? g + 1 | 0 : g, f = DA(C, g, 32), g = h + B | 0, c = DA(n ^ (B = i = f + i | 0), (g = B >>> 0 < f >>> 0 ? g + 1 | 0 : g) ^ c, 21), D = h, i = DA(y, w, 17) ^ C, f = DA(i, A ^= h, 13), A = A + o | 0, C = A = h ^ ((i = i + r | 0) >>> 0 < r >>> 0 ? A + 1 | 0 : A), i = DA(o = i ^ f, A, 17) ^ c, A = h ^ D, C = g + C | 0, g = DA(g = B + o | 0, C = g >>> 0 < B >>> 0 ? C + 1 | 0 : C, 32) ^ i ^ g, E[0 | I] = g, E[I + 1 | 0] = g >>> 8, E[I + 2 | 0] = g >>> 16, E[I + 3 | 0] = g >>> 24, A ^= C ^ h, E[I + 4 | 0] = A, E[I + 5 | 0] = A >>> 8, E[I + 6 | 0] = A >>> 16, E[I + 7 | 0] = A >>> 24, 0;
                                        },
                                        Gb: function(A) {
                                            HA(A |= 0, 16);
                                        },
                                        Hb: EI,
                                        Ib: eI,
                                        Jb: aI,
                                        Kb: aI,
                                        Lb: eI,
                                        Mb: function() {
                                            return -65;
                                        },
                                        Nb: function(A, I, g) {
                                            A |= 0;
                                            var C, B, Q, i, o = 0, f = 0, c = 0, e = 0, r = 0;
                                            return w = Q = w - 160 | 0, aA(I |= 0, g |= 0, 32, 0), E[0 | I] = 248 & a[0 | I], E[I + 31 | 0] = 63 & a[I + 31 | 0] | 64, u(Q, I), MA(A, Q), f = a[(B = g) + 8 | 0] | a[B + 9 | 0] << 8 | a[B + 10 | 0] << 16 | a[B + 11 | 0] << 24, o = a[B + 12 | 0] | a[B + 13 | 0] << 8 | a[B + 14 | 0] << 16 | a[B + 15 | 0] << 24, c = a[B + 16 | 0] | a[B + 17 | 0] << 8 | a[B + 18 | 0] << 16 | a[B + 19 | 0] << 24, e = a[B + 20 | 0] | a[B + 21 | 0] << 8 | a[B + 22 | 0] << 16 | a[B + 23 | 0] << 24, r = a[0 | B] | a[B + 1 | 0] << 8 | a[B + 2 | 0] << 16 | a[B + 3 | 0] << 24, g = a[B + 4 | 0] | a[B + 5 | 0] << 8 | a[B + 6 | 0] << 16 | a[B + 7 | 0] << 24, i = a[B + 28 | 0] | a[B + 29 | 0] << 8 | a[B + 30 | 0] << 16 | a[B + 31 | 0] << 24, C = I, I = a[B + 24 | 0] | a[B + 25 | 0] << 8 | a[B + 26 | 0] << 16 | a[B + 27 | 0] << 24, E[C + 24 | 0] = I, E[C + 25 | 0] = I >>> 8, E[C + 26 | 0] = I >>> 16, E[C + 27 | 0] = I >>> 24, E[C + 28 | 0] = i, E[C + 29 | 0] = i >>> 8, E[C + 30 | 0] = i >>> 16, E[C + 31 | 0] = i >>> 24, E[C + 16 | 0] = c, E[C + 17 | 0] = c >>> 8, E[C + 18 | 0] = c >>> 16, E[C + 19 | 0] = c >>> 24, E[C + 20 | 0] = e, E[C + 21 | 0] = e >>> 8, E[C + 22 | 0] = e >>> 16, E[C + 23 | 0] = e >>> 24, E[C + 8 | 0] = f, E[C + 9 | 0] = f >>> 8, E[C + 10 | 0] = f >>> 16, E[C + 11 | 0] = f >>> 24, E[C + 12 | 0] = o, E[C + 13 | 0] = o >>> 8, E[C + 14 | 0] = o >>> 16, E[C + 15 | 0] = o >>> 24, E[0 | C] = r, E[C + 1 | 0] = r >>> 8, E[C + 2 | 0] = r >>> 16, E[C + 3 | 0] = r >>> 24, E[C + 4 | 0] = g, E[C + 5 | 0] = g >>> 8, E[C + 6 | 0] = g >>> 16, E[C + 7 | 0] = g >>> 24, c = a[(o = A) + 8 | 0] | a[o + 9 | 0] << 8 | a[o + 10 | 0] << 16 | a[o + 11 | 0] << 24, e = a[o + 12 | 0] | a[o + 13 | 0] << 8 | a[o + 14 | 0] << 16 | a[o + 15 | 0] << 24, r = a[o + 16 | 0] | a[o + 17 | 0] << 8 | a[o + 18 | 0] << 16 | a[o + 19 | 0] << 24, g = a[o + 20 | 0] | a[o + 21 | 0] << 8 | a[o + 22 | 0] << 16 | a[o + 23 | 0] << 24, I = a[0 | o] | a[o + 1 | 0] << 8 | a[o + 2 | 0] << 16 | a[o + 3 | 0] << 24, A = a[o + 4 | 0] | a[o + 5 | 0] << 8 | a[o + 6 | 0] << 16 | a[o + 7 | 0] << 24, f = a[o + 28 | 0] | a[o + 29 | 0] << 8 | a[o + 30 | 0] << 16 | a[o + 31 | 0] << 24, o = a[o + 24 | 0] | a[o + 25 | 0] << 8 | a[o + 26 | 0] << 16 | a[o + 27 | 0] << 24, E[C + 56 | 0] = o, E[C + 57 | 0] = o >>> 8, E[C + 58 | 0] = o >>> 16, E[C + 59 | 0] = o >>> 24, E[C + 60 | 0] = f, E[C + 61 | 0] = f >>> 8, E[C + 62 | 0] = f >>> 16, E[C + 63 | 0] = f >>> 24, E[C + 48 | 0] = r, E[C + 49 | 0] = r >>> 8, E[C + 50 | 0] = r >>> 16, E[C + 51 | 0] = r >>> 24, E[C + 52 | 0] = g, E[C + 53 | 0] = g >>> 8, E[C + 54 | 0] = g >>> 16, E[C + 55 | 0] = g >>> 24, E[C + 40 | 0] = c, E[C + 41 | 0] = c >>> 8, E[C + 42 | 0] = c >>> 16, E[C + 43 | 0] = c >>> 24, E[C + 44 | 0] = e, E[C + 45 | 0] = e >>> 8, E[C + 46 | 0] = e >>> 16, E[C + 47 | 0] = e >>> 24, E[C + 32 | 0] = I, E[C + 33 | 0] = I >>> 8, E[C + 34 | 0] = I >>> 16, E[C + 35 | 0] = I >>> 24, E[C + 36 | 0] = A, E[C + 37 | 0] = A >>> 8, E[C + 38 | 0] = A >>> 16, E[C + 39 | 0] = A >>> 24, w = Q + 160 | 0, 0;
                                        },
                                        Ob: function(A, I) {
                                            A |= 0, I |= 0;
                                            var g, C, B, Q, i, f = 0, c = 0, e = 0;
                                            return w = c = w - 192 | 0, HA(c, 32), aA(I, c, 32, 0), E[0 | I] = 248 & a[0 | I], E[I + 31 | 0] = 63 & a[I + 31 | 0] | 64, u(e = c + 32 | 0, I), MA(A, e), g = c, e = o[c + 28 >> 2], c = o[c + 24 >> 2], E[I + 24 | 0] = c, E[I + 25 | 0] = c >>> 8, E[I + 26 | 0] = c >>> 16, E[I + 27 | 0] = c >>> 24, E[I + 28 | 0] = e, E[I + 29 | 0] = e >>> 8, E[I + 30 | 0] = e >>> 16, E[I + 31 | 0] = e >>> 24, e = o[g + 20 >> 2], c = o[g + 16 >> 2], E[I + 16 | 0] = c, E[I + 17 | 0] = c >>> 8, E[I + 18 | 0] = c >>> 16, E[I + 19 | 0] = c >>> 24, E[I + 20 | 0] = e, E[I + 21 | 0] = e >>> 8, E[I + 22 | 0] = e >>> 16, E[I + 23 | 0] = e >>> 24, e = o[g + 12 >> 2], c = o[g + 8 >> 2], E[I + 8 | 0] = c, E[I + 9 | 0] = c >>> 8, E[I + 10 | 0] = c >>> 16, E[I + 11 | 0] = c >>> 24, E[I + 12 | 0] = e, E[I + 13 | 0] = e >>> 8, E[I + 14 | 0] = e >>> 16, E[I + 15 | 0] = e >>> 24, e = o[g + 4 >> 2], c = o[g >> 2], E[0 | I] = c, E[I + 1 | 0] = c >>> 8, E[I + 2 | 0] = c >>> 16, E[I + 3 | 0] = c >>> 24, E[I + 4 | 0] = e, E[I + 5 | 0] = e >>> 8, E[I + 6 | 0] = e >>> 16, E[I + 7 | 0] = e >>> 24, C = a[(f = A) + 8 | 0] | a[f + 9 | 0] << 8 | a[f + 10 | 0] << 16 | a[f + 11 | 0] << 24, B = a[f + 12 | 0] | a[f + 13 | 0] << 8 | a[f + 14 | 0] << 16 | a[f + 15 | 0] << 24, Q = a[f + 16 | 0] | a[f + 17 | 0] << 8 | a[f + 18 | 0] << 16 | a[f + 19 | 0] << 24, e = a[f + 20 | 0] | a[f + 21 | 0] << 8 | a[f + 22 | 0] << 16 | a[f + 23 | 0] << 24, c = a[0 | f] | a[f + 1 | 0] << 8 | a[f + 2 | 0] << 16 | a[f + 3 | 0] << 24, A = a[f + 4 | 0] | a[f + 5 | 0] << 8 | a[f + 6 | 0] << 16 | a[f + 7 | 0] << 24, i = a[f + 28 | 0] | a[f + 29 | 0] << 8 | a[f + 30 | 0] << 16 | a[f + 31 | 0] << 24, f = a[f + 24 | 0] | a[f + 25 | 0] << 8 | a[f + 26 | 0] << 16 | a[f + 27 | 0] << 24, E[I + 56 | 0] = f, E[I + 57 | 0] = f >>> 8, E[I + 58 | 0] = f >>> 16, E[I + 59 | 0] = f >>> 24, E[I + 60 | 0] = i, E[I + 61 | 0] = i >>> 8, E[I + 62 | 0] = i >>> 16, E[I + 63 | 0] = i >>> 24, E[I + 48 | 0] = Q, E[I + 49 | 0] = Q >>> 8, E[I + 50 | 0] = Q >>> 16, E[I + 51 | 0] = Q >>> 24, E[I + 52 | 0] = e, E[I + 53 | 0] = e >>> 8, E[I + 54 | 0] = e >>> 16, E[I + 55 | 0] = e >>> 24, E[I + 40 | 0] = C, E[I + 41 | 0] = C >>> 8, E[I + 42 | 0] = C >>> 16, E[I + 43 | 0] = C >>> 24, E[I + 44 | 0] = B, E[I + 45 | 0] = B >>> 8, E[I + 46 | 0] = B >>> 16, E[I + 47 | 0] = B >>> 24, E[I + 32 | 0] = c, E[I + 33 | 0] = c >>> 8, E[I + 34 | 0] = c >>> 16, E[I + 35 | 0] = c >>> 24, E[I + 36 | 0] = A, E[I + 37 | 0] = A >>> 8, E[I + 38 | 0] = A >>> 16, E[I + 39 | 0] = A >>> 24, iI(g, 32), w = g + 192 | 0, 0;
                                        },
                                        Pb: function(A, I, g, C, B, Q) {
                                            I |= 0, B |= 0, Q |= 0;
                                            var i, E = 0;
                                            return w = i = w - 16 | 0, s(A |= 0, i + 8 | 0, pA(A - -64 | 0, g |= 0, C |= 0), C, B, Q, 0), 64 != o[i + 8 >> 2] | o[i + 12 >> 2] ? (I && (o[I >> 2] = 0, o[I + 4 >> 2] = 0), dA(A, 0, C - -64 | 0), E = -1) : I && (o[I >> 2] = C - -64, o[I + 4 >> 2] = B - ((C >>> 0 < 4294967232) - 1 | 0)), w = i + 16 | 0, 0 | E;
                                        },
                                        Qb: function(A, I, g, C, B, Q) {
                                            A |= 0, I |= 0, g |= 0;
                                            var i = 0;
                                            A: {
                                                I: {
                                                    if (i = C |= 0, !(!(B |= 0) & C >>> 0 < 64 || (C = B - 1 | 0, !(C = (B = i + -64 | 0) >>> 0 < 4294967232 ? C + 1 | 0 : C) & B >>> 0 > 4294967231 | C))) {
                                                        if (!S(g, i = g - -64 | 0, B, C, Q |= 0, 0)) break I;
                                                        A && dA(A, 0, B);
                                                    }
                                                    if (g = -1, !I) break A;
                                                    o[I >> 2] = 0, o[I + 4 >> 2] = 0;
                                                    break A;
                                                }
                                                I && (o[I >> 2] = B, o[I + 4 >> 2] = C), g = 0, A && pA(A, i, B);
                                            }
                                            return 0 | g;
                                        },
                                        Rb: function(A, I, g, C, B, Q) {
                                            return s(A |= 0, I |= 0, g |= 0, C |= 0, B |= 0, Q |= 0, 0), 0;
                                        },
                                        Sb: function(A, I, g, C, B) {
                                            return 0 | S(A |= 0, I |= 0, g |= 0, C |= 0, B |= 0, 0);
                                        },
                                        Tb: function(A) {
                                            return cA(A |= 0), 0;
                                        },
                                        Ub: function(A, I, g, C) {
                                            return 0 | R(A |= 0, I |= 0, g |= 0, C |= 0);
                                        },
                                        Vb: function(A, I, g, C) {
                                            var B;
                                            return I |= 0, g |= 0, C |= 0, w = B = w + -64 | 0, N(A |= 0, B), A = s(I, g, B, 64, 0, C, 1), w = B - -64 | 0, 0 | A;
                                        },
                                        Wb: function(A, I, g) {
                                            var C;
                                            return I |= 0, g |= 0, w = C = w + -64 | 0, N(A |= 0, C), A = S(I, C, 64, 0, g, 1), w = C - -64 | 0, 0 | A;
                                        },
                                        Xb: function(A, I) {
                                            A |= 0;
                                            var g, C = 0, B = 0, Q = 0, i = 0, a = 0, f = 0, e = 0, r = 0, D = 0, t = 0, y = 0, n = 0, s = 0, k = 0, F = 0, S = 0, _ = 0, M = 0, p = 0, N = 0, J = 0, Y = 0, d = 0, K = 0, v = 0, L = 0, R = 0, u = 0, x = 0, m = 0, l = 0, z = 0, q = 0, X = 0, j = 0, T = 0, V = 0, Z = 0, $ = 0, AA = 0, gA = 0, CA = 0, BA = 0, QA = 0, iA = 0, EA = 0, oA = 0, aA = 0, cA = 0, eA = 0, DA = 0, tA = 0, yA = 0, wA = 0, hA = 0, nA = 0, sA = 0, FA = 0, SA = 0, HA = 0, GA = 0, _A = 0, MA = 0, pA = 0, NA = 0, JA = 0, UA = 0, YA = 0, KA = 0, bA = 0, PA = 0, vA = 0, LA = 0, RA = 0, uA = 0, xA = 0, mA = 0, lA = 0, zA = 0, qA = 0;
                                            if (w = g = w - 256 | 0, vA = -1, !rA(I |= 0) && !U(C = g + 96 | 0, I)) {
                                                for(w = Q = w - 2048 | 0, W(i = Q + 640 | 0, C), C = o[(I = C) + 36 >> 2], o[Q + 352 >> 2] = o[I + 32 >> 2], o[Q + 356 >> 2] = C, C = o[I + 28 >> 2], o[Q + 344 >> 2] = o[I + 24 >> 2], o[Q + 348 >> 2] = C, C = o[I + 20 >> 2], o[Q + 336 >> 2] = o[I + 16 >> 2], o[Q + 340 >> 2] = C, C = o[I + 12 >> 2], o[Q + 328 >> 2] = o[I + 8 >> 2], o[Q + 332 >> 2] = C, C = o[I + 4 >> 2], o[Q + 320 >> 2] = o[I >> 2], o[Q + 324 >> 2] = C, C = o[I + 52 >> 2], o[Q + 368 >> 2] = o[I + 48 >> 2], o[Q + 372 >> 2] = C, C = o[I + 60 >> 2], o[Q + 376 >> 2] = o[I + 56 >> 2], o[Q + 380 >> 2] = C, B = o[4 + (C = I - -64 | 0) >> 2], o[Q + 384 >> 2] = o[C >> 2], o[Q + 388 >> 2] = B, C = o[I + 76 >> 2], o[Q + 392 >> 2] = o[I + 72 >> 2], o[Q + 396 >> 2] = C, C = o[I + 44 >> 2], o[Q + 360 >> 2] = o[I + 40 >> 2], o[Q + 364 >> 2] = C, C = o[I + 92 >> 2], o[Q + 408 >> 2] = o[I + 88 >> 2], o[Q + 412 >> 2] = C, C = o[I + 100 >> 2], o[Q + 416 >> 2] = o[I + 96 >> 2], o[Q + 420 >> 2] = C, C = o[I + 108 >> 2], o[Q + 424 >> 2] = o[I + 104 >> 2], o[Q + 428 >> 2] = C, C = o[I + 116 >> 2], o[Q + 432 >> 2] = o[I + 112 >> 2], o[Q + 436 >> 2] = C, C = o[I + 84 >> 2], o[Q + 400 >> 2] = o[I + 80 >> 2], o[Q + 404 >> 2] = C, G(I = Q + 480 | 0, C = Q + 320 | 0), H(B = Q + 160 | 0, I, f = Q + 600 | 0), H(Q + 200 | 0, r = Q + 520 | 0, D = Q + 560 | 0), H(Q + 240 | 0, D, f), H(Q + 280 | 0, I, r), b(I, B, i), H(C, I, f), H(F = Q + 360 | 0, r, D), H(S = Q + 400 | 0, D, f), H(n = Q + 440 | 0, I, r), W(i = Q + 800 | 0, C), b(I, B, i), H(C, I, f), H(F, r, D), H(S, D, f), H(n, I, r), W(i = Q + 960 | 0, C), b(I, B, i), H(C, I, f), H(F, r, D), H(S, D, f), H(n, I, r), W(i = Q + 1120 | 0, C), b(I, B, i), H(C, I, f), H(F, r, D), H(S, D, f), H(n, I, r), W(i = Q + 1280 | 0, C), b(I, B, i), H(C, I, f), H(F, r, D), H(S, D, f), H(n, I, r), W(i = Q + 1440 | 0, C), b(I, B, i), H(C, I, f), H(F, r, D), H(S, D, f), H(n, I, r), W(i = Q + 1600 | 0, C), b(I, B, i), H(C, I, f), H(F, r, D), H(S, D, f), H(n, I, r), W(Q + 1760 | 0, C), o[Q + 32 >> 2] = 0, o[Q + 36 >> 2] = 0, o[Q + 24 >> 2] = 0, o[Q + 28 >> 2] = 0, o[Q + 16 >> 2] = 0, o[Q + 20 >> 2] = 0, o[Q + 8 >> 2] = 0, o[Q + 12 >> 2] = 0, o[Q + 44 >> 2] = 0, o[Q + 48 >> 2] = 0, o[Q + 52 >> 2] = 0, o[Q + 56 >> 2] = 0, o[Q + 60 >> 2] = 0, o[Q + 64 >> 2] = 0, o[Q + 68 >> 2] = 0, o[Q + 72 >> 2] = 0, o[Q + 76 >> 2] = 0, o[Q + 80 >> 2] = 1, o[Q >> 2] = 0, o[Q + 4 >> 2] = 0, o[Q + 40 >> 2] = 1, dA(Q + 84 | 0, 0, 76), t = Q + 120 | 0, k = Q + 2008 | 0, s = Q + 1968 | 0, C = Q + 80 | 0, B = Q + 40 | 0, i = 252; a = o[Q + 36 >> 2], o[(I = Q + 1960 | 0) >> 2] = o[Q + 32 >> 2], o[I + 4 >> 2] = a, a = o[Q + 28 >> 2], o[(I = Q + 1952 | 0) >> 2] = o[Q + 24 >> 2], o[I + 4 >> 2] = a, a = o[Q + 20 >> 2], o[(I = Q + 1944 | 0) >> 2] = o[Q + 16 >> 2], o[I + 4 >> 2] = a, a = o[Q + 12 >> 2], o[(I = Q + 1936 | 0) >> 2] = o[Q + 8 >> 2], o[I + 4 >> 2] = a, I = o[Q + 4 >> 2], o[Q + 1928 >> 2] = o[Q >> 2], o[Q + 1932 >> 2] = I, a = o[(I = B) + 36 >> 2], o[s + 32 >> 2] = o[I + 32 >> 2], o[s + 36 >> 2] = a, a = o[I + 28 >> 2], o[s + 24 >> 2] = o[I + 24 >> 2], o[s + 28 >> 2] = a, a = o[I + 20 >> 2], o[s + 16 >> 2] = o[I + 16 >> 2], o[s + 20 >> 2] = a, a = o[I + 12 >> 2], o[s + 8 >> 2] = o[I + 8 >> 2], o[s + 12 >> 2] = a, a = o[I + 4 >> 2], o[s >> 2] = o[I >> 2], o[s + 4 >> 2] = a, a = o[(I = C) + 36 >> 2], o[k + 32 >> 2] = o[I + 32 >> 2], o[k + 36 >> 2] = a, a = o[I + 28 >> 2], o[k + 24 >> 2] = o[I + 24 >> 2], o[k + 28 >> 2] = a, a = o[I + 20 >> 2], o[k + 16 >> 2] = o[I + 16 >> 2], o[k + 20 >> 2] = a, a = o[I + 12 >> 2], o[k + 8 >> 2] = o[I + 8 >> 2], o[k + 12 >> 2] = a, a = o[I + 4 >> 2], o[k >> 2] = o[I >> 2], o[k + 4 >> 2] = a, i = E[(I = i) + 33424 | 0], G(a = Q + 480 | 0, Q + 1928 | 0), (0 | i) > 0 ? (H(M = Q + 320 | 0, a, f), H(F, r, D), H(S, D, f), H(n, a, r), b(a, M, (Q + 640 | 0) + c((254 & i) >>> 1 | 0, 160) | 0)) : (0 | i) >= 0 || (H(M = Q + 320 | 0, a = Q + 480 | 0, f), H(F, r, D), H(S, D, f), H(n, a, r), P(a, M, (Q + 640 | 0) + c((0 - i & 254) >>> 1 | 0, 160) | 0)), H(Q, i = Q + 480 | 0, f), H(B, r, D), H(C, D, f), H(t, i, r), i = I - 1 | 0, I;);
                                                IA(I = Q + 640 | 0, Q), I = fA(I, 32), w = Q + 2048 | 0, I && (Q = o[g + 136 >> 2], o[g >> 2] = 1 - Q, vA = 0, z = o[g + 172 >> 2], o[g + 36 >> 2] = 0 - z, F = o[g + 168 >> 2], o[g + 32 >> 2] = 0 - F, q = o[g + 164 >> 2], o[g + 28 >> 2] = 0 - q, r = o[g + 160 >> 2], o[g + 24 >> 2] = 0 - r, X = o[g + 156 >> 2], o[g + 20 >> 2] = 0 - X, D = o[g + 152 >> 2], o[g + 16 >> 2] = 0 - D, j = o[g + 148 >> 2], o[g + 12 >> 2] = 0 - j, k = o[g + 144 >> 2], o[g + 8 >> 2] = 0 - k, T = o[g + 140 >> 2], o[g + 4 >> 2] = 0 - T, O(g, g), I = kA(S = o[g + 4 >> 2], x = S >> 31, Y = X << 1, cA = Y >> 31), C = h, B = kA(f = o[g >> 2], d = f >> 31, r, K = r >> 31), C = h + C | 0, C = (I = B + I | 0) >>> 0 < B >>> 0 ? C + 1 | 0 : C, B = (i = kA(a = o[g + 8 >> 2], V = a >> 31, D, v = D >> 31)) + I | 0, I = h + C | 0, I = B >>> 0 < i >>> 0 ? I + 1 | 0 : I, C = B, B = kA(m = o[g + 12 >> 2], AA = m >> 31, BA = j << 1, eA = BA >> 31), I = h + I | 0, I = (C = C + B | 0) >>> 0 < B >>> 0 ? I + 1 | 0 : I, B = kA(Z = o[g + 16 >> 2], QA = Z >> 31, k, L = k >> 31), I = h + I | 0, I = (C = B + C | 0) >>> 0 < B >>> 0 ? I + 1 | 0 : I, JA = i = o[g + 20 >> 2], s = kA(i, DA = i >> 31, iA = T << 1, tA = iA >> 31), B = h + I | 0, B = (C = s + C | 0) >>> 0 < s >>> 0 ? B + 1 | 0 : B, UA = p = o[g + 24 >> 2], I = (Q = kA(p, MA = p >> 31, s = Q + 1 | 0, R = s >> 31)) + C | 0, C = h + B | 0, C = I >>> 0 < Q >>> 0 ? C + 1 | 0 : C, yA = o[g + 28 >> 2], B = (Q = kA(M = c(yA, 19), gA = M >> 31, EA = z << 1, wA = EA >> 31)) + I | 0, I = h + C | 0, I = B >>> 0 < Q >>> 0 ? I + 1 | 0 : I, C = B, LA = o[g + 32 >> 2], B = kA(t = c(LA, 19), $ = t >> 31, F, u = F >> 31), I = h + I | 0, I = (C = C + B | 0) >>> 0 < B >>> 0 ? I + 1 | 0 : I, RA = o[g + 36 >> 2], B = kA(n = c(RA, 19), l = n >> 31, oA = q << 1, hA = oA >> 31), I = h + I | 0, y = C = B + C | 0, Q = C >>> 0 < B >>> 0 ? I + 1 | 0 : I, I = kA(D, v, S, x), C = h, e = kA(f, d, X, nA = X >> 31), B = h + C | 0, B = (I = e + I | 0) >>> 0 < e >>> 0 ? B + 1 | 0 : B, e = kA(a, V, j, sA = j >> 31), C = h + B | 0, C = (I = e + I | 0) >>> 0 < e >>> 0 ? C + 1 | 0 : C, B = (e = kA(k, L, m, AA)) + I | 0, I = h + C | 0, I = B >>> 0 < e >>> 0 ? I + 1 | 0 : I, C = B, B = kA(Z, QA, T, FA = T >> 31), I = h + I | 0, I = (C = C + B | 0) >>> 0 < B >>> 0 ? I + 1 | 0 : I, B = kA(s, R, i, DA), I = h + I | 0, I = (C = B + C | 0) >>> 0 < B >>> 0 ? I + 1 | 0 : I, e = kA(p = c(p, 19), aA = p >> 31, z, SA = z >> 31), B = h + I | 0, B = (C = e + C | 0) >>> 0 < e >>> 0 ? B + 1 | 0 : B, I = (e = kA(F, u, M, gA)) + C | 0, C = h + B | 0, C = I >>> 0 < e >>> 0 ? C + 1 | 0 : C, B = (e = kA(t, $, q, HA = q >> 31)) + I | 0, I = h + C | 0, I = B >>> 0 < e >>> 0 ? I + 1 | 0 : I, C = B, B = kA(r, K, n, l), I = h + I | 0, YA = C = C + B | 0, CA = C >>> 0 < B >>> 0 ? I + 1 | 0 : I, I = kA(S, x, BA, eA), B = h, C = (e = kA(f, d, D, v)) + I | 0, I = h + B | 0, I = C >>> 0 < e >>> 0 ? I + 1 | 0 : I, e = kA(k, L, a, V), B = h + I | 0, B = (C = e + C | 0) >>> 0 < e >>> 0 ? B + 1 | 0 : B, I = (e = kA(m, AA, iA, tA)) + C | 0, C = h + B | 0, C = I >>> 0 < e >>> 0 ? C + 1 | 0 : C, B = (e = kA(s, R, Z, QA)) + I | 0, I = h + C | 0, I = B >>> 0 < e >>> 0 ? I + 1 | 0 : I, C = B, B = kA(e = c(i, 19), GA = e >> 31, EA, wA), I = h + I | 0, I = (C = C + B | 0) >>> 0 < B >>> 0 ? I + 1 | 0 : I, B = kA(F, u, p, aA), I = h + I | 0, I = (C = B + C | 0) >>> 0 < B >>> 0 ? I + 1 | 0 : I, i = kA(M, gA, oA, hA), B = h + I | 0, B = (C = i + C | 0) >>> 0 < i >>> 0 ? B + 1 | 0 : B, I = (i = kA(r, K, t, $)) + C | 0, C = h + B | 0, C = I >>> 0 < i >>> 0 ? C + 1 | 0 : C, B = (i = kA(n, l, Y, cA)) + I | 0, I = h + C | 0, uA = B, xA = I = B >>> 0 < i >>> 0 ? I + 1 | 0 : I, mA = B = B + 33554432 | 0, lA = I = B >>> 0 < 33554432 ? I + 1 | 0 : I, B = (67108863 & I) << 6 | B >>> 26, I = (I >> 26) + CA | 0, YA = i = B + YA | 0, I = B >>> 0 > i >>> 0 ? I + 1 | 0 : I, zA = i = i + 16777216 | 0, I = (C = (B = i >>> 0 < 16777216 ? I + 1 | 0 : I) >> 25) + Q | 0, I = (B = (i = (33554431 & B) << 7 | i >>> 25) + y | 0) >>> 0 < i >>> 0 ? I + 1 | 0 : I, J = C = B + 33554432 | 0, i = I = C >>> 0 < 33554432 ? I + 1 | 0 : I, o[g + 72 >> 2] = B - (-67108864 & C), I = kA(S, x, iA, tA), C = h, Q = kA(f, d, k, L), B = h + C | 0, B = (I = Q + I | 0) >>> 0 < Q >>> 0 ? B + 1 | 0 : B, C = (Q = kA(s, R, a, V)) + I | 0, I = h + B | 0, I = C >>> 0 < Q >>> 0 ? I + 1 | 0 : I, B = kA(Q = c(m, 19), _A = Q >> 31, EA, wA), I = h + I | 0, I = (C = B + C | 0) >>> 0 < B >>> 0 ? I + 1 | 0 : I, B = (y = kA(CA = c(Z, 19), pA = CA >> 31, F, u)) + C | 0, C = h + I | 0, C = B >>> 0 < y >>> 0 ? C + 1 | 0 : C, y = kA(oA, hA, e, GA), I = h + C | 0, I = (B = y + B | 0) >>> 0 < y >>> 0 ? I + 1 | 0 : I, C = (y = kA(r, K, p, aA)) + B | 0, B = h + I | 0, B = C >>> 0 < y >>> 0 ? B + 1 | 0 : B, y = kA(M, gA, Y, cA), I = h + B | 0, I = (C = y + C | 0) >>> 0 < y >>> 0 ? I + 1 | 0 : I, B = kA(D, v, t, $), I = h + I | 0, I = (C = B + C | 0) >>> 0 < B >>> 0 ? I + 1 | 0 : I, B = (y = kA(n, l, BA, eA)) + C | 0, C = h + I | 0, N = B, KA = B >>> 0 < y >>> 0 ? C + 1 | 0 : C, I = kA(s, R, S, x), C = h, B = (y = kA(f, d, T, FA)) + I | 0, I = h + C | 0, I = B >>> 0 < y >>> 0 ? I + 1 | 0 : I, y = C = c(a, 19), C = (_ = kA(C, NA = C >> 31, z, SA)) + B | 0, B = h + I | 0, B = C >>> 0 < _ >>> 0 ? B + 1 | 0 : B, _ = kA(Q, _A, F, u), I = h + B | 0, I = (C = _ + C | 0) >>> 0 < _ >>> 0 ? I + 1 | 0 : I, B = kA(CA, pA, q, HA), I = h + I | 0, I = (C = B + C | 0) >>> 0 < B >>> 0 ? I + 1 | 0 : I, B = (_ = kA(r, K, e, GA)) + C | 0, C = h + I | 0, C = B >>> 0 < _ >>> 0 ? C + 1 | 0 : C, _ = kA(p, aA, X, nA), I = h + C | 0, I = (B = _ + B | 0) >>> 0 < _ >>> 0 ? I + 1 | 0 : I, C = (_ = kA(D, v, M, gA)) + B | 0, B = h + I | 0, B = C >>> 0 < _ >>> 0 ? B + 1 | 0 : B, _ = kA(t, $, j, sA), I = h + B | 0, I = (C = _ + C | 0) >>> 0 < _ >>> 0 ? I + 1 | 0 : I, B = kA(k, L, n, l), I = h + I | 0, bA = C = B + C | 0, _ = C >>> 0 < B >>> 0 ? I + 1 | 0 : I, I = kA(I = c(S, 19), I >> 31, EA, wA), C = h, B = kA(f, d, s, R), C = h + C | 0, C = (I = B + I | 0) >>> 0 < B >>> 0 ? C + 1 | 0 : C, B = (y = kA(y, NA, F, u)) + I | 0, I = h + C | 0, C = (Q = kA(Q, _A, oA, hA)) + B | 0, B = h + (B >>> 0 < y >>> 0 ? I + 1 | 0 : I) | 0, B = C >>> 0 < Q >>> 0 ? B + 1 | 0 : B, Q = kA(r, K, CA, pA), I = h + B | 0, I = (C = Q + C | 0) >>> 0 < Q >>> 0 ? I + 1 | 0 : I, B = kA(Y, cA, e, GA), I = h + I | 0, I = (C = B + C | 0) >>> 0 < B >>> 0 ? I + 1 | 0 : I, B = (Q = kA(D, v, p, aA)) + C | 0, C = h + I | 0, C = B >>> 0 < Q >>> 0 ? C + 1 | 0 : C, Q = kA(M, gA, BA, eA), I = h + C | 0, I = (B = Q + B | 0) >>> 0 < Q >>> 0 ? I + 1 | 0 : I, C = (Q = kA(k, L, t, $)) + B | 0, B = h + I | 0, B = C >>> 0 < Q >>> 0 ? B + 1 | 0 : B, Q = kA(n, l, iA, tA), I = h + B | 0, y = C = Q + C | 0, _A = I = C >>> 0 < Q >>> 0 ? I + 1 | 0 : I, NA = C = C + 33554432 | 0, qA = I = C >>> 0 < 33554432 ? I + 1 | 0 : I, B = I >> 26, I = (67108863 & I) << 6 | C >>> 26, C = B + _ | 0, _ = Q = I + bA | 0, I = C = I >>> 0 > Q >>> 0 ? C + 1 | 0 : C, bA = Q = Q + 16777216 | 0, Q = (33554431 & (I = Q >>> 0 < 16777216 ? I + 1 | 0 : I)) << 7 | Q >>> 25, I = (I >> 25) + KA | 0, I = (C = Q + N | 0) >>> 0 < Q >>> 0 ? I + 1 | 0 : I, B = C, KA = C = C + 33554432 | 0, Q = I = C >>> 0 < 33554432 ? I + 1 | 0 : I, o[g + 56 >> 2] = B - (-67108864 & C), I = kA(r, K, S, x), B = h, C = (N = kA(f, d, q, HA)) + I | 0, I = h + B | 0, I = C >>> 0 < N >>> 0 ? I + 1 | 0 : I, B = kA(a, V, X, nA), I = h + I | 0, I = (C = B + C | 0) >>> 0 < B >>> 0 ? I + 1 | 0 : I, B = kA(D, v, m, AA), I = h + I | 0, I = (C = B + C | 0) >>> 0 < B >>> 0 ? I + 1 | 0 : I, N = kA(Z, QA, j, sA), B = h + I | 0, B = (C = N + C | 0) >>> 0 < N >>> 0 ? B + 1 | 0 : B, I = (N = kA(k, L, JA, DA)) + C | 0, C = h + B | 0, C = I >>> 0 < N >>> 0 ? C + 1 | 0 : C, B = (N = kA(T, FA, UA, MA)) + I | 0, I = h + C | 0, I = B >>> 0 < N >>> 0 ? I + 1 | 0 : I, C = B, B = kA(yA, PA = yA >> 31, s, R), I = h + I | 0, I = (C = C + B | 0) >>> 0 < B >>> 0 ? I + 1 | 0 : I, B = kA(t, $, z, SA), I = h + I | 0, I = (C = B + C | 0) >>> 0 < B >>> 0 ? I + 1 | 0 : I, N = (B = C) + (C = kA(F, u, n, l)) | 0, B = h + I | 0, C = (I = i >> 26) + (C = C >>> 0 > N >>> 0 ? B + 1 | 0 : B) | 0, J = B = (i = (67108863 & i) << 6 | J >>> 26) + N | 0, I = C = B >>> 0 < i >>> 0 ? C + 1 | 0 : C, N = B = B + 16777216 | 0, i = I = B >>> 0 < 16777216 ? I + 1 | 0 : I, o[g + 76 >> 2] = J - (-33554432 & B), I = kA(k, L, S, x), C = h, J = kA(f, d, j, sA), B = h + C | 0, B = (I = J + I | 0) >>> 0 < J >>> 0 ? B + 1 | 0 : B, J = kA(a, V, T, FA), C = h + B | 0, C = (I = J + I | 0) >>> 0 < J >>> 0 ? C + 1 | 0 : C, B = (J = kA(s, R, m, AA)) + I | 0, I = h + C | 0, I = B >>> 0 < J >>> 0 ? I + 1 | 0 : I, C = B, B = kA(CA, pA, z, SA), I = h + I | 0, I = (C = C + B | 0) >>> 0 < B >>> 0 ? I + 1 | 0 : I, B = kA(F, u, e, GA), I = h + I | 0, I = (C = B + C | 0) >>> 0 < B >>> 0 ? I + 1 | 0 : I, C = (p = kA(p, aA, q, HA)) + C | 0, B = h + I | 0, I = (M = kA(r, K, M, gA)) + C | 0, C = h + (C >>> 0 < p >>> 0 ? B + 1 | 0 : B) | 0, B = (t = kA(t, $, X, nA)) + I | 0, I = h + (I >>> 0 < M >>> 0 ? C + 1 | 0 : C) | 0, I = B >>> 0 < t >>> 0 ? I + 1 | 0 : I, C = B, B = kA(D, v, n, l), I = h + I | 0, J = C = C + B | 0, I = (I = C >>> 0 < B >>> 0 ? I + 1 | 0 : I) + (C = Q >> 26) | 0, t = Q = J + (B = (67108863 & Q) << 6 | KA >>> 26) | 0, I = B >>> 0 > Q >>> 0 ? I + 1 | 0 : I, M = C = Q + 16777216 | 0, Q = B = C >>> 0 < 16777216 ? I + 1 | 0 : I, o[g + 60 >> 2] = t - (-33554432 & C), I = kA(S, x, oA, hA), B = h, C = (t = kA(f, d, F, u)) + I | 0, I = h + B | 0, I = C >>> 0 < t >>> 0 ? I + 1 | 0 : I, B = kA(r, K, a, V), I = h + I | 0, I = (C = B + C | 0) >>> 0 < B >>> 0 ? I + 1 | 0 : I, t = kA(m, AA, Y, cA), B = h + I | 0, B = (C = t + C | 0) >>> 0 < t >>> 0 ? B + 1 | 0 : B, I = (t = kA(D, v, Z, QA)) + C | 0, C = h + B | 0, C = I >>> 0 < t >>> 0 ? C + 1 | 0 : C, B = (t = kA(BA, eA, JA, DA)) + I | 0, I = h + C | 0, I = B >>> 0 < t >>> 0 ? I + 1 | 0 : I, C = B, B = kA(k, L, UA, MA), I = h + I | 0, I = (C = C + B | 0) >>> 0 < B >>> 0 ? I + 1 | 0 : I, B = C, C = kA(iA, tA, yA, PA), I = h + I | 0, I = C >>> 0 > (B = B + C | 0) >>> 0 ? I + 1 | 0 : I, t = C = LA, C = (Y = kA(C, p = C >> 31, s, R)) + B | 0, B = h + I | 0, I = (n = kA(n, l, EA, wA)) + C | 0, C = h + (C >>> 0 < Y >>> 0 ? B + 1 | 0 : B) | 0, B = I >>> 0 < n >>> 0 ? C + 1 | 0 : C, C = I, I = (I = i >> 25) + B | 0, I = (C = C + (i = (33554431 & i) << 7 | N >>> 25) | 0) >>> 0 < i >>> 0 ? I + 1 | 0 : I, B = C, n = C = C + 33554432 | 0, i = I = C >>> 0 < 33554432 ? I + 1 | 0 : I, o[g + 80 >> 2] = B - (-67108864 & C), C = Q >> 25, B = (Q = (33554431 & Q) << 7 | M >>> 25) + (uA - (I = -67108864 & mA) | 0) | 0, I = C + (xA - ((I >>> 0 > uA >>> 0) + lA | 0) | 0) | 0, I = B >>> 0 < Q >>> 0 ? I + 1 | 0 : I, I = ((67108863 & (I = (C = B + 33554432 | 0) >>> 0 < 33554432 ? I + 1 | 0 : I)) << 6 | C >>> 26) + (Y = YA - (-33554432 & zA) | 0) | 0, o[g + 68 >> 2] = I, o[g + 64 >> 2] = B - (-67108864 & C), I = kA(F, u, S, x), B = h, C = (Q = kA(f, d, z, SA)) + I | 0, I = h + B | 0, I = C >>> 0 < Q >>> 0 ? I + 1 | 0 : I, B = (Q = kA(a, V, q, HA)) + C | 0, C = h + I | 0, C = B >>> 0 < Q >>> 0 ? C + 1 | 0 : C, I = (Q = kA(r, K, m, AA)) + B | 0, B = h + C | 0, B = I >>> 0 < Q >>> 0 ? B + 1 | 0 : B, C = (Q = kA(Z, QA, X, nA)) + I | 0, I = h + B | 0, I = C >>> 0 < Q >>> 0 ? I + 1 | 0 : I, B = kA(D, v, JA, DA), I = h + I | 0, I = (C = B + C | 0) >>> 0 < B >>> 0 ? I + 1 | 0 : I, B = kA(j, sA, UA, MA), I = h + I | 0, I = (C = B + C | 0) >>> 0 < B >>> 0 ? I + 1 | 0 : I, B = (Q = kA(k, L, yA, PA)) + C | 0, C = h + I | 0, C = B >>> 0 < Q >>> 0 ? C + 1 | 0 : C, Q = (I = kA(t, p, T, FA)) + B | 0, B = h + C | 0, B = I >>> 0 > Q >>> 0 ? B + 1 | 0 : B, C = Q, Q = kA(I = RA, I >> 31, s, R), I = h + B | 0, B = C = C + Q | 0, I = (I = C >>> 0 < Q >>> 0 ? I + 1 | 0 : I) + (C = i >> 26) | 0, I = (B = B + (i = (67108863 & i) << 6 | n >>> 26) | 0) >>> 0 < i >>> 0 ? I + 1 | 0 : I, I = (C = B + 16777216 | 0) >>> 0 < 16777216 ? I + 1 | 0 : I, o[g + 84 >> 2] = B - (-33554432 & C), i = _ - (-33554432 & bA) | 0, Q = y - (B = -67108864 & NA) | 0, f = _A - ((B >>> 0 > y >>> 0) + qA | 0) | 0, I = kA((33554431 & (B = I)) << 7 | C >>> 25, I >>= 25, 19, 0), C = h + f | 0, I = I >>> 0 > (B = I + Q | 0) >>> 0 ? C + 1 | 0 : C, I = ((67108863 & (I = (C = B + 33554432 | 0) >>> 0 < 33554432 ? I + 1 | 0 : I)) << 6 | C >>> 26) + i | 0, o[g + 52 >> 2] = I, o[g + 48 >> 2] = B - (-67108864 & C), IA(A, g + 48 | 0));
                                            }
                                            return w = g + 256 | 0, 0 | vA;
                                        },
                                        Yb: function(A, I) {
                                            A |= 0;
                                            var g, C = 0;
                                            return w = g = w + -64 | 0, aA(g, I |= 0, 32, 0), E[0 | g] = 248 & a[0 | g], E[g + 31 | 0] = 63 & a[g + 31 | 0] | 64, I = o[g + 20 >> 2], C = o[g + 16 >> 2], E[A + 16 | 0] = C, E[A + 17 | 0] = C >>> 8, E[A + 18 | 0] = C >>> 16, E[A + 19 | 0] = C >>> 24, E[A + 20 | 0] = I, E[A + 21 | 0] = I >>> 8, E[A + 22 | 0] = I >>> 16, E[A + 23 | 0] = I >>> 24, I = o[g + 12 >> 2], C = o[g + 8 >> 2], E[A + 8 | 0] = C, E[A + 9 | 0] = C >>> 8, E[A + 10 | 0] = C >>> 16, E[A + 11 | 0] = C >>> 24, E[A + 12 | 0] = I, E[A + 13 | 0] = I >>> 8, E[A + 14 | 0] = I >>> 16, E[A + 15 | 0] = I >>> 24, I = o[g + 4 >> 2], C = o[g >> 2], E[0 | A] = C, E[A + 1 | 0] = C >>> 8, E[A + 2 | 0] = C >>> 16, E[A + 3 | 0] = C >>> 24, E[A + 4 | 0] = I, E[A + 5 | 0] = I >>> 8, E[A + 6 | 0] = I >>> 16, E[A + 7 | 0] = I >>> 24, I = o[g + 28 >> 2], C = o[g + 24 >> 2], E[A + 24 | 0] = C, E[A + 25 | 0] = C >>> 8, E[A + 26 | 0] = C >>> 16, E[A + 27 | 0] = C >>> 24, E[A + 28 | 0] = I, E[A + 29 | 0] = I >>> 8, E[A + 30 | 0] = I >>> 16, E[A + 31 | 0] = I >>> 24, iI(g, 64), w = g - -64 | 0, 0;
                                        },
                                        Zb: function() {
                                            var A, I;
                                            return w = A = w - 16 | 0, E[A + 15 | 0] = 0, I = 0 | r(35256, A + 15 | 0, 0), w = A + 16 | 0, 0 | I;
                                        },
                                        _b: mA,
                                        $b: function(A) {
                                            var I, g = 0, C = 0;
                                            if (w = I = w - 16 | 0, (A |= 0) >>> 0 >= 2) {
                                                for(g = (0 - A >>> 0) % (A >>> 0) | 0; E[I + 15 | 0] = 0, g >>> 0 > (C = 0 | r(35256, I + 15 | 0, 0)) >>> 0;);
                                                g = (C >>> 0) % (A >>> 0) | 0;
                                            }
                                            return w = I + 16 | 0, 0 | g;
                                        },
                                        ac: HA,
                                        bc: function(A, I, g) {
                                            ZA(A |= 0, I |= 0, 1024, g |= 0);
                                        },
                                        cc: aI,
                                        dc: function() {
                                            var A = 0, I = 0;
                                            return (A = o[9004]) && (A = o[A + 20 >> 2]) && (I = 0 | wI[0 | A]()), 0 | I;
                                        },
                                        ec: function(A, I, g) {
                                            A |= 0, I |= 0;
                                            var C, B = 0, i = 0, o = 0;
                                            if (w = C = w - 16 | 0, g |= 0) D(1240, 1100, 197, 1036), Q();
                                            else {
                                                if (I) for(; E[C + 15 | 0] = 0, i = A + B | 0, o = 0 | r(35256, C + 15 | 0, 0), E[0 | i] = o, (0 | I) != (0 | (B = B + 1 | 0)););
                                                w = C + 16 | 0;
                                            }
                                        },
                                        fc: function(A, I, g, C) {
                                            A |= 0, g |= 0;
                                            var B = 0, i = 0, o = 0;
                                            if (!((C |= 0) >>> 0 > 2147483646 | C << 1 >>> 0 >= (I |= 0) >>> 0)) {
                                                if (I = 0, C) {
                                                    for(; B = (I << 1) + A | 0, i = 15 & (o = a[I + g | 0]), E[B + 1 | 0] = 22272 + ((i << 8) + (i + 65526 & 55552) | 0) >>> 8, i = B, B = o >>> 4 | 0, E[0 | i] = 87 + ((B + 65526 >>> 8 & 217) + B | 0), (0 | C) != (0 | (I = I + 1 | 0)););
                                                    I = C << 1;
                                                } else I = 0;
                                                return E[I + A | 0] = 0, 0 | A;
                                            }
                                            zA(), Q();
                                        },
                                        gc: function(A, I, g, C, B, Q, i) {
                                            A |= 0, I |= 0, g |= 0, B |= 0, Q |= 0, i |= 0;
                                            var f = 0, c = 0, e = 0, r = 0, D = 0, t = 0, y = 0, w = 0, h = 0, n = 0;
                                            A: if (C |= 0) {
                                                I: {
                                                    g: {
                                                        C: {
                                                            B: {
                                                                if (!B) {
                                                                    for(c = 1, B = 0;;){
                                                                        if (!(255 & ((y = (65526 + (e = (223 & (D = a[g + f | 0])) - 55 & 255) ^ e + 65520) >>> 8 | 0) | (w = 65526 + (D ^= 48) >>> 8 | 0)))) break C;
                                                                        if (I >>> 0 <= t >>> 0) break B;
                                                                        if (e = e & y | D & w, 255 & r ? (E[A + t | 0] = B | e, t = t + 1 | 0) : B = e << 4, r ^= -1, (0 | (f = f + 1 | 0)) == (0 | C)) break;
                                                                    }
                                                                    f = C;
                                                                    break C;
                                                                }
                                                                for(;;){
                                                                    Q: {
                                                                        i: {
                                                                            E: {
                                                                                o: {
                                                                                    a: {
                                                                                        if (!(255 & ((D = (65526 + (e = (223 & (c = a[g + f | 0])) - 55 & 255) ^ e + 65520) >>> 8 | 0) | (w = 65526 + (y = 48 ^ c) >>> 8 | 0)))) {
                                                                                            if (255 & r) break g;
                                                                                            if (!BA(B, c)) break A;
                                                                                            if ((f = r = f + 1 | 0) >>> 0 < C >>> 0) break a;
                                                                                            break A;
                                                                                        }
                                                                                        if (I >>> 0 <= t >>> 0) break B;
                                                                                        if (c = e & D | y & w, !(255 & r)) break o;
                                                                                        E[A + t | 0] = c | n, t = t + 1 | 0;
                                                                                        break Q;
                                                                                    }
                                                                                    for(;;){
                                                                                        if (!(255 & ((D = (65526 + (e = (223 & (c = a[g + f | 0])) - 55 & 255) ^ e + 65520) >>> 8 | 0) | (w = 65526 + (y = 48 ^ c) >>> 8 | 0)))) {
                                                                                            if (!BA(B, c)) break A;
                                                                                            if ((f = f + 1 | 0) >>> 0 < C >>> 0) continue;
                                                                                            break E;
                                                                                        }
                                                                                        break;
                                                                                    }
                                                                                    if (I >>> 0 <= t >>> 0) break i;
                                                                                    c = e & D | y & w;
                                                                                }
                                                                                n = c << 4, r = 0;
                                                                                break Q;
                                                                            }
                                                                            f = C >>> 0 > r >>> 0 ? C : r;
                                                                            break A;
                                                                        }
                                                                        r = 0;
                                                                        break B;
                                                                    }
                                                                    if (r ^= -1, c = 1, !((f = f + 1 | 0) >>> 0 < C >>> 0)) break;
                                                                }
                                                                break C;
                                                            }
                                                            o[9005] = 68, c = 0;
                                                        }
                                                        if (!(255 & r)) break I;
                                                    }
                                                    o[9005] = 28, h = -1, f = f - 1 | 0, t = 0;
                                                    break A;
                                                }
                                                c || (t = 0, h = -1);
                                            }
                                            return i ? o[i >> 2] = g + f : (0 | C) != (0 | f) && (o[9005] = 28, h = -1), Q && (o[Q >> 2] = t), 0 | h;
                                        },
                                        hc: function(A, I) {
                                            A |= 0;
                                            var g = 0;
                                            return 1 != (-7 & (I |= 0)) && (zA(), Q()), 1 + ((3 & (g = (g = A) + c(A = (A >>> 0) / 3 | 0, -3) | 0) ? 2 & I ? g + 1 | 0 : 4 : 0) + (A << 2) | 0) | 0;
                                        },
                                        ic: function(A, I, g, C, B) {
                                            A |= 0, I |= 0, g |= 0, C |= 0;
                                            var i = 0, o = 0, f = 0, e = 0, r = 0, t = 0, y = 0, w = 0, h = 0, n = 0;
                                            A: {
                                                I: {
                                                    g: {
                                                        C: {
                                                            B: {
                                                                Q: {
                                                                    i: {
                                                                        if (1 == (-7 & (B |= 0)) && (r = (o = (C >>> 0) / 3 | 0) << 2, (o = c(o, -3) + C | 0) && (r = 2 & B ? (2 | r) + (o >>> 1 | 0) | 0 : r + 4 | 0), !(I >>> 0 <= r >>> 0))) {
                                                                            if (!(4 & B)) {
                                                                                if (!C) {
                                                                                    B = 0;
                                                                                    break C;
                                                                                }
                                                                                B = 0;
                                                                                break i;
                                                                            }
                                                                            if (!C) {
                                                                                B = 0;
                                                                                break C;
                                                                            }
                                                                            for(B = 0;;){
                                                                                for(y = (w = a[g + t | 0]) | y << 8, o = B, B = 1 + ((((e |= 8) - 6 >>> 0) / 6 | 0) + B | 0) | 0; h = 65510 + (f = y >>> (e = (i = e) - 6 | 0) & 63) >>> 8 | 0, n = f + 65484 >>> 8 | 0, E[A + o | 0] = (1 + (16321 ^ f) ^ -1) >>> 8 & 45 | f + 252 & f + 65474 >>> 8 & (-1 ^ n) | (f + 32705 ^ -1) >>> 8 & 95 | h & f + 65 | n & f + 71 & (-1 ^ h), (0 | (o = o + 1 | 0)) != (0 | B););
                                                                                if ((0 | (t = t + 1 | 0)) == (0 | C)) break;
                                                                            }
                                                                            if (!e) break B;
                                                                            o = (C = 65510 + (i = w << 12 - i & 63) >>> 8 | 0) & i + 65, e = i + 252 & i + 65474 >>> 8 & (-1 ^ (g = i + 65484 >>> 8 | 0)), C = g & i + 71 & (-1 ^ C), t = i + 32705 | 0, y = 95, g = (1 + (16321 ^ i) ^ -1) >>> 8 & 45;
                                                                            break Q;
                                                                        }
                                                                        zA(), Q();
                                                                    }
                                                                    for(;;){
                                                                        for(y = (w = a[g + t | 0]) | y << 8, o = B, B = 1 + ((((e |= 8) - 6 >>> 0) / 6 | 0) + B | 0) | 0; h = 65510 + (f = y >>> (e = (i = e) - 6 | 0) & 63) >>> 8 | 0, n = f + 65484 >>> 8 | 0, E[A + o | 0] = (1 + (16321 ^ f) ^ -1) >>> 8 & 43 | f + 252 & f + 65474 >>> 8 & (-1 ^ n) | (f + 16321 ^ -1) >>> 8 & 47 | h & f + 65 | n & f + 71 & (-1 ^ h), (0 | (o = o + 1 | 0)) != (0 | B););
                                                                        if ((0 | (t = t + 1 | 0)) == (0 | C)) break;
                                                                    }
                                                                    if (!e) break B;
                                                                    o = (C = 65510 + (i = w << 12 - i & 63) >>> 8 | 0) & i + 65, e = i + 252 & i + 65474 >>> 8 & (-1 ^ (g = i + 65484 >>> 8 | 0)), C = g & i + 71 & (-1 ^ C), t = i + 16321 | 0, y = 47, g = (1 + (16321 ^ i) ^ -1) >>> 8 & 43;
                                                                }
                                                                E[A + B | 0] = g | (-1 ^ t) >>> 8 & y | o | e | C, B = B + 1 | 0;
                                                            }
                                                            if (B >>> 0 > r >>> 0) break g;
                                                        }
                                                        if (B >>> 0 < r >>> 0) break I;
                                                        r = B;
                                                        break A;
                                                    }
                                                    D(1048, 1126, 231, 1319), Q();
                                                }
                                                dA(A + B | 0, 61, r - B | 0);
                                            }
                                            return dA(A + r | 0, 0, (I >>> 0 > (g = r + 1 | 0) >>> 0 ? I : g) - r | 0), 0 | A;
                                        },
                                        jc: function(A, I, g, C, B, i, f, c) {
                                            A |= 0, I |= 0, g |= 0, C |= 0, B |= 0, i |= 0, f |= 0;
                                            var e = 0, r = 0, D = 0, t = 0, y = 0, w = 0, h = 0, n = 0;
                                            A: {
                                                I: {
                                                    g: {
                                                        C: {
                                                            B: {
                                                                Q: {
                                                                    i: {
                                                                        E: {
                                                                            o: {
                                                                                a: {
                                                                                    f: {
                                                                                        if (1 == (-7 & (c |= 0))) {
                                                                                            if (D = 0, !C) break E;
                                                                                            if (4 & c) break f;
                                                                                            for(;;){
                                                                                                D = r;
                                                                                                c: {
                                                                                                    e: {
                                                                                                        r: {
                                                                                                            D: {
                                                                                                                for(;;){
                                                                                                                    if (e = (e = (t = E[g + D | 0]) - 65 | 0) & ((90 - t ^ -1) & (-1 ^ e)) >>> 8 & 255 | t + 4 & ((t + 65488 ^ -1) & (57 - t ^ -1)) >>> 8 & 255 | t + 185 & ((t + 65439 ^ -1) & (122 - t ^ -1)) >>> 8 & 255 | (1 + (16336 ^ t) ^ -1) >>> 8 & 63 | (1 + (16340 ^ t) ^ -1) >>> 8 & 62, 255 != (0 | (e |= (e - 1 & 1 + (65470 ^ t)) >>> 8 & 255))) break D;
                                                                                                                    if (e = 0, !B) break o;
                                                                                                                    if (!BA(B, t)) break;
                                                                                                                    if ((D = D + 1 | 0) >>> 0 >= C >>> 0) break r;
                                                                                                                }
                                                                                                                r = D;
                                                                                                                break o;
                                                                                                            }
                                                                                                            if (h = e + (h << 6) | 0, y >>> 0 > 1) break e;
                                                                                                            y = y + 6 | 0;
                                                                                                            break c;
                                                                                                        }
                                                                                                        r = (A = r + 1 | 0) >>> 0 < C >>> 0 ? C : A;
                                                                                                        break o;
                                                                                                    }
                                                                                                    if (y = y - 2 | 0, I >>> 0 <= w >>> 0) break a;
                                                                                                    E[A + w | 0] = h >>> y, w = w + 1 | 0;
                                                                                                }
                                                                                                if (e = 0, !((r = D + 1 | 0) >>> 0 < C >>> 0)) break;
                                                                                            }
                                                                                            break o;
                                                                                        }
                                                                                        zA(), Q();
                                                                                    }
                                                                                    f: for(;;){
                                                                                        for(D = r;;){
                                                                                            c: {
                                                                                                if (e = (e = (t = E[g + D | 0]) - 65 | 0) & ((90 - t ^ -1) & (-1 ^ e)) >>> 8 & 255 | t + 4 & ((t + 65488 ^ -1) & (57 - t ^ -1)) >>> 8 & 255 | t + 185 & ((t + 65439 ^ -1) & (122 - t ^ -1)) >>> 8 & 255 | (1 + (16288 ^ t) ^ -1) >>> 8 & 63 | (1 + (16338 ^ t) ^ -1) >>> 8 & 62, 255 == (0 | (e |= (e - 1 & 1 + (65470 ^ t)) >>> 8 & 255))) {
                                                                                                    if (e = 0, !B) break o;
                                                                                                    if (BA(B, t)) break c;
                                                                                                    r = D;
                                                                                                    break o;
                                                                                                }
                                                                                                if (h = e + (h << 6) | 0, y >>> 0 < 2) y = y + 6 | 0;
                                                                                                else {
                                                                                                    if (y = y - 2 | 0, I >>> 0 <= w >>> 0) break a;
                                                                                                    E[A + w | 0] = h >>> y, w = w + 1 | 0;
                                                                                                }
                                                                                                if (e = 0, (r = D + 1 | 0) >>> 0 < C >>> 0) continue f;
                                                                                                break o;
                                                                                            }
                                                                                            if (!((D = D + 1 | 0) >>> 0 < C >>> 0)) break;
                                                                                        }
                                                                                        break;
                                                                                    }
                                                                                    r = (A = r + 1 | 0) >>> 0 < C >>> 0 ? C : A;
                                                                                    break o;
                                                                                }
                                                                                r = D, o[9005] = 68, e = 1;
                                                                            }
                                                                            if (y >>> 0 > 4) break i;
                                                                            D = r;
                                                                        }
                                                                        if (A = D, I = -1, e) {
                                                                            r = A;
                                                                            break A;
                                                                        }
                                                                        if ((-1 << y ^ -1) & h) {
                                                                            r = A;
                                                                            break A;
                                                                        }
                                                                        if (2 & c) {
                                                                            c = A;
                                                                            break B;
                                                                        }
                                                                        if (y >>> 0 < 2) {
                                                                            c = A;
                                                                            break B;
                                                                        }
                                                                        if (r = A >>> 0 > C >>> 0 ? A : C, D = y >>> 1 | 0, !B) break Q;
                                                                        for(c = A;;){
                                                                            if ((0 | c) == (0 | r)) {
                                                                                e = 68;
                                                                                break C;
                                                                            }
                                                                            if (61 != (0 | (A = E[g + c | 0]))) {
                                                                                if (!BA(B, A)) {
                                                                                    e = 28, r = c;
                                                                                    break C;
                                                                                }
                                                                            } else D = D - 1 | 0;
                                                                            if (c = c + 1 | 0, !D) break;
                                                                        }
                                                                        break B;
                                                                    }
                                                                    I = -1;
                                                                    break A;
                                                                }
                                                                if (e = 68, A >>> 0 >= C >>> 0) break C;
                                                                if (61 != a[A + g | 0]) {
                                                                    r = A, e = 28;
                                                                    break C;
                                                                }
                                                                if (c = A + D | 0, 1 != (0 | D)) {
                                                                    if ((0 | (y = A + 1 | 0)) == (0 | r)) break C;
                                                                    if (61 != a[g + y | 0]) {
                                                                        r = y, e = 28;
                                                                        break C;
                                                                    }
                                                                    if (2 != (0 | D)) {
                                                                        if ((0 | (A = A + 2 | 0)) == (0 | r)) break C;
                                                                        if (e = 28, r = A, 61 != a[A + g | 0]) break C;
                                                                    }
                                                                }
                                                            }
                                                            if (I = 0, B) break g;
                                                            break I;
                                                        }
                                                        o[9005] = e;
                                                        break A;
                                                    }
                                                    if (!(C >>> 0 <= c >>> 0)) {
                                                        for(;;){
                                                            if (!BA(B, E[g + c | 0])) break I;
                                                            if ((0 | (c = c + 1 | 0)) == (0 | C)) break;
                                                        }
                                                        c = C;
                                                    }
                                                }
                                                r = c, n = w;
                                            }
                                            return f ? o[f >> 2] = g + r : (0 | C) != (0 | r) && (o[9005] = 28, I = -1), i && (o[i >> 2] = n), 0 | I;
                                        },
                                        kc: function() {
                                            var A = 0;
                                            return o[9136] ? A = 1 : (mA(), HA(36528, 16), o[9136] = 1, A = 0), 0 | A;
                                        },
                                        lc: function(A, I, g, C, B) {
                                            A |= 0, I |= 0, g |= 0, B |= 0;
                                            var i, f = 0, c = 0, e = 0;
                                            w = i = w - 16 | 0;
                                            A: {
                                                if (C |= 0) {
                                                    if ((f = C - 1 | 0) & C ? (c = -1 ^ g, f = f - ((g >>> 0) % (C >>> 0) | 0) | 0) : f &= c = -1 ^ g, c >>> 0 <= f >>> 0) break A;
                                                    if (c = -1, !((g = g + f | 0) >>> 0 >= B >>> 0)) for(A && (o[A >> 2] = g + 1), A = I + g | 0, c = 0, E[i + 15 | 0] = 0, g = 0; B = I = A - g | 0, e = a[0 | I] & a[i + 15 | 0], I = (g ^ f) - 1 >>> 24 | 0, E[0 | B] = e | 128 & I, E[i + 15 | 0] = I | a[i + 15 | 0], (0 | C) != (0 | (g = g + 1 | 0)););
                                                } else c = -1;
                                                return w = i + 16 | 0, 0 | c;
                                            }
                                            zA(), Q();
                                        },
                                        mc: function(A, I, g, C) {
                                            A |= 0, I |= 0, g |= 0, C |= 0;
                                            var B, Q = 0, i = 0, E = 0, f = 0, c = 0;
                                            if (o[12 + (B = w - 16 | 0) >> 2] = 0, C - 1 >>> 0 < g >>> 0) {
                                                for(c = (Q = g - 1 | 0) + I | 0, g = 0, I = 0; f = ((128 ^ (i = a[c - g | 0])) - 1 & o[B + 12 >> 2] - 1 & E - 1) >>> 8 & 1, o[B + 12 >> 2] = o[B + 12 >> 2] | 0 - f & g, I |= f, E |= i, (0 | C) != (0 | (g = g + 1 | 0)););
                                                o[A >> 2] = Q - o[B + 12 >> 2], A = (255 & I) - 1 | 0;
                                            } else A = -1;
                                            return 0 | A;
                                        },
                                        nc: function() {
                                            return 1312;
                                        },
                                        oc: function() {
                                            return 26;
                                        },
                                        pc: rI,
                                        qc: rI,
                                        rc: function(A) {
                                            var I, g = 0, C = 0, B = 0, Q = 0, i = 0, E = 0, c = 0, r = 0, D = 0, t = 0, y = 0, h = 0;
                                            w = I = w - 16 | 0;
                                            A: {
                                                I: {
                                                    g: {
                                                        C: {
                                                            B: {
                                                                Q: {
                                                                    i: {
                                                                        E: {
                                                                            o: {
                                                                                a: {
                                                                                    f: {
                                                                                        c: {
                                                                                            e: {
                                                                                                r: {
                                                                                                    if ((A |= 0) >>> 0 <= 244) {
                                                                                                        if (3 & (g = (E = o[9006]) >>> (C = (c = A >>> 0 < 11 ? 16 : A + 11 & -8) >>> 3 | 0) | 0)) {
                                                                                                            g = 36064 + (A = (C = C + (1 & (-1 ^ g)) | 0) << 3) | 0, B = o[A + 36072 >> 2], (0 | g) != (0 | (A = o[B + 8 >> 2])) ? (o[A + 12 >> 2] = g, o[g + 8 >> 2] = A) : (y = 36024, h = RA(-2, C) & E, o[y >> 2] = h), A = B + 8 | 0, g = C << 3, o[B + 4 >> 2] = 3 | g, o[4 + (g = g + B | 0) >> 2] = 1 | o[g + 4 >> 2];
                                                                                                            break A;
                                                                                                        }
                                                                                                        if ((t = o[9008]) >>> 0 >= c >>> 0) break r;
                                                                                                        if (g) {
                                                                                                            g = 36064 + (A = (B = TA((0 - (A = 2 << C) | A) & g << C)) << 3) | 0, Q = o[A + 36072 >> 2], (0 | g) != (0 | (A = o[Q + 8 >> 2])) ? (o[A + 12 >> 2] = g, o[g + 8 >> 2] = A) : (E = RA(-2, B) & E, o[9006] = E), o[Q + 4 >> 2] = 3 | c, B = (A = B << 3) - c | 0, o[4 + (C = Q + c | 0) >> 2] = 1 | B, o[A + Q >> 2] = B, t && (g = 36064 + (-8 & t) | 0, i = o[9011], (A = 1 << (t >>> 3)) & E ? A = o[g + 8 >> 2] : (o[9006] = A | E, A = g), o[g + 8 >> 2] = i, o[A + 12 >> 2] = i, o[i + 12 >> 2] = g, o[i + 8 >> 2] = A), A = Q + 8 | 0, o[9011] = C, o[9008] = B;
                                                                                                            break A;
                                                                                                        }
                                                                                                        if (!(D = o[9007])) break r;
                                                                                                        for(C = o[36328 + (TA(D) << 2) >> 2], i = (-8 & o[C + 4 >> 2]) - c | 0, g = C; (A = o[g + 16 >> 2]) || (A = o[g + 20 >> 2]);)i = (B = (g = (-8 & o[A + 4 >> 2]) - c | 0) >>> 0 < i >>> 0) ? g : i, C = B ? A : C, g = A;
                                                                                                        if (r = o[C + 24 >> 2], (0 | (B = o[C + 12 >> 2])) != (0 | C)) {
                                                                                                            A = o[C + 8 >> 2], o[A + 12 >> 2] = B, o[B + 8 >> 2] = A;
                                                                                                            break I;
                                                                                                        }
                                                                                                        if (!(A = o[(g = C + 20 | 0) >> 2])) {
                                                                                                            if (!(A = o[C + 16 >> 2])) break e;
                                                                                                            g = C + 16 | 0;
                                                                                                        }
                                                                                                        for(; Q = g, B = A, (A = o[(g = A + 20 | 0) >> 2]) || (g = B + 16 | 0, A = o[B + 16 >> 2]););
                                                                                                        o[Q >> 2] = 0;
                                                                                                        break I;
                                                                                                    }
                                                                                                    if (c = -1, !(A >>> 0 > 4294967231) && (c = -8 & (A = A + 11 | 0), D = o[9007])) {
                                                                                                        i = 0 - c | 0, E = 0, c >>> 0 < 256 || (E = 31, c >>> 0 > 16777215 || (E = 62 + ((c >>> 38 - (A = e(A >>> 8 | 0)) & 1) - (A << 1) | 0) | 0));
                                                                                                        D: {
                                                                                                            t: {
                                                                                                                if (g = o[36328 + (E << 2) >> 2]) for(A = 0, C = c << (31 != (0 | E) ? 25 - (E >>> 1 | 0) | 0 : 0);;){
                                                                                                                    if (!((Q = (-8 & o[g + 4 >> 2]) - c | 0) >>> 0 >= i >>> 0 || (B = g, i = Q, Q))) {
                                                                                                                        i = 0, A = g;
                                                                                                                        break t;
                                                                                                                    }
                                                                                                                    if (Q = o[g + 20 >> 2], g = o[16 + ((C >>> 29 & 4) + g | 0) >> 2], A = Q ? (0 | Q) == (0 | g) ? A : Q : A, C <<= 1, !g) break;
                                                                                                                }
                                                                                                                else A = 0;
                                                                                                                if (!(A | B)) {
                                                                                                                    if (B = 0, !(A = (0 - (A = 2 << E) | A) & D)) break r;
                                                                                                                    A = o[36328 + (TA(A) << 2) >> 2];
                                                                                                                }
                                                                                                                if (!A) break D;
                                                                                                            }
                                                                                                            for(; i = (C = (g = (-8 & o[A + 4 >> 2]) - c | 0) >>> 0 < i >>> 0) ? g : i, B = C ? A : B, A = (g = o[A + 16 >> 2]) || o[A + 20 >> 2];);
                                                                                                        }
                                                                                                        if (!(!B | o[9008] - c >>> 0 <= i >>> 0)) {
                                                                                                            if (E = o[B + 24 >> 2], (0 | B) != (0 | (C = o[B + 12 >> 2]))) {
                                                                                                                A = o[B + 8 >> 2], o[A + 12 >> 2] = C, o[C + 8 >> 2] = A;
                                                                                                                break g;
                                                                                                            }
                                                                                                            if (!(A = o[(g = B + 20 | 0) >> 2])) {
                                                                                                                if (!(A = o[B + 16 >> 2])) break c;
                                                                                                                g = B + 16 | 0;
                                                                                                            }
                                                                                                            for(; Q = g, C = A, (A = o[(g = A + 20 | 0) >> 2]) || (g = C + 16 | 0, A = o[C + 16 >> 2]););
                                                                                                            o[Q >> 2] = 0;
                                                                                                            break g;
                                                                                                        }
                                                                                                    }
                                                                                                }
                                                                                                if ((A = o[9008]) >>> 0 >= c >>> 0) {
                                                                                                    B = o[9011], (g = A - c | 0) >>> 0 >= 16 ? (o[4 + (C = B + c | 0) >> 2] = 1 | g, o[A + B >> 2] = g, o[B + 4 >> 2] = 3 | c) : (o[B + 4 >> 2] = 3 | A, o[4 + (A = A + B | 0) >> 2] = 1 | o[A + 4 >> 2], C = 0, g = 0), o[9008] = g, o[9011] = C, A = B + 8 | 0;
                                                                                                    break A;
                                                                                                }
                                                                                                if ((r = o[9009]) >>> 0 > c >>> 0) {
                                                                                                    g = r - c | 0, o[9009] = g, A = (C = o[9012]) + c | 0, o[9012] = A, o[A + 4 >> 2] = 1 | g, o[C + 4 >> 2] = 3 | c, A = C + 8 | 0;
                                                                                                    break A;
                                                                                                }
                                                                                                if (A = 0, D = c + 47 | 0, o[9124] ? C = o[9126] : (o[9127] = -1, o[9128] = -1, o[9125] = 4096, o[9126] = 4096, o[9124] = I + 12 & -16 ^ 1431655768, o[9129] = 0, o[9117] = 0, C = 4096), (g = (Q = D + C | 0) & (i = 0 - C | 0)) >>> 0 <= c >>> 0) break A;
                                                                                                if ((B = o[9116]) && B >>> 0 < (E = (C = o[9114]) + g | 0) >>> 0 | C >>> 0 >= E >>> 0) break A;
                                                                                                r: {
                                                                                                    if (!(4 & a[36468])) {
                                                                                                        D: {
                                                                                                            t: {
                                                                                                                y: {
                                                                                                                    w: {
                                                                                                                        if (B = o[9012]) for(A = 36472;;){
                                                                                                                            if ((C = o[A >> 2]) >>> 0 <= B >>> 0 & B >>> 0 < C + o[A + 4 >> 2] >>> 0) break w;
                                                                                                                            if (!(A = o[A + 8 >> 2])) break;
                                                                                                                        }
                                                                                                                        if (-1 == (0 | (C = _A(0)))) break D;
                                                                                                                        if (E = g, (A = (B = o[9125]) - 1 | 0) & C && (E = (g - C | 0) + (A + C & 0 - B) | 0), E >>> 0 <= c >>> 0) break D;
                                                                                                                        if ((B = o[9116]) && B >>> 0 < (i = (A = o[9114]) + E | 0) >>> 0 | A >>> 0 >= i >>> 0) break D;
                                                                                                                        if ((0 | C) != (0 | (A = _A(E)))) break y;
                                                                                                                        break r;
                                                                                                                    }
                                                                                                                    if ((0 | (C = _A(E = i & Q - r))) == (o[A >> 2] + o[A + 4 >> 2] | 0)) break t;
                                                                                                                    A = C;
                                                                                                                }
                                                                                                                if (-1 == (0 | A)) break D;
                                                                                                                if (c + 48 >>> 0 <= E >>> 0) {
                                                                                                                    C = A;
                                                                                                                    break r;
                                                                                                                }
                                                                                                                if (-1 == (0 | _A(C = (C = o[9126]) + (D - E | 0) & 0 - C))) break D;
                                                                                                                E = C + E | 0, C = A;
                                                                                                                break r;
                                                                                                            }
                                                                                                            if (-1 != (0 | C)) break r;
                                                                                                        }
                                                                                                        o[9117] = 4 | o[9117];
                                                                                                    }
                                                                                                    if (-1 == (0 | (C = _A(g))) | -1 == (0 | (A = _A(0))) | A >>> 0 <= C >>> 0) break o;
                                                                                                    if ((E = A - C | 0) >>> 0 <= c + 40 >>> 0) break o;
                                                                                                }
                                                                                                A = o[9114] + E | 0, o[9114] = A, A >>> 0 > f[9115] && (o[9115] = A);
                                                                                                r: {
                                                                                                    if (Q = o[9012]) {
                                                                                                        for(A = 36472;;){
                                                                                                            if (((B = o[A >> 2]) + (g = o[A + 4 >> 2]) | 0) == (0 | C)) break r;
                                                                                                            if (!(A = o[A + 8 >> 2])) break;
                                                                                                        }
                                                                                                        break f;
                                                                                                    }
                                                                                                    for((A = o[9010]) >>> 0 <= C >>> 0 && A || (o[9010] = C), A = 0, o[9119] = E, o[9118] = C, o[9014] = -1, o[9015] = o[9124], o[9121] = 0; g = 36064 + (B = A << 3) | 0, o[B + 36072 >> 2] = g, o[B + 36076 >> 2] = g, 32 != (0 | (A = A + 1 | 0)););
                                                                                                    g = (B = E - 40 | 0) - (A = -8 - C & 7) | 0, o[9009] = g, A = A + C | 0, o[9012] = A, o[A + 4 >> 2] = 1 | g, o[4 + (C + B | 0) >> 2] = 40, o[9013] = o[9128];
                                                                                                    break a;
                                                                                                }
                                                                                                if (8 & o[A + 12 >> 2] | C >>> 0 <= Q >>> 0 | B >>> 0 > Q >>> 0) break f;
                                                                                                o[A + 4 >> 2] = g + E, C = (A = -8 - Q & 7) + Q | 0, o[9012] = C, A = (g = o[9009] + E | 0) - A | 0, o[9009] = A, o[C + 4 >> 2] = 1 | A, o[4 + (g + Q | 0) >> 2] = 40, o[9013] = o[9128];
                                                                                                break a;
                                                                                            }
                                                                                            B = 0;
                                                                                            break I;
                                                                                        }
                                                                                        C = 0;
                                                                                        break g;
                                                                                    }
                                                                                    f[9010] > C >>> 0 && (o[9010] = C), g = C + E | 0, A = 36472;
                                                                                    f: {
                                                                                        c: {
                                                                                            e: {
                                                                                                for(;;){
                                                                                                    if ((0 | g) != o[A >> 2]) {
                                                                                                        if (A = o[A + 8 >> 2]) continue;
                                                                                                        break e;
                                                                                                    }
                                                                                                    break;
                                                                                                }
                                                                                                if (!(8 & a[A + 12 | 0])) break c;
                                                                                            }
                                                                                            for(A = 36472;;){
                                                                                                if ((g = o[A >> 2]) >>> 0 <= Q >>> 0 && (i = g + o[A + 4 >> 2] | 0) >>> 0 > Q >>> 0) break f;
                                                                                                A = o[A + 8 >> 2];
                                                                                            }
                                                                                        }
                                                                                        if (o[A >> 2] = C, o[A + 4 >> 2] = o[A + 4 >> 2] + E, o[4 + (D = (-8 - C & 7) + C | 0) >> 2] = 3 | c, A = (E = g + (-8 - g & 7) | 0) - (r = c + D | 0) | 0, (0 | Q) == (0 | E)) {
                                                                                            o[9012] = r, A = o[9009] + A | 0, o[9009] = A, o[r + 4 >> 2] = 1 | A;
                                                                                            break C;
                                                                                        }
                                                                                        if (o[9011] == (0 | E)) {
                                                                                            o[9011] = r, A = o[9008] + A | 0, o[9008] = A, o[r + 4 >> 2] = 1 | A, o[A + r >> 2] = A;
                                                                                            break C;
                                                                                        }
                                                                                        if (1 != (3 & (i = o[E + 4 >> 2]))) break B;
                                                                                        if (Q = -8 & i, i >>> 0 <= 255) {
                                                                                            if ((0 | (C = o[E + 12 >> 2])) == (0 | (g = o[E + 8 >> 2]))) {
                                                                                                y = 36024, h = o[9006] & RA(-2, i >>> 3 | 0), o[y >> 2] = h;
                                                                                                break Q;
                                                                                            }
                                                                                            o[g + 12 >> 2] = C, o[C + 8 >> 2] = g;
                                                                                            break Q;
                                                                                        }
                                                                                        if (c = o[E + 24 >> 2], (0 | E) != (0 | (C = o[E + 12 >> 2]))) {
                                                                                            g = o[E + 8 >> 2], o[g + 12 >> 2] = C, o[C + 8 >> 2] = g;
                                                                                            break i;
                                                                                        }
                                                                                        if (!(i = o[(g = E + 20 | 0) >> 2])) {
                                                                                            if (!(i = o[E + 16 >> 2])) break E;
                                                                                            g = E + 16 | 0;
                                                                                        }
                                                                                        for(; B = g, (i = o[(g = (C = i) + 20 | 0) >> 2]) || (g = C + 16 | 0, i = o[C + 16 >> 2]););
                                                                                        o[B >> 2] = 0;
                                                                                        break i;
                                                                                    }
                                                                                    for(g = (B = E - 40 | 0) - (A = -8 - C & 7) | 0, o[9009] = g, A = A + C | 0, o[9012] = A, o[A + 4 >> 2] = 1 | g, o[4 + (C + B | 0) >> 2] = 40, o[9013] = o[9128], o[(B = (A = (i + (39 - i & 7) | 0) - 47 | 0) >>> 0 < Q + 16 >>> 0 ? Q : A) + 4 >> 2] = 27, A = o[9121], o[B + 16 >> 2] = o[9120], o[B + 20 >> 2] = A, A = o[9119], o[B + 8 >> 2] = o[9118], o[B + 12 >> 2] = A, o[9120] = B + 8, o[9119] = E, o[9118] = C, o[9121] = 0, A = B + 24 | 0; o[A + 4 >> 2] = 7, g = A + 8 | 0, A = A + 4 | 0, g >>> 0 < i >>> 0;);
                                                                                    if ((0 | B) != (0 | Q)) {
                                                                                        if (o[B + 4 >> 2] = -2 & o[B + 4 >> 2], i = B - Q | 0, o[Q + 4 >> 2] = 1 | i, o[B >> 2] = i, i >>> 0 <= 255) g = 36064 + (-8 & i) | 0, (C = o[9006]) & (A = 1 << (i >>> 3)) ? A = o[g + 8 >> 2] : (o[9006] = A | C, A = g), o[g + 8 >> 2] = Q, o[A + 12 >> 2] = Q, o[Q + 12 >> 2] = g, o[Q + 8 >> 2] = A;
                                                                                        else {
                                                                                            A = 31, i >>> 0 <= 16777215 && (A = 62 + ((i >>> 38 - (A = e(i >>> 8 | 0)) & 1) - (A << 1) | 0) | 0), o[Q + 28 >> 2] = A, o[Q + 16 >> 2] = 0, o[Q + 20 >> 2] = 0, g = 36328 + (A << 2) | 0;
                                                                                            f: {
                                                                                                if ((B = o[9007]) & (C = 1 << A)) {
                                                                                                    for(A = i << (31 != (0 | A) ? 25 - (A >>> 1 | 0) | 0 : 0), B = o[g >> 2];;){
                                                                                                        if ((0 | i) == (-8 & o[(g = B) + 4 >> 2])) break f;
                                                                                                        if (C = A >>> 29 | 0, A <<= 1, !(B = o[16 + (C = (4 & C) + g | 0) >> 2])) break;
                                                                                                    }
                                                                                                    o[C + 16 >> 2] = Q;
                                                                                                } else o[9007] = C | B, o[g >> 2] = Q;
                                                                                                o[Q + 24 >> 2] = g, o[Q + 12 >> 2] = Q, o[Q + 8 >> 2] = Q;
                                                                                                break a;
                                                                                            }
                                                                                            A = o[g + 8 >> 2], o[A + 12 >> 2] = Q, o[g + 8 >> 2] = Q, o[Q + 24 >> 2] = 0, o[Q + 12 >> 2] = g, o[Q + 8 >> 2] = A;
                                                                                        }
                                                                                    }
                                                                                }
                                                                                if (!((A = o[9009]) >>> 0 <= c >>> 0)) {
                                                                                    g = A - c | 0, o[9009] = g, A = (C = o[9012]) + c | 0, o[9012] = A, o[A + 4 >> 2] = 1 | g, o[C + 4 >> 2] = 3 | c, A = C + 8 | 0;
                                                                                    break A;
                                                                                }
                                                                            }
                                                                            o[9005] = 48, A = 0;
                                                                            break A;
                                                                        }
                                                                        C = 0;
                                                                    }
                                                                    if (c) {
                                                                        B = o[E + 28 >> 2];
                                                                        i: {
                                                                            if (o[(g = 36328 + (B << 2) | 0) >> 2] == (0 | E)) {
                                                                                if (o[g >> 2] = C, C) break i;
                                                                                y = 36028, h = o[9007] & RA(-2, B), o[y >> 2] = h;
                                                                                break Q;
                                                                            }
                                                                            if (o[c + (o[c + 16 >> 2] == (0 | E) ? 16 : 20) >> 2] = C, !C) break Q;
                                                                        }
                                                                        o[C + 24 >> 2] = c, (g = o[E + 16 >> 2]) && (o[C + 16 >> 2] = g, o[g + 24 >> 2] = C), (g = o[E + 20 >> 2]) && (o[C + 20 >> 2] = g, o[g + 24 >> 2] = C);
                                                                    }
                                                                }
                                                                A = A + Q | 0, i = o[4 + (E = Q + E | 0) >> 2];
                                                            }
                                                            if (o[E + 4 >> 2] = -2 & i, o[r + 4 >> 2] = 1 | A, o[A + r >> 2] = A, A >>> 0 <= 255) g = 36064 + (-8 & A) | 0, (C = o[9006]) & (A = 1 << (A >>> 3)) ? A = o[g + 8 >> 2] : (o[9006] = A | C, A = g), o[g + 8 >> 2] = r, o[A + 12 >> 2] = r, o[r + 12 >> 2] = g, o[r + 8 >> 2] = A;
                                                            else {
                                                                i = 31, A >>> 0 <= 16777215 && (i = 62 + ((A >>> 38 - (g = e(A >>> 8 | 0)) & 1) - (g << 1) | 0) | 0), o[r + 28 >> 2] = i, o[r + 16 >> 2] = 0, o[r + 20 >> 2] = 0, g = 36328 + (i << 2) | 0;
                                                                B: {
                                                                    if ((B = o[9007]) & (C = 1 << i)) {
                                                                        for(i = A << (31 != (0 | i) ? 25 - (i >>> 1 | 0) | 0 : 0), C = o[g >> 2];;){
                                                                            if (g = C, (-8 & o[C + 4 >> 2]) == (0 | A)) break B;
                                                                            if (B = i >>> 29 | 0, i <<= 1, !(C = o[16 + (B = (4 & B) + C | 0) >> 2])) break;
                                                                        }
                                                                        o[B + 16 >> 2] = r;
                                                                    } else o[9007] = C | B, o[g >> 2] = r;
                                                                    o[r + 24 >> 2] = g, o[r + 12 >> 2] = r, o[r + 8 >> 2] = r;
                                                                    break C;
                                                                }
                                                                A = o[g + 8 >> 2], o[A + 12 >> 2] = r, o[g + 8 >> 2] = r, o[r + 24 >> 2] = 0, o[r + 12 >> 2] = g, o[r + 8 >> 2] = A;
                                                            }
                                                        }
                                                        A = D + 8 | 0;
                                                        break A;
                                                    }
                                                    g: if (E) {
                                                        g = o[B + 28 >> 2];
                                                        C: {
                                                            if (o[(A = 36328 + (g << 2) | 0) >> 2] == (0 | B)) {
                                                                if (o[A >> 2] = C, C) break C;
                                                                D = RA(-2, g) & D, o[9007] = D;
                                                                break g;
                                                            }
                                                            if (o[E + (o[E + 16 >> 2] == (0 | B) ? 16 : 20) >> 2] = C, !C) break g;
                                                        }
                                                        o[C + 24 >> 2] = E, (A = o[B + 16 >> 2]) && (o[C + 16 >> 2] = A, o[A + 24 >> 2] = C), (A = o[B + 20 >> 2]) && (o[C + 20 >> 2] = A, o[A + 24 >> 2] = C);
                                                    }
                                                    g: if (i >>> 0 <= 15) A = i + c | 0, o[B + 4 >> 2] = 3 | A, o[4 + (A = A + B | 0) >> 2] = 1 | o[A + 4 >> 2];
                                                    else if (o[B + 4 >> 2] = 3 | c, o[4 + (Q = B + c | 0) >> 2] = 1 | i, o[Q + i >> 2] = i, i >>> 0 <= 255) g = 36064 + (-8 & i) | 0, (C = o[9006]) & (A = 1 << (i >>> 3)) ? A = o[g + 8 >> 2] : (o[9006] = A | C, A = g), o[g + 8 >> 2] = Q, o[A + 12 >> 2] = Q, o[Q + 12 >> 2] = g, o[Q + 8 >> 2] = A;
                                                    else {
                                                        A = 31, i >>> 0 <= 16777215 && (A = 62 + ((i >>> 38 - (A = e(i >>> 8 | 0)) & 1) - (A << 1) | 0) | 0), o[Q + 28 >> 2] = A, o[Q + 16 >> 2] = 0, o[Q + 20 >> 2] = 0, g = 36328 + (A << 2) | 0;
                                                        C: {
                                                            if ((C = 1 << A) & D) {
                                                                for(A = i << (31 != (0 | A) ? 25 - (A >>> 1 | 0) | 0 : 0), c = o[g >> 2];;){
                                                                    if ((-8 & o[(g = c) + 4 >> 2]) == (0 | i)) break C;
                                                                    if (C = A >>> 29 | 0, A <<= 1, !(c = o[16 + (C = (4 & C) + g | 0) >> 2])) break;
                                                                }
                                                                o[C + 16 >> 2] = Q;
                                                            } else o[9007] = C | D, o[g >> 2] = Q;
                                                            o[Q + 24 >> 2] = g, o[Q + 12 >> 2] = Q, o[Q + 8 >> 2] = Q;
                                                            break g;
                                                        }
                                                        A = o[g + 8 >> 2], o[A + 12 >> 2] = Q, o[g + 8 >> 2] = Q, o[Q + 24 >> 2] = 0, o[Q + 12 >> 2] = g, o[Q + 8 >> 2] = A;
                                                    }
                                                    A = B + 8 | 0;
                                                    break A;
                                                }
                                                I: if (r) {
                                                    g = o[C + 28 >> 2];
                                                    g: {
                                                        if (o[(A = 36328 + (g << 2) | 0) >> 2] == (0 | C)) {
                                                            if (o[A >> 2] = B, B) break g;
                                                            y = 36028, h = RA(-2, g) & D, o[y >> 2] = h;
                                                            break I;
                                                        }
                                                        if (o[r + (o[r + 16 >> 2] == (0 | C) ? 16 : 20) >> 2] = B, !B) break I;
                                                    }
                                                    o[B + 24 >> 2] = r, (A = o[C + 16 >> 2]) && (o[B + 16 >> 2] = A, o[A + 24 >> 2] = B), (A = o[C + 20 >> 2]) && (o[B + 20 >> 2] = A, o[A + 24 >> 2] = B);
                                                }
                                                i >>> 0 <= 15 ? (A = i + c | 0, o[C + 4 >> 2] = 3 | A, o[4 + (A = A + C | 0) >> 2] = 1 | o[A + 4 >> 2]) : (o[C + 4 >> 2] = 3 | c, o[4 + (B = C + c | 0) >> 2] = 1 | i, o[B + i >> 2] = i, t && (g = 36064 + (-8 & t) | 0, Q = o[9011], (A = 1 << (t >>> 3)) & E ? A = o[g + 8 >> 2] : (o[9006] = A | E, A = g), o[g + 8 >> 2] = Q, o[A + 12 >> 2] = Q, o[Q + 12 >> 2] = g, o[Q + 8 >> 2] = A), o[9011] = B, o[9008] = i), A = C + 8 | 0;
                                            }
                                            return w = I + 16 | 0, 0 | A;
                                        },
                                        sc: function(A) {
                                            var I = 0, g = 0, C = 0, B = 0, Q = 0, i = 0, E = 0, a = 0, c = 0;
                                            A: if (A |= 0) {
                                                Q = (C = A - 8 | 0) + (A = -8 & (I = o[A - 4 >> 2])) | 0;
                                                I: if (!(1 & I)) {
                                                    if (!(3 & I)) break A;
                                                    if ((C = C - (I = o[C >> 2]) | 0) >>> 0 < f[9010]) break A;
                                                    A = A + I | 0;
                                                    g: {
                                                        C: {
                                                            if (o[9011] != (0 | C)) {
                                                                if (I >>> 0 <= 255) {
                                                                    if (B = I >>> 3 | 0, (0 | (I = o[C + 12 >> 2])) == (0 | (g = o[C + 8 >> 2]))) {
                                                                        a = 36024, c = o[9006] & RA(-2, B), o[a >> 2] = c;
                                                                        break I;
                                                                    }
                                                                    o[g + 12 >> 2] = I, o[I + 8 >> 2] = g;
                                                                    break I;
                                                                }
                                                                if (E = o[C + 24 >> 2], (0 | C) != (0 | (I = o[C + 12 >> 2]))) {
                                                                    g = o[C + 8 >> 2], o[g + 12 >> 2] = I, o[I + 8 >> 2] = g;
                                                                    break g;
                                                                }
                                                                if (!(g = o[(B = C + 20 | 0) >> 2])) {
                                                                    if (!(g = o[C + 16 >> 2])) break C;
                                                                    B = C + 16 | 0;
                                                                }
                                                                for(; i = B, (g = o[(B = (I = g) + 20 | 0) >> 2]) || (B = I + 16 | 0, g = o[I + 16 >> 2]););
                                                                o[i >> 2] = 0;
                                                                break g;
                                                            }
                                                            if (3 != (3 & (I = o[Q + 4 >> 2]))) break I;
                                                            return o[9008] = A, o[Q + 4 >> 2] = -2 & I, o[C + 4 >> 2] = 1 | A, void (o[Q >> 2] = A);
                                                        }
                                                        I = 0;
                                                    }
                                                    if (E) {
                                                        g = o[C + 28 >> 2];
                                                        g: {
                                                            if (o[(B = 36328 + (g << 2) | 0) >> 2] == (0 | C)) {
                                                                if (o[B >> 2] = I, I) break g;
                                                                a = 36028, c = o[9007] & RA(-2, g), o[a >> 2] = c;
                                                                break I;
                                                            }
                                                            if (o[E + (o[E + 16 >> 2] == (0 | C) ? 16 : 20) >> 2] = I, !I) break I;
                                                        }
                                                        o[I + 24 >> 2] = E, (g = o[C + 16 >> 2]) && (o[I + 16 >> 2] = g, o[g + 24 >> 2] = I), (g = o[C + 20 >> 2]) && (o[I + 20 >> 2] = g, o[g + 24 >> 2] = I);
                                                    }
                                                }
                                                if (!(C >>> 0 >= Q >>> 0) && 1 & (I = o[Q + 4 >> 2])) {
                                                    I: {
                                                        g: {
                                                            C: {
                                                                B: {
                                                                    if (!(2 & I)) {
                                                                        if (o[9012] == (0 | Q)) {
                                                                            if (o[9012] = C, A = o[9009] + A | 0, o[9009] = A, o[C + 4 >> 2] = 1 | A, o[9011] != (0 | C)) break A;
                                                                            return o[9008] = 0, void (o[9011] = 0);
                                                                        }
                                                                        if (o[9011] == (0 | Q)) return o[9011] = C, A = o[9008] + A | 0, o[9008] = A, o[C + 4 >> 2] = 1 | A, void (o[A + C >> 2] = A);
                                                                        if (A = (-8 & I) + A | 0, I >>> 0 <= 255) {
                                                                            if (B = I >>> 3 | 0, (0 | (I = o[Q + 12 >> 2])) == (0 | (g = o[Q + 8 >> 2]))) {
                                                                                a = 36024, c = o[9006] & RA(-2, B), o[a >> 2] = c;
                                                                                break g;
                                                                            }
                                                                            o[g + 12 >> 2] = I, o[I + 8 >> 2] = g;
                                                                            break g;
                                                                        }
                                                                        if (E = o[Q + 24 >> 2], (0 | Q) != (0 | (I = o[Q + 12 >> 2]))) {
                                                                            g = o[Q + 8 >> 2], o[g + 12 >> 2] = I, o[I + 8 >> 2] = g;
                                                                            break C;
                                                                        }
                                                                        if (!(g = o[(B = Q + 20 | 0) >> 2])) {
                                                                            if (!(g = o[Q + 16 >> 2])) break B;
                                                                            B = Q + 16 | 0;
                                                                        }
                                                                        for(; i = B, (g = o[(B = (I = g) + 20 | 0) >> 2]) || (B = I + 16 | 0, g = o[I + 16 >> 2]););
                                                                        o[i >> 2] = 0;
                                                                        break C;
                                                                    }
                                                                    o[Q + 4 >> 2] = -2 & I, o[C + 4 >> 2] = 1 | A, o[A + C >> 2] = A;
                                                                    break I;
                                                                }
                                                                I = 0;
                                                            }
                                                            if (E) {
                                                                g = o[Q + 28 >> 2];
                                                                C: {
                                                                    if (o[(B = 36328 + (g << 2) | 0) >> 2] == (0 | Q)) {
                                                                        if (o[B >> 2] = I, I) break C;
                                                                        a = 36028, c = o[9007] & RA(-2, g), o[a >> 2] = c;
                                                                        break g;
                                                                    }
                                                                    if (o[E + (o[E + 16 >> 2] == (0 | Q) ? 16 : 20) >> 2] = I, !I) break g;
                                                                }
                                                                o[I + 24 >> 2] = E, (g = o[Q + 16 >> 2]) && (o[I + 16 >> 2] = g, o[g + 24 >> 2] = I), (g = o[Q + 20 >> 2]) && (o[I + 20 >> 2] = g, o[g + 24 >> 2] = I);
                                                            }
                                                        }
                                                        if (o[C + 4 >> 2] = 1 | A, o[A + C >> 2] = A, o[9011] == (0 | C)) return void (o[9008] = A);
                                                    }
                                                    if (A >>> 0 <= 255) return I = 36064 + (-8 & A) | 0, (g = o[9006]) & (A = 1 << (A >>> 3)) ? A = o[I + 8 >> 2] : (o[9006] = A | g, A = I), o[I + 8 >> 2] = C, o[A + 12 >> 2] = C, o[C + 12 >> 2] = I, void (o[C + 8 >> 2] = A);
                                                    g = 31, A >>> 0 <= 16777215 && (g = 62 + ((A >>> 38 - (I = e(A >>> 8 | 0)) & 1) - (I << 1) | 0) | 0), o[C + 28 >> 2] = g, o[C + 16 >> 2] = 0, o[C + 20 >> 2] = 0, I = 36328 + (g << 2) | 0;
                                                    I: {
                                                        g: {
                                                            if ((B = o[9007]) & (i = 1 << g)) {
                                                                for(g = A << (31 != (0 | g) ? 25 - (g >>> 1 | 0) | 0 : 0), I = o[I >> 2];;){
                                                                    if (B = I, (-8 & o[I + 4 >> 2]) == (0 | A)) break g;
                                                                    if (i = g >>> 29 | 0, g <<= 1, !(I = o[16 + (i = I + (4 & i) | 0) >> 2])) break;
                                                                }
                                                                o[i + 16 >> 2] = C, o[C + 24 >> 2] = B;
                                                            } else o[9007] = B | i, o[I >> 2] = C, o[C + 24 >> 2] = I;
                                                            o[C + 12 >> 2] = C, o[C + 8 >> 2] = C;
                                                            break I;
                                                        }
                                                        A = o[B + 8 >> 2], o[A + 12 >> 2] = C, o[B + 8 >> 2] = C, o[C + 24 >> 2] = 0, o[C + 12 >> 2] = B, o[C + 8 >> 2] = A;
                                                    }
                                                    A = o[9014] - 1 | 0, o[9014] = A || -1;
                                                }
                                            }
                                        },
                                        tc: wI
                                    };
                                }(A);
                            }(I);
                        },
                        instantiate: function(A, I) {
                            return {
                                then: function(g) {
                                    var C = new y.Module(A);
                                    g({
                                        instance: new y.Instance(C, I)
                                    });
                                }
                            };
                        },
                        RuntimeError: Error
                    };
                    r = [], "object" != typeof y && d("no native wasm support detected");
                    var w, h, n, s, k, F, S, H = !1;
                    function G() {
                        var A = t.buffer;
                        Q.HEAP8 = w = new Int8Array(A), Q.HEAP16 = n = new Int16Array(A), Q.HEAPU8 = h = new Uint8Array(A), Q.HEAPU16 = new Uint16Array(A), Q.HEAP32 = s = new Int32Array(A), Q.HEAPU32 = k = new Uint32Array(A), Q.HEAPF32 = F = new Float32Array(A), Q.HEAPF64 = S = new Float64Array(A);
                    }
                    var _ = Q.INITIAL_MEMORY || 16777216;
                    _ >= 65536 || d("INITIAL_MEMORY should be larger than STACK_SIZE, was " + _ + "! (STACK_SIZE=65536)"), t = Q.wasmMemory ? Q.wasmMemory : new y.Memory({
                        initial: _ / 65536,
                        maximum: 32768
                    }), G(), _ = t.buffer.byteLength;
                    var M = [], p = [], N = [], J = 0, U = null, Y = null;
                    function d(A) {
                        throw Q.onAbort && Q.onAbort(A), D(A = "Aborted(" + A + ")"), H = !0, A += ". Build with -sASSERTIONS for more info.", new y.RuntimeError(A);
                    }
                    var K, b, P = "data:application/octet-stream;base64,";
                    function v(A) {
                        return A.startsWith(P);
                    }
                    v(K = "<<< WASM_BINARY_FILE >>>") || (b = K, K = Q.locateFile ? Q.locateFile(b, f) : f + b);
                    var L, R = {
                        35256: ()=>Q.getRandomValue(),
                        35292: ()=>{
                            if (void 0 === Q.getRandomValue) try {
                                var A = "object" == typeof window ? window : self, I = void 0 !== A.crypto ? A.crypto : A.msCrypto, g = function() {
                                    var A = new Uint32Array(1);
                                    return I.getRandomValues(A), A[0] >>> 0;
                                };
                                g(), Q.getRandomValue = g;
                            } catch (A) {
                                try {
                                    var C = (parcelRequire("aO8Ot")), B = function() {
                                        var A = C.randomBytes(4);
                                        return (A[0] << 24 | A[1] << 16 | A[2] << 8 | A[3]) >>> 0;
                                    };
                                    B(), Q.getRandomValue = B;
                                } catch (A) {
                                    throw "No secure random number generator found";
                                }
                            }
                        }
                    }, u = (A)=>{
                        for(; A.length > 0;)A.shift()(Q);
                    }, x = "undefined" != typeof TextDecoder ? new TextDecoder("utf8") : void 0, m = (A, I)=>A ? ((A, I, g)=>{
                            for(var C = I + g, B = I; A[B] && !(B >= C);)++B;
                            if (B - I > 16 && A.buffer && x) return x.decode(A.subarray(I, B));
                            for(var Q = ""; I < B;){
                                var i = A[I++];
                                if (128 & i) {
                                    var E = 63 & A[I++];
                                    if (192 != (224 & i)) {
                                        var o = 63 & A[I++];
                                        if ((i = 224 == (240 & i) ? (15 & i) << 12 | E << 6 | o : (7 & i) << 18 | E << 12 | o << 6 | 63 & A[I++]) < 65536) Q += String.fromCharCode(i);
                                        else {
                                            var a = i - 65536;
                                            Q += String.fromCharCode(55296 | a >> 10, 56320 | 1023 & a);
                                        }
                                    } else Q += String.fromCharCode((31 & i) << 6 | E);
                                } else Q += String.fromCharCode(i);
                            }
                            return Q;
                        })(h, A, I) : "", l = [], z = (A)=>{
                        var I = (A - t.buffer.byteLength + 65535) / 65536;
                        try {
                            return t.grow(I), G(), 1;
                        } catch (A) {}
                    }, q = {
                        c: (A, I, g, C)=>{
                            d(`Assertion failed: ${m(A)}, at: ` + [
                                I ? m(I) : "unknown filename",
                                g,
                                C ? m(C) : "unknown function"
                            ]);
                        },
                        d: ()=>{
                            d("");
                        },
                        b: (A, I, g)=>((A, I, g)=>{
                                var C = ((A, I)=>{
                                    var g;
                                    for(l.length = 0; g = h[A++];)I += 105 != g && I % 8 ? 4 : 0, l.push(105 == g ? s[I >> 2] : S[I >> 3]), I += 105 == g ? 4 : 8;
                                    return l;
                                })(I, g);
                                return R[A].apply(null, C);
                            })(A, I, g),
                        e: (A)=>{
                            var I = h.length, g = 2147483648;
                            if ((A >>>= 0) > g) return !1;
                            for(var C, B = 1; B <= 4; B *= 2){
                                var Q = I * (1 + .2 / B);
                                Q = Math.min(Q, A + 100663296);
                                var i = Math.min(g, (C = Math.max(A, Q)) + (65536 - C % 65536) % 65536);
                                if (z(i)) return !0;
                            }
                            return !1;
                        },
                        a: t
                    }, X = function() {
                        var A, I, g = {
                            a: q
                        };
                        function C(A, I) {
                            var g, C = A.exports;
                            return (X = C).tc, g = X.f, p.unshift(g), function(A) {
                                if (J--, Q.monitorRunDependencies && Q.monitorRunDependencies(J), 0 == J && (null !== U && (clearInterval(U), U = null), Y)) {
                                    var I = Y;
                                    Y = null, I();
                                }
                            }(), C;
                        }
                        if (J++, Q.monitorRunDependencies && Q.monitorRunDependencies(J), Q.instantiateWasm) try {
                            return Q.instantiateWasm(g, C);
                        } catch (A) {
                            return D(`Module.instantiateWasm callback failed with error: ${A}`), !1;
                        }
                        return A = g, I = function(A) {
                            C(A.instance);
                        }, (function(A) {
                            return Promise.resolve().then(()=>(function(A) {
                                    if (A == K && r) return new Uint8Array(r);
                                    var I = function(A) {
                                        if (v(A)) return function(A) {
                                            if (void 0 !== a && a) {
                                                var I = $6b86f601ca43a026$require$Buffer.from(A, "base64");
                                                return new Uint8Array(I.buffer, I.byteOffset, I.length);
                                            }
                                            try {
                                                for(var g = atob(A), C = new Uint8Array(g.length), B = 0; B < g.length; ++B)C[B] = g.charCodeAt(B);
                                                return C;
                                            } catch (A) {
                                                throw new Error("Converting base64 string to bytes failed.");
                                            }
                                        }(A.slice(P.length));
                                    }(A);
                                    if (I) return I;
                                    if (B) return B(A);
                                    throw "both async and sync fetching of the wasm failed";
                                })(A));
                        })(K).then((I)=>y.instantiate(I, A)).then((A)=>A).then(I, (A)=>{
                            D(`failed to asynchronously prepare wasm: ${A}`), d(A);
                        }), {};
                    }();
                    function j() {
                        function A() {
                            L || (L = !0, Q.calledRun = !0, H || (u(p), Q.onRuntimeInitialized && Q.onRuntimeInitialized(), function() {
                                if (Q.postRun) for("function" == typeof Q.postRun && (Q.postRun = [
                                    Q.postRun
                                ]); Q.postRun.length;)A = Q.postRun.shift(), N.unshift(A);
                                var A;
                                u(N);
                            }()));
                        }
                        J > 0 || (function() {
                            if (Q.preRun) for("function" == typeof Q.preRun && (Q.preRun = [
                                Q.preRun
                            ]); Q.preRun.length;)A = Q.preRun.shift(), M.unshift(A);
                            var A;
                            u(M);
                        }(), J > 0 || (Q.setStatus ? (Q.setStatus("Running..."), setTimeout(function() {
                            setTimeout(function() {
                                Q.setStatus("");
                            }, 1), A();
                        }, 1)) : A()));
                    }
                    if (Q._crypto_aead_chacha20poly1305_encrypt_detached = (A, I, g, C, B, i, E, o, a, f, c, e)=>(Q._crypto_aead_chacha20poly1305_encrypt_detached = X.g)(A, I, g, C, B, i, E, o, a, f, c, e), Q._crypto_aead_chacha20poly1305_encrypt = (A, I, g, C, B, i, E, o, a, f, c)=>(Q._crypto_aead_chacha20poly1305_encrypt = X.h)(A, I, g, C, B, i, E, o, a, f, c), Q._crypto_aead_chacha20poly1305_ietf_encrypt_detached = (A, I, g, C, B, i, E, o, a, f, c, e)=>(Q._crypto_aead_chacha20poly1305_ietf_encrypt_detached = X.i)(A, I, g, C, B, i, E, o, a, f, c, e), Q._crypto_aead_chacha20poly1305_ietf_encrypt = (A, I, g, C, B, i, E, o, a, f, c)=>(Q._crypto_aead_chacha20poly1305_ietf_encrypt = X.j)(A, I, g, C, B, i, E, o, a, f, c), Q._crypto_aead_chacha20poly1305_decrypt_detached = (A, I, g, C, B, i, E, o, a, f, c)=>(Q._crypto_aead_chacha20poly1305_decrypt_detached = X.k)(A, I, g, C, B, i, E, o, a, f, c), Q._crypto_aead_chacha20poly1305_decrypt = (A, I, g, C, B, i, E, o, a, f, c)=>(Q._crypto_aead_chacha20poly1305_decrypt = X.l)(A, I, g, C, B, i, E, o, a, f, c), Q._crypto_aead_chacha20poly1305_ietf_decrypt_detached = (A, I, g, C, B, i, E, o, a, f, c)=>(Q._crypto_aead_chacha20poly1305_ietf_decrypt_detached = X.m)(A, I, g, C, B, i, E, o, a, f, c), Q._crypto_aead_chacha20poly1305_ietf_decrypt = (A, I, g, C, B, i, E, o, a, f, c)=>(Q._crypto_aead_chacha20poly1305_ietf_decrypt = X.n)(A, I, g, C, B, i, E, o, a, f, c), Q._crypto_aead_chacha20poly1305_ietf_keybytes = ()=>(Q._crypto_aead_chacha20poly1305_ietf_keybytes = X.o)(), Q._crypto_aead_chacha20poly1305_ietf_npubbytes = ()=>(Q._crypto_aead_chacha20poly1305_ietf_npubbytes = X.p)(), Q._crypto_aead_chacha20poly1305_ietf_nsecbytes = ()=>(Q._crypto_aead_chacha20poly1305_ietf_nsecbytes = X.q)(), Q._crypto_aead_chacha20poly1305_ietf_abytes = ()=>(Q._crypto_aead_chacha20poly1305_ietf_abytes = X.r)(), Q._crypto_aead_chacha20poly1305_ietf_messagebytes_max = ()=>(Q._crypto_aead_chacha20poly1305_ietf_messagebytes_max = X.s)(), Q._crypto_aead_chacha20poly1305_ietf_keygen = (A)=>(Q._crypto_aead_chacha20poly1305_ietf_keygen = X.t)(A), Q._crypto_aead_chacha20poly1305_keybytes = ()=>(Q._crypto_aead_chacha20poly1305_keybytes = X.u)(), Q._crypto_aead_chacha20poly1305_npubbytes = ()=>(Q._crypto_aead_chacha20poly1305_npubbytes = X.v)(), Q._crypto_aead_chacha20poly1305_nsecbytes = ()=>(Q._crypto_aead_chacha20poly1305_nsecbytes = X.w)(), Q._crypto_aead_chacha20poly1305_abytes = ()=>(Q._crypto_aead_chacha20poly1305_abytes = X.x)(), Q._crypto_aead_chacha20poly1305_messagebytes_max = ()=>(Q._crypto_aead_chacha20poly1305_messagebytes_max = X.y)(), Q._crypto_aead_chacha20poly1305_keygen = (A)=>(Q._crypto_aead_chacha20poly1305_keygen = X.z)(A), Q._crypto_aead_xchacha20poly1305_ietf_encrypt_detached = (A, I, g, C, B, i, E, o, a, f, c, e)=>(Q._crypto_aead_xchacha20poly1305_ietf_encrypt_detached = X.A)(A, I, g, C, B, i, E, o, a, f, c, e), Q._crypto_aead_xchacha20poly1305_ietf_encrypt = (A, I, g, C, B, i, E, o, a, f, c)=>(Q._crypto_aead_xchacha20poly1305_ietf_encrypt = X.B)(A, I, g, C, B, i, E, o, a, f, c), Q._crypto_aead_xchacha20poly1305_ietf_decrypt_detached = (A, I, g, C, B, i, E, o, a, f, c)=>(Q._crypto_aead_xchacha20poly1305_ietf_decrypt_detached = X.C)(A, I, g, C, B, i, E, o, a, f, c), Q._crypto_aead_xchacha20poly1305_ietf_decrypt = (A, I, g, C, B, i, E, o, a, f, c)=>(Q._crypto_aead_xchacha20poly1305_ietf_decrypt = X.D)(A, I, g, C, B, i, E, o, a, f, c), Q._crypto_aead_xchacha20poly1305_ietf_keybytes = ()=>(Q._crypto_aead_xchacha20poly1305_ietf_keybytes = X.E)(), Q._crypto_aead_xchacha20poly1305_ietf_npubbytes = ()=>(Q._crypto_aead_xchacha20poly1305_ietf_npubbytes = X.F)(), Q._crypto_aead_xchacha20poly1305_ietf_nsecbytes = ()=>(Q._crypto_aead_xchacha20poly1305_ietf_nsecbytes = X.G)(), Q._crypto_aead_xchacha20poly1305_ietf_abytes = ()=>(Q._crypto_aead_xchacha20poly1305_ietf_abytes = X.H)(), Q._crypto_aead_xchacha20poly1305_ietf_messagebytes_max = ()=>(Q._crypto_aead_xchacha20poly1305_ietf_messagebytes_max = X.I)(), Q._crypto_aead_xchacha20poly1305_ietf_keygen = (A)=>(Q._crypto_aead_xchacha20poly1305_ietf_keygen = X.J)(A), Q._crypto_auth_bytes = ()=>(Q._crypto_auth_bytes = X.K)(), Q._crypto_auth_keybytes = ()=>(Q._crypto_auth_keybytes = X.L)(), Q._crypto_auth = (A, I, g, C, B)=>(Q._crypto_auth = X.M)(A, I, g, C, B), Q._crypto_auth_verify = (A, I, g, C, B)=>(Q._crypto_auth_verify = X.N)(A, I, g, C, B), Q._crypto_auth_keygen = (A)=>(Q._crypto_auth_keygen = X.O)(A), Q._crypto_box_seedbytes = ()=>(Q._crypto_box_seedbytes = X.P)(), Q._crypto_box_publickeybytes = ()=>(Q._crypto_box_publickeybytes = X.Q)(), Q._crypto_box_secretkeybytes = ()=>(Q._crypto_box_secretkeybytes = X.R)(), Q._crypto_box_beforenmbytes = ()=>(Q._crypto_box_beforenmbytes = X.S)(), Q._crypto_box_noncebytes = ()=>(Q._crypto_box_noncebytes = X.T)(), Q._crypto_box_macbytes = ()=>(Q._crypto_box_macbytes = X.U)(), Q._crypto_box_messagebytes_max = ()=>(Q._crypto_box_messagebytes_max = X.V)(), Q._crypto_box_seed_keypair = (A, I, g)=>(Q._crypto_box_seed_keypair = X.W)(A, I, g), Q._crypto_box_keypair = (A, I)=>(Q._crypto_box_keypair = X.X)(A, I), Q._crypto_box_beforenm = (A, I, g)=>(Q._crypto_box_beforenm = X.Y)(A, I, g), Q._crypto_box_detached_afternm = (A, I, g, C, B, i, E)=>(Q._crypto_box_detached_afternm = X.Z)(A, I, g, C, B, i, E), Q._crypto_box_detached = (A, I, g, C, B, i, E, o)=>(Q._crypto_box_detached = X._)(A, I, g, C, B, i, E, o), Q._crypto_box_easy_afternm = (A, I, g, C, B, i)=>(Q._crypto_box_easy_afternm = X.$)(A, I, g, C, B, i), Q._crypto_box_easy = (A, I, g, C, B, i, E)=>(Q._crypto_box_easy = X.aa)(A, I, g, C, B, i, E), Q._crypto_box_open_detached_afternm = (A, I, g, C, B, i, E)=>(Q._crypto_box_open_detached_afternm = X.ba)(A, I, g, C, B, i, E), Q._crypto_box_open_detached = (A, I, g, C, B, i, E, o)=>(Q._crypto_box_open_detached = X.ca)(A, I, g, C, B, i, E, o), Q._crypto_box_open_easy_afternm = (A, I, g, C, B, i)=>(Q._crypto_box_open_easy_afternm = X.da)(A, I, g, C, B, i), Q._crypto_box_open_easy = (A, I, g, C, B, i, E)=>(Q._crypto_box_open_easy = X.ea)(A, I, g, C, B, i, E), Q._crypto_box_seal = (A, I, g, C, B)=>(Q._crypto_box_seal = X.fa)(A, I, g, C, B), Q._crypto_box_seal_open = (A, I, g, C, B, i)=>(Q._crypto_box_seal_open = X.ga)(A, I, g, C, B, i), Q._crypto_box_sealbytes = ()=>(Q._crypto_box_sealbytes = X.ha)(), Q._crypto_generichash_bytes_min = ()=>(Q._crypto_generichash_bytes_min = X.ia)(), Q._crypto_generichash_bytes_max = ()=>(Q._crypto_generichash_bytes_max = X.ja)(), Q._crypto_generichash_bytes = ()=>(Q._crypto_generichash_bytes = X.ka)(), Q._crypto_generichash_keybytes_min = ()=>(Q._crypto_generichash_keybytes_min = X.la)(), Q._crypto_generichash_keybytes_max = ()=>(Q._crypto_generichash_keybytes_max = X.ma)(), Q._crypto_generichash_keybytes = ()=>(Q._crypto_generichash_keybytes = X.na)(), Q._crypto_generichash_statebytes = ()=>(Q._crypto_generichash_statebytes = X.oa)(), Q._crypto_generichash = (A, I, g, C, B, i, E)=>(Q._crypto_generichash = X.pa)(A, I, g, C, B, i, E), Q._crypto_generichash_init = (A, I, g, C)=>(Q._crypto_generichash_init = X.qa)(A, I, g, C), Q._crypto_generichash_update = (A, I, g, C)=>(Q._crypto_generichash_update = X.ra)(A, I, g, C), Q._crypto_generichash_final = (A, I, g)=>(Q._crypto_generichash_final = X.sa)(A, I, g), Q._crypto_generichash_keygen = (A)=>(Q._crypto_generichash_keygen = X.ta)(A), Q._crypto_hash_bytes = ()=>(Q._crypto_hash_bytes = X.ua)(), Q._crypto_hash = (A, I, g, C)=>(Q._crypto_hash = X.va)(A, I, g, C), Q._crypto_kdf_bytes_min = ()=>(Q._crypto_kdf_bytes_min = X.wa)(), Q._crypto_kdf_bytes_max = ()=>(Q._crypto_kdf_bytes_max = X.xa)(), Q._crypto_kdf_contextbytes = ()=>(Q._crypto_kdf_contextbytes = X.ya)(), Q._crypto_kdf_keybytes = ()=>(Q._crypto_kdf_keybytes = X.za)(), Q._crypto_kdf_derive_from_key = (A, I, g, C, B, i)=>(Q._crypto_kdf_derive_from_key = X.Aa)(A, I, g, C, B, i), Q._crypto_kdf_keygen = (A)=>(Q._crypto_kdf_keygen = X.Ba)(A), Q._crypto_kdf_hkdf_sha256_extract_init = (A, I, g)=>(Q._crypto_kdf_hkdf_sha256_extract_init = X.Ca)(A, I, g), Q._crypto_kdf_hkdf_sha256_extract_update = (A, I, g)=>(Q._crypto_kdf_hkdf_sha256_extract_update = X.Da)(A, I, g), Q._crypto_kdf_hkdf_sha256_extract_final = (A, I)=>(Q._crypto_kdf_hkdf_sha256_extract_final = X.Ea)(A, I), Q._crypto_kdf_hkdf_sha256_extract = (A, I, g, C, B)=>(Q._crypto_kdf_hkdf_sha256_extract = X.Fa)(A, I, g, C, B), Q._crypto_kdf_hkdf_sha256_keygen = (A)=>(Q._crypto_kdf_hkdf_sha256_keygen = X.Ga)(A), Q._crypto_kdf_hkdf_sha256_expand = (A, I, g, C, B)=>(Q._crypto_kdf_hkdf_sha256_expand = X.Ha)(A, I, g, C, B), Q._crypto_kdf_hkdf_sha256_keybytes = ()=>(Q._crypto_kdf_hkdf_sha256_keybytes = X.Ia)(), Q._crypto_kdf_hkdf_sha256_bytes_min = ()=>(Q._crypto_kdf_hkdf_sha256_bytes_min = X.Ja)(), Q._crypto_kdf_hkdf_sha256_bytes_max = ()=>(Q._crypto_kdf_hkdf_sha256_bytes_max = X.Ka)(), Q._crypto_kdf_hkdf_sha256_statebytes = ()=>(Q._crypto_kdf_hkdf_sha256_statebytes = X.La)(), Q._crypto_kdf_hkdf_sha512_extract_init = (A, I, g)=>(Q._crypto_kdf_hkdf_sha512_extract_init = X.Ma)(A, I, g), Q._crypto_kdf_hkdf_sha512_extract_update = (A, I, g)=>(Q._crypto_kdf_hkdf_sha512_extract_update = X.Na)(A, I, g), Q._crypto_kdf_hkdf_sha512_extract_final = (A, I)=>(Q._crypto_kdf_hkdf_sha512_extract_final = X.Oa)(A, I), Q._crypto_kdf_hkdf_sha512_extract = (A, I, g, C, B)=>(Q._crypto_kdf_hkdf_sha512_extract = X.Pa)(A, I, g, C, B), Q._crypto_kdf_hkdf_sha512_keygen = (A)=>(Q._crypto_kdf_hkdf_sha512_keygen = X.Qa)(A), Q._crypto_kdf_hkdf_sha512_expand = (A, I, g, C, B)=>(Q._crypto_kdf_hkdf_sha512_expand = X.Ra)(A, I, g, C, B), Q._crypto_kdf_hkdf_sha512_keybytes = ()=>(Q._crypto_kdf_hkdf_sha512_keybytes = X.Sa)(), Q._crypto_kdf_hkdf_sha512_bytes_min = ()=>(Q._crypto_kdf_hkdf_sha512_bytes_min = X.Ta)(), Q._crypto_kdf_hkdf_sha512_bytes_max = ()=>(Q._crypto_kdf_hkdf_sha512_bytes_max = X.Ua)(), Q._crypto_kx_seed_keypair = (A, I, g)=>(Q._crypto_kx_seed_keypair = X.Va)(A, I, g), Q._crypto_kx_keypair = (A, I)=>(Q._crypto_kx_keypair = X.Wa)(A, I), Q._crypto_kx_client_session_keys = (A, I, g, C, B)=>(Q._crypto_kx_client_session_keys = X.Xa)(A, I, g, C, B), Q._crypto_kx_server_session_keys = (A, I, g, C, B)=>(Q._crypto_kx_server_session_keys = X.Ya)(A, I, g, C, B), Q._crypto_kx_publickeybytes = ()=>(Q._crypto_kx_publickeybytes = X.Za)(), Q._crypto_kx_secretkeybytes = ()=>(Q._crypto_kx_secretkeybytes = X._a)(), Q._crypto_kx_seedbytes = ()=>(Q._crypto_kx_seedbytes = X.$a)(), Q._crypto_kx_sessionkeybytes = ()=>(Q._crypto_kx_sessionkeybytes = X.ab)(), Q._crypto_scalarmult_base = (A, I)=>(Q._crypto_scalarmult_base = X.bb)(A, I), Q._crypto_scalarmult = (A, I, g)=>(Q._crypto_scalarmult = X.cb)(A, I, g), Q._crypto_scalarmult_bytes = ()=>(Q._crypto_scalarmult_bytes = X.db)(), Q._crypto_scalarmult_scalarbytes = ()=>(Q._crypto_scalarmult_scalarbytes = X.eb)(), Q._crypto_secretbox_keybytes = ()=>(Q._crypto_secretbox_keybytes = X.fb)(), Q._crypto_secretbox_noncebytes = ()=>(Q._crypto_secretbox_noncebytes = X.gb)(), Q._crypto_secretbox_macbytes = ()=>(Q._crypto_secretbox_macbytes = X.hb)(), Q._crypto_secretbox_messagebytes_max = ()=>(Q._crypto_secretbox_messagebytes_max = X.ib)(), Q._crypto_secretbox_keygen = (A)=>(Q._crypto_secretbox_keygen = X.jb)(A), Q._crypto_secretbox_detached = (A, I, g, C, B, i, E)=>(Q._crypto_secretbox_detached = X.kb)(A, I, g, C, B, i, E), Q._crypto_secretbox_easy = (A, I, g, C, B, i)=>(Q._crypto_secretbox_easy = X.lb)(A, I, g, C, B, i), Q._crypto_secretbox_open_detached = (A, I, g, C, B, i, E)=>(Q._crypto_secretbox_open_detached = X.mb)(A, I, g, C, B, i, E), Q._crypto_secretbox_open_easy = (A, I, g, C, B, i)=>(Q._crypto_secretbox_open_easy = X.nb)(A, I, g, C, B, i), Q._crypto_secretstream_xchacha20poly1305_keygen = (A)=>(Q._crypto_secretstream_xchacha20poly1305_keygen = X.ob)(A), Q._crypto_secretstream_xchacha20poly1305_init_push = (A, I, g)=>(Q._crypto_secretstream_xchacha20poly1305_init_push = X.pb)(A, I, g), Q._crypto_secretstream_xchacha20poly1305_init_pull = (A, I, g)=>(Q._crypto_secretstream_xchacha20poly1305_init_pull = X.qb)(A, I, g), Q._crypto_secretstream_xchacha20poly1305_rekey = (A)=>(Q._crypto_secretstream_xchacha20poly1305_rekey = X.rb)(A), Q._crypto_secretstream_xchacha20poly1305_push = (A, I, g, C, B, i, E, o, a, f)=>(Q._crypto_secretstream_xchacha20poly1305_push = X.sb)(A, I, g, C, B, i, E, o, a, f), Q._crypto_secretstream_xchacha20poly1305_pull = (A, I, g, C, B, i, E, o, a, f)=>(Q._crypto_secretstream_xchacha20poly1305_pull = X.tb)(A, I, g, C, B, i, E, o, a, f), Q._crypto_secretstream_xchacha20poly1305_statebytes = ()=>(Q._crypto_secretstream_xchacha20poly1305_statebytes = X.ub)(), Q._crypto_secretstream_xchacha20poly1305_abytes = ()=>(Q._crypto_secretstream_xchacha20poly1305_abytes = X.vb)(), Q._crypto_secretstream_xchacha20poly1305_headerbytes = ()=>(Q._crypto_secretstream_xchacha20poly1305_headerbytes = X.wb)(), Q._crypto_secretstream_xchacha20poly1305_keybytes = ()=>(Q._crypto_secretstream_xchacha20poly1305_keybytes = X.xb)(), Q._crypto_secretstream_xchacha20poly1305_messagebytes_max = ()=>(Q._crypto_secretstream_xchacha20poly1305_messagebytes_max = X.yb)(), Q._crypto_secretstream_xchacha20poly1305_tag_message = ()=>(Q._crypto_secretstream_xchacha20poly1305_tag_message = X.zb)(), Q._crypto_secretstream_xchacha20poly1305_tag_push = ()=>(Q._crypto_secretstream_xchacha20poly1305_tag_push = X.Ab)(), Q._crypto_secretstream_xchacha20poly1305_tag_rekey = ()=>(Q._crypto_secretstream_xchacha20poly1305_tag_rekey = X.Bb)(), Q._crypto_secretstream_xchacha20poly1305_tag_final = ()=>(Q._crypto_secretstream_xchacha20poly1305_tag_final = X.Cb)(), Q._crypto_shorthash_bytes = ()=>(Q._crypto_shorthash_bytes = X.Db)(), Q._crypto_shorthash_keybytes = ()=>(Q._crypto_shorthash_keybytes = X.Eb)(), Q._crypto_shorthash = (A, I, g, C, B)=>(Q._crypto_shorthash = X.Fb)(A, I, g, C, B), Q._crypto_shorthash_keygen = (A)=>(Q._crypto_shorthash_keygen = X.Gb)(A), Q._crypto_sign_statebytes = ()=>(Q._crypto_sign_statebytes = X.Hb)(), Q._crypto_sign_bytes = ()=>(Q._crypto_sign_bytes = X.Ib)(), Q._crypto_sign_seedbytes = ()=>(Q._crypto_sign_seedbytes = X.Jb)(), Q._crypto_sign_publickeybytes = ()=>(Q._crypto_sign_publickeybytes = X.Kb)(), Q._crypto_sign_secretkeybytes = ()=>(Q._crypto_sign_secretkeybytes = X.Lb)(), Q._crypto_sign_messagebytes_max = ()=>(Q._crypto_sign_messagebytes_max = X.Mb)(), Q._crypto_sign_seed_keypair = (A, I, g)=>(Q._crypto_sign_seed_keypair = X.Nb)(A, I, g), Q._crypto_sign_keypair = (A, I)=>(Q._crypto_sign_keypair = X.Ob)(A, I), Q._crypto_sign = (A, I, g, C, B, i)=>(Q._crypto_sign = X.Pb)(A, I, g, C, B, i), Q._crypto_sign_open = (A, I, g, C, B, i)=>(Q._crypto_sign_open = X.Qb)(A, I, g, C, B, i), Q._crypto_sign_detached = (A, I, g, C, B, i)=>(Q._crypto_sign_detached = X.Rb)(A, I, g, C, B, i), Q._crypto_sign_verify_detached = (A, I, g, C, B)=>(Q._crypto_sign_verify_detached = X.Sb)(A, I, g, C, B), Q._crypto_sign_init = (A)=>(Q._crypto_sign_init = X.Tb)(A), Q._crypto_sign_update = (A, I, g, C)=>(Q._crypto_sign_update = X.Ub)(A, I, g, C), Q._crypto_sign_final_create = (A, I, g, C)=>(Q._crypto_sign_final_create = X.Vb)(A, I, g, C), Q._crypto_sign_final_verify = (A, I, g)=>(Q._crypto_sign_final_verify = X.Wb)(A, I, g), Q._crypto_sign_ed25519_pk_to_curve25519 = (A, I)=>(Q._crypto_sign_ed25519_pk_to_curve25519 = X.Xb)(A, I), Q._crypto_sign_ed25519_sk_to_curve25519 = (A, I)=>(Q._crypto_sign_ed25519_sk_to_curve25519 = X.Yb)(A, I), Q._randombytes_random = ()=>(Q._randombytes_random = X.Zb)(), Q._randombytes_stir = ()=>(Q._randombytes_stir = X._b)(), Q._randombytes_uniform = (A)=>(Q._randombytes_uniform = X.$b)(A), Q._randombytes_buf = (A, I)=>(Q._randombytes_buf = X.ac)(A, I), Q._randombytes_buf_deterministic = (A, I, g)=>(Q._randombytes_buf_deterministic = X.bc)(A, I, g), Q._randombytes_seedbytes = ()=>(Q._randombytes_seedbytes = X.cc)(), Q._randombytes_close = ()=>(Q._randombytes_close = X.dc)(), Q._randombytes = (A, I, g)=>(Q._randombytes = X.ec)(A, I, g), Q._sodium_bin2hex = (A, I, g, C)=>(Q._sodium_bin2hex = X.fc)(A, I, g, C), Q._sodium_hex2bin = (A, I, g, C, B, i, E)=>(Q._sodium_hex2bin = X.gc)(A, I, g, C, B, i, E), Q._sodium_base64_encoded_len = (A, I)=>(Q._sodium_base64_encoded_len = X.hc)(A, I), Q._sodium_bin2base64 = (A, I, g, C, B)=>(Q._sodium_bin2base64 = X.ic)(A, I, g, C, B), Q._sodium_base642bin = (A, I, g, C, B, i, E, o)=>(Q._sodium_base642bin = X.jc)(A, I, g, C, B, i, E, o), Q._sodium_init = ()=>(Q._sodium_init = X.kc)(), Q._sodium_pad = (A, I, g, C, B)=>(Q._sodium_pad = X.lc)(A, I, g, C, B), Q._sodium_unpad = (A, I, g, C)=>(Q._sodium_unpad = X.mc)(A, I, g, C), Q._sodium_version_string = ()=>(Q._sodium_version_string = X.nc)(), Q._sodium_library_version_major = ()=>(Q._sodium_library_version_major = X.oc)(), Q._sodium_library_version_minor = ()=>(Q._sodium_library_version_minor = X.pc)(), Q._sodium_library_minimal = ()=>(Q._sodium_library_minimal = X.qc)(), Q._malloc = (A)=>(Q._malloc = X.rc)(A), Q._free = (A)=>(Q._free = X.sc)(A), Q.setValue = function(A, I, g = "i8") {
                        switch(g.endsWith("*") && (g = "*"), g){
                            case "i1":
                            case "i8":
                                w[A >> 0] = I;
                                break;
                            case "i16":
                                n[A >> 1] = I;
                                break;
                            case "i32":
                                s[A >> 2] = I;
                                break;
                            case "i64":
                                d("to do setValue(i64) use WASM_BIGINT");
                            case "float":
                                F[A >> 2] = I;
                                break;
                            case "double":
                                S[A >> 3] = I;
                                break;
                            case "*":
                                k[A >> 2] = I;
                                break;
                            default:
                                d(`invalid type for setValue: ${g}`);
                        }
                    }, Q.getValue = function(A, I = "i8") {
                        switch(I.endsWith("*") && (I = "*"), I){
                            case "i1":
                            case "i8":
                                return w[A >> 0];
                            case "i16":
                                return n[A >> 1];
                            case "i32":
                                return s[A >> 2];
                            case "i64":
                                d("to do getValue(i64) use WASM_BIGINT");
                            case "float":
                                return F[A >> 2];
                            case "double":
                                return S[A >> 3];
                            case "*":
                                return k[A >> 2];
                            default:
                                d(`invalid type for getValue: ${I}`);
                        }
                    }, Q.UTF8ToString = m, Y = function A() {
                        L || j(), L || (Y = A);
                    }, Q.preInit) for("function" == typeof Q.preInit && (Q.preInit = [
                        Q.preInit
                    ]); Q.preInit.length > 0;)Q.preInit.pop()();
                    j();
                });
            };
            var g, B, Q = void 0 !== Q ? Q : {}, i = Object.assign({}, Q), E = "object" == typeof window, o = "function" == typeof importScripts, a = "object" == typeof $4TNnu && "object" == typeof $4TNnu.versions && "string" == typeof $4TNnu.versions.node, f = "";
            if (a) {
                var c = (parcelRequire("5Io6y")), e = (parcelRequire("5Io6y"));
                f = o ? e.dirname(f) + "/" : $6b86f601ca43a026$var$__dirname + "/", g = (A, I)=>(A = function(A) {
                        return A.startsWith("file://");
                    }(A) ? new URL(A) : e.normalize(A), c.readFileSync(A, I ? void 0 : "utf8")), B = (A)=>{
                    var I = g(A, !0);
                    return I.buffer || (I = new Uint8Array(I)), I;
                }, !Q.thisProgram && $4TNnu.argv.length > 1 && $4TNnu.argv[1].replace(/\\/g, "/"), $4TNnu.argv.slice(2), module.exports = Q, Q.inspect = ()=>"[Emscripten Module object]";
            } else (E || o) && (o ? f = self.location.href : "undefined" != typeof document && document.currentScript && (f = document.currentScript.src), f = 0 !== f.indexOf("blob:") ? f.substr(0, f.replace(/[?#].*/, "").lastIndexOf("/") + 1) : "", g = (A)=>{
                var I = new XMLHttpRequest;
                return I.open("GET", A, !1), I.send(null), I.responseText;
            }, o && (B = (A)=>{
                var I = new XMLHttpRequest;
                return I.open("GET", A, !1), I.responseType = "arraybuffer", I.send(null), new Uint8Array(I.response);
            }));
            Q.print;
            var r, D, t = Q.printErr || void 0;
            Object.assign(Q, i), i = null, Q.arguments && Q.arguments, Q.thisProgram && Q.thisProgram, Q.quit && Q.quit, Q.wasmBinary && (r = Q.wasmBinary), Q.noExitRuntime, "object" != typeof WebAssembly && U("no native wasm support detected");
            var y, w, h, n, s, k, F, S = !1;
            function H() {
                var A = D.buffer;
                Q.HEAP8 = y = new Int8Array(A), Q.HEAP16 = h = new Int16Array(A), Q.HEAPU8 = w = new Uint8Array(A), Q.HEAPU16 = new Uint16Array(A), Q.HEAP32 = n = new Int32Array(A), Q.HEAPU32 = s = new Uint32Array(A), Q.HEAPF32 = k = new Float32Array(A), Q.HEAPF64 = F = new Float64Array(A);
            }
            var G = [], _ = [], M = [], p = 0, N = null, J = null;
            function U(A) {
                throw Q.onAbort && Q.onAbort(A), t(A = "Aborted(" + A + ")"), S = !0, A += ". Build with -sASSERTIONS for more info.", new WebAssembly.RuntimeError(A);
            }
            var Y, d, K = "data:application/octet-stream;base64,";
            function b(A) {
                return A.startsWith(K);
            }
            b(Y = "data:application/octet-stream;base64,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") || (d = Y, Y = Q.locateFile ? Q.locateFile(d, f) : f + d);
            var P, v = {
                35256: ()=>Q.getRandomValue(),
                35292: ()=>{
                    if (void 0 === Q.getRandomValue) try {
                        var A = "object" == typeof window ? window : self, I = void 0 !== A.crypto ? A.crypto : A.msCrypto, g = function() {
                            var A = new Uint32Array(1);
                            return I.getRandomValues(A), A[0] >>> 0;
                        };
                        g(), Q.getRandomValue = g;
                    } catch (A) {
                        try {
                            var C = (parcelRequire("aO8Ot")), B = function() {
                                var A = C.randomBytes(4);
                                return (A[0] << 24 | A[1] << 16 | A[2] << 8 | A[3]) >>> 0;
                            };
                            B(), Q.getRandomValue = B;
                        } catch (A) {
                            throw "No secure random number generator found";
                        }
                    }
                }
            }, L = (A)=>{
                for(; A.length > 0;)A.shift()(Q);
            }, R = "undefined" != typeof TextDecoder ? new TextDecoder("utf8") : void 0, u = (A, I)=>A ? ((A, I, g)=>{
                    for(var C = I + g, B = I; A[B] && !(B >= C);)++B;
                    if (B - I > 16 && A.buffer && R) return R.decode(A.subarray(I, B));
                    for(var Q = ""; I < B;){
                        var i = A[I++];
                        if (128 & i) {
                            var E = 63 & A[I++];
                            if (192 != (224 & i)) {
                                var o = 63 & A[I++];
                                if ((i = 224 == (240 & i) ? (15 & i) << 12 | E << 6 | o : (7 & i) << 18 | E << 12 | o << 6 | 63 & A[I++]) < 65536) Q += String.fromCharCode(i);
                                else {
                                    var a = i - 65536;
                                    Q += String.fromCharCode(55296 | a >> 10, 56320 | 1023 & a);
                                }
                            } else Q += String.fromCharCode((31 & i) << 6 | E);
                        } else Q += String.fromCharCode(i);
                    }
                    return Q;
                })(w, A, I) : "", x = [], m = (A)=>{
                var I = (A - D.buffer.byteLength + 65535) / 65536;
                try {
                    return D.grow(I), H(), 1;
                } catch (A) {}
            }, l = {
                b: (A, I, g, C)=>{
                    U(`Assertion failed: ${u(A)}, at: ` + [
                        I ? u(I) : "unknown filename",
                        g,
                        C ? u(C) : "unknown function"
                    ]);
                },
                c: ()=>{
                    U("");
                },
                a: (A, I, g)=>((A, I, g)=>{
                        var C = ((A, I)=>{
                            var g;
                            for(x.length = 0; g = w[A++];)I += 105 != g && I % 8 ? 4 : 0, x.push(105 == g ? n[I >> 2] : F[I >> 3]), I += 105 == g ? 4 : 8;
                            return x;
                        })(I, g);
                        return v[A].apply(null, C);
                    })(A, I, g),
                d: (A, I, g)=>w.copyWithin(A, I, I + g),
                e: (A)=>{
                    var I = w.length, g = 2147483648;
                    if ((A >>>= 0) > g) return !1;
                    for(var C, B = 1; B <= 4; B *= 2){
                        var Q = I * (1 + .2 / B);
                        Q = Math.min(Q, A + 100663296);
                        var i = Math.min(g, (C = Math.max(A, Q)) + (65536 - C % 65536) % 65536);
                        if (m(i)) return !0;
                    }
                    return !1;
                }
            }, z = function() {
                var A, I, g = {
                    a: l
                };
                function C(A, I) {
                    var g = A.exports;
                    return D = (z = g).f, H(), z.tc, function(A) {
                        if (p--, Q.monitorRunDependencies && Q.monitorRunDependencies(p), 0 == p && (null !== N && (clearInterval(N), N = null), J)) {
                            var I = J;
                            J = null, I();
                        }
                    }(), g;
                }
                if (p++, Q.monitorRunDependencies && Q.monitorRunDependencies(p), Q.instantiateWasm) try {
                    return Q.instantiateWasm(g, C);
                } catch (A) {
                    return t(`Module.instantiateWasm callback failed with error: ${A}`), !1;
                }
                return A = g, I = function(A) {
                    C(A.instance);
                }, (function(A) {
                    return Promise.resolve().then(()=>(function(A) {
                            if (A == Y && r) return new Uint8Array(r);
                            var I = function(A) {
                                if (b(A)) return function(A) {
                                    if (void 0 !== a && a) {
                                        var I = $6b86f601ca43a026$require$Buffer.from(A, "base64");
                                        return new Uint8Array(I.buffer, I.byteOffset, I.length);
                                    }
                                    try {
                                        for(var g = atob(A), C = new Uint8Array(g.length), B = 0; B < g.length; ++B)C[B] = g.charCodeAt(B);
                                        return C;
                                    } catch (A) {
                                        throw new Error("Converting base64 string to bytes failed.");
                                    }
                                }(A.slice(K.length));
                            }(A);
                            if (I) return I;
                            if (B) return B(A);
                            throw "both async and sync fetching of the wasm failed";
                        })(A));
                })(Y).then((I)=>WebAssembly.instantiate(I, A)).then((A)=>A).then(I, (A)=>{
                    t(`failed to asynchronously prepare wasm: ${A}`), U(A);
                }), {};
            }();
            function q() {
                function A() {
                    P || (P = !0, Q.calledRun = !0, S || (L(_), Q.onRuntimeInitialized && Q.onRuntimeInitialized(), function() {
                        if (Q.postRun) for("function" == typeof Q.postRun && (Q.postRun = [
                            Q.postRun
                        ]); Q.postRun.length;)A = Q.postRun.shift(), M.unshift(A);
                        var A;
                        L(M);
                    }()));
                }
                p > 0 || (function() {
                    if (Q.preRun) for("function" == typeof Q.preRun && (Q.preRun = [
                        Q.preRun
                    ]); Q.preRun.length;)A = Q.preRun.shift(), G.unshift(A);
                    var A;
                    L(G);
                }(), p > 0 || (Q.setStatus ? (Q.setStatus("Running..."), setTimeout(function() {
                    setTimeout(function() {
                        Q.setStatus("");
                    }, 1), A();
                }, 1)) : A()));
            }
            if (Q._crypto_aead_chacha20poly1305_encrypt_detached = (A, I, g, C, B, i, E, o, a, f, c, e)=>(Q._crypto_aead_chacha20poly1305_encrypt_detached = z.g)(A, I, g, C, B, i, E, o, a, f, c, e), Q._crypto_aead_chacha20poly1305_encrypt = (A, I, g, C, B, i, E, o, a, f, c)=>(Q._crypto_aead_chacha20poly1305_encrypt = z.h)(A, I, g, C, B, i, E, o, a, f, c), Q._crypto_aead_chacha20poly1305_ietf_encrypt_detached = (A, I, g, C, B, i, E, o, a, f, c, e)=>(Q._crypto_aead_chacha20poly1305_ietf_encrypt_detached = z.i)(A, I, g, C, B, i, E, o, a, f, c, e), Q._crypto_aead_chacha20poly1305_ietf_encrypt = (A, I, g, C, B, i, E, o, a, f, c)=>(Q._crypto_aead_chacha20poly1305_ietf_encrypt = z.j)(A, I, g, C, B, i, E, o, a, f, c), Q._crypto_aead_chacha20poly1305_decrypt_detached = (A, I, g, C, B, i, E, o, a, f, c)=>(Q._crypto_aead_chacha20poly1305_decrypt_detached = z.k)(A, I, g, C, B, i, E, o, a, f, c), Q._crypto_aead_chacha20poly1305_decrypt = (A, I, g, C, B, i, E, o, a, f, c)=>(Q._crypto_aead_chacha20poly1305_decrypt = z.l)(A, I, g, C, B, i, E, o, a, f, c), Q._crypto_aead_chacha20poly1305_ietf_decrypt_detached = (A, I, g, C, B, i, E, o, a, f, c)=>(Q._crypto_aead_chacha20poly1305_ietf_decrypt_detached = z.m)(A, I, g, C, B, i, E, o, a, f, c), Q._crypto_aead_chacha20poly1305_ietf_decrypt = (A, I, g, C, B, i, E, o, a, f, c)=>(Q._crypto_aead_chacha20poly1305_ietf_decrypt = z.n)(A, I, g, C, B, i, E, o, a, f, c), Q._crypto_aead_chacha20poly1305_ietf_keybytes = ()=>(Q._crypto_aead_chacha20poly1305_ietf_keybytes = z.o)(), Q._crypto_aead_chacha20poly1305_ietf_npubbytes = ()=>(Q._crypto_aead_chacha20poly1305_ietf_npubbytes = z.p)(), Q._crypto_aead_chacha20poly1305_ietf_nsecbytes = ()=>(Q._crypto_aead_chacha20poly1305_ietf_nsecbytes = z.q)(), Q._crypto_aead_chacha20poly1305_ietf_abytes = ()=>(Q._crypto_aead_chacha20poly1305_ietf_abytes = z.r)(), Q._crypto_aead_chacha20poly1305_ietf_messagebytes_max = ()=>(Q._crypto_aead_chacha20poly1305_ietf_messagebytes_max = z.s)(), Q._crypto_aead_chacha20poly1305_ietf_keygen = (A)=>(Q._crypto_aead_chacha20poly1305_ietf_keygen = z.t)(A), Q._crypto_aead_chacha20poly1305_keybytes = ()=>(Q._crypto_aead_chacha20poly1305_keybytes = z.u)(), Q._crypto_aead_chacha20poly1305_npubbytes = ()=>(Q._crypto_aead_chacha20poly1305_npubbytes = z.v)(), Q._crypto_aead_chacha20poly1305_nsecbytes = ()=>(Q._crypto_aead_chacha20poly1305_nsecbytes = z.w)(), Q._crypto_aead_chacha20poly1305_abytes = ()=>(Q._crypto_aead_chacha20poly1305_abytes = z.x)(), Q._crypto_aead_chacha20poly1305_messagebytes_max = ()=>(Q._crypto_aead_chacha20poly1305_messagebytes_max = z.y)(), Q._crypto_aead_chacha20poly1305_keygen = (A)=>(Q._crypto_aead_chacha20poly1305_keygen = z.z)(A), Q._crypto_aead_xchacha20poly1305_ietf_encrypt_detached = (A, I, g, C, B, i, E, o, a, f, c, e)=>(Q._crypto_aead_xchacha20poly1305_ietf_encrypt_detached = z.A)(A, I, g, C, B, i, E, o, a, f, c, e), Q._crypto_aead_xchacha20poly1305_ietf_encrypt = (A, I, g, C, B, i, E, o, a, f, c)=>(Q._crypto_aead_xchacha20poly1305_ietf_encrypt = z.B)(A, I, g, C, B, i, E, o, a, f, c), Q._crypto_aead_xchacha20poly1305_ietf_decrypt_detached = (A, I, g, C, B, i, E, o, a, f, c)=>(Q._crypto_aead_xchacha20poly1305_ietf_decrypt_detached = z.C)(A, I, g, C, B, i, E, o, a, f, c), Q._crypto_aead_xchacha20poly1305_ietf_decrypt = (A, I, g, C, B, i, E, o, a, f, c)=>(Q._crypto_aead_xchacha20poly1305_ietf_decrypt = z.D)(A, I, g, C, B, i, E, o, a, f, c), Q._crypto_aead_xchacha20poly1305_ietf_keybytes = ()=>(Q._crypto_aead_xchacha20poly1305_ietf_keybytes = z.E)(), Q._crypto_aead_xchacha20poly1305_ietf_npubbytes = ()=>(Q._crypto_aead_xchacha20poly1305_ietf_npubbytes = z.F)(), Q._crypto_aead_xchacha20poly1305_ietf_nsecbytes = ()=>(Q._crypto_aead_xchacha20poly1305_ietf_nsecbytes = z.G)(), Q._crypto_aead_xchacha20poly1305_ietf_abytes = ()=>(Q._crypto_aead_xchacha20poly1305_ietf_abytes = z.H)(), Q._crypto_aead_xchacha20poly1305_ietf_messagebytes_max = ()=>(Q._crypto_aead_xchacha20poly1305_ietf_messagebytes_max = z.I)(), Q._crypto_aead_xchacha20poly1305_ietf_keygen = (A)=>(Q._crypto_aead_xchacha20poly1305_ietf_keygen = z.J)(A), Q._crypto_auth_bytes = ()=>(Q._crypto_auth_bytes = z.K)(), Q._crypto_auth_keybytes = ()=>(Q._crypto_auth_keybytes = z.L)(), Q._crypto_auth = (A, I, g, C, B)=>(Q._crypto_auth = z.M)(A, I, g, C, B), Q._crypto_auth_verify = (A, I, g, C, B)=>(Q._crypto_auth_verify = z.N)(A, I, g, C, B), Q._crypto_auth_keygen = (A)=>(Q._crypto_auth_keygen = z.O)(A), Q._crypto_box_seedbytes = ()=>(Q._crypto_box_seedbytes = z.P)(), Q._crypto_box_publickeybytes = ()=>(Q._crypto_box_publickeybytes = z.Q)(), Q._crypto_box_secretkeybytes = ()=>(Q._crypto_box_secretkeybytes = z.R)(), Q._crypto_box_beforenmbytes = ()=>(Q._crypto_box_beforenmbytes = z.S)(), Q._crypto_box_noncebytes = ()=>(Q._crypto_box_noncebytes = z.T)(), Q._crypto_box_macbytes = ()=>(Q._crypto_box_macbytes = z.U)(), Q._crypto_box_messagebytes_max = ()=>(Q._crypto_box_messagebytes_max = z.V)(), Q._crypto_box_seed_keypair = (A, I, g)=>(Q._crypto_box_seed_keypair = z.W)(A, I, g), Q._crypto_box_keypair = (A, I)=>(Q._crypto_box_keypair = z.X)(A, I), Q._crypto_box_beforenm = (A, I, g)=>(Q._crypto_box_beforenm = z.Y)(A, I, g), Q._crypto_box_detached_afternm = (A, I, g, C, B, i, E)=>(Q._crypto_box_detached_afternm = z.Z)(A, I, g, C, B, i, E), Q._crypto_box_detached = (A, I, g, C, B, i, E, o)=>(Q._crypto_box_detached = z._)(A, I, g, C, B, i, E, o), Q._crypto_box_easy_afternm = (A, I, g, C, B, i)=>(Q._crypto_box_easy_afternm = z.$)(A, I, g, C, B, i), Q._crypto_box_easy = (A, I, g, C, B, i, E)=>(Q._crypto_box_easy = z.aa)(A, I, g, C, B, i, E), Q._crypto_box_open_detached_afternm = (A, I, g, C, B, i, E)=>(Q._crypto_box_open_detached_afternm = z.ba)(A, I, g, C, B, i, E), Q._crypto_box_open_detached = (A, I, g, C, B, i, E, o)=>(Q._crypto_box_open_detached = z.ca)(A, I, g, C, B, i, E, o), Q._crypto_box_open_easy_afternm = (A, I, g, C, B, i)=>(Q._crypto_box_open_easy_afternm = z.da)(A, I, g, C, B, i), Q._crypto_box_open_easy = (A, I, g, C, B, i, E)=>(Q._crypto_box_open_easy = z.ea)(A, I, g, C, B, i, E), Q._crypto_box_seal = (A, I, g, C, B)=>(Q._crypto_box_seal = z.fa)(A, I, g, C, B), Q._crypto_box_seal_open = (A, I, g, C, B, i)=>(Q._crypto_box_seal_open = z.ga)(A, I, g, C, B, i), Q._crypto_box_sealbytes = ()=>(Q._crypto_box_sealbytes = z.ha)(), Q._crypto_generichash_bytes_min = ()=>(Q._crypto_generichash_bytes_min = z.ia)(), Q._crypto_generichash_bytes_max = ()=>(Q._crypto_generichash_bytes_max = z.ja)(), Q._crypto_generichash_bytes = ()=>(Q._crypto_generichash_bytes = z.ka)(), Q._crypto_generichash_keybytes_min = ()=>(Q._crypto_generichash_keybytes_min = z.la)(), Q._crypto_generichash_keybytes_max = ()=>(Q._crypto_generichash_keybytes_max = z.ma)(), Q._crypto_generichash_keybytes = ()=>(Q._crypto_generichash_keybytes = z.na)(), Q._crypto_generichash_statebytes = ()=>(Q._crypto_generichash_statebytes = z.oa)(), Q._crypto_generichash = (A, I, g, C, B, i, E)=>(Q._crypto_generichash = z.pa)(A, I, g, C, B, i, E), Q._crypto_generichash_init = (A, I, g, C)=>(Q._crypto_generichash_init = z.qa)(A, I, g, C), Q._crypto_generichash_update = (A, I, g, C)=>(Q._crypto_generichash_update = z.ra)(A, I, g, C), Q._crypto_generichash_final = (A, I, g)=>(Q._crypto_generichash_final = z.sa)(A, I, g), Q._crypto_generichash_keygen = (A)=>(Q._crypto_generichash_keygen = z.ta)(A), Q._crypto_hash_bytes = ()=>(Q._crypto_hash_bytes = z.ua)(), Q._crypto_hash = (A, I, g, C)=>(Q._crypto_hash = z.va)(A, I, g, C), Q._crypto_kdf_bytes_min = ()=>(Q._crypto_kdf_bytes_min = z.wa)(), Q._crypto_kdf_bytes_max = ()=>(Q._crypto_kdf_bytes_max = z.xa)(), Q._crypto_kdf_contextbytes = ()=>(Q._crypto_kdf_contextbytes = z.ya)(), Q._crypto_kdf_keybytes = ()=>(Q._crypto_kdf_keybytes = z.za)(), Q._crypto_kdf_derive_from_key = (A, I, g, C, B, i)=>(Q._crypto_kdf_derive_from_key = z.Aa)(A, I, g, C, B, i), Q._crypto_kdf_keygen = (A)=>(Q._crypto_kdf_keygen = z.Ba)(A), Q._crypto_kdf_hkdf_sha256_extract_init = (A, I, g)=>(Q._crypto_kdf_hkdf_sha256_extract_init = z.Ca)(A, I, g), Q._crypto_kdf_hkdf_sha256_extract_update = (A, I, g)=>(Q._crypto_kdf_hkdf_sha256_extract_update = z.Da)(A, I, g), Q._crypto_kdf_hkdf_sha256_extract_final = (A, I)=>(Q._crypto_kdf_hkdf_sha256_extract_final = z.Ea)(A, I), Q._crypto_kdf_hkdf_sha256_extract = (A, I, g, C, B)=>(Q._crypto_kdf_hkdf_sha256_extract = z.Fa)(A, I, g, C, B), Q._crypto_kdf_hkdf_sha256_keygen = (A)=>(Q._crypto_kdf_hkdf_sha256_keygen = z.Ga)(A), Q._crypto_kdf_hkdf_sha256_expand = (A, I, g, C, B)=>(Q._crypto_kdf_hkdf_sha256_expand = z.Ha)(A, I, g, C, B), Q._crypto_kdf_hkdf_sha256_keybytes = ()=>(Q._crypto_kdf_hkdf_sha256_keybytes = z.Ia)(), Q._crypto_kdf_hkdf_sha256_bytes_min = ()=>(Q._crypto_kdf_hkdf_sha256_bytes_min = z.Ja)(), Q._crypto_kdf_hkdf_sha256_bytes_max = ()=>(Q._crypto_kdf_hkdf_sha256_bytes_max = z.Ka)(), Q._crypto_kdf_hkdf_sha256_statebytes = ()=>(Q._crypto_kdf_hkdf_sha256_statebytes = z.La)(), Q._crypto_kdf_hkdf_sha512_extract_init = (A, I, g)=>(Q._crypto_kdf_hkdf_sha512_extract_init = z.Ma)(A, I, g), Q._crypto_kdf_hkdf_sha512_extract_update = (A, I, g)=>(Q._crypto_kdf_hkdf_sha512_extract_update = z.Na)(A, I, g), Q._crypto_kdf_hkdf_sha512_extract_final = (A, I)=>(Q._crypto_kdf_hkdf_sha512_extract_final = z.Oa)(A, I), Q._crypto_kdf_hkdf_sha512_extract = (A, I, g, C, B)=>(Q._crypto_kdf_hkdf_sha512_extract = z.Pa)(A, I, g, C, B), Q._crypto_kdf_hkdf_sha512_keygen = (A)=>(Q._crypto_kdf_hkdf_sha512_keygen = z.Qa)(A), Q._crypto_kdf_hkdf_sha512_expand = (A, I, g, C, B)=>(Q._crypto_kdf_hkdf_sha512_expand = z.Ra)(A, I, g, C, B), Q._crypto_kdf_hkdf_sha512_keybytes = ()=>(Q._crypto_kdf_hkdf_sha512_keybytes = z.Sa)(), Q._crypto_kdf_hkdf_sha512_bytes_min = ()=>(Q._crypto_kdf_hkdf_sha512_bytes_min = z.Ta)(), Q._crypto_kdf_hkdf_sha512_bytes_max = ()=>(Q._crypto_kdf_hkdf_sha512_bytes_max = z.Ua)(), Q._crypto_kx_seed_keypair = (A, I, g)=>(Q._crypto_kx_seed_keypair = z.Va)(A, I, g), Q._crypto_kx_keypair = (A, I)=>(Q._crypto_kx_keypair = z.Wa)(A, I), Q._crypto_kx_client_session_keys = (A, I, g, C, B)=>(Q._crypto_kx_client_session_keys = z.Xa)(A, I, g, C, B), Q._crypto_kx_server_session_keys = (A, I, g, C, B)=>(Q._crypto_kx_server_session_keys = z.Ya)(A, I, g, C, B), Q._crypto_kx_publickeybytes = ()=>(Q._crypto_kx_publickeybytes = z.Za)(), Q._crypto_kx_secretkeybytes = ()=>(Q._crypto_kx_secretkeybytes = z._a)(), Q._crypto_kx_seedbytes = ()=>(Q._crypto_kx_seedbytes = z.$a)(), Q._crypto_kx_sessionkeybytes = ()=>(Q._crypto_kx_sessionkeybytes = z.ab)(), Q._crypto_scalarmult_base = (A, I)=>(Q._crypto_scalarmult_base = z.bb)(A, I), Q._crypto_scalarmult = (A, I, g)=>(Q._crypto_scalarmult = z.cb)(A, I, g), Q._crypto_scalarmult_bytes = ()=>(Q._crypto_scalarmult_bytes = z.db)(), Q._crypto_scalarmult_scalarbytes = ()=>(Q._crypto_scalarmult_scalarbytes = z.eb)(), Q._crypto_secretbox_keybytes = ()=>(Q._crypto_secretbox_keybytes = z.fb)(), Q._crypto_secretbox_noncebytes = ()=>(Q._crypto_secretbox_noncebytes = z.gb)(), Q._crypto_secretbox_macbytes = ()=>(Q._crypto_secretbox_macbytes = z.hb)(), Q._crypto_secretbox_messagebytes_max = ()=>(Q._crypto_secretbox_messagebytes_max = z.ib)(), Q._crypto_secretbox_keygen = (A)=>(Q._crypto_secretbox_keygen = z.jb)(A), Q._crypto_secretbox_detached = (A, I, g, C, B, i, E)=>(Q._crypto_secretbox_detached = z.kb)(A, I, g, C, B, i, E), Q._crypto_secretbox_easy = (A, I, g, C, B, i)=>(Q._crypto_secretbox_easy = z.lb)(A, I, g, C, B, i), Q._crypto_secretbox_open_detached = (A, I, g, C, B, i, E)=>(Q._crypto_secretbox_open_detached = z.mb)(A, I, g, C, B, i, E), Q._crypto_secretbox_open_easy = (A, I, g, C, B, i)=>(Q._crypto_secretbox_open_easy = z.nb)(A, I, g, C, B, i), Q._crypto_secretstream_xchacha20poly1305_keygen = (A)=>(Q._crypto_secretstream_xchacha20poly1305_keygen = z.ob)(A), Q._crypto_secretstream_xchacha20poly1305_init_push = (A, I, g)=>(Q._crypto_secretstream_xchacha20poly1305_init_push = z.pb)(A, I, g), Q._crypto_secretstream_xchacha20poly1305_init_pull = (A, I, g)=>(Q._crypto_secretstream_xchacha20poly1305_init_pull = z.qb)(A, I, g), Q._crypto_secretstream_xchacha20poly1305_rekey = (A)=>(Q._crypto_secretstream_xchacha20poly1305_rekey = z.rb)(A), Q._crypto_secretstream_xchacha20poly1305_push = (A, I, g, C, B, i, E, o, a, f)=>(Q._crypto_secretstream_xchacha20poly1305_push = z.sb)(A, I, g, C, B, i, E, o, a, f), Q._crypto_secretstream_xchacha20poly1305_pull = (A, I, g, C, B, i, E, o, a, f)=>(Q._crypto_secretstream_xchacha20poly1305_pull = z.tb)(A, I, g, C, B, i, E, o, a, f), Q._crypto_secretstream_xchacha20poly1305_statebytes = ()=>(Q._crypto_secretstream_xchacha20poly1305_statebytes = z.ub)(), Q._crypto_secretstream_xchacha20poly1305_abytes = ()=>(Q._crypto_secretstream_xchacha20poly1305_abytes = z.vb)(), Q._crypto_secretstream_xchacha20poly1305_headerbytes = ()=>(Q._crypto_secretstream_xchacha20poly1305_headerbytes = z.wb)(), Q._crypto_secretstream_xchacha20poly1305_keybytes = ()=>(Q._crypto_secretstream_xchacha20poly1305_keybytes = z.xb)(), Q._crypto_secretstream_xchacha20poly1305_messagebytes_max = ()=>(Q._crypto_secretstream_xchacha20poly1305_messagebytes_max = z.yb)(), Q._crypto_secretstream_xchacha20poly1305_tag_message = ()=>(Q._crypto_secretstream_xchacha20poly1305_tag_message = z.zb)(), Q._crypto_secretstream_xchacha20poly1305_tag_push = ()=>(Q._crypto_secretstream_xchacha20poly1305_tag_push = z.Ab)(), Q._crypto_secretstream_xchacha20poly1305_tag_rekey = ()=>(Q._crypto_secretstream_xchacha20poly1305_tag_rekey = z.Bb)(), Q._crypto_secretstream_xchacha20poly1305_tag_final = ()=>(Q._crypto_secretstream_xchacha20poly1305_tag_final = z.Cb)(), Q._crypto_shorthash_bytes = ()=>(Q._crypto_shorthash_bytes = z.Db)(), Q._crypto_shorthash_keybytes = ()=>(Q._crypto_shorthash_keybytes = z.Eb)(), Q._crypto_shorthash = (A, I, g, C, B)=>(Q._crypto_shorthash = z.Fb)(A, I, g, C, B), Q._crypto_shorthash_keygen = (A)=>(Q._crypto_shorthash_keygen = z.Gb)(A), Q._crypto_sign_statebytes = ()=>(Q._crypto_sign_statebytes = z.Hb)(), Q._crypto_sign_bytes = ()=>(Q._crypto_sign_bytes = z.Ib)(), Q._crypto_sign_seedbytes = ()=>(Q._crypto_sign_seedbytes = z.Jb)(), Q._crypto_sign_publickeybytes = ()=>(Q._crypto_sign_publickeybytes = z.Kb)(), Q._crypto_sign_secretkeybytes = ()=>(Q._crypto_sign_secretkeybytes = z.Lb)(), Q._crypto_sign_messagebytes_max = ()=>(Q._crypto_sign_messagebytes_max = z.Mb)(), Q._crypto_sign_seed_keypair = (A, I, g)=>(Q._crypto_sign_seed_keypair = z.Nb)(A, I, g), Q._crypto_sign_keypair = (A, I)=>(Q._crypto_sign_keypair = z.Ob)(A, I), Q._crypto_sign = (A, I, g, C, B, i)=>(Q._crypto_sign = z.Pb)(A, I, g, C, B, i), Q._crypto_sign_open = (A, I, g, C, B, i)=>(Q._crypto_sign_open = z.Qb)(A, I, g, C, B, i), Q._crypto_sign_detached = (A, I, g, C, B, i)=>(Q._crypto_sign_detached = z.Rb)(A, I, g, C, B, i), Q._crypto_sign_verify_detached = (A, I, g, C, B)=>(Q._crypto_sign_verify_detached = z.Sb)(A, I, g, C, B), Q._crypto_sign_init = (A)=>(Q._crypto_sign_init = z.Tb)(A), Q._crypto_sign_update = (A, I, g, C)=>(Q._crypto_sign_update = z.Ub)(A, I, g, C), Q._crypto_sign_final_create = (A, I, g, C)=>(Q._crypto_sign_final_create = z.Vb)(A, I, g, C), Q._crypto_sign_final_verify = (A, I, g)=>(Q._crypto_sign_final_verify = z.Wb)(A, I, g), Q._crypto_sign_ed25519_pk_to_curve25519 = (A, I)=>(Q._crypto_sign_ed25519_pk_to_curve25519 = z.Xb)(A, I), Q._crypto_sign_ed25519_sk_to_curve25519 = (A, I)=>(Q._crypto_sign_ed25519_sk_to_curve25519 = z.Yb)(A, I), Q._randombytes_random = ()=>(Q._randombytes_random = z.Zb)(), Q._randombytes_stir = ()=>(Q._randombytes_stir = z._b)(), Q._randombytes_uniform = (A)=>(Q._randombytes_uniform = z.$b)(A), Q._randombytes_buf = (A, I)=>(Q._randombytes_buf = z.ac)(A, I), Q._randombytes_buf_deterministic = (A, I, g)=>(Q._randombytes_buf_deterministic = z.bc)(A, I, g), Q._randombytes_seedbytes = ()=>(Q._randombytes_seedbytes = z.cc)(), Q._randombytes_close = ()=>(Q._randombytes_close = z.dc)(), Q._randombytes = (A, I, g)=>(Q._randombytes = z.ec)(A, I, g), Q._sodium_bin2hex = (A, I, g, C)=>(Q._sodium_bin2hex = z.fc)(A, I, g, C), Q._sodium_hex2bin = (A, I, g, C, B, i, E)=>(Q._sodium_hex2bin = z.gc)(A, I, g, C, B, i, E), Q._sodium_base64_encoded_len = (A, I)=>(Q._sodium_base64_encoded_len = z.hc)(A, I), Q._sodium_bin2base64 = (A, I, g, C, B)=>(Q._sodium_bin2base64 = z.ic)(A, I, g, C, B), Q._sodium_base642bin = (A, I, g, C, B, i, E, o)=>(Q._sodium_base642bin = z.jc)(A, I, g, C, B, i, E, o), Q._sodium_init = ()=>(Q._sodium_init = z.kc)(), Q._sodium_pad = (A, I, g, C, B)=>(Q._sodium_pad = z.lc)(A, I, g, C, B), Q._sodium_unpad = (A, I, g, C)=>(Q._sodium_unpad = z.mc)(A, I, g, C), Q._sodium_version_string = ()=>(Q._sodium_version_string = z.nc)(), Q._sodium_library_version_major = ()=>(Q._sodium_library_version_major = z.oc)(), Q._sodium_library_version_minor = ()=>(Q._sodium_library_version_minor = z.pc)(), Q._sodium_library_minimal = ()=>(Q._sodium_library_minimal = z.qc)(), Q._malloc = (A)=>(Q._malloc = z.rc)(A), Q._free = (A)=>(Q._free = z.sc)(A), Q.setValue = function(A, I, g = "i8") {
                switch(g.endsWith("*") && (g = "*"), g){
                    case "i1":
                    case "i8":
                        y[A >> 0] = I;
                        break;
                    case "i16":
                        h[A >> 1] = I;
                        break;
                    case "i32":
                        n[A >> 2] = I;
                        break;
                    case "i64":
                        U("to do setValue(i64) use WASM_BIGINT");
                    case "float":
                        k[A >> 2] = I;
                        break;
                    case "double":
                        F[A >> 3] = I;
                        break;
                    case "*":
                        s[A >> 2] = I;
                        break;
                    default:
                        U(`invalid type for setValue: ${g}`);
                }
            }, Q.getValue = function(A, I = "i8") {
                switch(I.endsWith("*") && (I = "*"), I){
                    case "i1":
                    case "i8":
                        return y[A >> 0];
                    case "i16":
                        return h[A >> 1];
                    case "i32":
                        return n[A >> 2];
                    case "i64":
                        U("to do getValue(i64) use WASM_BIGINT");
                    case "float":
                        return k[A >> 2];
                    case "double":
                        return F[A >> 3];
                    case "*":
                        return s[A >> 2];
                    default:
                        U(`invalid type for getValue: ${I}`);
                }
            }, Q.UTF8ToString = u, J = function A() {
                P || q(), P || (J = A);
            }, Q.preInit) for("function" == typeof Q.preInit && (Q.preInit = [
                Q.preInit
            ]); Q.preInit.length > 0;)Q.preInit.pop()();
            q();
        }).catch(function() {
            return C.useBackupModule();
        }), I;
    }
    "function" == typeof define && define.amd ? define([
        "exports"
    ], I) : "string" != typeof module.exports.nodeName ? I(module.exports) : A.libsodium = I(A.libsodium_mod || (A.commonJsStrict = {}));
}(module.exports);

});
parcelRequire.register("aO8Ot", function(module, exports) {

$parcel$export(module.exports, "randomBytes", function () { return $7de568f77242e9e6$export$5f828d93ff035aa8; }, function (v) { return $7de568f77242e9e6$export$5f828d93ff035aa8 = v; });
$parcel$export(module.exports, "rng", function () { return $7de568f77242e9e6$export$cd94982b18c6332c; }, function (v) { return $7de568f77242e9e6$export$cd94982b18c6332c = v; });
$parcel$export(module.exports, "pseudoRandomBytes", function () { return $7de568f77242e9e6$export$1d518568e4f529b0; }, function (v) { return $7de568f77242e9e6$export$1d518568e4f529b0 = v; });
$parcel$export(module.exports, "prng", function () { return $7de568f77242e9e6$export$5285b6d41c912b41; }, function (v) { return $7de568f77242e9e6$export$5285b6d41c912b41 = v; });
$parcel$export(module.exports, "createHash", function () { return $7de568f77242e9e6$export$2fb37efbf6ae0c0e; }, function (v) { return $7de568f77242e9e6$export$2fb37efbf6ae0c0e = v; });
$parcel$export(module.exports, "Hash", function () { return $7de568f77242e9e6$export$ab85ecd77ce6a5cd; }, function (v) { return $7de568f77242e9e6$export$ab85ecd77ce6a5cd = v; });
$parcel$export(module.exports, "createHmac", function () { return $7de568f77242e9e6$export$da39cf97e1eb7c91; }, function (v) { return $7de568f77242e9e6$export$da39cf97e1eb7c91 = v; });
$parcel$export(module.exports, "Hmac", function () { return $7de568f77242e9e6$export$52a9039d7177394f; }, function (v) { return $7de568f77242e9e6$export$52a9039d7177394f = v; });
$parcel$export(module.exports, "getHashes", function () { return $7de568f77242e9e6$export$f7201db400317331; }, function (v) { return $7de568f77242e9e6$export$f7201db400317331 = v; });
$parcel$export(module.exports, "pbkdf2", function () { return $7de568f77242e9e6$export$448fa22aedc9dbca; }, function (v) { return $7de568f77242e9e6$export$448fa22aedc9dbca = v; });
$parcel$export(module.exports, "pbkdf2Sync", function () { return $7de568f77242e9e6$export$b80c7ba289c8fa56; }, function (v) { return $7de568f77242e9e6$export$b80c7ba289c8fa56 = v; });
$parcel$export(module.exports, "Cipher", function () { return $7de568f77242e9e6$export$26e5786e8ac8e530; }, function (v) { return $7de568f77242e9e6$export$26e5786e8ac8e530 = v; });
$parcel$export(module.exports, "createCipher", function () { return $7de568f77242e9e6$export$bdd223f16383713e; }, function (v) { return $7de568f77242e9e6$export$bdd223f16383713e = v; });
$parcel$export(module.exports, "Cipheriv", function () { return $7de568f77242e9e6$export$20533d26f07f1ee0; }, function (v) { return $7de568f77242e9e6$export$20533d26f07f1ee0 = v; });
$parcel$export(module.exports, "createCipheriv", function () { return $7de568f77242e9e6$export$2f64596b8cbf08b4; }, function (v) { return $7de568f77242e9e6$export$2f64596b8cbf08b4 = v; });
$parcel$export(module.exports, "Decipher", function () { return $7de568f77242e9e6$export$2ce6d8d0e8b04e1a; }, function (v) { return $7de568f77242e9e6$export$2ce6d8d0e8b04e1a = v; });
$parcel$export(module.exports, "createDecipher", function () { return $7de568f77242e9e6$export$12ada9414fbc594c; }, function (v) { return $7de568f77242e9e6$export$12ada9414fbc594c = v; });
$parcel$export(module.exports, "Decipheriv", function () { return $7de568f77242e9e6$export$f5e7e39d57cd9700; }, function (v) { return $7de568f77242e9e6$export$f5e7e39d57cd9700 = v; });
$parcel$export(module.exports, "createDecipheriv", function () { return $7de568f77242e9e6$export$36b6d6ef312eab39; }, function (v) { return $7de568f77242e9e6$export$36b6d6ef312eab39 = v; });
$parcel$export(module.exports, "getCiphers", function () { return $7de568f77242e9e6$export$58a258485f1e49f6; }, function (v) { return $7de568f77242e9e6$export$58a258485f1e49f6 = v; });
$parcel$export(module.exports, "listCiphers", function () { return $7de568f77242e9e6$export$dedd8dc3dc62b370; }, function (v) { return $7de568f77242e9e6$export$dedd8dc3dc62b370 = v; });
$parcel$export(module.exports, "DiffieHellmanGroup", function () { return $7de568f77242e9e6$export$971862a2fcb1bb40; }, function (v) { return $7de568f77242e9e6$export$971862a2fcb1bb40 = v; });
$parcel$export(module.exports, "createDiffieHellmanGroup", function () { return $7de568f77242e9e6$export$c6ff6a88acbeaf40; }, function (v) { return $7de568f77242e9e6$export$c6ff6a88acbeaf40 = v; });
$parcel$export(module.exports, "getDiffieHellman", function () { return $7de568f77242e9e6$export$fdc27893e98845cc; }, function (v) { return $7de568f77242e9e6$export$fdc27893e98845cc = v; });
$parcel$export(module.exports, "createDiffieHellman", function () { return $7de568f77242e9e6$export$6671fb9a1323bed; }, function (v) { return $7de568f77242e9e6$export$6671fb9a1323bed = v; });
$parcel$export(module.exports, "DiffieHellman", function () { return $7de568f77242e9e6$export$d74daf141a551db; }, function (v) { return $7de568f77242e9e6$export$d74daf141a551db = v; });
$parcel$export(module.exports, "createSign", function () { return $7de568f77242e9e6$export$45df7cae684751af; }, function (v) { return $7de568f77242e9e6$export$45df7cae684751af = v; });
$parcel$export(module.exports, "Sign", function () { return $7de568f77242e9e6$export$1db683ad541682f6; }, function (v) { return $7de568f77242e9e6$export$1db683ad541682f6 = v; });
$parcel$export(module.exports, "createVerify", function () { return $7de568f77242e9e6$export$6f65485f87568e37; }, function (v) { return $7de568f77242e9e6$export$6f65485f87568e37 = v; });
$parcel$export(module.exports, "Verify", function () { return $7de568f77242e9e6$export$91a8e56769aeb334; }, function (v) { return $7de568f77242e9e6$export$91a8e56769aeb334 = v; });
$parcel$export(module.exports, "createECDH", function () { return $7de568f77242e9e6$export$2d4117e99c2179e4; }, function (v) { return $7de568f77242e9e6$export$2d4117e99c2179e4 = v; });
$parcel$export(module.exports, "publicEncrypt", function () { return $7de568f77242e9e6$export$512823e338ddb1b7; }, function (v) { return $7de568f77242e9e6$export$512823e338ddb1b7 = v; });
$parcel$export(module.exports, "privateEncrypt", function () { return $7de568f77242e9e6$export$9d0e0c0c4a8d30f3; }, function (v) { return $7de568f77242e9e6$export$9d0e0c0c4a8d30f3 = v; });
$parcel$export(module.exports, "publicDecrypt", function () { return $7de568f77242e9e6$export$b9d55ff329113abd; }, function (v) { return $7de568f77242e9e6$export$b9d55ff329113abd = v; });
$parcel$export(module.exports, "privateDecrypt", function () { return $7de568f77242e9e6$export$7efb24e2fddf99b9; }, function (v) { return $7de568f77242e9e6$export$7efb24e2fddf99b9 = v; });
$parcel$export(module.exports, "randomFill", function () { return $7de568f77242e9e6$export$bb1abf2ce84fc7e8; }, function (v) { return $7de568f77242e9e6$export$bb1abf2ce84fc7e8 = v; });
$parcel$export(module.exports, "randomFillSync", function () { return $7de568f77242e9e6$export$2f7171e78e524d5e; }, function (v) { return $7de568f77242e9e6$export$2f7171e78e524d5e = v; });
$parcel$export(module.exports, "createCredentials", function () { return $7de568f77242e9e6$export$e1d879b482f37d98; }, function (v) { return $7de568f77242e9e6$export$e1d879b482f37d98 = v; });
$parcel$export(module.exports, "constants", function () { return $7de568f77242e9e6$export$1a988e7317c65621; }, function (v) { return $7de568f77242e9e6$export$1a988e7317c65621 = v; });
var $7de568f77242e9e6$export$5f828d93ff035aa8;
var $7de568f77242e9e6$export$cd94982b18c6332c;
var $7de568f77242e9e6$export$1d518568e4f529b0;
var $7de568f77242e9e6$export$5285b6d41c912b41;
var $7de568f77242e9e6$export$2fb37efbf6ae0c0e;
var $7de568f77242e9e6$export$ab85ecd77ce6a5cd;
var $7de568f77242e9e6$export$da39cf97e1eb7c91;
var $7de568f77242e9e6$export$52a9039d7177394f;
var $7de568f77242e9e6$export$f7201db400317331;
var $7de568f77242e9e6$export$448fa22aedc9dbca;
var $7de568f77242e9e6$export$b80c7ba289c8fa56;
var $7de568f77242e9e6$export$26e5786e8ac8e530;
var $7de568f77242e9e6$export$bdd223f16383713e;
var $7de568f77242e9e6$export$20533d26f07f1ee0;
var $7de568f77242e9e6$export$2f64596b8cbf08b4;
var $7de568f77242e9e6$export$2ce6d8d0e8b04e1a;
var $7de568f77242e9e6$export$12ada9414fbc594c;
var $7de568f77242e9e6$export$f5e7e39d57cd9700;
var $7de568f77242e9e6$export$36b6d6ef312eab39;
var $7de568f77242e9e6$export$58a258485f1e49f6;
var $7de568f77242e9e6$export$dedd8dc3dc62b370;
var $7de568f77242e9e6$export$971862a2fcb1bb40;
var $7de568f77242e9e6$export$c6ff6a88acbeaf40;
var $7de568f77242e9e6$export$fdc27893e98845cc;
var $7de568f77242e9e6$export$6671fb9a1323bed;
var $7de568f77242e9e6$export$d74daf141a551db;
var $7de568f77242e9e6$export$45df7cae684751af;
var $7de568f77242e9e6$export$1db683ad541682f6;
var $7de568f77242e9e6$export$6f65485f87568e37;
var $7de568f77242e9e6$export$91a8e56769aeb334;
var $7de568f77242e9e6$export$2d4117e99c2179e4;
var $7de568f77242e9e6$export$512823e338ddb1b7;
var $7de568f77242e9e6$export$9d0e0c0c4a8d30f3;
var $7de568f77242e9e6$export$b9d55ff329113abd;
var $7de568f77242e9e6$export$7efb24e2fddf99b9;
var $7de568f77242e9e6$export$bb1abf2ce84fc7e8;
var $7de568f77242e9e6$export$2f7171e78e524d5e;
var $7de568f77242e9e6$export$e1d879b482f37d98;
var $7de568f77242e9e6$export$1a988e7317c65621;
"use strict";

$7de568f77242e9e6$export$5f828d93ff035aa8 = $7de568f77242e9e6$export$cd94982b18c6332c = $7de568f77242e9e6$export$1d518568e4f529b0 = $7de568f77242e9e6$export$5285b6d41c912b41 = (parcelRequire("5rfiH"));

$7de568f77242e9e6$export$2fb37efbf6ae0c0e = $7de568f77242e9e6$export$ab85ecd77ce6a5cd = (parcelRequire("3FiLE"));

$7de568f77242e9e6$export$da39cf97e1eb7c91 = $7de568f77242e9e6$export$52a9039d7177394f = (parcelRequire("cUvgf"));

var $fAh7A = parcelRequire("fAh7A");
var $7de568f77242e9e6$var$algoKeys = Object.keys($fAh7A);
var $7de568f77242e9e6$var$hashes = [
    "sha1",
    "sha224",
    "sha256",
    "sha384",
    "sha512",
    "md5",
    "rmd160"
].concat($7de568f77242e9e6$var$algoKeys);
$7de568f77242e9e6$export$f7201db400317331 = function() {
    return $7de568f77242e9e6$var$hashes;
};

var $1UZ5c = parcelRequire("1UZ5c");
$7de568f77242e9e6$export$448fa22aedc9dbca = $1UZ5c.pbkdf2;
$7de568f77242e9e6$export$b80c7ba289c8fa56 = $1UZ5c.pbkdf2Sync;

var $3lJ0u = parcelRequire("3lJ0u");
$7de568f77242e9e6$export$26e5786e8ac8e530 = $3lJ0u.Cipher;
$7de568f77242e9e6$export$bdd223f16383713e = $3lJ0u.createCipher;
$7de568f77242e9e6$export$20533d26f07f1ee0 = $3lJ0u.Cipheriv;
$7de568f77242e9e6$export$2f64596b8cbf08b4 = $3lJ0u.createCipheriv;
$7de568f77242e9e6$export$2ce6d8d0e8b04e1a = $3lJ0u.Decipher;
$7de568f77242e9e6$export$12ada9414fbc594c = $3lJ0u.createDecipher;
$7de568f77242e9e6$export$f5e7e39d57cd9700 = $3lJ0u.Decipheriv;
$7de568f77242e9e6$export$36b6d6ef312eab39 = $3lJ0u.createDecipheriv;
$7de568f77242e9e6$export$58a258485f1e49f6 = $3lJ0u.getCiphers;
$7de568f77242e9e6$export$dedd8dc3dc62b370 = $3lJ0u.listCiphers;

var $4evoR = parcelRequire("4evoR");
$7de568f77242e9e6$export$971862a2fcb1bb40 = $4evoR.DiffieHellmanGroup;
$7de568f77242e9e6$export$c6ff6a88acbeaf40 = $4evoR.createDiffieHellmanGroup;
$7de568f77242e9e6$export$fdc27893e98845cc = $4evoR.getDiffieHellman;
$7de568f77242e9e6$export$6671fb9a1323bed = $4evoR.createDiffieHellman;
$7de568f77242e9e6$export$d74daf141a551db = $4evoR.DiffieHellman;

var $bOCXe = parcelRequire("bOCXe");
$7de568f77242e9e6$export$45df7cae684751af = $bOCXe.createSign;
$7de568f77242e9e6$export$1db683ad541682f6 = $bOCXe.Sign;
$7de568f77242e9e6$export$6f65485f87568e37 = $bOCXe.createVerify;
$7de568f77242e9e6$export$91a8e56769aeb334 = $bOCXe.Verify;

$7de568f77242e9e6$export$2d4117e99c2179e4 = (parcelRequire("bpRNH"));

var $e8Hvp = parcelRequire("e8Hvp");
$7de568f77242e9e6$export$512823e338ddb1b7 = $e8Hvp.publicEncrypt;
$7de568f77242e9e6$export$9d0e0c0c4a8d30f3 = $e8Hvp.privateEncrypt;
$7de568f77242e9e6$export$b9d55ff329113abd = $e8Hvp.publicDecrypt;
$7de568f77242e9e6$export$7efb24e2fddf99b9 = $e8Hvp.privateDecrypt;

var $6zHAr = parcelRequire("6zHAr");
$7de568f77242e9e6$export$bb1abf2ce84fc7e8 = $6zHAr.randomFill;
$7de568f77242e9e6$export$2f7171e78e524d5e = $6zHAr.randomFillSync;
$7de568f77242e9e6$export$e1d879b482f37d98 = function() {
    throw new Error([
        "sorry, createCredentials is not implemented yet",
        "we accept pull requests",
        "https://github.com/crypto-browserify/crypto-browserify"
    ].join("\n"));
};
$7de568f77242e9e6$export$1a988e7317c65621 = {
    "DH_CHECK_P_NOT_SAFE_PRIME": 2,
    "DH_CHECK_P_NOT_PRIME": 1,
    "DH_UNABLE_TO_CHECK_GENERATOR": 4,
    "DH_NOT_SUITABLE_GENERATOR": 8,
    "NPN_ENABLED": 1,
    "ALPN_ENABLED": 1,
    "RSA_PKCS1_PADDING": 1,
    "RSA_SSLV23_PADDING": 2,
    "RSA_NO_PADDING": 3,
    "RSA_PKCS1_OAEP_PADDING": 4,
    "RSA_X931_PADDING": 5,
    "RSA_PKCS1_PSS_PADDING": 6,
    "POINT_CONVERSION_COMPRESSED": 2,
    "POINT_CONVERSION_UNCOMPRESSED": 4,
    "POINT_CONVERSION_HYBRID": 6
};

});
parcelRequire.register("5rfiH", function(module, exports) {

var $4TNnu = parcelRequire("4TNnu");
"use strict";
// limit of Crypto.getRandomValues()
// https://developer.mozilla.org/en-US/docs/Web/API/Crypto/getRandomValues
var $3f5b57c5e5054ef5$var$MAX_BYTES = 65536;
// Node supports requesting up to this number of bytes
// https://github.com/nodejs/node/blob/master/lib/internal/crypto/random.js#L48
var $3f5b57c5e5054ef5$var$MAX_UINT32 = 4294967295;
function $3f5b57c5e5054ef5$var$oldBrowser() {
    throw new Error("Secure random number generation is not supported by this browser.\nUse Chrome, Firefox or Internet Explorer 11");
}

var $6U9mG = parcelRequire("6U9mG");
var $3f5b57c5e5054ef5$require$Buffer = $6U9mG.Buffer;
var $3f5b57c5e5054ef5$var$crypto = $parcel$global.crypto || $parcel$global.msCrypto;
if ($3f5b57c5e5054ef5$var$crypto && $3f5b57c5e5054ef5$var$crypto.getRandomValues) module.exports = $3f5b57c5e5054ef5$var$randomBytes;
else module.exports = $3f5b57c5e5054ef5$var$oldBrowser;
function $3f5b57c5e5054ef5$var$randomBytes(size, cb) {
    // phantomjs needs to throw
    if (size > $3f5b57c5e5054ef5$var$MAX_UINT32) throw new RangeError("requested too many random bytes");
    var bytes = $3f5b57c5e5054ef5$require$Buffer.allocUnsafe(size);
    if (size > 0) {
        if (size > $3f5b57c5e5054ef5$var$MAX_BYTES) // can do at once see https://developer.mozilla.org/en-US/docs/Web/API/window.crypto.getRandomValues
        for(var generated = 0; generated < size; generated += $3f5b57c5e5054ef5$var$MAX_BYTES)// buffer.slice automatically checks if the end is past the end of
        // the buffer so we don't have to here
        $3f5b57c5e5054ef5$var$crypto.getRandomValues(bytes.slice(generated, generated + $3f5b57c5e5054ef5$var$MAX_BYTES));
        else $3f5b57c5e5054ef5$var$crypto.getRandomValues(bytes);
    }
    if (typeof cb === "function") return $4TNnu.nextTick(function() {
        cb(null, bytes);
    });
    return bytes;
}

});
parcelRequire.register("6U9mG", function(module, exports) {
/*! safe-buffer. MIT License. Feross Aboukhadijeh <https://feross.org/opensource> */ /* eslint-disable node/no-deprecated-api */ 
var $ihoyg = parcelRequire("ihoyg");
var $506f3cb9e9ae23e7$var$Buffer = $ihoyg.Buffer;
// alternative to using Object.keys for old browsers
function $506f3cb9e9ae23e7$var$copyProps(src, dst) {
    for(var key in src)dst[key] = src[key];
}
if ($506f3cb9e9ae23e7$var$Buffer.from && $506f3cb9e9ae23e7$var$Buffer.alloc && $506f3cb9e9ae23e7$var$Buffer.allocUnsafe && $506f3cb9e9ae23e7$var$Buffer.allocUnsafeSlow) module.exports = $ihoyg;
else {
    // Copy properties from require('buffer')
    $506f3cb9e9ae23e7$var$copyProps($ihoyg, module.exports);
    module.exports.Buffer = $506f3cb9e9ae23e7$var$SafeBuffer;
}
function $506f3cb9e9ae23e7$var$SafeBuffer(arg, encodingOrOffset, length) {
    return $506f3cb9e9ae23e7$var$Buffer(arg, encodingOrOffset, length);
}
$506f3cb9e9ae23e7$var$SafeBuffer.prototype = Object.create($506f3cb9e9ae23e7$var$Buffer.prototype);
// Copy static methods from Buffer
$506f3cb9e9ae23e7$var$copyProps($506f3cb9e9ae23e7$var$Buffer, $506f3cb9e9ae23e7$var$SafeBuffer);
$506f3cb9e9ae23e7$var$SafeBuffer.from = function(arg, encodingOrOffset, length) {
    if (typeof arg === "number") throw new TypeError("Argument must not be a number");
    return $506f3cb9e9ae23e7$var$Buffer(arg, encodingOrOffset, length);
};
$506f3cb9e9ae23e7$var$SafeBuffer.alloc = function(size, fill, encoding) {
    if (typeof size !== "number") throw new TypeError("Argument must be a number");
    var buf = $506f3cb9e9ae23e7$var$Buffer(size);
    if (fill !== undefined) {
        if (typeof encoding === "string") buf.fill(fill, encoding);
        else buf.fill(fill);
    } else buf.fill(0);
    return buf;
};
$506f3cb9e9ae23e7$var$SafeBuffer.allocUnsafe = function(size) {
    if (typeof size !== "number") throw new TypeError("Argument must be a number");
    return $506f3cb9e9ae23e7$var$Buffer(size);
};
$506f3cb9e9ae23e7$var$SafeBuffer.allocUnsafeSlow = function(size) {
    if (typeof size !== "number") throw new TypeError("Argument must be a number");
    return $ihoyg.SlowBuffer(size);
};

});


parcelRequire.register("3FiLE", function(module, exports) {
"use strict";

var $eSHUL = parcelRequire("eSHUL");

var $cvCaQ = parcelRequire("cvCaQ");

var $cjuEr = parcelRequire("cjuEr");

var $fkJVr = parcelRequire("fkJVr");

var $fpHcA = parcelRequire("fpHcA");
function $2ab3c24d6f7239f3$var$Hash(hash) {
    $fpHcA.call(this, "digest");
    this._hash = hash;
}
$eSHUL($2ab3c24d6f7239f3$var$Hash, $fpHcA);
$2ab3c24d6f7239f3$var$Hash.prototype._update = function(data) {
    this._hash.update(data);
};
$2ab3c24d6f7239f3$var$Hash.prototype._final = function() {
    return this._hash.digest();
};
module.exports = function createHash(alg) {
    alg = alg.toLowerCase();
    if (alg === "md5") return new $cvCaQ();
    if (alg === "rmd160" || alg === "ripemd160") return new $cjuEr();
    return new $2ab3c24d6f7239f3$var$Hash($fkJVr(alg));
};

});
parcelRequire.register("cvCaQ", function(module, exports) {
"use strict";

var $eSHUL = parcelRequire("eSHUL");

var $9aUYR = parcelRequire("9aUYR");

var $6U9mG = parcelRequire("6U9mG");
var $91b5fdd475e07956$require$Buffer = $6U9mG.Buffer;
var $91b5fdd475e07956$var$ARRAY16 = new Array(16);
function $91b5fdd475e07956$var$MD5() {
    $9aUYR.call(this, 64);
    // state
    this._a = 0x67452301;
    this._b = 0xefcdab89;
    this._c = 0x98badcfe;
    this._d = 0x10325476;
}
$eSHUL($91b5fdd475e07956$var$MD5, $9aUYR);
$91b5fdd475e07956$var$MD5.prototype._update = function() {
    var M = $91b5fdd475e07956$var$ARRAY16;
    for(var i = 0; i < 16; ++i)M[i] = this._block.readInt32LE(i * 4);
    var a = this._a;
    var b = this._b;
    var c = this._c;
    var d = this._d;
    a = $91b5fdd475e07956$var$fnF(a, b, c, d, M[0], 0xd76aa478, 7);
    d = $91b5fdd475e07956$var$fnF(d, a, b, c, M[1], 0xe8c7b756, 12);
    c = $91b5fdd475e07956$var$fnF(c, d, a, b, M[2], 0x242070db, 17);
    b = $91b5fdd475e07956$var$fnF(b, c, d, a, M[3], 0xc1bdceee, 22);
    a = $91b5fdd475e07956$var$fnF(a, b, c, d, M[4], 0xf57c0faf, 7);
    d = $91b5fdd475e07956$var$fnF(d, a, b, c, M[5], 0x4787c62a, 12);
    c = $91b5fdd475e07956$var$fnF(c, d, a, b, M[6], 0xa8304613, 17);
    b = $91b5fdd475e07956$var$fnF(b, c, d, a, M[7], 0xfd469501, 22);
    a = $91b5fdd475e07956$var$fnF(a, b, c, d, M[8], 0x698098d8, 7);
    d = $91b5fdd475e07956$var$fnF(d, a, b, c, M[9], 0x8b44f7af, 12);
    c = $91b5fdd475e07956$var$fnF(c, d, a, b, M[10], 0xffff5bb1, 17);
    b = $91b5fdd475e07956$var$fnF(b, c, d, a, M[11], 0x895cd7be, 22);
    a = $91b5fdd475e07956$var$fnF(a, b, c, d, M[12], 0x6b901122, 7);
    d = $91b5fdd475e07956$var$fnF(d, a, b, c, M[13], 0xfd987193, 12);
    c = $91b5fdd475e07956$var$fnF(c, d, a, b, M[14], 0xa679438e, 17);
    b = $91b5fdd475e07956$var$fnF(b, c, d, a, M[15], 0x49b40821, 22);
    a = $91b5fdd475e07956$var$fnG(a, b, c, d, M[1], 0xf61e2562, 5);
    d = $91b5fdd475e07956$var$fnG(d, a, b, c, M[6], 0xc040b340, 9);
    c = $91b5fdd475e07956$var$fnG(c, d, a, b, M[11], 0x265e5a51, 14);
    b = $91b5fdd475e07956$var$fnG(b, c, d, a, M[0], 0xe9b6c7aa, 20);
    a = $91b5fdd475e07956$var$fnG(a, b, c, d, M[5], 0xd62f105d, 5);
    d = $91b5fdd475e07956$var$fnG(d, a, b, c, M[10], 0x02441453, 9);
    c = $91b5fdd475e07956$var$fnG(c, d, a, b, M[15], 0xd8a1e681, 14);
    b = $91b5fdd475e07956$var$fnG(b, c, d, a, M[4], 0xe7d3fbc8, 20);
    a = $91b5fdd475e07956$var$fnG(a, b, c, d, M[9], 0x21e1cde6, 5);
    d = $91b5fdd475e07956$var$fnG(d, a, b, c, M[14], 0xc33707d6, 9);
    c = $91b5fdd475e07956$var$fnG(c, d, a, b, M[3], 0xf4d50d87, 14);
    b = $91b5fdd475e07956$var$fnG(b, c, d, a, M[8], 0x455a14ed, 20);
    a = $91b5fdd475e07956$var$fnG(a, b, c, d, M[13], 0xa9e3e905, 5);
    d = $91b5fdd475e07956$var$fnG(d, a, b, c, M[2], 0xfcefa3f8, 9);
    c = $91b5fdd475e07956$var$fnG(c, d, a, b, M[7], 0x676f02d9, 14);
    b = $91b5fdd475e07956$var$fnG(b, c, d, a, M[12], 0x8d2a4c8a, 20);
    a = $91b5fdd475e07956$var$fnH(a, b, c, d, M[5], 0xfffa3942, 4);
    d = $91b5fdd475e07956$var$fnH(d, a, b, c, M[8], 0x8771f681, 11);
    c = $91b5fdd475e07956$var$fnH(c, d, a, b, M[11], 0x6d9d6122, 16);
    b = $91b5fdd475e07956$var$fnH(b, c, d, a, M[14], 0xfde5380c, 23);
    a = $91b5fdd475e07956$var$fnH(a, b, c, d, M[1], 0xa4beea44, 4);
    d = $91b5fdd475e07956$var$fnH(d, a, b, c, M[4], 0x4bdecfa9, 11);
    c = $91b5fdd475e07956$var$fnH(c, d, a, b, M[7], 0xf6bb4b60, 16);
    b = $91b5fdd475e07956$var$fnH(b, c, d, a, M[10], 0xbebfbc70, 23);
    a = $91b5fdd475e07956$var$fnH(a, b, c, d, M[13], 0x289b7ec6, 4);
    d = $91b5fdd475e07956$var$fnH(d, a, b, c, M[0], 0xeaa127fa, 11);
    c = $91b5fdd475e07956$var$fnH(c, d, a, b, M[3], 0xd4ef3085, 16);
    b = $91b5fdd475e07956$var$fnH(b, c, d, a, M[6], 0x04881d05, 23);
    a = $91b5fdd475e07956$var$fnH(a, b, c, d, M[9], 0xd9d4d039, 4);
    d = $91b5fdd475e07956$var$fnH(d, a, b, c, M[12], 0xe6db99e5, 11);
    c = $91b5fdd475e07956$var$fnH(c, d, a, b, M[15], 0x1fa27cf8, 16);
    b = $91b5fdd475e07956$var$fnH(b, c, d, a, M[2], 0xc4ac5665, 23);
    a = $91b5fdd475e07956$var$fnI(a, b, c, d, M[0], 0xf4292244, 6);
    d = $91b5fdd475e07956$var$fnI(d, a, b, c, M[7], 0x432aff97, 10);
    c = $91b5fdd475e07956$var$fnI(c, d, a, b, M[14], 0xab9423a7, 15);
    b = $91b5fdd475e07956$var$fnI(b, c, d, a, M[5], 0xfc93a039, 21);
    a = $91b5fdd475e07956$var$fnI(a, b, c, d, M[12], 0x655b59c3, 6);
    d = $91b5fdd475e07956$var$fnI(d, a, b, c, M[3], 0x8f0ccc92, 10);
    c = $91b5fdd475e07956$var$fnI(c, d, a, b, M[10], 0xffeff47d, 15);
    b = $91b5fdd475e07956$var$fnI(b, c, d, a, M[1], 0x85845dd1, 21);
    a = $91b5fdd475e07956$var$fnI(a, b, c, d, M[8], 0x6fa87e4f, 6);
    d = $91b5fdd475e07956$var$fnI(d, a, b, c, M[15], 0xfe2ce6e0, 10);
    c = $91b5fdd475e07956$var$fnI(c, d, a, b, M[6], 0xa3014314, 15);
    b = $91b5fdd475e07956$var$fnI(b, c, d, a, M[13], 0x4e0811a1, 21);
    a = $91b5fdd475e07956$var$fnI(a, b, c, d, M[4], 0xf7537e82, 6);
    d = $91b5fdd475e07956$var$fnI(d, a, b, c, M[11], 0xbd3af235, 10);
    c = $91b5fdd475e07956$var$fnI(c, d, a, b, M[2], 0x2ad7d2bb, 15);
    b = $91b5fdd475e07956$var$fnI(b, c, d, a, M[9], 0xeb86d391, 21);
    this._a = this._a + a | 0;
    this._b = this._b + b | 0;
    this._c = this._c + c | 0;
    this._d = this._d + d | 0;
};
$91b5fdd475e07956$var$MD5.prototype._digest = function() {
    // create padding and handle blocks
    this._block[this._blockOffset++] = 0x80;
    if (this._blockOffset > 56) {
        this._block.fill(0, this._blockOffset, 64);
        this._update();
        this._blockOffset = 0;
    }
    this._block.fill(0, this._blockOffset, 56);
    this._block.writeUInt32LE(this._length[0], 56);
    this._block.writeUInt32LE(this._length[1], 60);
    this._update();
    // produce result
    var buffer = $91b5fdd475e07956$require$Buffer.allocUnsafe(16);
    buffer.writeInt32LE(this._a, 0);
    buffer.writeInt32LE(this._b, 4);
    buffer.writeInt32LE(this._c, 8);
    buffer.writeInt32LE(this._d, 12);
    return buffer;
};
function $91b5fdd475e07956$var$rotl(x, n) {
    return x << n | x >>> 32 - n;
}
function $91b5fdd475e07956$var$fnF(a, b, c, d, m, k, s) {
    return $91b5fdd475e07956$var$rotl(a + (b & c | ~b & d) + m + k | 0, s) + b | 0;
}
function $91b5fdd475e07956$var$fnG(a, b, c, d, m, k, s) {
    return $91b5fdd475e07956$var$rotl(a + (b & d | c & ~d) + m + k | 0, s) + b | 0;
}
function $91b5fdd475e07956$var$fnH(a, b, c, d, m, k, s) {
    return $91b5fdd475e07956$var$rotl(a + (b ^ c ^ d) + m + k | 0, s) + b | 0;
}
function $91b5fdd475e07956$var$fnI(a, b, c, d, m, k, s) {
    return $91b5fdd475e07956$var$rotl(a + (c ^ (b | ~d)) + m + k | 0, s) + b | 0;
}
module.exports = $91b5fdd475e07956$var$MD5;

});
parcelRequire.register("9aUYR", function(module, exports) {
"use strict";

var $6U9mG = parcelRequire("6U9mG");
var $6ae13f602076a4da$require$Buffer = $6U9mG.Buffer;

var $9AddZ = parcelRequire("9AddZ");
var $6ae13f602076a4da$require$Transform = $9AddZ.Transform;

var $eSHUL = parcelRequire("eSHUL");
function $6ae13f602076a4da$var$throwIfNotStringOrBuffer(val, prefix) {
    if (!$6ae13f602076a4da$require$Buffer.isBuffer(val) && typeof val !== "string") throw new TypeError(prefix + " must be a string or a buffer");
}
function $6ae13f602076a4da$var$HashBase(blockSize) {
    $6ae13f602076a4da$require$Transform.call(this);
    this._block = $6ae13f602076a4da$require$Buffer.allocUnsafe(blockSize);
    this._blockSize = blockSize;
    this._blockOffset = 0;
    this._length = [
        0,
        0,
        0,
        0
    ];
    this._finalized = false;
}
$eSHUL($6ae13f602076a4da$var$HashBase, $6ae13f602076a4da$require$Transform);
$6ae13f602076a4da$var$HashBase.prototype._transform = function(chunk, encoding, callback) {
    var error = null;
    try {
        this.update(chunk, encoding);
    } catch (err) {
        error = err;
    }
    callback(error);
};
$6ae13f602076a4da$var$HashBase.prototype._flush = function(callback) {
    var error = null;
    try {
        this.push(this.digest());
    } catch (err) {
        error = err;
    }
    callback(error);
};
$6ae13f602076a4da$var$HashBase.prototype.update = function(data, encoding) {
    $6ae13f602076a4da$var$throwIfNotStringOrBuffer(data, "Data");
    if (this._finalized) throw new Error("Digest already called");
    if (!$6ae13f602076a4da$require$Buffer.isBuffer(data)) data = $6ae13f602076a4da$require$Buffer.from(data, encoding);
    // consume data
    var block = this._block;
    var offset = 0;
    while(this._blockOffset + data.length - offset >= this._blockSize){
        for(var i = this._blockOffset; i < this._blockSize;)block[i++] = data[offset++];
        this._update();
        this._blockOffset = 0;
    }
    while(offset < data.length)block[this._blockOffset++] = data[offset++];
    // update length
    for(var j = 0, carry = data.length * 8; carry > 0; ++j){
        this._length[j] += carry;
        carry = this._length[j] / 0x0100000000 | 0;
        if (carry > 0) this._length[j] -= 0x0100000000 * carry;
    }
    return this;
};
$6ae13f602076a4da$var$HashBase.prototype._update = function() {
    throw new Error("_update is not implemented");
};
$6ae13f602076a4da$var$HashBase.prototype.digest = function(encoding) {
    if (this._finalized) throw new Error("Digest already called");
    this._finalized = true;
    var digest = this._digest();
    if (encoding !== undefined) digest = digest.toString(encoding);
    // reset state
    this._block.fill(0);
    this._blockOffset = 0;
    for(var i = 0; i < 4; ++i)this._length[i] = 0;
    return digest;
};
$6ae13f602076a4da$var$HashBase.prototype._digest = function() {
    throw new Error("_digest is not implemented");
};
module.exports = $6ae13f602076a4da$var$HashBase;

});
parcelRequire.register("9AddZ", function(module, exports) {

exports = module.exports = (parcelRequire("cEnbP"));
exports.Stream = exports;
exports.Readable = exports;

exports.Writable = (parcelRequire("cuAoD"));

exports.Duplex = (parcelRequire("2Hlr9"));

exports.Transform = (parcelRequire("l7DDn"));

exports.PassThrough = (parcelRequire("6VFzs"));

exports.finished = (parcelRequire("gr8mb"));

exports.pipeline = (parcelRequire("e8JAK"));

});
parcelRequire.register("cEnbP", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

var $4TNnu = parcelRequire("4TNnu");
"use strict";
module.exports = $935b35782dc2f587$var$Readable;
/*<replacement>*/ var $935b35782dc2f587$var$Duplex;
/*</replacement>*/ $935b35782dc2f587$var$Readable.ReadableState = $935b35782dc2f587$var$ReadableState;

var $jMc9N = parcelRequire("jMc9N");
var $935b35782dc2f587$require$EE = $jMc9N.EventEmitter;
var $935b35782dc2f587$var$EElistenerCount = function EElistenerCount(emitter, type) {
    return emitter.listeners(type).length;
};

var $j5tZS = parcelRequire("j5tZS");

var $ihoyg = parcelRequire("ihoyg");
var $935b35782dc2f587$require$Buffer = $ihoyg.Buffer;
var $935b35782dc2f587$var$OurUint8Array = (typeof $parcel$global !== "undefined" ? $parcel$global : typeof window !== "undefined" ? window : typeof self !== "undefined" ? self : {}).Uint8Array || function() {};
function $935b35782dc2f587$var$_uint8ArrayToBuffer(chunk) {
    return $935b35782dc2f587$require$Buffer.from(chunk);
}
function $935b35782dc2f587$var$_isUint8Array(obj) {
    return $935b35782dc2f587$require$Buffer.isBuffer(obj) || obj instanceof $935b35782dc2f587$var$OurUint8Array;
}

var $5Io6y = parcelRequire("5Io6y");
var $935b35782dc2f587$var$debug;
if ($5Io6y && $5Io6y.debuglog) $935b35782dc2f587$var$debug = $5Io6y.debuglog("stream");
else $935b35782dc2f587$var$debug = function debug() {};

var $5KjdV = parcelRequire("5KjdV");

var $kZIsm = parcelRequire("kZIsm");

var $ipGaF = parcelRequire("ipGaF");
var $935b35782dc2f587$var$getHighWaterMark = $ipGaF.getHighWaterMark;

var $dzxhd = parcelRequire("dzxhd");
var $935b35782dc2f587$require$_require$codes = $dzxhd.codes;
var $935b35782dc2f587$var$ERR_INVALID_ARG_TYPE = $935b35782dc2f587$require$_require$codes.ERR_INVALID_ARG_TYPE, $935b35782dc2f587$var$ERR_STREAM_PUSH_AFTER_EOF = $935b35782dc2f587$require$_require$codes.ERR_STREAM_PUSH_AFTER_EOF, $935b35782dc2f587$var$ERR_METHOD_NOT_IMPLEMENTED = $935b35782dc2f587$require$_require$codes.ERR_METHOD_NOT_IMPLEMENTED, $935b35782dc2f587$var$ERR_STREAM_UNSHIFT_AFTER_END_EVENT = $935b35782dc2f587$require$_require$codes.ERR_STREAM_UNSHIFT_AFTER_END_EVENT;
// Lazy loaded to improve the startup performance.
var $935b35782dc2f587$var$StringDecoder;
var $935b35782dc2f587$var$createReadableStreamAsyncIterator;
var $935b35782dc2f587$var$from;

(parcelRequire("eSHUL"))($935b35782dc2f587$var$Readable, $j5tZS);
var $935b35782dc2f587$var$errorOrDestroy = $kZIsm.errorOrDestroy;
var $935b35782dc2f587$var$kProxyEvents = [
    "error",
    "close",
    "destroy",
    "pause",
    "resume"
];
function $935b35782dc2f587$var$prependListener(emitter, event, fn) {
    // Sadly this is not cacheable as some libraries bundle their own
    // event emitter implementation with them.
    if (typeof emitter.prependListener === "function") return emitter.prependListener(event, fn);
    // This is a hack to make sure that our error handler is attached before any
    // userland ones.  NEVER DO THIS. This is here only because this code needs
    // to continue to work with older versions of Node.js that do not include
    // the prependListener() method. The goal is to eventually remove this hack.
    if (!emitter._events || !emitter._events[event]) emitter.on(event, fn);
    else if (Array.isArray(emitter._events[event])) emitter._events[event].unshift(fn);
    else emitter._events[event] = [
        fn,
        emitter._events[event]
    ];
}


function $935b35782dc2f587$var$ReadableState(options, stream, isDuplex) {
    $935b35782dc2f587$var$Duplex = $935b35782dc2f587$var$Duplex || (parcelRequire("2Hlr9"));
    options = options || {};
    // Duplex streams are both readable and writable, but share
    // the same options object.
    // However, some cases require setting options to different
    // values for the readable and the writable sides of the duplex stream.
    // These options can be provided separately as readableXXX and writableXXX.
    if (typeof isDuplex !== "boolean") isDuplex = stream instanceof $935b35782dc2f587$var$Duplex;
    // object stream flag. Used to make read(n) ignore n and to
    // make all the buffer merging and length checks go away
    this.objectMode = !!options.objectMode;
    if (isDuplex) this.objectMode = this.objectMode || !!options.readableObjectMode;
    // the point at which it stops calling _read() to fill the buffer
    // Note: 0 is a valid value, means "don't call _read preemptively ever"
    this.highWaterMark = $935b35782dc2f587$var$getHighWaterMark(this, options, "readableHighWaterMark", isDuplex);
    // A linked list is used to store data chunks instead of an array because the
    // linked list can remove elements from the beginning faster than
    // array.shift()
    this.buffer = new $5KjdV();
    this.length = 0;
    this.pipes = null;
    this.pipesCount = 0;
    this.flowing = null;
    this.ended = false;
    this.endEmitted = false;
    this.reading = false;
    // a flag to be able to tell if the event 'readable'/'data' is emitted
    // immediately, or on a later tick.  We set this to true at first, because
    // any actions that shouldn't happen until "later" should generally also
    // not happen before the first read call.
    this.sync = true;
    // whenever we return null, then we set a flag to say
    // that we're awaiting a 'readable' event emission.
    this.needReadable = false;
    this.emittedReadable = false;
    this.readableListening = false;
    this.resumeScheduled = false;
    this.paused = true;
    // Should close be emitted on destroy. Defaults to true.
    this.emitClose = options.emitClose !== false;
    // Should .destroy() be called after 'end' (and potentially 'finish')
    this.autoDestroy = !!options.autoDestroy;
    // has it been destroyed
    this.destroyed = false;
    // Crypto is kind of old and crusty.  Historically, its default string
    // encoding is 'binary' so we have to make this configurable.
    // Everything else in the universe uses 'utf8', though.
    this.defaultEncoding = options.defaultEncoding || "utf8";
    // the number of writers that are awaiting a drain event in .pipe()s
    this.awaitDrain = 0;
    // if true, a maybeReadMore has been scheduled
    this.readingMore = false;
    this.decoder = null;
    this.encoding = null;
    if (options.encoding) {
        if (!$935b35782dc2f587$var$StringDecoder) $935b35782dc2f587$var$StringDecoder = (parcelRequire("lEpDX")).StringDecoder;
        this.decoder = new $935b35782dc2f587$var$StringDecoder(options.encoding);
        this.encoding = options.encoding;
    }
}

function $935b35782dc2f587$var$Readable(options) {
    $935b35782dc2f587$var$Duplex = $935b35782dc2f587$var$Duplex || (parcelRequire("2Hlr9"));
    if (!(this instanceof $935b35782dc2f587$var$Readable)) return new $935b35782dc2f587$var$Readable(options);
    // Checking for a Stream.Duplex instance is faster here instead of inside
    // the ReadableState constructor, at least with V8 6.5
    var isDuplex = this instanceof $935b35782dc2f587$var$Duplex;
    this._readableState = new $935b35782dc2f587$var$ReadableState(options, this, isDuplex);
    // legacy
    this.readable = true;
    if (options) {
        if (typeof options.read === "function") this._read = options.read;
        if (typeof options.destroy === "function") this._destroy = options.destroy;
    }
    $j5tZS.call(this);
}
Object.defineProperty($935b35782dc2f587$var$Readable.prototype, "destroyed", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        if (this._readableState === undefined) return false;
        return this._readableState.destroyed;
    },
    set: function set(value) {
        // we ignore the value if the stream
        // has not been initialized yet
        if (!this._readableState) return;
        // backward compatibility, the user is explicitly
        // managing destroyed
        this._readableState.destroyed = value;
    }
});
$935b35782dc2f587$var$Readable.prototype.destroy = $kZIsm.destroy;
$935b35782dc2f587$var$Readable.prototype._undestroy = $kZIsm.undestroy;
$935b35782dc2f587$var$Readable.prototype._destroy = function(err, cb) {
    cb(err);
};
// Manually shove something into the read() buffer.
// This returns true if the highWaterMark has not been hit yet,
// similar to how Writable.write() returns true if you should
// write() some more.
$935b35782dc2f587$var$Readable.prototype.push = function(chunk, encoding) {
    var state = this._readableState;
    var skipChunkCheck;
    if (!state.objectMode) {
        if (typeof chunk === "string") {
            encoding = encoding || state.defaultEncoding;
            if (encoding !== state.encoding) {
                chunk = $935b35782dc2f587$require$Buffer.from(chunk, encoding);
                encoding = "";
            }
            skipChunkCheck = true;
        }
    } else skipChunkCheck = true;
    return $935b35782dc2f587$var$readableAddChunk(this, chunk, encoding, false, skipChunkCheck);
};
// Unshift should *always* be something directly out of read()
$935b35782dc2f587$var$Readable.prototype.unshift = function(chunk) {
    return $935b35782dc2f587$var$readableAddChunk(this, chunk, null, true, false);
};
function $935b35782dc2f587$var$readableAddChunk(stream, chunk, encoding, addToFront, skipChunkCheck) {
    $935b35782dc2f587$var$debug("readableAddChunk", chunk);
    var state = stream._readableState;
    if (chunk === null) {
        state.reading = false;
        $935b35782dc2f587$var$onEofChunk(stream, state);
    } else {
        var er;
        if (!skipChunkCheck) er = $935b35782dc2f587$var$chunkInvalid(state, chunk);
        if (er) $935b35782dc2f587$var$errorOrDestroy(stream, er);
        else if (state.objectMode || chunk && chunk.length > 0) {
            if (typeof chunk !== "string" && !state.objectMode && Object.getPrototypeOf(chunk) !== $935b35782dc2f587$require$Buffer.prototype) chunk = $935b35782dc2f587$var$_uint8ArrayToBuffer(chunk);
            if (addToFront) {
                if (state.endEmitted) $935b35782dc2f587$var$errorOrDestroy(stream, new $935b35782dc2f587$var$ERR_STREAM_UNSHIFT_AFTER_END_EVENT());
                else $935b35782dc2f587$var$addChunk(stream, state, chunk, true);
            } else if (state.ended) $935b35782dc2f587$var$errorOrDestroy(stream, new $935b35782dc2f587$var$ERR_STREAM_PUSH_AFTER_EOF());
            else if (state.destroyed) return false;
            else {
                state.reading = false;
                if (state.decoder && !encoding) {
                    chunk = state.decoder.write(chunk);
                    if (state.objectMode || chunk.length !== 0) $935b35782dc2f587$var$addChunk(stream, state, chunk, false);
                    else $935b35782dc2f587$var$maybeReadMore(stream, state);
                } else $935b35782dc2f587$var$addChunk(stream, state, chunk, false);
            }
        } else if (!addToFront) {
            state.reading = false;
            $935b35782dc2f587$var$maybeReadMore(stream, state);
        }
    }
    // We can push more data if we are below the highWaterMark.
    // Also, if we have no data yet, we can stand some more bytes.
    // This is to work around cases where hwm=0, such as the repl.
    return !state.ended && (state.length < state.highWaterMark || state.length === 0);
}
function $935b35782dc2f587$var$addChunk(stream, state, chunk, addToFront) {
    if (state.flowing && state.length === 0 && !state.sync) {
        state.awaitDrain = 0;
        stream.emit("data", chunk);
    } else {
        // update the buffer info.
        state.length += state.objectMode ? 1 : chunk.length;
        if (addToFront) state.buffer.unshift(chunk);
        else state.buffer.push(chunk);
        if (state.needReadable) $935b35782dc2f587$var$emitReadable(stream);
    }
    $935b35782dc2f587$var$maybeReadMore(stream, state);
}
function $935b35782dc2f587$var$chunkInvalid(state, chunk) {
    var er;
    if (!$935b35782dc2f587$var$_isUint8Array(chunk) && typeof chunk !== "string" && chunk !== undefined && !state.objectMode) er = new $935b35782dc2f587$var$ERR_INVALID_ARG_TYPE("chunk", [
        "string",
        "Buffer",
        "Uint8Array"
    ], chunk);
    return er;
}
$935b35782dc2f587$var$Readable.prototype.isPaused = function() {
    return this._readableState.flowing === false;
};

// backwards compatibility.
$935b35782dc2f587$var$Readable.prototype.setEncoding = function(enc) {
    if (!$935b35782dc2f587$var$StringDecoder) $935b35782dc2f587$var$StringDecoder = (parcelRequire("lEpDX")).StringDecoder;
    var decoder = new $935b35782dc2f587$var$StringDecoder(enc);
    this._readableState.decoder = decoder;
    // If setEncoding(null), decoder.encoding equals utf8
    this._readableState.encoding = this._readableState.decoder.encoding;
    // Iterate over current buffer to convert already stored Buffers:
    var p = this._readableState.buffer.head;
    var content = "";
    while(p !== null){
        content += decoder.write(p.data);
        p = p.next;
    }
    this._readableState.buffer.clear();
    if (content !== "") this._readableState.buffer.push(content);
    this._readableState.length = content.length;
    return this;
};
// Don't raise the hwm > 1GB
var $935b35782dc2f587$var$MAX_HWM = 0x40000000;
function $935b35782dc2f587$var$computeNewHighWaterMark(n) {
    if (n >= $935b35782dc2f587$var$MAX_HWM) // TODO(ronag): Throw ERR_VALUE_OUT_OF_RANGE.
    n = $935b35782dc2f587$var$MAX_HWM;
    else {
        // Get the next highest power of 2 to prevent increasing hwm excessively in
        // tiny amounts
        n--;
        n |= n >>> 1;
        n |= n >>> 2;
        n |= n >>> 4;
        n |= n >>> 8;
        n |= n >>> 16;
        n++;
    }
    return n;
}
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function $935b35782dc2f587$var$howMuchToRead(n, state) {
    if (n <= 0 || state.length === 0 && state.ended) return 0;
    if (state.objectMode) return 1;
    if (n !== n) {
        // Only flow one buffer at a time
        if (state.flowing && state.length) return state.buffer.head.data.length;
        else return state.length;
    }
    // If we're asking for more than the current hwm, then raise the hwm.
    if (n > state.highWaterMark) state.highWaterMark = $935b35782dc2f587$var$computeNewHighWaterMark(n);
    if (n <= state.length) return n;
    // Don't have enough
    if (!state.ended) {
        state.needReadable = true;
        return 0;
    }
    return state.length;
}
// you can override either this method, or the async _read(n) below.
$935b35782dc2f587$var$Readable.prototype.read = function(n) {
    $935b35782dc2f587$var$debug("read", n);
    n = parseInt(n, 10);
    var state = this._readableState;
    var nOrig = n;
    if (n !== 0) state.emittedReadable = false;
    // if we're doing read(0) to trigger a readable event, but we
    // already have a bunch of data in the buffer, then just trigger
    // the 'readable' event and move on.
    if (n === 0 && state.needReadable && ((state.highWaterMark !== 0 ? state.length >= state.highWaterMark : state.length > 0) || state.ended)) {
        $935b35782dc2f587$var$debug("read: emitReadable", state.length, state.ended);
        if (state.length === 0 && state.ended) $935b35782dc2f587$var$endReadable(this);
        else $935b35782dc2f587$var$emitReadable(this);
        return null;
    }
    n = $935b35782dc2f587$var$howMuchToRead(n, state);
    // if we've ended, and we're now clear, then finish it up.
    if (n === 0 && state.ended) {
        if (state.length === 0) $935b35782dc2f587$var$endReadable(this);
        return null;
    }
    // All the actual chunk generation logic needs to be
    // *below* the call to _read.  The reason is that in certain
    // synthetic stream cases, such as passthrough streams, _read
    // may be a completely synchronous operation which may change
    // the state of the read buffer, providing enough data when
    // before there was *not* enough.
    //
    // So, the steps are:
    // 1. Figure out what the state of things will be after we do
    // a read from the buffer.
    //
    // 2. If that resulting state will trigger a _read, then call _read.
    // Note that this may be asynchronous, or synchronous.  Yes, it is
    // deeply ugly to write APIs this way, but that still doesn't mean
    // that the Readable class should behave improperly, as streams are
    // designed to be sync/async agnostic.
    // Take note if the _read call is sync or async (ie, if the read call
    // has returned yet), so that we know whether or not it's safe to emit
    // 'readable' etc.
    //
    // 3. Actually pull the requested chunks out of the buffer and return.
    // if we need a readable event, then we need to do some reading.
    var doRead = state.needReadable;
    $935b35782dc2f587$var$debug("need readable", doRead);
    // if we currently have less than the highWaterMark, then also read some
    if (state.length === 0 || state.length - n < state.highWaterMark) {
        doRead = true;
        $935b35782dc2f587$var$debug("length less than watermark", doRead);
    }
    // however, if we've ended, then there's no point, and if we're already
    // reading, then it's unnecessary.
    if (state.ended || state.reading) {
        doRead = false;
        $935b35782dc2f587$var$debug("reading or ended", doRead);
    } else if (doRead) {
        $935b35782dc2f587$var$debug("do read");
        state.reading = true;
        state.sync = true;
        // if the length is currently zero, then we *need* a readable event.
        if (state.length === 0) state.needReadable = true;
        // call internal read method
        this._read(state.highWaterMark);
        state.sync = false;
        // If _read pushed data synchronously, then `reading` will be false,
        // and we need to re-evaluate how much data we can return to the user.
        if (!state.reading) n = $935b35782dc2f587$var$howMuchToRead(nOrig, state);
    }
    var ret;
    if (n > 0) ret = $935b35782dc2f587$var$fromList(n, state);
    else ret = null;
    if (ret === null) {
        state.needReadable = state.length <= state.highWaterMark;
        n = 0;
    } else {
        state.length -= n;
        state.awaitDrain = 0;
    }
    if (state.length === 0) {
        // If we have nothing in the buffer, then we want to know
        // as soon as we *do* get something into the buffer.
        if (!state.ended) state.needReadable = true;
        // If we tried to read() past the EOF, then emit end on the next tick.
        if (nOrig !== n && state.ended) $935b35782dc2f587$var$endReadable(this);
    }
    if (ret !== null) this.emit("data", ret);
    return ret;
};
function $935b35782dc2f587$var$onEofChunk(stream, state) {
    $935b35782dc2f587$var$debug("onEofChunk");
    if (state.ended) return;
    if (state.decoder) {
        var chunk = state.decoder.end();
        if (chunk && chunk.length) {
            state.buffer.push(chunk);
            state.length += state.objectMode ? 1 : chunk.length;
        }
    }
    state.ended = true;
    if (state.sync) // if we are sync, wait until next tick to emit the data.
    // Otherwise we risk emitting data in the flow()
    // the readable code triggers during a read() call
    $935b35782dc2f587$var$emitReadable(stream);
    else {
        // emit 'readable' now to make sure it gets picked up.
        state.needReadable = false;
        if (!state.emittedReadable) {
            state.emittedReadable = true;
            $935b35782dc2f587$var$emitReadable_(stream);
        }
    }
}
// Don't emit readable right away in sync mode, because this can trigger
// another read() call => stack overflow.  This way, it might trigger
// a nextTick recursion warning, but that's not so bad.
function $935b35782dc2f587$var$emitReadable(stream) {
    var state = stream._readableState;
    $935b35782dc2f587$var$debug("emitReadable", state.needReadable, state.emittedReadable);
    state.needReadable = false;
    if (!state.emittedReadable) {
        $935b35782dc2f587$var$debug("emitReadable", state.flowing);
        state.emittedReadable = true;
        $4TNnu.nextTick($935b35782dc2f587$var$emitReadable_, stream);
    }
}
function $935b35782dc2f587$var$emitReadable_(stream) {
    var state = stream._readableState;
    $935b35782dc2f587$var$debug("emitReadable_", state.destroyed, state.length, state.ended);
    if (!state.destroyed && (state.length || state.ended)) {
        stream.emit("readable");
        state.emittedReadable = false;
    }
    // The stream needs another readable event if
    // 1. It is not flowing, as the flow mechanism will take
    //    care of it.
    // 2. It is not ended.
    // 3. It is below the highWaterMark, so we can schedule
    //    another readable later.
    state.needReadable = !state.flowing && !state.ended && state.length <= state.highWaterMark;
    $935b35782dc2f587$var$flow(stream);
}
// at this point, the user has presumably seen the 'readable' event,
// and called read() to consume some data.  that may have triggered
// in turn another _read(n) call, in which case reading = true if
// it's in progress.
// However, if we're not ended, or reading, and the length < hwm,
// then go ahead and try to read some more preemptively.
function $935b35782dc2f587$var$maybeReadMore(stream, state) {
    if (!state.readingMore) {
        state.readingMore = true;
        $4TNnu.nextTick($935b35782dc2f587$var$maybeReadMore_, stream, state);
    }
}
function $935b35782dc2f587$var$maybeReadMore_(stream, state) {
    // Attempt to read more data if we should.
    //
    // The conditions for reading more data are (one of):
    // - Not enough data buffered (state.length < state.highWaterMark). The loop
    //   is responsible for filling the buffer with enough data if such data
    //   is available. If highWaterMark is 0 and we are not in the flowing mode
    //   we should _not_ attempt to buffer any extra data. We'll get more data
    //   when the stream consumer calls read() instead.
    // - No data in the buffer, and the stream is in flowing mode. In this mode
    //   the loop below is responsible for ensuring read() is called. Failing to
    //   call read here would abort the flow and there's no other mechanism for
    //   continuing the flow if the stream consumer has just subscribed to the
    //   'data' event.
    //
    // In addition to the above conditions to keep reading data, the following
    // conditions prevent the data from being read:
    // - The stream has ended (state.ended).
    // - There is already a pending 'read' operation (state.reading). This is a
    //   case where the the stream has called the implementation defined _read()
    //   method, but they are processing the call asynchronously and have _not_
    //   called push() with new data. In this case we skip performing more
    //   read()s. The execution ends in this method again after the _read() ends
    //   up calling push() with more data.
    while(!state.reading && !state.ended && (state.length < state.highWaterMark || state.flowing && state.length === 0)){
        var len = state.length;
        $935b35782dc2f587$var$debug("maybeReadMore read 0");
        stream.read(0);
        if (len === state.length) break;
    }
    state.readingMore = false;
}
// abstract method.  to be overridden in specific implementation classes.
// call cb(er, data) where data is <= n in length.
// for virtual (non-string, non-buffer) streams, "length" is somewhat
// arbitrary, and perhaps not very meaningful.
$935b35782dc2f587$var$Readable.prototype._read = function(n) {
    $935b35782dc2f587$var$errorOrDestroy(this, new $935b35782dc2f587$var$ERR_METHOD_NOT_IMPLEMENTED("_read()"));
};
$935b35782dc2f587$var$Readable.prototype.pipe = function(dest, pipeOpts) {
    var src = this;
    var state = this._readableState;
    switch(state.pipesCount){
        case 0:
            state.pipes = dest;
            break;
        case 1:
            state.pipes = [
                state.pipes,
                dest
            ];
            break;
        default:
            state.pipes.push(dest);
            break;
    }
    state.pipesCount += 1;
    $935b35782dc2f587$var$debug("pipe count=%d opts=%j", state.pipesCount, pipeOpts);
    var doEnd = (!pipeOpts || pipeOpts.end !== false) && dest !== $4TNnu.stdout && dest !== $4TNnu.stderr;
    var endFn = doEnd ? onend : unpipe;
    if (state.endEmitted) $4TNnu.nextTick(endFn);
    else src.once("end", endFn);
    dest.on("unpipe", onunpipe);
    function onunpipe(readable, unpipeInfo) {
        $935b35782dc2f587$var$debug("onunpipe");
        if (readable === src) {
            if (unpipeInfo && unpipeInfo.hasUnpiped === false) {
                unpipeInfo.hasUnpiped = true;
                cleanup();
            }
        }
    }
    function onend() {
        $935b35782dc2f587$var$debug("onend");
        dest.end();
    }
    // when the dest drains, it reduces the awaitDrain counter
    // on the source.  This would be more elegant with a .once()
    // handler in flow(), but adding and removing repeatedly is
    // too slow.
    var ondrain = $935b35782dc2f587$var$pipeOnDrain(src);
    dest.on("drain", ondrain);
    var cleanedUp = false;
    function cleanup() {
        $935b35782dc2f587$var$debug("cleanup");
        // cleanup event handlers once the pipe is broken
        dest.removeListener("close", onclose);
        dest.removeListener("finish", onfinish);
        dest.removeListener("drain", ondrain);
        dest.removeListener("error", onerror);
        dest.removeListener("unpipe", onunpipe);
        src.removeListener("end", onend);
        src.removeListener("end", unpipe);
        src.removeListener("data", ondata);
        cleanedUp = true;
        // if the reader is waiting for a drain event from this
        // specific writer, then it would cause it to never start
        // flowing again.
        // So, if this is awaiting a drain, then we just call it now.
        // If we don't know, then assume that we are waiting for one.
        if (state.awaitDrain && (!dest._writableState || dest._writableState.needDrain)) ondrain();
    }
    src.on("data", ondata);
    function ondata(chunk) {
        $935b35782dc2f587$var$debug("ondata");
        var ret = dest.write(chunk);
        $935b35782dc2f587$var$debug("dest.write", ret);
        if (ret === false) {
            // If the user unpiped during `dest.write()`, it is possible
            // to get stuck in a permanently paused state if that write
            // also returned false.
            // => Check whether `dest` is still a piping destination.
            if ((state.pipesCount === 1 && state.pipes === dest || state.pipesCount > 1 && $935b35782dc2f587$var$indexOf(state.pipes, dest) !== -1) && !cleanedUp) {
                $935b35782dc2f587$var$debug("false write response, pause", state.awaitDrain);
                state.awaitDrain++;
            }
            src.pause();
        }
    }
    // if the dest has an error, then stop piping into it.
    // however, don't suppress the throwing behavior for this.
    function onerror(er) {
        $935b35782dc2f587$var$debug("onerror", er);
        unpipe();
        dest.removeListener("error", onerror);
        if ($935b35782dc2f587$var$EElistenerCount(dest, "error") === 0) $935b35782dc2f587$var$errorOrDestroy(dest, er);
    }
    // Make sure our error handler is attached before userland ones.
    $935b35782dc2f587$var$prependListener(dest, "error", onerror);
    // Both close and finish should trigger unpipe, but only once.
    function onclose() {
        dest.removeListener("finish", onfinish);
        unpipe();
    }
    dest.once("close", onclose);
    function onfinish() {
        $935b35782dc2f587$var$debug("onfinish");
        dest.removeListener("close", onclose);
        unpipe();
    }
    dest.once("finish", onfinish);
    function unpipe() {
        $935b35782dc2f587$var$debug("unpipe");
        src.unpipe(dest);
    }
    // tell the dest that it's being piped to
    dest.emit("pipe", src);
    // start the flow if it hasn't been started already.
    if (!state.flowing) {
        $935b35782dc2f587$var$debug("pipe resume");
        src.resume();
    }
    return dest;
};
function $935b35782dc2f587$var$pipeOnDrain(src) {
    return function pipeOnDrainFunctionResult() {
        var state = src._readableState;
        $935b35782dc2f587$var$debug("pipeOnDrain", state.awaitDrain);
        if (state.awaitDrain) state.awaitDrain--;
        if (state.awaitDrain === 0 && $935b35782dc2f587$var$EElistenerCount(src, "data")) {
            state.flowing = true;
            $935b35782dc2f587$var$flow(src);
        }
    };
}
$935b35782dc2f587$var$Readable.prototype.unpipe = function(dest) {
    var state = this._readableState;
    var unpipeInfo = {
        hasUnpiped: false
    };
    // if we're not piping anywhere, then do nothing.
    if (state.pipesCount === 0) return this;
    // just one destination.  most common case.
    if (state.pipesCount === 1) {
        // passed in one, but it's not the right one.
        if (dest && dest !== state.pipes) return this;
        if (!dest) dest = state.pipes;
        // got a match.
        state.pipes = null;
        state.pipesCount = 0;
        state.flowing = false;
        if (dest) dest.emit("unpipe", this, unpipeInfo);
        return this;
    }
    // slow case. multiple pipe destinations.
    if (!dest) {
        // remove all.
        var dests = state.pipes;
        var len = state.pipesCount;
        state.pipes = null;
        state.pipesCount = 0;
        state.flowing = false;
        for(var i = 0; i < len; i++)dests[i].emit("unpipe", this, {
            hasUnpiped: false
        });
        return this;
    }
    // try to find the right one.
    var index = $935b35782dc2f587$var$indexOf(state.pipes, dest);
    if (index === -1) return this;
    state.pipes.splice(index, 1);
    state.pipesCount -= 1;
    if (state.pipesCount === 1) state.pipes = state.pipes[0];
    dest.emit("unpipe", this, unpipeInfo);
    return this;
};
// set up data events if they are asked for
// Ensure readable listeners eventually get something
$935b35782dc2f587$var$Readable.prototype.on = function(ev, fn) {
    var res = $j5tZS.prototype.on.call(this, ev, fn);
    var state = this._readableState;
    if (ev === "data") {
        // update readableListening so that resume() may be a no-op
        // a few lines down. This is needed to support once('readable').
        state.readableListening = this.listenerCount("readable") > 0;
        // Try start flowing on next tick if stream isn't explicitly paused
        if (state.flowing !== false) this.resume();
    } else if (ev === "readable") {
        if (!state.endEmitted && !state.readableListening) {
            state.readableListening = state.needReadable = true;
            state.flowing = false;
            state.emittedReadable = false;
            $935b35782dc2f587$var$debug("on readable", state.length, state.reading);
            if (state.length) $935b35782dc2f587$var$emitReadable(this);
            else if (!state.reading) $4TNnu.nextTick($935b35782dc2f587$var$nReadingNextTick, this);
        }
    }
    return res;
};
$935b35782dc2f587$var$Readable.prototype.addListener = $935b35782dc2f587$var$Readable.prototype.on;
$935b35782dc2f587$var$Readable.prototype.removeListener = function(ev, fn) {
    var res = $j5tZS.prototype.removeListener.call(this, ev, fn);
    if (ev === "readable") // We need to check if there is someone still listening to
    // readable and reset the state. However this needs to happen
    // after readable has been emitted but before I/O (nextTick) to
    // support once('readable', fn) cycles. This means that calling
    // resume within the same tick will have no
    // effect.
    $4TNnu.nextTick($935b35782dc2f587$var$updateReadableListening, this);
    return res;
};
$935b35782dc2f587$var$Readable.prototype.removeAllListeners = function(ev) {
    var res = $j5tZS.prototype.removeAllListeners.apply(this, arguments);
    if (ev === "readable" || ev === undefined) // We need to check if there is someone still listening to
    // readable and reset the state. However this needs to happen
    // after readable has been emitted but before I/O (nextTick) to
    // support once('readable', fn) cycles. This means that calling
    // resume within the same tick will have no
    // effect.
    $4TNnu.nextTick($935b35782dc2f587$var$updateReadableListening, this);
    return res;
};
function $935b35782dc2f587$var$updateReadableListening(self1) {
    var state = self1._readableState;
    state.readableListening = self1.listenerCount("readable") > 0;
    if (state.resumeScheduled && !state.paused) // flowing needs to be set to true now, otherwise
    // the upcoming resume will not flow.
    state.flowing = true;
    else if (self1.listenerCount("data") > 0) self1.resume();
}
function $935b35782dc2f587$var$nReadingNextTick(self1) {
    $935b35782dc2f587$var$debug("readable nexttick read 0");
    self1.read(0);
}
// pause() and resume() are remnants of the legacy readable stream API
// If the user uses them, then switch into old mode.
$935b35782dc2f587$var$Readable.prototype.resume = function() {
    var state = this._readableState;
    if (!state.flowing) {
        $935b35782dc2f587$var$debug("resume");
        // we flow only if there is no one listening
        // for readable, but we still have to call
        // resume()
        state.flowing = !state.readableListening;
        $935b35782dc2f587$var$resume(this, state);
    }
    state.paused = false;
    return this;
};
function $935b35782dc2f587$var$resume(stream, state) {
    if (!state.resumeScheduled) {
        state.resumeScheduled = true;
        $4TNnu.nextTick($935b35782dc2f587$var$resume_, stream, state);
    }
}
function $935b35782dc2f587$var$resume_(stream, state) {
    $935b35782dc2f587$var$debug("resume", state.reading);
    if (!state.reading) stream.read(0);
    state.resumeScheduled = false;
    stream.emit("resume");
    $935b35782dc2f587$var$flow(stream);
    if (state.flowing && !state.reading) stream.read(0);
}
$935b35782dc2f587$var$Readable.prototype.pause = function() {
    $935b35782dc2f587$var$debug("call pause flowing=%j", this._readableState.flowing);
    if (this._readableState.flowing !== false) {
        $935b35782dc2f587$var$debug("pause");
        this._readableState.flowing = false;
        this.emit("pause");
    }
    this._readableState.paused = true;
    return this;
};
function $935b35782dc2f587$var$flow(stream) {
    var state = stream._readableState;
    $935b35782dc2f587$var$debug("flow", state.flowing);
    while(state.flowing && stream.read() !== null);
}
// wrap an old-style stream as the async data source.
// This is *not* part of the readable stream interface.
// It is an ugly unfortunate mess of history.
$935b35782dc2f587$var$Readable.prototype.wrap = function(stream) {
    var _this = this;
    var state = this._readableState;
    var paused = false;
    stream.on("end", function() {
        $935b35782dc2f587$var$debug("wrapped end");
        if (state.decoder && !state.ended) {
            var chunk = state.decoder.end();
            if (chunk && chunk.length) _this.push(chunk);
        }
        _this.push(null);
    });
    stream.on("data", function(chunk) {
        $935b35782dc2f587$var$debug("wrapped data");
        if (state.decoder) chunk = state.decoder.write(chunk);
        // don't skip over falsy values in objectMode
        if (state.objectMode && (chunk === null || chunk === undefined)) return;
        else if (!state.objectMode && (!chunk || !chunk.length)) return;
        var ret = _this.push(chunk);
        if (!ret) {
            paused = true;
            stream.pause();
        }
    });
    // proxy all the other methods.
    // important when wrapping filters and duplexes.
    for(var i in stream)if (this[i] === undefined && typeof stream[i] === "function") this[i] = function methodWrap(method) {
        return function methodWrapReturnFunction() {
            return stream[method].apply(stream, arguments);
        };
    }(i);
    // proxy certain important events.
    for(var n = 0; n < $935b35782dc2f587$var$kProxyEvents.length; n++)stream.on($935b35782dc2f587$var$kProxyEvents[n], this.emit.bind(this, $935b35782dc2f587$var$kProxyEvents[n]));
    // when we try to consume some more bytes, simply unpause the
    // underlying stream.
    this._read = function(n) {
        $935b35782dc2f587$var$debug("wrapped _read", n);
        if (paused) {
            paused = false;
            stream.resume();
        }
    };
    return this;
};

if (typeof Symbol === "function") $935b35782dc2f587$var$Readable.prototype[Symbol.asyncIterator] = function() {
    if ($935b35782dc2f587$var$createReadableStreamAsyncIterator === undefined) $935b35782dc2f587$var$createReadableStreamAsyncIterator = (parcelRequire("8BamM"));
    return $935b35782dc2f587$var$createReadableStreamAsyncIterator(this);
};
Object.defineProperty($935b35782dc2f587$var$Readable.prototype, "readableHighWaterMark", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._readableState.highWaterMark;
    }
});
Object.defineProperty($935b35782dc2f587$var$Readable.prototype, "readableBuffer", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._readableState && this._readableState.buffer;
    }
});
Object.defineProperty($935b35782dc2f587$var$Readable.prototype, "readableFlowing", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._readableState.flowing;
    },
    set: function set(state) {
        if (this._readableState) this._readableState.flowing = state;
    }
});
// exposed for testing purposes only.
$935b35782dc2f587$var$Readable._fromList = $935b35782dc2f587$var$fromList;
Object.defineProperty($935b35782dc2f587$var$Readable.prototype, "readableLength", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._readableState.length;
    }
});
// Pluck off n bytes from an array of buffers.
// Length is the combined lengths of all the buffers in the list.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function $935b35782dc2f587$var$fromList(n, state) {
    // nothing buffered
    if (state.length === 0) return null;
    var ret;
    if (state.objectMode) ret = state.buffer.shift();
    else if (!n || n >= state.length) {
        // read it all, truncate the list
        if (state.decoder) ret = state.buffer.join("");
        else if (state.buffer.length === 1) ret = state.buffer.first();
        else ret = state.buffer.concat(state.length);
        state.buffer.clear();
    } else // read part of list
    ret = state.buffer.consume(n, state.decoder);
    return ret;
}
function $935b35782dc2f587$var$endReadable(stream) {
    var state = stream._readableState;
    $935b35782dc2f587$var$debug("endReadable", state.endEmitted);
    if (!state.endEmitted) {
        state.ended = true;
        $4TNnu.nextTick($935b35782dc2f587$var$endReadableNT, state, stream);
    }
}
function $935b35782dc2f587$var$endReadableNT(state, stream) {
    $935b35782dc2f587$var$debug("endReadableNT", state.endEmitted, state.length);
    // Check that we didn't get one last unshift.
    if (!state.endEmitted && state.length === 0) {
        state.endEmitted = true;
        stream.readable = false;
        stream.emit("end");
        if (state.autoDestroy) {
            // In case of duplex streams we need a way to detect
            // if the writable side is ready for autoDestroy as well
            var wState = stream._writableState;
            if (!wState || wState.autoDestroy && wState.finished) stream.destroy();
        }
    }
}

if (typeof Symbol === "function") $935b35782dc2f587$var$Readable.from = function(iterable, opts) {
    if ($935b35782dc2f587$var$from === undefined) $935b35782dc2f587$var$from = (parcelRequire("eGESN"));
    return $935b35782dc2f587$var$from($935b35782dc2f587$var$Readable, iterable, opts);
};
function $935b35782dc2f587$var$indexOf(xs, x) {
    for(var i = 0, l = xs.length; i < l; i++){
        if (xs[i] === x) return i;
    }
    return -1;
}

});
parcelRequire.register("jMc9N", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
"use strict";
var $e65bee21a7cdc3da$var$R = typeof Reflect === "object" ? Reflect : null;
var $e65bee21a7cdc3da$var$ReflectApply = $e65bee21a7cdc3da$var$R && typeof $e65bee21a7cdc3da$var$R.apply === "function" ? $e65bee21a7cdc3da$var$R.apply : function ReflectApply(target, receiver, args) {
    return Function.prototype.apply.call(target, receiver, args);
};
var $e65bee21a7cdc3da$var$ReflectOwnKeys;
if ($e65bee21a7cdc3da$var$R && typeof $e65bee21a7cdc3da$var$R.ownKeys === "function") $e65bee21a7cdc3da$var$ReflectOwnKeys = $e65bee21a7cdc3da$var$R.ownKeys;
else if (Object.getOwnPropertySymbols) $e65bee21a7cdc3da$var$ReflectOwnKeys = function ReflectOwnKeys(target) {
    return Object.getOwnPropertyNames(target).concat(Object.getOwnPropertySymbols(target));
};
else $e65bee21a7cdc3da$var$ReflectOwnKeys = function ReflectOwnKeys(target) {
    return Object.getOwnPropertyNames(target);
};
function $e65bee21a7cdc3da$var$ProcessEmitWarning(warning) {
    if (console && console.warn) console.warn(warning);
}
var $e65bee21a7cdc3da$var$NumberIsNaN = Number.isNaN || function NumberIsNaN(value) {
    return value !== value;
};
function $e65bee21a7cdc3da$var$EventEmitter() {
    $e65bee21a7cdc3da$var$EventEmitter.init.call(this);
}
module.exports = $e65bee21a7cdc3da$var$EventEmitter;
module.exports.once = $e65bee21a7cdc3da$var$once;
// Backwards-compat with node 0.10.x
$e65bee21a7cdc3da$var$EventEmitter.EventEmitter = $e65bee21a7cdc3da$var$EventEmitter;
$e65bee21a7cdc3da$var$EventEmitter.prototype._events = undefined;
$e65bee21a7cdc3da$var$EventEmitter.prototype._eventsCount = 0;
$e65bee21a7cdc3da$var$EventEmitter.prototype._maxListeners = undefined;
// By default EventEmitters will print a warning if more than 10 listeners are
// added to it. This is a useful default which helps finding memory leaks.
var $e65bee21a7cdc3da$var$defaultMaxListeners = 10;
function $e65bee21a7cdc3da$var$checkListener(listener) {
    if (typeof listener !== "function") throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof listener);
}
Object.defineProperty($e65bee21a7cdc3da$var$EventEmitter, "defaultMaxListeners", {
    enumerable: true,
    get: function() {
        return $e65bee21a7cdc3da$var$defaultMaxListeners;
    },
    set: function(arg) {
        if (typeof arg !== "number" || arg < 0 || $e65bee21a7cdc3da$var$NumberIsNaN(arg)) throw new RangeError('The value of "defaultMaxListeners" is out of range. It must be a non-negative number. Received ' + arg + ".");
        $e65bee21a7cdc3da$var$defaultMaxListeners = arg;
    }
});
$e65bee21a7cdc3da$var$EventEmitter.init = function() {
    if (this._events === undefined || this._events === Object.getPrototypeOf(this)._events) {
        this._events = Object.create(null);
        this._eventsCount = 0;
    }
    this._maxListeners = this._maxListeners || undefined;
};
// Obviously not all Emitters should be limited to 10. This function allows
// that to be increased. Set to zero for unlimited.
$e65bee21a7cdc3da$var$EventEmitter.prototype.setMaxListeners = function setMaxListeners(n) {
    if (typeof n !== "number" || n < 0 || $e65bee21a7cdc3da$var$NumberIsNaN(n)) throw new RangeError('The value of "n" is out of range. It must be a non-negative number. Received ' + n + ".");
    this._maxListeners = n;
    return this;
};
function $e65bee21a7cdc3da$var$_getMaxListeners(that) {
    if (that._maxListeners === undefined) return $e65bee21a7cdc3da$var$EventEmitter.defaultMaxListeners;
    return that._maxListeners;
}
$e65bee21a7cdc3da$var$EventEmitter.prototype.getMaxListeners = function getMaxListeners() {
    return $e65bee21a7cdc3da$var$_getMaxListeners(this);
};
$e65bee21a7cdc3da$var$EventEmitter.prototype.emit = function emit(type) {
    var args = [];
    for(var i = 1; i < arguments.length; i++)args.push(arguments[i]);
    var doError = type === "error";
    var events = this._events;
    if (events !== undefined) doError = doError && events.error === undefined;
    else if (!doError) return false;
    // If there is no 'error' event listener then throw.
    if (doError) {
        var er;
        if (args.length > 0) er = args[0];
        if (er instanceof Error) // Note: The comments on the `throw` lines are intentional, they show
        // up in Node's output if this results in an unhandled exception.
        throw er; // Unhandled 'error' event
        // At least give some kind of context to the user
        var err = new Error("Unhandled error." + (er ? " (" + er.message + ")" : ""));
        err.context = er;
        throw err; // Unhandled 'error' event
    }
    var handler = events[type];
    if (handler === undefined) return false;
    if (typeof handler === "function") $e65bee21a7cdc3da$var$ReflectApply(handler, this, args);
    else {
        var len = handler.length;
        var listeners = $e65bee21a7cdc3da$var$arrayClone(handler, len);
        for(var i = 0; i < len; ++i)$e65bee21a7cdc3da$var$ReflectApply(listeners[i], this, args);
    }
    return true;
};
function $e65bee21a7cdc3da$var$_addListener(target, type, listener, prepend) {
    var m;
    var events;
    var existing;
    $e65bee21a7cdc3da$var$checkListener(listener);
    events = target._events;
    if (events === undefined) {
        events = target._events = Object.create(null);
        target._eventsCount = 0;
    } else {
        // To avoid recursion in the case that type === "newListener"! Before
        // adding it to the listeners, first emit "newListener".
        if (events.newListener !== undefined) {
            target.emit("newListener", type, listener.listener ? listener.listener : listener);
            // Re-assign `events` because a newListener handler could have caused the
            // this._events to be assigned to a new object
            events = target._events;
        }
        existing = events[type];
    }
    if (existing === undefined) {
        // Optimize the case of one listener. Don't need the extra array object.
        existing = events[type] = listener;
        ++target._eventsCount;
    } else {
        if (typeof existing === "function") // Adding the second element, need to change to array.
        existing = events[type] = prepend ? [
            listener,
            existing
        ] : [
            existing,
            listener
        ];
        else if (prepend) existing.unshift(listener);
        else existing.push(listener);
        // Check for listener leak
        m = $e65bee21a7cdc3da$var$_getMaxListeners(target);
        if (m > 0 && existing.length > m && !existing.warned) {
            existing.warned = true;
            // No error code for this since it is a Warning
            // eslint-disable-next-line no-restricted-syntax
            var w = new Error("Possible EventEmitter memory leak detected. " + existing.length + " " + String(type) + " listeners " + "added. Use emitter.setMaxListeners() to " + "increase limit");
            w.name = "MaxListenersExceededWarning";
            w.emitter = target;
            w.type = type;
            w.count = existing.length;
            $e65bee21a7cdc3da$var$ProcessEmitWarning(w);
        }
    }
    return target;
}
$e65bee21a7cdc3da$var$EventEmitter.prototype.addListener = function addListener(type, listener) {
    return $e65bee21a7cdc3da$var$_addListener(this, type, listener, false);
};
$e65bee21a7cdc3da$var$EventEmitter.prototype.on = $e65bee21a7cdc3da$var$EventEmitter.prototype.addListener;
$e65bee21a7cdc3da$var$EventEmitter.prototype.prependListener = function prependListener(type, listener) {
    return $e65bee21a7cdc3da$var$_addListener(this, type, listener, true);
};
function $e65bee21a7cdc3da$var$onceWrapper() {
    if (!this.fired) {
        this.target.removeListener(this.type, this.wrapFn);
        this.fired = true;
        if (arguments.length === 0) return this.listener.call(this.target);
        return this.listener.apply(this.target, arguments);
    }
}
function $e65bee21a7cdc3da$var$_onceWrap(target, type, listener) {
    var state = {
        fired: false,
        wrapFn: undefined,
        target: target,
        type: type,
        listener: listener
    };
    var wrapped = $e65bee21a7cdc3da$var$onceWrapper.bind(state);
    wrapped.listener = listener;
    state.wrapFn = wrapped;
    return wrapped;
}
$e65bee21a7cdc3da$var$EventEmitter.prototype.once = function once(type, listener) {
    $e65bee21a7cdc3da$var$checkListener(listener);
    this.on(type, $e65bee21a7cdc3da$var$_onceWrap(this, type, listener));
    return this;
};
$e65bee21a7cdc3da$var$EventEmitter.prototype.prependOnceListener = function prependOnceListener(type, listener) {
    $e65bee21a7cdc3da$var$checkListener(listener);
    this.prependListener(type, $e65bee21a7cdc3da$var$_onceWrap(this, type, listener));
    return this;
};
// Emits a 'removeListener' event if and only if the listener was removed.
$e65bee21a7cdc3da$var$EventEmitter.prototype.removeListener = function removeListener(type, listener) {
    var list, events, position, i, originalListener;
    $e65bee21a7cdc3da$var$checkListener(listener);
    events = this._events;
    if (events === undefined) return this;
    list = events[type];
    if (list === undefined) return this;
    if (list === listener || list.listener === listener) {
        if (--this._eventsCount === 0) this._events = Object.create(null);
        else {
            delete events[type];
            if (events.removeListener) this.emit("removeListener", type, list.listener || listener);
        }
    } else if (typeof list !== "function") {
        position = -1;
        for(i = list.length - 1; i >= 0; i--)if (list[i] === listener || list[i].listener === listener) {
            originalListener = list[i].listener;
            position = i;
            break;
        }
        if (position < 0) return this;
        if (position === 0) list.shift();
        else $e65bee21a7cdc3da$var$spliceOne(list, position);
        if (list.length === 1) events[type] = list[0];
        if (events.removeListener !== undefined) this.emit("removeListener", type, originalListener || listener);
    }
    return this;
};
$e65bee21a7cdc3da$var$EventEmitter.prototype.off = $e65bee21a7cdc3da$var$EventEmitter.prototype.removeListener;
$e65bee21a7cdc3da$var$EventEmitter.prototype.removeAllListeners = function removeAllListeners(type) {
    var listeners, events, i;
    events = this._events;
    if (events === undefined) return this;
    // not listening for removeListener, no need to emit
    if (events.removeListener === undefined) {
        if (arguments.length === 0) {
            this._events = Object.create(null);
            this._eventsCount = 0;
        } else if (events[type] !== undefined) {
            if (--this._eventsCount === 0) this._events = Object.create(null);
            else delete events[type];
        }
        return this;
    }
    // emit removeListener for all listeners on all events
    if (arguments.length === 0) {
        var keys = Object.keys(events);
        var key;
        for(i = 0; i < keys.length; ++i){
            key = keys[i];
            if (key === "removeListener") continue;
            this.removeAllListeners(key);
        }
        this.removeAllListeners("removeListener");
        this._events = Object.create(null);
        this._eventsCount = 0;
        return this;
    }
    listeners = events[type];
    if (typeof listeners === "function") this.removeListener(type, listeners);
    else if (listeners !== undefined) // LIFO order
    for(i = listeners.length - 1; i >= 0; i--)this.removeListener(type, listeners[i]);
    return this;
};
function $e65bee21a7cdc3da$var$_listeners(target, type, unwrap) {
    var events = target._events;
    if (events === undefined) return [];
    var evlistener = events[type];
    if (evlistener === undefined) return [];
    if (typeof evlistener === "function") return unwrap ? [
        evlistener.listener || evlistener
    ] : [
        evlistener
    ];
    return unwrap ? $e65bee21a7cdc3da$var$unwrapListeners(evlistener) : $e65bee21a7cdc3da$var$arrayClone(evlistener, evlistener.length);
}
$e65bee21a7cdc3da$var$EventEmitter.prototype.listeners = function listeners(type) {
    return $e65bee21a7cdc3da$var$_listeners(this, type, true);
};
$e65bee21a7cdc3da$var$EventEmitter.prototype.rawListeners = function rawListeners(type) {
    return $e65bee21a7cdc3da$var$_listeners(this, type, false);
};
$e65bee21a7cdc3da$var$EventEmitter.listenerCount = function(emitter, type) {
    if (typeof emitter.listenerCount === "function") return emitter.listenerCount(type);
    else return $e65bee21a7cdc3da$var$listenerCount.call(emitter, type);
};
$e65bee21a7cdc3da$var$EventEmitter.prototype.listenerCount = $e65bee21a7cdc3da$var$listenerCount;
function $e65bee21a7cdc3da$var$listenerCount(type) {
    var events = this._events;
    if (events !== undefined) {
        var evlistener = events[type];
        if (typeof evlistener === "function") return 1;
        else if (evlistener !== undefined) return evlistener.length;
    }
    return 0;
}
$e65bee21a7cdc3da$var$EventEmitter.prototype.eventNames = function eventNames() {
    return this._eventsCount > 0 ? $e65bee21a7cdc3da$var$ReflectOwnKeys(this._events) : [];
};
function $e65bee21a7cdc3da$var$arrayClone(arr, n) {
    var copy = new Array(n);
    for(var i = 0; i < n; ++i)copy[i] = arr[i];
    return copy;
}
function $e65bee21a7cdc3da$var$spliceOne(list, index) {
    for(; index + 1 < list.length; index++)list[index] = list[index + 1];
    list.pop();
}
function $e65bee21a7cdc3da$var$unwrapListeners(arr) {
    var ret = new Array(arr.length);
    for(var i = 0; i < ret.length; ++i)ret[i] = arr[i].listener || arr[i];
    return ret;
}
function $e65bee21a7cdc3da$var$once(emitter, name) {
    return new Promise(function(resolve, reject) {
        function errorListener(err) {
            emitter.removeListener(name, resolver);
            reject(err);
        }
        function resolver() {
            if (typeof emitter.removeListener === "function") emitter.removeListener("error", errorListener);
            resolve([].slice.call(arguments));
        }
        $e65bee21a7cdc3da$var$eventTargetAgnosticAddListener(emitter, name, resolver, {
            once: true
        });
        if (name !== "error") $e65bee21a7cdc3da$var$addErrorHandlerIfEventEmitter(emitter, errorListener, {
            once: true
        });
    });
}
function $e65bee21a7cdc3da$var$addErrorHandlerIfEventEmitter(emitter, handler, flags) {
    if (typeof emitter.on === "function") $e65bee21a7cdc3da$var$eventTargetAgnosticAddListener(emitter, "error", handler, flags);
}
function $e65bee21a7cdc3da$var$eventTargetAgnosticAddListener(emitter, name, listener, flags) {
    if (typeof emitter.on === "function") {
        if (flags.once) emitter.once(name, listener);
        else emitter.on(name, listener);
    } else if (typeof emitter.addEventListener === "function") // EventTarget does not have `error` event semantics like Node
    // EventEmitters, we do not listen for `error` events here.
    emitter.addEventListener(name, function wrapListener(arg) {
        // IE does not have builtin `{ once: true }` support so we
        // have to do it manually.
        if (flags.once) emitter.removeEventListener(name, wrapListener);
        listener(arg);
    });
    else throw new TypeError('The "emitter" argument must be of type EventEmitter. Received type ' + typeof emitter);
}

});

parcelRequire.register("j5tZS", function(module, exports) {

module.exports = (parcelRequire("jMc9N")).EventEmitter;

});

parcelRequire.register("5KjdV", function(module, exports) {
"use strict";
function $42f0290b37cf0d25$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $42f0290b37cf0d25$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $42f0290b37cf0d25$var$ownKeys(Object(source), !0).forEach(function(key) {
            $42f0290b37cf0d25$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $42f0290b37cf0d25$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $42f0290b37cf0d25$var$_defineProperty(obj, key, value) {
    key = $42f0290b37cf0d25$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $42f0290b37cf0d25$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $42f0290b37cf0d25$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $42f0290b37cf0d25$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $42f0290b37cf0d25$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $42f0290b37cf0d25$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $42f0290b37cf0d25$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $42f0290b37cf0d25$var$_toPropertyKey(arg) {
    var key = $42f0290b37cf0d25$var$_toPrimitive(arg, "string");
    return typeof key === "symbol" ? key : String(key);
}
function $42f0290b37cf0d25$var$_toPrimitive(input, hint) {
    if (typeof input !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (typeof res !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}

var $ihoyg = parcelRequire("ihoyg");
var $42f0290b37cf0d25$var$Buffer = $ihoyg.Buffer;

var $5Io6y = parcelRequire("5Io6y");
var $42f0290b37cf0d25$var$inspect = $5Io6y.inspect;
var $42f0290b37cf0d25$var$custom = $42f0290b37cf0d25$var$inspect && $42f0290b37cf0d25$var$inspect.custom || "inspect";
function $42f0290b37cf0d25$var$copyBuffer(src, target, offset) {
    $42f0290b37cf0d25$var$Buffer.prototype.copy.call(src, target, offset);
}
module.exports = /*#__PURE__*/ function() {
    function BufferList() {
        $42f0290b37cf0d25$var$_classCallCheck(this, BufferList);
        this.head = null;
        this.tail = null;
        this.length = 0;
    }
    $42f0290b37cf0d25$var$_createClass(BufferList, [
        {
            key: "push",
            value: function push(v) {
                var entry = {
                    data: v,
                    next: null
                };
                if (this.length > 0) this.tail.next = entry;
                else this.head = entry;
                this.tail = entry;
                ++this.length;
            }
        },
        {
            key: "unshift",
            value: function unshift(v) {
                var entry = {
                    data: v,
                    next: this.head
                };
                if (this.length === 0) this.tail = entry;
                this.head = entry;
                ++this.length;
            }
        },
        {
            key: "shift",
            value: function shift() {
                if (this.length === 0) return;
                var ret = this.head.data;
                if (this.length === 1) this.head = this.tail = null;
                else this.head = this.head.next;
                --this.length;
                return ret;
            }
        },
        {
            key: "clear",
            value: function clear() {
                this.head = this.tail = null;
                this.length = 0;
            }
        },
        {
            key: "join",
            value: function join(s) {
                if (this.length === 0) return "";
                var p = this.head;
                var ret = "" + p.data;
                while(p = p.next)ret += s + p.data;
                return ret;
            }
        },
        {
            key: "concat",
            value: function concat(n) {
                if (this.length === 0) return $42f0290b37cf0d25$var$Buffer.alloc(0);
                var ret = $42f0290b37cf0d25$var$Buffer.allocUnsafe(n >>> 0);
                var p = this.head;
                var i = 0;
                while(p){
                    $42f0290b37cf0d25$var$copyBuffer(p.data, ret, i);
                    i += p.data.length;
                    p = p.next;
                }
                return ret;
            }
        },
        {
            key: "consume",
            value: function consume(n, hasStrings) {
                var ret;
                if (n < this.head.data.length) {
                    // `slice` is the same for buffers and strings.
                    ret = this.head.data.slice(0, n);
                    this.head.data = this.head.data.slice(n);
                } else if (n === this.head.data.length) // First chunk is a perfect match.
                ret = this.shift();
                else // Result spans more than one buffer.
                ret = hasStrings ? this._getString(n) : this._getBuffer(n);
                return ret;
            }
        },
        {
            key: "first",
            value: function first() {
                return this.head.data;
            }
        },
        {
            key: "_getString",
            value: function _getString(n) {
                var p = this.head;
                var c = 1;
                var ret = p.data;
                n -= ret.length;
                while(p = p.next){
                    var str = p.data;
                    var nb = n > str.length ? str.length : n;
                    if (nb === str.length) ret += str;
                    else ret += str.slice(0, n);
                    n -= nb;
                    if (n === 0) {
                        if (nb === str.length) {
                            ++c;
                            if (p.next) this.head = p.next;
                            else this.head = this.tail = null;
                        } else {
                            this.head = p;
                            p.data = str.slice(nb);
                        }
                        break;
                    }
                    ++c;
                }
                this.length -= c;
                return ret;
            }
        },
        {
            key: "_getBuffer",
            value: function _getBuffer(n) {
                var ret = $42f0290b37cf0d25$var$Buffer.allocUnsafe(n);
                var p = this.head;
                var c = 1;
                p.data.copy(ret);
                n -= p.data.length;
                while(p = p.next){
                    var buf = p.data;
                    var nb = n > buf.length ? buf.length : n;
                    buf.copy(ret, ret.length - n, 0, nb);
                    n -= nb;
                    if (n === 0) {
                        if (nb === buf.length) {
                            ++c;
                            if (p.next) this.head = p.next;
                            else this.head = this.tail = null;
                        } else {
                            this.head = p;
                            p.data = buf.slice(nb);
                        }
                        break;
                    }
                    ++c;
                }
                this.length -= c;
                return ret;
            }
        },
        {
            key: $42f0290b37cf0d25$var$custom,
            value: function value(_, options) {
                return $42f0290b37cf0d25$var$inspect(this, $42f0290b37cf0d25$var$_objectSpread($42f0290b37cf0d25$var$_objectSpread({}, options), {}, {
                    // Only inspect one level.
                    depth: 0,
                    // It should not recurse.
                    customInspect: false
                }));
            }
        }
    ]);
    return BufferList;
}();

});

parcelRequire.register("kZIsm", function(module, exports) {

var $4TNnu = parcelRequire("4TNnu");
"use strict";
// undocumented cb() API, needed for core, not for public API
function $f48bfd4745615c07$var$destroy(err, cb) {
    var _this = this;
    var readableDestroyed = this._readableState && this._readableState.destroyed;
    var writableDestroyed = this._writableState && this._writableState.destroyed;
    if (readableDestroyed || writableDestroyed) {
        if (cb) cb(err);
        else if (err) {
            if (!this._writableState) $4TNnu.nextTick($f48bfd4745615c07$var$emitErrorNT, this, err);
            else if (!this._writableState.errorEmitted) {
                this._writableState.errorEmitted = true;
                $4TNnu.nextTick($f48bfd4745615c07$var$emitErrorNT, this, err);
            }
        }
        return this;
    }
    // we set destroyed to true before firing error callbacks in order
    // to make it re-entrance safe in case destroy() is called within callbacks
    if (this._readableState) this._readableState.destroyed = true;
    // if this is a duplex stream mark the writable part as destroyed as well
    if (this._writableState) this._writableState.destroyed = true;
    this._destroy(err || null, function(err) {
        if (!cb && err) {
            if (!_this._writableState) $4TNnu.nextTick($f48bfd4745615c07$var$emitErrorAndCloseNT, _this, err);
            else if (!_this._writableState.errorEmitted) {
                _this._writableState.errorEmitted = true;
                $4TNnu.nextTick($f48bfd4745615c07$var$emitErrorAndCloseNT, _this, err);
            } else $4TNnu.nextTick($f48bfd4745615c07$var$emitCloseNT, _this);
        } else if (cb) {
            $4TNnu.nextTick($f48bfd4745615c07$var$emitCloseNT, _this);
            cb(err);
        } else $4TNnu.nextTick($f48bfd4745615c07$var$emitCloseNT, _this);
    });
    return this;
}
function $f48bfd4745615c07$var$emitErrorAndCloseNT(self, err) {
    $f48bfd4745615c07$var$emitErrorNT(self, err);
    $f48bfd4745615c07$var$emitCloseNT(self);
}
function $f48bfd4745615c07$var$emitCloseNT(self) {
    if (self._writableState && !self._writableState.emitClose) return;
    if (self._readableState && !self._readableState.emitClose) return;
    self.emit("close");
}
function $f48bfd4745615c07$var$undestroy() {
    if (this._readableState) {
        this._readableState.destroyed = false;
        this._readableState.reading = false;
        this._readableState.ended = false;
        this._readableState.endEmitted = false;
    }
    if (this._writableState) {
        this._writableState.destroyed = false;
        this._writableState.ended = false;
        this._writableState.ending = false;
        this._writableState.finalCalled = false;
        this._writableState.prefinished = false;
        this._writableState.finished = false;
        this._writableState.errorEmitted = false;
    }
}
function $f48bfd4745615c07$var$emitErrorNT(self, err) {
    self.emit("error", err);
}
function $f48bfd4745615c07$var$errorOrDestroy(stream, err) {
    // We have tests that rely on errors being emitted
    // in the same tick, so changing this is semver major.
    // For now when you opt-in to autoDestroy we allow
    // the error to be emitted nextTick. In a future
    // semver major update we should change the default to this.
    var rState = stream._readableState;
    var wState = stream._writableState;
    if (rState && rState.autoDestroy || wState && wState.autoDestroy) stream.destroy(err);
    else stream.emit("error", err);
}
module.exports = {
    destroy: $f48bfd4745615c07$var$destroy,
    undestroy: $f48bfd4745615c07$var$undestroy,
    errorOrDestroy: $f48bfd4745615c07$var$errorOrDestroy
};

});

parcelRequire.register("ipGaF", function(module, exports) {
"use strict";

var $dzxhd = parcelRequire("dzxhd");
var $d67b4619993ae46f$var$ERR_INVALID_OPT_VALUE = $dzxhd.codes.ERR_INVALID_OPT_VALUE;
function $d67b4619993ae46f$var$highWaterMarkFrom(options, isDuplex, duplexKey) {
    return options.highWaterMark != null ? options.highWaterMark : isDuplex ? options[duplexKey] : null;
}
function $d67b4619993ae46f$var$getHighWaterMark(state, options, duplexKey, isDuplex) {
    var hwm = $d67b4619993ae46f$var$highWaterMarkFrom(options, isDuplex, duplexKey);
    if (hwm != null) {
        if (!(isFinite(hwm) && Math.floor(hwm) === hwm) || hwm < 0) {
            var name = isDuplex ? duplexKey : "highWaterMark";
            throw new $d67b4619993ae46f$var$ERR_INVALID_OPT_VALUE(name, hwm);
        }
        return Math.floor(hwm);
    }
    // Default value
    return state.objectMode ? 16 : 16384;
}
module.exports = {
    getHighWaterMark: $d67b4619993ae46f$var$getHighWaterMark
};

});
parcelRequire.register("dzxhd", function(module, exports) {

$parcel$export(module.exports, "codes", function () { return $9e185b4d377b7281$export$e45cb6485273080e; }, function (v) { return $9e185b4d377b7281$export$e45cb6485273080e = v; });
var $9e185b4d377b7281$export$e45cb6485273080e;
"use strict";
function $9e185b4d377b7281$var$_inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    subClass.__proto__ = superClass;
}
var $9e185b4d377b7281$var$codes = {};
function $9e185b4d377b7281$var$createErrorType(code, message, Base) {
    if (!Base) Base = Error;
    function getMessage(arg1, arg2, arg3) {
        if (typeof message === "string") return message;
        else return message(arg1, arg2, arg3);
    }
    var NodeError = /*#__PURE__*/ function(_Base) {
        $9e185b4d377b7281$var$_inheritsLoose(NodeError, _Base);
        function NodeError(arg1, arg2, arg3) {
            return _Base.call(this, getMessage(arg1, arg2, arg3)) || this;
        }
        return NodeError;
    }(Base);
    NodeError.prototype.name = Base.name;
    NodeError.prototype.code = code;
    $9e185b4d377b7281$var$codes[code] = NodeError;
} // https://github.com/nodejs/node/blob/v10.8.0/lib/internal/errors.js
function $9e185b4d377b7281$var$oneOf(expected, thing) {
    if (Array.isArray(expected)) {
        var len = expected.length;
        expected = expected.map(function(i) {
            return String(i);
        });
        if (len > 2) return "one of ".concat(thing, " ").concat(expected.slice(0, len - 1).join(", "), ", or ") + expected[len - 1];
        else if (len === 2) return "one of ".concat(thing, " ").concat(expected[0], " or ").concat(expected[1]);
        else return "of ".concat(thing, " ").concat(expected[0]);
    } else return "of ".concat(thing, " ").concat(String(expected));
} // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/startsWith
function $9e185b4d377b7281$var$startsWith(str, search, pos) {
    return str.substr(!pos || pos < 0 ? 0 : +pos, search.length) === search;
} // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/endsWith
function $9e185b4d377b7281$var$endsWith(str, search, this_len) {
    if (this_len === undefined || this_len > str.length) this_len = str.length;
    return str.substring(this_len - search.length, this_len) === search;
} // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/includes
function $9e185b4d377b7281$var$includes(str, search, start) {
    if (typeof start !== "number") start = 0;
    if (start + search.length > str.length) return false;
    else return str.indexOf(search, start) !== -1;
}
$9e185b4d377b7281$var$createErrorType("ERR_INVALID_OPT_VALUE", function(name, value) {
    return 'The value "' + value + '" is invalid for option "' + name + '"';
}, TypeError);
$9e185b4d377b7281$var$createErrorType("ERR_INVALID_ARG_TYPE", function(name, expected, actual) {
    // determiner: 'must be' or 'must not be'
    var determiner;
    if (typeof expected === "string" && $9e185b4d377b7281$var$startsWith(expected, "not ")) {
        determiner = "must not be";
        expected = expected.replace(/^not /, "");
    } else determiner = "must be";
    var msg;
    if ($9e185b4d377b7281$var$endsWith(name, " argument")) // For cases like 'first argument'
    msg = "The ".concat(name, " ").concat(determiner, " ").concat($9e185b4d377b7281$var$oneOf(expected, "type"));
    else {
        var type = $9e185b4d377b7281$var$includes(name, ".") ? "property" : "argument";
        msg = 'The "'.concat(name, '" ').concat(type, " ").concat(determiner, " ").concat($9e185b4d377b7281$var$oneOf(expected, "type"));
    }
    msg += ". Received type ".concat(typeof actual);
    return msg;
}, TypeError);
$9e185b4d377b7281$var$createErrorType("ERR_STREAM_PUSH_AFTER_EOF", "stream.push() after EOF");
$9e185b4d377b7281$var$createErrorType("ERR_METHOD_NOT_IMPLEMENTED", function(name) {
    return "The " + name + " method is not implemented";
});
$9e185b4d377b7281$var$createErrorType("ERR_STREAM_PREMATURE_CLOSE", "Premature close");
$9e185b4d377b7281$var$createErrorType("ERR_STREAM_DESTROYED", function(name) {
    return "Cannot call " + name + " after a stream was destroyed";
});
$9e185b4d377b7281$var$createErrorType("ERR_MULTIPLE_CALLBACK", "Callback called multiple times");
$9e185b4d377b7281$var$createErrorType("ERR_STREAM_CANNOT_PIPE", "Cannot pipe, not readable");
$9e185b4d377b7281$var$createErrorType("ERR_STREAM_WRITE_AFTER_END", "write after end");
$9e185b4d377b7281$var$createErrorType("ERR_STREAM_NULL_VALUES", "May not write null values to stream", TypeError);
$9e185b4d377b7281$var$createErrorType("ERR_UNKNOWN_ENCODING", function(arg) {
    return "Unknown encoding: " + arg;
}, TypeError);
$9e185b4d377b7281$var$createErrorType("ERR_STREAM_UNSHIFT_AFTER_END_EVENT", "stream.unshift() after end event");
$9e185b4d377b7281$export$e45cb6485273080e = $9e185b4d377b7281$var$codes;

});


parcelRequire.register("2Hlr9", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a duplex stream is just a stream that is both readable and writable.
// Since JS doesn't have multiple prototypal inheritance, this class
// prototypally inherits from Readable, and then parasitically from
// Writable.

var $4TNnu = parcelRequire("4TNnu");
"use strict";
/*<replacement>*/ var $1f7039dea5b1b29a$var$objectKeys = Object.keys || function(obj) {
    var keys = [];
    for(var key in obj)keys.push(key);
    return keys;
};
/*</replacement>*/ module.exports = $1f7039dea5b1b29a$var$Duplex;

var $cEnbP = parcelRequire("cEnbP");

var $cuAoD = parcelRequire("cuAoD");

(parcelRequire("eSHUL"))($1f7039dea5b1b29a$var$Duplex, $cEnbP);
// Allow the keys array to be GC'ed.
var $1f7039dea5b1b29a$var$keys = $1f7039dea5b1b29a$var$objectKeys($cuAoD.prototype);
for(var $1f7039dea5b1b29a$var$v = 0; $1f7039dea5b1b29a$var$v < $1f7039dea5b1b29a$var$keys.length; $1f7039dea5b1b29a$var$v++){
    var $1f7039dea5b1b29a$var$method = $1f7039dea5b1b29a$var$keys[$1f7039dea5b1b29a$var$v];
    if (!$1f7039dea5b1b29a$var$Duplex.prototype[$1f7039dea5b1b29a$var$method]) $1f7039dea5b1b29a$var$Duplex.prototype[$1f7039dea5b1b29a$var$method] = $cuAoD.prototype[$1f7039dea5b1b29a$var$method];
}
function $1f7039dea5b1b29a$var$Duplex(options) {
    if (!(this instanceof $1f7039dea5b1b29a$var$Duplex)) return new $1f7039dea5b1b29a$var$Duplex(options);
    $cEnbP.call(this, options);
    $cuAoD.call(this, options);
    this.allowHalfOpen = true;
    if (options) {
        if (options.readable === false) this.readable = false;
        if (options.writable === false) this.writable = false;
        if (options.allowHalfOpen === false) {
            this.allowHalfOpen = false;
            this.once("end", $1f7039dea5b1b29a$var$onend);
        }
    }
}
Object.defineProperty($1f7039dea5b1b29a$var$Duplex.prototype, "writableHighWaterMark", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._writableState.highWaterMark;
    }
});
Object.defineProperty($1f7039dea5b1b29a$var$Duplex.prototype, "writableBuffer", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._writableState && this._writableState.getBuffer();
    }
});
Object.defineProperty($1f7039dea5b1b29a$var$Duplex.prototype, "writableLength", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._writableState.length;
    }
});
// the no-half-open enforcer
function $1f7039dea5b1b29a$var$onend() {
    // If the writable side ended, then we're ok.
    if (this._writableState.ended) return;
    // no more data can be written.
    // But allow more writes to happen in this tick.
    $4TNnu.nextTick($1f7039dea5b1b29a$var$onEndNT, this);
}
function $1f7039dea5b1b29a$var$onEndNT(self) {
    self.end();
}
Object.defineProperty($1f7039dea5b1b29a$var$Duplex.prototype, "destroyed", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        if (this._readableState === undefined || this._writableState === undefined) return false;
        return this._readableState.destroyed && this._writableState.destroyed;
    },
    set: function set(value) {
        // we ignore the value if the stream
        // has not been initialized yet
        if (this._readableState === undefined || this._writableState === undefined) return;
        // backward compatibility, the user is explicitly
        // managing destroyed
        this._readableState.destroyed = value;
        this._writableState.destroyed = value;
    }
});

});
parcelRequire.register("cuAoD", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// A bit simpler than readable streams.
// Implement an async ._write(chunk, encoding, cb), and it'll handle all
// the drain event emission and buffering.

var $4TNnu = parcelRequire("4TNnu");
"use strict";
module.exports = $918484e8c698b555$var$Writable;
/* <replacement> */ function $918484e8c698b555$var$WriteReq(chunk, encoding, cb) {
    this.chunk = chunk;
    this.encoding = encoding;
    this.callback = cb;
    this.next = null;
}
// It seems a linked list but it is not
// there will be only 2 of these for each stream
function $918484e8c698b555$var$CorkedRequest(state) {
    var _this = this;
    this.next = null;
    this.entry = null;
    this.finish = function() {
        $918484e8c698b555$var$onCorkedFinish(_this, state);
    };
}
/* </replacement> */ /*<replacement>*/ var $918484e8c698b555$var$Duplex;
/*</replacement>*/ $918484e8c698b555$var$Writable.WritableState = $918484e8c698b555$var$WritableState;

/*<replacement>*/ var $918484e8c698b555$var$internalUtil = {
    deprecate: (parcelRequire("l4FQK"))
};

var $j5tZS = parcelRequire("j5tZS");

var $ihoyg = parcelRequire("ihoyg");
var $918484e8c698b555$require$Buffer = $ihoyg.Buffer;
var $918484e8c698b555$var$OurUint8Array = (typeof $parcel$global !== "undefined" ? $parcel$global : typeof window !== "undefined" ? window : typeof self !== "undefined" ? self : {}).Uint8Array || function() {};
function $918484e8c698b555$var$_uint8ArrayToBuffer(chunk) {
    return $918484e8c698b555$require$Buffer.from(chunk);
}
function $918484e8c698b555$var$_isUint8Array(obj) {
    return $918484e8c698b555$require$Buffer.isBuffer(obj) || obj instanceof $918484e8c698b555$var$OurUint8Array;
}

var $kZIsm = parcelRequire("kZIsm");

var $ipGaF = parcelRequire("ipGaF");
var $918484e8c698b555$var$getHighWaterMark = $ipGaF.getHighWaterMark;

var $dzxhd = parcelRequire("dzxhd");
var $918484e8c698b555$require$_require$codes = $dzxhd.codes;
var $918484e8c698b555$var$ERR_INVALID_ARG_TYPE = $918484e8c698b555$require$_require$codes.ERR_INVALID_ARG_TYPE, $918484e8c698b555$var$ERR_METHOD_NOT_IMPLEMENTED = $918484e8c698b555$require$_require$codes.ERR_METHOD_NOT_IMPLEMENTED, $918484e8c698b555$var$ERR_MULTIPLE_CALLBACK = $918484e8c698b555$require$_require$codes.ERR_MULTIPLE_CALLBACK, $918484e8c698b555$var$ERR_STREAM_CANNOT_PIPE = $918484e8c698b555$require$_require$codes.ERR_STREAM_CANNOT_PIPE, $918484e8c698b555$var$ERR_STREAM_DESTROYED = $918484e8c698b555$require$_require$codes.ERR_STREAM_DESTROYED, $918484e8c698b555$var$ERR_STREAM_NULL_VALUES = $918484e8c698b555$require$_require$codes.ERR_STREAM_NULL_VALUES, $918484e8c698b555$var$ERR_STREAM_WRITE_AFTER_END = $918484e8c698b555$require$_require$codes.ERR_STREAM_WRITE_AFTER_END, $918484e8c698b555$var$ERR_UNKNOWN_ENCODING = $918484e8c698b555$require$_require$codes.ERR_UNKNOWN_ENCODING;
var $918484e8c698b555$var$errorOrDestroy = $kZIsm.errorOrDestroy;

(parcelRequire("eSHUL"))($918484e8c698b555$var$Writable, $j5tZS);
function $918484e8c698b555$var$nop() {}

function $918484e8c698b555$var$WritableState(options, stream, isDuplex) {
    $918484e8c698b555$var$Duplex = $918484e8c698b555$var$Duplex || (parcelRequire("2Hlr9"));
    options = options || {};
    // Duplex streams are both readable and writable, but share
    // the same options object.
    // However, some cases require setting options to different
    // values for the readable and the writable sides of the duplex stream,
    // e.g. options.readableObjectMode vs. options.writableObjectMode, etc.
    if (typeof isDuplex !== "boolean") isDuplex = stream instanceof $918484e8c698b555$var$Duplex;
    // object stream flag to indicate whether or not this stream
    // contains buffers or objects.
    this.objectMode = !!options.objectMode;
    if (isDuplex) this.objectMode = this.objectMode || !!options.writableObjectMode;
    // the point at which write() starts returning false
    // Note: 0 is a valid value, means that we always return false if
    // the entire buffer is not flushed immediately on write()
    this.highWaterMark = $918484e8c698b555$var$getHighWaterMark(this, options, "writableHighWaterMark", isDuplex);
    // if _final has been called
    this.finalCalled = false;
    // drain event flag.
    this.needDrain = false;
    // at the start of calling end()
    this.ending = false;
    // when end() has been called, and returned
    this.ended = false;
    // when 'finish' is emitted
    this.finished = false;
    // has it been destroyed
    this.destroyed = false;
    // should we decode strings into buffers before passing to _write?
    // this is here so that some node-core streams can optimize string
    // handling at a lower level.
    var noDecode = options.decodeStrings === false;
    this.decodeStrings = !noDecode;
    // Crypto is kind of old and crusty.  Historically, its default string
    // encoding is 'binary' so we have to make this configurable.
    // Everything else in the universe uses 'utf8', though.
    this.defaultEncoding = options.defaultEncoding || "utf8";
    // not an actual buffer we keep track of, but a measurement
    // of how much we're waiting to get pushed to some underlying
    // socket or file.
    this.length = 0;
    // a flag to see when we're in the middle of a write.
    this.writing = false;
    // when true all writes will be buffered until .uncork() call
    this.corked = 0;
    // a flag to be able to tell if the onwrite cb is called immediately,
    // or on a later tick.  We set this to true at first, because any
    // actions that shouldn't happen until "later" should generally also
    // not happen before the first write call.
    this.sync = true;
    // a flag to know if we're processing previously buffered items, which
    // may call the _write() callback in the same tick, so that we don't
    // end up in an overlapped onwrite situation.
    this.bufferProcessing = false;
    // the callback that's passed to _write(chunk,cb)
    this.onwrite = function(er) {
        $918484e8c698b555$var$onwrite(stream, er);
    };
    // the callback that the user supplies to write(chunk,encoding,cb)
    this.writecb = null;
    // the amount that is being written when _write is called.
    this.writelen = 0;
    this.bufferedRequest = null;
    this.lastBufferedRequest = null;
    // number of pending user-supplied write callbacks
    // this must be 0 before 'finish' can be emitted
    this.pendingcb = 0;
    // emit prefinish if the only thing we're waiting for is _write cbs
    // This is relevant for synchronous Transform streams
    this.prefinished = false;
    // True if the error was already emitted and should not be thrown again
    this.errorEmitted = false;
    // Should close be emitted on destroy. Defaults to true.
    this.emitClose = options.emitClose !== false;
    // Should .destroy() be called after 'finish' (and potentially 'end')
    this.autoDestroy = !!options.autoDestroy;
    // count buffered requests
    this.bufferedRequestCount = 0;
    // allocate the first CorkedRequest, there is always
    // one allocated and free to use, and we maintain at most two
    this.corkedRequestsFree = new $918484e8c698b555$var$CorkedRequest(this);
}
$918484e8c698b555$var$WritableState.prototype.getBuffer = function getBuffer() {
    var current = this.bufferedRequest;
    var out = [];
    while(current){
        out.push(current);
        current = current.next;
    }
    return out;
};
(function() {
    try {
        Object.defineProperty($918484e8c698b555$var$WritableState.prototype, "buffer", {
            get: $918484e8c698b555$var$internalUtil.deprecate(function writableStateBufferGetter() {
                return this.getBuffer();
            }, "_writableState.buffer is deprecated. Use _writableState.getBuffer instead.", "DEP0003")
        });
    } catch (_) {}
})();
// Test _writableState for inheritance to account for Duplex streams,
// whose prototype chain only points to Readable.
var $918484e8c698b555$var$realHasInstance;
if (typeof Symbol === "function" && Symbol.hasInstance && typeof Function.prototype[Symbol.hasInstance] === "function") {
    $918484e8c698b555$var$realHasInstance = Function.prototype[Symbol.hasInstance];
    Object.defineProperty($918484e8c698b555$var$Writable, Symbol.hasInstance, {
        value: function value(object) {
            if ($918484e8c698b555$var$realHasInstance.call(this, object)) return true;
            if (this !== $918484e8c698b555$var$Writable) return false;
            return object && object._writableState instanceof $918484e8c698b555$var$WritableState;
        }
    });
} else $918484e8c698b555$var$realHasInstance = function realHasInstance(object) {
    return object instanceof this;
};

function $918484e8c698b555$var$Writable(options) {
    $918484e8c698b555$var$Duplex = $918484e8c698b555$var$Duplex || (parcelRequire("2Hlr9"));
    // Writable ctor is applied to Duplexes, too.
    // `realHasInstance` is necessary because using plain `instanceof`
    // would return false, as no `_writableState` property is attached.
    // Trying to use the custom `instanceof` for Writable here will also break the
    // Node.js LazyTransform implementation, which has a non-trivial getter for
    // `_writableState` that would lead to infinite recursion.
    // Checking for a Stream.Duplex instance is faster here instead of inside
    // the WritableState constructor, at least with V8 6.5
    var isDuplex = this instanceof $918484e8c698b555$var$Duplex;
    if (!isDuplex && !$918484e8c698b555$var$realHasInstance.call($918484e8c698b555$var$Writable, this)) return new $918484e8c698b555$var$Writable(options);
    this._writableState = new $918484e8c698b555$var$WritableState(options, this, isDuplex);
    // legacy.
    this.writable = true;
    if (options) {
        if (typeof options.write === "function") this._write = options.write;
        if (typeof options.writev === "function") this._writev = options.writev;
        if (typeof options.destroy === "function") this._destroy = options.destroy;
        if (typeof options.final === "function") this._final = options.final;
    }
    $j5tZS.call(this);
}
// Otherwise people can pipe Writable streams, which is just wrong.
$918484e8c698b555$var$Writable.prototype.pipe = function() {
    $918484e8c698b555$var$errorOrDestroy(this, new $918484e8c698b555$var$ERR_STREAM_CANNOT_PIPE());
};
function $918484e8c698b555$var$writeAfterEnd(stream, cb) {
    var er = new $918484e8c698b555$var$ERR_STREAM_WRITE_AFTER_END();
    // TODO: defer error events consistently everywhere, not just the cb
    $918484e8c698b555$var$errorOrDestroy(stream, er);
    $4TNnu.nextTick(cb, er);
}
// Checks that a user-supplied chunk is valid, especially for the particular
// mode the stream is in. Currently this means that `null` is never accepted
// and undefined/non-string values are only allowed in object mode.
function $918484e8c698b555$var$validChunk(stream, state, chunk, cb) {
    var er;
    if (chunk === null) er = new $918484e8c698b555$var$ERR_STREAM_NULL_VALUES();
    else if (typeof chunk !== "string" && !state.objectMode) er = new $918484e8c698b555$var$ERR_INVALID_ARG_TYPE("chunk", [
        "string",
        "Buffer"
    ], chunk);
    if (er) {
        $918484e8c698b555$var$errorOrDestroy(stream, er);
        $4TNnu.nextTick(cb, er);
        return false;
    }
    return true;
}
$918484e8c698b555$var$Writable.prototype.write = function(chunk, encoding, cb) {
    var state = this._writableState;
    var ret = false;
    var isBuf = !state.objectMode && $918484e8c698b555$var$_isUint8Array(chunk);
    if (isBuf && !$918484e8c698b555$require$Buffer.isBuffer(chunk)) chunk = $918484e8c698b555$var$_uint8ArrayToBuffer(chunk);
    if (typeof encoding === "function") {
        cb = encoding;
        encoding = null;
    }
    if (isBuf) encoding = "buffer";
    else if (!encoding) encoding = state.defaultEncoding;
    if (typeof cb !== "function") cb = $918484e8c698b555$var$nop;
    if (state.ending) $918484e8c698b555$var$writeAfterEnd(this, cb);
    else if (isBuf || $918484e8c698b555$var$validChunk(this, state, chunk, cb)) {
        state.pendingcb++;
        ret = $918484e8c698b555$var$writeOrBuffer(this, state, isBuf, chunk, encoding, cb);
    }
    return ret;
};
$918484e8c698b555$var$Writable.prototype.cork = function() {
    this._writableState.corked++;
};
$918484e8c698b555$var$Writable.prototype.uncork = function() {
    var state = this._writableState;
    if (state.corked) {
        state.corked--;
        if (!state.writing && !state.corked && !state.bufferProcessing && state.bufferedRequest) $918484e8c698b555$var$clearBuffer(this, state);
    }
};
$918484e8c698b555$var$Writable.prototype.setDefaultEncoding = function setDefaultEncoding(encoding) {
    // node::ParseEncoding() requires lower case.
    if (typeof encoding === "string") encoding = encoding.toLowerCase();
    if (!([
        "hex",
        "utf8",
        "utf-8",
        "ascii",
        "binary",
        "base64",
        "ucs2",
        "ucs-2",
        "utf16le",
        "utf-16le",
        "raw"
    ].indexOf((encoding + "").toLowerCase()) > -1)) throw new $918484e8c698b555$var$ERR_UNKNOWN_ENCODING(encoding);
    this._writableState.defaultEncoding = encoding;
    return this;
};
Object.defineProperty($918484e8c698b555$var$Writable.prototype, "writableBuffer", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._writableState && this._writableState.getBuffer();
    }
});
function $918484e8c698b555$var$decodeChunk(state, chunk, encoding) {
    if (!state.objectMode && state.decodeStrings !== false && typeof chunk === "string") chunk = $918484e8c698b555$require$Buffer.from(chunk, encoding);
    return chunk;
}
Object.defineProperty($918484e8c698b555$var$Writable.prototype, "writableHighWaterMark", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._writableState.highWaterMark;
    }
});
// if we're already writing something, then just put this
// in the queue, and wait our turn.  Otherwise, call _write
// If we return false, then we need a drain event, so set that flag.
function $918484e8c698b555$var$writeOrBuffer(stream, state, isBuf, chunk, encoding, cb) {
    if (!isBuf) {
        var newChunk = $918484e8c698b555$var$decodeChunk(state, chunk, encoding);
        if (chunk !== newChunk) {
            isBuf = true;
            encoding = "buffer";
            chunk = newChunk;
        }
    }
    var len = state.objectMode ? 1 : chunk.length;
    state.length += len;
    var ret = state.length < state.highWaterMark;
    // we must ensure that previous needDrain will not be reset to false.
    if (!ret) state.needDrain = true;
    if (state.writing || state.corked) {
        var last = state.lastBufferedRequest;
        state.lastBufferedRequest = {
            chunk: chunk,
            encoding: encoding,
            isBuf: isBuf,
            callback: cb,
            next: null
        };
        if (last) last.next = state.lastBufferedRequest;
        else state.bufferedRequest = state.lastBufferedRequest;
        state.bufferedRequestCount += 1;
    } else $918484e8c698b555$var$doWrite(stream, state, false, len, chunk, encoding, cb);
    return ret;
}
function $918484e8c698b555$var$doWrite(stream, state, writev, len, chunk, encoding, cb) {
    state.writelen = len;
    state.writecb = cb;
    state.writing = true;
    state.sync = true;
    if (state.destroyed) state.onwrite(new $918484e8c698b555$var$ERR_STREAM_DESTROYED("write"));
    else if (writev) stream._writev(chunk, state.onwrite);
    else stream._write(chunk, encoding, state.onwrite);
    state.sync = false;
}
function $918484e8c698b555$var$onwriteError(stream, state, sync, er, cb) {
    --state.pendingcb;
    if (sync) {
        // defer the callback if we are being called synchronously
        // to avoid piling up things on the stack
        $4TNnu.nextTick(cb, er);
        // this can emit finish, and it will always happen
        // after error
        $4TNnu.nextTick($918484e8c698b555$var$finishMaybe, stream, state);
        stream._writableState.errorEmitted = true;
        $918484e8c698b555$var$errorOrDestroy(stream, er);
    } else {
        // the caller expect this to happen before if
        // it is async
        cb(er);
        stream._writableState.errorEmitted = true;
        $918484e8c698b555$var$errorOrDestroy(stream, er);
        // this can emit finish, but finish must
        // always follow error
        $918484e8c698b555$var$finishMaybe(stream, state);
    }
}
function $918484e8c698b555$var$onwriteStateUpdate(state) {
    state.writing = false;
    state.writecb = null;
    state.length -= state.writelen;
    state.writelen = 0;
}
function $918484e8c698b555$var$onwrite(stream, er) {
    var state = stream._writableState;
    var sync = state.sync;
    var cb = state.writecb;
    if (typeof cb !== "function") throw new $918484e8c698b555$var$ERR_MULTIPLE_CALLBACK();
    $918484e8c698b555$var$onwriteStateUpdate(state);
    if (er) $918484e8c698b555$var$onwriteError(stream, state, sync, er, cb);
    else {
        // Check if we're actually ready to finish, but don't emit yet
        var finished = $918484e8c698b555$var$needFinish(state) || stream.destroyed;
        if (!finished && !state.corked && !state.bufferProcessing && state.bufferedRequest) $918484e8c698b555$var$clearBuffer(stream, state);
        if (sync) $4TNnu.nextTick($918484e8c698b555$var$afterWrite, stream, state, finished, cb);
        else $918484e8c698b555$var$afterWrite(stream, state, finished, cb);
    }
}
function $918484e8c698b555$var$afterWrite(stream, state, finished, cb) {
    if (!finished) $918484e8c698b555$var$onwriteDrain(stream, state);
    state.pendingcb--;
    cb();
    $918484e8c698b555$var$finishMaybe(stream, state);
}
// Must force callback to be called on nextTick, so that we don't
// emit 'drain' before the write() consumer gets the 'false' return
// value, and has a chance to attach a 'drain' listener.
function $918484e8c698b555$var$onwriteDrain(stream, state) {
    if (state.length === 0 && state.needDrain) {
        state.needDrain = false;
        stream.emit("drain");
    }
}
// if there's something in the buffer waiting, then process it
function $918484e8c698b555$var$clearBuffer(stream, state) {
    state.bufferProcessing = true;
    var entry = state.bufferedRequest;
    if (stream._writev && entry && entry.next) {
        // Fast case, write everything using _writev()
        var l = state.bufferedRequestCount;
        var buffer = new Array(l);
        var holder = state.corkedRequestsFree;
        holder.entry = entry;
        var count = 0;
        var allBuffers = true;
        while(entry){
            buffer[count] = entry;
            if (!entry.isBuf) allBuffers = false;
            entry = entry.next;
            count += 1;
        }
        buffer.allBuffers = allBuffers;
        $918484e8c698b555$var$doWrite(stream, state, true, state.length, buffer, "", holder.finish);
        // doWrite is almost always async, defer these to save a bit of time
        // as the hot path ends with doWrite
        state.pendingcb++;
        state.lastBufferedRequest = null;
        if (holder.next) {
            state.corkedRequestsFree = holder.next;
            holder.next = null;
        } else state.corkedRequestsFree = new $918484e8c698b555$var$CorkedRequest(state);
        state.bufferedRequestCount = 0;
    } else {
        // Slow case, write chunks one-by-one
        while(entry){
            var chunk = entry.chunk;
            var encoding = entry.encoding;
            var cb = entry.callback;
            var len = state.objectMode ? 1 : chunk.length;
            $918484e8c698b555$var$doWrite(stream, state, false, len, chunk, encoding, cb);
            entry = entry.next;
            state.bufferedRequestCount--;
            // if we didn't call the onwrite immediately, then
            // it means that we need to wait until it does.
            // also, that means that the chunk and cb are currently
            // being processed, so move the buffer counter past them.
            if (state.writing) break;
        }
        if (entry === null) state.lastBufferedRequest = null;
    }
    state.bufferedRequest = entry;
    state.bufferProcessing = false;
}
$918484e8c698b555$var$Writable.prototype._write = function(chunk, encoding, cb) {
    cb(new $918484e8c698b555$var$ERR_METHOD_NOT_IMPLEMENTED("_write()"));
};
$918484e8c698b555$var$Writable.prototype._writev = null;
$918484e8c698b555$var$Writable.prototype.end = function(chunk, encoding, cb) {
    var state = this._writableState;
    if (typeof chunk === "function") {
        cb = chunk;
        chunk = null;
        encoding = null;
    } else if (typeof encoding === "function") {
        cb = encoding;
        encoding = null;
    }
    if (chunk !== null && chunk !== undefined) this.write(chunk, encoding);
    // .end() fully uncorks
    if (state.corked) {
        state.corked = 1;
        this.uncork();
    }
    // ignore unnecessary end() calls.
    if (!state.ending) $918484e8c698b555$var$endWritable(this, state, cb);
    return this;
};
Object.defineProperty($918484e8c698b555$var$Writable.prototype, "writableLength", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._writableState.length;
    }
});
function $918484e8c698b555$var$needFinish(state) {
    return state.ending && state.length === 0 && state.bufferedRequest === null && !state.finished && !state.writing;
}
function $918484e8c698b555$var$callFinal(stream, state) {
    stream._final(function(err) {
        state.pendingcb--;
        if (err) $918484e8c698b555$var$errorOrDestroy(stream, err);
        state.prefinished = true;
        stream.emit("prefinish");
        $918484e8c698b555$var$finishMaybe(stream, state);
    });
}
function $918484e8c698b555$var$prefinish(stream, state) {
    if (!state.prefinished && !state.finalCalled) {
        if (typeof stream._final === "function" && !state.destroyed) {
            state.pendingcb++;
            state.finalCalled = true;
            $4TNnu.nextTick($918484e8c698b555$var$callFinal, stream, state);
        } else {
            state.prefinished = true;
            stream.emit("prefinish");
        }
    }
}
function $918484e8c698b555$var$finishMaybe(stream, state) {
    var need = $918484e8c698b555$var$needFinish(state);
    if (need) {
        $918484e8c698b555$var$prefinish(stream, state);
        if (state.pendingcb === 0) {
            state.finished = true;
            stream.emit("finish");
            if (state.autoDestroy) {
                // In case of duplex streams we need a way to detect
                // if the readable side is ready for autoDestroy as well
                var rState = stream._readableState;
                if (!rState || rState.autoDestroy && rState.endEmitted) stream.destroy();
            }
        }
    }
    return need;
}
function $918484e8c698b555$var$endWritable(stream, state, cb) {
    state.ending = true;
    $918484e8c698b555$var$finishMaybe(stream, state);
    if (cb) {
        if (state.finished) $4TNnu.nextTick(cb);
        else stream.once("finish", cb);
    }
    state.ended = true;
    stream.writable = false;
}
function $918484e8c698b555$var$onCorkedFinish(corkReq, state, err) {
    var entry = corkReq.entry;
    corkReq.entry = null;
    while(entry){
        var cb = entry.callback;
        state.pendingcb--;
        cb(err);
        entry = entry.next;
    }
    // reuse the free corkReq.
    state.corkedRequestsFree.next = corkReq;
}
Object.defineProperty($918484e8c698b555$var$Writable.prototype, "destroyed", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        if (this._writableState === undefined) return false;
        return this._writableState.destroyed;
    },
    set: function set(value) {
        // we ignore the value if the stream
        // has not been initialized yet
        if (!this._writableState) return;
        // backward compatibility, the user is explicitly
        // managing destroyed
        this._writableState.destroyed = value;
    }
});
$918484e8c698b555$var$Writable.prototype.destroy = $kZIsm.destroy;
$918484e8c698b555$var$Writable.prototype._undestroy = $kZIsm.undestroy;
$918484e8c698b555$var$Writable.prototype._destroy = function(err, cb) {
    cb(err);
};

});
parcelRequire.register("l4FQK", function(module, exports) {
/**
 * Module exports.
 */ module.exports = $f57a6f356a44cf08$var$deprecate;
/**
 * Mark that a method should not be used.
 * Returns a modified function which warns once by default.
 *
 * If `localStorage.noDeprecation = true` is set, then it is a no-op.
 *
 * If `localStorage.throwDeprecation = true` is set, then deprecated functions
 * will throw an Error when invoked.
 *
 * If `localStorage.traceDeprecation = true` is set, then deprecated functions
 * will invoke `console.trace()` instead of `console.error()`.
 *
 * @param {Function} fn - the function to deprecate
 * @param {String} msg - the string to print to the console when `fn` is invoked
 * @returns {Function} a new "deprecated" version of `fn`
 * @api public
 */ function $f57a6f356a44cf08$var$deprecate(fn, msg) {
    if ($f57a6f356a44cf08$var$config("noDeprecation")) return fn;
    var warned = false;
    function deprecated() {
        if (!warned) {
            if ($f57a6f356a44cf08$var$config("throwDeprecation")) throw new Error(msg);
            else if ($f57a6f356a44cf08$var$config("traceDeprecation")) console.trace(msg);
            else console.warn(msg);
            warned = true;
        }
        return fn.apply(this, arguments);
    }
    return deprecated;
}
/**
 * Checks `localStorage` for boolean values for the given `name`.
 *
 * @param {String} name
 * @returns {Boolean}
 * @api private
 */ function $f57a6f356a44cf08$var$config(name) {
    // accessing global.localStorage can trigger a DOMException in sandboxed iframes
    try {
        if (!$parcel$global.localStorage) return false;
    } catch (_) {
        return false;
    }
    var val = $parcel$global.localStorage[name];
    if (null == val) return false;
    return String(val).toLowerCase() === "true";
}

});



parcelRequire.register("lEpDX", function(module, exports) {

$parcel$export(module.exports, "StringDecoder", function () { return $fc3139ad3bf9c399$export$63a7aa211a91ed69; }, function (v) { return $fc3139ad3bf9c399$export$63a7aa211a91ed69 = v; });
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// StringDecoder provides an interface for efficiently splitting a series of
// buffers into a series of JS strings without breaking apart multi-byte
// characters.
var $fc3139ad3bf9c399$export$63a7aa211a91ed69;
"use strict";

var $6U9mG = parcelRequire("6U9mG");
var $fc3139ad3bf9c399$require$Buffer = $6U9mG.Buffer;
/*</replacement>*/ var $fc3139ad3bf9c399$var$isEncoding = $fc3139ad3bf9c399$require$Buffer.isEncoding || function(encoding) {
    encoding = "" + encoding;
    switch(encoding && encoding.toLowerCase()){
        case "hex":
        case "utf8":
        case "utf-8":
        case "ascii":
        case "binary":
        case "base64":
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
        case "raw":
            return true;
        default:
            return false;
    }
};
function $fc3139ad3bf9c399$var$_normalizeEncoding(enc) {
    if (!enc) return "utf8";
    var retried;
    while(true)switch(enc){
        case "utf8":
        case "utf-8":
            return "utf8";
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return "utf16le";
        case "latin1":
        case "binary":
            return "latin1";
        case "base64":
        case "ascii":
        case "hex":
            return enc;
        default:
            if (retried) return; // undefined
            enc = ("" + enc).toLowerCase();
            retried = true;
    }
}
// Do not cache `Buffer.isEncoding` when checking encoding names as some
// modules monkey-patch it to support additional encodings
function $fc3139ad3bf9c399$var$normalizeEncoding(enc) {
    var nenc = $fc3139ad3bf9c399$var$_normalizeEncoding(enc);
    if (typeof nenc !== "string" && ($fc3139ad3bf9c399$require$Buffer.isEncoding === $fc3139ad3bf9c399$var$isEncoding || !$fc3139ad3bf9c399$var$isEncoding(enc))) throw new Error("Unknown encoding: " + enc);
    return nenc || enc;
}
$fc3139ad3bf9c399$export$63a7aa211a91ed69 = $fc3139ad3bf9c399$var$StringDecoder;
function $fc3139ad3bf9c399$var$StringDecoder(encoding) {
    this.encoding = $fc3139ad3bf9c399$var$normalizeEncoding(encoding);
    var nb;
    switch(this.encoding){
        case "utf16le":
            this.text = $fc3139ad3bf9c399$var$utf16Text;
            this.end = $fc3139ad3bf9c399$var$utf16End;
            nb = 4;
            break;
        case "utf8":
            this.fillLast = $fc3139ad3bf9c399$var$utf8FillLast;
            nb = 4;
            break;
        case "base64":
            this.text = $fc3139ad3bf9c399$var$base64Text;
            this.end = $fc3139ad3bf9c399$var$base64End;
            nb = 3;
            break;
        default:
            this.write = $fc3139ad3bf9c399$var$simpleWrite;
            this.end = $fc3139ad3bf9c399$var$simpleEnd;
            return;
    }
    this.lastNeed = 0;
    this.lastTotal = 0;
    this.lastChar = $fc3139ad3bf9c399$require$Buffer.allocUnsafe(nb);
}
$fc3139ad3bf9c399$var$StringDecoder.prototype.write = function(buf) {
    if (buf.length === 0) return "";
    var r;
    var i;
    if (this.lastNeed) {
        r = this.fillLast(buf);
        if (r === undefined) return "";
        i = this.lastNeed;
        this.lastNeed = 0;
    } else i = 0;
    if (i < buf.length) return r ? r + this.text(buf, i) : this.text(buf, i);
    return r || "";
};
$fc3139ad3bf9c399$var$StringDecoder.prototype.end = $fc3139ad3bf9c399$var$utf8End;
// Returns only complete characters in a Buffer
$fc3139ad3bf9c399$var$StringDecoder.prototype.text = $fc3139ad3bf9c399$var$utf8Text;
// Attempts to complete a partial non-UTF-8 character using bytes from a Buffer
$fc3139ad3bf9c399$var$StringDecoder.prototype.fillLast = function(buf) {
    if (this.lastNeed <= buf.length) {
        buf.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, this.lastNeed);
        return this.lastChar.toString(this.encoding, 0, this.lastTotal);
    }
    buf.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, buf.length);
    this.lastNeed -= buf.length;
};
// Checks the type of a UTF-8 byte, whether it's ASCII, a leading byte, or a
// continuation byte. If an invalid byte is detected, -2 is returned.
function $fc3139ad3bf9c399$var$utf8CheckByte(byte) {
    if (byte <= 0x7F) return 0;
    else if (byte >> 5 === 0x06) return 2;
    else if (byte >> 4 === 0x0E) return 3;
    else if (byte >> 3 === 0x1E) return 4;
    return byte >> 6 === 0x02 ? -1 : -2;
}
// Checks at most 3 bytes at the end of a Buffer in order to detect an
// incomplete multi-byte UTF-8 character. The total number of bytes (2, 3, or 4)
// needed to complete the UTF-8 character (if applicable) are returned.
function $fc3139ad3bf9c399$var$utf8CheckIncomplete(self, buf, i) {
    var j = buf.length - 1;
    if (j < i) return 0;
    var nb = $fc3139ad3bf9c399$var$utf8CheckByte(buf[j]);
    if (nb >= 0) {
        if (nb > 0) self.lastNeed = nb - 1;
        return nb;
    }
    if (--j < i || nb === -2) return 0;
    nb = $fc3139ad3bf9c399$var$utf8CheckByte(buf[j]);
    if (nb >= 0) {
        if (nb > 0) self.lastNeed = nb - 2;
        return nb;
    }
    if (--j < i || nb === -2) return 0;
    nb = $fc3139ad3bf9c399$var$utf8CheckByte(buf[j]);
    if (nb >= 0) {
        if (nb > 0) {
            if (nb === 2) nb = 0;
            else self.lastNeed = nb - 3;
        }
        return nb;
    }
    return 0;
}
// Validates as many continuation bytes for a multi-byte UTF-8 character as
// needed or are available. If we see a non-continuation byte where we expect
// one, we "replace" the validated continuation bytes we've seen so far with
// a single UTF-8 replacement character ('\ufffd'), to match v8's UTF-8 decoding
// behavior. The continuation byte check is included three times in the case
// where all of the continuation bytes for a character exist in the same buffer.
// It is also done this way as a slight performance increase instead of using a
// loop.
function $fc3139ad3bf9c399$var$utf8CheckExtraBytes(self, buf, p) {
    if ((buf[0] & 0xC0) !== 0x80) {
        self.lastNeed = 0;
        return "�";
    }
    if (self.lastNeed > 1 && buf.length > 1) {
        if ((buf[1] & 0xC0) !== 0x80) {
            self.lastNeed = 1;
            return "�";
        }
        if (self.lastNeed > 2 && buf.length > 2) {
            if ((buf[2] & 0xC0) !== 0x80) {
                self.lastNeed = 2;
                return "�";
            }
        }
    }
}
// Attempts to complete a multi-byte UTF-8 character using bytes from a Buffer.
function $fc3139ad3bf9c399$var$utf8FillLast(buf) {
    var p = this.lastTotal - this.lastNeed;
    var r = $fc3139ad3bf9c399$var$utf8CheckExtraBytes(this, buf, p);
    if (r !== undefined) return r;
    if (this.lastNeed <= buf.length) {
        buf.copy(this.lastChar, p, 0, this.lastNeed);
        return this.lastChar.toString(this.encoding, 0, this.lastTotal);
    }
    buf.copy(this.lastChar, p, 0, buf.length);
    this.lastNeed -= buf.length;
}
// Returns all complete UTF-8 characters in a Buffer. If the Buffer ended on a
// partial character, the character's bytes are buffered until the required
// number of bytes are available.
function $fc3139ad3bf9c399$var$utf8Text(buf, i) {
    var total = $fc3139ad3bf9c399$var$utf8CheckIncomplete(this, buf, i);
    if (!this.lastNeed) return buf.toString("utf8", i);
    this.lastTotal = total;
    var end = buf.length - (total - this.lastNeed);
    buf.copy(this.lastChar, 0, end);
    return buf.toString("utf8", i, end);
}
// For UTF-8, a replacement character is added when ending on a partial
// character.
function $fc3139ad3bf9c399$var$utf8End(buf) {
    var r = buf && buf.length ? this.write(buf) : "";
    if (this.lastNeed) return r + "�";
    return r;
}
// UTF-16LE typically needs two bytes per character, but even if we have an even
// number of bytes available, we need to check if we end on a leading/high
// surrogate. In that case, we need to wait for the next two bytes in order to
// decode the last character properly.
function $fc3139ad3bf9c399$var$utf16Text(buf, i) {
    if ((buf.length - i) % 2 === 0) {
        var r = buf.toString("utf16le", i);
        if (r) {
            var c = r.charCodeAt(r.length - 1);
            if (c >= 0xD800 && c <= 0xDBFF) {
                this.lastNeed = 2;
                this.lastTotal = 4;
                this.lastChar[0] = buf[buf.length - 2];
                this.lastChar[1] = buf[buf.length - 1];
                return r.slice(0, -1);
            }
        }
        return r;
    }
    this.lastNeed = 1;
    this.lastTotal = 2;
    this.lastChar[0] = buf[buf.length - 1];
    return buf.toString("utf16le", i, buf.length - 1);
}
// For UTF-16LE we do not explicitly append special replacement characters if we
// end on a partial character, we simply let v8 handle that.
function $fc3139ad3bf9c399$var$utf16End(buf) {
    var r = buf && buf.length ? this.write(buf) : "";
    if (this.lastNeed) {
        var end = this.lastTotal - this.lastNeed;
        return r + this.lastChar.toString("utf16le", 0, end);
    }
    return r;
}
function $fc3139ad3bf9c399$var$base64Text(buf, i) {
    var n = (buf.length - i) % 3;
    if (n === 0) return buf.toString("base64", i);
    this.lastNeed = 3 - n;
    this.lastTotal = 3;
    if (n === 1) this.lastChar[0] = buf[buf.length - 1];
    else {
        this.lastChar[0] = buf[buf.length - 2];
        this.lastChar[1] = buf[buf.length - 1];
    }
    return buf.toString("base64", i, buf.length - n);
}
function $fc3139ad3bf9c399$var$base64End(buf) {
    var r = buf && buf.length ? this.write(buf) : "";
    if (this.lastNeed) return r + this.lastChar.toString("base64", 0, 3 - this.lastNeed);
    return r;
}
// Pass bytes on through for single-byte encodings (e.g. ascii, latin1, hex)
function $fc3139ad3bf9c399$var$simpleWrite(buf) {
    return buf.toString(this.encoding);
}
function $fc3139ad3bf9c399$var$simpleEnd(buf) {
    return buf && buf.length ? this.write(buf) : "";
}

});

parcelRequire.register("8BamM", function(module, exports) {

var $4TNnu = parcelRequire("4TNnu");
"use strict";
var $6429d1f92cebcf33$var$_Object$setPrototypeO;
function $6429d1f92cebcf33$var$_defineProperty(obj, key, value) {
    key = $6429d1f92cebcf33$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $6429d1f92cebcf33$var$_toPropertyKey(arg) {
    var key = $6429d1f92cebcf33$var$_toPrimitive(arg, "string");
    return typeof key === "symbol" ? key : String(key);
}
function $6429d1f92cebcf33$var$_toPrimitive(input, hint) {
    if (typeof input !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (typeof res !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}

var $gr8mb = parcelRequire("gr8mb");
var $6429d1f92cebcf33$var$kLastResolve = Symbol("lastResolve");
var $6429d1f92cebcf33$var$kLastReject = Symbol("lastReject");
var $6429d1f92cebcf33$var$kError = Symbol("error");
var $6429d1f92cebcf33$var$kEnded = Symbol("ended");
var $6429d1f92cebcf33$var$kLastPromise = Symbol("lastPromise");
var $6429d1f92cebcf33$var$kHandlePromise = Symbol("handlePromise");
var $6429d1f92cebcf33$var$kStream = Symbol("stream");
function $6429d1f92cebcf33$var$createIterResult(value, done) {
    return {
        value: value,
        done: done
    };
}
function $6429d1f92cebcf33$var$readAndResolve(iter) {
    var resolve = iter[$6429d1f92cebcf33$var$kLastResolve];
    if (resolve !== null) {
        var data = iter[$6429d1f92cebcf33$var$kStream].read();
        // we defer if data is null
        // we can be expecting either 'end' or
        // 'error'
        if (data !== null) {
            iter[$6429d1f92cebcf33$var$kLastPromise] = null;
            iter[$6429d1f92cebcf33$var$kLastResolve] = null;
            iter[$6429d1f92cebcf33$var$kLastReject] = null;
            resolve($6429d1f92cebcf33$var$createIterResult(data, false));
        }
    }
}
function $6429d1f92cebcf33$var$onReadable(iter) {
    // we wait for the next tick, because it might
    // emit an error with process.nextTick
    $4TNnu.nextTick($6429d1f92cebcf33$var$readAndResolve, iter);
}
function $6429d1f92cebcf33$var$wrapForNext(lastPromise, iter) {
    return function(resolve, reject) {
        lastPromise.then(function() {
            if (iter[$6429d1f92cebcf33$var$kEnded]) {
                resolve($6429d1f92cebcf33$var$createIterResult(undefined, true));
                return;
            }
            iter[$6429d1f92cebcf33$var$kHandlePromise](resolve, reject);
        }, reject);
    };
}
var $6429d1f92cebcf33$var$AsyncIteratorPrototype = Object.getPrototypeOf(function() {});
var $6429d1f92cebcf33$var$ReadableStreamAsyncIteratorPrototype = Object.setPrototypeOf(($6429d1f92cebcf33$var$_Object$setPrototypeO = {
    get stream () {
        return this[$6429d1f92cebcf33$var$kStream];
    },
    next: function next() {
        var _this = this;
        // if we have detected an error in the meanwhile
        // reject straight away
        var error = this[$6429d1f92cebcf33$var$kError];
        if (error !== null) return Promise.reject(error);
        if (this[$6429d1f92cebcf33$var$kEnded]) return Promise.resolve($6429d1f92cebcf33$var$createIterResult(undefined, true));
        if (this[$6429d1f92cebcf33$var$kStream].destroyed) // We need to defer via nextTick because if .destroy(err) is
        // called, the error will be emitted via nextTick, and
        // we cannot guarantee that there is no error lingering around
        // waiting to be emitted.
        return new Promise(function(resolve, reject) {
            $4TNnu.nextTick(function() {
                if (_this[$6429d1f92cebcf33$var$kError]) reject(_this[$6429d1f92cebcf33$var$kError]);
                else resolve($6429d1f92cebcf33$var$createIterResult(undefined, true));
            });
        });
        // if we have multiple next() calls
        // we will wait for the previous Promise to finish
        // this logic is optimized to support for await loops,
        // where next() is only called once at a time
        var lastPromise = this[$6429d1f92cebcf33$var$kLastPromise];
        var promise;
        if (lastPromise) promise = new Promise($6429d1f92cebcf33$var$wrapForNext(lastPromise, this));
        else {
            // fast path needed to support multiple this.push()
            // without triggering the next() queue
            var data = this[$6429d1f92cebcf33$var$kStream].read();
            if (data !== null) return Promise.resolve($6429d1f92cebcf33$var$createIterResult(data, false));
            promise = new Promise(this[$6429d1f92cebcf33$var$kHandlePromise]);
        }
        this[$6429d1f92cebcf33$var$kLastPromise] = promise;
        return promise;
    }
}, $6429d1f92cebcf33$var$_defineProperty($6429d1f92cebcf33$var$_Object$setPrototypeO, Symbol.asyncIterator, function() {
    return this;
}), $6429d1f92cebcf33$var$_defineProperty($6429d1f92cebcf33$var$_Object$setPrototypeO, "return", function _return() {
    var _this2 = this;
    // destroy(err, cb) is a private API
    // we can guarantee we have that here, because we control the
    // Readable class this is attached to
    return new Promise(function(resolve, reject) {
        _this2[$6429d1f92cebcf33$var$kStream].destroy(null, function(err) {
            if (err) {
                reject(err);
                return;
            }
            resolve($6429d1f92cebcf33$var$createIterResult(undefined, true));
        });
    });
}), $6429d1f92cebcf33$var$_Object$setPrototypeO), $6429d1f92cebcf33$var$AsyncIteratorPrototype);
var $6429d1f92cebcf33$var$createReadableStreamAsyncIterator = function createReadableStreamAsyncIterator(stream) {
    var _Object$create;
    var iterator = Object.create($6429d1f92cebcf33$var$ReadableStreamAsyncIteratorPrototype, (_Object$create = {}, $6429d1f92cebcf33$var$_defineProperty(_Object$create, $6429d1f92cebcf33$var$kStream, {
        value: stream,
        writable: true
    }), $6429d1f92cebcf33$var$_defineProperty(_Object$create, $6429d1f92cebcf33$var$kLastResolve, {
        value: null,
        writable: true
    }), $6429d1f92cebcf33$var$_defineProperty(_Object$create, $6429d1f92cebcf33$var$kLastReject, {
        value: null,
        writable: true
    }), $6429d1f92cebcf33$var$_defineProperty(_Object$create, $6429d1f92cebcf33$var$kError, {
        value: null,
        writable: true
    }), $6429d1f92cebcf33$var$_defineProperty(_Object$create, $6429d1f92cebcf33$var$kEnded, {
        value: stream._readableState.endEmitted,
        writable: true
    }), $6429d1f92cebcf33$var$_defineProperty(_Object$create, $6429d1f92cebcf33$var$kHandlePromise, {
        value: function value(resolve, reject) {
            var data = iterator[$6429d1f92cebcf33$var$kStream].read();
            if (data) {
                iterator[$6429d1f92cebcf33$var$kLastPromise] = null;
                iterator[$6429d1f92cebcf33$var$kLastResolve] = null;
                iterator[$6429d1f92cebcf33$var$kLastReject] = null;
                resolve($6429d1f92cebcf33$var$createIterResult(data, false));
            } else {
                iterator[$6429d1f92cebcf33$var$kLastResolve] = resolve;
                iterator[$6429d1f92cebcf33$var$kLastReject] = reject;
            }
        },
        writable: true
    }), _Object$create));
    iterator[$6429d1f92cebcf33$var$kLastPromise] = null;
    $gr8mb(stream, function(err) {
        if (err && err.code !== "ERR_STREAM_PREMATURE_CLOSE") {
            var reject = iterator[$6429d1f92cebcf33$var$kLastReject];
            // reject if we are waiting for data in the Promise
            // returned by next() and store the error
            if (reject !== null) {
                iterator[$6429d1f92cebcf33$var$kLastPromise] = null;
                iterator[$6429d1f92cebcf33$var$kLastResolve] = null;
                iterator[$6429d1f92cebcf33$var$kLastReject] = null;
                reject(err);
            }
            iterator[$6429d1f92cebcf33$var$kError] = err;
            return;
        }
        var resolve = iterator[$6429d1f92cebcf33$var$kLastResolve];
        if (resolve !== null) {
            iterator[$6429d1f92cebcf33$var$kLastPromise] = null;
            iterator[$6429d1f92cebcf33$var$kLastResolve] = null;
            iterator[$6429d1f92cebcf33$var$kLastReject] = null;
            resolve($6429d1f92cebcf33$var$createIterResult(undefined, true));
        }
        iterator[$6429d1f92cebcf33$var$kEnded] = true;
    });
    stream.on("readable", $6429d1f92cebcf33$var$onReadable.bind(null, iterator));
    return iterator;
};
module.exports = $6429d1f92cebcf33$var$createReadableStreamAsyncIterator;

});
parcelRequire.register("gr8mb", function(module, exports) {
// Ported from https://github.com/mafintosh/end-of-stream with
// permission from the author, Mathias Buus (@mafintosh).
"use strict";

var $dzxhd = parcelRequire("dzxhd");
var $bf75a6707710fb34$var$ERR_STREAM_PREMATURE_CLOSE = $dzxhd.codes.ERR_STREAM_PREMATURE_CLOSE;
function $bf75a6707710fb34$var$once(callback) {
    var called = false;
    return function() {
        if (called) return;
        called = true;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        callback.apply(this, args);
    };
}
function $bf75a6707710fb34$var$noop() {}
function $bf75a6707710fb34$var$isRequest(stream) {
    return stream.setHeader && typeof stream.abort === "function";
}
function $bf75a6707710fb34$var$eos(stream, opts, callback) {
    if (typeof opts === "function") return $bf75a6707710fb34$var$eos(stream, null, opts);
    if (!opts) opts = {};
    callback = $bf75a6707710fb34$var$once(callback || $bf75a6707710fb34$var$noop);
    var readable = opts.readable || opts.readable !== false && stream.readable;
    var writable = opts.writable || opts.writable !== false && stream.writable;
    var onlegacyfinish = function onlegacyfinish() {
        if (!stream.writable) onfinish();
    };
    var writableEnded = stream._writableState && stream._writableState.finished;
    var onfinish = function onfinish() {
        writable = false;
        writableEnded = true;
        if (!readable) callback.call(stream);
    };
    var readableEnded = stream._readableState && stream._readableState.endEmitted;
    var onend = function onend() {
        readable = false;
        readableEnded = true;
        if (!writable) callback.call(stream);
    };
    var onerror = function onerror(err) {
        callback.call(stream, err);
    };
    var onclose = function onclose() {
        var err;
        if (readable && !readableEnded) {
            if (!stream._readableState || !stream._readableState.ended) err = new $bf75a6707710fb34$var$ERR_STREAM_PREMATURE_CLOSE();
            return callback.call(stream, err);
        }
        if (writable && !writableEnded) {
            if (!stream._writableState || !stream._writableState.ended) err = new $bf75a6707710fb34$var$ERR_STREAM_PREMATURE_CLOSE();
            return callback.call(stream, err);
        }
    };
    var onrequest = function onrequest() {
        stream.req.on("finish", onfinish);
    };
    if ($bf75a6707710fb34$var$isRequest(stream)) {
        stream.on("complete", onfinish);
        stream.on("abort", onclose);
        if (stream.req) onrequest();
        else stream.on("request", onrequest);
    } else if (writable && !stream._writableState) {
        // legacy streams
        stream.on("end", onlegacyfinish);
        stream.on("close", onlegacyfinish);
    }
    stream.on("end", onend);
    stream.on("finish", onfinish);
    if (opts.error !== false) stream.on("error", onerror);
    stream.on("close", onclose);
    return function() {
        stream.removeListener("complete", onfinish);
        stream.removeListener("abort", onclose);
        stream.removeListener("request", onrequest);
        if (stream.req) stream.req.removeListener("finish", onfinish);
        stream.removeListener("end", onlegacyfinish);
        stream.removeListener("close", onlegacyfinish);
        stream.removeListener("finish", onfinish);
        stream.removeListener("end", onend);
        stream.removeListener("error", onerror);
        stream.removeListener("close", onclose);
    };
}
module.exports = $bf75a6707710fb34$var$eos;

});


parcelRequire.register("eGESN", function(module, exports) {
module.exports = function() {
    throw new Error("Readable.from is not available in the browser");
};

});


parcelRequire.register("l7DDn", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a transform stream is a readable/writable stream where you do
// something with the data.  Sometimes it's called a "filter",
// but that's not a great name for it, since that implies a thing where
// some bits pass through, and others are simply ignored.  (That would
// be a valid example of a transform, of course.)
//
// While the output is causally related to the input, it's not a
// necessarily symmetric or synchronous transformation.  For example,
// a zlib stream might take multiple plain-text writes(), and then
// emit a single compressed chunk some time in the future.
//
// Here's how this works:
//
// The Transform stream has all the aspects of the readable and writable
// stream classes.  When you write(chunk), that calls _write(chunk,cb)
// internally, and returns false if there's a lot of pending writes
// buffered up.  When you call read(), that calls _read(n) until
// there's enough pending readable data buffered up.
//
// In a transform stream, the written data is placed in a buffer.  When
// _read(n) is called, it transforms the queued up data, calling the
// buffered _write cb's as it consumes chunks.  If consuming a single
// written chunk would result in multiple output chunks, then the first
// outputted bit calls the readcb, and subsequent chunks just go into
// the read buffer, and will cause it to emit 'readable' if necessary.
//
// This way, back-pressure is actually determined by the reading side,
// since _read has to be called to start processing a new chunk.  However,
// a pathological inflate type of transform can cause excessive buffering
// here.  For example, imagine a stream where every byte of input is
// interpreted as an integer from 0-255, and then results in that many
// bytes of output.  Writing the 4 bytes {ff,ff,ff,ff} would result in
// 1kb of data being output.  In this case, you could write a very small
// amount of input, and end up with a very large amount of output.  In
// such a pathological inflating mechanism, there'd be no way to tell
// the system to stop doing the transform.  A single 4MB write could
// cause the system to run out of memory.
//
// However, even in such a pathological case, only a single written chunk
// would be consumed, and then the rest would wait (un-transformed) until
// the results of the previous transformed chunk were consumed.
"use strict";
module.exports = $f608fef10a5347dd$var$Transform;

var $dzxhd = parcelRequire("dzxhd");
var $f608fef10a5347dd$require$_require$codes = $dzxhd.codes;
var $f608fef10a5347dd$var$ERR_METHOD_NOT_IMPLEMENTED = $f608fef10a5347dd$require$_require$codes.ERR_METHOD_NOT_IMPLEMENTED, $f608fef10a5347dd$var$ERR_MULTIPLE_CALLBACK = $f608fef10a5347dd$require$_require$codes.ERR_MULTIPLE_CALLBACK, $f608fef10a5347dd$var$ERR_TRANSFORM_ALREADY_TRANSFORMING = $f608fef10a5347dd$require$_require$codes.ERR_TRANSFORM_ALREADY_TRANSFORMING, $f608fef10a5347dd$var$ERR_TRANSFORM_WITH_LENGTH_0 = $f608fef10a5347dd$require$_require$codes.ERR_TRANSFORM_WITH_LENGTH_0;

var $2Hlr9 = parcelRequire("2Hlr9");

(parcelRequire("eSHUL"))($f608fef10a5347dd$var$Transform, $2Hlr9);
function $f608fef10a5347dd$var$afterTransform(er, data) {
    var ts = this._transformState;
    ts.transforming = false;
    var cb = ts.writecb;
    if (cb === null) return this.emit("error", new $f608fef10a5347dd$var$ERR_MULTIPLE_CALLBACK());
    ts.writechunk = null;
    ts.writecb = null;
    if (data != null) // single equals check for both `null` and `undefined`
    this.push(data);
    cb(er);
    var rs = this._readableState;
    rs.reading = false;
    if (rs.needReadable || rs.length < rs.highWaterMark) this._read(rs.highWaterMark);
}
function $f608fef10a5347dd$var$Transform(options) {
    if (!(this instanceof $f608fef10a5347dd$var$Transform)) return new $f608fef10a5347dd$var$Transform(options);
    $2Hlr9.call(this, options);
    this._transformState = {
        afterTransform: $f608fef10a5347dd$var$afterTransform.bind(this),
        needTransform: false,
        transforming: false,
        writecb: null,
        writechunk: null,
        writeencoding: null
    };
    // start out asking for a readable event once data is transformed.
    this._readableState.needReadable = true;
    // we have implemented the _read method, and done the other things
    // that Readable wants before the first _read call, so unset the
    // sync guard flag.
    this._readableState.sync = false;
    if (options) {
        if (typeof options.transform === "function") this._transform = options.transform;
        if (typeof options.flush === "function") this._flush = options.flush;
    }
    // When the writable side finishes, then flush out anything remaining.
    this.on("prefinish", $f608fef10a5347dd$var$prefinish);
}
function $f608fef10a5347dd$var$prefinish() {
    var _this = this;
    if (typeof this._flush === "function" && !this._readableState.destroyed) this._flush(function(er, data) {
        $f608fef10a5347dd$var$done(_this, er, data);
    });
    else $f608fef10a5347dd$var$done(this, null, null);
}
$f608fef10a5347dd$var$Transform.prototype.push = function(chunk, encoding) {
    this._transformState.needTransform = false;
    return $2Hlr9.prototype.push.call(this, chunk, encoding);
};
// This is the part where you do stuff!
// override this function in implementation classes.
// 'chunk' is an input chunk.
//
// Call `push(newChunk)` to pass along transformed output
// to the readable side.  You may call 'push' zero or more times.
//
// Call `cb(err)` when you are done with this chunk.  If you pass
// an error, then that'll put the hurt on the whole operation.  If you
// never call cb(), then you'll never get another chunk.
$f608fef10a5347dd$var$Transform.prototype._transform = function(chunk, encoding, cb) {
    cb(new $f608fef10a5347dd$var$ERR_METHOD_NOT_IMPLEMENTED("_transform()"));
};
$f608fef10a5347dd$var$Transform.prototype._write = function(chunk, encoding, cb) {
    var ts = this._transformState;
    ts.writecb = cb;
    ts.writechunk = chunk;
    ts.writeencoding = encoding;
    if (!ts.transforming) {
        var rs = this._readableState;
        if (ts.needTransform || rs.needReadable || rs.length < rs.highWaterMark) this._read(rs.highWaterMark);
    }
};
// Doesn't matter what the args are here.
// _transform does all the work.
// That we got here means that the readable side wants more data.
$f608fef10a5347dd$var$Transform.prototype._read = function(n) {
    var ts = this._transformState;
    if (ts.writechunk !== null && !ts.transforming) {
        ts.transforming = true;
        this._transform(ts.writechunk, ts.writeencoding, ts.afterTransform);
    } else // mark that we need a transform, so that any data that comes in
    // will get processed, now that we've asked for it.
    ts.needTransform = true;
};
$f608fef10a5347dd$var$Transform.prototype._destroy = function(err, cb) {
    $2Hlr9.prototype._destroy.call(this, err, function(err2) {
        cb(err2);
    });
};
function $f608fef10a5347dd$var$done(stream, er, data) {
    if (er) return stream.emit("error", er);
    if (data != null) // single equals check for both `null` and `undefined`
    stream.push(data);
    // TODO(BridgeAR): Write a test for these two error cases
    // if there's nothing in the write buffer, then that means
    // that nothing more will ever be provided
    if (stream._writableState.length) throw new $f608fef10a5347dd$var$ERR_TRANSFORM_WITH_LENGTH_0();
    if (stream._transformState.transforming) throw new $f608fef10a5347dd$var$ERR_TRANSFORM_ALREADY_TRANSFORMING();
    return stream.push(null);
}

});

parcelRequire.register("6VFzs", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a passthrough stream.
// basically just the most minimal sort of Transform stream.
// Every written chunk gets output as-is.
"use strict";
module.exports = $50b8500ab5b3088d$var$PassThrough;

var $l7DDn = parcelRequire("l7DDn");

(parcelRequire("eSHUL"))($50b8500ab5b3088d$var$PassThrough, $l7DDn);
function $50b8500ab5b3088d$var$PassThrough(options) {
    if (!(this instanceof $50b8500ab5b3088d$var$PassThrough)) return new $50b8500ab5b3088d$var$PassThrough(options);
    $l7DDn.call(this, options);
}
$50b8500ab5b3088d$var$PassThrough.prototype._transform = function(chunk, encoding, cb) {
    cb(null, chunk);
};

});

parcelRequire.register("e8JAK", function(module, exports) {
// Ported from https://github.com/mafintosh/pump with
// permission from the author, Mathias Buus (@mafintosh).
"use strict";
var $a4b52da101f8f158$var$eos;
function $a4b52da101f8f158$var$once(callback) {
    var called = false;
    return function() {
        if (called) return;
        called = true;
        callback.apply(void 0, arguments);
    };
}

var $dzxhd = parcelRequire("dzxhd");
var $a4b52da101f8f158$require$_require$codes = $dzxhd.codes;
var $a4b52da101f8f158$var$ERR_MISSING_ARGS = $a4b52da101f8f158$require$_require$codes.ERR_MISSING_ARGS, $a4b52da101f8f158$var$ERR_STREAM_DESTROYED = $a4b52da101f8f158$require$_require$codes.ERR_STREAM_DESTROYED;
function $a4b52da101f8f158$var$noop(err) {
    // Rethrow the error if it exists to avoid swallowing it
    if (err) throw err;
}
function $a4b52da101f8f158$var$isRequest(stream) {
    return stream.setHeader && typeof stream.abort === "function";
}

function $a4b52da101f8f158$var$destroyer(stream, reading, writing, callback) {
    callback = $a4b52da101f8f158$var$once(callback);
    var closed = false;
    stream.on("close", function() {
        closed = true;
    });
    if ($a4b52da101f8f158$var$eos === undefined) $a4b52da101f8f158$var$eos = (parcelRequire("gr8mb"));
    $a4b52da101f8f158$var$eos(stream, {
        readable: reading,
        writable: writing
    }, function(err) {
        if (err) return callback(err);
        closed = true;
        callback();
    });
    var destroyed = false;
    return function(err) {
        if (closed) return;
        if (destroyed) return;
        destroyed = true;
        // request.destroy just do .end - .abort is what we want
        if ($a4b52da101f8f158$var$isRequest(stream)) return stream.abort();
        if (typeof stream.destroy === "function") return stream.destroy();
        callback(err || new $a4b52da101f8f158$var$ERR_STREAM_DESTROYED("pipe"));
    };
}
function $a4b52da101f8f158$var$call(fn) {
    fn();
}
function $a4b52da101f8f158$var$pipe(from, to) {
    return from.pipe(to);
}
function $a4b52da101f8f158$var$popCallback(streams) {
    if (!streams.length) return $a4b52da101f8f158$var$noop;
    if (typeof streams[streams.length - 1] !== "function") return $a4b52da101f8f158$var$noop;
    return streams.pop();
}
function $a4b52da101f8f158$var$pipeline() {
    for(var _len = arguments.length, streams = new Array(_len), _key = 0; _key < _len; _key++)streams[_key] = arguments[_key];
    var callback = $a4b52da101f8f158$var$popCallback(streams);
    if (Array.isArray(streams[0])) streams = streams[0];
    if (streams.length < 2) throw new $a4b52da101f8f158$var$ERR_MISSING_ARGS("streams");
    var error;
    var destroys = streams.map(function(stream, i) {
        var reading = i < streams.length - 1;
        var writing = i > 0;
        return $a4b52da101f8f158$var$destroyer(stream, reading, writing, function(err) {
            if (!error) error = err;
            if (err) destroys.forEach($a4b52da101f8f158$var$call);
            if (reading) return;
            destroys.forEach($a4b52da101f8f158$var$call);
            callback(error);
        });
    });
    return streams.reduce($a4b52da101f8f158$var$pipe);
}
module.exports = $a4b52da101f8f158$var$pipeline;

});




parcelRequire.register("cjuEr", function(module, exports) {
"use strict";

var $ihoyg = parcelRequire("ihoyg");
var $8f6f09199cc1903f$require$Buffer = $ihoyg.Buffer;

var $eSHUL = parcelRequire("eSHUL");

var $9aUYR = parcelRequire("9aUYR");
var $8f6f09199cc1903f$var$ARRAY16 = new Array(16);
var $8f6f09199cc1903f$var$zl = [
    0,
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10,
    11,
    12,
    13,
    14,
    15,
    7,
    4,
    13,
    1,
    10,
    6,
    15,
    3,
    12,
    0,
    9,
    5,
    2,
    14,
    11,
    8,
    3,
    10,
    14,
    4,
    9,
    15,
    8,
    1,
    2,
    7,
    0,
    6,
    13,
    11,
    5,
    12,
    1,
    9,
    11,
    10,
    0,
    8,
    12,
    4,
    13,
    3,
    7,
    15,
    14,
    5,
    6,
    2,
    4,
    0,
    5,
    9,
    7,
    12,
    2,
    10,
    14,
    1,
    3,
    8,
    11,
    6,
    15,
    13
];
var $8f6f09199cc1903f$var$zr = [
    5,
    14,
    7,
    0,
    9,
    2,
    11,
    4,
    13,
    6,
    15,
    8,
    1,
    10,
    3,
    12,
    6,
    11,
    3,
    7,
    0,
    13,
    5,
    10,
    14,
    15,
    8,
    12,
    4,
    9,
    1,
    2,
    15,
    5,
    1,
    3,
    7,
    14,
    6,
    9,
    11,
    8,
    12,
    2,
    10,
    0,
    4,
    13,
    8,
    6,
    4,
    1,
    3,
    11,
    15,
    0,
    5,
    12,
    2,
    13,
    9,
    7,
    10,
    14,
    12,
    15,
    10,
    4,
    1,
    5,
    8,
    7,
    6,
    2,
    13,
    14,
    0,
    3,
    9,
    11
];
var $8f6f09199cc1903f$var$sl = [
    11,
    14,
    15,
    12,
    5,
    8,
    7,
    9,
    11,
    13,
    14,
    15,
    6,
    7,
    9,
    8,
    7,
    6,
    8,
    13,
    11,
    9,
    7,
    15,
    7,
    12,
    15,
    9,
    11,
    7,
    13,
    12,
    11,
    13,
    6,
    7,
    14,
    9,
    13,
    15,
    14,
    8,
    13,
    6,
    5,
    12,
    7,
    5,
    11,
    12,
    14,
    15,
    14,
    15,
    9,
    8,
    9,
    14,
    5,
    6,
    8,
    6,
    5,
    12,
    9,
    15,
    5,
    11,
    6,
    8,
    13,
    12,
    5,
    12,
    13,
    14,
    11,
    8,
    5,
    6
];
var $8f6f09199cc1903f$var$sr = [
    8,
    9,
    9,
    11,
    13,
    15,
    15,
    5,
    7,
    7,
    8,
    11,
    14,
    14,
    12,
    6,
    9,
    13,
    15,
    7,
    12,
    8,
    9,
    11,
    7,
    7,
    12,
    7,
    6,
    15,
    13,
    11,
    9,
    7,
    15,
    11,
    8,
    6,
    6,
    14,
    12,
    13,
    5,
    14,
    13,
    13,
    7,
    5,
    15,
    5,
    8,
    11,
    14,
    14,
    6,
    14,
    6,
    9,
    12,
    9,
    12,
    5,
    15,
    8,
    8,
    5,
    12,
    9,
    12,
    5,
    14,
    6,
    8,
    13,
    6,
    5,
    15,
    13,
    11,
    11
];
var $8f6f09199cc1903f$var$hl = [
    0x00000000,
    0x5a827999,
    0x6ed9eba1,
    0x8f1bbcdc,
    0xa953fd4e
];
var $8f6f09199cc1903f$var$hr = [
    0x50a28be6,
    0x5c4dd124,
    0x6d703ef3,
    0x7a6d76e9,
    0x00000000
];
function $8f6f09199cc1903f$var$RIPEMD160() {
    $9aUYR.call(this, 64);
    // state
    this._a = 0x67452301;
    this._b = 0xefcdab89;
    this._c = 0x98badcfe;
    this._d = 0x10325476;
    this._e = 0xc3d2e1f0;
}
$eSHUL($8f6f09199cc1903f$var$RIPEMD160, $9aUYR);
$8f6f09199cc1903f$var$RIPEMD160.prototype._update = function() {
    var words = $8f6f09199cc1903f$var$ARRAY16;
    for(var j = 0; j < 16; ++j)words[j] = this._block.readInt32LE(j * 4);
    var al = this._a | 0;
    var bl = this._b | 0;
    var cl = this._c | 0;
    var dl = this._d | 0;
    var el = this._e | 0;
    var ar = this._a | 0;
    var br = this._b | 0;
    var cr = this._c | 0;
    var dr = this._d | 0;
    var er = this._e | 0;
    // computation
    for(var i = 0; i < 80; i += 1){
        var tl;
        var tr;
        if (i < 16) {
            tl = $8f6f09199cc1903f$var$fn1(al, bl, cl, dl, el, words[$8f6f09199cc1903f$var$zl[i]], $8f6f09199cc1903f$var$hl[0], $8f6f09199cc1903f$var$sl[i]);
            tr = $8f6f09199cc1903f$var$fn5(ar, br, cr, dr, er, words[$8f6f09199cc1903f$var$zr[i]], $8f6f09199cc1903f$var$hr[0], $8f6f09199cc1903f$var$sr[i]);
        } else if (i < 32) {
            tl = $8f6f09199cc1903f$var$fn2(al, bl, cl, dl, el, words[$8f6f09199cc1903f$var$zl[i]], $8f6f09199cc1903f$var$hl[1], $8f6f09199cc1903f$var$sl[i]);
            tr = $8f6f09199cc1903f$var$fn4(ar, br, cr, dr, er, words[$8f6f09199cc1903f$var$zr[i]], $8f6f09199cc1903f$var$hr[1], $8f6f09199cc1903f$var$sr[i]);
        } else if (i < 48) {
            tl = $8f6f09199cc1903f$var$fn3(al, bl, cl, dl, el, words[$8f6f09199cc1903f$var$zl[i]], $8f6f09199cc1903f$var$hl[2], $8f6f09199cc1903f$var$sl[i]);
            tr = $8f6f09199cc1903f$var$fn3(ar, br, cr, dr, er, words[$8f6f09199cc1903f$var$zr[i]], $8f6f09199cc1903f$var$hr[2], $8f6f09199cc1903f$var$sr[i]);
        } else if (i < 64) {
            tl = $8f6f09199cc1903f$var$fn4(al, bl, cl, dl, el, words[$8f6f09199cc1903f$var$zl[i]], $8f6f09199cc1903f$var$hl[3], $8f6f09199cc1903f$var$sl[i]);
            tr = $8f6f09199cc1903f$var$fn2(ar, br, cr, dr, er, words[$8f6f09199cc1903f$var$zr[i]], $8f6f09199cc1903f$var$hr[3], $8f6f09199cc1903f$var$sr[i]);
        } else {
            tl = $8f6f09199cc1903f$var$fn5(al, bl, cl, dl, el, words[$8f6f09199cc1903f$var$zl[i]], $8f6f09199cc1903f$var$hl[4], $8f6f09199cc1903f$var$sl[i]);
            tr = $8f6f09199cc1903f$var$fn1(ar, br, cr, dr, er, words[$8f6f09199cc1903f$var$zr[i]], $8f6f09199cc1903f$var$hr[4], $8f6f09199cc1903f$var$sr[i]);
        }
        al = el;
        el = dl;
        dl = $8f6f09199cc1903f$var$rotl(cl, 10);
        cl = bl;
        bl = tl;
        ar = er;
        er = dr;
        dr = $8f6f09199cc1903f$var$rotl(cr, 10);
        cr = br;
        br = tr;
    }
    // update state
    var t = this._b + cl + dr | 0;
    this._b = this._c + dl + er | 0;
    this._c = this._d + el + ar | 0;
    this._d = this._e + al + br | 0;
    this._e = this._a + bl + cr | 0;
    this._a = t;
};
$8f6f09199cc1903f$var$RIPEMD160.prototype._digest = function() {
    // create padding and handle blocks
    this._block[this._blockOffset++] = 0x80;
    if (this._blockOffset > 56) {
        this._block.fill(0, this._blockOffset, 64);
        this._update();
        this._blockOffset = 0;
    }
    this._block.fill(0, this._blockOffset, 56);
    this._block.writeUInt32LE(this._length[0], 56);
    this._block.writeUInt32LE(this._length[1], 60);
    this._update();
    // produce result
    var buffer = $8f6f09199cc1903f$require$Buffer.alloc ? $8f6f09199cc1903f$require$Buffer.alloc(20) : new $8f6f09199cc1903f$require$Buffer(20);
    buffer.writeInt32LE(this._a, 0);
    buffer.writeInt32LE(this._b, 4);
    buffer.writeInt32LE(this._c, 8);
    buffer.writeInt32LE(this._d, 12);
    buffer.writeInt32LE(this._e, 16);
    return buffer;
};
function $8f6f09199cc1903f$var$rotl(x, n) {
    return x << n | x >>> 32 - n;
}
function $8f6f09199cc1903f$var$fn1(a, b, c, d, e, m, k, s) {
    return $8f6f09199cc1903f$var$rotl(a + (b ^ c ^ d) + m + k | 0, s) + e | 0;
}
function $8f6f09199cc1903f$var$fn2(a, b, c, d, e, m, k, s) {
    return $8f6f09199cc1903f$var$rotl(a + (b & c | ~b & d) + m + k | 0, s) + e | 0;
}
function $8f6f09199cc1903f$var$fn3(a, b, c, d, e, m, k, s) {
    return $8f6f09199cc1903f$var$rotl(a + ((b | ~c) ^ d) + m + k | 0, s) + e | 0;
}
function $8f6f09199cc1903f$var$fn4(a, b, c, d, e, m, k, s) {
    return $8f6f09199cc1903f$var$rotl(a + (b & d | c & ~d) + m + k | 0, s) + e | 0;
}
function $8f6f09199cc1903f$var$fn5(a, b, c, d, e, m, k, s) {
    return $8f6f09199cc1903f$var$rotl(a + (b ^ (c | ~d)) + m + k | 0, s) + e | 0;
}
module.exports = $8f6f09199cc1903f$var$RIPEMD160;

});

parcelRequire.register("fkJVr", function(module, exports) {
var $b29c591d3a8bb26b$var$exports = module.exports = function SHA(algorithm) {
    algorithm = algorithm.toLowerCase();
    var Algorithm = $b29c591d3a8bb26b$var$exports[algorithm];
    if (!Algorithm) throw new Error(algorithm + " is not supported (we accept pull requests)");
    return new Algorithm();
};

$b29c591d3a8bb26b$var$exports.sha = (parcelRequire("g2uoB"));

$b29c591d3a8bb26b$var$exports.sha1 = (parcelRequire("lyJtz"));

$b29c591d3a8bb26b$var$exports.sha224 = (parcelRequire("cwjAo"));

$b29c591d3a8bb26b$var$exports.sha256 = (parcelRequire("1o1iT"));

$b29c591d3a8bb26b$var$exports.sha384 = (parcelRequire("kWtXA"));

$b29c591d3a8bb26b$var$exports.sha512 = (parcelRequire("1HQNC"));

});
parcelRequire.register("g2uoB", function(module, exports) {
/*
 * A JavaScript implementation of the Secure Hash Algorithm, SHA-0, as defined
 * in FIPS PUB 180-1
 * This source code is derived from sha1.js of the same repository.
 * The difference between SHA-0 and SHA-1 is just a bitwise rotate left
 * operation was added.
 */ 
var $eSHUL = parcelRequire("eSHUL");

var $6fUHB = parcelRequire("6fUHB");

var $6U9mG = parcelRequire("6U9mG");
var $bad46934fbfe816d$require$Buffer = $6U9mG.Buffer;
var $bad46934fbfe816d$var$K = [
    0x5a827999,
    0x6ed9eba1,
    -1894007588,
    -899497514
];
var $bad46934fbfe816d$var$W = new Array(80);
function $bad46934fbfe816d$var$Sha() {
    this.init();
    this._w = $bad46934fbfe816d$var$W;
    $6fUHB.call(this, 64, 56);
}
$eSHUL($bad46934fbfe816d$var$Sha, $6fUHB);
$bad46934fbfe816d$var$Sha.prototype.init = function() {
    this._a = 0x67452301;
    this._b = 0xefcdab89;
    this._c = 0x98badcfe;
    this._d = 0x10325476;
    this._e = 0xc3d2e1f0;
    return this;
};
function $bad46934fbfe816d$var$rotl5(num) {
    return num << 5 | num >>> 27;
}
function $bad46934fbfe816d$var$rotl30(num) {
    return num << 30 | num >>> 2;
}
function $bad46934fbfe816d$var$ft(s, b, c, d) {
    if (s === 0) return b & c | ~b & d;
    if (s === 2) return b & c | b & d | c & d;
    return b ^ c ^ d;
}
$bad46934fbfe816d$var$Sha.prototype._update = function(M) {
    var W = this._w;
    var a = this._a | 0;
    var b = this._b | 0;
    var c = this._c | 0;
    var d = this._d | 0;
    var e = this._e | 0;
    for(var i = 0; i < 16; ++i)W[i] = M.readInt32BE(i * 4);
    for(; i < 80; ++i)W[i] = W[i - 3] ^ W[i - 8] ^ W[i - 14] ^ W[i - 16];
    for(var j = 0; j < 80; ++j){
        var s = ~~(j / 20);
        var t = $bad46934fbfe816d$var$rotl5(a) + $bad46934fbfe816d$var$ft(s, b, c, d) + e + W[j] + $bad46934fbfe816d$var$K[s] | 0;
        e = d;
        d = c;
        c = $bad46934fbfe816d$var$rotl30(b);
        b = a;
        a = t;
    }
    this._a = a + this._a | 0;
    this._b = b + this._b | 0;
    this._c = c + this._c | 0;
    this._d = d + this._d | 0;
    this._e = e + this._e | 0;
};
$bad46934fbfe816d$var$Sha.prototype._hash = function() {
    var H = $bad46934fbfe816d$require$Buffer.allocUnsafe(20);
    H.writeInt32BE(this._a | 0, 0);
    H.writeInt32BE(this._b | 0, 4);
    H.writeInt32BE(this._c | 0, 8);
    H.writeInt32BE(this._d | 0, 12);
    H.writeInt32BE(this._e | 0, 16);
    return H;
};
module.exports = $bad46934fbfe816d$var$Sha;

});
parcelRequire.register("6fUHB", function(module, exports) {

var $6U9mG = parcelRequire("6U9mG");
var $48e020b2c4716d14$require$Buffer = $6U9mG.Buffer;
// prototype class for hash functions
function $48e020b2c4716d14$var$Hash(blockSize, finalSize) {
    this._block = $48e020b2c4716d14$require$Buffer.alloc(blockSize);
    this._finalSize = finalSize;
    this._blockSize = blockSize;
    this._len = 0;
}
$48e020b2c4716d14$var$Hash.prototype.update = function(data, enc) {
    if (typeof data === "string") {
        enc = enc || "utf8";
        data = $48e020b2c4716d14$require$Buffer.from(data, enc);
    }
    var block = this._block;
    var blockSize = this._blockSize;
    var length = data.length;
    var accum = this._len;
    for(var offset = 0; offset < length;){
        var assigned = accum % blockSize;
        var remainder = Math.min(length - offset, blockSize - assigned);
        for(var i = 0; i < remainder; i++)block[assigned + i] = data[offset + i];
        accum += remainder;
        offset += remainder;
        if (accum % blockSize === 0) this._update(block);
    }
    this._len += length;
    return this;
};
$48e020b2c4716d14$var$Hash.prototype.digest = function(enc) {
    var rem = this._len % this._blockSize;
    this._block[rem] = 0x80;
    // zero (rem + 1) trailing bits, where (rem + 1) is the smallest
    // non-negative solution to the equation (length + 1 + (rem + 1)) === finalSize mod blockSize
    this._block.fill(0, rem + 1);
    if (rem >= this._finalSize) {
        this._update(this._block);
        this._block.fill(0);
    }
    var bits = this._len * 8;
    // uint32
    if (bits <= 0xffffffff) this._block.writeUInt32BE(bits, this._blockSize - 4);
    else {
        var lowBits = (bits & 0xffffffff) >>> 0;
        var highBits = (bits - lowBits) / 0x100000000;
        this._block.writeUInt32BE(highBits, this._blockSize - 8);
        this._block.writeUInt32BE(lowBits, this._blockSize - 4);
    }
    this._update(this._block);
    var hash = this._hash();
    return enc ? hash.toString(enc) : hash;
};
$48e020b2c4716d14$var$Hash.prototype._update = function() {
    throw new Error("_update must be implemented by subclass");
};
module.exports = $48e020b2c4716d14$var$Hash;

});


parcelRequire.register("lyJtz", function(module, exports) {
/*
 * A JavaScript implementation of the Secure Hash Algorithm, SHA-1, as defined
 * in FIPS PUB 180-1
 * Version 2.1a Copyright Paul Johnston 2000 - 2002.
 * Other contributors: Greg Holt, Andrew Kepert, Ydnar, Lostinet
 * Distributed under the BSD License
 * See http://pajhome.org.uk/crypt/md5 for details.
 */ 
var $eSHUL = parcelRequire("eSHUL");

var $6fUHB = parcelRequire("6fUHB");

var $6U9mG = parcelRequire("6U9mG");
var $fb200c8a1442e09f$require$Buffer = $6U9mG.Buffer;
var $fb200c8a1442e09f$var$K = [
    0x5a827999,
    0x6ed9eba1,
    -1894007588,
    -899497514
];
var $fb200c8a1442e09f$var$W = new Array(80);
function $fb200c8a1442e09f$var$Sha1() {
    this.init();
    this._w = $fb200c8a1442e09f$var$W;
    $6fUHB.call(this, 64, 56);
}
$eSHUL($fb200c8a1442e09f$var$Sha1, $6fUHB);
$fb200c8a1442e09f$var$Sha1.prototype.init = function() {
    this._a = 0x67452301;
    this._b = 0xefcdab89;
    this._c = 0x98badcfe;
    this._d = 0x10325476;
    this._e = 0xc3d2e1f0;
    return this;
};
function $fb200c8a1442e09f$var$rotl1(num) {
    return num << 1 | num >>> 31;
}
function $fb200c8a1442e09f$var$rotl5(num) {
    return num << 5 | num >>> 27;
}
function $fb200c8a1442e09f$var$rotl30(num) {
    return num << 30 | num >>> 2;
}
function $fb200c8a1442e09f$var$ft(s, b, c, d) {
    if (s === 0) return b & c | ~b & d;
    if (s === 2) return b & c | b & d | c & d;
    return b ^ c ^ d;
}
$fb200c8a1442e09f$var$Sha1.prototype._update = function(M) {
    var W = this._w;
    var a = this._a | 0;
    var b = this._b | 0;
    var c = this._c | 0;
    var d = this._d | 0;
    var e = this._e | 0;
    for(var i = 0; i < 16; ++i)W[i] = M.readInt32BE(i * 4);
    for(; i < 80; ++i)W[i] = $fb200c8a1442e09f$var$rotl1(W[i - 3] ^ W[i - 8] ^ W[i - 14] ^ W[i - 16]);
    for(var j = 0; j < 80; ++j){
        var s = ~~(j / 20);
        var t = $fb200c8a1442e09f$var$rotl5(a) + $fb200c8a1442e09f$var$ft(s, b, c, d) + e + W[j] + $fb200c8a1442e09f$var$K[s] | 0;
        e = d;
        d = c;
        c = $fb200c8a1442e09f$var$rotl30(b);
        b = a;
        a = t;
    }
    this._a = a + this._a | 0;
    this._b = b + this._b | 0;
    this._c = c + this._c | 0;
    this._d = d + this._d | 0;
    this._e = e + this._e | 0;
};
$fb200c8a1442e09f$var$Sha1.prototype._hash = function() {
    var H = $fb200c8a1442e09f$require$Buffer.allocUnsafe(20);
    H.writeInt32BE(this._a | 0, 0);
    H.writeInt32BE(this._b | 0, 4);
    H.writeInt32BE(this._c | 0, 8);
    H.writeInt32BE(this._d | 0, 12);
    H.writeInt32BE(this._e | 0, 16);
    return H;
};
module.exports = $fb200c8a1442e09f$var$Sha1;

});

parcelRequire.register("cwjAo", function(module, exports) {
/**
 * A JavaScript implementation of the Secure Hash Algorithm, SHA-256, as defined
 * in FIPS 180-2
 * Version 2.2-beta Copyright Angel Marin, Paul Johnston 2000 - 2009.
 * Other contributors: Greg Holt, Andrew Kepert, Ydnar, Lostinet
 *
 */ 
var $eSHUL = parcelRequire("eSHUL");

var $1o1iT = parcelRequire("1o1iT");

var $6fUHB = parcelRequire("6fUHB");

var $6U9mG = parcelRequire("6U9mG");
var $91d7aa8b17a16320$require$Buffer = $6U9mG.Buffer;
var $91d7aa8b17a16320$var$W = new Array(64);
function $91d7aa8b17a16320$var$Sha224() {
    this.init();
    this._w = $91d7aa8b17a16320$var$W // new Array(64)
    ;
    $6fUHB.call(this, 64, 56);
}
$eSHUL($91d7aa8b17a16320$var$Sha224, $1o1iT);
$91d7aa8b17a16320$var$Sha224.prototype.init = function() {
    this._a = 0xc1059ed8;
    this._b = 0x367cd507;
    this._c = 0x3070dd17;
    this._d = 0xf70e5939;
    this._e = 0xffc00b31;
    this._f = 0x68581511;
    this._g = 0x64f98fa7;
    this._h = 0xbefa4fa4;
    return this;
};
$91d7aa8b17a16320$var$Sha224.prototype._hash = function() {
    var H = $91d7aa8b17a16320$require$Buffer.allocUnsafe(28);
    H.writeInt32BE(this._a, 0);
    H.writeInt32BE(this._b, 4);
    H.writeInt32BE(this._c, 8);
    H.writeInt32BE(this._d, 12);
    H.writeInt32BE(this._e, 16);
    H.writeInt32BE(this._f, 20);
    H.writeInt32BE(this._g, 24);
    return H;
};
module.exports = $91d7aa8b17a16320$var$Sha224;

});
parcelRequire.register("1o1iT", function(module, exports) {
/**
 * A JavaScript implementation of the Secure Hash Algorithm, SHA-256, as defined
 * in FIPS 180-2
 * Version 2.2-beta Copyright Angel Marin, Paul Johnston 2000 - 2009.
 * Other contributors: Greg Holt, Andrew Kepert, Ydnar, Lostinet
 *
 */ 
var $eSHUL = parcelRequire("eSHUL");

var $6fUHB = parcelRequire("6fUHB");

var $6U9mG = parcelRequire("6U9mG");
var $10290b3c9978cdf8$require$Buffer = $6U9mG.Buffer;
var $10290b3c9978cdf8$var$K = [
    0x428A2F98,
    0x71374491,
    0xB5C0FBCF,
    0xE9B5DBA5,
    0x3956C25B,
    0x59F111F1,
    0x923F82A4,
    0xAB1C5ED5,
    0xD807AA98,
    0x12835B01,
    0x243185BE,
    0x550C7DC3,
    0x72BE5D74,
    0x80DEB1FE,
    0x9BDC06A7,
    0xC19BF174,
    0xE49B69C1,
    0xEFBE4786,
    0x0FC19DC6,
    0x240CA1CC,
    0x2DE92C6F,
    0x4A7484AA,
    0x5CB0A9DC,
    0x76F988DA,
    0x983E5152,
    0xA831C66D,
    0xB00327C8,
    0xBF597FC7,
    0xC6E00BF3,
    0xD5A79147,
    0x06CA6351,
    0x14292967,
    0x27B70A85,
    0x2E1B2138,
    0x4D2C6DFC,
    0x53380D13,
    0x650A7354,
    0x766A0ABB,
    0x81C2C92E,
    0x92722C85,
    0xA2BFE8A1,
    0xA81A664B,
    0xC24B8B70,
    0xC76C51A3,
    0xD192E819,
    0xD6990624,
    0xF40E3585,
    0x106AA070,
    0x19A4C116,
    0x1E376C08,
    0x2748774C,
    0x34B0BCB5,
    0x391C0CB3,
    0x4ED8AA4A,
    0x5B9CCA4F,
    0x682E6FF3,
    0x748F82EE,
    0x78A5636F,
    0x84C87814,
    0x8CC70208,
    0x90BEFFFA,
    0xA4506CEB,
    0xBEF9A3F7,
    0xC67178F2
];
var $10290b3c9978cdf8$var$W = new Array(64);
function $10290b3c9978cdf8$var$Sha256() {
    this.init();
    this._w = $10290b3c9978cdf8$var$W // new Array(64)
    ;
    $6fUHB.call(this, 64, 56);
}
$eSHUL($10290b3c9978cdf8$var$Sha256, $6fUHB);
$10290b3c9978cdf8$var$Sha256.prototype.init = function() {
    this._a = 0x6a09e667;
    this._b = 0xbb67ae85;
    this._c = 0x3c6ef372;
    this._d = 0xa54ff53a;
    this._e = 0x510e527f;
    this._f = 0x9b05688c;
    this._g = 0x1f83d9ab;
    this._h = 0x5be0cd19;
    return this;
};
function $10290b3c9978cdf8$var$ch(x, y, z) {
    return z ^ x & (y ^ z);
}
function $10290b3c9978cdf8$var$maj(x, y, z) {
    return x & y | z & (x | y);
}
function $10290b3c9978cdf8$var$sigma0(x) {
    return (x >>> 2 | x << 30) ^ (x >>> 13 | x << 19) ^ (x >>> 22 | x << 10);
}
function $10290b3c9978cdf8$var$sigma1(x) {
    return (x >>> 6 | x << 26) ^ (x >>> 11 | x << 21) ^ (x >>> 25 | x << 7);
}
function $10290b3c9978cdf8$var$gamma0(x) {
    return (x >>> 7 | x << 25) ^ (x >>> 18 | x << 14) ^ x >>> 3;
}
function $10290b3c9978cdf8$var$gamma1(x) {
    return (x >>> 17 | x << 15) ^ (x >>> 19 | x << 13) ^ x >>> 10;
}
$10290b3c9978cdf8$var$Sha256.prototype._update = function(M) {
    var W = this._w;
    var a = this._a | 0;
    var b = this._b | 0;
    var c = this._c | 0;
    var d = this._d | 0;
    var e = this._e | 0;
    var f = this._f | 0;
    var g = this._g | 0;
    var h = this._h | 0;
    for(var i = 0; i < 16; ++i)W[i] = M.readInt32BE(i * 4);
    for(; i < 64; ++i)W[i] = $10290b3c9978cdf8$var$gamma1(W[i - 2]) + W[i - 7] + $10290b3c9978cdf8$var$gamma0(W[i - 15]) + W[i - 16] | 0;
    for(var j = 0; j < 64; ++j){
        var T1 = h + $10290b3c9978cdf8$var$sigma1(e) + $10290b3c9978cdf8$var$ch(e, f, g) + $10290b3c9978cdf8$var$K[j] + W[j] | 0;
        var T2 = $10290b3c9978cdf8$var$sigma0(a) + $10290b3c9978cdf8$var$maj(a, b, c) | 0;
        h = g;
        g = f;
        f = e;
        e = d + T1 | 0;
        d = c;
        c = b;
        b = a;
        a = T1 + T2 | 0;
    }
    this._a = a + this._a | 0;
    this._b = b + this._b | 0;
    this._c = c + this._c | 0;
    this._d = d + this._d | 0;
    this._e = e + this._e | 0;
    this._f = f + this._f | 0;
    this._g = g + this._g | 0;
    this._h = h + this._h | 0;
};
$10290b3c9978cdf8$var$Sha256.prototype._hash = function() {
    var H = $10290b3c9978cdf8$require$Buffer.allocUnsafe(32);
    H.writeInt32BE(this._a, 0);
    H.writeInt32BE(this._b, 4);
    H.writeInt32BE(this._c, 8);
    H.writeInt32BE(this._d, 12);
    H.writeInt32BE(this._e, 16);
    H.writeInt32BE(this._f, 20);
    H.writeInt32BE(this._g, 24);
    H.writeInt32BE(this._h, 28);
    return H;
};
module.exports = $10290b3c9978cdf8$var$Sha256;

});


parcelRequire.register("kWtXA", function(module, exports) {

var $eSHUL = parcelRequire("eSHUL");

var $1HQNC = parcelRequire("1HQNC");

var $6fUHB = parcelRequire("6fUHB");

var $6U9mG = parcelRequire("6U9mG");
var $f3f076e48793fba5$require$Buffer = $6U9mG.Buffer;
var $f3f076e48793fba5$var$W = new Array(160);
function $f3f076e48793fba5$var$Sha384() {
    this.init();
    this._w = $f3f076e48793fba5$var$W;
    $6fUHB.call(this, 128, 112);
}
$eSHUL($f3f076e48793fba5$var$Sha384, $1HQNC);
$f3f076e48793fba5$var$Sha384.prototype.init = function() {
    this._ah = 0xcbbb9d5d;
    this._bh = 0x629a292a;
    this._ch = 0x9159015a;
    this._dh = 0x152fecd8;
    this._eh = 0x67332667;
    this._fh = 0x8eb44a87;
    this._gh = 0xdb0c2e0d;
    this._hh = 0x47b5481d;
    this._al = 0xc1059ed8;
    this._bl = 0x367cd507;
    this._cl = 0x3070dd17;
    this._dl = 0xf70e5939;
    this._el = 0xffc00b31;
    this._fl = 0x68581511;
    this._gl = 0x64f98fa7;
    this._hl = 0xbefa4fa4;
    return this;
};
$f3f076e48793fba5$var$Sha384.prototype._hash = function() {
    var H = $f3f076e48793fba5$require$Buffer.allocUnsafe(48);
    function writeInt64BE(h, l, offset) {
        H.writeInt32BE(h, offset);
        H.writeInt32BE(l, offset + 4);
    }
    writeInt64BE(this._ah, this._al, 0);
    writeInt64BE(this._bh, this._bl, 8);
    writeInt64BE(this._ch, this._cl, 16);
    writeInt64BE(this._dh, this._dl, 24);
    writeInt64BE(this._eh, this._el, 32);
    writeInt64BE(this._fh, this._fl, 40);
    return H;
};
module.exports = $f3f076e48793fba5$var$Sha384;

});
parcelRequire.register("1HQNC", function(module, exports) {

var $eSHUL = parcelRequire("eSHUL");

var $6fUHB = parcelRequire("6fUHB");

var $6U9mG = parcelRequire("6U9mG");
var $13e2c371a41c8789$require$Buffer = $6U9mG.Buffer;
var $13e2c371a41c8789$var$K = [
    0x428a2f98,
    0xd728ae22,
    0x71374491,
    0x23ef65cd,
    0xb5c0fbcf,
    0xec4d3b2f,
    0xe9b5dba5,
    0x8189dbbc,
    0x3956c25b,
    0xf348b538,
    0x59f111f1,
    0xb605d019,
    0x923f82a4,
    0xaf194f9b,
    0xab1c5ed5,
    0xda6d8118,
    0xd807aa98,
    0xa3030242,
    0x12835b01,
    0x45706fbe,
    0x243185be,
    0x4ee4b28c,
    0x550c7dc3,
    0xd5ffb4e2,
    0x72be5d74,
    0xf27b896f,
    0x80deb1fe,
    0x3b1696b1,
    0x9bdc06a7,
    0x25c71235,
    0xc19bf174,
    0xcf692694,
    0xe49b69c1,
    0x9ef14ad2,
    0xefbe4786,
    0x384f25e3,
    0x0fc19dc6,
    0x8b8cd5b5,
    0x240ca1cc,
    0x77ac9c65,
    0x2de92c6f,
    0x592b0275,
    0x4a7484aa,
    0x6ea6e483,
    0x5cb0a9dc,
    0xbd41fbd4,
    0x76f988da,
    0x831153b5,
    0x983e5152,
    0xee66dfab,
    0xa831c66d,
    0x2db43210,
    0xb00327c8,
    0x98fb213f,
    0xbf597fc7,
    0xbeef0ee4,
    0xc6e00bf3,
    0x3da88fc2,
    0xd5a79147,
    0x930aa725,
    0x06ca6351,
    0xe003826f,
    0x14292967,
    0x0a0e6e70,
    0x27b70a85,
    0x46d22ffc,
    0x2e1b2138,
    0x5c26c926,
    0x4d2c6dfc,
    0x5ac42aed,
    0x53380d13,
    0x9d95b3df,
    0x650a7354,
    0x8baf63de,
    0x766a0abb,
    0x3c77b2a8,
    0x81c2c92e,
    0x47edaee6,
    0x92722c85,
    0x1482353b,
    0xa2bfe8a1,
    0x4cf10364,
    0xa81a664b,
    0xbc423001,
    0xc24b8b70,
    0xd0f89791,
    0xc76c51a3,
    0x0654be30,
    0xd192e819,
    0xd6ef5218,
    0xd6990624,
    0x5565a910,
    0xf40e3585,
    0x5771202a,
    0x106aa070,
    0x32bbd1b8,
    0x19a4c116,
    0xb8d2d0c8,
    0x1e376c08,
    0x5141ab53,
    0x2748774c,
    0xdf8eeb99,
    0x34b0bcb5,
    0xe19b48a8,
    0x391c0cb3,
    0xc5c95a63,
    0x4ed8aa4a,
    0xe3418acb,
    0x5b9cca4f,
    0x7763e373,
    0x682e6ff3,
    0xd6b2b8a3,
    0x748f82ee,
    0x5defb2fc,
    0x78a5636f,
    0x43172f60,
    0x84c87814,
    0xa1f0ab72,
    0x8cc70208,
    0x1a6439ec,
    0x90befffa,
    0x23631e28,
    0xa4506ceb,
    0xde82bde9,
    0xbef9a3f7,
    0xb2c67915,
    0xc67178f2,
    0xe372532b,
    0xca273ece,
    0xea26619c,
    0xd186b8c7,
    0x21c0c207,
    0xeada7dd6,
    0xcde0eb1e,
    0xf57d4f7f,
    0xee6ed178,
    0x06f067aa,
    0x72176fba,
    0x0a637dc5,
    0xa2c898a6,
    0x113f9804,
    0xbef90dae,
    0x1b710b35,
    0x131c471b,
    0x28db77f5,
    0x23047d84,
    0x32caab7b,
    0x40c72493,
    0x3c9ebe0a,
    0x15c9bebc,
    0x431d67c4,
    0x9c100d4c,
    0x4cc5d4be,
    0xcb3e42b6,
    0x597f299c,
    0xfc657e2a,
    0x5fcb6fab,
    0x3ad6faec,
    0x6c44198c,
    0x4a475817
];
var $13e2c371a41c8789$var$W = new Array(160);
function $13e2c371a41c8789$var$Sha512() {
    this.init();
    this._w = $13e2c371a41c8789$var$W;
    $6fUHB.call(this, 128, 112);
}
$eSHUL($13e2c371a41c8789$var$Sha512, $6fUHB);
$13e2c371a41c8789$var$Sha512.prototype.init = function() {
    this._ah = 0x6a09e667;
    this._bh = 0xbb67ae85;
    this._ch = 0x3c6ef372;
    this._dh = 0xa54ff53a;
    this._eh = 0x510e527f;
    this._fh = 0x9b05688c;
    this._gh = 0x1f83d9ab;
    this._hh = 0x5be0cd19;
    this._al = 0xf3bcc908;
    this._bl = 0x84caa73b;
    this._cl = 0xfe94f82b;
    this._dl = 0x5f1d36f1;
    this._el = 0xade682d1;
    this._fl = 0x2b3e6c1f;
    this._gl = 0xfb41bd6b;
    this._hl = 0x137e2179;
    return this;
};
function $13e2c371a41c8789$var$Ch(x, y, z) {
    return z ^ x & (y ^ z);
}
function $13e2c371a41c8789$var$maj(x, y, z) {
    return x & y | z & (x | y);
}
function $13e2c371a41c8789$var$sigma0(x, xl) {
    return (x >>> 28 | xl << 4) ^ (xl >>> 2 | x << 30) ^ (xl >>> 7 | x << 25);
}
function $13e2c371a41c8789$var$sigma1(x, xl) {
    return (x >>> 14 | xl << 18) ^ (x >>> 18 | xl << 14) ^ (xl >>> 9 | x << 23);
}
function $13e2c371a41c8789$var$Gamma0(x, xl) {
    return (x >>> 1 | xl << 31) ^ (x >>> 8 | xl << 24) ^ x >>> 7;
}
function $13e2c371a41c8789$var$Gamma0l(x, xl) {
    return (x >>> 1 | xl << 31) ^ (x >>> 8 | xl << 24) ^ (x >>> 7 | xl << 25);
}
function $13e2c371a41c8789$var$Gamma1(x, xl) {
    return (x >>> 19 | xl << 13) ^ (xl >>> 29 | x << 3) ^ x >>> 6;
}
function $13e2c371a41c8789$var$Gamma1l(x, xl) {
    return (x >>> 19 | xl << 13) ^ (xl >>> 29 | x << 3) ^ (x >>> 6 | xl << 26);
}
function $13e2c371a41c8789$var$getCarry(a, b) {
    return a >>> 0 < b >>> 0 ? 1 : 0;
}
$13e2c371a41c8789$var$Sha512.prototype._update = function(M) {
    var W = this._w;
    var ah = this._ah | 0;
    var bh = this._bh | 0;
    var ch = this._ch | 0;
    var dh = this._dh | 0;
    var eh = this._eh | 0;
    var fh = this._fh | 0;
    var gh = this._gh | 0;
    var hh = this._hh | 0;
    var al = this._al | 0;
    var bl = this._bl | 0;
    var cl = this._cl | 0;
    var dl = this._dl | 0;
    var el = this._el | 0;
    var fl = this._fl | 0;
    var gl = this._gl | 0;
    var hl = this._hl | 0;
    for(var i = 0; i < 32; i += 2){
        W[i] = M.readInt32BE(i * 4);
        W[i + 1] = M.readInt32BE(i * 4 + 4);
    }
    for(; i < 160; i += 2){
        var xh = W[i - 30];
        var xl = W[i - 30 + 1];
        var gamma0 = $13e2c371a41c8789$var$Gamma0(xh, xl);
        var gamma0l = $13e2c371a41c8789$var$Gamma0l(xl, xh);
        xh = W[i - 4];
        xl = W[i - 4 + 1];
        var gamma1 = $13e2c371a41c8789$var$Gamma1(xh, xl);
        var gamma1l = $13e2c371a41c8789$var$Gamma1l(xl, xh);
        // W[i] = gamma0 + W[i - 7] + gamma1 + W[i - 16]
        var Wi7h = W[i - 14];
        var Wi7l = W[i - 14 + 1];
        var Wi16h = W[i - 32];
        var Wi16l = W[i - 32 + 1];
        var Wil = gamma0l + Wi7l | 0;
        var Wih = gamma0 + Wi7h + $13e2c371a41c8789$var$getCarry(Wil, gamma0l) | 0;
        Wil = Wil + gamma1l | 0;
        Wih = Wih + gamma1 + $13e2c371a41c8789$var$getCarry(Wil, gamma1l) | 0;
        Wil = Wil + Wi16l | 0;
        Wih = Wih + Wi16h + $13e2c371a41c8789$var$getCarry(Wil, Wi16l) | 0;
        W[i] = Wih;
        W[i + 1] = Wil;
    }
    for(var j = 0; j < 160; j += 2){
        Wih = W[j];
        Wil = W[j + 1];
        var majh = $13e2c371a41c8789$var$maj(ah, bh, ch);
        var majl = $13e2c371a41c8789$var$maj(al, bl, cl);
        var sigma0h = $13e2c371a41c8789$var$sigma0(ah, al);
        var sigma0l = $13e2c371a41c8789$var$sigma0(al, ah);
        var sigma1h = $13e2c371a41c8789$var$sigma1(eh, el);
        var sigma1l = $13e2c371a41c8789$var$sigma1(el, eh);
        // t1 = h + sigma1 + ch + K[j] + W[j]
        var Kih = $13e2c371a41c8789$var$K[j];
        var Kil = $13e2c371a41c8789$var$K[j + 1];
        var chh = $13e2c371a41c8789$var$Ch(eh, fh, gh);
        var chl = $13e2c371a41c8789$var$Ch(el, fl, gl);
        var t1l = hl + sigma1l | 0;
        var t1h = hh + sigma1h + $13e2c371a41c8789$var$getCarry(t1l, hl) | 0;
        t1l = t1l + chl | 0;
        t1h = t1h + chh + $13e2c371a41c8789$var$getCarry(t1l, chl) | 0;
        t1l = t1l + Kil | 0;
        t1h = t1h + Kih + $13e2c371a41c8789$var$getCarry(t1l, Kil) | 0;
        t1l = t1l + Wil | 0;
        t1h = t1h + Wih + $13e2c371a41c8789$var$getCarry(t1l, Wil) | 0;
        // t2 = sigma0 + maj
        var t2l = sigma0l + majl | 0;
        var t2h = sigma0h + majh + $13e2c371a41c8789$var$getCarry(t2l, sigma0l) | 0;
        hh = gh;
        hl = gl;
        gh = fh;
        gl = fl;
        fh = eh;
        fl = el;
        el = dl + t1l | 0;
        eh = dh + t1h + $13e2c371a41c8789$var$getCarry(el, dl) | 0;
        dh = ch;
        dl = cl;
        ch = bh;
        cl = bl;
        bh = ah;
        bl = al;
        al = t1l + t2l | 0;
        ah = t1h + t2h + $13e2c371a41c8789$var$getCarry(al, t1l) | 0;
    }
    this._al = this._al + al | 0;
    this._bl = this._bl + bl | 0;
    this._cl = this._cl + cl | 0;
    this._dl = this._dl + dl | 0;
    this._el = this._el + el | 0;
    this._fl = this._fl + fl | 0;
    this._gl = this._gl + gl | 0;
    this._hl = this._hl + hl | 0;
    this._ah = this._ah + ah + $13e2c371a41c8789$var$getCarry(this._al, al) | 0;
    this._bh = this._bh + bh + $13e2c371a41c8789$var$getCarry(this._bl, bl) | 0;
    this._ch = this._ch + ch + $13e2c371a41c8789$var$getCarry(this._cl, cl) | 0;
    this._dh = this._dh + dh + $13e2c371a41c8789$var$getCarry(this._dl, dl) | 0;
    this._eh = this._eh + eh + $13e2c371a41c8789$var$getCarry(this._el, el) | 0;
    this._fh = this._fh + fh + $13e2c371a41c8789$var$getCarry(this._fl, fl) | 0;
    this._gh = this._gh + gh + $13e2c371a41c8789$var$getCarry(this._gl, gl) | 0;
    this._hh = this._hh + hh + $13e2c371a41c8789$var$getCarry(this._hl, hl) | 0;
};
$13e2c371a41c8789$var$Sha512.prototype._hash = function() {
    var H = $13e2c371a41c8789$require$Buffer.allocUnsafe(64);
    function writeInt64BE(h, l, offset) {
        H.writeInt32BE(h, offset);
        H.writeInt32BE(l, offset + 4);
    }
    writeInt64BE(this._ah, this._al, 0);
    writeInt64BE(this._bh, this._bl, 8);
    writeInt64BE(this._ch, this._cl, 16);
    writeInt64BE(this._dh, this._dl, 24);
    writeInt64BE(this._eh, this._el, 32);
    writeInt64BE(this._fh, this._fl, 40);
    writeInt64BE(this._gh, this._gl, 48);
    writeInt64BE(this._hh, this._hl, 56);
    return H;
};
module.exports = $13e2c371a41c8789$var$Sha512;

});



parcelRequire.register("fpHcA", function(module, exports) {

var $6U9mG = parcelRequire("6U9mG");
var $b38ab3d1a7f86ec9$require$Buffer = $6U9mG.Buffer;

var $bks2w = parcelRequire("bks2w");
var $b38ab3d1a7f86ec9$require$Transform = $bks2w.Transform;

var $lEpDX = parcelRequire("lEpDX");
var $b38ab3d1a7f86ec9$require$StringDecoder = $lEpDX.StringDecoder;

var $eSHUL = parcelRequire("eSHUL");
function $b38ab3d1a7f86ec9$var$CipherBase(hashMode) {
    $b38ab3d1a7f86ec9$require$Transform.call(this);
    this.hashMode = typeof hashMode === "string";
    if (this.hashMode) this[hashMode] = this._finalOrDigest;
    else this.final = this._finalOrDigest;
    if (this._final) {
        this.__final = this._final;
        this._final = null;
    }
    this._decoder = null;
    this._encoding = null;
}
$eSHUL($b38ab3d1a7f86ec9$var$CipherBase, $b38ab3d1a7f86ec9$require$Transform);
$b38ab3d1a7f86ec9$var$CipherBase.prototype.update = function(data, inputEnc, outputEnc) {
    if (typeof data === "string") data = $b38ab3d1a7f86ec9$require$Buffer.from(data, inputEnc);
    var outData = this._update(data);
    if (this.hashMode) return this;
    if (outputEnc) outData = this._toString(outData, outputEnc);
    return outData;
};
$b38ab3d1a7f86ec9$var$CipherBase.prototype.setAutoPadding = function() {};
$b38ab3d1a7f86ec9$var$CipherBase.prototype.getAuthTag = function() {
    throw new Error("trying to get auth tag in unsupported state");
};
$b38ab3d1a7f86ec9$var$CipherBase.prototype.setAuthTag = function() {
    throw new Error("trying to set auth tag in unsupported state");
};
$b38ab3d1a7f86ec9$var$CipherBase.prototype.setAAD = function() {
    throw new Error("trying to set aad in unsupported state");
};
$b38ab3d1a7f86ec9$var$CipherBase.prototype._transform = function(data, _, next) {
    var err;
    try {
        if (this.hashMode) this._update(data);
        else this.push(this._update(data));
    } catch (e) {
        err = e;
    } finally{
        next(err);
    }
};
$b38ab3d1a7f86ec9$var$CipherBase.prototype._flush = function(done) {
    var err;
    try {
        this.push(this.__final());
    } catch (e) {
        err = e;
    }
    done(err);
};
$b38ab3d1a7f86ec9$var$CipherBase.prototype._finalOrDigest = function(outputEnc) {
    var outData = this.__final() || $b38ab3d1a7f86ec9$require$Buffer.alloc(0);
    if (outputEnc) outData = this._toString(outData, outputEnc, true);
    return outData;
};
$b38ab3d1a7f86ec9$var$CipherBase.prototype._toString = function(value, enc, fin) {
    if (!this._decoder) {
        this._decoder = new $b38ab3d1a7f86ec9$require$StringDecoder(enc);
        this._encoding = enc;
    }
    if (this._encoding !== enc) throw new Error("can't switch encodings");
    var out = this._decoder.write(value);
    if (fin) out += this._decoder.end();
    return out;
};
module.exports = $b38ab3d1a7f86ec9$var$CipherBase;

});
parcelRequire.register("bks2w", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
module.exports = $83f7500f17fcc367$var$Stream;

var $jMc9N = parcelRequire("jMc9N");
var $83f7500f17fcc367$require$EE = $jMc9N.EventEmitter;

var $eSHUL = parcelRequire("eSHUL");
$eSHUL($83f7500f17fcc367$var$Stream, $83f7500f17fcc367$require$EE);

$83f7500f17fcc367$var$Stream.Readable = (parcelRequire("cEnbP"));

$83f7500f17fcc367$var$Stream.Writable = (parcelRequire("cuAoD"));

$83f7500f17fcc367$var$Stream.Duplex = (parcelRequire("2Hlr9"));

$83f7500f17fcc367$var$Stream.Transform = (parcelRequire("l7DDn"));

$83f7500f17fcc367$var$Stream.PassThrough = (parcelRequire("6VFzs"));

$83f7500f17fcc367$var$Stream.finished = (parcelRequire("gr8mb"));

$83f7500f17fcc367$var$Stream.pipeline = (parcelRequire("e8JAK"));
// Backwards-compat with node 0.4.x
$83f7500f17fcc367$var$Stream.Stream = $83f7500f17fcc367$var$Stream;
// old-style streams.  Note that the pipe method (the only relevant
// part of this class) is overridden in the Readable class.
function $83f7500f17fcc367$var$Stream() {
    $83f7500f17fcc367$require$EE.call(this);
}
$83f7500f17fcc367$var$Stream.prototype.pipe = function(dest, options) {
    var source = this;
    function ondata(chunk) {
        if (dest.writable) {
            if (false === dest.write(chunk) && source.pause) source.pause();
        }
    }
    source.on("data", ondata);
    function ondrain() {
        if (source.readable && source.resume) source.resume();
    }
    dest.on("drain", ondrain);
    // If the 'end' option is not supplied, dest.end() will be called when
    // source gets the 'end' or 'close' events.  Only dest.end() once.
    if (!dest._isStdio && (!options || options.end !== false)) {
        source.on("end", onend);
        source.on("close", onclose);
    }
    var didOnEnd = false;
    function onend() {
        if (didOnEnd) return;
        didOnEnd = true;
        dest.end();
    }
    function onclose() {
        if (didOnEnd) return;
        didOnEnd = true;
        if (typeof dest.destroy === "function") dest.destroy();
    }
    // don't leave dangling pipes when there are errors.
    function onerror(er) {
        cleanup();
        if ($83f7500f17fcc367$require$EE.listenerCount(this, "error") === 0) throw er; // Unhandled stream error in pipe.
    }
    source.on("error", onerror);
    dest.on("error", onerror);
    // remove all the event listeners that were added.
    function cleanup() {
        source.removeListener("data", ondata);
        dest.removeListener("drain", ondrain);
        source.removeListener("end", onend);
        source.removeListener("close", onclose);
        source.removeListener("error", onerror);
        dest.removeListener("error", onerror);
        source.removeListener("end", cleanup);
        source.removeListener("close", cleanup);
        dest.removeListener("close", cleanup);
    }
    source.on("end", cleanup);
    source.on("close", cleanup);
    dest.on("close", cleanup);
    dest.emit("pipe", source);
    // Allow for unix-like usage: A.pipe(B).pipe(C)
    return dest;
};

});



parcelRequire.register("cUvgf", function(module, exports) {
"use strict";

var $eSHUL = parcelRequire("eSHUL");

var $bRBTe = parcelRequire("bRBTe");

var $fpHcA = parcelRequire("fpHcA");

var $6U9mG = parcelRequire("6U9mG");
var $9662f6cbdeac7c49$require$Buffer = $6U9mG.Buffer;

var $5GY4Y = parcelRequire("5GY4Y");

var $cjuEr = parcelRequire("cjuEr");

var $fkJVr = parcelRequire("fkJVr");
var $9662f6cbdeac7c49$var$ZEROS = $9662f6cbdeac7c49$require$Buffer.alloc(128);
function $9662f6cbdeac7c49$var$Hmac(alg, key) {
    $fpHcA.call(this, "digest");
    if (typeof key === "string") key = $9662f6cbdeac7c49$require$Buffer.from(key);
    var blocksize = alg === "sha512" || alg === "sha384" ? 128 : 64;
    this._alg = alg;
    this._key = key;
    if (key.length > blocksize) {
        var hash = alg === "rmd160" ? new $cjuEr() : $fkJVr(alg);
        key = hash.update(key).digest();
    } else if (key.length < blocksize) key = $9662f6cbdeac7c49$require$Buffer.concat([
        key,
        $9662f6cbdeac7c49$var$ZEROS
    ], blocksize);
    var ipad = this._ipad = $9662f6cbdeac7c49$require$Buffer.allocUnsafe(blocksize);
    var opad = this._opad = $9662f6cbdeac7c49$require$Buffer.allocUnsafe(blocksize);
    for(var i = 0; i < blocksize; i++){
        ipad[i] = key[i] ^ 0x36;
        opad[i] = key[i] ^ 0x5C;
    }
    this._hash = alg === "rmd160" ? new $cjuEr() : $fkJVr(alg);
    this._hash.update(ipad);
}
$eSHUL($9662f6cbdeac7c49$var$Hmac, $fpHcA);
$9662f6cbdeac7c49$var$Hmac.prototype._update = function(data) {
    this._hash.update(data);
};
$9662f6cbdeac7c49$var$Hmac.prototype._final = function() {
    var h = this._hash.digest();
    var hash = this._alg === "rmd160" ? new $cjuEr() : $fkJVr(this._alg);
    return hash.update(this._opad).update(h).digest();
};
module.exports = function createHmac(alg, key) {
    alg = alg.toLowerCase();
    if (alg === "rmd160" || alg === "ripemd160") return new $9662f6cbdeac7c49$var$Hmac("rmd160", key);
    if (alg === "md5") return new $bRBTe($5GY4Y, key);
    return new $9662f6cbdeac7c49$var$Hmac(alg, key);
};

});
parcelRequire.register("bRBTe", function(module, exports) {
"use strict";

var $eSHUL = parcelRequire("eSHUL");

var $6U9mG = parcelRequire("6U9mG");
var $8a32091105b403f5$require$Buffer = $6U9mG.Buffer;

var $fpHcA = parcelRequire("fpHcA");
var $8a32091105b403f5$var$ZEROS = $8a32091105b403f5$require$Buffer.alloc(128);
var $8a32091105b403f5$var$blocksize = 64;
function $8a32091105b403f5$var$Hmac(alg, key) {
    $fpHcA.call(this, "digest");
    if (typeof key === "string") key = $8a32091105b403f5$require$Buffer.from(key);
    this._alg = alg;
    this._key = key;
    if (key.length > $8a32091105b403f5$var$blocksize) key = alg(key);
    else if (key.length < $8a32091105b403f5$var$blocksize) key = $8a32091105b403f5$require$Buffer.concat([
        key,
        $8a32091105b403f5$var$ZEROS
    ], $8a32091105b403f5$var$blocksize);
    var ipad = this._ipad = $8a32091105b403f5$require$Buffer.allocUnsafe($8a32091105b403f5$var$blocksize);
    var opad = this._opad = $8a32091105b403f5$require$Buffer.allocUnsafe($8a32091105b403f5$var$blocksize);
    for(var i = 0; i < $8a32091105b403f5$var$blocksize; i++){
        ipad[i] = key[i] ^ 0x36;
        opad[i] = key[i] ^ 0x5C;
    }
    this._hash = [
        ipad
    ];
}
$eSHUL($8a32091105b403f5$var$Hmac, $fpHcA);
$8a32091105b403f5$var$Hmac.prototype._update = function(data) {
    this._hash.push(data);
};
$8a32091105b403f5$var$Hmac.prototype._final = function() {
    var h = this._alg($8a32091105b403f5$require$Buffer.concat(this._hash));
    return this._alg($8a32091105b403f5$require$Buffer.concat([
        this._opad,
        h
    ]));
};
module.exports = $8a32091105b403f5$var$Hmac;

});

parcelRequire.register("5GY4Y", function(module, exports) {

var $cvCaQ = parcelRequire("cvCaQ");
module.exports = function(buffer) {
    return new $cvCaQ().update(buffer).digest();
};

});


parcelRequire.register("fAh7A", function(module, exports) {

module.exports = (parcelRequire("jdVex"));

});
parcelRequire.register("jdVex", function(module, exports) {
module.exports = JSON.parse('{"sha224WithRSAEncryption":{"sign":"rsa","hash":"sha224","id":"302d300d06096086480165030402040500041c"},"RSA-SHA224":{"sign":"ecdsa/rsa","hash":"sha224","id":"302d300d06096086480165030402040500041c"},"sha256WithRSAEncryption":{"sign":"rsa","hash":"sha256","id":"3031300d060960864801650304020105000420"},"RSA-SHA256":{"sign":"ecdsa/rsa","hash":"sha256","id":"3031300d060960864801650304020105000420"},"sha384WithRSAEncryption":{"sign":"rsa","hash":"sha384","id":"3041300d060960864801650304020205000430"},"RSA-SHA384":{"sign":"ecdsa/rsa","hash":"sha384","id":"3041300d060960864801650304020205000430"},"sha512WithRSAEncryption":{"sign":"rsa","hash":"sha512","id":"3051300d060960864801650304020305000440"},"RSA-SHA512":{"sign":"ecdsa/rsa","hash":"sha512","id":"3051300d060960864801650304020305000440"},"RSA-SHA1":{"sign":"rsa","hash":"sha1","id":"3021300906052b0e03021a05000414"},"ecdsa-with-SHA1":{"sign":"ecdsa","hash":"sha1","id":""},"sha256":{"sign":"ecdsa","hash":"sha256","id":""},"sha224":{"sign":"ecdsa","hash":"sha224","id":""},"sha384":{"sign":"ecdsa","hash":"sha384","id":""},"sha512":{"sign":"ecdsa","hash":"sha512","id":""},"DSA-SHA":{"sign":"dsa","hash":"sha1","id":""},"DSA-SHA1":{"sign":"dsa","hash":"sha1","id":""},"DSA":{"sign":"dsa","hash":"sha1","id":""},"DSA-WITH-SHA224":{"sign":"dsa","hash":"sha224","id":""},"DSA-SHA224":{"sign":"dsa","hash":"sha224","id":""},"DSA-WITH-SHA256":{"sign":"dsa","hash":"sha256","id":""},"DSA-SHA256":{"sign":"dsa","hash":"sha256","id":""},"DSA-WITH-SHA384":{"sign":"dsa","hash":"sha384","id":""},"DSA-SHA384":{"sign":"dsa","hash":"sha384","id":""},"DSA-WITH-SHA512":{"sign":"dsa","hash":"sha512","id":""},"DSA-SHA512":{"sign":"dsa","hash":"sha512","id":""},"DSA-RIPEMD160":{"sign":"dsa","hash":"rmd160","id":""},"ripemd160WithRSA":{"sign":"rsa","hash":"rmd160","id":"3021300906052b2403020105000414"},"RSA-RIPEMD160":{"sign":"rsa","hash":"rmd160","id":"3021300906052b2403020105000414"},"md5WithRSAEncryption":{"sign":"rsa","hash":"md5","id":"3020300c06082a864886f70d020505000410"},"RSA-MD5":{"sign":"rsa","hash":"md5","id":"3020300c06082a864886f70d020505000410"}}');

});


parcelRequire.register("1UZ5c", function(module, exports) {

$parcel$export(module.exports, "pbkdf2", function () { return $165a6736bece551e$export$448fa22aedc9dbca; }, function (v) { return $165a6736bece551e$export$448fa22aedc9dbca = v; });
$parcel$export(module.exports, "pbkdf2Sync", function () { return $165a6736bece551e$export$b80c7ba289c8fa56; }, function (v) { return $165a6736bece551e$export$b80c7ba289c8fa56 = v; });
var $165a6736bece551e$export$448fa22aedc9dbca;
var $165a6736bece551e$export$b80c7ba289c8fa56;

$165a6736bece551e$export$448fa22aedc9dbca = (parcelRequire("dIhCC"));

$165a6736bece551e$export$b80c7ba289c8fa56 = (parcelRequire("6LmVU"));

});
parcelRequire.register("dIhCC", function(module, exports) {

var $6U9mG = parcelRequire("6U9mG");
var $9fbd0dc1d3c42e2b$require$Buffer = $6U9mG.Buffer;

var $1iCjP = parcelRequire("1iCjP");

var $d5AyT = parcelRequire("d5AyT");

var $6LmVU = parcelRequire("6LmVU");

var $dq9GI = parcelRequire("dq9GI");
var $9fbd0dc1d3c42e2b$var$ZERO_BUF;
var $9fbd0dc1d3c42e2b$var$subtle = $parcel$global.crypto && $parcel$global.crypto.subtle;
var $9fbd0dc1d3c42e2b$var$toBrowser = {
    sha: "SHA-1",
    "sha-1": "SHA-1",
    sha1: "SHA-1",
    sha256: "SHA-256",
    "sha-256": "SHA-256",
    sha384: "SHA-384",
    "sha-384": "SHA-384",
    "sha-512": "SHA-512",
    sha512: "SHA-512"
};
var $9fbd0dc1d3c42e2b$var$checks = [];
function $9fbd0dc1d3c42e2b$var$checkNative(algo) {
    if ($parcel$global.process && !$parcel$global.process.browser) return Promise.resolve(false);
    if (!$9fbd0dc1d3c42e2b$var$subtle || !$9fbd0dc1d3c42e2b$var$subtle.importKey || !$9fbd0dc1d3c42e2b$var$subtle.deriveBits) return Promise.resolve(false);
    if ($9fbd0dc1d3c42e2b$var$checks[algo] !== undefined) return $9fbd0dc1d3c42e2b$var$checks[algo];
    $9fbd0dc1d3c42e2b$var$ZERO_BUF = $9fbd0dc1d3c42e2b$var$ZERO_BUF || $9fbd0dc1d3c42e2b$require$Buffer.alloc(8);
    var prom = $9fbd0dc1d3c42e2b$var$browserPbkdf2($9fbd0dc1d3c42e2b$var$ZERO_BUF, $9fbd0dc1d3c42e2b$var$ZERO_BUF, 10, 128, algo).then(function() {
        return true;
    }).catch(function() {
        return false;
    });
    $9fbd0dc1d3c42e2b$var$checks[algo] = prom;
    return prom;
}
var $9fbd0dc1d3c42e2b$var$nextTick;
function $9fbd0dc1d3c42e2b$var$getNextTick() {
    if ($9fbd0dc1d3c42e2b$var$nextTick) return $9fbd0dc1d3c42e2b$var$nextTick;
    if ($parcel$global.process && $parcel$global.process.nextTick) $9fbd0dc1d3c42e2b$var$nextTick = $parcel$global.process.nextTick;
    else if ($parcel$global.queueMicrotask) $9fbd0dc1d3c42e2b$var$nextTick = $parcel$global.queueMicrotask;
    else if ($parcel$global.setImmediate) $9fbd0dc1d3c42e2b$var$nextTick = $parcel$global.setImmediate;
    else $9fbd0dc1d3c42e2b$var$nextTick = $parcel$global.setTimeout;
    return $9fbd0dc1d3c42e2b$var$nextTick;
}
function $9fbd0dc1d3c42e2b$var$browserPbkdf2(password, salt, iterations, length, algo) {
    return $9fbd0dc1d3c42e2b$var$subtle.importKey("raw", password, {
        name: "PBKDF2"
    }, false, [
        "deriveBits"
    ]).then(function(key) {
        return $9fbd0dc1d3c42e2b$var$subtle.deriveBits({
            name: "PBKDF2",
            salt: salt,
            iterations: iterations,
            hash: {
                name: algo
            }
        }, key, length << 3);
    }).then(function(res) {
        return $9fbd0dc1d3c42e2b$require$Buffer.from(res);
    });
}
function $9fbd0dc1d3c42e2b$var$resolvePromise(promise, callback) {
    promise.then(function(out) {
        $9fbd0dc1d3c42e2b$var$getNextTick()(function() {
            callback(null, out);
        });
    }, function(e) {
        $9fbd0dc1d3c42e2b$var$getNextTick()(function() {
            callback(e);
        });
    });
}
module.exports = function(password, salt, iterations, keylen, digest, callback) {
    if (typeof digest === "function") {
        callback = digest;
        digest = undefined;
    }
    digest = digest || "sha1";
    var algo = $9fbd0dc1d3c42e2b$var$toBrowser[digest.toLowerCase()];
    if (!algo || typeof $parcel$global.Promise !== "function") {
        $9fbd0dc1d3c42e2b$var$getNextTick()(function() {
            var out;
            try {
                out = $6LmVU(password, salt, iterations, keylen, digest);
            } catch (e) {
                return callback(e);
            }
            callback(null, out);
        });
        return;
    }
    $1iCjP(iterations, keylen);
    password = $dq9GI(password, $d5AyT, "Password");
    salt = $dq9GI(salt, $d5AyT, "Salt");
    if (typeof callback !== "function") throw new Error("No callback provided to pbkdf2");
    $9fbd0dc1d3c42e2b$var$resolvePromise($9fbd0dc1d3c42e2b$var$checkNative(algo).then(function(resp) {
        if (resp) return $9fbd0dc1d3c42e2b$var$browserPbkdf2(password, salt, iterations, keylen, algo);
        return $6LmVU(password, salt, iterations, keylen, digest);
    }), callback);
};

});
parcelRequire.register("1iCjP", function(module, exports) {
var $0f253230941a725c$var$MAX_ALLOC = Math.pow(2, 30) - 1 // default in iojs
;
module.exports = function(iterations, keylen) {
    if (typeof iterations !== "number") throw new TypeError("Iterations not a number");
    if (iterations < 0) throw new TypeError("Bad iterations");
    if (typeof keylen !== "number") throw new TypeError("Key length not a number");
    if (keylen < 0 || keylen > $0f253230941a725c$var$MAX_ALLOC || keylen !== keylen) throw new TypeError("Bad key length");
};

});

parcelRequire.register("d5AyT", function(module, exports) {

var $4TNnu = parcelRequire("4TNnu");
var $98781a6615686185$var$defaultEncoding;
/* istanbul ignore next */ if ($parcel$global.process && $parcel$global.process.browser) $98781a6615686185$var$defaultEncoding = "utf-8";
else if ($parcel$global.process && $parcel$global.process.version) {
    var $98781a6615686185$var$pVersionMajor = parseInt($4TNnu.version.split(".")[0].slice(1), 10);
    $98781a6615686185$var$defaultEncoding = $98781a6615686185$var$pVersionMajor >= 6 ? "utf-8" : "binary";
} else $98781a6615686185$var$defaultEncoding = "utf-8";
module.exports = $98781a6615686185$var$defaultEncoding;

});

parcelRequire.register("6LmVU", function(module, exports) {

var $5GY4Y = parcelRequire("5GY4Y");

var $cjuEr = parcelRequire("cjuEr");

var $fkJVr = parcelRequire("fkJVr");

var $6U9mG = parcelRequire("6U9mG");
var $4ec8ebe845b2b457$require$Buffer = $6U9mG.Buffer;

var $1iCjP = parcelRequire("1iCjP");

var $d5AyT = parcelRequire("d5AyT");

var $dq9GI = parcelRequire("dq9GI");
var $4ec8ebe845b2b457$var$ZEROS = $4ec8ebe845b2b457$require$Buffer.alloc(128);
var $4ec8ebe845b2b457$var$sizes = {
    md5: 16,
    sha1: 20,
    sha224: 28,
    sha256: 32,
    sha384: 48,
    sha512: 64,
    rmd160: 20,
    ripemd160: 20
};
function $4ec8ebe845b2b457$var$Hmac(alg, key, saltLen) {
    var hash = $4ec8ebe845b2b457$var$getDigest(alg);
    var blocksize = alg === "sha512" || alg === "sha384" ? 128 : 64;
    if (key.length > blocksize) key = hash(key);
    else if (key.length < blocksize) key = $4ec8ebe845b2b457$require$Buffer.concat([
        key,
        $4ec8ebe845b2b457$var$ZEROS
    ], blocksize);
    var ipad = $4ec8ebe845b2b457$require$Buffer.allocUnsafe(blocksize + $4ec8ebe845b2b457$var$sizes[alg]);
    var opad = $4ec8ebe845b2b457$require$Buffer.allocUnsafe(blocksize + $4ec8ebe845b2b457$var$sizes[alg]);
    for(var i = 0; i < blocksize; i++){
        ipad[i] = key[i] ^ 0x36;
        opad[i] = key[i] ^ 0x5C;
    }
    var ipad1 = $4ec8ebe845b2b457$require$Buffer.allocUnsafe(blocksize + saltLen + 4);
    ipad.copy(ipad1, 0, 0, blocksize);
    this.ipad1 = ipad1;
    this.ipad2 = ipad;
    this.opad = opad;
    this.alg = alg;
    this.blocksize = blocksize;
    this.hash = hash;
    this.size = $4ec8ebe845b2b457$var$sizes[alg];
}
$4ec8ebe845b2b457$var$Hmac.prototype.run = function(data, ipad) {
    data.copy(ipad, this.blocksize);
    var h = this.hash(ipad);
    h.copy(this.opad, this.blocksize);
    return this.hash(this.opad);
};
function $4ec8ebe845b2b457$var$getDigest(alg) {
    function shaFunc(data) {
        return $fkJVr(alg).update(data).digest();
    }
    function rmd160Func(data) {
        return new $cjuEr().update(data).digest();
    }
    if (alg === "rmd160" || alg === "ripemd160") return rmd160Func;
    if (alg === "md5") return $5GY4Y;
    return shaFunc;
}
function $4ec8ebe845b2b457$var$pbkdf2(password, salt, iterations, keylen, digest) {
    $1iCjP(iterations, keylen);
    password = $dq9GI(password, $d5AyT, "Password");
    salt = $dq9GI(salt, $d5AyT, "Salt");
    digest = digest || "sha1";
    var hmac = new $4ec8ebe845b2b457$var$Hmac(digest, password, salt.length);
    var DK = $4ec8ebe845b2b457$require$Buffer.allocUnsafe(keylen);
    var block1 = $4ec8ebe845b2b457$require$Buffer.allocUnsafe(salt.length + 4);
    salt.copy(block1, 0, 0, salt.length);
    var destPos = 0;
    var hLen = $4ec8ebe845b2b457$var$sizes[digest];
    var l = Math.ceil(keylen / hLen);
    for(var i = 1; i <= l; i++){
        block1.writeUInt32BE(i, salt.length);
        var T = hmac.run(block1, hmac.ipad1);
        var U = T;
        for(var j = 1; j < iterations; j++){
            U = hmac.run(U, hmac.ipad2);
            for(var k = 0; k < hLen; k++)T[k] ^= U[k];
        }
        T.copy(DK, destPos);
        destPos += hLen;
    }
    return DK;
}
module.exports = $4ec8ebe845b2b457$var$pbkdf2;

});
parcelRequire.register("dq9GI", function(module, exports) {

var $6U9mG = parcelRequire("6U9mG");
var $9c5537e46f7ed310$require$Buffer = $6U9mG.Buffer;
module.exports = function(thing, encoding, name) {
    if ($9c5537e46f7ed310$require$Buffer.isBuffer(thing)) return thing;
    else if (typeof thing === "string") return $9c5537e46f7ed310$require$Buffer.from(thing, encoding);
    else if (ArrayBuffer.isView(thing)) return $9c5537e46f7ed310$require$Buffer.from(thing.buffer);
    else throw new TypeError(name + " must be a string, a Buffer, a typed array or a DataView");
};

});




parcelRequire.register("3lJ0u", function(module, exports) {

$parcel$export(module.exports, "createCipher", function () { return $27063eb805988425$export$bdd223f16383713e; }, function (v) { return $27063eb805988425$export$bdd223f16383713e = v; });
$parcel$export(module.exports, "Cipher", function () { return $27063eb805988425$export$26e5786e8ac8e530; }, function (v) { return $27063eb805988425$export$26e5786e8ac8e530 = v; });
$parcel$export(module.exports, "createCipheriv", function () { return $27063eb805988425$export$2f64596b8cbf08b4; }, function (v) { return $27063eb805988425$export$2f64596b8cbf08b4 = v; });
$parcel$export(module.exports, "Cipheriv", function () { return $27063eb805988425$export$20533d26f07f1ee0; }, function (v) { return $27063eb805988425$export$20533d26f07f1ee0 = v; });
$parcel$export(module.exports, "createDecipher", function () { return $27063eb805988425$export$12ada9414fbc594c; }, function (v) { return $27063eb805988425$export$12ada9414fbc594c = v; });
$parcel$export(module.exports, "Decipher", function () { return $27063eb805988425$export$2ce6d8d0e8b04e1a; }, function (v) { return $27063eb805988425$export$2ce6d8d0e8b04e1a = v; });
$parcel$export(module.exports, "createDecipheriv", function () { return $27063eb805988425$export$36b6d6ef312eab39; }, function (v) { return $27063eb805988425$export$36b6d6ef312eab39 = v; });
$parcel$export(module.exports, "Decipheriv", function () { return $27063eb805988425$export$f5e7e39d57cd9700; }, function (v) { return $27063eb805988425$export$f5e7e39d57cd9700 = v; });
$parcel$export(module.exports, "listCiphers", function () { return $27063eb805988425$export$dedd8dc3dc62b370; }, function (v) { return $27063eb805988425$export$dedd8dc3dc62b370 = v; });
$parcel$export(module.exports, "getCiphers", function () { return $27063eb805988425$export$58a258485f1e49f6; }, function (v) { return $27063eb805988425$export$58a258485f1e49f6 = v; });
var $27063eb805988425$export$bdd223f16383713e;
var $27063eb805988425$export$26e5786e8ac8e530;
var $27063eb805988425$export$2f64596b8cbf08b4;
var $27063eb805988425$export$20533d26f07f1ee0;
var $27063eb805988425$export$12ada9414fbc594c;
var $27063eb805988425$export$2ce6d8d0e8b04e1a;
var $27063eb805988425$export$36b6d6ef312eab39;
var $27063eb805988425$export$f5e7e39d57cd9700;
var $27063eb805988425$export$dedd8dc3dc62b370;
var $27063eb805988425$export$58a258485f1e49f6;

var $5e4Jl = parcelRequire("5e4Jl");

var $k1gB1 = parcelRequire("k1gB1");

var $saHx5 = parcelRequire("saHx5");

var $hqhSB = parcelRequire("hqhSB");

var $5uIwM = parcelRequire("5uIwM");
function $27063eb805988425$var$createCipher(suite, password) {
    suite = suite.toLowerCase();
    var keyLen, ivLen;
    if ($saHx5[suite]) {
        keyLen = $saHx5[suite].key;
        ivLen = $saHx5[suite].iv;
    } else if ($hqhSB[suite]) {
        keyLen = $hqhSB[suite].key * 8;
        ivLen = $hqhSB[suite].iv;
    } else throw new TypeError("invalid suite type");
    var keys = $5uIwM(password, false, keyLen, ivLen);
    return $27063eb805988425$var$createCipheriv(suite, keys.key, keys.iv);
}
function $27063eb805988425$var$createDecipher(suite, password) {
    suite = suite.toLowerCase();
    var keyLen, ivLen;
    if ($saHx5[suite]) {
        keyLen = $saHx5[suite].key;
        ivLen = $saHx5[suite].iv;
    } else if ($hqhSB[suite]) {
        keyLen = $hqhSB[suite].key * 8;
        ivLen = $hqhSB[suite].iv;
    } else throw new TypeError("invalid suite type");
    var keys = $5uIwM(password, false, keyLen, ivLen);
    return $27063eb805988425$var$createDecipheriv(suite, keys.key, keys.iv);
}
function $27063eb805988425$var$createCipheriv(suite, key, iv) {
    suite = suite.toLowerCase();
    if ($saHx5[suite]) return $k1gB1.createCipheriv(suite, key, iv);
    if ($hqhSB[suite]) return new $5e4Jl({
        key: key,
        iv: iv,
        mode: suite
    });
    throw new TypeError("invalid suite type");
}
function $27063eb805988425$var$createDecipheriv(suite, key, iv) {
    suite = suite.toLowerCase();
    if ($saHx5[suite]) return $k1gB1.createDecipheriv(suite, key, iv);
    if ($hqhSB[suite]) return new $5e4Jl({
        key: key,
        iv: iv,
        mode: suite,
        decrypt: true
    });
    throw new TypeError("invalid suite type");
}
function $27063eb805988425$var$getCiphers() {
    return Object.keys($hqhSB).concat($k1gB1.getCiphers());
}
$27063eb805988425$export$bdd223f16383713e = $27063eb805988425$export$26e5786e8ac8e530 = $27063eb805988425$var$createCipher;
$27063eb805988425$export$2f64596b8cbf08b4 = $27063eb805988425$export$20533d26f07f1ee0 = $27063eb805988425$var$createCipheriv;
$27063eb805988425$export$12ada9414fbc594c = $27063eb805988425$export$2ce6d8d0e8b04e1a = $27063eb805988425$var$createDecipher;
$27063eb805988425$export$36b6d6ef312eab39 = $27063eb805988425$export$f5e7e39d57cd9700 = $27063eb805988425$var$createDecipheriv;
$27063eb805988425$export$dedd8dc3dc62b370 = $27063eb805988425$export$58a258485f1e49f6 = $27063eb805988425$var$getCiphers;

});
parcelRequire.register("5e4Jl", function(module, exports) {

var $fpHcA = parcelRequire("fpHcA");

var $lCSZA = parcelRequire("lCSZA");

var $eSHUL = parcelRequire("eSHUL");

var $6U9mG = parcelRequire("6U9mG");
var $3ce1edebcff63bba$require$Buffer = $6U9mG.Buffer;
var $3ce1edebcff63bba$var$modes = {
    "des-ede3-cbc": $lCSZA.CBC.instantiate($lCSZA.EDE),
    "des-ede3": $lCSZA.EDE,
    "des-ede-cbc": $lCSZA.CBC.instantiate($lCSZA.EDE),
    "des-ede": $lCSZA.EDE,
    "des-cbc": $lCSZA.CBC.instantiate($lCSZA.DES),
    "des-ecb": $lCSZA.DES
};
$3ce1edebcff63bba$var$modes.des = $3ce1edebcff63bba$var$modes["des-cbc"];
$3ce1edebcff63bba$var$modes.des3 = $3ce1edebcff63bba$var$modes["des-ede3-cbc"];
module.exports = $3ce1edebcff63bba$var$DES;
$eSHUL($3ce1edebcff63bba$var$DES, $fpHcA);
function $3ce1edebcff63bba$var$DES(opts) {
    $fpHcA.call(this);
    var modeName = opts.mode.toLowerCase();
    var mode = $3ce1edebcff63bba$var$modes[modeName];
    var type;
    if (opts.decrypt) type = "decrypt";
    else type = "encrypt";
    var key = opts.key;
    if (!$3ce1edebcff63bba$require$Buffer.isBuffer(key)) key = $3ce1edebcff63bba$require$Buffer.from(key);
    if (modeName === "des-ede" || modeName === "des-ede-cbc") key = $3ce1edebcff63bba$require$Buffer.concat([
        key,
        key.slice(0, 8)
    ]);
    var iv = opts.iv;
    if (!$3ce1edebcff63bba$require$Buffer.isBuffer(iv)) iv = $3ce1edebcff63bba$require$Buffer.from(iv);
    this._des = mode.create({
        key: key,
        iv: iv,
        type: type
    });
}
$3ce1edebcff63bba$var$DES.prototype._update = function(data) {
    return $3ce1edebcff63bba$require$Buffer.from(this._des.update(data));
};
$3ce1edebcff63bba$var$DES.prototype._final = function() {
    return $3ce1edebcff63bba$require$Buffer.from(this._des.final());
};

});
parcelRequire.register("lCSZA", function(module, exports) {

$parcel$export(module.exports, "DES", function () { return $fbe7cdeec3c8acd6$export$cc8859615686b300; }, function (v) { return $fbe7cdeec3c8acd6$export$cc8859615686b300 = v; });
$parcel$export(module.exports, "CBC", function () { return $fbe7cdeec3c8acd6$export$8ad3f227af08fcc5; }, function (v) { return $fbe7cdeec3c8acd6$export$8ad3f227af08fcc5 = v; });
$parcel$export(module.exports, "EDE", function () { return $fbe7cdeec3c8acd6$export$947646e34766044f; }, function (v) { return $fbe7cdeec3c8acd6$export$947646e34766044f = v; });
var $fbe7cdeec3c8acd6$export$eab97d15b1788b8d;
var $fbe7cdeec3c8acd6$export$26e5786e8ac8e530;
var $fbe7cdeec3c8acd6$export$cc8859615686b300;
var $fbe7cdeec3c8acd6$export$8ad3f227af08fcc5;
var $fbe7cdeec3c8acd6$export$947646e34766044f;
"use strict";

$fbe7cdeec3c8acd6$export$eab97d15b1788b8d = (parcelRequire("amxhE"));

$fbe7cdeec3c8acd6$export$26e5786e8ac8e530 = (parcelRequire("aAaZT"));

$fbe7cdeec3c8acd6$export$cc8859615686b300 = (parcelRequire("lbpyh"));

$fbe7cdeec3c8acd6$export$8ad3f227af08fcc5 = (parcelRequire("4KVAb"));

$fbe7cdeec3c8acd6$export$947646e34766044f = (parcelRequire("ipB6Y"));

});
parcelRequire.register("amxhE", function(module, exports) {

$parcel$export(module.exports, "readUInt32BE", function () { return $78b5c6e404207be9$export$cfaef8ed399428b0; }, function (v) { return $78b5c6e404207be9$export$cfaef8ed399428b0 = v; });
$parcel$export(module.exports, "writeUInt32BE", function () { return $78b5c6e404207be9$export$a80c7deaea7cbd80; }, function (v) { return $78b5c6e404207be9$export$a80c7deaea7cbd80 = v; });
$parcel$export(module.exports, "ip", function () { return $78b5c6e404207be9$export$ed7577ae6e1cd0ef; }, function (v) { return $78b5c6e404207be9$export$ed7577ae6e1cd0ef = v; });
$parcel$export(module.exports, "rip", function () { return $78b5c6e404207be9$export$5dcbef3aa594f567; }, function (v) { return $78b5c6e404207be9$export$5dcbef3aa594f567 = v; });
$parcel$export(module.exports, "pc1", function () { return $78b5c6e404207be9$export$5bc8001ca71ed9c5; }, function (v) { return $78b5c6e404207be9$export$5bc8001ca71ed9c5 = v; });
$parcel$export(module.exports, "r28shl", function () { return $78b5c6e404207be9$export$3e714e2c5d5d8cb2; }, function (v) { return $78b5c6e404207be9$export$3e714e2c5d5d8cb2 = v; });
$parcel$export(module.exports, "pc2", function () { return $78b5c6e404207be9$export$94c3e544fd062b7f; }, function (v) { return $78b5c6e404207be9$export$94c3e544fd062b7f = v; });
$parcel$export(module.exports, "expand", function () { return $78b5c6e404207be9$export$9f77e0932fb78f72; }, function (v) { return $78b5c6e404207be9$export$9f77e0932fb78f72 = v; });
$parcel$export(module.exports, "substitute", function () { return $78b5c6e404207be9$export$d865ce2836f5927f; }, function (v) { return $78b5c6e404207be9$export$d865ce2836f5927f = v; });
$parcel$export(module.exports, "permute", function () { return $78b5c6e404207be9$export$95e62ad65da8b7d2; }, function (v) { return $78b5c6e404207be9$export$95e62ad65da8b7d2 = v; });
$parcel$export(module.exports, "padSplit", function () { return $78b5c6e404207be9$export$209139ff098c441a; }, function (v) { return $78b5c6e404207be9$export$209139ff098c441a = v; });
var $78b5c6e404207be9$export$cfaef8ed399428b0;
var $78b5c6e404207be9$export$a80c7deaea7cbd80;
var $78b5c6e404207be9$export$ed7577ae6e1cd0ef;
var $78b5c6e404207be9$export$5dcbef3aa594f567;
var $78b5c6e404207be9$export$5bc8001ca71ed9c5;
var $78b5c6e404207be9$export$3e714e2c5d5d8cb2;
var $78b5c6e404207be9$export$94c3e544fd062b7f;
var $78b5c6e404207be9$export$9f77e0932fb78f72;
var $78b5c6e404207be9$export$d865ce2836f5927f;
var $78b5c6e404207be9$export$95e62ad65da8b7d2;
var $78b5c6e404207be9$export$209139ff098c441a;
"use strict";
$78b5c6e404207be9$export$cfaef8ed399428b0 = function readUInt32BE(bytes, off) {
    var res = bytes[0 + off] << 24 | bytes[1 + off] << 16 | bytes[2 + off] << 8 | bytes[3 + off];
    return res >>> 0;
};
$78b5c6e404207be9$export$a80c7deaea7cbd80 = function writeUInt32BE(bytes, value, off) {
    bytes[0 + off] = value >>> 24;
    bytes[1 + off] = value >>> 16 & 0xff;
    bytes[2 + off] = value >>> 8 & 0xff;
    bytes[3 + off] = value & 0xff;
};
$78b5c6e404207be9$export$ed7577ae6e1cd0ef = function ip(inL, inR, out, off) {
    var outL = 0;
    var outR = 0;
    for(var i = 6; i >= 0; i -= 2){
        for(var j = 0; j <= 24; j += 8){
            outL <<= 1;
            outL |= inR >>> j + i & 1;
        }
        for(var j = 0; j <= 24; j += 8){
            outL <<= 1;
            outL |= inL >>> j + i & 1;
        }
    }
    for(var i = 6; i >= 0; i -= 2){
        for(var j = 1; j <= 25; j += 8){
            outR <<= 1;
            outR |= inR >>> j + i & 1;
        }
        for(var j = 1; j <= 25; j += 8){
            outR <<= 1;
            outR |= inL >>> j + i & 1;
        }
    }
    out[off + 0] = outL >>> 0;
    out[off + 1] = outR >>> 0;
};
$78b5c6e404207be9$export$5dcbef3aa594f567 = function rip(inL, inR, out, off) {
    var outL = 0;
    var outR = 0;
    for(var i = 0; i < 4; i++)for(var j = 24; j >= 0; j -= 8){
        outL <<= 1;
        outL |= inR >>> j + i & 1;
        outL <<= 1;
        outL |= inL >>> j + i & 1;
    }
    for(var i = 4; i < 8; i++)for(var j = 24; j >= 0; j -= 8){
        outR <<= 1;
        outR |= inR >>> j + i & 1;
        outR <<= 1;
        outR |= inL >>> j + i & 1;
    }
    out[off + 0] = outL >>> 0;
    out[off + 1] = outR >>> 0;
};
$78b5c6e404207be9$export$5bc8001ca71ed9c5 = function pc1(inL, inR, out, off) {
    var outL = 0;
    var outR = 0;
    // 7, 15, 23, 31, 39, 47, 55, 63
    // 6, 14, 22, 30, 39, 47, 55, 63
    // 5, 13, 21, 29, 39, 47, 55, 63
    // 4, 12, 20, 28
    for(var i = 7; i >= 5; i--){
        for(var j = 0; j <= 24; j += 8){
            outL <<= 1;
            outL |= inR >> j + i & 1;
        }
        for(var j = 0; j <= 24; j += 8){
            outL <<= 1;
            outL |= inL >> j + i & 1;
        }
    }
    for(var j = 0; j <= 24; j += 8){
        outL <<= 1;
        outL |= inR >> j + i & 1;
    }
    // 1, 9, 17, 25, 33, 41, 49, 57
    // 2, 10, 18, 26, 34, 42, 50, 58
    // 3, 11, 19, 27, 35, 43, 51, 59
    // 36, 44, 52, 60
    for(var i = 1; i <= 3; i++){
        for(var j = 0; j <= 24; j += 8){
            outR <<= 1;
            outR |= inR >> j + i & 1;
        }
        for(var j = 0; j <= 24; j += 8){
            outR <<= 1;
            outR |= inL >> j + i & 1;
        }
    }
    for(var j = 0; j <= 24; j += 8){
        outR <<= 1;
        outR |= inL >> j + i & 1;
    }
    out[off + 0] = outL >>> 0;
    out[off + 1] = outR >>> 0;
};
$78b5c6e404207be9$export$3e714e2c5d5d8cb2 = function r28shl(num, shift) {
    return num << shift & 0xfffffff | num >>> 28 - shift;
};
var $78b5c6e404207be9$var$pc2table = [
    // inL => outL
    14,
    11,
    17,
    4,
    27,
    23,
    25,
    0,
    13,
    22,
    7,
    18,
    5,
    9,
    16,
    24,
    2,
    20,
    12,
    21,
    1,
    8,
    15,
    26,
    // inR => outR
    15,
    4,
    25,
    19,
    9,
    1,
    26,
    16,
    5,
    11,
    23,
    8,
    12,
    7,
    17,
    0,
    22,
    3,
    10,
    14,
    6,
    20,
    27,
    24
];
$78b5c6e404207be9$export$94c3e544fd062b7f = function pc2(inL, inR, out, off) {
    var outL = 0;
    var outR = 0;
    var len = $78b5c6e404207be9$var$pc2table.length >>> 1;
    for(var i = 0; i < len; i++){
        outL <<= 1;
        outL |= inL >>> $78b5c6e404207be9$var$pc2table[i] & 0x1;
    }
    for(var i = len; i < $78b5c6e404207be9$var$pc2table.length; i++){
        outR <<= 1;
        outR |= inR >>> $78b5c6e404207be9$var$pc2table[i] & 0x1;
    }
    out[off + 0] = outL >>> 0;
    out[off + 1] = outR >>> 0;
};
$78b5c6e404207be9$export$9f77e0932fb78f72 = function expand(r, out, off) {
    var outL = 0;
    var outR = 0;
    outL = (r & 1) << 5 | r >>> 27;
    for(var i = 23; i >= 15; i -= 4){
        outL <<= 6;
        outL |= r >>> i & 0x3f;
    }
    for(var i = 11; i >= 3; i -= 4){
        outR |= r >>> i & 0x3f;
        outR <<= 6;
    }
    outR |= (r & 0x1f) << 1 | r >>> 31;
    out[off + 0] = outL >>> 0;
    out[off + 1] = outR >>> 0;
};
var $78b5c6e404207be9$var$sTable = [
    14,
    0,
    4,
    15,
    13,
    7,
    1,
    4,
    2,
    14,
    15,
    2,
    11,
    13,
    8,
    1,
    3,
    10,
    10,
    6,
    6,
    12,
    12,
    11,
    5,
    9,
    9,
    5,
    0,
    3,
    7,
    8,
    4,
    15,
    1,
    12,
    14,
    8,
    8,
    2,
    13,
    4,
    6,
    9,
    2,
    1,
    11,
    7,
    15,
    5,
    12,
    11,
    9,
    3,
    7,
    14,
    3,
    10,
    10,
    0,
    5,
    6,
    0,
    13,
    15,
    3,
    1,
    13,
    8,
    4,
    14,
    7,
    6,
    15,
    11,
    2,
    3,
    8,
    4,
    14,
    9,
    12,
    7,
    0,
    2,
    1,
    13,
    10,
    12,
    6,
    0,
    9,
    5,
    11,
    10,
    5,
    0,
    13,
    14,
    8,
    7,
    10,
    11,
    1,
    10,
    3,
    4,
    15,
    13,
    4,
    1,
    2,
    5,
    11,
    8,
    6,
    12,
    7,
    6,
    12,
    9,
    0,
    3,
    5,
    2,
    14,
    15,
    9,
    10,
    13,
    0,
    7,
    9,
    0,
    14,
    9,
    6,
    3,
    3,
    4,
    15,
    6,
    5,
    10,
    1,
    2,
    13,
    8,
    12,
    5,
    7,
    14,
    11,
    12,
    4,
    11,
    2,
    15,
    8,
    1,
    13,
    1,
    6,
    10,
    4,
    13,
    9,
    0,
    8,
    6,
    15,
    9,
    3,
    8,
    0,
    7,
    11,
    4,
    1,
    15,
    2,
    14,
    12,
    3,
    5,
    11,
    10,
    5,
    14,
    2,
    7,
    12,
    7,
    13,
    13,
    8,
    14,
    11,
    3,
    5,
    0,
    6,
    6,
    15,
    9,
    0,
    10,
    3,
    1,
    4,
    2,
    7,
    8,
    2,
    5,
    12,
    11,
    1,
    12,
    10,
    4,
    14,
    15,
    9,
    10,
    3,
    6,
    15,
    9,
    0,
    0,
    6,
    12,
    10,
    11,
    1,
    7,
    13,
    13,
    8,
    15,
    9,
    1,
    4,
    3,
    5,
    14,
    11,
    5,
    12,
    2,
    7,
    8,
    2,
    4,
    14,
    2,
    14,
    12,
    11,
    4,
    2,
    1,
    12,
    7,
    4,
    10,
    7,
    11,
    13,
    6,
    1,
    8,
    5,
    5,
    0,
    3,
    15,
    15,
    10,
    13,
    3,
    0,
    9,
    14,
    8,
    9,
    6,
    4,
    11,
    2,
    8,
    1,
    12,
    11,
    7,
    10,
    1,
    13,
    14,
    7,
    2,
    8,
    13,
    15,
    6,
    9,
    15,
    12,
    0,
    5,
    9,
    6,
    10,
    3,
    4,
    0,
    5,
    14,
    3,
    12,
    10,
    1,
    15,
    10,
    4,
    15,
    2,
    9,
    7,
    2,
    12,
    6,
    9,
    8,
    5,
    0,
    6,
    13,
    1,
    3,
    13,
    4,
    14,
    14,
    0,
    7,
    11,
    5,
    3,
    11,
    8,
    9,
    4,
    14,
    3,
    15,
    2,
    5,
    12,
    2,
    9,
    8,
    5,
    12,
    15,
    3,
    10,
    7,
    11,
    0,
    14,
    4,
    1,
    10,
    7,
    1,
    6,
    13,
    0,
    11,
    8,
    6,
    13,
    4,
    13,
    11,
    0,
    2,
    11,
    14,
    7,
    15,
    4,
    0,
    9,
    8,
    1,
    13,
    10,
    3,
    14,
    12,
    3,
    9,
    5,
    7,
    12,
    5,
    2,
    10,
    15,
    6,
    8,
    1,
    6,
    1,
    6,
    4,
    11,
    11,
    13,
    13,
    8,
    12,
    1,
    3,
    4,
    7,
    10,
    14,
    7,
    10,
    9,
    15,
    5,
    6,
    0,
    8,
    15,
    0,
    14,
    5,
    2,
    9,
    3,
    2,
    12,
    13,
    1,
    2,
    15,
    8,
    13,
    4,
    8,
    6,
    10,
    15,
    3,
    11,
    7,
    1,
    4,
    10,
    12,
    9,
    5,
    3,
    6,
    14,
    11,
    5,
    0,
    0,
    14,
    12,
    9,
    7,
    2,
    7,
    2,
    11,
    1,
    4,
    14,
    1,
    7,
    9,
    4,
    12,
    10,
    14,
    8,
    2,
    13,
    0,
    15,
    6,
    12,
    10,
    9,
    13,
    0,
    15,
    3,
    3,
    5,
    5,
    6,
    8,
    11
];
$78b5c6e404207be9$export$d865ce2836f5927f = function substitute(inL, inR) {
    var out = 0;
    for(var i = 0; i < 4; i++){
        var b = inL >>> 18 - i * 6 & 0x3f;
        var sb = $78b5c6e404207be9$var$sTable[i * 0x40 + b];
        out <<= 4;
        out |= sb;
    }
    for(var i = 0; i < 4; i++){
        var b = inR >>> 18 - i * 6 & 0x3f;
        var sb = $78b5c6e404207be9$var$sTable[256 + i * 0x40 + b];
        out <<= 4;
        out |= sb;
    }
    return out >>> 0;
};
var $78b5c6e404207be9$var$permuteTable = [
    16,
    25,
    12,
    11,
    3,
    20,
    4,
    15,
    31,
    17,
    9,
    6,
    27,
    14,
    1,
    22,
    30,
    24,
    8,
    18,
    0,
    5,
    29,
    23,
    13,
    19,
    2,
    26,
    10,
    21,
    28,
    7
];
$78b5c6e404207be9$export$95e62ad65da8b7d2 = function permute(num) {
    var out = 0;
    for(var i = 0; i < $78b5c6e404207be9$var$permuteTable.length; i++){
        out <<= 1;
        out |= num >>> $78b5c6e404207be9$var$permuteTable[i] & 0x1;
    }
    return out >>> 0;
};
$78b5c6e404207be9$export$209139ff098c441a = function padSplit(num, size, group) {
    var str = num.toString(2);
    while(str.length < size)str = "0" + str;
    var out = [];
    for(var i = 0; i < size; i += group)out.push(str.slice(i, i + group));
    return out.join(" ");
};

});

parcelRequire.register("aAaZT", function(module, exports) {
"use strict";

var $aJt1P = parcelRequire("aJt1P");
function $7b45cbfb22d7466a$var$Cipher(options) {
    this.options = options;
    this.type = this.options.type;
    this.blockSize = 8;
    this._init();
    this.buffer = new Array(this.blockSize);
    this.bufferOff = 0;
    this.padding = options.padding !== false;
}
module.exports = $7b45cbfb22d7466a$var$Cipher;
$7b45cbfb22d7466a$var$Cipher.prototype._init = function _init() {
// Might be overrided
};
$7b45cbfb22d7466a$var$Cipher.prototype.update = function update(data) {
    if (data.length === 0) return [];
    if (this.type === "decrypt") return this._updateDecrypt(data);
    else return this._updateEncrypt(data);
};
$7b45cbfb22d7466a$var$Cipher.prototype._buffer = function _buffer(data, off) {
    // Append data to buffer
    var min = Math.min(this.buffer.length - this.bufferOff, data.length - off);
    for(var i = 0; i < min; i++)this.buffer[this.bufferOff + i] = data[off + i];
    this.bufferOff += min;
    // Shift next
    return min;
};
$7b45cbfb22d7466a$var$Cipher.prototype._flushBuffer = function _flushBuffer(out, off) {
    this._update(this.buffer, 0, out, off);
    this.bufferOff = 0;
    return this.blockSize;
};
$7b45cbfb22d7466a$var$Cipher.prototype._updateEncrypt = function _updateEncrypt(data) {
    var inputOff = 0;
    var outputOff = 0;
    var count = (this.bufferOff + data.length) / this.blockSize | 0;
    var out = new Array(count * this.blockSize);
    if (this.bufferOff !== 0) {
        inputOff += this._buffer(data, inputOff);
        if (this.bufferOff === this.buffer.length) outputOff += this._flushBuffer(out, outputOff);
    }
    // Write blocks
    var max = data.length - (data.length - inputOff) % this.blockSize;
    for(; inputOff < max; inputOff += this.blockSize){
        this._update(data, inputOff, out, outputOff);
        outputOff += this.blockSize;
    }
    // Queue rest
    for(; inputOff < data.length; inputOff++, this.bufferOff++)this.buffer[this.bufferOff] = data[inputOff];
    return out;
};
$7b45cbfb22d7466a$var$Cipher.prototype._updateDecrypt = function _updateDecrypt(data) {
    var inputOff = 0;
    var outputOff = 0;
    var count = Math.ceil((this.bufferOff + data.length) / this.blockSize) - 1;
    var out = new Array(count * this.blockSize);
    // TODO(indutny): optimize it, this is far from optimal
    for(; count > 0; count--){
        inputOff += this._buffer(data, inputOff);
        outputOff += this._flushBuffer(out, outputOff);
    }
    // Buffer rest of the input
    inputOff += this._buffer(data, inputOff);
    return out;
};
$7b45cbfb22d7466a$var$Cipher.prototype.final = function final(buffer) {
    var first;
    if (buffer) first = this.update(buffer);
    var last;
    if (this.type === "encrypt") last = this._finalEncrypt();
    else last = this._finalDecrypt();
    if (first) return first.concat(last);
    else return last;
};
$7b45cbfb22d7466a$var$Cipher.prototype._pad = function _pad(buffer, off) {
    if (off === 0) return false;
    while(off < buffer.length)buffer[off++] = 0;
    return true;
};
$7b45cbfb22d7466a$var$Cipher.prototype._finalEncrypt = function _finalEncrypt() {
    if (!this._pad(this.buffer, this.bufferOff)) return [];
    var out = new Array(this.blockSize);
    this._update(this.buffer, 0, out, 0);
    return out;
};
$7b45cbfb22d7466a$var$Cipher.prototype._unpad = function _unpad(buffer) {
    return buffer;
};
$7b45cbfb22d7466a$var$Cipher.prototype._finalDecrypt = function _finalDecrypt() {
    $aJt1P.equal(this.bufferOff, this.blockSize, "Not enough data to decrypt");
    var out = new Array(this.blockSize);
    this._flushBuffer(out, 0);
    return this._unpad(out);
};

});

parcelRequire.register("lbpyh", function(module, exports) {
"use strict";

var $aJt1P = parcelRequire("aJt1P");

var $eSHUL = parcelRequire("eSHUL");

var $amxhE = parcelRequire("amxhE");

var $aAaZT = parcelRequire("aAaZT");
function $f6be72270bafa6fd$var$DESState() {
    this.tmp = new Array(2);
    this.keys = null;
}
function $f6be72270bafa6fd$var$DES(options) {
    $aAaZT.call(this, options);
    var state = new $f6be72270bafa6fd$var$DESState();
    this._desState = state;
    this.deriveKeys(state, options.key);
}
$eSHUL($f6be72270bafa6fd$var$DES, $aAaZT);
module.exports = $f6be72270bafa6fd$var$DES;
$f6be72270bafa6fd$var$DES.create = function create(options) {
    return new $f6be72270bafa6fd$var$DES(options);
};
var $f6be72270bafa6fd$var$shiftTable = [
    1,
    1,
    2,
    2,
    2,
    2,
    2,
    2,
    1,
    2,
    2,
    2,
    2,
    2,
    2,
    1
];
$f6be72270bafa6fd$var$DES.prototype.deriveKeys = function deriveKeys(state, key) {
    state.keys = new Array(32);
    $aJt1P.equal(key.length, this.blockSize, "Invalid key length");
    var kL = $amxhE.readUInt32BE(key, 0);
    var kR = $amxhE.readUInt32BE(key, 4);
    $amxhE.pc1(kL, kR, state.tmp, 0);
    kL = state.tmp[0];
    kR = state.tmp[1];
    for(var i = 0; i < state.keys.length; i += 2){
        var shift = $f6be72270bafa6fd$var$shiftTable[i >>> 1];
        kL = $amxhE.r28shl(kL, shift);
        kR = $amxhE.r28shl(kR, shift);
        $amxhE.pc2(kL, kR, state.keys, i);
    }
};
$f6be72270bafa6fd$var$DES.prototype._update = function _update(inp, inOff, out, outOff) {
    var state = this._desState;
    var l = $amxhE.readUInt32BE(inp, inOff);
    var r = $amxhE.readUInt32BE(inp, inOff + 4);
    // Initial Permutation
    $amxhE.ip(l, r, state.tmp, 0);
    l = state.tmp[0];
    r = state.tmp[1];
    if (this.type === "encrypt") this._encrypt(state, l, r, state.tmp, 0);
    else this._decrypt(state, l, r, state.tmp, 0);
    l = state.tmp[0];
    r = state.tmp[1];
    $amxhE.writeUInt32BE(out, l, outOff);
    $amxhE.writeUInt32BE(out, r, outOff + 4);
};
$f6be72270bafa6fd$var$DES.prototype._pad = function _pad(buffer, off) {
    if (this.padding === false) return false;
    var value = buffer.length - off;
    for(var i = off; i < buffer.length; i++)buffer[i] = value;
    return true;
};
$f6be72270bafa6fd$var$DES.prototype._unpad = function _unpad(buffer) {
    if (this.padding === false) return buffer;
    var pad = buffer[buffer.length - 1];
    for(var i = buffer.length - pad; i < buffer.length; i++)$aJt1P.equal(buffer[i], pad);
    return buffer.slice(0, buffer.length - pad);
};
$f6be72270bafa6fd$var$DES.prototype._encrypt = function _encrypt(state, lStart, rStart, out, off) {
    var l = lStart;
    var r = rStart;
    // Apply f() x16 times
    for(var i = 0; i < state.keys.length; i += 2){
        var keyL = state.keys[i];
        var keyR = state.keys[i + 1];
        // f(r, k)
        $amxhE.expand(r, state.tmp, 0);
        keyL ^= state.tmp[0];
        keyR ^= state.tmp[1];
        var s = $amxhE.substitute(keyL, keyR);
        var f = $amxhE.permute(s);
        var t = r;
        r = (l ^ f) >>> 0;
        l = t;
    }
    // Reverse Initial Permutation
    $amxhE.rip(r, l, out, off);
};
$f6be72270bafa6fd$var$DES.prototype._decrypt = function _decrypt(state, lStart, rStart, out, off) {
    var l = rStart;
    var r = lStart;
    // Apply f() x16 times
    for(var i = state.keys.length - 2; i >= 0; i -= 2){
        var keyL = state.keys[i];
        var keyR = state.keys[i + 1];
        // f(r, k)
        $amxhE.expand(l, state.tmp, 0);
        keyL ^= state.tmp[0];
        keyR ^= state.tmp[1];
        var s = $amxhE.substitute(keyL, keyR);
        var f = $amxhE.permute(s);
        var t = l;
        l = (r ^ f) >>> 0;
        r = t;
    }
    // Reverse Initial Permutation
    $amxhE.rip(l, r, out, off);
};

});

parcelRequire.register("4KVAb", function(module, exports) {

$parcel$export(module.exports, "instantiate", function () { return $37681ffc4c67db45$export$f9bb8d20ccc7477a; }, function (v) { return $37681ffc4c67db45$export$f9bb8d20ccc7477a = v; });
var $37681ffc4c67db45$export$f9bb8d20ccc7477a;
"use strict";

var $aJt1P = parcelRequire("aJt1P");

var $eSHUL = parcelRequire("eSHUL");
var $37681ffc4c67db45$var$proto = {};
function $37681ffc4c67db45$var$CBCState(iv) {
    $aJt1P.equal(iv.length, 8, "Invalid IV length");
    this.iv = new Array(8);
    for(var i = 0; i < this.iv.length; i++)this.iv[i] = iv[i];
}
function $37681ffc4c67db45$var$instantiate(Base) {
    function CBC(options) {
        Base.call(this, options);
        this._cbcInit();
    }
    $eSHUL(CBC, Base);
    var keys = Object.keys($37681ffc4c67db45$var$proto);
    for(var i = 0; i < keys.length; i++){
        var key = keys[i];
        CBC.prototype[key] = $37681ffc4c67db45$var$proto[key];
    }
    CBC.create = function create(options) {
        return new CBC(options);
    };
    return CBC;
}
$37681ffc4c67db45$export$f9bb8d20ccc7477a = $37681ffc4c67db45$var$instantiate;
$37681ffc4c67db45$var$proto._cbcInit = function _cbcInit() {
    var state = new $37681ffc4c67db45$var$CBCState(this.options.iv);
    this._cbcState = state;
};
$37681ffc4c67db45$var$proto._update = function _update(inp, inOff, out, outOff) {
    var state = this._cbcState;
    var superProto = this.constructor.super_.prototype;
    var iv = state.iv;
    if (this.type === "encrypt") {
        for(var i = 0; i < this.blockSize; i++)iv[i] ^= inp[inOff + i];
        superProto._update.call(this, iv, 0, out, outOff);
        for(var i = 0; i < this.blockSize; i++)iv[i] = out[outOff + i];
    } else {
        superProto._update.call(this, inp, inOff, out, outOff);
        for(var i = 0; i < this.blockSize; i++)out[outOff + i] ^= iv[i];
        for(var i = 0; i < this.blockSize; i++)iv[i] = inp[inOff + i];
    }
};

});

parcelRequire.register("ipB6Y", function(module, exports) {
"use strict";

var $aJt1P = parcelRequire("aJt1P");

var $eSHUL = parcelRequire("eSHUL");

var $aAaZT = parcelRequire("aAaZT");

var $lbpyh = parcelRequire("lbpyh");
function $d677595fc0ef2155$var$EDEState(type, key) {
    $aJt1P.equal(key.length, 24, "Invalid key length");
    var k1 = key.slice(0, 8);
    var k2 = key.slice(8, 16);
    var k3 = key.slice(16, 24);
    if (type === "encrypt") this.ciphers = [
        $lbpyh.create({
            type: "encrypt",
            key: k1
        }),
        $lbpyh.create({
            type: "decrypt",
            key: k2
        }),
        $lbpyh.create({
            type: "encrypt",
            key: k3
        })
    ];
    else this.ciphers = [
        $lbpyh.create({
            type: "decrypt",
            key: k3
        }),
        $lbpyh.create({
            type: "encrypt",
            key: k2
        }),
        $lbpyh.create({
            type: "decrypt",
            key: k1
        })
    ];
}
function $d677595fc0ef2155$var$EDE(options) {
    $aAaZT.call(this, options);
    var state = new $d677595fc0ef2155$var$EDEState(this.type, this.options.key);
    this._edeState = state;
}
$eSHUL($d677595fc0ef2155$var$EDE, $aAaZT);
module.exports = $d677595fc0ef2155$var$EDE;
$d677595fc0ef2155$var$EDE.create = function create(options) {
    return new $d677595fc0ef2155$var$EDE(options);
};
$d677595fc0ef2155$var$EDE.prototype._update = function _update(inp, inOff, out, outOff) {
    var state = this._edeState;
    state.ciphers[0]._update(inp, inOff, out, outOff);
    state.ciphers[1]._update(out, outOff, out, outOff);
    state.ciphers[2]._update(out, outOff, out, outOff);
};
$d677595fc0ef2155$var$EDE.prototype._pad = $lbpyh.prototype._pad;
$d677595fc0ef2155$var$EDE.prototype._unpad = $lbpyh.prototype._unpad;

});



parcelRequire.register("k1gB1", function(module, exports) {

$parcel$export(module.exports, "createCipheriv", function () { return $e930c647c2b036f8$export$2f64596b8cbf08b4; }, function (v) { return $e930c647c2b036f8$export$2f64596b8cbf08b4 = v; });
$parcel$export(module.exports, "createDecipheriv", function () { return $e930c647c2b036f8$export$36b6d6ef312eab39; }, function (v) { return $e930c647c2b036f8$export$36b6d6ef312eab39 = v; });
$parcel$export(module.exports, "getCiphers", function () { return $e930c647c2b036f8$export$58a258485f1e49f6; }, function (v) { return $e930c647c2b036f8$export$58a258485f1e49f6 = v; });
var $e930c647c2b036f8$export$bdd223f16383713e;
var $e930c647c2b036f8$export$26e5786e8ac8e530;
var $e930c647c2b036f8$export$2f64596b8cbf08b4;
var $e930c647c2b036f8$export$20533d26f07f1ee0;
var $e930c647c2b036f8$export$12ada9414fbc594c;
var $e930c647c2b036f8$export$2ce6d8d0e8b04e1a;
var $e930c647c2b036f8$export$36b6d6ef312eab39;
var $e930c647c2b036f8$export$f5e7e39d57cd9700;
var $e930c647c2b036f8$export$dedd8dc3dc62b370;
var $e930c647c2b036f8$export$58a258485f1e49f6;

var $5lUqw = parcelRequire("5lUqw");

var $gQor2 = parcelRequire("gQor2");

var $hPX1p = parcelRequire("hPX1p");
function $e930c647c2b036f8$var$getCiphers() {
    return Object.keys($hPX1p);
}
$e930c647c2b036f8$export$bdd223f16383713e = $e930c647c2b036f8$export$26e5786e8ac8e530 = $5lUqw.createCipher;
$e930c647c2b036f8$export$2f64596b8cbf08b4 = $e930c647c2b036f8$export$20533d26f07f1ee0 = $5lUqw.createCipheriv;
$e930c647c2b036f8$export$12ada9414fbc594c = $e930c647c2b036f8$export$2ce6d8d0e8b04e1a = $gQor2.createDecipher;
$e930c647c2b036f8$export$36b6d6ef312eab39 = $e930c647c2b036f8$export$f5e7e39d57cd9700 = $gQor2.createDecipheriv;
$e930c647c2b036f8$export$dedd8dc3dc62b370 = $e930c647c2b036f8$export$58a258485f1e49f6 = $e930c647c2b036f8$var$getCiphers;

});
parcelRequire.register("5lUqw", function(module, exports) {

$parcel$export(module.exports, "createCipheriv", function () { return $3e5aaf1af369121b$export$2f64596b8cbf08b4; }, function (v) { return $3e5aaf1af369121b$export$2f64596b8cbf08b4 = v; });
$parcel$export(module.exports, "createCipher", function () { return $3e5aaf1af369121b$export$bdd223f16383713e; }, function (v) { return $3e5aaf1af369121b$export$bdd223f16383713e = v; });
var $3e5aaf1af369121b$export$2f64596b8cbf08b4;
var $3e5aaf1af369121b$export$bdd223f16383713e;

var $saHx5 = parcelRequire("saHx5");

var $iEPe6 = parcelRequire("iEPe6");

var $6U9mG = parcelRequire("6U9mG");
var $3e5aaf1af369121b$require$Buffer = $6U9mG.Buffer;

var $aKCeN = parcelRequire("aKCeN");

var $fpHcA = parcelRequire("fpHcA");

var $4Nfih = parcelRequire("4Nfih");

var $5uIwM = parcelRequire("5uIwM");

var $eSHUL = parcelRequire("eSHUL");
function $3e5aaf1af369121b$var$Cipher(mode, key, iv) {
    $fpHcA.call(this);
    this._cache = new $3e5aaf1af369121b$var$Splitter();
    this._cipher = new $4Nfih.AES(key);
    this._prev = $3e5aaf1af369121b$require$Buffer.from(iv);
    this._mode = mode;
    this._autopadding = true;
}
$eSHUL($3e5aaf1af369121b$var$Cipher, $fpHcA);
$3e5aaf1af369121b$var$Cipher.prototype._update = function(data) {
    this._cache.add(data);
    var chunk;
    var thing;
    var out = [];
    while(chunk = this._cache.get()){
        thing = this._mode.encrypt(this, chunk);
        out.push(thing);
    }
    return $3e5aaf1af369121b$require$Buffer.concat(out);
};
var $3e5aaf1af369121b$var$PADDING = $3e5aaf1af369121b$require$Buffer.alloc(16, 0x10);
$3e5aaf1af369121b$var$Cipher.prototype._final = function() {
    var chunk = this._cache.flush();
    if (this._autopadding) {
        chunk = this._mode.encrypt(this, chunk);
        this._cipher.scrub();
        return chunk;
    }
    if (!chunk.equals($3e5aaf1af369121b$var$PADDING)) {
        this._cipher.scrub();
        throw new Error("data not multiple of block length");
    }
};
$3e5aaf1af369121b$var$Cipher.prototype.setAutoPadding = function(setTo) {
    this._autopadding = !!setTo;
    return this;
};
function $3e5aaf1af369121b$var$Splitter() {
    this.cache = $3e5aaf1af369121b$require$Buffer.allocUnsafe(0);
}
$3e5aaf1af369121b$var$Splitter.prototype.add = function(data) {
    this.cache = $3e5aaf1af369121b$require$Buffer.concat([
        this.cache,
        data
    ]);
};
$3e5aaf1af369121b$var$Splitter.prototype.get = function() {
    if (this.cache.length > 15) {
        var out = this.cache.slice(0, 16);
        this.cache = this.cache.slice(16);
        return out;
    }
    return null;
};
$3e5aaf1af369121b$var$Splitter.prototype.flush = function() {
    var len = 16 - this.cache.length;
    var padBuff = $3e5aaf1af369121b$require$Buffer.allocUnsafe(len);
    var i = -1;
    while(++i < len)padBuff.writeUInt8(len, i);
    return $3e5aaf1af369121b$require$Buffer.concat([
        this.cache,
        padBuff
    ]);
};
function $3e5aaf1af369121b$var$createCipheriv(suite, password, iv) {
    var config = $saHx5[suite.toLowerCase()];
    if (!config) throw new TypeError("invalid suite type");
    if (typeof password === "string") password = $3e5aaf1af369121b$require$Buffer.from(password);
    if (password.length !== config.key / 8) throw new TypeError("invalid key length " + password.length);
    if (typeof iv === "string") iv = $3e5aaf1af369121b$require$Buffer.from(iv);
    if (config.mode !== "GCM" && iv.length !== config.iv) throw new TypeError("invalid iv length " + iv.length);
    if (config.type === "stream") return new $aKCeN(config.module, password, iv);
    else if (config.type === "auth") return new $iEPe6(config.module, password, iv);
    return new $3e5aaf1af369121b$var$Cipher(config.module, password, iv);
}
function $3e5aaf1af369121b$var$createCipher(suite, password) {
    var config = $saHx5[suite.toLowerCase()];
    if (!config) throw new TypeError("invalid suite type");
    var keys = $5uIwM(password, false, config.key, config.iv);
    return $3e5aaf1af369121b$var$createCipheriv(suite, keys.key, keys.iv);
}
$3e5aaf1af369121b$export$2f64596b8cbf08b4 = $3e5aaf1af369121b$var$createCipheriv;
$3e5aaf1af369121b$export$bdd223f16383713e = $3e5aaf1af369121b$var$createCipher;

});
parcelRequire.register("saHx5", function(module, exports) {








var $054aeaa9bab312d6$var$modeModules = {
    ECB: (parcelRequire("l764o")),
    CBC: (parcelRequire("gXYn1")),
    CFB: (parcelRequire("UMnWk")),
    CFB8: (parcelRequire("00tcX")),
    CFB1: (parcelRequire("6r7x9")),
    OFB: (parcelRequire("anS7G")),
    CTR: (parcelRequire("1z9Wt")),
    GCM: (parcelRequire("1z9Wt"))
};

var $hPX1p = parcelRequire("hPX1p");
for(var $054aeaa9bab312d6$var$key in $hPX1p)$hPX1p[$054aeaa9bab312d6$var$key].module = $054aeaa9bab312d6$var$modeModules[$hPX1p[$054aeaa9bab312d6$var$key].mode];
module.exports = $hPX1p;

});
parcelRequire.register("l764o", function(module, exports) {

$parcel$export(module.exports, "encrypt", function () { return $f5eef5c6e22a602a$export$5b0f6292f11d1d18; }, function (v) { return $f5eef5c6e22a602a$export$5b0f6292f11d1d18 = v; });
$parcel$export(module.exports, "decrypt", function () { return $f5eef5c6e22a602a$export$e85a0c9a1067c5d3; }, function (v) { return $f5eef5c6e22a602a$export$e85a0c9a1067c5d3 = v; });
var $f5eef5c6e22a602a$export$5b0f6292f11d1d18;
var $f5eef5c6e22a602a$export$e85a0c9a1067c5d3;
$f5eef5c6e22a602a$export$5b0f6292f11d1d18 = function(self, block) {
    return self._cipher.encryptBlock(block);
};
$f5eef5c6e22a602a$export$e85a0c9a1067c5d3 = function(self, block) {
    return self._cipher.decryptBlock(block);
};

});

parcelRequire.register("gXYn1", function(module, exports) {

$parcel$export(module.exports, "encrypt", function () { return $c5a0fc56dc7b26c3$export$5b0f6292f11d1d18; }, function (v) { return $c5a0fc56dc7b26c3$export$5b0f6292f11d1d18 = v; });
$parcel$export(module.exports, "decrypt", function () { return $c5a0fc56dc7b26c3$export$e85a0c9a1067c5d3; }, function (v) { return $c5a0fc56dc7b26c3$export$e85a0c9a1067c5d3 = v; });
var $c5a0fc56dc7b26c3$export$5b0f6292f11d1d18;
var $c5a0fc56dc7b26c3$export$e85a0c9a1067c5d3;

var $fDcjW = parcelRequire("fDcjW");
$c5a0fc56dc7b26c3$export$5b0f6292f11d1d18 = function(self, block) {
    var data = $fDcjW(block, self._prev);
    self._prev = self._cipher.encryptBlock(data);
    return self._prev;
};
$c5a0fc56dc7b26c3$export$e85a0c9a1067c5d3 = function(self, block) {
    var pad = self._prev;
    self._prev = block;
    var out = self._cipher.decryptBlock(block);
    return $fDcjW(out, pad);
};

});
parcelRequire.register("fDcjW", function(module, exports) {

var $ihoyg = parcelRequire("ihoyg");
var $b6140e2d47be3780$require$Buffer = $ihoyg.Buffer;
module.exports = function xor(a, b) {
    var length = Math.min(a.length, b.length);
    var buffer = new $b6140e2d47be3780$require$Buffer(length);
    for(var i = 0; i < length; ++i)buffer[i] = a[i] ^ b[i];
    return buffer;
};

});


parcelRequire.register("UMnWk", function(module, exports) {

$parcel$export(module.exports, "encrypt", function () { return $0aaac35ae317ce1a$export$5b0f6292f11d1d18; }, function (v) { return $0aaac35ae317ce1a$export$5b0f6292f11d1d18 = v; });
var $0aaac35ae317ce1a$export$5b0f6292f11d1d18;

var $6U9mG = parcelRequire("6U9mG");
var $0aaac35ae317ce1a$require$Buffer = $6U9mG.Buffer;

var $fDcjW = parcelRequire("fDcjW");
function $0aaac35ae317ce1a$var$encryptStart(self, data, decrypt) {
    var len = data.length;
    var out = $fDcjW(data, self._cache);
    self._cache = self._cache.slice(len);
    self._prev = $0aaac35ae317ce1a$require$Buffer.concat([
        self._prev,
        decrypt ? data : out
    ]);
    return out;
}
$0aaac35ae317ce1a$export$5b0f6292f11d1d18 = function(self, data, decrypt) {
    var out = $0aaac35ae317ce1a$require$Buffer.allocUnsafe(0);
    var len;
    while(data.length){
        if (self._cache.length === 0) {
            self._cache = self._cipher.encryptBlock(self._prev);
            self._prev = $0aaac35ae317ce1a$require$Buffer.allocUnsafe(0);
        }
        if (self._cache.length <= data.length) {
            len = self._cache.length;
            out = $0aaac35ae317ce1a$require$Buffer.concat([
                out,
                $0aaac35ae317ce1a$var$encryptStart(self, data.slice(0, len), decrypt)
            ]);
            data = data.slice(len);
        } else {
            out = $0aaac35ae317ce1a$require$Buffer.concat([
                out,
                $0aaac35ae317ce1a$var$encryptStart(self, data, decrypt)
            ]);
            break;
        }
    }
    return out;
};

});

parcelRequire.register("00tcX", function(module, exports) {

$parcel$export(module.exports, "encrypt", function () { return $00005d8db091e94d$export$5b0f6292f11d1d18; }, function (v) { return $00005d8db091e94d$export$5b0f6292f11d1d18 = v; });
var $00005d8db091e94d$export$5b0f6292f11d1d18;

var $6U9mG = parcelRequire("6U9mG");
var $00005d8db091e94d$require$Buffer = $6U9mG.Buffer;
function $00005d8db091e94d$var$encryptByte(self, byteParam, decrypt) {
    var pad = self._cipher.encryptBlock(self._prev);
    var out = pad[0] ^ byteParam;
    self._prev = $00005d8db091e94d$require$Buffer.concat([
        self._prev.slice(1),
        $00005d8db091e94d$require$Buffer.from([
            decrypt ? byteParam : out
        ])
    ]);
    return out;
}
$00005d8db091e94d$export$5b0f6292f11d1d18 = function(self, chunk, decrypt) {
    var len = chunk.length;
    var out = $00005d8db091e94d$require$Buffer.allocUnsafe(len);
    var i = -1;
    while(++i < len)out[i] = $00005d8db091e94d$var$encryptByte(self, chunk[i], decrypt);
    return out;
};

});

parcelRequire.register("6r7x9", function(module, exports) {

$parcel$export(module.exports, "encrypt", function () { return $4afb1bbda820b619$export$5b0f6292f11d1d18; }, function (v) { return $4afb1bbda820b619$export$5b0f6292f11d1d18 = v; });
var $4afb1bbda820b619$export$5b0f6292f11d1d18;

var $6U9mG = parcelRequire("6U9mG");
var $4afb1bbda820b619$require$Buffer = $6U9mG.Buffer;
function $4afb1bbda820b619$var$encryptByte(self, byteParam, decrypt) {
    var pad;
    var i = -1;
    var len = 8;
    var out = 0;
    var bit, value;
    while(++i < len){
        pad = self._cipher.encryptBlock(self._prev);
        bit = byteParam & 1 << 7 - i ? 0x80 : 0;
        value = pad[0] ^ bit;
        out += (value & 0x80) >> i % 8;
        self._prev = $4afb1bbda820b619$var$shiftIn(self._prev, decrypt ? bit : value);
    }
    return out;
}
function $4afb1bbda820b619$var$shiftIn(buffer, value) {
    var len = buffer.length;
    var i = -1;
    var out = $4afb1bbda820b619$require$Buffer.allocUnsafe(buffer.length);
    buffer = $4afb1bbda820b619$require$Buffer.concat([
        buffer,
        $4afb1bbda820b619$require$Buffer.from([
            value
        ])
    ]);
    while(++i < len)out[i] = buffer[i] << 1 | buffer[i + 1] >> 7;
    return out;
}
$4afb1bbda820b619$export$5b0f6292f11d1d18 = function(self, chunk, decrypt) {
    var len = chunk.length;
    var out = $4afb1bbda820b619$require$Buffer.allocUnsafe(len);
    var i = -1;
    while(++i < len)out[i] = $4afb1bbda820b619$var$encryptByte(self, chunk[i], decrypt);
    return out;
};

});

parcelRequire.register("anS7G", function(module, exports) {

$parcel$export(module.exports, "encrypt", function () { return $78f6090cb273111f$export$5b0f6292f11d1d18; }, function (v) { return $78f6090cb273111f$export$5b0f6292f11d1d18 = v; });
var $78f6090cb273111f$export$5b0f6292f11d1d18;

var $ihoyg = parcelRequire("ihoyg");
var $78f6090cb273111f$require$Buffer = $ihoyg.Buffer;

var $fDcjW = parcelRequire("fDcjW");
function $78f6090cb273111f$var$getBlock(self) {
    self._prev = self._cipher.encryptBlock(self._prev);
    return self._prev;
}
$78f6090cb273111f$export$5b0f6292f11d1d18 = function(self, chunk) {
    while(self._cache.length < chunk.length)self._cache = $78f6090cb273111f$require$Buffer.concat([
        self._cache,
        $78f6090cb273111f$var$getBlock(self)
    ]);
    var pad = self._cache.slice(0, chunk.length);
    self._cache = self._cache.slice(chunk.length);
    return $fDcjW(chunk, pad);
};

});

parcelRequire.register("1z9Wt", function(module, exports) {

$parcel$export(module.exports, "encrypt", function () { return $1240c5a5b7a9d372$export$5b0f6292f11d1d18; }, function (v) { return $1240c5a5b7a9d372$export$5b0f6292f11d1d18 = v; });
var $1240c5a5b7a9d372$export$5b0f6292f11d1d18;

var $fDcjW = parcelRequire("fDcjW");

var $6U9mG = parcelRequire("6U9mG");
var $1240c5a5b7a9d372$require$Buffer = $6U9mG.Buffer;

var $b0v5s = parcelRequire("b0v5s");
function $1240c5a5b7a9d372$var$getBlock(self) {
    var out = self._cipher.encryptBlockRaw(self._prev);
    $b0v5s(self._prev);
    return out;
}
var $1240c5a5b7a9d372$var$blockSize = 16;
$1240c5a5b7a9d372$export$5b0f6292f11d1d18 = function(self, chunk) {
    var chunkNum = Math.ceil(chunk.length / $1240c5a5b7a9d372$var$blockSize);
    var start = self._cache.length;
    self._cache = $1240c5a5b7a9d372$require$Buffer.concat([
        self._cache,
        $1240c5a5b7a9d372$require$Buffer.allocUnsafe(chunkNum * $1240c5a5b7a9d372$var$blockSize)
    ]);
    for(var i = 0; i < chunkNum; i++){
        var out = $1240c5a5b7a9d372$var$getBlock(self);
        var offset = start + i * $1240c5a5b7a9d372$var$blockSize;
        self._cache.writeUInt32BE(out[0], offset + 0);
        self._cache.writeUInt32BE(out[1], offset + 4);
        self._cache.writeUInt32BE(out[2], offset + 8);
        self._cache.writeUInt32BE(out[3], offset + 12);
    }
    var pad = self._cache.slice(0, chunk.length);
    self._cache = self._cache.slice(chunk.length);
    return $fDcjW(chunk, pad);
};

});
parcelRequire.register("b0v5s", function(module, exports) {
function $8037cf0dcb3400de$var$incr32(iv) {
    var len = iv.length;
    var item;
    while(len--){
        item = iv.readUInt8(len);
        if (item === 255) iv.writeUInt8(0, len);
        else {
            item++;
            iv.writeUInt8(item, len);
            break;
        }
    }
}
module.exports = $8037cf0dcb3400de$var$incr32;

});


parcelRequire.register("hPX1p", function(module, exports) {
module.exports = JSON.parse('{"aes-128-ecb":{"cipher":"AES","key":128,"iv":0,"mode":"ECB","type":"block"},"aes-192-ecb":{"cipher":"AES","key":192,"iv":0,"mode":"ECB","type":"block"},"aes-256-ecb":{"cipher":"AES","key":256,"iv":0,"mode":"ECB","type":"block"},"aes-128-cbc":{"cipher":"AES","key":128,"iv":16,"mode":"CBC","type":"block"},"aes-192-cbc":{"cipher":"AES","key":192,"iv":16,"mode":"CBC","type":"block"},"aes-256-cbc":{"cipher":"AES","key":256,"iv":16,"mode":"CBC","type":"block"},"aes128":{"cipher":"AES","key":128,"iv":16,"mode":"CBC","type":"block"},"aes192":{"cipher":"AES","key":192,"iv":16,"mode":"CBC","type":"block"},"aes256":{"cipher":"AES","key":256,"iv":16,"mode":"CBC","type":"block"},"aes-128-cfb":{"cipher":"AES","key":128,"iv":16,"mode":"CFB","type":"stream"},"aes-192-cfb":{"cipher":"AES","key":192,"iv":16,"mode":"CFB","type":"stream"},"aes-256-cfb":{"cipher":"AES","key":256,"iv":16,"mode":"CFB","type":"stream"},"aes-128-cfb8":{"cipher":"AES","key":128,"iv":16,"mode":"CFB8","type":"stream"},"aes-192-cfb8":{"cipher":"AES","key":192,"iv":16,"mode":"CFB8","type":"stream"},"aes-256-cfb8":{"cipher":"AES","key":256,"iv":16,"mode":"CFB8","type":"stream"},"aes-128-cfb1":{"cipher":"AES","key":128,"iv":16,"mode":"CFB1","type":"stream"},"aes-192-cfb1":{"cipher":"AES","key":192,"iv":16,"mode":"CFB1","type":"stream"},"aes-256-cfb1":{"cipher":"AES","key":256,"iv":16,"mode":"CFB1","type":"stream"},"aes-128-ofb":{"cipher":"AES","key":128,"iv":16,"mode":"OFB","type":"stream"},"aes-192-ofb":{"cipher":"AES","key":192,"iv":16,"mode":"OFB","type":"stream"},"aes-256-ofb":{"cipher":"AES","key":256,"iv":16,"mode":"OFB","type":"stream"},"aes-128-ctr":{"cipher":"AES","key":128,"iv":16,"mode":"CTR","type":"stream"},"aes-192-ctr":{"cipher":"AES","key":192,"iv":16,"mode":"CTR","type":"stream"},"aes-256-ctr":{"cipher":"AES","key":256,"iv":16,"mode":"CTR","type":"stream"},"aes-128-gcm":{"cipher":"AES","key":128,"iv":12,"mode":"GCM","type":"auth"},"aes-192-gcm":{"cipher":"AES","key":192,"iv":12,"mode":"GCM","type":"auth"},"aes-256-gcm":{"cipher":"AES","key":256,"iv":12,"mode":"GCM","type":"auth"}}');

});


parcelRequire.register("iEPe6", function(module, exports) {

var $4Nfih = parcelRequire("4Nfih");

var $6U9mG = parcelRequire("6U9mG");
var $d953b2ef02a1977a$require$Buffer = $6U9mG.Buffer;

var $fpHcA = parcelRequire("fpHcA");

var $eSHUL = parcelRequire("eSHUL");

var $eqhe5 = parcelRequire("eqhe5");

var $fDcjW = parcelRequire("fDcjW");

var $b0v5s = parcelRequire("b0v5s");
function $d953b2ef02a1977a$var$xorTest(a, b) {
    var out = 0;
    if (a.length !== b.length) out++;
    var len = Math.min(a.length, b.length);
    for(var i = 0; i < len; ++i)out += a[i] ^ b[i];
    return out;
}
function $d953b2ef02a1977a$var$calcIv(self, iv, ck) {
    if (iv.length === 12) {
        self._finID = $d953b2ef02a1977a$require$Buffer.concat([
            iv,
            $d953b2ef02a1977a$require$Buffer.from([
                0,
                0,
                0,
                1
            ])
        ]);
        return $d953b2ef02a1977a$require$Buffer.concat([
            iv,
            $d953b2ef02a1977a$require$Buffer.from([
                0,
                0,
                0,
                2
            ])
        ]);
    }
    var ghash = new $eqhe5(ck);
    var len = iv.length;
    var toPad = len % 16;
    ghash.update(iv);
    if (toPad) {
        toPad = 16 - toPad;
        ghash.update($d953b2ef02a1977a$require$Buffer.alloc(toPad, 0));
    }
    ghash.update($d953b2ef02a1977a$require$Buffer.alloc(8, 0));
    var ivBits = len * 8;
    var tail = $d953b2ef02a1977a$require$Buffer.alloc(8);
    tail.writeUIntBE(ivBits, 0, 8);
    ghash.update(tail);
    self._finID = ghash.state;
    var out = $d953b2ef02a1977a$require$Buffer.from(self._finID);
    $b0v5s(out);
    return out;
}
function $d953b2ef02a1977a$var$StreamCipher(mode, key, iv, decrypt) {
    $fpHcA.call(this);
    var h = $d953b2ef02a1977a$require$Buffer.alloc(4, 0);
    this._cipher = new $4Nfih.AES(key);
    var ck = this._cipher.encryptBlock(h);
    this._ghash = new $eqhe5(ck);
    iv = $d953b2ef02a1977a$var$calcIv(this, iv, ck);
    this._prev = $d953b2ef02a1977a$require$Buffer.from(iv);
    this._cache = $d953b2ef02a1977a$require$Buffer.allocUnsafe(0);
    this._secCache = $d953b2ef02a1977a$require$Buffer.allocUnsafe(0);
    this._decrypt = decrypt;
    this._alen = 0;
    this._len = 0;
    this._mode = mode;
    this._authTag = null;
    this._called = false;
}
$eSHUL($d953b2ef02a1977a$var$StreamCipher, $fpHcA);
$d953b2ef02a1977a$var$StreamCipher.prototype._update = function(chunk) {
    if (!this._called && this._alen) {
        var rump = 16 - this._alen % 16;
        if (rump < 16) {
            rump = $d953b2ef02a1977a$require$Buffer.alloc(rump, 0);
            this._ghash.update(rump);
        }
    }
    this._called = true;
    var out = this._mode.encrypt(this, chunk);
    if (this._decrypt) this._ghash.update(chunk);
    else this._ghash.update(out);
    this._len += chunk.length;
    return out;
};
$d953b2ef02a1977a$var$StreamCipher.prototype._final = function() {
    if (this._decrypt && !this._authTag) throw new Error("Unsupported state or unable to authenticate data");
    var tag = $fDcjW(this._ghash.final(this._alen * 8, this._len * 8), this._cipher.encryptBlock(this._finID));
    if (this._decrypt && $d953b2ef02a1977a$var$xorTest(tag, this._authTag)) throw new Error("Unsupported state or unable to authenticate data");
    this._authTag = tag;
    this._cipher.scrub();
};
$d953b2ef02a1977a$var$StreamCipher.prototype.getAuthTag = function getAuthTag() {
    if (this._decrypt || !$d953b2ef02a1977a$require$Buffer.isBuffer(this._authTag)) throw new Error("Attempting to get auth tag in unsupported state");
    return this._authTag;
};
$d953b2ef02a1977a$var$StreamCipher.prototype.setAuthTag = function setAuthTag(tag) {
    if (!this._decrypt) throw new Error("Attempting to set auth tag in unsupported state");
    this._authTag = tag;
};
$d953b2ef02a1977a$var$StreamCipher.prototype.setAAD = function setAAD(buf) {
    if (this._called) throw new Error("Attempting to set AAD in unsupported state");
    this._ghash.update(buf);
    this._alen += buf.length;
};
module.exports = $d953b2ef02a1977a$var$StreamCipher;

});
parcelRequire.register("4Nfih", function(module, exports) {

$parcel$export(module.exports, "AES", function () { return $37d79a127135d0aa$export$b80fbe1c3a2b92b5; }, function (v) { return $37d79a127135d0aa$export$b80fbe1c3a2b92b5 = v; });
// based on the aes implimentation in triple sec
// https://github.com/keybase/triplesec
// which is in turn based on the one from crypto-js
// https://code.google.com/p/crypto-js/
var $37d79a127135d0aa$export$b80fbe1c3a2b92b5;

var $6U9mG = parcelRequire("6U9mG");
var $37d79a127135d0aa$require$Buffer = $6U9mG.Buffer;
function $37d79a127135d0aa$var$asUInt32Array(buf) {
    if (!$37d79a127135d0aa$require$Buffer.isBuffer(buf)) buf = $37d79a127135d0aa$require$Buffer.from(buf);
    var len = buf.length / 4 | 0;
    var out = new Array(len);
    for(var i = 0; i < len; i++)out[i] = buf.readUInt32BE(i * 4);
    return out;
}
function $37d79a127135d0aa$var$scrubVec(v) {
    for(var i = 0; i < v.length; v++)v[i] = 0;
}
function $37d79a127135d0aa$var$cryptBlock(M, keySchedule, SUB_MIX, SBOX, nRounds) {
    var SUB_MIX0 = SUB_MIX[0];
    var SUB_MIX1 = SUB_MIX[1];
    var SUB_MIX2 = SUB_MIX[2];
    var SUB_MIX3 = SUB_MIX[3];
    var s0 = M[0] ^ keySchedule[0];
    var s1 = M[1] ^ keySchedule[1];
    var s2 = M[2] ^ keySchedule[2];
    var s3 = M[3] ^ keySchedule[3];
    var t0, t1, t2, t3;
    var ksRow = 4;
    for(var round = 1; round < nRounds; round++){
        t0 = SUB_MIX0[s0 >>> 24] ^ SUB_MIX1[s1 >>> 16 & 0xff] ^ SUB_MIX2[s2 >>> 8 & 0xff] ^ SUB_MIX3[s3 & 0xff] ^ keySchedule[ksRow++];
        t1 = SUB_MIX0[s1 >>> 24] ^ SUB_MIX1[s2 >>> 16 & 0xff] ^ SUB_MIX2[s3 >>> 8 & 0xff] ^ SUB_MIX3[s0 & 0xff] ^ keySchedule[ksRow++];
        t2 = SUB_MIX0[s2 >>> 24] ^ SUB_MIX1[s3 >>> 16 & 0xff] ^ SUB_MIX2[s0 >>> 8 & 0xff] ^ SUB_MIX3[s1 & 0xff] ^ keySchedule[ksRow++];
        t3 = SUB_MIX0[s3 >>> 24] ^ SUB_MIX1[s0 >>> 16 & 0xff] ^ SUB_MIX2[s1 >>> 8 & 0xff] ^ SUB_MIX3[s2 & 0xff] ^ keySchedule[ksRow++];
        s0 = t0;
        s1 = t1;
        s2 = t2;
        s3 = t3;
    }
    t0 = (SBOX[s0 >>> 24] << 24 | SBOX[s1 >>> 16 & 0xff] << 16 | SBOX[s2 >>> 8 & 0xff] << 8 | SBOX[s3 & 0xff]) ^ keySchedule[ksRow++];
    t1 = (SBOX[s1 >>> 24] << 24 | SBOX[s2 >>> 16 & 0xff] << 16 | SBOX[s3 >>> 8 & 0xff] << 8 | SBOX[s0 & 0xff]) ^ keySchedule[ksRow++];
    t2 = (SBOX[s2 >>> 24] << 24 | SBOX[s3 >>> 16 & 0xff] << 16 | SBOX[s0 >>> 8 & 0xff] << 8 | SBOX[s1 & 0xff]) ^ keySchedule[ksRow++];
    t3 = (SBOX[s3 >>> 24] << 24 | SBOX[s0 >>> 16 & 0xff] << 16 | SBOX[s1 >>> 8 & 0xff] << 8 | SBOX[s2 & 0xff]) ^ keySchedule[ksRow++];
    t0 = t0 >>> 0;
    t1 = t1 >>> 0;
    t2 = t2 >>> 0;
    t3 = t3 >>> 0;
    return [
        t0,
        t1,
        t2,
        t3
    ];
}
// AES constants
var $37d79a127135d0aa$var$RCON = [
    0x00,
    0x01,
    0x02,
    0x04,
    0x08,
    0x10,
    0x20,
    0x40,
    0x80,
    0x1b,
    0x36
];
var $37d79a127135d0aa$var$G = function() {
    // Compute double table
    var d = new Array(256);
    for(var j = 0; j < 256; j++)if (j < 128) d[j] = j << 1;
    else d[j] = j << 1 ^ 0x11b;
    var SBOX = [];
    var INV_SBOX = [];
    var SUB_MIX = [
        [],
        [],
        [],
        []
    ];
    var INV_SUB_MIX = [
        [],
        [],
        [],
        []
    ];
    // Walk GF(2^8)
    var x = 0;
    var xi = 0;
    for(var i = 0; i < 256; ++i){
        // Compute sbox
        var sx = xi ^ xi << 1 ^ xi << 2 ^ xi << 3 ^ xi << 4;
        sx = sx >>> 8 ^ sx & 0xff ^ 0x63;
        SBOX[x] = sx;
        INV_SBOX[sx] = x;
        // Compute multiplication
        var x2 = d[x];
        var x4 = d[x2];
        var x8 = d[x4];
        // Compute sub bytes, mix columns tables
        var t = d[sx] * 0x101 ^ sx * 0x1010100;
        SUB_MIX[0][x] = t << 24 | t >>> 8;
        SUB_MIX[1][x] = t << 16 | t >>> 16;
        SUB_MIX[2][x] = t << 8 | t >>> 24;
        SUB_MIX[3][x] = t;
        // Compute inv sub bytes, inv mix columns tables
        t = x8 * 0x1010101 ^ x4 * 0x10001 ^ x2 * 0x101 ^ x * 0x1010100;
        INV_SUB_MIX[0][sx] = t << 24 | t >>> 8;
        INV_SUB_MIX[1][sx] = t << 16 | t >>> 16;
        INV_SUB_MIX[2][sx] = t << 8 | t >>> 24;
        INV_SUB_MIX[3][sx] = t;
        if (x === 0) x = xi = 1;
        else {
            x = x2 ^ d[d[d[x8 ^ x2]]];
            xi ^= d[d[xi]];
        }
    }
    return {
        SBOX: SBOX,
        INV_SBOX: INV_SBOX,
        SUB_MIX: SUB_MIX,
        INV_SUB_MIX: INV_SUB_MIX
    };
}();
function $37d79a127135d0aa$var$AES(key) {
    this._key = $37d79a127135d0aa$var$asUInt32Array(key);
    this._reset();
}
$37d79a127135d0aa$var$AES.blockSize = 16;
$37d79a127135d0aa$var$AES.keySize = 32;
$37d79a127135d0aa$var$AES.prototype.blockSize = $37d79a127135d0aa$var$AES.blockSize;
$37d79a127135d0aa$var$AES.prototype.keySize = $37d79a127135d0aa$var$AES.keySize;
$37d79a127135d0aa$var$AES.prototype._reset = function() {
    var keyWords = this._key;
    var keySize = keyWords.length;
    var nRounds = keySize + 6;
    var ksRows = (nRounds + 1) * 4;
    var keySchedule = [];
    for(var k = 0; k < keySize; k++)keySchedule[k] = keyWords[k];
    for(k = keySize; k < ksRows; k++){
        var t = keySchedule[k - 1];
        if (k % keySize === 0) {
            t = t << 8 | t >>> 24;
            t = $37d79a127135d0aa$var$G.SBOX[t >>> 24] << 24 | $37d79a127135d0aa$var$G.SBOX[t >>> 16 & 0xff] << 16 | $37d79a127135d0aa$var$G.SBOX[t >>> 8 & 0xff] << 8 | $37d79a127135d0aa$var$G.SBOX[t & 0xff];
            t ^= $37d79a127135d0aa$var$RCON[k / keySize | 0] << 24;
        } else if (keySize > 6 && k % keySize === 4) t = $37d79a127135d0aa$var$G.SBOX[t >>> 24] << 24 | $37d79a127135d0aa$var$G.SBOX[t >>> 16 & 0xff] << 16 | $37d79a127135d0aa$var$G.SBOX[t >>> 8 & 0xff] << 8 | $37d79a127135d0aa$var$G.SBOX[t & 0xff];
        keySchedule[k] = keySchedule[k - keySize] ^ t;
    }
    var invKeySchedule = [];
    for(var ik = 0; ik < ksRows; ik++){
        var ksR = ksRows - ik;
        var tt = keySchedule[ksR - (ik % 4 ? 0 : 4)];
        if (ik < 4 || ksR <= 4) invKeySchedule[ik] = tt;
        else invKeySchedule[ik] = $37d79a127135d0aa$var$G.INV_SUB_MIX[0][$37d79a127135d0aa$var$G.SBOX[tt >>> 24]] ^ $37d79a127135d0aa$var$G.INV_SUB_MIX[1][$37d79a127135d0aa$var$G.SBOX[tt >>> 16 & 0xff]] ^ $37d79a127135d0aa$var$G.INV_SUB_MIX[2][$37d79a127135d0aa$var$G.SBOX[tt >>> 8 & 0xff]] ^ $37d79a127135d0aa$var$G.INV_SUB_MIX[3][$37d79a127135d0aa$var$G.SBOX[tt & 0xff]];
    }
    this._nRounds = nRounds;
    this._keySchedule = keySchedule;
    this._invKeySchedule = invKeySchedule;
};
$37d79a127135d0aa$var$AES.prototype.encryptBlockRaw = function(M) {
    M = $37d79a127135d0aa$var$asUInt32Array(M);
    return $37d79a127135d0aa$var$cryptBlock(M, this._keySchedule, $37d79a127135d0aa$var$G.SUB_MIX, $37d79a127135d0aa$var$G.SBOX, this._nRounds);
};
$37d79a127135d0aa$var$AES.prototype.encryptBlock = function(M) {
    var out = this.encryptBlockRaw(M);
    var buf = $37d79a127135d0aa$require$Buffer.allocUnsafe(16);
    buf.writeUInt32BE(out[0], 0);
    buf.writeUInt32BE(out[1], 4);
    buf.writeUInt32BE(out[2], 8);
    buf.writeUInt32BE(out[3], 12);
    return buf;
};
$37d79a127135d0aa$var$AES.prototype.decryptBlock = function(M) {
    M = $37d79a127135d0aa$var$asUInt32Array(M);
    // swap
    var m1 = M[1];
    M[1] = M[3];
    M[3] = m1;
    var out = $37d79a127135d0aa$var$cryptBlock(M, this._invKeySchedule, $37d79a127135d0aa$var$G.INV_SUB_MIX, $37d79a127135d0aa$var$G.INV_SBOX, this._nRounds);
    var buf = $37d79a127135d0aa$require$Buffer.allocUnsafe(16);
    buf.writeUInt32BE(out[0], 0);
    buf.writeUInt32BE(out[3], 4);
    buf.writeUInt32BE(out[2], 8);
    buf.writeUInt32BE(out[1], 12);
    return buf;
};
$37d79a127135d0aa$var$AES.prototype.scrub = function() {
    $37d79a127135d0aa$var$scrubVec(this._keySchedule);
    $37d79a127135d0aa$var$scrubVec(this._invKeySchedule);
    $37d79a127135d0aa$var$scrubVec(this._key);
};
$37d79a127135d0aa$export$b80fbe1c3a2b92b5 = $37d79a127135d0aa$var$AES;

});

parcelRequire.register("eqhe5", function(module, exports) {

var $6U9mG = parcelRequire("6U9mG");
var $a800db270fade44b$require$Buffer = $6U9mG.Buffer;
var $a800db270fade44b$var$ZEROES = $a800db270fade44b$require$Buffer.alloc(16, 0);
function $a800db270fade44b$var$toArray(buf) {
    return [
        buf.readUInt32BE(0),
        buf.readUInt32BE(4),
        buf.readUInt32BE(8),
        buf.readUInt32BE(12)
    ];
}
function $a800db270fade44b$var$fromArray(out) {
    var buf = $a800db270fade44b$require$Buffer.allocUnsafe(16);
    buf.writeUInt32BE(out[0] >>> 0, 0);
    buf.writeUInt32BE(out[1] >>> 0, 4);
    buf.writeUInt32BE(out[2] >>> 0, 8);
    buf.writeUInt32BE(out[3] >>> 0, 12);
    return buf;
}
function $a800db270fade44b$var$GHASH(key) {
    this.h = key;
    this.state = $a800db270fade44b$require$Buffer.alloc(16, 0);
    this.cache = $a800db270fade44b$require$Buffer.allocUnsafe(0);
}
// from http://bitwiseshiftleft.github.io/sjcl/doc/symbols/src/core_gcm.js.html
// by Juho Vähä-Herttua
$a800db270fade44b$var$GHASH.prototype.ghash = function(block) {
    var i = -1;
    while(++i < block.length)this.state[i] ^= block[i];
    this._multiply();
};
$a800db270fade44b$var$GHASH.prototype._multiply = function() {
    var Vi = $a800db270fade44b$var$toArray(this.h);
    var Zi = [
        0,
        0,
        0,
        0
    ];
    var j, xi, lsbVi;
    var i = -1;
    while(++i < 128){
        xi = (this.state[~~(i / 8)] & 1 << 7 - i % 8) !== 0;
        if (xi) {
            // Z_i+1 = Z_i ^ V_i
            Zi[0] ^= Vi[0];
            Zi[1] ^= Vi[1];
            Zi[2] ^= Vi[2];
            Zi[3] ^= Vi[3];
        }
        // Store the value of LSB(V_i)
        lsbVi = (Vi[3] & 1) !== 0;
        // V_i+1 = V_i >> 1
        for(j = 3; j > 0; j--)Vi[j] = Vi[j] >>> 1 | (Vi[j - 1] & 1) << 31;
        Vi[0] = Vi[0] >>> 1;
        // If LSB(V_i) is 1, V_i+1 = (V_i >> 1) ^ R
        if (lsbVi) Vi[0] = Vi[0] ^ -520093696;
    }
    this.state = $a800db270fade44b$var$fromArray(Zi);
};
$a800db270fade44b$var$GHASH.prototype.update = function(buf) {
    this.cache = $a800db270fade44b$require$Buffer.concat([
        this.cache,
        buf
    ]);
    var chunk;
    while(this.cache.length >= 16){
        chunk = this.cache.slice(0, 16);
        this.cache = this.cache.slice(16);
        this.ghash(chunk);
    }
};
$a800db270fade44b$var$GHASH.prototype.final = function(abl, bl) {
    if (this.cache.length) this.ghash($a800db270fade44b$require$Buffer.concat([
        this.cache,
        $a800db270fade44b$var$ZEROES
    ], 16));
    this.ghash($a800db270fade44b$var$fromArray([
        0,
        abl,
        0,
        bl
    ]));
    return this.state;
};
module.exports = $a800db270fade44b$var$GHASH;

});


parcelRequire.register("aKCeN", function(module, exports) {

var $4Nfih = parcelRequire("4Nfih");

var $6U9mG = parcelRequire("6U9mG");
var $7d3bdc7569c86a8c$require$Buffer = $6U9mG.Buffer;

var $fpHcA = parcelRequire("fpHcA");

var $eSHUL = parcelRequire("eSHUL");
function $7d3bdc7569c86a8c$var$StreamCipher(mode, key, iv, decrypt) {
    $fpHcA.call(this);
    this._cipher = new $4Nfih.AES(key);
    this._prev = $7d3bdc7569c86a8c$require$Buffer.from(iv);
    this._cache = $7d3bdc7569c86a8c$require$Buffer.allocUnsafe(0);
    this._secCache = $7d3bdc7569c86a8c$require$Buffer.allocUnsafe(0);
    this._decrypt = decrypt;
    this._mode = mode;
}
$eSHUL($7d3bdc7569c86a8c$var$StreamCipher, $fpHcA);
$7d3bdc7569c86a8c$var$StreamCipher.prototype._update = function(chunk) {
    return this._mode.encrypt(this, chunk, this._decrypt);
};
$7d3bdc7569c86a8c$var$StreamCipher.prototype._final = function() {
    this._cipher.scrub();
};
module.exports = $7d3bdc7569c86a8c$var$StreamCipher;

});

parcelRequire.register("5uIwM", function(module, exports) {

var $6U9mG = parcelRequire("6U9mG");
var $40024b5f4411b288$require$Buffer = $6U9mG.Buffer;

var $cvCaQ = parcelRequire("cvCaQ");
/* eslint-disable camelcase */ function $40024b5f4411b288$var$EVP_BytesToKey(password, salt, keyBits, ivLen) {
    if (!$40024b5f4411b288$require$Buffer.isBuffer(password)) password = $40024b5f4411b288$require$Buffer.from(password, "binary");
    if (salt) {
        if (!$40024b5f4411b288$require$Buffer.isBuffer(salt)) salt = $40024b5f4411b288$require$Buffer.from(salt, "binary");
        if (salt.length !== 8) throw new RangeError("salt should be Buffer with 8 byte length");
    }
    var keyLen = keyBits / 8;
    var key = $40024b5f4411b288$require$Buffer.alloc(keyLen);
    var iv = $40024b5f4411b288$require$Buffer.alloc(ivLen || 0);
    var tmp = $40024b5f4411b288$require$Buffer.alloc(0);
    while(keyLen > 0 || ivLen > 0){
        var hash = new $cvCaQ();
        hash.update(tmp);
        hash.update(password);
        if (salt) hash.update(salt);
        tmp = hash.digest();
        var used = 0;
        if (keyLen > 0) {
            var keyStart = key.length - keyLen;
            used = Math.min(keyLen, tmp.length);
            tmp.copy(key, keyStart, 0, used);
            keyLen -= used;
        }
        if (used < tmp.length && ivLen > 0) {
            var ivStart = iv.length - ivLen;
            var length = Math.min(ivLen, tmp.length - used);
            tmp.copy(iv, ivStart, used, used + length);
            ivLen -= length;
        }
    }
    tmp.fill(0);
    return {
        key: key,
        iv: iv
    };
}
module.exports = $40024b5f4411b288$var$EVP_BytesToKey;

});


parcelRequire.register("gQor2", function(module, exports) {

$parcel$export(module.exports, "createDecipher", function () { return $c43474f95c9fc530$export$12ada9414fbc594c; }, function (v) { return $c43474f95c9fc530$export$12ada9414fbc594c = v; });
$parcel$export(module.exports, "createDecipheriv", function () { return $c43474f95c9fc530$export$36b6d6ef312eab39; }, function (v) { return $c43474f95c9fc530$export$36b6d6ef312eab39 = v; });
var $c43474f95c9fc530$export$12ada9414fbc594c;
var $c43474f95c9fc530$export$36b6d6ef312eab39;

var $iEPe6 = parcelRequire("iEPe6");

var $6U9mG = parcelRequire("6U9mG");
var $c43474f95c9fc530$require$Buffer = $6U9mG.Buffer;

var $saHx5 = parcelRequire("saHx5");

var $aKCeN = parcelRequire("aKCeN");

var $fpHcA = parcelRequire("fpHcA");

var $4Nfih = parcelRequire("4Nfih");

var $5uIwM = parcelRequire("5uIwM");

var $eSHUL = parcelRequire("eSHUL");
function $c43474f95c9fc530$var$Decipher(mode, key, iv) {
    $fpHcA.call(this);
    this._cache = new $c43474f95c9fc530$var$Splitter();
    this._last = void 0;
    this._cipher = new $4Nfih.AES(key);
    this._prev = $c43474f95c9fc530$require$Buffer.from(iv);
    this._mode = mode;
    this._autopadding = true;
}
$eSHUL($c43474f95c9fc530$var$Decipher, $fpHcA);
$c43474f95c9fc530$var$Decipher.prototype._update = function(data) {
    this._cache.add(data);
    var chunk;
    var thing;
    var out = [];
    while(chunk = this._cache.get(this._autopadding)){
        thing = this._mode.decrypt(this, chunk);
        out.push(thing);
    }
    return $c43474f95c9fc530$require$Buffer.concat(out);
};
$c43474f95c9fc530$var$Decipher.prototype._final = function() {
    var chunk = this._cache.flush();
    if (this._autopadding) return $c43474f95c9fc530$var$unpad(this._mode.decrypt(this, chunk));
    else if (chunk) throw new Error("data not multiple of block length");
};
$c43474f95c9fc530$var$Decipher.prototype.setAutoPadding = function(setTo) {
    this._autopadding = !!setTo;
    return this;
};
function $c43474f95c9fc530$var$Splitter() {
    this.cache = $c43474f95c9fc530$require$Buffer.allocUnsafe(0);
}
$c43474f95c9fc530$var$Splitter.prototype.add = function(data) {
    this.cache = $c43474f95c9fc530$require$Buffer.concat([
        this.cache,
        data
    ]);
};
$c43474f95c9fc530$var$Splitter.prototype.get = function(autoPadding) {
    var out;
    if (autoPadding) {
        if (this.cache.length > 16) {
            out = this.cache.slice(0, 16);
            this.cache = this.cache.slice(16);
            return out;
        }
    } else if (this.cache.length >= 16) {
        out = this.cache.slice(0, 16);
        this.cache = this.cache.slice(16);
        return out;
    }
    return null;
};
$c43474f95c9fc530$var$Splitter.prototype.flush = function() {
    if (this.cache.length) return this.cache;
};
function $c43474f95c9fc530$var$unpad(last) {
    var padded = last[15];
    if (padded < 1 || padded > 16) throw new Error("unable to decrypt data");
    var i = -1;
    while(++i < padded){
        if (last[i + (16 - padded)] !== padded) throw new Error("unable to decrypt data");
    }
    if (padded === 16) return;
    return last.slice(0, 16 - padded);
}
function $c43474f95c9fc530$var$createDecipheriv(suite, password, iv) {
    var config = $saHx5[suite.toLowerCase()];
    if (!config) throw new TypeError("invalid suite type");
    if (typeof iv === "string") iv = $c43474f95c9fc530$require$Buffer.from(iv);
    if (config.mode !== "GCM" && iv.length !== config.iv) throw new TypeError("invalid iv length " + iv.length);
    if (typeof password === "string") password = $c43474f95c9fc530$require$Buffer.from(password);
    if (password.length !== config.key / 8) throw new TypeError("invalid key length " + password.length);
    if (config.type === "stream") return new $aKCeN(config.module, password, iv, true);
    else if (config.type === "auth") return new $iEPe6(config.module, password, iv, true);
    return new $c43474f95c9fc530$var$Decipher(config.module, password, iv);
}
function $c43474f95c9fc530$var$createDecipher(suite, password) {
    var config = $saHx5[suite.toLowerCase()];
    if (!config) throw new TypeError("invalid suite type");
    var keys = $5uIwM(password, false, config.key, config.iv);
    return $c43474f95c9fc530$var$createDecipheriv(suite, keys.key, keys.iv);
}
$c43474f95c9fc530$export$12ada9414fbc594c = $c43474f95c9fc530$var$createDecipher;
$c43474f95c9fc530$export$36b6d6ef312eab39 = $c43474f95c9fc530$var$createDecipheriv;

});


parcelRequire.register("hqhSB", function(module, exports) {

$parcel$export(module.exports, "des-ecb", function () { return $caf2bbe4b8db6f3b$export$116f8a5cee447347; }, function (v) { return $caf2bbe4b8db6f3b$export$116f8a5cee447347 = v; });
$parcel$export(module.exports, "des-cbc", function () { return $caf2bbe4b8db6f3b$export$7483c4066bfb7ae9; }, function (v) { return $caf2bbe4b8db6f3b$export$7483c4066bfb7ae9 = v; });
$parcel$export(module.exports, "des", function () { return $caf2bbe4b8db6f3b$export$e7a565d2e588bb06; }, function (v) { return $caf2bbe4b8db6f3b$export$e7a565d2e588bb06 = v; });
$parcel$export(module.exports, "des-ede3-cbc", function () { return $caf2bbe4b8db6f3b$export$aaa2f54a426f3eb8; }, function (v) { return $caf2bbe4b8db6f3b$export$aaa2f54a426f3eb8 = v; });
$parcel$export(module.exports, "des3", function () { return $caf2bbe4b8db6f3b$export$eba20568dde4ada; }, function (v) { return $caf2bbe4b8db6f3b$export$eba20568dde4ada = v; });
$parcel$export(module.exports, "des-ede3", function () { return $caf2bbe4b8db6f3b$export$d3b5e5996938f5ae; }, function (v) { return $caf2bbe4b8db6f3b$export$d3b5e5996938f5ae = v; });
$parcel$export(module.exports, "des-ede-cbc", function () { return $caf2bbe4b8db6f3b$export$57c08356130bc99b; }, function (v) { return $caf2bbe4b8db6f3b$export$57c08356130bc99b = v; });
$parcel$export(module.exports, "des-ede", function () { return $caf2bbe4b8db6f3b$export$c7169791d5c1e65d; }, function (v) { return $caf2bbe4b8db6f3b$export$c7169791d5c1e65d = v; });
var $caf2bbe4b8db6f3b$export$116f8a5cee447347;
var $caf2bbe4b8db6f3b$export$7483c4066bfb7ae9;
var $caf2bbe4b8db6f3b$export$e7a565d2e588bb06;
var $caf2bbe4b8db6f3b$export$aaa2f54a426f3eb8;
var $caf2bbe4b8db6f3b$export$eba20568dde4ada;
var $caf2bbe4b8db6f3b$export$d3b5e5996938f5ae;
var $caf2bbe4b8db6f3b$export$57c08356130bc99b;
var $caf2bbe4b8db6f3b$export$c7169791d5c1e65d;
$caf2bbe4b8db6f3b$export$116f8a5cee447347 = {
    key: 8,
    iv: 0
};
$caf2bbe4b8db6f3b$export$7483c4066bfb7ae9 = $caf2bbe4b8db6f3b$export$e7a565d2e588bb06 = {
    key: 8,
    iv: 8
};
$caf2bbe4b8db6f3b$export$aaa2f54a426f3eb8 = $caf2bbe4b8db6f3b$export$eba20568dde4ada = {
    key: 24,
    iv: 8
};
$caf2bbe4b8db6f3b$export$d3b5e5996938f5ae = {
    key: 24,
    iv: 0
};
$caf2bbe4b8db6f3b$export$57c08356130bc99b = {
    key: 16,
    iv: 8
};
$caf2bbe4b8db6f3b$export$c7169791d5c1e65d = {
    key: 16,
    iv: 0
};

});


parcelRequire.register("4evoR", function(module, exports) {

$parcel$export(module.exports, "DiffieHellmanGroup", function () { return $3150d39cd6c438f1$export$971862a2fcb1bb40; }, function (v) { return $3150d39cd6c438f1$export$971862a2fcb1bb40 = v; });
$parcel$export(module.exports, "createDiffieHellmanGroup", function () { return $3150d39cd6c438f1$export$c6ff6a88acbeaf40; }, function (v) { return $3150d39cd6c438f1$export$c6ff6a88acbeaf40 = v; });
$parcel$export(module.exports, "getDiffieHellman", function () { return $3150d39cd6c438f1$export$fdc27893e98845cc; }, function (v) { return $3150d39cd6c438f1$export$fdc27893e98845cc = v; });
$parcel$export(module.exports, "createDiffieHellman", function () { return $3150d39cd6c438f1$export$6671fb9a1323bed; }, function (v) { return $3150d39cd6c438f1$export$6671fb9a1323bed = v; });
$parcel$export(module.exports, "DiffieHellman", function () { return $3150d39cd6c438f1$export$d74daf141a551db; }, function (v) { return $3150d39cd6c438f1$export$d74daf141a551db = v; });
var $3150d39cd6c438f1$export$971862a2fcb1bb40;
var $3150d39cd6c438f1$export$c6ff6a88acbeaf40;
var $3150d39cd6c438f1$export$fdc27893e98845cc;
var $3150d39cd6c438f1$export$6671fb9a1323bed;
var $3150d39cd6c438f1$export$d74daf141a551db;

var $ihoyg = parcelRequire("ihoyg");
var $3150d39cd6c438f1$require$Buffer = $ihoyg.Buffer;

var $lNmPw = parcelRequire("lNmPw");

var $fsr3h = parcelRequire("fsr3h");

var $2kgCI = parcelRequire("2kgCI");
function $3150d39cd6c438f1$var$getDiffieHellman(mod) {
    var prime = new $3150d39cd6c438f1$require$Buffer($fsr3h[mod].prime, "hex");
    var gen = new $3150d39cd6c438f1$require$Buffer($fsr3h[mod].gen, "hex");
    return new $2kgCI(prime, gen);
}
var $3150d39cd6c438f1$var$ENCODINGS = {
    "binary": true,
    "hex": true,
    "base64": true
};
function $3150d39cd6c438f1$var$createDiffieHellman(prime, enc, generator, genc) {
    if ($3150d39cd6c438f1$require$Buffer.isBuffer(enc) || $3150d39cd6c438f1$var$ENCODINGS[enc] === undefined) return $3150d39cd6c438f1$var$createDiffieHellman(prime, "binary", enc, generator);
    enc = enc || "binary";
    genc = genc || "binary";
    generator = generator || new $3150d39cd6c438f1$require$Buffer([
        2
    ]);
    if (!$3150d39cd6c438f1$require$Buffer.isBuffer(generator)) generator = new $3150d39cd6c438f1$require$Buffer(generator, genc);
    if (typeof prime === "number") return new $2kgCI($lNmPw(prime, generator), generator, true);
    if (!$3150d39cd6c438f1$require$Buffer.isBuffer(prime)) prime = new $3150d39cd6c438f1$require$Buffer(prime, enc);
    return new $2kgCI(prime, generator, true);
}
$3150d39cd6c438f1$export$971862a2fcb1bb40 = $3150d39cd6c438f1$export$c6ff6a88acbeaf40 = $3150d39cd6c438f1$export$fdc27893e98845cc = $3150d39cd6c438f1$var$getDiffieHellman;
$3150d39cd6c438f1$export$6671fb9a1323bed = $3150d39cd6c438f1$export$d74daf141a551db = $3150d39cd6c438f1$var$createDiffieHellman;

});
parcelRequire.register("lNmPw", function(module, exports) {

var $5rfiH = parcelRequire("5rfiH");
module.exports = $fddfe224e234e046$var$findPrime;
$fddfe224e234e046$var$findPrime.simpleSieve = $fddfe224e234e046$var$simpleSieve;
$fddfe224e234e046$var$findPrime.fermatTest = $fddfe224e234e046$var$fermatTest;

var $7vYz3 = parcelRequire("7vYz3");
var $fddfe224e234e046$var$TWENTYFOUR = new $7vYz3(24);

var $4hcaz = parcelRequire("4hcaz");
var $fddfe224e234e046$var$millerRabin = new $4hcaz();
var $fddfe224e234e046$var$ONE = new $7vYz3(1);
var $fddfe224e234e046$var$TWO = new $7vYz3(2);
var $fddfe224e234e046$var$FIVE = new $7vYz3(5);
var $fddfe224e234e046$var$SIXTEEN = new $7vYz3(16);
var $fddfe224e234e046$var$EIGHT = new $7vYz3(8);
var $fddfe224e234e046$var$TEN = new $7vYz3(10);
var $fddfe224e234e046$var$THREE = new $7vYz3(3);
var $fddfe224e234e046$var$SEVEN = new $7vYz3(7);
var $fddfe224e234e046$var$ELEVEN = new $7vYz3(11);
var $fddfe224e234e046$var$FOUR = new $7vYz3(4);
var $fddfe224e234e046$var$TWELVE = new $7vYz3(12);
var $fddfe224e234e046$var$primes = null;
function $fddfe224e234e046$var$_getPrimes() {
    if ($fddfe224e234e046$var$primes !== null) return $fddfe224e234e046$var$primes;
    var limit = 0x100000;
    var res = [];
    res[0] = 2;
    for(var i = 1, k = 3; k < limit; k += 2){
        var sqrt = Math.ceil(Math.sqrt(k));
        for(var j = 0; j < i && res[j] <= sqrt; j++)if (k % res[j] === 0) break;
        if (i !== j && res[j] <= sqrt) continue;
        res[i++] = k;
    }
    $fddfe224e234e046$var$primes = res;
    return res;
}
function $fddfe224e234e046$var$simpleSieve(p) {
    var primes = $fddfe224e234e046$var$_getPrimes();
    for(var i = 0; i < primes.length; i++)if (p.modn(primes[i]) === 0) {
        if (p.cmpn(primes[i]) === 0) return true;
        else return false;
    }
    return true;
}
function $fddfe224e234e046$var$fermatTest(p) {
    var red = $7vYz3.mont(p);
    return $fddfe224e234e046$var$TWO.toRed(red).redPow(p.subn(1)).fromRed().cmpn(1) === 0;
}
function $fddfe224e234e046$var$findPrime(bits, gen) {
    if (bits < 16) {
        // this is what openssl does
        if (gen === 2 || gen === 5) return new $7vYz3([
            0x8c,
            0x7b
        ]);
        else return new $7vYz3([
            0x8c,
            0x27
        ]);
    }
    gen = new $7vYz3(gen);
    var num, n2;
    while(true){
        num = new $7vYz3($5rfiH(Math.ceil(bits / 8)));
        while(num.bitLength() > bits)num.ishrn(1);
        if (num.isEven()) num.iadd($fddfe224e234e046$var$ONE);
        if (!num.testn(1)) num.iadd($fddfe224e234e046$var$TWO);
        if (!gen.cmp($fddfe224e234e046$var$TWO)) while(num.mod($fddfe224e234e046$var$TWENTYFOUR).cmp($fddfe224e234e046$var$ELEVEN))num.iadd($fddfe224e234e046$var$FOUR);
        else if (!gen.cmp($fddfe224e234e046$var$FIVE)) while(num.mod($fddfe224e234e046$var$TEN).cmp($fddfe224e234e046$var$THREE))num.iadd($fddfe224e234e046$var$FOUR);
        n2 = num.shrn(1);
        if ($fddfe224e234e046$var$simpleSieve(n2) && $fddfe224e234e046$var$simpleSieve(num) && $fddfe224e234e046$var$fermatTest(n2) && $fddfe224e234e046$var$fermatTest(num) && $fddfe224e234e046$var$millerRabin.test(n2) && $fddfe224e234e046$var$millerRabin.test(num)) return num;
    }
}

});
parcelRequire.register("7vYz3", function(module, exports) {

(function(module1, exports) {
    "use strict";
    // Utils
    function assert(val, msg) {
        if (!val) throw new Error(msg || "Assertion failed");
    }
    // Could use `inherits` module, but don't want to move from single file
    // architecture yet.
    function inherits(ctor, superCtor) {
        ctor.super_ = superCtor;
        var TempCtor = function() {};
        TempCtor.prototype = superCtor.prototype;
        ctor.prototype = new TempCtor();
        ctor.prototype.constructor = ctor;
    }
    // BN
    function BN(number, base, endian) {
        if (BN.isBN(number)) return number;
        this.negative = 0;
        this.words = null;
        this.length = 0;
        // Reduction context
        this.red = null;
        if (number !== null) {
            if (base === "le" || base === "be") {
                endian = base;
                base = 10;
            }
            this._init(number || 0, base || 10, endian || "be");
        }
    }
    if (typeof module1 === "object") module1.exports = BN;
    else exports.BN = BN;
    BN.BN = BN;
    BN.wordSize = 26;
    var Buffer;
    try {
        if (typeof window !== "undefined" && typeof window.Buffer !== "undefined") Buffer = window.Buffer;
        else Buffer = (parcelRequire("5Io6y")).Buffer;
    } catch (e) {}
    BN.isBN = function isBN(num) {
        if (num instanceof BN) return true;
        return num !== null && typeof num === "object" && num.constructor.wordSize === BN.wordSize && Array.isArray(num.words);
    };
    BN.max = function max(left, right) {
        if (left.cmp(right) > 0) return left;
        return right;
    };
    BN.min = function min(left, right) {
        if (left.cmp(right) < 0) return left;
        return right;
    };
    BN.prototype._init = function init(number, base, endian) {
        if (typeof number === "number") return this._initNumber(number, base, endian);
        if (typeof number === "object") return this._initArray(number, base, endian);
        if (base === "hex") base = 16;
        assert(base === (base | 0) && base >= 2 && base <= 36);
        number = number.toString().replace(/\s+/g, "");
        var start = 0;
        if (number[0] === "-") {
            start++;
            this.negative = 1;
        }
        if (start < number.length) {
            if (base === 16) this._parseHex(number, start, endian);
            else {
                this._parseBase(number, base, start);
                if (endian === "le") this._initArray(this.toArray(), base, endian);
            }
        }
    };
    BN.prototype._initNumber = function _initNumber(number, base, endian) {
        if (number < 0) {
            this.negative = 1;
            number = -number;
        }
        if (number < 0x4000000) {
            this.words = [
                number & 0x3ffffff
            ];
            this.length = 1;
        } else if (number < 0x10000000000000) {
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff
            ];
            this.length = 2;
        } else {
            assert(number < 0x20000000000000); // 2 ^ 53 (unsafe)
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff,
                1
            ];
            this.length = 3;
        }
        if (endian !== "le") return;
        // Reverse the bytes
        this._initArray(this.toArray(), base, endian);
    };
    BN.prototype._initArray = function _initArray(number, base, endian) {
        // Perhaps a Uint8Array
        assert(typeof number.length === "number");
        if (number.length <= 0) {
            this.words = [
                0
            ];
            this.length = 1;
            return this;
        }
        this.length = Math.ceil(number.length / 3);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        var j, w;
        var off = 0;
        if (endian === "be") for(i = number.length - 1, j = 0; i >= 0; i -= 3){
            w = number[i] | number[i - 1] << 8 | number[i - 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        else if (endian === "le") for(i = 0, j = 0; i < number.length; i += 3){
            w = number[i] | number[i + 1] << 8 | number[i + 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        return this.strip();
    };
    function parseHex4Bits(string, index) {
        var c = string.charCodeAt(index);
        // 'A' - 'F'
        if (c >= 65 && c <= 70) return c - 55;
        else if (c >= 97 && c <= 102) return c - 87;
        else return c - 48 & 0xf;
    }
    function parseHexByte(string, lowerBound, index) {
        var r = parseHex4Bits(string, index);
        if (index - 1 >= lowerBound) r |= parseHex4Bits(string, index - 1) << 4;
        return r;
    }
    BN.prototype._parseHex = function _parseHex(number, start, endian) {
        // Create possibly bigger array to ensure that it fits the number
        this.length = Math.ceil((number.length - start) / 6);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        // 24-bits chunks
        var off = 0;
        var j = 0;
        var w;
        if (endian === "be") for(i = number.length - 1; i >= start; i -= 2){
            w = parseHexByte(number, start, i) << off;
            this.words[j] |= w & 0x3ffffff;
            if (off >= 18) {
                off -= 18;
                j += 1;
                this.words[j] |= w >>> 26;
            } else off += 8;
        }
        else {
            var parseLength = number.length - start;
            for(i = parseLength % 2 === 0 ? start + 1 : start; i < number.length; i += 2){
                w = parseHexByte(number, start, i) << off;
                this.words[j] |= w & 0x3ffffff;
                if (off >= 18) {
                    off -= 18;
                    j += 1;
                    this.words[j] |= w >>> 26;
                } else off += 8;
            }
        }
        this.strip();
    };
    function parseBase(str, start, end, mul) {
        var r = 0;
        var len = Math.min(str.length, end);
        for(var i = start; i < len; i++){
            var c = str.charCodeAt(i) - 48;
            r *= mul;
            // 'a'
            if (c >= 49) r += c - 49 + 0xa;
            else if (c >= 17) r += c - 17 + 0xa;
            else r += c;
        }
        return r;
    }
    BN.prototype._parseBase = function _parseBase(number, base, start) {
        // Initialize as zero
        this.words = [
            0
        ];
        this.length = 1;
        // Find length of limb in base
        for(var limbLen = 0, limbPow = 1; limbPow <= 0x3ffffff; limbPow *= base)limbLen++;
        limbLen--;
        limbPow = limbPow / base | 0;
        var total = number.length - start;
        var mod = total % limbLen;
        var end = Math.min(total, total - mod) + start;
        var word = 0;
        for(var i = start; i < end; i += limbLen){
            word = parseBase(number, i, i + limbLen, base);
            this.imuln(limbPow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        if (mod !== 0) {
            var pow = 1;
            word = parseBase(number, i, number.length, base);
            for(i = 0; i < mod; i++)pow *= base;
            this.imuln(pow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        this.strip();
    };
    BN.prototype.copy = function copy(dest) {
        dest.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)dest.words[i] = this.words[i];
        dest.length = this.length;
        dest.negative = this.negative;
        dest.red = this.red;
    };
    BN.prototype.clone = function clone() {
        var r = new BN(null);
        this.copy(r);
        return r;
    };
    BN.prototype._expand = function _expand(size) {
        while(this.length < size)this.words[this.length++] = 0;
        return this;
    };
    // Remove leading `0` from `this`
    BN.prototype.strip = function strip() {
        while(this.length > 1 && this.words[this.length - 1] === 0)this.length--;
        return this._normSign();
    };
    BN.prototype._normSign = function _normSign() {
        // -0 = 0
        if (this.length === 1 && this.words[0] === 0) this.negative = 0;
        return this;
    };
    BN.prototype.inspect = function inspect() {
        return (this.red ? "<BN-R: " : "<BN: ") + this.toString(16) + ">";
    };
    /*

  var zeros = [];
  var groupSizes = [];
  var groupBases = [];

  var s = '';
  var i = -1;
  while (++i < BN.wordSize) {
    zeros[i] = s;
    s += '0';
  }
  groupSizes[0] = 0;
  groupSizes[1] = 0;
  groupBases[0] = 0;
  groupBases[1] = 0;
  var base = 2 - 1;
  while (++base < 36 + 1) {
    var groupSize = 0;
    var groupBase = 1;
    while (groupBase < (1 << BN.wordSize) / base) {
      groupBase *= base;
      groupSize += 1;
    }
    groupSizes[base] = groupSize;
    groupBases[base] = groupBase;
  }

  */ var zeros = [
        "",
        "0",
        "00",
        "000",
        "0000",
        "00000",
        "000000",
        "0000000",
        "00000000",
        "000000000",
        "0000000000",
        "00000000000",
        "000000000000",
        "0000000000000",
        "00000000000000",
        "000000000000000",
        "0000000000000000",
        "00000000000000000",
        "000000000000000000",
        "0000000000000000000",
        "00000000000000000000",
        "000000000000000000000",
        "0000000000000000000000",
        "00000000000000000000000",
        "000000000000000000000000",
        "0000000000000000000000000"
    ];
    var groupSizes = [
        0,
        0,
        25,
        16,
        12,
        11,
        10,
        9,
        8,
        8,
        7,
        7,
        7,
        7,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5
    ];
    var groupBases = [
        0,
        0,
        33554432,
        43046721,
        16777216,
        48828125,
        60466176,
        40353607,
        16777216,
        43046721,
        10000000,
        19487171,
        35831808,
        62748517,
        7529536,
        11390625,
        16777216,
        24137569,
        34012224,
        47045881,
        64000000,
        4084101,
        5153632,
        6436343,
        7962624,
        9765625,
        11881376,
        14348907,
        17210368,
        20511149,
        24300000,
        28629151,
        33554432,
        39135393,
        45435424,
        52521875,
        60466176
    ];
    BN.prototype.toString = function toString(base, padding) {
        base = base || 10;
        padding = padding | 0 || 1;
        var out;
        if (base === 16 || base === "hex") {
            out = "";
            var off = 0;
            var carry = 0;
            for(var i = 0; i < this.length; i++){
                var w = this.words[i];
                var word = ((w << off | carry) & 0xffffff).toString(16);
                carry = w >>> 24 - off & 0xffffff;
                if (carry !== 0 || i !== this.length - 1) out = zeros[6 - word.length] + word + out;
                else out = word + out;
                off += 2;
                if (off >= 26) {
                    off -= 26;
                    i--;
                }
            }
            if (carry !== 0) out = carry.toString(16) + out;
            while(out.length % padding !== 0)out = "0" + out;
            if (this.negative !== 0) out = "-" + out;
            return out;
        }
        if (base === (base | 0) && base >= 2 && base <= 36) {
            // var groupSize = Math.floor(BN.wordSize * Math.LN2 / Math.log(base));
            var groupSize = groupSizes[base];
            // var groupBase = Math.pow(base, groupSize);
            var groupBase = groupBases[base];
            out = "";
            var c = this.clone();
            c.negative = 0;
            while(!c.isZero()){
                var r = c.modn(groupBase).toString(base);
                c = c.idivn(groupBase);
                if (!c.isZero()) out = zeros[groupSize - r.length] + r + out;
                else out = r + out;
            }
            if (this.isZero()) out = "0" + out;
            while(out.length % padding !== 0)out = "0" + out;
            if (this.negative !== 0) out = "-" + out;
            return out;
        }
        assert(false, "Base should be between 2 and 36");
    };
    BN.prototype.toNumber = function toNumber() {
        var ret = this.words[0];
        if (this.length === 2) ret += this.words[1] * 0x4000000;
        else if (this.length === 3 && this.words[2] === 0x01) // NOTE: at this stage it is known that the top bit is set
        ret += 0x10000000000000 + this.words[1] * 0x4000000;
        else if (this.length > 2) assert(false, "Number can only safely store up to 53 bits");
        return this.negative !== 0 ? -ret : ret;
    };
    BN.prototype.toJSON = function toJSON() {
        return this.toString(16);
    };
    BN.prototype.toBuffer = function toBuffer(endian, length) {
        assert(typeof Buffer !== "undefined");
        return this.toArrayLike(Buffer, endian, length);
    };
    BN.prototype.toArray = function toArray(endian, length) {
        return this.toArrayLike(Array, endian, length);
    };
    BN.prototype.toArrayLike = function toArrayLike(ArrayType, endian, length) {
        var byteLength = this.byteLength();
        var reqLength = length || Math.max(1, byteLength);
        assert(byteLength <= reqLength, "byte array longer than desired length");
        assert(reqLength > 0, "Requested array length <= 0");
        this.strip();
        var littleEndian = endian === "le";
        var res = new ArrayType(reqLength);
        var b, i;
        var q = this.clone();
        if (!littleEndian) {
            // Assume big-endian
            for(i = 0; i < reqLength - byteLength; i++)res[i] = 0;
            for(i = 0; !q.isZero(); i++){
                b = q.andln(0xff);
                q.iushrn(8);
                res[reqLength - i - 1] = b;
            }
        } else {
            for(i = 0; !q.isZero(); i++){
                b = q.andln(0xff);
                q.iushrn(8);
                res[i] = b;
            }
            for(; i < reqLength; i++)res[i] = 0;
        }
        return res;
    };
    if (Math.clz32) BN.prototype._countBits = function _countBits(w) {
        return 32 - Math.clz32(w);
    };
    else BN.prototype._countBits = function _countBits(w) {
        var t = w;
        var r = 0;
        if (t >= 0x1000) {
            r += 13;
            t >>>= 13;
        }
        if (t >= 0x40) {
            r += 7;
            t >>>= 7;
        }
        if (t >= 0x8) {
            r += 4;
            t >>>= 4;
        }
        if (t >= 0x02) {
            r += 2;
            t >>>= 2;
        }
        return r + t;
    };
    BN.prototype._zeroBits = function _zeroBits(w) {
        // Short-cut
        if (w === 0) return 26;
        var t = w;
        var r = 0;
        if ((t & 0x1fff) === 0) {
            r += 13;
            t >>>= 13;
        }
        if ((t & 0x7f) === 0) {
            r += 7;
            t >>>= 7;
        }
        if ((t & 0xf) === 0) {
            r += 4;
            t >>>= 4;
        }
        if ((t & 0x3) === 0) {
            r += 2;
            t >>>= 2;
        }
        if ((t & 0x1) === 0) r++;
        return r;
    };
    // Return number of used bits in a BN
    BN.prototype.bitLength = function bitLength() {
        var w = this.words[this.length - 1];
        var hi = this._countBits(w);
        return (this.length - 1) * 26 + hi;
    };
    function toBitArray(num) {
        var w = new Array(num.bitLength());
        for(var bit = 0; bit < w.length; bit++){
            var off = bit / 26 | 0;
            var wbit = bit % 26;
            w[bit] = (num.words[off] & 1 << wbit) >>> wbit;
        }
        return w;
    }
    // Number of trailing zero bits
    BN.prototype.zeroBits = function zeroBits() {
        if (this.isZero()) return 0;
        var r = 0;
        for(var i = 0; i < this.length; i++){
            var b = this._zeroBits(this.words[i]);
            r += b;
            if (b !== 26) break;
        }
        return r;
    };
    BN.prototype.byteLength = function byteLength() {
        return Math.ceil(this.bitLength() / 8);
    };
    BN.prototype.toTwos = function toTwos(width) {
        if (this.negative !== 0) return this.abs().inotn(width).iaddn(1);
        return this.clone();
    };
    BN.prototype.fromTwos = function fromTwos(width) {
        if (this.testn(width - 1)) return this.notn(width).iaddn(1).ineg();
        return this.clone();
    };
    BN.prototype.isNeg = function isNeg() {
        return this.negative !== 0;
    };
    // Return negative clone of `this`
    BN.prototype.neg = function neg() {
        return this.clone().ineg();
    };
    BN.prototype.ineg = function ineg() {
        if (!this.isZero()) this.negative ^= 1;
        return this;
    };
    // Or `num` with `this` in-place
    BN.prototype.iuor = function iuor(num) {
        while(this.length < num.length)this.words[this.length++] = 0;
        for(var i = 0; i < num.length; i++)this.words[i] = this.words[i] | num.words[i];
        return this.strip();
    };
    BN.prototype.ior = function ior(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuor(num);
    };
    // Or `num` with `this`
    BN.prototype.or = function or(num) {
        if (this.length > num.length) return this.clone().ior(num);
        return num.clone().ior(this);
    };
    BN.prototype.uor = function uor(num) {
        if (this.length > num.length) return this.clone().iuor(num);
        return num.clone().iuor(this);
    };
    // And `num` with `this` in-place
    BN.prototype.iuand = function iuand(num) {
        // b = min-length(num, this)
        var b;
        if (this.length > num.length) b = num;
        else b = this;
        for(var i = 0; i < b.length; i++)this.words[i] = this.words[i] & num.words[i];
        this.length = b.length;
        return this.strip();
    };
    BN.prototype.iand = function iand(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuand(num);
    };
    // And `num` with `this`
    BN.prototype.and = function and(num) {
        if (this.length > num.length) return this.clone().iand(num);
        return num.clone().iand(this);
    };
    BN.prototype.uand = function uand(num) {
        if (this.length > num.length) return this.clone().iuand(num);
        return num.clone().iuand(this);
    };
    // Xor `num` with `this` in-place
    BN.prototype.iuxor = function iuxor(num) {
        // a.length > b.length
        var a;
        var b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        for(var i = 0; i < b.length; i++)this.words[i] = a.words[i] ^ b.words[i];
        if (this !== a) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = a.length;
        return this.strip();
    };
    BN.prototype.ixor = function ixor(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuxor(num);
    };
    // Xor `num` with `this`
    BN.prototype.xor = function xor(num) {
        if (this.length > num.length) return this.clone().ixor(num);
        return num.clone().ixor(this);
    };
    BN.prototype.uxor = function uxor(num) {
        if (this.length > num.length) return this.clone().iuxor(num);
        return num.clone().iuxor(this);
    };
    // Not ``this`` with ``width`` bitwidth
    BN.prototype.inotn = function inotn(width) {
        assert(typeof width === "number" && width >= 0);
        var bytesNeeded = Math.ceil(width / 26) | 0;
        var bitsLeft = width % 26;
        // Extend the buffer with leading zeroes
        this._expand(bytesNeeded);
        if (bitsLeft > 0) bytesNeeded--;
        // Handle complete words
        for(var i = 0; i < bytesNeeded; i++)this.words[i] = ~this.words[i] & 0x3ffffff;
        // Handle the residue
        if (bitsLeft > 0) this.words[i] = ~this.words[i] & 0x3ffffff >> 26 - bitsLeft;
        // And remove leading zeroes
        return this.strip();
    };
    BN.prototype.notn = function notn(width) {
        return this.clone().inotn(width);
    };
    // Set `bit` of `this`
    BN.prototype.setn = function setn(bit, val) {
        assert(typeof bit === "number" && bit >= 0);
        var off = bit / 26 | 0;
        var wbit = bit % 26;
        this._expand(off + 1);
        if (val) this.words[off] = this.words[off] | 1 << wbit;
        else this.words[off] = this.words[off] & ~(1 << wbit);
        return this.strip();
    };
    // Add `num` to `this` in-place
    BN.prototype.iadd = function iadd(num) {
        var r;
        // negative + positive
        if (this.negative !== 0 && num.negative === 0) {
            this.negative = 0;
            r = this.isub(num);
            this.negative ^= 1;
            return this._normSign();
        // positive + negative
        } else if (this.negative === 0 && num.negative !== 0) {
            num.negative = 0;
            r = this.isub(num);
            num.negative = 1;
            return r._normSign();
        }
        // a.length > b.length
        var a, b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) + (b.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        this.length = a.length;
        if (carry !== 0) {
            this.words[this.length] = carry;
            this.length++;
        // Copy the rest of the words
        } else if (a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        return this;
    };
    // Add `num` to `this`
    BN.prototype.add = function add(num) {
        var res;
        if (num.negative !== 0 && this.negative === 0) {
            num.negative = 0;
            res = this.sub(num);
            num.negative ^= 1;
            return res;
        } else if (num.negative === 0 && this.negative !== 0) {
            this.negative = 0;
            res = num.sub(this);
            this.negative = 1;
            return res;
        }
        if (this.length > num.length) return this.clone().iadd(num);
        return num.clone().iadd(this);
    };
    // Subtract `num` from `this` in-place
    BN.prototype.isub = function isub(num) {
        // this - (-num) = this + num
        if (num.negative !== 0) {
            num.negative = 0;
            var r = this.iadd(num);
            num.negative = 1;
            return r._normSign();
        // -this - num = -(this + num)
        } else if (this.negative !== 0) {
            this.negative = 0;
            this.iadd(num);
            this.negative = 1;
            return this._normSign();
        }
        // At this point both numbers are positive
        var cmp = this.cmp(num);
        // Optimization - zeroify
        if (cmp === 0) {
            this.negative = 0;
            this.length = 1;
            this.words[0] = 0;
            return this;
        }
        // a > b
        var a, b;
        if (cmp > 0) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) - (b.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        // Copy rest of the words
        if (carry === 0 && i < a.length && a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = Math.max(this.length, i);
        if (a !== this) this.negative = 1;
        return this.strip();
    };
    // Subtract `num` from `this`
    BN.prototype.sub = function sub(num) {
        return this.clone().isub(num);
    };
    function smallMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        var len = self.length + num.length | 0;
        out.length = len;
        len = len - 1 | 0;
        // Peel one iteration (compiler can't do it, because of code complexity)
        var a = self.words[0] | 0;
        var b = num.words[0] | 0;
        var r = a * b;
        var lo = r & 0x3ffffff;
        var carry = r / 0x4000000 | 0;
        out.words[0] = lo;
        for(var k = 1; k < len; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = carry >>> 26;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j | 0;
                a = self.words[i] | 0;
                b = num.words[j] | 0;
                r = a * b + rword;
                ncarry += r / 0x4000000 | 0;
                rword = r & 0x3ffffff;
            }
            out.words[k] = rword | 0;
            carry = ncarry | 0;
        }
        if (carry !== 0) out.words[k] = carry | 0;
        else out.length--;
        return out.strip();
    }
    // TODO(indutny): it may be reasonable to omit it for users who don't need
    // to work with 256-bit numbers, otherwise it gives 20% improvement for 256-bit
    // multiplication (like elliptic secp256k1).
    var comb10MulTo = function comb10MulTo(self, num, out) {
        var a = self.words;
        var b = num.words;
        var o = out.words;
        var c = 0;
        var lo;
        var mid;
        var hi;
        var a0 = a[0] | 0;
        var al0 = a0 & 0x1fff;
        var ah0 = a0 >>> 13;
        var a1 = a[1] | 0;
        var al1 = a1 & 0x1fff;
        var ah1 = a1 >>> 13;
        var a2 = a[2] | 0;
        var al2 = a2 & 0x1fff;
        var ah2 = a2 >>> 13;
        var a3 = a[3] | 0;
        var al3 = a3 & 0x1fff;
        var ah3 = a3 >>> 13;
        var a4 = a[4] | 0;
        var al4 = a4 & 0x1fff;
        var ah4 = a4 >>> 13;
        var a5 = a[5] | 0;
        var al5 = a5 & 0x1fff;
        var ah5 = a5 >>> 13;
        var a6 = a[6] | 0;
        var al6 = a6 & 0x1fff;
        var ah6 = a6 >>> 13;
        var a7 = a[7] | 0;
        var al7 = a7 & 0x1fff;
        var ah7 = a7 >>> 13;
        var a8 = a[8] | 0;
        var al8 = a8 & 0x1fff;
        var ah8 = a8 >>> 13;
        var a9 = a[9] | 0;
        var al9 = a9 & 0x1fff;
        var ah9 = a9 >>> 13;
        var b0 = b[0] | 0;
        var bl0 = b0 & 0x1fff;
        var bh0 = b0 >>> 13;
        var b1 = b[1] | 0;
        var bl1 = b1 & 0x1fff;
        var bh1 = b1 >>> 13;
        var b2 = b[2] | 0;
        var bl2 = b2 & 0x1fff;
        var bh2 = b2 >>> 13;
        var b3 = b[3] | 0;
        var bl3 = b3 & 0x1fff;
        var bh3 = b3 >>> 13;
        var b4 = b[4] | 0;
        var bl4 = b4 & 0x1fff;
        var bh4 = b4 >>> 13;
        var b5 = b[5] | 0;
        var bl5 = b5 & 0x1fff;
        var bh5 = b5 >>> 13;
        var b6 = b[6] | 0;
        var bl6 = b6 & 0x1fff;
        var bh6 = b6 >>> 13;
        var b7 = b[7] | 0;
        var bl7 = b7 & 0x1fff;
        var bh7 = b7 >>> 13;
        var b8 = b[8] | 0;
        var bl8 = b8 & 0x1fff;
        var bh8 = b8 >>> 13;
        var b9 = b[9] | 0;
        var bl9 = b9 & 0x1fff;
        var bh9 = b9 >>> 13;
        out.negative = self.negative ^ num.negative;
        out.length = 19;
        /* k = 0 */ lo = Math.imul(al0, bl0);
        mid = Math.imul(al0, bh0);
        mid = mid + Math.imul(ah0, bl0) | 0;
        hi = Math.imul(ah0, bh0);
        var w0 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w0 >>> 26) | 0;
        w0 &= 0x3ffffff;
        /* k = 1 */ lo = Math.imul(al1, bl0);
        mid = Math.imul(al1, bh0);
        mid = mid + Math.imul(ah1, bl0) | 0;
        hi = Math.imul(ah1, bh0);
        lo = lo + Math.imul(al0, bl1) | 0;
        mid = mid + Math.imul(al0, bh1) | 0;
        mid = mid + Math.imul(ah0, bl1) | 0;
        hi = hi + Math.imul(ah0, bh1) | 0;
        var w1 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w1 >>> 26) | 0;
        w1 &= 0x3ffffff;
        /* k = 2 */ lo = Math.imul(al2, bl0);
        mid = Math.imul(al2, bh0);
        mid = mid + Math.imul(ah2, bl0) | 0;
        hi = Math.imul(ah2, bh0);
        lo = lo + Math.imul(al1, bl1) | 0;
        mid = mid + Math.imul(al1, bh1) | 0;
        mid = mid + Math.imul(ah1, bl1) | 0;
        hi = hi + Math.imul(ah1, bh1) | 0;
        lo = lo + Math.imul(al0, bl2) | 0;
        mid = mid + Math.imul(al0, bh2) | 0;
        mid = mid + Math.imul(ah0, bl2) | 0;
        hi = hi + Math.imul(ah0, bh2) | 0;
        var w2 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w2 >>> 26) | 0;
        w2 &= 0x3ffffff;
        /* k = 3 */ lo = Math.imul(al3, bl0);
        mid = Math.imul(al3, bh0);
        mid = mid + Math.imul(ah3, bl0) | 0;
        hi = Math.imul(ah3, bh0);
        lo = lo + Math.imul(al2, bl1) | 0;
        mid = mid + Math.imul(al2, bh1) | 0;
        mid = mid + Math.imul(ah2, bl1) | 0;
        hi = hi + Math.imul(ah2, bh1) | 0;
        lo = lo + Math.imul(al1, bl2) | 0;
        mid = mid + Math.imul(al1, bh2) | 0;
        mid = mid + Math.imul(ah1, bl2) | 0;
        hi = hi + Math.imul(ah1, bh2) | 0;
        lo = lo + Math.imul(al0, bl3) | 0;
        mid = mid + Math.imul(al0, bh3) | 0;
        mid = mid + Math.imul(ah0, bl3) | 0;
        hi = hi + Math.imul(ah0, bh3) | 0;
        var w3 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w3 >>> 26) | 0;
        w3 &= 0x3ffffff;
        /* k = 4 */ lo = Math.imul(al4, bl0);
        mid = Math.imul(al4, bh0);
        mid = mid + Math.imul(ah4, bl0) | 0;
        hi = Math.imul(ah4, bh0);
        lo = lo + Math.imul(al3, bl1) | 0;
        mid = mid + Math.imul(al3, bh1) | 0;
        mid = mid + Math.imul(ah3, bl1) | 0;
        hi = hi + Math.imul(ah3, bh1) | 0;
        lo = lo + Math.imul(al2, bl2) | 0;
        mid = mid + Math.imul(al2, bh2) | 0;
        mid = mid + Math.imul(ah2, bl2) | 0;
        hi = hi + Math.imul(ah2, bh2) | 0;
        lo = lo + Math.imul(al1, bl3) | 0;
        mid = mid + Math.imul(al1, bh3) | 0;
        mid = mid + Math.imul(ah1, bl3) | 0;
        hi = hi + Math.imul(ah1, bh3) | 0;
        lo = lo + Math.imul(al0, bl4) | 0;
        mid = mid + Math.imul(al0, bh4) | 0;
        mid = mid + Math.imul(ah0, bl4) | 0;
        hi = hi + Math.imul(ah0, bh4) | 0;
        var w4 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w4 >>> 26) | 0;
        w4 &= 0x3ffffff;
        /* k = 5 */ lo = Math.imul(al5, bl0);
        mid = Math.imul(al5, bh0);
        mid = mid + Math.imul(ah5, bl0) | 0;
        hi = Math.imul(ah5, bh0);
        lo = lo + Math.imul(al4, bl1) | 0;
        mid = mid + Math.imul(al4, bh1) | 0;
        mid = mid + Math.imul(ah4, bl1) | 0;
        hi = hi + Math.imul(ah4, bh1) | 0;
        lo = lo + Math.imul(al3, bl2) | 0;
        mid = mid + Math.imul(al3, bh2) | 0;
        mid = mid + Math.imul(ah3, bl2) | 0;
        hi = hi + Math.imul(ah3, bh2) | 0;
        lo = lo + Math.imul(al2, bl3) | 0;
        mid = mid + Math.imul(al2, bh3) | 0;
        mid = mid + Math.imul(ah2, bl3) | 0;
        hi = hi + Math.imul(ah2, bh3) | 0;
        lo = lo + Math.imul(al1, bl4) | 0;
        mid = mid + Math.imul(al1, bh4) | 0;
        mid = mid + Math.imul(ah1, bl4) | 0;
        hi = hi + Math.imul(ah1, bh4) | 0;
        lo = lo + Math.imul(al0, bl5) | 0;
        mid = mid + Math.imul(al0, bh5) | 0;
        mid = mid + Math.imul(ah0, bl5) | 0;
        hi = hi + Math.imul(ah0, bh5) | 0;
        var w5 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w5 >>> 26) | 0;
        w5 &= 0x3ffffff;
        /* k = 6 */ lo = Math.imul(al6, bl0);
        mid = Math.imul(al6, bh0);
        mid = mid + Math.imul(ah6, bl0) | 0;
        hi = Math.imul(ah6, bh0);
        lo = lo + Math.imul(al5, bl1) | 0;
        mid = mid + Math.imul(al5, bh1) | 0;
        mid = mid + Math.imul(ah5, bl1) | 0;
        hi = hi + Math.imul(ah5, bh1) | 0;
        lo = lo + Math.imul(al4, bl2) | 0;
        mid = mid + Math.imul(al4, bh2) | 0;
        mid = mid + Math.imul(ah4, bl2) | 0;
        hi = hi + Math.imul(ah4, bh2) | 0;
        lo = lo + Math.imul(al3, bl3) | 0;
        mid = mid + Math.imul(al3, bh3) | 0;
        mid = mid + Math.imul(ah3, bl3) | 0;
        hi = hi + Math.imul(ah3, bh3) | 0;
        lo = lo + Math.imul(al2, bl4) | 0;
        mid = mid + Math.imul(al2, bh4) | 0;
        mid = mid + Math.imul(ah2, bl4) | 0;
        hi = hi + Math.imul(ah2, bh4) | 0;
        lo = lo + Math.imul(al1, bl5) | 0;
        mid = mid + Math.imul(al1, bh5) | 0;
        mid = mid + Math.imul(ah1, bl5) | 0;
        hi = hi + Math.imul(ah1, bh5) | 0;
        lo = lo + Math.imul(al0, bl6) | 0;
        mid = mid + Math.imul(al0, bh6) | 0;
        mid = mid + Math.imul(ah0, bl6) | 0;
        hi = hi + Math.imul(ah0, bh6) | 0;
        var w6 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w6 >>> 26) | 0;
        w6 &= 0x3ffffff;
        /* k = 7 */ lo = Math.imul(al7, bl0);
        mid = Math.imul(al7, bh0);
        mid = mid + Math.imul(ah7, bl0) | 0;
        hi = Math.imul(ah7, bh0);
        lo = lo + Math.imul(al6, bl1) | 0;
        mid = mid + Math.imul(al6, bh1) | 0;
        mid = mid + Math.imul(ah6, bl1) | 0;
        hi = hi + Math.imul(ah6, bh1) | 0;
        lo = lo + Math.imul(al5, bl2) | 0;
        mid = mid + Math.imul(al5, bh2) | 0;
        mid = mid + Math.imul(ah5, bl2) | 0;
        hi = hi + Math.imul(ah5, bh2) | 0;
        lo = lo + Math.imul(al4, bl3) | 0;
        mid = mid + Math.imul(al4, bh3) | 0;
        mid = mid + Math.imul(ah4, bl3) | 0;
        hi = hi + Math.imul(ah4, bh3) | 0;
        lo = lo + Math.imul(al3, bl4) | 0;
        mid = mid + Math.imul(al3, bh4) | 0;
        mid = mid + Math.imul(ah3, bl4) | 0;
        hi = hi + Math.imul(ah3, bh4) | 0;
        lo = lo + Math.imul(al2, bl5) | 0;
        mid = mid + Math.imul(al2, bh5) | 0;
        mid = mid + Math.imul(ah2, bl5) | 0;
        hi = hi + Math.imul(ah2, bh5) | 0;
        lo = lo + Math.imul(al1, bl6) | 0;
        mid = mid + Math.imul(al1, bh6) | 0;
        mid = mid + Math.imul(ah1, bl6) | 0;
        hi = hi + Math.imul(ah1, bh6) | 0;
        lo = lo + Math.imul(al0, bl7) | 0;
        mid = mid + Math.imul(al0, bh7) | 0;
        mid = mid + Math.imul(ah0, bl7) | 0;
        hi = hi + Math.imul(ah0, bh7) | 0;
        var w7 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w7 >>> 26) | 0;
        w7 &= 0x3ffffff;
        /* k = 8 */ lo = Math.imul(al8, bl0);
        mid = Math.imul(al8, bh0);
        mid = mid + Math.imul(ah8, bl0) | 0;
        hi = Math.imul(ah8, bh0);
        lo = lo + Math.imul(al7, bl1) | 0;
        mid = mid + Math.imul(al7, bh1) | 0;
        mid = mid + Math.imul(ah7, bl1) | 0;
        hi = hi + Math.imul(ah7, bh1) | 0;
        lo = lo + Math.imul(al6, bl2) | 0;
        mid = mid + Math.imul(al6, bh2) | 0;
        mid = mid + Math.imul(ah6, bl2) | 0;
        hi = hi + Math.imul(ah6, bh2) | 0;
        lo = lo + Math.imul(al5, bl3) | 0;
        mid = mid + Math.imul(al5, bh3) | 0;
        mid = mid + Math.imul(ah5, bl3) | 0;
        hi = hi + Math.imul(ah5, bh3) | 0;
        lo = lo + Math.imul(al4, bl4) | 0;
        mid = mid + Math.imul(al4, bh4) | 0;
        mid = mid + Math.imul(ah4, bl4) | 0;
        hi = hi + Math.imul(ah4, bh4) | 0;
        lo = lo + Math.imul(al3, bl5) | 0;
        mid = mid + Math.imul(al3, bh5) | 0;
        mid = mid + Math.imul(ah3, bl5) | 0;
        hi = hi + Math.imul(ah3, bh5) | 0;
        lo = lo + Math.imul(al2, bl6) | 0;
        mid = mid + Math.imul(al2, bh6) | 0;
        mid = mid + Math.imul(ah2, bl6) | 0;
        hi = hi + Math.imul(ah2, bh6) | 0;
        lo = lo + Math.imul(al1, bl7) | 0;
        mid = mid + Math.imul(al1, bh7) | 0;
        mid = mid + Math.imul(ah1, bl7) | 0;
        hi = hi + Math.imul(ah1, bh7) | 0;
        lo = lo + Math.imul(al0, bl8) | 0;
        mid = mid + Math.imul(al0, bh8) | 0;
        mid = mid + Math.imul(ah0, bl8) | 0;
        hi = hi + Math.imul(ah0, bh8) | 0;
        var w8 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w8 >>> 26) | 0;
        w8 &= 0x3ffffff;
        /* k = 9 */ lo = Math.imul(al9, bl0);
        mid = Math.imul(al9, bh0);
        mid = mid + Math.imul(ah9, bl0) | 0;
        hi = Math.imul(ah9, bh0);
        lo = lo + Math.imul(al8, bl1) | 0;
        mid = mid + Math.imul(al8, bh1) | 0;
        mid = mid + Math.imul(ah8, bl1) | 0;
        hi = hi + Math.imul(ah8, bh1) | 0;
        lo = lo + Math.imul(al7, bl2) | 0;
        mid = mid + Math.imul(al7, bh2) | 0;
        mid = mid + Math.imul(ah7, bl2) | 0;
        hi = hi + Math.imul(ah7, bh2) | 0;
        lo = lo + Math.imul(al6, bl3) | 0;
        mid = mid + Math.imul(al6, bh3) | 0;
        mid = mid + Math.imul(ah6, bl3) | 0;
        hi = hi + Math.imul(ah6, bh3) | 0;
        lo = lo + Math.imul(al5, bl4) | 0;
        mid = mid + Math.imul(al5, bh4) | 0;
        mid = mid + Math.imul(ah5, bl4) | 0;
        hi = hi + Math.imul(ah5, bh4) | 0;
        lo = lo + Math.imul(al4, bl5) | 0;
        mid = mid + Math.imul(al4, bh5) | 0;
        mid = mid + Math.imul(ah4, bl5) | 0;
        hi = hi + Math.imul(ah4, bh5) | 0;
        lo = lo + Math.imul(al3, bl6) | 0;
        mid = mid + Math.imul(al3, bh6) | 0;
        mid = mid + Math.imul(ah3, bl6) | 0;
        hi = hi + Math.imul(ah3, bh6) | 0;
        lo = lo + Math.imul(al2, bl7) | 0;
        mid = mid + Math.imul(al2, bh7) | 0;
        mid = mid + Math.imul(ah2, bl7) | 0;
        hi = hi + Math.imul(ah2, bh7) | 0;
        lo = lo + Math.imul(al1, bl8) | 0;
        mid = mid + Math.imul(al1, bh8) | 0;
        mid = mid + Math.imul(ah1, bl8) | 0;
        hi = hi + Math.imul(ah1, bh8) | 0;
        lo = lo + Math.imul(al0, bl9) | 0;
        mid = mid + Math.imul(al0, bh9) | 0;
        mid = mid + Math.imul(ah0, bl9) | 0;
        hi = hi + Math.imul(ah0, bh9) | 0;
        var w9 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w9 >>> 26) | 0;
        w9 &= 0x3ffffff;
        /* k = 10 */ lo = Math.imul(al9, bl1);
        mid = Math.imul(al9, bh1);
        mid = mid + Math.imul(ah9, bl1) | 0;
        hi = Math.imul(ah9, bh1);
        lo = lo + Math.imul(al8, bl2) | 0;
        mid = mid + Math.imul(al8, bh2) | 0;
        mid = mid + Math.imul(ah8, bl2) | 0;
        hi = hi + Math.imul(ah8, bh2) | 0;
        lo = lo + Math.imul(al7, bl3) | 0;
        mid = mid + Math.imul(al7, bh3) | 0;
        mid = mid + Math.imul(ah7, bl3) | 0;
        hi = hi + Math.imul(ah7, bh3) | 0;
        lo = lo + Math.imul(al6, bl4) | 0;
        mid = mid + Math.imul(al6, bh4) | 0;
        mid = mid + Math.imul(ah6, bl4) | 0;
        hi = hi + Math.imul(ah6, bh4) | 0;
        lo = lo + Math.imul(al5, bl5) | 0;
        mid = mid + Math.imul(al5, bh5) | 0;
        mid = mid + Math.imul(ah5, bl5) | 0;
        hi = hi + Math.imul(ah5, bh5) | 0;
        lo = lo + Math.imul(al4, bl6) | 0;
        mid = mid + Math.imul(al4, bh6) | 0;
        mid = mid + Math.imul(ah4, bl6) | 0;
        hi = hi + Math.imul(ah4, bh6) | 0;
        lo = lo + Math.imul(al3, bl7) | 0;
        mid = mid + Math.imul(al3, bh7) | 0;
        mid = mid + Math.imul(ah3, bl7) | 0;
        hi = hi + Math.imul(ah3, bh7) | 0;
        lo = lo + Math.imul(al2, bl8) | 0;
        mid = mid + Math.imul(al2, bh8) | 0;
        mid = mid + Math.imul(ah2, bl8) | 0;
        hi = hi + Math.imul(ah2, bh8) | 0;
        lo = lo + Math.imul(al1, bl9) | 0;
        mid = mid + Math.imul(al1, bh9) | 0;
        mid = mid + Math.imul(ah1, bl9) | 0;
        hi = hi + Math.imul(ah1, bh9) | 0;
        var w10 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w10 >>> 26) | 0;
        w10 &= 0x3ffffff;
        /* k = 11 */ lo = Math.imul(al9, bl2);
        mid = Math.imul(al9, bh2);
        mid = mid + Math.imul(ah9, bl2) | 0;
        hi = Math.imul(ah9, bh2);
        lo = lo + Math.imul(al8, bl3) | 0;
        mid = mid + Math.imul(al8, bh3) | 0;
        mid = mid + Math.imul(ah8, bl3) | 0;
        hi = hi + Math.imul(ah8, bh3) | 0;
        lo = lo + Math.imul(al7, bl4) | 0;
        mid = mid + Math.imul(al7, bh4) | 0;
        mid = mid + Math.imul(ah7, bl4) | 0;
        hi = hi + Math.imul(ah7, bh4) | 0;
        lo = lo + Math.imul(al6, bl5) | 0;
        mid = mid + Math.imul(al6, bh5) | 0;
        mid = mid + Math.imul(ah6, bl5) | 0;
        hi = hi + Math.imul(ah6, bh5) | 0;
        lo = lo + Math.imul(al5, bl6) | 0;
        mid = mid + Math.imul(al5, bh6) | 0;
        mid = mid + Math.imul(ah5, bl6) | 0;
        hi = hi + Math.imul(ah5, bh6) | 0;
        lo = lo + Math.imul(al4, bl7) | 0;
        mid = mid + Math.imul(al4, bh7) | 0;
        mid = mid + Math.imul(ah4, bl7) | 0;
        hi = hi + Math.imul(ah4, bh7) | 0;
        lo = lo + Math.imul(al3, bl8) | 0;
        mid = mid + Math.imul(al3, bh8) | 0;
        mid = mid + Math.imul(ah3, bl8) | 0;
        hi = hi + Math.imul(ah3, bh8) | 0;
        lo = lo + Math.imul(al2, bl9) | 0;
        mid = mid + Math.imul(al2, bh9) | 0;
        mid = mid + Math.imul(ah2, bl9) | 0;
        hi = hi + Math.imul(ah2, bh9) | 0;
        var w11 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w11 >>> 26) | 0;
        w11 &= 0x3ffffff;
        /* k = 12 */ lo = Math.imul(al9, bl3);
        mid = Math.imul(al9, bh3);
        mid = mid + Math.imul(ah9, bl3) | 0;
        hi = Math.imul(ah9, bh3);
        lo = lo + Math.imul(al8, bl4) | 0;
        mid = mid + Math.imul(al8, bh4) | 0;
        mid = mid + Math.imul(ah8, bl4) | 0;
        hi = hi + Math.imul(ah8, bh4) | 0;
        lo = lo + Math.imul(al7, bl5) | 0;
        mid = mid + Math.imul(al7, bh5) | 0;
        mid = mid + Math.imul(ah7, bl5) | 0;
        hi = hi + Math.imul(ah7, bh5) | 0;
        lo = lo + Math.imul(al6, bl6) | 0;
        mid = mid + Math.imul(al6, bh6) | 0;
        mid = mid + Math.imul(ah6, bl6) | 0;
        hi = hi + Math.imul(ah6, bh6) | 0;
        lo = lo + Math.imul(al5, bl7) | 0;
        mid = mid + Math.imul(al5, bh7) | 0;
        mid = mid + Math.imul(ah5, bl7) | 0;
        hi = hi + Math.imul(ah5, bh7) | 0;
        lo = lo + Math.imul(al4, bl8) | 0;
        mid = mid + Math.imul(al4, bh8) | 0;
        mid = mid + Math.imul(ah4, bl8) | 0;
        hi = hi + Math.imul(ah4, bh8) | 0;
        lo = lo + Math.imul(al3, bl9) | 0;
        mid = mid + Math.imul(al3, bh9) | 0;
        mid = mid + Math.imul(ah3, bl9) | 0;
        hi = hi + Math.imul(ah3, bh9) | 0;
        var w12 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w12 >>> 26) | 0;
        w12 &= 0x3ffffff;
        /* k = 13 */ lo = Math.imul(al9, bl4);
        mid = Math.imul(al9, bh4);
        mid = mid + Math.imul(ah9, bl4) | 0;
        hi = Math.imul(ah9, bh4);
        lo = lo + Math.imul(al8, bl5) | 0;
        mid = mid + Math.imul(al8, bh5) | 0;
        mid = mid + Math.imul(ah8, bl5) | 0;
        hi = hi + Math.imul(ah8, bh5) | 0;
        lo = lo + Math.imul(al7, bl6) | 0;
        mid = mid + Math.imul(al7, bh6) | 0;
        mid = mid + Math.imul(ah7, bl6) | 0;
        hi = hi + Math.imul(ah7, bh6) | 0;
        lo = lo + Math.imul(al6, bl7) | 0;
        mid = mid + Math.imul(al6, bh7) | 0;
        mid = mid + Math.imul(ah6, bl7) | 0;
        hi = hi + Math.imul(ah6, bh7) | 0;
        lo = lo + Math.imul(al5, bl8) | 0;
        mid = mid + Math.imul(al5, bh8) | 0;
        mid = mid + Math.imul(ah5, bl8) | 0;
        hi = hi + Math.imul(ah5, bh8) | 0;
        lo = lo + Math.imul(al4, bl9) | 0;
        mid = mid + Math.imul(al4, bh9) | 0;
        mid = mid + Math.imul(ah4, bl9) | 0;
        hi = hi + Math.imul(ah4, bh9) | 0;
        var w13 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w13 >>> 26) | 0;
        w13 &= 0x3ffffff;
        /* k = 14 */ lo = Math.imul(al9, bl5);
        mid = Math.imul(al9, bh5);
        mid = mid + Math.imul(ah9, bl5) | 0;
        hi = Math.imul(ah9, bh5);
        lo = lo + Math.imul(al8, bl6) | 0;
        mid = mid + Math.imul(al8, bh6) | 0;
        mid = mid + Math.imul(ah8, bl6) | 0;
        hi = hi + Math.imul(ah8, bh6) | 0;
        lo = lo + Math.imul(al7, bl7) | 0;
        mid = mid + Math.imul(al7, bh7) | 0;
        mid = mid + Math.imul(ah7, bl7) | 0;
        hi = hi + Math.imul(ah7, bh7) | 0;
        lo = lo + Math.imul(al6, bl8) | 0;
        mid = mid + Math.imul(al6, bh8) | 0;
        mid = mid + Math.imul(ah6, bl8) | 0;
        hi = hi + Math.imul(ah6, bh8) | 0;
        lo = lo + Math.imul(al5, bl9) | 0;
        mid = mid + Math.imul(al5, bh9) | 0;
        mid = mid + Math.imul(ah5, bl9) | 0;
        hi = hi + Math.imul(ah5, bh9) | 0;
        var w14 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w14 >>> 26) | 0;
        w14 &= 0x3ffffff;
        /* k = 15 */ lo = Math.imul(al9, bl6);
        mid = Math.imul(al9, bh6);
        mid = mid + Math.imul(ah9, bl6) | 0;
        hi = Math.imul(ah9, bh6);
        lo = lo + Math.imul(al8, bl7) | 0;
        mid = mid + Math.imul(al8, bh7) | 0;
        mid = mid + Math.imul(ah8, bl7) | 0;
        hi = hi + Math.imul(ah8, bh7) | 0;
        lo = lo + Math.imul(al7, bl8) | 0;
        mid = mid + Math.imul(al7, bh8) | 0;
        mid = mid + Math.imul(ah7, bl8) | 0;
        hi = hi + Math.imul(ah7, bh8) | 0;
        lo = lo + Math.imul(al6, bl9) | 0;
        mid = mid + Math.imul(al6, bh9) | 0;
        mid = mid + Math.imul(ah6, bl9) | 0;
        hi = hi + Math.imul(ah6, bh9) | 0;
        var w15 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w15 >>> 26) | 0;
        w15 &= 0x3ffffff;
        /* k = 16 */ lo = Math.imul(al9, bl7);
        mid = Math.imul(al9, bh7);
        mid = mid + Math.imul(ah9, bl7) | 0;
        hi = Math.imul(ah9, bh7);
        lo = lo + Math.imul(al8, bl8) | 0;
        mid = mid + Math.imul(al8, bh8) | 0;
        mid = mid + Math.imul(ah8, bl8) | 0;
        hi = hi + Math.imul(ah8, bh8) | 0;
        lo = lo + Math.imul(al7, bl9) | 0;
        mid = mid + Math.imul(al7, bh9) | 0;
        mid = mid + Math.imul(ah7, bl9) | 0;
        hi = hi + Math.imul(ah7, bh9) | 0;
        var w16 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w16 >>> 26) | 0;
        w16 &= 0x3ffffff;
        /* k = 17 */ lo = Math.imul(al9, bl8);
        mid = Math.imul(al9, bh8);
        mid = mid + Math.imul(ah9, bl8) | 0;
        hi = Math.imul(ah9, bh8);
        lo = lo + Math.imul(al8, bl9) | 0;
        mid = mid + Math.imul(al8, bh9) | 0;
        mid = mid + Math.imul(ah8, bl9) | 0;
        hi = hi + Math.imul(ah8, bh9) | 0;
        var w17 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w17 >>> 26) | 0;
        w17 &= 0x3ffffff;
        /* k = 18 */ lo = Math.imul(al9, bl9);
        mid = Math.imul(al9, bh9);
        mid = mid + Math.imul(ah9, bl9) | 0;
        hi = Math.imul(ah9, bh9);
        var w18 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w18 >>> 26) | 0;
        w18 &= 0x3ffffff;
        o[0] = w0;
        o[1] = w1;
        o[2] = w2;
        o[3] = w3;
        o[4] = w4;
        o[5] = w5;
        o[6] = w6;
        o[7] = w7;
        o[8] = w8;
        o[9] = w9;
        o[10] = w10;
        o[11] = w11;
        o[12] = w12;
        o[13] = w13;
        o[14] = w14;
        o[15] = w15;
        o[16] = w16;
        o[17] = w17;
        o[18] = w18;
        if (c !== 0) {
            o[19] = c;
            out.length++;
        }
        return out;
    };
    // Polyfill comb
    if (!Math.imul) comb10MulTo = smallMulTo;
    function bigMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        out.length = self.length + num.length;
        var carry = 0;
        var hncarry = 0;
        for(var k = 0; k < out.length - 1; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = hncarry;
            hncarry = 0;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j;
                var a = self.words[i] | 0;
                var b = num.words[j] | 0;
                var r = a * b;
                var lo = r & 0x3ffffff;
                ncarry = ncarry + (r / 0x4000000 | 0) | 0;
                lo = lo + rword | 0;
                rword = lo & 0x3ffffff;
                ncarry = ncarry + (lo >>> 26) | 0;
                hncarry += ncarry >>> 26;
                ncarry &= 0x3ffffff;
            }
            out.words[k] = rword;
            carry = ncarry;
            ncarry = hncarry;
        }
        if (carry !== 0) out.words[k] = carry;
        else out.length--;
        return out.strip();
    }
    function jumboMulTo(self, num, out) {
        var fftm = new FFTM();
        return fftm.mulp(self, num, out);
    }
    BN.prototype.mulTo = function mulTo(num, out) {
        var res;
        var len = this.length + num.length;
        if (this.length === 10 && num.length === 10) res = comb10MulTo(this, num, out);
        else if (len < 63) res = smallMulTo(this, num, out);
        else if (len < 1024) res = bigMulTo(this, num, out);
        else res = jumboMulTo(this, num, out);
        return res;
    };
    // Cooley-Tukey algorithm for FFT
    // slightly revisited to rely on looping instead of recursion
    function FFTM(x, y) {
        this.x = x;
        this.y = y;
    }
    FFTM.prototype.makeRBT = function makeRBT(N) {
        var t = new Array(N);
        var l = BN.prototype._countBits(N) - 1;
        for(var i = 0; i < N; i++)t[i] = this.revBin(i, l, N);
        return t;
    };
    // Returns binary-reversed representation of `x`
    FFTM.prototype.revBin = function revBin(x, l, N) {
        if (x === 0 || x === N - 1) return x;
        var rb = 0;
        for(var i = 0; i < l; i++){
            rb |= (x & 1) << l - i - 1;
            x >>= 1;
        }
        return rb;
    };
    // Performs "tweedling" phase, therefore 'emulating'
    // behaviour of the recursive algorithm
    FFTM.prototype.permute = function permute(rbt, rws, iws, rtws, itws, N) {
        for(var i = 0; i < N; i++){
            rtws[i] = rws[rbt[i]];
            itws[i] = iws[rbt[i]];
        }
    };
    FFTM.prototype.transform = function transform(rws, iws, rtws, itws, N, rbt) {
        this.permute(rbt, rws, iws, rtws, itws, N);
        for(var s = 1; s < N; s <<= 1){
            var l = s << 1;
            var rtwdf = Math.cos(2 * Math.PI / l);
            var itwdf = Math.sin(2 * Math.PI / l);
            for(var p = 0; p < N; p += l){
                var rtwdf_ = rtwdf;
                var itwdf_ = itwdf;
                for(var j = 0; j < s; j++){
                    var re = rtws[p + j];
                    var ie = itws[p + j];
                    var ro = rtws[p + j + s];
                    var io = itws[p + j + s];
                    var rx = rtwdf_ * ro - itwdf_ * io;
                    io = rtwdf_ * io + itwdf_ * ro;
                    ro = rx;
                    rtws[p + j] = re + ro;
                    itws[p + j] = ie + io;
                    rtws[p + j + s] = re - ro;
                    itws[p + j + s] = ie - io;
                    /* jshint maxdepth : false */ if (j !== l) {
                        rx = rtwdf * rtwdf_ - itwdf * itwdf_;
                        itwdf_ = rtwdf * itwdf_ + itwdf * rtwdf_;
                        rtwdf_ = rx;
                    }
                }
            }
        }
    };
    FFTM.prototype.guessLen13b = function guessLen13b(n, m) {
        var N = Math.max(m, n) | 1;
        var odd = N & 1;
        var i = 0;
        for(N = N / 2 | 0; N; N = N >>> 1)i++;
        return 1 << i + 1 + odd;
    };
    FFTM.prototype.conjugate = function conjugate(rws, iws, N) {
        if (N <= 1) return;
        for(var i = 0; i < N / 2; i++){
            var t = rws[i];
            rws[i] = rws[N - i - 1];
            rws[N - i - 1] = t;
            t = iws[i];
            iws[i] = -iws[N - i - 1];
            iws[N - i - 1] = -t;
        }
    };
    FFTM.prototype.normalize13b = function normalize13b(ws, N) {
        var carry = 0;
        for(var i = 0; i < N / 2; i++){
            var w = Math.round(ws[2 * i + 1] / N) * 0x2000 + Math.round(ws[2 * i] / N) + carry;
            ws[i] = w & 0x3ffffff;
            if (w < 0x4000000) carry = 0;
            else carry = w / 0x4000000 | 0;
        }
        return ws;
    };
    FFTM.prototype.convert13b = function convert13b(ws, len, rws, N) {
        var carry = 0;
        for(var i = 0; i < len; i++){
            carry = carry + (ws[i] | 0);
            rws[2 * i] = carry & 0x1fff;
            carry = carry >>> 13;
            rws[2 * i + 1] = carry & 0x1fff;
            carry = carry >>> 13;
        }
        // Pad with zeroes
        for(i = 2 * len; i < N; ++i)rws[i] = 0;
        assert(carry === 0);
        assert((carry & -8192) === 0);
    };
    FFTM.prototype.stub = function stub(N) {
        var ph = new Array(N);
        for(var i = 0; i < N; i++)ph[i] = 0;
        return ph;
    };
    FFTM.prototype.mulp = function mulp(x, y, out) {
        var N = 2 * this.guessLen13b(x.length, y.length);
        var rbt = this.makeRBT(N);
        var _ = this.stub(N);
        var rws = new Array(N);
        var rwst = new Array(N);
        var iwst = new Array(N);
        var nrws = new Array(N);
        var nrwst = new Array(N);
        var niwst = new Array(N);
        var rmws = out.words;
        rmws.length = N;
        this.convert13b(x.words, x.length, rws, N);
        this.convert13b(y.words, y.length, nrws, N);
        this.transform(rws, _, rwst, iwst, N, rbt);
        this.transform(nrws, _, nrwst, niwst, N, rbt);
        for(var i = 0; i < N; i++){
            var rx = rwst[i] * nrwst[i] - iwst[i] * niwst[i];
            iwst[i] = rwst[i] * niwst[i] + iwst[i] * nrwst[i];
            rwst[i] = rx;
        }
        this.conjugate(rwst, iwst, N);
        this.transform(rwst, iwst, rmws, _, N, rbt);
        this.conjugate(rmws, _, N);
        this.normalize13b(rmws, N);
        out.negative = x.negative ^ y.negative;
        out.length = x.length + y.length;
        return out.strip();
    };
    // Multiply `this` by `num`
    BN.prototype.mul = function mul(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return this.mulTo(num, out);
    };
    // Multiply employing FFT
    BN.prototype.mulf = function mulf(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return jumboMulTo(this, num, out);
    };
    // In-place Multiplication
    BN.prototype.imul = function imul(num) {
        return this.clone().mulTo(num, this);
    };
    BN.prototype.imuln = function imuln(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        // Carry
        var carry = 0;
        for(var i = 0; i < this.length; i++){
            var w = (this.words[i] | 0) * num;
            var lo = (w & 0x3ffffff) + (carry & 0x3ffffff);
            carry >>= 26;
            carry += w / 0x4000000 | 0;
            // NOTE: lo is 27bit maximum
            carry += lo >>> 26;
            this.words[i] = lo & 0x3ffffff;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return this;
    };
    BN.prototype.muln = function muln(num) {
        return this.clone().imuln(num);
    };
    // `this` * `this`
    BN.prototype.sqr = function sqr() {
        return this.mul(this);
    };
    // `this` * `this` in-place
    BN.prototype.isqr = function isqr() {
        return this.imul(this.clone());
    };
    // Math.pow(`this`, `num`)
    BN.prototype.pow = function pow(num) {
        var w = toBitArray(num);
        if (w.length === 0) return new BN(1);
        // Skip leading zeroes
        var res = this;
        for(var i = 0; i < w.length; i++, res = res.sqr()){
            if (w[i] !== 0) break;
        }
        if (++i < w.length) for(var q = res.sqr(); i < w.length; i++, q = q.sqr()){
            if (w[i] === 0) continue;
            res = res.mul(q);
        }
        return res;
    };
    // Shift-left in-place
    BN.prototype.iushln = function iushln(bits) {
        assert(typeof bits === "number" && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        var carryMask = 0x3ffffff >>> 26 - r << 26 - r;
        var i;
        if (r !== 0) {
            var carry = 0;
            for(i = 0; i < this.length; i++){
                var newCarry = this.words[i] & carryMask;
                var c = (this.words[i] | 0) - newCarry << r;
                this.words[i] = c | carry;
                carry = newCarry >>> 26 - r;
            }
            if (carry) {
                this.words[i] = carry;
                this.length++;
            }
        }
        if (s !== 0) {
            for(i = this.length - 1; i >= 0; i--)this.words[i + s] = this.words[i];
            for(i = 0; i < s; i++)this.words[i] = 0;
            this.length += s;
        }
        return this.strip();
    };
    BN.prototype.ishln = function ishln(bits) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushln(bits);
    };
    // Shift-right in-place
    // NOTE: `hint` is a lowest bit before trailing zeroes
    // NOTE: if `extended` is present - it will be filled with destroyed bits
    BN.prototype.iushrn = function iushrn(bits, hint, extended) {
        assert(typeof bits === "number" && bits >= 0);
        var h;
        if (hint) h = (hint - hint % 26) / 26;
        else h = 0;
        var r = bits % 26;
        var s = Math.min((bits - r) / 26, this.length);
        var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
        var maskedWords = extended;
        h -= s;
        h = Math.max(0, h);
        // Extended mode, copy masked part
        if (maskedWords) {
            for(var i = 0; i < s; i++)maskedWords.words[i] = this.words[i];
            maskedWords.length = s;
        }
        if (s === 0) ;
        else if (this.length > s) {
            this.length -= s;
            for(i = 0; i < this.length; i++)this.words[i] = this.words[i + s];
        } else {
            this.words[0] = 0;
            this.length = 1;
        }
        var carry = 0;
        for(i = this.length - 1; i >= 0 && (carry !== 0 || i >= h); i--){
            var word = this.words[i] | 0;
            this.words[i] = carry << 26 - r | word >>> r;
            carry = word & mask;
        }
        // Push carried bits as a mask
        if (maskedWords && carry !== 0) maskedWords.words[maskedWords.length++] = carry;
        if (this.length === 0) {
            this.words[0] = 0;
            this.length = 1;
        }
        return this.strip();
    };
    BN.prototype.ishrn = function ishrn(bits, hint, extended) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushrn(bits, hint, extended);
    };
    // Shift-left
    BN.prototype.shln = function shln(bits) {
        return this.clone().ishln(bits);
    };
    BN.prototype.ushln = function ushln(bits) {
        return this.clone().iushln(bits);
    };
    // Shift-right
    BN.prototype.shrn = function shrn(bits) {
        return this.clone().ishrn(bits);
    };
    BN.prototype.ushrn = function ushrn(bits) {
        return this.clone().iushrn(bits);
    };
    // Test if n bit is set
    BN.prototype.testn = function testn(bit) {
        assert(typeof bit === "number" && bit >= 0);
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) return false;
        // Check bit and return
        var w = this.words[s];
        return !!(w & q);
    };
    // Return only lowers bits of number (in-place)
    BN.prototype.imaskn = function imaskn(bits) {
        assert(typeof bits === "number" && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        assert(this.negative === 0, "imaskn works only with positive numbers");
        if (this.length <= s) return this;
        if (r !== 0) s++;
        this.length = Math.min(s, this.length);
        if (r !== 0) {
            var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
            this.words[this.length - 1] &= mask;
        }
        return this.strip();
    };
    // Return only lowers bits of number
    BN.prototype.maskn = function maskn(bits) {
        return this.clone().imaskn(bits);
    };
    // Add plain number `num` to `this`
    BN.prototype.iaddn = function iaddn(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        if (num < 0) return this.isubn(-num);
        // Possible sign change
        if (this.negative !== 0) {
            if (this.length === 1 && (this.words[0] | 0) < num) {
                this.words[0] = num - (this.words[0] | 0);
                this.negative = 0;
                return this;
            }
            this.negative = 0;
            this.isubn(num);
            this.negative = 1;
            return this;
        }
        // Add without checks
        return this._iaddn(num);
    };
    BN.prototype._iaddn = function _iaddn(num) {
        this.words[0] += num;
        // Carry
        for(var i = 0; i < this.length && this.words[i] >= 0x4000000; i++){
            this.words[i] -= 0x4000000;
            if (i === this.length - 1) this.words[i + 1] = 1;
            else this.words[i + 1]++;
        }
        this.length = Math.max(this.length, i + 1);
        return this;
    };
    // Subtract plain number `num` from `this`
    BN.prototype.isubn = function isubn(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        if (num < 0) return this.iaddn(-num);
        if (this.negative !== 0) {
            this.negative = 0;
            this.iaddn(num);
            this.negative = 1;
            return this;
        }
        this.words[0] -= num;
        if (this.length === 1 && this.words[0] < 0) {
            this.words[0] = -this.words[0];
            this.negative = 1;
        } else // Carry
        for(var i = 0; i < this.length && this.words[i] < 0; i++){
            this.words[i] += 0x4000000;
            this.words[i + 1] -= 1;
        }
        return this.strip();
    };
    BN.prototype.addn = function addn(num) {
        return this.clone().iaddn(num);
    };
    BN.prototype.subn = function subn(num) {
        return this.clone().isubn(num);
    };
    BN.prototype.iabs = function iabs() {
        this.negative = 0;
        return this;
    };
    BN.prototype.abs = function abs() {
        return this.clone().iabs();
    };
    BN.prototype._ishlnsubmul = function _ishlnsubmul(num, mul, shift) {
        var len = num.length + shift;
        var i;
        this._expand(len);
        var w;
        var carry = 0;
        for(i = 0; i < num.length; i++){
            w = (this.words[i + shift] | 0) + carry;
            var right = (num.words[i] | 0) * mul;
            w -= right & 0x3ffffff;
            carry = (w >> 26) - (right / 0x4000000 | 0);
            this.words[i + shift] = w & 0x3ffffff;
        }
        for(; i < this.length - shift; i++){
            w = (this.words[i + shift] | 0) + carry;
            carry = w >> 26;
            this.words[i + shift] = w & 0x3ffffff;
        }
        if (carry === 0) return this.strip();
        // Subtraction overflow
        assert(carry === -1);
        carry = 0;
        for(i = 0; i < this.length; i++){
            w = -(this.words[i] | 0) + carry;
            carry = w >> 26;
            this.words[i] = w & 0x3ffffff;
        }
        this.negative = 1;
        return this.strip();
    };
    BN.prototype._wordDiv = function _wordDiv(num, mode) {
        var shift = this.length - num.length;
        var a = this.clone();
        var b = num;
        // Normalize
        var bhi = b.words[b.length - 1] | 0;
        var bhiBits = this._countBits(bhi);
        shift = 26 - bhiBits;
        if (shift !== 0) {
            b = b.ushln(shift);
            a.iushln(shift);
            bhi = b.words[b.length - 1] | 0;
        }
        // Initialize quotient
        var m = a.length - b.length;
        var q;
        if (mode !== "mod") {
            q = new BN(null);
            q.length = m + 1;
            q.words = new Array(q.length);
            for(var i = 0; i < q.length; i++)q.words[i] = 0;
        }
        var diff = a.clone()._ishlnsubmul(b, 1, m);
        if (diff.negative === 0) {
            a = diff;
            if (q) q.words[m] = 1;
        }
        for(var j = m - 1; j >= 0; j--){
            var qj = (a.words[b.length + j] | 0) * 0x4000000 + (a.words[b.length + j - 1] | 0);
            // NOTE: (qj / bhi) is (0x3ffffff * 0x4000000 + 0x3ffffff) / 0x2000000 max
            // (0x7ffffff)
            qj = Math.min(qj / bhi | 0, 0x3ffffff);
            a._ishlnsubmul(b, qj, j);
            while(a.negative !== 0){
                qj--;
                a.negative = 0;
                a._ishlnsubmul(b, 1, j);
                if (!a.isZero()) a.negative ^= 1;
            }
            if (q) q.words[j] = qj;
        }
        if (q) q.strip();
        a.strip();
        // Denormalize
        if (mode !== "div" && shift !== 0) a.iushrn(shift);
        return {
            div: q || null,
            mod: a
        };
    };
    // NOTE: 1) `mode` can be set to `mod` to request mod only,
    //       to `div` to request div only, or be absent to
    //       request both div & mod
    //       2) `positive` is true if unsigned mod is requested
    BN.prototype.divmod = function divmod(num, mode, positive) {
        assert(!num.isZero());
        if (this.isZero()) return {
            div: new BN(0),
            mod: new BN(0)
        };
        var div, mod, res;
        if (this.negative !== 0 && num.negative === 0) {
            res = this.neg().divmod(num, mode);
            if (mode !== "mod") div = res.div.neg();
            if (mode !== "div") {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.iadd(num);
            }
            return {
                div: div,
                mod: mod
            };
        }
        if (this.negative === 0 && num.negative !== 0) {
            res = this.divmod(num.neg(), mode);
            if (mode !== "mod") div = res.div.neg();
            return {
                div: div,
                mod: res.mod
            };
        }
        if ((this.negative & num.negative) !== 0) {
            res = this.neg().divmod(num.neg(), mode);
            if (mode !== "div") {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.isub(num);
            }
            return {
                div: res.div,
                mod: mod
            };
        }
        // Both numbers are positive at this point
        // Strip both numbers to approximate shift value
        if (num.length > this.length || this.cmp(num) < 0) return {
            div: new BN(0),
            mod: this
        };
        // Very short reduction
        if (num.length === 1) {
            if (mode === "div") return {
                div: this.divn(num.words[0]),
                mod: null
            };
            if (mode === "mod") return {
                div: null,
                mod: new BN(this.modn(num.words[0]))
            };
            return {
                div: this.divn(num.words[0]),
                mod: new BN(this.modn(num.words[0]))
            };
        }
        return this._wordDiv(num, mode);
    };
    // Find `this` / `num`
    BN.prototype.div = function div(num) {
        return this.divmod(num, "div", false).div;
    };
    // Find `this` % `num`
    BN.prototype.mod = function mod(num) {
        return this.divmod(num, "mod", false).mod;
    };
    BN.prototype.umod = function umod(num) {
        return this.divmod(num, "mod", true).mod;
    };
    // Find Round(`this` / `num`)
    BN.prototype.divRound = function divRound(num) {
        var dm = this.divmod(num);
        // Fast case - exact division
        if (dm.mod.isZero()) return dm.div;
        var mod = dm.div.negative !== 0 ? dm.mod.isub(num) : dm.mod;
        var half = num.ushrn(1);
        var r2 = num.andln(1);
        var cmp = mod.cmp(half);
        // Round down
        if (cmp < 0 || r2 === 1 && cmp === 0) return dm.div;
        // Round up
        return dm.div.negative !== 0 ? dm.div.isubn(1) : dm.div.iaddn(1);
    };
    BN.prototype.modn = function modn(num) {
        assert(num <= 0x3ffffff);
        var p = 67108864 % num;
        var acc = 0;
        for(var i = this.length - 1; i >= 0; i--)acc = (p * acc + (this.words[i] | 0)) % num;
        return acc;
    };
    // In-place division by number
    BN.prototype.idivn = function idivn(num) {
        assert(num <= 0x3ffffff);
        var carry = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var w = (this.words[i] | 0) + carry * 0x4000000;
            this.words[i] = w / num | 0;
            carry = w % num;
        }
        return this.strip();
    };
    BN.prototype.divn = function divn(num) {
        return this.clone().idivn(num);
    };
    BN.prototype.egcd = function egcd(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var x = this;
        var y = p.clone();
        if (x.negative !== 0) x = x.umod(p);
        else x = x.clone();
        // A * x + B * y = x
        var A = new BN(1);
        var B = new BN(0);
        // C * x + D * y = y
        var C = new BN(0);
        var D = new BN(1);
        var g = 0;
        while(x.isEven() && y.isEven()){
            x.iushrn(1);
            y.iushrn(1);
            ++g;
        }
        var yp = y.clone();
        var xp = x.clone();
        while(!x.isZero()){
            for(var i = 0, im = 1; (x.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                x.iushrn(i);
                while(i-- > 0){
                    if (A.isOdd() || B.isOdd()) {
                        A.iadd(yp);
                        B.isub(xp);
                    }
                    A.iushrn(1);
                    B.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (y.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                y.iushrn(j);
                while(j-- > 0){
                    if (C.isOdd() || D.isOdd()) {
                        C.iadd(yp);
                        D.isub(xp);
                    }
                    C.iushrn(1);
                    D.iushrn(1);
                }
            }
            if (x.cmp(y) >= 0) {
                x.isub(y);
                A.isub(C);
                B.isub(D);
            } else {
                y.isub(x);
                C.isub(A);
                D.isub(B);
            }
        }
        return {
            a: C,
            b: D,
            gcd: y.iushln(g)
        };
    };
    // This is reduced incarnation of the binary EEA
    // above, designated to invert members of the
    // _prime_ fields F(p) at a maximal speed
    BN.prototype._invmp = function _invmp(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var a = this;
        var b = p.clone();
        if (a.negative !== 0) a = a.umod(p);
        else a = a.clone();
        var x1 = new BN(1);
        var x2 = new BN(0);
        var delta = b.clone();
        while(a.cmpn(1) > 0 && b.cmpn(1) > 0){
            for(var i = 0, im = 1; (a.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                a.iushrn(i);
                while(i-- > 0){
                    if (x1.isOdd()) x1.iadd(delta);
                    x1.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (b.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                b.iushrn(j);
                while(j-- > 0){
                    if (x2.isOdd()) x2.iadd(delta);
                    x2.iushrn(1);
                }
            }
            if (a.cmp(b) >= 0) {
                a.isub(b);
                x1.isub(x2);
            } else {
                b.isub(a);
                x2.isub(x1);
            }
        }
        var res;
        if (a.cmpn(1) === 0) res = x1;
        else res = x2;
        if (res.cmpn(0) < 0) res.iadd(p);
        return res;
    };
    BN.prototype.gcd = function gcd(num) {
        if (this.isZero()) return num.abs();
        if (num.isZero()) return this.abs();
        var a = this.clone();
        var b = num.clone();
        a.negative = 0;
        b.negative = 0;
        // Remove common factor of two
        for(var shift = 0; a.isEven() && b.isEven(); shift++){
            a.iushrn(1);
            b.iushrn(1);
        }
        do {
            while(a.isEven())a.iushrn(1);
            while(b.isEven())b.iushrn(1);
            var r = a.cmp(b);
            if (r < 0) {
                // Swap `a` and `b` to make `a` always bigger than `b`
                var t = a;
                a = b;
                b = t;
            } else if (r === 0 || b.cmpn(1) === 0) break;
            a.isub(b);
        }while (true);
        return b.iushln(shift);
    };
    // Invert number in the field F(num)
    BN.prototype.invm = function invm(num) {
        return this.egcd(num).a.umod(num);
    };
    BN.prototype.isEven = function isEven() {
        return (this.words[0] & 1) === 0;
    };
    BN.prototype.isOdd = function isOdd() {
        return (this.words[0] & 1) === 1;
    };
    // And first word and num
    BN.prototype.andln = function andln(num) {
        return this.words[0] & num;
    };
    // Increment at the bit position in-line
    BN.prototype.bincn = function bincn(bit) {
        assert(typeof bit === "number");
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) {
            this._expand(s + 1);
            this.words[s] |= q;
            return this;
        }
        // Add bit and propagate, if needed
        var carry = q;
        for(var i = s; carry !== 0 && i < this.length; i++){
            var w = this.words[i] | 0;
            w += carry;
            carry = w >>> 26;
            w &= 0x3ffffff;
            this.words[i] = w;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return this;
    };
    BN.prototype.isZero = function isZero() {
        return this.length === 1 && this.words[0] === 0;
    };
    BN.prototype.cmpn = function cmpn(num) {
        var negative = num < 0;
        if (this.negative !== 0 && !negative) return -1;
        if (this.negative === 0 && negative) return 1;
        this.strip();
        var res;
        if (this.length > 1) res = 1;
        else {
            if (negative) num = -num;
            assert(num <= 0x3ffffff, "Number is too big");
            var w = this.words[0] | 0;
            res = w === num ? 0 : w < num ? -1 : 1;
        }
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Compare two numbers and return:
    // 1 - if `this` > `num`
    // 0 - if `this` == `num`
    // -1 - if `this` < `num`
    BN.prototype.cmp = function cmp(num) {
        if (this.negative !== 0 && num.negative === 0) return -1;
        if (this.negative === 0 && num.negative !== 0) return 1;
        var res = this.ucmp(num);
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Unsigned comparison
    BN.prototype.ucmp = function ucmp(num) {
        // At this point both numbers have the same sign
        if (this.length > num.length) return 1;
        if (this.length < num.length) return -1;
        var res = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var a = this.words[i] | 0;
            var b = num.words[i] | 0;
            if (a === b) continue;
            if (a < b) res = -1;
            else if (a > b) res = 1;
            break;
        }
        return res;
    };
    BN.prototype.gtn = function gtn(num) {
        return this.cmpn(num) === 1;
    };
    BN.prototype.gt = function gt(num) {
        return this.cmp(num) === 1;
    };
    BN.prototype.gten = function gten(num) {
        return this.cmpn(num) >= 0;
    };
    BN.prototype.gte = function gte(num) {
        return this.cmp(num) >= 0;
    };
    BN.prototype.ltn = function ltn(num) {
        return this.cmpn(num) === -1;
    };
    BN.prototype.lt = function lt(num) {
        return this.cmp(num) === -1;
    };
    BN.prototype.lten = function lten(num) {
        return this.cmpn(num) <= 0;
    };
    BN.prototype.lte = function lte(num) {
        return this.cmp(num) <= 0;
    };
    BN.prototype.eqn = function eqn(num) {
        return this.cmpn(num) === 0;
    };
    BN.prototype.eq = function eq(num) {
        return this.cmp(num) === 0;
    };
    //
    // A reduce context, could be using montgomery or something better, depending
    // on the `m` itself.
    //
    BN.red = function red(num) {
        return new Red(num);
    };
    BN.prototype.toRed = function toRed(ctx) {
        assert(!this.red, "Already a number in reduction context");
        assert(this.negative === 0, "red works only with positives");
        return ctx.convertTo(this)._forceRed(ctx);
    };
    BN.prototype.fromRed = function fromRed() {
        assert(this.red, "fromRed works only with numbers in reduction context");
        return this.red.convertFrom(this);
    };
    BN.prototype._forceRed = function _forceRed(ctx) {
        this.red = ctx;
        return this;
    };
    BN.prototype.forceRed = function forceRed(ctx) {
        assert(!this.red, "Already a number in reduction context");
        return this._forceRed(ctx);
    };
    BN.prototype.redAdd = function redAdd(num) {
        assert(this.red, "redAdd works only with red numbers");
        return this.red.add(this, num);
    };
    BN.prototype.redIAdd = function redIAdd(num) {
        assert(this.red, "redIAdd works only with red numbers");
        return this.red.iadd(this, num);
    };
    BN.prototype.redSub = function redSub(num) {
        assert(this.red, "redSub works only with red numbers");
        return this.red.sub(this, num);
    };
    BN.prototype.redISub = function redISub(num) {
        assert(this.red, "redISub works only with red numbers");
        return this.red.isub(this, num);
    };
    BN.prototype.redShl = function redShl(num) {
        assert(this.red, "redShl works only with red numbers");
        return this.red.shl(this, num);
    };
    BN.prototype.redMul = function redMul(num) {
        assert(this.red, "redMul works only with red numbers");
        this.red._verify2(this, num);
        return this.red.mul(this, num);
    };
    BN.prototype.redIMul = function redIMul(num) {
        assert(this.red, "redMul works only with red numbers");
        this.red._verify2(this, num);
        return this.red.imul(this, num);
    };
    BN.prototype.redSqr = function redSqr() {
        assert(this.red, "redSqr works only with red numbers");
        this.red._verify1(this);
        return this.red.sqr(this);
    };
    BN.prototype.redISqr = function redISqr() {
        assert(this.red, "redISqr works only with red numbers");
        this.red._verify1(this);
        return this.red.isqr(this);
    };
    // Square root over p
    BN.prototype.redSqrt = function redSqrt() {
        assert(this.red, "redSqrt works only with red numbers");
        this.red._verify1(this);
        return this.red.sqrt(this);
    };
    BN.prototype.redInvm = function redInvm() {
        assert(this.red, "redInvm works only with red numbers");
        this.red._verify1(this);
        return this.red.invm(this);
    };
    // Return negative clone of `this` % `red modulo`
    BN.prototype.redNeg = function redNeg() {
        assert(this.red, "redNeg works only with red numbers");
        this.red._verify1(this);
        return this.red.neg(this);
    };
    BN.prototype.redPow = function redPow(num) {
        assert(this.red && !num.red, "redPow(normalNum)");
        this.red._verify1(this);
        return this.red.pow(this, num);
    };
    // Prime numbers with efficient reduction
    var primes = {
        k256: null,
        p224: null,
        p192: null,
        p25519: null
    };
    // Pseudo-Mersenne prime
    function MPrime(name, p) {
        // P = 2 ^ N - K
        this.name = name;
        this.p = new BN(p, 16);
        this.n = this.p.bitLength();
        this.k = new BN(1).iushln(this.n).isub(this.p);
        this.tmp = this._tmp();
    }
    MPrime.prototype._tmp = function _tmp() {
        var tmp = new BN(null);
        tmp.words = new Array(Math.ceil(this.n / 13));
        return tmp;
    };
    MPrime.prototype.ireduce = function ireduce(num) {
        // Assumes that `num` is less than `P^2`
        // num = HI * (2 ^ N - K) + HI * K + LO = HI * K + LO (mod P)
        var r = num;
        var rlen;
        do {
            this.split(r, this.tmp);
            r = this.imulK(r);
            r = r.iadd(this.tmp);
            rlen = r.bitLength();
        }while (rlen > this.n);
        var cmp = rlen < this.n ? -1 : r.ucmp(this.p);
        if (cmp === 0) {
            r.words[0] = 0;
            r.length = 1;
        } else if (cmp > 0) r.isub(this.p);
        else if (r.strip !== undefined) // r is BN v4 instance
        r.strip();
        else // r is BN v5 instance
        r._strip();
        return r;
    };
    MPrime.prototype.split = function split(input, out) {
        input.iushrn(this.n, 0, out);
    };
    MPrime.prototype.imulK = function imulK(num) {
        return num.imul(this.k);
    };
    function K256() {
        MPrime.call(this, "k256", "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f");
    }
    inherits(K256, MPrime);
    K256.prototype.split = function split(input, output) {
        // 256 = 9 * 26 + 22
        var mask = 0x3fffff;
        var outLen = Math.min(input.length, 9);
        for(var i = 0; i < outLen; i++)output.words[i] = input.words[i];
        output.length = outLen;
        if (input.length <= 9) {
            input.words[0] = 0;
            input.length = 1;
            return;
        }
        // Shift by 9 limbs
        var prev = input.words[9];
        output.words[output.length++] = prev & mask;
        for(i = 10; i < input.length; i++){
            var next = input.words[i] | 0;
            input.words[i - 10] = (next & mask) << 4 | prev >>> 22;
            prev = next;
        }
        prev >>>= 22;
        input.words[i - 10] = prev;
        if (prev === 0 && input.length > 10) input.length -= 10;
        else input.length -= 9;
    };
    K256.prototype.imulK = function imulK(num) {
        // K = 0x1000003d1 = [ 0x40, 0x3d1 ]
        num.words[num.length] = 0;
        num.words[num.length + 1] = 0;
        num.length += 2;
        // bounded at: 0x40 * 0x3ffffff + 0x3d0 = 0x100000390
        var lo = 0;
        for(var i = 0; i < num.length; i++){
            var w = num.words[i] | 0;
            lo += w * 0x3d1;
            num.words[i] = lo & 0x3ffffff;
            lo = w * 0x40 + (lo / 0x4000000 | 0);
        }
        // Fast length reduction
        if (num.words[num.length - 1] === 0) {
            num.length--;
            if (num.words[num.length - 1] === 0) num.length--;
        }
        return num;
    };
    function P224() {
        MPrime.call(this, "p224", "ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001");
    }
    inherits(P224, MPrime);
    function P192() {
        MPrime.call(this, "p192", "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff");
    }
    inherits(P192, MPrime);
    function P25519() {
        // 2 ^ 255 - 19
        MPrime.call(this, "25519", "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed");
    }
    inherits(P25519, MPrime);
    P25519.prototype.imulK = function imulK(num) {
        // K = 0x13
        var carry = 0;
        for(var i = 0; i < num.length; i++){
            var hi = (num.words[i] | 0) * 0x13 + carry;
            var lo = hi & 0x3ffffff;
            hi >>>= 26;
            num.words[i] = lo;
            carry = hi;
        }
        if (carry !== 0) num.words[num.length++] = carry;
        return num;
    };
    // Exported mostly for testing purposes, use plain name instead
    BN._prime = function prime(name) {
        // Cached version of prime
        if (primes[name]) return primes[name];
        var prime;
        if (name === "k256") prime = new K256();
        else if (name === "p224") prime = new P224();
        else if (name === "p192") prime = new P192();
        else if (name === "p25519") prime = new P25519();
        else throw new Error("Unknown prime " + name);
        primes[name] = prime;
        return prime;
    };
    //
    // Base reduction engine
    //
    function Red(m) {
        if (typeof m === "string") {
            var prime = BN._prime(m);
            this.m = prime.p;
            this.prime = prime;
        } else {
            assert(m.gtn(1), "modulus must be greater than 1");
            this.m = m;
            this.prime = null;
        }
    }
    Red.prototype._verify1 = function _verify1(a) {
        assert(a.negative === 0, "red works only with positives");
        assert(a.red, "red works only with red numbers");
    };
    Red.prototype._verify2 = function _verify2(a, b) {
        assert((a.negative | b.negative) === 0, "red works only with positives");
        assert(a.red && a.red === b.red, "red works only with red numbers");
    };
    Red.prototype.imod = function imod(a) {
        if (this.prime) return this.prime.ireduce(a)._forceRed(this);
        return a.umod(this.m)._forceRed(this);
    };
    Red.prototype.neg = function neg(a) {
        if (a.isZero()) return a.clone();
        return this.m.sub(a)._forceRed(this);
    };
    Red.prototype.add = function add(a, b) {
        this._verify2(a, b);
        var res = a.add(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res._forceRed(this);
    };
    Red.prototype.iadd = function iadd(a, b) {
        this._verify2(a, b);
        var res = a.iadd(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res;
    };
    Red.prototype.sub = function sub(a, b) {
        this._verify2(a, b);
        var res = a.sub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res._forceRed(this);
    };
    Red.prototype.isub = function isub(a, b) {
        this._verify2(a, b);
        var res = a.isub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res;
    };
    Red.prototype.shl = function shl(a, num) {
        this._verify1(a);
        return this.imod(a.ushln(num));
    };
    Red.prototype.imul = function imul(a, b) {
        this._verify2(a, b);
        return this.imod(a.imul(b));
    };
    Red.prototype.mul = function mul(a, b) {
        this._verify2(a, b);
        return this.imod(a.mul(b));
    };
    Red.prototype.isqr = function isqr(a) {
        return this.imul(a, a.clone());
    };
    Red.prototype.sqr = function sqr(a) {
        return this.mul(a, a);
    };
    Red.prototype.sqrt = function sqrt(a) {
        if (a.isZero()) return a.clone();
        var mod3 = this.m.andln(3);
        assert(mod3 % 2 === 1);
        // Fast case
        if (mod3 === 3) {
            var pow = this.m.add(new BN(1)).iushrn(2);
            return this.pow(a, pow);
        }
        // Tonelli-Shanks algorithm (Totally unoptimized and slow)
        //
        // Find Q and S, that Q * 2 ^ S = (P - 1)
        var q = this.m.subn(1);
        var s = 0;
        while(!q.isZero() && q.andln(1) === 0){
            s++;
            q.iushrn(1);
        }
        assert(!q.isZero());
        var one = new BN(1).toRed(this);
        var nOne = one.redNeg();
        // Find quadratic non-residue
        // NOTE: Max is such because of generalized Riemann hypothesis.
        var lpow = this.m.subn(1).iushrn(1);
        var z = this.m.bitLength();
        z = new BN(2 * z * z).toRed(this);
        while(this.pow(z, lpow).cmp(nOne) !== 0)z.redIAdd(nOne);
        var c = this.pow(z, q);
        var r = this.pow(a, q.addn(1).iushrn(1));
        var t = this.pow(a, q);
        var m = s;
        while(t.cmp(one) !== 0){
            var tmp = t;
            for(var i = 0; tmp.cmp(one) !== 0; i++)tmp = tmp.redSqr();
            assert(i < m);
            var b = this.pow(c, new BN(1).iushln(m - i - 1));
            r = r.redMul(b);
            c = b.redSqr();
            t = t.redMul(c);
            m = i;
        }
        return r;
    };
    Red.prototype.invm = function invm(a) {
        var inv = a._invmp(this.m);
        if (inv.negative !== 0) {
            inv.negative = 0;
            return this.imod(inv).redNeg();
        } else return this.imod(inv);
    };
    Red.prototype.pow = function pow(a, num) {
        if (num.isZero()) return new BN(1).toRed(this);
        if (num.cmpn(1) === 0) return a.clone();
        var windowSize = 4;
        var wnd = new Array(1 << windowSize);
        wnd[0] = new BN(1).toRed(this);
        wnd[1] = a;
        for(var i = 2; i < wnd.length; i++)wnd[i] = this.mul(wnd[i - 1], a);
        var res = wnd[0];
        var current = 0;
        var currentLen = 0;
        var start = num.bitLength() % 26;
        if (start === 0) start = 26;
        for(i = num.length - 1; i >= 0; i--){
            var word = num.words[i];
            for(var j = start - 1; j >= 0; j--){
                var bit = word >> j & 1;
                if (res !== wnd[0]) res = this.sqr(res);
                if (bit === 0 && current === 0) {
                    currentLen = 0;
                    continue;
                }
                current <<= 1;
                current |= bit;
                currentLen++;
                if (currentLen !== windowSize && (i !== 0 || j !== 0)) continue;
                res = this.mul(res, wnd[current]);
                currentLen = 0;
                current = 0;
            }
            start = 26;
        }
        return res;
    };
    Red.prototype.convertTo = function convertTo(num) {
        var r = num.umod(this.m);
        return r === num ? r.clone() : r;
    };
    Red.prototype.convertFrom = function convertFrom(num) {
        var res = num.clone();
        res.red = null;
        return res;
    };
    //
    // Montgomery method engine
    //
    BN.mont = function mont(num) {
        return new Mont(num);
    };
    function Mont(m) {
        Red.call(this, m);
        this.shift = this.m.bitLength();
        if (this.shift % 26 !== 0) this.shift += 26 - this.shift % 26;
        this.r = new BN(1).iushln(this.shift);
        this.r2 = this.imod(this.r.sqr());
        this.rinv = this.r._invmp(this.m);
        this.minv = this.rinv.mul(this.r).isubn(1).div(this.m);
        this.minv = this.minv.umod(this.r);
        this.minv = this.r.sub(this.minv);
    }
    inherits(Mont, Red);
    Mont.prototype.convertTo = function convertTo(num) {
        return this.imod(num.ushln(this.shift));
    };
    Mont.prototype.convertFrom = function convertFrom(num) {
        var r = this.imod(num.mul(this.rinv));
        r.red = null;
        return r;
    };
    Mont.prototype.imul = function imul(a, b) {
        if (a.isZero() || b.isZero()) {
            a.words[0] = 0;
            a.length = 1;
            return a;
        }
        var t = a.imul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.mul = function mul(a, b) {
        if (a.isZero() || b.isZero()) return new BN(0)._forceRed(this);
        var t = a.mul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.invm = function invm(a) {
        // (AR)^-1 * R^2 = (A^-1 * R^-1) * R^2 = A^-1 * R
        var res = this.imod(a._invmp(this.m).mul(this.r2));
        return res._forceRed(this);
    };
})(module, this);

});

parcelRequire.register("4hcaz", function(module, exports) {

var $7vYz3 = parcelRequire("7vYz3");

var $9JRha = parcelRequire("9JRha");
function $31d2308cd740d826$var$MillerRabin(rand) {
    this.rand = rand || new $9JRha.Rand();
}
module.exports = $31d2308cd740d826$var$MillerRabin;
$31d2308cd740d826$var$MillerRabin.create = function create(rand) {
    return new $31d2308cd740d826$var$MillerRabin(rand);
};
$31d2308cd740d826$var$MillerRabin.prototype._randbelow = function _randbelow(n) {
    var len = n.bitLength();
    var min_bytes = Math.ceil(len / 8);
    // Generage random bytes until a number less than n is found.
    // This ensures that 0..n-1 have an equal probability of being selected.
    do var a = new $7vYz3(this.rand.generate(min_bytes));
    while (a.cmp(n) >= 0);
    return a;
};
$31d2308cd740d826$var$MillerRabin.prototype._randrange = function _randrange(start, stop) {
    // Generate a random number greater than or equal to start and less than stop.
    var size = stop.sub(start);
    return start.add(this._randbelow(size));
};
$31d2308cd740d826$var$MillerRabin.prototype.test = function test(n, k, cb) {
    var len = n.bitLength();
    var red = $7vYz3.mont(n);
    var rone = new $7vYz3(1).toRed(red);
    if (!k) k = Math.max(1, len / 48 | 0);
    // Find d and s, (n - 1) = (2 ^ s) * d;
    var n1 = n.subn(1);
    for(var s = 0; !n1.testn(s); s++);
    var d = n.shrn(s);
    var rn1 = n1.toRed(red);
    var prime = true;
    for(; k > 0; k--){
        var a = this._randrange(new $7vYz3(2), n1);
        if (cb) cb(a);
        var x = a.toRed(red).redPow(d);
        if (x.cmp(rone) === 0 || x.cmp(rn1) === 0) continue;
        for(var i = 1; i < s; i++){
            x = x.redSqr();
            if (x.cmp(rone) === 0) return false;
            if (x.cmp(rn1) === 0) break;
        }
        if (i === s) return false;
    }
    return prime;
};
$31d2308cd740d826$var$MillerRabin.prototype.getDivisor = function getDivisor(n, k) {
    var len = n.bitLength();
    var red = $7vYz3.mont(n);
    var rone = new $7vYz3(1).toRed(red);
    if (!k) k = Math.max(1, len / 48 | 0);
    // Find d and s, (n - 1) = (2 ^ s) * d;
    var n1 = n.subn(1);
    for(var s = 0; !n1.testn(s); s++);
    var d = n.shrn(s);
    var rn1 = n1.toRed(red);
    for(; k > 0; k--){
        var a = this._randrange(new $7vYz3(2), n1);
        var g = n.gcd(a);
        if (g.cmpn(1) !== 0) return g;
        var x = a.toRed(red).redPow(d);
        if (x.cmp(rone) === 0 || x.cmp(rn1) === 0) continue;
        for(var i = 1; i < s; i++){
            x = x.redSqr();
            if (x.cmp(rone) === 0) return x.fromRed().subn(1).gcd(n);
            if (x.cmp(rn1) === 0) break;
        }
        if (i === s) {
            x = x.redSqr();
            return x.fromRed().subn(1).gcd(n);
        }
    }
    return false;
};

});
parcelRequire.register("9JRha", function(module, exports) {
var $7171a486633c2eed$var$r;
module.exports = function rand(len) {
    if (!$7171a486633c2eed$var$r) $7171a486633c2eed$var$r = new $7171a486633c2eed$var$Rand(null);
    return $7171a486633c2eed$var$r.generate(len);
};
function $7171a486633c2eed$var$Rand(rand) {
    this.rand = rand;
}
module.exports.Rand = $7171a486633c2eed$var$Rand;
$7171a486633c2eed$var$Rand.prototype.generate = function generate(len) {
    return this._rand(len);
};
// Emulate crypto API using randy
$7171a486633c2eed$var$Rand.prototype._rand = function _rand(n) {
    if (this.rand.getBytes) return this.rand.getBytes(n);
    var res = new Uint8Array(n);
    for(var i = 0; i < res.length; i++)res[i] = this.rand.getByte();
    return res;
};

if (typeof self === "object") {
    if (self.crypto && self.crypto.getRandomValues) // Modern browsers
    $7171a486633c2eed$var$Rand.prototype._rand = function _rand(n) {
        var arr = new Uint8Array(n);
        self.crypto.getRandomValues(arr);
        return arr;
    };
    else if (self.msCrypto && self.msCrypto.getRandomValues) // IE
    $7171a486633c2eed$var$Rand.prototype._rand = function _rand(n) {
        var arr = new Uint8Array(n);
        self.msCrypto.getRandomValues(arr);
        return arr;
    };
    else if (typeof window === "object") // Old junk
    $7171a486633c2eed$var$Rand.prototype._rand = function() {
        throw new Error("Not implemented yet");
    };
} else // Node.js or Web worker with no crypto support
try {
    var $7171a486633c2eed$var$crypto = (parcelRequire("5Io6y"));
    if (typeof $7171a486633c2eed$var$crypto.randomBytes !== "function") throw new Error("Not supported");
    $7171a486633c2eed$var$Rand.prototype._rand = function _rand(n) {
        return $7171a486633c2eed$var$crypto.randomBytes(n);
    };
} catch (e) {}

});



parcelRequire.register("fsr3h", function(module, exports) {
module.exports = JSON.parse('{"modp1":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a63a3620ffffffffffffffff"},"modp2":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece65381ffffffffffffffff"},"modp5":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca237327ffffffffffffffff"},"modp14":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aacaa68ffffffffffffffff"},"modp15":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a93ad2caffffffffffffffff"},"modp16":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a92108011a723c12a787e6d788719a10bdba5b2699c327186af4e23c1a946834b6150bda2583e9ca2ad44ce8dbbbc2db04de8ef92e8efc141fbecaa6287c59474e6bc05d99b2964fa090c3a2233ba186515be7ed1f612970cee2d7afb81bdd762170481cd0069127d5b05aa993b4ea988d8fddc186ffb7dc90a6c08f4df435c934063199ffffffffffffffff"},"modp17":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a92108011a723c12a787e6d788719a10bdba5b2699c327186af4e23c1a946834b6150bda2583e9ca2ad44ce8dbbbc2db04de8ef92e8efc141fbecaa6287c59474e6bc05d99b2964fa090c3a2233ba186515be7ed1f612970cee2d7afb81bdd762170481cd0069127d5b05aa993b4ea988d8fddc186ffb7dc90a6c08f4df435c93402849236c3fab4d27c7026c1d4dcb2602646dec9751e763dba37bdf8ff9406ad9e530ee5db382f413001aeb06a53ed9027d831179727b0865a8918da3edbebcf9b14ed44ce6cbaced4bb1bdb7f1447e6cc254b332051512bd7af426fb8f401378cd2bf5983ca01c64b92ecf032ea15d1721d03f482d7ce6e74fef6d55e702f46980c82b5a84031900b1c9e59e7c97fbec7e8f323a97a7e36cc88be0f1d45b7ff585ac54bd407b22b4154aacc8f6d7ebf48e1d814cc5ed20f8037e0a79715eef29be32806a1d58bb7c5da76f550aa3d8a1fbff0eb19ccb1a313d55cda56c9ec2ef29632387fe8d76e3c0468043e8f663f4860ee12bf2d5b0b7474d6e694f91e6dcc4024ffffffffffffffff"},"modp18":{"gen":"02","prime":"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"}}');

});

parcelRequire.register("2kgCI", function(module, exports) {

var $ihoyg = parcelRequire("ihoyg");
var $1b1a581faa6d58f2$require$Buffer = $ihoyg.Buffer;

var $7vYz3 = parcelRequire("7vYz3");

var $4hcaz = parcelRequire("4hcaz");
var $1b1a581faa6d58f2$var$millerRabin = new $4hcaz();
var $1b1a581faa6d58f2$var$TWENTYFOUR = new $7vYz3(24);
var $1b1a581faa6d58f2$var$ELEVEN = new $7vYz3(11);
var $1b1a581faa6d58f2$var$TEN = new $7vYz3(10);
var $1b1a581faa6d58f2$var$THREE = new $7vYz3(3);
var $1b1a581faa6d58f2$var$SEVEN = new $7vYz3(7);

var $lNmPw = parcelRequire("lNmPw");

var $5rfiH = parcelRequire("5rfiH");
module.exports = $1b1a581faa6d58f2$var$DH;
function $1b1a581faa6d58f2$var$setPublicKey(pub, enc) {
    enc = enc || "utf8";
    if (!$1b1a581faa6d58f2$require$Buffer.isBuffer(pub)) pub = new $1b1a581faa6d58f2$require$Buffer(pub, enc);
    this._pub = new $7vYz3(pub);
    return this;
}
function $1b1a581faa6d58f2$var$setPrivateKey(priv, enc) {
    enc = enc || "utf8";
    if (!$1b1a581faa6d58f2$require$Buffer.isBuffer(priv)) priv = new $1b1a581faa6d58f2$require$Buffer(priv, enc);
    this._priv = new $7vYz3(priv);
    return this;
}
var $1b1a581faa6d58f2$var$primeCache = {};
function $1b1a581faa6d58f2$var$checkPrime(prime, generator) {
    var gen = generator.toString("hex");
    var hex = [
        gen,
        prime.toString(16)
    ].join("_");
    if (hex in $1b1a581faa6d58f2$var$primeCache) return $1b1a581faa6d58f2$var$primeCache[hex];
    var error = 0;
    if (prime.isEven() || !$lNmPw.simpleSieve || !$lNmPw.fermatTest(prime) || !$1b1a581faa6d58f2$var$millerRabin.test(prime)) {
        //not a prime so +1
        error += 1;
        if (gen === "02" || gen === "05") // we'd be able to check the generator
        // it would fail so +8
        error += 8;
        else //we wouldn't be able to test the generator
        // so +4
        error += 4;
        $1b1a581faa6d58f2$var$primeCache[hex] = error;
        return error;
    }
    if (!$1b1a581faa6d58f2$var$millerRabin.test(prime.shrn(1))) //not a safe prime
    error += 2;
    var rem;
    switch(gen){
        case "02":
            if (prime.mod($1b1a581faa6d58f2$var$TWENTYFOUR).cmp($1b1a581faa6d58f2$var$ELEVEN)) // unsuidable generator
            error += 8;
            break;
        case "05":
            rem = prime.mod($1b1a581faa6d58f2$var$TEN);
            if (rem.cmp($1b1a581faa6d58f2$var$THREE) && rem.cmp($1b1a581faa6d58f2$var$SEVEN)) // prime mod 10 needs to equal 3 or 7
            error += 8;
            break;
        default:
            error += 4;
    }
    $1b1a581faa6d58f2$var$primeCache[hex] = error;
    return error;
}
function $1b1a581faa6d58f2$var$DH(prime, generator, malleable) {
    this.setGenerator(generator);
    this.__prime = new $7vYz3(prime);
    this._prime = $7vYz3.mont(this.__prime);
    this._primeLen = prime.length;
    this._pub = undefined;
    this._priv = undefined;
    this._primeCode = undefined;
    if (malleable) {
        this.setPublicKey = $1b1a581faa6d58f2$var$setPublicKey;
        this.setPrivateKey = $1b1a581faa6d58f2$var$setPrivateKey;
    } else this._primeCode = 8;
}
Object.defineProperty($1b1a581faa6d58f2$var$DH.prototype, "verifyError", {
    enumerable: true,
    get: function() {
        if (typeof this._primeCode !== "number") this._primeCode = $1b1a581faa6d58f2$var$checkPrime(this.__prime, this.__gen);
        return this._primeCode;
    }
});
$1b1a581faa6d58f2$var$DH.prototype.generateKeys = function() {
    if (!this._priv) this._priv = new $7vYz3($5rfiH(this._primeLen));
    this._pub = this._gen.toRed(this._prime).redPow(this._priv).fromRed();
    return this.getPublicKey();
};
$1b1a581faa6d58f2$var$DH.prototype.computeSecret = function(other) {
    other = new $7vYz3(other);
    other = other.toRed(this._prime);
    var secret = other.redPow(this._priv).fromRed();
    var out = new $1b1a581faa6d58f2$require$Buffer(secret.toArray());
    var prime = this.getPrime();
    if (out.length < prime.length) {
        var front = new $1b1a581faa6d58f2$require$Buffer(prime.length - out.length);
        front.fill(0);
        out = $1b1a581faa6d58f2$require$Buffer.concat([
            front,
            out
        ]);
    }
    return out;
};
$1b1a581faa6d58f2$var$DH.prototype.getPublicKey = function getPublicKey(enc) {
    return $1b1a581faa6d58f2$var$formatReturnValue(this._pub, enc);
};
$1b1a581faa6d58f2$var$DH.prototype.getPrivateKey = function getPrivateKey(enc) {
    return $1b1a581faa6d58f2$var$formatReturnValue(this._priv, enc);
};
$1b1a581faa6d58f2$var$DH.prototype.getPrime = function(enc) {
    return $1b1a581faa6d58f2$var$formatReturnValue(this.__prime, enc);
};
$1b1a581faa6d58f2$var$DH.prototype.getGenerator = function(enc) {
    return $1b1a581faa6d58f2$var$formatReturnValue(this._gen, enc);
};
$1b1a581faa6d58f2$var$DH.prototype.setGenerator = function(gen, enc) {
    enc = enc || "utf8";
    if (!$1b1a581faa6d58f2$require$Buffer.isBuffer(gen)) gen = new $1b1a581faa6d58f2$require$Buffer(gen, enc);
    this.__gen = gen;
    this._gen = new $7vYz3(gen);
    return this;
};
function $1b1a581faa6d58f2$var$formatReturnValue(bn, enc) {
    var buf = new $1b1a581faa6d58f2$require$Buffer(bn.toArray());
    if (!enc) return buf;
    else return buf.toString(enc);
}

});


parcelRequire.register("bOCXe", function(module, exports) {

var $6U9mG = parcelRequire("6U9mG");
var $89a294bd7a4a7e9a$require$Buffer = $6U9mG.Buffer;

var $3FiLE = parcelRequire("3FiLE");

var $9AddZ = parcelRequire("9AddZ");

var $eSHUL = parcelRequire("eSHUL");

var $ar1Lb = parcelRequire("ar1Lb");

var $eri43 = parcelRequire("eri43");

var $jdVex = parcelRequire("jdVex");
Object.keys($jdVex).forEach(function(key) {
    $jdVex[key].id = $89a294bd7a4a7e9a$require$Buffer.from($jdVex[key].id, "hex");
    $jdVex[key.toLowerCase()] = $jdVex[key];
});
function $89a294bd7a4a7e9a$var$Sign(algorithm) {
    $9AddZ.Writable.call(this);
    var data = $jdVex[algorithm];
    if (!data) throw new Error("Unknown message digest");
    this._hashType = data.hash;
    this._hash = $3FiLE(data.hash);
    this._tag = data.id;
    this._signType = data.sign;
}
$eSHUL($89a294bd7a4a7e9a$var$Sign, $9AddZ.Writable);
$89a294bd7a4a7e9a$var$Sign.prototype._write = function _write(data, _, done) {
    this._hash.update(data);
    done();
};
$89a294bd7a4a7e9a$var$Sign.prototype.update = function update(data, enc) {
    if (typeof data === "string") data = $89a294bd7a4a7e9a$require$Buffer.from(data, enc);
    this._hash.update(data);
    return this;
};
$89a294bd7a4a7e9a$var$Sign.prototype.sign = function signMethod(key, enc) {
    this.end();
    var hash = this._hash.digest();
    var sig = $ar1Lb(hash, key, this._hashType, this._signType, this._tag);
    return enc ? sig.toString(enc) : sig;
};
function $89a294bd7a4a7e9a$var$Verify(algorithm) {
    $9AddZ.Writable.call(this);
    var data = $jdVex[algorithm];
    if (!data) throw new Error("Unknown message digest");
    this._hash = $3FiLE(data.hash);
    this._tag = data.id;
    this._signType = data.sign;
}
$eSHUL($89a294bd7a4a7e9a$var$Verify, $9AddZ.Writable);
$89a294bd7a4a7e9a$var$Verify.prototype._write = function _write(data, _, done) {
    this._hash.update(data);
    done();
};
$89a294bd7a4a7e9a$var$Verify.prototype.update = function update(data, enc) {
    if (typeof data === "string") data = $89a294bd7a4a7e9a$require$Buffer.from(data, enc);
    this._hash.update(data);
    return this;
};
$89a294bd7a4a7e9a$var$Verify.prototype.verify = function verifyMethod(key, sig, enc) {
    if (typeof sig === "string") sig = $89a294bd7a4a7e9a$require$Buffer.from(sig, enc);
    this.end();
    var hash = this._hash.digest();
    return $eri43(sig, hash, key, this._signType, this._tag);
};
function $89a294bd7a4a7e9a$var$createSign(algorithm) {
    return new $89a294bd7a4a7e9a$var$Sign(algorithm);
}
function $89a294bd7a4a7e9a$var$createVerify(algorithm) {
    return new $89a294bd7a4a7e9a$var$Verify(algorithm);
}
module.exports = {
    Sign: $89a294bd7a4a7e9a$var$createSign,
    Verify: $89a294bd7a4a7e9a$var$createVerify,
    createSign: $89a294bd7a4a7e9a$var$createSign,
    createVerify: $89a294bd7a4a7e9a$var$createVerify
};

});
parcelRequire.register("ar1Lb", function(module, exports) {
// much of this based on https://github.com/indutny/self-signed/blob/gh-pages/lib/rsa.js

var $6U9mG = parcelRequire("6U9mG");
var $798dca7f522a1f11$require$Buffer = $6U9mG.Buffer;

var $cUvgf = parcelRequire("cUvgf");

var $hG1cM = parcelRequire("hG1cM");

var $8J1ou = parcelRequire("8J1ou");
var $798dca7f522a1f11$require$EC = $8J1ou.ec;

var $4B7L6 = parcelRequire("4B7L6");

var $579Op = parcelRequire("579Op");

var $i66tY = parcelRequire("i66tY");
function $798dca7f522a1f11$var$sign(hash, key, hashType, signType, tag) {
    var priv = $579Op(key);
    if (priv.curve) {
        // rsa keys can be interpreted as ecdsa ones in openssl
        if (signType !== "ecdsa" && signType !== "ecdsa/rsa") throw new Error("wrong private key type");
        return $798dca7f522a1f11$var$ecSign(hash, priv);
    } else if (priv.type === "dsa") {
        if (signType !== "dsa") throw new Error("wrong private key type");
        return $798dca7f522a1f11$var$dsaSign(hash, priv, hashType);
    } else {
        if (signType !== "rsa" && signType !== "ecdsa/rsa") throw new Error("wrong private key type");
    }
    hash = $798dca7f522a1f11$require$Buffer.concat([
        tag,
        hash
    ]);
    var len = priv.modulus.byteLength();
    var pad = [
        0,
        1
    ];
    while(hash.length + pad.length + 1 < len)pad.push(0xff);
    pad.push(0x00);
    var i = -1;
    while(++i < hash.length)pad.push(hash[i]);
    var out = $hG1cM(pad, priv);
    return out;
}
function $798dca7f522a1f11$var$ecSign(hash, priv) {
    var curveId = $i66tY[priv.curve.join(".")];
    if (!curveId) throw new Error("unknown curve " + priv.curve.join("."));
    var curve = new $798dca7f522a1f11$require$EC(curveId);
    var key = curve.keyFromPrivate(priv.privateKey);
    var out = key.sign(hash);
    return $798dca7f522a1f11$require$Buffer.from(out.toDER());
}
function $798dca7f522a1f11$var$dsaSign(hash, priv, algo) {
    var x = priv.params.priv_key;
    var p = priv.params.p;
    var q = priv.params.q;
    var g = priv.params.g;
    var r = new $4B7L6(0);
    var k;
    var H = $798dca7f522a1f11$var$bits2int(hash, q).mod(q);
    var s = false;
    var kv = $798dca7f522a1f11$var$getKey(x, q, hash, algo);
    while(s === false){
        k = $798dca7f522a1f11$var$makeKey(q, kv, algo);
        r = $798dca7f522a1f11$var$makeR(g, k, p, q);
        s = k.invm(q).imul(H.add(x.mul(r))).mod(q);
        if (s.cmpn(0) === 0) {
            s = false;
            r = new $4B7L6(0);
        }
    }
    return $798dca7f522a1f11$var$toDER(r, s);
}
function $798dca7f522a1f11$var$toDER(r, s) {
    r = r.toArray();
    s = s.toArray();
    // Pad values
    if (r[0] & 0x80) r = [
        0
    ].concat(r);
    if (s[0] & 0x80) s = [
        0
    ].concat(s);
    var total = r.length + s.length + 4;
    var res = [
        0x30,
        total,
        0x02,
        r.length
    ];
    res = res.concat(r, [
        0x02,
        s.length
    ], s);
    return $798dca7f522a1f11$require$Buffer.from(res);
}
function $798dca7f522a1f11$var$getKey(x, q, hash, algo) {
    x = $798dca7f522a1f11$require$Buffer.from(x.toArray());
    if (x.length < q.byteLength()) {
        var zeros = $798dca7f522a1f11$require$Buffer.alloc(q.byteLength() - x.length);
        x = $798dca7f522a1f11$require$Buffer.concat([
            zeros,
            x
        ]);
    }
    var hlen = hash.length;
    var hbits = $798dca7f522a1f11$var$bits2octets(hash, q);
    var v = $798dca7f522a1f11$require$Buffer.alloc(hlen);
    v.fill(1);
    var k = $798dca7f522a1f11$require$Buffer.alloc(hlen);
    k = $cUvgf(algo, k).update(v).update($798dca7f522a1f11$require$Buffer.from([
        0
    ])).update(x).update(hbits).digest();
    v = $cUvgf(algo, k).update(v).digest();
    k = $cUvgf(algo, k).update(v).update($798dca7f522a1f11$require$Buffer.from([
        1
    ])).update(x).update(hbits).digest();
    v = $cUvgf(algo, k).update(v).digest();
    return {
        k: k,
        v: v
    };
}
function $798dca7f522a1f11$var$bits2int(obits, q) {
    var bits = new $4B7L6(obits);
    var shift = (obits.length << 3) - q.bitLength();
    if (shift > 0) bits.ishrn(shift);
    return bits;
}
function $798dca7f522a1f11$var$bits2octets(bits, q) {
    bits = $798dca7f522a1f11$var$bits2int(bits, q);
    bits = bits.mod(q);
    var out = $798dca7f522a1f11$require$Buffer.from(bits.toArray());
    if (out.length < q.byteLength()) {
        var zeros = $798dca7f522a1f11$require$Buffer.alloc(q.byteLength() - out.length);
        out = $798dca7f522a1f11$require$Buffer.concat([
            zeros,
            out
        ]);
    }
    return out;
}
function $798dca7f522a1f11$var$makeKey(q, kv, algo) {
    var t;
    var k;
    do {
        t = $798dca7f522a1f11$require$Buffer.alloc(0);
        while(t.length * 8 < q.bitLength()){
            kv.v = $cUvgf(algo, kv.k).update(kv.v).digest();
            t = $798dca7f522a1f11$require$Buffer.concat([
                t,
                kv.v
            ]);
        }
        k = $798dca7f522a1f11$var$bits2int(t, q);
        kv.k = $cUvgf(algo, kv.k).update(kv.v).update($798dca7f522a1f11$require$Buffer.from([
            0
        ])).digest();
        kv.v = $cUvgf(algo, kv.k).update(kv.v).digest();
    }while (k.cmp(q) !== -1);
    return k;
}
function $798dca7f522a1f11$var$makeR(g, k, p, q) {
    return g.toRed($4B7L6.mont(p)).redPow(k).fromRed().mod(q);
}
module.exports = $798dca7f522a1f11$var$sign;
module.exports.getKey = $798dca7f522a1f11$var$getKey;
module.exports.makeKey = $798dca7f522a1f11$var$makeKey;

});
parcelRequire.register("hG1cM", function(module, exports) {

var $ihoyg = parcelRequire("ihoyg");
var $03522ea20c8c4eb1$require$Buffer = $ihoyg.Buffer;

var $DJXAs = parcelRequire("DJXAs");

var $5rfiH = parcelRequire("5rfiH");
function $03522ea20c8c4eb1$var$blind(priv) {
    var r = $03522ea20c8c4eb1$var$getr(priv);
    var blinder = r.toRed($DJXAs.mont(priv.modulus)).redPow(new $DJXAs(priv.publicExponent)).fromRed();
    return {
        blinder: blinder,
        unblinder: r.invm(priv.modulus)
    };
}
function $03522ea20c8c4eb1$var$getr(priv) {
    var len = priv.modulus.byteLength();
    var r;
    do r = new $DJXAs($5rfiH(len));
    while (r.cmp(priv.modulus) >= 0 || !r.umod(priv.prime1) || !r.umod(priv.prime2));
    return r;
}
function $03522ea20c8c4eb1$var$crt(msg, priv) {
    var blinds = $03522ea20c8c4eb1$var$blind(priv);
    var len = priv.modulus.byteLength();
    var blinded = new $DJXAs(msg).mul(blinds.blinder).umod(priv.modulus);
    var c1 = blinded.toRed($DJXAs.mont(priv.prime1));
    var c2 = blinded.toRed($DJXAs.mont(priv.prime2));
    var qinv = priv.coefficient;
    var p = priv.prime1;
    var q = priv.prime2;
    var m1 = c1.redPow(priv.exponent1).fromRed();
    var m2 = c2.redPow(priv.exponent2).fromRed();
    var h = m1.isub(m2).imul(qinv).umod(p).imul(q);
    return m2.iadd(h).imul(blinds.unblinder).umod(priv.modulus).toArrayLike($03522ea20c8c4eb1$require$Buffer, "be", len);
}
$03522ea20c8c4eb1$var$crt.getr = $03522ea20c8c4eb1$var$getr;
module.exports = $03522ea20c8c4eb1$var$crt;

});
parcelRequire.register("DJXAs", function(module, exports) {

(function(module1, exports) {
    "use strict";
    // Utils
    function assert(val, msg) {
        if (!val) throw new Error(msg || "Assertion failed");
    }
    // Could use `inherits` module, but don't want to move from single file
    // architecture yet.
    function inherits(ctor, superCtor) {
        ctor.super_ = superCtor;
        var TempCtor = function() {};
        TempCtor.prototype = superCtor.prototype;
        ctor.prototype = new TempCtor();
        ctor.prototype.constructor = ctor;
    }
    // BN
    function BN(number, base, endian) {
        if (BN.isBN(number)) return number;
        this.negative = 0;
        this.words = null;
        this.length = 0;
        // Reduction context
        this.red = null;
        if (number !== null) {
            if (base === "le" || base === "be") {
                endian = base;
                base = 10;
            }
            this._init(number || 0, base || 10, endian || "be");
        }
    }
    if (typeof module1 === "object") module1.exports = BN;
    else exports.BN = BN;
    BN.BN = BN;
    BN.wordSize = 26;
    var Buffer;
    try {
        if (typeof window !== "undefined" && typeof window.Buffer !== "undefined") Buffer = window.Buffer;
        else Buffer = (parcelRequire("5Io6y")).Buffer;
    } catch (e) {}
    BN.isBN = function isBN(num) {
        if (num instanceof BN) return true;
        return num !== null && typeof num === "object" && num.constructor.wordSize === BN.wordSize && Array.isArray(num.words);
    };
    BN.max = function max(left, right) {
        if (left.cmp(right) > 0) return left;
        return right;
    };
    BN.min = function min(left, right) {
        if (left.cmp(right) < 0) return left;
        return right;
    };
    BN.prototype._init = function init(number, base, endian) {
        if (typeof number === "number") return this._initNumber(number, base, endian);
        if (typeof number === "object") return this._initArray(number, base, endian);
        if (base === "hex") base = 16;
        assert(base === (base | 0) && base >= 2 && base <= 36);
        number = number.toString().replace(/\s+/g, "");
        var start = 0;
        if (number[0] === "-") {
            start++;
            this.negative = 1;
        }
        if (start < number.length) {
            if (base === 16) this._parseHex(number, start, endian);
            else {
                this._parseBase(number, base, start);
                if (endian === "le") this._initArray(this.toArray(), base, endian);
            }
        }
    };
    BN.prototype._initNumber = function _initNumber(number, base, endian) {
        if (number < 0) {
            this.negative = 1;
            number = -number;
        }
        if (number < 0x4000000) {
            this.words = [
                number & 0x3ffffff
            ];
            this.length = 1;
        } else if (number < 0x10000000000000) {
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff
            ];
            this.length = 2;
        } else {
            assert(number < 0x20000000000000); // 2 ^ 53 (unsafe)
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff,
                1
            ];
            this.length = 3;
        }
        if (endian !== "le") return;
        // Reverse the bytes
        this._initArray(this.toArray(), base, endian);
    };
    BN.prototype._initArray = function _initArray(number, base, endian) {
        // Perhaps a Uint8Array
        assert(typeof number.length === "number");
        if (number.length <= 0) {
            this.words = [
                0
            ];
            this.length = 1;
            return this;
        }
        this.length = Math.ceil(number.length / 3);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        var j, w;
        var off = 0;
        if (endian === "be") for(i = number.length - 1, j = 0; i >= 0; i -= 3){
            w = number[i] | number[i - 1] << 8 | number[i - 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        else if (endian === "le") for(i = 0, j = 0; i < number.length; i += 3){
            w = number[i] | number[i + 1] << 8 | number[i + 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        return this._strip();
    };
    function parseHex4Bits(string, index) {
        var c = string.charCodeAt(index);
        // '0' - '9'
        if (c >= 48 && c <= 57) return c - 48;
        else if (c >= 65 && c <= 70) return c - 55;
        else if (c >= 97 && c <= 102) return c - 87;
        else assert(false, "Invalid character in " + string);
    }
    function parseHexByte(string, lowerBound, index) {
        var r = parseHex4Bits(string, index);
        if (index - 1 >= lowerBound) r |= parseHex4Bits(string, index - 1) << 4;
        return r;
    }
    BN.prototype._parseHex = function _parseHex(number, start, endian) {
        // Create possibly bigger array to ensure that it fits the number
        this.length = Math.ceil((number.length - start) / 6);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        // 24-bits chunks
        var off = 0;
        var j = 0;
        var w;
        if (endian === "be") for(i = number.length - 1; i >= start; i -= 2){
            w = parseHexByte(number, start, i) << off;
            this.words[j] |= w & 0x3ffffff;
            if (off >= 18) {
                off -= 18;
                j += 1;
                this.words[j] |= w >>> 26;
            } else off += 8;
        }
        else {
            var parseLength = number.length - start;
            for(i = parseLength % 2 === 0 ? start + 1 : start; i < number.length; i += 2){
                w = parseHexByte(number, start, i) << off;
                this.words[j] |= w & 0x3ffffff;
                if (off >= 18) {
                    off -= 18;
                    j += 1;
                    this.words[j] |= w >>> 26;
                } else off += 8;
            }
        }
        this._strip();
    };
    function parseBase(str, start, end, mul) {
        var r = 0;
        var b = 0;
        var len = Math.min(str.length, end);
        for(var i = start; i < len; i++){
            var c = str.charCodeAt(i) - 48;
            r *= mul;
            // 'a'
            if (c >= 49) b = c - 49 + 0xa;
            else if (c >= 17) b = c - 17 + 0xa;
            else b = c;
            assert(c >= 0 && b < mul, "Invalid character");
            r += b;
        }
        return r;
    }
    BN.prototype._parseBase = function _parseBase(number, base, start) {
        // Initialize as zero
        this.words = [
            0
        ];
        this.length = 1;
        // Find length of limb in base
        for(var limbLen = 0, limbPow = 1; limbPow <= 0x3ffffff; limbPow *= base)limbLen++;
        limbLen--;
        limbPow = limbPow / base | 0;
        var total = number.length - start;
        var mod = total % limbLen;
        var end = Math.min(total, total - mod) + start;
        var word = 0;
        for(var i = start; i < end; i += limbLen){
            word = parseBase(number, i, i + limbLen, base);
            this.imuln(limbPow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        if (mod !== 0) {
            var pow = 1;
            word = parseBase(number, i, number.length, base);
            for(i = 0; i < mod; i++)pow *= base;
            this.imuln(pow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        this._strip();
    };
    BN.prototype.copy = function copy(dest) {
        dest.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)dest.words[i] = this.words[i];
        dest.length = this.length;
        dest.negative = this.negative;
        dest.red = this.red;
    };
    function move(dest, src) {
        dest.words = src.words;
        dest.length = src.length;
        dest.negative = src.negative;
        dest.red = src.red;
    }
    BN.prototype._move = function _move(dest) {
        move(dest, this);
    };
    BN.prototype.clone = function clone() {
        var r = new BN(null);
        this.copy(r);
        return r;
    };
    BN.prototype._expand = function _expand(size) {
        while(this.length < size)this.words[this.length++] = 0;
        return this;
    };
    // Remove leading `0` from `this`
    BN.prototype._strip = function strip() {
        while(this.length > 1 && this.words[this.length - 1] === 0)this.length--;
        return this._normSign();
    };
    BN.prototype._normSign = function _normSign() {
        // -0 = 0
        if (this.length === 1 && this.words[0] === 0) this.negative = 0;
        return this;
    };
    // Check Symbol.for because not everywhere where Symbol defined
    // See https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Symbol#Browser_compatibility
    if (typeof Symbol !== "undefined" && typeof Symbol.for === "function") try {
        BN.prototype[Symbol.for("nodejs.util.inspect.custom")] = inspect;
    } catch (e) {
        BN.prototype.inspect = inspect;
    }
    else BN.prototype.inspect = inspect;
    function inspect() {
        return (this.red ? "<BN-R: " : "<BN: ") + this.toString(16) + ">";
    }
    /*

  var zeros = [];
  var groupSizes = [];
  var groupBases = [];

  var s = '';
  var i = -1;
  while (++i < BN.wordSize) {
    zeros[i] = s;
    s += '0';
  }
  groupSizes[0] = 0;
  groupSizes[1] = 0;
  groupBases[0] = 0;
  groupBases[1] = 0;
  var base = 2 - 1;
  while (++base < 36 + 1) {
    var groupSize = 0;
    var groupBase = 1;
    while (groupBase < (1 << BN.wordSize) / base) {
      groupBase *= base;
      groupSize += 1;
    }
    groupSizes[base] = groupSize;
    groupBases[base] = groupBase;
  }

  */ var zeros = [
        "",
        "0",
        "00",
        "000",
        "0000",
        "00000",
        "000000",
        "0000000",
        "00000000",
        "000000000",
        "0000000000",
        "00000000000",
        "000000000000",
        "0000000000000",
        "00000000000000",
        "000000000000000",
        "0000000000000000",
        "00000000000000000",
        "000000000000000000",
        "0000000000000000000",
        "00000000000000000000",
        "000000000000000000000",
        "0000000000000000000000",
        "00000000000000000000000",
        "000000000000000000000000",
        "0000000000000000000000000"
    ];
    var groupSizes = [
        0,
        0,
        25,
        16,
        12,
        11,
        10,
        9,
        8,
        8,
        7,
        7,
        7,
        7,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5
    ];
    var groupBases = [
        0,
        0,
        33554432,
        43046721,
        16777216,
        48828125,
        60466176,
        40353607,
        16777216,
        43046721,
        10000000,
        19487171,
        35831808,
        62748517,
        7529536,
        11390625,
        16777216,
        24137569,
        34012224,
        47045881,
        64000000,
        4084101,
        5153632,
        6436343,
        7962624,
        9765625,
        11881376,
        14348907,
        17210368,
        20511149,
        24300000,
        28629151,
        33554432,
        39135393,
        45435424,
        52521875,
        60466176
    ];
    BN.prototype.toString = function toString(base, padding) {
        base = base || 10;
        padding = padding | 0 || 1;
        var out;
        if (base === 16 || base === "hex") {
            out = "";
            var off = 0;
            var carry = 0;
            for(var i = 0; i < this.length; i++){
                var w = this.words[i];
                var word = ((w << off | carry) & 0xffffff).toString(16);
                carry = w >>> 24 - off & 0xffffff;
                off += 2;
                if (off >= 26) {
                    off -= 26;
                    i--;
                }
                if (carry !== 0 || i !== this.length - 1) out = zeros[6 - word.length] + word + out;
                else out = word + out;
            }
            if (carry !== 0) out = carry.toString(16) + out;
            while(out.length % padding !== 0)out = "0" + out;
            if (this.negative !== 0) out = "-" + out;
            return out;
        }
        if (base === (base | 0) && base >= 2 && base <= 36) {
            // var groupSize = Math.floor(BN.wordSize * Math.LN2 / Math.log(base));
            var groupSize = groupSizes[base];
            // var groupBase = Math.pow(base, groupSize);
            var groupBase = groupBases[base];
            out = "";
            var c = this.clone();
            c.negative = 0;
            while(!c.isZero()){
                var r = c.modrn(groupBase).toString(base);
                c = c.idivn(groupBase);
                if (!c.isZero()) out = zeros[groupSize - r.length] + r + out;
                else out = r + out;
            }
            if (this.isZero()) out = "0" + out;
            while(out.length % padding !== 0)out = "0" + out;
            if (this.negative !== 0) out = "-" + out;
            return out;
        }
        assert(false, "Base should be between 2 and 36");
    };
    BN.prototype.toNumber = function toNumber() {
        var ret = this.words[0];
        if (this.length === 2) ret += this.words[1] * 0x4000000;
        else if (this.length === 3 && this.words[2] === 0x01) // NOTE: at this stage it is known that the top bit is set
        ret += 0x10000000000000 + this.words[1] * 0x4000000;
        else if (this.length > 2) assert(false, "Number can only safely store up to 53 bits");
        return this.negative !== 0 ? -ret : ret;
    };
    BN.prototype.toJSON = function toJSON() {
        return this.toString(16, 2);
    };
    if (Buffer) BN.prototype.toBuffer = function toBuffer(endian, length) {
        return this.toArrayLike(Buffer, endian, length);
    };
    BN.prototype.toArray = function toArray(endian, length) {
        return this.toArrayLike(Array, endian, length);
    };
    var allocate = function allocate(ArrayType, size) {
        if (ArrayType.allocUnsafe) return ArrayType.allocUnsafe(size);
        return new ArrayType(size);
    };
    BN.prototype.toArrayLike = function toArrayLike(ArrayType, endian, length) {
        this._strip();
        var byteLength = this.byteLength();
        var reqLength = length || Math.max(1, byteLength);
        assert(byteLength <= reqLength, "byte array longer than desired length");
        assert(reqLength > 0, "Requested array length <= 0");
        var res = allocate(ArrayType, reqLength);
        var postfix = endian === "le" ? "LE" : "BE";
        this["_toArrayLike" + postfix](res, byteLength);
        return res;
    };
    BN.prototype._toArrayLikeLE = function _toArrayLikeLE(res, byteLength) {
        var position = 0;
        var carry = 0;
        for(var i = 0, shift = 0; i < this.length; i++){
            var word = this.words[i] << shift | carry;
            res[position++] = word & 0xff;
            if (position < res.length) res[position++] = word >> 8 & 0xff;
            if (position < res.length) res[position++] = word >> 16 & 0xff;
            if (shift === 6) {
                if (position < res.length) res[position++] = word >> 24 & 0xff;
                carry = 0;
                shift = 0;
            } else {
                carry = word >>> 24;
                shift += 2;
            }
        }
        if (position < res.length) {
            res[position++] = carry;
            while(position < res.length)res[position++] = 0;
        }
    };
    BN.prototype._toArrayLikeBE = function _toArrayLikeBE(res, byteLength) {
        var position = res.length - 1;
        var carry = 0;
        for(var i = 0, shift = 0; i < this.length; i++){
            var word = this.words[i] << shift | carry;
            res[position--] = word & 0xff;
            if (position >= 0) res[position--] = word >> 8 & 0xff;
            if (position >= 0) res[position--] = word >> 16 & 0xff;
            if (shift === 6) {
                if (position >= 0) res[position--] = word >> 24 & 0xff;
                carry = 0;
                shift = 0;
            } else {
                carry = word >>> 24;
                shift += 2;
            }
        }
        if (position >= 0) {
            res[position--] = carry;
            while(position >= 0)res[position--] = 0;
        }
    };
    if (Math.clz32) BN.prototype._countBits = function _countBits(w) {
        return 32 - Math.clz32(w);
    };
    else BN.prototype._countBits = function _countBits(w) {
        var t = w;
        var r = 0;
        if (t >= 0x1000) {
            r += 13;
            t >>>= 13;
        }
        if (t >= 0x40) {
            r += 7;
            t >>>= 7;
        }
        if (t >= 0x8) {
            r += 4;
            t >>>= 4;
        }
        if (t >= 0x02) {
            r += 2;
            t >>>= 2;
        }
        return r + t;
    };
    BN.prototype._zeroBits = function _zeroBits(w) {
        // Short-cut
        if (w === 0) return 26;
        var t = w;
        var r = 0;
        if ((t & 0x1fff) === 0) {
            r += 13;
            t >>>= 13;
        }
        if ((t & 0x7f) === 0) {
            r += 7;
            t >>>= 7;
        }
        if ((t & 0xf) === 0) {
            r += 4;
            t >>>= 4;
        }
        if ((t & 0x3) === 0) {
            r += 2;
            t >>>= 2;
        }
        if ((t & 0x1) === 0) r++;
        return r;
    };
    // Return number of used bits in a BN
    BN.prototype.bitLength = function bitLength() {
        var w = this.words[this.length - 1];
        var hi = this._countBits(w);
        return (this.length - 1) * 26 + hi;
    };
    function toBitArray(num) {
        var w = new Array(num.bitLength());
        for(var bit = 0; bit < w.length; bit++){
            var off = bit / 26 | 0;
            var wbit = bit % 26;
            w[bit] = num.words[off] >>> wbit & 0x01;
        }
        return w;
    }
    // Number of trailing zero bits
    BN.prototype.zeroBits = function zeroBits() {
        if (this.isZero()) return 0;
        var r = 0;
        for(var i = 0; i < this.length; i++){
            var b = this._zeroBits(this.words[i]);
            r += b;
            if (b !== 26) break;
        }
        return r;
    };
    BN.prototype.byteLength = function byteLength() {
        return Math.ceil(this.bitLength() / 8);
    };
    BN.prototype.toTwos = function toTwos(width) {
        if (this.negative !== 0) return this.abs().inotn(width).iaddn(1);
        return this.clone();
    };
    BN.prototype.fromTwos = function fromTwos(width) {
        if (this.testn(width - 1)) return this.notn(width).iaddn(1).ineg();
        return this.clone();
    };
    BN.prototype.isNeg = function isNeg() {
        return this.negative !== 0;
    };
    // Return negative clone of `this`
    BN.prototype.neg = function neg() {
        return this.clone().ineg();
    };
    BN.prototype.ineg = function ineg() {
        if (!this.isZero()) this.negative ^= 1;
        return this;
    };
    // Or `num` with `this` in-place
    BN.prototype.iuor = function iuor(num) {
        while(this.length < num.length)this.words[this.length++] = 0;
        for(var i = 0; i < num.length; i++)this.words[i] = this.words[i] | num.words[i];
        return this._strip();
    };
    BN.prototype.ior = function ior(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuor(num);
    };
    // Or `num` with `this`
    BN.prototype.or = function or(num) {
        if (this.length > num.length) return this.clone().ior(num);
        return num.clone().ior(this);
    };
    BN.prototype.uor = function uor(num) {
        if (this.length > num.length) return this.clone().iuor(num);
        return num.clone().iuor(this);
    };
    // And `num` with `this` in-place
    BN.prototype.iuand = function iuand(num) {
        // b = min-length(num, this)
        var b;
        if (this.length > num.length) b = num;
        else b = this;
        for(var i = 0; i < b.length; i++)this.words[i] = this.words[i] & num.words[i];
        this.length = b.length;
        return this._strip();
    };
    BN.prototype.iand = function iand(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuand(num);
    };
    // And `num` with `this`
    BN.prototype.and = function and(num) {
        if (this.length > num.length) return this.clone().iand(num);
        return num.clone().iand(this);
    };
    BN.prototype.uand = function uand(num) {
        if (this.length > num.length) return this.clone().iuand(num);
        return num.clone().iuand(this);
    };
    // Xor `num` with `this` in-place
    BN.prototype.iuxor = function iuxor(num) {
        // a.length > b.length
        var a;
        var b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        for(var i = 0; i < b.length; i++)this.words[i] = a.words[i] ^ b.words[i];
        if (this !== a) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = a.length;
        return this._strip();
    };
    BN.prototype.ixor = function ixor(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuxor(num);
    };
    // Xor `num` with `this`
    BN.prototype.xor = function xor(num) {
        if (this.length > num.length) return this.clone().ixor(num);
        return num.clone().ixor(this);
    };
    BN.prototype.uxor = function uxor(num) {
        if (this.length > num.length) return this.clone().iuxor(num);
        return num.clone().iuxor(this);
    };
    // Not ``this`` with ``width`` bitwidth
    BN.prototype.inotn = function inotn(width) {
        assert(typeof width === "number" && width >= 0);
        var bytesNeeded = Math.ceil(width / 26) | 0;
        var bitsLeft = width % 26;
        // Extend the buffer with leading zeroes
        this._expand(bytesNeeded);
        if (bitsLeft > 0) bytesNeeded--;
        // Handle complete words
        for(var i = 0; i < bytesNeeded; i++)this.words[i] = ~this.words[i] & 0x3ffffff;
        // Handle the residue
        if (bitsLeft > 0) this.words[i] = ~this.words[i] & 0x3ffffff >> 26 - bitsLeft;
        // And remove leading zeroes
        return this._strip();
    };
    BN.prototype.notn = function notn(width) {
        return this.clone().inotn(width);
    };
    // Set `bit` of `this`
    BN.prototype.setn = function setn(bit, val) {
        assert(typeof bit === "number" && bit >= 0);
        var off = bit / 26 | 0;
        var wbit = bit % 26;
        this._expand(off + 1);
        if (val) this.words[off] = this.words[off] | 1 << wbit;
        else this.words[off] = this.words[off] & ~(1 << wbit);
        return this._strip();
    };
    // Add `num` to `this` in-place
    BN.prototype.iadd = function iadd(num) {
        var r;
        // negative + positive
        if (this.negative !== 0 && num.negative === 0) {
            this.negative = 0;
            r = this.isub(num);
            this.negative ^= 1;
            return this._normSign();
        // positive + negative
        } else if (this.negative === 0 && num.negative !== 0) {
            num.negative = 0;
            r = this.isub(num);
            num.negative = 1;
            return r._normSign();
        }
        // a.length > b.length
        var a, b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) + (b.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        this.length = a.length;
        if (carry !== 0) {
            this.words[this.length] = carry;
            this.length++;
        // Copy the rest of the words
        } else if (a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        return this;
    };
    // Add `num` to `this`
    BN.prototype.add = function add(num) {
        var res;
        if (num.negative !== 0 && this.negative === 0) {
            num.negative = 0;
            res = this.sub(num);
            num.negative ^= 1;
            return res;
        } else if (num.negative === 0 && this.negative !== 0) {
            this.negative = 0;
            res = num.sub(this);
            this.negative = 1;
            return res;
        }
        if (this.length > num.length) return this.clone().iadd(num);
        return num.clone().iadd(this);
    };
    // Subtract `num` from `this` in-place
    BN.prototype.isub = function isub(num) {
        // this - (-num) = this + num
        if (num.negative !== 0) {
            num.negative = 0;
            var r = this.iadd(num);
            num.negative = 1;
            return r._normSign();
        // -this - num = -(this + num)
        } else if (this.negative !== 0) {
            this.negative = 0;
            this.iadd(num);
            this.negative = 1;
            return this._normSign();
        }
        // At this point both numbers are positive
        var cmp = this.cmp(num);
        // Optimization - zeroify
        if (cmp === 0) {
            this.negative = 0;
            this.length = 1;
            this.words[0] = 0;
            return this;
        }
        // a > b
        var a, b;
        if (cmp > 0) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) - (b.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        // Copy rest of the words
        if (carry === 0 && i < a.length && a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = Math.max(this.length, i);
        if (a !== this) this.negative = 1;
        return this._strip();
    };
    // Subtract `num` from `this`
    BN.prototype.sub = function sub(num) {
        return this.clone().isub(num);
    };
    function smallMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        var len = self.length + num.length | 0;
        out.length = len;
        len = len - 1 | 0;
        // Peel one iteration (compiler can't do it, because of code complexity)
        var a = self.words[0] | 0;
        var b = num.words[0] | 0;
        var r = a * b;
        var lo = r & 0x3ffffff;
        var carry = r / 0x4000000 | 0;
        out.words[0] = lo;
        for(var k = 1; k < len; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = carry >>> 26;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j | 0;
                a = self.words[i] | 0;
                b = num.words[j] | 0;
                r = a * b + rword;
                ncarry += r / 0x4000000 | 0;
                rword = r & 0x3ffffff;
            }
            out.words[k] = rword | 0;
            carry = ncarry | 0;
        }
        if (carry !== 0) out.words[k] = carry | 0;
        else out.length--;
        return out._strip();
    }
    // TODO(indutny): it may be reasonable to omit it for users who don't need
    // to work with 256-bit numbers, otherwise it gives 20% improvement for 256-bit
    // multiplication (like elliptic secp256k1).
    var comb10MulTo = function comb10MulTo(self, num, out) {
        var a = self.words;
        var b = num.words;
        var o = out.words;
        var c = 0;
        var lo;
        var mid;
        var hi;
        var a0 = a[0] | 0;
        var al0 = a0 & 0x1fff;
        var ah0 = a0 >>> 13;
        var a1 = a[1] | 0;
        var al1 = a1 & 0x1fff;
        var ah1 = a1 >>> 13;
        var a2 = a[2] | 0;
        var al2 = a2 & 0x1fff;
        var ah2 = a2 >>> 13;
        var a3 = a[3] | 0;
        var al3 = a3 & 0x1fff;
        var ah3 = a3 >>> 13;
        var a4 = a[4] | 0;
        var al4 = a4 & 0x1fff;
        var ah4 = a4 >>> 13;
        var a5 = a[5] | 0;
        var al5 = a5 & 0x1fff;
        var ah5 = a5 >>> 13;
        var a6 = a[6] | 0;
        var al6 = a6 & 0x1fff;
        var ah6 = a6 >>> 13;
        var a7 = a[7] | 0;
        var al7 = a7 & 0x1fff;
        var ah7 = a7 >>> 13;
        var a8 = a[8] | 0;
        var al8 = a8 & 0x1fff;
        var ah8 = a8 >>> 13;
        var a9 = a[9] | 0;
        var al9 = a9 & 0x1fff;
        var ah9 = a9 >>> 13;
        var b0 = b[0] | 0;
        var bl0 = b0 & 0x1fff;
        var bh0 = b0 >>> 13;
        var b1 = b[1] | 0;
        var bl1 = b1 & 0x1fff;
        var bh1 = b1 >>> 13;
        var b2 = b[2] | 0;
        var bl2 = b2 & 0x1fff;
        var bh2 = b2 >>> 13;
        var b3 = b[3] | 0;
        var bl3 = b3 & 0x1fff;
        var bh3 = b3 >>> 13;
        var b4 = b[4] | 0;
        var bl4 = b4 & 0x1fff;
        var bh4 = b4 >>> 13;
        var b5 = b[5] | 0;
        var bl5 = b5 & 0x1fff;
        var bh5 = b5 >>> 13;
        var b6 = b[6] | 0;
        var bl6 = b6 & 0x1fff;
        var bh6 = b6 >>> 13;
        var b7 = b[7] | 0;
        var bl7 = b7 & 0x1fff;
        var bh7 = b7 >>> 13;
        var b8 = b[8] | 0;
        var bl8 = b8 & 0x1fff;
        var bh8 = b8 >>> 13;
        var b9 = b[9] | 0;
        var bl9 = b9 & 0x1fff;
        var bh9 = b9 >>> 13;
        out.negative = self.negative ^ num.negative;
        out.length = 19;
        /* k = 0 */ lo = Math.imul(al0, bl0);
        mid = Math.imul(al0, bh0);
        mid = mid + Math.imul(ah0, bl0) | 0;
        hi = Math.imul(ah0, bh0);
        var w0 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w0 >>> 26) | 0;
        w0 &= 0x3ffffff;
        /* k = 1 */ lo = Math.imul(al1, bl0);
        mid = Math.imul(al1, bh0);
        mid = mid + Math.imul(ah1, bl0) | 0;
        hi = Math.imul(ah1, bh0);
        lo = lo + Math.imul(al0, bl1) | 0;
        mid = mid + Math.imul(al0, bh1) | 0;
        mid = mid + Math.imul(ah0, bl1) | 0;
        hi = hi + Math.imul(ah0, bh1) | 0;
        var w1 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w1 >>> 26) | 0;
        w1 &= 0x3ffffff;
        /* k = 2 */ lo = Math.imul(al2, bl0);
        mid = Math.imul(al2, bh0);
        mid = mid + Math.imul(ah2, bl0) | 0;
        hi = Math.imul(ah2, bh0);
        lo = lo + Math.imul(al1, bl1) | 0;
        mid = mid + Math.imul(al1, bh1) | 0;
        mid = mid + Math.imul(ah1, bl1) | 0;
        hi = hi + Math.imul(ah1, bh1) | 0;
        lo = lo + Math.imul(al0, bl2) | 0;
        mid = mid + Math.imul(al0, bh2) | 0;
        mid = mid + Math.imul(ah0, bl2) | 0;
        hi = hi + Math.imul(ah0, bh2) | 0;
        var w2 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w2 >>> 26) | 0;
        w2 &= 0x3ffffff;
        /* k = 3 */ lo = Math.imul(al3, bl0);
        mid = Math.imul(al3, bh0);
        mid = mid + Math.imul(ah3, bl0) | 0;
        hi = Math.imul(ah3, bh0);
        lo = lo + Math.imul(al2, bl1) | 0;
        mid = mid + Math.imul(al2, bh1) | 0;
        mid = mid + Math.imul(ah2, bl1) | 0;
        hi = hi + Math.imul(ah2, bh1) | 0;
        lo = lo + Math.imul(al1, bl2) | 0;
        mid = mid + Math.imul(al1, bh2) | 0;
        mid = mid + Math.imul(ah1, bl2) | 0;
        hi = hi + Math.imul(ah1, bh2) | 0;
        lo = lo + Math.imul(al0, bl3) | 0;
        mid = mid + Math.imul(al0, bh3) | 0;
        mid = mid + Math.imul(ah0, bl3) | 0;
        hi = hi + Math.imul(ah0, bh3) | 0;
        var w3 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w3 >>> 26) | 0;
        w3 &= 0x3ffffff;
        /* k = 4 */ lo = Math.imul(al4, bl0);
        mid = Math.imul(al4, bh0);
        mid = mid + Math.imul(ah4, bl0) | 0;
        hi = Math.imul(ah4, bh0);
        lo = lo + Math.imul(al3, bl1) | 0;
        mid = mid + Math.imul(al3, bh1) | 0;
        mid = mid + Math.imul(ah3, bl1) | 0;
        hi = hi + Math.imul(ah3, bh1) | 0;
        lo = lo + Math.imul(al2, bl2) | 0;
        mid = mid + Math.imul(al2, bh2) | 0;
        mid = mid + Math.imul(ah2, bl2) | 0;
        hi = hi + Math.imul(ah2, bh2) | 0;
        lo = lo + Math.imul(al1, bl3) | 0;
        mid = mid + Math.imul(al1, bh3) | 0;
        mid = mid + Math.imul(ah1, bl3) | 0;
        hi = hi + Math.imul(ah1, bh3) | 0;
        lo = lo + Math.imul(al0, bl4) | 0;
        mid = mid + Math.imul(al0, bh4) | 0;
        mid = mid + Math.imul(ah0, bl4) | 0;
        hi = hi + Math.imul(ah0, bh4) | 0;
        var w4 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w4 >>> 26) | 0;
        w4 &= 0x3ffffff;
        /* k = 5 */ lo = Math.imul(al5, bl0);
        mid = Math.imul(al5, bh0);
        mid = mid + Math.imul(ah5, bl0) | 0;
        hi = Math.imul(ah5, bh0);
        lo = lo + Math.imul(al4, bl1) | 0;
        mid = mid + Math.imul(al4, bh1) | 0;
        mid = mid + Math.imul(ah4, bl1) | 0;
        hi = hi + Math.imul(ah4, bh1) | 0;
        lo = lo + Math.imul(al3, bl2) | 0;
        mid = mid + Math.imul(al3, bh2) | 0;
        mid = mid + Math.imul(ah3, bl2) | 0;
        hi = hi + Math.imul(ah3, bh2) | 0;
        lo = lo + Math.imul(al2, bl3) | 0;
        mid = mid + Math.imul(al2, bh3) | 0;
        mid = mid + Math.imul(ah2, bl3) | 0;
        hi = hi + Math.imul(ah2, bh3) | 0;
        lo = lo + Math.imul(al1, bl4) | 0;
        mid = mid + Math.imul(al1, bh4) | 0;
        mid = mid + Math.imul(ah1, bl4) | 0;
        hi = hi + Math.imul(ah1, bh4) | 0;
        lo = lo + Math.imul(al0, bl5) | 0;
        mid = mid + Math.imul(al0, bh5) | 0;
        mid = mid + Math.imul(ah0, bl5) | 0;
        hi = hi + Math.imul(ah0, bh5) | 0;
        var w5 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w5 >>> 26) | 0;
        w5 &= 0x3ffffff;
        /* k = 6 */ lo = Math.imul(al6, bl0);
        mid = Math.imul(al6, bh0);
        mid = mid + Math.imul(ah6, bl0) | 0;
        hi = Math.imul(ah6, bh0);
        lo = lo + Math.imul(al5, bl1) | 0;
        mid = mid + Math.imul(al5, bh1) | 0;
        mid = mid + Math.imul(ah5, bl1) | 0;
        hi = hi + Math.imul(ah5, bh1) | 0;
        lo = lo + Math.imul(al4, bl2) | 0;
        mid = mid + Math.imul(al4, bh2) | 0;
        mid = mid + Math.imul(ah4, bl2) | 0;
        hi = hi + Math.imul(ah4, bh2) | 0;
        lo = lo + Math.imul(al3, bl3) | 0;
        mid = mid + Math.imul(al3, bh3) | 0;
        mid = mid + Math.imul(ah3, bl3) | 0;
        hi = hi + Math.imul(ah3, bh3) | 0;
        lo = lo + Math.imul(al2, bl4) | 0;
        mid = mid + Math.imul(al2, bh4) | 0;
        mid = mid + Math.imul(ah2, bl4) | 0;
        hi = hi + Math.imul(ah2, bh4) | 0;
        lo = lo + Math.imul(al1, bl5) | 0;
        mid = mid + Math.imul(al1, bh5) | 0;
        mid = mid + Math.imul(ah1, bl5) | 0;
        hi = hi + Math.imul(ah1, bh5) | 0;
        lo = lo + Math.imul(al0, bl6) | 0;
        mid = mid + Math.imul(al0, bh6) | 0;
        mid = mid + Math.imul(ah0, bl6) | 0;
        hi = hi + Math.imul(ah0, bh6) | 0;
        var w6 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w6 >>> 26) | 0;
        w6 &= 0x3ffffff;
        /* k = 7 */ lo = Math.imul(al7, bl0);
        mid = Math.imul(al7, bh0);
        mid = mid + Math.imul(ah7, bl0) | 0;
        hi = Math.imul(ah7, bh0);
        lo = lo + Math.imul(al6, bl1) | 0;
        mid = mid + Math.imul(al6, bh1) | 0;
        mid = mid + Math.imul(ah6, bl1) | 0;
        hi = hi + Math.imul(ah6, bh1) | 0;
        lo = lo + Math.imul(al5, bl2) | 0;
        mid = mid + Math.imul(al5, bh2) | 0;
        mid = mid + Math.imul(ah5, bl2) | 0;
        hi = hi + Math.imul(ah5, bh2) | 0;
        lo = lo + Math.imul(al4, bl3) | 0;
        mid = mid + Math.imul(al4, bh3) | 0;
        mid = mid + Math.imul(ah4, bl3) | 0;
        hi = hi + Math.imul(ah4, bh3) | 0;
        lo = lo + Math.imul(al3, bl4) | 0;
        mid = mid + Math.imul(al3, bh4) | 0;
        mid = mid + Math.imul(ah3, bl4) | 0;
        hi = hi + Math.imul(ah3, bh4) | 0;
        lo = lo + Math.imul(al2, bl5) | 0;
        mid = mid + Math.imul(al2, bh5) | 0;
        mid = mid + Math.imul(ah2, bl5) | 0;
        hi = hi + Math.imul(ah2, bh5) | 0;
        lo = lo + Math.imul(al1, bl6) | 0;
        mid = mid + Math.imul(al1, bh6) | 0;
        mid = mid + Math.imul(ah1, bl6) | 0;
        hi = hi + Math.imul(ah1, bh6) | 0;
        lo = lo + Math.imul(al0, bl7) | 0;
        mid = mid + Math.imul(al0, bh7) | 0;
        mid = mid + Math.imul(ah0, bl7) | 0;
        hi = hi + Math.imul(ah0, bh7) | 0;
        var w7 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w7 >>> 26) | 0;
        w7 &= 0x3ffffff;
        /* k = 8 */ lo = Math.imul(al8, bl0);
        mid = Math.imul(al8, bh0);
        mid = mid + Math.imul(ah8, bl0) | 0;
        hi = Math.imul(ah8, bh0);
        lo = lo + Math.imul(al7, bl1) | 0;
        mid = mid + Math.imul(al7, bh1) | 0;
        mid = mid + Math.imul(ah7, bl1) | 0;
        hi = hi + Math.imul(ah7, bh1) | 0;
        lo = lo + Math.imul(al6, bl2) | 0;
        mid = mid + Math.imul(al6, bh2) | 0;
        mid = mid + Math.imul(ah6, bl2) | 0;
        hi = hi + Math.imul(ah6, bh2) | 0;
        lo = lo + Math.imul(al5, bl3) | 0;
        mid = mid + Math.imul(al5, bh3) | 0;
        mid = mid + Math.imul(ah5, bl3) | 0;
        hi = hi + Math.imul(ah5, bh3) | 0;
        lo = lo + Math.imul(al4, bl4) | 0;
        mid = mid + Math.imul(al4, bh4) | 0;
        mid = mid + Math.imul(ah4, bl4) | 0;
        hi = hi + Math.imul(ah4, bh4) | 0;
        lo = lo + Math.imul(al3, bl5) | 0;
        mid = mid + Math.imul(al3, bh5) | 0;
        mid = mid + Math.imul(ah3, bl5) | 0;
        hi = hi + Math.imul(ah3, bh5) | 0;
        lo = lo + Math.imul(al2, bl6) | 0;
        mid = mid + Math.imul(al2, bh6) | 0;
        mid = mid + Math.imul(ah2, bl6) | 0;
        hi = hi + Math.imul(ah2, bh6) | 0;
        lo = lo + Math.imul(al1, bl7) | 0;
        mid = mid + Math.imul(al1, bh7) | 0;
        mid = mid + Math.imul(ah1, bl7) | 0;
        hi = hi + Math.imul(ah1, bh7) | 0;
        lo = lo + Math.imul(al0, bl8) | 0;
        mid = mid + Math.imul(al0, bh8) | 0;
        mid = mid + Math.imul(ah0, bl8) | 0;
        hi = hi + Math.imul(ah0, bh8) | 0;
        var w8 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w8 >>> 26) | 0;
        w8 &= 0x3ffffff;
        /* k = 9 */ lo = Math.imul(al9, bl0);
        mid = Math.imul(al9, bh0);
        mid = mid + Math.imul(ah9, bl0) | 0;
        hi = Math.imul(ah9, bh0);
        lo = lo + Math.imul(al8, bl1) | 0;
        mid = mid + Math.imul(al8, bh1) | 0;
        mid = mid + Math.imul(ah8, bl1) | 0;
        hi = hi + Math.imul(ah8, bh1) | 0;
        lo = lo + Math.imul(al7, bl2) | 0;
        mid = mid + Math.imul(al7, bh2) | 0;
        mid = mid + Math.imul(ah7, bl2) | 0;
        hi = hi + Math.imul(ah7, bh2) | 0;
        lo = lo + Math.imul(al6, bl3) | 0;
        mid = mid + Math.imul(al6, bh3) | 0;
        mid = mid + Math.imul(ah6, bl3) | 0;
        hi = hi + Math.imul(ah6, bh3) | 0;
        lo = lo + Math.imul(al5, bl4) | 0;
        mid = mid + Math.imul(al5, bh4) | 0;
        mid = mid + Math.imul(ah5, bl4) | 0;
        hi = hi + Math.imul(ah5, bh4) | 0;
        lo = lo + Math.imul(al4, bl5) | 0;
        mid = mid + Math.imul(al4, bh5) | 0;
        mid = mid + Math.imul(ah4, bl5) | 0;
        hi = hi + Math.imul(ah4, bh5) | 0;
        lo = lo + Math.imul(al3, bl6) | 0;
        mid = mid + Math.imul(al3, bh6) | 0;
        mid = mid + Math.imul(ah3, bl6) | 0;
        hi = hi + Math.imul(ah3, bh6) | 0;
        lo = lo + Math.imul(al2, bl7) | 0;
        mid = mid + Math.imul(al2, bh7) | 0;
        mid = mid + Math.imul(ah2, bl7) | 0;
        hi = hi + Math.imul(ah2, bh7) | 0;
        lo = lo + Math.imul(al1, bl8) | 0;
        mid = mid + Math.imul(al1, bh8) | 0;
        mid = mid + Math.imul(ah1, bl8) | 0;
        hi = hi + Math.imul(ah1, bh8) | 0;
        lo = lo + Math.imul(al0, bl9) | 0;
        mid = mid + Math.imul(al0, bh9) | 0;
        mid = mid + Math.imul(ah0, bl9) | 0;
        hi = hi + Math.imul(ah0, bh9) | 0;
        var w9 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w9 >>> 26) | 0;
        w9 &= 0x3ffffff;
        /* k = 10 */ lo = Math.imul(al9, bl1);
        mid = Math.imul(al9, bh1);
        mid = mid + Math.imul(ah9, bl1) | 0;
        hi = Math.imul(ah9, bh1);
        lo = lo + Math.imul(al8, bl2) | 0;
        mid = mid + Math.imul(al8, bh2) | 0;
        mid = mid + Math.imul(ah8, bl2) | 0;
        hi = hi + Math.imul(ah8, bh2) | 0;
        lo = lo + Math.imul(al7, bl3) | 0;
        mid = mid + Math.imul(al7, bh3) | 0;
        mid = mid + Math.imul(ah7, bl3) | 0;
        hi = hi + Math.imul(ah7, bh3) | 0;
        lo = lo + Math.imul(al6, bl4) | 0;
        mid = mid + Math.imul(al6, bh4) | 0;
        mid = mid + Math.imul(ah6, bl4) | 0;
        hi = hi + Math.imul(ah6, bh4) | 0;
        lo = lo + Math.imul(al5, bl5) | 0;
        mid = mid + Math.imul(al5, bh5) | 0;
        mid = mid + Math.imul(ah5, bl5) | 0;
        hi = hi + Math.imul(ah5, bh5) | 0;
        lo = lo + Math.imul(al4, bl6) | 0;
        mid = mid + Math.imul(al4, bh6) | 0;
        mid = mid + Math.imul(ah4, bl6) | 0;
        hi = hi + Math.imul(ah4, bh6) | 0;
        lo = lo + Math.imul(al3, bl7) | 0;
        mid = mid + Math.imul(al3, bh7) | 0;
        mid = mid + Math.imul(ah3, bl7) | 0;
        hi = hi + Math.imul(ah3, bh7) | 0;
        lo = lo + Math.imul(al2, bl8) | 0;
        mid = mid + Math.imul(al2, bh8) | 0;
        mid = mid + Math.imul(ah2, bl8) | 0;
        hi = hi + Math.imul(ah2, bh8) | 0;
        lo = lo + Math.imul(al1, bl9) | 0;
        mid = mid + Math.imul(al1, bh9) | 0;
        mid = mid + Math.imul(ah1, bl9) | 0;
        hi = hi + Math.imul(ah1, bh9) | 0;
        var w10 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w10 >>> 26) | 0;
        w10 &= 0x3ffffff;
        /* k = 11 */ lo = Math.imul(al9, bl2);
        mid = Math.imul(al9, bh2);
        mid = mid + Math.imul(ah9, bl2) | 0;
        hi = Math.imul(ah9, bh2);
        lo = lo + Math.imul(al8, bl3) | 0;
        mid = mid + Math.imul(al8, bh3) | 0;
        mid = mid + Math.imul(ah8, bl3) | 0;
        hi = hi + Math.imul(ah8, bh3) | 0;
        lo = lo + Math.imul(al7, bl4) | 0;
        mid = mid + Math.imul(al7, bh4) | 0;
        mid = mid + Math.imul(ah7, bl4) | 0;
        hi = hi + Math.imul(ah7, bh4) | 0;
        lo = lo + Math.imul(al6, bl5) | 0;
        mid = mid + Math.imul(al6, bh5) | 0;
        mid = mid + Math.imul(ah6, bl5) | 0;
        hi = hi + Math.imul(ah6, bh5) | 0;
        lo = lo + Math.imul(al5, bl6) | 0;
        mid = mid + Math.imul(al5, bh6) | 0;
        mid = mid + Math.imul(ah5, bl6) | 0;
        hi = hi + Math.imul(ah5, bh6) | 0;
        lo = lo + Math.imul(al4, bl7) | 0;
        mid = mid + Math.imul(al4, bh7) | 0;
        mid = mid + Math.imul(ah4, bl7) | 0;
        hi = hi + Math.imul(ah4, bh7) | 0;
        lo = lo + Math.imul(al3, bl8) | 0;
        mid = mid + Math.imul(al3, bh8) | 0;
        mid = mid + Math.imul(ah3, bl8) | 0;
        hi = hi + Math.imul(ah3, bh8) | 0;
        lo = lo + Math.imul(al2, bl9) | 0;
        mid = mid + Math.imul(al2, bh9) | 0;
        mid = mid + Math.imul(ah2, bl9) | 0;
        hi = hi + Math.imul(ah2, bh9) | 0;
        var w11 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w11 >>> 26) | 0;
        w11 &= 0x3ffffff;
        /* k = 12 */ lo = Math.imul(al9, bl3);
        mid = Math.imul(al9, bh3);
        mid = mid + Math.imul(ah9, bl3) | 0;
        hi = Math.imul(ah9, bh3);
        lo = lo + Math.imul(al8, bl4) | 0;
        mid = mid + Math.imul(al8, bh4) | 0;
        mid = mid + Math.imul(ah8, bl4) | 0;
        hi = hi + Math.imul(ah8, bh4) | 0;
        lo = lo + Math.imul(al7, bl5) | 0;
        mid = mid + Math.imul(al7, bh5) | 0;
        mid = mid + Math.imul(ah7, bl5) | 0;
        hi = hi + Math.imul(ah7, bh5) | 0;
        lo = lo + Math.imul(al6, bl6) | 0;
        mid = mid + Math.imul(al6, bh6) | 0;
        mid = mid + Math.imul(ah6, bl6) | 0;
        hi = hi + Math.imul(ah6, bh6) | 0;
        lo = lo + Math.imul(al5, bl7) | 0;
        mid = mid + Math.imul(al5, bh7) | 0;
        mid = mid + Math.imul(ah5, bl7) | 0;
        hi = hi + Math.imul(ah5, bh7) | 0;
        lo = lo + Math.imul(al4, bl8) | 0;
        mid = mid + Math.imul(al4, bh8) | 0;
        mid = mid + Math.imul(ah4, bl8) | 0;
        hi = hi + Math.imul(ah4, bh8) | 0;
        lo = lo + Math.imul(al3, bl9) | 0;
        mid = mid + Math.imul(al3, bh9) | 0;
        mid = mid + Math.imul(ah3, bl9) | 0;
        hi = hi + Math.imul(ah3, bh9) | 0;
        var w12 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w12 >>> 26) | 0;
        w12 &= 0x3ffffff;
        /* k = 13 */ lo = Math.imul(al9, bl4);
        mid = Math.imul(al9, bh4);
        mid = mid + Math.imul(ah9, bl4) | 0;
        hi = Math.imul(ah9, bh4);
        lo = lo + Math.imul(al8, bl5) | 0;
        mid = mid + Math.imul(al8, bh5) | 0;
        mid = mid + Math.imul(ah8, bl5) | 0;
        hi = hi + Math.imul(ah8, bh5) | 0;
        lo = lo + Math.imul(al7, bl6) | 0;
        mid = mid + Math.imul(al7, bh6) | 0;
        mid = mid + Math.imul(ah7, bl6) | 0;
        hi = hi + Math.imul(ah7, bh6) | 0;
        lo = lo + Math.imul(al6, bl7) | 0;
        mid = mid + Math.imul(al6, bh7) | 0;
        mid = mid + Math.imul(ah6, bl7) | 0;
        hi = hi + Math.imul(ah6, bh7) | 0;
        lo = lo + Math.imul(al5, bl8) | 0;
        mid = mid + Math.imul(al5, bh8) | 0;
        mid = mid + Math.imul(ah5, bl8) | 0;
        hi = hi + Math.imul(ah5, bh8) | 0;
        lo = lo + Math.imul(al4, bl9) | 0;
        mid = mid + Math.imul(al4, bh9) | 0;
        mid = mid + Math.imul(ah4, bl9) | 0;
        hi = hi + Math.imul(ah4, bh9) | 0;
        var w13 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w13 >>> 26) | 0;
        w13 &= 0x3ffffff;
        /* k = 14 */ lo = Math.imul(al9, bl5);
        mid = Math.imul(al9, bh5);
        mid = mid + Math.imul(ah9, bl5) | 0;
        hi = Math.imul(ah9, bh5);
        lo = lo + Math.imul(al8, bl6) | 0;
        mid = mid + Math.imul(al8, bh6) | 0;
        mid = mid + Math.imul(ah8, bl6) | 0;
        hi = hi + Math.imul(ah8, bh6) | 0;
        lo = lo + Math.imul(al7, bl7) | 0;
        mid = mid + Math.imul(al7, bh7) | 0;
        mid = mid + Math.imul(ah7, bl7) | 0;
        hi = hi + Math.imul(ah7, bh7) | 0;
        lo = lo + Math.imul(al6, bl8) | 0;
        mid = mid + Math.imul(al6, bh8) | 0;
        mid = mid + Math.imul(ah6, bl8) | 0;
        hi = hi + Math.imul(ah6, bh8) | 0;
        lo = lo + Math.imul(al5, bl9) | 0;
        mid = mid + Math.imul(al5, bh9) | 0;
        mid = mid + Math.imul(ah5, bl9) | 0;
        hi = hi + Math.imul(ah5, bh9) | 0;
        var w14 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w14 >>> 26) | 0;
        w14 &= 0x3ffffff;
        /* k = 15 */ lo = Math.imul(al9, bl6);
        mid = Math.imul(al9, bh6);
        mid = mid + Math.imul(ah9, bl6) | 0;
        hi = Math.imul(ah9, bh6);
        lo = lo + Math.imul(al8, bl7) | 0;
        mid = mid + Math.imul(al8, bh7) | 0;
        mid = mid + Math.imul(ah8, bl7) | 0;
        hi = hi + Math.imul(ah8, bh7) | 0;
        lo = lo + Math.imul(al7, bl8) | 0;
        mid = mid + Math.imul(al7, bh8) | 0;
        mid = mid + Math.imul(ah7, bl8) | 0;
        hi = hi + Math.imul(ah7, bh8) | 0;
        lo = lo + Math.imul(al6, bl9) | 0;
        mid = mid + Math.imul(al6, bh9) | 0;
        mid = mid + Math.imul(ah6, bl9) | 0;
        hi = hi + Math.imul(ah6, bh9) | 0;
        var w15 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w15 >>> 26) | 0;
        w15 &= 0x3ffffff;
        /* k = 16 */ lo = Math.imul(al9, bl7);
        mid = Math.imul(al9, bh7);
        mid = mid + Math.imul(ah9, bl7) | 0;
        hi = Math.imul(ah9, bh7);
        lo = lo + Math.imul(al8, bl8) | 0;
        mid = mid + Math.imul(al8, bh8) | 0;
        mid = mid + Math.imul(ah8, bl8) | 0;
        hi = hi + Math.imul(ah8, bh8) | 0;
        lo = lo + Math.imul(al7, bl9) | 0;
        mid = mid + Math.imul(al7, bh9) | 0;
        mid = mid + Math.imul(ah7, bl9) | 0;
        hi = hi + Math.imul(ah7, bh9) | 0;
        var w16 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w16 >>> 26) | 0;
        w16 &= 0x3ffffff;
        /* k = 17 */ lo = Math.imul(al9, bl8);
        mid = Math.imul(al9, bh8);
        mid = mid + Math.imul(ah9, bl8) | 0;
        hi = Math.imul(ah9, bh8);
        lo = lo + Math.imul(al8, bl9) | 0;
        mid = mid + Math.imul(al8, bh9) | 0;
        mid = mid + Math.imul(ah8, bl9) | 0;
        hi = hi + Math.imul(ah8, bh9) | 0;
        var w17 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w17 >>> 26) | 0;
        w17 &= 0x3ffffff;
        /* k = 18 */ lo = Math.imul(al9, bl9);
        mid = Math.imul(al9, bh9);
        mid = mid + Math.imul(ah9, bl9) | 0;
        hi = Math.imul(ah9, bh9);
        var w18 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w18 >>> 26) | 0;
        w18 &= 0x3ffffff;
        o[0] = w0;
        o[1] = w1;
        o[2] = w2;
        o[3] = w3;
        o[4] = w4;
        o[5] = w5;
        o[6] = w6;
        o[7] = w7;
        o[8] = w8;
        o[9] = w9;
        o[10] = w10;
        o[11] = w11;
        o[12] = w12;
        o[13] = w13;
        o[14] = w14;
        o[15] = w15;
        o[16] = w16;
        o[17] = w17;
        o[18] = w18;
        if (c !== 0) {
            o[19] = c;
            out.length++;
        }
        return out;
    };
    // Polyfill comb
    if (!Math.imul) comb10MulTo = smallMulTo;
    function bigMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        out.length = self.length + num.length;
        var carry = 0;
        var hncarry = 0;
        for(var k = 0; k < out.length - 1; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = hncarry;
            hncarry = 0;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j;
                var a = self.words[i] | 0;
                var b = num.words[j] | 0;
                var r = a * b;
                var lo = r & 0x3ffffff;
                ncarry = ncarry + (r / 0x4000000 | 0) | 0;
                lo = lo + rword | 0;
                rword = lo & 0x3ffffff;
                ncarry = ncarry + (lo >>> 26) | 0;
                hncarry += ncarry >>> 26;
                ncarry &= 0x3ffffff;
            }
            out.words[k] = rword;
            carry = ncarry;
            ncarry = hncarry;
        }
        if (carry !== 0) out.words[k] = carry;
        else out.length--;
        return out._strip();
    }
    function jumboMulTo(self, num, out) {
        // Temporary disable, see https://github.com/indutny/bn.js/issues/211
        // var fftm = new FFTM();
        // return fftm.mulp(self, num, out);
        return bigMulTo(self, num, out);
    }
    BN.prototype.mulTo = function mulTo(num, out) {
        var res;
        var len = this.length + num.length;
        if (this.length === 10 && num.length === 10) res = comb10MulTo(this, num, out);
        else if (len < 63) res = smallMulTo(this, num, out);
        else if (len < 1024) res = bigMulTo(this, num, out);
        else res = jumboMulTo(this, num, out);
        return res;
    };
    // Cooley-Tukey algorithm for FFT
    // slightly revisited to rely on looping instead of recursion
    function FFTM(x, y) {
        this.x = x;
        this.y = y;
    }
    FFTM.prototype.makeRBT = function makeRBT(N) {
        var t = new Array(N);
        var l = BN.prototype._countBits(N) - 1;
        for(var i = 0; i < N; i++)t[i] = this.revBin(i, l, N);
        return t;
    };
    // Returns binary-reversed representation of `x`
    FFTM.prototype.revBin = function revBin(x, l, N) {
        if (x === 0 || x === N - 1) return x;
        var rb = 0;
        for(var i = 0; i < l; i++){
            rb |= (x & 1) << l - i - 1;
            x >>= 1;
        }
        return rb;
    };
    // Performs "tweedling" phase, therefore 'emulating'
    // behaviour of the recursive algorithm
    FFTM.prototype.permute = function permute(rbt, rws, iws, rtws, itws, N) {
        for(var i = 0; i < N; i++){
            rtws[i] = rws[rbt[i]];
            itws[i] = iws[rbt[i]];
        }
    };
    FFTM.prototype.transform = function transform(rws, iws, rtws, itws, N, rbt) {
        this.permute(rbt, rws, iws, rtws, itws, N);
        for(var s = 1; s < N; s <<= 1){
            var l = s << 1;
            var rtwdf = Math.cos(2 * Math.PI / l);
            var itwdf = Math.sin(2 * Math.PI / l);
            for(var p = 0; p < N; p += l){
                var rtwdf_ = rtwdf;
                var itwdf_ = itwdf;
                for(var j = 0; j < s; j++){
                    var re = rtws[p + j];
                    var ie = itws[p + j];
                    var ro = rtws[p + j + s];
                    var io = itws[p + j + s];
                    var rx = rtwdf_ * ro - itwdf_ * io;
                    io = rtwdf_ * io + itwdf_ * ro;
                    ro = rx;
                    rtws[p + j] = re + ro;
                    itws[p + j] = ie + io;
                    rtws[p + j + s] = re - ro;
                    itws[p + j + s] = ie - io;
                    /* jshint maxdepth : false */ if (j !== l) {
                        rx = rtwdf * rtwdf_ - itwdf * itwdf_;
                        itwdf_ = rtwdf * itwdf_ + itwdf * rtwdf_;
                        rtwdf_ = rx;
                    }
                }
            }
        }
    };
    FFTM.prototype.guessLen13b = function guessLen13b(n, m) {
        var N = Math.max(m, n) | 1;
        var odd = N & 1;
        var i = 0;
        for(N = N / 2 | 0; N; N = N >>> 1)i++;
        return 1 << i + 1 + odd;
    };
    FFTM.prototype.conjugate = function conjugate(rws, iws, N) {
        if (N <= 1) return;
        for(var i = 0; i < N / 2; i++){
            var t = rws[i];
            rws[i] = rws[N - i - 1];
            rws[N - i - 1] = t;
            t = iws[i];
            iws[i] = -iws[N - i - 1];
            iws[N - i - 1] = -t;
        }
    };
    FFTM.prototype.normalize13b = function normalize13b(ws, N) {
        var carry = 0;
        for(var i = 0; i < N / 2; i++){
            var w = Math.round(ws[2 * i + 1] / N) * 0x2000 + Math.round(ws[2 * i] / N) + carry;
            ws[i] = w & 0x3ffffff;
            if (w < 0x4000000) carry = 0;
            else carry = w / 0x4000000 | 0;
        }
        return ws;
    };
    FFTM.prototype.convert13b = function convert13b(ws, len, rws, N) {
        var carry = 0;
        for(var i = 0; i < len; i++){
            carry = carry + (ws[i] | 0);
            rws[2 * i] = carry & 0x1fff;
            carry = carry >>> 13;
            rws[2 * i + 1] = carry & 0x1fff;
            carry = carry >>> 13;
        }
        // Pad with zeroes
        for(i = 2 * len; i < N; ++i)rws[i] = 0;
        assert(carry === 0);
        assert((carry & -8192) === 0);
    };
    FFTM.prototype.stub = function stub(N) {
        var ph = new Array(N);
        for(var i = 0; i < N; i++)ph[i] = 0;
        return ph;
    };
    FFTM.prototype.mulp = function mulp(x, y, out) {
        var N = 2 * this.guessLen13b(x.length, y.length);
        var rbt = this.makeRBT(N);
        var _ = this.stub(N);
        var rws = new Array(N);
        var rwst = new Array(N);
        var iwst = new Array(N);
        var nrws = new Array(N);
        var nrwst = new Array(N);
        var niwst = new Array(N);
        var rmws = out.words;
        rmws.length = N;
        this.convert13b(x.words, x.length, rws, N);
        this.convert13b(y.words, y.length, nrws, N);
        this.transform(rws, _, rwst, iwst, N, rbt);
        this.transform(nrws, _, nrwst, niwst, N, rbt);
        for(var i = 0; i < N; i++){
            var rx = rwst[i] * nrwst[i] - iwst[i] * niwst[i];
            iwst[i] = rwst[i] * niwst[i] + iwst[i] * nrwst[i];
            rwst[i] = rx;
        }
        this.conjugate(rwst, iwst, N);
        this.transform(rwst, iwst, rmws, _, N, rbt);
        this.conjugate(rmws, _, N);
        this.normalize13b(rmws, N);
        out.negative = x.negative ^ y.negative;
        out.length = x.length + y.length;
        return out._strip();
    };
    // Multiply `this` by `num`
    BN.prototype.mul = function mul(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return this.mulTo(num, out);
    };
    // Multiply employing FFT
    BN.prototype.mulf = function mulf(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return jumboMulTo(this, num, out);
    };
    // In-place Multiplication
    BN.prototype.imul = function imul(num) {
        return this.clone().mulTo(num, this);
    };
    BN.prototype.imuln = function imuln(num) {
        var isNegNum = num < 0;
        if (isNegNum) num = -num;
        assert(typeof num === "number");
        assert(num < 0x4000000);
        // Carry
        var carry = 0;
        for(var i = 0; i < this.length; i++){
            var w = (this.words[i] | 0) * num;
            var lo = (w & 0x3ffffff) + (carry & 0x3ffffff);
            carry >>= 26;
            carry += w / 0x4000000 | 0;
            // NOTE: lo is 27bit maximum
            carry += lo >>> 26;
            this.words[i] = lo & 0x3ffffff;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return isNegNum ? this.ineg() : this;
    };
    BN.prototype.muln = function muln(num) {
        return this.clone().imuln(num);
    };
    // `this` * `this`
    BN.prototype.sqr = function sqr() {
        return this.mul(this);
    };
    // `this` * `this` in-place
    BN.prototype.isqr = function isqr() {
        return this.imul(this.clone());
    };
    // Math.pow(`this`, `num`)
    BN.prototype.pow = function pow(num) {
        var w = toBitArray(num);
        if (w.length === 0) return new BN(1);
        // Skip leading zeroes
        var res = this;
        for(var i = 0; i < w.length; i++, res = res.sqr()){
            if (w[i] !== 0) break;
        }
        if (++i < w.length) for(var q = res.sqr(); i < w.length; i++, q = q.sqr()){
            if (w[i] === 0) continue;
            res = res.mul(q);
        }
        return res;
    };
    // Shift-left in-place
    BN.prototype.iushln = function iushln(bits) {
        assert(typeof bits === "number" && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        var carryMask = 0x3ffffff >>> 26 - r << 26 - r;
        var i;
        if (r !== 0) {
            var carry = 0;
            for(i = 0; i < this.length; i++){
                var newCarry = this.words[i] & carryMask;
                var c = (this.words[i] | 0) - newCarry << r;
                this.words[i] = c | carry;
                carry = newCarry >>> 26 - r;
            }
            if (carry) {
                this.words[i] = carry;
                this.length++;
            }
        }
        if (s !== 0) {
            for(i = this.length - 1; i >= 0; i--)this.words[i + s] = this.words[i];
            for(i = 0; i < s; i++)this.words[i] = 0;
            this.length += s;
        }
        return this._strip();
    };
    BN.prototype.ishln = function ishln(bits) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushln(bits);
    };
    // Shift-right in-place
    // NOTE: `hint` is a lowest bit before trailing zeroes
    // NOTE: if `extended` is present - it will be filled with destroyed bits
    BN.prototype.iushrn = function iushrn(bits, hint, extended) {
        assert(typeof bits === "number" && bits >= 0);
        var h;
        if (hint) h = (hint - hint % 26) / 26;
        else h = 0;
        var r = bits % 26;
        var s = Math.min((bits - r) / 26, this.length);
        var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
        var maskedWords = extended;
        h -= s;
        h = Math.max(0, h);
        // Extended mode, copy masked part
        if (maskedWords) {
            for(var i = 0; i < s; i++)maskedWords.words[i] = this.words[i];
            maskedWords.length = s;
        }
        if (s === 0) ;
        else if (this.length > s) {
            this.length -= s;
            for(i = 0; i < this.length; i++)this.words[i] = this.words[i + s];
        } else {
            this.words[0] = 0;
            this.length = 1;
        }
        var carry = 0;
        for(i = this.length - 1; i >= 0 && (carry !== 0 || i >= h); i--){
            var word = this.words[i] | 0;
            this.words[i] = carry << 26 - r | word >>> r;
            carry = word & mask;
        }
        // Push carried bits as a mask
        if (maskedWords && carry !== 0) maskedWords.words[maskedWords.length++] = carry;
        if (this.length === 0) {
            this.words[0] = 0;
            this.length = 1;
        }
        return this._strip();
    };
    BN.prototype.ishrn = function ishrn(bits, hint, extended) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushrn(bits, hint, extended);
    };
    // Shift-left
    BN.prototype.shln = function shln(bits) {
        return this.clone().ishln(bits);
    };
    BN.prototype.ushln = function ushln(bits) {
        return this.clone().iushln(bits);
    };
    // Shift-right
    BN.prototype.shrn = function shrn(bits) {
        return this.clone().ishrn(bits);
    };
    BN.prototype.ushrn = function ushrn(bits) {
        return this.clone().iushrn(bits);
    };
    // Test if n bit is set
    BN.prototype.testn = function testn(bit) {
        assert(typeof bit === "number" && bit >= 0);
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) return false;
        // Check bit and return
        var w = this.words[s];
        return !!(w & q);
    };
    // Return only lowers bits of number (in-place)
    BN.prototype.imaskn = function imaskn(bits) {
        assert(typeof bits === "number" && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        assert(this.negative === 0, "imaskn works only with positive numbers");
        if (this.length <= s) return this;
        if (r !== 0) s++;
        this.length = Math.min(s, this.length);
        if (r !== 0) {
            var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
            this.words[this.length - 1] &= mask;
        }
        return this._strip();
    };
    // Return only lowers bits of number
    BN.prototype.maskn = function maskn(bits) {
        return this.clone().imaskn(bits);
    };
    // Add plain number `num` to `this`
    BN.prototype.iaddn = function iaddn(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        if (num < 0) return this.isubn(-num);
        // Possible sign change
        if (this.negative !== 0) {
            if (this.length === 1 && (this.words[0] | 0) <= num) {
                this.words[0] = num - (this.words[0] | 0);
                this.negative = 0;
                return this;
            }
            this.negative = 0;
            this.isubn(num);
            this.negative = 1;
            return this;
        }
        // Add without checks
        return this._iaddn(num);
    };
    BN.prototype._iaddn = function _iaddn(num) {
        this.words[0] += num;
        // Carry
        for(var i = 0; i < this.length && this.words[i] >= 0x4000000; i++){
            this.words[i] -= 0x4000000;
            if (i === this.length - 1) this.words[i + 1] = 1;
            else this.words[i + 1]++;
        }
        this.length = Math.max(this.length, i + 1);
        return this;
    };
    // Subtract plain number `num` from `this`
    BN.prototype.isubn = function isubn(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        if (num < 0) return this.iaddn(-num);
        if (this.negative !== 0) {
            this.negative = 0;
            this.iaddn(num);
            this.negative = 1;
            return this;
        }
        this.words[0] -= num;
        if (this.length === 1 && this.words[0] < 0) {
            this.words[0] = -this.words[0];
            this.negative = 1;
        } else // Carry
        for(var i = 0; i < this.length && this.words[i] < 0; i++){
            this.words[i] += 0x4000000;
            this.words[i + 1] -= 1;
        }
        return this._strip();
    };
    BN.prototype.addn = function addn(num) {
        return this.clone().iaddn(num);
    };
    BN.prototype.subn = function subn(num) {
        return this.clone().isubn(num);
    };
    BN.prototype.iabs = function iabs() {
        this.negative = 0;
        return this;
    };
    BN.prototype.abs = function abs() {
        return this.clone().iabs();
    };
    BN.prototype._ishlnsubmul = function _ishlnsubmul(num, mul, shift) {
        var len = num.length + shift;
        var i;
        this._expand(len);
        var w;
        var carry = 0;
        for(i = 0; i < num.length; i++){
            w = (this.words[i + shift] | 0) + carry;
            var right = (num.words[i] | 0) * mul;
            w -= right & 0x3ffffff;
            carry = (w >> 26) - (right / 0x4000000 | 0);
            this.words[i + shift] = w & 0x3ffffff;
        }
        for(; i < this.length - shift; i++){
            w = (this.words[i + shift] | 0) + carry;
            carry = w >> 26;
            this.words[i + shift] = w & 0x3ffffff;
        }
        if (carry === 0) return this._strip();
        // Subtraction overflow
        assert(carry === -1);
        carry = 0;
        for(i = 0; i < this.length; i++){
            w = -(this.words[i] | 0) + carry;
            carry = w >> 26;
            this.words[i] = w & 0x3ffffff;
        }
        this.negative = 1;
        return this._strip();
    };
    BN.prototype._wordDiv = function _wordDiv(num, mode) {
        var shift = this.length - num.length;
        var a = this.clone();
        var b = num;
        // Normalize
        var bhi = b.words[b.length - 1] | 0;
        var bhiBits = this._countBits(bhi);
        shift = 26 - bhiBits;
        if (shift !== 0) {
            b = b.ushln(shift);
            a.iushln(shift);
            bhi = b.words[b.length - 1] | 0;
        }
        // Initialize quotient
        var m = a.length - b.length;
        var q;
        if (mode !== "mod") {
            q = new BN(null);
            q.length = m + 1;
            q.words = new Array(q.length);
            for(var i = 0; i < q.length; i++)q.words[i] = 0;
        }
        var diff = a.clone()._ishlnsubmul(b, 1, m);
        if (diff.negative === 0) {
            a = diff;
            if (q) q.words[m] = 1;
        }
        for(var j = m - 1; j >= 0; j--){
            var qj = (a.words[b.length + j] | 0) * 0x4000000 + (a.words[b.length + j - 1] | 0);
            // NOTE: (qj / bhi) is (0x3ffffff * 0x4000000 + 0x3ffffff) / 0x2000000 max
            // (0x7ffffff)
            qj = Math.min(qj / bhi | 0, 0x3ffffff);
            a._ishlnsubmul(b, qj, j);
            while(a.negative !== 0){
                qj--;
                a.negative = 0;
                a._ishlnsubmul(b, 1, j);
                if (!a.isZero()) a.negative ^= 1;
            }
            if (q) q.words[j] = qj;
        }
        if (q) q._strip();
        a._strip();
        // Denormalize
        if (mode !== "div" && shift !== 0) a.iushrn(shift);
        return {
            div: q || null,
            mod: a
        };
    };
    // NOTE: 1) `mode` can be set to `mod` to request mod only,
    //       to `div` to request div only, or be absent to
    //       request both div & mod
    //       2) `positive` is true if unsigned mod is requested
    BN.prototype.divmod = function divmod(num, mode, positive) {
        assert(!num.isZero());
        if (this.isZero()) return {
            div: new BN(0),
            mod: new BN(0)
        };
        var div, mod, res;
        if (this.negative !== 0 && num.negative === 0) {
            res = this.neg().divmod(num, mode);
            if (mode !== "mod") div = res.div.neg();
            if (mode !== "div") {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.iadd(num);
            }
            return {
                div: div,
                mod: mod
            };
        }
        if (this.negative === 0 && num.negative !== 0) {
            res = this.divmod(num.neg(), mode);
            if (mode !== "mod") div = res.div.neg();
            return {
                div: div,
                mod: res.mod
            };
        }
        if ((this.negative & num.negative) !== 0) {
            res = this.neg().divmod(num.neg(), mode);
            if (mode !== "div") {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.isub(num);
            }
            return {
                div: res.div,
                mod: mod
            };
        }
        // Both numbers are positive at this point
        // Strip both numbers to approximate shift value
        if (num.length > this.length || this.cmp(num) < 0) return {
            div: new BN(0),
            mod: this
        };
        // Very short reduction
        if (num.length === 1) {
            if (mode === "div") return {
                div: this.divn(num.words[0]),
                mod: null
            };
            if (mode === "mod") return {
                div: null,
                mod: new BN(this.modrn(num.words[0]))
            };
            return {
                div: this.divn(num.words[0]),
                mod: new BN(this.modrn(num.words[0]))
            };
        }
        return this._wordDiv(num, mode);
    };
    // Find `this` / `num`
    BN.prototype.div = function div(num) {
        return this.divmod(num, "div", false).div;
    };
    // Find `this` % `num`
    BN.prototype.mod = function mod(num) {
        return this.divmod(num, "mod", false).mod;
    };
    BN.prototype.umod = function umod(num) {
        return this.divmod(num, "mod", true).mod;
    };
    // Find Round(`this` / `num`)
    BN.prototype.divRound = function divRound(num) {
        var dm = this.divmod(num);
        // Fast case - exact division
        if (dm.mod.isZero()) return dm.div;
        var mod = dm.div.negative !== 0 ? dm.mod.isub(num) : dm.mod;
        var half = num.ushrn(1);
        var r2 = num.andln(1);
        var cmp = mod.cmp(half);
        // Round down
        if (cmp < 0 || r2 === 1 && cmp === 0) return dm.div;
        // Round up
        return dm.div.negative !== 0 ? dm.div.isubn(1) : dm.div.iaddn(1);
    };
    BN.prototype.modrn = function modrn(num) {
        var isNegNum = num < 0;
        if (isNegNum) num = -num;
        assert(num <= 0x3ffffff);
        var p = 67108864 % num;
        var acc = 0;
        for(var i = this.length - 1; i >= 0; i--)acc = (p * acc + (this.words[i] | 0)) % num;
        return isNegNum ? -acc : acc;
    };
    // WARNING: DEPRECATED
    BN.prototype.modn = function modn(num) {
        return this.modrn(num);
    };
    // In-place division by number
    BN.prototype.idivn = function idivn(num) {
        var isNegNum = num < 0;
        if (isNegNum) num = -num;
        assert(num <= 0x3ffffff);
        var carry = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var w = (this.words[i] | 0) + carry * 0x4000000;
            this.words[i] = w / num | 0;
            carry = w % num;
        }
        this._strip();
        return isNegNum ? this.ineg() : this;
    };
    BN.prototype.divn = function divn(num) {
        return this.clone().idivn(num);
    };
    BN.prototype.egcd = function egcd(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var x = this;
        var y = p.clone();
        if (x.negative !== 0) x = x.umod(p);
        else x = x.clone();
        // A * x + B * y = x
        var A = new BN(1);
        var B = new BN(0);
        // C * x + D * y = y
        var C = new BN(0);
        var D = new BN(1);
        var g = 0;
        while(x.isEven() && y.isEven()){
            x.iushrn(1);
            y.iushrn(1);
            ++g;
        }
        var yp = y.clone();
        var xp = x.clone();
        while(!x.isZero()){
            for(var i = 0, im = 1; (x.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                x.iushrn(i);
                while(i-- > 0){
                    if (A.isOdd() || B.isOdd()) {
                        A.iadd(yp);
                        B.isub(xp);
                    }
                    A.iushrn(1);
                    B.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (y.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                y.iushrn(j);
                while(j-- > 0){
                    if (C.isOdd() || D.isOdd()) {
                        C.iadd(yp);
                        D.isub(xp);
                    }
                    C.iushrn(1);
                    D.iushrn(1);
                }
            }
            if (x.cmp(y) >= 0) {
                x.isub(y);
                A.isub(C);
                B.isub(D);
            } else {
                y.isub(x);
                C.isub(A);
                D.isub(B);
            }
        }
        return {
            a: C,
            b: D,
            gcd: y.iushln(g)
        };
    };
    // This is reduced incarnation of the binary EEA
    // above, designated to invert members of the
    // _prime_ fields F(p) at a maximal speed
    BN.prototype._invmp = function _invmp(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var a = this;
        var b = p.clone();
        if (a.negative !== 0) a = a.umod(p);
        else a = a.clone();
        var x1 = new BN(1);
        var x2 = new BN(0);
        var delta = b.clone();
        while(a.cmpn(1) > 0 && b.cmpn(1) > 0){
            for(var i = 0, im = 1; (a.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                a.iushrn(i);
                while(i-- > 0){
                    if (x1.isOdd()) x1.iadd(delta);
                    x1.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (b.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                b.iushrn(j);
                while(j-- > 0){
                    if (x2.isOdd()) x2.iadd(delta);
                    x2.iushrn(1);
                }
            }
            if (a.cmp(b) >= 0) {
                a.isub(b);
                x1.isub(x2);
            } else {
                b.isub(a);
                x2.isub(x1);
            }
        }
        var res;
        if (a.cmpn(1) === 0) res = x1;
        else res = x2;
        if (res.cmpn(0) < 0) res.iadd(p);
        return res;
    };
    BN.prototype.gcd = function gcd(num) {
        if (this.isZero()) return num.abs();
        if (num.isZero()) return this.abs();
        var a = this.clone();
        var b = num.clone();
        a.negative = 0;
        b.negative = 0;
        // Remove common factor of two
        for(var shift = 0; a.isEven() && b.isEven(); shift++){
            a.iushrn(1);
            b.iushrn(1);
        }
        do {
            while(a.isEven())a.iushrn(1);
            while(b.isEven())b.iushrn(1);
            var r = a.cmp(b);
            if (r < 0) {
                // Swap `a` and `b` to make `a` always bigger than `b`
                var t = a;
                a = b;
                b = t;
            } else if (r === 0 || b.cmpn(1) === 0) break;
            a.isub(b);
        }while (true);
        return b.iushln(shift);
    };
    // Invert number in the field F(num)
    BN.prototype.invm = function invm(num) {
        return this.egcd(num).a.umod(num);
    };
    BN.prototype.isEven = function isEven() {
        return (this.words[0] & 1) === 0;
    };
    BN.prototype.isOdd = function isOdd() {
        return (this.words[0] & 1) === 1;
    };
    // And first word and num
    BN.prototype.andln = function andln(num) {
        return this.words[0] & num;
    };
    // Increment at the bit position in-line
    BN.prototype.bincn = function bincn(bit) {
        assert(typeof bit === "number");
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) {
            this._expand(s + 1);
            this.words[s] |= q;
            return this;
        }
        // Add bit and propagate, if needed
        var carry = q;
        for(var i = s; carry !== 0 && i < this.length; i++){
            var w = this.words[i] | 0;
            w += carry;
            carry = w >>> 26;
            w &= 0x3ffffff;
            this.words[i] = w;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return this;
    };
    BN.prototype.isZero = function isZero() {
        return this.length === 1 && this.words[0] === 0;
    };
    BN.prototype.cmpn = function cmpn(num) {
        var negative = num < 0;
        if (this.negative !== 0 && !negative) return -1;
        if (this.negative === 0 && negative) return 1;
        this._strip();
        var res;
        if (this.length > 1) res = 1;
        else {
            if (negative) num = -num;
            assert(num <= 0x3ffffff, "Number is too big");
            var w = this.words[0] | 0;
            res = w === num ? 0 : w < num ? -1 : 1;
        }
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Compare two numbers and return:
    // 1 - if `this` > `num`
    // 0 - if `this` == `num`
    // -1 - if `this` < `num`
    BN.prototype.cmp = function cmp(num) {
        if (this.negative !== 0 && num.negative === 0) return -1;
        if (this.negative === 0 && num.negative !== 0) return 1;
        var res = this.ucmp(num);
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Unsigned comparison
    BN.prototype.ucmp = function ucmp(num) {
        // At this point both numbers have the same sign
        if (this.length > num.length) return 1;
        if (this.length < num.length) return -1;
        var res = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var a = this.words[i] | 0;
            var b = num.words[i] | 0;
            if (a === b) continue;
            if (a < b) res = -1;
            else if (a > b) res = 1;
            break;
        }
        return res;
    };
    BN.prototype.gtn = function gtn(num) {
        return this.cmpn(num) === 1;
    };
    BN.prototype.gt = function gt(num) {
        return this.cmp(num) === 1;
    };
    BN.prototype.gten = function gten(num) {
        return this.cmpn(num) >= 0;
    };
    BN.prototype.gte = function gte(num) {
        return this.cmp(num) >= 0;
    };
    BN.prototype.ltn = function ltn(num) {
        return this.cmpn(num) === -1;
    };
    BN.prototype.lt = function lt(num) {
        return this.cmp(num) === -1;
    };
    BN.prototype.lten = function lten(num) {
        return this.cmpn(num) <= 0;
    };
    BN.prototype.lte = function lte(num) {
        return this.cmp(num) <= 0;
    };
    BN.prototype.eqn = function eqn(num) {
        return this.cmpn(num) === 0;
    };
    BN.prototype.eq = function eq(num) {
        return this.cmp(num) === 0;
    };
    //
    // A reduce context, could be using montgomery or something better, depending
    // on the `m` itself.
    //
    BN.red = function red(num) {
        return new Red(num);
    };
    BN.prototype.toRed = function toRed(ctx) {
        assert(!this.red, "Already a number in reduction context");
        assert(this.negative === 0, "red works only with positives");
        return ctx.convertTo(this)._forceRed(ctx);
    };
    BN.prototype.fromRed = function fromRed() {
        assert(this.red, "fromRed works only with numbers in reduction context");
        return this.red.convertFrom(this);
    };
    BN.prototype._forceRed = function _forceRed(ctx) {
        this.red = ctx;
        return this;
    };
    BN.prototype.forceRed = function forceRed(ctx) {
        assert(!this.red, "Already a number in reduction context");
        return this._forceRed(ctx);
    };
    BN.prototype.redAdd = function redAdd(num) {
        assert(this.red, "redAdd works only with red numbers");
        return this.red.add(this, num);
    };
    BN.prototype.redIAdd = function redIAdd(num) {
        assert(this.red, "redIAdd works only with red numbers");
        return this.red.iadd(this, num);
    };
    BN.prototype.redSub = function redSub(num) {
        assert(this.red, "redSub works only with red numbers");
        return this.red.sub(this, num);
    };
    BN.prototype.redISub = function redISub(num) {
        assert(this.red, "redISub works only with red numbers");
        return this.red.isub(this, num);
    };
    BN.prototype.redShl = function redShl(num) {
        assert(this.red, "redShl works only with red numbers");
        return this.red.shl(this, num);
    };
    BN.prototype.redMul = function redMul(num) {
        assert(this.red, "redMul works only with red numbers");
        this.red._verify2(this, num);
        return this.red.mul(this, num);
    };
    BN.prototype.redIMul = function redIMul(num) {
        assert(this.red, "redMul works only with red numbers");
        this.red._verify2(this, num);
        return this.red.imul(this, num);
    };
    BN.prototype.redSqr = function redSqr() {
        assert(this.red, "redSqr works only with red numbers");
        this.red._verify1(this);
        return this.red.sqr(this);
    };
    BN.prototype.redISqr = function redISqr() {
        assert(this.red, "redISqr works only with red numbers");
        this.red._verify1(this);
        return this.red.isqr(this);
    };
    // Square root over p
    BN.prototype.redSqrt = function redSqrt() {
        assert(this.red, "redSqrt works only with red numbers");
        this.red._verify1(this);
        return this.red.sqrt(this);
    };
    BN.prototype.redInvm = function redInvm() {
        assert(this.red, "redInvm works only with red numbers");
        this.red._verify1(this);
        return this.red.invm(this);
    };
    // Return negative clone of `this` % `red modulo`
    BN.prototype.redNeg = function redNeg() {
        assert(this.red, "redNeg works only with red numbers");
        this.red._verify1(this);
        return this.red.neg(this);
    };
    BN.prototype.redPow = function redPow(num) {
        assert(this.red && !num.red, "redPow(normalNum)");
        this.red._verify1(this);
        return this.red.pow(this, num);
    };
    // Prime numbers with efficient reduction
    var primes = {
        k256: null,
        p224: null,
        p192: null,
        p25519: null
    };
    // Pseudo-Mersenne prime
    function MPrime(name, p) {
        // P = 2 ^ N - K
        this.name = name;
        this.p = new BN(p, 16);
        this.n = this.p.bitLength();
        this.k = new BN(1).iushln(this.n).isub(this.p);
        this.tmp = this._tmp();
    }
    MPrime.prototype._tmp = function _tmp() {
        var tmp = new BN(null);
        tmp.words = new Array(Math.ceil(this.n / 13));
        return tmp;
    };
    MPrime.prototype.ireduce = function ireduce(num) {
        // Assumes that `num` is less than `P^2`
        // num = HI * (2 ^ N - K) + HI * K + LO = HI * K + LO (mod P)
        var r = num;
        var rlen;
        do {
            this.split(r, this.tmp);
            r = this.imulK(r);
            r = r.iadd(this.tmp);
            rlen = r.bitLength();
        }while (rlen > this.n);
        var cmp = rlen < this.n ? -1 : r.ucmp(this.p);
        if (cmp === 0) {
            r.words[0] = 0;
            r.length = 1;
        } else if (cmp > 0) r.isub(this.p);
        else if (r.strip !== undefined) // r is a BN v4 instance
        r.strip();
        else // r is a BN v5 instance
        r._strip();
        return r;
    };
    MPrime.prototype.split = function split(input, out) {
        input.iushrn(this.n, 0, out);
    };
    MPrime.prototype.imulK = function imulK(num) {
        return num.imul(this.k);
    };
    function K256() {
        MPrime.call(this, "k256", "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f");
    }
    inherits(K256, MPrime);
    K256.prototype.split = function split(input, output) {
        // 256 = 9 * 26 + 22
        var mask = 0x3fffff;
        var outLen = Math.min(input.length, 9);
        for(var i = 0; i < outLen; i++)output.words[i] = input.words[i];
        output.length = outLen;
        if (input.length <= 9) {
            input.words[0] = 0;
            input.length = 1;
            return;
        }
        // Shift by 9 limbs
        var prev = input.words[9];
        output.words[output.length++] = prev & mask;
        for(i = 10; i < input.length; i++){
            var next = input.words[i] | 0;
            input.words[i - 10] = (next & mask) << 4 | prev >>> 22;
            prev = next;
        }
        prev >>>= 22;
        input.words[i - 10] = prev;
        if (prev === 0 && input.length > 10) input.length -= 10;
        else input.length -= 9;
    };
    K256.prototype.imulK = function imulK(num) {
        // K = 0x1000003d1 = [ 0x40, 0x3d1 ]
        num.words[num.length] = 0;
        num.words[num.length + 1] = 0;
        num.length += 2;
        // bounded at: 0x40 * 0x3ffffff + 0x3d0 = 0x100000390
        var lo = 0;
        for(var i = 0; i < num.length; i++){
            var w = num.words[i] | 0;
            lo += w * 0x3d1;
            num.words[i] = lo & 0x3ffffff;
            lo = w * 0x40 + (lo / 0x4000000 | 0);
        }
        // Fast length reduction
        if (num.words[num.length - 1] === 0) {
            num.length--;
            if (num.words[num.length - 1] === 0) num.length--;
        }
        return num;
    };
    function P224() {
        MPrime.call(this, "p224", "ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001");
    }
    inherits(P224, MPrime);
    function P192() {
        MPrime.call(this, "p192", "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff");
    }
    inherits(P192, MPrime);
    function P25519() {
        // 2 ^ 255 - 19
        MPrime.call(this, "25519", "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed");
    }
    inherits(P25519, MPrime);
    P25519.prototype.imulK = function imulK(num) {
        // K = 0x13
        var carry = 0;
        for(var i = 0; i < num.length; i++){
            var hi = (num.words[i] | 0) * 0x13 + carry;
            var lo = hi & 0x3ffffff;
            hi >>>= 26;
            num.words[i] = lo;
            carry = hi;
        }
        if (carry !== 0) num.words[num.length++] = carry;
        return num;
    };
    // Exported mostly for testing purposes, use plain name instead
    BN._prime = function prime(name) {
        // Cached version of prime
        if (primes[name]) return primes[name];
        var prime;
        if (name === "k256") prime = new K256();
        else if (name === "p224") prime = new P224();
        else if (name === "p192") prime = new P192();
        else if (name === "p25519") prime = new P25519();
        else throw new Error("Unknown prime " + name);
        primes[name] = prime;
        return prime;
    };
    //
    // Base reduction engine
    //
    function Red(m) {
        if (typeof m === "string") {
            var prime = BN._prime(m);
            this.m = prime.p;
            this.prime = prime;
        } else {
            assert(m.gtn(1), "modulus must be greater than 1");
            this.m = m;
            this.prime = null;
        }
    }
    Red.prototype._verify1 = function _verify1(a) {
        assert(a.negative === 0, "red works only with positives");
        assert(a.red, "red works only with red numbers");
    };
    Red.prototype._verify2 = function _verify2(a, b) {
        assert((a.negative | b.negative) === 0, "red works only with positives");
        assert(a.red && a.red === b.red, "red works only with red numbers");
    };
    Red.prototype.imod = function imod(a) {
        if (this.prime) return this.prime.ireduce(a)._forceRed(this);
        move(a, a.umod(this.m)._forceRed(this));
        return a;
    };
    Red.prototype.neg = function neg(a) {
        if (a.isZero()) return a.clone();
        return this.m.sub(a)._forceRed(this);
    };
    Red.prototype.add = function add(a, b) {
        this._verify2(a, b);
        var res = a.add(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res._forceRed(this);
    };
    Red.prototype.iadd = function iadd(a, b) {
        this._verify2(a, b);
        var res = a.iadd(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res;
    };
    Red.prototype.sub = function sub(a, b) {
        this._verify2(a, b);
        var res = a.sub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res._forceRed(this);
    };
    Red.prototype.isub = function isub(a, b) {
        this._verify2(a, b);
        var res = a.isub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res;
    };
    Red.prototype.shl = function shl(a, num) {
        this._verify1(a);
        return this.imod(a.ushln(num));
    };
    Red.prototype.imul = function imul(a, b) {
        this._verify2(a, b);
        return this.imod(a.imul(b));
    };
    Red.prototype.mul = function mul(a, b) {
        this._verify2(a, b);
        return this.imod(a.mul(b));
    };
    Red.prototype.isqr = function isqr(a) {
        return this.imul(a, a.clone());
    };
    Red.prototype.sqr = function sqr(a) {
        return this.mul(a, a);
    };
    Red.prototype.sqrt = function sqrt(a) {
        if (a.isZero()) return a.clone();
        var mod3 = this.m.andln(3);
        assert(mod3 % 2 === 1);
        // Fast case
        if (mod3 === 3) {
            var pow = this.m.add(new BN(1)).iushrn(2);
            return this.pow(a, pow);
        }
        // Tonelli-Shanks algorithm (Totally unoptimized and slow)
        //
        // Find Q and S, that Q * 2 ^ S = (P - 1)
        var q = this.m.subn(1);
        var s = 0;
        while(!q.isZero() && q.andln(1) === 0){
            s++;
            q.iushrn(1);
        }
        assert(!q.isZero());
        var one = new BN(1).toRed(this);
        var nOne = one.redNeg();
        // Find quadratic non-residue
        // NOTE: Max is such because of generalized Riemann hypothesis.
        var lpow = this.m.subn(1).iushrn(1);
        var z = this.m.bitLength();
        z = new BN(2 * z * z).toRed(this);
        while(this.pow(z, lpow).cmp(nOne) !== 0)z.redIAdd(nOne);
        var c = this.pow(z, q);
        var r = this.pow(a, q.addn(1).iushrn(1));
        var t = this.pow(a, q);
        var m = s;
        while(t.cmp(one) !== 0){
            var tmp = t;
            for(var i = 0; tmp.cmp(one) !== 0; i++)tmp = tmp.redSqr();
            assert(i < m);
            var b = this.pow(c, new BN(1).iushln(m - i - 1));
            r = r.redMul(b);
            c = b.redSqr();
            t = t.redMul(c);
            m = i;
        }
        return r;
    };
    Red.prototype.invm = function invm(a) {
        var inv = a._invmp(this.m);
        if (inv.negative !== 0) {
            inv.negative = 0;
            return this.imod(inv).redNeg();
        } else return this.imod(inv);
    };
    Red.prototype.pow = function pow(a, num) {
        if (num.isZero()) return new BN(1).toRed(this);
        if (num.cmpn(1) === 0) return a.clone();
        var windowSize = 4;
        var wnd = new Array(1 << windowSize);
        wnd[0] = new BN(1).toRed(this);
        wnd[1] = a;
        for(var i = 2; i < wnd.length; i++)wnd[i] = this.mul(wnd[i - 1], a);
        var res = wnd[0];
        var current = 0;
        var currentLen = 0;
        var start = num.bitLength() % 26;
        if (start === 0) start = 26;
        for(i = num.length - 1; i >= 0; i--){
            var word = num.words[i];
            for(var j = start - 1; j >= 0; j--){
                var bit = word >> j & 1;
                if (res !== wnd[0]) res = this.sqr(res);
                if (bit === 0 && current === 0) {
                    currentLen = 0;
                    continue;
                }
                current <<= 1;
                current |= bit;
                currentLen++;
                if (currentLen !== windowSize && (i !== 0 || j !== 0)) continue;
                res = this.mul(res, wnd[current]);
                currentLen = 0;
                current = 0;
            }
            start = 26;
        }
        return res;
    };
    Red.prototype.convertTo = function convertTo(num) {
        var r = num.umod(this.m);
        return r === num ? r.clone() : r;
    };
    Red.prototype.convertFrom = function convertFrom(num) {
        var res = num.clone();
        res.red = null;
        return res;
    };
    //
    // Montgomery method engine
    //
    BN.mont = function mont(num) {
        return new Mont(num);
    };
    function Mont(m) {
        Red.call(this, m);
        this.shift = this.m.bitLength();
        if (this.shift % 26 !== 0) this.shift += 26 - this.shift % 26;
        this.r = new BN(1).iushln(this.shift);
        this.r2 = this.imod(this.r.sqr());
        this.rinv = this.r._invmp(this.m);
        this.minv = this.rinv.mul(this.r).isubn(1).div(this.m);
        this.minv = this.minv.umod(this.r);
        this.minv = this.r.sub(this.minv);
    }
    inherits(Mont, Red);
    Mont.prototype.convertTo = function convertTo(num) {
        return this.imod(num.ushln(this.shift));
    };
    Mont.prototype.convertFrom = function convertFrom(num) {
        var r = this.imod(num.mul(this.rinv));
        r.red = null;
        return r;
    };
    Mont.prototype.imul = function imul(a, b) {
        if (a.isZero() || b.isZero()) {
            a.words[0] = 0;
            a.length = 1;
            return a;
        }
        var t = a.imul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.mul = function mul(a, b) {
        if (a.isZero() || b.isZero()) return new BN(0)._forceRed(this);
        var t = a.mul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.invm = function invm(a) {
        // (AR)^-1 * R^2 = (A^-1 * R^-1) * R^2 = A^-1 * R
        var res = this.imod(a._invmp(this.m).mul(this.r2));
        return res._forceRed(this);
    };
})(module, this);

});


parcelRequire.register("8J1ou", function(module, exports) {
"use strict";
var $65a39b84537b61c7$var$elliptic = module.exports;

$65a39b84537b61c7$var$elliptic.version = (parcelRequire("jfwBV")).version;

$65a39b84537b61c7$var$elliptic.utils = (parcelRequire("ZdcNb"));

$65a39b84537b61c7$var$elliptic.rand = (parcelRequire("9JRha"));

$65a39b84537b61c7$var$elliptic.curve = (parcelRequire("fYJT3"));

$65a39b84537b61c7$var$elliptic.curves = (parcelRequire("hwVHR"));

// Protocols
$65a39b84537b61c7$var$elliptic.ec = (parcelRequire("9lW0h"));

$65a39b84537b61c7$var$elliptic.eddsa = (parcelRequire("96jZE"));

});
parcelRequire.register("jfwBV", function(module, exports) {
module.exports = JSON.parse('{"name":"elliptic","version":"6.5.4","description":"EC cryptography","main":"lib/elliptic.js","files":["lib"],"scripts":{"lint":"eslint lib test","lint:fix":"npm run lint -- --fix","unit":"istanbul test _mocha --reporter=spec test/index.js","test":"npm run lint && npm run unit","version":"grunt dist && git add dist/"},"repository":{"type":"git","url":"git@github.com:indutny/elliptic"},"keywords":["EC","Elliptic","curve","Cryptography"],"author":"Fedor Indutny <fedor@indutny.com>","license":"MIT","bugs":{"url":"https://github.com/indutny/elliptic/issues"},"homepage":"https://github.com/indutny/elliptic","devDependencies":{"brfs":"^2.0.2","coveralls":"^3.1.0","eslint":"^7.6.0","grunt":"^1.2.1","grunt-browserify":"^5.3.0","grunt-cli":"^1.3.2","grunt-contrib-connect":"^3.0.0","grunt-contrib-copy":"^1.0.0","grunt-contrib-uglify":"^5.0.0","grunt-mocha-istanbul":"^5.0.2","grunt-saucelabs":"^9.0.1","istanbul":"^0.4.5","mocha":"^8.0.1"},"dependencies":{"bn.js":"^4.11.9","brorand":"^1.1.0","hash.js":"^1.0.0","hmac-drbg":"^1.0.1","inherits":"^2.0.4","minimalistic-assert":"^1.0.1","minimalistic-crypto-utils":"^1.0.1"}}');

});

parcelRequire.register("ZdcNb", function(module, exports) {
"use strict";
var $0b7ff0ec21b47efd$var$utils = module.exports;

var $7vYz3 = parcelRequire("7vYz3");

var $aJt1P = parcelRequire("aJt1P");

var $6J8qY = parcelRequire("6J8qY");
$0b7ff0ec21b47efd$var$utils.assert = $aJt1P;
$0b7ff0ec21b47efd$var$utils.toArray = $6J8qY.toArray;
$0b7ff0ec21b47efd$var$utils.zero2 = $6J8qY.zero2;
$0b7ff0ec21b47efd$var$utils.toHex = $6J8qY.toHex;
$0b7ff0ec21b47efd$var$utils.encode = $6J8qY.encode;
// Represent num in a w-NAF form
function $0b7ff0ec21b47efd$var$getNAF(num, w, bits) {
    var naf = new Array(Math.max(num.bitLength(), bits) + 1);
    naf.fill(0);
    var ws = 1 << w + 1;
    var k = num.clone();
    for(var i = 0; i < naf.length; i++){
        var z;
        var mod = k.andln(ws - 1);
        if (k.isOdd()) {
            if (mod > (ws >> 1) - 1) z = (ws >> 1) - mod;
            else z = mod;
            k.isubn(z);
        } else z = 0;
        naf[i] = z;
        k.iushrn(1);
    }
    return naf;
}
$0b7ff0ec21b47efd$var$utils.getNAF = $0b7ff0ec21b47efd$var$getNAF;
// Represent k1, k2 in a Joint Sparse Form
function $0b7ff0ec21b47efd$var$getJSF(k1, k2) {
    var jsf = [
        [],
        []
    ];
    k1 = k1.clone();
    k2 = k2.clone();
    var d1 = 0;
    var d2 = 0;
    var m8;
    while(k1.cmpn(-d1) > 0 || k2.cmpn(-d2) > 0){
        // First phase
        var m14 = k1.andln(3) + d1 & 3;
        var m24 = k2.andln(3) + d2 & 3;
        if (m14 === 3) m14 = -1;
        if (m24 === 3) m24 = -1;
        var u1;
        if ((m14 & 1) === 0) u1 = 0;
        else {
            m8 = k1.andln(7) + d1 & 7;
            if ((m8 === 3 || m8 === 5) && m24 === 2) u1 = -m14;
            else u1 = m14;
        }
        jsf[0].push(u1);
        var u2;
        if ((m24 & 1) === 0) u2 = 0;
        else {
            m8 = k2.andln(7) + d2 & 7;
            if ((m8 === 3 || m8 === 5) && m14 === 2) u2 = -m24;
            else u2 = m24;
        }
        jsf[1].push(u2);
        // Second phase
        if (2 * d1 === u1 + 1) d1 = 1 - d1;
        if (2 * d2 === u2 + 1) d2 = 1 - d2;
        k1.iushrn(1);
        k2.iushrn(1);
    }
    return jsf;
}
$0b7ff0ec21b47efd$var$utils.getJSF = $0b7ff0ec21b47efd$var$getJSF;
function $0b7ff0ec21b47efd$var$cachedProperty(obj, name, computer) {
    var key = "_" + name;
    obj.prototype[name] = function cachedProperty() {
        return this[key] !== undefined ? this[key] : this[key] = computer.call(this);
    };
}
$0b7ff0ec21b47efd$var$utils.cachedProperty = $0b7ff0ec21b47efd$var$cachedProperty;
function $0b7ff0ec21b47efd$var$parseBytes(bytes) {
    return typeof bytes === "string" ? $0b7ff0ec21b47efd$var$utils.toArray(bytes, "hex") : bytes;
}
$0b7ff0ec21b47efd$var$utils.parseBytes = $0b7ff0ec21b47efd$var$parseBytes;
function $0b7ff0ec21b47efd$var$intFromLE(bytes) {
    return new $7vYz3(bytes, "hex", "le");
}
$0b7ff0ec21b47efd$var$utils.intFromLE = $0b7ff0ec21b47efd$var$intFromLE;

});
parcelRequire.register("6J8qY", function(module, exports) {
"use strict";
var $4e5d7ce234b4cbb5$var$utils = module.exports;
function $4e5d7ce234b4cbb5$var$toArray(msg, enc) {
    if (Array.isArray(msg)) return msg.slice();
    if (!msg) return [];
    var res = [];
    if (typeof msg !== "string") {
        for(var i = 0; i < msg.length; i++)res[i] = msg[i] | 0;
        return res;
    }
    if (enc === "hex") {
        msg = msg.replace(/[^a-z0-9]+/ig, "");
        if (msg.length % 2 !== 0) msg = "0" + msg;
        for(var i = 0; i < msg.length; i += 2)res.push(parseInt(msg[i] + msg[i + 1], 16));
    } else for(var i = 0; i < msg.length; i++){
        var c = msg.charCodeAt(i);
        var hi = c >> 8;
        var lo = c & 0xff;
        if (hi) res.push(hi, lo);
        else res.push(lo);
    }
    return res;
}
$4e5d7ce234b4cbb5$var$utils.toArray = $4e5d7ce234b4cbb5$var$toArray;
function $4e5d7ce234b4cbb5$var$zero2(word) {
    if (word.length === 1) return "0" + word;
    else return word;
}
$4e5d7ce234b4cbb5$var$utils.zero2 = $4e5d7ce234b4cbb5$var$zero2;
function $4e5d7ce234b4cbb5$var$toHex(msg) {
    var res = "";
    for(var i = 0; i < msg.length; i++)res += $4e5d7ce234b4cbb5$var$zero2(msg[i].toString(16));
    return res;
}
$4e5d7ce234b4cbb5$var$utils.toHex = $4e5d7ce234b4cbb5$var$toHex;
$4e5d7ce234b4cbb5$var$utils.encode = function encode(arr, enc) {
    if (enc === "hex") return $4e5d7ce234b4cbb5$var$toHex(arr);
    else return arr;
};

});


parcelRequire.register("fYJT3", function(module, exports) {
"use strict";
var $ba200dd58ee56ab1$var$curve = module.exports;

$ba200dd58ee56ab1$var$curve.base = (parcelRequire("1dHTG"));

$ba200dd58ee56ab1$var$curve.short = (parcelRequire("laKc8"));

$ba200dd58ee56ab1$var$curve.mont = (parcelRequire("3uGhx"));

$ba200dd58ee56ab1$var$curve.edwards = (parcelRequire("a0HUE"));

});
parcelRequire.register("1dHTG", function(module, exports) {
"use strict";

var $7vYz3 = parcelRequire("7vYz3");

var $ZdcNb = parcelRequire("ZdcNb");
var $0e390e60fe847ab5$var$getNAF = $ZdcNb.getNAF;
var $0e390e60fe847ab5$var$getJSF = $ZdcNb.getJSF;
var $0e390e60fe847ab5$var$assert = $ZdcNb.assert;
function $0e390e60fe847ab5$var$BaseCurve(type, conf) {
    this.type = type;
    this.p = new $7vYz3(conf.p, 16);
    // Use Montgomery, when there is no fast reduction for the prime
    this.red = conf.prime ? $7vYz3.red(conf.prime) : $7vYz3.mont(this.p);
    // Useful for many curves
    this.zero = new $7vYz3(0).toRed(this.red);
    this.one = new $7vYz3(1).toRed(this.red);
    this.two = new $7vYz3(2).toRed(this.red);
    // Curve configuration, optional
    this.n = conf.n && new $7vYz3(conf.n, 16);
    this.g = conf.g && this.pointFromJSON(conf.g, conf.gRed);
    // Temporary arrays
    this._wnafT1 = new Array(4);
    this._wnafT2 = new Array(4);
    this._wnafT3 = new Array(4);
    this._wnafT4 = new Array(4);
    this._bitLength = this.n ? this.n.bitLength() : 0;
    // Generalized Greg Maxwell's trick
    var adjustCount = this.n && this.p.div(this.n);
    if (!adjustCount || adjustCount.cmpn(100) > 0) this.redN = null;
    else {
        this._maxwellTrick = true;
        this.redN = this.n.toRed(this.red);
    }
}
module.exports = $0e390e60fe847ab5$var$BaseCurve;
$0e390e60fe847ab5$var$BaseCurve.prototype.point = function point() {
    throw new Error("Not implemented");
};
$0e390e60fe847ab5$var$BaseCurve.prototype.validate = function validate() {
    throw new Error("Not implemented");
};
$0e390e60fe847ab5$var$BaseCurve.prototype._fixedNafMul = function _fixedNafMul(p, k) {
    $0e390e60fe847ab5$var$assert(p.precomputed);
    var doubles = p._getDoubles();
    var naf = $0e390e60fe847ab5$var$getNAF(k, 1, this._bitLength);
    var I = (1 << doubles.step + 1) - (doubles.step % 2 === 0 ? 2 : 1);
    I /= 3;
    // Translate into more windowed form
    var repr = [];
    var j;
    var nafW;
    for(j = 0; j < naf.length; j += doubles.step){
        nafW = 0;
        for(var l = j + doubles.step - 1; l >= j; l--)nafW = (nafW << 1) + naf[l];
        repr.push(nafW);
    }
    var a = this.jpoint(null, null, null);
    var b = this.jpoint(null, null, null);
    for(var i = I; i > 0; i--){
        for(j = 0; j < repr.length; j++){
            nafW = repr[j];
            if (nafW === i) b = b.mixedAdd(doubles.points[j]);
            else if (nafW === -i) b = b.mixedAdd(doubles.points[j].neg());
        }
        a = a.add(b);
    }
    return a.toP();
};
$0e390e60fe847ab5$var$BaseCurve.prototype._wnafMul = function _wnafMul(p, k) {
    var w = 4;
    // Precompute window
    var nafPoints = p._getNAFPoints(w);
    w = nafPoints.wnd;
    var wnd = nafPoints.points;
    // Get NAF form
    var naf = $0e390e60fe847ab5$var$getNAF(k, w, this._bitLength);
    // Add `this`*(N+1) for every w-NAF index
    var acc = this.jpoint(null, null, null);
    for(var i = naf.length - 1; i >= 0; i--){
        // Count zeroes
        for(var l = 0; i >= 0 && naf[i] === 0; i--)l++;
        if (i >= 0) l++;
        acc = acc.dblp(l);
        if (i < 0) break;
        var z = naf[i];
        $0e390e60fe847ab5$var$assert(z !== 0);
        if (p.type === "affine") {
            // J +- P
            if (z > 0) acc = acc.mixedAdd(wnd[z - 1 >> 1]);
            else acc = acc.mixedAdd(wnd[-z - 1 >> 1].neg());
        } else // J +- J
        if (z > 0) acc = acc.add(wnd[z - 1 >> 1]);
        else acc = acc.add(wnd[-z - 1 >> 1].neg());
    }
    return p.type === "affine" ? acc.toP() : acc;
};
$0e390e60fe847ab5$var$BaseCurve.prototype._wnafMulAdd = function _wnafMulAdd(defW, points, coeffs, len, jacobianResult) {
    var wndWidth = this._wnafT1;
    var wnd = this._wnafT2;
    var naf = this._wnafT3;
    // Fill all arrays
    var max = 0;
    var i;
    var j;
    var p;
    for(i = 0; i < len; i++){
        p = points[i];
        var nafPoints = p._getNAFPoints(defW);
        wndWidth[i] = nafPoints.wnd;
        wnd[i] = nafPoints.points;
    }
    // Comb small window NAFs
    for(i = len - 1; i >= 1; i -= 2){
        var a = i - 1;
        var b = i;
        if (wndWidth[a] !== 1 || wndWidth[b] !== 1) {
            naf[a] = $0e390e60fe847ab5$var$getNAF(coeffs[a], wndWidth[a], this._bitLength);
            naf[b] = $0e390e60fe847ab5$var$getNAF(coeffs[b], wndWidth[b], this._bitLength);
            max = Math.max(naf[a].length, max);
            max = Math.max(naf[b].length, max);
            continue;
        }
        var comb = [
            points[a],
            /* 1 */ null,
            /* 3 */ null,
            /* 5 */ points[b]
        ];
        // Try to avoid Projective points, if possible
        if (points[a].y.cmp(points[b].y) === 0) {
            comb[1] = points[a].add(points[b]);
            comb[2] = points[a].toJ().mixedAdd(points[b].neg());
        } else if (points[a].y.cmp(points[b].y.redNeg()) === 0) {
            comb[1] = points[a].toJ().mixedAdd(points[b]);
            comb[2] = points[a].add(points[b].neg());
        } else {
            comb[1] = points[a].toJ().mixedAdd(points[b]);
            comb[2] = points[a].toJ().mixedAdd(points[b].neg());
        }
        var index = [
            -3,
            /* -1 -1 */ -1,
            /* -1 0 */ -5,
            /* -1 1 */ -7,
            /* 0 -1 */ 0,
            /* 0 0 */ 7,
            /* 0 1 */ 5,
            /* 1 -1 */ 1,
            /* 1 0 */ 3
        ];
        var jsf = $0e390e60fe847ab5$var$getJSF(coeffs[a], coeffs[b]);
        max = Math.max(jsf[0].length, max);
        naf[a] = new Array(max);
        naf[b] = new Array(max);
        for(j = 0; j < max; j++){
            var ja = jsf[0][j] | 0;
            var jb = jsf[1][j] | 0;
            naf[a][j] = index[(ja + 1) * 3 + (jb + 1)];
            naf[b][j] = 0;
            wnd[a] = comb;
        }
    }
    var acc = this.jpoint(null, null, null);
    var tmp = this._wnafT4;
    for(i = max; i >= 0; i--){
        var k = 0;
        while(i >= 0){
            var zero = true;
            for(j = 0; j < len; j++){
                tmp[j] = naf[j][i] | 0;
                if (tmp[j] !== 0) zero = false;
            }
            if (!zero) break;
            k++;
            i--;
        }
        if (i >= 0) k++;
        acc = acc.dblp(k);
        if (i < 0) break;
        for(j = 0; j < len; j++){
            var z = tmp[j];
            p;
            if (z === 0) continue;
            else if (z > 0) p = wnd[j][z - 1 >> 1];
            else if (z < 0) p = wnd[j][-z - 1 >> 1].neg();
            if (p.type === "affine") acc = acc.mixedAdd(p);
            else acc = acc.add(p);
        }
    }
    // Zeroify references
    for(i = 0; i < len; i++)wnd[i] = null;
    if (jacobianResult) return acc;
    else return acc.toP();
};
function $0e390e60fe847ab5$var$BasePoint(curve, type) {
    this.curve = curve;
    this.type = type;
    this.precomputed = null;
}
$0e390e60fe847ab5$var$BaseCurve.BasePoint = $0e390e60fe847ab5$var$BasePoint;
$0e390e60fe847ab5$var$BasePoint.prototype.eq = function eq() {
    throw new Error("Not implemented");
};
$0e390e60fe847ab5$var$BasePoint.prototype.validate = function validate() {
    return this.curve.validate(this);
};
$0e390e60fe847ab5$var$BaseCurve.prototype.decodePoint = function decodePoint(bytes, enc) {
    bytes = $ZdcNb.toArray(bytes, enc);
    var len = this.p.byteLength();
    // uncompressed, hybrid-odd, hybrid-even
    if ((bytes[0] === 0x04 || bytes[0] === 0x06 || bytes[0] === 0x07) && bytes.length - 1 === 2 * len) {
        if (bytes[0] === 0x06) $0e390e60fe847ab5$var$assert(bytes[bytes.length - 1] % 2 === 0);
        else if (bytes[0] === 0x07) $0e390e60fe847ab5$var$assert(bytes[bytes.length - 1] % 2 === 1);
        var res = this.point(bytes.slice(1, 1 + len), bytes.slice(1 + len, 1 + 2 * len));
        return res;
    } else if ((bytes[0] === 0x02 || bytes[0] === 0x03) && bytes.length - 1 === len) return this.pointFromX(bytes.slice(1, 1 + len), bytes[0] === 0x03);
    throw new Error("Unknown point format");
};
$0e390e60fe847ab5$var$BasePoint.prototype.encodeCompressed = function encodeCompressed(enc) {
    return this.encode(enc, true);
};
$0e390e60fe847ab5$var$BasePoint.prototype._encode = function _encode(compact) {
    var len = this.curve.p.byteLength();
    var x = this.getX().toArray("be", len);
    if (compact) return [
        this.getY().isEven() ? 0x02 : 0x03
    ].concat(x);
    return [
        0x04
    ].concat(x, this.getY().toArray("be", len));
};
$0e390e60fe847ab5$var$BasePoint.prototype.encode = function encode(enc, compact) {
    return $ZdcNb.encode(this._encode(compact), enc);
};
$0e390e60fe847ab5$var$BasePoint.prototype.precompute = function precompute(power) {
    if (this.precomputed) return this;
    var precomputed = {
        doubles: null,
        naf: null,
        beta: null
    };
    precomputed.naf = this._getNAFPoints(8);
    precomputed.doubles = this._getDoubles(4, power);
    precomputed.beta = this._getBeta();
    this.precomputed = precomputed;
    return this;
};
$0e390e60fe847ab5$var$BasePoint.prototype._hasDoubles = function _hasDoubles(k) {
    if (!this.precomputed) return false;
    var doubles = this.precomputed.doubles;
    if (!doubles) return false;
    return doubles.points.length >= Math.ceil((k.bitLength() + 1) / doubles.step);
};
$0e390e60fe847ab5$var$BasePoint.prototype._getDoubles = function _getDoubles(step, power) {
    if (this.precomputed && this.precomputed.doubles) return this.precomputed.doubles;
    var doubles = [
        this
    ];
    var acc = this;
    for(var i = 0; i < power; i += step){
        for(var j = 0; j < step; j++)acc = acc.dbl();
        doubles.push(acc);
    }
    return {
        step: step,
        points: doubles
    };
};
$0e390e60fe847ab5$var$BasePoint.prototype._getNAFPoints = function _getNAFPoints(wnd) {
    if (this.precomputed && this.precomputed.naf) return this.precomputed.naf;
    var res = [
        this
    ];
    var max = (1 << wnd) - 1;
    var dbl = max === 1 ? null : this.dbl();
    for(var i = 1; i < max; i++)res[i] = res[i - 1].add(dbl);
    return {
        wnd: wnd,
        points: res
    };
};
$0e390e60fe847ab5$var$BasePoint.prototype._getBeta = function _getBeta() {
    return null;
};
$0e390e60fe847ab5$var$BasePoint.prototype.dblp = function dblp(k) {
    var r = this;
    for(var i = 0; i < k; i++)r = r.dbl();
    return r;
};

});

parcelRequire.register("laKc8", function(module, exports) {
"use strict";

var $ZdcNb = parcelRequire("ZdcNb");

var $7vYz3 = parcelRequire("7vYz3");

var $eSHUL = parcelRequire("eSHUL");

var $1dHTG = parcelRequire("1dHTG");
var $f69e5d783a5b036a$var$assert = $ZdcNb.assert;
function $f69e5d783a5b036a$var$ShortCurve(conf) {
    $1dHTG.call(this, "short", conf);
    this.a = new $7vYz3(conf.a, 16).toRed(this.red);
    this.b = new $7vYz3(conf.b, 16).toRed(this.red);
    this.tinv = this.two.redInvm();
    this.zeroA = this.a.fromRed().cmpn(0) === 0;
    this.threeA = this.a.fromRed().sub(this.p).cmpn(-3) === 0;
    // If the curve is endomorphic, precalculate beta and lambda
    this.endo = this._getEndomorphism(conf);
    this._endoWnafT1 = new Array(4);
    this._endoWnafT2 = new Array(4);
}
$eSHUL($f69e5d783a5b036a$var$ShortCurve, $1dHTG);
module.exports = $f69e5d783a5b036a$var$ShortCurve;
$f69e5d783a5b036a$var$ShortCurve.prototype._getEndomorphism = function _getEndomorphism(conf) {
    // No efficient endomorphism
    if (!this.zeroA || !this.g || !this.n || this.p.modn(3) !== 1) return;
    // Compute beta and lambda, that lambda * P = (beta * Px; Py)
    var beta;
    var lambda;
    if (conf.beta) beta = new $7vYz3(conf.beta, 16).toRed(this.red);
    else {
        var betas = this._getEndoRoots(this.p);
        // Choose the smallest beta
        beta = betas[0].cmp(betas[1]) < 0 ? betas[0] : betas[1];
        beta = beta.toRed(this.red);
    }
    if (conf.lambda) lambda = new $7vYz3(conf.lambda, 16);
    else {
        // Choose the lambda that is matching selected beta
        var lambdas = this._getEndoRoots(this.n);
        if (this.g.mul(lambdas[0]).x.cmp(this.g.x.redMul(beta)) === 0) lambda = lambdas[0];
        else {
            lambda = lambdas[1];
            $f69e5d783a5b036a$var$assert(this.g.mul(lambda).x.cmp(this.g.x.redMul(beta)) === 0);
        }
    }
    // Get basis vectors, used for balanced length-two representation
    var basis;
    if (conf.basis) basis = conf.basis.map(function(vec) {
        return {
            a: new $7vYz3(vec.a, 16),
            b: new $7vYz3(vec.b, 16)
        };
    });
    else basis = this._getEndoBasis(lambda);
    return {
        beta: beta,
        lambda: lambda,
        basis: basis
    };
};
$f69e5d783a5b036a$var$ShortCurve.prototype._getEndoRoots = function _getEndoRoots(num) {
    // Find roots of for x^2 + x + 1 in F
    // Root = (-1 +- Sqrt(-3)) / 2
    //
    var red = num === this.p ? this.red : $7vYz3.mont(num);
    var tinv = new $7vYz3(2).toRed(red).redInvm();
    var ntinv = tinv.redNeg();
    var s = new $7vYz3(3).toRed(red).redNeg().redSqrt().redMul(tinv);
    var l1 = ntinv.redAdd(s).fromRed();
    var l2 = ntinv.redSub(s).fromRed();
    return [
        l1,
        l2
    ];
};
$f69e5d783a5b036a$var$ShortCurve.prototype._getEndoBasis = function _getEndoBasis(lambda) {
    // aprxSqrt >= sqrt(this.n)
    var aprxSqrt = this.n.ushrn(Math.floor(this.n.bitLength() / 2));
    // 3.74
    // Run EGCD, until r(L + 1) < aprxSqrt
    var u = lambda;
    var v = this.n.clone();
    var x1 = new $7vYz3(1);
    var y1 = new $7vYz3(0);
    var x2 = new $7vYz3(0);
    var y2 = new $7vYz3(1);
    // NOTE: all vectors are roots of: a + b * lambda = 0 (mod n)
    var a0;
    var b0;
    // First vector
    var a1;
    var b1;
    // Second vector
    var a2;
    var b2;
    var prevR;
    var i = 0;
    var r;
    var x;
    while(u.cmpn(0) !== 0){
        var q = v.div(u);
        r = v.sub(q.mul(u));
        x = x2.sub(q.mul(x1));
        var y = y2.sub(q.mul(y1));
        if (!a1 && r.cmp(aprxSqrt) < 0) {
            a0 = prevR.neg();
            b0 = x1;
            a1 = r.neg();
            b1 = x;
        } else if (a1 && ++i === 2) break;
        prevR = r;
        v = u;
        u = r;
        x2 = x1;
        x1 = x;
        y2 = y1;
        y1 = y;
    }
    a2 = r.neg();
    b2 = x;
    var len1 = a1.sqr().add(b1.sqr());
    var len2 = a2.sqr().add(b2.sqr());
    if (len2.cmp(len1) >= 0) {
        a2 = a0;
        b2 = b0;
    }
    // Normalize signs
    if (a1.negative) {
        a1 = a1.neg();
        b1 = b1.neg();
    }
    if (a2.negative) {
        a2 = a2.neg();
        b2 = b2.neg();
    }
    return [
        {
            a: a1,
            b: b1
        },
        {
            a: a2,
            b: b2
        }
    ];
};
$f69e5d783a5b036a$var$ShortCurve.prototype._endoSplit = function _endoSplit(k) {
    var basis = this.endo.basis;
    var v1 = basis[0];
    var v2 = basis[1];
    var c1 = v2.b.mul(k).divRound(this.n);
    var c2 = v1.b.neg().mul(k).divRound(this.n);
    var p1 = c1.mul(v1.a);
    var p2 = c2.mul(v2.a);
    var q1 = c1.mul(v1.b);
    var q2 = c2.mul(v2.b);
    // Calculate answer
    var k1 = k.sub(p1).sub(p2);
    var k2 = q1.add(q2).neg();
    return {
        k1: k1,
        k2: k2
    };
};
$f69e5d783a5b036a$var$ShortCurve.prototype.pointFromX = function pointFromX(x, odd) {
    x = new $7vYz3(x, 16);
    if (!x.red) x = x.toRed(this.red);
    var y2 = x.redSqr().redMul(x).redIAdd(x.redMul(this.a)).redIAdd(this.b);
    var y = y2.redSqrt();
    if (y.redSqr().redSub(y2).cmp(this.zero) !== 0) throw new Error("invalid point");
    // XXX Is there any way to tell if the number is odd without converting it
    // to non-red form?
    var isOdd = y.fromRed().isOdd();
    if (odd && !isOdd || !odd && isOdd) y = y.redNeg();
    return this.point(x, y);
};
$f69e5d783a5b036a$var$ShortCurve.prototype.validate = function validate(point) {
    if (point.inf) return true;
    var x = point.x;
    var y = point.y;
    var ax = this.a.redMul(x);
    var rhs = x.redSqr().redMul(x).redIAdd(ax).redIAdd(this.b);
    return y.redSqr().redISub(rhs).cmpn(0) === 0;
};
$f69e5d783a5b036a$var$ShortCurve.prototype._endoWnafMulAdd = function _endoWnafMulAdd(points, coeffs, jacobianResult) {
    var npoints = this._endoWnafT1;
    var ncoeffs = this._endoWnafT2;
    for(var i = 0; i < points.length; i++){
        var split = this._endoSplit(coeffs[i]);
        var p = points[i];
        var beta = p._getBeta();
        if (split.k1.negative) {
            split.k1.ineg();
            p = p.neg(true);
        }
        if (split.k2.negative) {
            split.k2.ineg();
            beta = beta.neg(true);
        }
        npoints[i * 2] = p;
        npoints[i * 2 + 1] = beta;
        ncoeffs[i * 2] = split.k1;
        ncoeffs[i * 2 + 1] = split.k2;
    }
    var res = this._wnafMulAdd(1, npoints, ncoeffs, i * 2, jacobianResult);
    // Clean-up references to points and coefficients
    for(var j = 0; j < i * 2; j++){
        npoints[j] = null;
        ncoeffs[j] = null;
    }
    return res;
};
function $f69e5d783a5b036a$var$Point(curve, x, y, isRed) {
    $1dHTG.BasePoint.call(this, curve, "affine");
    if (x === null && y === null) {
        this.x = null;
        this.y = null;
        this.inf = true;
    } else {
        this.x = new $7vYz3(x, 16);
        this.y = new $7vYz3(y, 16);
        // Force redgomery representation when loading from JSON
        if (isRed) {
            this.x.forceRed(this.curve.red);
            this.y.forceRed(this.curve.red);
        }
        if (!this.x.red) this.x = this.x.toRed(this.curve.red);
        if (!this.y.red) this.y = this.y.toRed(this.curve.red);
        this.inf = false;
    }
}
$eSHUL($f69e5d783a5b036a$var$Point, $1dHTG.BasePoint);
$f69e5d783a5b036a$var$ShortCurve.prototype.point = function point(x, y, isRed) {
    return new $f69e5d783a5b036a$var$Point(this, x, y, isRed);
};
$f69e5d783a5b036a$var$ShortCurve.prototype.pointFromJSON = function pointFromJSON(obj, red) {
    return $f69e5d783a5b036a$var$Point.fromJSON(this, obj, red);
};
$f69e5d783a5b036a$var$Point.prototype._getBeta = function _getBeta() {
    if (!this.curve.endo) return;
    var pre = this.precomputed;
    if (pre && pre.beta) return pre.beta;
    var beta = this.curve.point(this.x.redMul(this.curve.endo.beta), this.y);
    if (pre) {
        var curve = this.curve;
        var endoMul = function(p) {
            return curve.point(p.x.redMul(curve.endo.beta), p.y);
        };
        pre.beta = beta;
        beta.precomputed = {
            beta: null,
            naf: pre.naf && {
                wnd: pre.naf.wnd,
                points: pre.naf.points.map(endoMul)
            },
            doubles: pre.doubles && {
                step: pre.doubles.step,
                points: pre.doubles.points.map(endoMul)
            }
        };
    }
    return beta;
};
$f69e5d783a5b036a$var$Point.prototype.toJSON = function toJSON() {
    if (!this.precomputed) return [
        this.x,
        this.y
    ];
    return [
        this.x,
        this.y,
        this.precomputed && {
            doubles: this.precomputed.doubles && {
                step: this.precomputed.doubles.step,
                points: this.precomputed.doubles.points.slice(1)
            },
            naf: this.precomputed.naf && {
                wnd: this.precomputed.naf.wnd,
                points: this.precomputed.naf.points.slice(1)
            }
        }
    ];
};
$f69e5d783a5b036a$var$Point.fromJSON = function fromJSON(curve, obj, red) {
    if (typeof obj === "string") obj = JSON.parse(obj);
    var res = curve.point(obj[0], obj[1], red);
    if (!obj[2]) return res;
    function obj2point(obj) {
        return curve.point(obj[0], obj[1], red);
    }
    var pre = obj[2];
    res.precomputed = {
        beta: null,
        doubles: pre.doubles && {
            step: pre.doubles.step,
            points: [
                res
            ].concat(pre.doubles.points.map(obj2point))
        },
        naf: pre.naf && {
            wnd: pre.naf.wnd,
            points: [
                res
            ].concat(pre.naf.points.map(obj2point))
        }
    };
    return res;
};
$f69e5d783a5b036a$var$Point.prototype.inspect = function inspect() {
    if (this.isInfinity()) return "<EC Point Infinity>";
    return "<EC Point x: " + this.x.fromRed().toString(16, 2) + " y: " + this.y.fromRed().toString(16, 2) + ">";
};
$f69e5d783a5b036a$var$Point.prototype.isInfinity = function isInfinity() {
    return this.inf;
};
$f69e5d783a5b036a$var$Point.prototype.add = function add(p) {
    // O + P = P
    if (this.inf) return p;
    // P + O = P
    if (p.inf) return this;
    // P + P = 2P
    if (this.eq(p)) return this.dbl();
    // P + (-P) = O
    if (this.neg().eq(p)) return this.curve.point(null, null);
    // P + Q = O
    if (this.x.cmp(p.x) === 0) return this.curve.point(null, null);
    var c = this.y.redSub(p.y);
    if (c.cmpn(0) !== 0) c = c.redMul(this.x.redSub(p.x).redInvm());
    var nx = c.redSqr().redISub(this.x).redISub(p.x);
    var ny = c.redMul(this.x.redSub(nx)).redISub(this.y);
    return this.curve.point(nx, ny);
};
$f69e5d783a5b036a$var$Point.prototype.dbl = function dbl() {
    if (this.inf) return this;
    // 2P = O
    var ys1 = this.y.redAdd(this.y);
    if (ys1.cmpn(0) === 0) return this.curve.point(null, null);
    var a = this.curve.a;
    var x2 = this.x.redSqr();
    var dyinv = ys1.redInvm();
    var c = x2.redAdd(x2).redIAdd(x2).redIAdd(a).redMul(dyinv);
    var nx = c.redSqr().redISub(this.x.redAdd(this.x));
    var ny = c.redMul(this.x.redSub(nx)).redISub(this.y);
    return this.curve.point(nx, ny);
};
$f69e5d783a5b036a$var$Point.prototype.getX = function getX() {
    return this.x.fromRed();
};
$f69e5d783a5b036a$var$Point.prototype.getY = function getY() {
    return this.y.fromRed();
};
$f69e5d783a5b036a$var$Point.prototype.mul = function mul(k) {
    k = new $7vYz3(k, 16);
    if (this.isInfinity()) return this;
    else if (this._hasDoubles(k)) return this.curve._fixedNafMul(this, k);
    else if (this.curve.endo) return this.curve._endoWnafMulAdd([
        this
    ], [
        k
    ]);
    else return this.curve._wnafMul(this, k);
};
$f69e5d783a5b036a$var$Point.prototype.mulAdd = function mulAdd(k1, p2, k2) {
    var points = [
        this,
        p2
    ];
    var coeffs = [
        k1,
        k2
    ];
    if (this.curve.endo) return this.curve._endoWnafMulAdd(points, coeffs);
    else return this.curve._wnafMulAdd(1, points, coeffs, 2);
};
$f69e5d783a5b036a$var$Point.prototype.jmulAdd = function jmulAdd(k1, p2, k2) {
    var points = [
        this,
        p2
    ];
    var coeffs = [
        k1,
        k2
    ];
    if (this.curve.endo) return this.curve._endoWnafMulAdd(points, coeffs, true);
    else return this.curve._wnafMulAdd(1, points, coeffs, 2, true);
};
$f69e5d783a5b036a$var$Point.prototype.eq = function eq(p) {
    return this === p || this.inf === p.inf && (this.inf || this.x.cmp(p.x) === 0 && this.y.cmp(p.y) === 0);
};
$f69e5d783a5b036a$var$Point.prototype.neg = function neg(_precompute) {
    if (this.inf) return this;
    var res = this.curve.point(this.x, this.y.redNeg());
    if (_precompute && this.precomputed) {
        var pre = this.precomputed;
        var negate = function(p) {
            return p.neg();
        };
        res.precomputed = {
            naf: pre.naf && {
                wnd: pre.naf.wnd,
                points: pre.naf.points.map(negate)
            },
            doubles: pre.doubles && {
                step: pre.doubles.step,
                points: pre.doubles.points.map(negate)
            }
        };
    }
    return res;
};
$f69e5d783a5b036a$var$Point.prototype.toJ = function toJ() {
    if (this.inf) return this.curve.jpoint(null, null, null);
    var res = this.curve.jpoint(this.x, this.y, this.curve.one);
    return res;
};
function $f69e5d783a5b036a$var$JPoint(curve, x, y, z) {
    $1dHTG.BasePoint.call(this, curve, "jacobian");
    if (x === null && y === null && z === null) {
        this.x = this.curve.one;
        this.y = this.curve.one;
        this.z = new $7vYz3(0);
    } else {
        this.x = new $7vYz3(x, 16);
        this.y = new $7vYz3(y, 16);
        this.z = new $7vYz3(z, 16);
    }
    if (!this.x.red) this.x = this.x.toRed(this.curve.red);
    if (!this.y.red) this.y = this.y.toRed(this.curve.red);
    if (!this.z.red) this.z = this.z.toRed(this.curve.red);
    this.zOne = this.z === this.curve.one;
}
$eSHUL($f69e5d783a5b036a$var$JPoint, $1dHTG.BasePoint);
$f69e5d783a5b036a$var$ShortCurve.prototype.jpoint = function jpoint(x, y, z) {
    return new $f69e5d783a5b036a$var$JPoint(this, x, y, z);
};
$f69e5d783a5b036a$var$JPoint.prototype.toP = function toP() {
    if (this.isInfinity()) return this.curve.point(null, null);
    var zinv = this.z.redInvm();
    var zinv2 = zinv.redSqr();
    var ax = this.x.redMul(zinv2);
    var ay = this.y.redMul(zinv2).redMul(zinv);
    return this.curve.point(ax, ay);
};
$f69e5d783a5b036a$var$JPoint.prototype.neg = function neg() {
    return this.curve.jpoint(this.x, this.y.redNeg(), this.z);
};
$f69e5d783a5b036a$var$JPoint.prototype.add = function add(p) {
    // O + P = P
    if (this.isInfinity()) return p;
    // P + O = P
    if (p.isInfinity()) return this;
    // 12M + 4S + 7A
    var pz2 = p.z.redSqr();
    var z2 = this.z.redSqr();
    var u1 = this.x.redMul(pz2);
    var u2 = p.x.redMul(z2);
    var s1 = this.y.redMul(pz2.redMul(p.z));
    var s2 = p.y.redMul(z2.redMul(this.z));
    var h = u1.redSub(u2);
    var r = s1.redSub(s2);
    if (h.cmpn(0) === 0) {
        if (r.cmpn(0) !== 0) return this.curve.jpoint(null, null, null);
        else return this.dbl();
    }
    var h2 = h.redSqr();
    var h3 = h2.redMul(h);
    var v = u1.redMul(h2);
    var nx = r.redSqr().redIAdd(h3).redISub(v).redISub(v);
    var ny = r.redMul(v.redISub(nx)).redISub(s1.redMul(h3));
    var nz = this.z.redMul(p.z).redMul(h);
    return this.curve.jpoint(nx, ny, nz);
};
$f69e5d783a5b036a$var$JPoint.prototype.mixedAdd = function mixedAdd(p) {
    // O + P = P
    if (this.isInfinity()) return p.toJ();
    // P + O = P
    if (p.isInfinity()) return this;
    // 8M + 3S + 7A
    var z2 = this.z.redSqr();
    var u1 = this.x;
    var u2 = p.x.redMul(z2);
    var s1 = this.y;
    var s2 = p.y.redMul(z2).redMul(this.z);
    var h = u1.redSub(u2);
    var r = s1.redSub(s2);
    if (h.cmpn(0) === 0) {
        if (r.cmpn(0) !== 0) return this.curve.jpoint(null, null, null);
        else return this.dbl();
    }
    var h2 = h.redSqr();
    var h3 = h2.redMul(h);
    var v = u1.redMul(h2);
    var nx = r.redSqr().redIAdd(h3).redISub(v).redISub(v);
    var ny = r.redMul(v.redISub(nx)).redISub(s1.redMul(h3));
    var nz = this.z.redMul(h);
    return this.curve.jpoint(nx, ny, nz);
};
$f69e5d783a5b036a$var$JPoint.prototype.dblp = function dblp(pow) {
    if (pow === 0) return this;
    if (this.isInfinity()) return this;
    if (!pow) return this.dbl();
    var i;
    if (this.curve.zeroA || this.curve.threeA) {
        var r = this;
        for(i = 0; i < pow; i++)r = r.dbl();
        return r;
    }
    // 1M + 2S + 1A + N * (4S + 5M + 8A)
    // N = 1 => 6M + 6S + 9A
    var a = this.curve.a;
    var tinv = this.curve.tinv;
    var jx = this.x;
    var jy = this.y;
    var jz = this.z;
    var jz4 = jz.redSqr().redSqr();
    // Reuse results
    var jyd = jy.redAdd(jy);
    for(i = 0; i < pow; i++){
        var jx2 = jx.redSqr();
        var jyd2 = jyd.redSqr();
        var jyd4 = jyd2.redSqr();
        var c = jx2.redAdd(jx2).redIAdd(jx2).redIAdd(a.redMul(jz4));
        var t1 = jx.redMul(jyd2);
        var nx = c.redSqr().redISub(t1.redAdd(t1));
        var t2 = t1.redISub(nx);
        var dny = c.redMul(t2);
        dny = dny.redIAdd(dny).redISub(jyd4);
        var nz = jyd.redMul(jz);
        if (i + 1 < pow) jz4 = jz4.redMul(jyd4);
        jx = nx;
        jz = nz;
        jyd = dny;
    }
    return this.curve.jpoint(jx, jyd.redMul(tinv), jz);
};
$f69e5d783a5b036a$var$JPoint.prototype.dbl = function dbl() {
    if (this.isInfinity()) return this;
    if (this.curve.zeroA) return this._zeroDbl();
    else if (this.curve.threeA) return this._threeDbl();
    else return this._dbl();
};
$f69e5d783a5b036a$var$JPoint.prototype._zeroDbl = function _zeroDbl() {
    var nx;
    var ny;
    var nz;
    // Z = 1
    if (this.zOne) {
        // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-0.html
        //     #doubling-mdbl-2007-bl
        // 1M + 5S + 14A
        // XX = X1^2
        var xx = this.x.redSqr();
        // YY = Y1^2
        var yy = this.y.redSqr();
        // YYYY = YY^2
        var yyyy = yy.redSqr();
        // S = 2 * ((X1 + YY)^2 - XX - YYYY)
        var s = this.x.redAdd(yy).redSqr().redISub(xx).redISub(yyyy);
        s = s.redIAdd(s);
        // M = 3 * XX + a; a = 0
        var m = xx.redAdd(xx).redIAdd(xx);
        // T = M ^ 2 - 2*S
        var t = m.redSqr().redISub(s).redISub(s);
        // 8 * YYYY
        var yyyy8 = yyyy.redIAdd(yyyy);
        yyyy8 = yyyy8.redIAdd(yyyy8);
        yyyy8 = yyyy8.redIAdd(yyyy8);
        // X3 = T
        nx = t;
        // Y3 = M * (S - T) - 8 * YYYY
        ny = m.redMul(s.redISub(t)).redISub(yyyy8);
        // Z3 = 2*Y1
        nz = this.y.redAdd(this.y);
    } else {
        // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-0.html
        //     #doubling-dbl-2009-l
        // 2M + 5S + 13A
        // A = X1^2
        var a = this.x.redSqr();
        // B = Y1^2
        var b = this.y.redSqr();
        // C = B^2
        var c = b.redSqr();
        // D = 2 * ((X1 + B)^2 - A - C)
        var d = this.x.redAdd(b).redSqr().redISub(a).redISub(c);
        d = d.redIAdd(d);
        // E = 3 * A
        var e = a.redAdd(a).redIAdd(a);
        // F = E^2
        var f = e.redSqr();
        // 8 * C
        var c8 = c.redIAdd(c);
        c8 = c8.redIAdd(c8);
        c8 = c8.redIAdd(c8);
        // X3 = F - 2 * D
        nx = f.redISub(d).redISub(d);
        // Y3 = E * (D - X3) - 8 * C
        ny = e.redMul(d.redISub(nx)).redISub(c8);
        // Z3 = 2 * Y1 * Z1
        nz = this.y.redMul(this.z);
        nz = nz.redIAdd(nz);
    }
    return this.curve.jpoint(nx, ny, nz);
};
$f69e5d783a5b036a$var$JPoint.prototype._threeDbl = function _threeDbl() {
    var nx;
    var ny;
    var nz;
    // Z = 1
    if (this.zOne) {
        // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-3.html
        //     #doubling-mdbl-2007-bl
        // 1M + 5S + 15A
        // XX = X1^2
        var xx = this.x.redSqr();
        // YY = Y1^2
        var yy = this.y.redSqr();
        // YYYY = YY^2
        var yyyy = yy.redSqr();
        // S = 2 * ((X1 + YY)^2 - XX - YYYY)
        var s = this.x.redAdd(yy).redSqr().redISub(xx).redISub(yyyy);
        s = s.redIAdd(s);
        // M = 3 * XX + a
        var m = xx.redAdd(xx).redIAdd(xx).redIAdd(this.curve.a);
        // T = M^2 - 2 * S
        var t = m.redSqr().redISub(s).redISub(s);
        // X3 = T
        nx = t;
        // Y3 = M * (S - T) - 8 * YYYY
        var yyyy8 = yyyy.redIAdd(yyyy);
        yyyy8 = yyyy8.redIAdd(yyyy8);
        yyyy8 = yyyy8.redIAdd(yyyy8);
        ny = m.redMul(s.redISub(t)).redISub(yyyy8);
        // Z3 = 2 * Y1
        nz = this.y.redAdd(this.y);
    } else {
        // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-3.html#doubling-dbl-2001-b
        // 3M + 5S
        // delta = Z1^2
        var delta = this.z.redSqr();
        // gamma = Y1^2
        var gamma = this.y.redSqr();
        // beta = X1 * gamma
        var beta = this.x.redMul(gamma);
        // alpha = 3 * (X1 - delta) * (X1 + delta)
        var alpha = this.x.redSub(delta).redMul(this.x.redAdd(delta));
        alpha = alpha.redAdd(alpha).redIAdd(alpha);
        // X3 = alpha^2 - 8 * beta
        var beta4 = beta.redIAdd(beta);
        beta4 = beta4.redIAdd(beta4);
        var beta8 = beta4.redAdd(beta4);
        nx = alpha.redSqr().redISub(beta8);
        // Z3 = (Y1 + Z1)^2 - gamma - delta
        nz = this.y.redAdd(this.z).redSqr().redISub(gamma).redISub(delta);
        // Y3 = alpha * (4 * beta - X3) - 8 * gamma^2
        var ggamma8 = gamma.redSqr();
        ggamma8 = ggamma8.redIAdd(ggamma8);
        ggamma8 = ggamma8.redIAdd(ggamma8);
        ggamma8 = ggamma8.redIAdd(ggamma8);
        ny = alpha.redMul(beta4.redISub(nx)).redISub(ggamma8);
    }
    return this.curve.jpoint(nx, ny, nz);
};
$f69e5d783a5b036a$var$JPoint.prototype._dbl = function _dbl() {
    var a = this.curve.a;
    // 4M + 6S + 10A
    var jx = this.x;
    var jy = this.y;
    var jz = this.z;
    var jz4 = jz.redSqr().redSqr();
    var jx2 = jx.redSqr();
    var jy2 = jy.redSqr();
    var c = jx2.redAdd(jx2).redIAdd(jx2).redIAdd(a.redMul(jz4));
    var jxd4 = jx.redAdd(jx);
    jxd4 = jxd4.redIAdd(jxd4);
    var t1 = jxd4.redMul(jy2);
    var nx = c.redSqr().redISub(t1.redAdd(t1));
    var t2 = t1.redISub(nx);
    var jyd8 = jy2.redSqr();
    jyd8 = jyd8.redIAdd(jyd8);
    jyd8 = jyd8.redIAdd(jyd8);
    jyd8 = jyd8.redIAdd(jyd8);
    var ny = c.redMul(t2).redISub(jyd8);
    var nz = jy.redAdd(jy).redMul(jz);
    return this.curve.jpoint(nx, ny, nz);
};
$f69e5d783a5b036a$var$JPoint.prototype.trpl = function trpl() {
    if (!this.curve.zeroA) return this.dbl().add(this);
    // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-0.html#tripling-tpl-2007-bl
    // 5M + 10S + ...
    // XX = X1^2
    var xx = this.x.redSqr();
    // YY = Y1^2
    var yy = this.y.redSqr();
    // ZZ = Z1^2
    var zz = this.z.redSqr();
    // YYYY = YY^2
    var yyyy = yy.redSqr();
    // M = 3 * XX + a * ZZ2; a = 0
    var m = xx.redAdd(xx).redIAdd(xx);
    // MM = M^2
    var mm = m.redSqr();
    // E = 6 * ((X1 + YY)^2 - XX - YYYY) - MM
    var e = this.x.redAdd(yy).redSqr().redISub(xx).redISub(yyyy);
    e = e.redIAdd(e);
    e = e.redAdd(e).redIAdd(e);
    e = e.redISub(mm);
    // EE = E^2
    var ee = e.redSqr();
    // T = 16*YYYY
    var t = yyyy.redIAdd(yyyy);
    t = t.redIAdd(t);
    t = t.redIAdd(t);
    t = t.redIAdd(t);
    // U = (M + E)^2 - MM - EE - T
    var u = m.redIAdd(e).redSqr().redISub(mm).redISub(ee).redISub(t);
    // X3 = 4 * (X1 * EE - 4 * YY * U)
    var yyu4 = yy.redMul(u);
    yyu4 = yyu4.redIAdd(yyu4);
    yyu4 = yyu4.redIAdd(yyu4);
    var nx = this.x.redMul(ee).redISub(yyu4);
    nx = nx.redIAdd(nx);
    nx = nx.redIAdd(nx);
    // Y3 = 8 * Y1 * (U * (T - U) - E * EE)
    var ny = this.y.redMul(u.redMul(t.redISub(u)).redISub(e.redMul(ee)));
    ny = ny.redIAdd(ny);
    ny = ny.redIAdd(ny);
    ny = ny.redIAdd(ny);
    // Z3 = (Z1 + E)^2 - ZZ - EE
    var nz = this.z.redAdd(e).redSqr().redISub(zz).redISub(ee);
    return this.curve.jpoint(nx, ny, nz);
};
$f69e5d783a5b036a$var$JPoint.prototype.mul = function mul(k, kbase) {
    k = new $7vYz3(k, kbase);
    return this.curve._wnafMul(this, k);
};
$f69e5d783a5b036a$var$JPoint.prototype.eq = function eq(p) {
    if (p.type === "affine") return this.eq(p.toJ());
    if (this === p) return true;
    // x1 * z2^2 == x2 * z1^2
    var z2 = this.z.redSqr();
    var pz2 = p.z.redSqr();
    if (this.x.redMul(pz2).redISub(p.x.redMul(z2)).cmpn(0) !== 0) return false;
    // y1 * z2^3 == y2 * z1^3
    var z3 = z2.redMul(this.z);
    var pz3 = pz2.redMul(p.z);
    return this.y.redMul(pz3).redISub(p.y.redMul(z3)).cmpn(0) === 0;
};
$f69e5d783a5b036a$var$JPoint.prototype.eqXToP = function eqXToP(x) {
    var zs = this.z.redSqr();
    var rx = x.toRed(this.curve.red).redMul(zs);
    if (this.x.cmp(rx) === 0) return true;
    var xc = x.clone();
    var t = this.curve.redN.redMul(zs);
    for(;;){
        xc.iadd(this.curve.n);
        if (xc.cmp(this.curve.p) >= 0) return false;
        rx.redIAdd(t);
        if (this.x.cmp(rx) === 0) return true;
    }
};
$f69e5d783a5b036a$var$JPoint.prototype.inspect = function inspect() {
    if (this.isInfinity()) return "<EC JPoint Infinity>";
    return "<EC JPoint x: " + this.x.toString(16, 2) + " y: " + this.y.toString(16, 2) + " z: " + this.z.toString(16, 2) + ">";
};
$f69e5d783a5b036a$var$JPoint.prototype.isInfinity = function isInfinity() {
    // XXX This code assumes that zero is always zero in red
    return this.z.cmpn(0) === 0;
};

});

parcelRequire.register("3uGhx", function(module, exports) {
"use strict";

var $7vYz3 = parcelRequire("7vYz3");

var $eSHUL = parcelRequire("eSHUL");

var $1dHTG = parcelRequire("1dHTG");

var $ZdcNb = parcelRequire("ZdcNb");
function $28b4f8bfddf22eb4$var$MontCurve(conf) {
    $1dHTG.call(this, "mont", conf);
    this.a = new $7vYz3(conf.a, 16).toRed(this.red);
    this.b = new $7vYz3(conf.b, 16).toRed(this.red);
    this.i4 = new $7vYz3(4).toRed(this.red).redInvm();
    this.two = new $7vYz3(2).toRed(this.red);
    this.a24 = this.i4.redMul(this.a.redAdd(this.two));
}
$eSHUL($28b4f8bfddf22eb4$var$MontCurve, $1dHTG);
module.exports = $28b4f8bfddf22eb4$var$MontCurve;
$28b4f8bfddf22eb4$var$MontCurve.prototype.validate = function validate(point) {
    var x = point.normalize().x;
    var x2 = x.redSqr();
    var rhs = x2.redMul(x).redAdd(x2.redMul(this.a)).redAdd(x);
    var y = rhs.redSqrt();
    return y.redSqr().cmp(rhs) === 0;
};
function $28b4f8bfddf22eb4$var$Point(curve, x, z) {
    $1dHTG.BasePoint.call(this, curve, "projective");
    if (x === null && z === null) {
        this.x = this.curve.one;
        this.z = this.curve.zero;
    } else {
        this.x = new $7vYz3(x, 16);
        this.z = new $7vYz3(z, 16);
        if (!this.x.red) this.x = this.x.toRed(this.curve.red);
        if (!this.z.red) this.z = this.z.toRed(this.curve.red);
    }
}
$eSHUL($28b4f8bfddf22eb4$var$Point, $1dHTG.BasePoint);
$28b4f8bfddf22eb4$var$MontCurve.prototype.decodePoint = function decodePoint(bytes, enc) {
    return this.point($ZdcNb.toArray(bytes, enc), 1);
};
$28b4f8bfddf22eb4$var$MontCurve.prototype.point = function point(x, z) {
    return new $28b4f8bfddf22eb4$var$Point(this, x, z);
};
$28b4f8bfddf22eb4$var$MontCurve.prototype.pointFromJSON = function pointFromJSON(obj) {
    return $28b4f8bfddf22eb4$var$Point.fromJSON(this, obj);
};
$28b4f8bfddf22eb4$var$Point.prototype.precompute = function precompute() {
// No-op
};
$28b4f8bfddf22eb4$var$Point.prototype._encode = function _encode() {
    return this.getX().toArray("be", this.curve.p.byteLength());
};
$28b4f8bfddf22eb4$var$Point.fromJSON = function fromJSON(curve, obj) {
    return new $28b4f8bfddf22eb4$var$Point(curve, obj[0], obj[1] || curve.one);
};
$28b4f8bfddf22eb4$var$Point.prototype.inspect = function inspect() {
    if (this.isInfinity()) return "<EC Point Infinity>";
    return "<EC Point x: " + this.x.fromRed().toString(16, 2) + " z: " + this.z.fromRed().toString(16, 2) + ">";
};
$28b4f8bfddf22eb4$var$Point.prototype.isInfinity = function isInfinity() {
    // XXX This code assumes that zero is always zero in red
    return this.z.cmpn(0) === 0;
};
$28b4f8bfddf22eb4$var$Point.prototype.dbl = function dbl() {
    // http://hyperelliptic.org/EFD/g1p/auto-montgom-xz.html#doubling-dbl-1987-m-3
    // 2M + 2S + 4A
    // A = X1 + Z1
    var a = this.x.redAdd(this.z);
    // AA = A^2
    var aa = a.redSqr();
    // B = X1 - Z1
    var b = this.x.redSub(this.z);
    // BB = B^2
    var bb = b.redSqr();
    // C = AA - BB
    var c = aa.redSub(bb);
    // X3 = AA * BB
    var nx = aa.redMul(bb);
    // Z3 = C * (BB + A24 * C)
    var nz = c.redMul(bb.redAdd(this.curve.a24.redMul(c)));
    return this.curve.point(nx, nz);
};
$28b4f8bfddf22eb4$var$Point.prototype.add = function add() {
    throw new Error("Not supported on Montgomery curve");
};
$28b4f8bfddf22eb4$var$Point.prototype.diffAdd = function diffAdd(p, diff) {
    // http://hyperelliptic.org/EFD/g1p/auto-montgom-xz.html#diffadd-dadd-1987-m-3
    // 4M + 2S + 6A
    // A = X2 + Z2
    var a = this.x.redAdd(this.z);
    // B = X2 - Z2
    var b = this.x.redSub(this.z);
    // C = X3 + Z3
    var c = p.x.redAdd(p.z);
    // D = X3 - Z3
    var d = p.x.redSub(p.z);
    // DA = D * A
    var da = d.redMul(a);
    // CB = C * B
    var cb = c.redMul(b);
    // X5 = Z1 * (DA + CB)^2
    var nx = diff.z.redMul(da.redAdd(cb).redSqr());
    // Z5 = X1 * (DA - CB)^2
    var nz = diff.x.redMul(da.redISub(cb).redSqr());
    return this.curve.point(nx, nz);
};
$28b4f8bfddf22eb4$var$Point.prototype.mul = function mul(k) {
    var t = k.clone();
    var a = this; // (N / 2) * Q + Q
    var b = this.curve.point(null, null); // (N / 2) * Q
    var c = this; // Q
    for(var bits = []; t.cmpn(0) !== 0; t.iushrn(1))bits.push(t.andln(1));
    for(var i = bits.length - 1; i >= 0; i--)if (bits[i] === 0) {
        // N * Q + Q = ((N / 2) * Q + Q)) + (N / 2) * Q
        a = a.diffAdd(b, c);
        // N * Q = 2 * ((N / 2) * Q + Q))
        b = b.dbl();
    } else {
        // N * Q = ((N / 2) * Q + Q) + ((N / 2) * Q)
        b = a.diffAdd(b, c);
        // N * Q + Q = 2 * ((N / 2) * Q + Q)
        a = a.dbl();
    }
    return b;
};
$28b4f8bfddf22eb4$var$Point.prototype.mulAdd = function mulAdd() {
    throw new Error("Not supported on Montgomery curve");
};
$28b4f8bfddf22eb4$var$Point.prototype.jumlAdd = function jumlAdd() {
    throw new Error("Not supported on Montgomery curve");
};
$28b4f8bfddf22eb4$var$Point.prototype.eq = function eq(other) {
    return this.getX().cmp(other.getX()) === 0;
};
$28b4f8bfddf22eb4$var$Point.prototype.normalize = function normalize() {
    this.x = this.x.redMul(this.z.redInvm());
    this.z = this.curve.one;
    return this;
};
$28b4f8bfddf22eb4$var$Point.prototype.getX = function getX() {
    // Normalize coordinates
    this.normalize();
    return this.x.fromRed();
};

});

parcelRequire.register("a0HUE", function(module, exports) {
"use strict";

var $ZdcNb = parcelRequire("ZdcNb");

var $7vYz3 = parcelRequire("7vYz3");

var $eSHUL = parcelRequire("eSHUL");

var $1dHTG = parcelRequire("1dHTG");
var $749bf799fac4284f$var$assert = $ZdcNb.assert;
function $749bf799fac4284f$var$EdwardsCurve(conf) {
    // NOTE: Important as we are creating point in Base.call()
    this.twisted = (conf.a | 0) !== 1;
    this.mOneA = this.twisted && (conf.a | 0) === -1;
    this.extended = this.mOneA;
    $1dHTG.call(this, "edwards", conf);
    this.a = new $7vYz3(conf.a, 16).umod(this.red.m);
    this.a = this.a.toRed(this.red);
    this.c = new $7vYz3(conf.c, 16).toRed(this.red);
    this.c2 = this.c.redSqr();
    this.d = new $7vYz3(conf.d, 16).toRed(this.red);
    this.dd = this.d.redAdd(this.d);
    $749bf799fac4284f$var$assert(!this.twisted || this.c.fromRed().cmpn(1) === 0);
    this.oneC = (conf.c | 0) === 1;
}
$eSHUL($749bf799fac4284f$var$EdwardsCurve, $1dHTG);
module.exports = $749bf799fac4284f$var$EdwardsCurve;
$749bf799fac4284f$var$EdwardsCurve.prototype._mulA = function _mulA(num) {
    if (this.mOneA) return num.redNeg();
    else return this.a.redMul(num);
};
$749bf799fac4284f$var$EdwardsCurve.prototype._mulC = function _mulC(num) {
    if (this.oneC) return num;
    else return this.c.redMul(num);
};
// Just for compatibility with Short curve
$749bf799fac4284f$var$EdwardsCurve.prototype.jpoint = function jpoint(x, y, z, t) {
    return this.point(x, y, z, t);
};
$749bf799fac4284f$var$EdwardsCurve.prototype.pointFromX = function pointFromX(x, odd) {
    x = new $7vYz3(x, 16);
    if (!x.red) x = x.toRed(this.red);
    var x2 = x.redSqr();
    var rhs = this.c2.redSub(this.a.redMul(x2));
    var lhs = this.one.redSub(this.c2.redMul(this.d).redMul(x2));
    var y2 = rhs.redMul(lhs.redInvm());
    var y = y2.redSqrt();
    if (y.redSqr().redSub(y2).cmp(this.zero) !== 0) throw new Error("invalid point");
    var isOdd = y.fromRed().isOdd();
    if (odd && !isOdd || !odd && isOdd) y = y.redNeg();
    return this.point(x, y);
};
$749bf799fac4284f$var$EdwardsCurve.prototype.pointFromY = function pointFromY(y, odd) {
    y = new $7vYz3(y, 16);
    if (!y.red) y = y.toRed(this.red);
    // x^2 = (y^2 - c^2) / (c^2 d y^2 - a)
    var y2 = y.redSqr();
    var lhs = y2.redSub(this.c2);
    var rhs = y2.redMul(this.d).redMul(this.c2).redSub(this.a);
    var x2 = lhs.redMul(rhs.redInvm());
    if (x2.cmp(this.zero) === 0) {
        if (odd) throw new Error("invalid point");
        else return this.point(this.zero, y);
    }
    var x = x2.redSqrt();
    if (x.redSqr().redSub(x2).cmp(this.zero) !== 0) throw new Error("invalid point");
    if (x.fromRed().isOdd() !== odd) x = x.redNeg();
    return this.point(x, y);
};
$749bf799fac4284f$var$EdwardsCurve.prototype.validate = function validate(point) {
    if (point.isInfinity()) return true;
    // Curve: A * X^2 + Y^2 = C^2 * (1 + D * X^2 * Y^2)
    point.normalize();
    var x2 = point.x.redSqr();
    var y2 = point.y.redSqr();
    var lhs = x2.redMul(this.a).redAdd(y2);
    var rhs = this.c2.redMul(this.one.redAdd(this.d.redMul(x2).redMul(y2)));
    return lhs.cmp(rhs) === 0;
};
function $749bf799fac4284f$var$Point(curve, x, y, z, t) {
    $1dHTG.BasePoint.call(this, curve, "projective");
    if (x === null && y === null && z === null) {
        this.x = this.curve.zero;
        this.y = this.curve.one;
        this.z = this.curve.one;
        this.t = this.curve.zero;
        this.zOne = true;
    } else {
        this.x = new $7vYz3(x, 16);
        this.y = new $7vYz3(y, 16);
        this.z = z ? new $7vYz3(z, 16) : this.curve.one;
        this.t = t && new $7vYz3(t, 16);
        if (!this.x.red) this.x = this.x.toRed(this.curve.red);
        if (!this.y.red) this.y = this.y.toRed(this.curve.red);
        if (!this.z.red) this.z = this.z.toRed(this.curve.red);
        if (this.t && !this.t.red) this.t = this.t.toRed(this.curve.red);
        this.zOne = this.z === this.curve.one;
        // Use extended coordinates
        if (this.curve.extended && !this.t) {
            this.t = this.x.redMul(this.y);
            if (!this.zOne) this.t = this.t.redMul(this.z.redInvm());
        }
    }
}
$eSHUL($749bf799fac4284f$var$Point, $1dHTG.BasePoint);
$749bf799fac4284f$var$EdwardsCurve.prototype.pointFromJSON = function pointFromJSON(obj) {
    return $749bf799fac4284f$var$Point.fromJSON(this, obj);
};
$749bf799fac4284f$var$EdwardsCurve.prototype.point = function point(x, y, z, t) {
    return new $749bf799fac4284f$var$Point(this, x, y, z, t);
};
$749bf799fac4284f$var$Point.fromJSON = function fromJSON(curve, obj) {
    return new $749bf799fac4284f$var$Point(curve, obj[0], obj[1], obj[2]);
};
$749bf799fac4284f$var$Point.prototype.inspect = function inspect() {
    if (this.isInfinity()) return "<EC Point Infinity>";
    return "<EC Point x: " + this.x.fromRed().toString(16, 2) + " y: " + this.y.fromRed().toString(16, 2) + " z: " + this.z.fromRed().toString(16, 2) + ">";
};
$749bf799fac4284f$var$Point.prototype.isInfinity = function isInfinity() {
    // XXX This code assumes that zero is always zero in red
    return this.x.cmpn(0) === 0 && (this.y.cmp(this.z) === 0 || this.zOne && this.y.cmp(this.curve.c) === 0);
};
$749bf799fac4284f$var$Point.prototype._extDbl = function _extDbl() {
    // hyperelliptic.org/EFD/g1p/auto-twisted-extended-1.html
    //     #doubling-dbl-2008-hwcd
    // 4M + 4S
    // A = X1^2
    var a = this.x.redSqr();
    // B = Y1^2
    var b = this.y.redSqr();
    // C = 2 * Z1^2
    var c = this.z.redSqr();
    c = c.redIAdd(c);
    // D = a * A
    var d = this.curve._mulA(a);
    // E = (X1 + Y1)^2 - A - B
    var e = this.x.redAdd(this.y).redSqr().redISub(a).redISub(b);
    // G = D + B
    var g = d.redAdd(b);
    // F = G - C
    var f = g.redSub(c);
    // H = D - B
    var h = d.redSub(b);
    // X3 = E * F
    var nx = e.redMul(f);
    // Y3 = G * H
    var ny = g.redMul(h);
    // T3 = E * H
    var nt = e.redMul(h);
    // Z3 = F * G
    var nz = f.redMul(g);
    return this.curve.point(nx, ny, nz, nt);
};
$749bf799fac4284f$var$Point.prototype._projDbl = function _projDbl() {
    // hyperelliptic.org/EFD/g1p/auto-twisted-projective.html
    //     #doubling-dbl-2008-bbjlp
    //     #doubling-dbl-2007-bl
    // and others
    // Generally 3M + 4S or 2M + 4S
    // B = (X1 + Y1)^2
    var b = this.x.redAdd(this.y).redSqr();
    // C = X1^2
    var c = this.x.redSqr();
    // D = Y1^2
    var d = this.y.redSqr();
    var nx;
    var ny;
    var nz;
    var e;
    var h;
    var j;
    if (this.curve.twisted) {
        // E = a * C
        e = this.curve._mulA(c);
        // F = E + D
        var f = e.redAdd(d);
        if (this.zOne) {
            // X3 = (B - C - D) * (F - 2)
            nx = b.redSub(c).redSub(d).redMul(f.redSub(this.curve.two));
            // Y3 = F * (E - D)
            ny = f.redMul(e.redSub(d));
            // Z3 = F^2 - 2 * F
            nz = f.redSqr().redSub(f).redSub(f);
        } else {
            // H = Z1^2
            h = this.z.redSqr();
            // J = F - 2 * H
            j = f.redSub(h).redISub(h);
            // X3 = (B-C-D)*J
            nx = b.redSub(c).redISub(d).redMul(j);
            // Y3 = F * (E - D)
            ny = f.redMul(e.redSub(d));
            // Z3 = F * J
            nz = f.redMul(j);
        }
    } else {
        // E = C + D
        e = c.redAdd(d);
        // H = (c * Z1)^2
        h = this.curve._mulC(this.z).redSqr();
        // J = E - 2 * H
        j = e.redSub(h).redSub(h);
        // X3 = c * (B - E) * J
        nx = this.curve._mulC(b.redISub(e)).redMul(j);
        // Y3 = c * E * (C - D)
        ny = this.curve._mulC(e).redMul(c.redISub(d));
        // Z3 = E * J
        nz = e.redMul(j);
    }
    return this.curve.point(nx, ny, nz);
};
$749bf799fac4284f$var$Point.prototype.dbl = function dbl() {
    if (this.isInfinity()) return this;
    // Double in extended coordinates
    if (this.curve.extended) return this._extDbl();
    else return this._projDbl();
};
$749bf799fac4284f$var$Point.prototype._extAdd = function _extAdd(p) {
    // hyperelliptic.org/EFD/g1p/auto-twisted-extended-1.html
    //     #addition-add-2008-hwcd-3
    // 8M
    // A = (Y1 - X1) * (Y2 - X2)
    var a = this.y.redSub(this.x).redMul(p.y.redSub(p.x));
    // B = (Y1 + X1) * (Y2 + X2)
    var b = this.y.redAdd(this.x).redMul(p.y.redAdd(p.x));
    // C = T1 * k * T2
    var c = this.t.redMul(this.curve.dd).redMul(p.t);
    // D = Z1 * 2 * Z2
    var d = this.z.redMul(p.z.redAdd(p.z));
    // E = B - A
    var e = b.redSub(a);
    // F = D - C
    var f = d.redSub(c);
    // G = D + C
    var g = d.redAdd(c);
    // H = B + A
    var h = b.redAdd(a);
    // X3 = E * F
    var nx = e.redMul(f);
    // Y3 = G * H
    var ny = g.redMul(h);
    // T3 = E * H
    var nt = e.redMul(h);
    // Z3 = F * G
    var nz = f.redMul(g);
    return this.curve.point(nx, ny, nz, nt);
};
$749bf799fac4284f$var$Point.prototype._projAdd = function _projAdd(p) {
    // hyperelliptic.org/EFD/g1p/auto-twisted-projective.html
    //     #addition-add-2008-bbjlp
    //     #addition-add-2007-bl
    // 10M + 1S
    // A = Z1 * Z2
    var a = this.z.redMul(p.z);
    // B = A^2
    var b = a.redSqr();
    // C = X1 * X2
    var c = this.x.redMul(p.x);
    // D = Y1 * Y2
    var d = this.y.redMul(p.y);
    // E = d * C * D
    var e = this.curve.d.redMul(c).redMul(d);
    // F = B - E
    var f = b.redSub(e);
    // G = B + E
    var g = b.redAdd(e);
    // X3 = A * F * ((X1 + Y1) * (X2 + Y2) - C - D)
    var tmp = this.x.redAdd(this.y).redMul(p.x.redAdd(p.y)).redISub(c).redISub(d);
    var nx = a.redMul(f).redMul(tmp);
    var ny;
    var nz;
    if (this.curve.twisted) {
        // Y3 = A * G * (D - a * C)
        ny = a.redMul(g).redMul(d.redSub(this.curve._mulA(c)));
        // Z3 = F * G
        nz = f.redMul(g);
    } else {
        // Y3 = A * G * (D - C)
        ny = a.redMul(g).redMul(d.redSub(c));
        // Z3 = c * F * G
        nz = this.curve._mulC(f).redMul(g);
    }
    return this.curve.point(nx, ny, nz);
};
$749bf799fac4284f$var$Point.prototype.add = function add(p) {
    if (this.isInfinity()) return p;
    if (p.isInfinity()) return this;
    if (this.curve.extended) return this._extAdd(p);
    else return this._projAdd(p);
};
$749bf799fac4284f$var$Point.prototype.mul = function mul(k) {
    if (this._hasDoubles(k)) return this.curve._fixedNafMul(this, k);
    else return this.curve._wnafMul(this, k);
};
$749bf799fac4284f$var$Point.prototype.mulAdd = function mulAdd(k1, p, k2) {
    return this.curve._wnafMulAdd(1, [
        this,
        p
    ], [
        k1,
        k2
    ], 2, false);
};
$749bf799fac4284f$var$Point.prototype.jmulAdd = function jmulAdd(k1, p, k2) {
    return this.curve._wnafMulAdd(1, [
        this,
        p
    ], [
        k1,
        k2
    ], 2, true);
};
$749bf799fac4284f$var$Point.prototype.normalize = function normalize() {
    if (this.zOne) return this;
    // Normalize coordinates
    var zi = this.z.redInvm();
    this.x = this.x.redMul(zi);
    this.y = this.y.redMul(zi);
    if (this.t) this.t = this.t.redMul(zi);
    this.z = this.curve.one;
    this.zOne = true;
    return this;
};
$749bf799fac4284f$var$Point.prototype.neg = function neg() {
    return this.curve.point(this.x.redNeg(), this.y, this.z, this.t && this.t.redNeg());
};
$749bf799fac4284f$var$Point.prototype.getX = function getX() {
    this.normalize();
    return this.x.fromRed();
};
$749bf799fac4284f$var$Point.prototype.getY = function getY() {
    this.normalize();
    return this.y.fromRed();
};
$749bf799fac4284f$var$Point.prototype.eq = function eq(other) {
    return this === other || this.getX().cmp(other.getX()) === 0 && this.getY().cmp(other.getY()) === 0;
};
$749bf799fac4284f$var$Point.prototype.eqXToP = function eqXToP(x) {
    var rx = x.toRed(this.curve.red).redMul(this.z);
    if (this.x.cmp(rx) === 0) return true;
    var xc = x.clone();
    var t = this.curve.redN.redMul(this.z);
    for(;;){
        xc.iadd(this.curve.n);
        if (xc.cmp(this.curve.p) >= 0) return false;
        rx.redIAdd(t);
        if (this.x.cmp(rx) === 0) return true;
    }
};
// Compatibility with BaseCurve
$749bf799fac4284f$var$Point.prototype.toP = $749bf799fac4284f$var$Point.prototype.normalize;
$749bf799fac4284f$var$Point.prototype.mixedAdd = $749bf799fac4284f$var$Point.prototype.add;

});


parcelRequire.register("hwVHR", function(module, exports) {
"use strict";
var $cc32301b3f482b8e$var$curves = module.exports;

var $leqJp = parcelRequire("leqJp");

var $fYJT3 = parcelRequire("fYJT3");

var $ZdcNb = parcelRequire("ZdcNb");
var $cc32301b3f482b8e$var$assert = $ZdcNb.assert;
function $cc32301b3f482b8e$var$PresetCurve(options) {
    if (options.type === "short") this.curve = new $fYJT3.short(options);
    else if (options.type === "edwards") this.curve = new $fYJT3.edwards(options);
    else this.curve = new $fYJT3.mont(options);
    this.g = this.curve.g;
    this.n = this.curve.n;
    this.hash = options.hash;
    $cc32301b3f482b8e$var$assert(this.g.validate(), "Invalid curve");
    $cc32301b3f482b8e$var$assert(this.g.mul(this.n).isInfinity(), "Invalid curve, G*N != O");
}
$cc32301b3f482b8e$var$curves.PresetCurve = $cc32301b3f482b8e$var$PresetCurve;
function $cc32301b3f482b8e$var$defineCurve(name, options) {
    Object.defineProperty($cc32301b3f482b8e$var$curves, name, {
        configurable: true,
        enumerable: true,
        get: function() {
            var curve = new $cc32301b3f482b8e$var$PresetCurve(options);
            Object.defineProperty($cc32301b3f482b8e$var$curves, name, {
                configurable: true,
                enumerable: true,
                value: curve
            });
            return curve;
        }
    });
}
$cc32301b3f482b8e$var$defineCurve("p192", {
    type: "short",
    prime: "p192",
    p: "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff",
    a: "ffffffff ffffffff ffffffff fffffffe ffffffff fffffffc",
    b: "64210519 e59c80e7 0fa7e9ab 72243049 feb8deec c146b9b1",
    n: "ffffffff ffffffff ffffffff 99def836 146bc9b1 b4d22831",
    hash: $leqJp.sha256,
    gRed: false,
    g: [
        "188da80e b03090f6 7cbf20eb 43a18800 f4ff0afd 82ff1012",
        "07192b95 ffc8da78 631011ed 6b24cdd5 73f977a1 1e794811"
    ]
});
$cc32301b3f482b8e$var$defineCurve("p224", {
    type: "short",
    prime: "p224",
    p: "ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001",
    a: "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff fffffffe",
    b: "b4050a85 0c04b3ab f5413256 5044b0b7 d7bfd8ba 270b3943 2355ffb4",
    n: "ffffffff ffffffff ffffffff ffff16a2 e0b8f03e 13dd2945 5c5c2a3d",
    hash: $leqJp.sha256,
    gRed: false,
    g: [
        "b70e0cbd 6bb4bf7f 321390b9 4a03c1d3 56c21122 343280d6 115c1d21",
        "bd376388 b5f723fb 4c22dfe6 cd4375a0 5a074764 44d58199 85007e34"
    ]
});
$cc32301b3f482b8e$var$defineCurve("p256", {
    type: "short",
    prime: null,
    p: "ffffffff 00000001 00000000 00000000 00000000 ffffffff ffffffff ffffffff",
    a: "ffffffff 00000001 00000000 00000000 00000000 ffffffff ffffffff fffffffc",
    b: "5ac635d8 aa3a93e7 b3ebbd55 769886bc 651d06b0 cc53b0f6 3bce3c3e 27d2604b",
    n: "ffffffff 00000000 ffffffff ffffffff bce6faad a7179e84 f3b9cac2 fc632551",
    hash: $leqJp.sha256,
    gRed: false,
    g: [
        "6b17d1f2 e12c4247 f8bce6e5 63a440f2 77037d81 2deb33a0 f4a13945 d898c296",
        "4fe342e2 fe1a7f9b 8ee7eb4a 7c0f9e16 2bce3357 6b315ece cbb64068 37bf51f5"
    ]
});
$cc32301b3f482b8e$var$defineCurve("p384", {
    type: "short",
    prime: null,
    p: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe ffffffff 00000000 00000000 ffffffff",
    a: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe ffffffff 00000000 00000000 fffffffc",
    b: "b3312fa7 e23ee7e4 988e056b e3f82d19 181d9c6e fe814112 0314088f 5013875a c656398d 8a2ed19d 2a85c8ed d3ec2aef",
    n: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff c7634d81 f4372ddf 581a0db2 48b0a77a ecec196a ccc52973",
    hash: $leqJp.sha384,
    gRed: false,
    g: [
        "aa87ca22 be8b0537 8eb1c71e f320ad74 6e1d3b62 8ba79b98 59f741e0 82542a38 5502f25d bf55296c 3a545e38 72760ab7",
        "3617de4a 96262c6f 5d9e98bf 9292dc29 f8f41dbd 289a147c e9da3113 b5f0b8c0 0a60b1ce 1d7e819d 7a431d7c 90ea0e5f"
    ]
});
$cc32301b3f482b8e$var$defineCurve("p521", {
    type: "short",
    prime: null,
    p: "000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff",
    a: "000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffc",
    b: "00000051 953eb961 8e1c9a1f 929a21a0 b68540ee a2da725b 99b315f3 b8b48991 8ef109e1 56193951 ec7e937b 1652c0bd 3bb1bf07 3573df88 3d2c34f1 ef451fd4 6b503f00",
    n: "000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffa 51868783 bf2f966b 7fcc0148 f709a5d0 3bb5c9b8 899c47ae bb6fb71e 91386409",
    hash: $leqJp.sha512,
    gRed: false,
    g: [
        "000000c6 858e06b7 0404e9cd 9e3ecb66 2395b442 9c648139 053fb521 f828af60 6b4d3dba a14b5e77 efe75928 fe1dc127 a2ffa8de 3348b3c1 856a429b f97e7e31 c2e5bd66",
        "00000118 39296a78 9a3bc004 5c8a5fb4 2c7d1bd9 98f54449 579b4468 17afbd17 273e662c 97ee7299 5ef42640 c550b901 3fad0761 353c7086 a272c240 88be9476 9fd16650"
    ]
});
$cc32301b3f482b8e$var$defineCurve("curve25519", {
    type: "mont",
    prime: "p25519",
    p: "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed",
    a: "76d06",
    b: "1",
    n: "1000000000000000 0000000000000000 14def9dea2f79cd6 5812631a5cf5d3ed",
    hash: $leqJp.sha256,
    gRed: false,
    g: [
        "9"
    ]
});
$cc32301b3f482b8e$var$defineCurve("ed25519", {
    type: "edwards",
    prime: "p25519",
    p: "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed",
    a: "-1",
    c: "1",
    // -121665 * (121666^(-1)) (mod P)
    d: "52036cee2b6ffe73 8cc740797779e898 00700a4d4141d8ab 75eb4dca135978a3",
    n: "1000000000000000 0000000000000000 14def9dea2f79cd6 5812631a5cf5d3ed",
    hash: $leqJp.sha256,
    gRed: false,
    g: [
        "216936d3cd6e53fec0a4e231fdd6dc5c692cc7609525a7b2c9562d608f25d51a",
        // 4/5
        "6666666666666666666666666666666666666666666666666666666666666658"
    ]
});
var $cc32301b3f482b8e$var$pre;

try {
    $cc32301b3f482b8e$var$pre = (parcelRequire("63oZi"));
} catch (e) {
    $cc32301b3f482b8e$var$pre = undefined;
}
$cc32301b3f482b8e$var$defineCurve("secp256k1", {
    type: "short",
    prime: "k256",
    p: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f",
    a: "0",
    b: "7",
    n: "ffffffff ffffffff ffffffff fffffffe baaedce6 af48a03b bfd25e8c d0364141",
    h: "1",
    hash: $leqJp.sha256,
    // Precomputed endomorphism
    beta: "7ae96a2b657c07106e64479eac3434e99cf0497512f58995c1396c28719501ee",
    lambda: "5363ad4cc05c30e0a5261c028812645a122e22ea20816678df02967c1b23bd72",
    basis: [
        {
            a: "3086d221a7d46bcde86c90e49284eb15",
            b: "-e4437ed6010e88286f547fa90abfe4c3"
        },
        {
            a: "114ca50f7a8e2f3f657c1108d9d44cfd8",
            b: "3086d221a7d46bcde86c90e49284eb15"
        }
    ],
    gRed: false,
    g: [
        "79be667ef9dcbbac55a06295ce870b07029bfcdb2dce28d959f2815b16f81798",
        "483ada7726a3c4655da4fbfc0e1108a8fd17b448a68554199c47d08ffb10d4b8",
        $cc32301b3f482b8e$var$pre
    ]
});

});
parcelRequire.register("leqJp", function(module, exports) {
var $f74fa412f2053ea0$var$hash = module.exports;

$f74fa412f2053ea0$var$hash.utils = (parcelRequire("3vltz"));

$f74fa412f2053ea0$var$hash.common = (parcelRequire("hoO3s"));

$f74fa412f2053ea0$var$hash.sha = (parcelRequire("esJCG"));

$f74fa412f2053ea0$var$hash.ripemd = (parcelRequire("ak1PH"));

$f74fa412f2053ea0$var$hash.hmac = (parcelRequire("X5z30"));
// Proxy hash functions to the main object
$f74fa412f2053ea0$var$hash.sha1 = $f74fa412f2053ea0$var$hash.sha.sha1;
$f74fa412f2053ea0$var$hash.sha256 = $f74fa412f2053ea0$var$hash.sha.sha256;
$f74fa412f2053ea0$var$hash.sha224 = $f74fa412f2053ea0$var$hash.sha.sha224;
$f74fa412f2053ea0$var$hash.sha384 = $f74fa412f2053ea0$var$hash.sha.sha384;
$f74fa412f2053ea0$var$hash.sha512 = $f74fa412f2053ea0$var$hash.sha.sha512;
$f74fa412f2053ea0$var$hash.ripemd160 = $f74fa412f2053ea0$var$hash.ripemd.ripemd160;

});

parcelRequire.register("63oZi", function(module, exports) {
module.exports = {
    doubles: {
        step: 4,
        points: [
            [
                "e60fce93b59e9ec53011aabc21c23e97b2a31369b87a5ae9c44ee89e2a6dec0a",
                "f7e3507399e595929db99f34f57937101296891e44d23f0be1f32cce69616821"
            ],
            [
                "8282263212c609d9ea2a6e3e172de238d8c39cabd5ac1ca10646e23fd5f51508",
                "11f8a8098557dfe45e8256e830b60ace62d613ac2f7b17bed31b6eaff6e26caf"
            ],
            [
                "175e159f728b865a72f99cc6c6fc846de0b93833fd2222ed73fce5b551e5b739",
                "d3506e0d9e3c79eba4ef97a51ff71f5eacb5955add24345c6efa6ffee9fed695"
            ],
            [
                "363d90d447b00c9c99ceac05b6262ee053441c7e55552ffe526bad8f83ff4640",
                "4e273adfc732221953b445397f3363145b9a89008199ecb62003c7f3bee9de9"
            ],
            [
                "8b4b5f165df3c2be8c6244b5b745638843e4a781a15bcd1b69f79a55dffdf80c",
                "4aad0a6f68d308b4b3fbd7813ab0da04f9e336546162ee56b3eff0c65fd4fd36"
            ],
            [
                "723cbaa6e5db996d6bf771c00bd548c7b700dbffa6c0e77bcb6115925232fcda",
                "96e867b5595cc498a921137488824d6e2660a0653779494801dc069d9eb39f5f"
            ],
            [
                "eebfa4d493bebf98ba5feec812c2d3b50947961237a919839a533eca0e7dd7fa",
                "5d9a8ca3970ef0f269ee7edaf178089d9ae4cdc3a711f712ddfd4fdae1de8999"
            ],
            [
                "100f44da696e71672791d0a09b7bde459f1215a29b3c03bfefd7835b39a48db0",
                "cdd9e13192a00b772ec8f3300c090666b7ff4a18ff5195ac0fbd5cd62bc65a09"
            ],
            [
                "e1031be262c7ed1b1dc9227a4a04c017a77f8d4464f3b3852c8acde6e534fd2d",
                "9d7061928940405e6bb6a4176597535af292dd419e1ced79a44f18f29456a00d"
            ],
            [
                "feea6cae46d55b530ac2839f143bd7ec5cf8b266a41d6af52d5e688d9094696d",
                "e57c6b6c97dce1bab06e4e12bf3ecd5c981c8957cc41442d3155debf18090088"
            ],
            [
                "da67a91d91049cdcb367be4be6ffca3cfeed657d808583de33fa978bc1ec6cb1",
                "9bacaa35481642bc41f463f7ec9780e5dec7adc508f740a17e9ea8e27a68be1d"
            ],
            [
                "53904faa0b334cdda6e000935ef22151ec08d0f7bb11069f57545ccc1a37b7c0",
                "5bc087d0bc80106d88c9eccac20d3c1c13999981e14434699dcb096b022771c8"
            ],
            [
                "8e7bcd0bd35983a7719cca7764ca906779b53a043a9b8bcaeff959f43ad86047",
                "10b7770b2a3da4b3940310420ca9514579e88e2e47fd68b3ea10047e8460372a"
            ],
            [
                "385eed34c1cdff21e6d0818689b81bde71a7f4f18397e6690a841e1599c43862",
                "283bebc3e8ea23f56701de19e9ebf4576b304eec2086dc8cc0458fe5542e5453"
            ],
            [
                "6f9d9b803ecf191637c73a4413dfa180fddf84a5947fbc9c606ed86c3fac3a7",
                "7c80c68e603059ba69b8e2a30e45c4d47ea4dd2f5c281002d86890603a842160"
            ],
            [
                "3322d401243c4e2582a2147c104d6ecbf774d163db0f5e5313b7e0e742d0e6bd",
                "56e70797e9664ef5bfb019bc4ddaf9b72805f63ea2873af624f3a2e96c28b2a0"
            ],
            [
                "85672c7d2de0b7da2bd1770d89665868741b3f9af7643397721d74d28134ab83",
                "7c481b9b5b43b2eb6374049bfa62c2e5e77f17fcc5298f44c8e3094f790313a6"
            ],
            [
                "948bf809b1988a46b06c9f1919413b10f9226c60f668832ffd959af60c82a0a",
                "53a562856dcb6646dc6b74c5d1c3418c6d4dff08c97cd2bed4cb7f88d8c8e589"
            ],
            [
                "6260ce7f461801c34f067ce0f02873a8f1b0e44dfc69752accecd819f38fd8e8",
                "bc2da82b6fa5b571a7f09049776a1ef7ecd292238051c198c1a84e95b2b4ae17"
            ],
            [
                "e5037de0afc1d8d43d8348414bbf4103043ec8f575bfdc432953cc8d2037fa2d",
                "4571534baa94d3b5f9f98d09fb990bddbd5f5b03ec481f10e0e5dc841d755bda"
            ],
            [
                "e06372b0f4a207adf5ea905e8f1771b4e7e8dbd1c6a6c5b725866a0ae4fce725",
                "7a908974bce18cfe12a27bb2ad5a488cd7484a7787104870b27034f94eee31dd"
            ],
            [
                "213c7a715cd5d45358d0bbf9dc0ce02204b10bdde2a3f58540ad6908d0559754",
                "4b6dad0b5ae462507013ad06245ba190bb4850f5f36a7eeddff2c27534b458f2"
            ],
            [
                "4e7c272a7af4b34e8dbb9352a5419a87e2838c70adc62cddf0cc3a3b08fbd53c",
                "17749c766c9d0b18e16fd09f6def681b530b9614bff7dd33e0b3941817dcaae6"
            ],
            [
                "fea74e3dbe778b1b10f238ad61686aa5c76e3db2be43057632427e2840fb27b6",
                "6e0568db9b0b13297cf674deccb6af93126b596b973f7b77701d3db7f23cb96f"
            ],
            [
                "76e64113f677cf0e10a2570d599968d31544e179b760432952c02a4417bdde39",
                "c90ddf8dee4e95cf577066d70681f0d35e2a33d2b56d2032b4b1752d1901ac01"
            ],
            [
                "c738c56b03b2abe1e8281baa743f8f9a8f7cc643df26cbee3ab150242bcbb891",
                "893fb578951ad2537f718f2eacbfbbbb82314eef7880cfe917e735d9699a84c3"
            ],
            [
                "d895626548b65b81e264c7637c972877d1d72e5f3a925014372e9f6588f6c14b",
                "febfaa38f2bc7eae728ec60818c340eb03428d632bb067e179363ed75d7d991f"
            ],
            [
                "b8da94032a957518eb0f6433571e8761ceffc73693e84edd49150a564f676e03",
                "2804dfa44805a1e4d7c99cc9762808b092cc584d95ff3b511488e4e74efdf6e7"
            ],
            [
                "e80fea14441fb33a7d8adab9475d7fab2019effb5156a792f1a11778e3c0df5d",
                "eed1de7f638e00771e89768ca3ca94472d155e80af322ea9fcb4291b6ac9ec78"
            ],
            [
                "a301697bdfcd704313ba48e51d567543f2a182031efd6915ddc07bbcc4e16070",
                "7370f91cfb67e4f5081809fa25d40f9b1735dbf7c0a11a130c0d1a041e177ea1"
            ],
            [
                "90ad85b389d6b936463f9d0512678de208cc330b11307fffab7ac63e3fb04ed4",
                "e507a3620a38261affdcbd9427222b839aefabe1582894d991d4d48cb6ef150"
            ],
            [
                "8f68b9d2f63b5f339239c1ad981f162ee88c5678723ea3351b7b444c9ec4c0da",
                "662a9f2dba063986de1d90c2b6be215dbbea2cfe95510bfdf23cbf79501fff82"
            ],
            [
                "e4f3fb0176af85d65ff99ff9198c36091f48e86503681e3e6686fd5053231e11",
                "1e63633ad0ef4f1c1661a6d0ea02b7286cc7e74ec951d1c9822c38576feb73bc"
            ],
            [
                "8c00fa9b18ebf331eb961537a45a4266c7034f2f0d4e1d0716fb6eae20eae29e",
                "efa47267fea521a1a9dc343a3736c974c2fadafa81e36c54e7d2a4c66702414b"
            ],
            [
                "e7a26ce69dd4829f3e10cec0a9e98ed3143d084f308b92c0997fddfc60cb3e41",
                "2a758e300fa7984b471b006a1aafbb18d0a6b2c0420e83e20e8a9421cf2cfd51"
            ],
            [
                "b6459e0ee3662ec8d23540c223bcbdc571cbcb967d79424f3cf29eb3de6b80ef",
                "67c876d06f3e06de1dadf16e5661db3c4b3ae6d48e35b2ff30bf0b61a71ba45"
            ],
            [
                "d68a80c8280bb840793234aa118f06231d6f1fc67e73c5a5deda0f5b496943e8",
                "db8ba9fff4b586d00c4b1f9177b0e28b5b0e7b8f7845295a294c84266b133120"
            ],
            [
                "324aed7df65c804252dc0270907a30b09612aeb973449cea4095980fc28d3d5d",
                "648a365774b61f2ff130c0c35aec1f4f19213b0c7e332843967224af96ab7c84"
            ],
            [
                "4df9c14919cde61f6d51dfdbe5fee5dceec4143ba8d1ca888e8bd373fd054c96",
                "35ec51092d8728050974c23a1d85d4b5d506cdc288490192ebac06cad10d5d"
            ],
            [
                "9c3919a84a474870faed8a9c1cc66021523489054d7f0308cbfc99c8ac1f98cd",
                "ddb84f0f4a4ddd57584f044bf260e641905326f76c64c8e6be7e5e03d4fc599d"
            ],
            [
                "6057170b1dd12fdf8de05f281d8e06bb91e1493a8b91d4cc5a21382120a959e5",
                "9a1af0b26a6a4807add9a2daf71df262465152bc3ee24c65e899be932385a2a8"
            ],
            [
                "a576df8e23a08411421439a4518da31880cef0fba7d4df12b1a6973eecb94266",
                "40a6bf20e76640b2c92b97afe58cd82c432e10a7f514d9f3ee8be11ae1b28ec8"
            ],
            [
                "7778a78c28dec3e30a05fe9629de8c38bb30d1f5cf9a3a208f763889be58ad71",
                "34626d9ab5a5b22ff7098e12f2ff580087b38411ff24ac563b513fc1fd9f43ac"
            ],
            [
                "928955ee637a84463729fd30e7afd2ed5f96274e5ad7e5cb09eda9c06d903ac",
                "c25621003d3f42a827b78a13093a95eeac3d26efa8a8d83fc5180e935bcd091f"
            ],
            [
                "85d0fef3ec6db109399064f3a0e3b2855645b4a907ad354527aae75163d82751",
                "1f03648413a38c0be29d496e582cf5663e8751e96877331582c237a24eb1f962"
            ],
            [
                "ff2b0dce97eece97c1c9b6041798b85dfdfb6d8882da20308f5404824526087e",
                "493d13fef524ba188af4c4dc54d07936c7b7ed6fb90e2ceb2c951e01f0c29907"
            ],
            [
                "827fbbe4b1e880ea9ed2b2e6301b212b57f1ee148cd6dd28780e5e2cf856e241",
                "c60f9c923c727b0b71bef2c67d1d12687ff7a63186903166d605b68baec293ec"
            ],
            [
                "eaa649f21f51bdbae7be4ae34ce6e5217a58fdce7f47f9aa7f3b58fa2120e2b3",
                "be3279ed5bbbb03ac69a80f89879aa5a01a6b965f13f7e59d47a5305ba5ad93d"
            ],
            [
                "e4a42d43c5cf169d9391df6decf42ee541b6d8f0c9a137401e23632dda34d24f",
                "4d9f92e716d1c73526fc99ccfb8ad34ce886eedfa8d8e4f13a7f7131deba9414"
            ],
            [
                "1ec80fef360cbdd954160fadab352b6b92b53576a88fea4947173b9d4300bf19",
                "aeefe93756b5340d2f3a4958a7abbf5e0146e77f6295a07b671cdc1cc107cefd"
            ],
            [
                "146a778c04670c2f91b00af4680dfa8bce3490717d58ba889ddb5928366642be",
                "b318e0ec3354028add669827f9d4b2870aaa971d2f7e5ed1d0b297483d83efd0"
            ],
            [
                "fa50c0f61d22e5f07e3acebb1aa07b128d0012209a28b9776d76a8793180eef9",
                "6b84c6922397eba9b72cd2872281a68a5e683293a57a213b38cd8d7d3f4f2811"
            ],
            [
                "da1d61d0ca721a11b1a5bf6b7d88e8421a288ab5d5bba5220e53d32b5f067ec2",
                "8157f55a7c99306c79c0766161c91e2966a73899d279b48a655fba0f1ad836f1"
            ],
            [
                "a8e282ff0c9706907215ff98e8fd416615311de0446f1e062a73b0610d064e13",
                "7f97355b8db81c09abfb7f3c5b2515888b679a3e50dd6bd6cef7c73111f4cc0c"
            ],
            [
                "174a53b9c9a285872d39e56e6913cab15d59b1fa512508c022f382de8319497c",
                "ccc9dc37abfc9c1657b4155f2c47f9e6646b3a1d8cb9854383da13ac079afa73"
            ],
            [
                "959396981943785c3d3e57edf5018cdbe039e730e4918b3d884fdff09475b7ba",
                "2e7e552888c331dd8ba0386a4b9cd6849c653f64c8709385e9b8abf87524f2fd"
            ],
            [
                "d2a63a50ae401e56d645a1153b109a8fcca0a43d561fba2dbb51340c9d82b151",
                "e82d86fb6443fcb7565aee58b2948220a70f750af484ca52d4142174dcf89405"
            ],
            [
                "64587e2335471eb890ee7896d7cfdc866bacbdbd3839317b3436f9b45617e073",
                "d99fcdd5bf6902e2ae96dd6447c299a185b90a39133aeab358299e5e9faf6589"
            ],
            [
                "8481bde0e4e4d885b3a546d3e549de042f0aa6cea250e7fd358d6c86dd45e458",
                "38ee7b8cba5404dd84a25bf39cecb2ca900a79c42b262e556d64b1b59779057e"
            ],
            [
                "13464a57a78102aa62b6979ae817f4637ffcfed3c4b1ce30bcd6303f6caf666b",
                "69be159004614580ef7e433453ccb0ca48f300a81d0942e13f495a907f6ecc27"
            ],
            [
                "bc4a9df5b713fe2e9aef430bcc1dc97a0cd9ccede2f28588cada3a0d2d83f366",
                "d3a81ca6e785c06383937adf4b798caa6e8a9fbfa547b16d758d666581f33c1"
            ],
            [
                "8c28a97bf8298bc0d23d8c749452a32e694b65e30a9472a3954ab30fe5324caa",
                "40a30463a3305193378fedf31f7cc0eb7ae784f0451cb9459e71dc73cbef9482"
            ],
            [
                "8ea9666139527a8c1dd94ce4f071fd23c8b350c5a4bb33748c4ba111faccae0",
                "620efabbc8ee2782e24e7c0cfb95c5d735b783be9cf0f8e955af34a30e62b945"
            ],
            [
                "dd3625faef5ba06074669716bbd3788d89bdde815959968092f76cc4eb9a9787",
                "7a188fa3520e30d461da2501045731ca941461982883395937f68d00c644a573"
            ],
            [
                "f710d79d9eb962297e4f6232b40e8f7feb2bc63814614d692c12de752408221e",
                "ea98e67232d3b3295d3b535532115ccac8612c721851617526ae47a9c77bfc82"
            ]
        ]
    },
    naf: {
        wnd: 7,
        points: [
            [
                "f9308a019258c31049344f85f89d5229b531c845836f99b08601f113bce036f9",
                "388f7b0f632de8140fe337e62a37f3566500a99934c2231b6cb9fd7584b8e672"
            ],
            [
                "2f8bde4d1a07209355b4a7250a5c5128e88b84bddc619ab7cba8d569b240efe4",
                "d8ac222636e5e3d6d4dba9dda6c9c426f788271bab0d6840dca87d3aa6ac62d6"
            ],
            [
                "5cbdf0646e5db4eaa398f365f2ea7a0e3d419b7e0330e39ce92bddedcac4f9bc",
                "6aebca40ba255960a3178d6d861a54dba813d0b813fde7b5a5082628087264da"
            ],
            [
                "acd484e2f0c7f65309ad178a9f559abde09796974c57e714c35f110dfc27ccbe",
                "cc338921b0a7d9fd64380971763b61e9add888a4375f8e0f05cc262ac64f9c37"
            ],
            [
                "774ae7f858a9411e5ef4246b70c65aac5649980be5c17891bbec17895da008cb",
                "d984a032eb6b5e190243dd56d7b7b365372db1e2dff9d6a8301d74c9c953c61b"
            ],
            [
                "f28773c2d975288bc7d1d205c3748651b075fbc6610e58cddeeddf8f19405aa8",
                "ab0902e8d880a89758212eb65cdaf473a1a06da521fa91f29b5cb52db03ed81"
            ],
            [
                "d7924d4f7d43ea965a465ae3095ff41131e5946f3c85f79e44adbcf8e27e080e",
                "581e2872a86c72a683842ec228cc6defea40af2bd896d3a5c504dc9ff6a26b58"
            ],
            [
                "defdea4cdb677750a420fee807eacf21eb9898ae79b9768766e4faa04a2d4a34",
                "4211ab0694635168e997b0ead2a93daeced1f4a04a95c0f6cfb199f69e56eb77"
            ],
            [
                "2b4ea0a797a443d293ef5cff444f4979f06acfebd7e86d277475656138385b6c",
                "85e89bc037945d93b343083b5a1c86131a01f60c50269763b570c854e5c09b7a"
            ],
            [
                "352bbf4a4cdd12564f93fa332ce333301d9ad40271f8107181340aef25be59d5",
                "321eb4075348f534d59c18259dda3e1f4a1b3b2e71b1039c67bd3d8bcf81998c"
            ],
            [
                "2fa2104d6b38d11b0230010559879124e42ab8dfeff5ff29dc9cdadd4ecacc3f",
                "2de1068295dd865b64569335bd5dd80181d70ecfc882648423ba76b532b7d67"
            ],
            [
                "9248279b09b4d68dab21a9b066edda83263c3d84e09572e269ca0cd7f5453714",
                "73016f7bf234aade5d1aa71bdea2b1ff3fc0de2a887912ffe54a32ce97cb3402"
            ],
            [
                "daed4f2be3a8bf278e70132fb0beb7522f570e144bf615c07e996d443dee8729",
                "a69dce4a7d6c98e8d4a1aca87ef8d7003f83c230f3afa726ab40e52290be1c55"
            ],
            [
                "c44d12c7065d812e8acf28d7cbb19f9011ecd9e9fdf281b0e6a3b5e87d22e7db",
                "2119a460ce326cdc76c45926c982fdac0e106e861edf61c5a039063f0e0e6482"
            ],
            [
                "6a245bf6dc698504c89a20cfded60853152b695336c28063b61c65cbd269e6b4",
                "e022cf42c2bd4a708b3f5126f16a24ad8b33ba48d0423b6efd5e6348100d8a82"
            ],
            [
                "1697ffa6fd9de627c077e3d2fe541084ce13300b0bec1146f95ae57f0d0bd6a5",
                "b9c398f186806f5d27561506e4557433a2cf15009e498ae7adee9d63d01b2396"
            ],
            [
                "605bdb019981718b986d0f07e834cb0d9deb8360ffb7f61df982345ef27a7479",
                "2972d2de4f8d20681a78d93ec96fe23c26bfae84fb14db43b01e1e9056b8c49"
            ],
            [
                "62d14dab4150bf497402fdc45a215e10dcb01c354959b10cfe31c7e9d87ff33d",
                "80fc06bd8cc5b01098088a1950eed0db01aa132967ab472235f5642483b25eaf"
            ],
            [
                "80c60ad0040f27dade5b4b06c408e56b2c50e9f56b9b8b425e555c2f86308b6f",
                "1c38303f1cc5c30f26e66bad7fe72f70a65eed4cbe7024eb1aa01f56430bd57a"
            ],
            [
                "7a9375ad6167ad54aa74c6348cc54d344cc5dc9487d847049d5eabb0fa03c8fb",
                "d0e3fa9eca8726909559e0d79269046bdc59ea10c70ce2b02d499ec224dc7f7"
            ],
            [
                "d528ecd9b696b54c907a9ed045447a79bb408ec39b68df504bb51f459bc3ffc9",
                "eecf41253136e5f99966f21881fd656ebc4345405c520dbc063465b521409933"
            ],
            [
                "49370a4b5f43412ea25f514e8ecdad05266115e4a7ecb1387231808f8b45963",
                "758f3f41afd6ed428b3081b0512fd62a54c3f3afbb5b6764b653052a12949c9a"
            ],
            [
                "77f230936ee88cbbd73df930d64702ef881d811e0e1498e2f1c13eb1fc345d74",
                "958ef42a7886b6400a08266e9ba1b37896c95330d97077cbbe8eb3c7671c60d6"
            ],
            [
                "f2dac991cc4ce4b9ea44887e5c7c0bce58c80074ab9d4dbaeb28531b7739f530",
                "e0dedc9b3b2f8dad4da1f32dec2531df9eb5fbeb0598e4fd1a117dba703a3c37"
            ],
            [
                "463b3d9f662621fb1b4be8fbbe2520125a216cdfc9dae3debcba4850c690d45b",
                "5ed430d78c296c3543114306dd8622d7c622e27c970a1de31cb377b01af7307e"
            ],
            [
                "f16f804244e46e2a09232d4aff3b59976b98fac14328a2d1a32496b49998f247",
                "cedabd9b82203f7e13d206fcdf4e33d92a6c53c26e5cce26d6579962c4e31df6"
            ],
            [
                "caf754272dc84563b0352b7a14311af55d245315ace27c65369e15f7151d41d1",
                "cb474660ef35f5f2a41b643fa5e460575f4fa9b7962232a5c32f908318a04476"
            ],
            [
                "2600ca4b282cb986f85d0f1709979d8b44a09c07cb86d7c124497bc86f082120",
                "4119b88753c15bd6a693b03fcddbb45d5ac6be74ab5f0ef44b0be9475a7e4b40"
            ],
            [
                "7635ca72d7e8432c338ec53cd12220bc01c48685e24f7dc8c602a7746998e435",
                "91b649609489d613d1d5e590f78e6d74ecfc061d57048bad9e76f302c5b9c61"
            ],
            [
                "754e3239f325570cdbbf4a87deee8a66b7f2b33479d468fbc1a50743bf56cc18",
                "673fb86e5bda30fb3cd0ed304ea49a023ee33d0197a695d0c5d98093c536683"
            ],
            [
                "e3e6bd1071a1e96aff57859c82d570f0330800661d1c952f9fe2694691d9b9e8",
                "59c9e0bba394e76f40c0aa58379a3cb6a5a2283993e90c4167002af4920e37f5"
            ],
            [
                "186b483d056a033826ae73d88f732985c4ccb1f32ba35f4b4cc47fdcf04aa6eb",
                "3b952d32c67cf77e2e17446e204180ab21fb8090895138b4a4a797f86e80888b"
            ],
            [
                "df9d70a6b9876ce544c98561f4be4f725442e6d2b737d9c91a8321724ce0963f",
                "55eb2dafd84d6ccd5f862b785dc39d4ab157222720ef9da217b8c45cf2ba2417"
            ],
            [
                "5edd5cc23c51e87a497ca815d5dce0f8ab52554f849ed8995de64c5f34ce7143",
                "efae9c8dbc14130661e8cec030c89ad0c13c66c0d17a2905cdc706ab7399a868"
            ],
            [
                "290798c2b6476830da12fe02287e9e777aa3fba1c355b17a722d362f84614fba",
                "e38da76dcd440621988d00bcf79af25d5b29c094db2a23146d003afd41943e7a"
            ],
            [
                "af3c423a95d9f5b3054754efa150ac39cd29552fe360257362dfdecef4053b45",
                "f98a3fd831eb2b749a93b0e6f35cfb40c8cd5aa667a15581bc2feded498fd9c6"
            ],
            [
                "766dbb24d134e745cccaa28c99bf274906bb66b26dcf98df8d2fed50d884249a",
                "744b1152eacbe5e38dcc887980da38b897584a65fa06cedd2c924f97cbac5996"
            ],
            [
                "59dbf46f8c94759ba21277c33784f41645f7b44f6c596a58ce92e666191abe3e",
                "c534ad44175fbc300f4ea6ce648309a042ce739a7919798cd85e216c4a307f6e"
            ],
            [
                "f13ada95103c4537305e691e74e9a4a8dd647e711a95e73cb62dc6018cfd87b8",
                "e13817b44ee14de663bf4bc808341f326949e21a6a75c2570778419bdaf5733d"
            ],
            [
                "7754b4fa0e8aced06d4167a2c59cca4cda1869c06ebadfb6488550015a88522c",
                "30e93e864e669d82224b967c3020b8fa8d1e4e350b6cbcc537a48b57841163a2"
            ],
            [
                "948dcadf5990e048aa3874d46abef9d701858f95de8041d2a6828c99e2262519",
                "e491a42537f6e597d5d28a3224b1bc25df9154efbd2ef1d2cbba2cae5347d57e"
            ],
            [
                "7962414450c76c1689c7b48f8202ec37fb224cf5ac0bfa1570328a8a3d7c77ab",
                "100b610ec4ffb4760d5c1fc133ef6f6b12507a051f04ac5760afa5b29db83437"
            ],
            [
                "3514087834964b54b15b160644d915485a16977225b8847bb0dd085137ec47ca",
                "ef0afbb2056205448e1652c48e8127fc6039e77c15c2378b7e7d15a0de293311"
            ],
            [
                "d3cc30ad6b483e4bc79ce2c9dd8bc54993e947eb8df787b442943d3f7b527eaf",
                "8b378a22d827278d89c5e9be8f9508ae3c2ad46290358630afb34db04eede0a4"
            ],
            [
                "1624d84780732860ce1c78fcbfefe08b2b29823db913f6493975ba0ff4847610",
                "68651cf9b6da903e0914448c6cd9d4ca896878f5282be4c8cc06e2a404078575"
            ],
            [
                "733ce80da955a8a26902c95633e62a985192474b5af207da6df7b4fd5fc61cd4",
                "f5435a2bd2badf7d485a4d8b8db9fcce3e1ef8e0201e4578c54673bc1dc5ea1d"
            ],
            [
                "15d9441254945064cf1a1c33bbd3b49f8966c5092171e699ef258dfab81c045c",
                "d56eb30b69463e7234f5137b73b84177434800bacebfc685fc37bbe9efe4070d"
            ],
            [
                "a1d0fcf2ec9de675b612136e5ce70d271c21417c9d2b8aaaac138599d0717940",
                "edd77f50bcb5a3cab2e90737309667f2641462a54070f3d519212d39c197a629"
            ],
            [
                "e22fbe15c0af8ccc5780c0735f84dbe9a790badee8245c06c7ca37331cb36980",
                "a855babad5cd60c88b430a69f53a1a7a38289154964799be43d06d77d31da06"
            ],
            [
                "311091dd9860e8e20ee13473c1155f5f69635e394704eaa74009452246cfa9b3",
                "66db656f87d1f04fffd1f04788c06830871ec5a64feee685bd80f0b1286d8374"
            ],
            [
                "34c1fd04d301be89b31c0442d3e6ac24883928b45a9340781867d4232ec2dbdf",
                "9414685e97b1b5954bd46f730174136d57f1ceeb487443dc5321857ba73abee"
            ],
            [
                "f219ea5d6b54701c1c14de5b557eb42a8d13f3abbcd08affcc2a5e6b049b8d63",
                "4cb95957e83d40b0f73af4544cccf6b1f4b08d3c07b27fb8d8c2962a400766d1"
            ],
            [
                "d7b8740f74a8fbaab1f683db8f45de26543a5490bca627087236912469a0b448",
                "fa77968128d9c92ee1010f337ad4717eff15db5ed3c049b3411e0315eaa4593b"
            ],
            [
                "32d31c222f8f6f0ef86f7c98d3a3335ead5bcd32abdd94289fe4d3091aa824bf",
                "5f3032f5892156e39ccd3d7915b9e1da2e6dac9e6f26e961118d14b8462e1661"
            ],
            [
                "7461f371914ab32671045a155d9831ea8793d77cd59592c4340f86cbc18347b5",
                "8ec0ba238b96bec0cbdddcae0aa442542eee1ff50c986ea6b39847b3cc092ff6"
            ],
            [
                "ee079adb1df1860074356a25aa38206a6d716b2c3e67453d287698bad7b2b2d6",
                "8dc2412aafe3be5c4c5f37e0ecc5f9f6a446989af04c4e25ebaac479ec1c8c1e"
            ],
            [
                "16ec93e447ec83f0467b18302ee620f7e65de331874c9dc72bfd8616ba9da6b5",
                "5e4631150e62fb40d0e8c2a7ca5804a39d58186a50e497139626778e25b0674d"
            ],
            [
                "eaa5f980c245f6f038978290afa70b6bd8855897f98b6aa485b96065d537bd99",
                "f65f5d3e292c2e0819a528391c994624d784869d7e6ea67fb18041024edc07dc"
            ],
            [
                "78c9407544ac132692ee1910a02439958ae04877151342ea96c4b6b35a49f51",
                "f3e0319169eb9b85d5404795539a5e68fa1fbd583c064d2462b675f194a3ddb4"
            ],
            [
                "494f4be219a1a77016dcd838431aea0001cdc8ae7a6fc688726578d9702857a5",
                "42242a969283a5f339ba7f075e36ba2af925ce30d767ed6e55f4b031880d562c"
            ],
            [
                "a598a8030da6d86c6bc7f2f5144ea549d28211ea58faa70ebf4c1e665c1fe9b5",
                "204b5d6f84822c307e4b4a7140737aec23fc63b65b35f86a10026dbd2d864e6b"
            ],
            [
                "c41916365abb2b5d09192f5f2dbeafec208f020f12570a184dbadc3e58595997",
                "4f14351d0087efa49d245b328984989d5caf9450f34bfc0ed16e96b58fa9913"
            ],
            [
                "841d6063a586fa475a724604da03bc5b92a2e0d2e0a36acfe4c73a5514742881",
                "73867f59c0659e81904f9a1c7543698e62562d6744c169ce7a36de01a8d6154"
            ],
            [
                "5e95bb399a6971d376026947f89bde2f282b33810928be4ded112ac4d70e20d5",
                "39f23f366809085beebfc71181313775a99c9aed7d8ba38b161384c746012865"
            ],
            [
                "36e4641a53948fd476c39f8a99fd974e5ec07564b5315d8bf99471bca0ef2f66",
                "d2424b1b1abe4eb8164227b085c9aa9456ea13493fd563e06fd51cf5694c78fc"
            ],
            [
                "336581ea7bfbbb290c191a2f507a41cf5643842170e914faeab27c2c579f726",
                "ead12168595fe1be99252129b6e56b3391f7ab1410cd1e0ef3dcdcabd2fda224"
            ],
            [
                "8ab89816dadfd6b6a1f2634fcf00ec8403781025ed6890c4849742706bd43ede",
                "6fdcef09f2f6d0a044e654aef624136f503d459c3e89845858a47a9129cdd24e"
            ],
            [
                "1e33f1a746c9c5778133344d9299fcaa20b0938e8acff2544bb40284b8c5fb94",
                "60660257dd11b3aa9c8ed618d24edff2306d320f1d03010e33a7d2057f3b3b6"
            ],
            [
                "85b7c1dcb3cec1b7ee7f30ded79dd20a0ed1f4cc18cbcfcfa410361fd8f08f31",
                "3d98a9cdd026dd43f39048f25a8847f4fcafad1895d7a633c6fed3c35e999511"
            ],
            [
                "29df9fbd8d9e46509275f4b125d6d45d7fbe9a3b878a7af872a2800661ac5f51",
                "b4c4fe99c775a606e2d8862179139ffda61dc861c019e55cd2876eb2a27d84b"
            ],
            [
                "a0b1cae06b0a847a3fea6e671aaf8adfdfe58ca2f768105c8082b2e449fce252",
                "ae434102edde0958ec4b19d917a6a28e6b72da1834aff0e650f049503a296cf2"
            ],
            [
                "4e8ceafb9b3e9a136dc7ff67e840295b499dfb3b2133e4ba113f2e4c0e121e5",
                "cf2174118c8b6d7a4b48f6d534ce5c79422c086a63460502b827ce62a326683c"
            ],
            [
                "d24a44e047e19b6f5afb81c7ca2f69080a5076689a010919f42725c2b789a33b",
                "6fb8d5591b466f8fc63db50f1c0f1c69013f996887b8244d2cdec417afea8fa3"
            ],
            [
                "ea01606a7a6c9cdd249fdfcfacb99584001edd28abbab77b5104e98e8e3b35d4",
                "322af4908c7312b0cfbfe369f7a7b3cdb7d4494bc2823700cfd652188a3ea98d"
            ],
            [
                "af8addbf2b661c8a6c6328655eb96651252007d8c5ea31be4ad196de8ce2131f",
                "6749e67c029b85f52a034eafd096836b2520818680e26ac8f3dfbcdb71749700"
            ],
            [
                "e3ae1974566ca06cc516d47e0fb165a674a3dabcfca15e722f0e3450f45889",
                "2aeabe7e4531510116217f07bf4d07300de97e4874f81f533420a72eeb0bd6a4"
            ],
            [
                "591ee355313d99721cf6993ffed1e3e301993ff3ed258802075ea8ced397e246",
                "b0ea558a113c30bea60fc4775460c7901ff0b053d25ca2bdeee98f1a4be5d196"
            ],
            [
                "11396d55fda54c49f19aa97318d8da61fa8584e47b084945077cf03255b52984",
                "998c74a8cd45ac01289d5833a7beb4744ff536b01b257be4c5767bea93ea57a4"
            ],
            [
                "3c5d2a1ba39c5a1790000738c9e0c40b8dcdfd5468754b6405540157e017aa7a",
                "b2284279995a34e2f9d4de7396fc18b80f9b8b9fdd270f6661f79ca4c81bd257"
            ],
            [
                "cc8704b8a60a0defa3a99a7299f2e9c3fbc395afb04ac078425ef8a1793cc030",
                "bdd46039feed17881d1e0862db347f8cf395b74fc4bcdc4e940b74e3ac1f1b13"
            ],
            [
                "c533e4f7ea8555aacd9777ac5cad29b97dd4defccc53ee7ea204119b2889b197",
                "6f0a256bc5efdf429a2fb6242f1a43a2d9b925bb4a4b3a26bb8e0f45eb596096"
            ],
            [
                "c14f8f2ccb27d6f109f6d08d03cc96a69ba8c34eec07bbcf566d48e33da6593",
                "c359d6923bb398f7fd4473e16fe1c28475b740dd098075e6c0e8649113dc3a38"
            ],
            [
                "a6cbc3046bc6a450bac24789fa17115a4c9739ed75f8f21ce441f72e0b90e6ef",
                "21ae7f4680e889bb130619e2c0f95a360ceb573c70603139862afd617fa9b9f"
            ],
            [
                "347d6d9a02c48927ebfb86c1359b1caf130a3c0267d11ce6344b39f99d43cc38",
                "60ea7f61a353524d1c987f6ecec92f086d565ab687870cb12689ff1e31c74448"
            ],
            [
                "da6545d2181db8d983f7dcb375ef5866d47c67b1bf31c8cf855ef7437b72656a",
                "49b96715ab6878a79e78f07ce5680c5d6673051b4935bd897fea824b77dc208a"
            ],
            [
                "c40747cc9d012cb1a13b8148309c6de7ec25d6945d657146b9d5994b8feb1111",
                "5ca560753be2a12fc6de6caf2cb489565db936156b9514e1bb5e83037e0fa2d4"
            ],
            [
                "4e42c8ec82c99798ccf3a610be870e78338c7f713348bd34c8203ef4037f3502",
                "7571d74ee5e0fb92a7a8b33a07783341a5492144cc54bcc40a94473693606437"
            ],
            [
                "3775ab7089bc6af823aba2e1af70b236d251cadb0c86743287522a1b3b0dedea",
                "be52d107bcfa09d8bcb9736a828cfa7fac8db17bf7a76a2c42ad961409018cf7"
            ],
            [
                "cee31cbf7e34ec379d94fb814d3d775ad954595d1314ba8846959e3e82f74e26",
                "8fd64a14c06b589c26b947ae2bcf6bfa0149ef0be14ed4d80f448a01c43b1c6d"
            ],
            [
                "b4f9eaea09b6917619f6ea6a4eb5464efddb58fd45b1ebefcdc1a01d08b47986",
                "39e5c9925b5a54b07433a4f18c61726f8bb131c012ca542eb24a8ac07200682a"
            ],
            [
                "d4263dfc3d2df923a0179a48966d30ce84e2515afc3dccc1b77907792ebcc60e",
                "62dfaf07a0f78feb30e30d6295853ce189e127760ad6cf7fae164e122a208d54"
            ],
            [
                "48457524820fa65a4f8d35eb6930857c0032acc0a4a2de422233eeda897612c4",
                "25a748ab367979d98733c38a1fa1c2e7dc6cc07db2d60a9ae7a76aaa49bd0f77"
            ],
            [
                "dfeeef1881101f2cb11644f3a2afdfc2045e19919152923f367a1767c11cceda",
                "ecfb7056cf1de042f9420bab396793c0c390bde74b4bbdff16a83ae09a9a7517"
            ],
            [
                "6d7ef6b17543f8373c573f44e1f389835d89bcbc6062ced36c82df83b8fae859",
                "cd450ec335438986dfefa10c57fea9bcc521a0959b2d80bbf74b190dca712d10"
            ],
            [
                "e75605d59102a5a2684500d3b991f2e3f3c88b93225547035af25af66e04541f",
                "f5c54754a8f71ee540b9b48728473e314f729ac5308b06938360990e2bfad125"
            ],
            [
                "eb98660f4c4dfaa06a2be453d5020bc99a0c2e60abe388457dd43fefb1ed620c",
                "6cb9a8876d9cb8520609af3add26cd20a0a7cd8a9411131ce85f44100099223e"
            ],
            [
                "13e87b027d8514d35939f2e6892b19922154596941888336dc3563e3b8dba942",
                "fef5a3c68059a6dec5d624114bf1e91aac2b9da568d6abeb2570d55646b8adf1"
            ],
            [
                "ee163026e9fd6fe017c38f06a5be6fc125424b371ce2708e7bf4491691e5764a",
                "1acb250f255dd61c43d94ccc670d0f58f49ae3fa15b96623e5430da0ad6c62b2"
            ],
            [
                "b268f5ef9ad51e4d78de3a750c2dc89b1e626d43505867999932e5db33af3d80",
                "5f310d4b3c99b9ebb19f77d41c1dee018cf0d34fd4191614003e945a1216e423"
            ],
            [
                "ff07f3118a9df035e9fad85eb6c7bfe42b02f01ca99ceea3bf7ffdba93c4750d",
                "438136d603e858a3a5c440c38eccbaddc1d2942114e2eddd4740d098ced1f0d8"
            ],
            [
                "8d8b9855c7c052a34146fd20ffb658bea4b9f69e0d825ebec16e8c3ce2b526a1",
                "cdb559eedc2d79f926baf44fb84ea4d44bcf50fee51d7ceb30e2e7f463036758"
            ],
            [
                "52db0b5384dfbf05bfa9d472d7ae26dfe4b851ceca91b1eba54263180da32b63",
                "c3b997d050ee5d423ebaf66a6db9f57b3180c902875679de924b69d84a7b375"
            ],
            [
                "e62f9490d3d51da6395efd24e80919cc7d0f29c3f3fa48c6fff543becbd43352",
                "6d89ad7ba4876b0b22c2ca280c682862f342c8591f1daf5170e07bfd9ccafa7d"
            ],
            [
                "7f30ea2476b399b4957509c88f77d0191afa2ff5cb7b14fd6d8e7d65aaab1193",
                "ca5ef7d4b231c94c3b15389a5f6311e9daff7bb67b103e9880ef4bff637acaec"
            ],
            [
                "5098ff1e1d9f14fb46a210fada6c903fef0fb7b4a1dd1d9ac60a0361800b7a00",
                "9731141d81fc8f8084d37c6e7542006b3ee1b40d60dfe5362a5b132fd17ddc0"
            ],
            [
                "32b78c7de9ee512a72895be6b9cbefa6e2f3c4ccce445c96b9f2c81e2778ad58",
                "ee1849f513df71e32efc3896ee28260c73bb80547ae2275ba497237794c8753c"
            ],
            [
                "e2cb74fddc8e9fbcd076eef2a7c72b0ce37d50f08269dfc074b581550547a4f7",
                "d3aa2ed71c9dd2247a62df062736eb0baddea9e36122d2be8641abcb005cc4a4"
            ],
            [
                "8438447566d4d7bedadc299496ab357426009a35f235cb141be0d99cd10ae3a8",
                "c4e1020916980a4da5d01ac5e6ad330734ef0d7906631c4f2390426b2edd791f"
            ],
            [
                "4162d488b89402039b584c6fc6c308870587d9c46f660b878ab65c82c711d67e",
                "67163e903236289f776f22c25fb8a3afc1732f2b84b4e95dbda47ae5a0852649"
            ],
            [
                "3fad3fa84caf0f34f0f89bfd2dcf54fc175d767aec3e50684f3ba4a4bf5f683d",
                "cd1bc7cb6cc407bb2f0ca647c718a730cf71872e7d0d2a53fa20efcdfe61826"
            ],
            [
                "674f2600a3007a00568c1a7ce05d0816c1fb84bf1370798f1c69532faeb1a86b",
                "299d21f9413f33b3edf43b257004580b70db57da0b182259e09eecc69e0d38a5"
            ],
            [
                "d32f4da54ade74abb81b815ad1fb3b263d82d6c692714bcff87d29bd5ee9f08f",
                "f9429e738b8e53b968e99016c059707782e14f4535359d582fc416910b3eea87"
            ],
            [
                "30e4e670435385556e593657135845d36fbb6931f72b08cb1ed954f1e3ce3ff6",
                "462f9bce619898638499350113bbc9b10a878d35da70740dc695a559eb88db7b"
            ],
            [
                "be2062003c51cc3004682904330e4dee7f3dcd10b01e580bf1971b04d4cad297",
                "62188bc49d61e5428573d48a74e1c655b1c61090905682a0d5558ed72dccb9bc"
            ],
            [
                "93144423ace3451ed29e0fb9ac2af211cb6e84a601df5993c419859fff5df04a",
                "7c10dfb164c3425f5c71a3f9d7992038f1065224f72bb9d1d902a6d13037b47c"
            ],
            [
                "b015f8044f5fcbdcf21ca26d6c34fb8197829205c7b7d2a7cb66418c157b112c",
                "ab8c1e086d04e813744a655b2df8d5f83b3cdc6faa3088c1d3aea1454e3a1d5f"
            ],
            [
                "d5e9e1da649d97d89e4868117a465a3a4f8a18de57a140d36b3f2af341a21b52",
                "4cb04437f391ed73111a13cc1d4dd0db1693465c2240480d8955e8592f27447a"
            ],
            [
                "d3ae41047dd7ca065dbf8ed77b992439983005cd72e16d6f996a5316d36966bb",
                "bd1aeb21ad22ebb22a10f0303417c6d964f8cdd7df0aca614b10dc14d125ac46"
            ],
            [
                "463e2763d885f958fc66cdd22800f0a487197d0a82e377b49f80af87c897b065",
                "bfefacdb0e5d0fd7df3a311a94de062b26b80c61fbc97508b79992671ef7ca7f"
            ],
            [
                "7985fdfd127c0567c6f53ec1bb63ec3158e597c40bfe747c83cddfc910641917",
                "603c12daf3d9862ef2b25fe1de289aed24ed291e0ec6708703a5bd567f32ed03"
            ],
            [
                "74a1ad6b5f76e39db2dd249410eac7f99e74c59cb83d2d0ed5ff1543da7703e9",
                "cc6157ef18c9c63cd6193d83631bbea0093e0968942e8c33d5737fd790e0db08"
            ],
            [
                "30682a50703375f602d416664ba19b7fc9bab42c72747463a71d0896b22f6da3",
                "553e04f6b018b4fa6c8f39e7f311d3176290d0e0f19ca73f17714d9977a22ff8"
            ],
            [
                "9e2158f0d7c0d5f26c3791efefa79597654e7a2b2464f52b1ee6c1347769ef57",
                "712fcdd1b9053f09003a3481fa7762e9ffd7c8ef35a38509e2fbf2629008373"
            ],
            [
                "176e26989a43c9cfeba4029c202538c28172e566e3c4fce7322857f3be327d66",
                "ed8cc9d04b29eb877d270b4878dc43c19aefd31f4eee09ee7b47834c1fa4b1c3"
            ],
            [
                "75d46efea3771e6e68abb89a13ad747ecf1892393dfc4f1b7004788c50374da8",
                "9852390a99507679fd0b86fd2b39a868d7efc22151346e1a3ca4726586a6bed8"
            ],
            [
                "809a20c67d64900ffb698c4c825f6d5f2310fb0451c869345b7319f645605721",
                "9e994980d9917e22b76b061927fa04143d096ccc54963e6a5ebfa5f3f8e286c1"
            ],
            [
                "1b38903a43f7f114ed4500b4eac7083fdefece1cf29c63528d563446f972c180",
                "4036edc931a60ae889353f77fd53de4a2708b26b6f5da72ad3394119daf408f9"
            ]
        ]
    }
};

});


parcelRequire.register("9lW0h", function(module, exports) {
"use strict";

var $7vYz3 = parcelRequire("7vYz3");

var $5WFpm = parcelRequire("5WFpm");

var $ZdcNb = parcelRequire("ZdcNb");

var $hwVHR = parcelRequire("hwVHR");

var $9JRha = parcelRequire("9JRha");
var $6cf31182d56f3d95$var$assert = $ZdcNb.assert;

var $lE5ol = parcelRequire("lE5ol");

var $kQeFn = parcelRequire("kQeFn");
function $6cf31182d56f3d95$var$EC(options) {
    if (!(this instanceof $6cf31182d56f3d95$var$EC)) return new $6cf31182d56f3d95$var$EC(options);
    // Shortcut `elliptic.ec(curve-name)`
    if (typeof options === "string") {
        $6cf31182d56f3d95$var$assert(Object.prototype.hasOwnProperty.call($hwVHR, options), "Unknown curve " + options);
        options = $hwVHR[options];
    }
    // Shortcut for `elliptic.ec(elliptic.curves.curveName)`
    if (options instanceof $hwVHR.PresetCurve) options = {
        curve: options
    };
    this.curve = options.curve.curve;
    this.n = this.curve.n;
    this.nh = this.n.ushrn(1);
    this.g = this.curve.g;
    // Point on curve
    this.g = options.curve.g;
    this.g.precompute(options.curve.n.bitLength() + 1);
    // Hash for function for DRBG
    this.hash = options.hash || options.curve.hash;
}
module.exports = $6cf31182d56f3d95$var$EC;
$6cf31182d56f3d95$var$EC.prototype.keyPair = function keyPair(options) {
    return new $lE5ol(this, options);
};
$6cf31182d56f3d95$var$EC.prototype.keyFromPrivate = function keyFromPrivate(priv, enc) {
    return $lE5ol.fromPrivate(this, priv, enc);
};
$6cf31182d56f3d95$var$EC.prototype.keyFromPublic = function keyFromPublic(pub, enc) {
    return $lE5ol.fromPublic(this, pub, enc);
};
$6cf31182d56f3d95$var$EC.prototype.genKeyPair = function genKeyPair(options) {
    if (!options) options = {};
    // Instantiate Hmac_DRBG
    var drbg = new $5WFpm({
        hash: this.hash,
        pers: options.pers,
        persEnc: options.persEnc || "utf8",
        entropy: options.entropy || $9JRha(this.hash.hmacStrength),
        entropyEnc: options.entropy && options.entropyEnc || "utf8",
        nonce: this.n.toArray()
    });
    var bytes = this.n.byteLength();
    var ns2 = this.n.sub(new $7vYz3(2));
    for(;;){
        var priv = new $7vYz3(drbg.generate(bytes));
        if (priv.cmp(ns2) > 0) continue;
        priv.iaddn(1);
        return this.keyFromPrivate(priv);
    }
};
$6cf31182d56f3d95$var$EC.prototype._truncateToN = function _truncateToN(msg, truncOnly) {
    var delta = msg.byteLength() * 8 - this.n.bitLength();
    if (delta > 0) msg = msg.ushrn(delta);
    if (!truncOnly && msg.cmp(this.n) >= 0) return msg.sub(this.n);
    else return msg;
};
$6cf31182d56f3d95$var$EC.prototype.sign = function sign(msg, key, enc, options) {
    if (typeof enc === "object") {
        options = enc;
        enc = null;
    }
    if (!options) options = {};
    key = this.keyFromPrivate(key, enc);
    msg = this._truncateToN(new $7vYz3(msg, 16));
    // Zero-extend key to provide enough entropy
    var bytes = this.n.byteLength();
    var bkey = key.getPrivate().toArray("be", bytes);
    // Zero-extend nonce to have the same byte size as N
    var nonce = msg.toArray("be", bytes);
    // Instantiate Hmac_DRBG
    var drbg = new $5WFpm({
        hash: this.hash,
        entropy: bkey,
        nonce: nonce,
        pers: options.pers,
        persEnc: options.persEnc || "utf8"
    });
    // Number of bytes to generate
    var ns1 = this.n.sub(new $7vYz3(1));
    for(var iter = 0;; iter++){
        var k = options.k ? options.k(iter) : new $7vYz3(drbg.generate(this.n.byteLength()));
        k = this._truncateToN(k, true);
        if (k.cmpn(1) <= 0 || k.cmp(ns1) >= 0) continue;
        var kp = this.g.mul(k);
        if (kp.isInfinity()) continue;
        var kpX = kp.getX();
        var r = kpX.umod(this.n);
        if (r.cmpn(0) === 0) continue;
        var s = k.invm(this.n).mul(r.mul(key.getPrivate()).iadd(msg));
        s = s.umod(this.n);
        if (s.cmpn(0) === 0) continue;
        var recoveryParam = (kp.getY().isOdd() ? 1 : 0) | (kpX.cmp(r) !== 0 ? 2 : 0);
        // Use complement of `s`, if it is > `n / 2`
        if (options.canonical && s.cmp(this.nh) > 0) {
            s = this.n.sub(s);
            recoveryParam ^= 1;
        }
        return new $kQeFn({
            r: r,
            s: s,
            recoveryParam: recoveryParam
        });
    }
};
$6cf31182d56f3d95$var$EC.prototype.verify = function verify(msg, signature, key, enc) {
    msg = this._truncateToN(new $7vYz3(msg, 16));
    key = this.keyFromPublic(key, enc);
    signature = new $kQeFn(signature, "hex");
    // Perform primitive values validation
    var r = signature.r;
    var s = signature.s;
    if (r.cmpn(1) < 0 || r.cmp(this.n) >= 0) return false;
    if (s.cmpn(1) < 0 || s.cmp(this.n) >= 0) return false;
    // Validate signature
    var sinv = s.invm(this.n);
    var u1 = sinv.mul(msg).umod(this.n);
    var u2 = sinv.mul(r).umod(this.n);
    var p;
    if (!this.curve._maxwellTrick) {
        p = this.g.mulAdd(u1, key.getPublic(), u2);
        if (p.isInfinity()) return false;
        return p.getX().umod(this.n).cmp(r) === 0;
    }
    // NOTE: Greg Maxwell's trick, inspired by:
    // https://git.io/vad3K
    p = this.g.jmulAdd(u1, key.getPublic(), u2);
    if (p.isInfinity()) return false;
    // Compare `p.x` of Jacobian point with `r`,
    // this will do `p.x == r * p.z^2` instead of multiplying `p.x` by the
    // inverse of `p.z^2`
    return p.eqXToP(r);
};
$6cf31182d56f3d95$var$EC.prototype.recoverPubKey = function(msg, signature, j, enc) {
    $6cf31182d56f3d95$var$assert((3 & j) === j, "The recovery param is more than two bits");
    signature = new $kQeFn(signature, enc);
    var n = this.n;
    var e = new $7vYz3(msg);
    var r = signature.r;
    var s = signature.s;
    // A set LSB signifies that the y-coordinate is odd
    var isYOdd = j & 1;
    var isSecondKey = j >> 1;
    if (r.cmp(this.curve.p.umod(this.curve.n)) >= 0 && isSecondKey) throw new Error("Unable to find sencond key candinate");
    // 1.1. Let x = r + jn.
    if (isSecondKey) r = this.curve.pointFromX(r.add(this.curve.n), isYOdd);
    else r = this.curve.pointFromX(r, isYOdd);
    var rInv = signature.r.invm(n);
    var s1 = n.sub(e).mul(rInv).umod(n);
    var s2 = s.mul(rInv).umod(n);
    // 1.6.1 Compute Q = r^-1 (sR -  eG)
    //               Q = r^-1 (sR + -eG)
    return this.g.mulAdd(s1, r, s2);
};
$6cf31182d56f3d95$var$EC.prototype.getKeyRecoveryParam = function(e, signature, Q, enc) {
    signature = new $kQeFn(signature, enc);
    if (signature.recoveryParam !== null) return signature.recoveryParam;
    for(var i = 0; i < 4; i++){
        var Qprime;
        try {
            Qprime = this.recoverPubKey(e, signature, i);
        } catch (e) {
            continue;
        }
        if (Qprime.eq(Q)) return i;
    }
    throw new Error("Unable to find valid recovery factor");
};

});
parcelRequire.register("5WFpm", function(module, exports) {
"use strict";

var $leqJp = parcelRequire("leqJp");

var $6J8qY = parcelRequire("6J8qY");

var $aJt1P = parcelRequire("aJt1P");
function $45427d4f96da3b8c$var$HmacDRBG(options) {
    if (!(this instanceof $45427d4f96da3b8c$var$HmacDRBG)) return new $45427d4f96da3b8c$var$HmacDRBG(options);
    this.hash = options.hash;
    this.predResist = !!options.predResist;
    this.outLen = this.hash.outSize;
    this.minEntropy = options.minEntropy || this.hash.hmacStrength;
    this._reseed = null;
    this.reseedInterval = null;
    this.K = null;
    this.V = null;
    var entropy = $6J8qY.toArray(options.entropy, options.entropyEnc || "hex");
    var nonce = $6J8qY.toArray(options.nonce, options.nonceEnc || "hex");
    var pers = $6J8qY.toArray(options.pers, options.persEnc || "hex");
    $aJt1P(entropy.length >= this.minEntropy / 8, "Not enough entropy. Minimum is: " + this.minEntropy + " bits");
    this._init(entropy, nonce, pers);
}
module.exports = $45427d4f96da3b8c$var$HmacDRBG;
$45427d4f96da3b8c$var$HmacDRBG.prototype._init = function init(entropy, nonce, pers) {
    var seed = entropy.concat(nonce).concat(pers);
    this.K = new Array(this.outLen / 8);
    this.V = new Array(this.outLen / 8);
    for(var i = 0; i < this.V.length; i++){
        this.K[i] = 0x00;
        this.V[i] = 0x01;
    }
    this._update(seed);
    this._reseed = 1;
    this.reseedInterval = 0x1000000000000; // 2^48
};
$45427d4f96da3b8c$var$HmacDRBG.prototype._hmac = function hmac() {
    return new $leqJp.hmac(this.hash, this.K);
};
$45427d4f96da3b8c$var$HmacDRBG.prototype._update = function update(seed) {
    var kmac = this._hmac().update(this.V).update([
        0x00
    ]);
    if (seed) kmac = kmac.update(seed);
    this.K = kmac.digest();
    this.V = this._hmac().update(this.V).digest();
    if (!seed) return;
    this.K = this._hmac().update(this.V).update([
        0x01
    ]).update(seed).digest();
    this.V = this._hmac().update(this.V).digest();
};
$45427d4f96da3b8c$var$HmacDRBG.prototype.reseed = function reseed(entropy, entropyEnc, add, addEnc) {
    // Optional entropy enc
    if (typeof entropyEnc !== "string") {
        addEnc = add;
        add = entropyEnc;
        entropyEnc = null;
    }
    entropy = $6J8qY.toArray(entropy, entropyEnc);
    add = $6J8qY.toArray(add, addEnc);
    $aJt1P(entropy.length >= this.minEntropy / 8, "Not enough entropy. Minimum is: " + this.minEntropy + " bits");
    this._update(entropy.concat(add || []));
    this._reseed = 1;
};
$45427d4f96da3b8c$var$HmacDRBG.prototype.generate = function generate(len, enc, add, addEnc) {
    if (this._reseed > this.reseedInterval) throw new Error("Reseed is required");
    // Optional encoding
    if (typeof enc !== "string") {
        addEnc = add;
        add = enc;
        enc = null;
    }
    // Optional additional data
    if (add) {
        add = $6J8qY.toArray(add, addEnc || "hex");
        this._update(add);
    }
    var temp = [];
    while(temp.length < len){
        this.V = this._hmac().update(this.V).digest();
        temp = temp.concat(this.V);
    }
    var res = temp.slice(0, len);
    this._update(add);
    this._reseed++;
    return $6J8qY.encode(res, enc);
};

});

parcelRequire.register("lE5ol", function(module, exports) {
"use strict";

var $7vYz3 = parcelRequire("7vYz3");

var $ZdcNb = parcelRequire("ZdcNb");
var $fc21840fd53be280$var$assert = $ZdcNb.assert;
function $fc21840fd53be280$var$KeyPair(ec, options) {
    this.ec = ec;
    this.priv = null;
    this.pub = null;
    // KeyPair(ec, { priv: ..., pub: ... })
    if (options.priv) this._importPrivate(options.priv, options.privEnc);
    if (options.pub) this._importPublic(options.pub, options.pubEnc);
}
module.exports = $fc21840fd53be280$var$KeyPair;
$fc21840fd53be280$var$KeyPair.fromPublic = function fromPublic(ec, pub, enc) {
    if (pub instanceof $fc21840fd53be280$var$KeyPair) return pub;
    return new $fc21840fd53be280$var$KeyPair(ec, {
        pub: pub,
        pubEnc: enc
    });
};
$fc21840fd53be280$var$KeyPair.fromPrivate = function fromPrivate(ec, priv, enc) {
    if (priv instanceof $fc21840fd53be280$var$KeyPair) return priv;
    return new $fc21840fd53be280$var$KeyPair(ec, {
        priv: priv,
        privEnc: enc
    });
};
$fc21840fd53be280$var$KeyPair.prototype.validate = function validate() {
    var pub = this.getPublic();
    if (pub.isInfinity()) return {
        result: false,
        reason: "Invalid public key"
    };
    if (!pub.validate()) return {
        result: false,
        reason: "Public key is not a point"
    };
    if (!pub.mul(this.ec.curve.n).isInfinity()) return {
        result: false,
        reason: "Public key * N != O"
    };
    return {
        result: true,
        reason: null
    };
};
$fc21840fd53be280$var$KeyPair.prototype.getPublic = function getPublic(compact, enc) {
    // compact is optional argument
    if (typeof compact === "string") {
        enc = compact;
        compact = null;
    }
    if (!this.pub) this.pub = this.ec.g.mul(this.priv);
    if (!enc) return this.pub;
    return this.pub.encode(enc, compact);
};
$fc21840fd53be280$var$KeyPair.prototype.getPrivate = function getPrivate(enc) {
    if (enc === "hex") return this.priv.toString(16, 2);
    else return this.priv;
};
$fc21840fd53be280$var$KeyPair.prototype._importPrivate = function _importPrivate(key, enc) {
    this.priv = new $7vYz3(key, enc || 16);
    // Ensure that the priv won't be bigger than n, otherwise we may fail
    // in fixed multiplication method
    this.priv = this.priv.umod(this.ec.curve.n);
};
$fc21840fd53be280$var$KeyPair.prototype._importPublic = function _importPublic(key, enc) {
    if (key.x || key.y) {
        // Montgomery points only have an `x` coordinate.
        // Weierstrass/Edwards points on the other hand have both `x` and
        // `y` coordinates.
        if (this.ec.curve.type === "mont") $fc21840fd53be280$var$assert(key.x, "Need x coordinate");
        else if (this.ec.curve.type === "short" || this.ec.curve.type === "edwards") $fc21840fd53be280$var$assert(key.x && key.y, "Need both x and y coordinate");
        this.pub = this.ec.curve.point(key.x, key.y);
        return;
    }
    this.pub = this.ec.curve.decodePoint(key, enc);
};
// ECDH
$fc21840fd53be280$var$KeyPair.prototype.derive = function derive(pub) {
    if (!pub.validate()) $fc21840fd53be280$var$assert(pub.validate(), "public point not validated");
    return pub.mul(this.priv).getX();
};
// ECDSA
$fc21840fd53be280$var$KeyPair.prototype.sign = function sign(msg, enc, options) {
    return this.ec.sign(msg, this, enc, options);
};
$fc21840fd53be280$var$KeyPair.prototype.verify = function verify(msg, signature) {
    return this.ec.verify(msg, signature, this);
};
$fc21840fd53be280$var$KeyPair.prototype.inspect = function inspect() {
    return "<Key priv: " + (this.priv && this.priv.toString(16, 2)) + " pub: " + (this.pub && this.pub.inspect()) + " >";
};

});

parcelRequire.register("kQeFn", function(module, exports) {
"use strict";

var $7vYz3 = parcelRequire("7vYz3");

var $ZdcNb = parcelRequire("ZdcNb");
var $f2c40a6448de4ea4$var$assert = $ZdcNb.assert;
function $f2c40a6448de4ea4$var$Signature(options, enc) {
    if (options instanceof $f2c40a6448de4ea4$var$Signature) return options;
    if (this._importDER(options, enc)) return;
    $f2c40a6448de4ea4$var$assert(options.r && options.s, "Signature without r or s");
    this.r = new $7vYz3(options.r, 16);
    this.s = new $7vYz3(options.s, 16);
    if (options.recoveryParam === undefined) this.recoveryParam = null;
    else this.recoveryParam = options.recoveryParam;
}
module.exports = $f2c40a6448de4ea4$var$Signature;
function $f2c40a6448de4ea4$var$Position() {
    this.place = 0;
}
function $f2c40a6448de4ea4$var$getLength(buf, p) {
    var initial = buf[p.place++];
    if (!(initial & 0x80)) return initial;
    var octetLen = initial & 0xf;
    // Indefinite length or overflow
    if (octetLen === 0 || octetLen > 4) return false;
    var val = 0;
    for(var i = 0, off = p.place; i < octetLen; i++, off++){
        val <<= 8;
        val |= buf[off];
        val >>>= 0;
    }
    // Leading zeroes
    if (val <= 0x7f) return false;
    p.place = off;
    return val;
}
function $f2c40a6448de4ea4$var$rmPadding(buf) {
    var i = 0;
    var len = buf.length - 1;
    while(!buf[i] && !(buf[i + 1] & 0x80) && i < len)i++;
    if (i === 0) return buf;
    return buf.slice(i);
}
$f2c40a6448de4ea4$var$Signature.prototype._importDER = function _importDER(data, enc) {
    data = $ZdcNb.toArray(data, enc);
    var p = new $f2c40a6448de4ea4$var$Position();
    if (data[p.place++] !== 0x30) return false;
    var len = $f2c40a6448de4ea4$var$getLength(data, p);
    if (len === false) return false;
    if (len + p.place !== data.length) return false;
    if (data[p.place++] !== 0x02) return false;
    var rlen = $f2c40a6448de4ea4$var$getLength(data, p);
    if (rlen === false) return false;
    var r = data.slice(p.place, rlen + p.place);
    p.place += rlen;
    if (data[p.place++] !== 0x02) return false;
    var slen = $f2c40a6448de4ea4$var$getLength(data, p);
    if (slen === false) return false;
    if (data.length !== slen + p.place) return false;
    var s = data.slice(p.place, slen + p.place);
    if (r[0] === 0) {
        if (r[1] & 0x80) r = r.slice(1);
        else // Leading zeroes
        return false;
    }
    if (s[0] === 0) {
        if (s[1] & 0x80) s = s.slice(1);
        else // Leading zeroes
        return false;
    }
    this.r = new $7vYz3(r);
    this.s = new $7vYz3(s);
    this.recoveryParam = null;
    return true;
};
function $f2c40a6448de4ea4$var$constructLength(arr, len) {
    if (len < 0x80) {
        arr.push(len);
        return;
    }
    var octets = 1 + (Math.log(len) / Math.LN2 >>> 3);
    arr.push(octets | 0x80);
    while(--octets)arr.push(len >>> (octets << 3) & 0xff);
    arr.push(len);
}
$f2c40a6448de4ea4$var$Signature.prototype.toDER = function toDER(enc) {
    var r = this.r.toArray();
    var s = this.s.toArray();
    // Pad values
    if (r[0] & 0x80) r = [
        0
    ].concat(r);
    // Pad values
    if (s[0] & 0x80) s = [
        0
    ].concat(s);
    r = $f2c40a6448de4ea4$var$rmPadding(r);
    s = $f2c40a6448de4ea4$var$rmPadding(s);
    while(!s[0] && !(s[1] & 0x80))s = s.slice(1);
    var arr = [
        0x02
    ];
    $f2c40a6448de4ea4$var$constructLength(arr, r.length);
    arr = arr.concat(r);
    arr.push(0x02);
    $f2c40a6448de4ea4$var$constructLength(arr, s.length);
    var backHalf = arr.concat(s);
    var res = [
        0x30
    ];
    $f2c40a6448de4ea4$var$constructLength(res, backHalf.length);
    res = res.concat(backHalf);
    return $ZdcNb.encode(res, enc);
};

});


parcelRequire.register("96jZE", function(module, exports) {
"use strict";

var $leqJp = parcelRequire("leqJp");

var $hwVHR = parcelRequire("hwVHR");

var $ZdcNb = parcelRequire("ZdcNb");
var $6a042ee1f208896f$var$assert = $ZdcNb.assert;
var $6a042ee1f208896f$var$parseBytes = $ZdcNb.parseBytes;

var $cR8ar = parcelRequire("cR8ar");

var $8zcvU = parcelRequire("8zcvU");
function $6a042ee1f208896f$var$EDDSA(curve) {
    $6a042ee1f208896f$var$assert(curve === "ed25519", "only tested with ed25519 so far");
    if (!(this instanceof $6a042ee1f208896f$var$EDDSA)) return new $6a042ee1f208896f$var$EDDSA(curve);
    curve = $hwVHR[curve].curve;
    this.curve = curve;
    this.g = curve.g;
    this.g.precompute(curve.n.bitLength() + 1);
    this.pointClass = curve.point().constructor;
    this.encodingLength = Math.ceil(curve.n.bitLength() / 8);
    this.hash = $leqJp.sha512;
}
module.exports = $6a042ee1f208896f$var$EDDSA;
/**
* @param {Array|String} message - message bytes
* @param {Array|String|KeyPair} secret - secret bytes or a keypair
* @returns {Signature} - signature
*/ $6a042ee1f208896f$var$EDDSA.prototype.sign = function sign(message, secret) {
    message = $6a042ee1f208896f$var$parseBytes(message);
    var key = this.keyFromSecret(secret);
    var r = this.hashInt(key.messagePrefix(), message);
    var R = this.g.mul(r);
    var Rencoded = this.encodePoint(R);
    var s_ = this.hashInt(Rencoded, key.pubBytes(), message).mul(key.priv());
    var S = r.add(s_).umod(this.curve.n);
    return this.makeSignature({
        R: R,
        S: S,
        Rencoded: Rencoded
    });
};
/**
* @param {Array} message - message bytes
* @param {Array|String|Signature} sig - sig bytes
* @param {Array|String|Point|KeyPair} pub - public key
* @returns {Boolean} - true if public key matches sig of message
*/ $6a042ee1f208896f$var$EDDSA.prototype.verify = function verify(message, sig, pub) {
    message = $6a042ee1f208896f$var$parseBytes(message);
    sig = this.makeSignature(sig);
    var key = this.keyFromPublic(pub);
    var h = this.hashInt(sig.Rencoded(), key.pubBytes(), message);
    var SG = this.g.mul(sig.S());
    var RplusAh = sig.R().add(key.pub().mul(h));
    return RplusAh.eq(SG);
};
$6a042ee1f208896f$var$EDDSA.prototype.hashInt = function hashInt() {
    var hash = this.hash();
    for(var i = 0; i < arguments.length; i++)hash.update(arguments[i]);
    return $ZdcNb.intFromLE(hash.digest()).umod(this.curve.n);
};
$6a042ee1f208896f$var$EDDSA.prototype.keyFromPublic = function keyFromPublic(pub) {
    return $cR8ar.fromPublic(this, pub);
};
$6a042ee1f208896f$var$EDDSA.prototype.keyFromSecret = function keyFromSecret(secret) {
    return $cR8ar.fromSecret(this, secret);
};
$6a042ee1f208896f$var$EDDSA.prototype.makeSignature = function makeSignature(sig) {
    if (sig instanceof $8zcvU) return sig;
    return new $8zcvU(this, sig);
};
/**
* * https://tools.ietf.org/html/draft-josefsson-eddsa-ed25519-03#section-5.2
*
* EDDSA defines methods for encoding and decoding points and integers. These are
* helper convenience methods, that pass along to utility functions implied
* parameters.
*
*/ $6a042ee1f208896f$var$EDDSA.prototype.encodePoint = function encodePoint(point) {
    var enc = point.getY().toArray("le", this.encodingLength);
    enc[this.encodingLength - 1] |= point.getX().isOdd() ? 0x80 : 0;
    return enc;
};
$6a042ee1f208896f$var$EDDSA.prototype.decodePoint = function decodePoint(bytes) {
    bytes = $ZdcNb.parseBytes(bytes);
    var lastIx = bytes.length - 1;
    var normed = bytes.slice(0, lastIx).concat(bytes[lastIx] & -129);
    var xIsOdd = (bytes[lastIx] & 0x80) !== 0;
    var y = $ZdcNb.intFromLE(normed);
    return this.curve.pointFromY(y, xIsOdd);
};
$6a042ee1f208896f$var$EDDSA.prototype.encodeInt = function encodeInt(num) {
    return num.toArray("le", this.encodingLength);
};
$6a042ee1f208896f$var$EDDSA.prototype.decodeInt = function decodeInt(bytes) {
    return $ZdcNb.intFromLE(bytes);
};
$6a042ee1f208896f$var$EDDSA.prototype.isPoint = function isPoint(val) {
    return val instanceof this.pointClass;
};

});
parcelRequire.register("cR8ar", function(module, exports) {
"use strict";

var $ZdcNb = parcelRequire("ZdcNb");
var $95c0c52842c57a81$var$assert = $ZdcNb.assert;
var $95c0c52842c57a81$var$parseBytes = $ZdcNb.parseBytes;
var $95c0c52842c57a81$var$cachedProperty = $ZdcNb.cachedProperty;
/**
* @param {EDDSA} eddsa - instance
* @param {Object} params - public/private key parameters
*
* @param {Array<Byte>} [params.secret] - secret seed bytes
* @param {Point} [params.pub] - public key point (aka `A` in eddsa terms)
* @param {Array<Byte>} [params.pub] - public key point encoded as bytes
*
*/ function $95c0c52842c57a81$var$KeyPair(eddsa, params) {
    this.eddsa = eddsa;
    this._secret = $95c0c52842c57a81$var$parseBytes(params.secret);
    if (eddsa.isPoint(params.pub)) this._pub = params.pub;
    else this._pubBytes = $95c0c52842c57a81$var$parseBytes(params.pub);
}
$95c0c52842c57a81$var$KeyPair.fromPublic = function fromPublic(eddsa, pub) {
    if (pub instanceof $95c0c52842c57a81$var$KeyPair) return pub;
    return new $95c0c52842c57a81$var$KeyPair(eddsa, {
        pub: pub
    });
};
$95c0c52842c57a81$var$KeyPair.fromSecret = function fromSecret(eddsa, secret) {
    if (secret instanceof $95c0c52842c57a81$var$KeyPair) return secret;
    return new $95c0c52842c57a81$var$KeyPair(eddsa, {
        secret: secret
    });
};
$95c0c52842c57a81$var$KeyPair.prototype.secret = function secret() {
    return this._secret;
};
$95c0c52842c57a81$var$cachedProperty($95c0c52842c57a81$var$KeyPair, "pubBytes", function pubBytes() {
    return this.eddsa.encodePoint(this.pub());
});
$95c0c52842c57a81$var$cachedProperty($95c0c52842c57a81$var$KeyPair, "pub", function pub() {
    if (this._pubBytes) return this.eddsa.decodePoint(this._pubBytes);
    return this.eddsa.g.mul(this.priv());
});
$95c0c52842c57a81$var$cachedProperty($95c0c52842c57a81$var$KeyPair, "privBytes", function privBytes() {
    var eddsa = this.eddsa;
    var hash = this.hash();
    var lastIx = eddsa.encodingLength - 1;
    var a = hash.slice(0, eddsa.encodingLength);
    a[0] &= 248;
    a[lastIx] &= 127;
    a[lastIx] |= 64;
    return a;
});
$95c0c52842c57a81$var$cachedProperty($95c0c52842c57a81$var$KeyPair, "priv", function priv() {
    return this.eddsa.decodeInt(this.privBytes());
});
$95c0c52842c57a81$var$cachedProperty($95c0c52842c57a81$var$KeyPair, "hash", function hash() {
    return this.eddsa.hash().update(this.secret()).digest();
});
$95c0c52842c57a81$var$cachedProperty($95c0c52842c57a81$var$KeyPair, "messagePrefix", function messagePrefix() {
    return this.hash().slice(this.eddsa.encodingLength);
});
$95c0c52842c57a81$var$KeyPair.prototype.sign = function sign(message) {
    $95c0c52842c57a81$var$assert(this._secret, "KeyPair can only verify");
    return this.eddsa.sign(message, this);
};
$95c0c52842c57a81$var$KeyPair.prototype.verify = function verify(message, sig) {
    return this.eddsa.verify(message, sig, this);
};
$95c0c52842c57a81$var$KeyPair.prototype.getSecret = function getSecret(enc) {
    $95c0c52842c57a81$var$assert(this._secret, "KeyPair is public only");
    return $ZdcNb.encode(this.secret(), enc);
};
$95c0c52842c57a81$var$KeyPair.prototype.getPublic = function getPublic(enc) {
    return $ZdcNb.encode(this.pubBytes(), enc);
};
module.exports = $95c0c52842c57a81$var$KeyPair;

});

parcelRequire.register("8zcvU", function(module, exports) {
"use strict";

var $7vYz3 = parcelRequire("7vYz3");

var $ZdcNb = parcelRequire("ZdcNb");
var $63cb4c939de36593$var$assert = $ZdcNb.assert;
var $63cb4c939de36593$var$cachedProperty = $ZdcNb.cachedProperty;
var $63cb4c939de36593$var$parseBytes = $ZdcNb.parseBytes;
/**
* @param {EDDSA} eddsa - eddsa instance
* @param {Array<Bytes>|Object} sig -
* @param {Array<Bytes>|Point} [sig.R] - R point as Point or bytes
* @param {Array<Bytes>|bn} [sig.S] - S scalar as bn or bytes
* @param {Array<Bytes>} [sig.Rencoded] - R point encoded
* @param {Array<Bytes>} [sig.Sencoded] - S scalar encoded
*/ function $63cb4c939de36593$var$Signature(eddsa, sig) {
    this.eddsa = eddsa;
    if (typeof sig !== "object") sig = $63cb4c939de36593$var$parseBytes(sig);
    if (Array.isArray(sig)) sig = {
        R: sig.slice(0, eddsa.encodingLength),
        S: sig.slice(eddsa.encodingLength)
    };
    $63cb4c939de36593$var$assert(sig.R && sig.S, "Signature without R or S");
    if (eddsa.isPoint(sig.R)) this._R = sig.R;
    if (sig.S instanceof $7vYz3) this._S = sig.S;
    this._Rencoded = Array.isArray(sig.R) ? sig.R : sig.Rencoded;
    this._Sencoded = Array.isArray(sig.S) ? sig.S : sig.Sencoded;
}
$63cb4c939de36593$var$cachedProperty($63cb4c939de36593$var$Signature, "S", function S() {
    return this.eddsa.decodeInt(this.Sencoded());
});
$63cb4c939de36593$var$cachedProperty($63cb4c939de36593$var$Signature, "R", function R() {
    return this.eddsa.decodePoint(this.Rencoded());
});
$63cb4c939de36593$var$cachedProperty($63cb4c939de36593$var$Signature, "Rencoded", function Rencoded() {
    return this.eddsa.encodePoint(this.R());
});
$63cb4c939de36593$var$cachedProperty($63cb4c939de36593$var$Signature, "Sencoded", function Sencoded() {
    return this.eddsa.encodeInt(this.S());
});
$63cb4c939de36593$var$Signature.prototype.toBytes = function toBytes() {
    return this.Rencoded().concat(this.Sencoded());
};
$63cb4c939de36593$var$Signature.prototype.toHex = function toHex() {
    return $ZdcNb.encode(this.toBytes(), "hex").toUpperCase();
};
module.exports = $63cb4c939de36593$var$Signature;

});



parcelRequire.register("4B7L6", function(module, exports) {

(function(module1, exports) {
    "use strict";
    // Utils
    function assert(val, msg) {
        if (!val) throw new Error(msg || "Assertion failed");
    }
    // Could use `inherits` module, but don't want to move from single file
    // architecture yet.
    function inherits(ctor, superCtor) {
        ctor.super_ = superCtor;
        var TempCtor = function() {};
        TempCtor.prototype = superCtor.prototype;
        ctor.prototype = new TempCtor();
        ctor.prototype.constructor = ctor;
    }
    // BN
    function BN(number, base, endian) {
        if (BN.isBN(number)) return number;
        this.negative = 0;
        this.words = null;
        this.length = 0;
        // Reduction context
        this.red = null;
        if (number !== null) {
            if (base === "le" || base === "be") {
                endian = base;
                base = 10;
            }
            this._init(number || 0, base || 10, endian || "be");
        }
    }
    if (typeof module1 === "object") module1.exports = BN;
    else exports.BN = BN;
    BN.BN = BN;
    BN.wordSize = 26;
    var Buffer;
    try {
        if (typeof window !== "undefined" && typeof window.Buffer !== "undefined") Buffer = window.Buffer;
        else Buffer = (parcelRequire("5Io6y")).Buffer;
    } catch (e) {}
    BN.isBN = function isBN(num) {
        if (num instanceof BN) return true;
        return num !== null && typeof num === "object" && num.constructor.wordSize === BN.wordSize && Array.isArray(num.words);
    };
    BN.max = function max(left, right) {
        if (left.cmp(right) > 0) return left;
        return right;
    };
    BN.min = function min(left, right) {
        if (left.cmp(right) < 0) return left;
        return right;
    };
    BN.prototype._init = function init(number, base, endian) {
        if (typeof number === "number") return this._initNumber(number, base, endian);
        if (typeof number === "object") return this._initArray(number, base, endian);
        if (base === "hex") base = 16;
        assert(base === (base | 0) && base >= 2 && base <= 36);
        number = number.toString().replace(/\s+/g, "");
        var start = 0;
        if (number[0] === "-") {
            start++;
            this.negative = 1;
        }
        if (start < number.length) {
            if (base === 16) this._parseHex(number, start, endian);
            else {
                this._parseBase(number, base, start);
                if (endian === "le") this._initArray(this.toArray(), base, endian);
            }
        }
    };
    BN.prototype._initNumber = function _initNumber(number, base, endian) {
        if (number < 0) {
            this.negative = 1;
            number = -number;
        }
        if (number < 0x4000000) {
            this.words = [
                number & 0x3ffffff
            ];
            this.length = 1;
        } else if (number < 0x10000000000000) {
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff
            ];
            this.length = 2;
        } else {
            assert(number < 0x20000000000000); // 2 ^ 53 (unsafe)
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff,
                1
            ];
            this.length = 3;
        }
        if (endian !== "le") return;
        // Reverse the bytes
        this._initArray(this.toArray(), base, endian);
    };
    BN.prototype._initArray = function _initArray(number, base, endian) {
        // Perhaps a Uint8Array
        assert(typeof number.length === "number");
        if (number.length <= 0) {
            this.words = [
                0
            ];
            this.length = 1;
            return this;
        }
        this.length = Math.ceil(number.length / 3);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        var j, w;
        var off = 0;
        if (endian === "be") for(i = number.length - 1, j = 0; i >= 0; i -= 3){
            w = number[i] | number[i - 1] << 8 | number[i - 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        else if (endian === "le") for(i = 0, j = 0; i < number.length; i += 3){
            w = number[i] | number[i + 1] << 8 | number[i + 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        return this._strip();
    };
    function parseHex4Bits(string, index) {
        var c = string.charCodeAt(index);
        // '0' - '9'
        if (c >= 48 && c <= 57) return c - 48;
        else if (c >= 65 && c <= 70) return c - 55;
        else if (c >= 97 && c <= 102) return c - 87;
        else assert(false, "Invalid character in " + string);
    }
    function parseHexByte(string, lowerBound, index) {
        var r = parseHex4Bits(string, index);
        if (index - 1 >= lowerBound) r |= parseHex4Bits(string, index - 1) << 4;
        return r;
    }
    BN.prototype._parseHex = function _parseHex(number, start, endian) {
        // Create possibly bigger array to ensure that it fits the number
        this.length = Math.ceil((number.length - start) / 6);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        // 24-bits chunks
        var off = 0;
        var j = 0;
        var w;
        if (endian === "be") for(i = number.length - 1; i >= start; i -= 2){
            w = parseHexByte(number, start, i) << off;
            this.words[j] |= w & 0x3ffffff;
            if (off >= 18) {
                off -= 18;
                j += 1;
                this.words[j] |= w >>> 26;
            } else off += 8;
        }
        else {
            var parseLength = number.length - start;
            for(i = parseLength % 2 === 0 ? start + 1 : start; i < number.length; i += 2){
                w = parseHexByte(number, start, i) << off;
                this.words[j] |= w & 0x3ffffff;
                if (off >= 18) {
                    off -= 18;
                    j += 1;
                    this.words[j] |= w >>> 26;
                } else off += 8;
            }
        }
        this._strip();
    };
    function parseBase(str, start, end, mul) {
        var r = 0;
        var b = 0;
        var len = Math.min(str.length, end);
        for(var i = start; i < len; i++){
            var c = str.charCodeAt(i) - 48;
            r *= mul;
            // 'a'
            if (c >= 49) b = c - 49 + 0xa;
            else if (c >= 17) b = c - 17 + 0xa;
            else b = c;
            assert(c >= 0 && b < mul, "Invalid character");
            r += b;
        }
        return r;
    }
    BN.prototype._parseBase = function _parseBase(number, base, start) {
        // Initialize as zero
        this.words = [
            0
        ];
        this.length = 1;
        // Find length of limb in base
        for(var limbLen = 0, limbPow = 1; limbPow <= 0x3ffffff; limbPow *= base)limbLen++;
        limbLen--;
        limbPow = limbPow / base | 0;
        var total = number.length - start;
        var mod = total % limbLen;
        var end = Math.min(total, total - mod) + start;
        var word = 0;
        for(var i = start; i < end; i += limbLen){
            word = parseBase(number, i, i + limbLen, base);
            this.imuln(limbPow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        if (mod !== 0) {
            var pow = 1;
            word = parseBase(number, i, number.length, base);
            for(i = 0; i < mod; i++)pow *= base;
            this.imuln(pow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        this._strip();
    };
    BN.prototype.copy = function copy(dest) {
        dest.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)dest.words[i] = this.words[i];
        dest.length = this.length;
        dest.negative = this.negative;
        dest.red = this.red;
    };
    function move(dest, src) {
        dest.words = src.words;
        dest.length = src.length;
        dest.negative = src.negative;
        dest.red = src.red;
    }
    BN.prototype._move = function _move(dest) {
        move(dest, this);
    };
    BN.prototype.clone = function clone() {
        var r = new BN(null);
        this.copy(r);
        return r;
    };
    BN.prototype._expand = function _expand(size) {
        while(this.length < size)this.words[this.length++] = 0;
        return this;
    };
    // Remove leading `0` from `this`
    BN.prototype._strip = function strip() {
        while(this.length > 1 && this.words[this.length - 1] === 0)this.length--;
        return this._normSign();
    };
    BN.prototype._normSign = function _normSign() {
        // -0 = 0
        if (this.length === 1 && this.words[0] === 0) this.negative = 0;
        return this;
    };
    // Check Symbol.for because not everywhere where Symbol defined
    // See https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Symbol#Browser_compatibility
    if (typeof Symbol !== "undefined" && typeof Symbol.for === "function") try {
        BN.prototype[Symbol.for("nodejs.util.inspect.custom")] = inspect;
    } catch (e) {
        BN.prototype.inspect = inspect;
    }
    else BN.prototype.inspect = inspect;
    function inspect() {
        return (this.red ? "<BN-R: " : "<BN: ") + this.toString(16) + ">";
    }
    /*

  var zeros = [];
  var groupSizes = [];
  var groupBases = [];

  var s = '';
  var i = -1;
  while (++i < BN.wordSize) {
    zeros[i] = s;
    s += '0';
  }
  groupSizes[0] = 0;
  groupSizes[1] = 0;
  groupBases[0] = 0;
  groupBases[1] = 0;
  var base = 2 - 1;
  while (++base < 36 + 1) {
    var groupSize = 0;
    var groupBase = 1;
    while (groupBase < (1 << BN.wordSize) / base) {
      groupBase *= base;
      groupSize += 1;
    }
    groupSizes[base] = groupSize;
    groupBases[base] = groupBase;
  }

  */ var zeros = [
        "",
        "0",
        "00",
        "000",
        "0000",
        "00000",
        "000000",
        "0000000",
        "00000000",
        "000000000",
        "0000000000",
        "00000000000",
        "000000000000",
        "0000000000000",
        "00000000000000",
        "000000000000000",
        "0000000000000000",
        "00000000000000000",
        "000000000000000000",
        "0000000000000000000",
        "00000000000000000000",
        "000000000000000000000",
        "0000000000000000000000",
        "00000000000000000000000",
        "000000000000000000000000",
        "0000000000000000000000000"
    ];
    var groupSizes = [
        0,
        0,
        25,
        16,
        12,
        11,
        10,
        9,
        8,
        8,
        7,
        7,
        7,
        7,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5
    ];
    var groupBases = [
        0,
        0,
        33554432,
        43046721,
        16777216,
        48828125,
        60466176,
        40353607,
        16777216,
        43046721,
        10000000,
        19487171,
        35831808,
        62748517,
        7529536,
        11390625,
        16777216,
        24137569,
        34012224,
        47045881,
        64000000,
        4084101,
        5153632,
        6436343,
        7962624,
        9765625,
        11881376,
        14348907,
        17210368,
        20511149,
        24300000,
        28629151,
        33554432,
        39135393,
        45435424,
        52521875,
        60466176
    ];
    BN.prototype.toString = function toString(base, padding) {
        base = base || 10;
        padding = padding | 0 || 1;
        var out;
        if (base === 16 || base === "hex") {
            out = "";
            var off = 0;
            var carry = 0;
            for(var i = 0; i < this.length; i++){
                var w = this.words[i];
                var word = ((w << off | carry) & 0xffffff).toString(16);
                carry = w >>> 24 - off & 0xffffff;
                off += 2;
                if (off >= 26) {
                    off -= 26;
                    i--;
                }
                if (carry !== 0 || i !== this.length - 1) out = zeros[6 - word.length] + word + out;
                else out = word + out;
            }
            if (carry !== 0) out = carry.toString(16) + out;
            while(out.length % padding !== 0)out = "0" + out;
            if (this.negative !== 0) out = "-" + out;
            return out;
        }
        if (base === (base | 0) && base >= 2 && base <= 36) {
            // var groupSize = Math.floor(BN.wordSize * Math.LN2 / Math.log(base));
            var groupSize = groupSizes[base];
            // var groupBase = Math.pow(base, groupSize);
            var groupBase = groupBases[base];
            out = "";
            var c = this.clone();
            c.negative = 0;
            while(!c.isZero()){
                var r = c.modrn(groupBase).toString(base);
                c = c.idivn(groupBase);
                if (!c.isZero()) out = zeros[groupSize - r.length] + r + out;
                else out = r + out;
            }
            if (this.isZero()) out = "0" + out;
            while(out.length % padding !== 0)out = "0" + out;
            if (this.negative !== 0) out = "-" + out;
            return out;
        }
        assert(false, "Base should be between 2 and 36");
    };
    BN.prototype.toNumber = function toNumber() {
        var ret = this.words[0];
        if (this.length === 2) ret += this.words[1] * 0x4000000;
        else if (this.length === 3 && this.words[2] === 0x01) // NOTE: at this stage it is known that the top bit is set
        ret += 0x10000000000000 + this.words[1] * 0x4000000;
        else if (this.length > 2) assert(false, "Number can only safely store up to 53 bits");
        return this.negative !== 0 ? -ret : ret;
    };
    BN.prototype.toJSON = function toJSON() {
        return this.toString(16, 2);
    };
    if (Buffer) BN.prototype.toBuffer = function toBuffer(endian, length) {
        return this.toArrayLike(Buffer, endian, length);
    };
    BN.prototype.toArray = function toArray(endian, length) {
        return this.toArrayLike(Array, endian, length);
    };
    var allocate = function allocate(ArrayType, size) {
        if (ArrayType.allocUnsafe) return ArrayType.allocUnsafe(size);
        return new ArrayType(size);
    };
    BN.prototype.toArrayLike = function toArrayLike(ArrayType, endian, length) {
        this._strip();
        var byteLength = this.byteLength();
        var reqLength = length || Math.max(1, byteLength);
        assert(byteLength <= reqLength, "byte array longer than desired length");
        assert(reqLength > 0, "Requested array length <= 0");
        var res = allocate(ArrayType, reqLength);
        var postfix = endian === "le" ? "LE" : "BE";
        this["_toArrayLike" + postfix](res, byteLength);
        return res;
    };
    BN.prototype._toArrayLikeLE = function _toArrayLikeLE(res, byteLength) {
        var position = 0;
        var carry = 0;
        for(var i = 0, shift = 0; i < this.length; i++){
            var word = this.words[i] << shift | carry;
            res[position++] = word & 0xff;
            if (position < res.length) res[position++] = word >> 8 & 0xff;
            if (position < res.length) res[position++] = word >> 16 & 0xff;
            if (shift === 6) {
                if (position < res.length) res[position++] = word >> 24 & 0xff;
                carry = 0;
                shift = 0;
            } else {
                carry = word >>> 24;
                shift += 2;
            }
        }
        if (position < res.length) {
            res[position++] = carry;
            while(position < res.length)res[position++] = 0;
        }
    };
    BN.prototype._toArrayLikeBE = function _toArrayLikeBE(res, byteLength) {
        var position = res.length - 1;
        var carry = 0;
        for(var i = 0, shift = 0; i < this.length; i++){
            var word = this.words[i] << shift | carry;
            res[position--] = word & 0xff;
            if (position >= 0) res[position--] = word >> 8 & 0xff;
            if (position >= 0) res[position--] = word >> 16 & 0xff;
            if (shift === 6) {
                if (position >= 0) res[position--] = word >> 24 & 0xff;
                carry = 0;
                shift = 0;
            } else {
                carry = word >>> 24;
                shift += 2;
            }
        }
        if (position >= 0) {
            res[position--] = carry;
            while(position >= 0)res[position--] = 0;
        }
    };
    if (Math.clz32) BN.prototype._countBits = function _countBits(w) {
        return 32 - Math.clz32(w);
    };
    else BN.prototype._countBits = function _countBits(w) {
        var t = w;
        var r = 0;
        if (t >= 0x1000) {
            r += 13;
            t >>>= 13;
        }
        if (t >= 0x40) {
            r += 7;
            t >>>= 7;
        }
        if (t >= 0x8) {
            r += 4;
            t >>>= 4;
        }
        if (t >= 0x02) {
            r += 2;
            t >>>= 2;
        }
        return r + t;
    };
    BN.prototype._zeroBits = function _zeroBits(w) {
        // Short-cut
        if (w === 0) return 26;
        var t = w;
        var r = 0;
        if ((t & 0x1fff) === 0) {
            r += 13;
            t >>>= 13;
        }
        if ((t & 0x7f) === 0) {
            r += 7;
            t >>>= 7;
        }
        if ((t & 0xf) === 0) {
            r += 4;
            t >>>= 4;
        }
        if ((t & 0x3) === 0) {
            r += 2;
            t >>>= 2;
        }
        if ((t & 0x1) === 0) r++;
        return r;
    };
    // Return number of used bits in a BN
    BN.prototype.bitLength = function bitLength() {
        var w = this.words[this.length - 1];
        var hi = this._countBits(w);
        return (this.length - 1) * 26 + hi;
    };
    function toBitArray(num) {
        var w = new Array(num.bitLength());
        for(var bit = 0; bit < w.length; bit++){
            var off = bit / 26 | 0;
            var wbit = bit % 26;
            w[bit] = num.words[off] >>> wbit & 0x01;
        }
        return w;
    }
    // Number of trailing zero bits
    BN.prototype.zeroBits = function zeroBits() {
        if (this.isZero()) return 0;
        var r = 0;
        for(var i = 0; i < this.length; i++){
            var b = this._zeroBits(this.words[i]);
            r += b;
            if (b !== 26) break;
        }
        return r;
    };
    BN.prototype.byteLength = function byteLength() {
        return Math.ceil(this.bitLength() / 8);
    };
    BN.prototype.toTwos = function toTwos(width) {
        if (this.negative !== 0) return this.abs().inotn(width).iaddn(1);
        return this.clone();
    };
    BN.prototype.fromTwos = function fromTwos(width) {
        if (this.testn(width - 1)) return this.notn(width).iaddn(1).ineg();
        return this.clone();
    };
    BN.prototype.isNeg = function isNeg() {
        return this.negative !== 0;
    };
    // Return negative clone of `this`
    BN.prototype.neg = function neg() {
        return this.clone().ineg();
    };
    BN.prototype.ineg = function ineg() {
        if (!this.isZero()) this.negative ^= 1;
        return this;
    };
    // Or `num` with `this` in-place
    BN.prototype.iuor = function iuor(num) {
        while(this.length < num.length)this.words[this.length++] = 0;
        for(var i = 0; i < num.length; i++)this.words[i] = this.words[i] | num.words[i];
        return this._strip();
    };
    BN.prototype.ior = function ior(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuor(num);
    };
    // Or `num` with `this`
    BN.prototype.or = function or(num) {
        if (this.length > num.length) return this.clone().ior(num);
        return num.clone().ior(this);
    };
    BN.prototype.uor = function uor(num) {
        if (this.length > num.length) return this.clone().iuor(num);
        return num.clone().iuor(this);
    };
    // And `num` with `this` in-place
    BN.prototype.iuand = function iuand(num) {
        // b = min-length(num, this)
        var b;
        if (this.length > num.length) b = num;
        else b = this;
        for(var i = 0; i < b.length; i++)this.words[i] = this.words[i] & num.words[i];
        this.length = b.length;
        return this._strip();
    };
    BN.prototype.iand = function iand(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuand(num);
    };
    // And `num` with `this`
    BN.prototype.and = function and(num) {
        if (this.length > num.length) return this.clone().iand(num);
        return num.clone().iand(this);
    };
    BN.prototype.uand = function uand(num) {
        if (this.length > num.length) return this.clone().iuand(num);
        return num.clone().iuand(this);
    };
    // Xor `num` with `this` in-place
    BN.prototype.iuxor = function iuxor(num) {
        // a.length > b.length
        var a;
        var b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        for(var i = 0; i < b.length; i++)this.words[i] = a.words[i] ^ b.words[i];
        if (this !== a) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = a.length;
        return this._strip();
    };
    BN.prototype.ixor = function ixor(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuxor(num);
    };
    // Xor `num` with `this`
    BN.prototype.xor = function xor(num) {
        if (this.length > num.length) return this.clone().ixor(num);
        return num.clone().ixor(this);
    };
    BN.prototype.uxor = function uxor(num) {
        if (this.length > num.length) return this.clone().iuxor(num);
        return num.clone().iuxor(this);
    };
    // Not ``this`` with ``width`` bitwidth
    BN.prototype.inotn = function inotn(width) {
        assert(typeof width === "number" && width >= 0);
        var bytesNeeded = Math.ceil(width / 26) | 0;
        var bitsLeft = width % 26;
        // Extend the buffer with leading zeroes
        this._expand(bytesNeeded);
        if (bitsLeft > 0) bytesNeeded--;
        // Handle complete words
        for(var i = 0; i < bytesNeeded; i++)this.words[i] = ~this.words[i] & 0x3ffffff;
        // Handle the residue
        if (bitsLeft > 0) this.words[i] = ~this.words[i] & 0x3ffffff >> 26 - bitsLeft;
        // And remove leading zeroes
        return this._strip();
    };
    BN.prototype.notn = function notn(width) {
        return this.clone().inotn(width);
    };
    // Set `bit` of `this`
    BN.prototype.setn = function setn(bit, val) {
        assert(typeof bit === "number" && bit >= 0);
        var off = bit / 26 | 0;
        var wbit = bit % 26;
        this._expand(off + 1);
        if (val) this.words[off] = this.words[off] | 1 << wbit;
        else this.words[off] = this.words[off] & ~(1 << wbit);
        return this._strip();
    };
    // Add `num` to `this` in-place
    BN.prototype.iadd = function iadd(num) {
        var r;
        // negative + positive
        if (this.negative !== 0 && num.negative === 0) {
            this.negative = 0;
            r = this.isub(num);
            this.negative ^= 1;
            return this._normSign();
        // positive + negative
        } else if (this.negative === 0 && num.negative !== 0) {
            num.negative = 0;
            r = this.isub(num);
            num.negative = 1;
            return r._normSign();
        }
        // a.length > b.length
        var a, b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) + (b.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        this.length = a.length;
        if (carry !== 0) {
            this.words[this.length] = carry;
            this.length++;
        // Copy the rest of the words
        } else if (a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        return this;
    };
    // Add `num` to `this`
    BN.prototype.add = function add(num) {
        var res;
        if (num.negative !== 0 && this.negative === 0) {
            num.negative = 0;
            res = this.sub(num);
            num.negative ^= 1;
            return res;
        } else if (num.negative === 0 && this.negative !== 0) {
            this.negative = 0;
            res = num.sub(this);
            this.negative = 1;
            return res;
        }
        if (this.length > num.length) return this.clone().iadd(num);
        return num.clone().iadd(this);
    };
    // Subtract `num` from `this` in-place
    BN.prototype.isub = function isub(num) {
        // this - (-num) = this + num
        if (num.negative !== 0) {
            num.negative = 0;
            var r = this.iadd(num);
            num.negative = 1;
            return r._normSign();
        // -this - num = -(this + num)
        } else if (this.negative !== 0) {
            this.negative = 0;
            this.iadd(num);
            this.negative = 1;
            return this._normSign();
        }
        // At this point both numbers are positive
        var cmp = this.cmp(num);
        // Optimization - zeroify
        if (cmp === 0) {
            this.negative = 0;
            this.length = 1;
            this.words[0] = 0;
            return this;
        }
        // a > b
        var a, b;
        if (cmp > 0) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) - (b.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        // Copy rest of the words
        if (carry === 0 && i < a.length && a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = Math.max(this.length, i);
        if (a !== this) this.negative = 1;
        return this._strip();
    };
    // Subtract `num` from `this`
    BN.prototype.sub = function sub(num) {
        return this.clone().isub(num);
    };
    function smallMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        var len = self.length + num.length | 0;
        out.length = len;
        len = len - 1 | 0;
        // Peel one iteration (compiler can't do it, because of code complexity)
        var a = self.words[0] | 0;
        var b = num.words[0] | 0;
        var r = a * b;
        var lo = r & 0x3ffffff;
        var carry = r / 0x4000000 | 0;
        out.words[0] = lo;
        for(var k = 1; k < len; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = carry >>> 26;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j | 0;
                a = self.words[i] | 0;
                b = num.words[j] | 0;
                r = a * b + rword;
                ncarry += r / 0x4000000 | 0;
                rword = r & 0x3ffffff;
            }
            out.words[k] = rword | 0;
            carry = ncarry | 0;
        }
        if (carry !== 0) out.words[k] = carry | 0;
        else out.length--;
        return out._strip();
    }
    // TODO(indutny): it may be reasonable to omit it for users who don't need
    // to work with 256-bit numbers, otherwise it gives 20% improvement for 256-bit
    // multiplication (like elliptic secp256k1).
    var comb10MulTo = function comb10MulTo(self, num, out) {
        var a = self.words;
        var b = num.words;
        var o = out.words;
        var c = 0;
        var lo;
        var mid;
        var hi;
        var a0 = a[0] | 0;
        var al0 = a0 & 0x1fff;
        var ah0 = a0 >>> 13;
        var a1 = a[1] | 0;
        var al1 = a1 & 0x1fff;
        var ah1 = a1 >>> 13;
        var a2 = a[2] | 0;
        var al2 = a2 & 0x1fff;
        var ah2 = a2 >>> 13;
        var a3 = a[3] | 0;
        var al3 = a3 & 0x1fff;
        var ah3 = a3 >>> 13;
        var a4 = a[4] | 0;
        var al4 = a4 & 0x1fff;
        var ah4 = a4 >>> 13;
        var a5 = a[5] | 0;
        var al5 = a5 & 0x1fff;
        var ah5 = a5 >>> 13;
        var a6 = a[6] | 0;
        var al6 = a6 & 0x1fff;
        var ah6 = a6 >>> 13;
        var a7 = a[7] | 0;
        var al7 = a7 & 0x1fff;
        var ah7 = a7 >>> 13;
        var a8 = a[8] | 0;
        var al8 = a8 & 0x1fff;
        var ah8 = a8 >>> 13;
        var a9 = a[9] | 0;
        var al9 = a9 & 0x1fff;
        var ah9 = a9 >>> 13;
        var b0 = b[0] | 0;
        var bl0 = b0 & 0x1fff;
        var bh0 = b0 >>> 13;
        var b1 = b[1] | 0;
        var bl1 = b1 & 0x1fff;
        var bh1 = b1 >>> 13;
        var b2 = b[2] | 0;
        var bl2 = b2 & 0x1fff;
        var bh2 = b2 >>> 13;
        var b3 = b[3] | 0;
        var bl3 = b3 & 0x1fff;
        var bh3 = b3 >>> 13;
        var b4 = b[4] | 0;
        var bl4 = b4 & 0x1fff;
        var bh4 = b4 >>> 13;
        var b5 = b[5] | 0;
        var bl5 = b5 & 0x1fff;
        var bh5 = b5 >>> 13;
        var b6 = b[6] | 0;
        var bl6 = b6 & 0x1fff;
        var bh6 = b6 >>> 13;
        var b7 = b[7] | 0;
        var bl7 = b7 & 0x1fff;
        var bh7 = b7 >>> 13;
        var b8 = b[8] | 0;
        var bl8 = b8 & 0x1fff;
        var bh8 = b8 >>> 13;
        var b9 = b[9] | 0;
        var bl9 = b9 & 0x1fff;
        var bh9 = b9 >>> 13;
        out.negative = self.negative ^ num.negative;
        out.length = 19;
        /* k = 0 */ lo = Math.imul(al0, bl0);
        mid = Math.imul(al0, bh0);
        mid = mid + Math.imul(ah0, bl0) | 0;
        hi = Math.imul(ah0, bh0);
        var w0 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w0 >>> 26) | 0;
        w0 &= 0x3ffffff;
        /* k = 1 */ lo = Math.imul(al1, bl0);
        mid = Math.imul(al1, bh0);
        mid = mid + Math.imul(ah1, bl0) | 0;
        hi = Math.imul(ah1, bh0);
        lo = lo + Math.imul(al0, bl1) | 0;
        mid = mid + Math.imul(al0, bh1) | 0;
        mid = mid + Math.imul(ah0, bl1) | 0;
        hi = hi + Math.imul(ah0, bh1) | 0;
        var w1 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w1 >>> 26) | 0;
        w1 &= 0x3ffffff;
        /* k = 2 */ lo = Math.imul(al2, bl0);
        mid = Math.imul(al2, bh0);
        mid = mid + Math.imul(ah2, bl0) | 0;
        hi = Math.imul(ah2, bh0);
        lo = lo + Math.imul(al1, bl1) | 0;
        mid = mid + Math.imul(al1, bh1) | 0;
        mid = mid + Math.imul(ah1, bl1) | 0;
        hi = hi + Math.imul(ah1, bh1) | 0;
        lo = lo + Math.imul(al0, bl2) | 0;
        mid = mid + Math.imul(al0, bh2) | 0;
        mid = mid + Math.imul(ah0, bl2) | 0;
        hi = hi + Math.imul(ah0, bh2) | 0;
        var w2 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w2 >>> 26) | 0;
        w2 &= 0x3ffffff;
        /* k = 3 */ lo = Math.imul(al3, bl0);
        mid = Math.imul(al3, bh0);
        mid = mid + Math.imul(ah3, bl0) | 0;
        hi = Math.imul(ah3, bh0);
        lo = lo + Math.imul(al2, bl1) | 0;
        mid = mid + Math.imul(al2, bh1) | 0;
        mid = mid + Math.imul(ah2, bl1) | 0;
        hi = hi + Math.imul(ah2, bh1) | 0;
        lo = lo + Math.imul(al1, bl2) | 0;
        mid = mid + Math.imul(al1, bh2) | 0;
        mid = mid + Math.imul(ah1, bl2) | 0;
        hi = hi + Math.imul(ah1, bh2) | 0;
        lo = lo + Math.imul(al0, bl3) | 0;
        mid = mid + Math.imul(al0, bh3) | 0;
        mid = mid + Math.imul(ah0, bl3) | 0;
        hi = hi + Math.imul(ah0, bh3) | 0;
        var w3 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w3 >>> 26) | 0;
        w3 &= 0x3ffffff;
        /* k = 4 */ lo = Math.imul(al4, bl0);
        mid = Math.imul(al4, bh0);
        mid = mid + Math.imul(ah4, bl0) | 0;
        hi = Math.imul(ah4, bh0);
        lo = lo + Math.imul(al3, bl1) | 0;
        mid = mid + Math.imul(al3, bh1) | 0;
        mid = mid + Math.imul(ah3, bl1) | 0;
        hi = hi + Math.imul(ah3, bh1) | 0;
        lo = lo + Math.imul(al2, bl2) | 0;
        mid = mid + Math.imul(al2, bh2) | 0;
        mid = mid + Math.imul(ah2, bl2) | 0;
        hi = hi + Math.imul(ah2, bh2) | 0;
        lo = lo + Math.imul(al1, bl3) | 0;
        mid = mid + Math.imul(al1, bh3) | 0;
        mid = mid + Math.imul(ah1, bl3) | 0;
        hi = hi + Math.imul(ah1, bh3) | 0;
        lo = lo + Math.imul(al0, bl4) | 0;
        mid = mid + Math.imul(al0, bh4) | 0;
        mid = mid + Math.imul(ah0, bl4) | 0;
        hi = hi + Math.imul(ah0, bh4) | 0;
        var w4 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w4 >>> 26) | 0;
        w4 &= 0x3ffffff;
        /* k = 5 */ lo = Math.imul(al5, bl0);
        mid = Math.imul(al5, bh0);
        mid = mid + Math.imul(ah5, bl0) | 0;
        hi = Math.imul(ah5, bh0);
        lo = lo + Math.imul(al4, bl1) | 0;
        mid = mid + Math.imul(al4, bh1) | 0;
        mid = mid + Math.imul(ah4, bl1) | 0;
        hi = hi + Math.imul(ah4, bh1) | 0;
        lo = lo + Math.imul(al3, bl2) | 0;
        mid = mid + Math.imul(al3, bh2) | 0;
        mid = mid + Math.imul(ah3, bl2) | 0;
        hi = hi + Math.imul(ah3, bh2) | 0;
        lo = lo + Math.imul(al2, bl3) | 0;
        mid = mid + Math.imul(al2, bh3) | 0;
        mid = mid + Math.imul(ah2, bl3) | 0;
        hi = hi + Math.imul(ah2, bh3) | 0;
        lo = lo + Math.imul(al1, bl4) | 0;
        mid = mid + Math.imul(al1, bh4) | 0;
        mid = mid + Math.imul(ah1, bl4) | 0;
        hi = hi + Math.imul(ah1, bh4) | 0;
        lo = lo + Math.imul(al0, bl5) | 0;
        mid = mid + Math.imul(al0, bh5) | 0;
        mid = mid + Math.imul(ah0, bl5) | 0;
        hi = hi + Math.imul(ah0, bh5) | 0;
        var w5 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w5 >>> 26) | 0;
        w5 &= 0x3ffffff;
        /* k = 6 */ lo = Math.imul(al6, bl0);
        mid = Math.imul(al6, bh0);
        mid = mid + Math.imul(ah6, bl0) | 0;
        hi = Math.imul(ah6, bh0);
        lo = lo + Math.imul(al5, bl1) | 0;
        mid = mid + Math.imul(al5, bh1) | 0;
        mid = mid + Math.imul(ah5, bl1) | 0;
        hi = hi + Math.imul(ah5, bh1) | 0;
        lo = lo + Math.imul(al4, bl2) | 0;
        mid = mid + Math.imul(al4, bh2) | 0;
        mid = mid + Math.imul(ah4, bl2) | 0;
        hi = hi + Math.imul(ah4, bh2) | 0;
        lo = lo + Math.imul(al3, bl3) | 0;
        mid = mid + Math.imul(al3, bh3) | 0;
        mid = mid + Math.imul(ah3, bl3) | 0;
        hi = hi + Math.imul(ah3, bh3) | 0;
        lo = lo + Math.imul(al2, bl4) | 0;
        mid = mid + Math.imul(al2, bh4) | 0;
        mid = mid + Math.imul(ah2, bl4) | 0;
        hi = hi + Math.imul(ah2, bh4) | 0;
        lo = lo + Math.imul(al1, bl5) | 0;
        mid = mid + Math.imul(al1, bh5) | 0;
        mid = mid + Math.imul(ah1, bl5) | 0;
        hi = hi + Math.imul(ah1, bh5) | 0;
        lo = lo + Math.imul(al0, bl6) | 0;
        mid = mid + Math.imul(al0, bh6) | 0;
        mid = mid + Math.imul(ah0, bl6) | 0;
        hi = hi + Math.imul(ah0, bh6) | 0;
        var w6 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w6 >>> 26) | 0;
        w6 &= 0x3ffffff;
        /* k = 7 */ lo = Math.imul(al7, bl0);
        mid = Math.imul(al7, bh0);
        mid = mid + Math.imul(ah7, bl0) | 0;
        hi = Math.imul(ah7, bh0);
        lo = lo + Math.imul(al6, bl1) | 0;
        mid = mid + Math.imul(al6, bh1) | 0;
        mid = mid + Math.imul(ah6, bl1) | 0;
        hi = hi + Math.imul(ah6, bh1) | 0;
        lo = lo + Math.imul(al5, bl2) | 0;
        mid = mid + Math.imul(al5, bh2) | 0;
        mid = mid + Math.imul(ah5, bl2) | 0;
        hi = hi + Math.imul(ah5, bh2) | 0;
        lo = lo + Math.imul(al4, bl3) | 0;
        mid = mid + Math.imul(al4, bh3) | 0;
        mid = mid + Math.imul(ah4, bl3) | 0;
        hi = hi + Math.imul(ah4, bh3) | 0;
        lo = lo + Math.imul(al3, bl4) | 0;
        mid = mid + Math.imul(al3, bh4) | 0;
        mid = mid + Math.imul(ah3, bl4) | 0;
        hi = hi + Math.imul(ah3, bh4) | 0;
        lo = lo + Math.imul(al2, bl5) | 0;
        mid = mid + Math.imul(al2, bh5) | 0;
        mid = mid + Math.imul(ah2, bl5) | 0;
        hi = hi + Math.imul(ah2, bh5) | 0;
        lo = lo + Math.imul(al1, bl6) | 0;
        mid = mid + Math.imul(al1, bh6) | 0;
        mid = mid + Math.imul(ah1, bl6) | 0;
        hi = hi + Math.imul(ah1, bh6) | 0;
        lo = lo + Math.imul(al0, bl7) | 0;
        mid = mid + Math.imul(al0, bh7) | 0;
        mid = mid + Math.imul(ah0, bl7) | 0;
        hi = hi + Math.imul(ah0, bh7) | 0;
        var w7 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w7 >>> 26) | 0;
        w7 &= 0x3ffffff;
        /* k = 8 */ lo = Math.imul(al8, bl0);
        mid = Math.imul(al8, bh0);
        mid = mid + Math.imul(ah8, bl0) | 0;
        hi = Math.imul(ah8, bh0);
        lo = lo + Math.imul(al7, bl1) | 0;
        mid = mid + Math.imul(al7, bh1) | 0;
        mid = mid + Math.imul(ah7, bl1) | 0;
        hi = hi + Math.imul(ah7, bh1) | 0;
        lo = lo + Math.imul(al6, bl2) | 0;
        mid = mid + Math.imul(al6, bh2) | 0;
        mid = mid + Math.imul(ah6, bl2) | 0;
        hi = hi + Math.imul(ah6, bh2) | 0;
        lo = lo + Math.imul(al5, bl3) | 0;
        mid = mid + Math.imul(al5, bh3) | 0;
        mid = mid + Math.imul(ah5, bl3) | 0;
        hi = hi + Math.imul(ah5, bh3) | 0;
        lo = lo + Math.imul(al4, bl4) | 0;
        mid = mid + Math.imul(al4, bh4) | 0;
        mid = mid + Math.imul(ah4, bl4) | 0;
        hi = hi + Math.imul(ah4, bh4) | 0;
        lo = lo + Math.imul(al3, bl5) | 0;
        mid = mid + Math.imul(al3, bh5) | 0;
        mid = mid + Math.imul(ah3, bl5) | 0;
        hi = hi + Math.imul(ah3, bh5) | 0;
        lo = lo + Math.imul(al2, bl6) | 0;
        mid = mid + Math.imul(al2, bh6) | 0;
        mid = mid + Math.imul(ah2, bl6) | 0;
        hi = hi + Math.imul(ah2, bh6) | 0;
        lo = lo + Math.imul(al1, bl7) | 0;
        mid = mid + Math.imul(al1, bh7) | 0;
        mid = mid + Math.imul(ah1, bl7) | 0;
        hi = hi + Math.imul(ah1, bh7) | 0;
        lo = lo + Math.imul(al0, bl8) | 0;
        mid = mid + Math.imul(al0, bh8) | 0;
        mid = mid + Math.imul(ah0, bl8) | 0;
        hi = hi + Math.imul(ah0, bh8) | 0;
        var w8 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w8 >>> 26) | 0;
        w8 &= 0x3ffffff;
        /* k = 9 */ lo = Math.imul(al9, bl0);
        mid = Math.imul(al9, bh0);
        mid = mid + Math.imul(ah9, bl0) | 0;
        hi = Math.imul(ah9, bh0);
        lo = lo + Math.imul(al8, bl1) | 0;
        mid = mid + Math.imul(al8, bh1) | 0;
        mid = mid + Math.imul(ah8, bl1) | 0;
        hi = hi + Math.imul(ah8, bh1) | 0;
        lo = lo + Math.imul(al7, bl2) | 0;
        mid = mid + Math.imul(al7, bh2) | 0;
        mid = mid + Math.imul(ah7, bl2) | 0;
        hi = hi + Math.imul(ah7, bh2) | 0;
        lo = lo + Math.imul(al6, bl3) | 0;
        mid = mid + Math.imul(al6, bh3) | 0;
        mid = mid + Math.imul(ah6, bl3) | 0;
        hi = hi + Math.imul(ah6, bh3) | 0;
        lo = lo + Math.imul(al5, bl4) | 0;
        mid = mid + Math.imul(al5, bh4) | 0;
        mid = mid + Math.imul(ah5, bl4) | 0;
        hi = hi + Math.imul(ah5, bh4) | 0;
        lo = lo + Math.imul(al4, bl5) | 0;
        mid = mid + Math.imul(al4, bh5) | 0;
        mid = mid + Math.imul(ah4, bl5) | 0;
        hi = hi + Math.imul(ah4, bh5) | 0;
        lo = lo + Math.imul(al3, bl6) | 0;
        mid = mid + Math.imul(al3, bh6) | 0;
        mid = mid + Math.imul(ah3, bl6) | 0;
        hi = hi + Math.imul(ah3, bh6) | 0;
        lo = lo + Math.imul(al2, bl7) | 0;
        mid = mid + Math.imul(al2, bh7) | 0;
        mid = mid + Math.imul(ah2, bl7) | 0;
        hi = hi + Math.imul(ah2, bh7) | 0;
        lo = lo + Math.imul(al1, bl8) | 0;
        mid = mid + Math.imul(al1, bh8) | 0;
        mid = mid + Math.imul(ah1, bl8) | 0;
        hi = hi + Math.imul(ah1, bh8) | 0;
        lo = lo + Math.imul(al0, bl9) | 0;
        mid = mid + Math.imul(al0, bh9) | 0;
        mid = mid + Math.imul(ah0, bl9) | 0;
        hi = hi + Math.imul(ah0, bh9) | 0;
        var w9 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w9 >>> 26) | 0;
        w9 &= 0x3ffffff;
        /* k = 10 */ lo = Math.imul(al9, bl1);
        mid = Math.imul(al9, bh1);
        mid = mid + Math.imul(ah9, bl1) | 0;
        hi = Math.imul(ah9, bh1);
        lo = lo + Math.imul(al8, bl2) | 0;
        mid = mid + Math.imul(al8, bh2) | 0;
        mid = mid + Math.imul(ah8, bl2) | 0;
        hi = hi + Math.imul(ah8, bh2) | 0;
        lo = lo + Math.imul(al7, bl3) | 0;
        mid = mid + Math.imul(al7, bh3) | 0;
        mid = mid + Math.imul(ah7, bl3) | 0;
        hi = hi + Math.imul(ah7, bh3) | 0;
        lo = lo + Math.imul(al6, bl4) | 0;
        mid = mid + Math.imul(al6, bh4) | 0;
        mid = mid + Math.imul(ah6, bl4) | 0;
        hi = hi + Math.imul(ah6, bh4) | 0;
        lo = lo + Math.imul(al5, bl5) | 0;
        mid = mid + Math.imul(al5, bh5) | 0;
        mid = mid + Math.imul(ah5, bl5) | 0;
        hi = hi + Math.imul(ah5, bh5) | 0;
        lo = lo + Math.imul(al4, bl6) | 0;
        mid = mid + Math.imul(al4, bh6) | 0;
        mid = mid + Math.imul(ah4, bl6) | 0;
        hi = hi + Math.imul(ah4, bh6) | 0;
        lo = lo + Math.imul(al3, bl7) | 0;
        mid = mid + Math.imul(al3, bh7) | 0;
        mid = mid + Math.imul(ah3, bl7) | 0;
        hi = hi + Math.imul(ah3, bh7) | 0;
        lo = lo + Math.imul(al2, bl8) | 0;
        mid = mid + Math.imul(al2, bh8) | 0;
        mid = mid + Math.imul(ah2, bl8) | 0;
        hi = hi + Math.imul(ah2, bh8) | 0;
        lo = lo + Math.imul(al1, bl9) | 0;
        mid = mid + Math.imul(al1, bh9) | 0;
        mid = mid + Math.imul(ah1, bl9) | 0;
        hi = hi + Math.imul(ah1, bh9) | 0;
        var w10 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w10 >>> 26) | 0;
        w10 &= 0x3ffffff;
        /* k = 11 */ lo = Math.imul(al9, bl2);
        mid = Math.imul(al9, bh2);
        mid = mid + Math.imul(ah9, bl2) | 0;
        hi = Math.imul(ah9, bh2);
        lo = lo + Math.imul(al8, bl3) | 0;
        mid = mid + Math.imul(al8, bh3) | 0;
        mid = mid + Math.imul(ah8, bl3) | 0;
        hi = hi + Math.imul(ah8, bh3) | 0;
        lo = lo + Math.imul(al7, bl4) | 0;
        mid = mid + Math.imul(al7, bh4) | 0;
        mid = mid + Math.imul(ah7, bl4) | 0;
        hi = hi + Math.imul(ah7, bh4) | 0;
        lo = lo + Math.imul(al6, bl5) | 0;
        mid = mid + Math.imul(al6, bh5) | 0;
        mid = mid + Math.imul(ah6, bl5) | 0;
        hi = hi + Math.imul(ah6, bh5) | 0;
        lo = lo + Math.imul(al5, bl6) | 0;
        mid = mid + Math.imul(al5, bh6) | 0;
        mid = mid + Math.imul(ah5, bl6) | 0;
        hi = hi + Math.imul(ah5, bh6) | 0;
        lo = lo + Math.imul(al4, bl7) | 0;
        mid = mid + Math.imul(al4, bh7) | 0;
        mid = mid + Math.imul(ah4, bl7) | 0;
        hi = hi + Math.imul(ah4, bh7) | 0;
        lo = lo + Math.imul(al3, bl8) | 0;
        mid = mid + Math.imul(al3, bh8) | 0;
        mid = mid + Math.imul(ah3, bl8) | 0;
        hi = hi + Math.imul(ah3, bh8) | 0;
        lo = lo + Math.imul(al2, bl9) | 0;
        mid = mid + Math.imul(al2, bh9) | 0;
        mid = mid + Math.imul(ah2, bl9) | 0;
        hi = hi + Math.imul(ah2, bh9) | 0;
        var w11 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w11 >>> 26) | 0;
        w11 &= 0x3ffffff;
        /* k = 12 */ lo = Math.imul(al9, bl3);
        mid = Math.imul(al9, bh3);
        mid = mid + Math.imul(ah9, bl3) | 0;
        hi = Math.imul(ah9, bh3);
        lo = lo + Math.imul(al8, bl4) | 0;
        mid = mid + Math.imul(al8, bh4) | 0;
        mid = mid + Math.imul(ah8, bl4) | 0;
        hi = hi + Math.imul(ah8, bh4) | 0;
        lo = lo + Math.imul(al7, bl5) | 0;
        mid = mid + Math.imul(al7, bh5) | 0;
        mid = mid + Math.imul(ah7, bl5) | 0;
        hi = hi + Math.imul(ah7, bh5) | 0;
        lo = lo + Math.imul(al6, bl6) | 0;
        mid = mid + Math.imul(al6, bh6) | 0;
        mid = mid + Math.imul(ah6, bl6) | 0;
        hi = hi + Math.imul(ah6, bh6) | 0;
        lo = lo + Math.imul(al5, bl7) | 0;
        mid = mid + Math.imul(al5, bh7) | 0;
        mid = mid + Math.imul(ah5, bl7) | 0;
        hi = hi + Math.imul(ah5, bh7) | 0;
        lo = lo + Math.imul(al4, bl8) | 0;
        mid = mid + Math.imul(al4, bh8) | 0;
        mid = mid + Math.imul(ah4, bl8) | 0;
        hi = hi + Math.imul(ah4, bh8) | 0;
        lo = lo + Math.imul(al3, bl9) | 0;
        mid = mid + Math.imul(al3, bh9) | 0;
        mid = mid + Math.imul(ah3, bl9) | 0;
        hi = hi + Math.imul(ah3, bh9) | 0;
        var w12 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w12 >>> 26) | 0;
        w12 &= 0x3ffffff;
        /* k = 13 */ lo = Math.imul(al9, bl4);
        mid = Math.imul(al9, bh4);
        mid = mid + Math.imul(ah9, bl4) | 0;
        hi = Math.imul(ah9, bh4);
        lo = lo + Math.imul(al8, bl5) | 0;
        mid = mid + Math.imul(al8, bh5) | 0;
        mid = mid + Math.imul(ah8, bl5) | 0;
        hi = hi + Math.imul(ah8, bh5) | 0;
        lo = lo + Math.imul(al7, bl6) | 0;
        mid = mid + Math.imul(al7, bh6) | 0;
        mid = mid + Math.imul(ah7, bl6) | 0;
        hi = hi + Math.imul(ah7, bh6) | 0;
        lo = lo + Math.imul(al6, bl7) | 0;
        mid = mid + Math.imul(al6, bh7) | 0;
        mid = mid + Math.imul(ah6, bl7) | 0;
        hi = hi + Math.imul(ah6, bh7) | 0;
        lo = lo + Math.imul(al5, bl8) | 0;
        mid = mid + Math.imul(al5, bh8) | 0;
        mid = mid + Math.imul(ah5, bl8) | 0;
        hi = hi + Math.imul(ah5, bh8) | 0;
        lo = lo + Math.imul(al4, bl9) | 0;
        mid = mid + Math.imul(al4, bh9) | 0;
        mid = mid + Math.imul(ah4, bl9) | 0;
        hi = hi + Math.imul(ah4, bh9) | 0;
        var w13 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w13 >>> 26) | 0;
        w13 &= 0x3ffffff;
        /* k = 14 */ lo = Math.imul(al9, bl5);
        mid = Math.imul(al9, bh5);
        mid = mid + Math.imul(ah9, bl5) | 0;
        hi = Math.imul(ah9, bh5);
        lo = lo + Math.imul(al8, bl6) | 0;
        mid = mid + Math.imul(al8, bh6) | 0;
        mid = mid + Math.imul(ah8, bl6) | 0;
        hi = hi + Math.imul(ah8, bh6) | 0;
        lo = lo + Math.imul(al7, bl7) | 0;
        mid = mid + Math.imul(al7, bh7) | 0;
        mid = mid + Math.imul(ah7, bl7) | 0;
        hi = hi + Math.imul(ah7, bh7) | 0;
        lo = lo + Math.imul(al6, bl8) | 0;
        mid = mid + Math.imul(al6, bh8) | 0;
        mid = mid + Math.imul(ah6, bl8) | 0;
        hi = hi + Math.imul(ah6, bh8) | 0;
        lo = lo + Math.imul(al5, bl9) | 0;
        mid = mid + Math.imul(al5, bh9) | 0;
        mid = mid + Math.imul(ah5, bl9) | 0;
        hi = hi + Math.imul(ah5, bh9) | 0;
        var w14 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w14 >>> 26) | 0;
        w14 &= 0x3ffffff;
        /* k = 15 */ lo = Math.imul(al9, bl6);
        mid = Math.imul(al9, bh6);
        mid = mid + Math.imul(ah9, bl6) | 0;
        hi = Math.imul(ah9, bh6);
        lo = lo + Math.imul(al8, bl7) | 0;
        mid = mid + Math.imul(al8, bh7) | 0;
        mid = mid + Math.imul(ah8, bl7) | 0;
        hi = hi + Math.imul(ah8, bh7) | 0;
        lo = lo + Math.imul(al7, bl8) | 0;
        mid = mid + Math.imul(al7, bh8) | 0;
        mid = mid + Math.imul(ah7, bl8) | 0;
        hi = hi + Math.imul(ah7, bh8) | 0;
        lo = lo + Math.imul(al6, bl9) | 0;
        mid = mid + Math.imul(al6, bh9) | 0;
        mid = mid + Math.imul(ah6, bl9) | 0;
        hi = hi + Math.imul(ah6, bh9) | 0;
        var w15 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w15 >>> 26) | 0;
        w15 &= 0x3ffffff;
        /* k = 16 */ lo = Math.imul(al9, bl7);
        mid = Math.imul(al9, bh7);
        mid = mid + Math.imul(ah9, bl7) | 0;
        hi = Math.imul(ah9, bh7);
        lo = lo + Math.imul(al8, bl8) | 0;
        mid = mid + Math.imul(al8, bh8) | 0;
        mid = mid + Math.imul(ah8, bl8) | 0;
        hi = hi + Math.imul(ah8, bh8) | 0;
        lo = lo + Math.imul(al7, bl9) | 0;
        mid = mid + Math.imul(al7, bh9) | 0;
        mid = mid + Math.imul(ah7, bl9) | 0;
        hi = hi + Math.imul(ah7, bh9) | 0;
        var w16 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w16 >>> 26) | 0;
        w16 &= 0x3ffffff;
        /* k = 17 */ lo = Math.imul(al9, bl8);
        mid = Math.imul(al9, bh8);
        mid = mid + Math.imul(ah9, bl8) | 0;
        hi = Math.imul(ah9, bh8);
        lo = lo + Math.imul(al8, bl9) | 0;
        mid = mid + Math.imul(al8, bh9) | 0;
        mid = mid + Math.imul(ah8, bl9) | 0;
        hi = hi + Math.imul(ah8, bh9) | 0;
        var w17 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w17 >>> 26) | 0;
        w17 &= 0x3ffffff;
        /* k = 18 */ lo = Math.imul(al9, bl9);
        mid = Math.imul(al9, bh9);
        mid = mid + Math.imul(ah9, bl9) | 0;
        hi = Math.imul(ah9, bh9);
        var w18 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w18 >>> 26) | 0;
        w18 &= 0x3ffffff;
        o[0] = w0;
        o[1] = w1;
        o[2] = w2;
        o[3] = w3;
        o[4] = w4;
        o[5] = w5;
        o[6] = w6;
        o[7] = w7;
        o[8] = w8;
        o[9] = w9;
        o[10] = w10;
        o[11] = w11;
        o[12] = w12;
        o[13] = w13;
        o[14] = w14;
        o[15] = w15;
        o[16] = w16;
        o[17] = w17;
        o[18] = w18;
        if (c !== 0) {
            o[19] = c;
            out.length++;
        }
        return out;
    };
    // Polyfill comb
    if (!Math.imul) comb10MulTo = smallMulTo;
    function bigMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        out.length = self.length + num.length;
        var carry = 0;
        var hncarry = 0;
        for(var k = 0; k < out.length - 1; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = hncarry;
            hncarry = 0;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j;
                var a = self.words[i] | 0;
                var b = num.words[j] | 0;
                var r = a * b;
                var lo = r & 0x3ffffff;
                ncarry = ncarry + (r / 0x4000000 | 0) | 0;
                lo = lo + rword | 0;
                rword = lo & 0x3ffffff;
                ncarry = ncarry + (lo >>> 26) | 0;
                hncarry += ncarry >>> 26;
                ncarry &= 0x3ffffff;
            }
            out.words[k] = rword;
            carry = ncarry;
            ncarry = hncarry;
        }
        if (carry !== 0) out.words[k] = carry;
        else out.length--;
        return out._strip();
    }
    function jumboMulTo(self, num, out) {
        // Temporary disable, see https://github.com/indutny/bn.js/issues/211
        // var fftm = new FFTM();
        // return fftm.mulp(self, num, out);
        return bigMulTo(self, num, out);
    }
    BN.prototype.mulTo = function mulTo(num, out) {
        var res;
        var len = this.length + num.length;
        if (this.length === 10 && num.length === 10) res = comb10MulTo(this, num, out);
        else if (len < 63) res = smallMulTo(this, num, out);
        else if (len < 1024) res = bigMulTo(this, num, out);
        else res = jumboMulTo(this, num, out);
        return res;
    };
    // Cooley-Tukey algorithm for FFT
    // slightly revisited to rely on looping instead of recursion
    function FFTM(x, y) {
        this.x = x;
        this.y = y;
    }
    FFTM.prototype.makeRBT = function makeRBT(N) {
        var t = new Array(N);
        var l = BN.prototype._countBits(N) - 1;
        for(var i = 0; i < N; i++)t[i] = this.revBin(i, l, N);
        return t;
    };
    // Returns binary-reversed representation of `x`
    FFTM.prototype.revBin = function revBin(x, l, N) {
        if (x === 0 || x === N - 1) return x;
        var rb = 0;
        for(var i = 0; i < l; i++){
            rb |= (x & 1) << l - i - 1;
            x >>= 1;
        }
        return rb;
    };
    // Performs "tweedling" phase, therefore 'emulating'
    // behaviour of the recursive algorithm
    FFTM.prototype.permute = function permute(rbt, rws, iws, rtws, itws, N) {
        for(var i = 0; i < N; i++){
            rtws[i] = rws[rbt[i]];
            itws[i] = iws[rbt[i]];
        }
    };
    FFTM.prototype.transform = function transform(rws, iws, rtws, itws, N, rbt) {
        this.permute(rbt, rws, iws, rtws, itws, N);
        for(var s = 1; s < N; s <<= 1){
            var l = s << 1;
            var rtwdf = Math.cos(2 * Math.PI / l);
            var itwdf = Math.sin(2 * Math.PI / l);
            for(var p = 0; p < N; p += l){
                var rtwdf_ = rtwdf;
                var itwdf_ = itwdf;
                for(var j = 0; j < s; j++){
                    var re = rtws[p + j];
                    var ie = itws[p + j];
                    var ro = rtws[p + j + s];
                    var io = itws[p + j + s];
                    var rx = rtwdf_ * ro - itwdf_ * io;
                    io = rtwdf_ * io + itwdf_ * ro;
                    ro = rx;
                    rtws[p + j] = re + ro;
                    itws[p + j] = ie + io;
                    rtws[p + j + s] = re - ro;
                    itws[p + j + s] = ie - io;
                    /* jshint maxdepth : false */ if (j !== l) {
                        rx = rtwdf * rtwdf_ - itwdf * itwdf_;
                        itwdf_ = rtwdf * itwdf_ + itwdf * rtwdf_;
                        rtwdf_ = rx;
                    }
                }
            }
        }
    };
    FFTM.prototype.guessLen13b = function guessLen13b(n, m) {
        var N = Math.max(m, n) | 1;
        var odd = N & 1;
        var i = 0;
        for(N = N / 2 | 0; N; N = N >>> 1)i++;
        return 1 << i + 1 + odd;
    };
    FFTM.prototype.conjugate = function conjugate(rws, iws, N) {
        if (N <= 1) return;
        for(var i = 0; i < N / 2; i++){
            var t = rws[i];
            rws[i] = rws[N - i - 1];
            rws[N - i - 1] = t;
            t = iws[i];
            iws[i] = -iws[N - i - 1];
            iws[N - i - 1] = -t;
        }
    };
    FFTM.prototype.normalize13b = function normalize13b(ws, N) {
        var carry = 0;
        for(var i = 0; i < N / 2; i++){
            var w = Math.round(ws[2 * i + 1] / N) * 0x2000 + Math.round(ws[2 * i] / N) + carry;
            ws[i] = w & 0x3ffffff;
            if (w < 0x4000000) carry = 0;
            else carry = w / 0x4000000 | 0;
        }
        return ws;
    };
    FFTM.prototype.convert13b = function convert13b(ws, len, rws, N) {
        var carry = 0;
        for(var i = 0; i < len; i++){
            carry = carry + (ws[i] | 0);
            rws[2 * i] = carry & 0x1fff;
            carry = carry >>> 13;
            rws[2 * i + 1] = carry & 0x1fff;
            carry = carry >>> 13;
        }
        // Pad with zeroes
        for(i = 2 * len; i < N; ++i)rws[i] = 0;
        assert(carry === 0);
        assert((carry & -8192) === 0);
    };
    FFTM.prototype.stub = function stub(N) {
        var ph = new Array(N);
        for(var i = 0; i < N; i++)ph[i] = 0;
        return ph;
    };
    FFTM.prototype.mulp = function mulp(x, y, out) {
        var N = 2 * this.guessLen13b(x.length, y.length);
        var rbt = this.makeRBT(N);
        var _ = this.stub(N);
        var rws = new Array(N);
        var rwst = new Array(N);
        var iwst = new Array(N);
        var nrws = new Array(N);
        var nrwst = new Array(N);
        var niwst = new Array(N);
        var rmws = out.words;
        rmws.length = N;
        this.convert13b(x.words, x.length, rws, N);
        this.convert13b(y.words, y.length, nrws, N);
        this.transform(rws, _, rwst, iwst, N, rbt);
        this.transform(nrws, _, nrwst, niwst, N, rbt);
        for(var i = 0; i < N; i++){
            var rx = rwst[i] * nrwst[i] - iwst[i] * niwst[i];
            iwst[i] = rwst[i] * niwst[i] + iwst[i] * nrwst[i];
            rwst[i] = rx;
        }
        this.conjugate(rwst, iwst, N);
        this.transform(rwst, iwst, rmws, _, N, rbt);
        this.conjugate(rmws, _, N);
        this.normalize13b(rmws, N);
        out.negative = x.negative ^ y.negative;
        out.length = x.length + y.length;
        return out._strip();
    };
    // Multiply `this` by `num`
    BN.prototype.mul = function mul(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return this.mulTo(num, out);
    };
    // Multiply employing FFT
    BN.prototype.mulf = function mulf(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return jumboMulTo(this, num, out);
    };
    // In-place Multiplication
    BN.prototype.imul = function imul(num) {
        return this.clone().mulTo(num, this);
    };
    BN.prototype.imuln = function imuln(num) {
        var isNegNum = num < 0;
        if (isNegNum) num = -num;
        assert(typeof num === "number");
        assert(num < 0x4000000);
        // Carry
        var carry = 0;
        for(var i = 0; i < this.length; i++){
            var w = (this.words[i] | 0) * num;
            var lo = (w & 0x3ffffff) + (carry & 0x3ffffff);
            carry >>= 26;
            carry += w / 0x4000000 | 0;
            // NOTE: lo is 27bit maximum
            carry += lo >>> 26;
            this.words[i] = lo & 0x3ffffff;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return isNegNum ? this.ineg() : this;
    };
    BN.prototype.muln = function muln(num) {
        return this.clone().imuln(num);
    };
    // `this` * `this`
    BN.prototype.sqr = function sqr() {
        return this.mul(this);
    };
    // `this` * `this` in-place
    BN.prototype.isqr = function isqr() {
        return this.imul(this.clone());
    };
    // Math.pow(`this`, `num`)
    BN.prototype.pow = function pow(num) {
        var w = toBitArray(num);
        if (w.length === 0) return new BN(1);
        // Skip leading zeroes
        var res = this;
        for(var i = 0; i < w.length; i++, res = res.sqr()){
            if (w[i] !== 0) break;
        }
        if (++i < w.length) for(var q = res.sqr(); i < w.length; i++, q = q.sqr()){
            if (w[i] === 0) continue;
            res = res.mul(q);
        }
        return res;
    };
    // Shift-left in-place
    BN.prototype.iushln = function iushln(bits) {
        assert(typeof bits === "number" && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        var carryMask = 0x3ffffff >>> 26 - r << 26 - r;
        var i;
        if (r !== 0) {
            var carry = 0;
            for(i = 0; i < this.length; i++){
                var newCarry = this.words[i] & carryMask;
                var c = (this.words[i] | 0) - newCarry << r;
                this.words[i] = c | carry;
                carry = newCarry >>> 26 - r;
            }
            if (carry) {
                this.words[i] = carry;
                this.length++;
            }
        }
        if (s !== 0) {
            for(i = this.length - 1; i >= 0; i--)this.words[i + s] = this.words[i];
            for(i = 0; i < s; i++)this.words[i] = 0;
            this.length += s;
        }
        return this._strip();
    };
    BN.prototype.ishln = function ishln(bits) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushln(bits);
    };
    // Shift-right in-place
    // NOTE: `hint` is a lowest bit before trailing zeroes
    // NOTE: if `extended` is present - it will be filled with destroyed bits
    BN.prototype.iushrn = function iushrn(bits, hint, extended) {
        assert(typeof bits === "number" && bits >= 0);
        var h;
        if (hint) h = (hint - hint % 26) / 26;
        else h = 0;
        var r = bits % 26;
        var s = Math.min((bits - r) / 26, this.length);
        var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
        var maskedWords = extended;
        h -= s;
        h = Math.max(0, h);
        // Extended mode, copy masked part
        if (maskedWords) {
            for(var i = 0; i < s; i++)maskedWords.words[i] = this.words[i];
            maskedWords.length = s;
        }
        if (s === 0) ;
        else if (this.length > s) {
            this.length -= s;
            for(i = 0; i < this.length; i++)this.words[i] = this.words[i + s];
        } else {
            this.words[0] = 0;
            this.length = 1;
        }
        var carry = 0;
        for(i = this.length - 1; i >= 0 && (carry !== 0 || i >= h); i--){
            var word = this.words[i] | 0;
            this.words[i] = carry << 26 - r | word >>> r;
            carry = word & mask;
        }
        // Push carried bits as a mask
        if (maskedWords && carry !== 0) maskedWords.words[maskedWords.length++] = carry;
        if (this.length === 0) {
            this.words[0] = 0;
            this.length = 1;
        }
        return this._strip();
    };
    BN.prototype.ishrn = function ishrn(bits, hint, extended) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushrn(bits, hint, extended);
    };
    // Shift-left
    BN.prototype.shln = function shln(bits) {
        return this.clone().ishln(bits);
    };
    BN.prototype.ushln = function ushln(bits) {
        return this.clone().iushln(bits);
    };
    // Shift-right
    BN.prototype.shrn = function shrn(bits) {
        return this.clone().ishrn(bits);
    };
    BN.prototype.ushrn = function ushrn(bits) {
        return this.clone().iushrn(bits);
    };
    // Test if n bit is set
    BN.prototype.testn = function testn(bit) {
        assert(typeof bit === "number" && bit >= 0);
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) return false;
        // Check bit and return
        var w = this.words[s];
        return !!(w & q);
    };
    // Return only lowers bits of number (in-place)
    BN.prototype.imaskn = function imaskn(bits) {
        assert(typeof bits === "number" && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        assert(this.negative === 0, "imaskn works only with positive numbers");
        if (this.length <= s) return this;
        if (r !== 0) s++;
        this.length = Math.min(s, this.length);
        if (r !== 0) {
            var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
            this.words[this.length - 1] &= mask;
        }
        return this._strip();
    };
    // Return only lowers bits of number
    BN.prototype.maskn = function maskn(bits) {
        return this.clone().imaskn(bits);
    };
    // Add plain number `num` to `this`
    BN.prototype.iaddn = function iaddn(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        if (num < 0) return this.isubn(-num);
        // Possible sign change
        if (this.negative !== 0) {
            if (this.length === 1 && (this.words[0] | 0) <= num) {
                this.words[0] = num - (this.words[0] | 0);
                this.negative = 0;
                return this;
            }
            this.negative = 0;
            this.isubn(num);
            this.negative = 1;
            return this;
        }
        // Add without checks
        return this._iaddn(num);
    };
    BN.prototype._iaddn = function _iaddn(num) {
        this.words[0] += num;
        // Carry
        for(var i = 0; i < this.length && this.words[i] >= 0x4000000; i++){
            this.words[i] -= 0x4000000;
            if (i === this.length - 1) this.words[i + 1] = 1;
            else this.words[i + 1]++;
        }
        this.length = Math.max(this.length, i + 1);
        return this;
    };
    // Subtract plain number `num` from `this`
    BN.prototype.isubn = function isubn(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        if (num < 0) return this.iaddn(-num);
        if (this.negative !== 0) {
            this.negative = 0;
            this.iaddn(num);
            this.negative = 1;
            return this;
        }
        this.words[0] -= num;
        if (this.length === 1 && this.words[0] < 0) {
            this.words[0] = -this.words[0];
            this.negative = 1;
        } else // Carry
        for(var i = 0; i < this.length && this.words[i] < 0; i++){
            this.words[i] += 0x4000000;
            this.words[i + 1] -= 1;
        }
        return this._strip();
    };
    BN.prototype.addn = function addn(num) {
        return this.clone().iaddn(num);
    };
    BN.prototype.subn = function subn(num) {
        return this.clone().isubn(num);
    };
    BN.prototype.iabs = function iabs() {
        this.negative = 0;
        return this;
    };
    BN.prototype.abs = function abs() {
        return this.clone().iabs();
    };
    BN.prototype._ishlnsubmul = function _ishlnsubmul(num, mul, shift) {
        var len = num.length + shift;
        var i;
        this._expand(len);
        var w;
        var carry = 0;
        for(i = 0; i < num.length; i++){
            w = (this.words[i + shift] | 0) + carry;
            var right = (num.words[i] | 0) * mul;
            w -= right & 0x3ffffff;
            carry = (w >> 26) - (right / 0x4000000 | 0);
            this.words[i + shift] = w & 0x3ffffff;
        }
        for(; i < this.length - shift; i++){
            w = (this.words[i + shift] | 0) + carry;
            carry = w >> 26;
            this.words[i + shift] = w & 0x3ffffff;
        }
        if (carry === 0) return this._strip();
        // Subtraction overflow
        assert(carry === -1);
        carry = 0;
        for(i = 0; i < this.length; i++){
            w = -(this.words[i] | 0) + carry;
            carry = w >> 26;
            this.words[i] = w & 0x3ffffff;
        }
        this.negative = 1;
        return this._strip();
    };
    BN.prototype._wordDiv = function _wordDiv(num, mode) {
        var shift = this.length - num.length;
        var a = this.clone();
        var b = num;
        // Normalize
        var bhi = b.words[b.length - 1] | 0;
        var bhiBits = this._countBits(bhi);
        shift = 26 - bhiBits;
        if (shift !== 0) {
            b = b.ushln(shift);
            a.iushln(shift);
            bhi = b.words[b.length - 1] | 0;
        }
        // Initialize quotient
        var m = a.length - b.length;
        var q;
        if (mode !== "mod") {
            q = new BN(null);
            q.length = m + 1;
            q.words = new Array(q.length);
            for(var i = 0; i < q.length; i++)q.words[i] = 0;
        }
        var diff = a.clone()._ishlnsubmul(b, 1, m);
        if (diff.negative === 0) {
            a = diff;
            if (q) q.words[m] = 1;
        }
        for(var j = m - 1; j >= 0; j--){
            var qj = (a.words[b.length + j] | 0) * 0x4000000 + (a.words[b.length + j - 1] | 0);
            // NOTE: (qj / bhi) is (0x3ffffff * 0x4000000 + 0x3ffffff) / 0x2000000 max
            // (0x7ffffff)
            qj = Math.min(qj / bhi | 0, 0x3ffffff);
            a._ishlnsubmul(b, qj, j);
            while(a.negative !== 0){
                qj--;
                a.negative = 0;
                a._ishlnsubmul(b, 1, j);
                if (!a.isZero()) a.negative ^= 1;
            }
            if (q) q.words[j] = qj;
        }
        if (q) q._strip();
        a._strip();
        // Denormalize
        if (mode !== "div" && shift !== 0) a.iushrn(shift);
        return {
            div: q || null,
            mod: a
        };
    };
    // NOTE: 1) `mode` can be set to `mod` to request mod only,
    //       to `div` to request div only, or be absent to
    //       request both div & mod
    //       2) `positive` is true if unsigned mod is requested
    BN.prototype.divmod = function divmod(num, mode, positive) {
        assert(!num.isZero());
        if (this.isZero()) return {
            div: new BN(0),
            mod: new BN(0)
        };
        var div, mod, res;
        if (this.negative !== 0 && num.negative === 0) {
            res = this.neg().divmod(num, mode);
            if (mode !== "mod") div = res.div.neg();
            if (mode !== "div") {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.iadd(num);
            }
            return {
                div: div,
                mod: mod
            };
        }
        if (this.negative === 0 && num.negative !== 0) {
            res = this.divmod(num.neg(), mode);
            if (mode !== "mod") div = res.div.neg();
            return {
                div: div,
                mod: res.mod
            };
        }
        if ((this.negative & num.negative) !== 0) {
            res = this.neg().divmod(num.neg(), mode);
            if (mode !== "div") {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.isub(num);
            }
            return {
                div: res.div,
                mod: mod
            };
        }
        // Both numbers are positive at this point
        // Strip both numbers to approximate shift value
        if (num.length > this.length || this.cmp(num) < 0) return {
            div: new BN(0),
            mod: this
        };
        // Very short reduction
        if (num.length === 1) {
            if (mode === "div") return {
                div: this.divn(num.words[0]),
                mod: null
            };
            if (mode === "mod") return {
                div: null,
                mod: new BN(this.modrn(num.words[0]))
            };
            return {
                div: this.divn(num.words[0]),
                mod: new BN(this.modrn(num.words[0]))
            };
        }
        return this._wordDiv(num, mode);
    };
    // Find `this` / `num`
    BN.prototype.div = function div(num) {
        return this.divmod(num, "div", false).div;
    };
    // Find `this` % `num`
    BN.prototype.mod = function mod(num) {
        return this.divmod(num, "mod", false).mod;
    };
    BN.prototype.umod = function umod(num) {
        return this.divmod(num, "mod", true).mod;
    };
    // Find Round(`this` / `num`)
    BN.prototype.divRound = function divRound(num) {
        var dm = this.divmod(num);
        // Fast case - exact division
        if (dm.mod.isZero()) return dm.div;
        var mod = dm.div.negative !== 0 ? dm.mod.isub(num) : dm.mod;
        var half = num.ushrn(1);
        var r2 = num.andln(1);
        var cmp = mod.cmp(half);
        // Round down
        if (cmp < 0 || r2 === 1 && cmp === 0) return dm.div;
        // Round up
        return dm.div.negative !== 0 ? dm.div.isubn(1) : dm.div.iaddn(1);
    };
    BN.prototype.modrn = function modrn(num) {
        var isNegNum = num < 0;
        if (isNegNum) num = -num;
        assert(num <= 0x3ffffff);
        var p = 67108864 % num;
        var acc = 0;
        for(var i = this.length - 1; i >= 0; i--)acc = (p * acc + (this.words[i] | 0)) % num;
        return isNegNum ? -acc : acc;
    };
    // WARNING: DEPRECATED
    BN.prototype.modn = function modn(num) {
        return this.modrn(num);
    };
    // In-place division by number
    BN.prototype.idivn = function idivn(num) {
        var isNegNum = num < 0;
        if (isNegNum) num = -num;
        assert(num <= 0x3ffffff);
        var carry = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var w = (this.words[i] | 0) + carry * 0x4000000;
            this.words[i] = w / num | 0;
            carry = w % num;
        }
        this._strip();
        return isNegNum ? this.ineg() : this;
    };
    BN.prototype.divn = function divn(num) {
        return this.clone().idivn(num);
    };
    BN.prototype.egcd = function egcd(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var x = this;
        var y = p.clone();
        if (x.negative !== 0) x = x.umod(p);
        else x = x.clone();
        // A * x + B * y = x
        var A = new BN(1);
        var B = new BN(0);
        // C * x + D * y = y
        var C = new BN(0);
        var D = new BN(1);
        var g = 0;
        while(x.isEven() && y.isEven()){
            x.iushrn(1);
            y.iushrn(1);
            ++g;
        }
        var yp = y.clone();
        var xp = x.clone();
        while(!x.isZero()){
            for(var i = 0, im = 1; (x.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                x.iushrn(i);
                while(i-- > 0){
                    if (A.isOdd() || B.isOdd()) {
                        A.iadd(yp);
                        B.isub(xp);
                    }
                    A.iushrn(1);
                    B.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (y.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                y.iushrn(j);
                while(j-- > 0){
                    if (C.isOdd() || D.isOdd()) {
                        C.iadd(yp);
                        D.isub(xp);
                    }
                    C.iushrn(1);
                    D.iushrn(1);
                }
            }
            if (x.cmp(y) >= 0) {
                x.isub(y);
                A.isub(C);
                B.isub(D);
            } else {
                y.isub(x);
                C.isub(A);
                D.isub(B);
            }
        }
        return {
            a: C,
            b: D,
            gcd: y.iushln(g)
        };
    };
    // This is reduced incarnation of the binary EEA
    // above, designated to invert members of the
    // _prime_ fields F(p) at a maximal speed
    BN.prototype._invmp = function _invmp(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var a = this;
        var b = p.clone();
        if (a.negative !== 0) a = a.umod(p);
        else a = a.clone();
        var x1 = new BN(1);
        var x2 = new BN(0);
        var delta = b.clone();
        while(a.cmpn(1) > 0 && b.cmpn(1) > 0){
            for(var i = 0, im = 1; (a.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                a.iushrn(i);
                while(i-- > 0){
                    if (x1.isOdd()) x1.iadd(delta);
                    x1.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (b.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                b.iushrn(j);
                while(j-- > 0){
                    if (x2.isOdd()) x2.iadd(delta);
                    x2.iushrn(1);
                }
            }
            if (a.cmp(b) >= 0) {
                a.isub(b);
                x1.isub(x2);
            } else {
                b.isub(a);
                x2.isub(x1);
            }
        }
        var res;
        if (a.cmpn(1) === 0) res = x1;
        else res = x2;
        if (res.cmpn(0) < 0) res.iadd(p);
        return res;
    };
    BN.prototype.gcd = function gcd(num) {
        if (this.isZero()) return num.abs();
        if (num.isZero()) return this.abs();
        var a = this.clone();
        var b = num.clone();
        a.negative = 0;
        b.negative = 0;
        // Remove common factor of two
        for(var shift = 0; a.isEven() && b.isEven(); shift++){
            a.iushrn(1);
            b.iushrn(1);
        }
        do {
            while(a.isEven())a.iushrn(1);
            while(b.isEven())b.iushrn(1);
            var r = a.cmp(b);
            if (r < 0) {
                // Swap `a` and `b` to make `a` always bigger than `b`
                var t = a;
                a = b;
                b = t;
            } else if (r === 0 || b.cmpn(1) === 0) break;
            a.isub(b);
        }while (true);
        return b.iushln(shift);
    };
    // Invert number in the field F(num)
    BN.prototype.invm = function invm(num) {
        return this.egcd(num).a.umod(num);
    };
    BN.prototype.isEven = function isEven() {
        return (this.words[0] & 1) === 0;
    };
    BN.prototype.isOdd = function isOdd() {
        return (this.words[0] & 1) === 1;
    };
    // And first word and num
    BN.prototype.andln = function andln(num) {
        return this.words[0] & num;
    };
    // Increment at the bit position in-line
    BN.prototype.bincn = function bincn(bit) {
        assert(typeof bit === "number");
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) {
            this._expand(s + 1);
            this.words[s] |= q;
            return this;
        }
        // Add bit and propagate, if needed
        var carry = q;
        for(var i = s; carry !== 0 && i < this.length; i++){
            var w = this.words[i] | 0;
            w += carry;
            carry = w >>> 26;
            w &= 0x3ffffff;
            this.words[i] = w;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return this;
    };
    BN.prototype.isZero = function isZero() {
        return this.length === 1 && this.words[0] === 0;
    };
    BN.prototype.cmpn = function cmpn(num) {
        var negative = num < 0;
        if (this.negative !== 0 && !negative) return -1;
        if (this.negative === 0 && negative) return 1;
        this._strip();
        var res;
        if (this.length > 1) res = 1;
        else {
            if (negative) num = -num;
            assert(num <= 0x3ffffff, "Number is too big");
            var w = this.words[0] | 0;
            res = w === num ? 0 : w < num ? -1 : 1;
        }
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Compare two numbers and return:
    // 1 - if `this` > `num`
    // 0 - if `this` == `num`
    // -1 - if `this` < `num`
    BN.prototype.cmp = function cmp(num) {
        if (this.negative !== 0 && num.negative === 0) return -1;
        if (this.negative === 0 && num.negative !== 0) return 1;
        var res = this.ucmp(num);
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Unsigned comparison
    BN.prototype.ucmp = function ucmp(num) {
        // At this point both numbers have the same sign
        if (this.length > num.length) return 1;
        if (this.length < num.length) return -1;
        var res = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var a = this.words[i] | 0;
            var b = num.words[i] | 0;
            if (a === b) continue;
            if (a < b) res = -1;
            else if (a > b) res = 1;
            break;
        }
        return res;
    };
    BN.prototype.gtn = function gtn(num) {
        return this.cmpn(num) === 1;
    };
    BN.prototype.gt = function gt(num) {
        return this.cmp(num) === 1;
    };
    BN.prototype.gten = function gten(num) {
        return this.cmpn(num) >= 0;
    };
    BN.prototype.gte = function gte(num) {
        return this.cmp(num) >= 0;
    };
    BN.prototype.ltn = function ltn(num) {
        return this.cmpn(num) === -1;
    };
    BN.prototype.lt = function lt(num) {
        return this.cmp(num) === -1;
    };
    BN.prototype.lten = function lten(num) {
        return this.cmpn(num) <= 0;
    };
    BN.prototype.lte = function lte(num) {
        return this.cmp(num) <= 0;
    };
    BN.prototype.eqn = function eqn(num) {
        return this.cmpn(num) === 0;
    };
    BN.prototype.eq = function eq(num) {
        return this.cmp(num) === 0;
    };
    //
    // A reduce context, could be using montgomery or something better, depending
    // on the `m` itself.
    //
    BN.red = function red(num) {
        return new Red(num);
    };
    BN.prototype.toRed = function toRed(ctx) {
        assert(!this.red, "Already a number in reduction context");
        assert(this.negative === 0, "red works only with positives");
        return ctx.convertTo(this)._forceRed(ctx);
    };
    BN.prototype.fromRed = function fromRed() {
        assert(this.red, "fromRed works only with numbers in reduction context");
        return this.red.convertFrom(this);
    };
    BN.prototype._forceRed = function _forceRed(ctx) {
        this.red = ctx;
        return this;
    };
    BN.prototype.forceRed = function forceRed(ctx) {
        assert(!this.red, "Already a number in reduction context");
        return this._forceRed(ctx);
    };
    BN.prototype.redAdd = function redAdd(num) {
        assert(this.red, "redAdd works only with red numbers");
        return this.red.add(this, num);
    };
    BN.prototype.redIAdd = function redIAdd(num) {
        assert(this.red, "redIAdd works only with red numbers");
        return this.red.iadd(this, num);
    };
    BN.prototype.redSub = function redSub(num) {
        assert(this.red, "redSub works only with red numbers");
        return this.red.sub(this, num);
    };
    BN.prototype.redISub = function redISub(num) {
        assert(this.red, "redISub works only with red numbers");
        return this.red.isub(this, num);
    };
    BN.prototype.redShl = function redShl(num) {
        assert(this.red, "redShl works only with red numbers");
        return this.red.shl(this, num);
    };
    BN.prototype.redMul = function redMul(num) {
        assert(this.red, "redMul works only with red numbers");
        this.red._verify2(this, num);
        return this.red.mul(this, num);
    };
    BN.prototype.redIMul = function redIMul(num) {
        assert(this.red, "redMul works only with red numbers");
        this.red._verify2(this, num);
        return this.red.imul(this, num);
    };
    BN.prototype.redSqr = function redSqr() {
        assert(this.red, "redSqr works only with red numbers");
        this.red._verify1(this);
        return this.red.sqr(this);
    };
    BN.prototype.redISqr = function redISqr() {
        assert(this.red, "redISqr works only with red numbers");
        this.red._verify1(this);
        return this.red.isqr(this);
    };
    // Square root over p
    BN.prototype.redSqrt = function redSqrt() {
        assert(this.red, "redSqrt works only with red numbers");
        this.red._verify1(this);
        return this.red.sqrt(this);
    };
    BN.prototype.redInvm = function redInvm() {
        assert(this.red, "redInvm works only with red numbers");
        this.red._verify1(this);
        return this.red.invm(this);
    };
    // Return negative clone of `this` % `red modulo`
    BN.prototype.redNeg = function redNeg() {
        assert(this.red, "redNeg works only with red numbers");
        this.red._verify1(this);
        return this.red.neg(this);
    };
    BN.prototype.redPow = function redPow(num) {
        assert(this.red && !num.red, "redPow(normalNum)");
        this.red._verify1(this);
        return this.red.pow(this, num);
    };
    // Prime numbers with efficient reduction
    var primes = {
        k256: null,
        p224: null,
        p192: null,
        p25519: null
    };
    // Pseudo-Mersenne prime
    function MPrime(name, p) {
        // P = 2 ^ N - K
        this.name = name;
        this.p = new BN(p, 16);
        this.n = this.p.bitLength();
        this.k = new BN(1).iushln(this.n).isub(this.p);
        this.tmp = this._tmp();
    }
    MPrime.prototype._tmp = function _tmp() {
        var tmp = new BN(null);
        tmp.words = new Array(Math.ceil(this.n / 13));
        return tmp;
    };
    MPrime.prototype.ireduce = function ireduce(num) {
        // Assumes that `num` is less than `P^2`
        // num = HI * (2 ^ N - K) + HI * K + LO = HI * K + LO (mod P)
        var r = num;
        var rlen;
        do {
            this.split(r, this.tmp);
            r = this.imulK(r);
            r = r.iadd(this.tmp);
            rlen = r.bitLength();
        }while (rlen > this.n);
        var cmp = rlen < this.n ? -1 : r.ucmp(this.p);
        if (cmp === 0) {
            r.words[0] = 0;
            r.length = 1;
        } else if (cmp > 0) r.isub(this.p);
        else if (r.strip !== undefined) // r is a BN v4 instance
        r.strip();
        else // r is a BN v5 instance
        r._strip();
        return r;
    };
    MPrime.prototype.split = function split(input, out) {
        input.iushrn(this.n, 0, out);
    };
    MPrime.prototype.imulK = function imulK(num) {
        return num.imul(this.k);
    };
    function K256() {
        MPrime.call(this, "k256", "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f");
    }
    inherits(K256, MPrime);
    K256.prototype.split = function split(input, output) {
        // 256 = 9 * 26 + 22
        var mask = 0x3fffff;
        var outLen = Math.min(input.length, 9);
        for(var i = 0; i < outLen; i++)output.words[i] = input.words[i];
        output.length = outLen;
        if (input.length <= 9) {
            input.words[0] = 0;
            input.length = 1;
            return;
        }
        // Shift by 9 limbs
        var prev = input.words[9];
        output.words[output.length++] = prev & mask;
        for(i = 10; i < input.length; i++){
            var next = input.words[i] | 0;
            input.words[i - 10] = (next & mask) << 4 | prev >>> 22;
            prev = next;
        }
        prev >>>= 22;
        input.words[i - 10] = prev;
        if (prev === 0 && input.length > 10) input.length -= 10;
        else input.length -= 9;
    };
    K256.prototype.imulK = function imulK(num) {
        // K = 0x1000003d1 = [ 0x40, 0x3d1 ]
        num.words[num.length] = 0;
        num.words[num.length + 1] = 0;
        num.length += 2;
        // bounded at: 0x40 * 0x3ffffff + 0x3d0 = 0x100000390
        var lo = 0;
        for(var i = 0; i < num.length; i++){
            var w = num.words[i] | 0;
            lo += w * 0x3d1;
            num.words[i] = lo & 0x3ffffff;
            lo = w * 0x40 + (lo / 0x4000000 | 0);
        }
        // Fast length reduction
        if (num.words[num.length - 1] === 0) {
            num.length--;
            if (num.words[num.length - 1] === 0) num.length--;
        }
        return num;
    };
    function P224() {
        MPrime.call(this, "p224", "ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001");
    }
    inherits(P224, MPrime);
    function P192() {
        MPrime.call(this, "p192", "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff");
    }
    inherits(P192, MPrime);
    function P25519() {
        // 2 ^ 255 - 19
        MPrime.call(this, "25519", "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed");
    }
    inherits(P25519, MPrime);
    P25519.prototype.imulK = function imulK(num) {
        // K = 0x13
        var carry = 0;
        for(var i = 0; i < num.length; i++){
            var hi = (num.words[i] | 0) * 0x13 + carry;
            var lo = hi & 0x3ffffff;
            hi >>>= 26;
            num.words[i] = lo;
            carry = hi;
        }
        if (carry !== 0) num.words[num.length++] = carry;
        return num;
    };
    // Exported mostly for testing purposes, use plain name instead
    BN._prime = function prime(name) {
        // Cached version of prime
        if (primes[name]) return primes[name];
        var prime;
        if (name === "k256") prime = new K256();
        else if (name === "p224") prime = new P224();
        else if (name === "p192") prime = new P192();
        else if (name === "p25519") prime = new P25519();
        else throw new Error("Unknown prime " + name);
        primes[name] = prime;
        return prime;
    };
    //
    // Base reduction engine
    //
    function Red(m) {
        if (typeof m === "string") {
            var prime = BN._prime(m);
            this.m = prime.p;
            this.prime = prime;
        } else {
            assert(m.gtn(1), "modulus must be greater than 1");
            this.m = m;
            this.prime = null;
        }
    }
    Red.prototype._verify1 = function _verify1(a) {
        assert(a.negative === 0, "red works only with positives");
        assert(a.red, "red works only with red numbers");
    };
    Red.prototype._verify2 = function _verify2(a, b) {
        assert((a.negative | b.negative) === 0, "red works only with positives");
        assert(a.red && a.red === b.red, "red works only with red numbers");
    };
    Red.prototype.imod = function imod(a) {
        if (this.prime) return this.prime.ireduce(a)._forceRed(this);
        move(a, a.umod(this.m)._forceRed(this));
        return a;
    };
    Red.prototype.neg = function neg(a) {
        if (a.isZero()) return a.clone();
        return this.m.sub(a)._forceRed(this);
    };
    Red.prototype.add = function add(a, b) {
        this._verify2(a, b);
        var res = a.add(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res._forceRed(this);
    };
    Red.prototype.iadd = function iadd(a, b) {
        this._verify2(a, b);
        var res = a.iadd(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res;
    };
    Red.prototype.sub = function sub(a, b) {
        this._verify2(a, b);
        var res = a.sub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res._forceRed(this);
    };
    Red.prototype.isub = function isub(a, b) {
        this._verify2(a, b);
        var res = a.isub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res;
    };
    Red.prototype.shl = function shl(a, num) {
        this._verify1(a);
        return this.imod(a.ushln(num));
    };
    Red.prototype.imul = function imul(a, b) {
        this._verify2(a, b);
        return this.imod(a.imul(b));
    };
    Red.prototype.mul = function mul(a, b) {
        this._verify2(a, b);
        return this.imod(a.mul(b));
    };
    Red.prototype.isqr = function isqr(a) {
        return this.imul(a, a.clone());
    };
    Red.prototype.sqr = function sqr(a) {
        return this.mul(a, a);
    };
    Red.prototype.sqrt = function sqrt(a) {
        if (a.isZero()) return a.clone();
        var mod3 = this.m.andln(3);
        assert(mod3 % 2 === 1);
        // Fast case
        if (mod3 === 3) {
            var pow = this.m.add(new BN(1)).iushrn(2);
            return this.pow(a, pow);
        }
        // Tonelli-Shanks algorithm (Totally unoptimized and slow)
        //
        // Find Q and S, that Q * 2 ^ S = (P - 1)
        var q = this.m.subn(1);
        var s = 0;
        while(!q.isZero() && q.andln(1) === 0){
            s++;
            q.iushrn(1);
        }
        assert(!q.isZero());
        var one = new BN(1).toRed(this);
        var nOne = one.redNeg();
        // Find quadratic non-residue
        // NOTE: Max is such because of generalized Riemann hypothesis.
        var lpow = this.m.subn(1).iushrn(1);
        var z = this.m.bitLength();
        z = new BN(2 * z * z).toRed(this);
        while(this.pow(z, lpow).cmp(nOne) !== 0)z.redIAdd(nOne);
        var c = this.pow(z, q);
        var r = this.pow(a, q.addn(1).iushrn(1));
        var t = this.pow(a, q);
        var m = s;
        while(t.cmp(one) !== 0){
            var tmp = t;
            for(var i = 0; tmp.cmp(one) !== 0; i++)tmp = tmp.redSqr();
            assert(i < m);
            var b = this.pow(c, new BN(1).iushln(m - i - 1));
            r = r.redMul(b);
            c = b.redSqr();
            t = t.redMul(c);
            m = i;
        }
        return r;
    };
    Red.prototype.invm = function invm(a) {
        var inv = a._invmp(this.m);
        if (inv.negative !== 0) {
            inv.negative = 0;
            return this.imod(inv).redNeg();
        } else return this.imod(inv);
    };
    Red.prototype.pow = function pow(a, num) {
        if (num.isZero()) return new BN(1).toRed(this);
        if (num.cmpn(1) === 0) return a.clone();
        var windowSize = 4;
        var wnd = new Array(1 << windowSize);
        wnd[0] = new BN(1).toRed(this);
        wnd[1] = a;
        for(var i = 2; i < wnd.length; i++)wnd[i] = this.mul(wnd[i - 1], a);
        var res = wnd[0];
        var current = 0;
        var currentLen = 0;
        var start = num.bitLength() % 26;
        if (start === 0) start = 26;
        for(i = num.length - 1; i >= 0; i--){
            var word = num.words[i];
            for(var j = start - 1; j >= 0; j--){
                var bit = word >> j & 1;
                if (res !== wnd[0]) res = this.sqr(res);
                if (bit === 0 && current === 0) {
                    currentLen = 0;
                    continue;
                }
                current <<= 1;
                current |= bit;
                currentLen++;
                if (currentLen !== windowSize && (i !== 0 || j !== 0)) continue;
                res = this.mul(res, wnd[current]);
                currentLen = 0;
                current = 0;
            }
            start = 26;
        }
        return res;
    };
    Red.prototype.convertTo = function convertTo(num) {
        var r = num.umod(this.m);
        return r === num ? r.clone() : r;
    };
    Red.prototype.convertFrom = function convertFrom(num) {
        var res = num.clone();
        res.red = null;
        return res;
    };
    //
    // Montgomery method engine
    //
    BN.mont = function mont(num) {
        return new Mont(num);
    };
    function Mont(m) {
        Red.call(this, m);
        this.shift = this.m.bitLength();
        if (this.shift % 26 !== 0) this.shift += 26 - this.shift % 26;
        this.r = new BN(1).iushln(this.shift);
        this.r2 = this.imod(this.r.sqr());
        this.rinv = this.r._invmp(this.m);
        this.minv = this.rinv.mul(this.r).isubn(1).div(this.m);
        this.minv = this.minv.umod(this.r);
        this.minv = this.r.sub(this.minv);
    }
    inherits(Mont, Red);
    Mont.prototype.convertTo = function convertTo(num) {
        return this.imod(num.ushln(this.shift));
    };
    Mont.prototype.convertFrom = function convertFrom(num) {
        var r = this.imod(num.mul(this.rinv));
        r.red = null;
        return r;
    };
    Mont.prototype.imul = function imul(a, b) {
        if (a.isZero() || b.isZero()) {
            a.words[0] = 0;
            a.length = 1;
            return a;
        }
        var t = a.imul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.mul = function mul(a, b) {
        if (a.isZero() || b.isZero()) return new BN(0)._forceRed(this);
        var t = a.mul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.invm = function invm(a) {
        // (AR)^-1 * R^2 = (A^-1 * R^-1) * R^2 = A^-1 * R
        var res = this.imod(a._invmp(this.m).mul(this.r2));
        return res._forceRed(this);
    };
})(module, this);

});

parcelRequire.register("579Op", function(module, exports) {

var $2FHZp = parcelRequire("2FHZp");

var $buRsR = parcelRequire("buRsR");

var $hpCup = parcelRequire("hpCup");

var $k1gB1 = parcelRequire("k1gB1");

var $1UZ5c = parcelRequire("1UZ5c");

var $6U9mG = parcelRequire("6U9mG");
var $3b9537b0914cb295$require$Buffer = $6U9mG.Buffer;
module.exports = $3b9537b0914cb295$var$parseKeys;
function $3b9537b0914cb295$var$parseKeys(buffer) {
    var password;
    if (typeof buffer === "object" && !$3b9537b0914cb295$require$Buffer.isBuffer(buffer)) {
        password = buffer.passphrase;
        buffer = buffer.key;
    }
    if (typeof buffer === "string") buffer = $3b9537b0914cb295$require$Buffer.from(buffer);
    var stripped = $hpCup(buffer, password);
    var type = stripped.tag;
    var data = stripped.data;
    var subtype, ndata;
    switch(type){
        case "CERTIFICATE":
            ndata = $2FHZp.certificate.decode(data, "der").tbsCertificate.subjectPublicKeyInfo;
        // falls through
        case "PUBLIC KEY":
            if (!ndata) ndata = $2FHZp.PublicKey.decode(data, "der");
            subtype = ndata.algorithm.algorithm.join(".");
            switch(subtype){
                case "1.2.840.113549.1.1.1":
                    return $2FHZp.RSAPublicKey.decode(ndata.subjectPublicKey.data, "der");
                case "1.2.840.10045.2.1":
                    ndata.subjectPrivateKey = ndata.subjectPublicKey;
                    return {
                        type: "ec",
                        data: ndata
                    };
                case "1.2.840.10040.4.1":
                    ndata.algorithm.params.pub_key = $2FHZp.DSAparam.decode(ndata.subjectPublicKey.data, "der");
                    return {
                        type: "dsa",
                        data: ndata.algorithm.params
                    };
                default:
                    throw new Error("unknown key id " + subtype);
            }
        // throw new Error('unknown key type ' + type)
        case "ENCRYPTED PRIVATE KEY":
            data = $2FHZp.EncryptedPrivateKey.decode(data, "der");
            data = $3b9537b0914cb295$var$decrypt(data, password);
        // falls through
        case "PRIVATE KEY":
            ndata = $2FHZp.PrivateKey.decode(data, "der");
            subtype = ndata.algorithm.algorithm.join(".");
            switch(subtype){
                case "1.2.840.113549.1.1.1":
                    return $2FHZp.RSAPrivateKey.decode(ndata.subjectPrivateKey, "der");
                case "1.2.840.10045.2.1":
                    return {
                        curve: ndata.algorithm.curve,
                        privateKey: $2FHZp.ECPrivateKey.decode(ndata.subjectPrivateKey, "der").privateKey
                    };
                case "1.2.840.10040.4.1":
                    ndata.algorithm.params.priv_key = $2FHZp.DSAparam.decode(ndata.subjectPrivateKey, "der");
                    return {
                        type: "dsa",
                        params: ndata.algorithm.params
                    };
                default:
                    throw new Error("unknown key id " + subtype);
            }
        // throw new Error('unknown key type ' + type)
        case "RSA PUBLIC KEY":
            return $2FHZp.RSAPublicKey.decode(data, "der");
        case "RSA PRIVATE KEY":
            return $2FHZp.RSAPrivateKey.decode(data, "der");
        case "DSA PRIVATE KEY":
            return {
                type: "dsa",
                params: $2FHZp.DSAPrivateKey.decode(data, "der")
            };
        case "EC PRIVATE KEY":
            data = $2FHZp.ECPrivateKey.decode(data, "der");
            return {
                curve: data.parameters.value,
                privateKey: data.privateKey
            };
        default:
            throw new Error("unknown key type " + type);
    }
}
$3b9537b0914cb295$var$parseKeys.signature = $2FHZp.signature;
function $3b9537b0914cb295$var$decrypt(data, password) {
    var salt = data.algorithm.decrypt.kde.kdeparams.salt;
    var iters = parseInt(data.algorithm.decrypt.kde.kdeparams.iters.toString(), 10);
    var algo = $buRsR[data.algorithm.decrypt.cipher.algo.join(".")];
    var iv = data.algorithm.decrypt.cipher.iv;
    var cipherText = data.subjectPrivateKey;
    var keylen = parseInt(algo.split("-")[1], 10) / 8;
    var key = $1UZ5c.pbkdf2Sync(password, salt, iters, keylen, "sha1");
    var cipher = $k1gB1.createDecipheriv(algo, key, iv);
    var out = [];
    out.push(cipher.update(cipherText));
    out.push(cipher.final());
    return $3b9537b0914cb295$require$Buffer.concat(out);
}

});
parcelRequire.register("2FHZp", function(module, exports) {

$parcel$export(module.exports, "certificate", function () { return $1f21887c987abd19$export$c98397a6eb8d0678; }, function (v) { return $1f21887c987abd19$export$c98397a6eb8d0678 = v; });
$parcel$export(module.exports, "RSAPrivateKey", function () { return $1f21887c987abd19$export$f4aab6816f64fa6b; }, function (v) { return $1f21887c987abd19$export$f4aab6816f64fa6b = v; });
$parcel$export(module.exports, "RSAPublicKey", function () { return $1f21887c987abd19$export$4471f5c65d097c11; }, function (v) { return $1f21887c987abd19$export$4471f5c65d097c11 = v; });
$parcel$export(module.exports, "PublicKey", function () { return $1f21887c987abd19$export$ca8b6604d6ce14de; }, function (v) { return $1f21887c987abd19$export$ca8b6604d6ce14de = v; });
$parcel$export(module.exports, "PrivateKey", function () { return $1f21887c987abd19$export$8f54525b330fd87b; }, function (v) { return $1f21887c987abd19$export$8f54525b330fd87b = v; });
$parcel$export(module.exports, "EncryptedPrivateKey", function () { return $1f21887c987abd19$export$23cd2842b44ca3e7; }, function (v) { return $1f21887c987abd19$export$23cd2842b44ca3e7 = v; });
$parcel$export(module.exports, "DSAPrivateKey", function () { return $1f21887c987abd19$export$245c9aaa9f5ce4ce; }, function (v) { return $1f21887c987abd19$export$245c9aaa9f5ce4ce = v; });
$parcel$export(module.exports, "DSAparam", function () { return $1f21887c987abd19$export$8ad762e3e6399afe; }, function (v) { return $1f21887c987abd19$export$8ad762e3e6399afe = v; });
$parcel$export(module.exports, "ECPrivateKey", function () { return $1f21887c987abd19$export$32ef6f92e22c6ab0; }, function (v) { return $1f21887c987abd19$export$32ef6f92e22c6ab0 = v; });
$parcel$export(module.exports, "signature", function () { return $1f21887c987abd19$export$c9cd164b539ebb63; }, function (v) { return $1f21887c987abd19$export$c9cd164b539ebb63 = v; });
// from https://github.com/indutny/self-signed/blob/gh-pages/lib/asn1.js
// Fedor, you are amazing.
var $1f21887c987abd19$export$c98397a6eb8d0678;
var $1f21887c987abd19$export$f4aab6816f64fa6b;
var $1f21887c987abd19$export$4471f5c65d097c11;
var $1f21887c987abd19$export$ca8b6604d6ce14de;
var $1f21887c987abd19$export$8f54525b330fd87b;
var $1f21887c987abd19$export$23cd2842b44ca3e7;
var $1f21887c987abd19$export$245c9aaa9f5ce4ce;
var $1f21887c987abd19$export$8ad762e3e6399afe;
var $1f21887c987abd19$export$32ef6f92e22c6ab0;
var $1f21887c987abd19$export$c9cd164b539ebb63;
"use strict";

var $aMCkA = parcelRequire("aMCkA");

$1f21887c987abd19$export$c98397a6eb8d0678 = (parcelRequire("aa7wN"));
var $1f21887c987abd19$var$RSAPrivateKey = $aMCkA.define("RSAPrivateKey", function() {
    this.seq().obj(this.key("version").int(), this.key("modulus").int(), this.key("publicExponent").int(), this.key("privateExponent").int(), this.key("prime1").int(), this.key("prime2").int(), this.key("exponent1").int(), this.key("exponent2").int(), this.key("coefficient").int());
});
$1f21887c987abd19$export$f4aab6816f64fa6b = $1f21887c987abd19$var$RSAPrivateKey;
var $1f21887c987abd19$var$RSAPublicKey = $aMCkA.define("RSAPublicKey", function() {
    this.seq().obj(this.key("modulus").int(), this.key("publicExponent").int());
});
$1f21887c987abd19$export$4471f5c65d097c11 = $1f21887c987abd19$var$RSAPublicKey;
var $1f21887c987abd19$var$PublicKey = $aMCkA.define("SubjectPublicKeyInfo", function() {
    this.seq().obj(this.key("algorithm").use($1f21887c987abd19$var$AlgorithmIdentifier), this.key("subjectPublicKey").bitstr());
});
$1f21887c987abd19$export$ca8b6604d6ce14de = $1f21887c987abd19$var$PublicKey;
var $1f21887c987abd19$var$AlgorithmIdentifier = $aMCkA.define("AlgorithmIdentifier", function() {
    this.seq().obj(this.key("algorithm").objid(), this.key("none").null_().optional(), this.key("curve").objid().optional(), this.key("params").seq().obj(this.key("p").int(), this.key("q").int(), this.key("g").int()).optional());
});
var $1f21887c987abd19$var$PrivateKeyInfo = $aMCkA.define("PrivateKeyInfo", function() {
    this.seq().obj(this.key("version").int(), this.key("algorithm").use($1f21887c987abd19$var$AlgorithmIdentifier), this.key("subjectPrivateKey").octstr());
});
$1f21887c987abd19$export$8f54525b330fd87b = $1f21887c987abd19$var$PrivateKeyInfo;
var $1f21887c987abd19$var$EncryptedPrivateKeyInfo = $aMCkA.define("EncryptedPrivateKeyInfo", function() {
    this.seq().obj(this.key("algorithm").seq().obj(this.key("id").objid(), this.key("decrypt").seq().obj(this.key("kde").seq().obj(this.key("id").objid(), this.key("kdeparams").seq().obj(this.key("salt").octstr(), this.key("iters").int())), this.key("cipher").seq().obj(this.key("algo").objid(), this.key("iv").octstr()))), this.key("subjectPrivateKey").octstr());
});
$1f21887c987abd19$export$23cd2842b44ca3e7 = $1f21887c987abd19$var$EncryptedPrivateKeyInfo;
var $1f21887c987abd19$var$DSAPrivateKey = $aMCkA.define("DSAPrivateKey", function() {
    this.seq().obj(this.key("version").int(), this.key("p").int(), this.key("q").int(), this.key("g").int(), this.key("pub_key").int(), this.key("priv_key").int());
});
$1f21887c987abd19$export$245c9aaa9f5ce4ce = $1f21887c987abd19$var$DSAPrivateKey;
$1f21887c987abd19$export$8ad762e3e6399afe = $aMCkA.define("DSAparam", function() {
    this.int();
});
var $1f21887c987abd19$var$ECPrivateKey = $aMCkA.define("ECPrivateKey", function() {
    this.seq().obj(this.key("version").int(), this.key("privateKey").octstr(), this.key("parameters").optional().explicit(0).use($1f21887c987abd19$var$ECParameters), this.key("publicKey").optional().explicit(1).bitstr());
});
$1f21887c987abd19$export$32ef6f92e22c6ab0 = $1f21887c987abd19$var$ECPrivateKey;
var $1f21887c987abd19$var$ECParameters = $aMCkA.define("ECParameters", function() {
    this.choice({
        namedCurve: this.objid()
    });
});
$1f21887c987abd19$export$c9cd164b539ebb63 = $aMCkA.define("signature", function() {
    this.seq().obj(this.key("r").int(), this.key("s").int());
});

});
parcelRequire.register("aMCkA", function(module, exports) {
"use strict";
const $7d9c1ed330ef59e6$var$asn1 = module.exports;

$7d9c1ed330ef59e6$var$asn1.bignum = (parcelRequire("7vYz3"));

$7d9c1ed330ef59e6$var$asn1.define = (parcelRequire("jcRMx")).define;

$7d9c1ed330ef59e6$var$asn1.base = (parcelRequire("eMucS"));

$7d9c1ed330ef59e6$var$asn1.constants = (parcelRequire("2Qobq"));

$7d9c1ed330ef59e6$var$asn1.decoders = (parcelRequire("jTBMn"));

$7d9c1ed330ef59e6$var$asn1.encoders = (parcelRequire("8MqVr"));

});
parcelRequire.register("jcRMx", function(module, exports) {
"use strict";

var $8MqVr = parcelRequire("8MqVr");

var $jTBMn = parcelRequire("jTBMn");

var $eSHUL = parcelRequire("eSHUL");
const $dfb8db4a4a86a3f4$var$api = module.exports;
$dfb8db4a4a86a3f4$var$api.define = function define(name, body) {
    return new $dfb8db4a4a86a3f4$var$Entity(name, body);
};
function $dfb8db4a4a86a3f4$var$Entity(name, body) {
    this.name = name;
    this.body = body;
    this.decoders = {};
    this.encoders = {};
}
$dfb8db4a4a86a3f4$var$Entity.prototype._createNamed = function createNamed(Base) {
    const name = this.name;
    function Generated(entity) {
        this._initNamed(entity, name);
    }
    $eSHUL(Generated, Base);
    Generated.prototype._initNamed = function _initNamed(entity, name) {
        Base.call(this, entity, name);
    };
    return new Generated(this);
};
$dfb8db4a4a86a3f4$var$Entity.prototype._getDecoder = function _getDecoder(enc) {
    enc = enc || "der";
    // Lazily create decoder
    if (!this.decoders.hasOwnProperty(enc)) this.decoders[enc] = this._createNamed($jTBMn[enc]);
    return this.decoders[enc];
};
$dfb8db4a4a86a3f4$var$Entity.prototype.decode = function decode(data, enc, options) {
    return this._getDecoder(enc).decode(data, options);
};
$dfb8db4a4a86a3f4$var$Entity.prototype._getEncoder = function _getEncoder(enc) {
    enc = enc || "der";
    // Lazily create encoder
    if (!this.encoders.hasOwnProperty(enc)) this.encoders[enc] = this._createNamed($8MqVr[enc]);
    return this.encoders[enc];
};
$dfb8db4a4a86a3f4$var$Entity.prototype.encode = function encode(data, enc, /* internal */ reporter) {
    return this._getEncoder(enc).encode(data, reporter);
};

});
parcelRequire.register("8MqVr", function(module, exports) {
"use strict";
const $6647b13f24468e50$var$encoders = module.exports;

$6647b13f24468e50$var$encoders.der = (parcelRequire("44g7l"));

$6647b13f24468e50$var$encoders.pem = (parcelRequire("8MKvJ"));

});
parcelRequire.register("44g7l", function(module, exports) {
"use strict";

var $eSHUL = parcelRequire("eSHUL");

var $dLNO7 = parcelRequire("dLNO7");
var $2f6409b794513848$require$Buffer = $dLNO7.Buffer;

var $aAKRg = parcelRequire("aAKRg");

var $6SLsO = parcelRequire("6SLsO");
function $2f6409b794513848$var$DEREncoder(entity) {
    this.enc = "der";
    this.name = entity.name;
    this.entity = entity;
    // Construct base tree
    this.tree = new $2f6409b794513848$var$DERNode();
    this.tree._init(entity.body);
}
module.exports = $2f6409b794513848$var$DEREncoder;
$2f6409b794513848$var$DEREncoder.prototype.encode = function encode(data, reporter) {
    return this.tree._encode(data, reporter).join();
};
// Tree methods
function $2f6409b794513848$var$DERNode(parent) {
    $aAKRg.call(this, "der", parent);
}
$eSHUL($2f6409b794513848$var$DERNode, $aAKRg);
$2f6409b794513848$var$DERNode.prototype._encodeComposite = function encodeComposite(tag, primitive, cls, content) {
    const encodedTag = $2f6409b794513848$var$encodeTag(tag, primitive, cls, this.reporter);
    // Short form
    if (content.length < 0x80) {
        const header = $2f6409b794513848$require$Buffer.alloc(2);
        header[0] = encodedTag;
        header[1] = content.length;
        return this._createEncoderBuffer([
            header,
            content
        ]);
    }
    // Long form
    // Count octets required to store length
    let lenOctets = 1;
    for(let i = content.length; i >= 0x100; i >>= 8)lenOctets++;
    const header = $2f6409b794513848$require$Buffer.alloc(2 + lenOctets);
    header[0] = encodedTag;
    header[1] = 0x80 | lenOctets;
    for(let i = 1 + lenOctets, j = content.length; j > 0; i--, j >>= 8)header[i] = j & 0xff;
    return this._createEncoderBuffer([
        header,
        content
    ]);
};
$2f6409b794513848$var$DERNode.prototype._encodeStr = function encodeStr(str, tag) {
    if (tag === "bitstr") return this._createEncoderBuffer([
        str.unused | 0,
        str.data
    ]);
    else if (tag === "bmpstr") {
        const buf = $2f6409b794513848$require$Buffer.alloc(str.length * 2);
        for(let i = 0; i < str.length; i++)buf.writeUInt16BE(str.charCodeAt(i), i * 2);
        return this._createEncoderBuffer(buf);
    } else if (tag === "numstr") {
        if (!this._isNumstr(str)) return this.reporter.error("Encoding of string type: numstr supports only digits and space");
        return this._createEncoderBuffer(str);
    } else if (tag === "printstr") {
        if (!this._isPrintstr(str)) return this.reporter.error("Encoding of string type: printstr supports only latin upper and lower case letters, digits, space, apostrophe, left and rigth parenthesis, plus sign, comma, hyphen, dot, slash, colon, equal sign, question mark");
        return this._createEncoderBuffer(str);
    } else if (/str$/.test(tag)) return this._createEncoderBuffer(str);
    else if (tag === "objDesc") return this._createEncoderBuffer(str);
    else return this.reporter.error("Encoding of string type: " + tag + " unsupported");
};
$2f6409b794513848$var$DERNode.prototype._encodeObjid = function encodeObjid(id, values, relative) {
    if (typeof id === "string") {
        if (!values) return this.reporter.error("string objid given, but no values map found");
        if (!values.hasOwnProperty(id)) return this.reporter.error("objid not found in values map");
        id = values[id].split(/[\s.]+/g);
        for(let i = 0; i < id.length; i++)id[i] |= 0;
    } else if (Array.isArray(id)) {
        id = id.slice();
        for(let i = 0; i < id.length; i++)id[i] |= 0;
    }
    if (!Array.isArray(id)) return this.reporter.error("objid() should be either array or string, got: " + JSON.stringify(id));
    if (!relative) {
        if (id[1] >= 40) return this.reporter.error("Second objid identifier OOB");
        id.splice(0, 2, id[0] * 40 + id[1]);
    }
    // Count number of octets
    let size = 0;
    for(let i = 0; i < id.length; i++){
        let ident = id[i];
        for(size++; ident >= 0x80; ident >>= 7)size++;
    }
    const objid = $2f6409b794513848$require$Buffer.alloc(size);
    let offset = objid.length - 1;
    for(let i = id.length - 1; i >= 0; i--){
        let ident = id[i];
        objid[offset--] = ident & 0x7f;
        while((ident >>= 7) > 0)objid[offset--] = 0x80 | ident & 0x7f;
    }
    return this._createEncoderBuffer(objid);
};
function $2f6409b794513848$var$two(num) {
    if (num < 10) return "0" + num;
    else return num;
}
$2f6409b794513848$var$DERNode.prototype._encodeTime = function encodeTime(time, tag) {
    let str;
    const date = new Date(time);
    if (tag === "gentime") str = [
        $2f6409b794513848$var$two(date.getUTCFullYear()),
        $2f6409b794513848$var$two(date.getUTCMonth() + 1),
        $2f6409b794513848$var$two(date.getUTCDate()),
        $2f6409b794513848$var$two(date.getUTCHours()),
        $2f6409b794513848$var$two(date.getUTCMinutes()),
        $2f6409b794513848$var$two(date.getUTCSeconds()),
        "Z"
    ].join("");
    else if (tag === "utctime") str = [
        $2f6409b794513848$var$two(date.getUTCFullYear() % 100),
        $2f6409b794513848$var$two(date.getUTCMonth() + 1),
        $2f6409b794513848$var$two(date.getUTCDate()),
        $2f6409b794513848$var$two(date.getUTCHours()),
        $2f6409b794513848$var$two(date.getUTCMinutes()),
        $2f6409b794513848$var$two(date.getUTCSeconds()),
        "Z"
    ].join("");
    else this.reporter.error("Encoding " + tag + " time is not supported yet");
    return this._encodeStr(str, "octstr");
};
$2f6409b794513848$var$DERNode.prototype._encodeNull = function encodeNull() {
    return this._createEncoderBuffer("");
};
$2f6409b794513848$var$DERNode.prototype._encodeInt = function encodeInt(num, values) {
    if (typeof num === "string") {
        if (!values) return this.reporter.error("String int or enum given, but no values map");
        if (!values.hasOwnProperty(num)) return this.reporter.error("Values map doesn't contain: " + JSON.stringify(num));
        num = values[num];
    }
    // Bignum, assume big endian
    if (typeof num !== "number" && !$2f6409b794513848$require$Buffer.isBuffer(num)) {
        const numArray = num.toArray();
        if (!num.sign && numArray[0] & 0x80) numArray.unshift(0);
        num = $2f6409b794513848$require$Buffer.from(numArray);
    }
    if ($2f6409b794513848$require$Buffer.isBuffer(num)) {
        let size = num.length;
        if (num.length === 0) size++;
        const out = $2f6409b794513848$require$Buffer.alloc(size);
        num.copy(out);
        if (num.length === 0) out[0] = 0;
        return this._createEncoderBuffer(out);
    }
    if (num < 0x80) return this._createEncoderBuffer(num);
    if (num < 0x100) return this._createEncoderBuffer([
        0,
        num
    ]);
    let size = 1;
    for(let i = num; i >= 0x100; i >>= 8)size++;
    const out = new Array(size);
    for(let i = out.length - 1; i >= 0; i--){
        out[i] = num & 0xff;
        num >>= 8;
    }
    if (out[0] & 0x80) out.unshift(0);
    return this._createEncoderBuffer($2f6409b794513848$require$Buffer.from(out));
};
$2f6409b794513848$var$DERNode.prototype._encodeBool = function encodeBool(value) {
    return this._createEncoderBuffer(value ? 0xff : 0);
};
$2f6409b794513848$var$DERNode.prototype._use = function use(entity, obj) {
    if (typeof entity === "function") entity = entity(obj);
    return entity._getEncoder("der").tree;
};
$2f6409b794513848$var$DERNode.prototype._skipDefault = function skipDefault(dataBuffer, reporter, parent) {
    const state = this._baseState;
    let i;
    if (state["default"] === null) return false;
    const data = dataBuffer.join();
    if (state.defaultBuffer === undefined) state.defaultBuffer = this._encodeValue(state["default"], reporter, parent).join();
    if (data.length !== state.defaultBuffer.length) return false;
    for(i = 0; i < data.length; i++)if (data[i] !== state.defaultBuffer[i]) return false;
    return true;
};
// Utility methods
function $2f6409b794513848$var$encodeTag(tag, primitive, cls, reporter) {
    let res;
    if (tag === "seqof") tag = "seq";
    else if (tag === "setof") tag = "set";
    if ($6SLsO.tagByName.hasOwnProperty(tag)) res = $6SLsO.tagByName[tag];
    else if (typeof tag === "number" && (tag | 0) === tag) res = tag;
    else return reporter.error("Unknown tag: " + tag);
    if (res >= 0x1f) return reporter.error("Multi-octet tag encoding unsupported");
    if (!primitive) res |= 0x20;
    res |= $6SLsO.tagClassByName[cls || "universal"] << 6;
    return res;
}

});
parcelRequire.register("dLNO7", function(module, exports) {
/* eslint-disable node/no-deprecated-api */ 
var $4TNnu = parcelRequire("4TNnu");
"use strict";

var $ihoyg = parcelRequire("ihoyg");
var $a0664cdc1e6bc00b$var$Buffer = $ihoyg.Buffer;
var $a0664cdc1e6bc00b$var$safer = {};
var $a0664cdc1e6bc00b$var$key;
for($a0664cdc1e6bc00b$var$key in $ihoyg){
    if (!$ihoyg.hasOwnProperty($a0664cdc1e6bc00b$var$key)) continue;
    if ($a0664cdc1e6bc00b$var$key === "SlowBuffer" || $a0664cdc1e6bc00b$var$key === "Buffer") continue;
    $a0664cdc1e6bc00b$var$safer[$a0664cdc1e6bc00b$var$key] = $ihoyg[$a0664cdc1e6bc00b$var$key];
}
var $a0664cdc1e6bc00b$var$Safer = $a0664cdc1e6bc00b$var$safer.Buffer = {};
for($a0664cdc1e6bc00b$var$key in $a0664cdc1e6bc00b$var$Buffer){
    if (!$a0664cdc1e6bc00b$var$Buffer.hasOwnProperty($a0664cdc1e6bc00b$var$key)) continue;
    if ($a0664cdc1e6bc00b$var$key === "allocUnsafe" || $a0664cdc1e6bc00b$var$key === "allocUnsafeSlow") continue;
    $a0664cdc1e6bc00b$var$Safer[$a0664cdc1e6bc00b$var$key] = $a0664cdc1e6bc00b$var$Buffer[$a0664cdc1e6bc00b$var$key];
}
$a0664cdc1e6bc00b$var$safer.Buffer.prototype = $a0664cdc1e6bc00b$var$Buffer.prototype;
if (!$a0664cdc1e6bc00b$var$Safer.from || $a0664cdc1e6bc00b$var$Safer.from === Uint8Array.from) $a0664cdc1e6bc00b$var$Safer.from = function(value, encodingOrOffset, length) {
    if (typeof value === "number") throw new TypeError('The "value" argument must not be of type number. Received type ' + typeof value);
    if (value && typeof value.length === "undefined") throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
    return $a0664cdc1e6bc00b$var$Buffer(value, encodingOrOffset, length);
};
if (!$a0664cdc1e6bc00b$var$Safer.alloc) $a0664cdc1e6bc00b$var$Safer.alloc = function(size, fill, encoding) {
    if (typeof size !== "number") throw new TypeError('The "size" argument must be of type number. Received type ' + typeof size);
    if (size < 0 || size >= 2 * 1073741824) throw new RangeError('The value "' + size + '" is invalid for option "size"');
    var buf = $a0664cdc1e6bc00b$var$Buffer(size);
    if (!fill || fill.length === 0) buf.fill(0);
    else if (typeof encoding === "string") buf.fill(fill, encoding);
    else buf.fill(fill);
    return buf;
};
if (!$a0664cdc1e6bc00b$var$safer.kStringMaxLength) try {
    $a0664cdc1e6bc00b$var$safer.kStringMaxLength = $4TNnu.binding("buffer").kStringMaxLength;
} catch (e) {
// we can't determine kStringMaxLength in environments where process.binding
// is unsupported, so let's not set it
}
if (!$a0664cdc1e6bc00b$var$safer.constants) {
    $a0664cdc1e6bc00b$var$safer.constants = {
        MAX_LENGTH: $a0664cdc1e6bc00b$var$safer.kMaxLength
    };
    if ($a0664cdc1e6bc00b$var$safer.kStringMaxLength) $a0664cdc1e6bc00b$var$safer.constants.MAX_STRING_LENGTH = $a0664cdc1e6bc00b$var$safer.kStringMaxLength;
}
module.exports = $a0664cdc1e6bc00b$var$safer;

});

parcelRequire.register("aAKRg", function(module, exports) {
"use strict";

var $1NWy8 = parcelRequire("1NWy8");
var $7b619d3ab2aa52ef$require$Reporter = $1NWy8.Reporter;

var $hJsPi = parcelRequire("hJsPi");
var $7b619d3ab2aa52ef$require$EncoderBuffer = $hJsPi.EncoderBuffer;

var $hJsPi = parcelRequire("hJsPi");
var $7b619d3ab2aa52ef$require$DecoderBuffer = $hJsPi.DecoderBuffer;

var $aJt1P = parcelRequire("aJt1P");
// Supported tags
const $7b619d3ab2aa52ef$var$tags = [
    "seq",
    "seqof",
    "set",
    "setof",
    "objid",
    "bool",
    "gentime",
    "utctime",
    "null_",
    "enum",
    "int",
    "objDesc",
    "bitstr",
    "bmpstr",
    "charstr",
    "genstr",
    "graphstr",
    "ia5str",
    "iso646str",
    "numstr",
    "octstr",
    "printstr",
    "t61str",
    "unistr",
    "utf8str",
    "videostr"
];
// Public methods list
const $7b619d3ab2aa52ef$var$methods = [
    "key",
    "obj",
    "use",
    "optional",
    "explicit",
    "implicit",
    "def",
    "choice",
    "any",
    "contains"
].concat($7b619d3ab2aa52ef$var$tags);
// Overrided methods list
const $7b619d3ab2aa52ef$var$overrided = [
    "_peekTag",
    "_decodeTag",
    "_use",
    "_decodeStr",
    "_decodeObjid",
    "_decodeTime",
    "_decodeNull",
    "_decodeInt",
    "_decodeBool",
    "_decodeList",
    "_encodeComposite",
    "_encodeStr",
    "_encodeObjid",
    "_encodeTime",
    "_encodeNull",
    "_encodeInt",
    "_encodeBool"
];
function $7b619d3ab2aa52ef$var$Node(enc, parent, name) {
    const state = {};
    this._baseState = state;
    state.name = name;
    state.enc = enc;
    state.parent = parent || null;
    state.children = null;
    // State
    state.tag = null;
    state.args = null;
    state.reverseArgs = null;
    state.choice = null;
    state.optional = false;
    state.any = false;
    state.obj = false;
    state.use = null;
    state.useDecoder = null;
    state.key = null;
    state["default"] = null;
    state.explicit = null;
    state.implicit = null;
    state.contains = null;
    // Should create new instance on each method
    if (!state.parent) {
        state.children = [];
        this._wrap();
    }
}
module.exports = $7b619d3ab2aa52ef$var$Node;
const $7b619d3ab2aa52ef$var$stateProps = [
    "enc",
    "parent",
    "children",
    "tag",
    "args",
    "reverseArgs",
    "choice",
    "optional",
    "any",
    "obj",
    "use",
    "alteredUse",
    "key",
    "default",
    "explicit",
    "implicit",
    "contains"
];
$7b619d3ab2aa52ef$var$Node.prototype.clone = function clone() {
    const state = this._baseState;
    const cstate = {};
    $7b619d3ab2aa52ef$var$stateProps.forEach(function(prop) {
        cstate[prop] = state[prop];
    });
    const res = new this.constructor(cstate.parent);
    res._baseState = cstate;
    return res;
};
$7b619d3ab2aa52ef$var$Node.prototype._wrap = function wrap() {
    const state = this._baseState;
    $7b619d3ab2aa52ef$var$methods.forEach(function(method) {
        this[method] = function _wrappedMethod() {
            const clone = new this.constructor(this);
            state.children.push(clone);
            return clone[method].apply(clone, arguments);
        };
    }, this);
};
$7b619d3ab2aa52ef$var$Node.prototype._init = function init(body) {
    const state = this._baseState;
    $aJt1P(state.parent === null);
    body.call(this);
    // Filter children
    state.children = state.children.filter(function(child) {
        return child._baseState.parent === this;
    }, this);
    $aJt1P.equal(state.children.length, 1, "Root node can have only one child");
};
$7b619d3ab2aa52ef$var$Node.prototype._useArgs = function useArgs(args) {
    const state = this._baseState;
    // Filter children and args
    const children = args.filter(function(arg) {
        return arg instanceof this.constructor;
    }, this);
    args = args.filter(function(arg) {
        return !(arg instanceof this.constructor);
    }, this);
    if (children.length !== 0) {
        $aJt1P(state.children === null);
        state.children = children;
        // Replace parent to maintain backward link
        children.forEach(function(child) {
            child._baseState.parent = this;
        }, this);
    }
    if (args.length !== 0) {
        $aJt1P(state.args === null);
        state.args = args;
        state.reverseArgs = args.map(function(arg) {
            if (typeof arg !== "object" || arg.constructor !== Object) return arg;
            const res = {};
            Object.keys(arg).forEach(function(key) {
                if (key == (key | 0)) key |= 0;
                const value = arg[key];
                res[value] = key;
            });
            return res;
        });
    }
};
//
// Overrided methods
//
$7b619d3ab2aa52ef$var$overrided.forEach(function(method) {
    $7b619d3ab2aa52ef$var$Node.prototype[method] = function _overrided() {
        const state = this._baseState;
        throw new Error(method + " not implemented for encoding: " + state.enc);
    };
});
//
// Public methods
//
$7b619d3ab2aa52ef$var$tags.forEach(function(tag) {
    $7b619d3ab2aa52ef$var$Node.prototype[tag] = function _tagMethod() {
        const state = this._baseState;
        const args = Array.prototype.slice.call(arguments);
        $aJt1P(state.tag === null);
        state.tag = tag;
        this._useArgs(args);
        return this;
    };
});
$7b619d3ab2aa52ef$var$Node.prototype.use = function use(item) {
    $aJt1P(item);
    const state = this._baseState;
    $aJt1P(state.use === null);
    state.use = item;
    return this;
};
$7b619d3ab2aa52ef$var$Node.prototype.optional = function optional() {
    const state = this._baseState;
    state.optional = true;
    return this;
};
$7b619d3ab2aa52ef$var$Node.prototype.def = function def(val) {
    const state = this._baseState;
    $aJt1P(state["default"] === null);
    state["default"] = val;
    state.optional = true;
    return this;
};
$7b619d3ab2aa52ef$var$Node.prototype.explicit = function explicit(num) {
    const state = this._baseState;
    $aJt1P(state.explicit === null && state.implicit === null);
    state.explicit = num;
    return this;
};
$7b619d3ab2aa52ef$var$Node.prototype.implicit = function implicit(num) {
    const state = this._baseState;
    $aJt1P(state.explicit === null && state.implicit === null);
    state.implicit = num;
    return this;
};
$7b619d3ab2aa52ef$var$Node.prototype.obj = function obj() {
    const state = this._baseState;
    const args = Array.prototype.slice.call(arguments);
    state.obj = true;
    if (args.length !== 0) this._useArgs(args);
    return this;
};
$7b619d3ab2aa52ef$var$Node.prototype.key = function key(newKey) {
    const state = this._baseState;
    $aJt1P(state.key === null);
    state.key = newKey;
    return this;
};
$7b619d3ab2aa52ef$var$Node.prototype.any = function any() {
    const state = this._baseState;
    state.any = true;
    return this;
};
$7b619d3ab2aa52ef$var$Node.prototype.choice = function choice(obj) {
    const state = this._baseState;
    $aJt1P(state.choice === null);
    state.choice = obj;
    this._useArgs(Object.keys(obj).map(function(key) {
        return obj[key];
    }));
    return this;
};
$7b619d3ab2aa52ef$var$Node.prototype.contains = function contains(item) {
    const state = this._baseState;
    $aJt1P(state.use === null);
    state.contains = item;
    return this;
};
//
// Decoding
//
$7b619d3ab2aa52ef$var$Node.prototype._decode = function decode(input, options) {
    const state = this._baseState;
    // Decode root node
    if (state.parent === null) return input.wrapResult(state.children[0]._decode(input, options));
    let result = state["default"];
    let present = true;
    let prevKey = null;
    if (state.key !== null) prevKey = input.enterKey(state.key);
    // Check if tag is there
    if (state.optional) {
        let tag = null;
        if (state.explicit !== null) tag = state.explicit;
        else if (state.implicit !== null) tag = state.implicit;
        else if (state.tag !== null) tag = state.tag;
        if (tag === null && !state.any) {
            // Trial and Error
            const save = input.save();
            try {
                if (state.choice === null) this._decodeGeneric(state.tag, input, options);
                else this._decodeChoice(input, options);
                present = true;
            } catch (e) {
                present = false;
            }
            input.restore(save);
        } else {
            present = this._peekTag(input, tag, state.any);
            if (input.isError(present)) return present;
        }
    }
    // Push object on stack
    let prevObj;
    if (state.obj && present) prevObj = input.enterObject();
    if (present) {
        // Unwrap explicit values
        if (state.explicit !== null) {
            const explicit = this._decodeTag(input, state.explicit);
            if (input.isError(explicit)) return explicit;
            input = explicit;
        }
        const start = input.offset;
        // Unwrap implicit and normal values
        if (state.use === null && state.choice === null) {
            let save;
            if (state.any) save = input.save();
            const body = this._decodeTag(input, state.implicit !== null ? state.implicit : state.tag, state.any);
            if (input.isError(body)) return body;
            if (state.any) result = input.raw(save);
            else input = body;
        }
        if (options && options.track && state.tag !== null) options.track(input.path(), start, input.length, "tagged");
        if (options && options.track && state.tag !== null) options.track(input.path(), input.offset, input.length, "content");
        // Select proper method for tag
        if (state.any) ;
        else if (state.choice === null) result = this._decodeGeneric(state.tag, input, options);
        else result = this._decodeChoice(input, options);
        if (input.isError(result)) return result;
        // Decode children
        if (!state.any && state.choice === null && state.children !== null) state.children.forEach(function decodeChildren(child) {
            // NOTE: We are ignoring errors here, to let parser continue with other
            // parts of encoded data
            child._decode(input, options);
        });
        // Decode contained/encoded by schema, only in bit or octet strings
        if (state.contains && (state.tag === "octstr" || state.tag === "bitstr")) {
            const data = new $7b619d3ab2aa52ef$require$DecoderBuffer(result);
            result = this._getUse(state.contains, input._reporterState.obj)._decode(data, options);
        }
    }
    // Pop object
    if (state.obj && present) result = input.leaveObject(prevObj);
    // Set key
    if (state.key !== null && (result !== null || present === true)) input.leaveKey(prevKey, state.key, result);
    else if (prevKey !== null) input.exitKey(prevKey);
    return result;
};
$7b619d3ab2aa52ef$var$Node.prototype._decodeGeneric = function decodeGeneric(tag, input, options) {
    const state = this._baseState;
    if (tag === "seq" || tag === "set") return null;
    if (tag === "seqof" || tag === "setof") return this._decodeList(input, tag, state.args[0], options);
    else if (/str$/.test(tag)) return this._decodeStr(input, tag, options);
    else if (tag === "objid" && state.args) return this._decodeObjid(input, state.args[0], state.args[1], options);
    else if (tag === "objid") return this._decodeObjid(input, null, null, options);
    else if (tag === "gentime" || tag === "utctime") return this._decodeTime(input, tag, options);
    else if (tag === "null_") return this._decodeNull(input, options);
    else if (tag === "bool") return this._decodeBool(input, options);
    else if (tag === "objDesc") return this._decodeStr(input, tag, options);
    else if (tag === "int" || tag === "enum") return this._decodeInt(input, state.args && state.args[0], options);
    if (state.use !== null) return this._getUse(state.use, input._reporterState.obj)._decode(input, options);
    else return input.error("unknown tag: " + tag);
};
$7b619d3ab2aa52ef$var$Node.prototype._getUse = function _getUse(entity, obj) {
    const state = this._baseState;
    // Create altered use decoder if implicit is set
    state.useDecoder = this._use(entity, obj);
    $aJt1P(state.useDecoder._baseState.parent === null);
    state.useDecoder = state.useDecoder._baseState.children[0];
    if (state.implicit !== state.useDecoder._baseState.implicit) {
        state.useDecoder = state.useDecoder.clone();
        state.useDecoder._baseState.implicit = state.implicit;
    }
    return state.useDecoder;
};
$7b619d3ab2aa52ef$var$Node.prototype._decodeChoice = function decodeChoice(input, options) {
    const state = this._baseState;
    let result = null;
    let match = false;
    Object.keys(state.choice).some(function(key) {
        const save = input.save();
        const node = state.choice[key];
        try {
            const value = node._decode(input, options);
            if (input.isError(value)) return false;
            result = {
                type: key,
                value: value
            };
            match = true;
        } catch (e) {
            input.restore(save);
            return false;
        }
        return true;
    }, this);
    if (!match) return input.error("Choice not matched");
    return result;
};
//
// Encoding
//
$7b619d3ab2aa52ef$var$Node.prototype._createEncoderBuffer = function createEncoderBuffer(data) {
    return new $7b619d3ab2aa52ef$require$EncoderBuffer(data, this.reporter);
};
$7b619d3ab2aa52ef$var$Node.prototype._encode = function encode(data, reporter, parent) {
    const state = this._baseState;
    if (state["default"] !== null && state["default"] === data) return;
    const result = this._encodeValue(data, reporter, parent);
    if (result === undefined) return;
    if (this._skipDefault(result, reporter, parent)) return;
    return result;
};
$7b619d3ab2aa52ef$var$Node.prototype._encodeValue = function encode(data, reporter, parent) {
    const state = this._baseState;
    // Decode root node
    if (state.parent === null) return state.children[0]._encode(data, reporter || new $7b619d3ab2aa52ef$require$Reporter());
    let result = null;
    // Set reporter to share it with a child class
    this.reporter = reporter;
    // Check if data is there
    if (state.optional && data === undefined) {
        if (state["default"] !== null) data = state["default"];
        else return;
    }
    // Encode children first
    let content = null;
    let primitive = false;
    if (state.any) // Anything that was given is translated to buffer
    result = this._createEncoderBuffer(data);
    else if (state.choice) result = this._encodeChoice(data, reporter);
    else if (state.contains) {
        content = this._getUse(state.contains, parent)._encode(data, reporter);
        primitive = true;
    } else if (state.children) {
        content = state.children.map(function(child) {
            if (child._baseState.tag === "null_") return child._encode(null, reporter, data);
            if (child._baseState.key === null) return reporter.error("Child should have a key");
            const prevKey = reporter.enterKey(child._baseState.key);
            if (typeof data !== "object") return reporter.error("Child expected, but input is not object");
            const res = child._encode(data[child._baseState.key], reporter, data);
            reporter.leaveKey(prevKey);
            return res;
        }, this).filter(function(child) {
            return child;
        });
        content = this._createEncoderBuffer(content);
    } else {
        if (state.tag === "seqof" || state.tag === "setof") {
            // TODO(indutny): this should be thrown on DSL level
            if (!(state.args && state.args.length === 1)) return reporter.error("Too many args for : " + state.tag);
            if (!Array.isArray(data)) return reporter.error("seqof/setof, but data is not Array");
            const child = this.clone();
            child._baseState.implicit = null;
            content = this._createEncoderBuffer(data.map(function(item) {
                const state = this._baseState;
                return this._getUse(state.args[0], data)._encode(item, reporter);
            }, child));
        } else if (state.use !== null) result = this._getUse(state.use, parent)._encode(data, reporter);
        else {
            content = this._encodePrimitive(state.tag, data);
            primitive = true;
        }
    }
    // Encode data itself
    if (!state.any && state.choice === null) {
        const tag = state.implicit !== null ? state.implicit : state.tag;
        const cls = state.implicit === null ? "universal" : "context";
        if (tag === null) {
            if (state.use === null) reporter.error("Tag could be omitted only for .use()");
        } else if (state.use === null) result = this._encodeComposite(tag, primitive, cls, content);
    }
    // Wrap in explicit
    if (state.explicit !== null) result = this._encodeComposite(state.explicit, false, "context", result);
    return result;
};
$7b619d3ab2aa52ef$var$Node.prototype._encodeChoice = function encodeChoice(data, reporter) {
    const state = this._baseState;
    const node = state.choice[data.type];
    if (!node) $aJt1P(false, data.type + " not found in " + JSON.stringify(Object.keys(state.choice)));
    return node._encode(data.value, reporter);
};
$7b619d3ab2aa52ef$var$Node.prototype._encodePrimitive = function encodePrimitive(tag, data) {
    const state = this._baseState;
    if (/str$/.test(tag)) return this._encodeStr(data, tag);
    else if (tag === "objid" && state.args) return this._encodeObjid(data, state.reverseArgs[0], state.args[1]);
    else if (tag === "objid") return this._encodeObjid(data, null, null);
    else if (tag === "gentime" || tag === "utctime") return this._encodeTime(data, tag);
    else if (tag === "null_") return this._encodeNull();
    else if (tag === "int" || tag === "enum") return this._encodeInt(data, state.args && state.reverseArgs[0]);
    else if (tag === "bool") return this._encodeBool(data);
    else if (tag === "objDesc") return this._encodeStr(data, tag);
    else throw new Error("Unsupported tag: " + tag);
};
$7b619d3ab2aa52ef$var$Node.prototype._isNumstr = function isNumstr(str) {
    return /^[0-9 ]*$/.test(str);
};
$7b619d3ab2aa52ef$var$Node.prototype._isPrintstr = function isPrintstr(str) {
    return /^[A-Za-z0-9 '()+,-./:=?]*$/.test(str);
};

});
parcelRequire.register("1NWy8", function(module, exports) {

$parcel$export(module.exports, "Reporter", function () { return $1507c8ca35a04511$export$957313a2f485e5ed; }, function (v) { return $1507c8ca35a04511$export$957313a2f485e5ed = v; });
var $1507c8ca35a04511$export$957313a2f485e5ed;
"use strict";

var $eSHUL = parcelRequire("eSHUL");
function $1507c8ca35a04511$var$Reporter(options) {
    this._reporterState = {
        obj: null,
        path: [],
        options: options || {},
        errors: []
    };
}
$1507c8ca35a04511$export$957313a2f485e5ed = $1507c8ca35a04511$var$Reporter;
$1507c8ca35a04511$var$Reporter.prototype.isError = function isError(obj) {
    return obj instanceof $1507c8ca35a04511$var$ReporterError;
};
$1507c8ca35a04511$var$Reporter.prototype.save = function save() {
    const state = this._reporterState;
    return {
        obj: state.obj,
        pathLen: state.path.length
    };
};
$1507c8ca35a04511$var$Reporter.prototype.restore = function restore(data) {
    const state = this._reporterState;
    state.obj = data.obj;
    state.path = state.path.slice(0, data.pathLen);
};
$1507c8ca35a04511$var$Reporter.prototype.enterKey = function enterKey(key) {
    return this._reporterState.path.push(key);
};
$1507c8ca35a04511$var$Reporter.prototype.exitKey = function exitKey(index) {
    const state = this._reporterState;
    state.path = state.path.slice(0, index - 1);
};
$1507c8ca35a04511$var$Reporter.prototype.leaveKey = function leaveKey(index, key, value) {
    const state = this._reporterState;
    this.exitKey(index);
    if (state.obj !== null) state.obj[key] = value;
};
$1507c8ca35a04511$var$Reporter.prototype.path = function path() {
    return this._reporterState.path.join("/");
};
$1507c8ca35a04511$var$Reporter.prototype.enterObject = function enterObject() {
    const state = this._reporterState;
    const prev = state.obj;
    state.obj = {};
    return prev;
};
$1507c8ca35a04511$var$Reporter.prototype.leaveObject = function leaveObject(prev) {
    const state = this._reporterState;
    const now = state.obj;
    state.obj = prev;
    return now;
};
$1507c8ca35a04511$var$Reporter.prototype.error = function error(msg) {
    let err;
    const state = this._reporterState;
    const inherited = msg instanceof $1507c8ca35a04511$var$ReporterError;
    if (inherited) err = msg;
    else err = new $1507c8ca35a04511$var$ReporterError(state.path.map(function(elem) {
        return "[" + JSON.stringify(elem) + "]";
    }).join(""), msg.message || msg, msg.stack);
    if (!state.options.partial) throw err;
    if (!inherited) state.errors.push(err);
    return err;
};
$1507c8ca35a04511$var$Reporter.prototype.wrapResult = function wrapResult(result) {
    const state = this._reporterState;
    if (!state.options.partial) return result;
    return {
        result: this.isError(result) ? null : result,
        errors: state.errors
    };
};
function $1507c8ca35a04511$var$ReporterError(path, msg) {
    this.path = path;
    this.rethrow(msg);
}
$eSHUL($1507c8ca35a04511$var$ReporterError, Error);
$1507c8ca35a04511$var$ReporterError.prototype.rethrow = function rethrow(msg) {
    this.message = msg + " at: " + (this.path || "(shallow)");
    if (Error.captureStackTrace) Error.captureStackTrace(this, $1507c8ca35a04511$var$ReporterError);
    if (!this.stack) try {
        // IE only adds stack when thrown
        throw new Error(this.message);
    } catch (e) {
        this.stack = e.stack;
    }
    return this;
};

});

parcelRequire.register("hJsPi", function(module, exports) {

$parcel$export(module.exports, "DecoderBuffer", function () { return $ce8cfff3092e20f1$export$bf9f79cdc4a49163; }, function (v) { return $ce8cfff3092e20f1$export$bf9f79cdc4a49163 = v; });
$parcel$export(module.exports, "EncoderBuffer", function () { return $ce8cfff3092e20f1$export$8ff24f7760c7a78e; }, function (v) { return $ce8cfff3092e20f1$export$8ff24f7760c7a78e = v; });
var $ce8cfff3092e20f1$export$bf9f79cdc4a49163;
var $ce8cfff3092e20f1$export$8ff24f7760c7a78e;
"use strict";

var $eSHUL = parcelRequire("eSHUL");

var $1NWy8 = parcelRequire("1NWy8");
var $ce8cfff3092e20f1$require$Reporter = $1NWy8.Reporter;

var $dLNO7 = parcelRequire("dLNO7");
var $ce8cfff3092e20f1$require$Buffer = $dLNO7.Buffer;
function $ce8cfff3092e20f1$var$DecoderBuffer(base, options) {
    $ce8cfff3092e20f1$require$Reporter.call(this, options);
    if (!$ce8cfff3092e20f1$require$Buffer.isBuffer(base)) {
        this.error("Input not Buffer");
        return;
    }
    this.base = base;
    this.offset = 0;
    this.length = base.length;
}
$eSHUL($ce8cfff3092e20f1$var$DecoderBuffer, $ce8cfff3092e20f1$require$Reporter);
$ce8cfff3092e20f1$export$bf9f79cdc4a49163 = $ce8cfff3092e20f1$var$DecoderBuffer;
$ce8cfff3092e20f1$var$DecoderBuffer.isDecoderBuffer = function isDecoderBuffer(data) {
    if (data instanceof $ce8cfff3092e20f1$var$DecoderBuffer) return true;
    // Or accept compatible API
    const isCompatible = typeof data === "object" && $ce8cfff3092e20f1$require$Buffer.isBuffer(data.base) && data.constructor.name === "DecoderBuffer" && typeof data.offset === "number" && typeof data.length === "number" && typeof data.save === "function" && typeof data.restore === "function" && typeof data.isEmpty === "function" && typeof data.readUInt8 === "function" && typeof data.skip === "function" && typeof data.raw === "function";
    return isCompatible;
};
$ce8cfff3092e20f1$var$DecoderBuffer.prototype.save = function save() {
    return {
        offset: this.offset,
        reporter: $ce8cfff3092e20f1$require$Reporter.prototype.save.call(this)
    };
};
$ce8cfff3092e20f1$var$DecoderBuffer.prototype.restore = function restore(save) {
    // Return skipped data
    const res = new $ce8cfff3092e20f1$var$DecoderBuffer(this.base);
    res.offset = save.offset;
    res.length = this.offset;
    this.offset = save.offset;
    $ce8cfff3092e20f1$require$Reporter.prototype.restore.call(this, save.reporter);
    return res;
};
$ce8cfff3092e20f1$var$DecoderBuffer.prototype.isEmpty = function isEmpty() {
    return this.offset === this.length;
};
$ce8cfff3092e20f1$var$DecoderBuffer.prototype.readUInt8 = function readUInt8(fail) {
    if (this.offset + 1 <= this.length) return this.base.readUInt8(this.offset++, true);
    else return this.error(fail || "DecoderBuffer overrun");
};
$ce8cfff3092e20f1$var$DecoderBuffer.prototype.skip = function skip(bytes, fail) {
    if (!(this.offset + bytes <= this.length)) return this.error(fail || "DecoderBuffer overrun");
    const res = new $ce8cfff3092e20f1$var$DecoderBuffer(this.base);
    // Share reporter state
    res._reporterState = this._reporterState;
    res.offset = this.offset;
    res.length = this.offset + bytes;
    this.offset += bytes;
    return res;
};
$ce8cfff3092e20f1$var$DecoderBuffer.prototype.raw = function raw(save) {
    return this.base.slice(save ? save.offset : this.offset, this.length);
};
function $ce8cfff3092e20f1$var$EncoderBuffer(value, reporter) {
    if (Array.isArray(value)) {
        this.length = 0;
        this.value = value.map(function(item) {
            if (!$ce8cfff3092e20f1$var$EncoderBuffer.isEncoderBuffer(item)) item = new $ce8cfff3092e20f1$var$EncoderBuffer(item, reporter);
            this.length += item.length;
            return item;
        }, this);
    } else if (typeof value === "number") {
        if (!(0 <= value && value <= 0xff)) return reporter.error("non-byte EncoderBuffer value");
        this.value = value;
        this.length = 1;
    } else if (typeof value === "string") {
        this.value = value;
        this.length = $ce8cfff3092e20f1$require$Buffer.byteLength(value);
    } else if ($ce8cfff3092e20f1$require$Buffer.isBuffer(value)) {
        this.value = value;
        this.length = value.length;
    } else return reporter.error("Unsupported type: " + typeof value);
}
$ce8cfff3092e20f1$export$8ff24f7760c7a78e = $ce8cfff3092e20f1$var$EncoderBuffer;
$ce8cfff3092e20f1$var$EncoderBuffer.isEncoderBuffer = function isEncoderBuffer(data) {
    if (data instanceof $ce8cfff3092e20f1$var$EncoderBuffer) return true;
    // Or accept compatible API
    const isCompatible = typeof data === "object" && data.constructor.name === "EncoderBuffer" && typeof data.length === "number" && typeof data.join === "function";
    return isCompatible;
};
$ce8cfff3092e20f1$var$EncoderBuffer.prototype.join = function join(out, offset) {
    if (!out) out = $ce8cfff3092e20f1$require$Buffer.alloc(this.length);
    if (!offset) offset = 0;
    if (this.length === 0) return out;
    if (Array.isArray(this.value)) this.value.forEach(function(item) {
        item.join(out, offset);
        offset += item.length;
    });
    else {
        if (typeof this.value === "number") out[offset] = this.value;
        else if (typeof this.value === "string") out.write(this.value, offset);
        else if ($ce8cfff3092e20f1$require$Buffer.isBuffer(this.value)) this.value.copy(out, offset);
        offset += this.length;
    }
    return out;
};

});


parcelRequire.register("6SLsO", function(module, exports) {

$parcel$export(module.exports, "tagClass", function () { return $502c9a8b0256715a$export$3584c46ed60baee8; }, function (v) { return $502c9a8b0256715a$export$3584c46ed60baee8 = v; });
$parcel$export(module.exports, "tagClassByName", function () { return $502c9a8b0256715a$export$f18596ef8d632e49; }, function (v) { return $502c9a8b0256715a$export$f18596ef8d632e49 = v; });
$parcel$export(module.exports, "tag", function () { return $502c9a8b0256715a$export$2b067c6666111485; }, function (v) { return $502c9a8b0256715a$export$2b067c6666111485 = v; });
$parcel$export(module.exports, "tagByName", function () { return $502c9a8b0256715a$export$f17df38a421ab9e3; }, function (v) { return $502c9a8b0256715a$export$f17df38a421ab9e3 = v; });
var $502c9a8b0256715a$export$3584c46ed60baee8;
var $502c9a8b0256715a$export$f18596ef8d632e49;
var $502c9a8b0256715a$export$2b067c6666111485;
var $502c9a8b0256715a$export$f17df38a421ab9e3;
"use strict";
// Helper
function $502c9a8b0256715a$var$reverse(map) {
    const res = {};
    Object.keys(map).forEach(function(key) {
        // Convert key to integer if it is stringified
        if ((key | 0) == key) key = key | 0;
        const value = map[key];
        res[value] = key;
    });
    return res;
}
$502c9a8b0256715a$export$3584c46ed60baee8 = {
    0: "universal",
    1: "application",
    2: "context",
    3: "private"
};
$502c9a8b0256715a$export$f18596ef8d632e49 = $502c9a8b0256715a$var$reverse($502c9a8b0256715a$export$3584c46ed60baee8);
$502c9a8b0256715a$export$2b067c6666111485 = {
    0x00: "end",
    0x01: "bool",
    0x02: "int",
    0x03: "bitstr",
    0x04: "octstr",
    0x05: "null_",
    0x06: "objid",
    0x07: "objDesc",
    0x08: "external",
    0x09: "real",
    0x0a: "enum",
    0x0b: "embed",
    0x0c: "utf8str",
    0x0d: "relativeOid",
    0x10: "seq",
    0x11: "set",
    0x12: "numstr",
    0x13: "printstr",
    0x14: "t61str",
    0x15: "videostr",
    0x16: "ia5str",
    0x17: "utctime",
    0x18: "gentime",
    0x19: "graphstr",
    0x1a: "iso646str",
    0x1b: "genstr",
    0x1c: "unistr",
    0x1d: "charstr",
    0x1e: "bmpstr"
};
$502c9a8b0256715a$export$f17df38a421ab9e3 = $502c9a8b0256715a$var$reverse($502c9a8b0256715a$export$2b067c6666111485);

});


parcelRequire.register("8MKvJ", function(module, exports) {
"use strict";

var $eSHUL = parcelRequire("eSHUL");

var $44g7l = parcelRequire("44g7l");
function $6656e2818f922400$var$PEMEncoder(entity) {
    $44g7l.call(this, entity);
    this.enc = "pem";
}
$eSHUL($6656e2818f922400$var$PEMEncoder, $44g7l);
module.exports = $6656e2818f922400$var$PEMEncoder;
$6656e2818f922400$var$PEMEncoder.prototype.encode = function encode(data, options) {
    const buf = $44g7l.prototype.encode.call(this, data);
    const p = buf.toString("base64");
    const out = [
        "-----BEGIN " + options.label + "-----"
    ];
    for(let i = 0; i < p.length; i += 64)out.push(p.slice(i, i + 64));
    out.push("-----END " + options.label + "-----");
    return out.join("\n");
};

});


parcelRequire.register("jTBMn", function(module, exports) {
"use strict";
const $e7c0758d361c90ed$var$decoders = module.exports;

$e7c0758d361c90ed$var$decoders.der = (parcelRequire("9Mx3V"));

$e7c0758d361c90ed$var$decoders.pem = (parcelRequire("3KeDh"));

});
parcelRequire.register("9Mx3V", function(module, exports) {
"use strict";

var $eSHUL = parcelRequire("eSHUL");

var $7vYz3 = parcelRequire("7vYz3");

var $hJsPi = parcelRequire("hJsPi");
var $71f23e3d24920fc8$require$DecoderBuffer = $hJsPi.DecoderBuffer;

var $aAKRg = parcelRequire("aAKRg");

var $6SLsO = parcelRequire("6SLsO");
function $71f23e3d24920fc8$var$DERDecoder(entity) {
    this.enc = "der";
    this.name = entity.name;
    this.entity = entity;
    // Construct base tree
    this.tree = new $71f23e3d24920fc8$var$DERNode();
    this.tree._init(entity.body);
}
module.exports = $71f23e3d24920fc8$var$DERDecoder;
$71f23e3d24920fc8$var$DERDecoder.prototype.decode = function decode(data, options) {
    if (!$71f23e3d24920fc8$require$DecoderBuffer.isDecoderBuffer(data)) data = new $71f23e3d24920fc8$require$DecoderBuffer(data, options);
    return this.tree._decode(data, options);
};
// Tree methods
function $71f23e3d24920fc8$var$DERNode(parent) {
    $aAKRg.call(this, "der", parent);
}
$eSHUL($71f23e3d24920fc8$var$DERNode, $aAKRg);
$71f23e3d24920fc8$var$DERNode.prototype._peekTag = function peekTag(buffer, tag, any) {
    if (buffer.isEmpty()) return false;
    const state = buffer.save();
    const decodedTag = $71f23e3d24920fc8$var$derDecodeTag(buffer, 'Failed to peek tag: "' + tag + '"');
    if (buffer.isError(decodedTag)) return decodedTag;
    buffer.restore(state);
    return decodedTag.tag === tag || decodedTag.tagStr === tag || decodedTag.tagStr + "of" === tag || any;
};
$71f23e3d24920fc8$var$DERNode.prototype._decodeTag = function decodeTag(buffer, tag, any) {
    const decodedTag = $71f23e3d24920fc8$var$derDecodeTag(buffer, 'Failed to decode tag of "' + tag + '"');
    if (buffer.isError(decodedTag)) return decodedTag;
    let len = $71f23e3d24920fc8$var$derDecodeLen(buffer, decodedTag.primitive, 'Failed to get length of "' + tag + '"');
    // Failure
    if (buffer.isError(len)) return len;
    if (!any && decodedTag.tag !== tag && decodedTag.tagStr !== tag && decodedTag.tagStr + "of" !== tag) return buffer.error('Failed to match tag: "' + tag + '"');
    if (decodedTag.primitive || len !== null) return buffer.skip(len, 'Failed to match body of: "' + tag + '"');
    // Indefinite length... find END tag
    const state = buffer.save();
    const res = this._skipUntilEnd(buffer, 'Failed to skip indefinite length body: "' + this.tag + '"');
    if (buffer.isError(res)) return res;
    len = buffer.offset - state.offset;
    buffer.restore(state);
    return buffer.skip(len, 'Failed to match body of: "' + tag + '"');
};
$71f23e3d24920fc8$var$DERNode.prototype._skipUntilEnd = function skipUntilEnd(buffer, fail) {
    for(;;){
        const tag = $71f23e3d24920fc8$var$derDecodeTag(buffer, fail);
        if (buffer.isError(tag)) return tag;
        const len = $71f23e3d24920fc8$var$derDecodeLen(buffer, tag.primitive, fail);
        if (buffer.isError(len)) return len;
        let res;
        if (tag.primitive || len !== null) res = buffer.skip(len);
        else res = this._skipUntilEnd(buffer, fail);
        // Failure
        if (buffer.isError(res)) return res;
        if (tag.tagStr === "end") break;
    }
};
$71f23e3d24920fc8$var$DERNode.prototype._decodeList = function decodeList(buffer, tag, decoder, options) {
    const result = [];
    while(!buffer.isEmpty()){
        const possibleEnd = this._peekTag(buffer, "end");
        if (buffer.isError(possibleEnd)) return possibleEnd;
        const res = decoder.decode(buffer, "der", options);
        if (buffer.isError(res) && possibleEnd) break;
        result.push(res);
    }
    return result;
};
$71f23e3d24920fc8$var$DERNode.prototype._decodeStr = function decodeStr(buffer, tag) {
    if (tag === "bitstr") {
        const unused = buffer.readUInt8();
        if (buffer.isError(unused)) return unused;
        return {
            unused: unused,
            data: buffer.raw()
        };
    } else if (tag === "bmpstr") {
        const raw = buffer.raw();
        if (raw.length % 2 === 1) return buffer.error("Decoding of string type: bmpstr length mismatch");
        let str = "";
        for(let i = 0; i < raw.length / 2; i++)str += String.fromCharCode(raw.readUInt16BE(i * 2));
        return str;
    } else if (tag === "numstr") {
        const numstr = buffer.raw().toString("ascii");
        if (!this._isNumstr(numstr)) return buffer.error("Decoding of string type: numstr unsupported characters");
        return numstr;
    } else if (tag === "octstr") return buffer.raw();
    else if (tag === "objDesc") return buffer.raw();
    else if (tag === "printstr") {
        const printstr = buffer.raw().toString("ascii");
        if (!this._isPrintstr(printstr)) return buffer.error("Decoding of string type: printstr unsupported characters");
        return printstr;
    } else if (/str$/.test(tag)) return buffer.raw().toString();
    else return buffer.error("Decoding of string type: " + tag + " unsupported");
};
$71f23e3d24920fc8$var$DERNode.prototype._decodeObjid = function decodeObjid(buffer, values, relative) {
    let result;
    const identifiers = [];
    let ident = 0;
    let subident = 0;
    while(!buffer.isEmpty()){
        subident = buffer.readUInt8();
        ident <<= 7;
        ident |= subident & 0x7f;
        if ((subident & 0x80) === 0) {
            identifiers.push(ident);
            ident = 0;
        }
    }
    if (subident & 0x80) identifiers.push(ident);
    const first = identifiers[0] / 40 | 0;
    const second = identifiers[0] % 40;
    if (relative) result = identifiers;
    else result = [
        first,
        second
    ].concat(identifiers.slice(1));
    if (values) {
        let tmp = values[result.join(" ")];
        if (tmp === undefined) tmp = values[result.join(".")];
        if (tmp !== undefined) result = tmp;
    }
    return result;
};
$71f23e3d24920fc8$var$DERNode.prototype._decodeTime = function decodeTime(buffer, tag) {
    const str = buffer.raw().toString();
    let year;
    let mon;
    let day;
    let hour;
    let min;
    let sec;
    if (tag === "gentime") {
        year = str.slice(0, 4) | 0;
        mon = str.slice(4, 6) | 0;
        day = str.slice(6, 8) | 0;
        hour = str.slice(8, 10) | 0;
        min = str.slice(10, 12) | 0;
        sec = str.slice(12, 14) | 0;
    } else if (tag === "utctime") {
        year = str.slice(0, 2) | 0;
        mon = str.slice(2, 4) | 0;
        day = str.slice(4, 6) | 0;
        hour = str.slice(6, 8) | 0;
        min = str.slice(8, 10) | 0;
        sec = str.slice(10, 12) | 0;
        if (year < 70) year = 2000 + year;
        else year = 1900 + year;
    } else return buffer.error("Decoding " + tag + " time is not supported yet");
    return Date.UTC(year, mon - 1, day, hour, min, sec, 0);
};
$71f23e3d24920fc8$var$DERNode.prototype._decodeNull = function decodeNull() {
    return null;
};
$71f23e3d24920fc8$var$DERNode.prototype._decodeBool = function decodeBool(buffer) {
    const res = buffer.readUInt8();
    if (buffer.isError(res)) return res;
    else return res !== 0;
};
$71f23e3d24920fc8$var$DERNode.prototype._decodeInt = function decodeInt(buffer, values) {
    // Bigint, return as it is (assume big endian)
    const raw = buffer.raw();
    let res = new $7vYz3(raw);
    if (values) res = values[res.toString(10)] || res;
    return res;
};
$71f23e3d24920fc8$var$DERNode.prototype._use = function use(entity, obj) {
    if (typeof entity === "function") entity = entity(obj);
    return entity._getDecoder("der").tree;
};
// Utility methods
function $71f23e3d24920fc8$var$derDecodeTag(buf, fail) {
    let tag = buf.readUInt8(fail);
    if (buf.isError(tag)) return tag;
    const cls = $6SLsO.tagClass[tag >> 6];
    const primitive = (tag & 0x20) === 0;
    // Multi-octet tag - load
    if ((tag & 0x1f) === 0x1f) {
        let oct = tag;
        tag = 0;
        while((oct & 0x80) === 0x80){
            oct = buf.readUInt8(fail);
            if (buf.isError(oct)) return oct;
            tag <<= 7;
            tag |= oct & 0x7f;
        }
    } else tag &= 0x1f;
    const tagStr = $6SLsO.tag[tag];
    return {
        cls: cls,
        primitive: primitive,
        tag: tag,
        tagStr: tagStr
    };
}
function $71f23e3d24920fc8$var$derDecodeLen(buf, primitive, fail) {
    let len = buf.readUInt8(fail);
    if (buf.isError(len)) return len;
    // Indefinite form
    if (!primitive && len === 0x80) return null;
    // Definite form
    if ((len & 0x80) === 0) // Short form
    return len;
    // Long form
    const num = len & 0x7f;
    if (num > 4) return buf.error("length octect is too long");
    len = 0;
    for(let i = 0; i < num; i++){
        len <<= 8;
        const j = buf.readUInt8(fail);
        if (buf.isError(j)) return j;
        len |= j;
    }
    return len;
}

});

parcelRequire.register("3KeDh", function(module, exports) {
"use strict";

var $eSHUL = parcelRequire("eSHUL");

var $dLNO7 = parcelRequire("dLNO7");
var $2ba104b685a3b739$require$Buffer = $dLNO7.Buffer;

var $9Mx3V = parcelRequire("9Mx3V");
function $2ba104b685a3b739$var$PEMDecoder(entity) {
    $9Mx3V.call(this, entity);
    this.enc = "pem";
}
$eSHUL($2ba104b685a3b739$var$PEMDecoder, $9Mx3V);
module.exports = $2ba104b685a3b739$var$PEMDecoder;
$2ba104b685a3b739$var$PEMDecoder.prototype.decode = function decode(data, options) {
    const lines = data.toString().split(/[\r\n]+/g);
    const label = options.label.toUpperCase();
    const re = /^-----(BEGIN|END) ([^-]+)-----$/;
    let start = -1;
    let end = -1;
    for(let i = 0; i < lines.length; i++){
        const match = lines[i].match(re);
        if (match === null) continue;
        if (match[2] !== label) continue;
        if (start === -1) {
            if (match[1] !== "BEGIN") break;
            start = i;
        } else {
            if (match[1] !== "END") break;
            end = i;
            break;
        }
    }
    if (start === -1 || end === -1) throw new Error("PEM section not found for: " + label);
    const base64 = lines.slice(start + 1, end).join("");
    // Remove excessive symbols
    base64.replace(/[^a-z0-9+/=]+/gi, "");
    const input = $2ba104b685a3b739$require$Buffer.from(base64, "base64");
    return $9Mx3V.prototype.decode.call(this, input, options);
};

});



parcelRequire.register("eMucS", function(module, exports) {
"use strict";
const $ac2cfaccb178df17$var$base = module.exports;

$ac2cfaccb178df17$var$base.Reporter = (parcelRequire("1NWy8")).Reporter;

$ac2cfaccb178df17$var$base.DecoderBuffer = (parcelRequire("hJsPi")).DecoderBuffer;

$ac2cfaccb178df17$var$base.EncoderBuffer = (parcelRequire("hJsPi")).EncoderBuffer;

$ac2cfaccb178df17$var$base.Node = (parcelRequire("aAKRg"));

});

parcelRequire.register("2Qobq", function(module, exports) {
"use strict";
const $2123325f185a31d1$var$constants = module.exports;
// Helper
$2123325f185a31d1$var$constants._reverse = function reverse(map) {
    const res = {};
    Object.keys(map).forEach(function(key) {
        // Convert key to integer if it is stringified
        if ((key | 0) == key) key = key | 0;
        const value = map[key];
        res[value] = key;
    });
    return res;
};

$2123325f185a31d1$var$constants.der = (parcelRequire("6SLsO"));

});


parcelRequire.register("aa7wN", function(module, exports) {
// from https://github.com/Rantanen/node-dtls/blob/25a7dc861bda38cfeac93a723500eea4f0ac2e86/Certificate.js
// thanks to @Rantanen
"use strict";

var $aMCkA = parcelRequire("aMCkA");
var $7660ad76acc34f2e$var$Time = $aMCkA.define("Time", function() {
    this.choice({
        utcTime: this.utctime(),
        generalTime: this.gentime()
    });
});
var $7660ad76acc34f2e$var$AttributeTypeValue = $aMCkA.define("AttributeTypeValue", function() {
    this.seq().obj(this.key("type").objid(), this.key("value").any());
});
var $7660ad76acc34f2e$var$AlgorithmIdentifier = $aMCkA.define("AlgorithmIdentifier", function() {
    this.seq().obj(this.key("algorithm").objid(), this.key("parameters").optional(), this.key("curve").objid().optional());
});
var $7660ad76acc34f2e$var$SubjectPublicKeyInfo = $aMCkA.define("SubjectPublicKeyInfo", function() {
    this.seq().obj(this.key("algorithm").use($7660ad76acc34f2e$var$AlgorithmIdentifier), this.key("subjectPublicKey").bitstr());
});
var $7660ad76acc34f2e$var$RelativeDistinguishedName = $aMCkA.define("RelativeDistinguishedName", function() {
    this.setof($7660ad76acc34f2e$var$AttributeTypeValue);
});
var $7660ad76acc34f2e$var$RDNSequence = $aMCkA.define("RDNSequence", function() {
    this.seqof($7660ad76acc34f2e$var$RelativeDistinguishedName);
});
var $7660ad76acc34f2e$var$Name = $aMCkA.define("Name", function() {
    this.choice({
        rdnSequence: this.use($7660ad76acc34f2e$var$RDNSequence)
    });
});
var $7660ad76acc34f2e$var$Validity = $aMCkA.define("Validity", function() {
    this.seq().obj(this.key("notBefore").use($7660ad76acc34f2e$var$Time), this.key("notAfter").use($7660ad76acc34f2e$var$Time));
});
var $7660ad76acc34f2e$var$Extension = $aMCkA.define("Extension", function() {
    this.seq().obj(this.key("extnID").objid(), this.key("critical").bool().def(false), this.key("extnValue").octstr());
});
var $7660ad76acc34f2e$var$TBSCertificate = $aMCkA.define("TBSCertificate", function() {
    this.seq().obj(this.key("version").explicit(0).int().optional(), this.key("serialNumber").int(), this.key("signature").use($7660ad76acc34f2e$var$AlgorithmIdentifier), this.key("issuer").use($7660ad76acc34f2e$var$Name), this.key("validity").use($7660ad76acc34f2e$var$Validity), this.key("subject").use($7660ad76acc34f2e$var$Name), this.key("subjectPublicKeyInfo").use($7660ad76acc34f2e$var$SubjectPublicKeyInfo), this.key("issuerUniqueID").implicit(1).bitstr().optional(), this.key("subjectUniqueID").implicit(2).bitstr().optional(), this.key("extensions").explicit(3).seqof($7660ad76acc34f2e$var$Extension).optional());
});
var $7660ad76acc34f2e$var$X509Certificate = $aMCkA.define("X509Certificate", function() {
    this.seq().obj(this.key("tbsCertificate").use($7660ad76acc34f2e$var$TBSCertificate), this.key("signatureAlgorithm").use($7660ad76acc34f2e$var$AlgorithmIdentifier), this.key("signatureValue").bitstr());
});
module.exports = $7660ad76acc34f2e$var$X509Certificate;

});


parcelRequire.register("buRsR", function(module, exports) {
module.exports = JSON.parse('{"2.16.840.1.101.3.4.1.1":"aes-128-ecb","2.16.840.1.101.3.4.1.2":"aes-128-cbc","2.16.840.1.101.3.4.1.3":"aes-128-ofb","2.16.840.1.101.3.4.1.4":"aes-128-cfb","2.16.840.1.101.3.4.1.21":"aes-192-ecb","2.16.840.1.101.3.4.1.22":"aes-192-cbc","2.16.840.1.101.3.4.1.23":"aes-192-ofb","2.16.840.1.101.3.4.1.24":"aes-192-cfb","2.16.840.1.101.3.4.1.41":"aes-256-ecb","2.16.840.1.101.3.4.1.42":"aes-256-cbc","2.16.840.1.101.3.4.1.43":"aes-256-ofb","2.16.840.1.101.3.4.1.44":"aes-256-cfb"}');

});

parcelRequire.register("hpCup", function(module, exports) {
// adapted from https://github.com/apatil/pemstrip
var $cad2a0aed7a43a6b$var$findProc = /Proc-Type: 4,ENCRYPTED[\n\r]+DEK-Info: AES-((?:128)|(?:192)|(?:256))-CBC,([0-9A-H]+)[\n\r]+([0-9A-z\n\r+/=]+)[\n\r]+/m;
var $cad2a0aed7a43a6b$var$startRegex = /^-----BEGIN ((?:.*? KEY)|CERTIFICATE)-----/m;
var $cad2a0aed7a43a6b$var$fullRegex = /^-----BEGIN ((?:.*? KEY)|CERTIFICATE)-----([0-9A-z\n\r+/=]+)-----END \1-----$/m;

var $5uIwM = parcelRequire("5uIwM");

var $k1gB1 = parcelRequire("k1gB1");

var $6U9mG = parcelRequire("6U9mG");
var $cad2a0aed7a43a6b$require$Buffer = $6U9mG.Buffer;
module.exports = function(okey, password) {
    var key = okey.toString();
    var match = key.match($cad2a0aed7a43a6b$var$findProc);
    var decrypted;
    if (!match) {
        var match2 = key.match($cad2a0aed7a43a6b$var$fullRegex);
        decrypted = $cad2a0aed7a43a6b$require$Buffer.from(match2[2].replace(/[\r\n]/g, ""), "base64");
    } else {
        var suite = "aes" + match[1];
        var iv = $cad2a0aed7a43a6b$require$Buffer.from(match[2], "hex");
        var cipherText = $cad2a0aed7a43a6b$require$Buffer.from(match[3].replace(/[\r\n]/g, ""), "base64");
        var cipherKey = $5uIwM(password, iv.slice(0, 8), parseInt(match[1], 10)).key;
        var out = [];
        var cipher = $k1gB1.createDecipheriv(suite, cipherKey, iv);
        out.push(cipher.update(cipherText));
        out.push(cipher.final());
        decrypted = $cad2a0aed7a43a6b$require$Buffer.concat(out);
    }
    var tag = key.match($cad2a0aed7a43a6b$var$startRegex)[1];
    return {
        tag: tag,
        data: decrypted
    };
};

});


parcelRequire.register("i66tY", function(module, exports) {
module.exports = JSON.parse('{"1.3.132.0.10":"secp256k1","1.3.132.0.33":"p224","1.2.840.10045.3.1.1":"p192","1.2.840.10045.3.1.7":"p256","1.3.132.0.34":"p384","1.3.132.0.35":"p521"}');

});


parcelRequire.register("eri43", function(module, exports) {
// much of this based on https://github.com/indutny/self-signed/blob/gh-pages/lib/rsa.js

var $6U9mG = parcelRequire("6U9mG");
var $a831998143a5cb0b$require$Buffer = $6U9mG.Buffer;

var $4B7L6 = parcelRequire("4B7L6");

var $8J1ou = parcelRequire("8J1ou");
var $a831998143a5cb0b$require$EC = $8J1ou.ec;

var $579Op = parcelRequire("579Op");

var $i66tY = parcelRequire("i66tY");
function $a831998143a5cb0b$var$verify(sig, hash, key, signType, tag) {
    var pub = $579Op(key);
    if (pub.type === "ec") {
        // rsa keys can be interpreted as ecdsa ones in openssl
        if (signType !== "ecdsa" && signType !== "ecdsa/rsa") throw new Error("wrong public key type");
        return $a831998143a5cb0b$var$ecVerify(sig, hash, pub);
    } else if (pub.type === "dsa") {
        if (signType !== "dsa") throw new Error("wrong public key type");
        return $a831998143a5cb0b$var$dsaVerify(sig, hash, pub);
    } else {
        if (signType !== "rsa" && signType !== "ecdsa/rsa") throw new Error("wrong public key type");
    }
    hash = $a831998143a5cb0b$require$Buffer.concat([
        tag,
        hash
    ]);
    var len = pub.modulus.byteLength();
    var pad = [
        1
    ];
    var padNum = 0;
    while(hash.length + pad.length + 2 < len){
        pad.push(0xff);
        padNum++;
    }
    pad.push(0x00);
    var i = -1;
    while(++i < hash.length)pad.push(hash[i]);
    pad = $a831998143a5cb0b$require$Buffer.from(pad);
    var red = $4B7L6.mont(pub.modulus);
    sig = new $4B7L6(sig).toRed(red);
    sig = sig.redPow(new $4B7L6(pub.publicExponent));
    sig = $a831998143a5cb0b$require$Buffer.from(sig.fromRed().toArray());
    var out = padNum < 8 ? 1 : 0;
    len = Math.min(sig.length, pad.length);
    if (sig.length !== pad.length) out = 1;
    i = -1;
    while(++i < len)out |= sig[i] ^ pad[i];
    return out === 0;
}
function $a831998143a5cb0b$var$ecVerify(sig, hash, pub) {
    var curveId = $i66tY[pub.data.algorithm.curve.join(".")];
    if (!curveId) throw new Error("unknown curve " + pub.data.algorithm.curve.join("."));
    var curve = new $a831998143a5cb0b$require$EC(curveId);
    var pubkey = pub.data.subjectPrivateKey.data;
    return curve.verify(hash, sig, pubkey);
}
function $a831998143a5cb0b$var$dsaVerify(sig, hash, pub) {
    var p = pub.data.p;
    var q = pub.data.q;
    var g = pub.data.g;
    var y = pub.data.pub_key;
    var unpacked = $579Op.signature.decode(sig, "der");
    var s = unpacked.s;
    var r = unpacked.r;
    $a831998143a5cb0b$var$checkValue(s, q);
    $a831998143a5cb0b$var$checkValue(r, q);
    var montp = $4B7L6.mont(p);
    var w = s.invm(q);
    var v = g.toRed(montp).redPow(new $4B7L6(hash).mul(w).mod(q)).fromRed().mul(y.toRed(montp).redPow(r.mul(w).mod(q)).fromRed()).mod(p).mod(q);
    return v.cmp(r) === 0;
}
function $a831998143a5cb0b$var$checkValue(b, q) {
    if (b.cmpn(0) <= 0) throw new Error("invalid sig");
    if (b.cmp(q) >= q) throw new Error("invalid sig");
}
module.exports = $a831998143a5cb0b$var$verify;

});


parcelRequire.register("bpRNH", function(module, exports) {

var $ihoyg = parcelRequire("ihoyg");
var $84fbc32b9717e45c$require$Buffer = $ihoyg.Buffer;

var $8J1ou = parcelRequire("8J1ou");

var $7vYz3 = parcelRequire("7vYz3");
module.exports = function createECDH(curve) {
    return new $84fbc32b9717e45c$var$ECDH(curve);
};
var $84fbc32b9717e45c$var$aliases = {
    secp256k1: {
        name: "secp256k1",
        byteLength: 32
    },
    secp224r1: {
        name: "p224",
        byteLength: 28
    },
    prime256v1: {
        name: "p256",
        byteLength: 32
    },
    prime192v1: {
        name: "p192",
        byteLength: 24
    },
    ed25519: {
        name: "ed25519",
        byteLength: 32
    },
    secp384r1: {
        name: "p384",
        byteLength: 48
    },
    secp521r1: {
        name: "p521",
        byteLength: 66
    }
};
$84fbc32b9717e45c$var$aliases.p224 = $84fbc32b9717e45c$var$aliases.secp224r1;
$84fbc32b9717e45c$var$aliases.p256 = $84fbc32b9717e45c$var$aliases.secp256r1 = $84fbc32b9717e45c$var$aliases.prime256v1;
$84fbc32b9717e45c$var$aliases.p192 = $84fbc32b9717e45c$var$aliases.secp192r1 = $84fbc32b9717e45c$var$aliases.prime192v1;
$84fbc32b9717e45c$var$aliases.p384 = $84fbc32b9717e45c$var$aliases.secp384r1;
$84fbc32b9717e45c$var$aliases.p521 = $84fbc32b9717e45c$var$aliases.secp521r1;
function $84fbc32b9717e45c$var$ECDH(curve) {
    this.curveType = $84fbc32b9717e45c$var$aliases[curve];
    if (!this.curveType) this.curveType = {
        name: curve
    };
    this.curve = new $8J1ou.ec(this.curveType.name) // eslint-disable-line new-cap
    ;
    this.keys = void 0;
}
$84fbc32b9717e45c$var$ECDH.prototype.generateKeys = function(enc, format) {
    this.keys = this.curve.genKeyPair();
    return this.getPublicKey(enc, format);
};
$84fbc32b9717e45c$var$ECDH.prototype.computeSecret = function(other, inenc, enc) {
    inenc = inenc || "utf8";
    if (!$84fbc32b9717e45c$require$Buffer.isBuffer(other)) other = new $84fbc32b9717e45c$require$Buffer(other, inenc);
    var otherPub = this.curve.keyFromPublic(other).getPublic();
    var out = otherPub.mul(this.keys.getPrivate()).getX();
    return $84fbc32b9717e45c$var$formatReturnValue(out, enc, this.curveType.byteLength);
};
$84fbc32b9717e45c$var$ECDH.prototype.getPublicKey = function(enc, format) {
    var key = this.keys.getPublic(format === "compressed", true);
    if (format === "hybrid") {
        if (key[key.length - 1] % 2) key[0] = 7;
        else key[0] = 6;
    }
    return $84fbc32b9717e45c$var$formatReturnValue(key, enc);
};
$84fbc32b9717e45c$var$ECDH.prototype.getPrivateKey = function(enc) {
    return $84fbc32b9717e45c$var$formatReturnValue(this.keys.getPrivate(), enc);
};
$84fbc32b9717e45c$var$ECDH.prototype.setPublicKey = function(pub, enc) {
    enc = enc || "utf8";
    if (!$84fbc32b9717e45c$require$Buffer.isBuffer(pub)) pub = new $84fbc32b9717e45c$require$Buffer(pub, enc);
    this.keys._importPublic(pub);
    return this;
};
$84fbc32b9717e45c$var$ECDH.prototype.setPrivateKey = function(priv, enc) {
    enc = enc || "utf8";
    if (!$84fbc32b9717e45c$require$Buffer.isBuffer(priv)) priv = new $84fbc32b9717e45c$require$Buffer(priv, enc);
    var _priv = new $7vYz3(priv);
    _priv = _priv.toString(16);
    this.keys = this.curve.genKeyPair();
    this.keys._importPrivate(_priv);
    return this;
};
function $84fbc32b9717e45c$var$formatReturnValue(bn, enc, len) {
    if (!Array.isArray(bn)) bn = bn.toArray();
    var buf = new $84fbc32b9717e45c$require$Buffer(bn);
    if (len && buf.length < len) {
        var zeros = new $84fbc32b9717e45c$require$Buffer(len - buf.length);
        zeros.fill(0);
        buf = $84fbc32b9717e45c$require$Buffer.concat([
            zeros,
            buf
        ]);
    }
    if (!enc) return buf;
    else return buf.toString(enc);
}

});

parcelRequire.register("e8Hvp", function(module, exports) {

$parcel$export(module.exports, "publicEncrypt", function () { return $a4b38f5366ff7954$export$512823e338ddb1b7; }, function (v) { return $a4b38f5366ff7954$export$512823e338ddb1b7 = v; });
$parcel$export(module.exports, "privateDecrypt", function () { return $a4b38f5366ff7954$export$7efb24e2fddf99b9; }, function (v) { return $a4b38f5366ff7954$export$7efb24e2fddf99b9 = v; });
$parcel$export(module.exports, "privateEncrypt", function () { return $a4b38f5366ff7954$export$9d0e0c0c4a8d30f3; }, function (v) { return $a4b38f5366ff7954$export$9d0e0c0c4a8d30f3 = v; });
$parcel$export(module.exports, "publicDecrypt", function () { return $a4b38f5366ff7954$export$b9d55ff329113abd; }, function (v) { return $a4b38f5366ff7954$export$b9d55ff329113abd = v; });
var $a4b38f5366ff7954$export$512823e338ddb1b7;
var $a4b38f5366ff7954$export$7efb24e2fddf99b9;
var $a4b38f5366ff7954$export$9d0e0c0c4a8d30f3;
var $a4b38f5366ff7954$export$b9d55ff329113abd;

$a4b38f5366ff7954$export$512823e338ddb1b7 = (parcelRequire("4XSWL"));

$a4b38f5366ff7954$export$7efb24e2fddf99b9 = (parcelRequire("JGlZv"));
$a4b38f5366ff7954$export$9d0e0c0c4a8d30f3 = function privateEncrypt(key, buf) {
    return $a4b38f5366ff7954$export$512823e338ddb1b7(key, buf, true);
};
$a4b38f5366ff7954$export$b9d55ff329113abd = function publicDecrypt(key, buf) {
    return $a4b38f5366ff7954$export$7efb24e2fddf99b9(key, buf, true);
};

});
parcelRequire.register("4XSWL", function(module, exports) {

var $579Op = parcelRequire("579Op");

var $5rfiH = parcelRequire("5rfiH");

var $3FiLE = parcelRequire("3FiLE");

var $lRbMS = parcelRequire("lRbMS");

var $65ECs = parcelRequire("65ECs");

var $7vYz3 = parcelRequire("7vYz3");

var $d9Eed = parcelRequire("d9Eed");

var $hG1cM = parcelRequire("hG1cM");

var $6U9mG = parcelRequire("6U9mG");
var $39d74b68ba721c1e$require$Buffer = $6U9mG.Buffer;
module.exports = function publicEncrypt(publicKey, msg, reverse) {
    var padding;
    if (publicKey.padding) padding = publicKey.padding;
    else if (reverse) padding = 1;
    else padding = 4;
    var key = $579Op(publicKey);
    var paddedMsg;
    if (padding === 4) paddedMsg = $39d74b68ba721c1e$var$oaep(key, msg);
    else if (padding === 1) paddedMsg = $39d74b68ba721c1e$var$pkcs1(key, msg, reverse);
    else if (padding === 3) {
        paddedMsg = new $7vYz3(msg);
        if (paddedMsg.cmp(key.modulus) >= 0) throw new Error("data too long for modulus");
    } else throw new Error("unknown padding");
    if (reverse) return $hG1cM(paddedMsg, key);
    else return $d9Eed(paddedMsg, key);
};
function $39d74b68ba721c1e$var$oaep(key, msg) {
    var k = key.modulus.byteLength();
    var mLen = msg.length;
    var iHash = $3FiLE("sha1").update($39d74b68ba721c1e$require$Buffer.alloc(0)).digest();
    var hLen = iHash.length;
    var hLen2 = 2 * hLen;
    if (mLen > k - hLen2 - 2) throw new Error("message too long");
    var ps = $39d74b68ba721c1e$require$Buffer.alloc(k - mLen - hLen2 - 2);
    var dblen = k - hLen - 1;
    var seed = $5rfiH(hLen);
    var maskedDb = $65ECs($39d74b68ba721c1e$require$Buffer.concat([
        iHash,
        ps,
        $39d74b68ba721c1e$require$Buffer.alloc(1, 1),
        msg
    ], dblen), $lRbMS(seed, dblen));
    var maskedSeed = $65ECs(seed, $lRbMS(maskedDb, hLen));
    return new $7vYz3($39d74b68ba721c1e$require$Buffer.concat([
        $39d74b68ba721c1e$require$Buffer.alloc(1),
        maskedSeed,
        maskedDb
    ], k));
}
function $39d74b68ba721c1e$var$pkcs1(key, msg, reverse) {
    var mLen = msg.length;
    var k = key.modulus.byteLength();
    if (mLen > k - 11) throw new Error("message too long");
    var ps;
    if (reverse) ps = $39d74b68ba721c1e$require$Buffer.alloc(k - mLen - 3, 0xff);
    else ps = $39d74b68ba721c1e$var$nonZero(k - mLen - 3);
    return new $7vYz3($39d74b68ba721c1e$require$Buffer.concat([
        $39d74b68ba721c1e$require$Buffer.from([
            0,
            reverse ? 1 : 2
        ]),
        ps,
        $39d74b68ba721c1e$require$Buffer.alloc(1),
        msg
    ], k));
}
function $39d74b68ba721c1e$var$nonZero(len) {
    var out = $39d74b68ba721c1e$require$Buffer.allocUnsafe(len);
    var i = 0;
    var cache = $5rfiH(len * 2);
    var cur = 0;
    var num;
    while(i < len){
        if (cur === cache.length) {
            cache = $5rfiH(len * 2);
            cur = 0;
        }
        num = cache[cur++];
        if (num) out[i++] = num;
    }
    return out;
}

});
parcelRequire.register("lRbMS", function(module, exports) {

var $3FiLE = parcelRequire("3FiLE");

var $6U9mG = parcelRequire("6U9mG");
var $fe97b0ee2bc1dbf7$require$Buffer = $6U9mG.Buffer;
module.exports = function(seed, len) {
    var t = $fe97b0ee2bc1dbf7$require$Buffer.alloc(0);
    var i = 0;
    var c;
    while(t.length < len){
        c = $fe97b0ee2bc1dbf7$var$i2ops(i++);
        t = $fe97b0ee2bc1dbf7$require$Buffer.concat([
            t,
            $3FiLE("sha1").update(seed).update(c).digest()
        ]);
    }
    return t.slice(0, len);
};
function $fe97b0ee2bc1dbf7$var$i2ops(c) {
    var out = $fe97b0ee2bc1dbf7$require$Buffer.allocUnsafe(4);
    out.writeUInt32BE(c, 0);
    return out;
}

});

parcelRequire.register("65ECs", function(module, exports) {
module.exports = function xor(a, b) {
    var len = a.length;
    var i = -1;
    while(++i < len)a[i] ^= b[i];
    return a;
};

});

parcelRequire.register("d9Eed", function(module, exports) {

var $7vYz3 = parcelRequire("7vYz3");

var $6U9mG = parcelRequire("6U9mG");
var $993b521f149aacc0$require$Buffer = $6U9mG.Buffer;
function $993b521f149aacc0$var$withPublic(paddedMsg, key) {
    return $993b521f149aacc0$require$Buffer.from(paddedMsg.toRed($7vYz3.mont(key.modulus)).redPow(new $7vYz3(key.publicExponent)).fromRed().toArray());
}
module.exports = $993b521f149aacc0$var$withPublic;

});


parcelRequire.register("JGlZv", function(module, exports) {

var $579Op = parcelRequire("579Op");

var $lRbMS = parcelRequire("lRbMS");

var $65ECs = parcelRequire("65ECs");

var $7vYz3 = parcelRequire("7vYz3");

var $hG1cM = parcelRequire("hG1cM");

var $3FiLE = parcelRequire("3FiLE");

var $d9Eed = parcelRequire("d9Eed");

var $6U9mG = parcelRequire("6U9mG");
var $08950ea5301bc0f1$require$Buffer = $6U9mG.Buffer;
module.exports = function privateDecrypt(privateKey, enc, reverse) {
    var padding;
    if (privateKey.padding) padding = privateKey.padding;
    else if (reverse) padding = 1;
    else padding = 4;
    var key = $579Op(privateKey);
    var k = key.modulus.byteLength();
    if (enc.length > k || new $7vYz3(enc).cmp(key.modulus) >= 0) throw new Error("decryption error");
    var msg;
    if (reverse) msg = $d9Eed(new $7vYz3(enc), key);
    else msg = $hG1cM(enc, key);
    var zBuffer = $08950ea5301bc0f1$require$Buffer.alloc(k - msg.length);
    msg = $08950ea5301bc0f1$require$Buffer.concat([
        zBuffer,
        msg
    ], k);
    if (padding === 4) return $08950ea5301bc0f1$var$oaep(key, msg);
    else if (padding === 1) return $08950ea5301bc0f1$var$pkcs1(key, msg, reverse);
    else if (padding === 3) return msg;
    else throw new Error("unknown padding");
};
function $08950ea5301bc0f1$var$oaep(key, msg) {
    var k = key.modulus.byteLength();
    var iHash = $3FiLE("sha1").update($08950ea5301bc0f1$require$Buffer.alloc(0)).digest();
    var hLen = iHash.length;
    if (msg[0] !== 0) throw new Error("decryption error");
    var maskedSeed = msg.slice(1, hLen + 1);
    var maskedDb = msg.slice(hLen + 1);
    var seed = $65ECs(maskedSeed, $lRbMS(maskedDb, hLen));
    var db = $65ECs(maskedDb, $lRbMS(seed, k - hLen - 1));
    if ($08950ea5301bc0f1$var$compare(iHash, db.slice(0, hLen))) throw new Error("decryption error");
    var i = hLen;
    while(db[i] === 0)i++;
    if (db[i++] !== 1) throw new Error("decryption error");
    return db.slice(i);
}
function $08950ea5301bc0f1$var$pkcs1(key, msg, reverse) {
    var p1 = msg.slice(0, 2);
    var i = 2;
    var status = 0;
    while(msg[i++] !== 0)if (i >= msg.length) {
        status++;
        break;
    }
    var ps = msg.slice(2, i - 1);
    if (p1.toString("hex") !== "0002" && !reverse || p1.toString("hex") !== "0001" && reverse) status++;
    if (ps.length < 8) status++;
    if (status) throw new Error("decryption error");
    return msg.slice(i);
}
function $08950ea5301bc0f1$var$compare(a, b) {
    a = $08950ea5301bc0f1$require$Buffer.from(a);
    b = $08950ea5301bc0f1$require$Buffer.from(b);
    var dif = 0;
    var len = a.length;
    if (a.length !== b.length) {
        dif++;
        len = Math.min(a.length, b.length);
    }
    var i = -1;
    while(++i < len)dif += a[i] ^ b[i];
    return dif;
}

});


parcelRequire.register("6zHAr", function(module, exports) {

$parcel$export(module.exports, "randomFill", function () { return $4c97d268940b2c08$export$bb1abf2ce84fc7e8; }, function (v) { return $4c97d268940b2c08$export$bb1abf2ce84fc7e8 = v; });
$parcel$export(module.exports, "randomFillSync", function () { return $4c97d268940b2c08$export$2f7171e78e524d5e; }, function (v) { return $4c97d268940b2c08$export$2f7171e78e524d5e = v; });
var $4c97d268940b2c08$export$bb1abf2ce84fc7e8;
var $4c97d268940b2c08$export$2f7171e78e524d5e;

var $4TNnu = parcelRequire("4TNnu");
"use strict";
function $4c97d268940b2c08$var$oldBrowser() {
    throw new Error("secure random number generation not supported by this browser\nuse chrome, FireFox or Internet Explorer 11");
}

var $6U9mG = parcelRequire("6U9mG");

var $5rfiH = parcelRequire("5rfiH");
var $4c97d268940b2c08$var$Buffer = $6U9mG.Buffer;
var $4c97d268940b2c08$var$kBufferMaxLength = $6U9mG.kMaxLength;
var $4c97d268940b2c08$var$crypto = $parcel$global.crypto || $parcel$global.msCrypto;
var $4c97d268940b2c08$var$kMaxUint32 = Math.pow(2, 32) - 1;
function $4c97d268940b2c08$var$assertOffset(offset, length) {
    if (typeof offset !== "number" || offset !== offset) throw new TypeError("offset must be a number");
    if (offset > $4c97d268940b2c08$var$kMaxUint32 || offset < 0) throw new TypeError("offset must be a uint32");
    if (offset > $4c97d268940b2c08$var$kBufferMaxLength || offset > length) throw new RangeError("offset out of range");
}
function $4c97d268940b2c08$var$assertSize(size, offset, length) {
    if (typeof size !== "number" || size !== size) throw new TypeError("size must be a number");
    if (size > $4c97d268940b2c08$var$kMaxUint32 || size < 0) throw new TypeError("size must be a uint32");
    if (size + offset > length || size > $4c97d268940b2c08$var$kBufferMaxLength) throw new RangeError("buffer too small");
}
if ($4c97d268940b2c08$var$crypto && $4c97d268940b2c08$var$crypto.getRandomValues || false) {
    $4c97d268940b2c08$export$bb1abf2ce84fc7e8 = $4c97d268940b2c08$var$randomFill;
    $4c97d268940b2c08$export$2f7171e78e524d5e = $4c97d268940b2c08$var$randomFillSync;
} else {
    $4c97d268940b2c08$export$bb1abf2ce84fc7e8 = $4c97d268940b2c08$var$oldBrowser;
    $4c97d268940b2c08$export$2f7171e78e524d5e = $4c97d268940b2c08$var$oldBrowser;
}
function $4c97d268940b2c08$var$randomFill(buf, offset, size, cb) {
    if (!$4c97d268940b2c08$var$Buffer.isBuffer(buf) && !(buf instanceof $parcel$global.Uint8Array)) throw new TypeError('"buf" argument must be a Buffer or Uint8Array');
    if (typeof offset === "function") {
        cb = offset;
        offset = 0;
        size = buf.length;
    } else if (typeof size === "function") {
        cb = size;
        size = buf.length - offset;
    } else if (typeof cb !== "function") throw new TypeError('"cb" argument must be a function');
    $4c97d268940b2c08$var$assertOffset(offset, buf.length);
    $4c97d268940b2c08$var$assertSize(size, offset, buf.length);
    return $4c97d268940b2c08$var$actualFill(buf, offset, size, cb);
}
function $4c97d268940b2c08$var$actualFill(buf, offset, size, cb) {
    var ourBuf = buf.buffer;
    var uint = new Uint8Array(ourBuf, offset, size);
    $4c97d268940b2c08$var$crypto.getRandomValues(uint);
    if (cb) {
        $4TNnu.nextTick(function() {
            cb(null, buf);
        });
        return;
    }
    return buf;
    if (cb) {
        $5rfiH(size, function(err, bytes) {
            if (err) return cb(err);
            bytes.copy(buf, offset);
            cb(null, buf);
        });
        return;
    }
    var bytes = $5rfiH(size);
    bytes.copy(buf, offset);
    return buf;
}
function $4c97d268940b2c08$var$randomFillSync(buf, offset, size) {
    if (typeof offset === "undefined") offset = 0;
    if (!$4c97d268940b2c08$var$Buffer.isBuffer(buf) && !(buf instanceof $parcel$global.Uint8Array)) throw new TypeError('"buf" argument must be a Buffer or Uint8Array');
    $4c97d268940b2c08$var$assertOffset(offset, buf.length);
    if (size === undefined) size = buf.length - offset;
    $4c97d268940b2c08$var$assertSize(size, offset, buf.length);
    return $4c97d268940b2c08$var$actualFill(buf, offset, size);
}

});




parcelRequire.register("gtrXq", function(module, exports) {

(function(module1, exports) {
    "use strict";
    // Utils
    function assert(val, msg) {
        if (!val) throw new Error(msg || "Assertion failed");
    }
    // Could use `inherits` module, but don't want to move from single file
    // architecture yet.
    function inherits(ctor, superCtor) {
        ctor.super_ = superCtor;
        var TempCtor = function() {};
        TempCtor.prototype = superCtor.prototype;
        ctor.prototype = new TempCtor();
        ctor.prototype.constructor = ctor;
    }
    // BN
    function BN(number, base, endian) {
        if (BN.isBN(number)) return number;
        this.negative = 0;
        this.words = null;
        this.length = 0;
        // Reduction context
        this.red = null;
        if (number !== null) {
            if (base === "le" || base === "be") {
                endian = base;
                base = 10;
            }
            this._init(number || 0, base || 10, endian || "be");
        }
    }
    if (typeof module1 === "object") module1.exports = BN;
    else exports.BN = BN;
    BN.BN = BN;
    BN.wordSize = 26;
    var Buffer;
    try {
        if (typeof window !== "undefined" && typeof window.Buffer !== "undefined") Buffer = window.Buffer;
        else Buffer = (parcelRequire("5Io6y")).Buffer;
    } catch (e) {}
    BN.isBN = function isBN(num) {
        if (num instanceof BN) return true;
        return num !== null && typeof num === "object" && num.constructor.wordSize === BN.wordSize && Array.isArray(num.words);
    };
    BN.max = function max(left, right) {
        if (left.cmp(right) > 0) return left;
        return right;
    };
    BN.min = function min(left, right) {
        if (left.cmp(right) < 0) return left;
        return right;
    };
    BN.prototype._init = function init(number, base, endian) {
        if (typeof number === "number") return this._initNumber(number, base, endian);
        if (typeof number === "object") return this._initArray(number, base, endian);
        if (base === "hex") base = 16;
        assert(base === (base | 0) && base >= 2 && base <= 36);
        number = number.toString().replace(/\s+/g, "");
        var start = 0;
        if (number[0] === "-") {
            start++;
            this.negative = 1;
        }
        if (start < number.length) {
            if (base === 16) this._parseHex(number, start, endian);
            else {
                this._parseBase(number, base, start);
                if (endian === "le") this._initArray(this.toArray(), base, endian);
            }
        }
    };
    BN.prototype._initNumber = function _initNumber(number, base, endian) {
        if (number < 0) {
            this.negative = 1;
            number = -number;
        }
        if (number < 0x4000000) {
            this.words = [
                number & 0x3ffffff
            ];
            this.length = 1;
        } else if (number < 0x10000000000000) {
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff
            ];
            this.length = 2;
        } else {
            assert(number < 0x20000000000000); // 2 ^ 53 (unsafe)
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff,
                1
            ];
            this.length = 3;
        }
        if (endian !== "le") return;
        // Reverse the bytes
        this._initArray(this.toArray(), base, endian);
    };
    BN.prototype._initArray = function _initArray(number, base, endian) {
        // Perhaps a Uint8Array
        assert(typeof number.length === "number");
        if (number.length <= 0) {
            this.words = [
                0
            ];
            this.length = 1;
            return this;
        }
        this.length = Math.ceil(number.length / 3);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        var j, w;
        var off = 0;
        if (endian === "be") for(i = number.length - 1, j = 0; i >= 0; i -= 3){
            w = number[i] | number[i - 1] << 8 | number[i - 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        else if (endian === "le") for(i = 0, j = 0; i < number.length; i += 3){
            w = number[i] | number[i + 1] << 8 | number[i + 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        return this._strip();
    };
    function parseHex4Bits(string, index) {
        var c = string.charCodeAt(index);
        // '0' - '9'
        if (c >= 48 && c <= 57) return c - 48;
        else if (c >= 65 && c <= 70) return c - 55;
        else if (c >= 97 && c <= 102) return c - 87;
        else assert(false, "Invalid character in " + string);
    }
    function parseHexByte(string, lowerBound, index) {
        var r = parseHex4Bits(string, index);
        if (index - 1 >= lowerBound) r |= parseHex4Bits(string, index - 1) << 4;
        return r;
    }
    BN.prototype._parseHex = function _parseHex(number, start, endian) {
        // Create possibly bigger array to ensure that it fits the number
        this.length = Math.ceil((number.length - start) / 6);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        // 24-bits chunks
        var off = 0;
        var j = 0;
        var w;
        if (endian === "be") for(i = number.length - 1; i >= start; i -= 2){
            w = parseHexByte(number, start, i) << off;
            this.words[j] |= w & 0x3ffffff;
            if (off >= 18) {
                off -= 18;
                j += 1;
                this.words[j] |= w >>> 26;
            } else off += 8;
        }
        else {
            var parseLength = number.length - start;
            for(i = parseLength % 2 === 0 ? start + 1 : start; i < number.length; i += 2){
                w = parseHexByte(number, start, i) << off;
                this.words[j] |= w & 0x3ffffff;
                if (off >= 18) {
                    off -= 18;
                    j += 1;
                    this.words[j] |= w >>> 26;
                } else off += 8;
            }
        }
        this._strip();
    };
    function parseBase(str, start, end, mul) {
        var r = 0;
        var b = 0;
        var len = Math.min(str.length, end);
        for(var i = start; i < len; i++){
            var c = str.charCodeAt(i) - 48;
            r *= mul;
            // 'a'
            if (c >= 49) b = c - 49 + 0xa;
            else if (c >= 17) b = c - 17 + 0xa;
            else b = c;
            assert(c >= 0 && b < mul, "Invalid character");
            r += b;
        }
        return r;
    }
    BN.prototype._parseBase = function _parseBase(number, base, start) {
        // Initialize as zero
        this.words = [
            0
        ];
        this.length = 1;
        // Find length of limb in base
        for(var limbLen = 0, limbPow = 1; limbPow <= 0x3ffffff; limbPow *= base)limbLen++;
        limbLen--;
        limbPow = limbPow / base | 0;
        var total = number.length - start;
        var mod = total % limbLen;
        var end = Math.min(total, total - mod) + start;
        var word = 0;
        for(var i = start; i < end; i += limbLen){
            word = parseBase(number, i, i + limbLen, base);
            this.imuln(limbPow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        if (mod !== 0) {
            var pow = 1;
            word = parseBase(number, i, number.length, base);
            for(i = 0; i < mod; i++)pow *= base;
            this.imuln(pow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        this._strip();
    };
    BN.prototype.copy = function copy(dest) {
        dest.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)dest.words[i] = this.words[i];
        dest.length = this.length;
        dest.negative = this.negative;
        dest.red = this.red;
    };
    function move(dest, src) {
        dest.words = src.words;
        dest.length = src.length;
        dest.negative = src.negative;
        dest.red = src.red;
    }
    BN.prototype._move = function _move(dest) {
        move(dest, this);
    };
    BN.prototype.clone = function clone() {
        var r = new BN(null);
        this.copy(r);
        return r;
    };
    BN.prototype._expand = function _expand(size) {
        while(this.length < size)this.words[this.length++] = 0;
        return this;
    };
    // Remove leading `0` from `this`
    BN.prototype._strip = function strip() {
        while(this.length > 1 && this.words[this.length - 1] === 0)this.length--;
        return this._normSign();
    };
    BN.prototype._normSign = function _normSign() {
        // -0 = 0
        if (this.length === 1 && this.words[0] === 0) this.negative = 0;
        return this;
    };
    // Check Symbol.for because not everywhere where Symbol defined
    // See https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Symbol#Browser_compatibility
    if (typeof Symbol !== "undefined" && typeof Symbol.for === "function") try {
        BN.prototype[Symbol.for("nodejs.util.inspect.custom")] = inspect;
    } catch (e) {
        BN.prototype.inspect = inspect;
    }
    else BN.prototype.inspect = inspect;
    function inspect() {
        return (this.red ? "<BN-R: " : "<BN: ") + this.toString(16) + ">";
    }
    /*

  var zeros = [];
  var groupSizes = [];
  var groupBases = [];

  var s = '';
  var i = -1;
  while (++i < BN.wordSize) {
    zeros[i] = s;
    s += '0';
  }
  groupSizes[0] = 0;
  groupSizes[1] = 0;
  groupBases[0] = 0;
  groupBases[1] = 0;
  var base = 2 - 1;
  while (++base < 36 + 1) {
    var groupSize = 0;
    var groupBase = 1;
    while (groupBase < (1 << BN.wordSize) / base) {
      groupBase *= base;
      groupSize += 1;
    }
    groupSizes[base] = groupSize;
    groupBases[base] = groupBase;
  }

  */ var zeros = [
        "",
        "0",
        "00",
        "000",
        "0000",
        "00000",
        "000000",
        "0000000",
        "00000000",
        "000000000",
        "0000000000",
        "00000000000",
        "000000000000",
        "0000000000000",
        "00000000000000",
        "000000000000000",
        "0000000000000000",
        "00000000000000000",
        "000000000000000000",
        "0000000000000000000",
        "00000000000000000000",
        "000000000000000000000",
        "0000000000000000000000",
        "00000000000000000000000",
        "000000000000000000000000",
        "0000000000000000000000000"
    ];
    var groupSizes = [
        0,
        0,
        25,
        16,
        12,
        11,
        10,
        9,
        8,
        8,
        7,
        7,
        7,
        7,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5
    ];
    var groupBases = [
        0,
        0,
        33554432,
        43046721,
        16777216,
        48828125,
        60466176,
        40353607,
        16777216,
        43046721,
        10000000,
        19487171,
        35831808,
        62748517,
        7529536,
        11390625,
        16777216,
        24137569,
        34012224,
        47045881,
        64000000,
        4084101,
        5153632,
        6436343,
        7962624,
        9765625,
        11881376,
        14348907,
        17210368,
        20511149,
        24300000,
        28629151,
        33554432,
        39135393,
        45435424,
        52521875,
        60466176
    ];
    BN.prototype.toString = function toString(base, padding) {
        base = base || 10;
        padding = padding | 0 || 1;
        var out;
        if (base === 16 || base === "hex") {
            out = "";
            var off = 0;
            var carry = 0;
            for(var i = 0; i < this.length; i++){
                var w = this.words[i];
                var word = ((w << off | carry) & 0xffffff).toString(16);
                carry = w >>> 24 - off & 0xffffff;
                off += 2;
                if (off >= 26) {
                    off -= 26;
                    i--;
                }
                if (carry !== 0 || i !== this.length - 1) out = zeros[6 - word.length] + word + out;
                else out = word + out;
            }
            if (carry !== 0) out = carry.toString(16) + out;
            while(out.length % padding !== 0)out = "0" + out;
            if (this.negative !== 0) out = "-" + out;
            return out;
        }
        if (base === (base | 0) && base >= 2 && base <= 36) {
            // var groupSize = Math.floor(BN.wordSize * Math.LN2 / Math.log(base));
            var groupSize = groupSizes[base];
            // var groupBase = Math.pow(base, groupSize);
            var groupBase = groupBases[base];
            out = "";
            var c = this.clone();
            c.negative = 0;
            while(!c.isZero()){
                var r = c.modrn(groupBase).toString(base);
                c = c.idivn(groupBase);
                if (!c.isZero()) out = zeros[groupSize - r.length] + r + out;
                else out = r + out;
            }
            if (this.isZero()) out = "0" + out;
            while(out.length % padding !== 0)out = "0" + out;
            if (this.negative !== 0) out = "-" + out;
            return out;
        }
        assert(false, "Base should be between 2 and 36");
    };
    BN.prototype.toNumber = function toNumber() {
        var ret = this.words[0];
        if (this.length === 2) ret += this.words[1] * 0x4000000;
        else if (this.length === 3 && this.words[2] === 0x01) // NOTE: at this stage it is known that the top bit is set
        ret += 0x10000000000000 + this.words[1] * 0x4000000;
        else if (this.length > 2) assert(false, "Number can only safely store up to 53 bits");
        return this.negative !== 0 ? -ret : ret;
    };
    BN.prototype.toJSON = function toJSON() {
        return this.toString(16, 2);
    };
    if (Buffer) BN.prototype.toBuffer = function toBuffer(endian, length) {
        return this.toArrayLike(Buffer, endian, length);
    };
    BN.prototype.toArray = function toArray(endian, length) {
        return this.toArrayLike(Array, endian, length);
    };
    var allocate = function allocate(ArrayType, size) {
        if (ArrayType.allocUnsafe) return ArrayType.allocUnsafe(size);
        return new ArrayType(size);
    };
    BN.prototype.toArrayLike = function toArrayLike(ArrayType, endian, length) {
        this._strip();
        var byteLength = this.byteLength();
        var reqLength = length || Math.max(1, byteLength);
        assert(byteLength <= reqLength, "byte array longer than desired length");
        assert(reqLength > 0, "Requested array length <= 0");
        var res = allocate(ArrayType, reqLength);
        var postfix = endian === "le" ? "LE" : "BE";
        this["_toArrayLike" + postfix](res, byteLength);
        return res;
    };
    BN.prototype._toArrayLikeLE = function _toArrayLikeLE(res, byteLength) {
        var position = 0;
        var carry = 0;
        for(var i = 0, shift = 0; i < this.length; i++){
            var word = this.words[i] << shift | carry;
            res[position++] = word & 0xff;
            if (position < res.length) res[position++] = word >> 8 & 0xff;
            if (position < res.length) res[position++] = word >> 16 & 0xff;
            if (shift === 6) {
                if (position < res.length) res[position++] = word >> 24 & 0xff;
                carry = 0;
                shift = 0;
            } else {
                carry = word >>> 24;
                shift += 2;
            }
        }
        if (position < res.length) {
            res[position++] = carry;
            while(position < res.length)res[position++] = 0;
        }
    };
    BN.prototype._toArrayLikeBE = function _toArrayLikeBE(res, byteLength) {
        var position = res.length - 1;
        var carry = 0;
        for(var i = 0, shift = 0; i < this.length; i++){
            var word = this.words[i] << shift | carry;
            res[position--] = word & 0xff;
            if (position >= 0) res[position--] = word >> 8 & 0xff;
            if (position >= 0) res[position--] = word >> 16 & 0xff;
            if (shift === 6) {
                if (position >= 0) res[position--] = word >> 24 & 0xff;
                carry = 0;
                shift = 0;
            } else {
                carry = word >>> 24;
                shift += 2;
            }
        }
        if (position >= 0) {
            res[position--] = carry;
            while(position >= 0)res[position--] = 0;
        }
    };
    if (Math.clz32) BN.prototype._countBits = function _countBits(w) {
        return 32 - Math.clz32(w);
    };
    else BN.prototype._countBits = function _countBits(w) {
        var t = w;
        var r = 0;
        if (t >= 0x1000) {
            r += 13;
            t >>>= 13;
        }
        if (t >= 0x40) {
            r += 7;
            t >>>= 7;
        }
        if (t >= 0x8) {
            r += 4;
            t >>>= 4;
        }
        if (t >= 0x02) {
            r += 2;
            t >>>= 2;
        }
        return r + t;
    };
    BN.prototype._zeroBits = function _zeroBits(w) {
        // Short-cut
        if (w === 0) return 26;
        var t = w;
        var r = 0;
        if ((t & 0x1fff) === 0) {
            r += 13;
            t >>>= 13;
        }
        if ((t & 0x7f) === 0) {
            r += 7;
            t >>>= 7;
        }
        if ((t & 0xf) === 0) {
            r += 4;
            t >>>= 4;
        }
        if ((t & 0x3) === 0) {
            r += 2;
            t >>>= 2;
        }
        if ((t & 0x1) === 0) r++;
        return r;
    };
    // Return number of used bits in a BN
    BN.prototype.bitLength = function bitLength() {
        var w = this.words[this.length - 1];
        var hi = this._countBits(w);
        return (this.length - 1) * 26 + hi;
    };
    function toBitArray(num) {
        var w = new Array(num.bitLength());
        for(var bit = 0; bit < w.length; bit++){
            var off = bit / 26 | 0;
            var wbit = bit % 26;
            w[bit] = num.words[off] >>> wbit & 0x01;
        }
        return w;
    }
    // Number of trailing zero bits
    BN.prototype.zeroBits = function zeroBits() {
        if (this.isZero()) return 0;
        var r = 0;
        for(var i = 0; i < this.length; i++){
            var b = this._zeroBits(this.words[i]);
            r += b;
            if (b !== 26) break;
        }
        return r;
    };
    BN.prototype.byteLength = function byteLength() {
        return Math.ceil(this.bitLength() / 8);
    };
    BN.prototype.toTwos = function toTwos(width) {
        if (this.negative !== 0) return this.abs().inotn(width).iaddn(1);
        return this.clone();
    };
    BN.prototype.fromTwos = function fromTwos(width) {
        if (this.testn(width - 1)) return this.notn(width).iaddn(1).ineg();
        return this.clone();
    };
    BN.prototype.isNeg = function isNeg() {
        return this.negative !== 0;
    };
    // Return negative clone of `this`
    BN.prototype.neg = function neg() {
        return this.clone().ineg();
    };
    BN.prototype.ineg = function ineg() {
        if (!this.isZero()) this.negative ^= 1;
        return this;
    };
    // Or `num` with `this` in-place
    BN.prototype.iuor = function iuor(num) {
        while(this.length < num.length)this.words[this.length++] = 0;
        for(var i = 0; i < num.length; i++)this.words[i] = this.words[i] | num.words[i];
        return this._strip();
    };
    BN.prototype.ior = function ior(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuor(num);
    };
    // Or `num` with `this`
    BN.prototype.or = function or(num) {
        if (this.length > num.length) return this.clone().ior(num);
        return num.clone().ior(this);
    };
    BN.prototype.uor = function uor(num) {
        if (this.length > num.length) return this.clone().iuor(num);
        return num.clone().iuor(this);
    };
    // And `num` with `this` in-place
    BN.prototype.iuand = function iuand(num) {
        // b = min-length(num, this)
        var b;
        if (this.length > num.length) b = num;
        else b = this;
        for(var i = 0; i < b.length; i++)this.words[i] = this.words[i] & num.words[i];
        this.length = b.length;
        return this._strip();
    };
    BN.prototype.iand = function iand(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuand(num);
    };
    // And `num` with `this`
    BN.prototype.and = function and(num) {
        if (this.length > num.length) return this.clone().iand(num);
        return num.clone().iand(this);
    };
    BN.prototype.uand = function uand(num) {
        if (this.length > num.length) return this.clone().iuand(num);
        return num.clone().iuand(this);
    };
    // Xor `num` with `this` in-place
    BN.prototype.iuxor = function iuxor(num) {
        // a.length > b.length
        var a;
        var b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        for(var i = 0; i < b.length; i++)this.words[i] = a.words[i] ^ b.words[i];
        if (this !== a) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = a.length;
        return this._strip();
    };
    BN.prototype.ixor = function ixor(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuxor(num);
    };
    // Xor `num` with `this`
    BN.prototype.xor = function xor(num) {
        if (this.length > num.length) return this.clone().ixor(num);
        return num.clone().ixor(this);
    };
    BN.prototype.uxor = function uxor(num) {
        if (this.length > num.length) return this.clone().iuxor(num);
        return num.clone().iuxor(this);
    };
    // Not ``this`` with ``width`` bitwidth
    BN.prototype.inotn = function inotn(width) {
        assert(typeof width === "number" && width >= 0);
        var bytesNeeded = Math.ceil(width / 26) | 0;
        var bitsLeft = width % 26;
        // Extend the buffer with leading zeroes
        this._expand(bytesNeeded);
        if (bitsLeft > 0) bytesNeeded--;
        // Handle complete words
        for(var i = 0; i < bytesNeeded; i++)this.words[i] = ~this.words[i] & 0x3ffffff;
        // Handle the residue
        if (bitsLeft > 0) this.words[i] = ~this.words[i] & 0x3ffffff >> 26 - bitsLeft;
        // And remove leading zeroes
        return this._strip();
    };
    BN.prototype.notn = function notn(width) {
        return this.clone().inotn(width);
    };
    // Set `bit` of `this`
    BN.prototype.setn = function setn(bit, val) {
        assert(typeof bit === "number" && bit >= 0);
        var off = bit / 26 | 0;
        var wbit = bit % 26;
        this._expand(off + 1);
        if (val) this.words[off] = this.words[off] | 1 << wbit;
        else this.words[off] = this.words[off] & ~(1 << wbit);
        return this._strip();
    };
    // Add `num` to `this` in-place
    BN.prototype.iadd = function iadd(num) {
        var r;
        // negative + positive
        if (this.negative !== 0 && num.negative === 0) {
            this.negative = 0;
            r = this.isub(num);
            this.negative ^= 1;
            return this._normSign();
        // positive + negative
        } else if (this.negative === 0 && num.negative !== 0) {
            num.negative = 0;
            r = this.isub(num);
            num.negative = 1;
            return r._normSign();
        }
        // a.length > b.length
        var a, b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) + (b.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        this.length = a.length;
        if (carry !== 0) {
            this.words[this.length] = carry;
            this.length++;
        // Copy the rest of the words
        } else if (a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        return this;
    };
    // Add `num` to `this`
    BN.prototype.add = function add(num) {
        var res;
        if (num.negative !== 0 && this.negative === 0) {
            num.negative = 0;
            res = this.sub(num);
            num.negative ^= 1;
            return res;
        } else if (num.negative === 0 && this.negative !== 0) {
            this.negative = 0;
            res = num.sub(this);
            this.negative = 1;
            return res;
        }
        if (this.length > num.length) return this.clone().iadd(num);
        return num.clone().iadd(this);
    };
    // Subtract `num` from `this` in-place
    BN.prototype.isub = function isub(num) {
        // this - (-num) = this + num
        if (num.negative !== 0) {
            num.negative = 0;
            var r = this.iadd(num);
            num.negative = 1;
            return r._normSign();
        // -this - num = -(this + num)
        } else if (this.negative !== 0) {
            this.negative = 0;
            this.iadd(num);
            this.negative = 1;
            return this._normSign();
        }
        // At this point both numbers are positive
        var cmp = this.cmp(num);
        // Optimization - zeroify
        if (cmp === 0) {
            this.negative = 0;
            this.length = 1;
            this.words[0] = 0;
            return this;
        }
        // a > b
        var a, b;
        if (cmp > 0) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) - (b.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        // Copy rest of the words
        if (carry === 0 && i < a.length && a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = Math.max(this.length, i);
        if (a !== this) this.negative = 1;
        return this._strip();
    };
    // Subtract `num` from `this`
    BN.prototype.sub = function sub(num) {
        return this.clone().isub(num);
    };
    function smallMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        var len = self.length + num.length | 0;
        out.length = len;
        len = len - 1 | 0;
        // Peel one iteration (compiler can't do it, because of code complexity)
        var a = self.words[0] | 0;
        var b = num.words[0] | 0;
        var r = a * b;
        var lo = r & 0x3ffffff;
        var carry = r / 0x4000000 | 0;
        out.words[0] = lo;
        for(var k = 1; k < len; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = carry >>> 26;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j | 0;
                a = self.words[i] | 0;
                b = num.words[j] | 0;
                r = a * b + rword;
                ncarry += r / 0x4000000 | 0;
                rword = r & 0x3ffffff;
            }
            out.words[k] = rword | 0;
            carry = ncarry | 0;
        }
        if (carry !== 0) out.words[k] = carry | 0;
        else out.length--;
        return out._strip();
    }
    // TODO(indutny): it may be reasonable to omit it for users who don't need
    // to work with 256-bit numbers, otherwise it gives 20% improvement for 256-bit
    // multiplication (like elliptic secp256k1).
    var comb10MulTo = function comb10MulTo(self, num, out) {
        var a = self.words;
        var b = num.words;
        var o = out.words;
        var c = 0;
        var lo;
        var mid;
        var hi;
        var a0 = a[0] | 0;
        var al0 = a0 & 0x1fff;
        var ah0 = a0 >>> 13;
        var a1 = a[1] | 0;
        var al1 = a1 & 0x1fff;
        var ah1 = a1 >>> 13;
        var a2 = a[2] | 0;
        var al2 = a2 & 0x1fff;
        var ah2 = a2 >>> 13;
        var a3 = a[3] | 0;
        var al3 = a3 & 0x1fff;
        var ah3 = a3 >>> 13;
        var a4 = a[4] | 0;
        var al4 = a4 & 0x1fff;
        var ah4 = a4 >>> 13;
        var a5 = a[5] | 0;
        var al5 = a5 & 0x1fff;
        var ah5 = a5 >>> 13;
        var a6 = a[6] | 0;
        var al6 = a6 & 0x1fff;
        var ah6 = a6 >>> 13;
        var a7 = a[7] | 0;
        var al7 = a7 & 0x1fff;
        var ah7 = a7 >>> 13;
        var a8 = a[8] | 0;
        var al8 = a8 & 0x1fff;
        var ah8 = a8 >>> 13;
        var a9 = a[9] | 0;
        var al9 = a9 & 0x1fff;
        var ah9 = a9 >>> 13;
        var b0 = b[0] | 0;
        var bl0 = b0 & 0x1fff;
        var bh0 = b0 >>> 13;
        var b1 = b[1] | 0;
        var bl1 = b1 & 0x1fff;
        var bh1 = b1 >>> 13;
        var b2 = b[2] | 0;
        var bl2 = b2 & 0x1fff;
        var bh2 = b2 >>> 13;
        var b3 = b[3] | 0;
        var bl3 = b3 & 0x1fff;
        var bh3 = b3 >>> 13;
        var b4 = b[4] | 0;
        var bl4 = b4 & 0x1fff;
        var bh4 = b4 >>> 13;
        var b5 = b[5] | 0;
        var bl5 = b5 & 0x1fff;
        var bh5 = b5 >>> 13;
        var b6 = b[6] | 0;
        var bl6 = b6 & 0x1fff;
        var bh6 = b6 >>> 13;
        var b7 = b[7] | 0;
        var bl7 = b7 & 0x1fff;
        var bh7 = b7 >>> 13;
        var b8 = b[8] | 0;
        var bl8 = b8 & 0x1fff;
        var bh8 = b8 >>> 13;
        var b9 = b[9] | 0;
        var bl9 = b9 & 0x1fff;
        var bh9 = b9 >>> 13;
        out.negative = self.negative ^ num.negative;
        out.length = 19;
        /* k = 0 */ lo = Math.imul(al0, bl0);
        mid = Math.imul(al0, bh0);
        mid = mid + Math.imul(ah0, bl0) | 0;
        hi = Math.imul(ah0, bh0);
        var w0 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w0 >>> 26) | 0;
        w0 &= 0x3ffffff;
        /* k = 1 */ lo = Math.imul(al1, bl0);
        mid = Math.imul(al1, bh0);
        mid = mid + Math.imul(ah1, bl0) | 0;
        hi = Math.imul(ah1, bh0);
        lo = lo + Math.imul(al0, bl1) | 0;
        mid = mid + Math.imul(al0, bh1) | 0;
        mid = mid + Math.imul(ah0, bl1) | 0;
        hi = hi + Math.imul(ah0, bh1) | 0;
        var w1 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w1 >>> 26) | 0;
        w1 &= 0x3ffffff;
        /* k = 2 */ lo = Math.imul(al2, bl0);
        mid = Math.imul(al2, bh0);
        mid = mid + Math.imul(ah2, bl0) | 0;
        hi = Math.imul(ah2, bh0);
        lo = lo + Math.imul(al1, bl1) | 0;
        mid = mid + Math.imul(al1, bh1) | 0;
        mid = mid + Math.imul(ah1, bl1) | 0;
        hi = hi + Math.imul(ah1, bh1) | 0;
        lo = lo + Math.imul(al0, bl2) | 0;
        mid = mid + Math.imul(al0, bh2) | 0;
        mid = mid + Math.imul(ah0, bl2) | 0;
        hi = hi + Math.imul(ah0, bh2) | 0;
        var w2 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w2 >>> 26) | 0;
        w2 &= 0x3ffffff;
        /* k = 3 */ lo = Math.imul(al3, bl0);
        mid = Math.imul(al3, bh0);
        mid = mid + Math.imul(ah3, bl0) | 0;
        hi = Math.imul(ah3, bh0);
        lo = lo + Math.imul(al2, bl1) | 0;
        mid = mid + Math.imul(al2, bh1) | 0;
        mid = mid + Math.imul(ah2, bl1) | 0;
        hi = hi + Math.imul(ah2, bh1) | 0;
        lo = lo + Math.imul(al1, bl2) | 0;
        mid = mid + Math.imul(al1, bh2) | 0;
        mid = mid + Math.imul(ah1, bl2) | 0;
        hi = hi + Math.imul(ah1, bh2) | 0;
        lo = lo + Math.imul(al0, bl3) | 0;
        mid = mid + Math.imul(al0, bh3) | 0;
        mid = mid + Math.imul(ah0, bl3) | 0;
        hi = hi + Math.imul(ah0, bh3) | 0;
        var w3 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w3 >>> 26) | 0;
        w3 &= 0x3ffffff;
        /* k = 4 */ lo = Math.imul(al4, bl0);
        mid = Math.imul(al4, bh0);
        mid = mid + Math.imul(ah4, bl0) | 0;
        hi = Math.imul(ah4, bh0);
        lo = lo + Math.imul(al3, bl1) | 0;
        mid = mid + Math.imul(al3, bh1) | 0;
        mid = mid + Math.imul(ah3, bl1) | 0;
        hi = hi + Math.imul(ah3, bh1) | 0;
        lo = lo + Math.imul(al2, bl2) | 0;
        mid = mid + Math.imul(al2, bh2) | 0;
        mid = mid + Math.imul(ah2, bl2) | 0;
        hi = hi + Math.imul(ah2, bh2) | 0;
        lo = lo + Math.imul(al1, bl3) | 0;
        mid = mid + Math.imul(al1, bh3) | 0;
        mid = mid + Math.imul(ah1, bl3) | 0;
        hi = hi + Math.imul(ah1, bh3) | 0;
        lo = lo + Math.imul(al0, bl4) | 0;
        mid = mid + Math.imul(al0, bh4) | 0;
        mid = mid + Math.imul(ah0, bl4) | 0;
        hi = hi + Math.imul(ah0, bh4) | 0;
        var w4 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w4 >>> 26) | 0;
        w4 &= 0x3ffffff;
        /* k = 5 */ lo = Math.imul(al5, bl0);
        mid = Math.imul(al5, bh0);
        mid = mid + Math.imul(ah5, bl0) | 0;
        hi = Math.imul(ah5, bh0);
        lo = lo + Math.imul(al4, bl1) | 0;
        mid = mid + Math.imul(al4, bh1) | 0;
        mid = mid + Math.imul(ah4, bl1) | 0;
        hi = hi + Math.imul(ah4, bh1) | 0;
        lo = lo + Math.imul(al3, bl2) | 0;
        mid = mid + Math.imul(al3, bh2) | 0;
        mid = mid + Math.imul(ah3, bl2) | 0;
        hi = hi + Math.imul(ah3, bh2) | 0;
        lo = lo + Math.imul(al2, bl3) | 0;
        mid = mid + Math.imul(al2, bh3) | 0;
        mid = mid + Math.imul(ah2, bl3) | 0;
        hi = hi + Math.imul(ah2, bh3) | 0;
        lo = lo + Math.imul(al1, bl4) | 0;
        mid = mid + Math.imul(al1, bh4) | 0;
        mid = mid + Math.imul(ah1, bl4) | 0;
        hi = hi + Math.imul(ah1, bh4) | 0;
        lo = lo + Math.imul(al0, bl5) | 0;
        mid = mid + Math.imul(al0, bh5) | 0;
        mid = mid + Math.imul(ah0, bl5) | 0;
        hi = hi + Math.imul(ah0, bh5) | 0;
        var w5 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w5 >>> 26) | 0;
        w5 &= 0x3ffffff;
        /* k = 6 */ lo = Math.imul(al6, bl0);
        mid = Math.imul(al6, bh0);
        mid = mid + Math.imul(ah6, bl0) | 0;
        hi = Math.imul(ah6, bh0);
        lo = lo + Math.imul(al5, bl1) | 0;
        mid = mid + Math.imul(al5, bh1) | 0;
        mid = mid + Math.imul(ah5, bl1) | 0;
        hi = hi + Math.imul(ah5, bh1) | 0;
        lo = lo + Math.imul(al4, bl2) | 0;
        mid = mid + Math.imul(al4, bh2) | 0;
        mid = mid + Math.imul(ah4, bl2) | 0;
        hi = hi + Math.imul(ah4, bh2) | 0;
        lo = lo + Math.imul(al3, bl3) | 0;
        mid = mid + Math.imul(al3, bh3) | 0;
        mid = mid + Math.imul(ah3, bl3) | 0;
        hi = hi + Math.imul(ah3, bh3) | 0;
        lo = lo + Math.imul(al2, bl4) | 0;
        mid = mid + Math.imul(al2, bh4) | 0;
        mid = mid + Math.imul(ah2, bl4) | 0;
        hi = hi + Math.imul(ah2, bh4) | 0;
        lo = lo + Math.imul(al1, bl5) | 0;
        mid = mid + Math.imul(al1, bh5) | 0;
        mid = mid + Math.imul(ah1, bl5) | 0;
        hi = hi + Math.imul(ah1, bh5) | 0;
        lo = lo + Math.imul(al0, bl6) | 0;
        mid = mid + Math.imul(al0, bh6) | 0;
        mid = mid + Math.imul(ah0, bl6) | 0;
        hi = hi + Math.imul(ah0, bh6) | 0;
        var w6 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w6 >>> 26) | 0;
        w6 &= 0x3ffffff;
        /* k = 7 */ lo = Math.imul(al7, bl0);
        mid = Math.imul(al7, bh0);
        mid = mid + Math.imul(ah7, bl0) | 0;
        hi = Math.imul(ah7, bh0);
        lo = lo + Math.imul(al6, bl1) | 0;
        mid = mid + Math.imul(al6, bh1) | 0;
        mid = mid + Math.imul(ah6, bl1) | 0;
        hi = hi + Math.imul(ah6, bh1) | 0;
        lo = lo + Math.imul(al5, bl2) | 0;
        mid = mid + Math.imul(al5, bh2) | 0;
        mid = mid + Math.imul(ah5, bl2) | 0;
        hi = hi + Math.imul(ah5, bh2) | 0;
        lo = lo + Math.imul(al4, bl3) | 0;
        mid = mid + Math.imul(al4, bh3) | 0;
        mid = mid + Math.imul(ah4, bl3) | 0;
        hi = hi + Math.imul(ah4, bh3) | 0;
        lo = lo + Math.imul(al3, bl4) | 0;
        mid = mid + Math.imul(al3, bh4) | 0;
        mid = mid + Math.imul(ah3, bl4) | 0;
        hi = hi + Math.imul(ah3, bh4) | 0;
        lo = lo + Math.imul(al2, bl5) | 0;
        mid = mid + Math.imul(al2, bh5) | 0;
        mid = mid + Math.imul(ah2, bl5) | 0;
        hi = hi + Math.imul(ah2, bh5) | 0;
        lo = lo + Math.imul(al1, bl6) | 0;
        mid = mid + Math.imul(al1, bh6) | 0;
        mid = mid + Math.imul(ah1, bl6) | 0;
        hi = hi + Math.imul(ah1, bh6) | 0;
        lo = lo + Math.imul(al0, bl7) | 0;
        mid = mid + Math.imul(al0, bh7) | 0;
        mid = mid + Math.imul(ah0, bl7) | 0;
        hi = hi + Math.imul(ah0, bh7) | 0;
        var w7 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w7 >>> 26) | 0;
        w7 &= 0x3ffffff;
        /* k = 8 */ lo = Math.imul(al8, bl0);
        mid = Math.imul(al8, bh0);
        mid = mid + Math.imul(ah8, bl0) | 0;
        hi = Math.imul(ah8, bh0);
        lo = lo + Math.imul(al7, bl1) | 0;
        mid = mid + Math.imul(al7, bh1) | 0;
        mid = mid + Math.imul(ah7, bl1) | 0;
        hi = hi + Math.imul(ah7, bh1) | 0;
        lo = lo + Math.imul(al6, bl2) | 0;
        mid = mid + Math.imul(al6, bh2) | 0;
        mid = mid + Math.imul(ah6, bl2) | 0;
        hi = hi + Math.imul(ah6, bh2) | 0;
        lo = lo + Math.imul(al5, bl3) | 0;
        mid = mid + Math.imul(al5, bh3) | 0;
        mid = mid + Math.imul(ah5, bl3) | 0;
        hi = hi + Math.imul(ah5, bh3) | 0;
        lo = lo + Math.imul(al4, bl4) | 0;
        mid = mid + Math.imul(al4, bh4) | 0;
        mid = mid + Math.imul(ah4, bl4) | 0;
        hi = hi + Math.imul(ah4, bh4) | 0;
        lo = lo + Math.imul(al3, bl5) | 0;
        mid = mid + Math.imul(al3, bh5) | 0;
        mid = mid + Math.imul(ah3, bl5) | 0;
        hi = hi + Math.imul(ah3, bh5) | 0;
        lo = lo + Math.imul(al2, bl6) | 0;
        mid = mid + Math.imul(al2, bh6) | 0;
        mid = mid + Math.imul(ah2, bl6) | 0;
        hi = hi + Math.imul(ah2, bh6) | 0;
        lo = lo + Math.imul(al1, bl7) | 0;
        mid = mid + Math.imul(al1, bh7) | 0;
        mid = mid + Math.imul(ah1, bl7) | 0;
        hi = hi + Math.imul(ah1, bh7) | 0;
        lo = lo + Math.imul(al0, bl8) | 0;
        mid = mid + Math.imul(al0, bh8) | 0;
        mid = mid + Math.imul(ah0, bl8) | 0;
        hi = hi + Math.imul(ah0, bh8) | 0;
        var w8 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w8 >>> 26) | 0;
        w8 &= 0x3ffffff;
        /* k = 9 */ lo = Math.imul(al9, bl0);
        mid = Math.imul(al9, bh0);
        mid = mid + Math.imul(ah9, bl0) | 0;
        hi = Math.imul(ah9, bh0);
        lo = lo + Math.imul(al8, bl1) | 0;
        mid = mid + Math.imul(al8, bh1) | 0;
        mid = mid + Math.imul(ah8, bl1) | 0;
        hi = hi + Math.imul(ah8, bh1) | 0;
        lo = lo + Math.imul(al7, bl2) | 0;
        mid = mid + Math.imul(al7, bh2) | 0;
        mid = mid + Math.imul(ah7, bl2) | 0;
        hi = hi + Math.imul(ah7, bh2) | 0;
        lo = lo + Math.imul(al6, bl3) | 0;
        mid = mid + Math.imul(al6, bh3) | 0;
        mid = mid + Math.imul(ah6, bl3) | 0;
        hi = hi + Math.imul(ah6, bh3) | 0;
        lo = lo + Math.imul(al5, bl4) | 0;
        mid = mid + Math.imul(al5, bh4) | 0;
        mid = mid + Math.imul(ah5, bl4) | 0;
        hi = hi + Math.imul(ah5, bh4) | 0;
        lo = lo + Math.imul(al4, bl5) | 0;
        mid = mid + Math.imul(al4, bh5) | 0;
        mid = mid + Math.imul(ah4, bl5) | 0;
        hi = hi + Math.imul(ah4, bh5) | 0;
        lo = lo + Math.imul(al3, bl6) | 0;
        mid = mid + Math.imul(al3, bh6) | 0;
        mid = mid + Math.imul(ah3, bl6) | 0;
        hi = hi + Math.imul(ah3, bh6) | 0;
        lo = lo + Math.imul(al2, bl7) | 0;
        mid = mid + Math.imul(al2, bh7) | 0;
        mid = mid + Math.imul(ah2, bl7) | 0;
        hi = hi + Math.imul(ah2, bh7) | 0;
        lo = lo + Math.imul(al1, bl8) | 0;
        mid = mid + Math.imul(al1, bh8) | 0;
        mid = mid + Math.imul(ah1, bl8) | 0;
        hi = hi + Math.imul(ah1, bh8) | 0;
        lo = lo + Math.imul(al0, bl9) | 0;
        mid = mid + Math.imul(al0, bh9) | 0;
        mid = mid + Math.imul(ah0, bl9) | 0;
        hi = hi + Math.imul(ah0, bh9) | 0;
        var w9 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w9 >>> 26) | 0;
        w9 &= 0x3ffffff;
        /* k = 10 */ lo = Math.imul(al9, bl1);
        mid = Math.imul(al9, bh1);
        mid = mid + Math.imul(ah9, bl1) | 0;
        hi = Math.imul(ah9, bh1);
        lo = lo + Math.imul(al8, bl2) | 0;
        mid = mid + Math.imul(al8, bh2) | 0;
        mid = mid + Math.imul(ah8, bl2) | 0;
        hi = hi + Math.imul(ah8, bh2) | 0;
        lo = lo + Math.imul(al7, bl3) | 0;
        mid = mid + Math.imul(al7, bh3) | 0;
        mid = mid + Math.imul(ah7, bl3) | 0;
        hi = hi + Math.imul(ah7, bh3) | 0;
        lo = lo + Math.imul(al6, bl4) | 0;
        mid = mid + Math.imul(al6, bh4) | 0;
        mid = mid + Math.imul(ah6, bl4) | 0;
        hi = hi + Math.imul(ah6, bh4) | 0;
        lo = lo + Math.imul(al5, bl5) | 0;
        mid = mid + Math.imul(al5, bh5) | 0;
        mid = mid + Math.imul(ah5, bl5) | 0;
        hi = hi + Math.imul(ah5, bh5) | 0;
        lo = lo + Math.imul(al4, bl6) | 0;
        mid = mid + Math.imul(al4, bh6) | 0;
        mid = mid + Math.imul(ah4, bl6) | 0;
        hi = hi + Math.imul(ah4, bh6) | 0;
        lo = lo + Math.imul(al3, bl7) | 0;
        mid = mid + Math.imul(al3, bh7) | 0;
        mid = mid + Math.imul(ah3, bl7) | 0;
        hi = hi + Math.imul(ah3, bh7) | 0;
        lo = lo + Math.imul(al2, bl8) | 0;
        mid = mid + Math.imul(al2, bh8) | 0;
        mid = mid + Math.imul(ah2, bl8) | 0;
        hi = hi + Math.imul(ah2, bh8) | 0;
        lo = lo + Math.imul(al1, bl9) | 0;
        mid = mid + Math.imul(al1, bh9) | 0;
        mid = mid + Math.imul(ah1, bl9) | 0;
        hi = hi + Math.imul(ah1, bh9) | 0;
        var w10 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w10 >>> 26) | 0;
        w10 &= 0x3ffffff;
        /* k = 11 */ lo = Math.imul(al9, bl2);
        mid = Math.imul(al9, bh2);
        mid = mid + Math.imul(ah9, bl2) | 0;
        hi = Math.imul(ah9, bh2);
        lo = lo + Math.imul(al8, bl3) | 0;
        mid = mid + Math.imul(al8, bh3) | 0;
        mid = mid + Math.imul(ah8, bl3) | 0;
        hi = hi + Math.imul(ah8, bh3) | 0;
        lo = lo + Math.imul(al7, bl4) | 0;
        mid = mid + Math.imul(al7, bh4) | 0;
        mid = mid + Math.imul(ah7, bl4) | 0;
        hi = hi + Math.imul(ah7, bh4) | 0;
        lo = lo + Math.imul(al6, bl5) | 0;
        mid = mid + Math.imul(al6, bh5) | 0;
        mid = mid + Math.imul(ah6, bl5) | 0;
        hi = hi + Math.imul(ah6, bh5) | 0;
        lo = lo + Math.imul(al5, bl6) | 0;
        mid = mid + Math.imul(al5, bh6) | 0;
        mid = mid + Math.imul(ah5, bl6) | 0;
        hi = hi + Math.imul(ah5, bh6) | 0;
        lo = lo + Math.imul(al4, bl7) | 0;
        mid = mid + Math.imul(al4, bh7) | 0;
        mid = mid + Math.imul(ah4, bl7) | 0;
        hi = hi + Math.imul(ah4, bh7) | 0;
        lo = lo + Math.imul(al3, bl8) | 0;
        mid = mid + Math.imul(al3, bh8) | 0;
        mid = mid + Math.imul(ah3, bl8) | 0;
        hi = hi + Math.imul(ah3, bh8) | 0;
        lo = lo + Math.imul(al2, bl9) | 0;
        mid = mid + Math.imul(al2, bh9) | 0;
        mid = mid + Math.imul(ah2, bl9) | 0;
        hi = hi + Math.imul(ah2, bh9) | 0;
        var w11 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w11 >>> 26) | 0;
        w11 &= 0x3ffffff;
        /* k = 12 */ lo = Math.imul(al9, bl3);
        mid = Math.imul(al9, bh3);
        mid = mid + Math.imul(ah9, bl3) | 0;
        hi = Math.imul(ah9, bh3);
        lo = lo + Math.imul(al8, bl4) | 0;
        mid = mid + Math.imul(al8, bh4) | 0;
        mid = mid + Math.imul(ah8, bl4) | 0;
        hi = hi + Math.imul(ah8, bh4) | 0;
        lo = lo + Math.imul(al7, bl5) | 0;
        mid = mid + Math.imul(al7, bh5) | 0;
        mid = mid + Math.imul(ah7, bl5) | 0;
        hi = hi + Math.imul(ah7, bh5) | 0;
        lo = lo + Math.imul(al6, bl6) | 0;
        mid = mid + Math.imul(al6, bh6) | 0;
        mid = mid + Math.imul(ah6, bl6) | 0;
        hi = hi + Math.imul(ah6, bh6) | 0;
        lo = lo + Math.imul(al5, bl7) | 0;
        mid = mid + Math.imul(al5, bh7) | 0;
        mid = mid + Math.imul(ah5, bl7) | 0;
        hi = hi + Math.imul(ah5, bh7) | 0;
        lo = lo + Math.imul(al4, bl8) | 0;
        mid = mid + Math.imul(al4, bh8) | 0;
        mid = mid + Math.imul(ah4, bl8) | 0;
        hi = hi + Math.imul(ah4, bh8) | 0;
        lo = lo + Math.imul(al3, bl9) | 0;
        mid = mid + Math.imul(al3, bh9) | 0;
        mid = mid + Math.imul(ah3, bl9) | 0;
        hi = hi + Math.imul(ah3, bh9) | 0;
        var w12 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w12 >>> 26) | 0;
        w12 &= 0x3ffffff;
        /* k = 13 */ lo = Math.imul(al9, bl4);
        mid = Math.imul(al9, bh4);
        mid = mid + Math.imul(ah9, bl4) | 0;
        hi = Math.imul(ah9, bh4);
        lo = lo + Math.imul(al8, bl5) | 0;
        mid = mid + Math.imul(al8, bh5) | 0;
        mid = mid + Math.imul(ah8, bl5) | 0;
        hi = hi + Math.imul(ah8, bh5) | 0;
        lo = lo + Math.imul(al7, bl6) | 0;
        mid = mid + Math.imul(al7, bh6) | 0;
        mid = mid + Math.imul(ah7, bl6) | 0;
        hi = hi + Math.imul(ah7, bh6) | 0;
        lo = lo + Math.imul(al6, bl7) | 0;
        mid = mid + Math.imul(al6, bh7) | 0;
        mid = mid + Math.imul(ah6, bl7) | 0;
        hi = hi + Math.imul(ah6, bh7) | 0;
        lo = lo + Math.imul(al5, bl8) | 0;
        mid = mid + Math.imul(al5, bh8) | 0;
        mid = mid + Math.imul(ah5, bl8) | 0;
        hi = hi + Math.imul(ah5, bh8) | 0;
        lo = lo + Math.imul(al4, bl9) | 0;
        mid = mid + Math.imul(al4, bh9) | 0;
        mid = mid + Math.imul(ah4, bl9) | 0;
        hi = hi + Math.imul(ah4, bh9) | 0;
        var w13 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w13 >>> 26) | 0;
        w13 &= 0x3ffffff;
        /* k = 14 */ lo = Math.imul(al9, bl5);
        mid = Math.imul(al9, bh5);
        mid = mid + Math.imul(ah9, bl5) | 0;
        hi = Math.imul(ah9, bh5);
        lo = lo + Math.imul(al8, bl6) | 0;
        mid = mid + Math.imul(al8, bh6) | 0;
        mid = mid + Math.imul(ah8, bl6) | 0;
        hi = hi + Math.imul(ah8, bh6) | 0;
        lo = lo + Math.imul(al7, bl7) | 0;
        mid = mid + Math.imul(al7, bh7) | 0;
        mid = mid + Math.imul(ah7, bl7) | 0;
        hi = hi + Math.imul(ah7, bh7) | 0;
        lo = lo + Math.imul(al6, bl8) | 0;
        mid = mid + Math.imul(al6, bh8) | 0;
        mid = mid + Math.imul(ah6, bl8) | 0;
        hi = hi + Math.imul(ah6, bh8) | 0;
        lo = lo + Math.imul(al5, bl9) | 0;
        mid = mid + Math.imul(al5, bh9) | 0;
        mid = mid + Math.imul(ah5, bl9) | 0;
        hi = hi + Math.imul(ah5, bh9) | 0;
        var w14 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w14 >>> 26) | 0;
        w14 &= 0x3ffffff;
        /* k = 15 */ lo = Math.imul(al9, bl6);
        mid = Math.imul(al9, bh6);
        mid = mid + Math.imul(ah9, bl6) | 0;
        hi = Math.imul(ah9, bh6);
        lo = lo + Math.imul(al8, bl7) | 0;
        mid = mid + Math.imul(al8, bh7) | 0;
        mid = mid + Math.imul(ah8, bl7) | 0;
        hi = hi + Math.imul(ah8, bh7) | 0;
        lo = lo + Math.imul(al7, bl8) | 0;
        mid = mid + Math.imul(al7, bh8) | 0;
        mid = mid + Math.imul(ah7, bl8) | 0;
        hi = hi + Math.imul(ah7, bh8) | 0;
        lo = lo + Math.imul(al6, bl9) | 0;
        mid = mid + Math.imul(al6, bh9) | 0;
        mid = mid + Math.imul(ah6, bl9) | 0;
        hi = hi + Math.imul(ah6, bh9) | 0;
        var w15 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w15 >>> 26) | 0;
        w15 &= 0x3ffffff;
        /* k = 16 */ lo = Math.imul(al9, bl7);
        mid = Math.imul(al9, bh7);
        mid = mid + Math.imul(ah9, bl7) | 0;
        hi = Math.imul(ah9, bh7);
        lo = lo + Math.imul(al8, bl8) | 0;
        mid = mid + Math.imul(al8, bh8) | 0;
        mid = mid + Math.imul(ah8, bl8) | 0;
        hi = hi + Math.imul(ah8, bh8) | 0;
        lo = lo + Math.imul(al7, bl9) | 0;
        mid = mid + Math.imul(al7, bh9) | 0;
        mid = mid + Math.imul(ah7, bl9) | 0;
        hi = hi + Math.imul(ah7, bh9) | 0;
        var w16 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w16 >>> 26) | 0;
        w16 &= 0x3ffffff;
        /* k = 17 */ lo = Math.imul(al9, bl8);
        mid = Math.imul(al9, bh8);
        mid = mid + Math.imul(ah9, bl8) | 0;
        hi = Math.imul(ah9, bh8);
        lo = lo + Math.imul(al8, bl9) | 0;
        mid = mid + Math.imul(al8, bh9) | 0;
        mid = mid + Math.imul(ah8, bl9) | 0;
        hi = hi + Math.imul(ah8, bh9) | 0;
        var w17 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w17 >>> 26) | 0;
        w17 &= 0x3ffffff;
        /* k = 18 */ lo = Math.imul(al9, bl9);
        mid = Math.imul(al9, bh9);
        mid = mid + Math.imul(ah9, bl9) | 0;
        hi = Math.imul(ah9, bh9);
        var w18 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w18 >>> 26) | 0;
        w18 &= 0x3ffffff;
        o[0] = w0;
        o[1] = w1;
        o[2] = w2;
        o[3] = w3;
        o[4] = w4;
        o[5] = w5;
        o[6] = w6;
        o[7] = w7;
        o[8] = w8;
        o[9] = w9;
        o[10] = w10;
        o[11] = w11;
        o[12] = w12;
        o[13] = w13;
        o[14] = w14;
        o[15] = w15;
        o[16] = w16;
        o[17] = w17;
        o[18] = w18;
        if (c !== 0) {
            o[19] = c;
            out.length++;
        }
        return out;
    };
    // Polyfill comb
    if (!Math.imul) comb10MulTo = smallMulTo;
    function bigMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        out.length = self.length + num.length;
        var carry = 0;
        var hncarry = 0;
        for(var k = 0; k < out.length - 1; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = hncarry;
            hncarry = 0;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j;
                var a = self.words[i] | 0;
                var b = num.words[j] | 0;
                var r = a * b;
                var lo = r & 0x3ffffff;
                ncarry = ncarry + (r / 0x4000000 | 0) | 0;
                lo = lo + rword | 0;
                rword = lo & 0x3ffffff;
                ncarry = ncarry + (lo >>> 26) | 0;
                hncarry += ncarry >>> 26;
                ncarry &= 0x3ffffff;
            }
            out.words[k] = rword;
            carry = ncarry;
            ncarry = hncarry;
        }
        if (carry !== 0) out.words[k] = carry;
        else out.length--;
        return out._strip();
    }
    function jumboMulTo(self, num, out) {
        // Temporary disable, see https://github.com/indutny/bn.js/issues/211
        // var fftm = new FFTM();
        // return fftm.mulp(self, num, out);
        return bigMulTo(self, num, out);
    }
    BN.prototype.mulTo = function mulTo(num, out) {
        var res;
        var len = this.length + num.length;
        if (this.length === 10 && num.length === 10) res = comb10MulTo(this, num, out);
        else if (len < 63) res = smallMulTo(this, num, out);
        else if (len < 1024) res = bigMulTo(this, num, out);
        else res = jumboMulTo(this, num, out);
        return res;
    };
    // Cooley-Tukey algorithm for FFT
    // slightly revisited to rely on looping instead of recursion
    function FFTM(x, y) {
        this.x = x;
        this.y = y;
    }
    FFTM.prototype.makeRBT = function makeRBT(N) {
        var t = new Array(N);
        var l = BN.prototype._countBits(N) - 1;
        for(var i = 0; i < N; i++)t[i] = this.revBin(i, l, N);
        return t;
    };
    // Returns binary-reversed representation of `x`
    FFTM.prototype.revBin = function revBin(x, l, N) {
        if (x === 0 || x === N - 1) return x;
        var rb = 0;
        for(var i = 0; i < l; i++){
            rb |= (x & 1) << l - i - 1;
            x >>= 1;
        }
        return rb;
    };
    // Performs "tweedling" phase, therefore 'emulating'
    // behaviour of the recursive algorithm
    FFTM.prototype.permute = function permute(rbt, rws, iws, rtws, itws, N) {
        for(var i = 0; i < N; i++){
            rtws[i] = rws[rbt[i]];
            itws[i] = iws[rbt[i]];
        }
    };
    FFTM.prototype.transform = function transform(rws, iws, rtws, itws, N, rbt) {
        this.permute(rbt, rws, iws, rtws, itws, N);
        for(var s = 1; s < N; s <<= 1){
            var l = s << 1;
            var rtwdf = Math.cos(2 * Math.PI / l);
            var itwdf = Math.sin(2 * Math.PI / l);
            for(var p = 0; p < N; p += l){
                var rtwdf_ = rtwdf;
                var itwdf_ = itwdf;
                for(var j = 0; j < s; j++){
                    var re = rtws[p + j];
                    var ie = itws[p + j];
                    var ro = rtws[p + j + s];
                    var io = itws[p + j + s];
                    var rx = rtwdf_ * ro - itwdf_ * io;
                    io = rtwdf_ * io + itwdf_ * ro;
                    ro = rx;
                    rtws[p + j] = re + ro;
                    itws[p + j] = ie + io;
                    rtws[p + j + s] = re - ro;
                    itws[p + j + s] = ie - io;
                    /* jshint maxdepth : false */ if (j !== l) {
                        rx = rtwdf * rtwdf_ - itwdf * itwdf_;
                        itwdf_ = rtwdf * itwdf_ + itwdf * rtwdf_;
                        rtwdf_ = rx;
                    }
                }
            }
        }
    };
    FFTM.prototype.guessLen13b = function guessLen13b(n, m) {
        var N = Math.max(m, n) | 1;
        var odd = N & 1;
        var i = 0;
        for(N = N / 2 | 0; N; N = N >>> 1)i++;
        return 1 << i + 1 + odd;
    };
    FFTM.prototype.conjugate = function conjugate(rws, iws, N) {
        if (N <= 1) return;
        for(var i = 0; i < N / 2; i++){
            var t = rws[i];
            rws[i] = rws[N - i - 1];
            rws[N - i - 1] = t;
            t = iws[i];
            iws[i] = -iws[N - i - 1];
            iws[N - i - 1] = -t;
        }
    };
    FFTM.prototype.normalize13b = function normalize13b(ws, N) {
        var carry = 0;
        for(var i = 0; i < N / 2; i++){
            var w = Math.round(ws[2 * i + 1] / N) * 0x2000 + Math.round(ws[2 * i] / N) + carry;
            ws[i] = w & 0x3ffffff;
            if (w < 0x4000000) carry = 0;
            else carry = w / 0x4000000 | 0;
        }
        return ws;
    };
    FFTM.prototype.convert13b = function convert13b(ws, len, rws, N) {
        var carry = 0;
        for(var i = 0; i < len; i++){
            carry = carry + (ws[i] | 0);
            rws[2 * i] = carry & 0x1fff;
            carry = carry >>> 13;
            rws[2 * i + 1] = carry & 0x1fff;
            carry = carry >>> 13;
        }
        // Pad with zeroes
        for(i = 2 * len; i < N; ++i)rws[i] = 0;
        assert(carry === 0);
        assert((carry & -8192) === 0);
    };
    FFTM.prototype.stub = function stub(N) {
        var ph = new Array(N);
        for(var i = 0; i < N; i++)ph[i] = 0;
        return ph;
    };
    FFTM.prototype.mulp = function mulp(x, y, out) {
        var N = 2 * this.guessLen13b(x.length, y.length);
        var rbt = this.makeRBT(N);
        var _ = this.stub(N);
        var rws = new Array(N);
        var rwst = new Array(N);
        var iwst = new Array(N);
        var nrws = new Array(N);
        var nrwst = new Array(N);
        var niwst = new Array(N);
        var rmws = out.words;
        rmws.length = N;
        this.convert13b(x.words, x.length, rws, N);
        this.convert13b(y.words, y.length, nrws, N);
        this.transform(rws, _, rwst, iwst, N, rbt);
        this.transform(nrws, _, nrwst, niwst, N, rbt);
        for(var i = 0; i < N; i++){
            var rx = rwst[i] * nrwst[i] - iwst[i] * niwst[i];
            iwst[i] = rwst[i] * niwst[i] + iwst[i] * nrwst[i];
            rwst[i] = rx;
        }
        this.conjugate(rwst, iwst, N);
        this.transform(rwst, iwst, rmws, _, N, rbt);
        this.conjugate(rmws, _, N);
        this.normalize13b(rmws, N);
        out.negative = x.negative ^ y.negative;
        out.length = x.length + y.length;
        return out._strip();
    };
    // Multiply `this` by `num`
    BN.prototype.mul = function mul(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return this.mulTo(num, out);
    };
    // Multiply employing FFT
    BN.prototype.mulf = function mulf(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return jumboMulTo(this, num, out);
    };
    // In-place Multiplication
    BN.prototype.imul = function imul(num) {
        return this.clone().mulTo(num, this);
    };
    BN.prototype.imuln = function imuln(num) {
        var isNegNum = num < 0;
        if (isNegNum) num = -num;
        assert(typeof num === "number");
        assert(num < 0x4000000);
        // Carry
        var carry = 0;
        for(var i = 0; i < this.length; i++){
            var w = (this.words[i] | 0) * num;
            var lo = (w & 0x3ffffff) + (carry & 0x3ffffff);
            carry >>= 26;
            carry += w / 0x4000000 | 0;
            // NOTE: lo is 27bit maximum
            carry += lo >>> 26;
            this.words[i] = lo & 0x3ffffff;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return isNegNum ? this.ineg() : this;
    };
    BN.prototype.muln = function muln(num) {
        return this.clone().imuln(num);
    };
    // `this` * `this`
    BN.prototype.sqr = function sqr() {
        return this.mul(this);
    };
    // `this` * `this` in-place
    BN.prototype.isqr = function isqr() {
        return this.imul(this.clone());
    };
    // Math.pow(`this`, `num`)
    BN.prototype.pow = function pow(num) {
        var w = toBitArray(num);
        if (w.length === 0) return new BN(1);
        // Skip leading zeroes
        var res = this;
        for(var i = 0; i < w.length; i++, res = res.sqr()){
            if (w[i] !== 0) break;
        }
        if (++i < w.length) for(var q = res.sqr(); i < w.length; i++, q = q.sqr()){
            if (w[i] === 0) continue;
            res = res.mul(q);
        }
        return res;
    };
    // Shift-left in-place
    BN.prototype.iushln = function iushln(bits) {
        assert(typeof bits === "number" && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        var carryMask = 0x3ffffff >>> 26 - r << 26 - r;
        var i;
        if (r !== 0) {
            var carry = 0;
            for(i = 0; i < this.length; i++){
                var newCarry = this.words[i] & carryMask;
                var c = (this.words[i] | 0) - newCarry << r;
                this.words[i] = c | carry;
                carry = newCarry >>> 26 - r;
            }
            if (carry) {
                this.words[i] = carry;
                this.length++;
            }
        }
        if (s !== 0) {
            for(i = this.length - 1; i >= 0; i--)this.words[i + s] = this.words[i];
            for(i = 0; i < s; i++)this.words[i] = 0;
            this.length += s;
        }
        return this._strip();
    };
    BN.prototype.ishln = function ishln(bits) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushln(bits);
    };
    // Shift-right in-place
    // NOTE: `hint` is a lowest bit before trailing zeroes
    // NOTE: if `extended` is present - it will be filled with destroyed bits
    BN.prototype.iushrn = function iushrn(bits, hint, extended) {
        assert(typeof bits === "number" && bits >= 0);
        var h;
        if (hint) h = (hint - hint % 26) / 26;
        else h = 0;
        var r = bits % 26;
        var s = Math.min((bits - r) / 26, this.length);
        var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
        var maskedWords = extended;
        h -= s;
        h = Math.max(0, h);
        // Extended mode, copy masked part
        if (maskedWords) {
            for(var i = 0; i < s; i++)maskedWords.words[i] = this.words[i];
            maskedWords.length = s;
        }
        if (s === 0) ;
        else if (this.length > s) {
            this.length -= s;
            for(i = 0; i < this.length; i++)this.words[i] = this.words[i + s];
        } else {
            this.words[0] = 0;
            this.length = 1;
        }
        var carry = 0;
        for(i = this.length - 1; i >= 0 && (carry !== 0 || i >= h); i--){
            var word = this.words[i] | 0;
            this.words[i] = carry << 26 - r | word >>> r;
            carry = word & mask;
        }
        // Push carried bits as a mask
        if (maskedWords && carry !== 0) maskedWords.words[maskedWords.length++] = carry;
        if (this.length === 0) {
            this.words[0] = 0;
            this.length = 1;
        }
        return this._strip();
    };
    BN.prototype.ishrn = function ishrn(bits, hint, extended) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushrn(bits, hint, extended);
    };
    // Shift-left
    BN.prototype.shln = function shln(bits) {
        return this.clone().ishln(bits);
    };
    BN.prototype.ushln = function ushln(bits) {
        return this.clone().iushln(bits);
    };
    // Shift-right
    BN.prototype.shrn = function shrn(bits) {
        return this.clone().ishrn(bits);
    };
    BN.prototype.ushrn = function ushrn(bits) {
        return this.clone().iushrn(bits);
    };
    // Test if n bit is set
    BN.prototype.testn = function testn(bit) {
        assert(typeof bit === "number" && bit >= 0);
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) return false;
        // Check bit and return
        var w = this.words[s];
        return !!(w & q);
    };
    // Return only lowers bits of number (in-place)
    BN.prototype.imaskn = function imaskn(bits) {
        assert(typeof bits === "number" && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        assert(this.negative === 0, "imaskn works only with positive numbers");
        if (this.length <= s) return this;
        if (r !== 0) s++;
        this.length = Math.min(s, this.length);
        if (r !== 0) {
            var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
            this.words[this.length - 1] &= mask;
        }
        return this._strip();
    };
    // Return only lowers bits of number
    BN.prototype.maskn = function maskn(bits) {
        return this.clone().imaskn(bits);
    };
    // Add plain number `num` to `this`
    BN.prototype.iaddn = function iaddn(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        if (num < 0) return this.isubn(-num);
        // Possible sign change
        if (this.negative !== 0) {
            if (this.length === 1 && (this.words[0] | 0) <= num) {
                this.words[0] = num - (this.words[0] | 0);
                this.negative = 0;
                return this;
            }
            this.negative = 0;
            this.isubn(num);
            this.negative = 1;
            return this;
        }
        // Add without checks
        return this._iaddn(num);
    };
    BN.prototype._iaddn = function _iaddn(num) {
        this.words[0] += num;
        // Carry
        for(var i = 0; i < this.length && this.words[i] >= 0x4000000; i++){
            this.words[i] -= 0x4000000;
            if (i === this.length - 1) this.words[i + 1] = 1;
            else this.words[i + 1]++;
        }
        this.length = Math.max(this.length, i + 1);
        return this;
    };
    // Subtract plain number `num` from `this`
    BN.prototype.isubn = function isubn(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        if (num < 0) return this.iaddn(-num);
        if (this.negative !== 0) {
            this.negative = 0;
            this.iaddn(num);
            this.negative = 1;
            return this;
        }
        this.words[0] -= num;
        if (this.length === 1 && this.words[0] < 0) {
            this.words[0] = -this.words[0];
            this.negative = 1;
        } else // Carry
        for(var i = 0; i < this.length && this.words[i] < 0; i++){
            this.words[i] += 0x4000000;
            this.words[i + 1] -= 1;
        }
        return this._strip();
    };
    BN.prototype.addn = function addn(num) {
        return this.clone().iaddn(num);
    };
    BN.prototype.subn = function subn(num) {
        return this.clone().isubn(num);
    };
    BN.prototype.iabs = function iabs() {
        this.negative = 0;
        return this;
    };
    BN.prototype.abs = function abs() {
        return this.clone().iabs();
    };
    BN.prototype._ishlnsubmul = function _ishlnsubmul(num, mul, shift) {
        var len = num.length + shift;
        var i;
        this._expand(len);
        var w;
        var carry = 0;
        for(i = 0; i < num.length; i++){
            w = (this.words[i + shift] | 0) + carry;
            var right = (num.words[i] | 0) * mul;
            w -= right & 0x3ffffff;
            carry = (w >> 26) - (right / 0x4000000 | 0);
            this.words[i + shift] = w & 0x3ffffff;
        }
        for(; i < this.length - shift; i++){
            w = (this.words[i + shift] | 0) + carry;
            carry = w >> 26;
            this.words[i + shift] = w & 0x3ffffff;
        }
        if (carry === 0) return this._strip();
        // Subtraction overflow
        assert(carry === -1);
        carry = 0;
        for(i = 0; i < this.length; i++){
            w = -(this.words[i] | 0) + carry;
            carry = w >> 26;
            this.words[i] = w & 0x3ffffff;
        }
        this.negative = 1;
        return this._strip();
    };
    BN.prototype._wordDiv = function _wordDiv(num, mode) {
        var shift = this.length - num.length;
        var a = this.clone();
        var b = num;
        // Normalize
        var bhi = b.words[b.length - 1] | 0;
        var bhiBits = this._countBits(bhi);
        shift = 26 - bhiBits;
        if (shift !== 0) {
            b = b.ushln(shift);
            a.iushln(shift);
            bhi = b.words[b.length - 1] | 0;
        }
        // Initialize quotient
        var m = a.length - b.length;
        var q;
        if (mode !== "mod") {
            q = new BN(null);
            q.length = m + 1;
            q.words = new Array(q.length);
            for(var i = 0; i < q.length; i++)q.words[i] = 0;
        }
        var diff = a.clone()._ishlnsubmul(b, 1, m);
        if (diff.negative === 0) {
            a = diff;
            if (q) q.words[m] = 1;
        }
        for(var j = m - 1; j >= 0; j--){
            var qj = (a.words[b.length + j] | 0) * 0x4000000 + (a.words[b.length + j - 1] | 0);
            // NOTE: (qj / bhi) is (0x3ffffff * 0x4000000 + 0x3ffffff) / 0x2000000 max
            // (0x7ffffff)
            qj = Math.min(qj / bhi | 0, 0x3ffffff);
            a._ishlnsubmul(b, qj, j);
            while(a.negative !== 0){
                qj--;
                a.negative = 0;
                a._ishlnsubmul(b, 1, j);
                if (!a.isZero()) a.negative ^= 1;
            }
            if (q) q.words[j] = qj;
        }
        if (q) q._strip();
        a._strip();
        // Denormalize
        if (mode !== "div" && shift !== 0) a.iushrn(shift);
        return {
            div: q || null,
            mod: a
        };
    };
    // NOTE: 1) `mode` can be set to `mod` to request mod only,
    //       to `div` to request div only, or be absent to
    //       request both div & mod
    //       2) `positive` is true if unsigned mod is requested
    BN.prototype.divmod = function divmod(num, mode, positive) {
        assert(!num.isZero());
        if (this.isZero()) return {
            div: new BN(0),
            mod: new BN(0)
        };
        var div, mod, res;
        if (this.negative !== 0 && num.negative === 0) {
            res = this.neg().divmod(num, mode);
            if (mode !== "mod") div = res.div.neg();
            if (mode !== "div") {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.iadd(num);
            }
            return {
                div: div,
                mod: mod
            };
        }
        if (this.negative === 0 && num.negative !== 0) {
            res = this.divmod(num.neg(), mode);
            if (mode !== "mod") div = res.div.neg();
            return {
                div: div,
                mod: res.mod
            };
        }
        if ((this.negative & num.negative) !== 0) {
            res = this.neg().divmod(num.neg(), mode);
            if (mode !== "div") {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.isub(num);
            }
            return {
                div: res.div,
                mod: mod
            };
        }
        // Both numbers are positive at this point
        // Strip both numbers to approximate shift value
        if (num.length > this.length || this.cmp(num) < 0) return {
            div: new BN(0),
            mod: this
        };
        // Very short reduction
        if (num.length === 1) {
            if (mode === "div") return {
                div: this.divn(num.words[0]),
                mod: null
            };
            if (mode === "mod") return {
                div: null,
                mod: new BN(this.modrn(num.words[0]))
            };
            return {
                div: this.divn(num.words[0]),
                mod: new BN(this.modrn(num.words[0]))
            };
        }
        return this._wordDiv(num, mode);
    };
    // Find `this` / `num`
    BN.prototype.div = function div(num) {
        return this.divmod(num, "div", false).div;
    };
    // Find `this` % `num`
    BN.prototype.mod = function mod(num) {
        return this.divmod(num, "mod", false).mod;
    };
    BN.prototype.umod = function umod(num) {
        return this.divmod(num, "mod", true).mod;
    };
    // Find Round(`this` / `num`)
    BN.prototype.divRound = function divRound(num) {
        var dm = this.divmod(num);
        // Fast case - exact division
        if (dm.mod.isZero()) return dm.div;
        var mod = dm.div.negative !== 0 ? dm.mod.isub(num) : dm.mod;
        var half = num.ushrn(1);
        var r2 = num.andln(1);
        var cmp = mod.cmp(half);
        // Round down
        if (cmp < 0 || r2 === 1 && cmp === 0) return dm.div;
        // Round up
        return dm.div.negative !== 0 ? dm.div.isubn(1) : dm.div.iaddn(1);
    };
    BN.prototype.modrn = function modrn(num) {
        var isNegNum = num < 0;
        if (isNegNum) num = -num;
        assert(num <= 0x3ffffff);
        var p = 67108864 % num;
        var acc = 0;
        for(var i = this.length - 1; i >= 0; i--)acc = (p * acc + (this.words[i] | 0)) % num;
        return isNegNum ? -acc : acc;
    };
    // WARNING: DEPRECATED
    BN.prototype.modn = function modn(num) {
        return this.modrn(num);
    };
    // In-place division by number
    BN.prototype.idivn = function idivn(num) {
        var isNegNum = num < 0;
        if (isNegNum) num = -num;
        assert(num <= 0x3ffffff);
        var carry = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var w = (this.words[i] | 0) + carry * 0x4000000;
            this.words[i] = w / num | 0;
            carry = w % num;
        }
        this._strip();
        return isNegNum ? this.ineg() : this;
    };
    BN.prototype.divn = function divn(num) {
        return this.clone().idivn(num);
    };
    BN.prototype.egcd = function egcd(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var x = this;
        var y = p.clone();
        if (x.negative !== 0) x = x.umod(p);
        else x = x.clone();
        // A * x + B * y = x
        var A = new BN(1);
        var B = new BN(0);
        // C * x + D * y = y
        var C = new BN(0);
        var D = new BN(1);
        var g = 0;
        while(x.isEven() && y.isEven()){
            x.iushrn(1);
            y.iushrn(1);
            ++g;
        }
        var yp = y.clone();
        var xp = x.clone();
        while(!x.isZero()){
            for(var i = 0, im = 1; (x.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                x.iushrn(i);
                while(i-- > 0){
                    if (A.isOdd() || B.isOdd()) {
                        A.iadd(yp);
                        B.isub(xp);
                    }
                    A.iushrn(1);
                    B.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (y.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                y.iushrn(j);
                while(j-- > 0){
                    if (C.isOdd() || D.isOdd()) {
                        C.iadd(yp);
                        D.isub(xp);
                    }
                    C.iushrn(1);
                    D.iushrn(1);
                }
            }
            if (x.cmp(y) >= 0) {
                x.isub(y);
                A.isub(C);
                B.isub(D);
            } else {
                y.isub(x);
                C.isub(A);
                D.isub(B);
            }
        }
        return {
            a: C,
            b: D,
            gcd: y.iushln(g)
        };
    };
    // This is reduced incarnation of the binary EEA
    // above, designated to invert members of the
    // _prime_ fields F(p) at a maximal speed
    BN.prototype._invmp = function _invmp(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var a = this;
        var b = p.clone();
        if (a.negative !== 0) a = a.umod(p);
        else a = a.clone();
        var x1 = new BN(1);
        var x2 = new BN(0);
        var delta = b.clone();
        while(a.cmpn(1) > 0 && b.cmpn(1) > 0){
            for(var i = 0, im = 1; (a.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                a.iushrn(i);
                while(i-- > 0){
                    if (x1.isOdd()) x1.iadd(delta);
                    x1.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (b.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                b.iushrn(j);
                while(j-- > 0){
                    if (x2.isOdd()) x2.iadd(delta);
                    x2.iushrn(1);
                }
            }
            if (a.cmp(b) >= 0) {
                a.isub(b);
                x1.isub(x2);
            } else {
                b.isub(a);
                x2.isub(x1);
            }
        }
        var res;
        if (a.cmpn(1) === 0) res = x1;
        else res = x2;
        if (res.cmpn(0) < 0) res.iadd(p);
        return res;
    };
    BN.prototype.gcd = function gcd(num) {
        if (this.isZero()) return num.abs();
        if (num.isZero()) return this.abs();
        var a = this.clone();
        var b = num.clone();
        a.negative = 0;
        b.negative = 0;
        // Remove common factor of two
        for(var shift = 0; a.isEven() && b.isEven(); shift++){
            a.iushrn(1);
            b.iushrn(1);
        }
        do {
            while(a.isEven())a.iushrn(1);
            while(b.isEven())b.iushrn(1);
            var r = a.cmp(b);
            if (r < 0) {
                // Swap `a` and `b` to make `a` always bigger than `b`
                var t = a;
                a = b;
                b = t;
            } else if (r === 0 || b.cmpn(1) === 0) break;
            a.isub(b);
        }while (true);
        return b.iushln(shift);
    };
    // Invert number in the field F(num)
    BN.prototype.invm = function invm(num) {
        return this.egcd(num).a.umod(num);
    };
    BN.prototype.isEven = function isEven() {
        return (this.words[0] & 1) === 0;
    };
    BN.prototype.isOdd = function isOdd() {
        return (this.words[0] & 1) === 1;
    };
    // And first word and num
    BN.prototype.andln = function andln(num) {
        return this.words[0] & num;
    };
    // Increment at the bit position in-line
    BN.prototype.bincn = function bincn(bit) {
        assert(typeof bit === "number");
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) {
            this._expand(s + 1);
            this.words[s] |= q;
            return this;
        }
        // Add bit and propagate, if needed
        var carry = q;
        for(var i = s; carry !== 0 && i < this.length; i++){
            var w = this.words[i] | 0;
            w += carry;
            carry = w >>> 26;
            w &= 0x3ffffff;
            this.words[i] = w;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return this;
    };
    BN.prototype.isZero = function isZero() {
        return this.length === 1 && this.words[0] === 0;
    };
    BN.prototype.cmpn = function cmpn(num) {
        var negative = num < 0;
        if (this.negative !== 0 && !negative) return -1;
        if (this.negative === 0 && negative) return 1;
        this._strip();
        var res;
        if (this.length > 1) res = 1;
        else {
            if (negative) num = -num;
            assert(num <= 0x3ffffff, "Number is too big");
            var w = this.words[0] | 0;
            res = w === num ? 0 : w < num ? -1 : 1;
        }
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Compare two numbers and return:
    // 1 - if `this` > `num`
    // 0 - if `this` == `num`
    // -1 - if `this` < `num`
    BN.prototype.cmp = function cmp(num) {
        if (this.negative !== 0 && num.negative === 0) return -1;
        if (this.negative === 0 && num.negative !== 0) return 1;
        var res = this.ucmp(num);
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Unsigned comparison
    BN.prototype.ucmp = function ucmp(num) {
        // At this point both numbers have the same sign
        if (this.length > num.length) return 1;
        if (this.length < num.length) return -1;
        var res = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var a = this.words[i] | 0;
            var b = num.words[i] | 0;
            if (a === b) continue;
            if (a < b) res = -1;
            else if (a > b) res = 1;
            break;
        }
        return res;
    };
    BN.prototype.gtn = function gtn(num) {
        return this.cmpn(num) === 1;
    };
    BN.prototype.gt = function gt(num) {
        return this.cmp(num) === 1;
    };
    BN.prototype.gten = function gten(num) {
        return this.cmpn(num) >= 0;
    };
    BN.prototype.gte = function gte(num) {
        return this.cmp(num) >= 0;
    };
    BN.prototype.ltn = function ltn(num) {
        return this.cmpn(num) === -1;
    };
    BN.prototype.lt = function lt(num) {
        return this.cmp(num) === -1;
    };
    BN.prototype.lten = function lten(num) {
        return this.cmpn(num) <= 0;
    };
    BN.prototype.lte = function lte(num) {
        return this.cmp(num) <= 0;
    };
    BN.prototype.eqn = function eqn(num) {
        return this.cmpn(num) === 0;
    };
    BN.prototype.eq = function eq(num) {
        return this.cmp(num) === 0;
    };
    //
    // A reduce context, could be using montgomery or something better, depending
    // on the `m` itself.
    //
    BN.red = function red(num) {
        return new Red(num);
    };
    BN.prototype.toRed = function toRed(ctx) {
        assert(!this.red, "Already a number in reduction context");
        assert(this.negative === 0, "red works only with positives");
        return ctx.convertTo(this)._forceRed(ctx);
    };
    BN.prototype.fromRed = function fromRed() {
        assert(this.red, "fromRed works only with numbers in reduction context");
        return this.red.convertFrom(this);
    };
    BN.prototype._forceRed = function _forceRed(ctx) {
        this.red = ctx;
        return this;
    };
    BN.prototype.forceRed = function forceRed(ctx) {
        assert(!this.red, "Already a number in reduction context");
        return this._forceRed(ctx);
    };
    BN.prototype.redAdd = function redAdd(num) {
        assert(this.red, "redAdd works only with red numbers");
        return this.red.add(this, num);
    };
    BN.prototype.redIAdd = function redIAdd(num) {
        assert(this.red, "redIAdd works only with red numbers");
        return this.red.iadd(this, num);
    };
    BN.prototype.redSub = function redSub(num) {
        assert(this.red, "redSub works only with red numbers");
        return this.red.sub(this, num);
    };
    BN.prototype.redISub = function redISub(num) {
        assert(this.red, "redISub works only with red numbers");
        return this.red.isub(this, num);
    };
    BN.prototype.redShl = function redShl(num) {
        assert(this.red, "redShl works only with red numbers");
        return this.red.shl(this, num);
    };
    BN.prototype.redMul = function redMul(num) {
        assert(this.red, "redMul works only with red numbers");
        this.red._verify2(this, num);
        return this.red.mul(this, num);
    };
    BN.prototype.redIMul = function redIMul(num) {
        assert(this.red, "redMul works only with red numbers");
        this.red._verify2(this, num);
        return this.red.imul(this, num);
    };
    BN.prototype.redSqr = function redSqr() {
        assert(this.red, "redSqr works only with red numbers");
        this.red._verify1(this);
        return this.red.sqr(this);
    };
    BN.prototype.redISqr = function redISqr() {
        assert(this.red, "redISqr works only with red numbers");
        this.red._verify1(this);
        return this.red.isqr(this);
    };
    // Square root over p
    BN.prototype.redSqrt = function redSqrt() {
        assert(this.red, "redSqrt works only with red numbers");
        this.red._verify1(this);
        return this.red.sqrt(this);
    };
    BN.prototype.redInvm = function redInvm() {
        assert(this.red, "redInvm works only with red numbers");
        this.red._verify1(this);
        return this.red.invm(this);
    };
    // Return negative clone of `this` % `red modulo`
    BN.prototype.redNeg = function redNeg() {
        assert(this.red, "redNeg works only with red numbers");
        this.red._verify1(this);
        return this.red.neg(this);
    };
    BN.prototype.redPow = function redPow(num) {
        assert(this.red && !num.red, "redPow(normalNum)");
        this.red._verify1(this);
        return this.red.pow(this, num);
    };
    // Prime numbers with efficient reduction
    var primes = {
        k256: null,
        p224: null,
        p192: null,
        p25519: null
    };
    // Pseudo-Mersenne prime
    function MPrime(name, p) {
        // P = 2 ^ N - K
        this.name = name;
        this.p = new BN(p, 16);
        this.n = this.p.bitLength();
        this.k = new BN(1).iushln(this.n).isub(this.p);
        this.tmp = this._tmp();
    }
    MPrime.prototype._tmp = function _tmp() {
        var tmp = new BN(null);
        tmp.words = new Array(Math.ceil(this.n / 13));
        return tmp;
    };
    MPrime.prototype.ireduce = function ireduce(num) {
        // Assumes that `num` is less than `P^2`
        // num = HI * (2 ^ N - K) + HI * K + LO = HI * K + LO (mod P)
        var r = num;
        var rlen;
        do {
            this.split(r, this.tmp);
            r = this.imulK(r);
            r = r.iadd(this.tmp);
            rlen = r.bitLength();
        }while (rlen > this.n);
        var cmp = rlen < this.n ? -1 : r.ucmp(this.p);
        if (cmp === 0) {
            r.words[0] = 0;
            r.length = 1;
        } else if (cmp > 0) r.isub(this.p);
        else if (r.strip !== undefined) // r is a BN v4 instance
        r.strip();
        else // r is a BN v5 instance
        r._strip();
        return r;
    };
    MPrime.prototype.split = function split(input, out) {
        input.iushrn(this.n, 0, out);
    };
    MPrime.prototype.imulK = function imulK(num) {
        return num.imul(this.k);
    };
    function K256() {
        MPrime.call(this, "k256", "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f");
    }
    inherits(K256, MPrime);
    K256.prototype.split = function split(input, output) {
        // 256 = 9 * 26 + 22
        var mask = 0x3fffff;
        var outLen = Math.min(input.length, 9);
        for(var i = 0; i < outLen; i++)output.words[i] = input.words[i];
        output.length = outLen;
        if (input.length <= 9) {
            input.words[0] = 0;
            input.length = 1;
            return;
        }
        // Shift by 9 limbs
        var prev = input.words[9];
        output.words[output.length++] = prev & mask;
        for(i = 10; i < input.length; i++){
            var next = input.words[i] | 0;
            input.words[i - 10] = (next & mask) << 4 | prev >>> 22;
            prev = next;
        }
        prev >>>= 22;
        input.words[i - 10] = prev;
        if (prev === 0 && input.length > 10) input.length -= 10;
        else input.length -= 9;
    };
    K256.prototype.imulK = function imulK(num) {
        // K = 0x1000003d1 = [ 0x40, 0x3d1 ]
        num.words[num.length] = 0;
        num.words[num.length + 1] = 0;
        num.length += 2;
        // bounded at: 0x40 * 0x3ffffff + 0x3d0 = 0x100000390
        var lo = 0;
        for(var i = 0; i < num.length; i++){
            var w = num.words[i] | 0;
            lo += w * 0x3d1;
            num.words[i] = lo & 0x3ffffff;
            lo = w * 0x40 + (lo / 0x4000000 | 0);
        }
        // Fast length reduction
        if (num.words[num.length - 1] === 0) {
            num.length--;
            if (num.words[num.length - 1] === 0) num.length--;
        }
        return num;
    };
    function P224() {
        MPrime.call(this, "p224", "ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001");
    }
    inherits(P224, MPrime);
    function P192() {
        MPrime.call(this, "p192", "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff");
    }
    inherits(P192, MPrime);
    function P25519() {
        // 2 ^ 255 - 19
        MPrime.call(this, "25519", "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed");
    }
    inherits(P25519, MPrime);
    P25519.prototype.imulK = function imulK(num) {
        // K = 0x13
        var carry = 0;
        for(var i = 0; i < num.length; i++){
            var hi = (num.words[i] | 0) * 0x13 + carry;
            var lo = hi & 0x3ffffff;
            hi >>>= 26;
            num.words[i] = lo;
            carry = hi;
        }
        if (carry !== 0) num.words[num.length++] = carry;
        return num;
    };
    // Exported mostly for testing purposes, use plain name instead
    BN._prime = function prime(name) {
        // Cached version of prime
        if (primes[name]) return primes[name];
        var prime;
        if (name === "k256") prime = new K256();
        else if (name === "p224") prime = new P224();
        else if (name === "p192") prime = new P192();
        else if (name === "p25519") prime = new P25519();
        else throw new Error("Unknown prime " + name);
        primes[name] = prime;
        return prime;
    };
    //
    // Base reduction engine
    //
    function Red(m) {
        if (typeof m === "string") {
            var prime = BN._prime(m);
            this.m = prime.p;
            this.prime = prime;
        } else {
            assert(m.gtn(1), "modulus must be greater than 1");
            this.m = m;
            this.prime = null;
        }
    }
    Red.prototype._verify1 = function _verify1(a) {
        assert(a.negative === 0, "red works only with positives");
        assert(a.red, "red works only with red numbers");
    };
    Red.prototype._verify2 = function _verify2(a, b) {
        assert((a.negative | b.negative) === 0, "red works only with positives");
        assert(a.red && a.red === b.red, "red works only with red numbers");
    };
    Red.prototype.imod = function imod(a) {
        if (this.prime) return this.prime.ireduce(a)._forceRed(this);
        move(a, a.umod(this.m)._forceRed(this));
        return a;
    };
    Red.prototype.neg = function neg(a) {
        if (a.isZero()) return a.clone();
        return this.m.sub(a)._forceRed(this);
    };
    Red.prototype.add = function add(a, b) {
        this._verify2(a, b);
        var res = a.add(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res._forceRed(this);
    };
    Red.prototype.iadd = function iadd(a, b) {
        this._verify2(a, b);
        var res = a.iadd(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res;
    };
    Red.prototype.sub = function sub(a, b) {
        this._verify2(a, b);
        var res = a.sub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res._forceRed(this);
    };
    Red.prototype.isub = function isub(a, b) {
        this._verify2(a, b);
        var res = a.isub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res;
    };
    Red.prototype.shl = function shl(a, num) {
        this._verify1(a);
        return this.imod(a.ushln(num));
    };
    Red.prototype.imul = function imul(a, b) {
        this._verify2(a, b);
        return this.imod(a.imul(b));
    };
    Red.prototype.mul = function mul(a, b) {
        this._verify2(a, b);
        return this.imod(a.mul(b));
    };
    Red.prototype.isqr = function isqr(a) {
        return this.imul(a, a.clone());
    };
    Red.prototype.sqr = function sqr(a) {
        return this.mul(a, a);
    };
    Red.prototype.sqrt = function sqrt(a) {
        if (a.isZero()) return a.clone();
        var mod3 = this.m.andln(3);
        assert(mod3 % 2 === 1);
        // Fast case
        if (mod3 === 3) {
            var pow = this.m.add(new BN(1)).iushrn(2);
            return this.pow(a, pow);
        }
        // Tonelli-Shanks algorithm (Totally unoptimized and slow)
        //
        // Find Q and S, that Q * 2 ^ S = (P - 1)
        var q = this.m.subn(1);
        var s = 0;
        while(!q.isZero() && q.andln(1) === 0){
            s++;
            q.iushrn(1);
        }
        assert(!q.isZero());
        var one = new BN(1).toRed(this);
        var nOne = one.redNeg();
        // Find quadratic non-residue
        // NOTE: Max is such because of generalized Riemann hypothesis.
        var lpow = this.m.subn(1).iushrn(1);
        var z = this.m.bitLength();
        z = new BN(2 * z * z).toRed(this);
        while(this.pow(z, lpow).cmp(nOne) !== 0)z.redIAdd(nOne);
        var c = this.pow(z, q);
        var r = this.pow(a, q.addn(1).iushrn(1));
        var t = this.pow(a, q);
        var m = s;
        while(t.cmp(one) !== 0){
            var tmp = t;
            for(var i = 0; tmp.cmp(one) !== 0; i++)tmp = tmp.redSqr();
            assert(i < m);
            var b = this.pow(c, new BN(1).iushln(m - i - 1));
            r = r.redMul(b);
            c = b.redSqr();
            t = t.redMul(c);
            m = i;
        }
        return r;
    };
    Red.prototype.invm = function invm(a) {
        var inv = a._invmp(this.m);
        if (inv.negative !== 0) {
            inv.negative = 0;
            return this.imod(inv).redNeg();
        } else return this.imod(inv);
    };
    Red.prototype.pow = function pow(a, num) {
        if (num.isZero()) return new BN(1).toRed(this);
        if (num.cmpn(1) === 0) return a.clone();
        var windowSize = 4;
        var wnd = new Array(1 << windowSize);
        wnd[0] = new BN(1).toRed(this);
        wnd[1] = a;
        for(var i = 2; i < wnd.length; i++)wnd[i] = this.mul(wnd[i - 1], a);
        var res = wnd[0];
        var current = 0;
        var currentLen = 0;
        var start = num.bitLength() % 26;
        if (start === 0) start = 26;
        for(i = num.length - 1; i >= 0; i--){
            var word = num.words[i];
            for(var j = start - 1; j >= 0; j--){
                var bit = word >> j & 1;
                if (res !== wnd[0]) res = this.sqr(res);
                if (bit === 0 && current === 0) {
                    currentLen = 0;
                    continue;
                }
                current <<= 1;
                current |= bit;
                currentLen++;
                if (currentLen !== windowSize && (i !== 0 || j !== 0)) continue;
                res = this.mul(res, wnd[current]);
                currentLen = 0;
                current = 0;
            }
            start = 26;
        }
        return res;
    };
    Red.prototype.convertTo = function convertTo(num) {
        var r = num.umod(this.m);
        return r === num ? r.clone() : r;
    };
    Red.prototype.convertFrom = function convertFrom(num) {
        var res = num.clone();
        res.red = null;
        return res;
    };
    //
    // Montgomery method engine
    //
    BN.mont = function mont(num) {
        return new Mont(num);
    };
    function Mont(m) {
        Red.call(this, m);
        this.shift = this.m.bitLength();
        if (this.shift % 26 !== 0) this.shift += 26 - this.shift % 26;
        this.r = new BN(1).iushln(this.shift);
        this.r2 = this.imod(this.r.sqr());
        this.rinv = this.r._invmp(this.m);
        this.minv = this.rinv.mul(this.r).isubn(1).div(this.m);
        this.minv = this.minv.umod(this.r);
        this.minv = this.r.sub(this.minv);
    }
    inherits(Mont, Red);
    Mont.prototype.convertTo = function convertTo(num) {
        return this.imod(num.ushln(this.shift));
    };
    Mont.prototype.convertFrom = function convertFrom(num) {
        var r = this.imod(num.mul(this.rinv));
        r.red = null;
        return r;
    };
    Mont.prototype.imul = function imul(a, b) {
        if (a.isZero() || b.isZero()) {
            a.words[0] = 0;
            a.length = 1;
            return a;
        }
        var t = a.imul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.mul = function mul(a, b) {
        if (a.isZero() || b.isZero()) return new BN(0)._forceRed(this);
        var t = a.mul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.invm = function invm(a) {
        // (AR)^-1 * R^2 = (A^-1 * R^-1) * R^2 = A^-1 * R
        var res = this.imod(a._invmp(this.m).mul(this.r2));
        return res._forceRed(this);
    };
})(module, this);

});

parcelRequire.register("fnnh9", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.findAttribute = module.exports.parseLogs = module.exports.parseLog = module.exports.parseEvent = module.exports.parseAttribute = void 0;

var $dOLgD = parcelRequire("dOLgD");
function $b31b0f0d7bdb5310$var$parseAttribute(input) {
    if (!(0, $dOLgD.isNonNullObject)(input)) throw new Error("Attribute must be a non-null object");
    const { key: key, value: value } = input;
    if (typeof key !== "string" || !key) throw new Error("Attribute's key must be a non-empty string");
    if (typeof value !== "string" && typeof value !== "undefined") throw new Error("Attribute's value must be a string or unset");
    return {
        key: key,
        value: value || ""
    };
}
module.exports.parseAttribute = $b31b0f0d7bdb5310$var$parseAttribute;
function $b31b0f0d7bdb5310$var$parseEvent(input) {
    if (!(0, $dOLgD.isNonNullObject)(input)) throw new Error("Event must be a non-null object");
    const { type: type, attributes: attributes } = input;
    if (typeof type !== "string" || type === "") throw new Error(`Event type must be a non-empty string`);
    if (!Array.isArray(attributes)) throw new Error("Event's attributes must be an array");
    return {
        type: type,
        attributes: attributes.map($b31b0f0d7bdb5310$var$parseAttribute)
    };
}
module.exports.parseEvent = $b31b0f0d7bdb5310$var$parseEvent;
function $b31b0f0d7bdb5310$var$parseLog(input) {
    if (!(0, $dOLgD.isNonNullObject)(input)) throw new Error("Log must be a non-null object");
    const { msg_index: msg_index, log: log, events: events } = input;
    if (typeof msg_index !== "number") throw new Error("Log's msg_index must be a number");
    if (typeof log !== "string") throw new Error("Log's log must be a string");
    if (!Array.isArray(events)) throw new Error("Log's events must be an array");
    return {
        msg_index: msg_index,
        log: log,
        events: events.map($b31b0f0d7bdb5310$var$parseEvent)
    };
}
module.exports.parseLog = $b31b0f0d7bdb5310$var$parseLog;
function $b31b0f0d7bdb5310$var$parseLogs(input) {
    if (!Array.isArray(input)) throw new Error("Logs must be an array");
    return input.map($b31b0f0d7bdb5310$var$parseLog);
}
module.exports.parseLogs = $b31b0f0d7bdb5310$var$parseLogs;
/**
 * Searches in logs for the first event of the given event type and in that event
 * for the first first attribute with the given attribute key.
 *
 * Throws if the attribute was not found.
 */ function $b31b0f0d7bdb5310$var$findAttribute(logs, eventType, attrKey) {
    var _a;
    const firstLogs = logs.find(()=>true);
    const out = (_a = firstLogs === null || firstLogs === void 0 ? void 0 : firstLogs.events.find((event)=>event.type === eventType)) === null || _a === void 0 ? void 0 : _a.attributes.find((attr)=>attr.key === attrKey);
    if (!out) throw new Error(`Could not find attribute '${attrKey}' in first event of type '${eventType}' in first log.`);
    return out;
}
module.exports.findAttribute = $b31b0f0d7bdb5310$var$findAttribute;

});
parcelRequire.register("dOLgD", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.isUint8Array = module.exports.isNonNullObject = module.exports.sleep = module.exports.assertDefinedAndNotNull = module.exports.assertDefined = module.exports.assert = module.exports.arrayContentStartsWith = module.exports.arrayContentEquals = void 0;

var $7VxGB = parcelRequire("7VxGB");
Object.defineProperty(module.exports, "arrayContentEquals", {
    enumerable: true,
    get: function() {
        return $7VxGB.arrayContentEquals;
    }
});
Object.defineProperty(module.exports, "arrayContentStartsWith", {
    enumerable: true,
    get: function() {
        return $7VxGB.arrayContentStartsWith;
    }
});

var $fTUk9 = parcelRequire("fTUk9");
Object.defineProperty(module.exports, "assert", {
    enumerable: true,
    get: function() {
        return $fTUk9.assert;
    }
});
Object.defineProperty(module.exports, "assertDefined", {
    enumerable: true,
    get: function() {
        return $fTUk9.assertDefined;
    }
});
Object.defineProperty(module.exports, "assertDefinedAndNotNull", {
    enumerable: true,
    get: function() {
        return $fTUk9.assertDefinedAndNotNull;
    }
});

var $3KVts = parcelRequire("3KVts");
Object.defineProperty(module.exports, "sleep", {
    enumerable: true,
    get: function() {
        return $3KVts.sleep;
    }
});

var $8Ijzm = parcelRequire("8Ijzm");
Object.defineProperty(module.exports, "isNonNullObject", {
    enumerable: true,
    get: function() {
        return $8Ijzm.isNonNullObject;
    }
});
Object.defineProperty(module.exports, "isUint8Array", {
    enumerable: true,
    get: function() {
        return $8Ijzm.isUint8Array;
    }
});

});
parcelRequire.register("7VxGB", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.arrayContentStartsWith = module.exports.arrayContentEquals = void 0;
/**
 * Compares the content of two arrays-like objects for equality.
 *
 * Equality is defined as having equal length and element values, where element equality means `===` returning `true`.
 *
 * This allows you to compare the content of a Buffer, Uint8Array or number[], ignoring the specific type.
 * As a consequence, this returns different results than Jasmine's `toEqual`, which ensures elements have the same type.
 */ function $5c57fca41182473f$var$arrayContentEquals(a, b) {
    if (a.length !== b.length) return false;
    for(let i = 0; i < a.length; ++i){
        if (a[i] !== b[i]) return false;
    }
    return true;
}
module.exports.arrayContentEquals = $5c57fca41182473f$var$arrayContentEquals;
/**
 * Checks if `a` starts with the contents of `b`.
 *
 * This requires equality of the element values, where element equality means `===` returning `true`.
 *
 * This allows you to compare the content of a Buffer, Uint8Array or number[], ignoring the specific type.
 * As a consequence, this returns different results than Jasmine's `toEqual`, which ensures elements have the same type.
 */ function $5c57fca41182473f$var$arrayContentStartsWith(a, b) {
    if (a.length < b.length) return false;
    for(let i = 0; i < b.length; ++i){
        if (a[i] !== b[i]) return false;
    }
    return true;
}
module.exports.arrayContentStartsWith = $5c57fca41182473f$var$arrayContentStartsWith;

});

parcelRequire.register("fTUk9", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.assertDefinedAndNotNull = module.exports.assertDefined = module.exports.assert = void 0;
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
function $b937aed71b557125$var$assert(condition, msg) {
    if (!condition) throw new Error(msg || "condition is not truthy");
}
module.exports.assert = $b937aed71b557125$var$assert;
function $b937aed71b557125$var$assertDefined(value, msg) {
    if (value === undefined) throw new Error(msg !== null && msg !== void 0 ? msg : "value is undefined");
}
module.exports.assertDefined = $b937aed71b557125$var$assertDefined;
function $b937aed71b557125$var$assertDefinedAndNotNull(value, msg) {
    if (value === undefined || value === null) throw new Error(msg !== null && msg !== void 0 ? msg : "value is undefined or null");
}
module.exports.assertDefinedAndNotNull = $b937aed71b557125$var$assertDefinedAndNotNull;

});

parcelRequire.register("3KVts", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.sleep = void 0;
async function $2bc24024437b146a$var$sleep(ms) {
    return new Promise((resolve)=>setTimeout(resolve, ms));
}
module.exports.sleep = $2bc24024437b146a$var$sleep;

});

parcelRequire.register("8Ijzm", function(module, exports) {

var $ihoyg = parcelRequire("ihoyg");
var $65819cdeb4e83c40$require$Buffer = $ihoyg.Buffer;
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.isUint8Array = module.exports.isNonNullObject = void 0;
/**
 * Checks if data is a non-null object (i.e. matches the TypeScript object type).
 *
 * Note: this returns true for arrays, which are objects in JavaScript
 * even though array and object are different types in JSON.
 *
 * @see https://www.typescriptlang.org/docs/handbook/basic-types.html#object
 */ // eslint-disable-next-line @typescript-eslint/ban-types
function $65819cdeb4e83c40$var$isNonNullObject(data) {
    return typeof data === "object" && data !== null;
}
module.exports.isNonNullObject = $65819cdeb4e83c40$var$isNonNullObject;
/**
 * Checks if data is an Uint8Array. Note: Buffer is treated as not a Uint8Array
 */ function $65819cdeb4e83c40$var$isUint8Array(data) {
    if (!$65819cdeb4e83c40$var$isNonNullObject(data)) return false;
    // Avoid instanceof check which is unreliable in some JS environments
    // https://medium.com/@simonwarta/limitations-of-the-instanceof-operator-f4bcdbe7a400
    // Use check that was discussed in https://github.com/crypto-browserify/pbkdf2/pull/81
    if (Object.prototype.toString.call(data) !== "[object Uint8Array]") return false;
    if (typeof $65819cdeb4e83c40$require$Buffer !== "undefined" && typeof $65819cdeb4e83c40$require$Buffer.isBuffer !== "undefined") {
        // Buffer.isBuffer is available at runtime
        if ($65819cdeb4e83c40$require$Buffer.isBuffer(data)) return false;
    }
    return true;
}
module.exports.isUint8Array = $65819cdeb4e83c40$var$isUint8Array;

});



parcelRequire.register("2shzp", function(module, exports) {

module.exports = (parcelRequire("bRlFp"));

});
parcelRequire.register("bRlFp", function(module, exports) {
"use strict";

var $2bBga = parcelRequire("2bBga");

var $djt5d = parcelRequire("djt5d");

var $6zSb1 = parcelRequire("6zSb1");

var $d0EKm = parcelRequire("d0EKm");

var $8SEIg = parcelRequire("8SEIg");
/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 * @return {Axios} A new instance of Axios
 */ function $8a2573892eafc323$var$createInstance(defaultConfig) {
    var context = new $6zSb1(defaultConfig);
    var instance = $djt5d($6zSb1.prototype.request, context);
    // Copy axios.prototype to instance
    $2bBga.extend(instance, $6zSb1.prototype, context);
    // Copy context to instance
    $2bBga.extend(instance, context);
    return instance;
}
// Create the default instance to be exported
var $8a2573892eafc323$var$axios = $8a2573892eafc323$var$createInstance($8SEIg);
// Expose Axios class to allow class inheritance
$8a2573892eafc323$var$axios.Axios = $6zSb1;
// Factory for creating new instances
$8a2573892eafc323$var$axios.create = function create(instanceConfig) {
    return $8a2573892eafc323$var$createInstance($d0EKm($8a2573892eafc323$var$axios.defaults, instanceConfig));
};

// Expose Cancel & CancelToken
$8a2573892eafc323$var$axios.Cancel = (parcelRequire("guIkb"));

$8a2573892eafc323$var$axios.CancelToken = (parcelRequire("2sjhC"));

$8a2573892eafc323$var$axios.isCancel = (parcelRequire("ksuZT"));
// Expose all/spread
$8a2573892eafc323$var$axios.all = function all(promises) {
    return Promise.all(promises);
};

$8a2573892eafc323$var$axios.spread = (parcelRequire("av9gA"));

// Expose isAxiosError
$8a2573892eafc323$var$axios.isAxiosError = (parcelRequire("gNhGc"));
module.exports = $8a2573892eafc323$var$axios;
// Allow use of default import syntax in TypeScript
module.exports.default = $8a2573892eafc323$var$axios;

});
parcelRequire.register("2bBga", function(module, exports) {
"use strict";

var $djt5d = parcelRequire("djt5d");
// utils is a library of generic helper functions non-specific to axios
var $197982d8c7a73e5f$var$toString = Object.prototype.toString;
/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Array, otherwise false
 */ function $197982d8c7a73e5f$var$isArray(val) {
    return $197982d8c7a73e5f$var$toString.call(val) === "[object Array]";
}
/**
 * Determine if a value is undefined
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if the value is undefined, otherwise false
 */ function $197982d8c7a73e5f$var$isUndefined(val) {
    return typeof val === "undefined";
}
/**
 * Determine if a value is a Buffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Buffer, otherwise false
 */ function $197982d8c7a73e5f$var$isBuffer(val) {
    return val !== null && !$197982d8c7a73e5f$var$isUndefined(val) && val.constructor !== null && !$197982d8c7a73e5f$var$isUndefined(val.constructor) && typeof val.constructor.isBuffer === "function" && val.constructor.isBuffer(val);
}
/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */ function $197982d8c7a73e5f$var$isArrayBuffer(val) {
    return $197982d8c7a73e5f$var$toString.call(val) === "[object ArrayBuffer]";
}
/**
 * Determine if a value is a FormData
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an FormData, otherwise false
 */ function $197982d8c7a73e5f$var$isFormData(val) {
    return typeof FormData !== "undefined" && val instanceof FormData;
}
/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */ function $197982d8c7a73e5f$var$isArrayBufferView(val) {
    var result;
    if (typeof ArrayBuffer !== "undefined" && ArrayBuffer.isView) result = ArrayBuffer.isView(val);
    else result = val && val.buffer && val.buffer instanceof ArrayBuffer;
    return result;
}
/**
 * Determine if a value is a String
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a String, otherwise false
 */ function $197982d8c7a73e5f$var$isString(val) {
    return typeof val === "string";
}
/**
 * Determine if a value is a Number
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Number, otherwise false
 */ function $197982d8c7a73e5f$var$isNumber(val) {
    return typeof val === "number";
}
/**
 * Determine if a value is an Object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Object, otherwise false
 */ function $197982d8c7a73e5f$var$isObject(val) {
    return val !== null && typeof val === "object";
}
/**
 * Determine if a value is a plain Object
 *
 * @param {Object} val The value to test
 * @return {boolean} True if value is a plain Object, otherwise false
 */ function $197982d8c7a73e5f$var$isPlainObject(val) {
    if ($197982d8c7a73e5f$var$toString.call(val) !== "[object Object]") return false;
    var prototype = Object.getPrototypeOf(val);
    return prototype === null || prototype === Object.prototype;
}
/**
 * Determine if a value is a Date
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Date, otherwise false
 */ function $197982d8c7a73e5f$var$isDate(val) {
    return $197982d8c7a73e5f$var$toString.call(val) === "[object Date]";
}
/**
 * Determine if a value is a File
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a File, otherwise false
 */ function $197982d8c7a73e5f$var$isFile(val) {
    return $197982d8c7a73e5f$var$toString.call(val) === "[object File]";
}
/**
 * Determine if a value is a Blob
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Blob, otherwise false
 */ function $197982d8c7a73e5f$var$isBlob(val) {
    return $197982d8c7a73e5f$var$toString.call(val) === "[object Blob]";
}
/**
 * Determine if a value is a Function
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */ function $197982d8c7a73e5f$var$isFunction(val) {
    return $197982d8c7a73e5f$var$toString.call(val) === "[object Function]";
}
/**
 * Determine if a value is a Stream
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Stream, otherwise false
 */ function $197982d8c7a73e5f$var$isStream(val) {
    return $197982d8c7a73e5f$var$isObject(val) && $197982d8c7a73e5f$var$isFunction(val.pipe);
}
/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */ function $197982d8c7a73e5f$var$isURLSearchParams(val) {
    return typeof URLSearchParams !== "undefined" && val instanceof URLSearchParams;
}
/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 * @returns {String} The String freed of excess whitespace
 */ function $197982d8c7a73e5f$var$trim(str) {
    return str.trim ? str.trim() : str.replace(/^\s+|\s+$/g, "");
}
/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 * nativescript
 *  navigator.product -> 'NativeScript' or 'NS'
 */ function $197982d8c7a73e5f$var$isStandardBrowserEnv() {
    if (typeof navigator !== "undefined" && (navigator.product === "ReactNative" || navigator.product === "NativeScript" || navigator.product === "NS")) return false;
    return typeof window !== "undefined" && typeof document !== "undefined";
}
/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 */ function $197982d8c7a73e5f$var$forEach(obj, fn) {
    // Don't bother if no value provided
    if (obj === null || typeof obj === "undefined") return;
    // Force an array if not already something iterable
    if (typeof obj !== "object") /*eslint no-param-reassign:0*/ obj = [
        obj
    ];
    if ($197982d8c7a73e5f$var$isArray(obj)) // Iterate over array values
    for(var i = 0, l = obj.length; i < l; i++)fn.call(null, obj[i], i, obj);
    else {
        // Iterate over object keys
        for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) fn.call(null, obj[key], key, obj);
    }
}
/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 * @returns {Object} Result of all merge properties
 */ function $197982d8c7a73e5f$var$merge() {
    var result = {};
    function assignValue(val, key) {
        if ($197982d8c7a73e5f$var$isPlainObject(result[key]) && $197982d8c7a73e5f$var$isPlainObject(val)) result[key] = $197982d8c7a73e5f$var$merge(result[key], val);
        else if ($197982d8c7a73e5f$var$isPlainObject(val)) result[key] = $197982d8c7a73e5f$var$merge({}, val);
        else if ($197982d8c7a73e5f$var$isArray(val)) result[key] = val.slice();
        else result[key] = val;
    }
    for(var i = 0, l = arguments.length; i < l; i++)$197982d8c7a73e5f$var$forEach(arguments[i], assignValue);
    return result;
}
/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 * @return {Object} The resulting value of object a
 */ function $197982d8c7a73e5f$var$extend(a, b, thisArg) {
    $197982d8c7a73e5f$var$forEach(b, function assignValue(val, key) {
        if (thisArg && typeof val === "function") a[key] = $djt5d(val, thisArg);
        else a[key] = val;
    });
    return a;
}
/**
 * Remove byte order marker. This catches EF BB BF (the UTF-8 BOM)
 *
 * @param {string} content with BOM
 * @return {string} content value without BOM
 */ function $197982d8c7a73e5f$var$stripBOM(content) {
    if (content.charCodeAt(0) === 0xFEFF) content = content.slice(1);
    return content;
}
module.exports = {
    isArray: $197982d8c7a73e5f$var$isArray,
    isArrayBuffer: $197982d8c7a73e5f$var$isArrayBuffer,
    isBuffer: $197982d8c7a73e5f$var$isBuffer,
    isFormData: $197982d8c7a73e5f$var$isFormData,
    isArrayBufferView: $197982d8c7a73e5f$var$isArrayBufferView,
    isString: $197982d8c7a73e5f$var$isString,
    isNumber: $197982d8c7a73e5f$var$isNumber,
    isObject: $197982d8c7a73e5f$var$isObject,
    isPlainObject: $197982d8c7a73e5f$var$isPlainObject,
    isUndefined: $197982d8c7a73e5f$var$isUndefined,
    isDate: $197982d8c7a73e5f$var$isDate,
    isFile: $197982d8c7a73e5f$var$isFile,
    isBlob: $197982d8c7a73e5f$var$isBlob,
    isFunction: $197982d8c7a73e5f$var$isFunction,
    isStream: $197982d8c7a73e5f$var$isStream,
    isURLSearchParams: $197982d8c7a73e5f$var$isURLSearchParams,
    isStandardBrowserEnv: $197982d8c7a73e5f$var$isStandardBrowserEnv,
    forEach: $197982d8c7a73e5f$var$forEach,
    merge: $197982d8c7a73e5f$var$merge,
    extend: $197982d8c7a73e5f$var$extend,
    trim: $197982d8c7a73e5f$var$trim,
    stripBOM: $197982d8c7a73e5f$var$stripBOM
};

});
parcelRequire.register("djt5d", function(module, exports) {
"use strict";
module.exports = function bind(fn, thisArg) {
    return function wrap() {
        var args = new Array(arguments.length);
        for(var i = 0; i < args.length; i++)args[i] = arguments[i];
        return fn.apply(thisArg, args);
    };
};

});


parcelRequire.register("6zSb1", function(module, exports) {
"use strict";

var $2bBga = parcelRequire("2bBga");

var $2RNjJ = parcelRequire("2RNjJ");

var $5Dm7L = parcelRequire("5Dm7L");

var $eQ5d8 = parcelRequire("eQ5d8");

var $d0EKm = parcelRequire("d0EKm");

var $6zj0X = parcelRequire("6zj0X");
var $4ca0095817960ee3$var$validators = $6zj0X.validators;
/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 */ function $4ca0095817960ee3$var$Axios(instanceConfig) {
    this.defaults = instanceConfig;
    this.interceptors = {
        request: new $5Dm7L(),
        response: new $5Dm7L()
    };
}
/**
 * Dispatch a request
 *
 * @param {Object} config The config specific for this request (merged with this.defaults)
 */ $4ca0095817960ee3$var$Axios.prototype.request = function request(config) {
    /*eslint no-param-reassign:0*/ // Allow for axios('example/url'[, config]) a la fetch API
    if (typeof config === "string") {
        config = arguments[1] || {};
        config.url = arguments[0];
    } else config = config || {};
    config = $d0EKm(this.defaults, config);
    // Set config.method
    if (config.method) config.method = config.method.toLowerCase();
    else if (this.defaults.method) config.method = this.defaults.method.toLowerCase();
    else config.method = "get";
    var transitional = config.transitional;
    if (transitional !== undefined) $6zj0X.assertOptions(transitional, {
        silentJSONParsing: $4ca0095817960ee3$var$validators.transitional($4ca0095817960ee3$var$validators.boolean, "1.0.0"),
        forcedJSONParsing: $4ca0095817960ee3$var$validators.transitional($4ca0095817960ee3$var$validators.boolean, "1.0.0"),
        clarifyTimeoutError: $4ca0095817960ee3$var$validators.transitional($4ca0095817960ee3$var$validators.boolean, "1.0.0")
    }, false);
    // filter out skipped interceptors
    var requestInterceptorChain = [];
    var synchronousRequestInterceptors = true;
    this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
        if (typeof interceptor.runWhen === "function" && interceptor.runWhen(config) === false) return;
        synchronousRequestInterceptors = synchronousRequestInterceptors && interceptor.synchronous;
        requestInterceptorChain.unshift(interceptor.fulfilled, interceptor.rejected);
    });
    var responseInterceptorChain = [];
    this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
        responseInterceptorChain.push(interceptor.fulfilled, interceptor.rejected);
    });
    var promise;
    if (!synchronousRequestInterceptors) {
        var chain = [
            $eQ5d8,
            undefined
        ];
        Array.prototype.unshift.apply(chain, requestInterceptorChain);
        chain = chain.concat(responseInterceptorChain);
        promise = Promise.resolve(config);
        while(chain.length)promise = promise.then(chain.shift(), chain.shift());
        return promise;
    }
    var newConfig = config;
    while(requestInterceptorChain.length){
        var onFulfilled = requestInterceptorChain.shift();
        var onRejected = requestInterceptorChain.shift();
        try {
            newConfig = onFulfilled(newConfig);
        } catch (error) {
            onRejected(error);
            break;
        }
    }
    try {
        promise = $eQ5d8(newConfig);
    } catch (error) {
        return Promise.reject(error);
    }
    while(responseInterceptorChain.length)promise = promise.then(responseInterceptorChain.shift(), responseInterceptorChain.shift());
    return promise;
};
$4ca0095817960ee3$var$Axios.prototype.getUri = function getUri(config) {
    config = $d0EKm(this.defaults, config);
    return $2RNjJ(config.url, config.params, config.paramsSerializer).replace(/^\?/, "");
};
// Provide aliases for supported request methods
$2bBga.forEach([
    "delete",
    "get",
    "head",
    "options"
], function forEachMethodNoData(method) {
    /*eslint func-names:0*/ $4ca0095817960ee3$var$Axios.prototype[method] = function(url, config) {
        return this.request($d0EKm(config || {}, {
            method: method,
            url: url,
            data: (config || {}).data
        }));
    };
});
$2bBga.forEach([
    "post",
    "put",
    "patch"
], function forEachMethodWithData(method) {
    /*eslint func-names:0*/ $4ca0095817960ee3$var$Axios.prototype[method] = function(url, data, config) {
        return this.request($d0EKm(config || {}, {
            method: method,
            url: url,
            data: data
        }));
    };
});
module.exports = $4ca0095817960ee3$var$Axios;

});
parcelRequire.register("2RNjJ", function(module, exports) {
"use strict";

var $2bBga = parcelRequire("2bBga");
function $2166c96446d6ea30$var$encode(val) {
    return encodeURIComponent(val).replace(/%3A/gi, ":").replace(/%24/g, "$").replace(/%2C/gi, ",").replace(/%20/g, "+").replace(/%5B/gi, "[").replace(/%5D/gi, "]");
}
/**
 * Build a URL by appending params to the end
 *
 * @param {string} url The base of the url (e.g., http://www.google.com)
 * @param {object} [params] The params to be appended
 * @returns {string} The formatted url
 */ module.exports = function buildURL(url, params, paramsSerializer) {
    /*eslint no-param-reassign:0*/ if (!params) return url;
    var serializedParams;
    if (paramsSerializer) serializedParams = paramsSerializer(params);
    else if ($2bBga.isURLSearchParams(params)) serializedParams = params.toString();
    else {
        var parts = [];
        $2bBga.forEach(params, function serialize(val, key) {
            if (val === null || typeof val === "undefined") return;
            if ($2bBga.isArray(val)) key = key + "[]";
            else val = [
                val
            ];
            $2bBga.forEach(val, function parseValue(v) {
                if ($2bBga.isDate(v)) v = v.toISOString();
                else if ($2bBga.isObject(v)) v = JSON.stringify(v);
                parts.push($2166c96446d6ea30$var$encode(key) + "=" + $2166c96446d6ea30$var$encode(v));
            });
        });
        serializedParams = parts.join("&");
    }
    if (serializedParams) {
        var hashmarkIndex = url.indexOf("#");
        if (hashmarkIndex !== -1) url = url.slice(0, hashmarkIndex);
        url += (url.indexOf("?") === -1 ? "?" : "&") + serializedParams;
    }
    return url;
};

});

parcelRequire.register("5Dm7L", function(module, exports) {
"use strict";

var $2bBga = parcelRequire("2bBga");
function $41a1c1ac65ef962e$var$InterceptorManager() {
    this.handlers = [];
}
/**
 * Add a new interceptor to the stack
 *
 * @param {Function} fulfilled The function to handle `then` for a `Promise`
 * @param {Function} rejected The function to handle `reject` for a `Promise`
 *
 * @return {Number} An ID used to remove interceptor later
 */ $41a1c1ac65ef962e$var$InterceptorManager.prototype.use = function use(fulfilled, rejected, options) {
    this.handlers.push({
        fulfilled: fulfilled,
        rejected: rejected,
        synchronous: options ? options.synchronous : false,
        runWhen: options ? options.runWhen : null
    });
    return this.handlers.length - 1;
};
/**
 * Remove an interceptor from the stack
 *
 * @param {Number} id The ID that was returned by `use`
 */ $41a1c1ac65ef962e$var$InterceptorManager.prototype.eject = function eject(id) {
    if (this.handlers[id]) this.handlers[id] = null;
};
/**
 * Iterate over all the registered interceptors
 *
 * This method is particularly useful for skipping over any
 * interceptors that may have become `null` calling `eject`.
 *
 * @param {Function} fn The function to call for each interceptor
 */ $41a1c1ac65ef962e$var$InterceptorManager.prototype.forEach = function forEach(fn) {
    $2bBga.forEach(this.handlers, function forEachHandler(h) {
        if (h !== null) fn(h);
    });
};
module.exports = $41a1c1ac65ef962e$var$InterceptorManager;

});

parcelRequire.register("eQ5d8", function(module, exports) {
"use strict";

var $2bBga = parcelRequire("2bBga");

var $bhEpd = parcelRequire("bhEpd");

var $ksuZT = parcelRequire("ksuZT");

var $8SEIg = parcelRequire("8SEIg");
/**
 * Throws a `Cancel` if cancellation has been requested.
 */ function $acd9f6ce0996c2c9$var$throwIfCancellationRequested(config) {
    if (config.cancelToken) config.cancelToken.throwIfRequested();
}
/**
 * Dispatch a request to the server using the configured adapter.
 *
 * @param {object} config The config that is to be used for the request
 * @returns {Promise} The Promise to be fulfilled
 */ module.exports = function dispatchRequest(config) {
    $acd9f6ce0996c2c9$var$throwIfCancellationRequested(config);
    // Ensure headers exist
    config.headers = config.headers || {};
    // Transform request data
    config.data = $bhEpd.call(config, config.data, config.headers, config.transformRequest);
    // Flatten headers
    config.headers = $2bBga.merge(config.headers.common || {}, config.headers[config.method] || {}, config.headers);
    $2bBga.forEach([
        "delete",
        "get",
        "head",
        "post",
        "put",
        "patch",
        "common"
    ], function cleanHeaderConfig(method) {
        delete config.headers[method];
    });
    var adapter = config.adapter || $8SEIg.adapter;
    return adapter(config).then(function onAdapterResolution(response) {
        $acd9f6ce0996c2c9$var$throwIfCancellationRequested(config);
        // Transform response data
        response.data = $bhEpd.call(config, response.data, response.headers, config.transformResponse);
        return response;
    }, function onAdapterRejection(reason) {
        if (!$ksuZT(reason)) {
            $acd9f6ce0996c2c9$var$throwIfCancellationRequested(config);
            // Transform response data
            if (reason && reason.response) reason.response.data = $bhEpd.call(config, reason.response.data, reason.response.headers, config.transformResponse);
        }
        return Promise.reject(reason);
    });
};

});
parcelRequire.register("bhEpd", function(module, exports) {
"use strict";

var $2bBga = parcelRequire("2bBga");

var $8SEIg = parcelRequire("8SEIg");
/**
 * Transform the data for a request or a response
 *
 * @param {Object|String} data The data to be transformed
 * @param {Array} headers The headers for the request or response
 * @param {Array|Function} fns A single function or Array of functions
 * @returns {*} The resulting transformed data
 */ module.exports = function transformData(data, headers, fns) {
    var context = this || $8SEIg;
    /*eslint no-param-reassign:0*/ $2bBga.forEach(fns, function transform(fn) {
        data = fn.call(context, data, headers);
    });
    return data;
};

});
parcelRequire.register("8SEIg", function(module, exports) {

var $4TNnu = parcelRequire("4TNnu");
"use strict";

var $2bBga = parcelRequire("2bBga");

var $i16eu = parcelRequire("i16eu");

var $56XJZ = parcelRequire("56XJZ");
var $6772f29a7a4c17c5$var$DEFAULT_CONTENT_TYPE = {
    "Content-Type": "application/x-www-form-urlencoded"
};
function $6772f29a7a4c17c5$var$setContentTypeIfUnset(headers, value) {
    if (!$2bBga.isUndefined(headers) && $2bBga.isUndefined(headers["Content-Type"])) headers["Content-Type"] = value;
}


function $6772f29a7a4c17c5$var$getDefaultAdapter() {
    var adapter;
    if (typeof XMLHttpRequest !== "undefined") // For browsers use XHR adapter
    adapter = (parcelRequire("9VVcb"));
    else if (typeof $4TNnu !== "undefined" && Object.prototype.toString.call($4TNnu) === "[object process]") // For node use HTTP adapter
    adapter = (parcelRequire("9VVcb"));
    return adapter;
}
function $6772f29a7a4c17c5$var$stringifySafely(rawValue, parser, encoder) {
    if ($2bBga.isString(rawValue)) try {
        (parser || JSON.parse)(rawValue);
        return $2bBga.trim(rawValue);
    } catch (e) {
        if (e.name !== "SyntaxError") throw e;
    }
    return (encoder || JSON.stringify)(rawValue);
}
var $6772f29a7a4c17c5$var$defaults = {
    transitional: {
        silentJSONParsing: true,
        forcedJSONParsing: true,
        clarifyTimeoutError: false
    },
    adapter: $6772f29a7a4c17c5$var$getDefaultAdapter(),
    transformRequest: [
        function transformRequest(data, headers) {
            $i16eu(headers, "Accept");
            $i16eu(headers, "Content-Type");
            if ($2bBga.isFormData(data) || $2bBga.isArrayBuffer(data) || $2bBga.isBuffer(data) || $2bBga.isStream(data) || $2bBga.isFile(data) || $2bBga.isBlob(data)) return data;
            if ($2bBga.isArrayBufferView(data)) return data.buffer;
            if ($2bBga.isURLSearchParams(data)) {
                $6772f29a7a4c17c5$var$setContentTypeIfUnset(headers, "application/x-www-form-urlencoded;charset=utf-8");
                return data.toString();
            }
            if ($2bBga.isObject(data) || headers && headers["Content-Type"] === "application/json") {
                $6772f29a7a4c17c5$var$setContentTypeIfUnset(headers, "application/json");
                return $6772f29a7a4c17c5$var$stringifySafely(data);
            }
            return data;
        }
    ],
    transformResponse: [
        function transformResponse(data) {
            var transitional = this.transitional;
            var silentJSONParsing = transitional && transitional.silentJSONParsing;
            var forcedJSONParsing = transitional && transitional.forcedJSONParsing;
            var strictJSONParsing = !silentJSONParsing && this.responseType === "json";
            if (strictJSONParsing || forcedJSONParsing && $2bBga.isString(data) && data.length) try {
                return JSON.parse(data);
            } catch (e) {
                if (strictJSONParsing) {
                    if (e.name === "SyntaxError") throw $56XJZ(e, this, "E_JSON_PARSE");
                    throw e;
                }
            }
            return data;
        }
    ],
    /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */ timeout: 0,
    xsrfCookieName: "XSRF-TOKEN",
    xsrfHeaderName: "X-XSRF-TOKEN",
    maxContentLength: -1,
    maxBodyLength: -1,
    validateStatus: function validateStatus(status) {
        return status >= 200 && status < 300;
    }
};
$6772f29a7a4c17c5$var$defaults.headers = {
    common: {
        "Accept": "application/json, text/plain, */*"
    }
};
$2bBga.forEach([
    "delete",
    "get",
    "head"
], function forEachMethodNoData(method) {
    $6772f29a7a4c17c5$var$defaults.headers[method] = {};
});
$2bBga.forEach([
    "post",
    "put",
    "patch"
], function forEachMethodWithData(method) {
    $6772f29a7a4c17c5$var$defaults.headers[method] = $2bBga.merge($6772f29a7a4c17c5$var$DEFAULT_CONTENT_TYPE);
});
module.exports = $6772f29a7a4c17c5$var$defaults;

});
parcelRequire.register("i16eu", function(module, exports) {
"use strict";

var $2bBga = parcelRequire("2bBga");
module.exports = function normalizeHeaderName(headers, normalizedName) {
    $2bBga.forEach(headers, function processHeader(value, name) {
        if (name !== normalizedName && name.toUpperCase() === normalizedName.toUpperCase()) {
            headers[normalizedName] = value;
            delete headers[name];
        }
    });
};

});

parcelRequire.register("56XJZ", function(module, exports) {
"use strict";
/**
 * Update an Error with the specified config, error code, and response.
 *
 * @param {Error} error The error to update.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The error.
 */ module.exports = function enhanceError(error, config, code, request, response) {
    error.config = config;
    if (code) error.code = code;
    error.request = request;
    error.response = response;
    error.isAxiosError = true;
    error.toJSON = function toJSON() {
        return {
            // Standard
            message: this.message,
            name: this.name,
            // Microsoft
            description: this.description,
            number: this.number,
            // Mozilla
            fileName: this.fileName,
            lineNumber: this.lineNumber,
            columnNumber: this.columnNumber,
            stack: this.stack,
            // Axios
            config: this.config,
            code: this.code
        };
    };
    return error;
};

});

parcelRequire.register("9VVcb", function(module, exports) {
"use strict";

var $2bBga = parcelRequire("2bBga");

var $1TQad = parcelRequire("1TQad");

var $kTwUV = parcelRequire("kTwUV");

var $2RNjJ = parcelRequire("2RNjJ");

var $1ZTQa = parcelRequire("1ZTQa");

var $9cPEm = parcelRequire("9cPEm");

var $g3yOT = parcelRequire("g3yOT");

var $4bjXw = parcelRequire("4bjXw");
module.exports = function xhrAdapter(config) {
    return new Promise(function dispatchXhrRequest(resolve, reject) {
        var requestData = config.data;
        var requestHeaders = config.headers;
        var responseType = config.responseType;
        if ($2bBga.isFormData(requestData)) delete requestHeaders["Content-Type"]; // Let the browser set it
        var request = new XMLHttpRequest();
        // HTTP basic authentication
        if (config.auth) {
            var username = config.auth.username || "";
            var password = config.auth.password ? unescape(encodeURIComponent(config.auth.password)) : "";
            requestHeaders.Authorization = "Basic " + btoa(username + ":" + password);
        }
        var fullPath = $1ZTQa(config.baseURL, config.url);
        request.open(config.method.toUpperCase(), $2RNjJ(fullPath, config.params, config.paramsSerializer), true);
        // Set the request timeout in MS
        request.timeout = config.timeout;
        function onloadend() {
            if (!request) return;
            // Prepare the response
            var responseHeaders = "getAllResponseHeaders" in request ? $9cPEm(request.getAllResponseHeaders()) : null;
            var responseData = !responseType || responseType === "text" || responseType === "json" ? request.responseText : request.response;
            var response = {
                data: responseData,
                status: request.status,
                statusText: request.statusText,
                headers: responseHeaders,
                config: config,
                request: request
            };
            $1TQad(resolve, reject, response);
            // Clean up request
            request = null;
        }
        if ("onloadend" in request) // Use onloadend if available
        request.onloadend = onloadend;
        else // Listen for ready state to emulate onloadend
        request.onreadystatechange = function handleLoad() {
            if (!request || request.readyState !== 4) return;
            // The request errored out and we didn't get a response, this will be
            // handled by onerror instead
            // With one exception: request that using file: protocol, most browsers
            // will return status as 0 even though it's a successful request
            if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf("file:") === 0)) return;
            // readystate handler is calling before onerror or ontimeout handlers,
            // so we should call onloadend on the next 'tick'
            setTimeout(onloadend);
        };
        // Handle browser request cancellation (as opposed to a manual cancellation)
        request.onabort = function handleAbort() {
            if (!request) return;
            reject($4bjXw("Request aborted", config, "ECONNABORTED", request));
            // Clean up request
            request = null;
        };
        // Handle low level network errors
        request.onerror = function handleError() {
            // Real errors are hidden from us by the browser
            // onerror should only fire if it's a network error
            reject($4bjXw("Network Error", config, null, request));
            // Clean up request
            request = null;
        };
        // Handle timeout
        request.ontimeout = function handleTimeout() {
            var timeoutErrorMessage = "timeout of " + config.timeout + "ms exceeded";
            if (config.timeoutErrorMessage) timeoutErrorMessage = config.timeoutErrorMessage;
            reject($4bjXw(timeoutErrorMessage, config, config.transitional && config.transitional.clarifyTimeoutError ? "ETIMEDOUT" : "ECONNABORTED", request));
            // Clean up request
            request = null;
        };
        // Add xsrf header
        // This is only done if running in a standard browser environment.
        // Specifically not if we're in a web worker, or react-native.
        if ($2bBga.isStandardBrowserEnv()) {
            // Add xsrf header
            var xsrfValue = (config.withCredentials || $g3yOT(fullPath)) && config.xsrfCookieName ? $kTwUV.read(config.xsrfCookieName) : undefined;
            if (xsrfValue) requestHeaders[config.xsrfHeaderName] = xsrfValue;
        }
        // Add headers to the request
        if ("setRequestHeader" in request) $2bBga.forEach(requestHeaders, function setRequestHeader(val, key) {
            if (typeof requestData === "undefined" && key.toLowerCase() === "content-type") // Remove Content-Type if data is undefined
            delete requestHeaders[key];
            else // Otherwise add header to the request
            request.setRequestHeader(key, val);
        });
        // Add withCredentials to request if needed
        if (!$2bBga.isUndefined(config.withCredentials)) request.withCredentials = !!config.withCredentials;
        // Add responseType to request if needed
        if (responseType && responseType !== "json") request.responseType = config.responseType;
        // Handle progress if needed
        if (typeof config.onDownloadProgress === "function") request.addEventListener("progress", config.onDownloadProgress);
        // Not all browsers support upload events
        if (typeof config.onUploadProgress === "function" && request.upload) request.upload.addEventListener("progress", config.onUploadProgress);
        if (config.cancelToken) // Handle cancellation
        config.cancelToken.promise.then(function onCanceled(cancel) {
            if (!request) return;
            request.abort();
            reject(cancel);
            // Clean up request
            request = null;
        });
        if (!requestData) requestData = null;
        // Send the request
        request.send(requestData);
    });
};

});
parcelRequire.register("1TQad", function(module, exports) {
"use strict";

var $4bjXw = parcelRequire("4bjXw");
/**
 * Resolve or reject a Promise based on response status.
 *
 * @param {Function} resolve A function that resolves the promise.
 * @param {Function} reject A function that rejects the promise.
 * @param {object} response The response.
 */ module.exports = function settle(resolve, reject, response) {
    var validateStatus = response.config.validateStatus;
    if (!response.status || !validateStatus || validateStatus(response.status)) resolve(response);
    else reject($4bjXw("Request failed with status code " + response.status, response.config, null, response.request, response));
};

});
parcelRequire.register("4bjXw", function(module, exports) {
"use strict";

var $56XJZ = parcelRequire("56XJZ");
/**
 * Create an Error with the specified message, config, error code, request and response.
 *
 * @param {string} message The error message.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The created error.
 */ module.exports = function createError(message, config, code, request, response) {
    var error = new Error(message);
    return $56XJZ(error, config, code, request, response);
};

});


parcelRequire.register("kTwUV", function(module, exports) {
"use strict";

var $2bBga = parcelRequire("2bBga");
module.exports = $2bBga.isStandardBrowserEnv() ? // Standard browser envs support document.cookie
function standardBrowserEnv() {
    return {
        write: function write(name, value, expires, path, domain, secure) {
            var cookie = [];
            cookie.push(name + "=" + encodeURIComponent(value));
            if ($2bBga.isNumber(expires)) cookie.push("expires=" + new Date(expires).toGMTString());
            if ($2bBga.isString(path)) cookie.push("path=" + path);
            if ($2bBga.isString(domain)) cookie.push("domain=" + domain);
            if (secure === true) cookie.push("secure");
            document.cookie = cookie.join("; ");
        },
        read: function read(name) {
            var match = document.cookie.match(new RegExp("(^|;\\s*)(" + name + ")=([^;]*)"));
            return match ? decodeURIComponent(match[3]) : null;
        },
        remove: function remove(name) {
            this.write(name, "", Date.now() - 86400000);
        }
    };
}() : // Non standard browser env (web workers, react-native) lack needed support.
function nonStandardBrowserEnv() {
    return {
        write: function write() {},
        read: function read() {
            return null;
        },
        remove: function remove() {}
    };
}();

});

parcelRequire.register("1ZTQa", function(module, exports) {
"use strict";

var $iUwU6 = parcelRequire("iUwU6");

var $91vFE = parcelRequire("91vFE");
/**
 * Creates a new URL by combining the baseURL with the requestedURL,
 * only when the requestedURL is not already an absolute URL.
 * If the requestURL is absolute, this function returns the requestedURL untouched.
 *
 * @param {string} baseURL The base URL
 * @param {string} requestedURL Absolute or relative URL to combine
 * @returns {string} The combined full path
 */ module.exports = function buildFullPath(baseURL, requestedURL) {
    if (baseURL && !$iUwU6(requestedURL)) return $91vFE(baseURL, requestedURL);
    return requestedURL;
};

});
parcelRequire.register("iUwU6", function(module, exports) {
"use strict";
/**
 * Determines whether the specified URL is absolute
 *
 * @param {string} url The URL to test
 * @returns {boolean} True if the specified URL is absolute, otherwise false
 */ module.exports = function isAbsoluteURL(url) {
    // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
    // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
    // by any combination of letters, digits, plus, period, or hyphen.
    return /^([a-z][a-z\d\+\-\.]*:)?\/\//i.test(url);
};

});

parcelRequire.register("91vFE", function(module, exports) {
"use strict";
/**
 * Creates a new URL by combining the specified URLs
 *
 * @param {string} baseURL The base URL
 * @param {string} relativeURL The relative URL
 * @returns {string} The combined URL
 */ module.exports = function combineURLs(baseURL, relativeURL) {
    return relativeURL ? baseURL.replace(/\/+$/, "") + "/" + relativeURL.replace(/^\/+/, "") : baseURL;
};

});


parcelRequire.register("9cPEm", function(module, exports) {
"use strict";

var $2bBga = parcelRequire("2bBga");
// Headers whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
var $6b3d4ca234f68ddb$var$ignoreDuplicateOf = [
    "age",
    "authorization",
    "content-length",
    "content-type",
    "etag",
    "expires",
    "from",
    "host",
    "if-modified-since",
    "if-unmodified-since",
    "last-modified",
    "location",
    "max-forwards",
    "proxy-authorization",
    "referer",
    "retry-after",
    "user-agent"
];
/**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} headers Headers needing to be parsed
 * @returns {Object} Headers parsed into an object
 */ module.exports = function parseHeaders(headers) {
    var parsed = {};
    var key;
    var val;
    var i;
    if (!headers) return parsed;
    $2bBga.forEach(headers.split("\n"), function parser(line) {
        i = line.indexOf(":");
        key = $2bBga.trim(line.substr(0, i)).toLowerCase();
        val = $2bBga.trim(line.substr(i + 1));
        if (key) {
            if (parsed[key] && $6b3d4ca234f68ddb$var$ignoreDuplicateOf.indexOf(key) >= 0) return;
            if (key === "set-cookie") parsed[key] = (parsed[key] ? parsed[key] : []).concat([
                val
            ]);
            else parsed[key] = parsed[key] ? parsed[key] + ", " + val : val;
        }
    });
    return parsed;
};

});

parcelRequire.register("g3yOT", function(module, exports) {
"use strict";

var $2bBga = parcelRequire("2bBga");
module.exports = $2bBga.isStandardBrowserEnv() ? // Standard browser envs have full support of the APIs needed to test
// whether the request URL is of the same origin as current location.
function standardBrowserEnv() {
    var msie = /(msie|trident)/i.test(navigator.userAgent);
    var urlParsingNode = document.createElement("a");
    var originURL;
    /**
    * Parse a URL to discover it's components
    *
    * @param {String} url The URL to be parsed
    * @returns {Object}
    */ function resolveURL(url) {
        var href = url;
        if (msie) {
            // IE needs attribute set twice to normalize properties
            urlParsingNode.setAttribute("href", href);
            href = urlParsingNode.href;
        }
        urlParsingNode.setAttribute("href", href);
        // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
        return {
            href: urlParsingNode.href,
            protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, "") : "",
            host: urlParsingNode.host,
            search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, "") : "",
            hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, "") : "",
            hostname: urlParsingNode.hostname,
            port: urlParsingNode.port,
            pathname: urlParsingNode.pathname.charAt(0) === "/" ? urlParsingNode.pathname : "/" + urlParsingNode.pathname
        };
    }
    originURL = resolveURL(window.location.href);
    /**
    * Determine if a URL shares the same origin as the current location
    *
    * @param {String} requestURL The URL to test
    * @returns {boolean} True if URL shares the same origin, otherwise false
    */ return function isURLSameOrigin(requestURL) {
        var parsed = $2bBga.isString(requestURL) ? resolveURL(requestURL) : requestURL;
        return parsed.protocol === originURL.protocol && parsed.host === originURL.host;
    };
}() : // Non standard browser envs (web workers, react-native) lack needed support.
function nonStandardBrowserEnv() {
    return function isURLSameOrigin() {
        return true;
    };
}();

});




parcelRequire.register("ksuZT", function(module, exports) {
"use strict";
module.exports = function isCancel(value) {
    return !!(value && value.__CANCEL__);
};

});


parcelRequire.register("d0EKm", function(module, exports) {
"use strict";

var $2bBga = parcelRequire("2bBga");
/**
 * Config-specific merge-function which creates a new config-object
 * by merging two configuration objects together.
 *
 * @param {Object} config1
 * @param {Object} config2
 * @returns {Object} New object resulting from merging config2 to config1
 */ module.exports = function mergeConfig(config1, config2) {
    // eslint-disable-next-line no-param-reassign
    config2 = config2 || {};
    var config = {};
    var valueFromConfig2Keys = [
        "url",
        "method",
        "data"
    ];
    var mergeDeepPropertiesKeys = [
        "headers",
        "auth",
        "proxy",
        "params"
    ];
    var defaultToConfig2Keys = [
        "baseURL",
        "transformRequest",
        "transformResponse",
        "paramsSerializer",
        "timeout",
        "timeoutMessage",
        "withCredentials",
        "adapter",
        "responseType",
        "xsrfCookieName",
        "xsrfHeaderName",
        "onUploadProgress",
        "onDownloadProgress",
        "decompress",
        "maxContentLength",
        "maxBodyLength",
        "maxRedirects",
        "transport",
        "httpAgent",
        "httpsAgent",
        "cancelToken",
        "socketPath",
        "responseEncoding"
    ];
    var directMergeKeys = [
        "validateStatus"
    ];
    function getMergedValue(target, source) {
        if ($2bBga.isPlainObject(target) && $2bBga.isPlainObject(source)) return $2bBga.merge(target, source);
        else if ($2bBga.isPlainObject(source)) return $2bBga.merge({}, source);
        else if ($2bBga.isArray(source)) return source.slice();
        return source;
    }
    function mergeDeepProperties(prop) {
        if (!$2bBga.isUndefined(config2[prop])) config[prop] = getMergedValue(config1[prop], config2[prop]);
        else if (!$2bBga.isUndefined(config1[prop])) config[prop] = getMergedValue(undefined, config1[prop]);
    }
    $2bBga.forEach(valueFromConfig2Keys, function valueFromConfig2(prop) {
        if (!$2bBga.isUndefined(config2[prop])) config[prop] = getMergedValue(undefined, config2[prop]);
    });
    $2bBga.forEach(mergeDeepPropertiesKeys, mergeDeepProperties);
    $2bBga.forEach(defaultToConfig2Keys, function defaultToConfig2(prop) {
        if (!$2bBga.isUndefined(config2[prop])) config[prop] = getMergedValue(undefined, config2[prop]);
        else if (!$2bBga.isUndefined(config1[prop])) config[prop] = getMergedValue(undefined, config1[prop]);
    });
    $2bBga.forEach(directMergeKeys, function merge(prop) {
        if (prop in config2) config[prop] = getMergedValue(config1[prop], config2[prop]);
        else if (prop in config1) config[prop] = getMergedValue(undefined, config1[prop]);
    });
    var axiosKeys = valueFromConfig2Keys.concat(mergeDeepPropertiesKeys).concat(defaultToConfig2Keys).concat(directMergeKeys);
    var otherKeys = Object.keys(config1).concat(Object.keys(config2)).filter(function filterAxiosKeys(key) {
        return axiosKeys.indexOf(key) === -1;
    });
    $2bBga.forEach(otherKeys, mergeDeepProperties);
    return config;
};

});

parcelRequire.register("6zj0X", function(module, exports) {
"use strict";

var $8wpMv = parcelRequire("8wpMv");
var $4c84c2d525dc977b$var$validators = {};
// eslint-disable-next-line func-names
[
    "object",
    "boolean",
    "number",
    "function",
    "string",
    "symbol"
].forEach(function(type, i) {
    $4c84c2d525dc977b$var$validators[type] = function validator(thing) {
        return typeof thing === type || "a" + (i < 1 ? "n " : " ") + type;
    };
});
var $4c84c2d525dc977b$var$deprecatedWarnings = {};
var $4c84c2d525dc977b$var$currentVerArr = $8wpMv.version.split(".");
/**
 * Compare package versions
 * @param {string} version
 * @param {string?} thanVersion
 * @returns {boolean}
 */ function $4c84c2d525dc977b$var$isOlderVersion(version, thanVersion) {
    var pkgVersionArr = thanVersion ? thanVersion.split(".") : $4c84c2d525dc977b$var$currentVerArr;
    var destVer = version.split(".");
    for(var i = 0; i < 3; i++){
        if (pkgVersionArr[i] > destVer[i]) return true;
        else if (pkgVersionArr[i] < destVer[i]) return false;
    }
    return false;
}
/**
 * Transitional option validator
 * @param {function|boolean?} validator
 * @param {string?} version
 * @param {string} message
 * @returns {function}
 */ $4c84c2d525dc977b$var$validators.transitional = function transitional(validator, version, message) {
    var isDeprecated = version && $4c84c2d525dc977b$var$isOlderVersion(version);
    function formatMessage(opt, desc) {
        return "[Axios v" + $8wpMv.version + "] Transitional option '" + opt + "'" + desc + (message ? ". " + message : "");
    }
    // eslint-disable-next-line func-names
    return function(value, opt, opts) {
        if (validator === false) throw new Error(formatMessage(opt, " has been removed in " + version));
        if (isDeprecated && !$4c84c2d525dc977b$var$deprecatedWarnings[opt]) {
            $4c84c2d525dc977b$var$deprecatedWarnings[opt] = true;
            // eslint-disable-next-line no-console
            console.warn(formatMessage(opt, " has been deprecated since v" + version + " and will be removed in the near future"));
        }
        return validator ? validator(value, opt, opts) : true;
    };
};
/**
 * Assert object's properties type
 * @param {object} options
 * @param {object} schema
 * @param {boolean?} allowUnknown
 */ function $4c84c2d525dc977b$var$assertOptions(options, schema, allowUnknown) {
    if (typeof options !== "object") throw new TypeError("options must be an object");
    var keys = Object.keys(options);
    var i = keys.length;
    while(i-- > 0){
        var opt = keys[i];
        var validator = schema[opt];
        if (validator) {
            var value = options[opt];
            var result = value === undefined || validator(value, opt, options);
            if (result !== true) throw new TypeError("option " + opt + " must be " + result);
            continue;
        }
        if (allowUnknown !== true) throw Error("Unknown option " + opt);
    }
}
module.exports = {
    isOlderVersion: $4c84c2d525dc977b$var$isOlderVersion,
    assertOptions: $4c84c2d525dc977b$var$assertOptions,
    validators: $4c84c2d525dc977b$var$validators
};

});
parcelRequire.register("8wpMv", function(module, exports) {
module.exports = JSON.parse('{"name":"axios","version":"0.21.4","description":"Promise based HTTP client for the browser and node.js","main":"index.js","scripts":{"test":"grunt test","start":"node ./sandbox/server.js","build":"NODE_ENV=production grunt build","preversion":"npm test","version":"npm run build && grunt version && git add -A dist && git add CHANGELOG.md bower.json package.json","postversion":"git push && git push --tags","examples":"node ./examples/server.js","coveralls":"cat coverage/lcov.info | ./node_modules/coveralls/bin/coveralls.js","fix":"eslint --fix lib/**/*.js"},"repository":{"type":"git","url":"https://github.com/axios/axios.git"},"keywords":["xhr","http","ajax","promise","node"],"author":"Matt Zabriskie","license":"MIT","bugs":{"url":"https://github.com/axios/axios/issues"},"homepage":"https://axios-http.com","devDependencies":{"coveralls":"^3.0.0","es6-promise":"^4.2.4","grunt":"^1.3.0","grunt-banner":"^0.6.0","grunt-cli":"^1.2.0","grunt-contrib-clean":"^1.1.0","grunt-contrib-watch":"^1.0.0","grunt-eslint":"^23.0.0","grunt-karma":"^4.0.0","grunt-mocha-test":"^0.13.3","grunt-ts":"^6.0.0-beta.19","grunt-webpack":"^4.0.2","istanbul-instrumenter-loader":"^1.0.0","jasmine-core":"^2.4.1","karma":"^6.3.2","karma-chrome-launcher":"^3.1.0","karma-firefox-launcher":"^2.1.0","karma-jasmine":"^1.1.1","karma-jasmine-ajax":"^0.1.13","karma-safari-launcher":"^1.0.0","karma-sauce-launcher":"^4.3.6","karma-sinon":"^1.0.5","karma-sourcemap-loader":"^0.3.8","karma-webpack":"^4.0.2","load-grunt-tasks":"^3.5.2","minimist":"^1.2.0","mocha":"^8.2.1","sinon":"^4.5.0","terser-webpack-plugin":"^4.2.3","typescript":"^4.0.5","url-search-params":"^0.10.0","webpack":"^4.44.2","webpack-dev-server":"^3.11.0"},"browser":{"./lib/adapters/http.js":"./lib/adapters/xhr.js"},"jsdelivr":"dist/axios.min.js","unpkg":"dist/axios.min.js","typings":"./index.d.ts","dependencies":{"follow-redirects":"^1.14.0"},"bundlesize":[{"path":"./dist/axios.min.js","threshold":"5kB"}]}');

});



parcelRequire.register("guIkb", function(module, exports) {
"use strict";
/**
 * A `Cancel` is an object that is thrown when an operation is canceled.
 *
 * @class
 * @param {string=} message The message.
 */ function $c021d497680ea7c0$var$Cancel(message) {
    this.message = message;
}
$c021d497680ea7c0$var$Cancel.prototype.toString = function toString() {
    return "Cancel" + (this.message ? ": " + this.message : "");
};
$c021d497680ea7c0$var$Cancel.prototype.__CANCEL__ = true;
module.exports = $c021d497680ea7c0$var$Cancel;

});

parcelRequire.register("2sjhC", function(module, exports) {
"use strict";

var $guIkb = parcelRequire("guIkb");
/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @class
 * @param {Function} executor The executor function.
 */ function $1c9d2783569136b3$var$CancelToken(executor) {
    if (typeof executor !== "function") throw new TypeError("executor must be a function.");
    var resolvePromise;
    this.promise = new Promise(function promiseExecutor(resolve) {
        resolvePromise = resolve;
    });
    var token = this;
    executor(function cancel(message) {
        if (token.reason) // Cancellation has already been requested
        return;
        token.reason = new $guIkb(message);
        resolvePromise(token.reason);
    });
}
/**
 * Throws a `Cancel` if cancellation has been requested.
 */ $1c9d2783569136b3$var$CancelToken.prototype.throwIfRequested = function throwIfRequested() {
    if (this.reason) throw this.reason;
};
/**
 * Returns an object that contains a new `CancelToken` and a function that, when called,
 * cancels the `CancelToken`.
 */ $1c9d2783569136b3$var$CancelToken.source = function source() {
    var cancel;
    var token = new $1c9d2783569136b3$var$CancelToken(function executor(c) {
        cancel = c;
    });
    return {
        token: token,
        cancel: cancel
    };
};
module.exports = $1c9d2783569136b3$var$CancelToken;

});

parcelRequire.register("av9gA", function(module, exports) {
"use strict";
/**
 * Syntactic sugar for invoking a function and expanding an array for arguments.
 *
 * Common use case would be to use `Function.prototype.apply`.
 *
 *  ```js
 *  function f(x, y, z) {}
 *  var args = [1, 2, 3];
 *  f.apply(null, args);
 *  ```
 *
 * With `spread` this example can be re-written.
 *
 *  ```js
 *  spread(function(x, y, z) {})([1, 2, 3]);
 *  ```
 *
 * @param {Function} callback
 * @returns {Function}
 */ module.exports = function spread(callback) {
    return function wrap(arr) {
        return callback.apply(null, arr);
    };
};

});

parcelRequire.register("gNhGc", function(module, exports) {
"use strict";
/**
 * Determines whether the payload is an error thrown by Axios
 *
 * @param {*} payload The value to test
 * @returns {boolean} True if the payload is an error thrown by Axios, otherwise false
 */ module.exports = function isAxiosError(payload) {
    return typeof payload === "object" && payload.isAxiosError === true;
};

});



parcelRequire.register("iLExI", function(module, exports) {
"use strict";
// do not edit .js files directly - edit src/index.jst
module.exports = function equal(a, b) {
    if (a === b) return true;
    if (a && b && typeof a == "object" && typeof b == "object") {
        if (a.constructor !== b.constructor) return false;
        var length, i, keys;
        if (Array.isArray(a)) {
            length = a.length;
            if (length != b.length) return false;
            for(i = length; i-- !== 0;)if (!equal(a[i], b[i])) return false;
            return true;
        }
        if (a.constructor === RegExp) return a.source === b.source && a.flags === b.flags;
        if (a.valueOf !== Object.prototype.valueOf) return a.valueOf() === b.valueOf();
        if (a.toString !== Object.prototype.toString) return a.toString() === b.toString();
        keys = Object.keys(a);
        length = keys.length;
        if (length !== Object.keys(b).length) return false;
        for(i = length; i-- !== 0;)if (!Object.prototype.hasOwnProperty.call(b, keys[i])) return false;
        for(i = length; i-- !== 0;){
            var key = keys[i];
            if (!equal(a[key], b[key])) return false;
        }
        return true;
    }
    // true if both NaN, false otherwise
    return a !== a && b !== b;
};

});

parcelRequire.register("lTJZ9", function(module, exports) {

(function(module1, exports) {
    "use strict";
    // Utils
    function assert(val, msg) {
        if (!val) throw new Error(msg || "Assertion failed");
    }
    // Could use `inherits` module, but don't want to move from single file
    // architecture yet.
    function inherits(ctor, superCtor) {
        ctor.super_ = superCtor;
        var TempCtor = function() {};
        TempCtor.prototype = superCtor.prototype;
        ctor.prototype = new TempCtor();
        ctor.prototype.constructor = ctor;
    }
    // BN
    function BN(number, base, endian) {
        if (BN.isBN(number)) return number;
        this.negative = 0;
        this.words = null;
        this.length = 0;
        // Reduction context
        this.red = null;
        if (number !== null) {
            if (base === "le" || base === "be") {
                endian = base;
                base = 10;
            }
            this._init(number || 0, base || 10, endian || "be");
        }
    }
    if (typeof module1 === "object") module1.exports = BN;
    else exports.BN = BN;
    BN.BN = BN;
    BN.wordSize = 26;
    var Buffer;
    try {
        if (typeof window !== "undefined" && typeof window.Buffer !== "undefined") Buffer = window.Buffer;
        else Buffer = (parcelRequire("5Io6y")).Buffer;
    } catch (e) {}
    BN.isBN = function isBN(num) {
        if (num instanceof BN) return true;
        return num !== null && typeof num === "object" && num.constructor.wordSize === BN.wordSize && Array.isArray(num.words);
    };
    BN.max = function max(left, right) {
        if (left.cmp(right) > 0) return left;
        return right;
    };
    BN.min = function min(left, right) {
        if (left.cmp(right) < 0) return left;
        return right;
    };
    BN.prototype._init = function init(number, base, endian) {
        if (typeof number === "number") return this._initNumber(number, base, endian);
        if (typeof number === "object") return this._initArray(number, base, endian);
        if (base === "hex") base = 16;
        assert(base === (base | 0) && base >= 2 && base <= 36);
        number = number.toString().replace(/\s+/g, "");
        var start = 0;
        if (number[0] === "-") {
            start++;
            this.negative = 1;
        }
        if (start < number.length) {
            if (base === 16) this._parseHex(number, start, endian);
            else {
                this._parseBase(number, base, start);
                if (endian === "le") this._initArray(this.toArray(), base, endian);
            }
        }
    };
    BN.prototype._initNumber = function _initNumber(number, base, endian) {
        if (number < 0) {
            this.negative = 1;
            number = -number;
        }
        if (number < 0x4000000) {
            this.words = [
                number & 0x3ffffff
            ];
            this.length = 1;
        } else if (number < 0x10000000000000) {
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff
            ];
            this.length = 2;
        } else {
            assert(number < 0x20000000000000); // 2 ^ 53 (unsafe)
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff,
                1
            ];
            this.length = 3;
        }
        if (endian !== "le") return;
        // Reverse the bytes
        this._initArray(this.toArray(), base, endian);
    };
    BN.prototype._initArray = function _initArray(number, base, endian) {
        // Perhaps a Uint8Array
        assert(typeof number.length === "number");
        if (number.length <= 0) {
            this.words = [
                0
            ];
            this.length = 1;
            return this;
        }
        this.length = Math.ceil(number.length / 3);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        var j, w;
        var off = 0;
        if (endian === "be") for(i = number.length - 1, j = 0; i >= 0; i -= 3){
            w = number[i] | number[i - 1] << 8 | number[i - 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        else if (endian === "le") for(i = 0, j = 0; i < number.length; i += 3){
            w = number[i] | number[i + 1] << 8 | number[i + 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        return this._strip();
    };
    function parseHex4Bits(string, index) {
        var c = string.charCodeAt(index);
        // '0' - '9'
        if (c >= 48 && c <= 57) return c - 48;
        else if (c >= 65 && c <= 70) return c - 55;
        else if (c >= 97 && c <= 102) return c - 87;
        else assert(false, "Invalid character in " + string);
    }
    function parseHexByte(string, lowerBound, index) {
        var r = parseHex4Bits(string, index);
        if (index - 1 >= lowerBound) r |= parseHex4Bits(string, index - 1) << 4;
        return r;
    }
    BN.prototype._parseHex = function _parseHex(number, start, endian) {
        // Create possibly bigger array to ensure that it fits the number
        this.length = Math.ceil((number.length - start) / 6);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        // 24-bits chunks
        var off = 0;
        var j = 0;
        var w;
        if (endian === "be") for(i = number.length - 1; i >= start; i -= 2){
            w = parseHexByte(number, start, i) << off;
            this.words[j] |= w & 0x3ffffff;
            if (off >= 18) {
                off -= 18;
                j += 1;
                this.words[j] |= w >>> 26;
            } else off += 8;
        }
        else {
            var parseLength = number.length - start;
            for(i = parseLength % 2 === 0 ? start + 1 : start; i < number.length; i += 2){
                w = parseHexByte(number, start, i) << off;
                this.words[j] |= w & 0x3ffffff;
                if (off >= 18) {
                    off -= 18;
                    j += 1;
                    this.words[j] |= w >>> 26;
                } else off += 8;
            }
        }
        this._strip();
    };
    function parseBase(str, start, end, mul) {
        var r = 0;
        var b = 0;
        var len = Math.min(str.length, end);
        for(var i = start; i < len; i++){
            var c = str.charCodeAt(i) - 48;
            r *= mul;
            // 'a'
            if (c >= 49) b = c - 49 + 0xa;
            else if (c >= 17) b = c - 17 + 0xa;
            else b = c;
            assert(c >= 0 && b < mul, "Invalid character");
            r += b;
        }
        return r;
    }
    BN.prototype._parseBase = function _parseBase(number, base, start) {
        // Initialize as zero
        this.words = [
            0
        ];
        this.length = 1;
        // Find length of limb in base
        for(var limbLen = 0, limbPow = 1; limbPow <= 0x3ffffff; limbPow *= base)limbLen++;
        limbLen--;
        limbPow = limbPow / base | 0;
        var total = number.length - start;
        var mod = total % limbLen;
        var end = Math.min(total, total - mod) + start;
        var word = 0;
        for(var i = start; i < end; i += limbLen){
            word = parseBase(number, i, i + limbLen, base);
            this.imuln(limbPow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        if (mod !== 0) {
            var pow = 1;
            word = parseBase(number, i, number.length, base);
            for(i = 0; i < mod; i++)pow *= base;
            this.imuln(pow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        this._strip();
    };
    BN.prototype.copy = function copy(dest) {
        dest.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)dest.words[i] = this.words[i];
        dest.length = this.length;
        dest.negative = this.negative;
        dest.red = this.red;
    };
    function move(dest, src) {
        dest.words = src.words;
        dest.length = src.length;
        dest.negative = src.negative;
        dest.red = src.red;
    }
    BN.prototype._move = function _move(dest) {
        move(dest, this);
    };
    BN.prototype.clone = function clone() {
        var r = new BN(null);
        this.copy(r);
        return r;
    };
    BN.prototype._expand = function _expand(size) {
        while(this.length < size)this.words[this.length++] = 0;
        return this;
    };
    // Remove leading `0` from `this`
    BN.prototype._strip = function strip() {
        while(this.length > 1 && this.words[this.length - 1] === 0)this.length--;
        return this._normSign();
    };
    BN.prototype._normSign = function _normSign() {
        // -0 = 0
        if (this.length === 1 && this.words[0] === 0) this.negative = 0;
        return this;
    };
    // Check Symbol.for because not everywhere where Symbol defined
    // See https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Symbol#Browser_compatibility
    if (typeof Symbol !== "undefined" && typeof Symbol.for === "function") try {
        BN.prototype[Symbol.for("nodejs.util.inspect.custom")] = inspect;
    } catch (e) {
        BN.prototype.inspect = inspect;
    }
    else BN.prototype.inspect = inspect;
    function inspect() {
        return (this.red ? "<BN-R: " : "<BN: ") + this.toString(16) + ">";
    }
    /*

  var zeros = [];
  var groupSizes = [];
  var groupBases = [];

  var s = '';
  var i = -1;
  while (++i < BN.wordSize) {
    zeros[i] = s;
    s += '0';
  }
  groupSizes[0] = 0;
  groupSizes[1] = 0;
  groupBases[0] = 0;
  groupBases[1] = 0;
  var base = 2 - 1;
  while (++base < 36 + 1) {
    var groupSize = 0;
    var groupBase = 1;
    while (groupBase < (1 << BN.wordSize) / base) {
      groupBase *= base;
      groupSize += 1;
    }
    groupSizes[base] = groupSize;
    groupBases[base] = groupBase;
  }

  */ var zeros = [
        "",
        "0",
        "00",
        "000",
        "0000",
        "00000",
        "000000",
        "0000000",
        "00000000",
        "000000000",
        "0000000000",
        "00000000000",
        "000000000000",
        "0000000000000",
        "00000000000000",
        "000000000000000",
        "0000000000000000",
        "00000000000000000",
        "000000000000000000",
        "0000000000000000000",
        "00000000000000000000",
        "000000000000000000000",
        "0000000000000000000000",
        "00000000000000000000000",
        "000000000000000000000000",
        "0000000000000000000000000"
    ];
    var groupSizes = [
        0,
        0,
        25,
        16,
        12,
        11,
        10,
        9,
        8,
        8,
        7,
        7,
        7,
        7,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5
    ];
    var groupBases = [
        0,
        0,
        33554432,
        43046721,
        16777216,
        48828125,
        60466176,
        40353607,
        16777216,
        43046721,
        10000000,
        19487171,
        35831808,
        62748517,
        7529536,
        11390625,
        16777216,
        24137569,
        34012224,
        47045881,
        64000000,
        4084101,
        5153632,
        6436343,
        7962624,
        9765625,
        11881376,
        14348907,
        17210368,
        20511149,
        24300000,
        28629151,
        33554432,
        39135393,
        45435424,
        52521875,
        60466176
    ];
    BN.prototype.toString = function toString(base, padding) {
        base = base || 10;
        padding = padding | 0 || 1;
        var out;
        if (base === 16 || base === "hex") {
            out = "";
            var off = 0;
            var carry = 0;
            for(var i = 0; i < this.length; i++){
                var w = this.words[i];
                var word = ((w << off | carry) & 0xffffff).toString(16);
                carry = w >>> 24 - off & 0xffffff;
                off += 2;
                if (off >= 26) {
                    off -= 26;
                    i--;
                }
                if (carry !== 0 || i !== this.length - 1) out = zeros[6 - word.length] + word + out;
                else out = word + out;
            }
            if (carry !== 0) out = carry.toString(16) + out;
            while(out.length % padding !== 0)out = "0" + out;
            if (this.negative !== 0) out = "-" + out;
            return out;
        }
        if (base === (base | 0) && base >= 2 && base <= 36) {
            // var groupSize = Math.floor(BN.wordSize * Math.LN2 / Math.log(base));
            var groupSize = groupSizes[base];
            // var groupBase = Math.pow(base, groupSize);
            var groupBase = groupBases[base];
            out = "";
            var c = this.clone();
            c.negative = 0;
            while(!c.isZero()){
                var r = c.modrn(groupBase).toString(base);
                c = c.idivn(groupBase);
                if (!c.isZero()) out = zeros[groupSize - r.length] + r + out;
                else out = r + out;
            }
            if (this.isZero()) out = "0" + out;
            while(out.length % padding !== 0)out = "0" + out;
            if (this.negative !== 0) out = "-" + out;
            return out;
        }
        assert(false, "Base should be between 2 and 36");
    };
    BN.prototype.toNumber = function toNumber() {
        var ret = this.words[0];
        if (this.length === 2) ret += this.words[1] * 0x4000000;
        else if (this.length === 3 && this.words[2] === 0x01) // NOTE: at this stage it is known that the top bit is set
        ret += 0x10000000000000 + this.words[1] * 0x4000000;
        else if (this.length > 2) assert(false, "Number can only safely store up to 53 bits");
        return this.negative !== 0 ? -ret : ret;
    };
    BN.prototype.toJSON = function toJSON() {
        return this.toString(16, 2);
    };
    if (Buffer) BN.prototype.toBuffer = function toBuffer(endian, length) {
        return this.toArrayLike(Buffer, endian, length);
    };
    BN.prototype.toArray = function toArray(endian, length) {
        return this.toArrayLike(Array, endian, length);
    };
    var allocate = function allocate(ArrayType, size) {
        if (ArrayType.allocUnsafe) return ArrayType.allocUnsafe(size);
        return new ArrayType(size);
    };
    BN.prototype.toArrayLike = function toArrayLike(ArrayType, endian, length) {
        this._strip();
        var byteLength = this.byteLength();
        var reqLength = length || Math.max(1, byteLength);
        assert(byteLength <= reqLength, "byte array longer than desired length");
        assert(reqLength > 0, "Requested array length <= 0");
        var res = allocate(ArrayType, reqLength);
        var postfix = endian === "le" ? "LE" : "BE";
        this["_toArrayLike" + postfix](res, byteLength);
        return res;
    };
    BN.prototype._toArrayLikeLE = function _toArrayLikeLE(res, byteLength) {
        var position = 0;
        var carry = 0;
        for(var i = 0, shift = 0; i < this.length; i++){
            var word = this.words[i] << shift | carry;
            res[position++] = word & 0xff;
            if (position < res.length) res[position++] = word >> 8 & 0xff;
            if (position < res.length) res[position++] = word >> 16 & 0xff;
            if (shift === 6) {
                if (position < res.length) res[position++] = word >> 24 & 0xff;
                carry = 0;
                shift = 0;
            } else {
                carry = word >>> 24;
                shift += 2;
            }
        }
        if (position < res.length) {
            res[position++] = carry;
            while(position < res.length)res[position++] = 0;
        }
    };
    BN.prototype._toArrayLikeBE = function _toArrayLikeBE(res, byteLength) {
        var position = res.length - 1;
        var carry = 0;
        for(var i = 0, shift = 0; i < this.length; i++){
            var word = this.words[i] << shift | carry;
            res[position--] = word & 0xff;
            if (position >= 0) res[position--] = word >> 8 & 0xff;
            if (position >= 0) res[position--] = word >> 16 & 0xff;
            if (shift === 6) {
                if (position >= 0) res[position--] = word >> 24 & 0xff;
                carry = 0;
                shift = 0;
            } else {
                carry = word >>> 24;
                shift += 2;
            }
        }
        if (position >= 0) {
            res[position--] = carry;
            while(position >= 0)res[position--] = 0;
        }
    };
    if (Math.clz32) BN.prototype._countBits = function _countBits(w) {
        return 32 - Math.clz32(w);
    };
    else BN.prototype._countBits = function _countBits(w) {
        var t = w;
        var r = 0;
        if (t >= 0x1000) {
            r += 13;
            t >>>= 13;
        }
        if (t >= 0x40) {
            r += 7;
            t >>>= 7;
        }
        if (t >= 0x8) {
            r += 4;
            t >>>= 4;
        }
        if (t >= 0x02) {
            r += 2;
            t >>>= 2;
        }
        return r + t;
    };
    BN.prototype._zeroBits = function _zeroBits(w) {
        // Short-cut
        if (w === 0) return 26;
        var t = w;
        var r = 0;
        if ((t & 0x1fff) === 0) {
            r += 13;
            t >>>= 13;
        }
        if ((t & 0x7f) === 0) {
            r += 7;
            t >>>= 7;
        }
        if ((t & 0xf) === 0) {
            r += 4;
            t >>>= 4;
        }
        if ((t & 0x3) === 0) {
            r += 2;
            t >>>= 2;
        }
        if ((t & 0x1) === 0) r++;
        return r;
    };
    // Return number of used bits in a BN
    BN.prototype.bitLength = function bitLength() {
        var w = this.words[this.length - 1];
        var hi = this._countBits(w);
        return (this.length - 1) * 26 + hi;
    };
    function toBitArray(num) {
        var w = new Array(num.bitLength());
        for(var bit = 0; bit < w.length; bit++){
            var off = bit / 26 | 0;
            var wbit = bit % 26;
            w[bit] = num.words[off] >>> wbit & 0x01;
        }
        return w;
    }
    // Number of trailing zero bits
    BN.prototype.zeroBits = function zeroBits() {
        if (this.isZero()) return 0;
        var r = 0;
        for(var i = 0; i < this.length; i++){
            var b = this._zeroBits(this.words[i]);
            r += b;
            if (b !== 26) break;
        }
        return r;
    };
    BN.prototype.byteLength = function byteLength() {
        return Math.ceil(this.bitLength() / 8);
    };
    BN.prototype.toTwos = function toTwos(width) {
        if (this.negative !== 0) return this.abs().inotn(width).iaddn(1);
        return this.clone();
    };
    BN.prototype.fromTwos = function fromTwos(width) {
        if (this.testn(width - 1)) return this.notn(width).iaddn(1).ineg();
        return this.clone();
    };
    BN.prototype.isNeg = function isNeg() {
        return this.negative !== 0;
    };
    // Return negative clone of `this`
    BN.prototype.neg = function neg() {
        return this.clone().ineg();
    };
    BN.prototype.ineg = function ineg() {
        if (!this.isZero()) this.negative ^= 1;
        return this;
    };
    // Or `num` with `this` in-place
    BN.prototype.iuor = function iuor(num) {
        while(this.length < num.length)this.words[this.length++] = 0;
        for(var i = 0; i < num.length; i++)this.words[i] = this.words[i] | num.words[i];
        return this._strip();
    };
    BN.prototype.ior = function ior(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuor(num);
    };
    // Or `num` with `this`
    BN.prototype.or = function or(num) {
        if (this.length > num.length) return this.clone().ior(num);
        return num.clone().ior(this);
    };
    BN.prototype.uor = function uor(num) {
        if (this.length > num.length) return this.clone().iuor(num);
        return num.clone().iuor(this);
    };
    // And `num` with `this` in-place
    BN.prototype.iuand = function iuand(num) {
        // b = min-length(num, this)
        var b;
        if (this.length > num.length) b = num;
        else b = this;
        for(var i = 0; i < b.length; i++)this.words[i] = this.words[i] & num.words[i];
        this.length = b.length;
        return this._strip();
    };
    BN.prototype.iand = function iand(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuand(num);
    };
    // And `num` with `this`
    BN.prototype.and = function and(num) {
        if (this.length > num.length) return this.clone().iand(num);
        return num.clone().iand(this);
    };
    BN.prototype.uand = function uand(num) {
        if (this.length > num.length) return this.clone().iuand(num);
        return num.clone().iuand(this);
    };
    // Xor `num` with `this` in-place
    BN.prototype.iuxor = function iuxor(num) {
        // a.length > b.length
        var a;
        var b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        for(var i = 0; i < b.length; i++)this.words[i] = a.words[i] ^ b.words[i];
        if (this !== a) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = a.length;
        return this._strip();
    };
    BN.prototype.ixor = function ixor(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuxor(num);
    };
    // Xor `num` with `this`
    BN.prototype.xor = function xor(num) {
        if (this.length > num.length) return this.clone().ixor(num);
        return num.clone().ixor(this);
    };
    BN.prototype.uxor = function uxor(num) {
        if (this.length > num.length) return this.clone().iuxor(num);
        return num.clone().iuxor(this);
    };
    // Not ``this`` with ``width`` bitwidth
    BN.prototype.inotn = function inotn(width) {
        assert(typeof width === "number" && width >= 0);
        var bytesNeeded = Math.ceil(width / 26) | 0;
        var bitsLeft = width % 26;
        // Extend the buffer with leading zeroes
        this._expand(bytesNeeded);
        if (bitsLeft > 0) bytesNeeded--;
        // Handle complete words
        for(var i = 0; i < bytesNeeded; i++)this.words[i] = ~this.words[i] & 0x3ffffff;
        // Handle the residue
        if (bitsLeft > 0) this.words[i] = ~this.words[i] & 0x3ffffff >> 26 - bitsLeft;
        // And remove leading zeroes
        return this._strip();
    };
    BN.prototype.notn = function notn(width) {
        return this.clone().inotn(width);
    };
    // Set `bit` of `this`
    BN.prototype.setn = function setn(bit, val) {
        assert(typeof bit === "number" && bit >= 0);
        var off = bit / 26 | 0;
        var wbit = bit % 26;
        this._expand(off + 1);
        if (val) this.words[off] = this.words[off] | 1 << wbit;
        else this.words[off] = this.words[off] & ~(1 << wbit);
        return this._strip();
    };
    // Add `num` to `this` in-place
    BN.prototype.iadd = function iadd(num) {
        var r;
        // negative + positive
        if (this.negative !== 0 && num.negative === 0) {
            this.negative = 0;
            r = this.isub(num);
            this.negative ^= 1;
            return this._normSign();
        // positive + negative
        } else if (this.negative === 0 && num.negative !== 0) {
            num.negative = 0;
            r = this.isub(num);
            num.negative = 1;
            return r._normSign();
        }
        // a.length > b.length
        var a, b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) + (b.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        this.length = a.length;
        if (carry !== 0) {
            this.words[this.length] = carry;
            this.length++;
        // Copy the rest of the words
        } else if (a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        return this;
    };
    // Add `num` to `this`
    BN.prototype.add = function add(num) {
        var res;
        if (num.negative !== 0 && this.negative === 0) {
            num.negative = 0;
            res = this.sub(num);
            num.negative ^= 1;
            return res;
        } else if (num.negative === 0 && this.negative !== 0) {
            this.negative = 0;
            res = num.sub(this);
            this.negative = 1;
            return res;
        }
        if (this.length > num.length) return this.clone().iadd(num);
        return num.clone().iadd(this);
    };
    // Subtract `num` from `this` in-place
    BN.prototype.isub = function isub(num) {
        // this - (-num) = this + num
        if (num.negative !== 0) {
            num.negative = 0;
            var r = this.iadd(num);
            num.negative = 1;
            return r._normSign();
        // -this - num = -(this + num)
        } else if (this.negative !== 0) {
            this.negative = 0;
            this.iadd(num);
            this.negative = 1;
            return this._normSign();
        }
        // At this point both numbers are positive
        var cmp = this.cmp(num);
        // Optimization - zeroify
        if (cmp === 0) {
            this.negative = 0;
            this.length = 1;
            this.words[0] = 0;
            return this;
        }
        // a > b
        var a, b;
        if (cmp > 0) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) - (b.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        // Copy rest of the words
        if (carry === 0 && i < a.length && a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = Math.max(this.length, i);
        if (a !== this) this.negative = 1;
        return this._strip();
    };
    // Subtract `num` from `this`
    BN.prototype.sub = function sub(num) {
        return this.clone().isub(num);
    };
    function smallMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        var len = self.length + num.length | 0;
        out.length = len;
        len = len - 1 | 0;
        // Peel one iteration (compiler can't do it, because of code complexity)
        var a = self.words[0] | 0;
        var b = num.words[0] | 0;
        var r = a * b;
        var lo = r & 0x3ffffff;
        var carry = r / 0x4000000 | 0;
        out.words[0] = lo;
        for(var k = 1; k < len; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = carry >>> 26;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j | 0;
                a = self.words[i] | 0;
                b = num.words[j] | 0;
                r = a * b + rword;
                ncarry += r / 0x4000000 | 0;
                rword = r & 0x3ffffff;
            }
            out.words[k] = rword | 0;
            carry = ncarry | 0;
        }
        if (carry !== 0) out.words[k] = carry | 0;
        else out.length--;
        return out._strip();
    }
    // TODO(indutny): it may be reasonable to omit it for users who don't need
    // to work with 256-bit numbers, otherwise it gives 20% improvement for 256-bit
    // multiplication (like elliptic secp256k1).
    var comb10MulTo = function comb10MulTo(self, num, out) {
        var a = self.words;
        var b = num.words;
        var o = out.words;
        var c = 0;
        var lo;
        var mid;
        var hi;
        var a0 = a[0] | 0;
        var al0 = a0 & 0x1fff;
        var ah0 = a0 >>> 13;
        var a1 = a[1] | 0;
        var al1 = a1 & 0x1fff;
        var ah1 = a1 >>> 13;
        var a2 = a[2] | 0;
        var al2 = a2 & 0x1fff;
        var ah2 = a2 >>> 13;
        var a3 = a[3] | 0;
        var al3 = a3 & 0x1fff;
        var ah3 = a3 >>> 13;
        var a4 = a[4] | 0;
        var al4 = a4 & 0x1fff;
        var ah4 = a4 >>> 13;
        var a5 = a[5] | 0;
        var al5 = a5 & 0x1fff;
        var ah5 = a5 >>> 13;
        var a6 = a[6] | 0;
        var al6 = a6 & 0x1fff;
        var ah6 = a6 >>> 13;
        var a7 = a[7] | 0;
        var al7 = a7 & 0x1fff;
        var ah7 = a7 >>> 13;
        var a8 = a[8] | 0;
        var al8 = a8 & 0x1fff;
        var ah8 = a8 >>> 13;
        var a9 = a[9] | 0;
        var al9 = a9 & 0x1fff;
        var ah9 = a9 >>> 13;
        var b0 = b[0] | 0;
        var bl0 = b0 & 0x1fff;
        var bh0 = b0 >>> 13;
        var b1 = b[1] | 0;
        var bl1 = b1 & 0x1fff;
        var bh1 = b1 >>> 13;
        var b2 = b[2] | 0;
        var bl2 = b2 & 0x1fff;
        var bh2 = b2 >>> 13;
        var b3 = b[3] | 0;
        var bl3 = b3 & 0x1fff;
        var bh3 = b3 >>> 13;
        var b4 = b[4] | 0;
        var bl4 = b4 & 0x1fff;
        var bh4 = b4 >>> 13;
        var b5 = b[5] | 0;
        var bl5 = b5 & 0x1fff;
        var bh5 = b5 >>> 13;
        var b6 = b[6] | 0;
        var bl6 = b6 & 0x1fff;
        var bh6 = b6 >>> 13;
        var b7 = b[7] | 0;
        var bl7 = b7 & 0x1fff;
        var bh7 = b7 >>> 13;
        var b8 = b[8] | 0;
        var bl8 = b8 & 0x1fff;
        var bh8 = b8 >>> 13;
        var b9 = b[9] | 0;
        var bl9 = b9 & 0x1fff;
        var bh9 = b9 >>> 13;
        out.negative = self.negative ^ num.negative;
        out.length = 19;
        /* k = 0 */ lo = Math.imul(al0, bl0);
        mid = Math.imul(al0, bh0);
        mid = mid + Math.imul(ah0, bl0) | 0;
        hi = Math.imul(ah0, bh0);
        var w0 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w0 >>> 26) | 0;
        w0 &= 0x3ffffff;
        /* k = 1 */ lo = Math.imul(al1, bl0);
        mid = Math.imul(al1, bh0);
        mid = mid + Math.imul(ah1, bl0) | 0;
        hi = Math.imul(ah1, bh0);
        lo = lo + Math.imul(al0, bl1) | 0;
        mid = mid + Math.imul(al0, bh1) | 0;
        mid = mid + Math.imul(ah0, bl1) | 0;
        hi = hi + Math.imul(ah0, bh1) | 0;
        var w1 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w1 >>> 26) | 0;
        w1 &= 0x3ffffff;
        /* k = 2 */ lo = Math.imul(al2, bl0);
        mid = Math.imul(al2, bh0);
        mid = mid + Math.imul(ah2, bl0) | 0;
        hi = Math.imul(ah2, bh0);
        lo = lo + Math.imul(al1, bl1) | 0;
        mid = mid + Math.imul(al1, bh1) | 0;
        mid = mid + Math.imul(ah1, bl1) | 0;
        hi = hi + Math.imul(ah1, bh1) | 0;
        lo = lo + Math.imul(al0, bl2) | 0;
        mid = mid + Math.imul(al0, bh2) | 0;
        mid = mid + Math.imul(ah0, bl2) | 0;
        hi = hi + Math.imul(ah0, bh2) | 0;
        var w2 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w2 >>> 26) | 0;
        w2 &= 0x3ffffff;
        /* k = 3 */ lo = Math.imul(al3, bl0);
        mid = Math.imul(al3, bh0);
        mid = mid + Math.imul(ah3, bl0) | 0;
        hi = Math.imul(ah3, bh0);
        lo = lo + Math.imul(al2, bl1) | 0;
        mid = mid + Math.imul(al2, bh1) | 0;
        mid = mid + Math.imul(ah2, bl1) | 0;
        hi = hi + Math.imul(ah2, bh1) | 0;
        lo = lo + Math.imul(al1, bl2) | 0;
        mid = mid + Math.imul(al1, bh2) | 0;
        mid = mid + Math.imul(ah1, bl2) | 0;
        hi = hi + Math.imul(ah1, bh2) | 0;
        lo = lo + Math.imul(al0, bl3) | 0;
        mid = mid + Math.imul(al0, bh3) | 0;
        mid = mid + Math.imul(ah0, bl3) | 0;
        hi = hi + Math.imul(ah0, bh3) | 0;
        var w3 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w3 >>> 26) | 0;
        w3 &= 0x3ffffff;
        /* k = 4 */ lo = Math.imul(al4, bl0);
        mid = Math.imul(al4, bh0);
        mid = mid + Math.imul(ah4, bl0) | 0;
        hi = Math.imul(ah4, bh0);
        lo = lo + Math.imul(al3, bl1) | 0;
        mid = mid + Math.imul(al3, bh1) | 0;
        mid = mid + Math.imul(ah3, bl1) | 0;
        hi = hi + Math.imul(ah3, bh1) | 0;
        lo = lo + Math.imul(al2, bl2) | 0;
        mid = mid + Math.imul(al2, bh2) | 0;
        mid = mid + Math.imul(ah2, bl2) | 0;
        hi = hi + Math.imul(ah2, bh2) | 0;
        lo = lo + Math.imul(al1, bl3) | 0;
        mid = mid + Math.imul(al1, bh3) | 0;
        mid = mid + Math.imul(ah1, bl3) | 0;
        hi = hi + Math.imul(ah1, bh3) | 0;
        lo = lo + Math.imul(al0, bl4) | 0;
        mid = mid + Math.imul(al0, bh4) | 0;
        mid = mid + Math.imul(ah0, bl4) | 0;
        hi = hi + Math.imul(ah0, bh4) | 0;
        var w4 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w4 >>> 26) | 0;
        w4 &= 0x3ffffff;
        /* k = 5 */ lo = Math.imul(al5, bl0);
        mid = Math.imul(al5, bh0);
        mid = mid + Math.imul(ah5, bl0) | 0;
        hi = Math.imul(ah5, bh0);
        lo = lo + Math.imul(al4, bl1) | 0;
        mid = mid + Math.imul(al4, bh1) | 0;
        mid = mid + Math.imul(ah4, bl1) | 0;
        hi = hi + Math.imul(ah4, bh1) | 0;
        lo = lo + Math.imul(al3, bl2) | 0;
        mid = mid + Math.imul(al3, bh2) | 0;
        mid = mid + Math.imul(ah3, bl2) | 0;
        hi = hi + Math.imul(ah3, bh2) | 0;
        lo = lo + Math.imul(al2, bl3) | 0;
        mid = mid + Math.imul(al2, bh3) | 0;
        mid = mid + Math.imul(ah2, bl3) | 0;
        hi = hi + Math.imul(ah2, bh3) | 0;
        lo = lo + Math.imul(al1, bl4) | 0;
        mid = mid + Math.imul(al1, bh4) | 0;
        mid = mid + Math.imul(ah1, bl4) | 0;
        hi = hi + Math.imul(ah1, bh4) | 0;
        lo = lo + Math.imul(al0, bl5) | 0;
        mid = mid + Math.imul(al0, bh5) | 0;
        mid = mid + Math.imul(ah0, bl5) | 0;
        hi = hi + Math.imul(ah0, bh5) | 0;
        var w5 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w5 >>> 26) | 0;
        w5 &= 0x3ffffff;
        /* k = 6 */ lo = Math.imul(al6, bl0);
        mid = Math.imul(al6, bh0);
        mid = mid + Math.imul(ah6, bl0) | 0;
        hi = Math.imul(ah6, bh0);
        lo = lo + Math.imul(al5, bl1) | 0;
        mid = mid + Math.imul(al5, bh1) | 0;
        mid = mid + Math.imul(ah5, bl1) | 0;
        hi = hi + Math.imul(ah5, bh1) | 0;
        lo = lo + Math.imul(al4, bl2) | 0;
        mid = mid + Math.imul(al4, bh2) | 0;
        mid = mid + Math.imul(ah4, bl2) | 0;
        hi = hi + Math.imul(ah4, bh2) | 0;
        lo = lo + Math.imul(al3, bl3) | 0;
        mid = mid + Math.imul(al3, bh3) | 0;
        mid = mid + Math.imul(ah3, bl3) | 0;
        hi = hi + Math.imul(ah3, bh3) | 0;
        lo = lo + Math.imul(al2, bl4) | 0;
        mid = mid + Math.imul(al2, bh4) | 0;
        mid = mid + Math.imul(ah2, bl4) | 0;
        hi = hi + Math.imul(ah2, bh4) | 0;
        lo = lo + Math.imul(al1, bl5) | 0;
        mid = mid + Math.imul(al1, bh5) | 0;
        mid = mid + Math.imul(ah1, bl5) | 0;
        hi = hi + Math.imul(ah1, bh5) | 0;
        lo = lo + Math.imul(al0, bl6) | 0;
        mid = mid + Math.imul(al0, bh6) | 0;
        mid = mid + Math.imul(ah0, bl6) | 0;
        hi = hi + Math.imul(ah0, bh6) | 0;
        var w6 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w6 >>> 26) | 0;
        w6 &= 0x3ffffff;
        /* k = 7 */ lo = Math.imul(al7, bl0);
        mid = Math.imul(al7, bh0);
        mid = mid + Math.imul(ah7, bl0) | 0;
        hi = Math.imul(ah7, bh0);
        lo = lo + Math.imul(al6, bl1) | 0;
        mid = mid + Math.imul(al6, bh1) | 0;
        mid = mid + Math.imul(ah6, bl1) | 0;
        hi = hi + Math.imul(ah6, bh1) | 0;
        lo = lo + Math.imul(al5, bl2) | 0;
        mid = mid + Math.imul(al5, bh2) | 0;
        mid = mid + Math.imul(ah5, bl2) | 0;
        hi = hi + Math.imul(ah5, bh2) | 0;
        lo = lo + Math.imul(al4, bl3) | 0;
        mid = mid + Math.imul(al4, bh3) | 0;
        mid = mid + Math.imul(ah4, bl3) | 0;
        hi = hi + Math.imul(ah4, bh3) | 0;
        lo = lo + Math.imul(al3, bl4) | 0;
        mid = mid + Math.imul(al3, bh4) | 0;
        mid = mid + Math.imul(ah3, bl4) | 0;
        hi = hi + Math.imul(ah3, bh4) | 0;
        lo = lo + Math.imul(al2, bl5) | 0;
        mid = mid + Math.imul(al2, bh5) | 0;
        mid = mid + Math.imul(ah2, bl5) | 0;
        hi = hi + Math.imul(ah2, bh5) | 0;
        lo = lo + Math.imul(al1, bl6) | 0;
        mid = mid + Math.imul(al1, bh6) | 0;
        mid = mid + Math.imul(ah1, bl6) | 0;
        hi = hi + Math.imul(ah1, bh6) | 0;
        lo = lo + Math.imul(al0, bl7) | 0;
        mid = mid + Math.imul(al0, bh7) | 0;
        mid = mid + Math.imul(ah0, bl7) | 0;
        hi = hi + Math.imul(ah0, bh7) | 0;
        var w7 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w7 >>> 26) | 0;
        w7 &= 0x3ffffff;
        /* k = 8 */ lo = Math.imul(al8, bl0);
        mid = Math.imul(al8, bh0);
        mid = mid + Math.imul(ah8, bl0) | 0;
        hi = Math.imul(ah8, bh0);
        lo = lo + Math.imul(al7, bl1) | 0;
        mid = mid + Math.imul(al7, bh1) | 0;
        mid = mid + Math.imul(ah7, bl1) | 0;
        hi = hi + Math.imul(ah7, bh1) | 0;
        lo = lo + Math.imul(al6, bl2) | 0;
        mid = mid + Math.imul(al6, bh2) | 0;
        mid = mid + Math.imul(ah6, bl2) | 0;
        hi = hi + Math.imul(ah6, bh2) | 0;
        lo = lo + Math.imul(al5, bl3) | 0;
        mid = mid + Math.imul(al5, bh3) | 0;
        mid = mid + Math.imul(ah5, bl3) | 0;
        hi = hi + Math.imul(ah5, bh3) | 0;
        lo = lo + Math.imul(al4, bl4) | 0;
        mid = mid + Math.imul(al4, bh4) | 0;
        mid = mid + Math.imul(ah4, bl4) | 0;
        hi = hi + Math.imul(ah4, bh4) | 0;
        lo = lo + Math.imul(al3, bl5) | 0;
        mid = mid + Math.imul(al3, bh5) | 0;
        mid = mid + Math.imul(ah3, bl5) | 0;
        hi = hi + Math.imul(ah3, bh5) | 0;
        lo = lo + Math.imul(al2, bl6) | 0;
        mid = mid + Math.imul(al2, bh6) | 0;
        mid = mid + Math.imul(ah2, bl6) | 0;
        hi = hi + Math.imul(ah2, bh6) | 0;
        lo = lo + Math.imul(al1, bl7) | 0;
        mid = mid + Math.imul(al1, bh7) | 0;
        mid = mid + Math.imul(ah1, bl7) | 0;
        hi = hi + Math.imul(ah1, bh7) | 0;
        lo = lo + Math.imul(al0, bl8) | 0;
        mid = mid + Math.imul(al0, bh8) | 0;
        mid = mid + Math.imul(ah0, bl8) | 0;
        hi = hi + Math.imul(ah0, bh8) | 0;
        var w8 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w8 >>> 26) | 0;
        w8 &= 0x3ffffff;
        /* k = 9 */ lo = Math.imul(al9, bl0);
        mid = Math.imul(al9, bh0);
        mid = mid + Math.imul(ah9, bl0) | 0;
        hi = Math.imul(ah9, bh0);
        lo = lo + Math.imul(al8, bl1) | 0;
        mid = mid + Math.imul(al8, bh1) | 0;
        mid = mid + Math.imul(ah8, bl1) | 0;
        hi = hi + Math.imul(ah8, bh1) | 0;
        lo = lo + Math.imul(al7, bl2) | 0;
        mid = mid + Math.imul(al7, bh2) | 0;
        mid = mid + Math.imul(ah7, bl2) | 0;
        hi = hi + Math.imul(ah7, bh2) | 0;
        lo = lo + Math.imul(al6, bl3) | 0;
        mid = mid + Math.imul(al6, bh3) | 0;
        mid = mid + Math.imul(ah6, bl3) | 0;
        hi = hi + Math.imul(ah6, bh3) | 0;
        lo = lo + Math.imul(al5, bl4) | 0;
        mid = mid + Math.imul(al5, bh4) | 0;
        mid = mid + Math.imul(ah5, bl4) | 0;
        hi = hi + Math.imul(ah5, bh4) | 0;
        lo = lo + Math.imul(al4, bl5) | 0;
        mid = mid + Math.imul(al4, bh5) | 0;
        mid = mid + Math.imul(ah4, bl5) | 0;
        hi = hi + Math.imul(ah4, bh5) | 0;
        lo = lo + Math.imul(al3, bl6) | 0;
        mid = mid + Math.imul(al3, bh6) | 0;
        mid = mid + Math.imul(ah3, bl6) | 0;
        hi = hi + Math.imul(ah3, bh6) | 0;
        lo = lo + Math.imul(al2, bl7) | 0;
        mid = mid + Math.imul(al2, bh7) | 0;
        mid = mid + Math.imul(ah2, bl7) | 0;
        hi = hi + Math.imul(ah2, bh7) | 0;
        lo = lo + Math.imul(al1, bl8) | 0;
        mid = mid + Math.imul(al1, bh8) | 0;
        mid = mid + Math.imul(ah1, bl8) | 0;
        hi = hi + Math.imul(ah1, bh8) | 0;
        lo = lo + Math.imul(al0, bl9) | 0;
        mid = mid + Math.imul(al0, bh9) | 0;
        mid = mid + Math.imul(ah0, bl9) | 0;
        hi = hi + Math.imul(ah0, bh9) | 0;
        var w9 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w9 >>> 26) | 0;
        w9 &= 0x3ffffff;
        /* k = 10 */ lo = Math.imul(al9, bl1);
        mid = Math.imul(al9, bh1);
        mid = mid + Math.imul(ah9, bl1) | 0;
        hi = Math.imul(ah9, bh1);
        lo = lo + Math.imul(al8, bl2) | 0;
        mid = mid + Math.imul(al8, bh2) | 0;
        mid = mid + Math.imul(ah8, bl2) | 0;
        hi = hi + Math.imul(ah8, bh2) | 0;
        lo = lo + Math.imul(al7, bl3) | 0;
        mid = mid + Math.imul(al7, bh3) | 0;
        mid = mid + Math.imul(ah7, bl3) | 0;
        hi = hi + Math.imul(ah7, bh3) | 0;
        lo = lo + Math.imul(al6, bl4) | 0;
        mid = mid + Math.imul(al6, bh4) | 0;
        mid = mid + Math.imul(ah6, bl4) | 0;
        hi = hi + Math.imul(ah6, bh4) | 0;
        lo = lo + Math.imul(al5, bl5) | 0;
        mid = mid + Math.imul(al5, bh5) | 0;
        mid = mid + Math.imul(ah5, bl5) | 0;
        hi = hi + Math.imul(ah5, bh5) | 0;
        lo = lo + Math.imul(al4, bl6) | 0;
        mid = mid + Math.imul(al4, bh6) | 0;
        mid = mid + Math.imul(ah4, bl6) | 0;
        hi = hi + Math.imul(ah4, bh6) | 0;
        lo = lo + Math.imul(al3, bl7) | 0;
        mid = mid + Math.imul(al3, bh7) | 0;
        mid = mid + Math.imul(ah3, bl7) | 0;
        hi = hi + Math.imul(ah3, bh7) | 0;
        lo = lo + Math.imul(al2, bl8) | 0;
        mid = mid + Math.imul(al2, bh8) | 0;
        mid = mid + Math.imul(ah2, bl8) | 0;
        hi = hi + Math.imul(ah2, bh8) | 0;
        lo = lo + Math.imul(al1, bl9) | 0;
        mid = mid + Math.imul(al1, bh9) | 0;
        mid = mid + Math.imul(ah1, bl9) | 0;
        hi = hi + Math.imul(ah1, bh9) | 0;
        var w10 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w10 >>> 26) | 0;
        w10 &= 0x3ffffff;
        /* k = 11 */ lo = Math.imul(al9, bl2);
        mid = Math.imul(al9, bh2);
        mid = mid + Math.imul(ah9, bl2) | 0;
        hi = Math.imul(ah9, bh2);
        lo = lo + Math.imul(al8, bl3) | 0;
        mid = mid + Math.imul(al8, bh3) | 0;
        mid = mid + Math.imul(ah8, bl3) | 0;
        hi = hi + Math.imul(ah8, bh3) | 0;
        lo = lo + Math.imul(al7, bl4) | 0;
        mid = mid + Math.imul(al7, bh4) | 0;
        mid = mid + Math.imul(ah7, bl4) | 0;
        hi = hi + Math.imul(ah7, bh4) | 0;
        lo = lo + Math.imul(al6, bl5) | 0;
        mid = mid + Math.imul(al6, bh5) | 0;
        mid = mid + Math.imul(ah6, bl5) | 0;
        hi = hi + Math.imul(ah6, bh5) | 0;
        lo = lo + Math.imul(al5, bl6) | 0;
        mid = mid + Math.imul(al5, bh6) | 0;
        mid = mid + Math.imul(ah5, bl6) | 0;
        hi = hi + Math.imul(ah5, bh6) | 0;
        lo = lo + Math.imul(al4, bl7) | 0;
        mid = mid + Math.imul(al4, bh7) | 0;
        mid = mid + Math.imul(ah4, bl7) | 0;
        hi = hi + Math.imul(ah4, bh7) | 0;
        lo = lo + Math.imul(al3, bl8) | 0;
        mid = mid + Math.imul(al3, bh8) | 0;
        mid = mid + Math.imul(ah3, bl8) | 0;
        hi = hi + Math.imul(ah3, bh8) | 0;
        lo = lo + Math.imul(al2, bl9) | 0;
        mid = mid + Math.imul(al2, bh9) | 0;
        mid = mid + Math.imul(ah2, bl9) | 0;
        hi = hi + Math.imul(ah2, bh9) | 0;
        var w11 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w11 >>> 26) | 0;
        w11 &= 0x3ffffff;
        /* k = 12 */ lo = Math.imul(al9, bl3);
        mid = Math.imul(al9, bh3);
        mid = mid + Math.imul(ah9, bl3) | 0;
        hi = Math.imul(ah9, bh3);
        lo = lo + Math.imul(al8, bl4) | 0;
        mid = mid + Math.imul(al8, bh4) | 0;
        mid = mid + Math.imul(ah8, bl4) | 0;
        hi = hi + Math.imul(ah8, bh4) | 0;
        lo = lo + Math.imul(al7, bl5) | 0;
        mid = mid + Math.imul(al7, bh5) | 0;
        mid = mid + Math.imul(ah7, bl5) | 0;
        hi = hi + Math.imul(ah7, bh5) | 0;
        lo = lo + Math.imul(al6, bl6) | 0;
        mid = mid + Math.imul(al6, bh6) | 0;
        mid = mid + Math.imul(ah6, bl6) | 0;
        hi = hi + Math.imul(ah6, bh6) | 0;
        lo = lo + Math.imul(al5, bl7) | 0;
        mid = mid + Math.imul(al5, bh7) | 0;
        mid = mid + Math.imul(ah5, bl7) | 0;
        hi = hi + Math.imul(ah5, bh7) | 0;
        lo = lo + Math.imul(al4, bl8) | 0;
        mid = mid + Math.imul(al4, bh8) | 0;
        mid = mid + Math.imul(ah4, bl8) | 0;
        hi = hi + Math.imul(ah4, bh8) | 0;
        lo = lo + Math.imul(al3, bl9) | 0;
        mid = mid + Math.imul(al3, bh9) | 0;
        mid = mid + Math.imul(ah3, bl9) | 0;
        hi = hi + Math.imul(ah3, bh9) | 0;
        var w12 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w12 >>> 26) | 0;
        w12 &= 0x3ffffff;
        /* k = 13 */ lo = Math.imul(al9, bl4);
        mid = Math.imul(al9, bh4);
        mid = mid + Math.imul(ah9, bl4) | 0;
        hi = Math.imul(ah9, bh4);
        lo = lo + Math.imul(al8, bl5) | 0;
        mid = mid + Math.imul(al8, bh5) | 0;
        mid = mid + Math.imul(ah8, bl5) | 0;
        hi = hi + Math.imul(ah8, bh5) | 0;
        lo = lo + Math.imul(al7, bl6) | 0;
        mid = mid + Math.imul(al7, bh6) | 0;
        mid = mid + Math.imul(ah7, bl6) | 0;
        hi = hi + Math.imul(ah7, bh6) | 0;
        lo = lo + Math.imul(al6, bl7) | 0;
        mid = mid + Math.imul(al6, bh7) | 0;
        mid = mid + Math.imul(ah6, bl7) | 0;
        hi = hi + Math.imul(ah6, bh7) | 0;
        lo = lo + Math.imul(al5, bl8) | 0;
        mid = mid + Math.imul(al5, bh8) | 0;
        mid = mid + Math.imul(ah5, bl8) | 0;
        hi = hi + Math.imul(ah5, bh8) | 0;
        lo = lo + Math.imul(al4, bl9) | 0;
        mid = mid + Math.imul(al4, bh9) | 0;
        mid = mid + Math.imul(ah4, bl9) | 0;
        hi = hi + Math.imul(ah4, bh9) | 0;
        var w13 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w13 >>> 26) | 0;
        w13 &= 0x3ffffff;
        /* k = 14 */ lo = Math.imul(al9, bl5);
        mid = Math.imul(al9, bh5);
        mid = mid + Math.imul(ah9, bl5) | 0;
        hi = Math.imul(ah9, bh5);
        lo = lo + Math.imul(al8, bl6) | 0;
        mid = mid + Math.imul(al8, bh6) | 0;
        mid = mid + Math.imul(ah8, bl6) | 0;
        hi = hi + Math.imul(ah8, bh6) | 0;
        lo = lo + Math.imul(al7, bl7) | 0;
        mid = mid + Math.imul(al7, bh7) | 0;
        mid = mid + Math.imul(ah7, bl7) | 0;
        hi = hi + Math.imul(ah7, bh7) | 0;
        lo = lo + Math.imul(al6, bl8) | 0;
        mid = mid + Math.imul(al6, bh8) | 0;
        mid = mid + Math.imul(ah6, bl8) | 0;
        hi = hi + Math.imul(ah6, bh8) | 0;
        lo = lo + Math.imul(al5, bl9) | 0;
        mid = mid + Math.imul(al5, bh9) | 0;
        mid = mid + Math.imul(ah5, bl9) | 0;
        hi = hi + Math.imul(ah5, bh9) | 0;
        var w14 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w14 >>> 26) | 0;
        w14 &= 0x3ffffff;
        /* k = 15 */ lo = Math.imul(al9, bl6);
        mid = Math.imul(al9, bh6);
        mid = mid + Math.imul(ah9, bl6) | 0;
        hi = Math.imul(ah9, bh6);
        lo = lo + Math.imul(al8, bl7) | 0;
        mid = mid + Math.imul(al8, bh7) | 0;
        mid = mid + Math.imul(ah8, bl7) | 0;
        hi = hi + Math.imul(ah8, bh7) | 0;
        lo = lo + Math.imul(al7, bl8) | 0;
        mid = mid + Math.imul(al7, bh8) | 0;
        mid = mid + Math.imul(ah7, bl8) | 0;
        hi = hi + Math.imul(ah7, bh8) | 0;
        lo = lo + Math.imul(al6, bl9) | 0;
        mid = mid + Math.imul(al6, bh9) | 0;
        mid = mid + Math.imul(ah6, bl9) | 0;
        hi = hi + Math.imul(ah6, bh9) | 0;
        var w15 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w15 >>> 26) | 0;
        w15 &= 0x3ffffff;
        /* k = 16 */ lo = Math.imul(al9, bl7);
        mid = Math.imul(al9, bh7);
        mid = mid + Math.imul(ah9, bl7) | 0;
        hi = Math.imul(ah9, bh7);
        lo = lo + Math.imul(al8, bl8) | 0;
        mid = mid + Math.imul(al8, bh8) | 0;
        mid = mid + Math.imul(ah8, bl8) | 0;
        hi = hi + Math.imul(ah8, bh8) | 0;
        lo = lo + Math.imul(al7, bl9) | 0;
        mid = mid + Math.imul(al7, bh9) | 0;
        mid = mid + Math.imul(ah7, bl9) | 0;
        hi = hi + Math.imul(ah7, bh9) | 0;
        var w16 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w16 >>> 26) | 0;
        w16 &= 0x3ffffff;
        /* k = 17 */ lo = Math.imul(al9, bl8);
        mid = Math.imul(al9, bh8);
        mid = mid + Math.imul(ah9, bl8) | 0;
        hi = Math.imul(ah9, bh8);
        lo = lo + Math.imul(al8, bl9) | 0;
        mid = mid + Math.imul(al8, bh9) | 0;
        mid = mid + Math.imul(ah8, bl9) | 0;
        hi = hi + Math.imul(ah8, bh9) | 0;
        var w17 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w17 >>> 26) | 0;
        w17 &= 0x3ffffff;
        /* k = 18 */ lo = Math.imul(al9, bl9);
        mid = Math.imul(al9, bh9);
        mid = mid + Math.imul(ah9, bl9) | 0;
        hi = Math.imul(ah9, bh9);
        var w18 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w18 >>> 26) | 0;
        w18 &= 0x3ffffff;
        o[0] = w0;
        o[1] = w1;
        o[2] = w2;
        o[3] = w3;
        o[4] = w4;
        o[5] = w5;
        o[6] = w6;
        o[7] = w7;
        o[8] = w8;
        o[9] = w9;
        o[10] = w10;
        o[11] = w11;
        o[12] = w12;
        o[13] = w13;
        o[14] = w14;
        o[15] = w15;
        o[16] = w16;
        o[17] = w17;
        o[18] = w18;
        if (c !== 0) {
            o[19] = c;
            out.length++;
        }
        return out;
    };
    // Polyfill comb
    if (!Math.imul) comb10MulTo = smallMulTo;
    function bigMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        out.length = self.length + num.length;
        var carry = 0;
        var hncarry = 0;
        for(var k = 0; k < out.length - 1; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = hncarry;
            hncarry = 0;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j;
                var a = self.words[i] | 0;
                var b = num.words[j] | 0;
                var r = a * b;
                var lo = r & 0x3ffffff;
                ncarry = ncarry + (r / 0x4000000 | 0) | 0;
                lo = lo + rword | 0;
                rword = lo & 0x3ffffff;
                ncarry = ncarry + (lo >>> 26) | 0;
                hncarry += ncarry >>> 26;
                ncarry &= 0x3ffffff;
            }
            out.words[k] = rword;
            carry = ncarry;
            ncarry = hncarry;
        }
        if (carry !== 0) out.words[k] = carry;
        else out.length--;
        return out._strip();
    }
    function jumboMulTo(self, num, out) {
        // Temporary disable, see https://github.com/indutny/bn.js/issues/211
        // var fftm = new FFTM();
        // return fftm.mulp(self, num, out);
        return bigMulTo(self, num, out);
    }
    BN.prototype.mulTo = function mulTo(num, out) {
        var res;
        var len = this.length + num.length;
        if (this.length === 10 && num.length === 10) res = comb10MulTo(this, num, out);
        else if (len < 63) res = smallMulTo(this, num, out);
        else if (len < 1024) res = bigMulTo(this, num, out);
        else res = jumboMulTo(this, num, out);
        return res;
    };
    // Cooley-Tukey algorithm for FFT
    // slightly revisited to rely on looping instead of recursion
    function FFTM(x, y) {
        this.x = x;
        this.y = y;
    }
    FFTM.prototype.makeRBT = function makeRBT(N) {
        var t = new Array(N);
        var l = BN.prototype._countBits(N) - 1;
        for(var i = 0; i < N; i++)t[i] = this.revBin(i, l, N);
        return t;
    };
    // Returns binary-reversed representation of `x`
    FFTM.prototype.revBin = function revBin(x, l, N) {
        if (x === 0 || x === N - 1) return x;
        var rb = 0;
        for(var i = 0; i < l; i++){
            rb |= (x & 1) << l - i - 1;
            x >>= 1;
        }
        return rb;
    };
    // Performs "tweedling" phase, therefore 'emulating'
    // behaviour of the recursive algorithm
    FFTM.prototype.permute = function permute(rbt, rws, iws, rtws, itws, N) {
        for(var i = 0; i < N; i++){
            rtws[i] = rws[rbt[i]];
            itws[i] = iws[rbt[i]];
        }
    };
    FFTM.prototype.transform = function transform(rws, iws, rtws, itws, N, rbt) {
        this.permute(rbt, rws, iws, rtws, itws, N);
        for(var s = 1; s < N; s <<= 1){
            var l = s << 1;
            var rtwdf = Math.cos(2 * Math.PI / l);
            var itwdf = Math.sin(2 * Math.PI / l);
            for(var p = 0; p < N; p += l){
                var rtwdf_ = rtwdf;
                var itwdf_ = itwdf;
                for(var j = 0; j < s; j++){
                    var re = rtws[p + j];
                    var ie = itws[p + j];
                    var ro = rtws[p + j + s];
                    var io = itws[p + j + s];
                    var rx = rtwdf_ * ro - itwdf_ * io;
                    io = rtwdf_ * io + itwdf_ * ro;
                    ro = rx;
                    rtws[p + j] = re + ro;
                    itws[p + j] = ie + io;
                    rtws[p + j + s] = re - ro;
                    itws[p + j + s] = ie - io;
                    /* jshint maxdepth : false */ if (j !== l) {
                        rx = rtwdf * rtwdf_ - itwdf * itwdf_;
                        itwdf_ = rtwdf * itwdf_ + itwdf * rtwdf_;
                        rtwdf_ = rx;
                    }
                }
            }
        }
    };
    FFTM.prototype.guessLen13b = function guessLen13b(n, m) {
        var N = Math.max(m, n) | 1;
        var odd = N & 1;
        var i = 0;
        for(N = N / 2 | 0; N; N = N >>> 1)i++;
        return 1 << i + 1 + odd;
    };
    FFTM.prototype.conjugate = function conjugate(rws, iws, N) {
        if (N <= 1) return;
        for(var i = 0; i < N / 2; i++){
            var t = rws[i];
            rws[i] = rws[N - i - 1];
            rws[N - i - 1] = t;
            t = iws[i];
            iws[i] = -iws[N - i - 1];
            iws[N - i - 1] = -t;
        }
    };
    FFTM.prototype.normalize13b = function normalize13b(ws, N) {
        var carry = 0;
        for(var i = 0; i < N / 2; i++){
            var w = Math.round(ws[2 * i + 1] / N) * 0x2000 + Math.round(ws[2 * i] / N) + carry;
            ws[i] = w & 0x3ffffff;
            if (w < 0x4000000) carry = 0;
            else carry = w / 0x4000000 | 0;
        }
        return ws;
    };
    FFTM.prototype.convert13b = function convert13b(ws, len, rws, N) {
        var carry = 0;
        for(var i = 0; i < len; i++){
            carry = carry + (ws[i] | 0);
            rws[2 * i] = carry & 0x1fff;
            carry = carry >>> 13;
            rws[2 * i + 1] = carry & 0x1fff;
            carry = carry >>> 13;
        }
        // Pad with zeroes
        for(i = 2 * len; i < N; ++i)rws[i] = 0;
        assert(carry === 0);
        assert((carry & -8192) === 0);
    };
    FFTM.prototype.stub = function stub(N) {
        var ph = new Array(N);
        for(var i = 0; i < N; i++)ph[i] = 0;
        return ph;
    };
    FFTM.prototype.mulp = function mulp(x, y, out) {
        var N = 2 * this.guessLen13b(x.length, y.length);
        var rbt = this.makeRBT(N);
        var _ = this.stub(N);
        var rws = new Array(N);
        var rwst = new Array(N);
        var iwst = new Array(N);
        var nrws = new Array(N);
        var nrwst = new Array(N);
        var niwst = new Array(N);
        var rmws = out.words;
        rmws.length = N;
        this.convert13b(x.words, x.length, rws, N);
        this.convert13b(y.words, y.length, nrws, N);
        this.transform(rws, _, rwst, iwst, N, rbt);
        this.transform(nrws, _, nrwst, niwst, N, rbt);
        for(var i = 0; i < N; i++){
            var rx = rwst[i] * nrwst[i] - iwst[i] * niwst[i];
            iwst[i] = rwst[i] * niwst[i] + iwst[i] * nrwst[i];
            rwst[i] = rx;
        }
        this.conjugate(rwst, iwst, N);
        this.transform(rwst, iwst, rmws, _, N, rbt);
        this.conjugate(rmws, _, N);
        this.normalize13b(rmws, N);
        out.negative = x.negative ^ y.negative;
        out.length = x.length + y.length;
        return out._strip();
    };
    // Multiply `this` by `num`
    BN.prototype.mul = function mul(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return this.mulTo(num, out);
    };
    // Multiply employing FFT
    BN.prototype.mulf = function mulf(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return jumboMulTo(this, num, out);
    };
    // In-place Multiplication
    BN.prototype.imul = function imul(num) {
        return this.clone().mulTo(num, this);
    };
    BN.prototype.imuln = function imuln(num) {
        var isNegNum = num < 0;
        if (isNegNum) num = -num;
        assert(typeof num === "number");
        assert(num < 0x4000000);
        // Carry
        var carry = 0;
        for(var i = 0; i < this.length; i++){
            var w = (this.words[i] | 0) * num;
            var lo = (w & 0x3ffffff) + (carry & 0x3ffffff);
            carry >>= 26;
            carry += w / 0x4000000 | 0;
            // NOTE: lo is 27bit maximum
            carry += lo >>> 26;
            this.words[i] = lo & 0x3ffffff;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return isNegNum ? this.ineg() : this;
    };
    BN.prototype.muln = function muln(num) {
        return this.clone().imuln(num);
    };
    // `this` * `this`
    BN.prototype.sqr = function sqr() {
        return this.mul(this);
    };
    // `this` * `this` in-place
    BN.prototype.isqr = function isqr() {
        return this.imul(this.clone());
    };
    // Math.pow(`this`, `num`)
    BN.prototype.pow = function pow(num) {
        var w = toBitArray(num);
        if (w.length === 0) return new BN(1);
        // Skip leading zeroes
        var res = this;
        for(var i = 0; i < w.length; i++, res = res.sqr()){
            if (w[i] !== 0) break;
        }
        if (++i < w.length) for(var q = res.sqr(); i < w.length; i++, q = q.sqr()){
            if (w[i] === 0) continue;
            res = res.mul(q);
        }
        return res;
    };
    // Shift-left in-place
    BN.prototype.iushln = function iushln(bits) {
        assert(typeof bits === "number" && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        var carryMask = 0x3ffffff >>> 26 - r << 26 - r;
        var i;
        if (r !== 0) {
            var carry = 0;
            for(i = 0; i < this.length; i++){
                var newCarry = this.words[i] & carryMask;
                var c = (this.words[i] | 0) - newCarry << r;
                this.words[i] = c | carry;
                carry = newCarry >>> 26 - r;
            }
            if (carry) {
                this.words[i] = carry;
                this.length++;
            }
        }
        if (s !== 0) {
            for(i = this.length - 1; i >= 0; i--)this.words[i + s] = this.words[i];
            for(i = 0; i < s; i++)this.words[i] = 0;
            this.length += s;
        }
        return this._strip();
    };
    BN.prototype.ishln = function ishln(bits) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushln(bits);
    };
    // Shift-right in-place
    // NOTE: `hint` is a lowest bit before trailing zeroes
    // NOTE: if `extended` is present - it will be filled with destroyed bits
    BN.prototype.iushrn = function iushrn(bits, hint, extended) {
        assert(typeof bits === "number" && bits >= 0);
        var h;
        if (hint) h = (hint - hint % 26) / 26;
        else h = 0;
        var r = bits % 26;
        var s = Math.min((bits - r) / 26, this.length);
        var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
        var maskedWords = extended;
        h -= s;
        h = Math.max(0, h);
        // Extended mode, copy masked part
        if (maskedWords) {
            for(var i = 0; i < s; i++)maskedWords.words[i] = this.words[i];
            maskedWords.length = s;
        }
        if (s === 0) ;
        else if (this.length > s) {
            this.length -= s;
            for(i = 0; i < this.length; i++)this.words[i] = this.words[i + s];
        } else {
            this.words[0] = 0;
            this.length = 1;
        }
        var carry = 0;
        for(i = this.length - 1; i >= 0 && (carry !== 0 || i >= h); i--){
            var word = this.words[i] | 0;
            this.words[i] = carry << 26 - r | word >>> r;
            carry = word & mask;
        }
        // Push carried bits as a mask
        if (maskedWords && carry !== 0) maskedWords.words[maskedWords.length++] = carry;
        if (this.length === 0) {
            this.words[0] = 0;
            this.length = 1;
        }
        return this._strip();
    };
    BN.prototype.ishrn = function ishrn(bits, hint, extended) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushrn(bits, hint, extended);
    };
    // Shift-left
    BN.prototype.shln = function shln(bits) {
        return this.clone().ishln(bits);
    };
    BN.prototype.ushln = function ushln(bits) {
        return this.clone().iushln(bits);
    };
    // Shift-right
    BN.prototype.shrn = function shrn(bits) {
        return this.clone().ishrn(bits);
    };
    BN.prototype.ushrn = function ushrn(bits) {
        return this.clone().iushrn(bits);
    };
    // Test if n bit is set
    BN.prototype.testn = function testn(bit) {
        assert(typeof bit === "number" && bit >= 0);
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) return false;
        // Check bit and return
        var w = this.words[s];
        return !!(w & q);
    };
    // Return only lowers bits of number (in-place)
    BN.prototype.imaskn = function imaskn(bits) {
        assert(typeof bits === "number" && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        assert(this.negative === 0, "imaskn works only with positive numbers");
        if (this.length <= s) return this;
        if (r !== 0) s++;
        this.length = Math.min(s, this.length);
        if (r !== 0) {
            var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
            this.words[this.length - 1] &= mask;
        }
        return this._strip();
    };
    // Return only lowers bits of number
    BN.prototype.maskn = function maskn(bits) {
        return this.clone().imaskn(bits);
    };
    // Add plain number `num` to `this`
    BN.prototype.iaddn = function iaddn(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        if (num < 0) return this.isubn(-num);
        // Possible sign change
        if (this.negative !== 0) {
            if (this.length === 1 && (this.words[0] | 0) <= num) {
                this.words[0] = num - (this.words[0] | 0);
                this.negative = 0;
                return this;
            }
            this.negative = 0;
            this.isubn(num);
            this.negative = 1;
            return this;
        }
        // Add without checks
        return this._iaddn(num);
    };
    BN.prototype._iaddn = function _iaddn(num) {
        this.words[0] += num;
        // Carry
        for(var i = 0; i < this.length && this.words[i] >= 0x4000000; i++){
            this.words[i] -= 0x4000000;
            if (i === this.length - 1) this.words[i + 1] = 1;
            else this.words[i + 1]++;
        }
        this.length = Math.max(this.length, i + 1);
        return this;
    };
    // Subtract plain number `num` from `this`
    BN.prototype.isubn = function isubn(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        if (num < 0) return this.iaddn(-num);
        if (this.negative !== 0) {
            this.negative = 0;
            this.iaddn(num);
            this.negative = 1;
            return this;
        }
        this.words[0] -= num;
        if (this.length === 1 && this.words[0] < 0) {
            this.words[0] = -this.words[0];
            this.negative = 1;
        } else // Carry
        for(var i = 0; i < this.length && this.words[i] < 0; i++){
            this.words[i] += 0x4000000;
            this.words[i + 1] -= 1;
        }
        return this._strip();
    };
    BN.prototype.addn = function addn(num) {
        return this.clone().iaddn(num);
    };
    BN.prototype.subn = function subn(num) {
        return this.clone().isubn(num);
    };
    BN.prototype.iabs = function iabs() {
        this.negative = 0;
        return this;
    };
    BN.prototype.abs = function abs() {
        return this.clone().iabs();
    };
    BN.prototype._ishlnsubmul = function _ishlnsubmul(num, mul, shift) {
        var len = num.length + shift;
        var i;
        this._expand(len);
        var w;
        var carry = 0;
        for(i = 0; i < num.length; i++){
            w = (this.words[i + shift] | 0) + carry;
            var right = (num.words[i] | 0) * mul;
            w -= right & 0x3ffffff;
            carry = (w >> 26) - (right / 0x4000000 | 0);
            this.words[i + shift] = w & 0x3ffffff;
        }
        for(; i < this.length - shift; i++){
            w = (this.words[i + shift] | 0) + carry;
            carry = w >> 26;
            this.words[i + shift] = w & 0x3ffffff;
        }
        if (carry === 0) return this._strip();
        // Subtraction overflow
        assert(carry === -1);
        carry = 0;
        for(i = 0; i < this.length; i++){
            w = -(this.words[i] | 0) + carry;
            carry = w >> 26;
            this.words[i] = w & 0x3ffffff;
        }
        this.negative = 1;
        return this._strip();
    };
    BN.prototype._wordDiv = function _wordDiv(num, mode) {
        var shift = this.length - num.length;
        var a = this.clone();
        var b = num;
        // Normalize
        var bhi = b.words[b.length - 1] | 0;
        var bhiBits = this._countBits(bhi);
        shift = 26 - bhiBits;
        if (shift !== 0) {
            b = b.ushln(shift);
            a.iushln(shift);
            bhi = b.words[b.length - 1] | 0;
        }
        // Initialize quotient
        var m = a.length - b.length;
        var q;
        if (mode !== "mod") {
            q = new BN(null);
            q.length = m + 1;
            q.words = new Array(q.length);
            for(var i = 0; i < q.length; i++)q.words[i] = 0;
        }
        var diff = a.clone()._ishlnsubmul(b, 1, m);
        if (diff.negative === 0) {
            a = diff;
            if (q) q.words[m] = 1;
        }
        for(var j = m - 1; j >= 0; j--){
            var qj = (a.words[b.length + j] | 0) * 0x4000000 + (a.words[b.length + j - 1] | 0);
            // NOTE: (qj / bhi) is (0x3ffffff * 0x4000000 + 0x3ffffff) / 0x2000000 max
            // (0x7ffffff)
            qj = Math.min(qj / bhi | 0, 0x3ffffff);
            a._ishlnsubmul(b, qj, j);
            while(a.negative !== 0){
                qj--;
                a.negative = 0;
                a._ishlnsubmul(b, 1, j);
                if (!a.isZero()) a.negative ^= 1;
            }
            if (q) q.words[j] = qj;
        }
        if (q) q._strip();
        a._strip();
        // Denormalize
        if (mode !== "div" && shift !== 0) a.iushrn(shift);
        return {
            div: q || null,
            mod: a
        };
    };
    // NOTE: 1) `mode` can be set to `mod` to request mod only,
    //       to `div` to request div only, or be absent to
    //       request both div & mod
    //       2) `positive` is true if unsigned mod is requested
    BN.prototype.divmod = function divmod(num, mode, positive) {
        assert(!num.isZero());
        if (this.isZero()) return {
            div: new BN(0),
            mod: new BN(0)
        };
        var div, mod, res;
        if (this.negative !== 0 && num.negative === 0) {
            res = this.neg().divmod(num, mode);
            if (mode !== "mod") div = res.div.neg();
            if (mode !== "div") {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.iadd(num);
            }
            return {
                div: div,
                mod: mod
            };
        }
        if (this.negative === 0 && num.negative !== 0) {
            res = this.divmod(num.neg(), mode);
            if (mode !== "mod") div = res.div.neg();
            return {
                div: div,
                mod: res.mod
            };
        }
        if ((this.negative & num.negative) !== 0) {
            res = this.neg().divmod(num.neg(), mode);
            if (mode !== "div") {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.isub(num);
            }
            return {
                div: res.div,
                mod: mod
            };
        }
        // Both numbers are positive at this point
        // Strip both numbers to approximate shift value
        if (num.length > this.length || this.cmp(num) < 0) return {
            div: new BN(0),
            mod: this
        };
        // Very short reduction
        if (num.length === 1) {
            if (mode === "div") return {
                div: this.divn(num.words[0]),
                mod: null
            };
            if (mode === "mod") return {
                div: null,
                mod: new BN(this.modrn(num.words[0]))
            };
            return {
                div: this.divn(num.words[0]),
                mod: new BN(this.modrn(num.words[0]))
            };
        }
        return this._wordDiv(num, mode);
    };
    // Find `this` / `num`
    BN.prototype.div = function div(num) {
        return this.divmod(num, "div", false).div;
    };
    // Find `this` % `num`
    BN.prototype.mod = function mod(num) {
        return this.divmod(num, "mod", false).mod;
    };
    BN.prototype.umod = function umod(num) {
        return this.divmod(num, "mod", true).mod;
    };
    // Find Round(`this` / `num`)
    BN.prototype.divRound = function divRound(num) {
        var dm = this.divmod(num);
        // Fast case - exact division
        if (dm.mod.isZero()) return dm.div;
        var mod = dm.div.negative !== 0 ? dm.mod.isub(num) : dm.mod;
        var half = num.ushrn(1);
        var r2 = num.andln(1);
        var cmp = mod.cmp(half);
        // Round down
        if (cmp < 0 || r2 === 1 && cmp === 0) return dm.div;
        // Round up
        return dm.div.negative !== 0 ? dm.div.isubn(1) : dm.div.iaddn(1);
    };
    BN.prototype.modrn = function modrn(num) {
        var isNegNum = num < 0;
        if (isNegNum) num = -num;
        assert(num <= 0x3ffffff);
        var p = 67108864 % num;
        var acc = 0;
        for(var i = this.length - 1; i >= 0; i--)acc = (p * acc + (this.words[i] | 0)) % num;
        return isNegNum ? -acc : acc;
    };
    // WARNING: DEPRECATED
    BN.prototype.modn = function modn(num) {
        return this.modrn(num);
    };
    // In-place division by number
    BN.prototype.idivn = function idivn(num) {
        var isNegNum = num < 0;
        if (isNegNum) num = -num;
        assert(num <= 0x3ffffff);
        var carry = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var w = (this.words[i] | 0) + carry * 0x4000000;
            this.words[i] = w / num | 0;
            carry = w % num;
        }
        this._strip();
        return isNegNum ? this.ineg() : this;
    };
    BN.prototype.divn = function divn(num) {
        return this.clone().idivn(num);
    };
    BN.prototype.egcd = function egcd(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var x = this;
        var y = p.clone();
        if (x.negative !== 0) x = x.umod(p);
        else x = x.clone();
        // A * x + B * y = x
        var A = new BN(1);
        var B = new BN(0);
        // C * x + D * y = y
        var C = new BN(0);
        var D = new BN(1);
        var g = 0;
        while(x.isEven() && y.isEven()){
            x.iushrn(1);
            y.iushrn(1);
            ++g;
        }
        var yp = y.clone();
        var xp = x.clone();
        while(!x.isZero()){
            for(var i = 0, im = 1; (x.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                x.iushrn(i);
                while(i-- > 0){
                    if (A.isOdd() || B.isOdd()) {
                        A.iadd(yp);
                        B.isub(xp);
                    }
                    A.iushrn(1);
                    B.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (y.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                y.iushrn(j);
                while(j-- > 0){
                    if (C.isOdd() || D.isOdd()) {
                        C.iadd(yp);
                        D.isub(xp);
                    }
                    C.iushrn(1);
                    D.iushrn(1);
                }
            }
            if (x.cmp(y) >= 0) {
                x.isub(y);
                A.isub(C);
                B.isub(D);
            } else {
                y.isub(x);
                C.isub(A);
                D.isub(B);
            }
        }
        return {
            a: C,
            b: D,
            gcd: y.iushln(g)
        };
    };
    // This is reduced incarnation of the binary EEA
    // above, designated to invert members of the
    // _prime_ fields F(p) at a maximal speed
    BN.prototype._invmp = function _invmp(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var a = this;
        var b = p.clone();
        if (a.negative !== 0) a = a.umod(p);
        else a = a.clone();
        var x1 = new BN(1);
        var x2 = new BN(0);
        var delta = b.clone();
        while(a.cmpn(1) > 0 && b.cmpn(1) > 0){
            for(var i = 0, im = 1; (a.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                a.iushrn(i);
                while(i-- > 0){
                    if (x1.isOdd()) x1.iadd(delta);
                    x1.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (b.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                b.iushrn(j);
                while(j-- > 0){
                    if (x2.isOdd()) x2.iadd(delta);
                    x2.iushrn(1);
                }
            }
            if (a.cmp(b) >= 0) {
                a.isub(b);
                x1.isub(x2);
            } else {
                b.isub(a);
                x2.isub(x1);
            }
        }
        var res;
        if (a.cmpn(1) === 0) res = x1;
        else res = x2;
        if (res.cmpn(0) < 0) res.iadd(p);
        return res;
    };
    BN.prototype.gcd = function gcd(num) {
        if (this.isZero()) return num.abs();
        if (num.isZero()) return this.abs();
        var a = this.clone();
        var b = num.clone();
        a.negative = 0;
        b.negative = 0;
        // Remove common factor of two
        for(var shift = 0; a.isEven() && b.isEven(); shift++){
            a.iushrn(1);
            b.iushrn(1);
        }
        do {
            while(a.isEven())a.iushrn(1);
            while(b.isEven())b.iushrn(1);
            var r = a.cmp(b);
            if (r < 0) {
                // Swap `a` and `b` to make `a` always bigger than `b`
                var t = a;
                a = b;
                b = t;
            } else if (r === 0 || b.cmpn(1) === 0) break;
            a.isub(b);
        }while (true);
        return b.iushln(shift);
    };
    // Invert number in the field F(num)
    BN.prototype.invm = function invm(num) {
        return this.egcd(num).a.umod(num);
    };
    BN.prototype.isEven = function isEven() {
        return (this.words[0] & 1) === 0;
    };
    BN.prototype.isOdd = function isOdd() {
        return (this.words[0] & 1) === 1;
    };
    // And first word and num
    BN.prototype.andln = function andln(num) {
        return this.words[0] & num;
    };
    // Increment at the bit position in-line
    BN.prototype.bincn = function bincn(bit) {
        assert(typeof bit === "number");
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) {
            this._expand(s + 1);
            this.words[s] |= q;
            return this;
        }
        // Add bit and propagate, if needed
        var carry = q;
        for(var i = s; carry !== 0 && i < this.length; i++){
            var w = this.words[i] | 0;
            w += carry;
            carry = w >>> 26;
            w &= 0x3ffffff;
            this.words[i] = w;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return this;
    };
    BN.prototype.isZero = function isZero() {
        return this.length === 1 && this.words[0] === 0;
    };
    BN.prototype.cmpn = function cmpn(num) {
        var negative = num < 0;
        if (this.negative !== 0 && !negative) return -1;
        if (this.negative === 0 && negative) return 1;
        this._strip();
        var res;
        if (this.length > 1) res = 1;
        else {
            if (negative) num = -num;
            assert(num <= 0x3ffffff, "Number is too big");
            var w = this.words[0] | 0;
            res = w === num ? 0 : w < num ? -1 : 1;
        }
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Compare two numbers and return:
    // 1 - if `this` > `num`
    // 0 - if `this` == `num`
    // -1 - if `this` < `num`
    BN.prototype.cmp = function cmp(num) {
        if (this.negative !== 0 && num.negative === 0) return -1;
        if (this.negative === 0 && num.negative !== 0) return 1;
        var res = this.ucmp(num);
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Unsigned comparison
    BN.prototype.ucmp = function ucmp(num) {
        // At this point both numbers have the same sign
        if (this.length > num.length) return 1;
        if (this.length < num.length) return -1;
        var res = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var a = this.words[i] | 0;
            var b = num.words[i] | 0;
            if (a === b) continue;
            if (a < b) res = -1;
            else if (a > b) res = 1;
            break;
        }
        return res;
    };
    BN.prototype.gtn = function gtn(num) {
        return this.cmpn(num) === 1;
    };
    BN.prototype.gt = function gt(num) {
        return this.cmp(num) === 1;
    };
    BN.prototype.gten = function gten(num) {
        return this.cmpn(num) >= 0;
    };
    BN.prototype.gte = function gte(num) {
        return this.cmp(num) >= 0;
    };
    BN.prototype.ltn = function ltn(num) {
        return this.cmpn(num) === -1;
    };
    BN.prototype.lt = function lt(num) {
        return this.cmp(num) === -1;
    };
    BN.prototype.lten = function lten(num) {
        return this.cmpn(num) <= 0;
    };
    BN.prototype.lte = function lte(num) {
        return this.cmp(num) <= 0;
    };
    BN.prototype.eqn = function eqn(num) {
        return this.cmpn(num) === 0;
    };
    BN.prototype.eq = function eq(num) {
        return this.cmp(num) === 0;
    };
    //
    // A reduce context, could be using montgomery or something better, depending
    // on the `m` itself.
    //
    BN.red = function red(num) {
        return new Red(num);
    };
    BN.prototype.toRed = function toRed(ctx) {
        assert(!this.red, "Already a number in reduction context");
        assert(this.negative === 0, "red works only with positives");
        return ctx.convertTo(this)._forceRed(ctx);
    };
    BN.prototype.fromRed = function fromRed() {
        assert(this.red, "fromRed works only with numbers in reduction context");
        return this.red.convertFrom(this);
    };
    BN.prototype._forceRed = function _forceRed(ctx) {
        this.red = ctx;
        return this;
    };
    BN.prototype.forceRed = function forceRed(ctx) {
        assert(!this.red, "Already a number in reduction context");
        return this._forceRed(ctx);
    };
    BN.prototype.redAdd = function redAdd(num) {
        assert(this.red, "redAdd works only with red numbers");
        return this.red.add(this, num);
    };
    BN.prototype.redIAdd = function redIAdd(num) {
        assert(this.red, "redIAdd works only with red numbers");
        return this.red.iadd(this, num);
    };
    BN.prototype.redSub = function redSub(num) {
        assert(this.red, "redSub works only with red numbers");
        return this.red.sub(this, num);
    };
    BN.prototype.redISub = function redISub(num) {
        assert(this.red, "redISub works only with red numbers");
        return this.red.isub(this, num);
    };
    BN.prototype.redShl = function redShl(num) {
        assert(this.red, "redShl works only with red numbers");
        return this.red.shl(this, num);
    };
    BN.prototype.redMul = function redMul(num) {
        assert(this.red, "redMul works only with red numbers");
        this.red._verify2(this, num);
        return this.red.mul(this, num);
    };
    BN.prototype.redIMul = function redIMul(num) {
        assert(this.red, "redMul works only with red numbers");
        this.red._verify2(this, num);
        return this.red.imul(this, num);
    };
    BN.prototype.redSqr = function redSqr() {
        assert(this.red, "redSqr works only with red numbers");
        this.red._verify1(this);
        return this.red.sqr(this);
    };
    BN.prototype.redISqr = function redISqr() {
        assert(this.red, "redISqr works only with red numbers");
        this.red._verify1(this);
        return this.red.isqr(this);
    };
    // Square root over p
    BN.prototype.redSqrt = function redSqrt() {
        assert(this.red, "redSqrt works only with red numbers");
        this.red._verify1(this);
        return this.red.sqrt(this);
    };
    BN.prototype.redInvm = function redInvm() {
        assert(this.red, "redInvm works only with red numbers");
        this.red._verify1(this);
        return this.red.invm(this);
    };
    // Return negative clone of `this` % `red modulo`
    BN.prototype.redNeg = function redNeg() {
        assert(this.red, "redNeg works only with red numbers");
        this.red._verify1(this);
        return this.red.neg(this);
    };
    BN.prototype.redPow = function redPow(num) {
        assert(this.red && !num.red, "redPow(normalNum)");
        this.red._verify1(this);
        return this.red.pow(this, num);
    };
    // Prime numbers with efficient reduction
    var primes = {
        k256: null,
        p224: null,
        p192: null,
        p25519: null
    };
    // Pseudo-Mersenne prime
    function MPrime(name, p) {
        // P = 2 ^ N - K
        this.name = name;
        this.p = new BN(p, 16);
        this.n = this.p.bitLength();
        this.k = new BN(1).iushln(this.n).isub(this.p);
        this.tmp = this._tmp();
    }
    MPrime.prototype._tmp = function _tmp() {
        var tmp = new BN(null);
        tmp.words = new Array(Math.ceil(this.n / 13));
        return tmp;
    };
    MPrime.prototype.ireduce = function ireduce(num) {
        // Assumes that `num` is less than `P^2`
        // num = HI * (2 ^ N - K) + HI * K + LO = HI * K + LO (mod P)
        var r = num;
        var rlen;
        do {
            this.split(r, this.tmp);
            r = this.imulK(r);
            r = r.iadd(this.tmp);
            rlen = r.bitLength();
        }while (rlen > this.n);
        var cmp = rlen < this.n ? -1 : r.ucmp(this.p);
        if (cmp === 0) {
            r.words[0] = 0;
            r.length = 1;
        } else if (cmp > 0) r.isub(this.p);
        else if (r.strip !== undefined) // r is a BN v4 instance
        r.strip();
        else // r is a BN v5 instance
        r._strip();
        return r;
    };
    MPrime.prototype.split = function split(input, out) {
        input.iushrn(this.n, 0, out);
    };
    MPrime.prototype.imulK = function imulK(num) {
        return num.imul(this.k);
    };
    function K256() {
        MPrime.call(this, "k256", "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f");
    }
    inherits(K256, MPrime);
    K256.prototype.split = function split(input, output) {
        // 256 = 9 * 26 + 22
        var mask = 0x3fffff;
        var outLen = Math.min(input.length, 9);
        for(var i = 0; i < outLen; i++)output.words[i] = input.words[i];
        output.length = outLen;
        if (input.length <= 9) {
            input.words[0] = 0;
            input.length = 1;
            return;
        }
        // Shift by 9 limbs
        var prev = input.words[9];
        output.words[output.length++] = prev & mask;
        for(i = 10; i < input.length; i++){
            var next = input.words[i] | 0;
            input.words[i - 10] = (next & mask) << 4 | prev >>> 22;
            prev = next;
        }
        prev >>>= 22;
        input.words[i - 10] = prev;
        if (prev === 0 && input.length > 10) input.length -= 10;
        else input.length -= 9;
    };
    K256.prototype.imulK = function imulK(num) {
        // K = 0x1000003d1 = [ 0x40, 0x3d1 ]
        num.words[num.length] = 0;
        num.words[num.length + 1] = 0;
        num.length += 2;
        // bounded at: 0x40 * 0x3ffffff + 0x3d0 = 0x100000390
        var lo = 0;
        for(var i = 0; i < num.length; i++){
            var w = num.words[i] | 0;
            lo += w * 0x3d1;
            num.words[i] = lo & 0x3ffffff;
            lo = w * 0x40 + (lo / 0x4000000 | 0);
        }
        // Fast length reduction
        if (num.words[num.length - 1] === 0) {
            num.length--;
            if (num.words[num.length - 1] === 0) num.length--;
        }
        return num;
    };
    function P224() {
        MPrime.call(this, "p224", "ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001");
    }
    inherits(P224, MPrime);
    function P192() {
        MPrime.call(this, "p192", "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff");
    }
    inherits(P192, MPrime);
    function P25519() {
        // 2 ^ 255 - 19
        MPrime.call(this, "25519", "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed");
    }
    inherits(P25519, MPrime);
    P25519.prototype.imulK = function imulK(num) {
        // K = 0x13
        var carry = 0;
        for(var i = 0; i < num.length; i++){
            var hi = (num.words[i] | 0) * 0x13 + carry;
            var lo = hi & 0x3ffffff;
            hi >>>= 26;
            num.words[i] = lo;
            carry = hi;
        }
        if (carry !== 0) num.words[num.length++] = carry;
        return num;
    };
    // Exported mostly for testing purposes, use plain name instead
    BN._prime = function prime(name) {
        // Cached version of prime
        if (primes[name]) return primes[name];
        var prime;
        if (name === "k256") prime = new K256();
        else if (name === "p224") prime = new P224();
        else if (name === "p192") prime = new P192();
        else if (name === "p25519") prime = new P25519();
        else throw new Error("Unknown prime " + name);
        primes[name] = prime;
        return prime;
    };
    //
    // Base reduction engine
    //
    function Red(m) {
        if (typeof m === "string") {
            var prime = BN._prime(m);
            this.m = prime.p;
            this.prime = prime;
        } else {
            assert(m.gtn(1), "modulus must be greater than 1");
            this.m = m;
            this.prime = null;
        }
    }
    Red.prototype._verify1 = function _verify1(a) {
        assert(a.negative === 0, "red works only with positives");
        assert(a.red, "red works only with red numbers");
    };
    Red.prototype._verify2 = function _verify2(a, b) {
        assert((a.negative | b.negative) === 0, "red works only with positives");
        assert(a.red && a.red === b.red, "red works only with red numbers");
    };
    Red.prototype.imod = function imod(a) {
        if (this.prime) return this.prime.ireduce(a)._forceRed(this);
        move(a, a.umod(this.m)._forceRed(this));
        return a;
    };
    Red.prototype.neg = function neg(a) {
        if (a.isZero()) return a.clone();
        return this.m.sub(a)._forceRed(this);
    };
    Red.prototype.add = function add(a, b) {
        this._verify2(a, b);
        var res = a.add(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res._forceRed(this);
    };
    Red.prototype.iadd = function iadd(a, b) {
        this._verify2(a, b);
        var res = a.iadd(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res;
    };
    Red.prototype.sub = function sub(a, b) {
        this._verify2(a, b);
        var res = a.sub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res._forceRed(this);
    };
    Red.prototype.isub = function isub(a, b) {
        this._verify2(a, b);
        var res = a.isub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res;
    };
    Red.prototype.shl = function shl(a, num) {
        this._verify1(a);
        return this.imod(a.ushln(num));
    };
    Red.prototype.imul = function imul(a, b) {
        this._verify2(a, b);
        return this.imod(a.imul(b));
    };
    Red.prototype.mul = function mul(a, b) {
        this._verify2(a, b);
        return this.imod(a.mul(b));
    };
    Red.prototype.isqr = function isqr(a) {
        return this.imul(a, a.clone());
    };
    Red.prototype.sqr = function sqr(a) {
        return this.mul(a, a);
    };
    Red.prototype.sqrt = function sqrt(a) {
        if (a.isZero()) return a.clone();
        var mod3 = this.m.andln(3);
        assert(mod3 % 2 === 1);
        // Fast case
        if (mod3 === 3) {
            var pow = this.m.add(new BN(1)).iushrn(2);
            return this.pow(a, pow);
        }
        // Tonelli-Shanks algorithm (Totally unoptimized and slow)
        //
        // Find Q and S, that Q * 2 ^ S = (P - 1)
        var q = this.m.subn(1);
        var s = 0;
        while(!q.isZero() && q.andln(1) === 0){
            s++;
            q.iushrn(1);
        }
        assert(!q.isZero());
        var one = new BN(1).toRed(this);
        var nOne = one.redNeg();
        // Find quadratic non-residue
        // NOTE: Max is such because of generalized Riemann hypothesis.
        var lpow = this.m.subn(1).iushrn(1);
        var z = this.m.bitLength();
        z = new BN(2 * z * z).toRed(this);
        while(this.pow(z, lpow).cmp(nOne) !== 0)z.redIAdd(nOne);
        var c = this.pow(z, q);
        var r = this.pow(a, q.addn(1).iushrn(1));
        var t = this.pow(a, q);
        var m = s;
        while(t.cmp(one) !== 0){
            var tmp = t;
            for(var i = 0; tmp.cmp(one) !== 0; i++)tmp = tmp.redSqr();
            assert(i < m);
            var b = this.pow(c, new BN(1).iushln(m - i - 1));
            r = r.redMul(b);
            c = b.redSqr();
            t = t.redMul(c);
            m = i;
        }
        return r;
    };
    Red.prototype.invm = function invm(a) {
        var inv = a._invmp(this.m);
        if (inv.negative !== 0) {
            inv.negative = 0;
            return this.imod(inv).redNeg();
        } else return this.imod(inv);
    };
    Red.prototype.pow = function pow(a, num) {
        if (num.isZero()) return new BN(1).toRed(this);
        if (num.cmpn(1) === 0) return a.clone();
        var windowSize = 4;
        var wnd = new Array(1 << windowSize);
        wnd[0] = new BN(1).toRed(this);
        wnd[1] = a;
        for(var i = 2; i < wnd.length; i++)wnd[i] = this.mul(wnd[i - 1], a);
        var res = wnd[0];
        var current = 0;
        var currentLen = 0;
        var start = num.bitLength() % 26;
        if (start === 0) start = 26;
        for(i = num.length - 1; i >= 0; i--){
            var word = num.words[i];
            for(var j = start - 1; j >= 0; j--){
                var bit = word >> j & 1;
                if (res !== wnd[0]) res = this.sqr(res);
                if (bit === 0 && current === 0) {
                    currentLen = 0;
                    continue;
                }
                current <<= 1;
                current |= bit;
                currentLen++;
                if (currentLen !== windowSize && (i !== 0 || j !== 0)) continue;
                res = this.mul(res, wnd[current]);
                currentLen = 0;
                current = 0;
            }
            start = 26;
        }
        return res;
    };
    Red.prototype.convertTo = function convertTo(num) {
        var r = num.umod(this.m);
        return r === num ? r.clone() : r;
    };
    Red.prototype.convertFrom = function convertFrom(num) {
        var res = num.clone();
        res.red = null;
        return res;
    };
    //
    // Montgomery method engine
    //
    BN.mont = function mont(num) {
        return new Mont(num);
    };
    function Mont(m) {
        Red.call(this, m);
        this.shift = this.m.bitLength();
        if (this.shift % 26 !== 0) this.shift += 26 - this.shift % 26;
        this.r = new BN(1).iushln(this.shift);
        this.r2 = this.imod(this.r.sqr());
        this.rinv = this.r._invmp(this.m);
        this.minv = this.rinv.mul(this.r).isubn(1).div(this.m);
        this.minv = this.minv.umod(this.r);
        this.minv = this.r.sub(this.minv);
    }
    inherits(Mont, Red);
    Mont.prototype.convertTo = function convertTo(num) {
        return this.imod(num.ushln(this.shift));
    };
    Mont.prototype.convertFrom = function convertFrom(num) {
        var r = this.imod(num.mul(this.rinv));
        r.red = null;
        return r;
    };
    Mont.prototype.imul = function imul(a, b) {
        if (a.isZero() || b.isZero()) {
            a.words[0] = 0;
            a.length = 1;
            return a;
        }
        var t = a.imul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.mul = function mul(a, b) {
        if (a.isZero() || b.isZero()) return new BN(0)._forceRed(this);
        var t = a.mul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.invm = function invm(a) {
        // (AR)^-1 * R^2 = (A^-1 * R^-1) * R^2 = A^-1 * R
        var res = this.imod(a._invmp(this.m).mul(this.r2));
        return res._forceRed(this);
    };
})(module, this);

});

parcelRequire.register("fQBv0", function(module, exports) {
// minimal library entry point.
"use strict";

module.exports = (parcelRequire("lgkiq"));

});
parcelRequire.register("lgkiq", function(module, exports) {
"use strict";
var $f7aad5fe2e4466b7$var$protobuf = module.exports;
/**
 * Build type, one of `"full"`, `"light"` or `"minimal"`.
 * @name build
 * @type {string}
 * @const
 */ $f7aad5fe2e4466b7$var$protobuf.build = "minimal";

// Serialization
$f7aad5fe2e4466b7$var$protobuf.Writer = (parcelRequire("73ZlY"));

$f7aad5fe2e4466b7$var$protobuf.BufferWriter = (parcelRequire("6oXFW"));

$f7aad5fe2e4466b7$var$protobuf.Reader = (parcelRequire("jNsDJ"));

$f7aad5fe2e4466b7$var$protobuf.BufferReader = (parcelRequire("kDrIk"));

// Utility
$f7aad5fe2e4466b7$var$protobuf.util = (parcelRequire("fK14h"));

$f7aad5fe2e4466b7$var$protobuf.rpc = (parcelRequire("cFFQd"));

$f7aad5fe2e4466b7$var$protobuf.roots = (parcelRequire("eFuHd"));
$f7aad5fe2e4466b7$var$protobuf.configure = $f7aad5fe2e4466b7$var$configure;
/* istanbul ignore next */ /**
 * Reconfigures the library according to the environment.
 * @returns {undefined}
 */ function $f7aad5fe2e4466b7$var$configure() {
    $f7aad5fe2e4466b7$var$protobuf.util._configure();
    $f7aad5fe2e4466b7$var$protobuf.Writer._configure($f7aad5fe2e4466b7$var$protobuf.BufferWriter);
    $f7aad5fe2e4466b7$var$protobuf.Reader._configure($f7aad5fe2e4466b7$var$protobuf.BufferReader);
}
// Set up buffer utility according to the environment
$f7aad5fe2e4466b7$var$configure();

});
parcelRequire.register("73ZlY", function(module, exports) {
"use strict";
module.exports = $524867ba9b208546$var$Writer;

var $fK14h = parcelRequire("fK14h");
var $524867ba9b208546$var$BufferWriter; // cyclic
var $524867ba9b208546$var$LongBits = $fK14h.LongBits, $524867ba9b208546$var$base64 = $fK14h.base64, $524867ba9b208546$var$utf8 = $fK14h.utf8;
/**
 * Constructs a new writer operation instance.
 * @classdesc Scheduled writer operation.
 * @constructor
 * @param {function(*, Uint8Array, number)} fn Function to call
 * @param {number} len Value byte length
 * @param {*} val Value to write
 * @ignore
 */ function $524867ba9b208546$var$Op(fn, len, val) {
    /**
     * Function to call.
     * @type {function(Uint8Array, number, *)}
     */ this.fn = fn;
    /**
     * Value byte length.
     * @type {number}
     */ this.len = len;
    /**
     * Next operation.
     * @type {Writer.Op|undefined}
     */ this.next = undefined;
    /**
     * Value to write.
     * @type {*}
     */ this.val = val; // type varies
}
/* istanbul ignore next */ function $524867ba9b208546$var$noop() {} // eslint-disable-line no-empty-function
/**
 * Constructs a new writer state instance.
 * @classdesc Copied writer state.
 * @memberof Writer
 * @constructor
 * @param {Writer} writer Writer to copy state from
 * @ignore
 */ function $524867ba9b208546$var$State(writer) {
    /**
     * Current head.
     * @type {Writer.Op}
     */ this.head = writer.head;
    /**
     * Current tail.
     * @type {Writer.Op}
     */ this.tail = writer.tail;
    /**
     * Current buffer length.
     * @type {number}
     */ this.len = writer.len;
    /**
     * Next state.
     * @type {State|null}
     */ this.next = writer.states;
}
/**
 * Constructs a new writer instance.
 * @classdesc Wire format writer using `Uint8Array` if available, otherwise `Array`.
 * @constructor
 */ function $524867ba9b208546$var$Writer() {
    /**
     * Current length.
     * @type {number}
     */ this.len = 0;
    /**
     * Operations head.
     * @type {Object}
     */ this.head = new $524867ba9b208546$var$Op($524867ba9b208546$var$noop, 0, 0);
    /**
     * Operations tail
     * @type {Object}
     */ this.tail = this.head;
    /**
     * Linked forked states.
     * @type {Object|null}
     */ this.states = null;
// When a value is written, the writer calculates its byte length and puts it into a linked
// list of operations to perform when finish() is called. This both allows us to allocate
// buffers of the exact required size and reduces the amount of work we have to do compared
// to first calculating over objects and then encoding over objects. In our case, the encoding
// part is just a linked list walk calling operations with already prepared values.
}
var $524867ba9b208546$var$create = function create() {
    return $fK14h.Buffer ? function create_buffer_setup() {
        return ($524867ba9b208546$var$Writer.create = function create_buffer() {
            return new $524867ba9b208546$var$BufferWriter();
        })();
    } : function create_array() {
        return new $524867ba9b208546$var$Writer();
    };
};
/**
 * Creates a new writer.
 * @function
 * @returns {BufferWriter|Writer} A {@link BufferWriter} when Buffers are supported, otherwise a {@link Writer}
 */ $524867ba9b208546$var$Writer.create = $524867ba9b208546$var$create();
/**
 * Allocates a buffer of the specified size.
 * @param {number} size Buffer size
 * @returns {Uint8Array} Buffer
 */ $524867ba9b208546$var$Writer.alloc = function alloc(size) {
    return new $fK14h.Array(size);
};
// Use Uint8Array buffer pool in the browser, just like node does with buffers
/* istanbul ignore else */ if ($fK14h.Array !== Array) $524867ba9b208546$var$Writer.alloc = $fK14h.pool($524867ba9b208546$var$Writer.alloc, $fK14h.Array.prototype.subarray);
/**
 * Pushes a new operation to the queue.
 * @param {function(Uint8Array, number, *)} fn Function to call
 * @param {number} len Value byte length
 * @param {number} val Value to write
 * @returns {Writer} `this`
 * @private
 */ $524867ba9b208546$var$Writer.prototype._push = function push(fn, len, val) {
    this.tail = this.tail.next = new $524867ba9b208546$var$Op(fn, len, val);
    this.len += len;
    return this;
};
function $524867ba9b208546$var$writeByte(val, buf, pos) {
    buf[pos] = val & 255;
}
function $524867ba9b208546$var$writeVarint32(val, buf, pos) {
    while(val > 127){
        buf[pos++] = val & 127 | 128;
        val >>>= 7;
    }
    buf[pos] = val;
}
/**
 * Constructs a new varint writer operation instance.
 * @classdesc Scheduled varint writer operation.
 * @extends Op
 * @constructor
 * @param {number} len Value byte length
 * @param {number} val Value to write
 * @ignore
 */ function $524867ba9b208546$var$VarintOp(len, val) {
    this.len = len;
    this.next = undefined;
    this.val = val;
}
$524867ba9b208546$var$VarintOp.prototype = Object.create($524867ba9b208546$var$Op.prototype);
$524867ba9b208546$var$VarintOp.prototype.fn = $524867ba9b208546$var$writeVarint32;
/**
 * Writes an unsigned 32 bit value as a varint.
 * @param {number} value Value to write
 * @returns {Writer} `this`
 */ $524867ba9b208546$var$Writer.prototype.uint32 = function write_uint32(value) {
    // here, the call to this.push has been inlined and a varint specific Op subclass is used.
    // uint32 is by far the most frequently used operation and benefits significantly from this.
    this.len += (this.tail = this.tail.next = new $524867ba9b208546$var$VarintOp((value = value >>> 0) < 128 ? 1 : value < 16384 ? 2 : value < 2097152 ? 3 : value < 268435456 ? 4 : 5, value)).len;
    return this;
};
/**
 * Writes a signed 32 bit value as a varint.
 * @function
 * @param {number} value Value to write
 * @returns {Writer} `this`
 */ $524867ba9b208546$var$Writer.prototype.int32 = function write_int32(value) {
    return value < 0 ? this._push($524867ba9b208546$var$writeVarint64, 10, $524867ba9b208546$var$LongBits.fromNumber(value)) // 10 bytes per spec
     : this.uint32(value);
};
/**
 * Writes a 32 bit value as a varint, zig-zag encoded.
 * @param {number} value Value to write
 * @returns {Writer} `this`
 */ $524867ba9b208546$var$Writer.prototype.sint32 = function write_sint32(value) {
    return this.uint32((value << 1 ^ value >> 31) >>> 0);
};
function $524867ba9b208546$var$writeVarint64(val, buf, pos) {
    while(val.hi){
        buf[pos++] = val.lo & 127 | 128;
        val.lo = (val.lo >>> 7 | val.hi << 25) >>> 0;
        val.hi >>>= 7;
    }
    while(val.lo > 127){
        buf[pos++] = val.lo & 127 | 128;
        val.lo = val.lo >>> 7;
    }
    buf[pos++] = val.lo;
}
/**
 * Writes an unsigned 64 bit value as a varint.
 * @param {Long|number|string} value Value to write
 * @returns {Writer} `this`
 * @throws {TypeError} If `value` is a string and no long library is present.
 */ $524867ba9b208546$var$Writer.prototype.uint64 = function write_uint64(value) {
    var bits = $524867ba9b208546$var$LongBits.from(value);
    return this._push($524867ba9b208546$var$writeVarint64, bits.length(), bits);
};
/**
 * Writes a signed 64 bit value as a varint.
 * @function
 * @param {Long|number|string} value Value to write
 * @returns {Writer} `this`
 * @throws {TypeError} If `value` is a string and no long library is present.
 */ $524867ba9b208546$var$Writer.prototype.int64 = $524867ba9b208546$var$Writer.prototype.uint64;
/**
 * Writes a signed 64 bit value as a varint, zig-zag encoded.
 * @param {Long|number|string} value Value to write
 * @returns {Writer} `this`
 * @throws {TypeError} If `value` is a string and no long library is present.
 */ $524867ba9b208546$var$Writer.prototype.sint64 = function write_sint64(value) {
    var bits = $524867ba9b208546$var$LongBits.from(value).zzEncode();
    return this._push($524867ba9b208546$var$writeVarint64, bits.length(), bits);
};
/**
 * Writes a boolish value as a varint.
 * @param {boolean} value Value to write
 * @returns {Writer} `this`
 */ $524867ba9b208546$var$Writer.prototype.bool = function write_bool(value) {
    return this._push($524867ba9b208546$var$writeByte, 1, value ? 1 : 0);
};
function $524867ba9b208546$var$writeFixed32(val, buf, pos) {
    buf[pos] = val & 255;
    buf[pos + 1] = val >>> 8 & 255;
    buf[pos + 2] = val >>> 16 & 255;
    buf[pos + 3] = val >>> 24;
}
/**
 * Writes an unsigned 32 bit value as fixed 32 bits.
 * @param {number} value Value to write
 * @returns {Writer} `this`
 */ $524867ba9b208546$var$Writer.prototype.fixed32 = function write_fixed32(value) {
    return this._push($524867ba9b208546$var$writeFixed32, 4, value >>> 0);
};
/**
 * Writes a signed 32 bit value as fixed 32 bits.
 * @function
 * @param {number} value Value to write
 * @returns {Writer} `this`
 */ $524867ba9b208546$var$Writer.prototype.sfixed32 = $524867ba9b208546$var$Writer.prototype.fixed32;
/**
 * Writes an unsigned 64 bit value as fixed 64 bits.
 * @param {Long|number|string} value Value to write
 * @returns {Writer} `this`
 * @throws {TypeError} If `value` is a string and no long library is present.
 */ $524867ba9b208546$var$Writer.prototype.fixed64 = function write_fixed64(value) {
    var bits = $524867ba9b208546$var$LongBits.from(value);
    return this._push($524867ba9b208546$var$writeFixed32, 4, bits.lo)._push($524867ba9b208546$var$writeFixed32, 4, bits.hi);
};
/**
 * Writes a signed 64 bit value as fixed 64 bits.
 * @function
 * @param {Long|number|string} value Value to write
 * @returns {Writer} `this`
 * @throws {TypeError} If `value` is a string and no long library is present.
 */ $524867ba9b208546$var$Writer.prototype.sfixed64 = $524867ba9b208546$var$Writer.prototype.fixed64;
/**
 * Writes a float (32 bit).
 * @function
 * @param {number} value Value to write
 * @returns {Writer} `this`
 */ $524867ba9b208546$var$Writer.prototype.float = function write_float(value) {
    return this._push($fK14h.float.writeFloatLE, 4, value);
};
/**
 * Writes a double (64 bit float).
 * @function
 * @param {number} value Value to write
 * @returns {Writer} `this`
 */ $524867ba9b208546$var$Writer.prototype.double = function write_double(value) {
    return this._push($fK14h.float.writeDoubleLE, 8, value);
};
var $524867ba9b208546$var$writeBytes = $fK14h.Array.prototype.set ? function writeBytes_set(val, buf, pos) {
    buf.set(val, pos); // also works for plain array values
} : function writeBytes_for(val, buf, pos) {
    for(var i = 0; i < val.length; ++i)buf[pos + i] = val[i];
};
/**
 * Writes a sequence of bytes.
 * @param {Uint8Array|string} value Buffer or base64 encoded string to write
 * @returns {Writer} `this`
 */ $524867ba9b208546$var$Writer.prototype.bytes = function write_bytes(value) {
    var len = value.length >>> 0;
    if (!len) return this._push($524867ba9b208546$var$writeByte, 1, 0);
    if ($fK14h.isString(value)) {
        var buf = $524867ba9b208546$var$Writer.alloc(len = $524867ba9b208546$var$base64.length(value));
        $524867ba9b208546$var$base64.decode(value, buf, 0);
        value = buf;
    }
    return this.uint32(len)._push($524867ba9b208546$var$writeBytes, len, value);
};
/**
 * Writes a string.
 * @param {string} value Value to write
 * @returns {Writer} `this`
 */ $524867ba9b208546$var$Writer.prototype.string = function write_string(value) {
    var len = $524867ba9b208546$var$utf8.length(value);
    return len ? this.uint32(len)._push($524867ba9b208546$var$utf8.write, len, value) : this._push($524867ba9b208546$var$writeByte, 1, 0);
};
/**
 * Forks this writer's state by pushing it to a stack.
 * Calling {@link Writer#reset|reset} or {@link Writer#ldelim|ldelim} resets the writer to the previous state.
 * @returns {Writer} `this`
 */ $524867ba9b208546$var$Writer.prototype.fork = function fork() {
    this.states = new $524867ba9b208546$var$State(this);
    this.head = this.tail = new $524867ba9b208546$var$Op($524867ba9b208546$var$noop, 0, 0);
    this.len = 0;
    return this;
};
/**
 * Resets this instance to the last state.
 * @returns {Writer} `this`
 */ $524867ba9b208546$var$Writer.prototype.reset = function reset() {
    if (this.states) {
        this.head = this.states.head;
        this.tail = this.states.tail;
        this.len = this.states.len;
        this.states = this.states.next;
    } else {
        this.head = this.tail = new $524867ba9b208546$var$Op($524867ba9b208546$var$noop, 0, 0);
        this.len = 0;
    }
    return this;
};
/**
 * Resets to the last state and appends the fork state's current write length as a varint followed by its operations.
 * @returns {Writer} `this`
 */ $524867ba9b208546$var$Writer.prototype.ldelim = function ldelim() {
    var head = this.head, tail = this.tail, len = this.len;
    this.reset().uint32(len);
    if (len) {
        this.tail.next = head.next; // skip noop
        this.tail = tail;
        this.len += len;
    }
    return this;
};
/**
 * Finishes the write operation.
 * @returns {Uint8Array} Finished buffer
 */ $524867ba9b208546$var$Writer.prototype.finish = function finish() {
    var head = this.head.next, buf = this.constructor.alloc(this.len), pos = 0;
    while(head){
        head.fn(head.val, buf, pos);
        pos += head.len;
        head = head.next;
    }
    // this.head = this.tail = null;
    return buf;
};
$524867ba9b208546$var$Writer._configure = function(BufferWriter_) {
    $524867ba9b208546$var$BufferWriter = BufferWriter_;
    $524867ba9b208546$var$Writer.create = $524867ba9b208546$var$create();
    $524867ba9b208546$var$BufferWriter._configure();
};

});
parcelRequire.register("fK14h", function(module, exports) {
"use strict";
var $b75bfaf55b32d107$var$util = module.exports;

// used to return a Promise where callback is omitted
$b75bfaf55b32d107$var$util.asPromise = (parcelRequire("4kb80"));

// converts to / from base64 encoded strings
$b75bfaf55b32d107$var$util.base64 = (parcelRequire("1U6dm"));

// base class of rpc.Service
$b75bfaf55b32d107$var$util.EventEmitter = (parcelRequire("4BOh8"));

// float handling accross browsers
$b75bfaf55b32d107$var$util.float = (parcelRequire("fQJez"));

// requires modules optionally and hides the call from bundlers
$b75bfaf55b32d107$var$util.inquire = (parcelRequire("8PAo2"));

// converts to / from utf8 encoded strings
$b75bfaf55b32d107$var$util.utf8 = (parcelRequire("lgVql"));

// provides a node-like buffer pool in the browser
$b75bfaf55b32d107$var$util.pool = (parcelRequire("g3IvT"));

// utility to work with the low and high bits of a 64 bit value
$b75bfaf55b32d107$var$util.LongBits = (parcelRequire("bDI60"));
/**
 * Whether running within node or not.
 * @memberof util
 * @type {boolean}
 */ $b75bfaf55b32d107$var$util.isNode = Boolean(typeof $parcel$global !== "undefined" && $parcel$global && $parcel$global.process && $parcel$global.process.versions && $parcel$global.process.versions.node);
/**
 * Global object reference.
 * @memberof util
 * @type {Object}
 */ $b75bfaf55b32d107$var$util.global = $b75bfaf55b32d107$var$util.isNode && $parcel$global || typeof window !== "undefined" && window || typeof self !== "undefined" && self || module.exports; // eslint-disable-line no-invalid-this
/**
 * An immuable empty array.
 * @memberof util
 * @type {Array.<*>}
 * @const
 */ $b75bfaf55b32d107$var$util.emptyArray = Object.freeze ? Object.freeze([]) : /* istanbul ignore next */ []; // used on prototypes
/**
 * An immutable empty object.
 * @type {Object}
 * @const
 */ $b75bfaf55b32d107$var$util.emptyObject = Object.freeze ? Object.freeze({}) : /* istanbul ignore next */ {}; // used on prototypes
/**
 * Tests if the specified value is an integer.
 * @function
 * @param {*} value Value to test
 * @returns {boolean} `true` if the value is an integer
 */ $b75bfaf55b32d107$var$util.isInteger = Number.isInteger || /* istanbul ignore next */ function isInteger(value) {
    return typeof value === "number" && isFinite(value) && Math.floor(value) === value;
};
/**
 * Tests if the specified value is a string.
 * @param {*} value Value to test
 * @returns {boolean} `true` if the value is a string
 */ $b75bfaf55b32d107$var$util.isString = function isString(value) {
    return typeof value === "string" || value instanceof String;
};
/**
 * Tests if the specified value is a non-null object.
 * @param {*} value Value to test
 * @returns {boolean} `true` if the value is a non-null object
 */ $b75bfaf55b32d107$var$util.isObject = function isObject(value) {
    return value && typeof value === "object";
};
/**
 * Checks if a property on a message is considered to be present.
 * This is an alias of {@link util.isSet}.
 * @function
 * @param {Object} obj Plain object or message instance
 * @param {string} prop Property name
 * @returns {boolean} `true` if considered to be present, otherwise `false`
 */ $b75bfaf55b32d107$var$util.isset = /**
 * Checks if a property on a message is considered to be present.
 * @param {Object} obj Plain object or message instance
 * @param {string} prop Property name
 * @returns {boolean} `true` if considered to be present, otherwise `false`
 */ $b75bfaf55b32d107$var$util.isSet = function isSet(obj, prop) {
    var value = obj[prop];
    if (value != null && obj.hasOwnProperty(prop)) return typeof value !== "object" || (Array.isArray(value) ? value.length : Object.keys(value).length) > 0;
    return false;
};
/**
 * Any compatible Buffer instance.
 * This is a minimal stand-alone definition of a Buffer instance. The actual type is that exported by node's typings.
 * @interface Buffer
 * @extends Uint8Array
 */ /**
 * Node's Buffer class if available.
 * @type {Constructor<Buffer>}
 */ $b75bfaf55b32d107$var$util.Buffer = function() {
    try {
        var Buffer = $b75bfaf55b32d107$var$util.inquire("buffer").Buffer;
        // refuse to use non-node buffers if not explicitly assigned (perf reasons):
        return Buffer.prototype.utf8Write ? Buffer : /* istanbul ignore next */ null;
    } catch (e) {
        /* istanbul ignore next */ return null;
    }
}();
// Internal alias of or polyfull for Buffer.from.
$b75bfaf55b32d107$var$util._Buffer_from = null;
// Internal alias of or polyfill for Buffer.allocUnsafe.
$b75bfaf55b32d107$var$util._Buffer_allocUnsafe = null;
/**
 * Creates a new buffer of whatever type supported by the environment.
 * @param {number|number[]} [sizeOrArray=0] Buffer size or number array
 * @returns {Uint8Array|Buffer} Buffer
 */ $b75bfaf55b32d107$var$util.newBuffer = function newBuffer(sizeOrArray) {
    /* istanbul ignore next */ return typeof sizeOrArray === "number" ? $b75bfaf55b32d107$var$util.Buffer ? $b75bfaf55b32d107$var$util._Buffer_allocUnsafe(sizeOrArray) : new $b75bfaf55b32d107$var$util.Array(sizeOrArray) : $b75bfaf55b32d107$var$util.Buffer ? $b75bfaf55b32d107$var$util._Buffer_from(sizeOrArray) : typeof Uint8Array === "undefined" ? sizeOrArray : new Uint8Array(sizeOrArray);
};
/**
 * Array implementation used in the browser. `Uint8Array` if supported, otherwise `Array`.
 * @type {Constructor<Uint8Array>}
 */ $b75bfaf55b32d107$var$util.Array = typeof Uint8Array !== "undefined" ? Uint8Array /* istanbul ignore next */  : Array;
/**
 * Any compatible Long instance.
 * This is a minimal stand-alone definition of a Long instance. The actual type is that exported by long.js.
 * @interface Long
 * @property {number} low Low bits
 * @property {number} high High bits
 * @property {boolean} unsigned Whether unsigned or not
 */ /**
 * Long.js's Long class if available.
 * @type {Constructor<Long>}
 */ $b75bfaf55b32d107$var$util.Long = /* istanbul ignore next */ $b75bfaf55b32d107$var$util.global.dcodeIO && /* istanbul ignore next */ $b75bfaf55b32d107$var$util.global.dcodeIO.Long || /* istanbul ignore next */ $b75bfaf55b32d107$var$util.global.Long || $b75bfaf55b32d107$var$util.inquire("long");
/**
 * Regular expression used to verify 2 bit (`bool`) map keys.
 * @type {RegExp}
 * @const
 */ $b75bfaf55b32d107$var$util.key2Re = /^true|false|0|1$/;
/**
 * Regular expression used to verify 32 bit (`int32` etc.) map keys.
 * @type {RegExp}
 * @const
 */ $b75bfaf55b32d107$var$util.key32Re = /^-?(?:0|[1-9][0-9]*)$/;
/**
 * Regular expression used to verify 64 bit (`int64` etc.) map keys.
 * @type {RegExp}
 * @const
 */ $b75bfaf55b32d107$var$util.key64Re = /^(?:[\\x00-\\xff]{8}|-?(?:0|[1-9][0-9]*))$/;
/**
 * Converts a number or long to an 8 characters long hash string.
 * @param {Long|number} value Value to convert
 * @returns {string} Hash
 */ $b75bfaf55b32d107$var$util.longToHash = function longToHash(value) {
    return value ? $b75bfaf55b32d107$var$util.LongBits.from(value).toHash() : $b75bfaf55b32d107$var$util.LongBits.zeroHash;
};
/**
 * Converts an 8 characters long hash string to a long or number.
 * @param {string} hash Hash
 * @param {boolean} [unsigned=false] Whether unsigned or not
 * @returns {Long|number} Original value
 */ $b75bfaf55b32d107$var$util.longFromHash = function longFromHash(hash, unsigned) {
    var bits = $b75bfaf55b32d107$var$util.LongBits.fromHash(hash);
    if ($b75bfaf55b32d107$var$util.Long) return $b75bfaf55b32d107$var$util.Long.fromBits(bits.lo, bits.hi, unsigned);
    return bits.toNumber(Boolean(unsigned));
};
/**
 * Merges the properties of the source object into the destination object.
 * @memberof util
 * @param {Object.<string,*>} dst Destination object
 * @param {Object.<string,*>} src Source object
 * @param {boolean} [ifNotSet=false] Merges only if the key is not already set
 * @returns {Object.<string,*>} Destination object
 */ function $b75bfaf55b32d107$var$merge(dst, src, ifNotSet) {
    for(var keys = Object.keys(src), i = 0; i < keys.length; ++i)if (dst[keys[i]] === undefined || !ifNotSet) dst[keys[i]] = src[keys[i]];
    return dst;
}
$b75bfaf55b32d107$var$util.merge = $b75bfaf55b32d107$var$merge;
/**
 * Converts the first character of a string to lower case.
 * @param {string} str String to convert
 * @returns {string} Converted string
 */ $b75bfaf55b32d107$var$util.lcFirst = function lcFirst(str) {
    return str.charAt(0).toLowerCase() + str.substring(1);
};
/**
 * Creates a custom error constructor.
 * @memberof util
 * @param {string} name Error name
 * @returns {Constructor<Error>} Custom error constructor
 */ function $b75bfaf55b32d107$var$newError(name) {
    function CustomError(message, properties) {
        if (!(this instanceof CustomError)) return new CustomError(message, properties);
        // Error.call(this, message);
        // ^ just returns a new error instance because the ctor can be called as a function
        Object.defineProperty(this, "message", {
            get: function() {
                return message;
            }
        });
        /* istanbul ignore next */ if (Error.captureStackTrace) Error.captureStackTrace(this, CustomError);
        else Object.defineProperty(this, "stack", {
            value: new Error().stack || ""
        });
        if (properties) $b75bfaf55b32d107$var$merge(this, properties);
    }
    (CustomError.prototype = Object.create(Error.prototype)).constructor = CustomError;
    Object.defineProperty(CustomError.prototype, "name", {
        get: function() {
            return name;
        }
    });
    CustomError.prototype.toString = function toString() {
        return this.name + ": " + this.message;
    };
    return CustomError;
}
$b75bfaf55b32d107$var$util.newError = $b75bfaf55b32d107$var$newError;
/**
 * Constructs a new protocol error.
 * @classdesc Error subclass indicating a protocol specifc error.
 * @memberof util
 * @extends Error
 * @template T extends Message<T>
 * @constructor
 * @param {string} message Error message
 * @param {Object.<string,*>} [properties] Additional properties
 * @example
 * try {
 *     MyMessage.decode(someBuffer); // throws if required fields are missing
 * } catch (e) {
 *     if (e instanceof ProtocolError && e.instance)
 *         console.log("decoded so far: " + JSON.stringify(e.instance));
 * }
 */ $b75bfaf55b32d107$var$util.ProtocolError = $b75bfaf55b32d107$var$newError("ProtocolError");
/**
 * So far decoded message instance.
 * @name util.ProtocolError#instance
 * @type {Message<T>}
 */ /**
 * A OneOf getter as returned by {@link util.oneOfGetter}.
 * @typedef OneOfGetter
 * @type {function}
 * @returns {string|undefined} Set field name, if any
 */ /**
 * Builds a getter for a oneof's present field name.
 * @param {string[]} fieldNames Field names
 * @returns {OneOfGetter} Unbound getter
 */ $b75bfaf55b32d107$var$util.oneOfGetter = function getOneOf(fieldNames) {
    var fieldMap = {};
    for(var i = 0; i < fieldNames.length; ++i)fieldMap[fieldNames[i]] = 1;
    /**
     * @returns {string|undefined} Set field name, if any
     * @this Object
     * @ignore
     */ return function() {
        for(var keys = Object.keys(this), i = keys.length - 1; i > -1; --i)if (fieldMap[keys[i]] === 1 && this[keys[i]] !== undefined && this[keys[i]] !== null) return keys[i];
    };
};
/**
 * A OneOf setter as returned by {@link util.oneOfSetter}.
 * @typedef OneOfSetter
 * @type {function}
 * @param {string|undefined} value Field name
 * @returns {undefined}
 */ /**
 * Builds a setter for a oneof's present field name.
 * @param {string[]} fieldNames Field names
 * @returns {OneOfSetter} Unbound setter
 */ $b75bfaf55b32d107$var$util.oneOfSetter = function setOneOf(fieldNames) {
    /**
     * @param {string} name Field name
     * @returns {undefined}
     * @this Object
     * @ignore
     */ return function(name) {
        for(var i = 0; i < fieldNames.length; ++i)if (fieldNames[i] !== name) delete this[fieldNames[i]];
    };
};
/**
 * Default conversion options used for {@link Message#toJSON} implementations.
 *
 * These options are close to proto3's JSON mapping with the exception that internal types like Any are handled just like messages. More precisely:
 *
 * - Longs become strings
 * - Enums become string keys
 * - Bytes become base64 encoded strings
 * - (Sub-)Messages become plain objects
 * - Maps become plain objects with all string keys
 * - Repeated fields become arrays
 * - NaN and Infinity for float and double fields become strings
 *
 * @type {IConversionOptions}
 * @see https://developers.google.com/protocol-buffers/docs/proto3?hl=en#json
 */ $b75bfaf55b32d107$var$util.toJSONOptions = {
    longs: String,
    enums: String,
    bytes: String,
    json: true
};
// Sets up buffer utility according to the environment (called in index-minimal)
$b75bfaf55b32d107$var$util._configure = function() {
    var Buffer = $b75bfaf55b32d107$var$util.Buffer;
    /* istanbul ignore if */ if (!Buffer) {
        $b75bfaf55b32d107$var$util._Buffer_from = $b75bfaf55b32d107$var$util._Buffer_allocUnsafe = null;
        return;
    }
    // because node 4.x buffers are incompatible & immutable
    // see: https://github.com/dcodeIO/protobuf.js/pull/665
    $b75bfaf55b32d107$var$util._Buffer_from = Buffer.from !== Uint8Array.from && Buffer.from || /* istanbul ignore next */ function Buffer_from(value, encoding) {
        return new Buffer(value, encoding);
    };
    $b75bfaf55b32d107$var$util._Buffer_allocUnsafe = Buffer.allocUnsafe || /* istanbul ignore next */ function Buffer_allocUnsafe(size) {
        return new Buffer(size);
    };
};

});
parcelRequire.register("4kb80", function(module, exports) {
"use strict";
module.exports = $3261a98357726230$var$asPromise;
/**
 * Callback as used by {@link util.asPromise}.
 * @typedef asPromiseCallback
 * @type {function}
 * @param {Error|null} error Error, if any
 * @param {...*} params Additional arguments
 * @returns {undefined}
 */ /**
 * Returns a promise from a node-style callback function.
 * @memberof util
 * @param {asPromiseCallback} fn Function to call
 * @param {*} ctx Function context
 * @param {...*} params Function arguments
 * @returns {Promise<*>} Promisified function
 */ function $3261a98357726230$var$asPromise(fn, ctx /*, varargs */ ) {
    var params = new Array(arguments.length - 1), offset = 0, index = 2, pending = true;
    while(index < arguments.length)params[offset++] = arguments[index++];
    return new Promise(function executor(resolve, reject) {
        params[offset] = function callback(err /*, varargs */ ) {
            if (pending) {
                pending = false;
                if (err) reject(err);
                else {
                    var params = new Array(arguments.length - 1), offset = 0;
                    while(offset < params.length)params[offset++] = arguments[offset];
                    resolve.apply(null, params);
                }
            }
        };
        try {
            fn.apply(ctx || null, params);
        } catch (err) {
            if (pending) {
                pending = false;
                reject(err);
            }
        }
    });
}

});

parcelRequire.register("1U6dm", function(module, exports) {
"use strict";
/**
 * A minimal base64 implementation for number arrays.
 * @memberof util
 * @namespace
 */ var $162fd77556348d84$var$base64 = module.exports;
/**
 * Calculates the byte length of a base64 encoded string.
 * @param {string} string Base64 encoded string
 * @returns {number} Byte length
 */ $162fd77556348d84$var$base64.length = function length(string) {
    var p = string.length;
    if (!p) return 0;
    var n = 0;
    while(--p % 4 > 1 && string.charAt(p) === "=")++n;
    return Math.ceil(string.length * 3) / 4 - n;
};
// Base64 encoding table
var $162fd77556348d84$var$b64 = new Array(64);
// Base64 decoding table
var $162fd77556348d84$var$s64 = new Array(123);
// 65..90, 97..122, 48..57, 43, 47
for(var $162fd77556348d84$var$i = 0; $162fd77556348d84$var$i < 64;)$162fd77556348d84$var$s64[$162fd77556348d84$var$b64[$162fd77556348d84$var$i] = $162fd77556348d84$var$i < 26 ? $162fd77556348d84$var$i + 65 : $162fd77556348d84$var$i < 52 ? $162fd77556348d84$var$i + 71 : $162fd77556348d84$var$i < 62 ? $162fd77556348d84$var$i - 4 : $162fd77556348d84$var$i - 59 | 43] = $162fd77556348d84$var$i++;
/**
 * Encodes a buffer to a base64 encoded string.
 * @param {Uint8Array} buffer Source buffer
 * @param {number} start Source start
 * @param {number} end Source end
 * @returns {string} Base64 encoded string
 */ $162fd77556348d84$var$base64.encode = function encode(buffer, start, end) {
    var parts = null, chunk = [];
    var i = 0, j = 0, t; // temporary
    while(start < end){
        var b = buffer[start++];
        switch(j){
            case 0:
                chunk[i++] = $162fd77556348d84$var$b64[b >> 2];
                t = (b & 3) << 4;
                j = 1;
                break;
            case 1:
                chunk[i++] = $162fd77556348d84$var$b64[t | b >> 4];
                t = (b & 15) << 2;
                j = 2;
                break;
            case 2:
                chunk[i++] = $162fd77556348d84$var$b64[t | b >> 6];
                chunk[i++] = $162fd77556348d84$var$b64[b & 63];
                j = 0;
                break;
        }
        if (i > 8191) {
            (parts || (parts = [])).push(String.fromCharCode.apply(String, chunk));
            i = 0;
        }
    }
    if (j) {
        chunk[i++] = $162fd77556348d84$var$b64[t];
        chunk[i++] = 61;
        if (j === 1) chunk[i++] = 61;
    }
    if (parts) {
        if (i) parts.push(String.fromCharCode.apply(String, chunk.slice(0, i)));
        return parts.join("");
    }
    return String.fromCharCode.apply(String, chunk.slice(0, i));
};
var $162fd77556348d84$var$invalidEncoding = "invalid encoding";
/**
 * Decodes a base64 encoded string to a buffer.
 * @param {string} string Source string
 * @param {Uint8Array} buffer Destination buffer
 * @param {number} offset Destination offset
 * @returns {number} Number of bytes written
 * @throws {Error} If encoding is invalid
 */ $162fd77556348d84$var$base64.decode = function decode(string, buffer, offset) {
    var start = offset;
    var j = 0, t; // temporary
    for(var i = 0; i < string.length;){
        var c = string.charCodeAt(i++);
        if (c === 61 && j > 1) break;
        if ((c = $162fd77556348d84$var$s64[c]) === undefined) throw Error($162fd77556348d84$var$invalidEncoding);
        switch(j){
            case 0:
                t = c;
                j = 1;
                break;
            case 1:
                buffer[offset++] = t << 2 | (c & 48) >> 4;
                t = c;
                j = 2;
                break;
            case 2:
                buffer[offset++] = (t & 15) << 4 | (c & 60) >> 2;
                t = c;
                j = 3;
                break;
            case 3:
                buffer[offset++] = (t & 3) << 6 | c;
                j = 0;
                break;
        }
    }
    if (j === 1) throw Error($162fd77556348d84$var$invalidEncoding);
    return offset - start;
};
/**
 * Tests if the specified string appears to be base64 encoded.
 * @param {string} string String to test
 * @returns {boolean} `true` if probably base64 encoded, otherwise false
 */ $162fd77556348d84$var$base64.test = function test(string) {
    return /^(?:[A-Za-z0-9+/]{4})*(?:[A-Za-z0-9+/]{2}==|[A-Za-z0-9+/]{3}=)?$/.test(string);
};

});

parcelRequire.register("4BOh8", function(module, exports) {
"use strict";
module.exports = $35b19dc581739756$var$EventEmitter;
/**
 * Constructs a new event emitter instance.
 * @classdesc A minimal event emitter.
 * @memberof util
 * @constructor
 */ function $35b19dc581739756$var$EventEmitter() {
    /**
     * Registered listeners.
     * @type {Object.<string,*>}
     * @private
     */ this._listeners = {};
}
/**
 * Registers an event listener.
 * @param {string} evt Event name
 * @param {function} fn Listener
 * @param {*} [ctx] Listener context
 * @returns {util.EventEmitter} `this`
 */ $35b19dc581739756$var$EventEmitter.prototype.on = function on(evt, fn, ctx) {
    (this._listeners[evt] || (this._listeners[evt] = [])).push({
        fn: fn,
        ctx: ctx || this
    });
    return this;
};
/**
 * Removes an event listener or any matching listeners if arguments are omitted.
 * @param {string} [evt] Event name. Removes all listeners if omitted.
 * @param {function} [fn] Listener to remove. Removes all listeners of `evt` if omitted.
 * @returns {util.EventEmitter} `this`
 */ $35b19dc581739756$var$EventEmitter.prototype.off = function off(evt, fn) {
    if (evt === undefined) this._listeners = {};
    else if (fn === undefined) this._listeners[evt] = [];
    else {
        var listeners = this._listeners[evt];
        for(var i = 0; i < listeners.length;)if (listeners[i].fn === fn) listeners.splice(i, 1);
        else ++i;
    }
    return this;
};
/**
 * Emits an event by calling its listeners with the specified arguments.
 * @param {string} evt Event name
 * @param {...*} args Arguments
 * @returns {util.EventEmitter} `this`
 */ $35b19dc581739756$var$EventEmitter.prototype.emit = function emit(evt) {
    var listeners = this._listeners[evt];
    if (listeners) {
        var args = [], i = 1;
        for(; i < arguments.length;)args.push(arguments[i++]);
        for(i = 0; i < listeners.length;)listeners[i].fn.apply(listeners[i++].ctx, args);
    }
    return this;
};

});

parcelRequire.register("fQJez", function(module, exports) {
"use strict";
module.exports = $b89eccdf9e00ce53$var$factory($b89eccdf9e00ce53$var$factory);
/**
 * Reads / writes floats / doubles from / to buffers.
 * @name util.float
 * @namespace
 */ /**
 * Writes a 32 bit float to a buffer using little endian byte order.
 * @name util.float.writeFloatLE
 * @function
 * @param {number} val Value to write
 * @param {Uint8Array} buf Target buffer
 * @param {number} pos Target buffer offset
 * @returns {undefined}
 */ /**
 * Writes a 32 bit float to a buffer using big endian byte order.
 * @name util.float.writeFloatBE
 * @function
 * @param {number} val Value to write
 * @param {Uint8Array} buf Target buffer
 * @param {number} pos Target buffer offset
 * @returns {undefined}
 */ /**
 * Reads a 32 bit float from a buffer using little endian byte order.
 * @name util.float.readFloatLE
 * @function
 * @param {Uint8Array} buf Source buffer
 * @param {number} pos Source buffer offset
 * @returns {number} Value read
 */ /**
 * Reads a 32 bit float from a buffer using big endian byte order.
 * @name util.float.readFloatBE
 * @function
 * @param {Uint8Array} buf Source buffer
 * @param {number} pos Source buffer offset
 * @returns {number} Value read
 */ /**
 * Writes a 64 bit double to a buffer using little endian byte order.
 * @name util.float.writeDoubleLE
 * @function
 * @param {number} val Value to write
 * @param {Uint8Array} buf Target buffer
 * @param {number} pos Target buffer offset
 * @returns {undefined}
 */ /**
 * Writes a 64 bit double to a buffer using big endian byte order.
 * @name util.float.writeDoubleBE
 * @function
 * @param {number} val Value to write
 * @param {Uint8Array} buf Target buffer
 * @param {number} pos Target buffer offset
 * @returns {undefined}
 */ /**
 * Reads a 64 bit double from a buffer using little endian byte order.
 * @name util.float.readDoubleLE
 * @function
 * @param {Uint8Array} buf Source buffer
 * @param {number} pos Source buffer offset
 * @returns {number} Value read
 */ /**
 * Reads a 64 bit double from a buffer using big endian byte order.
 * @name util.float.readDoubleBE
 * @function
 * @param {Uint8Array} buf Source buffer
 * @param {number} pos Source buffer offset
 * @returns {number} Value read
 */ // Factory function for the purpose of node-based testing in modified global environments
function $b89eccdf9e00ce53$var$factory(exports) {
    // float: typed array
    if (typeof Float32Array !== "undefined") (function() {
        var f32 = new Float32Array([
            -0
        ]), f8b = new Uint8Array(f32.buffer), le = f8b[3] === 128;
        function writeFloat_f32_cpy(val, buf, pos) {
            f32[0] = val;
            buf[pos] = f8b[0];
            buf[pos + 1] = f8b[1];
            buf[pos + 2] = f8b[2];
            buf[pos + 3] = f8b[3];
        }
        function writeFloat_f32_rev(val, buf, pos) {
            f32[0] = val;
            buf[pos] = f8b[3];
            buf[pos + 1] = f8b[2];
            buf[pos + 2] = f8b[1];
            buf[pos + 3] = f8b[0];
        }
        /* istanbul ignore next */ exports.writeFloatLE = le ? writeFloat_f32_cpy : writeFloat_f32_rev;
        /* istanbul ignore next */ exports.writeFloatBE = le ? writeFloat_f32_rev : writeFloat_f32_cpy;
        function readFloat_f32_cpy(buf, pos) {
            f8b[0] = buf[pos];
            f8b[1] = buf[pos + 1];
            f8b[2] = buf[pos + 2];
            f8b[3] = buf[pos + 3];
            return f32[0];
        }
        function readFloat_f32_rev(buf, pos) {
            f8b[3] = buf[pos];
            f8b[2] = buf[pos + 1];
            f8b[1] = buf[pos + 2];
            f8b[0] = buf[pos + 3];
            return f32[0];
        }
        /* istanbul ignore next */ exports.readFloatLE = le ? readFloat_f32_cpy : readFloat_f32_rev;
        /* istanbul ignore next */ exports.readFloatBE = le ? readFloat_f32_rev : readFloat_f32_cpy;
    // float: ieee754
    })();
    else (function() {
        function writeFloat_ieee754(writeUint, val, buf, pos) {
            var sign = val < 0 ? 1 : 0;
            if (sign) val = -val;
            if (val === 0) writeUint(1 / val > 0 ? /* positive */ 0 : /* negative 0 */ 2147483648, buf, pos);
            else if (isNaN(val)) writeUint(2143289344, buf, pos);
            else if (val > 3.4028234663852886e+38) writeUint((sign << 31 | 2139095040) >>> 0, buf, pos);
            else if (val < 1.1754943508222875e-38) writeUint((sign << 31 | Math.round(val / 1.401298464324817e-45)) >>> 0, buf, pos);
            else {
                var exponent = Math.floor(Math.log(val) / Math.LN2), mantissa = Math.round(val * Math.pow(2, -exponent) * 8388608) & 8388607;
                writeUint((sign << 31 | exponent + 127 << 23 | mantissa) >>> 0, buf, pos);
            }
        }
        exports.writeFloatLE = writeFloat_ieee754.bind(null, $b89eccdf9e00ce53$var$writeUintLE);
        exports.writeFloatBE = writeFloat_ieee754.bind(null, $b89eccdf9e00ce53$var$writeUintBE);
        function readFloat_ieee754(readUint, buf, pos) {
            var uint = readUint(buf, pos), sign = (uint >> 31) * 2 + 1, exponent = uint >>> 23 & 255, mantissa = uint & 8388607;
            return exponent === 255 ? mantissa ? NaN : sign * Infinity : exponent === 0 // denormal
             ? sign * 1.401298464324817e-45 * mantissa : sign * Math.pow(2, exponent - 150) * (mantissa + 8388608);
        }
        exports.readFloatLE = readFloat_ieee754.bind(null, $b89eccdf9e00ce53$var$readUintLE);
        exports.readFloatBE = readFloat_ieee754.bind(null, $b89eccdf9e00ce53$var$readUintBE);
    })();
    // double: typed array
    if (typeof Float64Array !== "undefined") (function() {
        var f64 = new Float64Array([
            -0
        ]), f8b = new Uint8Array(f64.buffer), le = f8b[7] === 128;
        function writeDouble_f64_cpy(val, buf, pos) {
            f64[0] = val;
            buf[pos] = f8b[0];
            buf[pos + 1] = f8b[1];
            buf[pos + 2] = f8b[2];
            buf[pos + 3] = f8b[3];
            buf[pos + 4] = f8b[4];
            buf[pos + 5] = f8b[5];
            buf[pos + 6] = f8b[6];
            buf[pos + 7] = f8b[7];
        }
        function writeDouble_f64_rev(val, buf, pos) {
            f64[0] = val;
            buf[pos] = f8b[7];
            buf[pos + 1] = f8b[6];
            buf[pos + 2] = f8b[5];
            buf[pos + 3] = f8b[4];
            buf[pos + 4] = f8b[3];
            buf[pos + 5] = f8b[2];
            buf[pos + 6] = f8b[1];
            buf[pos + 7] = f8b[0];
        }
        /* istanbul ignore next */ exports.writeDoubleLE = le ? writeDouble_f64_cpy : writeDouble_f64_rev;
        /* istanbul ignore next */ exports.writeDoubleBE = le ? writeDouble_f64_rev : writeDouble_f64_cpy;
        function readDouble_f64_cpy(buf, pos) {
            f8b[0] = buf[pos];
            f8b[1] = buf[pos + 1];
            f8b[2] = buf[pos + 2];
            f8b[3] = buf[pos + 3];
            f8b[4] = buf[pos + 4];
            f8b[5] = buf[pos + 5];
            f8b[6] = buf[pos + 6];
            f8b[7] = buf[pos + 7];
            return f64[0];
        }
        function readDouble_f64_rev(buf, pos) {
            f8b[7] = buf[pos];
            f8b[6] = buf[pos + 1];
            f8b[5] = buf[pos + 2];
            f8b[4] = buf[pos + 3];
            f8b[3] = buf[pos + 4];
            f8b[2] = buf[pos + 5];
            f8b[1] = buf[pos + 6];
            f8b[0] = buf[pos + 7];
            return f64[0];
        }
        /* istanbul ignore next */ exports.readDoubleLE = le ? readDouble_f64_cpy : readDouble_f64_rev;
        /* istanbul ignore next */ exports.readDoubleBE = le ? readDouble_f64_rev : readDouble_f64_cpy;
    // double: ieee754
    })();
    else (function() {
        function writeDouble_ieee754(writeUint, off0, off1, val, buf, pos) {
            var sign = val < 0 ? 1 : 0;
            if (sign) val = -val;
            if (val === 0) {
                writeUint(0, buf, pos + off0);
                writeUint(1 / val > 0 ? /* positive */ 0 : /* negative 0 */ 2147483648, buf, pos + off1);
            } else if (isNaN(val)) {
                writeUint(0, buf, pos + off0);
                writeUint(2146959360, buf, pos + off1);
            } else if (val > 1.7976931348623157e+308) {
                writeUint(0, buf, pos + off0);
                writeUint((sign << 31 | 2146435072) >>> 0, buf, pos + off1);
            } else {
                var mantissa;
                if (val < 2.2250738585072014e-308) {
                    mantissa = val / 5e-324;
                    writeUint(mantissa >>> 0, buf, pos + off0);
                    writeUint((sign << 31 | mantissa / 4294967296) >>> 0, buf, pos + off1);
                } else {
                    var exponent = Math.floor(Math.log(val) / Math.LN2);
                    if (exponent === 1024) exponent = 1023;
                    mantissa = val * Math.pow(2, -exponent);
                    writeUint(mantissa * 4503599627370496 >>> 0, buf, pos + off0);
                    writeUint((sign << 31 | exponent + 1023 << 20 | mantissa * 1048576 & 1048575) >>> 0, buf, pos + off1);
                }
            }
        }
        exports.writeDoubleLE = writeDouble_ieee754.bind(null, $b89eccdf9e00ce53$var$writeUintLE, 0, 4);
        exports.writeDoubleBE = writeDouble_ieee754.bind(null, $b89eccdf9e00ce53$var$writeUintBE, 4, 0);
        function readDouble_ieee754(readUint, off0, off1, buf, pos) {
            var lo = readUint(buf, pos + off0), hi = readUint(buf, pos + off1);
            var sign = (hi >> 31) * 2 + 1, exponent = hi >>> 20 & 2047, mantissa = 4294967296 * (hi & 1048575) + lo;
            return exponent === 2047 ? mantissa ? NaN : sign * Infinity : exponent === 0 // denormal
             ? sign * 5e-324 * mantissa : sign * Math.pow(2, exponent - 1075) * (mantissa + 4503599627370496);
        }
        exports.readDoubleLE = readDouble_ieee754.bind(null, $b89eccdf9e00ce53$var$readUintLE, 0, 4);
        exports.readDoubleBE = readDouble_ieee754.bind(null, $b89eccdf9e00ce53$var$readUintBE, 4, 0);
    })();
    return exports;
}
// uint helpers
function $b89eccdf9e00ce53$var$writeUintLE(val, buf, pos) {
    buf[pos] = val & 255;
    buf[pos + 1] = val >>> 8 & 255;
    buf[pos + 2] = val >>> 16 & 255;
    buf[pos + 3] = val >>> 24;
}
function $b89eccdf9e00ce53$var$writeUintBE(val, buf, pos) {
    buf[pos] = val >>> 24;
    buf[pos + 1] = val >>> 16 & 255;
    buf[pos + 2] = val >>> 8 & 255;
    buf[pos + 3] = val & 255;
}
function $b89eccdf9e00ce53$var$readUintLE(buf, pos) {
    return (buf[pos] | buf[pos + 1] << 8 | buf[pos + 2] << 16 | buf[pos + 3] << 24) >>> 0;
}
function $b89eccdf9e00ce53$var$readUintBE(buf, pos) {
    return (buf[pos] << 24 | buf[pos + 1] << 16 | buf[pos + 2] << 8 | buf[pos + 3]) >>> 0;
}

});

parcelRequire.register("8PAo2", function(module, exports) {
"use strict";
module.exports = inquire;
/**
 * Requires a module only if available.
 * @memberof util
 * @param {string} moduleName Module to require
 * @returns {?Object} Required module if available and not empty, otherwise `null`
 */ function inquire(moduleName) {
    try {
        var mod = eval("quire".replace(/^/, "re"))(moduleName); // eslint-disable-line no-eval
        if (mod && (mod.length || Object.keys(mod).length)) return mod;
    } catch (e) {} // eslint-disable-line no-empty
    return null;
}

});

parcelRequire.register("lgVql", function(module, exports) {
"use strict";
/**
 * A minimal UTF8 implementation for number arrays.
 * @memberof util
 * @namespace
 */ var $f7c7a2cdd3358709$var$utf8 = module.exports;
/**
 * Calculates the UTF8 byte length of a string.
 * @param {string} string String
 * @returns {number} Byte length
 */ $f7c7a2cdd3358709$var$utf8.length = function utf8_length(string) {
    var len = 0, c = 0;
    for(var i = 0; i < string.length; ++i){
        c = string.charCodeAt(i);
        if (c < 128) len += 1;
        else if (c < 2048) len += 2;
        else if ((c & 0xFC00) === 0xD800 && (string.charCodeAt(i + 1) & 0xFC00) === 0xDC00) {
            ++i;
            len += 4;
        } else len += 3;
    }
    return len;
};
/**
 * Reads UTF8 bytes as a string.
 * @param {Uint8Array} buffer Source buffer
 * @param {number} start Source start
 * @param {number} end Source end
 * @returns {string} String read
 */ $f7c7a2cdd3358709$var$utf8.read = function utf8_read(buffer, start, end) {
    var len = end - start;
    if (len < 1) return "";
    var parts = null, chunk = [], i = 0, t; // temporary
    while(start < end){
        t = buffer[start++];
        if (t < 128) chunk[i++] = t;
        else if (t > 191 && t < 224) chunk[i++] = (t & 31) << 6 | buffer[start++] & 63;
        else if (t > 239 && t < 365) {
            t = ((t & 7) << 18 | (buffer[start++] & 63) << 12 | (buffer[start++] & 63) << 6 | buffer[start++] & 63) - 0x10000;
            chunk[i++] = 0xD800 + (t >> 10);
            chunk[i++] = 0xDC00 + (t & 1023);
        } else chunk[i++] = (t & 15) << 12 | (buffer[start++] & 63) << 6 | buffer[start++] & 63;
        if (i > 8191) {
            (parts || (parts = [])).push(String.fromCharCode.apply(String, chunk));
            i = 0;
        }
    }
    if (parts) {
        if (i) parts.push(String.fromCharCode.apply(String, chunk.slice(0, i)));
        return parts.join("");
    }
    return String.fromCharCode.apply(String, chunk.slice(0, i));
};
/**
 * Writes a string as UTF8 bytes.
 * @param {string} string Source string
 * @param {Uint8Array} buffer Destination buffer
 * @param {number} offset Destination offset
 * @returns {number} Bytes written
 */ $f7c7a2cdd3358709$var$utf8.write = function utf8_write(string, buffer, offset) {
    var start = offset, c1, c2; // character 2
    for(var i = 0; i < string.length; ++i){
        c1 = string.charCodeAt(i);
        if (c1 < 128) buffer[offset++] = c1;
        else if (c1 < 2048) {
            buffer[offset++] = c1 >> 6 | 192;
            buffer[offset++] = c1 & 63 | 128;
        } else if ((c1 & 0xFC00) === 0xD800 && ((c2 = string.charCodeAt(i + 1)) & 0xFC00) === 0xDC00) {
            c1 = 0x10000 + ((c1 & 0x03FF) << 10) + (c2 & 0x03FF);
            ++i;
            buffer[offset++] = c1 >> 18 | 240;
            buffer[offset++] = c1 >> 12 & 63 | 128;
            buffer[offset++] = c1 >> 6 & 63 | 128;
            buffer[offset++] = c1 & 63 | 128;
        } else {
            buffer[offset++] = c1 >> 12 | 224;
            buffer[offset++] = c1 >> 6 & 63 | 128;
            buffer[offset++] = c1 & 63 | 128;
        }
    }
    return offset - start;
};

});

parcelRequire.register("g3IvT", function(module, exports) {
"use strict";
module.exports = $bb0f74988a25d628$var$pool;
/**
 * An allocator as used by {@link util.pool}.
 * @typedef PoolAllocator
 * @type {function}
 * @param {number} size Buffer size
 * @returns {Uint8Array} Buffer
 */ /**
 * A slicer as used by {@link util.pool}.
 * @typedef PoolSlicer
 * @type {function}
 * @param {number} start Start offset
 * @param {number} end End offset
 * @returns {Uint8Array} Buffer slice
 * @this {Uint8Array}
 */ /**
 * A general purpose buffer pool.
 * @memberof util
 * @function
 * @param {PoolAllocator} alloc Allocator
 * @param {PoolSlicer} slice Slicer
 * @param {number} [size=8192] Slab size
 * @returns {PoolAllocator} Pooled allocator
 */ function $bb0f74988a25d628$var$pool(alloc, slice, size) {
    var SIZE = size || 8192;
    var MAX = SIZE >>> 1;
    var slab = null;
    var offset = SIZE;
    return function pool_alloc(size) {
        if (size < 1 || size > MAX) return alloc(size);
        if (offset + size > SIZE) {
            slab = alloc(SIZE);
            offset = 0;
        }
        var buf = slice.call(slab, offset, offset += size);
        if (offset & 7) offset = (offset | 7) + 1;
        return buf;
    };
}

});

parcelRequire.register("bDI60", function(module, exports) {
"use strict";
module.exports = $87958abfc7ed58e3$var$LongBits;

var $fK14h = parcelRequire("fK14h");
/**
 * Constructs new long bits.
 * @classdesc Helper class for working with the low and high bits of a 64 bit value.
 * @memberof util
 * @constructor
 * @param {number} lo Low 32 bits, unsigned
 * @param {number} hi High 32 bits, unsigned
 */ function $87958abfc7ed58e3$var$LongBits(lo, hi) {
    // note that the casts below are theoretically unnecessary as of today, but older statically
    // generated converter code might still call the ctor with signed 32bits. kept for compat.
    /**
     * Low bits.
     * @type {number}
     */ this.lo = lo >>> 0;
    /**
     * High bits.
     * @type {number}
     */ this.hi = hi >>> 0;
}
/**
 * Zero bits.
 * @memberof util.LongBits
 * @type {util.LongBits}
 */ var $87958abfc7ed58e3$var$zero = $87958abfc7ed58e3$var$LongBits.zero = new $87958abfc7ed58e3$var$LongBits(0, 0);
$87958abfc7ed58e3$var$zero.toNumber = function() {
    return 0;
};
$87958abfc7ed58e3$var$zero.zzEncode = $87958abfc7ed58e3$var$zero.zzDecode = function() {
    return this;
};
$87958abfc7ed58e3$var$zero.length = function() {
    return 1;
};
/**
 * Zero hash.
 * @memberof util.LongBits
 * @type {string}
 */ var $87958abfc7ed58e3$var$zeroHash = $87958abfc7ed58e3$var$LongBits.zeroHash = "\x00\x00\x00\x00\x00\x00\x00\x00";
/**
 * Constructs new long bits from the specified number.
 * @param {number} value Value
 * @returns {util.LongBits} Instance
 */ $87958abfc7ed58e3$var$LongBits.fromNumber = function fromNumber(value) {
    if (value === 0) return $87958abfc7ed58e3$var$zero;
    var sign = value < 0;
    if (sign) value = -value;
    var lo = value >>> 0, hi = (value - lo) / 4294967296 >>> 0;
    if (sign) {
        hi = ~hi >>> 0;
        lo = ~lo >>> 0;
        if (++lo > 4294967295) {
            lo = 0;
            if (++hi > 4294967295) hi = 0;
        }
    }
    return new $87958abfc7ed58e3$var$LongBits(lo, hi);
};
/**
 * Constructs new long bits from a number, long or string.
 * @param {Long|number|string} value Value
 * @returns {util.LongBits} Instance
 */ $87958abfc7ed58e3$var$LongBits.from = function from(value) {
    if (typeof value === "number") return $87958abfc7ed58e3$var$LongBits.fromNumber(value);
    if ($fK14h.isString(value)) {
        /* istanbul ignore else */ if ($fK14h.Long) value = $fK14h.Long.fromString(value);
        else return $87958abfc7ed58e3$var$LongBits.fromNumber(parseInt(value, 10));
    }
    return value.low || value.high ? new $87958abfc7ed58e3$var$LongBits(value.low >>> 0, value.high >>> 0) : $87958abfc7ed58e3$var$zero;
};
/**
 * Converts this long bits to a possibly unsafe JavaScript number.
 * @param {boolean} [unsigned=false] Whether unsigned or not
 * @returns {number} Possibly unsafe number
 */ $87958abfc7ed58e3$var$LongBits.prototype.toNumber = function toNumber(unsigned) {
    if (!unsigned && this.hi >>> 31) {
        var lo = ~this.lo + 1 >>> 0, hi = ~this.hi >>> 0;
        if (!lo) hi = hi + 1 >>> 0;
        return -(lo + hi * 4294967296);
    }
    return this.lo + this.hi * 4294967296;
};
/**
 * Converts this long bits to a long.
 * @param {boolean} [unsigned=false] Whether unsigned or not
 * @returns {Long} Long
 */ $87958abfc7ed58e3$var$LongBits.prototype.toLong = function toLong(unsigned) {
    return $fK14h.Long ? new $fK14h.Long(this.lo | 0, this.hi | 0, Boolean(unsigned)) : {
        low: this.lo | 0,
        high: this.hi | 0,
        unsigned: Boolean(unsigned)
    };
};
var $87958abfc7ed58e3$var$charCodeAt = String.prototype.charCodeAt;
/**
 * Constructs new long bits from the specified 8 characters long hash.
 * @param {string} hash Hash
 * @returns {util.LongBits} Bits
 */ $87958abfc7ed58e3$var$LongBits.fromHash = function fromHash(hash) {
    if (hash === $87958abfc7ed58e3$var$zeroHash) return $87958abfc7ed58e3$var$zero;
    return new $87958abfc7ed58e3$var$LongBits(($87958abfc7ed58e3$var$charCodeAt.call(hash, 0) | $87958abfc7ed58e3$var$charCodeAt.call(hash, 1) << 8 | $87958abfc7ed58e3$var$charCodeAt.call(hash, 2) << 16 | $87958abfc7ed58e3$var$charCodeAt.call(hash, 3) << 24) >>> 0, ($87958abfc7ed58e3$var$charCodeAt.call(hash, 4) | $87958abfc7ed58e3$var$charCodeAt.call(hash, 5) << 8 | $87958abfc7ed58e3$var$charCodeAt.call(hash, 6) << 16 | $87958abfc7ed58e3$var$charCodeAt.call(hash, 7) << 24) >>> 0);
};
/**
 * Converts this long bits to a 8 characters long hash.
 * @returns {string} Hash
 */ $87958abfc7ed58e3$var$LongBits.prototype.toHash = function toHash() {
    return String.fromCharCode(this.lo & 255, this.lo >>> 8 & 255, this.lo >>> 16 & 255, this.lo >>> 24, this.hi & 255, this.hi >>> 8 & 255, this.hi >>> 16 & 255, this.hi >>> 24);
};
/**
 * Zig-zag encodes this long bits.
 * @returns {util.LongBits} `this`
 */ $87958abfc7ed58e3$var$LongBits.prototype.zzEncode = function zzEncode() {
    var mask = this.hi >> 31;
    this.hi = ((this.hi << 1 | this.lo >>> 31) ^ mask) >>> 0;
    this.lo = (this.lo << 1 ^ mask) >>> 0;
    return this;
};
/**
 * Zig-zag decodes this long bits.
 * @returns {util.LongBits} `this`
 */ $87958abfc7ed58e3$var$LongBits.prototype.zzDecode = function zzDecode() {
    var mask = -(this.lo & 1);
    this.lo = ((this.lo >>> 1 | this.hi << 31) ^ mask) >>> 0;
    this.hi = (this.hi >>> 1 ^ mask) >>> 0;
    return this;
};
/**
 * Calculates the length of this longbits when encoded as a varint.
 * @returns {number} Length
 */ $87958abfc7ed58e3$var$LongBits.prototype.length = function length() {
    var part0 = this.lo, part1 = (this.lo >>> 28 | this.hi << 4) >>> 0, part2 = this.hi >>> 24;
    return part2 === 0 ? part1 === 0 ? part0 < 16384 ? part0 < 128 ? 1 : 2 : part0 < 2097152 ? 3 : 4 : part1 < 16384 ? part1 < 128 ? 5 : 6 : part1 < 2097152 ? 7 : 8 : part2 < 128 ? 9 : 10;
};

});



parcelRequire.register("6oXFW", function(module, exports) {
"use strict";
module.exports = $4a9346486373df92$var$BufferWriter;

var $73ZlY = parcelRequire("73ZlY");
($4a9346486373df92$var$BufferWriter.prototype = Object.create($73ZlY.prototype)).constructor = $4a9346486373df92$var$BufferWriter;

var $fK14h = parcelRequire("fK14h");
/**
 * Constructs a new buffer writer instance.
 * @classdesc Wire format writer using node buffers.
 * @extends Writer
 * @constructor
 */ function $4a9346486373df92$var$BufferWriter() {
    $73ZlY.call(this);
}
$4a9346486373df92$var$BufferWriter._configure = function() {
    /**
     * Allocates a buffer of the specified size.
     * @function
     * @param {number} size Buffer size
     * @returns {Buffer} Buffer
     */ $4a9346486373df92$var$BufferWriter.alloc = $fK14h._Buffer_allocUnsafe;
    $4a9346486373df92$var$BufferWriter.writeBytesBuffer = $fK14h.Buffer && $fK14h.Buffer.prototype instanceof Uint8Array && $fK14h.Buffer.prototype.set.name === "set" ? function writeBytesBuffer_set(val, buf, pos) {
        buf.set(val, pos); // faster than copy (requires node >= 4 where Buffers extend Uint8Array and set is properly inherited)
    // also works for plain array values
    } : function writeBytesBuffer_copy(val, buf, pos) {
        if (val.copy) val.copy(buf, pos, 0, val.length);
        else for(var i = 0; i < val.length;)buf[pos++] = val[i++];
    };
};
/**
 * @override
 */ $4a9346486373df92$var$BufferWriter.prototype.bytes = function write_bytes_buffer(value) {
    if ($fK14h.isString(value)) value = $fK14h._Buffer_from(value, "base64");
    var len = value.length >>> 0;
    this.uint32(len);
    if (len) this._push($4a9346486373df92$var$BufferWriter.writeBytesBuffer, len, value);
    return this;
};
function $4a9346486373df92$var$writeStringBuffer(val, buf, pos) {
    if (val.length < 40) $fK14h.utf8.write(val, buf, pos);
    else if (buf.utf8Write) buf.utf8Write(val, pos);
    else buf.write(val, pos);
}
/**
 * @override
 */ $4a9346486373df92$var$BufferWriter.prototype.string = function write_string_buffer(value) {
    var len = $fK14h.Buffer.byteLength(value);
    this.uint32(len);
    if (len) this._push($4a9346486373df92$var$writeStringBuffer, len, value);
    return this;
};
/**
 * Finishes the write operation.
 * @name BufferWriter#finish
 * @function
 * @returns {Buffer} Finished buffer
 */ $4a9346486373df92$var$BufferWriter._configure();

});

parcelRequire.register("jNsDJ", function(module, exports) {
"use strict";
module.exports = $e698cf366e13f6cc$var$Reader;

var $fK14h = parcelRequire("fK14h");
var $e698cf366e13f6cc$var$BufferReader; // cyclic
var $e698cf366e13f6cc$var$LongBits = $fK14h.LongBits, $e698cf366e13f6cc$var$utf8 = $fK14h.utf8;
/* istanbul ignore next */ function $e698cf366e13f6cc$var$indexOutOfRange(reader, writeLength) {
    return RangeError("index out of range: " + reader.pos + " + " + (writeLength || 1) + " > " + reader.len);
}
/**
 * Constructs a new reader instance using the specified buffer.
 * @classdesc Wire format reader using `Uint8Array` if available, otherwise `Array`.
 * @constructor
 * @param {Uint8Array} buffer Buffer to read from
 */ function $e698cf366e13f6cc$var$Reader(buffer) {
    /**
     * Read buffer.
     * @type {Uint8Array}
     */ this.buf = buffer;
    /**
     * Read buffer position.
     * @type {number}
     */ this.pos = 0;
    /**
     * Read buffer length.
     * @type {number}
     */ this.len = buffer.length;
}
var $e698cf366e13f6cc$var$create_array = typeof Uint8Array !== "undefined" ? function create_typed_array(buffer) {
    if (buffer instanceof Uint8Array || Array.isArray(buffer)) return new $e698cf366e13f6cc$var$Reader(buffer);
    throw Error("illegal buffer");
} : function create_array(buffer) {
    if (Array.isArray(buffer)) return new $e698cf366e13f6cc$var$Reader(buffer);
    throw Error("illegal buffer");
};
var $e698cf366e13f6cc$var$create = function create() {
    return $fK14h.Buffer ? function create_buffer_setup(buffer) {
        return ($e698cf366e13f6cc$var$Reader.create = function create_buffer(buffer) {
            return $fK14h.Buffer.isBuffer(buffer) ? new $e698cf366e13f6cc$var$BufferReader(buffer) : $e698cf366e13f6cc$var$create_array(buffer);
        })(buffer);
    } : $e698cf366e13f6cc$var$create_array;
};
/**
 * Creates a new reader using the specified buffer.
 * @function
 * @param {Uint8Array|Buffer} buffer Buffer to read from
 * @returns {Reader|BufferReader} A {@link BufferReader} if `buffer` is a Buffer, otherwise a {@link Reader}
 * @throws {Error} If `buffer` is not a valid buffer
 */ $e698cf366e13f6cc$var$Reader.create = $e698cf366e13f6cc$var$create();
$e698cf366e13f6cc$var$Reader.prototype._slice = $fK14h.Array.prototype.subarray || /* istanbul ignore next */ $fK14h.Array.prototype.slice;
/**
 * Reads a varint as an unsigned 32 bit value.
 * @function
 * @returns {number} Value read
 */ $e698cf366e13f6cc$var$Reader.prototype.uint32 = function read_uint32_setup() {
    var value = 4294967295; // optimizer type-hint, tends to deopt otherwise (?!)
    return function read_uint32() {
        value = (this.buf[this.pos] & 127) >>> 0;
        if (this.buf[this.pos++] < 128) return value;
        value = (value | (this.buf[this.pos] & 127) << 7) >>> 0;
        if (this.buf[this.pos++] < 128) return value;
        value = (value | (this.buf[this.pos] & 127) << 14) >>> 0;
        if (this.buf[this.pos++] < 128) return value;
        value = (value | (this.buf[this.pos] & 127) << 21) >>> 0;
        if (this.buf[this.pos++] < 128) return value;
        value = (value | (this.buf[this.pos] & 15) << 28) >>> 0;
        if (this.buf[this.pos++] < 128) return value;
        /* istanbul ignore if */ if ((this.pos += 5) > this.len) {
            this.pos = this.len;
            throw $e698cf366e13f6cc$var$indexOutOfRange(this, 10);
        }
        return value;
    };
}();
/**
 * Reads a varint as a signed 32 bit value.
 * @returns {number} Value read
 */ $e698cf366e13f6cc$var$Reader.prototype.int32 = function read_int32() {
    return this.uint32() | 0;
};
/**
 * Reads a zig-zag encoded varint as a signed 32 bit value.
 * @returns {number} Value read
 */ $e698cf366e13f6cc$var$Reader.prototype.sint32 = function read_sint32() {
    var value = this.uint32();
    return value >>> 1 ^ -(value & 1) | 0;
};
/* eslint-disable no-invalid-this */ function $e698cf366e13f6cc$var$readLongVarint() {
    // tends to deopt with local vars for octet etc.
    var bits = new $e698cf366e13f6cc$var$LongBits(0, 0);
    var i = 0;
    if (this.len - this.pos > 4) {
        for(; i < 4; ++i){
            // 1st..4th
            bits.lo = (bits.lo | (this.buf[this.pos] & 127) << i * 7) >>> 0;
            if (this.buf[this.pos++] < 128) return bits;
        }
        // 5th
        bits.lo = (bits.lo | (this.buf[this.pos] & 127) << 28) >>> 0;
        bits.hi = (bits.hi | (this.buf[this.pos] & 127) >> 4) >>> 0;
        if (this.buf[this.pos++] < 128) return bits;
        i = 0;
    } else {
        for(; i < 3; ++i){
            /* istanbul ignore if */ if (this.pos >= this.len) throw $e698cf366e13f6cc$var$indexOutOfRange(this);
            // 1st..3th
            bits.lo = (bits.lo | (this.buf[this.pos] & 127) << i * 7) >>> 0;
            if (this.buf[this.pos++] < 128) return bits;
        }
        // 4th
        bits.lo = (bits.lo | (this.buf[this.pos++] & 127) << i * 7) >>> 0;
        return bits;
    }
    if (this.len - this.pos > 4) for(; i < 5; ++i){
        // 6th..10th
        bits.hi = (bits.hi | (this.buf[this.pos] & 127) << i * 7 + 3) >>> 0;
        if (this.buf[this.pos++] < 128) return bits;
    }
    else for(; i < 5; ++i){
        /* istanbul ignore if */ if (this.pos >= this.len) throw $e698cf366e13f6cc$var$indexOutOfRange(this);
        // 6th..10th
        bits.hi = (bits.hi | (this.buf[this.pos] & 127) << i * 7 + 3) >>> 0;
        if (this.buf[this.pos++] < 128) return bits;
    }
    /* istanbul ignore next */ throw Error("invalid varint encoding");
}
/* eslint-enable no-invalid-this */ /**
 * Reads a varint as a signed 64 bit value.
 * @name Reader#int64
 * @function
 * @returns {Long} Value read
 */ /**
 * Reads a varint as an unsigned 64 bit value.
 * @name Reader#uint64
 * @function
 * @returns {Long} Value read
 */ /**
 * Reads a zig-zag encoded varint as a signed 64 bit value.
 * @name Reader#sint64
 * @function
 * @returns {Long} Value read
 */ /**
 * Reads a varint as a boolean.
 * @returns {boolean} Value read
 */ $e698cf366e13f6cc$var$Reader.prototype.bool = function read_bool() {
    return this.uint32() !== 0;
};
function $e698cf366e13f6cc$var$readFixed32_end(buf, end) {
    return (buf[end - 4] | buf[end - 3] << 8 | buf[end - 2] << 16 | buf[end - 1] << 24) >>> 0;
}
/**
 * Reads fixed 32 bits as an unsigned 32 bit integer.
 * @returns {number} Value read
 */ $e698cf366e13f6cc$var$Reader.prototype.fixed32 = function read_fixed32() {
    /* istanbul ignore if */ if (this.pos + 4 > this.len) throw $e698cf366e13f6cc$var$indexOutOfRange(this, 4);
    return $e698cf366e13f6cc$var$readFixed32_end(this.buf, this.pos += 4);
};
/**
 * Reads fixed 32 bits as a signed 32 bit integer.
 * @returns {number} Value read
 */ $e698cf366e13f6cc$var$Reader.prototype.sfixed32 = function read_sfixed32() {
    /* istanbul ignore if */ if (this.pos + 4 > this.len) throw $e698cf366e13f6cc$var$indexOutOfRange(this, 4);
    return $e698cf366e13f6cc$var$readFixed32_end(this.buf, this.pos += 4) | 0;
};
/* eslint-disable no-invalid-this */ function $e698cf366e13f6cc$var$readFixed64() {
    /* istanbul ignore if */ if (this.pos + 8 > this.len) throw $e698cf366e13f6cc$var$indexOutOfRange(this, 8);
    return new $e698cf366e13f6cc$var$LongBits($e698cf366e13f6cc$var$readFixed32_end(this.buf, this.pos += 4), $e698cf366e13f6cc$var$readFixed32_end(this.buf, this.pos += 4));
}
/* eslint-enable no-invalid-this */ /**
 * Reads fixed 64 bits.
 * @name Reader#fixed64
 * @function
 * @returns {Long} Value read
 */ /**
 * Reads zig-zag encoded fixed 64 bits.
 * @name Reader#sfixed64
 * @function
 * @returns {Long} Value read
 */ /**
 * Reads a float (32 bit) as a number.
 * @function
 * @returns {number} Value read
 */ $e698cf366e13f6cc$var$Reader.prototype.float = function read_float() {
    /* istanbul ignore if */ if (this.pos + 4 > this.len) throw $e698cf366e13f6cc$var$indexOutOfRange(this, 4);
    var value = $fK14h.float.readFloatLE(this.buf, this.pos);
    this.pos += 4;
    return value;
};
/**
 * Reads a double (64 bit float) as a number.
 * @function
 * @returns {number} Value read
 */ $e698cf366e13f6cc$var$Reader.prototype.double = function read_double() {
    /* istanbul ignore if */ if (this.pos + 8 > this.len) throw $e698cf366e13f6cc$var$indexOutOfRange(this, 4);
    var value = $fK14h.float.readDoubleLE(this.buf, this.pos);
    this.pos += 8;
    return value;
};
/**
 * Reads a sequence of bytes preceeded by its length as a varint.
 * @returns {Uint8Array} Value read
 */ $e698cf366e13f6cc$var$Reader.prototype.bytes = function read_bytes() {
    var length = this.uint32(), start = this.pos, end = this.pos + length;
    /* istanbul ignore if */ if (end > this.len) throw $e698cf366e13f6cc$var$indexOutOfRange(this, length);
    this.pos += length;
    if (Array.isArray(this.buf)) return this.buf.slice(start, end);
    return start === end // fix for IE 10/Win8 and others' subarray returning array of size 1
     ? new this.buf.constructor(0) : this._slice.call(this.buf, start, end);
};
/**
 * Reads a string preceeded by its byte length as a varint.
 * @returns {string} Value read
 */ $e698cf366e13f6cc$var$Reader.prototype.string = function read_string() {
    var bytes = this.bytes();
    return $e698cf366e13f6cc$var$utf8.read(bytes, 0, bytes.length);
};
/**
 * Skips the specified number of bytes if specified, otherwise skips a varint.
 * @param {number} [length] Length if known, otherwise a varint is assumed
 * @returns {Reader} `this`
 */ $e698cf366e13f6cc$var$Reader.prototype.skip = function skip(length) {
    if (typeof length === "number") {
        /* istanbul ignore if */ if (this.pos + length > this.len) throw $e698cf366e13f6cc$var$indexOutOfRange(this, length);
        this.pos += length;
    } else do {
        /* istanbul ignore if */ if (this.pos >= this.len) throw $e698cf366e13f6cc$var$indexOutOfRange(this);
    }while (this.buf[this.pos++] & 128);
    return this;
};
/**
 * Skips the next element of the specified wire type.
 * @param {number} wireType Wire type received
 * @returns {Reader} `this`
 */ $e698cf366e13f6cc$var$Reader.prototype.skipType = function(wireType) {
    switch(wireType){
        case 0:
            this.skip();
            break;
        case 1:
            this.skip(8);
            break;
        case 2:
            this.skip(this.uint32());
            break;
        case 3:
            while((wireType = this.uint32() & 7) !== 4)this.skipType(wireType);
            break;
        case 5:
            this.skip(4);
            break;
        /* istanbul ignore next */ default:
            throw Error("invalid wire type " + wireType + " at offset " + this.pos);
    }
    return this;
};
$e698cf366e13f6cc$var$Reader._configure = function(BufferReader_) {
    $e698cf366e13f6cc$var$BufferReader = BufferReader_;
    $e698cf366e13f6cc$var$Reader.create = $e698cf366e13f6cc$var$create();
    $e698cf366e13f6cc$var$BufferReader._configure();
    var fn = $fK14h.Long ? "toLong" : /* istanbul ignore next */ "toNumber";
    $fK14h.merge($e698cf366e13f6cc$var$Reader.prototype, {
        int64: function read_int64() {
            return $e698cf366e13f6cc$var$readLongVarint.call(this)[fn](false);
        },
        uint64: function read_uint64() {
            return $e698cf366e13f6cc$var$readLongVarint.call(this)[fn](true);
        },
        sint64: function read_sint64() {
            return $e698cf366e13f6cc$var$readLongVarint.call(this).zzDecode()[fn](false);
        },
        fixed64: function read_fixed64() {
            return $e698cf366e13f6cc$var$readFixed64.call(this)[fn](true);
        },
        sfixed64: function read_sfixed64() {
            return $e698cf366e13f6cc$var$readFixed64.call(this)[fn](false);
        }
    });
};

});

parcelRequire.register("kDrIk", function(module, exports) {
"use strict";
module.exports = $f05cf291b5626a0a$var$BufferReader;

var $jNsDJ = parcelRequire("jNsDJ");
($f05cf291b5626a0a$var$BufferReader.prototype = Object.create($jNsDJ.prototype)).constructor = $f05cf291b5626a0a$var$BufferReader;

var $fK14h = parcelRequire("fK14h");
/**
 * Constructs a new buffer reader instance.
 * @classdesc Wire format reader using node buffers.
 * @extends Reader
 * @constructor
 * @param {Buffer} buffer Buffer to read from
 */ function $f05cf291b5626a0a$var$BufferReader(buffer) {
    $jNsDJ.call(this, buffer);
/**
     * Read buffer.
     * @name BufferReader#buf
     * @type {Buffer}
     */ }
$f05cf291b5626a0a$var$BufferReader._configure = function() {
    /* istanbul ignore else */ if ($fK14h.Buffer) $f05cf291b5626a0a$var$BufferReader.prototype._slice = $fK14h.Buffer.prototype.slice;
};
/**
 * @override
 */ $f05cf291b5626a0a$var$BufferReader.prototype.string = function read_string_buffer() {
    var len = this.uint32(); // modifies pos
    return this.buf.utf8Slice ? this.buf.utf8Slice(this.pos, this.pos = Math.min(this.pos + len, this.len)) : this.buf.toString("utf-8", this.pos, this.pos = Math.min(this.pos + len, this.len));
};
/**
 * Reads a sequence of bytes preceeded by its length as a varint.
 * @name BufferReader#bytes
 * @function
 * @returns {Buffer} Value read
 */ $f05cf291b5626a0a$var$BufferReader._configure();

});

parcelRequire.register("cFFQd", function(module, exports) {
"use strict";
/**
 * Streaming RPC helpers.
 * @namespace
 */ var $9399c52e3a844204$var$rpc = module.exports;

/**
 * RPC implementation passed to {@link Service#create} performing a service request on network level, i.e. by utilizing http requests or websockets.
 * @typedef RPCImpl
 * @type {function}
 * @param {Method|rpc.ServiceMethod<Message<{}>,Message<{}>>} method Reflected or static method being called
 * @param {Uint8Array} requestData Request data
 * @param {RPCImplCallback} callback Callback function
 * @returns {undefined}
 * @example
 * function rpcImpl(method, requestData, callback) {
 *     if (protobuf.util.lcFirst(method.name) !== "myMethod") // compatible with static code
 *         throw Error("no such method");
 *     asynchronouslyObtainAResponse(requestData, function(err, responseData) {
 *         callback(err, responseData);
 *     });
 * }
 */ /**
 * Node-style callback as used by {@link RPCImpl}.
 * @typedef RPCImplCallback
 * @type {function}
 * @param {Error|null} error Error, if any, otherwise `null`
 * @param {Uint8Array|null} [response] Response data or `null` to signal end of stream, if there hasn't been an error
 * @returns {undefined}
 */ $9399c52e3a844204$var$rpc.Service = (parcelRequire("k0kEe"));

});
parcelRequire.register("k0kEe", function(module, exports) {
"use strict";
module.exports = $e903d2f6365c046a$var$Service;

var $fK14h = parcelRequire("fK14h");
// Extends EventEmitter
($e903d2f6365c046a$var$Service.prototype = Object.create($fK14h.EventEmitter.prototype)).constructor = $e903d2f6365c046a$var$Service;
/**
 * A service method callback as used by {@link rpc.ServiceMethod|ServiceMethod}.
 *
 * Differs from {@link RPCImplCallback} in that it is an actual callback of a service method which may not return `response = null`.
 * @typedef rpc.ServiceMethodCallback
 * @template TRes extends Message<TRes>
 * @type {function}
 * @param {Error|null} error Error, if any
 * @param {TRes} [response] Response message
 * @returns {undefined}
 */ /**
 * A service method part of a {@link rpc.Service} as created by {@link Service.create}.
 * @typedef rpc.ServiceMethod
 * @template TReq extends Message<TReq>
 * @template TRes extends Message<TRes>
 * @type {function}
 * @param {TReq|Properties<TReq>} request Request message or plain object
 * @param {rpc.ServiceMethodCallback<TRes>} [callback] Node-style callback called with the error, if any, and the response message
 * @returns {Promise<Message<TRes>>} Promise if `callback` has been omitted, otherwise `undefined`
 */ /**
 * Constructs a new RPC service instance.
 * @classdesc An RPC service as returned by {@link Service#create}.
 * @exports rpc.Service
 * @extends util.EventEmitter
 * @constructor
 * @param {RPCImpl} rpcImpl RPC implementation
 * @param {boolean} [requestDelimited=false] Whether requests are length-delimited
 * @param {boolean} [responseDelimited=false] Whether responses are length-delimited
 */ function $e903d2f6365c046a$var$Service(rpcImpl, requestDelimited, responseDelimited) {
    if (typeof rpcImpl !== "function") throw TypeError("rpcImpl must be a function");
    $fK14h.EventEmitter.call(this);
    /**
     * RPC implementation. Becomes `null` once the service is ended.
     * @type {RPCImpl|null}
     */ this.rpcImpl = rpcImpl;
    /**
     * Whether requests are length-delimited.
     * @type {boolean}
     */ this.requestDelimited = Boolean(requestDelimited);
    /**
     * Whether responses are length-delimited.
     * @type {boolean}
     */ this.responseDelimited = Boolean(responseDelimited);
}
/**
 * Calls a service method through {@link rpc.Service#rpcImpl|rpcImpl}.
 * @param {Method|rpc.ServiceMethod<TReq,TRes>} method Reflected or static method
 * @param {Constructor<TReq>} requestCtor Request constructor
 * @param {Constructor<TRes>} responseCtor Response constructor
 * @param {TReq|Properties<TReq>} request Request message or plain object
 * @param {rpc.ServiceMethodCallback<TRes>} callback Service callback
 * @returns {undefined}
 * @template TReq extends Message<TReq>
 * @template TRes extends Message<TRes>
 */ $e903d2f6365c046a$var$Service.prototype.rpcCall = function rpcCall(method, requestCtor, responseCtor, request, callback) {
    if (!request) throw TypeError("request must be specified");
    var self = this;
    if (!callback) return $fK14h.asPromise(rpcCall, self, method, requestCtor, responseCtor, request);
    if (!self.rpcImpl) {
        setTimeout(function() {
            callback(Error("already ended"));
        }, 0);
        return undefined;
    }
    try {
        return self.rpcImpl(method, requestCtor[self.requestDelimited ? "encodeDelimited" : "encode"](request).finish(), function rpcCallback(err, response) {
            if (err) {
                self.emit("error", err, method);
                return callback(err);
            }
            if (response === null) {
                self.end(/* endedByRPC */ true);
                return undefined;
            }
            if (!(response instanceof responseCtor)) try {
                response = responseCtor[self.responseDelimited ? "decodeDelimited" : "decode"](response);
            } catch (err) {
                self.emit("error", err, method);
                return callback(err);
            }
            self.emit("data", response, method);
            return callback(null, response);
        });
    } catch (err) {
        self.emit("error", err, method);
        setTimeout(function() {
            callback(err);
        }, 0);
        return undefined;
    }
};
/**
 * Ends this service and emits the `end` event.
 * @param {boolean} [endedByRPC=false] Whether the service has been ended by the RPC implementation.
 * @returns {rpc.Service} `this`
 */ $e903d2f6365c046a$var$Service.prototype.end = function end(endedByRPC) {
    if (this.rpcImpl) {
        if (!endedByRPC) this.rpcImpl(null, null, null);
        this.rpcImpl = null;
        this.emit("end").off();
    }
    return this;
};

});


parcelRequire.register("eFuHd", function(module, exports) {
"use strict";
module.exports = {}; /**
 * Named roots.
 * This is where pbjs stores generated structures (the option `-r, --root` specifies a name).
 * Can also be used manually to make roots available accross modules.
 * @name roots
 * @type {Object.<string,Root>}
 * @example
 * // pbjs -r myroot -o compiled.js ...
 *
 * // in another module:
 * require("./compiled.js");
 *
 * // in any subsequent module:
 * var root = protobuf.roots["myroot"];
 */ 

});



parcelRequire.register("jRkuS", function(module, exports) {
module.exports = $e752ddd240bc56a4$var$Long;
/**
 * wasm optimizations, to do native i64 multiplication and divide
 */ var $e752ddd240bc56a4$var$wasm = null;
try {
    $e752ddd240bc56a4$var$wasm = new WebAssembly.Instance(new WebAssembly.Module(new Uint8Array([
        0,
        97,
        115,
        109,
        1,
        0,
        0,
        0,
        1,
        13,
        2,
        96,
        0,
        1,
        127,
        96,
        4,
        127,
        127,
        127,
        127,
        1,
        127,
        3,
        7,
        6,
        0,
        1,
        1,
        1,
        1,
        1,
        6,
        6,
        1,
        127,
        1,
        65,
        0,
        11,
        7,
        50,
        6,
        3,
        109,
        117,
        108,
        0,
        1,
        5,
        100,
        105,
        118,
        95,
        115,
        0,
        2,
        5,
        100,
        105,
        118,
        95,
        117,
        0,
        3,
        5,
        114,
        101,
        109,
        95,
        115,
        0,
        4,
        5,
        114,
        101,
        109,
        95,
        117,
        0,
        5,
        8,
        103,
        101,
        116,
        95,
        104,
        105,
        103,
        104,
        0,
        0,
        10,
        191,
        1,
        6,
        4,
        0,
        35,
        0,
        11,
        36,
        1,
        1,
        126,
        32,
        0,
        173,
        32,
        1,
        173,
        66,
        32,
        134,
        132,
        32,
        2,
        173,
        32,
        3,
        173,
        66,
        32,
        134,
        132,
        126,
        34,
        4,
        66,
        32,
        135,
        167,
        36,
        0,
        32,
        4,
        167,
        11,
        36,
        1,
        1,
        126,
        32,
        0,
        173,
        32,
        1,
        173,
        66,
        32,
        134,
        132,
        32,
        2,
        173,
        32,
        3,
        173,
        66,
        32,
        134,
        132,
        127,
        34,
        4,
        66,
        32,
        135,
        167,
        36,
        0,
        32,
        4,
        167,
        11,
        36,
        1,
        1,
        126,
        32,
        0,
        173,
        32,
        1,
        173,
        66,
        32,
        134,
        132,
        32,
        2,
        173,
        32,
        3,
        173,
        66,
        32,
        134,
        132,
        128,
        34,
        4,
        66,
        32,
        135,
        167,
        36,
        0,
        32,
        4,
        167,
        11,
        36,
        1,
        1,
        126,
        32,
        0,
        173,
        32,
        1,
        173,
        66,
        32,
        134,
        132,
        32,
        2,
        173,
        32,
        3,
        173,
        66,
        32,
        134,
        132,
        129,
        34,
        4,
        66,
        32,
        135,
        167,
        36,
        0,
        32,
        4,
        167,
        11,
        36,
        1,
        1,
        126,
        32,
        0,
        173,
        32,
        1,
        173,
        66,
        32,
        134,
        132,
        32,
        2,
        173,
        32,
        3,
        173,
        66,
        32,
        134,
        132,
        130,
        34,
        4,
        66,
        32,
        135,
        167,
        36,
        0,
        32,
        4,
        167,
        11
    ])), {}).exports;
} catch (e) {
// no wasm support :(
}
/**
 * Constructs a 64 bit two's-complement integer, given its low and high 32 bit values as *signed* integers.
 *  See the from* functions below for more convenient ways of constructing Longs.
 * @exports Long
 * @class A Long class for representing a 64 bit two's-complement integer value.
 * @param {number} low The low (signed) 32 bits of the long
 * @param {number} high The high (signed) 32 bits of the long
 * @param {boolean=} unsigned Whether unsigned or not, defaults to signed
 * @constructor
 */ function $e752ddd240bc56a4$var$Long(low, high, unsigned) {
    /**
     * The low 32 bits as a signed value.
     * @type {number}
     */ this.low = low | 0;
    /**
     * The high 32 bits as a signed value.
     * @type {number}
     */ this.high = high | 0;
    /**
     * Whether unsigned or not.
     * @type {boolean}
     */ this.unsigned = !!unsigned;
}
// The internal representation of a long is the two given signed, 32-bit values.
// We use 32-bit pieces because these are the size of integers on which
// Javascript performs bit-operations.  For operations like addition and
// multiplication, we split each number into 16 bit pieces, which can easily be
// multiplied within Javascript's floating-point representation without overflow
// or change in sign.
//
// In the algorithms below, we frequently reduce the negative case to the
// positive case by negating the input(s) and then post-processing the result.
// Note that we must ALWAYS check specially whether those values are MIN_VALUE
// (-2^63) because -MIN_VALUE == MIN_VALUE (since 2^63 cannot be represented as
// a positive number, it overflows back into a negative).  Not handling this
// case would often result in infinite recursion.
//
// Common constant values ZERO, ONE, NEG_ONE, etc. are defined below the from*
// methods on which they depend.
/**
 * An indicator used to reliably determine if an object is a Long or not.
 * @type {boolean}
 * @const
 * @private
 */ $e752ddd240bc56a4$var$Long.prototype.__isLong__;
Object.defineProperty($e752ddd240bc56a4$var$Long.prototype, "__isLong__", {
    value: true
});
/**
 * @function
 * @param {*} obj Object
 * @returns {boolean}
 * @inner
 */ function $e752ddd240bc56a4$var$isLong(obj) {
    return (obj && obj["__isLong__"]) === true;
}
/**
 * Tests if the specified object is a Long.
 * @function
 * @param {*} obj Object
 * @returns {boolean}
 */ $e752ddd240bc56a4$var$Long.isLong = $e752ddd240bc56a4$var$isLong;
/**
 * A cache of the Long representations of small integer values.
 * @type {!Object}
 * @inner
 */ var $e752ddd240bc56a4$var$INT_CACHE = {};
/**
 * A cache of the Long representations of small unsigned integer values.
 * @type {!Object}
 * @inner
 */ var $e752ddd240bc56a4$var$UINT_CACHE = {};
/**
 * @param {number} value
 * @param {boolean=} unsigned
 * @returns {!Long}
 * @inner
 */ function $e752ddd240bc56a4$var$fromInt(value, unsigned) {
    var obj, cachedObj, cache;
    if (unsigned) {
        value >>>= 0;
        if (cache = 0 <= value && value < 256) {
            cachedObj = $e752ddd240bc56a4$var$UINT_CACHE[value];
            if (cachedObj) return cachedObj;
        }
        obj = $e752ddd240bc56a4$var$fromBits(value, (value | 0) < 0 ? -1 : 0, true);
        if (cache) $e752ddd240bc56a4$var$UINT_CACHE[value] = obj;
        return obj;
    } else {
        value |= 0;
        if (cache = -128 <= value && value < 128) {
            cachedObj = $e752ddd240bc56a4$var$INT_CACHE[value];
            if (cachedObj) return cachedObj;
        }
        obj = $e752ddd240bc56a4$var$fromBits(value, value < 0 ? -1 : 0, false);
        if (cache) $e752ddd240bc56a4$var$INT_CACHE[value] = obj;
        return obj;
    }
}
/**
 * Returns a Long representing the given 32 bit integer value.
 * @function
 * @param {number} value The 32 bit integer in question
 * @param {boolean=} unsigned Whether unsigned or not, defaults to signed
 * @returns {!Long} The corresponding Long value
 */ $e752ddd240bc56a4$var$Long.fromInt = $e752ddd240bc56a4$var$fromInt;
/**
 * @param {number} value
 * @param {boolean=} unsigned
 * @returns {!Long}
 * @inner
 */ function $e752ddd240bc56a4$var$fromNumber(value, unsigned) {
    if (isNaN(value)) return unsigned ? $e752ddd240bc56a4$var$UZERO : $e752ddd240bc56a4$var$ZERO;
    if (unsigned) {
        if (value < 0) return $e752ddd240bc56a4$var$UZERO;
        if (value >= $e752ddd240bc56a4$var$TWO_PWR_64_DBL) return $e752ddd240bc56a4$var$MAX_UNSIGNED_VALUE;
    } else {
        if (value <= -$e752ddd240bc56a4$var$TWO_PWR_63_DBL) return $e752ddd240bc56a4$var$MIN_VALUE;
        if (value + 1 >= $e752ddd240bc56a4$var$TWO_PWR_63_DBL) return $e752ddd240bc56a4$var$MAX_VALUE;
    }
    if (value < 0) return $e752ddd240bc56a4$var$fromNumber(-value, unsigned).neg();
    return $e752ddd240bc56a4$var$fromBits(value % $e752ddd240bc56a4$var$TWO_PWR_32_DBL | 0, value / $e752ddd240bc56a4$var$TWO_PWR_32_DBL | 0, unsigned);
}
/**
 * Returns a Long representing the given value, provided that it is a finite number. Otherwise, zero is returned.
 * @function
 * @param {number} value The number in question
 * @param {boolean=} unsigned Whether unsigned or not, defaults to signed
 * @returns {!Long} The corresponding Long value
 */ $e752ddd240bc56a4$var$Long.fromNumber = $e752ddd240bc56a4$var$fromNumber;
/**
 * @param {number} lowBits
 * @param {number} highBits
 * @param {boolean=} unsigned
 * @returns {!Long}
 * @inner
 */ function $e752ddd240bc56a4$var$fromBits(lowBits, highBits, unsigned) {
    return new $e752ddd240bc56a4$var$Long(lowBits, highBits, unsigned);
}
/**
 * Returns a Long representing the 64 bit integer that comes by concatenating the given low and high bits. Each is
 *  assumed to use 32 bits.
 * @function
 * @param {number} lowBits The low 32 bits
 * @param {number} highBits The high 32 bits
 * @param {boolean=} unsigned Whether unsigned or not, defaults to signed
 * @returns {!Long} The corresponding Long value
 */ $e752ddd240bc56a4$var$Long.fromBits = $e752ddd240bc56a4$var$fromBits;
/**
 * @function
 * @param {number} base
 * @param {number} exponent
 * @returns {number}
 * @inner
 */ var $e752ddd240bc56a4$var$pow_dbl = Math.pow; // Used 4 times (4*8 to 15+4)
/**
 * @param {string} str
 * @param {(boolean|number)=} unsigned
 * @param {number=} radix
 * @returns {!Long}
 * @inner
 */ function $e752ddd240bc56a4$var$fromString(str, unsigned, radix) {
    if (str.length === 0) throw Error("empty string");
    if (str === "NaN" || str === "Infinity" || str === "+Infinity" || str === "-Infinity") return $e752ddd240bc56a4$var$ZERO;
    if (typeof unsigned === "number") // For goog.math.long compatibility
    radix = unsigned, unsigned = false;
    else unsigned = !!unsigned;
    radix = radix || 10;
    if (radix < 2 || 36 < radix) throw RangeError("radix");
    var p;
    if ((p = str.indexOf("-")) > 0) throw Error("interior hyphen");
    else if (p === 0) return $e752ddd240bc56a4$var$fromString(str.substring(1), unsigned, radix).neg();
    // Do several (8) digits each time through the loop, so as to
    // minimize the calls to the very expensive emulated div.
    var radixToPower = $e752ddd240bc56a4$var$fromNumber($e752ddd240bc56a4$var$pow_dbl(radix, 8));
    var result = $e752ddd240bc56a4$var$ZERO;
    for(var i = 0; i < str.length; i += 8){
        var size = Math.min(8, str.length - i), value = parseInt(str.substring(i, i + size), radix);
        if (size < 8) {
            var power = $e752ddd240bc56a4$var$fromNumber($e752ddd240bc56a4$var$pow_dbl(radix, size));
            result = result.mul(power).add($e752ddd240bc56a4$var$fromNumber(value));
        } else {
            result = result.mul(radixToPower);
            result = result.add($e752ddd240bc56a4$var$fromNumber(value));
        }
    }
    result.unsigned = unsigned;
    return result;
}
/**
 * Returns a Long representation of the given string, written using the specified radix.
 * @function
 * @param {string} str The textual representation of the Long
 * @param {(boolean|number)=} unsigned Whether unsigned or not, defaults to signed
 * @param {number=} radix The radix in which the text is written (2-36), defaults to 10
 * @returns {!Long} The corresponding Long value
 */ $e752ddd240bc56a4$var$Long.fromString = $e752ddd240bc56a4$var$fromString;
/**
 * @function
 * @param {!Long|number|string|!{low: number, high: number, unsigned: boolean}} val
 * @param {boolean=} unsigned
 * @returns {!Long}
 * @inner
 */ function $e752ddd240bc56a4$var$fromValue(val, unsigned) {
    if (typeof val === "number") return $e752ddd240bc56a4$var$fromNumber(val, unsigned);
    if (typeof val === "string") return $e752ddd240bc56a4$var$fromString(val, unsigned);
    // Throws for non-objects, converts non-instanceof Long:
    return $e752ddd240bc56a4$var$fromBits(val.low, val.high, typeof unsigned === "boolean" ? unsigned : val.unsigned);
}
/**
 * Converts the specified value to a Long using the appropriate from* function for its type.
 * @function
 * @param {!Long|number|string|!{low: number, high: number, unsigned: boolean}} val Value
 * @param {boolean=} unsigned Whether unsigned or not, defaults to signed
 * @returns {!Long}
 */ $e752ddd240bc56a4$var$Long.fromValue = $e752ddd240bc56a4$var$fromValue;
// NOTE: the compiler should inline these constant values below and then remove these variables, so there should be
// no runtime penalty for these.
/**
 * @type {number}
 * @const
 * @inner
 */ var $e752ddd240bc56a4$var$TWO_PWR_16_DBL = 65536;
/**
 * @type {number}
 * @const
 * @inner
 */ var $e752ddd240bc56a4$var$TWO_PWR_24_DBL = 16777216;
/**
 * @type {number}
 * @const
 * @inner
 */ var $e752ddd240bc56a4$var$TWO_PWR_32_DBL = $e752ddd240bc56a4$var$TWO_PWR_16_DBL * $e752ddd240bc56a4$var$TWO_PWR_16_DBL;
/**
 * @type {number}
 * @const
 * @inner
 */ var $e752ddd240bc56a4$var$TWO_PWR_64_DBL = $e752ddd240bc56a4$var$TWO_PWR_32_DBL * $e752ddd240bc56a4$var$TWO_PWR_32_DBL;
/**
 * @type {number}
 * @const
 * @inner
 */ var $e752ddd240bc56a4$var$TWO_PWR_63_DBL = $e752ddd240bc56a4$var$TWO_PWR_64_DBL / 2;
/**
 * @type {!Long}
 * @const
 * @inner
 */ var $e752ddd240bc56a4$var$TWO_PWR_24 = $e752ddd240bc56a4$var$fromInt($e752ddd240bc56a4$var$TWO_PWR_24_DBL);
/**
 * @type {!Long}
 * @inner
 */ var $e752ddd240bc56a4$var$ZERO = $e752ddd240bc56a4$var$fromInt(0);
/**
 * Signed zero.
 * @type {!Long}
 */ $e752ddd240bc56a4$var$Long.ZERO = $e752ddd240bc56a4$var$ZERO;
/**
 * @type {!Long}
 * @inner
 */ var $e752ddd240bc56a4$var$UZERO = $e752ddd240bc56a4$var$fromInt(0, true);
/**
 * Unsigned zero.
 * @type {!Long}
 */ $e752ddd240bc56a4$var$Long.UZERO = $e752ddd240bc56a4$var$UZERO;
/**
 * @type {!Long}
 * @inner
 */ var $e752ddd240bc56a4$var$ONE = $e752ddd240bc56a4$var$fromInt(1);
/**
 * Signed one.
 * @type {!Long}
 */ $e752ddd240bc56a4$var$Long.ONE = $e752ddd240bc56a4$var$ONE;
/**
 * @type {!Long}
 * @inner
 */ var $e752ddd240bc56a4$var$UONE = $e752ddd240bc56a4$var$fromInt(1, true);
/**
 * Unsigned one.
 * @type {!Long}
 */ $e752ddd240bc56a4$var$Long.UONE = $e752ddd240bc56a4$var$UONE;
/**
 * @type {!Long}
 * @inner
 */ var $e752ddd240bc56a4$var$NEG_ONE = $e752ddd240bc56a4$var$fromInt(-1);
/**
 * Signed negative one.
 * @type {!Long}
 */ $e752ddd240bc56a4$var$Long.NEG_ONE = $e752ddd240bc56a4$var$NEG_ONE;
/**
 * @type {!Long}
 * @inner
 */ var $e752ddd240bc56a4$var$MAX_VALUE = $e752ddd240bc56a4$var$fromBits(-1, 2147483647, false);
/**
 * Maximum signed value.
 * @type {!Long}
 */ $e752ddd240bc56a4$var$Long.MAX_VALUE = $e752ddd240bc56a4$var$MAX_VALUE;
/**
 * @type {!Long}
 * @inner
 */ var $e752ddd240bc56a4$var$MAX_UNSIGNED_VALUE = $e752ddd240bc56a4$var$fromBits(-1, -1, true);
/**
 * Maximum unsigned value.
 * @type {!Long}
 */ $e752ddd240bc56a4$var$Long.MAX_UNSIGNED_VALUE = $e752ddd240bc56a4$var$MAX_UNSIGNED_VALUE;
/**
 * @type {!Long}
 * @inner
 */ var $e752ddd240bc56a4$var$MIN_VALUE = $e752ddd240bc56a4$var$fromBits(0, -2147483648, false);
/**
 * Minimum signed value.
 * @type {!Long}
 */ $e752ddd240bc56a4$var$Long.MIN_VALUE = $e752ddd240bc56a4$var$MIN_VALUE;
/**
 * @alias Long.prototype
 * @inner
 */ var $e752ddd240bc56a4$var$LongPrototype = $e752ddd240bc56a4$var$Long.prototype;
/**
 * Converts the Long to a 32 bit integer, assuming it is a 32 bit integer.
 * @returns {number}
 */ $e752ddd240bc56a4$var$LongPrototype.toInt = function toInt() {
    return this.unsigned ? this.low >>> 0 : this.low;
};
/**
 * Converts the Long to a the nearest floating-point representation of this value (double, 53 bit mantissa).
 * @returns {number}
 */ $e752ddd240bc56a4$var$LongPrototype.toNumber = function toNumber() {
    if (this.unsigned) return (this.high >>> 0) * $e752ddd240bc56a4$var$TWO_PWR_32_DBL + (this.low >>> 0);
    return this.high * $e752ddd240bc56a4$var$TWO_PWR_32_DBL + (this.low >>> 0);
};
/**
 * Converts the Long to a string written in the specified radix.
 * @param {number=} radix Radix (2-36), defaults to 10
 * @returns {string}
 * @override
 * @throws {RangeError} If `radix` is out of range
 */ $e752ddd240bc56a4$var$LongPrototype.toString = function toString(radix) {
    radix = radix || 10;
    if (radix < 2 || 36 < radix) throw RangeError("radix");
    if (this.isZero()) return "0";
    if (this.isNegative()) {
        if (this.eq($e752ddd240bc56a4$var$MIN_VALUE)) {
            // We need to change the Long value before it can be negated, so we remove
            // the bottom-most digit in this base and then recurse to do the rest.
            var radixLong = $e752ddd240bc56a4$var$fromNumber(radix), div = this.div(radixLong), rem1 = div.mul(radixLong).sub(this);
            return div.toString(radix) + rem1.toInt().toString(radix);
        } else return "-" + this.neg().toString(radix);
    }
    // Do several (6) digits each time through the loop, so as to
    // minimize the calls to the very expensive emulated div.
    var radixToPower = $e752ddd240bc56a4$var$fromNumber($e752ddd240bc56a4$var$pow_dbl(radix, 6), this.unsigned), rem = this;
    var result = "";
    while(true){
        var remDiv = rem.div(radixToPower), intval = rem.sub(remDiv.mul(radixToPower)).toInt() >>> 0, digits = intval.toString(radix);
        rem = remDiv;
        if (rem.isZero()) return digits + result;
        else {
            while(digits.length < 6)digits = "0" + digits;
            result = "" + digits + result;
        }
    }
};
/**
 * Gets the high 32 bits as a signed integer.
 * @returns {number} Signed high bits
 */ $e752ddd240bc56a4$var$LongPrototype.getHighBits = function getHighBits() {
    return this.high;
};
/**
 * Gets the high 32 bits as an unsigned integer.
 * @returns {number} Unsigned high bits
 */ $e752ddd240bc56a4$var$LongPrototype.getHighBitsUnsigned = function getHighBitsUnsigned() {
    return this.high >>> 0;
};
/**
 * Gets the low 32 bits as a signed integer.
 * @returns {number} Signed low bits
 */ $e752ddd240bc56a4$var$LongPrototype.getLowBits = function getLowBits() {
    return this.low;
};
/**
 * Gets the low 32 bits as an unsigned integer.
 * @returns {number} Unsigned low bits
 */ $e752ddd240bc56a4$var$LongPrototype.getLowBitsUnsigned = function getLowBitsUnsigned() {
    return this.low >>> 0;
};
/**
 * Gets the number of bits needed to represent the absolute value of this Long.
 * @returns {number}
 */ $e752ddd240bc56a4$var$LongPrototype.getNumBitsAbs = function getNumBitsAbs() {
    if (this.isNegative()) return this.eq($e752ddd240bc56a4$var$MIN_VALUE) ? 64 : this.neg().getNumBitsAbs();
    var val = this.high != 0 ? this.high : this.low;
    for(var bit = 31; bit > 0; bit--)if ((val & 1 << bit) != 0) break;
    return this.high != 0 ? bit + 33 : bit + 1;
};
/**
 * Tests if this Long's value equals zero.
 * @returns {boolean}
 */ $e752ddd240bc56a4$var$LongPrototype.isZero = function isZero() {
    return this.high === 0 && this.low === 0;
};
/**
 * Tests if this Long's value equals zero. This is an alias of {@link Long#isZero}.
 * @returns {boolean}
 */ $e752ddd240bc56a4$var$LongPrototype.eqz = $e752ddd240bc56a4$var$LongPrototype.isZero;
/**
 * Tests if this Long's value is negative.
 * @returns {boolean}
 */ $e752ddd240bc56a4$var$LongPrototype.isNegative = function isNegative() {
    return !this.unsigned && this.high < 0;
};
/**
 * Tests if this Long's value is positive.
 * @returns {boolean}
 */ $e752ddd240bc56a4$var$LongPrototype.isPositive = function isPositive() {
    return this.unsigned || this.high >= 0;
};
/**
 * Tests if this Long's value is odd.
 * @returns {boolean}
 */ $e752ddd240bc56a4$var$LongPrototype.isOdd = function isOdd() {
    return (this.low & 1) === 1;
};
/**
 * Tests if this Long's value is even.
 * @returns {boolean}
 */ $e752ddd240bc56a4$var$LongPrototype.isEven = function isEven() {
    return (this.low & 1) === 0;
};
/**
 * Tests if this Long's value equals the specified's.
 * @param {!Long|number|string} other Other value
 * @returns {boolean}
 */ $e752ddd240bc56a4$var$LongPrototype.equals = function equals(other) {
    if (!$e752ddd240bc56a4$var$isLong(other)) other = $e752ddd240bc56a4$var$fromValue(other);
    if (this.unsigned !== other.unsigned && this.high >>> 31 === 1 && other.high >>> 31 === 1) return false;
    return this.high === other.high && this.low === other.low;
};
/**
 * Tests if this Long's value equals the specified's. This is an alias of {@link Long#equals}.
 * @function
 * @param {!Long|number|string} other Other value
 * @returns {boolean}
 */ $e752ddd240bc56a4$var$LongPrototype.eq = $e752ddd240bc56a4$var$LongPrototype.equals;
/**
 * Tests if this Long's value differs from the specified's.
 * @param {!Long|number|string} other Other value
 * @returns {boolean}
 */ $e752ddd240bc56a4$var$LongPrototype.notEquals = function notEquals(other) {
    return !this.eq(/* validates */ other);
};
/**
 * Tests if this Long's value differs from the specified's. This is an alias of {@link Long#notEquals}.
 * @function
 * @param {!Long|number|string} other Other value
 * @returns {boolean}
 */ $e752ddd240bc56a4$var$LongPrototype.neq = $e752ddd240bc56a4$var$LongPrototype.notEquals;
/**
 * Tests if this Long's value differs from the specified's. This is an alias of {@link Long#notEquals}.
 * @function
 * @param {!Long|number|string} other Other value
 * @returns {boolean}
 */ $e752ddd240bc56a4$var$LongPrototype.ne = $e752ddd240bc56a4$var$LongPrototype.notEquals;
/**
 * Tests if this Long's value is less than the specified's.
 * @param {!Long|number|string} other Other value
 * @returns {boolean}
 */ $e752ddd240bc56a4$var$LongPrototype.lessThan = function lessThan(other) {
    return this.comp(/* validates */ other) < 0;
};
/**
 * Tests if this Long's value is less than the specified's. This is an alias of {@link Long#lessThan}.
 * @function
 * @param {!Long|number|string} other Other value
 * @returns {boolean}
 */ $e752ddd240bc56a4$var$LongPrototype.lt = $e752ddd240bc56a4$var$LongPrototype.lessThan;
/**
 * Tests if this Long's value is less than or equal the specified's.
 * @param {!Long|number|string} other Other value
 * @returns {boolean}
 */ $e752ddd240bc56a4$var$LongPrototype.lessThanOrEqual = function lessThanOrEqual(other) {
    return this.comp(/* validates */ other) <= 0;
};
/**
 * Tests if this Long's value is less than or equal the specified's. This is an alias of {@link Long#lessThanOrEqual}.
 * @function
 * @param {!Long|number|string} other Other value
 * @returns {boolean}
 */ $e752ddd240bc56a4$var$LongPrototype.lte = $e752ddd240bc56a4$var$LongPrototype.lessThanOrEqual;
/**
 * Tests if this Long's value is less than or equal the specified's. This is an alias of {@link Long#lessThanOrEqual}.
 * @function
 * @param {!Long|number|string} other Other value
 * @returns {boolean}
 */ $e752ddd240bc56a4$var$LongPrototype.le = $e752ddd240bc56a4$var$LongPrototype.lessThanOrEqual;
/**
 * Tests if this Long's value is greater than the specified's.
 * @param {!Long|number|string} other Other value
 * @returns {boolean}
 */ $e752ddd240bc56a4$var$LongPrototype.greaterThan = function greaterThan(other) {
    return this.comp(/* validates */ other) > 0;
};
/**
 * Tests if this Long's value is greater than the specified's. This is an alias of {@link Long#greaterThan}.
 * @function
 * @param {!Long|number|string} other Other value
 * @returns {boolean}
 */ $e752ddd240bc56a4$var$LongPrototype.gt = $e752ddd240bc56a4$var$LongPrototype.greaterThan;
/**
 * Tests if this Long's value is greater than or equal the specified's.
 * @param {!Long|number|string} other Other value
 * @returns {boolean}
 */ $e752ddd240bc56a4$var$LongPrototype.greaterThanOrEqual = function greaterThanOrEqual(other) {
    return this.comp(/* validates */ other) >= 0;
};
/**
 * Tests if this Long's value is greater than or equal the specified's. This is an alias of {@link Long#greaterThanOrEqual}.
 * @function
 * @param {!Long|number|string} other Other value
 * @returns {boolean}
 */ $e752ddd240bc56a4$var$LongPrototype.gte = $e752ddd240bc56a4$var$LongPrototype.greaterThanOrEqual;
/**
 * Tests if this Long's value is greater than or equal the specified's. This is an alias of {@link Long#greaterThanOrEqual}.
 * @function
 * @param {!Long|number|string} other Other value
 * @returns {boolean}
 */ $e752ddd240bc56a4$var$LongPrototype.ge = $e752ddd240bc56a4$var$LongPrototype.greaterThanOrEqual;
/**
 * Compares this Long's value with the specified's.
 * @param {!Long|number|string} other Other value
 * @returns {number} 0 if they are the same, 1 if the this is greater and -1
 *  if the given one is greater
 */ $e752ddd240bc56a4$var$LongPrototype.compare = function compare(other) {
    if (!$e752ddd240bc56a4$var$isLong(other)) other = $e752ddd240bc56a4$var$fromValue(other);
    if (this.eq(other)) return 0;
    var thisNeg = this.isNegative(), otherNeg = other.isNegative();
    if (thisNeg && !otherNeg) return -1;
    if (!thisNeg && otherNeg) return 1;
    // At this point the sign bits are the same
    if (!this.unsigned) return this.sub(other).isNegative() ? -1 : 1;
    // Both are positive if at least one is unsigned
    return other.high >>> 0 > this.high >>> 0 || other.high === this.high && other.low >>> 0 > this.low >>> 0 ? -1 : 1;
};
/**
 * Compares this Long's value with the specified's. This is an alias of {@link Long#compare}.
 * @function
 * @param {!Long|number|string} other Other value
 * @returns {number} 0 if they are the same, 1 if the this is greater and -1
 *  if the given one is greater
 */ $e752ddd240bc56a4$var$LongPrototype.comp = $e752ddd240bc56a4$var$LongPrototype.compare;
/**
 * Negates this Long's value.
 * @returns {!Long} Negated Long
 */ $e752ddd240bc56a4$var$LongPrototype.negate = function negate() {
    if (!this.unsigned && this.eq($e752ddd240bc56a4$var$MIN_VALUE)) return $e752ddd240bc56a4$var$MIN_VALUE;
    return this.not().add($e752ddd240bc56a4$var$ONE);
};
/**
 * Negates this Long's value. This is an alias of {@link Long#negate}.
 * @function
 * @returns {!Long} Negated Long
 */ $e752ddd240bc56a4$var$LongPrototype.neg = $e752ddd240bc56a4$var$LongPrototype.negate;
/**
 * Returns the sum of this and the specified Long.
 * @param {!Long|number|string} addend Addend
 * @returns {!Long} Sum
 */ $e752ddd240bc56a4$var$LongPrototype.add = function add(addend) {
    if (!$e752ddd240bc56a4$var$isLong(addend)) addend = $e752ddd240bc56a4$var$fromValue(addend);
    // Divide each number into 4 chunks of 16 bits, and then sum the chunks.
    var a48 = this.high >>> 16;
    var a32 = this.high & 0xFFFF;
    var a16 = this.low >>> 16;
    var a00 = this.low & 0xFFFF;
    var b48 = addend.high >>> 16;
    var b32 = addend.high & 0xFFFF;
    var b16 = addend.low >>> 16;
    var b00 = addend.low & 0xFFFF;
    var c48 = 0, c32 = 0, c16 = 0, c00 = 0;
    c00 += a00 + b00;
    c16 += c00 >>> 16;
    c00 &= 0xFFFF;
    c16 += a16 + b16;
    c32 += c16 >>> 16;
    c16 &= 0xFFFF;
    c32 += a32 + b32;
    c48 += c32 >>> 16;
    c32 &= 0xFFFF;
    c48 += a48 + b48;
    c48 &= 0xFFFF;
    return $e752ddd240bc56a4$var$fromBits(c16 << 16 | c00, c48 << 16 | c32, this.unsigned);
};
/**
 * Returns the difference of this and the specified Long.
 * @param {!Long|number|string} subtrahend Subtrahend
 * @returns {!Long} Difference
 */ $e752ddd240bc56a4$var$LongPrototype.subtract = function subtract(subtrahend) {
    if (!$e752ddd240bc56a4$var$isLong(subtrahend)) subtrahend = $e752ddd240bc56a4$var$fromValue(subtrahend);
    return this.add(subtrahend.neg());
};
/**
 * Returns the difference of this and the specified Long. This is an alias of {@link Long#subtract}.
 * @function
 * @param {!Long|number|string} subtrahend Subtrahend
 * @returns {!Long} Difference
 */ $e752ddd240bc56a4$var$LongPrototype.sub = $e752ddd240bc56a4$var$LongPrototype.subtract;
/**
 * Returns the product of this and the specified Long.
 * @param {!Long|number|string} multiplier Multiplier
 * @returns {!Long} Product
 */ $e752ddd240bc56a4$var$LongPrototype.multiply = function multiply(multiplier) {
    if (this.isZero()) return $e752ddd240bc56a4$var$ZERO;
    if (!$e752ddd240bc56a4$var$isLong(multiplier)) multiplier = $e752ddd240bc56a4$var$fromValue(multiplier);
    // use wasm support if present
    if ($e752ddd240bc56a4$var$wasm) {
        var low = $e752ddd240bc56a4$var$wasm.mul(this.low, this.high, multiplier.low, multiplier.high);
        return $e752ddd240bc56a4$var$fromBits(low, $e752ddd240bc56a4$var$wasm.get_high(), this.unsigned);
    }
    if (multiplier.isZero()) return $e752ddd240bc56a4$var$ZERO;
    if (this.eq($e752ddd240bc56a4$var$MIN_VALUE)) return multiplier.isOdd() ? $e752ddd240bc56a4$var$MIN_VALUE : $e752ddd240bc56a4$var$ZERO;
    if (multiplier.eq($e752ddd240bc56a4$var$MIN_VALUE)) return this.isOdd() ? $e752ddd240bc56a4$var$MIN_VALUE : $e752ddd240bc56a4$var$ZERO;
    if (this.isNegative()) {
        if (multiplier.isNegative()) return this.neg().mul(multiplier.neg());
        else return this.neg().mul(multiplier).neg();
    } else if (multiplier.isNegative()) return this.mul(multiplier.neg()).neg();
    // If both longs are small, use float multiplication
    if (this.lt($e752ddd240bc56a4$var$TWO_PWR_24) && multiplier.lt($e752ddd240bc56a4$var$TWO_PWR_24)) return $e752ddd240bc56a4$var$fromNumber(this.toNumber() * multiplier.toNumber(), this.unsigned);
    // Divide each long into 4 chunks of 16 bits, and then add up 4x4 products.
    // We can skip products that would overflow.
    var a48 = this.high >>> 16;
    var a32 = this.high & 0xFFFF;
    var a16 = this.low >>> 16;
    var a00 = this.low & 0xFFFF;
    var b48 = multiplier.high >>> 16;
    var b32 = multiplier.high & 0xFFFF;
    var b16 = multiplier.low >>> 16;
    var b00 = multiplier.low & 0xFFFF;
    var c48 = 0, c32 = 0, c16 = 0, c00 = 0;
    c00 += a00 * b00;
    c16 += c00 >>> 16;
    c00 &= 0xFFFF;
    c16 += a16 * b00;
    c32 += c16 >>> 16;
    c16 &= 0xFFFF;
    c16 += a00 * b16;
    c32 += c16 >>> 16;
    c16 &= 0xFFFF;
    c32 += a32 * b00;
    c48 += c32 >>> 16;
    c32 &= 0xFFFF;
    c32 += a16 * b16;
    c48 += c32 >>> 16;
    c32 &= 0xFFFF;
    c32 += a00 * b32;
    c48 += c32 >>> 16;
    c32 &= 0xFFFF;
    c48 += a48 * b00 + a32 * b16 + a16 * b32 + a00 * b48;
    c48 &= 0xFFFF;
    return $e752ddd240bc56a4$var$fromBits(c16 << 16 | c00, c48 << 16 | c32, this.unsigned);
};
/**
 * Returns the product of this and the specified Long. This is an alias of {@link Long#multiply}.
 * @function
 * @param {!Long|number|string} multiplier Multiplier
 * @returns {!Long} Product
 */ $e752ddd240bc56a4$var$LongPrototype.mul = $e752ddd240bc56a4$var$LongPrototype.multiply;
/**
 * Returns this Long divided by the specified. The result is signed if this Long is signed or
 *  unsigned if this Long is unsigned.
 * @param {!Long|number|string} divisor Divisor
 * @returns {!Long} Quotient
 */ $e752ddd240bc56a4$var$LongPrototype.divide = function divide(divisor) {
    if (!$e752ddd240bc56a4$var$isLong(divisor)) divisor = $e752ddd240bc56a4$var$fromValue(divisor);
    if (divisor.isZero()) throw Error("division by zero");
    // use wasm support if present
    if ($e752ddd240bc56a4$var$wasm) {
        // guard against signed division overflow: the largest
        // negative number / -1 would be 1 larger than the largest
        // positive number, due to two's complement.
        if (!this.unsigned && this.high === -2147483648 && divisor.low === -1 && divisor.high === -1) // be consistent with non-wasm code path
        return this;
        var low = (this.unsigned ? $e752ddd240bc56a4$var$wasm.div_u : $e752ddd240bc56a4$var$wasm.div_s)(this.low, this.high, divisor.low, divisor.high);
        return $e752ddd240bc56a4$var$fromBits(low, $e752ddd240bc56a4$var$wasm.get_high(), this.unsigned);
    }
    if (this.isZero()) return this.unsigned ? $e752ddd240bc56a4$var$UZERO : $e752ddd240bc56a4$var$ZERO;
    var approx, rem, res;
    if (!this.unsigned) {
        // This section is only relevant for signed longs and is derived from the
        // closure library as a whole.
        if (this.eq($e752ddd240bc56a4$var$MIN_VALUE)) {
            if (divisor.eq($e752ddd240bc56a4$var$ONE) || divisor.eq($e752ddd240bc56a4$var$NEG_ONE)) return $e752ddd240bc56a4$var$MIN_VALUE; // recall that -MIN_VALUE == MIN_VALUE
            else if (divisor.eq($e752ddd240bc56a4$var$MIN_VALUE)) return $e752ddd240bc56a4$var$ONE;
            else {
                // At this point, we have |other| >= 2, so |this/other| < |MIN_VALUE|.
                var halfThis = this.shr(1);
                approx = halfThis.div(divisor).shl(1);
                if (approx.eq($e752ddd240bc56a4$var$ZERO)) return divisor.isNegative() ? $e752ddd240bc56a4$var$ONE : $e752ddd240bc56a4$var$NEG_ONE;
                else {
                    rem = this.sub(divisor.mul(approx));
                    res = approx.add(rem.div(divisor));
                    return res;
                }
            }
        } else if (divisor.eq($e752ddd240bc56a4$var$MIN_VALUE)) return this.unsigned ? $e752ddd240bc56a4$var$UZERO : $e752ddd240bc56a4$var$ZERO;
        if (this.isNegative()) {
            if (divisor.isNegative()) return this.neg().div(divisor.neg());
            return this.neg().div(divisor).neg();
        } else if (divisor.isNegative()) return this.div(divisor.neg()).neg();
        res = $e752ddd240bc56a4$var$ZERO;
    } else {
        // The algorithm below has not been made for unsigned longs. It's therefore
        // required to take special care of the MSB prior to running it.
        if (!divisor.unsigned) divisor = divisor.toUnsigned();
        if (divisor.gt(this)) return $e752ddd240bc56a4$var$UZERO;
        if (divisor.gt(this.shru(1))) return $e752ddd240bc56a4$var$UONE;
        res = $e752ddd240bc56a4$var$UZERO;
    }
    // Repeat the following until the remainder is less than other:  find a
    // floating-point that approximates remainder / other *from below*, add this
    // into the result, and subtract it from the remainder.  It is critical that
    // the approximate value is less than or equal to the real value so that the
    // remainder never becomes negative.
    rem = this;
    while(rem.gte(divisor)){
        // Approximate the result of division. This may be a little greater or
        // smaller than the actual value.
        approx = Math.max(1, Math.floor(rem.toNumber() / divisor.toNumber()));
        // We will tweak the approximate result by changing it in the 48-th digit or
        // the smallest non-fractional digit, whichever is larger.
        var log2 = Math.ceil(Math.log(approx) / Math.LN2), delta = log2 <= 48 ? 1 : $e752ddd240bc56a4$var$pow_dbl(2, log2 - 48), // Decrease the approximation until it is smaller than the remainder.  Note
        // that if it is too large, the product overflows and is negative.
        approxRes = $e752ddd240bc56a4$var$fromNumber(approx), approxRem = approxRes.mul(divisor);
        while(approxRem.isNegative() || approxRem.gt(rem)){
            approx -= delta;
            approxRes = $e752ddd240bc56a4$var$fromNumber(approx, this.unsigned);
            approxRem = approxRes.mul(divisor);
        }
        // We know the answer can't be zero... and actually, zero would cause
        // infinite recursion since we would make no progress.
        if (approxRes.isZero()) approxRes = $e752ddd240bc56a4$var$ONE;
        res = res.add(approxRes);
        rem = rem.sub(approxRem);
    }
    return res;
};
/**
 * Returns this Long divided by the specified. This is an alias of {@link Long#divide}.
 * @function
 * @param {!Long|number|string} divisor Divisor
 * @returns {!Long} Quotient
 */ $e752ddd240bc56a4$var$LongPrototype.div = $e752ddd240bc56a4$var$LongPrototype.divide;
/**
 * Returns this Long modulo the specified.
 * @param {!Long|number|string} divisor Divisor
 * @returns {!Long} Remainder
 */ $e752ddd240bc56a4$var$LongPrototype.modulo = function modulo(divisor) {
    if (!$e752ddd240bc56a4$var$isLong(divisor)) divisor = $e752ddd240bc56a4$var$fromValue(divisor);
    // use wasm support if present
    if ($e752ddd240bc56a4$var$wasm) {
        var low = (this.unsigned ? $e752ddd240bc56a4$var$wasm.rem_u : $e752ddd240bc56a4$var$wasm.rem_s)(this.low, this.high, divisor.low, divisor.high);
        return $e752ddd240bc56a4$var$fromBits(low, $e752ddd240bc56a4$var$wasm.get_high(), this.unsigned);
    }
    return this.sub(this.div(divisor).mul(divisor));
};
/**
 * Returns this Long modulo the specified. This is an alias of {@link Long#modulo}.
 * @function
 * @param {!Long|number|string} divisor Divisor
 * @returns {!Long} Remainder
 */ $e752ddd240bc56a4$var$LongPrototype.mod = $e752ddd240bc56a4$var$LongPrototype.modulo;
/**
 * Returns this Long modulo the specified. This is an alias of {@link Long#modulo}.
 * @function
 * @param {!Long|number|string} divisor Divisor
 * @returns {!Long} Remainder
 */ $e752ddd240bc56a4$var$LongPrototype.rem = $e752ddd240bc56a4$var$LongPrototype.modulo;
/**
 * Returns the bitwise NOT of this Long.
 * @returns {!Long}
 */ $e752ddd240bc56a4$var$LongPrototype.not = function not() {
    return $e752ddd240bc56a4$var$fromBits(~this.low, ~this.high, this.unsigned);
};
/**
 * Returns the bitwise AND of this Long and the specified.
 * @param {!Long|number|string} other Other Long
 * @returns {!Long}
 */ $e752ddd240bc56a4$var$LongPrototype.and = function and(other) {
    if (!$e752ddd240bc56a4$var$isLong(other)) other = $e752ddd240bc56a4$var$fromValue(other);
    return $e752ddd240bc56a4$var$fromBits(this.low & other.low, this.high & other.high, this.unsigned);
};
/**
 * Returns the bitwise OR of this Long and the specified.
 * @param {!Long|number|string} other Other Long
 * @returns {!Long}
 */ $e752ddd240bc56a4$var$LongPrototype.or = function or(other) {
    if (!$e752ddd240bc56a4$var$isLong(other)) other = $e752ddd240bc56a4$var$fromValue(other);
    return $e752ddd240bc56a4$var$fromBits(this.low | other.low, this.high | other.high, this.unsigned);
};
/**
 * Returns the bitwise XOR of this Long and the given one.
 * @param {!Long|number|string} other Other Long
 * @returns {!Long}
 */ $e752ddd240bc56a4$var$LongPrototype.xor = function xor(other) {
    if (!$e752ddd240bc56a4$var$isLong(other)) other = $e752ddd240bc56a4$var$fromValue(other);
    return $e752ddd240bc56a4$var$fromBits(this.low ^ other.low, this.high ^ other.high, this.unsigned);
};
/**
 * Returns this Long with bits shifted to the left by the given amount.
 * @param {number|!Long} numBits Number of bits
 * @returns {!Long} Shifted Long
 */ $e752ddd240bc56a4$var$LongPrototype.shiftLeft = function shiftLeft(numBits) {
    if ($e752ddd240bc56a4$var$isLong(numBits)) numBits = numBits.toInt();
    if ((numBits &= 63) === 0) return this;
    else if (numBits < 32) return $e752ddd240bc56a4$var$fromBits(this.low << numBits, this.high << numBits | this.low >>> 32 - numBits, this.unsigned);
    else return $e752ddd240bc56a4$var$fromBits(0, this.low << numBits - 32, this.unsigned);
};
/**
 * Returns this Long with bits shifted to the left by the given amount. This is an alias of {@link Long#shiftLeft}.
 * @function
 * @param {number|!Long} numBits Number of bits
 * @returns {!Long} Shifted Long
 */ $e752ddd240bc56a4$var$LongPrototype.shl = $e752ddd240bc56a4$var$LongPrototype.shiftLeft;
/**
 * Returns this Long with bits arithmetically shifted to the right by the given amount.
 * @param {number|!Long} numBits Number of bits
 * @returns {!Long} Shifted Long
 */ $e752ddd240bc56a4$var$LongPrototype.shiftRight = function shiftRight(numBits) {
    if ($e752ddd240bc56a4$var$isLong(numBits)) numBits = numBits.toInt();
    if ((numBits &= 63) === 0) return this;
    else if (numBits < 32) return $e752ddd240bc56a4$var$fromBits(this.low >>> numBits | this.high << 32 - numBits, this.high >> numBits, this.unsigned);
    else return $e752ddd240bc56a4$var$fromBits(this.high >> numBits - 32, this.high >= 0 ? 0 : -1, this.unsigned);
};
/**
 * Returns this Long with bits arithmetically shifted to the right by the given amount. This is an alias of {@link Long#shiftRight}.
 * @function
 * @param {number|!Long} numBits Number of bits
 * @returns {!Long} Shifted Long
 */ $e752ddd240bc56a4$var$LongPrototype.shr = $e752ddd240bc56a4$var$LongPrototype.shiftRight;
/**
 * Returns this Long with bits logically shifted to the right by the given amount.
 * @param {number|!Long} numBits Number of bits
 * @returns {!Long} Shifted Long
 */ $e752ddd240bc56a4$var$LongPrototype.shiftRightUnsigned = function shiftRightUnsigned(numBits) {
    if ($e752ddd240bc56a4$var$isLong(numBits)) numBits = numBits.toInt();
    numBits &= 63;
    if (numBits === 0) return this;
    else {
        var high = this.high;
        if (numBits < 32) {
            var low = this.low;
            return $e752ddd240bc56a4$var$fromBits(low >>> numBits | high << 32 - numBits, high >>> numBits, this.unsigned);
        } else if (numBits === 32) return $e752ddd240bc56a4$var$fromBits(high, 0, this.unsigned);
        else return $e752ddd240bc56a4$var$fromBits(high >>> numBits - 32, 0, this.unsigned);
    }
};
/**
 * Returns this Long with bits logically shifted to the right by the given amount. This is an alias of {@link Long#shiftRightUnsigned}.
 * @function
 * @param {number|!Long} numBits Number of bits
 * @returns {!Long} Shifted Long
 */ $e752ddd240bc56a4$var$LongPrototype.shru = $e752ddd240bc56a4$var$LongPrototype.shiftRightUnsigned;
/**
 * Returns this Long with bits logically shifted to the right by the given amount. This is an alias of {@link Long#shiftRightUnsigned}.
 * @function
 * @param {number|!Long} numBits Number of bits
 * @returns {!Long} Shifted Long
 */ $e752ddd240bc56a4$var$LongPrototype.shr_u = $e752ddd240bc56a4$var$LongPrototype.shiftRightUnsigned;
/**
 * Converts this Long to signed.
 * @returns {!Long} Signed long
 */ $e752ddd240bc56a4$var$LongPrototype.toSigned = function toSigned() {
    if (!this.unsigned) return this;
    return $e752ddd240bc56a4$var$fromBits(this.low, this.high, false);
};
/**
 * Converts this Long to unsigned.
 * @returns {!Long} Unsigned long
 */ $e752ddd240bc56a4$var$LongPrototype.toUnsigned = function toUnsigned() {
    if (this.unsigned) return this;
    return $e752ddd240bc56a4$var$fromBits(this.low, this.high, true);
};
/**
 * Converts this Long to its byte representation.
 * @param {boolean=} le Whether little or big endian, defaults to big endian
 * @returns {!Array.<number>} Byte representation
 */ $e752ddd240bc56a4$var$LongPrototype.toBytes = function toBytes(le) {
    return le ? this.toBytesLE() : this.toBytesBE();
};
/**
 * Converts this Long to its little endian byte representation.
 * @returns {!Array.<number>} Little endian byte representation
 */ $e752ddd240bc56a4$var$LongPrototype.toBytesLE = function toBytesLE() {
    var hi = this.high, lo = this.low;
    return [
        lo & 0xff,
        lo >>> 8 & 0xff,
        lo >>> 16 & 0xff,
        lo >>> 24,
        hi & 0xff,
        hi >>> 8 & 0xff,
        hi >>> 16 & 0xff,
        hi >>> 24
    ];
};
/**
 * Converts this Long to its big endian byte representation.
 * @returns {!Array.<number>} Big endian byte representation
 */ $e752ddd240bc56a4$var$LongPrototype.toBytesBE = function toBytesBE() {
    var hi = this.high, lo = this.low;
    return [
        hi >>> 24,
        hi >>> 16 & 0xff,
        hi >>> 8 & 0xff,
        hi & 0xff,
        lo >>> 24,
        lo >>> 16 & 0xff,
        lo >>> 8 & 0xff,
        lo & 0xff
    ];
};
/**
 * Creates a Long from its byte representation.
 * @param {!Array.<number>} bytes Byte representation
 * @param {boolean=} unsigned Whether unsigned or not, defaults to signed
 * @param {boolean=} le Whether little or big endian, defaults to big endian
 * @returns {Long} The corresponding Long value
 */ $e752ddd240bc56a4$var$Long.fromBytes = function fromBytes(bytes, unsigned, le) {
    return le ? $e752ddd240bc56a4$var$Long.fromBytesLE(bytes, unsigned) : $e752ddd240bc56a4$var$Long.fromBytesBE(bytes, unsigned);
};
/**
 * Creates a Long from its little endian byte representation.
 * @param {!Array.<number>} bytes Little endian byte representation
 * @param {boolean=} unsigned Whether unsigned or not, defaults to signed
 * @returns {Long} The corresponding Long value
 */ $e752ddd240bc56a4$var$Long.fromBytesLE = function fromBytesLE(bytes, unsigned) {
    return new $e752ddd240bc56a4$var$Long(bytes[0] | bytes[1] << 8 | bytes[2] << 16 | bytes[3] << 24, bytes[4] | bytes[5] << 8 | bytes[6] << 16 | bytes[7] << 24, unsigned);
};
/**
 * Creates a Long from its big endian byte representation.
 * @param {!Array.<number>} bytes Big endian byte representation
 * @param {boolean=} unsigned Whether unsigned or not, defaults to signed
 * @returns {Long} The corresponding Long value
 */ $e752ddd240bc56a4$var$Long.fromBytesBE = function fromBytesBE(bytes, unsigned) {
    return new $e752ddd240bc56a4$var$Long(bytes[4] << 24 | bytes[5] << 16 | bytes[6] << 8 | bytes[7], bytes[0] << 24 | bytes[1] << 16 | bytes[2] << 8 | bytes[3], unsigned);
};

});

parcelRequire.register("8GcGB", function(module, exports) {

!function(e) {
    function r(e, r) {
        "use strict";
        var t, a = "uint8array", _ = r.ready.then(function() {
            function a() {
                if (0 !== t._sodium_init()) throw new Error("libsodium was not correctly initialized.");
                for(var r = [
                    "crypto_aead_aegis128l_decrypt",
                    "crypto_aead_aegis128l_decrypt_detached",
                    "crypto_aead_aegis128l_encrypt",
                    "crypto_aead_aegis128l_encrypt_detached",
                    "crypto_aead_aegis128l_keygen",
                    "crypto_aead_aegis256_decrypt",
                    "crypto_aead_aegis256_decrypt_detached",
                    "crypto_aead_aegis256_encrypt",
                    "crypto_aead_aegis256_encrypt_detached",
                    "crypto_aead_aegis256_keygen",
                    "crypto_aead_chacha20poly1305_decrypt",
                    "crypto_aead_chacha20poly1305_decrypt_detached",
                    "crypto_aead_chacha20poly1305_encrypt",
                    "crypto_aead_chacha20poly1305_encrypt_detached",
                    "crypto_aead_chacha20poly1305_ietf_decrypt",
                    "crypto_aead_chacha20poly1305_ietf_decrypt_detached",
                    "crypto_aead_chacha20poly1305_ietf_encrypt",
                    "crypto_aead_chacha20poly1305_ietf_encrypt_detached",
                    "crypto_aead_chacha20poly1305_ietf_keygen",
                    "crypto_aead_chacha20poly1305_keygen",
                    "crypto_aead_xchacha20poly1305_ietf_decrypt",
                    "crypto_aead_xchacha20poly1305_ietf_decrypt_detached",
                    "crypto_aead_xchacha20poly1305_ietf_encrypt",
                    "crypto_aead_xchacha20poly1305_ietf_encrypt_detached",
                    "crypto_aead_xchacha20poly1305_ietf_keygen",
                    "crypto_auth",
                    "crypto_auth_hmacsha256",
                    "crypto_auth_hmacsha256_final",
                    "crypto_auth_hmacsha256_init",
                    "crypto_auth_hmacsha256_keygen",
                    "crypto_auth_hmacsha256_update",
                    "crypto_auth_hmacsha256_verify",
                    "crypto_auth_hmacsha512",
                    "crypto_auth_hmacsha512_final",
                    "crypto_auth_hmacsha512_init",
                    "crypto_auth_hmacsha512_keygen",
                    "crypto_auth_hmacsha512_update",
                    "crypto_auth_hmacsha512_verify",
                    "crypto_auth_keygen",
                    "crypto_auth_verify",
                    "crypto_box_beforenm",
                    "crypto_box_curve25519xchacha20poly1305_beforenm",
                    "crypto_box_curve25519xchacha20poly1305_detached",
                    "crypto_box_curve25519xchacha20poly1305_detached_afternm",
                    "crypto_box_curve25519xchacha20poly1305_easy",
                    "crypto_box_curve25519xchacha20poly1305_easy_afternm",
                    "crypto_box_curve25519xchacha20poly1305_keypair",
                    "crypto_box_curve25519xchacha20poly1305_open_detached",
                    "crypto_box_curve25519xchacha20poly1305_open_detached_afternm",
                    "crypto_box_curve25519xchacha20poly1305_open_easy",
                    "crypto_box_curve25519xchacha20poly1305_open_easy_afternm",
                    "crypto_box_curve25519xchacha20poly1305_seal",
                    "crypto_box_curve25519xchacha20poly1305_seal_open",
                    "crypto_box_curve25519xchacha20poly1305_seed_keypair",
                    "crypto_box_detached",
                    "crypto_box_easy",
                    "crypto_box_easy_afternm",
                    "crypto_box_keypair",
                    "crypto_box_open_detached",
                    "crypto_box_open_easy",
                    "crypto_box_open_easy_afternm",
                    "crypto_box_seal",
                    "crypto_box_seal_open",
                    "crypto_box_seed_keypair",
                    "crypto_core_ed25519_add",
                    "crypto_core_ed25519_from_hash",
                    "crypto_core_ed25519_from_uniform",
                    "crypto_core_ed25519_is_valid_point",
                    "crypto_core_ed25519_random",
                    "crypto_core_ed25519_scalar_add",
                    "crypto_core_ed25519_scalar_complement",
                    "crypto_core_ed25519_scalar_invert",
                    "crypto_core_ed25519_scalar_mul",
                    "crypto_core_ed25519_scalar_negate",
                    "crypto_core_ed25519_scalar_random",
                    "crypto_core_ed25519_scalar_reduce",
                    "crypto_core_ed25519_scalar_sub",
                    "crypto_core_ed25519_sub",
                    "crypto_core_hchacha20",
                    "crypto_core_hsalsa20",
                    "crypto_core_ristretto255_add",
                    "crypto_core_ristretto255_from_hash",
                    "crypto_core_ristretto255_is_valid_point",
                    "crypto_core_ristretto255_random",
                    "crypto_core_ristretto255_scalar_add",
                    "crypto_core_ristretto255_scalar_complement",
                    "crypto_core_ristretto255_scalar_invert",
                    "crypto_core_ristretto255_scalar_mul",
                    "crypto_core_ristretto255_scalar_negate",
                    "crypto_core_ristretto255_scalar_random",
                    "crypto_core_ristretto255_scalar_reduce",
                    "crypto_core_ristretto255_scalar_sub",
                    "crypto_core_ristretto255_sub",
                    "crypto_generichash",
                    "crypto_generichash_blake2b_salt_personal",
                    "crypto_generichash_final",
                    "crypto_generichash_init",
                    "crypto_generichash_keygen",
                    "crypto_generichash_update",
                    "crypto_hash",
                    "crypto_hash_sha256",
                    "crypto_hash_sha256_final",
                    "crypto_hash_sha256_init",
                    "crypto_hash_sha256_update",
                    "crypto_hash_sha512",
                    "crypto_hash_sha512_final",
                    "crypto_hash_sha512_init",
                    "crypto_hash_sha512_update",
                    "crypto_kdf_derive_from_key",
                    "crypto_kdf_keygen",
                    "crypto_kx_client_session_keys",
                    "crypto_kx_keypair",
                    "crypto_kx_seed_keypair",
                    "crypto_kx_server_session_keys",
                    "crypto_onetimeauth",
                    "crypto_onetimeauth_final",
                    "crypto_onetimeauth_init",
                    "crypto_onetimeauth_keygen",
                    "crypto_onetimeauth_update",
                    "crypto_onetimeauth_verify",
                    "crypto_pwhash",
                    "crypto_pwhash_scryptsalsa208sha256",
                    "crypto_pwhash_scryptsalsa208sha256_ll",
                    "crypto_pwhash_scryptsalsa208sha256_str",
                    "crypto_pwhash_scryptsalsa208sha256_str_verify",
                    "crypto_pwhash_str",
                    "crypto_pwhash_str_needs_rehash",
                    "crypto_pwhash_str_verify",
                    "crypto_scalarmult",
                    "crypto_scalarmult_base",
                    "crypto_scalarmult_ed25519",
                    "crypto_scalarmult_ed25519_base",
                    "crypto_scalarmult_ed25519_base_noclamp",
                    "crypto_scalarmult_ed25519_noclamp",
                    "crypto_scalarmult_ristretto255",
                    "crypto_scalarmult_ristretto255_base",
                    "crypto_secretbox_detached",
                    "crypto_secretbox_easy",
                    "crypto_secretbox_keygen",
                    "crypto_secretbox_open_detached",
                    "crypto_secretbox_open_easy",
                    "crypto_secretstream_xchacha20poly1305_init_pull",
                    "crypto_secretstream_xchacha20poly1305_init_push",
                    "crypto_secretstream_xchacha20poly1305_keygen",
                    "crypto_secretstream_xchacha20poly1305_pull",
                    "crypto_secretstream_xchacha20poly1305_push",
                    "crypto_secretstream_xchacha20poly1305_rekey",
                    "crypto_shorthash",
                    "crypto_shorthash_keygen",
                    "crypto_shorthash_siphashx24",
                    "crypto_sign",
                    "crypto_sign_detached",
                    "crypto_sign_ed25519_pk_to_curve25519",
                    "crypto_sign_ed25519_sk_to_curve25519",
                    "crypto_sign_ed25519_sk_to_pk",
                    "crypto_sign_ed25519_sk_to_seed",
                    "crypto_sign_final_create",
                    "crypto_sign_final_verify",
                    "crypto_sign_init",
                    "crypto_sign_keypair",
                    "crypto_sign_open",
                    "crypto_sign_seed_keypair",
                    "crypto_sign_update",
                    "crypto_sign_verify_detached",
                    "crypto_stream_chacha20",
                    "crypto_stream_chacha20_ietf_xor",
                    "crypto_stream_chacha20_ietf_xor_ic",
                    "crypto_stream_chacha20_keygen",
                    "crypto_stream_chacha20_xor",
                    "crypto_stream_chacha20_xor_ic",
                    "crypto_stream_keygen",
                    "crypto_stream_xchacha20_keygen",
                    "crypto_stream_xchacha20_xor",
                    "crypto_stream_xchacha20_xor_ic",
                    "randombytes_buf",
                    "randombytes_buf_deterministic",
                    "randombytes_close",
                    "randombytes_random",
                    "randombytes_set_implementation",
                    "randombytes_stir",
                    "randombytes_uniform",
                    "sodium_version_string"
                ], a = [
                    E,
                    k,
                    S,
                    T,
                    w,
                    Y,
                    B,
                    A,
                    K,
                    M,
                    I,
                    N,
                    L,
                    U,
                    O,
                    C,
                    R,
                    P,
                    G,
                    X,
                    D,
                    F,
                    V,
                    H,
                    q,
                    j,
                    z,
                    W,
                    J,
                    Q,
                    Z,
                    $,
                    ee,
                    re,
                    te,
                    ae,
                    _e,
                    ne,
                    se,
                    ce,
                    oe,
                    he,
                    pe,
                    ye,
                    ie,
                    le,
                    ue,
                    de,
                    ve,
                    ge,
                    be,
                    fe,
                    me,
                    xe,
                    Ee,
                    ke,
                    Se,
                    Te,
                    we,
                    Ye,
                    Be,
                    Ae,
                    Ke,
                    Me,
                    Ie,
                    Ne,
                    Le,
                    Ue,
                    Oe,
                    Ce,
                    Re,
                    Pe,
                    Ge,
                    Xe,
                    De,
                    Fe,
                    Ve,
                    He,
                    qe,
                    je,
                    ze,
                    We,
                    Je,
                    Qe,
                    Ze,
                    $e,
                    er,
                    rr,
                    tr,
                    ar,
                    _r,
                    nr,
                    sr,
                    cr,
                    or,
                    hr,
                    pr,
                    yr,
                    ir,
                    lr,
                    ur,
                    dr,
                    vr,
                    gr,
                    br,
                    fr,
                    mr,
                    xr,
                    Er,
                    kr,
                    Sr,
                    Tr,
                    wr,
                    Yr,
                    Br,
                    Ar,
                    Kr,
                    Mr,
                    Ir,
                    Nr,
                    Lr,
                    Ur,
                    Or,
                    Cr,
                    Rr,
                    Pr,
                    Gr,
                    Xr,
                    Dr,
                    Fr,
                    Vr,
                    Hr,
                    qr,
                    jr,
                    zr,
                    Wr,
                    Jr,
                    Qr,
                    Zr,
                    $r,
                    et,
                    rt,
                    tt,
                    at,
                    _t,
                    nt,
                    st,
                    ct,
                    ot,
                    ht,
                    pt,
                    yt,
                    it,
                    lt,
                    ut,
                    dt,
                    vt,
                    gt,
                    bt,
                    ft,
                    mt,
                    xt,
                    Et,
                    kt,
                    St,
                    Tt,
                    wt,
                    Yt,
                    Bt,
                    At,
                    Kt,
                    Mt,
                    It,
                    Nt,
                    Lt,
                    Ut,
                    Ot,
                    Ct,
                    Rt,
                    Pt,
                    Gt,
                    Xt
                ], _ = 0; _ < a.length; _++)"function" == typeof t["_" + r[_]] && (e[r[_]] = a[_]);
                var n = [
                    "SODIUM_LIBRARY_VERSION_MAJOR",
                    "SODIUM_LIBRARY_VERSION_MINOR",
                    "crypto_aead_chacha20poly1305_ABYTES",
                    "crypto_aead_chacha20poly1305_IETF_ABYTES",
                    "crypto_aead_chacha20poly1305_IETF_KEYBYTES",
                    "crypto_aead_chacha20poly1305_IETF_MESSAGEBYTES_MAX",
                    "crypto_aead_chacha20poly1305_IETF_NPUBBYTES",
                    "crypto_aead_chacha20poly1305_IETF_NSECBYTES",
                    "crypto_aead_chacha20poly1305_KEYBYTES",
                    "crypto_aead_chacha20poly1305_MESSAGEBYTES_MAX",
                    "crypto_aead_chacha20poly1305_NPUBBYTES",
                    "crypto_aead_chacha20poly1305_NSECBYTES",
                    "crypto_aead_chacha20poly1305_ietf_ABYTES",
                    "crypto_aead_chacha20poly1305_ietf_KEYBYTES",
                    "crypto_aead_chacha20poly1305_ietf_MESSAGEBYTES_MAX",
                    "crypto_aead_chacha20poly1305_ietf_NPUBBYTES",
                    "crypto_aead_chacha20poly1305_ietf_NSECBYTES",
                    "crypto_aead_xchacha20poly1305_IETF_ABYTES",
                    "crypto_aead_xchacha20poly1305_IETF_KEYBYTES",
                    "crypto_aead_xchacha20poly1305_IETF_MESSAGEBYTES_MAX",
                    "crypto_aead_xchacha20poly1305_IETF_NPUBBYTES",
                    "crypto_aead_xchacha20poly1305_IETF_NSECBYTES",
                    "crypto_aead_xchacha20poly1305_ietf_ABYTES",
                    "crypto_aead_xchacha20poly1305_ietf_KEYBYTES",
                    "crypto_aead_xchacha20poly1305_ietf_MESSAGEBYTES_MAX",
                    "crypto_aead_xchacha20poly1305_ietf_NPUBBYTES",
                    "crypto_aead_xchacha20poly1305_ietf_NSECBYTES",
                    "crypto_auth_BYTES",
                    "crypto_auth_KEYBYTES",
                    "crypto_auth_hmacsha256_BYTES",
                    "crypto_auth_hmacsha256_KEYBYTES",
                    "crypto_auth_hmacsha512256_BYTES",
                    "crypto_auth_hmacsha512256_KEYBYTES",
                    "crypto_auth_hmacsha512_BYTES",
                    "crypto_auth_hmacsha512_KEYBYTES",
                    "crypto_box_BEFORENMBYTES",
                    "crypto_box_MACBYTES",
                    "crypto_box_MESSAGEBYTES_MAX",
                    "crypto_box_NONCEBYTES",
                    "crypto_box_PUBLICKEYBYTES",
                    "crypto_box_SEALBYTES",
                    "crypto_box_SECRETKEYBYTES",
                    "crypto_box_SEEDBYTES",
                    "crypto_box_curve25519xchacha20poly1305_BEFORENMBYTES",
                    "crypto_box_curve25519xchacha20poly1305_MACBYTES",
                    "crypto_box_curve25519xchacha20poly1305_MESSAGEBYTES_MAX",
                    "crypto_box_curve25519xchacha20poly1305_NONCEBYTES",
                    "crypto_box_curve25519xchacha20poly1305_PUBLICKEYBYTES",
                    "crypto_box_curve25519xchacha20poly1305_SEALBYTES",
                    "crypto_box_curve25519xchacha20poly1305_SECRETKEYBYTES",
                    "crypto_box_curve25519xchacha20poly1305_SEEDBYTES",
                    "crypto_box_curve25519xsalsa20poly1305_BEFORENMBYTES",
                    "crypto_box_curve25519xsalsa20poly1305_MACBYTES",
                    "crypto_box_curve25519xsalsa20poly1305_MESSAGEBYTES_MAX",
                    "crypto_box_curve25519xsalsa20poly1305_NONCEBYTES",
                    "crypto_box_curve25519xsalsa20poly1305_PUBLICKEYBYTES",
                    "crypto_box_curve25519xsalsa20poly1305_SECRETKEYBYTES",
                    "crypto_box_curve25519xsalsa20poly1305_SEEDBYTES",
                    "crypto_core_ed25519_BYTES",
                    "crypto_core_ed25519_HASHBYTES",
                    "crypto_core_ed25519_NONREDUCEDSCALARBYTES",
                    "crypto_core_ed25519_SCALARBYTES",
                    "crypto_core_ed25519_UNIFORMBYTES",
                    "crypto_core_hchacha20_CONSTBYTES",
                    "crypto_core_hchacha20_INPUTBYTES",
                    "crypto_core_hchacha20_KEYBYTES",
                    "crypto_core_hchacha20_OUTPUTBYTES",
                    "crypto_core_hsalsa20_CONSTBYTES",
                    "crypto_core_hsalsa20_INPUTBYTES",
                    "crypto_core_hsalsa20_KEYBYTES",
                    "crypto_core_hsalsa20_OUTPUTBYTES",
                    "crypto_core_ristretto255_BYTES",
                    "crypto_core_ristretto255_HASHBYTES",
                    "crypto_core_ristretto255_NONREDUCEDSCALARBYTES",
                    "crypto_core_ristretto255_SCALARBYTES",
                    "crypto_core_salsa2012_CONSTBYTES",
                    "crypto_core_salsa2012_INPUTBYTES",
                    "crypto_core_salsa2012_KEYBYTES",
                    "crypto_core_salsa2012_OUTPUTBYTES",
                    "crypto_core_salsa20_CONSTBYTES",
                    "crypto_core_salsa20_INPUTBYTES",
                    "crypto_core_salsa20_KEYBYTES",
                    "crypto_core_salsa20_OUTPUTBYTES",
                    "crypto_generichash_BYTES",
                    "crypto_generichash_BYTES_MAX",
                    "crypto_generichash_BYTES_MIN",
                    "crypto_generichash_KEYBYTES",
                    "crypto_generichash_KEYBYTES_MAX",
                    "crypto_generichash_KEYBYTES_MIN",
                    "crypto_generichash_blake2b_BYTES",
                    "crypto_generichash_blake2b_BYTES_MAX",
                    "crypto_generichash_blake2b_BYTES_MIN",
                    "crypto_generichash_blake2b_KEYBYTES",
                    "crypto_generichash_blake2b_KEYBYTES_MAX",
                    "crypto_generichash_blake2b_KEYBYTES_MIN",
                    "crypto_generichash_blake2b_PERSONALBYTES",
                    "crypto_generichash_blake2b_SALTBYTES",
                    "crypto_hash_BYTES",
                    "crypto_hash_sha256_BYTES",
                    "crypto_hash_sha512_BYTES",
                    "crypto_kdf_BYTES_MAX",
                    "crypto_kdf_BYTES_MIN",
                    "crypto_kdf_CONTEXTBYTES",
                    "crypto_kdf_KEYBYTES",
                    "crypto_kdf_blake2b_BYTES_MAX",
                    "crypto_kdf_blake2b_BYTES_MIN",
                    "crypto_kdf_blake2b_CONTEXTBYTES",
                    "crypto_kdf_blake2b_KEYBYTES",
                    "crypto_kx_PUBLICKEYBYTES",
                    "crypto_kx_SECRETKEYBYTES",
                    "crypto_kx_SEEDBYTES",
                    "crypto_kx_SESSIONKEYBYTES",
                    "crypto_onetimeauth_BYTES",
                    "crypto_onetimeauth_KEYBYTES",
                    "crypto_onetimeauth_poly1305_BYTES",
                    "crypto_onetimeauth_poly1305_KEYBYTES",
                    "crypto_pwhash_ALG_ARGON2I13",
                    "crypto_pwhash_ALG_ARGON2ID13",
                    "crypto_pwhash_ALG_DEFAULT",
                    "crypto_pwhash_BYTES_MAX",
                    "crypto_pwhash_BYTES_MIN",
                    "crypto_pwhash_MEMLIMIT_INTERACTIVE",
                    "crypto_pwhash_MEMLIMIT_MAX",
                    "crypto_pwhash_MEMLIMIT_MIN",
                    "crypto_pwhash_MEMLIMIT_MODERATE",
                    "crypto_pwhash_MEMLIMIT_SENSITIVE",
                    "crypto_pwhash_OPSLIMIT_INTERACTIVE",
                    "crypto_pwhash_OPSLIMIT_MAX",
                    "crypto_pwhash_OPSLIMIT_MIN",
                    "crypto_pwhash_OPSLIMIT_MODERATE",
                    "crypto_pwhash_OPSLIMIT_SENSITIVE",
                    "crypto_pwhash_PASSWD_MAX",
                    "crypto_pwhash_PASSWD_MIN",
                    "crypto_pwhash_SALTBYTES",
                    "crypto_pwhash_STRBYTES",
                    "crypto_pwhash_argon2i_BYTES_MAX",
                    "crypto_pwhash_argon2i_BYTES_MIN",
                    "crypto_pwhash_argon2i_SALTBYTES",
                    "crypto_pwhash_argon2i_STRBYTES",
                    "crypto_pwhash_argon2id_BYTES_MAX",
                    "crypto_pwhash_argon2id_BYTES_MIN",
                    "crypto_pwhash_argon2id_SALTBYTES",
                    "crypto_pwhash_argon2id_STRBYTES",
                    "crypto_pwhash_scryptsalsa208sha256_BYTES_MAX",
                    "crypto_pwhash_scryptsalsa208sha256_BYTES_MIN",
                    "crypto_pwhash_scryptsalsa208sha256_MEMLIMIT_INTERACTIVE",
                    "crypto_pwhash_scryptsalsa208sha256_MEMLIMIT_MAX",
                    "crypto_pwhash_scryptsalsa208sha256_MEMLIMIT_MIN",
                    "crypto_pwhash_scryptsalsa208sha256_MEMLIMIT_SENSITIVE",
                    "crypto_pwhash_scryptsalsa208sha256_OPSLIMIT_INTERACTIVE",
                    "crypto_pwhash_scryptsalsa208sha256_OPSLIMIT_MAX",
                    "crypto_pwhash_scryptsalsa208sha256_OPSLIMIT_MIN",
                    "crypto_pwhash_scryptsalsa208sha256_OPSLIMIT_SENSITIVE",
                    "crypto_pwhash_scryptsalsa208sha256_SALTBYTES",
                    "crypto_pwhash_scryptsalsa208sha256_STRBYTES",
                    "crypto_scalarmult_BYTES",
                    "crypto_scalarmult_SCALARBYTES",
                    "crypto_scalarmult_curve25519_BYTES",
                    "crypto_scalarmult_curve25519_SCALARBYTES",
                    "crypto_scalarmult_ed25519_BYTES",
                    "crypto_scalarmult_ed25519_SCALARBYTES",
                    "crypto_scalarmult_ristretto255_BYTES",
                    "crypto_scalarmult_ristretto255_SCALARBYTES",
                    "crypto_secretbox_KEYBYTES",
                    "crypto_secretbox_MACBYTES",
                    "crypto_secretbox_MESSAGEBYTES_MAX",
                    "crypto_secretbox_NONCEBYTES",
                    "crypto_secretbox_xchacha20poly1305_KEYBYTES",
                    "crypto_secretbox_xchacha20poly1305_MACBYTES",
                    "crypto_secretbox_xchacha20poly1305_MESSAGEBYTES_MAX",
                    "crypto_secretbox_xchacha20poly1305_NONCEBYTES",
                    "crypto_secretbox_xsalsa20poly1305_KEYBYTES",
                    "crypto_secretbox_xsalsa20poly1305_MACBYTES",
                    "crypto_secretbox_xsalsa20poly1305_MESSAGEBYTES_MAX",
                    "crypto_secretbox_xsalsa20poly1305_NONCEBYTES",
                    "crypto_secretstream_xchacha20poly1305_ABYTES",
                    "crypto_secretstream_xchacha20poly1305_HEADERBYTES",
                    "crypto_secretstream_xchacha20poly1305_KEYBYTES",
                    "crypto_secretstream_xchacha20poly1305_MESSAGEBYTES_MAX",
                    "crypto_secretstream_xchacha20poly1305_TAG_FINAL",
                    "crypto_secretstream_xchacha20poly1305_TAG_MESSAGE",
                    "crypto_secretstream_xchacha20poly1305_TAG_PUSH",
                    "crypto_secretstream_xchacha20poly1305_TAG_REKEY",
                    "crypto_shorthash_BYTES",
                    "crypto_shorthash_KEYBYTES",
                    "crypto_shorthash_siphash24_BYTES",
                    "crypto_shorthash_siphash24_KEYBYTES",
                    "crypto_shorthash_siphashx24_BYTES",
                    "crypto_shorthash_siphashx24_KEYBYTES",
                    "crypto_sign_BYTES",
                    "crypto_sign_MESSAGEBYTES_MAX",
                    "crypto_sign_PUBLICKEYBYTES",
                    "crypto_sign_SECRETKEYBYTES",
                    "crypto_sign_SEEDBYTES",
                    "crypto_sign_ed25519_BYTES",
                    "crypto_sign_ed25519_MESSAGEBYTES_MAX",
                    "crypto_sign_ed25519_PUBLICKEYBYTES",
                    "crypto_sign_ed25519_SECRETKEYBYTES",
                    "crypto_sign_ed25519_SEEDBYTES",
                    "crypto_stream_KEYBYTES",
                    "crypto_stream_MESSAGEBYTES_MAX",
                    "crypto_stream_NONCEBYTES",
                    "crypto_stream_chacha20_IETF_KEYBYTES",
                    "crypto_stream_chacha20_IETF_MESSAGEBYTES_MAX",
                    "crypto_stream_chacha20_IETF_NONCEBYTES",
                    "crypto_stream_chacha20_KEYBYTES",
                    "crypto_stream_chacha20_MESSAGEBYTES_MAX",
                    "crypto_stream_chacha20_NONCEBYTES",
                    "crypto_stream_chacha20_ietf_KEYBYTES",
                    "crypto_stream_chacha20_ietf_MESSAGEBYTES_MAX",
                    "crypto_stream_chacha20_ietf_NONCEBYTES",
                    "crypto_stream_salsa2012_KEYBYTES",
                    "crypto_stream_salsa2012_MESSAGEBYTES_MAX",
                    "crypto_stream_salsa2012_NONCEBYTES",
                    "crypto_stream_salsa208_KEYBYTES",
                    "crypto_stream_salsa208_MESSAGEBYTES_MAX",
                    "crypto_stream_salsa208_NONCEBYTES",
                    "crypto_stream_salsa20_KEYBYTES",
                    "crypto_stream_salsa20_MESSAGEBYTES_MAX",
                    "crypto_stream_salsa20_NONCEBYTES",
                    "crypto_stream_xchacha20_KEYBYTES",
                    "crypto_stream_xchacha20_MESSAGEBYTES_MAX",
                    "crypto_stream_xchacha20_NONCEBYTES",
                    "crypto_stream_xsalsa20_KEYBYTES",
                    "crypto_stream_xsalsa20_MESSAGEBYTES_MAX",
                    "crypto_stream_xsalsa20_NONCEBYTES",
                    "crypto_verify_16_BYTES",
                    "crypto_verify_32_BYTES",
                    "crypto_verify_64_BYTES"
                ];
                for(_ = 0; _ < n.length; _++)"function" == typeof (c = t["_" + n[_].toLowerCase()]) && (e[n[_]] = c());
                var s = [
                    "SODIUM_VERSION_STRING",
                    "crypto_pwhash_STRPREFIX",
                    "crypto_pwhash_scryptsalsa208sha256_STRPREFIX"
                ];
                for(_ = 0; _ < s.length; _++){
                    var c;
                    "function" == typeof (c = t["_" + s[_].toLowerCase()]) && (e[s[_]] = t.UTF8ToString(c()));
                }
            }
            t = r;
            try {
                a();
                var _ = new Uint8Array([
                    98,
                    97,
                    108,
                    108,
                    115
                ]), n = e.randombytes_buf(e.crypto_secretbox_NONCEBYTES), s = e.randombytes_buf(e.crypto_secretbox_KEYBYTES), c = e.crypto_secretbox_easy(_, n, s), o = e.crypto_secretbox_open_easy(c, n, s);
                if (e.memcmp(_, o)) return;
            } catch (e) {
                if (null == t.useBackupModule) throw new Error("Both wasm and asm failed to load" + e);
            }
            t.useBackupModule(), a();
        });
        function n(e) {
            if ("function" == typeof TextEncoder) return (new TextEncoder).encode(e);
            e = unescape(encodeURIComponent(e));
            for(var r = new Uint8Array(e.length), t = 0, a = e.length; t < a; t++)r[t] = e.charCodeAt(t);
            return r;
        }
        function s(e) {
            if ("function" == typeof TextDecoder) return new TextDecoder("utf-8", {
                fatal: !0
            }).decode(e);
            var r = 8192, t = Math.ceil(e.length / r);
            if (t <= 1) try {
                return decodeURIComponent(escape(String.fromCharCode.apply(null, e)));
            } catch (e) {
                throw new TypeError("The encoded data was not valid.");
            }
            for(var a = "", _ = 0, n = 0; n < t; n++){
                var c = Array.prototype.slice.call(e, n * r + _, (n + 1) * r + _);
                if (0 != c.length) {
                    var o, h = c.length, p = 0;
                    do {
                        var y = c[--h];
                        y >= 240 ? (p = 4, o = !0) : y >= 224 ? (p = 3, o = !0) : y >= 192 ? (p = 2, o = !0) : y < 128 && (p = 1, o = !0);
                    }while (!o);
                    for(var i = p - (c.length - h), l = 0; l < i; l++)_--, c.pop();
                    a += s(c);
                }
            }
            return a;
        }
        function c(e) {
            e = x(null, e, "input");
            for(var r, t, a, _ = "", n = 0; n < e.length; n++)a = 87 + (t = 15 & e[n]) + (t - 10 >> 8 & -39) << 8 | 87 + (r = e[n] >>> 4) + (r - 10 >> 8 & -39), _ += String.fromCharCode(255 & a) + String.fromCharCode(a >>> 8);
            return _;
        }
        var o = {
            ORIGINAL: 1,
            ORIGINAL_NO_PADDING: 3,
            URLSAFE: 5,
            URLSAFE_NO_PADDING: 7
        };
        function h(e) {
            if (null == e) return o.URLSAFE_NO_PADDING;
            if (e !== o.ORIGINAL && e !== o.ORIGINAL_NO_PADDING && e !== o.URLSAFE && e != o.URLSAFE_NO_PADDING) throw new Error("unsupported base64 variant");
            return e;
        }
        function p(e, r) {
            r = h(r), e = x(_, e, "input");
            var a, _ = [], n = 0 | Math.floor(e.length / 3), c = e.length - 3 * n, o = 4 * n + (0 !== c ? 0 == (2 & r) ? 4 : 2 + (c >>> 1) : 0), p = new u(o + 1), y = d(e);
            return _.push(y), _.push(p.address), 0 === t._sodium_bin2base64(p.address, p.length, y, e.length, r) && b(_, "conversion failed"), p.length = o, a = s(p.to_Uint8Array()), g(_), a;
        }
        function y(e, r) {
            var t = r || a;
            if (!i(t)) throw new Error(t + " output format is not available");
            if (e instanceof u) {
                if ("uint8array" === t) return e.to_Uint8Array();
                if ("text" === t) return s(e.to_Uint8Array());
                if ("hex" === t) return c(e.to_Uint8Array());
                if ("base64" === t) return p(e.to_Uint8Array(), o.URLSAFE_NO_PADDING);
                throw new Error('What is output format "' + t + '"?');
            }
            if ("object" == typeof e) {
                for(var _ = Object.keys(e), n = {}, h = 0; h < _.length; h++)n[_[h]] = y(e[_[h]], t);
                return n;
            }
            if ("string" == typeof e) return e;
            throw new TypeError("Cannot format output");
        }
        function i(e) {
            for(var r = [
                "uint8array",
                "text",
                "hex",
                "base64"
            ], t = 0; t < r.length; t++)if (r[t] === e) return !0;
            return !1;
        }
        function l(e) {
            if (e) {
                if ("string" != typeof e) throw new TypeError("When defined, the output format must be a string");
                if (!i(e)) throw new Error(e + " is not a supported output format");
            }
        }
        function u(e) {
            this.length = e, this.address = v(e);
        }
        function d(e) {
            var r = v(e.length);
            return t.HEAPU8.set(e, r), r;
        }
        function v(e) {
            var r = t._malloc(e);
            if (0 === r) throw {
                message: "_malloc() failed",
                length: e
            };
            return r;
        }
        function g(e) {
            if (e) for(var r = 0; r < e.length; r++)a = e[r], t._free(a);
            var a;
        }
        function b(e, r) {
            throw g(e), new Error(r);
        }
        function f(e, r) {
            throw g(e), new TypeError(r);
        }
        function m(e, r, t) {
            null == r && f(e, t + " cannot be null or undefined");
        }
        function x(e, r, t) {
            return m(e, r, t), r instanceof Uint8Array ? r : "string" == typeof r ? n(r) : void f(e, "unsupported input type for " + t);
        }
        function E(e, r, a, _, n, s) {
            var c = [];
            l(s);
            var o = null;
            null != e && (o = d(e = x(c, e, "secret_nonce")), e.length, c.push(o)), r = x(c, r, "ciphertext");
            var h, p = t._crypto_aead_aegis128l_abytes(), i = r.length;
            i < p && f(c, "ciphertext is too short"), h = d(r), c.push(h);
            var v = null, m = 0;
            null != a && (v = d(a = x(c, a, "additional_data")), m = a.length, c.push(v)), _ = x(c, _, "public_nonce");
            var E, k = 0 | t._crypto_aead_aegis128l_npubbytes();
            _.length !== k && f(c, "invalid public_nonce length"), E = d(_), c.push(E), n = x(c, n, "key");
            var S, T = 0 | t._crypto_aead_aegis128l_keybytes();
            n.length !== T && f(c, "invalid key length"), S = d(n), c.push(S);
            var w = new u(i - t._crypto_aead_aegis128l_abytes() | 0), Y = w.address;
            if (c.push(Y), 0 === t._crypto_aead_aegis128l_decrypt(Y, null, o, h, i, 0, v, m, 0, E, S)) {
                var B = y(w, s);
                return g(c), B;
            }
            b(c, "ciphertext cannot be decrypted using that key");
        }
        function k(e, r, a, _, n, s, c) {
            var o = [];
            l(c);
            var h = null;
            null != e && (h = d(e = x(o, e, "secret_nonce")), e.length, o.push(h));
            var p = d(r = x(o, r, "ciphertext")), i = r.length;
            o.push(p), a = x(o, a, "mac");
            var v, m = 0 | t._crypto_box_macbytes();
            a.length !== m && f(o, "invalid mac length"), v = d(a), o.push(v);
            var E = null, k = 0;
            null != _ && (E = d(_ = x(o, _, "additional_data")), k = _.length, o.push(E)), n = x(o, n, "public_nonce");
            var S, T = 0 | t._crypto_aead_aegis128l_npubbytes();
            n.length !== T && f(o, "invalid public_nonce length"), S = d(n), o.push(S), s = x(o, s, "key");
            var w, Y = 0 | t._crypto_aead_aegis128l_keybytes();
            s.length !== Y && f(o, "invalid key length"), w = d(s), o.push(w);
            var B = new u(0 | i), A = B.address;
            if (o.push(A), 0 === t._crypto_aead_aegis128l_decrypt_detached(A, h, p, i, 0, v, E, k, 0, S, w)) {
                var K = y(B, c);
                return g(o), K;
            }
            b(o, "ciphertext cannot be decrypted using that key");
        }
        function S(e, r, a, _, n, s) {
            var c = [];
            l(s);
            var o = d(e = x(c, e, "message")), h = e.length;
            c.push(o);
            var p = null, i = 0;
            null != r && (p = d(r = x(c, r, "additional_data")), i = r.length, c.push(p));
            var v = null;
            null != a && (v = d(a = x(c, a, "secret_nonce")), a.length, c.push(v)), _ = x(c, _, "public_nonce");
            var m, E = 0 | t._crypto_aead_aegis128l_npubbytes();
            _.length !== E && f(c, "invalid public_nonce length"), m = d(_), c.push(m), n = x(c, n, "key");
            var k, S = 0 | t._crypto_aead_aegis128l_keybytes();
            n.length !== S && f(c, "invalid key length"), k = d(n), c.push(k);
            var T = new u(h + t._crypto_aead_aegis128l_abytes() | 0), w = T.address;
            if (c.push(w), 0 === t._crypto_aead_aegis128l_encrypt(w, null, o, h, 0, p, i, 0, v, m, k)) {
                var Y = y(T, s);
                return g(c), Y;
            }
            b(c, "invalid usage");
        }
        function T(e, r, a, _, n, s) {
            var c = [];
            l(s);
            var o = d(e = x(c, e, "message")), h = e.length;
            c.push(o);
            var p = null, i = 0;
            null != r && (p = d(r = x(c, r, "additional_data")), i = r.length, c.push(p));
            var v = null;
            null != a && (v = d(a = x(c, a, "secret_nonce")), a.length, c.push(v)), _ = x(c, _, "public_nonce");
            var m, E = 0 | t._crypto_aead_aegis128l_npubbytes();
            _.length !== E && f(c, "invalid public_nonce length"), m = d(_), c.push(m), n = x(c, n, "key");
            var k, S = 0 | t._crypto_aead_aegis128l_keybytes();
            n.length !== S && f(c, "invalid key length"), k = d(n), c.push(k);
            var T = new u(0 | h), w = T.address;
            c.push(w);
            var Y = new u(0 | t._crypto_aead_aegis128l_abytes()), B = Y.address;
            if (c.push(B), 0 === t._crypto_aead_aegis128l_encrypt_detached(w, B, null, o, h, 0, p, i, 0, v, m, k)) {
                var A = y({
                    ciphertext: T,
                    mac: Y
                }, s);
                return g(c), A;
            }
            b(c, "invalid usage");
        }
        function w(e) {
            var r = [];
            l(e);
            var a = new u(0 | t._crypto_aead_aegis128l_keybytes()), _ = a.address;
            r.push(_), t._crypto_aead_aegis128l_keygen(_);
            var n = y(a, e);
            return g(r), n;
        }
        function Y(e, r, a, _, n, s) {
            var c = [];
            l(s);
            var o = null;
            null != e && (o = d(e = x(c, e, "secret_nonce")), e.length, c.push(o)), r = x(c, r, "ciphertext");
            var h, p = t._crypto_aead_aegis256_abytes(), i = r.length;
            i < p && f(c, "ciphertext is too short"), h = d(r), c.push(h);
            var v = null, m = 0;
            null != a && (v = d(a = x(c, a, "additional_data")), m = a.length, c.push(v)), _ = x(c, _, "public_nonce");
            var E, k = 0 | t._crypto_aead_aegis256_npubbytes();
            _.length !== k && f(c, "invalid public_nonce length"), E = d(_), c.push(E), n = x(c, n, "key");
            var S, T = 0 | t._crypto_aead_aegis256_keybytes();
            n.length !== T && f(c, "invalid key length"), S = d(n), c.push(S);
            var w = new u(i - t._crypto_aead_aegis256_abytes() | 0), Y = w.address;
            if (c.push(Y), 0 === t._crypto_aead_aegis256_decrypt(Y, null, o, h, i, 0, v, m, 0, E, S)) {
                var B = y(w, s);
                return g(c), B;
            }
            b(c, "ciphertext cannot be decrypted using that key");
        }
        function B(e, r, a, _, n, s, c) {
            var o = [];
            l(c);
            var h = null;
            null != e && (h = d(e = x(o, e, "secret_nonce")), e.length, o.push(h));
            var p = d(r = x(o, r, "ciphertext")), i = r.length;
            o.push(p), a = x(o, a, "mac");
            var v, m = 0 | t._crypto_box_macbytes();
            a.length !== m && f(o, "invalid mac length"), v = d(a), o.push(v);
            var E = null, k = 0;
            null != _ && (E = d(_ = x(o, _, "additional_data")), k = _.length, o.push(E)), n = x(o, n, "public_nonce");
            var S, T = 0 | t._crypto_aead_aegis256_npubbytes();
            n.length !== T && f(o, "invalid public_nonce length"), S = d(n), o.push(S), s = x(o, s, "key");
            var w, Y = 0 | t._crypto_aead_aegis256_keybytes();
            s.length !== Y && f(o, "invalid key length"), w = d(s), o.push(w);
            var B = new u(0 | i), A = B.address;
            if (o.push(A), 0 === t._crypto_aead_aegis256_decrypt_detached(A, h, p, i, 0, v, E, k, 0, S, w)) {
                var K = y(B, c);
                return g(o), K;
            }
            b(o, "ciphertext cannot be decrypted using that key");
        }
        function A(e, r, a, _, n, s) {
            var c = [];
            l(s);
            var o = d(e = x(c, e, "message")), h = e.length;
            c.push(o);
            var p = null, i = 0;
            null != r && (p = d(r = x(c, r, "additional_data")), i = r.length, c.push(p));
            var v = null;
            null != a && (v = d(a = x(c, a, "secret_nonce")), a.length, c.push(v)), _ = x(c, _, "public_nonce");
            var m, E = 0 | t._crypto_aead_aegis256_npubbytes();
            _.length !== E && f(c, "invalid public_nonce length"), m = d(_), c.push(m), n = x(c, n, "key");
            var k, S = 0 | t._crypto_aead_aegis256_keybytes();
            n.length !== S && f(c, "invalid key length"), k = d(n), c.push(k);
            var T = new u(h + t._crypto_aead_aegis256_abytes() | 0), w = T.address;
            if (c.push(w), 0 === t._crypto_aead_aegis256_encrypt(w, null, o, h, 0, p, i, 0, v, m, k)) {
                var Y = y(T, s);
                return g(c), Y;
            }
            b(c, "invalid usage");
        }
        function K(e, r, a, _, n, s) {
            var c = [];
            l(s);
            var o = d(e = x(c, e, "message")), h = e.length;
            c.push(o);
            var p = null, i = 0;
            null != r && (p = d(r = x(c, r, "additional_data")), i = r.length, c.push(p));
            var v = null;
            null != a && (v = d(a = x(c, a, "secret_nonce")), a.length, c.push(v)), _ = x(c, _, "public_nonce");
            var m, E = 0 | t._crypto_aead_aegis256_npubbytes();
            _.length !== E && f(c, "invalid public_nonce length"), m = d(_), c.push(m), n = x(c, n, "key");
            var k, S = 0 | t._crypto_aead_aegis256_keybytes();
            n.length !== S && f(c, "invalid key length"), k = d(n), c.push(k);
            var T = new u(0 | h), w = T.address;
            c.push(w);
            var Y = new u(0 | t._crypto_aead_aegis256_abytes()), B = Y.address;
            if (c.push(B), 0 === t._crypto_aead_aegis256_encrypt_detached(w, B, null, o, h, 0, p, i, 0, v, m, k)) {
                var A = y({
                    ciphertext: T,
                    mac: Y
                }, s);
                return g(c), A;
            }
            b(c, "invalid usage");
        }
        function M(e) {
            var r = [];
            l(e);
            var a = new u(0 | t._crypto_aead_aegis256_keybytes()), _ = a.address;
            r.push(_), t._crypto_aead_aegis256_keygen(_);
            var n = y(a, e);
            return g(r), n;
        }
        function I(e, r, a, _, n, s) {
            var c = [];
            l(s);
            var o = null;
            null != e && (o = d(e = x(c, e, "secret_nonce")), e.length, c.push(o)), r = x(c, r, "ciphertext");
            var h, p = t._crypto_aead_chacha20poly1305_abytes(), i = r.length;
            i < p && f(c, "ciphertext is too short"), h = d(r), c.push(h);
            var v = null, m = 0;
            null != a && (v = d(a = x(c, a, "additional_data")), m = a.length, c.push(v)), _ = x(c, _, "public_nonce");
            var E, k = 0 | t._crypto_aead_chacha20poly1305_npubbytes();
            _.length !== k && f(c, "invalid public_nonce length"), E = d(_), c.push(E), n = x(c, n, "key");
            var S, T = 0 | t._crypto_aead_chacha20poly1305_keybytes();
            n.length !== T && f(c, "invalid key length"), S = d(n), c.push(S);
            var w = new u(i - t._crypto_aead_chacha20poly1305_abytes() | 0), Y = w.address;
            if (c.push(Y), 0 === t._crypto_aead_chacha20poly1305_decrypt(Y, null, o, h, i, 0, v, m, 0, E, S)) {
                var B = y(w, s);
                return g(c), B;
            }
            b(c, "ciphertext cannot be decrypted using that key");
        }
        function N(e, r, a, _, n, s, c) {
            var o = [];
            l(c);
            var h = null;
            null != e && (h = d(e = x(o, e, "secret_nonce")), e.length, o.push(h));
            var p = d(r = x(o, r, "ciphertext")), i = r.length;
            o.push(p), a = x(o, a, "mac");
            var v, m = 0 | t._crypto_box_macbytes();
            a.length !== m && f(o, "invalid mac length"), v = d(a), o.push(v);
            var E = null, k = 0;
            null != _ && (E = d(_ = x(o, _, "additional_data")), k = _.length, o.push(E)), n = x(o, n, "public_nonce");
            var S, T = 0 | t._crypto_aead_chacha20poly1305_npubbytes();
            n.length !== T && f(o, "invalid public_nonce length"), S = d(n), o.push(S), s = x(o, s, "key");
            var w, Y = 0 | t._crypto_aead_chacha20poly1305_keybytes();
            s.length !== Y && f(o, "invalid key length"), w = d(s), o.push(w);
            var B = new u(0 | i), A = B.address;
            if (o.push(A), 0 === t._crypto_aead_chacha20poly1305_decrypt_detached(A, h, p, i, 0, v, E, k, 0, S, w)) {
                var K = y(B, c);
                return g(o), K;
            }
            b(o, "ciphertext cannot be decrypted using that key");
        }
        function L(e, r, a, _, n, s) {
            var c = [];
            l(s);
            var o = d(e = x(c, e, "message")), h = e.length;
            c.push(o);
            var p = null, i = 0;
            null != r && (p = d(r = x(c, r, "additional_data")), i = r.length, c.push(p));
            var v = null;
            null != a && (v = d(a = x(c, a, "secret_nonce")), a.length, c.push(v)), _ = x(c, _, "public_nonce");
            var m, E = 0 | t._crypto_aead_chacha20poly1305_npubbytes();
            _.length !== E && f(c, "invalid public_nonce length"), m = d(_), c.push(m), n = x(c, n, "key");
            var k, S = 0 | t._crypto_aead_chacha20poly1305_keybytes();
            n.length !== S && f(c, "invalid key length"), k = d(n), c.push(k);
            var T = new u(h + t._crypto_aead_chacha20poly1305_abytes() | 0), w = T.address;
            if (c.push(w), 0 === t._crypto_aead_chacha20poly1305_encrypt(w, null, o, h, 0, p, i, 0, v, m, k)) {
                var Y = y(T, s);
                return g(c), Y;
            }
            b(c, "invalid usage");
        }
        function U(e, r, a, _, n, s) {
            var c = [];
            l(s);
            var o = d(e = x(c, e, "message")), h = e.length;
            c.push(o);
            var p = null, i = 0;
            null != r && (p = d(r = x(c, r, "additional_data")), i = r.length, c.push(p));
            var v = null;
            null != a && (v = d(a = x(c, a, "secret_nonce")), a.length, c.push(v)), _ = x(c, _, "public_nonce");
            var m, E = 0 | t._crypto_aead_chacha20poly1305_npubbytes();
            _.length !== E && f(c, "invalid public_nonce length"), m = d(_), c.push(m), n = x(c, n, "key");
            var k, S = 0 | t._crypto_aead_chacha20poly1305_keybytes();
            n.length !== S && f(c, "invalid key length"), k = d(n), c.push(k);
            var T = new u(0 | h), w = T.address;
            c.push(w);
            var Y = new u(0 | t._crypto_aead_chacha20poly1305_abytes()), B = Y.address;
            if (c.push(B), 0 === t._crypto_aead_chacha20poly1305_encrypt_detached(w, B, null, o, h, 0, p, i, 0, v, m, k)) {
                var A = y({
                    ciphertext: T,
                    mac: Y
                }, s);
                return g(c), A;
            }
            b(c, "invalid usage");
        }
        function O(e, r, a, _, n, s) {
            var c = [];
            l(s);
            var o = null;
            null != e && (o = d(e = x(c, e, "secret_nonce")), e.length, c.push(o)), r = x(c, r, "ciphertext");
            var h, p = t._crypto_aead_chacha20poly1305_ietf_abytes(), i = r.length;
            i < p && f(c, "ciphertext is too short"), h = d(r), c.push(h);
            var v = null, m = 0;
            null != a && (v = d(a = x(c, a, "additional_data")), m = a.length, c.push(v)), _ = x(c, _, "public_nonce");
            var E, k = 0 | t._crypto_aead_chacha20poly1305_ietf_npubbytes();
            _.length !== k && f(c, "invalid public_nonce length"), E = d(_), c.push(E), n = x(c, n, "key");
            var S, T = 0 | t._crypto_aead_chacha20poly1305_ietf_keybytes();
            n.length !== T && f(c, "invalid key length"), S = d(n), c.push(S);
            var w = new u(i - t._crypto_aead_chacha20poly1305_ietf_abytes() | 0), Y = w.address;
            if (c.push(Y), 0 === t._crypto_aead_chacha20poly1305_ietf_decrypt(Y, null, o, h, i, 0, v, m, 0, E, S)) {
                var B = y(w, s);
                return g(c), B;
            }
            b(c, "ciphertext cannot be decrypted using that key");
        }
        function C(e, r, a, _, n, s, c) {
            var o = [];
            l(c);
            var h = null;
            null != e && (h = d(e = x(o, e, "secret_nonce")), e.length, o.push(h));
            var p = d(r = x(o, r, "ciphertext")), i = r.length;
            o.push(p), a = x(o, a, "mac");
            var v, m = 0 | t._crypto_box_macbytes();
            a.length !== m && f(o, "invalid mac length"), v = d(a), o.push(v);
            var E = null, k = 0;
            null != _ && (E = d(_ = x(o, _, "additional_data")), k = _.length, o.push(E)), n = x(o, n, "public_nonce");
            var S, T = 0 | t._crypto_aead_chacha20poly1305_ietf_npubbytes();
            n.length !== T && f(o, "invalid public_nonce length"), S = d(n), o.push(S), s = x(o, s, "key");
            var w, Y = 0 | t._crypto_aead_chacha20poly1305_ietf_keybytes();
            s.length !== Y && f(o, "invalid key length"), w = d(s), o.push(w);
            var B = new u(0 | i), A = B.address;
            if (o.push(A), 0 === t._crypto_aead_chacha20poly1305_ietf_decrypt_detached(A, h, p, i, 0, v, E, k, 0, S, w)) {
                var K = y(B, c);
                return g(o), K;
            }
            b(o, "ciphertext cannot be decrypted using that key");
        }
        function R(e, r, a, _, n, s) {
            var c = [];
            l(s);
            var o = d(e = x(c, e, "message")), h = e.length;
            c.push(o);
            var p = null, i = 0;
            null != r && (p = d(r = x(c, r, "additional_data")), i = r.length, c.push(p));
            var v = null;
            null != a && (v = d(a = x(c, a, "secret_nonce")), a.length, c.push(v)), _ = x(c, _, "public_nonce");
            var m, E = 0 | t._crypto_aead_chacha20poly1305_ietf_npubbytes();
            _.length !== E && f(c, "invalid public_nonce length"), m = d(_), c.push(m), n = x(c, n, "key");
            var k, S = 0 | t._crypto_aead_chacha20poly1305_ietf_keybytes();
            n.length !== S && f(c, "invalid key length"), k = d(n), c.push(k);
            var T = new u(h + t._crypto_aead_chacha20poly1305_ietf_abytes() | 0), w = T.address;
            if (c.push(w), 0 === t._crypto_aead_chacha20poly1305_ietf_encrypt(w, null, o, h, 0, p, i, 0, v, m, k)) {
                var Y = y(T, s);
                return g(c), Y;
            }
            b(c, "invalid usage");
        }
        function P(e, r, a, _, n, s) {
            var c = [];
            l(s);
            var o = d(e = x(c, e, "message")), h = e.length;
            c.push(o);
            var p = null, i = 0;
            null != r && (p = d(r = x(c, r, "additional_data")), i = r.length, c.push(p));
            var v = null;
            null != a && (v = d(a = x(c, a, "secret_nonce")), a.length, c.push(v)), _ = x(c, _, "public_nonce");
            var m, E = 0 | t._crypto_aead_chacha20poly1305_ietf_npubbytes();
            _.length !== E && f(c, "invalid public_nonce length"), m = d(_), c.push(m), n = x(c, n, "key");
            var k, S = 0 | t._crypto_aead_chacha20poly1305_ietf_keybytes();
            n.length !== S && f(c, "invalid key length"), k = d(n), c.push(k);
            var T = new u(0 | h), w = T.address;
            c.push(w);
            var Y = new u(0 | t._crypto_aead_chacha20poly1305_ietf_abytes()), B = Y.address;
            if (c.push(B), 0 === t._crypto_aead_chacha20poly1305_ietf_encrypt_detached(w, B, null, o, h, 0, p, i, 0, v, m, k)) {
                var A = y({
                    ciphertext: T,
                    mac: Y
                }, s);
                return g(c), A;
            }
            b(c, "invalid usage");
        }
        function G(e) {
            var r = [];
            l(e);
            var a = new u(0 | t._crypto_aead_chacha20poly1305_ietf_keybytes()), _ = a.address;
            r.push(_), t._crypto_aead_chacha20poly1305_ietf_keygen(_);
            var n = y(a, e);
            return g(r), n;
        }
        function X(e) {
            var r = [];
            l(e);
            var a = new u(0 | t._crypto_aead_chacha20poly1305_keybytes()), _ = a.address;
            r.push(_), t._crypto_aead_chacha20poly1305_keygen(_);
            var n = y(a, e);
            return g(r), n;
        }
        function D(e, r, a, _, n, s) {
            var c = [];
            l(s);
            var o = null;
            null != e && (o = d(e = x(c, e, "secret_nonce")), e.length, c.push(o)), r = x(c, r, "ciphertext");
            var h, p = t._crypto_aead_xchacha20poly1305_ietf_abytes(), i = r.length;
            i < p && f(c, "ciphertext is too short"), h = d(r), c.push(h);
            var v = null, m = 0;
            null != a && (v = d(a = x(c, a, "additional_data")), m = a.length, c.push(v)), _ = x(c, _, "public_nonce");
            var E, k = 0 | t._crypto_aead_xchacha20poly1305_ietf_npubbytes();
            _.length !== k && f(c, "invalid public_nonce length"), E = d(_), c.push(E), n = x(c, n, "key");
            var S, T = 0 | t._crypto_aead_xchacha20poly1305_ietf_keybytes();
            n.length !== T && f(c, "invalid key length"), S = d(n), c.push(S);
            var w = new u(i - t._crypto_aead_xchacha20poly1305_ietf_abytes() | 0), Y = w.address;
            if (c.push(Y), 0 === t._crypto_aead_xchacha20poly1305_ietf_decrypt(Y, null, o, h, i, 0, v, m, 0, E, S)) {
                var B = y(w, s);
                return g(c), B;
            }
            b(c, "ciphertext cannot be decrypted using that key");
        }
        function F(e, r, a, _, n, s, c) {
            var o = [];
            l(c);
            var h = null;
            null != e && (h = d(e = x(o, e, "secret_nonce")), e.length, o.push(h));
            var p = d(r = x(o, r, "ciphertext")), i = r.length;
            o.push(p), a = x(o, a, "mac");
            var v, m = 0 | t._crypto_box_macbytes();
            a.length !== m && f(o, "invalid mac length"), v = d(a), o.push(v);
            var E = null, k = 0;
            null != _ && (E = d(_ = x(o, _, "additional_data")), k = _.length, o.push(E)), n = x(o, n, "public_nonce");
            var S, T = 0 | t._crypto_aead_xchacha20poly1305_ietf_npubbytes();
            n.length !== T && f(o, "invalid public_nonce length"), S = d(n), o.push(S), s = x(o, s, "key");
            var w, Y = 0 | t._crypto_aead_xchacha20poly1305_ietf_keybytes();
            s.length !== Y && f(o, "invalid key length"), w = d(s), o.push(w);
            var B = new u(0 | i), A = B.address;
            if (o.push(A), 0 === t._crypto_aead_xchacha20poly1305_ietf_decrypt_detached(A, h, p, i, 0, v, E, k, 0, S, w)) {
                var K = y(B, c);
                return g(o), K;
            }
            b(o, "ciphertext cannot be decrypted using that key");
        }
        function V(e, r, a, _, n, s) {
            var c = [];
            l(s);
            var o = d(e = x(c, e, "message")), h = e.length;
            c.push(o);
            var p = null, i = 0;
            null != r && (p = d(r = x(c, r, "additional_data")), i = r.length, c.push(p));
            var v = null;
            null != a && (v = d(a = x(c, a, "secret_nonce")), a.length, c.push(v)), _ = x(c, _, "public_nonce");
            var m, E = 0 | t._crypto_aead_xchacha20poly1305_ietf_npubbytes();
            _.length !== E && f(c, "invalid public_nonce length"), m = d(_), c.push(m), n = x(c, n, "key");
            var k, S = 0 | t._crypto_aead_xchacha20poly1305_ietf_keybytes();
            n.length !== S && f(c, "invalid key length"), k = d(n), c.push(k);
            var T = new u(h + t._crypto_aead_xchacha20poly1305_ietf_abytes() | 0), w = T.address;
            if (c.push(w), 0 === t._crypto_aead_xchacha20poly1305_ietf_encrypt(w, null, o, h, 0, p, i, 0, v, m, k)) {
                var Y = y(T, s);
                return g(c), Y;
            }
            b(c, "invalid usage");
        }
        function H(e, r, a, _, n, s) {
            var c = [];
            l(s);
            var o = d(e = x(c, e, "message")), h = e.length;
            c.push(o);
            var p = null, i = 0;
            null != r && (p = d(r = x(c, r, "additional_data")), i = r.length, c.push(p));
            var v = null;
            null != a && (v = d(a = x(c, a, "secret_nonce")), a.length, c.push(v)), _ = x(c, _, "public_nonce");
            var m, E = 0 | t._crypto_aead_xchacha20poly1305_ietf_npubbytes();
            _.length !== E && f(c, "invalid public_nonce length"), m = d(_), c.push(m), n = x(c, n, "key");
            var k, S = 0 | t._crypto_aead_xchacha20poly1305_ietf_keybytes();
            n.length !== S && f(c, "invalid key length"), k = d(n), c.push(k);
            var T = new u(0 | h), w = T.address;
            c.push(w);
            var Y = new u(0 | t._crypto_aead_xchacha20poly1305_ietf_abytes()), B = Y.address;
            if (c.push(B), 0 === t._crypto_aead_xchacha20poly1305_ietf_encrypt_detached(w, B, null, o, h, 0, p, i, 0, v, m, k)) {
                var A = y({
                    ciphertext: T,
                    mac: Y
                }, s);
                return g(c), A;
            }
            b(c, "invalid usage");
        }
        function q(e) {
            var r = [];
            l(e);
            var a = new u(0 | t._crypto_aead_xchacha20poly1305_ietf_keybytes()), _ = a.address;
            r.push(_), t._crypto_aead_xchacha20poly1305_ietf_keygen(_);
            var n = y(a, e);
            return g(r), n;
        }
        function j(e, r, a) {
            var _ = [];
            l(a);
            var n = d(e = x(_, e, "message")), s = e.length;
            _.push(n), r = x(_, r, "key");
            var c, o = 0 | t._crypto_auth_keybytes();
            r.length !== o && f(_, "invalid key length"), c = d(r), _.push(c);
            var h = new u(0 | t._crypto_auth_bytes()), p = h.address;
            if (_.push(p), 0 == (0 | t._crypto_auth(p, n, s, 0, c))) {
                var i = y(h, a);
                return g(_), i;
            }
            b(_, "invalid usage");
        }
        function z(e, r, a) {
            var _ = [];
            l(a);
            var n = d(e = x(_, e, "message")), s = e.length;
            _.push(n), r = x(_, r, "key");
            var c, o = 0 | t._crypto_auth_hmacsha256_keybytes();
            r.length !== o && f(_, "invalid key length"), c = d(r), _.push(c);
            var h = new u(0 | t._crypto_auth_hmacsha256_bytes()), p = h.address;
            if (_.push(p), 0 == (0 | t._crypto_auth_hmacsha256(p, n, s, 0, c))) {
                var i = y(h, a);
                return g(_), i;
            }
            b(_, "invalid usage");
        }
        function W(e, r) {
            var a = [];
            l(r), m(a, e, "state_address");
            var _ = new u(0 | t._crypto_auth_hmacsha256_bytes()), n = _.address;
            if (a.push(n), 0 == (0 | t._crypto_auth_hmacsha256_final(e, n))) {
                var s = (t._free(e), y(_, r));
                return g(a), s;
            }
            b(a, "invalid usage");
        }
        function J(e, r) {
            var a = [];
            l(r);
            var _ = null, n = 0;
            null != e && (_ = d(e = x(a, e, "key")), n = e.length, a.push(_));
            var s = new u(208).address;
            if (0 == (0 | t._crypto_auth_hmacsha256_init(s, _, n))) {
                var c = s;
                return g(a), c;
            }
            b(a, "invalid usage");
        }
        function Q(e) {
            var r = [];
            l(e);
            var a = new u(0 | t._crypto_auth_hmacsha256_keybytes()), _ = a.address;
            r.push(_), t._crypto_auth_hmacsha256_keygen(_);
            var n = y(a, e);
            return g(r), n;
        }
        function Z(e, r, a) {
            var _ = [];
            l(a), m(_, e, "state_address");
            var n = d(r = x(_, r, "message_chunk")), s = r.length;
            _.push(n), 0 != (0 | t._crypto_auth_hmacsha256_update(e, n, s)) && b(_, "invalid usage"), g(_);
        }
        function $(e, r, a) {
            var _ = [];
            e = x(_, e, "tag");
            var n, s = 0 | t._crypto_auth_hmacsha256_bytes();
            e.length !== s && f(_, "invalid tag length"), n = d(e), _.push(n);
            var c = d(r = x(_, r, "message")), o = r.length;
            _.push(c), a = x(_, a, "key");
            var h, p = 0 | t._crypto_auth_hmacsha256_keybytes();
            a.length !== p && f(_, "invalid key length"), h = d(a), _.push(h);
            var y = 0 == (0 | t._crypto_auth_hmacsha256_verify(n, c, o, 0, h));
            return g(_), y;
        }
        function ee(e, r, a) {
            var _ = [];
            l(a);
            var n = d(e = x(_, e, "message")), s = e.length;
            _.push(n), r = x(_, r, "key");
            var c, o = 0 | t._crypto_auth_hmacsha512_keybytes();
            r.length !== o && f(_, "invalid key length"), c = d(r), _.push(c);
            var h = new u(0 | t._crypto_auth_hmacsha512_bytes()), p = h.address;
            if (_.push(p), 0 == (0 | t._crypto_auth_hmacsha512(p, n, s, 0, c))) {
                var i = y(h, a);
                return g(_), i;
            }
            b(_, "invalid usage");
        }
        function re(e, r) {
            var a = [];
            l(r), m(a, e, "state_address");
            var _ = new u(0 | t._crypto_auth_hmacsha512_bytes()), n = _.address;
            if (a.push(n), 0 == (0 | t._crypto_auth_hmacsha512_final(e, n))) {
                var s = (t._free(e), y(_, r));
                return g(a), s;
            }
            b(a, "invalid usage");
        }
        function te(e, r) {
            var a = [];
            l(r);
            var _ = null, n = 0;
            null != e && (_ = d(e = x(a, e, "key")), n = e.length, a.push(_));
            var s = new u(416).address;
            if (0 == (0 | t._crypto_auth_hmacsha512_init(s, _, n))) {
                var c = s;
                return g(a), c;
            }
            b(a, "invalid usage");
        }
        function ae(e) {
            var r = [];
            l(e);
            var a = new u(0 | t._crypto_auth_hmacsha512_keybytes()), _ = a.address;
            r.push(_), t._crypto_auth_hmacsha512_keygen(_);
            var n = y(a, e);
            return g(r), n;
        }
        function _e(e, r, a) {
            var _ = [];
            l(a), m(_, e, "state_address");
            var n = d(r = x(_, r, "message_chunk")), s = r.length;
            _.push(n), 0 != (0 | t._crypto_auth_hmacsha512_update(e, n, s)) && b(_, "invalid usage"), g(_);
        }
        function ne(e, r, a) {
            var _ = [];
            e = x(_, e, "tag");
            var n, s = 0 | t._crypto_auth_hmacsha512_bytes();
            e.length !== s && f(_, "invalid tag length"), n = d(e), _.push(n);
            var c = d(r = x(_, r, "message")), o = r.length;
            _.push(c), a = x(_, a, "key");
            var h, p = 0 | t._crypto_auth_hmacsha512_keybytes();
            a.length !== p && f(_, "invalid key length"), h = d(a), _.push(h);
            var y = 0 == (0 | t._crypto_auth_hmacsha512_verify(n, c, o, 0, h));
            return g(_), y;
        }
        function se(e) {
            var r = [];
            l(e);
            var a = new u(0 | t._crypto_auth_keybytes()), _ = a.address;
            r.push(_), t._crypto_auth_keygen(_);
            var n = y(a, e);
            return g(r), n;
        }
        function ce(e, r, a) {
            var _ = [];
            e = x(_, e, "tag");
            var n, s = 0 | t._crypto_auth_bytes();
            e.length !== s && f(_, "invalid tag length"), n = d(e), _.push(n);
            var c = d(r = x(_, r, "message")), o = r.length;
            _.push(c), a = x(_, a, "key");
            var h, p = 0 | t._crypto_auth_keybytes();
            a.length !== p && f(_, "invalid key length"), h = d(a), _.push(h);
            var y = 0 == (0 | t._crypto_auth_verify(n, c, o, 0, h));
            return g(_), y;
        }
        function oe(e, r, a) {
            var _ = [];
            l(a), e = x(_, e, "publicKey");
            var n, s = 0 | t._crypto_box_publickeybytes();
            e.length !== s && f(_, "invalid publicKey length"), n = d(e), _.push(n), r = x(_, r, "privateKey");
            var c, o = 0 | t._crypto_box_secretkeybytes();
            r.length !== o && f(_, "invalid privateKey length"), c = d(r), _.push(c);
            var h = new u(0 | t._crypto_box_beforenmbytes()), p = h.address;
            if (_.push(p), 0 == (0 | t._crypto_box_beforenm(p, n, c))) {
                var i = y(h, a);
                return g(_), i;
            }
            b(_, "invalid usage");
        }
        function he(e, r, a) {
            var _ = [];
            l(a), e = x(_, e, "publicKey");
            var n, s = 0 | t._crypto_box_curve25519xchacha20poly1305_publickeybytes();
            e.length !== s && f(_, "invalid publicKey length"), n = d(e), _.push(n), r = x(_, r, "privateKey");
            var c, o = 0 | t._crypto_box_curve25519xchacha20poly1305_secretkeybytes();
            r.length !== o && f(_, "invalid privateKey length"), c = d(r), _.push(c);
            var h = new u(0 | t._crypto_box_curve25519xchacha20poly1305_beforenmbytes()), p = h.address;
            if (_.push(p), 0 == (0 | t._crypto_box_curve25519xchacha20poly1305_beforenm(p, n, c))) {
                var i = y(h, a);
                return g(_), i;
            }
            b(_, "invalid usage");
        }
        function pe(e, r, a, _, n) {
            var s = [];
            l(n);
            var c = d(e = x(s, e, "message")), o = e.length;
            s.push(c), r = x(s, r, "nonce");
            var h, p = 0 | t._crypto_box_curve25519xchacha20poly1305_noncebytes();
            r.length !== p && f(s, "invalid nonce length"), h = d(r), s.push(h), a = x(s, a, "publicKey");
            var i, v = 0 | t._crypto_box_curve25519xchacha20poly1305_publickeybytes();
            a.length !== v && f(s, "invalid publicKey length"), i = d(a), s.push(i), _ = x(s, _, "privateKey");
            var m, E = 0 | t._crypto_box_curve25519xchacha20poly1305_secretkeybytes();
            _.length !== E && f(s, "invalid privateKey length"), m = d(_), s.push(m);
            var k = new u(0 | o), S = k.address;
            s.push(S);
            var T = new u(0 | t._crypto_box_curve25519xchacha20poly1305_macbytes()), w = T.address;
            if (s.push(w), 0 == (0 | t._crypto_box_curve25519xchacha20poly1305_detached(S, w, c, o, 0, h, i, m))) {
                var Y = y({
                    ciphertext: k,
                    mac: T
                }, n);
                return g(s), Y;
            }
            b(s, "invalid usage");
        }
        function ye(e, r, a, _) {
            var n = [];
            l(_);
            var s = d(e = x(n, e, "message")), c = e.length;
            n.push(s), r = x(n, r, "nonce");
            var o, h = 0 | t._crypto_box_curve25519xchacha20poly1305_noncebytes();
            r.length !== h && f(n, "invalid nonce length"), o = d(r), n.push(o), a = x(n, a, "sharedKey");
            var p, i = 0 | t._crypto_box_curve25519xchacha20poly1305_beforenmbytes();
            a.length !== i && f(n, "invalid sharedKey length"), p = d(a), n.push(p);
            var v = new u(0 | c), m = v.address;
            n.push(m);
            var E = new u(0 | t._crypto_box_curve25519xchacha20poly1305_macbytes()), k = E.address;
            if (n.push(k), 0 == (0 | t._crypto_box_curve25519xchacha20poly1305_detached_afternm(m, k, s, c, 0, o, p))) {
                var S = y({
                    ciphertext: v,
                    mac: E
                }, _);
                return g(n), S;
            }
            b(n, "invalid usage");
        }
        function ie(e, r, a, _, n) {
            var s = [];
            l(n);
            var c = d(e = x(s, e, "message")), o = e.length;
            s.push(c), r = x(s, r, "nonce");
            var h, p = 0 | t._crypto_box_curve25519xchacha20poly1305_noncebytes();
            r.length !== p && f(s, "invalid nonce length"), h = d(r), s.push(h), a = x(s, a, "publicKey");
            var i, v = 0 | t._crypto_box_curve25519xchacha20poly1305_publickeybytes();
            a.length !== v && f(s, "invalid publicKey length"), i = d(a), s.push(i), _ = x(s, _, "privateKey");
            var m, E = 0 | t._crypto_box_curve25519xchacha20poly1305_secretkeybytes();
            _.length !== E && f(s, "invalid privateKey length"), m = d(_), s.push(m);
            var k = new u(o + t._crypto_box_curve25519xchacha20poly1305_macbytes() | 0), S = k.address;
            if (s.push(S), 0 == (0 | t._crypto_box_curve25519xchacha20poly1305_easy(S, c, o, 0, h, i, m))) {
                var T = y(k, n);
                return g(s), T;
            }
            b(s, "invalid usage");
        }
        function le(e, r, a, _) {
            var n = [];
            l(_);
            var s = d(e = x(n, e, "message")), c = e.length;
            n.push(s), r = x(n, r, "nonce");
            var o, h = 0 | t._crypto_box_curve25519xchacha20poly1305_noncebytes();
            r.length !== h && f(n, "invalid nonce length"), o = d(r), n.push(o), a = x(n, a, "sharedKey");
            var p, i = 0 | t._crypto_box_curve25519xchacha20poly1305_beforenmbytes();
            a.length !== i && f(n, "invalid sharedKey length"), p = d(a), n.push(p);
            var v = new u(c + t._crypto_box_curve25519xchacha20poly1305_macbytes() | 0), m = v.address;
            if (n.push(m), 0 == (0 | t._crypto_box_curve25519xchacha20poly1305_easy_afternm(m, s, c, 0, o, p))) {
                var E = y(v, _);
                return g(n), E;
            }
            b(n, "invalid usage");
        }
        function ue(e) {
            var r = [];
            l(e);
            var a = new u(0 | t._crypto_box_curve25519xchacha20poly1305_publickeybytes()), _ = a.address;
            r.push(_);
            var n = new u(0 | t._crypto_box_curve25519xchacha20poly1305_secretkeybytes()), s = n.address;
            r.push(s), t._crypto_box_curve25519xchacha20poly1305_keypair(_, s);
            var c = y({
                publicKey: a,
                privateKey: n,
                keyType: "curve25519"
            }, e);
            return g(r), c;
        }
        function de(e, r, a, _, n, s) {
            var c = [];
            l(s);
            var o = d(e = x(c, e, "ciphertext")), h = e.length;
            c.push(o), r = x(c, r, "mac");
            var p, i = 0 | t._crypto_box_curve25519xchacha20poly1305_macbytes();
            r.length !== i && f(c, "invalid mac length"), p = d(r), c.push(p), a = x(c, a, "nonce");
            var v, m = 0 | t._crypto_box_curve25519xchacha20poly1305_noncebytes();
            a.length !== m && f(c, "invalid nonce length"), v = d(a), c.push(v), _ = x(c, _, "publicKey");
            var E, k = 0 | t._crypto_box_curve25519xchacha20poly1305_publickeybytes();
            _.length !== k && f(c, "invalid publicKey length"), E = d(_), c.push(E), n = x(c, n, "privateKey");
            var S, T = 0 | t._crypto_box_curve25519xchacha20poly1305_secretkeybytes();
            n.length !== T && f(c, "invalid privateKey length"), S = d(n), c.push(S);
            var w = new u(0 | h), Y = w.address;
            if (c.push(Y), 0 == (0 | t._crypto_box_curve25519xchacha20poly1305_open_detached(Y, o, p, h, 0, v, E, S))) {
                var B = y(w, s);
                return g(c), B;
            }
            b(c, "incorrect key pair for the given ciphertext");
        }
        function ve(e, r, a, _, n) {
            var s = [];
            l(n);
            var c = d(e = x(s, e, "ciphertext")), o = e.length;
            s.push(c), r = x(s, r, "mac");
            var h, p = 0 | t._crypto_box_curve25519xchacha20poly1305_macbytes();
            r.length !== p && f(s, "invalid mac length"), h = d(r), s.push(h), a = x(s, a, "nonce");
            var i, v = 0 | t._crypto_box_curve25519xchacha20poly1305_noncebytes();
            a.length !== v && f(s, "invalid nonce length"), i = d(a), s.push(i), _ = x(s, _, "sharedKey");
            var m, E = 0 | t._crypto_box_curve25519xchacha20poly1305_beforenmbytes();
            _.length !== E && f(s, "invalid sharedKey length"), m = d(_), s.push(m);
            var k = new u(0 | o), S = k.address;
            if (s.push(S), 0 == (0 | t._crypto_box_curve25519xchacha20poly1305_open_detached_afternm(S, c, h, o, 0, i, m))) {
                var T = y(k, n);
                return g(s), T;
            }
            b(s, "incorrect secret key for the given ciphertext");
        }
        function ge(e, r, a, _, n) {
            var s = [];
            l(n), e = x(s, e, "ciphertext");
            var c, o = t._crypto_box_curve25519xchacha20poly1305_macbytes(), h = e.length;
            h < o && f(s, "ciphertext is too short"), c = d(e), s.push(c), r = x(s, r, "nonce");
            var p, i = 0 | t._crypto_box_curve25519xchacha20poly1305_noncebytes();
            r.length !== i && f(s, "invalid nonce length"), p = d(r), s.push(p), a = x(s, a, "publicKey");
            var v, m = 0 | t._crypto_box_curve25519xchacha20poly1305_publickeybytes();
            a.length !== m && f(s, "invalid publicKey length"), v = d(a), s.push(v), _ = x(s, _, "privateKey");
            var E, k = 0 | t._crypto_box_curve25519xchacha20poly1305_secretkeybytes();
            _.length !== k && f(s, "invalid privateKey length"), E = d(_), s.push(E);
            var S = new u(h - t._crypto_box_curve25519xchacha20poly1305_macbytes() | 0), T = S.address;
            if (s.push(T), 0 == (0 | t._crypto_box_curve25519xchacha20poly1305_open_easy(T, c, h, 0, p, v, E))) {
                var w = y(S, n);
                return g(s), w;
            }
            b(s, "incorrect key pair for the given ciphertext");
        }
        function be(e, r, a, _) {
            var n = [];
            l(_);
            var s = d(e = x(n, e, "ciphertext")), c = e.length;
            n.push(s), r = x(n, r, "nonce");
            var o, h = 0 | t._crypto_box_curve25519xchacha20poly1305_noncebytes();
            r.length !== h && f(n, "invalid nonce length"), o = d(r), n.push(o), a = x(n, a, "sharedKey");
            var p, i = 0 | t._crypto_box_curve25519xchacha20poly1305_beforenmbytes();
            a.length !== i && f(n, "invalid sharedKey length"), p = d(a), n.push(p);
            var v = new u(c - t._crypto_box_curve25519xchacha20poly1305_macbytes() | 0), m = v.address;
            if (n.push(m), 0 == (0 | t._crypto_box_curve25519xchacha20poly1305_open_easy_afternm(m, s, c, 0, o, p))) {
                var E = y(v, _);
                return g(n), E;
            }
            b(n, "incorrect secret key for the given ciphertext");
        }
        function fe(e, r, a) {
            var _ = [];
            l(a);
            var n = d(e = x(_, e, "message")), s = e.length;
            _.push(n), r = x(_, r, "publicKey");
            var c, o = 0 | t._crypto_box_curve25519xchacha20poly1305_publickeybytes();
            r.length !== o && f(_, "invalid publicKey length"), c = d(r), _.push(c);
            var h = new u(s + t._crypto_box_curve25519xchacha20poly1305_sealbytes() | 0), p = h.address;
            _.push(p), t._crypto_box_curve25519xchacha20poly1305_seal(p, n, s, 0, c);
            var i = y(h, a);
            return g(_), i;
        }
        function me(e, r, a, _) {
            var n = [];
            l(_), e = x(n, e, "ciphertext");
            var s, c = t._crypto_box_curve25519xchacha20poly1305_sealbytes(), o = e.length;
            o < c && f(n, "ciphertext is too short"), s = d(e), n.push(s), r = x(n, r, "publicKey");
            var h, p = 0 | t._crypto_box_curve25519xchacha20poly1305_publickeybytes();
            r.length !== p && f(n, "invalid publicKey length"), h = d(r), n.push(h), a = x(n, a, "secretKey");
            var i, v = 0 | t._crypto_box_curve25519xchacha20poly1305_secretkeybytes();
            a.length !== v && f(n, "invalid secretKey length"), i = d(a), n.push(i);
            var b = new u(o - t._crypto_box_curve25519xchacha20poly1305_sealbytes() | 0), m = b.address;
            n.push(m), t._crypto_box_curve25519xchacha20poly1305_seal_open(m, s, o, 0, h, i);
            var E = y(b, _);
            return g(n), E;
        }
        function xe(e, r) {
            var a = [];
            l(r), e = x(a, e, "seed");
            var _, n = 0 | t._crypto_box_curve25519xchacha20poly1305_seedbytes();
            e.length !== n && f(a, "invalid seed length"), _ = d(e), a.push(_);
            var s = new u(0 | t._crypto_box_curve25519xchacha20poly1305_publickeybytes()), c = s.address;
            a.push(c);
            var o = new u(0 | t._crypto_box_curve25519xchacha20poly1305_secretkeybytes()), h = o.address;
            if (a.push(h), 0 == (0 | t._crypto_box_curve25519xchacha20poly1305_seed_keypair(c, h, _))) {
                var p = {
                    publicKey: y(s, r),
                    privateKey: y(o, r),
                    keyType: "x25519"
                };
                return g(a), p;
            }
            b(a, "invalid usage");
        }
        function Ee(e, r, a, _, n) {
            var s = [];
            l(n);
            var c = d(e = x(s, e, "message")), o = e.length;
            s.push(c), r = x(s, r, "nonce");
            var h, p = 0 | t._crypto_box_noncebytes();
            r.length !== p && f(s, "invalid nonce length"), h = d(r), s.push(h), a = x(s, a, "publicKey");
            var i, v = 0 | t._crypto_box_publickeybytes();
            a.length !== v && f(s, "invalid publicKey length"), i = d(a), s.push(i), _ = x(s, _, "privateKey");
            var m, E = 0 | t._crypto_box_secretkeybytes();
            _.length !== E && f(s, "invalid privateKey length"), m = d(_), s.push(m);
            var k = new u(0 | o), S = k.address;
            s.push(S);
            var T = new u(0 | t._crypto_box_macbytes()), w = T.address;
            if (s.push(w), 0 == (0 | t._crypto_box_detached(S, w, c, o, 0, h, i, m))) {
                var Y = y({
                    ciphertext: k,
                    mac: T
                }, n);
                return g(s), Y;
            }
            b(s, "invalid usage");
        }
        function ke(e, r, a, _, n) {
            var s = [];
            l(n);
            var c = d(e = x(s, e, "message")), o = e.length;
            s.push(c), r = x(s, r, "nonce");
            var h, p = 0 | t._crypto_box_noncebytes();
            r.length !== p && f(s, "invalid nonce length"), h = d(r), s.push(h), a = x(s, a, "publicKey");
            var i, v = 0 | t._crypto_box_publickeybytes();
            a.length !== v && f(s, "invalid publicKey length"), i = d(a), s.push(i), _ = x(s, _, "privateKey");
            var m, E = 0 | t._crypto_box_secretkeybytes();
            _.length !== E && f(s, "invalid privateKey length"), m = d(_), s.push(m);
            var k = new u(o + t._crypto_box_macbytes() | 0), S = k.address;
            if (s.push(S), 0 == (0 | t._crypto_box_easy(S, c, o, 0, h, i, m))) {
                var T = y(k, n);
                return g(s), T;
            }
            b(s, "invalid usage");
        }
        function Se(e, r, a, _) {
            var n = [];
            l(_);
            var s = d(e = x(n, e, "message")), c = e.length;
            n.push(s), r = x(n, r, "nonce");
            var o, h = 0 | t._crypto_box_noncebytes();
            r.length !== h && f(n, "invalid nonce length"), o = d(r), n.push(o), a = x(n, a, "sharedKey");
            var p, i = 0 | t._crypto_box_beforenmbytes();
            a.length !== i && f(n, "invalid sharedKey length"), p = d(a), n.push(p);
            var v = new u(c + t._crypto_box_macbytes() | 0), m = v.address;
            if (n.push(m), 0 == (0 | t._crypto_box_easy_afternm(m, s, c, 0, o, p))) {
                var E = y(v, _);
                return g(n), E;
            }
            b(n, "invalid usage");
        }
        function Te(e) {
            var r = [];
            l(e);
            var a = new u(0 | t._crypto_box_publickeybytes()), _ = a.address;
            r.push(_);
            var n = new u(0 | t._crypto_box_secretkeybytes()), s = n.address;
            if (r.push(s), 0 == (0 | t._crypto_box_keypair(_, s))) {
                var c = {
                    publicKey: y(a, e),
                    privateKey: y(n, e),
                    keyType: "x25519"
                };
                return g(r), c;
            }
            b(r, "internal error");
        }
        function we(e, r, a, _, n, s) {
            var c = [];
            l(s);
            var o = d(e = x(c, e, "ciphertext")), h = e.length;
            c.push(o), r = x(c, r, "mac");
            var p, i = 0 | t._crypto_box_macbytes();
            r.length !== i && f(c, "invalid mac length"), p = d(r), c.push(p), a = x(c, a, "nonce");
            var v, m = 0 | t._crypto_box_noncebytes();
            a.length !== m && f(c, "invalid nonce length"), v = d(a), c.push(v), _ = x(c, _, "publicKey");
            var E, k = 0 | t._crypto_box_publickeybytes();
            _.length !== k && f(c, "invalid publicKey length"), E = d(_), c.push(E), n = x(c, n, "privateKey");
            var S, T = 0 | t._crypto_box_secretkeybytes();
            n.length !== T && f(c, "invalid privateKey length"), S = d(n), c.push(S);
            var w = new u(0 | h), Y = w.address;
            if (c.push(Y), 0 == (0 | t._crypto_box_open_detached(Y, o, p, h, 0, v, E, S))) {
                var B = y(w, s);
                return g(c), B;
            }
            b(c, "incorrect key pair for the given ciphertext");
        }
        function Ye(e, r, a, _, n) {
            var s = [];
            l(n), e = x(s, e, "ciphertext");
            var c, o = t._crypto_box_macbytes(), h = e.length;
            h < o && f(s, "ciphertext is too short"), c = d(e), s.push(c), r = x(s, r, "nonce");
            var p, i = 0 | t._crypto_box_noncebytes();
            r.length !== i && f(s, "invalid nonce length"), p = d(r), s.push(p), a = x(s, a, "publicKey");
            var v, m = 0 | t._crypto_box_publickeybytes();
            a.length !== m && f(s, "invalid publicKey length"), v = d(a), s.push(v), _ = x(s, _, "privateKey");
            var E, k = 0 | t._crypto_box_secretkeybytes();
            _.length !== k && f(s, "invalid privateKey length"), E = d(_), s.push(E);
            var S = new u(h - t._crypto_box_macbytes() | 0), T = S.address;
            if (s.push(T), 0 == (0 | t._crypto_box_open_easy(T, c, h, 0, p, v, E))) {
                var w = y(S, n);
                return g(s), w;
            }
            b(s, "incorrect key pair for the given ciphertext");
        }
        function Be(e, r, a, _) {
            var n = [];
            l(_);
            var s = d(e = x(n, e, "ciphertext")), c = e.length;
            n.push(s), r = x(n, r, "nonce");
            var o, h = 0 | t._crypto_box_noncebytes();
            r.length !== h && f(n, "invalid nonce length"), o = d(r), n.push(o), a = x(n, a, "sharedKey");
            var p, i = 0 | t._crypto_box_beforenmbytes();
            a.length !== i && f(n, "invalid sharedKey length"), p = d(a), n.push(p);
            var v = new u(c - t._crypto_box_macbytes() | 0), m = v.address;
            if (n.push(m), 0 == (0 | t._crypto_box_open_easy_afternm(m, s, c, 0, o, p))) {
                var E = y(v, _);
                return g(n), E;
            }
            b(n, "incorrect secret key for the given ciphertext");
        }
        function Ae(e, r, a) {
            var _ = [];
            l(a);
            var n = d(e = x(_, e, "message")), s = e.length;
            _.push(n), r = x(_, r, "publicKey");
            var c, o = 0 | t._crypto_box_publickeybytes();
            r.length !== o && f(_, "invalid publicKey length"), c = d(r), _.push(c);
            var h = new u(s + t._crypto_box_sealbytes() | 0), p = h.address;
            if (_.push(p), 0 == (0 | t._crypto_box_seal(p, n, s, 0, c))) {
                var i = y(h, a);
                return g(_), i;
            }
            b(_, "invalid usage");
        }
        function Ke(e, r, a, _) {
            var n = [];
            l(_), e = x(n, e, "ciphertext");
            var s, c = t._crypto_box_sealbytes(), o = e.length;
            o < c && f(n, "ciphertext is too short"), s = d(e), n.push(s), r = x(n, r, "publicKey");
            var h, p = 0 | t._crypto_box_publickeybytes();
            r.length !== p && f(n, "invalid publicKey length"), h = d(r), n.push(h), a = x(n, a, "privateKey");
            var i, v = 0 | t._crypto_box_secretkeybytes();
            a.length !== v && f(n, "invalid privateKey length"), i = d(a), n.push(i);
            var m = new u(o - t._crypto_box_sealbytes() | 0), E = m.address;
            if (n.push(E), 0 == (0 | t._crypto_box_seal_open(E, s, o, 0, h, i))) {
                var k = y(m, _);
                return g(n), k;
            }
            b(n, "incorrect key pair for the given ciphertext");
        }
        function Me(e, r) {
            var a = [];
            l(r), e = x(a, e, "seed");
            var _, n = 0 | t._crypto_box_seedbytes();
            e.length !== n && f(a, "invalid seed length"), _ = d(e), a.push(_);
            var s = new u(0 | t._crypto_box_publickeybytes()), c = s.address;
            a.push(c);
            var o = new u(0 | t._crypto_box_secretkeybytes()), h = o.address;
            if (a.push(h), 0 == (0 | t._crypto_box_seed_keypair(c, h, _))) {
                var p = {
                    publicKey: y(s, r),
                    privateKey: y(o, r),
                    keyType: "x25519"
                };
                return g(a), p;
            }
            b(a, "invalid usage");
        }
        function Ie(e, r, a) {
            var _ = [];
            l(a), e = x(_, e, "p");
            var n, s = 0 | t._crypto_core_ed25519_bytes();
            e.length !== s && f(_, "invalid p length"), n = d(e), _.push(n), r = x(_, r, "q");
            var c, o = 0 | t._crypto_core_ed25519_bytes();
            r.length !== o && f(_, "invalid q length"), c = d(r), _.push(c);
            var h = new u(0 | t._crypto_core_ed25519_bytes()), p = h.address;
            if (_.push(p), 0 == (0 | t._crypto_core_ed25519_add(p, n, c))) {
                var i = y(h, a);
                return g(_), i;
            }
            b(_, "input is an invalid element");
        }
        function Ne(e, r) {
            var a = [];
            l(r);
            var _ = d(e = x(a, e, "r"));
            e.length, a.push(_);
            var n = new u(0 | t._crypto_core_ed25519_bytes()), s = n.address;
            if (a.push(s), 0 == (0 | t._crypto_core_ed25519_from_hash(s, _))) {
                var c = y(n, r);
                return g(a), c;
            }
            b(a, "invalid usage");
        }
        function Le(e, r) {
            var a = [];
            l(r);
            var _ = d(e = x(a, e, "r"));
            e.length, a.push(_);
            var n = new u(0 | t._crypto_core_ed25519_bytes()), s = n.address;
            if (a.push(s), 0 == (0 | t._crypto_core_ed25519_from_uniform(s, _))) {
                var c = y(n, r);
                return g(a), c;
            }
            b(a, "invalid usage");
        }
        function Ue(e, r) {
            var a = [];
            l(r), e = x(a, e, "repr");
            var _, n = 0 | t._crypto_core_ed25519_bytes();
            e.length !== n && f(a, "invalid repr length"), _ = d(e), a.push(_);
            var s = 1 == (0 | t._crypto_core_ed25519_is_valid_point(_));
            return g(a), s;
        }
        function Oe(e) {
            var r = [];
            l(e);
            var a = new u(0 | t._crypto_core_ed25519_bytes()), _ = a.address;
            r.push(_), t._crypto_core_ed25519_random(_);
            var n = y(a, e);
            return g(r), n;
        }
        function Ce(e, r, a) {
            var _ = [];
            l(a), e = x(_, e, "x");
            var n, s = 0 | t._crypto_core_ed25519_scalarbytes();
            e.length !== s && f(_, "invalid x length"), n = d(e), _.push(n), r = x(_, r, "y");
            var c, o = 0 | t._crypto_core_ed25519_scalarbytes();
            r.length !== o && f(_, "invalid y length"), c = d(r), _.push(c);
            var h = new u(0 | t._crypto_core_ed25519_scalarbytes()), p = h.address;
            _.push(p), t._crypto_core_ed25519_scalar_add(p, n, c);
            var i = y(h, a);
            return g(_), i;
        }
        function Re(e, r) {
            var a = [];
            l(r), e = x(a, e, "s");
            var _, n = 0 | t._crypto_core_ed25519_scalarbytes();
            e.length !== n && f(a, "invalid s length"), _ = d(e), a.push(_);
            var s = new u(0 | t._crypto_core_ed25519_scalarbytes()), c = s.address;
            a.push(c), t._crypto_core_ed25519_scalar_complement(c, _);
            var o = y(s, r);
            return g(a), o;
        }
        function Pe(e, r) {
            var a = [];
            l(r), e = x(a, e, "s");
            var _, n = 0 | t._crypto_core_ed25519_scalarbytes();
            e.length !== n && f(a, "invalid s length"), _ = d(e), a.push(_);
            var s = new u(0 | t._crypto_core_ed25519_scalarbytes()), c = s.address;
            if (a.push(c), 0 == (0 | t._crypto_core_ed25519_scalar_invert(c, _))) {
                var o = y(s, r);
                return g(a), o;
            }
            b(a, "invalid reciprocate");
        }
        function Ge(e, r, a) {
            var _ = [];
            l(a), e = x(_, e, "x");
            var n, s = 0 | t._crypto_core_ed25519_scalarbytes();
            e.length !== s && f(_, "invalid x length"), n = d(e), _.push(n), r = x(_, r, "y");
            var c, o = 0 | t._crypto_core_ed25519_scalarbytes();
            r.length !== o && f(_, "invalid y length"), c = d(r), _.push(c);
            var h = new u(0 | t._crypto_core_ed25519_scalarbytes()), p = h.address;
            _.push(p), t._crypto_core_ed25519_scalar_mul(p, n, c);
            var i = y(h, a);
            return g(_), i;
        }
        function Xe(e, r) {
            var a = [];
            l(r), e = x(a, e, "s");
            var _, n = 0 | t._crypto_core_ed25519_scalarbytes();
            e.length !== n && f(a, "invalid s length"), _ = d(e), a.push(_);
            var s = new u(0 | t._crypto_core_ed25519_scalarbytes()), c = s.address;
            a.push(c), t._crypto_core_ed25519_scalar_negate(c, _);
            var o = y(s, r);
            return g(a), o;
        }
        function De(e) {
            var r = [];
            l(e);
            var a = new u(0 | t._crypto_core_ed25519_scalarbytes()), _ = a.address;
            r.push(_), t._crypto_core_ed25519_scalar_random(_);
            var n = y(a, e);
            return g(r), n;
        }
        function Fe(e, r) {
            var a = [];
            l(r), e = x(a, e, "sample");
            var _, n = 0 | t._crypto_core_ed25519_nonreducedscalarbytes();
            e.length !== n && f(a, "invalid sample length"), _ = d(e), a.push(_);
            var s = new u(0 | t._crypto_core_ed25519_scalarbytes()), c = s.address;
            a.push(c), t._crypto_core_ed25519_scalar_reduce(c, _);
            var o = y(s, r);
            return g(a), o;
        }
        function Ve(e, r, a) {
            var _ = [];
            l(a), e = x(_, e, "x");
            var n, s = 0 | t._crypto_core_ed25519_scalarbytes();
            e.length !== s && f(_, "invalid x length"), n = d(e), _.push(n), r = x(_, r, "y");
            var c, o = 0 | t._crypto_core_ed25519_scalarbytes();
            r.length !== o && f(_, "invalid y length"), c = d(r), _.push(c);
            var h = new u(0 | t._crypto_core_ed25519_scalarbytes()), p = h.address;
            _.push(p), t._crypto_core_ed25519_scalar_sub(p, n, c);
            var i = y(h, a);
            return g(_), i;
        }
        function He(e, r, a) {
            var _ = [];
            l(a), e = x(_, e, "p");
            var n, s = 0 | t._crypto_core_ed25519_bytes();
            e.length !== s && f(_, "invalid p length"), n = d(e), _.push(n), r = x(_, r, "q");
            var c, o = 0 | t._crypto_core_ed25519_bytes();
            r.length !== o && f(_, "invalid q length"), c = d(r), _.push(c);
            var h = new u(0 | t._crypto_core_ed25519_bytes()), p = h.address;
            if (_.push(p), 0 == (0 | t._crypto_core_ed25519_sub(p, n, c))) {
                var i = y(h, a);
                return g(_), i;
            }
            b(_, "input is an invalid element");
        }
        function qe(e, r, a, _) {
            var n = [];
            l(_), e = x(n, e, "input");
            var s, c = 0 | t._crypto_core_hchacha20_inputbytes();
            e.length !== c && f(n, "invalid input length"), s = d(e), n.push(s), r = x(n, r, "privateKey");
            var o, h = 0 | t._crypto_core_hchacha20_keybytes();
            r.length !== h && f(n, "invalid privateKey length"), o = d(r), n.push(o);
            var p = null;
            null != a && (p = d(a = x(n, a, "constant")), a.length, n.push(p));
            var i = new u(0 | t._crypto_core_hchacha20_outputbytes()), v = i.address;
            if (n.push(v), 0 == (0 | t._crypto_core_hchacha20(v, s, o, p))) {
                var m = y(i, _);
                return g(n), m;
            }
            b(n, "invalid usage");
        }
        function je(e, r, a, _) {
            var n = [];
            l(_), e = x(n, e, "input");
            var s, c = 0 | t._crypto_core_hsalsa20_inputbytes();
            e.length !== c && f(n, "invalid input length"), s = d(e), n.push(s), r = x(n, r, "privateKey");
            var o, h = 0 | t._crypto_core_hsalsa20_keybytes();
            r.length !== h && f(n, "invalid privateKey length"), o = d(r), n.push(o);
            var p = null;
            null != a && (p = d(a = x(n, a, "constant")), a.length, n.push(p));
            var i = new u(0 | t._crypto_core_hsalsa20_outputbytes()), v = i.address;
            if (n.push(v), 0 == (0 | t._crypto_core_hsalsa20(v, s, o, p))) {
                var m = y(i, _);
                return g(n), m;
            }
            b(n, "invalid usage");
        }
        function ze(e, r, a) {
            var _ = [];
            l(a), e = x(_, e, "p");
            var n, s = 0 | t._crypto_core_ristretto255_bytes();
            e.length !== s && f(_, "invalid p length"), n = d(e), _.push(n), r = x(_, r, "q");
            var c, o = 0 | t._crypto_core_ristretto255_bytes();
            r.length !== o && f(_, "invalid q length"), c = d(r), _.push(c);
            var h = new u(0 | t._crypto_core_ristretto255_bytes()), p = h.address;
            if (_.push(p), 0 == (0 | t._crypto_core_ristretto255_add(p, n, c))) {
                var i = y(h, a);
                return g(_), i;
            }
            b(_, "input is an invalid element");
        }
        function We(e, r) {
            var a = [];
            l(r);
            var _ = d(e = x(a, e, "r"));
            e.length, a.push(_);
            var n = new u(0 | t._crypto_core_ristretto255_bytes()), s = n.address;
            if (a.push(s), 0 == (0 | t._crypto_core_ristretto255_from_hash(s, _))) {
                var c = y(n, r);
                return g(a), c;
            }
            b(a, "invalid usage");
        }
        function Je(e, r) {
            var a = [];
            l(r), e = x(a, e, "repr");
            var _, n = 0 | t._crypto_core_ristretto255_bytes();
            e.length !== n && f(a, "invalid repr length"), _ = d(e), a.push(_);
            var s = 1 == (0 | t._crypto_core_ristretto255_is_valid_point(_));
            return g(a), s;
        }
        function Qe(e) {
            var r = [];
            l(e);
            var a = new u(0 | t._crypto_core_ristretto255_bytes()), _ = a.address;
            r.push(_), t._crypto_core_ristretto255_random(_);
            var n = y(a, e);
            return g(r), n;
        }
        function Ze(e, r, a) {
            var _ = [];
            l(a), e = x(_, e, "x");
            var n, s = 0 | t._crypto_core_ristretto255_scalarbytes();
            e.length !== s && f(_, "invalid x length"), n = d(e), _.push(n), r = x(_, r, "y");
            var c, o = 0 | t._crypto_core_ristretto255_scalarbytes();
            r.length !== o && f(_, "invalid y length"), c = d(r), _.push(c);
            var h = new u(0 | t._crypto_core_ristretto255_scalarbytes()), p = h.address;
            _.push(p), t._crypto_core_ristretto255_scalar_add(p, n, c);
            var i = y(h, a);
            return g(_), i;
        }
        function $e(e, r) {
            var a = [];
            l(r), e = x(a, e, "s");
            var _, n = 0 | t._crypto_core_ristretto255_scalarbytes();
            e.length !== n && f(a, "invalid s length"), _ = d(e), a.push(_);
            var s = new u(0 | t._crypto_core_ristretto255_scalarbytes()), c = s.address;
            a.push(c), t._crypto_core_ristretto255_scalar_complement(c, _);
            var o = y(s, r);
            return g(a), o;
        }
        function er(e, r) {
            var a = [];
            l(r), e = x(a, e, "s");
            var _, n = 0 | t._crypto_core_ristretto255_scalarbytes();
            e.length !== n && f(a, "invalid s length"), _ = d(e), a.push(_);
            var s = new u(0 | t._crypto_core_ristretto255_scalarbytes()), c = s.address;
            if (a.push(c), 0 == (0 | t._crypto_core_ristretto255_scalar_invert(c, _))) {
                var o = y(s, r);
                return g(a), o;
            }
            b(a, "invalid reciprocate");
        }
        function rr(e, r, a) {
            var _ = [];
            l(a), e = x(_, e, "x");
            var n, s = 0 | t._crypto_core_ristretto255_scalarbytes();
            e.length !== s && f(_, "invalid x length"), n = d(e), _.push(n), r = x(_, r, "y");
            var c, o = 0 | t._crypto_core_ristretto255_scalarbytes();
            r.length !== o && f(_, "invalid y length"), c = d(r), _.push(c);
            var h = new u(0 | t._crypto_core_ristretto255_scalarbytes()), p = h.address;
            _.push(p), t._crypto_core_ristretto255_scalar_mul(p, n, c);
            var i = y(h, a);
            return g(_), i;
        }
        function tr(e, r) {
            var a = [];
            l(r), e = x(a, e, "s");
            var _, n = 0 | t._crypto_core_ristretto255_scalarbytes();
            e.length !== n && f(a, "invalid s length"), _ = d(e), a.push(_);
            var s = new u(0 | t._crypto_core_ristretto255_scalarbytes()), c = s.address;
            a.push(c), t._crypto_core_ristretto255_scalar_negate(c, _);
            var o = y(s, r);
            return g(a), o;
        }
        function ar(e) {
            var r = [];
            l(e);
            var a = new u(0 | t._crypto_core_ristretto255_scalarbytes()), _ = a.address;
            r.push(_), t._crypto_core_ristretto255_scalar_random(_);
            var n = y(a, e);
            return g(r), n;
        }
        function _r(e, r) {
            var a = [];
            l(r), e = x(a, e, "sample");
            var _, n = 0 | t._crypto_core_ristretto255_nonreducedscalarbytes();
            e.length !== n && f(a, "invalid sample length"), _ = d(e), a.push(_);
            var s = new u(0 | t._crypto_core_ristretto255_scalarbytes()), c = s.address;
            a.push(c), t._crypto_core_ristretto255_scalar_reduce(c, _);
            var o = y(s, r);
            return g(a), o;
        }
        function nr(e, r, a) {
            var _ = [];
            l(a), e = x(_, e, "x");
            var n, s = 0 | t._crypto_core_ristretto255_scalarbytes();
            e.length !== s && f(_, "invalid x length"), n = d(e), _.push(n), r = x(_, r, "y");
            var c, o = 0 | t._crypto_core_ristretto255_scalarbytes();
            r.length !== o && f(_, "invalid y length"), c = d(r), _.push(c);
            var h = new u(0 | t._crypto_core_ristretto255_scalarbytes()), p = h.address;
            _.push(p), t._crypto_core_ristretto255_scalar_sub(p, n, c);
            var i = y(h, a);
            return g(_), i;
        }
        function sr(e, r, a) {
            var _ = [];
            l(a), e = x(_, e, "p");
            var n, s = 0 | t._crypto_core_ristretto255_bytes();
            e.length !== s && f(_, "invalid p length"), n = d(e), _.push(n), r = x(_, r, "q");
            var c, o = 0 | t._crypto_core_ristretto255_bytes();
            r.length !== o && f(_, "invalid q length"), c = d(r), _.push(c);
            var h = new u(0 | t._crypto_core_ristretto255_bytes()), p = h.address;
            if (_.push(p), 0 == (0 | t._crypto_core_ristretto255_sub(p, n, c))) {
                var i = y(h, a);
                return g(_), i;
            }
            b(_, "input is an invalid element");
        }
        function cr(e, r, a, _) {
            var n = [];
            l(_), m(n, e, "hash_length"), ("number" != typeof e || (0 | e) !== e || e < 0) && f(n, "hash_length must be an unsigned integer");
            var s = d(r = x(n, r, "message")), c = r.length;
            n.push(s);
            var o = null, h = 0;
            null != a && (o = d(a = x(n, a, "key")), h = a.length, n.push(o));
            var p = new u(e |= 0), i = p.address;
            if (n.push(i), 0 == (0 | t._crypto_generichash(i, e, s, c, 0, o, h))) {
                var v = y(p, _);
                return g(n), v;
            }
            b(n, "invalid usage");
        }
        function or(e, r, a, _, n) {
            var s = [];
            l(n), m(s, e, "subkey_len"), ("number" != typeof e || (0 | e) !== e || e < 0) && f(s, "subkey_len must be an unsigned integer");
            var c = null, o = 0;
            null != r && (c = d(r = x(s, r, "key")), o = r.length, s.push(c));
            var h = null, p = 0;
            null != a && (a = x(s, a, "id"), p = 0 | t._crypto_generichash_blake2b_saltbytes(), a.length !== p && f(s, "invalid id length"), h = d(a), s.push(h));
            var i = null, v = 0;
            null != _ && (_ = x(s, _, "ctx"), v = 0 | t._crypto_generichash_blake2b_personalbytes(), _.length !== v && f(s, "invalid ctx length"), i = d(_), s.push(i));
            var E = new u(0 | e), k = E.address;
            if (s.push(k), 0 == (0 | t._crypto_generichash_blake2b_salt_personal(k, e, null, 0, 0, c, o, h, i))) {
                var S = y(E, n);
                return g(s), S;
            }
            b(s, "invalid usage");
        }
        function hr(e, r, a) {
            var _ = [];
            l(a), m(_, e, "state_address"), m(_, r, "hash_length"), ("number" != typeof r || (0 | r) !== r || r < 0) && f(_, "hash_length must be an unsigned integer");
            var n = new u(r |= 0), s = n.address;
            if (_.push(s), 0 == (0 | t._crypto_generichash_final(e, s, r))) {
                var c = (t._free(e), y(n, a));
                return g(_), c;
            }
            b(_, "invalid usage");
        }
        function pr(e, r, a) {
            var _ = [];
            l(a);
            var n = null, s = 0;
            null != e && (n = d(e = x(_, e, "key")), s = e.length, _.push(n)), m(_, r, "hash_length"), ("number" != typeof r || (0 | r) !== r || r < 0) && f(_, "hash_length must be an unsigned integer");
            var c = new u(357).address;
            if (0 == (0 | t._crypto_generichash_init(c, n, s, r))) {
                var o = c;
                return g(_), o;
            }
            b(_, "invalid usage");
        }
        function yr(e) {
            var r = [];
            l(e);
            var a = new u(0 | t._crypto_generichash_keybytes()), _ = a.address;
            r.push(_), t._crypto_generichash_keygen(_);
            var n = y(a, e);
            return g(r), n;
        }
        function ir(e, r, a) {
            var _ = [];
            l(a), m(_, e, "state_address");
            var n = d(r = x(_, r, "message_chunk")), s = r.length;
            _.push(n), 0 != (0 | t._crypto_generichash_update(e, n, s)) && b(_, "invalid usage"), g(_);
        }
        function lr(e, r) {
            var a = [];
            l(r);
            var _ = d(e = x(a, e, "message")), n = e.length;
            a.push(_);
            var s = new u(0 | t._crypto_hash_bytes()), c = s.address;
            if (a.push(c), 0 == (0 | t._crypto_hash(c, _, n, 0))) {
                var o = y(s, r);
                return g(a), o;
            }
            b(a, "invalid usage");
        }
        function ur(e, r) {
            var a = [];
            l(r);
            var _ = d(e = x(a, e, "message")), n = e.length;
            a.push(_);
            var s = new u(0 | t._crypto_hash_sha256_bytes()), c = s.address;
            if (a.push(c), 0 == (0 | t._crypto_hash_sha256(c, _, n, 0))) {
                var o = y(s, r);
                return g(a), o;
            }
            b(a, "invalid usage");
        }
        function dr(e, r) {
            var a = [];
            l(r), m(a, e, "state_address");
            var _ = new u(0 | t._crypto_hash_sha256_bytes()), n = _.address;
            if (a.push(n), 0 == (0 | t._crypto_hash_sha256_final(e, n))) {
                var s = (t._free(e), y(_, r));
                return g(a), s;
            }
            b(a, "invalid usage");
        }
        function vr(e) {
            var r = [];
            l(e);
            var a = new u(104).address;
            if (0 == (0 | t._crypto_hash_sha256_init(a))) {
                var _ = a;
                return g(r), _;
            }
            b(r, "invalid usage");
        }
        function gr(e, r, a) {
            var _ = [];
            l(a), m(_, e, "state_address");
            var n = d(r = x(_, r, "message_chunk")), s = r.length;
            _.push(n), 0 != (0 | t._crypto_hash_sha256_update(e, n, s)) && b(_, "invalid usage"), g(_);
        }
        function br(e, r) {
            var a = [];
            l(r);
            var _ = d(e = x(a, e, "message")), n = e.length;
            a.push(_);
            var s = new u(0 | t._crypto_hash_sha512_bytes()), c = s.address;
            if (a.push(c), 0 == (0 | t._crypto_hash_sha512(c, _, n, 0))) {
                var o = y(s, r);
                return g(a), o;
            }
            b(a, "invalid usage");
        }
        function fr(e, r) {
            var a = [];
            l(r), m(a, e, "state_address");
            var _ = new u(0 | t._crypto_hash_sha512_bytes()), n = _.address;
            if (a.push(n), 0 == (0 | t._crypto_hash_sha512_final(e, n))) {
                var s = (t._free(e), y(_, r));
                return g(a), s;
            }
            b(a, "invalid usage");
        }
        function mr(e) {
            var r = [];
            l(e);
            var a = new u(208).address;
            if (0 == (0 | t._crypto_hash_sha512_init(a))) {
                var _ = a;
                return g(r), _;
            }
            b(r, "invalid usage");
        }
        function xr(e, r, a) {
            var _ = [];
            l(a), m(_, e, "state_address");
            var n = d(r = x(_, r, "message_chunk")), s = r.length;
            _.push(n), 0 != (0 | t._crypto_hash_sha512_update(e, n, s)) && b(_, "invalid usage"), g(_);
        }
        function Er(e, r, a, _, s) {
            var c = [];
            l(s), m(c, e, "subkey_len"), ("number" != typeof e || (0 | e) !== e || e < 0) && f(c, "subkey_len must be an unsigned integer"), m(c, r, "subkey_id"), ("number" != typeof r || (0 | r) !== r || r < 0) && f(c, "subkey_id must be an unsigned integer"), "string" != typeof a && f(c, "ctx must be a string"), a = n(a + "\x00"), null != h && a.length - 1 !== h && f(c, "invalid ctx length");
            var o = d(a), h = a.length - 1;
            c.push(o), _ = x(c, _, "key");
            var p, i = 0 | t._crypto_kdf_keybytes();
            _.length !== i && f(c, "invalid key length"), p = d(_), c.push(p);
            var v = new u(0 | e), b = v.address;
            c.push(b), t._crypto_kdf_derive_from_key(b, e, r, r >>> 24 >>> 8, o, p);
            var E = y(v, s);
            return g(c), E;
        }
        function kr(e) {
            var r = [];
            l(e);
            var a = new u(0 | t._crypto_kdf_keybytes()), _ = a.address;
            r.push(_), t._crypto_kdf_keygen(_);
            var n = y(a, e);
            return g(r), n;
        }
        function Sr(e, r, a, _) {
            var n = [];
            l(_), e = x(n, e, "clientPublicKey");
            var s, c = 0 | t._crypto_kx_publickeybytes();
            e.length !== c && f(n, "invalid clientPublicKey length"), s = d(e), n.push(s), r = x(n, r, "clientSecretKey");
            var o, h = 0 | t._crypto_kx_secretkeybytes();
            r.length !== h && f(n, "invalid clientSecretKey length"), o = d(r), n.push(o), a = x(n, a, "serverPublicKey");
            var p, i = 0 | t._crypto_kx_publickeybytes();
            a.length !== i && f(n, "invalid serverPublicKey length"), p = d(a), n.push(p);
            var v = new u(0 | t._crypto_kx_sessionkeybytes()), m = v.address;
            n.push(m);
            var E = new u(0 | t._crypto_kx_sessionkeybytes()), k = E.address;
            if (n.push(k), 0 == (0 | t._crypto_kx_client_session_keys(m, k, s, o, p))) {
                var S = y({
                    sharedRx: v,
                    sharedTx: E
                }, _);
                return g(n), S;
            }
            b(n, "invalid usage");
        }
        function Tr(e) {
            var r = [];
            l(e);
            var a = new u(0 | t._crypto_kx_publickeybytes()), _ = a.address;
            r.push(_);
            var n = new u(0 | t._crypto_kx_secretkeybytes()), s = n.address;
            if (r.push(s), 0 == (0 | t._crypto_kx_keypair(_, s))) {
                var c = {
                    publicKey: y(a, e),
                    privateKey: y(n, e),
                    keyType: "x25519"
                };
                return g(r), c;
            }
            b(r, "internal error");
        }
        function wr(e, r) {
            var a = [];
            l(r), e = x(a, e, "seed");
            var _, n = 0 | t._crypto_kx_seedbytes();
            e.length !== n && f(a, "invalid seed length"), _ = d(e), a.push(_);
            var s = new u(0 | t._crypto_kx_publickeybytes()), c = s.address;
            a.push(c);
            var o = new u(0 | t._crypto_kx_secretkeybytes()), h = o.address;
            if (a.push(h), 0 == (0 | t._crypto_kx_seed_keypair(c, h, _))) {
                var p = {
                    publicKey: y(s, r),
                    privateKey: y(o, r),
                    keyType: "x25519"
                };
                return g(a), p;
            }
            b(a, "internal error");
        }
        function Yr(e, r, a, _) {
            var n = [];
            l(_), e = x(n, e, "serverPublicKey");
            var s, c = 0 | t._crypto_kx_publickeybytes();
            e.length !== c && f(n, "invalid serverPublicKey length"), s = d(e), n.push(s), r = x(n, r, "serverSecretKey");
            var o, h = 0 | t._crypto_kx_secretkeybytes();
            r.length !== h && f(n, "invalid serverSecretKey length"), o = d(r), n.push(o), a = x(n, a, "clientPublicKey");
            var p, i = 0 | t._crypto_kx_publickeybytes();
            a.length !== i && f(n, "invalid clientPublicKey length"), p = d(a), n.push(p);
            var v = new u(0 | t._crypto_kx_sessionkeybytes()), m = v.address;
            n.push(m);
            var E = new u(0 | t._crypto_kx_sessionkeybytes()), k = E.address;
            if (n.push(k), 0 == (0 | t._crypto_kx_server_session_keys(m, k, s, o, p))) {
                var S = y({
                    sharedRx: v,
                    sharedTx: E
                }, _);
                return g(n), S;
            }
            b(n, "invalid usage");
        }
        function Br(e, r, a) {
            var _ = [];
            l(a);
            var n = d(e = x(_, e, "message")), s = e.length;
            _.push(n), r = x(_, r, "key");
            var c, o = 0 | t._crypto_onetimeauth_keybytes();
            r.length !== o && f(_, "invalid key length"), c = d(r), _.push(c);
            var h = new u(0 | t._crypto_onetimeauth_bytes()), p = h.address;
            if (_.push(p), 0 == (0 | t._crypto_onetimeauth(p, n, s, 0, c))) {
                var i = y(h, a);
                return g(_), i;
            }
            b(_, "invalid usage");
        }
        function Ar(e, r) {
            var a = [];
            l(r), m(a, e, "state_address");
            var _ = new u(0 | t._crypto_onetimeauth_bytes()), n = _.address;
            if (a.push(n), 0 == (0 | t._crypto_onetimeauth_final(e, n))) {
                var s = (t._free(e), y(_, r));
                return g(a), s;
            }
            b(a, "invalid usage");
        }
        function Kr(e, r) {
            var a = [];
            l(r);
            var _ = null;
            null != e && (_ = d(e = x(a, e, "key")), e.length, a.push(_));
            var n = new u(144).address;
            if (0 == (0 | t._crypto_onetimeauth_init(n, _))) {
                var s = n;
                return g(a), s;
            }
            b(a, "invalid usage");
        }
        function Mr(e) {
            var r = [];
            l(e);
            var a = new u(0 | t._crypto_onetimeauth_keybytes()), _ = a.address;
            r.push(_), t._crypto_onetimeauth_keygen(_);
            var n = y(a, e);
            return g(r), n;
        }
        function Ir(e, r, a) {
            var _ = [];
            l(a), m(_, e, "state_address");
            var n = d(r = x(_, r, "message_chunk")), s = r.length;
            _.push(n), 0 != (0 | t._crypto_onetimeauth_update(e, n, s)) && b(_, "invalid usage"), g(_);
        }
        function Nr(e, r, a) {
            var _ = [];
            e = x(_, e, "hash");
            var n, s = 0 | t._crypto_onetimeauth_bytes();
            e.length !== s && f(_, "invalid hash length"), n = d(e), _.push(n);
            var c = d(r = x(_, r, "message")), o = r.length;
            _.push(c), a = x(_, a, "key");
            var h, p = 0 | t._crypto_onetimeauth_keybytes();
            a.length !== p && f(_, "invalid key length"), h = d(a), _.push(h);
            var y = 0 == (0 | t._crypto_onetimeauth_verify(n, c, o, 0, h));
            return g(_), y;
        }
        function Lr(e, r, a, _, n, s, c) {
            var o = [];
            l(c), m(o, e, "keyLength"), ("number" != typeof e || (0 | e) !== e || e < 0) && f(o, "keyLength must be an unsigned integer");
            var h = d(r = x(o, r, "password")), p = r.length;
            o.push(h), a = x(o, a, "salt");
            var i, v = 0 | t._crypto_pwhash_saltbytes();
            a.length !== v && f(o, "invalid salt length"), i = d(a), o.push(i), m(o, _, "opsLimit"), ("number" != typeof _ || (0 | _) !== _ || _ < 0) && f(o, "opsLimit must be an unsigned integer"), m(o, n, "memLimit"), ("number" != typeof n || (0 | n) !== n || n < 0) && f(o, "memLimit must be an unsigned integer"), m(o, s, "algorithm"), ("number" != typeof s || (0 | s) !== s || s < 0) && f(o, "algorithm must be an unsigned integer");
            var E = new u(0 | e), k = E.address;
            if (o.push(k), 0 == (0 | t._crypto_pwhash(k, e, 0, h, p, 0, i, _, 0, n, s))) {
                var S = y(E, c);
                return g(o), S;
            }
            b(o, "invalid usage");
        }
        function Ur(e, r, a, _, n, s) {
            var c = [];
            l(s), m(c, e, "keyLength"), ("number" != typeof e || (0 | e) !== e || e < 0) && f(c, "keyLength must be an unsigned integer");
            var o = d(r = x(c, r, "password")), h = r.length;
            c.push(o), a = x(c, a, "salt");
            var p, i = 0 | t._crypto_pwhash_scryptsalsa208sha256_saltbytes();
            a.length !== i && f(c, "invalid salt length"), p = d(a), c.push(p), m(c, _, "opsLimit"), ("number" != typeof _ || (0 | _) !== _ || _ < 0) && f(c, "opsLimit must be an unsigned integer"), m(c, n, "memLimit"), ("number" != typeof n || (0 | n) !== n || n < 0) && f(c, "memLimit must be an unsigned integer");
            var v = new u(0 | e), E = v.address;
            if (c.push(E), 0 == (0 | t._crypto_pwhash_scryptsalsa208sha256(E, e, 0, o, h, 0, p, _, 0, n))) {
                var k = y(v, s);
                return g(c), k;
            }
            b(c, "invalid usage");
        }
        function Or(e, r, a, _, n, s, c) {
            var o = [];
            l(c);
            var h = d(e = x(o, e, "password")), p = e.length;
            o.push(h);
            var i = d(r = x(o, r, "salt")), v = r.length;
            o.push(i), m(o, a, "opsLimit"), ("number" != typeof a || (0 | a) !== a || a < 0) && f(o, "opsLimit must be an unsigned integer"), m(o, _, "r"), ("number" != typeof _ || (0 | _) !== _ || _ < 0) && f(o, "r must be an unsigned integer"), m(o, n, "p"), ("number" != typeof n || (0 | n) !== n || n < 0) && f(o, "p must be an unsigned integer"), m(o, s, "keyLength"), ("number" != typeof s || (0 | s) !== s || s < 0) && f(o, "keyLength must be an unsigned integer");
            var E = new u(0 | s), k = E.address;
            if (o.push(k), 0 == (0 | t._crypto_pwhash_scryptsalsa208sha256_ll(h, p, i, v, a, 0, _, n, k, s))) {
                var S = y(E, c);
                return g(o), S;
            }
            b(o, "invalid usage");
        }
        function Cr(e, r, a, _) {
            var n = [];
            l(_);
            var s = d(e = x(n, e, "password")), c = e.length;
            n.push(s), m(n, r, "opsLimit"), ("number" != typeof r || (0 | r) !== r || r < 0) && f(n, "opsLimit must be an unsigned integer"), m(n, a, "memLimit"), ("number" != typeof a || (0 | a) !== a || a < 0) && f(n, "memLimit must be an unsigned integer");
            var o = new u(0 | t._crypto_pwhash_scryptsalsa208sha256_strbytes()).address;
            if (n.push(o), 0 == (0 | t._crypto_pwhash_scryptsalsa208sha256_str(o, s, c, 0, r, 0, a))) {
                var h = t.UTF8ToString(o);
                return g(n), h;
            }
            b(n, "invalid usage");
        }
        function Rr(e, r, a) {
            var _ = [];
            l(a), "string" != typeof e && f(_, "hashed_password must be a string"), e = n(e + "\x00"), null != c && e.length - 1 !== c && f(_, "invalid hashed_password length");
            var s = d(e), c = e.length - 1;
            _.push(s);
            var o = d(r = x(_, r, "password")), h = r.length;
            _.push(o);
            var p = 0 == (0 | t._crypto_pwhash_scryptsalsa208sha256_str_verify(s, o, h, 0));
            return g(_), p;
        }
        function Pr(e, r, a, _) {
            var n = [];
            l(_);
            var s = d(e = x(n, e, "password")), c = e.length;
            n.push(s), m(n, r, "opsLimit"), ("number" != typeof r || (0 | r) !== r || r < 0) && f(n, "opsLimit must be an unsigned integer"), m(n, a, "memLimit"), ("number" != typeof a || (0 | a) !== a || a < 0) && f(n, "memLimit must be an unsigned integer");
            var o = new u(0 | t._crypto_pwhash_strbytes()).address;
            if (n.push(o), 0 == (0 | t._crypto_pwhash_str(o, s, c, 0, r, 0, a))) {
                var h = t.UTF8ToString(o);
                return g(n), h;
            }
            b(n, "invalid usage");
        }
        function Gr(e, r, a, _) {
            var s = [];
            l(_), "string" != typeof e && f(s, "hashed_password must be a string"), e = n(e + "\x00"), null != o && e.length - 1 !== o && f(s, "invalid hashed_password length");
            var c = d(e), o = e.length - 1;
            s.push(c), m(s, r, "opsLimit"), ("number" != typeof r || (0 | r) !== r || r < 0) && f(s, "opsLimit must be an unsigned integer"), m(s, a, "memLimit"), ("number" != typeof a || (0 | a) !== a || a < 0) && f(s, "memLimit must be an unsigned integer");
            var h = 0 != (0 | t._crypto_pwhash_str_needs_rehash(c, r, 0, a));
            return g(s), h;
        }
        function Xr(e, r, a) {
            var _ = [];
            l(a), "string" != typeof e && f(_, "hashed_password must be a string"), e = n(e + "\x00"), null != c && e.length - 1 !== c && f(_, "invalid hashed_password length");
            var s = d(e), c = e.length - 1;
            _.push(s);
            var o = d(r = x(_, r, "password")), h = r.length;
            _.push(o);
            var p = 0 == (0 | t._crypto_pwhash_str_verify(s, o, h, 0));
            return g(_), p;
        }
        function Dr(e, r, a) {
            var _ = [];
            l(a), e = x(_, e, "privateKey");
            var n, s = 0 | t._crypto_scalarmult_scalarbytes();
            e.length !== s && f(_, "invalid privateKey length"), n = d(e), _.push(n), r = x(_, r, "publicKey");
            var c, o = 0 | t._crypto_scalarmult_bytes();
            r.length !== o && f(_, "invalid publicKey length"), c = d(r), _.push(c);
            var h = new u(0 | t._crypto_scalarmult_bytes()), p = h.address;
            if (_.push(p), 0 == (0 | t._crypto_scalarmult(p, n, c))) {
                var i = y(h, a);
                return g(_), i;
            }
            b(_, "weak public key");
        }
        function Fr(e, r) {
            var a = [];
            l(r), e = x(a, e, "privateKey");
            var _, n = 0 | t._crypto_scalarmult_scalarbytes();
            e.length !== n && f(a, "invalid privateKey length"), _ = d(e), a.push(_);
            var s = new u(0 | t._crypto_scalarmult_bytes()), c = s.address;
            if (a.push(c), 0 == (0 | t._crypto_scalarmult_base(c, _))) {
                var o = y(s, r);
                return g(a), o;
            }
            b(a, "unknown error");
        }
        function Vr(e, r, a) {
            var _ = [];
            l(a), e = x(_, e, "n");
            var n, s = 0 | t._crypto_scalarmult_ed25519_scalarbytes();
            e.length !== s && f(_, "invalid n length"), n = d(e), _.push(n), r = x(_, r, "p");
            var c, o = 0 | t._crypto_scalarmult_ed25519_bytes();
            r.length !== o && f(_, "invalid p length"), c = d(r), _.push(c);
            var h = new u(0 | t._crypto_scalarmult_ed25519_bytes()), p = h.address;
            if (_.push(p), 0 == (0 | t._crypto_scalarmult_ed25519(p, n, c))) {
                var i = y(h, a);
                return g(_), i;
            }
            b(_, "invalid point or scalar is 0");
        }
        function Hr(e, r) {
            var a = [];
            l(r), e = x(a, e, "scalar");
            var _, n = 0 | t._crypto_scalarmult_ed25519_scalarbytes();
            e.length !== n && f(a, "invalid scalar length"), _ = d(e), a.push(_);
            var s = new u(0 | t._crypto_scalarmult_ed25519_bytes()), c = s.address;
            if (a.push(c), 0 == (0 | t._crypto_scalarmult_ed25519_base(c, _))) {
                var o = y(s, r);
                return g(a), o;
            }
            b(a, "scalar is 0");
        }
        function qr(e, r) {
            var a = [];
            l(r), e = x(a, e, "scalar");
            var _, n = 0 | t._crypto_scalarmult_ed25519_scalarbytes();
            e.length !== n && f(a, "invalid scalar length"), _ = d(e), a.push(_);
            var s = new u(0 | t._crypto_scalarmult_ed25519_bytes()), c = s.address;
            if (a.push(c), 0 == (0 | t._crypto_scalarmult_ed25519_base_noclamp(c, _))) {
                var o = y(s, r);
                return g(a), o;
            }
            b(a, "scalar is 0");
        }
        function jr(e, r, a) {
            var _ = [];
            l(a), e = x(_, e, "n");
            var n, s = 0 | t._crypto_scalarmult_ed25519_scalarbytes();
            e.length !== s && f(_, "invalid n length"), n = d(e), _.push(n), r = x(_, r, "p");
            var c, o = 0 | t._crypto_scalarmult_ed25519_bytes();
            r.length !== o && f(_, "invalid p length"), c = d(r), _.push(c);
            var h = new u(0 | t._crypto_scalarmult_ed25519_bytes()), p = h.address;
            if (_.push(p), 0 == (0 | t._crypto_scalarmult_ed25519_noclamp(p, n, c))) {
                var i = y(h, a);
                return g(_), i;
            }
            b(_, "invalid point or scalar is 0");
        }
        function zr(e, r, a) {
            var _ = [];
            l(a), e = x(_, e, "scalar");
            var n, s = 0 | t._crypto_scalarmult_ristretto255_scalarbytes();
            e.length !== s && f(_, "invalid scalar length"), n = d(e), _.push(n), r = x(_, r, "element");
            var c, o = 0 | t._crypto_scalarmult_ristretto255_bytes();
            r.length !== o && f(_, "invalid element length"), c = d(r), _.push(c);
            var h = new u(0 | t._crypto_scalarmult_ristretto255_bytes()), p = h.address;
            if (_.push(p), 0 == (0 | t._crypto_scalarmult_ristretto255(p, n, c))) {
                var i = y(h, a);
                return g(_), i;
            }
            b(_, "result is identity element");
        }
        function Wr(e, r) {
            var a = [];
            l(r), e = x(a, e, "scalar");
            var _, n = 0 | t._crypto_core_ristretto255_scalarbytes();
            e.length !== n && f(a, "invalid scalar length"), _ = d(e), a.push(_);
            var s = new u(0 | t._crypto_core_ristretto255_bytes()), c = s.address;
            if (a.push(c), 0 == (0 | t._crypto_scalarmult_ristretto255_base(c, _))) {
                var o = y(s, r);
                return g(a), o;
            }
            b(a, "scalar is 0");
        }
        function Jr(e, r, a, _) {
            var n = [];
            l(_);
            var s = d(e = x(n, e, "message")), c = e.length;
            n.push(s), r = x(n, r, "nonce");
            var o, h = 0 | t._crypto_secretbox_noncebytes();
            r.length !== h && f(n, "invalid nonce length"), o = d(r), n.push(o), a = x(n, a, "key");
            var p, i = 0 | t._crypto_secretbox_keybytes();
            a.length !== i && f(n, "invalid key length"), p = d(a), n.push(p);
            var v = new u(0 | c), m = v.address;
            n.push(m);
            var E = new u(0 | t._crypto_secretbox_macbytes()), k = E.address;
            if (n.push(k), 0 == (0 | t._crypto_secretbox_detached(m, k, s, c, 0, o, p))) {
                var S = y({
                    mac: E,
                    cipher: v
                }, _);
                return g(n), S;
            }
            b(n, "invalid usage");
        }
        function Qr(e, r, a, _) {
            var n = [];
            l(_);
            var s = d(e = x(n, e, "message")), c = e.length;
            n.push(s), r = x(n, r, "nonce");
            var o, h = 0 | t._crypto_secretbox_noncebytes();
            r.length !== h && f(n, "invalid nonce length"), o = d(r), n.push(o), a = x(n, a, "key");
            var p, i = 0 | t._crypto_secretbox_keybytes();
            a.length !== i && f(n, "invalid key length"), p = d(a), n.push(p);
            var v = new u(c + t._crypto_secretbox_macbytes() | 0), m = v.address;
            if (n.push(m), 0 == (0 | t._crypto_secretbox_easy(m, s, c, 0, o, p))) {
                var E = y(v, _);
                return g(n), E;
            }
            b(n, "invalid usage");
        }
        function Zr(e) {
            var r = [];
            l(e);
            var a = new u(0 | t._crypto_secretbox_keybytes()), _ = a.address;
            r.push(_), t._crypto_secretbox_keygen(_);
            var n = y(a, e);
            return g(r), n;
        }
        function $r(e, r, a, _, n) {
            var s = [];
            l(n);
            var c = d(e = x(s, e, "ciphertext")), o = e.length;
            s.push(c), r = x(s, r, "mac");
            var h, p = 0 | t._crypto_secretbox_macbytes();
            r.length !== p && f(s, "invalid mac length"), h = d(r), s.push(h), a = x(s, a, "nonce");
            var i, v = 0 | t._crypto_secretbox_noncebytes();
            a.length !== v && f(s, "invalid nonce length"), i = d(a), s.push(i), _ = x(s, _, "key");
            var m, E = 0 | t._crypto_secretbox_keybytes();
            _.length !== E && f(s, "invalid key length"), m = d(_), s.push(m);
            var k = new u(0 | o), S = k.address;
            if (s.push(S), 0 == (0 | t._crypto_secretbox_open_detached(S, c, h, o, 0, i, m))) {
                var T = y(k, n);
                return g(s), T;
            }
            b(s, "wrong secret key for the given ciphertext");
        }
        function et(e, r, a, _) {
            var n = [];
            l(_), e = x(n, e, "ciphertext");
            var s, c = t._crypto_secretbox_macbytes(), o = e.length;
            o < c && f(n, "ciphertext is too short"), s = d(e), n.push(s), r = x(n, r, "nonce");
            var h, p = 0 | t._crypto_secretbox_noncebytes();
            r.length !== p && f(n, "invalid nonce length"), h = d(r), n.push(h), a = x(n, a, "key");
            var i, v = 0 | t._crypto_secretbox_keybytes();
            a.length !== v && f(n, "invalid key length"), i = d(a), n.push(i);
            var m = new u(o - t._crypto_secretbox_macbytes() | 0), E = m.address;
            if (n.push(E), 0 == (0 | t._crypto_secretbox_open_easy(E, s, o, 0, h, i))) {
                var k = y(m, _);
                return g(n), k;
            }
            b(n, "wrong secret key for the given ciphertext");
        }
        function rt(e, r, a) {
            var _ = [];
            l(a), e = x(_, e, "header");
            var n, s = 0 | t._crypto_secretstream_xchacha20poly1305_headerbytes();
            e.length !== s && f(_, "invalid header length"), n = d(e), _.push(n), r = x(_, r, "key");
            var c, o = 0 | t._crypto_secretstream_xchacha20poly1305_keybytes();
            r.length !== o && f(_, "invalid key length"), c = d(r), _.push(c);
            var h = new u(52).address;
            if (0 == (0 | t._crypto_secretstream_xchacha20poly1305_init_pull(h, n, c))) {
                var p = h;
                return g(_), p;
            }
            b(_, "invalid usage");
        }
        function tt(e, r) {
            var a = [];
            l(r), e = x(a, e, "key");
            var _, n = 0 | t._crypto_secretstream_xchacha20poly1305_keybytes();
            e.length !== n && f(a, "invalid key length"), _ = d(e), a.push(_);
            var s = new u(52).address, c = new u(0 | t._crypto_secretstream_xchacha20poly1305_headerbytes()), o = c.address;
            if (a.push(o), 0 == (0 | t._crypto_secretstream_xchacha20poly1305_init_push(s, o, _))) {
                var h = {
                    state: s,
                    header: y(c, r)
                };
                return g(a), h;
            }
            b(a, "invalid usage");
        }
        function at(e) {
            var r = [];
            l(e);
            var a = new u(0 | t._crypto_secretstream_xchacha20poly1305_keybytes()), _ = a.address;
            r.push(_), t._crypto_secretstream_xchacha20poly1305_keygen(_);
            var n = y(a, e);
            return g(r), n;
        }
        function _t(e, r, a, _) {
            var n = [];
            l(_), m(n, e, "state_address"), r = x(n, r, "cipher");
            var s, c = t._crypto_secretstream_xchacha20poly1305_abytes(), o = r.length;
            o < c && f(n, "cipher is too short"), s = d(r), n.push(s);
            var h = null, p = 0;
            null != a && (h = d(a = x(n, a, "ad")), p = a.length, n.push(h));
            var i = new u(o - t._crypto_secretstream_xchacha20poly1305_abytes() | 0), b = i.address;
            n.push(b);
            var E, k = (E = v(1), n.push(E), (k = 0 === t._crypto_secretstream_xchacha20poly1305_pull(e, b, 0, E, s, o, 0, h, p) && {
                tag: t.HEAPU8[E],
                message: i
            }) && {
                message: y(k.message, _),
                tag: k.tag
            });
            return g(n), k;
        }
        function nt(e, r, a, _, n) {
            var s = [];
            l(n), m(s, e, "state_address");
            var c = d(r = x(s, r, "message_chunk")), o = r.length;
            s.push(c);
            var h = null, p = 0;
            null != a && (h = d(a = x(s, a, "ad")), p = a.length, s.push(h)), m(s, _, "tag"), ("number" != typeof _ || (0 | _) !== _ || _ < 0) && f(s, "tag must be an unsigned integer");
            var i = new u(o + t._crypto_secretstream_xchacha20poly1305_abytes() | 0), v = i.address;
            if (s.push(v), 0 == (0 | t._crypto_secretstream_xchacha20poly1305_push(e, v, 0, c, o, 0, h, p, 0, _))) {
                var E = y(i, n);
                return g(s), E;
            }
            b(s, "invalid usage");
        }
        function st(e, r) {
            var a = [];
            return l(r), m(a, e, "state_address"), t._crypto_secretstream_xchacha20poly1305_rekey(e), g(a), !0;
        }
        function ct(e, r, a) {
            var _ = [];
            l(a);
            var n = d(e = x(_, e, "message")), s = e.length;
            _.push(n), r = x(_, r, "key");
            var c, o = 0 | t._crypto_shorthash_keybytes();
            r.length !== o && f(_, "invalid key length"), c = d(r), _.push(c);
            var h = new u(0 | t._crypto_shorthash_bytes()), p = h.address;
            if (_.push(p), 0 == (0 | t._crypto_shorthash(p, n, s, 0, c))) {
                var i = y(h, a);
                return g(_), i;
            }
            b(_, "invalid usage");
        }
        function ot(e) {
            var r = [];
            l(e);
            var a = new u(0 | t._crypto_shorthash_keybytes()), _ = a.address;
            r.push(_), t._crypto_shorthash_keygen(_);
            var n = y(a, e);
            return g(r), n;
        }
        function ht(e, r, a) {
            var _ = [];
            l(a);
            var n = d(e = x(_, e, "message")), s = e.length;
            _.push(n), r = x(_, r, "key");
            var c, o = 0 | t._crypto_shorthash_siphashx24_keybytes();
            r.length !== o && f(_, "invalid key length"), c = d(r), _.push(c);
            var h = new u(0 | t._crypto_shorthash_siphashx24_bytes()), p = h.address;
            if (_.push(p), 0 == (0 | t._crypto_shorthash_siphashx24(p, n, s, 0, c))) {
                var i = y(h, a);
                return g(_), i;
            }
            b(_, "invalid usage");
        }
        function pt(e, r, a) {
            var _ = [];
            l(a);
            var n = d(e = x(_, e, "message")), s = e.length;
            _.push(n), r = x(_, r, "privateKey");
            var c, o = 0 | t._crypto_sign_secretkeybytes();
            r.length !== o && f(_, "invalid privateKey length"), c = d(r), _.push(c);
            var h = new u(e.length + t._crypto_sign_bytes() | 0), p = h.address;
            if (_.push(p), 0 == (0 | t._crypto_sign(p, null, n, s, 0, c))) {
                var i = y(h, a);
                return g(_), i;
            }
            b(_, "invalid usage");
        }
        function yt(e, r, a) {
            var _ = [];
            l(a);
            var n = d(e = x(_, e, "message")), s = e.length;
            _.push(n), r = x(_, r, "privateKey");
            var c, o = 0 | t._crypto_sign_secretkeybytes();
            r.length !== o && f(_, "invalid privateKey length"), c = d(r), _.push(c);
            var h = new u(0 | t._crypto_sign_bytes()), p = h.address;
            if (_.push(p), 0 == (0 | t._crypto_sign_detached(p, null, n, s, 0, c))) {
                var i = y(h, a);
                return g(_), i;
            }
            b(_, "invalid usage");
        }
        function it(e, r) {
            var a = [];
            l(r), e = x(a, e, "edPk");
            var _, n = 0 | t._crypto_sign_publickeybytes();
            e.length !== n && f(a, "invalid edPk length"), _ = d(e), a.push(_);
            var s = new u(0 | t._crypto_scalarmult_scalarbytes()), c = s.address;
            if (a.push(c), 0 == (0 | t._crypto_sign_ed25519_pk_to_curve25519(c, _))) {
                var o = y(s, r);
                return g(a), o;
            }
            b(a, "invalid key");
        }
        function lt(e, r) {
            var a = [];
            l(r), e = x(a, e, "edSk");
            var _, n = 0 | t._crypto_sign_secretkeybytes();
            e.length !== n && f(a, "invalid edSk length"), _ = d(e), a.push(_);
            var s = new u(0 | t._crypto_scalarmult_scalarbytes()), c = s.address;
            if (a.push(c), 0 == (0 | t._crypto_sign_ed25519_sk_to_curve25519(c, _))) {
                var o = y(s, r);
                return g(a), o;
            }
            b(a, "invalid key");
        }
        function ut(e, r) {
            var a = [];
            l(r), e = x(a, e, "privateKey");
            var _, n = 0 | t._crypto_sign_secretkeybytes();
            e.length !== n && f(a, "invalid privateKey length"), _ = d(e), a.push(_);
            var s = new u(0 | t._crypto_sign_publickeybytes()), c = s.address;
            if (a.push(c), 0 == (0 | t._crypto_sign_ed25519_sk_to_pk(c, _))) {
                var o = y(s, r);
                return g(a), o;
            }
            b(a, "invalid key");
        }
        function dt(e, r) {
            var a = [];
            l(r), e = x(a, e, "privateKey");
            var _, n = 0 | t._crypto_sign_secretkeybytes();
            e.length !== n && f(a, "invalid privateKey length"), _ = d(e), a.push(_);
            var s = new u(0 | t._crypto_sign_seedbytes()), c = s.address;
            if (a.push(c), 0 == (0 | t._crypto_sign_ed25519_sk_to_seed(c, _))) {
                var o = y(s, r);
                return g(a), o;
            }
            b(a, "invalid key");
        }
        function vt(e, r, a) {
            var _ = [];
            l(a), m(_, e, "state_address"), r = x(_, r, "privateKey");
            var n, s = 0 | t._crypto_sign_secretkeybytes();
            r.length !== s && f(_, "invalid privateKey length"), n = d(r), _.push(n);
            var c = new u(0 | t._crypto_sign_bytes()), o = c.address;
            if (_.push(o), 0 == (0 | t._crypto_sign_final_create(e, o, null, n))) {
                var h = (t._free(e), y(c, a));
                return g(_), h;
            }
            b(_, "invalid usage");
        }
        function gt(e, r, a, _) {
            var n = [];
            l(_), m(n, e, "state_address"), r = x(n, r, "signature");
            var s, c = 0 | t._crypto_sign_bytes();
            r.length !== c && f(n, "invalid signature length"), s = d(r), n.push(s), a = x(n, a, "publicKey");
            var o, h = 0 | t._crypto_sign_publickeybytes();
            a.length !== h && f(n, "invalid publicKey length"), o = d(a), n.push(o);
            var p = 0 == (0 | t._crypto_sign_final_verify(e, s, o));
            return g(n), p;
        }
        function bt(e) {
            var r = [];
            l(e);
            var a = new u(208).address;
            if (0 == (0 | t._crypto_sign_init(a))) {
                var _ = a;
                return g(r), _;
            }
            b(r, "internal error");
        }
        function ft(e) {
            var r = [];
            l(e);
            var a = new u(0 | t._crypto_sign_publickeybytes()), _ = a.address;
            r.push(_);
            var n = new u(0 | t._crypto_sign_secretkeybytes()), s = n.address;
            if (r.push(s), 0 == (0 | t._crypto_sign_keypair(_, s))) {
                var c = {
                    publicKey: y(a, e),
                    privateKey: y(n, e),
                    keyType: "ed25519"
                };
                return g(r), c;
            }
            b(r, "internal error");
        }
        function mt(e, r, a) {
            var _ = [];
            l(a), e = x(_, e, "signedMessage");
            var n, s = t._crypto_sign_bytes(), c = e.length;
            c < s && f(_, "signedMessage is too short"), n = d(e), _.push(n), r = x(_, r, "publicKey");
            var o, h = 0 | t._crypto_sign_publickeybytes();
            r.length !== h && f(_, "invalid publicKey length"), o = d(r), _.push(o);
            var p = new u(c - t._crypto_sign_bytes() | 0), i = p.address;
            if (_.push(i), 0 == (0 | t._crypto_sign_open(i, null, n, c, 0, o))) {
                var v = y(p, a);
                return g(_), v;
            }
            b(_, "incorrect signature for the given public key");
        }
        function xt(e, r) {
            var a = [];
            l(r), e = x(a, e, "seed");
            var _, n = 0 | t._crypto_sign_seedbytes();
            e.length !== n && f(a, "invalid seed length"), _ = d(e), a.push(_);
            var s = new u(0 | t._crypto_sign_publickeybytes()), c = s.address;
            a.push(c);
            var o = new u(0 | t._crypto_sign_secretkeybytes()), h = o.address;
            if (a.push(h), 0 == (0 | t._crypto_sign_seed_keypair(c, h, _))) {
                var p = {
                    publicKey: y(s, r),
                    privateKey: y(o, r),
                    keyType: "ed25519"
                };
                return g(a), p;
            }
            b(a, "invalid usage");
        }
        function Et(e, r, a) {
            var _ = [];
            l(a), m(_, e, "state_address");
            var n = d(r = x(_, r, "message_chunk")), s = r.length;
            _.push(n), 0 != (0 | t._crypto_sign_update(e, n, s, 0)) && b(_, "invalid usage"), g(_);
        }
        function kt(e, r, a) {
            var _ = [];
            e = x(_, e, "signature");
            var n, s = 0 | t._crypto_sign_bytes();
            e.length !== s && f(_, "invalid signature length"), n = d(e), _.push(n);
            var c = d(r = x(_, r, "message")), o = r.length;
            _.push(c), a = x(_, a, "publicKey");
            var h, p = 0 | t._crypto_sign_publickeybytes();
            a.length !== p && f(_, "invalid publicKey length"), h = d(a), _.push(h);
            var y = 0 == (0 | t._crypto_sign_verify_detached(n, c, o, 0, h));
            return g(_), y;
        }
        function St(e, r, a, _) {
            var n = [];
            l(_), m(n, e, "outLength"), ("number" != typeof e || (0 | e) !== e || e < 0) && f(n, "outLength must be an unsigned integer"), r = x(n, r, "key");
            var s, c = 0 | t._crypto_stream_chacha20_keybytes();
            r.length !== c && f(n, "invalid key length"), s = d(r), n.push(s), a = x(n, a, "nonce");
            var o, h = 0 | t._crypto_stream_chacha20_noncebytes();
            a.length !== h && f(n, "invalid nonce length"), o = d(a), n.push(o);
            var p = new u(0 | e), i = p.address;
            n.push(i), t._crypto_stream_chacha20(i, e, 0, o, s);
            var v = y(p, _);
            return g(n), v;
        }
        function Tt(e, r, a, _) {
            var n = [];
            l(_);
            var s = d(e = x(n, e, "input_message")), c = e.length;
            n.push(s), r = x(n, r, "nonce");
            var o, h = 0 | t._crypto_stream_chacha20_ietf_noncebytes();
            r.length !== h && f(n, "invalid nonce length"), o = d(r), n.push(o), a = x(n, a, "key");
            var p, i = 0 | t._crypto_stream_chacha20_ietf_keybytes();
            a.length !== i && f(n, "invalid key length"), p = d(a), n.push(p);
            var v = new u(0 | c), m = v.address;
            if (n.push(m), 0 === t._crypto_stream_chacha20_ietf_xor(m, s, c, 0, o, p)) {
                var E = y(v, _);
                return g(n), E;
            }
            b(n, "invalid usage");
        }
        function wt(e, r, a, _, n) {
            var s = [];
            l(n);
            var c = d(e = x(s, e, "input_message")), o = e.length;
            s.push(c), r = x(s, r, "nonce");
            var h, p = 0 | t._crypto_stream_chacha20_ietf_noncebytes();
            r.length !== p && f(s, "invalid nonce length"), h = d(r), s.push(h), m(s, a, "nonce_increment"), ("number" != typeof a || (0 | a) !== a || a < 0) && f(s, "nonce_increment must be an unsigned integer"), _ = x(s, _, "key");
            var i, v = 0 | t._crypto_stream_chacha20_ietf_keybytes();
            _.length !== v && f(s, "invalid key length"), i = d(_), s.push(i);
            var E = new u(0 | o), k = E.address;
            if (s.push(k), 0 === t._crypto_stream_chacha20_ietf_xor_ic(k, c, o, 0, h, a, i)) {
                var S = y(E, n);
                return g(s), S;
            }
            b(s, "invalid usage");
        }
        function Yt(e) {
            var r = [];
            l(e);
            var a = new u(0 | t._crypto_stream_chacha20_keybytes()), _ = a.address;
            r.push(_), t._crypto_stream_chacha20_keygen(_);
            var n = y(a, e);
            return g(r), n;
        }
        function Bt(e, r, a, _) {
            var n = [];
            l(_);
            var s = d(e = x(n, e, "input_message")), c = e.length;
            n.push(s), r = x(n, r, "nonce");
            var o, h = 0 | t._crypto_stream_chacha20_noncebytes();
            r.length !== h && f(n, "invalid nonce length"), o = d(r), n.push(o), a = x(n, a, "key");
            var p, i = 0 | t._crypto_stream_chacha20_keybytes();
            a.length !== i && f(n, "invalid key length"), p = d(a), n.push(p);
            var v = new u(0 | c), m = v.address;
            if (n.push(m), 0 === t._crypto_stream_chacha20_xor(m, s, c, 0, o, p)) {
                var E = y(v, _);
                return g(n), E;
            }
            b(n, "invalid usage");
        }
        function At(e, r, a, _, n) {
            var s = [];
            l(n);
            var c = d(e = x(s, e, "input_message")), o = e.length;
            s.push(c), r = x(s, r, "nonce");
            var h, p = 0 | t._crypto_stream_chacha20_noncebytes();
            r.length !== p && f(s, "invalid nonce length"), h = d(r), s.push(h), m(s, a, "nonce_increment"), ("number" != typeof a || (0 | a) !== a || a < 0) && f(s, "nonce_increment must be an unsigned integer"), _ = x(s, _, "key");
            var i, v = 0 | t._crypto_stream_chacha20_keybytes();
            _.length !== v && f(s, "invalid key length"), i = d(_), s.push(i);
            var E = new u(0 | o), k = E.address;
            if (s.push(k), 0 === t._crypto_stream_chacha20_xor_ic(k, c, o, 0, h, a, 0, i)) {
                var S = y(E, n);
                return g(s), S;
            }
            b(s, "invalid usage");
        }
        function Kt(e) {
            var r = [];
            l(e);
            var a = new u(0 | t._crypto_stream_keybytes()), _ = a.address;
            r.push(_), t._crypto_stream_keygen(_);
            var n = y(a, e);
            return g(r), n;
        }
        function Mt(e) {
            var r = [];
            l(e);
            var a = new u(0 | t._crypto_stream_xchacha20_keybytes()), _ = a.address;
            r.push(_), t._crypto_stream_xchacha20_keygen(_);
            var n = y(a, e);
            return g(r), n;
        }
        function It(e, r, a, _) {
            var n = [];
            l(_);
            var s = d(e = x(n, e, "input_message")), c = e.length;
            n.push(s), r = x(n, r, "nonce");
            var o, h = 0 | t._crypto_stream_xchacha20_noncebytes();
            r.length !== h && f(n, "invalid nonce length"), o = d(r), n.push(o), a = x(n, a, "key");
            var p, i = 0 | t._crypto_stream_xchacha20_keybytes();
            a.length !== i && f(n, "invalid key length"), p = d(a), n.push(p);
            var v = new u(0 | c), m = v.address;
            if (n.push(m), 0 === t._crypto_stream_xchacha20_xor(m, s, c, 0, o, p)) {
                var E = y(v, _);
                return g(n), E;
            }
            b(n, "invalid usage");
        }
        function Nt(e, r, a, _, n) {
            var s = [];
            l(n);
            var c = d(e = x(s, e, "input_message")), o = e.length;
            s.push(c), r = x(s, r, "nonce");
            var h, p = 0 | t._crypto_stream_xchacha20_noncebytes();
            r.length !== p && f(s, "invalid nonce length"), h = d(r), s.push(h), m(s, a, "nonce_increment"), ("number" != typeof a || (0 | a) !== a || a < 0) && f(s, "nonce_increment must be an unsigned integer"), _ = x(s, _, "key");
            var i, v = 0 | t._crypto_stream_xchacha20_keybytes();
            _.length !== v && f(s, "invalid key length"), i = d(_), s.push(i);
            var E = new u(0 | o), k = E.address;
            if (s.push(k), 0 === t._crypto_stream_xchacha20_xor_ic(k, c, o, 0, h, a, 0, i)) {
                var S = y(E, n);
                return g(s), S;
            }
            b(s, "invalid usage");
        }
        function Lt(e, r) {
            var a = [];
            l(r), m(a, e, "length"), ("number" != typeof e || (0 | e) !== e || e < 0) && f(a, "length must be an unsigned integer");
            var _ = new u(0 | e), n = _.address;
            a.push(n), t._randombytes_buf(n, e);
            var s = y(_, r);
            return g(a), s;
        }
        function Ut(e, r, a) {
            var _ = [];
            l(a), m(_, e, "length"), ("number" != typeof e || (0 | e) !== e || e < 0) && f(_, "length must be an unsigned integer"), r = x(_, r, "seed");
            var n, s = 0 | t._randombytes_seedbytes();
            r.length !== s && f(_, "invalid seed length"), n = d(r), _.push(n);
            var c = new u(0 | e), o = c.address;
            _.push(o), t._randombytes_buf_deterministic(o, e, n);
            var h = y(c, a);
            return g(_), h;
        }
        function Ot(e) {
            l(e), t._randombytes_close();
        }
        function Ct(e) {
            l(e);
            var r = t._randombytes_random() >>> 0;
            return g([]), r;
        }
        function Rt(e, r) {
            var a = [];
            l(r);
            for(var _ = t._malloc(24), n = 0; n < 6; n++)t.setValue(_ + 4 * n, t.Runtime.addFunction(e[[
                "implementation_name",
                "random",
                "stir",
                "uniform",
                "buf",
                "close"
            ][n]]), "i32");
            0 != (0 | t._randombytes_set_implementation(_)) && b(a, "unsupported implementation"), g(a);
        }
        function Pt(e) {
            l(e), t._randombytes_stir();
        }
        function Gt(e, r) {
            var a = [];
            l(r), m(a, e, "upper_bound"), ("number" != typeof e || (0 | e) !== e || e < 0) && f(a, "upper_bound must be an unsigned integer");
            var _ = t._randombytes_uniform(e) >>> 0;
            return g(a), _;
        }
        function Xt() {
            var e = t._sodium_version_string(), r = t.UTF8ToString(e);
            return g([]), r;
        }
        return u.prototype.to_Uint8Array = function() {
            var e = new Uint8Array(this.length);
            return e.set(t.HEAPU8.subarray(this.address, this.address + this.length)), e;
        }, e.add = function(e, r) {
            if (!(e instanceof Uint8Array && r instanceof Uint8Array)) throw new TypeError("Only Uint8Array instances can added");
            var t = e.length, a = 0, _ = 0;
            if (r.length != e.length) throw new TypeError("Arguments must have the same length");
            for(_ = 0; _ < t; _++)a >>= 8, a += e[_] + r[_], e[_] = 255 & a;
        }, e.base64_variants = o, e.compare = function(e, r) {
            if (!(e instanceof Uint8Array && r instanceof Uint8Array)) throw new TypeError("Only Uint8Array instances can be compared");
            if (e.length !== r.length) throw new TypeError("Only instances of identical length can be compared");
            for(var t = 0, a = 1, _ = e.length; _-- > 0;)t |= r[_] - e[_] >> 8 & a, a &= (r[_] ^ e[_]) - 1 >> 8;
            return t + t + a - 1;
        }, e.from_base64 = function(e, r) {
            r = h(r);
            var a, _ = [], n = new u(3 * (e = x(_, e, "input")).length / 4), s = d(e), c = v(4), o = v(4);
            return _.push(s), _.push(n.address), _.push(n.result_bin_len_p), _.push(n.b64_end_p), 0 !== t._sodium_base642bin(n.address, n.length, s, e.length, 0, c, o, r) && b(_, "invalid input"), t.getValue(o, "i32") - s !== e.length && b(_, "incomplete input"), n.length = t.getValue(c, "i32"), a = n.to_Uint8Array(), g(_), a;
        }, e.from_hex = function(e) {
            var r, a = [], _ = new u((e = x(a, e, "input")).length / 2), n = d(e), s = v(4);
            return a.push(n), a.push(_.address), a.push(_.hex_end_p), 0 !== t._sodium_hex2bin(_.address, _.length, n, e.length, 0, 0, s) && b(a, "invalid input"), t.getValue(s, "i32") - n !== e.length && b(a, "incomplete input"), r = _.to_Uint8Array(), g(a), r;
        }, e.from_string = n, e.increment = function(e) {
            if (!(e instanceof Uint8Array)) throw new TypeError("Only Uint8Array instances can be incremented");
            for(var r = 256, t = 0, a = e.length; t < a; t++)r >>= 8, r += e[t], e[t] = 255 & r;
        }, e.is_zero = function(e) {
            if (!(e instanceof Uint8Array)) throw new TypeError("Only Uint8Array instances can be checked");
            for(var r = 0, t = 0, a = e.length; t < a; t++)r |= e[t];
            return 0 === r;
        }, e.libsodium = r, e.memcmp = function(e, r) {
            if (!(e instanceof Uint8Array && r instanceof Uint8Array)) throw new TypeError("Only Uint8Array instances can be compared");
            if (e.length !== r.length) throw new TypeError("Only instances of identical length can be compared");
            for(var t = 0, a = 0, _ = e.length; a < _; a++)t |= e[a] ^ r[a];
            return 0 === t;
        }, e.memzero = function(e) {
            if (!(e instanceof Uint8Array)) throw new TypeError("Only Uint8Array instances can be wiped");
            for(var r = 0, t = e.length; r < t; r++)e[r] = 0;
        }, e.output_formats = function() {
            return [
                "uint8array",
                "text",
                "hex",
                "base64"
            ];
        }, e.pad = function(e, r) {
            if (!(e instanceof Uint8Array)) throw new TypeError("buffer must be a Uint8Array");
            if ((r |= 0) <= 0) throw new Error("block size must be > 0");
            var a, _ = [], n = v(4), s = 1, c = 0, o = 0 | e.length, h = new u(o + r);
            _.push(n), _.push(h.address);
            for(var p = h.address, y = h.address + o + r; p < y; p++)t.HEAPU8[p] = e[c], c += s = 1 & ~((65535 & ((o -= s) >>> 48 | o >>> 32 | o >>> 16 | o)) - 1 >> 16);
            return 0 !== t._sodium_pad(n, h.address, e.length, r, h.length) && b(_, "internal error"), h.length = t.getValue(n, "i32"), a = h.to_Uint8Array(), g(_), a;
        }, e.unpad = function(e, r) {
            if (!(e instanceof Uint8Array)) throw new TypeError("buffer must be a Uint8Array");
            if ((r |= 0) <= 0) throw new Error("block size must be > 0");
            var a = [], _ = d(e), n = v(4);
            return a.push(_), a.push(n), 0 !== t._sodium_unpad(n, _, e.length, r) && b(a, "unsupported/invalid padding"), e = (e = new Uint8Array(e)).subarray(0, t.getValue(n, "i32")), g(a), e;
        }, e.ready = _, e.symbols = function() {
            return Object.keys(e).sort();
        }, e.to_base64 = p, e.to_hex = c, e.to_string = s, e;
    }
    var t = "object" == typeof e.sodium && "function" == typeof e.sodium.onload ? e.sodium.onload : null;
    "function" == typeof define && define.amd ? define([
        "exports",
        "libsodium-sumo"
    ], r) : "string" != typeof module.exports.nodeName ? r(module.exports, (parcelRequire("3fJ9X"))) : e.sodium = r(e.commonJsStrict = {}, e.libsodium), t && e.sodium.ready.then(function() {
        t(e.sodium);
    });
}(module.exports);

});
parcelRequire.register("3fJ9X", function(module, exports) {

var $4TNnu = parcelRequire("4TNnu");
var $25e5cd8cfcef32a3$var$__dirname = "node_modules/libsodium-sumo/dist/modules-sumo";

var $ihoyg = parcelRequire("ihoyg");
var $25e5cd8cfcef32a3$require$Buffer = $ihoyg.Buffer;






!function(A) {
    function I(A) {
        "use strict";
        var I;
        void 0 === (I = A) && (I = {});
        var g = I;
        "object" != typeof g.sodium && ("object" == typeof $parcel$global ? g = $parcel$global : "object" == typeof window && (g = window));
        var C = I;
        return I.ready = new Promise(function(A, I) {
            (Q = C).onAbort = I, Q.print = function(A) {}, Q.printErr = function(A) {}, Q.onRuntimeInitialized = function() {
                try {
                    Q._crypto_secretbox_keybytes(), A();
                } catch (A) {
                    I(A);
                }
            }, Q.useBackupModule = function() {
                return new Promise(function(A, I) {
                    (Q = {}).onAbort = I, Q.onRuntimeInitialized = function() {
                        Object.keys(C).forEach(function(A) {
                            "getRandomValue" !== A && delete C[A];
                        }), Object.keys(Q).forEach(function(A) {
                            C[A] = Q[A];
                        }), A();
                    };
                    var g, B, Q = void 0 !== Q ? Q : {}, i = Object.assign({}, Q), o = "object" == typeof window, E = "function" == typeof importScripts, a = "object" == typeof $4TNnu && "object" == typeof $4TNnu.versions && "string" == typeof $4TNnu.versions.node, _ = "";
                    if (a) {
                        var c = (parcelRequire("5Io6y")), t = (parcelRequire("5Io6y"));
                        _ = E ? t.dirname(_) + "/" : $25e5cd8cfcef32a3$var$__dirname + "/", g = (A, I)=>(A = function(A) {
                                return A.startsWith("file://");
                            }(A) ? new URL(A) : t.normalize(A), c.readFileSync(A, I ? void 0 : "utf8")), B = (A)=>{
                            var I = g(A, !0);
                            return I.buffer || (I = new Uint8Array(I)), I;
                        }, !Q.thisProgram && $4TNnu.argv.length > 1 && $4TNnu.argv[1].replace(/\\/g, "/"), $4TNnu.argv.slice(2), module.exports = Q, Q.inspect = ()=>"[Emscripten Module object]";
                    } else (o || E) && (E ? _ = self.location.href : "undefined" != typeof document && document.currentScript && (_ = document.currentScript.src), _ = 0 !== _.indexOf("blob:") ? _.substr(0, _.replace(/[?#].*/, "").lastIndexOf("/") + 1) : "", g = (A)=>{
                        var I = new XMLHttpRequest;
                        return I.open("GET", A, !1), I.send(null), I.responseText;
                    }, E && (B = (A)=>{
                        var I = new XMLHttpRequest;
                        return I.open("GET", A, !1), I.responseType = "arraybuffer", I.send(null), new Uint8Array(I.response);
                    }));
                    Q.print;
                    var r, e = Q.printErr || void 0;
                    Object.assign(Q, i), i = null, Q.arguments && Q.arguments, Q.thisProgram && Q.thisProgram, Q.quit && Q.quit, Q.wasmBinary && (r = Q.wasmBinary), Q.noExitRuntime;
                    var y, s = {
                        Memory: function(A) {
                            this.buffer = new ArrayBuffer(65536 * A.initial);
                        },
                        Module: function(A) {},
                        Instance: function(A, I) {
                            this.exports = function(A) {
                                for(var I, g = new Uint8Array(123), C = 25; C >= 0; --C)g[48 + C] = 52 + C, g[65 + C] = C, g[97 + C] = 26 + C;
                                function B(A, I, C) {
                                    for(var B, Q, i = 0, o = I, E = C.length, a = I + (3 * E >> 2) - ("=" == C[E - 2]) - ("=" == C[E - 1]); i < E; i += 4)B = g[C.charCodeAt(i + 1)], Q = g[C.charCodeAt(i + 2)], A[o++] = g[C.charCodeAt(i)] << 2 | B >> 4, o < a && (A[o++] = B << 4 | Q >> 2), o < a && (A[o++] = Q << 6 | g[C.charCodeAt(i + 3)]);
                                }
                                function Q() {
                                    throw new Error("abort");
                                }
                                return g[43] = 62, g[47] = 63, function(A) {
                                    var g = A.a, C = g.a, i = C.buffer;
                                    C.grow = function(A) {
                                        A |= 0;
                                        var g = 0 | wB(), B = g + A | 0;
                                        if (g < B && B < 65536) {
                                            var Q = new ArrayBuffer(c(B, 65536));
                                            new Int8Array(Q).set(o), o = new Int8Array(Q), new Int16Array(Q), E = new Int32Array(Q), a = new Uint8Array(Q), new Uint16Array(Q), _ = new Uint32Array(Q), new Float32Array(Q), new Float64Array(Q), i = Q, C.buffer = i, I = a;
                                        }
                                        return g;
                                    };
                                    var o = new Int8Array(i), E = (new Int16Array(i), new Int32Array(i)), a = new Uint8Array(i), _ = (new Uint16Array(i), new Uint32Array(i)), c = (new Float32Array(i), new Float64Array(i), Math.imul), t = (Math.fround, Math.abs, Math.clz32), r = (Math.min, Math.max, Math.floor, Math.ceil, Math.trunc, Math.sqrt, g.b), e = g.c, y = g.d, s = g.e, h = 103648, D = 0, p = 0, w = 0;
                                    function f(A, I) {
                                        var g, C, B, Q, i, E = 0, _ = 0, c = 0, t = 0, r = 0, e = 0, y = 0, s = 0, h = 0, D = 0, p = 0, f = 0, n = 0, k = 0, F = 0, N = 0, S = 0, G = 0, M = 0, b = 0, K = 0, H = 0, Y = 0, d = 0, J = 0, U = 0, l = 0, m = 0, u = 0, x = 0, R = 0, v = 0, L = 0, P = 0, q = 0, z = 0, j = 0, X = 0, O = 0, V = 0, Z = 0, W = 0, T = 0, $ = 0, AA = 0, IA = 0, gA = 0, CA = 0, BA = 0, QA = 0, iA = 0, oA = 0, EA = 0, aA = 0, _A = 0, cA = 0, tA = 0, rA = 0, eA = 0, yA = 0, sA = 0, hA = 0, DA = 0, pA = 0, wA = 0, fA = 0, nA = 0, kA = 0, FA = 0, NA = 0, SA = 0, GA = 0, MA = 0, bA = 0;
                                        rA = a[I + 40 | 0] | a[I + 41 | 0] << 8 | a[I + 42 | 0] << 16 | a[I + 43 | 0] << 24, yA = E = a[I + 44 | 0] | a[I + 45 | 0] << 8 | a[I + 46 | 0] << 16 | a[I + 47 | 0] << 24, gA = a[I + 104 | 0] | a[I + 105 | 0] << 8 | a[I + 106 | 0] << 16 | a[I + 107 | 0] << 24, sA = E = a[I + 108 | 0] | a[I + 109 | 0] << 8 | a[I + 110 | 0] << 16 | a[I + 111 | 0] << 24, E = a[I + 68 | 0] | a[I + 69 | 0] << 8 | a[I + 70 | 0] << 16 | a[I + 71 | 0] << 24, j = a[I + 64 | 0] | a[I + 65 | 0] << 8 | a[I + 66 | 0] << 16 | a[I + 67 | 0] << 24, BA = E, SA = E = a[I + 36 | 0] | a[I + 37 | 0] << 8 | a[I + 38 | 0] << 16 | a[I + 39 | 0] << 24, S = E, EA = a[I + 120 | 0] | a[I + 121 | 0] << 8 | a[I + 122 | 0] << 16 | a[I + 123 | 0] << 24, wA = E = a[I + 124 | 0] | a[I + 125 | 0] << 8 | a[I + 126 | 0] << 16 | a[I + 127 | 0] << 24, B = E = a[I + 92 | 0] | a[I + 93 | 0] << 8 | a[I + 94 | 0] << 16 | a[I + 95 | 0] << 24, g = a[I + 88 | 0] | a[I + 89 | 0] << 8 | a[I + 90 | 0] << 16 | a[I + 91 | 0] << 24, z = E, oA = a[I + 80 | 0] | a[I + 81 | 0] << 8 | a[I + 82 | 0] << 16 | a[I + 83 | 0] << 24, DA = E = a[I + 84 | 0] | a[I + 85 | 0] << 8 | a[I + 86 | 0] << 16 | a[I + 87 | 0] << 24, X = E, QA = a[A + 16 | 0] | a[A + 17 | 0] << 8 | a[A + 18 | 0] << 16 | a[A + 19 | 0] << 24, E = (_A = a[A + 52 | 0] | a[A + 53 | 0] << 8 | a[A + 54 | 0] << 16 | a[A + 55 | 0] << 24) + S | 0, P = (aA = a[A + 48 | 0] | a[A + 49 | 0] << 8 | a[A + 50 | 0] << 16 | a[A + 51 | 0] << 24) + (cA = a[I + 32 | 0] | a[I + 33 | 0] << 8 | a[I + 34 | 0] << 16 | a[I + 35 | 0] << 24) | 0, E = (a[A + 20 | 0] | a[A + 21 | 0] << 8 | a[A + 22 | 0] << 16 | a[A + 23 | 0] << 24) + (aA >>> 0 > P >>> 0 ? E + 1 | 0 : E) | 0, E = (QA = (_ = P) >>> 0 > (P = P + QA | 0) >>> 0 ? E + 1 | 0 : E) + yA | 0, iA = eA = P + rA | 0, eA = E = eA >>> 0 < P >>> 0 ? E + 1 | 0 : E, P = KI(P ^ (a[A + 80 | 0] | a[A + 81 | 0] << 8 | a[A + 82 | 0] << 16 | a[A + 83 | 0] << 24) ^ -79577749, QA ^ (a[A + 84 | 0] | a[A + 85 | 0] << 8 | a[A + 86 | 0] << 16 | a[A + 87 | 0] << 24) ^ 528734635, 32), kA = E = w, E = E + 1013904242 | 0, QA = P, Z = E = (P = P - 23791573 | 0) >>> 0 < 4271175723 ? E + 1 | 0 : E, _A = KI(P ^ aA, E ^ _A, 40), E = (E = eA) + (eA = w) | 0, aA = KI(QA ^ (h = aA = _A + iA | 0), kA ^ (D = h >>> 0 < _A >>> 0 ? E + 1 | 0 : E), 48), E = Z + (v = w) | 0, k = E = (aA = P + (p = aA) | 0) >>> 0 < P >>> 0 ? E + 1 | 0 : E, aA = E = KI(_A ^ (n = aA), eA ^ E, 1), Z = P = w, eA = a[I + 24 | 0] | a[I + 25 | 0] << 8 | a[I + 26 | 0] << 16 | a[I + 27 | 0] << 24, kA = E = a[I + 28 | 0] | a[I + 29 | 0] << 8 | a[I + 30 | 0] << 16 | a[I + 31 | 0] << 24, tA = a[A + 8 | 0] | a[A + 9 | 0] << 8 | a[A + 10 | 0] << 16 | a[A + 11 | 0] << 24, P = (_A = a[I + 16 | 0] | a[I + 17 | 0] << 8 | a[I + 18 | 0] << 16 | a[I + 19 | 0] << 24) + (QA = a[A + 40 | 0] | a[A + 41 | 0] << 8 | a[A + 42 | 0] << 16 | a[A + 43 | 0] << 24) | 0, E = (GA = a[I + 20 | 0] | a[I + 21 | 0] << 8 | a[I + 22 | 0] << 16 | a[I + 23 | 0] << 24) + (bA = a[A + 44 | 0] | a[A + 45 | 0] << 8 | a[A + 46 | 0] << 16 | a[A + 47 | 0] << 24) | 0, E = (a[A + 12 | 0] | a[A + 13 | 0] << 8 | a[A + 14 | 0] << 16 | a[A + 15 | 0] << 24) + (P >>> 0 < QA >>> 0 ? E + 1 | 0 : E) | 0, E = kA + (iA = (_ = P) >>> 0 > (P = P + tA | 0) >>> 0 ? E + 1 | 0 : E) | 0, E = (tA = P + eA | 0) >>> 0 < P >>> 0 ? E + 1 | 0 : E, _ = KI(P ^ (a[A + 72 | 0] | a[A + 73 | 0] << 8 | a[A + 74 | 0] << 16 | a[A + 75 | 0] << 24) ^ 725511199, iA ^ (a[A + 76 | 0] | a[A + 77 | 0] << 8 | a[A + 78 | 0] << 16 | a[A + 79 | 0] << 24) ^ -1694144372, 32), e = KI(QA ^ (c = _ - 2067093701 | 0), bA ^ (x = (J = P = w) - ((_ >>> 0 < 2067093701) + 1150833018 | 0) | 0), 40), E = (L = w) + E | 0, E = (d = (F = P = e + tA | 0) >>> 0 < e >>> 0 ? E + 1 | 0 : E) + Z | 0, E = (F >>> 0 > (P = F + aA | 0) >>> 0 ? E + 1 | 0 : E) + X | 0, E = (QA = (t = P) >>> 0 > (P = P + oA | 0) >>> 0 ? E + 1 | 0 : E) + z | 0, m = z = P + g | 0, s = E = z >>> 0 < P >>> 0 ? E + 1 | 0 : E, f = aA, fA = Z, Z = P, iA = QA, aA = a[I + 8 | 0] | a[I + 9 | 0] << 8 | a[I + 10 | 0] << 16 | a[I + 11 | 0] << 24, P = E = a[I + 12 | 0] | a[I + 13 | 0] << 8 | a[I + 14 | 0] << 16 | a[I + 15 | 0] << 24, bA = E = a[0 | A] | a[A + 1 | 0] << 8 | a[A + 2 | 0] << 16 | a[A + 3 | 0] << 24, Q = QA = a[A + 4 | 0] | a[A + 5 | 0] << 8 | a[A + 6 | 0] << 16 | a[A + 7 | 0] << 24, X = E, E = (FA = a[I + 4 | 0] | a[I + 5 | 0] << 8 | a[I + 6 | 0] << 16 | a[I + 7 | 0] << 24) + (r = a[A + 36 | 0] | a[A + 37 | 0] << 8 | a[A + 38 | 0] << 16 | a[A + 39 | 0] << 24) | 0, E = Q + ((z = a[A + 32 | 0] | a[A + 33 | 0] << 8 | a[A + 34 | 0] << 16 | a[A + 35 | 0] << 24) >>> 0 > (t = z + (QA = a[0 | I] | a[I + 1 | 0] << 8 | a[I + 2 | 0] << 16 | a[I + 3 | 0] << 24) | 0) >>> 0 ? E + 1 | 0 : E) | 0, E = (tA = (X = t + X | 0) >>> 0 < t >>> 0 ? E + 1 | 0 : E) + P | 0, pA = t = X + aA | 0, t = E = t >>> 0 < X >>> 0 ? E + 1 | 0 : E, y = z, z = KI(X ^ (a[0 | (E = A - -64 | 0)] | a[E + 1 | 0] << 8 | a[E + 2 | 0] << 16 | a[E + 3 | 0] << 24) ^ -1377402159, tA ^ (a[E + 4 | 0] | a[E + 5 | 0] << 8 | a[E + 6 | 0] << 16 | a[E + 7 | 0] << 24) ^ 1359893119, 32), tA = E = w, E = E + 1779033703 | 0, X = z, K = E = (z = z - 205731576 | 0) >>> 0 < 4089235720 ? E + 1 | 0 : E, r = KI(y ^ (N = z), E ^ r, 40), E = (l = w) + t | 0, y = KI(X ^ (t = z = r + pA | 0), tA ^ (G = r >>> 0 > t >>> 0 ? E + 1 | 0 : E), 48), E = KI(y ^ Z, (T = w) ^ iA, 32), V = z = w, u = E, C = E = a[I + 60 | 0] | a[I + 61 | 0] << 8 | a[I + 62 | 0] << 16 | a[I + 63 | 0] << 24, tA = pA = a[I + 56 | 0] | a[I + 57 | 0] << 8 | a[I + 58 | 0] << 16 | a[I + 59 | 0] << 24, b = a[A + 24 | 0] | a[A + 25 | 0] << 8 | a[A + 26 | 0] << 16 | a[A + 27 | 0] << 24, z = (iA = a[I + 48 | 0] | a[I + 49 | 0] << 8 | a[I + 50 | 0] << 16 | a[I + 51 | 0] << 24) + (X = a[A + 56 | 0] | a[A + 57 | 0] << 8 | a[A + 58 | 0] << 16 | a[A + 59 | 0] << 24) | 0, E = (NA = a[I + 52 | 0] | a[I + 53 | 0] << 8 | a[I + 54 | 0] << 16 | a[I + 55 | 0] << 24) + (U = a[A + 60 | 0] | a[A + 61 | 0] << 8 | a[A + 62 | 0] << 16 | a[A + 63 | 0] << 24) | 0, E = (a[A + 28 | 0] | a[A + 29 | 0] << 8 | a[A + 30 | 0] << 16 | a[A + 31 | 0] << 24) + (z >>> 0 < X >>> 0 ? E + 1 | 0 : E) | 0, E = C + (Z = (M = z) >>> 0 > (z = b + z | 0) >>> 0 ? E + 1 | 0 : E) | 0, E = (b = z + tA | 0) >>> 0 < z >>> 0 ? E + 1 | 0 : E, Z = KI(z ^ (a[A + 88 | 0] | a[A + 89 | 0] << 8 | a[A + 90 | 0] << 16 | a[A + 91 | 0] << 24) ^ 327033209, Z ^ (a[A + 92 | 0] | a[A + 93 | 0] << 8 | a[A + 94 | 0] << 16 | a[A + 95 | 0] << 24) ^ 1541459225, 32), X = KI(X ^ (tA = Z + 1595750129 | 0), (M = U) ^ (U = (H = z = w) - ((Z >>> 0 < 2699217167) + 1521486533 | 0) | 0), 40), E = (IA = w) + E | 0, z = KI((b = z = X + b | 0) ^ Z, H ^ (M = b >>> 0 < X >>> 0 ? E + 1 | 0 : E), 48), E = U + ($ = w) | 0, Y = E = (z = tA + (U = z) | 0) >>> 0 < tA >>> 0 ? E + 1 | 0 : E, E = V + E | 0, O = f ^ (Z = u + (H = z) | 0), f = E = Z >>> 0 < H >>> 0 ? E + 1 | 0 : E, tA = KI(O, E ^ fA, 40), E = (fA = w) + s | 0, z = KI(m = u ^ (s = z = tA + m | 0), V ^ (u = s >>> 0 < tA >>> 0 ? E + 1 | 0 : E), 48), E = f + (CA = w) | 0, V = E = (f = Z + (m = z) | 0) >>> 0 < Z >>> 0 ? E + 1 | 0 : E, z = (R = KI(f ^ tA, fA ^ E, 1)) + (Z = a[I + 72 | 0] | a[I + 73 | 0] << 8 | a[I + 74 | 0] << 16 | a[I + 75 | 0] << 24) | 0, E = (hA = w) + (fA = a[I + 76 | 0] | a[I + 77 | 0] << 8 | a[I + 78 | 0] << 16 | a[I + 79 | 0] << 24) | 0, nA = z, q = z >>> 0 < Z >>> 0 ? E + 1 | 0 : E, W = sA, z = a[I + 96 | 0] | a[I + 97 | 0] << 8 | a[I + 98 | 0] << 16 | a[I + 99 | 0] << 24, tA = E = a[I + 100 | 0] | a[I + 101 | 0] << 8 | a[I + 102 | 0] << 16 | a[I + 103 | 0] << 24, X = (E = h) + (h = KI(H ^ X, Y ^ IA, 1)) | 0, E = (H = w) + D | 0, E = (h >>> 0 > X >>> 0 ? E + 1 | 0 : E) + tA | 0, E = (D = (D = X) >>> 0 > (X = z + X | 0) >>> 0 ? E + 1 | 0 : E) + W | 0, O = Y = X + gA | 0, Y = E = Y >>> 0 < X >>> 0 ? E + 1 | 0 : E, F = KI(_ ^ F, d ^ J, 48), d = E = KI(F ^ X, (J = w) ^ D, 32), E = K + T | 0, E = (IA = X = w) + (N = (X = y + N | 0) >>> 0 < y >>> 0 ? E + 1 | 0 : E) | 0, K = E = (D = X) >>> 0 > (y = D + d | 0) >>> 0 ? E + 1 | 0 : E, h = KI(y ^ h, H ^ E, 40), E = (T = w) + Y | 0, E = (H = h >>> 0 > (Y = X = h + O | 0) >>> 0 ? E + 1 | 0 : E) + q | 0, E = (_ = Y >>> 0 > (X = Y + nA | 0) >>> 0 ? E + 1 | 0 : E) + wA | 0, nA = q = X + EA | 0, q = E = q >>> 0 < X >>> 0 ? E + 1 | 0 : E, O = X, W = _, X = a[I + 116 | 0] | a[I + 117 | 0] << 8 | a[I + 118 | 0] << 16 | a[I + 119 | 0] << 24, I = a[I + 112 | 0] | a[I + 113 | 0] << 8 | a[I + 114 | 0] << 16 | a[I + 115 | 0] << 24, r = KI(r ^ D, N ^ l, 1), E = (l = w) + M | 0, E = ((_ = r + b | 0) >>> 0 < r >>> 0 ? E + 1 | 0 : E) + X | 0, E = (D = (N = _) >>> 0 > (_ = I + _ | 0) >>> 0 ? E + 1 | 0 : E) + wA | 0, MA = N = _ + EA | 0, N = E = N >>> 0 < _ >>> 0 ? E + 1 | 0 : E, E = KI(_ ^ p, D ^ v, 32), AA = _ = w, p = E, D = _, E = J + x | 0, F = _ = c + F | 0, b = E = _ >>> 0 < c >>> 0 ? E + 1 | 0 : E, E = E + D | 0, M = _ = _ + p | 0, v = E = F >>> 0 > _ >>> 0 ? E + 1 | 0 : E, D = KI(_ ^ r, l ^ E, 40), E = (l = w) + N | 0, p = KI((_ = D + MA | 0) ^ p, AA ^ (c = _ >>> 0 < D >>> 0 ? E + 1 | 0 : E), 48), E = KI(p ^ O, (MA = w) ^ W, 32), AA = r = w, N = E, O = r, e = KI(e ^ F, b ^ L, 1), E = G + (F = w) | 0, E = ((r = t) >>> 0 > (t = t + e | 0) >>> 0 ? E + 1 | 0 : E) + BA | 0, E = (t = (r = t + j | 0) >>> 0 < t >>> 0 ? E + 1 | 0 : E) + fA | 0, W = G = r + Z | 0, G = E = G >>> 0 < r >>> 0 ? E + 1 | 0 : E, b = e, r = KI(r ^ U, t ^ $, 32), E = (U = w) + k | 0, n = KI(b ^ (t = e = r + n | 0), (k = r >>> 0 > t >>> 0 ? E + 1 | 0 : E) ^ F, 40), E = ($ = w) + G | 0, F = e = n + W | 0, e = KI(r ^ e, U ^ (G = e >>> 0 < n >>> 0 ? E + 1 | 0 : E), 48), E = k + (i = w) | 0, k = e, U = E = (e = t + e | 0) >>> 0 < t >>> 0 ? E + 1 | 0 : E, E = E + O | 0, E = (b = e) >>> 0 > (e = e + N | 0) >>> 0 ? E + 1 | 0 : E, O = e, e ^= R, R = E, r = KI(e, hA ^ E, 40), E = (hA = w) + q | 0, q = e = r + nA | 0, E = B + (W = r >>> 0 > e >>> 0 ? E + 1 | 0 : E) | 0, nA = e = e + g | 0, J = E = e >>> 0 < g >>> 0 ? E + 1 | 0 : E, e = _, x = gA, L = sA, _ = KI(d ^ Y, H ^ IA, 48), E = K + (IA = w) | 0, d = _, K = E = (t = y + _ | 0) >>> 0 < y >>> 0 ? E + 1 | 0 : E, _ = KI(t ^ h, T ^ E, 1), E = (y = w) + L | 0, E = ((h = _ + x | 0) >>> 0 < _ >>> 0 ? E + 1 | 0 : E) + c | 0, E = NA + (e = (c = e + h | 0) >>> 0 < h >>> 0 ? E + 1 | 0 : E) | 0, Y = h = c + iA | 0, h = E = h >>> 0 < iA >>> 0 ? E + 1 | 0 : E, c = KI(c ^ k, e ^ i, 32), E = V + (H = w) | 0, k = c, f = E = (c = f + c | 0) >>> 0 < f >>> 0 ? E + 1 | 0 : E, e = KI(_ ^ c, E ^ y, 40), E = (E = h) + (h = w) | 0, y = _ = e + Y | 0, _ = KI(_ ^ k, H ^ (Y = _ >>> 0 < e >>> 0 ? E + 1 | 0 : E), 48), E = f + (T = w) | 0, H = _, V = E = (f = c + _ | 0) >>> 0 < c >>> 0 ? E + 1 | 0 : E, _ = KI(e ^ f, h ^ E, 1), E = (h = w) + J | 0, E = C + (e = (c = _ + nA | 0) >>> 0 < _ >>> 0 ? E + 1 | 0 : E) | 0, nA = k = c + pA | 0, k = E = k >>> 0 < pA >>> 0 ? E + 1 | 0 : E, J = _, x = h, E = v + MA | 0, E = (_ = p + M | 0) >>> 0 < p >>> 0 ? E + 1 | 0 : E, p = _, M = E, E = KI(_ ^ D, l ^ E, 1), D = h = w, _ = E, E = G + X | 0, E = ((F = I + F | 0) >>> 0 < I >>> 0 ? E + 1 | 0 : E) + h | 0, E = DA + (F = (h = _ + F | 0) >>> 0 < F >>> 0 ? E + 1 | 0 : E) | 0, v = G = h + oA | 0, G = E = G >>> 0 < oA >>> 0 ? E + 1 | 0 : E, h = KI(h ^ m, F ^ CA, 32), E = K + (m = w) | 0, F = h, K = E = (K = t) >>> 0 > (t = t + h | 0) >>> 0 ? E + 1 | 0 : E, h = KI(_ ^ t, E ^ D, 40), E = (l = w) + G | 0, D = _ = h + v | 0, _ = KI(G = _ ^ F, m ^ (F = _ >>> 0 < h >>> 0 ? E + 1 | 0 : E), 48), E = K + (CA = w) | 0, K = _, G = _ = t + _ | 0, m = E = _ >>> 0 < t >>> 0 ? E + 1 | 0 : E, v = c, L = e, _ = KI(n ^ b, U ^ $, 1), E = (t = w) + S | 0, E = u + ((c = _ + cA | 0) >>> 0 < _ >>> 0 ? E + 1 | 0 : E) | 0, E = BA + (e = (c = c + s | 0) >>> 0 < s >>> 0 ? E + 1 | 0 : E) | 0, u = s = c + j | 0, s = E = s >>> 0 < c >>> 0 ? E + 1 | 0 : E, n = _, _ = (c = KI(c ^ d, e ^ IA, 32)) + p | 0, E = (p = w) + M | 0, e = _, t = KI(_ ^ n, (d = _ >>> 0 < c >>> 0 ? E + 1 | 0 : E) ^ t, 40), E = (IA = w) + s | 0, s = _ = t + u | 0, b = KI(_ ^ c, p ^ (u = _ >>> 0 < t >>> 0 ? E + 1 | 0 : E), 48), c = KI(b ^ v, (E = L) ^ (L = w), 32), E = (v = w) + m | 0, p = _ = c + G | 0, n = KI(_ ^ J, (M = _ >>> 0 < c >>> 0 ? E + 1 | 0 : E) ^ x, 40), E = (J = w) + k | 0, k = _ = n + nA | 0, _ = KI(_ ^ c, v ^ (U = _ >>> 0 < n >>> 0 ? E + 1 | 0 : E), 48), E = M + ($ = w) | 0, M = _, v = E = (c = p) >>> 0 > (p = p + _ | 0) >>> 0 ? E + 1 | 0 : E, _ = KI(p ^ n, J ^ E, 1), E = wA + (nA = w) | 0, J = _, MA = _ = EA + _ | 0, n = E = _ >>> 0 < EA >>> 0 ? E + 1 | 0 : E, c = rA, _ = KI(h ^ G, l ^ m, 1), E = Y + (h = w) | 0, E = ((G = y) >>> 0 > (y = _ + y | 0) >>> 0 ? E + 1 | 0 : E) + yA | 0, E = (G = (c = c + y | 0) >>> 0 < y >>> 0 ? E + 1 | 0 : E) + kA | 0, x = y = c + eA | 0, Y = E = y >>> 0 < c >>> 0 ? E + 1 | 0 : E, m = _, y = KI(N ^ q, W ^ AA, 48), E = KI(y ^ c, (l = w) ^ G, 32), AA = _ = w, N = E, c = _, E = d + L | 0, E = (_ = e + b | 0) >>> 0 < e >>> 0 ? E + 1 | 0 : E, e = _, d = E, E = E + c | 0, G = _ = _ + N | 0, b = E = e >>> 0 > _ >>> 0 ? E + 1 | 0 : E, c = KI(_ ^ m, E ^ h, 40), E = (E = Y) + (Y = w) | 0, m = _ = c + x | 0, q = E = _ >>> 0 < c >>> 0 ? E + 1 | 0 : E, E = E + n | 0, W = E = (h = _ + MA | 0) >>> 0 < _ >>> 0 ? E + 1 | 0 : E, n = E, _ = KI(t ^ e, d ^ IA, 1), E = P + (t = w) | 0, E = F + ((e = _ + aA | 0) >>> 0 < aA >>> 0 ? E + 1 | 0 : E) | 0, E = tA + (D = (e = e + D | 0) >>> 0 < D >>> 0 ? E + 1 | 0 : E) | 0, x = F = e + z | 0, F = E = F >>> 0 < z >>> 0 ? E + 1 | 0 : E, d = _, E = KI(e ^ H, D ^ T, 32), L = _ = w, e = E, D = _, E = l + R | 0, H = _ = y + O | 0, R = E = _ >>> 0 < y >>> 0 ? E + 1 | 0 : E, E = E + D | 0, E = (y = _ + e | 0) >>> 0 < _ >>> 0 ? E + 1 | 0 : E, _ = y ^ d, d = E, D = KI(_, E ^ t, 40), E = (T = w) + F | 0, t = _ = D + x | 0, O = KI(_ ^ e, L ^ (F = _ >>> 0 < D >>> 0 ? E + 1 | 0 : E), 48), E = KI(O ^ h, (IA = w) ^ n, 32), MA = _ = w, x = E, n = _, _ = KI(r ^ H, R ^ hA, 1), E = u + (r = w) | 0, E = FA + ((e = _ + s | 0) >>> 0 < s >>> 0 ? E + 1 | 0 : E) | 0, E = (s = (e = e + QA | 0) >>> 0 < QA >>> 0 ? E + 1 | 0 : E) + GA | 0, H = u = e + _A | 0, u = E = u >>> 0 < e >>> 0 ? E + 1 | 0 : E, e = KI(e ^ K, s ^ CA, 32), E = V + (R = w) | 0, K = e, s = r, r = E = (e = f + e | 0) >>> 0 < f >>> 0 ? E + 1 | 0 : E, s = KI(_ ^ e, s ^ E, 40), E = (CA = w) + u | 0, f = _ = s + H | 0, _ = KI(H = _ ^ K, R ^ (K = _ >>> 0 < s >>> 0 ? E + 1 | 0 : E), 48), E = r + (l = w) | 0, r = _, u = _ = e + _ | 0, H = E = _ >>> 0 < e >>> 0 ? E + 1 | 0 : E, E = E + n | 0, V = E = (n = _ + x | 0) >>> 0 < _ >>> 0 ? E + 1 | 0 : E, e = KI(n ^ J, nA ^ E, 40), E = W + (R = w) | 0, E = ((_ = e + h | 0) >>> 0 < h >>> 0 ? E + 1 | 0 : E) + sA | 0, h = _, W = _ = _ + gA | 0, J = E = h >>> 0 > _ >>> 0 ? E + 1 | 0 : E, L = BA, h = KI(N ^ m, q ^ AA, 48), E = (hA = w) + b | 0, N = _ = h + G | 0, E = KI(_ ^ c, (G = _ >>> 0 < h >>> 0 ? E + 1 | 0 : E) ^ Y, 1), Y = c = w, _ = E, E = F + B | 0, E = ((t = t + g | 0) >>> 0 < g >>> 0 ? E + 1 | 0 : E) + c | 0, E = (t = (c = _ + t | 0) >>> 0 < t >>> 0 ? E + 1 | 0 : E) + L | 0, b = F = c + j | 0, F = E = F >>> 0 < c >>> 0 ? E + 1 | 0 : E, c = KI(c ^ r, t ^ l, 32), E = v + (m = w) | 0, p = E = (r = c + p | 0) >>> 0 < p >>> 0 ? E + 1 | 0 : E, t = KI(_ ^ r, E ^ Y, 40), E = (q = w) + F | 0, F = _ = t + b | 0, c = KI(_ ^ c, m ^ (Y = _ >>> 0 < t >>> 0 ? E + 1 | 0 : E), 48), E = p + (b = w) | 0, m = E = (p = c + r | 0) >>> 0 < r >>> 0 ? E + 1 | 0 : E, _ = KI(t ^ p, q ^ E, 1), E = (q = w) + J | 0, E = fA + ((r = _ + W | 0) >>> 0 < _ >>> 0 ? E + 1 | 0 : E) | 0, E = (t = (r = r + Z | 0) >>> 0 < Z >>> 0 ? E + 1 | 0 : E) + S | 0, nA = S = r + cA | 0, S = E = S >>> 0 < r >>> 0 ? E + 1 | 0 : E, v = _, L = r, l = t, r = rA, _ = KI(s ^ u, H ^ CA, 1), E = U + (s = w) | 0, E = ((t = k) >>> 0 > (k = _ + k | 0) >>> 0 ? E + 1 | 0 : E) + yA | 0, E = GA + (t = (r = r + k | 0) >>> 0 < k >>> 0 ? E + 1 | 0 : E) | 0, U = k = r + _A | 0, u = E = k >>> 0 < _A >>> 0 ? E + 1 | 0 : E, k = _, t = E = KI(r ^ h, t ^ hA, 32), E = d + IA | 0, E = (H = _ = w) + (y = (_ = y + O | 0) >>> 0 < y >>> 0 ? E + 1 | 0 : E) | 0, d = E = (h = _ + t | 0) >>> 0 < _ >>> 0 ? E + 1 | 0 : E, k = KI(h ^ k, E ^ s, 40), E = (IA = w) + u | 0, u = KI(U = (r = k + U | 0) ^ t, H ^ (t = r >>> 0 < k >>> 0 ? E + 1 | 0 : E), 48), E = KI(u ^ L, (CA = w) ^ l, 32), hA = s = w, U = E, H = s, _ = KI(_ ^ D, y ^ T, 1), E = tA + (s = w) | 0, E = K + ((y = _ + z | 0) >>> 0 < z >>> 0 ? E + 1 | 0 : E) | 0, E = FA + (f = (y = y + f | 0) >>> 0 < f >>> 0 ? E + 1 | 0 : E) | 0, L = D = y + QA | 0, D = E = D >>> 0 < QA >>> 0 ? E + 1 | 0 : E, K = _, O = s, y = KI(y ^ M, f ^ $, 32), E = (M = w) + G | 0, s = _ = y + N | 0, f = KI(_ ^ K, (N = _ >>> 0 < y >>> 0 ? E + 1 | 0 : E) ^ O, 40), E = (T = w) + D | 0, K = _ = f + L | 0, _ = KI(_ ^ y, M ^ (G = _ >>> 0 < f >>> 0 ? E + 1 | 0 : E), 48), E = N + (L = w) | 0, D = _, N = _ = s + _ | 0, M = E = _ >>> 0 < s >>> 0 ? E + 1 | 0 : E, E = E + H | 0, H = _ = _ + U | 0, y = q, q = E = N >>> 0 > _ >>> 0 ? E + 1 | 0 : E, y = KI(_ ^ v, y ^ E, 40), E = (E = S) + (S = w) | 0, O = _ = y + nA | 0, v = E = _ >>> 0 < y >>> 0 ? E + 1 | 0 : E, s = t, _ = KI(x ^ W, J ^ MA, 48), E = V + ($ = w) | 0, V = _, t = (_ = n + _ | 0) ^ e, e = E = _ >>> 0 < n >>> 0 ? E + 1 | 0 : E, t = KI(t, E ^ R, 1), E = (R = w) + s | 0, E = C + ((r = t + r | 0) >>> 0 < t >>> 0 ? E + 1 | 0 : E) | 0, E = (s = (r = r + pA | 0) >>> 0 < pA >>> 0 ? E + 1 | 0 : E) + P | 0, W = n = r + aA | 0, n = E = n >>> 0 < r >>> 0 ? E + 1 | 0 : E, r = KI(r ^ D, s ^ L, 32), E = m + (J = w) | 0, m = r, p = E = (s = p + r | 0) >>> 0 < p >>> 0 ? E + 1 | 0 : E, t = KI(t ^ s, R ^ E, 40), E = (E = n) + (n = w) | 0, D = r = t + W | 0, r = KI(x = r ^ m, J ^ (m = r >>> 0 < t >>> 0 ? E + 1 | 0 : E), 48), E = p + (nA = w) | 0, R = r, W = E = (p = s + r | 0) >>> 0 < s >>> 0 ? E + 1 | 0 : E, r = KI(t ^ p, n ^ E, 1), E = (n = w) + v | 0, E = B + ((t = r + O | 0) >>> 0 < r >>> 0 ? E + 1 | 0 : E) | 0, E = X + (s = (t = t + g | 0) >>> 0 < g >>> 0 ? E + 1 | 0 : E) | 0, MA = J = I + t | 0, J = E = J >>> 0 < I >>> 0 ? E + 1 | 0 : E, x = r, L = n, n = t, l = s, r = KI(f ^ N, M ^ T, 1), E = (s = w) + Y | 0, E = DA + ((t = r + F | 0) >>> 0 < r >>> 0 ? E + 1 | 0 : E) | 0, E = (f = (t = t + oA | 0) >>> 0 < oA >>> 0 ? E + 1 | 0 : E) + X | 0, Y = F = I + t | 0, F = E = F >>> 0 < t >>> 0 ? E + 1 | 0 : E, N = r, t = E = KI(t ^ V, f ^ $, 32), f = r = w, E = d + CA | 0, d = E = (r = h + u | 0) >>> 0 < h >>> 0 ? E + 1 | 0 : E, E = E + f | 0, E = (h = r) >>> 0 > (r = r + t | 0) >>> 0 ? E + 1 | 0 : E, u = r, r ^= N, N = E, s = KI(r, E ^ s, 40), E = (T = w) + F | 0, f = KI(F = (r = s + Y | 0) ^ t, f ^ (t = r >>> 0 < s >>> 0 ? E + 1 | 0 : E), 48), E = KI(f ^ n, (E = l) ^ (l = w), 32), $ = n = w, F = E, Y = e, e = c, E = KI(h ^ k, d ^ IA, 1), M = c = w, h = E, E = G + kA | 0, E = ((k = K + eA | 0) >>> 0 < eA >>> 0 ? E + 1 | 0 : E) + c | 0, k = E = (c = h + k | 0) >>> 0 < k >>> 0 ? E + 1 | 0 : E, e = KI(c ^ e, E ^ b, 32), E = (E = Y) + (Y = w) | 0, h = KI((_ = e + _ | 0) ^ h, M ^ (d = _ >>> 0 < e >>> 0 ? E + 1 | 0 : E), 40), E = k + (IA = w) | 0, K = h, E = NA + ((G = c) >>> 0 > (c = c + h | 0) >>> 0 ? E + 1 | 0 : E) | 0, G = E = (h = c + iA | 0) >>> 0 < iA >>> 0 ? E + 1 | 0 : E, c = KI(e ^ h, Y ^ E, 48), E = d + (CA = w) | 0, b = _, e = c, d = _ = _ + c | 0, Y = E = b >>> 0 > _ >>> 0 ? E + 1 | 0 : E, E = E + n | 0, b = E = (n = _ + F | 0) >>> 0 < _ >>> 0 ? E + 1 | 0 : E, _ = (k = KI(n ^ x, E ^ L, 40)) + MA | 0, E = (MA = w) + J | 0, M = _, V = _ >>> 0 < k >>> 0 ? E + 1 | 0 : E, _ = KI(U ^ O, v ^ hA, 48), E = (U = w) + q | 0, H = c = _ + H | 0, x = S, S = E = c >>> 0 < _ >>> 0 ? E + 1 | 0 : E, E = KI(c ^ y, x ^ E, 1), O = c = w, y = E, E = t + C | 0, E = ((r = r + pA | 0) >>> 0 < pA >>> 0 ? E + 1 | 0 : E) + c | 0, E = fA + (r = (c = r + y | 0) >>> 0 < r >>> 0 ? E + 1 | 0 : E) | 0, v = t = c + Z | 0, t = E = t >>> 0 < Z >>> 0 ? E + 1 | 0 : E, c = KI(c ^ e, r ^ CA, 32), E = W + (J = w) | 0, q = c, c = (e = p + c | 0) ^ y, y = E = e >>> 0 < p >>> 0 ? E + 1 | 0 : E, r = KI(c, O ^ E, 40), E = (E = t) + (t = w) | 0, O = c = r + v | 0, c = KI(p = c ^ q, J ^ (q = c >>> 0 < r >>> 0 ? E + 1 | 0 : E), 48), E = y + (CA = w) | 0, W = c, e = E = (c = e + c | 0) >>> 0 < e >>> 0 ? E + 1 | 0 : E, r = KI(c ^ r, t ^ E, 1), E = (p = w) + V | 0, E = wA + ((t = r + M | 0) >>> 0 < r >>> 0 ? E + 1 | 0 : E) | 0, E = (y = (t = t + EA | 0) >>> 0 < EA >>> 0 ? E + 1 | 0 : E) + BA | 0, AA = v = t + j | 0, v = E = v >>> 0 < t >>> 0 ? E + 1 | 0 : E, J = r, x = t, L = y, r = KI(K ^ d, Y ^ IA, 1), E = (Y = w) + sA | 0, E = m + (r >>> 0 > (t = r + gA | 0) >>> 0 ? E + 1 | 0 : E) | 0, y = E = (t = t + D | 0) >>> 0 < D >>> 0 ? E + 1 | 0 : E, E = KI(_ ^ t, E ^ U, 32), U = _ = w, D = E, E = N + l | 0, E = (_ = f + u | 0) >>> 0 < f >>> 0 ? E + 1 | 0 : E, f = _, d = E, E = U + E | 0, N = _ = _ + D | 0, K = E = f >>> 0 > _ >>> 0 ? E + 1 | 0 : E, _ = KI(_ ^ r, Y ^ E, 40), E = y + (l = w) | 0, u = _, E = tA + ((_ = t + _ | 0) >>> 0 < t >>> 0 ? E + 1 | 0 : E) | 0, E = (_ = _ + z | 0) >>> 0 < z >>> 0 ? E + 1 | 0 : E, Y = _, _ ^= D, D = E, y = KI(_, U ^ E, 48), E = KI(y ^ x, (E = L) ^ (L = w), 32), IA = _ = w, U = E, m = _, _ = KI(s ^ f, d ^ T, 1), E = kA + (t = w) | 0, E = G + ((r = _ + eA | 0) >>> 0 < eA >>> 0 ? E + 1 | 0 : E) | 0, E = (s = (r = r + h | 0) >>> 0 < h >>> 0 ? E + 1 | 0 : E) + P | 0, G = f = r + aA | 0, f = E = f >>> 0 < r >>> 0 ? E + 1 | 0 : E, h = _, d = t, _ = (r = KI(r ^ R, s ^ nA, 32)) + H | 0, E = (H = w) + S | 0, t = _, s = KI(s = _ ^ h, (h = _ >>> 0 < r >>> 0 ? E + 1 | 0 : E) ^ d, 40), E = (T = w) + f | 0, f = _ = s + G | 0, r = KI(_ ^ r, H ^ (S = _ >>> 0 < s >>> 0 ? E + 1 | 0 : E), 48), E = h + (d = w) | 0, G = _ = r + t | 0, H = E = _ >>> 0 < t >>> 0 ? E + 1 | 0 : E, E = E + m | 0, m = E = (h = _ + U | 0) >>> 0 < _ >>> 0 ? E + 1 | 0 : E, t = KI(h ^ J, E ^ p, 40), E = (R = w) + v | 0, v = _ = t + AA | 0, J = E = _ >>> 0 < t >>> 0 ? E + 1 | 0 : E, _ = c, p = e, e = r, c = KI(F ^ M, V ^ $, 48), E = b + (AA = w) | 0, F = c, n = E = (r = n + c | 0) >>> 0 < n >>> 0 ? E + 1 | 0 : E, E = KI(r ^ k, MA ^ E, 1), b = c = w, k = E, E = D + SA | 0, E = ((D = Y + cA | 0) >>> 0 < cA >>> 0 ? E + 1 | 0 : E) + c | 0, D = E = (c = D + k | 0) >>> 0 < D >>> 0 ? E + 1 | 0 : E, e = KI(c ^ e, E ^ d, 32), E = (Y = w) + p | 0, k = KI((_ = e + _ | 0) ^ k, b ^ (p = _ >>> 0 < e >>> 0 ? E + 1 | 0 : E), 40), E = D + (M = w) | 0, E = FA + ((D = c) >>> 0 > (c = c + k | 0) >>> 0 ? E + 1 | 0 : E) | 0, d = E = (D = c + QA | 0) >>> 0 < QA >>> 0 ? E + 1 | 0 : E, c = KI(e ^ D, Y ^ E, 48), E = p + ($ = w) | 0, Y = c, b = E = (p = _ + c | 0) >>> 0 < _ >>> 0 ? E + 1 | 0 : E, _ = KI(p ^ k, M ^ E, 1), E = (k = w) + J | 0, E = DA + ((c = _ + v | 0) >>> 0 < _ >>> 0 ? E + 1 | 0 : E) | 0, E = wA + (e = (c = c + oA | 0) >>> 0 < oA >>> 0 ? E + 1 | 0 : E) | 0, hA = M = c + EA | 0, M = E = M >>> 0 < EA >>> 0 ? E + 1 | 0 : E, V = _, x = c, _ = KI(s ^ G, H ^ T, 1), E = (s = w) + q | 0, E = GA + ((c = _ + O | 0) >>> 0 < _ >>> 0 ? E + 1 | 0 : E) | 0, E = NA + (G = (c = c + _A | 0) >>> 0 < _A >>> 0 ? E + 1 | 0 : E) | 0, O = H = c + iA | 0, H = E = H >>> 0 < iA >>> 0 ? E + 1 | 0 : E, q = _, E = KI(c ^ F, G ^ AA, 32), AA = _ = w, c = E, E = K + L | 0, N = _ = y + N | 0, F = E = _ >>> 0 < y >>> 0 ? E + 1 | 0 : E, E = AA + E | 0, K = E = (y = _ + c | 0) >>> 0 < _ >>> 0 ? E + 1 | 0 : E, s = KI(y ^ q, E ^ s, 40), E = (L = w) + H | 0, G = _ = s + O | 0, q = KI(_ ^ c, AA ^ (H = _ >>> 0 < s >>> 0 ? E + 1 | 0 : E), 48), E = KI(q ^ x, (AA = w) ^ e, 32), T = _ = w, O = E, e = _, c = rA, _ = KI(N ^ u, F ^ l, 1), E = S + (F = w) | 0, E = ((N = f) >>> 0 > (f = _ + f | 0) >>> 0 ? E + 1 | 0 : E) + yA | 0, E = DA + (f = (c = c + f | 0) >>> 0 < f >>> 0 ? E + 1 | 0 : E) | 0, N = S = c + oA | 0, S = E = S >>> 0 < oA >>> 0 ? E + 1 | 0 : E, c = KI(c ^ W, f ^ CA, 32), E = n + (u = w) | 0, n = c, E = (c = r + c | 0) >>> 0 < r >>> 0 ? E + 1 | 0 : E, r = F, F = E, r = KI(_ ^ c, r ^ E, 40), E = (l = w) + S | 0, f = _ = r + N | 0, _ = KI(_ ^ n, u ^ (S = _ >>> 0 < r >>> 0 ? E + 1 | 0 : E), 48), E = F + (x = w) | 0, F = _, N = _ = c + _ | 0, u = E = _ >>> 0 < c >>> 0 ? E + 1 | 0 : E, E = E + e | 0, E = (n = _ + O | 0) >>> 0 < _ >>> 0 ? E + 1 | 0 : E, _ = n ^ V, V = E, k = KI(_, E ^ k, 40), E = (CA = w) + M | 0, M = _ = k + hA | 0, W = _ >>> 0 < k >>> 0 ? E + 1 | 0 : E, _ = KI(U ^ v, J ^ IA, 48), E = m + (IA = w) | 0, U = _, E = (_ = h + _ | 0) >>> 0 < h >>> 0 ? E + 1 | 0 : E, h = _, m = E, E = KI(_ ^ t, E ^ R, 1), R = _ = w, e = E, E = H + fA | 0, E = ((c = G + Z | 0) >>> 0 < Z >>> 0 ? E + 1 | 0 : E) + _ | 0, E = FA + (c = (_ = c + e | 0) >>> 0 < c >>> 0 ? E + 1 | 0 : E) | 0, G = t = _ + QA | 0, t = E = t >>> 0 < QA >>> 0 ? E + 1 | 0 : E, _ = KI(_ ^ F, c ^ x, 32), E = b + (H = w) | 0, F = _, p = E = (c = p + _ | 0) >>> 0 < p >>> 0 ? E + 1 | 0 : E, e = KI(c ^ e, R ^ E, 40), E = (R = w) + t | 0, G = _ = e + G | 0, _ = KI(t = _ ^ F, H ^ (F = _ >>> 0 < e >>> 0 ? E + 1 | 0 : E), 48), E = p + (hA = w) | 0, p = _, b = E = (t = c + _ | 0) >>> 0 < c >>> 0 ? E + 1 | 0 : E, _ = KI(t ^ e, R ^ E, 1), E = (H = w) + W | 0, E = kA + ((c = _ + M | 0) >>> 0 < _ >>> 0 ? E + 1 | 0 : E) | 0, E = (e = (c = c + eA | 0) >>> 0 < eA >>> 0 ? E + 1 | 0 : E) + sA | 0, nA = R = c + gA | 0, R = E = R >>> 0 < c >>> 0 ? E + 1 | 0 : E, v = _, J = c, x = e, _ = KI(r ^ N, l ^ u, 1), E = GA + (e = w) | 0, E = d + ((c = _ + _A | 0) >>> 0 < _A >>> 0 ? E + 1 | 0 : E) | 0, E = SA + (r = (c = c + D | 0) >>> 0 < D >>> 0 ? E + 1 | 0 : E) | 0, u = D = c + cA | 0, D = E = D >>> 0 < cA >>> 0 ? E + 1 | 0 : E, d = _, N = e, E = KI(c ^ U, r ^ IA, 32), U = _ = w, r = E, c = _, E = K + AA | 0, E = (_ = y + q | 0) >>> 0 < y >>> 0 ? E + 1 | 0 : E, y = _, K = E, E = E + c | 0, E = (e = _ + r | 0) >>> 0 < _ >>> 0 ? E + 1 | 0 : E, _ = e ^ d, d = E, _ = KI(_, E ^ N, 40), E = (E = D) + (D = w) | 0, N = c = _ + u | 0, u = E = c >>> 0 < _ >>> 0 ? E + 1 | 0 : E, U = KI(c ^ r, U ^ E, 48), E = KI(U ^ J, (E = x) ^ (x = w), 32), l = c = w, q = E, c = KI(y ^ s, K ^ L, 1), E = (y = w) + yA | 0, E = S + ((r = c + rA | 0) >>> 0 < c >>> 0 ? E + 1 | 0 : E) | 0, E = C + (s = (r = r + f | 0) >>> 0 < f >>> 0 ? E + 1 | 0 : E) | 0, L = f = r + pA | 0, f = E = f >>> 0 < pA >>> 0 ? E + 1 | 0 : E, S = c, K = y, r = KI(r ^ Y, s ^ $, 32), E = (Y = w) + m | 0, y = c = r + h | 0, c = (s = KI(c ^ S, (h = c >>> 0 < r >>> 0 ? E + 1 | 0 : E) ^ K, 40)) + L | 0, E = (L = w) + f | 0, S = c, c = KI(c ^ r, Y ^ (K = c >>> 0 < s >>> 0 ? E + 1 | 0 : E), 48), E = h + (AA = w) | 0, Y = c, m = c = y + c | 0, J = E = c >>> 0 < y >>> 0 ? E + 1 | 0 : E, E = l + E | 0, E = (r = c + q | 0) >>> 0 < c >>> 0 ? E + 1 | 0 : E, c = H, H = E, y = KI(r ^ v, c ^ E, 40), E = (IA = w) + R | 0, f = c = y + nA | 0, E = KI(c ^ q, l ^ (R = c >>> 0 < y >>> 0 ? E + 1 | 0 : E), 48), l = c = w, q = E, c = _, E = d + x | 0, d = _ = e + U | 0, U = E = _ >>> 0 < e >>> 0 ? E + 1 | 0 : E, E = KI(_ ^ c, E ^ D, 1), e = c = w, _ = E, E = K + B | 0, E = ((h = S + g | 0) >>> 0 < g >>> 0 ? E + 1 | 0 : E) + c | 0, E = tA + (h = (c = _ + h | 0) >>> 0 < h >>> 0 ? E + 1 | 0 : E) | 0, x = D = c + z | 0, D = E = D >>> 0 < z >>> 0 ? E + 1 | 0 : E, S = _, K = e, _ = KI(M ^ O, W ^ T, 48), E = V + (T = w) | 0, M = _, E = (_ = n + _ | 0) >>> 0 < n >>> 0 ? E + 1 | 0 : E, n = _, c = KI(c ^ p, h ^ hA, 32), V = E, E = E + (O = w) | 0, e = _ = c + _ | 0, h = KI(_ ^ S, (p = _ >>> 0 < c >>> 0 ? E + 1 | 0 : E) ^ K, 40), E = (W = w) + D | 0, D = _ = h + x | 0, _ = KI(_ ^ c, O ^ (S = _ >>> 0 < h >>> 0 ? E + 1 | 0 : E), 48), E = p + ($ = w) | 0, K = _, O = E = (p = e + _ | 0) >>> 0 < e >>> 0 ? E + 1 | 0 : E, _ = KI(h ^ p, W ^ E, 1), E = FA + (x = w) | 0, W = _, hA = _ = QA + _ | 0, e = E = _ >>> 0 < QA >>> 0 ? E + 1 | 0 : E, _ = KI(k ^ n, V ^ CA, 1), E = (h = w) + u | 0, E = NA + ((c = _ + N | 0) >>> 0 < _ >>> 0 ? E + 1 | 0 : E) | 0, E = BA + (n = (c = c + iA | 0) >>> 0 < iA >>> 0 ? E + 1 | 0 : E) | 0, V = k = c + j | 0, k = E = k >>> 0 < j >>> 0 ? E + 1 | 0 : E, N = h, c = KI(c ^ Y, n ^ AA, 32), E = b + (AA = w) | 0, u = c, E = (h = t + c | 0) >>> 0 < t >>> 0 ? E + 1 | 0 : E, t = N, N = E, n = KI(_ ^ h, t ^ E, 40), E = (CA = w) + k | 0, Y = _ = n + V | 0, E = (b = _ >>> 0 < n >>> 0 ? E + 1 | 0 : E) + e | 0, k = E = (e = _ + hA | 0) >>> 0 < _ >>> 0 ? E + 1 | 0 : E, V = E = KI(e ^ q, E ^ l, 32), v = _ = w, _ = KI(s ^ m, J ^ L, 1), E = (t = w) + F | 0, E = X + ((c = _ + G | 0) >>> 0 < _ >>> 0 ? E + 1 | 0 : E) | 0, E = (s = (c = I + c | 0) >>> 0 < I >>> 0 ? E + 1 | 0 : E) + P | 0, J = F = c + aA | 0, F = E = F >>> 0 < c >>> 0 ? E + 1 | 0 : E, G = _, m = t, c = KI(c ^ M, s ^ T, 32), E = (M = w) + U | 0, t = _ = c + d | 0, _ = (s = KI(_ ^ G, (d = _ >>> 0 < c >>> 0 ? E + 1 | 0 : E) ^ m, 40)) + J | 0, E = (J = w) + F | 0, F = _, _ = KI(_ ^ c, M ^ (G = _ >>> 0 < s >>> 0 ? E + 1 | 0 : E), 48), E = d + (T = w) | 0, d = _, M = E = (_ = t + _ | 0) >>> 0 < t >>> 0 ? E + 1 | 0 : E, E = E + v | 0, U = E = (t = _) >>> 0 > (_ = _ + V | 0) >>> 0 ? E + 1 | 0 : E, c = KI(_ ^ W, x ^ E, 40), E = k + (x = w) | 0, m = c, E = B + ((c = e + c | 0) >>> 0 < e >>> 0 ? E + 1 | 0 : E) | 0, W = c = c + g | 0, e = c ^ V, V = E = c >>> 0 < g >>> 0 ? E + 1 | 0 : E, c = KI(e, v ^ E, 48), E = U + (v = w) | 0, U = E = (k = _ + c | 0) >>> 0 < _ >>> 0 ? E + 1 | 0 : E, _ = E = KI(k ^ m, x ^ E, 1), m = e = w, e = KI(t ^ s, M ^ J, 1), E = S + (s = w) | 0, E = NA + ((t = e + D | 0) >>> 0 < D >>> 0 ? E + 1 | 0 : E) | 0, E = DA + (D = (t = t + iA | 0) >>> 0 < iA >>> 0 ? E + 1 | 0 : E) | 0, x = S = t + oA | 0, S = E = S >>> 0 < oA >>> 0 ? E + 1 | 0 : E, M = e, J = s, E = H + l | 0, E = (e = r + q | 0) >>> 0 < r >>> 0 ? E + 1 | 0 : E, H = e, u = KI(Y ^ u, b ^ AA, 48), s = KI(t ^ u, D ^ (AA = w), 32), Y = E, E = E + (hA = w) | 0, D = e = s + e | 0, e = KI(e ^ M, (b = e >>> 0 < s >>> 0 ? E + 1 | 0 : E) ^ J, 40), E = (M = w) + S | 0, J = E = (r = e + x | 0) >>> 0 < e >>> 0 ? E + 1 | 0 : E, E = E + m | 0, E = C + ((q = r) >>> 0 > (r = _ + r | 0) >>> 0 ? E + 1 | 0 : E) | 0, E = (t = (r = r + pA | 0) >>> 0 < pA >>> 0 ? E + 1 | 0 : E) + yA | 0, nA = S = r + rA | 0, x = E = S >>> 0 < r >>> 0 ? E + 1 | 0 : E, L = _, l = r, E = KI(y ^ H, Y ^ IA, 1), y = r = w, _ = E, E = G + GA | 0, E = ((S = F + _A | 0) >>> 0 < _A >>> 0 ? E + 1 | 0 : E) + r | 0, E = tA + (S = (r = _ + S | 0) >>> 0 < S >>> 0 ? E + 1 | 0 : E) | 0, Y = F = r + z | 0, F = E = F >>> 0 < z >>> 0 ? E + 1 | 0 : E, G = _, E = KI(r ^ K, S ^ $, 32), H = _ = w, r = E, S = _, E = N + AA | 0, N = _ = h + u | 0, K = E = _ >>> 0 < h >>> 0 ? E + 1 | 0 : E, E = E + S | 0, E = (h = _ + r | 0) >>> 0 < _ >>> 0 ? E + 1 | 0 : E;
                                        _ = h ^ G, G = E, S = KI(_, E ^ y, 40), E = (AA = w) + F | 0, u = KI(F = (_ = S + Y | 0) ^ r, H ^ (r = _ >>> 0 < S >>> 0 ? E + 1 | 0 : E), 48), E = KI(E = u ^ l, (l = w) ^ t, 32), IA = t = w, Y = E, F = t, t = KI(n ^ N, K ^ CA, 1), E = BA + (n = w) | 0, E = R + ((y = t + j | 0) >>> 0 < j >>> 0 ? E + 1 | 0 : E) | 0, E = kA + (f = (y = y + f | 0) >>> 0 < f >>> 0 ? E + 1 | 0 : E) | 0, K = N = y + eA | 0, N = E = N >>> 0 < eA >>> 0 ? E + 1 | 0 : E, y = KI(y ^ d, f ^ T, 32), E = O + (H = w) | 0, d = y, p = E = (y = p + y | 0) >>> 0 < p >>> 0 ? E + 1 | 0 : E, f = KI(t ^ y, E ^ n, 40), E = (T = w) + N | 0, n = t = f + K | 0, t = KI(N = t ^ d, H ^ (d = t >>> 0 < f >>> 0 ? E + 1 | 0 : E), 48), E = p + ($ = w) | 0, N = t, K = t = y + t | 0, H = E = t >>> 0 < y >>> 0 ? E + 1 | 0 : E, E = E + F | 0, E = (y = t + Y | 0) >>> 0 < t >>> 0 ? E + 1 | 0 : E, t = m, m = E, p = KI(y ^ L, t ^ E, 40), E = (R = w) + x | 0, F = t = p + nA | 0, t = KI(x = t ^ Y, IA ^ (Y = t >>> 0 < p >>> 0 ? E + 1 | 0 : E), 48), E = m + (IA = w) | 0, m = t, y = E = (t = y + t | 0) >>> 0 < y >>> 0 ? E + 1 | 0 : E, R = E = KI(t ^ p, R ^ E, 1), CA = E, O = p = w, p = r, r = e, e = KI(s ^ q, J ^ hA, 48), E = b + (hA = w) | 0, b = e, E = (e = D + e | 0) >>> 0 < D >>> 0 ? E + 1 | 0 : E, D = _, _ = r ^ e, r = E, _ = KI(_, E ^ M, 1), E = (M = w) + p | 0, E = SA + (_ >>> 0 > (s = D + _ | 0) >>> 0 ? E + 1 | 0 : E) | 0, E = sA + (D = (s = s + cA | 0) >>> 0 < cA >>> 0 ? E + 1 | 0 : E) | 0, q = p = s + gA | 0, p = E = p >>> 0 < gA >>> 0 ? E + 1 | 0 : E, s = KI(s ^ N, D ^ $, 32), E = U + (J = w) | 0, N = E = (D = s + k | 0) >>> 0 < k >>> 0 ? E + 1 | 0 : E, k = KI(_ ^ D, M ^ E, 40), E = ($ = w) + p | 0, M = _ = k + q | 0, s = KI(_ ^ s, J ^ (U = _ >>> 0 < k >>> 0 ? E + 1 | 0 : E), 48), E = N + (q = w) | 0, J = _ = s + D | 0, N = _, x = E = _ >>> 0 < D >>> 0 ? E + 1 | 0 : E, D = e, p = r, E = G + l | 0, E = (_ = h + u | 0) >>> 0 < h >>> 0 ? E + 1 | 0 : E, h = _, _ ^= S, S = E, E = KI(_, AA ^ E, 1), L = _ = w, G = E, r = E, E = d + P | 0, E = ((e = n + aA | 0) >>> 0 < aA >>> 0 ? E + 1 | 0 : E) + _ | 0, n = E = (_ = e) >>> 0 > (e = r + e | 0) >>> 0 ? E + 1 | 0 : E, r = KI(c ^ e, E ^ v, 32), E = (E = p) + (p = w) | 0, u = _ = r + D | 0, c = KI(c = _ ^ G, L ^ (G = _ >>> 0 < r >>> 0 ? E + 1 | 0 : E), 40), E = n + (v = w) | 0, E = fA + ((_ = c + e | 0) >>> 0 < e >>> 0 ? E + 1 | 0 : E) | 0, L = E = (D = _ + Z | 0) >>> 0 < Z >>> 0 ? E + 1 | 0 : E, p = KI(r ^ D, p ^ E, 48), nA = E = w, _ = KI(f ^ K, H ^ T, 1), E = (r = w) + V | 0, E = wA + ((e = _ + W | 0) >>> 0 < _ >>> 0 ? E + 1 | 0 : E) | 0, E = X + (f = (e = e + EA | 0) >>> 0 < EA >>> 0 ? E + 1 | 0 : E) | 0, V = n = I + e | 0, K = E = n >>> 0 < I >>> 0 ? E + 1 | 0 : E, H = _, n = KI(e ^ b, f ^ hA, 32), E = (T = w) + S | 0, S = _ = n + h | 0, e = KI(_ ^ H, (b = _ >>> 0 < n >>> 0 ? E + 1 | 0 : E) ^ r, 40), E = (E = K) + (K = w) | 0, H = _ = e + V | 0, V = E = _ >>> 0 < e >>> 0 ? E + 1 | 0 : E, r = E, E = X + O | 0, E = ((f = I + R | 0) >>> 0 < I >>> 0 ? E + 1 | 0 : E) + r | 0, d = E = (r = _ + f | 0) >>> 0 < f >>> 0 ? E + 1 | 0 : E, _ = KI(r ^ p, nA ^ E, 32), E = (R = w) + x | 0, h = KI((f = _ + N | 0) ^ CA, (E = f >>> 0 < _ >>> 0 ? E + 1 | 0 : E) ^ O, 40), O = E, E = sA + (N = w) | 0, E = d + ((W = h + gA | 0) >>> 0 < gA >>> 0 ? E + 1 | 0 : E) | 0, E = (d = r + W | 0) >>> 0 < r >>> 0 ? E + 1 | 0 : E, r = R, R = E, r = KI(_ ^ d, r ^ E, 48), E = (E = O) + (O = w) | 0, _ = h ^ (f = r + f | 0), h = E = f >>> 0 < r >>> 0 ? E + 1 | 0 : E, W = E = KI(_, E ^ N, 1), CA = E, l = _ = w, N = t, AA = y, t = e, e = KI(n ^ H, V ^ T, 48), E = b + (H = w) | 0, n = _ = e + S | 0, S = E = _ >>> 0 < S >>> 0 ? E + 1 | 0 : E, t = KI(_ ^ t, E ^ K, 1), E = (V = w) + SA | 0, E = L + ((_ = t + cA | 0) >>> 0 < t >>> 0 ? E + 1 | 0 : E) | 0, D = E = (y = _ + D | 0) >>> 0 < D >>> 0 ? E + 1 | 0 : E, _ = KI(y ^ s, E ^ q, 32), E = (K = w) + AA | 0, N = s = _ + N | 0, b = E = s >>> 0 < _ >>> 0 ? E + 1 | 0 : E, t = KI(t ^ s, E ^ V, 40), E = DA + (hA = w) | 0, V = t, E = D + ((t = oA + t | 0) >>> 0 < oA >>> 0 ? E + 1 | 0 : E) | 0, y = E = (t = t + y | 0) >>> 0 < y >>> 0 ? E + 1 | 0 : E, s = KI(_ ^ t, E ^ K, 48), E = (E = b) + (b = w) | 0, q = _ = s + N | 0, K = _, L = E = _ >>> 0 < s >>> 0 ? E + 1 | 0 : E, E = G + nA | 0, N = (_ = p + u | 0) ^ c, c = E = _ >>> 0 < p >>> 0 ? E + 1 | 0 : E, E = KI(N, E ^ v, 1), v = D = w, N = E, E = U + tA | 0, E = ((p = M + z | 0) >>> 0 < z >>> 0 ? E + 1 | 0 : E) + D | 0, G = E = (G = p) >>> 0 > (p = p + N | 0) >>> 0 ? E + 1 | 0 : E, u = D = KI(p ^ m, IA ^ E, 32), M = E = w, E = E + S | 0, U = D = D + n | 0, m = E = u >>> 0 > D >>> 0 ? E + 1 | 0 : E, D = KI(D ^ N, v ^ E, 40), E = yA + (v = w) | 0, E = G + ((n = D + rA | 0) >>> 0 < rA >>> 0 ? E + 1 | 0 : E) | 0, n = E = (N = p) >>> 0 > (p = p + n | 0) >>> 0 ? E + 1 | 0 : E, N = KI(p ^ u, E ^ M, 48), IA = E = w, S = E, k = KI(k ^ J, x ^ $, 1), G = E = w, u = e, E = E + P | 0, E = Y + ((e = k + aA | 0) >>> 0 < aA >>> 0 ? E + 1 | 0 : E) | 0, E = (e = e + F | 0) >>> 0 < F >>> 0 ? E + 1 | 0 : E, F = e ^ u, u = E, F = KI(F, E ^ H, 32), E = ($ = w) + c | 0, Y = _ = F + _ | 0, c = KI(_ ^ k, (c = G) ^ (G = _ >>> 0 < F >>> 0 ? E + 1 | 0 : E), 40), E = wA + (M = w) | 0, E = u + ((_ = c + EA | 0) >>> 0 < EA >>> 0 ? E + 1 | 0 : E) | 0, u = _ = _ + e | 0, H = E = _ >>> 0 < e >>> 0 ? E + 1 | 0 : E, e = E, E = l + NA | 0, E = ((k = W + iA | 0) >>> 0 < iA >>> 0 ? E + 1 | 0 : E) + e | 0, W = E = (e = _ + k | 0) >>> 0 < k >>> 0 ? E + 1 | 0 : E, _ = KI(e ^ N, E ^ S, 32), E = (J = w) + L | 0, S = KI((k = _ + K | 0) ^ CA, (E = k >>> 0 < _ >>> 0 ? E + 1 | 0 : E) ^ l, 40), x = K = w, l = E, E = K + kA | 0, E = W + ((K = S + eA | 0) >>> 0 < eA >>> 0 ? E + 1 | 0 : E) | 0, W = E = (K = e + K | 0) >>> 0 < e >>> 0 ? E + 1 | 0 : E, e = KI(_ ^ K, E ^ J, 48), E = (J = w) + l | 0, _ = (k = e + k | 0) ^ S, S = E = k >>> 0 < e >>> 0 ? E + 1 | 0 : E, x = E = KI(_, E ^ x, 1), l = _ = w, AA = f, T = s, s = c, c = KI(F ^ u, H ^ $, 48), E = (F = w) + G | 0, G = _ = c + Y | 0, u = E = _ >>> 0 < c >>> 0 ? E + 1 | 0 : E, s = KI(_ ^ s, E ^ M, 1), E = (M = w) + FA | 0, E = ((_ = s + QA | 0) >>> 0 < s >>> 0 ? E + 1 | 0 : E) + n | 0, p = E = (f = _ + p | 0) >>> 0 < _ >>> 0 ? E + 1 | 0 : E, _ = KI(f ^ T, E ^ b, 32), E = (n = w) + h | 0, Y = h = _ + AA | 0, b = E = h >>> 0 < _ >>> 0 ? E + 1 | 0 : E, s = KI(s ^ h, E ^ M, 40), E = C + (T = w) | 0, M = s, E = p + ((s = pA + s | 0) >>> 0 < pA >>> 0 ? E + 1 | 0 : E) | 0, H = E = (h = s + f | 0) >>> 0 < f >>> 0 ? E + 1 | 0 : E, s = KI(_ ^ h, E ^ n, 48), E = (E = b) + (b = w) | 0, Y = _ = s + Y | 0, AA = E = _ >>> 0 < s >>> 0 ? E + 1 | 0 : E, p = r, f = t, E = m + IA | 0, r = E = (_ = N + U | 0) >>> 0 < N >>> 0 ? E + 1 | 0 : E, t = KI(_ ^ D, E ^ v, 1), E = (D = w) + BA | 0, E = ((n = t + j | 0) >>> 0 < t >>> 0 ? E + 1 | 0 : E) + y | 0, y = KI(p ^ (f = f + n | 0), (E = f >>> 0 < n >>> 0 ? E + 1 | 0 : E) ^ O, 32), n = E, N = t, E = (p = w) + u | 0, E = (t = y + G | 0) >>> 0 < y >>> 0 ? E + 1 | 0 : E, G = t, t ^= N, N = E, t = KI(t, E ^ D, 40), E = B + (u = w) | 0, E = ((D = t + g | 0) >>> 0 < g >>> 0 ? E + 1 | 0 : E) + n | 0, U = E = (n = D) >>> 0 > (D = D + f | 0) >>> 0 ? E + 1 | 0 : E, p = KI(y ^ D, E ^ p, 48), IA = E = w, f = E, y = KI(q ^ V, L ^ hA, 1), m = E = w, V = r, E = E + fA | 0, E = R + ((r = y + Z | 0) >>> 0 < Z >>> 0 ? E + 1 | 0 : E) | 0, n = F, F = E = (r = r + d | 0) >>> 0 < d >>> 0 ? E + 1 | 0 : E, n = KI(c ^ r, n ^ E, 32), E = ($ = w) + V | 0, d = _ = n + _ | 0, c = KI(_ ^ y, (c = m) ^ (m = _ >>> 0 < n >>> 0 ? E + 1 | 0 : E), 40), E = GA + (V = w) | 0, E = F + ((_ = c + _A | 0) >>> 0 < _A >>> 0 ? E + 1 | 0 : E) | 0, R = _ = _ + r | 0, q = E = _ >>> 0 < r >>> 0 ? E + 1 | 0 : E, r = E, E = l + tA | 0, E = ((y = z + x | 0) >>> 0 < z >>> 0 ? E + 1 | 0 : E) + r | 0, F = E = (r = _ + y | 0) >>> 0 < y >>> 0 ? E + 1 | 0 : E, _ = KI(r ^ p, E ^ f, 32), E = (O = w) + AA | 0, f = KI((y = _ + Y | 0) ^ x, (E = y >>> 0 < _ >>> 0 ? E + 1 | 0 : E) ^ l, 40), x = E, E = P + (v = w) | 0, E = F + ((L = f + aA | 0) >>> 0 < aA >>> 0 ? E + 1 | 0 : E) | 0, E = (F = r + L | 0) >>> 0 < r >>> 0 ? E + 1 | 0 : E, r = O, O = E, r = KI(_ ^ F, r ^ E, 48), E = (E = x) + (x = w) | 0, _ = (y = r + y | 0) ^ f, f = E = y >>> 0 < r >>> 0 ? E + 1 | 0 : E, v = E = KI(_, E ^ v, 1), L = _ = w, l = s, s = c, c = KI(n ^ R, q ^ $, 48), E = (E = m) + (m = w) | 0, d = _ = c + d | 0, n = V, V = E = _ >>> 0 < c >>> 0 ? E + 1 | 0 : E, s = KI(_ ^ s, n ^ E, 1), E = (R = w) + kA | 0, E = U + ((_ = s + eA | 0) >>> 0 < s >>> 0 ? E + 1 | 0 : E) | 0, n = D, D = _ + D | 0, _ = b, b = E = n >>> 0 > D >>> 0 ? E + 1 | 0 : E, _ = KI(D ^ l, _ ^ E, 32), E = (E = S) + (S = w) | 0, U = E = (n = _ + k | 0) >>> 0 < _ >>> 0 ? E + 1 | 0 : E, k = n, s = KI(s ^ n, E ^ R, 40), E = fA + ($ = w) | 0, R = s, E = b + ((s = Z + s | 0) >>> 0 < Z >>> 0 ? E + 1 | 0 : E) | 0, b = E = (n = s + D | 0) >>> 0 < D >>> 0 ? E + 1 | 0 : E, s = KI(_ ^ n, E ^ S, 48), E = (E = U) + (U = w) | 0, q = _ = s + k | 0, l = E = _ >>> 0 < s >>> 0 ? E + 1 | 0 : E, k = e, E = N + IA | 0, e = E = (_ = p + G | 0) >>> 0 < p >>> 0 ? E + 1 | 0 : E, t = KI(_ ^ t, E ^ u, 1), E = sA + (p = w) | 0, E = H + ((D = t + gA | 0) >>> 0 < gA >>> 0 ? E + 1 | 0 : E) | 0, N = (D = h + D | 0) ^ k, k = E = D >>> 0 < h >>> 0 ? E + 1 | 0 : E, h = KI(N, E ^ J, 32), S = E = w, N = t, E = E + V | 0, E = (t = h + d | 0) >>> 0 < h >>> 0 ? E + 1 | 0 : E, G = t, t ^= N, N = E, t = KI(t, E ^ p, 40), E = B + (u = w) | 0, E = k + ((p = t + g | 0) >>> 0 < g >>> 0 ? E + 1 | 0 : E) | 0, H = E = (p = D + p | 0) >>> 0 < D >>> 0 ? E + 1 | 0 : E, k = KI(h ^ p, E ^ S, 48), IA = E = w, D = E, h = KI(M ^ Y, T ^ AA, 1), d = E = w, Y = e, E = E + C | 0, E = W + ((e = h + pA | 0) >>> 0 < pA >>> 0 ? E + 1 | 0 : E) | 0, K = E = (e = e + K | 0) >>> 0 < K >>> 0 ? E + 1 | 0 : E, S = KI(c ^ e, E ^ m, 32), E = (CA = w) + Y | 0, Y = _ = S + _ | 0, c = KI(_ ^ h, (M = _ >>> 0 < S >>> 0 ? E + 1 | 0 : E) ^ d, 40), E = X + (m = w) | 0, E = K + ((_ = I + c | 0) >>> 0 < I >>> 0 ? E + 1 | 0 : E) | 0, K = _ = _ + e | 0, V = E = _ >>> 0 < e >>> 0 ? E + 1 | 0 : E, e = E, E = L + wA | 0, E = ((h = v + EA | 0) >>> 0 < EA >>> 0 ? E + 1 | 0 : E) + e | 0, d = E = (e = _ + h | 0) >>> 0 < h >>> 0 ? E + 1 | 0 : E, _ = KI(e ^ k, E ^ D, 32), E = (W = w) + l | 0, D = KI((h = _ + q | 0) ^ v, (E = h >>> 0 < _ >>> 0 ? E + 1 | 0 : E) ^ L, 40), J = E, E = SA + (v = w) | 0, E = d + ((L = D + cA | 0) >>> 0 < cA >>> 0 ? E + 1 | 0 : E) | 0, E = (d = e + L | 0) >>> 0 < e >>> 0 ? E + 1 | 0 : E, e = W, W = E, e = KI(_ ^ d, e ^ E, 48), E = (E = J) + (J = w) | 0, _ = (h = e + h | 0) ^ D, D = E = h >>> 0 < e >>> 0 ? E + 1 | 0 : E, v = E = KI(_, E ^ v, 1), hA = E, L = _ = w, AA = y, T = s, y = c, c = KI(S ^ K, V ^ CA, 48), E = (S = w) + M | 0, K = _ = c + Y | 0, Y = E = _ >>> 0 < c >>> 0 ? E + 1 | 0 : E, y = KI(_ ^ y, E ^ m, 1), E = (m = w) + yA | 0, E = H + ((_ = y + rA | 0) >>> 0 < y >>> 0 ? E + 1 | 0 : E) | 0, p = E = (s = _ + p | 0) >>> 0 < p >>> 0 ? E + 1 | 0 : E, _ = KI(s ^ T, E ^ U, 32), E = (M = w) + f | 0, U = E = (f = _ + AA | 0) >>> 0 < _ >>> 0 ? E + 1 | 0 : E, y = KI(y ^ f, E ^ m, 40), E = FA + (CA = w) | 0, H = y, E = p + ((y = QA + y | 0) >>> 0 < QA >>> 0 ? E + 1 | 0 : E) | 0, p = y + s | 0, y = M, M = E = p >>> 0 < s >>> 0 ? E + 1 | 0 : E, y = KI(_ ^ p, y ^ E, 48), E = (E = U) + (U = w) | 0, m = _ = y + f | 0, V = E = _ >>> 0 < y >>> 0 ? E + 1 | 0 : E, s = r, E = N + IA | 0, r = E = (_ = k + G | 0) >>> 0 < k >>> 0 ? E + 1 | 0 : E, t = KI(_ ^ t, E ^ u, 1), E = (k = w) + GA | 0, E = b + ((f = t + _A | 0) >>> 0 < t >>> 0 ? E + 1 | 0 : E) | 0, s = KI(s ^ (f = f + n | 0), (E = f >>> 0 < n >>> 0 ? E + 1 | 0 : E) ^ x, 32), N = n = w, n = E, G = t, E = N + Y | 0, E = (t = s + K | 0) >>> 0 < s >>> 0 ? E + 1 | 0 : E, K = t, t ^= G, G = E, t = KI(t, E ^ k, 40), E = DA + (u = w) | 0, E = ((k = t + oA | 0) >>> 0 < oA >>> 0 ? E + 1 | 0 : E) + n | 0, b = N, N = E = (n = f + k | 0) >>> 0 < k >>> 0 ? E + 1 | 0 : E, k = KI(s ^ n, b ^ E, 48), IA = E = w, f = E, s = KI(q ^ R, l ^ $, 1), Y = E = w, b = r, E = E + BA | 0, E = O + ((r = s + j | 0) >>> 0 < j >>> 0 ? E + 1 | 0 : E) | 0, F = E = (r = r + F | 0) >>> 0 < F >>> 0 ? E + 1 | 0 : E, S = KI(c ^ r, E ^ S, 32), E = ($ = w) + b | 0, b = _ = S + _ | 0, c = KI(_ ^ s, (c = Y) ^ (Y = _ >>> 0 < S >>> 0 ? E + 1 | 0 : E), 40), E = NA + (R = w) | 0, E = F + ((_ = c + iA | 0) >>> 0 < iA >>> 0 ? E + 1 | 0 : E) | 0, q = _ = _ + r | 0, O = E = _ >>> 0 < r >>> 0 ? E + 1 | 0 : E, r = E, E = L + B | 0, E = ((s = v + g | 0) >>> 0 < g >>> 0 ? E + 1 | 0 : E) + r | 0, F = E = (r = _ + s | 0) >>> 0 < s >>> 0 ? E + 1 | 0 : E, _ = KI(r ^ k, E ^ f, 32), E = (v = w) + V | 0, f = KI((s = _ + m | 0) ^ hA, (E = s >>> 0 < _ >>> 0 ? E + 1 | 0 : E) ^ L, 40), L = E, E = kA + (x = w) | 0, E = F + ((l = f + eA | 0) >>> 0 < eA >>> 0 ? E + 1 | 0 : E) | 0, E = (F = r + l | 0) >>> 0 < r >>> 0 ? E + 1 | 0 : E, r = v, v = E, r = KI(_ ^ F, r ^ E, 48), E = (E = L) + (L = w) | 0, _ = (s = r + s | 0) ^ f, f = E = s >>> 0 < r >>> 0 ? E + 1 | 0 : E, x = E = KI(_, E ^ x, 1), l = _ = w, AA = h, T = y, y = c, c = KI(S ^ q, O ^ $, 48), E = (S = w) + Y | 0, Y = _ = c + b | 0, b = E = _ >>> 0 < c >>> 0 ? E + 1 | 0 : E, y = KI(_ ^ y, E ^ R, 1), E = (R = w) + FA | 0, E = N + ((_ = y + QA | 0) >>> 0 < y >>> 0 ? E + 1 | 0 : E) | 0, n = E = (h = _ + n | 0) >>> 0 < n >>> 0 ? E + 1 | 0 : E, _ = KI(h ^ T, E ^ U, 32), E = (N = w) + D | 0, U = E = (D = _ + AA | 0) >>> 0 < _ >>> 0 ? E + 1 | 0 : E, y = KI(y ^ D, E ^ R, 40), E = BA + ($ = w) | 0, R = y, E = n + ((y = j + y | 0) >>> 0 < j >>> 0 ? E + 1 | 0 : E) | 0, n = y + h | 0, y = N, N = E = n >>> 0 < h >>> 0 ? E + 1 | 0 : E, y = KI(_ ^ n, y ^ E, 48), E = (E = U) + (U = w) | 0, q = _ = y + D | 0, O = E = _ >>> 0 < y >>> 0 ? E + 1 | 0 : E, h = e, E = G + IA | 0, e = E = (_ = k + K | 0) >>> 0 < k >>> 0 ? E + 1 | 0 : E, t = KI(_ ^ t, E ^ u, 1), E = NA + (k = w) | 0, E = M + ((D = t + iA | 0) >>> 0 < iA >>> 0 ? E + 1 | 0 : E) | 0, p = E = (D = D + p | 0) >>> 0 < p >>> 0 ? E + 1 | 0 : E, h = KI(h ^ D, E ^ J, 32), K = E = w, G = t, E = E + b | 0, E = (t = h + Y | 0) >>> 0 < h >>> 0 ? E + 1 | 0 : E, u = t, t ^= G, G = E, t = KI(t, E ^ k, 40), E = wA + (Y = w) | 0, E = p + ((k = t + EA | 0) >>> 0 < EA >>> 0 ? E + 1 | 0 : E) | 0, E = (p = D + k | 0) >>> 0 < D >>> 0 ? E + 1 | 0 : E, D = K, K = E, k = KI(h ^ p, D ^ E, 48), IA = E = w, D = E, h = KI(H ^ m, V ^ CA, 1), b = E = w, M = e, E = E + X | 0, E = W + ((e = I + h | 0) >>> 0 < I >>> 0 ? E + 1 | 0 : E) | 0, d = E = (e = e + d | 0) >>> 0 < d >>> 0 ? E + 1 | 0 : E, S = KI(c ^ e, E ^ S, 32), E = (CA = w) + M | 0, M = _ = S + _ | 0, c = KI(_ ^ h, (c = b) ^ (b = _ >>> 0 < S >>> 0 ? E + 1 | 0 : E), 40), E = fA + (H = w) | 0, E = d + ((_ = c + Z | 0) >>> 0 < Z >>> 0 ? E + 1 | 0 : E) | 0, m = _ = _ + e | 0, V = E = _ >>> 0 < e >>> 0 ? E + 1 | 0 : E, e = E, E = l + sA | 0, E = ((h = x + gA | 0) >>> 0 < gA >>> 0 ? E + 1 | 0 : E) + e | 0, d = E = (e = _ + h | 0) >>> 0 < h >>> 0 ? E + 1 | 0 : E, _ = KI(e ^ k, E ^ D, 32), E = (W = w) + O | 0, D = KI((h = _ + q | 0) ^ x, (E = h >>> 0 < _ >>> 0 ? E + 1 | 0 : E) ^ l, 40), x = E, E = C + (J = w) | 0, E = d + ((l = D + pA | 0) >>> 0 < pA >>> 0 ? E + 1 | 0 : E) | 0, E = (d = e + l | 0) >>> 0 < e >>> 0 ? E + 1 | 0 : E, e = W, W = E, e = KI(_ ^ d, e ^ E, 48), E = (E = x) + (x = w) | 0, _ = (h = e + h | 0) ^ D, D = E = h >>> 0 < e >>> 0 ? E + 1 | 0 : E, J = E = KI(_, E ^ J, 1), l = _ = w, AA = s, T = y, y = c, c = KI(S ^ m, V ^ CA, 48), E = (S = w) + b | 0, b = _ = c + M | 0, M = E = _ >>> 0 < c >>> 0 ? E + 1 | 0 : E, y = KI(_ ^ y, E ^ H, 1), E = (H = w) + tA | 0, E = K + ((_ = y + z | 0) >>> 0 < y >>> 0 ? E + 1 | 0 : E) | 0, p = E = (s = _ + p | 0) >>> 0 < p >>> 0 ? E + 1 | 0 : E, _ = KI(s ^ T, E ^ U, 32), E = (K = w) + f | 0, U = E = (f = _ + AA | 0) >>> 0 < _ >>> 0 ? E + 1 | 0 : E, y = KI(y ^ f, E ^ H, 40), E = GA + (CA = w) | 0, H = y, E = p + ((y = _A + y | 0) >>> 0 < _A >>> 0 ? E + 1 | 0 : E) | 0, p = y + s | 0, y = K, K = E = p >>> 0 < s >>> 0 ? E + 1 | 0 : E, y = KI(_ ^ p, y ^ E, 48), E = (E = U) + (U = w) | 0, m = _ = y + f | 0, V = E = _ >>> 0 < y >>> 0 ? E + 1 | 0 : E, s = r, E = G + IA | 0, r = E = (_ = k + u | 0) >>> 0 < k >>> 0 ? E + 1 | 0 : E, t = KI(_ ^ t, E ^ Y, 1), E = (k = w) + DA | 0, E = N + ((f = t + oA | 0) >>> 0 < t >>> 0 ? E + 1 | 0 : E) | 0, n = E = (f = f + n | 0) >>> 0 < n >>> 0 ? E + 1 | 0 : E, s = KI(s ^ f, E ^ L, 32), N = E = w, G = t, E = E + M | 0, E = (t = s + b | 0) >>> 0 < s >>> 0 ? E + 1 | 0 : E, u = t, t ^= G, G = E, t = KI(t, E ^ k, 40), E = yA + (Y = w) | 0, E = n + ((k = t + rA | 0) >>> 0 < rA >>> 0 ? E + 1 | 0 : E) | 0, b = N, N = E = (n = f + k | 0) >>> 0 < f >>> 0 ? E + 1 | 0 : E, k = KI(s ^ n, b ^ E, 48), IA = E = w, f = E, s = KI(q ^ R, O ^ $, 1), b = E = w, M = r, E = E + P | 0, E = v + ((r = s + aA | 0) >>> 0 < aA >>> 0 ? E + 1 | 0 : E) | 0, F = E = (r = r + F | 0) >>> 0 < F >>> 0 ? E + 1 | 0 : E, S = KI(c ^ r, E ^ S, 32), E = ($ = w) + M | 0, M = _ = S + _ | 0, c = KI(_ ^ s, (c = b) ^ (b = _ >>> 0 < S >>> 0 ? E + 1 | 0 : E), 40), E = SA + (R = w) | 0, E = F + ((_ = c + cA | 0) >>> 0 < cA >>> 0 ? E + 1 | 0 : E) | 0, q = _ = _ + r | 0, O = E = _ >>> 0 < r >>> 0 ? E + 1 | 0 : E, r = E, E = l + C | 0, E = ((s = J + pA | 0) >>> 0 < pA >>> 0 ? E + 1 | 0 : E) + r | 0, F = E = (r = _ + s | 0) >>> 0 < s >>> 0 ? E + 1 | 0 : E, _ = KI(r ^ k, E ^ f, 32), E = (v = w) + V | 0, f = KI((s = _ + m | 0) ^ J, (E = s >>> 0 < _ >>> 0 ? E + 1 | 0 : E) ^ l, 40), L = E, E = NA + (J = w) | 0, E = F + ((l = f + iA | 0) >>> 0 < iA >>> 0 ? E + 1 | 0 : E) | 0, E = (F = r + l | 0) >>> 0 < r >>> 0 ? E + 1 | 0 : E, r = v, v = E, r = KI(_ ^ F, r ^ E, 48), E = (E = L) + (L = w) | 0, _ = (s = r + s | 0) ^ f, f = E = s >>> 0 < r >>> 0 ? E + 1 | 0 : E, J = E = KI(_, E ^ J, 1), l = _ = w, AA = h, T = y, y = c, c = KI(S ^ q, O ^ $, 48), E = (S = w) + b | 0, b = _ = c + M | 0, M = E = _ >>> 0 < c >>> 0 ? E + 1 | 0 : E, y = KI(_ ^ y, E ^ R, 1), E = (R = w) + P | 0, E = N + ((_ = y + aA | 0) >>> 0 < y >>> 0 ? E + 1 | 0 : E) | 0, n = E = (h = _ + n | 0) >>> 0 < n >>> 0 ? E + 1 | 0 : E, _ = KI(h ^ T, E ^ U, 32), E = (N = w) + D | 0, U = E = (D = _ + AA | 0) >>> 0 < _ >>> 0 ? E + 1 | 0 : E, y = KI(y ^ D, E ^ R, 40), E = yA + ($ = w) | 0, R = y, E = n + ((y = rA + y | 0) >>> 0 < rA >>> 0 ? E + 1 | 0 : E) | 0, n = y + h | 0, y = N, N = E = n >>> 0 < h >>> 0 ? E + 1 | 0 : E, y = KI(_ ^ n, y ^ E, 48), E = (E = U) + (U = w) | 0, q = _ = y + D | 0, O = E = _ >>> 0 < y >>> 0 ? E + 1 | 0 : E, h = e, E = G + IA | 0, e = E = (_ = k + u | 0) >>> 0 < k >>> 0 ? E + 1 | 0 : E, t = KI(_ ^ t, E ^ Y, 1), E = DA + (k = w) | 0, E = K + ((D = t + oA | 0) >>> 0 < oA >>> 0 ? E + 1 | 0 : E) | 0, p = E = (D = D + p | 0) >>> 0 < p >>> 0 ? E + 1 | 0 : E, h = KI(h ^ D, E ^ x, 32), K = E = w, G = t, E = E + M | 0, E = (t = h + b | 0) >>> 0 < h >>> 0 ? E + 1 | 0 : E, u = t, t ^= G, G = E, t = KI(t, E ^ k, 40), E = GA + (Y = w) | 0, E = p + ((k = t + _A | 0) >>> 0 < _A >>> 0 ? E + 1 | 0 : E) | 0, E = (p = D + k | 0) >>> 0 < D >>> 0 ? E + 1 | 0 : E, D = K, K = E, k = KI(h ^ p, D ^ E, 48), IA = E = w, D = E, h = KI(H ^ m, V ^ CA, 1), b = E = w, M = e, E = E + BA | 0, E = W + ((e = h + j | 0) >>> 0 < j >>> 0 ? E + 1 | 0 : E) | 0, d = E = (e = e + d | 0) >>> 0 < d >>> 0 ? E + 1 | 0 : E, S = KI(c ^ e, E ^ S, 32), E = (CA = w) + M | 0, M = _ = S + _ | 0, c = KI(_ ^ h, (c = b) ^ (b = _ >>> 0 < S >>> 0 ? E + 1 | 0 : E), 40), E = SA + (H = w) | 0, E = d + ((_ = c + cA | 0) >>> 0 < cA >>> 0 ? E + 1 | 0 : E) | 0, m = _ = _ + e | 0, V = E = _ >>> 0 < e >>> 0 ? E + 1 | 0 : E, e = E, E = l + fA | 0, E = ((h = J + Z | 0) >>> 0 < Z >>> 0 ? E + 1 | 0 : E) + e | 0, d = E = (e = _ + h | 0) >>> 0 < h >>> 0 ? E + 1 | 0 : E, _ = KI(e ^ k, E ^ D, 32), E = (W = w) + O | 0, D = KI((h = _ + q | 0) ^ J, (E = h >>> 0 < _ >>> 0 ? E + 1 | 0 : E) ^ l, 40), x = E, E = X + (J = w) | 0, E = d + ((l = I + D | 0) >>> 0 < I >>> 0 ? E + 1 | 0 : E) | 0, E = (d = e + l | 0) >>> 0 < e >>> 0 ? E + 1 | 0 : E, e = W, W = E, e = KI(_ ^ d, e ^ E, 48), E = (E = x) + (x = w) | 0, _ = (h = e + h | 0) ^ D, D = E = h >>> 0 < e >>> 0 ? E + 1 | 0 : E, J = E = KI(_, E ^ J, 1), l = _ = w, AA = s, T = y, y = c, c = KI(S ^ m, V ^ CA, 48), E = (S = w) + b | 0, b = _ = c + M | 0, M = E = _ >>> 0 < c >>> 0 ? E + 1 | 0 : E, y = KI(_ ^ y, E ^ H, 1), E = (H = w) + wA | 0, E = K + ((_ = y + EA | 0) >>> 0 < y >>> 0 ? E + 1 | 0 : E) | 0, p = E = (s = _ + p | 0) >>> 0 < p >>> 0 ? E + 1 | 0 : E, _ = KI(s ^ T, E ^ U, 32), E = (K = w) + f | 0, U = E = (f = _ + AA | 0) >>> 0 < _ >>> 0 ? E + 1 | 0 : E, y = KI(y ^ f, E ^ H, 40), E = B + (CA = w) | 0, H = y, E = p + ((y = g + y | 0) >>> 0 < g >>> 0 ? E + 1 | 0 : E) | 0, p = y + s | 0, y = K, K = E = p >>> 0 < s >>> 0 ? E + 1 | 0 : E, y = KI(_ ^ p, y ^ E, 48), E = (E = U) + (U = w) | 0, m = _ = y + f | 0, V = E = _ >>> 0 < y >>> 0 ? E + 1 | 0 : E, s = r, E = G + IA | 0, r = E = (_ = k + u | 0) >>> 0 < k >>> 0 ? E + 1 | 0 : E, t = KI(_ ^ t, E ^ Y, 1), E = (k = w) + sA | 0, E = N + ((f = t + gA | 0) >>> 0 < t >>> 0 ? E + 1 | 0 : E) | 0, n = E = (f = f + n | 0) >>> 0 < n >>> 0 ? E + 1 | 0 : E, s = KI(s ^ f, E ^ L, 32), N = E = w, G = t, E = E + M | 0, E = (t = s + b | 0) >>> 0 < s >>> 0 ? E + 1 | 0 : E, u = t, t ^= G, G = E, t = KI(t, E ^ k, 40), E = FA + (Y = w) | 0, E = n + ((k = t + QA | 0) >>> 0 < QA >>> 0 ? E + 1 | 0 : E) | 0, b = N, N = E = (n = f + k | 0) >>> 0 < f >>> 0 ? E + 1 | 0 : E, k = KI(s ^ n, b ^ E, 48), IA = E = w, f = E, s = KI(q ^ R, O ^ $, 1), b = E = w, M = r, E = E + kA | 0, E = v + ((r = s + eA | 0) >>> 0 < eA >>> 0 ? E + 1 | 0 : E) | 0, F = E = (r = r + F | 0) >>> 0 < F >>> 0 ? E + 1 | 0 : E, S = KI(c ^ r, E ^ S, 32), E = ($ = w) + M | 0, M = _ = S + _ | 0, c = KI(_ ^ s, (c = b) ^ (b = _ >>> 0 < S >>> 0 ? E + 1 | 0 : E), 40), E = tA + (R = w) | 0, E = F + ((_ = c + z | 0) >>> 0 < z >>> 0 ? E + 1 | 0 : E) | 0, q = _ = _ + r | 0, O = E = _ >>> 0 < r >>> 0 ? E + 1 | 0 : E, r = E, E = l + SA | 0, E = ((s = J + cA | 0) >>> 0 < cA >>> 0 ? E + 1 | 0 : E) + r | 0, F = E = (r = _ + s | 0) >>> 0 < s >>> 0 ? E + 1 | 0 : E, _ = KI(r ^ k, E ^ f, 32), E = (v = w) + V | 0, f = KI((s = _ + m | 0) ^ J, (E = s >>> 0 < _ >>> 0 ? E + 1 | 0 : E) ^ l, 40), L = E, E = yA + (J = w) | 0, E = F + ((l = f + rA | 0) >>> 0 < rA >>> 0 ? E + 1 | 0 : E) | 0, E = (F = r + l | 0) >>> 0 < r >>> 0 ? E + 1 | 0 : E, r = v, v = E, r = KI(_ ^ F, r ^ E, 48), E = (E = L) + (L = w) | 0, _ = (s = r + s | 0) ^ f, f = E = s >>> 0 < r >>> 0 ? E + 1 | 0 : E, J = E = KI(_, E ^ J, 1), l = _ = w, AA = h, T = y, y = c, c = KI(S ^ q, O ^ $, 48), E = (S = w) + b | 0, b = _ = c + M | 0, M = E = _ >>> 0 < c >>> 0 ? E + 1 | 0 : E, y = KI(_ ^ y, E ^ R, 1), E = (R = w) + NA | 0, E = N + ((_ = y + iA | 0) >>> 0 < y >>> 0 ? E + 1 | 0 : E) | 0, n = E = (h = _ + n | 0) >>> 0 < n >>> 0 ? E + 1 | 0 : E, _ = KI(h ^ T, E ^ U, 32), E = (N = w) + D | 0, U = E = (D = _ + AA | 0) >>> 0 < _ >>> 0 ? E + 1 | 0 : E, y = KI(y ^ D, E ^ R, 40), E = C + ($ = w) | 0, R = y, E = n + ((y = pA + y | 0) >>> 0 < pA >>> 0 ? E + 1 | 0 : E) | 0, n = y + h | 0, y = N, N = E = n >>> 0 < h >>> 0 ? E + 1 | 0 : E, y = KI(_ ^ n, y ^ E, 48), E = (E = U) + (U = w) | 0, q = _ = y + D | 0, O = E = _ >>> 0 < y >>> 0 ? E + 1 | 0 : E, h = e, E = G + IA | 0, e = E = (_ = k + u | 0) >>> 0 < k >>> 0 ? E + 1 | 0 : E, t = KI(_ ^ t, E ^ Y, 1), E = FA + (k = w) | 0, E = K + ((D = t + QA | 0) >>> 0 < QA >>> 0 ? E + 1 | 0 : E) | 0, p = E = (D = D + p | 0) >>> 0 < p >>> 0 ? E + 1 | 0 : E, h = KI(h ^ D, E ^ x, 32), K = E = w, G = t, E = E + M | 0, E = (t = h + b | 0) >>> 0 < h >>> 0 ? E + 1 | 0 : E, u = t, t ^= G, G = E, t = KI(t, E ^ k, 40), E = P + (Y = w) | 0, E = p + ((k = t + aA | 0) >>> 0 < aA >>> 0 ? E + 1 | 0 : E) | 0, E = (p = D + k | 0) >>> 0 < D >>> 0 ? E + 1 | 0 : E, D = K, K = E, k = KI(h ^ p, D ^ E, 48), IA = E = w, D = E, h = KI(H ^ m, V ^ CA, 1), b = E = w, M = e, E = E + GA | 0, E = W + ((e = h + _A | 0) >>> 0 < _A >>> 0 ? E + 1 | 0 : E) | 0, d = E = (e = e + d | 0) >>> 0 < d >>> 0 ? E + 1 | 0 : E, S = KI(c ^ e, E ^ S, 32), E = (CA = w) + M | 0, M = _ = S + _ | 0, c = KI(_ ^ h, (c = b) ^ (b = _ >>> 0 < S >>> 0 ? E + 1 | 0 : E), 40), E = kA + (H = w) | 0, E = d + ((_ = c + eA | 0) >>> 0 < eA >>> 0 ? E + 1 | 0 : E) | 0, m = _ = _ + e | 0, V = E = _ >>> 0 < e >>> 0 ? E + 1 | 0 : E, e = E, E = l + DA | 0, E = ((h = J + oA | 0) >>> 0 < oA >>> 0 ? E + 1 | 0 : E) + e | 0, d = E = (e = _ + h | 0) >>> 0 < h >>> 0 ? E + 1 | 0 : E, _ = KI(e ^ k, E ^ D, 32), E = (W = w) + O | 0, D = KI((h = _ + q | 0) ^ J, (E = h >>> 0 < _ >>> 0 ? E + 1 | 0 : E) ^ l, 40), x = E, E = B + (J = w) | 0, E = d + ((l = D + g | 0) >>> 0 < g >>> 0 ? E + 1 | 0 : E) | 0, E = (d = e + l | 0) >>> 0 < e >>> 0 ? E + 1 | 0 : E, e = W, W = E, e = KI(_ ^ d, e ^ E, 48), E = (E = x) + (x = w) | 0, _ = (h = e + h | 0) ^ D, D = E = h >>> 0 < e >>> 0 ? E + 1 | 0 : E, J = E = KI(_, E ^ J, 1), l = _ = w, AA = s, T = y, y = c, c = KI(S ^ m, V ^ CA, 48), E = (S = w) + b | 0, b = _ = c + M | 0, M = E = _ >>> 0 < c >>> 0 ? E + 1 | 0 : E, y = KI(_ ^ y, E ^ H, 1), E = (m = w) + BA | 0, E = K + ((_ = y + j | 0) >>> 0 < y >>> 0 ? E + 1 | 0 : E) | 0, p = E = (s = _ + p | 0) >>> 0 < p >>> 0 ? E + 1 | 0 : E, _ = KI(s ^ T, E ^ U, 32), E = (K = w) + f | 0, U = f = _ + AA | 0, H = E = f >>> 0 < _ >>> 0 ? E + 1 | 0 : E, y = KI(y ^ f, E ^ m, 40), E = fA + (AA = w) | 0, m = y, E = p + ((y = Z + y | 0) >>> 0 < Z >>> 0 ? E + 1 | 0 : E) | 0, f = y + s | 0, y = K, K = E = f >>> 0 < s >>> 0 ? E + 1 | 0 : E, y = KI(_ ^ f, y ^ E, 48), E = (E = H) + (H = w) | 0, U = _ = y + U | 0, V = E = _ >>> 0 < y >>> 0 ? E + 1 | 0 : E, s = r, E = G + IA | 0, r = E = (_ = k + u | 0) >>> 0 < k >>> 0 ? E + 1 | 0 : E, t = KI(_ ^ t, E ^ Y, 1), E = (k = w) + X | 0, E = N + ((p = I + t | 0) >>> 0 < t >>> 0 ? E + 1 | 0 : E) | 0, n = E = (p = p + n | 0) >>> 0 < n >>> 0 ? E + 1 | 0 : E, N = s = KI(s ^ p, E ^ L, 32), G = E = w, u = t, E = E + M | 0, E = (t = s + b | 0) >>> 0 < s >>> 0 ? E + 1 | 0 : E, Y = t, t ^= u, u = E, t = KI(t, E ^ k, 40), E = wA + (b = w) | 0, E = n + ((s = t + EA | 0) >>> 0 < EA >>> 0 ? E + 1 | 0 : E) | 0, M = (s = s + p | 0) ^ N, N = E = s >>> 0 < p >>> 0 ? E + 1 | 0 : E, p = KI(M, E ^ G, 48), L = E = w, k = E, G = n = KI(q ^ R, O ^ $, 1), M = E = w, R = r, E = E + tA | 0, E = v + ((r = n + z | 0) >>> 0 < z >>> 0 ? E + 1 | 0 : E) | 0, E = (r = r + F | 0) >>> 0 < F >>> 0 ? E + 1 | 0 : E, F = S, S = E, n = KI(c ^ r, F ^ E, 32), E = (T = w) + R | 0, F = _ = n + _ | 0, c = KI(c = _ ^ G, (G = _ >>> 0 < n >>> 0 ? E + 1 | 0 : E) ^ M, 40), E = sA + (M = w) | 0, E = S + ((_ = c + gA | 0) >>> 0 < gA >>> 0 ? E + 1 | 0 : E) | 0, S = _ = _ + r | 0, R = E = _ >>> 0 < r >>> 0 ? E + 1 | 0 : E, r = E, E = l + fA | 0, E = ((v = Z) >>> 0 > (Z = J + Z | 0) >>> 0 ? E + 1 | 0 : E) + r | 0, fA = E = (_ = _ + Z | 0) >>> 0 < Z >>> 0 ? E + 1 | 0 : E, Z = KI(_ ^ p, E ^ k, 32), E = (q = w) + V | 0, k = KI((r = U + Z | 0) ^ J, (E = r >>> 0 < Z >>> 0 ? E + 1 | 0 : E) ^ l, 40), v = E, E = wA + (O = w) | 0, E = fA + ((J = EA) >>> 0 > (EA = k + EA | 0) >>> 0 ? E + 1 | 0 : E) | 0, E = (EA = _ + EA | 0) >>> 0 < _ >>> 0 ? E + 1 | 0 : E, _ = Z ^ EA, Z = E;
                                        wA = KI(_, E ^ q, 48), E = (fA = w) + v | 0, r = E = (_ = r + wA | 0) >>> 0 < wA >>> 0 ? E + 1 | 0 : E, E = KI(_ ^ k, E ^ O, 1), k = w, q = E, O = h, h = gA, v = sA, sA = KI(n ^ S, R ^ T, 48), E = (n = w) + G | 0, G = h, F = E = (gA = F + sA | 0) >>> 0 < sA >>> 0 ? E + 1 | 0 : E, h = KI(c ^ (S = gA), E ^ M, 1), E = (M = w) + v | 0, E = N + (h >>> 0 > (gA = G + h | 0) >>> 0 ? E + 1 | 0 : E) | 0, c = E = (gA = s + gA | 0) >>> 0 < s >>> 0 ? E + 1 | 0 : E, y = KI(y ^ gA, E ^ H, 32), E = (E = D) + (D = w) | 0, N = s = y + O | 0, G = E = s >>> 0 < y >>> 0 ? E + 1 | 0 : E, s = KI(s ^ h, E ^ M, 40), E = (M = w) + NA | 0, E = (s >>> 0 > (iA = s + iA | 0) >>> 0 ? E + 1 | 0 : E) + c | 0, c = E = (c = iA) >>> 0 > (iA = gA + iA | 0) >>> 0 ? E + 1 | 0 : E, y = KI(y ^ iA, E ^ D, 48), E = (h = w) + G | 0, D = gA = y + N | 0, NA = E = gA >>> 0 < y >>> 0 ? E + 1 | 0 : E, N = I, G = X, E = u + L | 0, gA = E = (I = p + Y | 0) >>> 0 < p >>> 0 ? E + 1 | 0 : E, X = KI(I ^ t, E ^ b, 1), E = (p = w) + G | 0, E = K + ((t = N + X | 0) >>> 0 < X >>> 0 ? E + 1 | 0 : E) | 0, e = KI((t = t + f | 0) ^ e, (E = t >>> 0 < f >>> 0 ? E + 1 | 0 : E) ^ x, 32), N = E, K = oA, oA = X, E = (f = w) + F | 0, F = p, p = E = (X = e + S | 0) >>> 0 < e >>> 0 ? E + 1 | 0 : E, oA = KI(X ^ oA, F ^ E, 40), E = (S = w) + DA | 0, E = ((DA = K + oA | 0) >>> 0 < oA >>> 0 ? E + 1 | 0 : E) + N | 0, N = DA, t = e ^ (DA = t + DA | 0), e = E = N >>> 0 > DA >>> 0 ? E + 1 | 0 : E, E = KI(t, E ^ f, 48), u = t = w, f = E, F = j, N = BA, j = KI(U ^ m, V ^ AA, 1), G = E = w, E = E + SA | 0, E = W + ((j = (K = j) + cA | 0) >>> 0 < cA >>> 0 ? E + 1 | 0 : E) | 0, cA = E = (j = d + j | 0) >>> 0 < d >>> 0 ? E + 1 | 0 : E, BA = KI(j ^ sA, E ^ n, 32), E = (d = w) + gA | 0, gA = I = BA + I | 0, sA = KI(I ^ K, (n = I >>> 0 < BA >>> 0 ? E + 1 | 0 : E) ^ G, 40), E = (E = N) + (N = w) | 0, E = cA + ((I = sA + F | 0) >>> 0 < sA >>> 0 ? E + 1 | 0 : E) | 0, cA = I = I + j | 0, SA = E = I >>> 0 < j >>> 0 ? E + 1 | 0 : E, j = E, E = k + FA | 0, E = ((K = QA) >>> 0 > (QA = q + QA | 0) >>> 0 ? E + 1 | 0 : E) + j | 0, FA = E = (j = I + QA | 0) >>> 0 < QA >>> 0 ? E + 1 | 0 : E, QA = KI(f ^ j, E ^ t, 32), E = (K = w) + NA | 0, t = I = QA + D | 0, I = KI(I ^ q, (F = k) ^ (k = I >>> 0 < QA >>> 0 ? E + 1 | 0 : E), 40), E = GA + (G = w) | 0, GA = I, E = FA + ((I = _A + I | 0) >>> 0 < _A >>> 0 ? E + 1 | 0 : E) | 0, E = (I = I + j | 0) >>> 0 < j >>> 0 ? E + 1 | 0 : E, FA = I, Y = (a[A + 8 | 0] | a[A + 9 | 0] << 8 | a[A + 10 | 0] << 16 | a[A + 11 | 0] << 24) ^ I, F = E, b = E ^ (a[A + 12 | 0] | a[A + 13 | 0] << 8 | a[A + 14 | 0] << 16 | a[A + 15 | 0] << 24), j = KI(BA ^ cA, d ^ SA, 48), E = (cA = w) + n | 0, n = I = j + gA | 0, SA = E = I >>> 0 < j >>> 0 ? E + 1 | 0 : E, BA = rA, E = p + u | 0, rA = E = (I = f + X | 0) >>> 0 < X >>> 0 ? E + 1 | 0 : E, oA = KI(I ^ oA, E ^ S, 1), E = (f = w) + yA | 0, E = ((BA = oA + BA | 0) >>> 0 < oA >>> 0 ? E + 1 | 0 : E) + c | 0, BA = E = (yA = BA + iA | 0) >>> 0 < BA >>> 0 ? E + 1 | 0 : E, gA = KI(yA ^ wA, E ^ fA, 32), E = (X = w) + SA | 0, iA = E = (_A = gA + n | 0) >>> 0 < gA >>> 0 ? E + 1 | 0 : E, wA = gA, gA = KI(oA ^ _A, E ^ f, 40), E = (c = w) + kA | 0, E = (gA >>> 0 > (oA = gA + eA | 0) >>> 0 ? E + 1 | 0 : E) + BA | 0, p = X, X = E = (yA = oA + yA | 0) >>> 0 < oA >>> 0 ? E + 1 | 0 : E, oA = KI(wA ^ (eA = yA), p ^ E, 48), E = (f = w) + iA | 0, E = (BA = oA + _A | 0) >>> 0 < oA >>> 0 ? E + 1 | 0 : E, _A = BA, BA ^= Y, o[A + 8 | 0] = BA, o[A + 9 | 0] = BA >>> 8, o[A + 10 | 0] = BA >>> 16, o[A + 11 | 0] = BA >>> 24, iA = E, E ^= b, o[A + 12 | 0] = E, o[A + 13 | 0] = E >>> 8, o[A + 14 | 0] = E >>> 16, o[A + 15 | 0] = E >>> 24, yA = I, BA = rA, I = j, j = KI(s ^ D, M ^ NA, 1), E = (kA = w) + B | 0, E = (j >>> 0 > (rA = j + g | 0) >>> 0 ? E + 1 | 0 : E) + Z | 0, EA = E = (D = rA) >>> 0 > (rA = EA + rA | 0) >>> 0 ? E + 1 | 0 : E, I = KI(I ^ rA, E ^ cA, 32), E = (E = BA) + (BA = w) | 0, cA = E = (yA = I + yA | 0) >>> 0 < I >>> 0 ? E + 1 | 0 : E, wA = I, yA = KI(j ^ (Z = yA), E ^ kA, 40), E = (s = w) + C | 0, E = EA + ((I = yA + pA | 0) >>> 0 < yA >>> 0 ? E + 1 | 0 : E) | 0, E = (I = I + rA | 0) >>> 0 < rA >>> 0 ? E + 1 | 0 : E, EA = I, I ^= wA, wA = E, rA = KI(I, E ^ BA, 48), E = (D = w) + cA | 0, Z = I = rA + Z | 0, cA = I >>> 0 < rA >>> 0 ? E + 1 | 0 : E, sA = I = KI(n ^ sA, N ^ SA, 1), kA = E = w, E = E + P | 0, E = e + ((I = I + aA | 0) >>> 0 < aA >>> 0 ? E + 1 | 0 : E) | 0, P = E = (j = I + DA | 0) >>> 0 < DA >>> 0 ? E + 1 | 0 : E, I = (BA = KI(y ^ j, E ^ h, 32)) + _ | 0, E = (_ = w) + r | 0, DA = I, I = (aA = KI(e = I ^ sA, (sA = I >>> 0 < BA >>> 0 ? E + 1 | 0 : E) ^ kA, 40)) + z | 0, E = (z = w) + tA | 0, E = P + (I >>> 0 < aA >>> 0 ? E + 1 | 0 : E) | 0, E = (P = I + j | 0) >>> 0 < j >>> 0 ? E + 1 | 0 : E, j = P ^ bA ^ Z, o[0 | (I = A)] = j, o[I + 1 | 0] = j >>> 8, o[I + 2 | 0] = j >>> 16, o[I + 3 | 0] = j >>> 24, j = E ^ Q ^ cA, o[I + 4 | 0] = j, o[I + 5 | 0] = j >>> 8, o[I + 6 | 0] = j >>> 16, o[I + 7 | 0] = j >>> 24, j = (BA = KI(P ^ BA, E ^ _, 48)) + DA | 0, E = (DA = w) + sA | 0, E = (sA = j >>> 0 < BA >>> 0 ? E + 1 | 0 : E) ^ (a[I + 20 | 0] | a[I + 21 | 0] << 8 | a[I + 22 | 0] << 16 | a[I + 23 | 0] << 24) ^ wA, P = (a[I + 16 | 0] | a[I + 17 | 0] << 8 | a[I + 18 | 0] << 16 | a[I + 19 | 0] << 24) ^ EA ^ j, o[I + 16 | 0] = P, o[I + 17 | 0] = P >>> 8, o[I + 18 | 0] = P >>> 16, o[I + 19 | 0] = P >>> 24, o[I + 20 | 0] = E, o[I + 21 | 0] = E >>> 8, o[I + 22 | 0] = E >>> 16, o[I + 23 | 0] = E >>> 24, I = KI(QA ^ FA, F ^ K, 48), P = w, EA = a[A + 36 | 0] | a[A + 37 | 0] << 8 | a[A + 38 | 0] << 16 | a[A + 39 | 0] << 24, E = (a[A + 32 | 0] | a[A + 33 | 0] << 8 | a[A + 34 | 0] << 16 | a[A + 35 | 0] << 24) ^ KI(gA ^ _A, c ^ iA, 1) ^ I, o[A + 32 | 0] = E, o[A + 33 | 0] = E >>> 8, o[A + 34 | 0] = E >>> 16, o[A + 35 | 0] = E >>> 24, E = w ^ EA ^ P, o[A + 36 | 0] = E, o[A + 37 | 0] = E >>> 8, o[A + 38 | 0] = E >>> 16, o[A + 39 | 0] = E >>> 24, E = k + P | 0, E = (EA = I + t | 0) >>> 0 < I >>> 0 ? E + 1 | 0 : E, gA = (a[(I = A) + 28 | 0] | a[I + 29 | 0] << 8 | a[I + 30 | 0] << 16 | a[I + 31 | 0] << 24) ^ X ^ E, P = (a[I + 24 | 0] | a[I + 25 | 0] << 8 | a[I + 26 | 0] << 16 | a[I + 27 | 0] << 24) ^ eA ^ EA, o[I + 24 | 0] = P, o[I + 25 | 0] = P >>> 8, o[I + 26 | 0] = P >>> 16, o[I + 27 | 0] = P >>> 24, o[I + 28 | 0] = gA, o[I + 29 | 0] = gA >>> 8, o[I + 30 | 0] = gA >>> 16, o[I + 31 | 0] = gA >>> 24, gA = a[I + 44 | 0] | a[I + 45 | 0] << 8 | a[I + 46 | 0] << 16 | a[I + 47 | 0] << 24, I = rA ^ (a[I + 40 | 0] | a[I + 41 | 0] << 8 | a[I + 42 | 0] << 16 | a[I + 43 | 0] << 24) ^ KI(j ^ aA, z ^ sA, 1), o[A + 40 | 0] = I, o[A + 41 | 0] = I >>> 8, o[A + 42 | 0] = I >>> 16, o[A + 43 | 0] = I >>> 24, I = D ^ w ^ gA, o[A + 44 | 0] = I, o[A + 45 | 0] = I >>> 8, o[A + 46 | 0] = I >>> 16, o[A + 47 | 0] = I >>> 24, j = a[A + 60 | 0] | a[A + 61 | 0] << 8 | a[A + 62 | 0] << 16 | a[A + 63 | 0] << 24, I = BA ^ (a[A + 56 | 0] | a[A + 57 | 0] << 8 | a[A + 58 | 0] << 16 | a[A + 59 | 0] << 24) ^ KI(Z ^ yA, s ^ cA, 1), o[A + 56 | 0] = I, o[A + 57 | 0] = I >>> 8, o[A + 58 | 0] = I >>> 16, o[A + 59 | 0] = I >>> 24, I = DA ^ w ^ j, o[A + 60 | 0] = I, o[A + 61 | 0] = I >>> 8, o[A + 62 | 0] = I >>> 16, o[A + 63 | 0] = I >>> 24, j = a[A + 52 | 0] | a[A + 53 | 0] << 8 | a[A + 54 | 0] << 16 | a[A + 55 | 0] << 24, I = oA ^ (a[A + 48 | 0] | a[A + 49 | 0] << 8 | a[A + 50 | 0] << 16 | a[A + 51 | 0] << 24) ^ KI(EA ^ GA, E ^ G, 1), o[A + 48 | 0] = I, o[A + 49 | 0] = I >>> 8, o[A + 50 | 0] = I >>> 16, o[A + 51 | 0] = I >>> 24, I = f ^ w ^ j, o[A + 52 | 0] = I, o[A + 53 | 0] = I >>> 8, o[A + 54 | 0] = I >>> 16, o[A + 55 | 0] = I >>> 24;
                                    }
                                    function n(A, I, g, C, B, Q, i) {
                                        var _, c, t, r, e, y, s, D, p, f, n, k, F, S, G, M, b, K, H, Y, d, J, U, l, m, u, x, R, v, L, P, q, j, X, O, V, Z, W, T, $, AA, IA, gA, CA, BA, QA, iA, oA, EA = 0, aA = 0, _A = 0, cA = 0, tA = 0, rA = 0, eA = 0, yA = 0, sA = 0, hA = 0, DA = 0, pA = 0, wA = 0, fA = 0, FA = 0, NA = 0, SA = 0, GA = 0, MA = 0, bA = 0, KA = 0, HA = 0, YA = 0, dA = 0, JA = 0, UA = 0, lA = 0, mA = 0, uA = 0, xA = 0, RA = 0, vA = 0, LA = 0, PA = 0, qA = 0, zA = 0, jA = 0, XA = 0, OA = 0, VA = 0, ZA = 0, WA = 0, TA = 0, $A = 0, AI = 0, II = 0;
                                        return h = t = h - 560 | 0, SI(_A = t + 352 | 0), i && nA(_A, 35600, 34, 0), kI(t + 288 | 0, Q, 32, 0), nA(cA = t + 352 | 0, t + 320 | 0, 32, 0), nA(cA, g, C, B), z(cA, yA = t + 224 | 0), sA = a[(aA = Q) + 32 | 0] | a[aA + 33 | 0] << 8 | a[aA + 34 | 0] << 16 | a[aA + 35 | 0] << 24, DA = a[aA + 36 | 0] | a[aA + 37 | 0] << 8 | a[aA + 38 | 0] << 16 | a[aA + 39 | 0] << 24, tA = a[aA + 40 | 0] | a[aA + 41 | 0] << 8 | a[aA + 42 | 0] << 16 | a[aA + 43 | 0] << 24, EA = a[aA + 44 | 0] | a[aA + 45 | 0] << 8 | a[aA + 46 | 0] << 16 | a[aA + 47 | 0] << 24, _A = a[aA + 48 | 0] | a[aA + 49 | 0] << 8 | a[aA + 50 | 0] << 16 | a[aA + 51 | 0] << 24, Q = a[aA + 52 | 0] | a[aA + 53 | 0] << 8 | a[aA + 54 | 0] << 16 | a[aA + 55 | 0] << 24, rA = a[aA + 60 | 0] | a[aA + 61 | 0] << 8 | a[aA + 62 | 0] << 16 | a[aA + 63 | 0] << 24, aA = a[aA + 56 | 0] | a[aA + 57 | 0] << 8 | a[aA + 58 | 0] << 16 | a[aA + 59 | 0] << 24, o[A + 56 | 0] = aA, o[A + 57 | 0] = aA >>> 8, o[A + 58 | 0] = aA >>> 16, o[A + 59 | 0] = aA >>> 24, o[A + 60 | 0] = rA, o[A + 61 | 0] = rA >>> 8, o[A + 62 | 0] = rA >>> 16, o[A + 63 | 0] = rA >>> 24, o[A + 48 | 0] = _A, o[A + 49 | 0] = _A >>> 8, o[A + 50 | 0] = _A >>> 16, o[A + 51 | 0] = _A >>> 24, o[A + 52 | 0] = Q, o[A + 53 | 0] = Q >>> 8, o[A + 54 | 0] = Q >>> 16, o[A + 55 | 0] = Q >>> 24, o[A + 40 | 0] = tA, o[A + 41 | 0] = tA >>> 8, o[A + 42 | 0] = tA >>> 16, o[A + 43 | 0] = tA >>> 24, o[A + 44 | 0] = EA, o[A + 45 | 0] = EA >>> 8, o[A + 46 | 0] = EA >>> 16, o[A + 47 | 0] = EA >>> 24, o[0 | (Q = A + 32 | 0)] = sA, o[Q + 1 | 0] = sA >>> 8, o[Q + 2 | 0] = sA >>> 16, o[Q + 3 | 0] = sA >>> 24, o[Q + 4 | 0] = DA, o[Q + 5 | 0] = DA >>> 8, o[Q + 6 | 0] = DA >>> 16, o[Q + 7 | 0] = DA >>> 24, N(yA), kA(t, yA), tg(A, t), SI(cA), i && nA(cA, 35600, 34, 0), nA(i = t + 352 | 0, A, 64, 0), nA(i, g, C, B), z(i, eA = t + 160 | 0), N(eA), o[t + 288 | 0] = 248 & a[t + 288 | 0], o[t + 319 | 0] = 63 & a[t + 319 | 0] | 64, g = a[23 + (A = c = t + 288 | 0) | 0], tA = Ig(r = a[A + 21 | 0] | a[A + 22 | 0] << 8 | g << 16 & 2031616, 0, e = (a[eA + 28 | 0] | a[eA + 29 | 0] << 8 | a[eA + 30 | 0] << 16 | a[eA + 31 | 0] << 24) >>> 7 | 0, 0), _A = w, g = (A = a[eA + 27 | 0]) >>> 24 | 0, B = A << 8 | (EA = a[eA + 23 | 0] | a[eA + 24 | 0] << 8 | a[eA + 25 | 0] << 16 | a[eA + 26 | 0] << 24) >>> 24, A = Ig(y = 2097151 & ((3 & (DA = (A = (C = a[eA + 28 | 0]) >>> 16 | 0) | g)) << 30 | (g = (C <<= 16) | B) >>> 2), 0, s = (i = a[c + 23 | 0] | a[c + 24 | 0] << 8 | a[c + 25 | 0] << 16 | a[c + 26 | 0] << 24) >>> 5 & 2097151, 0), g = w + _A | 0, C = A >>> 0 > (B = A + tA | 0) >>> 0 ? g + 1 | 0 : g, A = Ig(D = (g = a[eA + 23 | 0]) << 16 & 2031616 | a[eA + 21 | 0] | a[eA + 22 | 0] << 8, 0, p = (a[c + 28 | 0] | a[c + 29 | 0] << 8 | a[c + 30 | 0] << 16 | a[c + 31 | 0] << 24) >>> 7 | 0, 0), C = w + C | 0, _A = g = A + B | 0, B = A >>> 0 > g >>> 0 ? C + 1 | 0 : C, C = (A = a[c + 27 | 0]) >>> 24 | 0, i = A << 8 | i >>> 24, A = Ig(f = 2097151 & ((3 & (C |= g = (A = a[c + 28 | 0]) >>> 16 | 0)) << 30 | (g = (A <<= 16) | i) >>> 2), 0, n = EA >>> 5 & 2097151, 0), g = w + B | 0, aA = C = A + _A | 0, B = A >>> 0 > C >>> 0 ? g + 1 | 0 : g, EA = Ig(s, 0, n, 0), _A = w, g = (A = a[c + 19 | 0]) >>> 24 | 0, i = A << 8 | (SA = a[c + 15 | 0] | a[c + 16 | 0] << 8 | a[c + 17 | 0] << 16 | a[c + 18 | 0] << 24) >>> 24, C = g, g = Ig(k = (7 & (C |= g = (A = a[c + 20 | 0]) >>> 16 | 0)) << 29 | (g = (A <<= 16) | i) >>> 3, DA = C >>> 3 | 0, e, 0), A = w + _A | 0, A = g >>> 0 > (C = g + EA | 0) >>> 0 ? A + 1 | 0 : A, i = (g = Ig(r, 0, y, 0)) + C | 0, C = w + A | 0, g = g >>> 0 > (EA = i) >>> 0 ? C + 1 | 0 : C, C = (A = a[eA + 19 | 0]) >>> 24 | 0, _A = A << 8 | (NA = a[eA + 15 | 0] | a[eA + 16 | 0] << 8 | a[eA + 17 | 0] << 16 | a[eA + 18 | 0] << 24) >>> 24, A = Ig(F = (7 & (tA = (A = (i = a[eA + 20 | 0]) >>> 16 | 0) | C)) << 29 | (C = (i <<= 16) | _A) >>> 3, S = tA >>> 3 | 0, p, 0), g = w + g | 0, g = A >>> 0 > (C = A + EA | 0) >>> 0 ? g + 1 | 0 : g, A = Ig(D, 0, f, 0), g = w + g | 0, sA = g = A >>> 0 > (yA = A + C | 0) >>> 0 ? g + 1 | 0 : g, pA = A = g - ((yA >>> 0 < 4293918720) - 1 | 0) | 0, C = (g = A >>> 21 | 0) + B | 0, EA = C = (A = (2097151 & A) << 11 | (tA = yA - -1048576 | 0) >>> 21) >>> 0 > (aA = A + aA | 0) >>> 0 ? C + 1 | 0 : C, fA = A = C - ((aA >>> 0 < 4293918720) - 1 | 0) | 0, rA = (2097151 & A) << 11 | (_A = aA - -1048576 | 0) >>> 21, i = A >>> 21 | 0, A = Ig(p, 0, n, 0), g = w, C = A, A = Ig(e, 0, s, 0), g = w + g | 0, g = A >>> 0 > (C = C + A | 0) >>> 0 ? g + 1 | 0 : g, wA = (A = C) + (C = Ig(y, 0, f, 0)) | 0, A = w + g | 0, A = C >>> 0 > wA >>> 0 ? A + 1 | 0 : A, cA = wA - (g = -2097152 & (C = wA - -1048576 | 0)) | 0, g = (A - ((131071 & (B = A - ((wA >>> 0 < 4293918720) - 1 | 0) | 0)) + (g >>> 0 > wA >>> 0) | 0) | 0) + i | 0, v = g = (A = cA + rA | 0) >>> 0 < cA >>> 0 ? g + 1 | 0 : g, L = A, cA = Ig(A, g, 470296, 0), rA = w, g = Ig(e, 0, f, 0), A = w, i = g, g = Ig(y, 0, p, 0), A = w + A | 0, g = g >>> 0 > (i = i + g | 0) >>> 0 ? A + 1 | 0 : A, A = B >>> 21 | 0, B = (2097151 & B) << 11 | C >>> 21, C = A + g | 0, HA = B = (C = B >>> 0 > (i = B + i | 0) >>> 0 ? C + 1 | 0 : C) - ((i >>> 0 < 4293918720) - 1 | 0) | 0, A = i - (g = -2097152 & (KA = i - -1048576 | 0)) | 0, P = i = C - ((131071 & B) + (g >>> 0 > i >>> 0) | 0) | 0, q = g = aA - (C = -2097152 & _A) | 0, j = B = EA - ((C >>> 0 > aA >>> 0) + fA | 0) | 0, X = A, C = Ig(A, i, 666643, 0), A = w + rA | 0, A = C >>> 0 > (i = C + cA | 0) >>> 0 ? A + 1 | 0 : A, C = Ig(g, B, 654183, 0), g = w + A | 0, hA = B = C + i | 0, _A = C >>> 0 > B >>> 0 ? g + 1 | 0 : g, wA = yA - (A = -2097152 & tA) | 0, pA = sA - ((A >>> 0 > yA >>> 0) + pA | 0) | 0, g = Ig(y, 0, k, DA), C = w, B = (A = g) + (g = Ig(G = SA >>> 6 & 2097151, 0, e, 0)) | 0, A = w + C | 0, A = g >>> 0 > B >>> 0 ? A + 1 | 0 : A, g = Ig(s, 0, D, 0), C = w + A | 0, C = g >>> 0 > (B = g + B | 0) >>> 0 ? C + 1 | 0 : C, A = Ig(r, 0, n, 0), g = w + C | 0, g = A >>> 0 > (B = A + B | 0) >>> 0 ? g + 1 | 0 : g, C = Ig(p, 0, M = NA >>> 6 & 2097151, 0), A = w + g | 0, A = C >>> 0 > (B = C + B | 0) >>> 0 ? A + 1 | 0 : A, C = Ig(f, 0, F, S), g = w + A | 0, yA = B = C + B | 0, i = C >>> 0 > B >>> 0 ? g + 1 | 0 : g, g = (A = a[c + 14 | 0]) >>> 24 | 0, B = A << 8 | (sA = a[c + 10 | 0] | a[c + 11 | 0] << 8 | a[c + 12 | 0] << 16 | a[c + 13 | 0] << 24) >>> 24, g = Ig(b = 2097151 & ((1 & (g |= A = (C = a[c + 15 | 0]) >>> 16 | 0)) << 31 | (A = (C <<= 16) | B) >>> 1), 0, e, 0), A = w, C = g, g = Ig(y, 0, G, 0), A = w + A | 0, A = g >>> 0 > (C = C + g | 0) >>> 0 ? A + 1 | 0 : A, B = (g = Ig(n, 0, k, DA)) + C | 0, C = w + A | 0, C = g >>> 0 > B >>> 0 ? C + 1 | 0 : C, A = Ig(s, 0, F, S), g = w + C | 0, g = A >>> 0 > (B = A + B | 0) >>> 0 ? g + 1 | 0 : g, A = Ig(r, 0, D, 0), g = w + g | 0, tA = C = A + B | 0, B = A >>> 0 > C >>> 0 ? g + 1 | 0 : g, g = (A = a[eA + 14 | 0]) >>> 24 | 0, EA = A << 8 | (aA = a[eA + 10 | 0] | a[eA + 11 | 0] << 8 | a[eA + 12 | 0] << 16 | a[eA + 13 | 0] << 24) >>> 24, C = g, g = (A = a[eA + 15 | 0]) >>> 16 | 0, g = Ig(K = 2097151 & ((1 & (g |= C)) << 31 | (A = A << 16 | EA) >>> 1), 0, p, 0), A = w + B | 0, A = g >>> 0 > (C = g + tA | 0) >>> 0 ? A + 1 | 0 : A, g = Ig(f, 0, M, 0), A = w + A | 0, EA = A = g >>> 0 > (tA = g + C | 0) >>> 0 ? A + 1 | 0 : A, YA = g = A - ((tA >>> 0 < 4293918720) - 1 | 0) | 0, C = (A = g >>> 21 | 0) + i | 0, rA = C = (g = (2097151 & g) << 11 | (cA = tA - -1048576 | 0) >>> 21) >>> 0 > (fA = g + yA | 0) >>> 0 ? C + 1 | 0 : C, MA = g = C - ((fA >>> 0 < 4293918720) - 1 | 0) | 0, A = (A = g >>> 21 | 0) + pA | 0, O = A = (g = (C = (2097151 & g) << 11 | (yA = fA - -1048576 | 0) >>> 21) + wA | 0) >>> 0 < C >>> 0 ? A + 1 | 0 : A, V = g, A = Ig(g, A, -997805, -1), g = w + _A | 0, hA = C = A + hA | 0, _A = A >>> 0 > C >>> 0 ? g + 1 | 0 : g, wA = (UA = a[23 + (_ = t + 224 | 0) | 0] | a[_ + 24 | 0] << 8 | a[_ + 25 | 0] << 16 | a[_ + 26 | 0] << 24) >>> 5 & 2097151, C = Ig(H = (A = a[c + 2 | 0]) << 16 & 2031616 | a[0 | c] | a[c + 1 | 0] << 8, 0, n, 0), g = w, B = (A = Ig(D, 0, Y = (i = a[c + 2 | 0] | a[c + 3 | 0] << 8 | a[c + 4 | 0] << 16 | a[c + 5 | 0] << 24) >>> 5 & 2097151, 0)) + C | 0, C = w + g | 0, C = A >>> 0 > B >>> 0 ? C + 1 | 0 : C, A = Ig(d = (a[c + 7 | 0] | a[c + 8 | 0] << 8 | a[c + 9 | 0] << 16 | a[c + 10 | 0] << 24) >>> 7 & 2097151, 0, M, 0), g = w + C | 0, g = A >>> 0 > (B = A + B | 0) >>> 0 ? g + 1 | 0 : g, C = Ig(K, 0, J = sA >>> 4 & 2097151, 0), A = w + g | 0, sA = B = C + B | 0, B = C >>> 0 > B >>> 0 ? A + 1 | 0 : A, i = (g = a[c + 6 | 0]) << 8 | i >>> 24, C = A = g >>> 24 | 0, g = (A = a[c + 7 | 0]) >>> 16 | 0, g = Ig(U = 2097151 & ((3 & (g |= C)) << 30 | (A = A << 16 | i) >>> 2), 0, F, S), A = w + B | 0, A = g >>> 0 > (C = g + sA | 0) >>> 0 ? A + 1 | 0 : A, B = (g = Ig(G, 0, l = (a[eA + 7 | 0] | a[eA + 8 | 0] << 8 | a[eA + 9 | 0] << 16 | a[eA + 10 | 0] << 24) >>> 7 & 2097151, 0)) + C | 0, C = w + A | 0, C = g >>> 0 > B >>> 0 ? C + 1 | 0 : C, g = Ig(b, 0, bA = aA >>> 4 & 2097151, 0), A = w + C | 0, i = g >>> 0 > (B = g + B | 0) >>> 0 ? A + 1 | 0 : A, A = (g = a[eA + 6 | 0]) >>> 24 | 0, sA = g << 8 | (aA = a[eA + 2 | 0] | a[eA + 3 | 0] << 8 | a[eA + 4 | 0] << 16 | a[eA + 5 | 0] << 24) >>> 24, g = A, A = Ig(k, DA, m = 2097151 & ((3 & (g |= C = (A = a[eA + 7 | 0]) >>> 16 | 0)) << 30 | (A = A << 16 | sA) >>> 2), 0), g = w + i | 0, g = A >>> 0 > (C = A + B | 0) >>> 0 ? g + 1 | 0 : g, B = C, C = Ig(u = (A = a[eA + 2 | 0]) << 16 & 2031616 | a[0 | eA] | a[eA + 1 | 0] << 8, 0, s, 0), A = w + g | 0, A = C >>> 0 > (B = B + C | 0) >>> 0 ? A + 1 | 0 : A, g = Ig(r, 0, x = aA >>> 5 & 2097151, 0), A = w + A | 0, A = g >>> 0 > (C = g + B | 0) >>> 0 ? A + 1 | 0 : A, g = C, sA = C = C + wA | 0, i = g = g >>> 0 > C >>> 0 ? A + 1 | 0 : A, B = a[_ + 21 | 0] | a[_ + 22 | 0] << 8, A = Ig(D, 0, H, 0), g = w, aA = (C = A) + (A = Ig(F, S, Y, 0)) | 0, C = w + g | 0, C = A >>> 0 > aA >>> 0 ? C + 1 | 0 : C, A = Ig(K, 0, d, 0), g = w + C | 0, g = A >>> 0 > (aA = A + aA | 0) >>> 0 ? g + 1 | 0 : g, A = Ig(J, 0, bA, 0), g = w + g | 0, g = A >>> 0 > (C = A + aA | 0) >>> 0 ? g + 1 | 0 : g, aA = (A = C) + (C = Ig(M, 0, U, 0)) | 0, A = w + g | 0, A = C >>> 0 > aA >>> 0 ? A + 1 | 0 : A, g = Ig(G, 0, m, 0), A = w + A | 0, A = g >>> 0 > (C = g + aA | 0) >>> 0 ? A + 1 | 0 : A, aA = (g = Ig(b, 0, l, 0)) + C | 0, C = w + A | 0, C = g >>> 0 > aA >>> 0 ? C + 1 | 0 : C, A = Ig(k, DA, x, 0), g = w + C | 0, g = A >>> 0 > (aA = A + aA | 0) >>> 0 ? g + 1 | 0 : g, A = Ig(r, 0, u, 0), g = w + g | 0, A = A >>> 0 > (C = A + aA | 0) >>> 0 ? g + 1 | 0 : g, g = (g = C) >>> 0 > (C = C + B | 0) >>> 0 ? A + 1 | 0 : A, B = C, C = (A = a[_ + 23 | 0]) << 16 & 2031616, A = g, C = A = C >>> 0 > (B = B + C | 0) >>> 0 ? A + 1 | 0 : A, eA = A = A - ((B >>> 0 < 4293918720) - 1 | 0) | 0, g = (g = A >>> 21 | 0) + i | 0, A = (g = (i = sA = (A = (2097151 & A) << 11 | (aA = B - -1048576 | 0) >>> 21) + sA | 0) >>> 0 < A >>> 0 ? g + 1 | 0 : g) + _A | 0, A = (_A = i + hA | 0) >>> 0 < i >>> 0 ? A + 1 | 0 : A, SA = i - -1048576 | 0, FA = i = g - ((i >>> 0 < 4293918720) - 1 | 0) | 0, GA = _A - (g = -2097152 & SA) | 0, dA = A - ((g >>> 0 > _A >>> 0) + i | 0) | 0, sA = B, _A = C, A = Ig(q, j, 470296, 0), g = w, C = A, A = Ig(L, v, 666643, 0), g = w + g | 0, g = A >>> 0 > (C = C + A | 0) >>> 0 ? g + 1 | 0 : g, B = (A = C) + (C = Ig(V, O, 654183, 0)) | 0, A = w + g | 0, NA = B, i = C >>> 0 > B >>> 0 ? A + 1 | 0 : A, g = Ig(F, S, H, 0), A = w, C = g, g = Ig(M, 0, Y, 0), A = w + A | 0, A = g >>> 0 > (C = C + g | 0) >>> 0 ? A + 1 | 0 : A, B = (g = C) + (C = Ig(d, 0, bA, 0)) | 0, g = w + A | 0, g = C >>> 0 > B >>> 0 ? g + 1 | 0 : g, A = Ig(J, 0, l, 0), C = w + g | 0, C = A >>> 0 > (B = A + B | 0) >>> 0 ? C + 1 | 0 : C, A = Ig(K, 0, U, 0), g = w + C | 0, g = A >>> 0 > (B = A + B | 0) >>> 0 ? g + 1 | 0 : g, C = Ig(G, 0, x, 0), A = w + g | 0, A = C >>> 0 > (B = C + B | 0) >>> 0 ? A + 1 | 0 : A, g = Ig(b, 0, m, 0), A = w + A | 0, A = g >>> 0 > (C = g + B | 0) >>> 0 ? A + 1 | 0 : A, B = (g = C) + (C = Ig(k, DA, u, 0)) | 0, g = w + A | 0, wA = B, C = C >>> 0 > B >>> 0 ? g + 1 | 0 : g, g = (A = a[_ + 19 | 0]) >>> 24 | 0, pA = A << 8 | (hA = a[_ + 15 | 0] | a[_ + 16 | 0] << 8 | a[_ + 17 | 0] << 16 | a[_ + 18 | 0] << 24) >>> 24, C = ((JA = (A = (B = a[_ + 20 | 0]) >>> 16 | 0) | g) >>> 3 | 0) + C | 0, wA = B = (g = (7 & JA) << 29 | (g = (B <<= 16) | pA) >>> 3) + wA | 0, B = g >>> 0 > B >>> 0 ? C + 1 | 0 : C, pA = hA >>> 6 & 2097151, A = Ig(M, 0, H, 0), g = w, C = A, A = Ig(K, 0, Y, 0), g = w + g | 0, g = A >>> 0 > (C = C + A | 0) >>> 0 ? g + 1 | 0 : g, hA = (A = C) + (C = Ig(d, 0, l, 0)) | 0, A = w + g | 0, A = C >>> 0 > hA >>> 0 ? A + 1 | 0 : A, C = Ig(J, 0, m, 0), g = w + A | 0, g = C >>> 0 > (hA = C + hA | 0) >>> 0 ? g + 1 | 0 : g, C = Ig(U, 0, bA, 0), A = w + g | 0, A = C >>> 0 > (hA = C + hA | 0) >>> 0 ? A + 1 | 0 : A, g = Ig(G, 0, u, 0), C = w + A | 0, C = g >>> 0 > (hA = g + hA | 0) >>> 0 ? C + 1 | 0 : C, A = Ig(b, 0, x, 0), g = w + C | 0, A = A >>> 0 > (hA = A + hA | 0) >>> 0 ? g + 1 | 0 : g, qA = A = (mA = hA + pA | 0) >>> 0 < hA >>> 0 ? A + 1 | 0 : A, WA = A = A - ((mA >>> 0 < 4293918720) - 1 | 0) | 0, C = (2097151 & A) << 11 | (LA = mA - -1048576 | 0) >>> 21, A = (A >>> 21 | 0) + B | 0, jA = A = C >>> 0 > (zA = C + wA | 0) >>> 0 ? A + 1 | 0 : A, TA = A = A - ((zA >>> 0 < 4293918720) - 1 | 0) | 0, C = (2097151 & A) << 11 | (xA = zA - -1048576 | 0) >>> 21, A = (A >>> 21 | 0) + i | 0, g = (C >>> 0 > (B = C + NA | 0) >>> 0 ? A + 1 | 0 : A) + _A | 0, _A = (C = B + sA | 0) - (A = -2097152 & aA) | 0, eA = A = (g = C >>> 0 < B >>> 0 ? g + 1 | 0 : g) - ((A >>> 0 > C >>> 0) + eA | 0) | 0, $A = A = A - ((_A >>> 0 < 4293918720) - 1 | 0) | 0, C = (2097151 & A) << 11 | (RA = _A - -1048576 | 0) >>> 21, A = (A >> 21) + dA | 0, B = A = C >>> 0 > (i = C + GA | 0) >>> 0 ? A + 1 | 0 : A, ZA = A = A - ((i >>> 0 < 4293918720) - 1 | 0) | 0, vA = (2097151 & A) << 11 | (NA = i - -1048576 | 0) >>> 21, sA = A >> 21, JA = fA - (A = -2097152 & yA) | 0, MA = rA - ((A >>> 0 > fA >>> 0) + MA | 0) | 0, A = Ig(e, 0, p, 0), PA = g = w, GA = A, hA = A - -1048576 | 0, uA = g = g - ((A >>> 0 < 4293918720) - 1 | 0) | 0, Z = A = g >>> 21 | 0, A = Ig(R = (2097151 & g) << 11 | hA >>> 21, A, -683901, -1), g = w + EA | 0, g = A >>> 0 > (C = A + tA | 0) >>> 0 ? g + 1 | 0 : g, yA = C - (A = -2097152 & cA) | 0, aA = g - ((A >>> 0 > C >>> 0) + YA | 0) | 0, g = Ig(n, 0, G, 0), A = w, C = g, g = Ig(e, 0, J, 0), A = w + A | 0, A = g >>> 0 > (C = C + g | 0) >>> 0 ? A + 1 | 0 : A, g = Ig(y, 0, b, 0), A = w + A | 0, A = g >>> 0 > (C = g + C | 0) >>> 0 ? A + 1 | 0 : A, EA = (g = C) + (C = Ig(D, 0, k, DA)) | 0, g = w + A | 0, g = C >>> 0 > EA >>> 0 ? g + 1 | 0 : g, A = Ig(s, 0, M, 0), C = w + g | 0, C = A >>> 0 > (EA = A + EA | 0) >>> 0 ? C + 1 | 0 : C, A = Ig(r, 0, F, S), g = w + C | 0, g = A >>> 0 > (EA = A + EA | 0) >>> 0 ? g + 1 | 0 : g, C = Ig(p, 0, bA, 0), A = w + g | 0, A = C >>> 0 > (EA = C + EA | 0) >>> 0 ? A + 1 | 0 : A, g = Ig(f, 0, K, 0), A = w + A | 0, tA = C = g + EA | 0, EA = g >>> 0 > C >>> 0 ? A + 1 | 0 : A, A = Ig(y, 0, J, 0), g = w, C = A, A = Ig(e, 0, d, 0), g = w + g | 0, g = A >>> 0 > (C = C + A | 0) >>> 0 ? g + 1 | 0 : g, rA = (A = Ig(D, 0, G, 0)) + C | 0, C = w + g | 0, C = A >>> 0 > rA >>> 0 ? C + 1 | 0 : C, A = Ig(n, 0, b, 0), g = w + C | 0, g = A >>> 0 > (rA = A + rA | 0) >>> 0 ? g + 1 | 0 : g, C = Ig(k, DA, F, S), A = w + g | 0, A = C >>> 0 > (rA = C + rA | 0) >>> 0 ? A + 1 | 0 : A, g = Ig(s, 0, K, 0), A = w + A | 0, A = g >>> 0 > (C = g + rA | 0) >>> 0 ? A + 1 | 0 : A, rA = (g = C) + (C = Ig(r, 0, M, 0)) | 0, g = w + A | 0, g = C >>> 0 > rA >>> 0 ? g + 1 | 0 : g, A = Ig(p, 0, l, 0), C = w + g | 0, C = A >>> 0 > (rA = A + rA | 0) >>> 0 ? C + 1 | 0 : C, A = Ig(f, 0, bA, 0), g = w + C | 0, pA = g = A >>> 0 > (wA = A + rA | 0) >>> 0 ? g + 1 | 0 : g, OA = A = g - ((wA >>> 0 < 4293918720) - 1 | 0) | 0, g = (2097151 & A) << 11 | (fA = wA - -1048576 | 0) >>> 21, A = (A >>> 21 | 0) + EA | 0, cA = A = g >>> 0 > (YA = g + tA | 0) >>> 0 ? A + 1 | 0 : A, lA = A = A - ((YA >>> 0 < 4293918720) - 1 | 0) | 0, g = (C = A >>> 21 | 0) + aA | 0, yA = g = (A = (2097151 & A) << 11 | (rA = YA - -1048576 | 0) >>> 21) >>> 0 > (dA = A + yA | 0) >>> 0 ? g + 1 | 0 : g, XA = A = g - ((dA >>> 0 < 4293918720) - 1 | 0) | 0, EA = (2097151 & A) << 11 | (aA = dA - -1048576 | 0) >>> 21, A = (A >> 21) + MA | 0, W = A = (g = EA + JA | 0) >>> 0 < EA >>> 0 ? A + 1 | 0 : A, T = g, A = Ig(g, A, -683901, -1), g = w + sA | 0, vA = C = A + vA | 0, sA = A >>> 0 > C >>> 0 ? g + 1 | 0 : g, A = Ig(y, 0, H, 0), g = w, C = A, A = Ig(n, 0, Y, 0), g = w + g | 0, g = A >>> 0 > (C = C + A | 0) >>> 0 ? g + 1 | 0 : g, EA = (A = C) + (C = Ig(F, S, d, 0)) | 0, A = w + g | 0, A = C >>> 0 > EA >>> 0 ? A + 1 | 0 : A, g = Ig(M, 0, J, 0), C = w + A | 0, C = g >>> 0 > (EA = g + EA | 0) >>> 0 ? C + 1 | 0 : C, g = Ig(D, 0, U, 0), A = w + C | 0, A = g >>> 0 > (EA = g + EA | 0) >>> 0 ? A + 1 | 0 : A, C = Ig(G, 0, bA, 0), g = w + A | 0, g = C >>> 0 > (EA = C + EA | 0) >>> 0 ? g + 1 | 0 : g, A = Ig(b, 0, K, 0), g = w + g | 0, g = A >>> 0 > (C = A + EA | 0) >>> 0 ? g + 1 | 0 : g, EA = (A = C) + (C = Ig(k, DA, l, 0)) | 0, A = w + g | 0, A = C >>> 0 > EA >>> 0 ? A + 1 | 0 : A, g = Ig(s, 0, x, 0), C = w + A | 0, C = g >>> 0 > (EA = g + EA | 0) >>> 0 ? C + 1 | 0 : C, g = Ig(r, 0, m, 0), A = w + C | 0, A = g >>> 0 > (EA = g + EA | 0) >>> 0 ? A + 1 | 0 : A, C = Ig(f, 0, u, 0), g = w + A | 0, MA = EA = C + EA | 0, C = C >>> 0 > EA >>> 0 ? g + 1 | 0 : g, g = (A = a[_ + 27 | 0]) >>> 24 | 0, tA = A << 8 | UA >>> 24, EA = 2097151 & ((3 & (g |= A = (EA = a[_ + 28 | 0]) >>> 16 | 0)) << 30 | (A = (EA <<= 16) | tA) >>> 2), g = C, tA = A = EA + MA | 0, EA = A >>> 0 < EA >>> 0 ? g + 1 | 0 : g, JA = Ig(X, P, 470296, 0), MA = w, A = (C = (2097151 & HA) << 11 | KA >>> 21) + (GA - (g = -2097152 & hA) | 0) | 0, g = PA - ((524287 & uA) + (g >>> 0 > GA >>> 0) | 0) + (HA >>> 21) | 0, $ = g = A >>> 0 < C >>> 0 ? g + 1 | 0 : g, AA = A, g = Ig(A, g, 666643, 0), A = w + MA | 0, A = g >>> 0 > (C = g + JA | 0) >>> 0 ? A + 1 | 0 : A, hA = (g = Ig(L, v, 654183, 0)) + C | 0, C = w + A | 0, C = g >>> 0 > hA >>> 0 ? C + 1 | 0 : C, g = Ig(q, j, -997805, -1), A = w + C | 0, A = g >>> 0 > (hA = g + hA | 0) >>> 0 ? A + 1 | 0 : A, C = Ig(V, O, 136657, 0), g = w + A | 0, SA = (A = (2097151 & FA) << 11 | SA >>> 21) + (hA = C + hA | 0) | 0, g = (FA >>> 21 | 0) + (C >>> 0 > hA >>> 0 ? g + 1 | 0 : g) | 0, uA = hA = EA - ((tA >>> 0 < 4293918720) - 1 | 0) | 0, A = (A >>> 0 > SA >>> 0 ? g + 1 | 0 : g) + EA | 0, g = (EA = tA + SA | 0) - (C = -2097152 & (PA = tA - -1048576 | 0)) | 0, C = (A = (A = EA >>> 0 < SA >>> 0 ? A + 1 | 0 : A) - ((C >>> 0 > EA >>> 0) + hA | 0) | 0) + sA | 0, JA = EA = A - ((g >>> 0 < 4293918720) - 1 | 0) | 0, GA = (C = (tA = g + vA | 0) >>> 0 < g >>> 0 ? C + 1 | 0 : C) - (((g = -2097152 & (MA = g - -1048576 | 0)) >>> 0 > tA >>> 0) + EA | 0) | 0, UA = A = tA - g | 0, EA = i, i = B, VA = dA - (A = -2097152 & aA) | 0, hA = yA - ((A >>> 0 > dA >>> 0) + XA | 0) | 0, A = Ig(AA, $, -683901, -1), g = w, B = (C = A) + (A = Ig(R, Z, 136657, 0)) | 0, C = w + g | 0, g = cA + (A >>> 0 > B >>> 0 ? C + 1 | 0 : C) | 0, rA = (C = B + YA | 0) - (A = -2097152 & rA) | 0, yA = (g = C >>> 0 < YA >>> 0 ? g + 1 | 0 : g) - ((A >>> 0 > C >>> 0) + lA | 0) | 0, g = Ig(R, Z, -997805, -1), A = w + pA | 0, A = g >>> 0 > (C = g + wA | 0) >>> 0 ? A + 1 | 0 : A, B = (g = Ig(AA, $, 136657, 0)) + C | 0, C = w + A | 0, C = g >>> 0 > B >>> 0 ? C + 1 | 0 : C, A = Ig(X, P, -683901, -1), g = w + C | 0, g = A >>> 0 > (B = A + B | 0) >>> 0 ? g + 1 | 0 : g, aA = B - (A = -2097152 & fA) | 0, sA = g - ((A >>> 0 > B >>> 0) + OA | 0) | 0, g = Ig(n, 0, J, 0), A = w, C = g, g = Ig(y, 0, d, 0), A = w + A | 0, A = g >>> 0 > (C = C + g | 0) >>> 0 ? A + 1 | 0 : A, B = (g = Ig(e, 0, U, 0)) + C | 0, C = w + A | 0, C = g >>> 0 > B >>> 0 ? C + 1 | 0 : C, A = Ig(F, S, G, 0), g = w + C | 0, g = A >>> 0 > (B = A + B | 0) >>> 0 ? g + 1 | 0 : g, C = Ig(D, 0, b, 0), A = w + g | 0, A = C >>> 0 > (B = C + B | 0) >>> 0 ? A + 1 | 0 : A, C = Ig(k, DA, M, 0), g = w + A | 0, g = C >>> 0 > (B = C + B | 0) >>> 0 ? g + 1 | 0 : g, C = Ig(s, 0, bA, 0), A = w + g | 0, A = C >>> 0 > (B = C + B | 0) >>> 0 ? A + 1 | 0 : A, g = Ig(r, 0, K, 0), C = w + A | 0, C = g >>> 0 > (B = g + B | 0) >>> 0 ? C + 1 | 0 : C, A = Ig(p, 0, m, 0), g = w + C | 0, g = A >>> 0 > (B = A + B | 0) >>> 0 ? g + 1 | 0 : g, C = Ig(f, 0, l, 0), A = w + g | 0, tA = B = C + B | 0, B = C >>> 0 > B >>> 0 ? A + 1 | 0 : A, A = Ig(n, 0, d, 0), g = w, C = A, A = Ig(e, 0, Y, 0), g = w + g | 0, g = A >>> 0 > (C = C + A | 0) >>> 0 ? g + 1 | 0 : g, cA = (A = C) + (C = Ig(D, 0, J, 0)) | 0, A = w + g | 0, A = C >>> 0 > cA >>> 0 ? A + 1 | 0 : A, g = Ig(y, 0, U, 0), C = w + A | 0, C = g >>> 0 > (cA = g + cA | 0) >>> 0 ? C + 1 | 0 : C, A = Ig(G, 0, M, 0), g = w + C | 0, g = A >>> 0 > (cA = A + cA | 0) >>> 0 ? g + 1 | 0 : g, C = Ig(F, S, b, 0), A = w + g | 0, A = C >>> 0 > (cA = C + cA | 0) >>> 0 ? A + 1 | 0 : A, C = Ig(k, DA, K, 0), g = w + A | 0, g = C >>> 0 > (cA = C + cA | 0) >>> 0 ? g + 1 | 0 : g, C = Ig(s, 0, l, 0), A = w + g | 0, A = C >>> 0 > (cA = C + cA | 0) >>> 0 ? A + 1 | 0 : A, g = Ig(r, 0, bA, 0), C = w + A | 0, C = g >>> 0 > (cA = g + cA | 0) >>> 0 ? C + 1 | 0 : C, cA = (A = Ig(p, 0, x, 0)) + cA | 0, g = w + C | 0, C = Ig(f, 0, m, 0), A = w + (A >>> 0 > cA >>> 0 ? g + 1 | 0 : g) | 0, dA = A = C >>> 0 > (XA = C + cA | 0) >>> 0 ? A + 1 | 0 : A, gA = A = A - ((XA >>> 0 < 4293918720) - 1 | 0) | 0, C = (2097151 & A) << 11 | (HA = XA - -1048576 | 0) >>> 21, A = (A >>> 21 | 0) + B | 0, KA = A = C >>> 0 > (vA = C + tA | 0) >>> 0 ? A + 1 | 0 : A, CA = A = A - ((vA >>> 0 < 4293918720) - 1 | 0) | 0, C = (2097151 & A) << 11 | (FA = vA - -1048576 | 0) >>> 21, A = (A >>> 21 | 0) + sA | 0, SA = A = C >>> 0 > (YA = C + aA | 0) >>> 0 ? A + 1 | 0 : A, BA = A = A - ((YA >>> 0 < 4293918720) - 1 | 0) | 0, C = (2097151 & A) << 11 | (pA = YA - -1048576 | 0) >>> 21, A = (A >> 21) + yA | 0, B = A = C >>> 0 > (aA = C + rA | 0) >>> 0 ? A + 1 | 0 : A, yA = A = A - ((aA >>> 0 < 4293918720) - 1 | 0) | 0, sA = (2097151 & A) << 11 | (C = aA - -1048576 | 0) >>> 21, A = (A >> 21) + hA | 0, OA = A = (tA = sA + VA | 0) >>> 0 < sA >>> 0 ? A + 1 | 0 : A, lA = tA, A = Ig(tA, A, -683901, -1), g = w, tA = A, A = Ig(T, W, 136657, 0), g = w + g | 0, A = (A >>> 0 > (tA = tA + A | 0) >>> 0 ? g + 1 | 0 : g) + i | 0, AI = (i = EA + tA | 0) - (g = -2097152 & NA) | 0, II = (A = i >>> 0 < tA >>> 0 ? A + 1 | 0 : A) - ((g >>> 0 > i >>> 0) + ZA | 0) | 0, sA = _A, tA = eA, _A = Ig(lA, OA, 136657, 0), i = w, VA = A = aA - (g = -2097152 & C) | 0, IA = B = B - ((g >>> 0 > aA >>> 0) + yA | 0) | 0, C = Ig(T, W, -997805, -1), g = w + i | 0, g = C >>> 0 > (_A = C + _A | 0) >>> 0 ? g + 1 | 0 : g, C = Ig(A, B, -683901, -1), A = w + g | 0, ZA = B = C + _A | 0, EA = C >>> 0 > B >>> 0 ? A + 1 | 0 : A, A = Ig(V, O, 470296, 0), g = w, B = (C = A) + (A = Ig(q, j, 666643, 0)) | 0, C = w + g | 0, g = jA + (A >>> 0 > B >>> 0 ? C + 1 | 0 : C) | 0, hA = A = B + zA | 0, i = g = A >>> 0 < zA >>> 0 ? g + 1 | 0 : g, g = Ig(V, O, 666643, 0), A = w + qA | 0, A = g >>> 0 > (C = g + mA | 0) >>> 0 ? A + 1 | 0 : A, rA = C - (g = -2097152 & LA) | 0, wA = A - ((g >>> 0 > C >>> 0) + WA | 0) | 0, g = Ig(K, 0, H, 0), A = w, C = g, g = Ig(Y, 0, bA, 0), A = w + A | 0, A = g >>> 0 > (C = C + g | 0) >>> 0 ? A + 1 | 0 : A, B = (g = C) + (C = Ig(d, 0, m, 0)) | 0, g = w + A | 0, g = C >>> 0 > B >>> 0 ? g + 1 | 0 : g, C = Ig(J, 0, x, 0), A = w + g | 0, A = C >>> 0 > (B = C + B | 0) >>> 0 ? A + 1 | 0 : A, g = Ig(U, 0, l, 0), C = w + A | 0, C = g >>> 0 > (B = g + B | 0) >>> 0 ? C + 1 | 0 : C, A = Ig(b, 0, u, 0), g = w + C | 0, aA = B = A + B | 0, B = A >>> 0 > B >>> 0 ? g + 1 | 0 : g, g = (A = a[_ + 14 | 0]) >>> 24 | 0, _A = A << 8 | (yA = a[_ + 10 | 0] | a[_ + 11 | 0] << 8 | a[_ + 12 | 0] << 16 | a[_ + 13 | 0] << 24) >>> 24, g = 2097151 & ((1 & (g |= C = (A = a[_ + 15 | 0]) >>> 16 | 0)) << 31 | (A = _A | A << 16) >>> 1), A = B, aA = C = g + aA | 0, B = g >>> 0 > C >>> 0 ? A + 1 | 0 : A, _A = yA >>> 4 & 2097151, A = Ig(H, 0, bA, 0), g = w, C = A, A = Ig(Y, 0, l, 0), g = w + g | 0, g = A >>> 0 > (C = C + A | 0) >>> 0 ? g + 1 | 0 : g, A = Ig(d, 0, x, 0), g = w + g | 0, g = A >>> 0 > (C = A + C | 0) >>> 0 ? g + 1 | 0 : g, yA = (A = C) + (C = Ig(J, 0, u, 0)) | 0, A = w + g | 0, A = C >>> 0 > yA >>> 0 ? A + 1 | 0 : A, g = Ig(U, 0, m, 0), C = w + A | 0, A = g >>> 0 > (yA = g + yA | 0) >>> 0 ? C + 1 | 0 : C, eA = A = (LA = _A + yA | 0) >>> 0 < yA >>> 0 ? A + 1 | 0 : A, QA = A = A - ((LA >>> 0 < 4293918720) - 1 | 0) | 0, g = (C = A >>> 21 | 0) + B | 0, fA = g = (A = (2097151 & A) << 11 | (NA = LA - -1048576 | 0) >>> 21) >>> 0 > (jA = A + aA | 0) >>> 0 ? g + 1 | 0 : g, iA = A = g - ((jA >>> 0 < 4293918720) - 1 | 0) | 0, g = (2097151 & A) << 11 | (cA = jA - -1048576 | 0) >>> 21, A = (A >>> 21 | 0) + wA | 0, yA = A = g >>> 0 > (rA = g + rA | 0) >>> 0 ? A + 1 | 0 : A, oA = A = A - ((rA >>> 0 < 4293918720) - 1 | 0) | 0, g = (C = A >> 21) + i | 0, WA = g = (g = (A = (2097151 & A) << 11 | (aA = rA - -1048576 | 0) >>> 21) >>> 0 > (B = A + hA | 0) >>> 0 ? g + 1 | 0 : g) - (((C = -2097152 & xA) >>> 0 > B >>> 0) + TA | 0) | 0, xA = A = B - C | 0, _A = A - -1048576 | 0, TA = A = g - ((A >>> 0 < 4293918720) - 1 | 0) | 0, C = (g = A >> 21) + EA | 0, g = ((A = (2097151 & A) << 11 | _A >>> 21) >>> 0 > (B = A + ZA | 0) >>> 0 ? C + 1 | 0 : C) + tA | 0, mA = g = (g = (A = B) >>> 0 > (B = B + sA | 0) >>> 0 ? g + 1 | 0 : g) - (((C = -2097152 & RA) >>> 0 > B >>> 0) + $A | 0) | 0, tA = A = B - C | 0, i = A - -1048576 | 0, qA = A = g - ((A >>> 0 < 4293918720) - 1 | 0) | 0, C = (g = A >> 21) + II | 0, RA = A = (C = (A = (2097151 & A) << 11 | i >>> 21) >>> 0 > (EA = A + AI | 0) >>> 0 ? C + 1 | 0 : C) - ((EA >>> 0 < 4293918720) - 1 | 0) | 0, hA = UA - -1048576 | 0, wA = GA - ((UA >>> 0 < 4293918720) - 1 | 0) | 0, sA = (2097151 & A) << 11 | (B = EA - -1048576 | 0) >>> 21, A = (A >> 21) + GA | 0, $A = (UA = sA + UA | 0) - (g = -2097152 & hA) | 0, AI = (sA >>> 0 > UA >>> 0 ? A + 1 | 0 : A) - ((g >>> 0 > UA >>> 0) + wA | 0) | 0, II = EA - (A = -2097152 & B) | 0, ZA = C - ((A >>> 0 > EA >>> 0) + RA | 0) | 0, zA = tA - (A = -2097152 & i) | 0, UA = mA - ((A >>> 0 > tA >>> 0) + qA | 0) | 0, A = Ig(lA, OA, -997805, -1), g = w, C = A, A = Ig(T, W, 654183, 0), g = w + g | 0, g = A >>> 0 > (C = C + A | 0) >>> 0 ? g + 1 | 0 : g, B = (A = C) + (C = Ig(VA, IA, 136657, 0)) | 0, A = w + g | 0, g = WA + (C >>> 0 > B >>> 0 ? A + 1 | 0 : A) | 0, mA = (C = B + xA | 0) - (A = -2097152 & _A) | 0, qA = (g = C >>> 0 < xA >>> 0 ? g + 1 | 0 : g) - ((A >>> 0 > C >>> 0) + TA | 0) | 0, xA = YA - (A = -2097152 & pA) | 0, GA = SA - ((A >>> 0 > YA >>> 0) + BA | 0) | 0, g = Ig(AA, $, -997805, -1), A = w, C = g, g = Ig(R, Z, 654183, 0), A = w + A | 0, A = g >>> 0 > (C = C + g | 0) >>> 0 ? A + 1 | 0 : A, B = (g = C) + (C = Ig(X, P, 136657, 0)) | 0, g = w + A | 0, g = C >>> 0 > B >>> 0 ? g + 1 | 0 : g, A = Ig(L, v, -683901, -1), C = w + g | 0, g = KA + (A >>> 0 > (B = A + B | 0) >>> 0 ? C + 1 | 0 : C) | 0, pA = (C = B + vA | 0) - (A = -2097152 & FA) | 0, SA = (g = C >>> 0 < vA >>> 0 ? g + 1 | 0 : g) - ((A >>> 0 > C >>> 0) + CA | 0) | 0, g = Ig(AA, $, 654183, 0), A = w, C = g, g = Ig(R, Z, 470296, 0), A = w + A | 0, A = g >>> 0 > (C = C + g | 0) >>> 0 ? A + 1 | 0 : A, B = (g = Ig(X, P, -997805, -1)) + C | 0, C = w + A | 0, g = dA + (g >>> 0 > B >>> 0 ? C + 1 | 0 : C) | 0, g = (A = B + XA | 0) >>> 0 < XA >>> 0 ? g + 1 | 0 : g, C = A, A = Ig(L, v, 136657, 0), g = w + g | 0, g = A >>> 0 > (C = C + A | 0) >>> 0 ? g + 1 | 0 : g, B = (A = C) + (C = Ig(q, j, -683901, -1)) | 0, A = w + g | 0, _A = B - (g = -2097152 & HA) | 0, i = (C >>> 0 > B >>> 0 ? A + 1 | 0 : A) - ((g >>> 0 > B >>> 0) + gA | 0) | 0, B = (a[_ + 28 | 0] | a[_ + 29 | 0] << 8 | a[_ + 30 | 0] << 16 | a[_ + 31 | 0] << 24) >>> 7 | 0, A = Ig(e, 0, H, 0), g = w, EA = (C = A) + (A = Ig(y, 0, Y, 0)) | 0, C = w + g | 0, C = A >>> 0 > EA >>> 0 ? C + 1 | 0 : C, A = Ig(D, 0, d, 0), g = w + C | 0, g = A >>> 0 > (EA = A + EA | 0) >>> 0 ? g + 1 | 0 : g, C = Ig(F, S, J, 0), A = w + g | 0, A = C >>> 0 > (EA = C + EA | 0) >>> 0 ? A + 1 | 0 : A, C = Ig(n, 0, U, 0), g = w + A | 0, g = C >>> 0 > (EA = C + EA | 0) >>> 0 ? g + 1 | 0 : g, C = Ig(G, 0, K, 0), A = w + g | 0, A = C >>> 0 > (EA = C + EA | 0) >>> 0 ? A + 1 | 0 : A, g = Ig(M, 0, b, 0), C = w + A | 0, C = g >>> 0 > (EA = g + EA | 0) >>> 0 ? C + 1 | 0 : C, A = Ig(k, DA, bA, 0), g = w + C | 0, g = A >>> 0 > (EA = A + EA | 0) >>> 0 ? g + 1 | 0 : g, C = Ig(s, 0, m, 0), A = w + g | 0, A = C >>> 0 > (EA = C + EA | 0) >>> 0 ? A + 1 | 0 : A, C = Ig(r, 0, l, 0), g = w + A | 0, g = C >>> 0 > (EA = C + EA | 0) >>> 0 ? g + 1 | 0 : g, C = Ig(p, 0, u, 0), A = w + g | 0, A = C >>> 0 > (EA = C + EA | 0) >>> 0 ? A + 1 | 0 : A, g = Ig(f, 0, x, 0), C = w + A | 0, g = C = g >>> 0 > (EA = g + EA | 0) >>> 0 ? C + 1 | 0 : C, KA = (C = (2097151 & uA) << 11 | PA >>> 21) + (A = B + EA | 0) | 0, A = (uA >>> 21 | 0) + (g = A >>> 0 < EA >>> 0 ? g + 1 | 0 : g) | 0, sA = A = C >>> 0 > KA >>> 0 ? A + 1 | 0 : A, RA = g = A - ((KA >>> 0 < 4293918720) - 1 | 0) | 0, C = (A = g >>> 21 | 0) + i | 0, tA = C = (g = (2097151 & g) << 11 | (DA = KA - -1048576 | 0) >>> 21) >>> 0 > (FA = g + _A | 0) >>> 0 ? C + 1 | 0 : C, PA = g = C - ((FA >>> 0 < 4293918720) - 1 | 0) | 0, A = (A = g >> 21) + SA | 0, _A = A = (g = (2097151 & g) << 11 | (EA = FA - -1048576 | 0) >>> 21) >>> 0 > (pA = g + pA | 0) >>> 0 ? A + 1 | 0 : A, HA = g = A - ((pA >>> 0 < 4293918720) - 1 | 0) | 0, C = (A = g >> 21) + GA | 0, uA = C = (g = (B = (2097151 & g) << 11 | (i = pA - -1048576 | 0) >>> 21) + xA | 0) >>> 0 < B >>> 0 ? C + 1 | 0 : C, GA = g, A = Ig(g, C, -683901, -1), g = w + qA | 0, SA = C = A + mA | 0, B = A >>> 0 > C >>> 0 ? g + 1 | 0 : g, g = Ig(T, W, 470296, 0), A = w + yA | 0, A = g >>> 0 > (rA = g + rA | 0) >>> 0 ? A + 1 | 0 : A, g = Ig(lA, OA, 654183, 0), A = w + (A - (((C = -2097152 & aA) >>> 0 > rA >>> 0) + oA | 0) | 0) | 0, A = g >>> 0 > (aA = g + (rA - C | 0) | 0) >>> 0 ? A + 1 | 0 : A, C = Ig(VA, IA, -997805, -1), g = w + A | 0, g = C >>> 0 > (aA = C + aA | 0) >>> 0 ? g + 1 | 0 : g, dA = C = pA - (A = -2097152 & i) | 0, bA = _A = _A - ((A >>> 0 > pA >>> 0) + HA | 0) | 0, aA = (i = Ig(GA, uA, 136657, 0)) + aA | 0, A = w + g | 0, C = Ig(C, _A, -683901, -1), g = w + (i >>> 0 > aA >>> 0 ? A + 1 | 0 : A) | 0, _A = g = C >>> 0 > (yA = C + aA | 0) >>> 0 ? g + 1 | 0 : g, HA = A = g - ((yA >>> 0 < 4293918720) - 1 | 0) | 0, g = (2097151 & A) << 11 | (i = yA - -1048576 | 0) >>> 21, A = (A >> 21) + B | 0, pA = g = (A = g >>> 0 > (aA = g + SA | 0) >>> 0 ? A + 1 | 0 : A) - ((aA >>> 0 < 4293918720) - 1 | 0) | 0, rA = (2097151 & g) << 11 | (B = aA - -1048576 | 0) >>> 21, g = (g >> 21) + UA | 0, zA = SA = rA + zA | 0, SA = rA >>> 0 > SA >>> 0 ? g + 1 | 0 : g, UA = aA - (g = -2097152 & B) | 0, XA = A - ((g >>> 0 > aA >>> 0) + pA | 0) | 0, mA = yA - (A = -2097152 & i) | 0, qA = _A - ((A >>> 0 > yA >>> 0) + HA | 0) | 0, A = Ig(T, W, 666643, 0), C = fA + w | 0, C = (i = A + jA | 0) >>> 0 < jA >>> 0 ? C + 1 | 0 : C, B = (A = Ig(lA, OA, 470296, 0)) + (i - (g = -2097152 & cA) | 0) | 0, g = w + (C - ((g >>> 0 > i >>> 0) + iA | 0) | 0) | 0, g = A >>> 0 > B >>> 0 ? g + 1 | 0 : g, C = Ig(VA, IA, 654183, 0), A = w + g | 0, aA = B = C + B | 0, B = C >>> 0 > B >>> 0 ? A + 1 | 0 : A, i = FA - (A = -2097152 & EA) | 0, _A = tA - ((A >>> 0 > FA >>> 0) + PA | 0) | 0, A = Ig(AA, $, 470296, 0), g = w, C = A, A = Ig(R, Z, 666643, 0), g = w + g | 0, g = A >>> 0 > (C = C + A | 0) >>> 0 ? g + 1 | 0 : g, A = Ig(X, P, 654183, 0), g = w + g | 0, g = A >>> 0 > (C = A + C | 0) >>> 0 ? g + 1 | 0 : g, EA = (A = C) + (C = Ig(L, v, -997805, -1)) | 0, A = w + g | 0, A = C >>> 0 > EA >>> 0 ? A + 1 | 0 : A, g = Ig(q, j, 136657, 0), A = w + A | 0, A = g >>> 0 > (C = g + EA | 0) >>> 0 ? A + 1 | 0 : A, EA = (g = Ig(V, O, -683901, -1)) + C | 0, C = w + A | 0, g = sA + (g >>> 0 > EA >>> 0 ? C + 1 | 0 : C) | 0, FA = (C = (2097151 & JA) << 11 | MA >>> 21) + ((EA = EA + KA | 0) - (A = -2097152 & DA) | 0) | 0, A = ((g = EA >>> 0 < KA >>> 0 ? g + 1 | 0 : g) - ((A >>> 0 > EA >>> 0) + RA | 0) | 0) + (JA >> 21) | 0, pA = A = C >>> 0 > FA >>> 0 ? A + 1 | 0 : A, xA = A = A - ((FA >>> 0 < 4293918720) - 1 | 0) | 0, g = i, i = (2097151 & A) << 11 | (cA = FA - -1048576 | 0) >>> 21, A = (A >> 21) + _A | 0, HA = A = (C = g + i | 0) >>> 0 < i >>> 0 ? A + 1 | 0 : A, KA = C, A = Ig(C, A, -683901, -1), g = w + B | 0, g = A >>> 0 > (C = A + aA | 0) >>> 0 ? g + 1 | 0 : g, B = (A = C) + (C = Ig(GA, uA, -997805, -1)) | 0, A = w + g | 0, A = C >>> 0 > B >>> 0 ? A + 1 | 0 : A, g = Ig(dA, bA, 136657, 0), C = w + A | 0, MA = B = g + B | 0, tA = g >>> 0 > B >>> 0 ? C + 1 | 0 : C, aA = LA - (A = -2097152 & NA) | 0, sA = eA - ((A >>> 0 > LA >>> 0) + QA | 0) | 0, g = Ig(H, 0, l, 0), A = w, C = g, g = Ig(Y, 0, m, 0), A = w + A | 0, A = g >>> 0 > (C = C + g | 0) >>> 0 ? A + 1 | 0 : A, g = Ig(d, 0, u, 0), A = w + A | 0, A = g >>> 0 > (C = g + C | 0) >>> 0 ? A + 1 | 0 : A, B = (g = Ig(U, 0, x, 0)) + C | 0, C = w + A | 0, g = g >>> 0 > B >>> 0 ? C + 1 | 0 : C, DA = C = (A = (a[_ + 7 | 0] | a[_ + 8 | 0] << 8 | a[_ + 9 | 0] << 16 | a[_ + 10 | 0] << 24) >>> 7 & 2097151) + B | 0, EA = A >>> 0 > C >>> 0 ? g + 1 | 0 : g, A = Ig(H, 0, m, 0), g = w, C = A, A = Ig(Y, 0, x, 0), g = w + g | 0, g = A >>> 0 > (C = C + A | 0) >>> 0 ? g + 1 | 0 : g, B = (A = C) + (C = Ig(U, 0, u, 0)) | 0, A = w + g | 0, _A = B, B = C >>> 0 > B >>> 0 ? A + 1 | 0 : A, A = (g = a[_ + 6 | 0]) >>> 24 | 0, i = g << 8 | (RA = a[_ + 2 | 0] | a[_ + 3 | 0] << 8 | a[_ + 4 | 0] << 16 | a[_ + 5 | 0] << 24) >>> 24, C = A, g = (A = a[_ + 7 | 0]) >>> 16 | 0, g |= C, C = B, i = C = (A = 2097151 & ((3 & g) << 30 | (A = A << 16 | i) >>> 2)) >>> 0 > (_A = A + _A | 0) >>> 0 ? C + 1 | 0 : C, vA = A = C - ((_A >>> 0 < 4293918720) - 1 | 0) | 0, C = (2097151 & A) << 11 | (fA = _A - -1048576 | 0) >>> 21, A = (A >>> 21 | 0) + EA | 0, rA = A = C >>> 0 > (eA = C + DA | 0) >>> 0 ? A + 1 | 0 : A, PA = A = A - ((eA >>> 0 < 4293918720) - 1 | 0) | 0, C = (g = A >>> 21 | 0) + sA | 0, C = (A = (2097151 & A) << 11 | (yA = eA - -1048576 | 0) >>> 21) >>> 0 > (B = A + aA | 0) >>> 0 ? C + 1 | 0 : C, g = Ig(lA, OA, 666643, 0), A = w + C | 0, A = g >>> 0 > (B = g + B | 0) >>> 0 ? A + 1 | 0 : A, g = Ig(VA, IA, 470296, 0), A = w + A | 0, A = g >>> 0 > (C = g + B | 0) >>> 0 ? A + 1 | 0 : A, B = (g = C) + (C = Ig(KA, HA, 136657, 0)) | 0, g = w + A | 0, g = C >>> 0 > B >>> 0 ? g + 1 | 0 : g, A = Ig(GA, uA, 654183, 0), g = w + g | 0, g = A >>> 0 > (C = A + B | 0) >>> 0 ? g + 1 | 0 : g, aA = (A = Ig(dA, bA, -997805, -1)) + C | 0, C = w + g | 0, sA = C = A >>> 0 > aA >>> 0 ? C + 1 | 0 : C, JA = A = C - ((aA >>> 0 < 4293918720) - 1 | 0) | 0, C = (2097151 & A) << 11 | (DA = aA - -1048576 | 0) >>> 21, A = (A >> 21) + tA | 0, MA = C = (A = C >>> 0 > (B = C + MA | 0) >>> 0 ? A + 1 | 0 : A) - ((B >>> 0 < 4293918720) - 1 | 0) | 0, EA = (2097151 & C) << 11 | (tA = B - -1048576 | 0) >>> 21, C = (C >> 21) + qA | 0, YA = NA = EA + mA | 0, NA = EA >>> 0 > NA >>> 0 ? C + 1 | 0 : C, EA = B, g = A, B = (FA - (A = -2097152 & cA) | 0) + (cA = (2097151 & wA) << 11 | hA >>> 21) | 0, A = (pA - ((A >>> 0 > FA >>> 0) + xA | 0) | 0) + (wA >> 21) | 0, hA = A = B >>> 0 < cA >>> 0 ? A + 1 | 0 : A, mA = A = A - ((B >>> 0 < 4293918720) - 1 | 0) | 0, FA = C = A >> 21, A = Ig(lA = (2097151 & A) << 11 | (wA = B - -1048576 | 0) >>> 21, C, -683901, -1), g = w + g | 0, g = A >>> 0 > (C = A + EA | 0) >>> 0 ? g + 1 | 0 : g, qA = C - (A = -2097152 & tA) | 0, LA = g - ((A >>> 0 > C >>> 0) + MA | 0) | 0, g = Ig(lA, FA, 136657, 0), A = w + sA | 0, A = g >>> 0 > (C = g + aA | 0) >>> 0 ? A + 1 | 0 : A, jA = C - (g = -2097152 & DA) | 0, JA = A - ((g >>> 0 > C >>> 0) + JA | 0) | 0, g = Ig(VA, IA, 666643, 0), A = w + (rA - (((C = -2097152 & yA) >>> 0 > eA >>> 0) + PA | 0) | 0) | 0, A = g >>> 0 > (EA = g + (eA - C | 0) | 0) >>> 0 ? A + 1 | 0 : A, C = Ig(KA, HA, -997805, -1), g = w + A | 0, g = C >>> 0 > (EA = C + EA | 0) >>> 0 ? g + 1 | 0 : g, A = Ig(GA, uA, 470296, 0), C = w + g | 0, C = A >>> 0 > (EA = A + EA | 0) >>> 0 ? C + 1 | 0 : C, g = Ig(dA, bA, 654183, 0), A = w + C | 0, MA = EA = g + EA | 0, sA = g >>> 0 > EA >>> 0 ? A + 1 | 0 : A, C = RA >>> 5 & 2097151, A = Ig(H, 0, x, 0), g = w, tA = A, A = Ig(Y, 0, u, 0), g = w + g | 0, A = A >>> 0 > (EA = tA + A | 0) >>> 0 ? g + 1 | 0 : g, tA = g = C + EA | 0, C = A = g >>> 0 < EA >>> 0 ? A + 1 | 0 : A, eA = (g = Ig(H, 0, u, 0)) + (A = (A = a[_ + 2 | 0]) << 16 & 2031616 | a[0 | _] | a[_ + 1 | 0] << 8) | 0, g = w, cA = g = A >>> 0 > eA >>> 0 ? g + 1 | 0 : g, xA = g = g - ((eA >>> 0 < 4293918720) - 1 | 0) | 0, A = (A = g >>> 21 | 0) + C | 0, yA = A = (g = (2097151 & g) << 11 | (rA = eA - -1048576 | 0) >>> 21) >>> 0 > (pA = g + tA | 0) >>> 0 ? A + 1 | 0 : A, RA = g = A - ((pA >>> 0 < 4293918720) - 1 | 0) | 0, C = (2097151 & g) << 11 | (aA = pA - -1048576 | 0) >>> 21, g = (g >>> 21 | 0) + i | 0, g = C >>> 0 > (EA = C + _A | 0) >>> 0 ? g + 1 | 0 : g, C = Ig(KA, HA, 654183, 0), A = w + (g - (((i = -2097152 & fA) >>> 0 > EA >>> 0) + vA | 0) | 0) | 0, A = C >>> 0 > (_A = C + (EA - i | 0) | 0) >>> 0 ? A + 1 | 0 : A, g = Ig(GA, uA, 666643, 0), A = w + A | 0, A = g >>> 0 > (C = g + _A | 0) >>> 0 ? A + 1 | 0 : A, DA = (g = C) + (C = Ig(dA, bA, 470296, 0)) | 0, g = w + A | 0, tA = g = C >>> 0 > DA >>> 0 ? g + 1 | 0 : g, PA = g = g - ((DA >>> 0 < 4293918720) - 1 | 0) | 0, C = (A = g >> 21) + sA | 0, fA = g = (C = (g = (2097151 & g) << 11 | (EA = DA - -1048576 | 0) >>> 21) >>> 0 > (_A = g + MA | 0) >>> 0 ? C + 1 | 0 : C) - ((_A >>> 0 < 4293918720) - 1 | 0) | 0, sA = (2097151 & g) << 11 | (i = _A - -1048576 | 0) >>> 21, g = (g >> 21) + JA | 0, uA = GA = sA + jA | 0, sA = sA >>> 0 > GA >>> 0 ? g + 1 | 0 : g, A = Ig(lA, FA, -997805, -1), g = w + C | 0, g = A >>> 0 > (_A = A + _A | 0) >>> 0 ? g + 1 | 0 : g, JA = _A - (A = -2097152 & i) | 0, MA = g - ((A >>> 0 > _A >>> 0) + fA | 0) | 0, g = Ig(lA, FA, 654183, 0), A = w + tA | 0, A = g >>> 0 > (C = g + DA | 0) >>> 0 ? A + 1 | 0 : A, GA = C - (g = -2097152 & EA) | 0, fA = A - ((g >>> 0 > C >>> 0) + PA | 0) | 0, A = Ig(KA, HA, 470296, 0), C = w + (yA - (((g = -2097152 & aA) >>> 0 > pA >>> 0) + RA | 0) | 0) | 0, C = A >>> 0 > (i = A + (pA - g | 0) | 0) >>> 0 ? C + 1 | 0 : C, g = Ig(dA, bA, 666643, 0), A = w + C | 0, _A = i = g + i | 0, C = g >>> 0 > i >>> 0 ? A + 1 | 0 : A, g = Ig(KA, HA, 666643, 0), A = w + (cA - ((4095 & xA) + ((i = -2097152 & rA) >>> 0 > eA >>> 0) | 0) | 0) | 0, DA = A = g >>> 0 > (aA = g + (eA - i | 0) | 0) >>> 0 ? A + 1 | 0 : A, cA = A = A - ((aA >>> 0 < 4293918720) - 1 | 0) | 0, i = (2097151 & A) << 11 | (tA = aA - -1048576 | 0) >>> 21, A = (A >> 21) + C | 0, C = A = i >>> 0 > (EA = i + _A | 0) >>> 0 ? A + 1 | 0 : A, rA = A = A - ((EA >>> 0 < 4293918720) - 1 | 0) | 0, i = (2097151 & A) << 11 | (_A = EA - -1048576 | 0) >>> 21, A = (A >> 21) + fA | 0, i = i >>> 0 > (yA = i + GA | 0) >>> 0 ? A + 1 | 0 : A, A = Ig(lA, FA, 470296, 0), C = w + C | 0, C = A >>> 0 > (g = A + EA | 0) >>> 0 ? C + 1 | 0 : C, EA = g - (A = -2097152 & _A) | 0, _A = C - ((A >>> 0 > g >>> 0) + rA | 0) | 0, g = Ig(lA, FA, 666643, 0), A = w + (DA - (((C = -2097152 & tA) >>> 0 > aA >>> 0) + cA | 0) | 0) | 0, g = (C = (A = g >>> 0 > (pA = g + (aA - C | 0) | 0) >>> 0 ? A + 1 | 0 : A) >> 21) + _A | 0, A = (A = (g = (A = (2097151 & A) << 11 | pA >>> 21) >>> 0 > (fA = A + EA | 0) >>> 0 ? g + 1 | 0 : g) >> 21) + i | 0, g = (g = (A = (g = (2097151 & g) << 11 | fA >>> 21) >>> 0 > (cA = g + yA | 0) >>> 0 ? A + 1 | 0 : A) >> 21) + MA | 0, C = (A = (g = (A = (2097151 & A) << 11 | cA >>> 21) >>> 0 > (i = A + JA | 0) >>> 0 ? g + 1 | 0 : g) >> 21) + sA | 0, A = (g = (C = (g = (2097151 & g) << 11 | i >>> 21) >>> 0 > (rA = g + uA | 0) >>> 0 ? C + 1 | 0 : C) >> 21) + LA | 0, g = (C = (A = (C = (2097151 & C) << 11 | rA >>> 21) >>> 0 > (yA = C + qA | 0) >>> 0 ? A + 1 | 0 : A) >> 21) + NA | 0, A = (A = (g = (A = (2097151 & A) << 11 | yA >>> 21) >>> 0 > (aA = A + YA | 0) >>> 0 ? g + 1 | 0 : g) >> 21) + XA | 0, g = (g = (A = (g = (2097151 & g) << 11 | aA >>> 21) >>> 0 > (sA = g + UA | 0) >>> 0 ? A + 1 | 0 : A) >> 21) + SA | 0, C = (A = (g = (A = (2097151 & A) << 11 | sA >>> 21) >>> 0 > (DA = A + zA | 0) >>> 0 ? g + 1 | 0 : g) >> 21) + ZA | 0, A = (g = (C = (g = (2097151 & g) << 11 | DA >>> 21) >>> 0 > (tA = g + II | 0) >>> 0 ? C + 1 | 0 : C) >> 21) + AI | 0, _A = (wA = B - (g = -2097152 & wA) | 0) + ((2097151 & (A = (C = (2097151 & C) << 11 | tA >>> 21) >>> 0 > (EA = C + $A | 0) >>> 0 ? A + 1 | 0 : A)) << 11 | EA >>> 21) | 0, A = (hA - ((g >>> 0 > B >>> 0) + mA | 0) | 0) + (A >> 21) | 0, wA = g = (A = _A >>> 0 < wA >>> 0 ? A + 1 | 0 : A) >> 21, pA = (A = Ig(NA = (2097151 & A) << 11 | _A >>> 21, g, 666643, 0)) + (g = 2097151 & pA) | 0, A = w, B = A = g >>> 0 > pA >>> 0 ? A + 1 | 0 : A, o[0 | Q] = pA, o[Q + 1 | 0] = (255 & A) << 24 | pA >>> 8, A = 2097151 & fA, g = Ig(NA, wA, 470296, 0) + A | 0, C = w, A = (B >> 21) + (A >>> 0 > g >>> 0 ? C + 1 | 0 : C) | 0, A = (hA = (2097151 & B) << 11 | pA >>> 21) >>> 0 > (fA = hA + g | 0) >>> 0 ? A + 1 | 0 : A, o[Q + 4 | 0] = (2047 & A) << 21 | fA >>> 11, g = A, C = fA, o[Q + 3 | 0] = (7 & A) << 29 | C >>> 3, o[Q + 2 | 0] = 31 & ((65535 & B) << 16 | pA >>> 16) | C << 5, B = 2097151 & cA, cA = Ig(NA, wA, 654183, 0) + B | 0, A = w, fA = (2097151 & g) << 11 | C >>> 21, g = (g >> 21) + (B = B >>> 0 > cA >>> 0 ? A + 1 | 0 : A) | 0, A = g = (cA = fA + cA | 0) >>> 0 < fA >>> 0 ? g + 1 | 0 : g, o[Q + 6 | 0] = (63 & A) << 26 | cA >>> 6, B = cA, cA = 0, o[Q + 5 | 0] = cA << 13 | (1572864 & C) >>> 19 | B << 2, C = 2097151 & i, i = Ig(NA, wA, -997805, -1) + C | 0, g = w, g = C >>> 0 > i >>> 0 ? g + 1 | 0 : g, cA = (2097151 & (C = A)) << 11 | B >>> 21, C = (A >>= 21) + g | 0, C = (i = cA + i | 0) >>> 0 < cA >>> 0 ? C + 1 | 0 : C, o[Q + 9 | 0] = (511 & C) << 23 | i >>> 9, o[Q + 8 | 0] = (1 & C) << 31 | i >>> 1, g = 0, o[Q + 7 | 0] = g << 18 | (2080768 & B) >>> 14 | i << 7, g = 2097151 & rA, B = Ig(NA, wA, 136657, 0) + g | 0, A = w, A = g >>> 0 > B >>> 0 ? A + 1 | 0 : A, rA = (2097151 & (g = C)) << 11 | i >>> 21, g = A + (C = g >> 21) | 0, g = (B = rA + B | 0) >>> 0 < rA >>> 0 ? g + 1 | 0 : g, o[Q + 12 | 0] = (4095 & g) << 20 | B >>> 12, C = B, o[Q + 11 | 0] = (15 & g) << 28 | C >>> 4, B = 0, o[Q + 10 | 0] = B << 15 | (1966080 & i) >>> 17 | C << 4, B = 2097151 & yA, i = Ig(NA, wA, -683901, -1) + B | 0, A = w, A = B >>> 0 > i >>> 0 ? A + 1 | 0 : A, B = g, g = A + (g >>= 21) | 0, g = (B = (yA = i) + (i = (2097151 & B) << 11 | C >>> 21) | 0) >>> 0 < i >>> 0 ? g + 1 | 0 : g, o[Q + 14 | 0] = (127 & g) << 25 | B >>> 7, i = 0, o[Q + 13 | 0] = i << 12 | (1048576 & C) >>> 20 | B << 1, A = g >> 21, C = (g = (2097151 & g) << 11 | B >>> 21) >>> 0 > (i = g + (2097151 & aA) | 0) >>> 0 ? A + 1 | 0 : A, o[Q + 17 | 0] = (1023 & C) << 22 | i >>> 10, o[Q + 16 | 0] = (3 & C) << 30 | i >>> 2, g = 0, o[Q + 15 | 0] = g << 17 | (2064384 & B) >>> 15 | i << 6, A = C >> 21, A = (g = (2097151 & C) << 11 | i >>> 21) >>> 0 > (C = g + (2097151 & sA) | 0) >>> 0 ? A + 1 | 0 : A, o[Q + 20 | 0] = (8191 & A) << 19 | C >>> 13, o[Q + 19 | 0] = (31 & A) << 27 | C >>> 5, B = (g = 2097151 & DA) + (DA = (2097151 & A) << 11 | C >>> 21) | 0, g = A >> 21, g = B >>> 0 < DA >>> 0 ? g + 1 | 0 : g, DA = B, o[Q + 21 | 0] = B, sA = 0, o[Q + 18 | 0] = sA << 14 | (1835008 & i) >>> 18 | C << 3, o[Q + 22 | 0] = (255 & g) << 24 | B >>> 8, C = g >> 21, C = (B = (i = (2097151 & g) << 11 | B >>> 21) + (2097151 & tA) | 0) >>> 0 < i >>> 0 ? C + 1 | 0 : C, o[Q + 25 | 0] = (2047 & C) << 21 | B >>> 11, o[Q + 24 | 0] = (7 & C) << 29 | B >>> 3, o[Q + 23 | 0] = 31 & ((65535 & g) << 16 | DA >>> 16) | B << 5, A = C >> 21, A = (g = (2097151 & C) << 11 | B >>> 21) >>> 0 > (C = g + (2097151 & EA) | 0) >>> 0 ? A + 1 | 0 : A, o[Q + 27 | 0] = (63 & A) << 26 | C >>> 6, i = 0, o[Q + 26 | 0] = i << 13 | (1572864 & B) >>> 19 | C << 2, g = A >> 21, g = (A = (B = (2097151 & A) << 11 | C >>> 21) + (2097151 & _A) | 0) >>> 0 < B >>> 0 ? g + 1 | 0 : g, o[Q + 31 | 0] = (131071 & g) << 15 | A >>> 17, o[Q + 30 | 0] = (511 & g) << 23 | A >>> 9, o[Q + 29 | 0] = (1 & g) << 31 | A >>> 1, B = 0, o[Q + 28 | 0] = B << 18 | (2080768 & C) >>> 14 | A << 7, XC(c, 64), XC(_, 64), I && (E[I >> 2] = 64, E[I + 4 >> 2] = 0), h = t + 560 | 0, 0;
                                    }
                                    function k(A, I, g) {
                                        var C, B, Q, i, E, _, c, t, r, e, y, s, h, D, p, f, n, k, F, N, S, G, M, b, K, H, Y, d, J, U, l, m, u, x, R, v, L, P, q, z, j, X, O = 0, V = 0, Z = 0, W = 0, T = 0, $ = 0, AA = 0, IA = 0, gA = 0, CA = 0, BA = 0, QA = 0, iA = 0, oA = 0, EA = 0, aA = 0, _A = 0, cA = 0, tA = 0, rA = 0, eA = 0, yA = 0, sA = 0, hA = 0, DA = 0, pA = 0, wA = 0, fA = 0, nA = 0, kA = 0, FA = 0, NA = 0, SA = 0, GA = 0, MA = 0, bA = 0, KA = 0, HA = 0, YA = 0, dA = 0, JA = 0, UA = 0, lA = 0, mA = 0, uA = 0, xA = 0, RA = 0, vA = 0, LA = 0, PA = 0, qA = 0;
                                        W = Ig(C = (V = a[g + 2 | 0]) << 16 & 2031616 | a[0 | g] | a[g + 1 | 0] << 8, 0, B = (QA = a[I + 23 | 0] | a[I + 24 | 0] << 8 | a[I + 25 | 0] << 16 | a[I + 26 | 0] << 24) >>> 5 & 2097151, 0), Z = w, O = Ig(Q = (V = a[I + 23 | 0]) << 16 & 2031616 | a[I + 21 | 0] | a[I + 22 | 0] << 8, 0, i = (T = a[g + 2 | 0] | a[g + 3 | 0] << 8 | a[g + 4 | 0] << 16 | a[g + 5 | 0] << 24) >>> 5 & 2097151, 0), V = w + Z | 0, V = O >>> 0 > (W = O + W | 0) >>> 0 ? V + 1 | 0 : V, Z = Ig(E = (a[g + 7 | 0] | a[g + 8 | 0] << 8 | a[g + 9 | 0] << 16 | a[g + 10 | 0] << 24) >>> 7 & 2097151, 0, _ = (oA = a[I + 15 | 0] | a[I + 16 | 0] << 8 | a[I + 17 | 0] << 16 | a[I + 18 | 0] << 24) >>> 6 & 2097151, 0), O = w + V | 0, IA = W = Z + W | 0, Z = Z >>> 0 > W >>> 0 ? O + 1 | 0 : O, O = (V = a[I + 14 | 0]) >>> 24 | 0, $ = V << 8 | (gA = a[I + 10 | 0] | a[I + 11 | 0] << 8 | a[I + 12 | 0] << 16 | a[I + 13 | 0] << 24) >>> 24, O = Ig(c = 2097151 & ((1 & (CA = (V = O) | (O = (W = a[I + 15 | 0]) >>> 16 | 0))) << 31 | (V = (W <<= 16) | $) >>> 1), 0, t = (AA = a[g + 10 | 0] | a[g + 11 | 0] << 8 | a[g + 12 | 0] << 16 | a[g + 13 | 0] << 24) >>> 4 & 2097151, 0), Z = w + Z | 0, CA = V = O + IA | 0, W = V >>> 0 < O >>> 0 ? Z + 1 | 0 : Z, Z = (O = a[g + 6 | 0]) >>> 24 | 0, IA = O << 8 | T >>> 24, T = r = 2097151 & ((3 & (Z |= O = (V = a[g + 7 | 0]) >>> 16 | 0)) << 30 | (V = IA | V << 16) >>> 2), IA = 0, $ = (V = a[I + 19 | 0]) << 8 | oA >>> 24, Z = O = V >>> 24 | 0, V = (O = a[I + 20 | 0]) >>> 16 | 0, G = Z = (V |= Z) >>> 3 | 0, O = Ig(T, IA, e = (7 & V) << 29 | (O = O << 16 | $) >>> 3, Z), V = w + W | 0, V = O >>> 0 > ($ = O + CA | 0) >>> 0 ? V + 1 | 0 : V, Z = Ig(y = (T = a[g + 15 | 0] | a[g + 16 | 0] << 8 | a[g + 17 | 0] << 16 | a[g + 18 | 0] << 24) >>> 6 & 2097151, 0, s = (a[I + 7 | 0] | a[I + 8 | 0] << 8 | a[I + 9 | 0] << 16 | a[I + 10 | 0] << 24) >>> 7 & 2097151, 0), O = w + V | 0, IA = W = Z + $ | 0, W = Z >>> 0 > W >>> 0 ? O + 1 | 0 : O, $ = (V = a[g + 14 | 0]) << 8 | AA >>> 24, V = O = V >>> 24 | 0, Z = (O = a[g + 15 | 0]) >>> 16 | 0, O = Ig(h = 2097151 & ((1 & (Z |= V)) << 31 | (V = (O <<= 16) | $) >>> 1), 0, D = gA >>> 4 & 2097151, 0), V = w + W | 0, AA = Z = O + IA | 0, IA = O >>> 0 > Z >>> 0 ? V + 1 | 0 : V, V = (O = a[g + 19 | 0]) >>> 24 | 0, W = O << 8 | T >>> 24, Z = (O = a[g + 20 | 0]) >>> 16 | 0, p = (7 & (Z |= V)) << 29 | (O = W | O << 16) >>> 3, eA = V = Z >>> 3 | 0, W = V, V = (O = a[I + 6 | 0]) >>> 24 | 0, T = O << 8 | (CA = a[I + 2 | 0] | a[I + 3 | 0] << 8 | a[I + 4 | 0] << 16 | a[I + 5 | 0] << 24) >>> 24, Z = V, V = (O = a[I + 7 | 0]) >>> 16 | 0, V = Ig(p, W, f = 2097151 & ((3 & (V |= Z)) << 30 | (O = O << 16 | T) >>> 2), 0), O = w + IA | 0, Z = V >>> 0 > (W = V + AA | 0) >>> 0 ? O + 1 | 0 : O, V = Ig(n = (V = a[g + 23 | 0]) << 16 & 2031616 | a[g + 21 | 0] | a[g + 22 | 0] << 8, 0, k = CA >>> 5 & 2097151, 0), O = w + Z | 0, Z = V >>> 0 > (W = V + W | 0) >>> 0 ? O + 1 | 0 : O, O = Ig(F = (V = a[I + 2 | 0]) << 16 & 2031616 | a[0 | I] | a[I + 1 | 0] << 8, 0, DA = (CA = a[g + 23 | 0] | a[g + 24 | 0] << 8 | a[g + 25 | 0] << 16 | a[g + 26 | 0] << 24) >>> 5 & 2097151, 0), V = w + Z | 0, T = W = O + W | 0, IA = O >>> 0 > W >>> 0 ? V + 1 | 0 : V, O = Ig(Q, 0, C, 0), V = w, W = (Z = O) + (O = Ig(e, G, i, 0)) | 0, Z = w + V | 0, Z = O >>> 0 > W >>> 0 ? Z + 1 | 0 : Z, O = Ig(E, 0, c, 0), V = w + Z | 0, V = O >>> 0 > (W = O + W | 0) >>> 0 ? V + 1 | 0 : V, Z = Ig(t, 0, D, 0), O = w + V | 0, O = Z >>> 0 > (W = Z + W | 0) >>> 0 ? O + 1 | 0 : O, V = Ig(_, 0, r, 0), O = w + O | 0, O = V >>> 0 > (Z = V + W | 0) >>> 0 ? O + 1 | 0 : O, W = (V = Z) + (Z = Ig(y, 0, f, 0)) | 0, V = w + O | 0, V = Z >>> 0 > W >>> 0 ? V + 1 | 0 : V, O = Ig(h, 0, s, 0), Z = w + V | 0, Z = O >>> 0 > (W = O + W | 0) >>> 0 ? Z + 1 | 0 : Z, W = (O = Ig(p, eA, k, 0)) + W | 0, V = w + Z | 0, Z = Ig(n, 0, F, 0), O = w + (O >>> 0 > W >>> 0 ? V + 1 | 0 : V) | 0, W = O = Z >>> 0 > ($ = Z + W | 0) >>> 0 ? O + 1 | 0 : O, EA = O = O - (($ >>> 0 < 4293918720) - 1 | 0) | 0, V = (V = O >>> 21 | 0) + IA | 0, aA = Z = (V = (O = (2097151 & O) << 11 | (cA = $ - -1048576 | 0) >>> 21) >>> 0 > (T = O + T | 0) >>> 0 ? V + 1 | 0 : V) - ((T >>> 0 < 4293918720) - 1 | 0) | 0, iA = T - (O = -2097152 & (tA = T - -1048576 | 0)) | 0, BA = V - ((O >>> 0 > T >>> 0) + Z | 0) | 0, IA = (V = a[g + 27 | 0]) << 8 | CA >>> 24, Z = O = V >>> 24 | 0, T = Ig(N = 2097151 & ((3 & (Z |= V = (O = a[g + 28 | 0]) >>> 16 | 0)) << 30 | (V = (O <<= 16) | IA) >>> 2), 0, wA = (a[I + 28 | 0] | a[I + 29 | 0] << 8 | a[I + 30 | 0] << 16 | a[I + 31 | 0] << 24) >>> 7 | 0, 0), IA = w, V = (O = a[I + 27 | 0]) >>> 24 | 0, I = Ig(S = 2097151 & ((3 & (V |= Z = (I = a[I + 28 | 0]) >>> 16 | 0)) << 30 | (O = O << 8 | QA >>> 24 | I << 16) >>> 2), 0, fA = (a[g + 28 | 0] | a[g + 29 | 0] << 8 | a[g + 30 | 0] << 16 | a[g + 31 | 0] << 24) >>> 7 | 0, 0), O = w + IA | 0, O = I >>> 0 > (g = I + T | 0) >>> 0 ? O + 1 | 0 : O, Z = g, I = Ig(B, 0, fA, 0), g = w, IA = (V = I) + (I = Ig(DA, 0, wA, 0)) | 0, V = w + g | 0, V = I >>> 0 > IA >>> 0 ? V + 1 | 0 : V, I = Ig(N, 0, S, 0), V = w + V | 0, IA = V = I >>> 0 > (CA = I + IA | 0) >>> 0 ? V + 1 | 0 : V, AA = I = V - ((CA >>> 0 < 4293918720) - 1 | 0) | 0, V = I >>> 21 | 0, T = (I = (2097151 & I) << 11 | (g = CA - -1048576 | 0) >>> 21) + Z | 0, Z = V + O | 0, oA = V = (Z = I >>> 0 > T >>> 0 ? Z + 1 | 0 : Z) - ((T >>> 0 < 4293918720) - 1 | 0) | 0, I = T - (O = -2097152 & (gA = T - -1048576 | 0)) | 0, b = O = Z - ((131071 & V) + (O >>> 0 > T >>> 0) | 0) | 0, K = I, I = Ig(I, O, 666643, 0), O = w + BA | 0, kA = V = I + iA | 0, T = I >>> 0 > V >>> 0 ? O + 1 | 0 : O, iA = CA - (I = -2097152 & g) | 0, sA = IA - ((131071 & AA) + (I >>> 0 > CA >>> 0) | 0) | 0, I = Ig(n, 0, wA, 0), g = w, V = (O = I) + (I = Ig(DA, 0, S, 0)) | 0, O = w + g | 0, O = I >>> 0 > V >>> 0 ? O + 1 | 0 : O, g = (I = Ig(Q, 0, fA, 0)) + V | 0, V = w + O | 0, V = I >>> 0 > g >>> 0 ? V + 1 | 0 : V, I = Ig(B, 0, N, 0), O = w + V | 0, AA = g = I + g | 0, I = I >>> 0 > g >>> 0 ? O + 1 | 0 : O, g = Ig(B, 0, DA, 0), O = w, Z = (V = g) + (g = Ig(p, eA, wA, 0)) | 0, V = w + O | 0, V = g >>> 0 > Z >>> 0 ? V + 1 | 0 : V, O = (g = Ig(n, 0, S, 0)) + Z | 0, Z = w + V | 0, Z = g >>> 0 > O >>> 0 ? Z + 1 | 0 : Z, V = (g = Ig(e, G, fA, 0)) + O | 0, O = w + Z | 0, O = g >>> 0 > V >>> 0 ? O + 1 | 0 : O, BA = (g = Ig(Q, 0, N, 0)) + V | 0, V = w + O | 0, CA = V = g >>> 0 > BA >>> 0 ? V + 1 | 0 : V, _A = g = V - ((BA >>> 0 < 4293918720) - 1 | 0) | 0, V = I + (O = g >>> 21 | 0) | 0, g = V = (g = (2097151 & g) << 11 | (IA = BA - -1048576 | 0) >>> 21) >>> 0 > (AA = g + AA | 0) >>> 0 ? V + 1 | 0 : V, QA = V = V - ((AA >>> 0 < 4293918720) - 1 | 0) | 0, O = iA, iA = (2097151 & V) << 11 | (I = AA - -1048576 | 0) >>> 21, V = (V >>> 21 | 0) + sA | 0, H = V = (Z = O + iA | 0) >>> 0 < iA >>> 0 ? V + 1 | 0 : V, Y = I = AA - (O = -2097152 & I) | 0, d = AA = g - ((O >>> 0 > AA >>> 0) + QA | 0) | 0, J = Z, g = Ig(Z, V, 470296, 0), O = w + T | 0, O = g >>> 0 > (V = g + kA | 0) >>> 0 ? O + 1 | 0 : O, I = Ig(I, AA, 654183, 0), Z = w + O | 0, sA = g = I + V | 0, T = I >>> 0 > g >>> 0 ? Z + 1 | 0 : Z, QA = BA - (I = -2097152 & IA) | 0, BA = CA - ((I >>> 0 > BA >>> 0) + _A | 0) | 0, I = Ig(p, eA, S, 0), g = w, V = (O = I) + (I = Ig(y, 0, wA, 0)) | 0, O = w + g | 0, O = I >>> 0 > V >>> 0 ? O + 1 | 0 : O, g = (I = Ig(Q, 0, DA, 0)) + V | 0, V = w + O | 0, V = I >>> 0 > g >>> 0 ? V + 1 | 0 : V, I = Ig(B, 0, n, 0), Z = w + V | 0, Z = I >>> 0 > (g = I + g | 0) >>> 0 ? Z + 1 | 0 : Z, I = Ig(_, 0, fA, 0), O = w + Z | 0, O = I >>> 0 > (g = I + g | 0) >>> 0 ? O + 1 | 0 : O, I = Ig(e, G, N, 0), V = w + O | 0, CA = g = I + g | 0, IA = I >>> 0 > g >>> 0 ? V + 1 | 0 : V, I = Ig(h, 0, wA, 0), g = w, V = (O = I) + (I = Ig(y, 0, S, 0)) | 0, O = w + g | 0, O = I >>> 0 > V >>> 0 ? O + 1 | 0 : O, g = (I = Ig(B, 0, p, eA)) + V | 0, V = w + O | 0, V = I >>> 0 > g >>> 0 ? V + 1 | 0 : V, I = Ig(e, G, DA, 0), Z = w + V | 0, Z = I >>> 0 > (g = I + g | 0) >>> 0 ? Z + 1 | 0 : Z, I = Ig(Q, 0, n, 0), O = w + Z | 0, O = I >>> 0 > (g = I + g | 0) >>> 0 ? O + 1 | 0 : O, I = Ig(c, 0, fA, 0), V = w + O | 0, V = I >>> 0 > (g = I + g | 0) >>> 0 ? V + 1 | 0 : V, I = Ig(_, 0, N, 0), O = w + V | 0, I = O = I >>> 0 > (g = I + g | 0) >>> 0 ? O + 1 | 0 : O, yA = O = O - ((g >>> 0 < 4293918720) - 1 | 0) | 0, Z = (V = O >>> 21 | 0) + IA | 0, iA = Z = (O = (2097151 & O) << 11 | (_A = g - -1048576 | 0) >>> 21) >>> 0 > (hA = O + CA | 0) >>> 0 ? Z + 1 | 0 : Z, dA = O = Z - ((hA >>> 0 < 4293918720) - 1 | 0) | 0, IA = (2097151 & O) << 11 | (AA = hA - -1048576 | 0) >>> 21, O = (O >>> 21 | 0) + BA | 0, U = O = (Z = IA + QA | 0) >>> 0 < IA >>> 0 ? O + 1 | 0 : O, l = Z, O = Ig(Z, O, -997805, -1), V = w + T | 0, BA = Z = O + sA | 0, T = O >>> 0 > Z >>> 0 ? V + 1 | 0 : V, IA = $, $ = W, O = Ig(C, 0, e, G), V = w, W = (Z = O) + (O = Ig(_, 0, i, 0)) | 0, Z = w + V | 0, Z = O >>> 0 > W >>> 0 ? Z + 1 | 0 : Z, V = Ig(E, 0, D, 0), O = w + Z | 0, O = V >>> 0 > (W = V + W | 0) >>> 0 ? O + 1 | 0 : O, Z = Ig(t, 0, s, 0), V = w + O | 0, V = Z >>> 0 > (W = Z + W | 0) >>> 0 ? V + 1 | 0 : V, Z = Ig(c, 0, r, 0), O = w + V | 0, O = Z >>> 0 > (W = Z + W | 0) >>> 0 ? O + 1 | 0 : O, Z = Ig(y, 0, k, 0), V = w + O | 0, V = Z >>> 0 > (W = Z + W | 0) >>> 0 ? V + 1 | 0 : V, O = Ig(h, 0, f, 0), Z = w + V | 0, Z = O >>> 0 > (W = O + W | 0) >>> 0 ? Z + 1 | 0 : Z, V = Ig(p, eA, F, 0), O = w + Z | 0, CA = W = V + W | 0, W = V >>> 0 > W >>> 0 ? O + 1 | 0 : O, O = Ig(C, 0, _, 0), V = w, Z = O, O = Ig(c, 0, i, 0), V = w + V | 0, V = O >>> 0 > (Z = Z + O | 0) >>> 0 ? V + 1 | 0 : V, QA = (O = Z) + (Z = Ig(E, 0, s, 0)) | 0, O = w + V | 0, O = Z >>> 0 > QA >>> 0 ? O + 1 | 0 : O, Z = Ig(t, 0, f, 0), V = w + O | 0, V = Z >>> 0 > (QA = Z + QA | 0) >>> 0 ? V + 1 | 0 : V, O = Ig(r, 0, D, 0), Z = w + V | 0, Z = O >>> 0 > (QA = O + QA | 0) >>> 0 ? Z + 1 | 0 : Z, QA = (V = Ig(y, 0, F, 0)) + QA | 0, O = w + Z | 0, Z = Ig(h, 0, k, 0), V = w + (V >>> 0 > QA >>> 0 ? O + 1 | 0 : O) | 0, GA = V = Z >>> 0 > (SA = Z + QA | 0) >>> 0 ? V + 1 | 0 : V, xA = V = V - ((SA >>> 0 < 4293918720) - 1 | 0) | 0, Z = (2097151 & V) << 11 | (NA = SA - -1048576 | 0) >>> 21, V = (V >>> 21 | 0) + W | 0, rA = V = Z >>> 0 > (MA = Z + CA | 0) >>> 0 ? V + 1 | 0 : V, RA = V = V - ((MA >>> 0 < 4293918720) - 1 | 0) | 0, Z = (2097151 & V) << 11 | (kA = MA - -1048576 | 0) >>> 21, V = (V >>> 21 | 0) + $ | 0, V = Z >>> 0 > (IA = Z + IA | 0) >>> 0 ? V + 1 | 0 : V, O = Ig(J, H, 666643, 0), V = w + (V - (((Z = -2097152 & cA) >>> 0 > IA >>> 0) + EA | 0) | 0) | 0, V = O >>> 0 > (W = O + (IA - Z | 0) | 0) >>> 0 ? V + 1 | 0 : V, Z = Ig(Y, d, 470296, 0), O = w + V | 0, O = Z >>> 0 > (W = Z + W | 0) >>> 0 ? O + 1 | 0 : O, Z = Ig(l, U, 654183, 0), V = w + O | 0, sA = V = Z >>> 0 > (pA = Z + W | 0) >>> 0 ? V + 1 | 0 : V, lA = V = V - ((pA >>> 0 < 4293918720) - 1 | 0) | 0, O = (O = V >> 21) + T | 0, BA = O = (V = (2097151 & V) << 11 | (QA = pA - -1048576 | 0) >>> 21) >>> 0 > (EA = V + BA | 0) >>> 0 ? O + 1 | 0 : O, bA = V = O - ((EA >>> 0 < 4293918720) - 1 | 0) | 0, JA = (2097151 & V) << 11 | (cA = EA - -1048576 | 0) >>> 21, CA = V >> 21, O = Ig(C, 0, S, 0), V = w, Z = O, O = Ig(B, 0, i, 0), V = w + V | 0, V = O >>> 0 > (Z = Z + O | 0) >>> 0 ? V + 1 | 0 : V, W = (O = Ig(E, 0, e, G)) + Z | 0, Z = w + V | 0, Z = O >>> 0 > W >>> 0 ? Z + 1 | 0 : Z, V = Ig(_, 0, t, 0), O = w + Z | 0, O = V >>> 0 > (W = V + W | 0) >>> 0 ? O + 1 | 0 : O, Z = Ig(Q, 0, r, 0), V = w + O | 0, V = Z >>> 0 > (W = Z + W | 0) >>> 0 ? V + 1 | 0 : V, Z = Ig(y, 0, D, 0), O = w + V | 0, O = Z >>> 0 > (W = Z + W | 0) >>> 0 ? O + 1 | 0 : O, Z = Ig(c, 0, h, 0), V = w + O | 0, V = Z >>> 0 > (W = Z + W | 0) >>> 0 ? V + 1 | 0 : V, O = Ig(s, 0, p, eA), Z = w + V | 0, Z = O >>> 0 > (W = O + W | 0) >>> 0 ? Z + 1 | 0 : Z, V = Ig(k, 0, DA, 0), O = w + Z | 0, O = V >>> 0 > (W = V + W | 0) >>> 0 ? O + 1 | 0 : O, Z = Ig(f, 0, n, 0), V = w + O | 0, V = Z >>> 0 > (W = Z + W | 0) >>> 0 ? V + 1 | 0 : V, Z = (O = W) + (W = Ig(N, 0, F, 0)) | 0, O = w + V | 0, T = Z, IA = Z >>> 0 < W >>> 0 ? O + 1 | 0 : O, FA = Ig(wA, 0, fA, 0), $ = Z = (KA = w) - ((FA >>> 0 < 4293918720) - 1 | 0) | 0, V = FA - (O = -2097152 & (W = FA - -1048576 | 0)) | 0, O = (oA >>> 21 | 0) + (O = KA - ((524287 & Z) + (O >>> 0 > FA >>> 0) | 0) | 0) | 0, m = O = (Z = (gA = (2097151 & oA) << 11 | gA >>> 21) + V | 0) >>> 0 < gA >>> 0 ? O + 1 | 0 : O, u = Z, V = (2097151 & aA) << 11 | tA >>> 21, gA = Ig(Z, O, 666643, 0) + V | 0, O = w + (aA >>> 21 | 0) | 0, O = V >>> 0 > gA >>> 0 ? O + 1 | 0 : O, Z = Ig(K, b, 470296, 0), V = w + O | 0, V = (Z >>> 0 > (gA = Z + gA | 0) >>> 0 ? V + 1 | 0 : V) + IA | 0, V = (O = T + gA | 0) >>> 0 < gA >>> 0 ? V + 1 | 0 : V, gA = (Z = Ig(J, H, 654183, 0)) + O | 0, O = w + V | 0, UA = T - -1048576 | 0, FA = IA = IA - ((T >>> 0 < 4293918720) - 1 | 0) | 0, V = Ig(Y, d, -997805, -1), Z = w + (Z >>> 0 > gA >>> 0 ? O + 1 | 0 : O) | 0, Z = V >>> 0 > (T = V + gA | 0) >>> 0 ? Z + 1 | 0 : Z, tA = (O = Ig(l, U, 136657, 0)) + (T - (V = -2097152 & UA) | 0) | 0, V = w + (Z - ((V >>> 0 > T >>> 0) + IA | 0) | 0) | 0, Z = (oA = O >>> 0 > tA >>> 0 ? V + 1 | 0 : V) + CA | 0, HA = O = tA + JA | 0, gA = Z = O >>> 0 < tA >>> 0 ? Z + 1 | 0 : Z, KA = hA - (O = -2097152 & AA) | 0, hA = iA - ((O >>> 0 > hA >>> 0) + dA | 0) | 0, x = Z = $ >>> 21 | 0, V = (O = g) + (g = Ig(M = (2097151 & $) << 11 | W >>> 21, Z, -683901, -1)) | 0, O = w + I | 0, iA = V - (I = -2097152 & _A) | 0, aA = (g >>> 0 > V >>> 0 ? O + 1 | 0 : O) - ((I >>> 0 > V >>> 0) + yA | 0) | 0, I = Ig(B, 0, y, 0), g = w, O = I, I = Ig(t, 0, wA, 0), V = w + g | 0, V = I >>> 0 > (O = O + I | 0) >>> 0 ? V + 1 | 0 : V, I = Ig(h, 0, S, 0), Z = w + V | 0, Z = I >>> 0 > (g = I + O | 0) >>> 0 ? Z + 1 | 0 : Z, I = Ig(Q, 0, p, eA), O = w + Z | 0, O = I >>> 0 > (g = I + g | 0) >>> 0 ? O + 1 | 0 : O, I = Ig(_, 0, DA, 0), O = w + O | 0, O = I >>> 0 > (g = I + g | 0) >>> 0 ? O + 1 | 0 : O, I = Ig(e, G, n, 0), V = w + O | 0, V = I >>> 0 > (g = I + g | 0) >>> 0 ? V + 1 | 0 : V, I = Ig(D, 0, fA, 0), V = w + V | 0, V = I >>> 0 > (g = I + g | 0) >>> 0 ? V + 1 | 0 : V, I = Ig(c, 0, N, 0), Z = w + V | 0, W = g = I + g | 0, I = I >>> 0 > g >>> 0 ? Z + 1 | 0 : Z, g = Ig(t, 0, S, 0), O = w, V = g, g = Ig(E, 0, wA, 0), O = w + O | 0, O = g >>> 0 > (V = V + g | 0) >>> 0 ? O + 1 | 0 : O, g = Ig(Q, 0, y, 0), O = w + O | 0, O = g >>> 0 > (V = g + V | 0) >>> 0 ? O + 1 | 0 : O, Z = (g = Ig(B, 0, h, 0)) + V | 0, V = w + O | 0, V = g >>> 0 > Z >>> 0 ? V + 1 | 0 : V, g = Ig(e, G, p, eA), V = w + V | 0, V = g >>> 0 > (O = g + Z | 0) >>> 0 ? V + 1 | 0 : V, g = Ig(c, 0, DA, 0), Z = w + V | 0, Z = g >>> 0 > (O = g + O | 0) >>> 0 ? Z + 1 | 0 : Z, V = (g = Ig(_, 0, n, 0)) + O | 0, O = w + Z | 0, O = g >>> 0 > V >>> 0 ? O + 1 | 0 : O, g = Ig(s, 0, fA, 0), O = w + O | 0, O = g >>> 0 > (V = g + V | 0) >>> 0 ? O + 1 | 0 : O, AA = (g = Ig(D, 0, N, 0)) + V | 0, V = w + O | 0, CA = V = g >>> 0 > AA >>> 0 ? V + 1 | 0 : V, YA = g = V - ((AA >>> 0 < 4293918720) - 1 | 0) | 0, Z = I + (O = g >>> 21 | 0) | 0, IA = Z = (g = (2097151 & g) << 11 | (T = AA - -1048576 | 0) >>> 21) >>> 0 > (_A = g + W | 0) >>> 0 ? Z + 1 | 0 : Z, yA = I = Z - ((_A >>> 0 < 4293918720) - 1 | 0) | 0, V = (O = I >>> 21 | 0) + aA | 0, W = V = (I = (2097151 & I) << 11 | ($ = _A - -1048576 | 0) >>> 21) >>> 0 > (iA = I + iA | 0) >>> 0 ? V + 1 | 0 : V, aA = g = V - ((iA >>> 0 < 4293918720) - 1 | 0) | 0, Z = (O = g >> 21) + hA | 0, R = Z = (g = (V = (2097151 & g) << 11 | (I = iA - -1048576 | 0) >>> 21) + KA | 0) >>> 0 < V >>> 0 ? Z + 1 | 0 : Z, dA = tA - -1048576 | 0, JA = V = oA - ((tA >>> 0 < 4293918720) - 1 | 0) | 0, mA = g, g = Ig(g, Z, -683901, -1), O = w + gA | 0, KA = O = (V = (O = g >>> 0 > (Z = g + HA | 0) >>> 0 ? O + 1 | 0 : O) - (((g = -2097152 & dA) >>> 0 > Z >>> 0) + V | 0) | 0) - (((gA = Z - g | 0) >>> 0 < 4293918720) - 1 | 0) | 0, P = gA - (g = -2097152 & (hA = gA - -1048576 | 0)) | 0, vA = V - ((g >>> 0 > gA >>> 0) + O | 0) | 0, g = Ig(mA, R, 136657, 0), V = w + (BA - (((O = -2097152 & cA) >>> 0 > EA >>> 0) + bA | 0) | 0) | 0, uA = Z = g + (EA - O | 0) | 0, g = g >>> 0 > Z >>> 0 ? V + 1 | 0 : V, nA = iA - (I &= -2097152) | 0, cA = W - ((I >>> 0 > iA >>> 0) + aA | 0) | 0, I = Ig(u, m, -683901, -1), O = w, V = I, I = Ig(M, x, 136657, 0), O = w + O | 0, V = IA + (I >>> 0 > (Z = V + I | 0) >>> 0 ? O + 1 | 0 : O) | 0, oA = (O = Z + _A | 0) - (I = -2097152 & $) | 0, gA = (V = O >>> 0 < _A >>> 0 ? V + 1 | 0 : V) - ((I >>> 0 > O >>> 0) + yA | 0) | 0, I = Ig(M, x, -997805, -1), O = w + CA | 0, O = I >>> 0 > (V = I + AA | 0) >>> 0 ? O + 1 | 0 : O, I = Ig(u, m, 136657, 0), O = w + O | 0, O = I >>> 0 > (V = I + V | 0) >>> 0 ? O + 1 | 0 : O, Z = (I = Ig(K, b, -683901, -1)) + V | 0, V = w + O | 0, V = I >>> 0 > Z >>> 0 ? V + 1 | 0 : V, IA = Z - (I = -2097152 & T) | 0, $ = V - ((I >>> 0 > Z >>> 0) + YA | 0) | 0, I = Ig(B, 0, t, 0), O = w, Z = (V = I) + (I = Ig(E, 0, S, 0)) | 0, V = w + O | 0, V = I >>> 0 > Z >>> 0 ? V + 1 | 0 : V, I = Ig(r, 0, wA, 0), O = w + V | 0, O = I >>> 0 > (Z = I + Z | 0) >>> 0 ? O + 1 | 0 : O, I = Ig(y, 0, e, G), V = w + O | 0, V = I >>> 0 > (Z = I + Z | 0) >>> 0 ? V + 1 | 0 : V, I = Ig(Q, 0, h, 0), O = w + V | 0, O = I >>> 0 > (Z = I + Z | 0) >>> 0 ? O + 1 | 0 : O, V = (I = Ig(_, 0, p, eA)) + Z | 0, Z = w + O | 0, Z = I >>> 0 > V >>> 0 ? Z + 1 | 0 : Z, O = (I = Ig(D, 0, DA, 0)) + V | 0, V = w + Z | 0, V = I >>> 0 > O >>> 0 ? V + 1 | 0 : V, Z = (I = Ig(c, 0, n, 0)) + O | 0, O = w + V | 0, O = I >>> 0 > Z >>> 0 ? O + 1 | 0 : O, I = Ig(f, 0, fA, 0), V = w + O | 0, V = I >>> 0 > (Z = I + Z | 0) >>> 0 ? V + 1 | 0 : V, I = Ig(s, 0, N, 0), O = w + V | 0, W = Z = I + Z | 0, I = I >>> 0 > Z >>> 0 ? O + 1 | 0 : O, O = Ig(B, 0, E, 0), V = w, T = (Z = O) + (O = Ig(i, 0, wA, 0)) | 0, Z = w + V | 0, Z = O >>> 0 > T >>> 0 ? Z + 1 | 0 : Z, O = Ig(Q, 0, t, 0), V = w + Z | 0, V = O >>> 0 > (T = O + T | 0) >>> 0 ? V + 1 | 0 : V, Z = Ig(r, 0, S, 0), O = w + V | 0, O = Z >>> 0 > (T = Z + T | 0) >>> 0 ? O + 1 | 0 : O, Z = Ig(_, 0, y, 0), V = w + O | 0, V = Z >>> 0 > (T = Z + T | 0) >>> 0 ? V + 1 | 0 : V, Z = Ig(e, G, h, 0), O = w + V | 0, O = Z >>> 0 > (T = Z + T | 0) >>> 0 ? O + 1 | 0 : O, V = Ig(c, 0, p, eA), Z = w + O | 0, Z = V >>> 0 > (T = V + T | 0) >>> 0 ? Z + 1 | 0 : Z, O = Ig(s, 0, DA, 0), V = w + Z | 0, V = O >>> 0 > (T = O + T | 0) >>> 0 ? V + 1 | 0 : V, Z = Ig(D, 0, n, 0), O = w + V | 0, O = Z >>> 0 > (T = Z + T | 0) >>> 0 ? O + 1 | 0 : O, Z = Ig(k, 0, fA, 0), V = w + O | 0, V = Z >>> 0 > (T = Z + T | 0) >>> 0 ? V + 1 | 0 : V, Z = Ig(f, 0, N, 0), O = w + V | 0, EA = O = Z >>> 0 > (bA = Z + T | 0) >>> 0 ? O + 1 | 0 : O, q = O = O - ((bA >>> 0 < 4293918720) - 1 | 0) | 0, V = I + (V = O >>> 21 | 0) | 0, tA = V = (O = (2097151 & O) << 11 | (aA = bA - -1048576 | 0) >>> 21) >>> 0 > (HA = O + W | 0) >>> 0 ? V + 1 | 0 : V, z = I = V - ((HA >>> 0 < 4293918720) - 1 | 0) | 0, O = (V = I >>> 21 | 0) + $ | 0, iA = O = (I = (2097151 & I) << 11 | (_A = HA - -1048576 | 0) >>> 21) >>> 0 > (YA = I + IA | 0) >>> 0 ? O + 1 | 0 : O, j = I = O - ((YA >>> 0 < 4293918720) - 1 | 0) | 0, V = (V = I >> 21) + gA | 0, CA = V = (I = (2097151 & I) << 11 | (BA = YA - -1048576 | 0) >>> 21) >>> 0 > (yA = I + oA | 0) >>> 0 ? V + 1 | 0 : V, LA = I = V - ((yA >>> 0 < 4293918720) - 1 | 0) | 0, O = (V = I >> 21) + cA | 0, v = O = (I = (Z = (2097151 & I) << 11 | (W = yA - -1048576 | 0) >>> 21) + nA | 0) >>> 0 < Z >>> 0 ? O + 1 | 0 : O, nA = I, I = Ig(I, O, -683901, -1), Z = w + g | 0, PA = O = I + uA | 0, T = I >>> 0 > O >>> 0 ? Z + 1 | 0 : Z, qA = pA - (I = -2097152 & QA) | 0, lA = sA - ((I >>> 0 > pA >>> 0) + lA | 0) | 0, I = Ig(Y, d, 666643, 0), O = w + (rA - (((g = -2097152 & kA) >>> 0 > MA >>> 0) + RA | 0) | 0) | 0, O = I >>> 0 > (V = I + (MA - g | 0) | 0) >>> 0 ? O + 1 | 0 : O, g = (I = Ig(l, U, 470296, 0)) + V | 0, V = w + O | 0, kA = g, g = I >>> 0 > g >>> 0 ? V + 1 | 0 : V, AA = SA - (I = -2097152 & NA) | 0, IA = GA - ((I >>> 0 > SA >>> 0) + xA | 0) | 0, I = Ig(C, 0, c, 0), O = w, V = I, I = Ig(i, 0, D, 0), Z = w + O | 0, Z = I >>> 0 > (V = V + I | 0) >>> 0 ? Z + 1 | 0 : Z, I = Ig(E, 0, f, 0), O = w + Z | 0, O = I >>> 0 > (V = I + V | 0) >>> 0 ? O + 1 | 0 : O, Z = (I = Ig(t, 0, k, 0)) + V | 0, V = w + O | 0, V = I >>> 0 > Z >>> 0 ? V + 1 | 0 : V, I = Ig(r, 0, s, 0), O = w + V | 0, O = I >>> 0 > (Z = I + Z | 0) >>> 0 ? O + 1 | 0 : O, I = Ig(h, 0, F, 0), V = w + O | 0, $ = Z = I + Z | 0, I = I >>> 0 > Z >>> 0 ? V + 1 | 0 : V, O = Ig(C, 0, D, 0), V = w, gA = (Z = O) + (O = Ig(i, 0, s, 0)) | 0, Z = w + V | 0, Z = O >>> 0 > gA >>> 0 ? Z + 1 | 0 : Z, V = Ig(E, 0, k, 0), O = w + Z | 0, O = V >>> 0 > (gA = V + gA | 0) >>> 0 ? O + 1 | 0 : O, Z = Ig(t, 0, F, 0), V = w + O | 0, V = Z >>> 0 > (gA = Z + gA | 0) >>> 0 ? V + 1 | 0 : V, Z = Ig(r, 0, f, 0), O = w + V | 0, sA = O = Z >>> 0 > (pA = Z + gA | 0) >>> 0 ? O + 1 | 0 : O, X = O = O - ((pA >>> 0 < 4293918720) - 1 | 0) | 0, Z = I + (V = O >>> 21 | 0) | 0, cA = Z = (O = (2097151 & O) << 11 | (QA = pA - -1048576 | 0) >>> 21) >>> 0 > (GA = O + $ | 0) >>> 0 ? Z + 1 | 0 : Z, xA = I = Z - ((GA >>> 0 < 4293918720) - 1 | 0) | 0, O = (V = I >>> 21 | 0) + IA | 0, O = (I = (2097151 & I) << 11 | (oA = GA - -1048576 | 0) >>> 21) >>> 0 > (Z = I + AA | 0) >>> 0 ? O + 1 | 0 : O, I = Ig(l, U, 666643, 0), V = w + O | 0, gA = V = I >>> 0 > (NA = I + Z | 0) >>> 0 ? V + 1 | 0 : V, RA = I = V - ((NA >>> 0 < 4293918720) - 1 | 0) | 0, O = g + (O = I >> 21) | 0, IA = O = (I = (2097151 & I) << 11 | (AA = NA - -1048576 | 0) >>> 21) >>> 0 > (rA = I + kA | 0) >>> 0 ? O + 1 | 0 : O, uA = I = O - ((rA >>> 0 < 4293918720) - 1 | 0) | 0, V = (O = I >> 21) + lA | 0, V = (I = (2097151 & I) << 11 | ($ = rA - -1048576 | 0) >>> 21) >>> 0 > (g = I + qA | 0) >>> 0 ? V + 1 | 0 : V, I = Ig(mA, R, -997805, -1), Z = w + V | 0, Z = I >>> 0 > (O = I + g | 0) >>> 0 ? Z + 1 | 0 : Z, MA = I = yA - (g = -2097152 & W) | 0, L = V = CA - ((g >>> 0 > yA >>> 0) + LA | 0) | 0, W = (g = Ig(nA, v, 136657, 0)) + O | 0, O = w + Z | 0, I = Ig(I, V, -683901, -1), O = w + (g >>> 0 > W >>> 0 ? O + 1 | 0 : O) | 0, W = O = I >>> 0 > (CA = I + W | 0) >>> 0 ? O + 1 | 0 : O, SA = I = O - ((CA >>> 0 < 4293918720) - 1 | 0) | 0, O = (V = I >> 21) + T | 0, g = O = (T = kA = (I = (2097151 & I) << 11 | (Z = CA - -1048576 | 0) >>> 21) + PA | 0) >>> 0 < I >>> 0 ? O + 1 | 0 : O, yA = O = O - ((T >>> 0 < 4293918720) - 1 | 0) | 0, kA = (2097151 & O) << 11 | (I = T - -1048576 | 0) >>> 21, O = (O >> 21) + vA | 0, vA = lA = kA + P | 0, kA = kA >>> 0 > lA >>> 0 ? O + 1 | 0 : O, LA = T - (I &= -2097152) | 0, PA = g - ((I >>> 0 > T >>> 0) + yA | 0) | 0, qA = CA - (I = -2097152 & Z) | 0, lA = W - ((I >>> 0 > CA >>> 0) + SA | 0) | 0, I = Ig(mA, R, 654183, 0), V = w + (IA - (((g = -2097152 & $) >>> 0 > rA >>> 0) + uA | 0) | 0) | 0, V = I >>> 0 > (O = I + (rA - g | 0) | 0) >>> 0 ? V + 1 | 0 : V, g = (I = Ig(nA, v, -997805, -1)) + O | 0, O = w + V | 0, O = I >>> 0 > g >>> 0 ? O + 1 | 0 : O, I = Ig(MA, L, 136657, 0), O = w + O | 0, uA = g = I + g | 0, I = I >>> 0 > g >>> 0 ? O + 1 | 0 : O, SA = YA - (g = -2097152 & BA) | 0, rA = iA - ((g >>> 0 > YA >>> 0) + j | 0) | 0, g = Ig(u, m, -997805, -1), O = w, Z = (V = g) + (g = Ig(M, x, 654183, 0)) | 0, V = w + O | 0, V = g >>> 0 > Z >>> 0 ? V + 1 | 0 : V, g = Ig(K, b, 136657, 0), O = w + V | 0, O = g >>> 0 > (Z = g + Z | 0) >>> 0 ? O + 1 | 0 : O, g = Ig(J, H, -683901, -1), O = w + O | 0, V = tA + (g >>> 0 > (Z = g + Z | 0) >>> 0 ? O + 1 | 0 : O) | 0, BA = (O = Z + HA | 0) - (g = -2097152 & _A) | 0, tA = (V = O >>> 0 < HA >>> 0 ? V + 1 | 0 : V) - ((g >>> 0 > O >>> 0) + z | 0) | 0, g = Ig(u, m, 654183, 0), O = w, Z = (V = g) + (g = Ig(M, x, 470296, 0)) | 0, V = w + O | 0, V = g >>> 0 > Z >>> 0 ? V + 1 | 0 : V, g = Ig(K, b, -997805, -1), O = w + V | 0, V = EA + (g >>> 0 > (Z = g + Z | 0) >>> 0 ? O + 1 | 0 : O) | 0, V = (g = Z + bA | 0) >>> 0 < bA >>> 0 ? V + 1 | 0 : V, Z = (O = g) + (g = Ig(J, H, 136657, 0)) | 0, O = w + V | 0, O = g >>> 0 > Z >>> 0 ? O + 1 | 0 : O, V = (g = Ig(Y, d, -683901, -1)) + Z | 0, Z = w + O | 0, Z = g >>> 0 > V >>> 0 ? Z + 1 | 0 : Z, $ = V - (g = -2097152 & aA) | 0, W = Z - ((g >>> 0 > V >>> 0) + q | 0) | 0, g = Ig(C, 0, wA, 0), O = w, V = g, g = Ig(i, 0, S, 0), O = w + O | 0, O = g >>> 0 > (V = V + g | 0) >>> 0 ? O + 1 | 0 : O, g = Ig(Q, 0, E, 0), O = w + O | 0, O = g >>> 0 > (V = g + V | 0) >>> 0 ? O + 1 | 0 : O, g = Ig(e, G, t, 0), Z = w + O | 0, Z = g >>> 0 > (V = g + V | 0) >>> 0 ? Z + 1 | 0 : Z, O = (g = Ig(B, 0, r, 0)) + V | 0, V = w + Z | 0, V = g >>> 0 > O >>> 0 ? V + 1 | 0 : V, g = Ig(y, 0, c, 0), V = w + V | 0, V = g >>> 0 > (O = g + O | 0) >>> 0 ? V + 1 | 0 : V, Z = (g = Ig(_, 0, h, 0)) + O | 0, O = w + V | 0, O = g >>> 0 > Z >>> 0 ? O + 1 | 0 : O, g = Ig(D, 0, p, eA), O = w + O | 0, O = g >>> 0 > (V = g + Z | 0) >>> 0 ? O + 1 | 0 : O, g = Ig(f, 0, DA, 0), Z = w + O | 0, Z = g >>> 0 > (V = g + V | 0) >>> 0 ? Z + 1 | 0 : Z, O = (g = Ig(s, 0, n, 0)) + V | 0, V = w + Z | 0, V = g >>> 0 > O >>> 0 ? V + 1 | 0 : V, g = Ig(F, 0, fA, 0), V = w + V | 0, V = g >>> 0 > (O = g + O | 0) >>> 0 ? V + 1 | 0 : V, Z = (g = Ig(N, 0, k, 0)) + O | 0, O = w + V | 0, O = (FA >>> 21 | 0) + (O = g >>> 0 > Z >>> 0 ? O + 1 | 0 : O) | 0, CA = O = (g = (2097151 & FA) << 11 | UA >>> 21) >>> 0 > (_A = g + Z | 0) >>> 0 ? O + 1 | 0 : O, bA = g = O - ((_A >>> 0 < 4293918720) - 1 | 0) | 0, V = (V = g >>> 21 | 0) + W | 0, IA = V = (g = (2097151 & g) << 11 | (T = _A - -1048576 | 0) >>> 21) >>> 0 > (iA = g + $ | 0) >>> 0 ? V + 1 | 0 : V, yA = g = V - ((iA >>> 0 < 4293918720) - 1 | 0) | 0, O = (V = g >> 21) + tA | 0, W = O = (g = (2097151 & g) << 11 | ($ = iA - -1048576 | 0) >>> 21) >>> 0 > (BA = g + BA | 0) >>> 0 ? O + 1 | 0 : O, aA = O = O - ((BA >>> 0 < 4293918720) - 1 | 0) | 0, V = (V = O >> 21) + rA | 0, rA = V = (O = (Z = (2097151 & O) << 11 | (g = BA - -1048576 | 0) >>> 21) + SA | 0) >>> 0 < Z >>> 0 ? V + 1 | 0 : V, UA = O, V = Ig(O, V, -683901, -1), O = w + I | 0, tA = Z = V + uA | 0, I = V >>> 0 > Z >>> 0 ? O + 1 | 0 : O, O = Ig(mA, R, 470296, 0), Z = w + (gA - (((V = -2097152 & AA) >>> 0 > NA >>> 0) + RA | 0) | 0) | 0, Z = O >>> 0 > (AA = O + (NA - V | 0) | 0) >>> 0 ? Z + 1 | 0 : Z, O = Ig(nA, v, 654183, 0), V = w + Z | 0, V = O >>> 0 > (AA = O + AA | 0) >>> 0 ? V + 1 | 0 : V, Z = Ig(MA, L, -997805, -1), O = w + V | 0, O = Z >>> 0 > (AA = Z + AA | 0) >>> 0 ? O + 1 | 0 : O, FA = g = BA - (V = -2097152 & g) | 0, eA = W = W - ((V >>> 0 > BA >>> 0) + aA | 0) | 0, AA = (Z = Ig(UA, rA, 136657, 0)) + AA | 0, V = w + O | 0, g = Ig(g, W, -683901, -1), Z = w + (Z >>> 0 > AA >>> 0 ? V + 1 | 0 : V) | 0, W = Z = g >>> 0 > (gA = g + AA | 0) >>> 0 ? Z + 1 | 0 : Z, EA = V = Z - ((gA >>> 0 < 4293918720) - 1 | 0) | 0, Z = (2097151 & V) << 11 | (g = gA - -1048576 | 0) >>> 21, V = (V >> 21) + I | 0, aA = Z = (V = Z >>> 0 > (AA = Z + tA | 0) >>> 0 ? V + 1 | 0 : V) - ((AA >>> 0 < 4293918720) - 1 | 0) | 0, BA = (2097151 & Z) << 11 | (I = AA - -1048576 | 0) >>> 21, Z = (Z >> 21) + lA | 0, tA = BA >>> 0 > (DA = tA = BA + qA | 0) >>> 0 ? Z + 1 | 0 : Z, wA = AA - (I &= -2097152) | 0, fA = V - ((I >>> 0 > AA >>> 0) + aA | 0) | 0, HA = gA - (I = -2097152 & g) | 0, YA = W - ((I >>> 0 > gA >>> 0) + EA | 0) | 0, I = Ig(mA, R, 666643, 0), V = w + (cA - (((g = -2097152 & oA) >>> 0 > GA >>> 0) + xA | 0) | 0) | 0, V = I >>> 0 > (O = I + (GA - g | 0) | 0) >>> 0 ? V + 1 | 0 : V, I = Ig(nA, v, 470296, 0), Z = w + V | 0, Z = I >>> 0 > (g = I + O | 0) >>> 0 ? Z + 1 | 0 : Z, I = Ig(MA, L, 654183, 0), V = w + Z | 0, AA = g = I + g | 0, I = I >>> 0 > g >>> 0 ? V + 1 | 0 : V, $ = iA - (g = -2097152 & $) | 0, W = IA - ((g >>> 0 > iA >>> 0) + yA | 0) | 0, g = Ig(u, m, 470296, 0), O = w, V = g, g = Ig(M, x, 666643, 0), O = w + O | 0, O = g >>> 0 > (V = V + g | 0) >>> 0 ? O + 1 | 0 : O, g = Ig(K, b, 654183, 0), Z = w + O | 0, Z = g >>> 0 > (V = g + V | 0) >>> 0 ? Z + 1 | 0 : Z, O = (g = Ig(J, H, -997805, -1)) + V | 0, V = w + Z | 0, V = g >>> 0 > O >>> 0 ? V + 1 | 0 : V, g = Ig(Y, d, 136657, 0), V = w + V | 0, O = CA + (g >>> 0 > (Z = g + O | 0) >>> 0 ? V + 1 | 0 : V) | 0, O = (g = Z + _A | 0) >>> 0 < _A >>> 0 ? O + 1 | 0 : O, V = g, g = Ig(l, U, -683901, -1), O = w + O | 0, O = g >>> 0 > (Z = V + g | 0) >>> 0 ? O + 1 | 0 : O, EA = (g = (2097151 & JA) << 11 | dA >>> 21) + (Z - (V = -2097152 & T) | 0) | 0, V = (O - ((V >>> 0 > Z >>> 0) + bA | 0) | 0) + (JA >> 21) | 0, iA = V = g >>> 0 > EA >>> 0 ? V + 1 | 0 : V, yA = g = V - ((EA >>> 0 < 4293918720) - 1 | 0) | 0, V = (O = g >> 21) + W | 0, dA = V = (g = (Z = (2097151 & g) << 11 | (BA = EA - -1048576 | 0) >>> 21) + $ | 0) >>> 0 < Z >>> 0 ? V + 1 | 0 : V, JA = g, g = Ig(g, V, -683901, -1), Z = w + I | 0, Z = g >>> 0 > (O = g + AA | 0) >>> 0 ? Z + 1 | 0 : Z, I = Ig(UA, rA, -997805, -1), V = w + Z | 0, V = I >>> 0 > (g = I + O | 0) >>> 0 ? V + 1 | 0 : V, I = Ig(FA, eA, 136657, 0), O = w + V | 0, _A = g = I + g | 0, $ = I >>> 0 > g >>> 0 ? O + 1 | 0 : O, T = pA - (I = -2097152 & QA) | 0, IA = sA - ((I >>> 0 > pA >>> 0) + X | 0) | 0, I = Ig(C, 0, s, 0), g = w, O = I, I = Ig(i, 0, f, 0), V = w + g | 0, V = I >>> 0 > (O = O + I | 0) >>> 0 ? V + 1 | 0 : V, I = Ig(E, 0, F, 0), V = w + V | 0, V = I >>> 0 > (g = I + O | 0) >>> 0 ? V + 1 | 0 : V, I = Ig(r, 0, k, 0), O = w + V | 0, I = I >>> 0 > (V = g = I + g | 0) >>> 0 ? O + 1 | 0 : O, g = Ig(C, 0, f, 0), O = w, W = (Z = g) + (g = Ig(i, 0, k, 0)) | 0, Z = w + O | 0, Z = g >>> 0 > W >>> 0 ? Z + 1 | 0 : Z, g = Ig(r, 0, F, 0), O = w + Z | 0, g = O = g >>> 0 > (W = g + W | 0) >>> 0 ? O + 1 | 0 : O, mA = O = O - ((W >>> 0 < 4293918720) - 1 | 0) | 0, Z = O >>> 21 | 0, aA = (O = (2097151 & O) << 11 | (cA = W - -1048576 | 0) >>> 21) + V | 0, V = I + Z | 0, oA = V = O >>> 0 > aA >>> 0 ? V + 1 | 0 : V, pA = I = V - ((aA >>> 0 < 4293918720) - 1 | 0) | 0, O = (Z = I >>> 21 | 0) + IA | 0, O = (I = (2097151 & I) << 11 | (gA = aA - -1048576 | 0) >>> 21) >>> 0 > (V = I + T | 0) >>> 0 ? O + 1 | 0 : O, Z = (I = Ig(nA, v, 666643, 0)) + V | 0, V = w + O | 0, V = I >>> 0 > Z >>> 0 ? V + 1 | 0 : V, I = Ig(MA, L, 470296, 0), V = w + V | 0, V = I >>> 0 > (O = I + Z | 0) >>> 0 ? V + 1 | 0 : V, Z = (I = Ig(JA, dA, 136657, 0)) + O | 0, O = w + V | 0, O = I >>> 0 > Z >>> 0 ? O + 1 | 0 : O, V = (I = Ig(UA, rA, 654183, 0)) + Z | 0, Z = w + O | 0, Z = I >>> 0 > V >>> 0 ? Z + 1 | 0 : Z, I = Ig(FA, eA, -997805, -1), O = w + Z | 0, CA = O = I >>> 0 > (AA = I + V | 0) >>> 0 ? O + 1 | 0 : O, GA = I = O - ((AA >>> 0 < 4293918720) - 1 | 0) | 0, V = (Z = I >> 21) + $ | 0, NA = O = (V = (I = (O = (2097151 & I) << 11 | (T = AA - -1048576 | 0) >>> 21) + _A | 0) >>> 0 < O >>> 0 ? V + 1 | 0 : V) - ((I >>> 0 < 4293918720) - 1 | 0) | 0, $ = (2097151 & O) << 11 | (IA = I - -1048576 | 0) >>> 21, O = (O >> 21) + YA | 0, SA = QA = $ + HA | 0, _A = $ >>> 0 > QA >>> 0 ? O + 1 | 0 : O, $ = I, Z = V, V = (iA - (((O = -2097152 & BA) >>> 0 > EA >>> 0) + yA | 0) | 0) + (KA >> 21) | 0, sA = V = (I = (EA - O | 0) + (BA = (2097151 & KA) << 11 | hA >>> 21) | 0) >>> 0 < BA >>> 0 ? V + 1 | 0 : V, bA = V = V - ((I >>> 0 < 4293918720) - 1 | 0) | 0, EA = O = V >> 21, V = Ig(nA = (2097151 & V) << 11 | (QA = I - -1048576 | 0) >>> 21, O, -683901, -1), O = w + Z | 0, O = V >>> 0 > ($ = V + $ | 0) >>> 0 ? O + 1 | 0 : O, HA = $ - (V = -2097152 & IA) | 0, YA = O - ((V >>> 0 > $ >>> 0) + NA | 0) | 0, O = Ig(nA, EA, 136657, 0), V = w + CA | 0, V = O >>> 0 > (Z = O + AA | 0) >>> 0 ? V + 1 | 0 : V, yA = Z - (O = -2097152 & T) | 0, KA = V - ((O >>> 0 > Z >>> 0) + GA | 0) | 0, Z = (O = Ig(MA, L, 666643, 0)) + (aA - (V = -2097152 & gA) | 0) | 0, V = w + (oA - ((V >>> 0 > aA >>> 0) + pA | 0) | 0) | 0, V = O >>> 0 > Z >>> 0 ? V + 1 | 0 : V, $ = (O = Ig(JA, dA, -997805, -1)) + Z | 0, Z = w + V | 0, Z = O >>> 0 > $ >>> 0 ? Z + 1 | 0 : Z, V = Ig(UA, rA, 470296, 0), O = w + Z | 0, O = V >>> 0 > ($ = V + $ | 0) >>> 0 ? O + 1 | 0 : O, Z = Ig(FA, eA, 654183, 0), V = w + O | 0, hA = $ = Z + $ | 0, CA = Z >>> 0 > $ >>> 0 ? V + 1 | 0 : V, $ = W, W = g, g = Ig(i, 0, F, 0), O = w, V = g, g = Ig(C, 0, k, 0), O = w + O | 0, O = g >>> 0 > (Z = V + g | 0) >>> 0 ? O + 1 | 0 : O, g = Ig(C, 0, F, 0), pA = V = w, iA = g, oA = g - -1048576 | 0, GA = g = V - ((g >>> 0 < 4293918720) - 1 | 0) | 0, V = g >>> 21 | 0, BA = (g = (2097151 & g) << 11 | oA >>> 21) + Z | 0, Z = V + O | 0, gA = Z = g >>> 0 > BA >>> 0 ? Z + 1 | 0 : Z, NA = g = Z - ((BA >>> 0 < 4293918720) - 1 | 0) | 0, O = (V = g >>> 21 | 0) + W | 0, O = (g = (2097151 & g) << 11 | (AA = BA - -1048576 | 0) >>> 21) >>> 0 > (Z = g + $ | 0) >>> 0 ? O + 1 | 0 : O, W = (g = Ig(JA, dA, 654183, 0)) + (Z - (V = -2097152 & cA) | 0) | 0, Z = w + (O - ((8191 & mA) + (V >>> 0 > Z >>> 0) | 0) | 0) | 0, Z = g >>> 0 > W >>> 0 ? Z + 1 | 0 : Z, g = Ig(UA, rA, 666643, 0), V = w + Z | 0, V = g >>> 0 > (O = g + W | 0) >>> 0 ? V + 1 | 0 : V, T = (g = Ig(FA, eA, 470296, 0)) + O | 0, O = w + V | 0, IA = O = g >>> 0 > T >>> 0 ? O + 1 | 0 : O, aA = g = O - ((T >>> 0 < 4293918720) - 1 | 0) | 0, V = (V = g >> 21) + CA | 0, Z = V = (g = (2097151 & g) << 11 | ($ = T - -1048576 | 0) >>> 21) >>> 0 > (W = g + hA | 0) >>> 0 ? V + 1 | 0 : V, cA = O = V - ((W >>> 0 < 4293918720) - 1 | 0) | 0, CA = (2097151 & O) << 11 | (g = W - -1048576 | 0) >>> 21, O = (O >> 21) + KA | 0, CA = CA >>> 0 > (rA = hA = CA + yA | 0) >>> 0 ? O + 1 | 0 : O, V = Ig(nA, EA, -997805, -1), O = w + Z | 0, UA = (W = V + W | 0) - (g &= -2097152) | 0, KA = (V >>> 0 > W >>> 0 ? O + 1 | 0 : O) - ((g >>> 0 > W >>> 0) + cA | 0) | 0, g = Ig(nA, EA, 654183, 0), Z = w + IA | 0, Z = g >>> 0 > (O = g + T | 0) >>> 0 ? Z + 1 | 0 : Z, hA = O - (g = -2097152 & $) | 0, aA = Z - ((g >>> 0 > O >>> 0) + aA | 0) | 0, g = Ig(JA, dA, 470296, 0), V = w + (gA - ((8191 & NA) + ((O = -2097152 & AA) >>> 0 > BA >>> 0) | 0) | 0) | 0, V = g >>> 0 > (Z = g + (BA - O | 0) | 0) >>> 0 ? V + 1 | 0 : V, g = Ig(FA, eA, 666643, 0), V = w + V | 0, V = g >>> 0 > (O = g + Z | 0) >>> 0 ? V + 1 | 0 : V, W = O, g = Ig(JA, dA, 666643, 0), Z = w + (pA - ((2047 & GA) + ((O = -2097152 & oA) >>> 0 > iA >>> 0) | 0) | 0) | 0, T = Z = g >>> 0 > (AA = g + (iA - O | 0) | 0) >>> 0 ? Z + 1 | 0 : Z, cA = g = Z - ((AA >>> 0 < 4293918720) - 1 | 0) | 0, V = V + (O = g >> 21) | 0, oA = g = (V = (g = (2097151 & g) << 11 | (IA = AA - -1048576 | 0) >>> 21) >>> 0 > ($ = g + W | 0) >>> 0 ? V + 1 | 0 : V) - (($ >>> 0 < 4293918720) - 1 | 0) | 0, Z = (O = g >> 21) + aA | 0, g = (g = (2097151 & g) << 11 | (W = $ - -1048576 | 0) >>> 21) >>> 0 > (gA = g + hA | 0) >>> 0 ? Z + 1 | 0 : Z, O = Ig(nA, EA, 470296, 0), V = w + V | 0, V = O >>> 0 > (Z = O + $ | 0) >>> 0 ? V + 1 | 0 : V, W = Z - (O = -2097152 & W) | 0, $ = V - ((O >>> 0 > Z >>> 0) + oA | 0) | 0, O = Ig(nA, EA, 666643, 0), Z = w + (T - (((V = -2097152 & IA) >>> 0 > AA >>> 0) + cA | 0) | 0) | 0, O = (V = (Z = O >>> 0 > (iA = O + (AA - V | 0) | 0) >>> 0 ? Z + 1 | 0 : Z) >> 21) + $ | 0, V = g + (Z = (O = (Z = (2097151 & Z) << 11 | iA >>> 21) >>> 0 > (W = Z + W | 0) >>> 0 ? O + 1 | 0 : O) >> 21) | 0, O = (O = (V = (g = $ = (O = (2097151 & O) << 11 | W >>> 21) + gA | 0) >>> 0 < O >>> 0 ? V + 1 | 0 : V) >> 21) + KA | 0, V = (V = (O = (V = (2097151 & V) << 11 | g >>> 21) >>> 0 > (BA = V + UA | 0) >>> 0 ? O + 1 | 0 : O) >> 21) + CA | 0, Z = (O = (V = (O = (2097151 & O) << 11 | BA >>> 21) >>> 0 > (cA = O + rA | 0) >>> 0 ? V + 1 | 0 : V) >> 21) + YA | 0, O = (V = (Z = (V = (2097151 & V) << 11 | cA >>> 21) >>> 0 > (oA = V + HA | 0) >>> 0 ? Z + 1 | 0 : Z) >> 21) + _A | 0, V = (Z = (O = (Z = (2097151 & Z) << 11 | oA >>> 21) >>> 0 > (gA = Z + SA | 0) >>> 0 ? O + 1 | 0 : O) >> 21) + fA | 0, O = (O = (V = (O = (2097151 & O) << 11 | gA >>> 21) >>> 0 > (AA = O + wA | 0) >>> 0 ? V + 1 | 0 : V) >> 21) + tA | 0, V = (V = (O = (V = (2097151 & V) << 11 | AA >>> 21) >>> 0 > (CA = V + DA | 0) >>> 0 ? O + 1 | 0 : O) >> 21) + PA | 0, Z = (O = (V = (O = (2097151 & O) << 11 | CA >>> 21) >>> 0 > (T = O + LA | 0) >>> 0 ? V + 1 | 0 : V) >> 21) + kA | 0, V = (sA - ((I >>> 0 < (O = -2097152 & QA) >>> 0) + bA | 0) | 0) + ((Z = (V = (2097151 & V) << 11 | T >>> 21) >>> 0 > (IA = V + vA | 0) >>> 0 ? Z + 1 | 0 : Z) >> 21) | 0, QA = O = (V = ($ = (QA = I - O | 0) + ((2097151 & Z) << 11 | IA >>> 21) | 0) >>> 0 < QA >>> 0 ? V + 1 | 0 : V) >> 21, I = (I = Ig(sA = (2097151 & V) << 11 | $ >>> 21, O, 666643, 0)) + (O = 2097151 & iA) | 0, Z = w, o[0 | A] = I, Z = I >>> 0 < O >>> 0 ? Z + 1 | 0 : Z, o[A + 1 | 0] = (255 & Z) << 24 | I >>> 8, O = 2097151 & W, W = Ig(sA, QA, 470296, 0) + O | 0, V = w, V = (Z >> 21) + (V = O >>> 0 > W >>> 0 ? V + 1 | 0 : V) | 0, V = (W = (iA = (2097151 & Z) << 11 | I >>> 21) + W | 0) >>> 0 < iA >>> 0 ? V + 1 | 0 : V, o[A + 4 | 0] = (2047 & V) << 21 | W >>> 11;
                                        o[A + 3 | 0] = (7 & V) << 29 | W >>> 3, o[A + 2 | 0] = 31 & ((65535 & Z) << 16 | I >>> 16) | W << 5, I = 2097151 & g, g = Ig(sA, QA, 654183, 0) + I | 0, Z = w, Z = I >>> 0 > g >>> 0 ? Z + 1 | 0 : Z, I = V, O = (V >>= 21) + Z | 0, I = O = (I = (2097151 & I) << 11 | W >>> 21) >>> 0 > (g = I + g | 0) >>> 0 ? O + 1 | 0 : O, o[A + 6 | 0] = (63 & O) << 26 | g >>> 6, V = 0, o[A + 5 | 0] = V << 13 | (1572864 & W) >>> 19 | g << 2, V = 2097151 & BA, Z = Ig(sA, QA, -997805, -1) + V | 0, O = w, O = V >>> 0 > Z >>> 0 ? O + 1 | 0 : O, V = (V = I >> 21) + O | 0, V = (I = (W = Z) + (Z = (2097151 & I) << 11 | g >>> 21) | 0) >>> 0 < Z >>> 0 ? V + 1 | 0 : V, o[A + 9 | 0] = (511 & V) << 23 | I >>> 9, o[A + 8 | 0] = (1 & V) << 31 | I >>> 1, O = 0, o[A + 7 | 0] = O << 18 | (2080768 & g) >>> 14 | I << 7, g = 2097151 & cA, O = Ig(sA, QA, 136657, 0) + g | 0, Z = w, Z = g >>> 0 > O >>> 0 ? Z + 1 | 0 : Z, g = (W = (2097151 & (g = V)) << 11 | I >>> 21) + O | 0, O = (V >>= 21) + Z | 0, O = g >>> 0 < W >>> 0 ? O + 1 | 0 : O, o[A + 12 | 0] = (4095 & O) << 20 | g >>> 12, o[A + 11 | 0] = (15 & O) << 28 | g >>> 4, V = 0, o[A + 10 | 0] = V << 15 | (1966080 & I) >>> 17 | g << 4, I = 2097151 & oA, Z = Ig(sA, QA, -683901, -1) + I | 0, V = w, V = I >>> 0 > Z >>> 0 ? V + 1 | 0 : V, I = O, O = V + (O >>= 21) | 0, O = (I = (W = Z) + (Z = (2097151 & I) << 11 | g >>> 21) | 0) >>> 0 < Z >>> 0 ? O + 1 | 0 : O, o[A + 14 | 0] = (127 & O) << 25 | I >>> 7, V = 0, o[A + 13 | 0] = V << 12 | (1048576 & g) >>> 20 | I << 1, V = O >> 21, V = (g = (O = (2097151 & O) << 11 | I >>> 21) + (2097151 & gA) | 0) >>> 0 < O >>> 0 ? V + 1 | 0 : V, o[A + 17 | 0] = (1023 & V) << 22 | g >>> 10, o[A + 16 | 0] = (3 & V) << 30 | g >>> 2, O = 0, o[A + 15 | 0] = O << 17 | (2064384 & I) >>> 15 | g << 6, I = V, V >>= 21, Z = (I = (O = (2097151 & I) << 11 | g >>> 21) + (2097151 & AA) | 0) >>> 0 < O >>> 0 ? V + 1 | 0 : V, o[A + 20 | 0] = (8191 & Z) << 19 | I >>> 13, o[A + 19 | 0] = (31 & Z) << 27 | I >>> 5, O = Z >> 21, O = (V = (W = (2097151 & Z) << 11 | I >>> 21) + (2097151 & CA) | 0) >>> 0 < W >>> 0 ? O + 1 | 0 : O, W = V, o[A + 21 | 0] = V, V = 0, o[A + 18 | 0] = V << 14 | (1835008 & g) >>> 18 | I << 3, o[A + 22 | 0] = (255 & O) << 24 | W >>> 8, V = O >> 21, V = (I = (g = (2097151 & O) << 11 | W >>> 21) + (2097151 & T) | 0) >>> 0 < g >>> 0 ? V + 1 | 0 : V, o[A + 25 | 0] = (2047 & V) << 21 | I >>> 11, o[A + 24 | 0] = (7 & V) << 29 | I >>> 3, o[A + 23 | 0] = 31 & ((65535 & O) << 16 | W >>> 16) | I << 5, O = (2097151 & V) << 11 | I >>> 21, V >>= 21, V = (g = O + (2097151 & IA) | 0) >>> 0 < O >>> 0 ? V + 1 | 0 : V, o[A + 27 | 0] = (63 & V) << 26 | g >>> 6, O = 0, o[A + 26 | 0] = O << 13 | (1572864 & I) >>> 19 | g << 2, O = V >> 21, O = (I = (V = (2097151 & V) << 11 | g >>> 21) + (2097151 & $) | 0) >>> 0 < V >>> 0 ? O + 1 | 0 : O, o[A + 31 | 0] = (131071 & O) << 15 | I >>> 17, o[A + 30 | 0] = (511 & O) << 23 | I >>> 9, o[A + 29 | 0] = (1 & O) << 31 | I >>> 1, V = 0, o[A + 28 | 0] = V << 18 | (2080768 & g) >>> 14 | I << 7;
                                    }
                                    function F(A, I, g, C) {
                                        for(var B = 0, Q = 0, i = 0, o = 0, _ = 0, c = 0, t = 0, r = 0, e = 0, y = 0, s = 0, h = 0, D = 0, p = 0, f = 0, n = 0, k = 0, F = 0, N = 0, S = 0, G = 0, M = 0, b = 0, K = 0, H = 0, Y = 0, d = 0, J = 0, U = 0, l = 0, m = 0, u = 0, x = 0, R = 0, v = 0, L = 0, P = 0; i = (B = _ << 3) + g | 0, Q = a[0 | (B = I + B | 0)] | a[B + 1 | 0] << 8 | a[B + 2 | 0] << 16 | a[B + 3 | 0] << 24, G = a[B + 4 | 0] | a[B + 5 | 0] << 8 | a[B + 6 | 0] << 16 | a[B + 7 | 0] << 24, c = Q << 24 | (65280 & Q) << 8, t = (o = 16711680 & Q) << 24, o = o >>> 8 | 0, B = (e = -16777216 & Q) >>> 24 | 0, E[i >> 2] = t | e << 8 | -16777216 & ((255 & G) << 24 | Q >>> 8) | 16711680 & ((16777215 & G) << 8 | Q >>> 24) | G >>> 8 & 65280 | G >>> 24, Q = B | o | c, B = 0, E[i + 4 >> 2] = Q | B | B, 16 != (0 | (_ = _ + 1 | 0)););
                                        for(I = E[A + 4 >> 2], E[C >> 2] = E[A >> 2], E[C + 4 >> 2] = I, I = E[A + 60 >> 2], E[C + 56 >> 2] = E[A + 56 >> 2], E[C + 60 >> 2] = I, I = E[A + 52 >> 2], E[C + 48 >> 2] = E[A + 48 >> 2], E[C + 52 >> 2] = I, I = E[A + 44 >> 2], E[C + 40 >> 2] = E[A + 40 >> 2], E[C + 44 >> 2] = I, I = E[A + 36 >> 2], E[C + 32 >> 2] = E[A + 32 >> 2], E[C + 36 >> 2] = I, I = E[A + 28 >> 2], E[C + 24 >> 2] = E[A + 24 >> 2], E[C + 28 >> 2] = I, I = E[A + 20 >> 2], E[C + 16 >> 2] = E[A + 16 >> 2], E[C + 20 >> 2] = I, I = E[A + 12 >> 2], E[C + 8 >> 2] = E[A + 8 >> 2], E[C + 12 >> 2] = I; i = E[C + 56 >> 2], o = E[C + 60 >> 2], B = E[(I = G = (M = P << 3) + g | 0) >> 2], I = E[I + 4 >> 2], k = Q = E[C + 36 >> 2], Q = KI(p = E[C + 32 >> 2], Q, 50), _ = w, Q = KI(p, k, 46) ^ Q, _ ^= w, Q = KI(p, k, 23) ^ Q, I = (w ^ _) + I | 0, I = (B = Q + B | 0) >>> 0 < Q >>> 0 ? I + 1 | 0 : I, B = (_ = E[(Q = M + 34816 | 0) >> 2]) + B | 0, I = E[Q + 4 >> 2] + I | 0, I = B >>> 0 < _ >>> 0 ? I + 1 | 0 : I, Q = (_ = ((t = E[C + 48 >> 2]) ^ (y = E[C + 40 >> 2])) & p ^ t) + B | 0, B = (((f = E[C + 52 >> 2]) ^ (F = E[C + 44 >> 2])) & k ^ f) + I | 0, I = (Q >>> 0 < _ >>> 0 ? B + 1 | 0 : B) + o | 0, I = (i = Q + i | 0) >>> 0 < Q >>> 0 ? I + 1 | 0 : I, _ = (Q = E[C + 24 >> 2]) + i | 0, B = E[C + 28 >> 2] + I | 0, s = B = Q >>> 0 > _ >>> 0 ? B + 1 | 0 : B, E[C + 24 >> 2] = _, E[C + 28 >> 2] = B, n = B = E[C + 4 >> 2], B = KI(Q = E[C >> 2], B, 36), o = w, B = KI(Q, n, 30) ^ B, o ^= w, e = i + (KI(Q, n, 25) ^ B) | 0, B = I + (w ^ o) | 0, B = i >>> 0 > e >>> 0 ? B + 1 | 0 : B, c = (I = e) + (e = Q & ((o = E[C + 16 >> 2]) | (i = E[C + 8 >> 2])) | i & o) | 0, I = (I = B) + (n & ((B = E[C + 20 >> 2]) | (h = E[C + 12 >> 2])) | B & h) | 0, e = I = c >>> 0 < e >>> 0 ? I + 1 | 0 : I, E[C + 56 >> 2] = c, E[C + 60 >> 2] = I, r = o, D = B, S = E[(I = m = (N = 8 | M) + g | 0) >> 2], K = E[I + 4 >> 2], B = ((k ^ F) & s ^ F) + f | 0, B = (I = (o = (y ^ p) & _ ^ y) + t | 0) >>> 0 < o >>> 0 ? B + 1 | 0 : B, o = KI(_, s, 50), t = w, o = KI(_, s, 46) ^ o, t ^= w, o = (f = KI(_, s, 23) ^ o) + I | 0, I = (w ^ t) + B | 0, I = (o >>> 0 < f >>> 0 ? I + 1 | 0 : I) + K | 0, I = (B = o + S | 0) >>> 0 < o >>> 0 ? I + 1 | 0 : I, o = (o = B) + (t = E[(B = N + 34816 | 0) >> 2]) | 0, B = E[B + 4 >> 2] + I | 0, B = (I = o >>> 0 < t >>> 0 ? B + 1 | 0 : B) + D | 0, f = B = (t = o + r | 0) >>> 0 < o >>> 0 ? B + 1 | 0 : B, E[C + 16 >> 2] = t, E[C + 20 >> 2] = B, I = I + ((h | n) & e | h & n) | 0, I = (B = o + ((Q | i) & c | Q & i) | 0) >>> 0 < o >>> 0 ? I + 1 | 0 : I, o = KI(c, e, 36), r = w, o = KI(c, e, 30) ^ o, r ^= w, D = B, B = KI(c, e, 25) ^ o, I = (w ^ r) + I | 0, r = I = B >>> 0 > (o = D + B | 0) >>> 0 ? I + 1 | 0 : I, E[C + 48 >> 2] = o, E[C + 52 >> 2] = I, D = i, N = h, I = (h = E[(B = d = (i = 16 | M) + g | 0) >> 2]) + y | 0, B = E[B + 4 >> 2] + F | 0, B = I >>> 0 < h >>> 0 ? B + 1 | 0 : B, i = (y = I) + (h = E[(I = i + 34816 | 0) >> 2]) | 0, I = E[I + 4 >> 2] + B | 0, I = ((s ^ k) & f ^ k) + (I = i >>> 0 < h >>> 0 ? I + 1 | 0 : I) | 0, I = (B = (B = i) + (i = (_ ^ p) & t ^ p) | 0) >>> 0 < i >>> 0 ? I + 1 | 0 : I, i = KI(t, f, 50), h = w, i = KI(t, f, 46) ^ i, h ^= w, i = (y = KI(t, f, 23) ^ i) + B | 0, B = (w ^ h) + I | 0, B = (y = i >>> 0 < y >>> 0 ? B + 1 | 0 : B) + N | 0, N = B = (h = i) >>> 0 > (i = i + D | 0) >>> 0 ? B + 1 | 0 : B, E[C + 8 >> 2] = i, E[C + 12 >> 2] = B, I = KI(o, r, 36), B = w, I = KI(o, r, 30) ^ I, B ^= w, F = KI(o, r, 25) ^ I, I = ((e | n) & r | e & n) + (w ^ B) | 0, B = y + ((D = F + ((Q | c) & o | Q & c) | 0) >>> 0 < F >>> 0 ? I + 1 | 0 : I) | 0, h = B = (y = h + D | 0) >>> 0 < h >>> 0 ? B + 1 | 0 : B, E[C + 40 >> 2] = y, E[C + 44 >> 2] = B, D = Q, B = (B = p) + (p = E[(I = u = (Q = 24 | M) + g | 0) >> 2]) | 0, I = E[I + 4 >> 2] + k | 0, I = B >>> 0 < p >>> 0 ? I + 1 | 0 : I, Q = (F = B) + (p = E[(B = Q + 34816 | 0) >> 2]) | 0, B = E[B + 4 >> 2] + I | 0, B = (s ^ (s ^ f) & N) + (B = Q >>> 0 < p >>> 0 ? B + 1 | 0 : B) | 0, B = (I = (I = Q) + (Q = _ ^ (_ ^ t) & i) | 0) >>> 0 < Q >>> 0 ? B + 1 | 0 : B, Q = KI(i, N, 50), p = w, Q = KI(i, N, 46) ^ Q, p ^= w, Q = (k = KI(i, N, 23) ^ Q) + I | 0, I = (w ^ p) + B | 0, B = (I = Q >>> 0 < k >>> 0 ? I + 1 | 0 : I) + n | 0, k = B = (n = Q + D | 0) >>> 0 < Q >>> 0 ? B + 1 | 0 : B, E[C >> 2] = n, E[C + 4 >> 2] = B, B = KI(y, h, 36), p = w, B = KI(y, h, 30) ^ B, D = w ^ p, F = KI(y, h, 25) ^ B, B = ((e | r) & h | e & r) + (w ^ D) | 0, I = I + ((p = F + ((o | c) & y | o & c) | 0) >>> 0 < F >>> 0 ? B + 1 | 0 : B) | 0, p = I = (D = Q + p | 0) >>> 0 < Q >>> 0 ? I + 1 | 0 : I, E[C + 32 >> 2] = D, E[C + 36 >> 2] = I, Q = E[(B = l = (I = 32 | M) + g | 0) >> 2], B = s + E[B + 4 >> 2] | 0, B = (Q = Q + _ | 0) >>> 0 < _ >>> 0 ? B + 1 | 0 : B, Q = (_ = E[(I = I + 34816 | 0) >> 2]) + Q | 0, I = E[I + 4 >> 2] + B | 0, I = (f ^ (f ^ N) & k) + (I = Q >>> 0 < _ >>> 0 ? I + 1 | 0 : I) | 0, I = (B = (B = Q) + (Q = t ^ (i ^ t) & n) | 0) >>> 0 < Q >>> 0 ? I + 1 | 0 : I, Q = KI(n, k, 50), _ = w, Q = KI(n, k, 46) ^ Q, _ ^= w, Q = (s = KI(n, k, 23) ^ Q) + B | 0, B = (w ^ _) + I | 0, F = B = Q >>> 0 < s >>> 0 ? B + 1 | 0 : B, I = B, B = KI(D, p, 36), _ = w, B = KI(D, p, 30) ^ B, s = w ^ _, S = KI(D, p, 25) ^ B, B = ((r | h) & p | r & h) + (w ^ s) | 0, I = ((_ = S + ((o | y) & D | o & y) | 0) >>> 0 < S >>> 0 ? B + 1 | 0 : B) + I | 0, _ = I = (s = Q + _ | 0) >>> 0 < _ >>> 0 ? I + 1 | 0 : I, E[C + 24 >> 2] = s, E[C + 28 >> 2] = I, B = e + F | 0, F = B = (e = Q + c | 0) >>> 0 < Q >>> 0 ? B + 1 | 0 : B, E[C + 56 >> 2] = e, E[C + 60 >> 2] = B, Q = E[(I = J = (B = 40 | M) + g | 0) >> 2], I = f + E[I + 4 >> 2] | 0, I = (Q = Q + t | 0) >>> 0 < t >>> 0 ? I + 1 | 0 : I, Q = (c = E[(B = B + 34816 | 0) >> 2]) + Q | 0, B = E[B + 4 >> 2] + I | 0, B = (N ^ (k ^ N) & F) + (B = Q >>> 0 < c >>> 0 ? B + 1 | 0 : B) | 0, B = (I = (I = Q) + (Q = i ^ (i ^ n) & e) | 0) >>> 0 < Q >>> 0 ? B + 1 | 0 : B, Q = KI(e, F, 50), c = w, Q = KI(e, F, 46) ^ Q, c ^= w, Q = (t = KI(e, F, 23) ^ Q) + I | 0, I = (w ^ c) + B | 0, I = Q >>> 0 < t >>> 0 ? I + 1 | 0 : I, B = KI(s, _, 36), c = w, B = KI(s, _, 30) ^ B, t = w ^ c, f = KI(s, _, 25) ^ B, B = ((h | p) & _ | h & p) + (w ^ t) | 0, B = ((c = f + ((y | D) & s | y & D) | 0) >>> 0 < f >>> 0 ? B + 1 | 0 : B) + I | 0, c = B = (t = Q + c | 0) >>> 0 < c >>> 0 ? B + 1 | 0 : B, E[C + 16 >> 2] = t, E[C + 20 >> 2] = B, I = I + r | 0, S = I = (r = Q + o | 0) >>> 0 < o >>> 0 ? I + 1 | 0 : I, E[C + 48 >> 2] = r, E[C + 52 >> 2] = I, Q = E[(B = Y = (I = 48 | M) + g | 0) >> 2], B = N + E[B + 4 >> 2] | 0, B = (Q = Q + i | 0) >>> 0 < i >>> 0 ? B + 1 | 0 : B, Q = (i = E[(I = I + 34816 | 0) >> 2]) + Q | 0, I = E[I + 4 >> 2] + B | 0, I = (k ^ (k ^ F) & S) + (I = Q >>> 0 < i >>> 0 ? I + 1 | 0 : I) | 0, I = (B = (B = Q) + (Q = n ^ (e ^ n) & r) | 0) >>> 0 < Q >>> 0 ? I + 1 | 0 : I, Q = KI(r, S, 50), i = w, Q = KI(r, S, 46) ^ Q, i ^= w, Q = (o = KI(r, S, 23) ^ Q) + B | 0, B = (w ^ i) + I | 0, o = B = Q >>> 0 < o >>> 0 ? B + 1 | 0 : B, I = B, B = KI(t, c, 36), i = w, B = KI(t, c, 30) ^ B, f = w ^ i, N = KI(t, c, 25) ^ B, B = ((_ | p) & c | _ & p) + (w ^ f) | 0, I = ((i = N + ((s | D) & t | s & D) | 0) >>> 0 < N >>> 0 ? B + 1 | 0 : B) + I | 0, f = I = (B = i) >>> 0 > (i = Q + i | 0) >>> 0 ? I + 1 | 0 : I, E[C + 8 >> 2] = i, E[C + 12 >> 2] = I, B = o + h | 0, N = B = (K = Q + y | 0) >>> 0 < Q >>> 0 ? B + 1 | 0 : B, E[C + 40 >> 2] = K, E[C + 44 >> 2] = B, Q = E[(I = U = (B = 56 | M) + g | 0) >> 2], I = k + E[I + 4 >> 2] | 0, I = (Q = Q + n | 0) >>> 0 < n >>> 0 ? I + 1 | 0 : I, Q = (o = E[(B = B + 34816 | 0) >> 2]) + Q | 0, B = E[B + 4 >> 2] + I | 0, B = (F ^ (F ^ S) & N) + (B = Q >>> 0 < o >>> 0 ? B + 1 | 0 : B) | 0, B = (I = (I = Q) + (Q = e ^ (e ^ r) & K) | 0) >>> 0 < Q >>> 0 ? B + 1 | 0 : B, Q = KI(K, N, 50), o = w, Q = KI(K, N, 46) ^ Q, o ^= w, Q = (h = KI(K, N, 23) ^ Q) + I | 0, I = (w ^ o) + B | 0, I = Q >>> 0 < h >>> 0 ? I + 1 | 0 : I, B = KI(i, f, 36), o = w, B = KI(i, f, 30) ^ B, h = w ^ o, y = KI(i, f, 25) ^ B, B = ((_ | c) & f | _ & c) + (w ^ h) | 0, B = ((o = y + ((t | s) & i | t & s) | 0) >>> 0 < y >>> 0 ? B + 1 | 0 : B) + I | 0, h = B = (h = o) >>> 0 > (o = Q + o | 0) >>> 0 ? B + 1 | 0 : B, E[C >> 2] = o, E[C + 4 >> 2] = B, I = I + p | 0, k = I = (y = Q + D | 0) >>> 0 < Q >>> 0 ? I + 1 | 0 : I, E[C + 32 >> 2] = y, E[C + 36 >> 2] = I, Q = E[(B = x = (I = 64 | M) + g | 0) >> 2], B = F + E[B + 4 >> 2] | 0, B = (Q = Q + e | 0) >>> 0 < e >>> 0 ? B + 1 | 0 : B, Q = (e = E[(I = I + 34816 | 0) >> 2]) + Q | 0, I = E[I + 4 >> 2] + B | 0, I = (S ^ (N ^ S) & k) + (I = Q >>> 0 < e >>> 0 ? I + 1 | 0 : I) | 0, I = (B = (B = Q) + (Q = r ^ (r ^ K) & y) | 0) >>> 0 < Q >>> 0 ? I + 1 | 0 : I, Q = KI(y, k, 50), e = w, Q = KI(y, k, 46) ^ Q, e ^= w, Q = (n = KI(y, k, 23) ^ Q) + B | 0, B = (w ^ e) + I | 0, p = B = Q >>> 0 < n >>> 0 ? B + 1 | 0 : B, I = B, B = KI(o, h, 36), e = w, B = KI(o, h, 30) ^ B, n = w ^ e, D = KI(o, h, 25) ^ B, B = ((c | f) & h | c & f) + (w ^ n) | 0, I = ((e = D + ((i | t) & o | i & t) | 0) >>> 0 < D >>> 0 ? B + 1 | 0 : B) + I | 0, e = I = (n = Q + e | 0) >>> 0 < e >>> 0 ? I + 1 | 0 : I, E[C + 56 >> 2] = n, E[C + 60 >> 2] = I, B = _ + p | 0, F = B = (_ = Q + s | 0) >>> 0 < Q >>> 0 ? B + 1 | 0 : B, E[C + 24 >> 2] = _, E[C + 28 >> 2] = B, Q = E[(I = H = (B = 72 | M) + g | 0) >> 2], I = S + E[I + 4 >> 2] | 0, I = (Q = Q + r | 0) >>> 0 < r >>> 0 ? I + 1 | 0 : I, Q = (r = E[(B = B + 34816 | 0) >> 2]) + Q | 0, B = E[B + 4 >> 2] + I | 0, B = (N ^ (k ^ N) & F) + (B = Q >>> 0 < r >>> 0 ? B + 1 | 0 : B) | 0, B = (I = (I = Q) + (Q = K ^ (y ^ K) & _) | 0) >>> 0 < Q >>> 0 ? B + 1 | 0 : B, Q = KI(_, F, 50), r = w, Q = KI(_, F, 46) ^ Q, r ^= w, Q = (p = KI(_, F, 23) ^ Q) + I | 0, I = (w ^ r) + B | 0, I = Q >>> 0 < p >>> 0 ? I + 1 | 0 : I, B = KI(n, e, 36), r = w, B = KI(n, e, 30) ^ B, p = w ^ r, D = KI(n, e, 25) ^ B, B = ((h | f) & e | h & f) + (w ^ p) | 0, B = ((r = D + ((i | o) & n | i & o) | 0) >>> 0 < D >>> 0 ? B + 1 | 0 : B) + I | 0, r = B = (p = Q + r | 0) >>> 0 < r >>> 0 ? B + 1 | 0 : B, E[C + 48 >> 2] = p, E[C + 52 >> 2] = B, I = I + c | 0, S = I = (c = Q + t | 0) >>> 0 < Q >>> 0 ? I + 1 | 0 : I, E[C + 16 >> 2] = c, E[C + 20 >> 2] = I, I = (I = K) + (t = E[(B = K = (Q = 80 | M) + g | 0) >> 2]) | 0, B = E[B + 4 >> 2] + N | 0, B = I >>> 0 < t >>> 0 ? B + 1 | 0 : B, Q = (s = I) + (t = E[(I = Q + 34816 | 0) >> 2]) | 0, I = E[I + 4 >> 2] + B | 0, I = (k ^ (k ^ F) & S) + (I = Q >>> 0 < t >>> 0 ? I + 1 | 0 : I) | 0, I = (B = (B = Q) + (Q = y ^ (_ ^ y) & c) | 0) >>> 0 < Q >>> 0 ? I + 1 | 0 : I, Q = KI(c, S, 50), t = w, Q = KI(c, S, 46) ^ Q, t ^= w, Q = (D = KI(c, S, 23) ^ Q) + B | 0, B = (w ^ t) + I | 0, s = B = Q >>> 0 < D >>> 0 ? B + 1 | 0 : B, I = B, B = KI(p, r, 36), t = w, B = KI(p, r, 30) ^ B, D = w ^ t, N = KI(p, r, 25) ^ B, B = ((e | h) & r | e & h) + (w ^ D) | 0, I = ((t = N + ((o | n) & p | o & n) | 0) >>> 0 < N >>> 0 ? B + 1 | 0 : B) + I | 0, t = I = (D = Q + t | 0) >>> 0 < t >>> 0 ? I + 1 | 0 : I, E[C + 40 >> 2] = D, E[C + 44 >> 2] = I, B = s + f | 0, f = B = (s = Q + i | 0) >>> 0 < i >>> 0 ? B + 1 | 0 : B, E[C + 8 >> 2] = s, E[C + 12 >> 2] = B, B = 34816 + (I = 88 | M) | 0, i = E[(I = b = I + g | 0) >> 2], Q = E[B >> 2] + i | 0, I = E[B + 4 >> 2] + E[I + 4 >> 2] | 0, B = k + (Q >>> 0 < i >>> 0 ? I + 1 | 0 : I) | 0, B = (F ^ (F ^ S) & f) + (B = (I = Q + y | 0) >>> 0 < y >>> 0 ? B + 1 | 0 : B) | 0, B = (I = (Q = _ ^ (_ ^ c) & s) + I | 0) >>> 0 < Q >>> 0 ? B + 1 | 0 : B, Q = KI(s, f, 50), i = w, Q = KI(s, f, 46) ^ Q, i ^= w, Q = (y = KI(s, f, 23) ^ Q) + I | 0, I = (w ^ i) + B | 0, I = Q >>> 0 < y >>> 0 ? I + 1 | 0 : I, B = KI(D, t, 36), i = w, B = KI(D, t, 30) ^ B, y = w ^ i, N = KI(D, t, 25) ^ B, B = ((e | r) & t | e & r) + (w ^ y) | 0, B = ((i = N + ((p | n) & D | p & n) | 0) >>> 0 < N >>> 0 ? B + 1 | 0 : B) + I | 0, y = B = (y = i) >>> 0 > (i = Q + i | 0) >>> 0 ? B + 1 | 0 : B, E[C + 32 >> 2] = i, E[C + 36 >> 2] = B, I = I + h | 0, h = I = (B = o) >>> 0 > (o = Q + o | 0) >>> 0 ? I + 1 | 0 : I, E[C >> 2] = o, E[C + 4 >> 2] = I, B = 34816 + (I = 96 | M) | 0, N = E[(I = R = I + g | 0) >> 2], Q = E[B >> 2] + N | 0, B = E[B + 4 >> 2] + E[I + 4 >> 2] | 0, I = F + (Q >>> 0 < N >>> 0 ? B + 1 | 0 : B) | 0, I = (B = Q + _ | 0) >>> 0 < _ >>> 0 ? I + 1 | 0 : I, Q = (_ = c ^ (c ^ s) & o) + B | 0, B = (S ^ (f ^ S) & h) + I | 0, B = Q >>> 0 < _ >>> 0 ? B + 1 | 0 : B, I = KI(o, h, 50), _ = w, I = KI(o, h, 46) ^ I, _ ^= w, F = Q, Q = KI(o, h, 23) ^ I, B = (w ^ _) + B | 0, k = B = (I = F + Q | 0) >>> 0 < Q >>> 0 ? B + 1 | 0 : B, Q = I, I = KI(i, y, 36), _ = w, I = KI(i, y, 30) ^ I, N = w ^ _, F = KI(i, y, 25) ^ I, I = ((t | r) & y | t & r) + (w ^ N) | 0, B = ((_ = F + ((p | D) & i | p & D) | 0) >>> 0 < F >>> 0 ? I + 1 | 0 : I) + B | 0, _ = B = (N = Q + _ | 0) >>> 0 < _ >>> 0 ? B + 1 | 0 : B, E[C + 24 >> 2] = N, E[C + 28 >> 2] = B, B = e + k | 0, e = B = (n = Q + n | 0) >>> 0 < Q >>> 0 ? B + 1 | 0 : B, E[C + 56 >> 2] = n, E[C + 60 >> 2] = B, B = 34816 + (I = 104 | M) | 0, k = E[(I = L = I + g | 0) >> 2], Q = E[B >> 2] + k | 0, I = E[B + 4 >> 2] + E[I + 4 >> 2] | 0, B = S + (Q >>> 0 < k >>> 0 ? I + 1 | 0 : I) | 0, B = (I = Q + c | 0) >>> 0 < c >>> 0 ? B + 1 | 0 : B, Q = (c = s ^ (o ^ s) & n) + I | 0, I = (f ^ (h ^ f) & e) + B | 0, I = Q >>> 0 < c >>> 0 ? I + 1 | 0 : I, B = KI(n, e, 50), c = w, B = KI(n, e, 46) ^ B, c ^= w, k = KI(n, e, 23) ^ B, B = (w ^ c) + I | 0, F = B = (Q = k + Q | 0) >>> 0 < k >>> 0 ? B + 1 | 0 : B, I = B, B = KI(N, _, 36), c = w, B = KI(N, _, 30) ^ B, k = w ^ c, S = KI(N, _, 25) ^ B, B = ((t | y) & _ | t & y) + (w ^ k) | 0, I = ((c = S + ((i | D) & N | i & D) | 0) >>> 0 < S >>> 0 ? B + 1 | 0 : B) + I | 0, c = I = (k = Q + c | 0) >>> 0 < c >>> 0 ? I + 1 | 0 : I, E[C + 16 >> 2] = k, E[C + 20 >> 2] = I, I = r + F | 0, r = I = (p = Q + p | 0) >>> 0 < Q >>> 0 ? I + 1 | 0 : I, E[C + 48 >> 2] = p, E[C + 52 >> 2] = I, B = 34816 + (I = 112 | M) | 0, F = E[(Q = S = I + g | 0) >> 2], I = E[B >> 2] + F | 0, B = E[B + 4 >> 2] + E[Q + 4 >> 2] | 0, B = f + (I >>> 0 < F >>> 0 ? B + 1 | 0 : B) | 0, B = (h ^ (e ^ h) & r) + (B = (I = I + s | 0) >>> 0 < s >>> 0 ? B + 1 | 0 : B) | 0, B = (I = (Q = o ^ (o ^ n) & p) + I | 0) >>> 0 < Q >>> 0 ? B + 1 | 0 : B, Q = KI(p, r, 50), s = w, Q = KI(p, r, 46) ^ Q, s ^= w, Q = (f = KI(p, r, 23) ^ Q) + I | 0, I = (w ^ s) + B | 0, F = I = Q >>> 0 < f >>> 0 ? I + 1 | 0 : I, B = I, I = KI(k, c, 36), s = w, I = KI(k, c, 30) ^ I, f = w ^ s, v = KI(k, c, 25) ^ I, I = ((_ | y) & c | _ & y) + (w ^ f) | 0, B = ((s = v + ((i | N) & k | i & N) | 0) >>> 0 < v >>> 0 ? I + 1 | 0 : I) + B | 0, s = B = (f = Q + s | 0) >>> 0 < s >>> 0 ? B + 1 | 0 : B, E[C + 8 >> 2] = f, E[C + 12 >> 2] = B, B = t + F | 0, Q = B = (t = Q + D | 0) >>> 0 < Q >>> 0 ? B + 1 | 0 : B, E[C + 40 >> 2] = t, E[C + 44 >> 2] = B, B = 34816 + (I = 120 | M) | 0, M = E[(I = D = I + g | 0) >> 2], F = E[B >> 2] + M | 0, B = E[B + 4 >> 2] + E[I + 4 >> 2] | 0, I = h + (F >>> 0 < M >>> 0 ? B + 1 | 0 : B) | 0, I = (e ^ (e ^ r) & Q) + (I = (B = o + F | 0) >>> 0 < o >>> 0 ? I + 1 | 0 : I) | 0, I = (B = (o = n ^ (p ^ n) & t) + B | 0) >>> 0 < o >>> 0 ? I + 1 | 0 : I, o = KI(t, Q, 50), e = w, o = KI(t, Q, 46) ^ o, e ^= w, Q = (o = KI(t, Q, 23) ^ o) + B | 0, B = (w ^ e) + I | 0, B = Q >>> 0 < o >>> 0 ? B + 1 | 0 : B, o = Q, e = B, I = B, B = KI(f, s, 36), t = w, B = KI(f, s, 30) ^ B, r = w ^ t, h = KI(f, s, 25) ^ B, B = ((_ | c) & s | _ & c) + (w ^ r) | 0, I = ((t = h + ((k | N) & f | k & N) | 0) >>> 0 < h >>> 0 ? B + 1 | 0 : B) + I | 0, I = (Q = Q + t | 0) >>> 0 < t >>> 0 ? I + 1 | 0 : I, E[C >> 2] = Q, E[C + 4 >> 2] = I, B = e + y | 0, B = (r = i) >>> 0 > (i = i + o | 0) >>> 0 ? B + 1 | 0 : B, E[C + 32 >> 2] = i, E[C + 36 >> 2] = B, 64 != (0 | P);)c = ((P = P + 16 | 0) << 3) + g | 0, o = E[G >> 2], _ = E[G + 4 >> 2], v = E[H >> 2], e = I = E[H + 4 >> 2], B = I, Q = I = E[S + 4 >> 2], I = KI(N = E[S >> 2], I, 45), i = w, r = ((63 & Q) << 26 | N >>> 6) ^ (I = KI(N, Q, 3) ^ I), I = (Q >>> 6 ^ (t = w ^ i)) + B | 0, B = ((i = r + v | 0) >>> 0 < r >>> 0 ? I + 1 | 0 : I) + _ | 0, B = (I = i + o | 0) >>> 0 < i >>> 0 ? B + 1 | 0 : B, o = i = E[m + 4 >> 2], i = KI(_ = E[m >> 2], i, 63), t = w, i = ((127 & o) << 25 | _ >>> 7) ^ KI(_, o, 56) ^ i, B = (w ^ t ^ o >>> 7) + B | 0, i = B = i >>> 0 > (k = i + I | 0) >>> 0 ? B + 1 | 0 : B, E[c >> 2] = k, E[c + 4 >> 2] = B, _ = (S = E[K >> 2]) + _ | 0, I = (c = E[K + 4 >> 2]) + o | 0, B = _ >>> 0 < S >>> 0 ? I + 1 | 0 : I, o = I = E[D + 4 >> 2], I = KI(F = E[D >> 2], I, 45), t = w, r = _, _ = ((63 & o) << 26 | F >>> 6) ^ KI(F, o, 3) ^ I, B = (w ^ t ^ o >>> 6) + B | 0, _ = _ >>> 0 > (r = r + _ | 0) >>> 0 ? B + 1 | 0 : B, B = KI(t = E[d >> 2], I = E[d + 4 >> 2], 63), h = w, s = r, r = ((127 & I) << 25 | t >>> 7) ^ KI(t, I, 56) ^ B, B = (w ^ h ^ I >>> 7) + _ | 0, _ = B = r >>> 0 > (f = s + r | 0) >>> 0 ? B + 1 | 0 : B, E[G + 136 >> 2] = f, E[G + 140 >> 2] = B, B = (K = E[b >> 2]) + t | 0, I = (t = E[b + 4 >> 2]) + I | 0, r = KI(k, i, 45), h = w, r = (y = ((63 & i) << 26 | k >>> 6) ^ KI(k, i, 3) ^ r) + B | 0, B = (w ^ h ^ i >>> 6) + (B >>> 0 < K >>> 0 ? I + 1 | 0 : I) | 0, B = r >>> 0 < y >>> 0 ? B + 1 | 0 : B, h = I = E[u + 4 >> 2], I = KI(y = E[u >> 2], I, 63), n = w, s = r, r = ((127 & h) << 25 | y >>> 7) ^ KI(y, h, 56) ^ I, B = (w ^ n ^ h >>> 7) + B | 0, r = B = r >>> 0 > (M = s + r | 0) >>> 0 ? B + 1 | 0 : B, E[G + 144 >> 2] = M, E[G + 148 >> 2] = B, y = (m = E[R >> 2]) + y | 0, I = (I = h) + (h = E[R + 4 >> 2]) | 0, B = y >>> 0 < m >>> 0 ? I + 1 | 0 : I, I = KI(f, _, 45), n = w, p = ((63 & _) << 26 | f >>> 6) ^ KI(f, _, 3) ^ I, B = (w ^ n ^ _ >>> 6) + B | 0, B = (y = p + y | 0) >>> 0 < p >>> 0 ? B + 1 | 0 : B, n = I = E[l + 4 >> 2], I = KI(p = E[l >> 2], I, 63), D = w, s = y, y = ((127 & n) << 25 | p >>> 7) ^ KI(p, n, 56) ^ I, B = (w ^ D ^ n >>> 7) + B | 0, y = B = y >>> 0 > (d = s + y | 0) >>> 0 ? B + 1 | 0 : B, E[G + 152 >> 2] = d, E[G + 156 >> 2] = B, I = (u = E[L >> 2]) + p | 0, B = (B = n) + (n = E[L + 4 >> 2]) | 0, p = KI(M, r, 45), D = w, p = ((63 & r) << 26 | M >>> 6) ^ KI(M, r, 3) ^ p, B = (w ^ D ^ r >>> 6) + (I >>> 0 < u >>> 0 ? B + 1 | 0 : B) | 0, p = (s = p + I | 0) >>> 0 < p >>> 0 ? B + 1 | 0 : B, B = KI(D = E[J >> 2], I = E[J + 4 >> 2], 63), l = w, b = s, s = ((127 & I) << 25 | D >>> 7) ^ (B = KI(D, I, 56) ^ B), B = (I >>> 7 ^ (J = w ^ l)) + p | 0, p = B = s >>> 0 > (l = b + s | 0) >>> 0 ? B + 1 | 0 : B, E[G + 160 >> 2] = l, E[G + 164 >> 2] = B, I = I + Q | 0, I = (B = D + N | 0) >>> 0 < D >>> 0 ? I + 1 | 0 : I, D = KI(d, y, 45), s = w, D = (J = ((63 & y) << 26 | d >>> 6) ^ KI(d, y, 3) ^ D) + B | 0, B = (w ^ s ^ y >>> 6) + I | 0, B = D >>> 0 < J >>> 0 ? B + 1 | 0 : B, s = E[Y >> 2], Y = I = E[Y + 4 >> 2], I = KI(s, I, 63), J = w, I = KI(s, Y, 56) ^ I, b = D, B = (Y >>> 7 ^ (H = w ^ J)) + B | 0, D = B = (D = ((127 & Y) << 25 | s >>> 7) ^ I) >>> 0 > (J = b + D | 0) >>> 0 ? B + 1 | 0 : B, E[G + 168 >> 2] = J, E[G + 172 >> 2] = B, I = o + Y | 0, I = (B = s + F | 0) >>> 0 < s >>> 0 ? I + 1 | 0 : I, b = s = E[U + 4 >> 2], s = KI(H = E[U >> 2], s, 63), Y = w, s = (U = ((127 & b) << 25 | H >>> 7) ^ KI(H, b, 56) ^ s) + B | 0, B = (w ^ Y ^ b >>> 7) + I | 0, I = s >>> 0 < U >>> 0 ? B + 1 | 0 : B, B = KI(l, p, 45), Y = w, B = KI(l, p, 3) ^ B, U = w ^ Y, Y = s, I = (p >>> 6 ^ U) + I | 0, s = I = (s = ((63 & p) << 26 | l >>> 6) ^ B) >>> 0 > (Y = Y + s | 0) >>> 0 ? I + 1 | 0 : I, E[G + 176 >> 2] = Y, E[G + 180 >> 2] = I, R = E[x >> 2], x = I = E[x + 4 >> 2], U = I, I = KI(v, e, 63), B = w, L = ((127 & e) << 25 | v >>> 7) ^ KI(v, e, 56) ^ I, I = (w ^ B ^ e >>> 7) + _ | 0, B = ((f = L + f | 0) >>> 0 < L >>> 0 ? I + 1 | 0 : I) + U | 0, B = (I = f + R | 0) >>> 0 < f >>> 0 ? B + 1 | 0 : B, _ = KI(Y, s, 45), f = w, U = (_ = ((63 & s) << 26 | Y >>> 6) ^ KI(Y, s, 3) ^ _) + I | 0, I = (w ^ f ^ s >>> 6) + B | 0, _ = I = _ >>> 0 > U >>> 0 ? I + 1 | 0 : I, E[G + 192 >> 2] = U, E[G + 196 >> 2] = I, B = i + b | 0, B = (I = k + H | 0) >>> 0 < H >>> 0 ? B + 1 | 0 : B, f = KI(R, x, 63), H = w, b = ((127 & x) << 25 | R >>> 7) ^ KI(R, x, 56) ^ f, B = (w ^ H ^ x >>> 7) + B | 0, I = (f = b + I | 0) >>> 0 < b >>> 0 ? B + 1 | 0 : B, B = KI(J, D, 45), H = w, B = KI(J, D, 3) ^ B, x = f, I = (D >>> 6 ^ (b = w ^ H)) + I | 0, f = I = (f = ((63 & D) << 26 | J >>> 6) ^ B) >>> 0 > (H = x + f | 0) >>> 0 ? I + 1 | 0 : I, E[G + 184 >> 2] = H, E[G + 188 >> 2] = I, I = KI(K, t, 63), B = w, I = ((127 & t) << 25 | K >>> 7) ^ KI(K, t, 56) ^ I, B = (w ^ B ^ t >>> 7) + c | 0, I = y + (I >>> 0 > (b = I + S | 0) >>> 0 ? B + 1 | 0 : B) | 0, I = (B = d + b | 0) >>> 0 < d >>> 0 ? I + 1 | 0 : I, y = KI(U, _, 45), d = w, y = KI(U, _, 3) ^ y, b = w ^ d, d = (y ^= (63 & _) << 26 | U >>> 6) + B | 0, B = (_ >>> 6 ^ b) + I | 0, y = B = y >>> 0 > d >>> 0 ? B + 1 | 0 : B, E[G + 208 >> 2] = d, E[G + 212 >> 2] = B, I = KI(S, c, 63), B = w, b = KI(S, c, 56) ^ I, B = ((I = c >>> 7 | 0) ^ w ^ B) + e | 0, I = r + ((c = (S = b ^ ((127 & c) << 25 | S >>> 7)) + v | 0) >>> 0 < S >>> 0 ? B + 1 | 0 : B) | 0, I = (B = c + M | 0) >>> 0 < M >>> 0 ? I + 1 | 0 : I, e = KI(H, f, 45), c = w, r = (e = ((63 & f) << 26 | H >>> 6) ^ KI(H, f, 3) ^ e) + B | 0, B = (w ^ c ^ f >>> 6) + I | 0, e = B = e >>> 0 > r >>> 0 ? B + 1 | 0 : B, E[G + 200 >> 2] = r, E[G + 204 >> 2] = B, I = KI(u, n, 63), B = w, S = ((127 & n) << 25 | u >>> 7) ^ KI(u, n, 56) ^ I, I = (w ^ B ^ n >>> 7) + h | 0, B = D + ((c = S + m | 0) >>> 0 < S >>> 0 ? I + 1 | 0 : I) | 0, B = (I = c + J | 0) >>> 0 < J >>> 0 ? B + 1 | 0 : B, c = KI(d, y, 45), D = w, S = I, I = y >>> 6 | 0, c = ((63 & y) << 26 | d >>> 6) ^ KI(d, y, 3) ^ c, B = (I ^ w ^ D) + B | 0, c = B = c >>> 0 > (y = S + c | 0) >>> 0 ? B + 1 | 0 : B, E[G + 224 >> 2] = y, E[G + 228 >> 2] = B, I = KI(m, h, 63), B = w, I = KI(m, h, 56) ^ I, D = w ^ B, S = ((127 & h) << 25 | m >>> 7) ^ I, I = ((B = h >>> 7 | 0) ^ D) + t | 0, B = p + ((h = S + K | 0) >>> 0 < S >>> 0 ? I + 1 | 0 : I) | 0, B = (I = h + l | 0) >>> 0 < l >>> 0 ? B + 1 | 0 : B, t = KI(r, e, 45), h = w, D = I, I = e >>> 6 | 0, e = ((63 & e) << 26 | r >>> 6) ^ KI(r, e, 3) ^ t, I = (I ^ w ^ h) + B | 0, e = I = (t = D + e | 0) >>> 0 < e >>> 0 ? I + 1 | 0 : I, E[G + 216 >> 2] = t, E[G + 220 >> 2] = I, I = KI(F, o, 63), B = w, h = ((127 & o) << 25 | F >>> 7) ^ KI(F, o, 56) ^ I, B = (w ^ B ^ o >>> 7) + Q | 0, B = f + ((I = h + N | 0) >>> 0 < h >>> 0 ? B + 1 | 0 : B) | 0, I = (r = I + H | 0) >>> 0 < H >>> 0 ? B + 1 | 0 : B, B = KI(y, c, 45), h = w, D = r, r = KI(y, c, 3) ^ B, B = c >>> 6 | 0, c = D + (r ^= (63 & c) << 26 | y >>> 6) | 0, I = (B ^ w ^ h) + I | 0, E[G + 240 >> 2] = c, E[G + 244 >> 2] = c >>> 0 < r >>> 0 ? I + 1 | 0 : I, I = KI(N, Q, 63), B = w, I = KI(N, Q, 56) ^ I, c = w ^ B, B = ((B = Q >>> 7 | 0) ^ c) + n | 0, I = s + ((I ^= (127 & Q) << 25 | N >>> 7) >>> 0 > (Q = I + u | 0) >>> 0 ? B + 1 | 0 : B) | 0, I = (B = Q + Y | 0) >>> 0 < Y >>> 0 ? I + 1 | 0 : I, Q = KI(t, e, 45), c = w, r = B, B = e >>> 6 | 0, Q = ((63 & e) << 26 | t >>> 6) ^ KI(t, e, 3) ^ Q, B = (B ^ w ^ c) + I | 0, Q = B = Q >>> 0 > (e = r + Q | 0) >>> 0 ? B + 1 | 0 : B, E[G + 232 >> 2] = e, E[G + 236 >> 2] = B, I = KI(k, i, 63), B = w, r = KI(k, i, 56) ^ I, B = ((I = i >>> 7 | 0) ^ w ^ B) + o | 0, I = _ + ((i = (c = r ^ ((127 & i) << 25 | k >>> 7)) + F | 0) >>> 0 < c >>> 0 ? B + 1 | 0 : B) | 0, I = (B = i + U | 0) >>> 0 < U >>> 0 ? I + 1 | 0 : I, i = KI(e, Q, 45), o = w, r = B, B = Q >>> 6 | 0, Q = r + (i = ((63 & Q) << 26 | e >>> 6) ^ KI(e, Q, 3) ^ i) | 0, B = (B ^ w ^ o) + I | 0, E[G + 248 >> 2] = Q, E[G + 252 >> 2] = Q >>> 0 < i >>> 0 ? B + 1 | 0 : B;
                                        I = I + E[A + 4 >> 2] | 0, I = (g = Q + E[A >> 2] | 0) >>> 0 < Q >>> 0 ? I + 1 | 0 : I, E[A >> 2] = g, E[A + 4 >> 2] = I, B = E[A + 12 >> 2] + E[C + 12 >> 2] | 0, I = (g = E[C + 8 >> 2]) + E[A + 8 >> 2] | 0, E[A + 8 >> 2] = I, E[A + 12 >> 2] = I >>> 0 < g >>> 0 ? B + 1 | 0 : B, B = E[A + 20 >> 2] + E[C + 20 >> 2] | 0, I = (g = E[C + 16 >> 2]) + E[A + 16 >> 2] | 0, E[A + 16 >> 2] = I, E[A + 20 >> 2] = I >>> 0 < g >>> 0 ? B + 1 | 0 : B, I = E[A + 28 >> 2] + E[C + 28 >> 2] | 0, g = (B = E[C + 24 >> 2]) + E[A + 24 >> 2] | 0, E[A + 24 >> 2] = g, E[A + 28 >> 2] = g >>> 0 < B >>> 0 ? I + 1 | 0 : I, B = E[A + 36 >> 2] + E[C + 36 >> 2] | 0, I = (g = E[C + 32 >> 2]) + E[A + 32 >> 2] | 0, E[A + 32 >> 2] = I, E[A + 36 >> 2] = I >>> 0 < g >>> 0 ? B + 1 | 0 : B, I = E[A + 44 >> 2] + E[C + 44 >> 2] | 0, g = (B = E[C + 40 >> 2]) + E[A + 40 >> 2] | 0, E[A + 40 >> 2] = g, E[A + 44 >> 2] = g >>> 0 < B >>> 0 ? I + 1 | 0 : I, B = E[A + 52 >> 2] + E[C + 52 >> 2] | 0, I = (g = E[C + 48 >> 2]) + E[A + 48 >> 2] | 0, E[A + 48 >> 2] = I, E[A + 52 >> 2] = I >>> 0 < g >>> 0 ? B + 1 | 0 : B, B = E[A + 60 >> 2] + E[C + 60 >> 2] | 0, I = (g = E[C + 56 >> 2]) + E[A + 56 >> 2] | 0, E[A + 56 >> 2] = I, E[A + 60 >> 2] = I >>> 0 < g >>> 0 ? B + 1 | 0 : B;
                                    }
                                    function N(A) {
                                        var I, g, C, B, Q, i, E, _, c, t, r = 0, e = 0, y = 0, s = 0, h = 0, D = 0, p = 0, f = 0, n = 0, k = 0, F = 0, N = 0, S = 0, G = 0, M = 0, b = 0, K = 0, H = 0, Y = 0, d = 0, J = 0, U = 0, l = 0, m = 0, u = 0, x = 0, R = 0, v = 0, L = 0, P = 0, q = 0, z = 0, j = 0, X = 0, O = 0, V = 0, Z = 0, W = 0;
                                        s = (N = a[A + 44 | 0] | a[A + 45 | 0] << 8 | a[A + 46 | 0] << 16 | a[A + 47 | 0] << 24) >>> 5 & 2097151, y = Ig(U = (a[A + 60 | 0] | a[A + 61 | 0] << 8 | a[A + 62 | 0] << 16 | a[A + 63 | 0] << 24) >>> 3 | 0, 0, -683901, -1), e = (r = a[A + 44 | 0]) << 16 & 2031616 | a[A + 42 | 0] | a[A + 43 | 0] << 8, r = w, f = r = e >>> 0 > (n = y + e | 0) >>> 0 ? r + 1 | 0 : r, b = r = r - ((n >>> 0 < 4293918720) - 1 | 0) | 0, y = r >> 21, r = (e = s) + (s = (2097151 & r) << 11 | (D = n - -1048576 | 0) >>> 21) | 0, e = y, P = e = r >>> 0 < s >>> 0 ? e + 1 | 0 : e, q = r, Y = Ig(r, e, -683901, -1), k = w, p = Ig(I = (a[A + 49 | 0] | a[A + 50 | 0] << 8 | a[A + 51 | 0] << 16 | a[A + 52 | 0] << 24) >>> 7 & 2097151, 0, -997805, -1), y = (r = a[A + 27 | 0]) >>> 24 | 0, s = r << 8 | (S = a[A + 23 | 0] | a[A + 24 | 0] << 8 | a[A + 25 | 0] << 16 | a[A + 26 | 0] << 24) >>> 24, e = (r = a[A + 28 | 0]) >>> 16 | 0, e = 2097151 & ((3 & (e |= y)) << 30 | (r = s | r << 16) >>> 2), r = w, r = e >>> 0 > (y = e + p | 0) >>> 0 ? r + 1 | 0 : r, e = Ig(R = (G = a[A + 52 | 0] | a[A + 53 | 0] << 8 | a[A + 54 | 0] << 16 | a[A + 55 | 0] << 24) >>> 4 & 2097151, 0, 654183, 0), r = w + r | 0, p = y = e + y | 0, y = e >>> 0 > y >>> 0 ? r + 1 | 0 : r, h = (e = a[A + 48 | 0]) << 8 | N >>> 24, e = r = e >>> 24 | 0, r = Ig(g = 2097151 & ((3 & (N = (r = (s = a[A + 49 | 0]) >>> 16 | 0) | e)) << 30 | (e = (s <<= 16) | h) >>> 2), 0, 136657, 0), y = w + y | 0, y = r >>> 0 > (e = r + p | 0) >>> 0 ? y + 1 | 0 : y, s = (r = Ig(C = (a[A + 57 | 0] | a[A + 58 | 0] << 8 | a[A + 59 | 0] << 16 | a[A + 60 | 0] << 24) >>> 6 & 2097151, 0, 666643, 0)) + e | 0, e = w + y | 0, p = s, y = r >>> 0 > s >>> 0 ? e + 1 | 0 : e, e = (r = a[A + 56 | 0]) >>> 24 | 0, h = r << 8 | G >>> 24, e = Ig(B = 2097151 & ((1 & (G = (r = (s = a[A + 57 | 0]) >>> 16 | 0) | e)) << 31 | (e = (s <<= 16) | h) >>> 1), 0, 470296, 0), r = w + y | 0, e = (r = (y = s = e + p | 0) >>> 0 < e >>> 0 ? r + 1 | 0 : r) + k | 0, e = y >>> 0 > (s = y + Y | 0) >>> 0 ? e + 1 | 0 : e, K = y - -1048576 | 0, H = y = r - ((y >>> 0 < 4293918720) - 1 | 0) | 0, k = s - (r = -2097152 & K) | 0, Y = e - ((r >>> 0 > s >>> 0) + y | 0) | 0, e = Ig(I, 0, 654183, 0), r = w, r = e >>> 0 > (y = e + (S >>> 5 & 2097151) | 0) >>> 0 ? r + 1 | 0 : r, s = (e = y) + (y = Ig(R, 0, 470296, 0)) | 0, e = w + r | 0, e = y >>> 0 > s >>> 0 ? e + 1 | 0 : e, r = Ig(g, j, -997805, -1), e = w + e | 0, e = r >>> 0 > (y = r + s | 0) >>> 0 ? e + 1 | 0 : e, s = (r = y) + (y = Ig(B, X, 666643, 0)) | 0, r = w + e | 0, h = s, s = y >>> 0 > s >>> 0 ? r + 1 | 0 : r, p = (y = Ig(I, 0, 470296, 0)) + (r = (r = a[A + 23 | 0]) << 16 & 2031616 | a[A + 21 | 0] | a[A + 22 | 0] << 8) | 0, y = w, y = r >>> 0 > p >>> 0 ? y + 1 | 0 : y, p = (e = Ig(R, 0, 666643, 0)) + p | 0, r = w + y | 0, y = Ig(g, j, 654183, 0), e = w + (e >>> 0 > p >>> 0 ? r + 1 | 0 : r) | 0, G = e = y >>> 0 > (S = y + p | 0) >>> 0 ? e + 1 | 0 : e, x = e = e - ((S >>> 0 < 4293918720) - 1 | 0) | 0, r = (r = e >>> 21 | 0) + s | 0, y = r = (e = (2097151 & e) << 11 | (p = S - -1048576 | 0) >>> 21) >>> 0 > (h = e + h | 0) >>> 0 ? r + 1 | 0 : r, F = e = r - ((h >>> 0 < 4293918720) - 1 | 0) | 0, r = k, k = (2097151 & e) << 11 | (s = h - -1048576 | 0) >>> 21, e = (e >> 21) + Y | 0, N = k = (e = k >>> 0 > (M = r + k | 0) >>> 0 ? e + 1 | 0 : e) - ((M >>> 0 < 4293918720) - 1 | 0) | 0, v = M - (r = -2097152 & (Y = M - -1048576 | 0)) | 0, O = e - ((r >>> 0 > M >>> 0) + k | 0) | 0, r = Ig(q, P, 136657, 0), y = w + y | 0, y = r >>> 0 > (e = r + h | 0) >>> 0 ? y + 1 | 0 : y, J = e - (r = -2097152 & s) | 0, L = y - ((r >>> 0 > e >>> 0) + F | 0) | 0, M = n - (r = -2097152 & D) | 0, b = f - ((r >>> 0 > n >>> 0) + b | 0) | 0, f = Ig(U, 0, 136657, 0), e = (r = a[A + 40 | 0]) >>> 24 | 0, s = r << 8 | (D = a[A + 36 | 0] | a[A + 37 | 0] << 8 | a[A + 38 | 0] << 16 | a[A + 39 | 0] << 24) >>> 24, y = (r = a[A + 41 | 0]) >>> 16 | 0, e = (y |= e) >>> 3 | 0, y = (7 & y) << 29 | (r = s | r << 16) >>> 3, r = e + w | 0, r = y >>> 0 > (s = y + f | 0) >>> 0 ? r + 1 | 0 : r, e = Ig(C, 0, -683901, -1), r = w + r | 0, r = e >>> 0 > (y = e + s | 0) >>> 0 ? r + 1 | 0 : r, h = y, e = Ig(U, 0, -997805, -1), y = w, y = e >>> 0 > (s = e + (D >>> 6 & 2097151) | 0) >>> 0 ? y + 1 | 0 : y, D = (e = s) + (s = Ig(C, 0, 136657, 0)) | 0, e = w + y | 0, y = Ig(B, X, -683901, -1), e = w + (s >>> 0 > D >>> 0 ? e + 1 | 0 : e) | 0, k = e = y >>> 0 > (l = y + D | 0) >>> 0 ? e + 1 | 0 : e, V = y = e - ((l >>> 0 < 4293918720) - 1 | 0) | 0, r = r + (e = y >> 21) | 0, D = r = (y = (2097151 & y) << 11 | (n = l - -1048576 | 0) >>> 21) >>> 0 > (F = y + h | 0) >>> 0 ? r + 1 | 0 : r, m = r = r - ((F >>> 0 < 4293918720) - 1 | 0) | 0, e = (e = r >> 21) + b | 0, z = e = (r = (y = (2097151 & r) << 11 | (h = F - -1048576 | 0) >>> 21) + M | 0) >>> 0 < y >>> 0 ? e + 1 | 0 : e, u = r, e = Ig(r, e, -683901, -1), r = w + L | 0, d = y = e + J | 0, s = e >>> 0 > y >>> 0 ? r + 1 | 0 : r, L = S - (r = -2097152 & p) | 0, b = G - ((4095 & x) + (r >>> 0 > S >>> 0) | 0) | 0, S = Ig(I, 0, 666643, 0), r = (e = a[A + 19 | 0]) >>> 24 | 0, p = e << 8 | (G = a[A + 15 | 0] | a[A + 16 | 0] << 8 | a[A + 17 | 0] << 16 | a[A + 18 | 0] << 24) >>> 24, y = r, e = (7 & (y |= e = (r = a[A + 20 | 0]) >>> 16 | 0)) << 29 | (e = (r <<= 16) | p) >>> 3, y = w + (y >>> 3 | 0) | 0, y = e >>> 0 > (p = e + S | 0) >>> 0 ? y + 1 | 0 : y, r = Ig(g, j, 470296, 0), e = w + y | 0, r = r >>> 0 > (p = r + p | 0) >>> 0 ? e + 1 | 0 : e, y = Ig(g, j, 666643, 0), e = w, S = e = y >>> 0 > (J = y + (G >>> 6 & 2097151) | 0) >>> 0 ? e + 1 | 0 : e, Z = y = e - ((J >>> 0 < 4293918720) - 1 | 0) | 0, r = r + (e = y >>> 21 | 0) | 0, G = r = (y = (2097151 & y) << 11 | (f = J - -1048576 | 0) >>> 21) >>> 0 > (M = y + p | 0) >>> 0 ? r + 1 | 0 : r, W = r = r - ((M >>> 0 < 4293918720) - 1 | 0) | 0, e = (e = r >>> 21 | 0) + b | 0, e = (r = (2097151 & r) << 11 | (p = M - -1048576 | 0) >>> 21) >>> 0 > (y = r + L | 0) >>> 0 ? e + 1 | 0 : e, b = (r = y) + (y = Ig(q, P, -997805, -1)) | 0, r = w + e | 0, r = y >>> 0 > b >>> 0 ? r + 1 | 0 : r, x = e = F - (y = -2097152 & h) | 0, Q = h = D - ((y >>> 0 > F >>> 0) + m | 0) | 0, y = Ig(u, z, 136657, 0), r = w + r | 0, r = y >>> 0 > (D = y + b | 0) >>> 0 ? r + 1 | 0 : r, y = Ig(e, h, -683901, -1), e = w + r | 0, D = e = y >>> 0 > (b = y + D | 0) >>> 0 ? e + 1 | 0 : e, m = r = e - ((b >>> 0 < 4293918720) - 1 | 0) | 0, e = (2097151 & r) << 11 | (h = b - -1048576 | 0) >>> 21, r = (r >> 21) + s | 0, d = e = (r = e >>> 0 > (F = e + d | 0) >>> 0 ? r + 1 | 0 : r) - ((F >>> 0 < 4293918720) - 1 | 0) | 0, L = (2097151 & e) << 11 | (s = F - -1048576 | 0) >>> 21, e = (e >> 21) + O | 0, E = v = L + v | 0, L = v >>> 0 < L >>> 0 ? e + 1 | 0 : e, _ = F - (e = -2097152 & s) | 0, c = r - ((e >>> 0 > F >>> 0) + d | 0) | 0, v = b - (r = -2097152 & h) | 0, O = D - ((r >>> 0 > b >>> 0) + m | 0) | 0, y = (r = Ig(q, P, 654183, 0)) + (M - (e = -2097152 & p) | 0) | 0, e = w + (G - ((2147483647 & W) + (e >>> 0 > M >>> 0) | 0) | 0) | 0, e = r >>> 0 > y >>> 0 ? e + 1 | 0 : e, r = Ig(u, z, -997805, -1), e = w + e | 0, e = r >>> 0 > (y = r + y | 0) >>> 0 ? e + 1 | 0 : e, s = (r = y) + (y = Ig(x, Q, 136657, 0)) | 0, r = w + e | 0, d = s, D = y >>> 0 > s >>> 0 ? r + 1 | 0 : r, M = l - (r = -2097152 & n) | 0, F = k - ((r >>> 0 > l >>> 0) + V | 0) | 0, G = Ig(R, 0, -683901, -1), r = (e = a[A + 35 | 0]) >>> 24 | 0, s = e << 8 | (p = a[A + 31 | 0] | a[A + 32 | 0] << 8 | a[A + 33 | 0] << 16 | a[A + 34 | 0] << 24) >>> 24, y = r, e = (r = a[A + 36 | 0]) >>> 16 | 0, e |= y, y = w, y = (r = 2097151 & ((1 & e) << 31 | (r = r << 16 | s) >>> 1)) >>> 0 > (e = r + G | 0) >>> 0 ? y + 1 | 0 : y, s = (r = Ig(U, 0, 654183, 0)) + e | 0, e = w + y | 0, e = r >>> 0 > s >>> 0 ? e + 1 | 0 : e, y = Ig(C, 0, -997805, -1), r = w + e | 0, r = y >>> 0 > (s = y + s | 0) >>> 0 ? r + 1 | 0 : r, e = Ig(B, X, 136657, 0), r = w + r | 0, h = y = e + s | 0, s = e >>> 0 > y >>> 0 ? r + 1 | 0 : r, r = Ig(I, 0, -683901, -1), e = w, e = r >>> 0 > (y = r + (p >>> 4 & 2097151) | 0) >>> 0 ? e + 1 | 0 : e, p = (r = Ig(R, 0, 136657, 0)) + y | 0, y = w + e | 0, y = r >>> 0 > p >>> 0 ? y + 1 | 0 : y, r = Ig(U, 0, 470296, 0), e = w + y | 0, e = r >>> 0 > (p = r + p | 0) >>> 0 ? e + 1 | 0 : e, p = (y = Ig(C, 0, 654183, 0)) + p | 0, r = w + e | 0, e = Ig(B, X, -997805, -1), r = w + (y >>> 0 > p >>> 0 ? r + 1 | 0 : r) | 0, G = r = e >>> 0 > (k = e + p | 0) >>> 0 ? r + 1 | 0 : r, t = e = r - ((k >>> 0 < 4293918720) - 1 | 0) | 0, y = (r = e >> 21) + s | 0, b = e = (y = (e = (2097151 & e) << 11 | (p = k - -1048576 | 0) >>> 21) >>> 0 > (n = e + h | 0) >>> 0 ? y + 1 | 0 : y) - ((n >>> 0 < 4293918720) - 1 | 0) | 0, r = (r = e >> 21) + F | 0, m = r = (e = (s = (2097151 & e) << 11 | (h = n - -1048576 | 0) >>> 21) + M | 0) >>> 0 < s >>> 0 ? r + 1 | 0 : r, s = d, d = e, r = Ig(e, r, -683901, -1), e = w + D | 0, F = s = s + r | 0, s = r >>> 0 > s >>> 0 ? e + 1 | 0 : e, D = (r = Ig(q, P, 470296, 0)) + (J - (e = -2097152 & f) | 0) | 0, e = w + (S - ((2047 & Z) + (e >>> 0 > J >>> 0) | 0) | 0) | 0, e = r >>> 0 > D >>> 0 ? e + 1 | 0 : e, f = (r = D) + (D = Ig(u, z, 654183, 0)) | 0, r = w + e | 0, r = D >>> 0 > f >>> 0 ? r + 1 | 0 : r, D = Ig(x, Q, -997805, -1), e = w + r | 0, e = D >>> 0 > (f = D + f | 0) >>> 0 ? e + 1 | 0 : e, l = h = n - (r = -2097152 & h) | 0, i = D = y - ((r >>> 0 > n >>> 0) + b | 0) | 0, y = Ig(d, m, 136657, 0), r = w + e | 0, r = y >>> 0 > (f = y + f | 0) >>> 0 ? r + 1 | 0 : r, y = Ig(h, D, -683901, -1), e = w + r | 0, D = e = y >>> 0 > (S = y + f | 0) >>> 0 ? e + 1 | 0 : e, b = r = e - ((S >>> 0 < 4293918720) - 1 | 0) | 0, e = (2097151 & r) << 11 | (h = S - -1048576 | 0) >>> 21, r = (r >> 21) + s | 0, F = e = (r = e >>> 0 > (f = e + F | 0) >>> 0 ? r + 1 | 0 : r) - ((f >>> 0 < 4293918720) - 1 | 0) | 0, n = (2097151 & e) << 11 | (s = f - -1048576 | 0) >>> 21, e = (e >> 21) + O | 0, V = M = n + v | 0, M = n >>> 0 > M >>> 0 ? e + 1 | 0 : e, Z = f - (e = -2097152 & s) | 0, W = r - ((e >>> 0 > f >>> 0) + F | 0) | 0, v = S - (r = -2097152 & h) | 0, O = D - ((r >>> 0 > S >>> 0) + b | 0) | 0, D = Ig(q, P, 666643, 0), r = (e = a[A + 14 | 0]) >>> 24 | 0, s = e << 8 | (b = a[A + 10 | 0] | a[A + 11 | 0] << 8 | a[A + 12 | 0] << 16 | a[A + 13 | 0] << 24) >>> 24, y = r, e = (r = a[A + 15 | 0]) >>> 16 | 0, e |= y, y = w, y = (r = 2097151 & ((1 & e) << 31 | (r = r << 16 | s) >>> 1)) >>> 0 > (e = r + D | 0) >>> 0 ? y + 1 | 0 : y, s = (r = e) + (e = Ig(u, z, 470296, 0)) | 0, r = w + y | 0, r = e >>> 0 > s >>> 0 ? r + 1 | 0 : r, e = Ig(x, Q, 654183, 0), r = w + r | 0, r = e >>> 0 > (y = e + s | 0) >>> 0 ? r + 1 | 0 : r, s = (e = y) + (y = Ig(d, m, -997805, -1)) | 0, e = w + r | 0, e = y >>> 0 > s >>> 0 ? e + 1 | 0 : e, r = Ig(l, i, 136657, 0), e = w + e | 0, S = y = r + s | 0, s = r >>> 0 > y >>> 0 ? e + 1 | 0 : e, p = k - (r = -2097152 & p) | 0, D = G - ((r >>> 0 > k >>> 0) + t | 0) | 0, y = Ig(I, 0, 136657, 0), r = w, r = (e = (a[A + 28 | 0] | a[A + 29 | 0] << 8 | a[A + 30 | 0] << 16 | a[A + 31 | 0] << 24) >>> 7 & 2097151) >>> 0 > (y = e + y | 0) >>> 0 ? r + 1 | 0 : r, h = (e = y) + (y = Ig(R, 0, -997805, -1)) | 0, e = w + r | 0, e = y >>> 0 > h >>> 0 ? e + 1 | 0 : e, r = Ig(g, j, -683901, -1), e = w + e | 0, e = r >>> 0 > (y = r + h | 0) >>> 0 ? e + 1 | 0 : e, h = (r = Ig(U, 0, 666643, 0)) + y | 0, y = w + e | 0, y = r >>> 0 > h >>> 0 ? y + 1 | 0 : y, e = Ig(C, 0, 470296, 0), r = w + y | 0, r = e >>> 0 > (h = e + h | 0) >>> 0 ? r + 1 | 0 : r, e = Ig(B, X, 654183, 0), r = w + r | 0, e = (H >> 21) + (e >>> 0 > (y = e + h | 0) >>> 0 ? r + 1 | 0 : r) | 0, n = e = (h = (2097151 & H) << 11 | K >>> 21) >>> 0 > (K = h + y | 0) >>> 0 ? e + 1 | 0 : e, F = r = e - ((K >>> 0 < 4293918720) - 1 | 0) | 0, h = (2097151 & r) << 11 | (f = K - -1048576 | 0) >>> 21, r = (r >> 21) + D | 0, J = r = (e = h + p | 0) >>> 0 < h >>> 0 ? r + 1 | 0 : r, H = e, e = Ig(e, r, -683901, -1), r = w + s | 0, h = y = e + S | 0, s = e >>> 0 > y >>> 0 ? r + 1 | 0 : r, r = Ig(u, z, 666643, 0), e = w, e = r >>> 0 > (y = r + (b >>> 4 & 2097151) | 0) >>> 0 ? e + 1 | 0 : e, r = Ig(x, Q, 470296, 0), e = w + e | 0, e = r >>> 0 > (y = r + y | 0) >>> 0 ? e + 1 | 0 : e, D = (r = Ig(d, m, 654183, 0)) + y | 0, y = w + e | 0, y = r >>> 0 > D >>> 0 ? y + 1 | 0 : y, e = Ig(l, i, -997805, -1), r = w + y | 0, r = e >>> 0 > (D = e + D | 0) >>> 0 ? r + 1 | 0 : r, e = Ig(H, J, 136657, 0), r = w + r | 0, G = r = e >>> 0 > (k = e + D | 0) >>> 0 ? r + 1 | 0 : r, P = e = r - ((k >>> 0 < 4293918720) - 1 | 0) | 0, r = h, h = (2097151 & e) << 11 | (p = k - -1048576 | 0) >>> 21, e = (e >> 21) + s | 0, u = s = (e = (y = r + h | 0) >>> 0 < h >>> 0 ? e + 1 | 0 : e) - ((y >>> 0 < 4293918720) - 1 | 0) | 0, r = (r = s >> 21) + O | 0, q = h = (s = (2097151 & s) << 11 | (D = y - -1048576 | 0) >>> 21) + v | 0, S = s >>> 0 > h >>> 0 ? r + 1 | 0 : r, h = y, y = e, s = (K - (e = -2097152 & f) | 0) + (f = (2097151 & N) << 11 | Y >>> 21) | 0, e = (n - ((e >>> 0 > K >>> 0) + F | 0) | 0) + (N >> 21) | 0, b = e = s >>> 0 < f >>> 0 ? e + 1 | 0 : e, R = e = e - ((s >>> 0 < 4293918720) - 1 | 0) | 0, Y = r = e >> 21, r = Ig(U = (2097151 & e) << 11 | (F = s - -1048576 | 0) >>> 21, r, -683901, -1), y = w + y | 0, y = r >>> 0 > (e = r + h | 0) >>> 0 ? y + 1 | 0 : y, j = e - (r = -2097152 & D) | 0, X = y - ((r >>> 0 > e >>> 0) + u | 0) | 0, r = Ig(U, Y, 136657, 0), e = G + w | 0, z = (y = r + k | 0) - (r = -2097152 & p) | 0, u = (e = y >>> 0 < k >>> 0 ? e + 1 | 0 : e) - ((r >>> 0 > y >>> 0) + P | 0) | 0, e = Ig(x, Q, 666643, 0), y = w, y = (r = (a[A + 7 | 0] | a[A + 8 | 0] << 8 | a[A + 9 | 0] << 16 | a[A + 10 | 0] << 24) >>> 7 & 2097151) >>> 0 > (e = r + e | 0) >>> 0 ? y + 1 | 0 : y, h = (r = Ig(d, m, 470296, 0)) + e | 0, e = w + y | 0, e = r >>> 0 > h >>> 0 ? e + 1 | 0 : e, r = Ig(l, i, 654183, 0), e = w + e | 0, e = r >>> 0 > (y = r + h | 0) >>> 0 ? e + 1 | 0 : e, h = (r = y) + (y = Ig(H, J, -997805, -1)) | 0, r = w + e | 0, f = h, h = y >>> 0 > h >>> 0 ? r + 1 | 0 : r, G = Ig(d, m, 666643, 0), r = (e = a[A + 6 | 0]) >>> 24 | 0, D = e << 8 | (K = a[A + 2 | 0] | a[A + 3 | 0] << 8 | a[A + 4 | 0] << 16 | a[A + 5 | 0] << 24) >>> 24, y = r, e = (r = a[A + 7 | 0]) >>> 16 | 0, e = 2097151 & ((3 & (e |= y)) << 30 | (r = r << 16 | D) >>> 2), r = w, r = e >>> 0 > (y = e + G | 0) >>> 0 ? r + 1 | 0 : r, D = (e = Ig(l, i, 470296, 0)) + y | 0, y = w + r | 0, y = e >>> 0 > D >>> 0 ? y + 1 | 0 : y, e = Ig(H, J, 654183, 0), r = w + y | 0, G = r = e >>> 0 > (n = e + D | 0) >>> 0 ? r + 1 | 0 : r, N = r = r - ((n >>> 0 < 4293918720) - 1 | 0) | 0, e = (y = r >> 21) + h | 0, k = r = (e = (r = (2097151 & r) << 11 | (p = n - -1048576 | 0) >>> 21) >>> 0 > (D = r + f | 0) >>> 0 ? e + 1 | 0 : e) - ((D >>> 0 < 4293918720) - 1 | 0) | 0, f = (2097151 & r) << 11 | (h = D - -1048576 | 0) >>> 21, r = (r >> 21) + u | 0, u = d = f + z | 0, f = f >>> 0 > d >>> 0 ? r + 1 | 0 : r, r = Ig(U, Y, -997805, -1), e = w + e | 0, e = r >>> 0 > (y = r + D | 0) >>> 0 ? e + 1 | 0 : e, x = y - (r = -2097152 & h) | 0, m = e - ((r >>> 0 > y >>> 0) + k | 0) | 0, e = Ig(U, Y, 654183, 0), r = G + w | 0, d = (y = e + n | 0) - (e = -2097152 & p) | 0, N = (r = y >>> 0 < n >>> 0 ? r + 1 | 0 : r) - ((e >>> 0 > y >>> 0) + N | 0) | 0, r = Ig(l, i, 666643, 0), e = w, e = r >>> 0 > (y = r + (K >>> 5 & 2097151) | 0) >>> 0 ? e + 1 | 0 : e, r = Ig(H, J, 470296, 0), e = w + e | 0, D = y = r + y | 0, y = r >>> 0 > y >>> 0 ? e + 1 | 0 : e, h = Ig(H, J, 666643, 0), e = (r = a[A + 2 | 0]) << 16 & 2031616 | a[0 | A] | a[A + 1 | 0] << 8, r = w, G = r = e >>> 0 > (k = h + e | 0) >>> 0 ? r + 1 | 0 : r, J = r = r - ((k >>> 0 < 4293918720) - 1 | 0) | 0, h = (2097151 & r) << 11 | (p = k - -1048576 | 0) >>> 21, r = (r >> 21) + y | 0, y = r = h >>> 0 > (n = h + D | 0) >>> 0 ? r + 1 | 0 : r, K = r = r - ((n >>> 0 < 4293918720) - 1 | 0) | 0, h = (2097151 & r) << 11 | (D = n - -1048576 | 0) >>> 21, r = (r >> 21) + N | 0, h = h >>> 0 > (N = H = h + d | 0) >>> 0 ? r + 1 | 0 : r, r = Ig(U, Y, 470296, 0), y = y + w | 0, y = (e = r + n | 0) >>> 0 < n >>> 0 ? y + 1 | 0 : y, n = e - (r = -2097152 & D) | 0, D = y - ((r >>> 0 > e >>> 0) + K | 0) | 0, e = Ig(U, Y, 666643, 0), r = w + (G - (((y = -2097152 & p) >>> 0 > k >>> 0) + J | 0) | 0) | 0, e = (y = (r = e >>> 0 > (H = e + (k - y | 0) | 0) >>> 0 ? r + 1 | 0 : r) >> 21) + D | 0, r = (r = (e = (r = (2097151 & r) << 11 | H >>> 21) >>> 0 > (K = r + n | 0) >>> 0 ? e + 1 | 0 : e) >> 21) + h | 0, e = (e = (r = (e = (2097151 & e) << 11 | K >>> 21) >>> 0 > (N = e + N | 0) >>> 0 ? r + 1 | 0 : r) >> 21) + m | 0, y = (r = (e = (r = (2097151 & r) << 11 | N >>> 21) >>> 0 > (h = r + x | 0) >>> 0 ? e + 1 | 0 : e) >> 21) + f | 0, r = (e = (y = (e = (2097151 & e) << 11 | h >>> 21) >>> 0 > (Y = e + u | 0) >>> 0 ? y + 1 | 0 : y) >> 21) + X | 0, e = (y = (r = (y = (2097151 & y) << 11 | Y >>> 21) >>> 0 > (k = y + j | 0) >>> 0 ? r + 1 | 0 : r) >> 21) + S | 0, r = (r = (e = (r = (2097151 & r) << 11 | k >>> 21) >>> 0 > (n = r + q | 0) >>> 0 ? e + 1 | 0 : e) >> 21) + W | 0, e = (e = (r = (e = (2097151 & e) << 11 | n >>> 21) >>> 0 > (S = e + Z | 0) >>> 0 ? r + 1 | 0 : r) >> 21) + M | 0, y = (r = (e = (r = (2097151 & r) << 11 | S >>> 21) >>> 0 > (f = r + V | 0) >>> 0 ? e + 1 | 0 : e) >> 21) + c | 0, r = (e = (y = (e = (2097151 & e) << 11 | f >>> 21) >>> 0 > (G = e + _ | 0) >>> 0 ? y + 1 | 0 : y) >> 21) + L | 0, D = (F = s - (e = -2097152 & F) | 0) + ((2097151 & (r = (y = (2097151 & y) << 11 | G >>> 21) >>> 0 > (p = y + E | 0) >>> 0 ? r + 1 | 0 : r)) << 11 | p >>> 21) | 0, r = (b - ((e >>> 0 > s >>> 0) + R | 0) | 0) + (r >> 21) | 0, F = e = (r = D >>> 0 < F >>> 0 ? r + 1 | 0 : r) >> 21, H = (r = Ig(M = (2097151 & r) << 11 | D >>> 21, e, 666643, 0)) + (e = 2097151 & H) | 0, r = w, s = r = e >>> 0 > H >>> 0 ? r + 1 | 0 : r, o[0 | A] = H, o[A + 1 | 0] = (255 & r) << 24 | H >>> 8, r = 2097151 & K, e = Ig(M, F, 470296, 0) + r | 0, y = w, r = (s >> 21) + (r >>> 0 > e >>> 0 ? y + 1 | 0 : y) | 0, r = (b = (2097151 & s) << 11 | H >>> 21) >>> 0 > (K = b + e | 0) >>> 0 ? r + 1 | 0 : r, o[A + 4 | 0] = (2047 & r) << 21 | K >>> 11, e = r, y = K, o[A + 3 | 0] = (7 & r) << 29 | y >>> 3, o[A + 2 | 0] = 31 & ((65535 & s) << 16 | H >>> 16) | y << 5, s = 2097151 & N, N = Ig(M, F, 654183, 0) + s | 0, r = w, K = (2097151 & e) << 11 | y >>> 21, e = (e >> 21) + (s = s >>> 0 > N >>> 0 ? r + 1 | 0 : r) | 0, r = e = (N = K + N | 0) >>> 0 < K >>> 0 ? e + 1 | 0 : e, o[A + 6 | 0] = (63 & r) << 26 | N >>> 6, s = N, N = 0, o[A + 5 | 0] = N << 13 | (1572864 & y) >>> 19 | s << 2, y = 2097151 & h, h = Ig(M, F, -997805, -1) + y | 0, e = w, e = y >>> 0 > h >>> 0 ? e + 1 | 0 : e, N = (2097151 & (y = r)) << 11 | s >>> 21, y = (r >>= 21) + e | 0, y = (h = N + h | 0) >>> 0 < N >>> 0 ? y + 1 | 0 : y, o[A + 9 | 0] = (511 & y) << 23 | h >>> 9, o[A + 8 | 0] = (1 & y) << 31 | h >>> 1, e = 0, o[A + 7 | 0] = e << 18 | (2080768 & s) >>> 14 | h << 7, e = 2097151 & Y, s = Ig(M, F, 136657, 0) + e | 0, r = w, r = e >>> 0 > s >>> 0 ? r + 1 | 0 : r, Y = (2097151 & (e = y)) << 11 | h >>> 21, e = r + (y = e >> 21) | 0, e = (s = Y + s | 0) >>> 0 < Y >>> 0 ? e + 1 | 0 : e, o[A + 12 | 0] = (4095 & e) << 20 | s >>> 12, y = s, o[A + 11 | 0] = (15 & e) << 28 | y >>> 4, s = 0, o[A + 10 | 0] = s << 15 | (1966080 & h) >>> 17 | y << 4, s = 2097151 & k, h = Ig(M, F, -683901, -1) + s | 0, r = w, r = s >>> 0 > h >>> 0 ? r + 1 | 0 : r, s = e, e = r + (e >>= 21) | 0, e = (s = (d = h) + (h = (2097151 & s) << 11 | y >>> 21) | 0) >>> 0 < h >>> 0 ? e + 1 | 0 : e, o[A + 14 | 0] = (127 & e) << 25 | s >>> 7, h = 0, o[A + 13 | 0] = h << 12 | (1048576 & y) >>> 20 | s << 1, r = e >> 21, y = (e = (2097151 & e) << 11 | s >>> 21) >>> 0 > (h = e + (2097151 & n) | 0) >>> 0 ? r + 1 | 0 : r, o[A + 17 | 0] = (1023 & y) << 22 | h >>> 10, o[A + 16 | 0] = (3 & y) << 30 | h >>> 2, e = 0, o[A + 15 | 0] = e << 17 | (2064384 & s) >>> 15 | h << 6, r = y >> 21, r = (e = (2097151 & y) << 11 | h >>> 21) >>> 0 > (y = e + (2097151 & S) | 0) >>> 0 ? r + 1 | 0 : r, o[A + 20 | 0] = (8191 & r) << 19 | y >>> 13, o[A + 19 | 0] = (31 & r) << 27 | y >>> 5, s = (e = 2097151 & f) + (f = (2097151 & r) << 11 | y >>> 21) | 0, e = r >> 21, e = s >>> 0 < f >>> 0 ? e + 1 | 0 : e, f = s, o[A + 21 | 0] = s, S = 0, o[A + 18 | 0] = S << 14 | (1835008 & h) >>> 18 | y << 3, o[A + 22 | 0] = (255 & e) << 24 | s >>> 8, y = e >> 21, y = (s = (h = (2097151 & e) << 11 | s >>> 21) + (2097151 & G) | 0) >>> 0 < h >>> 0 ? y + 1 | 0 : y, o[A + 25 | 0] = (2047 & y) << 21 | s >>> 11, o[A + 24 | 0] = (7 & y) << 29 | s >>> 3, o[A + 23 | 0] = 31 & ((65535 & e) << 16 | f >>> 16) | s << 5, r = y >> 21, r = (e = (2097151 & y) << 11 | s >>> 21) >>> 0 > (y = e + (2097151 & p) | 0) >>> 0 ? r + 1 | 0 : r, o[A + 27 | 0] = (63 & r) << 26 | y >>> 6, h = 0, o[A + 26 | 0] = h << 13 | (1572864 & s) >>> 19 | y << 2, e = r >> 21, e = (r = (s = (2097151 & r) << 11 | y >>> 21) + (2097151 & D) | 0) >>> 0 < s >>> 0 ? e + 1 | 0 : e, o[A + 31 | 0] = (131071 & e) << 15 | r >>> 17, o[A + 30 | 0] = (511 & e) << 23 | r >>> 9, o[A + 29 | 0] = (1 & e) << 31 | r >>> 1, s = 0, o[A + 28 | 0] = s << 18 | (2080768 & y) >>> 14 | r << 7;
                                    }
                                    function S(A, I) {
                                        var g, C = 0, B = 0, Q = 0, i = 0, o = 0, _ = 0, t = 0, r = 0, e = 0, y = 0, s = 0, f = 0, n = 0, k = 0, F = 0, N = 0, S = 0, M = 0, b = 0, K = 0, H = 0, Y = 0, d = 0, J = 0, U = 0, l = 0, m = 0, u = 0, x = 0, R = 0, v = 0, L = 0, P = 0, q = 0, z = 0, j = 0, X = 0, O = 0, V = 0, Z = 0, W = 0, T = 0, $ = 0, AA = 0, IA = 0, gA = 0, CA = 0, BA = 0, QA = 0, iA = 0, oA = 0, EA = 0, aA = 0, _A = 0, cA = 0, tA = 0, rA = 0, eA = 0;
                                        if (h = g = h - 4096 | 0, A) {
                                            A: {
                                                I: {
                                                    if (2 == (0 | (_ = E[A + 36 >> 2]))) {
                                                        if (iA = E[A + 4 >> 2], (T = E[I >> 2]) | (X = a[I + 8 | 0]) >>> 0 >= 2) break I;
                                                        T = 0;
                                                    } else X = a[I + 8 | 0], iA = E[A + 4 >> 2], T = E[I >> 2];
                                                    if (Hg(g + 3072 | 0, 0, 1024), Hg(g + 2104 | 0, 0, 968), E[g + 2048 >> 2] = T, E[g + 2052 >> 2] = 0, u = E[I + 4 >> 2], E[g + 2064 >> 2] = X, E[g + 2068 >> 2] = 0, E[g + 2056 >> 2] = u, E[g + 2060 >> 2] = 0, E[g + 2072 >> 2] = E[A + 16 >> 2], E[g + 2076 >> 2] = 0, u = E[A + 8 >> 2], E[g + 2088 >> 2] = _, E[g + 2092 >> 2] = 0, E[g + 2080 >> 2] = u, E[g + 2084 >> 2] = 0, !E[A + 20 >> 2]) break A;
                                                    for(u = 0; (N = 127 & r) || (u = (P = P + 1 | 0) ? u : u + 1 | 0, E[g + 2096 >> 2] = P, E[g + 2100 >> 2] = u, _ = Hg(g, 0, 1024), Hg(_ + 1024 | 0, 0, 1024), G(C = _ + 3072 | 0, _ + 2048 | 0, _), G(C, _, _ + 1024 | 0)), N = E[4 + (_ = (g + 1024 | 0) + (N << 3) | 0) >> 2], E[(C = (r << 3) + iA | 0) >> 2] = E[_ >> 2], E[C + 4 >> 2] = N, (N = E[A + 20 >> 2]) >>> 0 > (r = r + 1 | 0) >>> 0;);
                                                    break A;
                                                }
                                                N = E[A + 20 >> 2], _A = 1;
                                            }
                                            if (!((u = (EA = !(X | T)) << 1) >>> 0 >= N >>> 0)) for(_ = E[A + 24 >> 2], QA = E[I + 4 >> 2], r = (P = (c(_, QA) + u | 0) + c(N, X) | 0) + ((P >>> 0) % (_ >>> 0) | 0 ? -1 : _ - 1 | 0) | 0, cA = X + 1 | 0;;){
                                                C = E[A + 28 >> 2], oA = 1 == ((P >>> 0) % ((_ = E[A + 24 >> 2]) >>> 0) | 0) ? P - 1 | 0 : r, r = _A ? E[E[A >> 2] + 4 >> 2] + (oA << 10) | 0 : (u << 3) + iA | 0, B = E[r >> 2], r = E[r + 4 >> 2], E[I + 12 >> 2] = u, C = EA ? QA : (r >>> 0) % (C >>> 0) | 0;
                                                A: if (T) r = _ + ((0 | C) == (0 | QA) ? (-1 ^ N) + u | 0 : (u ? 0 : -1) - N | 0) | 0, i = 0, 3 != (0 | X) && (i = c(N, cA));
                                                else {
                                                    if (!X) {
                                                        r = u - 1 | 0, i = 0;
                                                        break A;
                                                    }
                                                    if (r = c(N, X), (0 | C) == (0 | QA)) {
                                                        r = (r + u | 0) - 1 | 0, i = 0;
                                                        break A;
                                                    }
                                                    r = r - !u | 0, i = 0;
                                                }
                                                if (e = (N = E[E[A >> 2] + 4 >> 2]) + (c(C, _) << 10) | 0, i = (o = C = r - 1 | 0) >>> 0 > (C = C + i | 0) >>> 0, Ig(B, 0, B, 0), Ig(r, 0, w, 0), oI(C - (r = w) | 0, i - (C >>> 0 < r >>> 0) | 0, _), w = p, r = (D << 10) + e | 0, _ = N + (oA << 10) | 0, aA = N + (P << 10) | 0, T) G(_, r, aA);
                                                else {
                                                    for(Sg(g + 3072 | 0, r, 1024), r = 0; i = E[(B = (N = r << 3) + (C = g + 3072 | 0) | 0) >> 2], s = E[(e = _ + N | 0) >> 2], e = E[B + 4 >> 2] ^ E[e + 4 >> 2], E[B >> 2] = i ^ s, E[B + 4 >> 2] = e, e = E[(B = (i = 8 | N) + C | 0) >> 2], s = E[(i = _ + i | 0) >> 2], i = E[B + 4 >> 2] ^ E[i + 4 >> 2], E[B >> 2] = e ^ s, E[B + 4 >> 2] = i, e = E[(B = (i = 16 | N) + C | 0) >> 2], s = E[(i = _ + i | 0) >> 2], i = E[B + 4 >> 2] ^ E[i + 4 >> 2], E[B >> 2] = e ^ s, E[B + 4 >> 2] = i, i = E[(N = (B = 24 | N) + C | 0) >> 2], e = E[(B = B + _ | 0) >> 2], B = E[N + 4 >> 2] ^ E[B + 4 >> 2], E[N >> 2] = i ^ e, E[N + 4 >> 2] = B, 128 != (0 | (r = r + 4 | 0)););
                                                    for(Sg(g + 2048 | 0, C, 1024), N = 0, r = 0; e = (i = E[56 + (_ = (g + 3072 | 0) + (r << 7) | 0) >> 2]) + (B = E[_ + 24 >> 2]) | 0, s = (o = E[_ + 60 >> 2]) + (C = E[_ + 28 >> 2]) | 0, t = Ig(B << 1 & -2, 1 & (C << 1 | B >>> 31), i, 0), B = w + (B >>> 0 > e >>> 0 ? s + 1 | 0 : s) | 0, e = (C = t + e | 0) >>> 0 < t >>> 0 ? B + 1 | 0 : B, t = (s = KI(C ^ E[_ + 120 >> 2], e ^ E[_ + 124 >> 2], 32)) + (B = E[_ + 88 >> 2]) | 0, Q = (n = w) + (U = E[_ + 92 >> 2]) | 0, y = i, U = Ig(s, 0, B << 1 & -2, 1 & (U << 1 | B >>> 31)), B = w + (B >>> 0 > t >>> 0 ? Q + 1 | 0 : Q) | 0, J = KI(y ^ (i = U + t | 0), o ^ (R = i >>> 0 < U >>> 0 ? B + 1 | 0 : B), 40), t = 1 + (B = e + (gA = w) | 0) | 0, o = B, t = (B = C + J | 0) >>> 0 < C >>> 0 ? t : o, U = (C = Ig(J, 0, C << 1 & -2, 1 & (e << 1 | C >>> 31))) + B | 0, B = w + t | 0, k = KI(U ^ s, n ^ (z = C >>> 0 > U >>> 0 ? B + 1 | 0 : B), 48), H = y = w, e = (f = E[_ + 44 >> 2]) + (C = E[_ + 12 >> 2]) | 0, t = (s = E[_ + 40 >> 2]) + (B = E[_ + 8 >> 2]) | 0, Q = Ig(B << 1 & -2, 1 & (C << 1 | B >>> 31), s, 0), B = w + (B >>> 0 > t >>> 0 ? e + 1 | 0 : e) | 0, t = (C = t + Q | 0) >>> 0 < Q >>> 0 ? B + 1 | 0 : B, o = (Q = KI(C ^ E[_ + 104 >> 2], t ^ E[_ + 108 >> 2], 32)) + (e = E[_ + 72 >> 2]) | 0, n = (S = w) + (B = E[_ + 76 >> 2]) | 0, F = s, s = Ig(Q, 0, e << 1 & -2, 1 & (B << 1 | e >>> 31)), e = w + (e >>> 0 > o >>> 0 ? n + 1 | 0 : n) | 0, s = KI(F ^ (B = s + o | 0), f ^ (o = B >>> 0 < s >>> 0 ? e + 1 | 0 : e), 40), F = 1 + (e = t + (n = w) | 0) | 0, f = e, f = (e = C + s | 0) >>> 0 < C >>> 0 ? F : f, C = Ig(s, 0, C << 1 & -2, 1 & (t << 1 | C >>> 31)), t = w + f | 0, f = KI((e = C + e | 0) ^ Q, S ^ (j = C >>> 0 > e >>> 0 ? t + 1 | 0 : t), 48), Q = 1 + (C = o + (CA = w) | 0) | 0, t = C, t = (C = B + f | 0) >>> 0 < B >>> 0 ? Q : t, Q = s, s = C, C = Ig(f, 0, B << 1 & -2, 1 & (o << 1 | B >>> 31)), B = w + t | 0, S = KI(Q ^ (s = s + C | 0), n ^ (O = C >>> 0 > s >>> 0 ? B + 1 | 0 : B), 1), $ = M = w, t = (d = E[_ + 36 >> 2]) + (C = E[_ + 4 >> 2]) | 0, o = (Q = E[_ + 32 >> 2]) + (B = E[_ >> 2]) | 0, n = Ig(B << 1 & -2, 1 & (C << 1 | B >>> 31), Q, 0), B = w + (B >>> 0 > o >>> 0 ? t + 1 | 0 : t) | 0, o = (C = o + n | 0) >>> 0 < n >>> 0 ? B + 1 | 0 : B, n = (V = KI(C ^ E[_ + 96 >> 2], o ^ E[_ + 100 >> 2], 32)) + (B = E[(t = q = _ - -64 | 0) >> 2]) | 0, F = (BA = w) + (t = E[t + 4 >> 2]) | 0, b = Q, Q = Ig(V, 0, B << 1 & -2, 1 & (t << 1 | B >>> 31)), B = w + (B >>> 0 > n >>> 0 ? F + 1 | 0 : F) | 0, F = KI(b ^ (t = Q + n | 0), d ^ (L = Q >>> 0 > t >>> 0 ? B + 1 | 0 : B), 40), n = 1 + (B = o + (Z = w) | 0) | 0, Q = B, Q = (B = C + F | 0) >>> 0 < C >>> 0 ? n : Q, n = B, B = Ig(F, 0, C << 1 & -2, 1 & (o << 1 | C >>> 31)), Q = w + Q | 0, Q = 1 + (B = (x = (C = n + B | 0) >>> 0 < B >>> 0 ? Q + 1 | 0 : Q) + M | 0) | 0, o = B, o = (B = C + S | 0) >>> 0 < C >>> 0 ? Q : o, Q = B, B = Ig(S, 0, C << 1 & -2, 1 & (x << 1 | C >>> 31)), o = w + o | 0, y = KI((Q = Q + B | 0) ^ k, (m = B >>> 0 > Q >>> 0 ? o + 1 | 0 : o) ^ y, 32), W = w, n = (Y = E[_ + 52 >> 2]) + (B = E[_ + 20 >> 2]) | 0, d = (M = E[_ + 48 >> 2]) + (o = E[_ + 16 >> 2]) | 0, l = Ig(o << 1 & -2, 1 & (B << 1 | o >>> 31), M, 0), o = w + (o >>> 0 > d >>> 0 ? n + 1 | 0 : n) | 0, d = (B = d + l | 0) >>> 0 < l >>> 0 ? o + 1 | 0 : o, v = (l = KI(B ^ E[_ + 112 >> 2], d ^ E[_ + 116 >> 2], 32)) + (n = E[_ + 80 >> 2]) | 0, b = (AA = w) + (o = E[_ + 84 >> 2]) | 0, K = M, M = Ig(l, 0, n << 1 & -2, 1 & (o << 1 | n >>> 31)), n = w + (n >>> 0 > v >>> 0 ? b + 1 | 0 : b) | 0, M = KI(K ^ (o = M + v | 0), Y ^ (v = o >>> 0 < M >>> 0 ? n + 1 | 0 : n), 40), K = 1 + (n = d + (Y = w) | 0) | 0, b = n, b = (n = B + M | 0) >>> 0 < B >>> 0 ? K : b, B = Ig(M, 0, B << 1 & -2, 1 & (d << 1 | B >>> 31)), d = w + b | 0, d = KI(K = (n = B + n | 0) ^ l, AA ^ (l = B >>> 0 > n >>> 0 ? d + 1 | 0 : d), 48), K = 1 + (B = v + (AA = w) | 0) | 0, b = B, b = (B = o + d | 0) >>> 0 < o >>> 0 ? K : b, o = Ig(d, 0, o << 1 & -2, 1 & (v << 1 | o >>> 31)), v = w + b | 0, K = 1 + (o = (v = (B = o + B | 0) >>> 0 < o >>> 0 ? v + 1 | 0 : v) + W | 0) | 0, b = o, b = (o = B + y | 0) >>> 0 < B >>> 0 ? K : b, K = S, S = Ig(y, 0, B << 1 & -2, 1 & (v << 1 | B >>> 31)), b = w + b | 0, S = KI(K ^ (o = S + o | 0), $ ^ (b = o >>> 0 < S >>> 0 ? b + 1 | 0 : b), 40), tA = 1 + (K = m + ($ = w) | 0) | 0, IA = K, IA = (K = Q + S | 0) >>> 0 < Q >>> 0 ? tA : IA, Q = (m = Ig(S, 0, Q << 1 & -2, 1 & (m << 1 | Q >>> 31))) + K | 0, E[_ >> 2] = Q, K = w + IA | 0, m = Q >>> 0 < m >>> 0 ? K + 1 | 0 : K, E[_ + 4 >> 2] = m, Q = KI(Q ^ y, m ^ W, 48), E[_ + 120 >> 2] = Q, y = w, E[_ + 124 >> 2] = y, IA = 1 + (y = y + b | 0) | 0, K = y, m = (y = Q + o | 0) >>> 0 < o >>> 0 ? IA : K, Q = (o = Ig(Q, 0, o << 1 & -2, 1 & (b << 1 | o >>> 31))) + y | 0, E[_ + 80 >> 2] = Q, y = w + m | 0, o = Q >>> 0 < o >>> 0 ? y + 1 | 0 : y, E[_ + 84 >> 2] = o, rA = _, eA = KI(Q ^ S, o ^ $, 1), E[rA + 40 >> 2] = eA, E[_ + 44 >> 2] = w, Q = KI(B ^ M, v ^ Y, 1), y = 1 + (B = j + (M = w) | 0) | 0, o = B, o = (B = Q + e | 0) >>> 0 < e >>> 0 ? y : o, B = B + (S = Ig(Q, 0, e << 1 & -2, 1 & (j << 1 | e >>> 31))) | 0, e = w + o | 0, o = KI(C ^ V, x ^ BA, 48), e = KI(o ^ B, (S = B >>> 0 < S >>> 0 ? e + 1 | 0 : e) ^ (j = w), 32), V = y = w, b = 1 + (C = R + H | 0) | 0, H = C, x = (C = i + k | 0) >>> 0 < i >>> 0 ? b : H, i = Ig(k, 0, i << 1 & -2, 1 & (R << 1 | i >>> 31)), k = w + x | 0, H = 1 + (i = (k = (C = i + C | 0) >>> 0 < i >>> 0 ? k + 1 | 0 : k) + y | 0) | 0, y = i, y = (i = C + e | 0) >>> 0 < C >>> 0 ? H : y, H = Q, Q = Ig(e, 0, C << 1 & -2, 1 & (k << 1 | C >>> 31)), y = w + y | 0, Q = KI(H ^ (i = Q + i | 0), M ^ (y = i >>> 0 < Q >>> 0 ? y + 1 | 0 : y), 40), b = 1 + (R = S + (M = w) | 0) | 0, H = R, x = (R = B + Q | 0) >>> 0 < B >>> 0 ? b : H, H = e, e = Ig(Q, 0, B << 1 & -2, 1 & (S << 1 | B >>> 31)), S = w + x | 0, e = KI(H ^ (B = e + R | 0), V ^ (S = B >>> 0 < e >>> 0 ? S + 1 | 0 : S), 48), E[_ + 96 >> 2] = e, R = w, E[_ + 100 >> 2] = R, E[_ + 8 >> 2] = B, E[_ + 12 >> 2] = S, S = 1 + (B = y + R | 0) | 0, H = B, S = (B = i + e | 0) >>> 0 < i >>> 0 ? S : H, i = Ig(e, 0, i << 1 & -2, 1 & (y << 1 | i >>> 31)), e = w + S | 0, rA = _, eA = KI((B = i + B | 0) ^ Q, M ^ (i = B >>> 0 < i >>> 0 ? e + 1 | 0 : e), 1), E[rA + 48 >> 2] = eA, E[_ + 52 >> 2] = w, E[_ + 88 >> 2] = B, E[_ + 92 >> 2] = i, i = KI(C ^ J, k ^ gA, 1), e = 1 + (C = l + (J = w) | 0) | 0, B = C, e = (C = i + n | 0) >>> 0 < n >>> 0 ? e : B, B = C, C = Ig(i, 0, n << 1 & -2, 1 & (l << 1 | n >>> 31)), e = w + e | 0, e = KI((B = B + C | 0) ^ f, CA ^ (Q = C >>> 0 > B >>> 0 ? e + 1 | 0 : e), 32), k = n = w, f = 1 + (C = L + j | 0) | 0, y = C, f = (C = o + t | 0) >>> 0 < t >>> 0 ? f : y, t = Ig(o, 0, t << 1 & -2, 1 & (L << 1 | t >>> 31)), o = w + f | 0, f = 1 + (t = (o = (C = t + C | 0) >>> 0 < t >>> 0 ? o + 1 | 0 : o) + n | 0) | 0, y = t, n = (t = C + e | 0) >>> 0 < C >>> 0 ? f : y, y = i, i = t, t = Ig(e, 0, C << 1 & -2, 1 & (o << 1 | C >>> 31)), n = w + n | 0, t = KI(y ^ (i = i + t | 0), J ^ (n = i >>> 0 < t >>> 0 ? n + 1 | 0 : n), 40), M = 1 + (f = Q + (J = w) | 0) | 0, y = f, S = (f = B + t | 0) >>> 0 < B >>> 0 ? M : y, B = (Q = Ig(t, 0, B << 1 & -2, 1 & (Q << 1 | B >>> 31))) + f | 0, E[_ + 16 >> 2] = B, f = w + S | 0, Q = B >>> 0 < Q >>> 0 ? f + 1 | 0 : f, E[_ + 20 >> 2] = Q, B = KI(B ^ e, Q ^ k, 48), E[_ + 104 >> 2] = B, e = w, E[_ + 108 >> 2] = e, Q = 1 + (e = e + n | 0) | 0, y = e, Q = (e = B + i | 0) >>> 0 < i >>> 0 ? Q : y, i = (B = Ig(B, 0, i << 1 & -2, 1 & (n << 1 | i >>> 31))) + e | 0, e = w + Q | 0, n = B = B >>> 0 > i >>> 0 ? e + 1 | 0 : e, E[q >> 2] = i, E[q + 4 >> 2] = B, e = (B = KI(C ^ F, o ^ Z, 1)) + U | 0, Q = (k = w) + z | 0, C = (o = Ig(U << 1 & -2, 1 & (z << 1 | U >>> 31), B, 0)) + e | 0, e = w + (B >>> 0 > e >>> 0 ? Q + 1 | 0 : Q) | 0, e = KI(C ^ d, AA ^ (Q = C >>> 0 < o >>> 0 ? e + 1 | 0 : e), 32), f = 1 + (o = O + (U = w) | 0) | 0, y = o, f = (o = e + s | 0) >>> 0 < s >>> 0 ? f : y, y = B, B = (s = Ig(e, 0, s << 1 & -2, 1 & (O << 1 | s >>> 31))) + o | 0, o = w + f | 0, s = KI(y ^ B, k ^ (o = B >>> 0 < s >>> 0 ? o + 1 | 0 : o), 40), F = 1 + (f = Q + (k = w) | 0) | 0, y = f, S = (f = C + s | 0) >>> 0 < C >>> 0 ? F : y, y = e, C = Ig(s, 0, C << 1 & -2, 1 & (Q << 1 | C >>> 31)), Q = w + S | 0, C = KI(y ^ (e = C + f | 0), U ^ (Q = C >>> 0 > e >>> 0 ? Q + 1 | 0 : Q), 48), F = 1 + (f = o + (U = w) | 0) | 0, y = f, S = (f = C + B | 0) >>> 0 < B >>> 0 ? F : y, B = (o = Ig(C, 0, B << 1 & -2, 1 & (o << 1 | B >>> 31))) + f | 0, E[_ + 72 >> 2] = B, f = w + S | 0, o = B >>> 0 < o >>> 0 ? f + 1 | 0 : f, E[_ + 76 >> 2] = o, E[_ + 112 >> 2] = C, E[_ + 116 >> 2] = U, E[_ + 24 >> 2] = e, E[_ + 28 >> 2] = Q, rA = _, eA = KI(i ^ t, n ^ J, 1), E[rA + 56 >> 2] = eA, E[_ + 60 >> 2] = w, rA = _, eA = KI(B ^ s, o ^ k, 1), E[rA + 32 >> 2] = eA, E[_ + 36 >> 2] = w, 8 != (0 | (r = r + 1 | 0)););
                                                    for(; i = (B = E[392 + (_ = (g + 3072 | 0) + (N << 4) | 0) >> 2]) + (C = E[_ + 136 >> 2]) | 0, e = (Q = E[_ + 396 >> 2]) + (r = E[_ + 140 >> 2]) | 0, s = Ig(C << 1 & -2, 1 & (r << 1 | C >>> 31), B, 0), C = w + (C >>> 0 > i >>> 0 ? e + 1 | 0 : e) | 0, i = (r = s + i | 0) >>> 0 < s >>> 0 ? C + 1 | 0 : C, s = (e = KI(r ^ E[_ + 904 >> 2], i ^ E[_ + 908 >> 2], 32)) + (C = E[_ + 648 >> 2]) | 0, t = (o = w) + (n = E[_ + 652 >> 2]) | 0, y = B, n = Ig(e, 0, C << 1 & -2, 1 & (n << 1 | C >>> 31)), C = w + (C >>> 0 > s >>> 0 ? t + 1 | 0 : t) | 0, U = KI(y ^ (B = n + s | 0), Q ^ (d = B >>> 0 < n >>> 0 ? C + 1 | 0 : C), 40), y = 1 + (C = i + (v = w) | 0) | 0, t = C, s = (C = r + U | 0) >>> 0 < r >>> 0 ? y : t, n = (r = Ig(U, 0, r << 1 & -2, 1 & (i << 1 | r >>> 31))) + C | 0, C = w + s | 0, J = KI(n ^ e, o ^ (R = r >>> 0 > n >>> 0 ? C + 1 | 0 : C), 48), b = F = w, i = (k = E[_ + 268 >> 2]) + (r = E[_ + 12 >> 2]) | 0, s = (e = E[_ + 264 >> 2]) + (C = E[_ + 8 >> 2]) | 0, t = Ig(C << 1 & -2, 1 & (r << 1 | C >>> 31), e, 0), C = w + (C >>> 0 > s >>> 0 ? i + 1 | 0 : i) | 0, s = (r = s + t | 0) >>> 0 < t >>> 0 ? C + 1 | 0 : C, Q = (t = KI(r ^ E[_ + 776 >> 2], s ^ E[_ + 780 >> 2], 32)) + (i = E[_ + 520 >> 2]) | 0, o = (f = w) + (C = E[_ + 524 >> 2]) | 0, y = e, e = Ig(t, 0, i << 1 & -2, 1 & (C << 1 | i >>> 31)), i = w + (i >>> 0 > Q >>> 0 ? o + 1 | 0 : o) | 0, e = KI(y ^ (C = e + Q | 0), k ^ (Q = C >>> 0 < e >>> 0 ? i + 1 | 0 : i), 40), k = 1 + (i = s + (o = w) | 0) | 0, y = i, k = (i = r + e | 0) >>> 0 < r >>> 0 ? k : y, r = Ig(e, 0, r << 1 & -2, 1 & (s << 1 | r >>> 31)), s = w + k | 0, k = KI((i = r + i | 0) ^ t, f ^ (z = i >>> 0 < r >>> 0 ? s + 1 | 0 : s), 48), y = 1 + (r = Q + (gA = w) | 0) | 0, t = r, s = (r = C + k | 0) >>> 0 < C >>> 0 ? y : t, t = e, e = r, r = Ig(k, 0, C << 1 & -2, 1 & (Q << 1 | C >>> 31)), C = w + s | 0, f = KI(t ^ (e = e + r | 0), o ^ (j = r >>> 0 > e >>> 0 ? C + 1 | 0 : C), 1), H = y = w, s = (M = E[_ + 260 >> 2]) + (r = E[_ + 4 >> 2]) | 0, Q = (t = E[_ + 256 >> 2]) + (C = E[_ >> 2]) | 0, o = Ig(C << 1 & -2, 1 & (r << 1 | C >>> 31), t, 0), C = w + (C >>> 0 > Q >>> 0 ? s + 1 | 0 : s) | 0, Q = (r = Q + o | 0) >>> 0 < o >>> 0 ? C + 1 | 0 : C, o = (O = KI(r ^ E[_ + 768 >> 2], Q ^ E[_ + 772 >> 2], 32)) + (C = E[_ + 512 >> 2]) | 0, S = (CA = w) + (s = E[_ + 516 >> 2]) | 0, Y = t, t = Ig(O, 0, C << 1 & -2, 1 & (s << 1 | C >>> 31)), C = w + (C >>> 0 > o >>> 0 ? S + 1 | 0 : S) | 0, S = KI(Y ^ (s = t + o | 0), M ^ (V = t >>> 0 > s >>> 0 ? C + 1 | 0 : C), 40), t = 1 + (C = Q + ($ = w) | 0) | 0, o = C, t = (C = r + S | 0) >>> 0 < r >>> 0 ? t : o, o = C, C = Ig(S, 0, r << 1 & -2, 1 & (Q << 1 | r >>> 31)), t = w + t | 0, t = 1 + (C = (q = C >>> 0 > (r = o + C | 0) >>> 0 ? t + 1 | 0 : t) + y | 0) | 0, o = C, Q = (C = r + f | 0) >>> 0 < r >>> 0 ? t : o, o = C, C = Ig(f, 0, r << 1 & -2, 1 & (q << 1 | r >>> 31)), Q = w + Q | 0, F = KI((t = o + C | 0) ^ J, (L = C >>> 0 > t >>> 0 ? Q + 1 | 0 : Q) ^ F, 32), BA = w, o = (Z = E[_ + 388 >> 2]) + (C = E[_ + 132 >> 2]) | 0, M = (y = E[_ + 384 >> 2]) + (Q = E[_ + 128 >> 2]) | 0, x = Ig(Q << 1 & -2, 1 & (C << 1 | Q >>> 31), y, 0), Q = w + (Q >>> 0 > M >>> 0 ? o + 1 | 0 : o) | 0, M = (C = M + x | 0) >>> 0 < x >>> 0 ? Q + 1 | 0 : Q, m = (x = KI(C ^ E[_ + 896 >> 2], M ^ E[_ + 900 >> 2], 32)) + (o = E[_ + 640 >> 2]) | 0, l = (W = w) + (Q = E[_ + 644 >> 2]) | 0, Y = y, y = Ig(x, 0, o << 1 & -2, 1 & (Q << 1 | o >>> 31)), o = w + (o >>> 0 > m >>> 0 ? l + 1 | 0 : l) | 0, y = KI(Y ^ (Q = y + m | 0), Z ^ (m = Q >>> 0 < y >>> 0 ? o + 1 | 0 : o), 40), K = 1 + (o = M + (Z = w) | 0) | 0, Y = o, l = (o = C + y | 0) >>> 0 < C >>> 0 ? K : Y, C = Ig(y, 0, C << 1 & -2, 1 & (M << 1 | C >>> 31)), M = w + l | 0, M = KI(Y = (o = C + o | 0) ^ x, W ^ (x = C >>> 0 > o >>> 0 ? M + 1 | 0 : M), 48), K = 1 + (C = m + (W = w) | 0) | 0, Y = C, l = (C = Q + M | 0) >>> 0 < Q >>> 0 ? K : Y, Q = Ig(M, 0, Q << 1 & -2, 1 & (m << 1 | Q >>> 31)), m = w + l | 0, K = 1 + (Q = (m = (C = Q + C | 0) >>> 0 < Q >>> 0 ? m + 1 | 0 : m) + BA | 0) | 0, Y = Q, l = (Q = C + F | 0) >>> 0 < C >>> 0 ? K : Y, Y = f, f = Ig(F, 0, C << 1 & -2, 1 & (m << 1 | C >>> 31)), l = w + l | 0, f = KI(Y ^ (Q = f + Q | 0), H ^ (l = Q >>> 0 < f >>> 0 ? l + 1 | 0 : l), 40), IA = 1 + (Y = L + (H = w) | 0) | 0, K = Y, AA = (Y = t + f | 0) >>> 0 < t >>> 0 ? IA : K, t = (L = Ig(f, 0, t << 1 & -2, 1 & (L << 1 | t >>> 31))) + Y | 0, E[_ >> 2] = t, Y = w + AA | 0, L = t >>> 0 < L >>> 0 ? Y + 1 | 0 : Y, E[_ + 4 >> 2] = L, t = KI(t ^ F, L ^ BA, 48), E[_ + 904 >> 2] = t, F = w, E[_ + 908 >> 2] = F, K = 1 + (F = F + l | 0) | 0, Y = F, L = (F = Q + t | 0) >>> 0 < Q >>> 0 ? K : Y, t = (Q = Ig(t, 0, Q << 1 & -2, 1 & (l << 1 | Q >>> 31))) + F | 0, E[_ + 640 >> 2] = t, F = w + L | 0, Q = Q >>> 0 > t >>> 0 ? F + 1 | 0 : F, E[_ + 644 >> 2] = Q, rA = _, eA = KI(t ^ f, Q ^ H, 1), E[rA + 264 >> 2] = eA, E[_ + 268 >> 2] = w, t = KI(C ^ y, m ^ Z, 1), f = 1 + (C = z + (y = w) | 0) | 0, Q = C, Q = (C = i + t | 0) >>> 0 < i >>> 0 ? f : Q, C = C + (f = Ig(t, 0, i << 1 & -2, 1 & (z << 1 | i >>> 31))) | 0, i = w + Q | 0, Q = KI(r ^ O, q ^ CA, 48), i = KI(Q ^ C, (f = C >>> 0 < f >>> 0 ? i + 1 | 0 : i) ^ (z = w), 32), O = F = w, b = 1 + (r = d + b | 0) | 0, H = r, q = (r = B + J | 0) >>> 0 < B >>> 0 ? b : H, B = Ig(J, 0, B << 1 & -2, 1 & (d << 1 | B >>> 31)), J = w + q | 0, H = 1 + (B = (J = B >>> 0 > (r = B + r | 0) >>> 0 ? J + 1 | 0 : J) + F | 0) | 0, F = B, F = (B = i + r | 0) >>> 0 < r >>> 0 ? H : F, H = t, t = Ig(i, 0, r << 1 & -2, 1 & (J << 1 | r >>> 31)), F = w + F | 0, t = KI(H ^ (B = t + B | 0), y ^ (F = B >>> 0 < t >>> 0 ? F + 1 | 0 : F), 40), b = 1 + (d = f + (y = w) | 0) | 0, H = d, q = (d = C + t | 0) >>> 0 < C >>> 0 ? b : H, H = i, i = Ig(t, 0, C << 1 & -2, 1 & (f << 1 | C >>> 31)), f = w + q | 0, i = KI(H ^ (C = i + d | 0), O ^ (f = C >>> 0 < i >>> 0 ? f + 1 | 0 : f), 48), E[_ + 768 >> 2] = i, d = w, E[_ + 772 >> 2] = d, E[_ + 8 >> 2] = C, E[_ + 12 >> 2] = f, H = 1 + (C = F + d | 0) | 0, f = C, f = (C = B + i | 0) >>> 0 < B >>> 0 ? H : f, B = Ig(i, 0, B << 1 & -2, 1 & (F << 1 | B >>> 31)), i = w + f | 0, rA = _, eA = KI((C = B + C | 0) ^ t, y ^ (B = C >>> 0 < B >>> 0 ? i + 1 | 0 : i), 1), E[rA + 384 >> 2] = eA, E[_ + 388 >> 2] = w, E[_ + 648 >> 2] = C, E[_ + 652 >> 2] = B, B = KI(r ^ U, J ^ v, 1), i = 1 + (r = x + (U = w) | 0) | 0, C = r, i = (r = B + o | 0) >>> 0 < o >>> 0 ? i : C, C = r, r = Ig(B, 0, o << 1 & -2, 1 & (x << 1 | o >>> 31)), i = w + i | 0, i = KI((C = C + r | 0) ^ k, gA ^ (t = C >>> 0 < r >>> 0 ? i + 1 | 0 : i), 32), J = o = w, f = 1 + (r = z + V | 0) | 0, y = r, k = (r = Q + s | 0) >>> 0 < s >>> 0 ? f : y, s = Ig(Q, 0, s << 1 & -2, 1 & (V << 1 | s >>> 31)), Q = w + k | 0, y = 1 + (s = (Q = (r = s + r | 0) >>> 0 < s >>> 0 ? Q + 1 | 0 : Q) + o | 0) | 0, o = s, o = (s = i + r | 0) >>> 0 < r >>> 0 ? y : o, y = B, B = s, s = Ig(i, 0, r << 1 & -2, 1 & (Q << 1 | r >>> 31)), o = w + o | 0, s = KI(y ^ (B = B + s | 0), U ^ (o = B >>> 0 < s >>> 0 ? o + 1 | 0 : o), 40), f = 1 + (k = t + (U = w) | 0) | 0, y = k, f = (k = C + s | 0) >>> 0 < C >>> 0 ? f : y, C = (t = Ig(s, 0, C << 1 & -2, 1 & (t << 1 | C >>> 31))) + k | 0, E[_ + 128 >> 2] = C, k = w + f | 0, t = C >>> 0 < t >>> 0 ? k + 1 | 0 : k, E[_ + 132 >> 2] = t, C = KI(C ^ i, t ^ J, 48), E[_ + 776 >> 2] = C, i = w, E[_ + 780 >> 2] = i, y = 1 + (i = i + o | 0) | 0, t = i, t = (i = C + B | 0) >>> 0 < B >>> 0 ? y : t, B = (C = Ig(C, 0, B << 1 & -2, 1 & (o << 1 | B >>> 31))) + i | 0, i = w + t | 0, o = C = C >>> 0 > B >>> 0 ? i + 1 | 0 : i, E[_ + 512 >> 2] = B, E[_ + 516 >> 2] = C, i = (C = KI(r ^ S, Q ^ $, 1)) + n | 0, t = (J = w) + R | 0, r = (Q = Ig(n << 1 & -2, 1 & (R << 1 | n >>> 31), C, 0)) + i | 0, i = w + (C >>> 0 > i >>> 0 ? t + 1 | 0 : t) | 0, i = KI(r ^ M, W ^ (t = Q >>> 0 > r >>> 0 ? i + 1 | 0 : i), 32), f = 1 + (Q = j + (n = w) | 0) | 0, y = Q, k = (Q = i + e | 0) >>> 0 < e >>> 0 ? f : y, y = C, C = (e = Ig(i, 0, e << 1 & -2, 1 & (j << 1 | e >>> 31))) + Q | 0, Q = w + k | 0, e = KI(y ^ C, J ^ (Q = C >>> 0 < e >>> 0 ? Q + 1 | 0 : Q), 40), f = 1 + (k = t + (J = w) | 0) | 0, y = k, f = (k = r + e | 0) >>> 0 < r >>> 0 ? f : y, y = i, r = Ig(e, 0, r << 1 & -2, 1 & (t << 1 | r >>> 31)), t = w + f | 0, r = KI(y ^ (i = r + k | 0), n ^ (t = i >>> 0 < r >>> 0 ? t + 1 | 0 : t), 48), f = 1 + (k = Q + (n = w) | 0) | 0, y = k, f = (k = C + r | 0) >>> 0 < C >>> 0 ? f : y, C = (Q = Ig(r, 0, C << 1 & -2, 1 & (Q << 1 | C >>> 31))) + k | 0, E[_ + 520 >> 2] = C, k = w + f | 0, Q = C >>> 0 < Q >>> 0 ? k + 1 | 0 : k, E[_ + 524 >> 2] = Q, E[_ + 896 >> 2] = r, E[_ + 900 >> 2] = n, E[_ + 136 >> 2] = i, E[_ + 140 >> 2] = t, rA = _, eA = KI(B ^ s, o ^ U, 1), E[rA + 392 >> 2] = eA, E[_ + 396 >> 2] = w, rA = _, eA = KI(C ^ e, Q ^ J, 1), E[rA + 256 >> 2] = eA, E[_ + 260 >> 2] = w, 8 != (0 | (N = N + 1 | 0)););
                                                    for(_ = Sg(aA, g + 2048 | 0, 1024), r = 0; i = E[(C = (N = r << 3) + _ | 0) >> 2], s = E[(e = (B = g + 3072 | 0) + N | 0) >> 2], e = E[C + 4 >> 2] ^ E[e + 4 >> 2], E[C >> 2] = i ^ s, E[C + 4 >> 2] = e, e = E[(C = (i = 8 | N) + _ | 0) >> 2], s = E[(i = B + i | 0) >> 2], i = E[C + 4 >> 2] ^ E[i + 4 >> 2], E[C >> 2] = e ^ s, E[C + 4 >> 2] = i, e = E[(C = (i = 16 | N) + _ | 0) >> 2], s = E[(i = B + i | 0) >> 2], i = E[C + 4 >> 2] ^ E[i + 4 >> 2], E[C >> 2] = e ^ s, E[C + 4 >> 2] = i, i = E[(N = (C = 24 | N) + _ | 0) >> 2], B = E[(C = C + B | 0) >> 2], C = E[N + 4 >> 2] ^ E[C + 4 >> 2], E[N >> 2] = B ^ i, E[N + 4 >> 2] = C, 128 != (0 | (r = r + 4 | 0)););
                                                }
                                                if (r = oA + 1 | 0, P = P + 1 | 0, !((N = E[A + 20 >> 2]) >>> 0 > (u = u + 1 | 0) >>> 0)) break;
                                            }
                                        }
                                        h = g + 4096 | 0;
                                    }
                                    function G(A, I, g) {
                                        var C, B = 0, Q = 0, i = 0, o = 0, a = 0, _ = 0, c = 0, t = 0, r = 0, e = 0, y = 0, s = 0, D = 0, p = 0, f = 0, n = 0, k = 0, F = 0, N = 0, S = 0, G = 0, M = 0, b = 0, K = 0, H = 0, Y = 0, d = 0, J = 0, U = 0, l = 0, m = 0, u = 0, x = 0, R = 0, v = 0, L = 0, P = 0, q = 0, z = 0, j = 0, X = 0, O = 0, V = 0, Z = 0;
                                        for(h = o = h - 2048 | 0, Sg(o + 1024 | 0, I, 1024), I = 0; Q = E[(_ = (i = o + 1024 | 0) + (B = I << 3) | 0) >> 2], a = E[(c = A + B | 0) >> 2], c = E[_ + 4 >> 2] ^ E[c + 4 >> 2], E[_ >> 2] = Q ^ a, E[_ + 4 >> 2] = c, c = E[(_ = (Q = 8 | B) + i | 0) >> 2], a = E[(Q = A + Q | 0) >> 2], Q = E[_ + 4 >> 2] ^ E[Q + 4 >> 2], E[_ >> 2] = a ^ c, E[_ + 4 >> 2] = Q, c = E[(_ = (Q = 16 | B) + i | 0) >> 2], a = E[(Q = A + Q | 0) >> 2], Q = E[_ + 4 >> 2] ^ E[Q + 4 >> 2], E[_ >> 2] = a ^ c, E[_ + 4 >> 2] = Q, Q = E[(B = (_ = 24 | B) + i | 0) >> 2], c = E[(_ = A + _ | 0) >> 2], _ = E[B + 4 >> 2] ^ E[_ + 4 >> 2], E[B >> 2] = Q ^ c, E[B + 4 >> 2] = _, 128 != (0 | (I = I + 4 | 0)););
                                        for(C = Sg(o, i, 1024), A = 0, I = 0; o = E[(B = (i = I << 3) + C | 0) >> 2], Q = E[(_ = g + i | 0) >> 2], _ = E[B + 4 >> 2] ^ E[_ + 4 >> 2], E[B >> 2] = Q ^ o, E[B + 4 >> 2] = _, _ = E[(B = (o = 8 | i) + C | 0) >> 2], Q = E[(o = g + o | 0) >> 2], o = E[B + 4 >> 2] ^ E[o + 4 >> 2], E[B >> 2] = Q ^ _, E[B + 4 >> 2] = o, _ = E[(B = (o = 16 | i) + C | 0) >> 2], Q = E[(o = g + o | 0) >> 2], o = E[B + 4 >> 2] ^ E[o + 4 >> 2], E[B >> 2] = Q ^ _, E[B + 4 >> 2] = o, o = E[(i = (B = 24 | i) + C | 0) >> 2], _ = E[(B = g + B | 0) >> 2], B = E[i + 4 >> 2] ^ E[B + 4 >> 2], E[i >> 2] = o ^ _, E[i + 4 >> 2] = B, 128 != (0 | (I = I + 4 | 0)););
                                        for(; c = (Q = E[56 + (i = (C + 1024 | 0) + (A << 7) | 0) >> 2]) + (B = E[i + 24 >> 2]) | 0, I = (t = E[i + 60 >> 2]) + (o = E[i + 28 >> 2]) | 0, _ = B >>> 0 > c >>> 0 ? I + 1 | 0 : I, o = Ig(B << 1 & -2, 1 & (o << 1 | B >>> 31), Q, 0), I = w + _ | 0, _ = (B = o + c | 0) >>> 0 < o >>> 0 ? I + 1 | 0 : I, e = (c = KI(E[i + 120 >> 2] ^ B, _ ^ E[i + 124 >> 2], 32)) + (o = E[i + 88 >> 2]) | 0, I = (y = w) + (a = E[i + 92 >> 2]) | 0, r = o >>> 0 > e >>> 0 ? I + 1 | 0 : I, a = Ig(o << 1 & -2, 1 & (a << 1 | o >>> 31), c, 0), I = w + r | 0, x = KI(Q ^ (o = a + e | 0), t ^ (s = o >>> 0 < a >>> 0 ? I + 1 | 0 : I), 40), I = _ + (z = w) | 0, Q = (a = B + x | 0) >>> 0 < B >>> 0 ? I + 1 | 0 : I, B = Ig(x, 0, B << 1 & -2, 1 & (_ << 1 | B >>> 31)), I = w + Q | 0, Y = KI(c ^ (F = B + a | 0), y ^ (H = B >>> 0 > F >>> 0 ? I + 1 | 0 : I), 48), j = I = w, p = Y, e = I, a = (c = E[i + 40 >> 2]) + (B = E[i + 8 >> 2]) | 0, I = (d = E[i + 44 >> 2]) + (_ = E[i + 12 >> 2]) | 0, Q = B >>> 0 > a >>> 0 ? I + 1 | 0 : I, _ = Ig(B << 1 & -2, 1 & (_ << 1 | B >>> 31), c, 0), I = w + Q | 0, Q = (B = _ + a | 0) >>> 0 < _ >>> 0 ? I + 1 | 0 : I, y = (a = KI(E[i + 104 >> 2] ^ B, Q ^ E[i + 108 >> 2], 32)) + (_ = E[i + 72 >> 2]) | 0, I = (f = w) + (r = E[i + 76 >> 2]) | 0, t = _ >>> 0 > y >>> 0 ? I + 1 | 0 : I, r = Ig(_ << 1 & -2, 1 & (r << 1 | _ >>> 31), a, 0), I = w + t | 0, r = KI(t = (_ = r + y | 0) ^ c, d ^ (c = _ >>> 0 < r >>> 0 ? I + 1 | 0 : I), 40), I = Q + (n = w) | 0, t = (y = B + r | 0) >>> 0 < B >>> 0 ? I + 1 | 0 : I, Q = Ig(r, 0, B << 1 & -2, 1 & (Q << 1 | B >>> 31)), I = w + t | 0, R = KI((B = Q + y | 0) ^ a, f ^ (y = B >>> 0 < Q >>> 0 ? I + 1 | 0 : I), 48), I = c + (v = w) | 0, Q = (a = _ + R | 0) >>> 0 < _ >>> 0 ? I + 1 | 0 : I, c = Ig(R, 0, _ << 1 & -2, 1 & (c << 1 | _ >>> 31)), I = w + Q | 0, M = KI((_ = c + a | 0) ^ r, n ^ (d = _ >>> 0 < c >>> 0 ? I + 1 | 0 : I), 1), L = I = w, k = M, t = I, f = (r = E[i + 32 >> 2]) + (Q = E[i >> 2]) | 0, I = (J = E[i + 36 >> 2]) + (c = E[i + 4 >> 2]) | 0, a = Q >>> 0 > f >>> 0 ? I + 1 | 0 : I, c = Ig(Q << 1 & -2, 1 & (c << 1 | Q >>> 31), r, 0), I = w + a | 0, a = (Q = c + f | 0) >>> 0 < c >>> 0 ? I + 1 | 0 : I, D = (U = KI(E[i + 96 >> 2] ^ Q, a ^ E[i + 100 >> 2], 32)) + (c = E[(I = N = i - -64 | 0) >> 2]) | 0, I = (q = w) + (f = E[I + 4 >> 2]) | 0, n = c >>> 0 > D >>> 0 ? I + 1 | 0 : I, f = Ig(c << 1 & -2, 1 & (f << 1 | c >>> 31), U, 0), I = w + n | 0, J = KI((c = f + D | 0) ^ r, J ^ (f = c >>> 0 < f >>> 0 ? I + 1 | 0 : I), 40), I = a + (X = w) | 0, r = (n = Q + J | 0) >>> 0 < Q >>> 0 ? I + 1 | 0 : I, a = Ig(J, 0, Q << 1 & -2, 1 & (a << 1 | Q >>> 31)), I = w + r | 0, I = (n = (Q = a + n | 0) >>> 0 < a >>> 0 ? I + 1 | 0 : I) + t | 0, r = (a = Q + k | 0) >>> 0 < Q >>> 0 ? I + 1 | 0 : I, t = Ig(k, 0, Q << 1 & -2, 1 & (n << 1 | Q >>> 31)), I = w + r | 0, l = KI((a = t + a | 0) ^ p, (D = a >>> 0 < t >>> 0 ? I + 1 | 0 : I) ^ e, 32), P = I = w, S = I, k = (p = E[i + 48 >> 2]) + (r = E[i + 16 >> 2]) | 0, I = (m = E[i + 52 >> 2]) + (e = E[i + 20 >> 2]) | 0, t = r >>> 0 > k >>> 0 ? I + 1 | 0 : I, e = Ig(r << 1 & -2, 1 & (e << 1 | r >>> 31), p, 0), I = w + t | 0, t = (r = e + k | 0) >>> 0 < e >>> 0 ? I + 1 | 0 : I, G = (k = KI(E[i + 112 >> 2] ^ r, t ^ E[i + 116 >> 2], 32)) + (e = E[i + 80 >> 2]) | 0, I = (u = w) + (b = E[i + 84 >> 2]) | 0, K = e >>> 0 > G >>> 0 ? I + 1 | 0 : I, b = Ig(e << 1 & -2, 1 & (b << 1 | e >>> 31), k, 0), I = w + K | 0, b = KI(G = (e = b + G | 0) ^ p, m ^ (p = e >>> 0 < b >>> 0 ? I + 1 | 0 : I), 40), I = t + (m = w) | 0, K = (G = r + b | 0) >>> 0 < r >>> 0 ? I + 1 | 0 : I, t = Ig(b, 0, r << 1 & -2, 1 & (t << 1 | r >>> 31)), I = w + K | 0, K = KI(G = (r = t + G | 0) ^ k, u ^ (k = t >>> 0 > r >>> 0 ? I + 1 | 0 : I), 48), I = p + (u = w) | 0, t = (G = e + K | 0) >>> 0 < e >>> 0 ? I + 1 | 0 : I, p = Ig(K, 0, e << 1 & -2, 1 & (p << 1 | e >>> 31)), I = w + t | 0, I = (p = (e = p + G | 0) >>> 0 < p >>> 0 ? I + 1 | 0 : I) + S | 0, S = (t = e + l | 0) >>> 0 < e >>> 0 ? I + 1 | 0 : I, G = Ig(l, 0, e << 1 & -2, 1 & (p << 1 | e >>> 31)), I = w + S | 0, S = KI(S = (t = G + t | 0) ^ M, L ^ (M = t >>> 0 < G >>> 0 ? I + 1 | 0 : I), 40), I = D + (L = w) | 0, G = (O = a + S | 0) >>> 0 < a >>> 0 ? I + 1 | 0 : I, a = (D = Ig(S, 0, a << 1 & -2, 1 & (D << 1 | a >>> 31))) + O | 0, I = w + G | 0, E[i >> 2] = a, I = a >>> 0 < D >>> 0 ? I + 1 | 0 : I, E[i + 4 >> 2] = I, a = KI(a ^ l, I ^ P, 48), E[i + 120 >> 2] = a, I = w, E[i + 124 >> 2] = I, I = I + M | 0, D = (l = a + t | 0) >>> 0 < t >>> 0 ? I + 1 | 0 : I, a = (t = Ig(a, 0, t << 1 & -2, 1 & (M << 1 | t >>> 31))) + l | 0, I = w + D | 0, E[i + 80 >> 2] = a, I = a >>> 0 < t >>> 0 ? I + 1 | 0 : I, E[i + 84 >> 2] = I, V = i, Z = KI(a ^ S, I ^ L, 1), E[V + 40 >> 2] = Z, E[i + 44 >> 2] = w, I = s + j | 0, a = (t = o + Y | 0) >>> 0 < o >>> 0 ? I + 1 | 0 : I, o = Ig(Y, 0, o << 1 & -2, 1 & (s << 1 | o >>> 31)), I = w + a | 0, a = I = o >>> 0 > (t = o + t | 0) >>> 0 ? I + 1 | 0 : I, o = I, e = KI(e ^ b, p ^ m, 1), I = y + (p = w) | 0, s = (D = B + e | 0) >>> 0 < B >>> 0 ? I + 1 | 0 : I, B = (y = Ig(e, 0, B << 1 & -2, 1 & (y << 1 | B >>> 31))) + D | 0, I = w + s | 0, n = KI(Q ^ U, n ^ q, 48), y = KI(n ^ B, (Q = B >>> 0 < y >>> 0 ? I + 1 | 0 : I) ^ (M = w), 32), I = (Y = w) + o | 0, s = y >>> 0 > (D = y + t | 0) >>> 0 ? I + 1 | 0 : I, o = (I = D) + (D = Ig(t << 1 & -2, 1 & (o << 1 | t >>> 31), y, 0)) | 0, I = w + s | 0, s = KI(S = o ^ e, p ^ (e = o >>> 0 < D >>> 0 ? I + 1 | 0 : I), 40), I = Q + (D = w) | 0, p = (U = B + s | 0) >>> 0 < B >>> 0 ? I + 1 | 0 : I, B = Ig(s, 0, B << 1 & -2, 1 & (Q << 1 | B >>> 31)), I = w + p | 0, B = KI((Q = B + U | 0) ^ y, Y ^ (I = B >>> 0 > Q >>> 0 ? I + 1 | 0 : I), 48), E[i + 96 >> 2] = B, y = w, E[i + 100 >> 2] = y, E[i + 8 >> 2] = Q, E[i + 12 >> 2] = I, I = e + y | 0, Q = (y = B + o | 0) >>> 0 < o >>> 0 ? I + 1 | 0 : I, o = Ig(B, 0, o << 1 & -2, 1 & (e << 1 | o >>> 31)), I = w + Q | 0, V = i, Z = KI((B = o + y | 0) ^ s, (I = B >>> 0 < o >>> 0 ? I + 1 | 0 : I) ^ D, 1), E[V + 48 >> 2] = Z, E[i + 52 >> 2] = w, E[i + 88 >> 2] = B, E[i + 92 >> 2] = I, e = KI(t ^ x, a ^ z, 1), I = k + (s = w) | 0, o = (B = r + e | 0) >>> 0 < r >>> 0 ? I + 1 | 0 : I, Q = Ig(e, 0, r << 1 & -2, 1 & (k << 1 | r >>> 31)), I = w + o | 0, t = KI((B = Q + B | 0) ^ R, v ^ (a = B >>> 0 < Q >>> 0 ? I + 1 | 0 : I), 32), y = I = w, Q = I, I = f + M | 0, r = (o = c + n | 0) >>> 0 < c >>> 0 ? I + 1 | 0 : I, c = Ig(n, 0, c << 1 & -2, 1 & (f << 1 | c >>> 31)), I = w + r | 0, I = (c = (o = c + o | 0) >>> 0 < c >>> 0 ? I + 1 | 0 : I) + Q | 0, r = (Q = o + t | 0) >>> 0 < o >>> 0 ? I + 1 | 0 : I, f = Ig(t, 0, o << 1 & -2, 1 & (c << 1 | o >>> 31)), I = w + r | 0, e = KI((Q = f + Q | 0) ^ e, s ^ (r = Q >>> 0 < f >>> 0 ? I + 1 | 0 : I), 40), I = a + (f = w) | 0, s = (n = B + e | 0) >>> 0 < B >>> 0 ? I + 1 | 0 : I, B = (a = Ig(e, 0, B << 1 & -2, 1 & (a << 1 | B >>> 31))) + n | 0, I = w + s | 0, E[i + 16 >> 2] = B, I = B >>> 0 < a >>> 0 ? I + 1 | 0 : I, E[i + 20 >> 2] = I, B = KI(B ^ t, I ^ y, 48), E[i + 104 >> 2] = B, I = w, E[i + 108 >> 2] = I, a = N, I = I + r | 0, t = (s = B + Q | 0) >>> 0 < Q >>> 0 ? I + 1 | 0 : I, Q = Ig(B, 0, Q << 1 & -2, 1 & (r << 1 | Q >>> 31)), I = w + t | 0, r = B = Q + s | 0, t = I = B >>> 0 < Q >>> 0 ? I + 1 | 0 : I, E[a >> 2] = B, E[a + 4 >> 2] = I, c = KI(o ^ J, c ^ X, 1), I = (y = w) + H | 0, o = (B = c + F | 0) >>> 0 < c >>> 0 ? I + 1 | 0 : I, Q = Ig(F << 1 & -2, 1 & (H << 1 | F >>> 31), c, 0), I = w + o | 0, a = KI((B = Q + B | 0) ^ K, u ^ (Q = B >>> 0 < Q >>> 0 ? I + 1 | 0 : I), 32), I = d + (F = w) | 0, s = (o = a + _ | 0) >>> 0 < _ >>> 0 ? I + 1 | 0 : I, _ = Ig(a, 0, _ << 1 & -2, 1 & (d << 1 | _ >>> 31)), I = w + s | 0, c = KI((o = _ + o | 0) ^ c, y ^ (_ = o >>> 0 < _ >>> 0 ? I + 1 | 0 : I), 40), I = Q + (H = w) | 0, s = (y = B + c | 0) >>> 0 < B >>> 0 ? I + 1 | 0 : I, Q = Ig(c, 0, B << 1 & -2, 1 & (Q << 1 | B >>> 31)), I = w + s | 0, I = (B = Q + y | 0) >>> 0 < Q >>> 0 ? I + 1 | 0 : I, Q = B, B ^= a, a = I, B = KI(B, F ^ I, 48), I = _ + (F = w) | 0, s = (y = B + o | 0) >>> 0 < o >>> 0 ? I + 1 | 0 : I, o = (_ = Ig(B, 0, o << 1 & -2, 1 & (_ << 1 | o >>> 31))) + y | 0, I = w + s | 0, E[i + 72 >> 2] = o, I = o >>> 0 < _ >>> 0 ? I + 1 | 0 : I, E[i + 76 >> 2] = I, E[i + 112 >> 2] = B, E[i + 116 >> 2] = F, E[i + 24 >> 2] = Q, E[i + 28 >> 2] = a, V = i, Z = KI(r ^ e, t ^ f, 1), E[V + 56 >> 2] = Z, E[i + 60 >> 2] = w, V = i, Z = KI(o ^ c, I ^ H, 1), E[V + 32 >> 2] = Z, E[i + 36 >> 2] = w, 8 != (0 | (A = A + 1 | 0)););
                                        for(A = 0; c = (Q = E[392 + (i = (C + 1024 | 0) + (A << 4) | 0) >> 2]) + (B = E[i + 136 >> 2]) | 0, I = (t = E[i + 396 >> 2]) + (o = E[i + 140 >> 2]) | 0, _ = B >>> 0 > c >>> 0 ? I + 1 | 0 : I, o = Ig(B << 1 & -2, 1 & (o << 1 | B >>> 31), Q, 0), I = w + _ | 0, _ = (B = o + c | 0) >>> 0 < o >>> 0 ? I + 1 | 0 : I, e = (c = KI(E[i + 904 >> 2] ^ B, _ ^ E[i + 908 >> 2], 32)) + (o = E[i + 648 >> 2]) | 0, I = (y = w) + (a = E[i + 652 >> 2]) | 0, r = o >>> 0 > e >>> 0 ? I + 1 | 0 : I, a = Ig(o << 1 & -2, 1 & (a << 1 | o >>> 31), c, 0), I = w + r | 0, x = KI(Q ^ (o = a + e | 0), t ^ (s = o >>> 0 < a >>> 0 ? I + 1 | 0 : I), 40), I = _ + (G = w) | 0, Q = (a = B + x | 0) >>> 0 < B >>> 0 ? I + 1 | 0 : I, B = Ig(x, 0, B << 1 & -2, 1 & (_ << 1 | B >>> 31)), I = w + Q | 0, Y = KI(c ^ (F = B + a | 0), y ^ (H = B >>> 0 > F >>> 0 ? I + 1 | 0 : I), 48), z = I = w, p = Y, e = I, a = (c = E[i + 264 >> 2]) + (B = E[i + 8 >> 2]) | 0, I = (d = E[i + 268 >> 2]) + (_ = E[i + 12 >> 2]) | 0, Q = B >>> 0 > a >>> 0 ? I + 1 | 0 : I, _ = Ig(B << 1 & -2, 1 & (_ << 1 | B >>> 31), c, 0), I = w + Q | 0, Q = (B = _ + a | 0) >>> 0 < _ >>> 0 ? I + 1 | 0 : I, y = (a = KI(E[i + 776 >> 2] ^ B, Q ^ E[i + 780 >> 2], 32)) + (_ = E[i + 520 >> 2]) | 0, I = (f = w) + (r = E[i + 524 >> 2]) | 0, t = _ >>> 0 > y >>> 0 ? I + 1 | 0 : I, r = Ig(_ << 1 & -2, 1 & (r << 1 | _ >>> 31), a, 0), I = w + t | 0, r = KI(t = (_ = r + y | 0) ^ c, d ^ (c = _ >>> 0 < r >>> 0 ? I + 1 | 0 : I), 40), I = Q + (n = w) | 0, t = (y = B + r | 0) >>> 0 < B >>> 0 ? I + 1 | 0 : I, Q = Ig(r, 0, B << 1 & -2, 1 & (Q << 1 | B >>> 31)), I = w + t | 0, R = KI((B = Q + y | 0) ^ a, f ^ (y = B >>> 0 < Q >>> 0 ? I + 1 | 0 : I), 48), I = c + (j = w) | 0, Q = (a = _ + R | 0) >>> 0 < _ >>> 0 ? I + 1 | 0 : I, c = Ig(R, 0, _ << 1 & -2, 1 & (c << 1 | _ >>> 31)), I = w + Q | 0, M = KI((_ = c + a | 0) ^ r, n ^ (d = _ >>> 0 < c >>> 0 ? I + 1 | 0 : I), 1), v = I = w, k = M, t = I, f = (r = E[i + 256 >> 2]) + (Q = E[i >> 2]) | 0, I = (J = E[i + 260 >> 2]) + (c = E[i + 4 >> 2]) | 0, a = Q >>> 0 > f >>> 0 ? I + 1 | 0 : I, c = Ig(Q << 1 & -2, 1 & (c << 1 | Q >>> 31), r, 0), I = w + a | 0, a = (Q = c + f | 0) >>> 0 < c >>> 0 ? I + 1 | 0 : I, D = (U = KI(E[i + 768 >> 2] ^ Q, a ^ E[i + 772 >> 2], 32)) + (c = E[i + 512 >> 2]) | 0, I = (L = w) + (f = E[i + 516 >> 2]) | 0, n = c >>> 0 > D >>> 0 ? I + 1 | 0 : I, f = Ig(c << 1 & -2, 1 & (f << 1 | c >>> 31), U, 0), I = w + n | 0, J = KI((c = f + D | 0) ^ r, J ^ (f = c >>> 0 < f >>> 0 ? I + 1 | 0 : I), 40), I = a + (q = w) | 0, r = (n = Q + J | 0) >>> 0 < Q >>> 0 ? I + 1 | 0 : I, a = Ig(J, 0, Q << 1 & -2, 1 & (a << 1 | Q >>> 31)), I = w + r | 0, I = (n = (Q = a + n | 0) >>> 0 < a >>> 0 ? I + 1 | 0 : I) + t | 0, r = (a = Q + k | 0) >>> 0 < Q >>> 0 ? I + 1 | 0 : I, t = Ig(k, 0, Q << 1 & -2, 1 & (n << 1 | Q >>> 31)), I = w + r | 0, l = KI((a = t + a | 0) ^ p, (D = a >>> 0 < t >>> 0 ? I + 1 | 0 : I) ^ e, 32), X = I = w, S = I, k = (p = E[i + 384 >> 2]) + (r = E[i + 128 >> 2]) | 0, I = (P = E[i + 388 >> 2]) + (e = E[i + 132 >> 2]) | 0, t = r >>> 0 > k >>> 0 ? I + 1 | 0 : I, e = Ig(r << 1 & -2, 1 & (e << 1 | r >>> 31), p, 0), I = w + t | 0, t = (r = e + k | 0) >>> 0 < e >>> 0 ? I + 1 | 0 : I, N = (k = KI(E[i + 896 >> 2] ^ r, t ^ E[i + 900 >> 2], 32)) + (e = E[i + 640 >> 2]) | 0, I = (m = w) + (b = E[i + 644 >> 2]) | 0, K = e >>> 0 > N >>> 0 ? I + 1 | 0 : I, b = Ig(e << 1 & -2, 1 & (b << 1 | e >>> 31), k, 0), I = w + K | 0, b = KI(N = (e = b + N | 0) ^ p, P ^ (p = e >>> 0 < b >>> 0 ? I + 1 | 0 : I), 40), I = t + (P = w) | 0, K = (N = r + b | 0) >>> 0 < r >>> 0 ? I + 1 | 0 : I, t = Ig(b, 0, r << 1 & -2, 1 & (t << 1 | r >>> 31)), I = w + K | 0, K = KI(N = (r = t + N | 0) ^ k, m ^ (k = t >>> 0 > r >>> 0 ? I + 1 | 0 : I), 48), I = p + (m = w) | 0, t = (N = e + K | 0) >>> 0 < e >>> 0 ? I + 1 | 0 : I, p = Ig(K, 0, e << 1 & -2, 1 & (p << 1 | e >>> 31)), I = w + t | 0, I = (p = (e = p + N | 0) >>> 0 < p >>> 0 ? I + 1 | 0 : I) + S | 0, S = (t = e + l | 0) >>> 0 < e >>> 0 ? I + 1 | 0 : I, N = Ig(l, 0, e << 1 & -2, 1 & (p << 1 | e >>> 31)), I = w + S | 0, S = KI(S = (t = N + t | 0) ^ M, v ^ (M = t >>> 0 < N >>> 0 ? I + 1 | 0 : I), 40), I = D + (v = w) | 0, N = (u = a + S | 0) >>> 0 < a >>> 0 ? I + 1 | 0 : I, a = (D = Ig(S, 0, a << 1 & -2, 1 & (D << 1 | a >>> 31))) + u | 0, I = w + N | 0, E[i >> 2] = a, I = a >>> 0 < D >>> 0 ? I + 1 | 0 : I, E[i + 4 >> 2] = I, a = KI(a ^ l, I ^ X, 48), E[i + 904 >> 2] = a, I = w, E[i + 908 >> 2] = I, I = I + M | 0, D = (l = a + t | 0) >>> 0 < t >>> 0 ? I + 1 | 0 : I, a = (t = Ig(a, 0, t << 1 & -2, 1 & (M << 1 | t >>> 31))) + l | 0, I = w + D | 0, E[i + 640 >> 2] = a, I = a >>> 0 < t >>> 0 ? I + 1 | 0 : I, E[i + 644 >> 2] = I, V = i, Z = KI(a ^ S, I ^ v, 1), E[V + 264 >> 2] = Z, E[i + 268 >> 2] = w, I = s + z | 0, a = (t = o + Y | 0) >>> 0 < o >>> 0 ? I + 1 | 0 : I, o = Ig(Y, 0, o << 1 & -2, 1 & (s << 1 | o >>> 31)), I = w + a | 0, a = I = o >>> 0 > (t = o + t | 0) >>> 0 ? I + 1 | 0 : I, o = I, e = KI(e ^ b, p ^ P, 1), I = y + (p = w) | 0, s = (D = B + e | 0) >>> 0 < B >>> 0 ? I + 1 | 0 : I, B = (y = Ig(e, 0, B << 1 & -2, 1 & (y << 1 | B >>> 31))) + D | 0, I = w + s | 0, n = KI(Q ^ U, n ^ L, 48), y = KI(n ^ B, (Q = B >>> 0 < y >>> 0 ? I + 1 | 0 : I) ^ (M = w), 32), I = (Y = w) + o | 0, s = y >>> 0 > (D = y + t | 0) >>> 0 ? I + 1 | 0 : I, o = (I = D) + (D = Ig(t << 1 & -2, 1 & (o << 1 | t >>> 31), y, 0)) | 0, I = w + s | 0, s = KI(N = o ^ e, p ^ (e = o >>> 0 < D >>> 0 ? I + 1 | 0 : I), 40), I = Q + (D = w) | 0, p = (U = B + s | 0) >>> 0 < B >>> 0 ? I + 1 | 0 : I, B = Ig(s, 0, B << 1 & -2, 1 & (Q << 1 | B >>> 31)), I = w + p | 0, B = KI((Q = B + U | 0) ^ y, Y ^ (I = B >>> 0 > Q >>> 0 ? I + 1 | 0 : I), 48), E[i + 768 >> 2] = B, y = w, E[i + 772 >> 2] = y, E[i + 8 >> 2] = Q, E[i + 12 >> 2] = I, I = e + y | 0, Q = (y = B + o | 0) >>> 0 < o >>> 0 ? I + 1 | 0 : I, o = Ig(B, 0, o << 1 & -2, 1 & (e << 1 | o >>> 31)), I = w + Q | 0, V = i, Z = KI((B = o + y | 0) ^ s, (I = B >>> 0 < o >>> 0 ? I + 1 | 0 : I) ^ D, 1), E[V + 384 >> 2] = Z, E[i + 388 >> 2] = w, E[i + 648 >> 2] = B, E[i + 652 >> 2] = I, e = KI(t ^ x, a ^ G, 1), I = k + (s = w) | 0, o = (B = r + e | 0) >>> 0 < r >>> 0 ? I + 1 | 0 : I, Q = Ig(e, 0, r << 1 & -2, 1 & (k << 1 | r >>> 31)), I = w + o | 0, t = KI((B = Q + B | 0) ^ R, j ^ (a = B >>> 0 < Q >>> 0 ? I + 1 | 0 : I), 32), y = I = w, Q = I, I = f + M | 0, r = (o = c + n | 0) >>> 0 < c >>> 0 ? I + 1 | 0 : I, c = Ig(n, 0, c << 1 & -2, 1 & (f << 1 | c >>> 31)), I = w + r | 0, I = (c = (o = c + o | 0) >>> 0 < c >>> 0 ? I + 1 | 0 : I) + Q | 0, r = (Q = o + t | 0) >>> 0 < o >>> 0 ? I + 1 | 0 : I, f = Ig(t, 0, o << 1 & -2, 1 & (c << 1 | o >>> 31)), I = w + r | 0, e = KI((Q = f + Q | 0) ^ e, s ^ (r = Q >>> 0 < f >>> 0 ? I + 1 | 0 : I), 40), I = a + (f = w) | 0, s = (n = B + e | 0) >>> 0 < B >>> 0 ? I + 1 | 0 : I, B = (a = Ig(e, 0, B << 1 & -2, 1 & (a << 1 | B >>> 31))) + n | 0, I = w + s | 0, E[i + 128 >> 2] = B, I = B >>> 0 < a >>> 0 ? I + 1 | 0 : I, E[i + 132 >> 2] = I, B = KI(B ^ t, I ^ y, 48), E[i + 776 >> 2] = B, I = w, E[i + 780 >> 2] = I, I = I + r | 0, a = (t = B + Q | 0) >>> 0 < Q >>> 0 ? I + 1 | 0 : I, Q = Ig(B, 0, Q << 1 & -2, 1 & (r << 1 | Q >>> 31)), I = w + a | 0, r = B = Q + t | 0, t = I = B >>> 0 < Q >>> 0 ? I + 1 | 0 : I, E[i + 512 >> 2] = B, E[i + 516 >> 2] = I, c = KI(o ^ J, c ^ q, 1), I = (y = w) + H | 0, o = (B = c + F | 0) >>> 0 < c >>> 0 ? I + 1 | 0 : I, Q = Ig(F << 1 & -2, 1 & (H << 1 | F >>> 31), c, 0), I = w + o | 0, a = KI((B = Q + B | 0) ^ K, m ^ (Q = B >>> 0 < Q >>> 0 ? I + 1 | 0 : I), 32), I = d + (F = w) | 0, s = (o = a + _ | 0) >>> 0 < _ >>> 0 ? I + 1 | 0 : I, _ = Ig(a, 0, _ << 1 & -2, 1 & (d << 1 | _ >>> 31)), I = w + s | 0, c = KI((o = _ + o | 0) ^ c, y ^ (_ = o >>> 0 < _ >>> 0 ? I + 1 | 0 : I), 40), I = Q + (H = w) | 0, s = (y = B + c | 0) >>> 0 < B >>> 0 ? I + 1 | 0 : I, Q = Ig(c, 0, B << 1 & -2, 1 & (Q << 1 | B >>> 31)), I = w + s | 0, I = (B = Q + y | 0) >>> 0 < Q >>> 0 ? I + 1 | 0 : I, Q = B, B ^= a, a = I, B = KI(B, F ^ I, 48), I = _ + (F = w) | 0, s = (y = B + o | 0) >>> 0 < o >>> 0 ? I + 1 | 0 : I, o = (_ = Ig(B, 0, o << 1 & -2, 1 & (_ << 1 | o >>> 31))) + y | 0, I = w + s | 0, E[i + 520 >> 2] = o, I = o >>> 0 < _ >>> 0 ? I + 1 | 0 : I, E[i + 524 >> 2] = I, E[i + 896 >> 2] = B, E[i + 900 >> 2] = F, E[i + 136 >> 2] = Q, E[i + 140 >> 2] = a, V = i, Z = KI(r ^ e, t ^ f, 1), E[V + 392 >> 2] = Z, E[i + 396 >> 2] = w, V = i, Z = KI(o ^ c, I ^ H, 1), E[V + 256 >> 2] = Z, E[i + 260 >> 2] = w, 8 != (0 | (A = A + 1 | 0)););
                                        for(I = Sg(g, C, 1024), A = 0; B = E[(i = (g = A << 3) + I | 0) >> 2], Q = E[(_ = (o = a = C + 1024 | 0) + g | 0) >> 2], _ = E[i + 4 >> 2] ^ E[_ + 4 >> 2], E[i >> 2] = B ^ Q, E[i + 4 >> 2] = _, _ = E[(i = (B = 8 | g) + I | 0) >> 2], o = E[(B = B + o | 0) >> 2], B = E[i + 4 >> 2] ^ E[B + 4 >> 2], E[i >> 2] = o ^ _, E[i + 4 >> 2] = B, o = E[(i = (B = 16 | g) + I | 0) >> 2], _ = E[(B = B + a | 0) >> 2], B = E[i + 4 >> 2] ^ E[B + 4 >> 2], E[i >> 2] = o ^ _, E[i + 4 >> 2] = B, B = E[(g = (i = 24 | g) + I | 0) >> 2], o = E[(i = i + a | 0) >> 2], i = E[g + 4 >> 2] ^ E[i + 4 >> 2], E[g >> 2] = B ^ o, E[g + 4 >> 2] = i, 128 != (0 | (A = A + 4 | 0)););
                                        h = C + 2048 | 0;
                                    }
                                    function M(A, I, g) {
                                        var C, B, Q, i, o, _, c, t, r, e, y, s, D, p, w = 0, f = 0, n = 0, k = 0, F = 0, N = 0, S = 0, G = 0, M = 0, b = 0, K = 0;
                                        for(h = C = h - 800 | 0, k = a[I + 4 | 0] | a[I + 5 | 0] << 8 | a[I + 6 | 0] << 16 | a[I + 7 | 0] << 24, N = a[I + 8 | 0] | a[I + 9 | 0] << 8 | a[I + 10 | 0] << 16 | a[I + 11 | 0] << 24, G = a[I + 12 | 0] | a[I + 13 | 0] << 8 | a[I + 14 | 0] << 16 | a[I + 15 | 0] << 24, M = a[I + 16 | 0] | a[I + 17 | 0] << 8 | a[I + 18 | 0] << 16 | a[I + 19 | 0] << 24, f = a[I + 20 | 0] | a[I + 21 | 0] << 8 | a[I + 22 | 0] << 16 | a[I + 23 | 0] << 24, b = a[I + 24 | 0] | a[I + 25 | 0] << 8 | a[I + 26 | 0] << 16 | a[I + 27 | 0] << 24, K = a[I + 28 | 0] | a[I + 29 | 0] << 8 | a[I + 30 | 0] << 16 | a[I + 31 | 0] << 24, Q = a[A + 4 | 0] | a[A + 5 | 0] << 8 | a[A + 6 | 0] << 16 | a[A + 7 | 0] << 24, i = a[A + 8 | 0] | a[A + 9 | 0] << 8 | a[A + 10 | 0] << 16 | a[A + 11 | 0] << 24, o = a[A + 12 | 0] | a[A + 13 | 0] << 8 | a[A + 14 | 0] << 16 | a[A + 15 | 0] << 24, _ = a[A + 16 | 0] | a[A + 17 | 0] << 8 | a[A + 18 | 0] << 16 | a[A + 19 | 0] << 24, c = a[A + 20 | 0] | a[A + 21 | 0] << 8 | a[A + 22 | 0] << 16 | a[A + 23 | 0] << 24, t = a[A + 24 | 0] | a[A + 25 | 0] << 8 | a[A + 26 | 0] << 16 | a[A + 27 | 0] << 24, r = a[A + 28 | 0] | a[A + 29 | 0] << 8 | a[A + 30 | 0] << 16 | a[A + 31 | 0] << 24, n = a[0 | I] | a[I + 1 | 0] << 8 | a[I + 2 | 0] << 16 | a[I + 3 | 0] << 24, I = g - -64 | 0, e = a[0 | A] | a[A + 1 | 0] << 8 | a[A + 2 | 0] << 16 | a[A + 3 | 0] << 24, E[I >> 2] = 33620224 ^ e, E[g + 56 >> 2] = 1496785429, E[g + 60 >> 2] = 1652156816, E[(A = g + 48 | 0) >> 2] = 33620224, E[A + 4 >> 2] = 218629379, E[g + 40 >> 2] = 1110511904, E[g + 44 >> 2] = -584534669, E[(B = g + 32 | 0) >> 2] = 1427652059, E[B + 4 >> 2] = -248528275, y = n ^ e, E[g >> 2] = y, E[g + 92 >> 2] = -584534669 ^ r, E[g + 88 >> 2] = 1110511904 ^ t, E[g + 84 >> 2] = -248528275 ^ c, E[(n = g + 80 | 0) >> 2] = 1427652059 ^ _, E[g + 76 >> 2] = 1652156816 ^ o, E[g + 72 >> 2] = 1496785429 ^ i, E[g + 68 >> 2] = 218629379 ^ Q, K ^= r, E[g + 28 >> 2] = K, b ^= t, E[g + 24 >> 2] = b, s = f ^ c, E[g + 20 >> 2] = s, M ^= _, E[(f = g + 16 | 0) >> 2] = M, G ^= o, E[g + 12 >> 2] = G, D = N ^ i, E[g + 8 >> 2] = D, p = k ^ Q, E[g + 4 >> 2] = p, N = 0; k = E[n + 12 >> 2], E[C + 792 >> 2] = E[n + 8 >> 2], E[C + 796 >> 2] = k, k = E[n + 4 >> 2], E[C + 784 >> 2] = E[n >> 2], E[C + 788 >> 2] = k, k = E[I + 12 >> 2], E[C + 760 >> 2] = E[I + 8 >> 2], E[C + 764 >> 2] = k, k = E[I + 4 >> 2], E[C + 752 >> 2] = E[I >> 2], E[C + 756 >> 2] = k, k = E[n + 12 >> 2], E[C + 744 >> 2] = E[n + 8 >> 2], E[C + 748 >> 2] = k, k = E[n + 4 >> 2], E[C + 736 >> 2] = E[n >> 2], E[C + 740 >> 2] = k, $A(k = C + 768 | 0, C + 752 | 0, C + 736 | 0), w = E[C + 780 >> 2], E[n + 8 >> 2] = E[C + 776 >> 2], E[n + 12 >> 2] = w, w = E[C + 772 >> 2], E[n >> 2] = E[C + 768 >> 2], E[n + 4 >> 2] = w, w = E[A + 12 >> 2], E[C + 728 >> 2] = E[A + 8 >> 2], E[C + 732 >> 2] = w, w = E[A + 4 >> 2], E[C + 720 >> 2] = E[A >> 2], E[C + 724 >> 2] = w, w = E[I + 12 >> 2], E[C + 712 >> 2] = E[I + 8 >> 2], E[C + 716 >> 2] = w, w = E[I + 4 >> 2], E[C + 704 >> 2] = E[I >> 2], E[C + 708 >> 2] = w, $A(k, C + 720 | 0, C + 704 | 0), w = E[C + 780 >> 2], E[I + 8 >> 2] = E[C + 776 >> 2], E[I + 12 >> 2] = w, w = E[C + 772 >> 2], E[I >> 2] = E[C + 768 >> 2], E[I + 4 >> 2] = w, w = E[B + 12 >> 2], E[C + 696 >> 2] = E[B + 8 >> 2], E[C + 700 >> 2] = w, w = E[B + 4 >> 2], E[C + 688 >> 2] = E[B >> 2], E[C + 692 >> 2] = w, w = E[A + 12 >> 2], E[C + 680 >> 2] = E[A + 8 >> 2], E[C + 684 >> 2] = w, w = E[A + 4 >> 2], E[C + 672 >> 2] = E[A >> 2], E[C + 676 >> 2] = w, $A(k, C + 688 | 0, C + 672 | 0), w = E[C + 780 >> 2], E[A + 8 >> 2] = E[C + 776 >> 2], E[A + 12 >> 2] = w, w = E[C + 772 >> 2], E[A >> 2] = E[C + 768 >> 2], E[A + 4 >> 2] = w, w = E[f + 12 >> 2], E[C + 664 >> 2] = E[f + 8 >> 2], E[C + 668 >> 2] = w, w = E[f + 4 >> 2], E[C + 656 >> 2] = E[f >> 2], E[C + 660 >> 2] = w, w = E[B + 12 >> 2], E[C + 648 >> 2] = E[B + 8 >> 2], E[C + 652 >> 2] = w, w = E[B + 4 >> 2], E[C + 640 >> 2] = E[B >> 2], E[C + 644 >> 2] = w, $A(k, C + 656 | 0, C + 640 | 0), w = E[C + 780 >> 2], E[B + 8 >> 2] = E[C + 776 >> 2], E[B + 12 >> 2] = w, w = E[C + 772 >> 2], E[B >> 2] = E[C + 768 >> 2], E[B + 4 >> 2] = w, w = E[g + 12 >> 2], E[C + 632 >> 2] = E[g + 8 >> 2], E[C + 636 >> 2] = w, w = E[g + 4 >> 2], E[C + 624 >> 2] = E[g >> 2], E[C + 628 >> 2] = w, w = E[f + 12 >> 2], E[C + 616 >> 2] = E[f + 8 >> 2], E[C + 620 >> 2] = w, w = E[f + 4 >> 2], E[C + 608 >> 2] = E[f >> 2], E[C + 612 >> 2] = w, $A(k, C + 624 | 0, C + 608 | 0), w = E[C + 780 >> 2], E[f + 8 >> 2] = E[C + 776 >> 2], E[f + 12 >> 2] = w, w = E[C + 772 >> 2], E[f >> 2] = E[C + 768 >> 2], E[f + 4 >> 2] = w, w = E[C + 796 >> 2], E[C + 600 >> 2] = E[C + 792 >> 2], E[C + 604 >> 2] = w, w = E[C + 788 >> 2], E[C + 592 >> 2] = E[C + 784 >> 2], E[C + 596 >> 2] = w, w = E[g + 12 >> 2], E[C + 584 >> 2] = E[g + 8 >> 2], E[C + 588 >> 2] = w, w = E[g + 4 >> 2], E[C + 576 >> 2] = E[g >> 2], E[C + 580 >> 2] = w, $A(k, C + 592 | 0, C + 576 | 0), w = E[C + 768 >> 2], F = E[C + 772 >> 2], S = E[C + 776 >> 2], E[g + 12 >> 2] = E[C + 780 >> 2] ^ o, E[g + 8 >> 2] = S ^ i, E[g + 4 >> 2] = F ^ Q, E[g >> 2] = w ^ e, w = E[n + 12 >> 2], E[C + 792 >> 2] = E[n + 8 >> 2], E[C + 796 >> 2] = w, w = E[n + 4 >> 2], E[C + 784 >> 2] = E[n >> 2], E[C + 788 >> 2] = w, w = E[I + 12 >> 2], E[C + 568 >> 2] = E[I + 8 >> 2], E[C + 572 >> 2] = w, w = E[I + 4 >> 2], E[C + 560 >> 2] = E[I >> 2], E[C + 564 >> 2] = w, w = E[n + 12 >> 2], E[C + 552 >> 2] = E[n + 8 >> 2], E[C + 556 >> 2] = w, w = E[n + 4 >> 2], E[C + 544 >> 2] = E[n >> 2], E[C + 548 >> 2] = w, $A(k, C + 560 | 0, C + 544 | 0), w = E[C + 780 >> 2], E[n + 8 >> 2] = E[C + 776 >> 2], E[n + 12 >> 2] = w, w = E[C + 772 >> 2], E[n >> 2] = E[C + 768 >> 2], E[n + 4 >> 2] = w, w = E[A + 12 >> 2], E[C + 536 >> 2] = E[A + 8 >> 2], E[C + 540 >> 2] = w, w = E[A + 4 >> 2], E[C + 528 >> 2] = E[A >> 2], E[C + 532 >> 2] = w, w = E[I + 12 >> 2], E[C + 520 >> 2] = E[I + 8 >> 2], E[C + 524 >> 2] = w, w = E[I + 4 >> 2], E[C + 512 >> 2] = E[I >> 2], E[C + 516 >> 2] = w, $A(k, C + 528 | 0, C + 512 | 0), w = E[C + 780 >> 2], E[I + 8 >> 2] = E[C + 776 >> 2], E[I + 12 >> 2] = w, w = E[C + 772 >> 2], E[I >> 2] = E[C + 768 >> 2], E[I + 4 >> 2] = w, w = E[B + 12 >> 2], E[C + 504 >> 2] = E[B + 8 >> 2], E[C + 508 >> 2] = w, w = E[B + 4 >> 2], E[C + 496 >> 2] = E[B >> 2], E[C + 500 >> 2] = w, w = E[A + 12 >> 2], E[C + 488 >> 2] = E[A + 8 >> 2], E[C + 492 >> 2] = w, w = E[A + 4 >> 2], E[C + 480 >> 2] = E[A >> 2], E[C + 484 >> 2] = w, $A(k, C + 496 | 0, C + 480 | 0), w = E[C + 780 >> 2], E[A + 8 >> 2] = E[C + 776 >> 2], E[A + 12 >> 2] = w, w = E[C + 772 >> 2], E[A >> 2] = E[C + 768 >> 2], E[A + 4 >> 2] = w, w = E[f + 12 >> 2], E[C + 472 >> 2] = E[f + 8 >> 2], E[C + 476 >> 2] = w, w = E[f + 4 >> 2], E[C + 464 >> 2] = E[f >> 2], E[C + 468 >> 2] = w, w = E[B + 12 >> 2], E[C + 456 >> 2] = E[B + 8 >> 2], E[C + 460 >> 2] = w, w = E[B + 4 >> 2], E[C + 448 >> 2] = E[B >> 2], E[C + 452 >> 2] = w, $A(k, C + 464 | 0, C + 448 | 0), w = E[C + 780 >> 2], E[B + 8 >> 2] = E[C + 776 >> 2], E[B + 12 >> 2] = w, w = E[C + 772 >> 2], E[B >> 2] = E[C + 768 >> 2], E[B + 4 >> 2] = w, w = E[g + 12 >> 2], E[C + 440 >> 2] = E[g + 8 >> 2], E[C + 444 >> 2] = w, w = E[g + 4 >> 2], E[C + 432 >> 2] = E[g >> 2], E[C + 436 >> 2] = w, w = E[f + 12 >> 2], E[C + 424 >> 2] = E[f + 8 >> 2], E[C + 428 >> 2] = w, w = E[f + 4 >> 2], E[C + 416 >> 2] = E[f >> 2], E[C + 420 >> 2] = w, $A(k, C + 432 | 0, C + 416 | 0), w = E[C + 780 >> 2], E[f + 8 >> 2] = E[C + 776 >> 2], E[f + 12 >> 2] = w, w = E[C + 772 >> 2], E[f >> 2] = E[C + 768 >> 2], E[f + 4 >> 2] = w, w = E[C + 796 >> 2], E[C + 408 >> 2] = E[C + 792 >> 2], E[C + 412 >> 2] = w, w = E[C + 788 >> 2], E[C + 400 >> 2] = E[C + 784 >> 2], E[C + 404 >> 2] = w, w = E[g + 12 >> 2], E[C + 392 >> 2] = E[g + 8 >> 2], E[C + 396 >> 2] = w, w = E[g + 4 >> 2], E[C + 384 >> 2] = E[g >> 2], E[C + 388 >> 2] = w, $A(k, C + 400 | 0, C + 384 | 0), w = E[C + 768 >> 2], F = E[C + 772 >> 2], S = E[C + 776 >> 2], E[g + 12 >> 2] = E[C + 780 >> 2] ^ r, E[g + 8 >> 2] = S ^ t, E[g + 4 >> 2] = F ^ c, E[g >> 2] = w ^ _, w = E[n + 12 >> 2], E[C + 792 >> 2] = E[n + 8 >> 2], E[C + 796 >> 2] = w, w = E[n + 4 >> 2], E[C + 784 >> 2] = E[n >> 2], E[C + 788 >> 2] = w, w = E[I + 12 >> 2], E[C + 376 >> 2] = E[I + 8 >> 2], E[C + 380 >> 2] = w, w = E[I + 4 >> 2], E[C + 368 >> 2] = E[I >> 2], E[C + 372 >> 2] = w, w = E[n + 12 >> 2], E[C + 360 >> 2] = E[n + 8 >> 2], E[C + 364 >> 2] = w, w = E[n + 4 >> 2], E[C + 352 >> 2] = E[n >> 2], E[C + 356 >> 2] = w, $A(k, C + 368 | 0, C + 352 | 0), w = E[C + 780 >> 2], E[n + 8 >> 2] = E[C + 776 >> 2], E[n + 12 >> 2] = w, w = E[C + 772 >> 2], E[n >> 2] = E[C + 768 >> 2], E[n + 4 >> 2] = w, w = E[A + 12 >> 2], E[C + 344 >> 2] = E[A + 8 >> 2], E[C + 348 >> 2] = w, w = E[A + 4 >> 2], E[C + 336 >> 2] = E[A >> 2], E[C + 340 >> 2] = w, w = E[I + 12 >> 2], E[C + 328 >> 2] = E[I + 8 >> 2], E[C + 332 >> 2] = w, w = E[I + 4 >> 2], E[C + 320 >> 2] = E[I >> 2], E[C + 324 >> 2] = w, $A(k, C + 336 | 0, C + 320 | 0), w = E[C + 780 >> 2], E[I + 8 >> 2] = E[C + 776 >> 2], E[I + 12 >> 2] = w, w = E[C + 772 >> 2], E[I >> 2] = E[C + 768 >> 2], E[I + 4 >> 2] = w, w = E[B + 12 >> 2], E[C + 312 >> 2] = E[B + 8 >> 2], E[C + 316 >> 2] = w, w = E[B + 4 >> 2], E[C + 304 >> 2] = E[B >> 2], E[C + 308 >> 2] = w, w = E[A + 12 >> 2], E[C + 296 >> 2] = E[A + 8 >> 2], E[C + 300 >> 2] = w, w = E[A + 4 >> 2], E[C + 288 >> 2] = E[A >> 2], E[C + 292 >> 2] = w, $A(k, C + 304 | 0, C + 288 | 0), w = E[C + 780 >> 2], E[A + 8 >> 2] = E[C + 776 >> 2], E[A + 12 >> 2] = w, w = E[C + 772 >> 2], E[A >> 2] = E[C + 768 >> 2], E[A + 4 >> 2] = w, w = E[f + 12 >> 2], E[C + 280 >> 2] = E[f + 8 >> 2], E[C + 284 >> 2] = w, w = E[f + 4 >> 2], E[C + 272 >> 2] = E[f >> 2], E[C + 276 >> 2] = w, w = E[B + 12 >> 2], E[C + 264 >> 2] = E[B + 8 >> 2], E[C + 268 >> 2] = w, w = E[B + 4 >> 2], E[C + 256 >> 2] = E[B >> 2], E[C + 260 >> 2] = w, $A(k, C + 272 | 0, C + 256 | 0), w = E[C + 780 >> 2], E[B + 8 >> 2] = E[C + 776 >> 2], E[B + 12 >> 2] = w, w = E[C + 772 >> 2], E[B >> 2] = E[C + 768 >> 2], E[B + 4 >> 2] = w, w = E[g + 12 >> 2], E[C + 248 >> 2] = E[g + 8 >> 2], E[C + 252 >> 2] = w, w = E[g + 4 >> 2], E[C + 240 >> 2] = E[g >> 2], E[C + 244 >> 2] = w, w = E[f + 12 >> 2], E[C + 232 >> 2] = E[f + 8 >> 2], E[C + 236 >> 2] = w, w = E[f + 4 >> 2], E[C + 224 >> 2] = E[f >> 2], E[C + 228 >> 2] = w, $A(k, C + 240 | 0, C + 224 | 0), w = E[C + 780 >> 2], E[f + 8 >> 2] = E[C + 776 >> 2], E[f + 12 >> 2] = w, w = E[C + 772 >> 2], E[f >> 2] = E[C + 768 >> 2], E[f + 4 >> 2] = w, w = E[C + 796 >> 2], E[C + 216 >> 2] = E[C + 792 >> 2], E[C + 220 >> 2] = w, w = E[C + 788 >> 2], E[C + 208 >> 2] = E[C + 784 >> 2], E[C + 212 >> 2] = w, w = E[g + 12 >> 2], E[C + 200 >> 2] = E[g + 8 >> 2], E[C + 204 >> 2] = w, w = E[g + 4 >> 2], E[C + 192 >> 2] = E[g >> 2], E[C + 196 >> 2] = w, $A(k, C + 208 | 0, C + 192 | 0), w = E[C + 768 >> 2], F = E[C + 772 >> 2], S = E[C + 776 >> 2], E[g + 12 >> 2] = G ^ E[C + 780 >> 2], E[g + 8 >> 2] = S ^ D, E[g + 4 >> 2] = F ^ p, E[g >> 2] = w ^ y, w = E[n + 12 >> 2], E[C + 792 >> 2] = E[n + 8 >> 2], E[C + 796 >> 2] = w, w = E[n + 4 >> 2], E[C + 784 >> 2] = E[n >> 2], E[C + 788 >> 2] = w, w = E[I + 12 >> 2], E[C + 184 >> 2] = E[I + 8 >> 2], E[C + 188 >> 2] = w, w = E[I + 4 >> 2], E[C + 176 >> 2] = E[I >> 2], E[C + 180 >> 2] = w, w = E[n + 12 >> 2], E[C + 168 >> 2] = E[n + 8 >> 2], E[C + 172 >> 2] = w, w = E[n + 4 >> 2], E[C + 160 >> 2] = E[n >> 2], E[C + 164 >> 2] = w, $A(k, C + 176 | 0, C + 160 | 0), w = E[C + 780 >> 2], E[n + 8 >> 2] = E[C + 776 >> 2], E[n + 12 >> 2] = w, w = E[C + 772 >> 2], E[n >> 2] = E[C + 768 >> 2], E[n + 4 >> 2] = w, w = E[A + 12 >> 2], E[C + 152 >> 2] = E[A + 8 >> 2], E[C + 156 >> 2] = w, w = E[A + 4 >> 2], E[C + 144 >> 2] = E[A >> 2], E[C + 148 >> 2] = w, w = E[I + 12 >> 2], E[C + 136 >> 2] = E[I + 8 >> 2], E[C + 140 >> 2] = w, w = E[I + 4 >> 2], E[C + 128 >> 2] = E[I >> 2], E[C + 132 >> 2] = w, $A(k, C + 144 | 0, C + 128 | 0), w = E[C + 780 >> 2], E[I + 8 >> 2] = E[C + 776 >> 2], E[I + 12 >> 2] = w, w = E[C + 772 >> 2], E[I >> 2] = E[C + 768 >> 2], E[I + 4 >> 2] = w, w = E[B + 12 >> 2], E[C + 120 >> 2] = E[B + 8 >> 2], E[C + 124 >> 2] = w, w = E[B + 4 >> 2], E[C + 112 >> 2] = E[B >> 2], E[C + 116 >> 2] = w, w = E[A + 12 >> 2], E[C + 104 >> 2] = E[A + 8 >> 2], E[C + 108 >> 2] = w, w = E[A + 4 >> 2], E[C + 96 >> 2] = E[A >> 2], E[C + 100 >> 2] = w, $A(k, C + 112 | 0, C + 96 | 0), w = E[C + 780 >> 2], E[A + 8 >> 2] = E[C + 776 >> 2], E[A + 12 >> 2] = w, w = E[C + 772 >> 2], E[A >> 2] = E[C + 768 >> 2], E[A + 4 >> 2] = w, w = E[f + 12 >> 2], E[C + 88 >> 2] = E[f + 8 >> 2], E[C + 92 >> 2] = w, w = E[f + 4 >> 2], E[C + 80 >> 2] = E[f >> 2], E[C + 84 >> 2] = w, w = E[B + 12 >> 2], E[C + 72 >> 2] = E[B + 8 >> 2], E[C + 76 >> 2] = w, w = E[B + 4 >> 2], E[C + 64 >> 2] = E[B >> 2], E[C + 68 >> 2] = w, $A(k, C + 80 | 0, C - -64 | 0), w = E[C + 780 >> 2], E[B + 8 >> 2] = E[C + 776 >> 2], E[B + 12 >> 2] = w, w = E[C + 772 >> 2], E[B >> 2] = E[C + 768 >> 2], E[B + 4 >> 2] = w, w = E[g + 12 >> 2], E[C + 56 >> 2] = E[g + 8 >> 2], E[C + 60 >> 2] = w, w = E[g + 4 >> 2], E[C + 48 >> 2] = E[g >> 2], E[C + 52 >> 2] = w, w = E[f + 12 >> 2], E[C + 40 >> 2] = E[f + 8 >> 2], E[C + 44 >> 2] = w, w = E[f + 4 >> 2], E[C + 32 >> 2] = E[f >> 2], E[C + 36 >> 2] = w, $A(k, C + 48 | 0, C + 32 | 0), w = E[C + 780 >> 2], E[f + 8 >> 2] = E[C + 776 >> 2], E[f + 12 >> 2] = w, w = E[C + 772 >> 2], E[f >> 2] = E[C + 768 >> 2], E[f + 4 >> 2] = w, w = E[C + 796 >> 2], E[C + 24 >> 2] = E[C + 792 >> 2], E[C + 28 >> 2] = w, w = E[C + 788 >> 2], E[C + 16 >> 2] = E[C + 784 >> 2], E[C + 20 >> 2] = w, w = E[g + 12 >> 2], E[C + 8 >> 2] = E[g + 8 >> 2], E[C + 12 >> 2] = w, w = E[g + 4 >> 2], E[C >> 2] = E[g >> 2], E[C + 4 >> 2] = w, $A(k, C + 16 | 0, C), k = E[C + 768 >> 2], w = E[C + 772 >> 2], F = E[C + 776 >> 2], E[g + 12 >> 2] = K ^ E[C + 780 >> 2], E[g + 8 >> 2] = F ^ b, E[g + 4 >> 2] = w ^ s, E[g >> 2] = k ^ M, 4 != (0 | (N = N + 1 | 0)););
                                        h = C + 800 | 0;
                                    }
                                    function b(A, I) {
                                        var g, C, B, i, _, c, t, r, e, s, D, p, f, n, k, F, N, S, G, M, b, K, H = 0, d = 0, J = 0, U = 0, l = 0, m = 0, u = 0, x = 0, L = 0, P = 0, q = 0, z = 0, j = 0, X = 0, O = 0, V = 0, Z = 0, W = 0;
                                        for(h = g = h - 48 | 0, J = a[I + 28 | 0] | a[I + 29 | 0] << 8 | a[I + 30 | 0] << 16 | a[I + 31 | 0] << 24, d = a[I + 24 | 0] | a[I + 25 | 0] << 8 | a[I + 26 | 0] << 16 | a[I + 27 | 0] << 24, o[A + 24 | 0] = d, o[A + 25 | 0] = d >>> 8, o[A + 26 | 0] = d >>> 16, o[A + 27 | 0] = d >>> 24, o[A + 28 | 0] = J, o[A + 29 | 0] = J >>> 8, o[A + 30 | 0] = J >>> 16, o[A + 31 | 0] = J >>> 24, J = a[I + 4 | 0] | a[I + 5 | 0] << 8 | a[I + 6 | 0] << 16 | a[I + 7 | 0] << 24, d = a[0 | I] | a[I + 1 | 0] << 8 | a[I + 2 | 0] << 16 | a[I + 3 | 0] << 24, o[0 | A] = d, o[A + 1 | 0] = d >>> 8, o[A + 2 | 0] = d >>> 16, o[A + 3 | 0] = d >>> 24, o[A + 4 | 0] = J, o[A + 5 | 0] = J >>> 8, o[A + 6 | 0] = J >>> 16, o[A + 7 | 0] = J >>> 24, J = a[I + 20 | 0] | a[I + 21 | 0] << 8 | a[I + 22 | 0] << 16 | a[I + 23 | 0] << 24, d = a[I + 16 | 0] | a[I + 17 | 0] << 8 | a[I + 18 | 0] << 16 | a[I + 19 | 0] << 24, o[A + 16 | 0] = d, o[A + 17 | 0] = d >>> 8, o[A + 18 | 0] = d >>> 16, o[A + 19 | 0] = d >>> 24, o[A + 20 | 0] = J, o[A + 21 | 0] = J >>> 8, o[A + 22 | 0] = J >>> 16, o[A + 23 | 0] = J >>> 24, d = a[I + 12 | 0] | a[I + 13 | 0] << 8 | a[I + 14 | 0] << 16 | a[I + 15 | 0] << 24, I = a[I + 8 | 0] | a[I + 9 | 0] << 8 | a[I + 10 | 0] << 16 | a[I + 11 | 0] << 24, o[A + 8 | 0] = I, o[A + 9 | 0] = I >>> 8, o[A + 10 | 0] = I >>> 16, o[A + 11 | 0] = I >>> 24, o[A + 12 | 0] = d, o[A + 13 | 0] = d >>> 8, o[A + 14 | 0] = d >>> 16, o[A + 15 | 0] = d >>> 24, I = a[A + 31 | 0], o[A + 31 | 0] = 127 & I, pA(g, A), s = 128 & I, h = I = h - 960 | 0, R(d = I + 304 | 0, g), E[I + 304 >> 2] = E[I + 304 >> 2] + 1, vA(d, d), J = Ig(d = E[I + 340 >> 2], d >> 31, 486662, 0), d = w, u = (q = J + 16777216 | 0) >>> 0 < 16777216 ? d + 1 | 0 : d, L = J - (-33554432 & q) | 0, H = Ig(d = E[I + 336 >> 2], d >> 31, 486662, 0), J = w, U = Ig(d = E[I + 332 >> 2], d >> 31, 486662, 0), d = w, x = H, H = (H = (d = (m = U + 16777216 | 0) >>> 0 < 16777216 ? d + 1 | 0 : d) >> 25) + J | 0, d = (d = (33554431 & d) << 7 | m >>> 25) >>> 0 > (l = x + d | 0) >>> 0 ? H + 1 | 0 : H, C = ((67108863 & (d = (J = l + 33554432 | 0) >>> 0 < 33554432 ? d + 1 | 0 : d)) << 6 | J >>> 26) + L | 0, E[I + 292 >> 2] = 0 - C, Z = l - (-67108864 & J) | 0, E[I + 288 >> 2] = 0 - Z, L = U - (-33554432 & m) | 0, J = Ig(d = E[I + 328 >> 2], d >> 31, 486662, 0), d = w, m = Ig(H = E[I + 324 >> 2], H >> 31, 486662, 0), H = w, x = J, d = d + (J = (H = (l = m + 16777216 | 0) >>> 0 < 16777216 ? H + 1 | 0 : H) >> 25) | 0, d = (H = x + (U = (33554431 & H) << 7 | l >>> 25) | 0) >>> 0 < U >>> 0 ? d + 1 | 0 : d, B = ((67108863 & (d = (J = H + 33554432 | 0) >>> 0 < 33554432 ? d + 1 | 0 : d)) << 6 | J >>> 26) + L | 0, E[I + 284 >> 2] = 0 - B, i = H - (-67108864 & J) | 0, E[I + 280 >> 2] = 0 - i, L = m - (-33554432 & l) | 0, H = Ig(d = E[I + 320 >> 2], d >> 31, 486662, 0), d = w, m = Ig(J = E[I + 316 >> 2], J >> 31, 486662, 0), J = w, x = H, d = (H = (J = (l = m + 16777216 | 0) >>> 0 < 16777216 ? J + 1 | 0 : J) >> 25) + d | 0, H = d = (J = x + (U = (33554431 & J) << 7 | l >>> 25) | 0) >>> 0 < U >>> 0 ? d + 1 | 0 : d, _ = ((67108863 & (H = (U = J + 33554432 | 0) >>> 0 < 33554432 ? H + 1 | 0 : H)) << 6 | U >>> 26) + L | 0, E[I + 276 >> 2] = 0 - _, c = J - (-67108864 & U) | 0, E[I + 272 >> 2] = 0 - c, x = m - (-33554432 & l) | 0, d = Ig(d = E[I + 312 >> 2], d >> 31, 486662, 0), L = w, U = Ig(J = E[I + 308 >> 2], J >> 31, 486662, 0), H = w, J = (33554431 & (H = (m = U + 16777216 | 0) >>> 0 < 16777216 ? H + 1 | 0 : H)) << 7 | m >>> 25, H = (H >> 25) + L | 0, J = J >>> 0 > (l = J + d | 0) >>> 0 ? H + 1 | 0 : H, t = ((67108863 & (J = (d = l + 33554432 | 0) >>> 0 < 33554432 ? J + 1 | 0 : J)) << 6 | d >>> 26) + x | 0, E[I + 268 >> 2] = 0 - t, r = l - (-67108864 & d) | 0, E[I + 264 >> 2] = 0 - r, l = U - (-33554432 & m) | 0, J = Ig((33554431 & u) << 7 | q >>> 25, u >> 25, 19, 0), d = w, U = J, J = Ig(H = E[I + 304 >> 2], H >> 31, 486662, 0), d = w + d | 0, J = (H = U + J | 0) >>> 0 < J >>> 0 ? d + 1 | 0 : d, e = ((67108863 & (J = (d = H + 33554432 | 0) >>> 0 < 33554432 ? J + 1 | 0 : J)) << 6 | d >>> 26) + l | 0, E[I + 260 >> 2] = 0 - e, P = H - (-67108864 & d) | 0, E[I + 256 >> 2] = 0 - P, v(J = I + 208 | 0, d = I + 256 | 0), Y(I + 160 | 0, d, J), D = E[I + 196 >> 2], p = E[I + 160 >> 2], z = E[I + 208 >> 2], f = E[I + 164 >> 2], n = E[I + 168 >> 2], j = E[I + 212 >> 2], X = E[I + 216 >> 2], k = E[I + 172 >> 2], F = E[I + 176 >> 2], O = E[I + 220 >> 2], V = E[I + 224 >> 2], N = E[I + 180 >> 2], S = E[I + 184 >> 2], x = E[I + 228 >> 2], L = E[I + 232 >> 2], G = E[I + 188 >> 2], M = E[I + 192 >> 2], J = Ig(d = E[I + 244 >> 2], d >> 31, 486662, 0), d = w, u = (q = J + 16777216 | 0) >>> 0 < 16777216 ? d + 1 | 0 : d, b = J - (-33554432 & q) | 0, d = Ig(d = E[I + 240 >> 2], d >> 31, 486662, 0), K = w, U = Ig(J = E[I + 236 >> 2], J >> 31, 486662, 0), H = w, J = d, d = (33554431 & (H = (m = U + 16777216 | 0) >>> 0 < 16777216 ? H + 1 | 0 : H)) << 7 | m >>> 25, H = (H >> 25) + K | 0, d = d >>> 0 > (l = J + d | 0) >>> 0 ? H + 1 | 0 : H, H = ((67108863 & (d = (J = l + 33554432 | 0) >>> 0 < 33554432 ? d + 1 | 0 : d)) << 6 | J >>> 26) + b | 0, E[I + 244 >> 2] = H, E[I + 388 >> 2] = H + (D - C | 0), d = l - (-67108864 & J) | 0, E[I + 240 >> 2] = d, E[I + 384 >> 2] = d + (M - Z | 0), Z = U - (-33554432 & m) | 0, d = Ig(L, L >> 31, 486662, 0), U = w, m = Ig(x, x >> 31, 486662, 0), J = w, x = d, d = (d = (J = (l = m + 16777216 | 0) >>> 0 < 16777216 ? J + 1 | 0 : J) >> 25) + U | 0, H = d = (H = (33554431 & J) << 7 | l >>> 25) >>> 0 > (J = x + H | 0) >>> 0 ? d + 1 | 0 : d, U = ((67108863 & (H = (U = J + 33554432 | 0) >>> 0 < 33554432 ? H + 1 | 0 : H)) << 6 | (d = U) >>> 26) + Z | 0, E[I + 236 >> 2] = U, E[I + 380 >> 2] = U + (G - B | 0), d = J - (-67108864 & d) | 0, E[I + 232 >> 2] = d, E[I + 376 >> 2] = d + (S - i | 0), L = m - (-33554432 & l) | 0, H = Ig(V, V >> 31, 486662, 0), J = w, U = Ig(O, O >> 31, 486662, 0), d = w, x = H, H = (H = (d = (m = U + 16777216 | 0) >>> 0 < 16777216 ? d + 1 | 0 : d) >> 25) + J | 0, J = (d = (33554431 & d) << 7 | m >>> 25) >>> 0 > (l = x + d | 0) >>> 0 ? H + 1 | 0 : H, H = ((67108863 & (J = (d = l + 33554432 | 0) >>> 0 < 33554432 ? J + 1 | 0 : J)) << 6 | d >>> 26) + L | 0, E[I + 228 >> 2] = H, E[I + 372 >> 2] = H + (N - _ | 0), d = l - (-67108864 & d) | 0, E[I + 224 >> 2] = d, E[I + 368 >> 2] = d + (F - c | 0), L = U - (-33554432 & m) | 0, d = Ig(X, X >> 31, 486662, 0), J = w, m = Ig(j, j >> 31, 486662, 0), H = w, x = d, J = (d = (H = (l = m + 16777216 | 0) >>> 0 < 16777216 ? H + 1 | 0 : H) >> 25) + J | 0, d = J = (H = x + (U = (33554431 & H) << 7 | l >>> 25) | 0) >>> 0 < U >>> 0 ? J + 1 | 0 : J, U = ((67108863 & (d = (U = H + 33554432 | 0) >>> 0 < 33554432 ? d + 1 | 0 : d)) << 6 | (J = U) >>> 26) + L | 0, E[I + 220 >> 2] = U, E[I + 364 >> 2] = U + (k - t | 0), d = H - (-67108864 & J) | 0, E[I + 216 >> 2] = d, E[I + 360 >> 2] = d + (n - r | 0), l = m - (-33554432 & l) | 0, J = Ig((33554431 & u) << 7 | q >>> 25, u >> 25, 19, 0), d = w, H = J, J = Ig(z, z >> 31, 486662, 0), d = w + d | 0, d = (H = H + J | 0) >>> 0 < J >>> 0 ? d + 1 | 0 : d, u = ((67108863 & (d = (J = H + 33554432 | 0) >>> 0 < 33554432 ? d + 1 | 0 : d)) << 6 | J >>> 26) + l | 0, E[I + 212 >> 2] = u, E[I + 356 >> 2] = u + (f - e | 0), d = H - (-67108864 & J) | 0, E[I + 208 >> 2] = d, E[I + 352 >> 2] = d + (p - P | 0), Y(d = I + 624 | 0, J = I + 352 | 0, J), Y(I, J, d), v(J = I + 784 | 0, I), v(J, J), Y(d = I + 912 | 0, I, J), v(J = I + 576 | 0, d), v(J, J), v(J, J), v(J, J), Y(H = I + 528 | 0, d, J), v(H, H), v(H, H), Y(H, H, I), d = E[I + 564 >> 2], E[I + 512 >> 2] = E[I + 560 >> 2], E[I + 516 >> 2] = d, d = E[I + 556 >> 2], E[I + 504 >> 2] = E[I + 552 >> 2], E[I + 508 >> 2] = d, d = E[I + 548 >> 2], E[I + 496 >> 2] = E[I + 544 >> 2], E[I + 500 >> 2] = d, d = E[I + 540 >> 2], E[I + 488 >> 2] = E[I + 536 >> 2], E[I + 492 >> 2] = d, d = E[I + 532 >> 2], E[I + 480 >> 2] = E[I + 528 >> 2], E[I + 484 >> 2] = d, v(H, H), v(H, H), v(H, H), v(H, H), v(H, H), v(H, H), v(H, H), v(H, H), v(H, H), v(H, H), Y(H, H, d = I + 480 | 0), v(H, H), v(H, H), v(H, H), v(H, H), v(H, H), v(H, H), v(H, H), v(H, H), v(H, H), v(H, H), Y(H, H, d), d = E[I + 564 >> 2], E[I + 464 >> 2] = E[I + 560 >> 2], E[I + 468 >> 2] = d, d = E[I + 556 >> 2], E[I + 456 >> 2] = E[I + 552 >> 2], E[I + 460 >> 2] = d, d = E[I + 548 >> 2], E[I + 448 >> 2] = E[I + 544 >> 2], E[I + 452 >> 2] = d, d = E[I + 540 >> 2], E[I + 440 >> 2] = E[I + 536 >> 2], E[I + 444 >> 2] = d, d = E[I + 532 >> 2], E[I + 432 >> 2] = E[I + 528 >> 2], E[I + 436 >> 2] = d, v(H, H), v(H, H), v(H, H), v(H, H), v(H, H), v(H, H), v(H, H), v(H, H), v(H, H), v(H, H), v(H, H), v(H, H), v(H, H), v(H, H), v(H, H), v(H, H), v(H, H), v(H, H), v(H, H), v(H, H), v(H, H), v(H, H), v(H, H), v(H, H), v(H, H), v(H, H), v(H, H), v(H, H), v(H, H), v(H, H), Y(H, H, J = I + 432 | 0), d = E[I + 564 >> 2], E[I + 464 >> 2] = E[I + 560 >> 2], E[I + 468 >> 2] = d, d = E[I + 556 >> 2], E[I + 456 >> 2] = E[I + 552 >> 2], E[I + 460 >> 2] = d, d = E[I + 548 >> 2], E[I + 448 >> 2] = E[I + 544 >> 2], E[I + 452 >> 2] = d, d = E[I + 540 >> 2], E[I + 440 >> 2] = E[I + 536 >> 2], E[I + 444 >> 2] = d, d = E[I + 532 >> 2], E[I + 432 >> 2] = E[I + 528 >> 2], E[I + 436 >> 2] = d, v(H, H), v(H, H), v(H, H), v(H, H), v(H, H), v(H, H), v(H, H), v(H, H), v(H, H), v(H, H), v(H, H), v(H, H), v(H, H), v(H, H), v(H, H), v(H, H), v(H, H), v(H, H), v(H, H), v(H, H), v(H, H), v(H, H), v(H, H), v(H, H), v(H, H), v(H, H), v(H, H), v(H, H), v(H, H), v(H, H), v(H, H), v(H, H), v(H, H), v(H, H), v(H, H), v(H, H), v(H, H), v(H, H), v(H, H), v(H, H), v(H, H), v(H, H), v(H, H), v(H, H), v(H, H), v(H, H), v(H, H), v(H, H), v(H, H), v(H, H), v(H, H), v(H, H), v(H, H), v(H, H), v(H, H), v(H, H), v(H, H), v(H, H), v(H, H), v(H, H), Y(H, H, J), d = E[I + 564 >> 2], E[I + 464 >> 2] = E[I + 560 >> 2], E[I + 468 >> 2] = d, d = E[I + 556 >> 2], E[I + 456 >> 2] = E[I + 552 >> 2], E[I + 460 >> 2] = d, d = E[I + 548 >> 2], E[I + 448 >> 2] = E[I + 544 >> 2], E[I + 452 >> 2] = d, d = E[I + 540 >> 2], E[I + 440 >> 2] = E[I + 536 >> 2], E[I + 444 >> 2] = d, d = E[I + 532 >> 2], E[I + 432 >> 2] = E[I + 528 >> 2], E[I + 436 >> 2] = d; v(d = I + 528 | 0, d), 120 != (0 | (W = W + 1 | 0)););
                                        Y(d, d, I + 432 | 0), v(d, d), v(d, d), v(d, d), v(d, d), v(d, d), v(d, d), v(d, d), v(d, d), v(d, d), v(d, d), Y(d, d, I + 480 | 0), v(d, d), v(d, d), v(d, d), Y(d, d, I), v(d, d), BI(I + 400 | 0, d), z = E[I + 256 >> 2], j = E[I + 260 >> 2], X = E[I + 264 >> 2], O = E[I + 268 >> 2], V = E[I + 272 >> 2], l = E[I + 276 >> 2], u = E[I + 280 >> 2], H = E[I + 284 >> 2], J = E[I + 288 >> 2], x = (P = 0 - (1 & o[I + 401 | 0]) | 0) & (0 - (d = E[I + 292 >> 2]) ^ d) ^ d, E[I + 660 >> 2] = x, L = J ^ P & (J ^ 0 - J), E[I + 656 >> 2] = L, q = H ^ P & (H ^ 0 - H), E[I + 652 >> 2] = q, U = u ^ P & (u ^ 0 - u), E[I + 648 >> 2] = U, m = l ^ P & (l ^ 0 - l), E[I + 644 >> 2] = m, l = V ^ P & (V ^ 0 - V), E[I + 640 >> 2] = l, u = O ^ P & (O ^ 0 - O), E[I + 636 >> 2] = u, H = X ^ P & (X ^ 0 - X), E[I + 632 >> 2] = H, J = j ^ P & (j ^ 0 - j), E[I + 628 >> 2] = J, d = (z ^ P & (z ^ 0 - z)) - (486662 & P) | 0, E[I + 624 >> 2] = d + 1, E[I + 820 >> 2] = x, E[I + 816 >> 2] = L, E[I + 812 >> 2] = q, E[I + 808 >> 2] = U, E[I + 804 >> 2] = m, E[I + 800 >> 2] = l, E[I + 796 >> 2] = u, E[I + 792 >> 2] = H, E[I + 788 >> 2] = J, E[I + 784 >> 2] = d - 1, vA(I, I + 624 | 0), Y(d = I + 912 | 0, I + 784 | 0, I), BI(A, d), o[A + 31 | 0] = a[A + 31 | 0] | s, bA(I, A) && (y(), Q()), d = E[I + 36 >> 2], E[I + 816 >> 2] = E[I + 32 >> 2], E[I + 820 >> 2] = d, d = E[I + 28 >> 2], E[I + 808 >> 2] = E[I + 24 >> 2], E[I + 812 >> 2] = d, d = E[I + 20 >> 2], E[I + 800 >> 2] = E[I + 16 >> 2], E[I + 804 >> 2] = d, d = E[I + 12 >> 2], E[I + 792 >> 2] = E[I + 8 >> 2], E[I + 796 >> 2] = d, d = E[I + 52 >> 2], E[I + 832 >> 2] = E[I + 48 >> 2], E[I + 836 >> 2] = d, d = E[I + 60 >> 2], E[I + 840 >> 2] = E[I + 56 >> 2], E[I + 844 >> 2] = d, d = E[4 + (J = I - -64 | 0) >> 2], E[I + 848 >> 2] = E[J >> 2], E[I + 852 >> 2] = d, d = E[I + 76 >> 2], E[I + 856 >> 2] = E[I + 72 >> 2], E[I + 860 >> 2] = d, d = E[I + 4 >> 2], E[I + 784 >> 2] = E[I >> 2], E[I + 788 >> 2] = d, d = E[I + 44 >> 2], E[I + 824 >> 2] = E[I + 40 >> 2], E[I + 828 >> 2] = d, d = E[I + 116 >> 2], E[I + 896 >> 2] = E[I + 112 >> 2], E[I + 900 >> 2] = d, d = E[I + 108 >> 2], E[I + 888 >> 2] = E[I + 104 >> 2], E[I + 892 >> 2] = d, d = E[I + 100 >> 2], E[I + 880 >> 2] = E[I + 96 >> 2], E[I + 884 >> 2] = d, d = E[I + 92 >> 2], E[I + 872 >> 2] = E[I + 88 >> 2], E[I + 876 >> 2] = d, d = E[I + 84 >> 2], E[I + 864 >> 2] = E[I + 80 >> 2], E[I + 868 >> 2] = d, KA(U = I + 624 | 0, m = I + 784 | 0), Y(m, U, l = I + 744 | 0), Y(J = I + 824 | 0, H = I + 664 | 0, u = I + 704 | 0), Y(d = I + 864 | 0, u, l), KA(U, m), Y(m, U, l), Y(J, H, u), Y(d, u, l), KA(U, m), Y(I, U, l), Y(J = I + 40 | 0, H, u), Y(d = I + 80 | 0, u, l), Y(I + 120 | 0, U, H), vA(U, d), Y(m, I, U), Y(d = I + 912 | 0, J, U), BI(A, d), BI(I + 576 | 0, m), o[A + 31 | 0] = a[A + 31 | 0] ^ a[I + 576 | 0] << 7, h = I + 960 | 0, h = g + 48 | 0;
                                    }
                                    function K(A) {
                                        var I, g = 0, C = 0, B = 0, Q = 0, i = 0, o = 0, c = 0, r = 0, e = 0, y = 0, s = 0, D = 0;
                                        h = I = h - 16 | 0;
                                        A: {
                                            I: {
                                                g: {
                                                    C: {
                                                        B: {
                                                            Q: {
                                                                i: {
                                                                    o: {
                                                                        E: {
                                                                            a: {
                                                                                _: {
                                                                                    c: {
                                                                                        t: {
                                                                                            r: {
                                                                                                if ((A |= 0) >>> 0 <= 244) {
                                                                                                    if (3 & (g = (o = E[9393]) >>> (C = (c = A >>> 0 < 11 ? 16 : A + 11 & -8) >>> 3 | 0) | 0)) {
                                                                                                        g = 37612 + (A = (C = C + (1 & (-1 ^ g)) | 0) << 3) | 0, B = E[A + 37620 >> 2], (0 | g) != (0 | (A = E[B + 8 >> 2])) ? (E[A + 12 >> 2] = g, E[g + 8 >> 2] = A) : (s = 37572, D = Lg(-2, C) & o, E[s >> 2] = D), A = B + 8 | 0, g = C << 3, E[B + 4 >> 2] = 3 | g, E[4 + (g = g + B | 0) >> 2] = 1 | E[g + 4 >> 2];
                                                                                                        break A;
                                                                                                    }
                                                                                                    if ((y = E[9395]) >>> 0 >= c >>> 0) break r;
                                                                                                    if (g) {
                                                                                                        g = 37612 + (A = (B = FC((0 - (A = 2 << C) | A) & g << C)) << 3) | 0, Q = E[A + 37620 >> 2], (0 | g) != (0 | (A = E[Q + 8 >> 2])) ? (E[A + 12 >> 2] = g, E[g + 8 >> 2] = A) : (o = Lg(-2, B) & o, E[9393] = o), E[Q + 4 >> 2] = 3 | c, B = (A = B << 3) - c | 0, E[4 + (C = Q + c | 0) >> 2] = 1 | B, E[A + Q >> 2] = B, y && (g = 37612 + (-8 & y) | 0, i = E[9398], (A = 1 << (y >>> 3)) & o ? A = E[g + 8 >> 2] : (E[9393] = A | o, A = g), E[g + 8 >> 2] = i, E[A + 12 >> 2] = i, E[i + 12 >> 2] = g, E[i + 8 >> 2] = A), A = Q + 8 | 0, E[9398] = C, E[9395] = B;
                                                                                                        break A;
                                                                                                    }
                                                                                                    if (!(e = E[9394])) break r;
                                                                                                    for(C = E[37876 + (FC(e) << 2) >> 2], i = (-8 & E[C + 4 >> 2]) - c | 0, g = C; (A = E[g + 16 >> 2]) || (A = E[g + 20 >> 2]);)i = (B = (g = (-8 & E[A + 4 >> 2]) - c | 0) >>> 0 < i >>> 0) ? g : i, C = B ? A : C, g = A;
                                                                                                    if (r = E[C + 24 >> 2], (0 | (B = E[C + 12 >> 2])) != (0 | C)) {
                                                                                                        A = E[C + 8 >> 2], E[A + 12 >> 2] = B, E[B + 8 >> 2] = A;
                                                                                                        break I;
                                                                                                    }
                                                                                                    if (!(A = E[(g = C + 20 | 0) >> 2])) {
                                                                                                        if (!(A = E[C + 16 >> 2])) break t;
                                                                                                        g = C + 16 | 0;
                                                                                                    }
                                                                                                    for(; Q = g, B = A, (A = E[(g = A + 20 | 0) >> 2]) || (g = B + 16 | 0, A = E[B + 16 >> 2]););
                                                                                                    E[Q >> 2] = 0;
                                                                                                    break I;
                                                                                                }
                                                                                                if (c = -1, !(A >>> 0 > 4294967231) && (c = -8 & (A = A + 11 | 0), e = E[9394])) {
                                                                                                    i = 0 - c | 0, o = 0, c >>> 0 < 256 || (o = 31, c >>> 0 > 16777215 || (o = 62 + ((c >>> 38 - (A = t(A >>> 8 | 0)) & 1) - (A << 1) | 0) | 0));
                                                                                                    e: {
                                                                                                        y: {
                                                                                                            if (g = E[37876 + (o << 2) >> 2]) for(A = 0, C = c << (31 != (0 | o) ? 25 - (o >>> 1 | 0) | 0 : 0);;){
                                                                                                                if (!((Q = (-8 & E[g + 4 >> 2]) - c | 0) >>> 0 >= i >>> 0 || (B = g, i = Q, Q))) {
                                                                                                                    i = 0, A = g;
                                                                                                                    break y;
                                                                                                                }
                                                                                                                if (Q = E[g + 20 >> 2], g = E[16 + ((C >>> 29 & 4) + g | 0) >> 2], A = Q ? (0 | Q) == (0 | g) ? A : Q : A, C <<= 1, !g) break;
                                                                                                            }
                                                                                                            else A = 0;
                                                                                                            if (!(A | B)) {
                                                                                                                if (B = 0, !(A = (0 - (A = 2 << o) | A) & e)) break r;
                                                                                                                A = E[37876 + (FC(A) << 2) >> 2];
                                                                                                            }
                                                                                                            if (!A) break e;
                                                                                                        }
                                                                                                        for(; i = (C = (g = (-8 & E[A + 4 >> 2]) - c | 0) >>> 0 < i >>> 0) ? g : i, B = C ? A : B, A = (g = E[A + 16 >> 2]) || E[A + 20 >> 2];);
                                                                                                    }
                                                                                                    if (!(!B | E[9395] - c >>> 0 <= i >>> 0)) {
                                                                                                        if (o = E[B + 24 >> 2], (0 | B) != (0 | (C = E[B + 12 >> 2]))) {
                                                                                                            A = E[B + 8 >> 2], E[A + 12 >> 2] = C, E[C + 8 >> 2] = A;
                                                                                                            break g;
                                                                                                        }
                                                                                                        if (!(A = E[(g = B + 20 | 0) >> 2])) {
                                                                                                            if (!(A = E[B + 16 >> 2])) break c;
                                                                                                            g = B + 16 | 0;
                                                                                                        }
                                                                                                        for(; Q = g, C = A, (A = E[(g = A + 20 | 0) >> 2]) || (g = C + 16 | 0, A = E[C + 16 >> 2]););
                                                                                                        E[Q >> 2] = 0;
                                                                                                        break g;
                                                                                                    }
                                                                                                }
                                                                                            }
                                                                                            if ((A = E[9395]) >>> 0 >= c >>> 0) {
                                                                                                B = E[9398], (g = A - c | 0) >>> 0 >= 16 ? (E[4 + (C = B + c | 0) >> 2] = 1 | g, E[A + B >> 2] = g, E[B + 4 >> 2] = 3 | c) : (E[B + 4 >> 2] = 3 | A, E[4 + (A = A + B | 0) >> 2] = 1 | E[A + 4 >> 2], C = 0, g = 0), E[9395] = g, E[9398] = C, A = B + 8 | 0;
                                                                                                break A;
                                                                                            }
                                                                                            if ((r = E[9396]) >>> 0 > c >>> 0) {
                                                                                                g = r - c | 0, E[9396] = g, A = (C = E[9399]) + c | 0, E[9399] = A, E[A + 4 >> 2] = 1 | g, E[C + 4 >> 2] = 3 | c, A = C + 8 | 0;
                                                                                                break A;
                                                                                            }
                                                                                            if (A = 0, e = c + 47 | 0, E[9511] ? C = E[9513] : (E[9514] = -1, E[9515] = -1, E[9512] = 4096, E[9513] = 4096, E[9511] = I + 12 & -16 ^ 1431655768, E[9516] = 0, E[9504] = 0, C = 4096), (g = (Q = e + C | 0) & (i = 0 - C | 0)) >>> 0 <= c >>> 0) break A;
                                                                                            if ((B = E[9503]) && B >>> 0 < (o = (C = E[9501]) + g | 0) >>> 0 | C >>> 0 >= o >>> 0) break A;
                                                                                            r: {
                                                                                                if (!(4 & a[38016])) {
                                                                                                    e: {
                                                                                                        y: {
                                                                                                            s: {
                                                                                                                h: {
                                                                                                                    if (B = E[9399]) for(A = 38020;;){
                                                                                                                        if ((C = E[A >> 2]) >>> 0 <= B >>> 0 & B >>> 0 < C + E[A + 4 >> 2] >>> 0) break h;
                                                                                                                        if (!(A = E[A + 8 >> 2])) break;
                                                                                                                    }
                                                                                                                    if (-1 == (0 | (C = cg(0)))) break e;
                                                                                                                    if (o = g, (A = (B = E[9512]) - 1 | 0) & C && (o = (g - C | 0) + (A + C & 0 - B) | 0), o >>> 0 <= c >>> 0) break e;
                                                                                                                    if ((B = E[9503]) && B >>> 0 < (i = (A = E[9501]) + o | 0) >>> 0 | A >>> 0 >= i >>> 0) break e;
                                                                                                                    if ((0 | C) != (0 | (A = cg(o)))) break s;
                                                                                                                    break r;
                                                                                                                }
                                                                                                                if ((0 | (C = cg(o = i & Q - r))) == (E[A >> 2] + E[A + 4 >> 2] | 0)) break y;
                                                                                                                A = C;
                                                                                                            }
                                                                                                            if (-1 == (0 | A)) break e;
                                                                                                            if (c + 48 >>> 0 <= o >>> 0) {
                                                                                                                C = A;
                                                                                                                break r;
                                                                                                            }
                                                                                                            if (-1 == (0 | cg(C = (C = E[9513]) + (e - o | 0) & 0 - C))) break e;
                                                                                                            o = C + o | 0, C = A;
                                                                                                            break r;
                                                                                                        }
                                                                                                        if (-1 != (0 | C)) break r;
                                                                                                    }
                                                                                                    E[9504] = 4 | E[9504];
                                                                                                }
                                                                                                if (-1 == (0 | (C = cg(g))) | -1 == (0 | (A = cg(0))) | A >>> 0 <= C >>> 0) break E;
                                                                                                if ((o = A - C | 0) >>> 0 <= c + 40 >>> 0) break E;
                                                                                            }
                                                                                            A = E[9501] + o | 0, E[9501] = A, A >>> 0 > _[9502] && (E[9502] = A);
                                                                                            r: {
                                                                                                if (Q = E[9399]) {
                                                                                                    for(A = 38020;;){
                                                                                                        if (((B = E[A >> 2]) + (g = E[A + 4 >> 2]) | 0) == (0 | C)) break r;
                                                                                                        if (!(A = E[A + 8 >> 2])) break;
                                                                                                    }
                                                                                                    break _;
                                                                                                }
                                                                                                for((A = E[9397]) >>> 0 <= C >>> 0 && A || (E[9397] = C), A = 0, E[9506] = o, E[9505] = C, E[9401] = -1, E[9402] = E[9511], E[9508] = 0; g = 37612 + (B = A << 3) | 0, E[B + 37620 >> 2] = g, E[B + 37624 >> 2] = g, 32 != (0 | (A = A + 1 | 0)););
                                                                                                g = (B = o - 40 | 0) - (A = -8 - C & 7) | 0, E[9396] = g, A = A + C | 0, E[9399] = A, E[A + 4 >> 2] = 1 | g, E[4 + (C + B | 0) >> 2] = 40, E[9400] = E[9515];
                                                                                                break a;
                                                                                            }
                                                                                            if (8 & E[A + 12 >> 2] | C >>> 0 <= Q >>> 0 | B >>> 0 > Q >>> 0) break _;
                                                                                            E[A + 4 >> 2] = g + o, C = (A = -8 - Q & 7) + Q | 0, E[9399] = C, A = (g = E[9396] + o | 0) - A | 0, E[9396] = A, E[C + 4 >> 2] = 1 | A, E[4 + (g + Q | 0) >> 2] = 40, E[9400] = E[9515];
                                                                                            break a;
                                                                                        }
                                                                                        B = 0;
                                                                                        break I;
                                                                                    }
                                                                                    C = 0;
                                                                                    break g;
                                                                                }
                                                                                _[9397] > C >>> 0 && (E[9397] = C), g = C + o | 0, A = 38020;
                                                                                _: {
                                                                                    c: {
                                                                                        t: {
                                                                                            for(;;){
                                                                                                if ((0 | g) != E[A >> 2]) {
                                                                                                    if (A = E[A + 8 >> 2]) continue;
                                                                                                    break t;
                                                                                                }
                                                                                                break;
                                                                                            }
                                                                                            if (!(8 & a[A + 12 | 0])) break c;
                                                                                        }
                                                                                        for(A = 38020;;){
                                                                                            if ((g = E[A >> 2]) >>> 0 <= Q >>> 0 && (i = g + E[A + 4 >> 2] | 0) >>> 0 > Q >>> 0) break _;
                                                                                            A = E[A + 8 >> 2];
                                                                                        }
                                                                                    }
                                                                                    if (E[A >> 2] = C, E[A + 4 >> 2] = E[A + 4 >> 2] + o, E[4 + (e = (-8 - C & 7) + C | 0) >> 2] = 3 | c, A = (o = g + (-8 - g & 7) | 0) - (r = c + e | 0) | 0, (0 | Q) == (0 | o)) {
                                                                                        E[9399] = r, A = E[9396] + A | 0, E[9396] = A, E[r + 4 >> 2] = 1 | A;
                                                                                        break C;
                                                                                    }
                                                                                    if (E[9398] == (0 | o)) {
                                                                                        E[9398] = r, A = E[9395] + A | 0, E[9395] = A, E[r + 4 >> 2] = 1 | A, E[A + r >> 2] = A;
                                                                                        break C;
                                                                                    }
                                                                                    if (1 != (3 & (i = E[o + 4 >> 2]))) break B;
                                                                                    if (Q = -8 & i, i >>> 0 <= 255) {
                                                                                        if ((0 | (C = E[o + 12 >> 2])) == (0 | (g = E[o + 8 >> 2]))) {
                                                                                            s = 37572, D = E[9393] & Lg(-2, i >>> 3 | 0), E[s >> 2] = D;
                                                                                            break Q;
                                                                                        }
                                                                                        E[g + 12 >> 2] = C, E[C + 8 >> 2] = g;
                                                                                        break Q;
                                                                                    }
                                                                                    if (c = E[o + 24 >> 2], (0 | o) != (0 | (C = E[o + 12 >> 2]))) {
                                                                                        g = E[o + 8 >> 2], E[g + 12 >> 2] = C, E[C + 8 >> 2] = g;
                                                                                        break i;
                                                                                    }
                                                                                    if (!(i = E[(g = o + 20 | 0) >> 2])) {
                                                                                        if (!(i = E[o + 16 >> 2])) break o;
                                                                                        g = o + 16 | 0;
                                                                                    }
                                                                                    for(; B = g, (i = E[(g = (C = i) + 20 | 0) >> 2]) || (g = C + 16 | 0, i = E[C + 16 >> 2]););
                                                                                    E[B >> 2] = 0;
                                                                                    break i;
                                                                                }
                                                                                for(g = (B = o - 40 | 0) - (A = -8 - C & 7) | 0, E[9396] = g, A = A + C | 0, E[9399] = A, E[A + 4 >> 2] = 1 | g, E[4 + (C + B | 0) >> 2] = 40, E[9400] = E[9515], E[(B = (A = (i + (39 - i & 7) | 0) - 47 | 0) >>> 0 < Q + 16 >>> 0 ? Q : A) + 4 >> 2] = 27, A = E[9508], E[B + 16 >> 2] = E[9507], E[B + 20 >> 2] = A, A = E[9506], E[B + 8 >> 2] = E[9505], E[B + 12 >> 2] = A, E[9507] = B + 8, E[9506] = o, E[9505] = C, E[9508] = 0, A = B + 24 | 0; E[A + 4 >> 2] = 7, g = A + 8 | 0, A = A + 4 | 0, g >>> 0 < i >>> 0;);
                                                                                if ((0 | B) != (0 | Q)) {
                                                                                    if (E[B + 4 >> 2] = -2 & E[B + 4 >> 2], i = B - Q | 0, E[Q + 4 >> 2] = 1 | i, E[B >> 2] = i, i >>> 0 <= 255) g = 37612 + (-8 & i) | 0, (C = E[9393]) & (A = 1 << (i >>> 3)) ? A = E[g + 8 >> 2] : (E[9393] = A | C, A = g), E[g + 8 >> 2] = Q, E[A + 12 >> 2] = Q, E[Q + 12 >> 2] = g, E[Q + 8 >> 2] = A;
                                                                                    else {
                                                                                        A = 31, i >>> 0 <= 16777215 && (A = 62 + ((i >>> 38 - (A = t(i >>> 8 | 0)) & 1) - (A << 1) | 0) | 0), E[Q + 28 >> 2] = A, E[Q + 16 >> 2] = 0, E[Q + 20 >> 2] = 0, g = 37876 + (A << 2) | 0;
                                                                                        _: {
                                                                                            if ((B = E[9394]) & (C = 1 << A)) {
                                                                                                for(A = i << (31 != (0 | A) ? 25 - (A >>> 1 | 0) | 0 : 0), B = E[g >> 2];;){
                                                                                                    if ((0 | i) == (-8 & E[(g = B) + 4 >> 2])) break _;
                                                                                                    if (C = A >>> 29 | 0, A <<= 1, !(B = E[16 + (C = (4 & C) + g | 0) >> 2])) break;
                                                                                                }
                                                                                                E[C + 16 >> 2] = Q;
                                                                                            } else E[9394] = C | B, E[g >> 2] = Q;
                                                                                            E[Q + 24 >> 2] = g, E[Q + 12 >> 2] = Q, E[Q + 8 >> 2] = Q;
                                                                                            break a;
                                                                                        }
                                                                                        A = E[g + 8 >> 2], E[A + 12 >> 2] = Q, E[g + 8 >> 2] = Q, E[Q + 24 >> 2] = 0, E[Q + 12 >> 2] = g, E[Q + 8 >> 2] = A;
                                                                                    }
                                                                                }
                                                                            }
                                                                            if (!((A = E[9396]) >>> 0 <= c >>> 0)) {
                                                                                g = A - c | 0, E[9396] = g, A = (C = E[9399]) + c | 0, E[9399] = A, E[A + 4 >> 2] = 1 | g, E[C + 4 >> 2] = 3 | c, A = C + 8 | 0;
                                                                                break A;
                                                                            }
                                                                        }
                                                                        E[9392] = 48, A = 0;
                                                                        break A;
                                                                    }
                                                                    C = 0;
                                                                }
                                                                if (c) {
                                                                    B = E[o + 28 >> 2];
                                                                    i: {
                                                                        if (E[(g = 37876 + (B << 2) | 0) >> 2] == (0 | o)) {
                                                                            if (E[g >> 2] = C, C) break i;
                                                                            s = 37576, D = E[9394] & Lg(-2, B), E[s >> 2] = D;
                                                                            break Q;
                                                                        }
                                                                        if (E[c + (E[c + 16 >> 2] == (0 | o) ? 16 : 20) >> 2] = C, !C) break Q;
                                                                    }
                                                                    E[C + 24 >> 2] = c, (g = E[o + 16 >> 2]) && (E[C + 16 >> 2] = g, E[g + 24 >> 2] = C), (g = E[o + 20 >> 2]) && (E[C + 20 >> 2] = g, E[g + 24 >> 2] = C);
                                                                }
                                                            }
                                                            A = A + Q | 0, i = E[4 + (o = Q + o | 0) >> 2];
                                                        }
                                                        if (E[o + 4 >> 2] = -2 & i, E[r + 4 >> 2] = 1 | A, E[A + r >> 2] = A, A >>> 0 <= 255) g = 37612 + (-8 & A) | 0, (C = E[9393]) & (A = 1 << (A >>> 3)) ? A = E[g + 8 >> 2] : (E[9393] = A | C, A = g), E[g + 8 >> 2] = r, E[A + 12 >> 2] = r, E[r + 12 >> 2] = g, E[r + 8 >> 2] = A;
                                                        else {
                                                            i = 31, A >>> 0 <= 16777215 && (i = 62 + ((A >>> 38 - (g = t(A >>> 8 | 0)) & 1) - (g << 1) | 0) | 0), E[r + 28 >> 2] = i, E[r + 16 >> 2] = 0, E[r + 20 >> 2] = 0, g = 37876 + (i << 2) | 0;
                                                            B: {
                                                                if ((B = E[9394]) & (C = 1 << i)) {
                                                                    for(i = A << (31 != (0 | i) ? 25 - (i >>> 1 | 0) | 0 : 0), C = E[g >> 2];;){
                                                                        if (g = C, (-8 & E[C + 4 >> 2]) == (0 | A)) break B;
                                                                        if (B = i >>> 29 | 0, i <<= 1, !(C = E[16 + (B = (4 & B) + C | 0) >> 2])) break;
                                                                    }
                                                                    E[B + 16 >> 2] = r;
                                                                } else E[9394] = C | B, E[g >> 2] = r;
                                                                E[r + 24 >> 2] = g, E[r + 12 >> 2] = r, E[r + 8 >> 2] = r;
                                                                break C;
                                                            }
                                                            A = E[g + 8 >> 2], E[A + 12 >> 2] = r, E[g + 8 >> 2] = r, E[r + 24 >> 2] = 0, E[r + 12 >> 2] = g, E[r + 8 >> 2] = A;
                                                        }
                                                    }
                                                    A = e + 8 | 0;
                                                    break A;
                                                }
                                                g: if (o) {
                                                    g = E[B + 28 >> 2];
                                                    C: {
                                                        if (E[(A = 37876 + (g << 2) | 0) >> 2] == (0 | B)) {
                                                            if (E[A >> 2] = C, C) break C;
                                                            e = Lg(-2, g) & e, E[9394] = e;
                                                            break g;
                                                        }
                                                        if (E[o + (E[o + 16 >> 2] == (0 | B) ? 16 : 20) >> 2] = C, !C) break g;
                                                    }
                                                    E[C + 24 >> 2] = o, (A = E[B + 16 >> 2]) && (E[C + 16 >> 2] = A, E[A + 24 >> 2] = C), (A = E[B + 20 >> 2]) && (E[C + 20 >> 2] = A, E[A + 24 >> 2] = C);
                                                }
                                                g: if (i >>> 0 <= 15) A = i + c | 0, E[B + 4 >> 2] = 3 | A, E[4 + (A = A + B | 0) >> 2] = 1 | E[A + 4 >> 2];
                                                else if (E[B + 4 >> 2] = 3 | c, E[4 + (Q = B + c | 0) >> 2] = 1 | i, E[Q + i >> 2] = i, i >>> 0 <= 255) g = 37612 + (-8 & i) | 0, (C = E[9393]) & (A = 1 << (i >>> 3)) ? A = E[g + 8 >> 2] : (E[9393] = A | C, A = g), E[g + 8 >> 2] = Q, E[A + 12 >> 2] = Q, E[Q + 12 >> 2] = g, E[Q + 8 >> 2] = A;
                                                else {
                                                    A = 31, i >>> 0 <= 16777215 && (A = 62 + ((i >>> 38 - (A = t(i >>> 8 | 0)) & 1) - (A << 1) | 0) | 0), E[Q + 28 >> 2] = A, E[Q + 16 >> 2] = 0, E[Q + 20 >> 2] = 0, g = 37876 + (A << 2) | 0;
                                                    C: {
                                                        if ((C = 1 << A) & e) {
                                                            for(A = i << (31 != (0 | A) ? 25 - (A >>> 1 | 0) | 0 : 0), c = E[g >> 2];;){
                                                                if ((-8 & E[(g = c) + 4 >> 2]) == (0 | i)) break C;
                                                                if (C = A >>> 29 | 0, A <<= 1, !(c = E[16 + (C = (4 & C) + g | 0) >> 2])) break;
                                                            }
                                                            E[C + 16 >> 2] = Q;
                                                        } else E[9394] = C | e, E[g >> 2] = Q;
                                                        E[Q + 24 >> 2] = g, E[Q + 12 >> 2] = Q, E[Q + 8 >> 2] = Q;
                                                        break g;
                                                    }
                                                    A = E[g + 8 >> 2], E[A + 12 >> 2] = Q, E[g + 8 >> 2] = Q, E[Q + 24 >> 2] = 0, E[Q + 12 >> 2] = g, E[Q + 8 >> 2] = A;
                                                }
                                                A = B + 8 | 0;
                                                break A;
                                            }
                                            I: if (r) {
                                                g = E[C + 28 >> 2];
                                                g: {
                                                    if (E[(A = 37876 + (g << 2) | 0) >> 2] == (0 | C)) {
                                                        if (E[A >> 2] = B, B) break g;
                                                        s = 37576, D = Lg(-2, g) & e, E[s >> 2] = D;
                                                        break I;
                                                    }
                                                    if (E[r + (E[r + 16 >> 2] == (0 | C) ? 16 : 20) >> 2] = B, !B) break I;
                                                }
                                                E[B + 24 >> 2] = r, (A = E[C + 16 >> 2]) && (E[B + 16 >> 2] = A, E[A + 24 >> 2] = B), (A = E[C + 20 >> 2]) && (E[B + 20 >> 2] = A, E[A + 24 >> 2] = B);
                                            }
                                            i >>> 0 <= 15 ? (A = i + c | 0, E[C + 4 >> 2] = 3 | A, E[4 + (A = A + C | 0) >> 2] = 1 | E[A + 4 >> 2]) : (E[C + 4 >> 2] = 3 | c, E[4 + (B = C + c | 0) >> 2] = 1 | i, E[B + i >> 2] = i, y && (g = 37612 + (-8 & y) | 0, Q = E[9398], (A = 1 << (y >>> 3)) & o ? A = E[g + 8 >> 2] : (E[9393] = A | o, A = g), E[g + 8 >> 2] = Q, E[A + 12 >> 2] = Q, E[Q + 12 >> 2] = g, E[Q + 8 >> 2] = A), E[9398] = B, E[9395] = i), A = C + 8 | 0;
                                        }
                                        return h = I + 16 | 0, 0 | A;
                                    }
                                    function H(A, I, g, C, B, Q) {
                                        var i, _ = 0, t = 0, r = 0, e = 0, y = 0, s = 0, D = 0, p = 0, w = 0, f = 0, n = 0, k = 0, F = 0, S = 0, G = 0, M = 0, b = 0, K = 0, H = 0, d = 0, J = 0, U = 0, l = 0, m = 0, u = 0, x = 0, R = 0, v = 0, L = 0, P = 0, q = 0, j = 0, X = 0, O = 0, V = 0, Z = 0, W = 0, T = 0;
                                        if (h = i = h - 592 | 0, r = -1, ZI(t = A + 32 | 0) && !bI(A) && GI(B) && !bI(B) && !qA(y = i + 128 | 0, B)) {
                                            for(SI(r = i + 384 | 0), Q && nA(r, 35600, 34, 0), nA(r, A, 32, 0), nA(r, B, 32, 0), nA(r, I, g, C), z(I = r, r = i + 320 | 0), N(r), C = i + 8 | 0, g = t, B = 0, I = 0, h = _ = h - 2272 | 0; t = r + (B >>> 3 | 0) | 0, o[(Q = _ + 2016 | 0) + B | 0] = a[0 | t] >>> (6 & B) & 1, o[(e = Q) + (Q = 1 | B) | 0] = a[0 | t] >>> (7 & Q) & 1, 256 != (0 | (B = B + 2 | 0)););
                                            for(;;){
                                                I = (Q = I) + 1 | 0;
                                                A: if (!(Q >>> 0 > 254) && a[0 | (D = (B = _ + 2016 | 0) + Q | 0)]) {
                                                    I: if (B = o[0 | (s = I + B | 0)]) {
                                                        if ((0 | (B = (r = B << 1) + (t = o[0 | D]) | 0)) <= 15) o[0 | D] = B, o[0 | s] = 0;
                                                        else {
                                                            if ((0 | (B = t - r | 0)) < -15) break A;
                                                            for(o[0 | D] = B, B = I;;){
                                                                if (!a[0 | (t = (_ + 2016 | 0) + B | 0)]) {
                                                                    o[0 | t] = 1;
                                                                    break I;
                                                                }
                                                                if (o[0 | t] = 0, t = B >>> 0 < 255, B = B + 1 | 0, !t) break;
                                                            }
                                                        }
                                                    }
                                                    if (!(Q >>> 0 > 253)) {
                                                        I: if (t = o[0 | (e = (B = Q + 2 | 0) + (_ + 2016 | 0) | 0)]) {
                                                            if ((0 | (t = (s = t << 2) + (r = o[0 | D]) | 0)) >= 16) {
                                                                if ((0 | (t = r - s | 0)) < -15) break A;
                                                                for(o[0 | D] = t;;){
                                                                    if (a[0 | (t = (_ + 2016 | 0) + B | 0)]) {
                                                                        if (o[0 | t] = 0, t = B >>> 0 < 255, B = B + 1 | 0, t) continue;
                                                                        break I;
                                                                    }
                                                                    break;
                                                                }
                                                                o[0 | t] = 1;
                                                            } else o[0 | D] = t, o[0 | e] = 0;
                                                        }
                                                        if (!(Q >>> 0 > 252)) {
                                                            I: if (t = o[0 | (e = (B = Q + 3 | 0) + (_ + 2016 | 0) | 0)]) {
                                                                if ((0 | (t = (s = t << 3) + (r = o[0 | D]) | 0)) >= 16) {
                                                                    if ((0 | (t = r - s | 0)) < -15) break A;
                                                                    for(o[0 | D] = t;;){
                                                                        if (a[0 | (t = (_ + 2016 | 0) + B | 0)]) {
                                                                            if (o[0 | t] = 0, t = B >>> 0 < 255, B = B + 1 | 0, t) continue;
                                                                            break I;
                                                                        }
                                                                        break;
                                                                    }
                                                                    o[0 | t] = 1;
                                                                } else o[0 | D] = t, o[0 | e] = 0;
                                                            }
                                                            if (!(Q >>> 0 > 251)) {
                                                                I: if (t = o[0 | (e = (B = Q + 4 | 0) + (_ + 2016 | 0) | 0)]) {
                                                                    if ((0 | (t = (s = t << 4) + (r = o[0 | D]) | 0)) >= 16) {
                                                                        if ((0 | (t = r - s | 0)) < -15) break A;
                                                                        for(o[0 | D] = t;;){
                                                                            if (a[0 | (t = (_ + 2016 | 0) + B | 0)]) {
                                                                                if (o[0 | t] = 0, t = B >>> 0 < 255, B = B + 1 | 0, t) continue;
                                                                                break I;
                                                                            }
                                                                            break;
                                                                        }
                                                                        o[0 | t] = 1;
                                                                    } else o[0 | D] = t, o[0 | e] = 0;
                                                                }
                                                                if (!(Q >>> 0 > 250)) {
                                                                    I: if (t = o[0 | (e = (B = Q + 5 | 0) + (_ + 2016 | 0) | 0)]) {
                                                                        if ((0 | (t = (s = t << 5) + (r = o[0 | D]) | 0)) >= 16) {
                                                                            if ((0 | (t = r - s | 0)) < -15) break A;
                                                                            for(o[0 | D] = t;;){
                                                                                if (a[0 | (t = (_ + 2016 | 0) + B | 0)]) {
                                                                                    if (o[0 | t] = 0, t = B >>> 0 < 255, B = B + 1 | 0, t) continue;
                                                                                    break I;
                                                                                }
                                                                                break;
                                                                            }
                                                                            o[0 | t] = 1;
                                                                        } else o[0 | D] = t, o[0 | e] = 0;
                                                                    }
                                                                    if (!(Q >>> 0 > 249) && (Q = o[0 | (s = (B = Q + 6 | 0) + (_ + 2016 | 0) | 0)])) {
                                                                        if ((0 | (Q = (r = Q << 6) + (t = o[0 | D]) | 0)) >= 16) {
                                                                            if ((0 | (Q = t - r | 0)) < -15) break A;
                                                                            for(o[0 | D] = Q;;){
                                                                                if (a[0 | (Q = (_ + 2016 | 0) + B | 0)]) {
                                                                                    if (o[0 | Q] = 0, Q = B >>> 0 < 255, B = B + 1 | 0, Q) continue;
                                                                                    break A;
                                                                                }
                                                                                break;
                                                                            }
                                                                            o[0 | Q] = 1;
                                                                        } else o[0 | D] = Q, o[0 | s] = 0;
                                                                    }
                                                                }
                                                            }
                                                        }
                                                    }
                                                }
                                                if (256 == (0 | I)) break;
                                            }
                                            for(B = 0; Q = g + (B >>> 3 | 0) | 0, o[(I = _ + 1760 | 0) + B | 0] = a[0 | Q] >>> (6 & B) & 1, o[(t = I) + (I = 1 | B) | 0] = a[0 | Q] >>> (7 & I) & 1, 256 != (0 | (B = B + 2 | 0)););
                                            for(I = 0;;){
                                                g = I, I = I + 1 | 0;
                                                A: if (!(g >>> 0 > 254) && a[0 | (e = (B = _ + 1760 | 0) + g | 0)]) {
                                                    I: if (B = o[0 | (r = I + B | 0)]) {
                                                        if ((0 | (B = (t = B << 1) + (Q = o[0 | e]) | 0)) <= 15) o[0 | e] = B, o[0 | r] = 0;
                                                        else {
                                                            if ((0 | (B = Q - t | 0)) < -15) break A;
                                                            for(o[0 | e] = B, B = I;;){
                                                                if (!a[0 | (Q = (_ + 1760 | 0) + B | 0)]) {
                                                                    o[0 | Q] = 1;
                                                                    break I;
                                                                }
                                                                if (o[0 | Q] = 0, Q = B >>> 0 < 255, B = B + 1 | 0, !Q) break;
                                                            }
                                                        }
                                                    }
                                                    if (!(g >>> 0 > 253)) {
                                                        I: if (Q = o[0 | (s = (B = g + 2 | 0) + (_ + 1760 | 0) | 0)]) {
                                                            if ((0 | (Q = (r = Q << 2) + (t = o[0 | e]) | 0)) >= 16) {
                                                                if ((0 | (Q = t - r | 0)) < -15) break A;
                                                                for(o[0 | e] = Q;;){
                                                                    if (a[0 | (Q = (_ + 1760 | 0) + B | 0)]) {
                                                                        if (o[0 | Q] = 0, Q = B >>> 0 < 255, B = B + 1 | 0, Q) continue;
                                                                        break I;
                                                                    }
                                                                    break;
                                                                }
                                                                o[0 | Q] = 1;
                                                            } else o[0 | e] = Q, o[0 | s] = 0;
                                                        }
                                                        if (!(g >>> 0 > 252)) {
                                                            I: if (Q = o[0 | (s = (B = g + 3 | 0) + (_ + 1760 | 0) | 0)]) {
                                                                if ((0 | (Q = (r = Q << 3) + (t = o[0 | e]) | 0)) >= 16) {
                                                                    if ((0 | (Q = t - r | 0)) < -15) break A;
                                                                    for(o[0 | e] = Q;;){
                                                                        if (a[0 | (Q = (_ + 1760 | 0) + B | 0)]) {
                                                                            if (o[0 | Q] = 0, Q = B >>> 0 < 255, B = B + 1 | 0, Q) continue;
                                                                            break I;
                                                                        }
                                                                        break;
                                                                    }
                                                                    o[0 | Q] = 1;
                                                                } else o[0 | e] = Q, o[0 | s] = 0;
                                                            }
                                                            if (!(g >>> 0 > 251)) {
                                                                I: if (Q = o[0 | (s = (B = g + 4 | 0) + (_ + 1760 | 0) | 0)]) {
                                                                    if ((0 | (Q = (r = Q << 4) + (t = o[0 | e]) | 0)) >= 16) {
                                                                        if ((0 | (Q = t - r | 0)) < -15) break A;
                                                                        for(o[0 | e] = Q;;){
                                                                            if (a[0 | (Q = (_ + 1760 | 0) + B | 0)]) {
                                                                                if (o[0 | Q] = 0, Q = B >>> 0 < 255, B = B + 1 | 0, Q) continue;
                                                                                break I;
                                                                            }
                                                                            break;
                                                                        }
                                                                        o[0 | Q] = 1;
                                                                    } else o[0 | e] = Q, o[0 | s] = 0;
                                                                }
                                                                if (!(g >>> 0 > 250)) {
                                                                    I: if (Q = o[0 | (s = (B = g + 5 | 0) + (_ + 1760 | 0) | 0)]) {
                                                                        if ((0 | (Q = (r = Q << 5) + (t = o[0 | e]) | 0)) >= 16) {
                                                                            if ((0 | (Q = t - r | 0)) < -15) break A;
                                                                            for(o[0 | e] = Q;;){
                                                                                if (a[0 | (Q = (_ + 1760 | 0) + B | 0)]) {
                                                                                    if (o[0 | Q] = 0, Q = B >>> 0 < 255, B = B + 1 | 0, Q) continue;
                                                                                    break I;
                                                                                }
                                                                                break;
                                                                            }
                                                                            o[0 | Q] = 1;
                                                                        } else o[0 | e] = Q, o[0 | s] = 0;
                                                                    }
                                                                    if (!(g >>> 0 > 249) && (g = o[0 | (r = (B = g + 6 | 0) + (_ + 1760 | 0) | 0)])) {
                                                                        if ((0 | (g = (t = g << 6) + (Q = o[0 | e]) | 0)) >= 16) {
                                                                            if ((0 | (g = Q - t | 0)) < -15) break A;
                                                                            for(o[0 | e] = g;;){
                                                                                if (a[0 | (g = (_ + 1760 | 0) + B | 0)]) {
                                                                                    if (o[0 | g] = 0, g = B >>> 0 < 255, B = B + 1 | 0, g) continue;
                                                                                    break A;
                                                                                }
                                                                                break;
                                                                            }
                                                                            o[0 | g] = 1;
                                                                        } else o[0 | e] = g, o[0 | r] = 0;
                                                                    }
                                                                }
                                                            }
                                                        }
                                                    }
                                                }
                                                if (256 == (0 | I)) break;
                                            }
                                            for(TA(B = _ + 480 | 0, y), I = E[y + 36 >> 2], E[_ + 192 >> 2] = E[y + 32 >> 2], E[_ + 196 >> 2] = I, I = E[y + 28 >> 2], E[_ + 184 >> 2] = E[y + 24 >> 2], E[_ + 188 >> 2] = I, I = E[y + 20 >> 2], E[_ + 176 >> 2] = E[y + 16 >> 2], E[_ + 180 >> 2] = I, I = E[y + 12 >> 2], E[_ + 168 >> 2] = E[y + 8 >> 2], E[_ + 172 >> 2] = I, I = E[y + 4 >> 2], E[_ + 160 >> 2] = E[y >> 2], E[_ + 164 >> 2] = I, I = E[y + 52 >> 2], E[_ + 208 >> 2] = E[y + 48 >> 2], E[_ + 212 >> 2] = I, I = E[y + 60 >> 2], E[_ + 216 >> 2] = E[y + 56 >> 2], E[_ + 220 >> 2] = I, I = E[4 + (g = y - -64 | 0) >> 2], E[_ + 224 >> 2] = E[g >> 2], E[_ + 228 >> 2] = I, I = E[y + 76 >> 2], E[_ + 232 >> 2] = E[y + 72 >> 2], E[_ + 236 >> 2] = I, I = E[y + 44 >> 2], E[_ + 200 >> 2] = E[y + 40 >> 2], E[_ + 204 >> 2] = I, I = E[y + 92 >> 2], E[_ + 248 >> 2] = E[y + 88 >> 2], E[_ + 252 >> 2] = I, I = E[y + 100 >> 2], E[_ + 256 >> 2] = E[y + 96 >> 2], E[_ + 260 >> 2] = I, I = E[y + 108 >> 2], E[_ + 264 >> 2] = E[y + 104 >> 2], E[_ + 268 >> 2] = I, I = E[y + 116 >> 2], E[_ + 272 >> 2] = E[y + 112 >> 2], E[_ + 276 >> 2] = I, I = E[y + 84 >> 2], E[_ + 240 >> 2] = E[y + 80 >> 2], E[_ + 244 >> 2] = I, KA(Q = _ + 320 | 0, g = _ + 160 | 0), Y(_, Q, p = _ + 440 | 0), Y(_ + 40 | 0, w = _ + 360 | 0, f = _ + 400 | 0), Y(_ + 80 | 0, f, p), Y(_ + 120 | 0, Q, w), sA(Q, _, B), Y(g, Q, p), Y(k = _ + 200 | 0, w, f), Y(F = _ + 240 | 0, f, p), Y(n = _ + 280 | 0, Q, w), TA(I = _ + 640 | 0, g), sA(Q, _, I), Y(g, Q, p), Y(k, w, f), Y(F, f, p), Y(n, Q, w), TA(I = _ + 800 | 0, g), sA(Q, _, I), Y(g, Q, p), Y(k, w, f), Y(F, f, p), Y(n, Q, w), TA(I = _ + 960 | 0, g), sA(Q, _, I), Y(g, Q, p), Y(k, w, f), Y(F, f, p), Y(n, Q, w), TA(I = _ + 1120 | 0, g), sA(Q, _, I), Y(g, Q, p), Y(k, w, f), Y(F, f, p), Y(n, Q, w), TA(I = _ + 1280 | 0, g), sA(Q, _, I), Y(g, Q, p), Y(k, w, f), Y(F, f, p), Y(n, Q, w), TA(I = _ + 1440 | 0, g), sA(Q, _, I), Y(g, Q, p), Y(k, w, f), Y(F, f, p), Y(n, Q, w), TA(_ + 1600 | 0, g), E[C + 32 >> 2] = 0, E[C + 36 >> 2] = 0, E[C + 24 >> 2] = 0, E[C + 28 >> 2] = 0, E[C + 16 >> 2] = 0, E[C + 20 >> 2] = 0, E[C + 8 >> 2] = 0, E[C + 12 >> 2] = 0, E[C >> 2] = 0, E[C + 4 >> 2] = 0, E[C + 44 >> 2] = 0, E[C + 48 >> 2] = 0, E[(R = C + 40 | 0) >> 2] = 1, E[C + 52 >> 2] = 0, E[C + 56 >> 2] = 0, E[C + 60 >> 2] = 0, E[C + 64 >> 2] = 0, E[C + 68 >> 2] = 0, E[C + 72 >> 2] = 0, E[C + 84 >> 2] = 0, E[C + 88 >> 2] = 0, E[C + 76 >> 2] = 0, E[C + 80 >> 2] = 1, E[C + 92 >> 2] = 0, E[C + 96 >> 2] = 0, E[C + 100 >> 2] = 0, E[C + 104 >> 2] = 0, E[C + 108 >> 2] = 0, E[C + 112 >> 2] = 0, E[C + 116 >> 2] = 0, O = C + 80 | 0, I = 255;;){
                                                A: {
                                                    I: {
                                                        if (!a[(g = _ + 2016 | 0) + I | 0] && !a[(B = _ + 1760 | 0) + I | 0]) {
                                                            if (!(a[(Q = g) + (g = I - 1 | 0) | 0] | a[g + B | 0])) break I;
                                                            I = g;
                                                        }
                                                        if ((0 | I) < 0) break A;
                                                        for(; KA(B = _ + 320 | 0, C), g = I, (0 | (Q = o[I + (_ + 2016 | 0) | 0])) > 0 ? (Y(I = _ + 160 | 0, B, p), Y(k, w, f), Y(F, f, p), Y(n, B, w), sA(B, I, (_ + 480 | 0) + c((254 & Q) >>> 1 | 0, 160) | 0)) : (0 | Q) >= 0 || (Y(I = _ + 160 | 0, B = _ + 320 | 0, p), Y(k, w, f), Y(F, f, p), Y(n, B, w), hA(B, I, (_ + 480 | 0) + c((0 - Q & 254) >>> 1 | 0, 160) | 0)), (0 | (u = o[g + (_ + 1760 | 0) | 0])) > 0 ? (Y(I = _ + 160 | 0, B = _ + 320 | 0, p), Y(k, w, f), Y(F, f, p), Y(n, B, w), DA(B, I, c((254 & u) >>> 1 | 0, 120) + 1744 | 0)) : (0 | u) >= 0 || (Y(_ + 160 | 0, x = _ + 320 | 0, p), Y(k, w, f), Y(F, f, p), Y(n, x, w), S = E[_ + 160 >> 2], G = E[_ + 200 >> 2], M = E[_ + 164 >> 2], b = E[_ + 204 >> 2], K = E[_ + 168 >> 2], H = E[_ + 208 >> 2], d = E[_ + 172 >> 2], J = E[_ + 212 >> 2], U = E[_ + 176 >> 2], l = E[_ + 216 >> 2], m = E[_ + 180 >> 2], D = E[_ + 220 >> 2], e = E[_ + 184 >> 2], s = E[_ + 224 >> 2], r = E[_ + 188 >> 2], y = E[_ + 228 >> 2], t = E[_ + 192 >> 2], Q = E[_ + 232 >> 2], B = E[_ + 236 >> 2], I = E[_ + 196 >> 2], E[_ + 396 >> 2] = B - I, E[_ + 392 >> 2] = Q - t, E[_ + 388 >> 2] = y - r, E[_ + 384 >> 2] = s - e, E[_ + 380 >> 2] = D - m, E[_ + 376 >> 2] = l - U, E[_ + 372 >> 2] = J - d, E[_ + 368 >> 2] = H - K, E[_ + 364 >> 2] = b - M, E[_ + 360 >> 2] = G - S, E[_ + 356 >> 2] = I + B, E[_ + 352 >> 2] = Q + t, E[_ + 348 >> 2] = r + y, E[_ + 344 >> 2] = e + s, E[_ + 340 >> 2] = D + m, E[_ + 336 >> 2] = U + l, E[_ + 332 >> 2] = d + J, E[_ + 328 >> 2] = K + H, E[_ + 324 >> 2] = M + b, E[_ + 320 >> 2] = S + G, Y(f, x, 40 + (I = c((0 - u & 254) >>> 1 | 0, 120) + 1744 | 0) | 0), Y(w, w, I), Y(p, I + 80 | 0, n), V = E[_ + 276 >> 2], Z = E[_ + 272 >> 2], u = E[_ + 268 >> 2], x = E[_ + 264 >> 2], e = E[_ + 260 >> 2], s = E[_ + 256 >> 2], r = E[_ + 252 >> 2], y = E[_ + 248 >> 2], t = E[_ + 244 >> 2], Q = E[_ + 240 >> 2], v = E[_ + 360 >> 2], L = E[_ + 400 >> 2], P = E[_ + 364 >> 2], q = E[_ + 404 >> 2], j = E[_ + 368 >> 2], X = E[_ + 408 >> 2], S = E[_ + 372 >> 2], G = E[_ + 412 >> 2], M = E[_ + 376 >> 2], b = E[_ + 416 >> 2], K = E[_ + 380 >> 2], H = E[_ + 420 >> 2], d = E[_ + 384 >> 2], J = E[_ + 424 >> 2], U = E[_ + 388 >> 2], l = E[_ + 428 >> 2], m = E[_ + 392 >> 2], D = E[_ + 432 >> 2], B = E[_ + 396 >> 2], I = E[_ + 436 >> 2], E[_ + 396 >> 2] = B + I, E[_ + 392 >> 2] = D + m, E[_ + 388 >> 2] = U + l, E[_ + 384 >> 2] = d + J, E[_ + 380 >> 2] = K + H, E[_ + 376 >> 2] = M + b, E[_ + 372 >> 2] = S + G, E[_ + 368 >> 2] = j + X, E[_ + 364 >> 2] = P + q, E[_ + 360 >> 2] = v + L, E[_ + 356 >> 2] = I - B, E[_ + 352 >> 2] = D - m, E[_ + 348 >> 2] = l - U, E[_ + 344 >> 2] = J - d, E[_ + 340 >> 2] = H - K, E[_ + 336 >> 2] = b - M, E[_ + 332 >> 2] = G - S, E[_ + 328 >> 2] = X - j, E[_ + 324 >> 2] = q - P, E[_ + 320 >> 2] = L - v, S = Q << 1, G = E[_ + 440 >> 2], E[_ + 400 >> 2] = S - G, M = t << 1, b = E[_ + 444 >> 2], E[_ + 404 >> 2] = M - b, K = y << 1, H = E[_ + 448 >> 2], E[_ + 408 >> 2] = K - H, d = r << 1, J = E[_ + 452 >> 2], E[_ + 412 >> 2] = d - J, U = s << 1, l = E[_ + 456 >> 2], E[_ + 416 >> 2] = U - l, m = e << 1, D = E[_ + 460 >> 2], E[_ + 420 >> 2] = m - D, e = x << 1, s = E[_ + 464 >> 2], E[_ + 424 >> 2] = e - s, r = u << 1, y = E[_ + 468 >> 2], E[_ + 428 >> 2] = r - y, t = Z << 1, Q = E[_ + 472 >> 2], E[_ + 432 >> 2] = t - Q, B = V << 1, I = E[_ + 476 >> 2], E[_ + 436 >> 2] = B - I, E[_ + 440 >> 2] = S + G, E[_ + 444 >> 2] = M + b, E[_ + 448 >> 2] = K + H, E[_ + 452 >> 2] = d + J, E[_ + 456 >> 2] = U + l, E[_ + 460 >> 2] = D + m, E[_ + 464 >> 2] = e + s, E[_ + 468 >> 2] = r + y, E[_ + 472 >> 2] = Q + t, E[_ + 476 >> 2] = I + B), Y(C, _ + 320 | 0, p), Y(R, w, f), Y(O, f, p), I = g - 1 | 0, (0 | g) > 0;);
                                                        break A;
                                                    }
                                                    if (I = I - 2 | 0, g) continue;
                                                }
                                                break;
                                            }
                                            h = _ + 2272 | 0, tg(I = i + 288 | 0, C), W = -1, T = SC(I, A), r = ((0 | A) == (0 | I) ? W : T) | MI(A, I, 32);
                                        }
                                        return h = i + 592 | 0, r;
                                    }
                                    function Y(A, I, g) {
                                        var C, B, Q, i, o, a, _, t, r, e, y, s, h, D, p, f, n, k, F, N, S, G, M, b, K, H, Y, d, J, U, l, m, u, x, R, v, L, P, q, z, j, X, O, V, Z, W, T, $, AA, IA, gA, CA, BA, QA = 0, iA = 0, oA = 0, EA = 0, aA = 0, _A = 0, cA = 0, tA = 0, rA = 0, eA = 0, yA = 0, sA = 0, hA = 0, DA = 0, pA = 0, wA = 0, fA = 0, nA = 0, kA = 0, FA = 0, NA = 0, SA = 0, GA = 0, MA = 0, bA = 0;
                                        QA = Ig(C = E[g + 4 >> 2], e = C >> 31, fA = (f = E[I + 20 >> 2]) << 1, l = fA >> 31), oA = w, iA = (hA = Ig(pA = E[g >> 2], Q = pA >> 31, B = E[I + 24 >> 2], i = B >> 31)) + QA | 0, QA = w + oA | 0, QA = iA >>> 0 < hA >>> 0 ? QA + 1 | 0 : QA, rA = Ig(o = E[g + 8 >> 2], h = o >> 31, hA = E[I + 16 >> 2], a = hA >> 31), oA = w + QA | 0, oA = (iA = rA + iA | 0) >>> 0 < rA >>> 0 ? oA + 1 | 0 : oA, QA = (rA = Ig(y = E[g + 12 >> 2], n = y >> 31, b = (k = E[I + 12 >> 2]) << 1, m = b >> 31)) + iA | 0, iA = w + oA | 0, iA = QA >>> 0 < rA >>> 0 ? iA + 1 | 0 : iA, oA = (DA = Ig(D = E[g + 16 >> 2], K = D >> 31, rA = E[I + 8 >> 2], _ = rA >> 31)) + QA | 0, QA = w + iA | 0, QA = oA >>> 0 < DA >>> 0 ? QA + 1 | 0 : QA, iA = oA, oA = Ig(F = E[g + 20 >> 2], u = F >> 31, H = (N = E[I + 4 >> 2]) << 1, x = H >> 31), QA = w + QA | 0, QA = (iA = iA + oA | 0) >>> 0 < oA >>> 0 ? QA + 1 | 0 : QA, W = cA = E[g + 24 >> 2], oA = (eA = Ig(cA, V = cA >> 31, DA = E[I >> 2], t = DA >> 31)) + iA | 0, iA = w + QA | 0, iA = oA >>> 0 < eA >>> 0 ? iA + 1 | 0 : iA, R = E[g + 28 >> 2], QA = (eA = Ig(sA = c(R, 19), S = sA >> 31, Y = (G = E[I + 36 >> 2]) << 1, v = Y >> 31)) + oA | 0, oA = w + iA | 0, oA = QA >>> 0 < eA >>> 0 ? oA + 1 | 0 : oA, NA = E[g + 32 >> 2], iA = (tA = Ig(EA = c(NA, 19), p = EA >> 31, eA = E[I + 32 >> 2], r = eA >> 31)) + QA | 0, QA = w + oA | 0, QA = iA >>> 0 < tA >>> 0 ? QA + 1 | 0 : QA, T = E[g + 36 >> 2], g = Ig(tA = c(T, 19), s = tA >> 31, d = (M = E[I + 28 >> 2]) << 1, L = d >> 31), QA = w + QA | 0, aA = I = g + iA | 0, g = I >>> 0 < g >>> 0 ? QA + 1 | 0 : QA, I = Ig(hA, a, C, e), QA = w, iA = Ig(pA, Q, f, P = f >> 31), oA = w + QA | 0, oA = (I = iA + I | 0) >>> 0 < iA >>> 0 ? oA + 1 | 0 : oA, QA = Ig(o, h, k, q = k >> 31), iA = w + oA | 0, iA = (I = QA + I | 0) >>> 0 < QA >>> 0 ? iA + 1 | 0 : iA, oA = Ig(rA, _, y, n), QA = w + iA | 0, QA = (I = oA + I | 0) >>> 0 < oA >>> 0 ? QA + 1 | 0 : QA, iA = Ig(D, K, N, z = N >> 31), QA = w + QA | 0, QA = (I = iA + I | 0) >>> 0 < iA >>> 0 ? QA + 1 | 0 : QA, iA = Ig(DA, t, F, u), QA = w + QA | 0, QA = (I = iA + I | 0) >>> 0 < iA >>> 0 ? QA + 1 | 0 : QA, iA = Ig(cA = c(cA, 19), J = cA >> 31, G, j = G >> 31), oA = w + QA | 0, oA = (I = iA + I | 0) >>> 0 < iA >>> 0 ? oA + 1 | 0 : oA, QA = Ig(eA, r, sA, S), iA = w + oA | 0, iA = (I = QA + I | 0) >>> 0 < QA >>> 0 ? iA + 1 | 0 : iA, oA = Ig(EA, p, M, X = M >> 31), QA = w + iA | 0, QA = (I = oA + I | 0) >>> 0 < oA >>> 0 ? QA + 1 | 0 : QA, iA = Ig(tA, s, B, i), QA = w + QA | 0, GA = I = iA + I | 0, nA = I >>> 0 < iA >>> 0 ? QA + 1 | 0 : QA, I = Ig(C, e, b, m), QA = w, iA = Ig(pA, Q, hA, a), QA = w + QA | 0, QA = (I = iA + I | 0) >>> 0 < iA >>> 0 ? QA + 1 | 0 : QA, iA = Ig(rA, _, o, h), oA = w + QA | 0, oA = (I = iA + I | 0) >>> 0 < iA >>> 0 ? oA + 1 | 0 : oA, QA = Ig(y, n, H, x), iA = w + oA | 0, iA = (I = QA + I | 0) >>> 0 < QA >>> 0 ? iA + 1 | 0 : iA, oA = Ig(DA, t, D, K), QA = w + iA | 0, QA = (I = oA + I | 0) >>> 0 < oA >>> 0 ? QA + 1 | 0 : QA, iA = Ig(U = c(F, 19), O = U >> 31, Y, v), QA = w + QA | 0, QA = (I = iA + I | 0) >>> 0 < iA >>> 0 ? QA + 1 | 0 : QA, iA = Ig(eA, r, cA, J), QA = w + QA | 0, QA = (I = iA + I | 0) >>> 0 < iA >>> 0 ? QA + 1 | 0 : QA, iA = Ig(sA, S, d, L), oA = w + QA | 0, oA = (I = iA + I | 0) >>> 0 < iA >>> 0 ? oA + 1 | 0 : oA, QA = Ig(EA, p, B, i), iA = w + oA | 0, iA = (I = QA + I | 0) >>> 0 < QA >>> 0 ? iA + 1 | 0 : iA, oA = Ig(tA, s, fA, l), QA = w + iA | 0, $ = I = oA + I | 0, AA = QA = I >>> 0 < oA >>> 0 ? QA + 1 | 0 : QA, IA = I = I + 33554432 | 0, gA = QA = I >>> 0 < 33554432 ? QA + 1 | 0 : QA, oA = (67108863 & QA) << 6 | I >>> 26, QA = (QA >> 26) + nA | 0, GA = I = oA + GA | 0, QA = I >>> 0 < oA >>> 0 ? QA + 1 | 0 : QA, CA = I = I + 16777216 | 0, QA = g + (iA = (oA = I >>> 0 < 16777216 ? QA + 1 | 0 : QA) >> 25) | 0, QA = (I = (oA = (33554431 & oA) << 7 | I >>> 25) + aA | 0) >>> 0 < oA >>> 0 ? QA + 1 | 0 : QA, kA = g = (iA = I) + 33554432 | 0, I = QA = g >>> 0 < 33554432 ? QA + 1 | 0 : QA, E[A + 24 >> 2] = iA - (-67108864 & g), g = Ig(C, e, H, x), QA = w, iA = Ig(pA, Q, rA, _), oA = w + QA | 0, oA = (g = iA + g | 0) >>> 0 < iA >>> 0 ? oA + 1 | 0 : oA, iA = (QA = g) + (g = Ig(DA, t, o, h)) | 0, QA = w + oA | 0, QA = g >>> 0 > iA >>> 0 ? QA + 1 | 0 : QA, oA = Ig(g = c(y, 19), FA = g >> 31, Y, v), QA = w + QA | 0, QA = (iA = oA + iA | 0) >>> 0 < oA >>> 0 ? QA + 1 | 0 : QA, oA = (aA = Ig(eA, r, nA = c(D, 19), Z = nA >> 31)) + iA | 0, iA = w + QA | 0, iA = oA >>> 0 < aA >>> 0 ? iA + 1 | 0 : iA, aA = Ig(d, L, U, O), QA = w + iA | 0, QA = (oA = aA + oA | 0) >>> 0 < aA >>> 0 ? QA + 1 | 0 : QA, iA = (aA = Ig(B, i, cA, J)) + oA | 0, oA = w + QA | 0, oA = iA >>> 0 < aA >>> 0 ? oA + 1 | 0 : oA, aA = Ig(sA, S, fA, l), QA = w + oA | 0, QA = (iA = aA + iA | 0) >>> 0 < aA >>> 0 ? QA + 1 | 0 : QA, oA = Ig(EA, p, hA, a), QA = w + QA | 0, QA = (iA = oA + iA | 0) >>> 0 < oA >>> 0 ? QA + 1 | 0 : QA, oA = (aA = Ig(tA, s, b, m)) + iA | 0, iA = w + QA | 0, yA = oA, MA = oA >>> 0 < aA >>> 0 ? iA + 1 | 0 : iA, QA = Ig(DA, t, C, e), iA = w, oA = (aA = Ig(pA, Q, N, z)) + QA | 0, QA = w + iA | 0, QA = oA >>> 0 < aA >>> 0 ? QA + 1 | 0 : QA, aA = iA = c(o, 19), iA = (_A = Ig(iA, SA = iA >> 31, G, j)) + oA | 0, oA = w + QA | 0, oA = iA >>> 0 < _A >>> 0 ? oA + 1 | 0 : oA, _A = Ig(eA, r, g, FA), QA = w + oA | 0, QA = (iA = _A + iA | 0) >>> 0 < _A >>> 0 ? QA + 1 | 0 : QA, oA = Ig(nA, Z, M, X), QA = w + QA | 0, QA = (iA = oA + iA | 0) >>> 0 < oA >>> 0 ? QA + 1 | 0 : QA, oA = (_A = Ig(B, i, U, O)) + iA | 0, iA = w + QA | 0, iA = oA >>> 0 < _A >>> 0 ? iA + 1 | 0 : iA, _A = Ig(cA, J, f, P), QA = w + iA | 0, QA = (oA = _A + oA | 0) >>> 0 < _A >>> 0 ? QA + 1 | 0 : QA, iA = (_A = Ig(hA, a, sA, S)) + oA | 0, oA = w + QA | 0, oA = iA >>> 0 < _A >>> 0 ? oA + 1 | 0 : oA, _A = Ig(EA, p, k, q), QA = w + oA | 0, QA = (iA = _A + iA | 0) >>> 0 < _A >>> 0 ? QA + 1 | 0 : QA, oA = Ig(tA, s, rA, _), QA = w + QA | 0, bA = iA = oA + iA | 0, _A = iA >>> 0 < oA >>> 0 ? QA + 1 | 0 : QA, QA = Ig(QA = c(C, 19), QA >> 31, Y, v), iA = w, oA = Ig(pA, Q, DA, t), iA = w + iA | 0, iA = (QA = oA + QA | 0) >>> 0 < oA >>> 0 ? iA + 1 | 0 : iA, oA = (aA = Ig(eA, r, aA, SA)) + QA | 0, QA = w + iA | 0, g = (iA = Ig(g, FA, d, L)) + oA | 0, oA = w + (oA >>> 0 < aA >>> 0 ? QA + 1 | 0 : QA) | 0, oA = g >>> 0 < iA >>> 0 ? oA + 1 | 0 : oA, iA = Ig(B, i, nA, Z), QA = w + oA | 0, QA = (g = iA + g | 0) >>> 0 < iA >>> 0 ? QA + 1 | 0 : QA, iA = Ig(fA, l, U, O), QA = w + QA | 0, QA = (g = iA + g | 0) >>> 0 < iA >>> 0 ? QA + 1 | 0 : QA, oA = Ig(hA, a, cA, J), iA = w + QA | 0, iA = (g = oA + g | 0) >>> 0 < oA >>> 0 ? iA + 1 | 0 : iA, oA = Ig(sA, S, b, m), QA = w + iA | 0, QA = (g = oA + g | 0) >>> 0 < oA >>> 0 ? QA + 1 | 0 : QA, iA = Ig(EA, p, rA, _), oA = w + QA | 0, oA = (g = iA + g | 0) >>> 0 < iA >>> 0 ? oA + 1 | 0 : oA, iA = Ig(tA, s, H, x), QA = w + oA | 0, aA = g = iA + g | 0, FA = QA = g >>> 0 < iA >>> 0 ? QA + 1 | 0 : QA, SA = g = g + 33554432 | 0, BA = QA = g >>> 0 < 33554432 ? QA + 1 | 0 : QA, iA = (oA = QA >> 26) + _A | 0, _A = g = (QA = (67108863 & QA) << 6 | g >>> 26) + bA | 0, QA = g >>> 0 < QA >>> 0 ? iA + 1 | 0 : iA, bA = g = g + 16777216 | 0, iA = (33554431 & (QA = g >>> 0 < 16777216 ? QA + 1 | 0 : QA)) << 7 | g >>> 25, QA = (QA >> 25) + MA | 0, QA = (g = iA + yA | 0) >>> 0 < iA >>> 0 ? QA + 1 | 0 : QA, MA = iA = (oA = g) + 33554432 | 0, g = QA = iA >>> 0 < 33554432 ? QA + 1 | 0 : QA, E[A + 8 >> 2] = oA - (-67108864 & iA), QA = Ig(B, i, C, e), oA = w, iA = (yA = Ig(pA, Q, M, X)) + QA | 0, QA = w + oA | 0, QA = iA >>> 0 < yA >>> 0 ? QA + 1 | 0 : QA, oA = Ig(o, h, f, P), QA = w + QA | 0, QA = (iA = oA + iA | 0) >>> 0 < oA >>> 0 ? QA + 1 | 0 : QA, oA = Ig(hA, a, y, n), QA = w + QA | 0, QA = (iA = oA + iA | 0) >>> 0 < oA >>> 0 ? QA + 1 | 0 : QA, yA = Ig(D, K, k, q), oA = w + QA | 0, oA = (iA = yA + iA | 0) >>> 0 < yA >>> 0 ? oA + 1 | 0 : oA, QA = (yA = Ig(rA, _, F, u)) + iA | 0, iA = w + oA | 0, iA = QA >>> 0 < yA >>> 0 ? iA + 1 | 0 : iA, oA = (yA = Ig(N, z, W, V)) + QA | 0, QA = w + iA | 0, QA = oA >>> 0 < yA >>> 0 ? QA + 1 | 0 : QA, iA = oA, oA = Ig(DA, t, R, yA = R >> 31), QA = w + QA | 0, QA = (iA = iA + oA | 0) >>> 0 < oA >>> 0 ? QA + 1 | 0 : QA, oA = Ig(EA, p, G, j), QA = w + QA | 0, QA = (iA = oA + iA | 0) >>> 0 < oA >>> 0 ? QA + 1 | 0 : QA, wA = Ig(tA, s, eA, r), oA = w + QA | 0, QA = I >> 26, I = (kA = (67108863 & I) << 6 | kA >>> 26) + (iA = wA + iA | 0) | 0, iA = QA + (iA >>> 0 < wA >>> 0 ? oA + 1 | 0 : oA) | 0, QA = (oA = I) >>> 0 < kA >>> 0 ? iA + 1 | 0 : iA, kA = iA = oA + 16777216 | 0, I = QA = iA >>> 0 < 16777216 ? QA + 1 | 0 : QA, E[A + 28 >> 2] = oA - (-33554432 & iA), QA = Ig(rA, _, C, e), iA = w, wA = Ig(pA, Q, k, q), oA = w + iA | 0, oA = (QA = wA + QA | 0) >>> 0 < wA >>> 0 ? oA + 1 | 0 : oA, wA = Ig(o, h, N, z), iA = w + oA | 0, iA = (QA = wA + QA | 0) >>> 0 < wA >>> 0 ? iA + 1 | 0 : iA, oA = (wA = Ig(DA, t, y, n)) + QA | 0, QA = w + iA | 0, QA = oA >>> 0 < wA >>> 0 ? QA + 1 | 0 : QA, iA = oA, oA = Ig(nA, Z, G, j), QA = w + QA | 0, QA = (iA = iA + oA | 0) >>> 0 < oA >>> 0 ? QA + 1 | 0 : QA, oA = Ig(eA, r, U, O), QA = w + QA | 0, QA = (iA = oA + iA | 0) >>> 0 < oA >>> 0 ? QA + 1 | 0 : QA, iA = (cA = Ig(cA, J, M, X)) + iA | 0, oA = w + QA | 0, QA = (sA = Ig(B, i, sA, S)) + iA | 0, iA = w + (iA >>> 0 < cA >>> 0 ? oA + 1 | 0 : oA) | 0, oA = (EA = Ig(EA, p, f, P)) + QA | 0, QA = w + (QA >>> 0 < sA >>> 0 ? iA + 1 | 0 : iA) | 0, QA = oA >>> 0 < EA >>> 0 ? QA + 1 | 0 : QA, iA = oA, oA = Ig(tA, s, hA, a), QA = w + QA | 0, EA = iA = iA + oA | 0, QA = (QA = iA >>> 0 < oA >>> 0 ? QA + 1 | 0 : QA) + (iA = g >> 26) | 0, EA = g = EA + (oA = (67108863 & g) << 6 | MA >>> 26) | 0, QA = g >>> 0 < oA >>> 0 ? QA + 1 | 0 : QA, sA = iA = g + 16777216 | 0, g = oA = iA >>> 0 < 16777216 ? QA + 1 | 0 : QA, E[A + 12 >> 2] = EA - (-33554432 & iA), QA = Ig(C, e, d, L), oA = w, iA = (EA = Ig(pA, Q, eA, r)) + QA | 0, QA = w + oA | 0, QA = iA >>> 0 < EA >>> 0 ? QA + 1 | 0 : QA, oA = Ig(B, i, o, h), QA = w + QA | 0, QA = (iA = oA + iA | 0) >>> 0 < oA >>> 0 ? QA + 1 | 0 : QA, EA = Ig(y, n, fA, l), oA = w + QA | 0, oA = (iA = EA + iA | 0) >>> 0 < EA >>> 0 ? oA + 1 | 0 : oA, QA = (EA = Ig(hA, a, D, K)) + iA | 0, iA = w + oA | 0, iA = QA >>> 0 < EA >>> 0 ? iA + 1 | 0 : iA, oA = (EA = Ig(b, m, F, u)) + QA | 0, QA = w + iA | 0, QA = oA >>> 0 < EA >>> 0 ? QA + 1 | 0 : QA, iA = oA, oA = Ig(rA, _, W, V), QA = w + QA | 0, QA = (iA = iA + oA | 0) >>> 0 < oA >>> 0 ? QA + 1 | 0 : QA, oA = Ig(R, yA, H, x), QA = w + QA | 0, QA = (iA = oA + iA | 0) >>> 0 < oA >>> 0 ? QA + 1 | 0 : QA, iA = (fA = Ig(DA, t, EA = NA, cA = EA >> 31)) + iA | 0, oA = w + QA | 0, QA = (tA = Ig(tA, s, Y, v)) + iA | 0, iA = w + (iA >>> 0 < fA >>> 0 ? oA + 1 | 0 : oA) | 0, iA = QA >>> 0 < tA >>> 0 ? iA + 1 | 0 : iA, NA = QA, QA = (QA = I >> 25) + iA | 0, QA = (I = NA + (oA = (33554431 & I) << 7 | kA >>> 25) | 0) >>> 0 < oA >>> 0 ? QA + 1 | 0 : QA, tA = iA = (oA = I) + 33554432 | 0, I = QA = iA >>> 0 < 33554432 ? QA + 1 | 0 : QA, E[A + 32 >> 2] = oA - (-67108864 & iA), iA = g >> 25, g = (sA = (33554431 & g) << 7 | sA >>> 25) + ($ - (QA = -67108864 & IA) | 0) | 0, QA = iA + (AA - ((QA >>> 0 > $ >>> 0) + gA | 0) | 0) | 0, QA = g >>> 0 < sA >>> 0 ? QA + 1 | 0 : QA, QA = ((67108863 & (QA = (g = (iA = g) + 33554432 | 0) >>> 0 < 33554432 ? QA + 1 | 0 : QA)) << 6 | g >>> 26) + (oA = GA - (-33554432 & CA) | 0) | 0, E[A + 20 >> 2] = QA, E[A + 16 >> 2] = iA - (-67108864 & g), g = Ig(eA, r, C, e), QA = w, iA = Ig(pA, Q, G, j), QA = w + QA | 0, QA = (g = iA + g | 0) >>> 0 < iA >>> 0 ? QA + 1 | 0 : QA, oA = Ig(o, h, M, X), iA = w + QA | 0, iA = (g = oA + g | 0) >>> 0 < oA >>> 0 ? iA + 1 | 0 : iA, QA = Ig(B, i, y, n), oA = w + iA | 0, oA = (g = QA + g | 0) >>> 0 < QA >>> 0 ? oA + 1 | 0 : oA, iA = Ig(D, K, f, P), QA = w + oA | 0, QA = (g = iA + g | 0) >>> 0 < iA >>> 0 ? QA + 1 | 0 : QA, iA = Ig(hA, a, F, u), QA = w + QA | 0, QA = (g = iA + g | 0) >>> 0 < iA >>> 0 ? QA + 1 | 0 : QA, iA = Ig(k, q, W, V), QA = w + QA | 0, QA = (g = iA + g | 0) >>> 0 < iA >>> 0 ? QA + 1 | 0 : QA, oA = Ig(rA, _, R, yA), iA = w + QA | 0, iA = (g = oA + g | 0) >>> 0 < oA >>> 0 ? iA + 1 | 0 : iA, QA = Ig(EA, cA, N, z), oA = w + iA | 0, oA = (g = QA + g | 0) >>> 0 < QA >>> 0 ? oA + 1 | 0 : oA, iA = Ig(DA, t, T, T >> 31), QA = w + oA | 0, QA = (QA = (g = iA + g | 0) >>> 0 < iA >>> 0 ? QA + 1 | 0 : QA) + (iA = I >> 26) | 0, QA = (I = (oA = g) + (g = (67108863 & I) << 6 | tA >>> 26) | 0) >>> 0 < g >>> 0 ? QA + 1 | 0 : QA, QA = (I = (g = I) + 16777216 | 0) >>> 0 < 16777216 ? QA + 1 | 0 : QA, E[A + 36 >> 2] = g - (-33554432 & I), oA = _A - (-33554432 & bA) | 0, iA = aA - (g = -67108864 & SA) | 0, pA = FA - ((g >>> 0 > aA >>> 0) + BA | 0) | 0, I = (g = Ig((33554431 & (g = QA)) << 7 | I >>> 25, QA >>= 25, 19, 0)) + iA | 0, iA = w + pA | 0, QA = I >>> 0 < g >>> 0 ? iA + 1 | 0 : iA, QA = ((67108863 & (QA = (I = (g = I) + 33554432 | 0) >>> 0 < 33554432 ? QA + 1 | 0 : QA)) << 6 | I >>> 26) + oA | 0, E[A + 4 >> 2] = QA, E[A >> 2] = g - (-67108864 & I);
                                    }
                                    function d(A, I, g, C, B) {
                                        var Q, i = 0, _ = 0, c = 0, t = 0, r = 0, e = 0, y = 0, s = 0, D = 0, p = 0, w = 0, f = 0, n = 0, k = 0, F = 0, N = 0, S = 0, G = 0, M = 0, b = 0;
                                        for(h = Q = h - 288 | 0, D = (a[B + 44 | 0] | a[B + 45 | 0] << 8 | a[B + 46 | 0] << 16 | a[B + 47 | 0] << 24) ^ C >>> 29, p = (a[B + 40 | 0] | a[B + 41 | 0] << 8 | a[B + 42 | 0] << 16 | a[B + 43 | 0] << 24) ^ C << 3, w = (a[B + 36 | 0] | a[B + 37 | 0] << 8 | a[B + 38 | 0] << 16 | a[B + 39 | 0] << 24) ^ g >>> 29, C = (a[0 | (c = B + 32 | 0)] | a[c + 1 | 0] << 8 | a[c + 2 | 0] << 16 | a[c + 3 | 0] << 24) ^ g << 3, y = B + 16 | 0, r = B + 48 | 0, _ = B - -64 | 0, e = B + 80 | 0, i = B + 96 | 0, t = B + 112 | 0; g = E[t + 12 >> 2], E[Q + 280 >> 2] = E[t + 8 >> 2], E[Q + 284 >> 2] = g, g = E[t + 4 >> 2], E[Q + 272 >> 2] = E[t >> 2], E[Q + 276 >> 2] = g, g = E[i + 12 >> 2], E[Q + 248 >> 2] = E[i + 8 >> 2], E[Q + 252 >> 2] = g, g = E[i + 4 >> 2], E[Q + 240 >> 2] = E[i >> 2], E[Q + 244 >> 2] = g, g = E[t + 12 >> 2], E[Q + 232 >> 2] = E[t + 8 >> 2], E[Q + 236 >> 2] = g, g = E[t + 4 >> 2], E[Q + 224 >> 2] = E[t >> 2], E[Q + 228 >> 2] = g, $A(s = Q + 256 | 0, Q + 240 | 0, Q + 224 | 0), g = E[Q + 268 >> 2], E[t + 8 >> 2] = E[Q + 264 >> 2], E[t + 12 >> 2] = g, g = E[Q + 260 >> 2], E[t >> 2] = E[Q + 256 >> 2], E[t + 4 >> 2] = g, g = E[e + 12 >> 2], E[Q + 216 >> 2] = E[e + 8 >> 2], E[Q + 220 >> 2] = g, g = E[e + 4 >> 2], E[Q + 208 >> 2] = E[e >> 2], E[Q + 212 >> 2] = g, g = E[i + 12 >> 2], E[Q + 200 >> 2] = E[i + 8 >> 2], E[Q + 204 >> 2] = g, g = E[i + 4 >> 2], E[Q + 192 >> 2] = E[i >> 2], E[Q + 196 >> 2] = g, $A(s, Q + 208 | 0, Q + 192 | 0), g = E[Q + 268 >> 2], E[i + 8 >> 2] = E[Q + 264 >> 2], E[i + 12 >> 2] = g, g = E[Q + 260 >> 2], E[i >> 2] = E[Q + 256 >> 2], E[i + 4 >> 2] = g, g = E[_ + 12 >> 2], E[Q + 184 >> 2] = E[_ + 8 >> 2], E[Q + 188 >> 2] = g, g = E[_ + 4 >> 2], E[Q + 176 >> 2] = E[_ >> 2], E[Q + 180 >> 2] = g, g = E[e + 12 >> 2], E[Q + 168 >> 2] = E[e + 8 >> 2], E[Q + 172 >> 2] = g, g = E[e + 4 >> 2], E[Q + 160 >> 2] = E[e >> 2], E[Q + 164 >> 2] = g, $A(s, Q + 176 | 0, Q + 160 | 0), g = E[Q + 268 >> 2], E[e + 8 >> 2] = E[Q + 264 >> 2], E[e + 12 >> 2] = g, g = E[Q + 260 >> 2], E[e >> 2] = E[Q + 256 >> 2], E[e + 4 >> 2] = g, g = E[r + 12 >> 2], E[Q + 152 >> 2] = E[r + 8 >> 2], E[Q + 156 >> 2] = g, g = E[r + 4 >> 2], E[Q + 144 >> 2] = E[r >> 2], E[Q + 148 >> 2] = g, g = E[_ + 12 >> 2], E[Q + 136 >> 2] = E[_ + 8 >> 2], E[Q + 140 >> 2] = g, g = E[_ + 4 >> 2], E[Q + 128 >> 2] = E[_ >> 2], E[Q + 132 >> 2] = g, $A(s, Q + 144 | 0, Q + 128 | 0), g = E[Q + 268 >> 2], E[_ + 8 >> 2] = E[Q + 264 >> 2], E[_ + 12 >> 2] = g, g = E[Q + 260 >> 2], E[_ >> 2] = E[Q + 256 >> 2], E[_ + 4 >> 2] = g, g = E[c + 12 >> 2], E[Q + 120 >> 2] = E[c + 8 >> 2], E[Q + 124 >> 2] = g, g = E[c + 4 >> 2], E[Q + 112 >> 2] = E[c >> 2], E[Q + 116 >> 2] = g, g = E[r + 12 >> 2], E[Q + 104 >> 2] = E[r + 8 >> 2], E[Q + 108 >> 2] = g, g = E[r + 4 >> 2], E[Q + 96 >> 2] = E[r >> 2], E[Q + 100 >> 2] = g, $A(s, Q + 112 | 0, Q + 96 | 0), g = E[Q + 268 >> 2], E[r + 8 >> 2] = E[Q + 264 >> 2], E[r + 12 >> 2] = g, g = E[Q + 260 >> 2], E[r >> 2] = E[Q + 256 >> 2], E[r + 4 >> 2] = g, g = E[y + 12 >> 2], E[Q + 88 >> 2] = E[y + 8 >> 2], E[Q + 92 >> 2] = g, g = E[y + 4 >> 2], E[Q + 80 >> 2] = E[y >> 2], E[Q + 84 >> 2] = g, g = E[c + 12 >> 2], E[Q + 72 >> 2] = E[c + 8 >> 2], E[Q + 76 >> 2] = g, g = E[c + 4 >> 2], E[Q + 64 >> 2] = E[c >> 2], E[Q + 68 >> 2] = g, $A(s, Q + 80 | 0, Q - -64 | 0), g = E[Q + 268 >> 2], E[c + 8 >> 2] = E[Q + 264 >> 2], E[c + 12 >> 2] = g, g = E[Q + 260 >> 2], E[c >> 2] = E[Q + 256 >> 2], E[c + 4 >> 2] = g, g = E[B + 12 >> 2], E[Q + 56 >> 2] = E[B + 8 >> 2], E[Q + 60 >> 2] = g, g = E[B + 4 >> 2], E[Q + 48 >> 2] = E[B >> 2], E[Q + 52 >> 2] = g, g = E[y + 12 >> 2], E[Q + 40 >> 2] = E[y + 8 >> 2], E[Q + 44 >> 2] = g, g = E[y + 4 >> 2], E[Q + 32 >> 2] = E[y >> 2], E[Q + 36 >> 2] = g, $A(s, Q + 48 | 0, Q + 32 | 0), g = E[Q + 268 >> 2], E[y + 8 >> 2] = E[Q + 264 >> 2], E[y + 12 >> 2] = g, g = E[Q + 260 >> 2], E[y >> 2] = E[Q + 256 >> 2], E[y + 4 >> 2] = g, g = E[Q + 284 >> 2], E[Q + 24 >> 2] = E[Q + 280 >> 2], E[Q + 28 >> 2] = g, g = E[Q + 276 >> 2], E[Q + 16 >> 2] = E[Q + 272 >> 2], E[Q + 20 >> 2] = g, g = E[B + 12 >> 2], E[Q + 8 >> 2] = E[B + 8 >> 2], E[Q + 12 >> 2] = g, g = E[B + 4 >> 2], E[Q >> 2] = E[B >> 2], E[Q + 4 >> 2] = g, $A(s, Q + 16 | 0, Q), g = E[Q + 268 >> 2], E[B + 8 >> 2] = E[Q + 264 >> 2], E[B + 12 >> 2] = g, g = E[Q + 260 >> 2], E[B >> 2] = E[Q + 256 >> 2], E[B + 4 >> 2] = g, n = D ^ (a[B + 12 | 0] | a[B + 13 | 0] << 8 | a[B + 14 | 0] << 16 | a[B + 15 | 0] << 24), E[B + 12 >> 2] = n, k = p ^ (a[B + 8 | 0] | a[B + 9 | 0] << 8 | a[B + 10 | 0] << 16 | a[B + 11 | 0] << 24), E[B + 8 >> 2] = k, F = w ^ (a[B + 4 | 0] | a[B + 5 | 0] << 8 | a[B + 6 | 0] << 16 | a[B + 7 | 0] << 24), E[B + 4 >> 2] = F, N = C ^ (a[0 | B] | a[B + 1 | 0] << 8 | a[B + 2 | 0] << 16 | a[B + 3 | 0] << 24), E[B >> 2] = N, S = C ^ (a[0 | _] | a[_ + 1 | 0] << 8 | a[_ + 2 | 0] << 16 | a[_ + 3 | 0] << 24), E[_ >> 2] = S, G = w ^ (a[B + 68 | 0] | a[B + 69 | 0] << 8 | a[B + 70 | 0] << 16 | a[B + 71 | 0] << 24), E[B + 68 >> 2] = G, M = p ^ (a[B + 72 | 0] | a[B + 73 | 0] << 8 | a[B + 74 | 0] << 16 | a[B + 75 | 0] << 24), E[B + 72 >> 2] = M, b = D ^ (a[B + 76 | 0] | a[B + 77 | 0] << 8 | a[B + 78 | 0] << 16 | a[B + 79 | 0] << 24), E[B + 76 >> 2] = b, 7 != (0 | (f = f + 1 | 0)););
                                        A: {
                                            I: {
                                                g: {
                                                    if (g = I - 16 | 0) {
                                                        if (16 == (0 | g)) break g;
                                                        break I;
                                                    }
                                                    _ = a[B + 16 | 0] | a[B + 17 | 0] << 8 | a[B + 18 | 0] << 16 | a[B + 19 | 0] << 24, c = a[B + 48 | 0] | a[B + 49 | 0] << 8 | a[B + 50 | 0] << 16 | a[B + 51 | 0] << 24, y = a[B + 32 | 0] | a[B + 33 | 0] << 8 | a[B + 34 | 0] << 16 | a[B + 35 | 0] << 24, r = a[B + 96 | 0] | a[B + 97 | 0] << 8 | a[B + 98 | 0] << 16 | a[B + 99 | 0] << 24, e = a[B + 80 | 0] | a[B + 81 | 0] << 8 | a[B + 82 | 0] << 16 | a[B + 83 | 0] << 24, i = a[B + 20 | 0] | a[B + 21 | 0] << 8 | a[B + 22 | 0] << 16 | a[B + 23 | 0] << 24, t = a[B + 52 | 0] | a[B + 53 | 0] << 8 | a[B + 54 | 0] << 16 | a[B + 55 | 0] << 24, s = a[B + 36 | 0] | a[B + 37 | 0] << 8 | a[B + 38 | 0] << 16 | a[B + 39 | 0] << 24, D = a[B + 100 | 0] | a[B + 101 | 0] << 8 | a[B + 102 | 0] << 16 | a[B + 103 | 0] << 24, p = a[B + 84 | 0] | a[B + 85 | 0] << 8 | a[B + 86 | 0] << 16 | a[B + 87 | 0] << 24, w = a[B + 24 | 0] | a[B + 25 | 0] << 8 | a[B + 26 | 0] << 16 | a[B + 27 | 0] << 24, f = a[B + 56 | 0] | a[B + 57 | 0] << 8 | a[B + 58 | 0] << 16 | a[B + 59 | 0] << 24, C = a[B + 40 | 0] | a[B + 41 | 0] << 8 | a[B + 42 | 0] << 16 | a[B + 43 | 0] << 24, g = a[B + 104 | 0] | a[B + 105 | 0] << 8 | a[B + 106 | 0] << 16 | a[B + 107 | 0] << 24, I = a[B + 88 | 0] | a[B + 89 | 0] << 8 | a[B + 90 | 0] << 16 | a[B + 91 | 0] << 24, B = n ^ (a[B + 28 | 0] | a[B + 29 | 0] << 8 | a[B + 30 | 0] << 16 | a[B + 31 | 0] << 24) ^ (a[B + 60 | 0] | a[B + 61 | 0] << 8 | a[B + 62 | 0] << 16 | a[B + 63 | 0] << 24) ^ (a[B + 44 | 0] | a[B + 45 | 0] << 8 | a[B + 46 | 0] << 16 | a[B + 47 | 0] << 24) ^ (a[B + 92 | 0] | a[B + 93 | 0] << 8 | a[B + 94 | 0] << 16 | a[B + 95 | 0] << 24) ^ (a[B + 108 | 0] | a[B + 109 | 0] << 8 | a[B + 110 | 0] << 16 | a[B + 111 | 0] << 24) ^ b, o[A + 12 | 0] = B, o[A + 13 | 0] = B >>> 8, o[A + 14 | 0] = B >>> 16, o[A + 15 | 0] = B >>> 24, I = w ^ f ^ C ^ I ^ g ^ M ^ k, o[A + 8 | 0] = I, o[A + 9 | 0] = I >>> 8, o[A + 10 | 0] = I >>> 16, o[A + 11 | 0] = I >>> 24, I = i ^ t ^ s ^ D ^ p ^ G ^ F, o[A + 4 | 0] = I, o[A + 5 | 0] = I >>> 8, o[A + 6 | 0] = I >>> 16, o[A + 7 | 0] = I >>> 24, I = _ ^ c ^ y ^ r ^ e ^ S ^ N, o[0 | A] = I, o[A + 1 | 0] = I >>> 8, o[A + 2 | 0] = I >>> 16, o[A + 3 | 0] = I >>> 24;
                                                    break A;
                                                }
                                                t = a[B + 16 | 0] | a[B + 17 | 0] << 8 | a[B + 18 | 0] << 16 | a[B + 19 | 0] << 24, s = a[B + 48 | 0] | a[B + 49 | 0] << 8 | a[B + 50 | 0] << 16 | a[B + 51 | 0] << 24, D = a[B + 32 | 0] | a[B + 33 | 0] << 8 | a[B + 34 | 0] << 16 | a[B + 35 | 0] << 24, p = a[B + 20 | 0] | a[B + 21 | 0] << 8 | a[B + 22 | 0] << 16 | a[B + 23 | 0] << 24, w = a[B + 52 | 0] | a[B + 53 | 0] << 8 | a[B + 54 | 0] << 16 | a[B + 55 | 0] << 24, f = a[B + 36 | 0] | a[B + 37 | 0] << 8 | a[B + 38 | 0] << 16 | a[B + 39 | 0] << 24, C = a[B + 24 | 0] | a[B + 25 | 0] << 8 | a[B + 26 | 0] << 16 | a[B + 27 | 0] << 24, g = a[B + 56 | 0] | a[B + 57 | 0] << 8 | a[B + 58 | 0] << 16 | a[B + 59 | 0] << 24, I = a[B + 40 | 0] | a[B + 41 | 0] << 8 | a[B + 42 | 0] << 16 | a[B + 43 | 0] << 24, i = n ^ (a[B + 28 | 0] | a[B + 29 | 0] << 8 | a[B + 30 | 0] << 16 | a[B + 31 | 0] << 24) ^ (a[B + 60 | 0] | a[B + 61 | 0] << 8 | a[B + 62 | 0] << 16 | a[B + 63 | 0] << 24) ^ (a[B + 44 | 0] | a[B + 45 | 0] << 8 | a[B + 46 | 0] << 16 | a[B + 47 | 0] << 24), o[A + 12 | 0] = i, o[A + 13 | 0] = i >>> 8, o[A + 14 | 0] = i >>> 16, o[A + 15 | 0] = i >>> 24, I = C ^ I ^ g ^ k, o[A + 8 | 0] = I, o[A + 9 | 0] = I >>> 8, o[A + 10 | 0] = I >>> 16, o[A + 11 | 0] = I >>> 24, I = p ^ w ^ f ^ F, o[A + 4 | 0] = I, o[A + 5 | 0] = I >>> 8, o[A + 6 | 0] = I >>> 16, o[A + 7 | 0] = I >>> 24, I = t ^ s ^ D ^ N, o[0 | A] = I, o[A + 1 | 0] = I >>> 8, o[A + 2 | 0] = I >>> 16, o[A + 3 | 0] = I >>> 24, r = a[B + 80 | 0] | a[B + 81 | 0] << 8 | a[B + 82 | 0] << 16 | a[B + 83 | 0] << 24, e = a[0 | (I = B - -64 | 0)] | a[I + 1 | 0] << 8 | a[I + 2 | 0] << 16 | a[I + 3 | 0] << 24, i = a[B + 112 | 0] | a[B + 113 | 0] << 8 | a[B + 114 | 0] << 16 | a[B + 115 | 0] << 24, t = a[B + 96 | 0] | a[B + 97 | 0] << 8 | a[B + 98 | 0] << 16 | a[B + 99 | 0] << 24, s = a[B + 84 | 0] | a[B + 85 | 0] << 8 | a[B + 86 | 0] << 16 | a[B + 87 | 0] << 24, D = a[B + 68 | 0] | a[B + 69 | 0] << 8 | a[B + 70 | 0] << 16 | a[B + 71 | 0] << 24, p = a[B + 116 | 0] | a[B + 117 | 0] << 8 | a[B + 118 | 0] << 16 | a[B + 119 | 0] << 24, w = a[B + 100 | 0] | a[B + 101 | 0] << 8 | a[B + 102 | 0] << 16 | a[B + 103 | 0] << 24, f = a[B + 88 | 0] | a[B + 89 | 0] << 8 | a[B + 90 | 0] << 16 | a[B + 91 | 0] << 24, C = a[B + 72 | 0] | a[B + 73 | 0] << 8 | a[B + 74 | 0] << 16 | a[B + 75 | 0] << 24, g = a[B + 120 | 0] | a[B + 121 | 0] << 8 | a[B + 122 | 0] << 16 | a[B + 123 | 0] << 24, I = a[B + 104 | 0] | a[B + 105 | 0] << 8 | a[B + 106 | 0] << 16 | a[B + 107 | 0] << 24, B = (a[B + 92 | 0] | a[B + 93 | 0] << 8 | a[B + 94 | 0] << 16 | a[B + 95 | 0] << 24) ^ (a[B + 76 | 0] | a[B + 77 | 0] << 8 | a[B + 78 | 0] << 16 | a[B + 79 | 0] << 24) ^ (a[B + 124 | 0] | a[B + 125 | 0] << 8 | a[B + 126 | 0] << 16 | a[B + 127 | 0] << 24) ^ (a[B + 108 | 0] | a[B + 109 | 0] << 8 | a[B + 110 | 0] << 16 | a[B + 111 | 0] << 24), o[A + 28 | 0] = B, o[A + 29 | 0] = B >>> 8, o[A + 30 | 0] = B >>> 16, o[A + 31 | 0] = B >>> 24, I = f ^ C ^ I ^ g, o[A + 24 | 0] = I, o[A + 25 | 0] = I >>> 8, o[A + 26 | 0] = I >>> 16, o[A + 27 | 0] = I >>> 24, I = s ^ D ^ p ^ w, o[A + 20 | 0] = I, o[A + 21 | 0] = I >>> 8, o[A + 22 | 0] = I >>> 16, o[A + 23 | 0] = I >>> 24, I = r ^ e ^ i ^ t, o[A + 16 | 0] = I, o[A + 17 | 0] = I >>> 8, o[A + 18 | 0] = I >>> 16, o[A + 19 | 0] = I >>> 24;
                                                break A;
                                            }
                                            Hg(A, 0, I);
                                        }
                                        h = Q + 288 | 0;
                                    }
                                    function J(A, I, g, C) {
                                        var B = 0, Q = 0, i = 0, o = 0, _ = 0, c = 0, t = 0, r = 0, e = 0, y = 0, s = 0, h = 0, D = 0, p = 0, w = 0, f = 0, n = 0, k = 0, F = 0, N = 0, S = 0, G = 0, M = 0, b = 0, K = 0, H = 0, Y = 0;
                                        for(B = a[0 | I] | a[I + 1 | 0] << 8 | a[I + 2 | 0] << 16 | a[I + 3 | 0] << 24, E[g >> 2] = B << 24 | (65280 & B) << 8 | B >>> 8 & 65280 | B >>> 24, B = a[I + 4 | 0] | a[I + 5 | 0] << 8 | a[I + 6 | 0] << 16 | a[I + 7 | 0] << 24, E[g + 4 >> 2] = B << 24 | (65280 & B) << 8 | B >>> 8 & 65280 | B >>> 24, B = a[I + 8 | 0] | a[I + 9 | 0] << 8 | a[I + 10 | 0] << 16 | a[I + 11 | 0] << 24, E[g + 8 >> 2] = B << 24 | (65280 & B) << 8 | B >>> 8 & 65280 | B >>> 24, B = a[I + 12 | 0] | a[I + 13 | 0] << 8 | a[I + 14 | 0] << 16 | a[I + 15 | 0] << 24, E[g + 12 >> 2] = B << 24 | (65280 & B) << 8 | B >>> 8 & 65280 | B >>> 24, B = a[I + 16 | 0] | a[I + 17 | 0] << 8 | a[I + 18 | 0] << 16 | a[I + 19 | 0] << 24, E[g + 16 >> 2] = B << 24 | (65280 & B) << 8 | B >>> 8 & 65280 | B >>> 24, B = a[I + 20 | 0] | a[I + 21 | 0] << 8 | a[I + 22 | 0] << 16 | a[I + 23 | 0] << 24, E[g + 20 >> 2] = B << 24 | (65280 & B) << 8 | B >>> 8 & 65280 | B >>> 24, B = a[I + 24 | 0] | a[I + 25 | 0] << 8 | a[I + 26 | 0] << 16 | a[I + 27 | 0] << 24, E[g + 24 >> 2] = B << 24 | (65280 & B) << 8 | B >>> 8 & 65280 | B >>> 24, B = a[I + 28 | 0] | a[I + 29 | 0] << 8 | a[I + 30 | 0] << 16 | a[I + 31 | 0] << 24, E[g + 28 >> 2] = B << 24 | (65280 & B) << 8 | B >>> 8 & 65280 | B >>> 24, B = a[I + 32 | 0] | a[I + 33 | 0] << 8 | a[I + 34 | 0] << 16 | a[I + 35 | 0] << 24, E[g + 32 >> 2] = B << 24 | (65280 & B) << 8 | B >>> 8 & 65280 | B >>> 24, B = a[I + 36 | 0] | a[I + 37 | 0] << 8 | a[I + 38 | 0] << 16 | a[I + 39 | 0] << 24, E[g + 36 >> 2] = B << 24 | (65280 & B) << 8 | B >>> 8 & 65280 | B >>> 24, B = a[I + 40 | 0] | a[I + 41 | 0] << 8 | a[I + 42 | 0] << 16 | a[I + 43 | 0] << 24, E[g + 40 >> 2] = B << 24 | (65280 & B) << 8 | B >>> 8 & 65280 | B >>> 24, B = a[I + 44 | 0] | a[I + 45 | 0] << 8 | a[I + 46 | 0] << 16 | a[I + 47 | 0] << 24, E[g + 44 >> 2] = B << 24 | (65280 & B) << 8 | B >>> 8 & 65280 | B >>> 24, B = a[I + 48 | 0] | a[I + 49 | 0] << 8 | a[I + 50 | 0] << 16 | a[I + 51 | 0] << 24, E[g + 48 >> 2] = B << 24 | (65280 & B) << 8 | B >>> 8 & 65280 | B >>> 24, B = a[I + 52 | 0] | a[I + 53 | 0] << 8 | a[I + 54 | 0] << 16 | a[I + 55 | 0] << 24, E[g + 52 >> 2] = B << 24 | (65280 & B) << 8 | B >>> 8 & 65280 | B >>> 24, B = a[I + 56 | 0] | a[I + 57 | 0] << 8 | a[I + 58 | 0] << 16 | a[I + 59 | 0] << 24, E[g + 56 >> 2] = B << 24 | (65280 & B) << 8 | B >>> 8 & 65280 | B >>> 24, I = a[I + 60 | 0] | a[I + 61 | 0] << 8 | a[I + 62 | 0] << 16 | a[I + 63 | 0] << 24, E[g + 60 >> 2] = I << 24 | (65280 & I) << 8 | I >>> 8 & 65280 | I >>> 24, I = E[A + 28 >> 2], E[C + 24 >> 2] = E[A + 24 >> 2], E[C + 28 >> 2] = I, I = E[A + 20 >> 2], E[C + 16 >> 2] = E[A + 16 >> 2], E[C + 20 >> 2] = I, I = E[A + 12 >> 2], E[C + 8 >> 2] = E[A + 8 >> 2], E[C + 12 >> 2] = I, I = E[A + 4 >> 2], E[C >> 2] = E[A >> 2], E[C + 4 >> 2] = I; _ = E[C + 28 >> 2], B = (I = n << 2) + g | 0, i = E[C + 16 >> 2], c = E[B >> 2] + (Lg(i, 26) ^ Lg(i, 21) ^ Lg(i, 7)) | 0, r = (_ = ((Q = E[I + 34432 >> 2] + c | 0) + (i & ((c = E[C + 24 >> 2]) ^ (e = E[C + 20 >> 2])) ^ c) | 0) + _ | 0) + E[C + 12 >> 2] | 0, E[C + 12 >> 2] = r, _ = (s = _ + (Lg(t = E[C >> 2], 30) ^ Lg(t, 19) ^ Lg(t, 10)) | 0) + (t & ((Q = E[C + 8 >> 2]) | (o = E[C + 4 >> 2])) | Q & o) | 0, E[C + 28 >> 2] = _, Q = (s = Q) + (c = (E[(D = (Q = 4 | I) + g | 0) >> 2] + ((c + (e ^ r & (i ^ e)) | 0) + (Lg(r, 26) ^ Lg(r, 21) ^ Lg(r, 7)) | 0) | 0) + E[Q + 34432 >> 2] | 0) | 0, E[C + 8 >> 2] = Q, c = (c + (_ & (o | t) | o & t) | 0) + (Lg(_, 30) ^ Lg(_, 19) ^ Lg(_, 10)) | 0, E[C + 24 >> 2] = c, e = (s = o) + (o = (((e + E[(f = (o = 8 | I) + g | 0) >> 2] | 0) + E[o + 34432 >> 2] | 0) + (i ^ Q & (i ^ r)) | 0) + (Lg(Q, 26) ^ Lg(Q, 21) ^ Lg(Q, 7)) | 0) | 0, E[C + 4 >> 2] = e, o = o + ((c & (_ | t) | _ & t) + (Lg(c, 30) ^ Lg(c, 19) ^ Lg(c, 10)) | 0) | 0, E[C + 20 >> 2] = o, i = (s = t) + (t = (((i + E[(k = (t = 12 | I) + g | 0) >> 2] | 0) + E[t + 34432 >> 2] | 0) + (r ^ e & (Q ^ r)) | 0) + (Lg(e, 26) ^ Lg(e, 21) ^ Lg(e, 7)) | 0) | 0, E[C >> 2] = i, t = t + ((o & (_ | c) | _ & c) + (Lg(o, 30) ^ Lg(o, 19) ^ Lg(o, 10)) | 0) | 0, E[C + 16 >> 2] = t, r = (y = ((((s = r) + E[(F = (r = 16 | I) + g | 0) >> 2] | 0) + E[r + 34432 >> 2] | 0) + (Q ^ i & (Q ^ e)) | 0) + (Lg(i, 26) ^ Lg(i, 21) ^ Lg(i, 7)) | 0) + ((t & (o | c) | o & c) + (Lg(t, 30) ^ Lg(t, 19) ^ Lg(t, 10)) | 0) | 0, E[C + 12 >> 2] = r, y = _ + y | 0, E[C + 28 >> 2] = y, _ = (Q = (((Q + E[(N = (_ = 20 | I) + g | 0) >> 2] | 0) + E[_ + 34432 >> 2] | 0) + (e ^ y & (i ^ e)) | 0) + (Lg(y, 26) ^ Lg(y, 21) ^ Lg(y, 7)) | 0) + ((r & (o | t) | o & t) + (Lg(r, 30) ^ Lg(r, 19) ^ Lg(r, 10)) | 0) | 0, E[C + 8 >> 2] = _, Q = Q + c | 0, E[C + 24 >> 2] = Q, c = (e = (((e + E[(S = (c = 24 | I) + g | 0) >> 2] | 0) + E[c + 34432 >> 2] | 0) + (i ^ Q & (i ^ y)) | 0) + (Lg(Q, 26) ^ Lg(Q, 21) ^ Lg(Q, 7)) | 0) + ((_ & (t | r) | t & r) + (Lg(_, 30) ^ Lg(_, 19) ^ Lg(_, 10)) | 0) | 0, E[C + 4 >> 2] = c, e = o + e | 0, E[C + 20 >> 2] = e, o = (i = (((i + E[(G = (o = 28 | I) + g | 0) >> 2] | 0) + E[o + 34432 >> 2] | 0) + (y ^ e & (Q ^ y)) | 0) + (Lg(e, 26) ^ Lg(e, 21) ^ Lg(e, 7)) | 0) + ((c & (_ | r) | _ & r) + (Lg(c, 30) ^ Lg(c, 19) ^ Lg(c, 10)) | 0) | 0, E[C >> 2] = o, i = i + t | 0, E[C + 16 >> 2] = i, t = (y = (((y + E[(M = (t = 32 | I) + g | 0) >> 2] | 0) + E[t + 34432 >> 2] | 0) + (Q ^ i & (Q ^ e)) | 0) + (Lg(i, 26) ^ Lg(i, 21) ^ Lg(i, 7)) | 0) + ((o & (_ | c) | _ & c) + (Lg(o, 30) ^ Lg(o, 19) ^ Lg(o, 10)) | 0) | 0, E[C + 28 >> 2] = t, y = r + y | 0, E[C + 12 >> 2] = y, r = (Q = (((Q + E[(b = (r = 36 | I) + g | 0) >> 2] | 0) + E[r + 34432 >> 2] | 0) + (e ^ y & (i ^ e)) | 0) + (Lg(y, 26) ^ Lg(y, 21) ^ Lg(y, 7)) | 0) + ((t & (o | c) | o & c) + (Lg(t, 30) ^ Lg(t, 19) ^ Lg(t, 10)) | 0) | 0, E[C + 24 >> 2] = r, Q = Q + _ | 0, E[C + 8 >> 2] = Q, _ = (e = (((e + E[(K = (_ = 40 | I) + g | 0) >> 2] | 0) + E[_ + 34432 >> 2] | 0) + (i ^ Q & (i ^ y)) | 0) + (Lg(Q, 26) ^ Lg(Q, 21) ^ Lg(Q, 7)) | 0) + ((r & (o | t) | o & t) + (Lg(r, 30) ^ Lg(r, 19) ^ Lg(r, 10)) | 0) | 0, E[C + 20 >> 2] = _, e = c + e | 0, E[C + 4 >> 2] = e, s = (c = 44 | I) + g | 0, c = (i = ((i + (E[c + 34432 >> 2] + E[s >> 2] | 0) | 0) + (y ^ e & (Q ^ y)) | 0) + (Lg(e, 26) ^ Lg(e, 21) ^ Lg(e, 7)) | 0) + ((_ & (t | r) | t & r) + (Lg(_, 30) ^ Lg(_, 19) ^ Lg(_, 10)) | 0) | 0, E[C + 16 >> 2] = c, o = o + i | 0, E[C >> 2] = o, w = (i = 48 | I) + g | 0, i = (y = ((y + (E[i + 34432 >> 2] + E[w >> 2] | 0) | 0) + (Q ^ o & (Q ^ e)) | 0) + (Lg(o, 26) ^ Lg(o, 21) ^ Lg(o, 7)) | 0) + ((c & (_ | r) | _ & r) + (Lg(c, 30) ^ Lg(c, 19) ^ Lg(c, 10)) | 0) | 0, E[C + 12 >> 2] = i, t = t + y | 0, E[C + 28 >> 2] = t, p = (y = 52 | I) + g | 0, Q = (y = (((E[y + 34432 >> 2] + E[p >> 2] | 0) + Q | 0) + (e ^ t & (o ^ e)) | 0) + (Lg(t, 26) ^ Lg(t, 21) ^ Lg(t, 7)) | 0) + ((i & (_ | c) | _ & c) + (Lg(i, 30) ^ Lg(i, 19) ^ Lg(i, 10)) | 0) | 0, E[C + 8 >> 2] = Q, r = r + y | 0, E[C + 24 >> 2] = r, y = (h = 56 | I) + g | 0, e = (h = (((E[h + 34432 >> 2] + E[y >> 2] | 0) + e | 0) + (o ^ r & (o ^ t)) | 0) + (Lg(r, 26) ^ Lg(r, 21) ^ Lg(r, 7)) | 0) + ((Q & (c | i) | c & i) + (Lg(Q, 30) ^ Lg(Q, 19) ^ Lg(Q, 10)) | 0) | 0, E[C + 4 >> 2] = e, _ = _ + h | 0, E[C + 20 >> 2] = _, h = (I |= 60) + g | 0, _ = (I = ((o + (E[I + 34432 >> 2] + E[h >> 2] | 0) | 0) + (t ^ _ & (t ^ r)) | 0) + (Lg(_, 26) ^ Lg(_, 21) ^ Lg(_, 7)) | 0) + ((e & (Q | i) | Q & i) + (Lg(e, 30) ^ Lg(e, 19) ^ Lg(e, 10)) | 0) | 0, E[C >> 2] = _, E[C + 16 >> 2] = I + c, 48 != (0 | n);)o = E[b >> 2], n = n + 16 | 0, I = E[y >> 2], _ = (Q = E[B >> 2] + (o + (Lg(I, 15) ^ Lg(I, 13) ^ I >>> 10) | 0) | 0) + (Lg(c = E[D >> 2], 25) ^ Lg(c, 14) ^ c >>> 3) | 0, E[(n << 2) + g >> 2] = _, r = (i = (Q = (t = E[K >> 2]) + c | 0) + (Lg(c = E[h >> 2], 15) ^ Lg(c, 13) ^ c >>> 10) | 0) + (Lg(Q = E[f >> 2], 25) ^ Lg(Q, 14) ^ Q >>> 3) | 0, E[B + 68 >> 2] = r, e = (s = ((i = Q) + (Q = E[s >> 2]) | 0) + (Lg(_, 15) ^ Lg(_, 13) ^ _ >>> 10) | 0) + (Lg(i = E[k >> 2], 25) ^ Lg(i, 14) ^ i >>> 3) | 0, E[B + 72 >> 2] = e, y = (h = ((s = i) + (i = E[w >> 2]) | 0) + (Lg(r, 15) ^ Lg(r, 13) ^ r >>> 10) | 0) + (Lg(s = E[F >> 2], 25) ^ Lg(s, 14) ^ s >>> 3) | 0, E[B + 76 >> 2] = y, w = (h = ((h = s) + (s = E[p >> 2]) | 0) + (Lg(e, 15) ^ Lg(e, 13) ^ e >>> 10) | 0) + (Lg(p = E[N >> 2], 25) ^ Lg(p, 14) ^ p >>> 3) | 0, E[B + 80 >> 2] = w, p = (D = (I + p | 0) + (Lg(y, 15) ^ Lg(y, 13) ^ y >>> 10) | 0) + (Lg(h = E[S >> 2], 25) ^ Lg(h, 14) ^ h >>> 3) | 0, E[B + 84 >> 2] = p, h = ((c + h | 0) + (Lg(f = E[G >> 2], 25) ^ Lg(f, 14) ^ f >>> 3) | 0) + (Lg(w, 15) ^ Lg(w, 13) ^ w >>> 10) | 0, E[B + 88 >> 2] = h, r = ((D = E[M >> 2]) + (r + (Lg(o, 25) ^ Lg(o, 14) ^ o >>> 3) | 0) | 0) + (Lg(h, 15) ^ Lg(h, 13) ^ h >>> 10) | 0, E[B + 96 >> 2] = r, D = ((_ + f | 0) + (Lg(D, 25) ^ Lg(D, 14) ^ D >>> 3) | 0) + (Lg(p, 15) ^ Lg(p, 13) ^ p >>> 10) | 0, E[B + 92 >> 2] = D, y = (y + (t + (Lg(Q, 25) ^ Lg(Q, 14) ^ Q >>> 3) | 0) | 0) + (Lg(r, 15) ^ Lg(r, 13) ^ r >>> 10) | 0, E[B + 104 >> 2] = y, o = (e + (o + (Lg(t, 25) ^ Lg(t, 14) ^ t >>> 3) | 0) | 0) + (Lg(D, 15) ^ Lg(D, 13) ^ D >>> 10) | 0, E[B + 100 >> 2] = o, t = (p + (i + (Lg(s, 25) ^ Lg(s, 14) ^ s >>> 3) | 0) | 0) + (Lg(y, 15) ^ Lg(y, 13) ^ y >>> 10) | 0, E[B + 112 >> 2] = t, o = (w + (Q + (Lg(i, 25) ^ Lg(i, 14) ^ i >>> 3) | 0) | 0) + (Lg(o, 15) ^ Lg(o, 13) ^ o >>> 10) | 0, E[B + 108 >> 2] = o, H = B, Y = (D + (I + (Lg(c, 25) ^ Lg(c, 14) ^ c >>> 3) | 0) | 0) + (Lg(t, 15) ^ Lg(t, 13) ^ t >>> 10) | 0, E[H + 120 >> 2] = Y, I = (h + (s + (Lg(I, 25) ^ Lg(I, 14) ^ I >>> 3) | 0) | 0) + (Lg(o, 15) ^ Lg(o, 13) ^ o >>> 10) | 0, E[B + 116 >> 2] = I, H = B, Y = (r + (c + (Lg(_, 25) ^ Lg(_, 14) ^ _ >>> 3) | 0) | 0) + (Lg(I, 15) ^ Lg(I, 13) ^ I >>> 10) | 0, E[H + 124 >> 2] = Y;
                                        E[A >> 2] = _ + E[A >> 2], E[A + 4 >> 2] = E[A + 4 >> 2] + E[C + 4 >> 2], E[A + 8 >> 2] = E[A + 8 >> 2] + E[C + 8 >> 2], E[A + 12 >> 2] = E[A + 12 >> 2] + E[C + 12 >> 2], E[A + 16 >> 2] = E[A + 16 >> 2] + E[C + 16 >> 2], E[A + 20 >> 2] = E[A + 20 >> 2] + E[C + 20 >> 2], E[A + 24 >> 2] = E[A + 24 >> 2] + E[C + 24 >> 2], E[A + 28 >> 2] = E[A + 28 >> 2] + E[C + 28 >> 2];
                                    }
                                    function U(A, I, g) {
                                        var C, B, Q, i, _, c, t, r, e, y, s, D, p, w, f, n, k, F, N, S, G, M, b, K = 0, H = 0, Y = 0, d = 0, J = 0, U = 0, l = 0, m = 0;
                                        h = C = h - 288 | 0, t = a[g + 16 | 0] | a[g + 17 | 0] << 8 | a[g + 18 | 0] << 16 | a[g + 19 | 0] << 24, r = a[g + 48 | 0] | a[g + 49 | 0] << 8 | a[g + 50 | 0] << 16 | a[g + 51 | 0] << 24, e = a[g + 20 | 0] | a[g + 21 | 0] << 8 | a[g + 22 | 0] << 16 | a[g + 23 | 0] << 24, y = a[I + 4 | 0] | a[I + 5 | 0] << 8 | a[I + 6 | 0] << 16 | a[I + 7 | 0] << 24, s = a[g + 52 | 0] | a[g + 53 | 0] << 8 | a[g + 54 | 0] << 16 | a[g + 55 | 0] << 24, D = a[g + 24 | 0] | a[g + 25 | 0] << 8 | a[g + 26 | 0] << 16 | a[g + 27 | 0] << 24, p = a[I + 8 | 0] | a[I + 9 | 0] << 8 | a[I + 10 | 0] << 16 | a[I + 11 | 0] << 24, w = a[g + 56 | 0] | a[g + 57 | 0] << 8 | a[g + 58 | 0] << 16 | a[g + 59 | 0] << 24, J = a[g + 28 | 0] | a[g + 29 | 0] << 8 | a[g + 30 | 0] << 16 | a[g + 31 | 0] << 24, f = a[I + 12 | 0] | a[I + 13 | 0] << 8 | a[I + 14 | 0] << 16 | a[I + 15 | 0] << 24, n = a[g + 60 | 0] | a[g + 61 | 0] << 8 | a[g + 62 | 0] << 16 | a[g + 63 | 0] << 24, H = a[g + 32 | 0] | a[g + 33 | 0] << 8 | a[g + 34 | 0] << 16 | a[g + 35 | 0] << 24, U = a[g + 80 | 0] | a[g + 81 | 0] << 8 | a[g + 82 | 0] << 16 | a[g + 83 | 0] << 24, k = a[I + 16 | 0] | a[I + 17 | 0] << 8 | a[I + 18 | 0] << 16 | a[I + 19 | 0] << 24, F = a[g + 112 | 0] | a[g + 113 | 0] << 8 | a[g + 114 | 0] << 16 | a[g + 115 | 0] << 24, K = a[g + 96 | 0] | a[g + 97 | 0] << 8 | a[g + 98 | 0] << 16 | a[g + 99 | 0] << 24, Y = a[g + 36 | 0] | a[g + 37 | 0] << 8 | a[g + 38 | 0] << 16 | a[g + 39 | 0] << 24, l = a[g + 84 | 0] | a[g + 85 | 0] << 8 | a[g + 86 | 0] << 16 | a[g + 87 | 0] << 24, N = a[I + 20 | 0] | a[I + 21 | 0] << 8 | a[I + 22 | 0] << 16 | a[I + 23 | 0] << 24, S = a[g + 116 | 0] | a[g + 117 | 0] << 8 | a[g + 118 | 0] << 16 | a[g + 119 | 0] << 24, Q = a[g + 100 | 0] | a[g + 101 | 0] << 8 | a[g + 102 | 0] << 16 | a[g + 103 | 0] << 24, d = a[g + 40 | 0] | a[g + 41 | 0] << 8 | a[g + 42 | 0] << 16 | a[g + 43 | 0] << 24, m = a[g + 88 | 0] | a[g + 89 | 0] << 8 | a[g + 90 | 0] << 16 | a[g + 91 | 0] << 24, G = a[I + 24 | 0] | a[I + 25 | 0] << 8 | a[I + 26 | 0] << 16 | a[I + 27 | 0] << 24, M = a[g + 120 | 0] | a[g + 121 | 0] << 8 | a[g + 122 | 0] << 16 | a[g + 123 | 0] << 24, i = a[g + 104 | 0] | a[g + 105 | 0] << 8 | a[g + 106 | 0] << 16 | a[g + 107 | 0] << 24, b = a[0 | I] | a[I + 1 | 0] << 8 | a[I + 2 | 0] << 16 | a[I + 3 | 0] << 24, B = (_ = a[g + 44 | 0] | a[g + 45 | 0] << 8 | a[g + 46 | 0] << 16 | a[g + 47 | 0] << 24) ^ (c = a[g + 108 | 0] | a[g + 109 | 0] << 8 | a[g + 110 | 0] << 16 | a[g + 111 | 0] << 24) & (a[g + 124 | 0] | a[g + 125 | 0] << 8 | a[g + 126 | 0] << 16 | a[g + 127 | 0] << 24) ^ (a[g + 92 | 0] | a[g + 93 | 0] << 8 | a[g + 94 | 0] << 16 | a[g + 95 | 0] << 24) ^ (a[I + 28 | 0] | a[I + 29 | 0] << 8 | a[I + 30 | 0] << 16 | a[I + 31 | 0] << 24), o[A + 28 | 0] = B, o[A + 29 | 0] = B >>> 8, o[A + 30 | 0] = B >>> 16, o[A + 31 | 0] = B >>> 24, m = d ^ i & M ^ m ^ G, o[A + 24 | 0] = m, o[A + 25 | 0] = m >>> 8, o[A + 26 | 0] = m >>> 16, o[A + 27 | 0] = m >>> 24, l = Y ^ Q & S ^ l ^ N, o[A + 20 | 0] = l, o[A + 21 | 0] = l >>> 8, o[A + 22 | 0] = l >>> 16, o[A + 23 | 0] = l >>> 24, U = H ^ K & F ^ U ^ k, o[A + 16 | 0] = U, o[A + 17 | 0] = U >>> 8, o[A + 18 | 0] = U >>> 16, o[A + 19 | 0] = U >>> 24, J = n & _ ^ J ^ f ^ c, o[A + 12 | 0] = J, o[A + 13 | 0] = J >>> 8, o[A + 14 | 0] = J >>> 16, o[A + 15 | 0] = J >>> 24, d = d & w ^ D ^ p ^ i, o[A + 8 | 0] = d, o[A + 9 | 0] = d >>> 8, o[A + 10 | 0] = d >>> 16, o[A + 11 | 0] = d >>> 24, Y = Y & s ^ e ^ y ^ Q, o[A + 4 | 0] = Y, o[A + 5 | 0] = Y >>> 8, o[A + 6 | 0] = Y >>> 16, o[A + 7 | 0] = Y >>> 24, H = K ^ H & r ^ t ^ b, o[0 | A] = H, o[A + 1 | 0] = H >>> 8, o[A + 2 | 0] = H >>> 16, o[A + 3 | 0] = H >>> 24, A = E[g + 124 >> 2], E[C + 280 >> 2] = E[g + 120 >> 2], E[C + 284 >> 2] = A, A = E[g + 116 >> 2], E[C + 272 >> 2] = E[g + 112 >> 2], E[C + 276 >> 2] = A, A = E[g + 108 >> 2], E[C + 248 >> 2] = E[g + 104 >> 2], E[C + 252 >> 2] = A, A = E[g + 100 >> 2], E[C + 240 >> 2] = E[g + 96 >> 2], E[C + 244 >> 2] = A, A = E[g + 124 >> 2], E[C + 232 >> 2] = E[g + 120 >> 2], E[C + 236 >> 2] = A, A = E[g + 116 >> 2], E[C + 224 >> 2] = E[g + 112 >> 2], E[C + 228 >> 2] = A, $A(I = C + 256 | 0, C + 240 | 0, C + 224 | 0), A = E[C + 268 >> 2], E[g + 120 >> 2] = E[C + 264 >> 2], E[g + 124 >> 2] = A, A = E[C + 260 >> 2], E[g + 112 >> 2] = E[C + 256 >> 2], E[g + 116 >> 2] = A, A = E[g + 92 >> 2], E[C + 216 >> 2] = E[g + 88 >> 2], E[C + 220 >> 2] = A, A = E[g + 84 >> 2], E[C + 208 >> 2] = E[g + 80 >> 2], E[C + 212 >> 2] = A, A = E[g + 108 >> 2], E[C + 200 >> 2] = E[g + 104 >> 2], E[C + 204 >> 2] = A, A = E[g + 100 >> 2], E[C + 192 >> 2] = E[g + 96 >> 2], E[C + 196 >> 2] = A, $A(I, C + 208 | 0, C + 192 | 0), A = E[C + 268 >> 2], E[g + 104 >> 2] = E[C + 264 >> 2], E[g + 108 >> 2] = A, A = E[C + 260 >> 2], E[g + 96 >> 2] = E[C + 256 >> 2], E[g + 100 >> 2] = A, A = E[g + 76 >> 2], E[C + 184 >> 2] = E[g + 72 >> 2], E[C + 188 >> 2] = A, K = E[4 + (A = g - -64 | 0) >> 2], E[C + 176 >> 2] = E[A >> 2], E[C + 180 >> 2] = K, K = E[g + 92 >> 2], E[C + 168 >> 2] = E[g + 88 >> 2], E[C + 172 >> 2] = K, K = E[g + 84 >> 2], E[C + 160 >> 2] = E[g + 80 >> 2], E[C + 164 >> 2] = K, $A(I, C + 176 | 0, C + 160 | 0), K = E[C + 268 >> 2], E[g + 88 >> 2] = E[C + 264 >> 2], E[g + 92 >> 2] = K, K = E[C + 260 >> 2], E[g + 80 >> 2] = E[C + 256 >> 2], E[g + 84 >> 2] = K, K = E[g + 60 >> 2], E[C + 152 >> 2] = E[g + 56 >> 2], E[C + 156 >> 2] = K, K = E[g + 52 >> 2], E[C + 144 >> 2] = E[g + 48 >> 2], E[C + 148 >> 2] = K, K = E[g + 76 >> 2], E[C + 136 >> 2] = E[g + 72 >> 2], E[C + 140 >> 2] = K, K = E[A + 4 >> 2], E[C + 128 >> 2] = E[A >> 2], E[C + 132 >> 2] = K, $A(I, C + 144 | 0, C + 128 | 0), K = E[C + 268 >> 2], E[g + 72 >> 2] = E[C + 264 >> 2], E[g + 76 >> 2] = K, K = E[C + 260 >> 2], E[A >> 2] = E[C + 256 >> 2], E[A + 4 >> 2] = K, K = E[g + 44 >> 2], E[C + 120 >> 2] = E[g + 40 >> 2], E[C + 124 >> 2] = K, K = E[g + 36 >> 2], E[C + 112 >> 2] = E[g + 32 >> 2], E[C + 116 >> 2] = K, K = E[g + 60 >> 2], E[C + 104 >> 2] = E[g + 56 >> 2], E[C + 108 >> 2] = K, K = E[g + 52 >> 2], E[C + 96 >> 2] = E[g + 48 >> 2], E[C + 100 >> 2] = K, $A(I, C + 112 | 0, C + 96 | 0), K = E[C + 268 >> 2], E[g + 56 >> 2] = E[C + 264 >> 2], E[g + 60 >> 2] = K, K = E[C + 260 >> 2], E[g + 48 >> 2] = E[C + 256 >> 2], E[g + 52 >> 2] = K, K = E[g + 28 >> 2], E[C + 88 >> 2] = E[g + 24 >> 2], E[C + 92 >> 2] = K, K = E[g + 20 >> 2], E[C + 80 >> 2] = E[g + 16 >> 2], E[C + 84 >> 2] = K, K = E[g + 44 >> 2], E[C + 72 >> 2] = E[g + 40 >> 2], E[C + 76 >> 2] = K, K = E[g + 36 >> 2], E[C + 64 >> 2] = E[g + 32 >> 2], E[C + 68 >> 2] = K, $A(I, C + 80 | 0, C - -64 | 0), K = E[C + 268 >> 2], E[g + 40 >> 2] = E[C + 264 >> 2], E[g + 44 >> 2] = K, K = E[C + 260 >> 2], E[g + 32 >> 2] = E[C + 256 >> 2], E[g + 36 >> 2] = K, K = E[g + 12 >> 2], E[C + 56 >> 2] = E[g + 8 >> 2], E[C + 60 >> 2] = K, K = E[g + 4 >> 2], E[C + 48 >> 2] = E[g >> 2], E[C + 52 >> 2] = K, K = E[g + 28 >> 2], E[C + 40 >> 2] = E[g + 24 >> 2], E[C + 44 >> 2] = K, K = E[g + 20 >> 2], E[C + 32 >> 2] = E[g + 16 >> 2], E[C + 36 >> 2] = K, $A(I, C + 48 | 0, C + 32 | 0), K = E[C + 268 >> 2], E[g + 24 >> 2] = E[C + 264 >> 2], E[g + 28 >> 2] = K, K = E[C + 260 >> 2], E[g + 16 >> 2] = E[C + 256 >> 2], E[g + 20 >> 2] = K, K = E[C + 284 >> 2], E[C + 24 >> 2] = E[C + 280 >> 2], E[C + 28 >> 2] = K, K = E[C + 276 >> 2], E[C + 16 >> 2] = E[C + 272 >> 2], E[C + 20 >> 2] = K, K = E[g + 12 >> 2], E[C + 8 >> 2] = E[g + 8 >> 2], E[C + 12 >> 2] = K, K = E[g + 4 >> 2], E[C >> 2] = E[g >> 2], E[C + 4 >> 2] = K, $A(I, C + 16 | 0, C), I = E[C + 268 >> 2], E[g + 8 >> 2] = E[C + 264 >> 2], E[g + 12 >> 2] = I, I = E[C + 260 >> 2], E[g >> 2] = E[C + 256 >> 2], E[g + 4 >> 2] = I, E[g + 12 >> 2] = J ^ (a[g + 12 | 0] | a[g + 13 | 0] << 8 | a[g + 14 | 0] << 16 | a[g + 15 | 0] << 24), E[g + 8 >> 2] = d ^ (a[g + 8 | 0] | a[g + 9 | 0] << 8 | a[g + 10 | 0] << 16 | a[g + 11 | 0] << 24), E[g + 4 >> 2] = Y ^ (a[g + 4 | 0] | a[g + 5 | 0] << 8 | a[g + 6 | 0] << 16 | a[g + 7 | 0] << 24), E[g >> 2] = H ^ (a[0 | g] | a[g + 1 | 0] << 8 | a[g + 2 | 0] << 16 | a[g + 3 | 0] << 24), E[A >> 2] = U ^ (a[0 | A] | a[A + 1 | 0] << 8 | a[A + 2 | 0] << 16 | a[A + 3 | 0] << 24), E[g + 68 >> 2] = l ^ (a[g + 68 | 0] | a[g + 69 | 0] << 8 | a[g + 70 | 0] << 16 | a[g + 71 | 0] << 24), E[g + 72 >> 2] = m ^ (a[g + 72 | 0] | a[g + 73 | 0] << 8 | a[g + 74 | 0] << 16 | a[g + 75 | 0] << 24), E[g + 76 >> 2] = B ^ (a[g + 76 | 0] | a[g + 77 | 0] << 8 | a[g + 78 | 0] << 16 | a[g + 79 | 0] << 24), h = C + 288 | 0;
                                    }
                                    function l(A, I, g) {
                                        var C, B, Q, i, _, c, t, r, e, y, s, D, p, w, f, n, k, F, N, S, G, M, b, K, H, Y, d, J, U, l, m = 0;
                                        h = C = h - 288 | 0, k = a[g + 16 | 0] | a[g + 17 | 0] << 8 | a[g + 18 | 0] << 16 | a[g + 19 | 0] << 24, F = a[g + 48 | 0] | a[g + 49 | 0] << 8 | a[g + 50 | 0] << 16 | a[g + 51 | 0] << 24, B = a[I + 4 | 0] | a[I + 5 | 0] << 8 | a[I + 6 | 0] << 16 | a[I + 7 | 0] << 24, N = a[g + 20 | 0] | a[g + 21 | 0] << 8 | a[g + 22 | 0] << 16 | a[g + 23 | 0] << 24, S = a[g + 52 | 0] | a[g + 53 | 0] << 8 | a[g + 54 | 0] << 16 | a[g + 55 | 0] << 24, Q = a[I + 8 | 0] | a[I + 9 | 0] << 8 | a[I + 10 | 0] << 16 | a[I + 11 | 0] << 24, G = a[g + 24 | 0] | a[g + 25 | 0] << 8 | a[g + 26 | 0] << 16 | a[g + 27 | 0] << 24, M = a[g + 56 | 0] | a[g + 57 | 0] << 8 | a[g + 58 | 0] << 16 | a[g + 59 | 0] << 24, i = a[I + 12 | 0] | a[I + 13 | 0] << 8 | a[I + 14 | 0] << 16 | a[I + 15 | 0] << 24, b = a[g + 28 | 0] | a[g + 29 | 0] << 8 | a[g + 30 | 0] << 16 | a[g + 31 | 0] << 24, K = a[g + 60 | 0] | a[g + 61 | 0] << 8 | a[g + 62 | 0] << 16 | a[g + 63 | 0] << 24, m = a[g + 32 | 0] | a[g + 33 | 0] << 8 | a[g + 34 | 0] << 16 | a[g + 35 | 0] << 24, _ = a[I + 16 | 0] | a[I + 17 | 0] << 8 | a[I + 18 | 0] << 16 | a[I + 19 | 0] << 24, H = a[g + 80 | 0] | a[g + 81 | 0] << 8 | a[g + 82 | 0] << 16 | a[g + 83 | 0] << 24, Y = a[g + 112 | 0] | a[g + 113 | 0] << 8 | a[g + 114 | 0] << 16 | a[g + 115 | 0] << 24, c = a[g + 96 | 0] | a[g + 97 | 0] << 8 | a[g + 98 | 0] << 16 | a[g + 99 | 0] << 24, t = a[g + 36 | 0] | a[g + 37 | 0] << 8 | a[g + 38 | 0] << 16 | a[g + 39 | 0] << 24, r = a[I + 20 | 0] | a[I + 21 | 0] << 8 | a[I + 22 | 0] << 16 | a[I + 23 | 0] << 24, d = a[g + 84 | 0] | a[g + 85 | 0] << 8 | a[g + 86 | 0] << 16 | a[g + 87 | 0] << 24, J = a[g + 116 | 0] | a[g + 117 | 0] << 8 | a[g + 118 | 0] << 16 | a[g + 119 | 0] << 24, e = a[g + 100 | 0] | a[g + 101 | 0] << 8 | a[g + 102 | 0] << 16 | a[g + 103 | 0] << 24, y = a[g + 40 | 0] | a[g + 41 | 0] << 8 | a[g + 42 | 0] << 16 | a[g + 43 | 0] << 24, s = a[I + 24 | 0] | a[I + 25 | 0] << 8 | a[I + 26 | 0] << 16 | a[I + 27 | 0] << 24, U = a[g + 88 | 0] | a[g + 89 | 0] << 8 | a[g + 90 | 0] << 16 | a[g + 91 | 0] << 24, l = a[g + 120 | 0] | a[g + 121 | 0] << 8 | a[g + 122 | 0] << 16 | a[g + 123 | 0] << 24, D = a[g + 104 | 0] | a[g + 105 | 0] << 8 | a[g + 106 | 0] << 16 | a[g + 107 | 0] << 24, p = a[0 | I] | a[I + 1 | 0] << 8 | a[I + 2 | 0] << 16 | a[I + 3 | 0] << 24, I = (w = a[g + 44 | 0] | a[g + 45 | 0] << 8 | a[g + 46 | 0] << 16 | a[g + 47 | 0] << 24) ^ (f = a[I + 28 | 0] | a[I + 29 | 0] << 8 | a[I + 30 | 0] << 16 | a[I + 31 | 0] << 24) ^ (n = a[g + 108 | 0] | a[g + 109 | 0] << 8 | a[g + 110 | 0] << 16 | a[g + 111 | 0] << 24) & (a[g + 124 | 0] | a[g + 125 | 0] << 8 | a[g + 126 | 0] << 16 | a[g + 127 | 0] << 24) ^ (a[g + 92 | 0] | a[g + 93 | 0] << 8 | a[g + 94 | 0] << 16 | a[g + 95 | 0] << 24), o[A + 28 | 0] = I, o[A + 29 | 0] = I >>> 8, o[A + 30 | 0] = I >>> 16, o[A + 31 | 0] = I >>> 24, I = D & l ^ U ^ s ^ y, o[A + 24 | 0] = I, o[A + 25 | 0] = I >>> 8, o[A + 26 | 0] = I >>> 16, o[A + 27 | 0] = I >>> 24, I = e & J ^ d ^ r ^ t, o[A + 20 | 0] = I, o[A + 21 | 0] = I >>> 8, o[A + 22 | 0] = I >>> 16, o[A + 23 | 0] = I >>> 24, I = m ^ c & Y ^ H ^ _, o[A + 16 | 0] = I, o[A + 17 | 0] = I >>> 8, o[A + 18 | 0] = I >>> 16, o[A + 19 | 0] = I >>> 24, I = K & w ^ b ^ i ^ n, o[A + 12 | 0] = I, o[A + 13 | 0] = I >>> 8, o[A + 14 | 0] = I >>> 16, o[A + 15 | 0] = I >>> 24, I = y & M ^ G ^ Q ^ D, o[A + 8 | 0] = I, o[A + 9 | 0] = I >>> 8, o[A + 10 | 0] = I >>> 16, o[A + 11 | 0] = I >>> 24, I = t & S ^ N ^ B ^ e, o[A + 4 | 0] = I, o[A + 5 | 0] = I >>> 8, o[A + 6 | 0] = I >>> 16, o[A + 7 | 0] = I >>> 24, I = m & F ^ k ^ p ^ c, o[0 | A] = I, o[A + 1 | 0] = I >>> 8, o[A + 2 | 0] = I >>> 16, o[A + 3 | 0] = I >>> 24, A = E[g + 124 >> 2], E[C + 280 >> 2] = E[g + 120 >> 2], E[C + 284 >> 2] = A, A = E[g + 116 >> 2], E[C + 272 >> 2] = E[g + 112 >> 2], E[C + 276 >> 2] = A, A = E[g + 108 >> 2], E[C + 248 >> 2] = E[g + 104 >> 2], E[C + 252 >> 2] = A, A = E[g + 100 >> 2], E[C + 240 >> 2] = E[g + 96 >> 2], E[C + 244 >> 2] = A, A = E[g + 124 >> 2], E[C + 232 >> 2] = E[g + 120 >> 2], E[C + 236 >> 2] = A, A = E[g + 116 >> 2], E[C + 224 >> 2] = E[g + 112 >> 2], E[C + 228 >> 2] = A, $A(I = C + 256 | 0, C + 240 | 0, C + 224 | 0), A = E[C + 268 >> 2], E[g + 120 >> 2] = E[C + 264 >> 2], E[g + 124 >> 2] = A, A = E[C + 260 >> 2], E[g + 112 >> 2] = E[C + 256 >> 2], E[g + 116 >> 2] = A, A = E[g + 92 >> 2], E[C + 216 >> 2] = E[g + 88 >> 2], E[C + 220 >> 2] = A, A = E[g + 84 >> 2], E[C + 208 >> 2] = E[g + 80 >> 2], E[C + 212 >> 2] = A, A = E[g + 108 >> 2], E[C + 200 >> 2] = E[g + 104 >> 2], E[C + 204 >> 2] = A, A = E[g + 100 >> 2], E[C + 192 >> 2] = E[g + 96 >> 2], E[C + 196 >> 2] = A, $A(I, C + 208 | 0, C + 192 | 0), A = E[C + 268 >> 2], E[g + 104 >> 2] = E[C + 264 >> 2], E[g + 108 >> 2] = A, A = E[C + 260 >> 2], E[g + 96 >> 2] = E[C + 256 >> 2], E[g + 100 >> 2] = A, A = E[g + 76 >> 2], E[C + 184 >> 2] = E[g + 72 >> 2], E[C + 188 >> 2] = A, m = E[4 + (A = g - -64 | 0) >> 2], E[C + 176 >> 2] = E[A >> 2], E[C + 180 >> 2] = m, m = E[g + 92 >> 2], E[C + 168 >> 2] = E[g + 88 >> 2], E[C + 172 >> 2] = m, m = E[g + 84 >> 2], E[C + 160 >> 2] = E[g + 80 >> 2], E[C + 164 >> 2] = m, $A(I, C + 176 | 0, C + 160 | 0), m = E[C + 268 >> 2], E[g + 88 >> 2] = E[C + 264 >> 2], E[g + 92 >> 2] = m, m = E[C + 260 >> 2], E[g + 80 >> 2] = E[C + 256 >> 2], E[g + 84 >> 2] = m, m = E[g + 60 >> 2], E[C + 152 >> 2] = E[g + 56 >> 2], E[C + 156 >> 2] = m, m = E[g + 52 >> 2], E[C + 144 >> 2] = E[g + 48 >> 2], E[C + 148 >> 2] = m, m = E[g + 76 >> 2], E[C + 136 >> 2] = E[g + 72 >> 2], E[C + 140 >> 2] = m, m = E[A + 4 >> 2], E[C + 128 >> 2] = E[A >> 2], E[C + 132 >> 2] = m, $A(I, C + 144 | 0, C + 128 | 0), m = E[C + 268 >> 2], E[g + 72 >> 2] = E[C + 264 >> 2], E[g + 76 >> 2] = m, m = E[C + 260 >> 2], E[A >> 2] = E[C + 256 >> 2], E[A + 4 >> 2] = m, m = E[g + 44 >> 2], E[C + 120 >> 2] = E[g + 40 >> 2], E[C + 124 >> 2] = m, m = E[g + 36 >> 2], E[C + 112 >> 2] = E[g + 32 >> 2], E[C + 116 >> 2] = m, m = E[g + 60 >> 2], E[C + 104 >> 2] = E[g + 56 >> 2], E[C + 108 >> 2] = m, m = E[g + 52 >> 2], E[C + 96 >> 2] = E[g + 48 >> 2], E[C + 100 >> 2] = m, $A(I, C + 112 | 0, C + 96 | 0), m = E[C + 268 >> 2], E[g + 56 >> 2] = E[C + 264 >> 2], E[g + 60 >> 2] = m, m = E[C + 260 >> 2], E[g + 48 >> 2] = E[C + 256 >> 2], E[g + 52 >> 2] = m, m = E[g + 28 >> 2], E[C + 88 >> 2] = E[g + 24 >> 2], E[C + 92 >> 2] = m, m = E[g + 20 >> 2], E[C + 80 >> 2] = E[g + 16 >> 2], E[C + 84 >> 2] = m, m = E[g + 44 >> 2], E[C + 72 >> 2] = E[g + 40 >> 2], E[C + 76 >> 2] = m, m = E[g + 36 >> 2], E[C + 64 >> 2] = E[g + 32 >> 2], E[C + 68 >> 2] = m, $A(I, C + 80 | 0, C - -64 | 0), m = E[C + 268 >> 2], E[g + 40 >> 2] = E[C + 264 >> 2], E[g + 44 >> 2] = m, m = E[C + 260 >> 2], E[g + 32 >> 2] = E[C + 256 >> 2], E[g + 36 >> 2] = m, m = E[g + 12 >> 2], E[C + 56 >> 2] = E[g + 8 >> 2], E[C + 60 >> 2] = m, m = E[g + 4 >> 2], E[C + 48 >> 2] = E[g >> 2], E[C + 52 >> 2] = m, m = E[g + 28 >> 2], E[C + 40 >> 2] = E[g + 24 >> 2], E[C + 44 >> 2] = m, m = E[g + 20 >> 2], E[C + 32 >> 2] = E[g + 16 >> 2], E[C + 36 >> 2] = m, $A(I, C + 48 | 0, C + 32 | 0), m = E[C + 268 >> 2], E[g + 24 >> 2] = E[C + 264 >> 2], E[g + 28 >> 2] = m, m = E[C + 260 >> 2], E[g + 16 >> 2] = E[C + 256 >> 2], E[g + 20 >> 2] = m, m = E[C + 284 >> 2], E[C + 24 >> 2] = E[C + 280 >> 2], E[C + 28 >> 2] = m, m = E[C + 276 >> 2], E[C + 16 >> 2] = E[C + 272 >> 2], E[C + 20 >> 2] = m, m = E[g + 12 >> 2], E[C + 8 >> 2] = E[g + 8 >> 2], E[C + 12 >> 2] = m, m = E[g + 4 >> 2], E[C >> 2] = E[g >> 2], E[C + 4 >> 2] = m, $A(I, C + 16 | 0, C), I = E[C + 268 >> 2], E[g + 8 >> 2] = E[C + 264 >> 2], E[g + 12 >> 2] = I, I = E[C + 260 >> 2], E[g >> 2] = E[C + 256 >> 2], E[g + 4 >> 2] = I, E[g + 12 >> 2] = (a[g + 12 | 0] | a[g + 13 | 0] << 8 | a[g + 14 | 0] << 16 | a[g + 15 | 0] << 24) ^ i, E[g + 8 >> 2] = (a[g + 8 | 0] | a[g + 9 | 0] << 8 | a[g + 10 | 0] << 16 | a[g + 11 | 0] << 24) ^ Q, E[g + 4 >> 2] = (a[g + 4 | 0] | a[g + 5 | 0] << 8 | a[g + 6 | 0] << 16 | a[g + 7 | 0] << 24) ^ B, E[g >> 2] = (a[0 | g] | a[g + 1 | 0] << 8 | a[g + 2 | 0] << 16 | a[g + 3 | 0] << 24) ^ p, E[A >> 2] = (a[0 | A] | a[A + 1 | 0] << 8 | a[A + 2 | 0] << 16 | a[A + 3 | 0] << 24) ^ _, E[g + 68 >> 2] = (a[g + 68 | 0] | a[g + 69 | 0] << 8 | a[g + 70 | 0] << 16 | a[g + 71 | 0] << 24) ^ r, E[g + 72 >> 2] = (a[g + 72 | 0] | a[g + 73 | 0] << 8 | a[g + 74 | 0] << 16 | a[g + 75 | 0] << 24) ^ s, E[g + 76 >> 2] = f ^ (a[g + 76 | 0] | a[g + 77 | 0] << 8 | a[g + 78 | 0] << 16 | a[g + 79 | 0] << 24), h = C + 288 | 0;
                                    }
                                    function m(A, I, g, C, B) {
                                        var Q, i = 0, _ = 0, c = 0, t = 0, r = 0, e = 0, y = 0, s = 0, D = 0, p = 0, w = 0, f = 0, n = 0, k = 0, F = 0, N = 0;
                                        for(h = Q = h - 224 | 0, p = (a[B + 60 | 0] | a[B + 61 | 0] << 8 | a[B + 62 | 0] << 16 | a[B + 63 | 0] << 24) ^ C >>> 29, w = (a[B + 56 | 0] | a[B + 57 | 0] << 8 | a[B + 58 | 0] << 16 | a[B + 59 | 0] << 24) ^ C << 3, e = (a[B + 52 | 0] | a[B + 53 | 0] << 8 | a[B + 54 | 0] << 16 | a[B + 55 | 0] << 24) ^ g >>> 29, s = (a[0 | (i = B + 48 | 0)] | a[i + 1 | 0] << 8 | a[i + 2 | 0] << 16 | a[i + 3 | 0] << 24) ^ g << 3, _ = B + 16 | 0, c = B + 32 | 0, t = B - -64 | 0, r = B + 80 | 0; g = E[r + 12 >> 2], E[Q + 216 >> 2] = E[r + 8 >> 2], E[Q + 220 >> 2] = g, g = E[r + 4 >> 2], E[Q + 208 >> 2] = E[r >> 2], E[Q + 212 >> 2] = g, g = E[t + 12 >> 2], E[Q + 184 >> 2] = E[t + 8 >> 2], E[Q + 188 >> 2] = g, g = E[t + 4 >> 2], E[Q + 176 >> 2] = E[t >> 2], E[Q + 180 >> 2] = g, g = E[r + 12 >> 2], E[Q + 168 >> 2] = E[r + 8 >> 2], E[Q + 172 >> 2] = g, g = E[r + 4 >> 2], E[Q + 160 >> 2] = E[r >> 2], E[Q + 164 >> 2] = g, $A(C = Q + 192 | 0, Q + 176 | 0, Q + 160 | 0), g = E[Q + 204 >> 2], E[r + 8 >> 2] = E[Q + 200 >> 2], E[r + 12 >> 2] = g, g = E[Q + 196 >> 2], E[r >> 2] = E[Q + 192 >> 2], E[r + 4 >> 2] = g, g = E[i + 12 >> 2], E[Q + 152 >> 2] = E[i + 8 >> 2], E[Q + 156 >> 2] = g, g = E[i + 4 >> 2], E[Q + 144 >> 2] = E[i >> 2], E[Q + 148 >> 2] = g, g = E[t + 12 >> 2], E[Q + 136 >> 2] = E[t + 8 >> 2], E[Q + 140 >> 2] = g, g = E[t + 4 >> 2], E[Q + 128 >> 2] = E[t >> 2], E[Q + 132 >> 2] = g, $A(C, Q + 144 | 0, Q + 128 | 0), g = E[Q + 204 >> 2], E[t + 8 >> 2] = E[Q + 200 >> 2], E[t + 12 >> 2] = g, g = E[Q + 196 >> 2], E[t >> 2] = E[Q + 192 >> 2], E[t + 4 >> 2] = g, g = E[c + 12 >> 2], E[Q + 120 >> 2] = E[c + 8 >> 2], E[Q + 124 >> 2] = g, g = E[c + 4 >> 2], E[Q + 112 >> 2] = E[c >> 2], E[Q + 116 >> 2] = g, g = E[i + 12 >> 2], E[Q + 104 >> 2] = E[i + 8 >> 2], E[Q + 108 >> 2] = g, g = E[i + 4 >> 2], E[Q + 96 >> 2] = E[i >> 2], E[Q + 100 >> 2] = g, $A(C, Q + 112 | 0, Q + 96 | 0), g = E[Q + 204 >> 2], E[i + 8 >> 2] = E[Q + 200 >> 2], E[i + 12 >> 2] = g, g = E[Q + 196 >> 2], E[i >> 2] = E[Q + 192 >> 2], E[i + 4 >> 2] = g, g = E[_ + 12 >> 2], E[Q + 88 >> 2] = E[_ + 8 >> 2], E[Q + 92 >> 2] = g, g = E[_ + 4 >> 2], E[Q + 80 >> 2] = E[_ >> 2], E[Q + 84 >> 2] = g, g = E[c + 12 >> 2], E[Q + 72 >> 2] = E[c + 8 >> 2], E[Q + 76 >> 2] = g, g = E[c + 4 >> 2], E[Q + 64 >> 2] = E[c >> 2], E[Q + 68 >> 2] = g, $A(C, Q + 80 | 0, Q - -64 | 0), g = E[Q + 204 >> 2], E[c + 8 >> 2] = E[Q + 200 >> 2], E[c + 12 >> 2] = g, g = E[Q + 196 >> 2], E[c >> 2] = E[Q + 192 >> 2], E[c + 4 >> 2] = g, g = E[B + 12 >> 2], E[Q + 56 >> 2] = E[B + 8 >> 2], E[Q + 60 >> 2] = g, g = E[B + 4 >> 2], E[Q + 48 >> 2] = E[B >> 2], E[Q + 52 >> 2] = g, g = E[_ + 12 >> 2], E[Q + 40 >> 2] = E[_ + 8 >> 2], E[Q + 44 >> 2] = g, g = E[_ + 4 >> 2], E[Q + 32 >> 2] = E[_ >> 2], E[Q + 36 >> 2] = g, $A(C, Q + 48 | 0, Q + 32 | 0), g = E[Q + 204 >> 2], E[_ + 8 >> 2] = E[Q + 200 >> 2], E[_ + 12 >> 2] = g, g = E[Q + 196 >> 2], E[_ >> 2] = E[Q + 192 >> 2], E[_ + 4 >> 2] = g, g = E[Q + 220 >> 2], E[Q + 24 >> 2] = E[Q + 216 >> 2], E[Q + 28 >> 2] = g, g = E[Q + 212 >> 2], E[Q + 16 >> 2] = E[Q + 208 >> 2], E[Q + 20 >> 2] = g, g = E[B + 12 >> 2], E[Q + 8 >> 2] = E[B + 8 >> 2], E[Q + 12 >> 2] = g, g = E[B + 4 >> 2], E[Q >> 2] = E[B >> 2], E[Q + 4 >> 2] = g, $A(C, Q + 16 | 0, Q), D = E[Q + 192 >> 2], C = E[Q + 196 >> 2], g = E[Q + 200 >> 2], f = p ^ E[Q + 204 >> 2], E[B + 12 >> 2] = f, n = g ^ w, E[B + 8 >> 2] = n, k = C ^ e, E[B + 4 >> 2] = k, F = s ^ D, E[B >> 2] = F, 7 != (0 | (y = y + 1 | 0)););
                                        A: {
                                            I: {
                                                g: {
                                                    if (g = I - 16 | 0) {
                                                        if (16 == (0 | g)) break g;
                                                        break I;
                                                    }
                                                    N = a[B + 16 | 0] | a[B + 17 | 0] << 8 | a[B + 18 | 0] << 16 | a[B + 19 | 0] << 24, i = a[B + 48 | 0] | a[B + 49 | 0] << 8 | a[B + 50 | 0] << 16 | a[B + 51 | 0] << 24, _ = a[B + 32 | 0] | a[B + 33 | 0] << 8 | a[B + 34 | 0] << 16 | a[B + 35 | 0] << 24, c = a[B + 80 | 0] | a[B + 81 | 0] << 8 | a[B + 82 | 0] << 16 | a[B + 83 | 0] << 24, t = a[0 | (I = B - -64 | 0)] | a[I + 1 | 0] << 8 | a[I + 2 | 0] << 16 | a[I + 3 | 0] << 24, r = a[B + 20 | 0] | a[B + 21 | 0] << 8 | a[B + 22 | 0] << 16 | a[B + 23 | 0] << 24, p = a[B + 52 | 0] | a[B + 53 | 0] << 8 | a[B + 54 | 0] << 16 | a[B + 55 | 0] << 24, w = a[B + 36 | 0] | a[B + 37 | 0] << 8 | a[B + 38 | 0] << 16 | a[B + 39 | 0] << 24, e = a[B + 84 | 0] | a[B + 85 | 0] << 8 | a[B + 86 | 0] << 16 | a[B + 87 | 0] << 24, s = a[B + 68 | 0] | a[B + 69 | 0] << 8 | a[B + 70 | 0] << 16 | a[B + 71 | 0] << 24, D = a[B + 24 | 0] | a[B + 25 | 0] << 8 | a[B + 26 | 0] << 16 | a[B + 27 | 0] << 24, y = a[B + 56 | 0] | a[B + 57 | 0] << 8 | a[B + 58 | 0] << 16 | a[B + 59 | 0] << 24, C = a[B + 40 | 0] | a[B + 41 | 0] << 8 | a[B + 42 | 0] << 16 | a[B + 43 | 0] << 24, g = a[B + 88 | 0] | a[B + 89 | 0] << 8 | a[B + 90 | 0] << 16 | a[B + 91 | 0] << 24, I = a[B + 72 | 0] | a[B + 73 | 0] << 8 | a[B + 74 | 0] << 16 | a[B + 75 | 0] << 24, B = f ^ (a[B + 28 | 0] | a[B + 29 | 0] << 8 | a[B + 30 | 0] << 16 | a[B + 31 | 0] << 24) ^ (a[B + 60 | 0] | a[B + 61 | 0] << 8 | a[B + 62 | 0] << 16 | a[B + 63 | 0] << 24) ^ (a[B + 44 | 0] | a[B + 45 | 0] << 8 | a[B + 46 | 0] << 16 | a[B + 47 | 0] << 24) ^ (a[B + 92 | 0] | a[B + 93 | 0] << 8 | a[B + 94 | 0] << 16 | a[B + 95 | 0] << 24) ^ (a[B + 76 | 0] | a[B + 77 | 0] << 8 | a[B + 78 | 0] << 16 | a[B + 79 | 0] << 24), o[A + 12 | 0] = B, o[A + 13 | 0] = B >>> 8, o[A + 14 | 0] = B >>> 16, o[A + 15 | 0] = B >>> 24, I = n ^ D ^ I ^ g ^ C ^ y, o[A + 8 | 0] = I, o[A + 9 | 0] = I >>> 8, o[A + 10 | 0] = I >>> 16, o[A + 11 | 0] = I >>> 24, I = k ^ r ^ p ^ w ^ e ^ s, o[A + 4 | 0] = I, o[A + 5 | 0] = I >>> 8, o[A + 6 | 0] = I >>> 16, o[A + 7 | 0] = I >>> 24, I = F ^ N ^ i ^ _ ^ c ^ t, o[0 | A] = I, o[A + 1 | 0] = I >>> 8, o[A + 2 | 0] = I >>> 16, o[A + 3 | 0] = I >>> 24;
                                                    break A;
                                                }
                                                s = a[B + 32 | 0] | a[B + 33 | 0] << 8 | a[B + 34 | 0] << 16 | a[B + 35 | 0] << 24, D = a[B + 16 | 0] | a[B + 17 | 0] << 8 | a[B + 18 | 0] << 16 | a[B + 19 | 0] << 24, y = a[B + 36 | 0] | a[B + 37 | 0] << 8 | a[B + 38 | 0] << 16 | a[B + 39 | 0] << 24, C = a[B + 20 | 0] | a[B + 21 | 0] << 8 | a[B + 22 | 0] << 16 | a[B + 23 | 0] << 24, g = a[B + 40 | 0] | a[B + 41 | 0] << 8 | a[B + 42 | 0] << 16 | a[B + 43 | 0] << 24, I = a[B + 24 | 0] | a[B + 25 | 0] << 8 | a[B + 26 | 0] << 16 | a[B + 27 | 0] << 24, e = f ^ (a[B + 44 | 0] | a[B + 45 | 0] << 8 | a[B + 46 | 0] << 16 | a[B + 47 | 0] << 24) ^ (a[B + 28 | 0] | a[B + 29 | 0] << 8 | a[B + 30 | 0] << 16 | a[B + 31 | 0] << 24), o[A + 12 | 0] = e, o[A + 13 | 0] = e >>> 8, o[A + 14 | 0] = e >>> 16, o[A + 15 | 0] = e >>> 24, I = n ^ I ^ g, o[A + 8 | 0] = I, o[A + 9 | 0] = I >>> 8, o[A + 10 | 0] = I >>> 16, o[A + 11 | 0] = I >>> 24, I = k ^ C ^ y, o[A + 4 | 0] = I, o[A + 5 | 0] = I >>> 8, o[A + 6 | 0] = I >>> 16, o[A + 7 | 0] = I >>> 24, I = F ^ s ^ D, o[0 | A] = I, o[A + 1 | 0] = I >>> 8, o[A + 2 | 0] = I >>> 16, o[A + 3 | 0] = I >>> 24, p = a[B + 48 | 0] | a[B + 49 | 0] << 8 | a[B + 50 | 0] << 16 | a[B + 51 | 0] << 24, w = a[B + 80 | 0] | a[B + 81 | 0] << 8 | a[B + 82 | 0] << 16 | a[B + 83 | 0] << 24, e = a[0 | (I = B - -64 | 0)] | a[I + 1 | 0] << 8 | a[I + 2 | 0] << 16 | a[I + 3 | 0] << 24, s = a[B + 52 | 0] | a[B + 53 | 0] << 8 | a[B + 54 | 0] << 16 | a[B + 55 | 0] << 24, D = a[B + 84 | 0] | a[B + 85 | 0] << 8 | a[B + 86 | 0] << 16 | a[B + 87 | 0] << 24, y = a[B + 68 | 0] | a[B + 69 | 0] << 8 | a[B + 70 | 0] << 16 | a[B + 71 | 0] << 24, C = a[B + 56 | 0] | a[B + 57 | 0] << 8 | a[B + 58 | 0] << 16 | a[B + 59 | 0] << 24, g = a[B + 88 | 0] | a[B + 89 | 0] << 8 | a[B + 90 | 0] << 16 | a[B + 91 | 0] << 24, I = a[B + 72 | 0] | a[B + 73 | 0] << 8 | a[B + 74 | 0] << 16 | a[B + 75 | 0] << 24, B = (a[B + 60 | 0] | a[B + 61 | 0] << 8 | a[B + 62 | 0] << 16 | a[B + 63 | 0] << 24) ^ (a[B + 92 | 0] | a[B + 93 | 0] << 8 | a[B + 94 | 0] << 16 | a[B + 95 | 0] << 24) ^ (a[B + 76 | 0] | a[B + 77 | 0] << 8 | a[B + 78 | 0] << 16 | a[B + 79 | 0] << 24), o[A + 28 | 0] = B, o[A + 29 | 0] = B >>> 8, o[A + 30 | 0] = B >>> 16, o[A + 31 | 0] = B >>> 24, I = C ^ I ^ g, o[A + 24 | 0] = I, o[A + 25 | 0] = I >>> 8, o[A + 26 | 0] = I >>> 16, o[A + 27 | 0] = I >>> 24, I = s ^ D ^ y, o[A + 20 | 0] = I, o[A + 21 | 0] = I >>> 8, o[A + 22 | 0] = I >>> 16, o[A + 23 | 0] = I >>> 24, I = p ^ e ^ w, o[A + 16 | 0] = I, o[A + 17 | 0] = I >>> 8, o[A + 18 | 0] = I >>> 16, o[A + 19 | 0] = I >>> 24;
                                                break A;
                                            }
                                            Hg(A, 0, I);
                                        }
                                        h = Q + 224 | 0;
                                    }
                                    function u(A, I, g) {
                                        var C, B = 0, Q = 0, i = 0, _ = 0, c = 0, t = 0, r = 0, e = 0, y = 0, s = 0, D = 0, p = 0, w = 0, f = 0, n = 0, k = 0, F = 0, N = 0;
                                        for(h = C = h - 4032 | 0, TA(C + 160 | 0, g), _ = E[g + 36 >> 2], E[(i = C + 3840 | 0) >> 2] = E[g + 32 >> 2], E[i + 4 >> 2] = _, c = E[g + 28 >> 2], E[(_ = C + 3832 | 0) >> 2] = E[g + 24 >> 2], E[_ + 4 >> 2] = c, r = E[g + 20 >> 2], E[(c = C + 3824 | 0) >> 2] = E[g + 16 >> 2], E[c + 4 >> 2] = r, e = E[g + 12 >> 2], E[(r = C + 3816 | 0) >> 2] = E[g + 8 >> 2], E[r + 4 >> 2] = e, e = E[g + 4 >> 2], E[C + 3808 >> 2] = E[g >> 2], E[C + 3812 >> 2] = e, D = E[g + 52 >> 2], E[(e = C + 3856 | 0) >> 2] = E[g + 48 >> 2], E[e + 4 >> 2] = D, p = E[g + 60 >> 2], E[(D = C + 3864 | 0) >> 2] = E[g + 56 >> 2], E[D + 4 >> 2] = p, y = E[4 + (w = g - -64 | 0) >> 2], E[(p = C + 3872 | 0) >> 2] = E[w >> 2], E[p + 4 >> 2] = y, y = E[g + 76 >> 2], E[(w = C + 3880 | 0) >> 2] = E[g + 72 >> 2], E[w + 4 >> 2] = y, y = E[g + 44 >> 2], E[C + 3848 >> 2] = E[g + 40 >> 2], E[C + 3852 >> 2] = y, n = E[g + 92 >> 2], E[(y = C + 3896 | 0) >> 2] = E[g + 88 >> 2], E[y + 4 >> 2] = n, k = E[g + 100 >> 2], E[(n = C + 3904 | 0) >> 2] = E[g + 96 >> 2], E[n + 4 >> 2] = k, F = E[g + 108 >> 2], E[(k = C + 3912 | 0) >> 2] = E[g + 104 >> 2], E[k + 4 >> 2] = F, N = E[g + 116 >> 2], E[(F = C + 3920 | 0) >> 2] = E[g + 112 >> 2], E[F + 4 >> 2] = N, N = E[g + 84 >> 2], E[C + 3888 >> 2] = E[g + 80 >> 2], E[C + 3892 >> 2] = N, KA(B = C + 3528 | 0, N = C + 3808 | 0), Y(Q = C + 2408 | 0, B, t = C + 3648 | 0), Y(C + 2448 | 0, s = C + 3568 | 0, f = C + 3608 | 0), Y(C + 2488 | 0, f, t), Y(C + 2528 | 0, B, s), TA(t = C + 320 | 0, Q), sA(B = C + 3368 | 0, g, t), Y(Q = C + 2248 | 0, B, t = C + 3488 | 0), Y(C + 2288 | 0, s = C + 3408 | 0, f = C + 3448 | 0), Y(C + 2328 | 0, f, t), Y(C + 2368 | 0, B, s), TA(C + 480 | 0, Q), Q = E[4 + (B = C + 2440 | 0) >> 2], E[i >> 2] = E[B >> 2], E[i + 4 >> 2] = Q, Q = E[4 + (B = C + 2432 | 0) >> 2], E[_ >> 2] = E[B >> 2], E[_ + 4 >> 2] = Q, Q = E[4 + (B = C + 2424 | 0) >> 2], E[c >> 2] = E[B >> 2], E[c + 4 >> 2] = Q, Q = E[4 + (B = C + 2416 | 0) >> 2], E[r >> 2] = E[B >> 2], E[r + 4 >> 2] = Q, Q = E[4 + (B = C + 2456 | 0) >> 2], E[e >> 2] = E[B >> 2], E[e + 4 >> 2] = Q, Q = E[4 + (B = C + 2464 | 0) >> 2], E[D >> 2] = E[B >> 2], E[D + 4 >> 2] = Q, Q = E[4 + (B = C + 2472 | 0) >> 2], E[p >> 2] = E[B >> 2], E[p + 4 >> 2] = Q, Q = E[4 + (B = C + 2480 | 0) >> 2], E[w >> 2] = E[B >> 2], E[w + 4 >> 2] = Q, B = E[C + 2412 >> 2], E[C + 3808 >> 2] = E[C + 2408 >> 2], E[C + 3812 >> 2] = B, B = E[C + 2452 >> 2], E[C + 3848 >> 2] = E[C + 2448 >> 2], E[C + 3852 >> 2] = B, Q = E[4 + (B = C + 2520 | 0) >> 2], E[F >> 2] = E[B >> 2], E[F + 4 >> 2] = Q, Q = E[4 + (B = C + 2512 | 0) >> 2], E[k >> 2] = E[B >> 2], E[k + 4 >> 2] = Q, Q = E[4 + (B = C + 2504 | 0) >> 2], E[n >> 2] = E[B >> 2], E[n + 4 >> 2] = Q, Q = E[4 + (B = C + 2496 | 0) >> 2], E[y >> 2] = E[B >> 2], E[y + 4 >> 2] = Q, B = E[C + 2492 >> 2], E[C + 3888 >> 2] = E[C + 2488 >> 2], E[C + 3892 >> 2] = B, KA(B = C + 3208 | 0, N), Y(Q = C + 2088 | 0, B, t = C + 3328 | 0), Y(C + 2128 | 0, s = C + 3248 | 0, f = C + 3288 | 0), Y(C + 2168 | 0, f, t), Y(C + 2208 | 0, B, s), TA(t = C + 640 | 0, Q), sA(B = C + 3048 | 0, g, t), Y(Q = C + 1928 | 0, B, t = C + 3168 | 0), Y(C + 1968 | 0, s = C + 3088 | 0, f = C + 3128 | 0), Y(C + 2008 | 0, f, t), Y(C + 2048 | 0, B, s), TA(C + 800 | 0, Q), Q = E[4 + (B = C + 2280 | 0) >> 2], E[i >> 2] = E[B >> 2], E[i + 4 >> 2] = Q, Q = E[4 + (B = C + 2272 | 0) >> 2], E[_ >> 2] = E[B >> 2], E[_ + 4 >> 2] = Q, Q = E[4 + (B = C + 2264 | 0) >> 2], E[c >> 2] = E[B >> 2], E[c + 4 >> 2] = Q, Q = E[4 + (B = C + 2256 | 0) >> 2], E[r >> 2] = E[B >> 2], E[r + 4 >> 2] = Q, Q = E[4 + (B = C + 2296 | 0) >> 2], E[e >> 2] = E[B >> 2], E[e + 4 >> 2] = Q, Q = E[4 + (B = C + 2304 | 0) >> 2], E[D >> 2] = E[B >> 2], E[D + 4 >> 2] = Q, Q = E[4 + (B = C + 2312 | 0) >> 2], E[p >> 2] = E[B >> 2], E[p + 4 >> 2] = Q, Q = E[4 + (B = C + 2320 | 0) >> 2], E[w >> 2] = E[B >> 2], E[w + 4 >> 2] = Q, B = E[C + 2252 >> 2], E[C + 3808 >> 2] = E[C + 2248 >> 2], E[C + 3812 >> 2] = B, B = E[C + 2292 >> 2], E[C + 3848 >> 2] = E[C + 2288 >> 2], E[C + 3852 >> 2] = B, Q = E[4 + (B = C + 2360 | 0) >> 2], E[F >> 2] = E[B >> 2], E[F + 4 >> 2] = Q, Q = E[4 + (B = C + 2352 | 0) >> 2], E[k >> 2] = E[B >> 2], E[k + 4 >> 2] = Q, Q = E[4 + (B = C + 2344 | 0) >> 2], E[n >> 2] = E[B >> 2], E[n + 4 >> 2] = Q, Q = E[4 + (B = C + 2336 | 0) >> 2], E[y >> 2] = E[B >> 2], E[y + 4 >> 2] = Q, B = E[C + 2332 >> 2], E[C + 3888 >> 2] = E[C + 2328 >> 2], E[C + 3892 >> 2] = B, KA(B = C + 2888 | 0, N), Y(Q = C + 1768 | 0, B, t = C + 3008 | 0), Y(C + 1808 | 0, s = C + 2928 | 0, f = C + 2968 | 0), Y(C + 1848 | 0, f, t), Y(C + 1888 | 0, B, s), TA(t = C + 960 | 0, Q), sA(B = C + 2728 | 0, g, t), Y(g = C + 1608 | 0, B, Q = C + 2848 | 0), Y(C + 1648 | 0, t = C + 2768 | 0, s = C + 2808 | 0), Y(C + 1688 | 0, s, Q), Y(C + 1728 | 0, B, t), TA(C + 1120 | 0, g), B = E[4 + (g = C + 2120 | 0) >> 2], E[i >> 2] = E[g >> 2], E[i + 4 >> 2] = B, i = E[4 + (g = C + 2112 | 0) >> 2], E[_ >> 2] = E[g >> 2], E[_ + 4 >> 2] = i, i = E[4 + (g = C + 2104 | 0) >> 2], E[c >> 2] = E[g >> 2], E[c + 4 >> 2] = i, i = E[4 + (g = C + 2096 | 0) >> 2], E[r >> 2] = E[g >> 2], E[r + 4 >> 2] = i, i = E[4 + (g = C + 2136 | 0) >> 2], E[e >> 2] = E[g >> 2], E[e + 4 >> 2] = i, i = E[4 + (g = C + 2144 | 0) >> 2], E[D >> 2] = E[g >> 2], E[D + 4 >> 2] = i, i = E[4 + (g = C + 2152 | 0) >> 2], E[p >> 2] = E[g >> 2], E[p + 4 >> 2] = i, i = E[4 + (g = C + 2160 | 0) >> 2], E[w >> 2] = E[g >> 2], E[w + 4 >> 2] = i, g = E[C + 2092 >> 2], E[C + 3808 >> 2] = E[C + 2088 >> 2], E[C + 3812 >> 2] = g, g = E[C + 2132 >> 2], E[C + 3848 >> 2] = E[C + 2128 >> 2], E[C + 3852 >> 2] = g, i = E[4 + (g = C + 2200 | 0) >> 2], E[F >> 2] = E[g >> 2], E[F + 4 >> 2] = i, i = E[4 + (g = C + 2192 | 0) >> 2], E[k >> 2] = E[g >> 2], E[k + 4 >> 2] = i, i = E[4 + (g = C + 2184 | 0) >> 2], E[n >> 2] = E[g >> 2], E[n + 4 >> 2] = i, i = E[4 + (g = C + 2176 | 0) >> 2], E[y >> 2] = E[g >> 2], E[y + 4 >> 2] = i, g = E[C + 2172 >> 2], E[C + 3888 >> 2] = E[C + 2168 >> 2], E[C + 3892 >> 2] = g, KA(g = C + 2568 | 0, N), Y(i = C + 1448 | 0, g, _ = C + 2688 | 0), Y(C + 1488 | 0, c = C + 2608 | 0, r = C + 2648 | 0), Y(C + 1528 | 0, r, _), Y(C + 1568 | 0, g, c), TA(C + 1280 | 0, i), i = 0, g = 0; c = (_ = C + 3968 | 0) + (g << 1) | 0, r = a[I + g | 0], o[c + 1 | 0] = r >>> 4, o[0 | c] = 15 & r, _ = _ + ((c = 1 | g) << 1) | 0, c = a[I + c | 0], o[_ + 1 | 0] = c >>> 4, o[0 | _] = 15 & c, 32 != (0 | (g = g + 2 | 0)););
                                        for(I = 0; g = 8 + (_ = (g = I) + a[0 | (I = (C + 3968 | 0) + i | 0)] | 0) | 0, o[0 | I] = _ - (240 & g), g = 8 + (_ = a[I + 1 | 0] + (g << 24 >> 24 >> 4) | 0) | 0, o[I + 1 | 0] = _ - (240 & g), g = 8 + (_ = a[I + 2 | 0] + (g << 24 >> 24 >> 4) | 0) | 0, o[I + 2 | 0] = _ - (240 & g), I = g << 24 >> 24 >> 4, 63 != (0 | (i = i + 3 | 0)););
                                        for(o[C + 4031 | 0] = a[C + 4031 | 0] + I, E[A + 32 >> 2] = 0, E[A + 36 >> 2] = 0, E[A + 24 >> 2] = 0, E[A + 28 >> 2] = 0, E[A + 16 >> 2] = 0, E[A + 20 >> 2] = 0, E[A + 8 >> 2] = 0, E[A + 12 >> 2] = 0, E[A >> 2] = 0, E[A + 4 >> 2] = 0, E[A + 44 >> 2] = 0, E[A + 48 >> 2] = 0, E[(p = A + 40 | 0) >> 2] = 1, E[A + 52 >> 2] = 0, E[A + 56 >> 2] = 0, E[A + 60 >> 2] = 0, E[A + 64 >> 2] = 0, E[A + 68 >> 2] = 0, E[A + 72 >> 2] = 0, E[A + 76 >> 2] = 0, E[A + 80 >> 2] = 1, Hg(A + 84 | 0, 0, 76), w = A + 120 | 0, y = A + 80 | 0, r = C + 3768 | 0, g = C + 3888 | 0, _ = C + 3848 | 0, e = C + 3728 | 0, i = C + 3928 | 0, D = 63; HA(C, n = C + 160 | 0, o[(C + 3968 | 0) + D | 0]), sA(I = C + 3808 | 0, A, C), Y(c = C + 3688 | 0, I, i), Y(e, _, g), Y(r, g, i), KA(I, c), Y(c, I, i), Y(e, _, g), Y(r, g, i), KA(I, c), Y(c, I, i), Y(e, _, g), Y(r, g, i), KA(I, c), Y(c, I, i), Y(e, _, g), Y(r, g, i), KA(I, c), Y(A, I, i), Y(p, _, g), Y(y, g, i), Y(w, I, _), D = D - 1 | 0;);
                                        HA(C, n, o[C + 3968 | 0]), sA(I, A, C), Y(A, I, i), Y(p, _, g), Y(y, g, i), Y(w, I, _), h = C + 4032 | 0;
                                    }
                                    function x(A, I, g, C) {
                                        var B, Q, i, o, _, c, t, r, e, y, s, D, p, w, f, n, k, F, N, S, G, M, b, K, H = 0, Y = 0, d = 0, J = 0, U = 0, l = 0, m = 0, u = 0;
                                        h = B = h - 320 | 0, d = 32 - g | 0, H = Hg((Y = B + 256 | 0) + g | 0, 0, g >>> 0 <= 31 ? d : 0), Sg(Y, I, g), o = a[C + 16 | 0] | a[C + 17 | 0] << 8 | a[C + 18 | 0] << 16 | a[C + 19 | 0] << 24, _ = a[C + 48 | 0] | a[C + 49 | 0] << 8 | a[C + 50 | 0] << 16 | a[C + 51 | 0] << 24, c = a[C + 20 | 0] | a[C + 21 | 0] << 8 | a[C + 22 | 0] << 16 | a[C + 23 | 0] << 24, t = a[C + 52 | 0] | a[C + 53 | 0] << 8 | a[C + 54 | 0] << 16 | a[C + 55 | 0] << 24, r = a[C + 24 | 0] | a[C + 25 | 0] << 8 | a[C + 26 | 0] << 16 | a[C + 27 | 0] << 24, e = a[C + 56 | 0] | a[C + 57 | 0] << 8 | a[C + 58 | 0] << 16 | a[C + 59 | 0] << 24, y = a[C + 28 | 0] | a[C + 29 | 0] << 8 | a[C + 30 | 0] << 16 | a[C + 31 | 0] << 24, s = a[C + 60 | 0] | a[C + 61 | 0] << 8 | a[C + 62 | 0] << 16 | a[C + 63 | 0] << 24, I = a[C + 32 | 0] | a[C + 33 | 0] << 8 | a[C + 34 | 0] << 16 | a[C + 35 | 0] << 24, D = a[C + 80 | 0] | a[C + 81 | 0] << 8 | a[C + 82 | 0] << 16 | a[C + 83 | 0] << 24, p = a[C + 112 | 0] | a[C + 113 | 0] << 8 | a[C + 114 | 0] << 16 | a[C + 115 | 0] << 24, J = a[C + 96 | 0] | a[C + 97 | 0] << 8 | a[C + 98 | 0] << 16 | a[C + 99 | 0] << 24, U = a[C + 36 | 0] | a[C + 37 | 0] << 8 | a[C + 38 | 0] << 16 | a[C + 39 | 0] << 24, w = a[C + 84 | 0] | a[C + 85 | 0] << 8 | a[C + 86 | 0] << 16 | a[C + 87 | 0] << 24, f = a[C + 116 | 0] | a[C + 117 | 0] << 8 | a[C + 118 | 0] << 16 | a[C + 119 | 0] << 24, l = a[C + 100 | 0] | a[C + 101 | 0] << 8 | a[C + 102 | 0] << 16 | a[C + 103 | 0] << 24, m = a[C + 40 | 0] | a[C + 41 | 0] << 8 | a[C + 42 | 0] << 16 | a[C + 43 | 0] << 24, n = a[C + 88 | 0] | a[C + 89 | 0] << 8 | a[C + 90 | 0] << 16 | a[C + 91 | 0] << 24, k = a[C + 120 | 0] | a[C + 121 | 0] << 8 | a[C + 122 | 0] << 16 | a[C + 123 | 0] << 24, u = a[C + 104 | 0] | a[C + 105 | 0] << 8 | a[C + 106 | 0] << 16 | a[C + 107 | 0] << 24, F = E[B + 256 >> 2], N = E[B + 260 >> 2], S = E[B + 264 >> 2], G = E[B + 268 >> 2], M = E[B + 272 >> 2], b = E[B + 276 >> 2], K = E[B + 280 >> 2], Q = a[C + 44 | 0] | a[C + 45 | 0] << 8 | a[C + 46 | 0] << 16 | a[C + 47 | 0] << 24, i = a[C + 108 | 0] | a[C + 109 | 0] << 8 | a[C + 110 | 0] << 16 | a[C + 111 | 0] << 24, E[B + 284 >> 2] = Q ^ i & (a[C + 124 | 0] | a[C + 125 | 0] << 8 | a[C + 126 | 0] << 16 | a[C + 127 | 0] << 24) ^ E[B + 284 >> 2] ^ (a[C + 92 | 0] | a[C + 93 | 0] << 8 | a[C + 94 | 0] << 16 | a[C + 95 | 0] << 24), E[B + 280 >> 2] = m ^ u & k ^ n ^ K, E[B + 276 >> 2] = U ^ l & f ^ w ^ b, E[B + 272 >> 2] = I ^ J & p ^ D ^ M, E[B + 268 >> 2] = s & Q ^ y ^ G ^ i, E[B + 264 >> 2] = u ^ m & e ^ r ^ S, E[B + 260 >> 2] = l ^ U & t ^ c ^ N, E[B + 256 >> 2] = J ^ I & _ ^ o ^ F, Hg(H, 0, d), Sg(A, Y, g), g = E[B + 284 >> 2], Y = E[B + 280 >> 2], J = E[B + 276 >> 2], U = E[B + 272 >> 2], l = E[B + 256 >> 2], m = E[B + 260 >> 2], u = E[B + 264 >> 2], d = E[B + 268 >> 2], A = E[C + 124 >> 2], E[B + 312 >> 2] = E[C + 120 >> 2], E[B + 316 >> 2] = A, A = E[C + 116 >> 2], E[B + 304 >> 2] = E[C + 112 >> 2], E[B + 308 >> 2] = A, A = E[C + 108 >> 2], E[B + 248 >> 2] = E[C + 104 >> 2], E[B + 252 >> 2] = A, A = E[C + 100 >> 2], E[B + 240 >> 2] = E[C + 96 >> 2], E[B + 244 >> 2] = A, A = E[C + 124 >> 2], E[B + 232 >> 2] = E[C + 120 >> 2], E[B + 236 >> 2] = A, A = E[C + 116 >> 2], E[B + 224 >> 2] = E[C + 112 >> 2], E[B + 228 >> 2] = A, $A(I = B + 288 | 0, B + 240 | 0, B + 224 | 0), A = E[B + 300 >> 2], E[C + 120 >> 2] = E[B + 296 >> 2], E[C + 124 >> 2] = A, A = E[B + 292 >> 2], E[C + 112 >> 2] = E[B + 288 >> 2], E[C + 116 >> 2] = A, A = E[C + 92 >> 2], E[B + 216 >> 2] = E[C + 88 >> 2], E[B + 220 >> 2] = A, A = E[C + 84 >> 2], E[B + 208 >> 2] = E[C + 80 >> 2], E[B + 212 >> 2] = A, A = E[C + 108 >> 2], E[B + 200 >> 2] = E[C + 104 >> 2], E[B + 204 >> 2] = A, A = E[C + 100 >> 2], E[B + 192 >> 2] = E[C + 96 >> 2], E[B + 196 >> 2] = A, $A(I, B + 208 | 0, B + 192 | 0), A = E[B + 300 >> 2], E[C + 104 >> 2] = E[B + 296 >> 2], E[C + 108 >> 2] = A, A = E[B + 292 >> 2], E[C + 96 >> 2] = E[B + 288 >> 2], E[C + 100 >> 2] = A, A = E[C + 76 >> 2], E[B + 184 >> 2] = E[C + 72 >> 2], E[B + 188 >> 2] = A, H = E[4 + (A = C - -64 | 0) >> 2], E[B + 176 >> 2] = E[A >> 2], E[B + 180 >> 2] = H, H = E[C + 92 >> 2], E[B + 168 >> 2] = E[C + 88 >> 2], E[B + 172 >> 2] = H, H = E[C + 84 >> 2], E[B + 160 >> 2] = E[C + 80 >> 2], E[B + 164 >> 2] = H, $A(I, B + 176 | 0, B + 160 | 0), H = E[B + 300 >> 2], E[C + 88 >> 2] = E[B + 296 >> 2], E[C + 92 >> 2] = H, H = E[B + 292 >> 2], E[C + 80 >> 2] = E[B + 288 >> 2], E[C + 84 >> 2] = H, H = E[C + 60 >> 2], E[B + 152 >> 2] = E[C + 56 >> 2], E[B + 156 >> 2] = H, H = E[C + 52 >> 2], E[B + 144 >> 2] = E[C + 48 >> 2], E[B + 148 >> 2] = H, H = E[C + 76 >> 2], E[B + 136 >> 2] = E[C + 72 >> 2], E[B + 140 >> 2] = H, H = E[A + 4 >> 2], E[B + 128 >> 2] = E[A >> 2], E[B + 132 >> 2] = H, $A(I, B + 144 | 0, B + 128 | 0), H = E[B + 300 >> 2], E[C + 72 >> 2] = E[B + 296 >> 2], E[C + 76 >> 2] = H, H = E[B + 292 >> 2], E[A >> 2] = E[B + 288 >> 2], E[A + 4 >> 2] = H, H = E[C + 44 >> 2], E[B + 120 >> 2] = E[C + 40 >> 2], E[B + 124 >> 2] = H, H = E[C + 36 >> 2], E[B + 112 >> 2] = E[C + 32 >> 2], E[B + 116 >> 2] = H, H = E[C + 60 >> 2], E[B + 104 >> 2] = E[C + 56 >> 2], E[B + 108 >> 2] = H, H = E[C + 52 >> 2], E[B + 96 >> 2] = E[C + 48 >> 2], E[B + 100 >> 2] = H, $A(I, B + 112 | 0, B + 96 | 0), H = E[B + 300 >> 2], E[C + 56 >> 2] = E[B + 296 >> 2], E[C + 60 >> 2] = H, H = E[B + 292 >> 2], E[C + 48 >> 2] = E[B + 288 >> 2], E[C + 52 >> 2] = H, H = E[C + 28 >> 2], E[B + 88 >> 2] = E[C + 24 >> 2], E[B + 92 >> 2] = H, H = E[C + 20 >> 2], E[B + 80 >> 2] = E[C + 16 >> 2], E[B + 84 >> 2] = H, H = E[C + 44 >> 2], E[B + 72 >> 2] = E[C + 40 >> 2], E[B + 76 >> 2] = H, H = E[C + 36 >> 2], E[B + 64 >> 2] = E[C + 32 >> 2], E[B + 68 >> 2] = H, $A(I, B + 80 | 0, B - -64 | 0), H = E[B + 300 >> 2], E[C + 40 >> 2] = E[B + 296 >> 2], E[C + 44 >> 2] = H, H = E[B + 292 >> 2], E[C + 32 >> 2] = E[B + 288 >> 2], E[C + 36 >> 2] = H, H = E[C + 12 >> 2], E[B + 56 >> 2] = E[C + 8 >> 2], E[B + 60 >> 2] = H, H = E[C + 4 >> 2], E[B + 48 >> 2] = E[C >> 2], E[B + 52 >> 2] = H, H = E[C + 28 >> 2], E[B + 40 >> 2] = E[C + 24 >> 2], E[B + 44 >> 2] = H, H = E[C + 20 >> 2], E[B + 32 >> 2] = E[C + 16 >> 2], E[B + 36 >> 2] = H, $A(I, B + 48 | 0, B + 32 | 0), H = E[B + 300 >> 2], E[C + 24 >> 2] = E[B + 296 >> 2], E[C + 28 >> 2] = H, H = E[B + 292 >> 2], E[C + 16 >> 2] = E[B + 288 >> 2], E[C + 20 >> 2] = H, H = E[B + 316 >> 2], E[B + 24 >> 2] = E[B + 312 >> 2], E[B + 28 >> 2] = H, H = E[B + 308 >> 2], E[B + 16 >> 2] = E[B + 304 >> 2], E[B + 20 >> 2] = H, H = E[C + 12 >> 2], E[B + 8 >> 2] = E[C + 8 >> 2], E[B + 12 >> 2] = H, H = E[C + 4 >> 2], E[B >> 2] = E[C >> 2], E[B + 4 >> 2] = H, $A(I, B + 16 | 0, B), I = E[B + 300 >> 2], E[C + 8 >> 2] = E[B + 296 >> 2], E[C + 12 >> 2] = I, I = E[B + 292 >> 2], E[C >> 2] = E[B + 288 >> 2], E[C + 4 >> 2] = I, E[C + 12 >> 2] = d ^ (a[C + 12 | 0] | a[C + 13 | 0] << 8 | a[C + 14 | 0] << 16 | a[C + 15 | 0] << 24), E[C + 8 >> 2] = u ^ (a[C + 8 | 0] | a[C + 9 | 0] << 8 | a[C + 10 | 0] << 16 | a[C + 11 | 0] << 24), E[C + 4 >> 2] = m ^ (a[C + 4 | 0] | a[C + 5 | 0] << 8 | a[C + 6 | 0] << 16 | a[C + 7 | 0] << 24), E[C >> 2] = l ^ (a[0 | C] | a[C + 1 | 0] << 8 | a[C + 2 | 0] << 16 | a[C + 3 | 0] << 24), E[A >> 2] = U ^ (a[0 | A] | a[A + 1 | 0] << 8 | a[A + 2 | 0] << 16 | a[A + 3 | 0] << 24), E[C + 68 >> 2] = J ^ (a[C + 68 | 0] | a[C + 69 | 0] << 8 | a[C + 70 | 0] << 16 | a[C + 71 | 0] << 24), E[C + 72 >> 2] = Y ^ (a[C + 72 | 0] | a[C + 73 | 0] << 8 | a[C + 74 | 0] << 16 | a[C + 75 | 0] << 24), E[C + 76 >> 2] = g ^ (a[C + 76 | 0] | a[C + 77 | 0] << 8 | a[C + 78 | 0] << 16 | a[C + 79 | 0] << 24), h = B + 320 | 0;
                                    }
                                    function R(A, I) {
                                        var g, C, B, Q, i, o, a, _, t, r, e, y, s, h, D, p, f, n, k, F, N, S, G, M, b, K, H, Y, d, J, U, l, m, u, x, R, v = 0, L = 0, P = 0, q = 0, z = 0, j = 0, X = 0, O = 0, V = 0, Z = 0, W = 0, T = 0, $ = 0, AA = 0, IA = 0, gA = 0, CA = 0, BA = 0, QA = 0, iA = 0, oA = 0;
                                        v = Ig(C = (D = E[I + 12 >> 2]) << 1, o = C >> 31, $ = (q = E[I + 4 >> 2]) << 1, B = $ >> 31), P = w, F = Z = E[I + 8 >> 2], L = (W = Ig(Z, p = Z >> 31, Z, p)) + v | 0, v = w + P | 0, v = L >>> 0 < W >>> 0 ? v + 1 | 0 : v, P = Ig(j = E[I + 16 >> 2], a = j >> 31, W = (z = E[I >> 2]) << 1, Q = W >> 31), v = w + v | 0, v = (L = P + L | 0) >>> 0 < P >>> 0 ? v + 1 | 0 : v, e = E[I + 28 >> 2], P = Ig(BA = c(e, 38), f = BA >> 31, e, N = e >> 31), v = w + v | 0, v = (L = P + L | 0) >>> 0 < P >>> 0 ? v + 1 | 0 : v, P = L, y = E[I + 32 >> 2], X = Ig(O = c(y, 19), _ = O >> 31, L = (g = E[I + 24 >> 2]) << 1, L >> 31), L = w + v | 0, L = (P = P + X | 0) >>> 0 < X >>> 0 ? L + 1 | 0 : L, Y = E[I + 36 >> 2], v = Ig(X = c(Y, 38), i = X >> 31, AA = (t = E[I + 20 >> 2]) << 1, s = AA >> 31), I = w + L | 0, J = v = (v >>> 0 > (P = v + P | 0) >>> 0 ? I + 1 | 0 : I) << 1 | P >>> 31, U = L = 33554432 + (S = P << 1) | 0, l = v = L >>> 0 < 33554432 ? v + 1 | 0 : v, I = v >> 26, T = (67108863 & v) << 6 | L >>> 26, v = Ig($, B, j, a), P = w, L = (IA = Ig(Z <<= 1, h = Z >> 31, D, G = D >> 31)) + v | 0, v = w + P | 0, v = L >>> 0 < IA >>> 0 ? v + 1 | 0 : v, P = (IA = Ig(t, n = t >> 31, W, Q)) + L | 0, L = w + v | 0, L = P >>> 0 < IA >>> 0 ? L + 1 | 0 : L, iA = Ig(O, _, IA = e << 1, M = IA >> 31), v = w + L | 0, v = (P = iA + P | 0) >>> 0 < iA >>> 0 ? v + 1 | 0 : v, L = Ig(X, i, g, r = g >> 31), v = w + v | 0, I = I + (L = (L >>> 0 > (P = L + P | 0) >>> 0 ? v + 1 | 0 : v) << 1 | P >>> 31) | 0, iA = P = (v = P << 1) + T | 0, v = I = v >>> 0 > P >>> 0 ? I + 1 | 0 : I, m = P = P + 16777216 | 0, T = (33554431 & (v = P >>> 0 < 16777216 ? v + 1 | 0 : v)) << 7 | P >>> 25, P = v >> 25, I = Ig(C, o, D, G), v = w, L = Ig(j, a, Z, h), v = w + v | 0, v = (I = L + I | 0) >>> 0 < L >>> 0 ? v + 1 | 0 : v, L = Ig($, B, AA, s), v = w + v | 0, v = (I = L + I | 0) >>> 0 < L >>> 0 ? v + 1 | 0 : v, L = (gA = Ig(W, Q, g, r)) + I | 0, I = w + v | 0, I = L >>> 0 < gA >>> 0 ? I + 1 | 0 : I, gA = Ig(O, _, y, k = y >> 31), v = w + I | 0, v = (L = gA + L | 0) >>> 0 < gA >>> 0 ? v + 1 | 0 : v, I = (gA = Ig(X, i, IA, M)) + L | 0, L = w + v | 0, I = ((v = I) >>> 0 < gA >>> 0 ? L + 1 | 0 : L) << 1 | v >>> 31, L = T, T = v << 1, v = I + P | 0, v = (L = L + T | 0) >>> 0 < T >>> 0 ? v + 1 | 0 : v, gA = I = L + 33554432 | 0, P = v = I >>> 0 < 33554432 ? v + 1 | 0 : v, E[A + 24 >> 2] = L - (-67108864 & I), L = Ig(I = c(t, 38), I >> 31, t, n), T = w, I = (v = Ig(I = z, v = I >> 31, I, v)) + L | 0, L = w + T | 0, L = I >>> 0 < v >>> 0 ? L + 1 | 0 : L, CA = Ig(z = c(g, 19), b = z >> 31, T = j << 1, K = T >> 31), v = w + L | 0, v = (I = CA + I | 0) >>> 0 < CA >>> 0 ? v + 1 | 0 : v, L = Ig(C, o, BA, f), v = w + v | 0, v = (I = L + I | 0) >>> 0 < L >>> 0 ? v + 1 | 0 : v, L = (CA = Ig(O, _, Z, h)) + I | 0, I = w + v | 0, I = L >>> 0 < CA >>> 0 ? I + 1 | 0 : I, CA = Ig($, B, X, i), v = w + I | 0, CA = v = ((L = CA + L | 0) >>> 0 < CA >>> 0 ? v + 1 | 0 : v) << 1 | L >>> 31, u = I = 33554432 + (H = L << 1) | 0, x = L = I >>> 0 < 33554432 ? v + 1 | 0 : v, QA = (67108863 & L) << 6 | I >>> 26, oA = L >> 26, I = Ig(z, b, AA, s), v = w, L = Ig(W, Q, q, d = q >> 31), v = w + v | 0, v = (I = L + I | 0) >>> 0 < L >>> 0 ? v + 1 | 0 : v, L = (V = Ig(j, a, BA, f)) + I | 0, I = w + v | 0, I = L >>> 0 < V >>> 0 ? I + 1 | 0 : I, V = Ig(O, _, C, o), v = w + I | 0, v = (L = V + L | 0) >>> 0 < V >>> 0 ? v + 1 | 0 : v, V = (I = Ig(X, i, F, p)) + L | 0, L = w + v | 0, v = (I = (I >>> 0 > V >>> 0 ? L + 1 | 0 : L) << 1 | V >>> 31) + oA | 0, v = (L = (V <<= 1) + QA | 0) >>> 0 < V >>> 0 ? v + 1 | 0 : v, oA = L, V = L = L + 16777216 | 0, R = (33554431 & (v = L >>> 0 < 16777216 ? v + 1 | 0 : v)) << 7 | L >>> 25, QA = v >> 25, I = Ig(W, Q, F, p), v = w, L = Ig($, B, q, d), v = w + v | 0, v = (I = L + I | 0) >>> 0 < L >>> 0 ? v + 1 | 0 : v, q = Ig(z, b, g, r), L = w + v | 0, L = (I = q + I | 0) >>> 0 < q >>> 0 ? L + 1 | 0 : L, q = Ig(AA, s, BA, f), v = w + L | 0, v = (I = q + I | 0) >>> 0 < q >>> 0 ? v + 1 | 0 : v, L = Ig(O, _, T, K), v = w + v | 0, v = (I = L + I | 0) >>> 0 < L >>> 0 ? v + 1 | 0 : v, L = (q = Ig(X, i, C, o)) + I | 0, I = w + v | 0, v = (v = (L >>> 0 < q >>> 0 ? I + 1 | 0 : I) << 1 | L >>> 31) + QA | 0, z = I = (L <<= 1) + R | 0, v = I >>> 0 < L >>> 0 ? v + 1 | 0 : v, QA = I = I + 33554432 | 0, q = L = I >>> 0 < 33554432 ? v + 1 | 0 : v, E[A + 8 >> 2] = z - (-67108864 & I), I = Ig(Z, h, t, n), L = w, v = (z = Ig(j, a, C, o)) + I | 0, I = w + L | 0, I = v >>> 0 < z >>> 0 ? I + 1 | 0 : I, L = (z = Ig($, B, g, r)) + v | 0, v = w + I | 0, v = L >>> 0 < z >>> 0 ? v + 1 | 0 : v, I = (z = Ig(W, Q, e, N)) + L | 0, L = w + v | 0, L = I >>> 0 < z >>> 0 ? L + 1 | 0 : L, z = Ig(X, i, y, k), v = w + L | 0, v = (v = ((I = z + I | 0) >>> 0 < z >>> 0 ? v + 1 | 0 : v) << 1 | I >>> 31) + (L = P >> 26) | 0, I = (L = P = (z = I << 1) + (I = (67108863 & P) << 6 | gA >>> 26) | 0) >>> 0 < I >>> 0 ? v + 1 | 0 : v, z = v = L + 16777216 | 0, P = I = v >>> 0 < 16777216 ? I + 1 | 0 : I, E[A + 28 >> 2] = L - (-33554432 & v), I = Ig(W, Q, D, G), v = w, L = Ig($, B, F, p), v = w + v | 0, v = (I = L + I | 0) >>> 0 < L >>> 0 ? v + 1 | 0 : v, L = Ig(g, r, BA, f), v = w + v | 0, v = (I = L + I | 0) >>> 0 < L >>> 0 ? v + 1 | 0 : v, L = (O = Ig(O, _, AA, s)) + I | 0, I = w + v | 0, I = L >>> 0 < O >>> 0 ? I + 1 | 0 : I, v = (O = Ig(X, i, j, a)) + L | 0, L = w + I | 0, I = v, v = (v >>> 0 < O >>> 0 ? L + 1 | 0 : L) << 1 | v >>> 31, L = I << 1, v = (I = q >> 26) + v | 0, v = (L = L + (q = (67108863 & q) << 6 | QA >>> 26) | 0) >>> 0 < q >>> 0 ? v + 1 | 0 : v, O = I = L + 16777216 | 0, q = v = I >>> 0 < 16777216 ? v + 1 | 0 : v, E[A + 12 >> 2] = L - (-33554432 & I), I = Ig(g, r, Z, h), v = w, L = Ig(j, a, j, a), v = w + v | 0, v = (I = L + I | 0) >>> 0 < L >>> 0 ? v + 1 | 0 : v, L = Ig(C, o, AA, s), v = w + v | 0, v = (I = L + I | 0) >>> 0 < L >>> 0 ? v + 1 | 0 : v, L = Ig($, B, IA, M), v = w + v | 0, v = (I = L + I | 0) >>> 0 < L >>> 0 ? v + 1 | 0 : v, L = (j = Ig(W, Q, y, k)) + I | 0, I = w + v | 0, I = L >>> 0 < j >>> 0 ? I + 1 | 0 : I, v = (j = Ig(v = X, i, X = Y, AA = X >> 31)) + L | 0, L = w + I | 0, I = v, v = (v >>> 0 < j >>> 0 ? L + 1 | 0 : L) << 1 | v >>> 31, L = I << 1, v = (I = P >> 25) + v | 0, v = (L = L + (P = (33554431 & P) << 7 | z >>> 25) | 0) >>> 0 < P >>> 0 ? v + 1 | 0 : v, j = I = L + 33554432 | 0, P = v = I >>> 0 < 33554432 ? v + 1 | 0 : v, E[A + 32 >> 2] = L - (-67108864 & I), v = q >> 25, L = (q = (33554431 & q) << 7 | O >>> 25) + (S - (I = -67108864 & U) | 0) | 0, I = v + (J - ((I >>> 0 > S >>> 0) + l | 0) | 0) | 0, I = L >>> 0 < q >>> 0 ? I + 1 | 0 : I, q = L, v = I, I = ((67108863 & (v = (L = L + 33554432 | 0) >>> 0 < 33554432 ? v + 1 | 0 : v)) << 6 | L >>> 26) + (BA = iA - (-33554432 & m) | 0) | 0, E[A + 20 >> 2] = I, E[A + 16 >> 2] = q - (-67108864 & L), I = Ig(C, o, g, r), L = w, v = (q = Ig(t, n, T, K)) + I | 0, I = w + L | 0, I = v >>> 0 < q >>> 0 ? I + 1 | 0 : I, L = (q = Ig(Z, h, e, N)) + v | 0, v = w + I | 0, v = L >>> 0 < q >>> 0 ? v + 1 | 0 : v, I = (q = Ig($, B, y, k)) + L | 0, L = w + v | 0, L = I >>> 0 < q >>> 0 ? L + 1 | 0 : L, q = Ig(W, Q, X, AA), v = w + L | 0, v = ((I = q + I | 0) >>> 0 < q >>> 0 ? v + 1 | 0 : v) << 1 | I >>> 31, q = I << 1, v = v + (L = P >> 26) | 0, I = (I = (67108863 & P) << 6 | j >>> 26) >>> 0 > (P = q + I | 0) >>> 0 ? v + 1 | 0 : v, I = (v = P + 16777216 | 0) >>> 0 < 16777216 ? I + 1 | 0 : I, E[A + 36 >> 2] = P - (-33554432 & v), q = oA - (-33554432 & V) | 0, P = H - (L = -67108864 & u) | 0, $ = CA - ((L >>> 0 > H >>> 0) + x | 0) | 0, I = Ig((33554431 & I) << 7 | v >>> 25, I >> 25, 19, 0), L = w + $ | 0, P = v = I + P | 0, I = I >>> 0 > v >>> 0 ? L + 1 | 0 : L, I = ((67108863 & (I = (v = v + 33554432 | 0) >>> 0 < 33554432 ? I + 1 | 0 : I)) << 6 | v >>> 26) + q | 0, E[A + 4 >> 2] = I, E[A >> 2] = P - (-67108864 & v);
                                    }
                                    function v(A, I) {
                                        var g, C, B, Q, i, o, a, _, t, r, e, y, s, h, D, p, f, n, k, F, N, S, G, M, b, K, H, Y, d, J, U, l, m = 0, u = 0, x = 0, R = 0, v = 0, L = 0, P = 0, q = 0, z = 0, j = 0, X = 0, O = 0, V = 0, Z = 0, W = 0, T = 0, $ = 0, AA = 0, IA = 0, gA = 0, CA = 0, BA = 0;
                                        m = Ig(C = (p = E[I + 12 >> 2]) << 1, o = C >> 31, p, N = p >> 31), x = w, u = (z = Ig(v = E[I + 16 >> 2], a = v >> 31, _ = (R = E[I + 8 >> 2]) << 1, y = _ >> 31)) + m | 0, m = w + x | 0, m = u >>> 0 < z >>> 0 ? m + 1 | 0 : m, x = (j = Ig(V = (t = E[I + 20 >> 2]) << 1, s = V >> 31, z = (L = E[I + 4 >> 2]) << 1, B = z >> 31)) + u | 0, u = w + m | 0, u = x >>> 0 < j >>> 0 ? u + 1 | 0 : u, P = Ig(g = E[I + 24 >> 2], r = g >> 31, j = (T = E[I >> 2]) << 1, Q = j >> 31), m = w + u | 0, m = (x = P + x | 0) >>> 0 < P >>> 0 ? m + 1 | 0 : m, u = x, h = E[I + 32 >> 2], x = Ig(X = c(h, 19), e = X >> 31, h, n = h >> 31), m = w + m | 0, m = (u = u + x | 0) >>> 0 < x >>> 0 ? m + 1 | 0 : m, K = E[I + 36 >> 2], x = Ig(P = c(K, 38), i = P >> 31, k = (D = E[I + 28 >> 2]) << 1, S = k >> 31), I = w + m | 0, W = u = x + u | 0, x = u >>> 0 < x >>> 0 ? I + 1 | 0 : I, I = Ig(z, B, v, a), m = w, u = Ig(_, y, p, N), m = w + m | 0, m = (I = u + I | 0) >>> 0 < u >>> 0 ? m + 1 | 0 : m, q = Ig(t, F = t >> 31, j, Q), u = w + m | 0, u = (I = q + I | 0) >>> 0 < q >>> 0 ? u + 1 | 0 : u, q = Ig(X, e, k, S), m = w + u | 0, m = (I = q + I | 0) >>> 0 < q >>> 0 ? m + 1 | 0 : m, u = Ig(P, i, g, r), m = w + m | 0, CA = I = u + I | 0, O = I >>> 0 < u >>> 0 ? m + 1 | 0 : m, m = Ig(z, B, C, o), u = w, G = I = R, R = Ig(I, Z = I >> 31, I, Z), I = w + u | 0, I = (m = R + m | 0) >>> 0 < R >>> 0 ? I + 1 | 0 : I, u = (R = Ig(j, Q, v, a)) + m | 0, m = w + I | 0, m = u >>> 0 < R >>> 0 ? m + 1 | 0 : m, I = (R = Ig(q = c(D, 38), f = q >> 31, D, M = D >> 31)) + u | 0, u = w + m | 0, u = I >>> 0 < R >>> 0 ? u + 1 | 0 : u, I = (m = I) + (R = Ig(X, e, I = g << 1, I >> 31)) | 0, m = w + u | 0, m = I >>> 0 < R >>> 0 ? m + 1 | 0 : m, u = I, I = Ig(P, i, V, s), m = w + m | 0, H = u = u + I | 0, Y = m = I >>> 0 > u >>> 0 ? m + 1 | 0 : m, I = m, d = u = u + 33554432 | 0, J = I = u >>> 0 < 33554432 ? I + 1 | 0 : I, m = (m = I >> 26) + O | 0, CA = I = (u = (67108863 & I) << 6 | u >>> 26) + CA | 0, m = I >>> 0 < u >>> 0 ? m + 1 | 0 : m, U = I = I + 16777216 | 0, m = (m = (u = I >>> 0 < 16777216 ? m + 1 | 0 : m) >> 25) + x | 0, I = (I = (33554431 & u) << 7 | I >>> 25) >>> 0 > (u = I + W | 0) >>> 0 ? m + 1 | 0 : m, W = m = u + 33554432 | 0, R = I = m >>> 0 < 33554432 ? I + 1 | 0 : I, E[A + 24 >> 2] = u - (-67108864 & m), I = Ig(j, Q, G, Z), m = w, x = Ig(z, B, L, $ = L >> 31), u = w + m | 0, u = (I = x + I | 0) >>> 0 < x >>> 0 ? u + 1 | 0 : u, O = Ig(x = c(g, 19), gA = x >> 31, g, r), m = w + u | 0, m = (I = O + I | 0) >>> 0 < O >>> 0 ? m + 1 | 0 : m, u = (O = Ig(V, s, q, f)) + I | 0, I = w + m | 0, I = u >>> 0 < O >>> 0 ? I + 1 | 0 : I, AA = Ig(X, e, O = v << 1, b = O >> 31), m = w + I | 0, m = (u = AA + u | 0) >>> 0 < AA >>> 0 ? m + 1 | 0 : m, I = u, u = Ig(P, i, C, o), m = w + m | 0, IA = I = I + u | 0, AA = I >>> 0 < u >>> 0 ? m + 1 | 0 : m, I = Ig(V, s, x, gA), m = w, L = Ig(j, Q, L, $), u = w + m | 0, u = (I = L + I | 0) >>> 0 < L >>> 0 ? u + 1 | 0 : u, L = Ig(v, a, q, f), m = w + u | 0, m = (I = L + I | 0) >>> 0 < L >>> 0 ? m + 1 | 0 : m, u = (L = Ig(X, e, C, o)) + I | 0, I = w + m | 0, I = u >>> 0 < L >>> 0 ? I + 1 | 0 : I, L = Ig(P, i, G, Z), m = w + I | 0, BA = u = L + u | 0, $ = u >>> 0 < L >>> 0 ? m + 1 | 0 : m, u = Ig(I = c(t, 38), I >> 31, t, F), L = w, I = T, T = u, u = Ig(I, m = I >> 31, I, m), m = w + L | 0, m = (I = T + u | 0) >>> 0 < u >>> 0 ? m + 1 | 0 : m, x = Ig(x, gA, O, b), u = w + m | 0, u = (I = x + I | 0) >>> 0 < x >>> 0 ? u + 1 | 0 : u, x = Ig(C, o, q, f), m = w + u | 0, m = (I = x + I | 0) >>> 0 < x >>> 0 ? m + 1 | 0 : m, u = (x = Ig(X, e, _, y)) + I | 0, I = w + m | 0, I = u >>> 0 < x >>> 0 ? I + 1 | 0 : I, x = Ig(z, B, P, i), m = w + I | 0, L = u = x + u | 0, T = m = u >>> 0 < x >>> 0 ? m + 1 | 0 : m, gA = u = u + 33554432 | 0, l = m = u >>> 0 < 33554432 ? m + 1 | 0 : m, I = m >> 26, m = (67108863 & m) << 6 | u >>> 26, u = I + $ | 0, $ = x = m + BA | 0, m = m >>> 0 > x >>> 0 ? u + 1 | 0 : u, BA = u = x + 16777216 | 0, x = (33554431 & (m = u >>> 0 < 16777216 ? m + 1 | 0 : m)) << 7 | u >>> 25, m = (m >> 25) + AA | 0, m = (u = x + IA | 0) >>> 0 < x >>> 0 ? m + 1 | 0 : m, AA = I = u + 33554432 | 0, x = m = I >>> 0 < 33554432 ? m + 1 | 0 : m, E[A + 8 >> 2] = u - (-67108864 & I), I = Ig(_, y, t, F), m = w, u = Ig(v, a, C, o), m = w + m | 0, m = (I = u + I | 0) >>> 0 < u >>> 0 ? m + 1 | 0 : m, u = Ig(z, B, g, r), m = w + m | 0, m = (I = u + I | 0) >>> 0 < u >>> 0 ? m + 1 | 0 : m, u = Ig(j, Q, D, M), m = w + m | 0, m = (I = u + I | 0) >>> 0 < u >>> 0 ? m + 1 | 0 : m, IA = (u = Ig(P, i, h, n)) + I | 0, I = w + m | 0, u = (m = R >> 26) + (u = u >>> 0 > IA >>> 0 ? I + 1 | 0 : I) | 0, W = I = (R = (67108863 & R) << 6 | W >>> 26) + IA | 0, m = I >>> 0 < R >>> 0 ? u + 1 | 0 : u, IA = I = I + 16777216 | 0, R = m = I >>> 0 < 16777216 ? m + 1 | 0 : m, E[A + 28 >> 2] = W - (-33554432 & I), I = Ig(j, Q, p, N), u = w, m = (Z = Ig(z, B, G, Z)) + I | 0, I = w + u | 0, I = m >>> 0 < Z >>> 0 ? I + 1 | 0 : I, m = (q = Ig(g, r, q, f)) + m | 0, u = w + I | 0, I = (X = Ig(X, e, V, s)) + m | 0, m = w + (m >>> 0 < q >>> 0 ? u + 1 | 0 : u) | 0, m = I >>> 0 < X >>> 0 ? m + 1 | 0 : m, u = Ig(P, i, v, a), m = w + m | 0, m = (m = (I = u + I | 0) >>> 0 < u >>> 0 ? m + 1 | 0 : m) + (u = x >> 26) | 0, I = (u = x = (W = I) + (I = (67108863 & x) << 6 | AA >>> 26) | 0) >>> 0 < I >>> 0 ? m + 1 | 0 : m, X = m = u + 16777216 | 0, x = I = m >>> 0 < 16777216 ? I + 1 | 0 : I, E[A + 12 >> 2] = u - (-33554432 & m), I = Ig(g, r, _, y), m = w, u = Ig(v, a, v, a), m = w + m | 0, m = (I = u + I | 0) >>> 0 < u >>> 0 ? m + 1 | 0 : m, u = Ig(C, o, V, s), m = w + m | 0, m = (I = u + I | 0) >>> 0 < u >>> 0 ? m + 1 | 0 : m, u = (v = Ig(z, B, k, S)) + I | 0, I = w + m | 0, I = u >>> 0 < v >>> 0 ? I + 1 | 0 : I, m = (v = Ig(j, Q, h, n)) + u | 0, u = w + I | 0, u = m >>> 0 < v >>> 0 ? u + 1 | 0 : u, I = (v = Ig(I = P, i, P = K, V = P >> 31)) + m | 0, m = w + u | 0, m = I >>> 0 < v >>> 0 ? m + 1 | 0 : m, u = I, m = (I = R >> 25) + m | 0, m = (u = u + (R = (33554431 & R) << 7 | IA >>> 25) | 0) >>> 0 < R >>> 0 ? m + 1 | 0 : m, v = I = u + 33554432 | 0, R = m = I >>> 0 < 33554432 ? m + 1 | 0 : m, E[A + 32 >> 2] = u - (-67108864 & I), m = x >> 25, u = (x = (33554431 & x) << 7 | X >>> 25) + (H - (I = -67108864 & d) | 0) | 0, I = m + (Y - ((I >>> 0 > H >>> 0) + J | 0) | 0) | 0, I = u >>> 0 < x >>> 0 ? I + 1 | 0 : I, x = u, I = ((67108863 & (m = (u = u + 33554432 | 0) >>> 0 < 33554432 ? I + 1 | 0 : I)) << 6 | u >>> 26) + (q = CA - (-33554432 & U) | 0) | 0, E[A + 20 >> 2] = I, E[A + 16 >> 2] = x - (-67108864 & u), I = Ig(C, o, g, r), u = w, m = (x = Ig(t, F, O, b)) + I | 0, I = w + u | 0, I = m >>> 0 < x >>> 0 ? I + 1 | 0 : I, u = (x = Ig(_, y, D, M)) + m | 0, m = w + I | 0, m = u >>> 0 < x >>> 0 ? m + 1 | 0 : m, I = (x = Ig(z, B, h, n)) + u | 0, u = w + m | 0, u = I >>> 0 < x >>> 0 ? u + 1 | 0 : u, x = (m = I) + (I = Ig(j, Q, P, V)) | 0, m = w + u | 0, m = (I = I >>> 0 > x >>> 0 ? m + 1 | 0 : m) + (m = R >> 26) | 0, I = (u = (R = (67108863 & R) << 6 | v >>> 26) + x | 0) >>> 0 < R >>> 0 ? m + 1 | 0 : m, I = (m = u + 16777216 | 0) >>> 0 < 16777216 ? I + 1 | 0 : I, E[A + 36 >> 2] = u - (-33554432 & m), R = $ - (-33554432 & BA) | 0, x = L - (u = -67108864 & gA) | 0, z = T - ((u >>> 0 > L >>> 0) + l | 0) | 0, I = Ig((33554431 & I) << 7 | m >>> 25, I >> 25, 19, 0), m = w + z | 0, I = I >>> 0 > (u = I + x | 0) >>> 0 ? m + 1 | 0 : m, I = ((67108863 & (I = (m = u + 33554432 | 0) >>> 0 < 33554432 ? I + 1 | 0 : I)) << 6 | m >>> 26) + R | 0, E[A + 4 >> 2] = I, E[A >> 2] = u - (-67108864 & m);
                                    }
                                    function L(A, I) {
                                        var g, C = 0, B = 0, Q = 0, i = 0, t = 0, r = 0, e = 0, y = 0, s = 0, D = 0, p = 0, w = 0, f = 0, n = 0;
                                        if (h = g = h - 48 | 0, !((C = pI(A)) || (C = -26, I - 3 >>> 0 < 4294967294))) {
                                            Q = E[A + 44 >> 2], C = E[A + 48 >> 2], E[g + 4 >> 2] = 0, B = E[A + 40 >> 2], E[g + 32 >> 2] = C, E[g + 16 >> 2] = -1, E[g + 12 >> 2] = B, C = ((r = (B = C << 3) >>> 0 < Q >>> 0 ? Q : B) >>> 0) / ((Q = C << 2) >>> 0) | 0, E[g + 24 >> 2] = C, E[g + 28 >> 2] = C << 2, E[g + 20 >> 2] = c(C, Q), C = E[A + 52 >> 2], E[g + 40 >> 2] = I, E[g + 36 >> 2] = C, f = I = h, h = C = I - 1152 & -64, I = -25;
                                            A: {
                                                if (!(!(Q = g + 4 | 0) | !A) && (B = K(E[Q + 20 >> 2] << 3), E[Q + 4 >> 2] = B, I = -22, B)) {
                                                    I: {
                                                        if ((I = E[Q + 16 >> 2]) && 1024 == (((B = I << 10) >>> 0) / (I >>> 0) | 0) && (I = K(12), E[Q >> 2] = I, I)) {
                                                            if (E[I >> 2] = 0, E[I + 4 >> 2] = 0, I = _I(C + 128 | 0, B), E[9392] = I, I) E[C + 128 >> 2] = 0;
                                                            else if (I = E[C + 128 >> 2]) break I;
                                                            gA(E[Q >> 2]), E[Q >> 2] = 0;
                                                        }
                                                        VI(Q, E[A + 56 >> 2]), h = f, I = -22;
                                                        break A;
                                                    }
                                                    if (E[E[Q >> 2] >> 2] = I, E[E[Q >> 2] + 4 >> 2] = I, E[E[Q >> 2] + 8 >> 2] = B, D = E[Q + 36 >> 2], eA(I = C + 128 | 0, 0, 0, 64), E[C + 124 >> 2] = E[A + 48 >> 2], XA(I, B = C + 124 | 0, 4, 0), E[C + 124 >> 2] = E[A + 4 >> 2], XA(I, B, 4, 0), E[C + 124 >> 2] = E[A + 44 >> 2], XA(I, B, 4, 0), E[C + 124 >> 2] = E[A + 40 >> 2], XA(I, B, 4, 0), E[C + 124 >> 2] = 19, XA(C + 128 | 0, C + 124 | 0, 4, 0), E[C + 124 >> 2] = D, XA(C + 128 | 0, C + 124 | 0, 4, 0), E[C + 124 >> 2] = E[A + 12 >> 2], XA(C + 128 | 0, C + 124 | 0, 4, 0), (B = E[A + 8 >> 2]) && (XA(I, B, E[A + 12 >> 2], 0), 1 & o[A + 56 | 0] && (XC(E[A + 8 >> 2], E[A + 12 >> 2]), E[A + 12 >> 2] = 0)), E[C + 124 >> 2] = E[A + 20 >> 2], XA(I = C + 128 | 0, C + 124 | 0, 4, 0), (B = E[A + 16 >> 2]) && XA(I, B, E[A + 20 >> 2], 0), E[C + 124 >> 2] = E[A + 28 >> 2], XA(I = C + 128 | 0, C + 124 | 0, 4, 0), (B = E[A + 24 >> 2]) && (XA(I, B, E[A + 28 >> 2], 0), 2 & a[A + 56 | 0] && (XC(E[A + 24 >> 2], E[A + 28 >> 2]), E[A + 28 >> 2] = 0)), E[C + 124 >> 2] = E[A + 36 >> 2], XA(I = C + 128 | 0, C + 124 | 0, 4, 0), (B = E[A + 32 >> 2]) && XA(I, B, E[A + 36 >> 2], 0), Yg(C + 128 | 0, C + 48 | 0, 64), XC(C + 112 | 0, 8), E[Q + 28 >> 2]) for(B = 0;;){
                                                        for(E[C + 112 >> 2] = 0, E[C + 116 >> 2] = B, aA(C + 128 | 0, 1024, C + 48 | 0, 72), D = E[E[Q >> 2] + 4 >> 2] + (c(E[Q + 24 >> 2], B) << 10) | 0, I = 0; i = (t = I << 3) + D | 0, p = E[4 + (e = (r = C + 128 | 0) + t | 0) >> 2], E[i >> 2] = E[e >> 2], E[i + 4 >> 2] = p, e = (i = 8 | t) + D | 0, p = E[4 + (i = i + r | 0) >> 2], E[e >> 2] = E[i >> 2], E[e + 4 >> 2] = p, e = (i = 16 | t) + D | 0, p = E[4 + (i = i + r | 0) >> 2], E[e >> 2] = E[i >> 2], E[e + 4 >> 2] = p, i = (t |= 24) + D | 0, e = E[4 + (t = t + r | 0) >> 2], E[i >> 2] = E[t >> 2], E[i + 4 >> 2] = e, 128 != (0 | (I = I + 4 | 0)););
                                                        for(E[C + 112 >> 2] = 1, aA(r, 1024, C + 48 | 0, 72), D = 1024 + (E[E[Q >> 2] + 4 >> 2] + (c(E[Q + 24 >> 2], B) << 10) | 0) | 0, I = 0; i = (t = I << 3) + D | 0, p = E[4 + (e = (r = C + 128 | 0) + t | 0) >> 2], E[i >> 2] = E[e >> 2], E[i + 4 >> 2] = p, e = (i = 8 | t) + D | 0, p = E[4 + (i = i + r | 0) >> 2], E[e >> 2] = E[i >> 2], E[e + 4 >> 2] = p, e = (i = 16 | t) + D | 0, p = E[4 + (i = i + r | 0) >> 2], E[e >> 2] = E[i >> 2], E[e + 4 >> 2] = p, i = (t |= 24) + D | 0, r = E[4 + (t = t + r | 0) >> 2], E[i >> 2] = E[t >> 2], E[i + 4 >> 2] = r, 128 != (0 | (I = I + 4 | 0)););
                                                        if (!((B = B + 1 | 0) >>> 0 < _[Q + 28 >> 2])) break;
                                                    }
                                                    XC(C + 128 | 0, 1024), XC(C + 48 | 0, 72), I = 0;
                                                }
                                                h = f;
                                            }
                                            if (C = I, !I) {
                                                if (E[g + 12 >> 2]) for(;;){
                                                    if (h = I = h - 80 | 0, !(!(Q = g + 4 | 0) | !E[Q + 28 >> 2])) {
                                                        for(o[I + 72 | 0] = 0, E[I + 64 >> 2] = y, C = 0; E[I + 76 >> 2] = 0, B = E[I + 76 >> 2], E[I + 56 >> 2] = E[I + 72 >> 2], E[I + 60 >> 2] = B, E[I + 68 >> 2] = C, B = E[I + 68 >> 2], E[I + 48 >> 2] = E[I + 64 >> 2], E[I + 52 >> 2] = B, S(Q, I + 48 | 0), (C = C + 1 | 0) >>> 0 < (B = E[Q + 28 >> 2]) >>> 0;);
                                                        if (o[I + 72 | 0] = 1, B) {
                                                            for(C = 0; E[I + 76 >> 2] = 0, B = E[I + 76 >> 2], E[I + 40 >> 2] = E[I + 72 >> 2], E[I + 44 >> 2] = B, E[I + 68 >> 2] = C, B = E[I + 68 >> 2], E[I + 32 >> 2] = E[I + 64 >> 2], E[I + 36 >> 2] = B, S(Q, I + 32 | 0), (C = C + 1 | 0) >>> 0 < (B = E[Q + 28 >> 2]) >>> 0;);
                                                            if (o[I + 72 | 0] = 2, B) {
                                                                for(C = 0; E[I + 76 >> 2] = 0, B = E[I + 76 >> 2], E[I + 24 >> 2] = E[I + 72 >> 2], E[I + 28 >> 2] = B, E[I + 68 >> 2] = C, B = E[I + 68 >> 2], E[I + 16 >> 2] = E[I + 64 >> 2], E[I + 20 >> 2] = B, S(Q, I + 16 | 0), (C = C + 1 | 0) >>> 0 < (B = E[Q + 28 >> 2]) >>> 0;);
                                                                if (o[I + 72 | 0] = 3, B) for(C = 0; E[I + 76 >> 2] = 0, B = E[I + 76 >> 2], E[I + 8 >> 2] = E[I + 72 >> 2], E[I + 12 >> 2] = B, E[I + 68 >> 2] = C, B = E[I + 68 >> 2], E[I >> 2] = E[I + 64 >> 2], E[I + 4 >> 2] = B, S(Q, I), (C = C + 1 | 0) >>> 0 < _[Q + 28 >> 2];);
                                                            }
                                                        }
                                                    }
                                                    if (h = I + 80 | 0, !((y = y + 1 | 0) >>> 0 < _[g + 12 >> 2])) break;
                                                }
                                                if (h = I = h - 2048 | 0, !(!A | !(C = g + 4 | 0))) {
                                                    if (i = E[C >> 2], f = E[C + 24 >> 2], Sg(I + 1024 | 0, (E[i + 4 >> 2] + (f << 10) | 0) - 1024 | 0, 1024), (e = E[C + 28 >> 2]) >>> 0 >= 2) for(p = f - 1 | 0, D = 1;;){
                                                        for(Q = E[i + 4 >> 2] + (c(D, f) + p << 10) | 0, t = 0; s = E[(y = (B = t << 3) + (r = I + 1024 | 0) | 0) >> 2], n = E[(w = B + Q | 0) >> 2], w = E[y + 4 >> 2] ^ E[w + 4 >> 2], E[y >> 2] = s ^ n, E[y + 4 >> 2] = w, w = E[(y = (s = 8 | B) + r | 0) >> 2], n = E[(s = Q + s | 0) >> 2], s = E[y + 4 >> 2] ^ E[s + 4 >> 2], E[y >> 2] = w ^ n, E[y + 4 >> 2] = s, w = E[(y = (s = 16 | B) + r | 0) >> 2], n = E[(s = Q + s | 0) >> 2], s = E[y + 4 >> 2] ^ E[s + 4 >> 2], E[y >> 2] = w ^ n, E[y + 4 >> 2] = s, y = E[(B = (y = r) + (r = 24 | B) | 0) >> 2], s = E[(r = Q + r | 0) >> 2], r = E[B + 4 >> 2] ^ E[r + 4 >> 2], E[B >> 2] = y ^ s, E[B + 4 >> 2] = r, 128 != (0 | (t = t + 4 | 0)););
                                                        if ((0 | e) == (0 | (D = D + 1 | 0))) break;
                                                    }
                                                    Q = Sg(I, I + 1024 | 0, 1024), aA(E[A >> 2], E[A + 4 >> 2], Q, 1024), XC(Q + 1024 | 0, 1024), XC(Q, 1024), VI(C, E[A + 56 >> 2]);
                                                }
                                                h = I + 2048 | 0, C = 0;
                                            }
                                        }
                                        return h = g + 48 | 0, C;
                                    }
                                    function P(A, I, g) {
                                        var C, B, Q, i, o, _, c, t, r, e, y, s, D, p, w = 0, f = 0, n = 0;
                                        for(h = C = h - 288 | 0, y = a[I + 4 | 0] | a[I + 5 | 0] << 8 | a[I + 6 | 0] << 16 | a[I + 7 | 0] << 24, s = a[I + 8 | 0] | a[I + 9 | 0] << 8 | a[I + 10 | 0] << 16 | a[I + 11 | 0] << 24, D = a[I + 12 | 0] | a[I + 13 | 0] << 8 | a[I + 14 | 0] << 16 | a[I + 15 | 0] << 24, c = a[A + 4 | 0] | a[A + 5 | 0] << 8 | a[A + 6 | 0] << 16 | a[A + 7 | 0] << 24, t = a[A + 8 | 0] | a[A + 9 | 0] << 8 | a[A + 10 | 0] << 16 | a[A + 11 | 0] << 24, r = a[A + 12 | 0] | a[A + 13 | 0] << 8 | a[A + 14 | 0] << 16 | a[A + 15 | 0] << 24, p = a[0 | I] | a[I + 1 | 0] << 8 | a[I + 2 | 0] << 16 | a[I + 3 | 0] << 24, I = g + 112 | 0, A = 33620224 ^ (e = a[0 | A] | a[A + 1 | 0] << 8 | a[A + 2 | 0] << 16 | a[A + 3 | 0] << 24), E[I >> 2] = A, E[(o = g + 96 | 0) >> 2] = 1427652059 ^ e, E[(_ = g + 80 | 0) >> 2] = A, f = e ^ p, E[(A = g - -64 | 0) >> 2] = f, E[g + 56 >> 2] = 1110511904, E[g + 60 >> 2] = -584534669, E[(B = g + 48 | 0) >> 2] = 1427652059, E[B + 4 >> 2] = -248528275, E[g + 40 >> 2] = 1496785429, E[g + 44 >> 2] = 1652156816, E[(Q = g + 32 | 0) >> 2] = 33620224, E[Q + 4 >> 2] = 218629379, E[g + 24 >> 2] = 1110511904, E[g + 28 >> 2] = -584534669, E[(i = g + 16 | 0) >> 2] = 1427652059, E[i + 4 >> 2] = -248528275, E[g >> 2] = f, f = 1652156816 ^ r, E[g + 124 >> 2] = f, n = 1496785429 ^ t, E[g + 120 >> 2] = n, w = 218629379 ^ c, E[g + 116 >> 2] = w, E[g + 108 >> 2] = -584534669 ^ r, E[g + 104 >> 2] = 1110511904 ^ t, E[g + 100 >> 2] = -248528275 ^ c, E[g + 92 >> 2] = f, E[g + 88 >> 2] = n, E[g + 84 >> 2] = w, f = r ^ D, E[g + 76 >> 2] = f, n = t ^ s, E[g + 72 >> 2] = n, w = c ^ y, E[g + 68 >> 2] = w, E[g + 12 >> 2] = f, E[g + 8 >> 2] = n, E[g + 4 >> 2] = w, n = 0; f = E[I + 12 >> 2], E[C + 280 >> 2] = E[I + 8 >> 2], E[C + 284 >> 2] = f, f = E[I + 4 >> 2], E[C + 272 >> 2] = E[I >> 2], E[C + 276 >> 2] = f, f = E[o + 12 >> 2], E[C + 248 >> 2] = E[o + 8 >> 2], E[C + 252 >> 2] = f, f = E[o + 4 >> 2], E[C + 240 >> 2] = E[o >> 2], E[C + 244 >> 2] = f, f = E[I + 12 >> 2], E[C + 232 >> 2] = E[I + 8 >> 2], E[C + 236 >> 2] = f, f = E[I + 4 >> 2], E[C + 224 >> 2] = E[I >> 2], E[C + 228 >> 2] = f, $A(f = C + 256 | 0, C + 240 | 0, C + 224 | 0), w = E[C + 268 >> 2], E[I + 8 >> 2] = E[C + 264 >> 2], E[I + 12 >> 2] = w, w = E[C + 260 >> 2], E[I >> 2] = E[C + 256 >> 2], E[I + 4 >> 2] = w, w = E[_ + 12 >> 2], E[C + 216 >> 2] = E[_ + 8 >> 2], E[C + 220 >> 2] = w, w = E[_ + 4 >> 2], E[C + 208 >> 2] = E[_ >> 2], E[C + 212 >> 2] = w, w = E[o + 12 >> 2], E[C + 200 >> 2] = E[o + 8 >> 2], E[C + 204 >> 2] = w, w = E[o + 4 >> 2], E[C + 192 >> 2] = E[o >> 2], E[C + 196 >> 2] = w, $A(f, C + 208 | 0, C + 192 | 0), w = E[C + 268 >> 2], E[o + 8 >> 2] = E[C + 264 >> 2], E[o + 12 >> 2] = w, w = E[C + 260 >> 2], E[o >> 2] = E[C + 256 >> 2], E[o + 4 >> 2] = w, w = E[A + 12 >> 2], E[C + 184 >> 2] = E[A + 8 >> 2], E[C + 188 >> 2] = w, w = E[A + 4 >> 2], E[C + 176 >> 2] = E[A >> 2], E[C + 180 >> 2] = w, w = E[_ + 12 >> 2], E[C + 168 >> 2] = E[_ + 8 >> 2], E[C + 172 >> 2] = w, w = E[_ + 4 >> 2], E[C + 160 >> 2] = E[_ >> 2], E[C + 164 >> 2] = w, $A(f, C + 176 | 0, C + 160 | 0), w = E[C + 268 >> 2], E[_ + 8 >> 2] = E[C + 264 >> 2], E[_ + 12 >> 2] = w, w = E[C + 260 >> 2], E[_ >> 2] = E[C + 256 >> 2], E[_ + 4 >> 2] = w, w = E[B + 12 >> 2], E[C + 152 >> 2] = E[B + 8 >> 2], E[C + 156 >> 2] = w, w = E[B + 4 >> 2], E[C + 144 >> 2] = E[B >> 2], E[C + 148 >> 2] = w, w = E[A + 12 >> 2], E[C + 136 >> 2] = E[A + 8 >> 2], E[C + 140 >> 2] = w, w = E[A + 4 >> 2], E[C + 128 >> 2] = E[A >> 2], E[C + 132 >> 2] = w, $A(f, C + 144 | 0, C + 128 | 0), w = E[C + 268 >> 2], E[A + 8 >> 2] = E[C + 264 >> 2], E[A + 12 >> 2] = w, w = E[C + 260 >> 2], E[A >> 2] = E[C + 256 >> 2], E[A + 4 >> 2] = w, w = E[Q + 12 >> 2], E[C + 120 >> 2] = E[Q + 8 >> 2], E[C + 124 >> 2] = w, w = E[Q + 4 >> 2], E[C + 112 >> 2] = E[Q >> 2], E[C + 116 >> 2] = w, w = E[B + 12 >> 2], E[C + 104 >> 2] = E[B + 8 >> 2], E[C + 108 >> 2] = w, w = E[B + 4 >> 2], E[C + 96 >> 2] = E[B >> 2], E[C + 100 >> 2] = w, $A(f, C + 112 | 0, C + 96 | 0), w = E[C + 268 >> 2], E[B + 8 >> 2] = E[C + 264 >> 2], E[B + 12 >> 2] = w, w = E[C + 260 >> 2], E[B >> 2] = E[C + 256 >> 2], E[B + 4 >> 2] = w, w = E[i + 12 >> 2], E[C + 88 >> 2] = E[i + 8 >> 2], E[C + 92 >> 2] = w, w = E[i + 4 >> 2], E[C + 80 >> 2] = E[i >> 2], E[C + 84 >> 2] = w, w = E[Q + 12 >> 2], E[C + 72 >> 2] = E[Q + 8 >> 2], E[C + 76 >> 2] = w, w = E[Q + 4 >> 2], E[C + 64 >> 2] = E[Q >> 2], E[C + 68 >> 2] = w, $A(f, C + 80 | 0, C - -64 | 0), w = E[C + 268 >> 2], E[Q + 8 >> 2] = E[C + 264 >> 2], E[Q + 12 >> 2] = w, w = E[C + 260 >> 2], E[Q >> 2] = E[C + 256 >> 2], E[Q + 4 >> 2] = w, w = E[g + 12 >> 2], E[C + 56 >> 2] = E[g + 8 >> 2], E[C + 60 >> 2] = w, w = E[g + 4 >> 2], E[C + 48 >> 2] = E[g >> 2], E[C + 52 >> 2] = w, w = E[i + 12 >> 2], E[C + 40 >> 2] = E[i + 8 >> 2], E[C + 44 >> 2] = w, w = E[i + 4 >> 2], E[C + 32 >> 2] = E[i >> 2], E[C + 36 >> 2] = w, $A(f, C + 48 | 0, C + 32 | 0), w = E[C + 268 >> 2], E[i + 8 >> 2] = E[C + 264 >> 2], E[i + 12 >> 2] = w, w = E[C + 260 >> 2], E[i >> 2] = E[C + 256 >> 2], E[i + 4 >> 2] = w, w = E[C + 284 >> 2], E[C + 24 >> 2] = E[C + 280 >> 2], E[C + 28 >> 2] = w, w = E[C + 276 >> 2], E[C + 16 >> 2] = E[C + 272 >> 2], E[C + 20 >> 2] = w, w = E[g + 12 >> 2], E[C + 8 >> 2] = E[g + 8 >> 2], E[C + 12 >> 2] = w, w = E[g + 4 >> 2], E[C >> 2] = E[g >> 2], E[C + 4 >> 2] = w, $A(f, C + 16 | 0, C), f = E[C + 268 >> 2], E[g + 8 >> 2] = E[C + 264 >> 2], E[g + 12 >> 2] = f, f = E[C + 260 >> 2], E[g >> 2] = E[C + 256 >> 2], E[g + 4 >> 2] = f, E[g + 12 >> 2] = (a[g + 12 | 0] | a[g + 13 | 0] << 8 | a[g + 14 | 0] << 16 | a[g + 15 | 0] << 24) ^ D, E[g + 8 >> 2] = (a[g + 8 | 0] | a[g + 9 | 0] << 8 | a[g + 10 | 0] << 16 | a[g + 11 | 0] << 24) ^ s, E[g + 4 >> 2] = (a[g + 4 | 0] | a[g + 5 | 0] << 8 | a[g + 6 | 0] << 16 | a[g + 7 | 0] << 24) ^ y, E[g >> 2] = (a[0 | g] | a[g + 1 | 0] << 8 | a[g + 2 | 0] << 16 | a[g + 3 | 0] << 24) ^ p, E[A >> 2] = (a[0 | A] | a[A + 1 | 0] << 8 | a[A + 2 | 0] << 16 | a[A + 3 | 0] << 24) ^ e, E[g + 68 >> 2] = (a[g + 68 | 0] | a[g + 69 | 0] << 8 | a[g + 70 | 0] << 16 | a[g + 71 | 0] << 24) ^ c, E[g + 72 >> 2] = (a[g + 72 | 0] | a[g + 73 | 0] << 8 | a[g + 74 | 0] << 16 | a[g + 75 | 0] << 24) ^ t, E[g + 76 >> 2] = (a[g + 76 | 0] | a[g + 77 | 0] << 8 | a[g + 78 | 0] << 16 | a[g + 79 | 0] << 24) ^ r, 10 != (0 | (n = n + 1 | 0)););
                                        h = C + 288 | 0;
                                    }
                                    function q(A, I, g, C, B) {
                                        var Q, i, _, c, t, r, e, y, s, D, p, w, f, n, k, F = 0, N = 0, S = 0, G = 0, M = 0, b = 0, K = 0, H = 0, Y = 0, d = 0, J = 0, U = 0, l = 0, m = 0, u = 0, x = 0, R = 0, v = 0, L = 0, P = 0, q = 0, z = 0, j = 0, X = 0, O = 0, V = 0, Z = 0, W = 0, T = 0, $ = 0, AA = 0, IA = 0, gA = 0, CA = 0;
                                        for(Q = h + -64 | 0, i = E[A + 60 >> 2], _ = E[A + 56 >> 2], P = E[A + 52 >> 2], L = E[A + 48 >> 2], c = E[A + 44 >> 2], t = E[A + 40 >> 2], r = E[A + 36 >> 2], e = E[A + 32 >> 2], y = E[A + 28 >> 2], s = E[A + 24 >> 2], D = E[A + 20 >> 2], p = E[A + 16 >> 2], w = E[A + 12 >> 2], f = E[A + 8 >> 2], n = E[A + 4 >> 2], k = E[A >> 2];;){
                                            if (!B & C >>> 0 > 63 | B) F = g;
                                            else {
                                                if (E[Q + 56 >> 2] = 0, E[Q + 60 >> 2] = 0, E[Q + 48 >> 2] = 0, E[Q + 52 >> 2] = 0, E[Q + 40 >> 2] = 0, E[Q + 44 >> 2] = 0, E[Q + 32 >> 2] = 0, E[Q + 36 >> 2] = 0, E[Q + 24 >> 2] = 0, E[Q + 28 >> 2] = 0, E[Q + 16 >> 2] = 0, E[Q + 20 >> 2] = 0, E[Q + 8 >> 2] = 0, E[Q + 12 >> 2] = 0, E[Q >> 2] = 0, E[Q + 4 >> 2] = 0, S = 0, C | B) for(; o[S + Q | 0] = a[I + S | 0], !B & (S = S + 1 | 0) >>> 0 < C >>> 0 | B;);
                                                I = F = Q, O = g;
                                            }
                                            for(q = 20, N = k, d = n, J = f, m = w, S = p, g = D, M = s, b = y, K = e, x = r, U = t, G = i, R = _, u = P, l = L, H = c; Y = S, N = Lg((S = N + S | 0) ^ l, 16), Y = l = Lg(Y ^ (K = N + K | 0), 12), l = Lg((v = S + l | 0) ^ N, 8), S = Lg(Y ^ (K = l + K | 0), 7), G = Lg((N = b + m | 0) ^ G, 16), b = Lg((H = G + H | 0) ^ b, 12), m = Lg((J = M + J | 0) ^ R, 16), M = Lg((U = m + U | 0) ^ M, 12), R = (z = N + b | 0) + S | 0, j = Lg((J = M + J | 0) ^ m, 8), N = Lg(R ^ j, 16), m = Lg((d = g + d | 0) ^ u, 16), g = Lg((x = m + x | 0) ^ g, 12), Y = S, u = Lg((d = g + d | 0) ^ m, 8), Y = Lg(Y ^ (S = (X = u + x | 0) + N | 0), 12), R = Lg(N ^ (m = Y + R | 0), 8), S = Lg((x = R + S | 0) ^ Y, 7), Y = K, K = J, N = Lg(G ^ z, 8), J = Lg((G = N + H | 0) ^ b, 7), u = Lg((K = K + J | 0) ^ u, 16), H = Lg((b = Y + u | 0) ^ J, 12), u = Lg(u ^ (J = H + K | 0), 8), b = Lg((K = b + u | 0) ^ H, 7), H = G, G = d, d = Lg((U = U + j | 0) ^ M, 7), M = H + (l = Lg((G = G + d | 0) ^ l, 16)) | 0, H = G, G = Lg(M ^ d, 12), l = Lg(l ^ (d = H + G | 0), 8), M = Lg((H = M + l | 0) ^ G, 7), Y = U, G = N, N = Lg(g ^ X, 7), G = Lg(G ^ (U = N + v | 0), 16), v = Lg((g = Y + G | 0) ^ N, 12), G = Lg(G ^ (N = v + U | 0), 8), g = Lg((U = g + G | 0) ^ v, 7), q = q - 2 | 0;);
                                            if (q = a[I + 4 | 0] | a[I + 5 | 0] << 8 | a[I + 6 | 0] << 16 | a[I + 7 | 0] << 24, v = a[I + 8 | 0] | a[I + 9 | 0] << 8 | a[I + 10 | 0] << 16 | a[I + 11 | 0] << 24, z = a[I + 12 | 0] | a[I + 13 | 0] << 8 | a[I + 14 | 0] << 16 | a[I + 15 | 0] << 24, j = a[I + 16 | 0] | a[I + 17 | 0] << 8 | a[I + 18 | 0] << 16 | a[I + 19 | 0] << 24, X = a[I + 20 | 0] | a[I + 21 | 0] << 8 | a[I + 22 | 0] << 16 | a[I + 23 | 0] << 24, Y = a[I + 24 | 0] | a[I + 25 | 0] << 8 | a[I + 26 | 0] << 16 | a[I + 27 | 0] << 24, V = a[I + 28 | 0] | a[I + 29 | 0] << 8 | a[I + 30 | 0] << 16 | a[I + 31 | 0] << 24, Z = a[I + 32 | 0] | a[I + 33 | 0] << 8 | a[I + 34 | 0] << 16 | a[I + 35 | 0] << 24, W = a[I + 36 | 0] | a[I + 37 | 0] << 8 | a[I + 38 | 0] << 16 | a[I + 39 | 0] << 24, T = a[I + 40 | 0] | a[I + 41 | 0] << 8 | a[I + 42 | 0] << 16 | a[I + 43 | 0] << 24, $ = a[I + 44 | 0] | a[I + 45 | 0] << 8 | a[I + 46 | 0] << 16 | a[I + 47 | 0] << 24, AA = a[I + 48 | 0] | a[I + 49 | 0] << 8 | a[I + 50 | 0] << 16 | a[I + 51 | 0] << 24, IA = a[I + 52 | 0] | a[I + 53 | 0] << 8 | a[I + 54 | 0] << 16 | a[I + 55 | 0] << 24, gA = a[I + 56 | 0] | a[I + 57 | 0] << 8 | a[I + 58 | 0] << 16 | a[I + 59 | 0] << 24, CA = a[I + 60 | 0] | a[I + 61 | 0] << 8 | a[I + 62 | 0] << 16 | a[I + 63 | 0] << 24, N = N + k ^ (a[0 | I] | a[I + 1 | 0] << 8 | a[I + 2 | 0] << 16 | a[I + 3 | 0] << 24), o[0 | F] = N, o[F + 1 | 0] = N >>> 8, o[F + 2 | 0] = N >>> 16, o[F + 3 | 0] = N >>> 24, N = G + i ^ CA, o[F + 60 | 0] = N, o[F + 61 | 0] = N >>> 8, o[F + 62 | 0] = N >>> 16, o[F + 63 | 0] = N >>> 24, N = R + _ ^ gA, o[F + 56 | 0] = N, o[F + 57 | 0] = N >>> 8, o[F + 58 | 0] = N >>> 16, o[F + 59 | 0] = N >>> 24, N = u + P ^ IA, o[F + 52 | 0] = N, o[F + 53 | 0] = N >>> 8, o[F + 54 | 0] = N >>> 16, o[F + 55 | 0] = N >>> 24, N = l + L ^ AA, o[F + 48 | 0] = N, o[F + 49 | 0] = N >>> 8, o[F + 50 | 0] = N >>> 16, o[F + 51 | 0] = N >>> 24, N = H + c ^ $, o[F + 44 | 0] = N, o[F + 45 | 0] = N >>> 8, o[F + 46 | 0] = N >>> 16, o[F + 47 | 0] = N >>> 24, N = U + t ^ T, o[F + 40 | 0] = N, o[F + 41 | 0] = N >>> 8, o[F + 42 | 0] = N >>> 16, o[F + 43 | 0] = N >>> 24, N = x + r ^ W, o[F + 36 | 0] = N, o[F + 37 | 0] = N >>> 8, o[F + 38 | 0] = N >>> 16, o[F + 39 | 0] = N >>> 24, N = K + e ^ Z, o[F + 32 | 0] = N, o[F + 33 | 0] = N >>> 8, o[F + 34 | 0] = N >>> 16, o[F + 35 | 0] = N >>> 24, b = b + y ^ V, o[F + 28 | 0] = b, o[F + 29 | 0] = b >>> 8, o[F + 30 | 0] = b >>> 16, o[F + 31 | 0] = b >>> 24, M = Y ^ M + s, o[F + 24 | 0] = M, o[F + 25 | 0] = M >>> 8, o[F + 26 | 0] = M >>> 16, o[F + 27 | 0] = M >>> 24, g = X ^ g + D, o[F + 20 | 0] = g, o[F + 21 | 0] = g >>> 8, o[F + 22 | 0] = g >>> 16, o[F + 23 | 0] = g >>> 24, g = j ^ S + p, o[F + 16 | 0] = g, o[F + 17 | 0] = g >>> 8, o[F + 18 | 0] = g >>> 16, o[F + 19 | 0] = g >>> 24, g = z ^ m + w, o[F + 12 | 0] = g, o[F + 13 | 0] = g >>> 8, o[F + 14 | 0] = g >>> 16, o[F + 15 | 0] = g >>> 24, g = v ^ J + f, o[F + 8 | 0] = g, o[F + 9 | 0] = g >>> 8, o[F + 10 | 0] = g >>> 16, o[F + 11 | 0] = g >>> 24, g = q ^ d + n, o[F + 4 | 0] = g, o[F + 5 | 0] = g >>> 8, o[F + 6 | 0] = g >>> 16, o[F + 7 | 0] = g >>> 24, P = !(L = L + 1 | 0) + P | 0, !B & C >>> 0 <= 64) {
                                                if (!(!C | !B & C >>> 0 > 63 | 0 != (0 | B))) for(S = 0; o[S + O | 0] = a[F + S | 0], C >>> 0 > (S = S + 1 | 0) >>> 0;);
                                                E[A + 52 >> 2] = P, E[A + 48 >> 2] = L;
                                                break;
                                            }
                                            I = I - -64 | 0, g = F - -64 | 0, B = B - 1 | 0, B = (C = C + -64 | 0) >>> 0 < 4294967232 ? B + 1 | 0 : B;
                                        }
                                    }
                                    function z(A, I) {
                                        I |= 0;
                                        var g, C = 0, B = 0, Q = 0, i = 0, a = 0, _ = 0, c = 0;
                                        return h = g = h - 704 | 0, C = 80 + ((B = E[72 + (A |= 0) >> 2] >>> 3 & 127) + A | 0) | 0, B >>> 0 >= 112 ? (Sg(C, 35456, 128 - B | 0), F(A, B = A + 80 | 0, g, g + 640 | 0), Hg(B, 0, 112)) : Sg(C, 35456, 112 - B | 0), _ = (Q = E[A + 64 >> 2]) << 24 | (65280 & Q) << 8, B = (i = 16711680 & Q) >>> 8 | 0, c = i << 24, i = (a = -16777216 & Q) >>> 24 | 0, C = c | a << 8 | -16777216 & ((255 & (C = E[A + 68 >> 2])) << 24 | Q >>> 8) | 16711680 & ((16777215 & C) << 8 | Q >>> 24) | C >>> 8 & 65280 | C >>> 24, o[A + 192 | 0] = C, o[A + 193 | 0] = C >>> 8, o[A + 194 | 0] = C >>> 16, o[A + 195 | 0] = C >>> 24, B = (C = B | i | _) | (B = 0) | B | 0, o[A + 196 | 0] = B, o[A + 197 | 0] = B >>> 8, o[A + 198 | 0] = B >>> 16, o[A + 199 | 0] = B >>> 24, _ = (Q = E[A + 72 >> 2]) << 24 | (65280 & Q) << 8, B = (i = 16711680 & Q) >>> 8 | 0, c = i << 24, i = (a = -16777216 & Q) >>> 24 | 0, C = c | a << 8 | -16777216 & ((255 & (C = E[A + 76 >> 2])) << 24 | Q >>> 8) | 16711680 & ((16777215 & C) << 8 | Q >>> 24) | C >>> 8 & 65280 | C >>> 24, o[A + 200 | 0] = C, o[A + 201 | 0] = C >>> 8, o[A + 202 | 0] = C >>> 16, o[A + 203 | 0] = C >>> 24, B = (C = B | i | _) | (B = 0) | B | 0, o[A + 204 | 0] = B, o[A + 205 | 0] = B >>> 8, o[A + 206 | 0] = B >>> 16, o[A + 207 | 0] = B >>> 24, F(A, A + 80 | 0, g, g + 640 | 0), _ = (Q = E[A >> 2]) << 24 | (65280 & Q) << 8, B = (i = 16711680 & Q) >>> 8 | 0, c = i << 24, i = (a = -16777216 & Q) >>> 24 | 0, C = c | a << 8 | -16777216 & ((255 & (C = E[A + 4 >> 2])) << 24 | Q >>> 8) | 16711680 & ((16777215 & C) << 8 | Q >>> 24) | C >>> 8 & 65280 | C >>> 24, o[0 | I] = C, o[I + 1 | 0] = C >>> 8, o[I + 2 | 0] = C >>> 16, o[I + 3 | 0] = C >>> 24, B = (C = B | i | _) | (B = 0) | B | 0, o[I + 4 | 0] = B, o[I + 5 | 0] = B >>> 8, o[I + 6 | 0] = B >>> 16, o[I + 7 | 0] = B >>> 24, _ = (Q = E[A + 8 >> 2]) << 24 | (65280 & Q) << 8, B = (i = 16711680 & Q) >>> 8 | 0, c = i << 24, i = (a = -16777216 & Q) >>> 24 | 0, C = c | a << 8 | -16777216 & ((255 & (C = E[A + 12 >> 2])) << 24 | Q >>> 8) | 16711680 & ((16777215 & C) << 8 | Q >>> 24) | C >>> 8 & 65280 | C >>> 24, o[I + 8 | 0] = C, o[I + 9 | 0] = C >>> 8, o[I + 10 | 0] = C >>> 16, o[I + 11 | 0] = C >>> 24, B = (C = B | i | _) | (B = 0) | B | 0, o[I + 12 | 0] = B, o[I + 13 | 0] = B >>> 8, o[I + 14 | 0] = B >>> 16, o[I + 15 | 0] = B >>> 24, _ = (Q = E[A + 16 >> 2]) << 24 | (65280 & Q) << 8, B = (i = 16711680 & Q) >>> 8 | 0, c = i << 24, i = (a = -16777216 & Q) >>> 24 | 0, C = c | a << 8 | -16777216 & ((255 & (C = E[A + 20 >> 2])) << 24 | Q >>> 8) | 16711680 & ((16777215 & C) << 8 | Q >>> 24) | C >>> 8 & 65280 | C >>> 24, o[I + 16 | 0] = C, o[I + 17 | 0] = C >>> 8, o[I + 18 | 0] = C >>> 16, o[I + 19 | 0] = C >>> 24, B = (C = B | i | _) | (B = 0) | B | 0, o[I + 20 | 0] = B, o[I + 21 | 0] = B >>> 8, o[I + 22 | 0] = B >>> 16, o[I + 23 | 0] = B >>> 24, _ = (Q = E[A + 24 >> 2]) << 24 | (65280 & Q) << 8, B = (i = 16711680 & Q) >>> 8 | 0, c = i << 24, i = (a = -16777216 & Q) >>> 24 | 0, C = c | a << 8 | -16777216 & ((255 & (C = E[A + 28 >> 2])) << 24 | Q >>> 8) | 16711680 & ((16777215 & C) << 8 | Q >>> 24) | C >>> 8 & 65280 | C >>> 24, o[I + 24 | 0] = C, o[I + 25 | 0] = C >>> 8, o[I + 26 | 0] = C >>> 16, o[I + 27 | 0] = C >>> 24, B = (C = B | i | _) | (B = 0) | B | 0, o[I + 28 | 0] = B, o[I + 29 | 0] = B >>> 8, o[I + 30 | 0] = B >>> 16, o[I + 31 | 0] = B >>> 24, _ = (Q = E[A + 32 >> 2]) << 24 | (65280 & Q) << 8, B = (i = 16711680 & Q) >>> 8 | 0, c = i << 24, i = (a = -16777216 & Q) >>> 24 | 0, C = c | a << 8 | -16777216 & ((255 & (C = E[A + 36 >> 2])) << 24 | Q >>> 8) | 16711680 & ((16777215 & C) << 8 | Q >>> 24) | C >>> 8 & 65280 | C >>> 24, o[I + 32 | 0] = C, o[I + 33 | 0] = C >>> 8, o[I + 34 | 0] = C >>> 16, o[I + 35 | 0] = C >>> 24, B = (C = B | i | _) | (B = 0) | B | 0, o[I + 36 | 0] = B, o[I + 37 | 0] = B >>> 8, o[I + 38 | 0] = B >>> 16, o[I + 39 | 0] = B >>> 24, _ = (Q = E[A + 40 >> 2]) << 24 | (65280 & Q) << 8, B = (i = 16711680 & Q) >>> 8 | 0, c = i << 24, i = (a = -16777216 & Q) >>> 24 | 0, C = c | a << 8 | -16777216 & ((255 & (C = E[A + 44 >> 2])) << 24 | Q >>> 8) | 16711680 & ((16777215 & C) << 8 | Q >>> 24) | C >>> 8 & 65280 | C >>> 24, o[I + 40 | 0] = C, o[I + 41 | 0] = C >>> 8, o[I + 42 | 0] = C >>> 16, o[I + 43 | 0] = C >>> 24, B = (C = B | i | _) | (B = 0) | B | 0, o[I + 44 | 0] = B, o[I + 45 | 0] = B >>> 8, o[I + 46 | 0] = B >>> 16, o[I + 47 | 0] = B >>> 24, _ = (Q = E[A + 48 >> 2]) << 24 | (65280 & Q) << 8, B = (i = 16711680 & Q) >>> 8 | 0, c = i << 24, i = (a = -16777216 & Q) >>> 24 | 0, C = c | a << 8 | -16777216 & ((255 & (C = E[A + 52 >> 2])) << 24 | Q >>> 8) | 16711680 & ((16777215 & C) << 8 | Q >>> 24) | C >>> 8 & 65280 | C >>> 24, o[I + 48 | 0] = C, o[I + 49 | 0] = C >>> 8, o[I + 50 | 0] = C >>> 16, o[I + 51 | 0] = C >>> 24, B = (C = B | i | _) | (B = 0) | B | 0, o[I + 52 | 0] = B, o[I + 53 | 0] = B >>> 8, o[I + 54 | 0] = B >>> 16, o[I + 55 | 0] = B >>> 24, _ = (Q = E[A + 56 >> 2]) << 24 | (65280 & Q) << 8, B = (i = 16711680 & Q) >>> 8 | 0, C = I, c = i << 24, i = (a = -16777216 & Q) >>> 24 | 0, I = c | a << 8 | -16777216 & ((255 & (I = E[A + 60 >> 2])) << 24 | Q >>> 8) | 16711680 & ((16777215 & I) << 8 | Q >>> 24) | I >>> 8 & 65280 | I >>> 24, o[C + 56 | 0] = I, o[C + 57 | 0] = I >>> 8, o[C + 58 | 0] = I >>> 16, o[C + 59 | 0] = I >>> 24, I = (I = B | i | _) | (B = 0) | B | 0, o[C + 60 | 0] = I, o[C + 61 | 0] = I >>> 8, o[C + 62 | 0] = I >>> 16, o[C + 63 | 0] = I >>> 24, XC(g, 704), XC(A, 208), h = g + 704 | 0, 0;
                                    }
                                    function j(A, I, g) {
                                        var C, B, Q, i, _, c, t, r, e, y, s, D, p, w, f, n, k, F, N, S, G = 0;
                                        h = C = h - 224 | 0, c = a[g + 16 | 0] | a[g + 17 | 0] << 8 | a[g + 18 | 0] << 16 | a[g + 19 | 0] << 24, t = a[0 | (G = g - -64 | 0)] | a[G + 1 | 0] << 8 | a[G + 2 | 0] << 16 | a[G + 3 | 0] << 24, r = a[g + 80 | 0] | a[g + 81 | 0] << 8 | a[g + 82 | 0] << 16 | a[g + 83 | 0] << 24, e = a[g + 32 | 0] | a[g + 33 | 0] << 8 | a[g + 34 | 0] << 16 | a[g + 35 | 0] << 24, y = a[g + 48 | 0] | a[g + 49 | 0] << 8 | a[g + 50 | 0] << 16 | a[g + 51 | 0] << 24, B = a[I + 4 | 0] | a[I + 5 | 0] << 8 | a[I + 6 | 0] << 16 | a[I + 7 | 0] << 24, s = a[g + 20 | 0] | a[g + 21 | 0] << 8 | a[g + 22 | 0] << 16 | a[g + 23 | 0] << 24, D = a[g + 68 | 0] | a[g + 69 | 0] << 8 | a[g + 70 | 0] << 16 | a[g + 71 | 0] << 24, p = a[g + 84 | 0] | a[g + 85 | 0] << 8 | a[g + 86 | 0] << 16 | a[g + 87 | 0] << 24, w = a[g + 36 | 0] | a[g + 37 | 0] << 8 | a[g + 38 | 0] << 16 | a[g + 39 | 0] << 24, f = a[g + 52 | 0] | a[g + 53 | 0] << 8 | a[g + 54 | 0] << 16 | a[g + 55 | 0] << 24, Q = a[I + 8 | 0] | a[I + 9 | 0] << 8 | a[I + 10 | 0] << 16 | a[I + 11 | 0] << 24, n = a[g + 24 | 0] | a[g + 25 | 0] << 8 | a[g + 26 | 0] << 16 | a[g + 27 | 0] << 24, k = a[g + 72 | 0] | a[g + 73 | 0] << 8 | a[g + 74 | 0] << 16 | a[g + 75 | 0] << 24, F = a[g + 88 | 0] | a[g + 89 | 0] << 8 | a[g + 90 | 0] << 16 | a[g + 91 | 0] << 24, N = a[g + 40 | 0] | a[g + 41 | 0] << 8 | a[g + 42 | 0] << 16 | a[g + 43 | 0] << 24, S = a[g + 56 | 0] | a[g + 57 | 0] << 8 | a[g + 58 | 0] << 16 | a[g + 59 | 0] << 24, i = a[0 | I] | a[I + 1 | 0] << 8 | a[I + 2 | 0] << 16 | a[I + 3 | 0] << 24, I = (_ = a[I + 12 | 0] | a[I + 13 | 0] << 8 | a[I + 14 | 0] << 16 | a[I + 15 | 0] << 24) ^ (a[g + 44 | 0] | a[g + 45 | 0] << 8 | a[g + 46 | 0] << 16 | a[g + 47 | 0] << 24) & (a[g + 60 | 0] | a[g + 61 | 0] << 8 | a[g + 62 | 0] << 16 | a[g + 63 | 0] << 24) ^ (a[g + 28 | 0] | a[g + 29 | 0] << 8 | a[g + 30 | 0] << 16 | a[g + 31 | 0] << 24) ^ (a[g + 92 | 0] | a[g + 93 | 0] << 8 | a[g + 94 | 0] << 16 | a[g + 95 | 0] << 24) ^ (a[g + 76 | 0] | a[g + 77 | 0] << 8 | a[g + 78 | 0] << 16 | a[g + 79 | 0] << 24), o[A + 12 | 0] = I, o[A + 13 | 0] = I >>> 8, o[A + 14 | 0] = I >>> 16, o[A + 15 | 0] = I >>> 24, I = N & S ^ k ^ F ^ n ^ Q, o[A + 8 | 0] = I, o[A + 9 | 0] = I >>> 8, o[A + 10 | 0] = I >>> 16, o[A + 11 | 0] = I >>> 24, I = w & f ^ D ^ p ^ s ^ B, o[A + 4 | 0] = I, o[A + 5 | 0] = I >>> 8, o[A + 6 | 0] = I >>> 16, o[A + 7 | 0] = I >>> 24, I = e & y ^ c ^ t ^ r ^ i, o[0 | A] = I, o[A + 1 | 0] = I >>> 8, o[A + 2 | 0] = I >>> 16, o[A + 3 | 0] = I >>> 24, A = E[g + 92 >> 2], E[C + 216 >> 2] = E[g + 88 >> 2], E[C + 220 >> 2] = A, A = E[g + 84 >> 2], E[C + 208 >> 2] = E[g + 80 >> 2], E[C + 212 >> 2] = A, A = E[g + 76 >> 2], E[C + 184 >> 2] = E[g + 72 >> 2], E[C + 188 >> 2] = A, A = E[G + 4 >> 2], E[C + 176 >> 2] = E[G >> 2], E[C + 180 >> 2] = A, A = E[g + 92 >> 2], E[C + 168 >> 2] = E[g + 88 >> 2], E[C + 172 >> 2] = A, A = E[g + 84 >> 2], E[C + 160 >> 2] = E[g + 80 >> 2], E[C + 164 >> 2] = A, $A(A = C + 192 | 0, C + 176 | 0, C + 160 | 0), I = E[C + 204 >> 2], E[g + 88 >> 2] = E[C + 200 >> 2], E[g + 92 >> 2] = I, I = E[C + 196 >> 2], E[g + 80 >> 2] = E[C + 192 >> 2], E[g + 84 >> 2] = I, I = E[g + 60 >> 2], E[C + 152 >> 2] = E[g + 56 >> 2], E[C + 156 >> 2] = I, I = E[g + 52 >> 2], E[C + 144 >> 2] = E[g + 48 >> 2], E[C + 148 >> 2] = I, I = E[g + 76 >> 2], E[C + 136 >> 2] = E[g + 72 >> 2], E[C + 140 >> 2] = I, I = E[G + 4 >> 2], E[C + 128 >> 2] = E[G >> 2], E[C + 132 >> 2] = I, $A(A, C + 144 | 0, C + 128 | 0), I = E[C + 204 >> 2], E[g + 72 >> 2] = E[C + 200 >> 2], E[g + 76 >> 2] = I, I = E[C + 196 >> 2], E[G >> 2] = E[C + 192 >> 2], E[G + 4 >> 2] = I, I = E[g + 44 >> 2], E[C + 120 >> 2] = E[g + 40 >> 2], E[C + 124 >> 2] = I, I = E[g + 36 >> 2], E[C + 112 >> 2] = E[g + 32 >> 2], E[C + 116 >> 2] = I, I = E[g + 60 >> 2], E[C + 104 >> 2] = E[g + 56 >> 2], E[C + 108 >> 2] = I, I = E[g + 52 >> 2], E[C + 96 >> 2] = E[g + 48 >> 2], E[C + 100 >> 2] = I, $A(A, C + 112 | 0, C + 96 | 0), I = E[C + 204 >> 2], E[g + 56 >> 2] = E[C + 200 >> 2], E[g + 60 >> 2] = I, I = E[C + 196 >> 2], E[g + 48 >> 2] = E[C + 192 >> 2], E[g + 52 >> 2] = I, I = E[g + 28 >> 2], E[C + 88 >> 2] = E[g + 24 >> 2], E[C + 92 >> 2] = I, I = E[g + 20 >> 2], E[C + 80 >> 2] = E[g + 16 >> 2], E[C + 84 >> 2] = I, I = E[g + 44 >> 2], E[C + 72 >> 2] = E[g + 40 >> 2], E[C + 76 >> 2] = I, I = E[g + 36 >> 2], E[C + 64 >> 2] = E[g + 32 >> 2], E[C + 68 >> 2] = I, $A(A, C + 80 | 0, C - -64 | 0), I = E[C + 204 >> 2], E[g + 40 >> 2] = E[C + 200 >> 2], E[g + 44 >> 2] = I, I = E[C + 196 >> 2], E[g + 32 >> 2] = E[C + 192 >> 2], E[g + 36 >> 2] = I, I = E[g + 12 >> 2], E[C + 56 >> 2] = E[g + 8 >> 2], E[C + 60 >> 2] = I, I = E[g + 4 >> 2], E[C + 48 >> 2] = E[g >> 2], E[C + 52 >> 2] = I, I = E[g + 28 >> 2], E[C + 40 >> 2] = E[g + 24 >> 2], E[C + 44 >> 2] = I, I = E[g + 20 >> 2], E[C + 32 >> 2] = E[g + 16 >> 2], E[C + 36 >> 2] = I, $A(A, C + 48 | 0, C + 32 | 0), I = E[C + 204 >> 2], E[g + 24 >> 2] = E[C + 200 >> 2], E[g + 28 >> 2] = I, I = E[C + 196 >> 2], E[g + 16 >> 2] = E[C + 192 >> 2], E[g + 20 >> 2] = I, I = E[C + 220 >> 2], E[C + 24 >> 2] = E[C + 216 >> 2], E[C + 28 >> 2] = I, I = E[C + 212 >> 2], E[C + 16 >> 2] = E[C + 208 >> 2], E[C + 20 >> 2] = I, I = E[g + 12 >> 2], E[C + 8 >> 2] = E[g + 8 >> 2], E[C + 12 >> 2] = I, I = E[g + 4 >> 2], E[C >> 2] = E[g >> 2], E[C + 4 >> 2] = I, $A(A, C + 16 | 0, C), A = E[C + 192 >> 2], I = E[C + 196 >> 2], G = E[C + 200 >> 2], E[g + 12 >> 2] = _ ^ E[C + 204 >> 2], E[g + 8 >> 2] = G ^ Q, E[g + 4 >> 2] = I ^ B, E[g >> 2] = A ^ i, h = C + 224 | 0;
                                    }
                                    function X(A, I, g) {
                                        var C, B, Q, i, _, c, t, r, e, y, s, D, p, w, f, n = 0, k = 0, F = 0, N = 0, S = 0;
                                        h = C = h - 224 | 0, F = a[g + 16 | 0] | a[g + 17 | 0] << 8 | a[g + 18 | 0] << 16 | a[g + 19 | 0] << 24, k = a[0 | (n = g - -64 | 0)] | a[n + 1 | 0] << 8 | a[n + 2 | 0] << 16 | a[n + 3 | 0] << 24, B = a[g + 80 | 0] | a[g + 81 | 0] << 8 | a[g + 82 | 0] << 16 | a[g + 83 | 0] << 24, Q = a[g + 32 | 0] | a[g + 33 | 0] << 8 | a[g + 34 | 0] << 16 | a[g + 35 | 0] << 24, i = a[g + 48 | 0] | a[g + 49 | 0] << 8 | a[g + 50 | 0] << 16 | a[g + 51 | 0] << 24, N = a[g + 20 | 0] | a[g + 21 | 0] << 8 | a[g + 22 | 0] << 16 | a[g + 23 | 0] << 24, _ = a[g + 68 | 0] | a[g + 69 | 0] << 8 | a[g + 70 | 0] << 16 | a[g + 71 | 0] << 24, c = a[g + 84 | 0] | a[g + 85 | 0] << 8 | a[g + 86 | 0] << 16 | a[g + 87 | 0] << 24, t = a[I + 4 | 0] | a[I + 5 | 0] << 8 | a[I + 6 | 0] << 16 | a[I + 7 | 0] << 24, r = a[g + 36 | 0] | a[g + 37 | 0] << 8 | a[g + 38 | 0] << 16 | a[g + 39 | 0] << 24, e = a[g + 52 | 0] | a[g + 53 | 0] << 8 | a[g + 54 | 0] << 16 | a[g + 55 | 0] << 24, S = a[g + 24 | 0] | a[g + 25 | 0] << 8 | a[g + 26 | 0] << 16 | a[g + 27 | 0] << 24, y = a[g + 72 | 0] | a[g + 73 | 0] << 8 | a[g + 74 | 0] << 16 | a[g + 75 | 0] << 24, s = a[g + 88 | 0] | a[g + 89 | 0] << 8 | a[g + 90 | 0] << 16 | a[g + 91 | 0] << 24, D = a[I + 8 | 0] | a[I + 9 | 0] << 8 | a[I + 10 | 0] << 16 | a[I + 11 | 0] << 24, p = a[g + 40 | 0] | a[g + 41 | 0] << 8 | a[g + 42 | 0] << 16 | a[g + 43 | 0] << 24, w = a[g + 56 | 0] | a[g + 57 | 0] << 8 | a[g + 58 | 0] << 16 | a[g + 59 | 0] << 24, f = a[0 | I] | a[I + 1 | 0] << 8 | a[I + 2 | 0] << 16 | a[I + 3 | 0] << 24, I = (a[g + 44 | 0] | a[g + 45 | 0] << 8 | a[g + 46 | 0] << 16 | a[g + 47 | 0] << 24) & (a[g + 60 | 0] | a[g + 61 | 0] << 8 | a[g + 62 | 0] << 16 | a[g + 63 | 0] << 24) ^ (a[g + 28 | 0] | a[g + 29 | 0] << 8 | a[g + 30 | 0] << 16 | a[g + 31 | 0] << 24) ^ (a[g + 76 | 0] | a[g + 77 | 0] << 8 | a[g + 78 | 0] << 16 | a[g + 79 | 0] << 24) ^ (a[g + 92 | 0] | a[g + 93 | 0] << 8 | a[g + 94 | 0] << 16 | a[g + 95 | 0] << 24) ^ (a[I + 12 | 0] | a[I + 13 | 0] << 8 | a[I + 14 | 0] << 16 | a[I + 15 | 0] << 24), o[A + 12 | 0] = I, o[A + 13 | 0] = I >>> 8, o[A + 14 | 0] = I >>> 16, o[A + 15 | 0] = I >>> 24, S = p & w ^ S ^ s ^ D ^ y, o[A + 8 | 0] = S, o[A + 9 | 0] = S >>> 8, o[A + 10 | 0] = S >>> 16, o[A + 11 | 0] = S >>> 24, N = r & e ^ N ^ c ^ t ^ _, o[A + 4 | 0] = N, o[A + 5 | 0] = N >>> 8, o[A + 6 | 0] = N >>> 16, o[A + 7 | 0] = N >>> 24, F = Q & i ^ F ^ k ^ B ^ f, o[0 | A] = F, o[A + 1 | 0] = F >>> 8, o[A + 2 | 0] = F >>> 16, o[A + 3 | 0] = F >>> 24, A = E[g + 92 >> 2], E[C + 216 >> 2] = E[g + 88 >> 2], E[C + 220 >> 2] = A, A = E[g + 84 >> 2], E[C + 208 >> 2] = E[g + 80 >> 2], E[C + 212 >> 2] = A, A = E[g + 76 >> 2], E[C + 184 >> 2] = E[g + 72 >> 2], E[C + 188 >> 2] = A, A = E[n + 4 >> 2], E[C + 176 >> 2] = E[n >> 2], E[C + 180 >> 2] = A, A = E[g + 92 >> 2], E[C + 168 >> 2] = E[g + 88 >> 2], E[C + 172 >> 2] = A, A = E[g + 84 >> 2], E[C + 160 >> 2] = E[g + 80 >> 2], E[C + 164 >> 2] = A, $A(A = C + 192 | 0, C + 176 | 0, C + 160 | 0), k = E[C + 204 >> 2], E[g + 88 >> 2] = E[C + 200 >> 2], E[g + 92 >> 2] = k, k = E[C + 196 >> 2], E[g + 80 >> 2] = E[C + 192 >> 2], E[g + 84 >> 2] = k, k = E[g + 60 >> 2], E[C + 152 >> 2] = E[g + 56 >> 2], E[C + 156 >> 2] = k, k = E[g + 52 >> 2], E[C + 144 >> 2] = E[g + 48 >> 2], E[C + 148 >> 2] = k, k = E[g + 76 >> 2], E[C + 136 >> 2] = E[g + 72 >> 2], E[C + 140 >> 2] = k, k = E[n + 4 >> 2], E[C + 128 >> 2] = E[n >> 2], E[C + 132 >> 2] = k, $A(A, C + 144 | 0, C + 128 | 0), k = E[C + 204 >> 2], E[g + 72 >> 2] = E[C + 200 >> 2], E[g + 76 >> 2] = k, k = E[C + 196 >> 2], E[n >> 2] = E[C + 192 >> 2], E[n + 4 >> 2] = k, n = E[g + 44 >> 2], E[C + 120 >> 2] = E[g + 40 >> 2], E[C + 124 >> 2] = n, n = E[g + 36 >> 2], E[C + 112 >> 2] = E[g + 32 >> 2], E[C + 116 >> 2] = n, n = E[g + 60 >> 2], E[C + 104 >> 2] = E[g + 56 >> 2], E[C + 108 >> 2] = n, n = E[g + 52 >> 2], E[C + 96 >> 2] = E[g + 48 >> 2], E[C + 100 >> 2] = n, $A(A, C + 112 | 0, C + 96 | 0), n = E[C + 204 >> 2], E[g + 56 >> 2] = E[C + 200 >> 2], E[g + 60 >> 2] = n, n = E[C + 196 >> 2], E[g + 48 >> 2] = E[C + 192 >> 2], E[g + 52 >> 2] = n, n = E[g + 28 >> 2], E[C + 88 >> 2] = E[g + 24 >> 2], E[C + 92 >> 2] = n, n = E[g + 20 >> 2], E[C + 80 >> 2] = E[g + 16 >> 2], E[C + 84 >> 2] = n, n = E[g + 44 >> 2], E[C + 72 >> 2] = E[g + 40 >> 2], E[C + 76 >> 2] = n, n = E[g + 36 >> 2], E[C + 64 >> 2] = E[g + 32 >> 2], E[C + 68 >> 2] = n, $A(A, C + 80 | 0, C - -64 | 0), n = E[C + 204 >> 2], E[g + 40 >> 2] = E[C + 200 >> 2], E[g + 44 >> 2] = n, n = E[C + 196 >> 2], E[g + 32 >> 2] = E[C + 192 >> 2], E[g + 36 >> 2] = n, n = E[g + 12 >> 2], E[C + 56 >> 2] = E[g + 8 >> 2], E[C + 60 >> 2] = n, n = E[g + 4 >> 2], E[C + 48 >> 2] = E[g >> 2], E[C + 52 >> 2] = n, n = E[g + 28 >> 2], E[C + 40 >> 2] = E[g + 24 >> 2], E[C + 44 >> 2] = n, n = E[g + 20 >> 2], E[C + 32 >> 2] = E[g + 16 >> 2], E[C + 36 >> 2] = n, $A(A, C + 48 | 0, C + 32 | 0), n = E[C + 204 >> 2], E[g + 24 >> 2] = E[C + 200 >> 2], E[g + 28 >> 2] = n, n = E[C + 196 >> 2], E[g + 16 >> 2] = E[C + 192 >> 2], E[g + 20 >> 2] = n, n = E[C + 220 >> 2], E[C + 24 >> 2] = E[C + 216 >> 2], E[C + 28 >> 2] = n, n = E[C + 212 >> 2], E[C + 16 >> 2] = E[C + 208 >> 2], E[C + 20 >> 2] = n, n = E[g + 12 >> 2], E[C + 8 >> 2] = E[g + 8 >> 2], E[C + 12 >> 2] = n, n = E[g + 4 >> 2], E[C >> 2] = E[g >> 2], E[C + 4 >> 2] = n, $A(A, C + 16 | 0, C), A = E[C + 192 >> 2], n = E[C + 196 >> 2], k = E[C + 200 >> 2], E[g + 12 >> 2] = I ^ E[C + 204 >> 2], E[g + 8 >> 2] = k ^ S, E[g + 4 >> 2] = n ^ N, E[g >> 2] = A ^ F, h = C + 224 | 0;
                                    }
                                    function O(A, I) {
                                        var g, C, B, Q, i, _, c, t, r, e, y = 0, s = 0, D = 0, p = 0, w = 0, f = 0, n = 0, k = 0, F = 0, N = 0, S = 0, G = 0, M = 0, b = 0, K = 0, H = 0, d = 0, J = 0, U = 0, l = 0, m = 0, u = 0, x = 0, R = 0, L = 0, P = 0, q = 0, z = 0, j = 0, X = 0, O = 0, V = 0, Z = 0, W = 0;
                                        h = g = h - 800 | 0, y = E[(s = I + 40 | 0) >> 2], D = E[I + 80 >> 2], p = E[I + 44 >> 2], w = E[I + 84 >> 2], f = E[I + 48 >> 2], S = E[I + 88 >> 2], n = E[I + 52 >> 2], b = E[I + 92 >> 2], G = E[I + 56 >> 2], K = E[I + 96 >> 2], H = E[I + 60 >> 2], d = E[I + 100 >> 2], J = E[(k = I - -64 | 0) >> 2], U = E[I + 104 >> 2], l = E[I + 68 >> 2], m = E[I + 108 >> 2], u = E[I + 72 >> 2], x = E[I + 112 >> 2], F = E[I + 76 >> 2], N = E[I + 116 >> 2], E[g + 324 >> 2] = F + N, E[g + 320 >> 2] = u + x, E[g + 316 >> 2] = l + m, E[g + 312 >> 2] = J + U, E[g + 308 >> 2] = H + d, E[g + 304 >> 2] = G + K, E[g + 300 >> 2] = n + b, E[g + 296 >> 2] = f + S, E[g + 292 >> 2] = p + w, E[g + 288 >> 2] = y + D, E[g + 36 >> 2] = N - F, E[g + 32 >> 2] = x - u, E[g + 28 >> 2] = m - l, E[g + 24 >> 2] = U - J, E[g + 20 >> 2] = d - H, E[g + 16 >> 2] = K - G, E[g + 12 >> 2] = b - n, E[g + 8 >> 2] = S - f, E[g + 4 >> 2] = w - p, E[g >> 2] = D - y, Y(y = g + 288 | 0, y, g), Y(p = g + 240 | 0, I, s), v(D = g + 192 | 0, p), Y(D, y, D), E[g + 452 >> 2] = 0, E[g + 456 >> 2] = 0, E[g + 460 >> 2] = 0, E[g + 464 >> 2] = 0, E[g + 468 >> 2] = 0, E[g + 436 >> 2] = 0, E[g + 440 >> 2] = 0, E[g + 444 >> 2] = 0, E[g + 448 >> 2] = 0, E[g + 432 >> 2] = 1, GA(w = g + 576 | 0, g + 432 | 0, D), Y(D = g + 720 | 0, w, y), Y(b = g + 672 | 0, w, p), Y(n = g + 48 | 0, D, b), Y(n, n, y = I + 120 | 0), Y(g + 528 | 0, I, 1648), Y(g + 480 | 0, s, 1648), Y(g + 624 | 0, D, 2960), Y(D = g + 336 | 0, y, n), BI(S = g + 384 | 0, D), P = a[g + 384 | 0], D = E[I + 36 >> 2], y = E[I + 32 >> 2], E[g + 176 >> 2] = y, E[g + 180 >> 2] = D, p = E[I + 28 >> 2], D = E[I + 24 >> 2], E[g + 168 >> 2] = D, E[g + 172 >> 2] = p, w = E[I + 20 >> 2], p = E[I + 16 >> 2], E[g + 160 >> 2] = p, E[g + 164 >> 2] = w, f = E[I + 12 >> 2], w = E[I + 8 >> 2], E[g + 152 >> 2] = w, E[g + 156 >> 2] = f, G = E[I + 4 >> 2], f = E[I >> 2], E[g + 144 >> 2] = f, E[g + 148 >> 2] = G, G = E[s >> 2], K = E[I + 44 >> 2], H = E[I + 48 >> 2], d = E[I + 52 >> 2], J = E[I + 56 >> 2], U = E[I + 60 >> 2], l = E[k >> 2], m = E[I + 68 >> 2], u = E[I + 72 >> 2], x = E[I + 76 >> 2], q = E[g + 484 >> 2], k = E[g + 148 >> 2], z = E[g + 492 >> 2], F = E[g + 156 >> 2], j = E[g + 500 >> 2], N = E[g + 164 >> 2], X = E[g + 508 >> 2], M = E[g + 172 >> 2], O = E[g + 516 >> 2], L = E[g + 180 >> 2], V = E[g + 480 >> 2], Z = E[g + 488 >> 2], W = E[g + 496 >> 2], R = E[g + 504 >> 2], s = 0 - (1 & P) | 0, E[g + 176 >> 2] = y ^ s & (y ^ E[g + 512 >> 2]), E[g + 168 >> 2] = D ^ s & (D ^ R), E[g + 160 >> 2] = p ^ s & (p ^ W), E[g + 152 >> 2] = w ^ s & (w ^ Z), E[g + 144 >> 2] = f ^ s & (f ^ V), E[g + 180 >> 2] = L ^ s & (L ^ O), E[g + 172 >> 2] = M ^ s & (M ^ X), E[g + 164 >> 2] = N ^ s & (N ^ j), E[g + 156 >> 2] = F ^ s & (F ^ z), E[g + 148 >> 2] = k ^ s & (k ^ q), L = E[g + 528 >> 2], P = E[g + 532 >> 2], q = E[g + 536 >> 2], z = E[g + 540 >> 2], j = E[g + 544 >> 2], X = E[g + 548 >> 2], O = E[g + 552 >> 2], V = E[g + 556 >> 2], Z = E[g + 560 >> 2], W = E[g + 564 >> 2], y = E[g + 672 >> 2], R = E[g + 624 >> 2], D = E[g + 676 >> 2], B = E[g + 628 >> 2], p = E[g + 680 >> 2], Q = E[g + 632 >> 2], w = E[g + 684 >> 2], i = E[g + 636 >> 2], f = E[g + 688 >> 2], _ = E[g + 640 >> 2], k = E[g + 692 >> 2], c = E[g + 644 >> 2], F = E[g + 696 >> 2], t = E[g + 648 >> 2], N = E[g + 700 >> 2], r = E[g + 652 >> 2], M = E[g + 704 >> 2], e = E[g + 656 >> 2], C = E[g + 708 >> 2], E[g + 708 >> 2] = C ^ s & (E[g + 660 >> 2] ^ C), E[g + 704 >> 2] = M ^ s & (M ^ e), E[g + 700 >> 2] = N ^ s & (N ^ r), E[g + 696 >> 2] = F ^ s & (F ^ t), E[g + 692 >> 2] = k ^ s & (k ^ c), E[g + 688 >> 2] = f ^ s & (f ^ _), E[g + 684 >> 2] = w ^ s & (w ^ i), E[g + 680 >> 2] = p ^ s & (p ^ Q), E[g + 676 >> 2] = D ^ s & (D ^ B), E[g + 672 >> 2] = y ^ s & (y ^ R), Y(y = g + 96 | 0, g + 144 | 0, n), BI(S, y), D = E[I + 80 >> 2], p = E[I + 84 >> 2], w = E[I + 88 >> 2], f = E[I + 92 >> 2], n = E[I + 96 >> 2], k = E[I + 100 >> 2], F = E[I + 104 >> 2], N = E[I + 108 >> 2], M = E[I + 112 >> 2], R = E[I + 116 >> 2], I = 0 - (1 & o[g + 384 | 0]) | 0, y = x ^ s & (x ^ W), E[g + 420 >> 2] = R - (I & (0 - y ^ y) ^ y), y = u ^ s & (u ^ Z), E[g + 416 >> 2] = M - (I & (0 - y ^ y) ^ y), y = m ^ s & (m ^ V), E[g + 412 >> 2] = N - (I & (0 - y ^ y) ^ y), y = l ^ s & (l ^ O), E[g + 408 >> 2] = F - (I & (0 - y ^ y) ^ y), y = U ^ s & (U ^ X), E[g + 404 >> 2] = k - (I & (0 - y ^ y) ^ y), y = J ^ s & (J ^ j), E[g + 400 >> 2] = n - (I & (0 - y ^ y) ^ y), y = d ^ s & (d ^ z), E[g + 396 >> 2] = f - (I & (0 - y ^ y) ^ y), y = H ^ s & (H ^ q), E[g + 392 >> 2] = w - (I & (0 - y ^ y) ^ y), y = K ^ s & (K ^ P), E[g + 388 >> 2] = p - (I & (0 - y ^ y) ^ y), y = I, I = G ^ s & (G ^ L), E[g + 384 >> 2] = D - (y & (0 - I ^ I) ^ I), Y(S, b, S), BI(g + 768 | 0, S), I = 0 - (1 & o[g + 768 | 0]) | 0, y = E[g + 384 >> 2], E[g + 384 >> 2] = I & (0 - y ^ y) ^ y, y = E[g + 388 >> 2], E[g + 388 >> 2] = I & (0 - y ^ y) ^ y, y = E[g + 392 >> 2], E[g + 392 >> 2] = I & (0 - y ^ y) ^ y, y = E[g + 396 >> 2], E[g + 396 >> 2] = I & (0 - y ^ y) ^ y, y = E[g + 400 >> 2], E[g + 400 >> 2] = I & (0 - y ^ y) ^ y, y = E[g + 404 >> 2], E[g + 404 >> 2] = I & (0 - y ^ y) ^ y, y = E[g + 408 >> 2], E[g + 408 >> 2] = I & (0 - y ^ y) ^ y, y = E[g + 412 >> 2], E[g + 412 >> 2] = I & (0 - y ^ y) ^ y, y = E[g + 416 >> 2], E[g + 416 >> 2] = I & (0 - y ^ y) ^ y, y = I, I = E[g + 420 >> 2], E[g + 420 >> 2] = y & (0 - I ^ I) ^ I, BI(A, S), h = g + 800 | 0;
                                    }
                                    function V(A, I) {
                                        var g, C, B, Q, i, o, _, c, t, r = 0, e = 0;
                                        h = g = h - 288 | 0, C = a[A + 28 | 0] | a[A + 29 | 0] << 8 | a[A + 30 | 0] << 16 | a[A + 31 | 0] << 24, B = a[A + 24 | 0] | a[A + 25 | 0] << 8 | a[A + 26 | 0] << 16 | a[A + 27 | 0] << 24, Q = a[A + 20 | 0] | a[A + 21 | 0] << 8 | a[A + 22 | 0] << 16 | a[A + 23 | 0] << 24, i = a[A + 16 | 0] | a[A + 17 | 0] << 8 | a[A + 18 | 0] << 16 | a[A + 19 | 0] << 24, o = a[A + 4 | 0] | a[A + 5 | 0] << 8 | a[A + 6 | 0] << 16 | a[A + 7 | 0] << 24, _ = a[A + 8 | 0] | a[A + 9 | 0] << 8 | a[A + 10 | 0] << 16 | a[A + 11 | 0] << 24, c = a[A + 12 | 0] | a[A + 13 | 0] << 8 | a[A + 14 | 0] << 16 | a[A + 15 | 0] << 24, t = a[0 | A] | a[A + 1 | 0] << 8 | a[A + 2 | 0] << 16 | a[A + 3 | 0] << 24, A = E[I + 124 >> 2], E[g + 280 >> 2] = E[I + 120 >> 2], E[g + 284 >> 2] = A, A = E[I + 116 >> 2], E[g + 272 >> 2] = E[I + 112 >> 2], E[g + 276 >> 2] = A, A = E[I + 108 >> 2], E[g + 248 >> 2] = E[I + 104 >> 2], E[g + 252 >> 2] = A, A = E[I + 100 >> 2], E[g + 240 >> 2] = E[I + 96 >> 2], E[g + 244 >> 2] = A, A = E[I + 124 >> 2], E[g + 232 >> 2] = E[I + 120 >> 2], E[g + 236 >> 2] = A, A = E[I + 116 >> 2], E[g + 224 >> 2] = E[I + 112 >> 2], E[g + 228 >> 2] = A, $A(e = g + 256 | 0, g + 240 | 0, g + 224 | 0), A = E[g + 268 >> 2], E[I + 120 >> 2] = E[g + 264 >> 2], E[I + 124 >> 2] = A, A = E[g + 260 >> 2], E[I + 112 >> 2] = E[g + 256 >> 2], E[I + 116 >> 2] = A, A = E[I + 92 >> 2], E[g + 216 >> 2] = E[I + 88 >> 2], E[g + 220 >> 2] = A, A = E[I + 84 >> 2], E[g + 208 >> 2] = E[I + 80 >> 2], E[g + 212 >> 2] = A, A = E[I + 108 >> 2], E[g + 200 >> 2] = E[I + 104 >> 2], E[g + 204 >> 2] = A, A = E[I + 100 >> 2], E[g + 192 >> 2] = E[I + 96 >> 2], E[g + 196 >> 2] = A, $A(e, g + 208 | 0, g + 192 | 0), A = E[g + 268 >> 2], E[I + 104 >> 2] = E[g + 264 >> 2], E[I + 108 >> 2] = A, A = E[g + 260 >> 2], E[I + 96 >> 2] = E[g + 256 >> 2], E[I + 100 >> 2] = A, A = E[I + 76 >> 2], E[g + 184 >> 2] = E[I + 72 >> 2], E[g + 188 >> 2] = A, r = E[4 + (A = I - -64 | 0) >> 2], E[g + 176 >> 2] = E[A >> 2], E[g + 180 >> 2] = r, r = E[I + 92 >> 2], E[g + 168 >> 2] = E[I + 88 >> 2], E[g + 172 >> 2] = r, r = E[I + 84 >> 2], E[g + 160 >> 2] = E[I + 80 >> 2], E[g + 164 >> 2] = r, $A(e, g + 176 | 0, g + 160 | 0), r = E[g + 268 >> 2], E[I + 88 >> 2] = E[g + 264 >> 2], E[I + 92 >> 2] = r, r = E[g + 260 >> 2], E[I + 80 >> 2] = E[g + 256 >> 2], E[I + 84 >> 2] = r, r = E[I + 60 >> 2], E[g + 152 >> 2] = E[I + 56 >> 2], E[g + 156 >> 2] = r, r = E[I + 52 >> 2], E[g + 144 >> 2] = E[I + 48 >> 2], E[g + 148 >> 2] = r, r = E[I + 76 >> 2], E[g + 136 >> 2] = E[I + 72 >> 2], E[g + 140 >> 2] = r, r = E[A + 4 >> 2], E[g + 128 >> 2] = E[A >> 2], E[g + 132 >> 2] = r, $A(e, g + 144 | 0, g + 128 | 0), r = E[g + 268 >> 2], E[I + 72 >> 2] = E[g + 264 >> 2], E[I + 76 >> 2] = r, r = E[g + 260 >> 2], E[A >> 2] = E[g + 256 >> 2], E[A + 4 >> 2] = r, r = E[I + 44 >> 2], E[g + 120 >> 2] = E[I + 40 >> 2], E[g + 124 >> 2] = r, r = E[I + 36 >> 2], E[g + 112 >> 2] = E[I + 32 >> 2], E[g + 116 >> 2] = r, r = E[I + 60 >> 2], E[g + 104 >> 2] = E[I + 56 >> 2], E[g + 108 >> 2] = r, r = E[I + 52 >> 2], E[g + 96 >> 2] = E[I + 48 >> 2], E[g + 100 >> 2] = r, $A(e, g + 112 | 0, g + 96 | 0), r = E[g + 268 >> 2], E[I + 56 >> 2] = E[g + 264 >> 2], E[I + 60 >> 2] = r, r = E[g + 260 >> 2], E[I + 48 >> 2] = E[g + 256 >> 2], E[I + 52 >> 2] = r, r = E[I + 28 >> 2], E[g + 88 >> 2] = E[I + 24 >> 2], E[g + 92 >> 2] = r, r = E[I + 20 >> 2], E[g + 80 >> 2] = E[I + 16 >> 2], E[g + 84 >> 2] = r, r = E[I + 44 >> 2], E[g + 72 >> 2] = E[I + 40 >> 2], E[g + 76 >> 2] = r, r = E[I + 36 >> 2], E[g + 64 >> 2] = E[I + 32 >> 2], E[g + 68 >> 2] = r, $A(e, g + 80 | 0, g - -64 | 0), r = E[g + 268 >> 2], E[I + 40 >> 2] = E[g + 264 >> 2], E[I + 44 >> 2] = r, r = E[g + 260 >> 2], E[I + 32 >> 2] = E[g + 256 >> 2], E[I + 36 >> 2] = r, r = E[I + 12 >> 2], E[g + 56 >> 2] = E[I + 8 >> 2], E[g + 60 >> 2] = r, r = E[I + 4 >> 2], E[g + 48 >> 2] = E[I >> 2], E[g + 52 >> 2] = r, r = E[I + 28 >> 2], E[g + 40 >> 2] = E[I + 24 >> 2], E[g + 44 >> 2] = r, r = E[I + 20 >> 2], E[g + 32 >> 2] = E[I + 16 >> 2], E[g + 36 >> 2] = r, $A(e, g + 48 | 0, g + 32 | 0), r = E[g + 268 >> 2], E[I + 24 >> 2] = E[g + 264 >> 2], E[I + 28 >> 2] = r, r = E[g + 260 >> 2], E[I + 16 >> 2] = E[g + 256 >> 2], E[I + 20 >> 2] = r, r = E[g + 284 >> 2], E[g + 24 >> 2] = E[g + 280 >> 2], E[g + 28 >> 2] = r, r = E[g + 276 >> 2], E[g + 16 >> 2] = E[g + 272 >> 2], E[g + 20 >> 2] = r, r = E[I + 12 >> 2], E[g + 8 >> 2] = E[I + 8 >> 2], E[g + 12 >> 2] = r, r = E[I + 4 >> 2], E[g >> 2] = E[I >> 2], E[g + 4 >> 2] = r, $A(e, g + 16 | 0, g), e = E[g + 268 >> 2], E[I + 8 >> 2] = E[g + 264 >> 2], E[I + 12 >> 2] = e, e = E[g + 260 >> 2], E[I >> 2] = E[g + 256 >> 2], E[I + 4 >> 2] = e, E[I + 12 >> 2] = (a[I + 12 | 0] | a[I + 13 | 0] << 8 | a[I + 14 | 0] << 16 | a[I + 15 | 0] << 24) ^ c, E[I + 8 >> 2] = (a[I + 8 | 0] | a[I + 9 | 0] << 8 | a[I + 10 | 0] << 16 | a[I + 11 | 0] << 24) ^ _, E[I + 4 >> 2] = (a[I + 4 | 0] | a[I + 5 | 0] << 8 | a[I + 6 | 0] << 16 | a[I + 7 | 0] << 24) ^ o, E[I >> 2] = (a[0 | I] | a[I + 1 | 0] << 8 | a[I + 2 | 0] << 16 | a[I + 3 | 0] << 24) ^ t, E[A >> 2] = (a[0 | A] | a[A + 1 | 0] << 8 | a[A + 2 | 0] << 16 | a[A + 3 | 0] << 24) ^ i, E[I + 68 >> 2] = (a[I + 68 | 0] | a[I + 69 | 0] << 8 | a[I + 70 | 0] << 16 | a[I + 71 | 0] << 24) ^ Q, E[I + 72 >> 2] = (a[I + 72 | 0] | a[I + 73 | 0] << 8 | a[I + 74 | 0] << 16 | a[I + 75 | 0] << 24) ^ B, E[I + 76 >> 2] = (a[I + 76 | 0] | a[I + 77 | 0] << 8 | a[I + 78 | 0] << 16 | a[I + 79 | 0] << 24) ^ C, h = g + 288 | 0;
                                    }
                                    function Z(A, I, g, C) {
                                        var B, Q, i, o, _, c, t, r, e, y, s, D, p, w, f, n, k, F, N = 0, S = 0, G = 0, M = 0;
                                        h = B = h - 240 | 0, G = 16 - g | 0, M = Hg((S = B + 192 | 0) + g | 0, 0, g >>> 0 <= 15 ? G : 0), Sg(S, I, g), N = a[C + 16 | 0] | a[C + 17 | 0] << 8 | a[C + 18 | 0] << 16 | a[C + 19 | 0] << 24, Q = a[0 | (I = C - -64 | 0)] | a[I + 1 | 0] << 8 | a[I + 2 | 0] << 16 | a[I + 3 | 0] << 24, i = a[C + 80 | 0] | a[C + 81 | 0] << 8 | a[C + 82 | 0] << 16 | a[C + 83 | 0] << 24, o = a[C + 32 | 0] | a[C + 33 | 0] << 8 | a[C + 34 | 0] << 16 | a[C + 35 | 0] << 24, _ = a[C + 48 | 0] | a[C + 49 | 0] << 8 | a[C + 50 | 0] << 16 | a[C + 51 | 0] << 24, c = a[C + 20 | 0] | a[C + 21 | 0] << 8 | a[C + 22 | 0] << 16 | a[C + 23 | 0] << 24, t = a[C + 68 | 0] | a[C + 69 | 0] << 8 | a[C + 70 | 0] << 16 | a[C + 71 | 0] << 24, r = a[C + 84 | 0] | a[C + 85 | 0] << 8 | a[C + 86 | 0] << 16 | a[C + 87 | 0] << 24, e = a[C + 36 | 0] | a[C + 37 | 0] << 8 | a[C + 38 | 0] << 16 | a[C + 39 | 0] << 24, y = a[C + 52 | 0] | a[C + 53 | 0] << 8 | a[C + 54 | 0] << 16 | a[C + 55 | 0] << 24, s = a[C + 24 | 0] | a[C + 25 | 0] << 8 | a[C + 26 | 0] << 16 | a[C + 27 | 0] << 24, D = a[C + 72 | 0] | a[C + 73 | 0] << 8 | a[C + 74 | 0] << 16 | a[C + 75 | 0] << 24, p = a[C + 88 | 0] | a[C + 89 | 0] << 8 | a[C + 90 | 0] << 16 | a[C + 91 | 0] << 24, w = a[C + 40 | 0] | a[C + 41 | 0] << 8 | a[C + 42 | 0] << 16 | a[C + 43 | 0] << 24, f = a[C + 56 | 0] | a[C + 57 | 0] << 8 | a[C + 58 | 0] << 16 | a[C + 59 | 0] << 24, n = E[B + 192 >> 2], k = E[B + 196 >> 2], F = E[B + 200 >> 2], E[B + 204 >> 2] = (a[C + 44 | 0] | a[C + 45 | 0] << 8 | a[C + 46 | 0] << 16 | a[C + 47 | 0] << 24) & (a[C + 60 | 0] | a[C + 61 | 0] << 8 | a[C + 62 | 0] << 16 | a[C + 63 | 0] << 24) ^ (a[C + 28 | 0] | a[C + 29 | 0] << 8 | a[C + 30 | 0] << 16 | a[C + 31 | 0] << 24) ^ (a[C + 76 | 0] | a[C + 77 | 0] << 8 | a[C + 78 | 0] << 16 | a[C + 79 | 0] << 24) ^ E[B + 204 >> 2] ^ (a[C + 92 | 0] | a[C + 93 | 0] << 8 | a[C + 94 | 0] << 16 | a[C + 95 | 0] << 24), E[B + 200 >> 2] = w & f ^ p ^ F ^ D ^ s, E[B + 196 >> 2] = e & y ^ r ^ k ^ t ^ c, E[B + 192 >> 2] = o & _ ^ N ^ Q ^ i ^ n, Hg(M, 0, G), Sg(A, S, g), g = E[B + 192 >> 2], S = E[B + 196 >> 2], G = E[B + 200 >> 2], M = E[B + 204 >> 2], A = E[C + 92 >> 2], E[B + 232 >> 2] = E[C + 88 >> 2], E[B + 236 >> 2] = A, A = E[C + 84 >> 2], E[B + 224 >> 2] = E[C + 80 >> 2], E[B + 228 >> 2] = A, A = E[C + 76 >> 2], E[B + 184 >> 2] = E[C + 72 >> 2], E[B + 188 >> 2] = A, A = E[I + 4 >> 2], E[B + 176 >> 2] = E[I >> 2], E[B + 180 >> 2] = A, A = E[C + 92 >> 2], E[B + 168 >> 2] = E[C + 88 >> 2], E[B + 172 >> 2] = A, A = E[C + 84 >> 2], E[B + 160 >> 2] = E[C + 80 >> 2], E[B + 164 >> 2] = A, $A(A = B + 208 | 0, B + 176 | 0, B + 160 | 0), N = E[B + 220 >> 2], E[C + 88 >> 2] = E[B + 216 >> 2], E[C + 92 >> 2] = N, N = E[B + 212 >> 2], E[C + 80 >> 2] = E[B + 208 >> 2], E[C + 84 >> 2] = N, N = E[C + 60 >> 2], E[B + 152 >> 2] = E[C + 56 >> 2], E[B + 156 >> 2] = N, N = E[C + 52 >> 2], E[B + 144 >> 2] = E[C + 48 >> 2], E[B + 148 >> 2] = N, N = E[C + 76 >> 2], E[B + 136 >> 2] = E[C + 72 >> 2], E[B + 140 >> 2] = N, N = E[I + 4 >> 2], E[B + 128 >> 2] = E[I >> 2], E[B + 132 >> 2] = N, $A(A, B + 144 | 0, B + 128 | 0), N = E[B + 220 >> 2], E[C + 72 >> 2] = E[B + 216 >> 2], E[C + 76 >> 2] = N, N = E[B + 212 >> 2], E[I >> 2] = E[B + 208 >> 2], E[I + 4 >> 2] = N, I = E[C + 44 >> 2], E[B + 120 >> 2] = E[C + 40 >> 2], E[B + 124 >> 2] = I, I = E[C + 36 >> 2], E[B + 112 >> 2] = E[C + 32 >> 2], E[B + 116 >> 2] = I, I = E[C + 60 >> 2], E[B + 104 >> 2] = E[C + 56 >> 2], E[B + 108 >> 2] = I, I = E[C + 52 >> 2], E[B + 96 >> 2] = E[C + 48 >> 2], E[B + 100 >> 2] = I, $A(A, B + 112 | 0, B + 96 | 0), I = E[B + 220 >> 2], E[C + 56 >> 2] = E[B + 216 >> 2], E[C + 60 >> 2] = I, I = E[B + 212 >> 2], E[C + 48 >> 2] = E[B + 208 >> 2], E[C + 52 >> 2] = I, I = E[C + 28 >> 2], E[B + 88 >> 2] = E[C + 24 >> 2], E[B + 92 >> 2] = I, I = E[C + 20 >> 2], E[B + 80 >> 2] = E[C + 16 >> 2], E[B + 84 >> 2] = I, I = E[C + 44 >> 2], E[B + 72 >> 2] = E[C + 40 >> 2], E[B + 76 >> 2] = I, I = E[C + 36 >> 2], E[B + 64 >> 2] = E[C + 32 >> 2], E[B + 68 >> 2] = I, $A(A, B + 80 | 0, B - -64 | 0), I = E[B + 220 >> 2], E[C + 40 >> 2] = E[B + 216 >> 2], E[C + 44 >> 2] = I, I = E[B + 212 >> 2], E[C + 32 >> 2] = E[B + 208 >> 2], E[C + 36 >> 2] = I, I = E[C + 12 >> 2], E[B + 56 >> 2] = E[C + 8 >> 2], E[B + 60 >> 2] = I, I = E[C + 4 >> 2], E[B + 48 >> 2] = E[C >> 2], E[B + 52 >> 2] = I, I = E[C + 28 >> 2], E[B + 40 >> 2] = E[C + 24 >> 2], E[B + 44 >> 2] = I, I = E[C + 20 >> 2], E[B + 32 >> 2] = E[C + 16 >> 2], E[B + 36 >> 2] = I, $A(A, B + 48 | 0, B + 32 | 0), I = E[B + 220 >> 2], E[C + 24 >> 2] = E[B + 216 >> 2], E[C + 28 >> 2] = I, I = E[B + 212 >> 2], E[C + 16 >> 2] = E[B + 208 >> 2], E[C + 20 >> 2] = I, I = E[B + 236 >> 2], E[B + 24 >> 2] = E[B + 232 >> 2], E[B + 28 >> 2] = I, I = E[B + 228 >> 2], E[B + 16 >> 2] = E[B + 224 >> 2], E[B + 20 >> 2] = I, I = E[C + 12 >> 2], E[B + 8 >> 2] = E[C + 8 >> 2], E[B + 12 >> 2] = I, I = E[C + 4 >> 2], E[B >> 2] = E[C >> 2], E[B + 4 >> 2] = I, $A(A, B + 16 | 0, B), A = E[B + 208 >> 2], I = E[B + 212 >> 2], N = E[B + 216 >> 2], E[C + 12 >> 2] = E[B + 220 >> 2] ^ M, E[C + 8 >> 2] = N ^ G, E[C + 4 >> 2] = I ^ S, E[C >> 2] = A ^ g, h = B + 240 | 0;
                                    }
                                    function W(A, I, g, C, B) {
                                        A |= 0, I |= 0, g |= 0, C |= 0;
                                        var Q = 0, i = 0, E = 0, _ = 0, c = 0, t = 0, r = 0, e = 0, y = 0, s = 0, h = 0, D = 0, p = 0, f = 0, n = 0, k = 0;
                                        if (_ = 1886610805 ^ (C = a[0 | (B |= 0)] | a[B + 1 | 0] << 8 | a[B + 2 | 0] << 16 | a[B + 3 | 0] << 24), i = 1936682341 ^ (Q = a[B + 4 | 0] | a[B + 5 | 0] << 8 | a[B + 6 | 0] << 16 | a[B + 7 | 0] << 24), c = 1852142177 ^ C, E = 1819895653 ^ Q, Q = 1852075885 ^ (C = a[B + 8 | 0] | a[B + 9 | 0] << 8 | a[B + 10 | 0] << 16 | a[B + 11 | 0] << 24), B = 1685025377 ^ (r = a[B + 12 | 0] | a[B + 13 | 0] << 8 | a[B + 14 | 0] << 16 | a[B + 15 | 0] << 24), t = 2037671283 ^ C, r ^= 1952801890, (0 | (C = (I + g | 0) - (s = 7 & g) | 0)) != (0 | I)) {
                                            for(; c = c + (t ^= n = a[0 | I] | a[I + 1 | 0] << 8 | a[I + 2 | 0] << 16 | a[I + 3 | 0] << 24) | 0, E = E + (e = r ^ (k = a[I + 4 | 0] | a[I + 5 | 0] << 8 | a[I + 6 | 0] << 16 | a[I + 7 | 0] << 24)) | 0, E = c >>> 0 < t >>> 0 ? E + 1 | 0 : E, y = 1 + (i = B + i | 0) | 0, r = i, r = _ >>> 0 > (i = Q + _ | 0) >>> 0 ? y : r, _ = c + (B = KI(Q, B, 13) ^ i) | 0, Q = E + (y = w ^ r) | 0, y = KI(B, y, 17) ^ _, f = KI(y, p = (D = B >>> 0 > _ >>> 0 ? Q + 1 | 0 : Q) ^ w, 13), h = w, B = KI(t, e, 16), Q = E ^ w, E = B ^ c, c = KI(i, r, 32), i = w + Q | 0, r = 1 + (c = p + (t = (B = E + c | 0) >>> 0 < c >>> 0 ? i + 1 | 0 : i) | 0) | 0, i = c, i = (c = B + y | 0) >>> 0 < B >>> 0 ? r : i, p = KI(r = c ^ f, e = i ^ h, 17), f = w, Q = KI(E, Q, 21), E = t ^ w, t = B ^ Q, B = KI(_, D, 32), Q = w + E | 0, B = (D = B >>> 0 > (_ = t + B | 0) >>> 0 ? Q + 1 | 0 : Q) + e | 0, Q = (e = _ + r | 0) ^ p, B = (y = e >>> 0 < _ >>> 0 ? B + 1 | 0 : B) ^ f, E = KI(t, E, 16), r = t = D ^ w, E = KI(_ ^= E, t, 21), D = w, t = (_ = (c = KI(c, i, 32)) + _ | 0) ^ E, i = w + r | 0, r = (i = _ >>> 0 < c >>> 0 ? i + 1 | 0 : i) ^ D, c = KI(e, y, 32), E = w, _ ^= n, i ^= k, (0 | C) != (0 | (I = I + 8 | 0)););
                                            I = C;
                                        }
                                        switch(g <<= 24, C = 0, s - 1 | 0){
                                            case 6:
                                                g |= a[I + 6 | 0] << 16;
                                            case 5:
                                                g |= a[I + 5 | 0] << 8;
                                            case 4:
                                                g |= a[I + 4 | 0];
                                            case 3:
                                                e = (C = a[I + 3 | 0]) >>> 8 | 0, C <<= 24, g |= e;
                                            case 2:
                                                C |= (e = a[I + 2 | 0]) << 16, g |= y = e >>> 16 | 0;
                                            case 1:
                                                C |= (e = a[I + 1 | 0]) << 8, g |= y = e >>> 24 | 0;
                                            case 0:
                                                C = a[0 | I] | C;
                                        }
                                        return r = KI(I = C ^ t, t = g ^ r, 16), E = E + t | 0, c = (I = I + c | 0) >>> 0 < c >>> 0 ? E + 1 | 0 : E, r = KI(E = I ^ r, t = c ^ w, 21), e = w, h = 1 + (i = B + i | 0) | 0, y = i, y = _ = _ >>> 0 > (i = Q + _ | 0) >>> 0 ? h : y, s = KI(i, _, 32), t = w + t | 0, e = KI(E = r ^ (_ = E + s | 0), r = e ^ (t = _ >>> 0 < s >>> 0 ? t + 1 | 0 : t), 16), s = w, B = KI(Q, B, 13) ^ i, Q = (i = c) + (c = w ^ y) | 0, y = KI(I = I + B | 0, i = I >>> 0 < B >>> 0 ? Q + 1 | 0 : Q, 32), r = w + r | 0, y = KI(E = e ^ (Q = E + y | 0), e = (r = Q >>> 0 < y >>> 0 ? r + 1 | 0 : r) ^ s, 21), s = w, I = _ + (B = c = KI(B, c, 17) ^ I) | 0, _ = (i ^= w) + t | 0, t = B = I >>> 0 < B >>> 0 ? _ + 1 | 0 : _, h = y, _ = E + (y = KI(I, B, 32)) | 0, E = w + e | 0, y = KI(B = h ^ _, e = (E = _ >>> 0 < y >>> 0 ? E + 1 | 0 : E) ^ s, 16), s = w, h = Q, i = KI(c, i, 13) ^ I, c = (t ^= w) + r | 0, r = Q = (I = h + (Q = i) | 0) >>> 0 < Q >>> 0 ? c + 1 | 0 : c, Q = KI(I, Q, 32), c = e + w | 0, e = (h = B) >>> 0 > (B = B + (255 ^ Q) | 0) >>> 0 ? c + 1 | 0 : c, y = KI(c = B ^ y, Q = s ^ e, 21), s = w, i = KI(i, t, 17) ^ I, g = (t = r ^ w) + (g ^ E) | 0, g = KI(I = i + (C ^= _) | 0, E = g = I >>> 0 < C >>> 0 ? g + 1 | 0 : g, 32), C = Q + w | 0, c = KI(_ = (g = g + c | 0) ^ y, C = (Q = g >>> 0 < c >>> 0 ? C + 1 | 0 : C) ^ s, 16), r = w, i = KI(i, t, 13) ^ I, t = e + (E ^= w) | 0, t = B = (I = B + i | 0) >>> 0 < B >>> 0 ? t + 1 | 0 : t, B = KI(I, B, 32), y = r, h = 1 + (C = C + w | 0) | 0, r = C, r = (C = B + _ | 0) >>> 0 < _ >>> 0 ? h : r, c = KI(_ = C ^ c, B = y ^ r, 21), e = w, i = KI(i, E, 17), h = 1 + (Q = Q + (E = t ^ w) | 0) | 0, y = Q, i = I = (t = g) >>> 0 > (g = g + (Q = I ^ i) | 0) >>> 0 ? h : y, I = KI(g, I, 32), B = B + w | 0, t = (I = I + _ | 0) >>> 0 < _ >>> 0 ? B + 1 | 0 : B, c = KI(_ = I ^ c, B = t ^ e, 16), e = w, Q = KI(Q, E, 13), E = r + (i ^= w) | 0, r = C, g = KI(C = C + (Q ^= g) | 0, E = g = r >>> 0 > C >>> 0 ? E + 1 | 0 : E, 32), B = B + w | 0, r = (g = g + _ | 0) >>> 0 < _ >>> 0 ? B + 1 | 0 : B, c = KI(_ = g ^ c, B = r ^ e, 21), e = w, Q = KI(Q, i, 17), y = 1 + (E = t + (i = E ^ w) | 0) | 0, t = E, I = KI(C = I + (E = C ^ Q) | 0, Q = C >>> 0 < I >>> 0 ? y : t, 32), B = B + w | 0, t = (I = I + _ | 0) >>> 0 < _ >>> 0 ? B + 1 | 0 : B, c = KI(_ = I ^ c, B = t ^ e, 16), e = w, i = KI(E, i, 13), E = r + (Q ^= w) | 0, g = KI(C = g + (i ^= C) | 0, E = g = C >>> 0 < g >>> 0 ? E + 1 | 0 : E, 32), B = B + w | 0, _ = KI((g = g + _ | 0) ^ c, (B = g >>> 0 < _ >>> 0 ? B + 1 | 0 : B) ^ e, 21), c = w, C = KI(i, Q, 17) ^ C, i = KI(C, Q = E ^ w, 13), Q = Q + t | 0, I = w ^ (I >>> 0 > (C = I + C | 0) >>> 0 ? Q + 1 | 0 : Q), _ = KI(C ^= i, I, 17) ^ _, Q = w ^ c, i = 1 + (I = I + B | 0) | 0, B = I, I = KI(I = g + C | 0, g = g >>> 0 > I >>> 0 ? i : B, 32) ^ _ ^ I, o[0 | A] = I, o[A + 1 | 0] = I >>> 8, o[A + 2 | 0] = I >>> 16, o[A + 3 | 0] = I >>> 24, I = g ^ w ^ Q, o[A + 4 | 0] = I, o[A + 5 | 0] = I >>> 8, o[A + 6 | 0] = I >>> 16, o[A + 7 | 0] = I >>> 24, 0;
                                    }
                                    function T(A, I) {
                                        var g, C, B, Q, i, o = 0, _ = 0, c = 0, t = 0, r = 0, e = 0, y = 0, s = 0, D = 0, p = 0, w = 0, f = 0, n = 0, k = 0, F = 0, N = 0, S = 0, G = 0, M = 0, b = 0, K = 0, H = 0, d = 0, J = 0, U = 0, l = 0, m = 0, u = 0, x = 0, R = 0, L = 0;
                                        h = g = h - 624 | 0, v(o = g + 480 | 0, I), Y(o, 1648, o), c = E[g + 516 >> 2], E[g + 276 >> 2] = c, t = E[g + 512 >> 2], E[g + 272 >> 2] = t, r = E[g + 508 >> 2], E[g + 268 >> 2] = r, e = E[g + 504 >> 2], E[g + 264 >> 2] = e, y = E[g + 500 >> 2], E[g + 260 >> 2] = y, s = E[g + 496 >> 2], E[g + 256 >> 2] = s, D = E[g + 492 >> 2], E[g + 252 >> 2] = D, p = E[g + 488 >> 2], E[g + 248 >> 2] = p, w = E[g + 484 >> 2], E[g + 244 >> 2] = w, n = E[g + 480 >> 2], E[g + 240 >> 2] = n + 1, Y(_ = g + 240 | 0, _, 33984), E[g + 468 >> 2] = c - 12055116, E[g + 464 >> 2] = t - 18696448, E[g + 460 >> 2] = r - 3247719, E[g + 456 >> 2] = e - 6275908, E[g + 452 >> 2] = y - 8787816, E[g + 448 >> 2] = s + 114729, E[g + 444 >> 2] = D + 6949391, E[g + 440 >> 2] = p - 15372611, E[g + 436 >> 2] = w + 13857413, E[g + 432 >> 2] = n - 10913610, Y(f = g + 192 | 0, o, 1600), E[g + 228 >> 2] = 0 - E[g + 228 >> 2], E[g + 224 >> 2] = 0 - E[g + 224 >> 2], E[g + 220 >> 2] = 0 - E[g + 220 >> 2], E[g + 216 >> 2] = 0 - E[g + 216 >> 2], E[g + 212 >> 2] = 0 - E[g + 212 >> 2], E[g + 208 >> 2] = 0 - E[g + 208 >> 2], E[g + 204 >> 2] = 0 - E[g + 204 >> 2], E[g + 200 >> 2] = 0 - E[g + 200 >> 2], E[g + 196 >> 2] = 0 - E[g + 196 >> 2], E[g + 192 >> 2] = -1 ^ E[g + 192 >> 2], Y(f, f, g + 432 | 0), o = GA(C = g + 384 | 0, _, f), Y(_ = g + 336 | 0, C, I), BI(B = g + 576 | 0, _), i = a[g + 576 | 0], d = E[g + 420 >> 2], _ = E[g + 372 >> 2], J = E[g + 416 >> 2], k = E[g + 368 >> 2], U = E[g + 412 >> 2], F = E[g + 364 >> 2], l = E[g + 408 >> 2], N = E[g + 360 >> 2], m = E[g + 404 >> 2], S = E[g + 356 >> 2], u = E[g + 400 >> 2], G = E[g + 352 >> 2], x = E[g + 396 >> 2], M = E[g + 348 >> 2], R = E[g + 392 >> 2], b = E[g + 344 >> 2], L = E[g + 388 >> 2], K = E[g + 340 >> 2], Q = E[g + 384 >> 2], H = E[g + 336 >> 2], I = o - 1 | 0, E[g + 612 >> 2] = I & c, E[g + 608 >> 2] = I & t, E[g + 604 >> 2] = I & r, E[g + 600 >> 2] = I & e, E[g + 596 >> 2] = I & y, E[g + 592 >> 2] = I & s, E[g + 588 >> 2] = I & D, E[g + 584 >> 2] = I & p, E[g + 580 >> 2] = I & w, E[g + 576 >> 2] = n | 0 - o, H = I & (0 - (H ^ (o = 0 - (1 & i) | 0) & (H ^ 0 - H)) ^ Q) ^ Q, E[g + 384 >> 2] = H, K = L ^ I & (L ^ 0 - (K ^ o & (K ^ 0 - K))), E[g + 388 >> 2] = K, b = R ^ I & (R ^ 0 - (b ^ o & (b ^ 0 - b))), E[g + 392 >> 2] = b, M = x ^ I & (x ^ 0 - (M ^ o & (M ^ 0 - M))), E[g + 396 >> 2] = M, G = u ^ I & (u ^ 0 - (G ^ o & (G ^ 0 - G))), E[g + 400 >> 2] = G, S = m ^ I & (m ^ 0 - (S ^ o & (S ^ 0 - S))), E[g + 404 >> 2] = S, N = l ^ I & (l ^ 0 - (N ^ o & (N ^ 0 - N))), E[g + 408 >> 2] = N, F = U ^ I & (U ^ 0 - (F ^ o & (F ^ 0 - F))), E[g + 412 >> 2] = F, k = J ^ I & (J ^ 0 - (k ^ o & (k ^ 0 - k))), E[g + 416 >> 2] = k, o = d ^ I & (d ^ 0 - (_ ^ o & (_ ^ 0 - _))), E[g + 420 >> 2] = o, E[g + 564 >> 2] = c, E[g + 560 >> 2] = t, E[g + 556 >> 2] = r, E[g + 552 >> 2] = e, E[g + 548 >> 2] = y, E[g + 544 >> 2] = s, E[g + 540 >> 2] = D, E[g + 536 >> 2] = p, E[g + 532 >> 2] = w, E[g + 528 >> 2] = n - 1, Y(I = g + 528 | 0, I, B), Y(I, I, 34032), c = E[g + 192 >> 2], t = E[g + 528 >> 2], r = E[g + 196 >> 2], e = E[g + 532 >> 2], y = E[g + 200 >> 2], s = E[g + 536 >> 2], D = E[g + 204 >> 2], p = E[g + 540 >> 2], w = E[g + 208 >> 2], n = E[g + 544 >> 2], _ = E[g + 212 >> 2], d = E[g + 548 >> 2], J = E[g + 216 >> 2], U = E[g + 552 >> 2], l = E[g + 220 >> 2], m = E[g + 556 >> 2], u = E[g + 224 >> 2], x = E[g + 560 >> 2], R = E[g + 228 >> 2], L = E[g + 564 >> 2], E[g + 180 >> 2] = o << 1, E[g + 176 >> 2] = k << 1, E[g + 172 >> 2] = F << 1, E[g + 168 >> 2] = N << 1, E[g + 164 >> 2] = S << 1, E[g + 160 >> 2] = G << 1, E[g + 156 >> 2] = M << 1, E[g + 152 >> 2] = b << 1, E[g + 148 >> 2] = K << 1, E[g + 144 >> 2] = H << 1, E[g + 564 >> 2] = L - R, E[g + 560 >> 2] = x - u, E[g + 556 >> 2] = m - l, E[g + 552 >> 2] = U - J, E[g + 548 >> 2] = d - _, E[g + 544 >> 2] = n - w, E[g + 540 >> 2] = p - D, E[g + 536 >> 2] = s - y, E[g + 532 >> 2] = e - r, E[g + 528 >> 2] = t - c, Y(o = g + 144 | 0, o, f), Y(f = g + 96 | 0, I, 34080), v(g + 288 | 0, C), I = E[g + 324 >> 2], E[g + 84 >> 2] = 0 - I, c = E[g + 320 >> 2], E[g + 80 >> 2] = 0 - c, t = E[g + 316 >> 2], E[g + 76 >> 2] = 0 - t, r = E[g + 312 >> 2], E[g + 72 >> 2] = 0 - r, e = E[g + 308 >> 2], E[g + 68 >> 2] = 0 - e, y = E[g + 304 >> 2], E[g + 64 >> 2] = 0 - y, s = E[g + 300 >> 2], E[g + 60 >> 2] = 0 - s, D = E[g + 296 >> 2], E[g + 56 >> 2] = 0 - D, p = E[g + 292 >> 2], E[g + 52 >> 2] = 0 - p, w = E[g + 288 >> 2], E[g + 48 >> 2] = 1 - w, E[g + 36 >> 2] = I, E[g + 32 >> 2] = c, E[g + 28 >> 2] = t, E[g + 24 >> 2] = r, E[g + 20 >> 2] = e, E[g + 16 >> 2] = y, E[g + 12 >> 2] = s, E[g + 8 >> 2] = D, E[g + 4 >> 2] = p, E[g >> 2] = w + 1, Y(A, o, g), Y(A + 40 | 0, I = g + 48 | 0, f), Y(A + 80 | 0, f, g), Y(A + 120 | 0, o, I), h = g + 624 | 0;
                                    }
                                    function $(A, I, g) {
                                        var C, B = 0, i = 0, _ = 0, c = 0, t = 0, r = 0;
                                        h = C = h + -64 | 0;
                                        A: {
                                            if ((g - 65 & 255) >>> 0 > 191) {
                                                if (B = -1, !(a[A + 80 | 0] | a[A + 81 | 0] << 8 | a[A + 82 | 0] << 16 | a[A + 83 | 0] << 24 | a[A + 84 | 0] | a[A + 85 | 0] << 8 | a[A + 86 | 0] << 16 | a[A + 87 | 0] << 24)) {
                                                    if ((c = a[A + 352 | 0] | a[A + 353 | 0] << 8 | a[A + 354 | 0] << 16 | a[A + 355 | 0] << 24) >>> 0 >= 129) {
                                                        if (_ = a[0 | (B = A - -64 | 0)] | a[B + 1 | 0] << 8 | a[B + 2 | 0] << 16 | a[B + 3 | 0] << 24, t = i = a[B + 4 | 0] | a[B + 5 | 0] << 8 | a[B + 6 | 0] << 16 | a[B + 7 | 0] << 24, i = (c = _ + 128 | 0) >>> 0 < 128 ? i + 1 | 0 : i, o[0 | B] = c, o[B + 1 | 0] = c >>> 8, o[B + 2 | 0] = c >>> 16, o[B + 3 | 0] = c >>> 24, o[B + 4 | 0] = i, o[B + 5 | 0] = i >>> 8, o[B + 6 | 0] = i >>> 16, o[B + 7 | 0] = i >>> 24, i = a[A + 76 | 0] | a[A + 77 | 0] << 8 | a[A + 78 | 0] << 16 | a[A + 79 | 0] << 24, i = (B = -1 == (0 | t) & _ >>> 0 > 4294967167) >>> 0 > (_ = B + (a[A + 72 | 0] | a[A + 73 | 0] << 8 | a[A + 74 | 0] << 16 | a[A + 75 | 0] << 24) | 0) >>> 0 ? i + 1 | 0 : i, o[A + 72 | 0] = _, o[A + 73 | 0] = _ >>> 8, o[A + 74 | 0] = _ >>> 16, o[A + 75 | 0] = _ >>> 24, o[A + 76 | 0] = i, o[A + 77 | 0] = i >>> 8, o[A + 78 | 0] = i >>> 16, o[A + 79 | 0] = i >>> 24, f(A, i = A + 96 | 0), B = (a[A + 352 | 0] | a[A + 353 | 0] << 8 | a[A + 354 | 0] << 16 | a[A + 355 | 0] << 24) - 128 | 0, o[A + 352 | 0] = B, o[A + 353 | 0] = B >>> 8, o[A + 354 | 0] = B >>> 16, o[A + 355 | 0] = B >>> 24, B >>> 0 >= 129) break A;
                                                        Sg(i, A + 224 | 0, B), c = a[A + 352 | 0] | a[A + 353 | 0] << 8 | a[A + 354 | 0] << 16 | a[A + 355 | 0] << 24;
                                                    }
                                                    i = a[0 | (B = A - -64 | 0)] | a[B + 1 | 0] << 8 | a[B + 2 | 0] << 16 | a[B + 3 | 0] << 24, _ = r = a[B + 4 | 0] | a[B + 5 | 0] << 8 | a[B + 6 | 0] << 16 | a[B + 7 | 0] << 24, _ = (t = i + c | 0) >>> 0 < c >>> 0 ? _ + 1 | 0 : _, o[0 | B] = t, o[B + 1 | 0] = t >>> 8, o[B + 2 | 0] = t >>> 16, o[B + 3 | 0] = t >>> 24, o[B + 4 | 0] = _, o[B + 5 | 0] = _ >>> 8, o[B + 6 | 0] = _ >>> 16, o[B + 7 | 0] = _ >>> 24, B = (0 | _) == (0 | r) & i >>> 0 > t >>> 0 | _ >>> 0 < r >>> 0, i = a[A + 76 | 0] | a[A + 77 | 0] << 8 | a[A + 78 | 0] << 16 | a[A + 79 | 0] << 24, i = (_ = B + (a[A + 72 | 0] | a[A + 73 | 0] << 8 | a[A + 74 | 0] << 16 | a[A + 75 | 0] << 24) | 0) >>> 0 < B >>> 0 ? i + 1 | 0 : i, o[A + 72 | 0] = _, o[A + 73 | 0] = _ >>> 8, o[A + 74 | 0] = _ >>> 16, o[A + 75 | 0] = _ >>> 24, o[A + 76 | 0] = i, o[A + 77 | 0] = i >>> 8, o[A + 78 | 0] = i >>> 16, o[A + 79 | 0] = i >>> 24, a[A + 356 | 0] && (o[A + 88 | 0] = 255, o[A + 89 | 0] = 255, o[A + 90 | 0] = 255, o[A + 91 | 0] = 255, o[A + 92 | 0] = 255, o[A + 93 | 0] = 255, o[A + 94 | 0] = 255, o[A + 95 | 0] = 255), o[A + 80 | 0] = 255, o[A + 81 | 0] = 255, o[A + 82 | 0] = 255, o[A + 83 | 0] = 255, o[A + 84 | 0] = 255, o[A + 85 | 0] = 255, o[A + 86 | 0] = 255, o[A + 87 | 0] = 255, Hg((B = A + 96 | 0) + c | 0, 0, 256 - c | 0), f(A, B), i = a[A + 4 | 0] | a[A + 5 | 0] << 8 | a[A + 6 | 0] << 16 | a[A + 7 | 0] << 24, E[C >> 2] = a[0 | A] | a[A + 1 | 0] << 8 | a[A + 2 | 0] << 16 | a[A + 3 | 0] << 24, E[C + 4 >> 2] = i, i = a[A + 12 | 0] | a[A + 13 | 0] << 8 | a[A + 14 | 0] << 16 | a[A + 15 | 0] << 24, E[C + 8 >> 2] = a[A + 8 | 0] | a[A + 9 | 0] << 8 | a[A + 10 | 0] << 16 | a[A + 11 | 0] << 24, E[C + 12 >> 2] = i, i = a[A + 20 | 0] | a[A + 21 | 0] << 8 | a[A + 22 | 0] << 16 | a[A + 23 | 0] << 24, E[C + 16 >> 2] = a[A + 16 | 0] | a[A + 17 | 0] << 8 | a[A + 18 | 0] << 16 | a[A + 19 | 0] << 24, E[C + 20 >> 2] = i, i = a[A + 28 | 0] | a[A + 29 | 0] << 8 | a[A + 30 | 0] << 16 | a[A + 31 | 0] << 24, E[C + 24 >> 2] = a[A + 24 | 0] | a[A + 25 | 0] << 8 | a[A + 26 | 0] << 16 | a[A + 27 | 0] << 24, E[C + 28 >> 2] = i, i = a[A + 36 | 0] | a[A + 37 | 0] << 8 | a[A + 38 | 0] << 16 | a[A + 39 | 0] << 24, E[C + 32 >> 2] = a[A + 32 | 0] | a[A + 33 | 0] << 8 | a[A + 34 | 0] << 16 | a[A + 35 | 0] << 24, E[C + 36 >> 2] = i, i = a[A + 44 | 0] | a[A + 45 | 0] << 8 | a[A + 46 | 0] << 16 | a[A + 47 | 0] << 24, E[C + 40 >> 2] = a[A + 40 | 0] | a[A + 41 | 0] << 8 | a[A + 42 | 0] << 16 | a[A + 43 | 0] << 24, E[C + 44 >> 2] = i, i = a[A + 52 | 0] | a[A + 53 | 0] << 8 | a[A + 54 | 0] << 16 | a[A + 55 | 0] << 24, E[C + 48 >> 2] = a[A + 48 | 0] | a[A + 49 | 0] << 8 | a[A + 50 | 0] << 16 | a[A + 51 | 0] << 24, E[C + 52 >> 2] = i, i = a[A + 60 | 0] | a[A + 61 | 0] << 8 | a[A + 62 | 0] << 16 | a[A + 63 | 0] << 24, E[C + 56 >> 2] = a[A + 56 | 0] | a[A + 57 | 0] << 8 | a[A + 58 | 0] << 16 | a[A + 59 | 0] << 24, E[C + 60 >> 2] = i, Sg(I, C, g), XC(A, 64), XC(B, 256), B = 0;
                                                }
                                                return h = C - -64 | 0, B;
                                            }
                                            yC(), Q();
                                        }
                                        e(1369, 1217, 306, 1142), Q();
                                    }
                                    function AA(A, I, g) {
                                        A |= 0, I |= 0, g |= 0;
                                        var C, B, Q, i = 0, _ = 0;
                                        h = C = h - 192 | 0, E[C + 144 >> 2] = 0, E[C + 148 >> 2] = 0, E[C + 152 >> 2] = 0, E[C + 156 >> 2] = 0, E[C + 104 >> 2] = 0, E[C + 108 >> 2] = 0, E[C + 112 >> 2] = 0, E[C + 116 >> 2] = 0, E[C + 120 >> 2] = 0, E[C + 124 >> 2] = 0, i = E[8591], E[C + 168 >> 2] = E[8590], E[C + 172 >> 2] = i, i = E[8593], E[C + 176 >> 2] = E[8592], E[C + 180 >> 2] = i, i = E[8595], E[C + 184 >> 2] = E[8594], E[C + 188 >> 2] = i, E[C + 128 >> 2] = 0, E[C + 132 >> 2] = 0, E[C + 136 >> 2] = 0, E[C + 140 >> 2] = 0, E[C + 96 >> 2] = 0, E[C + 100 >> 2] = 0, i = E[8589], E[C + 160 >> 2] = E[8588], E[C + 164 >> 2] = i, i = a[g + 20 | 0] | a[g + 21 | 0] << 8 | a[g + 22 | 0] << 16 | a[g + 23 | 0] << 24, E[C + 80 >> 2] = a[g + 16 | 0] | a[g + 17 | 0] << 8 | a[g + 18 | 0] << 16 | a[g + 19 | 0] << 24, E[C + 84 >> 2] = i, i = a[g + 28 | 0] | a[g + 29 | 0] << 8 | a[g + 30 | 0] << 16 | a[g + 31 | 0] << 24, E[C + 88 >> 2] = a[g + 24 | 0] | a[g + 25 | 0] << 8 | a[g + 26 | 0] << 16 | a[g + 27 | 0] << 24, E[C + 92 >> 2] = i, i = a[g + 4 | 0] | a[g + 5 | 0] << 8 | a[g + 6 | 0] << 16 | a[g + 7 | 0] << 24, E[C + 64 >> 2] = a[0 | g] | a[g + 1 | 0] << 8 | a[g + 2 | 0] << 16 | a[g + 3 | 0] << 24, E[C + 68 >> 2] = i, i = a[g + 12 | 0] | a[g + 13 | 0] << 8 | a[g + 14 | 0] << 16 | a[g + 15 | 0] << 24, E[C + 72 >> 2] = a[g + 8 | 0] | a[g + 9 | 0] << 8 | a[g + 10 | 0] << 16 | a[g + 11 | 0] << 24, E[C + 76 >> 2] = i, Eg(g = C + 128 | 0, i = C - -64 | 0), N(g), _ = E[C + 156 >> 2], E[C + 24 >> 2] = E[C + 152 >> 2], E[C + 28 >> 2] = _, _ = E[C + 148 >> 2], E[C + 16 >> 2] = E[C + 144 >> 2], E[C + 20 >> 2] = _, _ = E[C + 140 >> 2], E[C + 8 >> 2] = E[C + 136 >> 2], E[C + 12 >> 2] = _, _ = E[C + 132 >> 2], E[C >> 2] = E[C + 128 >> 2], E[C + 4 >> 2] = _, E[C + 120 >> 2] = 0, E[C + 124 >> 2] = 0, E[C + 112 >> 2] = 0, E[C + 116 >> 2] = 0, E[C + 104 >> 2] = 0, E[C + 108 >> 2] = 0, E[C + 96 >> 2] = 0, E[C + 100 >> 2] = 0, _ = a[I + 20 | 0] | a[I + 21 | 0] << 8 | a[I + 22 | 0] << 16 | a[I + 23 | 0] << 24, E[C + 80 >> 2] = a[I + 16 | 0] | a[I + 17 | 0] << 8 | a[I + 18 | 0] << 16 | a[I + 19 | 0] << 24, E[C + 84 >> 2] = _, _ = a[I + 28 | 0] | a[I + 29 | 0] << 8 | a[I + 30 | 0] << 16 | a[I + 31 | 0] << 24, E[C + 88 >> 2] = a[I + 24 | 0] | a[I + 25 | 0] << 8 | a[I + 26 | 0] << 16 | a[I + 27 | 0] << 24, E[C + 92 >> 2] = _, _ = a[I + 8 | 0] | a[I + 9 | 0] << 8 | a[I + 10 | 0] << 16 | a[I + 11 | 0] << 24, B = a[I + 12 | 0] | a[I + 13 | 0] << 8 | a[I + 14 | 0] << 16 | a[I + 15 | 0] << 24, Q = a[0 | I] | a[I + 1 | 0] << 8 | a[I + 2 | 0] << 16 | a[I + 3 | 0] << 24, I = a[I + 4 | 0] | a[I + 5 | 0] << 8 | a[I + 6 | 0] << 16 | a[I + 7 | 0] << 24, E[C + 56 >> 2] = 0, E[C + 60 >> 2] = 0, E[C + 48 >> 2] = 0, E[C + 52 >> 2] = 0, E[C + 40 >> 2] = 0, E[C + 44 >> 2] = 0, E[C + 64 >> 2] = Q, E[C + 68 >> 2] = I, E[C + 72 >> 2] = _, E[C + 76 >> 2] = B, E[C + 32 >> 2] = 0, E[C + 36 >> 2] = 0, og(i, C), I = E[C + 124 >> 2], E[C + 184 >> 2] = E[C + 120 >> 2], E[C + 188 >> 2] = I, I = E[C + 116 >> 2], E[C + 176 >> 2] = E[C + 112 >> 2], E[C + 180 >> 2] = I, I = E[C + 108 >> 2], E[C + 168 >> 2] = E[C + 104 >> 2], E[C + 172 >> 2] = I, I = E[C + 100 >> 2], E[C + 160 >> 2] = E[C + 96 >> 2], E[C + 164 >> 2] = I, I = E[C + 92 >> 2], E[C + 152 >> 2] = E[C + 88 >> 2], E[C + 156 >> 2] = I, I = E[C + 84 >> 2], E[C + 144 >> 2] = E[C + 80 >> 2], E[C + 148 >> 2] = I, I = E[C + 76 >> 2], E[C + 136 >> 2] = E[C + 72 >> 2], E[C + 140 >> 2] = I, I = E[C + 68 >> 2], E[C + 128 >> 2] = E[C + 64 >> 2], E[C + 132 >> 2] = I, N(g), I = E[C + 156 >> 2], i = E[C + 152 >> 2], o[A + 24 | 0] = i, o[A + 25 | 0] = i >>> 8, o[A + 26 | 0] = i >>> 16, o[A + 27 | 0] = i >>> 24, o[A + 28 | 0] = I, o[A + 29 | 0] = I >>> 8, o[A + 30 | 0] = I >>> 16, o[A + 31 | 0] = I >>> 24, I = E[C + 148 >> 2], i = E[C + 144 >> 2], o[A + 16 | 0] = i, o[A + 17 | 0] = i >>> 8, o[A + 18 | 0] = i >>> 16, o[A + 19 | 0] = i >>> 24, o[A + 20 | 0] = I, o[A + 21 | 0] = I >>> 8, o[A + 22 | 0] = I >>> 16, o[A + 23 | 0] = I >>> 24, I = E[C + 140 >> 2], i = E[C + 136 >> 2], o[A + 8 | 0] = i, o[A + 9 | 0] = i >>> 8, o[A + 10 | 0] = i >>> 16, o[A + 11 | 0] = i >>> 24, o[A + 12 | 0] = I, o[A + 13 | 0] = I >>> 8, o[A + 14 | 0] = I >>> 16, o[A + 15 | 0] = I >>> 24, I = E[C + 132 >> 2], i = E[C + 128 >> 2], o[0 | A] = i, o[A + 1 | 0] = i >>> 8, o[A + 2 | 0] = i >>> 16, o[A + 3 | 0] = i >>> 24, o[A + 4 | 0] = I, o[A + 5 | 0] = I >>> 8, o[A + 6 | 0] = I >>> 16, o[A + 7 | 0] = I >>> 24, XC(g, 64), h = C + 192 | 0;
                                    }
                                    function IA(A) {
                                        var I, g, C, B, Q, i, a, _, t, r, e = 0, y = 0, s = 0, D = 0, p = 0;
                                        for(h = I = h - 2048 | 0, TA(D = I + 640 | 0, A), e = E[A + 36 >> 2], E[I + 352 >> 2] = E[A + 32 >> 2], E[I + 356 >> 2] = e, e = E[A + 28 >> 2], E[I + 344 >> 2] = E[A + 24 >> 2], E[I + 348 >> 2] = e, e = E[A + 20 >> 2], E[I + 336 >> 2] = E[A + 16 >> 2], E[I + 340 >> 2] = e, e = E[A + 12 >> 2], E[I + 328 >> 2] = E[A + 8 >> 2], E[I + 332 >> 2] = e, e = E[A + 4 >> 2], E[I + 320 >> 2] = E[A >> 2], E[I + 324 >> 2] = e, e = E[A + 52 >> 2], E[I + 368 >> 2] = E[A + 48 >> 2], E[I + 372 >> 2] = e, e = E[A + 60 >> 2], E[I + 376 >> 2] = E[A + 56 >> 2], E[I + 380 >> 2] = e, e = E[4 + (s = A - -64 | 0) >> 2], E[I + 384 >> 2] = E[s >> 2], E[I + 388 >> 2] = e, e = E[A + 76 >> 2], E[I + 392 >> 2] = E[A + 72 >> 2], E[I + 396 >> 2] = e, e = E[A + 44 >> 2], E[I + 360 >> 2] = E[A + 40 >> 2], E[I + 364 >> 2] = e, e = E[A + 92 >> 2], E[I + 408 >> 2] = E[A + 88 >> 2], E[I + 412 >> 2] = e, e = E[A + 100 >> 2], E[I + 416 >> 2] = E[A + 96 >> 2], E[I + 420 >> 2] = e, e = E[A + 108 >> 2], E[I + 424 >> 2] = E[A + 104 >> 2], E[I + 428 >> 2] = e, e = E[A + 116 >> 2], E[I + 432 >> 2] = E[A + 112 >> 2], E[I + 436 >> 2] = e, e = E[A + 84 >> 2], E[I + 400 >> 2] = E[A + 80 >> 2], E[I + 404 >> 2] = e, KA(y = I + 480 | 0, s = I + 320 | 0), Y(e = I + 160 | 0, y, g = I + 600 | 0), Y(I + 200 | 0, C = I + 520 | 0, B = I + 560 | 0), Y(I + 240 | 0, B, g), Y(I + 280 | 0, y, C), sA(y, e, D), Y(s, y, g), Y(a = I + 360 | 0, C, B), Y(_ = I + 400 | 0, B, g), Y(t = I + 440 | 0, y, C), TA(A = I + 800 | 0, s), sA(y, e, A), Y(s, y, g), Y(a, C, B), Y(_, B, g), Y(t, y, C), TA(A = I + 960 | 0, s), sA(y, e, A), Y(s, y, g), Y(a, C, B), Y(_, B, g), Y(t, y, C), TA(A = I + 1120 | 0, s), sA(y, e, A), Y(s, y, g), Y(a, C, B), Y(_, B, g), Y(t, y, C), TA(A = I + 1280 | 0, s), sA(y, e, A), Y(s, y, g), Y(a, C, B), Y(_, B, g), Y(t, y, C), TA(A = I + 1440 | 0, s), sA(y, e, A), Y(s, y, g), Y(a, C, B), Y(_, B, g), Y(t, y, C), TA(A = I + 1600 | 0, s), sA(y, e, A), Y(s, y, g), Y(a, C, B), Y(_, B, g), Y(t, y, C), TA(I + 1760 | 0, s), E[I + 32 >> 2] = 0, E[I + 36 >> 2] = 0, E[I + 24 >> 2] = 0, E[I + 28 >> 2] = 0, E[I + 16 >> 2] = 0, E[I + 20 >> 2] = 0, E[I + 8 >> 2] = 0, E[I + 12 >> 2] = 0, E[I + 44 >> 2] = 0, E[I + 48 >> 2] = 0, E[I + 52 >> 2] = 0, E[I + 56 >> 2] = 0, E[I + 60 >> 2] = 0, E[I + 64 >> 2] = 0, E[I + 68 >> 2] = 0, E[I + 72 >> 2] = 0, E[I + 76 >> 2] = 0, E[I + 80 >> 2] = 1, E[I >> 2] = 0, E[I + 4 >> 2] = 0, E[I + 40 >> 2] = 1, Hg(I + 84 | 0, 0, 76), r = I + 120 | 0, Q = I + 2008 | 0, i = I + 1968 | 0, D = I + 80 | 0, s = I + 40 | 0, A = 252; e = E[I + 36 >> 2], E[(y = I + 1960 | 0) >> 2] = E[I + 32 >> 2], E[y + 4 >> 2] = e, e = E[I + 28 >> 2], E[(y = I + 1952 | 0) >> 2] = E[I + 24 >> 2], E[y + 4 >> 2] = e, e = E[I + 20 >> 2], E[(y = I + 1944 | 0) >> 2] = E[I + 16 >> 2], E[y + 4 >> 2] = e, e = E[I + 12 >> 2], E[(y = I + 1936 | 0) >> 2] = E[I + 8 >> 2], E[y + 4 >> 2] = e, e = E[I + 4 >> 2], E[I + 1928 >> 2] = E[I >> 2], E[I + 1932 >> 2] = e, e = E[s + 36 >> 2], E[i + 32 >> 2] = E[s + 32 >> 2], E[i + 36 >> 2] = e, e = E[s + 28 >> 2], E[i + 24 >> 2] = E[s + 24 >> 2], E[i + 28 >> 2] = e, e = E[s + 20 >> 2], E[i + 16 >> 2] = E[s + 16 >> 2], E[i + 20 >> 2] = e, e = E[s + 12 >> 2], E[i + 8 >> 2] = E[s + 8 >> 2], E[i + 12 >> 2] = e, e = E[s + 4 >> 2], E[i >> 2] = E[s >> 2], E[i + 4 >> 2] = e, e = E[D + 36 >> 2], E[Q + 32 >> 2] = E[D + 32 >> 2], E[Q + 36 >> 2] = e, e = E[D + 28 >> 2], E[Q + 24 >> 2] = E[D + 24 >> 2], E[Q + 28 >> 2] = e, e = E[D + 20 >> 2], E[Q + 16 >> 2] = E[D + 16 >> 2], E[Q + 20 >> 2] = e, e = E[D + 12 >> 2], E[Q + 8 >> 2] = E[D + 8 >> 2], E[Q + 12 >> 2] = e, e = E[D + 4 >> 2], E[Q >> 2] = E[D >> 2], E[Q + 4 >> 2] = e, e = A, p = o[A + 33728 | 0], KA(y = I + 480 | 0, I + 1928 | 0), (0 | p) > 0 ? (Y(A = I + 320 | 0, y, g), Y(a, C, B), Y(_, B, g), Y(t, y, C), sA(y, A, (I + 640 | 0) + c((254 & p) >>> 1 | 0, 160) | 0)) : (0 | p) >= 0 || (Y(A = I + 320 | 0, y = I + 480 | 0, g), Y(a, C, B), Y(_, B, g), Y(t, y, C), hA(y, A, (I + 640 | 0) + c((0 - p & 254) >>> 1 | 0, 160) | 0)), Y(I, A = I + 480 | 0, g), Y(s, C, B), Y(D, B, g), Y(r, A, C), A = e - 1 | 0, e;);
                                        return BI(A = I + 640 | 0, I), A = NI(A, 32), h = I + 2048 | 0, A;
                                    }
                                    function gA(A) {
                                        var I = 0, g = 0, C = 0, B = 0, Q = 0, i = 0, o = 0, a = 0, c = 0;
                                        A: if (A |= 0) {
                                            Q = (C = A - 8 | 0) + (A = -8 & (I = E[A - 4 >> 2])) | 0;
                                            I: if (!(1 & I)) {
                                                if (!(3 & I)) break A;
                                                if ((C = C - (I = E[C >> 2]) | 0) >>> 0 < _[9397]) break A;
                                                A = A + I | 0;
                                                g: {
                                                    C: {
                                                        if (E[9398] != (0 | C)) {
                                                            if (I >>> 0 <= 255) {
                                                                if (B = I >>> 3 | 0, (0 | (I = E[C + 12 >> 2])) == (0 | (g = E[C + 8 >> 2]))) {
                                                                    a = 37572, c = E[9393] & Lg(-2, B), E[a >> 2] = c;
                                                                    break I;
                                                                }
                                                                E[g + 12 >> 2] = I, E[I + 8 >> 2] = g;
                                                                break I;
                                                            }
                                                            if (o = E[C + 24 >> 2], (0 | C) != (0 | (I = E[C + 12 >> 2]))) {
                                                                g = E[C + 8 >> 2], E[g + 12 >> 2] = I, E[I + 8 >> 2] = g;
                                                                break g;
                                                            }
                                                            if (!(g = E[(B = C + 20 | 0) >> 2])) {
                                                                if (!(g = E[C + 16 >> 2])) break C;
                                                                B = C + 16 | 0;
                                                            }
                                                            for(; i = B, (g = E[(B = (I = g) + 20 | 0) >> 2]) || (B = I + 16 | 0, g = E[I + 16 >> 2]););
                                                            E[i >> 2] = 0;
                                                            break g;
                                                        }
                                                        if (3 != (3 & (I = E[Q + 4 >> 2]))) break I;
                                                        return E[9395] = A, E[Q + 4 >> 2] = -2 & I, E[C + 4 >> 2] = 1 | A, void (E[Q >> 2] = A);
                                                    }
                                                    I = 0;
                                                }
                                                if (o) {
                                                    g = E[C + 28 >> 2];
                                                    g: {
                                                        if (E[(B = 37876 + (g << 2) | 0) >> 2] == (0 | C)) {
                                                            if (E[B >> 2] = I, I) break g;
                                                            a = 37576, c = E[9394] & Lg(-2, g), E[a >> 2] = c;
                                                            break I;
                                                        }
                                                        if (E[o + (E[o + 16 >> 2] == (0 | C) ? 16 : 20) >> 2] = I, !I) break I;
                                                    }
                                                    E[I + 24 >> 2] = o, (g = E[C + 16 >> 2]) && (E[I + 16 >> 2] = g, E[g + 24 >> 2] = I), (g = E[C + 20 >> 2]) && (E[I + 20 >> 2] = g, E[g + 24 >> 2] = I);
                                                }
                                            }
                                            if (!(C >>> 0 >= Q >>> 0) && 1 & (I = E[Q + 4 >> 2])) {
                                                I: {
                                                    g: {
                                                        C: {
                                                            B: {
                                                                if (!(2 & I)) {
                                                                    if (E[9399] == (0 | Q)) {
                                                                        if (E[9399] = C, A = E[9396] + A | 0, E[9396] = A, E[C + 4 >> 2] = 1 | A, E[9398] != (0 | C)) break A;
                                                                        return E[9395] = 0, void (E[9398] = 0);
                                                                    }
                                                                    if (E[9398] == (0 | Q)) return E[9398] = C, A = E[9395] + A | 0, E[9395] = A, E[C + 4 >> 2] = 1 | A, void (E[A + C >> 2] = A);
                                                                    if (A = (-8 & I) + A | 0, I >>> 0 <= 255) {
                                                                        if (B = I >>> 3 | 0, (0 | (I = E[Q + 12 >> 2])) == (0 | (g = E[Q + 8 >> 2]))) {
                                                                            a = 37572, c = E[9393] & Lg(-2, B), E[a >> 2] = c;
                                                                            break g;
                                                                        }
                                                                        E[g + 12 >> 2] = I, E[I + 8 >> 2] = g;
                                                                        break g;
                                                                    }
                                                                    if (o = E[Q + 24 >> 2], (0 | Q) != (0 | (I = E[Q + 12 >> 2]))) {
                                                                        g = E[Q + 8 >> 2], E[g + 12 >> 2] = I, E[I + 8 >> 2] = g;
                                                                        break C;
                                                                    }
                                                                    if (!(g = E[(B = Q + 20 | 0) >> 2])) {
                                                                        if (!(g = E[Q + 16 >> 2])) break B;
                                                                        B = Q + 16 | 0;
                                                                    }
                                                                    for(; i = B, (g = E[(B = (I = g) + 20 | 0) >> 2]) || (B = I + 16 | 0, g = E[I + 16 >> 2]););
                                                                    E[i >> 2] = 0;
                                                                    break C;
                                                                }
                                                                E[Q + 4 >> 2] = -2 & I, E[C + 4 >> 2] = 1 | A, E[A + C >> 2] = A;
                                                                break I;
                                                            }
                                                            I = 0;
                                                        }
                                                        if (o) {
                                                            g = E[Q + 28 >> 2];
                                                            C: {
                                                                if (E[(B = 37876 + (g << 2) | 0) >> 2] == (0 | Q)) {
                                                                    if (E[B >> 2] = I, I) break C;
                                                                    a = 37576, c = E[9394] & Lg(-2, g), E[a >> 2] = c;
                                                                    break g;
                                                                }
                                                                if (E[o + (E[o + 16 >> 2] == (0 | Q) ? 16 : 20) >> 2] = I, !I) break g;
                                                            }
                                                            E[I + 24 >> 2] = o, (g = E[Q + 16 >> 2]) && (E[I + 16 >> 2] = g, E[g + 24 >> 2] = I), (g = E[Q + 20 >> 2]) && (E[I + 20 >> 2] = g, E[g + 24 >> 2] = I);
                                                        }
                                                    }
                                                    if (E[C + 4 >> 2] = 1 | A, E[A + C >> 2] = A, E[9398] == (0 | C)) return void (E[9395] = A);
                                                }
                                                if (A >>> 0 <= 255) return I = 37612 + (-8 & A) | 0, (g = E[9393]) & (A = 1 << (A >>> 3)) ? A = E[I + 8 >> 2] : (E[9393] = A | g, A = I), E[I + 8 >> 2] = C, E[A + 12 >> 2] = C, E[C + 12 >> 2] = I, void (E[C + 8 >> 2] = A);
                                                g = 31, A >>> 0 <= 16777215 && (g = 62 + ((A >>> 38 - (I = t(A >>> 8 | 0)) & 1) - (I << 1) | 0) | 0), E[C + 28 >> 2] = g, E[C + 16 >> 2] = 0, E[C + 20 >> 2] = 0, I = 37876 + (g << 2) | 0;
                                                I: {
                                                    g: {
                                                        if ((B = E[9394]) & (i = 1 << g)) {
                                                            for(g = A << (31 != (0 | g) ? 25 - (g >>> 1 | 0) | 0 : 0), I = E[I >> 2];;){
                                                                if (B = I, (-8 & E[I + 4 >> 2]) == (0 | A)) break g;
                                                                if (i = g >>> 29 | 0, g <<= 1, !(I = E[16 + (i = I + (4 & i) | 0) >> 2])) break;
                                                            }
                                                            E[i + 16 >> 2] = C, E[C + 24 >> 2] = B;
                                                        } else E[9394] = B | i, E[I >> 2] = C, E[C + 24 >> 2] = I;
                                                        E[C + 12 >> 2] = C, E[C + 8 >> 2] = C;
                                                        break I;
                                                    }
                                                    A = E[B + 8 >> 2], E[A + 12 >> 2] = C, E[B + 8 >> 2] = C, E[C + 24 >> 2] = 0, E[C + 12 >> 2] = B, E[C + 8 >> 2] = A;
                                                }
                                                A = E[9401] - 1 | 0, E[9401] = A || -1;
                                            }
                                        }
                                    }
                                    function CA(A, I, g, C, B) {
                                        var Q, i, E, _, c, t, r, e, y, s, h, D, p = 0, w = 0, f = 0, n = 0, k = 0, F = 0, N = 0, S = 0, G = 0, M = 0, b = 0, K = 0, H = 0, Y = 0, d = 0, J = 0, U = 0, l = 0, m = 0, u = 0, x = 0, R = 0, v = 0, L = 0;
                                        if (C ? (U = a[C + 12 | 0] | a[C + 13 | 0] << 8 | a[C + 14 | 0] << 16 | a[C + 15 | 0] << 24, m = a[C + 8 | 0] | a[C + 9 | 0] << 8 | a[C + 10 | 0] << 16 | a[C + 11 | 0] << 24, l = a[0 | C] | a[C + 1 | 0] << 8 | a[C + 2 | 0] << 16 | a[C + 3 | 0] << 24, u = a[C + 4 | 0] | a[C + 5 | 0] << 8 | a[C + 6 | 0] << 16 | a[C + 7 | 0] << 24) : (U = 1797285236, l = 1634760805, m = 2036477234, u = 857760878), C = Q = a[g + 20 | 0] | a[g + 21 | 0] << 8 | a[g + 22 | 0] << 16 | a[g + 23 | 0] << 24, S = i = a[g + 24 | 0] | a[g + 25 | 0] << 8 | a[g + 26 | 0] << 16 | a[g + 27 | 0] << 24, K = E = a[g + 28 | 0] | a[g + 29 | 0] << 8 | a[g + 30 | 0] << 16 | a[g + 31 | 0] << 24, f = U, N = _ = a[g + 16 | 0] | a[g + 17 | 0] << 8 | a[g + 18 | 0] << 16 | a[g + 19 | 0] << 24, G = m, H = c = a[I + 12 | 0] | a[I + 13 | 0] << 8 | a[I + 14 | 0] << 16 | a[I + 15 | 0] << 24, M = t = a[I + 8 | 0] | a[I + 9 | 0] << 8 | a[I + 10 | 0] << 16 | a[I + 11 | 0] << 24, n = r = a[I + 4 | 0] | a[I + 5 | 0] << 8 | a[I + 6 | 0] << 16 | a[I + 7 | 0] << 24, I = e = a[0 | I] | a[I + 1 | 0] << 8 | a[I + 2 | 0] << 16 | a[I + 3 | 0] << 24, b = u, p = y = a[g + 12 | 0] | a[g + 13 | 0] << 8 | a[g + 14 | 0] << 16 | a[g + 15 | 0] << 24, w = s = a[g + 8 | 0] | a[g + 9 | 0] << 8 | a[g + 10 | 0] << 16 | a[g + 11 | 0] << 24, k = h = a[g + 4 | 0] | a[g + 5 | 0] << 8 | a[g + 6 | 0] << 16 | a[g + 7 | 0] << 24, g = D = a[0 | g] | a[g + 1 | 0] << 8 | a[g + 2 | 0] << 16 | a[g + 3 | 0] << 24, F = l, (0 | B) > 0) for(; Y = Lg(g + b | 0, 7) ^ H, x = Lg(Y + b | 0, 9) ^ S, d = Lg(C + F | 0, 7) ^ p, R = Lg(d + F | 0, 9) ^ M, v = Lg(d + R | 0, 13) ^ C, J = Lg(f + N | 0, 7) ^ w, n = Lg(J + f | 0, 9) ^ n, w = Lg(n + J | 0, 13) ^ N, f = Lg(n + w | 0, 18) ^ f, p = Lg(I + G | 0, 7) ^ K, C = v ^ Lg(f + p | 0, 7), S = Lg(C + f | 0, 9) ^ x, K = Lg(C + S | 0, 13) ^ p, f = Lg(S + K | 0, 18) ^ f, k = Lg(p + G | 0, 9) ^ k, p = Lg(k + p | 0, 13) ^ I, I = Lg(p + k | 0, 18) ^ G, N = Lg(I + Y | 0, 7) ^ w, M = Lg(N + I | 0, 9) ^ R, H = Lg(N + M | 0, 13) ^ Y, G = Lg(M + H | 0, 18) ^ I, g = Lg(Y + x | 0, 13) ^ g, w = Lg(g + x | 0, 18) ^ b, I = Lg(w + d | 0, 7) ^ p, n = Lg(I + w | 0, 9) ^ n, p = Lg(I + n | 0, 13) ^ d, b = Lg(n + p | 0, 18) ^ w, F = Lg(R + v | 0, 18) ^ F, g = Lg(F + J | 0, 7) ^ g, k = Lg(g + F | 0, 9) ^ k, w = Lg(g + k | 0, 13) ^ J, F = Lg(k + w | 0, 18) ^ F, (0 | (L = L + 2 | 0)) < (0 | B););
                                        B = f + U | 0, o[A + 60 | 0] = B, o[A + 61 | 0] = B >>> 8, o[A + 62 | 0] = B >>> 16, o[A + 63 | 0] = B >>> 24, B = K + E | 0, o[A + 56 | 0] = B, o[A + 57 | 0] = B >>> 8, o[A + 58 | 0] = B >>> 16, o[A + 59 | 0] = B >>> 24, B = S + i | 0, o[A + 52 | 0] = B, o[A + 53 | 0] = B >>> 8, o[A + 54 | 0] = B >>> 16, o[A + 55 | 0] = B >>> 24, C = C + Q | 0, o[A + 48 | 0] = C, o[A + 49 | 0] = C >>> 8, o[A + 50 | 0] = C >>> 16, o[A + 51 | 0] = C >>> 24, C = N + _ | 0, o[A + 44 | 0] = C, o[A + 45 | 0] = C >>> 8, o[A + 46 | 0] = C >>> 16, o[A + 47 | 0] = C >>> 24, C = G + m | 0, o[A + 40 | 0] = C, o[A + 41 | 0] = C >>> 8, o[A + 42 | 0] = C >>> 16, o[A + 43 | 0] = C >>> 24, C = H + c | 0, o[A + 36 | 0] = C, o[A + 37 | 0] = C >>> 8, o[A + 38 | 0] = C >>> 16, o[A + 39 | 0] = C >>> 24, C = M + t | 0, o[A + 32 | 0] = C, o[A + 33 | 0] = C >>> 8, o[A + 34 | 0] = C >>> 16, o[A + 35 | 0] = C >>> 24, C = n + r | 0, o[A + 28 | 0] = C, o[A + 29 | 0] = C >>> 8, o[A + 30 | 0] = C >>> 16, o[A + 31 | 0] = C >>> 24, I = I + e | 0, o[A + 24 | 0] = I, o[A + 25 | 0] = I >>> 8, o[A + 26 | 0] = I >>> 16, o[A + 27 | 0] = I >>> 24, I = b + u | 0, o[A + 20 | 0] = I, o[A + 21 | 0] = I >>> 8, o[A + 22 | 0] = I >>> 16, o[A + 23 | 0] = I >>> 24, I = p + y | 0, o[A + 16 | 0] = I, o[A + 17 | 0] = I >>> 8, o[A + 18 | 0] = I >>> 16, o[A + 19 | 0] = I >>> 24, I = w + s | 0, o[A + 12 | 0] = I, o[A + 13 | 0] = I >>> 8, o[A + 14 | 0] = I >>> 16, o[A + 15 | 0] = I >>> 24, I = k + h | 0, o[A + 8 | 0] = I, o[A + 9 | 0] = I >>> 8, o[A + 10 | 0] = I >>> 16, o[A + 11 | 0] = I >>> 24, I = g + D | 0, o[A + 4 | 0] = I, o[A + 5 | 0] = I >>> 8, o[A + 6 | 0] = I >>> 16, o[A + 7 | 0] = I >>> 24, I = F + l | 0, o[0 | A] = I, o[A + 1 | 0] = I >>> 8, o[A + 2 | 0] = I >>> 16, o[A + 3 | 0] = I >>> 24;
                                    }
                                    function BA(A, I, g, C, B, Q) {
                                        var i = 0;
                                        if (E[Q >> 2] = 8, !(I = (i = !I & A >>> 0 <= 32768) ? 0 : I) & g >>> 5 >>> 0 <= (A = i ? 32768 : A) >>> 0 | I) return i = 1, g >>> 0 < 4096 || (i = 2, g >>> 0 < 8192 || (i = 3, g >>> 0 < 16384 || (i = 4, g >>> 0 < 32768 || (i = 5, g >>> 0 < 65536 || (i = 6, g >>> 0 < 131072 || (i = 7, g >>> 0 < 262144 || (i = 8, g >>> 0 < 524288 || (i = 9, g >>> 0 < 1048576 || (i = 10, g >>> 0 < 2097152 || (i = 11, g >>> 0 < 4194304 || (i = 12, g >>> 0 < 8388608 || (i = 13, g >>> 0 < 16777216 || (i = 14, g >>> 0 < 33554432 || (i = 15, g >>> 0 < 67108864 || (i = 16, g >>> 0 < 134217728 || (i = 17, g >>> 0 < 268435456 || (i = 18, g >>> 0 < 536870912 || (i = 19, g >>> 0 < 1073741824 || (i = (0 | g) >= 0 ? 20 : 21))))))))))))))))))), g = i, E[C >> 2] = g, C = I >>> 2 | 0, I = (3 & I) << 30 | A >>> 2, A = 31 & g, (63 & g) >>> 0 >= 32 ? (g = 0, A = C >>> A | 0) : (g = C >>> A | 0, A = ((1 << A) - 1 & C) << 32 - A | I >>> A), void (E[B >> 2] = ((!g & A >>> 0 >= 1073741823 | g ? 1073741823 : A) >>> 0) / _[Q >> 2]);
                                        E[B >> 2] = 1, I = oI(A, I, E[Q >> 2] << 2), g = 1, !(A = w) & I >>> 0 < 4 || (g = 2, !A & I >>> 0 < 8 || (g = 3, !A & I >>> 0 < 16 || (g = 4, !A & I >>> 0 < 32 || (g = 5, !A & I >>> 0 < 64 || (g = 6, !A & I >>> 0 < 128 || (g = 7, !A & I >>> 0 < 256 || (g = 8, !A & I >>> 0 < 512 || (g = 9, !A & I >>> 0 < 1024 || (g = 10, !A & I >>> 0 < 2048 || (g = 11, !A & I >>> 0 < 4096 || (g = 12, !A & I >>> 0 < 8192 || (g = 13, !A & I >>> 0 < 16384 || (g = 14, !A & I >>> 0 < 32768 || (g = 15, !A & I >>> 0 < 65536 || (g = 16, !A & I >>> 0 < 131072 || (g = 17, !A & I >>> 0 < 262144 || (g = 18, !A & I >>> 0 < 524288 || (g = 19, !A & I >>> 0 < 1048576 || (g = 20, !A & I >>> 0 < 2097152 || (g = 21, !A & I >>> 0 < 4194304 || (g = 22, !A & I >>> 0 < 8388608 || (g = 23, !A & I >>> 0 < 16777216 || (g = 24, !A & I >>> 0 < 33554432 || (g = 25, !A & I >>> 0 < 67108864 || (g = 26, !A & I >>> 0 < 134217728 || (g = 27, !A & I >>> 0 < 268435456 || (g = 28, !A & I >>> 0 < 536870912 || (g = 29, !A & I >>> 0 < 1073741824 || (g = 30, !A & I >>> 0 < 2147483648 || (g = 31, A && (g = 32, A >>> 0 < 2 || (g = 33, A >>> 0 < 4 || (g = 34, A >>> 0 < 8 || (g = 35, A >>> 0 < 16 || (g = 36, A >>> 0 < 32 || (g = 37, A >>> 0 < 64 || (g = 38, A >>> 0 < 128 || (g = 39, A >>> 0 < 256 || (g = 40, A >>> 0 < 512 || (g = 41, A >>> 0 < 1024 || (g = 42, A >>> 0 < 2048 || (g = 43, A >>> 0 < 4096 || (g = 44, A >>> 0 < 8192 || (g = 45, A >>> 0 < 16384 || (g = 46, A >>> 0 < 32768 || (g = 47, A >>> 0 < 65536 || (g = 48, A >>> 0 < 131072 || (g = 49, A >>> 0 < 262144 || (g = 50, A >>> 0 < 524288 || (g = 51, A >>> 0 < 1048576 || (g = 52, A >>> 0 < 2097152 || (g = 53, A >>> 0 < 4194304 || (g = 54, A >>> 0 < 8388608 || (g = 55, A >>> 0 < 16777216 || (g = 56, A >>> 0 < 33554432 || (g = 57, A >>> 0 < 67108864 || (g = 58, A >>> 0 < 134217728 || (g = 59, A >>> 0 < 268435456 || (g = 60, A >>> 0 < 536870912 || (g = 61, A >>> 0 < 1073741824 || (g = (0 | A) > 0 | (0 | A) >= 0 ? 62 : 63))))))))))))))))))))))))))))))))))))))))))))))))))))))))))))), E[C >> 2] = g;
                                    }
                                    function QA(A, I, g, C, B, i, o, _, c) {
                                        var t = 0, r = 0, e = 0, y = 0, s = 0, D = 0, p = 0, w = 0;
                                        if (I - 65 >>> 0 < 4294967232 | o >>> 0 > 64) A = -1;
                                        else {
                                            w = t = h, h = t = t - 512 & -64;
                                            A: {
                                                I: if (!(!(!(C | B) | g) | !A | ((D = 255 & I) - 65 & 255) >>> 0 <= 191 | !(!(I = 255 & o) || i) | I >>> 0 >= 65)) {
                                                    if (I) {
                                                        if (!i) break I;
                                                        _ ? (r = 725511199 ^ (a[_ + 8 | 0] | a[_ + 9 | 0] << 8 | a[_ + 10 | 0] << 16 | a[_ + 11 | 0] << 24), e = -1694144372 ^ (a[_ + 12 | 0] | a[_ + 13 | 0] << 8 | a[_ + 14 | 0] << 16 | a[_ + 15 | 0] << 24), o = -1377402159 ^ (a[0 | _] | a[_ + 1 | 0] << 8 | a[_ + 2 | 0] << 16 | a[_ + 3 | 0] << 24), _ = 1359893119 ^ (a[_ + 4 | 0] | a[_ + 5 | 0] << 8 | a[_ + 6 | 0] << 16 | a[_ + 7 | 0] << 24)) : (r = 725511199, e = -1694144372, o = -1377402159, _ = 1359893119), c ? (y = 327033209 ^ (a[c + 8 | 0] | a[c + 9 | 0] << 8 | a[c + 10 | 0] << 16 | a[c + 11 | 0] << 24), s = 1541459225 ^ (a[c + 12 | 0] | a[c + 13 | 0] << 8 | a[c + 14 | 0] << 16 | a[c + 15 | 0] << 24), p = -79577749 ^ (a[0 | c] | a[c + 1 | 0] << 8 | a[c + 2 | 0] << 16 | a[c + 3 | 0] << 24), c = 528734635 ^ (a[c + 4 | 0] | a[c + 5 | 0] << 8 | a[c + 6 | 0] << 16 | a[c + 7 | 0] << 24)) : (y = 327033209, s = 1541459225, p = -79577749, c = 528734635), Hg(t - -64 | 0, 0, 293), E[t + 56 >> 2] = y, E[t + 60 >> 2] = s, E[t + 48 >> 2] = p, E[t + 52 >> 2] = c, E[t + 40 >> 2] = r, E[t + 44 >> 2] = e, E[t + 32 >> 2] = o, E[t + 36 >> 2] = _, E[t + 24 >> 2] = 1595750129, E[t + 28 >> 2] = -1521486534, E[t + 16 >> 2] = -23791573, E[t + 20 >> 2] = 1013904242, E[t + 8 >> 2] = -2067093701, E[t + 12 >> 2] = -1150833019, E[t >> 2] = -222443256 ^ (I << 8 | D), E[t + 4 >> 2] = I >>> 24 ^ 1779033703, Hg((o = t + 384 | 0) + I | 0, 0, 128 - I | 0), Sg(o, i, I), Sg(t + 96 | 0, o, 128), E[t + 352 >> 2] = 128, XC(o, 128), I = 128;
                                                    } else _ ? (r = 725511199 ^ (a[_ + 8 | 0] | a[_ + 9 | 0] << 8 | a[_ + 10 | 0] << 16 | a[_ + 11 | 0] << 24), e = -1694144372 ^ (a[_ + 12 | 0] | a[_ + 13 | 0] << 8 | a[_ + 14 | 0] << 16 | a[_ + 15 | 0] << 24), i = 1359893119 ^ (a[_ + 4 | 0] | a[_ + 5 | 0] << 8 | a[_ + 6 | 0] << 16 | a[_ + 7 | 0] << 24), I = -1377402159 ^ (a[0 | _] | a[_ + 1 | 0] << 8 | a[_ + 2 | 0] << 16 | a[_ + 3 | 0] << 24)) : (r = 725511199, e = -1694144372, i = 1359893119, I = -1377402159), c ? (y = 327033209 ^ (a[c + 8 | 0] | a[c + 9 | 0] << 8 | a[c + 10 | 0] << 16 | a[c + 11 | 0] << 24), s = 1541459225 ^ (a[c + 12 | 0] | a[c + 13 | 0] << 8 | a[c + 14 | 0] << 16 | a[c + 15 | 0] << 24), _ = 528734635 ^ (a[c + 4 | 0] | a[c + 5 | 0] << 8 | a[c + 6 | 0] << 16 | a[c + 7 | 0] << 24), o = -79577749 ^ (a[0 | c] | a[c + 1 | 0] << 8 | a[c + 2 | 0] << 16 | a[c + 3 | 0] << 24)) : (y = 327033209, s = 1541459225, _ = 528734635, o = -79577749), Hg(t - -64 | 0, 0, 293), E[t + 56 >> 2] = y, E[t + 60 >> 2] = s, E[t + 48 >> 2] = o, E[t + 52 >> 2] = _, E[t + 40 >> 2] = r, E[t + 44 >> 2] = e, E[t + 32 >> 2] = I, E[t + 36 >> 2] = i, E[t + 24 >> 2] = 1595750129, E[t + 28 >> 2] = -1521486534, E[t + 16 >> 2] = -23791573, E[t + 20 >> 2] = 1013904242, E[t + 8 >> 2] = -2067093701, E[t + 12 >> 2] = -1150833019, E[t >> 2] = -222443256 ^ D, E[t + 4 >> 2] = 1779033703, I = 0;
                                                    g: if (C | B) for(c = t + 224 | 0, _ = t + 96 | 0;;){
                                                        if (o = I + _ | 0, !B & C >>> 0 <= (i = 256 - I | 0) >>> 0) {
                                                            Sg(o, g, C), E[t + 352 >> 2] = C + E[t + 352 >> 2];
                                                            break g;
                                                        }
                                                        if (Sg(o, g, i), E[t + 352 >> 2] = i + E[t + 352 >> 2], r = I = E[t + 68 >> 2], I = (e = (o = E[t + 64 >> 2]) + 128 | 0) >>> 0 < 128 ? I + 1 | 0 : I, E[t + 64 >> 2] = e, E[t + 68 >> 2] = I, I = E[t + 76 >> 2], I = (r = o = -1 == (0 | r) & o >>> 0 > 4294967167) >>> 0 > (o = o + E[t + 72 >> 2] | 0) >>> 0 ? I + 1 | 0 : I, E[t + 72 >> 2] = o, E[t + 76 >> 2] = I, f(t, _), Sg(_, c, 128), I = E[t + 352 >> 2] - 128 | 0, E[t + 352 >> 2] = I, g = g + i | 0, !((B = B - (C >>> 0 < i >>> 0) | 0) | (C = C - i | 0))) break;
                                                    }
                                                    $(t, A, D), h = w;
                                                    break A;
                                                }
                                                yC(), Q();
                                            }
                                            A = 0;
                                        }
                                        return A;
                                    }
                                    function iA(A, I) {
                                        var g, C = 0, B = 0, Q = 0, i = 0, o = 0, a = 0, _ = 0;
                                        g = A + I | 0;
                                        A: {
                                            I: if (!(1 & (C = E[A + 4 >> 2]))) {
                                                if (!(3 & C)) break A;
                                                I = (C = E[A >> 2]) + I | 0;
                                                g: {
                                                    C: {
                                                        B: {
                                                            if ((0 | (A = A - C | 0)) != E[9398]) {
                                                                if (C >>> 0 <= 255) {
                                                                    if ((0 | (B = E[A + 8 >> 2])) != (0 | (Q = E[A + 12 >> 2]))) break B;
                                                                    a = 37572, _ = E[9393] & Lg(-2, C >>> 3 | 0), E[a >> 2] = _;
                                                                    break I;
                                                                }
                                                                if (o = E[A + 24 >> 2], (0 | (C = E[A + 12 >> 2])) != (0 | A)) {
                                                                    B = E[A + 8 >> 2], E[B + 12 >> 2] = C, E[C + 8 >> 2] = B;
                                                                    break g;
                                                                }
                                                                if (!(B = E[(Q = A + 20 | 0) >> 2])) {
                                                                    if (!(B = E[A + 16 >> 2])) break C;
                                                                    Q = A + 16 | 0;
                                                                }
                                                                for(; i = Q, (B = E[(Q = (C = B) + 20 | 0) >> 2]) || (Q = C + 16 | 0, B = E[C + 16 >> 2]););
                                                                E[i >> 2] = 0;
                                                                break g;
                                                            }
                                                            if (3 != (3 & (C = E[g + 4 >> 2]))) break I;
                                                            return E[9395] = I, E[g + 4 >> 2] = -2 & C, E[A + 4 >> 2] = 1 | I, void (E[g >> 2] = I);
                                                        }
                                                        E[B + 12 >> 2] = Q, E[Q + 8 >> 2] = B;
                                                        break I;
                                                    }
                                                    C = 0;
                                                }
                                                if (o) {
                                                    B = E[A + 28 >> 2];
                                                    g: {
                                                        if (E[(Q = 37876 + (B << 2) | 0) >> 2] == (0 | A)) {
                                                            if (E[Q >> 2] = C, C) break g;
                                                            a = 37576, _ = E[9394] & Lg(-2, B), E[a >> 2] = _;
                                                            break I;
                                                        }
                                                        if (E[o + (E[o + 16 >> 2] == (0 | A) ? 16 : 20) >> 2] = C, !C) break I;
                                                    }
                                                    E[C + 24 >> 2] = o, (B = E[A + 16 >> 2]) && (E[C + 16 >> 2] = B, E[B + 24 >> 2] = C), (B = E[A + 20 >> 2]) && (E[C + 20 >> 2] = B, E[B + 24 >> 2] = C);
                                                }
                                            }
                                            I: {
                                                g: {
                                                    C: {
                                                        B: {
                                                            if (!(2 & (C = E[g + 4 >> 2]))) {
                                                                if (E[9399] == (0 | g)) {
                                                                    if (E[9399] = A, I = E[9396] + I | 0, E[9396] = I, E[A + 4 >> 2] = 1 | I, E[9398] != (0 | A)) break A;
                                                                    return E[9395] = 0, void (E[9398] = 0);
                                                                }
                                                                if (E[9398] == (0 | g)) return E[9398] = A, I = E[9395] + I | 0, E[9395] = I, E[A + 4 >> 2] = 1 | I, void (E[A + I >> 2] = I);
                                                                if (I = (-8 & C) + I | 0, C >>> 0 <= 255) {
                                                                    if (Q = C >>> 3 | 0, (0 | (C = E[g + 12 >> 2])) == (0 | (B = E[g + 8 >> 2]))) {
                                                                        a = 37572, _ = E[9393] & Lg(-2, Q), E[a >> 2] = _;
                                                                        break g;
                                                                    }
                                                                    E[B + 12 >> 2] = C, E[C + 8 >> 2] = B;
                                                                    break g;
                                                                }
                                                                if (o = E[g + 24 >> 2], (0 | g) != (0 | (C = E[g + 12 >> 2]))) {
                                                                    B = E[g + 8 >> 2], E[B + 12 >> 2] = C, E[C + 8 >> 2] = B;
                                                                    break C;
                                                                }
                                                                if (!(B = E[(Q = g + 20 | 0) >> 2])) {
                                                                    if (!(B = E[g + 16 >> 2])) break B;
                                                                    Q = g + 16 | 0;
                                                                }
                                                                for(; i = Q, (B = E[(Q = (C = B) + 20 | 0) >> 2]) || (Q = C + 16 | 0, B = E[C + 16 >> 2]););
                                                                E[i >> 2] = 0;
                                                                break C;
                                                            }
                                                            E[g + 4 >> 2] = -2 & C, E[A + 4 >> 2] = 1 | I, E[A + I >> 2] = I;
                                                            break I;
                                                        }
                                                        C = 0;
                                                    }
                                                    if (o) {
                                                        B = E[g + 28 >> 2];
                                                        C: {
                                                            if (E[(Q = 37876 + (B << 2) | 0) >> 2] == (0 | g)) {
                                                                if (E[Q >> 2] = C, C) break C;
                                                                a = 37576, _ = E[9394] & Lg(-2, B), E[a >> 2] = _;
                                                                break g;
                                                            }
                                                            if (E[o + (E[o + 16 >> 2] == (0 | g) ? 16 : 20) >> 2] = C, !C) break g;
                                                        }
                                                        E[C + 24 >> 2] = o, (B = E[g + 16 >> 2]) && (E[C + 16 >> 2] = B, E[B + 24 >> 2] = C), (B = E[g + 20 >> 2]) && (E[C + 20 >> 2] = B, E[B + 24 >> 2] = C);
                                                    }
                                                }
                                                if (E[A + 4 >> 2] = 1 | I, E[A + I >> 2] = I, E[9398] == (0 | A)) return void (E[9395] = I);
                                            }
                                            if (I >>> 0 <= 255) return C = 37612 + (-8 & I) | 0, (B = E[9393]) & (I = 1 << (I >>> 3)) ? I = E[C + 8 >> 2] : (E[9393] = I | B, I = C), E[C + 8 >> 2] = A, E[I + 12 >> 2] = A, E[A + 12 >> 2] = C, void (E[A + 8 >> 2] = I);
                                            B = 31, I >>> 0 <= 16777215 && (B = 62 + ((I >>> 38 - (C = t(I >>> 8 | 0)) & 1) - (C << 1) | 0) | 0), E[A + 28 >> 2] = B, E[A + 16 >> 2] = 0, E[A + 20 >> 2] = 0, C = 37876 + (B << 2) | 0;
                                            I: {
                                                if ((Q = E[9394]) & (i = 1 << B)) {
                                                    for(B = I << (31 != (0 | B) ? 25 - (B >>> 1 | 0) | 0 : 0), C = E[C >> 2];;){
                                                        if (Q = C, (-8 & E[C + 4 >> 2]) == (0 | I)) break I;
                                                        if (i = B >>> 29 | 0, B <<= 1, !(C = E[16 + (i = C + (4 & i) | 0) >> 2])) break;
                                                    }
                                                    E[i + 16 >> 2] = A, E[A + 24 >> 2] = Q;
                                                } else E[9394] = Q | i, E[C >> 2] = A, E[A + 24 >> 2] = C;
                                                return E[A + 12 >> 2] = A, void (E[A + 8 >> 2] = A);
                                            }
                                            I = E[Q + 8 >> 2], E[I + 12 >> 2] = A, E[Q + 8 >> 2] = A, E[A + 24 >> 2] = 0, E[A + 12 >> 2] = Q, E[A + 8 >> 2] = I;
                                        }
                                    }
                                    function oA(A, I, g, C, B, Q, i) {
                                        var _, t, r = 0, e = 0, y = 0;
                                        if (h = _ = h + -64 | 0, t = K(32)) {
                                            E[_ + 36 >> 2] = 0, E[_ + 40 >> 2] = 0, E[_ + 28 >> 2] = 0, E[_ + 32 >> 2] = 0, E[_ + 24 >> 2] = 16, E[_ + 20 >> 2] = B, E[_ + 16 >> 2] = C, E[_ + 12 >> 2] = g, E[_ + 8 >> 2] = 32, E[_ + 4 >> 2] = t, E[_ + 60 >> 2] = 0, E[_ + 56 >> 2] = 1, E[_ + 52 >> 2] = 1, E[_ + 48 >> 2] = I, E[_ + 44 >> 2] = A;
                                            A: if (A = L(_ + 4 | 0, i)) XC(t, 32);
                                            else {
                                                if (Q) {
                                                    r = _ + 4 | 0, h = B = h - 32 | 0, A = -31;
                                                    I: {
                                                        g: {
                                                            C: switch(i - 1 | 0){
                                                                case 1:
                                                                    A = a[1417] | a[1418] << 8 | a[1419] << 16 | a[1420] << 24, I = a[1413] | a[1414] << 8 | a[1415] << 16 | a[1416] << 24, o[0 | Q] = I, o[Q + 1 | 0] = I >>> 8, o[Q + 2 | 0] = I >>> 16, o[Q + 3 | 0] = I >>> 24, o[Q + 4 | 0] = A, o[Q + 5 | 0] = A >>> 8, o[Q + 6 | 0] = A >>> 16, o[Q + 7 | 0] = A >>> 24, A = a[1422] | a[1423] << 8 | a[1424] << 16 | a[1425] << 24, I = a[1418] | a[1419] << 8 | a[1420] << 16 | a[1421] << 24, o[Q + 5 | 0] = I, o[Q + 6 | 0] = I >>> 8, o[Q + 7 | 0] = I >>> 16, o[Q + 8 | 0] = I >>> 24, o[Q + 9 | 0] = A, o[Q + 10 | 0] = A >>> 8, o[Q + 11 | 0] = A >>> 16, o[Q + 12 | 0] = A >>> 24, g = -12, I = 12;
                                                                    break g;
                                                                case 0:
                                                                    break C;
                                                                default:
                                                                    break I;
                                                            }
                                                            A = a[1405] | a[1406] << 8 | a[1407] << 16 | a[1408] << 24, I = a[1401] | a[1402] << 8 | a[1403] << 16 | a[1404] << 24, o[0 | Q] = I, o[Q + 1 | 0] = I >>> 8, o[Q + 2 | 0] = I >>> 16, o[Q + 3 | 0] = I >>> 24, o[Q + 4 | 0] = A, o[Q + 5 | 0] = A >>> 8, o[Q + 6 | 0] = A >>> 16, o[Q + 7 | 0] = A >>> 24, A = a[1409] | a[1410] << 8 | a[1411] << 16 | a[1412] << 24, o[Q + 8 | 0] = A, o[Q + 9 | 0] = A >>> 8, o[Q + 10 | 0] = A >>> 16, o[Q + 11 | 0] = A >>> 24, g = -11, I = 11;
                                                        }
                                                        if (!(A = pI(r))) {
                                                            if (o[B + 13 | 0] = 0, o[B + 11 | 0] = 49, o[B + 12 | 0] = 57, (g = g + 128 | 0) >>> 0 <= (A = LI(B + 11 | 0)) >>> 0) A = -31;
                                                            else if (I = Sg(I + Q | 0, B + 11 | 0, A + 1 | 0), (e = g - A | 0) >>> 0 < 4) A = -31;
                                                            else {
                                                                for(o[0 | (i = A + I | 0)] = 36, o[i + 1 | 0] = 109, o[i + 2 | 0] = 61, o[i + 3 | 0] = 0, A = E[r + 44 >> 2], I = 10; g = I, C = (A >>> 0) / 10 | 0, o[0 | (y = (I = I - 1 | 0) + (B + 22 | 0) | 0)] = A - c(C, 10) | 48, !(A >>> 0 < 10) && (A = C, I););
                                                                if (Sg(A = B + 11 | 0, y, I = 11 - g | 0), o[A + I | 0] = 0, (I = e - 3 | 0) >>> 0 <= (A = LI(A)) >>> 0) A = -31;
                                                                else if (g = Sg(i + 3 | 0, B + 11 | 0, A + 1 | 0), (e = I - A | 0) >>> 0 < 4) A = -31;
                                                                else {
                                                                    for(o[0 | (i = A + g | 0)] = 44, o[i + 1 | 0] = 116, o[i + 2 | 0] = 61, o[i + 3 | 0] = 0, A = E[r + 40 >> 2], I = 10; g = I, C = (A >>> 0) / 10 | 0, o[0 | (y = (I = I - 1 | 0) + (B + 22 | 0) | 0)] = A - c(C, 10) | 48, !(A >>> 0 < 10) && (A = C, I););
                                                                    if (Sg(A = B + 11 | 0, y, I = 11 - g | 0), o[A + I | 0] = 0, (I = e - 3 | 0) >>> 0 <= (A = LI(A)) >>> 0) A = -31;
                                                                    else if (g = Sg(i + 3 | 0, B + 11 | 0, A + 1 | 0), (e = I - A | 0) >>> 0 < 4) A = -31;
                                                                    else {
                                                                        for(o[0 | (i = A + g | 0)] = 44, o[i + 1 | 0] = 112, o[i + 2 | 0] = 61, o[i + 3 | 0] = 0, A = E[r + 48 >> 2], I = 10; g = I, C = (A >>> 0) / 10 | 0, o[0 | (y = (I = I - 1 | 0) + (B + 22 | 0) | 0)] = A - c(C, 10) | 48, !(A >>> 0 < 10) && (A = C, I););
                                                                        Sg(A = B + 11 | 0, y, I = 11 - g | 0), o[A + I | 0] = 0, (I = e - 3 | 0) >>> 0 <= (A = LI(A)) >>> 0 ? A = -31 : (g = Sg(i + 3 | 0, B + 11 | 0, A + 1 | 0), (C = I - A | 0) >>> 0 < 2 ? A = -31 : (o[0 | (A = A + g | 0)] = 36, o[A + 1 | 0] = 0, LA(I = A + 1 | 0, g = C - 1 | 0, E[r + 16 >> 2], E[r + 20 >> 2], 3) ? (A = -31, (C = (C = g) - (g = LI(I)) | 0) >>> 0 < 2 || (o[0 | (A = I + g | 0)] = 36, o[A + 1 | 0] = 0, A = LA(A + 1 | 0, C - 1 | 0, E[r >> 2], E[r + 4 >> 2], 3) ? 0 : -31)) : A = -31));
                                                                    }
                                                                }
                                                            }
                                                        }
                                                    }
                                                    if (h = B + 32 | 0, A) {
                                                        XC(t, 32), XC(Q, 128), A = -31;
                                                        break A;
                                                    }
                                                }
                                                XC(t, 32), A = 0;
                                            }
                                            gA(t);
                                        } else A = -22;
                                        return h = _ - -64 | 0, A;
                                    }
                                    function EA(A, I) {
                                        var g, C = 0, B = 0, Q = 0, i = 0, _ = 0, c = 0, t = 0, r = 0, e = 0, y = 0, s = 0, D = 0, p = 0, w = 0, f = 0, n = 0, k = 0, F = 0, N = 0, S = 0, G = 0, M = 0;
                                        return h = g = h - 512 | 0, C = -1, Q = a[I + 31 | 0], B = a[0 | I], 1 & (((255 & (127 & (-1 ^ Q) | a[I + 1 | 0] & a[I + 2 | 0] & a[I + 3 | 0] & a[I + 4 | 0] & a[I + 5 | 0] & a[I + 6 | 0] & a[I + 7 | 0] & a[I + 8 | 0] & a[I + 9 | 0] & a[I + 10 | 0] & a[I + 11 | 0] & a[I + 12 | 0] & a[I + 13 | 0] & a[I + 14 | 0] & a[I + 15 | 0] & a[I + 16 | 0] & a[I + 17 | 0] & a[I + 18 | 0] & a[I + 19 | 0] & a[I + 20 | 0] & a[I + 21 | 0] & a[I + 22 | 0] & a[I + 23 | 0] & a[I + 24 | 0] & a[I + 25 | 0] & a[I + 26 | 0] & a[I + 27 | 0] & a[I + 28 | 0] & a[I + 29 | 0] & a[I + 30 | 0] ^ -1)) - 1 & 236 - B) >>> 8 | B | Q >>> 7) || (pA(Q = g + 336 | 0, I), v(g + 288 | 0, Q), I = E[g + 324 >> 2], E[g + 276 >> 2] = 0 - I, C = E[g + 320 >> 2], E[g + 272 >> 2] = 0 - C, B = E[g + 316 >> 2], E[g + 268 >> 2] = 0 - B, i = E[g + 312 >> 2], E[g + 264 >> 2] = 0 - i, _ = E[g + 308 >> 2], E[g + 260 >> 2] = 0 - _, c = E[g + 304 >> 2], E[g + 256 >> 2] = 0 - c, t = E[g + 300 >> 2], E[g + 252 >> 2] = 0 - t, r = E[g + 296 >> 2], E[g + 248 >> 2] = 0 - r, e = E[g + 292 >> 2], E[g + 244 >> 2] = 0 - e, y = E[g + 288 >> 2], E[g + 240 >> 2] = 1 - y, v(s = g + 144 | 0, w = g + 240 | 0), E[g + 228 >> 2] = I, E[g + 224 >> 2] = C, E[g + 220 >> 2] = B, E[g + 216 >> 2] = i, E[g + 212 >> 2] = _, E[g + 208 >> 2] = c, E[g + 204 >> 2] = t, E[g + 200 >> 2] = r, E[g + 196 >> 2] = e, E[g + 192 >> 2] = y + 1, v(C = g + 96 | 0, i = g + 192 | 0), Y(I = g + 48 | 0, 1600, s), B = E[g + 96 >> 2], _ = E[g + 48 >> 2], c = E[g + 100 >> 2], t = E[g + 52 >> 2], r = E[g + 104 >> 2], e = E[g + 56 >> 2], y = E[g + 108 >> 2], s = E[g + 60 >> 2], D = E[g + 112 >> 2], p = E[g + 64 >> 2], f = E[g + 116 >> 2], n = E[g + 68 >> 2], k = E[g + 120 >> 2], F = E[g + 72 >> 2], N = E[g + 124 >> 2], S = E[g + 76 >> 2], G = E[g + 128 >> 2], M = E[g + 80 >> 2], E[g + 84 >> 2] = 0 - (E[g + 84 >> 2] + E[g + 132 >> 2] | 0), E[g + 80 >> 2] = 0 - (G + M | 0), E[g + 76 >> 2] = 0 - (N + S | 0), E[g + 72 >> 2] = 0 - (k + F | 0), E[g + 68 >> 2] = 0 - (f + n | 0), E[g + 64 >> 2] = 0 - (D + p | 0), E[g + 60 >> 2] = 0 - (y + s | 0), E[g + 56 >> 2] = 0 - (r + e | 0), E[g + 52 >> 2] = 0 - (c + t | 0), E[g + 48 >> 2] = 0 - (B + _ | 0), Y(g, I, C), E[g + 404 >> 2] = 0, E[g + 408 >> 2] = 0, E[g + 412 >> 2] = 0, E[g + 416 >> 2] = 0, E[g + 420 >> 2] = 0, E[g + 388 >> 2] = 0, E[g + 392 >> 2] = 0, E[g + 384 >> 2] = 1, E[g + 396 >> 2] = 0, E[g + 400 >> 2] = 0, p = GA(B = g + 432 | 0, g + 384 | 0, g), Y(A, B, i), Y(C = A + 40 | 0, B, A), Y(C, C, I), Y(A, A, Q), Q = E[A + 36 >> 2] << 1, E[A + 36 >> 2] = Q, B = E[A + 32 >> 2] << 1, E[A + 32 >> 2] = B, i = E[A + 28 >> 2] << 1, E[A + 28 >> 2] = i, _ = E[A + 24 >> 2] << 1, E[A + 24 >> 2] = _, c = E[A + 20 >> 2] << 1, E[A + 20 >> 2] = c, t = E[A + 16 >> 2] << 1, E[A + 16 >> 2] = t, r = E[A + 12 >> 2] << 1, E[A + 12 >> 2] = r, e = E[A + 8 >> 2] << 1, E[A + 8 >> 2] = e, y = E[A + 4 >> 2] << 1, E[A + 4 >> 2] = y, s = E[A >> 2] << 1, E[A >> 2] = s, BI(D = g + 480 | 0, A), I = 0 - (1 & o[g + 480 | 0]) | 0, E[A + 36 >> 2] = Q ^ I & (Q ^ 0 - Q), E[A + 32 >> 2] = B ^ I & (B ^ 0 - B), E[A + 28 >> 2] = i ^ I & (i ^ 0 - i), E[A + 24 >> 2] = _ ^ I & (_ ^ 0 - _), E[A + 20 >> 2] = c ^ I & (c ^ 0 - c), E[A + 16 >> 2] = t ^ I & (t ^ 0 - t), E[A + 12 >> 2] = r ^ I & (r ^ 0 - r), E[A + 8 >> 2] = e ^ I & (e ^ 0 - e), E[A + 4 >> 2] = y ^ I & (y ^ 0 - y), E[A >> 2] = s ^ I & (s ^ 0 - s), Y(C, w, C), E[A + 84 >> 2] = 0, E[A + 88 >> 2] = 0, E[A + 80 >> 2] = 1, E[A + 92 >> 2] = 0, E[A + 96 >> 2] = 0, E[A + 100 >> 2] = 0, E[A + 104 >> 2] = 0, E[A + 108 >> 2] = 0, E[A + 112 >> 2] = 0, E[A + 116 >> 2] = 0, Y(I = A + 120 | 0, A, C), BI(D, I), A = a[g + 480 | 0], BI(D, C), C = 0 - (NI(D, 32) | 1 - p | 1 & A) | 0), h = g + 512 | 0, C;
                                    }
                                    function aA(A, I, g, C) {
                                        var B, Q = 0, i = 0;
                                        B = Q = h, h = Q = Q - 576 & -64, E[Q + 188 >> 2] = I;
                                        A: if (I >>> 0 <= 64) {
                                            if ((0 | eA(i = Q + 192 | 0, 0, 0, I)) < 0) break A;
                                            if ((0 | XA(i, Q + 188 | 0, 4, 0)) < 0) break A;
                                            if ((0 | XA(i, g, C, 0)) < 0) break A;
                                            Yg(i, A, I);
                                        } else if (!((0 | eA(i = Q + 192 | 0, 0, 0, 64)) < 0 || (0 | XA(i, Q + 188 | 0, 4, 0)) < 0 || (0 | XA(i, g, C, 0)) < 0 || (0 | Yg(i, Q + 112 | 0, 64)) < 0)) {
                                            if (g = E[Q + 116 >> 2], C = E[Q + 112 >> 2], o[0 | A] = C, o[A + 1 | 0] = C >>> 8, o[A + 2 | 0] = C >>> 16, o[A + 3 | 0] = C >>> 24, o[A + 4 | 0] = g, o[A + 5 | 0] = g >>> 8, o[A + 6 | 0] = g >>> 16, o[A + 7 | 0] = g >>> 24, g = E[Q + 124 >> 2], C = E[Q + 120 >> 2], o[A + 8 | 0] = C, o[A + 9 | 0] = C >>> 8, o[A + 10 | 0] = C >>> 16, o[A + 11 | 0] = C >>> 24, o[A + 12 | 0] = g, o[A + 13 | 0] = g >>> 8, o[A + 14 | 0] = g >>> 16, o[A + 15 | 0] = g >>> 24, g = E[Q + 140 >> 2], C = E[Q + 136 >> 2], o[A + 24 | 0] = C, o[A + 25 | 0] = C >>> 8, o[A + 26 | 0] = C >>> 16, o[A + 27 | 0] = C >>> 24, o[A + 28 | 0] = g, o[A + 29 | 0] = g >>> 8, o[A + 30 | 0] = g >>> 16, o[A + 31 | 0] = g >>> 24, g = E[Q + 132 >> 2], C = E[Q + 128 >> 2], o[A + 16 | 0] = C, o[A + 17 | 0] = C >>> 8, o[A + 18 | 0] = C >>> 16, o[A + 19 | 0] = C >>> 24, o[A + 20 | 0] = g, o[A + 21 | 0] = g >>> 8, o[A + 22 | 0] = g >>> 16, o[A + 23 | 0] = g >>> 24, A = A + 32 | 0, (I = I - 32 | 0) >>> 0 >= 65) for(;;){
                                                if (g = E[Q + 172 >> 2], E[Q + 104 >> 2] = E[Q + 168 >> 2], E[Q + 108 >> 2] = g, g = E[Q + 164 >> 2], E[Q + 96 >> 2] = E[Q + 160 >> 2], E[Q + 100 >> 2] = g, g = E[Q + 156 >> 2], E[Q + 88 >> 2] = E[Q + 152 >> 2], E[Q + 92 >> 2] = g, g = E[Q + 148 >> 2], E[Q + 80 >> 2] = E[Q + 144 >> 2], E[Q + 84 >> 2] = g, g = E[Q + 140 >> 2], E[Q + 72 >> 2] = E[Q + 136 >> 2], E[Q + 76 >> 2] = g, C = E[Q + 132 >> 2], E[(g = Q - -64 | 0) >> 2] = E[Q + 128 >> 2], E[g + 4 >> 2] = C, g = E[Q + 124 >> 2], E[Q + 56 >> 2] = E[Q + 120 >> 2], E[Q + 60 >> 2] = g, g = E[Q + 116 >> 2], E[Q + 48 >> 2] = E[Q + 112 >> 2], E[Q + 52 >> 2] = g, (0 | lA(Q + 112 | 0, 64, Q + 48 | 0, 64, 0, 0, 0)) < 0) break A;
                                                if (g = E[Q + 116 >> 2], C = E[Q + 112 >> 2], o[0 | A] = C, o[A + 1 | 0] = C >>> 8, o[A + 2 | 0] = C >>> 16, o[A + 3 | 0] = C >>> 24, o[A + 4 | 0] = g, o[A + 5 | 0] = g >>> 8, o[A + 6 | 0] = g >>> 16, o[A + 7 | 0] = g >>> 24, g = E[Q + 124 >> 2], C = E[Q + 120 >> 2], o[A + 8 | 0] = C, o[A + 9 | 0] = C >>> 8, o[A + 10 | 0] = C >>> 16, o[A + 11 | 0] = C >>> 24, o[A + 12 | 0] = g, o[A + 13 | 0] = g >>> 8, o[A + 14 | 0] = g >>> 16, o[A + 15 | 0] = g >>> 24, g = E[Q + 140 >> 2], C = E[Q + 136 >> 2], o[A + 24 | 0] = C, o[A + 25 | 0] = C >>> 8, o[A + 26 | 0] = C >>> 16, o[A + 27 | 0] = C >>> 24, o[A + 28 | 0] = g, o[A + 29 | 0] = g >>> 8, o[A + 30 | 0] = g >>> 16, o[A + 31 | 0] = g >>> 24, g = E[Q + 132 >> 2], C = E[Q + 128 >> 2], o[A + 16 | 0] = C, o[A + 17 | 0] = C >>> 8, o[A + 18 | 0] = C >>> 16, o[A + 19 | 0] = C >>> 24, o[A + 20 | 0] = g, o[A + 21 | 0] = g >>> 8, o[A + 22 | 0] = g >>> 16, o[A + 23 | 0] = g >>> 24, A = A + 32 | 0, !((I = I - 32 | 0) >>> 0 > 64)) break;
                                            }
                                            g = E[Q + 172 >> 2], E[Q + 104 >> 2] = E[Q + 168 >> 2], E[Q + 108 >> 2] = g, g = E[Q + 164 >> 2], E[Q + 96 >> 2] = E[Q + 160 >> 2], E[Q + 100 >> 2] = g, g = E[Q + 156 >> 2], E[Q + 88 >> 2] = E[Q + 152 >> 2], E[Q + 92 >> 2] = g, g = E[Q + 148 >> 2], E[Q + 80 >> 2] = E[Q + 144 >> 2], E[Q + 84 >> 2] = g, g = E[Q + 140 >> 2], E[Q + 72 >> 2] = E[Q + 136 >> 2], E[Q + 76 >> 2] = g, C = E[Q + 132 >> 2], E[(g = Q - -64 | 0) >> 2] = E[Q + 128 >> 2], E[g + 4 >> 2] = C, g = E[Q + 124 >> 2], E[Q + 56 >> 2] = E[Q + 120 >> 2], E[Q + 60 >> 2] = g, g = E[Q + 116 >> 2], E[Q + 48 >> 2] = E[Q + 112 >> 2], E[Q + 52 >> 2] = g, (0 | lA(g = Q + 112 | 0, I, Q + 48 | 0, 64, 0, 0, 0)) < 0 || Sg(A, g, I);
                                        }
                                        XC(Q + 192 | 0, 384), h = B;
                                    }
                                    function _A(A, I, g, C, B, Q, i, t, r, e, y) {
                                        var s = 0, D = 0, p = 0, f = 0, n = 0, k = 0, F = 0, N = 0, S = 0, G = 0, M = 0, b = 0, K = 0, H = 0, Y = 0, d = 0, J = 0;
                                        if (s = Ig(r, 0, t, 0), !(D = w) & s >>> 0 >= 1073741824 | D) return E[9392] = 22, -1;
                                        if (1 == (0 | i) | i >>> 0 > 1) return E[9392] = 22, -1;
                                        for(s = Q, f = i; s | f;)D = s, s &= s - 1, f &= f - !D, n = (k = k + 1 | 0) ? n : n + 1 | 0;
                                        if (!(!(w = n) & k >>> 0 < 2 & (!i & Q >>> 0 >= 2 | 0 != (0 | i)))) return E[9392] = 28, -1;
                                        if (!r || !t) return E[9392] = 28, -1;
                                        if (!(33554431 / (r >>> 0) >>> 0 < t >>> 0 | t >>> 0 > 16777215) & !i & Q >>> 0 <= 33554431 / (t >>> 0) >>> 0 && !((S = c(N = t << 7, r)) >>> 0 > (D = (k = c(Q, N)) + S | 0) >>> 0 || D >>> 0 > (s = (D + (t << 8) | 0) - -64 | 0) >>> 0)) {
                                            A: {
                                                if (s >>> 0 > _[A + 8 >> 2]) {
                                                    if (D = -1, vg(A)) break A;
                                                    if (h = f = h - 16 | 0, n = _I(f + 12 | 0, s), E[9392] = n, n = n ? 0 : E[f + 12 >> 2], E[A + 4 >> 2] = n, E[A >> 2] = n, E[A + 8 >> 2] = n ? s : 0, h = f + 16 | 0, !n) break A;
                                                }
                                                for(DI(I, g, C, B, M = E[A + 4 >> 2], S), d = (s = (G = S + M | 0) + k | 0) + (C = (A = t << 7) - 64 | 0) | 0, b = s + (t << 8) | 0, J = (f = A + s | 0) + C | 0, Y = Q - 1 | 0, n = t << 5;;){
                                                    for(k = c(N, H) + M | 0, D = 0; C = (A = D << 2) + k | 0, E[A + s >> 2] = a[0 | C] | a[C + 1 | 0] << 8 | a[C + 2 | 0] << 16 | a[C + 3 | 0] << 24, B = (C = 4 | A) + s | 0, C = C + k | 0, E[B >> 2] = a[0 | C] | a[C + 1 | 0] << 8 | a[C + 2 | 0] << 16 | a[C + 3 | 0] << 24, B = (C = 8 | A) + s | 0, C = C + k | 0, E[B >> 2] = a[0 | C] | a[C + 1 | 0] << 8 | a[C + 2 | 0] << 16 | a[C + 3 | 0] << 24, C = (A |= 12) + s | 0, A = A + k | 0, E[C >> 2] = a[0 | A] | a[A + 1 | 0] << 8 | a[A + 2 | 0] << 16 | a[A + 3 | 0] << 24, K = 0, C = 0, (0 | n) != (0 | (D = D + 4 | 0)););
                                                    for(B = 0, A = 0; Sg(G + (c(B, n) << 2) | 0, s, N), tA(s, f, b, t), Sg(G + (c(n, 1 | B) << 2) | 0, f, N), tA(f, s, b, t), (0 | i) == (0 | (A = (B = B + 2 | 0) >>> 0 < 2 ? A + 1 | 0 : A)) & B >>> 0 < Q >>> 0 | A >>> 0 < i >>> 0;);
                                                    for(;;){
                                                        for(A = G + (c(n, Y & E[d >> 2]) << 2) | 0, D = 0; E[(p = (B = D << 2) + s | 0) >> 2] = E[p >> 2] ^ E[A + B >> 2], E[(F = (p = 4 | B) + s | 0) >> 2] = E[F >> 2] ^ E[A + p >> 2], E[(F = (p = 8 | B) + s | 0) >> 2] = E[F >> 2] ^ E[A + p >> 2], E[(p = (B |= 12) + s | 0) >> 2] = E[p >> 2] ^ E[A + B >> 2], (0 | n) != (0 | (D = D + 4 | 0)););
                                                        for(tA(s, f, b, t), A = G + (c(n, Y & E[J >> 2]) << 2) | 0, D = 0; E[(p = (B = D << 2) + f | 0) >> 2] = E[p >> 2] ^ E[A + B >> 2], E[(F = (p = 4 | B) + f | 0) >> 2] = E[F >> 2] ^ E[A + p >> 2], E[(F = (p = 8 | B) + f | 0) >> 2] = E[F >> 2] ^ E[A + p >> 2], E[(p = (B |= 12) + f | 0) >> 2] = E[p >> 2] ^ E[A + B >> 2], (0 | n) != (0 | (D = D + 4 | 0)););
                                                        if (tA(f, s, b, t), D = 0, C = A = (K = K + 2 | 0) >>> 0 < 2 ? C + 1 | 0 : C, !((0 | i) == (0 | A) & Q >>> 0 > K >>> 0 | A >>> 0 < i >>> 0)) break;
                                                    }
                                                    for(; C = (A = D << 2) + k | 0, B = E[A + s >> 2], o[0 | C] = B, o[C + 1 | 0] = B >>> 8, o[C + 2 | 0] = B >>> 16, o[C + 3 | 0] = B >>> 24, C = (B = 4 | A) + k | 0, B = E[B + s >> 2], o[0 | C] = B, o[C + 1 | 0] = B >>> 8, o[C + 2 | 0] = B >>> 16, o[C + 3 | 0] = B >>> 24, C = (B = 8 | A) + k | 0, B = E[B + s >> 2], o[0 | C] = B, o[C + 1 | 0] = B >>> 8, o[C + 2 | 0] = B >>> 16, o[C + 3 | 0] = B >>> 24, A = (C = 12 | A) + k | 0, C = E[C + s >> 2], o[0 | A] = C, o[A + 1 | 0] = C >>> 8, o[A + 2 | 0] = C >>> 16, o[A + 3 | 0] = C >>> 24, (0 | n) != (0 | (D = D + 4 | 0)););
                                                    if ((0 | (H = H + 1 | 0)) == (0 | r)) break;
                                                }
                                                DI(I, g, M, S, e, y), D = 0;
                                            }
                                            return D;
                                        }
                                        return E[9392] = 48, -1;
                                    }
                                    function cA(A, I, g) {
                                        A |= 0, I |= 0, g |= 0;
                                        var C, B, Q, i = 0;
                                        h = C = h - 192 | 0, E[C + 96 >> 2] = 0, E[C + 100 >> 2] = 0, E[C + 104 >> 2] = 0, E[C + 108 >> 2] = 0, E[C + 112 >> 2] = 0, E[C + 116 >> 2] = 0, E[C + 120 >> 2] = 0, E[C + 124 >> 2] = 0, i = a[I + 20 | 0] | a[I + 21 | 0] << 8 | a[I + 22 | 0] << 16 | a[I + 23 | 0] << 24, E[C + 80 >> 2] = a[I + 16 | 0] | a[I + 17 | 0] << 8 | a[I + 18 | 0] << 16 | a[I + 19 | 0] << 24, E[C + 84 >> 2] = i, i = a[I + 28 | 0] | a[I + 29 | 0] << 8 | a[I + 30 | 0] << 16 | a[I + 31 | 0] << 24, E[C + 88 >> 2] = a[I + 24 | 0] | a[I + 25 | 0] << 8 | a[I + 26 | 0] << 16 | a[I + 27 | 0] << 24, E[C + 92 >> 2] = i, B = a[I + 8 | 0] | a[I + 9 | 0] << 8 | a[I + 10 | 0] << 16 | a[I + 11 | 0] << 24, Q = a[I + 12 | 0] | a[I + 13 | 0] << 8 | a[I + 14 | 0] << 16 | a[I + 15 | 0] << 24, i = a[0 | I] | a[I + 1 | 0] << 8 | a[I + 2 | 0] << 16 | a[I + 3 | 0] << 24, I = a[I + 4 | 0] | a[I + 5 | 0] << 8 | a[I + 6 | 0] << 16 | a[I + 7 | 0] << 24, E[C + 40 >> 2] = 0, E[C + 44 >> 2] = 0, E[C + 48 >> 2] = 0, E[C + 52 >> 2] = 0, E[C + 56 >> 2] = 0, E[C + 60 >> 2] = 0, E[C + 64 >> 2] = i, E[C + 68 >> 2] = I, E[C + 72 >> 2] = B, E[C + 76 >> 2] = Q, E[C + 32 >> 2] = 0, E[C + 36 >> 2] = 0, I = a[g + 20 | 0] | a[g + 21 | 0] << 8 | a[g + 22 | 0] << 16 | a[g + 23 | 0] << 24, E[C + 16 >> 2] = a[g + 16 | 0] | a[g + 17 | 0] << 8 | a[g + 18 | 0] << 16 | a[g + 19 | 0] << 24, E[C + 20 >> 2] = I, I = a[g + 28 | 0] | a[g + 29 | 0] << 8 | a[g + 30 | 0] << 16 | a[g + 31 | 0] << 24, E[C + 24 >> 2] = a[g + 24 | 0] | a[g + 25 | 0] << 8 | a[g + 26 | 0] << 16 | a[g + 27 | 0] << 24, E[C + 28 >> 2] = I, I = a[g + 4 | 0] | a[g + 5 | 0] << 8 | a[g + 6 | 0] << 16 | a[g + 7 | 0] << 24, E[C >> 2] = a[0 | g] | a[g + 1 | 0] << 8 | a[g + 2 | 0] << 16 | a[g + 3 | 0] << 24, E[C + 4 >> 2] = I, I = a[g + 12 | 0] | a[g + 13 | 0] << 8 | a[g + 14 | 0] << 16 | a[g + 15 | 0] << 24, E[C + 8 >> 2] = a[g + 8 | 0] | a[g + 9 | 0] << 8 | a[g + 10 | 0] << 16 | a[g + 11 | 0] << 24, E[C + 12 >> 2] = I, og(C - -64 | 0, C), g = E[C + 124 >> 2], E[C + 184 >> 2] = E[C + 120 >> 2], E[C + 188 >> 2] = g, I = E[C + 116 >> 2], E[C + 176 >> 2] = E[C + 112 >> 2], E[C + 180 >> 2] = I, I = E[C + 108 >> 2], E[C + 168 >> 2] = E[C + 104 >> 2], E[C + 172 >> 2] = I, I = E[C + 100 >> 2], E[C + 160 >> 2] = E[C + 96 >> 2], E[C + 164 >> 2] = I, I = E[C + 92 >> 2], E[C + 152 >> 2] = E[C + 88 >> 2], E[C + 156 >> 2] = I, I = E[C + 84 >> 2], E[C + 144 >> 2] = E[C + 80 >> 2], E[C + 148 >> 2] = I, I = E[C + 76 >> 2], E[C + 136 >> 2] = E[C + 72 >> 2], E[C + 140 >> 2] = I, I = E[C + 68 >> 2], E[C + 128 >> 2] = E[C + 64 >> 2], E[C + 132 >> 2] = I, N(I = C + 128 | 0), i = E[C + 156 >> 2], g = E[C + 152 >> 2], o[A + 24 | 0] = g, o[A + 25 | 0] = g >>> 8, o[A + 26 | 0] = g >>> 16, o[A + 27 | 0] = g >>> 24, o[A + 28 | 0] = i, o[A + 29 | 0] = i >>> 8, o[A + 30 | 0] = i >>> 16, o[A + 31 | 0] = i >>> 24, i = E[C + 148 >> 2], g = E[C + 144 >> 2], o[A + 16 | 0] = g, o[A + 17 | 0] = g >>> 8, o[A + 18 | 0] = g >>> 16, o[A + 19 | 0] = g >>> 24, o[A + 20 | 0] = i, o[A + 21 | 0] = i >>> 8, o[A + 22 | 0] = i >>> 16, o[A + 23 | 0] = i >>> 24, i = E[C + 140 >> 2], g = E[C + 136 >> 2], o[A + 8 | 0] = g, o[A + 9 | 0] = g >>> 8, o[A + 10 | 0] = g >>> 16, o[A + 11 | 0] = g >>> 24, o[A + 12 | 0] = i, o[A + 13 | 0] = i >>> 8, o[A + 14 | 0] = i >>> 16, o[A + 15 | 0] = i >>> 24, i = E[C + 132 >> 2], g = E[C + 128 >> 2], o[0 | A] = g, o[A + 1 | 0] = g >>> 8, o[A + 2 | 0] = g >>> 16, o[A + 3 | 0] = g >>> 24, o[A + 4 | 0] = i, o[A + 5 | 0] = i >>> 8, o[A + 6 | 0] = i >>> 16, o[A + 7 | 0] = i >>> 24, XC(I, 64), h = C + 192 | 0;
                                    }
                                    function tA(A, I, g, C) {
                                        var B = 0, Q = 0, i = 0, o = 0, a = 0;
                                        if (i = E[4 + (B = ((C << 7) + A | 0) - 64 | 0) >> 2], E[g >> 2] = E[B >> 2], E[g + 4 >> 2] = i, i = E[B + 60 >> 2], E[g + 56 >> 2] = E[B + 56 >> 2], E[g + 60 >> 2] = i, i = E[B + 52 >> 2], E[g + 48 >> 2] = E[B + 48 >> 2], E[g + 52 >> 2] = i, i = E[B + 44 >> 2], E[g + 40 >> 2] = E[B + 40 >> 2], E[g + 44 >> 2] = i, i = E[B + 36 >> 2], E[g + 32 >> 2] = E[B + 32 >> 2], E[g + 36 >> 2] = i, i = E[B + 28 >> 2], E[g + 24 >> 2] = E[B + 24 >> 2], E[g + 28 >> 2] = i, i = E[B + 20 >> 2], E[g + 16 >> 2] = E[B + 16 >> 2], E[g + 20 >> 2] = i, i = E[B + 12 >> 2], E[g + 8 >> 2] = E[B + 8 >> 2], E[g + 12 >> 2] = i, C) for(i = C << 1, a = C << 4, C = 0; B = (Q = C << 6) + A | 0, E[g >> 2] = E[g >> 2] ^ E[B >> 2], E[g + 4 >> 2] = E[g + 4 >> 2] ^ E[B + 4 >> 2], E[g + 8 >> 2] = E[g + 8 >> 2] ^ E[B + 8 >> 2], E[g + 12 >> 2] = E[g + 12 >> 2] ^ E[B + 12 >> 2], E[g + 16 >> 2] = E[g + 16 >> 2] ^ E[B + 16 >> 2], E[g + 20 >> 2] = E[g + 20 >> 2] ^ E[B + 20 >> 2], E[g + 24 >> 2] = E[g + 24 >> 2] ^ E[B + 24 >> 2], E[g + 28 >> 2] = E[g + 28 >> 2] ^ E[B + 28 >> 2], E[g + 32 >> 2] = E[g + 32 >> 2] ^ E[B + 32 >> 2], E[g + 36 >> 2] = E[g + 36 >> 2] ^ E[B + 36 >> 2], E[g + 40 >> 2] = E[g + 40 >> 2] ^ E[B + 40 >> 2], E[g + 44 >> 2] = E[g + 44 >> 2] ^ E[B + 44 >> 2], E[g + 48 >> 2] = E[g + 48 >> 2] ^ E[B + 48 >> 2], E[g + 52 >> 2] = E[g + 52 >> 2] ^ E[B + 52 >> 2], E[g + 56 >> 2] = E[g + 56 >> 2] ^ E[B + 56 >> 2], E[g + 60 >> 2] = E[g + 60 >> 2] ^ E[B + 60 >> 2], OA(g), o = E[g + 60 >> 2], E[56 + (B = (C << 5) + I | 0) >> 2] = E[g + 56 >> 2], E[B + 60 >> 2] = o, o = E[g + 52 >> 2], E[B + 48 >> 2] = E[g + 48 >> 2], E[B + 52 >> 2] = o, o = E[g + 44 >> 2], E[B + 40 >> 2] = E[g + 40 >> 2], E[B + 44 >> 2] = o, o = E[g + 36 >> 2], E[B + 32 >> 2] = E[g + 32 >> 2], E[B + 36 >> 2] = o, o = E[g + 28 >> 2], E[B + 24 >> 2] = E[g + 24 >> 2], E[B + 28 >> 2] = o, o = E[g + 20 >> 2], E[B + 16 >> 2] = E[g + 16 >> 2], E[B + 20 >> 2] = o, o = E[g + 12 >> 2], E[B + 8 >> 2] = E[g + 8 >> 2], E[B + 12 >> 2] = o, o = E[g + 4 >> 2], E[B >> 2] = E[g >> 2], E[B + 4 >> 2] = o, B = (64 | Q) + A | 0, E[g >> 2] = E[g >> 2] ^ E[B >> 2], E[g + 4 >> 2] = E[g + 4 >> 2] ^ E[B + 4 >> 2], E[g + 8 >> 2] = E[g + 8 >> 2] ^ E[B + 8 >> 2], E[g + 12 >> 2] = E[g + 12 >> 2] ^ E[B + 12 >> 2], E[g + 16 >> 2] = E[g + 16 >> 2] ^ E[B + 16 >> 2], E[g + 20 >> 2] = E[g + 20 >> 2] ^ E[B + 20 >> 2], E[g + 24 >> 2] = E[g + 24 >> 2] ^ E[B + 24 >> 2], E[g + 28 >> 2] = E[g + 28 >> 2] ^ E[B + 28 >> 2], E[g + 32 >> 2] = E[g + 32 >> 2] ^ E[B + 32 >> 2], E[g + 36 >> 2] = E[g + 36 >> 2] ^ E[B + 36 >> 2], E[g + 40 >> 2] = E[g + 40 >> 2] ^ E[B + 40 >> 2], E[g + 44 >> 2] = E[g + 44 >> 2] ^ E[B + 44 >> 2], E[g + 48 >> 2] = E[g + 48 >> 2] ^ E[B + 48 >> 2], E[g + 52 >> 2] = E[g + 52 >> 2] ^ E[B + 52 >> 2], E[g + 56 >> 2] = E[g + 56 >> 2] ^ E[B + 56 >> 2], E[g + 60 >> 2] = E[g + 60 >> 2] ^ E[B + 60 >> 2], OA(g), Q = E[g + 60 >> 2], E[56 + (B = ((C << 3) + a << 2) + I | 0) >> 2] = E[g + 56 >> 2], E[B + 60 >> 2] = Q, Q = E[g + 52 >> 2], E[B + 48 >> 2] = E[g + 48 >> 2], E[B + 52 >> 2] = Q, Q = E[g + 44 >> 2], E[B + 40 >> 2] = E[g + 40 >> 2], E[B + 44 >> 2] = Q, Q = E[g + 36 >> 2], E[B + 32 >> 2] = E[g + 32 >> 2], E[B + 36 >> 2] = Q, Q = E[g + 28 >> 2], E[B + 24 >> 2] = E[g + 24 >> 2], E[B + 28 >> 2] = Q, Q = E[g + 20 >> 2], E[B + 16 >> 2] = E[g + 16 >> 2], E[B + 20 >> 2] = Q, Q = E[g + 12 >> 2], E[B + 8 >> 2] = E[g + 8 >> 2], E[B + 12 >> 2] = Q, Q = E[g + 4 >> 2], E[B >> 2] = E[g >> 2], E[B + 4 >> 2] = Q, i >>> 0 > (C = C + 2 | 0) >>> 0;);
                                    }
                                    function rA(A, I, g, C) {
                                        var B = 0, Q = 0, i = 0, o = 0, _ = 0, t = 0, r = 0, e = 0, y = 0, s = 0, h = 0, D = 0, p = 0, f = 0, n = 0, k = 0, F = 0, N = 0, S = 0, G = 0, M = 0, b = 0, K = 0, H = 0, Y = 0;
                                        if (h = E[A + 36 >> 2], y = E[A + 32 >> 2], s = E[A + 28 >> 2], r = E[A + 24 >> 2], e = E[A + 20 >> 2], !C & g >>> 0 >= 16 | C) for(M = !a[A + 80 | 0] << 24, p = E[A + 4 >> 2], b = c(p, 5), n = E[A + 8 >> 2], S = c(n, 5), F = E[A + 12 >> 2], N = c(F, 5), G = E[A + 16 >> 2], k = c(G, 5), f = E[A >> 2]; B = Ig(i = ((a[I + 3 | 0] | a[I + 4 | 0] << 8 | a[I + 5 | 0] << 16 | a[I + 6 | 0] << 24) >>> 2 & 67108863) + r | 0, 0, F, 0), _ = w, e = (o = Ig(r = (67108863 & (a[0 | I] | a[I + 1 | 0] << 8 | a[I + 2 | 0] << 16 | a[I + 3 | 0] << 24)) + e | 0, 0, G, 0)) + B | 0, B = w + _ | 0, B = o >>> 0 > e >>> 0 ? B + 1 | 0 : B, _ = Ig(s = ((a[I + 6 | 0] | a[I + 7 | 0] << 8 | a[I + 8 | 0] << 16 | a[I + 9 | 0] << 24) >>> 4 & 67108863) + s | 0, 0, n, 0), B = w + B | 0, B = _ >>> 0 > (e = _ + e | 0) >>> 0 ? B + 1 | 0 : B, _ = Ig(y = ((a[I + 9 | 0] | a[I + 10 | 0] << 8 | a[I + 11 | 0] << 16 | a[I + 12 | 0] << 24) >>> 6 | 0) + y | 0, 0, p, 0), B = w + B | 0, B = _ >>> 0 > (e = _ + e | 0) >>> 0 ? B + 1 | 0 : B, _ = Ig(h = h + M + ((a[I + 12 | 0] | a[I + 13 | 0] << 8 | a[I + 14 | 0] << 16 | a[I + 15 | 0] << 24) >>> 8) | 0, 0, f, 0), B = w + B | 0, K = e = _ + e | 0, e = _ >>> 0 > e >>> 0 ? B + 1 | 0 : B, B = Ig(i, 0, n, 0), _ = w, o = Ig(r, 0, F, 0), Q = w + _ | 0, Q = (B = o + B | 0) >>> 0 < o >>> 0 ? Q + 1 | 0 : Q, _ = (o = Ig(s, 0, p, 0)) + B | 0, B = w + Q | 0, B = o >>> 0 > _ >>> 0 ? B + 1 | 0 : B, o = Ig(y, 0, f, 0), B = w + B | 0, B = o >>> 0 > (_ = o + _ | 0) >>> 0 ? B + 1 | 0 : B, o = Ig(h, 0, k, 0), B = w + B | 0, H = _ = o + _ | 0, _ = o >>> 0 > _ >>> 0 ? B + 1 | 0 : B, B = Ig(i, 0, p, 0), t = w, o = (Q = Ig(r, 0, n, 0)) + B | 0, B = w + t | 0, B = Q >>> 0 > o >>> 0 ? B + 1 | 0 : B, t = Ig(s, 0, f, 0), Q = w + B | 0, Q = (o = t + o | 0) >>> 0 < t >>> 0 ? Q + 1 | 0 : Q, t = Ig(y, 0, k, 0), B = w + Q | 0, B = (o = t + o | 0) >>> 0 < t >>> 0 ? B + 1 | 0 : B, t = Ig(h, 0, N, 0), B = w + B | 0, Y = o = t + o | 0, o = o >>> 0 < t >>> 0 ? B + 1 | 0 : B, B = Ig(i, 0, f, 0), Q = w, t = (D = Ig(r, 0, p, 0)) + B | 0, B = w + Q | 0, B = t >>> 0 < D >>> 0 ? B + 1 | 0 : B, Q = Ig(s, 0, k, 0), B = w + B | 0, B = Q >>> 0 > (t = Q + t | 0) >>> 0 ? B + 1 | 0 : B, D = Ig(y, 0, N, 0), Q = w + B | 0, Q = (t = D + t | 0) >>> 0 < D >>> 0 ? Q + 1 | 0 : Q, D = Ig(h, 0, S, 0), B = w + Q | 0, B = (t = D + t | 0) >>> 0 < D >>> 0 ? B + 1 | 0 : B, D = t, t = B, B = Ig(i, 0, k, 0), Q = w, i = (r = Ig(r, 0, f, 0)) + B | 0, B = w + Q | 0, B = i >>> 0 < r >>> 0 ? B + 1 | 0 : B, r = Ig(s, 0, N, 0), B = w + B | 0, B = (i = r + i | 0) >>> 0 < r >>> 0 ? B + 1 | 0 : B, r = Ig(y, 0, S, 0), B = w + B | 0, B = (i = r + i | 0) >>> 0 < r >>> 0 ? B + 1 | 0 : B, r = Ig(h, 0, b, 0), Q = w + B | 0, Q = (i = r + i | 0) >>> 0 < r >>> 0 ? Q + 1 | 0 : Q, r = i, B = t, B = (i = (s = (67108863 & Q) << 6 | i >>> 26) + D | 0) >>> 0 < s >>> 0 ? B + 1 | 0 : B, s = i, y = (67108863 & B) << 6 | i >>> 26, B = o, B = (i = y + Y | 0) >>> 0 < y >>> 0 ? B + 1 | 0 : B, y = i, Q = _, h = B = (i = (67108863 & B) << 6 | i >>> 26) + H | 0, _ = (67108863 & (Q = B >>> 0 < i >>> 0 ? Q + 1 | 0 : Q)) << 6 | B >>> 26, B = e, r = (67108863 & s) + ((B = c((67108863 & ((i = _ + K | 0) >>> 0 < _ >>> 0 ? B + 1 | 0 : B)) << 6 | i >>> 26, 5) + (67108863 & r) | 0) >>> 26 | 0) | 0, s = 67108863 & y, y = 67108863 & h, h = 67108863 & i, e = 67108863 & B, I = I + 16 | 0, !(C = C - (g >>> 0 < 16) | 0) & (g = g - 16 | 0) >>> 0 > 15 | C;);
                                        E[A + 20 >> 2] = e, E[A + 36 >> 2] = h, E[A + 32 >> 2] = y, E[A + 28 >> 2] = s, E[A + 24 >> 2] = r;
                                    }
                                    function eA(A, I, g, C) {
                                        A |= 0, I |= 0;
                                        var B = 0;
                                        return B = -1, (C |= 0) - 65 >>> 0 < 4294967232 | (g |= 0) >>> 0 > 64 || (g && I ? (h = B = h - 128 | 0, !I | ((C &= 255) - 65 & 255) >>> 0 <= 191 | ((g &= 255) - 65 & 255) >>> 0 <= 191 ? (yC(), Q()) : (Hg(A - -64 | 0, 0, 293), o[A + 56 | 0] = 121, o[A + 57 | 0] = 33, o[A + 58 | 0] = 126, o[A + 59 | 0] = 19, o[A + 60 | 0] = 25, o[A + 61 | 0] = 205, o[A + 62 | 0] = 224, o[A + 63 | 0] = 91, o[A + 48 | 0] = 107, o[A + 49 | 0] = 189, o[A + 50 | 0] = 65, o[A + 51 | 0] = 251, o[A + 52 | 0] = 171, o[A + 53 | 0] = 217, o[A + 54 | 0] = 131, o[A + 55 | 0] = 31, o[A + 40 | 0] = 31, o[A + 41 | 0] = 108, o[A + 42 | 0] = 62, o[A + 43 | 0] = 43, o[A + 44 | 0] = 140, o[A + 45 | 0] = 104, o[A + 46 | 0] = 5, o[A + 47 | 0] = 155, o[A + 32 | 0] = 209, o[A + 33 | 0] = 130, o[A + 34 | 0] = 230, o[A + 35 | 0] = 173, o[A + 36 | 0] = 127, o[A + 37 | 0] = 82, o[A + 38 | 0] = 14, o[A + 39 | 0] = 81, o[A + 24 | 0] = 241, o[A + 25 | 0] = 54, o[A + 26 | 0] = 29, o[A + 27 | 0] = 95, o[A + 28 | 0] = 58, o[A + 29 | 0] = 245, o[A + 30 | 0] = 79, o[A + 31 | 0] = 165, o[A + 16 | 0] = 43, o[A + 17 | 0] = 248, o[A + 18 | 0] = 148, o[A + 19 | 0] = 254, o[A + 20 | 0] = 114, o[A + 21 | 0] = 243, o[A + 22 | 0] = 110, o[A + 23 | 0] = 60, o[A + 8 | 0] = 59, o[A + 9 | 0] = 167, o[A + 10 | 0] = 202, o[A + 11 | 0] = 132, o[A + 12 | 0] = 133, o[A + 13 | 0] = 174, o[A + 14 | 0] = 103, o[A + 15 | 0] = 187, C = -222443256 ^ (g << 8 | C), o[0 | A] = C, o[A + 1 | 0] = C >>> 8, o[A + 2 | 0] = C >>> 16, o[A + 3 | 0] = C >>> 24, C = g >>> 24 ^ 1779033703, o[A + 4 | 0] = C, o[A + 5 | 0] = C >>> 8, o[A + 6 | 0] = C >>> 16, o[A + 7 | 0] = C >>> 24, Hg(g + B | 0, 0, g << 24 >> 24 >= 0 ? 128 - g | 0 : 0), g = Sg(B, I, g), Sg(A + 96 | 0, g, 128), I = 128 + (a[A + 352 | 0] | a[A + 353 | 0] << 8 | a[A + 354 | 0] << 16 | a[A + 355 | 0] << 24) | 0, o[A + 352 | 0] = I, o[A + 353 | 0] = I >>> 8, o[A + 354 | 0] = I >>> 16, o[A + 355 | 0] = I >>> 24, XC(g, 128), h = g + 128 | 0)) : (((I = 255 & C) - 65 & 255) >>> 0 <= 191 && (yC(), Q()), Hg(A - -64 | 0, 0, 293), o[A + 56 | 0] = 121, o[A + 57 | 0] = 33, o[A + 58 | 0] = 126, o[A + 59 | 0] = 19, o[A + 60 | 0] = 25, o[A + 61 | 0] = 205, o[A + 62 | 0] = 224, o[A + 63 | 0] = 91, o[A + 48 | 0] = 107, o[A + 49 | 0] = 189, o[A + 50 | 0] = 65, o[A + 51 | 0] = 251, o[A + 52 | 0] = 171, o[A + 53 | 0] = 217, o[A + 54 | 0] = 131, o[A + 55 | 0] = 31, o[A + 40 | 0] = 31, o[A + 41 | 0] = 108, o[A + 42 | 0] = 62, o[A + 43 | 0] = 43, o[A + 44 | 0] = 140, o[A + 45 | 0] = 104, o[A + 46 | 0] = 5, o[A + 47 | 0] = 155, o[A + 32 | 0] = 209, o[A + 33 | 0] = 130, o[A + 34 | 0] = 230, o[A + 35 | 0] = 173, o[A + 36 | 0] = 127, o[A + 37 | 0] = 82, o[A + 38 | 0] = 14, o[A + 39 | 0] = 81, o[A + 24 | 0] = 241, o[A + 25 | 0] = 54, o[A + 26 | 0] = 29, o[A + 27 | 0] = 95, o[A + 28 | 0] = 58, o[A + 29 | 0] = 245, o[A + 30 | 0] = 79, o[A + 31 | 0] = 165, o[A + 16 | 0] = 43, o[A + 17 | 0] = 248, o[A + 18 | 0] = 148, o[A + 19 | 0] = 254, o[A + 20 | 0] = 114, o[A + 21 | 0] = 243, o[A + 22 | 0] = 110, o[A + 23 | 0] = 60, o[A + 8 | 0] = 59, o[A + 9 | 0] = 167, o[A + 10 | 0] = 202, o[A + 11 | 0] = 132, o[A + 12 | 0] = 133, o[A + 13 | 0] = 174, o[A + 14 | 0] = 103, o[A + 15 | 0] = 187, I ^= -222443256, o[0 | A] = I, o[A + 1 | 0] = I >>> 8, o[A + 2 | 0] = I >>> 16, o[A + 3 | 0] = I >>> 24, o[A + 4 | 0] = 103, o[A + 5 | 0] = 230, o[A + 6 | 0] = 9, o[A + 7 | 0] = 106), B = 0), 0 | B;
                                    }
                                    function yA(A, I, g, C) {
                                        A |= 0, I |= 0, g |= 0;
                                        var B = 0, Q = 0, i = 0, E = 0, _ = 0, c = 0, t = 0, r = 0, e = 0, y = 0, s = 0, h = 0, D = 0, p = 0, w = 0, f = 0, n = 0, k = 0, F = 0;
                                        for((C |= 0) ? (Q = a[C + 8 | 0] | a[C + 9 | 0] << 8 | a[C + 10 | 0] << 16 | a[C + 11 | 0] << 24, i = a[C + 4 | 0] | a[C + 5 | 0] << 8 | a[C + 6 | 0] << 16 | a[C + 7 | 0] << 24, B = a[0 | C] | a[C + 1 | 0] << 8 | a[C + 2 | 0] << 16 | a[C + 3 | 0] << 24, t = a[C + 12 | 0] | a[C + 13 | 0] << 8 | a[C + 14 | 0] << 16 | a[C + 15 | 0] << 24) : (Q = 2036477234, i = 857760878, B = 1634760805, t = 1797285236), E = a[I + 12 | 0] | a[I + 13 | 0] << 8 | a[I + 14 | 0] << 16 | a[I + 15 | 0] << 24, e = a[I + 8 | 0] | a[I + 9 | 0] << 8 | a[I + 10 | 0] << 16 | a[I + 11 | 0] << 24, _ = a[I + 4 | 0] | a[I + 5 | 0] << 8 | a[I + 6 | 0] << 16 | a[I + 7 | 0] << 24, y = a[g + 28 | 0] | a[g + 29 | 0] << 8 | a[g + 30 | 0] << 16 | a[g + 31 | 0] << 24, c = a[g + 24 | 0] | a[g + 25 | 0] << 8 | a[g + 26 | 0] << 16 | a[g + 27 | 0] << 24, f = a[g + 20 | 0] | a[g + 21 | 0] << 8 | a[g + 22 | 0] << 16 | a[g + 23 | 0] << 24, s = a[g + 16 | 0] | a[g + 17 | 0] << 8 | a[g + 18 | 0] << 16 | a[g + 19 | 0] << 24, C = a[g + 12 | 0] | a[g + 13 | 0] << 8 | a[g + 14 | 0] << 16 | a[g + 15 | 0] << 24, h = a[g + 8 | 0] | a[g + 9 | 0] << 8 | a[g + 10 | 0] << 16 | a[g + 11 | 0] << 24, D = a[g + 4 | 0] | a[g + 5 | 0] << 8 | a[g + 6 | 0] << 16 | a[g + 7 | 0] << 24, I = a[0 | I] | a[I + 1 | 0] << 8 | a[I + 2 | 0] << 16 | a[I + 3 | 0] << 24, g = a[0 | g] | a[g + 1 | 0] << 8 | a[g + 2 | 0] << 16 | a[g + 3 | 0] << 24; r = g, g = Lg((p = I) ^ (I = g + B | 0), 16), r = s = Lg(r ^ (B = g + s | 0), 12), w = Lg((p = I + s | 0) ^ g, 8), I = Lg(r ^ (s = w + B | 0), 7), E = Lg((g = C + t | 0) ^ E, 16), C = Lg((y = E + y | 0) ^ C, 12), r = h, Q = Lg((t = Q + h | 0) ^ e, 16), B = Lg(r ^ (h = Q + c | 0), 12), c = Lg((c = Q) ^ (Q = B + t | 0), 8), g = Lg(c ^ (t = (n = g + C | 0) + I | 0), 16), e = Lg((i = i + D | 0) ^ _, 16), D = Lg((_ = e + f | 0) ^ D, 12), r = I, I = Lg((i = D + i | 0) ^ e, 8), r = Lg(r ^ (_ = (k = I + _ | 0) + g | 0), 12), e = Lg(g ^ (t = r + t | 0), 8), g = Lg((f = e + _ | 0) ^ r, 7), E = Lg(E ^ n, 8), C = Lg((y = E + y | 0) ^ C, 7), _ = Lg((Q = C + Q | 0) ^ I, 16), C = Lg((I = _ + s | 0) ^ C, 12), _ = Lg(_ ^ (Q = C + Q | 0), 8), C = Lg((s = I + _ | 0) ^ C, 7), I = Lg((c = c + h | 0) ^ B, 7), h = Lg((i = I + i | 0) ^ w, 16), w = Lg(I ^ (B = h + y | 0), 12), I = Lg(h ^ (i = w + i | 0), 8), h = Lg((y = B + I | 0) ^ w, 7), r = c, c = E, B = Lg(D ^ k, 7), c = Lg(c ^ (E = B + p | 0), 16), p = Lg(B ^ (D = r + c | 0), 12), E = Lg(c ^ (B = p + E | 0), 8), D = Lg((c = D + E | 0) ^ p, 7), 10 != (0 | (F = F + 1 | 0)););
                                        return o[0 | A] = B, o[A + 1 | 0] = B >>> 8, o[A + 2 | 0] = B >>> 16, o[A + 3 | 0] = B >>> 24, o[A + 28 | 0] = E, o[A + 29 | 0] = E >>> 8, o[A + 30 | 0] = E >>> 16, o[A + 31 | 0] = E >>> 24, o[A + 24 | 0] = e, o[A + 25 | 0] = e >>> 8, o[A + 26 | 0] = e >>> 16, o[A + 27 | 0] = e >>> 24, o[A + 20 | 0] = _, o[A + 21 | 0] = _ >>> 8, o[A + 22 | 0] = _ >>> 16, o[A + 23 | 0] = _ >>> 24, o[A + 16 | 0] = I, o[A + 17 | 0] = I >>> 8, o[A + 18 | 0] = I >>> 16, o[A + 19 | 0] = I >>> 24, o[A + 12 | 0] = t, o[A + 13 | 0] = t >>> 8, o[A + 14 | 0] = t >>> 16, o[A + 15 | 0] = t >>> 24, o[A + 8 | 0] = Q, o[A + 9 | 0] = Q >>> 8, o[A + 10 | 0] = Q >>> 16, o[A + 11 | 0] = Q >>> 24, o[A + 4 | 0] = i, o[A + 5 | 0] = i >>> 8, o[A + 6 | 0] = i >>> 16, o[A + 7 | 0] = i >>> 24, 0;
                                    }
                                    function sA(A, I, g) {
                                        var C, B, Q, i, o, a, _, c, t, r, e, y = 0, s = 0, h = 0, D = 0, p = 0, w = 0, f = 0, n = 0, k = 0, F = 0, N = 0, S = 0, G = 0, M = 0, b = 0, K = 0, H = 0, d = 0, J = 0;
                                        y = E[I + 40 >> 2], s = E[I + 4 >> 2], D = E[I + 44 >> 2], p = E[I + 8 >> 2], w = E[I + 48 >> 2], f = E[I + 12 >> 2], n = E[I + 52 >> 2], k = E[I + 16 >> 2], F = E[I + 56 >> 2], N = E[I + 20 >> 2], S = E[I + 60 >> 2], G = E[I + 24 >> 2], M = E[(h = I - -64 | 0) >> 2], b = E[I + 28 >> 2], K = E[I + 68 >> 2], H = E[I + 32 >> 2], d = E[I + 72 >> 2], J = E[I >> 2], E[A + 36 >> 2] = E[I + 36 >> 2] + E[I + 76 >> 2], E[A + 32 >> 2] = H + d, E[A + 28 >> 2] = b + K, E[A + 24 >> 2] = G + M, E[A + 20 >> 2] = N + S, E[A + 16 >> 2] = k + F, E[A + 12 >> 2] = f + n, E[A + 8 >> 2] = p + w, E[A + 4 >> 2] = s + D, E[A >> 2] = y + J, D = E[I + 40 >> 2], y = E[I + 4 >> 2], p = E[I + 44 >> 2], w = E[I + 8 >> 2], f = E[I + 48 >> 2], n = E[I + 12 >> 2], k = E[I + 52 >> 2], F = E[I + 16 >> 2], N = E[I + 56 >> 2], S = E[I + 20 >> 2], G = E[I + 60 >> 2], M = E[I + 24 >> 2], h = E[h >> 2], s = E[I + 28 >> 2], b = E[I + 68 >> 2], K = E[I + 32 >> 2], H = E[I + 72 >> 2], d = E[I >> 2], E[A + 76 >> 2] = E[I + 76 >> 2] - E[I + 36 >> 2], E[A + 72 >> 2] = H - K, E[A + 68 >> 2] = b - s, E[(s = A - -64 | 0) >> 2] = h - M, E[A + 60 >> 2] = G - S, E[A + 56 >> 2] = N - F, E[A + 52 >> 2] = k - n, E[A + 48 >> 2] = f - w, E[A + 44 >> 2] = p - y, E[(y = A + 40 | 0) >> 2] = D - d, Y(A + 80 | 0, A, g), Y(y, y, g + 40 | 0), Y(A + 120 | 0, g + 120 | 0, I + 120 | 0), Y(A, I + 80 | 0, g + 80 | 0), J = E[A + 4 >> 2], Q = E[A + 8 >> 2], i = E[A + 12 >> 2], o = E[A + 16 >> 2], a = E[A + 20 >> 2], _ = E[A + 24 >> 2], c = E[A + 28 >> 2], t = E[A + 32 >> 2], r = E[A + 36 >> 2], I = E[y >> 2], g = E[A + 80 >> 2], D = E[A + 44 >> 2], p = E[A + 84 >> 2], w = E[A + 48 >> 2], f = E[A + 88 >> 2], n = E[A + 52 >> 2], k = E[A + 92 >> 2], F = E[A + 56 >> 2], N = E[A + 96 >> 2], S = E[A + 60 >> 2], G = E[A + 100 >> 2], h = E[s >> 2], M = E[A + 104 >> 2], b = E[A + 68 >> 2], K = E[A + 108 >> 2], H = E[A + 72 >> 2], d = E[A + 112 >> 2], e = E[A >> 2], C = E[A + 76 >> 2], B = E[A + 116 >> 2], E[A + 76 >> 2] = C + B, E[A + 72 >> 2] = H + d, E[A + 68 >> 2] = b + K, E[s >> 2] = h + M, E[A + 60 >> 2] = S + G, E[A + 56 >> 2] = F + N, E[A + 52 >> 2] = n + k, E[A + 48 >> 2] = w + f, E[A + 44 >> 2] = D + p, E[y >> 2] = I + g, E[A + 36 >> 2] = B - C, E[A + 32 >> 2] = d - H, E[A + 28 >> 2] = K - b, E[A + 24 >> 2] = M - h, E[A + 20 >> 2] = G - S, E[A + 16 >> 2] = N - F, E[A + 12 >> 2] = k - n, E[A + 8 >> 2] = f - w, E[A + 4 >> 2] = p - D, E[A >> 2] = g - I, I = r << 1, g = E[A + 156 >> 2], E[A + 156 >> 2] = I - g, y = t << 1, s = E[A + 152 >> 2], E[A + 152 >> 2] = y - s, D = c << 1, p = E[A + 148 >> 2], E[A + 148 >> 2] = D - p, w = _ << 1, f = E[A + 144 >> 2], E[A + 144 >> 2] = w - f, n = a << 1, k = E[A + 140 >> 2], E[A + 140 >> 2] = n - k, F = o << 1, N = E[A + 136 >> 2], E[A + 136 >> 2] = F - N, S = i << 1, G = E[A + 132 >> 2], E[A + 132 >> 2] = S - G, h = Q << 1, M = E[A + 128 >> 2], E[A + 128 >> 2] = h - M, b = J << 1, K = E[A + 124 >> 2], E[A + 124 >> 2] = b - K, H = e << 1, d = E[A + 120 >> 2], E[A + 120 >> 2] = H - d, E[A + 112 >> 2] = y + s, E[A + 108 >> 2] = D + p, E[A + 104 >> 2] = w + f, E[A + 100 >> 2] = n + k, E[A + 96 >> 2] = F + N, E[A + 92 >> 2] = S + G, E[A + 88 >> 2] = h + M, E[A + 84 >> 2] = b + K, E[A + 80 >> 2] = H + d, E[A + 116 >> 2] = I + g;
                                    }
                                    function hA(A, I, g) {
                                        var C, B, Q, i, o, a, _, c, t, r, e, y = 0, s = 0, h = 0, D = 0, p = 0, w = 0, f = 0, n = 0, k = 0, F = 0, N = 0, S = 0, G = 0, M = 0, b = 0, K = 0, H = 0, d = 0, J = 0;
                                        y = E[I + 40 >> 2], s = E[I + 4 >> 2], D = E[I + 44 >> 2], p = E[I + 8 >> 2], w = E[I + 48 >> 2], f = E[I + 12 >> 2], n = E[I + 52 >> 2], k = E[I + 16 >> 2], F = E[I + 56 >> 2], N = E[I + 20 >> 2], S = E[I + 60 >> 2], G = E[I + 24 >> 2], M = E[(h = I - -64 | 0) >> 2], b = E[I + 28 >> 2], K = E[I + 68 >> 2], H = E[I + 32 >> 2], d = E[I + 72 >> 2], J = E[I >> 2], E[A + 36 >> 2] = E[I + 36 >> 2] + E[I + 76 >> 2], E[A + 32 >> 2] = H + d, E[A + 28 >> 2] = b + K, E[A + 24 >> 2] = G + M, E[A + 20 >> 2] = N + S, E[A + 16 >> 2] = k + F, E[A + 12 >> 2] = f + n, E[A + 8 >> 2] = p + w, E[A + 4 >> 2] = s + D, E[A >> 2] = y + J, D = E[I + 40 >> 2], y = E[I + 4 >> 2], p = E[I + 44 >> 2], w = E[I + 8 >> 2], f = E[I + 48 >> 2], n = E[I + 12 >> 2], k = E[I + 52 >> 2], F = E[I + 16 >> 2], N = E[I + 56 >> 2], S = E[I + 20 >> 2], G = E[I + 60 >> 2], M = E[I + 24 >> 2], h = E[h >> 2], s = E[I + 28 >> 2], b = E[I + 68 >> 2], K = E[I + 32 >> 2], H = E[I + 72 >> 2], d = E[I >> 2], E[A + 76 >> 2] = E[I + 76 >> 2] - E[I + 36 >> 2], E[A + 72 >> 2] = H - K, E[A + 68 >> 2] = b - s, E[(s = A - -64 | 0) >> 2] = h - M, E[A + 60 >> 2] = G - S, E[A + 56 >> 2] = N - F, E[A + 52 >> 2] = k - n, E[A + 48 >> 2] = f - w, E[A + 44 >> 2] = p - y, E[(y = A + 40 | 0) >> 2] = D - d, Y(A + 80 | 0, A, g + 40 | 0), Y(y, y, g), Y(A + 120 | 0, g + 120 | 0, I + 120 | 0), Y(A, I + 80 | 0, g + 80 | 0), J = E[A + 4 >> 2], Q = E[A + 8 >> 2], i = E[A + 12 >> 2], o = E[A + 16 >> 2], a = E[A + 20 >> 2], _ = E[A + 24 >> 2], c = E[A + 28 >> 2], t = E[A + 32 >> 2], r = E[A + 36 >> 2], I = E[y >> 2], g = E[A + 80 >> 2], D = E[A + 44 >> 2], p = E[A + 84 >> 2], w = E[A + 48 >> 2], f = E[A + 88 >> 2], n = E[A + 52 >> 2], k = E[A + 92 >> 2], F = E[A + 56 >> 2], N = E[A + 96 >> 2], S = E[A + 60 >> 2], G = E[A + 100 >> 2], h = E[s >> 2], M = E[A + 104 >> 2], b = E[A + 68 >> 2], K = E[A + 108 >> 2], H = E[A + 72 >> 2], d = E[A + 112 >> 2], e = E[A >> 2], C = E[A + 76 >> 2], B = E[A + 116 >> 2], E[A + 76 >> 2] = C + B, E[A + 72 >> 2] = H + d, E[A + 68 >> 2] = b + K, E[s >> 2] = h + M, E[A + 60 >> 2] = S + G, E[A + 56 >> 2] = F + N, E[A + 52 >> 2] = n + k, E[A + 48 >> 2] = w + f, E[A + 44 >> 2] = D + p, E[y >> 2] = I + g, E[A + 36 >> 2] = B - C, E[A + 32 >> 2] = d - H, E[A + 28 >> 2] = K - b, E[A + 24 >> 2] = M - h, E[A + 20 >> 2] = G - S, E[A + 16 >> 2] = N - F, E[A + 12 >> 2] = k - n, E[A + 8 >> 2] = f - w, E[A + 4 >> 2] = p - D, E[A >> 2] = g - I, I = E[A + 156 >> 2], g = r << 1, E[A + 156 >> 2] = I + g, y = E[A + 152 >> 2], s = t << 1, E[A + 152 >> 2] = y + s, D = E[A + 148 >> 2], p = c << 1, E[A + 148 >> 2] = D + p, w = E[A + 144 >> 2], f = _ << 1, E[A + 144 >> 2] = w + f, n = E[A + 140 >> 2], k = a << 1, E[A + 140 >> 2] = n + k, F = E[A + 136 >> 2], N = o << 1, E[A + 136 >> 2] = F + N, S = E[A + 132 >> 2], G = i << 1, E[A + 132 >> 2] = S + G, h = E[A + 128 >> 2], M = Q << 1, E[A + 128 >> 2] = h + M, b = E[A + 124 >> 2], K = J << 1, E[A + 124 >> 2] = b + K, H = E[A + 120 >> 2], d = e << 1, E[A + 120 >> 2] = H + d, E[A + 112 >> 2] = s - y, E[A + 108 >> 2] = p - D, E[A + 104 >> 2] = f - w, E[A + 100 >> 2] = k - n, E[A + 96 >> 2] = N - F, E[A + 92 >> 2] = G - S, E[A + 88 >> 2] = M - h, E[A + 84 >> 2] = K - b, E[A + 80 >> 2] = d - H, E[A + 116 >> 2] = g - I;
                                    }
                                    function DA(A, I, g) {
                                        var C, B, Q, i, o, a, _, c, t, r, e, y = 0, s = 0, h = 0, D = 0, p = 0, w = 0, f = 0, n = 0, k = 0, F = 0, N = 0, S = 0, G = 0, M = 0, b = 0, K = 0, H = 0, d = 0, J = 0;
                                        y = E[I + 40 >> 2], s = E[I + 4 >> 2], D = E[I + 44 >> 2], p = E[I + 8 >> 2], w = E[I + 48 >> 2], f = E[I + 12 >> 2], n = E[I + 52 >> 2], k = E[I + 16 >> 2], F = E[I + 56 >> 2], N = E[I + 20 >> 2], S = E[I + 60 >> 2], G = E[I + 24 >> 2], M = E[(h = I - -64 | 0) >> 2], b = E[I + 28 >> 2], K = E[I + 68 >> 2], H = E[I + 32 >> 2], d = E[I + 72 >> 2], J = E[I >> 2], E[A + 36 >> 2] = E[I + 36 >> 2] + E[I + 76 >> 2], E[A + 32 >> 2] = H + d, E[A + 28 >> 2] = b + K, E[A + 24 >> 2] = G + M, E[A + 20 >> 2] = N + S, E[A + 16 >> 2] = k + F, E[A + 12 >> 2] = f + n, E[A + 8 >> 2] = p + w, E[A + 4 >> 2] = s + D, E[A >> 2] = y + J, D = E[I + 40 >> 2], y = E[I + 4 >> 2], p = E[I + 44 >> 2], w = E[I + 8 >> 2], f = E[I + 48 >> 2], n = E[I + 12 >> 2], k = E[I + 52 >> 2], F = E[I + 16 >> 2], N = E[I + 56 >> 2], S = E[I + 20 >> 2], G = E[I + 60 >> 2], M = E[I + 24 >> 2], h = E[h >> 2], s = E[I + 28 >> 2], b = E[I + 68 >> 2], K = E[I + 32 >> 2], H = E[I + 72 >> 2], d = E[I >> 2], E[A + 76 >> 2] = E[I + 76 >> 2] - E[I + 36 >> 2], E[A + 72 >> 2] = H - K, E[A + 68 >> 2] = b - s, E[(s = A - -64 | 0) >> 2] = h - M, E[A + 60 >> 2] = G - S, E[A + 56 >> 2] = N - F, E[A + 52 >> 2] = k - n, E[A + 48 >> 2] = f - w, E[A + 44 >> 2] = p - y, E[(y = A + 40 | 0) >> 2] = D - d, Y(A + 80 | 0, A, g), Y(y, y, g + 40 | 0), Y(A + 120 | 0, g + 80 | 0, I + 120 | 0), J = E[I + 80 >> 2], Q = E[I + 84 >> 2], i = E[I + 88 >> 2], o = E[I + 92 >> 2], a = E[I + 96 >> 2], _ = E[I + 100 >> 2], c = E[I + 104 >> 2], t = E[I + 108 >> 2], r = E[I + 112 >> 2], e = E[I + 116 >> 2], I = E[y >> 2], g = E[A + 80 >> 2], D = E[A + 44 >> 2], p = E[A + 84 >> 2], w = E[A + 48 >> 2], f = E[A + 88 >> 2], n = E[A + 52 >> 2], k = E[A + 92 >> 2], F = E[A + 56 >> 2], N = E[A + 96 >> 2], S = E[A + 60 >> 2], G = E[A + 100 >> 2], h = E[s >> 2], M = E[A + 104 >> 2], b = E[A + 68 >> 2], K = E[A + 108 >> 2], H = E[A + 72 >> 2], d = E[A + 112 >> 2], C = E[A + 76 >> 2], B = E[A + 116 >> 2], E[A + 76 >> 2] = C + B, E[A + 72 >> 2] = H + d, E[A + 68 >> 2] = b + K, E[s >> 2] = h + M, E[A + 60 >> 2] = S + G, E[A + 56 >> 2] = F + N, E[A + 52 >> 2] = n + k, E[A + 48 >> 2] = w + f, E[A + 44 >> 2] = D + p, E[y >> 2] = I + g, E[A + 36 >> 2] = B - C, E[A + 32 >> 2] = d - H, E[A + 28 >> 2] = K - b, E[A + 24 >> 2] = M - h, E[A + 20 >> 2] = G - S, E[A + 16 >> 2] = N - F, E[A + 12 >> 2] = k - n, E[A + 8 >> 2] = f - w, E[A + 4 >> 2] = p - D, E[A >> 2] = g - I, I = e << 1, g = E[A + 156 >> 2], E[A + 156 >> 2] = I - g, y = r << 1, s = E[A + 152 >> 2], E[A + 152 >> 2] = y - s, D = t << 1, p = E[A + 148 >> 2], E[A + 148 >> 2] = D - p, w = c << 1, f = E[A + 144 >> 2], E[A + 144 >> 2] = w - f, n = _ << 1, k = E[A + 140 >> 2], E[A + 140 >> 2] = n - k, F = a << 1, N = E[A + 136 >> 2], E[A + 136 >> 2] = F - N, S = o << 1, G = E[A + 132 >> 2], E[A + 132 >> 2] = S - G, h = i << 1, M = E[A + 128 >> 2], E[A + 128 >> 2] = h - M, b = Q << 1, K = E[A + 124 >> 2], E[A + 124 >> 2] = b - K, H = J << 1, d = E[A + 120 >> 2], E[A + 120 >> 2] = H - d, E[A + 112 >> 2] = y + s, E[A + 108 >> 2] = D + p, E[A + 104 >> 2] = w + f, E[A + 100 >> 2] = n + k, E[A + 96 >> 2] = F + N, E[A + 92 >> 2] = S + G, E[A + 88 >> 2] = h + M, E[A + 84 >> 2] = b + K, E[A + 80 >> 2] = H + d, E[A + 116 >> 2] = I + g;
                                    }
                                    function pA(A, I) {
                                        var g, C, B, Q, i, o, _, c, t, r, e, y, s, h, D = 0, p = 0, f = 0, n = 0, k = 0, F = 0, N = 0, S = 0, G = 0, M = 0, b = 0, K = 0, H = 0;
                                        s = a[I + 31 | 0], g = a[I + 30 | 0], C = a[I + 29 | 0], B = a[I + 6 | 0], Q = a[I + 5 | 0], i = a[I + 4 | 0], o = a[I + 9 | 0], _ = a[I + 8 | 0], c = a[I + 7 | 0], t = a[I + 12 | 0], b = a[I + 11 | 0], K = a[I + 10 | 0], r = a[I + 15 | 0], H = a[I + 14 | 0], e = a[I + 13 | 0], N = a[I + 28 | 0], M = a[I + 27 | 0], S = a[I + 26 | 0], F = a[I + 25 | 0], n = a[I + 24 | 0], f = a[I + 23 | 0], h = a[0 | I] | a[I + 1 | 0] << 8 | a[I + 2 | 0] << 16 | a[I + 3 | 0] << 24, k = (p = a[I + 21 | 0]) << 15, p = D = p >>> 17 | 0, G = k, G |= (k = a[I + 20 | 0]) << 7, k = (D = k >>> 25 | 0) | p, p = (D = a[I + 22 | 0]) >>> 9 | 0, D = D << 23 | G, p |= k, y = a[I + 16 | 0] | a[I + 17 | 0] << 8 | a[I + 18 | 0] << 16 | a[I + 19 | 0] << 24, I = 0, k = D, D = (33554431 & (I = (G = y + 16777216 | 0) >>> 0 < 16777216 ? 1 : I)) << 7 | G >>> 25, I = (I >>> 25 | 0) + p | 0, D = (p = k = k + D | 0) >>> 0 < D >>> 0 ? I + 1 | 0 : I, I = (k = p + 33554432 | 0) >>> 0 < 33554432 ? D + 1 | 0 : D, E[A + 24 >> 2] = p - (-67108864 & k), D = (p = f >>> 27 | 0) | n >>> 19 | F >>> 11, p = f = (n = F << 21 | (f = n << 13 | f << 5)) + (p = (67108863 & (p = I)) << 6 | k >>> 26) | 0, I = D, D = (f = n + 16777216 | 0) >>> 0 < 16777216 ? I + 1 | 0 : I, E[A + 28 >> 2] = p - (1040187392 & f), p = (D = (I = D) >>> 25 | 0) + (p = M >>> 20 | S >>> 28 | N >>> 12) | 0, I = p = (D = f = (I = (33554431 & I) << 7 | f >>> 25) + (M << 12 | S << 4 | N << 20) | 0) >>> 0 < I >>> 0 ? p + 1 | 0 : p, f = (N = D + 33554432 | 0) >>> 0 < 33554432 ? I + 1 | 0 : I, E[A + 32 >> 2] = D - (-67108864 & N), p = t >>> 13 | (D = b >>> 21 | K >>> 29), I = (p = (M = 16777216 + (b = b << 11 | K << 3 | t << 19) | 0) >>> 0 < 16777216 ? p + 1 | 0 : p) >>> 25 | 0, p = (D = n = H << 10 | e << 2 | r << 18) + (n = (33554431 & p) << 7 | M >>> 25) | 0, D = I + (F = H >>> 22 | e >>> 30 | r >>> 14) | 0, I = D = p >>> 0 < n >>> 0 ? D + 1 | 0 : D, n = ((67108863 & (I = (n = p + 33554432 | 0) >>> 0 < 33554432 ? I + 1 | 0 : I)) << 6 | (D = n) >>> 26) + (S = y - (-33554432 & G) | 0) | 0, E[A + 20 >> 2] = n, E[A + 16 >> 2] = p - (-67108864 & D), D = Q >>> 18 | i >>> 26 | B >>> 10, p = (D = (S = 16777216 + (K = Q << 14 | i << 6 | B << 22) | 0) >>> 0 < 16777216 ? D + 1 | 0 : D) >>> 25 | 0, D = (I = n = _ << 13 | c << 5 | o << 21) + (n = (33554431 & D) << 7 | S >>> 25) | 0, I = p + (F = _ >>> 19 | c >>> 27 | o >>> 11) | 0, I = D >>> 0 < n >>> 0 ? I + 1 | 0 : I, p = (F = D + 33554432 | 0) >>> 0 < 33554432 ? I + 1 | 0 : I, E[A + 8 >> 2] = D - (-67108864 & F), N = (f = (67108863 & f) << 6 | N >>> 26) + (H = s << 18 & 33292288 | g << 10 | C << 2) | 0, I = D = g >>> 22 | C >>> 30, D = (f = H + 16777216 | 0) >>> 0 < 16777216 ? I + 1 | 0 : I, E[A + 36 >> 2] = N - (33554432 & f), p = b + ((67108863 & p) << 6 | F >>> 26) | 0, E[A + 12 >> 2] = p - (234881024 & M), n = K - (2113929216 & S) | 0, p = Ig((33554431 & (I = D)) << 7 | f >>> 25, D = I >>> 25 | 0, 19, 0), I = w, p = (D = p + h | 0) >>> 0 < p >>> 0 ? I + 1 | 0 : I, f = ((67108863 & (p = (I = D + 33554432 | 0) >>> 0 < 33554432 ? p + 1 | 0 : p)) << 6 | I >>> 26) + n | 0, E[A + 4 >> 2] = f, E[A >> 2] = D - (-67108864 & I);
                                    }
                                    function wA(A, I, g, C, B, i, _, c) {
                                        A |= 0, I |= 0, g |= 0, C |= 0, B |= 0, i |= 0, _ |= 0;
                                        var t = 0, r = 0, e = 0, y = 0, s = 0, h = 0, D = 0, p = 0;
                                        A: {
                                            I: {
                                                g: {
                                                    C: {
                                                        B: {
                                                            Q: {
                                                                i: {
                                                                    o: {
                                                                        E: {
                                                                            a: {
                                                                                _: {
                                                                                    if (1 == (-7 & (c |= 0))) {
                                                                                        if (e = 0, !C) break o;
                                                                                        if (4 & c) break _;
                                                                                        for(;;){
                                                                                            e = r;
                                                                                            c: {
                                                                                                t: {
                                                                                                    r: {
                                                                                                        e: {
                                                                                                            for(;;){
                                                                                                                if (t = (t = (y = o[g + e | 0]) - 65 | 0) & ((90 - y ^ -1) & (-1 ^ t)) >>> 8 & 255 | y + 4 & ((y + 65488 ^ -1) & (57 - y ^ -1)) >>> 8 & 255 | y + 185 & ((y + 65439 ^ -1) & (122 - y ^ -1)) >>> 8 & 255 | (1 + (16336 ^ y) ^ -1) >>> 8 & 63 | (1 + (16340 ^ y) ^ -1) >>> 8 & 62, 255 != (0 | (t |= (t - 1 & 1 + (65470 ^ y)) >>> 8 & 255))) break e;
                                                                                                                if (t = 0, !B) break E;
                                                                                                                if (!FI(B, y)) break;
                                                                                                                if ((e = e + 1 | 0) >>> 0 >= C >>> 0) break r;
                                                                                                            }
                                                                                                            r = e;
                                                                                                            break E;
                                                                                                        }
                                                                                                        if (D = t + (D << 6) | 0, s >>> 0 > 1) break t;
                                                                                                        s = s + 6 | 0;
                                                                                                        break c;
                                                                                                    }
                                                                                                    r = (A = r + 1 | 0) >>> 0 < C >>> 0 ? C : A;
                                                                                                    break E;
                                                                                                }
                                                                                                if (s = s - 2 | 0, I >>> 0 <= h >>> 0) break a;
                                                                                                o[A + h | 0] = D >>> s, h = h + 1 | 0;
                                                                                            }
                                                                                            if (t = 0, !((r = e + 1 | 0) >>> 0 < C >>> 0)) break;
                                                                                        }
                                                                                        break E;
                                                                                    }
                                                                                    yC(), Q();
                                                                                }
                                                                                _: for(;;){
                                                                                    for(e = r;;){
                                                                                        c: {
                                                                                            if (t = (t = (y = o[g + e | 0]) - 65 | 0) & ((90 - y ^ -1) & (-1 ^ t)) >>> 8 & 255 | y + 4 & ((y + 65488 ^ -1) & (57 - y ^ -1)) >>> 8 & 255 | y + 185 & ((y + 65439 ^ -1) & (122 - y ^ -1)) >>> 8 & 255 | (1 + (16288 ^ y) ^ -1) >>> 8 & 63 | (1 + (16338 ^ y) ^ -1) >>> 8 & 62, 255 == (0 | (t |= (t - 1 & 1 + (65470 ^ y)) >>> 8 & 255))) {
                                                                                                if (t = 0, !B) break E;
                                                                                                if (FI(B, y)) break c;
                                                                                                r = e;
                                                                                                break E;
                                                                                            }
                                                                                            if (D = t + (D << 6) | 0, s >>> 0 < 2) s = s + 6 | 0;
                                                                                            else {
                                                                                                if (s = s - 2 | 0, I >>> 0 <= h >>> 0) break a;
                                                                                                o[A + h | 0] = D >>> s, h = h + 1 | 0;
                                                                                            }
                                                                                            if (t = 0, (r = e + 1 | 0) >>> 0 < C >>> 0) continue _;
                                                                                            break E;
                                                                                        }
                                                                                        if (!((e = e + 1 | 0) >>> 0 < C >>> 0)) break;
                                                                                    }
                                                                                    break;
                                                                                }
                                                                                r = (A = r + 1 | 0) >>> 0 < C >>> 0 ? C : A;
                                                                                break E;
                                                                            }
                                                                            r = e, E[9392] = 68, t = 1;
                                                                        }
                                                                        if (s >>> 0 > 4) break i;
                                                                        e = r;
                                                                    }
                                                                    if (A = e, I = -1, t) {
                                                                        r = A;
                                                                        break A;
                                                                    }
                                                                    if ((-1 << s ^ -1) & D) {
                                                                        r = A;
                                                                        break A;
                                                                    }
                                                                    if (2 & c) {
                                                                        c = A;
                                                                        break B;
                                                                    }
                                                                    if (s >>> 0 < 2) {
                                                                        c = A;
                                                                        break B;
                                                                    }
                                                                    if (r = A >>> 0 > C >>> 0 ? A : C, e = s >>> 1 | 0, !B) break Q;
                                                                    for(c = A;;){
                                                                        if ((0 | c) == (0 | r)) {
                                                                            t = 68;
                                                                            break C;
                                                                        }
                                                                        if (61 != (0 | (A = o[g + c | 0]))) {
                                                                            if (!FI(B, A)) {
                                                                                t = 28, r = c;
                                                                                break C;
                                                                            }
                                                                        } else e = e - 1 | 0;
                                                                        if (c = c + 1 | 0, !e) break;
                                                                    }
                                                                    break B;
                                                                }
                                                                I = -1;
                                                                break A;
                                                            }
                                                            if (t = 68, A >>> 0 >= C >>> 0) break C;
                                                            if (61 != a[A + g | 0]) {
                                                                r = A, t = 28;
                                                                break C;
                                                            }
                                                            if (c = A + e | 0, 1 != (0 | e)) {
                                                                if ((0 | (s = A + 1 | 0)) == (0 | r)) break C;
                                                                if (61 != a[g + s | 0]) {
                                                                    r = s, t = 28;
                                                                    break C;
                                                                }
                                                                if (2 != (0 | e)) {
                                                                    if ((0 | (A = A + 2 | 0)) == (0 | r)) break C;
                                                                    if (t = 28, r = A, 61 != a[A + g | 0]) break C;
                                                                }
                                                            }
                                                        }
                                                        if (I = 0, B) break g;
                                                        break I;
                                                    }
                                                    E[9392] = t;
                                                    break A;
                                                }
                                                if (!(C >>> 0 <= c >>> 0)) {
                                                    for(;;){
                                                        if (!FI(B, o[g + c | 0])) break I;
                                                        if ((0 | (c = c + 1 | 0)) == (0 | C)) break;
                                                    }
                                                    c = C;
                                                }
                                            }
                                            r = c, p = h;
                                        }
                                        return _ ? E[_ >> 2] = g + r : (0 | C) != (0 | r) && (E[9392] = 28, I = -1), i && (E[i >> 2] = p), 0 | I;
                                    }
                                    function fA(A, I, g, C) {
                                        A |= 0, I |= 0, g |= 0;
                                        var B = 0, Q = 0, i = 0, E = 0, _ = 0, c = 0, t = 0, r = 0, e = 0, y = 0, s = 0, h = 0, D = 0, p = 0, w = 0, f = 0, n = 0, k = 0, F = 0;
                                        for((C |= 0) ? (B = a[C + 12 | 0] | a[C + 13 | 0] << 8 | a[C + 14 | 0] << 16 | a[C + 15 | 0] << 24, _ = a[C + 8 | 0] | a[C + 9 | 0] << 8 | a[C + 10 | 0] << 16 | a[C + 11 | 0] << 24, c = a[C + 4 | 0] | a[C + 5 | 0] << 8 | a[C + 6 | 0] << 16 | a[C + 7 | 0] << 24, C = a[0 | C] | a[C + 1 | 0] << 8 | a[C + 2 | 0] << 16 | a[C + 3 | 0] << 24) : (B = 1797285236, _ = 2036477234, c = 857760878, C = 1634760805), Q = a[I + 12 | 0] | a[I + 13 | 0] << 8 | a[I + 14 | 0] << 16 | a[I + 15 | 0] << 24, E = a[I + 8 | 0] | a[I + 9 | 0] << 8 | a[I + 10 | 0] << 16 | a[I + 11 | 0] << 24, i = a[I + 4 | 0] | a[I + 5 | 0] << 8 | a[I + 6 | 0] << 16 | a[I + 7 | 0] << 24, p = a[g + 28 | 0] | a[g + 29 | 0] << 8 | a[g + 30 | 0] << 16 | a[g + 31 | 0] << 24, D = a[g + 24 | 0] | a[g + 25 | 0] << 8 | a[g + 26 | 0] << 16 | a[g + 27 | 0] << 24, w = 20, s = a[g + 20 | 0] | a[g + 21 | 0] << 8 | a[g + 22 | 0] << 16 | a[g + 23 | 0] << 24, h = a[g + 16 | 0] | a[g + 17 | 0] << 8 | a[g + 18 | 0] << 16 | a[g + 19 | 0] << 24, r = a[g + 12 | 0] | a[g + 13 | 0] << 8 | a[g + 14 | 0] << 16 | a[g + 15 | 0] << 24, e = a[g + 8 | 0] | a[g + 9 | 0] << 8 | a[g + 10 | 0] << 16 | a[g + 11 | 0] << 24, y = a[g + 4 | 0] | a[g + 5 | 0] << 8 | a[g + 6 | 0] << 16 | a[g + 7 | 0] << 24, I = a[0 | I] | a[I + 1 | 0] << 8 | a[I + 2 | 0] << 16 | a[I + 3 | 0] << 24, g = a[0 | g] | a[g + 1 | 0] << 8 | a[g + 2 | 0] << 16 | a[g + 3 | 0] << 24; t = Lg(g + c | 0, 7) ^ Q, f = Lg(t + c | 0, 9) ^ D, r = Lg(C + s | 0, 7) ^ r, n = Lg(r + C | 0, 9) ^ E, k = Lg(n + r | 0, 13) ^ s, e = Lg(B + h | 0, 7) ^ e, i = Lg(e + B | 0, 9) ^ i, E = Lg(i + e | 0, 13) ^ h, B = Lg(i + E | 0, 18) ^ B, Q = Lg(I + _ | 0, 7) ^ p, s = k ^ Lg(B + Q | 0, 7), D = f ^ Lg(s + B | 0, 9), p = Lg(s + D | 0, 13) ^ Q, B = Lg(D + p | 0, 18) ^ B, y = Lg(Q + _ | 0, 9) ^ y, F = Lg(y + Q | 0, 13) ^ I, I = Lg(F + y | 0, 18) ^ _, h = Lg(I + t | 0, 7) ^ E, E = Lg(h + I | 0, 9) ^ n, Q = Lg(E + h | 0, 13) ^ t, _ = Lg(Q + E | 0, 18) ^ I, t = Lg(t + f | 0, 13) ^ g, g = Lg(t + f | 0, 18) ^ c, I = Lg(g + r | 0, 7) ^ F, i = Lg(I + g | 0, 9) ^ i, r = Lg(I + i | 0, 13) ^ r, c = Lg(i + r | 0, 18) ^ g, C = Lg(n + k | 0, 18) ^ C, g = Lg(C + e | 0, 7) ^ t, y = Lg(g + C | 0, 9) ^ y, e = Lg(g + y | 0, 13) ^ e, C = Lg(y + e | 0, 18) ^ C, t = w >>> 0 > 2, w = w - 2 | 0, t;);
                                        return o[0 | A] = C, o[A + 1 | 0] = C >>> 8, o[A + 2 | 0] = C >>> 16, o[A + 3 | 0] = C >>> 24, o[A + 28 | 0] = Q, o[A + 29 | 0] = Q >>> 8, o[A + 30 | 0] = Q >>> 16, o[A + 31 | 0] = Q >>> 24, o[A + 24 | 0] = E, o[A + 25 | 0] = E >>> 8, o[A + 26 | 0] = E >>> 16, o[A + 27 | 0] = E >>> 24, o[A + 20 | 0] = i, o[A + 21 | 0] = i >>> 8, o[A + 22 | 0] = i >>> 16, o[A + 23 | 0] = i >>> 24, o[A + 16 | 0] = I, o[A + 17 | 0] = I >>> 8, o[A + 18 | 0] = I >>> 16, o[A + 19 | 0] = I >>> 24, o[A + 12 | 0] = B, o[A + 13 | 0] = B >>> 8, o[A + 14 | 0] = B >>> 16, o[A + 15 | 0] = B >>> 24, o[A + 8 | 0] = _, o[A + 9 | 0] = _ >>> 8, o[A + 10 | 0] = _ >>> 16, o[A + 11 | 0] = _ >>> 24, o[A + 4 | 0] = c, o[A + 5 | 0] = c >>> 8, o[A + 6 | 0] = c >>> 16, o[A + 7 | 0] = c >>> 24, 0;
                                    }
                                    function nA(A, I, g, C) {
                                        var B, Q = 0, i = 0, _ = 0, c = 0, t = 0, r = 0, e = 0, y = 0, s = 0, D = 0, p = 0, w = 0;
                                        if (h = B = h - 704 | 0, g | C) {
                                            if (Q = (C << 3 | g >>> 29) + (i = _ = E[A + 76 >> 2]) | 0, t = (r = E[A + 72 >> 2]) + (c = g << 3) | 0, E[A + 72 >> 2] = t, Q = c >>> 0 > t >>> 0 ? Q + 1 | 0 : Q, E[A + 76 >> 2] = Q, _ = E[4 + (c = A - -64 | 0) >> 2], _ = (e = Q = (0 | Q) == (0 | i) & t >>> 0 < r >>> 0 | Q >>> 0 < i >>> 0) >>> 0 > (Q = Q + E[c >> 2] | 0) >>> 0 ? _ + 1 | 0 : _, t = (e = C >>> 29 | 0) + Q | 0, Q = _, E[c >> 2] = t, E[c + 4 >> 2] = t >>> 0 < e >>> 0 ? Q + 1 | 0 : Q, (0 | C) == (0 | (_ = e = 0 - ((Q = 0) + ((c = 127 & ((7 & i) << 29 | r >>> 3)) >>> 0 > 128) | 0) | 0)) & g >>> 0 >= (t = 128 - c | 0) >>> 0 | C >>> 0 > _ >>> 0) {
                                                if (i = 0, _ = 0, !Q & (127 ^ c) >>> 0 >= 3 | Q) for(w = 252 & t, r = A + 80 | 0; o[(Q = i + c | 0) + r | 0] = a[I + i | 0], o[r + (c + (Q = 1 | i) | 0) | 0] = a[I + Q | 0], o[r + (c + (Q = 2 | i) | 0) | 0] = a[I + Q | 0], o[r + (c + (Q = 3 | i) | 0) | 0] = a[I + Q | 0], Q = _, _ = (i = i + 4 | 0) >>> 0 < 4 ? Q + 1 | 0 : Q, Q = s, s = Q = (D = D + 4 | 0) >>> 0 < 4 ? Q + 1 | 0 : Q, (0 | D) != (0 | w) | (0 | p) != (0 | Q););
                                                if (r = Q = 0, Q | (s = 3 & t)) for(; o[80 + (A + (Q = i + c | 0) | 0) | 0] = a[I + i | 0], Q = _, _ = (i = i + 1 | 0) ? Q : Q + 1 | 0, Q = p, p = Q = (y = y + 1 | 0) ? Q : Q + 1 | 0, (0 | s) != (0 | y) | (0 | r) != (0 | Q););
                                                if (F(A, A + 80 | 0, B, i = B + 640 | 0), I = I + t | 0, !(C = C - ((g >>> 0 < t >>> 0) + e | 0) | 0) & (g = g - t | 0) >>> 0 > 127 | C) for(; F(A, I, B, i), I = I + 128 | 0, !(C = C - (g >>> 0 < 128) | 0) & (g = g - 128 | 0) >>> 0 > 127 | C;);
                                                if (g | C) {
                                                    if (D = 3 & g, t = 0, y = 0, p = 0, i = 0, _ = 0, !C & g >>> 0 >= 4 | C) for(c = -4 & g, r = C, s = A + 80 | 0, g = 0, C = 0; o[i + s | 0] = a[I + i | 0], o[(Q = 1 | i) + s | 0] = a[I + Q | 0], o[(Q = 2 | i) + s | 0] = a[I + Q | 0], o[(Q = 3 | i) + s | 0] = a[I + Q | 0], Q = _, _ = (i = i + 4 | 0) >>> 0 < 4 ? Q + 1 | 0 : Q, Q = C, C = Q = (g = g + 4 | 0) >>> 0 < 4 ? Q + 1 | 0 : Q, (0 | g) != (0 | c) | (0 | r) != (0 | Q););
                                                    if (t | D) for(; o[80 + (A + i | 0) | 0] = a[I + i | 0], _ = (i = i + 1 | 0) ? _ : _ + 1 | 0, Q = p, p = Q = (y = y + 1 | 0) ? Q : Q + 1 | 0, (0 | y) != (0 | D) | (0 | t) != (0 | Q););
                                                }
                                                XC(B, 704);
                                            } else {
                                                if (i = 0, _ = 0, !C & g >>> 0 >= 4 | C) for(t = -4 & g, r = C, C = A + 80 | 0; o[C + (Q = i + c | 0) | 0] = a[I + i | 0], o[C + (e = c + (Q = 1 | i) | 0) | 0] = a[I + Q | 0], o[C + (e = c + (Q = 2 | i) | 0) | 0] = a[I + Q | 0], o[C + (e = c + (Q = 3 | i) | 0) | 0] = a[I + Q | 0], Q = _, _ = (i = i + 4 | 0) >>> 0 < 4 ? Q + 1 | 0 : Q, Q = s, s = Q = (D = D + 4 | 0) >>> 0 < 4 ? Q + 1 | 0 : Q, (0 | t) != (0 | D) | (0 | r) != (0 | Q););
                                                if ((g &= 3) | (C = 0)) for(; o[80 + (A + (Q = i + c | 0) | 0) | 0] = a[I + i | 0], _ = (i = i + 1 | 0) ? _ : _ + 1 | 0, Q = p, p = Q = (y = y + 1 | 0) ? Q : Q + 1 | 0, (0 | g) != (0 | y) | (0 | C) != (0 | Q););
                                            }
                                        }
                                        return h = B + 704 | 0, 0;
                                    }
                                    function kA(A, I) {
                                        var g, C, B, Q, i = 0, _ = 0, c = 0, t = 0, r = 0, e = 0;
                                        for(h = g = h - 480 | 0; c = (_ = g + 288 | 0) + (i << 1) | 0, t = a[I + i | 0], o[c + 1 | 0] = t >>> 4, o[0 | c] = 15 & t, _ = _ + ((c = 1 | i) << 1) | 0, c = a[I + c | 0], o[_ + 1 | 0] = c >>> 4, o[0 | _] = 15 & c, 32 != (0 | (i = i + 2 | 0)););
                                        for(I = 0; i = 8 + (_ = (i = I) + a[0 | (I = (g + 288 | 0) + r | 0)] | 0) | 0, o[0 | I] = _ - (240 & i), i = 8 + (_ = a[I + 1 | 0] + (i << 24 >> 24 >> 4) | 0) | 0, o[I + 1 | 0] = _ - (240 & i), i = 8 + (_ = a[I + 2 | 0] + (i << 24 >> 24 >> 4) | 0) | 0, o[I + 2 | 0] = _ - (240 & i), I = i << 24 >> 24 >> 4, 63 != (0 | (r = r + 3 | 0)););
                                        for(o[g + 351 | 0] = a[g + 351 | 0] + I, E[A + 32 >> 2] = 0, E[A + 36 >> 2] = 0, E[A + 24 >> 2] = 0, E[A + 28 >> 2] = 0, E[A + 16 >> 2] = 0, E[A + 20 >> 2] = 0, E[A + 8 >> 2] = 0, E[A + 12 >> 2] = 0, E[A >> 2] = 0, E[A + 4 >> 2] = 0, E[A + 44 >> 2] = 0, E[A + 48 >> 2] = 0, E[(I = A + 40 | 0) >> 2] = 1, E[A + 52 >> 2] = 0, E[A + 56 >> 2] = 0, E[A + 60 >> 2] = 0, E[A + 64 >> 2] = 0, E[A + 68 >> 2] = 0, E[A + 72 >> 2] = 0, E[A + 76 >> 2] = 0, E[A + 80 >> 2] = 1, Hg(A + 84 | 0, 0, 76), B = A + 120 | 0, r = A + 80 | 0, _ = g + 208 | 0, C = g + 168 | 0, c = g + 248 | 0, i = 1; zA(e = g + 8 | 0, i >>> 1 | 0, o[(g + 288 | 0) + i | 0]), DA(t = g + 128 | 0, A, e), Y(A, t, c), Y(I, C, _), Y(r, _, c), Y(B, t, C), e = i >>> 0 < 62, i = i + 2 | 0, e;);
                                        for(i = E[A + 36 >> 2], E[g + 392 >> 2] = E[A + 32 >> 2], E[g + 396 >> 2] = i, i = E[A + 28 >> 2], E[g + 384 >> 2] = E[A + 24 >> 2], E[g + 388 >> 2] = i, i = E[A + 20 >> 2], E[g + 376 >> 2] = E[A + 16 >> 2], E[g + 380 >> 2] = i, i = E[A + 12 >> 2], E[g + 368 >> 2] = E[A + 8 >> 2], E[g + 372 >> 2] = i, i = E[A + 4 >> 2], E[g + 360 >> 2] = E[A >> 2], E[g + 364 >> 2] = i, i = E[I + 12 >> 2], E[g + 408 >> 2] = E[I + 8 >> 2], E[g + 412 >> 2] = i, i = E[I + 20 >> 2], E[g + 416 >> 2] = E[I + 16 >> 2], E[g + 420 >> 2] = i, i = E[I + 28 >> 2], E[g + 424 >> 2] = E[I + 24 >> 2], E[g + 428 >> 2] = i, i = E[I + 36 >> 2], E[g + 432 >> 2] = E[I + 32 >> 2], E[g + 436 >> 2] = i, i = E[I + 4 >> 2], E[g + 400 >> 2] = E[I >> 2], E[g + 404 >> 2] = i, i = E[r + 12 >> 2], E[g + 448 >> 2] = E[r + 8 >> 2], E[g + 452 >> 2] = i, i = E[r + 20 >> 2], E[g + 456 >> 2] = E[r + 16 >> 2], E[g + 460 >> 2] = i, i = E[r + 28 >> 2], E[g + 464 >> 2] = E[r + 24 >> 2], E[g + 468 >> 2] = i, i = E[r + 36 >> 2], E[g + 472 >> 2] = E[r + 32 >> 2], E[g + 476 >> 2] = i, i = E[r + 4 >> 2], E[g + 440 >> 2] = E[r >> 2], E[g + 444 >> 2] = i, KA(t, i = g + 360 | 0), Y(i, t, c), Y(e = g + 400 | 0, C, _), Y(Q = g + 440 | 0, _, c), KA(t, i), Y(i, t, c), Y(e, C, _), Y(Q, _, c), KA(t, i), Y(i, t, c), Y(e, C, _), Y(Q, _, c), KA(t, i), Y(A, t, c), Y(I, C, _), Y(r, _, c), Y(B, t, C), i = 0; zA(e = g + 8 | 0, i >>> 1 | 0, o[(g + 288 | 0) + i | 0]), DA(t = g + 128 | 0, A, e), Y(A, t, c), Y(I, C, _), Y(r, _, c), Y(B, t, C), t = i >>> 0 < 62, i = i + 2 | 0, t;);
                                        h = g + 480 | 0;
                                    }
                                    function FA(A, I) {
                                        A |= 0;
                                        var g, C, B, Q, i, o = 0, E = 0, a = 0, _ = 0, c = 0, t = 0;
                                        for(h = g = h - 736 | 0, k(c = g + 704 | 0, I |= 0, I), k(E = g + 224 | 0, I, c), k(_ = g + 672 | 0, I, E), k(a = g + 640 | 0, _, _), k(C = g + 416 | 0, c, a), k(c = g + 320 | 0, I, C), k(o = g + 608 | 0, a, a), k(a = g + 288 | 0, c, c), k(t = g + 576 | 0, C, a), k(i = g + 448 | 0, o, a), k(B = g + 544 | 0, t, t), k(t = g + 384 | 0, o, B), k(Q = g + 352 | 0, E, t), k(E = g + 192 | 0, o, Q), k(o = g + 160 | 0, _, E), k(g + 96 | 0, _, o), k(E = g + 512 | 0, B, Q), k(o = g + 480 | 0, _, E), k(E = g + 256 | 0, i, o), k(g + 128 | 0, a, E), k(a = g - -64 | 0, t, o), k(o = g + 32 | 0, _, a), k(g, C, o), k(A, c, g), _ = 0; k(A, A, A), 126 != (0 | (_ = _ + 1 | 0)););
                                        return k(A, A, g + 352 | 0), k(A, A, A), k(A, A, A), k(A, A, A), k(A, A, A), k(A, A, A), k(A, A, A), k(A, A, A), k(A, A, A), k(A, A, A), k(A, A, g + 704 | 0), k(A, A, g), k(A, A, A), k(A, A, A), k(A, A, A), k(A, A, A), k(A, A, A), k(A, A, A), k(A, A, A), k(A, A, g + 160 | 0), k(A, A, A), k(A, A, A), k(A, A, A), k(A, A, A), k(A, A, A), k(A, A, A), k(A, A, A), k(A, A, A), k(A, A, A), k(A, A, g), k(A, A, A), k(A, A, A), k(A, A, A), k(A, A, A), k(A, A, A), k(A, A, A), k(A, A, A), k(A, A, A), k(A, A, A), k(A, A, A), k(A, A, A), k(A, A, g + 256 | 0), k(A, A, A), k(A, A, A), k(A, A, A), k(A, A, A), k(A, A, A), k(A, A, A), k(A, A, A), k(A, A, A), k(A, A, g - -64 | 0), k(A, A, A), k(A, A, A), k(A, A, A), k(A, A, A), k(A, A, A), k(A, A, A), k(A, A, A), k(A, A, A), k(A, A, A), k(A, A, g + 96 | 0), k(A, A, A), k(A, A, A), k(A, A, A), k(A, A, A), k(A, A, A), k(A, A, A), k(A, A, g + 320 | 0), k(A, A, A), k(A, A, A), k(A, A, A), k(A, A, A), k(A, A, A), k(A, A, A), k(A, A, A), k(A, A, A), k(A, A, A), k(A, A, A), k(A, A, A), k(A, A, A), k(A, A, A), k(A, A, A), k(A, A, g + 512 | 0), k(A, A, A), k(A, A, A), k(A, A, A), k(A, A, A), k(A, A, A), k(A, A, A), k(A, A, A), k(A, A, A), k(A, A, A), k(A, A, A), k(A, A, g + 192 | 0), k(A, A, A), k(A, A, A), k(A, A, A), k(A, A, A), k(A, A, A), k(A, A, A), k(A, A, A), k(A, A, A), k(A, A, A), k(A, A, g + 480 | 0), k(A, A, A), k(A, A, A), k(A, A, A), k(A, A, A), k(A, A, A), k(A, A, A), k(A, A, A), k(A, A, A), k(A, A, A), k(A, A, A), k(A, A, g), k(A, A, A), k(A, A, A), k(A, A, A), k(A, A, A), k(A, A, A), k(A, A, A), k(A, A, A), k(A, A, A), k(A, A, g + 128 | 0), k(A, A, A), k(A, A, A), k(A, A, A), k(A, A, A), k(A, A, A), k(A, A, A), k(A, A, A), k(A, A, A), k(A, A, g + 32 | 0), h = g + 736 | 0, 0 - NI(I, 32) | 0;
                                    }
                                    function NA(A, I, g) {
                                        A |= 0;
                                        var C, B, Q, i, E = 0, _ = 0, c = 0, t = 0, r = 0;
                                        return h = Q = h - 160 | 0, kI(I |= 0, g |= 0, 32, 0), o[0 | I] = 248 & a[0 | I], o[I + 31 | 0] = 63 & a[I + 31 | 0] | 64, kA(Q, I), tg(A, Q), _ = a[(B = g) + 8 | 0] | a[B + 9 | 0] << 8 | a[B + 10 | 0] << 16 | a[B + 11 | 0] << 24, E = a[B + 12 | 0] | a[B + 13 | 0] << 8 | a[B + 14 | 0] << 16 | a[B + 15 | 0] << 24, c = a[B + 16 | 0] | a[B + 17 | 0] << 8 | a[B + 18 | 0] << 16 | a[B + 19 | 0] << 24, t = a[B + 20 | 0] | a[B + 21 | 0] << 8 | a[B + 22 | 0] << 16 | a[B + 23 | 0] << 24, r = a[0 | B] | a[B + 1 | 0] << 8 | a[B + 2 | 0] << 16 | a[B + 3 | 0] << 24, g = a[B + 4 | 0] | a[B + 5 | 0] << 8 | a[B + 6 | 0] << 16 | a[B + 7 | 0] << 24, i = a[B + 28 | 0] | a[B + 29 | 0] << 8 | a[B + 30 | 0] << 16 | a[B + 31 | 0] << 24, C = I, I = a[B + 24 | 0] | a[B + 25 | 0] << 8 | a[B + 26 | 0] << 16 | a[B + 27 | 0] << 24, o[C + 24 | 0] = I, o[C + 25 | 0] = I >>> 8, o[C + 26 | 0] = I >>> 16, o[C + 27 | 0] = I >>> 24, o[C + 28 | 0] = i, o[C + 29 | 0] = i >>> 8, o[C + 30 | 0] = i >>> 16, o[C + 31 | 0] = i >>> 24, o[C + 16 | 0] = c, o[C + 17 | 0] = c >>> 8, o[C + 18 | 0] = c >>> 16, o[C + 19 | 0] = c >>> 24, o[C + 20 | 0] = t, o[C + 21 | 0] = t >>> 8, o[C + 22 | 0] = t >>> 16, o[C + 23 | 0] = t >>> 24, o[C + 8 | 0] = _, o[C + 9 | 0] = _ >>> 8, o[C + 10 | 0] = _ >>> 16, o[C + 11 | 0] = _ >>> 24, o[C + 12 | 0] = E, o[C + 13 | 0] = E >>> 8, o[C + 14 | 0] = E >>> 16, o[C + 15 | 0] = E >>> 24, o[0 | C] = r, o[C + 1 | 0] = r >>> 8, o[C + 2 | 0] = r >>> 16, o[C + 3 | 0] = r >>> 24, o[C + 4 | 0] = g, o[C + 5 | 0] = g >>> 8, o[C + 6 | 0] = g >>> 16, o[C + 7 | 0] = g >>> 24, c = a[(E = A) + 8 | 0] | a[E + 9 | 0] << 8 | a[E + 10 | 0] << 16 | a[E + 11 | 0] << 24, t = a[E + 12 | 0] | a[E + 13 | 0] << 8 | a[E + 14 | 0] << 16 | a[E + 15 | 0] << 24, r = a[E + 16 | 0] | a[E + 17 | 0] << 8 | a[E + 18 | 0] << 16 | a[E + 19 | 0] << 24, g = a[E + 20 | 0] | a[E + 21 | 0] << 8 | a[E + 22 | 0] << 16 | a[E + 23 | 0] << 24, I = a[0 | E] | a[E + 1 | 0] << 8 | a[E + 2 | 0] << 16 | a[E + 3 | 0] << 24, A = a[E + 4 | 0] | a[E + 5 | 0] << 8 | a[E + 6 | 0] << 16 | a[E + 7 | 0] << 24, _ = a[E + 28 | 0] | a[E + 29 | 0] << 8 | a[E + 30 | 0] << 16 | a[E + 31 | 0] << 24, E = a[E + 24 | 0] | a[E + 25 | 0] << 8 | a[E + 26 | 0] << 16 | a[E + 27 | 0] << 24, o[C + 56 | 0] = E, o[C + 57 | 0] = E >>> 8, o[C + 58 | 0] = E >>> 16, o[C + 59 | 0] = E >>> 24, o[C + 60 | 0] = _, o[C + 61 | 0] = _ >>> 8, o[C + 62 | 0] = _ >>> 16, o[C + 63 | 0] = _ >>> 24, o[C + 48 | 0] = r, o[C + 49 | 0] = r >>> 8, o[C + 50 | 0] = r >>> 16, o[C + 51 | 0] = r >>> 24, o[C + 52 | 0] = g, o[C + 53 | 0] = g >>> 8, o[C + 54 | 0] = g >>> 16, o[C + 55 | 0] = g >>> 24, o[C + 40 | 0] = c, o[C + 41 | 0] = c >>> 8, o[C + 42 | 0] = c >>> 16, o[C + 43 | 0] = c >>> 24, o[C + 44 | 0] = t, o[C + 45 | 0] = t >>> 8, o[C + 46 | 0] = t >>> 16, o[C + 47 | 0] = t >>> 24, o[C + 32 | 0] = I, o[C + 33 | 0] = I >>> 8, o[C + 34 | 0] = I >>> 16, o[C + 35 | 0] = I >>> 24, o[C + 36 | 0] = A, o[C + 37 | 0] = A >>> 8, o[C + 38 | 0] = A >>> 16, o[C + 39 | 0] = A >>> 24, h = Q + 160 | 0, 0;
                                    }
                                    function SA(A, I, g) {
                                        var C, B = 0, Q = 0, i = 0, o = 0, a = 0, _ = 0, c = 0, t = 0, r = 0, e = 0, y = 0, s = 0, h = 0, D = 0, p = 0, w = 0, f = 0, n = 0, k = 0;
                                        s = E[I + 4 >> 2], B = E[A + 4 >> 2], h = E[I + 8 >> 2], Q = E[A + 8 >> 2], D = E[I + 12 >> 2], i = E[A + 12 >> 2], p = E[I + 16 >> 2], o = E[A + 16 >> 2], w = E[I + 20 >> 2], a = E[A + 20 >> 2], f = E[I + 24 >> 2], _ = E[A + 24 >> 2], y = E[I + 28 >> 2], c = E[A + 28 >> 2], n = E[I + 32 >> 2], t = E[A + 32 >> 2], k = E[I + 36 >> 2], r = E[A + 36 >> 2], g = 0 - g | 0, e = E[A >> 2], E[A >> 2] = g & (e ^ E[I >> 2]) ^ e, E[A + 36 >> 2] = r ^ g & (r ^ k), E[A + 32 >> 2] = t ^ g & (t ^ n), E[A + 28 >> 2] = c ^ g & (c ^ y), E[A + 24 >> 2] = _ ^ g & (_ ^ f), E[A + 20 >> 2] = a ^ g & (a ^ w), E[A + 16 >> 2] = o ^ g & (o ^ p), E[A + 12 >> 2] = i ^ g & (i ^ D), E[A + 8 >> 2] = Q ^ g & (Q ^ h), E[A + 4 >> 2] = B ^ g & (B ^ s), B = E[A + 40 >> 2], s = E[I + 40 >> 2], Q = E[A + 44 >> 2], h = E[I + 44 >> 2], i = E[A + 48 >> 2], D = E[I + 48 >> 2], o = E[A + 52 >> 2], p = E[I + 52 >> 2], a = E[A + 56 >> 2], w = E[I + 56 >> 2], _ = E[A + 60 >> 2], f = E[I + 60 >> 2], c = E[(y = A - -64 | 0) >> 2], n = E[I - -64 >> 2], t = E[A + 68 >> 2], k = E[I + 68 >> 2], r = E[A + 72 >> 2], e = E[I + 72 >> 2], C = E[A + 76 >> 2], E[A + 76 >> 2] = C ^ g & (E[I + 76 >> 2] ^ C), E[A + 72 >> 2] = r ^ g & (r ^ e), E[A + 68 >> 2] = t ^ g & (t ^ k), E[y >> 2] = c ^ g & (c ^ n), E[A + 60 >> 2] = _ ^ g & (_ ^ f), E[A + 56 >> 2] = a ^ g & (a ^ w), E[A + 52 >> 2] = o ^ g & (o ^ p), E[A + 48 >> 2] = i ^ g & (i ^ D), E[A + 44 >> 2] = Q ^ g & (Q ^ h), E[A + 40 >> 2] = B ^ g & (B ^ s), B = E[A + 80 >> 2], s = E[I + 80 >> 2], Q = E[A + 84 >> 2], h = E[I + 84 >> 2], i = E[A + 88 >> 2], D = E[I + 88 >> 2], o = E[A + 92 >> 2], p = E[I + 92 >> 2], a = E[A + 96 >> 2], w = E[I + 96 >> 2], _ = E[A + 100 >> 2], f = E[I + 100 >> 2], c = E[A + 104 >> 2], y = E[I + 104 >> 2], t = E[A + 108 >> 2], n = E[I + 108 >> 2], r = E[A + 112 >> 2], k = E[I + 112 >> 2], e = E[A + 116 >> 2], E[A + 116 >> 2] = g & (e ^ E[I + 116 >> 2]) ^ e, E[A + 112 >> 2] = r ^ g & (r ^ k), E[A + 108 >> 2] = t ^ g & (t ^ n), E[A + 104 >> 2] = c ^ g & (c ^ y), E[A + 100 >> 2] = _ ^ g & (_ ^ f), E[A + 96 >> 2] = a ^ g & (a ^ w), E[A + 92 >> 2] = o ^ g & (o ^ p), E[A + 88 >> 2] = i ^ g & (i ^ D), E[A + 84 >> 2] = Q ^ g & (Q ^ h), E[A + 80 >> 2] = B ^ g & (B ^ s), B = E[A + 120 >> 2], s = E[I + 120 >> 2], Q = E[A + 124 >> 2], h = E[I + 124 >> 2], i = E[A + 128 >> 2], D = E[I + 128 >> 2], o = E[A + 132 >> 2], p = E[I + 132 >> 2], a = E[A + 136 >> 2], w = E[I + 136 >> 2], _ = E[A + 140 >> 2], f = E[I + 140 >> 2], c = E[A + 144 >> 2], y = E[I + 144 >> 2], t = E[A + 148 >> 2], n = E[I + 148 >> 2], r = E[A + 152 >> 2], k = E[I + 152 >> 2], e = E[I + 156 >> 2], I = E[A + 156 >> 2], E[A + 156 >> 2] = g & (e ^ I) ^ I, E[A + 152 >> 2] = r ^ g & (r ^ k), E[A + 148 >> 2] = t ^ g & (t ^ n), E[A + 144 >> 2] = c ^ g & (c ^ y), E[A + 140 >> 2] = _ ^ g & (_ ^ f), E[A + 136 >> 2] = a ^ g & (a ^ w), E[A + 132 >> 2] = o ^ g & (o ^ p), E[A + 128 >> 2] = i ^ g & (i ^ D), E[A + 124 >> 2] = Q ^ g & (Q ^ h), E[A + 120 >> 2] = B ^ g & (B ^ s);
                                    }
                                    function GA(A, I, g) {
                                        var C, B, Q = 0, i = 0, a = 0, _ = 0, c = 0, t = 0, r = 0, e = 0, y = 0, s = 0, D = 0, p = 0, w = 0, f = 0, n = 0, k = 0, F = 0, N = 0, S = 0;
                                        return h = C = h - 320 | 0, v(Q = C + 240 | 0, g), Y(Q, Q, g), v(A, Q), Y(A, A, g), Y(A, A, I), PA(A, A), Y(A, A, Q), Y(A, A, I), v(Q = C + 192 | 0, A), Y(Q, Q, g), i = E[I + 4 >> 2], s = E[I + 8 >> 2], p = E[I + 12 >> 2], w = E[I + 16 >> 2], f = E[I + 20 >> 2], n = E[I + 24 >> 2], k = E[I + 28 >> 2], F = E[I + 32 >> 2], N = E[I >> 2], g = E[C + 192 >> 2], Q = E[C + 196 >> 2], a = E[C + 200 >> 2], _ = E[C + 204 >> 2], c = E[C + 208 >> 2], t = E[C + 212 >> 2], r = E[C + 216 >> 2], e = E[C + 220 >> 2], y = E[C + 224 >> 2], D = E[C + 228 >> 2], S = E[I + 36 >> 2], E[C + 180 >> 2] = D - S, E[C + 176 >> 2] = y - F, E[C + 172 >> 2] = e - k, E[C + 168 >> 2] = r - n, E[C + 164 >> 2] = t - f, E[C + 160 >> 2] = c - w, E[C + 156 >> 2] = _ - p, E[C + 152 >> 2] = a - s, E[C + 148 >> 2] = Q - i, E[C + 144 >> 2] = g - N, E[C + 132 >> 2] = D + S, E[C + 128 >> 2] = y + F, E[C + 124 >> 2] = e + k, E[C + 120 >> 2] = r + n, E[C + 116 >> 2] = t + f, E[C + 112 >> 2] = c + w, E[C + 108 >> 2] = _ + p, E[C + 104 >> 2] = a + s, E[C + 100 >> 2] = Q + i, E[C + 96 >> 2] = g + N, Y(i = C + 48 | 0, I, 1648), E[C + 84 >> 2] = D + E[C + 84 >> 2], E[C + 80 >> 2] = y + E[C + 80 >> 2], E[C + 76 >> 2] = e + E[C + 76 >> 2], E[C + 72 >> 2] = r + E[C + 72 >> 2], E[C + 68 >> 2] = t + E[C + 68 >> 2], E[C + 64 >> 2] = c + E[C + 64 >> 2], E[C + 60 >> 2] = _ + E[C + 60 >> 2], E[C + 56 >> 2] = a + E[C + 56 >> 2], E[C + 52 >> 2] = Q + E[C + 52 >> 2], E[C + 48 >> 2] = g + E[C + 48 >> 2], BI(C, C + 144 | 0), p = NI(C, 32), BI(C, C + 96 | 0), s = NI(C, 32), BI(C, i), I = NI(C, 32), Y(C, A, 1648), y = E[A + 4 >> 2], e = E[A + 8 >> 2], r = E[A + 12 >> 2], t = E[A + 16 >> 2], c = E[A + 20 >> 2], _ = E[A + 24 >> 2], a = E[A + 28 >> 2], Q = E[A + 32 >> 2], i = E[A >> 2], w = E[C >> 2], f = E[C + 4 >> 2], n = E[C + 8 >> 2], k = E[C + 12 >> 2], F = E[C + 16 >> 2], N = E[C + 20 >> 2], D = E[C + 24 >> 2], S = E[C + 28 >> 2], B = E[C + 32 >> 2], g = (I = 0 - (I | s) | 0) & ((g = E[A + 36 >> 2]) ^ E[C + 36 >> 2]) ^ g, E[A + 36 >> 2] = g, Q ^= I & (Q ^ B), E[A + 32 >> 2] = Q, a ^= I & (a ^ S), E[A + 28 >> 2] = a, _ ^= I & (_ ^ D), E[A + 24 >> 2] = _, c ^= I & (c ^ N), E[A + 20 >> 2] = c, t ^= I & (t ^ F), E[A + 16 >> 2] = t, r ^= I & (r ^ k), E[A + 12 >> 2] = r, e ^= I & (e ^ n), E[A + 8 >> 2] = e, y ^= I & (y ^ f), E[A + 4 >> 2] = y, i ^= I & (i ^ w), E[A >> 2] = i, BI(C + 288 | 0, A), I = 0 - (1 & o[C + 288 | 0]) | 0, E[A + 36 >> 2] = g ^ I & (g ^ 0 - g), E[A + 32 >> 2] = Q ^ I & (Q ^ 0 - Q), E[A + 28 >> 2] = a ^ I & (a ^ 0 - a), E[A + 24 >> 2] = _ ^ I & (_ ^ 0 - _), E[A + 20 >> 2] = c ^ I & (c ^ 0 - c), E[A + 16 >> 2] = t ^ I & (t ^ 0 - t), E[A + 12 >> 2] = r ^ I & (r ^ 0 - r), E[A + 8 >> 2] = e ^ I & (e ^ 0 - e), E[A + 4 >> 2] = y ^ I & (y ^ 0 - y), E[A >> 2] = i ^ I & (i ^ 0 - i), h = C + 320 | 0, s | p;
                                    }
                                    function MA(A, I, g, C) {
                                        var B, Q = 0, i = 0, _ = 0, c = 0, t = 0, r = 0, e = 0, y = 0, s = 0, D = 0, p = 0, w = 0;
                                        if (h = B = h - 288 | 0, g | C) {
                                            if (Q = (i = E[A + 36 >> 2]) + (C << 3 | g >>> 29) | 0, _ = (r = E[A + 32 >> 2]) + (c = g << 3) | 0, E[A + 32 >> 2] = _, E[A + 36 >> 2] = _ >>> 0 < c >>> 0 ? Q + 1 | 0 : Q, c = 64 - (_ = t = 63 & ((7 & i) << 29 | r >>> 3)) | 0, (0 | C) == (0 | (_ = D = 0 - ((Q = 0) + (_ >>> 0 > 64) | 0) | 0)) & g >>> 0 >= c >>> 0 | C >>> 0 > _ >>> 0) {
                                                if (i = 0, _ = 0, !Q & (63 ^ t) >>> 0 >= 3 | Q) for(w = 124 & c, r = A + 40 | 0; o[(Q = i + t | 0) + r | 0] = a[I + i | 0], o[r + (t + (Q = 1 | i) | 0) | 0] = a[I + Q | 0], o[r + (t + (Q = 2 | i) | 0) | 0] = a[I + Q | 0], o[r + (t + (Q = 3 | i) | 0) | 0] = a[I + Q | 0], Q = _, _ = (i = i + 4 | 0) >>> 0 < 4 ? Q + 1 | 0 : Q, Q = y, y = Q = (s = s + 4 | 0) >>> 0 < 4 ? Q + 1 | 0 : Q, (0 | s) != (0 | w) | (0 | p) != (0 | Q););
                                                if (r = Q = 0, Q | (y = 3 & c)) for(; o[40 + (A + (Q = i + t | 0) | 0) | 0] = a[I + i | 0], Q = _, _ = (i = i + 1 | 0) ? Q : Q + 1 | 0, Q = p, p = Q = (e = e + 1 | 0) ? Q : Q + 1 | 0, (0 | y) != (0 | e) | (0 | r) != (0 | Q););
                                                if (J(A, A + 40 | 0, B, i = B + 256 | 0), I = I + c | 0, !(C = C - ((g >>> 0 < c >>> 0) + D | 0) | 0) & (g = g - c | 0) >>> 0 > 63 | C) for(; J(A, I, B, i), I = I - -64 | 0, Q = C - 1 | 0, !(C = (g = g + -64 | 0) >>> 0 < 4294967232 ? Q + 1 | 0 : Q) & g >>> 0 > 63 | C;);
                                                if (g | C) {
                                                    if (s = 3 & g, c = 0, e = 0, p = 0, i = 0, _ = 0, !C & g >>> 0 >= 4 | C) for(t = -4 & g, r = C, y = A + 40 | 0, g = 0, C = 0; o[i + y | 0] = a[I + i | 0], o[(Q = 1 | i) + y | 0] = a[I + Q | 0], o[(Q = 2 | i) + y | 0] = a[I + Q | 0], o[(Q = 3 | i) + y | 0] = a[I + Q | 0], Q = _, _ = (i = i + 4 | 0) >>> 0 < 4 ? Q + 1 | 0 : Q, Q = C, C = Q = (g = g + 4 | 0) >>> 0 < 4 ? Q + 1 | 0 : Q, (0 | g) != (0 | t) | (0 | r) != (0 | Q););
                                                    if (c | s) for(; o[40 + (A + i | 0) | 0] = a[I + i | 0], _ = (i = i + 1 | 0) ? _ : _ + 1 | 0, Q = p, p = Q = (e = e + 1 | 0) ? Q : Q + 1 | 0, (0 | e) != (0 | s) | (0 | c) != (0 | Q););
                                                }
                                                XC(B, 288);
                                            } else {
                                                if (i = 0, _ = 0, !C & g >>> 0 >= 4 | C) for(c = -4 & g, r = C, C = A + 40 | 0; o[C + (Q = i + t | 0) | 0] = a[I + i | 0], o[C + (D = t + (Q = 1 | i) | 0) | 0] = a[I + Q | 0], o[C + (D = t + (Q = 2 | i) | 0) | 0] = a[I + Q | 0], o[C + (D = t + (Q = 3 | i) | 0) | 0] = a[I + Q | 0], Q = _, _ = (i = i + 4 | 0) >>> 0 < 4 ? Q + 1 | 0 : Q, Q = y, y = Q = (s = s + 4 | 0) >>> 0 < 4 ? Q + 1 | 0 : Q, (0 | c) != (0 | s) | (0 | r) != (0 | Q););
                                                if ((g &= 3) | (C = 0)) for(; o[40 + (A + (Q = i + t | 0) | 0) | 0] = a[I + i | 0], _ = (i = i + 1 | 0) ? _ : _ + 1 | 0, Q = p, p = Q = (e = e + 1 | 0) ? Q : Q + 1 | 0, (0 | g) != (0 | e) | (0 | C) != (0 | Q););
                                            }
                                        }
                                        return h = B + 288 | 0, 0;
                                    }
                                    function bA(A, I) {
                                        var g, C, B, Q, i = 0, _ = 0, c = 0, t = 0, r = 0, e = 0, y = 0, s = 0, D = 0, p = 0, w = 0, f = 0, n = 0, k = 0, F = 0, N = 0, S = 0, G = 0, M = 0, b = 0;
                                        return h = g = h - 320 | 0, pA(C = A + 40 | 0, I), E[A + 84 >> 2] = 0, E[A + 88 >> 2] = 0, E[A + 80 >> 2] = 1, E[A + 92 >> 2] = 0, E[A + 96 >> 2] = 0, E[A + 100 >> 2] = 0, E[A + 104 >> 2] = 0, E[A + 108 >> 2] = 0, E[A + 112 >> 2] = 0, E[A + 116 >> 2] = 0, v(i = g + 240 | 0, C), Y(_ = g + 192 | 0, i, 1600), E[g + 192 >> 2] = E[g + 192 >> 2] + 1, c = E[g + 240 >> 2] - 1 | 0, E[g + 240 >> 2] = c, t = E[g + 244 >> 2], r = E[g + 248 >> 2], e = E[g + 252 >> 2], y = E[g + 256 >> 2], s = E[g + 260 >> 2], D = E[g + 264 >> 2], p = E[g + 268 >> 2], w = E[g + 272 >> 2], f = E[g + 276 >> 2], Y(A, i, _), PA(A, A), Y(A, i, A), v(i = g + 144 | 0, A), Y(i, i, _), i = E[g + 180 >> 2], E[g + 132 >> 2] = i - f, _ = E[g + 176 >> 2], E[g + 128 >> 2] = _ - w, n = E[g + 172 >> 2], E[g + 124 >> 2] = n - p, k = E[g + 168 >> 2], E[g + 120 >> 2] = k - D, F = E[g + 164 >> 2], E[g + 116 >> 2] = F - s, N = E[g + 160 >> 2], E[g + 112 >> 2] = N - y, S = E[g + 156 >> 2], E[g + 108 >> 2] = S - e, G = E[g + 152 >> 2], E[g + 104 >> 2] = G - r, M = E[g + 148 >> 2], E[g + 100 >> 2] = M - t, b = E[g + 144 >> 2], E[g + 96 >> 2] = b - c, E[g + 84 >> 2] = i + f, E[g + 80 >> 2] = _ + w, E[g + 76 >> 2] = p + n, E[g + 72 >> 2] = D + k, E[g + 68 >> 2] = s + F, E[g + 64 >> 2] = y + N, E[g + 60 >> 2] = e + S, E[g + 56 >> 2] = r + G, E[g + 52 >> 2] = t + M, E[g + 48 >> 2] = c + b, BI(g, g + 96 | 0), w = NI(g, 32), BI(g, g + 48 | 0), n = NI(g, 32), Y(g, A, 1648), p = E[A + 4 >> 2], D = E[A + 8 >> 2], s = E[A + 12 >> 2], y = E[A + 16 >> 2], e = E[A + 20 >> 2], r = E[A + 24 >> 2], t = E[A + 28 >> 2], c = E[A + 32 >> 2], f = E[A >> 2], k = E[g >> 2], F = E[g + 4 >> 2], N = E[g + 8 >> 2], S = E[g + 12 >> 2], G = E[g + 16 >> 2], M = E[g + 20 >> 2], b = E[g + 24 >> 2], B = E[g + 28 >> 2], Q = E[g + 32 >> 2], _ = (i = w - 1 | 0) & ((_ = E[A + 36 >> 2]) ^ E[g + 36 >> 2]) ^ _, E[A + 36 >> 2] = _, c ^= i & (c ^ Q), E[A + 32 >> 2] = c, t ^= i & (t ^ B), E[A + 28 >> 2] = t, r ^= i & (r ^ b), E[A + 24 >> 2] = r, e ^= i & (e ^ M), E[A + 20 >> 2] = e, y ^= i & (y ^ G), E[A + 16 >> 2] = y, s ^= i & (s ^ S), E[A + 12 >> 2] = s, D ^= i & (D ^ N), E[A + 8 >> 2] = D, p ^= i & (p ^ F), E[A + 4 >> 2] = p, i = f ^ i & (f ^ k), E[A >> 2] = i, BI(g + 288 | 0, A), I = 0 - (1 & o[g + 288 | 0] ^ a[I + 31 | 0] >>> 7) | 0, E[A + 36 >> 2] = _ ^ I & (_ ^ 0 - _), E[A + 32 >> 2] = c ^ I & (c ^ 0 - c), E[A + 28 >> 2] = t ^ I & (t ^ 0 - t), E[A + 24 >> 2] = r ^ I & (r ^ 0 - r), E[A + 20 >> 2] = e ^ I & (e ^ 0 - e), E[A + 16 >> 2] = y ^ I & (y ^ 0 - y), E[A + 12 >> 2] = s ^ I & (s ^ 0 - s), E[A + 8 >> 2] = D ^ I & (D ^ 0 - D), E[A + 4 >> 2] = p ^ I & (p ^ 0 - p), E[A >> 2] = i ^ I & (i ^ 0 - i), Y(A + 120 | 0, A, C), h = g + 320 | 0, (w | n) - 1 | 0;
                                    }
                                    function KA(A, I) {
                                        var g, C, B, Q, i, o, a, _, c, t, r, e, y, s = 0, D = 0, p = 0, w = 0, f = 0, n = 0, k = 0, F = 0, N = 0, S = 0, G = 0, M = 0, b = 0, K = 0, H = 0, Y = 0, d = 0, J = 0, U = 0;
                                        h = g = h - 48 | 0, v(A, I), v(A + 80 | 0, I + 40 | 0), R(A + 120 | 0, I + 80 | 0), n = E[I + 40 >> 2], D = E[I + 44 >> 2], s = E[I + 4 >> 2], p = E[I + 48 >> 2], k = E[I + 8 >> 2], w = E[I + 52 >> 2], F = E[I + 12 >> 2], f = E[I + 56 >> 2], b = E[I + 16 >> 2], N = E[I + 60 >> 2], K = E[I + 20 >> 2], S = E[I - -64 >> 2], H = E[I + 24 >> 2], G = E[I + 68 >> 2], Y = E[I + 28 >> 2], M = E[I + 72 >> 2], d = E[I + 32 >> 2], U = E[I >> 2], E[A + 76 >> 2] = E[I + 76 >> 2] + E[I + 36 >> 2], E[A + 72 >> 2] = M + d, E[A + 68 >> 2] = G + Y, E[(C = A - -64 | 0) >> 2] = S + H, E[A + 60 >> 2] = N + K, E[A + 56 >> 2] = f + b, E[A + 52 >> 2] = w + F, E[A + 48 >> 2] = p + k, E[A + 44 >> 2] = D + s, E[(I = A + 40 | 0) >> 2] = n + U, v(g, I), n = E[A + 80 >> 2], D = E[A + 4 >> 2], s = E[A + 84 >> 2], p = E[A + 8 >> 2], k = E[A + 88 >> 2], w = E[A + 12 >> 2], F = E[A + 92 >> 2], f = E[A + 16 >> 2], b = E[A + 96 >> 2], N = E[A + 20 >> 2], K = E[A + 100 >> 2], S = E[A + 24 >> 2], H = E[A + 104 >> 2], G = E[A + 28 >> 2], Y = E[A + 108 >> 2], M = E[A + 32 >> 2], d = E[A + 112 >> 2], U = E[A >> 2], Q = (J = E[A + 116 >> 2]) - (B = E[A + 36 >> 2]) | 0, E[A + 116 >> 2] = Q, i = d - M | 0, E[A + 112 >> 2] = i, o = Y - G | 0, E[A + 108 >> 2] = o, a = H - S | 0, E[A + 104 >> 2] = a, _ = K - N | 0, E[A + 100 >> 2] = _, c = b - f | 0, E[A + 96 >> 2] = c, t = F - w | 0, E[A + 92 >> 2] = t, r = k - p | 0, E[A + 88 >> 2] = r, e = s - D | 0, E[A + 84 >> 2] = e, y = n - U | 0, E[A + 80 >> 2] = y, J = J + B | 0, E[A + 76 >> 2] = J, M = M + d | 0, E[A + 72 >> 2] = M, G = G + Y | 0, E[A + 68 >> 2] = G, S = S + H | 0, E[C >> 2] = S, N = N + K | 0, E[A + 60 >> 2] = N, f = f + b | 0, E[A + 56 >> 2] = f, w = w + F | 0, E[A + 52 >> 2] = w, p = p + k | 0, E[A + 48 >> 2] = p, D = D + s | 0, E[A + 44 >> 2] = D, s = I, I = n + U | 0, E[s >> 2] = I, n = E[g >> 2], s = E[g + 4 >> 2], k = E[g + 8 >> 2], F = E[g + 12 >> 2], b = E[g + 16 >> 2], K = E[g + 20 >> 2], H = E[g + 24 >> 2], Y = E[g + 28 >> 2], d = E[g + 32 >> 2], E[A + 36 >> 2] = E[g + 36 >> 2] - J, E[A + 32 >> 2] = d - M, E[A + 28 >> 2] = Y - G, E[A + 24 >> 2] = H - S, E[A + 20 >> 2] = K - N, E[A + 16 >> 2] = b - f, E[A + 12 >> 2] = F - w, E[A + 8 >> 2] = k - p, E[A + 4 >> 2] = s - D, E[A >> 2] = n - I, I = E[A + 120 >> 2], n = E[A + 124 >> 2], D = E[A + 128 >> 2], s = E[A + 132 >> 2], p = E[A + 136 >> 2], k = E[A + 140 >> 2], w = E[A + 144 >> 2], F = E[A + 148 >> 2], f = E[A + 152 >> 2], E[A + 156 >> 2] = E[A + 156 >> 2] - Q, E[A + 152 >> 2] = f - i, E[A + 148 >> 2] = F - o, E[A + 144 >> 2] = w - a, E[A + 140 >> 2] = k - _, E[A + 136 >> 2] = p - c, E[A + 132 >> 2] = s - t, E[A + 128 >> 2] = D - r, E[A + 124 >> 2] = n - e, E[A + 120 >> 2] = I - y, h = g + 48 | 0;
                                    }
                                    function HA(A, I, g) {
                                        var C, B, Q, i, o, a, _, c, t = 0;
                                        h = C = h - 160 | 0, E[A >> 2] = 1, E[A + 4 >> 2] = 0, E[A + 8 >> 2] = 0, E[A + 12 >> 2] = 0, E[A + 16 >> 2] = 0, E[A + 20 >> 2] = 0, E[A + 24 >> 2] = 0, E[A + 28 >> 2] = 0, E[A + 32 >> 2] = 0, E[A + 44 >> 2] = 0, E[A + 48 >> 2] = 0, E[A + 36 >> 2] = 0, E[A + 40 >> 2] = 1, E[A + 52 >> 2] = 0, E[A + 56 >> 2] = 0, E[A + 60 >> 2] = 0, E[A + 64 >> 2] = 0, E[A + 68 >> 2] = 0, E[A + 72 >> 2] = 0, E[A + 76 >> 2] = 0, E[A + 80 >> 2] = 1, Hg(A + 84 | 0, 0, 76), SA(A, I, (255 & (1 ^ (t = g - ((g >> 31 & g) << 1) | 0))) - 1 >>> 31 | 0), SA(A, I + 160 | 0, (255 & (2 ^ t)) - 1 >>> 31 | 0), SA(A, I + 320 | 0, (255 & (3 ^ t)) - 1 >>> 31 | 0), SA(A, I + 480 | 0, (255 & (4 ^ t)) - 1 >>> 31 | 0), SA(A, I + 640 | 0, (255 & (5 ^ t)) - 1 >>> 31 | 0), SA(A, I + 800 | 0, (255 & (6 ^ t)) - 1 >>> 31 | 0), SA(A, I + 960 | 0, (255 & (7 ^ t)) - 1 >>> 31 | 0), SA(A, I + 1120 | 0, (255 & (8 ^ t)) - 1 >>> 31 | 0), I = E[A + 76 >> 2], E[C + 32 >> 2] = E[A + 72 >> 2], E[C + 36 >> 2] = I, t = E[4 + (I = A - -64 | 0) >> 2], E[C + 24 >> 2] = E[I >> 2], E[C + 28 >> 2] = t, I = E[A + 60 >> 2], E[C + 16 >> 2] = E[A + 56 >> 2], E[C + 20 >> 2] = I, I = E[A + 52 >> 2], E[C + 8 >> 2] = E[A + 48 >> 2], E[C + 12 >> 2] = I, I = E[A + 44 >> 2], E[C >> 2] = E[A + 40 >> 2], E[C + 4 >> 2] = I, I = E[A + 36 >> 2], E[C + 72 >> 2] = E[A + 32 >> 2], E[C + 76 >> 2] = I, t = E[A + 28 >> 2], E[(I = C - -64 | 0) >> 2] = E[A + 24 >> 2], E[I + 4 >> 2] = t, I = E[A + 20 >> 2], E[C + 56 >> 2] = E[A + 16 >> 2], E[C + 60 >> 2] = I, I = E[A + 12 >> 2], E[C + 48 >> 2] = E[A + 8 >> 2], E[C + 52 >> 2] = I, I = E[A + 4 >> 2], E[C + 40 >> 2] = E[A >> 2], E[C + 44 >> 2] = I, I = E[A + 92 >> 2], E[C + 88 >> 2] = E[A + 88 >> 2], E[C + 92 >> 2] = I, I = E[A + 100 >> 2], E[C + 96 >> 2] = E[A + 96 >> 2], E[C + 100 >> 2] = I, I = E[A + 108 >> 2], E[C + 104 >> 2] = E[A + 104 >> 2], E[C + 108 >> 2] = I, I = E[A + 116 >> 2], E[C + 112 >> 2] = E[A + 112 >> 2], E[C + 116 >> 2] = I, I = E[A + 84 >> 2], E[C + 80 >> 2] = E[A + 80 >> 2], E[C + 84 >> 2] = I, I = E[A + 120 >> 2], t = E[A + 124 >> 2], B = E[A + 128 >> 2], Q = E[A + 132 >> 2], i = E[A + 136 >> 2], o = E[A + 140 >> 2], a = E[A + 144 >> 2], _ = E[A + 148 >> 2], c = E[A + 152 >> 2], E[C + 156 >> 2] = 0 - E[A + 156 >> 2], E[C + 152 >> 2] = 0 - c, E[C + 148 >> 2] = 0 - _, E[C + 144 >> 2] = 0 - a, E[C + 140 >> 2] = 0 - o, E[C + 136 >> 2] = 0 - i, E[C + 132 >> 2] = 0 - Q, E[C + 128 >> 2] = 0 - B, E[C + 124 >> 2] = 0 - t, E[C + 120 >> 2] = 0 - I, SA(A, C, (128 & g) >>> 7 | 0), h = C + 160 | 0;
                                    }
                                    function YA(A, I) {
                                        A |= 0, I |= 0;
                                        var g, C, B, Q, i, _ = 0, c = 0, t = 0;
                                        return h = c = h - 192 | 0, ag(c, 32), kI(I, c, 32, 0), o[0 | I] = 248 & a[0 | I], o[I + 31 | 0] = 63 & a[I + 31 | 0] | 64, kA(t = c + 32 | 0, I), tg(A, t), g = c, t = E[c + 28 >> 2], c = E[c + 24 >> 2], o[I + 24 | 0] = c, o[I + 25 | 0] = c >>> 8, o[I + 26 | 0] = c >>> 16, o[I + 27 | 0] = c >>> 24, o[I + 28 | 0] = t, o[I + 29 | 0] = t >>> 8, o[I + 30 | 0] = t >>> 16, o[I + 31 | 0] = t >>> 24, t = E[g + 20 >> 2], c = E[g + 16 >> 2], o[I + 16 | 0] = c, o[I + 17 | 0] = c >>> 8, o[I + 18 | 0] = c >>> 16, o[I + 19 | 0] = c >>> 24, o[I + 20 | 0] = t, o[I + 21 | 0] = t >>> 8, o[I + 22 | 0] = t >>> 16, o[I + 23 | 0] = t >>> 24, t = E[g + 12 >> 2], c = E[g + 8 >> 2], o[I + 8 | 0] = c, o[I + 9 | 0] = c >>> 8, o[I + 10 | 0] = c >>> 16, o[I + 11 | 0] = c >>> 24, o[I + 12 | 0] = t, o[I + 13 | 0] = t >>> 8, o[I + 14 | 0] = t >>> 16, o[I + 15 | 0] = t >>> 24, t = E[g + 4 >> 2], c = E[g >> 2], o[0 | I] = c, o[I + 1 | 0] = c >>> 8, o[I + 2 | 0] = c >>> 16, o[I + 3 | 0] = c >>> 24, o[I + 4 | 0] = t, o[I + 5 | 0] = t >>> 8, o[I + 6 | 0] = t >>> 16, o[I + 7 | 0] = t >>> 24, C = a[(_ = A) + 8 | 0] | a[_ + 9 | 0] << 8 | a[_ + 10 | 0] << 16 | a[_ + 11 | 0] << 24, B = a[_ + 12 | 0] | a[_ + 13 | 0] << 8 | a[_ + 14 | 0] << 16 | a[_ + 15 | 0] << 24, Q = a[_ + 16 | 0] | a[_ + 17 | 0] << 8 | a[_ + 18 | 0] << 16 | a[_ + 19 | 0] << 24, t = a[_ + 20 | 0] | a[_ + 21 | 0] << 8 | a[_ + 22 | 0] << 16 | a[_ + 23 | 0] << 24, c = a[0 | _] | a[_ + 1 | 0] << 8 | a[_ + 2 | 0] << 16 | a[_ + 3 | 0] << 24, A = a[_ + 4 | 0] | a[_ + 5 | 0] << 8 | a[_ + 6 | 0] << 16 | a[_ + 7 | 0] << 24, i = a[_ + 28 | 0] | a[_ + 29 | 0] << 8 | a[_ + 30 | 0] << 16 | a[_ + 31 | 0] << 24, _ = a[_ + 24 | 0] | a[_ + 25 | 0] << 8 | a[_ + 26 | 0] << 16 | a[_ + 27 | 0] << 24, o[I + 56 | 0] = _, o[I + 57 | 0] = _ >>> 8, o[I + 58 | 0] = _ >>> 16, o[I + 59 | 0] = _ >>> 24, o[I + 60 | 0] = i, o[I + 61 | 0] = i >>> 8, o[I + 62 | 0] = i >>> 16, o[I + 63 | 0] = i >>> 24, o[I + 48 | 0] = Q, o[I + 49 | 0] = Q >>> 8, o[I + 50 | 0] = Q >>> 16, o[I + 51 | 0] = Q >>> 24, o[I + 52 | 0] = t, o[I + 53 | 0] = t >>> 8, o[I + 54 | 0] = t >>> 16, o[I + 55 | 0] = t >>> 24, o[I + 40 | 0] = C, o[I + 41 | 0] = C >>> 8, o[I + 42 | 0] = C >>> 16, o[I + 43 | 0] = C >>> 24, o[I + 44 | 0] = B, o[I + 45 | 0] = B >>> 8, o[I + 46 | 0] = B >>> 16, o[I + 47 | 0] = B >>> 24, o[I + 32 | 0] = c, o[I + 33 | 0] = c >>> 8, o[I + 34 | 0] = c >>> 16, o[I + 35 | 0] = c >>> 24, o[I + 36 | 0] = A, o[I + 37 | 0] = A >>> 8, o[I + 38 | 0] = A >>> 16, o[I + 39 | 0] = A >>> 24, XC(g, 32), h = g + 192 | 0, 0;
                                    }
                                    function dA(A, I) {
                                        I |= 0;
                                        var g, C, B = 0, Q = 0, i = 0, a = 0;
                                        return h = g = h - 288 | 0, Q = 40 + ((B = E[32 + (A |= 0) >> 2] >>> 3 & 63) + A | 0) | 0, B >>> 0 >= 56 ? (Sg(Q, 34688, 64 - B | 0), J(A, A + 40 | 0, g, g + 256 | 0), E[A + 88 >> 2] = 0, E[A + 92 >> 2] = 0, E[A + 80 >> 2] = 0, E[A + 84 >> 2] = 0, E[A + 72 >> 2] = 0, E[A + 76 >> 2] = 0, E[(B = A - -64 | 0) >> 2] = 0, E[B + 4 >> 2] = 0, E[A + 56 >> 2] = 0, E[A + 60 >> 2] = 0, E[A + 48 >> 2] = 0, E[A + 52 >> 2] = 0, E[A + 40 >> 2] = 0, E[A + 44 >> 2] = 0) : Sg(Q, 34688, 56 - B | 0), i = (B = 16711680 & (Q = E[A + 32 >> 2])) >>> 8 | 0, a = B << 24, C = (B = -16777216 & Q) >>> 24 | 0, B = (a |= B << 8) | -16777216 & ((255 & (B = E[A + 36 >> 2])) << 24 | Q >>> 8) | 16711680 & ((16777215 & B) << 8 | Q >>> 24) | B >>> 8 & 65280 | B >>> 24, o[A + 96 | 0] = B, o[A + 97 | 0] = B >>> 8, o[A + 98 | 0] = B >>> 16, o[A + 99 | 0] = B >>> 24, B = (B = i | C | Q << 24 | (65280 & Q) << 8) | (i = 0) | i, o[A + 100 | 0] = B, o[A + 101 | 0] = B >>> 8, o[A + 102 | 0] = B >>> 16, o[A + 103 | 0] = B >>> 24, J(A, A + 40 | 0, g, g + 256 | 0), B = (B = E[A >> 2]) << 24 | (65280 & B) << 8 | B >>> 8 & 65280 | B >>> 24, o[0 | I] = B, o[I + 1 | 0] = B >>> 8, o[I + 2 | 0] = B >>> 16, o[I + 3 | 0] = B >>> 24, B = (B = E[A + 4 >> 2]) << 24 | (65280 & B) << 8 | B >>> 8 & 65280 | B >>> 24, o[I + 4 | 0] = B, o[I + 5 | 0] = B >>> 8, o[I + 6 | 0] = B >>> 16, o[I + 7 | 0] = B >>> 24, B = (B = E[A + 8 >> 2]) << 24 | (65280 & B) << 8 | B >>> 8 & 65280 | B >>> 24, o[I + 8 | 0] = B, o[I + 9 | 0] = B >>> 8, o[I + 10 | 0] = B >>> 16, o[I + 11 | 0] = B >>> 24, B = (B = E[A + 12 >> 2]) << 24 | (65280 & B) << 8 | B >>> 8 & 65280 | B >>> 24, o[I + 12 | 0] = B, o[I + 13 | 0] = B >>> 8, o[I + 14 | 0] = B >>> 16, o[I + 15 | 0] = B >>> 24, B = (B = E[A + 16 >> 2]) << 24 | (65280 & B) << 8 | B >>> 8 & 65280 | B >>> 24, o[I + 16 | 0] = B, o[I + 17 | 0] = B >>> 8, o[I + 18 | 0] = B >>> 16, o[I + 19 | 0] = B >>> 24, B = (B = E[A + 20 >> 2]) << 24 | (65280 & B) << 8 | B >>> 8 & 65280 | B >>> 24, o[I + 20 | 0] = B, o[I + 21 | 0] = B >>> 8, o[I + 22 | 0] = B >>> 16, o[I + 23 | 0] = B >>> 24, B = (B = E[A + 24 >> 2]) << 24 | (65280 & B) << 8 | B >>> 8 & 65280 | B >>> 24, o[I + 24 | 0] = B, o[I + 25 | 0] = B >>> 8, o[I + 26 | 0] = B >>> 16, o[I + 27 | 0] = B >>> 24, B = (B = E[A + 28 >> 2]) << 24 | (65280 & B) << 8 | B >>> 8 & 65280 | B >>> 24, o[I + 28 | 0] = B, o[I + 29 | 0] = B >>> 8, o[I + 30 | 0] = B >>> 16, o[I + 31 | 0] = B >>> 24, XC(g, 288), XC(A, 104), h = g + 288 | 0, 0;
                                    }
                                    function JA(A, I) {
                                        A |= 0;
                                        var g, C = 0;
                                        h = g = h + -64 | 0, C = a[60 + (I |= 0) | 0] | a[I + 61 | 0] << 8 | a[I + 62 | 0] << 16 | a[I + 63 | 0] << 24, E[g + 56 >> 2] = a[I + 56 | 0] | a[I + 57 | 0] << 8 | a[I + 58 | 0] << 16 | a[I + 59 | 0] << 24, E[g + 60 >> 2] = C, C = a[I + 52 | 0] | a[I + 53 | 0] << 8 | a[I + 54 | 0] << 16 | a[I + 55 | 0] << 24, E[g + 48 >> 2] = a[I + 48 | 0] | a[I + 49 | 0] << 8 | a[I + 50 | 0] << 16 | a[I + 51 | 0] << 24, E[g + 52 >> 2] = C, C = a[I + 44 | 0] | a[I + 45 | 0] << 8 | a[I + 46 | 0] << 16 | a[I + 47 | 0] << 24, E[g + 40 >> 2] = a[I + 40 | 0] | a[I + 41 | 0] << 8 | a[I + 42 | 0] << 16 | a[I + 43 | 0] << 24, E[g + 44 >> 2] = C, C = a[I + 36 | 0] | a[I + 37 | 0] << 8 | a[I + 38 | 0] << 16 | a[I + 39 | 0] << 24, E[g + 32 >> 2] = a[I + 32 | 0] | a[I + 33 | 0] << 8 | a[I + 34 | 0] << 16 | a[I + 35 | 0] << 24, E[g + 36 >> 2] = C, C = a[I + 28 | 0] | a[I + 29 | 0] << 8 | a[I + 30 | 0] << 16 | a[I + 31 | 0] << 24, E[g + 24 >> 2] = a[I + 24 | 0] | a[I + 25 | 0] << 8 | a[I + 26 | 0] << 16 | a[I + 27 | 0] << 24, E[g + 28 >> 2] = C, C = a[I + 20 | 0] | a[I + 21 | 0] << 8 | a[I + 22 | 0] << 16 | a[I + 23 | 0] << 24, E[g + 16 >> 2] = a[I + 16 | 0] | a[I + 17 | 0] << 8 | a[I + 18 | 0] << 16 | a[I + 19 | 0] << 24, E[g + 20 >> 2] = C, C = a[I + 4 | 0] | a[I + 5 | 0] << 8 | a[I + 6 | 0] << 16 | a[I + 7 | 0] << 24, E[g >> 2] = a[0 | I] | a[I + 1 | 0] << 8 | a[I + 2 | 0] << 16 | a[I + 3 | 0] << 24, E[g + 4 >> 2] = C, C = a[I + 12 | 0] | a[I + 13 | 0] << 8 | a[I + 14 | 0] << 16 | a[I + 15 | 0] << 24, E[g + 8 >> 2] = a[I + 8 | 0] | a[I + 9 | 0] << 8 | a[I + 10 | 0] << 16 | a[I + 11 | 0] << 24, E[g + 12 >> 2] = C, N(g), I = E[g + 28 >> 2], C = E[g + 24 >> 2], o[A + 24 | 0] = C, o[A + 25 | 0] = C >>> 8, o[A + 26 | 0] = C >>> 16, o[A + 27 | 0] = C >>> 24, o[A + 28 | 0] = I, o[A + 29 | 0] = I >>> 8, o[A + 30 | 0] = I >>> 16, o[A + 31 | 0] = I >>> 24, I = E[g + 20 >> 2], C = E[g + 16 >> 2], o[A + 16 | 0] = C, o[A + 17 | 0] = C >>> 8, o[A + 18 | 0] = C >>> 16, o[A + 19 | 0] = C >>> 24, o[A + 20 | 0] = I, o[A + 21 | 0] = I >>> 8, o[A + 22 | 0] = I >>> 16, o[A + 23 | 0] = I >>> 24, I = E[g + 12 >> 2], C = E[g + 8 >> 2], o[A + 8 | 0] = C, o[A + 9 | 0] = C >>> 8, o[A + 10 | 0] = C >>> 16, o[A + 11 | 0] = C >>> 24, o[A + 12 | 0] = I, o[A + 13 | 0] = I >>> 8, o[A + 14 | 0] = I >>> 16, o[A + 15 | 0] = I >>> 24, I = E[g + 4 >> 2], C = E[g >> 2], o[0 | A] = C, o[A + 1 | 0] = C >>> 8, o[A + 2 | 0] = C >>> 16, o[A + 3 | 0] = C >>> 24, o[A + 4 | 0] = I, o[A + 5 | 0] = I >>> 8, o[A + 6 | 0] = I >>> 16, o[A + 7 | 0] = I >>> 24, XC(g, 64), h = g - -64 | 0;
                                    }
                                    function UA(A, I, g) {
                                        A |= 0, I |= 0;
                                        var C, B = 0, Q = 0, i = 0, _ = 0, c = 0, t = 0, r = 0, e = 0;
                                        if (h = C = h - 96 | 0, (g |= 0) >>> 0 >= 65 && ($I(A), MA(A, I, g, 0), dA(A, C), g = 32, I = C), $I(A), E[C + 88 >> 2] = 909522486, E[C + 92 >> 2] = 909522486, E[C + 80 >> 2] = 909522486, E[C + 84 >> 2] = 909522486, E[C + 72 >> 2] = 909522486, E[C + 76 >> 2] = 909522486, E[(i = r = C - -64 | 0) >> 2] = 909522486, E[i + 4 >> 2] = 909522486, E[C + 56 >> 2] = 909522486, E[C + 60 >> 2] = 909522486, E[C + 48 >> 2] = 909522486, E[C + 52 >> 2] = 909522486, E[C + 40 >> 2] = 909522486, E[C + 44 >> 2] = 909522486, E[C + 32 >> 2] = 909522486, E[C + 36 >> 2] = 909522486, g) {
                                            if (g >>> 0 >= 4) for(_ = 124 & g; o[0 | (Q = (i = C + 32 | 0) + B | 0)] = a[0 | Q] ^ a[I + B | 0], o[0 | (e = (Q = 1 | B) + i | 0)] = a[0 | e] ^ a[I + Q | 0], o[0 | (e = (Q = 2 | B) + i | 0)] = a[0 | e] ^ a[I + Q | 0], o[0 | (Q = (Q = i) + (i = 3 | B) | 0)] = a[0 | Q] ^ a[I + i | 0], B = B + 4 | 0, (0 | _) != (0 | (c = c + 4 | 0)););
                                            if (c = 3 & g) for(; o[0 | (i = (C + 32 | 0) + B | 0)] = a[0 | i] ^ a[I + B | 0], B = B + 1 | 0, (0 | c) != (0 | (t = t + 1 | 0)););
                                        }
                                        if (MA(A, C + 32 | 0, 64, 0), $I(i = A + 104 | 0), E[C + 88 >> 2] = 1549556828, E[C + 92 >> 2] = 1549556828, E[C + 80 >> 2] = 1549556828, E[C + 84 >> 2] = 1549556828, E[C + 72 >> 2] = 1549556828, E[C + 76 >> 2] = 1549556828, E[r >> 2] = 1549556828, E[r + 4 >> 2] = 1549556828, E[C + 56 >> 2] = 1549556828, E[C + 60 >> 2] = 1549556828, E[C + 48 >> 2] = 1549556828, E[C + 52 >> 2] = 1549556828, E[C + 40 >> 2] = 1549556828, E[C + 44 >> 2] = 1549556828, E[C + 32 >> 2] = 1549556828, E[C + 36 >> 2] = 1549556828, g) {
                                            if (t = 0, B = 0, g >>> 0 >= 4) for(r = 124 & g, c = 0; o[0 | (_ = (A = C + 32 | 0) + B | 0)] = a[0 | _] ^ a[I + B | 0], o[0 | (Q = (_ = 1 | B) + A | 0)] = a[0 | Q] ^ a[I + _ | 0], o[0 | (Q = (_ = 2 | B) + A | 0)] = a[0 | Q] ^ a[I + _ | 0], o[0 | (_ = (Q = A) + (A = 3 | B) | 0)] = a[0 | _] ^ a[A + I | 0], B = B + 4 | 0, (0 | r) != (0 | (c = c + 4 | 0)););
                                            if (A = 3 & g) for(; o[0 | (g = (C + 32 | 0) + B | 0)] = a[0 | g] ^ a[I + B | 0], B = B + 1 | 0, (0 | A) != (0 | (t = t + 1 | 0)););
                                        }
                                        return MA(i, A = C + 32 | 0, 64, 0), XC(A, 64), XC(C, 32), h = C + 96 | 0, 0;
                                    }
                                    function lA(A, I, g, C, B, i, o) {
                                        var a = 0, _ = 0, c = 0, t = 0, r = 0, e = 0, y = 0;
                                        if (I - 65 >>> 0 < 4294967232 | o >>> 0 > 64) A = -1;
                                        else {
                                            e = a = h, h = a = a - 512 & -64;
                                            A: {
                                                I: if (!(!(!(C | B) | g) | !A | ((_ = 255 & I) - 65 & 255) >>> 0 <= 191 | !(!(I = 255 & o) || i) | I >>> 0 >= 65)) {
                                                    if (I) {
                                                        if (!i) break I;
                                                        Hg(a - -64 | 0, 0, 293), E[a + 56 >> 2] = 327033209, E[a + 60 >> 2] = 1541459225, E[a + 48 >> 2] = -79577749, E[a + 52 >> 2] = 528734635, E[a + 40 >> 2] = 725511199, E[a + 44 >> 2] = -1694144372, E[a + 32 >> 2] = -1377402159, E[a + 36 >> 2] = 1359893119, E[a + 24 >> 2] = 1595750129, E[a + 28 >> 2] = -1521486534, E[a + 16 >> 2] = -23791573, E[a + 20 >> 2] = 1013904242, E[a + 8 >> 2] = -2067093701, E[a + 12 >> 2] = -1150833019, E[a >> 2] = -222443256 ^ (I << 8 | _), E[a + 4 >> 2] = I >>> 24 ^ 1779033703, Hg((o = a + 384 | 0) + I | 0, 0, 128 - I | 0), Sg(o, i, I), Sg(a + 96 | 0, o, 128), E[a + 352 >> 2] = 128, XC(o, 128), I = 128;
                                                    } else Hg(a - -64 | 0, 0, 293), E[a + 56 >> 2] = 327033209, E[a + 60 >> 2] = 1541459225, E[a + 48 >> 2] = -79577749, E[a + 52 >> 2] = 528734635, E[a + 40 >> 2] = 725511199, E[a + 44 >> 2] = -1694144372, E[a + 32 >> 2] = -1377402159, E[a + 36 >> 2] = 1359893119, E[a + 24 >> 2] = 1595750129, E[a + 28 >> 2] = -1521486534, E[a + 16 >> 2] = -23791573, E[a + 20 >> 2] = 1013904242, E[a + 8 >> 2] = -2067093701, E[a + 12 >> 2] = -1150833019, E[a >> 2] = -222443256 ^ _, E[a + 4 >> 2] = 1779033703, I = 0;
                                                    g: if (C | B) for(y = a + 224 | 0, c = a + 96 | 0;;){
                                                        if (o = I + c | 0, !B & C >>> 0 <= (i = 256 - I | 0) >>> 0) {
                                                            Sg(o, g, C), E[a + 352 >> 2] = C + E[a + 352 >> 2];
                                                            break g;
                                                        }
                                                        if (Sg(o, g, i), E[a + 352 >> 2] = i + E[a + 352 >> 2], t = I = E[a + 68 >> 2], I = (r = (o = E[a + 64 >> 2]) + 128 | 0) >>> 0 < 128 ? I + 1 | 0 : I, E[a + 64 >> 2] = r, E[a + 68 >> 2] = I, I = E[a + 76 >> 2], I = (t = o = -1 == (0 | t) & o >>> 0 > 4294967167) >>> 0 > (o = o + E[a + 72 >> 2] | 0) >>> 0 ? I + 1 | 0 : I, E[a + 72 >> 2] = o, E[a + 76 >> 2] = I, f(a, c), Sg(c, y, 128), I = E[a + 352 >> 2] - 128 | 0, E[a + 352 >> 2] = I, g = g + i | 0, !((B = B - (C >>> 0 < i >>> 0) | 0) | (C = C - i | 0))) break;
                                                    }
                                                    $(a, A, _), h = e;
                                                    break A;
                                                }
                                                yC(), Q();
                                            }
                                            A = 0;
                                        }
                                        return A;
                                    }
                                    function mA(A, I) {
                                        A |= 0, I |= 0;
                                        var g, C = 0;
                                        h = g = h - 128 | 0, E[g + 80 >> 2] = 0, E[g + 84 >> 2] = 0, E[g + 88 >> 2] = 0, E[g + 92 >> 2] = 0, E[g + 40 >> 2] = 0, E[g + 44 >> 2] = 0, E[g + 48 >> 2] = 0, E[g + 52 >> 2] = 0, E[g + 56 >> 2] = 0, E[g + 60 >> 2] = 0, C = E[8591], E[g + 104 >> 2] = E[8590], E[g + 108 >> 2] = C, C = E[8593], E[g + 112 >> 2] = E[8592], E[g + 116 >> 2] = C, C = E[8595], E[g + 120 >> 2] = E[8594], E[g + 124 >> 2] = C, E[g + 64 >> 2] = 0, E[g + 68 >> 2] = 0, E[g + 72 >> 2] = 0, E[g + 76 >> 2] = 0, o[g + 64 | 0] = 1, E[g + 32 >> 2] = 0, E[g + 36 >> 2] = 0, C = E[8589], E[g + 96 >> 2] = E[8588], E[g + 100 >> 2] = C, C = a[I + 28 | 0] | a[I + 29 | 0] << 8 | a[I + 30 | 0] << 16 | a[I + 31 | 0] << 24, E[g + 24 >> 2] = a[I + 24 | 0] | a[I + 25 | 0] << 8 | a[I + 26 | 0] << 16 | a[I + 27 | 0] << 24, E[g + 28 >> 2] = C, C = a[I + 20 | 0] | a[I + 21 | 0] << 8 | a[I + 22 | 0] << 16 | a[I + 23 | 0] << 24, E[g + 16 >> 2] = a[I + 16 | 0] | a[I + 17 | 0] << 8 | a[I + 18 | 0] << 16 | a[I + 19 | 0] << 24, E[g + 20 >> 2] = C, C = a[I + 12 | 0] | a[I + 13 | 0] << 8 | a[I + 14 | 0] << 16 | a[I + 15 | 0] << 24, E[g + 8 >> 2] = a[I + 8 | 0] | a[I + 9 | 0] << 8 | a[I + 10 | 0] << 16 | a[I + 11 | 0] << 24, E[g + 12 >> 2] = C, C = a[I + 4 | 0] | a[I + 5 | 0] << 8 | a[I + 6 | 0] << 16 | a[I + 7 | 0] << 24, E[g >> 2] = a[0 | I] | a[I + 1 | 0] << 8 | a[I + 2 | 0] << 16 | a[I + 3 | 0] << 24, E[g + 4 >> 2] = C, Eg(I = g - -64 | 0, g), N(I), I = E[g + 92 >> 2], C = E[g + 88 >> 2], o[A + 24 | 0] = C, o[A + 25 | 0] = C >>> 8, o[A + 26 | 0] = C >>> 16, o[A + 27 | 0] = C >>> 24, o[A + 28 | 0] = I, o[A + 29 | 0] = I >>> 8, o[A + 30 | 0] = I >>> 16, o[A + 31 | 0] = I >>> 24, I = E[g + 84 >> 2], C = E[g + 80 >> 2], o[A + 16 | 0] = C, o[A + 17 | 0] = C >>> 8, o[A + 18 | 0] = C >>> 16, o[A + 19 | 0] = C >>> 24, o[A + 20 | 0] = I, o[A + 21 | 0] = I >>> 8, o[A + 22 | 0] = I >>> 16, o[A + 23 | 0] = I >>> 24, I = E[g + 76 >> 2], C = E[g + 72 >> 2], o[A + 8 | 0] = C, o[A + 9 | 0] = C >>> 8, o[A + 10 | 0] = C >>> 16, o[A + 11 | 0] = C >>> 24, o[A + 12 | 0] = I, o[A + 13 | 0] = I >>> 8, o[A + 14 | 0] = I >>> 16, o[A + 15 | 0] = I >>> 24, I = E[g + 68 >> 2], C = E[g + 64 >> 2], o[0 | A] = C, o[A + 1 | 0] = C >>> 8, o[A + 2 | 0] = C >>> 16, o[A + 3 | 0] = C >>> 24, o[A + 4 | 0] = I, o[A + 5 | 0] = I >>> 8, o[A + 6 | 0] = I >>> 16, o[A + 7 | 0] = I >>> 24, h = g + 128 | 0;
                                    }
                                    function uA(A, I, g, C) {
                                        var B = 0, Q = 0, i = 0, _ = 0, c = 0, t = 0, r = 0, e = 0, y = 0, s = 0, h = 0, D = 0;
                                        A: {
                                            if ((i = E[A + 56 >> 2]) | (B = E[A + 60 >> 2])) {
                                                if (y = Q = 16 - i | 0, c = (Q = (0 | (_ = 0 - ((i >>> 0 > 16) + B | 0) | 0)) == (0 | C) & g >>> 0 > Q >>> 0 | C >>> 0 > _ >>> 0) ? y : g, y = Q = Q ? _ : C, Q | c) {
                                                    if (Q = 0, i = 0, !y & c >>> 0 >= 4 | y) for(t = -4 & c, _ = A - -64 | 0; B = Q + E[A + 56 >> 2] | 0, o[B + _ | 0] = a[I + Q | 0], B = (s = 1 | Q) + E[A + 56 >> 2] | 0, o[B + _ | 0] = a[I + s | 0], B = (s = 2 | Q) + E[A + 56 >> 2] | 0, o[B + _ | 0] = a[I + s | 0], B = (s = 3 | Q) + E[A + 56 >> 2] | 0, o[B + _ | 0] = a[I + s | 0], B = i, i = (Q = Q + 4 | 0) >>> 0 < 4 ? B + 1 | 0 : B, B = r, r = B = (e = e + 4 | 0) >>> 0 < 4 ? B + 1 | 0 : B, (0 | e) != (0 | t) | (0 | y) != (0 | B););
                                                    if (_ = B = 0, B | (r = 3 & c)) for(; e = Q + E[A + 56 >> 2] | 0, o[(A + e | 0) - -64 | 0] = a[I + Q | 0], i = (Q = Q + 1 | 0) ? i : i + 1 | 0, B = D, D = B = (h = h + 1 | 0) ? B : B + 1 | 0, (0 | r) != (0 | h) | (0 | _) != (0 | B););
                                                    i = E[A + 56 >> 2], B = E[A + 60 >> 2];
                                                }
                                                if (B = B + y | 0, B = (i = i + c | 0) >>> 0 < c >>> 0 ? B + 1 | 0 : B, E[A + 56 >> 2] = i, E[A + 60 >> 2] = B, !B & i >>> 0 < 16) break A;
                                                rA(A, A - -64 | 0, 16, 0), E[A + 56 >> 2] = 0, E[A + 60 >> 2] = 0, g = (i = g) - c | 0, C = C - ((i >>> 0 < c >>> 0) + y | 0) | 0, I = I + c | 0;
                                            }
                                            if (!C & g >>> 0 >= 16 | C && (rA(A, I, i = -16 & g, C), g &= 15, C = 0, I = I + i | 0), g | C) {
                                                if (h = 0, D = 0, Q = 0, i = 0, !C & g >>> 0 >= 4 | C) for(c = 12 & g, y = 0, _ = A - -64 | 0, e = 0, r = 0; B = Q + E[A + 56 >> 2] | 0, o[B + _ | 0] = a[I + Q | 0], B = (t = 1 | Q) + E[A + 56 >> 2] | 0, o[B + _ | 0] = a[I + t | 0], B = (t = 2 | Q) + E[A + 56 >> 2] | 0, o[B + _ | 0] = a[I + t | 0], B = (t = 3 | Q) + E[A + 56 >> 2] | 0, o[B + _ | 0] = a[I + t | 0], i = (Q = Q + 4 | 0) >>> 0 < 4 ? i + 1 | 0 : i, B = r, r = B = (e = e + 4 | 0) >>> 0 < 4 ? B + 1 | 0 : B, (0 | c) != (0 | e) | (0 | y) != (0 | B););
                                                if (_ = B = 0, B | (r = 3 & g)) for(; B = Q + E[A + 56 >> 2] | 0, o[(A + B | 0) - -64 | 0] = a[I + Q | 0], i = (Q = Q + 1 | 0) ? i : i + 1 | 0, B = D, D = B = (h = h + 1 | 0) ? B : B + 1 | 0, (0 | r) != (0 | h) | (0 | _) != (0 | B););
                                                i = C + E[A + 60 >> 2] | 0, i = (I = g + E[A + 56 >> 2] | 0) >>> 0 < g >>> 0 ? i + 1 | 0 : i, E[A + 56 >> 2] = I, E[A + 60 >> 2] = i;
                                            }
                                        }
                                    }
                                    function xA(A, I) {
                                        A |= 0, I |= 0;
                                        var g, C = 0;
                                        h = g = h - 128 | 0, E[g + 80 >> 2] = 0, E[g + 84 >> 2] = 0, E[g + 88 >> 2] = 0, E[g + 92 >> 2] = 0, E[g + 40 >> 2] = 0, E[g + 44 >> 2] = 0, E[g + 48 >> 2] = 0, E[g + 52 >> 2] = 0, E[g + 56 >> 2] = 0, E[g + 60 >> 2] = 0, C = E[8591], E[g + 104 >> 2] = E[8590], E[g + 108 >> 2] = C, C = E[8593], E[g + 112 >> 2] = E[8592], E[g + 116 >> 2] = C, C = E[8595], E[g + 120 >> 2] = E[8594], E[g + 124 >> 2] = C, E[g + 64 >> 2] = 0, E[g + 68 >> 2] = 0, E[g + 72 >> 2] = 0, E[g + 76 >> 2] = 0, E[g + 32 >> 2] = 0, E[g + 36 >> 2] = 0, C = E[8589], E[g + 96 >> 2] = E[8588], E[g + 100 >> 2] = C, C = a[I + 20 | 0] | a[I + 21 | 0] << 8 | a[I + 22 | 0] << 16 | a[I + 23 | 0] << 24, E[g + 16 >> 2] = a[I + 16 | 0] | a[I + 17 | 0] << 8 | a[I + 18 | 0] << 16 | a[I + 19 | 0] << 24, E[g + 20 >> 2] = C, C = a[I + 28 | 0] | a[I + 29 | 0] << 8 | a[I + 30 | 0] << 16 | a[I + 31 | 0] << 24, E[g + 24 >> 2] = a[I + 24 | 0] | a[I + 25 | 0] << 8 | a[I + 26 | 0] << 16 | a[I + 27 | 0] << 24, E[g + 28 >> 2] = C, C = a[I + 4 | 0] | a[I + 5 | 0] << 8 | a[I + 6 | 0] << 16 | a[I + 7 | 0] << 24, E[g >> 2] = a[0 | I] | a[I + 1 | 0] << 8 | a[I + 2 | 0] << 16 | a[I + 3 | 0] << 24, E[g + 4 >> 2] = C, C = a[I + 12 | 0] | a[I + 13 | 0] << 8 | a[I + 14 | 0] << 16 | a[I + 15 | 0] << 24, E[g + 8 >> 2] = a[I + 8 | 0] | a[I + 9 | 0] << 8 | a[I + 10 | 0] << 16 | a[I + 11 | 0] << 24, E[g + 12 >> 2] = C, Eg(I = g - -64 | 0, g), N(I), I = E[g + 92 >> 2], C = E[g + 88 >> 2], o[A + 24 | 0] = C, o[A + 25 | 0] = C >>> 8, o[A + 26 | 0] = C >>> 16, o[A + 27 | 0] = C >>> 24, o[A + 28 | 0] = I, o[A + 29 | 0] = I >>> 8, o[A + 30 | 0] = I >>> 16, o[A + 31 | 0] = I >>> 24, I = E[g + 84 >> 2], C = E[g + 80 >> 2], o[A + 16 | 0] = C, o[A + 17 | 0] = C >>> 8, o[A + 18 | 0] = C >>> 16, o[A + 19 | 0] = C >>> 24, o[A + 20 | 0] = I, o[A + 21 | 0] = I >>> 8, o[A + 22 | 0] = I >>> 16, o[A + 23 | 0] = I >>> 24, I = E[g + 76 >> 2], C = E[g + 72 >> 2], o[A + 8 | 0] = C, o[A + 9 | 0] = C >>> 8, o[A + 10 | 0] = C >>> 16, o[A + 11 | 0] = C >>> 24, o[A + 12 | 0] = I, o[A + 13 | 0] = I >>> 8, o[A + 14 | 0] = I >>> 16, o[A + 15 | 0] = I >>> 24, I = E[g + 68 >> 2], C = E[g + 64 >> 2], o[0 | A] = C, o[A + 1 | 0] = C >>> 8, o[A + 2 | 0] = C >>> 16, o[A + 3 | 0] = C >>> 24, o[A + 4 | 0] = I, o[A + 5 | 0] = I >>> 8, o[A + 6 | 0] = I >>> 16, o[A + 7 | 0] = I >>> 24, h = g + 128 | 0;
                                    }
                                    function RA(A, I, g) {
                                        var C, B = 0, Q = 0, i = 0, o = 0, a = 0, _ = 0, c = 0, t = 0, r = 0, e = 0, y = 0, s = 0, h = 0, D = 0, p = 0, w = 0, f = 0, n = 0, k = 0;
                                        s = E[I + 4 >> 2], B = E[A + 4 >> 2], h = E[I + 8 >> 2], Q = E[A + 8 >> 2], D = E[I + 12 >> 2], i = E[A + 12 >> 2], p = E[I + 16 >> 2], o = E[A + 16 >> 2], w = E[I + 20 >> 2], a = E[A + 20 >> 2], f = E[I + 24 >> 2], _ = E[A + 24 >> 2], e = E[I + 28 >> 2], c = E[A + 28 >> 2], n = E[I + 32 >> 2], t = E[A + 32 >> 2], k = E[I + 36 >> 2], r = E[A + 36 >> 2], g = 0 - g | 0, y = E[A >> 2], E[A >> 2] = g & (y ^ E[I >> 2]) ^ y, E[A + 36 >> 2] = r ^ g & (r ^ k), E[A + 32 >> 2] = t ^ g & (t ^ n), E[A + 28 >> 2] = c ^ g & (c ^ e), E[A + 24 >> 2] = _ ^ g & (_ ^ f), E[A + 20 >> 2] = a ^ g & (a ^ w), E[A + 16 >> 2] = o ^ g & (o ^ p), E[A + 12 >> 2] = i ^ g & (i ^ D), E[A + 8 >> 2] = Q ^ g & (Q ^ h), E[A + 4 >> 2] = B ^ g & (B ^ s), B = E[A + 40 >> 2], s = E[I + 40 >> 2], Q = E[A + 44 >> 2], h = E[I + 44 >> 2], i = E[A + 48 >> 2], D = E[I + 48 >> 2], o = E[A + 52 >> 2], p = E[I + 52 >> 2], a = E[A + 56 >> 2], w = E[I + 56 >> 2], _ = E[A + 60 >> 2], f = E[I + 60 >> 2], c = E[(e = A - -64 | 0) >> 2], n = E[I - -64 >> 2], t = E[A + 68 >> 2], k = E[I + 68 >> 2], r = E[A + 72 >> 2], y = E[I + 72 >> 2], C = E[A + 76 >> 2], E[A + 76 >> 2] = C ^ g & (E[I + 76 >> 2] ^ C), E[A + 72 >> 2] = r ^ g & (r ^ y), E[A + 68 >> 2] = t ^ g & (t ^ k), E[e >> 2] = c ^ g & (c ^ n), E[A + 60 >> 2] = _ ^ g & (_ ^ f), E[A + 56 >> 2] = a ^ g & (a ^ w), E[A + 52 >> 2] = o ^ g & (o ^ p), E[A + 48 >> 2] = i ^ g & (i ^ D), E[A + 44 >> 2] = Q ^ g & (Q ^ h), E[A + 40 >> 2] = B ^ g & (B ^ s), B = E[A + 80 >> 2], s = E[I + 80 >> 2], Q = E[A + 84 >> 2], h = E[I + 84 >> 2], i = E[A + 88 >> 2], D = E[I + 88 >> 2], o = E[A + 92 >> 2], p = E[I + 92 >> 2], a = E[A + 96 >> 2], w = E[I + 96 >> 2], _ = E[A + 100 >> 2], f = E[I + 100 >> 2], c = E[A + 104 >> 2], e = E[I + 104 >> 2], t = E[A + 108 >> 2], n = E[I + 108 >> 2], r = E[A + 112 >> 2], k = E[I + 112 >> 2], y = E[I + 116 >> 2], I = E[A + 116 >> 2], E[A + 116 >> 2] = g & (y ^ I) ^ I, E[A + 112 >> 2] = r ^ g & (r ^ k), E[A + 108 >> 2] = t ^ g & (t ^ n), E[A + 104 >> 2] = c ^ g & (c ^ e), E[A + 100 >> 2] = _ ^ g & (_ ^ f), E[A + 96 >> 2] = a ^ g & (a ^ w), E[A + 92 >> 2] = o ^ g & (o ^ p), E[A + 88 >> 2] = i ^ g & (i ^ D), E[A + 84 >> 2] = Q ^ g & (Q ^ h), E[A + 80 >> 2] = B ^ g & (B ^ s);
                                    }
                                    function vA(A, I) {
                                        var g, C, B = 0;
                                        for(h = g = h - 192 | 0, v(C = g + 144 | 0, I), v(B = g + 96 | 0, C), v(B, B), Y(B, I, B), Y(C, C, B), v(I = g + 48 | 0, C), Y(B, B, I), v(I, B), v(I, I), v(I, I), v(I, I), v(I, I), Y(B, I, B), v(I, B), v(I, I), v(I, I), v(I, I), v(I, I), v(I, I), v(I, I), v(I, I), v(I, I), v(I, I), Y(I, I, B), v(g, I), v(g, g), v(g, g), v(g, g), v(g, g), v(g, g), v(g, g), v(g, g), v(g, g), v(g, g), v(g, g), v(g, g), v(g, g), v(g, g), v(g, g), v(g, g), v(g, g), v(g, g), v(g, g), v(g, g), Y(I, g, I), v(I, I), v(I, I), v(I, I), v(I, I), v(I, I), v(I, I), v(I, I), v(I, I), v(I, I), v(I, I), Y(B, I, B), v(I, B), v(I, I), v(I, I), v(I, I), v(I, I), v(I, I), v(I, I), v(I, I), v(I, I), v(I, I), v(I, I), v(I, I), v(I, I), v(I, I), v(I, I), v(I, I), v(I, I), v(I, I), v(I, I), v(I, I), v(I, I), v(I, I), v(I, I), v(I, I), v(I, I), v(I, I), v(I, I), v(I, I), v(I, I), v(I, I), v(I, I), v(I, I), v(I, I), v(I, I), v(I, I), v(I, I), v(I, I), v(I, I), v(I, I), v(I, I), v(I, I), v(I, I), v(I, I), v(I, I), v(I, I), v(I, I), v(I, I), v(I, I), v(I, I), v(I, I), Y(I, I, B), v(g, I), I = 1; v(g, g), 100 != (0 | (I = I + 1 | 0)););
                                        Y(I = g + 48 | 0, g, I), v(I, I), v(I, I), v(I, I), v(I, I), v(I, I), v(I, I), v(I, I), v(I, I), v(I, I), v(I, I), v(I, I), v(I, I), v(I, I), v(I, I), v(I, I), v(I, I), v(I, I), v(I, I), v(I, I), v(I, I), v(I, I), v(I, I), v(I, I), v(I, I), v(I, I), v(I, I), v(I, I), v(I, I), v(I, I), v(I, I), v(I, I), v(I, I), v(I, I), v(I, I), v(I, I), v(I, I), v(I, I), v(I, I), v(I, I), v(I, I), v(I, I), v(I, I), v(I, I), v(I, I), v(I, I), v(I, I), v(I, I), v(I, I), v(I, I), v(I, I), Y(B = g + 96 | 0, I, B), v(B, B), v(B, B), v(B, B), v(B, B), v(B, B), Y(A, B, g + 144 | 0), h = g + 192 | 0;
                                    }
                                    function LA(A, I, g, C, B) {
                                        A |= 0, I |= 0, g |= 0, C |= 0;
                                        var i = 0, E = 0, _ = 0, t = 0, r = 0, y = 0, s = 0, h = 0, D = 0, p = 0;
                                        A: {
                                            I: {
                                                g: {
                                                    C: {
                                                        B: {
                                                            Q: {
                                                                i: {
                                                                    if (1 == (-7 & (B |= 0)) && (r = (E = (C >>> 0) / 3 | 0) << 2, (E = c(E, -3) + C | 0) && (r = 2 & B ? (2 | r) + (E >>> 1 | 0) | 0 : r + 4 | 0), !(I >>> 0 <= r >>> 0))) {
                                                                        if (!(4 & B)) {
                                                                            if (!C) {
                                                                                B = 0;
                                                                                break C;
                                                                            }
                                                                            B = 0;
                                                                            break i;
                                                                        }
                                                                        if (!C) {
                                                                            B = 0;
                                                                            break C;
                                                                        }
                                                                        for(B = 0;;){
                                                                            for(s = (h = a[g + y | 0]) | s << 8, E = B, B = 1 + ((((t |= 8) - 6 >>> 0) / 6 | 0) + B | 0) | 0; D = 65510 + (_ = s >>> (t = (i = t) - 6 | 0) & 63) >>> 8 | 0, p = _ + 65484 >>> 8 | 0, o[A + E | 0] = (1 + (16321 ^ _) ^ -1) >>> 8 & 45 | _ + 252 & _ + 65474 >>> 8 & (-1 ^ p) | (_ + 32705 ^ -1) >>> 8 & 95 | D & _ + 65 | p & _ + 71 & (-1 ^ D), (0 | (E = E + 1 | 0)) != (0 | B););
                                                                            if ((0 | (y = y + 1 | 0)) == (0 | C)) break;
                                                                        }
                                                                        if (!t) break B;
                                                                        E = (C = 65510 + (i = h << 12 - i & 63) >>> 8 | 0) & i + 65, t = i + 252 & i + 65474 >>> 8 & (-1 ^ (g = i + 65484 >>> 8 | 0)), C = g & i + 71 & (-1 ^ C), y = i + 32705 | 0, s = 95, g = (1 + (16321 ^ i) ^ -1) >>> 8 & 45;
                                                                        break Q;
                                                                    }
                                                                    yC(), Q();
                                                                }
                                                                for(;;){
                                                                    for(s = (h = a[g + y | 0]) | s << 8, E = B, B = 1 + ((((t |= 8) - 6 >>> 0) / 6 | 0) + B | 0) | 0; D = 65510 + (_ = s >>> (t = (i = t) - 6 | 0) & 63) >>> 8 | 0, p = _ + 65484 >>> 8 | 0, o[A + E | 0] = (1 + (16321 ^ _) ^ -1) >>> 8 & 43 | _ + 252 & _ + 65474 >>> 8 & (-1 ^ p) | (_ + 16321 ^ -1) >>> 8 & 47 | D & _ + 65 | p & _ + 71 & (-1 ^ D), (0 | (E = E + 1 | 0)) != (0 | B););
                                                                    if ((0 | (y = y + 1 | 0)) == (0 | C)) break;
                                                                }
                                                                if (!t) break B;
                                                                E = (C = 65510 + (i = h << 12 - i & 63) >>> 8 | 0) & i + 65, t = i + 252 & i + 65474 >>> 8 & (-1 ^ (g = i + 65484 >>> 8 | 0)), C = g & i + 71 & (-1 ^ C), y = i + 16321 | 0, s = 47, g = (1 + (16321 ^ i) ^ -1) >>> 8 & 43;
                                                            }
                                                            o[A + B | 0] = g | (-1 ^ y) >>> 8 & s | E | t | C, B = B + 1 | 0;
                                                        }
                                                        if (B >>> 0 > r >>> 0) break g;
                                                    }
                                                    if (B >>> 0 < r >>> 0) break I;
                                                    r = B;
                                                    break A;
                                                }
                                                e(1104, 1201, 231, 1505), Q();
                                            }
                                            Hg(A + B | 0, 61, r - B | 0);
                                        }
                                        return Hg(A + r | 0, 0, (I >>> 0 > (g = r + 1 | 0) >>> 0 ? I : g) - r | 0), 0 | A;
                                    }
                                    function PA(A, I) {
                                        var g, C = 0, B = 0;
                                        for(h = g = h - 144 | 0, v(B = g + 96 | 0, I), v(C = g + 48 | 0, B), v(C, C), Y(C, I, C), Y(B, B, C), v(B, B), Y(B, C, B), v(C, B), v(C, C), v(C, C), v(C, C), v(C, C), Y(B, C, B), v(C, B), v(C, C), v(C, C), v(C, C), v(C, C), v(C, C), v(C, C), v(C, C), v(C, C), v(C, C), Y(C, C, B), v(g, C), v(g, g), v(g, g), v(g, g), v(g, g), v(g, g), v(g, g), v(g, g), v(g, g), v(g, g), v(g, g), v(g, g), v(g, g), v(g, g), v(g, g), v(g, g), v(g, g), v(g, g), v(g, g), v(g, g), Y(C, g, C), v(C, C), v(C, C), v(C, C), v(C, C), v(C, C), v(C, C), v(C, C), v(C, C), v(C, C), v(C, C), Y(B, C, B), v(C, B), v(C, C), v(C, C), v(C, C), v(C, C), v(C, C), v(C, C), v(C, C), v(C, C), v(C, C), v(C, C), v(C, C), v(C, C), v(C, C), v(C, C), v(C, C), v(C, C), v(C, C), v(C, C), v(C, C), v(C, C), v(C, C), v(C, C), v(C, C), v(C, C), v(C, C), v(C, C), v(C, C), v(C, C), v(C, C), v(C, C), v(C, C), v(C, C), v(C, C), v(C, C), v(C, C), v(C, C), v(C, C), v(C, C), v(C, C), v(C, C), v(C, C), v(C, C), v(C, C), v(C, C), v(C, C), v(C, C), v(C, C), v(C, C), v(C, C), Y(C, C, B), v(g, C), C = 1; v(g, g), 100 != (0 | (C = C + 1 | 0)););
                                        Y(C = g + 48 | 0, g, C), v(C, C), v(C, C), v(C, C), v(C, C), v(C, C), v(C, C), v(C, C), v(C, C), v(C, C), v(C, C), v(C, C), v(C, C), v(C, C), v(C, C), v(C, C), v(C, C), v(C, C), v(C, C), v(C, C), v(C, C), v(C, C), v(C, C), v(C, C), v(C, C), v(C, C), v(C, C), v(C, C), v(C, C), v(C, C), v(C, C), v(C, C), v(C, C), v(C, C), v(C, C), v(C, C), v(C, C), v(C, C), v(C, C), v(C, C), v(C, C), v(C, C), v(C, C), v(C, C), v(C, C), v(C, C), v(C, C), v(C, C), v(C, C), v(C, C), v(C, C), Y(B = g + 96 | 0, C, B), v(B, B), v(B, B), Y(A, B, I), h = g + 144 | 0;
                                    }
                                    function qA(A, I) {
                                        var g, C, B, Q, i, _, c, t, r, e, y, s, D, p, w, f, n, k, F, N = 0, S = 0, G = 0, M = 0;
                                        h = g = h - 320 | 0, pA(C = A + 40 | 0, I), E[A + 84 >> 2] = 0, E[A + 88 >> 2] = 0, E[A + 80 >> 2] = 1, E[A + 92 >> 2] = 0, E[A + 96 >> 2] = 0, E[A + 100 >> 2] = 0, E[A + 104 >> 2] = 0, E[A + 108 >> 2] = 0, E[A + 112 >> 2] = 0, E[A + 116 >> 2] = 0, v(G = g + 240 | 0, C), Y(S = g + 192 | 0, G, 1600), M = -1, B = E[g + 240 >> 2] - 1 | 0, E[g + 240 >> 2] = B, E[g + 192 >> 2] = E[g + 192 >> 2] + 1, Q = E[g + 244 >> 2], i = E[g + 248 >> 2], _ = E[g + 252 >> 2], c = E[g + 256 >> 2], t = E[g + 260 >> 2], r = E[g + 264 >> 2], e = E[g + 268 >> 2], y = E[g + 272 >> 2], s = E[g + 276 >> 2], v(N = g + 144 | 0, S), Y(N, N, S), v(A, N), Y(A, A, S), Y(A, A, G), PA(A, A), Y(A, A, N), Y(A, A, G), v(N = g + 96 | 0, A), Y(N, N, S), S = E[g + 132 >> 2], E[g + 84 >> 2] = S - s, N = E[g + 128 >> 2], E[g + 80 >> 2] = N - y, G = E[g + 124 >> 2], E[g + 76 >> 2] = G - e, D = E[g + 120 >> 2], E[g + 72 >> 2] = D - r, p = E[g + 116 >> 2], E[g + 68 >> 2] = p - t, w = E[g + 112 >> 2], E[g + 64 >> 2] = w - c, f = E[g + 108 >> 2], E[g + 60 >> 2] = f - _, n = E[g + 104 >> 2], E[g + 56 >> 2] = n - i, k = E[g + 100 >> 2], E[g + 52 >> 2] = k - Q, F = E[g + 96 >> 2], E[g + 48 >> 2] = F - B, BI(g, g + 48 | 0);
                                        A: {
                                            if (!NI(g, 32)) {
                                                if (E[g + 36 >> 2] = S + s, E[g + 32 >> 2] = N + y, E[g + 28 >> 2] = G + e, E[g + 24 >> 2] = r + D, E[g + 20 >> 2] = t + p, E[g + 16 >> 2] = c + w, E[g + 12 >> 2] = _ + f, E[g + 8 >> 2] = i + n, E[g + 4 >> 2] = Q + k, E[g >> 2] = B + F, BI(S = g + 288 | 0, g), !NI(S, 32)) break A;
                                                Y(A, A, 1648);
                                            }
                                            BI(g + 288 | 0, A), (1 & o[g + 288 | 0]) == (a[I + 31 | 0] >>> 7 | 0) && (E[A >> 2] = 0 - E[A >> 2], E[A + 36 >> 2] = 0 - E[A + 36 >> 2], E[A + 32 >> 2] = 0 - E[A + 32 >> 2], E[A + 28 >> 2] = 0 - E[A + 28 >> 2], E[A + 24 >> 2] = 0 - E[A + 24 >> 2], E[A + 20 >> 2] = 0 - E[A + 20 >> 2], E[A + 16 >> 2] = 0 - E[A + 16 >> 2], E[A + 12 >> 2] = 0 - E[A + 12 >> 2], E[A + 8 >> 2] = 0 - E[A + 8 >> 2], E[A + 4 >> 2] = 0 - E[A + 4 >> 2]), Y(A + 120 | 0, A, C), M = 0;
                                        }
                                        return h = g + 320 | 0, M;
                                    }
                                    function zA(A, I, g) {
                                        var C, B, Q, i, o, a, _, t, r = 0;
                                        h = C = h - 128 | 0, E[A >> 2] = 1, E[A + 4 >> 2] = 0, E[A + 8 >> 2] = 0, E[A + 12 >> 2] = 0, E[A + 16 >> 2] = 0, E[A + 20 >> 2] = 0, E[A + 24 >> 2] = 0, E[A + 28 >> 2] = 0, E[A + 32 >> 2] = 0, E[A + 36 >> 2] = 0, E[A + 40 >> 2] = 1, Hg(A + 44 | 0, 0, 76), RA(A, I = c(I, 960) + 3008 | 0, (255 & (1 ^ (r = g - ((g >> 31 & g) << 1) | 0))) - 1 >>> 31 | 0), RA(A, I + 120 | 0, (255 & (2 ^ r)) - 1 >>> 31 | 0), RA(A, I + 240 | 0, (255 & (3 ^ r)) - 1 >>> 31 | 0), RA(A, I + 360 | 0, (255 & (4 ^ r)) - 1 >>> 31 | 0), RA(A, I + 480 | 0, (255 & (5 ^ r)) - 1 >>> 31 | 0), RA(A, I + 600 | 0, (255 & (6 ^ r)) - 1 >>> 31 | 0), RA(A, I + 720 | 0, (255 & (7 ^ r)) - 1 >>> 31 | 0), RA(A, I + 840 | 0, (255 & (8 ^ r)) - 1 >>> 31 | 0), I = E[A + 76 >> 2], E[C + 40 >> 2] = E[A + 72 >> 2], E[C + 44 >> 2] = I, r = E[4 + (I = A - -64 | 0) >> 2], E[C + 32 >> 2] = E[I >> 2], E[C + 36 >> 2] = r, I = E[A + 60 >> 2], E[C + 24 >> 2] = E[A + 56 >> 2], E[C + 28 >> 2] = I, I = E[A + 52 >> 2], E[C + 16 >> 2] = E[A + 48 >> 2], E[C + 20 >> 2] = I, I = E[A + 44 >> 2], E[C + 8 >> 2] = E[A + 40 >> 2], E[C + 12 >> 2] = I, I = E[A + 12 >> 2], E[C + 56 >> 2] = E[A + 8 >> 2], E[C + 60 >> 2] = I, r = E[A + 20 >> 2], E[(I = C - -64 | 0) >> 2] = E[A + 16 >> 2], E[I + 4 >> 2] = r, I = E[A + 28 >> 2], E[C + 72 >> 2] = E[A + 24 >> 2], E[C + 76 >> 2] = I, I = E[A + 36 >> 2], E[C + 80 >> 2] = E[A + 32 >> 2], E[C + 84 >> 2] = I, I = E[A + 4 >> 2], E[C + 48 >> 2] = E[A >> 2], E[C + 52 >> 2] = I, I = E[A + 80 >> 2], r = E[A + 84 >> 2], B = E[A + 88 >> 2], Q = E[A + 92 >> 2], i = E[A + 96 >> 2], o = E[A + 100 >> 2], a = E[A + 104 >> 2], _ = E[A + 108 >> 2], t = E[A + 112 >> 2], E[C + 124 >> 2] = 0 - E[A + 116 >> 2], E[C + 120 >> 2] = 0 - t, E[C + 116 >> 2] = 0 - _, E[C + 112 >> 2] = 0 - a, E[C + 108 >> 2] = 0 - o, E[C + 104 >> 2] = 0 - i, E[C + 100 >> 2] = 0 - Q, E[C + 96 >> 2] = 0 - B, E[C + 92 >> 2] = 0 - r, E[C + 88 >> 2] = 0 - I, RA(A, C + 8 | 0, (128 & g) >>> 7 | 0), h = C + 128 | 0;
                                    }
                                    function jA(A) {
                                        var I, g, C, B, Q, i, o, a, _ = 0, c = 0, t = 0, r = 0, e = 0, y = 0, s = 0, D = 0, p = 0, w = 0, f = 0, n = 0, k = 0, F = 0, N = 0, S = 0, G = 0, M = 0, b = 0, K = 0;
                                        return h = I = h - 320 | 0, v(c = I + 240 | 0, A), v(t = I + 192 | 0, A + 40 | 0), v(_ = I + 144 | 0, A + 80 | 0), A = E[I + 240 >> 2], r = E[I + 192 >> 2], e = E[I + 244 >> 2], y = E[I + 196 >> 2], s = E[I + 248 >> 2], D = E[I + 200 >> 2], p = E[I + 252 >> 2], w = E[I + 204 >> 2], f = E[I + 256 >> 2], n = E[I + 208 >> 2], k = E[I + 260 >> 2], F = E[I + 212 >> 2], N = E[I + 264 >> 2], S = E[I + 216 >> 2], G = E[I + 268 >> 2], M = E[I + 220 >> 2], b = E[I + 272 >> 2], K = E[I + 224 >> 2], E[I + 84 >> 2] = E[I + 228 >> 2] - E[I + 276 >> 2], E[I + 80 >> 2] = K - b, E[I + 76 >> 2] = M - G, E[I + 72 >> 2] = S - N, E[I + 68 >> 2] = F - k, E[I + 64 >> 2] = n - f, E[I + 60 >> 2] = w - p, E[I + 56 >> 2] = D - s, E[I + 52 >> 2] = y - e, E[I + 48 >> 2] = r - A, Y(A = I + 48 | 0, A, _), Y(I, c, t), Y(I, I, 1600), v(I + 96 | 0, _), _ = E[I + 48 >> 2], c = E[I + 96 >> 2], t = E[I >> 2], r = E[I + 52 >> 2], e = E[I + 100 >> 2], y = E[I + 4 >> 2], s = E[I + 56 >> 2], D = E[I + 104 >> 2], p = E[I + 8 >> 2], w = E[I + 60 >> 2], f = E[I + 108 >> 2], n = E[I + 12 >> 2], k = E[I + 64 >> 2], F = E[I + 112 >> 2], N = E[I + 16 >> 2], S = E[I + 68 >> 2], G = E[I + 116 >> 2], M = E[I + 20 >> 2], b = E[I + 72 >> 2], K = E[I + 120 >> 2], g = E[I + 24 >> 2], C = E[I + 76 >> 2], B = E[I + 124 >> 2], Q = E[I + 28 >> 2], i = E[I + 80 >> 2], o = E[I + 128 >> 2], a = E[I + 32 >> 2], E[I + 84 >> 2] = E[I + 84 >> 2] - (E[I + 132 >> 2] + E[I + 36 >> 2] | 0), E[I + 80 >> 2] = i - (o + a | 0), E[I + 76 >> 2] = C - (B + Q | 0), E[I + 72 >> 2] = b - (K + g | 0), E[I + 68 >> 2] = S - (G + M | 0), E[I + 64 >> 2] = k - (F + N | 0), E[I + 60 >> 2] = w - (f + n | 0), E[I + 56 >> 2] = s - (D + p | 0), E[I + 52 >> 2] = r - (e + y | 0), E[I + 48 >> 2] = _ - (c + t | 0), BI(_ = I + 288 | 0, A), A = NI(_, 32), h = I + 320 | 0, A;
                                    }
                                    function XA(A, I, g, C) {
                                        var B = 0, Q = 0, i = 0, E = 0, _ = 0, c = 0, t = 0;
                                        if (g | C) A: for(t = A + 224 | 0, _ = A + 96 | 0, Q = a[A + 352 | 0] | a[A + 353 | 0] << 8 | a[A + 354 | 0] << 16 | a[A + 355 | 0] << 24;;){
                                            if (B = Q + _ | 0, !C & g >>> 0 <= (i = 256 - Q | 0) >>> 0) {
                                                Sg(B, I, g), I = g + (a[A + 352 | 0] | a[A + 353 | 0] << 8 | a[A + 354 | 0] << 16 | a[A + 355 | 0] << 24) | 0, o[A + 352 | 0] = I, o[A + 353 | 0] = I >>> 8, o[A + 354 | 0] = I >>> 16, o[A + 355 | 0] = I >>> 24;
                                                break A;
                                            }
                                            if (Sg(B, I, i), B = (a[A + 352 | 0] | a[A + 353 | 0] << 8 | a[A + 354 | 0] << 16 | a[A + 355 | 0] << 24) + i | 0, o[A + 352 | 0] = B, o[A + 353 | 0] = B >>> 8, o[A + 354 | 0] = B >>> 16, o[A + 355 | 0] = B >>> 24, c = Q = a[A + 68 | 0] | a[A + 69 | 0] << 8 | a[A + 70 | 0] << 16 | a[A + 71 | 0] << 24, Q = (E = 128 + (B = a[A + 64 | 0] | a[A + 65 | 0] << 8 | a[A + 66 | 0] << 16 | a[A + 67 | 0] << 24) | 0) >>> 0 < 128 ? Q + 1 | 0 : Q, o[A + 64 | 0] = E, o[A + 65 | 0] = E >>> 8, o[A + 66 | 0] = E >>> 16, o[A + 67 | 0] = E >>> 24, o[A + 68 | 0] = Q, o[A + 69 | 0] = Q >>> 8, o[A + 70 | 0] = Q >>> 16, o[A + 71 | 0] = Q >>> 24, Q = a[A + 76 | 0] | a[A + 77 | 0] << 8 | a[A + 78 | 0] << 16 | a[A + 79 | 0] << 24, Q = (c = B = -1 == (0 | c) & B >>> 0 > 4294967167) >>> 0 > (B = B + (a[A + 72 | 0] | a[A + 73 | 0] << 8 | a[A + 74 | 0] << 16 | a[A + 75 | 0] << 24) | 0) >>> 0 ? Q + 1 | 0 : Q, o[A + 72 | 0] = B, o[A + 73 | 0] = B >>> 8, o[A + 74 | 0] = B >>> 16, o[A + 75 | 0] = B >>> 24, o[A + 76 | 0] = Q, o[A + 77 | 0] = Q >>> 8, o[A + 78 | 0] = Q >>> 16, o[A + 79 | 0] = Q >>> 24, f(A, _), Sg(_, t, 128), B = Q = (a[A + 352 | 0] | a[A + 353 | 0] << 8 | a[A + 354 | 0] << 16 | a[A + 355 | 0] << 24) - 128 | 0, o[A + 352 | 0] = B, o[A + 353 | 0] = B >>> 8, o[A + 354 | 0] = B >>> 16, o[A + 355 | 0] = B >>> 24, I = I + i | 0, !((C = C - (g >>> 0 < i >>> 0) | 0) | (g = g - i | 0))) break;
                                        }
                                        return 0;
                                    }
                                    function OA(A) {
                                        var I = 0, g = 0, C = 0, B = 0, Q = 0, i = 0, o = 0, a = 0, _ = 0, c = 0, t = 0, r = 0, e = 0, y = 0, s = 0, h = 0, D = 0, p = 0, w = 0, f = 0, n = 0;
                                        for(g = E[A + 60 >> 2], h = E[A + 56 >> 2], s = E[A + 52 >> 2], e = E[A + 48 >> 2], I = E[A + 44 >> 2], C = E[A + 40 >> 2], D = E[A + 36 >> 2], r = E[A + 32 >> 2], B = E[A + 28 >> 2], Q = E[A + 24 >> 2], i = E[A + 20 >> 2], o = E[A + 16 >> 2], a = E[A + 12 >> 2], _ = E[A + 8 >> 2], c = E[A + 4 >> 2], t = E[A >> 2]; y = Lg(i + c | 0, 7) ^ D, p = Lg(y + i | 0, 9) ^ s, o = Lg(t + e | 0, 7) ^ o, w = Lg(o + t | 0, 9) ^ r, f = Lg(w + o | 0, 13) ^ e, a = Lg(I + g | 0, 7) ^ a, B = Lg(a + g | 0, 9) ^ B, r = Lg(B + a | 0, 13) ^ I, g = Lg(B + r | 0, 18) ^ g, I = Lg(C + Q | 0, 7) ^ h, e = f ^ Lg(g + I | 0, 7), s = p ^ Lg(e + g | 0, 9), h = Lg(e + s | 0, 13) ^ I, g = Lg(s + h | 0, 18) ^ g, _ = Lg(I + C | 0, 9) ^ _, Q = Lg(_ + I | 0, 13) ^ Q, C = Lg(Q + _ | 0, 18) ^ C, I = Lg(C + y | 0, 7) ^ r, r = Lg(I + C | 0, 9) ^ w, D = Lg(I + r | 0, 13) ^ y, C = Lg(r + D | 0, 18) ^ C, c = Lg(y + p | 0, 13) ^ c, i = Lg(c + p | 0, 18) ^ i, Q = Lg(i + o | 0, 7) ^ Q, B = Lg(Q + i | 0, 9) ^ B, o = Lg(B + Q | 0, 13) ^ o, i = Lg(o + B | 0, 18) ^ i, t = Lg(w + f | 0, 18) ^ t, c = Lg(t + a | 0, 7) ^ c, _ = Lg(c + t | 0, 9) ^ _, a = Lg(_ + c | 0, 13) ^ a, t = Lg(a + _ | 0, 18) ^ t, y = n >>> 0 < 6, n = n + 2 | 0, y;);
                                        E[A >> 2] = E[A >> 2] + t, E[A + 4 >> 2] = E[A + 4 >> 2] + c, E[A + 8 >> 2] = E[A + 8 >> 2] + _, E[A + 12 >> 2] = E[A + 12 >> 2] + a, E[A + 16 >> 2] = E[A + 16 >> 2] + o, E[A + 20 >> 2] = E[A + 20 >> 2] + i, E[A + 24 >> 2] = E[A + 24 >> 2] + Q, E[A + 28 >> 2] = E[A + 28 >> 2] + B, E[A + 32 >> 2] = E[A + 32 >> 2] + r, E[A + 36 >> 2] = E[A + 36 >> 2] + D, E[A + 40 >> 2] = E[A + 40 >> 2] + C, E[A + 44 >> 2] = E[A + 44 >> 2] + I, E[A + 48 >> 2] = E[A + 48 >> 2] + e, E[A + 52 >> 2] = E[A + 52 >> 2] + s, E[A + 56 >> 2] = E[A + 56 >> 2] + h, E[A + 60 >> 2] = E[A + 60 >> 2] + g;
                                    }
                                    function VA(A, I, g, C) {
                                        var B, Q = 0;
                                        return h = B = h - 320 | 0, Q = -1, GI(g) && (bI(g) || bA(B, g) || IA(B) && (o[0 | A] = a[0 | I], o[A + 1 | 0] = a[I + 1 | 0], o[A + 2 | 0] = a[I + 2 | 0], o[A + 3 | 0] = a[I + 3 | 0], o[A + 4 | 0] = a[I + 4 | 0], o[A + 5 | 0] = a[I + 5 | 0], o[A + 6 | 0] = a[I + 6 | 0], o[A + 7 | 0] = a[I + 7 | 0], o[A + 8 | 0] = a[I + 8 | 0], o[A + 9 | 0] = a[I + 9 | 0], o[A + 10 | 0] = a[I + 10 | 0], o[A + 11 | 0] = a[I + 11 | 0], o[A + 12 | 0] = a[I + 12 | 0], o[A + 13 | 0] = a[I + 13 | 0], o[A + 14 | 0] = a[I + 14 | 0], o[A + 15 | 0] = a[I + 15 | 0], o[A + 16 | 0] = a[I + 16 | 0], o[A + 17 | 0] = a[I + 17 | 0], o[A + 18 | 0] = a[I + 18 | 0], o[A + 19 | 0] = a[I + 19 | 0], o[A + 20 | 0] = a[I + 20 | 0], o[A + 21 | 0] = a[I + 21 | 0], o[A + 22 | 0] = a[I + 22 | 0], o[A + 23 | 0] = a[I + 23 | 0], o[A + 24 | 0] = a[I + 24 | 0], o[A + 25 | 0] = a[I + 25 | 0], o[A + 26 | 0] = a[I + 26 | 0], o[A + 27 | 0] = a[I + 27 | 0], o[A + 28 | 0] = a[I + 28 | 0], o[A + 29 | 0] = a[I + 29 | 0], o[A + 30 | 0] = a[I + 30 | 0], g = a[I + 31 | 0], C && (o[0 | A] = 248 & a[0 | A], g |= 64), o[A + 31 | 0] = 127 & g, u(g = B + 160 | 0, A, B), tg(A, g), (127 & a[A + 31 | 0] | a[A + 30 | 0] | a[A + 29 | 0] | a[A + 28 | 0] | a[A + 27 | 0] | a[A + 26 | 0] | a[A + 25 | 0] | a[A + 24 | 0] | a[A + 23 | 0] | a[A + 22 | 0] | a[A + 21 | 0] | a[A + 20 | 0] | a[A + 19 | 0] | a[A + 18 | 0] | a[A + 17 | 0] | a[A + 16 | 0] | a[A + 15 | 0] | a[A + 14 | 0] | a[A + 13 | 0] | a[A + 12 | 0] | a[A + 11 | 0] | a[A + 10 | 0] | a[A + 9 | 0] | a[A + 8 | 0] | a[A + 7 | 0] | a[A + 6 | 0] | a[A + 5 | 0] | a[A + 4 | 0] | a[A + 3 | 0] | a[A + 2 | 0] | a[A + 1 | 0] | 1 ^ a[0 | A]) - 1 & 256 || (Q = NI(I, 32) ? -1 : 0))), h = B + 320 | 0, Q;
                                    }
                                    function ZA(A, I, g, C, B) {
                                        var Q, i = 0, _ = 0, c = 0, t = 0, r = 0, e = 0, y = 0, s = 0;
                                        if (h = Q = h - 48 | 0, B && ag(B, 102), !(36 != a[0 | C] | 55 != a[C + 1 | 0] | 36 != a[C + 2 | 0]) && (r = uI(a[C + 3 | 0])) && (i = PI(Q + 12 | 0, C + 4 | 0)) && (t = PI(Q + 8 | 0, i))) {
                                            for(_ = LI(t) + 1 | 0; i = 0, _ && 36 != a[0 | (i = t + (_ = _ - 1 | 0) | 0)];);
                                            if (c = i - t | 0, i || (c = LI(t)), !((c = 45 + (_ = (i = c) + (t - C | 0) | 0) | 0) >>> 0 > 102 | i >>> 0 > c >>> 0 || (c = A, y = I, s = g, A = 31 & (r = r - 1024 | 0), (63 & r) >>> 0 >= 32 ? (I = 1 << A, g = 0) : I = (g = 1 << A) - 1 & 1 >>> 32 - A, _A(c, y, s, t, i, g, I, E[Q + 12 >> 2], E[Q + 8 >> 2], Q + 16 | 0, 32)))) {
                                                for(i = Sg(B, C, _), o[0 | (A = i + _ | 0)] = 36, e = (c = i + 102 | 0) - (B = A + 1 | 0) | 0, g = 0;;){
                                                    A: if ((I = g) >>> 0 > 31) C = B;
                                                    else if (A = B, g = (_ = I + 1 | 0) + (y = (g = 31 - I | 0) >>> 0 >= 2 ? 2 : g) | 0, C = 0, t = 0, B = a[(r = Q + 16 | 0) + I | 0], y && (B = a[_ + r | 0] << 8 | B, (0 | (I = I + 2 | 0)) != (0 | g) && (t = 1, B = a[I + r | 0] << 16 | B)), e && (o[0 | A] = a[1024 + (63 & B) | 0], 1 != (0 | e))) {
                                                        if (o[A + 1 | 0] = a[1024 + (B >>> 6 & 63) | 0], y = A + e | 0, I = A + 2 | 0, (0 | g) != (0 | _)) {
                                                            if (2 == (0 | e)) break A;
                                                            if (o[A + 2 | 0] = a[1024 + (B >>> 12 & 63) | 0], I = A + 3 | 0, t) {
                                                                if (3 == (0 | e)) break A;
                                                                o[A + 3 | 0] = a[1024 + (B >>> 18 | 0) | 0], I = A + 4 | 0;
                                                            }
                                                        }
                                                        if (e = y - (B = I) | 0, B) continue;
                                                    }
                                                    break;
                                                }
                                                XC(Q + 16 | 0, 32), e = 0, !C | C >>> 0 >= c >>> 0 || (o[0 | C] = 0, e = i);
                                            }
                                        }
                                        return h = Q + 48 | 0, e;
                                    }
                                    function WA(A, I, g) {
                                        var C, B, Q, i = 0, o = 0, _ = 0, t = 0;
                                        h = C = h - 16 | 0, B = E[A + 20 >> 2], E[A + 20 >> 2] = 0, Q = E[A + 4 >> 2], E[A + 4 >> 2] = 0, i = -26;
                                        A: {
                                            I: {
                                                g: {
                                                    C: switch(g - 1 | 0){
                                                        case 1:
                                                            if (i = -32, Cg(I, 1165, 9)) break A;
                                                            I = I + 9 | 0;
                                                            break g;
                                                        case 0:
                                                            break C;
                                                        default:
                                                            break A;
                                                    }
                                                    if (i = -32, Cg(I, 1156, 8)) break A;
                                                    I = I + 8 | 0;
                                                }
                                                if (!((i = Cg(I, 1422, 3)) || ((o = a[0 | (g = I + 3 | 0)]) - 58 & 255) >>> 0 < 246)) {
                                                    for(t = i ? I : g, I = 0, i = o;;){
                                                        if (_ = g, I >>> 0 > 429496729) break I;
                                                        if ((i = (255 & i) - 48 | 0) >>> 0 > (-1 ^ (I = c(I, 10))) >>> 0) break I;
                                                        if (I = I + i | 0, !(((i = a[0 | (g = g + 1 | 0)]) - 58 & 255) >>> 0 > 245)) break;
                                                    }
                                                    if (!(48 == (0 | o) & (0 | t) != (0 | _) | (0 | g) == (0 | t))) {
                                                        if (i = -26, 19 != (0 | I)) break A;
                                                        if (!Cg(g, 1434, 3) && (g = mI(_ + 4 | 0, I = C + 12 | 0)) && (E[A + 44 >> 2] = E[C + 12 >> 2], !Cg(g, 1426, 3) && (g = mI(g + 3 | 0, I)) && (E[A + 40 >> 2] = E[C + 12 >> 2], !Cg(g, 1430, 3) && (g = mI(g + 3 | 0, I)) && (i = E[C + 12 >> 2], E[A + 48 >> 2] = i, E[A + 52 >> 2] = i, 36 == a[0 | g] && (E[C + 12 >> 2] = B, !wA(i = E[A + 16 >> 2], B, _ = g = g + 1 | 0, o = LI(g), 0, I, g = C + 8 | 0, 3) && (E[A + 20 >> 2] = E[C + 12 >> 2], i = E[C + 8 >> 2], 36 == a[0 | i] && (E[C + 12 >> 2] = Q, i = i + 1 | 0, !wA(E[A >> 2], Q, i, LI(i), 0, I, g, 3)))))))) {
                                                            if (E[A + 4 >> 2] = E[C + 12 >> 2], I = E[C + 8 >> 2], i = pI(A)) break A;
                                                            i = a[0 | I] ? -32 : 0;
                                                            break A;
                                                        }
                                                    }
                                                }
                                            }
                                            i = -32;
                                        }
                                        return h = C + 16 | 0, i;
                                    }
                                    function TA(A, I) {
                                        var g, C = 0, B = 0, Q = 0, i = 0, o = 0, a = 0, _ = 0, c = 0, t = 0, r = 0, e = 0, y = 0, s = 0, h = 0, D = 0, p = 0, w = 0, f = 0;
                                        C = E[I + 40 >> 2], Q = E[I + 4 >> 2], i = E[I + 44 >> 2], o = E[I + 8 >> 2], a = E[I + 48 >> 2], _ = E[I + 12 >> 2], c = E[I + 52 >> 2], t = E[I + 16 >> 2], r = E[I + 56 >> 2], e = E[I + 20 >> 2], y = E[I + 60 >> 2], s = E[I + 24 >> 2], h = E[(B = I - -64 | 0) >> 2], D = E[I + 28 >> 2], p = E[I + 68 >> 2], w = E[I + 32 >> 2], f = E[I + 72 >> 2], g = E[I >> 2], E[A + 36 >> 2] = E[I + 36 >> 2] + E[I + 76 >> 2], E[A + 32 >> 2] = w + f, E[A + 28 >> 2] = D + p, E[A + 24 >> 2] = s + h, E[A + 20 >> 2] = e + y, E[A + 16 >> 2] = t + r, E[A + 12 >> 2] = _ + c, E[A + 8 >> 2] = o + a, E[A + 4 >> 2] = Q + i, E[A >> 2] = C + g, C = E[I + 40 >> 2], Q = E[I + 4 >> 2], i = E[I + 44 >> 2], o = E[I + 8 >> 2], a = E[I + 48 >> 2], _ = E[I + 12 >> 2], c = E[I + 52 >> 2], t = E[I + 16 >> 2], r = E[I + 56 >> 2], e = E[I + 20 >> 2], y = E[I + 60 >> 2], s = E[I + 24 >> 2], B = E[B >> 2], h = E[I + 28 >> 2], D = E[I + 68 >> 2], p = E[I + 32 >> 2], w = E[I + 72 >> 2], f = E[I >> 2], E[A + 76 >> 2] = E[I + 76 >> 2] - E[I + 36 >> 2], E[A + 72 >> 2] = w - p, E[A + 68 >> 2] = D - h, E[A - -64 >> 2] = B - s, E[A + 60 >> 2] = y - e, E[A + 56 >> 2] = r - t, E[A + 52 >> 2] = c - _, E[A + 48 >> 2] = a - o, E[A + 44 >> 2] = i - Q, E[A + 40 >> 2] = C - f, C = E[I + 84 >> 2], E[A + 80 >> 2] = E[I + 80 >> 2], E[A + 84 >> 2] = C, C = E[I + 92 >> 2], E[A + 88 >> 2] = E[I + 88 >> 2], E[A + 92 >> 2] = C, C = E[I + 100 >> 2], E[A + 96 >> 2] = E[I + 96 >> 2], E[A + 100 >> 2] = C, C = E[I + 108 >> 2], E[A + 104 >> 2] = E[I + 104 >> 2], E[A + 108 >> 2] = C, C = E[I + 116 >> 2], E[A + 112 >> 2] = E[I + 112 >> 2], E[A + 116 >> 2] = C, Y(A + 120 | 0, I + 120 | 0, 1696);
                                    }
                                    function $A(A, I, g) {
                                        var C, B, Q, i, o, a, _, c, t, r, e, y, s = 0, D = 0, p = 0, w = 0, f = 0;
                                        s = E[I + 12 >> 2], D = E[I + 8 >> 2], p = E[I + 4 >> 2], C = h + -64 & -64, I = E[I >> 2], E[C >> 2] = E[35760 + ((255 & I) << 2) >> 2], E[C + 4 >> 2] = E[35760 + (p >>> 6 & 1020) >> 2], E[C + 8 >> 2] = E[35760 + (D >>> 14 & 1020) >> 2], E[C + 12 >> 2] = E[35760 + (s >>> 22 & 1020) >> 2], E[C + 16 >> 2] = E[35760 + ((255 & p) << 2) >> 2], E[C + 20 >> 2] = E[35760 + (D >>> 6 & 1020) >> 2], E[C + 24 >> 2] = E[35760 + (s >>> 14 & 1020) >> 2], E[C + 28 >> 2] = E[35760 + (I >>> 22 & 1020) >> 2], E[C + 32 >> 2] = E[35760 + ((255 & D) << 2) >> 2], E[C + 36 >> 2] = E[35760 + (s >>> 6 & 1020) >> 2], E[C + 40 >> 2] = E[35760 + (I >>> 14 & 1020) >> 2], E[C + 44 >> 2] = E[35760 + (p >>> 22 & 1020) >> 2], E[C + 48 >> 2] = E[35760 + ((255 & s) << 2) >> 2], E[C + 52 >> 2] = E[35760 + (I >>> 6 & 1020) >> 2], E[C + 56 >> 2] = E[35760 + (p >>> 14 & 1020) >> 2], E[C + 60 >> 2] = E[35760 + (D >>> 22 & 1020) >> 2], I = E[C + 12 >> 2], s = E[C >> 2], D = E[C + 4 >> 2], p = E[C + 8 >> 2], B = E[C + 28 >> 2], Q = E[C + 16 >> 2], i = E[C + 20 >> 2], o = E[C + 24 >> 2], a = E[C + 44 >> 2], _ = E[C + 32 >> 2], c = E[C + 36 >> 2], t = E[C + 40 >> 2], r = E[g >> 2], e = E[g + 4 >> 2], y = E[g + 8 >> 2], w = A, f = E[g + 12 >> 2] ^ E[C + 48 >> 2] ^ Lg(E[C + 52 >> 2], 8) ^ Lg(E[C + 56 >> 2], 16) ^ Lg(E[C + 60 >> 2], 24), E[w + 12 >> 2] = f, w = A, f = Lg(c, 8) ^ _ ^ Lg(t, 16) ^ Lg(a, 24) ^ y, E[w + 8 >> 2] = f, w = A, f = Lg(i, 8) ^ Q ^ Lg(o, 16) ^ Lg(B, 24) ^ e, E[w + 4 >> 2] = f, w = A, f = Lg(D, 8) ^ s ^ Lg(p, 16) ^ Lg(I, 24) ^ r, E[w >> 2] = f;
                                    }
                                    function AI(A, I, g) {
                                        var C, B = 0;
                                        return h = C = h - 160 | 0, o[0 | A] = a[0 | I], o[A + 1 | 0] = a[I + 1 | 0], o[A + 2 | 0] = a[I + 2 | 0], o[A + 3 | 0] = a[I + 3 | 0], o[A + 4 | 0] = a[I + 4 | 0], o[A + 5 | 0] = a[I + 5 | 0], o[A + 6 | 0] = a[I + 6 | 0], o[A + 7 | 0] = a[I + 7 | 0], o[A + 8 | 0] = a[I + 8 | 0], o[A + 9 | 0] = a[I + 9 | 0], o[A + 10 | 0] = a[I + 10 | 0], o[A + 11 | 0] = a[I + 11 | 0], o[A + 12 | 0] = a[I + 12 | 0], o[A + 13 | 0] = a[I + 13 | 0], o[A + 14 | 0] = a[I + 14 | 0], o[A + 15 | 0] = a[I + 15 | 0], o[A + 16 | 0] = a[I + 16 | 0], o[A + 17 | 0] = a[I + 17 | 0], o[A + 18 | 0] = a[I + 18 | 0], o[A + 19 | 0] = a[I + 19 | 0], o[A + 20 | 0] = a[I + 20 | 0], o[A + 21 | 0] = a[I + 21 | 0], o[A + 22 | 0] = a[I + 22 | 0], o[A + 23 | 0] = a[I + 23 | 0], o[A + 24 | 0] = a[I + 24 | 0], o[A + 25 | 0] = a[I + 25 | 0], o[A + 26 | 0] = a[I + 26 | 0], o[A + 27 | 0] = a[I + 27 | 0], o[A + 28 | 0] = a[I + 28 | 0], o[A + 29 | 0] = a[I + 29 | 0], o[A + 30 | 0] = a[I + 30 | 0], B = a[I + 31 | 0], g && (o[0 | A] = 248 & a[0 | A], B |= 64), o[A + 31 | 0] = 127 & B, kA(C, A), tg(A, C), g = -1, (127 & a[A + 31 | 0] | a[A + 30 | 0] | a[A + 29 | 0] | a[A + 28 | 0] | a[A + 27 | 0] | a[A + 26 | 0] | a[A + 25 | 0] | a[A + 24 | 0] | a[A + 23 | 0] | a[A + 22 | 0] | a[A + 21 | 0] | a[A + 20 | 0] | a[A + 19 | 0] | a[A + 18 | 0] | a[A + 17 | 0] | a[A + 16 | 0] | a[A + 15 | 0] | a[A + 14 | 0] | a[A + 13 | 0] | a[A + 12 | 0] | a[A + 11 | 0] | a[A + 10 | 0] | a[A + 9 | 0] | a[A + 8 | 0] | a[A + 7 | 0] | a[A + 6 | 0] | a[A + 5 | 0] | a[A + 4 | 0] | a[A + 3 | 0] | a[A + 2 | 0] | a[A + 1 | 0] | 1 ^ a[0 | A]) - 1 & 256 || (g = NI(I, 32) ? -1 : 0), h = C + 160 | 0, g;
                                    }
                                    function II(A, I) {
                                        var g, C, B, Q, i, a = 0, _ = 0, t = 0, r = 0, e = 0, y = 0, s = 0, h = 0, D = 0, p = 0;
                                        (a = E[A + 56 >> 2]) | (_ = E[A + 60 >> 2]) && (o[(r = A - -64 | 0) + a | 0] = 1, !((p = a + 1 | 0) ? _ : _ + 1 | 0) & p >>> 0 <= 15 && Hg(65 + (A + a | 0) | 0, 0, 15 - a | 0), o[A + 80 | 0] = 1, rA(A, r, 16, 0)), p = E[A + 52 >> 2], h = E[A + 48 >> 2], r = E[A + 44 >> 2], a = E[A + 24 >> 2], e = E[A + 28 >> 2] + (a >>> 26 | 0) | 0, t = E[A + 32 >> 2] + (e >>> 26 | 0) | 0, g = E[A + 36 >> 2] + (t >>> 26 | 0) | 0, _ = (s = (a = (a = (67108863 & a) + ((y = E[A + 20 >> 2] + c(g >>> 26 | 0, 5) | 0) >>> 26 | 0) | 0) & (e = (t = (i = (67108863 & g) + ((Q = (C = 67108863 & t) + ((B = (D = 67108863 & e) + ((y = a + ((_ = 5 + (s = 67108863 & y) | 0) >>> 26 | 0) | 0) >>> 26 | 0) | 0) >>> 26 | 0) | 0) >>> 26 | 0) | 0) - 67108864 | 0) >> 31) | y & (t = 67108863 & (y = (t >>> 31 | 0) - 1 | 0))) << 26 | _ & t | e & s) + E[A + 40 >> 2] | 0, o[0 | I] = _, o[I + 1 | 0] = _ >>> 8, o[I + 2 | 0] = _ >>> 16, o[I + 3 | 0] = _ >>> 24, s = _ >>> 0 < s >>> 0, _ = 0, _ = (a = (D = e & D | t & B) << 20 | a >>> 6) >>> 0 > (a = a + r | 0) >>> 0 ? 1 : _, _ = (r = a) >>> 0 > (a = a + s | 0) >>> 0 ? _ + 1 | 0 : _, o[I + 4 | 0] = a, o[I + 5 | 0] = a >>> 8, o[I + 6 | 0] = a >>> 16, o[I + 7 | 0] = a >>> 24, a = 0, r = (r = (t = e & C | t & Q) << 14 | D >>> 12) >>> 0 > (h = r + h | 0) >>> 0 ? 1 : a, a = h, h = _, a = a + _ | 0, _ = r, _ = a >>> 0 < h >>> 0 ? _ + 1 | 0 : _, o[I + 8 | 0] = a, o[I + 9 | 0] = a >>> 8, o[I + 10 | 0] = a >>> 16, o[I + 11 | 0] = a >>> 24, _ = (a = (a = (y & i | e & g) << 8 | t >>> 18) + p | 0) + _ | 0, o[I + 12 | 0] = _, o[I + 13 | 0] = _ >>> 8, o[I + 14 | 0] = _ >>> 16, o[I + 15 | 0] = _ >>> 24, XC(A, 88);
                                    }
                                    function gI(A, I, g) {
                                        A |= 0, I |= 0, g |= 0;
                                        var C, B = 0;
                                        return h = C = h - 16 | 0, o[C + 15 | 0] = 0, B = -1, 0 | pB[E[8934]](A, I, g) || (o[C + 15 | 0] = a[0 | A] | a[C + 15 | 0], o[C + 15 | 0] = a[A + 1 | 0] | a[C + 15 | 0], o[C + 15 | 0] = a[A + 2 | 0] | a[C + 15 | 0], o[C + 15 | 0] = a[A + 3 | 0] | a[C + 15 | 0], o[C + 15 | 0] = a[A + 4 | 0] | a[C + 15 | 0], o[C + 15 | 0] = a[A + 5 | 0] | a[C + 15 | 0], o[C + 15 | 0] = a[A + 6 | 0] | a[C + 15 | 0], o[C + 15 | 0] = a[A + 7 | 0] | a[C + 15 | 0], o[C + 15 | 0] = a[A + 8 | 0] | a[C + 15 | 0], o[C + 15 | 0] = a[A + 9 | 0] | a[C + 15 | 0], o[C + 15 | 0] = a[A + 10 | 0] | a[C + 15 | 0], o[C + 15 | 0] = a[A + 11 | 0] | a[C + 15 | 0], o[C + 15 | 0] = a[A + 12 | 0] | a[C + 15 | 0], o[C + 15 | 0] = a[A + 13 | 0] | a[C + 15 | 0], o[C + 15 | 0] = a[A + 14 | 0] | a[C + 15 | 0], o[C + 15 | 0] = a[A + 15 | 0] | a[C + 15 | 0], o[C + 15 | 0] = a[A + 16 | 0] | a[C + 15 | 0], o[C + 15 | 0] = a[A + 17 | 0] | a[C + 15 | 0], o[C + 15 | 0] = a[A + 18 | 0] | a[C + 15 | 0], o[C + 15 | 0] = a[A + 19 | 0] | a[C + 15 | 0], o[C + 15 | 0] = a[A + 20 | 0] | a[C + 15 | 0], o[C + 15 | 0] = a[A + 21 | 0] | a[C + 15 | 0], o[C + 15 | 0] = a[A + 22 | 0] | a[C + 15 | 0], o[C + 15 | 0] = a[A + 23 | 0] | a[C + 15 | 0], o[C + 15 | 0] = a[A + 24 | 0] | a[C + 15 | 0], o[C + 15 | 0] = a[A + 25 | 0] | a[C + 15 | 0], o[C + 15 | 0] = a[A + 26 | 0] | a[C + 15 | 0], o[C + 15 | 0] = a[A + 27 | 0] | a[C + 15 | 0], o[C + 15 | 0] = a[A + 28 | 0] | a[C + 15 | 0], o[C + 15 | 0] = a[A + 29 | 0] | a[C + 15 | 0], o[C + 15 | 0] = a[A + 30 | 0] | a[C + 15 | 0], o[C + 15 | 0] = a[A + 31 | 0] | a[C + 15 | 0], B = (a[C + 15 | 0] << 23) - 8388608 >> 31), h = C + 16 | 0, 0 | B;
                                    }
                                    function CI(A, I, g, C, B) {
                                        var Q = 0, i = 0, o = 0, a = 0, _ = 0, c = 0, t = 0;
                                        A: {
                                            if (1 == (0 | C) | C >>> 0 > 1) E[9392] = 22;
                                            else {
                                                h = C = h - 128 | 0, E[C - -64 >> 2] = 0, E[C + 56 >> 2] = 0, E[C + 60 >> 2] = 0, E[C + 48 >> 2] = 0, E[C + 52 >> 2] = 0, E[C + 40 >> 2] = 0, E[C + 44 >> 2] = 0, E[C + 32 >> 2] = 0, E[C + 36 >> 2] = 0, E[C + 24 >> 2] = 0, E[C + 28 >> 2] = 0, E[C + 16 >> 2] = 0, E[C + 20 >> 2] = 0, Q = LI(A), E[C + 28 >> 2] = Q, E[C + 44 >> 2] = Q, E[C + 12 >> 2] = Q, i = K(Q), E[C + 40 >> 2] = i, o = K(Q), E[C + 24 >> 2] = o, a = K(Q), E[C + 8 >> 2] = a;
                                                I: if (!a | !i | !o || !(Q = K(Q))) gA(i), gA(o), gA(a), A = -22;
                                                else {
                                                    if (A = WA(C + 8 | 0, A, B)) {
                                                        gA(E[C + 40 >> 2]), gA(E[C + 24 >> 2]), gA(E[C + 8 >> 2]), gA(Q);
                                                        break I;
                                                    }
                                                    a = E[C + 28 >> 2], _ = E[C + 24 >> 2], A = E[C + 60 >> 2], c = E[C + 52 >> 2], t = E[C + 48 >> 2], ag(Q, i = E[C + 12 >> 2]), (o = K(i)) ? (E[C + 100 >> 2] = 0, E[C + 104 >> 2] = 0, E[C + 92 >> 2] = 0, E[C + 96 >> 2] = 0, E[C + 88 >> 2] = a, E[C + 84 >> 2] = _, E[C + 80 >> 2] = g, E[C + 76 >> 2] = I, E[C + 72 >> 2] = i, E[C + 68 >> 2] = o, E[C + 124 >> 2] = 0, E[C + 120 >> 2] = A, E[C + 116 >> 2] = A, E[C + 112 >> 2] = c, E[C + 108 >> 2] = t, (A = L(C + 68 | 0, B)) || Sg(Q, o, i), XC(o, i), gA(o)) : A = -22, gA(E[C + 40 >> 2]), gA(E[C + 24 >> 2]), A || (A = MI(Q, E[C + 8 >> 2], E[C + 12 >> 2]) ? -35 : 0), gA(Q), gA(E[C + 8 >> 2]);
                                                }
                                                if (h = C + 128 | 0, I = A, !A) break A;
                                                -35 == (0 | A) && (E[9392] = 28);
                                            }
                                            I = -1;
                                        }
                                        return I;
                                    }
                                    function BI(A, I) {
                                        var g, C, B, Q, i, a, _, t = 0, r = 0;
                                        C = E[I + 32 >> 2], B = E[I + 28 >> 2], Q = E[I + 24 >> 2], i = E[I + 20 >> 2], a = E[I + 16 >> 2], _ = E[I + 12 >> 2], t = E[I + 4 >> 2], r = E[I >> 2], g = E[I + 36 >> 2], I = E[I + 8 >> 2], r = c((C + (B + (Q + (i + (a + (_ + ((t + (r + (c(g, 19) + 16777216 >>> 25 | 0) >> 26) >> 25) + I >> 26) >> 25) >> 26) >> 25) >> 26) >> 25) >> 26) + g >> 25, 19) + r | 0, o[0 | A] = r, o[A + 2 | 0] = r >>> 16, o[A + 1 | 0] = r >>> 8, t = t + (r >> 26) | 0, o[A + 5 | 0] = t >>> 14, o[A + 4 | 0] = t >>> 6, o[A + 3 | 0] = r >>> 24 & 3 | t << 2, I = I + (t >> 25) | 0, o[A + 8 | 0] = I >>> 13, o[A + 7 | 0] = I >>> 5, o[A + 6 | 0] = I << 3 | (29360128 & t) >>> 22, r = (I >> 26) + _ | 0, o[A + 11 | 0] = r >>> 11, o[A + 10 | 0] = r >>> 3, o[A + 9 | 0] = r << 5 | (65011712 & I) >>> 21, t = (r >> 25) + a | 0, o[A + 15 | 0] = t >>> 18, o[A + 14 | 0] = t >>> 10, o[A + 13 | 0] = t >>> 2, I = (t >> 26) + i | 0, o[A + 16 | 0] = I, o[A + 12 | 0] = t << 6 | (33030144 & r) >>> 19, o[A + 18 | 0] = I >>> 16, o[A + 17 | 0] = I >>> 8, t = (I >> 25) + Q | 0, o[A + 21 | 0] = t >>> 15, o[A + 20 | 0] = t >>> 7, o[A + 19 | 0] = I >>> 24 & 1 | t << 1, I = (t >> 26) + B | 0, o[A + 24 | 0] = I >>> 13, o[A + 23 | 0] = I >>> 5, o[A + 22 | 0] = I << 3 | (58720256 & t) >>> 23, t = (I >> 25) + C | 0, o[A + 27 | 0] = t >>> 12, o[A + 26 | 0] = t >>> 4, o[A + 25 | 0] = t << 4 | (31457280 & I) >>> 21, I = g + (t >> 26) | 0, o[A + 30 | 0] = I >>> 10, o[A + 29 | 0] = I >>> 2, o[A + 31 | 0] = (33292288 & I) >>> 18, o[A + 28 | 0] = I << 6 | (66060288 & t) >>> 20;
                                    }
                                    function QI(A, I, g) {
                                        A |= 0, I |= 0;
                                        var C, B = 0, Q = 0, i = 0, E = 0, _ = 0, c = 0, t = 0;
                                        if (h = C = h - 192 | 0, (g |= 0) >>> 0 >= 129 && (SI(A), nA(A, I, g, 0), z(A, C), g = 64, I = C), SI(A), Hg(C - -64 | 0, 54, 128), g) {
                                            if (g >>> 0 >= 4) for(t = 252 & g; o[0 | (B = (i = C - -64 | 0) + Q | 0)] = a[0 | B] ^ a[I + Q | 0], o[0 | (E = (B = 1 | Q) + i | 0)] = a[0 | E] ^ a[I + B | 0], o[0 | (E = (B = 2 | Q) + i | 0)] = a[0 | E] ^ a[I + B | 0], o[0 | (B = (B = i) + (i = 3 | Q) | 0)] = a[0 | B] ^ a[I + i | 0], Q = Q + 4 | 0, (0 | t) != (0 | (_ = _ + 4 | 0)););
                                            if (_ = 3 & g) for(; o[0 | (i = (C - -64 | 0) + Q | 0)] = a[0 | i] ^ a[I + Q | 0], Q = Q + 1 | 0, (0 | _) != (0 | (c = c + 1 | 0)););
                                        }
                                        if (nA(A, Q = C - -64 | 0, 128, 0), SI(i = A + 208 | 0), Hg(Q, 92, 128), g) {
                                            if (c = 0, Q = 0, g >>> 0 >= 4) for(t = 252 & g, _ = 0; o[0 | (B = (A = C - -64 | 0) + Q | 0)] = a[0 | B] ^ a[I + Q | 0], o[0 | (E = (B = 1 | Q) + A | 0)] = a[0 | E] ^ a[I + B | 0], o[0 | (E = (B = 2 | Q) + A | 0)] = a[0 | E] ^ a[I + B | 0], o[0 | (B = (B = A) + (A = 3 | Q) | 0)] = a[0 | B] ^ a[A + I | 0], Q = Q + 4 | 0, (0 | t) != (0 | (_ = _ + 4 | 0)););
                                            if (A = 3 & g) for(; o[0 | (g = (C - -64 | 0) + Q | 0)] = a[0 | g] ^ a[I + Q | 0], Q = Q + 1 | 0, (0 | A) != (0 | (c = c + 1 | 0)););
                                        }
                                        return nA(i, A = C - -64 | 0, 128, 0), XC(A, 128), XC(C, 64), h = C + 192 | 0, 0;
                                    }
                                    function iI(A, I) {
                                        var g;
                                        return A |= 0, I |= 0, E[12 + (g = h - 16 | 0) >> 2] = A, E[g + 8 >> 2] = I, E[g + 4 >> 2] = 0, E[g + 4 >> 2] = E[g + 4 >> 2] | a[E[g + 12 >> 2]] ^ a[E[g + 8 >> 2]], E[g + 4 >> 2] = E[g + 4 >> 2] | a[E[g + 12 >> 2] + 1 | 0] ^ a[E[g + 8 >> 2] + 1 | 0], E[g + 4 >> 2] = E[g + 4 >> 2] | a[E[g + 12 >> 2] + 2 | 0] ^ a[E[g + 8 >> 2] + 2 | 0], E[g + 4 >> 2] = E[g + 4 >> 2] | a[E[g + 12 >> 2] + 3 | 0] ^ a[E[g + 8 >> 2] + 3 | 0], E[g + 4 >> 2] = E[g + 4 >> 2] | a[E[g + 12 >> 2] + 4 | 0] ^ a[E[g + 8 >> 2] + 4 | 0], E[g + 4 >> 2] = E[g + 4 >> 2] | a[E[g + 12 >> 2] + 5 | 0] ^ a[E[g + 8 >> 2] + 5 | 0], E[g + 4 >> 2] = E[g + 4 >> 2] | a[E[g + 12 >> 2] + 6 | 0] ^ a[E[g + 8 >> 2] + 6 | 0], E[g + 4 >> 2] = E[g + 4 >> 2] | a[E[g + 12 >> 2] + 7 | 0] ^ a[E[g + 8 >> 2] + 7 | 0], E[g + 4 >> 2] = E[g + 4 >> 2] | a[E[g + 12 >> 2] + 8 | 0] ^ a[E[g + 8 >> 2] + 8 | 0], E[g + 4 >> 2] = E[g + 4 >> 2] | a[E[g + 12 >> 2] + 9 | 0] ^ a[E[g + 8 >> 2] + 9 | 0], E[g + 4 >> 2] = E[g + 4 >> 2] | a[E[g + 12 >> 2] + 10 | 0] ^ a[E[g + 8 >> 2] + 10 | 0], E[g + 4 >> 2] = E[g + 4 >> 2] | a[E[g + 12 >> 2] + 11 | 0] ^ a[E[g + 8 >> 2] + 11 | 0], E[g + 4 >> 2] = E[g + 4 >> 2] | a[E[g + 12 >> 2] + 12 | 0] ^ a[E[g + 8 >> 2] + 12 | 0], E[g + 4 >> 2] = E[g + 4 >> 2] | a[E[g + 12 >> 2] + 13 | 0] ^ a[E[g + 8 >> 2] + 13 | 0], E[g + 4 >> 2] = E[g + 4 >> 2] | a[E[g + 12 >> 2] + 14 | 0] ^ a[E[g + 8 >> 2] + 14 | 0], E[g + 4 >> 2] = E[g + 4 >> 2] | a[E[g + 12 >> 2] + 15 | 0] ^ a[E[g + 8 >> 2] + 15 | 0], (E[g + 4 >> 2] - 1 >>> 8 & 1) - 1 | 0;
                                    }
                                    function oI(A, I, g) {
                                        var C = 0, B = 0, Q = 0, i = 0, o = 0, E = 0, a = 0, _ = 0, r = 0;
                                        A: {
                                            I: {
                                                g: {
                                                    C: {
                                                        B: {
                                                            Q: {
                                                                i: {
                                                                    o: {
                                                                        E: {
                                                                            if (I) {
                                                                                if (!g) break E;
                                                                                break o;
                                                                            }
                                                                            return D = (I = A) - c(A = (A >>> 0) / (g >>> 0) | 0, g) | 0, p = 0, w = 0, A;
                                                                        }
                                                                        if (!A) break i;
                                                                        break Q;
                                                                    }
                                                                    if (!((C = g - 1 | 0) & g)) break B;
                                                                    Q = 0 - (i = (t(g) + 33 | 0) - t(I) | 0) | 0;
                                                                    break g;
                                                                }
                                                                return D = 0, p = I - c(A = (I >>> 0) / 0 | 0, 0) | 0, w = 0, A;
                                                            }
                                                            if ((C = 32 - t(I) | 0) >>> 0 < 31) break C;
                                                            break I;
                                                        }
                                                        if (D = A & C, p = 0, 1 == (0 | g)) break A;
                                                        return g = 31 & (C = FC(g)), (63 & C) >>> 0 >= 32 ? A = I >>> g | 0 : (B = I >>> g | 0, A = ((1 << g) - 1 & I) << 32 - g | A >>> g), w = B, A;
                                                    }
                                                    i = C + 1 | 0, Q = 63 - C | 0;
                                                }
                                                if (C = 31 & (B = 63 & i), B >>> 0 >= 32 ? (B = 0, o = I >>> C | 0) : (B = I >>> C | 0, o = ((1 << C) - 1 & I) << 32 - C | A >>> C), C = 31 & (Q &= 63), Q >>> 0 >= 32 ? (I = A << C, A = 0) : (I = (1 << C) - 1 & A >>> 32 - C | I << C, A <<= C), i) for(_ = -1 == (0 | (C = g - 1 | 0)) ? -1 : 0; E = B << 1 | o >>> 31, o = (B = o << 1 | I >>> 31) - (a = g & (Q = _ - (E + (B >>> 0 > C >>> 0) | 0) >> 31)) | 0, B = E - (B >>> 0 < a >>> 0) | 0, I = I << 1 | A >>> 31, A = r | A << 1, r = E = 1 & Q, i = i - 1 | 0;);
                                                return D = o, p = B, w = I << 1 | A >>> 31, E | A << 1;
                                            }
                                            D = A, p = I, A = 0, I = 0;
                                        }
                                        return w = I, A;
                                    }
                                    function EI(A, I, g, C, B) {
                                        var Q;
                                        return A |= 0, I |= 0, g |= 0, C |= 0, h = Q = h - 480 | 0, QI(Q, B |= 0, 32), dC(Q, I, g, C), fg(Q, Q + 416 | 0), I = E[Q + 444 >> 2], g = E[Q + 440 >> 2], o[A + 24 | 0] = g, o[A + 25 | 0] = g >>> 8, o[A + 26 | 0] = g >>> 16, o[A + 27 | 0] = g >>> 24, o[A + 28 | 0] = I, o[A + 29 | 0] = I >>> 8, o[A + 30 | 0] = I >>> 16, o[A + 31 | 0] = I >>> 24, I = E[Q + 436 >> 2], g = E[Q + 432 >> 2], o[A + 16 | 0] = g, o[A + 17 | 0] = g >>> 8, o[A + 18 | 0] = g >>> 16, o[A + 19 | 0] = g >>> 24, o[A + 20 | 0] = I, o[A + 21 | 0] = I >>> 8, o[A + 22 | 0] = I >>> 16, o[A + 23 | 0] = I >>> 24, I = E[Q + 428 >> 2], g = E[Q + 424 >> 2], o[A + 8 | 0] = g, o[A + 9 | 0] = g >>> 8, o[A + 10 | 0] = g >>> 16, o[A + 11 | 0] = g >>> 24, o[A + 12 | 0] = I, o[A + 13 | 0] = I >>> 8, o[A + 14 | 0] = I >>> 16, o[A + 15 | 0] = I >>> 24, I = E[Q + 420 >> 2], g = E[Q + 416 >> 2], o[0 | A] = g, o[A + 1 | 0] = g >>> 8, o[A + 2 | 0] = g >>> 16, o[A + 3 | 0] = g >>> 24, o[A + 4 | 0] = I, o[A + 5 | 0] = I >>> 8, o[A + 6 | 0] = I >>> 16, o[A + 7 | 0] = I >>> 24, h = Q + 480 | 0, 0;
                                    }
                                    function aI(A, I, g) {
                                        A |= 0, I |= 0;
                                        var C, B = 0;
                                        return h = C = h + -64 | 0, kI(C, g |= 0, 32, 0), g = E[C + 28 >> 2], B = E[C + 24 >> 2], o[I + 24 | 0] = B, o[I + 25 | 0] = B >>> 8, o[I + 26 | 0] = B >>> 16, o[I + 27 | 0] = B >>> 24, o[I + 28 | 0] = g, o[I + 29 | 0] = g >>> 8, o[I + 30 | 0] = g >>> 16, o[I + 31 | 0] = g >>> 24, g = E[C + 20 >> 2], B = E[C + 16 >> 2], o[I + 16 | 0] = B, o[I + 17 | 0] = B >>> 8, o[I + 18 | 0] = B >>> 16, o[I + 19 | 0] = B >>> 24, o[I + 20 | 0] = g, o[I + 21 | 0] = g >>> 8, o[I + 22 | 0] = g >>> 16, o[I + 23 | 0] = g >>> 24, g = E[C + 12 >> 2], B = E[C + 8 >> 2], o[I + 8 | 0] = B, o[I + 9 | 0] = B >>> 8, o[I + 10 | 0] = B >>> 16, o[I + 11 | 0] = B >>> 24, o[I + 12 | 0] = g, o[I + 13 | 0] = g >>> 8, o[I + 14 | 0] = g >>> 16, o[I + 15 | 0] = g >>> 24, g = E[C + 4 >> 2], B = E[C >> 2], o[0 | I] = B, o[I + 1 | 0] = B >>> 8, o[I + 2 | 0] = B >>> 16, o[I + 3 | 0] = B >>> 24, o[I + 4 | 0] = g, o[I + 5 | 0] = g >>> 8, o[I + 6 | 0] = g >>> 16, o[I + 7 | 0] = g >>> 24, XC(C, 64), A = wC(A, I), h = C - -64 | 0, 0 | A;
                                    }
                                    function _I(A, I) {
                                        var g = 0, C = 0, B = 0, Q = 0, i = 0, o = 0;
                                        if (I >>> 0 > 4294967168) A = 48;
                                        else {
                                            if (I >>> 0 >= 4294967168 ? (E[9392] = 48, g = 0) : (g = 0, (I = K(76 + (Q = I >>> 0 < 11 ? 16 : I + 11 & -8) | 0)) && (g = I - 8 | 0, 63 & I ? (B = (-8 & (o = E[(i = I - 4 | 0) >> 2])) - (C = (I = ((I = (I + 63 & -64) - 8 | 0) - g >>> 0 <= 15 ? 64 : 0) + I | 0) - g | 0) | 0, 3 & o ? (E[I + 4 >> 2] = B | 1 & E[I + 4 >> 2] | 2, E[4 + (B = I + B | 0) >> 2] = 1 | E[B + 4 >> 2], E[i >> 2] = C | 1 & E[i >> 2] | 2, E[4 + (B = g + C | 0) >> 2] = 1 | E[B + 4 >> 2], iA(g, C)) : (g = E[g >> 2], E[I + 4 >> 2] = B, E[I >> 2] = g + C)) : I = g, 3 & (g = E[I + 4 >> 2]) && ((C = -8 & g) >>> 0 <= Q + 16 >>> 0 || (E[I + 4 >> 2] = Q | 1 & g | 2, g = I + Q | 0, Q = C - Q | 0, E[g + 4 >> 2] = 3 | Q, E[4 + (C = I + C | 0) >> 2] = 1 | E[C + 4 >> 2], iA(g, Q))), g = I + 8 | 0)), !g) return 48;
                                            E[A >> 2] = g, A = 0;
                                        }
                                        return A;
                                    }
                                    function cI(A, I, g, C, B, Q, i, o, a, _, c) {
                                        var t;
                                        if (t = Hg(A, 0, I), 1 == (0 | g) | g >>> 0 > 1) return E[9392] = 22, -1;
                                        if (!(!g & I >>> 0 <= 15)) {
                                            if (!(!(Q | a) & _ >>> 0 < 2147483649)) return E[9392] = 22, -1;
                                            if (!(!((!a & o >>> 0 >= 3 | 0 != (0 | a)) & _ >>> 0 > 8191) | (0 | C) == (0 | t))) return 1 == (0 | c) ? (Q = _ >>> 10 | 0, h = A = h + -64 | 0, t && ag(t, I), (g = K(I)) ? (E[A + 36 >> 2] = 0, E[A + 40 >> 2] = 0, E[A + 28 >> 2] = 0, E[A + 32 >> 2] = 0, E[A + 24 >> 2] = 16, E[A + 20 >> 2] = i, E[A + 16 >> 2] = B, E[A + 12 >> 2] = C, E[A + 8 >> 2] = I, E[A + 4 >> 2] = g, E[A + 60 >> 2] = 0, E[A + 56 >> 2] = 1, E[A + 52 >> 2] = 1, E[A + 48 >> 2] = Q, E[A + 44 >> 2] = o, (C = L(A + 4 | 0, 1)) | !t || Sg(t, g, I), XC(g, I), gA(g)) : C = -22, h = A - -64 | 0, C ? -1 : 0) : (E[9392] = 28, -1);
                                        }
                                        return E[9392] = 28, -1;
                                    }
                                    function tI(A, I, g, C, B, Q, i, o, a, _, c) {
                                        var t;
                                        if (t = Hg(A, 0, I), 1 == (0 | g) | g >>> 0 > 1) return E[9392] = 22, -1;
                                        if (!(!g & I >>> 0 <= 15)) {
                                            if (!(!(Q | a) & _ >>> 0 < 2147483649)) return E[9392] = 22, -1;
                                            if (!(!(!!(o | a) & _ >>> 0 > 8191) | (0 | C) == (0 | t))) return 2 == (0 | c) ? (Q = _ >>> 10 | 0, h = A = h + -64 | 0, t && ag(t, I), (g = K(I)) ? (E[A + 36 >> 2] = 0, E[A + 40 >> 2] = 0, E[A + 28 >> 2] = 0, E[A + 32 >> 2] = 0, E[A + 24 >> 2] = 16, E[A + 20 >> 2] = i, E[A + 16 >> 2] = B, E[A + 12 >> 2] = C, E[A + 8 >> 2] = I, E[A + 4 >> 2] = g, E[A + 60 >> 2] = 0, E[A + 56 >> 2] = 1, E[A + 52 >> 2] = 1, E[A + 48 >> 2] = Q, E[A + 44 >> 2] = o, (C = L(A + 4 | 0, 2)) | !t || Sg(t, g, I), XC(g, I), gA(g)) : C = -22, h = A - -64 | 0, C ? -1 : 0) : (E[9392] = 28, -1);
                                        }
                                        return E[9392] = 28, -1;
                                    }
                                    function rI(A, I, g, C, B, Q, i) {
                                        var o, a, _, c, t = 0;
                                        return h = o = h - 352 | 0, yA(o, Q, i, 0), !((!B & C >>> 0 > A - g >>> 0 | 0 != (0 | B)) & A >>> 0 > g >>> 0) & (!B & C >>> 0 <= g - A >>> 0 | A >>> 0 >= g >>> 0) || (g = yg(A, g, C)), E[o + 56 >> 2] = 0, E[o + 60 >> 2] = 0, E[o + 48 >> 2] = 0, E[o + 52 >> 2] = 0, E[o + 40 >> 2] = 0, E[o + 44 >> 2] = 0, E[o + 32 >> 2] = 0, E[o + 36 >> 2] = 0, (_ = !((i = (t = !B & C >>> 0 >= 32 | 0 != (0 | B)) ? 32 : C) | (t = t ? 0 : B))) || Sg(o - -64 | 0, g, i), ug(a = o + 32 | 0, a, c = i + 32 | 0, c >>> 0 < 32 ? t + 1 | 0 : t, Q = Q + 16 | 0, o), fC(o + 96 | 0, a), _ || Sg(A, o - -64 | 0, i), XC(o + 32 | 0, 64), !B & C >>> 0 >= 33 | B && Ug(A + i | 0, g + i | 0, C - i | 0, B - (t + (C >>> 0 < i >>> 0) | 0) | 0, Q, 1, 0, o), XC(o, 32), NC(g = o + 96 | 0, A, C, B), nC(g, I), XC(g, 256), h = o + 352 | 0, 0;
                                    }
                                    function eI(A, I, g, C, B, Q, i) {
                                        var o, a, _, c, t = 0;
                                        return h = o = h - 352 | 0, fA(o, Q, i, 0), !((!B & C >>> 0 > A - g >>> 0 | 0 != (0 | B)) & A >>> 0 > g >>> 0) & (!B & C >>> 0 <= g - A >>> 0 | A >>> 0 >= g >>> 0) || (g = yg(A, g, C)), E[o + 56 >> 2] = 0, E[o + 60 >> 2] = 0, E[o + 48 >> 2] = 0, E[o + 52 >> 2] = 0, E[o + 40 >> 2] = 0, E[o + 44 >> 2] = 0, E[o + 32 >> 2] = 0, E[o + 36 >> 2] = 0, (_ = !((i = (t = !B & C >>> 0 >= 32 | 0 != (0 | B)) ? 32 : C) | (t = t ? 0 : B))) || Sg(o - -64 | 0, g, i), aC(a = o + 32 | 0, a, c = i + 32 | 0, c >>> 0 < 32 ? t + 1 | 0 : t, Q = Q + 16 | 0, o), fC(o + 96 | 0, a), _ || Sg(A, o - -64 | 0, i), XC(o + 32 | 0, 64), !B & C >>> 0 >= 33 | B && oC(A + i | 0, g + i | 0, C - i | 0, B - (t + (C >>> 0 < i >>> 0) | 0) | 0, Q, 1, 0, o), XC(o, 32), NC(g = o + 96 | 0, A, C, B), nC(g, I), XC(g, 256), h = o + 352 | 0, 0;
                                    }
                                    function yI(A, I, g, C, B, Q, i) {
                                        var o, E, a = 0, _ = 0, c = 0;
                                        h = o = h - 96 | 0, fA(o, Q, i, 0), pC(i = o + 32 | 0, 32, 0, E = Q + 16 | 0, o), Q = -1;
                                        A: {
                                            if (!DC(g, I, C, B, i)) {
                                                if (Q = 0, !A) break A;
                                                !((!B & C >>> 0 > I - A >>> 0 | 0 != (0 | B)) & A >>> 0 < I >>> 0) & (!B & C >>> 0 <= A - I >>> 0 | A >>> 0 <= I >>> 0) || (I = yg(A, I, C)), _ = i = (Q = !B & C >>> 0 >= 32 | 0 != (0 | B)) ? 0 : B, (g = Q ? 32 : C) | i ? (c = Sg(o - -64 | 0, I, g), aC(Q = o + 32 | 0, Q, a = g + 32 | 0, i = a >>> 0 < 32 ? i + 1 | 0 : i, E, o), Sg(A, c, g)) : aC(Q = o + 32 | 0, Q, a = g + 32 | 0, i = a >>> 0 < 32 ? i + 1 | 0 : i, E, o), XC(o + 32 | 0, 64), Q = 0, !B & C >>> 0 < 33 || oC(A + g | 0, I + g | 0, C - g | 0, B - (_ + (g >>> 0 > C >>> 0) | 0) | 0, E, 1, 0, o);
                                            }
                                            XC(o, 32);
                                        }
                                        return h = o + 96 | 0, Q;
                                    }
                                    function sI(A, I, g, C, B, Q, i, o, _, c) {
                                        var t, r;
                                        return h = t = h - 400 | 0, E[t + 4 >> 2] = 0, yA(r = t + 16 | 0, _, c, 0), c = a[_ + 20 | 0] | a[_ + 21 | 0] << 8 | a[_ + 22 | 0] << 16 | a[_ + 23 | 0] << 24, E[t + 8 >> 2] = a[_ + 16 | 0] | a[_ + 17 | 0] << 8 | a[_ + 18 | 0] << 16 | a[_ + 19 | 0] << 24, E[t + 12 >> 2] = c, Xg(c = t + 80 | 0, 64, 0, t + 4 | 0, r), fC(_ = t + 144 | 0, c), XC(c, 64), NC(_, Q, i, o), NC(_, 35680, 0 - i & 15, 0), NC(_, I, g, C), NC(_, 35680, 0 - g & 15, 0), E[t + 72 >> 2] = i, E[t + 76 >> 2] = o, NC(_, Q = t + 72 | 0, 8, 0), E[t + 72 >> 2] = g, E[t + 76 >> 2] = C, NC(_, Q, 8, 0), nC(_, Q = t + 48 | 0), XC(_, 256), _ = iI(Q, B), XC(Q, 16), A && (_ ? (Hg(A, 0, g), _ = -1) : (Og(A, I, g, C, t + 4 | 0, t + 16 | 0), _ = 0)), XC(t + 16 | 0, 32), h = t + 400 | 0, _;
                                    }
                                    function hI(A, I, g, C, B, Q, i) {
                                        var o, E, a = 0, _ = 0, c = 0;
                                        h = o = h - 96 | 0, yA(o, Q, i, 0), jg(i = o + 32 | 0, 32, 0, E = Q + 16 | 0, o), Q = -1;
                                        A: {
                                            if (!DC(g, I, C, B, i)) {
                                                if (Q = 0, !A) break A;
                                                !((!B & C >>> 0 > I - A >>> 0 | 0 != (0 | B)) & A >>> 0 < I >>> 0) & (!B & C >>> 0 <= A - I >>> 0 | A >>> 0 <= I >>> 0) || (I = yg(A, I, C)), _ = i = (Q = !B & C >>> 0 >= 32 | 0 != (0 | B)) ? 0 : B, (g = Q ? 32 : C) | i ? (c = Sg(o - -64 | 0, I, g), ug(Q = o + 32 | 0, Q, a = g + 32 | 0, i = a >>> 0 < 32 ? i + 1 | 0 : i, E, o), Sg(A, c, g)) : ug(Q = o + 32 | 0, Q, a = g + 32 | 0, i = a >>> 0 < 32 ? i + 1 | 0 : i, E, o), Q = 0, !B & C >>> 0 < 33 || Ug(A + g | 0, I + g | 0, C - g | 0, B - (_ + (g >>> 0 > C >>> 0) | 0) | 0, E, 1, 0, o);
                                            }
                                            XC(o, 32);
                                        }
                                        return h = o + 96 | 0, Q;
                                    }
                                    function DI(A, I, g, C, B, Q) {
                                        var i, a;
                                        if (h = i = h - 496 | 0, UA(a = i + 288 | 0, A, I), YC(a, g, C, 0), Q) for(A = 0, I = 0; g = (I = I + 1 | 0) << 24 | (65280 & I) << 8 | I >>> 8 & 65280 | I >>> 24, o[i + 76 | 0] = g, o[i + 77 | 0] = g >>> 8, o[i + 78 | 0] = g >>> 16, o[i + 79 | 0] = g >>> 24, Sg(g = i + 80 | 0, i + 288 | 0, 208), YC(g, i + 76 | 0, 4, 0), Fg(g, i + 32 | 0), g = E[i + 60 >> 2], E[i + 24 >> 2] = E[i + 56 >> 2], E[i + 28 >> 2] = g, g = E[i + 52 >> 2], E[i + 16 >> 2] = E[i + 48 >> 2], E[i + 20 >> 2] = g, g = E[i + 44 >> 2], E[i + 8 >> 2] = E[i + 40 >> 2], E[i + 12 >> 2] = g, g = E[i + 36 >> 2], E[i >> 2] = E[i + 32 >> 2], E[i + 4 >> 2] = g, Sg(g = A + B | 0, i, (A = Q - A | 0) >>> 0 >= 32 ? 32 : A), Q >>> 0 > (A = I << 5) >>> 0;);
                                        XC(i + 288 | 0, 208), h = i + 496 | 0;
                                    }
                                    function pI(A) {
                                        var I = 0, g = 0, C = 0;
                                        if (!A) return -25;
                                        if (!E[A >> 2]) return -1;
                                        if (I = -2, !(_[A + 4 >> 2] < 16) && (E[A + 8 >> 2] || (I = -18, !E[A + 12 >> 2]))) {
                                            if (g = E[A + 20 >> 2], !E[A + 16 >> 2]) return g ? -19 : -6;
                                            if (I = -6, !(g >>> 0 < 8) && (E[A + 24 >> 2] || (I = -20, !E[A + 28 >> 2])) && (E[A + 32 >> 2] || (I = -21, !E[A + 36 >> 2]))) {
                                                if (!(g = E[A + 48 >> 2])) return -16;
                                                if (I = -17, !(g >>> 0 > 16777215 || (I = -14, (C = E[A + 44 >> 2]) >>> 0 < 8 || (I = -15, C >>> 0 > 2097152 || (I = -14, g << 3 >>> 0 > C >>> 0))))) {
                                                    if (!E[A + 40 >> 2]) return -12;
                                                    if (!(A = E[A + 52 >> 2])) return -28;
                                                    I = A >>> 0 > 16777215 ? -29 : 0;
                                                }
                                            }
                                        }
                                        return I;
                                    }
                                    function wI(A, I, g, C, B, Q) {
                                        var i, E, a = 0;
                                        return h = i = h - 32 | 0, a = -1, (E = g >>> 0 < 32) & !C || (Kg(i, 32, 0, B, Q), DC(I + 16 | 0, I + 32 | 0, g - 32 | 0, C - E | 0, i) || (Gg(A, I, g, C, B, Q), o[A + 24 | 0] = 0, o[A + 25 | 0] = 0, o[A + 26 | 0] = 0, o[A + 27 | 0] = 0, o[A + 28 | 0] = 0, o[A + 29 | 0] = 0, o[A + 30 | 0] = 0, o[A + 31 | 0] = 0, o[A + 16 | 0] = 0, o[A + 17 | 0] = 0, o[A + 18 | 0] = 0, o[A + 19 | 0] = 0, o[A + 20 | 0] = 0, o[A + 21 | 0] = 0, o[A + 22 | 0] = 0, o[A + 23 | 0] = 0, o[A + 8 | 0] = 0, o[A + 9 | 0] = 0, o[A + 10 | 0] = 0, o[A + 11 | 0] = 0, o[A + 12 | 0] = 0, o[A + 13 | 0] = 0, o[A + 14 | 0] = 0, o[A + 15 | 0] = 0, o[0 | A] = 0, o[A + 1 | 0] = 0, o[A + 2 | 0] = 0, o[A + 3 | 0] = 0, o[A + 4 | 0] = 0, o[A + 5 | 0] = 0, o[A + 6 | 0] = 0, o[A + 7 | 0] = 0, a = 0)), h = i + 32 | 0, a;
                                    }
                                    function fI(A, I, g, C, B, Q, i, o, _, c, t) {
                                        var r, e, y;
                                        return h = r = h - 384 | 0, E[r + 4 >> 2] = 0, yA(e = r + 16 | 0, c, t, 0), t = a[c + 20 | 0] | a[c + 21 | 0] << 8 | a[c + 22 | 0] << 16 | a[c + 23 | 0] << 24, E[r + 8 >> 2] = a[c + 16 | 0] | a[c + 17 | 0] << 8 | a[c + 18 | 0] << 16 | a[c + 19 | 0] << 24, E[r + 12 >> 2] = t, Xg(t = r - -64 | 0, 64, 0, y = r + 4 | 0, e), fC(c = r + 128 | 0, t), XC(t, 64), NC(c, i, o, _), NC(c, 35680, 0 - o & 15, 0), Og(A, C, B, Q, y, e), NC(c, A, B, Q), NC(c, 35680, 0 - B & 15, 0), E[r + 56 >> 2] = o, E[r + 60 >> 2] = _, NC(c, A = r + 56 | 0, 8, 0), E[r + 56 >> 2] = B, E[r + 60 >> 2] = Q, NC(c, A, 8, 0), nC(c, I), XC(c, 256), g && (E[g >> 2] = 16, E[g + 4 >> 2] = 0), XC(r + 16 | 0, 32), h = r + 384 | 0, 0;
                                    }
                                    function nI(A, I, g, C, B) {
                                        var Q, i, o = 0;
                                        return h = Q = h + -64 | 0, !g & (i = LI(A)) >>> 0 < 128 ? (E[Q + 60 >> 2] = 0, E[Q + 52 >> 2] = 0, E[Q + 56 >> 2] = 0, E[Q + 44 >> 2] = 0, E[Q + 48 >> 2] = 0, g = 0, i && (g = i, (1 | i) >>> 0 < 65536 || (g = i)), !(o = K(g)) | !(3 & a[o - 4 | 0]) || Hg(o, 0, g), o ? (E[Q + 36 >> 2] = 0, E[Q + 40 >> 2] = 0, E[Q + 12 >> 2] = o, E[Q + 20 >> 2] = o, E[Q + 24 >> 2] = i, E[Q + 4 >> 2] = o, E[Q + 16 >> 2] = i, E[Q + 28 >> 2] = 0, E[Q + 32 >> 2] = 0, E[Q + 8 >> 2] = i, WA(Q + 4 | 0, A, B) ? (E[9392] = 28, A = -1) : A = E[Q + 44 >> 2] != (0 | I) | E[Q + 48 >> 2] != (C >>> 10 | 0), gA(o)) : A = -1) : (E[9392] = 28, A = -1), h = Q - -64 | 0, A;
                                    }
                                    function kI(A, I, g, C) {
                                        var B, Q = 0;
                                        return h = B = h - 208 | 0, E[B + 72 >> 2] = 0, E[B + 76 >> 2] = 0, Q = E[8691], E[B + 8 >> 2] = E[8690], E[B + 12 >> 2] = Q, Q = E[8693], E[B + 16 >> 2] = E[8692], E[B + 20 >> 2] = Q, Q = E[8695], E[B + 24 >> 2] = E[8694], E[B + 28 >> 2] = Q, Q = E[8697], E[B + 32 >> 2] = E[8696], E[B + 36 >> 2] = Q, Q = E[8699], E[B + 40 >> 2] = E[8698], E[B + 44 >> 2] = Q, Q = E[8701], E[B + 48 >> 2] = E[8700], E[B + 52 >> 2] = Q, Q = E[8703], E[B + 56 >> 2] = E[8702], E[B + 60 >> 2] = Q, E[B + 64 >> 2] = 0, E[B + 68 >> 2] = 0, Q = E[8689], E[B >> 2] = E[8688], E[B + 4 >> 2] = Q, nA(B, I, g, C), z(B, A), h = B + 208 | 0, 0;
                                    }
                                    function FI(A, I) {
                                        var g = 0, C = 0;
                                        A: if (C = 255 & I) {
                                            if (3 & A) for(;;){
                                                if (!(g = a[0 | A]) | (0 | g) == (255 & I)) break A;
                                                if (!(3 & (A = A + 1 | 0))) break;
                                            }
                                            I: if (!((-1 ^ (g = E[A >> 2])) & g - 16843009 & -2139062144)) for(C = c(C, 16843009);;){
                                                if ((-1 ^ (g ^= C)) & g - 16843009 & -2139062144) break I;
                                                if (g = E[A + 4 >> 2], A = A + 4 | 0, g - 16843009 & (-1 ^ g) & -2139062144) break;
                                            }
                                            for(; g = A, (C = a[0 | A]) && (A = A + 1 | 0, (0 | C) != (255 & I)););
                                            A = g;
                                        } else A = LI(A) + A | 0;
                                        return a[0 | A] == (255 & I) ? A : 0;
                                    }
                                    function NI(A, I) {
                                        var g, C = 0, B = 0, Q = 0;
                                        if (o[15 + (g = h - 16 | 0) | 0] = 0, I) {
                                            if (B = 3 & I, I >>> 0 >= 4) for(Q = -4 & I, I = 0; o[g + 15 | 0] = a[A + C | 0] | a[g + 15 | 0], o[g + 15 | 0] = a[(1 | C) + A | 0] | a[g + 15 | 0], o[g + 15 | 0] = a[(2 | C) + A | 0] | a[g + 15 | 0], o[g + 15 | 0] = a[(3 | C) + A | 0] | a[g + 15 | 0], C = C + 4 | 0, (0 | Q) != (0 | (I = I + 4 | 0)););
                                            if (B) for(I = 0; o[g + 15 | 0] = a[A + C | 0] | a[g + 15 | 0], C = C + 1 | 0, (0 | B) != (0 | (I = I + 1 | 0)););
                                        }
                                        return a[g + 15 | 0] - 1 >>> 8 & 1;
                                    }
                                    function SI(A) {
                                        var I = 0;
                                        return E[64 + (A |= 0) >> 2] = 0, E[A + 68 >> 2] = 0, E[A + 72 >> 2] = 0, E[A + 76 >> 2] = 0, I = E[8689], E[A >> 2] = E[8688], E[A + 4 >> 2] = I, I = E[8691], E[A + 8 >> 2] = E[8690], E[A + 12 >> 2] = I, I = E[8693], E[A + 16 >> 2] = E[8692], E[A + 20 >> 2] = I, I = E[8695], E[A + 24 >> 2] = E[8694], E[A + 28 >> 2] = I, I = E[8697], E[A + 32 >> 2] = E[8696], E[A + 36 >> 2] = I, I = E[8699], E[A + 40 >> 2] = E[8698], E[A + 44 >> 2] = I, I = E[8701], E[A + 48 >> 2] = E[8700], E[A + 52 >> 2] = I, I = E[8703], E[A + 56 >> 2] = E[8702], E[A + 60 >> 2] = I, 0;
                                    }
                                    function GI(A) {
                                        return ((127 & (-1 ^ a[A + 31 | 0]) | a[A + 1 | 0] & a[A + 2 | 0] & a[A + 3 | 0] & a[A + 4 | 0] & a[A + 5 | 0] & a[A + 6 | 0] & a[A + 7 | 0] & a[A + 8 | 0] & a[A + 9 | 0] & a[A + 10 | 0] & a[A + 11 | 0] & a[A + 12 | 0] & a[A + 13 | 0] & a[A + 14 | 0] & a[A + 15 | 0] & a[A + 16 | 0] & a[A + 17 | 0] & a[A + 18 | 0] & a[A + 19 | 0] & a[A + 20 | 0] & a[A + 21 | 0] & a[A + 22 | 0] & a[A + 23 | 0] & a[A + 24 | 0] & a[A + 25 | 0] & a[A + 26 | 0] & a[A + 27 | 0] & a[A + 28 | 0] & a[A + 30 | 0] & a[A + 29 | 0] ^ 255) - 1 & 236 - a[0 | A] ^ -1) >>> 8 & 1;
                                    }
                                    function MI(A, I, g) {
                                        var C, B = 0, Q = 0;
                                        if (E[12 + (C = h - 16 | 0) >> 2] = A, E[C + 8 >> 2] = I, A = 0, o[C + 7 | 0] = 0, g) {
                                            if (I = 1 & g, 1 != (0 | g)) for(Q = -2 & g, g = 0; o[C + 7 | 0] = a[C + 7 | 0] | a[E[C + 12 >> 2] + A | 0] ^ a[E[C + 8 >> 2] + A | 0], B = 1 | A, o[C + 7 | 0] = a[C + 7 | 0] | a[B + E[C + 12 >> 2] | 0] ^ a[E[C + 8 >> 2] + B | 0], A = A + 2 | 0, (0 | Q) != (0 | (g = g + 2 | 0)););
                                            I && (o[C + 7 | 0] = a[C + 7 | 0] | a[E[C + 12 >> 2] + A | 0] ^ a[E[C + 8 >> 2] + A | 0]);
                                        }
                                        return (a[C + 7 | 0] - 1 >>> 8 & 1) - 1 | 0;
                                    }
                                    function bI(A) {
                                        for(var I = 0, g = 0, C = 0, B = 0, Q = 0, i = 0, o = 0, E = 0, _ = 0, c = 0; B = (g = a[A + C | 0]) ^ a[0 | (I = C + 2704 | 0)] | B, Q = g ^ a[I + 192 | 0] | Q, i = g ^ a[I + 160 | 0] | i, o = g ^ a[I + 128 | 0] | o, E = g ^ a[I + 96 | 0] | E, _ = g ^ a[I - -64 | 0] | _, c = g ^ a[I + 32 | 0] | c, 31 != (0 | (C = C + 1 | 0)););
                                        return ((255 & ((I = 127 ^ (A = 127 & a[A + 31 | 0])) | Q)) - 1 | (255 & (I | i)) - 1 | (255 & (I | o)) - 1 | (255 & (122 ^ A | E)) - 1 | (255 & (5 ^ A | _)) - 1 | (255 & (A | c)) - 1 | (255 & (A | B)) - 1) >>> 8 & 1;
                                    }
                                    function KI(A, I, g) {
                                        var C = 0, B = 0, Q = 0, i = 0;
                                        return B = 31 & (Q = i = 63 & g), Q = Q >>> 0 >= 32 ? -1 >>> B | 0 : (C = -1 >>> B | 0) | (1 << B) - 1 << 32 - B, Q &= A, C &= I, B = 31 & i, i >>> 0 >= 32 ? (C = Q << B, i = 0) : (C = (1 << B) - 1 & Q >>> 32 - B | C << B, i = Q << B), Q = C, C = 31 & (B = 0 - g & 63), B >>> 0 >= 32 ? (C = -1 << C, g = 0) : C = (g = -1 << C) | (1 << C) - 1 & -1 >>> 32 - C, A &= g, I &= C, C = 31 & B, B >>> 0 >= 32 ? (g = 0, A = I >>> C | 0) : (g = I >>> C | 0, A = ((1 << C) - 1 & I) << 32 - C | A >>> C), w = g | Q, A | i;
                                    }
                                    function HI(A, I, g, C, B, Q) {
                                        A |= 0, I |= 0, g |= 0;
                                        var i = 0, o = 0;
                                        A: I: {
                                            g: {
                                                if (!(!(B |= 0) & (C |= 0) >>> 0 < 64 || (o = 1 + (B = B - 1 | 0) | 0, i = B, !(C = (B = C + -64 | 0) >>> 0 < 4294967232 ? o : i) & B >>> 0 > 4294967231 | C))) {
                                                    if (!H(i = g, g = g - -64 | 0, B, C, Q |= 0, 0)) break g;
                                                    A && Hg(A, 0, B);
                                                }
                                                if (C = -1, !I) break I;
                                                E[I >> 2] = 0, E[I + 4 >> 2] = 0, C = -1;
                                                break A;
                                            }
                                            I && (E[I >> 2] = B, E[I + 4 >> 2] = C), C = 0, A && yg(A, g, B);
                                        }
                                        return 0 | C;
                                    }
                                    function YI(A, I, g, C, B, Q, i, o, a, _) {
                                        var c, t, r;
                                        return h = c = h - 352 | 0, Xg(r = c + 32 | 0, 64, 0, a, _), fC(t = c + 96 | 0, r), XC(r, 64), NC(t, Q, i, o), NC(t, 35648, 0 - i & 15, 0), NC(t, I, g, C), NC(t, 35648, 0 - g & 15, 0), E[c + 24 >> 2] = i, E[c + 28 >> 2] = o, NC(t, Q = c + 24 | 0, 8, 0), E[c + 24 >> 2] = g, E[c + 28 >> 2] = C, NC(t, Q, 8, 0), nC(t, c), XC(t, 256), Q = iI(c, B), XC(c, 16), A && (Q ? (Hg(A, 0, g), Q = -1) : (gg(A, I, g, C, a, 1, _), Q = 0)), h = c + 352 | 0, Q;
                                    }
                                    function dI(A, I, g, C, B, Q) {
                                        var i, o;
                                        return A |= 0, I |= 0, g |= 0, C |= 0, Q |= 0, h = i = h - 32 | 0, o = a[0 | (B |= 0)] | a[B + 1 | 0] << 8 | a[B + 2 | 0] << 16 | a[B + 3 | 0] << 24, B = a[B + 4 | 0] | a[B + 5 | 0] << 8 | a[B + 6 | 0] << 16 | a[B + 7 | 0] << 24, E[i + 24 >> 2] = 0, E[i + 28 >> 2] = 0, E[i + 16 >> 2] = o, E[i + 20 >> 2] = B, E[i + 8 >> 2] = 0, E[i + 12 >> 2] = 0, E[i >> 2] = g, E[i + 4 >> 2] = C, I - 65 >>> 0 <= 4294967246 ? (E[9392] = 28, A = -1) : A = QA(A, I, 0, 0, 0, Q, 32, i, i + 16 | 0), h = i + 32 | 0, 0 | A;
                                    }
                                    function JI(A, I, g, C, B) {
                                        var Q, i;
                                        return A |= 0, I |= 0, g |= 0, C |= 0, h = Q = h - 512 | 0, QI(i = Q + 32 | 0, B |= 0, 32), dC(i, I, g, C), fg(i, Q + 448 | 0), I = E[Q + 476 >> 2], E[Q + 24 >> 2] = E[Q + 472 >> 2], E[Q + 28 >> 2] = I, I = E[Q + 468 >> 2], E[Q + 16 >> 2] = E[Q + 464 >> 2], E[Q + 20 >> 2] = I, I = E[Q + 460 >> 2], E[Q + 8 >> 2] = E[Q + 456 >> 2], E[Q + 12 >> 2] = I, I = E[Q + 452 >> 2], E[Q >> 2] = E[Q + 448 >> 2], E[Q + 4 >> 2] = I, I = SC(A, Q), g = MI(Q, A, 32), h = Q + 512 | 0, ((0 | A) == (0 | Q) ? -1 : I) | g;
                                    }
                                    function UI(A, I, g, C, B, Q, i, o, a, _) {
                                        var c, t, r;
                                        return h = c = h - 352 | 0, jg(r = c + 32 | 0, 64, 0, a, _), fC(t = c + 96 | 0, r), XC(r, 64), NC(t, Q, i, o), E[c + 24 >> 2] = i, E[c + 28 >> 2] = o, NC(t, Q = c + 24 | 0, 8, 0), NC(t, I, g, C), E[c + 24 >> 2] = g, E[c + 28 >> 2] = C, NC(t, Q, 8, 0), nC(t, c), XC(t, 256), Q = iI(c, B), XC(c, 16), A && (Q ? (Hg(A, 0, g), Q = -1) : (Ug(A, I, g, C, a, 1, 0, _), Q = 0)), h = c + 352 | 0, Q;
                                    }
                                    function lI(A, I, g, C, B, Q, i, o, a, _, c) {
                                        var t, r, e;
                                        return h = t = h - 336 | 0, Xg(e = t + 16 | 0, 64, 0, _, c), fC(r = t + 80 | 0, e), XC(e, 64), NC(r, i, o, a), NC(r, 35648, 0 - o & 15, 0), gg(A, C, B, Q, _, 1, c), NC(r, A, B, Q), NC(r, 35648, 0 - B & 15, 0), E[t + 8 >> 2] = o, E[t + 12 >> 2] = a, NC(r, A = t + 8 | 0, 8, 0), E[t + 8 >> 2] = B, E[t + 12 >> 2] = Q, NC(r, A, 8, 0), nC(r, I), XC(r, 256), g && (E[g >> 2] = 16, E[g + 4 >> 2] = 0), h = t + 336 | 0, 0;
                                    }
                                    function mI(A, I) {
                                        var g, C = 0, B = 0, Q = 0, i = 0, o = 0;
                                        A: if (!(((g = a[0 | A]) - 58 & 255) >>> 0 < 246)) {
                                            for(C = g, B = A;;){
                                                if (i = B, Q >>> 0 > 429496729) break A;
                                                if ((C = (255 & C) - 48 | 0) >>> 0 > (-1 ^ (Q = c(Q, 10))) >>> 0) break A;
                                                if (Q = Q + C | 0, !(((C = a[0 | (B = B + 1 | 0)]) - 58 & 255) >>> 0 > 245)) break;
                                            }
                                            48 == (0 | g) & (0 | A) != (0 | i) | (0 | A) == (0 | B) || (E[I >> 2] = Q, o = B);
                                        }
                                        return o;
                                    }
                                    function uI(A) {
                                        var I = 0, g = 0, C = 0, B = 0;
                                        I = 65, g = 1024;
                                        A: {
                                            I: {
                                                if ((0 | (C = 255 & A)) != a[1024]) for(C = c(C, 16843009);;){
                                                    if ((-1 ^ (B = C ^ E[g >> 2])) & B - 16843009 & -2139062144) break I;
                                                    if (g = g + 4 | 0, !((I = I - 4 | 0) >>> 0 > 3)) break;
                                                }
                                                if (!I) break A;
                                            }
                                            for(A &= 255;;){
                                                if ((0 | A) == a[0 | g]) return g;
                                                if (g = g + 1 | 0, !(I = I - 1 | 0)) break;
                                            }
                                        }
                                        return 0;
                                    }
                                    function xI(A, I, g, C, B, Q, i, o, a, _, c) {
                                        var t, r, e;
                                        return h = t = h - 336 | 0, jg(e = t + 16 | 0, 64, 0, _, c), fC(r = t + 80 | 0, e), XC(e, 64), NC(r, i, o, a), E[t + 8 >> 2] = o, E[t + 12 >> 2] = a, NC(r, i = t + 8 | 0, 8, 0), Ug(A, C, B, Q, _, 1, 0, c), NC(r, A, B, Q), E[t + 8 >> 2] = B, E[t + 12 >> 2] = Q, NC(r, i, 8, 0), nC(r, I), XC(r, 256), g && (E[g >> 2] = 16, E[g + 4 >> 2] = 0), h = t + 336 | 0, 0;
                                    }
                                    function RI(A, I, g, C, B, Q) {
                                        return !C & g >>> 0 >= 32 | C ? (Gg(A, I, g, C, B, Q), hC(A + 16 | 0, A + 32 | 0, g - 32 | 0, C - (g >>> 0 < 32) | 0, A), o[A + 8 | 0] = 0, o[A + 9 | 0] = 0, o[A + 10 | 0] = 0, o[A + 11 | 0] = 0, o[A + 12 | 0] = 0, o[A + 13 | 0] = 0, o[A + 14 | 0] = 0, o[A + 15 | 0] = 0, o[0 | A] = 0, o[A + 1 | 0] = 0, o[A + 2 | 0] = 0, o[A + 3 | 0] = 0, o[A + 4 | 0] = 0, o[A + 5 | 0] = 0, o[A + 6 | 0] = 0, o[A + 7 | 0] = 0, A = 0) : A = -1, A;
                                    }
                                    function vI(A, I, g, C, B, Q) {
                                        I |= 0, B |= 0, Q |= 0;
                                        var i, o = 0;
                                        return h = i = h - 16 | 0, n(A |= 0, i + 8 | 0, yg(A - -64 | 0, g |= 0, C |= 0), C, B, Q, 0), E[i + 12 >> 2] | 64 != E[i + 8 >> 2] ? (I && (E[I >> 2] = 0, E[I + 4 >> 2] = 0), Hg(A, 0, C - -64 | 0), o = -1) : I && (E[I >> 2] = C - -64, E[I + 4 >> 2] = B - ((C >>> 0 < 4294967232) - 1 | 0)), h = i + 16 | 0, 0 | o;
                                    }
                                    function LI(A) {
                                        var I = 0, g = 0, C = 0;
                                        A: {
                                            I: if (3 & (I = A)) {
                                                if (!a[0 | I]) return 0;
                                                for(;;){
                                                    if (!(3 & (I = I + 1 | 0))) break I;
                                                    if (!a[0 | I]) break;
                                                }
                                                break A;
                                            }
                                            for(; g = I, I = I + 4 | 0, !((-1 ^ (C = E[g >> 2])) & C - 16843009 & -2139062144););
                                            for(; g = (I = g) + 1 | 0, a[0 | I];);
                                        }
                                        return I - A | 0;
                                    }
                                    function PI(A, I) {
                                        var g, C = 0, B = 0, Q = 0, i = 0;
                                        return (g = uI(a[0 | I])) && (C = uI(a[I + 1 | 0])) && (B = uI(a[I + 2 | 0])) && (Q = uI(a[I + 3 | 0])) && (i = uI(a[I + 4 | 0])) ? (E[A >> 2] = g - 1024 | C - 1024 << 6 | B - 1024 << 12 | Q - 1024 << 18 | i - 1024 << 24, I + 5 | 0) : (E[A >> 2] = 0, 0);
                                    }
                                    function qI(A, I, g) {
                                        var C;
                                        for(E[12 + (C = h - 16 | 0) >> 2] = A, E[C + 8 >> 2] = I, A = 0, E[C + 4 >> 2] = 0; E[C + 4 >> 2] = E[C + 4 >> 2] | a[E[C + 12 >> 2] + A | 0] ^ a[E[C + 8 >> 2] + A | 0], I = 1 | A, E[C + 4 >> 2] = E[C + 4 >> 2] | a[I + E[C + 12 >> 2] | 0] ^ a[I + E[C + 8 >> 2] | 0], (0 | g) != (0 | (A = A + 2 | 0)););
                                        return (E[C + 4 >> 2] - 1 >>> 8 & 1) - 1 | 0;
                                    }
                                    function zI(A, I, g, C, B, Q, i, o, a, _, c) {
                                        var t = 0, r = 0, e = 0;
                                        return r = -1, (t = C >>> 0 < 32) & !B || !(t = B - t | 0) & (e = C - 32 | 0) >>> 0 > 4294967263 | t | !o & i >>> 0 > 4294967263 | o || (r = 0 | pB[E[c >> 2]](A, g, e, (g + C | 0) - 32 | 0, 32, Q, i, a, _)), I && (E[I >> 2] = r ? 0 : C - 32 | 0, E[I + 4 >> 2] = r ? 0 : B - (C >>> 0 < 32) | 0), r;
                                    }
                                    function jI(A, I) {
                                        var g, C = 0, B = 0, Q = 0;
                                        h = g = h - 896 | 0, pA(C = g + 848 | 0, I), pA(B = g + 800 | 0, I + 32 | 0), T(Q = g + 320 | 0, C), T(I = g + 160 | 0, B), TA(C = g + 640 | 0, I), sA(I = g + 480 | 0, Q, C), Y(g, I, C = g + 600 | 0), Y(g + 40 | 0, B = g + 520 | 0, Q = g + 560 | 0), Y(g + 80 | 0, Q, C), Y(g + 120 | 0, I, B), O(A, g), h = g + 896 | 0;
                                    }
                                    function XI(A) {
                                        var I = 0, g = 0, C = 0, B = 0;
                                        for(I = 1; I = a[0 | (g = A + C | 0)] + I | 0, o[0 | g] = I, I = a[0 | (g = (1 | C) + A | 0)] + (I >>> 8 | 0) | 0, o[0 | g] = I, I = a[0 | (g = (2 | C) + A | 0)] + (I >>> 8 | 0) | 0, o[0 | g] = I, I = a[0 | (g = (3 | C) + A | 0)] + (I >>> 8 | 0) | 0, o[0 | g] = I, I = I >>> 8 | 0, C = C + 4 | 0, 4 != (0 | (B = B + 4 | 0)););
                                    }
                                    function OI(A, I, g, C, B, Q, i) {
                                        var o;
                                        return h = o = h - 16 | 0, A = Hg(A, 0, 128), !(C | Q) & i >>> 0 < 2147483649 ? (!Q & B >>> 0 >= 3 | 0 != (0 | Q)) & i >>> 0 > 8191 ? (ag(o, 16), A = oA(B, i >>> 10 | 0, I, g, o, A, 1) ? -1 : 0) : (E[9392] = 28, A = -1) : (E[9392] = 22, A = -1), h = o + 16 | 0, A;
                                    }
                                    function VI(A, I) {
                                        var g = 0;
                                        4 & I && ((I = E[A >> 2]) && XC(E[I + 4 >> 2], E[A + 16 >> 2] << 10), (I = E[A + 4 >> 2]) && XC(I, E[A + 20 >> 2] << 3)), gA(E[A + 4 >> 2]), E[A + 4 >> 2] = 0, (I = E[A >> 2]) && (g = E[I >> 2]) && gA(g), gA(I), E[A >> 2] = 0;
                                    }
                                    function ZI(A) {
                                        var I = 0, g = 0, C = 0, B = 0, Q = 0, i = 0, o = 0, E = 0;
                                        for(I = 32, g = 1; E = (B = a[(C = I - 2 | 0) + A | 0]) - (Q = a[C + 2928 | 0]) >> 8 & (I = ((i = a[2928 + (I = I - 1 | 0) | 0]) ^ (o = a[A + I | 0])) - 1 >> 8 & g) | 255 & (o - i >>> 8 & g | E), g = I & (B ^ Q) - 1 >> 8, I = C;);
                                        return 0 != (255 & E);
                                    }
                                    function WI(A, I, g, C, B, i, o, a, _, c, t) {
                                        return !B & C >>> 0 > 4294967263 | 0 != (0 | B) | !a & o >>> 0 >= 4294967264 | 0 != (0 | a) ? (yC(), Q()) : (A = 0 | pB[E[t >> 2]](A, A + C | 0, 32, g, C, i, o, _, c), I && (C = (g = C + 32 | 0) >>> 0 < 32 ? B + 1 | 0 : B, E[I >> 2] = A ? 0 : g, E[I + 4 >> 2] = A ? 0 : C)), A;
                                    }
                                    function TI(A, I, g, C, B, Q, i) {
                                        var o;
                                        return h = o = h - 16 | 0, A = Hg(A, 0, 128), !(C | Q) & i >>> 0 < 2147483649 ? !!(B | Q) & i >>> 0 > 8191 ? (ag(o, 16), A = oA(B, i >>> 10 | 0, I, g, o, A, 2) ? -1 : 0) : (E[9392] = 28, A = -1) : (E[9392] = 22, A = -1), h = o + 16 | 0, A;
                                    }
                                    function $I(A) {
                                        var I = 0;
                                        return E[32 + (A |= 0) >> 2] = 0, E[A + 36 >> 2] = 0, I = E[8601], E[A >> 2] = E[8600], E[A + 4 >> 2] = I, I = E[8603], E[A + 8 >> 2] = E[8602], E[A + 12 >> 2] = I, I = E[8605], E[A + 16 >> 2] = E[8604], E[A + 20 >> 2] = I, I = E[8607], E[A + 24 >> 2] = E[8606], E[A + 28 >> 2] = I, 0;
                                    }
                                    function Ag(A, I, g, C, B, Q, i) {
                                        var o, E, a = 0, _ = 0;
                                        return h = o = h + -64 | 0, a = -1, (E = g >>> 0 < 16) & !C || gI(_ = o + 32 | 0, i, Q) || yA(o, 35584, _, 0) || (a = hI(A, I + 16 | 0, I, g - 16 | 0, C - E | 0, B, o), XC(o, 32)), h = o - -64 | 0, a;
                                    }
                                    function Ig(A, I, g, C) {
                                        var B, Q, i, o, E = 0, a = 0;
                                        return o = c(E = g >>> 16 | 0, a = A >>> 16 | 0), E = (65535 & (a = ((i = c(B = 65535 & g, Q = 65535 & A)) >>> 16 | 0) + c(a, B) | 0)) + c(E, Q) | 0, w = (c(I, g) + o | 0) + c(A, C) + (a >>> 16) + (E >>> 16) | 0, 65535 & i | E << 16;
                                    }
                                    function gg(A, I, g, C, B, i, o) {
                                        var a = 0, _ = 0;
                                        if (a = C, !(1 == (((a = (_ = g + 63 | 0) >>> 0 < 63 ? a + 1 | 0 : a) >>> 6 | 0) + (0 != (0 | (a = (63 & a) << 26 | _ >>> 6))) | 0) & i >>> 0 > (_ = 0 - a | 0) >>> 0 | 1 == (0 | C) | C >>> 0 > 1)) return 0 | pB[E[8928]](A, I, g, C, B, i, o);
                                        yC(), Q();
                                    }
                                    function Cg(A, I, g) {
                                        var C = 0, B = 0;
                                        if (!g) return 0;
                                        if (C = a[0 | A]) A: {
                                            for(;;){
                                                if ((0 | (B = a[0 | I])) != (0 | C) | !B) break A;
                                                if (!(g = g - 1 | 0)) break A;
                                                if (I = I + 1 | 0, C = a[A + 1 | 0], A = A + 1 | 0, !C) break;
                                            }
                                            C = 0;
                                        }
                                        else C = 0;
                                        return C - a[0 | I] | 0;
                                    }
                                    function Bg(A, I, g, C, B, Q, i) {
                                        var o;
                                        return A |= 0, I |= 0, g |= 0, C |= 0, B |= 0, h = o = h + -64 | 0, gI(o + 32 | 0, i |= 0, Q |= 0) ? Q = -1 : (Q = -1, fA(o, 35664, o + 32 | 0, 0) || (Q = wI(A, I, g, C, B, o), XC(o, 32))), h = o - -64 | 0, 0 | Q;
                                    }
                                    function Qg(A, I, g, C, B, Q, i) {
                                        var o;
                                        return A |= 0, I |= 0, g |= 0, C |= 0, B |= 0, h = o = h + -64 | 0, gI(o + 32 | 0, i |= 0, Q |= 0) ? Q = -1 : (Q = -1, fA(o, 35664, o + 32 | 0, 0) || (Q = RI(A, I, g, C, B, o), XC(o, 32))), h = o - -64 | 0, 0 | Q;
                                    }
                                    function ig(A, I, g, C, B, i, o) {
                                        var E;
                                        if (h = E = h + -64 | 0, !C & g >>> 0 < 4294967280) return gI(E + 32 | 0, o, i) ? o = -1 : (o = -1, yA(E, 35584, E + 32 | 0, 0) || (o = rI(A + 16 | 0, A, I, g, C, B, E), XC(E, 32))), h = E - -64 | 0, o;
                                        yC(), Q();
                                    }
                                    function og(A, I) {
                                        for(var g = 0, C = 0, B = 0, Q = 0, i = 0; C = A + B | 0, g = a[I + B | 0] + (a[0 | C] + g | 0) | 0, o[0 | C] = g, Q = (C = 1 | B) + A | 0, g = a[I + C | 0] + (a[0 | Q] + (g >>> 8 | 0) | 0) | 0, o[0 | Q] = g, g = g >>> 8 | 0, B = B + 2 | 0, 32 != (0 | (i = i + 2 | 0)););
                                    }
                                    function Eg(A, I) {
                                        for(var g = 0, C = 0, B = 0, Q = 0, i = 0; g = (a[0 | (C = A + B | 0)] - a[I + B | 0] | 0) + g | 0, o[0 | C] = g, g = (a[0 | (Q = (C = 1 | B) + A | 0)] - a[I + C | 0] | 0) + (g >> 8) | 0, o[0 | Q] = g, g >>= 8, B = B + 2 | 0, 64 != (0 | (i = i + 2 | 0)););
                                    }
                                    function ag(A, I) {
                                        A |= 0;
                                        var g, C = 0, B = 0, Q = 0;
                                        if (h = g = h - 16 | 0, I |= 0) for(; o[g + 15 | 0] = 0, B = A + C | 0, Q = 0 | r(36800, g + 15 | 0, 0), o[0 | B] = Q, (0 | (C = C + 1 | 0)) != (0 | I););
                                        h = g + 16 | 0;
                                    }
                                    function _g(A, I, g, C, B, Q, i) {
                                        var o, E, a = 0;
                                        return h = o = h - 32 | 0, a = -1, (E = g >>> 0 < 16) & !C || cC(o, Q, i) || (a = yI(A, I + 16 | 0, I, g - 16 | 0, C - E | 0, B, o), XC(o, 32)), h = o + 32 | 0, a;
                                    }
                                    function cg(A) {
                                        var I, g;
                                        return (A = (I = E[8924]) + (g = A + 7 & -8) | 0) >>> 0 <= I >>> 0 && g || A >>> 0 > wB() << 16 >>> 0 && !(0 | s(0 | A)) ? (E[9392] = 48, -1) : (E[8924] = A, I);
                                    }
                                    function tg(A, I) {
                                        var g, C, B;
                                        h = g = h - 176 | 0, vA(C = g + 96 | 0, I + 80 | 0), Y(B = g + 48 | 0, I, C), Y(g, I + 40 | 0, C), BI(A, g), BI(g + 144 | 0, B), o[A + 31 | 0] = a[A + 31 | 0] ^ a[g + 144 | 0] << 7, h = g + 176 | 0;
                                    }
                                    function rg(A, I, g, C, B, Q, i, o, E, a) {
                                        var _, c, t = 0, r = 0, e = 0;
                                        return h = _ = h - 16 | 0, t = -1, _C(c = _ + 4 | 0) || (r = -1, e = _A(c, A, I, g, C, B, Q, i, o, E, a), t = vg(c) ? r : e), h = _ + 16 | 0, t;
                                    }
                                    function eg(A, I, g, C, B, i, o, a, _, c, t, r) {
                                        return g && (E[g >> 2] = 32, E[g + 4 >> 2] = 0), !_ & a >>> 0 < 4294967264 & !i & B >>> 0 <= 4294967263 || (yC(), Q()), 0 | pB[E[r >> 2]](A, I, 32, C, B, o, a, c, t);
                                    }
                                    function yg(A, I, g) {
                                        var C = 0;
                                        if (A >>> 0 < I >>> 0) return Sg(A, I, g);
                                        if (g) for(C = A + g | 0, I = I + g | 0; I = I - 1 | 0, o[0 | (C = C - 1 | 0)] = a[0 | I], g = g - 1 | 0;);
                                        return A;
                                    }
                                    function sg(A, I, g, C, B, i, o) {
                                        var E, a = 0;
                                        if (h = E = h - 32 | 0, !C & g >>> 0 < 4294967280) return a = -1, cC(E, i, o) || (a = eI(A + 16 | 0, A, I, g, C, B, E), XC(E, 32)), h = E + 32 | 0, a;
                                        yC(), Q();
                                    }
                                    function hg(A, I, g, C, B, Q) {
                                        return I |= 0, 0 | (!(C |= 0) & (g |= 0) >>> 0 >= 16 | C ? yI(A |= 0, I + 16 | 0, I, g - 16 | 0, C - (g >>> 0 < 16) | 0, B |= 0, Q |= 0) : -1);
                                    }
                                    function Dg(A, I, g, C, B, Q) {
                                        return I |= 0, 0 | (!(C |= 0) & (g |= 0) >>> 0 >= 16 | C ? hI(A |= 0, I + 16 | 0, I, g - 16 | 0, C - (g >>> 0 < 16) | 0, B |= 0, Q |= 0) : -1);
                                    }
                                    function pg(A, I, g, C, B, Q, i, o, a, _, c) {
                                        return !C & g >>> 0 > 4294967263 | C | !o & i >>> 0 > 4294967263 | o ? -1 : 0 | pB[E[c >> 2]](A, I, g, B, 32, Q, i, a, _);
                                    }
                                    function wg(A, I, g) {
                                        A |= 0;
                                        var C, B = 0;
                                        return h = C = h - 32 | 0, B = -1, gI(C, g |= 0, I |= 0) || (B = fA(A, 35664, C, 0)), h = C + 32 | 0, 0 | B;
                                    }
                                    function fg(A, I) {
                                        var g;
                                        return I |= 0, h = g = h + -64 | 0, z(A |= 0, g), nA(A = A + 208 | 0, g, 64, 0), z(A, I), XC(g, 64), h = g - -64 | 0, 0;
                                    }
                                    function ng(A, I, g, C) {
                                        var B;
                                        return I |= 0, g |= 0, C |= 0, h = B = h + -64 | 0, z(A |= 0, B), A = n(I, g, B, 64, 0, C, 1), h = B - -64 | 0, 0 | A;
                                    }
                                    function kg(A, I) {
                                        var g, C, B;
                                        Y(A, I, g = I + 120 | 0), Y(A + 40 | 0, C = I + 40 | 0, B = I + 80 | 0), Y(A + 80 | 0, B, g), Y(A + 120 | 0, I, C);
                                    }
                                    function Fg(A, I) {
                                        var g;
                                        return I |= 0, h = g = h - 32 | 0, dA(A |= 0, g), MA(A = A + 104 | 0, g, 32, 0), dA(A, I), XC(g, 32), h = g + 32 | 0, 0;
                                    }
                                    function Ng(A, I, g, C, B, Q, i) {
                                        return 0 | TI(A |= 0, I |= 0, (A = 0) | (g |= 0), C |= 0, A | (B |= 0), Q |= 0, i |= 0);
                                    }
                                    function Sg(A, I, g) {
                                        var C = 0;
                                        if (g) for(C = A; o[0 | C] = a[0 | I], C = C + 1 | 0, I = I + 1 | 0, g = g - 1 | 0;);
                                        return A;
                                    }
                                    function Gg(A, I, g, C, B, Q) {
                                        var i;
                                        return h = i = h - 32 | 0, fA(i, B, Q, 0), A = oC(A, I, g, C, B + 16 | 0, 0, 0, i), XC(i, 32), h = i + 32 | 0, A;
                                    }
                                    function Mg(A) {
                                        for(A |= 0; ag(A, 32), o[A + 31 | 0] = 31 & a[A + 31 | 0], !ZI(A) || NI(A, 32););
                                    }
                                    function bg(A, I, g) {
                                        var C;
                                        return I |= 0, g |= 0, h = C = h + -64 | 0, z(A |= 0, C), A = H(I, C, 64, 0, g, 1), h = C - -64 | 0, 0 | A;
                                    }
                                    function Kg(A, I, g, C, B) {
                                        var Q;
                                        return h = Q = h - 32 | 0, fA(Q, C, B, 0), A = pC(A, I, g, C + 16 | 0, Q), XC(Q, 32), h = Q + 32 | 0, A;
                                    }
                                    function Hg(A, I, g) {
                                        var C = 0;
                                        if (g) for(C = A; o[0 | C] = I, C = C + 1 | 0, g = g - 1 | 0;);
                                        return A;
                                    }
                                    function Yg(A, I, g) {
                                        return A |= 0, I |= 0, (g |= 0) >>> 0 >= 256 && (e(1349, 1262, 107, 1123), Q()), 0 | $(A, I, 255 & g);
                                    }
                                    function dg(A, I, g, C, B, Q, i) {
                                        return 0 | eI(A |= 0, I |= 0, g |= 0, C |= 0, B |= 0, Q |= 0, i |= 0);
                                    }
                                    function Jg(A, I, g, C, B, Q, i) {
                                        return 0 | yI(A |= 0, I |= 0, g |= 0, C |= 0, B |= 0, Q |= 0, i |= 0);
                                    }
                                    function Ug(A, I, g, C, B, i, o, a) {
                                        return 1 == (0 | C) | C >>> 0 > 1 && (yC(), Q()), 0 | pB[E[8927]](A, I, g, C, B, i, o, a);
                                    }
                                    function lg(A, I, g, C, B, Q, i) {
                                        return 0 | rI(A |= 0, I |= 0, g |= 0, C |= 0, B |= 0, Q |= 0, i |= 0);
                                    }
                                    function mg(A, I, g, C, B, Q, i) {
                                        return 0 | hI(A |= 0, I |= 0, g |= 0, C |= 0, B |= 0, Q |= 0, i |= 0);
                                    }
                                    function ug(A, I, g, C, B, i) {
                                        return 1 == (0 | C) | C >>> 0 > 1 && (yC(), Q()), 0 | pB[E[8927]](A, I, g, C, B, 0, 0, i);
                                    }
                                    function xg(A, I, g, C, B, i) {
                                        return 1 == (0 | C) | C >>> 0 > 1 && (yC(), Q()), 0 | pB[E[8928]](A, I, g, C, B, 0, i);
                                    }
                                    function Rg(A, I, g, C, B, Q) {
                                        return n(A |= 0, I |= 0, g |= 0, C |= 0, B |= 0, Q |= 0, 0), 0;
                                    }
                                    function vg(A) {
                                        var I;
                                        return (I = E[A >> 2]) && gA(I), E[A + 8 >> 2] = 0, E[A >> 2] = 0, E[A + 4 >> 2] = 0, 0;
                                    }
                                    function Lg(A, I) {
                                        var g = 0;
                                        return (-1 >>> (g = 31 & I) & A) << g | ((g = A) & -1 << (A = 0 - I & 31)) >>> A;
                                    }
                                    function Pg(A, I, g, C, B, Q) {
                                        return 0 | RI(A |= 0, I |= 0, g |= 0, C |= 0, B |= 0, Q |= 0);
                                    }
                                    function qg(A, I, g, C, B, Q) {
                                        return 0 | wI(A |= 0, I |= 0, g |= 0, C |= 0, B |= 0, Q |= 0);
                                    }
                                    function zg(A, I, g, C, B, Q) {
                                        return 0 | Gg(A |= 0, I |= 0, g |= 0, C |= 0, B |= 0, Q |= 0);
                                    }
                                    function jg(A, I, g, C, B) {
                                        return 1 == (0 | g) | g >>> 0 > 1 && (yC(), Q()), 0 | pB[E[8925]](A, I, g, C, B);
                                    }
                                    function Xg(A, I, g, C, B) {
                                        return 1 == (0 | g) | g >>> 0 > 1 && (yC(), Q()), 0 | pB[E[8926]](A, I, g, C, B);
                                    }
                                    function Og(A, I, g, C, B, i) {
                                        1 == (0 | C) | C >>> 0 > 1 && (yC(), Q()), pB[E[8928]](A, I, g, C, B, 1, i);
                                    }
                                    function Vg(A, I, g, C, B) {
                                        return 0 | H(A |= 0, I |= 0, g |= 0, C |= 0, B |= 0, 0);
                                    }
                                    function Zg(A, I, g, C, B) {
                                        return 0 | hC(A |= 0, I |= 0, g |= 0, C |= 0, B |= 0);
                                    }
                                    function Wg(A, I, g, C, B) {
                                        return 0 | DC(A |= 0, I |= 0, g |= 0, C |= 0, B |= 0);
                                    }
                                    function Tg(A, I, g, C, B) {
                                        return 0 | Kg(A |= 0, I |= 0, g |= 0, C |= 0, B |= 0);
                                    }
                                    function $g() {
                                        var A;
                                        h = A = h - 16 | 0, o[A + 15 | 0] = 0, r(36836, A + 15 | 0, 0), h = A + 16 | 0;
                                    }
                                    function AC(A, I, g, C) {
                                        return CA(A |= 0, I |= 0, g |= 0, C |= 0, 20), 0;
                                    }
                                    function IC(A, I, g, C) {
                                        return CA(A |= 0, I |= 0, g |= 0, C |= 0, 12), 0;
                                    }
                                    function gC(A, I, g, C) {
                                        return CA(A |= 0, I |= 0, g |= 0, C |= 0, 8), 0;
                                    }
                                    function CC(A, I, g, C) {
                                        return 0 | kI(A |= 0, I |= 0, g |= 0, C |= 0);
                                    }
                                    function BC(A, I, g, C) {
                                        return 0 | NC(A |= 0, I |= 0, g |= 0, C |= 0);
                                    }
                                    function QC(A, I, g, C) {
                                        return 0 | nA(A |= 0, I |= 0, g |= 0, C |= 0);
                                    }
                                    function iC(A, I, g, C) {
                                        return 0 | eA(A |= 0, I |= 0, g |= 0, C |= 0);
                                    }
                                    function oC(A, I, g, C, B, Q, i, o) {
                                        return 0 | pB[E[8937]](A, I, g, C, B, Q, i, o);
                                    }
                                    function EC(A, I, g, C) {
                                        return 0 | dC(A |= 0, I |= 0, g |= 0, C |= 0);
                                    }
                                    function aC(A, I, g, C, B, Q) {
                                        return 0 | pB[E[8937]](A, I, g, C, B, 0, 0, Q);
                                    }
                                    function _C(A) {
                                        return E[A + 8 >> 2] = 0, E[A >> 2] = 0, E[A + 4 >> 2] = 0, 0;
                                    }
                                    function cC(A, I, g) {
                                        return 0 | wg(A |= 0, I |= 0, g |= 0);
                                    }
                                    function tC(A, I, g) {
                                        return 0 | gI(A |= 0, I |= 0, g |= 0);
                                    }
                                    function rC(A, I, g) {
                                        return 0 | Yg(A |= 0, I |= 0, g |= 0);
                                    }
                                    function eC(A, I, g) {
                                        return 0 | QI(A |= 0, I |= 0, g |= 0);
                                    }
                                    function yC() {
                                        var A;
                                        (A = E[9526]) && pB[0 | A](), y(), Q();
                                    }
                                    function sC(A, I) {
                                        return A |= 0, ag(I |= 0, 32), 0 | wC(A, I);
                                    }
                                    function hC(A, I, g, C, B) {
                                        return 0 | pB[E[8929]](A, I, g, C, B);
                                    }
                                    function DC(A, I, g, C, B) {
                                        return 0 | pB[E[8930]](A, I, g, C, B);
                                    }
                                    function pC(A, I, g, C, B) {
                                        return 0 | pB[E[8936]](A, I, g, C, B);
                                    }
                                    function wC(A, I) {
                                        return A |= 0, I |= 0, 0 | pB[E[8935]](A, I);
                                    }
                                    function fC(A, I) {
                                        return A |= 0, I |= 0, 0 | pB[E[8931]](A, I);
                                    }
                                    function nC(A, I) {
                                        return A |= 0, I |= 0, 0 | pB[E[8933]](A, I);
                                    }
                                    function kC(A, I, g, C, B, Q, i) {
                                        return lA(A, I, g, C, B, Q, i);
                                    }
                                    function FC(A) {
                                        return A ? 31 - t(A - 1 ^ A) | 0 : 32;
                                    }
                                    function NC(A, I, g, C) {
                                        return 0 | pB[E[8932]](A, I, g, C);
                                    }
                                    function SC(A, I) {
                                        return 0 | qI(A |= 0, I |= 0, 32);
                                    }
                                    function GC(A, I) {
                                        return 0 | qI(A |= 0, I |= 0, 64);
                                    }
                                    function MC(A, I, g) {
                                        k(A |= 0, I |= 0, g |= 0);
                                    }
                                    function bC(A, I) {
                                        return 0 | wC(A |= 0, I |= 0);
                                    }
                                    function KC(A, I) {
                                        return 0 | sC(A |= 0, I |= 0);
                                    }
                                    function HC(A, I, g, C) {
                                        return CI(A, I, g, C, 2);
                                    }
                                    function YC(A, I, g, C) {
                                        return MA(A, I, g, C), 0;
                                    }
                                    function dC(A, I, g, C) {
                                        return nA(A, I, g, C), 0;
                                    }
                                    function JC(A, I, g, C) {
                                        return CI(A, I, g, C, 1);
                                    }
                                    function UC(A, I, g, C) {
                                        return nI(A, I, g, C, 1);
                                    }
                                    function lC(A, I, g, C) {
                                        return nI(A, I, g, C, 2);
                                    }
                                    function mC(A, I, g, C) {
                                        return XA(A, I, g, C);
                                    }
                                    function uC(A) {
                                        return SI(A |= 0), 0;
                                    }
                                    function xC() {
                                        return 1073741824;
                                    }
                                    function RC() {
                                        return -2147483648;
                                    }
                                    function vC() {
                                        return 268435456;
                                    }
                                    function LC(A) {
                                        ag(A |= 0, 32);
                                    }
                                    function PC() {
                                        return 67108864;
                                    }
                                    function qC(A) {
                                        ag(A |= 0, 16);
                                    }
                                    function zC() {
                                        return 16777216;
                                    }
                                    function jC() {
                                        return 33554432;
                                    }
                                    function XC(A, I) {
                                        Hg(A, 0, I);
                                    }
                                    function OC() {
                                        return 1559;
                                    }
                                    function VC() {
                                        return 1321;
                                    }
                                    function ZC() {
                                        return 8192;
                                    }
                                    function WC() {
                                        return 384;
                                    }
                                    function TC() {
                                        return 416;
                                    }
                                    function $C() {
                                        return 256;
                                    }
                                    function AB() {
                                        return 128;
                                    }
                                    function IB() {
                                        return 208;
                                    }
                                    function gB() {
                                        return 64;
                                    }
                                    function CB() {
                                        return 16;
                                    }
                                    function BB() {
                                        return 32;
                                    }
                                    function QB() {
                                        return 12;
                                    }
                                    function iB() {
                                        return -65;
                                    }
                                    function oB() {
                                        return -17;
                                    }
                                    function EB() {
                                        return 48;
                                    }
                                    function aB() {
                                        return -33;
                                    }
                                    function _B() {
                                        return 24;
                                    }
                                    function cB() {
                                        return 4;
                                    }
                                    function tB() {
                                        return -1;
                                    }
                                    function rB() {
                                        return 1;
                                    }
                                    function eB() {
                                        return 2;
                                    }
                                    function yB() {
                                        return 3;
                                    }
                                    function sB() {
                                        return 8;
                                    }
                                    function hB() {
                                        return 0;
                                    }
                                    B(I = a, 1024, "Li8wMTIzNDU2Nzg5QUJDREVGR0hJSktMTU5PUFFSU1RVVldYWVphYmNkZWZnaGlqa2xtbm9wcXJzdHV2d3h5egBqcwByYW5kb21ieXRlcwBiNjRfcG9zIDw9IGI2NF9sZW4AY3J5cHRvX2dlbmVyaWNoYXNoX2JsYWtlMmJfZmluYWwAJGFyZ29uMmkAJGFyZ29uMmlkAHJhbmRvbWJ5dGVzL3JhbmRvbWJ5dGVzLmMAc29kaXVtL2NvZGVjcy5jAGNyeXB0b19nZW5lcmljaGFzaC9ibGFrZTJiL3JlZi9ibGFrZTJiLXJlZi5jAGNyeXB0b19nZW5lcmljaGFzaC9ibGFrZTJiL3JlZi9nZW5lcmljaGFzaF9ibGFrZTJiLmMAeDI1NTE5Ymxha2UyYgBidWZfbGVuIDw9IFNJWkVfTUFYAG91dGxlbiA8PSBVSU5UOF9NQVgAUy0+YnVmbGVuIDw9IEJMQUtFMkJfQkxPQ0tCWVRFUwAkYXJnb24yaSR2PQAkYXJnb24yaWQkdj0ALHQ9ACxwPQAkbT0AY3VydmUyNTUxOQBlZDI1NTE5ADEuMC4xOQBobWFjc2hhNTEyMjU2AGN1cnZlMjU1MTl4c2Fsc2EyMHBvbHkxMzA1AHNvZGl1bV9iaW4yYmFzZTY0AHNpcGhhc2gyNABzaGE1MTIAeHNhbHNhMjAAJGFyZ29uMmkkACRhcmdvbjJpZCQAJDckAExpYnNvZGl1bURSRw=="), B(I, 1600, "tnhZ/4Vy0wC9bhX/DwpqACnAAQCY6Hn/vDyg/5lxzv8At+L+tA1I/wAAAAAAAAAAsKAO/tPJhv+eGI8Af2k1AGAMvQCn1/v/n0yA/mpl4f8e/AQAkgyu"), B(I, 1696, "WfGy/grlpv973Sr+HhTUAFKAAwAw0fMAd3lA/zLjnP8AbsUBZxuQ"), B(I, 1744, "hTuMAb3xJP/4JcMBYNw3ALdMPv/DQj0AMkykAeGkTP9MPaP/dT4fAFGRQP92QQ4AonPW/waKLgB85vT/CoqPADQawgC49EwAgY8pAb70E/97qnr/YoFEAHnVkwBWZR7/oWebAIxZQ//v5b4BQwu1AMbwif7uRbz/Q5fuABMqbP/lVXEBMkSH/xFqCQAyZwH/UAGoASOYHv8QqLkBOFno/2XS/AAp+kcAzKpP/w4u7/9QTe8AvdZL/xGN+QAmUEz/vlV1AFbkqgCc2NABw8+k/5ZCTP+v4RD/jVBiAUzb8gDGonIALtqYAJsr8f6boGj/M7ulAAIRrwBCVKAB9zoeACNBNf5F7L8ALYb1AaN73QAgbhT/NBelALrWRwDpsGAA8u82ATlZigBTAFT/iKBkAFyOeP5ofL4AtbE+//opVQCYgioBYPz2AJeXP/7vhT4AIDicAC2nvf+OhbMBg1bTALuzlv76qg7/0qNOACU0lwBjTRoA7pzV/9XA0QFJLlQAFEEpATbOTwDJg5L+qm8Y/7EhMv6rJsv/Tvd0ANHdmQCFgLIBOiwZAMknOwG9E/wAMeXSAXW7dQC1s7gBAHLbADBekwD1KTgAfQ3M/vStdwAs3SD+VOoUAPmgxgHsfur/L2Oo/qrimf9ms9gA4o16/3pCmf629YYA4+QZAdY56//YrTj/tefSAHeAnf+BX4j/bn4zAAKpt/8HgmL+RbBe/3QE4wHZ8pH/yq0fAWkBJ/8ur0UA5C86/9fgRf7POEX/EP6L/xfP1P/KFH7/X9Vg/wmwIQDIBc//8SqA/iMhwP/45cQBgRF4APtnl/8HNHD/jDhC/yji9f/ZRiX+rNYJ/0hDhgGSwNb/LCZwAES4S//OWvsAleuNALWqOgB09O8AXJ0CAGatYgDpiWABfzHLAAWblAAXlAn/03oMACKGGv/bzIgAhggp/+BTK/5VGfcAbX8A/qmIMADud9v/563VAM4S/v4Iugf/fgkHAW8qSABvNOz+YD+NAJO/f/7NTsD/DmrtAbvbTACv87v+aVmtAFUZWQGi85QAAnbR/iGeCQCLoy7/XUYoAGwqjv5v/I7/m9+QADPlp/9J/Jv/XnQM/5ig2v+c7iX/s+rP/8UAs/+apI0A4cRoAAojGf7R1PL/Yf3e/rhl5QDeEn8BpIiH/x7PjP6SYfMAgcAa/slUIf9vCk7/k1Gy/wQEGACh7tf/Bo0hADXXDv8ptdD/54udALPL3f//uXEAveKs/3FC1v/KPi3/ZkAI/06uEP6FdUT/"), B(I, 2736, "AQ=="), B(I, 2768, "JuiVj8KyJ7BFw/SJ8u+Y8NXfrAXTxjM5sTgCiG1T/AXHF2pwPU3YT7o8C3YNEGcPKiBT+iw5zMZOx/13kqwDeuz///////////////////////////////////////9/7f///////////////////////////////////////3/u////////////////////////////////////////f+3T9VwaYxJY1pz3ot753hQ="), B(I, 2959, "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"), B(I, 33980, "AQAAAHbBXwBlcAL/UPyh/vJqxv+FBrIA5N9wAN/uVf4z8xoAPiuL/stBCg=="), B(I, 34032, "M03tAJGqVv82JjP/8YBl/yl5Sv/sTpsAqZdp/pwpSADCZq//zqJl/wAAAAAAAAAAGy57ARKo/f/Tr5f+w9tgADh2vv7+0fX/mWR+/uiBFf81uPL/x6Td"), B(I, 34160, "AQ=="), B(I, 34192, "4Ot6fDtBuK4WVuP68Z/EatoJjeucMrH9hmIFFl9JuABfnJW8o1CMJLHQsVWcg+9bBERcxFgcjobYIk7d0J8RV+z///////////////////////////////////////9/7f///////////////////////////////////////3/u////////////////////////////////////////f+3T9VwaYxJY1pz3ot753hQ="), B(I, 34383, "EA=="), B(I, 34400, "Z+YJaoWuZ7ty8248OvVPpX9SDlGMaAWbq9mDHxnN4FuYL4pCkUQ3cc/7wLWl27XpW8JWOfER8Vmkgj+S1V4cq5iqB9gBW4MSvoUxJMN9DFV0Xb5y/rHegKcG3Jt08ZvBwWmb5IZHvu/GncEPzKEMJG8s6S2qhHRK3KmwXNqI+XZSUT6YbcYxqMgnA7DHf1m/8wvgxkeRp9VRY8oGZykpFIUKtyc4IRsu/G0sTRMNOFNUcwpluwpqdi7JwoGFLHKSoei/oktmGqhwi0vCo1FsxxnoktEkBpnWhTUO9HCgahAWwaQZCGw3Hkx3SCe1vLA0swwcOUqq2E5Pypxb828uaO6Cj3RvY6V4FHjIhAgCx4z6/76Q62xQpPej+b7yeHHGgA=="), B(I, 34752, "CMm882fmCWo7p8qEha5nuyv4lP5y82488TYdXzr1T6XRguatf1IOUR9sPiuMaAWba71B+6vZgx95IX4TGc3gWyKuKNeYL4pCzWXvI5FEN3EvO03sz/vAtbzbiYGl27XpOLVI81vCVjkZ0AW28RHxWZtPGa+kgj+SGIFt2tVeHKtCAgOjmKoH2L5vcEUBW4MSjLLkTr6FMSTitP/Vw30MVW+Je/J0Xb5ysZYWO/6x3oA1Esclpwbcm5Qmac908ZvB0krxnsFpm+TjJU84hke+77XVjIvGncEPZZysd8yhDCR1AitZbyzpLYPkpm6qhHRK1PtBvdypsFy1UxGD2oj5dqvfZu5SUT6YEDK0LW3GMag/IfuYyCcDsOQO777Hf1m/wo+oPfML4MYlpwqTR5Gn1W+CA+BRY8oGcG4OCmcpKRT8L9JGhQq3JybJJlw4IRsu7SrEWvxtLE3fs5WdEw04U95jr4tUcwplqLJ3PLsKanbmru1HLsnCgTs1ghSFLHKSZAPxTKHov6IBMEK8S2YaqJGX+NBwi0vCML5UBqNRbMcYUu/WGeiS0RCpZVUkBpnWKiBxV4U1DvS40bsycKBqEMjQ0rgWwaQZU6tBUQhsNx6Z647fTHdIJ6hIm+G1vLA0Y1rJxbMMHDnLikHjSqrYTnPjY3dPypxbo7iy1vNvLmj8su9d7oKPdGAvF0NvY6V4cqvwoRR4yITsOWQaCALHjCgeYyP6/76Q6b2C3utsUKQVecay96P5vitTcuPyeHHGnGEm6s4+J8oHwsAhx7iG0R7r4M3WfdrqeNFu7n9PffW6bxdyqmfwBqaYyKLFfWMKrg35vgSYPxEbRxwTNQtxG4R9BCP1d9sokyTHQHuryjK8vskVCr6ePEwNEJzEZx1DtkI+y77UxUwqfmX8nCl/Wez61jqrb8tfF1hHSowZRGyA"), B(I, 35600, "U2lnRWQyNTUxOSBubyBFZDI1NTE5IGNvbGxpc2lvbnMB"), B(I, 35696, "4JQBAAEAAAACAAAAAwAAAAQAAAAFAAAABgAAAAcAAAAIAAAACQAAAAoAAAALAAAADAAAAA0="), B(I, 35760, "xmNjpfh8fITud3eZ9nt7jf/y8g3Wa2u93m9vsZHFxVRgMDBQAgEBA85nZ6lWKyt95/7+GbXX12JNq6vm7HZ2mo/KykUfgoKdicnJQPp9fYfv+voVsllZ645HR8n78PALQa2t7LPU1GdfoqL9Ra+v6iOcnL9TpKT35HJylpvAwFt1t7fC4f39HD2Tk65MJiZqbDY2Wn4/P0H19/cCg8zMT2g0NFxRpaX00eXlNPnx8QjicXGTq9jYc2IxMVMqFRU/CAQEDJXHx1JGIyNlncPDXjAYGCg3lpahCgUFDy+amrUOBwcJJBISNhuAgJvf4uI9zevrJk4nJ2l/srLN6nV1nxIJCRsdg4OeWCwsdDQaGi42Gxst3G5usrRaWu5boKD7pFJS9nY7O0231tZhfbOzzlIpKXvd4+M+Xi8vcROEhJemU1P1udHRaAAAAADB7e0sQCAgYOP8/B95sbHItltb7dRqar6Ny8tGZ76+2XI5OUuUSkremExM1LBYWOiFz89Ku9DQa8Xv7ypPqqrl7fv7FoZDQ8WaTU3XZjMzVRGFhZSKRUXP6fn5EAQCAgb+f3+BoFBQ8Hg8PEQln5+6S6io46JRUfNdo6P+gEBAwAWPj4o/kpKtIZ2dvHA4OEjx9fUEY7y833e2tsGv2tp1QiEhYyAQEDDl//8a/fPzDr/S0m2Bzc1MGAwMFCYTEzXD7Owvvl9f4TWXl6KIRETMLhcXOZPExFdVp6fy/H5+gno9PUfIZGSsul1d5zIZGSvmc3OVwGBgoBmBgZieT0/Ro9zcf0QiImZUKip+O5CQqwuIiIOMRkbKx+7uKWu4uNMoFBQ8p97eebxeXuIWCwsdrdvbdtvg4DtkMjJWdDo6ThQKCh6SSUnbDAYGCkgkJGy4XFzkn8LCXb3T025DrKzvxGJipjmRkagxlZWk0+TkN/J5eYvV5+cyi8jIQ243N1nabW23AY2NjLHV1WScTk7SSamp4NhsbLSsVlb68/T0B8/q6iXKZWWv9Hp6jkeurukQCAgYb7q61fB4eIhKJSVvXC4ucjgcHCRXpqbxc7S0x5fGxlHL6Ogjod3dfOh0dJw+Hx8hlktL3WG9vdwNi4uGD4qKheBwcJB8Pj5CcbW1xMxmZqqQSEjYBgMDBff29gEcDg4SwmFho2o1NV+uV1f5abm50BeGhpGZwcFYOh0dJyeenrnZ4eE46/j4EyuYmLMiEREz0mlpu6nZ2XAHjo6JM5SUpy2bm7Y8Hh4iFYeHksnp6SCHzs5JqlVV/1AoKHil3996A4yMj1mhofgJiYmAGg0NF2W/v9rX5uYxhEJCxtBoaLiCQUHDKZmZsFotLXceDw8Re7Cwy6hUVPxtu7vWLBYWOg4AAAAPAAAAEAAAABE=");
                                    var DB, pB = (DB = [
                                        null,
                                        function(A, I, g, C, B) {
                                            var Q;
                                            return A |= 0, C |= 0, B |= 0, h = Q = h + -64 | 0, (I |= 0) | (g |= 0) && (E[Q + 8 >> 2] = 2036477234, E[Q + 12 >> 2] = 1797285236, E[Q >> 2] = 1634760805, E[Q + 4 >> 2] = 857760878, E[Q + 16 >> 2] = a[0 | B] | a[B + 1 | 0] << 8 | a[B + 2 | 0] << 16 | a[B + 3 | 0] << 24, E[Q + 20 >> 2] = a[B + 4 | 0] | a[B + 5 | 0] << 8 | a[B + 6 | 0] << 16 | a[B + 7 | 0] << 24, E[Q + 24 >> 2] = a[B + 8 | 0] | a[B + 9 | 0] << 8 | a[B + 10 | 0] << 16 | a[B + 11 | 0] << 24, E[Q + 28 >> 2] = a[B + 12 | 0] | a[B + 13 | 0] << 8 | a[B + 14 | 0] << 16 | a[B + 15 | 0] << 24, E[Q + 32 >> 2] = a[B + 16 | 0] | a[B + 17 | 0] << 8 | a[B + 18 | 0] << 16 | a[B + 19 | 0] << 24, E[Q + 36 >> 2] = a[B + 20 | 0] | a[B + 21 | 0] << 8 | a[B + 22 | 0] << 16 | a[B + 23 | 0] << 24, E[Q + 40 >> 2] = a[B + 24 | 0] | a[B + 25 | 0] << 8 | a[B + 26 | 0] << 16 | a[B + 27 | 0] << 24, B = a[B + 28 | 0] | a[B + 29 | 0] << 8 | a[B + 30 | 0] << 16 | a[B + 31 | 0] << 24, E[Q + 48 >> 2] = 0, E[Q + 52 >> 2] = 0, E[Q + 44 >> 2] = B, E[Q + 56 >> 2] = a[0 | C] | a[C + 1 | 0] << 8 | a[C + 2 | 0] << 16 | a[C + 3 | 0] << 24, E[Q + 60 >> 2] = a[C + 4 | 0] | a[C + 5 | 0] << 8 | a[C + 6 | 0] << 16 | a[C + 7 | 0] << 24, q(Q, A = Hg(A, 0, I), A, I, g), XC(Q, 64)), h = Q - -64 | 0, 0;
                                        },
                                        function(A, I, g, C, B) {
                                            var Q;
                                            return A |= 0, C |= 0, B |= 0, h = Q = h + -64 | 0, (I |= 0) | (g |= 0) && (E[Q + 8 >> 2] = 2036477234, E[Q + 12 >> 2] = 1797285236, E[Q >> 2] = 1634760805, E[Q + 4 >> 2] = 857760878, E[Q + 16 >> 2] = a[0 | B] | a[B + 1 | 0] << 8 | a[B + 2 | 0] << 16 | a[B + 3 | 0] << 24, E[Q + 20 >> 2] = a[B + 4 | 0] | a[B + 5 | 0] << 8 | a[B + 6 | 0] << 16 | a[B + 7 | 0] << 24, E[Q + 24 >> 2] = a[B + 8 | 0] | a[B + 9 | 0] << 8 | a[B + 10 | 0] << 16 | a[B + 11 | 0] << 24, E[Q + 28 >> 2] = a[B + 12 | 0] | a[B + 13 | 0] << 8 | a[B + 14 | 0] << 16 | a[B + 15 | 0] << 24, E[Q + 32 >> 2] = a[B + 16 | 0] | a[B + 17 | 0] << 8 | a[B + 18 | 0] << 16 | a[B + 19 | 0] << 24, E[Q + 36 >> 2] = a[B + 20 | 0] | a[B + 21 | 0] << 8 | a[B + 22 | 0] << 16 | a[B + 23 | 0] << 24, E[Q + 40 >> 2] = a[B + 24 | 0] | a[B + 25 | 0] << 8 | a[B + 26 | 0] << 16 | a[B + 27 | 0] << 24, B = a[B + 28 | 0] | a[B + 29 | 0] << 8 | a[B + 30 | 0] << 16 | a[B + 31 | 0] << 24, E[Q + 48 >> 2] = 0, E[Q + 44 >> 2] = B, E[Q + 52 >> 2] = a[0 | C] | a[C + 1 | 0] << 8 | a[C + 2 | 0] << 16 | a[C + 3 | 0] << 24, E[Q + 56 >> 2] = a[C + 4 | 0] | a[C + 5 | 0] << 8 | a[C + 6 | 0] << 16 | a[C + 7 | 0] << 24, E[Q + 60 >> 2] = a[C + 8 | 0] | a[C + 9 | 0] << 8 | a[C + 10 | 0] << 16 | a[C + 11 | 0] << 24, q(Q, A = Hg(A, 0, I), A, I, g), XC(Q, 64)), h = Q - -64 | 0, 0;
                                        },
                                        function(A, I, g, C, B, Q, i, o) {
                                            var _;
                                            return A |= 0, I |= 0, B |= 0, Q |= 0, i |= 0, o |= 0, h = _ = h + -64 | 0, (g |= 0) | (C |= 0) && (E[_ + 8 >> 2] = 2036477234, E[_ + 12 >> 2] = 1797285236, E[_ >> 2] = 1634760805, E[_ + 4 >> 2] = 857760878, E[_ + 16 >> 2] = a[0 | o] | a[o + 1 | 0] << 8 | a[o + 2 | 0] << 16 | a[o + 3 | 0] << 24, E[_ + 20 >> 2] = a[o + 4 | 0] | a[o + 5 | 0] << 8 | a[o + 6 | 0] << 16 | a[o + 7 | 0] << 24, E[_ + 24 >> 2] = a[o + 8 | 0] | a[o + 9 | 0] << 8 | a[o + 10 | 0] << 16 | a[o + 11 | 0] << 24, E[_ + 28 >> 2] = a[o + 12 | 0] | a[o + 13 | 0] << 8 | a[o + 14 | 0] << 16 | a[o + 15 | 0] << 24, E[_ + 32 >> 2] = a[o + 16 | 0] | a[o + 17 | 0] << 8 | a[o + 18 | 0] << 16 | a[o + 19 | 0] << 24, E[_ + 36 >> 2] = a[o + 20 | 0] | a[o + 21 | 0] << 8 | a[o + 22 | 0] << 16 | a[o + 23 | 0] << 24, E[_ + 40 >> 2] = a[o + 24 | 0] | a[o + 25 | 0] << 8 | a[o + 26 | 0] << 16 | a[o + 27 | 0] << 24, E[_ + 44 >> 2] = a[o + 28 | 0] | a[o + 29 | 0] << 8 | a[o + 30 | 0] << 16 | a[o + 31 | 0] << 24, E[_ + 48 >> 2] = Q, E[_ + 52 >> 2] = i, E[_ + 56 >> 2] = a[0 | B] | a[B + 1 | 0] << 8 | a[B + 2 | 0] << 16 | a[B + 3 | 0] << 24, E[_ + 60 >> 2] = a[B + 4 | 0] | a[B + 5 | 0] << 8 | a[B + 6 | 0] << 16 | a[B + 7 | 0] << 24, q(_, I, A, g, C), XC(_, 64)), h = _ - -64 | 0, 0;
                                        },
                                        function(A, I, g, C, B, Q, i) {
                                            var o;
                                            return A |= 0, I |= 0, B |= 0, Q |= 0, i |= 0, h = o = h + -64 | 0, (g |= 0) | (C |= 0) && (E[o + 8 >> 2] = 2036477234, E[o + 12 >> 2] = 1797285236, E[o >> 2] = 1634760805, E[o + 4 >> 2] = 857760878, E[o + 16 >> 2] = a[0 | i] | a[i + 1 | 0] << 8 | a[i + 2 | 0] << 16 | a[i + 3 | 0] << 24, E[o + 20 >> 2] = a[i + 4 | 0] | a[i + 5 | 0] << 8 | a[i + 6 | 0] << 16 | a[i + 7 | 0] << 24, E[o + 24 >> 2] = a[i + 8 | 0] | a[i + 9 | 0] << 8 | a[i + 10 | 0] << 16 | a[i + 11 | 0] << 24, E[o + 28 >> 2] = a[i + 12 | 0] | a[i + 13 | 0] << 8 | a[i + 14 | 0] << 16 | a[i + 15 | 0] << 24, E[o + 32 >> 2] = a[i + 16 | 0] | a[i + 17 | 0] << 8 | a[i + 18 | 0] << 16 | a[i + 19 | 0] << 24, E[o + 36 >> 2] = a[i + 20 | 0] | a[i + 21 | 0] << 8 | a[i + 22 | 0] << 16 | a[i + 23 | 0] << 24, E[o + 40 >> 2] = a[i + 24 | 0] | a[i + 25 | 0] << 8 | a[i + 26 | 0] << 16 | a[i + 27 | 0] << 24, i = a[i + 28 | 0] | a[i + 29 | 0] << 8 | a[i + 30 | 0] << 16 | a[i + 31 | 0] << 24, E[o + 48 >> 2] = Q, E[o + 44 >> 2] = i, E[o + 52 >> 2] = a[0 | B] | a[B + 1 | 0] << 8 | a[B + 2 | 0] << 16 | a[B + 3 | 0] << 24, E[o + 56 >> 2] = a[B + 4 | 0] | a[B + 5 | 0] << 8 | a[B + 6 | 0] << 16 | a[B + 7 | 0] << 24, E[o + 60 >> 2] = a[B + 8 | 0] | a[B + 9 | 0] << 8 | a[B + 10 | 0] << 16 | a[B + 11 | 0] << 24, q(o, I, A, g, C), XC(o, 64)), h = o - -64 | 0, 0;
                                        },
                                        function(A, I, g, C, B) {
                                            var Q, i, _;
                                            return A |= 0, I |= 0, g |= 0, C |= 0, B |= 0, h = Q = (i = h) - 128 & -64, E[Q >> 2] = 67108863 & (a[0 | B] | a[B + 1 | 0] << 8 | a[B + 2 | 0] << 16 | a[B + 3 | 0] << 24), E[Q + 4 >> 2] = (a[B + 3 | 0] | a[B + 4 | 0] << 8 | a[B + 5 | 0] << 16 | a[B + 6 | 0] << 24) >>> 2 & 67108611, E[Q + 8 >> 2] = (a[B + 6 | 0] | a[B + 7 | 0] << 8 | a[B + 8 | 0] << 16 | a[B + 9 | 0] << 24) >>> 4 & 67092735, E[Q + 12 >> 2] = (a[B + 9 | 0] | a[B + 10 | 0] << 8 | a[B + 11 | 0] << 16 | a[B + 12 | 0] << 24) >>> 6 & 66076671, _ = a[B + 12 | 0] | a[B + 13 | 0] << 8 | a[B + 14 | 0] << 16 | a[B + 15 | 0] << 24, E[Q + 20 >> 2] = 0, E[Q + 24 >> 2] = 0, E[Q + 28 >> 2] = 0, E[Q + 32 >> 2] = 0, E[Q + 36 >> 2] = 0, E[Q + 16 >> 2] = _ >>> 8 & 1048575, E[Q + 40 >> 2] = a[B + 16 | 0] | a[B + 17 | 0] << 8 | a[B + 18 | 0] << 16 | a[B + 19 | 0] << 24, E[Q + 44 >> 2] = a[B + 20 | 0] | a[B + 21 | 0] << 8 | a[B + 22 | 0] << 16 | a[B + 23 | 0] << 24, E[Q + 48 >> 2] = a[B + 24 | 0] | a[B + 25 | 0] << 8 | a[B + 26 | 0] << 16 | a[B + 27 | 0] << 24, B = a[B + 28 | 0] | a[B + 29 | 0] << 8 | a[B + 30 | 0] << 16 | a[B + 31 | 0] << 24, o[Q + 80 | 0] = 0, E[Q + 56 >> 2] = 0, E[Q + 60 >> 2] = 0, E[Q + 52 >> 2] = B, uA(Q, I, g, C), II(Q, A), h = i, 0;
                                        },
                                        function(A, I, g, C, B) {
                                            var Q, i, _;
                                            return A |= 0, I |= 0, g |= 0, C |= 0, B |= 0, h = Q = (i = h) - 192 & -64, E[Q + 64 >> 2] = 67108863 & (a[0 | B] | a[B + 1 | 0] << 8 | a[B + 2 | 0] << 16 | a[B + 3 | 0] << 24), E[Q + 68 >> 2] = (a[B + 3 | 0] | a[B + 4 | 0] << 8 | a[B + 5 | 0] << 16 | a[B + 6 | 0] << 24) >>> 2 & 67108611, E[Q + 72 >> 2] = (a[B + 6 | 0] | a[B + 7 | 0] << 8 | a[B + 8 | 0] << 16 | a[B + 9 | 0] << 24) >>> 4 & 67092735, E[Q + 76 >> 2] = (a[B + 9 | 0] | a[B + 10 | 0] << 8 | a[B + 11 | 0] << 16 | a[B + 12 | 0] << 24) >>> 6 & 66076671, _ = a[B + 12 | 0] | a[B + 13 | 0] << 8 | a[B + 14 | 0] << 16 | a[B + 15 | 0] << 24, E[Q + 84 >> 2] = 0, E[Q + 88 >> 2] = 0, E[Q + 92 >> 2] = 0, E[Q + 96 >> 2] = 0, E[Q + 100 >> 2] = 0, E[Q + 80 >> 2] = _ >>> 8 & 1048575, E[Q + 104 >> 2] = a[B + 16 | 0] | a[B + 17 | 0] << 8 | a[B + 18 | 0] << 16 | a[B + 19 | 0] << 24, E[Q + 108 >> 2] = a[B + 20 | 0] | a[B + 21 | 0] << 8 | a[B + 22 | 0] << 16 | a[B + 23 | 0] << 24, E[Q + 112 >> 2] = a[B + 24 | 0] | a[B + 25 | 0] << 8 | a[B + 26 | 0] << 16 | a[B + 27 | 0] << 24, B = a[B + 28 | 0] | a[B + 29 | 0] << 8 | a[B + 30 | 0] << 16 | a[B + 31 | 0] << 24, o[Q + 144 | 0] = 0, E[Q + 120 >> 2] = 0, E[Q + 124 >> 2] = 0, E[Q + 116 >> 2] = B, uA(B = Q - -64 | 0, I, g, C), II(B, I = Q + 48 | 0), A = iI(A, I), h = i, 0 | A;
                                        },
                                        function(A, I) {
                                            var g;
                                            return I |= 0, E[(A |= 0) >> 2] = 67108863 & (a[0 | I] | a[I + 1 | 0] << 8 | a[I + 2 | 0] << 16 | a[I + 3 | 0] << 24), E[A + 4 >> 2] = (a[I + 3 | 0] | a[I + 4 | 0] << 8 | a[I + 5 | 0] << 16 | a[I + 6 | 0] << 24) >>> 2 & 67108611, E[A + 8 >> 2] = (a[I + 6 | 0] | a[I + 7 | 0] << 8 | a[I + 8 | 0] << 16 | a[I + 9 | 0] << 24) >>> 4 & 67092735, E[A + 12 >> 2] = (a[I + 9 | 0] | a[I + 10 | 0] << 8 | a[I + 11 | 0] << 16 | a[I + 12 | 0] << 24) >>> 6 & 66076671, g = a[I + 12 | 0] | a[I + 13 | 0] << 8 | a[I + 14 | 0] << 16 | a[I + 15 | 0] << 24, E[A + 20 >> 2] = 0, E[A + 24 >> 2] = 0, E[A + 28 >> 2] = 0, E[A + 32 >> 2] = 0, E[A + 36 >> 2] = 0, E[A + 16 >> 2] = g >>> 8 & 1048575, E[A + 40 >> 2] = a[I + 16 | 0] | a[I + 17 | 0] << 8 | a[I + 18 | 0] << 16 | a[I + 19 | 0] << 24, E[A + 44 >> 2] = a[I + 20 | 0] | a[I + 21 | 0] << 8 | a[I + 22 | 0] << 16 | a[I + 23 | 0] << 24, E[A + 48 >> 2] = a[I + 24 | 0] | a[I + 25 | 0] << 8 | a[I + 26 | 0] << 16 | a[I + 27 | 0] << 24, I = a[I + 28 | 0] | a[I + 29 | 0] << 8 | a[I + 30 | 0] << 16 | a[I + 31 | 0] << 24, o[A + 80 | 0] = 0, E[A + 56 >> 2] = 0, E[A + 60 >> 2] = 0, E[A + 52 >> 2] = I, 0;
                                        },
                                        function(A, I, g, C) {
                                            return uA(A |= 0, I |= 0, g |= 0, C |= 0), 0;
                                        },
                                        function(A, I) {
                                            return II(A |= 0, I |= 0), 0;
                                        },
                                        function(A, I, g) {
                                            A |= 0, I |= 0, g |= 0;
                                            var C, B = 0, Q = 0, i = 0, _ = 0, c = 0, t = 0, r = 0, e = 0, y = 0, s = 0, D = 0, p = 0, f = 0, n = 0, k = 0, F = 0, N = 0, S = 0, G = 0, M = 0, b = 0, K = 0, H = 0, d = 0, J = 0, U = 0, l = 0, m = 0, u = 0, x = 0, R = 0, L = 0, P = 0, q = 0, z = 0, j = 0, X = 0, O = 0, V = 0, Z = 0, W = 0, T = 0, $ = 0, AA = 0, IA = 0, gA = 0, CA = 0, BA = 0, QA = 0, iA = 0, oA = 0, EA = 0, aA = 0, _A = 0, cA = 0, tA = 0, rA = 0, eA = 0, yA = 0, sA = 0, hA = 0, DA = 0, wA = 0, fA = 0, nA = 0, kA = 0;
                                            for(h = C = h - 368 | 0; D = (i = a[g + B | 0]) ^ a[0 | (c = B + 34128 | 0)] | D, s = i ^ a[c + 192 | 0] | s, y = i ^ a[c + 160 | 0] | y, e = i ^ a[c + 128 | 0] | e, _ = i ^ a[c + 96 | 0] | _, t = i ^ a[c - -64 | 0] | t, Q = i ^ a[c + 32 | 0] | Q, 31 != (0 | (B = B + 1 | 0)););
                                            if (B = -1, !(256 & ((255 & ((i = 127 ^ (c = 127 & a[g + 31 | 0])) | s)) - 1 | (255 & (i | y)) - 1 | (255 & (i | e)) - 1 | (255 & (87 ^ c | _)) - 1 | (255 & (t | c)) - 1 | (255 & (Q | c)) - 1 | (255 & (c | D)) - 1))) {
                                                for(B = I, I = a[I + 28 | 0] | a[I + 29 | 0] << 8 | a[I + 30 | 0] << 16 | a[I + 31 | 0] << 24, E[C + 360 >> 2] = a[B + 24 | 0] | a[B + 25 | 0] << 8 | a[B + 26 | 0] << 16 | a[B + 27 | 0] << 24, E[C + 364 >> 2] = I, I = a[B + 20 | 0] | a[B + 21 | 0] << 8 | a[B + 22 | 0] << 16 | a[B + 23 | 0] << 24, E[C + 352 >> 2] = a[B + 16 | 0] | a[B + 17 | 0] << 8 | a[B + 18 | 0] << 16 | a[B + 19 | 0] << 24, E[C + 356 >> 2] = I, Q = a[B + 4 | 0] | a[B + 5 | 0] << 8 | a[B + 6 | 0] << 16 | a[B + 7 | 0] << 24, I = a[0 | B] | a[B + 1 | 0] << 8 | a[B + 2 | 0] << 16 | a[B + 3 | 0] << 24, E[C + 336 >> 2] = I, E[C + 340 >> 2] = Q, Q = a[B + 12 | 0] | a[B + 13 | 0] << 8 | a[B + 14 | 0] << 16 | a[B + 15 | 0] << 24, E[C + 344 >> 2] = a[B + 8 | 0] | a[B + 9 | 0] << 8 | a[B + 10 | 0] << 16 | a[B + 11 | 0] << 24, E[C + 348 >> 2] = Q, o[C + 336 | 0] = 248 & I, o[C + 367 | 0] = 63 & a[C + 367 | 0] | 64, pA(C + 288 | 0, g), E[C + 260 >> 2] = 0, E[C + 264 >> 2] = 0, E[C + 268 >> 2] = 0, E[C + 272 >> 2] = 0, E[C + 276 >> 2] = 0, E[C + 208 >> 2] = 0, E[C + 212 >> 2] = 0, E[C + 216 >> 2] = 0, E[C + 220 >> 2] = 0, E[C + 224 >> 2] = 0, E[C + 228 >> 2] = 0, I = E[C + 308 >> 2], E[C + 160 >> 2] = E[C + 304 >> 2], E[C + 164 >> 2] = I, I = E[C + 316 >> 2], E[C + 168 >> 2] = E[C + 312 >> 2], E[C + 172 >> 2] = I, I = E[C + 324 >> 2], E[C + 176 >> 2] = E[C + 320 >> 2], E[C + 180 >> 2] = I, E[C + 244 >> 2] = 0, E[C + 248 >> 2] = 0, E[C + 240 >> 2] = 1, E[C + 252 >> 2] = 0, E[C + 256 >> 2] = 0, E[C + 192 >> 2] = 0, E[C + 196 >> 2] = 0, E[C + 200 >> 2] = 0, E[C + 204 >> 2] = 0, I = E[C + 292 >> 2], E[C + 144 >> 2] = E[C + 288 >> 2], E[C + 148 >> 2] = I, I = E[C + 300 >> 2], E[C + 152 >> 2] = E[C + 296 >> 2], E[C + 156 >> 2] = I, E[C + 116 >> 2] = 0, E[C + 120 >> 2] = 0, E[C + 124 >> 2] = 0, E[C + 128 >> 2] = 0, E[C + 132 >> 2] = 0, E[C + 100 >> 2] = 0, E[C + 104 >> 2] = 0, E[C + 96 >> 2] = 1, E[C + 108 >> 2] = 0, E[C + 112 >> 2] = 0, g = 254; W = E[C + 276 >> 2], i = E[C + 180 >> 2], T = E[C + 96 >> 2], $ = E[C + 192 >> 2], AA = E[C + 144 >> 2], IA = E[C + 240 >> 2], gA = E[C + 100 >> 2], CA = E[C + 196 >> 2], BA = E[C + 148 >> 2], QA = E[C + 244 >> 2], K = E[C + 104 >> 2], iA = E[C + 200 >> 2], H = E[C + 152 >> 2], oA = E[C + 248 >> 2], U = E[C + 108 >> 2], EA = E[C + 204 >> 2], l = E[C + 156 >> 2], aA = E[C + 252 >> 2], d = E[C + 112 >> 2], _A = E[C + 208 >> 2], M = E[C + 160 >> 2], cA = E[C + 256 >> 2], D = E[C + 116 >> 2], tA = E[C + 212 >> 2], r = E[C + 164 >> 2], rA = E[C + 260 >> 2], s = E[C + 120 >> 2], eA = E[C + 216 >> 2], y = E[C + 168 >> 2], yA = E[C + 264 >> 2], e = E[C + 124 >> 2], sA = E[C + 220 >> 2], _ = E[C + 172 >> 2], hA = E[C + 268 >> 2], t = E[C + 128 >> 2], DA = E[C + 224 >> 2], Q = E[C + 176 >> 2], G = E[C + 272 >> 2], wA = g, b = (F = (I = 0 - ((I = Z) ^ (Z = a[(fA = C + 336 | 0) + (g >>> 3 | 0) | 0] >>> (7 & g) & 1)) | 0) & ((B = E[C + 132 >> 2]) ^ (j = E[C + 228 >> 2]))) ^ B, E[C + 132 >> 2] = b, X = i ^ (N = I & (i ^ W)), E[C + 84 >> 2] = X - b, J = t ^ (f = I & (t ^ DA)), E[C + 128 >> 2] = J, O = (S = I & (Q ^ G)) ^ Q, E[C + 80 >> 2] = O - J, u = e ^ (n = I & (e ^ sA)), E[C + 124 >> 2] = u, nA = _ ^ (k = I & (_ ^ hA)), E[C + 76 >> 2] = nA - u, x = s ^ (p = I & (s ^ eA)), E[C + 120 >> 2] = x, kA = y ^ (c = I & (y ^ yA)), E[C + 72 >> 2] = kA - x, R = D ^ (i = I & (D ^ tA)), E[C + 116 >> 2] = R, L = r ^ (D = I & (r ^ rA)), E[C + 68 >> 2] = L - R, P = d ^ (s = I & (d ^ _A)), E[C + 112 >> 2] = P, m = M ^ (y = I & (M ^ cA)), E[C + 64 >> 2] = m - P, q = U ^ (e = I & (U ^ EA)), E[C + 108 >> 2] = q, V = l ^ (_ = I & (l ^ aA)), E[C + 60 >> 2] = V - q, z = K ^ (t = I & (K ^ iA)), E[C + 104 >> 2] = z, U = H ^ (Q = I & (H ^ oA)), E[C + 56 >> 2] = U - z, K = gA ^ (B = I & (gA ^ CA)), E[C + 100 >> 2] = K, l = BA ^ (g = I & (BA ^ QA)), E[C + 52 >> 2] = l - K, H = T ^ (d = I & (T ^ $)), E[C + 96 >> 2] = H, M = (I &= AA ^ IA) ^ AA, E[C + 48 >> 2] = M - H, r = N ^ W, F ^= j, E[C + 36 >> 2] = r - F, N = S ^ G, f ^= DA, E[C + 32 >> 2] = N - f, S = k ^ hA, n ^= sA, E[C + 28 >> 2] = S - n, k = c ^ yA, p ^= eA, E[C + 24 >> 2] = k - p, c = D ^ rA, i ^= tA, E[C + 20 >> 2] = c - i, D = y ^ cA, s ^= _A, E[C + 16 >> 2] = D - s, y = _ ^ aA, e ^= EA, E[C + 12 >> 2] = y - e, _ = Q ^ oA, t ^= iA, E[C + 8 >> 2] = _ - t, Q = g ^ QA, B ^= CA, E[C + 4 >> 2] = Q - B, g = I ^ IA, I = d ^ $, E[C >> 2] = g - I, E[C + 276 >> 2] = r + F, E[C + 272 >> 2] = N + f, E[C + 268 >> 2] = n + S, E[C + 264 >> 2] = p + k, E[C + 260 >> 2] = i + c, E[C + 256 >> 2] = s + D, E[C + 248 >> 2] = _ + t, E[C + 244 >> 2] = B + Q, E[C + 240 >> 2] = I + g, E[C + 252 >> 2] = e + y, E[C + 228 >> 2] = b + X, E[C + 224 >> 2] = J + O, E[C + 220 >> 2] = u + nA, E[C + 216 >> 2] = x + kA, E[C + 212 >> 2] = R + L, E[C + 208 >> 2] = m + P, E[C + 204 >> 2] = q + V, E[C + 200 >> 2] = U + z, E[C + 196 >> 2] = K + l, E[C + 192 >> 2] = M + H, Y(X = C + 96 | 0, J = C + 48 | 0, b = C + 240 | 0), Y(G = C + 192 | 0, G, C), v(J, C), v(C, b), r = E[C + 192 >> 2], F = E[C + 96 >> 2], N = E[C + 196 >> 2], f = E[C + 100 >> 2], S = E[C + 200 >> 2], n = E[C + 104 >> 2], k = E[C + 204 >> 2], p = E[C + 108 >> 2], c = E[C + 208 >> 2], i = E[C + 112 >> 2], D = E[C + 212 >> 2], s = E[C + 116 >> 2], y = E[C + 216 >> 2], e = E[C + 120 >> 2], _ = E[C + 220 >> 2], t = E[C + 124 >> 2], Q = E[C + 224 >> 2], B = E[C + 128 >> 2], g = E[C + 228 >> 2], I = E[C + 132 >> 2], E[C + 180 >> 2] = g + I, E[C + 176 >> 2] = B + Q, E[C + 172 >> 2] = _ + t, E[C + 168 >> 2] = e + y, E[C + 164 >> 2] = s + D, E[C + 160 >> 2] = i + c, E[C + 156 >> 2] = p + k, E[C + 152 >> 2] = n + S, E[C + 148 >> 2] = N + f, E[C + 144 >> 2] = r + F, E[C + 228 >> 2] = I - g, E[C + 224 >> 2] = B - Q, E[C + 220 >> 2] = t - _, E[C + 216 >> 2] = e - y, E[C + 212 >> 2] = s - D, E[C + 208 >> 2] = i - c, E[C + 204 >> 2] = p - k, E[C + 200 >> 2] = n - S, E[C + 196 >> 2] = f - N, E[C + 192 >> 2] = F - r, Y(b, C, J), u = E[C + 52 >> 2], p = E[C + 4 >> 2], x = E[C + 56 >> 2], c = E[C + 8 >> 2], R = E[C + 64 >> 2], y = E[C + 16 >> 2], P = E[C + 60 >> 2], e = E[C + 12 >> 2], q = E[C + 72 >> 2], _ = E[C + 24 >> 2], z = E[C + 68 >> 2], t = E[C + 20 >> 2], K = E[C + 80 >> 2], Q = E[C + 32 >> 2], H = E[C + 76 >> 2], B = E[C + 28 >> 2], j = E[C + 84 >> 2], I = E[C + 36 >> 2], O = E[C + 48 >> 2], g = E[C >> 2] - O | 0, E[C >> 2] = g, I = I - j | 0, E[C + 36 >> 2] = I, d = B - H | 0, E[C + 28 >> 2] = d, M = Q - K | 0, E[C + 32 >> 2] = M, i = t - z | 0, E[C + 20 >> 2] = i, D = _ - q | 0, E[C + 24 >> 2] = D, s = e - P | 0, E[C + 12 >> 2] = s, y = y - R | 0, E[C + 16 >> 2] = y, e = c - x | 0, E[C + 8 >> 2] = e, Q = p - u | 0, E[C + 4 >> 2] = Q, v(G, G), I = Ig(I, I >> 31, 121666, 0), B = w, V = I, I = Ig((33554431 & (B = (r = I + 16777216 | 0) >>> 0 < 16777216 ? B + 1 | 0 : B)) << 7 | r >>> 25, B >> 25, 19, 0), t = w, B = I, I = Ig(g, g >> 31, 121666, 0), m = w + t | 0, I = I >>> 0 > (B = B + I | 0) >>> 0 ? m + 1 | 0 : m, g = (_ = B + 33554432 | 0) >>> 0 < 33554432 ? I + 1 | 0 : I, F = B - (-67108864 & _) | 0, E[C + 96 >> 2] = F, t = Ig(Q, Q >> 31, 121666, 0), B = w, B = (Q = t + 16777216 | 0) >>> 0 < 16777216 ? B + 1 | 0 : B, N = (t - (-33554432 & Q) | 0) + ((67108863 & g) << 6 | _ >>> 26) | 0, E[C + 100 >> 2] = N, m = (I = B) >> 25, B = (33554431 & I) << 7 | Q >>> 25, g = Ig(e, e >> 31, 121666, 0) + B | 0, I = m + w | 0, I = g >>> 0 < B >>> 0 ? I + 1 | 0 : I, t = (f = g + 33554432 | 0) >>> 0 < 33554432 ? I + 1 | 0 : I, S = g - (-67108864 & f) | 0, E[C + 104 >> 2] = S, B = Ig(y, y >> 31, 121666, 0), Q = w, g = Ig(s, s >> 31, 121666, 0), I = w, L = B, U = g, B = (33554431 & (I = (n = g + 16777216 | 0) >>> 0 < 16777216 ? I + 1 | 0 : I)) << 7 | n >>> 25, I = (I >> 25) + Q | 0, I = (g = L + B | 0) >>> 0 < B >>> 0 ? I + 1 | 0 : I, Q = (k = g + 33554432 | 0) >>> 0 < 33554432 ? I + 1 | 0 : I, p = g - (-67108864 & k) | 0, E[C + 112 >> 2] = p, B = Ig(D, D >> 31, 121666, 0), _ = w, g = Ig(i, i >> 31, 121666, 0), I = w, L = B, l = g, B = (33554431 & (I = (c = g + 16777216 | 0) >>> 0 < 16777216 ? I + 1 | 0 : I)) << 7 | c >>> 25, I = (I >> 25) + _ | 0, I = (g = L + B | 0) >>> 0 < B >>> 0 ? I + 1 | 0 : I, B = (i = g + 33554432 | 0) >>> 0 < 33554432 ? I + 1 | 0 : I, D = g - (-67108864 & i) | 0, E[C + 120 >> 2] = D, _ = Ig(M, M >> 31, 121666, 0), e = w, g = Ig(d, d >> 31, 121666, 0), I = w, M = g, g = (33554431 & (I = (s = g + 16777216 | 0) >>> 0 < 16777216 ? I + 1 | 0 : I)) << 7 | s >>> 25, I = (I >> 25) + e | 0, I = g >>> 0 > (_ = g + _ | 0) >>> 0 ? I + 1 | 0 : I, g = (y = _ + 33554432 | 0) >>> 0 < 33554432 ? I + 1 | 0 : I, e = _ - (-67108864 & y) | 0, E[C + 128 >> 2] = e, _ = (t = U + ((67108863 & t) << 6 | f >>> 26) | 0) - (-33554432 & n) | 0, E[C + 108 >> 2] = _, t = (Q = l + ((67108863 & Q) << 6 | k >>> 26) | 0) - (-33554432 & c) | 0, E[C + 116 >> 2] = t, Q = (I = M + ((67108863 & B) << 6 | i >>> 26) | 0) - (-33554432 & s) | 0, E[C + 124 >> 2] = Q, g = (g = V + ((67108863 & g) << 6 | y >>> 26) | 0) - (-33554432 & r) | 0, E[C + 132 >> 2] = g, v(I = C + 144 | 0, I), E[C + 84 >> 2] = g + j, E[C + 80 >> 2] = e + K, E[C + 76 >> 2] = Q + H, E[C + 72 >> 2] = D + q, E[C + 68 >> 2] = t + z, E[C + 64 >> 2] = p + R, E[C + 60 >> 2] = _ + P, E[C + 56 >> 2] = S + x, E[C + 52 >> 2] = N + u, E[C + 48 >> 2] = F + O, g = wA - 1 | 0, Y(X, C + 288 | 0, G), Y(G, C, J), wA;);
                                                D = E[C + 144 >> 2], F = E[C + 240 >> 2], s = E[C + 148 >> 2], N = E[C + 244 >> 2], y = E[C + 152 >> 2], f = E[C + 248 >> 2], e = E[C + 156 >> 2], S = E[C + 252 >> 2], _ = E[C + 160 >> 2], n = E[C + 256 >> 2], t = E[C + 164 >> 2], k = E[C + 260 >> 2], Q = E[C + 168 >> 2], p = E[C + 264 >> 2], B = E[C + 172 >> 2], c = E[C + 268 >> 2], g = E[C + 176 >> 2], i = E[C + 272 >> 2], r = 0 - Z | 0, I = E[C + 276 >> 2], E[C + 276 >> 2] = r & (I ^ E[C + 180 >> 2]) ^ I, E[C + 272 >> 2] = i ^ r & (g ^ i), E[C + 268 >> 2] = c ^ r & (B ^ c), E[C + 264 >> 2] = p ^ r & (Q ^ p), E[C + 260 >> 2] = k ^ r & (t ^ k), E[C + 256 >> 2] = n ^ r & (_ ^ n), E[C + 252 >> 2] = S ^ r & (e ^ S), E[C + 248 >> 2] = f ^ r & (y ^ f), E[C + 244 >> 2] = N ^ r & (s ^ N), E[C + 240 >> 2] = F ^ r & (D ^ F), F = E[C + 192 >> 2], D = E[C + 96 >> 2], N = E[C + 196 >> 2], s = E[C + 100 >> 2], f = E[C + 200 >> 2], y = E[C + 104 >> 2], S = E[C + 204 >> 2], e = E[C + 108 >> 2], n = E[C + 208 >> 2], _ = E[C + 112 >> 2], k = E[C + 212 >> 2], t = E[C + 116 >> 2], p = E[C + 216 >> 2], Q = E[C + 120 >> 2], c = E[C + 220 >> 2], B = E[C + 124 >> 2], i = E[C + 224 >> 2], g = E[C + 128 >> 2], I = E[C + 228 >> 2], E[C + 228 >> 2] = r & (I ^ E[C + 132 >> 2]) ^ I, E[C + 224 >> 2] = i ^ r & (g ^ i), E[C + 220 >> 2] = c ^ r & (B ^ c), E[C + 216 >> 2] = p ^ r & (Q ^ p), E[C + 212 >> 2] = k ^ r & (t ^ k), E[C + 208 >> 2] = n ^ r & (_ ^ n), E[C + 204 >> 2] = S ^ r & (e ^ S), E[C + 200 >> 2] = f ^ r & (y ^ f), E[C + 196 >> 2] = N ^ r & (s ^ N), E[C + 192 >> 2] = F ^ r & (D ^ F), vA(G, G), Y(b, b, G), BI(A, b), XC(fA, 32), B = 0;
                                            }
                                            return h = C + 368 | 0, 0 | B;
                                        },
                                        function(A, I) {
                                            var g, C, B, Q, i, _, c, t, r, e, y, s, D, p, w, f, n, k, F, N;
                                            return I |= 0, h = g = h - 304 | 0, o[0 | (A |= 0)] = a[0 | I], o[A + 1 | 0] = a[I + 1 | 0], o[A + 2 | 0] = a[I + 2 | 0], o[A + 3 | 0] = a[I + 3 | 0], o[A + 4 | 0] = a[I + 4 | 0], o[A + 5 | 0] = a[I + 5 | 0], o[A + 6 | 0] = a[I + 6 | 0], o[A + 7 | 0] = a[I + 7 | 0], o[A + 8 | 0] = a[I + 8 | 0], o[A + 9 | 0] = a[I + 9 | 0], o[A + 10 | 0] = a[I + 10 | 0], o[A + 11 | 0] = a[I + 11 | 0], o[A + 12 | 0] = a[I + 12 | 0], o[A + 13 | 0] = a[I + 13 | 0], o[A + 14 | 0] = a[I + 14 | 0], o[A + 15 | 0] = a[I + 15 | 0], o[A + 16 | 0] = a[I + 16 | 0], o[A + 17 | 0] = a[I + 17 | 0], o[A + 18 | 0] = a[I + 18 | 0], o[A + 19 | 0] = a[I + 19 | 0], o[A + 20 | 0] = a[I + 20 | 0], o[A + 21 | 0] = a[I + 21 | 0], o[A + 22 | 0] = a[I + 22 | 0], o[A + 23 | 0] = a[I + 23 | 0], o[A + 24 | 0] = a[I + 24 | 0], o[A + 25 | 0] = a[I + 25 | 0], o[A + 26 | 0] = a[I + 26 | 0], o[A + 27 | 0] = a[I + 27 | 0], o[A + 28 | 0] = a[I + 28 | 0], o[A + 29 | 0] = a[I + 29 | 0], o[A + 30 | 0] = a[I + 30 | 0], I = a[I + 31 | 0], o[0 | A] = 248 & a[0 | A], o[A + 31 | 0] = 63 & I | 64, kA(g + 48 | 0, A), I = E[g + 132 >> 2], C = E[g + 92 >> 2], B = E[g + 136 >> 2], Q = E[g + 96 >> 2], i = E[g + 140 >> 2], _ = E[g + 100 >> 2], c = E[g + 144 >> 2], t = E[g + 104 >> 2], r = E[g + 148 >> 2], e = E[g + 108 >> 2], y = E[g + 152 >> 2], s = E[g + 112 >> 2], D = E[g + 156 >> 2], p = E[g + 116 >> 2], w = E[g + 160 >> 2], f = E[g + 120 >> 2], n = E[g + 128 >> 2], k = E[g + 88 >> 2], F = E[g + 124 >> 2], N = E[g + 164 >> 2], E[g + 292 >> 2] = F + N, E[g + 288 >> 2] = w + f, E[g + 284 >> 2] = D + p, E[g + 280 >> 2] = y + s, E[g + 276 >> 2] = r + e, E[g + 272 >> 2] = c + t, E[g + 268 >> 2] = i + _, E[g + 264 >> 2] = B + Q, E[g + 260 >> 2] = I + C, E[g + 256 >> 2] = n + k, E[g + 244 >> 2] = N - F, E[g + 240 >> 2] = w - f, E[g + 236 >> 2] = D - p, E[g + 232 >> 2] = y - s, E[g + 228 >> 2] = r - e, E[g + 224 >> 2] = c - t, E[g + 220 >> 2] = i - _, E[g + 216 >> 2] = B - Q, E[g + 212 >> 2] = I - C, E[g + 208 >> 2] = n - k, vA(I = g + 208 | 0, I), Y(g, g + 256 | 0, I), BI(A, g), h = g + 304 | 0, 0;
                                        },
                                        function(A, I, g, C, B) {
                                            A |= 0, C |= 0, B |= 0;
                                            var Q, i = 0, _ = 0, c = 0, t = 0;
                                            if (h = Q = h - 112 | 0, (I |= 0) | (g |= 0)) {
                                                i = a[B + 28 | 0] | a[B + 29 | 0] << 8 | a[B + 30 | 0] << 16 | a[B + 31 | 0] << 24, E[Q + 24 >> 2] = a[B + 24 | 0] | a[B + 25 | 0] << 8 | a[B + 26 | 0] << 16 | a[B + 27 | 0] << 24, E[Q + 28 >> 2] = i, i = a[B + 20 | 0] | a[B + 21 | 0] << 8 | a[B + 22 | 0] << 16 | a[B + 23 | 0] << 24, E[Q + 16 >> 2] = a[B + 16 | 0] | a[B + 17 | 0] << 8 | a[B + 18 | 0] << 16 | a[B + 19 | 0] << 24, E[Q + 20 >> 2] = i, i = a[B + 4 | 0] | a[B + 5 | 0] << 8 | a[B + 6 | 0] << 16 | a[B + 7 | 0] << 24, E[Q >> 2] = a[0 | B] | a[B + 1 | 0] << 8 | a[B + 2 | 0] << 16 | a[B + 3 | 0] << 24, E[Q + 4 >> 2] = i, i = a[B + 12 | 0] | a[B + 13 | 0] << 8 | a[B + 14 | 0] << 16 | a[B + 15 | 0] << 24, E[Q + 8 >> 2] = a[B + 8 | 0] | a[B + 9 | 0] << 8 | a[B + 10 | 0] << 16 | a[B + 11 | 0] << 24, E[Q + 12 >> 2] = i, B = a[0 | C] | a[C + 1 | 0] << 8 | a[C + 2 | 0] << 16 | a[C + 3 | 0] << 24, C = a[C + 4 | 0] | a[C + 5 | 0] << 8 | a[C + 6 | 0] << 16 | a[C + 7 | 0] << 24, E[Q + 104 >> 2] = 0, E[Q + 108 >> 2] = 0, E[Q + 96 >> 2] = B, E[Q + 100 >> 2] = C;
                                                A: {
                                                    if (!g & I >>> 0 >= 64 | g) {
                                                        for(; AC(A, Q + 96 | 0, Q, 0), C = a[Q + 104 | 0] + 1 | 0, o[Q + 104 | 0] = C, C = a[Q + 105 | 0] + (C >>> 8 | 0) | 0, o[Q + 105 | 0] = C, C = a[Q + 106 | 0] + (C >>> 8 | 0) | 0, o[Q + 106 | 0] = C, C = a[Q + 107 | 0] + (C >>> 8 | 0) | 0, o[Q + 107 | 0] = C, C = a[Q + 108 | 0] + (C >>> 8 | 0) | 0, o[Q + 108 | 0] = C, C = a[Q + 109 | 0] + (C >>> 8 | 0) | 0, o[Q + 109 | 0] = C, C = a[Q + 110 | 0] + (C >>> 8 | 0) | 0, o[Q + 110 | 0] = C, o[Q + 111 | 0] = a[Q + 111 | 0] + (C >>> 8 | 0), A = A - -64 | 0, g = g - 1 | 0, !(g = (I = I + -64 | 0) >>> 0 < 4294967232 ? g + 1 | 0 : g) & I >>> 0 > 63 | g;);
                                                        if (!(I | g)) break A;
                                                    }
                                                    if (C = 0, AC(Q + 32 | 0, Q + 96 | 0, Q, 0), g = 3 & I, B = 0, I - 1 >>> 0 >= 3) for(i = -4 & I, I = 0; _ = c = Q + 32 | 0, o[A + B | 0] = a[_ + B | 0], o[(t = 1 | B) + A | 0] = a[_ + t | 0], o[(_ = 2 | B) + A | 0] = a[_ + c | 0], o[(_ = 3 | B) + A | 0] = a[_ + (Q + 32 | 0) | 0], B = B + 4 | 0, (0 | i) != (0 | (I = I + 4 | 0)););
                                                    if (g) for(; o[A + B | 0] = a[(Q + 32 | 0) + B | 0], B = B + 1 | 0, (0 | g) != (0 | (C = C + 1 | 0)););
                                                }
                                                XC(Q + 32 | 0, 64), XC(Q, 32);
                                            }
                                            return h = Q + 112 | 0, 0;
                                        },
                                        function(A, I, g, C, B, Q, i, _) {
                                            A |= 0, I |= 0, B |= 0, Q |= 0, i |= 0, _ |= 0;
                                            var c, t = 0;
                                            if (h = c = h - 112 | 0, (g |= 0) | (C |= 0)) {
                                                t = a[_ + 28 | 0] | a[_ + 29 | 0] << 8 | a[_ + 30 | 0] << 16 | a[_ + 31 | 0] << 24, E[c + 24 >> 2] = a[_ + 24 | 0] | a[_ + 25 | 0] << 8 | a[_ + 26 | 0] << 16 | a[_ + 27 | 0] << 24, E[c + 28 >> 2] = t, t = a[_ + 20 | 0] | a[_ + 21 | 0] << 8 | a[_ + 22 | 0] << 16 | a[_ + 23 | 0] << 24, E[c + 16 >> 2] = a[_ + 16 | 0] | a[_ + 17 | 0] << 8 | a[_ + 18 | 0] << 16 | a[_ + 19 | 0] << 24, E[c + 20 >> 2] = t, t = a[_ + 4 | 0] | a[_ + 5 | 0] << 8 | a[_ + 6 | 0] << 16 | a[_ + 7 | 0] << 24, E[c >> 2] = a[0 | _] | a[_ + 1 | 0] << 8 | a[_ + 2 | 0] << 16 | a[_ + 3 | 0] << 24, E[c + 4 >> 2] = t, t = a[_ + 12 | 0] | a[_ + 13 | 0] << 8 | a[_ + 14 | 0] << 16 | a[_ + 15 | 0] << 24, E[c + 8 >> 2] = a[_ + 8 | 0] | a[_ + 9 | 0] << 8 | a[_ + 10 | 0] << 16 | a[_ + 11 | 0] << 24, E[c + 12 >> 2] = t, _ = a[B + 4 | 0] | a[B + 5 | 0] << 8 | a[B + 6 | 0] << 16 | a[B + 7 | 0] << 24, E[c + 96 >> 2] = a[0 | B] | a[B + 1 | 0] << 8 | a[B + 2 | 0] << 16 | a[B + 3 | 0] << 24, E[c + 100 >> 2] = _, o[c + 104 | 0] = Q, o[c + 111 | 0] = i >>> 24, o[c + 110 | 0] = i >>> 16, o[c + 109 | 0] = i >>> 8, o[c + 108 | 0] = i, o[c + 107 | 0] = (16777215 & i) << 8 | Q >>> 24, o[c + 106 | 0] = (65535 & i) << 16 | Q >>> 16, o[c + 105 | 0] = (255 & i) << 24 | Q >>> 8;
                                                A: {
                                                    if (!C & g >>> 0 >= 64 | C) {
                                                        for(;;){
                                                            for(_ = 0, AC(c + 32 | 0, c + 96 | 0, c, 0); Q = c + 32 | 0, o[A + _ | 0] = a[Q + _ | 0] ^ a[I + _ | 0], o[(B = 1 | _) + A | 0] = a[B + Q | 0] ^ a[I + B | 0], 64 != (0 | (_ = _ + 2 | 0)););
                                                            if (B = a[c + 104 | 0] + 1 | 0, o[c + 104 | 0] = B, B = a[c + 105 | 0] + (B >>> 8 | 0) | 0, o[c + 105 | 0] = B, B = a[c + 106 | 0] + (B >>> 8 | 0) | 0, o[c + 106 | 0] = B, B = a[c + 107 | 0] + (B >>> 8 | 0) | 0, o[c + 107 | 0] = B, B = a[c + 108 | 0] + (B >>> 8 | 0) | 0, o[c + 108 | 0] = B, B = a[c + 109 | 0] + (B >>> 8 | 0) | 0, o[c + 109 | 0] = B, B = a[c + 110 | 0] + (B >>> 8 | 0) | 0, o[c + 110 | 0] = B, o[c + 111 | 0] = a[c + 111 | 0] + (B >>> 8 | 0), I = I - -64 | 0, A = A - -64 | 0, C = C - 1 | 0, !(!(C = (g = g + -64 | 0) >>> 0 < 4294967232 ? C + 1 | 0 : C) & g >>> 0 > 63 | C)) break;
                                                        }
                                                        if (!(g | C)) break A;
                                                    }
                                                    if (_ = 0, AC(c + 32 | 0, c + 96 | 0, c, 0), C = 1 & g, 1 != (0 | g)) for(Q = -2 & g, B = 0; i = c + 32 | 0, o[A + _ | 0] = a[i + _ | 0] ^ a[I + _ | 0], o[(g = 1 | _) + A | 0] = a[g + i | 0] ^ a[I + g | 0], _ = _ + 2 | 0, (0 | Q) != (0 | (B = B + 2 | 0)););
                                                    C && (o[A + _ | 0] = a[(c + 32 | 0) + _ | 0] ^ a[I + _ | 0]);
                                                }
                                                XC(c + 32 | 0, 64), XC(c, 32);
                                            }
                                            return h = c + 112 | 0, 0;
                                        },
                                        function(A, I, g, C, B, Q, i, o, E) {
                                            A |= 0, I |= 0, g |= 0, C |= 0, B |= 0, Q |= 0, i |= 0;
                                            var a, _, c = 0;
                                            if (_ = c = h, h = a = c - 192 & -32, P(E |= 0, o |= 0, a - -64 | 0), E = 32, c = 0, i >>> 0 < 32) o = 0;
                                            else for(; V(Q + c | 0, a - -64 | 0), o = E, c = E, (E = E + 32 | 0) >>> 0 <= i >>> 0;);
                                            if ((E = 31 & i) && (Hg((c = a + 32 | 0) | E, 0, 32 - E | 0), Sg(c, Q + o | 0, E), V(c, a - -64 | 0)), c = 32, o = 0, B >>> 0 < 32) E = 0;
                                            else for(; l(A + o | 0, C + o | 0, a - -64 | 0), o = E = c, (c = E + 32 | 0) >>> 0 <= B >>> 0;);
                                            return (Q = 31 & B) && (Hg((o = a + 32 | 0) | Q, 0, 32 - Q | 0), Sg(o, C + E | 0, Q), l(a, o, a - -64 | 0), Sg(A + E | 0, a, Q)), d(I, g, i, B, a - -64 | 0), h = _, 0;
                                        },
                                        function(A, I, g, C, B, Q, i, o, E) {
                                            A |= 0, I |= 0, g |= 0, C |= 0, B |= 0, Q |= 0, i |= 0;
                                            var a, _, c = 0;
                                            if (_ = c = h, h = a = c - 224 & -32, P(E |= 0, o |= 0, a + 96 | 0), E = 32, c = 0, i >>> 0 < 32) o = 0;
                                            else for(; V(Q + c | 0, a + 96 | 0), o = E, c = E, (E = E + 32 | 0) >>> 0 <= i >>> 0;);
                                            (E = 31 & i) && (Hg((c = a - -64 | 0) | E, 0, 32 - E | 0), Sg(c, Q + o | 0, E), V(c, a + 96 | 0));
                                            A: {
                                                I: {
                                                    g: {
                                                        C: {
                                                            B: {
                                                                if (A) {
                                                                    if (c = 32, g >>> 0 < 32) break B;
                                                                    for(E = 0; U(A + E | 0, I + E | 0, a + 96 | 0), o = c, (c = (E = c) + 32 | 0) >>> 0 <= g >>> 0;);
                                                                } else {
                                                                    if (E = 32, g >>> 0 < 32) break g;
                                                                    for(c = 0; U(a + 32 | 0, I + c | 0, a + 96 | 0), o = E, c = E, (E = E + 32 | 0) >>> 0 <= g >>> 0;);
                                                                }
                                                                if (!(E = 31 & g)) break A;
                                                                if (A) break C;
                                                                break I;
                                                            }
                                                            if (o = 0, !(E = g)) break A;
                                                        }
                                                        x(A + o | 0, I + o | 0, E, a + 96 | 0);
                                                        break A;
                                                    }
                                                    if (o = 0, !(E = g)) break A;
                                                }
                                                x(a + 32 | 0, I + o | 0, E, a + 96 | 0);
                                            }
                                            d(a, B, i, g, a + 96 | 0), o = -1;
                                            A: {
                                                I: {
                                                    if (I = B - 16 | 0) {
                                                        if (16 == (0 | I)) break I;
                                                        break A;
                                                    }
                                                    o = iI(a, C);
                                                    break A;
                                                }
                                                o = SC(a, C);
                                            }
                                            return !A | !o || Hg(A, 0, g), h = _, 0 | o;
                                        },
                                        function(A, I, g, C, B, Q, i, o, _) {
                                            A |= 0, I |= 0, g |= 0, C |= 0, B |= 0, Q |= 0, i |= 0;
                                            var c, t = 0, r = 0, e = 0, y = 0, s = 0, D = 0, p = 0, w = 0, f = 0, n = 0;
                                            if (h = c = h - 528 | 0, M(_ |= 0, o |= 0, c + 400 | 0), o = 0, i >>> 0 >= 16) for(r = c + 416 | 0, y = c + 432 | 0, s = c + 448 | 0, e = c + 464 | 0, D = c + 480 | 0, _ = 16; p = a[0 | (o = Q + o | 0)] | a[o + 1 | 0] << 8 | a[o + 2 | 0] << 16 | a[o + 3 | 0] << 24, w = a[o + 4 | 0] | a[o + 5 | 0] << 8 | a[o + 6 | 0] << 16 | a[o + 7 | 0] << 24, f = a[o + 8 | 0] | a[o + 9 | 0] << 8 | a[o + 10 | 0] << 16 | a[o + 11 | 0] << 24, n = a[o + 12 | 0] | a[o + 13 | 0] << 8 | a[o + 14 | 0] << 16 | a[o + 15 | 0] << 24, o = E[D + 12 >> 2], E[c + 520 >> 2] = E[D + 8 >> 2], E[c + 524 >> 2] = o, o = E[D + 4 >> 2], E[c + 512 >> 2] = E[D >> 2], E[c + 516 >> 2] = o, o = E[e + 12 >> 2], E[c + 376 >> 2] = E[e + 8 >> 2], E[c + 380 >> 2] = o, o = E[e + 4 >> 2], E[c + 368 >> 2] = E[e >> 2], E[c + 372 >> 2] = o, o = E[D + 12 >> 2], E[c + 360 >> 2] = E[D + 8 >> 2], E[c + 364 >> 2] = o, o = E[D + 4 >> 2], E[c + 352 >> 2] = E[D >> 2], E[c + 356 >> 2] = o, $A(o = c + 496 | 0, c + 368 | 0, c + 352 | 0), t = E[c + 508 >> 2], E[D + 8 >> 2] = E[c + 504 >> 2], E[D + 12 >> 2] = t, t = E[c + 500 >> 2], E[D >> 2] = E[c + 496 >> 2], E[D + 4 >> 2] = t, t = E[s + 12 >> 2], E[c + 344 >> 2] = E[s + 8 >> 2], E[c + 348 >> 2] = t, t = E[s + 4 >> 2], E[c + 336 >> 2] = E[s >> 2], E[c + 340 >> 2] = t, t = E[e + 12 >> 2], E[c + 328 >> 2] = E[e + 8 >> 2], E[c + 332 >> 2] = t, t = E[e + 4 >> 2], E[c + 320 >> 2] = E[e >> 2], E[c + 324 >> 2] = t, $A(o, c + 336 | 0, c + 320 | 0), t = E[c + 508 >> 2], E[e + 8 >> 2] = E[c + 504 >> 2], E[e + 12 >> 2] = t, t = E[c + 500 >> 2], E[e >> 2] = E[c + 496 >> 2], E[e + 4 >> 2] = t, t = E[y + 12 >> 2], E[c + 312 >> 2] = E[y + 8 >> 2], E[c + 316 >> 2] = t, t = E[y + 4 >> 2], E[c + 304 >> 2] = E[y >> 2], E[c + 308 >> 2] = t, t = E[s + 12 >> 2], E[c + 296 >> 2] = E[s + 8 >> 2], E[c + 300 >> 2] = t, t = E[s + 4 >> 2], E[c + 288 >> 2] = E[s >> 2], E[c + 292 >> 2] = t, $A(o, c + 304 | 0, c + 288 | 0), t = E[c + 508 >> 2], E[s + 8 >> 2] = E[c + 504 >> 2], E[s + 12 >> 2] = t, t = E[c + 500 >> 2], E[s >> 2] = E[c + 496 >> 2], E[s + 4 >> 2] = t, t = E[r + 12 >> 2], E[c + 280 >> 2] = E[r + 8 >> 2], E[c + 284 >> 2] = t, t = E[r + 4 >> 2], E[c + 272 >> 2] = E[r >> 2], E[c + 276 >> 2] = t, t = E[y + 12 >> 2], E[c + 264 >> 2] = E[y + 8 >> 2], E[c + 268 >> 2] = t, t = E[y + 4 >> 2], E[c + 256 >> 2] = E[y >> 2], E[c + 260 >> 2] = t, $A(o, c + 272 | 0, c + 256 | 0), t = E[c + 508 >> 2], E[y + 8 >> 2] = E[c + 504 >> 2], E[y + 12 >> 2] = t, t = E[c + 500 >> 2], E[y >> 2] = E[c + 496 >> 2], E[y + 4 >> 2] = t, t = E[c + 412 >> 2], E[c + 248 >> 2] = E[c + 408 >> 2], E[c + 252 >> 2] = t, t = E[c + 404 >> 2], E[c + 240 >> 2] = E[c + 400 >> 2], E[c + 244 >> 2] = t, t = E[r + 12 >> 2], E[c + 232 >> 2] = E[r + 8 >> 2], E[c + 236 >> 2] = t, t = E[r + 4 >> 2], E[c + 224 >> 2] = E[r >> 2], E[c + 228 >> 2] = t, $A(o, c + 240 | 0, c + 224 | 0), t = E[c + 508 >> 2], E[r + 8 >> 2] = E[c + 504 >> 2], E[r + 12 >> 2] = t, t = E[c + 500 >> 2], E[r >> 2] = E[c + 496 >> 2], E[r + 4 >> 2] = t, t = E[c + 524 >> 2], E[c + 216 >> 2] = E[c + 520 >> 2], E[c + 220 >> 2] = t, t = E[c + 412 >> 2], E[c + 200 >> 2] = E[c + 408 >> 2], E[c + 204 >> 2] = t, t = E[c + 516 >> 2], E[c + 208 >> 2] = E[c + 512 >> 2], E[c + 212 >> 2] = t, t = E[c + 404 >> 2], E[c + 192 >> 2] = E[c + 400 >> 2], E[c + 196 >> 2] = t, $A(o, c + 208 | 0, c + 192 | 0), E[c + 412 >> 2] = n ^ E[c + 508 >> 2], E[c + 408 >> 2] = E[c + 504 >> 2] ^ f, E[c + 404 >> 2] = E[c + 500 >> 2] ^ w, E[c + 400 >> 2] = E[c + 496 >> 2] ^ p, (_ = (o = _) + 16 | 0) >>> 0 <= i >>> 0;);
                                            if ((_ = 15 & i) && (Hg((r = c + 384 | 0) | _, 0, 16 - _ | 0), Sg(r, Q + o | 0, _), _ = E[c + 384 >> 2], r = E[c + 388 >> 2], y = E[c + 392 >> 2], s = E[c + 396 >> 2], o = E[c + 492 >> 2], Q = E[c + 488 >> 2], E[c + 520 >> 2] = Q, E[c + 524 >> 2] = o, e = E[c + 476 >> 2], E[c + 184 >> 2] = E[c + 472 >> 2], E[c + 188 >> 2] = e, E[c + 168 >> 2] = Q, E[c + 172 >> 2] = o, o = E[c + 484 >> 2], Q = E[c + 480 >> 2], E[c + 512 >> 2] = Q, E[c + 516 >> 2] = o, e = E[c + 468 >> 2], E[c + 176 >> 2] = E[c + 464 >> 2], E[c + 180 >> 2] = e, E[c + 160 >> 2] = Q, E[c + 164 >> 2] = o, $A(Q = c + 496 | 0, c + 176 | 0, c + 160 | 0), o = E[c + 508 >> 2], E[c + 488 >> 2] = E[c + 504 >> 2], E[c + 492 >> 2] = o, o = E[c + 460 >> 2], E[c + 152 >> 2] = E[c + 456 >> 2], E[c + 156 >> 2] = o, o = E[c + 476 >> 2], E[c + 136 >> 2] = E[c + 472 >> 2], E[c + 140 >> 2] = o, o = E[c + 500 >> 2], E[c + 480 >> 2] = E[c + 496 >> 2], E[c + 484 >> 2] = o, o = E[c + 452 >> 2], E[c + 144 >> 2] = E[c + 448 >> 2], E[c + 148 >> 2] = o, o = E[c + 468 >> 2], E[c + 128 >> 2] = E[c + 464 >> 2], E[c + 132 >> 2] = o, $A(Q, c + 144 | 0, c + 128 | 0), o = E[c + 508 >> 2], E[c + 472 >> 2] = E[c + 504 >> 2], E[c + 476 >> 2] = o, o = E[c + 444 >> 2], E[c + 120 >> 2] = E[c + 440 >> 2], E[c + 124 >> 2] = o, o = E[c + 460 >> 2], E[c + 104 >> 2] = E[c + 456 >> 2], E[c + 108 >> 2] = o, o = E[c + 500 >> 2], E[c + 464 >> 2] = E[c + 496 >> 2], E[c + 468 >> 2] = o, o = E[c + 436 >> 2], E[c + 112 >> 2] = E[c + 432 >> 2], E[c + 116 >> 2] = o, o = E[c + 452 >> 2], E[c + 96 >> 2] = E[c + 448 >> 2], E[c + 100 >> 2] = o, $A(Q, c + 112 | 0, c + 96 | 0), o = E[c + 508 >> 2], E[c + 456 >> 2] = E[c + 504 >> 2], E[c + 460 >> 2] = o, o = E[c + 428 >> 2], E[c + 88 >> 2] = E[c + 424 >> 2], E[c + 92 >> 2] = o, o = E[c + 444 >> 2], E[c + 72 >> 2] = E[c + 440 >> 2], E[c + 76 >> 2] = o, o = E[c + 500 >> 2], E[c + 448 >> 2] = E[c + 496 >> 2], E[c + 452 >> 2] = o, o = E[c + 420 >> 2], E[c + 80 >> 2] = E[c + 416 >> 2], E[c + 84 >> 2] = o, o = E[c + 436 >> 2], E[c + 64 >> 2] = E[c + 432 >> 2], E[c + 68 >> 2] = o, $A(Q, c + 80 | 0, c - -64 | 0), o = E[c + 508 >> 2], E[c + 440 >> 2] = E[c + 504 >> 2], E[c + 444 >> 2] = o, o = E[c + 412 >> 2], E[c + 56 >> 2] = E[c + 408 >> 2], E[c + 60 >> 2] = o, o = E[c + 428 >> 2], E[c + 40 >> 2] = E[c + 424 >> 2], E[c + 44 >> 2] = o, o = E[c + 500 >> 2], E[c + 432 >> 2] = E[c + 496 >> 2], E[c + 436 >> 2] = o, o = E[c + 404 >> 2], E[c + 48 >> 2] = E[c + 400 >> 2], E[c + 52 >> 2] = o, o = E[c + 420 >> 2], E[c + 32 >> 2] = E[c + 416 >> 2], E[c + 36 >> 2] = o, $A(Q, c + 48 | 0, c + 32 | 0), o = E[c + 508 >> 2], E[c + 424 >> 2] = E[c + 504 >> 2], E[c + 428 >> 2] = o, o = E[c + 524 >> 2], E[c + 24 >> 2] = E[c + 520 >> 2], E[c + 28 >> 2] = o, o = E[c + 412 >> 2], E[c + 8 >> 2] = E[c + 408 >> 2], E[c + 12 >> 2] = o, o = E[c + 500 >> 2], E[c + 416 >> 2] = E[c + 496 >> 2], E[c + 420 >> 2] = o, o = E[c + 516 >> 2], E[c + 16 >> 2] = E[c + 512 >> 2], E[c + 20 >> 2] = o, o = E[c + 404 >> 2], E[c >> 2] = E[c + 400 >> 2], E[c + 4 >> 2] = o, $A(Q, c + 16 | 0, c), E[c + 412 >> 2] = s ^ E[c + 508 >> 2], E[c + 408 >> 2] = y ^ E[c + 504 >> 2], E[c + 404 >> 2] = r ^ E[c + 500 >> 2], E[c + 400 >> 2] = _ ^ E[c + 496 >> 2]), Q = 16, o = 0, B >>> 0 < 16) _ = 0;
                                            else for(; j(A + o | 0, C + o | 0, c + 400 | 0), _ = Q, (Q = (o = Q) + 16 | 0) >>> 0 <= B >>> 0;);
                                            return (Q = 15 & B) && (Hg((o = c + 384 | 0) | Q, 0, 16 - Q | 0), Sg(o, C + _ | 0, Q), j(C = c + 512 | 0, o, c + 400 | 0), Sg(A + _ | 0, C, Q)), m(I, g, i, B, c + 400 | 0), h = c + 528 | 0, 0;
                                        },
                                        function(A, I, g, C, B, Q, i, o, _) {
                                            A |= 0, I |= 0, g |= 0, C |= 0, B |= 0, Q |= 0, i |= 0;
                                            var c, t = 0, r = 0, e = 0, y = 0, s = 0, D = 0, p = 0, w = 0, f = 0, n = 0;
                                            if (h = c = h - 544 | 0, M(_ |= 0, o |= 0, c + 432 | 0), o = 0, i >>> 0 >= 16) for(r = c + 448 | 0, y = c + 464 | 0, s = c + 480 | 0, e = c + 496 | 0, D = c + 512 | 0, _ = 16; p = a[0 | (o = Q + o | 0)] | a[o + 1 | 0] << 8 | a[o + 2 | 0] << 16 | a[o + 3 | 0] << 24, w = a[o + 4 | 0] | a[o + 5 | 0] << 8 | a[o + 6 | 0] << 16 | a[o + 7 | 0] << 24, f = a[o + 8 | 0] | a[o + 9 | 0] << 8 | a[o + 10 | 0] << 16 | a[o + 11 | 0] << 24, n = a[o + 12 | 0] | a[o + 13 | 0] << 8 | a[o + 14 | 0] << 16 | a[o + 15 | 0] << 24, o = E[D + 12 >> 2], E[c + 392 >> 2] = E[D + 8 >> 2], E[c + 396 >> 2] = o, o = E[D + 4 >> 2], E[c + 384 >> 2] = E[D >> 2], E[c + 388 >> 2] = o, o = E[e + 12 >> 2], E[c + 376 >> 2] = E[e + 8 >> 2], E[c + 380 >> 2] = o, o = E[e + 4 >> 2], E[c + 368 >> 2] = E[e >> 2], E[c + 372 >> 2] = o, o = E[D + 12 >> 2], E[c + 360 >> 2] = E[D + 8 >> 2], E[c + 364 >> 2] = o, o = E[D + 4 >> 2], E[c + 352 >> 2] = E[D >> 2], E[c + 356 >> 2] = o, $A(o = c + 528 | 0, c + 368 | 0, c + 352 | 0), t = E[c + 540 >> 2], E[D + 8 >> 2] = E[c + 536 >> 2], E[D + 12 >> 2] = t, t = E[c + 532 >> 2], E[D >> 2] = E[c + 528 >> 2], E[D + 4 >> 2] = t, t = E[s + 12 >> 2], E[c + 344 >> 2] = E[s + 8 >> 2], E[c + 348 >> 2] = t, t = E[s + 4 >> 2], E[c + 336 >> 2] = E[s >> 2], E[c + 340 >> 2] = t, t = E[e + 12 >> 2], E[c + 328 >> 2] = E[e + 8 >> 2], E[c + 332 >> 2] = t, t = E[e + 4 >> 2], E[c + 320 >> 2] = E[e >> 2], E[c + 324 >> 2] = t, $A(o, c + 336 | 0, c + 320 | 0), t = E[c + 540 >> 2], E[e + 8 >> 2] = E[c + 536 >> 2], E[e + 12 >> 2] = t, t = E[c + 532 >> 2], E[e >> 2] = E[c + 528 >> 2], E[e + 4 >> 2] = t, t = E[y + 12 >> 2], E[c + 312 >> 2] = E[y + 8 >> 2], E[c + 316 >> 2] = t, t = E[y + 4 >> 2], E[c + 304 >> 2] = E[y >> 2], E[c + 308 >> 2] = t, t = E[s + 12 >> 2], E[c + 296 >> 2] = E[s + 8 >> 2], E[c + 300 >> 2] = t, t = E[s + 4 >> 2], E[c + 288 >> 2] = E[s >> 2], E[c + 292 >> 2] = t, $A(o, c + 304 | 0, c + 288 | 0), t = E[c + 540 >> 2], E[s + 8 >> 2] = E[c + 536 >> 2], E[s + 12 >> 2] = t, t = E[c + 532 >> 2], E[s >> 2] = E[c + 528 >> 2], E[s + 4 >> 2] = t, t = E[r + 12 >> 2], E[c + 280 >> 2] = E[r + 8 >> 2], E[c + 284 >> 2] = t, t = E[r + 4 >> 2], E[c + 272 >> 2] = E[r >> 2], E[c + 276 >> 2] = t, t = E[y + 12 >> 2], E[c + 264 >> 2] = E[y + 8 >> 2], E[c + 268 >> 2] = t, t = E[y + 4 >> 2], E[c + 256 >> 2] = E[y >> 2], E[c + 260 >> 2] = t, $A(o, c + 272 | 0, c + 256 | 0), t = E[c + 540 >> 2], E[y + 8 >> 2] = E[c + 536 >> 2], E[y + 12 >> 2] = t, t = E[c + 532 >> 2], E[y >> 2] = E[c + 528 >> 2], E[y + 4 >> 2] = t, t = E[c + 444 >> 2], E[c + 248 >> 2] = E[c + 440 >> 2], E[c + 252 >> 2] = t, t = E[c + 436 >> 2], E[c + 240 >> 2] = E[c + 432 >> 2], E[c + 244 >> 2] = t, t = E[r + 12 >> 2], E[c + 232 >> 2] = E[r + 8 >> 2], E[c + 236 >> 2] = t, t = E[r + 4 >> 2], E[c + 224 >> 2] = E[r >> 2], E[c + 228 >> 2] = t, $A(o, c + 240 | 0, c + 224 | 0), t = E[c + 540 >> 2], E[r + 8 >> 2] = E[c + 536 >> 2], E[r + 12 >> 2] = t, t = E[c + 532 >> 2], E[r >> 2] = E[c + 528 >> 2], E[r + 4 >> 2] = t, t = E[c + 396 >> 2], E[c + 216 >> 2] = E[c + 392 >> 2], E[c + 220 >> 2] = t, t = E[c + 444 >> 2], E[c + 200 >> 2] = E[c + 440 >> 2], E[c + 204 >> 2] = t, t = E[c + 388 >> 2], E[c + 208 >> 2] = E[c + 384 >> 2], E[c + 212 >> 2] = t, t = E[c + 436 >> 2], E[c + 192 >> 2] = E[c + 432 >> 2], E[c + 196 >> 2] = t, $A(o, c + 208 | 0, c + 192 | 0), E[c + 444 >> 2] = n ^ E[c + 540 >> 2], E[c + 440 >> 2] = E[c + 536 >> 2] ^ f, E[c + 436 >> 2] = E[c + 532 >> 2] ^ w, E[c + 432 >> 2] = E[c + 528 >> 2] ^ p, (_ = (o = _) + 16 | 0) >>> 0 <= i >>> 0;);
                                            (_ = 15 & i) && (Hg((r = c + 416 | 0) | _, 0, 16 - _ | 0), Sg(r, Q + o | 0, _), _ = E[c + 416 >> 2], r = E[c + 420 >> 2], y = E[c + 424 >> 2], s = E[c + 428 >> 2], o = E[c + 524 >> 2], Q = E[c + 520 >> 2], E[c + 392 >> 2] = Q, E[c + 396 >> 2] = o, e = E[c + 508 >> 2], E[c + 184 >> 2] = E[c + 504 >> 2], E[c + 188 >> 2] = e, E[c + 168 >> 2] = Q, E[c + 172 >> 2] = o, o = E[c + 516 >> 2], Q = E[c + 512 >> 2], E[c + 384 >> 2] = Q, E[c + 388 >> 2] = o, e = E[c + 500 >> 2], E[c + 176 >> 2] = E[c + 496 >> 2], E[c + 180 >> 2] = e, E[c + 160 >> 2] = Q, E[c + 164 >> 2] = o, $A(Q = c + 528 | 0, c + 176 | 0, c + 160 | 0), o = E[c + 540 >> 2], E[c + 520 >> 2] = E[c + 536 >> 2], E[c + 524 >> 2] = o, o = E[c + 492 >> 2], E[c + 152 >> 2] = E[c + 488 >> 2], E[c + 156 >> 2] = o, o = E[c + 508 >> 2], E[c + 136 >> 2] = E[c + 504 >> 2], E[c + 140 >> 2] = o, o = E[c + 532 >> 2], E[c + 512 >> 2] = E[c + 528 >> 2], E[c + 516 >> 2] = o, o = E[c + 484 >> 2], E[c + 144 >> 2] = E[c + 480 >> 2], E[c + 148 >> 2] = o, o = E[c + 500 >> 2], E[c + 128 >> 2] = E[c + 496 >> 2], E[c + 132 >> 2] = o, $A(Q, c + 144 | 0, c + 128 | 0), o = E[c + 540 >> 2], E[c + 504 >> 2] = E[c + 536 >> 2], E[c + 508 >> 2] = o, o = E[c + 476 >> 2], E[c + 120 >> 2] = E[c + 472 >> 2], E[c + 124 >> 2] = o, o = E[c + 492 >> 2], E[c + 104 >> 2] = E[c + 488 >> 2], E[c + 108 >> 2] = o, o = E[c + 532 >> 2], E[c + 496 >> 2] = E[c + 528 >> 2], E[c + 500 >> 2] = o, o = E[c + 468 >> 2], E[c + 112 >> 2] = E[c + 464 >> 2], E[c + 116 >> 2] = o, o = E[c + 484 >> 2], E[c + 96 >> 2] = E[c + 480 >> 2], E[c + 100 >> 2] = o, $A(Q, c + 112 | 0, c + 96 | 0), o = E[c + 540 >> 2], E[c + 488 >> 2] = E[c + 536 >> 2], E[c + 492 >> 2] = o, o = E[c + 460 >> 2], E[c + 88 >> 2] = E[c + 456 >> 2], E[c + 92 >> 2] = o, o = E[c + 476 >> 2], E[c + 72 >> 2] = E[c + 472 >> 2], E[c + 76 >> 2] = o, o = E[c + 532 >> 2], E[c + 480 >> 2] = E[c + 528 >> 2], E[c + 484 >> 2] = o, o = E[c + 452 >> 2], E[c + 80 >> 2] = E[c + 448 >> 2], E[c + 84 >> 2] = o, o = E[c + 468 >> 2], E[c + 64 >> 2] = E[c + 464 >> 2], E[c + 68 >> 2] = o, $A(Q, c + 80 | 0, c - -64 | 0), o = E[c + 540 >> 2], E[c + 472 >> 2] = E[c + 536 >> 2], E[c + 476 >> 2] = o, o = E[c + 444 >> 2], E[c + 56 >> 2] = E[c + 440 >> 2], E[c + 60 >> 2] = o, o = E[c + 460 >> 2], E[c + 40 >> 2] = E[c + 456 >> 2], E[c + 44 >> 2] = o, o = E[c + 532 >> 2], E[c + 464 >> 2] = E[c + 528 >> 2], E[c + 468 >> 2] = o, o = E[c + 436 >> 2], E[c + 48 >> 2] = E[c + 432 >> 2], E[c + 52 >> 2] = o, o = E[c + 452 >> 2], E[c + 32 >> 2] = E[c + 448 >> 2], E[c + 36 >> 2] = o, $A(Q, c + 48 | 0, c + 32 | 0), o = E[c + 540 >> 2], E[c + 456 >> 2] = E[c + 536 >> 2], E[c + 460 >> 2] = o, o = E[c + 396 >> 2], E[c + 24 >> 2] = E[c + 392 >> 2], E[c + 28 >> 2] = o, o = E[c + 444 >> 2], E[c + 8 >> 2] = E[c + 440 >> 2], E[c + 12 >> 2] = o, o = E[c + 532 >> 2], E[c + 448 >> 2] = E[c + 528 >> 2], E[c + 452 >> 2] = o, o = E[c + 388 >> 2], E[c + 16 >> 2] = E[c + 384 >> 2], E[c + 20 >> 2] = o, o = E[c + 436 >> 2], E[c >> 2] = E[c + 432 >> 2], E[c + 4 >> 2] = o, $A(Q, c + 16 | 0, c), E[c + 444 >> 2] = s ^ E[c + 540 >> 2], E[c + 440 >> 2] = y ^ E[c + 536 >> 2], E[c + 436 >> 2] = r ^ E[c + 532 >> 2], E[c + 432 >> 2] = _ ^ E[c + 528 >> 2]);
                                            A: {
                                                I: {
                                                    g: {
                                                        C: {
                                                            B: {
                                                                if (A) {
                                                                    if (Q = 16, g >>> 0 < 16) break B;
                                                                    for(_ = 0; X(A + _ | 0, I + _ | 0, c + 432 | 0), _ = o = Q, (Q = o + 16 | 0) >>> 0 <= g >>> 0;);
                                                                } else {
                                                                    if (_ = 16, g >>> 0 < 16) break g;
                                                                    for(Q = 0; X(c + 528 | 0, I + Q | 0, c + 432 | 0), Q = o = _, (_ = o + 16 | 0) >>> 0 <= g >>> 0;);
                                                                }
                                                                if (!(_ = 15 & g)) break A;
                                                                if (A) break C;
                                                                break I;
                                                            }
                                                            if (o = 0, !(_ = g)) break A;
                                                        }
                                                        Z(A + o | 0, I + o | 0, _, c + 432 | 0);
                                                        break A;
                                                    }
                                                    if (o = 0, !(_ = g)) break A;
                                                }
                                                Z(c + 528 | 0, I + o | 0, _, c + 432 | 0);
                                            }
                                            m(c + 384 | 0, B, i, g, c + 432 | 0), o = -1;
                                            A: {
                                                I: {
                                                    if (I = B - 16 | 0) {
                                                        if (16 == (0 | I)) break I;
                                                        break A;
                                                    }
                                                    o = iI(c + 384 | 0, C);
                                                    break A;
                                                }
                                                o = SC(c + 384 | 0, C);
                                            }
                                            return !A | !o || Hg(A, 0, g), h = c + 544 | 0, 0 | o;
                                        }
                                    ], DB.grow = function(A) {
                                        var I = this.length;
                                        return this.length = this.length + A, I;
                                    }, DB.set = function(A, I) {
                                        this[A] = I;
                                    }, DB.get = function(A) {
                                        return this[A];
                                    }, DB);
                                    function wB() {
                                        return i.byteLength / 65536 | 0;
                                    }
                                    return {
                                        f: function() {},
                                        g: CB,
                                        h: hB,
                                        i: CB,
                                        j: BB,
                                        k: aB,
                                        l: qC,
                                        m: function(A, I, g, C, B, Q, i, o, E, a, _) {
                                            return 0 | WI(A |= 0, I |= 0, g |= 0, C |= 0, B |= 0, Q |= 0, i |= 0, o |= 0, a |= 0, _ |= 0, 36784);
                                        },
                                        n: function(A, I, g, C, B, Q, i, o, E, a, _, c) {
                                            return 0 | eg(A |= 0, I |= 0, g |= 0, C |= 0, B |= 0, Q |= 0, i |= 0, o |= 0, E |= 0, _ |= 0, c |= 0, 36784);
                                        },
                                        o: function(A, I, g, C, B, Q, i, o, E, a, _) {
                                            return 0 | zI(A |= 0, I |= 0, C |= 0, B |= 0, Q |= 0, i |= 0, o |= 0, E |= 0, a |= 0, _ |= 0, 36788);
                                        },
                                        p: function(A, I, g, C, B, Q, i, o, E, a, _) {
                                            return 0 | pg(A |= 0, g |= 0, C |= 0, B |= 0, Q |= 0, i |= 0, o |= 0, E |= 0, a |= 0, _ |= 0, 36788);
                                        },
                                        q: BB,
                                        r: hB,
                                        s: BB,
                                        t: BB,
                                        u: aB,
                                        v: LC,
                                        w: function(A, I, g, C, B, Q, i, o, E, a, _) {
                                            return 0 | WI(A |= 0, I |= 0, g |= 0, C |= 0, B |= 0, Q |= 0, i |= 0, o |= 0, a |= 0, _ |= 0, 36792);
                                        },
                                        x: function(A, I, g, C, B, Q, i, o, E, a, _, c) {
                                            return 0 | eg(A |= 0, I |= 0, g |= 0, C |= 0, B |= 0, Q |= 0, i |= 0, o |= 0, E |= 0, _ |= 0, c |= 0, 36792);
                                        },
                                        y: function(A, I, g, C, B, Q, i, o, E, a, _) {
                                            return 0 | zI(A |= 0, I |= 0, C |= 0, B |= 0, Q |= 0, i |= 0, o |= 0, E |= 0, a |= 0, _ |= 0, 36796);
                                        },
                                        z: function(A, I, g, C, B, Q, i, o, E, a, _) {
                                            return 0 | pg(A |= 0, g |= 0, C |= 0, B |= 0, Q |= 0, i |= 0, o |= 0, E |= 0, a |= 0, _ |= 0, 36796);
                                        },
                                        A: function(A, I, g, C, B, Q, i, o, E, a, _, c) {
                                            return 0 | xI(A |= 0, I |= 0, g |= 0, C |= 0, (A = 0) | (B |= 0), Q |= 0, i |= 0, A | (o |= 0), E |= 0, _ |= 0, c |= 0);
                                        },
                                        B: function(A, I, g, C, B, i, o, a, _, c, t) {
                                            return A |= 0, I |= 0, C |= 0, o |= 0, _ |= 0, o |= _ = 0, !(B |= 0) & (C |= _) >>> 0 < 4294967280 ? (xI(A, A + C | 0, 0, g |= 0, C, B, i |= 0, o, a |= 0, c |= 0, t |= 0), I && (B = (A = C + 16 | 0) >>> 0 < 16 ? B + 1 | 0 : B, E[I >> 2] = A, E[I + 4 >> 2] = B)) : (yC(), Q()), 0;
                                        },
                                        C: function(A, I, g, C, B, Q, i, o, E, a, _, c) {
                                            return 0 | lI(A |= 0, I |= 0, g |= 0, C |= 0, (A = 0) | (B |= 0), Q |= 0, i |= 0, A | (o |= 0), E |= 0, _ |= 0, c |= 0);
                                        },
                                        D: function(A, I, g, C, B, i, o, a, _, c, t) {
                                            return A |= 0, I |= 0, C |= 0, o |= 0, _ |= 0, o |= _ = 0, !(B |= 0) & (C |= _) >>> 0 < 4294967280 ? (lI(A, A + C | 0, 0, g |= 0, C, B, i |= 0, o, a |= 0, c |= 0, t |= 0), I && (B = (A = C + 16 | 0) >>> 0 < 16 ? B + 1 | 0 : B, E[I >> 2] = A, E[I + 4 >> 2] = B)) : (yC(), Q()), 0;
                                        },
                                        E: function(A, I, g, C, B, Q, i, o, E, a, _) {
                                            return 0 | UI(A |= 0, g |= 0, (A = 0) | (C |= 0), B |= 0, Q |= 0, i |= 0, A | (o |= 0), E |= 0, a |= 0, _ |= 0);
                                        },
                                        F: function(A, I, g, C, B, Q, i, o, a, _, c) {
                                            return I |= 0, g |= 0, C |= 0, B |= 0, o |= 0, o |= 0, g = -1, !(Q |= 0) & (B |= 0) >>> 0 >= 16 | Q && (g = UI(A |= 0, C, B - 16 | 0, Q - (B >>> 0 < 16) | 0, (C + B | 0) - 16 | 0, i |= 0, o, a |= 0, _ |= 0, c |= 0)), I && (E[I >> 2] = g ? 0 : B - 16 | 0, E[I + 4 >> 2] = g ? 0 : Q - (B >>> 0 < 16) | 0), 0 | g;
                                        },
                                        G: function(A, I, g, C, B, Q, i, o, E, a, _) {
                                            return 0 | YI(A |= 0, g |= 0, (A = 0) | (C |= 0), B |= 0, Q |= 0, i |= 0, A | (o |= 0), E |= 0, a |= 0, _ |= 0);
                                        },
                                        H: function(A, I, g, C, B, Q, i, o, a, _, c) {
                                            return I |= 0, g |= 0, C |= 0, B |= 0, o |= 0, o |= 0, g = -1, !(Q |= 0) & (B |= 0) >>> 0 >= 16 | Q && (g = YI(A |= 0, C, B - 16 | 0, Q - (B >>> 0 < 16) | 0, (C + B | 0) - 16 | 0, i |= 0, o, a |= 0, _ |= 0, c |= 0)), I && (E[I >> 2] = g ? 0 : B - 16 | 0, E[I + 4 >> 2] = g ? 0 : Q - (B >>> 0 < 16) | 0), 0 | g;
                                        },
                                        I: BB,
                                        J: QB,
                                        K: hB,
                                        L: CB,
                                        M: oB,
                                        N: LC,
                                        O: BB,
                                        P: sB,
                                        Q: hB,
                                        R: CB,
                                        S: oB,
                                        T: LC,
                                        U: function(A, I, g, C, B, Q, i, o, E, a, _, c) {
                                            return 0 | fI(A |= 0, I |= 0, g |= 0, C |= 0, (A = 0) | (B |= 0), Q |= 0, i |= 0, A | (o |= 0), E |= 0, _ |= 0, c |= 0);
                                        },
                                        V: function(A, I, g, C, B, i, o, a, _, c, t) {
                                            return A |= 0, I |= 0, C |= 0, o |= 0, _ |= 0, o |= _ = 0, !(B |= 0) & (C |= _) >>> 0 < 4294967280 ? (fI(A, A + C | 0, 0, g |= 0, C, B, i |= 0, o, a |= 0, c |= 0, t |= 0), I && (B = (A = C + 16 | 0) >>> 0 < 16 ? B + 1 | 0 : B, E[I >> 2] = A, E[I + 4 >> 2] = B)) : (yC(), Q()), 0;
                                        },
                                        W: function(A, I, g, C, B, Q, i, o, E, a, _) {
                                            return 0 | sI(A |= 0, g |= 0, (A = 0) | (C |= 0), B |= 0, Q |= 0, i |= 0, A | (o |= 0), E |= 0, a |= 0, _ |= 0);
                                        },
                                        X: function(A, I, g, C, B, Q, i, o, a, _, c) {
                                            return I |= 0, g |= 0, C |= 0, B |= 0, o |= 0, o |= 0, g = -1, !(Q |= 0) & (B |= 0) >>> 0 >= 16 | Q && (g = sI(A |= 0, C, B - 16 | 0, Q - (B >>> 0 < 16) | 0, (C + B | 0) - 16 | 0, i |= 0, o, a |= 0, _ |= 0, c |= 0)), I && (E[I >> 2] = g ? 0 : B - 16 | 0, E[I + 4 >> 2] = g ? 0 : Q - (B >>> 0 < 16) | 0), 0 | g;
                                        },
                                        Y: BB,
                                        Z: _B,
                                        _: hB,
                                        $: CB,
                                        aa: oB,
                                        ba: LC,
                                        ca: BB,
                                        da: BB,
                                        ea: function() {
                                            return 1464;
                                        },
                                        fa: EI,
                                        ga: JI,
                                        ha: LC,
                                        ia: BB,
                                        ja: BB,
                                        ka: IB,
                                        la: LC,
                                        ma: UA,
                                        na: function(A, I, g, C) {
                                            return 0 | YC(A |= 0, I |= 0, g |= 0, C |= 0);
                                        },
                                        oa: Fg,
                                        pa: function(A, I, g, C, B) {
                                            var Q;
                                            return A |= 0, I |= 0, g |= 0, C |= 0, h = Q = h - 240 | 0, UA(Q, B |= 0, 32), MA(Q, I, g, C), dA(Q, I = Q + 208 | 0), MA(g = Q + 104 | 0, I, 32, 0), dA(g, A), XC(I, 32), h = Q + 240 | 0, 0;
                                        },
                                        qa: function(A, I, g, C, B) {
                                            var Q, i;
                                            return A |= 0, I |= 0, g |= 0, C |= 0, h = Q = h - 272 | 0, UA(i = Q + 32 | 0, B |= 0, 32), MA(i, I, g, C), dA(i, I = Q + 240 | 0), MA(g = Q + 136 | 0, I, 32, 0), dA(g, Q), XC(I, 32), I = SC(A, Q), g = MI(Q, A, 32), h = Q + 272 | 0, ((0 | A) == (0 | Q) ? -1 : I) | g;
                                        },
                                        ra: gB,
                                        sa: BB,
                                        ta: TC,
                                        ua: LC,
                                        va: QI,
                                        wa: EC,
                                        xa: fg,
                                        ya: function(A, I, g, C, B) {
                                            var Q;
                                            return A |= 0, I |= 0, g |= 0, C |= 0, h = Q = h - 480 | 0, QI(Q, B |= 0, 32), nA(Q, I, g, C), z(Q, I = Q + 416 | 0), nA(g = Q + 208 | 0, I, 64, 0), z(g, A), XC(I, 64), h = Q + 480 | 0, 0;
                                        },
                                        za: function(A, I, g, C, B) {
                                            var Q, i;
                                            return A |= 0, I |= 0, g |= 0, C |= 0, h = Q = h - 544 | 0, QI(i = Q - -64 | 0, B |= 0, 32), nA(i, I, g, C), z(i, I = Q + 480 | 0), nA(g = Q + 272 | 0, I, 64, 0), z(g, Q), XC(I, 64), I = GC(A, Q), g = MI(Q, A, 64), h = Q + 544 | 0, ((0 | A) == (0 | Q) ? -1 : I) | g;
                                        },
                                        Aa: BB,
                                        Ba: BB,
                                        Ca: TC,
                                        Da: LC,
                                        Ea: eC,
                                        Fa: EC,
                                        Ga: function(A, I) {
                                            I |= 0;
                                            var g, C = 0;
                                            return h = g = h + -64 | 0, fg(A |= 0, g), C = E[g + 28 >> 2], A = E[g + 24 >> 2], o[I + 24 | 0] = A, o[I + 25 | 0] = A >>> 8, o[I + 26 | 0] = A >>> 16, o[I + 27 | 0] = A >>> 24, o[I + 28 | 0] = C, o[I + 29 | 0] = C >>> 8, o[I + 30 | 0] = C >>> 16, o[I + 31 | 0] = C >>> 24, C = E[g + 20 >> 2], A = E[g + 16 >> 2], o[I + 16 | 0] = A, o[I + 17 | 0] = A >>> 8, o[I + 18 | 0] = A >>> 16, o[I + 19 | 0] = A >>> 24, o[I + 20 | 0] = C, o[I + 21 | 0] = C >>> 8, o[I + 22 | 0] = C >>> 16, o[I + 23 | 0] = C >>> 24, C = E[g + 12 >> 2], A = E[g + 8 >> 2], o[I + 8 | 0] = A, o[I + 9 | 0] = A >>> 8, o[I + 10 | 0] = A >>> 16, o[I + 11 | 0] = A >>> 24, o[I + 12 | 0] = C, o[I + 13 | 0] = C >>> 8, o[I + 14 | 0] = C >>> 16, o[I + 15 | 0] = C >>> 24, C = E[g + 4 >> 2], A = E[g >> 2], o[0 | I] = A, o[I + 1 | 0] = A >>> 8, o[I + 2 | 0] = A >>> 16, o[I + 3 | 0] = A >>> 24, o[I + 4 | 0] = C, o[I + 5 | 0] = C >>> 8, o[I + 6 | 0] = C >>> 16, o[I + 7 | 0] = C >>> 24, h = g - -64 | 0, 0;
                                        },
                                        Ha: EI,
                                        Ia: JI,
                                        Ja: BB,
                                        Ka: BB,
                                        La: BB,
                                        Ma: BB,
                                        Na: _B,
                                        Oa: BB,
                                        Pa: CB,
                                        Qa: CB,
                                        Ra: oB,
                                        Sa: function() {
                                            return 1478;
                                        },
                                        Ta: function(A, I, g) {
                                            return 0 | aI(A |= 0, I |= 0, g |= 0);
                                        },
                                        Ua: KC,
                                        Va: cC,
                                        Wa: Pg,
                                        Xa: qg,
                                        Ya: Qg,
                                        Za: Bg,
                                        _a: dg,
                                        $a: function(A, I, g, C, B, Q, i, o) {
                                            A |= 0, I |= 0, g |= 0, Q |= 0;
                                            var E, a = 0;
                                            return a = C |= 0, C = B |= 0, E = 0 | a, h = a = h - 32 | 0, B = -1, cC(a, i |= 0, o |= 0) || (B = eI(A, I, g, E, C, Q, a), XC(a, 32)), h = a + 32 | 0, 0 | B;
                                        },
                                        ab: function(A, I, g, C, B, i) {
                                            return A |= 0, I |= 0, B |= 0, i |= 0, !(C |= 0) & (g |= 0) >>> 0 >= 4294967280 | C && (yC(), Q()), 0 | eI(A + 16 | 0, A, I, g, C, B, i);
                                        },
                                        bb: function(A, I, g, C, B, Q, i) {
                                            return 0 | sg(A |= 0, I |= 0, g |= 0, C |= 0, B |= 0, Q |= 0, i |= 0);
                                        },
                                        cb: Jg,
                                        db: function(A, I, g, C, B, Q, i, o) {
                                            A |= 0, I |= 0, g |= 0, Q |= 0;
                                            var E, a = 0;
                                            return a = C |= 0, C = B |= 0, E = 0 | a, h = a = h - 32 | 0, B = -1, cC(a, i |= 0, o |= 0) || (B = yI(A, I, g, E, C, Q, a), XC(a, 32)), h = a + 32 | 0, 0 | B;
                                        },
                                        eb: hg,
                                        fb: function(A, I, g, C, B, Q, i) {
                                            return 0 | _g(A |= 0, I |= 0, g |= 0, C |= 0, B |= 0, Q |= 0, i |= 0);
                                        },
                                        gb: function(A, I, g, C, B) {
                                            A |= 0, I |= 0, B |= 0;
                                            var Q, i, a, _, c = 0, t = 0;
                                            return c = g |= 0, g = C |= 0, _ = 0 | c, c = C = h, h = Q = C - 512 & -64, C = -1, KC(i = Q - -64 | 0, a = Q + 32 | 0) || (iC(C = Q + 128 | 0, 0, 0, 24), mC(C, i, 32, 0), mC(C, B, 32, 0), rC(C, t = Q + 96 | 0, 24), C = sg(A + 32 | 0, I, _, g, t, B, a), I = E[Q + 92 >> 2], g = E[Q + 88 >> 2], o[A + 24 | 0] = g, o[A + 25 | 0] = g >>> 8, o[A + 26 | 0] = g >>> 16, o[A + 27 | 0] = g >>> 24, o[A + 28 | 0] = I, o[A + 29 | 0] = I >>> 8, o[A + 30 | 0] = I >>> 16, o[A + 31 | 0] = I >>> 24, I = E[Q + 84 >> 2], g = E[Q + 80 >> 2], o[A + 16 | 0] = g, o[A + 17 | 0] = g >>> 8, o[A + 18 | 0] = g >>> 16, o[A + 19 | 0] = g >>> 24, o[A + 20 | 0] = I, o[A + 21 | 0] = I >>> 8, o[A + 22 | 0] = I >>> 16, o[A + 23 | 0] = I >>> 24, I = E[Q + 76 >> 2], g = E[Q + 72 >> 2], o[A + 8 | 0] = g, o[A + 9 | 0] = g >>> 8, o[A + 10 | 0] = g >>> 16, o[A + 11 | 0] = g >>> 24, o[A + 12 | 0] = I, o[A + 13 | 0] = I >>> 8, o[A + 14 | 0] = I >>> 16, o[A + 15 | 0] = I >>> 24, I = E[Q + 68 >> 2], g = E[Q + 64 >> 2], o[0 | A] = g, o[A + 1 | 0] = g >>> 8, o[A + 2 | 0] = g >>> 16, o[A + 3 | 0] = g >>> 24, o[A + 4 | 0] = I, o[A + 5 | 0] = I >>> 8, o[A + 6 | 0] = I >>> 16, o[A + 7 | 0] = I >>> 24, XC(a, 32), XC(i, 32), XC(t, 24)), h = c, 0 | C;
                                        },
                                        hb: function(A, I, g, C, B, Q) {
                                            A |= 0, I |= 0, B |= 0, Q |= 0;
                                            var i, o, E = 0;
                                            return o = E = h, h = i = E - 448 & -64, E = -1, !(C |= 0) & (g |= 0) >>> 0 >= 48 | C && (iC(E = i - -64 | 0, 0, 0, 24), mC(E, I, 32, 0), mC(E, B, 32, 0), rC(E, B = i + 32 | 0, 24), E = _g(A, I + 32 | 0, g - 32 | 0, C - (g >>> 0 < 32) | 0, B, I, Q)), h = o, 0 | E;
                                        },
                                        ib: EB,
                                        jb: aI,
                                        kb: sC,
                                        lb: wg,
                                        mb: Pg,
                                        nb: qg,
                                        ob: Qg,
                                        pb: Bg,
                                        qb: BB,
                                        rb: BB,
                                        sb: BB,
                                        tb: BB,
                                        ub: _B,
                                        vb: BB,
                                        wb: CB,
                                        xb: CB,
                                        yb: oB,
                                        zb: yA,
                                        Ab: BB,
                                        Bb: CB,
                                        Cb: BB,
                                        Db: CB,
                                        Eb: fA,
                                        Fb: BB,
                                        Gb: CB,
                                        Hb: BB,
                                        Ib: CB,
                                        Jb: AC,
                                        Kb: gB,
                                        Lb: CB,
                                        Mb: BB,
                                        Nb: CB,
                                        Ob: IC,
                                        Pb: gB,
                                        Qb: CB,
                                        Rb: BB,
                                        Sb: CB,
                                        Tb: gC,
                                        Ub: gB,
                                        Vb: CB,
                                        Wb: BB,
                                        Xb: CB,
                                        Yb: CB,
                                        Zb: gB,
                                        _b: BB,
                                        $b: CB,
                                        ac: gB,
                                        bc: BB,
                                        cc: VC,
                                        dc: WC,
                                        ec: function(A, I, g, C, B, Q, i) {
                                            return 0 | kC(A |= 0, I |= 0, g |= 0, C |= 0, B |= 0, Q |= 0, i |= 0);
                                        },
                                        fc: iC,
                                        gc: function(A, I, g, C) {
                                            return 0 | mC(A |= 0, I |= 0, g |= 0, C |= 0);
                                        },
                                        hc: rC,
                                        ic: LC,
                                        jc: CB,
                                        kc: gB,
                                        lc: BB,
                                        mc: CB,
                                        nc: gB,
                                        oc: BB,
                                        pc: CB,
                                        qc: CB,
                                        rc: WC,
                                        sc: LC,
                                        tc: kC,
                                        uc: function(A, I, g, C, B, Q, i, o, E) {
                                            return 0 | QA(A |= 0, I |= 0, g |= 0, C |= 0, B |= 0, Q |= 0, i |= 0, o |= 0, E |= 0);
                                        },
                                        vc: eA,
                                        wc: function(A, I, g, C, B, i) {
                                            A |= 0, I |= 0, B |= 0, i |= 0;
                                            var E = 0, _ = 0, c = 0, t = 0, r = 0, e = 0, y = 0;
                                            if (E = -1, !((C |= 0) - 65 >>> 0 < 4294967232 | (g |= 0) >>> 0 > 64)) {
                                                A: {
                                                    if (!g || !I) {
                                                        if (((t = 255 & C) - 65 & 255) >>> 0 > 191) {
                                                            B ? (_ = 725511199 ^ (a[B + 8 | 0] | a[B + 9 | 0] << 8 | a[B + 10 | 0] << 16 | a[B + 11 | 0] << 24), g = -1694144372 ^ (a[B + 12 | 0] | a[B + 13 | 0] << 8 | a[B + 14 | 0] << 16 | a[B + 15 | 0] << 24), I = -1377402159 ^ (a[0 | B] | a[B + 1 | 0] << 8 | a[B + 2 | 0] << 16 | a[B + 3 | 0] << 24), B = 1359893119 ^ (a[B + 4 | 0] | a[B + 5 | 0] << 8 | a[B + 6 | 0] << 16 | a[B + 7 | 0] << 24)) : (_ = 725511199, g = -1694144372, I = -1377402159, B = 1359893119), i ? (c = 327033209 ^ (a[i + 8 | 0] | a[i + 9 | 0] << 8 | a[i + 10 | 0] << 16 | a[i + 11 | 0] << 24), C = 1541459225 ^ (a[i + 12 | 0] | a[i + 13 | 0] << 8 | a[i + 14 | 0] << 16 | a[i + 15 | 0] << 24), E = -79577749 ^ (a[0 | i] | a[i + 1 | 0] << 8 | a[i + 2 | 0] << 16 | a[i + 3 | 0] << 24), i = 528734635 ^ (a[i + 4 | 0] | a[i + 5 | 0] << 8 | a[i + 6 | 0] << 16 | a[i + 7 | 0] << 24)) : (c = 327033209, C = 1541459225, E = -79577749, i = 528734635), Hg(A - -64 | 0, 0, 293), o[A + 56 | 0] = c, o[A + 57 | 0] = c >>> 8, o[A + 58 | 0] = c >>> 16, o[A + 59 | 0] = c >>> 24, o[A + 60 | 0] = C, o[A + 61 | 0] = C >>> 8, o[A + 62 | 0] = C >>> 16, o[A + 63 | 0] = C >>> 24, o[A + 48 | 0] = E, o[A + 49 | 0] = E >>> 8, o[A + 50 | 0] = E >>> 16, o[A + 51 | 0] = E >>> 24, o[A + 52 | 0] = i, o[A + 53 | 0] = i >>> 8, o[A + 54 | 0] = i >>> 16, o[A + 55 | 0] = i >>> 24, o[A + 40 | 0] = _, o[A + 41 | 0] = _ >>> 8, o[A + 42 | 0] = _ >>> 16, o[A + 43 | 0] = _ >>> 24, o[A + 44 | 0] = g, o[A + 45 | 0] = g >>> 8, o[A + 46 | 0] = g >>> 16, o[A + 47 | 0] = g >>> 24, o[A + 32 | 0] = I, o[A + 33 | 0] = I >>> 8, o[A + 34 | 0] = I >>> 16, o[A + 35 | 0] = I >>> 24, o[A + 36 | 0] = B, o[A + 37 | 0] = B >>> 8, o[A + 38 | 0] = B >>> 16, o[A + 39 | 0] = B >>> 24, o[A + 24 | 0] = 241, o[A + 25 | 0] = 54, o[A + 26 | 0] = 29, o[A + 27 | 0] = 95, o[A + 28 | 0] = 58, o[A + 29 | 0] = 245, o[A + 30 | 0] = 79, o[A + 31 | 0] = 165, o[A + 16 | 0] = 43, o[A + 17 | 0] = 248, o[A + 18 | 0] = 148, o[A + 19 | 0] = 254, o[A + 20 | 0] = 114, o[A + 21 | 0] = 243, o[A + 22 | 0] = 110, o[A + 23 | 0] = 60, o[A + 8 | 0] = 59, o[A + 9 | 0] = 167, o[A + 10 | 0] = 202, o[A + 11 | 0] = 132, o[A + 12 | 0] = 133, o[A + 13 | 0] = 174, o[A + 14 | 0] = 103, o[A + 15 | 0] = 187, I = -222443256 ^ t, o[0 | A] = I, o[A + 1 | 0] = I >>> 8, o[A + 2 | 0] = I >>> 16, o[A + 3 | 0] = I >>> 24, o[A + 4 | 0] = 103, o[A + 5 | 0] = 230, o[A + 6 | 0] = 9, o[A + 7 | 0] = 106;
                                                            break A;
                                                        }
                                                        yC(), Q();
                                                    }
                                                    h = e = h - 128 | 0, !I | ((y = 255 & C) - 65 & 255) >>> 0 <= 191 | ((E = 255 & g) - 65 & 255) >>> 0 <= 191 ? (yC(), Q()) : (B ? (_ = 725511199 ^ (a[B + 8 | 0] | a[B + 9 | 0] << 8 | a[B + 10 | 0] << 16 | a[B + 11 | 0] << 24), g = -1694144372 ^ (a[B + 12 | 0] | a[B + 13 | 0] << 8 | a[B + 14 | 0] << 16 | a[B + 15 | 0] << 24), t = -1377402159 ^ (a[0 | B] | a[B + 1 | 0] << 8 | a[B + 2 | 0] << 16 | a[B + 3 | 0] << 24), B = 1359893119 ^ (a[B + 4 | 0] | a[B + 5 | 0] << 8 | a[B + 6 | 0] << 16 | a[B + 7 | 0] << 24)) : (_ = 725511199, g = -1694144372, t = -1377402159, B = 1359893119), i ? (c = 327033209 ^ (a[i + 8 | 0] | a[i + 9 | 0] << 8 | a[i + 10 | 0] << 16 | a[i + 11 | 0] << 24), C = 1541459225 ^ (a[i + 12 | 0] | a[i + 13 | 0] << 8 | a[i + 14 | 0] << 16 | a[i + 15 | 0] << 24), r = -79577749 ^ (a[0 | i] | a[i + 1 | 0] << 8 | a[i + 2 | 0] << 16 | a[i + 3 | 0] << 24), i = 528734635 ^ (a[i + 4 | 0] | a[i + 5 | 0] << 8 | a[i + 6 | 0] << 16 | a[i + 7 | 0] << 24)) : (c = 327033209, C = 1541459225, r = -79577749, i = 528734635), Hg(A - -64 | 0, 0, 293), o[A + 56 | 0] = c, o[A + 57 | 0] = c >>> 8, o[A + 58 | 0] = c >>> 16, o[A + 59 | 0] = c >>> 24, o[A + 60 | 0] = C, o[A + 61 | 0] = C >>> 8, o[A + 62 | 0] = C >>> 16, o[A + 63 | 0] = C >>> 24, o[A + 48 | 0] = r, o[A + 49 | 0] = r >>> 8, o[A + 50 | 0] = r >>> 16, o[A + 51 | 0] = r >>> 24, o[A + 52 | 0] = i, o[A + 53 | 0] = i >>> 8, o[A + 54 | 0] = i >>> 16, o[A + 55 | 0] = i >>> 24, o[A + 40 | 0] = _, o[A + 41 | 0] = _ >>> 8, o[A + 42 | 0] = _ >>> 16, o[A + 43 | 0] = _ >>> 24, o[A + 44 | 0] = g, o[A + 45 | 0] = g >>> 8, o[A + 46 | 0] = g >>> 16, o[A + 47 | 0] = g >>> 24, o[A + 32 | 0] = t, o[A + 33 | 0] = t >>> 8, o[A + 34 | 0] = t >>> 16, o[A + 35 | 0] = t >>> 24, o[A + 36 | 0] = B, o[A + 37 | 0] = B >>> 8, o[A + 38 | 0] = B >>> 16, o[A + 39 | 0] = B >>> 24, o[A + 24 | 0] = 241, o[A + 25 | 0] = 54, o[A + 26 | 0] = 29, o[A + 27 | 0] = 95, o[A + 28 | 0] = 58, o[A + 29 | 0] = 245, o[A + 30 | 0] = 79, o[A + 31 | 0] = 165, o[A + 16 | 0] = 43, o[A + 17 | 0] = 248, o[A + 18 | 0] = 148, o[A + 19 | 0] = 254, o[A + 20 | 0] = 114, o[A + 21 | 0] = 243, o[A + 22 | 0] = 110, o[A + 23 | 0] = 60, o[A + 8 | 0] = 59, o[A + 9 | 0] = 167, o[A + 10 | 0] = 202, o[A + 11 | 0] = 132, o[A + 12 | 0] = 133, o[A + 13 | 0] = 174, o[A + 14 | 0] = 103, o[A + 15 | 0] = 187, g = -222443256 ^ (E << 8 | y), o[0 | A] = g, o[A + 1 | 0] = g >>> 8, o[A + 2 | 0] = g >>> 16, o[A + 3 | 0] = g >>> 24, g = E >>> 24 ^ 1779033703, o[A + 4 | 0] = g, o[A + 5 | 0] = g >>> 8, o[A + 6 | 0] = g >>> 16, o[A + 7 | 0] = g >>> 24, Hg(E + e | 0, 0, E << 24 >> 24 >= 0 ? 128 - E | 0 : 0), g = Sg(e, I, E), Sg(A + 96 | 0, g, 128), I = 128 + (a[A + 352 | 0] | a[A + 353 | 0] << 8 | a[A + 354 | 0] << 16 | a[A + 355 | 0] << 24) | 0, o[A + 352 | 0] = I, o[A + 353 | 0] = I >>> 8, o[A + 354 | 0] = I >>> 16, o[A + 355 | 0] = I >>> 24, XC(g, 128), h = g + 128 | 0);
                                                }
                                                E = 0;
                                            }
                                            return 0 | E;
                                        },
                                        xc: mC,
                                        yc: Yg,
                                        zc: gB,
                                        Ac: CC,
                                        Bc: function() {
                                            return 1533;
                                        },
                                        Cc: BB,
                                        Dc: function() {
                                            return 104;
                                        },
                                        Ec: $I,
                                        Fc: function(A, I, g, C) {
                                            return 0 | MA(A |= 0, I |= 0, g |= 0, C |= 0);
                                        },
                                        Gc: dA,
                                        Hc: function(A, I, g, C) {
                                            A |= 0, I |= 0, g |= 0, C |= 0;
                                            var B, Q = 0;
                                            return h = B = h - 112 | 0, Q = E[8603], E[B + 16 >> 2] = E[8602], E[B + 20 >> 2] = Q, Q = E[8605], E[B + 24 >> 2] = E[8604], E[B + 28 >> 2] = Q, Q = E[8607], E[B + 32 >> 2] = E[8606], E[B + 36 >> 2] = Q, E[B + 40 >> 2] = 0, E[B + 44 >> 2] = 0, Q = E[8601], E[B + 8 >> 2] = E[8600], E[B + 12 >> 2] = Q, MA(Q = B + 8 | 0, I, g, C), dA(Q, A), h = B + 112 | 0, 0;
                                        },
                                        Ic: gB,
                                        Jc: IB,
                                        Kc: SI,
                                        Lc: QC,
                                        Mc: z,
                                        Nc: CC,
                                        Oc: CB,
                                        Pc: gB,
                                        Qc: sB,
                                        Rc: BB,
                                        Sc: dI,
                                        Tc: VC,
                                        Uc: CB,
                                        Vc: gB,
                                        Wc: sB,
                                        Xc: BB,
                                        Yc: dI,
                                        Zc: LC,
                                        _c: function(A, I, g) {
                                            return 0 | UA(A |= 0, I |= 0, g |= 0);
                                        },
                                        $c: function(A, I, g) {
                                            return 0 | YC(A |= 0, I |= 0, g |= 0, 0);
                                        },
                                        ad: function(A, I) {
                                            return Fg(A |= 0, I |= 0), XC(A, 4), 0;
                                        },
                                        bd: function(A, I, g, C, B) {
                                            var Q;
                                            return A |= 0, C |= 0, B |= 0, h = Q = h - 208 | 0, UA(Q, I |= 0, g |= 0), YC(Q, C, B, 0), Fg(Q, A), XC(Q, 4), h = Q + 208 | 0, 0;
                                        },
                                        cd: LC,
                                        dd: function(A, I, g, C, B) {
                                            A |= 0, I |= 0, g |= 0, C |= 0, B |= 0;
                                            var Q, i = 0, _ = 0, c = 0;
                                            if (h = Q = h - 256 | 0, o[Q + 15 | 0] = 1, I >>> 0 <= 8160) {
                                                if (I >>> 0 >= 32) for(i = 32; c = i, UA(i = Q + 48 | 0, B, 32), _ && YC(i, (A + _ | 0) - 32 | 0, 32, 0), YC(i = Q + 48 | 0, g, C, 0), YC(i, Q + 15 | 0, 1, 0), Fg(i, A + _ | 0), o[Q + 15 | 0] = a[Q + 15 | 0] + 1, (i = (_ = c) + 32 | 0) >>> 0 <= I >>> 0;);
                                                (_ = 31 & I) && (UA(I = Q + 48 | 0, B, 32), c && YC(I, (A + c | 0) - 32 | 0, 32, 0), YC(I = Q + 48 | 0, g, C, 0), YC(I, Q + 15 | 0, 1, 0), Fg(g = I, I = Q + 16 | 0), Sg(A + c | 0, I, _), XC(I, 32)), XC(Q + 48 | 0, 208), A = 0;
                                            } else E[9392] = 28, A = -1;
                                            return h = Q + 256 | 0, 0 | A;
                                        },
                                        ed: BB,
                                        fd: hB,
                                        gd: function() {
                                            return 8160;
                                        },
                                        hd: IB,
                                        id: eC,
                                        jd: function(A, I, g) {
                                            return 0 | dC(A |= 0, I |= 0, g |= 0, 0);
                                        },
                                        kd: function(A, I) {
                                            return fg(A |= 0, I |= 0), XC(A, 4), 0;
                                        },
                                        ld: function(A, I, g, C, B) {
                                            var Q;
                                            return A |= 0, C |= 0, B |= 0, h = Q = h - 416 | 0, QI(Q, I |= 0, g |= 0), dC(Q, C, B, 0), fg(Q, A), XC(Q, 4), h = Q + 416 | 0, 0;
                                        },
                                        md: function(A) {
                                            ag(A |= 0, 64);
                                        },
                                        nd: function(A, I, g, C, B) {
                                            A |= 0, I |= 0, g |= 0, C |= 0, B |= 0;
                                            var Q, i = 0, _ = 0, c = 0;
                                            if (h = Q = h - 496 | 0, o[Q + 15 | 0] = 1, I >>> 0 <= 16320) {
                                                if (I >>> 0 >= 64) for(i = 64; c = i, QI(i = Q + 80 | 0, B, 64), _ && dC(i, (A + _ | 0) - 64 | 0, 64, 0), dC(i = Q + 80 | 0, g, C, 0), dC(i, Q + 15 | 0, 1, 0), fg(i, A + _ | 0), o[Q + 15 | 0] = a[Q + 15 | 0] + 1, (i = (_ = c) - -64 | 0) >>> 0 <= I >>> 0;);
                                                (_ = 63 & I) && (QI(I = Q + 80 | 0, B, 64), c && dC(I, (A + c | 0) - 64 | 0, 64, 0), dC(I = Q + 80 | 0, g, C, 0), dC(I, Q + 15 | 0, 1, 0), fg(g = I, I = Q + 16 | 0), Sg(A + c | 0, I, _), XC(I, 64)), XC(Q + 80 | 0, 416), A = 0;
                                            } else E[9392] = 28, A = -1;
                                            return h = Q + 496 | 0, 0 | A;
                                        },
                                        od: gB,
                                        pd: hB,
                                        qd: function() {
                                            return 16320;
                                        },
                                        rd: function(A, I, g) {
                                            return A |= 0, kC(I |= 0, 32, g |= 0, 32, 0, 0, 0), 0 | bC(A, I);
                                        },
                                        sd: function(A, I) {
                                            return A |= 0, ag(I |= 0, 32), 0 | bC(A, I);
                                        },
                                        td: function(A, I, g, C, B) {
                                            I |= 0, g |= 0, C |= 0, B |= 0;
                                            var i, E, _ = 0, c = 0, t = 0;
                                            if (E = _ = h, h = _ = _ - 512 & -64, i = (A |= 0) || I) {
                                                if (t = -1, !tC(c = _ + 96 | 0, C, B)) {
                                                    for(C = I || A, A = 0, iC(I = _ + 128 | 0, 0, 0, 64), mC(I, c, 32, 0), XC(c, 32), mC(I, g, 32, 0), mC(I, B, 32, 0), rC(I, _ + 32 | 0, 64), XC(I, 384); g = (I = _ + 32 | 0) + A | 0, o[A + i | 0] = a[0 | g], o[A + C | 0] = a[g + 32 | 0], o[(B = 1 | A) + i | 0] = a[I + B | 0], o[C + B | 0] = a[g + 33 | 0], 32 != (0 | (A = A + 2 | 0)););
                                                    XC(I, 64), t = 0;
                                                }
                                                return h = E, 0 | t;
                                            }
                                            yC(), Q();
                                        },
                                        ud: function(A, I, g, C, B) {
                                            I |= 0, g |= 0, C |= 0, B |= 0;
                                            var i, E, _ = 0, c = 0, t = 0;
                                            if (E = _ = h, h = _ = _ - 512 & -64, i = (A |= 0) || I) {
                                                if (t = -1, !tC(c = _ + 96 | 0, C, B)) {
                                                    for(C = I || A, A = 0, iC(I = _ + 128 | 0, 0, 0, 64), mC(I, c, 32, 0), XC(c, 32), mC(I, B, 32, 0), mC(I, g, 32, 0), rC(I, _ + 32 | 0, 64), XC(I, 384); g = (I = _ + 32 | 0) + A | 0, o[A + C | 0] = a[0 | g], o[A + i | 0] = a[g + 32 | 0], o[(B = 1 | A) + C | 0] = a[I + B | 0], o[B + i | 0] = a[g + 33 | 0], 32 != (0 | (A = A + 2 | 0)););
                                                    XC(I, 64), t = 0;
                                                }
                                                return h = E, 0 | t;
                                            }
                                            yC(), Q();
                                        },
                                        vd: BB,
                                        wd: BB,
                                        xd: BB,
                                        yd: BB,
                                        zd: function() {
                                            return 1315;
                                        },
                                        Ad: $C,
                                        Bd: CB,
                                        Cd: BB,
                                        Dd: Zg,
                                        Ed: Wg,
                                        Fd: function(A, I) {
                                            return 0 | fC(A |= 0, I |= 0);
                                        },
                                        Gd: BC,
                                        Hd: function(A, I) {
                                            return 0 | nC(A |= 0, I |= 0);
                                        },
                                        Id: function() {
                                            return 1496;
                                        },
                                        Jd: LC,
                                        Kd: Zg,
                                        Ld: Wg,
                                        Md: fC,
                                        Nd: BC,
                                        Od: nC,
                                        Pd: CB,
                                        Qd: BB,
                                        Rd: $C,
                                        Sd: LC,
                                        Td: rB,
                                        Ud: CB,
                                        Vd: tB,
                                        Wd: hB,
                                        Xd: tB,
                                        Yd: CB,
                                        Zd: AB,
                                        _d: function() {
                                            return 1549;
                                        },
                                        $d: yB,
                                        ae: tB,
                                        be: ZC,
                                        ce: RC,
                                        de: cB,
                                        ee: jC,
                                        fe: function() {
                                            return 6;
                                        },
                                        ge: function() {
                                            return 134217728;
                                        },
                                        he: sB,
                                        ie: function() {
                                            return 536870912;
                                        },
                                        je: function(A, I, g, C, B, Q, i, o, E, a, _) {
                                            return 0 | cI(A |= 0, (A = 0) | (I |= 0), g |= 0, C |= 0, A | (B |= 0), Q |= 0, i |= 0, A | (o |= 0), E |= 0, a |= 0, _ |= 0);
                                        },
                                        ke: function(A, I, g, C, B, Q, i) {
                                            return 0 | OI(A |= 0, I |= 0, (A = 0) | (g |= 0), C |= 0, A | (B |= 0), Q |= 0, i |= 0);
                                        },
                                        le: function(A, I, g, C) {
                                            return 0 | JC(A |= 0, I |= 0, g |= 0, C |= 0);
                                        },
                                        me: function(A, I, g, C) {
                                            return 0 | UC(A |= 0, I |= 0, g |= 0, C |= 0);
                                        },
                                        ne: function(A, I, g, C) {
                                            return 0 | lC(A |= 0, I |= 0, g |= 0, C |= 0);
                                        },
                                        oe: eB,
                                        pe: CB,
                                        qe: tB,
                                        re: hB,
                                        se: tB,
                                        te: CB,
                                        ue: AB,
                                        ve: OC,
                                        we: rB,
                                        xe: tB,
                                        ye: ZC,
                                        ze: RC,
                                        Ae: eB,
                                        Be: PC,
                                        Ce: yB,
                                        De: vC,
                                        Ee: cB,
                                        Fe: xC,
                                        Ge: function(A, I, g, C, B, Q, i, o, E, a, _) {
                                            return 0 | tI(A |= 0, (A = 0) | (I |= 0), g |= 0, C |= 0, A | (B |= 0), Q |= 0, i |= 0, A | (o |= 0), E |= 0, a |= 0, _ |= 0);
                                        },
                                        He: Ng,
                                        Ie: function(A, I, g, C) {
                                            return 0 | HC(A |= 0, I |= 0, g |= 0, C |= 0);
                                        },
                                        Je: rB,
                                        Ke: eB,
                                        Le: eB,
                                        Me: CB,
                                        Ne: tB,
                                        Oe: hB,
                                        Pe: tB,
                                        Qe: CB,
                                        Re: AB,
                                        Se: OC,
                                        Te: rB,
                                        Ue: tB,
                                        Ve: ZC,
                                        We: RC,
                                        Xe: eB,
                                        Ye: PC,
                                        Ze: yB,
                                        _e: vC,
                                        $e: cB,
                                        af: xC,
                                        bf: function(A, I, g, C, B, Q, i, o, a, _, c) {
                                            A |= 0, I |= 0, g |= 0, C |= 0, B |= 0, Q |= 0, i |= 0, o |= 0, a |= 0, _ |= 0, I |= 0, B |= 0, o |= 0;
                                            A: {
                                                switch((c |= 0) - 1 | 0){
                                                    case 0:
                                                        A = cI(A, I, g, C, B, Q, i, o, a, _, 1);
                                                        break A;
                                                    case 1:
                                                        A = tI(A, I, g, C, B, Q, i, o, a, _, 2);
                                                        break A;
                                                }
                                                E[9392] = 28, A = -1;
                                            }
                                            return 0 | A;
                                        },
                                        cf: Ng,
                                        df: function(A, I, g, C, B, i, o, E) {
                                            A |= 0, I |= 0, g |= 0, C |= 0, B |= 0, i |= 0, o |= 0, g |= 0, B |= 0;
                                            A: {
                                                switch((E |= 0) - 1 | 0){
                                                    case 1:
                                                        A = TI(A, I, g, C, B, i, o);
                                                        break A;
                                                    default:
                                                        yC(), Q();
                                                    case 0:
                                                }
                                                A = OI(A, I, g, C, B, i, o);
                                            }
                                            return 0 | A;
                                        },
                                        ef: function(A, I, g, C) {
                                            return I |= 0, g |= 0, C |= 0, Cg(A |= 0, 1559, 10) ? Cg(A, 1549, 9) ? (E[9392] = 28, A = -1) : A = JC(A, I, g, C) : A = HC(A, I, g, C), 0 | A;
                                        },
                                        ff: function(A, I, g, C) {
                                            return I |= 0, g |= 0, C |= 0, Cg(A |= 0, 1559, 10) ? Cg(A, 1549, 9) ? (E[9392] = 28, A = -1) : A = UC(A, I, g, C) : A = lC(A, I, g, C), 0 | A;
                                        },
                                        gf: function() {
                                            return 1157;
                                        },
                                        hf: function() {
                                            return 1438;
                                        },
                                        jf: bC,
                                        kf: tC,
                                        lf: BB,
                                        mf: BB,
                                        nf: gI,
                                        of: wC,
                                        pf: BB,
                                        qf: BB,
                                        rf: BB,
                                        sf: _B,
                                        tf: BB,
                                        uf: CB,
                                        vf: CB,
                                        wf: oB,
                                        xf: function() {
                                            return 1488;
                                        },
                                        yf: Pg,
                                        zf: qg,
                                        Af: LC,
                                        Bf: dg,
                                        Cf: function(A, I, g, C, B, i) {
                                            return A |= 0, I |= 0, B |= 0, i |= 0, !(C |= 0) & (g |= 0) >>> 0 >= 4294967280 | C && (yC(), Q()), eI(A + 16 | 0, A, I, g, C, B, i), 0;
                                        },
                                        Df: Jg,
                                        Ef: hg,
                                        Ff: Pg,
                                        Gf: qg,
                                        Hf: BB,
                                        If: _B,
                                        Jf: BB,
                                        Kf: CB,
                                        Lf: CB,
                                        Mf: oB,
                                        Nf: LC,
                                        Of: LC,
                                        Pf: function(A, I, g) {
                                            return A |= 0, g |= 0, ag(I |= 0, 24), yA(A, I, g, 0), o[A + 32 | 0] = 1, o[A + 33 | 0] = 0, o[A + 34 | 0] = 0, o[A + 35 | 0] = 0, g = a[I + 16 | 0] | a[I + 17 | 0] << 8 | a[I + 18 | 0] << 16 | a[I + 19 | 0] << 24, I = a[I + 20 | 0] | a[I + 21 | 0] << 8 | a[I + 22 | 0] << 16 | a[I + 23 | 0] << 24, o[A + 44 | 0] = 0, o[A + 45 | 0] = 0, o[A + 46 | 0] = 0, o[A + 47 | 0] = 0, o[A + 48 | 0] = 0, o[A + 49 | 0] = 0, o[A + 50 | 0] = 0, o[A + 51 | 0] = 0, o[A + 36 | 0] = g, o[A + 37 | 0] = g >>> 8, o[A + 38 | 0] = g >>> 16, o[A + 39 | 0] = g >>> 24, o[A + 40 | 0] = I, o[A + 41 | 0] = I >>> 8, o[A + 42 | 0] = I >>> 16, o[A + 43 | 0] = I >>> 24, 0;
                                        },
                                        Qf: function(A, I, g) {
                                            return yA(A |= 0, I |= 0, g |= 0, 0), o[A + 32 | 0] = 1, o[A + 33 | 0] = 0, o[A + 34 | 0] = 0, o[A + 35 | 0] = 0, g = a[I + 16 | 0] | a[I + 17 | 0] << 8 | a[I + 18 | 0] << 16 | a[I + 19 | 0] << 24, I = a[I + 20 | 0] | a[I + 21 | 0] << 8 | a[I + 22 | 0] << 16 | a[I + 23 | 0] << 24, o[A + 44 | 0] = 0, o[A + 45 | 0] = 0, o[A + 46 | 0] = 0, o[A + 47 | 0] = 0, o[A + 48 | 0] = 0, o[A + 49 | 0] = 0, o[A + 50 | 0] = 0, o[A + 51 | 0] = 0, o[A + 36 | 0] = g, o[A + 37 | 0] = g >>> 8, o[A + 38 | 0] = g >>> 16, o[A + 39 | 0] = g >>> 24, o[A + 40 | 0] = I, o[A + 41 | 0] = I >>> 8, o[A + 42 | 0] = I >>> 16, o[A + 43 | 0] = I >>> 24, 0;
                                        },
                                        Rf: function(A) {
                                            var I, g = 0, C = 0;
                                            h = I = h - 48 | 0, g = a[28 + (A |= 0) | 0] | a[A + 29 | 0] << 8 | a[A + 30 | 0] << 16 | a[A + 31 | 0] << 24, E[I + 24 >> 2] = a[A + 24 | 0] | a[A + 25 | 0] << 8 | a[A + 26 | 0] << 16 | a[A + 27 | 0] << 24, E[I + 28 >> 2] = g, g = a[A + 20 | 0] | a[A + 21 | 0] << 8 | a[A + 22 | 0] << 16 | a[A + 23 | 0] << 24, E[I + 16 >> 2] = a[A + 16 | 0] | a[A + 17 | 0] << 8 | a[A + 18 | 0] << 16 | a[A + 19 | 0] << 24, E[I + 20 >> 2] = g, g = a[A + 4 | 0] | a[A + 5 | 0] << 8 | a[A + 6 | 0] << 16 | a[A + 7 | 0] << 24, E[I >> 2] = a[0 | A] | a[A + 1 | 0] << 8 | a[A + 2 | 0] << 16 | a[A + 3 | 0] << 24, E[I + 4 >> 2] = g, g = a[A + 12 | 0] | a[A + 13 | 0] << 8 | a[A + 14 | 0] << 16 | a[A + 15 | 0] << 24, E[I + 8 >> 2] = a[A + 8 | 0] | a[A + 9 | 0] << 8 | a[A + 10 | 0] << 16 | a[A + 11 | 0] << 24, E[I + 12 >> 2] = g, g = a[A + 40 | 0] | a[A + 41 | 0] << 8 | a[A + 42 | 0] << 16 | a[A + 43 | 0] << 24, E[I + 32 >> 2] = a[A + 36 | 0] | a[A + 37 | 0] << 8 | a[A + 38 | 0] << 16 | a[A + 39 | 0] << 24, E[I + 36 >> 2] = g, xg(I, I, 40, 0, A + 32 | 0, A), g = E[I + 28 >> 2], C = E[I + 24 >> 2], o[A + 24 | 0] = C, o[A + 25 | 0] = C >>> 8, o[A + 26 | 0] = C >>> 16, o[A + 27 | 0] = C >>> 24, o[A + 28 | 0] = g, o[A + 29 | 0] = g >>> 8, o[A + 30 | 0] = g >>> 16, o[A + 31 | 0] = g >>> 24, g = E[I + 20 >> 2], C = E[I + 16 >> 2], o[A + 16 | 0] = C, o[A + 17 | 0] = C >>> 8, o[A + 18 | 0] = C >>> 16, o[A + 19 | 0] = C >>> 24, o[A + 20 | 0] = g, o[A + 21 | 0] = g >>> 8, o[A + 22 | 0] = g >>> 16, o[A + 23 | 0] = g >>> 24, g = E[I + 12 >> 2], C = E[I + 8 >> 2], o[A + 8 | 0] = C, o[A + 9 | 0] = C >>> 8, o[A + 10 | 0] = C >>> 16, o[A + 11 | 0] = C >>> 24, o[A + 12 | 0] = g, o[A + 13 | 0] = g >>> 8, o[A + 14 | 0] = g >>> 16, o[A + 15 | 0] = g >>> 24, g = E[I + 4 >> 2], C = E[I >> 2], o[0 | A] = C, o[A + 1 | 0] = C >>> 8, o[A + 2 | 0] = C >>> 16, o[A + 3 | 0] = C >>> 24, o[A + 4 | 0] = g, o[A + 5 | 0] = g >>> 8, o[A + 6 | 0] = g >>> 16, o[A + 7 | 0] = g >>> 24, C = E[I + 36 >> 2], g = E[I + 32 >> 2], o[A + 32 | 0] = 1, o[A + 33 | 0] = 0, o[A + 34 | 0] = 0, o[A + 35 | 0] = 0, o[A + 36 | 0] = g, o[A + 37 | 0] = g >>> 8, o[A + 38 | 0] = g >>> 16, o[A + 39 | 0] = g >>> 24, o[A + 40 | 0] = C, o[A + 41 | 0] = C >>> 8, o[A + 42 | 0] = C >>> 16, o[A + 43 | 0] = C >>> 24, h = I + 48 | 0;
                                        },
                                        Sf: function(A, I, g, C, B, i, _, c, t, r) {
                                            A |= 0, I |= 0, C |= 0, i |= 0, _ |= 0, t |= 0, r |= 0;
                                            var e, y = 0, s = 0, D = 0;
                                            return y = B |= 0, y |= B = 0, e = B | (c |= 0), h = B = h - 384 | 0, (g |= 0) && (E[g >> 2] = 0, E[g + 4 >> 2] = 0), !i & y >>> 0 < 4294967279 ? (Xg(s = B + 16 | 0, 64, 0, D = A + 32 | 0, A), fC(c = B + 80 | 0, s), XC(s, 64), NC(c, _, e, t), NC(c, 34384, 0 - e & 15, 0), E[B + 72 >> 2] = 0, E[B + 76 >> 2] = 0, E[(_ = B - -64 | 0) >> 2] = 0, E[_ + 4 >> 2] = 0, E[B + 56 >> 2] = 0, E[B + 60 >> 2] = 0, E[B + 48 >> 2] = 0, E[B + 52 >> 2] = 0, E[B + 40 >> 2] = 0, E[B + 44 >> 2] = 0, E[B + 32 >> 2] = 0, E[B + 36 >> 2] = 0, E[B + 16 >> 2] = 0, E[B + 20 >> 2] = 0, E[B + 24 >> 2] = 0, E[B + 28 >> 2] = 0, o[B + 16 | 0] = r, gg(s, s, 64, 0, D, 1, A), NC(c, s, 64, 0), o[0 | I] = a[B + 16 | 0], gg(I = I + 1 | 0, C, y, i, D, 2, A), NC(c, I, y, i), NC(c, 34384, 15 & y, 0), E[B + 8 >> 2] = e, E[B + 12 >> 2] = t, NC(c, C = B + 8 | 0, 8, 0), E[B + 8 >> 2] = y - -64, E[B + 12 >> 2] = i - ((y >>> 0 < 4294967232) - 1 | 0), NC(c, C, 8, 0), nC(c, I = I + y | 0), XC(c, 256), o[A + 36 | 0] = a[A + 36 | 0] ^ a[0 | I], o[A + 37 | 0] = a[A + 37 | 0] ^ a[I + 1 | 0], o[A + 38 | 0] = a[A + 38 | 0] ^ a[I + 2 | 0], o[A + 39 | 0] = a[A + 39 | 0] ^ a[I + 3 | 0], o[A + 40 | 0] = a[A + 40 | 0] ^ a[I + 4 | 0], o[A + 41 | 0] = a[A + 41 | 0] ^ a[I + 5 | 0], o[A + 42 | 0] = a[A + 42 | 0] ^ a[I + 6 | 0], o[A + 43 | 0] = a[A + 43 | 0] ^ a[I + 7 | 0], XI(D), (2 & r || NI(D, 4)) && (I = a[A + 28 | 0] | a[A + 29 | 0] << 8 | a[A + 30 | 0] << 16 | a[A + 31 | 0] << 24, E[B + 360 >> 2] = a[A + 24 | 0] | a[A + 25 | 0] << 8 | a[A + 26 | 0] << 16 | a[A + 27 | 0] << 24, E[B + 364 >> 2] = I, I = a[A + 20 | 0] | a[A + 21 | 0] << 8 | a[A + 22 | 0] << 16 | a[A + 23 | 0] << 24, E[B + 352 >> 2] = a[A + 16 | 0] | a[A + 17 | 0] << 8 | a[A + 18 | 0] << 16 | a[A + 19 | 0] << 24, E[B + 356 >> 2] = I, I = a[A + 4 | 0] | a[A + 5 | 0] << 8 | a[A + 6 | 0] << 16 | a[A + 7 | 0] << 24, E[B + 336 >> 2] = a[0 | A] | a[A + 1 | 0] << 8 | a[A + 2 | 0] << 16 | a[A + 3 | 0] << 24, E[B + 340 >> 2] = I, I = a[A + 12 | 0] | a[A + 13 | 0] << 8 | a[A + 14 | 0] << 16 | a[A + 15 | 0] << 24, E[B + 344 >> 2] = a[A + 8 | 0] | a[A + 9 | 0] << 8 | a[A + 10 | 0] << 16 | a[A + 11 | 0] << 24, E[B + 348 >> 2] = I, I = a[A + 40 | 0] | a[A + 41 | 0] << 8 | a[A + 42 | 0] << 16 | a[A + 43 | 0] << 24, E[B + 368 >> 2] = a[A + 36 | 0] | a[A + 37 | 0] << 8 | a[A + 38 | 0] << 16 | a[A + 39 | 0] << 24, E[B + 372 >> 2] = I, xg(I = B + 336 | 0, I, 40, 0, D, A), I = E[B + 364 >> 2], C = E[B + 360 >> 2], o[A + 24 | 0] = C, o[A + 25 | 0] = C >>> 8, o[A + 26 | 0] = C >>> 16, o[A + 27 | 0] = C >>> 24, o[A + 28 | 0] = I, o[A + 29 | 0] = I >>> 8, o[A + 30 | 0] = I >>> 16, o[A + 31 | 0] = I >>> 24, I = E[B + 356 >> 2], C = E[B + 352 >> 2], o[A + 16 | 0] = C, o[A + 17 | 0] = C >>> 8, o[A + 18 | 0] = C >>> 16, o[A + 19 | 0] = C >>> 24, o[A + 20 | 0] = I, o[A + 21 | 0] = I >>> 8, o[A + 22 | 0] = I >>> 16, o[A + 23 | 0] = I >>> 24, I = E[B + 348 >> 2], C = E[B + 344 >> 2], o[A + 8 | 0] = C, o[A + 9 | 0] = C >>> 8, o[A + 10 | 0] = C >>> 16, o[A + 11 | 0] = C >>> 24, o[A + 12 | 0] = I, o[A + 13 | 0] = I >>> 8, o[A + 14 | 0] = I >>> 16, o[A + 15 | 0] = I >>> 24, I = E[B + 340 >> 2], C = E[B + 336 >> 2], o[0 | A] = C, o[A + 1 | 0] = C >>> 8, o[A + 2 | 0] = C >>> 16, o[A + 3 | 0] = C >>> 24, o[A + 4 | 0] = I, o[A + 5 | 0] = I >>> 8, o[A + 6 | 0] = I >>> 16, o[A + 7 | 0] = I >>> 24, I = E[B + 368 >> 2], C = E[B + 372 >> 2], o[A + 32 | 0] = 1, o[A + 33 | 0] = 0, o[A + 34 | 0] = 0, o[A + 35 | 0] = 0, o[A + 36 | 0] = I, o[A + 37 | 0] = I >>> 8, o[A + 38 | 0] = I >>> 16, o[A + 39 | 0] = I >>> 24, o[A + 40 | 0] = C, o[A + 41 | 0] = C >>> 8, o[A + 42 | 0] = C >>> 16, o[A + 43 | 0] = C >>> 24), g && (i = (A = y + 17 | 0) >>> 0 < 17 ? i + 1 | 0 : i, E[g >> 2] = A, E[g + 4 >> 2] = i), h = B + 384 | 0) : (yC(), Q()), 0;
                                        },
                                        Tf: function(A, I, g, C, B, i, _, c, t, r) {
                                            A |= 0, I |= 0, C |= 0, B |= 0, c |= 0, r |= 0;
                                            var e, y = 0, s = 0, D = 0, p = 0, w = 0, f = 0;
                                            y = i |= 0, i = _ |= 0, s = 0 | y, e = t |= 0, h = _ = h - 400 | 0, (g |= 0) && (E[g >> 2] = 0, E[g + 4 >> 2] = 0), C && (o[0 | C] = 255), f = -1;
                                            A: {
                                                I: {
                                                    if (!((t = s >>> 0 < 17) & !i)) {
                                                        if (w = y = i - t | 0, !y & (t = s - 17 | 0) >>> 0 >= 4294967279 | y) break I;
                                                        Xg(D = _ + 32 | 0, 64, 0, p = A + 32 | 0, A), fC(y = _ + 96 | 0, D), XC(D, 64), NC(y, c, e, r), NC(y, 34384, 0 - e & 15, 0), E[_ + 88 >> 2] = 0, E[_ + 92 >> 2] = 0, E[_ + 80 >> 2] = 0, E[_ + 84 >> 2] = 0, E[_ + 72 >> 2] = 0, E[_ + 76 >> 2] = 0, E[(c = _ - -64 | 0) >> 2] = 0, E[c + 4 >> 2] = 0, E[_ + 56 >> 2] = 0, E[_ + 60 >> 2] = 0, E[_ + 48 >> 2] = 0, E[_ + 52 >> 2] = 0, E[_ + 40 >> 2] = 0, E[_ + 44 >> 2] = 0, E[_ + 32 >> 2] = 0, E[_ + 36 >> 2] = 0, o[_ + 32 | 0] = a[0 | B], gg(D, D, 64, 0, p, 1, A), c = a[_ + 32 | 0], o[_ + 32 | 0] = a[0 | B], NC(y, D, 64, 0), NC(y, B = B + 1 | 0, t, w), NC(y, 34384, s - 1 & 15, 0), E[_ + 24 >> 2] = e, E[_ + 28 >> 2] = r, NC(y, r = _ + 24 | 0, 8, 0), i = (s = s + 47 | 0) >>> 0 < 47 ? i + 1 | 0 : i, E[_ + 24 >> 2] = s, E[_ + 28 >> 2] = i, NC(y, r, 8, 0), nC(y, _), XC(y, 256), MI(_, B + t | 0, 16) ? XC(_, 16) : (gg(I, B, t, w, p, 2, A), o[A + 36 | 0] = a[A + 36 | 0] ^ a[0 | _], o[A + 37 | 0] = a[A + 37 | 0] ^ a[_ + 1 | 0], o[A + 38 | 0] = a[A + 38 | 0] ^ a[_ + 2 | 0], o[A + 39 | 0] = a[A + 39 | 0] ^ a[_ + 3 | 0], o[A + 40 | 0] = a[A + 40 | 0] ^ a[_ + 4 | 0], o[A + 41 | 0] = a[A + 41 | 0] ^ a[_ + 5 | 0], o[A + 42 | 0] = a[A + 42 | 0] ^ a[_ + 6 | 0], o[A + 43 | 0] = a[A + 43 | 0] ^ a[_ + 7 | 0], XI(p), (2 & c || NI(p, 4)) && (I = a[A + 28 | 0] | a[A + 29 | 0] << 8 | a[A + 30 | 0] << 16 | a[A + 31 | 0] << 24, E[_ + 376 >> 2] = a[A + 24 | 0] | a[A + 25 | 0] << 8 | a[A + 26 | 0] << 16 | a[A + 27 | 0] << 24, E[_ + 380 >> 2] = I, I = a[A + 20 | 0] | a[A + 21 | 0] << 8 | a[A + 22 | 0] << 16 | a[A + 23 | 0] << 24, E[_ + 368 >> 2] = a[A + 16 | 0] | a[A + 17 | 0] << 8 | a[A + 18 | 0] << 16 | a[A + 19 | 0] << 24, E[_ + 372 >> 2] = I, I = a[A + 4 | 0] | a[A + 5 | 0] << 8 | a[A + 6 | 0] << 16 | a[A + 7 | 0] << 24, E[_ + 352 >> 2] = a[0 | A] | a[A + 1 | 0] << 8 | a[A + 2 | 0] << 16 | a[A + 3 | 0] << 24, E[_ + 356 >> 2] = I, I = a[A + 12 | 0] | a[A + 13 | 0] << 8 | a[A + 14 | 0] << 16 | a[A + 15 | 0] << 24, E[_ + 360 >> 2] = a[A + 8 | 0] | a[A + 9 | 0] << 8 | a[A + 10 | 0] << 16 | a[A + 11 | 0] << 24, E[_ + 364 >> 2] = I, I = a[A + 40 | 0] | a[A + 41 | 0] << 8 | a[A + 42 | 0] << 16 | a[A + 43 | 0] << 24, E[_ + 384 >> 2] = a[A + 36 | 0] | a[A + 37 | 0] << 8 | a[A + 38 | 0] << 16 | a[A + 39 | 0] << 24, E[_ + 388 >> 2] = I, xg(I = _ + 352 | 0, I, 40, 0, p, A), I = E[_ + 380 >> 2], B = E[_ + 376 >> 2], o[A + 24 | 0] = B, o[A + 25 | 0] = B >>> 8, o[A + 26 | 0] = B >>> 16, o[A + 27 | 0] = B >>> 24, o[A + 28 | 0] = I, o[A + 29 | 0] = I >>> 8, o[A + 30 | 0] = I >>> 16, o[A + 31 | 0] = I >>> 24, I = E[_ + 372 >> 2], B = E[_ + 368 >> 2], o[A + 16 | 0] = B, o[A + 17 | 0] = B >>> 8, o[A + 18 | 0] = B >>> 16, o[A + 19 | 0] = B >>> 24, o[A + 20 | 0] = I, o[A + 21 | 0] = I >>> 8, o[A + 22 | 0] = I >>> 16, o[A + 23 | 0] = I >>> 24, I = E[_ + 364 >> 2], B = E[_ + 360 >> 2], o[A + 8 | 0] = B, o[A + 9 | 0] = B >>> 8, o[A + 10 | 0] = B >>> 16, o[A + 11 | 0] = B >>> 24, o[A + 12 | 0] = I, o[A + 13 | 0] = I >>> 8, o[A + 14 | 0] = I >>> 16, o[A + 15 | 0] = I >>> 24, I = E[_ + 356 >> 2], B = E[_ + 352 >> 2], o[0 | A] = B, o[A + 1 | 0] = B >>> 8, o[A + 2 | 0] = B >>> 16, o[A + 3 | 0] = B >>> 24, o[A + 4 | 0] = I, o[A + 5 | 0] = I >>> 8, o[A + 6 | 0] = I >>> 16, o[A + 7 | 0] = I >>> 24, I = E[_ + 384 >> 2], B = E[_ + 388 >> 2], o[A + 32 | 0] = 1, o[A + 33 | 0] = 0, o[A + 34 | 0] = 0, o[A + 35 | 0] = 0, o[A + 36 | 0] = I, o[A + 37 | 0] = I >>> 8, o[A + 38 | 0] = I >>> 16, o[A + 39 | 0] = I >>> 24, o[A + 40 | 0] = B, o[A + 41 | 0] = B >>> 8, o[A + 42 | 0] = B >>> 16, o[A + 43 | 0] = B >>> 24), g && (E[g >> 2] = t, E[g + 4 >> 2] = w), f = 0, C && (o[0 | C] = c));
                                                    }
                                                    h = _ + 400 | 0;
                                                    break A;
                                                }
                                                yC(), Q();
                                            }
                                            return 0 | f;
                                        },
                                        Uf: function() {
                                            return 52;
                                        },
                                        Vf: function() {
                                            return 17;
                                        },
                                        Wf: _B,
                                        Xf: BB,
                                        Yf: function() {
                                            return -18;
                                        },
                                        Zf: hB,
                                        _f: rB,
                                        $f: eB,
                                        ag: yB,
                                        bg: sB,
                                        cg: CB,
                                        dg: function() {
                                            return 1523;
                                        },
                                        eg: W,
                                        fg: qC,
                                        gg: sB,
                                        hg: CB,
                                        ig: W,
                                        jg: IB,
                                        kg: gB,
                                        lg: BB,
                                        mg: BB,
                                        ng: gB,
                                        og: iB,
                                        pg: function() {
                                            return 1449;
                                        },
                                        qg: function(A, I, g) {
                                            return 0 | NA(A |= 0, I |= 0, g |= 0);
                                        },
                                        rg: function(A, I) {
                                            return 0 | YA(A |= 0, I |= 0);
                                        },
                                        sg: vI,
                                        tg: HI,
                                        ug: Rg,
                                        vg: Vg,
                                        wg: function(A) {
                                            return 0 | uC(A |= 0);
                                        },
                                        xg: QC,
                                        yg: function(A, I, g, C) {
                                            return 0 | ng(A |= 0, I |= 0, g |= 0, C |= 0);
                                        },
                                        zg: function(A, I, g) {
                                            return 0 | bg(A |= 0, I |= 0, g |= 0);
                                        },
                                        Ag: IB,
                                        Bg: gB,
                                        Cg: BB,
                                        Dg: BB,
                                        Eg: gB,
                                        Fg: iB,
                                        Gg: function(A, I) {
                                            A |= 0;
                                            var g, C, B, Q, i, E, _ = 0;
                                            return g = a[8 + (_ = I |= 0) | 0] | a[_ + 9 | 0] << 8 | a[_ + 10 | 0] << 16 | a[_ + 11 | 0] << 24, C = a[_ + 12 | 0] | a[_ + 13 | 0] << 8 | a[_ + 14 | 0] << 16 | a[_ + 15 | 0] << 24, B = a[_ + 16 | 0] | a[_ + 17 | 0] << 8 | a[_ + 18 | 0] << 16 | a[_ + 19 | 0] << 24, Q = a[_ + 20 | 0] | a[_ + 21 | 0] << 8 | a[_ + 22 | 0] << 16 | a[_ + 23 | 0] << 24, i = a[0 | _] | a[_ + 1 | 0] << 8 | a[_ + 2 | 0] << 16 | a[_ + 3 | 0] << 24, I = a[_ + 4 | 0] | a[_ + 5 | 0] << 8 | a[_ + 6 | 0] << 16 | a[_ + 7 | 0] << 24, E = a[_ + 28 | 0] | a[_ + 29 | 0] << 8 | a[_ + 30 | 0] << 16 | a[_ + 31 | 0] << 24, _ = a[_ + 24 | 0] | a[_ + 25 | 0] << 8 | a[_ + 26 | 0] << 16 | a[_ + 27 | 0] << 24, o[A + 24 | 0] = _, o[A + 25 | 0] = _ >>> 8, o[A + 26 | 0] = _ >>> 16, o[A + 27 | 0] = _ >>> 24, o[A + 28 | 0] = E, o[A + 29 | 0] = E >>> 8, o[A + 30 | 0] = E >>> 16, o[A + 31 | 0] = E >>> 24, o[A + 16 | 0] = B, o[A + 17 | 0] = B >>> 8, o[A + 18 | 0] = B >>> 16, o[A + 19 | 0] = B >>> 24, o[A + 20 | 0] = Q, o[A + 21 | 0] = Q >>> 8, o[A + 22 | 0] = Q >>> 16, o[A + 23 | 0] = Q >>> 24, o[A + 8 | 0] = g, o[A + 9 | 0] = g >>> 8, o[A + 10 | 0] = g >>> 16, o[A + 11 | 0] = g >>> 24, o[A + 12 | 0] = C, o[A + 13 | 0] = C >>> 8, o[A + 14 | 0] = C >>> 16, o[A + 15 | 0] = C >>> 24, o[0 | A] = i, o[A + 1 | 0] = i >>> 8, o[A + 2 | 0] = i >>> 16, o[A + 3 | 0] = i >>> 24, o[A + 4 | 0] = I, o[A + 5 | 0] = I >>> 8, o[A + 6 | 0] = I >>> 16, o[A + 7 | 0] = I >>> 24, 0;
                                        },
                                        Hg: function(A, I) {
                                            A |= 0;
                                            var g, C, B, Q, i, E, _ = 0;
                                            return g = a[32 + (_ = I |= 0) | 0] | a[_ + 33 | 0] << 8 | a[_ + 34 | 0] << 16 | a[_ + 35 | 0] << 24, C = a[_ + 36 | 0] | a[_ + 37 | 0] << 8 | a[_ + 38 | 0] << 16 | a[_ + 39 | 0] << 24, B = a[_ + 40 | 0] | a[_ + 41 | 0] << 8 | a[_ + 42 | 0] << 16 | a[_ + 43 | 0] << 24, Q = a[_ + 44 | 0] | a[_ + 45 | 0] << 8 | a[_ + 46 | 0] << 16 | a[_ + 47 | 0] << 24, i = a[_ + 48 | 0] | a[_ + 49 | 0] << 8 | a[_ + 50 | 0] << 16 | a[_ + 51 | 0] << 24, I = a[_ + 52 | 0] | a[_ + 53 | 0] << 8 | a[_ + 54 | 0] << 16 | a[_ + 55 | 0] << 24, E = a[_ + 60 | 0] | a[_ + 61 | 0] << 8 | a[_ + 62 | 0] << 16 | a[_ + 63 | 0] << 24, _ = a[_ + 56 | 0] | a[_ + 57 | 0] << 8 | a[_ + 58 | 0] << 16 | a[_ + 59 | 0] << 24, o[A + 24 | 0] = _, o[A + 25 | 0] = _ >>> 8, o[A + 26 | 0] = _ >>> 16, o[A + 27 | 0] = _ >>> 24, o[A + 28 | 0] = E, o[A + 29 | 0] = E >>> 8, o[A + 30 | 0] = E >>> 16, o[A + 31 | 0] = E >>> 24, o[A + 16 | 0] = i, o[A + 17 | 0] = i >>> 8, o[A + 18 | 0] = i >>> 16, o[A + 19 | 0] = i >>> 24, o[A + 20 | 0] = I, o[A + 21 | 0] = I >>> 8, o[A + 22 | 0] = I >>> 16, o[A + 23 | 0] = I >>> 24, o[A + 8 | 0] = B, o[A + 9 | 0] = B >>> 8, o[A + 10 | 0] = B >>> 16, o[A + 11 | 0] = B >>> 24, o[A + 12 | 0] = Q, o[A + 13 | 0] = Q >>> 8, o[A + 14 | 0] = Q >>> 16, o[A + 15 | 0] = Q >>> 24, o[0 | A] = g, o[A + 1 | 0] = g >>> 8, o[A + 2 | 0] = g >>> 16, o[A + 3 | 0] = g >>> 24, o[A + 4 | 0] = C, o[A + 5 | 0] = C >>> 8, o[A + 6 | 0] = C >>> 16, o[A + 7 | 0] = C >>> 24, 0;
                                        },
                                        Ig: uC,
                                        Jg: QC,
                                        Kg: ng,
                                        Lg: bg,
                                        Mg: NA,
                                        Ng: YA,
                                        Og: function(A, I) {
                                            A |= 0;
                                            var g, C = 0, B = 0, Q = 0, i = 0, o = 0, a = 0, _ = 0, t = 0, r = 0, e = 0, y = 0, s = 0, D = 0, p = 0, f = 0, n = 0, k = 0, F = 0, N = 0, S = 0, G = 0, M = 0, b = 0, K = 0, H = 0, Y = 0, d = 0, J = 0, U = 0, l = 0, m = 0, u = 0, x = 0, R = 0, v = 0, L = 0, P = 0, q = 0, z = 0, j = 0, X = 0, O = 0, V = 0, Z = 0, W = 0, T = 0, $ = 0, AA = 0, gA = 0, CA = 0, BA = 0, QA = 0, iA = 0, oA = 0, EA = 0, aA = 0, _A = 0, cA = 0, tA = 0, rA = 0, eA = 0, yA = 0, sA = 0, hA = 0, DA = 0, pA = 0, wA = 0, fA = 0, nA = 0, kA = 0, FA = 0, NA = 0, SA = 0, GA = 0, MA = 0, bA = 0, KA = 0, HA = 0, YA = 0, dA = 0;
                                            return h = g = h - 256 | 0, NA = -1, bI(I |= 0) || qA(C = g + 96 | 0, I) || IA(C) && (Q = E[g + 136 >> 2], E[g >> 2] = 1 - Q, NA = 0, u = E[g + 172 >> 2], E[g + 36 >> 2] = 0 - u, n = E[g + 168 >> 2], E[g + 32 >> 2] = 0 - n, x = E[g + 164 >> 2], E[g + 28 >> 2] = 0 - x, k = E[g + 160 >> 2], E[g + 24 >> 2] = 0 - k, R = E[g + 156 >> 2], E[g + 20 >> 2] = 0 - R, F = E[g + 152 >> 2], E[g + 16 >> 2] = 0 - F, v = E[g + 148 >> 2], E[g + 12 >> 2] = 0 - v, N = E[g + 144 >> 2], E[g + 8 >> 2] = 0 - N, L = E[g + 140 >> 2], E[g + 4 >> 2] = 0 - L, vA(g, g), I = Ig(S = E[g + 4 >> 2], U = S >> 31, G = R << 1, gA = G >> 31), C = w, B = Ig(p = E[g >> 2], M = p >> 31, k, b = k >> 31), C = w + C | 0, C = (I = B + I | 0) >>> 0 < B >>> 0 ? C + 1 | 0 : C, B = (i = Ig(K = E[g + 8 >> 2], P = K >> 31, F, H = F >> 31)) + I | 0, I = w + C | 0, I = B >>> 0 < i >>> 0 ? I + 1 | 0 : I, C = B, B = Ig(l = E[g + 12 >> 2], j = l >> 31, V = v << 1, CA = V >> 31), I = w + I | 0, I = (C = C + B | 0) >>> 0 < B >>> 0 ? I + 1 | 0 : I, B = Ig(q = E[g + 16 >> 2], Z = q >> 31, N, Y = N >> 31), I = w + I | 0, I = (C = B + C | 0) >>> 0 < B >>> 0 ? I + 1 | 0 : I, pA = i = E[g + 20 >> 2], s = Ig(i, BA = i >> 31, W = L << 1, QA = W >> 31), B = w + I | 0, B = (C = s + C | 0) >>> 0 < s >>> 0 ? B + 1 | 0 : B, wA = r = E[g + 24 >> 2], I = (Q = Ig(r, sA = r >> 31, s = Q + 1 | 0, d = s >> 31)) + C | 0, C = w + B | 0, C = I >>> 0 < Q >>> 0 ? C + 1 | 0 : C, iA = E[g + 28 >> 2], B = (Q = Ig(f = c(iA, 19), X = f >> 31, T = u << 1, oA = T >> 31)) + I | 0, I = w + C | 0, I = B >>> 0 < Q >>> 0 ? I + 1 | 0 : I, C = B, SA = E[g + 32 >> 2], B = Ig(a = c(SA, 19), z = a >> 31, n, J = n >> 31), I = w + I | 0, I = (C = C + B | 0) >>> 0 < B >>> 0 ? I + 1 | 0 : I, GA = E[g + 36 >> 2], B = Ig(y = c(GA, 19), m = y >> 31, $ = x << 1, EA = $ >> 31), I = w + I | 0, _ = C = B + C | 0, Q = C >>> 0 < B >>> 0 ? I + 1 | 0 : I, I = Ig(F, H, S, U), C = w, o = Ig(p, M, R, aA = R >> 31), B = w + C | 0, B = (I = o + I | 0) >>> 0 < o >>> 0 ? B + 1 | 0 : B, o = Ig(K, P, v, _A = v >> 31), C = w + B | 0, C = (I = o + I | 0) >>> 0 < o >>> 0 ? C + 1 | 0 : C, B = (o = Ig(N, Y, l, j)) + I | 0, I = w + C | 0, I = B >>> 0 < o >>> 0 ? I + 1 | 0 : I, C = B, B = Ig(q, Z, L, cA = L >> 31), I = w + I | 0, I = (C = C + B | 0) >>> 0 < B >>> 0 ? I + 1 | 0 : I, B = Ig(s, d, i, BA), I = w + I | 0, I = (C = B + C | 0) >>> 0 < B >>> 0 ? I + 1 | 0 : I, o = Ig(r = c(r, 19), AA = r >> 31, u, tA = u >> 31), B = w + I | 0, B = (C = o + C | 0) >>> 0 < o >>> 0 ? B + 1 | 0 : B, I = (o = Ig(n, J, f, X)) + C | 0, C = w + B | 0, C = I >>> 0 < o >>> 0 ? C + 1 | 0 : C, B = (o = Ig(a, z, x, rA = x >> 31)) + I | 0, I = w + C | 0, I = B >>> 0 < o >>> 0 ? I + 1 | 0 : I, C = B, B = Ig(y, m, k, b), I = w + I | 0, fA = C = C + B | 0, O = C >>> 0 < B >>> 0 ? I + 1 | 0 : I, I = Ig(S, U, V, CA), B = w, C = (o = Ig(p, M, F, H)) + I | 0, I = w + B | 0, I = C >>> 0 < o >>> 0 ? I + 1 | 0 : I, o = Ig(N, Y, K, P), B = w + I | 0, B = (C = o + C | 0) >>> 0 < o >>> 0 ? B + 1 | 0 : B, I = (o = Ig(l, j, W, QA)) + C | 0, C = w + B | 0, C = I >>> 0 < o >>> 0 ? C + 1 | 0 : C, B = (o = Ig(s, d, q, Z)) + I | 0, I = w + C | 0, I = B >>> 0 < o >>> 0 ? I + 1 | 0 : I, C = B, B = Ig(o = c(i, 19), eA = o >> 31, T, oA), I = w + I | 0, I = (C = C + B | 0) >>> 0 < B >>> 0 ? I + 1 | 0 : I, B = Ig(n, J, r, AA), I = w + I | 0, I = (C = B + C | 0) >>> 0 < B >>> 0 ? I + 1 | 0 : I, i = Ig(f, X, $, EA), B = w + I | 0, B = (C = i + C | 0) >>> 0 < i >>> 0 ? B + 1 | 0 : B, I = (i = Ig(a, z, k, b)) + C | 0, C = w + B | 0, C = I >>> 0 < i >>> 0 ? C + 1 | 0 : C, B = (i = Ig(y, m, G, gA)) + I | 0, I = w + C | 0, MA = B, bA = I = B >>> 0 < i >>> 0 ? I + 1 | 0 : I, KA = B = B + 33554432 | 0, HA = I = B >>> 0 < 33554432 ? I + 1 | 0 : I, B = (67108863 & I) << 6 | B >>> 26, I = (I >> 26) + O | 0, fA = i = B + fA | 0, I = B >>> 0 > i >>> 0 ? I + 1 | 0 : I, YA = i = i + 16777216 | 0, I = (C = (B = i >>> 0 < 16777216 ? I + 1 | 0 : I) >> 25) + Q | 0, I = (B = (i = (33554431 & B) << 7 | i >>> 25) + _ | 0) >>> 0 < i >>> 0 ? I + 1 | 0 : I, D = C = B + 33554432 | 0, i = I = C >>> 0 < 33554432 ? I + 1 | 0 : I, E[g + 72 >> 2] = B - (-67108864 & C), I = Ig(S, U, W, QA), C = w, Q = Ig(p, M, N, Y), B = w + C | 0, B = (I = Q + I | 0) >>> 0 < Q >>> 0 ? B + 1 | 0 : B, C = (Q = Ig(s, d, K, P)) + I | 0, I = w + B | 0, I = C >>> 0 < Q >>> 0 ? I + 1 | 0 : I, B = Ig(Q = c(l, 19), yA = Q >> 31, T, oA), I = w + I | 0, I = (C = B + C | 0) >>> 0 < B >>> 0 ? I + 1 | 0 : I, B = (_ = Ig(O = c(q, 19), hA = O >> 31, n, J)) + C | 0, C = w + I | 0, C = B >>> 0 < _ >>> 0 ? C + 1 | 0 : C, _ = Ig($, EA, o, eA), I = w + C | 0, I = (B = _ + B | 0) >>> 0 < _ >>> 0 ? I + 1 | 0 : I, C = (_ = Ig(k, b, r, AA)) + B | 0, B = w + I | 0, B = C >>> 0 < _ >>> 0 ? B + 1 | 0 : B, _ = Ig(f, X, G, gA), I = w + B | 0, I = (C = _ + C | 0) >>> 0 < _ >>> 0 ? I + 1 | 0 : I, B = Ig(a, z, F, H), I = w + I | 0, I = (C = B + C | 0) >>> 0 < B >>> 0 ? I + 1 | 0 : I, B = (_ = Ig(y, m, V, CA)) + C | 0, C = w + I | 0, e = B, nA = B >>> 0 < _ >>> 0 ? C + 1 | 0 : C, I = Ig(s, d, S, U), C = w, B = (_ = Ig(p, M, L, cA)) + I | 0, I = w + C | 0, I = B >>> 0 < _ >>> 0 ? I + 1 | 0 : I, _ = C = c(K, 19), C = (t = Ig(C, DA = C >> 31, u, tA)) + B | 0, B = w + I | 0, B = C >>> 0 < t >>> 0 ? B + 1 | 0 : B, t = Ig(n, J, Q, yA), I = w + B | 0, I = (C = t + C | 0) >>> 0 < t >>> 0 ? I + 1 | 0 : I, B = Ig(O, hA, x, rA), I = w + I | 0, I = (C = B + C | 0) >>> 0 < B >>> 0 ? I + 1 | 0 : I, B = (t = Ig(k, b, o, eA)) + C | 0, C = w + I | 0, C = B >>> 0 < t >>> 0 ? C + 1 | 0 : C, t = Ig(r, AA, R, aA), I = w + C | 0, I = (B = t + B | 0) >>> 0 < t >>> 0 ? I + 1 | 0 : I, C = (t = Ig(F, H, f, X)) + B | 0, B = w + I | 0, B = C >>> 0 < t >>> 0 ? B + 1 | 0 : B, t = Ig(a, z, v, _A), I = w + B | 0, I = (C = t + C | 0) >>> 0 < t >>> 0 ? I + 1 | 0 : I, B = Ig(y, m, N, Y), I = w + I | 0, kA = C = B + C | 0, t = C >>> 0 < B >>> 0 ? I + 1 | 0 : I, I = Ig(I = c(S, 19), I >> 31, T, oA), C = w, B = Ig(p, M, s, d), C = w + C | 0, C = (I = B + I | 0) >>> 0 < B >>> 0 ? C + 1 | 0 : C, B = (_ = Ig(n, J, _, DA)) + I | 0, I = w + C | 0, C = (Q = Ig(Q, yA, $, EA)) + B | 0, B = w + (B >>> 0 < _ >>> 0 ? I + 1 | 0 : I) | 0, B = C >>> 0 < Q >>> 0 ? B + 1 | 0 : B, Q = Ig(k, b, O, hA), I = w + B | 0, I = (C = Q + C | 0) >>> 0 < Q >>> 0 ? I + 1 | 0 : I, B = Ig(G, gA, o, eA), I = w + I | 0, I = (C = B + C | 0) >>> 0 < B >>> 0 ? I + 1 | 0 : I, B = (Q = Ig(F, H, r, AA)) + C | 0, C = w + I | 0, C = B >>> 0 < Q >>> 0 ? C + 1 | 0 : C, Q = Ig(f, X, V, CA), I = w + C | 0, I = (B = Q + B | 0) >>> 0 < Q >>> 0 ? I + 1 | 0 : I, C = (Q = Ig(a, z, N, Y)) + B | 0, B = w + I | 0, B = C >>> 0 < Q >>> 0 ? B + 1 | 0 : B, Q = Ig(y, m, W, QA), I = w + B | 0, _ = C = Q + C | 0, yA = I = C >>> 0 < Q >>> 0 ? I + 1 | 0 : I, DA = C = C + 33554432 | 0, dA = I = C >>> 0 < 33554432 ? I + 1 | 0 : I, B = I >> 26, I = (67108863 & I) << 6 | C >>> 26, C = B + t | 0, t = Q = I + kA | 0, I = C = I >>> 0 > Q >>> 0 ? C + 1 | 0 : C, kA = Q = Q + 16777216 | 0, Q = (33554431 & (I = Q >>> 0 < 16777216 ? I + 1 | 0 : I)) << 7 | Q >>> 25, I = (I >> 25) + nA | 0, I = (C = Q + e | 0) >>> 0 < Q >>> 0 ? I + 1 | 0 : I, B = C, nA = C = C + 33554432 | 0, Q = I = C >>> 0 < 33554432 ? I + 1 | 0 : I, E[g + 56 >> 2] = B - (-67108864 & C), I = Ig(k, b, S, U), B = w, C = (e = Ig(p, M, x, rA)) + I | 0, I = w + B | 0, I = C >>> 0 < e >>> 0 ? I + 1 | 0 : I, B = Ig(K, P, R, aA), I = w + I | 0, I = (C = B + C | 0) >>> 0 < B >>> 0 ? I + 1 | 0 : I, B = Ig(F, H, l, j), I = w + I | 0, I = (C = B + C | 0) >>> 0 < B >>> 0 ? I + 1 | 0 : I, e = Ig(q, Z, v, _A), B = w + I | 0, B = (C = e + C | 0) >>> 0 < e >>> 0 ? B + 1 | 0 : B, I = (e = Ig(N, Y, pA, BA)) + C | 0, C = w + B | 0, C = I >>> 0 < e >>> 0 ? C + 1 | 0 : C, B = (e = Ig(L, cA, wA, sA)) + I | 0, I = w + C | 0, I = B >>> 0 < e >>> 0 ? I + 1 | 0 : I, C = B, B = Ig(iA, FA = iA >> 31, s, d), I = w + I | 0, I = (C = C + B | 0) >>> 0 < B >>> 0 ? I + 1 | 0 : I, B = Ig(a, z, u, tA), I = w + I | 0, I = (C = B + C | 0) >>> 0 < B >>> 0 ? I + 1 | 0 : I, e = (B = C) + (C = Ig(y, m, n, J)) | 0, B = w + I | 0, C = (I = i >> 26) + (C = C >>> 0 > e >>> 0 ? B + 1 | 0 : B) | 0, D = B = (i = (67108863 & i) << 6 | D >>> 26) + e | 0, I = C = B >>> 0 < i >>> 0 ? C + 1 | 0 : C, e = B = B + 16777216 | 0, i = I = B >>> 0 < 16777216 ? I + 1 | 0 : I, E[g + 76 >> 2] = D - (-33554432 & B), I = Ig(N, Y, S, U), C = w, D = Ig(p, M, v, _A), B = w + C | 0, B = (I = D + I | 0) >>> 0 < D >>> 0 ? B + 1 | 0 : B, D = Ig(K, P, L, cA), C = w + B | 0, C = (I = D + I | 0) >>> 0 < D >>> 0 ? C + 1 | 0 : C, B = (D = Ig(s, d, l, j)) + I | 0, I = w + C | 0, I = B >>> 0 < D >>> 0 ? I + 1 | 0 : I, C = B, B = Ig(O, hA, u, tA), I = w + I | 0, I = (C = C + B | 0) >>> 0 < B >>> 0 ? I + 1 | 0 : I, B = Ig(n, J, o, eA), I = w + I | 0, I = (C = B + C | 0) >>> 0 < B >>> 0 ? I + 1 | 0 : I, C = (r = Ig(r, AA, x, rA)) + C | 0, B = w + I | 0, I = (f = Ig(k, b, f, X)) + C | 0, C = w + (C >>> 0 < r >>> 0 ? B + 1 | 0 : B) | 0, B = (a = Ig(a, z, R, aA)) + I | 0, I = w + (I >>> 0 < f >>> 0 ? C + 1 | 0 : C) | 0, I = B >>> 0 < a >>> 0 ? I + 1 | 0 : I, C = B, B = Ig(y, m, F, H), I = w + I | 0, D = C = C + B | 0, I = (I = C >>> 0 < B >>> 0 ? I + 1 | 0 : I) + (C = Q >> 26) | 0, a = Q = D + (B = (67108863 & Q) << 6 | nA >>> 26) | 0, I = B >>> 0 > Q >>> 0 ? I + 1 | 0 : I, f = C = Q + 16777216 | 0, Q = B = C >>> 0 < 16777216 ? I + 1 | 0 : I, E[g + 60 >> 2] = a - (-33554432 & C), I = Ig(S, U, $, EA), B = w, C = (a = Ig(p, M, n, J)) + I | 0, I = w + B | 0, I = C >>> 0 < a >>> 0 ? I + 1 | 0 : I, B = Ig(k, b, K, P), I = w + I | 0, I = (C = B + C | 0) >>> 0 < B >>> 0 ? I + 1 | 0 : I, a = Ig(l, j, G, gA), B = w + I | 0, B = (C = a + C | 0) >>> 0 < a >>> 0 ? B + 1 | 0 : B, I = (a = Ig(F, H, q, Z)) + C | 0, C = w + B | 0, C = I >>> 0 < a >>> 0 ? C + 1 | 0 : C, B = (a = Ig(V, CA, pA, BA)) + I | 0, I = w + C | 0, I = B >>> 0 < a >>> 0 ? I + 1 | 0 : I, C = B, B = Ig(N, Y, wA, sA), I = w + I | 0, I = (C = C + B | 0) >>> 0 < B >>> 0 ? I + 1 | 0 : I, B = C, C = Ig(iA, FA, W, QA), I = w + I | 0, I = C >>> 0 > (B = B + C | 0) >>> 0 ? I + 1 | 0 : I, a = C = SA, C = (G = Ig(C, r = C >> 31, s, d)) + B | 0, B = w + I | 0, I = (y = Ig(y, m, T, oA)) + C | 0, C = w + (C >>> 0 < G >>> 0 ? B + 1 | 0 : B) | 0, B = I >>> 0 < y >>> 0 ? C + 1 | 0 : C, C = I, I = (I = i >> 25) + B | 0, I = (C = C + (i = (33554431 & i) << 7 | e >>> 25) | 0) >>> 0 < i >>> 0 ? I + 1 | 0 : I, B = C, y = C = C + 33554432 | 0, i = I = C >>> 0 < 33554432 ? I + 1 | 0 : I, E[g + 80 >> 2] = B - (-67108864 & C), C = Q >> 25, B = (Q = (33554431 & Q) << 7 | f >>> 25) + (MA - (I = -67108864 & KA) | 0) | 0, I = C + (bA - ((I >>> 0 > MA >>> 0) + HA | 0) | 0) | 0, I = B >>> 0 < Q >>> 0 ? I + 1 | 0 : I, I = ((67108863 & (I = (C = B + 33554432 | 0) >>> 0 < 33554432 ? I + 1 | 0 : I)) << 6 | C >>> 26) + (G = fA - (-33554432 & YA) | 0) | 0, E[g + 68 >> 2] = I, E[g + 64 >> 2] = B - (-67108864 & C), I = Ig(n, J, S, U), B = w, C = (Q = Ig(p, M, u, tA)) + I | 0, I = w + B | 0, I = C >>> 0 < Q >>> 0 ? I + 1 | 0 : I, B = (Q = Ig(K, P, x, rA)) + C | 0, C = w + I | 0, C = B >>> 0 < Q >>> 0 ? C + 1 | 0 : C, I = (Q = Ig(k, b, l, j)) + B | 0, B = w + C | 0, B = I >>> 0 < Q >>> 0 ? B + 1 | 0 : B, C = (Q = Ig(q, Z, R, aA)) + I | 0, I = w + B | 0, I = C >>> 0 < Q >>> 0 ? I + 1 | 0 : I, B = Ig(F, H, pA, BA), I = w + I | 0, I = (C = B + C | 0) >>> 0 < B >>> 0 ? I + 1 | 0 : I, B = Ig(v, _A, wA, sA), I = w + I | 0, I = (C = B + C | 0) >>> 0 < B >>> 0 ? I + 1 | 0 : I, B = (Q = Ig(N, Y, iA, FA)) + C | 0, C = w + I | 0, C = B >>> 0 < Q >>> 0 ? C + 1 | 0 : C, Q = (I = Ig(a, r, L, cA)) + B | 0, B = w + C | 0, B = I >>> 0 > Q >>> 0 ? B + 1 | 0 : B, C = Q, Q = Ig(I = GA, I >> 31, s, d), I = w + B | 0, B = C = C + Q | 0, I = (I = C >>> 0 < Q >>> 0 ? I + 1 | 0 : I) + (C = i >> 26) | 0, I = (B = B + (i = (67108863 & i) << 6 | y >>> 26) | 0) >>> 0 < i >>> 0 ? I + 1 | 0 : I, I = (C = B + 16777216 | 0) >>> 0 < 16777216 ? I + 1 | 0 : I, E[g + 84 >> 2] = B - (-33554432 & C), i = t - (-33554432 & kA) | 0, Q = _ - (B = -67108864 & DA) | 0, p = yA - ((B >>> 0 > _ >>> 0) + dA | 0) | 0, I = Ig((33554431 & (B = I)) << 7 | C >>> 25, I >>= 25, 19, 0), C = w + p | 0, I = I >>> 0 > (B = I + Q | 0) >>> 0 ? C + 1 | 0 : C, I = ((67108863 & (I = (C = B + 33554432 | 0) >>> 0 < 33554432 ? I + 1 | 0 : I)) << 6 | C >>> 26) + i | 0, E[g + 52 >> 2] = I, E[g + 48 >> 2] = B - (-67108864 & C), BI(A, g + 48 | 0)), h = g + 256 | 0, 0 | NA;
                                        },
                                        Pg: function(A, I) {
                                            A |= 0;
                                            var g, C = 0;
                                            return h = g = h + -64 | 0, kI(g, I |= 0, 32, 0), o[0 | g] = 248 & a[0 | g], o[g + 31 | 0] = 63 & a[g + 31 | 0] | 64, I = E[g + 20 >> 2], C = E[g + 16 >> 2], o[A + 16 | 0] = C, o[A + 17 | 0] = C >>> 8, o[A + 18 | 0] = C >>> 16, o[A + 19 | 0] = C >>> 24, o[A + 20 | 0] = I, o[A + 21 | 0] = I >>> 8, o[A + 22 | 0] = I >>> 16, o[A + 23 | 0] = I >>> 24, I = E[g + 12 >> 2], C = E[g + 8 >> 2], o[A + 8 | 0] = C, o[A + 9 | 0] = C >>> 8, o[A + 10 | 0] = C >>> 16, o[A + 11 | 0] = C >>> 24, o[A + 12 | 0] = I, o[A + 13 | 0] = I >>> 8, o[A + 14 | 0] = I >>> 16, o[A + 15 | 0] = I >>> 24, I = E[g + 4 >> 2], C = E[g >> 2], o[0 | A] = C, o[A + 1 | 0] = C >>> 8, o[A + 2 | 0] = C >>> 16, o[A + 3 | 0] = C >>> 24, o[A + 4 | 0] = I, o[A + 5 | 0] = I >>> 8, o[A + 6 | 0] = I >>> 16, o[A + 7 | 0] = I >>> 24, I = E[g + 28 >> 2], C = E[g + 24 >> 2], o[A + 24 | 0] = C, o[A + 25 | 0] = C >>> 8, o[A + 26 | 0] = C >>> 16, o[A + 27 | 0] = C >>> 24, o[A + 28 | 0] = I, o[A + 29 | 0] = I >>> 8, o[A + 30 | 0] = I >>> 16, o[A + 31 | 0] = I >>> 24, XC(g, 64), h = g - -64 | 0, 0;
                                        },
                                        Qg: Vg,
                                        Rg: HI,
                                        Sg: Rg,
                                        Tg: vI,
                                        Ug: BB,
                                        Vg: sB,
                                        Wg: tB,
                                        Xg: BB,
                                        Yg: QB,
                                        Zg: tB,
                                        _g: function(A, I, g, C, B) {
                                            return 0 | jg(A |= 0, I |= 0, g |= 0, C |= 0, B |= 0);
                                        },
                                        $g: function(A, I, g, C, B, Q, i, o) {
                                            return 0 | Ug(A |= 0, I |= 0, (A = 0) | (g |= 0), C |= 0, B |= 0, A | (Q |= 0), i |= 0, o |= 0);
                                        },
                                        ah: function(A, I, g, C, B, Q) {
                                            return 0 | ug(A |= 0, I |= 0, g |= 0, C |= 0, B |= 0, Q |= 0);
                                        },
                                        bh: function(A, I, g, C, B) {
                                            return 0 | Xg(A |= 0, I |= 0, g |= 0, C |= 0, B |= 0);
                                        },
                                        ch: function(A, I, g, C, B, Q, i) {
                                            return 0 | gg(A |= 0, I |= 0, g |= 0, C |= 0, B |= 0, Q |= 0, i |= 0);
                                        },
                                        dh: function(A, I, g, C, B, Q) {
                                            return 0 | xg(A |= 0, I |= 0, g |= 0, C |= 0, B |= 0, Q |= 0);
                                        },
                                        eh: LC,
                                        fh: LC,
                                        gh: BB,
                                        hh: _B,
                                        ih: tB,
                                        jh: function() {
                                            return 1540;
                                        },
                                        kh: Tg,
                                        lh: zg,
                                        mh: LC,
                                        nh: BB,
                                        oh: sB,
                                        ph: tB,
                                        qh: function(A, I, g, C, B) {
                                            return 0 | pC(A |= 0, I |= 0, g |= 0, C |= 0, B |= 0);
                                        },
                                        rh: function(A, I, g, C, B, Q, i, o) {
                                            return 0 | oC(A |= 0, I |= 0, (A = 0) | (g |= 0), C |= 0, B |= 0, A | (Q |= 0), i |= 0, o |= 0);
                                        },
                                        sh: function(A, I, g, C, B, Q) {
                                            return 0 | aC(A |= 0, I |= 0, g |= 0, C |= 0, B |= 0, Q |= 0);
                                        },
                                        th: LC,
                                        uh: Tg,
                                        vh: function(A, I, g, C, B, Q, i, o) {
                                            var E;
                                            return A |= 0, I |= 0, g |= 0, C |= 0, Q |= 0, i |= 0, h = E = h - 32 | 0, fA(E, B |= 0, o |= 0, 0), A = oC(o = A, I, (A = 0) | g, C, B + 16 | 0, A | Q, i, E), XC(E, 32), h = E + 32 | 0, 0 | A;
                                        },
                                        wh: zg,
                                        xh: BB,
                                        yh: _B,
                                        zh: tB,
                                        Ah: LC,
                                        Bh: CB,
                                        Ch: BB,
                                        Dh: gB,
                                        Eh: iI,
                                        Fh: SC,
                                        Gh: GC,
                                        Hh: function() {
                                            return 1089;
                                        },
                                        Ih: function() {
                                            var A, I;
                                            return h = A = h - 16 | 0, o[A + 15 | 0] = 0, I = 0 | r(36800, A + 15 | 0, 0), h = A + 16 | 0, 0 | I;
                                        },
                                        Jh: $g,
                                        Kh: function(A) {
                                            var I, g = 0, C = 0;
                                            if (h = I = h - 16 | 0, (A |= 0) >>> 0 >= 2) {
                                                for(g = (0 - A >>> 0) % (A >>> 0) | 0; o[I + 15 | 0] = 0, g >>> 0 > (C = 0 | r(36800, I + 15 | 0, 0)) >>> 0;);
                                                g = (C >>> 0) % (A >>> 0) | 0;
                                            }
                                            return h = I + 16 | 0, 0 | g;
                                        },
                                        Lh: ag,
                                        Mh: function(A, I, g) {
                                            Xg(A |= 0, I |= 0, 0, 1574, g |= 0);
                                        },
                                        Nh: BB,
                                        Oh: function() {
                                            var A = 0, I = 0;
                                            return (A = E[9524]) && (A = E[A + 20 >> 2]) && (I = 0 | pB[0 | A]()), 0 | I;
                                        },
                                        Ph: function(A, I, g) {
                                            A |= 0, I |= 0;
                                            var C, B = 0, i = 0, E = 0;
                                            if (h = C = h - 16 | 0, g |= 0) e(1329, 1175, 197, 1092), Q();
                                            else {
                                                if (I) for(; o[C + 15 | 0] = 0, i = A + B | 0, E = 0 | r(36800, C + 15 | 0, 0), o[0 | i] = E, (0 | I) != (0 | (B = B + 1 | 0)););
                                                h = C + 16 | 0;
                                            }
                                        },
                                        Qh: function(A, I, g, C) {
                                            A |= 0, g |= 0;
                                            var B = 0, i = 0, E = 0;
                                            if (!((C |= 0) >>> 0 > 2147483646 | C << 1 >>> 0 >= (I |= 0) >>> 0)) {
                                                if (I = 0, C) {
                                                    for(; B = (I << 1) + A | 0, i = 15 & (E = a[I + g | 0]), o[B + 1 | 0] = 22272 + ((i << 8) + (i + 65526 & 55552) | 0) >>> 8, i = B, B = E >>> 4 | 0, o[0 | i] = 87 + ((B + 65526 >>> 8 & 217) + B | 0), (0 | C) != (0 | (I = I + 1 | 0)););
                                                    I = C << 1;
                                                } else I = 0;
                                                return o[I + A | 0] = 0, 0 | A;
                                            }
                                            yC(), Q();
                                        },
                                        Rh: function(A, I, g, C, B, Q, i) {
                                            A |= 0, I |= 0, g |= 0, B |= 0, Q |= 0, i |= 0;
                                            var _ = 0, c = 0, t = 0, r = 0, e = 0, y = 0, s = 0, h = 0, D = 0, p = 0;
                                            A: if (C |= 0) {
                                                I: {
                                                    g: {
                                                        C: {
                                                            B: {
                                                                if (!B) {
                                                                    for(c = 1, B = 0;;){
                                                                        if (!(255 & ((s = (65526 + (t = (223 & (e = a[g + _ | 0])) - 55 & 255) ^ t + 65520) >>> 8 | 0) | (h = 65526 + (e ^= 48) >>> 8 | 0)))) break C;
                                                                        if (I >>> 0 <= y >>> 0) break B;
                                                                        if (t = t & s | e & h, 255 & r ? (o[A + y | 0] = B | t, y = y + 1 | 0) : B = t << 4, r ^= -1, (0 | (_ = _ + 1 | 0)) == (0 | C)) break;
                                                                    }
                                                                    _ = C;
                                                                    break C;
                                                                }
                                                                for(;;){
                                                                    Q: {
                                                                        i: {
                                                                            o: {
                                                                                E: {
                                                                                    a: {
                                                                                        if (!(255 & ((e = (65526 + (t = (223 & (c = a[g + _ | 0])) - 55 & 255) ^ t + 65520) >>> 8 | 0) | (h = 65526 + (s = 48 ^ c) >>> 8 | 0)))) {
                                                                                            if (255 & r) break g;
                                                                                            if (!FI(B, c)) break A;
                                                                                            if ((_ = r = _ + 1 | 0) >>> 0 < C >>> 0) break a;
                                                                                            break A;
                                                                                        }
                                                                                        if (I >>> 0 <= y >>> 0) break B;
                                                                                        if (c = t & e | s & h, !(255 & r)) break E;
                                                                                        o[A + y | 0] = c | p, y = y + 1 | 0;
                                                                                        break Q;
                                                                                    }
                                                                                    for(;;){
                                                                                        if (!(255 & ((e = (65526 + (t = (223 & (c = a[g + _ | 0])) - 55 & 255) ^ t + 65520) >>> 8 | 0) | (h = 65526 + (s = 48 ^ c) >>> 8 | 0)))) {
                                                                                            if (!FI(B, c)) break A;
                                                                                            if ((_ = _ + 1 | 0) >>> 0 < C >>> 0) continue;
                                                                                            break o;
                                                                                        }
                                                                                        break;
                                                                                    }
                                                                                    if (I >>> 0 <= y >>> 0) break i;
                                                                                    c = t & e | s & h;
                                                                                }
                                                                                p = c << 4, r = 0;
                                                                                break Q;
                                                                            }
                                                                            _ = C >>> 0 > r >>> 0 ? C : r;
                                                                            break A;
                                                                        }
                                                                        r = 0;
                                                                        break B;
                                                                    }
                                                                    if (r ^= -1, c = 1, !((_ = _ + 1 | 0) >>> 0 < C >>> 0)) break;
                                                                }
                                                                break C;
                                                            }
                                                            E[9392] = 68, c = 0;
                                                        }
                                                        if (!(255 & r)) break I;
                                                    }
                                                    E[9392] = 28, D = -1, _ = _ - 1 | 0, y = 0;
                                                    break A;
                                                }
                                                c || (y = 0, D = -1);
                                            }
                                            return i ? E[i >> 2] = g + _ : (0 | C) != (0 | _) && (E[9392] = 28, D = -1), Q && (E[Q >> 2] = y), 0 | D;
                                        },
                                        Sh: function(A, I) {
                                            A |= 0;
                                            var g = 0;
                                            return 1 != (-7 & (I |= 0)) && (yC(), Q()), 1 + ((3 & (g = (g = A) + c(A = (A >>> 0) / 3 | 0, -3) | 0) ? 2 & I ? g + 1 | 0 : 4 : 0) + (A << 2) | 0) | 0;
                                        },
                                        Th: LA,
                                        Uh: wA,
                                        Vh: function() {
                                            var A = 0;
                                            return E[9525] ? A = 1 : ($g(), ag(38080, 16), E[9525] = 1, A = 0), 0 | A;
                                        },
                                        Wh: function(A, I, g, C, B) {
                                            A |= 0, I |= 0, g |= 0, B |= 0;
                                            var i, _ = 0, c = 0, t = 0;
                                            h = i = h - 16 | 0;
                                            A: {
                                                if (C |= 0) {
                                                    if ((_ = C - 1 | 0) & C ? (c = -1 ^ g, _ = _ - ((g >>> 0) % (C >>> 0) | 0) | 0) : _ &= c = -1 ^ g, c >>> 0 <= _ >>> 0) break A;
                                                    if (c = -1, !((g = g + _ | 0) >>> 0 >= B >>> 0)) for(A && (E[A >> 2] = g + 1), A = I + g | 0, c = 0, o[i + 15 | 0] = 0, g = 0; B = I = A - g | 0, t = a[0 | I] & a[i + 15 | 0], I = (g ^ _) - 1 >>> 24 | 0, o[0 | B] = t | 128 & I, o[i + 15 | 0] = I | a[i + 15 | 0], (0 | C) != (0 | (g = g + 1 | 0)););
                                                } else c = -1;
                                                return h = i + 16 | 0, 0 | c;
                                            }
                                            yC(), Q();
                                        },
                                        Xh: function(A, I, g, C) {
                                            A |= 0, I |= 0, g |= 0, C |= 0;
                                            var B, Q = 0, i = 0, o = 0, _ = 0, c = 0;
                                            if (E[12 + (B = h - 16 | 0) >> 2] = 0, C - 1 >>> 0 < g >>> 0) {
                                                for(c = (Q = g - 1 | 0) + I | 0, g = 0, I = 0; _ = ((128 ^ (i = a[c - g | 0])) - 1 & E[B + 12 >> 2] - 1 & o - 1) >>> 8 & 1, E[B + 12 >> 2] = E[B + 12 >> 2] | 0 - _ & g, I |= _, o |= i, (0 | C) != (0 | (g = g + 1 | 0)););
                                                E[A >> 2] = Q - E[B + 12 >> 2], A = (255 & I) - 1 | 0;
                                            } else A = -1;
                                            return 0 | A;
                                        },
                                        Yh: function() {
                                            return 1457;
                                        },
                                        Zh: function() {
                                            return 26;
                                        },
                                        _h: rB,
                                        $h: hB,
                                        ai: aI,
                                        bi: sC,
                                        ci: function(A, I, g) {
                                            A |= 0;
                                            var C, B = 0;
                                            return h = C = h - 32 | 0, B = -1, gI(C, g |= 0, I |= 0) || (B = yA(A, 35584, C, 0)), h = C + 32 | 0, 0 | B;
                                        },
                                        di: lg,
                                        ei: function(A, I, g, C, B, Q, i, o) {
                                            var E, a;
                                            return A |= 0, I |= 0, g |= 0, Q |= 0, a = C |= 0, C = B |= 0, h = E = h + -64 | 0, gI(E + 32 | 0, o |= 0, i |= 0) ? B = -1 : (B = -1, yA(E, 35584, E + 32 | 0, 0) || (B = rI(A, I, g, a, C, Q, E), XC(E, 32))), h = E - -64 | 0, 0 | B;
                                        },
                                        fi: function(A, I, g, C, B, i) {
                                            return A |= 0, I |= 0, B |= 0, i |= 0, !(C |= 0) & (g |= 0) >>> 0 >= 4294967280 | C && (yC(), Q()), 0 | rI(A + 16 | 0, A, I, g, C, B, i);
                                        },
                                        gi: function(A, I, g, C, B, Q, i) {
                                            return 0 | ig(A |= 0, I |= 0, g |= 0, C |= 0, B |= 0, Q |= 0, i |= 0);
                                        },
                                        hi: mg,
                                        ii: function(A, I, g, C, B, Q, i, o) {
                                            var E, a;
                                            return A |= 0, I |= 0, g |= 0, Q |= 0, a = C |= 0, C = B |= 0, h = E = h + -64 | 0, gI(E + 32 | 0, o |= 0, i |= 0) ? B = -1 : (B = -1, yA(E, 35584, E + 32 | 0, 0) || (B = hI(A, I, g, a, C, Q, E), XC(E, 32))), h = E - -64 | 0, 0 | B;
                                        },
                                        ji: Dg,
                                        ki: function(A, I, g, C, B, Q, i) {
                                            return 0 | Ag(A |= 0, I |= 0, g |= 0, C |= 0, B |= 0, Q |= 0, i |= 0);
                                        },
                                        li: BB,
                                        mi: BB,
                                        ni: BB,
                                        oi: BB,
                                        pi: _B,
                                        qi: CB,
                                        ri: oB,
                                        si: function(A, I, g, C, B) {
                                            A |= 0, I |= 0, B |= 0;
                                            var Q, i, a, _, c = 0, t = 0;
                                            return c = g |= 0, g = C |= 0, _ = 0 | c, c = C = h, h = Q = C - 512 & -64, C = -1, sC(i = Q - -64 | 0, a = Q + 32 | 0) || (iC(C = Q + 128 | 0, 0, 0, 24), mC(C, i, 32, 0), mC(C, B, 32, 0), rC(C, t = Q + 96 | 0, 24), C = ig(A + 32 | 0, I, _, g, t, B, a), I = E[Q + 92 >> 2], g = E[Q + 88 >> 2], o[A + 24 | 0] = g, o[A + 25 | 0] = g >>> 8, o[A + 26 | 0] = g >>> 16, o[A + 27 | 0] = g >>> 24, o[A + 28 | 0] = I, o[A + 29 | 0] = I >>> 8, o[A + 30 | 0] = I >>> 16, o[A + 31 | 0] = I >>> 24, I = E[Q + 84 >> 2], g = E[Q + 80 >> 2], o[A + 16 | 0] = g, o[A + 17 | 0] = g >>> 8, o[A + 18 | 0] = g >>> 16, o[A + 19 | 0] = g >>> 24, o[A + 20 | 0] = I, o[A + 21 | 0] = I >>> 8, o[A + 22 | 0] = I >>> 16, o[A + 23 | 0] = I >>> 24, I = E[Q + 76 >> 2], g = E[Q + 72 >> 2], o[A + 8 | 0] = g, o[A + 9 | 0] = g >>> 8, o[A + 10 | 0] = g >>> 16, o[A + 11 | 0] = g >>> 24, o[A + 12 | 0] = I, o[A + 13 | 0] = I >>> 8, o[A + 14 | 0] = I >>> 16, o[A + 15 | 0] = I >>> 24, I = E[Q + 68 >> 2], g = E[Q + 64 >> 2], o[0 | A] = g, o[A + 1 | 0] = g >>> 8, o[A + 2 | 0] = g >>> 16, o[A + 3 | 0] = g >>> 24, o[A + 4 | 0] = I, o[A + 5 | 0] = I >>> 8, o[A + 6 | 0] = I >>> 16, o[A + 7 | 0] = I >>> 24, XC(a, 32), XC(i, 32), XC(t, 24)), h = c, 0 | C;
                                        },
                                        ti: function(A, I, g, C, B, Q) {
                                            A |= 0, I |= 0, B |= 0, Q |= 0;
                                            var i, o, E = 0;
                                            return o = E = h, h = i = E - 448 & -64, E = -1, !(C |= 0) & (g |= 0) >>> 0 >= 48 | C && (iC(E = i - -64 | 0, 0, 0, 24), mC(E, I, 32, 0), mC(E, B, 32, 0), rC(E, B = i + 32 | 0, 24), E = Ag(A, I + 32 | 0, g - 32 | 0, C - (g >>> 0 < 32) | 0, B, I, Q)), h = o, 0 | E;
                                        },
                                        ui: EB,
                                        vi: function(A) {
                                            var I, g = 0;
                                            return h = I = h - 160 | 0, GI(A |= 0) && (bI(A) || bA(I, A) || jA(I) && (g = 0 != (0 | IA(I)))), h = I + 160 | 0, 0 | g;
                                        },
                                        wi: function(A, I, g) {
                                            A |= 0, g |= 0;
                                            var C, B, Q = 0;
                                            return h = C = h - 800 | 0, Q = -1, bA(B = C + 640 | 0, I |= 0) || jA(B) && (bA(I = C + 480 | 0, g) || jA(I) && (TA(C, I), sA(I = C + 160 | 0, B, C), kg(g = C + 320 | 0, I), tg(A, g), Q = 0)), h = C + 800 | 0, 0 | Q;
                                        },
                                        xi: function(A, I, g) {
                                            A |= 0, g |= 0;
                                            var C, B, Q = 0;
                                            return h = C = h - 800 | 0, Q = -1, bA(B = C + 640 | 0, I |= 0) || jA(B) && (bA(I = C + 480 | 0, g) || jA(I) && (TA(C, I), hA(I = C + 160 | 0, B, C), kg(g = C + 320 | 0, I), tg(A, g), Q = 0)), h = C + 800 | 0, 0 | Q;
                                        },
                                        yi: function(A, I) {
                                            return b(A |= 0, I |= 0), 0;
                                        },
                                        zi: function(A) {
                                            var I;
                                            A |= 0, h = I = h - 32 | 0, ag(I, 32), b(A, I), h = I + 32 | 0;
                                        },
                                        Ai: Mg,
                                        Bi: FA,
                                        Ci: xA,
                                        Di: mA,
                                        Ei: cA,
                                        Fi: JA,
                                        Gi: AA,
                                        Hi: MC,
                                        Ii: BB,
                                        Ji: gB,
                                        Ki: BB,
                                        Li: gB,
                                        Mi: BB,
                                        Ni: function(A) {
                                            var I;
                                            return h = I = h - 160 | 0, A = EA(I, A |= 0), h = I + 160 | 0, 0 | !A;
                                        },
                                        Oi: function(A, I, g) {
                                            A |= 0, g |= 0;
                                            var C, B, Q = 0;
                                            return h = C = h - 800 | 0, Q = -1, EA(B = C + 640 | 0, I |= 0) || EA(I = C + 480 | 0, g) || (TA(C, I), sA(I = C + 160 | 0, B, C), kg(g = C + 320 | 0, I), O(A, g), Q = 0), h = C + 800 | 0, 0 | Q;
                                        },
                                        Pi: function(A, I, g) {
                                            A |= 0, g |= 0;
                                            var C, B, Q = 0;
                                            return h = C = h - 800 | 0, Q = -1, EA(B = C + 640 | 0, I |= 0) || EA(I = C + 480 | 0, g) || (TA(C, I), hA(I = C + 160 | 0, B, C), kg(g = C + 320 | 0, I), O(A, g), Q = 0), h = C + 800 | 0, 0 | Q;
                                        },
                                        Qi: function(A, I) {
                                            return jI(A |= 0, I |= 0), 0;
                                        },
                                        Ri: function(A) {
                                            var I;
                                            A |= 0, h = I = h + -64 | 0, ag(I, 64), jI(A, I), h = I - -64 | 0;
                                        },
                                        Si: function(A) {
                                            Mg(A |= 0);
                                        },
                                        Ti: function(A, I) {
                                            return 0 | FA(A |= 0, I |= 0);
                                        },
                                        Ui: function(A, I) {
                                            xA(A |= 0, I |= 0);
                                        },
                                        Vi: function(A, I) {
                                            mA(A |= 0, I |= 0);
                                        },
                                        Wi: function(A, I, g) {
                                            cA(A |= 0, I |= 0, g |= 0);
                                        },
                                        Xi: function(A, I, g) {
                                            AA(A |= 0, I |= 0, g |= 0);
                                        },
                                        Yi: MC,
                                        Zi: function(A, I) {
                                            JA(A |= 0, I |= 0);
                                        },
                                        _i: BB,
                                        $i: gB,
                                        aj: gB,
                                        bj: BB,
                                        cj: function(A, I, g, C, B, Q, i, o, E, a) {
                                            return 0 | rg(A |= 0, I |= 0, g |= 0, C |= 0, B |= 0, Q |= 0, i |= 0, o |= 0, E |= 0, a |= 0);
                                        },
                                        dj: CB,
                                        ej: tB,
                                        fj: hB,
                                        gj: tB,
                                        hj: BB,
                                        ij: function() {
                                            return 102;
                                        },
                                        jj: function() {
                                            return 1570;
                                        },
                                        kj: function() {
                                            return 32768;
                                        },
                                        lj: tB,
                                        mj: zC,
                                        nj: tB,
                                        oj: function() {
                                            return 524288;
                                        },
                                        pj: zC,
                                        qj: jC,
                                        rj: xC,
                                        sj: function(A, I, g, C, B, Q, i, o, a, _) {
                                            var c, t, r;
                                            I |= 0, g |= 0, C |= 0, B |= 0, Q |= 0, i |= 0, a |= 0, _ |= 0, t = 0 | (o |= 0), h = o = h - 16 | 0, r = I |= 0, c = Hg(A |= 0, 0, I), A = 0 | B;
                                            A: if (1 == (0 | (B = g | Q)) | B >>> 0 > 1) E[9392] = 22, A = -1;
                                            else if (!g & I >>> 0 >= 16 | g) {
                                                if (BA(t, a, _, o + 12 | 0, o + 8 | 0, o + 4 | 0), (0 | C) == (0 | c)) {
                                                    E[9392] = 28, A = -1;
                                                    break A;
                                                }
                                                B = A, A = 31 & (I = E[o + 12 >> 2]), (63 & I) >>> 0 >= 32 ? (I = 1 << A, g = 0) : I = (g = 1 << A) - 1 & 1 >>> 32 - A, A = rg(C, B, i, 32, g, I, E[o + 4 >> 2], E[o + 8 >> 2], c, r);
                                            } else E[9392] = 28, A = -1;
                                            return h = o + 16 | 0, 0 | A;
                                        },
                                        tj: function(A, I, g, C, B, Q, i) {
                                            I |= 0, g |= 0, C |= 0, Q |= 0, i |= 0;
                                            var _, c, t, r = 0, e = 0, y = 0, s = 0, D = 0, p = 0, f = 0;
                                            r = B |= 0, r |= B = 0, h = _ = h - 128 | 0, c = Hg(A |= 0, 0, 102), D = 22, t = g | B;
                                            A: {
                                                if (!C) {
                                                    BA(r, Q, i, _ + 16 | 0, _ + 12 | 0, _ + 8 | 0), ag(e = _ + 96 | 0, 32), D = 28, g = _ + 32 | 0, Q = E[_ + 16 >> 2], i = Ig(A = E[_ + 12 >> 2], 0, C = E[_ + 8 >> 2], 0);
                                                    I: if (!(!(r = w) & i >>> 0 > 1073741823 | r | Q >>> 0 > 63) && (o[0 | g] = 36, o[g + 1 | 0] = 55, o[g + 2 | 0] = 36, o[g + 3 | 0] = a[Q + 1024 | 0], o[g + 4 | 0] = a[1024 + (63 & C) | 0], o[g + 5 | 0] = a[1024 + (C >>> 6 & 63) | 0], o[g + 6 | 0] = a[1024 + (C >>> 12 & 63) | 0], o[g + 7 | 0] = a[1024 + (C >>> 18 & 63) | 0], o[g + 8 | 0] = a[1024 + (C >>> 24 & 63) | 0], (C = g + 9 | 0) && (0 | C) != (0 | (y = g + 58 | 0)) && (o[0 | C] = a[1024 + (63 & A) | 0], 1 != (0 | (C = y - C | 0)) && (o[g + 10 | 0] = a[1024 + (A >>> 6 & 63) | 0], 2 != (0 | C) && (o[g + 11 | 0] = a[1024 + (A >>> 12 & 63) | 0], 3 != (0 | C) && (o[g + 12 | 0] = a[1024 + (A >>> 18 & 63) | 0], 4 != (0 | C) && (o[g + 13 | 0] = a[1024 + (A >>> 24 & 63) | 0], Q = g + 14 | 0))))))) {
                                                        for(r = y - Q | 0, A = 0;;){
                                                            if (C = Q, !(A >>> 0 >= 32)) {
                                                                if (Q = a[A + e | 0], (p = (i = A + 1 | 0) >>> 0 >= 32) ? s = 0 : (Q = a[i + e | 0] << 8 | Q, (i = A + 2 | 0) >>> 0 >= 32 ? s = 0 : (Q = a[i + e | 0] << 16 | Q, s = 1, i = A + 3 | 0)), A = i, !r) break I;
                                                                if (o[0 | C] = a[1024 + (63 & Q) | 0], 1 == (0 | r)) break I;
                                                                if (o[C + 1 | 0] = a[1024 + (Q >>> 6 & 63) | 0], f = C + r | 0, i = C + 2 | 0, !p) {
                                                                    if (2 == (0 | r)) break I;
                                                                    if (o[C + 2 | 0] = a[1024 + (Q >>> 12 & 63) | 0], i = C + 3 | 0, s) {
                                                                        if (3 == (0 | r)) break I;
                                                                        o[C + 3 | 0] = a[1024 + (Q >>> 18 | 0) | 0], i = C + 4 | 0;
                                                                    }
                                                                }
                                                                if (r = f - (Q = i) | 0, Q) continue;
                                                                break I;
                                                            }
                                                            break;
                                                        }
                                                        C >>> 0 >= y >>> 0 || (o[0 | C] = 0, B = g);
                                                    }
                                                    if (B) {
                                                        if (A = -1, _C(C = _ + 20 | 0)) break A;
                                                        if (I = ZA(C, I, t, g, c), vg(C), A = 0, I) break A;
                                                    }
                                                }
                                                E[9392] = D, A = -1;
                                            }
                                            return h = _ + 128 | 0, 0 | A;
                                        },
                                        uj: function(A, I, g, C) {
                                            I |= 0, C |= 0;
                                            var B, Q, i = 0;
                                            B = A |= 0, Q = g |= 0, g = 0, h = C = h - 128 | 0;
                                            A: {
                                                I: {
                                                    for(;;){
                                                        if (!a[g + B | 0]) {
                                                            A = g;
                                                            break I;
                                                        }
                                                        if (!a[B + (A = g + 1 | 0) | 0]) break I;
                                                        if (!a[B + (A = g + 2 | 0) | 0]) break I;
                                                        if (102 == (0 | (g = g + 3 | 0))) break;
                                                    }
                                                    g = -1;
                                                    break A;
                                                }
                                                g = -1, 101 == (0 | A) && (_C(i = C + 4 | 0) || (Hg(A = C + 16 | 0, 0, 102), I = ZA(i, I, Q, B, A), vg(i), I && (g = MI(A, B, 102), XC(A, 102))));
                                            }
                                            return h = C + 128 | 0, 0 | g;
                                        },
                                        vj: function(A, I, g, C) {
                                            var B, Q;
                                            Q = A |= 0, h = B = h - 32 | 0, BA(I |= 0, g |= 0, C |= 0, B + 28 | 0, B + 20 | 0, B + 12 | 0), A = 0;
                                            A: {
                                                I: {
                                                    g: {
                                                        for(;;){
                                                            if (a[A + Q | 0]) {
                                                                if (a[Q + (I = A + 1 | 0) | 0] && a[Q + (I = A + 2 | 0) | 0]) {
                                                                    if (102 != (0 | (A = A + 3 | 0))) continue;
                                                                    break g;
                                                                }
                                                            } else I = A;
                                                            break;
                                                        }
                                                        if (101 == (0 | I)) {
                                                            if (g = B + 8 | 0, C = B + 16 | 0, A = 0, 36 != a[0 | Q] | 55 != a[Q + 1 | 0] | 36 != a[Q + 2 | 0] || (I = uI(a[Q + 3 | 0]), E[B + 24 >> 2] = I ? I - 1024 | 0 : 0, I && (I = PI(g, Q + 4 | 0)) && (A = PI(C, I))), A) break I;
                                                            E[9392] = 28, A = -1;
                                                            break A;
                                                        }
                                                    }
                                                    E[9392] = 28, A = -1;
                                                    break A;
                                                }
                                                A = 1, E[B + 28 >> 2] != E[B + 24 >> 2] | E[B + 12 >> 2] != E[B + 8 >> 2] || (A = E[B + 20 >> 2] != E[B + 16 >> 2]);
                                            }
                                            return h = B + 32 | 0, 0 | A;
                                        },
                                        wj: function(A, I, g) {
                                            return 0 | VA(A |= 0, I |= 0, g |= 0, 1);
                                        },
                                        xj: function(A, I, g) {
                                            return 0 | VA(A |= 0, I |= 0, g |= 0, 0);
                                        },
                                        yj: function(A, I) {
                                            return 0 | AI(A |= 0, I |= 0, 1);
                                        },
                                        zj: function(A, I) {
                                            return 0 | AI(A |= 0, I |= 0, 0);
                                        },
                                        Aj: BB,
                                        Bj: BB,
                                        Cj: function(A, I, g) {
                                            A |= 0, I |= 0;
                                            var C, B = 0;
                                            return h = C = h - 320 | 0, B = -1, EA(C, g |= 0) || (o[0 | A] = a[0 | I], o[A + 1 | 0] = a[I + 1 | 0], o[A + 2 | 0] = a[I + 2 | 0], o[A + 3 | 0] = a[I + 3 | 0], o[A + 4 | 0] = a[I + 4 | 0], o[A + 5 | 0] = a[I + 5 | 0], o[A + 6 | 0] = a[I + 6 | 0], o[A + 7 | 0] = a[I + 7 | 0], o[A + 8 | 0] = a[I + 8 | 0], o[A + 9 | 0] = a[I + 9 | 0], o[A + 10 | 0] = a[I + 10 | 0], o[A + 11 | 0] = a[I + 11 | 0], o[A + 12 | 0] = a[I + 12 | 0], o[A + 13 | 0] = a[I + 13 | 0], o[A + 14 | 0] = a[I + 14 | 0], o[A + 15 | 0] = a[I + 15 | 0], o[A + 16 | 0] = a[I + 16 | 0], o[A + 17 | 0] = a[I + 17 | 0], o[A + 18 | 0] = a[I + 18 | 0], o[A + 19 | 0] = a[I + 19 | 0], o[A + 20 | 0] = a[I + 20 | 0], o[A + 21 | 0] = a[I + 21 | 0], o[A + 22 | 0] = a[I + 22 | 0], o[A + 23 | 0] = a[I + 23 | 0], o[A + 24 | 0] = a[I + 24 | 0], o[A + 25 | 0] = a[I + 25 | 0], o[A + 26 | 0] = a[I + 26 | 0], o[A + 27 | 0] = a[I + 27 | 0], o[A + 28 | 0] = a[I + 28 | 0], o[A + 29 | 0] = a[I + 29 | 0], o[A + 30 | 0] = a[I + 30 | 0], o[A + 31 | 0] = 127 & a[I + 31 | 0], u(I = C + 160 | 0, A, C), O(A, I), B = NI(A, 32) ? -1 : 0), h = C + 320 | 0, 0 | B;
                                        },
                                        Dj: function(A, I) {
                                            var g;
                                            return I |= 0, h = g = h - 160 | 0, o[0 | (A |= 0)] = a[0 | I], o[A + 1 | 0] = a[I + 1 | 0], o[A + 2 | 0] = a[I + 2 | 0], o[A + 3 | 0] = a[I + 3 | 0], o[A + 4 | 0] = a[I + 4 | 0], o[A + 5 | 0] = a[I + 5 | 0], o[A + 6 | 0] = a[I + 6 | 0], o[A + 7 | 0] = a[I + 7 | 0], o[A + 8 | 0] = a[I + 8 | 0], o[A + 9 | 0] = a[I + 9 | 0], o[A + 10 | 0] = a[I + 10 | 0], o[A + 11 | 0] = a[I + 11 | 0], o[A + 12 | 0] = a[I + 12 | 0], o[A + 13 | 0] = a[I + 13 | 0], o[A + 14 | 0] = a[I + 14 | 0], o[A + 15 | 0] = a[I + 15 | 0], o[A + 16 | 0] = a[I + 16 | 0], o[A + 17 | 0] = a[I + 17 | 0], o[A + 18 | 0] = a[I + 18 | 0], o[A + 19 | 0] = a[I + 19 | 0], o[A + 20 | 0] = a[I + 20 | 0], o[A + 21 | 0] = a[I + 21 | 0], o[A + 22 | 0] = a[I + 22 | 0], o[A + 23 | 0] = a[I + 23 | 0], o[A + 24 | 0] = a[I + 24 | 0], o[A + 25 | 0] = a[I + 25 | 0], o[A + 26 | 0] = a[I + 26 | 0], o[A + 27 | 0] = a[I + 27 | 0], o[A + 28 | 0] = a[I + 28 | 0], o[A + 29 | 0] = a[I + 29 | 0], o[A + 30 | 0] = a[I + 30 | 0], o[A + 31 | 0] = 127 & a[I + 31 | 0], kA(g, A), O(A, g), A = NI(A, 32), h = g + 160 | 0, 0 | (A ? -1 : 0);
                                        },
                                        Ej: BB,
                                        Fj: BB,
                                        Gj: lg,
                                        Hj: function(A, I, g, C, B, i) {
                                            return A |= 0, I |= 0, B |= 0, i |= 0, !(C |= 0) & (g |= 0) >>> 0 >= 4294967280 | C && (yC(), Q()), rI(A + 16 | 0, A, I, g, C, B, i), 0;
                                        },
                                        Ij: mg,
                                        Jj: Dg,
                                        Kj: BB,
                                        Lj: _B,
                                        Mj: CB,
                                        Nj: oB,
                                        Oj: CB,
                                        Pj: CB,
                                        Qj: function(A, I, g, C, B) {
                                            A |= 0, I |= 0, g |= 0, C |= 0;
                                            var Q, i = 0, E = 0, _ = 0, c = 0, t = 0, r = 0, e = 0, y = 0, s = 0, h = 0, D = 0, p = 0, f = 0, n = 0, k = 0;
                                            if (n = 1886610805 ^ (E = a[0 | (B |= 0)] | a[B + 1 | 0] << 8 | a[B + 2 | 0] << 16 | a[B + 3 | 0] << 24), D = 1936682341 ^ (i = a[B + 4 | 0] | a[B + 5 | 0] << 8 | a[B + 6 | 0] << 16 | a[B + 7 | 0] << 24), E ^= 1852142177, _ = 1819895653 ^ i, k = 1852075907 ^ (i = a[B + 8 | 0] | a[B + 9 | 0] << 8 | a[B + 10 | 0] << 16 | a[B + 11 | 0] << 24), p = 1685025377 ^ (B = a[B + 12 | 0] | a[B + 13 | 0] << 8 | a[B + 14 | 0] << 16 | a[B + 15 | 0] << 24), c = 2037671283 ^ i, i = 1952801890 ^ B, h = g, (0 | (r = (g + I | 0) - (Q = 7 & g) | 0)) != (0 | I)) {
                                                for(; g = (s = i ^ (f = a[I + 4 | 0] | a[I + 5 | 0] << 8 | a[I + 6 | 0] << 16 | a[I + 7 | 0] << 24)) + _ | 0, c = C = E + (B = c ^ (e = a[0 | I] | a[I + 1 | 0] << 8 | a[I + 2 | 0] << 16 | a[I + 3 | 0] << 24)) | 0, t = g = C >>> 0 < B >>> 0 ? g + 1 | 0 : g, E = C, C = g, g = D + p | 0, g = (i = n + k | 0) >>> 0 < n >>> 0 ? g + 1 | 0 : g, y = (_ = KI(k, p, 13) ^ i) + E | 0, C = (E = w ^ g) + C | 0, E = KI(_, E, 17) ^ y, p = KI(E, C = (_ = _ >>> 0 > y >>> 0 ? C + 1 | 0 : C) ^ w, 13), D = w, s = KI(B, s, 16), B = t ^ w, s ^= c, t = KI(i, g, 32), g = w + B | 0, g = (c = C) + (C = (i = s + t | 0) >>> 0 < t >>> 0 ? g + 1 | 0 : g) | 0, t = g = (c = i + E | 0) >>> 0 < i >>> 0 ? g + 1 | 0 : g, p = KI(E = c ^ p, g ^= D, 17), D = w, s = KI(s, B, 21), B = C ^ w, s ^= i, i = KI(y, _, 32), C = w + B | 0, g = (i = i >>> 0 > (_ = s + i | 0) >>> 0 ? C + 1 | 0 : C) + g | 0, k = (E = E + _ | 0) ^ p, C = g = E >>> 0 < _ >>> 0 ? g + 1 | 0 : g, p = g ^ D, g = KI(s, B, 16), s = i ^= w, y = KI(g ^= _, i, 21), _ = w, t = (i = KI(c, t, 32)) + g | 0, g = w + s | 0, c = t ^ y, i = (g = i >>> 0 > t >>> 0 ? g + 1 | 0 : g) ^ _, E = KI(E, C, 32), _ = w, n = e ^ t, D = g ^ f, (0 | r) != (0 | (I = I + 8 | 0)););
                                                I = r;
                                            }
                                            switch(e = 0, B = h << 24, Q - 1 | 0){
                                                case 6:
                                                    B |= a[I + 6 | 0] << 16;
                                                case 5:
                                                    B |= a[I + 5 | 0] << 8;
                                                case 4:
                                                    B |= a[I + 4 | 0];
                                                case 3:
                                                    e |= (g = a[I + 3 | 0]) << 24, B |= C = g >>> 8 | 0;
                                                case 2:
                                                    e |= (C = a[I + 2 | 0]) << 16, B |= g = C >>> 16 | 0;
                                                case 1:
                                                    e |= (g = a[I + 1 | 0]) << 8, B |= C = g >>> 24 | 0;
                                                case 0:
                                                    e = a[0 | I] | e;
                                            }
                                            return y = B, I = B ^ i, C = KI(B = c ^ e, I, 16), I = I + _ | 0, t = I = (c = B + E | 0) >>> 0 < E >>> 0 ? I + 1 | 0 : I, r = KI(B = C ^ c, I ^= g = w, 21), i = w, g = D + p | 0, C = g = (E = n + k | 0) >>> 0 < n >>> 0 ? g + 1 | 0 : g, _ = B, B = KI(E, g, 32), g = w + I | 0, I = i, i = g = B >>> 0 > (_ = _ + B | 0) >>> 0 ? g + 1 | 0 : g, D = KI(B = _ ^ r, I ^= g, 16), s = w, g = (E = h = KI(k, p, 13) ^ E) + c | 0, C = (c = w ^ C) + t | 0, t = B, B = KI(g, C = g >>> 0 < E >>> 0 ? C + 1 | 0 : C, 32), I = w + I | 0, p = B = (E = B >>> 0 > (r = t + B | 0) >>> 0 ? I + 1 | 0 : I) ^ s, t = D ^= r, s = KI(h, c, 17) ^ g, g = (h = w ^ C) + i | 0, I = g = (C = _ = (I = s) + _ | 0) >>> 0 < I >>> 0 ? g + 1 | 0 : g, i = KI(C, g, 32), g = w + B | 0, _ = (c = i + t | 0) ^ e, y ^= t = i >>> 0 > c >>> 0 ? g + 1 | 0 : g, B = KI(s, h, 13) ^ C, C = KI(B, I ^= w, 17), I = I + E | 0, B = C ^ (i = B + r | 0), C = I = i >>> 0 < r >>> 0 ? I + 1 | 0 : I, g = (I ^= g = w) + y | 0, g = B >>> 0 > (_ = B + _ | 0) >>> 0 ? g + 1 | 0 : g, B = KI(B, I, 13) ^ _, E = g, r = KI(B, I = g ^ w, 17), e = w, y = KI(D, p, 21), h = t ^ w, t = c ^ y, i = 238 ^ KI(i, C, 32), g = w + h | 0, g = (c = I) + (I = (C = t + i | 0) >>> 0 < i >>> 0 ? g + 1 | 0 : g) | 0, i = g = (c = C + B | 0) >>> 0 < C >>> 0 ? g + 1 | 0 : g, e = KI(B = c ^ r, g ^= e, 13), y = w, t = KI(t, h, 16), h = I ^ w, r = C ^ t, C = KI(_, E, 32), I = w + h | 0, C = (_ = g) + (g = C >>> 0 > (E = r + C | 0) >>> 0 ? I + 1 | 0 : I) | 0, _ = C = (t = B + E | 0) >>> 0 < E >>> 0 ? C + 1 | 0 : C, e = KI(B = e ^ t, I = C ^ y, 17), y = w, C = KI(r, h, 21), h = g ^ w, r = C ^ E, C = KI(c, i, 32), g = w + h | 0, g = (C = C >>> 0 > (E = r + C | 0) >>> 0 ? g + 1 | 0 : g) + I | 0, i = g = (c = B + E | 0) >>> 0 < E >>> 0 ? g + 1 | 0 : g, e = KI(B = c ^ e, I = g ^ y, 13), y = w, g = KI(r, h, 16), h = C ^ w, r = g ^ E, g = KI(t, _, 32), C = w + h | 0, g = (C = g >>> 0 > (E = r + g | 0) >>> 0 ? C + 1 | 0 : C) + I | 0, _ = g = (t = B + E | 0) >>> 0 < E >>> 0 ? g + 1 | 0 : g, e = KI(B = e ^ t, I = g ^ y, 17), y = w, g = KI(r, h, 21), h = C ^ w, r = g ^ E, E = KI(c, i, 32), g = w + h | 0, I = (g = (C = r + E | 0) >>> 0 < E >>> 0 ? g + 1 | 0 : g) + I | 0, E = I = (i = C + B | 0) >>> 0 < C >>> 0 ? I + 1 | 0 : I, e = KI(B = i ^ e, I ^= y, 13), y = w, c = KI(r, h, 16), r = g ^ w, c ^= C, _ = KI(t, _, 32), g = w + r | 0, g = (t = I) + (I = (C = c + _ | 0) >>> 0 < _ >>> 0 ? g + 1 | 0 : g) | 0, _ = g = (t = C + B | 0) >>> 0 < C >>> 0 ? g + 1 | 0 : g, e = KI(B = e ^ t, g ^= y, 17), y = w, c = KI(c, r, 21), r = I ^ w, c ^= C, C = KI(i, E, 32), I = w + r | 0, C = (E = g) + (g = C >>> 0 > (i = c + C | 0) >>> 0 ? I + 1 | 0 : I) | 0, E = B = (C = (I = B + i | 0) >>> 0 < i >>> 0 ? C + 1 | 0 : C) ^ y, y = I ^ e, c = KI(c, r, 16), r = g ^ w, i = (c ^= i) + (_ = KI(t, _, 32)) | 0, g = w + r | 0, I = KI(I, C, 32), e = w, C = g = i >>> 0 < _ >>> 0 ? g + 1 | 0 : g, _ = A, c = (t = KI(c, r, 21) ^ i) ^ I ^ i ^ y, o[0 | _] = c, o[_ + 1 | 0] = c >>> 8, o[_ + 2 | 0] = c >>> 16, o[_ + 3 | 0] = c >>> 24, g = (c = g ^ w) ^ e ^ g ^ B, o[_ + 4 | 0] = g, o[_ + 5 | 0] = g >>> 8, o[_ + 6 | 0] = g >>> 16, o[_ + 7 | 0] = g >>> 24, B = _, g = c + e | 0, g = (A = I + t | 0) >>> 0 < I >>> 0 ? g + 1 | 0 : g, e = A, _ = KI(t, c, 16) ^ A, c = g, r = I = g ^ w, C = E + C | 0, y = (C = KI(i = (g = t = 221 ^ y) + i | 0, g = C = g >>> 0 > i >>> 0 ? C + 1 | 0 : C, 32)) + _ | 0, I = w + I | 0, f = KI(_, r, 21) ^ y, p = I = (_ = C >>> 0 > y >>> 0 ? I + 1 | 0 : I) ^ w, D = KI(f, I, 16), s = w, g = c + (r = g ^ (C = E << 13 | t >>> 19)) | 0, I = g = (C = A = e + (h = i ^ (t << 13 | E >>> 19)) | 0) >>> 0 < e >>> 0 ? g + 1 | 0 : g, A = KI(C, g, 32), g = p + w | 0, g = (i = (A = A + f | 0) >>> 0 < f >>> 0 ? g + 1 | 0 : g) ^ s, t = A, e = KI(s = D ^ A, g, 21), E = w, A = KI(h, r, 17), I = _ + (h = I ^ w) | 0, A = KI(C = y + (c = A ^ C) | 0, I = C >>> 0 < y >>> 0 ? I + 1 | 0 : I, 32), g = g + w | 0, r = g = (_ = E) ^ (E = (A = A + s | 0) >>> 0 < s >>> 0 ? g + 1 | 0 : g), e = KI(s = e ^ (_ = A), g, 16), y = w, A = KI(c, h, 13), g = i + (h = I ^ w) | 0, A = KI(I = t + (c = A ^ C) | 0, g = I >>> 0 < t >>> 0 ? g + 1 | 0 : g, 32), C = r + w | 0, r = i = (C = (A = A + s | 0) >>> 0 < s >>> 0 ? C + 1 | 0 : C) ^ y, t = A, e = KI(s = e ^ A, i, 21), y = w, A = KI(c, h, 17), g = E + (h = g ^ w) | 0, I = g = (i = _ + (c = A ^ I) | 0) >>> 0 < _ >>> 0 ? g + 1 | 0 : g, A = KI(i, g, 32), g = r + w | 0, r = g = (E = (A = A + s | 0) >>> 0 < s >>> 0 ? g + 1 | 0 : g) ^ y, e = KI(s = e ^ (_ = A), g, 16), y = w, A = KI(c, h, 13), C = C + (c = I ^ w) | 0, A = KI(g = t + (i ^= A) | 0, C = g >>> 0 < t >>> 0 ? C + 1 | 0 : C, 32), I = r + w | 0, e = KI((A = A + s | 0) ^ e, (I = A >>> 0 < s >>> 0 ? I + 1 | 0 : I) ^ y, 21), y = w, t = KI(i, c, 17), i = C ^ w, t = KI(C = g ^ t, i, 13), g = E + i | 0, E = KI(i = (C = C + _ | 0) ^ t, g = w ^ (C >>> 0 < _ >>> 0 ? g + 1 | 0 : g), 17) ^ e, C = w ^ y, g = I + g | 0, I = A, A = KI(A = A + i | 0, g = I >>> 0 > A >>> 0 ? g + 1 | 0 : g, 32) ^ E ^ A, o[B + 8 | 0] = A, o[B + 9 | 0] = A >>> 8, o[B + 10 | 0] = A >>> 16, o[B + 11 | 0] = A >>> 24, A = g ^ w ^ C, o[B + 12 | 0] = A, o[B + 13 | 0] = A >>> 8, o[B + 14 | 0] = A >>> 16, o[B + 15 | 0] = A >>> 24, 0;
                                        },
                                        Rj: function(A, I, g, C, B) {
                                            A |= 0, C |= 0, B |= 0;
                                            var Q, i = 0, _ = 0, c = 0, t = 0;
                                            if (h = Q = h - 112 | 0, i = I |= 0, I = g |= 0, i | g) {
                                                g = a[B + 28 | 0] | a[B + 29 | 0] << 8 | a[B + 30 | 0] << 16 | a[B + 31 | 0] << 24, E[Q + 24 >> 2] = a[B + 24 | 0] | a[B + 25 | 0] << 8 | a[B + 26 | 0] << 16 | a[B + 27 | 0] << 24, E[Q + 28 >> 2] = g, g = a[B + 20 | 0] | a[B + 21 | 0] << 8 | a[B + 22 | 0] << 16 | a[B + 23 | 0] << 24, E[Q + 16 >> 2] = a[B + 16 | 0] | a[B + 17 | 0] << 8 | a[B + 18 | 0] << 16 | a[B + 19 | 0] << 24, E[Q + 20 >> 2] = g, g = a[B + 4 | 0] | a[B + 5 | 0] << 8 | a[B + 6 | 0] << 16 | a[B + 7 | 0] << 24, E[Q >> 2] = a[0 | B] | a[B + 1 | 0] << 8 | a[B + 2 | 0] << 16 | a[B + 3 | 0] << 24, E[Q + 4 >> 2] = g, g = a[B + 12 | 0] | a[B + 13 | 0] << 8 | a[B + 14 | 0] << 16 | a[B + 15 | 0] << 24, E[Q + 8 >> 2] = a[B + 8 | 0] | a[B + 9 | 0] << 8 | a[B + 10 | 0] << 16 | a[B + 11 | 0] << 24, E[Q + 12 >> 2] = g, g = a[0 | C] | a[C + 1 | 0] << 8 | a[C + 2 | 0] << 16 | a[C + 3 | 0] << 24, C = a[C + 4 | 0] | a[C + 5 | 0] << 8 | a[C + 6 | 0] << 16 | a[C + 7 | 0] << 24, E[Q + 104 >> 2] = 0, E[Q + 108 >> 2] = 0, E[Q + 96 >> 2] = g, E[Q + 100 >> 2] = C;
                                                A: {
                                                    if (!I & i >>> 0 >= 64 | I) {
                                                        for(; IC(A, Q + 96 | 0, Q, 0), g = a[Q + 104 | 0] + 1 | 0, o[Q + 104 | 0] = g, g = a[Q + 105 | 0] + (g >>> 8 | 0) | 0, o[Q + 105 | 0] = g, g = a[Q + 106 | 0] + (g >>> 8 | 0) | 0, o[Q + 106 | 0] = g, g = a[Q + 107 | 0] + (g >>> 8 | 0) | 0, o[Q + 107 | 0] = g, g = a[Q + 108 | 0] + (g >>> 8 | 0) | 0, o[Q + 108 | 0] = g, g = a[Q + 109 | 0] + (g >>> 8 | 0) | 0, o[Q + 109 | 0] = g, g = a[Q + 110 | 0] + (g >>> 8 | 0) | 0, o[Q + 110 | 0] = g, o[Q + 111 | 0] = a[Q + 111 | 0] + (g >>> 8 | 0), A = A - -64 | 0, I = I - 1 | 0, !(I = (i = i + -64 | 0) >>> 0 < 4294967232 ? I + 1 | 0 : I) & i >>> 0 > 63 | I;);
                                                        if (!(I | i)) break A;
                                                    }
                                                    if (g = 0, IC(Q + 32 | 0, Q + 96 | 0, Q, 0), B = 3 & i, I = 0, i - 1 >>> 0 >= 3) for(i &= -4, C = 0; _ = t = Q + 32 | 0, o[A + I | 0] = a[_ + I | 0], o[(c = 1 | I) + A | 0] = a[_ + c | 0], o[(c = 2 | I) + A | 0] = a[_ + c | 0], o[(_ = 3 | I) + A | 0] = a[_ + t | 0], I = I + 4 | 0, (0 | i) != (0 | (C = C + 4 | 0)););
                                                    if (B) for(; o[A + I | 0] = a[(Q + 32 | 0) + I | 0], I = I + 1 | 0, (0 | B) != (0 | (g = g + 1 | 0)););
                                                }
                                                XC(Q + 32 | 0, 64), XC(Q, 32);
                                            }
                                            return h = Q + 112 | 0, 0;
                                        },
                                        Sj: function(A, I, g, C, B, Q) {
                                            A |= 0, I |= 0, B |= 0, Q |= 0;
                                            var i, _ = 0, c = 0;
                                            if (h = i = h - 112 | 0, _ = g |= 0, (C |= 0) | g) {
                                                g = a[Q + 28 | 0] | a[Q + 29 | 0] << 8 | a[Q + 30 | 0] << 16 | a[Q + 31 | 0] << 24, E[i + 24 >> 2] = a[Q + 24 | 0] | a[Q + 25 | 0] << 8 | a[Q + 26 | 0] << 16 | a[Q + 27 | 0] << 24, E[i + 28 >> 2] = g, g = a[Q + 20 | 0] | a[Q + 21 | 0] << 8 | a[Q + 22 | 0] << 16 | a[Q + 23 | 0] << 24, E[i + 16 >> 2] = a[Q + 16 | 0] | a[Q + 17 | 0] << 8 | a[Q + 18 | 0] << 16 | a[Q + 19 | 0] << 24, E[i + 20 >> 2] = g, g = a[Q + 4 | 0] | a[Q + 5 | 0] << 8 | a[Q + 6 | 0] << 16 | a[Q + 7 | 0] << 24, E[i >> 2] = a[0 | Q] | a[Q + 1 | 0] << 8 | a[Q + 2 | 0] << 16 | a[Q + 3 | 0] << 24, E[i + 4 >> 2] = g, g = a[Q + 12 | 0] | a[Q + 13 | 0] << 8 | a[Q + 14 | 0] << 16 | a[Q + 15 | 0] << 24, E[i + 8 >> 2] = a[Q + 8 | 0] | a[Q + 9 | 0] << 8 | a[Q + 10 | 0] << 16 | a[Q + 11 | 0] << 24, E[i + 12 >> 2] = g, g = a[0 | B] | a[B + 1 | 0] << 8 | a[B + 2 | 0] << 16 | a[B + 3 | 0] << 24, B = a[B + 4 | 0] | a[B + 5 | 0] << 8 | a[B + 6 | 0] << 16 | a[B + 7 | 0] << 24, E[i + 104 >> 2] = 0, E[i + 108 >> 2] = 0, E[i + 96 >> 2] = g, E[i + 100 >> 2] = B;
                                                A: {
                                                    if (!C & _ >>> 0 >= 64 | C) {
                                                        for(;;){
                                                            for(g = 0, IC(i + 32 | 0, i + 96 | 0, i, 0); Q = i + 32 | 0, o[A + g | 0] = a[Q + g | 0] ^ a[I + g | 0], o[(B = 1 | g) + A | 0] = a[B + Q | 0] ^ a[I + B | 0], 64 != (0 | (g = g + 2 | 0)););
                                                            if (g = a[i + 104 | 0] + 1 | 0, o[i + 104 | 0] = g, g = a[i + 105 | 0] + (g >>> 8 | 0) | 0, o[i + 105 | 0] = g, g = a[i + 106 | 0] + (g >>> 8 | 0) | 0, o[i + 106 | 0] = g, g = a[i + 107 | 0] + (g >>> 8 | 0) | 0, o[i + 107 | 0] = g, g = a[i + 108 | 0] + (g >>> 8 | 0) | 0, o[i + 108 | 0] = g, g = a[i + 109 | 0] + (g >>> 8 | 0) | 0, o[i + 109 | 0] = g, g = a[i + 110 | 0] + (g >>> 8 | 0) | 0, o[i + 110 | 0] = g, o[i + 111 | 0] = a[i + 111 | 0] + (g >>> 8 | 0), I = I - -64 | 0, A = A - -64 | 0, C = C - 1 | 0, !(!(C = (_ = _ + -64 | 0) >>> 0 < 4294967232 ? C + 1 | 0 : C) & _ >>> 0 > 63 | C)) break;
                                                        }
                                                        if (!(C | _)) break A;
                                                    }
                                                    if (g = 0, IC(i + 32 | 0, i + 96 | 0, i, 0), Q = 1 & _, 1 != (0 | _)) for(_ &= -2, C = 0; c = i + 32 | 0, o[A + g | 0] = a[c + g | 0] ^ a[I + g | 0], o[(B = 1 | g) + A | 0] = a[B + c | 0] ^ a[I + B | 0], g = g + 2 | 0, (0 | _) != (0 | (C = C + 2 | 0)););
                                                    Q && (o[A + g | 0] = a[(i + 32 | 0) + g | 0] ^ a[I + g | 0]);
                                                }
                                                XC(i + 32 | 0, 64), XC(i, 32);
                                            }
                                            return h = i + 112 | 0, 0;
                                        },
                                        Tj: BB,
                                        Uj: sB,
                                        Vj: tB,
                                        Wj: LC,
                                        Xj: function(A, I, g, C, B) {
                                            A |= 0, C |= 0, B |= 0;
                                            var Q, i = 0, _ = 0, c = 0, t = 0;
                                            if (h = Q = h - 112 | 0, i = I |= 0, I = g |= 0, i | g) {
                                                g = a[B + 28 | 0] | a[B + 29 | 0] << 8 | a[B + 30 | 0] << 16 | a[B + 31 | 0] << 24, E[Q + 24 >> 2] = a[B + 24 | 0] | a[B + 25 | 0] << 8 | a[B + 26 | 0] << 16 | a[B + 27 | 0] << 24, E[Q + 28 >> 2] = g, g = a[B + 20 | 0] | a[B + 21 | 0] << 8 | a[B + 22 | 0] << 16 | a[B + 23 | 0] << 24, E[Q + 16 >> 2] = a[B + 16 | 0] | a[B + 17 | 0] << 8 | a[B + 18 | 0] << 16 | a[B + 19 | 0] << 24, E[Q + 20 >> 2] = g, g = a[B + 4 | 0] | a[B + 5 | 0] << 8 | a[B + 6 | 0] << 16 | a[B + 7 | 0] << 24, E[Q >> 2] = a[0 | B] | a[B + 1 | 0] << 8 | a[B + 2 | 0] << 16 | a[B + 3 | 0] << 24, E[Q + 4 >> 2] = g, g = a[B + 12 | 0] | a[B + 13 | 0] << 8 | a[B + 14 | 0] << 16 | a[B + 15 | 0] << 24, E[Q + 8 >> 2] = a[B + 8 | 0] | a[B + 9 | 0] << 8 | a[B + 10 | 0] << 16 | a[B + 11 | 0] << 24, E[Q + 12 >> 2] = g, g = a[0 | C] | a[C + 1 | 0] << 8 | a[C + 2 | 0] << 16 | a[C + 3 | 0] << 24, C = a[C + 4 | 0] | a[C + 5 | 0] << 8 | a[C + 6 | 0] << 16 | a[C + 7 | 0] << 24, E[Q + 104 >> 2] = 0, E[Q + 108 >> 2] = 0, E[Q + 96 >> 2] = g, E[Q + 100 >> 2] = C;
                                                A: {
                                                    if (!I & i >>> 0 >= 64 | I) {
                                                        for(; gC(A, Q + 96 | 0, Q, 0), g = a[Q + 104 | 0] + 1 | 0, o[Q + 104 | 0] = g, g = a[Q + 105 | 0] + (g >>> 8 | 0) | 0, o[Q + 105 | 0] = g, g = a[Q + 106 | 0] + (g >>> 8 | 0) | 0, o[Q + 106 | 0] = g, g = a[Q + 107 | 0] + (g >>> 8 | 0) | 0, o[Q + 107 | 0] = g, g = a[Q + 108 | 0] + (g >>> 8 | 0) | 0, o[Q + 108 | 0] = g, g = a[Q + 109 | 0] + (g >>> 8 | 0) | 0, o[Q + 109 | 0] = g, g = a[Q + 110 | 0] + (g >>> 8 | 0) | 0, o[Q + 110 | 0] = g, o[Q + 111 | 0] = a[Q + 111 | 0] + (g >>> 8 | 0), A = A - -64 | 0, I = I - 1 | 0, !(I = (i = i + -64 | 0) >>> 0 < 4294967232 ? I + 1 | 0 : I) & i >>> 0 > 63 | I;);
                                                        if (!(I | i)) break A;
                                                    }
                                                    if (g = 0, gC(Q + 32 | 0, Q + 96 | 0, Q, 0), B = 3 & i, I = 0, i - 1 >>> 0 >= 3) for(i &= -4, C = 0; _ = t = Q + 32 | 0, o[A + I | 0] = a[_ + I | 0], o[(c = 1 | I) + A | 0] = a[_ + c | 0], o[(c = 2 | I) + A | 0] = a[_ + c | 0], o[(_ = 3 | I) + A | 0] = a[_ + t | 0], I = I + 4 | 0, (0 | i) != (0 | (C = C + 4 | 0)););
                                                    if (B) for(; o[A + I | 0] = a[(Q + 32 | 0) + I | 0], I = I + 1 | 0, (0 | B) != (0 | (g = g + 1 | 0)););
                                                }
                                                XC(Q + 32 | 0, 64), XC(Q, 32);
                                            }
                                            return h = Q + 112 | 0, 0;
                                        },
                                        Yj: function(A, I, g, C, B, Q) {
                                            A |= 0, I |= 0, B |= 0, Q |= 0;
                                            var i, _ = 0, c = 0;
                                            if (h = i = h - 112 | 0, _ = g |= 0, (C |= 0) | g) {
                                                g = a[Q + 28 | 0] | a[Q + 29 | 0] << 8 | a[Q + 30 | 0] << 16 | a[Q + 31 | 0] << 24, E[i + 24 >> 2] = a[Q + 24 | 0] | a[Q + 25 | 0] << 8 | a[Q + 26 | 0] << 16 | a[Q + 27 | 0] << 24, E[i + 28 >> 2] = g, g = a[Q + 20 | 0] | a[Q + 21 | 0] << 8 | a[Q + 22 | 0] << 16 | a[Q + 23 | 0] << 24, E[i + 16 >> 2] = a[Q + 16 | 0] | a[Q + 17 | 0] << 8 | a[Q + 18 | 0] << 16 | a[Q + 19 | 0] << 24, E[i + 20 >> 2] = g, g = a[Q + 4 | 0] | a[Q + 5 | 0] << 8 | a[Q + 6 | 0] << 16 | a[Q + 7 | 0] << 24, E[i >> 2] = a[0 | Q] | a[Q + 1 | 0] << 8 | a[Q + 2 | 0] << 16 | a[Q + 3 | 0] << 24, E[i + 4 >> 2] = g, g = a[Q + 12 | 0] | a[Q + 13 | 0] << 8 | a[Q + 14 | 0] << 16 | a[Q + 15 | 0] << 24, E[i + 8 >> 2] = a[Q + 8 | 0] | a[Q + 9 | 0] << 8 | a[Q + 10 | 0] << 16 | a[Q + 11 | 0] << 24, E[i + 12 >> 2] = g, g = a[0 | B] | a[B + 1 | 0] << 8 | a[B + 2 | 0] << 16 | a[B + 3 | 0] << 24, B = a[B + 4 | 0] | a[B + 5 | 0] << 8 | a[B + 6 | 0] << 16 | a[B + 7 | 0] << 24, E[i + 104 >> 2] = 0, E[i + 108 >> 2] = 0, E[i + 96 >> 2] = g, E[i + 100 >> 2] = B;
                                                A: {
                                                    if (!C & _ >>> 0 >= 64 | C) {
                                                        for(;;){
                                                            for(g = 0, gC(i + 32 | 0, i + 96 | 0, i, 0); Q = i + 32 | 0, o[A + g | 0] = a[Q + g | 0] ^ a[I + g | 0], o[(B = 1 | g) + A | 0] = a[B + Q | 0] ^ a[I + B | 0], 64 != (0 | (g = g + 2 | 0)););
                                                            if (g = a[i + 104 | 0] + 1 | 0, o[i + 104 | 0] = g, g = a[i + 105 | 0] + (g >>> 8 | 0) | 0, o[i + 105 | 0] = g, g = a[i + 106 | 0] + (g >>> 8 | 0) | 0, o[i + 106 | 0] = g, g = a[i + 107 | 0] + (g >>> 8 | 0) | 0, o[i + 107 | 0] = g, g = a[i + 108 | 0] + (g >>> 8 | 0) | 0, o[i + 108 | 0] = g, g = a[i + 109 | 0] + (g >>> 8 | 0) | 0, o[i + 109 | 0] = g, g = a[i + 110 | 0] + (g >>> 8 | 0) | 0, o[i + 110 | 0] = g, o[i + 111 | 0] = a[i + 111 | 0] + (g >>> 8 | 0), I = I - -64 | 0, A = A - -64 | 0, C = C - 1 | 0, !(!(C = (_ = _ + -64 | 0) >>> 0 < 4294967232 ? C + 1 | 0 : C) & _ >>> 0 > 63 | C)) break;
                                                        }
                                                        if (!(C | _)) break A;
                                                    }
                                                    if (g = 0, gC(i + 32 | 0, i + 96 | 0, i, 0), Q = 1 & _, 1 != (0 | _)) for(_ &= -2, C = 0; c = i + 32 | 0, o[A + g | 0] = a[c + g | 0] ^ a[I + g | 0], o[(B = 1 | g) + A | 0] = a[B + c | 0] ^ a[I + B | 0], g = g + 2 | 0, (0 | _) != (0 | (C = C + 2 | 0)););
                                                    Q && (o[A + g | 0] = a[(i + 32 | 0) + g | 0] ^ a[I + g | 0]);
                                                }
                                                XC(i + 32 | 0, 64), XC(i, 32);
                                            }
                                            return h = i + 112 | 0, 0;
                                        },
                                        Zj: BB,
                                        _j: sB,
                                        $j: tB,
                                        ak: LC,
                                        bk: BB,
                                        ck: _B,
                                        dk: tB,
                                        ek: function(A, I, g, C, B) {
                                            var Q;
                                            return A |= 0, I |= 0, g |= 0, h = Q = h - 32 | 0, yA(Q, C |= 0, B |= 0, 0), A = jg(A, I, g, C + 16 | 0, Q), h = Q + 32 | 0, 0 | A;
                                        },
                                        fk: function(A, I, g, C, B, Q, i, o) {
                                            var E;
                                            return A |= 0, I |= 0, g |= 0, C |= 0, Q |= 0, i |= 0, h = E = h - 32 | 0, yA(E, B |= 0, o |= 0, 0), A = Ug(o = A, I, (A = 0) | g, C, B + 16 | 0, A | Q, i, E), h = E + 32 | 0, 0 | A;
                                        },
                                        gk: function(A, I, g, C, B, Q) {
                                            var i;
                                            return A |= 0, I |= 0, g |= 0, C |= 0, h = i = h - 32 | 0, yA(i, B |= 0, Q |= 0, 0), A = Ug(A, I, g, C, B + 16 | 0, 0, 0, i), h = i + 32 | 0, 0 | A;
                                        },
                                        hk: LC,
                                        ik: K,
                                        jk: gA,
                                        kk: pB
                                    };
                                }(A);
                            }(I);
                        },
                        instantiate: function(A, I) {
                            return {
                                then: function(g) {
                                    var C = new s.Module(A);
                                    g({
                                        instance: new s.Instance(C, I)
                                    });
                                }
                            };
                        },
                        RuntimeError: Error
                    };
                    r = [], "object" != typeof s && d("no native wasm support detected");
                    var h, D, p, w, f, n, k, F = !1;
                    function N() {
                        var A = y.buffer;
                        Q.HEAP8 = h = new Int8Array(A), Q.HEAP16 = p = new Int16Array(A), Q.HEAPU8 = D = new Uint8Array(A), Q.HEAPU16 = new Uint16Array(A), Q.HEAP32 = w = new Int32Array(A), Q.HEAPU32 = f = new Uint32Array(A), Q.HEAPF32 = n = new Float32Array(A), Q.HEAPF64 = k = new Float64Array(A);
                    }
                    var S = Q.INITIAL_MEMORY || 50331648;
                    S >= 65536 || d("INITIAL_MEMORY should be larger than STACK_SIZE, was " + S + "! (STACK_SIZE=65536)"), y = Q.wasmMemory ? Q.wasmMemory : new s.Memory({
                        initial: S / 65536,
                        maximum: 32768
                    }), N(), S = y.buffer.byteLength;
                    var G = [], M = [], b = [], K = 0, H = null, Y = null;
                    function d(A) {
                        throw Q.onAbort && Q.onAbort(A), e(A = "Aborted(" + A + ")"), F = !0, A += ". Build with -sASSERTIONS for more info.", new s.RuntimeError(A);
                    }
                    var J, U, l = "data:application/octet-stream;base64,";
                    function m(A) {
                        return A.startsWith(l);
                    }
                    m(J = "<<< WASM_BINARY_FILE >>>") || (U = J, J = Q.locateFile ? Q.locateFile(U, _) : _ + U);
                    var u, x = {
                        36800: ()=>Q.getRandomValue(),
                        36836: ()=>{
                            if (void 0 === Q.getRandomValue) try {
                                var A = "object" == typeof window ? window : self, I = void 0 !== A.crypto ? A.crypto : A.msCrypto, g = function() {
                                    var A = new Uint32Array(1);
                                    return I.getRandomValues(A), A[0] >>> 0;
                                };
                                g(), Q.getRandomValue = g;
                            } catch (A) {
                                try {
                                    var C = (parcelRequire("aO8Ot")), B = function() {
                                        var A = C.randomBytes(4);
                                        return (A[0] << 24 | A[1] << 16 | A[2] << 8 | A[3]) >>> 0;
                                    };
                                    B(), Q.getRandomValue = B;
                                } catch (A) {
                                    throw "No secure random number generator found";
                                }
                            }
                        }
                    }, R = (A)=>{
                        for(; A.length > 0;)A.shift()(Q);
                    }, v = "undefined" != typeof TextDecoder ? new TextDecoder("utf8") : void 0, L = (A, I)=>A ? ((A, I, g)=>{
                            for(var C = I + g, B = I; A[B] && !(B >= C);)++B;
                            if (B - I > 16 && A.buffer && v) return v.decode(A.subarray(I, B));
                            for(var Q = ""; I < B;){
                                var i = A[I++];
                                if (128 & i) {
                                    var o = 63 & A[I++];
                                    if (192 != (224 & i)) {
                                        var E = 63 & A[I++];
                                        if ((i = 224 == (240 & i) ? (15 & i) << 12 | o << 6 | E : (7 & i) << 18 | o << 12 | E << 6 | 63 & A[I++]) < 65536) Q += String.fromCharCode(i);
                                        else {
                                            var a = i - 65536;
                                            Q += String.fromCharCode(55296 | a >> 10, 56320 | 1023 & a);
                                        }
                                    } else Q += String.fromCharCode((31 & i) << 6 | o);
                                } else Q += String.fromCharCode(i);
                            }
                            return Q;
                        })(D, A, I) : "", P = [], q = (A)=>{
                        var I = (A - y.buffer.byteLength + 65535) / 65536;
                        try {
                            return y.grow(I), N(), 1;
                        } catch (A) {}
                    }, z = {
                        c: (A, I, g, C)=>{
                            d(`Assertion failed: ${L(A)}, at: ` + [
                                I ? L(I) : "unknown filename",
                                g,
                                C ? L(C) : "unknown function"
                            ]);
                        },
                        d: ()=>{
                            d("");
                        },
                        b: (A, I, g)=>((A, I, g)=>{
                                var C = ((A, I)=>{
                                    var g;
                                    for(P.length = 0; g = D[A++];)I += 105 != g && I % 8 ? 4 : 0, P.push(105 == g ? w[I >> 2] : k[I >> 3]), I += 105 == g ? 4 : 8;
                                    return P;
                                })(I, g);
                                return x[A].apply(null, C);
                            })(A, I, g),
                        e: (A)=>{
                            var I = D.length, g = 2147483648;
                            if ((A >>>= 0) > g) return !1;
                            for(var C, B = 1; B <= 4; B *= 2){
                                var Q = I * (1 + .2 / B);
                                Q = Math.min(Q, A + 100663296);
                                var i = Math.min(g, (C = Math.max(A, Q)) + (65536 - C % 65536) % 65536);
                                if (q(i)) return !0;
                            }
                            return !1;
                        },
                        a: y
                    }, j = function() {
                        var A, I, g = {
                            a: z
                        };
                        function C(A, I) {
                            var g, C = A.exports;
                            return (j = C).kk, g = j.f, M.unshift(g), function(A) {
                                if (K--, Q.monitorRunDependencies && Q.monitorRunDependencies(K), 0 == K && (null !== H && (clearInterval(H), H = null), Y)) {
                                    var I = Y;
                                    Y = null, I();
                                }
                            }(), C;
                        }
                        if (K++, Q.monitorRunDependencies && Q.monitorRunDependencies(K), Q.instantiateWasm) try {
                            return Q.instantiateWasm(g, C);
                        } catch (A) {
                            return e(`Module.instantiateWasm callback failed with error: ${A}`), !1;
                        }
                        return A = g, I = function(A) {
                            C(A.instance);
                        }, (function(A) {
                            return Promise.resolve().then(()=>(function(A) {
                                    if (A == J && r) return new Uint8Array(r);
                                    var I = function(A) {
                                        if (m(A)) return function(A) {
                                            if (void 0 !== a && a) {
                                                var I = $25e5cd8cfcef32a3$require$Buffer.from(A, "base64");
                                                return new Uint8Array(I.buffer, I.byteOffset, I.length);
                                            }
                                            try {
                                                for(var g = atob(A), C = new Uint8Array(g.length), B = 0; B < g.length; ++B)C[B] = g.charCodeAt(B);
                                                return C;
                                            } catch (A) {
                                                throw new Error("Converting base64 string to bytes failed.");
                                            }
                                        }(A.slice(l.length));
                                    }(A);
                                    if (I) return I;
                                    if (B) return B(A);
                                    throw "both async and sync fetching of the wasm failed";
                                })(A));
                        })(J).then((I)=>s.instantiate(I, A)).then((A)=>A).then(I, (A)=>{
                            e(`failed to asynchronously prepare wasm: ${A}`), d(A);
                        }), {};
                    }();
                    function X() {
                        function A() {
                            u || (u = !0, Q.calledRun = !0, F || (R(M), Q.onRuntimeInitialized && Q.onRuntimeInitialized(), function() {
                                if (Q.postRun) for("function" == typeof Q.postRun && (Q.postRun = [
                                    Q.postRun
                                ]); Q.postRun.length;)A = Q.postRun.shift(), b.unshift(A);
                                var A;
                                R(b);
                            }()));
                        }
                        K > 0 || (function() {
                            if (Q.preRun) for("function" == typeof Q.preRun && (Q.preRun = [
                                Q.preRun
                            ]); Q.preRun.length;)A = Q.preRun.shift(), G.unshift(A);
                            var A;
                            R(G);
                        }(), K > 0 || (Q.setStatus ? (Q.setStatus("Running..."), setTimeout(function() {
                            setTimeout(function() {
                                Q.setStatus("");
                            }, 1), A();
                        }, 1)) : A()));
                    }
                    if (Q._crypto_aead_aegis128l_keybytes = ()=>(Q._crypto_aead_aegis128l_keybytes = j.g)(), Q._crypto_aead_aegis128l_nsecbytes = ()=>(Q._crypto_aead_aegis128l_nsecbytes = j.h)(), Q._crypto_aead_aegis128l_npubbytes = ()=>(Q._crypto_aead_aegis128l_npubbytes = j.i)(), Q._crypto_aead_aegis128l_abytes = ()=>(Q._crypto_aead_aegis128l_abytes = j.j)(), Q._crypto_aead_aegis128l_messagebytes_max = ()=>(Q._crypto_aead_aegis128l_messagebytes_max = j.k)(), Q._crypto_aead_aegis128l_keygen = (A)=>(Q._crypto_aead_aegis128l_keygen = j.l)(A), Q._crypto_aead_aegis128l_encrypt = (A, I, g, C, B, i, o, E, a, _, c)=>(Q._crypto_aead_aegis128l_encrypt = j.m)(A, I, g, C, B, i, o, E, a, _, c), Q._crypto_aead_aegis128l_encrypt_detached = (A, I, g, C, B, i, o, E, a, _, c, t)=>(Q._crypto_aead_aegis128l_encrypt_detached = j.n)(A, I, g, C, B, i, o, E, a, _, c, t), Q._crypto_aead_aegis128l_decrypt = (A, I, g, C, B, i, o, E, a, _, c)=>(Q._crypto_aead_aegis128l_decrypt = j.o)(A, I, g, C, B, i, o, E, a, _, c), Q._crypto_aead_aegis128l_decrypt_detached = (A, I, g, C, B, i, o, E, a, _, c)=>(Q._crypto_aead_aegis128l_decrypt_detached = j.p)(A, I, g, C, B, i, o, E, a, _, c), Q._crypto_aead_aegis256_keybytes = ()=>(Q._crypto_aead_aegis256_keybytes = j.q)(), Q._crypto_aead_aegis256_nsecbytes = ()=>(Q._crypto_aead_aegis256_nsecbytes = j.r)(), Q._crypto_aead_aegis256_npubbytes = ()=>(Q._crypto_aead_aegis256_npubbytes = j.s)(), Q._crypto_aead_aegis256_abytes = ()=>(Q._crypto_aead_aegis256_abytes = j.t)(), Q._crypto_aead_aegis256_messagebytes_max = ()=>(Q._crypto_aead_aegis256_messagebytes_max = j.u)(), Q._crypto_aead_aegis256_keygen = (A)=>(Q._crypto_aead_aegis256_keygen = j.v)(A), Q._crypto_aead_aegis256_encrypt = (A, I, g, C, B, i, o, E, a, _, c)=>(Q._crypto_aead_aegis256_encrypt = j.w)(A, I, g, C, B, i, o, E, a, _, c), Q._crypto_aead_aegis256_encrypt_detached = (A, I, g, C, B, i, o, E, a, _, c, t)=>(Q._crypto_aead_aegis256_encrypt_detached = j.x)(A, I, g, C, B, i, o, E, a, _, c, t), Q._crypto_aead_aegis256_decrypt = (A, I, g, C, B, i, o, E, a, _, c)=>(Q._crypto_aead_aegis256_decrypt = j.y)(A, I, g, C, B, i, o, E, a, _, c), Q._crypto_aead_aegis256_decrypt_detached = (A, I, g, C, B, i, o, E, a, _, c)=>(Q._crypto_aead_aegis256_decrypt_detached = j.z)(A, I, g, C, B, i, o, E, a, _, c), Q._crypto_aead_chacha20poly1305_encrypt_detached = (A, I, g, C, B, i, o, E, a, _, c, t)=>(Q._crypto_aead_chacha20poly1305_encrypt_detached = j.A)(A, I, g, C, B, i, o, E, a, _, c, t), Q._crypto_aead_chacha20poly1305_encrypt = (A, I, g, C, B, i, o, E, a, _, c)=>(Q._crypto_aead_chacha20poly1305_encrypt = j.B)(A, I, g, C, B, i, o, E, a, _, c), Q._crypto_aead_chacha20poly1305_ietf_encrypt_detached = (A, I, g, C, B, i, o, E, a, _, c, t)=>(Q._crypto_aead_chacha20poly1305_ietf_encrypt_detached = j.C)(A, I, g, C, B, i, o, E, a, _, c, t), Q._crypto_aead_chacha20poly1305_ietf_encrypt = (A, I, g, C, B, i, o, E, a, _, c)=>(Q._crypto_aead_chacha20poly1305_ietf_encrypt = j.D)(A, I, g, C, B, i, o, E, a, _, c), Q._crypto_aead_chacha20poly1305_decrypt_detached = (A, I, g, C, B, i, o, E, a, _, c)=>(Q._crypto_aead_chacha20poly1305_decrypt_detached = j.E)(A, I, g, C, B, i, o, E, a, _, c), Q._crypto_aead_chacha20poly1305_decrypt = (A, I, g, C, B, i, o, E, a, _, c)=>(Q._crypto_aead_chacha20poly1305_decrypt = j.F)(A, I, g, C, B, i, o, E, a, _, c), Q._crypto_aead_chacha20poly1305_ietf_decrypt_detached = (A, I, g, C, B, i, o, E, a, _, c)=>(Q._crypto_aead_chacha20poly1305_ietf_decrypt_detached = j.G)(A, I, g, C, B, i, o, E, a, _, c), Q._crypto_aead_chacha20poly1305_ietf_decrypt = (A, I, g, C, B, i, o, E, a, _, c)=>(Q._crypto_aead_chacha20poly1305_ietf_decrypt = j.H)(A, I, g, C, B, i, o, E, a, _, c), Q._crypto_aead_chacha20poly1305_ietf_keybytes = ()=>(Q._crypto_aead_chacha20poly1305_ietf_keybytes = j.I)(), Q._crypto_aead_chacha20poly1305_ietf_npubbytes = ()=>(Q._crypto_aead_chacha20poly1305_ietf_npubbytes = j.J)(), Q._crypto_aead_chacha20poly1305_ietf_nsecbytes = ()=>(Q._crypto_aead_chacha20poly1305_ietf_nsecbytes = j.K)(), Q._crypto_aead_chacha20poly1305_ietf_abytes = ()=>(Q._crypto_aead_chacha20poly1305_ietf_abytes = j.L)(), Q._crypto_aead_chacha20poly1305_ietf_messagebytes_max = ()=>(Q._crypto_aead_chacha20poly1305_ietf_messagebytes_max = j.M)(), Q._crypto_aead_chacha20poly1305_ietf_keygen = (A)=>(Q._crypto_aead_chacha20poly1305_ietf_keygen = j.N)(A), Q._crypto_aead_chacha20poly1305_keybytes = ()=>(Q._crypto_aead_chacha20poly1305_keybytes = j.O)(), Q._crypto_aead_chacha20poly1305_npubbytes = ()=>(Q._crypto_aead_chacha20poly1305_npubbytes = j.P)(), Q._crypto_aead_chacha20poly1305_nsecbytes = ()=>(Q._crypto_aead_chacha20poly1305_nsecbytes = j.Q)(), Q._crypto_aead_chacha20poly1305_abytes = ()=>(Q._crypto_aead_chacha20poly1305_abytes = j.R)(), Q._crypto_aead_chacha20poly1305_messagebytes_max = ()=>(Q._crypto_aead_chacha20poly1305_messagebytes_max = j.S)(), Q._crypto_aead_chacha20poly1305_keygen = (A)=>(Q._crypto_aead_chacha20poly1305_keygen = j.T)(A), Q._crypto_aead_xchacha20poly1305_ietf_encrypt_detached = (A, I, g, C, B, i, o, E, a, _, c, t)=>(Q._crypto_aead_xchacha20poly1305_ietf_encrypt_detached = j.U)(A, I, g, C, B, i, o, E, a, _, c, t), Q._crypto_aead_xchacha20poly1305_ietf_encrypt = (A, I, g, C, B, i, o, E, a, _, c)=>(Q._crypto_aead_xchacha20poly1305_ietf_encrypt = j.V)(A, I, g, C, B, i, o, E, a, _, c), Q._crypto_aead_xchacha20poly1305_ietf_decrypt_detached = (A, I, g, C, B, i, o, E, a, _, c)=>(Q._crypto_aead_xchacha20poly1305_ietf_decrypt_detached = j.W)(A, I, g, C, B, i, o, E, a, _, c), Q._crypto_aead_xchacha20poly1305_ietf_decrypt = (A, I, g, C, B, i, o, E, a, _, c)=>(Q._crypto_aead_xchacha20poly1305_ietf_decrypt = j.X)(A, I, g, C, B, i, o, E, a, _, c), Q._crypto_aead_xchacha20poly1305_ietf_keybytes = ()=>(Q._crypto_aead_xchacha20poly1305_ietf_keybytes = j.Y)(), Q._crypto_aead_xchacha20poly1305_ietf_npubbytes = ()=>(Q._crypto_aead_xchacha20poly1305_ietf_npubbytes = j.Z)(), Q._crypto_aead_xchacha20poly1305_ietf_nsecbytes = ()=>(Q._crypto_aead_xchacha20poly1305_ietf_nsecbytes = j._)(), Q._crypto_aead_xchacha20poly1305_ietf_abytes = ()=>(Q._crypto_aead_xchacha20poly1305_ietf_abytes = j.$)(), Q._crypto_aead_xchacha20poly1305_ietf_messagebytes_max = ()=>(Q._crypto_aead_xchacha20poly1305_ietf_messagebytes_max = j.aa)(), Q._crypto_aead_xchacha20poly1305_ietf_keygen = (A)=>(Q._crypto_aead_xchacha20poly1305_ietf_keygen = j.ba)(A), Q._crypto_auth_bytes = ()=>(Q._crypto_auth_bytes = j.ca)(), Q._crypto_auth_keybytes = ()=>(Q._crypto_auth_keybytes = j.da)(), Q._crypto_auth_primitive = ()=>(Q._crypto_auth_primitive = j.ea)(), Q._crypto_auth = (A, I, g, C, B)=>(Q._crypto_auth = j.fa)(A, I, g, C, B), Q._crypto_auth_verify = (A, I, g, C, B)=>(Q._crypto_auth_verify = j.ga)(A, I, g, C, B), Q._crypto_auth_keygen = (A)=>(Q._crypto_auth_keygen = j.ha)(A), Q._crypto_auth_hmacsha256_bytes = ()=>(Q._crypto_auth_hmacsha256_bytes = j.ia)(), Q._crypto_auth_hmacsha256_keybytes = ()=>(Q._crypto_auth_hmacsha256_keybytes = j.ja)(), Q._crypto_auth_hmacsha256_statebytes = ()=>(Q._crypto_auth_hmacsha256_statebytes = j.ka)(), Q._crypto_auth_hmacsha256_keygen = (A)=>(Q._crypto_auth_hmacsha256_keygen = j.la)(A), Q._crypto_auth_hmacsha256_init = (A, I, g)=>(Q._crypto_auth_hmacsha256_init = j.ma)(A, I, g), Q._crypto_auth_hmacsha256_update = (A, I, g, C)=>(Q._crypto_auth_hmacsha256_update = j.na)(A, I, g, C), Q._crypto_auth_hmacsha256_final = (A, I)=>(Q._crypto_auth_hmacsha256_final = j.oa)(A, I), Q._crypto_auth_hmacsha256 = (A, I, g, C, B)=>(Q._crypto_auth_hmacsha256 = j.pa)(A, I, g, C, B), Q._crypto_auth_hmacsha256_verify = (A, I, g, C, B)=>(Q._crypto_auth_hmacsha256_verify = j.qa)(A, I, g, C, B), Q._crypto_auth_hmacsha512_bytes = ()=>(Q._crypto_auth_hmacsha512_bytes = j.ra)(), Q._crypto_auth_hmacsha512_keybytes = ()=>(Q._crypto_auth_hmacsha512_keybytes = j.sa)(), Q._crypto_auth_hmacsha512_statebytes = ()=>(Q._crypto_auth_hmacsha512_statebytes = j.ta)(), Q._crypto_auth_hmacsha512_keygen = (A)=>(Q._crypto_auth_hmacsha512_keygen = j.ua)(A), Q._crypto_auth_hmacsha512_init = (A, I, g)=>(Q._crypto_auth_hmacsha512_init = j.va)(A, I, g), Q._crypto_auth_hmacsha512_update = (A, I, g, C)=>(Q._crypto_auth_hmacsha512_update = j.wa)(A, I, g, C), Q._crypto_auth_hmacsha512_final = (A, I)=>(Q._crypto_auth_hmacsha512_final = j.xa)(A, I), Q._crypto_auth_hmacsha512 = (A, I, g, C, B)=>(Q._crypto_auth_hmacsha512 = j.ya)(A, I, g, C, B), Q._crypto_auth_hmacsha512_verify = (A, I, g, C, B)=>(Q._crypto_auth_hmacsha512_verify = j.za)(A, I, g, C, B), Q._crypto_auth_hmacsha512256_bytes = ()=>(Q._crypto_auth_hmacsha512256_bytes = j.Aa)(), Q._crypto_auth_hmacsha512256_keybytes = ()=>(Q._crypto_auth_hmacsha512256_keybytes = j.Ba)(), Q._crypto_auth_hmacsha512256_statebytes = ()=>(Q._crypto_auth_hmacsha512256_statebytes = j.Ca)(), Q._crypto_auth_hmacsha512256_keygen = (A)=>(Q._crypto_auth_hmacsha512256_keygen = j.Da)(A), Q._crypto_auth_hmacsha512256_init = (A, I, g)=>(Q._crypto_auth_hmacsha512256_init = j.Ea)(A, I, g), Q._crypto_auth_hmacsha512256_update = (A, I, g, C)=>(Q._crypto_auth_hmacsha512256_update = j.Fa)(A, I, g, C), Q._crypto_auth_hmacsha512256_final = (A, I)=>(Q._crypto_auth_hmacsha512256_final = j.Ga)(A, I), Q._crypto_auth_hmacsha512256 = (A, I, g, C, B)=>(Q._crypto_auth_hmacsha512256 = j.Ha)(A, I, g, C, B), Q._crypto_auth_hmacsha512256_verify = (A, I, g, C, B)=>(Q._crypto_auth_hmacsha512256_verify = j.Ia)(A, I, g, C, B), Q._crypto_box_seedbytes = ()=>(Q._crypto_box_seedbytes = j.Ja)(), Q._crypto_box_publickeybytes = ()=>(Q._crypto_box_publickeybytes = j.Ka)(), Q._crypto_box_secretkeybytes = ()=>(Q._crypto_box_secretkeybytes = j.La)(), Q._crypto_box_beforenmbytes = ()=>(Q._crypto_box_beforenmbytes = j.Ma)(), Q._crypto_box_noncebytes = ()=>(Q._crypto_box_noncebytes = j.Na)(), Q._crypto_box_zerobytes = ()=>(Q._crypto_box_zerobytes = j.Oa)(), Q._crypto_box_boxzerobytes = ()=>(Q._crypto_box_boxzerobytes = j.Pa)(), Q._crypto_box_macbytes = ()=>(Q._crypto_box_macbytes = j.Qa)(), Q._crypto_box_messagebytes_max = ()=>(Q._crypto_box_messagebytes_max = j.Ra)(), Q._crypto_box_primitive = ()=>(Q._crypto_box_primitive = j.Sa)(), Q._crypto_box_seed_keypair = (A, I, g)=>(Q._crypto_box_seed_keypair = j.Ta)(A, I, g), Q._crypto_box_keypair = (A, I)=>(Q._crypto_box_keypair = j.Ua)(A, I), Q._crypto_box_beforenm = (A, I, g)=>(Q._crypto_box_beforenm = j.Va)(A, I, g), Q._crypto_box_afternm = (A, I, g, C, B, i)=>(Q._crypto_box_afternm = j.Wa)(A, I, g, C, B, i), Q._crypto_box_open_afternm = (A, I, g, C, B, i)=>(Q._crypto_box_open_afternm = j.Xa)(A, I, g, C, B, i), Q._crypto_box = (A, I, g, C, B, i, o)=>(Q._crypto_box = j.Ya)(A, I, g, C, B, i, o), Q._crypto_box_open = (A, I, g, C, B, i, o)=>(Q._crypto_box_open = j.Za)(A, I, g, C, B, i, o), Q._crypto_box_detached_afternm = (A, I, g, C, B, i, o)=>(Q._crypto_box_detached_afternm = j._a)(A, I, g, C, B, i, o), Q._crypto_box_detached = (A, I, g, C, B, i, o, E)=>(Q._crypto_box_detached = j.$a)(A, I, g, C, B, i, o, E), Q._crypto_box_easy_afternm = (A, I, g, C, B, i)=>(Q._crypto_box_easy_afternm = j.ab)(A, I, g, C, B, i), Q._crypto_box_easy = (A, I, g, C, B, i, o)=>(Q._crypto_box_easy = j.bb)(A, I, g, C, B, i, o), Q._crypto_box_open_detached_afternm = (A, I, g, C, B, i, o)=>(Q._crypto_box_open_detached_afternm = j.cb)(A, I, g, C, B, i, o), Q._crypto_box_open_detached = (A, I, g, C, B, i, o, E)=>(Q._crypto_box_open_detached = j.db)(A, I, g, C, B, i, o, E), Q._crypto_box_open_easy_afternm = (A, I, g, C, B, i)=>(Q._crypto_box_open_easy_afternm = j.eb)(A, I, g, C, B, i), Q._crypto_box_open_easy = (A, I, g, C, B, i, o)=>(Q._crypto_box_open_easy = j.fb)(A, I, g, C, B, i, o), Q._crypto_box_seal = (A, I, g, C, B)=>(Q._crypto_box_seal = j.gb)(A, I, g, C, B), Q._crypto_box_seal_open = (A, I, g, C, B, i)=>(Q._crypto_box_seal_open = j.hb)(A, I, g, C, B, i), Q._crypto_box_sealbytes = ()=>(Q._crypto_box_sealbytes = j.ib)(), Q._crypto_box_curve25519xsalsa20poly1305_seed_keypair = (A, I, g)=>(Q._crypto_box_curve25519xsalsa20poly1305_seed_keypair = j.jb)(A, I, g), Q._crypto_box_curve25519xsalsa20poly1305_keypair = (A, I)=>(Q._crypto_box_curve25519xsalsa20poly1305_keypair = j.kb)(A, I), Q._crypto_box_curve25519xsalsa20poly1305_beforenm = (A, I, g)=>(Q._crypto_box_curve25519xsalsa20poly1305_beforenm = j.lb)(A, I, g), Q._crypto_box_curve25519xsalsa20poly1305_afternm = (A, I, g, C, B, i)=>(Q._crypto_box_curve25519xsalsa20poly1305_afternm = j.mb)(A, I, g, C, B, i), Q._crypto_box_curve25519xsalsa20poly1305_open_afternm = (A, I, g, C, B, i)=>(Q._crypto_box_curve25519xsalsa20poly1305_open_afternm = j.nb)(A, I, g, C, B, i), Q._crypto_box_curve25519xsalsa20poly1305 = (A, I, g, C, B, i, o)=>(Q._crypto_box_curve25519xsalsa20poly1305 = j.ob)(A, I, g, C, B, i, o), Q._crypto_box_curve25519xsalsa20poly1305_open = (A, I, g, C, B, i, o)=>(Q._crypto_box_curve25519xsalsa20poly1305_open = j.pb)(A, I, g, C, B, i, o), Q._crypto_box_curve25519xsalsa20poly1305_seedbytes = ()=>(Q._crypto_box_curve25519xsalsa20poly1305_seedbytes = j.qb)(), Q._crypto_box_curve25519xsalsa20poly1305_publickeybytes = ()=>(Q._crypto_box_curve25519xsalsa20poly1305_publickeybytes = j.rb)(), Q._crypto_box_curve25519xsalsa20poly1305_secretkeybytes = ()=>(Q._crypto_box_curve25519xsalsa20poly1305_secretkeybytes = j.sb)(), Q._crypto_box_curve25519xsalsa20poly1305_beforenmbytes = ()=>(Q._crypto_box_curve25519xsalsa20poly1305_beforenmbytes = j.tb)(), Q._crypto_box_curve25519xsalsa20poly1305_noncebytes = ()=>(Q._crypto_box_curve25519xsalsa20poly1305_noncebytes = j.ub)(), Q._crypto_box_curve25519xsalsa20poly1305_zerobytes = ()=>(Q._crypto_box_curve25519xsalsa20poly1305_zerobytes = j.vb)(), Q._crypto_box_curve25519xsalsa20poly1305_boxzerobytes = ()=>(Q._crypto_box_curve25519xsalsa20poly1305_boxzerobytes = j.wb)(), Q._crypto_box_curve25519xsalsa20poly1305_macbytes = ()=>(Q._crypto_box_curve25519xsalsa20poly1305_macbytes = j.xb)(), Q._crypto_box_curve25519xsalsa20poly1305_messagebytes_max = ()=>(Q._crypto_box_curve25519xsalsa20poly1305_messagebytes_max = j.yb)(), Q._crypto_core_hchacha20 = (A, I, g, C)=>(Q._crypto_core_hchacha20 = j.zb)(A, I, g, C), Q._crypto_core_hchacha20_outputbytes = ()=>(Q._crypto_core_hchacha20_outputbytes = j.Ab)(), Q._crypto_core_hchacha20_inputbytes = ()=>(Q._crypto_core_hchacha20_inputbytes = j.Bb)(), Q._crypto_core_hchacha20_keybytes = ()=>(Q._crypto_core_hchacha20_keybytes = j.Cb)(), Q._crypto_core_hchacha20_constbytes = ()=>(Q._crypto_core_hchacha20_constbytes = j.Db)(), Q._crypto_core_hsalsa20 = (A, I, g, C)=>(Q._crypto_core_hsalsa20 = j.Eb)(A, I, g, C), Q._crypto_core_hsalsa20_outputbytes = ()=>(Q._crypto_core_hsalsa20_outputbytes = j.Fb)(), Q._crypto_core_hsalsa20_inputbytes = ()=>(Q._crypto_core_hsalsa20_inputbytes = j.Gb)(), Q._crypto_core_hsalsa20_keybytes = ()=>(Q._crypto_core_hsalsa20_keybytes = j.Hb)(), Q._crypto_core_hsalsa20_constbytes = ()=>(Q._crypto_core_hsalsa20_constbytes = j.Ib)(), Q._crypto_core_salsa20 = (A, I, g, C)=>(Q._crypto_core_salsa20 = j.Jb)(A, I, g, C), Q._crypto_core_salsa20_outputbytes = ()=>(Q._crypto_core_salsa20_outputbytes = j.Kb)(), Q._crypto_core_salsa20_inputbytes = ()=>(Q._crypto_core_salsa20_inputbytes = j.Lb)(), Q._crypto_core_salsa20_keybytes = ()=>(Q._crypto_core_salsa20_keybytes = j.Mb)(), Q._crypto_core_salsa20_constbytes = ()=>(Q._crypto_core_salsa20_constbytes = j.Nb)(), Q._crypto_core_salsa2012 = (A, I, g, C)=>(Q._crypto_core_salsa2012 = j.Ob)(A, I, g, C), Q._crypto_core_salsa2012_outputbytes = ()=>(Q._crypto_core_salsa2012_outputbytes = j.Pb)(), Q._crypto_core_salsa2012_inputbytes = ()=>(Q._crypto_core_salsa2012_inputbytes = j.Qb)(), Q._crypto_core_salsa2012_keybytes = ()=>(Q._crypto_core_salsa2012_keybytes = j.Rb)(), Q._crypto_core_salsa2012_constbytes = ()=>(Q._crypto_core_salsa2012_constbytes = j.Sb)(), Q._crypto_core_salsa208 = (A, I, g, C)=>(Q._crypto_core_salsa208 = j.Tb)(A, I, g, C), Q._crypto_core_salsa208_outputbytes = ()=>(Q._crypto_core_salsa208_outputbytes = j.Ub)(), Q._crypto_core_salsa208_inputbytes = ()=>(Q._crypto_core_salsa208_inputbytes = j.Vb)(), Q._crypto_core_salsa208_keybytes = ()=>(Q._crypto_core_salsa208_keybytes = j.Wb)(), Q._crypto_core_salsa208_constbytes = ()=>(Q._crypto_core_salsa208_constbytes = j.Xb)(), Q._crypto_generichash_bytes_min = ()=>(Q._crypto_generichash_bytes_min = j.Yb)(), Q._crypto_generichash_bytes_max = ()=>(Q._crypto_generichash_bytes_max = j.Zb)(), Q._crypto_generichash_bytes = ()=>(Q._crypto_generichash_bytes = j._b)(), Q._crypto_generichash_keybytes_min = ()=>(Q._crypto_generichash_keybytes_min = j.$b)(), Q._crypto_generichash_keybytes_max = ()=>(Q._crypto_generichash_keybytes_max = j.ac)(), Q._crypto_generichash_keybytes = ()=>(Q._crypto_generichash_keybytes = j.bc)(), Q._crypto_generichash_primitive = ()=>(Q._crypto_generichash_primitive = j.cc)(), Q._crypto_generichash_statebytes = ()=>(Q._crypto_generichash_statebytes = j.dc)(), Q._crypto_generichash = (A, I, g, C, B, i, o)=>(Q._crypto_generichash = j.ec)(A, I, g, C, B, i, o), Q._crypto_generichash_init = (A, I, g, C)=>(Q._crypto_generichash_init = j.fc)(A, I, g, C), Q._crypto_generichash_update = (A, I, g, C)=>(Q._crypto_generichash_update = j.gc)(A, I, g, C), Q._crypto_generichash_final = (A, I, g)=>(Q._crypto_generichash_final = j.hc)(A, I, g), Q._crypto_generichash_keygen = (A)=>(Q._crypto_generichash_keygen = j.ic)(A), Q._crypto_generichash_blake2b_bytes_min = ()=>(Q._crypto_generichash_blake2b_bytes_min = j.jc)(), Q._crypto_generichash_blake2b_bytes_max = ()=>(Q._crypto_generichash_blake2b_bytes_max = j.kc)(), Q._crypto_generichash_blake2b_bytes = ()=>(Q._crypto_generichash_blake2b_bytes = j.lc)(), Q._crypto_generichash_blake2b_keybytes_min = ()=>(Q._crypto_generichash_blake2b_keybytes_min = j.mc)(), Q._crypto_generichash_blake2b_keybytes_max = ()=>(Q._crypto_generichash_blake2b_keybytes_max = j.nc)(), Q._crypto_generichash_blake2b_keybytes = ()=>(Q._crypto_generichash_blake2b_keybytes = j.oc)(), Q._crypto_generichash_blake2b_saltbytes = ()=>(Q._crypto_generichash_blake2b_saltbytes = j.pc)(), Q._crypto_generichash_blake2b_personalbytes = ()=>(Q._crypto_generichash_blake2b_personalbytes = j.qc)(), Q._crypto_generichash_blake2b_statebytes = ()=>(Q._crypto_generichash_blake2b_statebytes = j.rc)(), Q._crypto_generichash_blake2b_keygen = (A)=>(Q._crypto_generichash_blake2b_keygen = j.sc)(A), Q._crypto_generichash_blake2b = (A, I, g, C, B, i, o)=>(Q._crypto_generichash_blake2b = j.tc)(A, I, g, C, B, i, o), Q._crypto_generichash_blake2b_salt_personal = (A, I, g, C, B, i, o, E, a)=>(Q._crypto_generichash_blake2b_salt_personal = j.uc)(A, I, g, C, B, i, o, E, a), Q._crypto_generichash_blake2b_init = (A, I, g, C)=>(Q._crypto_generichash_blake2b_init = j.vc)(A, I, g, C), Q._crypto_generichash_blake2b_init_salt_personal = (A, I, g, C, B, i)=>(Q._crypto_generichash_blake2b_init_salt_personal = j.wc)(A, I, g, C, B, i), Q._crypto_generichash_blake2b_update = (A, I, g, C)=>(Q._crypto_generichash_blake2b_update = j.xc)(A, I, g, C), Q._crypto_generichash_blake2b_final = (A, I, g)=>(Q._crypto_generichash_blake2b_final = j.yc)(A, I, g), Q._crypto_hash_bytes = ()=>(Q._crypto_hash_bytes = j.zc)(), Q._crypto_hash = (A, I, g, C)=>(Q._crypto_hash = j.Ac)(A, I, g, C), Q._crypto_hash_primitive = ()=>(Q._crypto_hash_primitive = j.Bc)(), Q._crypto_hash_sha256_bytes = ()=>(Q._crypto_hash_sha256_bytes = j.Cc)(), Q._crypto_hash_sha256_statebytes = ()=>(Q._crypto_hash_sha256_statebytes = j.Dc)(), Q._crypto_hash_sha256_init = (A)=>(Q._crypto_hash_sha256_init = j.Ec)(A), Q._crypto_hash_sha256_update = (A, I, g, C)=>(Q._crypto_hash_sha256_update = j.Fc)(A, I, g, C), Q._crypto_hash_sha256_final = (A, I)=>(Q._crypto_hash_sha256_final = j.Gc)(A, I), Q._crypto_hash_sha256 = (A, I, g, C)=>(Q._crypto_hash_sha256 = j.Hc)(A, I, g, C), Q._crypto_hash_sha512_bytes = ()=>(Q._crypto_hash_sha512_bytes = j.Ic)(), Q._crypto_hash_sha512_statebytes = ()=>(Q._crypto_hash_sha512_statebytes = j.Jc)(), Q._crypto_hash_sha512_init = (A)=>(Q._crypto_hash_sha512_init = j.Kc)(A), Q._crypto_hash_sha512_update = (A, I, g, C)=>(Q._crypto_hash_sha512_update = j.Lc)(A, I, g, C), Q._crypto_hash_sha512_final = (A, I)=>(Q._crypto_hash_sha512_final = j.Mc)(A, I), Q._crypto_hash_sha512 = (A, I, g, C)=>(Q._crypto_hash_sha512 = j.Nc)(A, I, g, C), Q._crypto_kdf_blake2b_bytes_min = ()=>(Q._crypto_kdf_blake2b_bytes_min = j.Oc)(), Q._crypto_kdf_blake2b_bytes_max = ()=>(Q._crypto_kdf_blake2b_bytes_max = j.Pc)(), Q._crypto_kdf_blake2b_contextbytes = ()=>(Q._crypto_kdf_blake2b_contextbytes = j.Qc)(), Q._crypto_kdf_blake2b_keybytes = ()=>(Q._crypto_kdf_blake2b_keybytes = j.Rc)(), Q._crypto_kdf_blake2b_derive_from_key = (A, I, g, C, B, i)=>(Q._crypto_kdf_blake2b_derive_from_key = j.Sc)(A, I, g, C, B, i), Q._crypto_kdf_primitive = ()=>(Q._crypto_kdf_primitive = j.Tc)(), Q._crypto_kdf_bytes_min = ()=>(Q._crypto_kdf_bytes_min = j.Uc)(), Q._crypto_kdf_bytes_max = ()=>(Q._crypto_kdf_bytes_max = j.Vc)(), Q._crypto_kdf_contextbytes = ()=>(Q._crypto_kdf_contextbytes = j.Wc)(), Q._crypto_kdf_keybytes = ()=>(Q._crypto_kdf_keybytes = j.Xc)(), Q._crypto_kdf_derive_from_key = (A, I, g, C, B, i)=>(Q._crypto_kdf_derive_from_key = j.Yc)(A, I, g, C, B, i), Q._crypto_kdf_keygen = (A)=>(Q._crypto_kdf_keygen = j.Zc)(A), Q._crypto_kdf_hkdf_sha256_extract_init = (A, I, g)=>(Q._crypto_kdf_hkdf_sha256_extract_init = j._c)(A, I, g), Q._crypto_kdf_hkdf_sha256_extract_update = (A, I, g)=>(Q._crypto_kdf_hkdf_sha256_extract_update = j.$c)(A, I, g), Q._crypto_kdf_hkdf_sha256_extract_final = (A, I)=>(Q._crypto_kdf_hkdf_sha256_extract_final = j.ad)(A, I), Q._crypto_kdf_hkdf_sha256_extract = (A, I, g, C, B)=>(Q._crypto_kdf_hkdf_sha256_extract = j.bd)(A, I, g, C, B), Q._crypto_kdf_hkdf_sha256_keygen = (A)=>(Q._crypto_kdf_hkdf_sha256_keygen = j.cd)(A), Q._crypto_kdf_hkdf_sha256_expand = (A, I, g, C, B)=>(Q._crypto_kdf_hkdf_sha256_expand = j.dd)(A, I, g, C, B), Q._crypto_kdf_hkdf_sha256_keybytes = ()=>(Q._crypto_kdf_hkdf_sha256_keybytes = j.ed)(), Q._crypto_kdf_hkdf_sha256_bytes_min = ()=>(Q._crypto_kdf_hkdf_sha256_bytes_min = j.fd)(), Q._crypto_kdf_hkdf_sha256_bytes_max = ()=>(Q._crypto_kdf_hkdf_sha256_bytes_max = j.gd)(), Q._crypto_kdf_hkdf_sha256_statebytes = ()=>(Q._crypto_kdf_hkdf_sha256_statebytes = j.hd)(), Q._crypto_kdf_hkdf_sha512_extract_init = (A, I, g)=>(Q._crypto_kdf_hkdf_sha512_extract_init = j.id)(A, I, g), Q._crypto_kdf_hkdf_sha512_extract_update = (A, I, g)=>(Q._crypto_kdf_hkdf_sha512_extract_update = j.jd)(A, I, g), Q._crypto_kdf_hkdf_sha512_extract_final = (A, I)=>(Q._crypto_kdf_hkdf_sha512_extract_final = j.kd)(A, I), Q._crypto_kdf_hkdf_sha512_extract = (A, I, g, C, B)=>(Q._crypto_kdf_hkdf_sha512_extract = j.ld)(A, I, g, C, B), Q._crypto_kdf_hkdf_sha512_keygen = (A)=>(Q._crypto_kdf_hkdf_sha512_keygen = j.md)(A), Q._crypto_kdf_hkdf_sha512_expand = (A, I, g, C, B)=>(Q._crypto_kdf_hkdf_sha512_expand = j.nd)(A, I, g, C, B), Q._crypto_kdf_hkdf_sha512_keybytes = ()=>(Q._crypto_kdf_hkdf_sha512_keybytes = j.od)(), Q._crypto_kdf_hkdf_sha512_bytes_min = ()=>(Q._crypto_kdf_hkdf_sha512_bytes_min = j.pd)(), Q._crypto_kdf_hkdf_sha512_bytes_max = ()=>(Q._crypto_kdf_hkdf_sha512_bytes_max = j.qd)(), Q._crypto_kx_seed_keypair = (A, I, g)=>(Q._crypto_kx_seed_keypair = j.rd)(A, I, g), Q._crypto_kx_keypair = (A, I)=>(Q._crypto_kx_keypair = j.sd)(A, I), Q._crypto_kx_client_session_keys = (A, I, g, C, B)=>(Q._crypto_kx_client_session_keys = j.td)(A, I, g, C, B), Q._crypto_kx_server_session_keys = (A, I, g, C, B)=>(Q._crypto_kx_server_session_keys = j.ud)(A, I, g, C, B), Q._crypto_kx_publickeybytes = ()=>(Q._crypto_kx_publickeybytes = j.vd)(), Q._crypto_kx_secretkeybytes = ()=>(Q._crypto_kx_secretkeybytes = j.wd)(), Q._crypto_kx_seedbytes = ()=>(Q._crypto_kx_seedbytes = j.xd)(), Q._crypto_kx_sessionkeybytes = ()=>(Q._crypto_kx_sessionkeybytes = j.yd)(), Q._crypto_kx_primitive = ()=>(Q._crypto_kx_primitive = j.zd)(), Q._crypto_onetimeauth_statebytes = ()=>(Q._crypto_onetimeauth_statebytes = j.Ad)(), Q._crypto_onetimeauth_bytes = ()=>(Q._crypto_onetimeauth_bytes = j.Bd)(), Q._crypto_onetimeauth_keybytes = ()=>(Q._crypto_onetimeauth_keybytes = j.Cd)(), Q._crypto_onetimeauth = (A, I, g, C, B)=>(Q._crypto_onetimeauth = j.Dd)(A, I, g, C, B), Q._crypto_onetimeauth_verify = (A, I, g, C, B)=>(Q._crypto_onetimeauth_verify = j.Ed)(A, I, g, C, B), Q._crypto_onetimeauth_init = (A, I)=>(Q._crypto_onetimeauth_init = j.Fd)(A, I), Q._crypto_onetimeauth_update = (A, I, g, C)=>(Q._crypto_onetimeauth_update = j.Gd)(A, I, g, C), Q._crypto_onetimeauth_final = (A, I)=>(Q._crypto_onetimeauth_final = j.Hd)(A, I), Q._crypto_onetimeauth_primitive = ()=>(Q._crypto_onetimeauth_primitive = j.Id)(), Q._crypto_onetimeauth_keygen = (A)=>(Q._crypto_onetimeauth_keygen = j.Jd)(A), Q._crypto_onetimeauth_poly1305 = (A, I, g, C, B)=>(Q._crypto_onetimeauth_poly1305 = j.Kd)(A, I, g, C, B), Q._crypto_onetimeauth_poly1305_verify = (A, I, g, C, B)=>(Q._crypto_onetimeauth_poly1305_verify = j.Ld)(A, I, g, C, B), Q._crypto_onetimeauth_poly1305_init = (A, I)=>(Q._crypto_onetimeauth_poly1305_init = j.Md)(A, I), Q._crypto_onetimeauth_poly1305_update = (A, I, g, C)=>(Q._crypto_onetimeauth_poly1305_update = j.Nd)(A, I, g, C), Q._crypto_onetimeauth_poly1305_final = (A, I)=>(Q._crypto_onetimeauth_poly1305_final = j.Od)(A, I), Q._crypto_onetimeauth_poly1305_bytes = ()=>(Q._crypto_onetimeauth_poly1305_bytes = j.Pd)(), Q._crypto_onetimeauth_poly1305_keybytes = ()=>(Q._crypto_onetimeauth_poly1305_keybytes = j.Qd)(), Q._crypto_onetimeauth_poly1305_statebytes = ()=>(Q._crypto_onetimeauth_poly1305_statebytes = j.Rd)(), Q._crypto_onetimeauth_poly1305_keygen = (A)=>(Q._crypto_onetimeauth_poly1305_keygen = j.Sd)(A), Q._crypto_pwhash_argon2i_alg_argon2i13 = ()=>(Q._crypto_pwhash_argon2i_alg_argon2i13 = j.Td)(), Q._crypto_pwhash_argon2i_bytes_min = ()=>(Q._crypto_pwhash_argon2i_bytes_min = j.Ud)(), Q._crypto_pwhash_argon2i_bytes_max = ()=>(Q._crypto_pwhash_argon2i_bytes_max = j.Vd)(), Q._crypto_pwhash_argon2i_passwd_min = ()=>(Q._crypto_pwhash_argon2i_passwd_min = j.Wd)(), Q._crypto_pwhash_argon2i_passwd_max = ()=>(Q._crypto_pwhash_argon2i_passwd_max = j.Xd)(), Q._crypto_pwhash_argon2i_saltbytes = ()=>(Q._crypto_pwhash_argon2i_saltbytes = j.Yd)(), Q._crypto_pwhash_argon2i_strbytes = ()=>(Q._crypto_pwhash_argon2i_strbytes = j.Zd)(), Q._crypto_pwhash_argon2i_strprefix = ()=>(Q._crypto_pwhash_argon2i_strprefix = j._d)(), Q._crypto_pwhash_argon2i_opslimit_min = ()=>(Q._crypto_pwhash_argon2i_opslimit_min = j.$d)(), Q._crypto_pwhash_argon2i_opslimit_max = ()=>(Q._crypto_pwhash_argon2i_opslimit_max = j.ae)(), Q._crypto_pwhash_argon2i_memlimit_min = ()=>(Q._crypto_pwhash_argon2i_memlimit_min = j.be)(), Q._crypto_pwhash_argon2i_memlimit_max = ()=>(Q._crypto_pwhash_argon2i_memlimit_max = j.ce)(), Q._crypto_pwhash_argon2i_opslimit_interactive = ()=>(Q._crypto_pwhash_argon2i_opslimit_interactive = j.de)(), Q._crypto_pwhash_argon2i_memlimit_interactive = ()=>(Q._crypto_pwhash_argon2i_memlimit_interactive = j.ee)(), Q._crypto_pwhash_argon2i_opslimit_moderate = ()=>(Q._crypto_pwhash_argon2i_opslimit_moderate = j.fe)(), Q._crypto_pwhash_argon2i_memlimit_moderate = ()=>(Q._crypto_pwhash_argon2i_memlimit_moderate = j.ge)(), Q._crypto_pwhash_argon2i_opslimit_sensitive = ()=>(Q._crypto_pwhash_argon2i_opslimit_sensitive = j.he)(), Q._crypto_pwhash_argon2i_memlimit_sensitive = ()=>(Q._crypto_pwhash_argon2i_memlimit_sensitive = j.ie)(), Q._crypto_pwhash_argon2i = (A, I, g, C, B, i, o, E, a, _, c)=>(Q._crypto_pwhash_argon2i = j.je)(A, I, g, C, B, i, o, E, a, _, c), Q._crypto_pwhash_argon2i_str = (A, I, g, C, B, i, o)=>(Q._crypto_pwhash_argon2i_str = j.ke)(A, I, g, C, B, i, o), Q._crypto_pwhash_argon2i_str_verify = (A, I, g, C)=>(Q._crypto_pwhash_argon2i_str_verify = j.le)(A, I, g, C), Q._crypto_pwhash_argon2i_str_needs_rehash = (A, I, g, C)=>(Q._crypto_pwhash_argon2i_str_needs_rehash = j.me)(A, I, g, C), Q._crypto_pwhash_argon2id_str_needs_rehash = (A, I, g, C)=>(Q._crypto_pwhash_argon2id_str_needs_rehash = j.ne)(A, I, g, C), Q._crypto_pwhash_argon2id_alg_argon2id13 = ()=>(Q._crypto_pwhash_argon2id_alg_argon2id13 = j.oe)(), Q._crypto_pwhash_argon2id_bytes_min = ()=>(Q._crypto_pwhash_argon2id_bytes_min = j.pe)(), Q._crypto_pwhash_argon2id_bytes_max = ()=>(Q._crypto_pwhash_argon2id_bytes_max = j.qe)(), Q._crypto_pwhash_argon2id_passwd_min = ()=>(Q._crypto_pwhash_argon2id_passwd_min = j.re)(), Q._crypto_pwhash_argon2id_passwd_max = ()=>(Q._crypto_pwhash_argon2id_passwd_max = j.se)(), Q._crypto_pwhash_argon2id_saltbytes = ()=>(Q._crypto_pwhash_argon2id_saltbytes = j.te)(), Q._crypto_pwhash_argon2id_strbytes = ()=>(Q._crypto_pwhash_argon2id_strbytes = j.ue)(), Q._crypto_pwhash_argon2id_strprefix = ()=>(Q._crypto_pwhash_argon2id_strprefix = j.ve)(), Q._crypto_pwhash_argon2id_opslimit_min = ()=>(Q._crypto_pwhash_argon2id_opslimit_min = j.we)(), Q._crypto_pwhash_argon2id_opslimit_max = ()=>(Q._crypto_pwhash_argon2id_opslimit_max = j.xe)(), Q._crypto_pwhash_argon2id_memlimit_min = ()=>(Q._crypto_pwhash_argon2id_memlimit_min = j.ye)(), Q._crypto_pwhash_argon2id_memlimit_max = ()=>(Q._crypto_pwhash_argon2id_memlimit_max = j.ze)(), Q._crypto_pwhash_argon2id_opslimit_interactive = ()=>(Q._crypto_pwhash_argon2id_opslimit_interactive = j.Ae)(), Q._crypto_pwhash_argon2id_memlimit_interactive = ()=>(Q._crypto_pwhash_argon2id_memlimit_interactive = j.Be)(), Q._crypto_pwhash_argon2id_opslimit_moderate = ()=>(Q._crypto_pwhash_argon2id_opslimit_moderate = j.Ce)(), Q._crypto_pwhash_argon2id_memlimit_moderate = ()=>(Q._crypto_pwhash_argon2id_memlimit_moderate = j.De)(), Q._crypto_pwhash_argon2id_opslimit_sensitive = ()=>(Q._crypto_pwhash_argon2id_opslimit_sensitive = j.Ee)(), Q._crypto_pwhash_argon2id_memlimit_sensitive = ()=>(Q._crypto_pwhash_argon2id_memlimit_sensitive = j.Fe)(), Q._crypto_pwhash_argon2id = (A, I, g, C, B, i, o, E, a, _, c)=>(Q._crypto_pwhash_argon2id = j.Ge)(A, I, g, C, B, i, o, E, a, _, c), Q._crypto_pwhash_argon2id_str = (A, I, g, C, B, i, o)=>(Q._crypto_pwhash_argon2id_str = j.He)(A, I, g, C, B, i, o), Q._crypto_pwhash_argon2id_str_verify = (A, I, g, C)=>(Q._crypto_pwhash_argon2id_str_verify = j.Ie)(A, I, g, C), Q._crypto_pwhash_alg_argon2i13 = ()=>(Q._crypto_pwhash_alg_argon2i13 = j.Je)(), Q._crypto_pwhash_alg_argon2id13 = ()=>(Q._crypto_pwhash_alg_argon2id13 = j.Ke)(), Q._crypto_pwhash_alg_default = ()=>(Q._crypto_pwhash_alg_default = j.Le)(), Q._crypto_pwhash_bytes_min = ()=>(Q._crypto_pwhash_bytes_min = j.Me)(), Q._crypto_pwhash_bytes_max = ()=>(Q._crypto_pwhash_bytes_max = j.Ne)(), Q._crypto_pwhash_passwd_min = ()=>(Q._crypto_pwhash_passwd_min = j.Oe)(), Q._crypto_pwhash_passwd_max = ()=>(Q._crypto_pwhash_passwd_max = j.Pe)(), Q._crypto_pwhash_saltbytes = ()=>(Q._crypto_pwhash_saltbytes = j.Qe)(), Q._crypto_pwhash_strbytes = ()=>(Q._crypto_pwhash_strbytes = j.Re)(), Q._crypto_pwhash_strprefix = ()=>(Q._crypto_pwhash_strprefix = j.Se)(), Q._crypto_pwhash_opslimit_min = ()=>(Q._crypto_pwhash_opslimit_min = j.Te)(), Q._crypto_pwhash_opslimit_max = ()=>(Q._crypto_pwhash_opslimit_max = j.Ue)(), Q._crypto_pwhash_memlimit_min = ()=>(Q._crypto_pwhash_memlimit_min = j.Ve)(), Q._crypto_pwhash_memlimit_max = ()=>(Q._crypto_pwhash_memlimit_max = j.We)(), Q._crypto_pwhash_opslimit_interactive = ()=>(Q._crypto_pwhash_opslimit_interactive = j.Xe)(), Q._crypto_pwhash_memlimit_interactive = ()=>(Q._crypto_pwhash_memlimit_interactive = j.Ye)(), Q._crypto_pwhash_opslimit_moderate = ()=>(Q._crypto_pwhash_opslimit_moderate = j.Ze)(), Q._crypto_pwhash_memlimit_moderate = ()=>(Q._crypto_pwhash_memlimit_moderate = j._e)(), Q._crypto_pwhash_opslimit_sensitive = ()=>(Q._crypto_pwhash_opslimit_sensitive = j.$e)(), Q._crypto_pwhash_memlimit_sensitive = ()=>(Q._crypto_pwhash_memlimit_sensitive = j.af)(), Q._crypto_pwhash = (A, I, g, C, B, i, o, E, a, _, c)=>(Q._crypto_pwhash = j.bf)(A, I, g, C, B, i, o, E, a, _, c), Q._crypto_pwhash_str = (A, I, g, C, B, i, o)=>(Q._crypto_pwhash_str = j.cf)(A, I, g, C, B, i, o), Q._crypto_pwhash_str_alg = (A, I, g, C, B, i, o, E)=>(Q._crypto_pwhash_str_alg = j.df)(A, I, g, C, B, i, o, E), Q._crypto_pwhash_str_verify = (A, I, g, C)=>(Q._crypto_pwhash_str_verify = j.ef)(A, I, g, C), Q._crypto_pwhash_str_needs_rehash = (A, I, g, C)=>(Q._crypto_pwhash_str_needs_rehash = j.ff)(A, I, g, C), Q._crypto_pwhash_primitive = ()=>(Q._crypto_pwhash_primitive = j.gf)(), Q._crypto_scalarmult_primitive = ()=>(Q._crypto_scalarmult_primitive = j.hf)(), Q._crypto_scalarmult_base = (A, I)=>(Q._crypto_scalarmult_base = j.jf)(A, I), Q._crypto_scalarmult = (A, I, g)=>(Q._crypto_scalarmult = j.kf)(A, I, g), Q._crypto_scalarmult_bytes = ()=>(Q._crypto_scalarmult_bytes = j.lf)(), Q._crypto_scalarmult_scalarbytes = ()=>(Q._crypto_scalarmult_scalarbytes = j.mf)(), Q._crypto_scalarmult_curve25519 = (A, I, g)=>(Q._crypto_scalarmult_curve25519 = j.nf)(A, I, g), Q._crypto_scalarmult_curve25519_base = (A, I)=>(Q._crypto_scalarmult_curve25519_base = j.of)(A, I), Q._crypto_scalarmult_curve25519_bytes = ()=>(Q._crypto_scalarmult_curve25519_bytes = j.pf)(), Q._crypto_scalarmult_curve25519_scalarbytes = ()=>(Q._crypto_scalarmult_curve25519_scalarbytes = j.qf)(), Q._crypto_secretbox_keybytes = ()=>(Q._crypto_secretbox_keybytes = j.rf)(), Q._crypto_secretbox_noncebytes = ()=>(Q._crypto_secretbox_noncebytes = j.sf)(), Q._crypto_secretbox_zerobytes = ()=>(Q._crypto_secretbox_zerobytes = j.tf)(), Q._crypto_secretbox_boxzerobytes = ()=>(Q._crypto_secretbox_boxzerobytes = j.uf)(), Q._crypto_secretbox_macbytes = ()=>(Q._crypto_secretbox_macbytes = j.vf)(), Q._crypto_secretbox_messagebytes_max = ()=>(Q._crypto_secretbox_messagebytes_max = j.wf)(), Q._crypto_secretbox_primitive = ()=>(Q._crypto_secretbox_primitive = j.xf)(), Q._crypto_secretbox = (A, I, g, C, B, i)=>(Q._crypto_secretbox = j.yf)(A, I, g, C, B, i), Q._crypto_secretbox_open = (A, I, g, C, B, i)=>(Q._crypto_secretbox_open = j.zf)(A, I, g, C, B, i), Q._crypto_secretbox_keygen = (A)=>(Q._crypto_secretbox_keygen = j.Af)(A), Q._crypto_secretbox_detached = (A, I, g, C, B, i, o)=>(Q._crypto_secretbox_detached = j.Bf)(A, I, g, C, B, i, o), Q._crypto_secretbox_easy = (A, I, g, C, B, i)=>(Q._crypto_secretbox_easy = j.Cf)(A, I, g, C, B, i), Q._crypto_secretbox_open_detached = (A, I, g, C, B, i, o)=>(Q._crypto_secretbox_open_detached = j.Df)(A, I, g, C, B, i, o), Q._crypto_secretbox_open_easy = (A, I, g, C, B, i)=>(Q._crypto_secretbox_open_easy = j.Ef)(A, I, g, C, B, i), Q._crypto_secretbox_xsalsa20poly1305 = (A, I, g, C, B, i)=>(Q._crypto_secretbox_xsalsa20poly1305 = j.Ff)(A, I, g, C, B, i), Q._crypto_secretbox_xsalsa20poly1305_open = (A, I, g, C, B, i)=>(Q._crypto_secretbox_xsalsa20poly1305_open = j.Gf)(A, I, g, C, B, i), Q._crypto_secretbox_xsalsa20poly1305_keybytes = ()=>(Q._crypto_secretbox_xsalsa20poly1305_keybytes = j.Hf)(), Q._crypto_secretbox_xsalsa20poly1305_noncebytes = ()=>(Q._crypto_secretbox_xsalsa20poly1305_noncebytes = j.If)(), Q._crypto_secretbox_xsalsa20poly1305_zerobytes = ()=>(Q._crypto_secretbox_xsalsa20poly1305_zerobytes = j.Jf)(), Q._crypto_secretbox_xsalsa20poly1305_boxzerobytes = ()=>(Q._crypto_secretbox_xsalsa20poly1305_boxzerobytes = j.Kf)(), Q._crypto_secretbox_xsalsa20poly1305_macbytes = ()=>(Q._crypto_secretbox_xsalsa20poly1305_macbytes = j.Lf)(), Q._crypto_secretbox_xsalsa20poly1305_messagebytes_max = ()=>(Q._crypto_secretbox_xsalsa20poly1305_messagebytes_max = j.Mf)(), Q._crypto_secretbox_xsalsa20poly1305_keygen = (A)=>(Q._crypto_secretbox_xsalsa20poly1305_keygen = j.Nf)(A), Q._crypto_secretstream_xchacha20poly1305_keygen = (A)=>(Q._crypto_secretstream_xchacha20poly1305_keygen = j.Of)(A), Q._crypto_secretstream_xchacha20poly1305_init_push = (A, I, g)=>(Q._crypto_secretstream_xchacha20poly1305_init_push = j.Pf)(A, I, g), Q._crypto_secretstream_xchacha20poly1305_init_pull = (A, I, g)=>(Q._crypto_secretstream_xchacha20poly1305_init_pull = j.Qf)(A, I, g), Q._crypto_secretstream_xchacha20poly1305_rekey = (A)=>(Q._crypto_secretstream_xchacha20poly1305_rekey = j.Rf)(A), Q._crypto_secretstream_xchacha20poly1305_push = (A, I, g, C, B, i, o, E, a, _)=>(Q._crypto_secretstream_xchacha20poly1305_push = j.Sf)(A, I, g, C, B, i, o, E, a, _), Q._crypto_secretstream_xchacha20poly1305_pull = (A, I, g, C, B, i, o, E, a, _)=>(Q._crypto_secretstream_xchacha20poly1305_pull = j.Tf)(A, I, g, C, B, i, o, E, a, _), Q._crypto_secretstream_xchacha20poly1305_statebytes = ()=>(Q._crypto_secretstream_xchacha20poly1305_statebytes = j.Uf)(), Q._crypto_secretstream_xchacha20poly1305_abytes = ()=>(Q._crypto_secretstream_xchacha20poly1305_abytes = j.Vf)(), Q._crypto_secretstream_xchacha20poly1305_headerbytes = ()=>(Q._crypto_secretstream_xchacha20poly1305_headerbytes = j.Wf)(), Q._crypto_secretstream_xchacha20poly1305_keybytes = ()=>(Q._crypto_secretstream_xchacha20poly1305_keybytes = j.Xf)(), Q._crypto_secretstream_xchacha20poly1305_messagebytes_max = ()=>(Q._crypto_secretstream_xchacha20poly1305_messagebytes_max = j.Yf)(), Q._crypto_secretstream_xchacha20poly1305_tag_message = ()=>(Q._crypto_secretstream_xchacha20poly1305_tag_message = j.Zf)(), Q._crypto_secretstream_xchacha20poly1305_tag_push = ()=>(Q._crypto_secretstream_xchacha20poly1305_tag_push = j._f)(), Q._crypto_secretstream_xchacha20poly1305_tag_rekey = ()=>(Q._crypto_secretstream_xchacha20poly1305_tag_rekey = j.$f)(), Q._crypto_secretstream_xchacha20poly1305_tag_final = ()=>(Q._crypto_secretstream_xchacha20poly1305_tag_final = j.ag)(), Q._crypto_shorthash_bytes = ()=>(Q._crypto_shorthash_bytes = j.bg)(), Q._crypto_shorthash_keybytes = ()=>(Q._crypto_shorthash_keybytes = j.cg)(), Q._crypto_shorthash_primitive = ()=>(Q._crypto_shorthash_primitive = j.dg)(), Q._crypto_shorthash = (A, I, g, C, B)=>(Q._crypto_shorthash = j.eg)(A, I, g, C, B), Q._crypto_shorthash_keygen = (A)=>(Q._crypto_shorthash_keygen = j.fg)(A), Q._crypto_shorthash_siphash24_bytes = ()=>(Q._crypto_shorthash_siphash24_bytes = j.gg)(), Q._crypto_shorthash_siphash24_keybytes = ()=>(Q._crypto_shorthash_siphash24_keybytes = j.hg)(), Q._crypto_shorthash_siphash24 = (A, I, g, C, B)=>(Q._crypto_shorthash_siphash24 = j.ig)(A, I, g, C, B), Q._crypto_sign_statebytes = ()=>(Q._crypto_sign_statebytes = j.jg)(), Q._crypto_sign_bytes = ()=>(Q._crypto_sign_bytes = j.kg)(), Q._crypto_sign_seedbytes = ()=>(Q._crypto_sign_seedbytes = j.lg)(), Q._crypto_sign_publickeybytes = ()=>(Q._crypto_sign_publickeybytes = j.mg)(), Q._crypto_sign_secretkeybytes = ()=>(Q._crypto_sign_secretkeybytes = j.ng)(), Q._crypto_sign_messagebytes_max = ()=>(Q._crypto_sign_messagebytes_max = j.og)(), Q._crypto_sign_primitive = ()=>(Q._crypto_sign_primitive = j.pg)(), Q._crypto_sign_seed_keypair = (A, I, g)=>(Q._crypto_sign_seed_keypair = j.qg)(A, I, g), Q._crypto_sign_keypair = (A, I)=>(Q._crypto_sign_keypair = j.rg)(A, I), Q._crypto_sign = (A, I, g, C, B, i)=>(Q._crypto_sign = j.sg)(A, I, g, C, B, i), Q._crypto_sign_open = (A, I, g, C, B, i)=>(Q._crypto_sign_open = j.tg)(A, I, g, C, B, i), Q._crypto_sign_detached = (A, I, g, C, B, i)=>(Q._crypto_sign_detached = j.ug)(A, I, g, C, B, i), Q._crypto_sign_verify_detached = (A, I, g, C, B)=>(Q._crypto_sign_verify_detached = j.vg)(A, I, g, C, B), Q._crypto_sign_init = (A)=>(Q._crypto_sign_init = j.wg)(A), Q._crypto_sign_update = (A, I, g, C)=>(Q._crypto_sign_update = j.xg)(A, I, g, C), Q._crypto_sign_final_create = (A, I, g, C)=>(Q._crypto_sign_final_create = j.yg)(A, I, g, C), Q._crypto_sign_final_verify = (A, I, g)=>(Q._crypto_sign_final_verify = j.zg)(A, I, g), Q._crypto_sign_ed25519ph_statebytes = ()=>(Q._crypto_sign_ed25519ph_statebytes = j.Ag)(), Q._crypto_sign_ed25519_bytes = ()=>(Q._crypto_sign_ed25519_bytes = j.Bg)(), Q._crypto_sign_ed25519_seedbytes = ()=>(Q._crypto_sign_ed25519_seedbytes = j.Cg)(), Q._crypto_sign_ed25519_publickeybytes = ()=>(Q._crypto_sign_ed25519_publickeybytes = j.Dg)(), Q._crypto_sign_ed25519_secretkeybytes = ()=>(Q._crypto_sign_ed25519_secretkeybytes = j.Eg)(), Q._crypto_sign_ed25519_messagebytes_max = ()=>(Q._crypto_sign_ed25519_messagebytes_max = j.Fg)(), Q._crypto_sign_ed25519_sk_to_seed = (A, I)=>(Q._crypto_sign_ed25519_sk_to_seed = j.Gg)(A, I), Q._crypto_sign_ed25519_sk_to_pk = (A, I)=>(Q._crypto_sign_ed25519_sk_to_pk = j.Hg)(A, I), Q._crypto_sign_ed25519ph_init = (A)=>(Q._crypto_sign_ed25519ph_init = j.Ig)(A), Q._crypto_sign_ed25519ph_update = (A, I, g, C)=>(Q._crypto_sign_ed25519ph_update = j.Jg)(A, I, g, C), Q._crypto_sign_ed25519ph_final_create = (A, I, g, C)=>(Q._crypto_sign_ed25519ph_final_create = j.Kg)(A, I, g, C), Q._crypto_sign_ed25519ph_final_verify = (A, I, g)=>(Q._crypto_sign_ed25519ph_final_verify = j.Lg)(A, I, g), Q._crypto_sign_ed25519_seed_keypair = (A, I, g)=>(Q._crypto_sign_ed25519_seed_keypair = j.Mg)(A, I, g), Q._crypto_sign_ed25519_keypair = (A, I)=>(Q._crypto_sign_ed25519_keypair = j.Ng)(A, I), Q._crypto_sign_ed25519_pk_to_curve25519 = (A, I)=>(Q._crypto_sign_ed25519_pk_to_curve25519 = j.Og)(A, I), Q._crypto_sign_ed25519_sk_to_curve25519 = (A, I)=>(Q._crypto_sign_ed25519_sk_to_curve25519 = j.Pg)(A, I), Q._crypto_sign_ed25519_verify_detached = (A, I, g, C, B)=>(Q._crypto_sign_ed25519_verify_detached = j.Qg)(A, I, g, C, B), Q._crypto_sign_ed25519_open = (A, I, g, C, B, i)=>(Q._crypto_sign_ed25519_open = j.Rg)(A, I, g, C, B, i), Q._crypto_sign_ed25519_detached = (A, I, g, C, B, i)=>(Q._crypto_sign_ed25519_detached = j.Sg)(A, I, g, C, B, i), Q._crypto_sign_ed25519 = (A, I, g, C, B, i)=>(Q._crypto_sign_ed25519 = j.Tg)(A, I, g, C, B, i), Q._crypto_stream_chacha20_keybytes = ()=>(Q._crypto_stream_chacha20_keybytes = j.Ug)(), Q._crypto_stream_chacha20_noncebytes = ()=>(Q._crypto_stream_chacha20_noncebytes = j.Vg)(), Q._crypto_stream_chacha20_messagebytes_max = ()=>(Q._crypto_stream_chacha20_messagebytes_max = j.Wg)(), Q._crypto_stream_chacha20_ietf_keybytes = ()=>(Q._crypto_stream_chacha20_ietf_keybytes = j.Xg)(), Q._crypto_stream_chacha20_ietf_noncebytes = ()=>(Q._crypto_stream_chacha20_ietf_noncebytes = j.Yg)(), Q._crypto_stream_chacha20_ietf_messagebytes_max = ()=>(Q._crypto_stream_chacha20_ietf_messagebytes_max = j.Zg)(), Q._crypto_stream_chacha20 = (A, I, g, C, B)=>(Q._crypto_stream_chacha20 = j._g)(A, I, g, C, B), Q._crypto_stream_chacha20_xor_ic = (A, I, g, C, B, i, o, E)=>(Q._crypto_stream_chacha20_xor_ic = j.$g)(A, I, g, C, B, i, o, E), Q._crypto_stream_chacha20_xor = (A, I, g, C, B, i)=>(Q._crypto_stream_chacha20_xor = j.ah)(A, I, g, C, B, i), Q._crypto_stream_chacha20_ietf = (A, I, g, C, B)=>(Q._crypto_stream_chacha20_ietf = j.bh)(A, I, g, C, B), Q._crypto_stream_chacha20_ietf_xor_ic = (A, I, g, C, B, i, o)=>(Q._crypto_stream_chacha20_ietf_xor_ic = j.ch)(A, I, g, C, B, i, o), Q._crypto_stream_chacha20_ietf_xor = (A, I, g, C, B, i)=>(Q._crypto_stream_chacha20_ietf_xor = j.dh)(A, I, g, C, B, i), Q._crypto_stream_chacha20_ietf_keygen = (A)=>(Q._crypto_stream_chacha20_ietf_keygen = j.eh)(A), Q._crypto_stream_chacha20_keygen = (A)=>(Q._crypto_stream_chacha20_keygen = j.fh)(A), Q._crypto_stream_keybytes = ()=>(Q._crypto_stream_keybytes = j.gh)(), Q._crypto_stream_noncebytes = ()=>(Q._crypto_stream_noncebytes = j.hh)(), Q._crypto_stream_messagebytes_max = ()=>(Q._crypto_stream_messagebytes_max = j.ih)(), Q._crypto_stream_primitive = ()=>(Q._crypto_stream_primitive = j.jh)(), Q._crypto_stream = (A, I, g, C, B)=>(Q._crypto_stream = j.kh)(A, I, g, C, B), Q._crypto_stream_xor = (A, I, g, C, B, i)=>(Q._crypto_stream_xor = j.lh)(A, I, g, C, B, i), Q._crypto_stream_keygen = (A)=>(Q._crypto_stream_keygen = j.mh)(A), Q._crypto_stream_salsa20_keybytes = ()=>(Q._crypto_stream_salsa20_keybytes = j.nh)(), Q._crypto_stream_salsa20_noncebytes = ()=>(Q._crypto_stream_salsa20_noncebytes = j.oh)(), Q._crypto_stream_salsa20_messagebytes_max = ()=>(Q._crypto_stream_salsa20_messagebytes_max = j.ph)(), Q._crypto_stream_salsa20 = (A, I, g, C, B)=>(Q._crypto_stream_salsa20 = j.qh)(A, I, g, C, B), Q._crypto_stream_salsa20_xor_ic = (A, I, g, C, B, i, o, E)=>(Q._crypto_stream_salsa20_xor_ic = j.rh)(A, I, g, C, B, i, o, E), Q._crypto_stream_salsa20_xor = (A, I, g, C, B, i)=>(Q._crypto_stream_salsa20_xor = j.sh)(A, I, g, C, B, i), Q._crypto_stream_salsa20_keygen = (A)=>(Q._crypto_stream_salsa20_keygen = j.th)(A), Q._crypto_stream_xsalsa20 = (A, I, g, C, B)=>(Q._crypto_stream_xsalsa20 = j.uh)(A, I, g, C, B), Q._crypto_stream_xsalsa20_xor_ic = (A, I, g, C, B, i, o, E)=>(Q._crypto_stream_xsalsa20_xor_ic = j.vh)(A, I, g, C, B, i, o, E), Q._crypto_stream_xsalsa20_xor = (A, I, g, C, B, i)=>(Q._crypto_stream_xsalsa20_xor = j.wh)(A, I, g, C, B, i), Q._crypto_stream_xsalsa20_keybytes = ()=>(Q._crypto_stream_xsalsa20_keybytes = j.xh)(), Q._crypto_stream_xsalsa20_noncebytes = ()=>(Q._crypto_stream_xsalsa20_noncebytes = j.yh)(), Q._crypto_stream_xsalsa20_messagebytes_max = ()=>(Q._crypto_stream_xsalsa20_messagebytes_max = j.zh)(), Q._crypto_stream_xsalsa20_keygen = (A)=>(Q._crypto_stream_xsalsa20_keygen = j.Ah)(A), Q._crypto_verify_16_bytes = ()=>(Q._crypto_verify_16_bytes = j.Bh)(), Q._crypto_verify_32_bytes = ()=>(Q._crypto_verify_32_bytes = j.Ch)(), Q._crypto_verify_64_bytes = ()=>(Q._crypto_verify_64_bytes = j.Dh)(), Q._crypto_verify_16 = (A, I)=>(Q._crypto_verify_16 = j.Eh)(A, I), Q._crypto_verify_32 = (A, I)=>(Q._crypto_verify_32 = j.Fh)(A, I), Q._crypto_verify_64 = (A, I)=>(Q._crypto_verify_64 = j.Gh)(A, I), Q._randombytes_implementation_name = ()=>(Q._randombytes_implementation_name = j.Hh)(), Q._randombytes_random = ()=>(Q._randombytes_random = j.Ih)(), Q._randombytes_stir = ()=>(Q._randombytes_stir = j.Jh)(), Q._randombytes_uniform = (A)=>(Q._randombytes_uniform = j.Kh)(A), Q._randombytes_buf = (A, I)=>(Q._randombytes_buf = j.Lh)(A, I), Q._randombytes_buf_deterministic = (A, I, g)=>(Q._randombytes_buf_deterministic = j.Mh)(A, I, g), Q._randombytes_seedbytes = ()=>(Q._randombytes_seedbytes = j.Nh)(), Q._randombytes_close = ()=>(Q._randombytes_close = j.Oh)(), Q._randombytes = (A, I, g)=>(Q._randombytes = j.Ph)(A, I, g), Q._sodium_bin2hex = (A, I, g, C)=>(Q._sodium_bin2hex = j.Qh)(A, I, g, C), Q._sodium_hex2bin = (A, I, g, C, B, i, o)=>(Q._sodium_hex2bin = j.Rh)(A, I, g, C, B, i, o), Q._sodium_base64_encoded_len = (A, I)=>(Q._sodium_base64_encoded_len = j.Sh)(A, I), Q._sodium_bin2base64 = (A, I, g, C, B)=>(Q._sodium_bin2base64 = j.Th)(A, I, g, C, B), Q._sodium_base642bin = (A, I, g, C, B, i, o, E)=>(Q._sodium_base642bin = j.Uh)(A, I, g, C, B, i, o, E), Q._sodium_init = ()=>(Q._sodium_init = j.Vh)(), Q._sodium_pad = (A, I, g, C, B)=>(Q._sodium_pad = j.Wh)(A, I, g, C, B), Q._sodium_unpad = (A, I, g, C)=>(Q._sodium_unpad = j.Xh)(A, I, g, C), Q._sodium_version_string = ()=>(Q._sodium_version_string = j.Yh)(), Q._sodium_library_version_major = ()=>(Q._sodium_library_version_major = j.Zh)(), Q._sodium_library_version_minor = ()=>(Q._sodium_library_version_minor = j._h)(), Q._sodium_library_minimal = ()=>(Q._sodium_library_minimal = j.$h)(), Q._crypto_box_curve25519xchacha20poly1305_seed_keypair = (A, I, g)=>(Q._crypto_box_curve25519xchacha20poly1305_seed_keypair = j.ai)(A, I, g), Q._crypto_box_curve25519xchacha20poly1305_keypair = (A, I)=>(Q._crypto_box_curve25519xchacha20poly1305_keypair = j.bi)(A, I), Q._crypto_box_curve25519xchacha20poly1305_beforenm = (A, I, g)=>(Q._crypto_box_curve25519xchacha20poly1305_beforenm = j.ci)(A, I, g), Q._crypto_box_curve25519xchacha20poly1305_detached_afternm = (A, I, g, C, B, i, o)=>(Q._crypto_box_curve25519xchacha20poly1305_detached_afternm = j.di)(A, I, g, C, B, i, o), Q._crypto_box_curve25519xchacha20poly1305_detached = (A, I, g, C, B, i, o, E)=>(Q._crypto_box_curve25519xchacha20poly1305_detached = j.ei)(A, I, g, C, B, i, o, E), Q._crypto_box_curve25519xchacha20poly1305_easy_afternm = (A, I, g, C, B, i)=>(Q._crypto_box_curve25519xchacha20poly1305_easy_afternm = j.fi)(A, I, g, C, B, i), Q._crypto_box_curve25519xchacha20poly1305_easy = (A, I, g, C, B, i, o)=>(Q._crypto_box_curve25519xchacha20poly1305_easy = j.gi)(A, I, g, C, B, i, o), Q._crypto_box_curve25519xchacha20poly1305_open_detached_afternm = (A, I, g, C, B, i, o)=>(Q._crypto_box_curve25519xchacha20poly1305_open_detached_afternm = j.hi)(A, I, g, C, B, i, o), Q._crypto_box_curve25519xchacha20poly1305_open_detached = (A, I, g, C, B, i, o, E)=>(Q._crypto_box_curve25519xchacha20poly1305_open_detached = j.ii)(A, I, g, C, B, i, o, E), Q._crypto_box_curve25519xchacha20poly1305_open_easy_afternm = (A, I, g, C, B, i)=>(Q._crypto_box_curve25519xchacha20poly1305_open_easy_afternm = j.ji)(A, I, g, C, B, i), Q._crypto_box_curve25519xchacha20poly1305_open_easy = (A, I, g, C, B, i, o)=>(Q._crypto_box_curve25519xchacha20poly1305_open_easy = j.ki)(A, I, g, C, B, i, o), Q._crypto_box_curve25519xchacha20poly1305_seedbytes = ()=>(Q._crypto_box_curve25519xchacha20poly1305_seedbytes = j.li)(), Q._crypto_box_curve25519xchacha20poly1305_publickeybytes = ()=>(Q._crypto_box_curve25519xchacha20poly1305_publickeybytes = j.mi)(), Q._crypto_box_curve25519xchacha20poly1305_secretkeybytes = ()=>(Q._crypto_box_curve25519xchacha20poly1305_secretkeybytes = j.ni)(), Q._crypto_box_curve25519xchacha20poly1305_beforenmbytes = ()=>(Q._crypto_box_curve25519xchacha20poly1305_beforenmbytes = j.oi)(), Q._crypto_box_curve25519xchacha20poly1305_noncebytes = ()=>(Q._crypto_box_curve25519xchacha20poly1305_noncebytes = j.pi)(), Q._crypto_box_curve25519xchacha20poly1305_macbytes = ()=>(Q._crypto_box_curve25519xchacha20poly1305_macbytes = j.qi)(), Q._crypto_box_curve25519xchacha20poly1305_messagebytes_max = ()=>(Q._crypto_box_curve25519xchacha20poly1305_messagebytes_max = j.ri)(), Q._crypto_box_curve25519xchacha20poly1305_seal = (A, I, g, C, B)=>(Q._crypto_box_curve25519xchacha20poly1305_seal = j.si)(A, I, g, C, B), Q._crypto_box_curve25519xchacha20poly1305_seal_open = (A, I, g, C, B, i)=>(Q._crypto_box_curve25519xchacha20poly1305_seal_open = j.ti)(A, I, g, C, B, i), Q._crypto_box_curve25519xchacha20poly1305_sealbytes = ()=>(Q._crypto_box_curve25519xchacha20poly1305_sealbytes = j.ui)(), Q._crypto_core_ed25519_is_valid_point = (A)=>(Q._crypto_core_ed25519_is_valid_point = j.vi)(A), Q._crypto_core_ed25519_add = (A, I, g)=>(Q._crypto_core_ed25519_add = j.wi)(A, I, g), Q._crypto_core_ed25519_sub = (A, I, g)=>(Q._crypto_core_ed25519_sub = j.xi)(A, I, g), Q._crypto_core_ed25519_from_uniform = (A, I)=>(Q._crypto_core_ed25519_from_uniform = j.yi)(A, I), Q._crypto_core_ed25519_random = (A)=>(Q._crypto_core_ed25519_random = j.zi)(A), Q._crypto_core_ed25519_scalar_random = (A)=>(Q._crypto_core_ed25519_scalar_random = j.Ai)(A), Q._crypto_core_ed25519_scalar_invert = (A, I)=>(Q._crypto_core_ed25519_scalar_invert = j.Bi)(A, I), Q._crypto_core_ed25519_scalar_negate = (A, I)=>(Q._crypto_core_ed25519_scalar_negate = j.Ci)(A, I), Q._crypto_core_ed25519_scalar_complement = (A, I)=>(Q._crypto_core_ed25519_scalar_complement = j.Di)(A, I), Q._crypto_core_ed25519_scalar_add = (A, I, g)=>(Q._crypto_core_ed25519_scalar_add = j.Ei)(A, I, g), Q._crypto_core_ed25519_scalar_reduce = (A, I)=>(Q._crypto_core_ed25519_scalar_reduce = j.Fi)(A, I), Q._crypto_core_ed25519_scalar_sub = (A, I, g)=>(Q._crypto_core_ed25519_scalar_sub = j.Gi)(A, I, g), Q._crypto_core_ed25519_scalar_mul = (A, I, g)=>(Q._crypto_core_ed25519_scalar_mul = j.Hi)(A, I, g), Q._crypto_core_ed25519_bytes = ()=>(Q._crypto_core_ed25519_bytes = j.Ii)(), Q._crypto_core_ed25519_nonreducedscalarbytes = ()=>(Q._crypto_core_ed25519_nonreducedscalarbytes = j.Ji)(), Q._crypto_core_ed25519_uniformbytes = ()=>(Q._crypto_core_ed25519_uniformbytes = j.Ki)(), Q._crypto_core_ed25519_hashbytes = ()=>(Q._crypto_core_ed25519_hashbytes = j.Li)(), Q._crypto_core_ed25519_scalarbytes = ()=>(Q._crypto_core_ed25519_scalarbytes = j.Mi)(), Q._crypto_core_ristretto255_is_valid_point = (A)=>(Q._crypto_core_ristretto255_is_valid_point = j.Ni)(A), Q._crypto_core_ristretto255_add = (A, I, g)=>(Q._crypto_core_ristretto255_add = j.Oi)(A, I, g), Q._crypto_core_ristretto255_sub = (A, I, g)=>(Q._crypto_core_ristretto255_sub = j.Pi)(A, I, g), Q._crypto_core_ristretto255_from_hash = (A, I)=>(Q._crypto_core_ristretto255_from_hash = j.Qi)(A, I), Q._crypto_core_ristretto255_random = (A)=>(Q._crypto_core_ristretto255_random = j.Ri)(A), Q._crypto_core_ristretto255_scalar_random = (A)=>(Q._crypto_core_ristretto255_scalar_random = j.Si)(A), Q._crypto_core_ristretto255_scalar_invert = (A, I)=>(Q._crypto_core_ristretto255_scalar_invert = j.Ti)(A, I), Q._crypto_core_ristretto255_scalar_negate = (A, I)=>(Q._crypto_core_ristretto255_scalar_negate = j.Ui)(A, I), Q._crypto_core_ristretto255_scalar_complement = (A, I)=>(Q._crypto_core_ristretto255_scalar_complement = j.Vi)(A, I), Q._crypto_core_ristretto255_scalar_add = (A, I, g)=>(Q._crypto_core_ristretto255_scalar_add = j.Wi)(A, I, g), Q._crypto_core_ristretto255_scalar_sub = (A, I, g)=>(Q._crypto_core_ristretto255_scalar_sub = j.Xi)(A, I, g), Q._crypto_core_ristretto255_scalar_mul = (A, I, g)=>(Q._crypto_core_ristretto255_scalar_mul = j.Yi)(A, I, g), Q._crypto_core_ristretto255_scalar_reduce = (A, I)=>(Q._crypto_core_ristretto255_scalar_reduce = j.Zi)(A, I), Q._crypto_core_ristretto255_bytes = ()=>(Q._crypto_core_ristretto255_bytes = j._i)(), Q._crypto_core_ristretto255_nonreducedscalarbytes = ()=>(Q._crypto_core_ristretto255_nonreducedscalarbytes = j.$i)(), Q._crypto_core_ristretto255_hashbytes = ()=>(Q._crypto_core_ristretto255_hashbytes = j.aj)(), Q._crypto_core_ristretto255_scalarbytes = ()=>(Q._crypto_core_ristretto255_scalarbytes = j.bj)(), Q._crypto_pwhash_scryptsalsa208sha256_ll = (A, I, g, C, B, i, o, E, a, _)=>(Q._crypto_pwhash_scryptsalsa208sha256_ll = j.cj)(A, I, g, C, B, i, o, E, a, _), Q._crypto_pwhash_scryptsalsa208sha256_bytes_min = ()=>(Q._crypto_pwhash_scryptsalsa208sha256_bytes_min = j.dj)(), Q._crypto_pwhash_scryptsalsa208sha256_bytes_max = ()=>(Q._crypto_pwhash_scryptsalsa208sha256_bytes_max = j.ej)(), Q._crypto_pwhash_scryptsalsa208sha256_passwd_min = ()=>(Q._crypto_pwhash_scryptsalsa208sha256_passwd_min = j.fj)(), Q._crypto_pwhash_scryptsalsa208sha256_passwd_max = ()=>(Q._crypto_pwhash_scryptsalsa208sha256_passwd_max = j.gj)(), Q._crypto_pwhash_scryptsalsa208sha256_saltbytes = ()=>(Q._crypto_pwhash_scryptsalsa208sha256_saltbytes = j.hj)(), Q._crypto_pwhash_scryptsalsa208sha256_strbytes = ()=>(Q._crypto_pwhash_scryptsalsa208sha256_strbytes = j.ij)(), Q._crypto_pwhash_scryptsalsa208sha256_strprefix = ()=>(Q._crypto_pwhash_scryptsalsa208sha256_strprefix = j.jj)(), Q._crypto_pwhash_scryptsalsa208sha256_opslimit_min = ()=>(Q._crypto_pwhash_scryptsalsa208sha256_opslimit_min = j.kj)(), Q._crypto_pwhash_scryptsalsa208sha256_opslimit_max = ()=>(Q._crypto_pwhash_scryptsalsa208sha256_opslimit_max = j.lj)(), Q._crypto_pwhash_scryptsalsa208sha256_memlimit_min = ()=>(Q._crypto_pwhash_scryptsalsa208sha256_memlimit_min = j.mj)(), Q._crypto_pwhash_scryptsalsa208sha256_memlimit_max = ()=>(Q._crypto_pwhash_scryptsalsa208sha256_memlimit_max = j.nj)(), Q._crypto_pwhash_scryptsalsa208sha256_opslimit_interactive = ()=>(Q._crypto_pwhash_scryptsalsa208sha256_opslimit_interactive = j.oj)(), Q._crypto_pwhash_scryptsalsa208sha256_memlimit_interactive = ()=>(Q._crypto_pwhash_scryptsalsa208sha256_memlimit_interactive = j.pj)(), Q._crypto_pwhash_scryptsalsa208sha256_opslimit_sensitive = ()=>(Q._crypto_pwhash_scryptsalsa208sha256_opslimit_sensitive = j.qj)(), Q._crypto_pwhash_scryptsalsa208sha256_memlimit_sensitive = ()=>(Q._crypto_pwhash_scryptsalsa208sha256_memlimit_sensitive = j.rj)(), Q._crypto_pwhash_scryptsalsa208sha256 = (A, I, g, C, B, i, o, E, a, _)=>(Q._crypto_pwhash_scryptsalsa208sha256 = j.sj)(A, I, g, C, B, i, o, E, a, _), Q._crypto_pwhash_scryptsalsa208sha256_str = (A, I, g, C, B, i, o)=>(Q._crypto_pwhash_scryptsalsa208sha256_str = j.tj)(A, I, g, C, B, i, o), Q._crypto_pwhash_scryptsalsa208sha256_str_verify = (A, I, g, C)=>(Q._crypto_pwhash_scryptsalsa208sha256_str_verify = j.uj)(A, I, g, C), Q._crypto_pwhash_scryptsalsa208sha256_str_needs_rehash = (A, I, g, C)=>(Q._crypto_pwhash_scryptsalsa208sha256_str_needs_rehash = j.vj)(A, I, g, C), Q._crypto_scalarmult_ed25519 = (A, I, g)=>(Q._crypto_scalarmult_ed25519 = j.wj)(A, I, g), Q._crypto_scalarmult_ed25519_noclamp = (A, I, g)=>(Q._crypto_scalarmult_ed25519_noclamp = j.xj)(A, I, g), Q._crypto_scalarmult_ed25519_base = (A, I)=>(Q._crypto_scalarmult_ed25519_base = j.yj)(A, I), Q._crypto_scalarmult_ed25519_base_noclamp = (A, I)=>(Q._crypto_scalarmult_ed25519_base_noclamp = j.zj)(A, I), Q._crypto_scalarmult_ed25519_bytes = ()=>(Q._crypto_scalarmult_ed25519_bytes = j.Aj)(), Q._crypto_scalarmult_ed25519_scalarbytes = ()=>(Q._crypto_scalarmult_ed25519_scalarbytes = j.Bj)(), Q._crypto_scalarmult_ristretto255 = (A, I, g)=>(Q._crypto_scalarmult_ristretto255 = j.Cj)(A, I, g), Q._crypto_scalarmult_ristretto255_base = (A, I)=>(Q._crypto_scalarmult_ristretto255_base = j.Dj)(A, I), Q._crypto_scalarmult_ristretto255_bytes = ()=>(Q._crypto_scalarmult_ristretto255_bytes = j.Ej)(), Q._crypto_scalarmult_ristretto255_scalarbytes = ()=>(Q._crypto_scalarmult_ristretto255_scalarbytes = j.Fj)(), Q._crypto_secretbox_xchacha20poly1305_detached = (A, I, g, C, B, i, o)=>(Q._crypto_secretbox_xchacha20poly1305_detached = j.Gj)(A, I, g, C, B, i, o), Q._crypto_secretbox_xchacha20poly1305_easy = (A, I, g, C, B, i)=>(Q._crypto_secretbox_xchacha20poly1305_easy = j.Hj)(A, I, g, C, B, i), Q._crypto_secretbox_xchacha20poly1305_open_detached = (A, I, g, C, B, i, o)=>(Q._crypto_secretbox_xchacha20poly1305_open_detached = j.Ij)(A, I, g, C, B, i, o), Q._crypto_secretbox_xchacha20poly1305_open_easy = (A, I, g, C, B, i)=>(Q._crypto_secretbox_xchacha20poly1305_open_easy = j.Jj)(A, I, g, C, B, i), Q._crypto_secretbox_xchacha20poly1305_keybytes = ()=>(Q._crypto_secretbox_xchacha20poly1305_keybytes = j.Kj)(), Q._crypto_secretbox_xchacha20poly1305_noncebytes = ()=>(Q._crypto_secretbox_xchacha20poly1305_noncebytes = j.Lj)(), Q._crypto_secretbox_xchacha20poly1305_macbytes = ()=>(Q._crypto_secretbox_xchacha20poly1305_macbytes = j.Mj)(), Q._crypto_secretbox_xchacha20poly1305_messagebytes_max = ()=>(Q._crypto_secretbox_xchacha20poly1305_messagebytes_max = j.Nj)(), Q._crypto_shorthash_siphashx24_bytes = ()=>(Q._crypto_shorthash_siphashx24_bytes = j.Oj)(), Q._crypto_shorthash_siphashx24_keybytes = ()=>(Q._crypto_shorthash_siphashx24_keybytes = j.Pj)(), Q._crypto_shorthash_siphashx24 = (A, I, g, C, B)=>(Q._crypto_shorthash_siphashx24 = j.Qj)(A, I, g, C, B), Q._crypto_stream_salsa2012 = (A, I, g, C, B)=>(Q._crypto_stream_salsa2012 = j.Rj)(A, I, g, C, B), Q._crypto_stream_salsa2012_xor = (A, I, g, C, B, i)=>(Q._crypto_stream_salsa2012_xor = j.Sj)(A, I, g, C, B, i), Q._crypto_stream_salsa2012_keybytes = ()=>(Q._crypto_stream_salsa2012_keybytes = j.Tj)(), Q._crypto_stream_salsa2012_noncebytes = ()=>(Q._crypto_stream_salsa2012_noncebytes = j.Uj)(), Q._crypto_stream_salsa2012_messagebytes_max = ()=>(Q._crypto_stream_salsa2012_messagebytes_max = j.Vj)(), Q._crypto_stream_salsa2012_keygen = (A)=>(Q._crypto_stream_salsa2012_keygen = j.Wj)(A), Q._crypto_stream_salsa208 = (A, I, g, C, B)=>(Q._crypto_stream_salsa208 = j.Xj)(A, I, g, C, B), Q._crypto_stream_salsa208_xor = (A, I, g, C, B, i)=>(Q._crypto_stream_salsa208_xor = j.Yj)(A, I, g, C, B, i), Q._crypto_stream_salsa208_keybytes = ()=>(Q._crypto_stream_salsa208_keybytes = j.Zj)(), Q._crypto_stream_salsa208_noncebytes = ()=>(Q._crypto_stream_salsa208_noncebytes = j._j)(), Q._crypto_stream_salsa208_messagebytes_max = ()=>(Q._crypto_stream_salsa208_messagebytes_max = j.$j)(), Q._crypto_stream_salsa208_keygen = (A)=>(Q._crypto_stream_salsa208_keygen = j.ak)(A), Q._crypto_stream_xchacha20_keybytes = ()=>(Q._crypto_stream_xchacha20_keybytes = j.bk)(), Q._crypto_stream_xchacha20_noncebytes = ()=>(Q._crypto_stream_xchacha20_noncebytes = j.ck)(), Q._crypto_stream_xchacha20_messagebytes_max = ()=>(Q._crypto_stream_xchacha20_messagebytes_max = j.dk)(), Q._crypto_stream_xchacha20 = (A, I, g, C, B)=>(Q._crypto_stream_xchacha20 = j.ek)(A, I, g, C, B), Q._crypto_stream_xchacha20_xor_ic = (A, I, g, C, B, i, o, E)=>(Q._crypto_stream_xchacha20_xor_ic = j.fk)(A, I, g, C, B, i, o, E), Q._crypto_stream_xchacha20_xor = (A, I, g, C, B, i)=>(Q._crypto_stream_xchacha20_xor = j.gk)(A, I, g, C, B, i), Q._crypto_stream_xchacha20_keygen = (A)=>(Q._crypto_stream_xchacha20_keygen = j.hk)(A), Q._malloc = (A)=>(Q._malloc = j.ik)(A), Q._free = (A)=>(Q._free = j.jk)(A), Q.setValue = function(A, I, g = "i8") {
                        switch(g.endsWith("*") && (g = "*"), g){
                            case "i1":
                            case "i8":
                                h[A >> 0] = I;
                                break;
                            case "i16":
                                p[A >> 1] = I;
                                break;
                            case "i32":
                                w[A >> 2] = I;
                                break;
                            case "i64":
                                d("to do setValue(i64) use WASM_BIGINT");
                            case "float":
                                n[A >> 2] = I;
                                break;
                            case "double":
                                k[A >> 3] = I;
                                break;
                            case "*":
                                f[A >> 2] = I;
                                break;
                            default:
                                d(`invalid type for setValue: ${g}`);
                        }
                    }, Q.getValue = function(A, I = "i8") {
                        switch(I.endsWith("*") && (I = "*"), I){
                            case "i1":
                            case "i8":
                                return h[A >> 0];
                            case "i16":
                                return p[A >> 1];
                            case "i32":
                                return w[A >> 2];
                            case "i64":
                                d("to do getValue(i64) use WASM_BIGINT");
                            case "float":
                                return n[A >> 2];
                            case "double":
                                return k[A >> 3];
                            case "*":
                                return f[A >> 2];
                            default:
                                d(`invalid type for getValue: ${I}`);
                        }
                    }, Q.UTF8ToString = L, Y = function A() {
                        u || X(), u || (Y = A);
                    }, Q.preInit) for("function" == typeof Q.preInit && (Q.preInit = [
                        Q.preInit
                    ]); Q.preInit.length > 0;)Q.preInit.pop()();
                    X();
                });
            };
            var g, B, Q = void 0 !== Q ? Q : {}, i = Object.assign({}, Q), o = "object" == typeof window, E = "function" == typeof importScripts, a = "object" == typeof $4TNnu && "object" == typeof $4TNnu.versions && "string" == typeof $4TNnu.versions.node, _ = "";
            if (a) {
                var c = (parcelRequire("5Io6y")), t = (parcelRequire("5Io6y"));
                _ = E ? t.dirname(_) + "/" : $25e5cd8cfcef32a3$var$__dirname + "/", g = (A, I)=>(A = function(A) {
                        return A.startsWith("file://");
                    }(A) ? new URL(A) : t.normalize(A), c.readFileSync(A, I ? void 0 : "utf8")), B = (A)=>{
                    var I = g(A, !0);
                    return I.buffer || (I = new Uint8Array(I)), I;
                }, !Q.thisProgram && $4TNnu.argv.length > 1 && $4TNnu.argv[1].replace(/\\/g, "/"), $4TNnu.argv.slice(2), module.exports = Q, Q.inspect = ()=>"[Emscripten Module object]";
            } else (o || E) && (E ? _ = self.location.href : "undefined" != typeof document && document.currentScript && (_ = document.currentScript.src), _ = 0 !== _.indexOf("blob:") ? _.substr(0, _.replace(/[?#].*/, "").lastIndexOf("/") + 1) : "", g = (A)=>{
                var I = new XMLHttpRequest;
                return I.open("GET", A, !1), I.send(null), I.responseText;
            }, E && (B = (A)=>{
                var I = new XMLHttpRequest;
                return I.open("GET", A, !1), I.responseType = "arraybuffer", I.send(null), new Uint8Array(I.response);
            }));
            Q.print;
            var r, e, y = Q.printErr || void 0;
            Object.assign(Q, i), i = null, Q.arguments && Q.arguments, Q.thisProgram && Q.thisProgram, Q.quit && Q.quit, Q.wasmBinary && (r = Q.wasmBinary), Q.noExitRuntime, "object" != typeof WebAssembly && H("no native wasm support detected");
            var s, h, D, p, w, f, n, k = !1;
            function F() {
                var A = e.buffer;
                Q.HEAP8 = s = new Int8Array(A), Q.HEAP16 = D = new Int16Array(A), Q.HEAPU8 = h = new Uint8Array(A), Q.HEAPU16 = new Uint16Array(A), Q.HEAP32 = p = new Int32Array(A), Q.HEAPU32 = w = new Uint32Array(A), Q.HEAPF32 = f = new Float32Array(A), Q.HEAPF64 = n = new Float64Array(A);
            }
            var N = [], S = [], G = [], M = 0, b = null, K = null;
            function H(A) {
                throw Q.onAbort && Q.onAbort(A), y(A = "Aborted(" + A + ")"), k = !0, A += ". Build with -sASSERTIONS for more info.", new WebAssembly.RuntimeError(A);
            }
            var Y, d, J = "data:application/octet-stream;base64,";
            function U(A) {
                return A.startsWith(J);
            }
            U(Y = "data:application/octet-stream;base64,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") || (d = Y, Y = Q.locateFile ? Q.locateFile(d, _) : _ + d);
            var l, m = {
                36800: ()=>Q.getRandomValue(),
                36836: ()=>{
                    if (void 0 === Q.getRandomValue) try {
                        var A = "object" == typeof window ? window : self, I = void 0 !== A.crypto ? A.crypto : A.msCrypto, g = function() {
                            var A = new Uint32Array(1);
                            return I.getRandomValues(A), A[0] >>> 0;
                        };
                        g(), Q.getRandomValue = g;
                    } catch (A) {
                        try {
                            var C = (parcelRequire("aO8Ot")), B = function() {
                                var A = C.randomBytes(4);
                                return (A[0] << 24 | A[1] << 16 | A[2] << 8 | A[3]) >>> 0;
                            };
                            B(), Q.getRandomValue = B;
                        } catch (A) {
                            throw "No secure random number generator found";
                        }
                    }
                }
            }, u = (A)=>{
                for(; A.length > 0;)A.shift()(Q);
            }, x = "undefined" != typeof TextDecoder ? new TextDecoder("utf8") : void 0, R = (A, I)=>A ? ((A, I, g)=>{
                    for(var C = I + g, B = I; A[B] && !(B >= C);)++B;
                    if (B - I > 16 && A.buffer && x) return x.decode(A.subarray(I, B));
                    for(var Q = ""; I < B;){
                        var i = A[I++];
                        if (128 & i) {
                            var o = 63 & A[I++];
                            if (192 != (224 & i)) {
                                var E = 63 & A[I++];
                                if ((i = 224 == (240 & i) ? (15 & i) << 12 | o << 6 | E : (7 & i) << 18 | o << 12 | E << 6 | 63 & A[I++]) < 65536) Q += String.fromCharCode(i);
                                else {
                                    var a = i - 65536;
                                    Q += String.fromCharCode(55296 | a >> 10, 56320 | 1023 & a);
                                }
                            } else Q += String.fromCharCode((31 & i) << 6 | o);
                        } else Q += String.fromCharCode(i);
                    }
                    return Q;
                })(h, A, I) : "", v = [], L = (A)=>{
                var I = (A - e.buffer.byteLength + 65535) / 65536;
                try {
                    return e.grow(I), F(), 1;
                } catch (A) {}
            }, P = {
                b: (A, I, g, C)=>{
                    H(`Assertion failed: ${R(A)}, at: ` + [
                        I ? R(I) : "unknown filename",
                        g,
                        C ? R(C) : "unknown function"
                    ]);
                },
                c: ()=>{
                    H("");
                },
                a: (A, I, g)=>((A, I, g)=>{
                        var C = ((A, I)=>{
                            var g;
                            for(v.length = 0; g = h[A++];)I += 105 != g && I % 8 ? 4 : 0, v.push(105 == g ? p[I >> 2] : n[I >> 3]), I += 105 == g ? 4 : 8;
                            return v;
                        })(I, g);
                        return m[A].apply(null, C);
                    })(A, I, g),
                e: (A, I, g)=>h.copyWithin(A, I, I + g),
                d: (A)=>{
                    var I = h.length, g = 2147483648;
                    if ((A >>>= 0) > g) return !1;
                    for(var C, B = 1; B <= 4; B *= 2){
                        var Q = I * (1 + .2 / B);
                        Q = Math.min(Q, A + 100663296);
                        var i = Math.min(g, (C = Math.max(A, Q)) + (65536 - C % 65536) % 65536);
                        if (L(i)) return !0;
                    }
                    return !1;
                }
            }, q = function() {
                var A, I, g = {
                    a: P
                };
                function C(A, I) {
                    var g = A.exports;
                    return e = (q = g).f, F(), q.kk, function(A) {
                        if (M--, Q.monitorRunDependencies && Q.monitorRunDependencies(M), 0 == M && (null !== b && (clearInterval(b), b = null), K)) {
                            var I = K;
                            K = null, I();
                        }
                    }(), g;
                }
                if (M++, Q.monitorRunDependencies && Q.monitorRunDependencies(M), Q.instantiateWasm) try {
                    return Q.instantiateWasm(g, C);
                } catch (A) {
                    return y(`Module.instantiateWasm callback failed with error: ${A}`), !1;
                }
                return A = g, I = function(A) {
                    C(A.instance);
                }, (function(A) {
                    return Promise.resolve().then(()=>(function(A) {
                            if (A == Y && r) return new Uint8Array(r);
                            var I = function(A) {
                                if (U(A)) return function(A) {
                                    if (void 0 !== a && a) {
                                        var I = $25e5cd8cfcef32a3$require$Buffer.from(A, "base64");
                                        return new Uint8Array(I.buffer, I.byteOffset, I.length);
                                    }
                                    try {
                                        for(var g = atob(A), C = new Uint8Array(g.length), B = 0; B < g.length; ++B)C[B] = g.charCodeAt(B);
                                        return C;
                                    } catch (A) {
                                        throw new Error("Converting base64 string to bytes failed.");
                                    }
                                }(A.slice(J.length));
                            }(A);
                            if (I) return I;
                            if (B) return B(A);
                            throw "both async and sync fetching of the wasm failed";
                        })(A));
                })(Y).then((I)=>WebAssembly.instantiate(I, A)).then((A)=>A).then(I, (A)=>{
                    y(`failed to asynchronously prepare wasm: ${A}`), H(A);
                }), {};
            }();
            function z() {
                function A() {
                    l || (l = !0, Q.calledRun = !0, k || (u(S), Q.onRuntimeInitialized && Q.onRuntimeInitialized(), function() {
                        if (Q.postRun) for("function" == typeof Q.postRun && (Q.postRun = [
                            Q.postRun
                        ]); Q.postRun.length;)A = Q.postRun.shift(), G.unshift(A);
                        var A;
                        u(G);
                    }()));
                }
                M > 0 || (function() {
                    if (Q.preRun) for("function" == typeof Q.preRun && (Q.preRun = [
                        Q.preRun
                    ]); Q.preRun.length;)A = Q.preRun.shift(), N.unshift(A);
                    var A;
                    u(N);
                }(), M > 0 || (Q.setStatus ? (Q.setStatus("Running..."), setTimeout(function() {
                    setTimeout(function() {
                        Q.setStatus("");
                    }, 1), A();
                }, 1)) : A()));
            }
            if (Q._crypto_aead_aegis128l_keybytes = ()=>(Q._crypto_aead_aegis128l_keybytes = q.g)(), Q._crypto_aead_aegis128l_nsecbytes = ()=>(Q._crypto_aead_aegis128l_nsecbytes = q.h)(), Q._crypto_aead_aegis128l_npubbytes = ()=>(Q._crypto_aead_aegis128l_npubbytes = q.i)(), Q._crypto_aead_aegis128l_abytes = ()=>(Q._crypto_aead_aegis128l_abytes = q.j)(), Q._crypto_aead_aegis128l_messagebytes_max = ()=>(Q._crypto_aead_aegis128l_messagebytes_max = q.k)(), Q._crypto_aead_aegis128l_keygen = (A)=>(Q._crypto_aead_aegis128l_keygen = q.l)(A), Q._crypto_aead_aegis128l_encrypt = (A, I, g, C, B, i, o, E, a, _, c)=>(Q._crypto_aead_aegis128l_encrypt = q.m)(A, I, g, C, B, i, o, E, a, _, c), Q._crypto_aead_aegis128l_encrypt_detached = (A, I, g, C, B, i, o, E, a, _, c, t)=>(Q._crypto_aead_aegis128l_encrypt_detached = q.n)(A, I, g, C, B, i, o, E, a, _, c, t), Q._crypto_aead_aegis128l_decrypt = (A, I, g, C, B, i, o, E, a, _, c)=>(Q._crypto_aead_aegis128l_decrypt = q.o)(A, I, g, C, B, i, o, E, a, _, c), Q._crypto_aead_aegis128l_decrypt_detached = (A, I, g, C, B, i, o, E, a, _, c)=>(Q._crypto_aead_aegis128l_decrypt_detached = q.p)(A, I, g, C, B, i, o, E, a, _, c), Q._crypto_aead_aegis256_keybytes = ()=>(Q._crypto_aead_aegis256_keybytes = q.q)(), Q._crypto_aead_aegis256_nsecbytes = ()=>(Q._crypto_aead_aegis256_nsecbytes = q.r)(), Q._crypto_aead_aegis256_npubbytes = ()=>(Q._crypto_aead_aegis256_npubbytes = q.s)(), Q._crypto_aead_aegis256_abytes = ()=>(Q._crypto_aead_aegis256_abytes = q.t)(), Q._crypto_aead_aegis256_messagebytes_max = ()=>(Q._crypto_aead_aegis256_messagebytes_max = q.u)(), Q._crypto_aead_aegis256_keygen = (A)=>(Q._crypto_aead_aegis256_keygen = q.v)(A), Q._crypto_aead_aegis256_encrypt = (A, I, g, C, B, i, o, E, a, _, c)=>(Q._crypto_aead_aegis256_encrypt = q.w)(A, I, g, C, B, i, o, E, a, _, c), Q._crypto_aead_aegis256_encrypt_detached = (A, I, g, C, B, i, o, E, a, _, c, t)=>(Q._crypto_aead_aegis256_encrypt_detached = q.x)(A, I, g, C, B, i, o, E, a, _, c, t), Q._crypto_aead_aegis256_decrypt = (A, I, g, C, B, i, o, E, a, _, c)=>(Q._crypto_aead_aegis256_decrypt = q.y)(A, I, g, C, B, i, o, E, a, _, c), Q._crypto_aead_aegis256_decrypt_detached = (A, I, g, C, B, i, o, E, a, _, c)=>(Q._crypto_aead_aegis256_decrypt_detached = q.z)(A, I, g, C, B, i, o, E, a, _, c), Q._crypto_aead_chacha20poly1305_encrypt_detached = (A, I, g, C, B, i, o, E, a, _, c, t)=>(Q._crypto_aead_chacha20poly1305_encrypt_detached = q.A)(A, I, g, C, B, i, o, E, a, _, c, t), Q._crypto_aead_chacha20poly1305_encrypt = (A, I, g, C, B, i, o, E, a, _, c)=>(Q._crypto_aead_chacha20poly1305_encrypt = q.B)(A, I, g, C, B, i, o, E, a, _, c), Q._crypto_aead_chacha20poly1305_ietf_encrypt_detached = (A, I, g, C, B, i, o, E, a, _, c, t)=>(Q._crypto_aead_chacha20poly1305_ietf_encrypt_detached = q.C)(A, I, g, C, B, i, o, E, a, _, c, t), Q._crypto_aead_chacha20poly1305_ietf_encrypt = (A, I, g, C, B, i, o, E, a, _, c)=>(Q._crypto_aead_chacha20poly1305_ietf_encrypt = q.D)(A, I, g, C, B, i, o, E, a, _, c), Q._crypto_aead_chacha20poly1305_decrypt_detached = (A, I, g, C, B, i, o, E, a, _, c)=>(Q._crypto_aead_chacha20poly1305_decrypt_detached = q.E)(A, I, g, C, B, i, o, E, a, _, c), Q._crypto_aead_chacha20poly1305_decrypt = (A, I, g, C, B, i, o, E, a, _, c)=>(Q._crypto_aead_chacha20poly1305_decrypt = q.F)(A, I, g, C, B, i, o, E, a, _, c), Q._crypto_aead_chacha20poly1305_ietf_decrypt_detached = (A, I, g, C, B, i, o, E, a, _, c)=>(Q._crypto_aead_chacha20poly1305_ietf_decrypt_detached = q.G)(A, I, g, C, B, i, o, E, a, _, c), Q._crypto_aead_chacha20poly1305_ietf_decrypt = (A, I, g, C, B, i, o, E, a, _, c)=>(Q._crypto_aead_chacha20poly1305_ietf_decrypt = q.H)(A, I, g, C, B, i, o, E, a, _, c), Q._crypto_aead_chacha20poly1305_ietf_keybytes = ()=>(Q._crypto_aead_chacha20poly1305_ietf_keybytes = q.I)(), Q._crypto_aead_chacha20poly1305_ietf_npubbytes = ()=>(Q._crypto_aead_chacha20poly1305_ietf_npubbytes = q.J)(), Q._crypto_aead_chacha20poly1305_ietf_nsecbytes = ()=>(Q._crypto_aead_chacha20poly1305_ietf_nsecbytes = q.K)(), Q._crypto_aead_chacha20poly1305_ietf_abytes = ()=>(Q._crypto_aead_chacha20poly1305_ietf_abytes = q.L)(), Q._crypto_aead_chacha20poly1305_ietf_messagebytes_max = ()=>(Q._crypto_aead_chacha20poly1305_ietf_messagebytes_max = q.M)(), Q._crypto_aead_chacha20poly1305_ietf_keygen = (A)=>(Q._crypto_aead_chacha20poly1305_ietf_keygen = q.N)(A), Q._crypto_aead_chacha20poly1305_keybytes = ()=>(Q._crypto_aead_chacha20poly1305_keybytes = q.O)(), Q._crypto_aead_chacha20poly1305_npubbytes = ()=>(Q._crypto_aead_chacha20poly1305_npubbytes = q.P)(), Q._crypto_aead_chacha20poly1305_nsecbytes = ()=>(Q._crypto_aead_chacha20poly1305_nsecbytes = q.Q)(), Q._crypto_aead_chacha20poly1305_abytes = ()=>(Q._crypto_aead_chacha20poly1305_abytes = q.R)(), Q._crypto_aead_chacha20poly1305_messagebytes_max = ()=>(Q._crypto_aead_chacha20poly1305_messagebytes_max = q.S)(), Q._crypto_aead_chacha20poly1305_keygen = (A)=>(Q._crypto_aead_chacha20poly1305_keygen = q.T)(A), Q._crypto_aead_xchacha20poly1305_ietf_encrypt_detached = (A, I, g, C, B, i, o, E, a, _, c, t)=>(Q._crypto_aead_xchacha20poly1305_ietf_encrypt_detached = q.U)(A, I, g, C, B, i, o, E, a, _, c, t), Q._crypto_aead_xchacha20poly1305_ietf_encrypt = (A, I, g, C, B, i, o, E, a, _, c)=>(Q._crypto_aead_xchacha20poly1305_ietf_encrypt = q.V)(A, I, g, C, B, i, o, E, a, _, c), Q._crypto_aead_xchacha20poly1305_ietf_decrypt_detached = (A, I, g, C, B, i, o, E, a, _, c)=>(Q._crypto_aead_xchacha20poly1305_ietf_decrypt_detached = q.W)(A, I, g, C, B, i, o, E, a, _, c), Q._crypto_aead_xchacha20poly1305_ietf_decrypt = (A, I, g, C, B, i, o, E, a, _, c)=>(Q._crypto_aead_xchacha20poly1305_ietf_decrypt = q.X)(A, I, g, C, B, i, o, E, a, _, c), Q._crypto_aead_xchacha20poly1305_ietf_keybytes = ()=>(Q._crypto_aead_xchacha20poly1305_ietf_keybytes = q.Y)(), Q._crypto_aead_xchacha20poly1305_ietf_npubbytes = ()=>(Q._crypto_aead_xchacha20poly1305_ietf_npubbytes = q.Z)(), Q._crypto_aead_xchacha20poly1305_ietf_nsecbytes = ()=>(Q._crypto_aead_xchacha20poly1305_ietf_nsecbytes = q._)(), Q._crypto_aead_xchacha20poly1305_ietf_abytes = ()=>(Q._crypto_aead_xchacha20poly1305_ietf_abytes = q.$)(), Q._crypto_aead_xchacha20poly1305_ietf_messagebytes_max = ()=>(Q._crypto_aead_xchacha20poly1305_ietf_messagebytes_max = q.aa)(), Q._crypto_aead_xchacha20poly1305_ietf_keygen = (A)=>(Q._crypto_aead_xchacha20poly1305_ietf_keygen = q.ba)(A), Q._crypto_auth_bytes = ()=>(Q._crypto_auth_bytes = q.ca)(), Q._crypto_auth_keybytes = ()=>(Q._crypto_auth_keybytes = q.da)(), Q._crypto_auth_primitive = ()=>(Q._crypto_auth_primitive = q.ea)(), Q._crypto_auth = (A, I, g, C, B)=>(Q._crypto_auth = q.fa)(A, I, g, C, B), Q._crypto_auth_verify = (A, I, g, C, B)=>(Q._crypto_auth_verify = q.ga)(A, I, g, C, B), Q._crypto_auth_keygen = (A)=>(Q._crypto_auth_keygen = q.ha)(A), Q._crypto_auth_hmacsha256_bytes = ()=>(Q._crypto_auth_hmacsha256_bytes = q.ia)(), Q._crypto_auth_hmacsha256_keybytes = ()=>(Q._crypto_auth_hmacsha256_keybytes = q.ja)(), Q._crypto_auth_hmacsha256_statebytes = ()=>(Q._crypto_auth_hmacsha256_statebytes = q.ka)(), Q._crypto_auth_hmacsha256_keygen = (A)=>(Q._crypto_auth_hmacsha256_keygen = q.la)(A), Q._crypto_auth_hmacsha256_init = (A, I, g)=>(Q._crypto_auth_hmacsha256_init = q.ma)(A, I, g), Q._crypto_auth_hmacsha256_update = (A, I, g, C)=>(Q._crypto_auth_hmacsha256_update = q.na)(A, I, g, C), Q._crypto_auth_hmacsha256_final = (A, I)=>(Q._crypto_auth_hmacsha256_final = q.oa)(A, I), Q._crypto_auth_hmacsha256 = (A, I, g, C, B)=>(Q._crypto_auth_hmacsha256 = q.pa)(A, I, g, C, B), Q._crypto_auth_hmacsha256_verify = (A, I, g, C, B)=>(Q._crypto_auth_hmacsha256_verify = q.qa)(A, I, g, C, B), Q._crypto_auth_hmacsha512_bytes = ()=>(Q._crypto_auth_hmacsha512_bytes = q.ra)(), Q._crypto_auth_hmacsha512_keybytes = ()=>(Q._crypto_auth_hmacsha512_keybytes = q.sa)(), Q._crypto_auth_hmacsha512_statebytes = ()=>(Q._crypto_auth_hmacsha512_statebytes = q.ta)(), Q._crypto_auth_hmacsha512_keygen = (A)=>(Q._crypto_auth_hmacsha512_keygen = q.ua)(A), Q._crypto_auth_hmacsha512_init = (A, I, g)=>(Q._crypto_auth_hmacsha512_init = q.va)(A, I, g), Q._crypto_auth_hmacsha512_update = (A, I, g, C)=>(Q._crypto_auth_hmacsha512_update = q.wa)(A, I, g, C), Q._crypto_auth_hmacsha512_final = (A, I)=>(Q._crypto_auth_hmacsha512_final = q.xa)(A, I), Q._crypto_auth_hmacsha512 = (A, I, g, C, B)=>(Q._crypto_auth_hmacsha512 = q.ya)(A, I, g, C, B), Q._crypto_auth_hmacsha512_verify = (A, I, g, C, B)=>(Q._crypto_auth_hmacsha512_verify = q.za)(A, I, g, C, B), Q._crypto_auth_hmacsha512256_bytes = ()=>(Q._crypto_auth_hmacsha512256_bytes = q.Aa)(), Q._crypto_auth_hmacsha512256_keybytes = ()=>(Q._crypto_auth_hmacsha512256_keybytes = q.Ba)(), Q._crypto_auth_hmacsha512256_statebytes = ()=>(Q._crypto_auth_hmacsha512256_statebytes = q.Ca)(), Q._crypto_auth_hmacsha512256_keygen = (A)=>(Q._crypto_auth_hmacsha512256_keygen = q.Da)(A), Q._crypto_auth_hmacsha512256_init = (A, I, g)=>(Q._crypto_auth_hmacsha512256_init = q.Ea)(A, I, g), Q._crypto_auth_hmacsha512256_update = (A, I, g, C)=>(Q._crypto_auth_hmacsha512256_update = q.Fa)(A, I, g, C), Q._crypto_auth_hmacsha512256_final = (A, I)=>(Q._crypto_auth_hmacsha512256_final = q.Ga)(A, I), Q._crypto_auth_hmacsha512256 = (A, I, g, C, B)=>(Q._crypto_auth_hmacsha512256 = q.Ha)(A, I, g, C, B), Q._crypto_auth_hmacsha512256_verify = (A, I, g, C, B)=>(Q._crypto_auth_hmacsha512256_verify = q.Ia)(A, I, g, C, B), Q._crypto_box_seedbytes = ()=>(Q._crypto_box_seedbytes = q.Ja)(), Q._crypto_box_publickeybytes = ()=>(Q._crypto_box_publickeybytes = q.Ka)(), Q._crypto_box_secretkeybytes = ()=>(Q._crypto_box_secretkeybytes = q.La)(), Q._crypto_box_beforenmbytes = ()=>(Q._crypto_box_beforenmbytes = q.Ma)(), Q._crypto_box_noncebytes = ()=>(Q._crypto_box_noncebytes = q.Na)(), Q._crypto_box_zerobytes = ()=>(Q._crypto_box_zerobytes = q.Oa)(), Q._crypto_box_boxzerobytes = ()=>(Q._crypto_box_boxzerobytes = q.Pa)(), Q._crypto_box_macbytes = ()=>(Q._crypto_box_macbytes = q.Qa)(), Q._crypto_box_messagebytes_max = ()=>(Q._crypto_box_messagebytes_max = q.Ra)(), Q._crypto_box_primitive = ()=>(Q._crypto_box_primitive = q.Sa)(), Q._crypto_box_seed_keypair = (A, I, g)=>(Q._crypto_box_seed_keypair = q.Ta)(A, I, g), Q._crypto_box_keypair = (A, I)=>(Q._crypto_box_keypair = q.Ua)(A, I), Q._crypto_box_beforenm = (A, I, g)=>(Q._crypto_box_beforenm = q.Va)(A, I, g), Q._crypto_box_afternm = (A, I, g, C, B, i)=>(Q._crypto_box_afternm = q.Wa)(A, I, g, C, B, i), Q._crypto_box_open_afternm = (A, I, g, C, B, i)=>(Q._crypto_box_open_afternm = q.Xa)(A, I, g, C, B, i), Q._crypto_box = (A, I, g, C, B, i, o)=>(Q._crypto_box = q.Ya)(A, I, g, C, B, i, o), Q._crypto_box_open = (A, I, g, C, B, i, o)=>(Q._crypto_box_open = q.Za)(A, I, g, C, B, i, o), Q._crypto_box_detached_afternm = (A, I, g, C, B, i, o)=>(Q._crypto_box_detached_afternm = q._a)(A, I, g, C, B, i, o), Q._crypto_box_detached = (A, I, g, C, B, i, o, E)=>(Q._crypto_box_detached = q.$a)(A, I, g, C, B, i, o, E), Q._crypto_box_easy_afternm = (A, I, g, C, B, i)=>(Q._crypto_box_easy_afternm = q.ab)(A, I, g, C, B, i), Q._crypto_box_easy = (A, I, g, C, B, i, o)=>(Q._crypto_box_easy = q.bb)(A, I, g, C, B, i, o), Q._crypto_box_open_detached_afternm = (A, I, g, C, B, i, o)=>(Q._crypto_box_open_detached_afternm = q.cb)(A, I, g, C, B, i, o), Q._crypto_box_open_detached = (A, I, g, C, B, i, o, E)=>(Q._crypto_box_open_detached = q.db)(A, I, g, C, B, i, o, E), Q._crypto_box_open_easy_afternm = (A, I, g, C, B, i)=>(Q._crypto_box_open_easy_afternm = q.eb)(A, I, g, C, B, i), Q._crypto_box_open_easy = (A, I, g, C, B, i, o)=>(Q._crypto_box_open_easy = q.fb)(A, I, g, C, B, i, o), Q._crypto_box_seal = (A, I, g, C, B)=>(Q._crypto_box_seal = q.gb)(A, I, g, C, B), Q._crypto_box_seal_open = (A, I, g, C, B, i)=>(Q._crypto_box_seal_open = q.hb)(A, I, g, C, B, i), Q._crypto_box_sealbytes = ()=>(Q._crypto_box_sealbytes = q.ib)(), Q._crypto_box_curve25519xsalsa20poly1305_seed_keypair = (A, I, g)=>(Q._crypto_box_curve25519xsalsa20poly1305_seed_keypair = q.jb)(A, I, g), Q._crypto_box_curve25519xsalsa20poly1305_keypair = (A, I)=>(Q._crypto_box_curve25519xsalsa20poly1305_keypair = q.kb)(A, I), Q._crypto_box_curve25519xsalsa20poly1305_beforenm = (A, I, g)=>(Q._crypto_box_curve25519xsalsa20poly1305_beforenm = q.lb)(A, I, g), Q._crypto_box_curve25519xsalsa20poly1305_afternm = (A, I, g, C, B, i)=>(Q._crypto_box_curve25519xsalsa20poly1305_afternm = q.mb)(A, I, g, C, B, i), Q._crypto_box_curve25519xsalsa20poly1305_open_afternm = (A, I, g, C, B, i)=>(Q._crypto_box_curve25519xsalsa20poly1305_open_afternm = q.nb)(A, I, g, C, B, i), Q._crypto_box_curve25519xsalsa20poly1305 = (A, I, g, C, B, i, o)=>(Q._crypto_box_curve25519xsalsa20poly1305 = q.ob)(A, I, g, C, B, i, o), Q._crypto_box_curve25519xsalsa20poly1305_open = (A, I, g, C, B, i, o)=>(Q._crypto_box_curve25519xsalsa20poly1305_open = q.pb)(A, I, g, C, B, i, o), Q._crypto_box_curve25519xsalsa20poly1305_seedbytes = ()=>(Q._crypto_box_curve25519xsalsa20poly1305_seedbytes = q.qb)(), Q._crypto_box_curve25519xsalsa20poly1305_publickeybytes = ()=>(Q._crypto_box_curve25519xsalsa20poly1305_publickeybytes = q.rb)(), Q._crypto_box_curve25519xsalsa20poly1305_secretkeybytes = ()=>(Q._crypto_box_curve25519xsalsa20poly1305_secretkeybytes = q.sb)(), Q._crypto_box_curve25519xsalsa20poly1305_beforenmbytes = ()=>(Q._crypto_box_curve25519xsalsa20poly1305_beforenmbytes = q.tb)(), Q._crypto_box_curve25519xsalsa20poly1305_noncebytes = ()=>(Q._crypto_box_curve25519xsalsa20poly1305_noncebytes = q.ub)(), Q._crypto_box_curve25519xsalsa20poly1305_zerobytes = ()=>(Q._crypto_box_curve25519xsalsa20poly1305_zerobytes = q.vb)(), Q._crypto_box_curve25519xsalsa20poly1305_boxzerobytes = ()=>(Q._crypto_box_curve25519xsalsa20poly1305_boxzerobytes = q.wb)(), Q._crypto_box_curve25519xsalsa20poly1305_macbytes = ()=>(Q._crypto_box_curve25519xsalsa20poly1305_macbytes = q.xb)(), Q._crypto_box_curve25519xsalsa20poly1305_messagebytes_max = ()=>(Q._crypto_box_curve25519xsalsa20poly1305_messagebytes_max = q.yb)(), Q._crypto_core_hchacha20 = (A, I, g, C)=>(Q._crypto_core_hchacha20 = q.zb)(A, I, g, C), Q._crypto_core_hchacha20_outputbytes = ()=>(Q._crypto_core_hchacha20_outputbytes = q.Ab)(), Q._crypto_core_hchacha20_inputbytes = ()=>(Q._crypto_core_hchacha20_inputbytes = q.Bb)(), Q._crypto_core_hchacha20_keybytes = ()=>(Q._crypto_core_hchacha20_keybytes = q.Cb)(), Q._crypto_core_hchacha20_constbytes = ()=>(Q._crypto_core_hchacha20_constbytes = q.Db)(), Q._crypto_core_hsalsa20 = (A, I, g, C)=>(Q._crypto_core_hsalsa20 = q.Eb)(A, I, g, C), Q._crypto_core_hsalsa20_outputbytes = ()=>(Q._crypto_core_hsalsa20_outputbytes = q.Fb)(), Q._crypto_core_hsalsa20_inputbytes = ()=>(Q._crypto_core_hsalsa20_inputbytes = q.Gb)(), Q._crypto_core_hsalsa20_keybytes = ()=>(Q._crypto_core_hsalsa20_keybytes = q.Hb)(), Q._crypto_core_hsalsa20_constbytes = ()=>(Q._crypto_core_hsalsa20_constbytes = q.Ib)(), Q._crypto_core_salsa20 = (A, I, g, C)=>(Q._crypto_core_salsa20 = q.Jb)(A, I, g, C), Q._crypto_core_salsa20_outputbytes = ()=>(Q._crypto_core_salsa20_outputbytes = q.Kb)(), Q._crypto_core_salsa20_inputbytes = ()=>(Q._crypto_core_salsa20_inputbytes = q.Lb)(), Q._crypto_core_salsa20_keybytes = ()=>(Q._crypto_core_salsa20_keybytes = q.Mb)(), Q._crypto_core_salsa20_constbytes = ()=>(Q._crypto_core_salsa20_constbytes = q.Nb)(), Q._crypto_core_salsa2012 = (A, I, g, C)=>(Q._crypto_core_salsa2012 = q.Ob)(A, I, g, C), Q._crypto_core_salsa2012_outputbytes = ()=>(Q._crypto_core_salsa2012_outputbytes = q.Pb)(), Q._crypto_core_salsa2012_inputbytes = ()=>(Q._crypto_core_salsa2012_inputbytes = q.Qb)(), Q._crypto_core_salsa2012_keybytes = ()=>(Q._crypto_core_salsa2012_keybytes = q.Rb)(), Q._crypto_core_salsa2012_constbytes = ()=>(Q._crypto_core_salsa2012_constbytes = q.Sb)(), Q._crypto_core_salsa208 = (A, I, g, C)=>(Q._crypto_core_salsa208 = q.Tb)(A, I, g, C), Q._crypto_core_salsa208_outputbytes = ()=>(Q._crypto_core_salsa208_outputbytes = q.Ub)(), Q._crypto_core_salsa208_inputbytes = ()=>(Q._crypto_core_salsa208_inputbytes = q.Vb)(), Q._crypto_core_salsa208_keybytes = ()=>(Q._crypto_core_salsa208_keybytes = q.Wb)(), Q._crypto_core_salsa208_constbytes = ()=>(Q._crypto_core_salsa208_constbytes = q.Xb)(), Q._crypto_generichash_bytes_min = ()=>(Q._crypto_generichash_bytes_min = q.Yb)(), Q._crypto_generichash_bytes_max = ()=>(Q._crypto_generichash_bytes_max = q.Zb)(), Q._crypto_generichash_bytes = ()=>(Q._crypto_generichash_bytes = q._b)(), Q._crypto_generichash_keybytes_min = ()=>(Q._crypto_generichash_keybytes_min = q.$b)(), Q._crypto_generichash_keybytes_max = ()=>(Q._crypto_generichash_keybytes_max = q.ac)(), Q._crypto_generichash_keybytes = ()=>(Q._crypto_generichash_keybytes = q.bc)(), Q._crypto_generichash_primitive = ()=>(Q._crypto_generichash_primitive = q.cc)(), Q._crypto_generichash_statebytes = ()=>(Q._crypto_generichash_statebytes = q.dc)(), Q._crypto_generichash = (A, I, g, C, B, i, o)=>(Q._crypto_generichash = q.ec)(A, I, g, C, B, i, o), Q._crypto_generichash_init = (A, I, g, C)=>(Q._crypto_generichash_init = q.fc)(A, I, g, C), Q._crypto_generichash_update = (A, I, g, C)=>(Q._crypto_generichash_update = q.gc)(A, I, g, C), Q._crypto_generichash_final = (A, I, g)=>(Q._crypto_generichash_final = q.hc)(A, I, g), Q._crypto_generichash_keygen = (A)=>(Q._crypto_generichash_keygen = q.ic)(A), Q._crypto_generichash_blake2b_bytes_min = ()=>(Q._crypto_generichash_blake2b_bytes_min = q.jc)(), Q._crypto_generichash_blake2b_bytes_max = ()=>(Q._crypto_generichash_blake2b_bytes_max = q.kc)(), Q._crypto_generichash_blake2b_bytes = ()=>(Q._crypto_generichash_blake2b_bytes = q.lc)(), Q._crypto_generichash_blake2b_keybytes_min = ()=>(Q._crypto_generichash_blake2b_keybytes_min = q.mc)(), Q._crypto_generichash_blake2b_keybytes_max = ()=>(Q._crypto_generichash_blake2b_keybytes_max = q.nc)(), Q._crypto_generichash_blake2b_keybytes = ()=>(Q._crypto_generichash_blake2b_keybytes = q.oc)(), Q._crypto_generichash_blake2b_saltbytes = ()=>(Q._crypto_generichash_blake2b_saltbytes = q.pc)(), Q._crypto_generichash_blake2b_personalbytes = ()=>(Q._crypto_generichash_blake2b_personalbytes = q.qc)(), Q._crypto_generichash_blake2b_statebytes = ()=>(Q._crypto_generichash_blake2b_statebytes = q.rc)(), Q._crypto_generichash_blake2b_keygen = (A)=>(Q._crypto_generichash_blake2b_keygen = q.sc)(A), Q._crypto_generichash_blake2b = (A, I, g, C, B, i, o)=>(Q._crypto_generichash_blake2b = q.tc)(A, I, g, C, B, i, o), Q._crypto_generichash_blake2b_salt_personal = (A, I, g, C, B, i, o, E, a)=>(Q._crypto_generichash_blake2b_salt_personal = q.uc)(A, I, g, C, B, i, o, E, a), Q._crypto_generichash_blake2b_init = (A, I, g, C)=>(Q._crypto_generichash_blake2b_init = q.vc)(A, I, g, C), Q._crypto_generichash_blake2b_init_salt_personal = (A, I, g, C, B, i)=>(Q._crypto_generichash_blake2b_init_salt_personal = q.wc)(A, I, g, C, B, i), Q._crypto_generichash_blake2b_update = (A, I, g, C)=>(Q._crypto_generichash_blake2b_update = q.xc)(A, I, g, C), Q._crypto_generichash_blake2b_final = (A, I, g)=>(Q._crypto_generichash_blake2b_final = q.yc)(A, I, g), Q._crypto_hash_bytes = ()=>(Q._crypto_hash_bytes = q.zc)(), Q._crypto_hash = (A, I, g, C)=>(Q._crypto_hash = q.Ac)(A, I, g, C), Q._crypto_hash_primitive = ()=>(Q._crypto_hash_primitive = q.Bc)(), Q._crypto_hash_sha256_bytes = ()=>(Q._crypto_hash_sha256_bytes = q.Cc)(), Q._crypto_hash_sha256_statebytes = ()=>(Q._crypto_hash_sha256_statebytes = q.Dc)(), Q._crypto_hash_sha256_init = (A)=>(Q._crypto_hash_sha256_init = q.Ec)(A), Q._crypto_hash_sha256_update = (A, I, g, C)=>(Q._crypto_hash_sha256_update = q.Fc)(A, I, g, C), Q._crypto_hash_sha256_final = (A, I)=>(Q._crypto_hash_sha256_final = q.Gc)(A, I), Q._crypto_hash_sha256 = (A, I, g, C)=>(Q._crypto_hash_sha256 = q.Hc)(A, I, g, C), Q._crypto_hash_sha512_bytes = ()=>(Q._crypto_hash_sha512_bytes = q.Ic)(), Q._crypto_hash_sha512_statebytes = ()=>(Q._crypto_hash_sha512_statebytes = q.Jc)(), Q._crypto_hash_sha512_init = (A)=>(Q._crypto_hash_sha512_init = q.Kc)(A), Q._crypto_hash_sha512_update = (A, I, g, C)=>(Q._crypto_hash_sha512_update = q.Lc)(A, I, g, C), Q._crypto_hash_sha512_final = (A, I)=>(Q._crypto_hash_sha512_final = q.Mc)(A, I), Q._crypto_hash_sha512 = (A, I, g, C)=>(Q._crypto_hash_sha512 = q.Nc)(A, I, g, C), Q._crypto_kdf_blake2b_bytes_min = ()=>(Q._crypto_kdf_blake2b_bytes_min = q.Oc)(), Q._crypto_kdf_blake2b_bytes_max = ()=>(Q._crypto_kdf_blake2b_bytes_max = q.Pc)(), Q._crypto_kdf_blake2b_contextbytes = ()=>(Q._crypto_kdf_blake2b_contextbytes = q.Qc)(), Q._crypto_kdf_blake2b_keybytes = ()=>(Q._crypto_kdf_blake2b_keybytes = q.Rc)(), Q._crypto_kdf_blake2b_derive_from_key = (A, I, g, C, B, i)=>(Q._crypto_kdf_blake2b_derive_from_key = q.Sc)(A, I, g, C, B, i), Q._crypto_kdf_primitive = ()=>(Q._crypto_kdf_primitive = q.Tc)(), Q._crypto_kdf_bytes_min = ()=>(Q._crypto_kdf_bytes_min = q.Uc)(), Q._crypto_kdf_bytes_max = ()=>(Q._crypto_kdf_bytes_max = q.Vc)(), Q._crypto_kdf_contextbytes = ()=>(Q._crypto_kdf_contextbytes = q.Wc)(), Q._crypto_kdf_keybytes = ()=>(Q._crypto_kdf_keybytes = q.Xc)(), Q._crypto_kdf_derive_from_key = (A, I, g, C, B, i)=>(Q._crypto_kdf_derive_from_key = q.Yc)(A, I, g, C, B, i), Q._crypto_kdf_keygen = (A)=>(Q._crypto_kdf_keygen = q.Zc)(A), Q._crypto_kdf_hkdf_sha256_extract_init = (A, I, g)=>(Q._crypto_kdf_hkdf_sha256_extract_init = q._c)(A, I, g), Q._crypto_kdf_hkdf_sha256_extract_update = (A, I, g)=>(Q._crypto_kdf_hkdf_sha256_extract_update = q.$c)(A, I, g), Q._crypto_kdf_hkdf_sha256_extract_final = (A, I)=>(Q._crypto_kdf_hkdf_sha256_extract_final = q.ad)(A, I), Q._crypto_kdf_hkdf_sha256_extract = (A, I, g, C, B)=>(Q._crypto_kdf_hkdf_sha256_extract = q.bd)(A, I, g, C, B), Q._crypto_kdf_hkdf_sha256_keygen = (A)=>(Q._crypto_kdf_hkdf_sha256_keygen = q.cd)(A), Q._crypto_kdf_hkdf_sha256_expand = (A, I, g, C, B)=>(Q._crypto_kdf_hkdf_sha256_expand = q.dd)(A, I, g, C, B), Q._crypto_kdf_hkdf_sha256_keybytes = ()=>(Q._crypto_kdf_hkdf_sha256_keybytes = q.ed)(), Q._crypto_kdf_hkdf_sha256_bytes_min = ()=>(Q._crypto_kdf_hkdf_sha256_bytes_min = q.fd)(), Q._crypto_kdf_hkdf_sha256_bytes_max = ()=>(Q._crypto_kdf_hkdf_sha256_bytes_max = q.gd)(), Q._crypto_kdf_hkdf_sha256_statebytes = ()=>(Q._crypto_kdf_hkdf_sha256_statebytes = q.hd)(), Q._crypto_kdf_hkdf_sha512_extract_init = (A, I, g)=>(Q._crypto_kdf_hkdf_sha512_extract_init = q.id)(A, I, g), Q._crypto_kdf_hkdf_sha512_extract_update = (A, I, g)=>(Q._crypto_kdf_hkdf_sha512_extract_update = q.jd)(A, I, g), Q._crypto_kdf_hkdf_sha512_extract_final = (A, I)=>(Q._crypto_kdf_hkdf_sha512_extract_final = q.kd)(A, I), Q._crypto_kdf_hkdf_sha512_extract = (A, I, g, C, B)=>(Q._crypto_kdf_hkdf_sha512_extract = q.ld)(A, I, g, C, B), Q._crypto_kdf_hkdf_sha512_keygen = (A)=>(Q._crypto_kdf_hkdf_sha512_keygen = q.md)(A), Q._crypto_kdf_hkdf_sha512_expand = (A, I, g, C, B)=>(Q._crypto_kdf_hkdf_sha512_expand = q.nd)(A, I, g, C, B), Q._crypto_kdf_hkdf_sha512_keybytes = ()=>(Q._crypto_kdf_hkdf_sha512_keybytes = q.od)(), Q._crypto_kdf_hkdf_sha512_bytes_min = ()=>(Q._crypto_kdf_hkdf_sha512_bytes_min = q.pd)(), Q._crypto_kdf_hkdf_sha512_bytes_max = ()=>(Q._crypto_kdf_hkdf_sha512_bytes_max = q.qd)(), Q._crypto_kx_seed_keypair = (A, I, g)=>(Q._crypto_kx_seed_keypair = q.rd)(A, I, g), Q._crypto_kx_keypair = (A, I)=>(Q._crypto_kx_keypair = q.sd)(A, I), Q._crypto_kx_client_session_keys = (A, I, g, C, B)=>(Q._crypto_kx_client_session_keys = q.td)(A, I, g, C, B), Q._crypto_kx_server_session_keys = (A, I, g, C, B)=>(Q._crypto_kx_server_session_keys = q.ud)(A, I, g, C, B), Q._crypto_kx_publickeybytes = ()=>(Q._crypto_kx_publickeybytes = q.vd)(), Q._crypto_kx_secretkeybytes = ()=>(Q._crypto_kx_secretkeybytes = q.wd)(), Q._crypto_kx_seedbytes = ()=>(Q._crypto_kx_seedbytes = q.xd)(), Q._crypto_kx_sessionkeybytes = ()=>(Q._crypto_kx_sessionkeybytes = q.yd)(), Q._crypto_kx_primitive = ()=>(Q._crypto_kx_primitive = q.zd)(), Q._crypto_onetimeauth_statebytes = ()=>(Q._crypto_onetimeauth_statebytes = q.Ad)(), Q._crypto_onetimeauth_bytes = ()=>(Q._crypto_onetimeauth_bytes = q.Bd)(), Q._crypto_onetimeauth_keybytes = ()=>(Q._crypto_onetimeauth_keybytes = q.Cd)(), Q._crypto_onetimeauth = (A, I, g, C, B)=>(Q._crypto_onetimeauth = q.Dd)(A, I, g, C, B), Q._crypto_onetimeauth_verify = (A, I, g, C, B)=>(Q._crypto_onetimeauth_verify = q.Ed)(A, I, g, C, B), Q._crypto_onetimeauth_init = (A, I)=>(Q._crypto_onetimeauth_init = q.Fd)(A, I), Q._crypto_onetimeauth_update = (A, I, g, C)=>(Q._crypto_onetimeauth_update = q.Gd)(A, I, g, C), Q._crypto_onetimeauth_final = (A, I)=>(Q._crypto_onetimeauth_final = q.Hd)(A, I), Q._crypto_onetimeauth_primitive = ()=>(Q._crypto_onetimeauth_primitive = q.Id)(), Q._crypto_onetimeauth_keygen = (A)=>(Q._crypto_onetimeauth_keygen = q.Jd)(A), Q._crypto_onetimeauth_poly1305 = (A, I, g, C, B)=>(Q._crypto_onetimeauth_poly1305 = q.Kd)(A, I, g, C, B), Q._crypto_onetimeauth_poly1305_verify = (A, I, g, C, B)=>(Q._crypto_onetimeauth_poly1305_verify = q.Ld)(A, I, g, C, B), Q._crypto_onetimeauth_poly1305_init = (A, I)=>(Q._crypto_onetimeauth_poly1305_init = q.Md)(A, I), Q._crypto_onetimeauth_poly1305_update = (A, I, g, C)=>(Q._crypto_onetimeauth_poly1305_update = q.Nd)(A, I, g, C), Q._crypto_onetimeauth_poly1305_final = (A, I)=>(Q._crypto_onetimeauth_poly1305_final = q.Od)(A, I), Q._crypto_onetimeauth_poly1305_bytes = ()=>(Q._crypto_onetimeauth_poly1305_bytes = q.Pd)(), Q._crypto_onetimeauth_poly1305_keybytes = ()=>(Q._crypto_onetimeauth_poly1305_keybytes = q.Qd)(), Q._crypto_onetimeauth_poly1305_statebytes = ()=>(Q._crypto_onetimeauth_poly1305_statebytes = q.Rd)(), Q._crypto_onetimeauth_poly1305_keygen = (A)=>(Q._crypto_onetimeauth_poly1305_keygen = q.Sd)(A), Q._crypto_pwhash_argon2i_alg_argon2i13 = ()=>(Q._crypto_pwhash_argon2i_alg_argon2i13 = q.Td)(), Q._crypto_pwhash_argon2i_bytes_min = ()=>(Q._crypto_pwhash_argon2i_bytes_min = q.Ud)(), Q._crypto_pwhash_argon2i_bytes_max = ()=>(Q._crypto_pwhash_argon2i_bytes_max = q.Vd)(), Q._crypto_pwhash_argon2i_passwd_min = ()=>(Q._crypto_pwhash_argon2i_passwd_min = q.Wd)(), Q._crypto_pwhash_argon2i_passwd_max = ()=>(Q._crypto_pwhash_argon2i_passwd_max = q.Xd)(), Q._crypto_pwhash_argon2i_saltbytes = ()=>(Q._crypto_pwhash_argon2i_saltbytes = q.Yd)(), Q._crypto_pwhash_argon2i_strbytes = ()=>(Q._crypto_pwhash_argon2i_strbytes = q.Zd)(), Q._crypto_pwhash_argon2i_strprefix = ()=>(Q._crypto_pwhash_argon2i_strprefix = q._d)(), Q._crypto_pwhash_argon2i_opslimit_min = ()=>(Q._crypto_pwhash_argon2i_opslimit_min = q.$d)(), Q._crypto_pwhash_argon2i_opslimit_max = ()=>(Q._crypto_pwhash_argon2i_opslimit_max = q.ae)(), Q._crypto_pwhash_argon2i_memlimit_min = ()=>(Q._crypto_pwhash_argon2i_memlimit_min = q.be)(), Q._crypto_pwhash_argon2i_memlimit_max = ()=>(Q._crypto_pwhash_argon2i_memlimit_max = q.ce)(), Q._crypto_pwhash_argon2i_opslimit_interactive = ()=>(Q._crypto_pwhash_argon2i_opslimit_interactive = q.de)(), Q._crypto_pwhash_argon2i_memlimit_interactive = ()=>(Q._crypto_pwhash_argon2i_memlimit_interactive = q.ee)(), Q._crypto_pwhash_argon2i_opslimit_moderate = ()=>(Q._crypto_pwhash_argon2i_opslimit_moderate = q.fe)(), Q._crypto_pwhash_argon2i_memlimit_moderate = ()=>(Q._crypto_pwhash_argon2i_memlimit_moderate = q.ge)(), Q._crypto_pwhash_argon2i_opslimit_sensitive = ()=>(Q._crypto_pwhash_argon2i_opslimit_sensitive = q.he)(), Q._crypto_pwhash_argon2i_memlimit_sensitive = ()=>(Q._crypto_pwhash_argon2i_memlimit_sensitive = q.ie)(), Q._crypto_pwhash_argon2i = (A, I, g, C, B, i, o, E, a, _, c)=>(Q._crypto_pwhash_argon2i = q.je)(A, I, g, C, B, i, o, E, a, _, c), Q._crypto_pwhash_argon2i_str = (A, I, g, C, B, i, o)=>(Q._crypto_pwhash_argon2i_str = q.ke)(A, I, g, C, B, i, o), Q._crypto_pwhash_argon2i_str_verify = (A, I, g, C)=>(Q._crypto_pwhash_argon2i_str_verify = q.le)(A, I, g, C), Q._crypto_pwhash_argon2i_str_needs_rehash = (A, I, g, C)=>(Q._crypto_pwhash_argon2i_str_needs_rehash = q.me)(A, I, g, C), Q._crypto_pwhash_argon2id_str_needs_rehash = (A, I, g, C)=>(Q._crypto_pwhash_argon2id_str_needs_rehash = q.ne)(A, I, g, C), Q._crypto_pwhash_argon2id_alg_argon2id13 = ()=>(Q._crypto_pwhash_argon2id_alg_argon2id13 = q.oe)(), Q._crypto_pwhash_argon2id_bytes_min = ()=>(Q._crypto_pwhash_argon2id_bytes_min = q.pe)(), Q._crypto_pwhash_argon2id_bytes_max = ()=>(Q._crypto_pwhash_argon2id_bytes_max = q.qe)(), Q._crypto_pwhash_argon2id_passwd_min = ()=>(Q._crypto_pwhash_argon2id_passwd_min = q.re)(), Q._crypto_pwhash_argon2id_passwd_max = ()=>(Q._crypto_pwhash_argon2id_passwd_max = q.se)(), Q._crypto_pwhash_argon2id_saltbytes = ()=>(Q._crypto_pwhash_argon2id_saltbytes = q.te)(), Q._crypto_pwhash_argon2id_strbytes = ()=>(Q._crypto_pwhash_argon2id_strbytes = q.ue)(), Q._crypto_pwhash_argon2id_strprefix = ()=>(Q._crypto_pwhash_argon2id_strprefix = q.ve)(), Q._crypto_pwhash_argon2id_opslimit_min = ()=>(Q._crypto_pwhash_argon2id_opslimit_min = q.we)(), Q._crypto_pwhash_argon2id_opslimit_max = ()=>(Q._crypto_pwhash_argon2id_opslimit_max = q.xe)(), Q._crypto_pwhash_argon2id_memlimit_min = ()=>(Q._crypto_pwhash_argon2id_memlimit_min = q.ye)(), Q._crypto_pwhash_argon2id_memlimit_max = ()=>(Q._crypto_pwhash_argon2id_memlimit_max = q.ze)(), Q._crypto_pwhash_argon2id_opslimit_interactive = ()=>(Q._crypto_pwhash_argon2id_opslimit_interactive = q.Ae)(), Q._crypto_pwhash_argon2id_memlimit_interactive = ()=>(Q._crypto_pwhash_argon2id_memlimit_interactive = q.Be)(), Q._crypto_pwhash_argon2id_opslimit_moderate = ()=>(Q._crypto_pwhash_argon2id_opslimit_moderate = q.Ce)(), Q._crypto_pwhash_argon2id_memlimit_moderate = ()=>(Q._crypto_pwhash_argon2id_memlimit_moderate = q.De)(), Q._crypto_pwhash_argon2id_opslimit_sensitive = ()=>(Q._crypto_pwhash_argon2id_opslimit_sensitive = q.Ee)(), Q._crypto_pwhash_argon2id_memlimit_sensitive = ()=>(Q._crypto_pwhash_argon2id_memlimit_sensitive = q.Fe)(), Q._crypto_pwhash_argon2id = (A, I, g, C, B, i, o, E, a, _, c)=>(Q._crypto_pwhash_argon2id = q.Ge)(A, I, g, C, B, i, o, E, a, _, c), Q._crypto_pwhash_argon2id_str = (A, I, g, C, B, i, o)=>(Q._crypto_pwhash_argon2id_str = q.He)(A, I, g, C, B, i, o), Q._crypto_pwhash_argon2id_str_verify = (A, I, g, C)=>(Q._crypto_pwhash_argon2id_str_verify = q.Ie)(A, I, g, C), Q._crypto_pwhash_alg_argon2i13 = ()=>(Q._crypto_pwhash_alg_argon2i13 = q.Je)(), Q._crypto_pwhash_alg_argon2id13 = ()=>(Q._crypto_pwhash_alg_argon2id13 = q.Ke)(), Q._crypto_pwhash_alg_default = ()=>(Q._crypto_pwhash_alg_default = q.Le)(), Q._crypto_pwhash_bytes_min = ()=>(Q._crypto_pwhash_bytes_min = q.Me)(), Q._crypto_pwhash_bytes_max = ()=>(Q._crypto_pwhash_bytes_max = q.Ne)(), Q._crypto_pwhash_passwd_min = ()=>(Q._crypto_pwhash_passwd_min = q.Oe)(), Q._crypto_pwhash_passwd_max = ()=>(Q._crypto_pwhash_passwd_max = q.Pe)(), Q._crypto_pwhash_saltbytes = ()=>(Q._crypto_pwhash_saltbytes = q.Qe)(), Q._crypto_pwhash_strbytes = ()=>(Q._crypto_pwhash_strbytes = q.Re)(), Q._crypto_pwhash_strprefix = ()=>(Q._crypto_pwhash_strprefix = q.Se)(), Q._crypto_pwhash_opslimit_min = ()=>(Q._crypto_pwhash_opslimit_min = q.Te)(), Q._crypto_pwhash_opslimit_max = ()=>(Q._crypto_pwhash_opslimit_max = q.Ue)(), Q._crypto_pwhash_memlimit_min = ()=>(Q._crypto_pwhash_memlimit_min = q.Ve)(), Q._crypto_pwhash_memlimit_max = ()=>(Q._crypto_pwhash_memlimit_max = q.We)(), Q._crypto_pwhash_opslimit_interactive = ()=>(Q._crypto_pwhash_opslimit_interactive = q.Xe)(), Q._crypto_pwhash_memlimit_interactive = ()=>(Q._crypto_pwhash_memlimit_interactive = q.Ye)(), Q._crypto_pwhash_opslimit_moderate = ()=>(Q._crypto_pwhash_opslimit_moderate = q.Ze)(), Q._crypto_pwhash_memlimit_moderate = ()=>(Q._crypto_pwhash_memlimit_moderate = q._e)(), Q._crypto_pwhash_opslimit_sensitive = ()=>(Q._crypto_pwhash_opslimit_sensitive = q.$e)(), Q._crypto_pwhash_memlimit_sensitive = ()=>(Q._crypto_pwhash_memlimit_sensitive = q.af)(), Q._crypto_pwhash = (A, I, g, C, B, i, o, E, a, _, c)=>(Q._crypto_pwhash = q.bf)(A, I, g, C, B, i, o, E, a, _, c), Q._crypto_pwhash_str = (A, I, g, C, B, i, o)=>(Q._crypto_pwhash_str = q.cf)(A, I, g, C, B, i, o), Q._crypto_pwhash_str_alg = (A, I, g, C, B, i, o, E)=>(Q._crypto_pwhash_str_alg = q.df)(A, I, g, C, B, i, o, E), Q._crypto_pwhash_str_verify = (A, I, g, C)=>(Q._crypto_pwhash_str_verify = q.ef)(A, I, g, C), Q._crypto_pwhash_str_needs_rehash = (A, I, g, C)=>(Q._crypto_pwhash_str_needs_rehash = q.ff)(A, I, g, C), Q._crypto_pwhash_primitive = ()=>(Q._crypto_pwhash_primitive = q.gf)(), Q._crypto_scalarmult_primitive = ()=>(Q._crypto_scalarmult_primitive = q.hf)(), Q._crypto_scalarmult_base = (A, I)=>(Q._crypto_scalarmult_base = q.jf)(A, I), Q._crypto_scalarmult = (A, I, g)=>(Q._crypto_scalarmult = q.kf)(A, I, g), Q._crypto_scalarmult_bytes = ()=>(Q._crypto_scalarmult_bytes = q.lf)(), Q._crypto_scalarmult_scalarbytes = ()=>(Q._crypto_scalarmult_scalarbytes = q.mf)(), Q._crypto_scalarmult_curve25519 = (A, I, g)=>(Q._crypto_scalarmult_curve25519 = q.nf)(A, I, g), Q._crypto_scalarmult_curve25519_base = (A, I)=>(Q._crypto_scalarmult_curve25519_base = q.of)(A, I), Q._crypto_scalarmult_curve25519_bytes = ()=>(Q._crypto_scalarmult_curve25519_bytes = q.pf)(), Q._crypto_scalarmult_curve25519_scalarbytes = ()=>(Q._crypto_scalarmult_curve25519_scalarbytes = q.qf)(), Q._crypto_secretbox_keybytes = ()=>(Q._crypto_secretbox_keybytes = q.rf)(), Q._crypto_secretbox_noncebytes = ()=>(Q._crypto_secretbox_noncebytes = q.sf)(), Q._crypto_secretbox_zerobytes = ()=>(Q._crypto_secretbox_zerobytes = q.tf)(), Q._crypto_secretbox_boxzerobytes = ()=>(Q._crypto_secretbox_boxzerobytes = q.uf)(), Q._crypto_secretbox_macbytes = ()=>(Q._crypto_secretbox_macbytes = q.vf)(), Q._crypto_secretbox_messagebytes_max = ()=>(Q._crypto_secretbox_messagebytes_max = q.wf)(), Q._crypto_secretbox_primitive = ()=>(Q._crypto_secretbox_primitive = q.xf)(), Q._crypto_secretbox = (A, I, g, C, B, i)=>(Q._crypto_secretbox = q.yf)(A, I, g, C, B, i), Q._crypto_secretbox_open = (A, I, g, C, B, i)=>(Q._crypto_secretbox_open = q.zf)(A, I, g, C, B, i), Q._crypto_secretbox_keygen = (A)=>(Q._crypto_secretbox_keygen = q.Af)(A), Q._crypto_secretbox_detached = (A, I, g, C, B, i, o)=>(Q._crypto_secretbox_detached = q.Bf)(A, I, g, C, B, i, o), Q._crypto_secretbox_easy = (A, I, g, C, B, i)=>(Q._crypto_secretbox_easy = q.Cf)(A, I, g, C, B, i), Q._crypto_secretbox_open_detached = (A, I, g, C, B, i, o)=>(Q._crypto_secretbox_open_detached = q.Df)(A, I, g, C, B, i, o), Q._crypto_secretbox_open_easy = (A, I, g, C, B, i)=>(Q._crypto_secretbox_open_easy = q.Ef)(A, I, g, C, B, i), Q._crypto_secretbox_xsalsa20poly1305 = (A, I, g, C, B, i)=>(Q._crypto_secretbox_xsalsa20poly1305 = q.Ff)(A, I, g, C, B, i), Q._crypto_secretbox_xsalsa20poly1305_open = (A, I, g, C, B, i)=>(Q._crypto_secretbox_xsalsa20poly1305_open = q.Gf)(A, I, g, C, B, i), Q._crypto_secretbox_xsalsa20poly1305_keybytes = ()=>(Q._crypto_secretbox_xsalsa20poly1305_keybytes = q.Hf)(), Q._crypto_secretbox_xsalsa20poly1305_noncebytes = ()=>(Q._crypto_secretbox_xsalsa20poly1305_noncebytes = q.If)(), Q._crypto_secretbox_xsalsa20poly1305_zerobytes = ()=>(Q._crypto_secretbox_xsalsa20poly1305_zerobytes = q.Jf)(), Q._crypto_secretbox_xsalsa20poly1305_boxzerobytes = ()=>(Q._crypto_secretbox_xsalsa20poly1305_boxzerobytes = q.Kf)(), Q._crypto_secretbox_xsalsa20poly1305_macbytes = ()=>(Q._crypto_secretbox_xsalsa20poly1305_macbytes = q.Lf)(), Q._crypto_secretbox_xsalsa20poly1305_messagebytes_max = ()=>(Q._crypto_secretbox_xsalsa20poly1305_messagebytes_max = q.Mf)(), Q._crypto_secretbox_xsalsa20poly1305_keygen = (A)=>(Q._crypto_secretbox_xsalsa20poly1305_keygen = q.Nf)(A), Q._crypto_secretstream_xchacha20poly1305_keygen = (A)=>(Q._crypto_secretstream_xchacha20poly1305_keygen = q.Of)(A), Q._crypto_secretstream_xchacha20poly1305_init_push = (A, I, g)=>(Q._crypto_secretstream_xchacha20poly1305_init_push = q.Pf)(A, I, g), Q._crypto_secretstream_xchacha20poly1305_init_pull = (A, I, g)=>(Q._crypto_secretstream_xchacha20poly1305_init_pull = q.Qf)(A, I, g), Q._crypto_secretstream_xchacha20poly1305_rekey = (A)=>(Q._crypto_secretstream_xchacha20poly1305_rekey = q.Rf)(A), Q._crypto_secretstream_xchacha20poly1305_push = (A, I, g, C, B, i, o, E, a, _)=>(Q._crypto_secretstream_xchacha20poly1305_push = q.Sf)(A, I, g, C, B, i, o, E, a, _), Q._crypto_secretstream_xchacha20poly1305_pull = (A, I, g, C, B, i, o, E, a, _)=>(Q._crypto_secretstream_xchacha20poly1305_pull = q.Tf)(A, I, g, C, B, i, o, E, a, _), Q._crypto_secretstream_xchacha20poly1305_statebytes = ()=>(Q._crypto_secretstream_xchacha20poly1305_statebytes = q.Uf)(), Q._crypto_secretstream_xchacha20poly1305_abytes = ()=>(Q._crypto_secretstream_xchacha20poly1305_abytes = q.Vf)(), Q._crypto_secretstream_xchacha20poly1305_headerbytes = ()=>(Q._crypto_secretstream_xchacha20poly1305_headerbytes = q.Wf)(), Q._crypto_secretstream_xchacha20poly1305_keybytes = ()=>(Q._crypto_secretstream_xchacha20poly1305_keybytes = q.Xf)(), Q._crypto_secretstream_xchacha20poly1305_messagebytes_max = ()=>(Q._crypto_secretstream_xchacha20poly1305_messagebytes_max = q.Yf)(), Q._crypto_secretstream_xchacha20poly1305_tag_message = ()=>(Q._crypto_secretstream_xchacha20poly1305_tag_message = q.Zf)(), Q._crypto_secretstream_xchacha20poly1305_tag_push = ()=>(Q._crypto_secretstream_xchacha20poly1305_tag_push = q._f)(), Q._crypto_secretstream_xchacha20poly1305_tag_rekey = ()=>(Q._crypto_secretstream_xchacha20poly1305_tag_rekey = q.$f)(), Q._crypto_secretstream_xchacha20poly1305_tag_final = ()=>(Q._crypto_secretstream_xchacha20poly1305_tag_final = q.ag)(), Q._crypto_shorthash_bytes = ()=>(Q._crypto_shorthash_bytes = q.bg)(), Q._crypto_shorthash_keybytes = ()=>(Q._crypto_shorthash_keybytes = q.cg)(), Q._crypto_shorthash_primitive = ()=>(Q._crypto_shorthash_primitive = q.dg)(), Q._crypto_shorthash = (A, I, g, C, B)=>(Q._crypto_shorthash = q.eg)(A, I, g, C, B), Q._crypto_shorthash_keygen = (A)=>(Q._crypto_shorthash_keygen = q.fg)(A), Q._crypto_shorthash_siphash24_bytes = ()=>(Q._crypto_shorthash_siphash24_bytes = q.gg)(), Q._crypto_shorthash_siphash24_keybytes = ()=>(Q._crypto_shorthash_siphash24_keybytes = q.hg)(), Q._crypto_shorthash_siphash24 = (A, I, g, C, B)=>(Q._crypto_shorthash_siphash24 = q.ig)(A, I, g, C, B), Q._crypto_sign_statebytes = ()=>(Q._crypto_sign_statebytes = q.jg)(), Q._crypto_sign_bytes = ()=>(Q._crypto_sign_bytes = q.kg)(), Q._crypto_sign_seedbytes = ()=>(Q._crypto_sign_seedbytes = q.lg)(), Q._crypto_sign_publickeybytes = ()=>(Q._crypto_sign_publickeybytes = q.mg)(), Q._crypto_sign_secretkeybytes = ()=>(Q._crypto_sign_secretkeybytes = q.ng)(), Q._crypto_sign_messagebytes_max = ()=>(Q._crypto_sign_messagebytes_max = q.og)(), Q._crypto_sign_primitive = ()=>(Q._crypto_sign_primitive = q.pg)(), Q._crypto_sign_seed_keypair = (A, I, g)=>(Q._crypto_sign_seed_keypair = q.qg)(A, I, g), Q._crypto_sign_keypair = (A, I)=>(Q._crypto_sign_keypair = q.rg)(A, I), Q._crypto_sign = (A, I, g, C, B, i)=>(Q._crypto_sign = q.sg)(A, I, g, C, B, i), Q._crypto_sign_open = (A, I, g, C, B, i)=>(Q._crypto_sign_open = q.tg)(A, I, g, C, B, i), Q._crypto_sign_detached = (A, I, g, C, B, i)=>(Q._crypto_sign_detached = q.ug)(A, I, g, C, B, i), Q._crypto_sign_verify_detached = (A, I, g, C, B)=>(Q._crypto_sign_verify_detached = q.vg)(A, I, g, C, B), Q._crypto_sign_init = (A)=>(Q._crypto_sign_init = q.wg)(A), Q._crypto_sign_update = (A, I, g, C)=>(Q._crypto_sign_update = q.xg)(A, I, g, C), Q._crypto_sign_final_create = (A, I, g, C)=>(Q._crypto_sign_final_create = q.yg)(A, I, g, C), Q._crypto_sign_final_verify = (A, I, g)=>(Q._crypto_sign_final_verify = q.zg)(A, I, g), Q._crypto_sign_ed25519ph_statebytes = ()=>(Q._crypto_sign_ed25519ph_statebytes = q.Ag)(), Q._crypto_sign_ed25519_bytes = ()=>(Q._crypto_sign_ed25519_bytes = q.Bg)(), Q._crypto_sign_ed25519_seedbytes = ()=>(Q._crypto_sign_ed25519_seedbytes = q.Cg)(), Q._crypto_sign_ed25519_publickeybytes = ()=>(Q._crypto_sign_ed25519_publickeybytes = q.Dg)(), Q._crypto_sign_ed25519_secretkeybytes = ()=>(Q._crypto_sign_ed25519_secretkeybytes = q.Eg)(), Q._crypto_sign_ed25519_messagebytes_max = ()=>(Q._crypto_sign_ed25519_messagebytes_max = q.Fg)(), Q._crypto_sign_ed25519_sk_to_seed = (A, I)=>(Q._crypto_sign_ed25519_sk_to_seed = q.Gg)(A, I), Q._crypto_sign_ed25519_sk_to_pk = (A, I)=>(Q._crypto_sign_ed25519_sk_to_pk = q.Hg)(A, I), Q._crypto_sign_ed25519ph_init = (A)=>(Q._crypto_sign_ed25519ph_init = q.Ig)(A), Q._crypto_sign_ed25519ph_update = (A, I, g, C)=>(Q._crypto_sign_ed25519ph_update = q.Jg)(A, I, g, C), Q._crypto_sign_ed25519ph_final_create = (A, I, g, C)=>(Q._crypto_sign_ed25519ph_final_create = q.Kg)(A, I, g, C), Q._crypto_sign_ed25519ph_final_verify = (A, I, g)=>(Q._crypto_sign_ed25519ph_final_verify = q.Lg)(A, I, g), Q._crypto_sign_ed25519_seed_keypair = (A, I, g)=>(Q._crypto_sign_ed25519_seed_keypair = q.Mg)(A, I, g), Q._crypto_sign_ed25519_keypair = (A, I)=>(Q._crypto_sign_ed25519_keypair = q.Ng)(A, I), Q._crypto_sign_ed25519_pk_to_curve25519 = (A, I)=>(Q._crypto_sign_ed25519_pk_to_curve25519 = q.Og)(A, I), Q._crypto_sign_ed25519_sk_to_curve25519 = (A, I)=>(Q._crypto_sign_ed25519_sk_to_curve25519 = q.Pg)(A, I), Q._crypto_sign_ed25519_verify_detached = (A, I, g, C, B)=>(Q._crypto_sign_ed25519_verify_detached = q.Qg)(A, I, g, C, B), Q._crypto_sign_ed25519_open = (A, I, g, C, B, i)=>(Q._crypto_sign_ed25519_open = q.Rg)(A, I, g, C, B, i), Q._crypto_sign_ed25519_detached = (A, I, g, C, B, i)=>(Q._crypto_sign_ed25519_detached = q.Sg)(A, I, g, C, B, i), Q._crypto_sign_ed25519 = (A, I, g, C, B, i)=>(Q._crypto_sign_ed25519 = q.Tg)(A, I, g, C, B, i), Q._crypto_stream_chacha20_keybytes = ()=>(Q._crypto_stream_chacha20_keybytes = q.Ug)(), Q._crypto_stream_chacha20_noncebytes = ()=>(Q._crypto_stream_chacha20_noncebytes = q.Vg)(), Q._crypto_stream_chacha20_messagebytes_max = ()=>(Q._crypto_stream_chacha20_messagebytes_max = q.Wg)(), Q._crypto_stream_chacha20_ietf_keybytes = ()=>(Q._crypto_stream_chacha20_ietf_keybytes = q.Xg)(), Q._crypto_stream_chacha20_ietf_noncebytes = ()=>(Q._crypto_stream_chacha20_ietf_noncebytes = q.Yg)(), Q._crypto_stream_chacha20_ietf_messagebytes_max = ()=>(Q._crypto_stream_chacha20_ietf_messagebytes_max = q.Zg)(), Q._crypto_stream_chacha20 = (A, I, g, C, B)=>(Q._crypto_stream_chacha20 = q._g)(A, I, g, C, B), Q._crypto_stream_chacha20_xor_ic = (A, I, g, C, B, i, o, E)=>(Q._crypto_stream_chacha20_xor_ic = q.$g)(A, I, g, C, B, i, o, E), Q._crypto_stream_chacha20_xor = (A, I, g, C, B, i)=>(Q._crypto_stream_chacha20_xor = q.ah)(A, I, g, C, B, i), Q._crypto_stream_chacha20_ietf = (A, I, g, C, B)=>(Q._crypto_stream_chacha20_ietf = q.bh)(A, I, g, C, B), Q._crypto_stream_chacha20_ietf_xor_ic = (A, I, g, C, B, i, o)=>(Q._crypto_stream_chacha20_ietf_xor_ic = q.ch)(A, I, g, C, B, i, o), Q._crypto_stream_chacha20_ietf_xor = (A, I, g, C, B, i)=>(Q._crypto_stream_chacha20_ietf_xor = q.dh)(A, I, g, C, B, i), Q._crypto_stream_chacha20_ietf_keygen = (A)=>(Q._crypto_stream_chacha20_ietf_keygen = q.eh)(A), Q._crypto_stream_chacha20_keygen = (A)=>(Q._crypto_stream_chacha20_keygen = q.fh)(A), Q._crypto_stream_keybytes = ()=>(Q._crypto_stream_keybytes = q.gh)(), Q._crypto_stream_noncebytes = ()=>(Q._crypto_stream_noncebytes = q.hh)(), Q._crypto_stream_messagebytes_max = ()=>(Q._crypto_stream_messagebytes_max = q.ih)(), Q._crypto_stream_primitive = ()=>(Q._crypto_stream_primitive = q.jh)(), Q._crypto_stream = (A, I, g, C, B)=>(Q._crypto_stream = q.kh)(A, I, g, C, B), Q._crypto_stream_xor = (A, I, g, C, B, i)=>(Q._crypto_stream_xor = q.lh)(A, I, g, C, B, i), Q._crypto_stream_keygen = (A)=>(Q._crypto_stream_keygen = q.mh)(A), Q._crypto_stream_salsa20_keybytes = ()=>(Q._crypto_stream_salsa20_keybytes = q.nh)(), Q._crypto_stream_salsa20_noncebytes = ()=>(Q._crypto_stream_salsa20_noncebytes = q.oh)(), Q._crypto_stream_salsa20_messagebytes_max = ()=>(Q._crypto_stream_salsa20_messagebytes_max = q.ph)(), Q._crypto_stream_salsa20 = (A, I, g, C, B)=>(Q._crypto_stream_salsa20 = q.qh)(A, I, g, C, B), Q._crypto_stream_salsa20_xor_ic = (A, I, g, C, B, i, o, E)=>(Q._crypto_stream_salsa20_xor_ic = q.rh)(A, I, g, C, B, i, o, E), Q._crypto_stream_salsa20_xor = (A, I, g, C, B, i)=>(Q._crypto_stream_salsa20_xor = q.sh)(A, I, g, C, B, i), Q._crypto_stream_salsa20_keygen = (A)=>(Q._crypto_stream_salsa20_keygen = q.th)(A), Q._crypto_stream_xsalsa20 = (A, I, g, C, B)=>(Q._crypto_stream_xsalsa20 = q.uh)(A, I, g, C, B), Q._crypto_stream_xsalsa20_xor_ic = (A, I, g, C, B, i, o, E)=>(Q._crypto_stream_xsalsa20_xor_ic = q.vh)(A, I, g, C, B, i, o, E), Q._crypto_stream_xsalsa20_xor = (A, I, g, C, B, i)=>(Q._crypto_stream_xsalsa20_xor = q.wh)(A, I, g, C, B, i), Q._crypto_stream_xsalsa20_keybytes = ()=>(Q._crypto_stream_xsalsa20_keybytes = q.xh)(), Q._crypto_stream_xsalsa20_noncebytes = ()=>(Q._crypto_stream_xsalsa20_noncebytes = q.yh)(), Q._crypto_stream_xsalsa20_messagebytes_max = ()=>(Q._crypto_stream_xsalsa20_messagebytes_max = q.zh)(), Q._crypto_stream_xsalsa20_keygen = (A)=>(Q._crypto_stream_xsalsa20_keygen = q.Ah)(A), Q._crypto_verify_16_bytes = ()=>(Q._crypto_verify_16_bytes = q.Bh)(), Q._crypto_verify_32_bytes = ()=>(Q._crypto_verify_32_bytes = q.Ch)(), Q._crypto_verify_64_bytes = ()=>(Q._crypto_verify_64_bytes = q.Dh)(), Q._crypto_verify_16 = (A, I)=>(Q._crypto_verify_16 = q.Eh)(A, I), Q._crypto_verify_32 = (A, I)=>(Q._crypto_verify_32 = q.Fh)(A, I), Q._crypto_verify_64 = (A, I)=>(Q._crypto_verify_64 = q.Gh)(A, I), Q._randombytes_implementation_name = ()=>(Q._randombytes_implementation_name = q.Hh)(), Q._randombytes_random = ()=>(Q._randombytes_random = q.Ih)(), Q._randombytes_stir = ()=>(Q._randombytes_stir = q.Jh)(), Q._randombytes_uniform = (A)=>(Q._randombytes_uniform = q.Kh)(A), Q._randombytes_buf = (A, I)=>(Q._randombytes_buf = q.Lh)(A, I), Q._randombytes_buf_deterministic = (A, I, g)=>(Q._randombytes_buf_deterministic = q.Mh)(A, I, g), Q._randombytes_seedbytes = ()=>(Q._randombytes_seedbytes = q.Nh)(), Q._randombytes_close = ()=>(Q._randombytes_close = q.Oh)(), Q._randombytes = (A, I, g)=>(Q._randombytes = q.Ph)(A, I, g), Q._sodium_bin2hex = (A, I, g, C)=>(Q._sodium_bin2hex = q.Qh)(A, I, g, C), Q._sodium_hex2bin = (A, I, g, C, B, i, o)=>(Q._sodium_hex2bin = q.Rh)(A, I, g, C, B, i, o), Q._sodium_base64_encoded_len = (A, I)=>(Q._sodium_base64_encoded_len = q.Sh)(A, I), Q._sodium_bin2base64 = (A, I, g, C, B)=>(Q._sodium_bin2base64 = q.Th)(A, I, g, C, B), Q._sodium_base642bin = (A, I, g, C, B, i, o, E)=>(Q._sodium_base642bin = q.Uh)(A, I, g, C, B, i, o, E), Q._sodium_init = ()=>(Q._sodium_init = q.Vh)(), Q._sodium_pad = (A, I, g, C, B)=>(Q._sodium_pad = q.Wh)(A, I, g, C, B), Q._sodium_unpad = (A, I, g, C)=>(Q._sodium_unpad = q.Xh)(A, I, g, C), Q._sodium_version_string = ()=>(Q._sodium_version_string = q.Yh)(), Q._sodium_library_version_major = ()=>(Q._sodium_library_version_major = q.Zh)(), Q._sodium_library_version_minor = ()=>(Q._sodium_library_version_minor = q._h)(), Q._sodium_library_minimal = ()=>(Q._sodium_library_minimal = q.$h)(), Q._crypto_box_curve25519xchacha20poly1305_seed_keypair = (A, I, g)=>(Q._crypto_box_curve25519xchacha20poly1305_seed_keypair = q.ai)(A, I, g), Q._crypto_box_curve25519xchacha20poly1305_keypair = (A, I)=>(Q._crypto_box_curve25519xchacha20poly1305_keypair = q.bi)(A, I), Q._crypto_box_curve25519xchacha20poly1305_beforenm = (A, I, g)=>(Q._crypto_box_curve25519xchacha20poly1305_beforenm = q.ci)(A, I, g), Q._crypto_box_curve25519xchacha20poly1305_detached_afternm = (A, I, g, C, B, i, o)=>(Q._crypto_box_curve25519xchacha20poly1305_detached_afternm = q.di)(A, I, g, C, B, i, o), Q._crypto_box_curve25519xchacha20poly1305_detached = (A, I, g, C, B, i, o, E)=>(Q._crypto_box_curve25519xchacha20poly1305_detached = q.ei)(A, I, g, C, B, i, o, E), Q._crypto_box_curve25519xchacha20poly1305_easy_afternm = (A, I, g, C, B, i)=>(Q._crypto_box_curve25519xchacha20poly1305_easy_afternm = q.fi)(A, I, g, C, B, i), Q._crypto_box_curve25519xchacha20poly1305_easy = (A, I, g, C, B, i, o)=>(Q._crypto_box_curve25519xchacha20poly1305_easy = q.gi)(A, I, g, C, B, i, o), Q._crypto_box_curve25519xchacha20poly1305_open_detached_afternm = (A, I, g, C, B, i, o)=>(Q._crypto_box_curve25519xchacha20poly1305_open_detached_afternm = q.hi)(A, I, g, C, B, i, o), Q._crypto_box_curve25519xchacha20poly1305_open_detached = (A, I, g, C, B, i, o, E)=>(Q._crypto_box_curve25519xchacha20poly1305_open_detached = q.ii)(A, I, g, C, B, i, o, E), Q._crypto_box_curve25519xchacha20poly1305_open_easy_afternm = (A, I, g, C, B, i)=>(Q._crypto_box_curve25519xchacha20poly1305_open_easy_afternm = q.ji)(A, I, g, C, B, i), Q._crypto_box_curve25519xchacha20poly1305_open_easy = (A, I, g, C, B, i, o)=>(Q._crypto_box_curve25519xchacha20poly1305_open_easy = q.ki)(A, I, g, C, B, i, o), Q._crypto_box_curve25519xchacha20poly1305_seedbytes = ()=>(Q._crypto_box_curve25519xchacha20poly1305_seedbytes = q.li)(), Q._crypto_box_curve25519xchacha20poly1305_publickeybytes = ()=>(Q._crypto_box_curve25519xchacha20poly1305_publickeybytes = q.mi)(), Q._crypto_box_curve25519xchacha20poly1305_secretkeybytes = ()=>(Q._crypto_box_curve25519xchacha20poly1305_secretkeybytes = q.ni)(), Q._crypto_box_curve25519xchacha20poly1305_beforenmbytes = ()=>(Q._crypto_box_curve25519xchacha20poly1305_beforenmbytes = q.oi)(), Q._crypto_box_curve25519xchacha20poly1305_noncebytes = ()=>(Q._crypto_box_curve25519xchacha20poly1305_noncebytes = q.pi)(), Q._crypto_box_curve25519xchacha20poly1305_macbytes = ()=>(Q._crypto_box_curve25519xchacha20poly1305_macbytes = q.qi)(), Q._crypto_box_curve25519xchacha20poly1305_messagebytes_max = ()=>(Q._crypto_box_curve25519xchacha20poly1305_messagebytes_max = q.ri)(), Q._crypto_box_curve25519xchacha20poly1305_seal = (A, I, g, C, B)=>(Q._crypto_box_curve25519xchacha20poly1305_seal = q.si)(A, I, g, C, B), Q._crypto_box_curve25519xchacha20poly1305_seal_open = (A, I, g, C, B, i)=>(Q._crypto_box_curve25519xchacha20poly1305_seal_open = q.ti)(A, I, g, C, B, i), Q._crypto_box_curve25519xchacha20poly1305_sealbytes = ()=>(Q._crypto_box_curve25519xchacha20poly1305_sealbytes = q.ui)(), Q._crypto_core_ed25519_is_valid_point = (A)=>(Q._crypto_core_ed25519_is_valid_point = q.vi)(A), Q._crypto_core_ed25519_add = (A, I, g)=>(Q._crypto_core_ed25519_add = q.wi)(A, I, g), Q._crypto_core_ed25519_sub = (A, I, g)=>(Q._crypto_core_ed25519_sub = q.xi)(A, I, g), Q._crypto_core_ed25519_from_uniform = (A, I)=>(Q._crypto_core_ed25519_from_uniform = q.yi)(A, I), Q._crypto_core_ed25519_random = (A)=>(Q._crypto_core_ed25519_random = q.zi)(A), Q._crypto_core_ed25519_scalar_random = (A)=>(Q._crypto_core_ed25519_scalar_random = q.Ai)(A), Q._crypto_core_ed25519_scalar_invert = (A, I)=>(Q._crypto_core_ed25519_scalar_invert = q.Bi)(A, I), Q._crypto_core_ed25519_scalar_negate = (A, I)=>(Q._crypto_core_ed25519_scalar_negate = q.Ci)(A, I), Q._crypto_core_ed25519_scalar_complement = (A, I)=>(Q._crypto_core_ed25519_scalar_complement = q.Di)(A, I), Q._crypto_core_ed25519_scalar_add = (A, I, g)=>(Q._crypto_core_ed25519_scalar_add = q.Ei)(A, I, g), Q._crypto_core_ed25519_scalar_reduce = (A, I)=>(Q._crypto_core_ed25519_scalar_reduce = q.Fi)(A, I), Q._crypto_core_ed25519_scalar_sub = (A, I, g)=>(Q._crypto_core_ed25519_scalar_sub = q.Gi)(A, I, g), Q._crypto_core_ed25519_scalar_mul = (A, I, g)=>(Q._crypto_core_ed25519_scalar_mul = q.Hi)(A, I, g), Q._crypto_core_ed25519_bytes = ()=>(Q._crypto_core_ed25519_bytes = q.Ii)(), Q._crypto_core_ed25519_nonreducedscalarbytes = ()=>(Q._crypto_core_ed25519_nonreducedscalarbytes = q.Ji)(), Q._crypto_core_ed25519_uniformbytes = ()=>(Q._crypto_core_ed25519_uniformbytes = q.Ki)(), Q._crypto_core_ed25519_hashbytes = ()=>(Q._crypto_core_ed25519_hashbytes = q.Li)(), Q._crypto_core_ed25519_scalarbytes = ()=>(Q._crypto_core_ed25519_scalarbytes = q.Mi)(), Q._crypto_core_ristretto255_is_valid_point = (A)=>(Q._crypto_core_ristretto255_is_valid_point = q.Ni)(A), Q._crypto_core_ristretto255_add = (A, I, g)=>(Q._crypto_core_ristretto255_add = q.Oi)(A, I, g), Q._crypto_core_ristretto255_sub = (A, I, g)=>(Q._crypto_core_ristretto255_sub = q.Pi)(A, I, g), Q._crypto_core_ristretto255_from_hash = (A, I)=>(Q._crypto_core_ristretto255_from_hash = q.Qi)(A, I), Q._crypto_core_ristretto255_random = (A)=>(Q._crypto_core_ristretto255_random = q.Ri)(A), Q._crypto_core_ristretto255_scalar_random = (A)=>(Q._crypto_core_ristretto255_scalar_random = q.Si)(A), Q._crypto_core_ristretto255_scalar_invert = (A, I)=>(Q._crypto_core_ristretto255_scalar_invert = q.Ti)(A, I), Q._crypto_core_ristretto255_scalar_negate = (A, I)=>(Q._crypto_core_ristretto255_scalar_negate = q.Ui)(A, I), Q._crypto_core_ristretto255_scalar_complement = (A, I)=>(Q._crypto_core_ristretto255_scalar_complement = q.Vi)(A, I), Q._crypto_core_ristretto255_scalar_add = (A, I, g)=>(Q._crypto_core_ristretto255_scalar_add = q.Wi)(A, I, g), Q._crypto_core_ristretto255_scalar_sub = (A, I, g)=>(Q._crypto_core_ristretto255_scalar_sub = q.Xi)(A, I, g), Q._crypto_core_ristretto255_scalar_mul = (A, I, g)=>(Q._crypto_core_ristretto255_scalar_mul = q.Yi)(A, I, g), Q._crypto_core_ristretto255_scalar_reduce = (A, I)=>(Q._crypto_core_ristretto255_scalar_reduce = q.Zi)(A, I), Q._crypto_core_ristretto255_bytes = ()=>(Q._crypto_core_ristretto255_bytes = q._i)(), Q._crypto_core_ristretto255_nonreducedscalarbytes = ()=>(Q._crypto_core_ristretto255_nonreducedscalarbytes = q.$i)(), Q._crypto_core_ristretto255_hashbytes = ()=>(Q._crypto_core_ristretto255_hashbytes = q.aj)(), Q._crypto_core_ristretto255_scalarbytes = ()=>(Q._crypto_core_ristretto255_scalarbytes = q.bj)(), Q._crypto_pwhash_scryptsalsa208sha256_ll = (A, I, g, C, B, i, o, E, a, _)=>(Q._crypto_pwhash_scryptsalsa208sha256_ll = q.cj)(A, I, g, C, B, i, o, E, a, _), Q._crypto_pwhash_scryptsalsa208sha256_bytes_min = ()=>(Q._crypto_pwhash_scryptsalsa208sha256_bytes_min = q.dj)(), Q._crypto_pwhash_scryptsalsa208sha256_bytes_max = ()=>(Q._crypto_pwhash_scryptsalsa208sha256_bytes_max = q.ej)(), Q._crypto_pwhash_scryptsalsa208sha256_passwd_min = ()=>(Q._crypto_pwhash_scryptsalsa208sha256_passwd_min = q.fj)(), Q._crypto_pwhash_scryptsalsa208sha256_passwd_max = ()=>(Q._crypto_pwhash_scryptsalsa208sha256_passwd_max = q.gj)(), Q._crypto_pwhash_scryptsalsa208sha256_saltbytes = ()=>(Q._crypto_pwhash_scryptsalsa208sha256_saltbytes = q.hj)(), Q._crypto_pwhash_scryptsalsa208sha256_strbytes = ()=>(Q._crypto_pwhash_scryptsalsa208sha256_strbytes = q.ij)(), Q._crypto_pwhash_scryptsalsa208sha256_strprefix = ()=>(Q._crypto_pwhash_scryptsalsa208sha256_strprefix = q.jj)(), Q._crypto_pwhash_scryptsalsa208sha256_opslimit_min = ()=>(Q._crypto_pwhash_scryptsalsa208sha256_opslimit_min = q.kj)(), Q._crypto_pwhash_scryptsalsa208sha256_opslimit_max = ()=>(Q._crypto_pwhash_scryptsalsa208sha256_opslimit_max = q.lj)(), Q._crypto_pwhash_scryptsalsa208sha256_memlimit_min = ()=>(Q._crypto_pwhash_scryptsalsa208sha256_memlimit_min = q.mj)(), Q._crypto_pwhash_scryptsalsa208sha256_memlimit_max = ()=>(Q._crypto_pwhash_scryptsalsa208sha256_memlimit_max = q.nj)(), Q._crypto_pwhash_scryptsalsa208sha256_opslimit_interactive = ()=>(Q._crypto_pwhash_scryptsalsa208sha256_opslimit_interactive = q.oj)(), Q._crypto_pwhash_scryptsalsa208sha256_memlimit_interactive = ()=>(Q._crypto_pwhash_scryptsalsa208sha256_memlimit_interactive = q.pj)(), Q._crypto_pwhash_scryptsalsa208sha256_opslimit_sensitive = ()=>(Q._crypto_pwhash_scryptsalsa208sha256_opslimit_sensitive = q.qj)(), Q._crypto_pwhash_scryptsalsa208sha256_memlimit_sensitive = ()=>(Q._crypto_pwhash_scryptsalsa208sha256_memlimit_sensitive = q.rj)(), Q._crypto_pwhash_scryptsalsa208sha256 = (A, I, g, C, B, i, o, E, a, _)=>(Q._crypto_pwhash_scryptsalsa208sha256 = q.sj)(A, I, g, C, B, i, o, E, a, _), Q._crypto_pwhash_scryptsalsa208sha256_str = (A, I, g, C, B, i, o)=>(Q._crypto_pwhash_scryptsalsa208sha256_str = q.tj)(A, I, g, C, B, i, o), Q._crypto_pwhash_scryptsalsa208sha256_str_verify = (A, I, g, C)=>(Q._crypto_pwhash_scryptsalsa208sha256_str_verify = q.uj)(A, I, g, C), Q._crypto_pwhash_scryptsalsa208sha256_str_needs_rehash = (A, I, g, C)=>(Q._crypto_pwhash_scryptsalsa208sha256_str_needs_rehash = q.vj)(A, I, g, C), Q._crypto_scalarmult_ed25519 = (A, I, g)=>(Q._crypto_scalarmult_ed25519 = q.wj)(A, I, g), Q._crypto_scalarmult_ed25519_noclamp = (A, I, g)=>(Q._crypto_scalarmult_ed25519_noclamp = q.xj)(A, I, g), Q._crypto_scalarmult_ed25519_base = (A, I)=>(Q._crypto_scalarmult_ed25519_base = q.yj)(A, I), Q._crypto_scalarmult_ed25519_base_noclamp = (A, I)=>(Q._crypto_scalarmult_ed25519_base_noclamp = q.zj)(A, I), Q._crypto_scalarmult_ed25519_bytes = ()=>(Q._crypto_scalarmult_ed25519_bytes = q.Aj)(), Q._crypto_scalarmult_ed25519_scalarbytes = ()=>(Q._crypto_scalarmult_ed25519_scalarbytes = q.Bj)(), Q._crypto_scalarmult_ristretto255 = (A, I, g)=>(Q._crypto_scalarmult_ristretto255 = q.Cj)(A, I, g), Q._crypto_scalarmult_ristretto255_base = (A, I)=>(Q._crypto_scalarmult_ristretto255_base = q.Dj)(A, I), Q._crypto_scalarmult_ristretto255_bytes = ()=>(Q._crypto_scalarmult_ristretto255_bytes = q.Ej)(), Q._crypto_scalarmult_ristretto255_scalarbytes = ()=>(Q._crypto_scalarmult_ristretto255_scalarbytes = q.Fj)(), Q._crypto_secretbox_xchacha20poly1305_detached = (A, I, g, C, B, i, o)=>(Q._crypto_secretbox_xchacha20poly1305_detached = q.Gj)(A, I, g, C, B, i, o), Q._crypto_secretbox_xchacha20poly1305_easy = (A, I, g, C, B, i)=>(Q._crypto_secretbox_xchacha20poly1305_easy = q.Hj)(A, I, g, C, B, i), Q._crypto_secretbox_xchacha20poly1305_open_detached = (A, I, g, C, B, i, o)=>(Q._crypto_secretbox_xchacha20poly1305_open_detached = q.Ij)(A, I, g, C, B, i, o), Q._crypto_secretbox_xchacha20poly1305_open_easy = (A, I, g, C, B, i)=>(Q._crypto_secretbox_xchacha20poly1305_open_easy = q.Jj)(A, I, g, C, B, i), Q._crypto_secretbox_xchacha20poly1305_keybytes = ()=>(Q._crypto_secretbox_xchacha20poly1305_keybytes = q.Kj)(), Q._crypto_secretbox_xchacha20poly1305_noncebytes = ()=>(Q._crypto_secretbox_xchacha20poly1305_noncebytes = q.Lj)(), Q._crypto_secretbox_xchacha20poly1305_macbytes = ()=>(Q._crypto_secretbox_xchacha20poly1305_macbytes = q.Mj)(), Q._crypto_secretbox_xchacha20poly1305_messagebytes_max = ()=>(Q._crypto_secretbox_xchacha20poly1305_messagebytes_max = q.Nj)(), Q._crypto_shorthash_siphashx24_bytes = ()=>(Q._crypto_shorthash_siphashx24_bytes = q.Oj)(), Q._crypto_shorthash_siphashx24_keybytes = ()=>(Q._crypto_shorthash_siphashx24_keybytes = q.Pj)(), Q._crypto_shorthash_siphashx24 = (A, I, g, C, B)=>(Q._crypto_shorthash_siphashx24 = q.Qj)(A, I, g, C, B), Q._crypto_stream_salsa2012 = (A, I, g, C, B)=>(Q._crypto_stream_salsa2012 = q.Rj)(A, I, g, C, B), Q._crypto_stream_salsa2012_xor = (A, I, g, C, B, i)=>(Q._crypto_stream_salsa2012_xor = q.Sj)(A, I, g, C, B, i), Q._crypto_stream_salsa2012_keybytes = ()=>(Q._crypto_stream_salsa2012_keybytes = q.Tj)(), Q._crypto_stream_salsa2012_noncebytes = ()=>(Q._crypto_stream_salsa2012_noncebytes = q.Uj)(), Q._crypto_stream_salsa2012_messagebytes_max = ()=>(Q._crypto_stream_salsa2012_messagebytes_max = q.Vj)(), Q._crypto_stream_salsa2012_keygen = (A)=>(Q._crypto_stream_salsa2012_keygen = q.Wj)(A), Q._crypto_stream_salsa208 = (A, I, g, C, B)=>(Q._crypto_stream_salsa208 = q.Xj)(A, I, g, C, B), Q._crypto_stream_salsa208_xor = (A, I, g, C, B, i)=>(Q._crypto_stream_salsa208_xor = q.Yj)(A, I, g, C, B, i), Q._crypto_stream_salsa208_keybytes = ()=>(Q._crypto_stream_salsa208_keybytes = q.Zj)(), Q._crypto_stream_salsa208_noncebytes = ()=>(Q._crypto_stream_salsa208_noncebytes = q._j)(), Q._crypto_stream_salsa208_messagebytes_max = ()=>(Q._crypto_stream_salsa208_messagebytes_max = q.$j)(), Q._crypto_stream_salsa208_keygen = (A)=>(Q._crypto_stream_salsa208_keygen = q.ak)(A), Q._crypto_stream_xchacha20_keybytes = ()=>(Q._crypto_stream_xchacha20_keybytes = q.bk)(), Q._crypto_stream_xchacha20_noncebytes = ()=>(Q._crypto_stream_xchacha20_noncebytes = q.ck)(), Q._crypto_stream_xchacha20_messagebytes_max = ()=>(Q._crypto_stream_xchacha20_messagebytes_max = q.dk)(), Q._crypto_stream_xchacha20 = (A, I, g, C, B)=>(Q._crypto_stream_xchacha20 = q.ek)(A, I, g, C, B), Q._crypto_stream_xchacha20_xor_ic = (A, I, g, C, B, i, o, E)=>(Q._crypto_stream_xchacha20_xor_ic = q.fk)(A, I, g, C, B, i, o, E), Q._crypto_stream_xchacha20_xor = (A, I, g, C, B, i)=>(Q._crypto_stream_xchacha20_xor = q.gk)(A, I, g, C, B, i), Q._crypto_stream_xchacha20_keygen = (A)=>(Q._crypto_stream_xchacha20_keygen = q.hk)(A), Q._malloc = (A)=>(Q._malloc = q.ik)(A), Q._free = (A)=>(Q._free = q.jk)(A), Q.setValue = function(A, I, g = "i8") {
                switch(g.endsWith("*") && (g = "*"), g){
                    case "i1":
                    case "i8":
                        s[A >> 0] = I;
                        break;
                    case "i16":
                        D[A >> 1] = I;
                        break;
                    case "i32":
                        p[A >> 2] = I;
                        break;
                    case "i64":
                        H("to do setValue(i64) use WASM_BIGINT");
                    case "float":
                        f[A >> 2] = I;
                        break;
                    case "double":
                        n[A >> 3] = I;
                        break;
                    case "*":
                        w[A >> 2] = I;
                        break;
                    default:
                        H(`invalid type for setValue: ${g}`);
                }
            }, Q.getValue = function(A, I = "i8") {
                switch(I.endsWith("*") && (I = "*"), I){
                    case "i1":
                    case "i8":
                        return s[A >> 0];
                    case "i16":
                        return D[A >> 1];
                    case "i32":
                        return p[A >> 2];
                    case "i64":
                        H("to do getValue(i64) use WASM_BIGINT");
                    case "float":
                        return f[A >> 2];
                    case "double":
                        return n[A >> 3];
                    case "*":
                        return w[A >> 2];
                    default:
                        H(`invalid type for getValue: ${I}`);
                }
            }, Q.UTF8ToString = R, K = function A() {
                l || z(), l || (K = A);
            }, Q.preInit) for("function" == typeof Q.preInit && (Q.preInit = [
                Q.preInit
            ]); Q.preInit.length > 0;)Q.preInit.pop()();
            z();
        }).catch(function() {
            return C.useBackupModule();
        }), I;
    }
    "function" == typeof define && define.amd ? define([
        "exports"
    ], I) : "string" != typeof module.exports.nodeName ? I(module.exports) : A.libsodium = I(A.libsodium_mod || (A.commonJsStrict = {}));
}(module.exports);

});


parcelRequire.register("8TyLy", function(module, exports) {

(function(module1, exports) {
    "use strict";
    // Utils
    function assert(val, msg) {
        if (!val) throw new Error(msg || "Assertion failed");
    }
    // Could use `inherits` module, but don't want to move from single file
    // architecture yet.
    function inherits(ctor, superCtor) {
        ctor.super_ = superCtor;
        var TempCtor = function() {};
        TempCtor.prototype = superCtor.prototype;
        ctor.prototype = new TempCtor();
        ctor.prototype.constructor = ctor;
    }
    // BN
    function BN(number, base, endian) {
        if (BN.isBN(number)) return number;
        this.negative = 0;
        this.words = null;
        this.length = 0;
        // Reduction context
        this.red = null;
        if (number !== null) {
            if (base === "le" || base === "be") {
                endian = base;
                base = 10;
            }
            this._init(number || 0, base || 10, endian || "be");
        }
    }
    if (typeof module1 === "object") module1.exports = BN;
    else exports.BN = BN;
    BN.BN = BN;
    BN.wordSize = 26;
    var Buffer;
    try {
        if (typeof window !== "undefined" && typeof window.Buffer !== "undefined") Buffer = window.Buffer;
        else Buffer = (parcelRequire("5Io6y")).Buffer;
    } catch (e) {}
    BN.isBN = function isBN(num) {
        if (num instanceof BN) return true;
        return num !== null && typeof num === "object" && num.constructor.wordSize === BN.wordSize && Array.isArray(num.words);
    };
    BN.max = function max(left, right) {
        if (left.cmp(right) > 0) return left;
        return right;
    };
    BN.min = function min(left, right) {
        if (left.cmp(right) < 0) return left;
        return right;
    };
    BN.prototype._init = function init(number, base, endian) {
        if (typeof number === "number") return this._initNumber(number, base, endian);
        if (typeof number === "object") return this._initArray(number, base, endian);
        if (base === "hex") base = 16;
        assert(base === (base | 0) && base >= 2 && base <= 36);
        number = number.toString().replace(/\s+/g, "");
        var start = 0;
        if (number[0] === "-") {
            start++;
            this.negative = 1;
        }
        if (start < number.length) {
            if (base === 16) this._parseHex(number, start, endian);
            else {
                this._parseBase(number, base, start);
                if (endian === "le") this._initArray(this.toArray(), base, endian);
            }
        }
    };
    BN.prototype._initNumber = function _initNumber(number, base, endian) {
        if (number < 0) {
            this.negative = 1;
            number = -number;
        }
        if (number < 0x4000000) {
            this.words = [
                number & 0x3ffffff
            ];
            this.length = 1;
        } else if (number < 0x10000000000000) {
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff
            ];
            this.length = 2;
        } else {
            assert(number < 0x20000000000000); // 2 ^ 53 (unsafe)
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff,
                1
            ];
            this.length = 3;
        }
        if (endian !== "le") return;
        // Reverse the bytes
        this._initArray(this.toArray(), base, endian);
    };
    BN.prototype._initArray = function _initArray(number, base, endian) {
        // Perhaps a Uint8Array
        assert(typeof number.length === "number");
        if (number.length <= 0) {
            this.words = [
                0
            ];
            this.length = 1;
            return this;
        }
        this.length = Math.ceil(number.length / 3);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        var j, w;
        var off = 0;
        if (endian === "be") for(i = number.length - 1, j = 0; i >= 0; i -= 3){
            w = number[i] | number[i - 1] << 8 | number[i - 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        else if (endian === "le") for(i = 0, j = 0; i < number.length; i += 3){
            w = number[i] | number[i + 1] << 8 | number[i + 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        return this._strip();
    };
    function parseHex4Bits(string, index) {
        var c = string.charCodeAt(index);
        // '0' - '9'
        if (c >= 48 && c <= 57) return c - 48;
        else if (c >= 65 && c <= 70) return c - 55;
        else if (c >= 97 && c <= 102) return c - 87;
        else assert(false, "Invalid character in " + string);
    }
    function parseHexByte(string, lowerBound, index) {
        var r = parseHex4Bits(string, index);
        if (index - 1 >= lowerBound) r |= parseHex4Bits(string, index - 1) << 4;
        return r;
    }
    BN.prototype._parseHex = function _parseHex(number, start, endian) {
        // Create possibly bigger array to ensure that it fits the number
        this.length = Math.ceil((number.length - start) / 6);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        // 24-bits chunks
        var off = 0;
        var j = 0;
        var w;
        if (endian === "be") for(i = number.length - 1; i >= start; i -= 2){
            w = parseHexByte(number, start, i) << off;
            this.words[j] |= w & 0x3ffffff;
            if (off >= 18) {
                off -= 18;
                j += 1;
                this.words[j] |= w >>> 26;
            } else off += 8;
        }
        else {
            var parseLength = number.length - start;
            for(i = parseLength % 2 === 0 ? start + 1 : start; i < number.length; i += 2){
                w = parseHexByte(number, start, i) << off;
                this.words[j] |= w & 0x3ffffff;
                if (off >= 18) {
                    off -= 18;
                    j += 1;
                    this.words[j] |= w >>> 26;
                } else off += 8;
            }
        }
        this._strip();
    };
    function parseBase(str, start, end, mul) {
        var r = 0;
        var b = 0;
        var len = Math.min(str.length, end);
        for(var i = start; i < len; i++){
            var c = str.charCodeAt(i) - 48;
            r *= mul;
            // 'a'
            if (c >= 49) b = c - 49 + 0xa;
            else if (c >= 17) b = c - 17 + 0xa;
            else b = c;
            assert(c >= 0 && b < mul, "Invalid character");
            r += b;
        }
        return r;
    }
    BN.prototype._parseBase = function _parseBase(number, base, start) {
        // Initialize as zero
        this.words = [
            0
        ];
        this.length = 1;
        // Find length of limb in base
        for(var limbLen = 0, limbPow = 1; limbPow <= 0x3ffffff; limbPow *= base)limbLen++;
        limbLen--;
        limbPow = limbPow / base | 0;
        var total = number.length - start;
        var mod = total % limbLen;
        var end = Math.min(total, total - mod) + start;
        var word = 0;
        for(var i = start; i < end; i += limbLen){
            word = parseBase(number, i, i + limbLen, base);
            this.imuln(limbPow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        if (mod !== 0) {
            var pow = 1;
            word = parseBase(number, i, number.length, base);
            for(i = 0; i < mod; i++)pow *= base;
            this.imuln(pow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        this._strip();
    };
    BN.prototype.copy = function copy(dest) {
        dest.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)dest.words[i] = this.words[i];
        dest.length = this.length;
        dest.negative = this.negative;
        dest.red = this.red;
    };
    function move(dest, src) {
        dest.words = src.words;
        dest.length = src.length;
        dest.negative = src.negative;
        dest.red = src.red;
    }
    BN.prototype._move = function _move(dest) {
        move(dest, this);
    };
    BN.prototype.clone = function clone() {
        var r = new BN(null);
        this.copy(r);
        return r;
    };
    BN.prototype._expand = function _expand(size) {
        while(this.length < size)this.words[this.length++] = 0;
        return this;
    };
    // Remove leading `0` from `this`
    BN.prototype._strip = function strip() {
        while(this.length > 1 && this.words[this.length - 1] === 0)this.length--;
        return this._normSign();
    };
    BN.prototype._normSign = function _normSign() {
        // -0 = 0
        if (this.length === 1 && this.words[0] === 0) this.negative = 0;
        return this;
    };
    // Check Symbol.for because not everywhere where Symbol defined
    // See https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Symbol#Browser_compatibility
    if (typeof Symbol !== "undefined" && typeof Symbol.for === "function") try {
        BN.prototype[Symbol.for("nodejs.util.inspect.custom")] = inspect;
    } catch (e) {
        BN.prototype.inspect = inspect;
    }
    else BN.prototype.inspect = inspect;
    function inspect() {
        return (this.red ? "<BN-R: " : "<BN: ") + this.toString(16) + ">";
    }
    /*

  var zeros = [];
  var groupSizes = [];
  var groupBases = [];

  var s = '';
  var i = -1;
  while (++i < BN.wordSize) {
    zeros[i] = s;
    s += '0';
  }
  groupSizes[0] = 0;
  groupSizes[1] = 0;
  groupBases[0] = 0;
  groupBases[1] = 0;
  var base = 2 - 1;
  while (++base < 36 + 1) {
    var groupSize = 0;
    var groupBase = 1;
    while (groupBase < (1 << BN.wordSize) / base) {
      groupBase *= base;
      groupSize += 1;
    }
    groupSizes[base] = groupSize;
    groupBases[base] = groupBase;
  }

  */ var zeros = [
        "",
        "0",
        "00",
        "000",
        "0000",
        "00000",
        "000000",
        "0000000",
        "00000000",
        "000000000",
        "0000000000",
        "00000000000",
        "000000000000",
        "0000000000000",
        "00000000000000",
        "000000000000000",
        "0000000000000000",
        "00000000000000000",
        "000000000000000000",
        "0000000000000000000",
        "00000000000000000000",
        "000000000000000000000",
        "0000000000000000000000",
        "00000000000000000000000",
        "000000000000000000000000",
        "0000000000000000000000000"
    ];
    var groupSizes = [
        0,
        0,
        25,
        16,
        12,
        11,
        10,
        9,
        8,
        8,
        7,
        7,
        7,
        7,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5
    ];
    var groupBases = [
        0,
        0,
        33554432,
        43046721,
        16777216,
        48828125,
        60466176,
        40353607,
        16777216,
        43046721,
        10000000,
        19487171,
        35831808,
        62748517,
        7529536,
        11390625,
        16777216,
        24137569,
        34012224,
        47045881,
        64000000,
        4084101,
        5153632,
        6436343,
        7962624,
        9765625,
        11881376,
        14348907,
        17210368,
        20511149,
        24300000,
        28629151,
        33554432,
        39135393,
        45435424,
        52521875,
        60466176
    ];
    BN.prototype.toString = function toString(base, padding) {
        base = base || 10;
        padding = padding | 0 || 1;
        var out;
        if (base === 16 || base === "hex") {
            out = "";
            var off = 0;
            var carry = 0;
            for(var i = 0; i < this.length; i++){
                var w = this.words[i];
                var word = ((w << off | carry) & 0xffffff).toString(16);
                carry = w >>> 24 - off & 0xffffff;
                off += 2;
                if (off >= 26) {
                    off -= 26;
                    i--;
                }
                if (carry !== 0 || i !== this.length - 1) out = zeros[6 - word.length] + word + out;
                else out = word + out;
            }
            if (carry !== 0) out = carry.toString(16) + out;
            while(out.length % padding !== 0)out = "0" + out;
            if (this.negative !== 0) out = "-" + out;
            return out;
        }
        if (base === (base | 0) && base >= 2 && base <= 36) {
            // var groupSize = Math.floor(BN.wordSize * Math.LN2 / Math.log(base));
            var groupSize = groupSizes[base];
            // var groupBase = Math.pow(base, groupSize);
            var groupBase = groupBases[base];
            out = "";
            var c = this.clone();
            c.negative = 0;
            while(!c.isZero()){
                var r = c.modrn(groupBase).toString(base);
                c = c.idivn(groupBase);
                if (!c.isZero()) out = zeros[groupSize - r.length] + r + out;
                else out = r + out;
            }
            if (this.isZero()) out = "0" + out;
            while(out.length % padding !== 0)out = "0" + out;
            if (this.negative !== 0) out = "-" + out;
            return out;
        }
        assert(false, "Base should be between 2 and 36");
    };
    BN.prototype.toNumber = function toNumber() {
        var ret = this.words[0];
        if (this.length === 2) ret += this.words[1] * 0x4000000;
        else if (this.length === 3 && this.words[2] === 0x01) // NOTE: at this stage it is known that the top bit is set
        ret += 0x10000000000000 + this.words[1] * 0x4000000;
        else if (this.length > 2) assert(false, "Number can only safely store up to 53 bits");
        return this.negative !== 0 ? -ret : ret;
    };
    BN.prototype.toJSON = function toJSON() {
        return this.toString(16, 2);
    };
    if (Buffer) BN.prototype.toBuffer = function toBuffer(endian, length) {
        return this.toArrayLike(Buffer, endian, length);
    };
    BN.prototype.toArray = function toArray(endian, length) {
        return this.toArrayLike(Array, endian, length);
    };
    var allocate = function allocate(ArrayType, size) {
        if (ArrayType.allocUnsafe) return ArrayType.allocUnsafe(size);
        return new ArrayType(size);
    };
    BN.prototype.toArrayLike = function toArrayLike(ArrayType, endian, length) {
        this._strip();
        var byteLength = this.byteLength();
        var reqLength = length || Math.max(1, byteLength);
        assert(byteLength <= reqLength, "byte array longer than desired length");
        assert(reqLength > 0, "Requested array length <= 0");
        var res = allocate(ArrayType, reqLength);
        var postfix = endian === "le" ? "LE" : "BE";
        this["_toArrayLike" + postfix](res, byteLength);
        return res;
    };
    BN.prototype._toArrayLikeLE = function _toArrayLikeLE(res, byteLength) {
        var position = 0;
        var carry = 0;
        for(var i = 0, shift = 0; i < this.length; i++){
            var word = this.words[i] << shift | carry;
            res[position++] = word & 0xff;
            if (position < res.length) res[position++] = word >> 8 & 0xff;
            if (position < res.length) res[position++] = word >> 16 & 0xff;
            if (shift === 6) {
                if (position < res.length) res[position++] = word >> 24 & 0xff;
                carry = 0;
                shift = 0;
            } else {
                carry = word >>> 24;
                shift += 2;
            }
        }
        if (position < res.length) {
            res[position++] = carry;
            while(position < res.length)res[position++] = 0;
        }
    };
    BN.prototype._toArrayLikeBE = function _toArrayLikeBE(res, byteLength) {
        var position = res.length - 1;
        var carry = 0;
        for(var i = 0, shift = 0; i < this.length; i++){
            var word = this.words[i] << shift | carry;
            res[position--] = word & 0xff;
            if (position >= 0) res[position--] = word >> 8 & 0xff;
            if (position >= 0) res[position--] = word >> 16 & 0xff;
            if (shift === 6) {
                if (position >= 0) res[position--] = word >> 24 & 0xff;
                carry = 0;
                shift = 0;
            } else {
                carry = word >>> 24;
                shift += 2;
            }
        }
        if (position >= 0) {
            res[position--] = carry;
            while(position >= 0)res[position--] = 0;
        }
    };
    if (Math.clz32) BN.prototype._countBits = function _countBits(w) {
        return 32 - Math.clz32(w);
    };
    else BN.prototype._countBits = function _countBits(w) {
        var t = w;
        var r = 0;
        if (t >= 0x1000) {
            r += 13;
            t >>>= 13;
        }
        if (t >= 0x40) {
            r += 7;
            t >>>= 7;
        }
        if (t >= 0x8) {
            r += 4;
            t >>>= 4;
        }
        if (t >= 0x02) {
            r += 2;
            t >>>= 2;
        }
        return r + t;
    };
    BN.prototype._zeroBits = function _zeroBits(w) {
        // Short-cut
        if (w === 0) return 26;
        var t = w;
        var r = 0;
        if ((t & 0x1fff) === 0) {
            r += 13;
            t >>>= 13;
        }
        if ((t & 0x7f) === 0) {
            r += 7;
            t >>>= 7;
        }
        if ((t & 0xf) === 0) {
            r += 4;
            t >>>= 4;
        }
        if ((t & 0x3) === 0) {
            r += 2;
            t >>>= 2;
        }
        if ((t & 0x1) === 0) r++;
        return r;
    };
    // Return number of used bits in a BN
    BN.prototype.bitLength = function bitLength() {
        var w = this.words[this.length - 1];
        var hi = this._countBits(w);
        return (this.length - 1) * 26 + hi;
    };
    function toBitArray(num) {
        var w = new Array(num.bitLength());
        for(var bit = 0; bit < w.length; bit++){
            var off = bit / 26 | 0;
            var wbit = bit % 26;
            w[bit] = num.words[off] >>> wbit & 0x01;
        }
        return w;
    }
    // Number of trailing zero bits
    BN.prototype.zeroBits = function zeroBits() {
        if (this.isZero()) return 0;
        var r = 0;
        for(var i = 0; i < this.length; i++){
            var b = this._zeroBits(this.words[i]);
            r += b;
            if (b !== 26) break;
        }
        return r;
    };
    BN.prototype.byteLength = function byteLength() {
        return Math.ceil(this.bitLength() / 8);
    };
    BN.prototype.toTwos = function toTwos(width) {
        if (this.negative !== 0) return this.abs().inotn(width).iaddn(1);
        return this.clone();
    };
    BN.prototype.fromTwos = function fromTwos(width) {
        if (this.testn(width - 1)) return this.notn(width).iaddn(1).ineg();
        return this.clone();
    };
    BN.prototype.isNeg = function isNeg() {
        return this.negative !== 0;
    };
    // Return negative clone of `this`
    BN.prototype.neg = function neg() {
        return this.clone().ineg();
    };
    BN.prototype.ineg = function ineg() {
        if (!this.isZero()) this.negative ^= 1;
        return this;
    };
    // Or `num` with `this` in-place
    BN.prototype.iuor = function iuor(num) {
        while(this.length < num.length)this.words[this.length++] = 0;
        for(var i = 0; i < num.length; i++)this.words[i] = this.words[i] | num.words[i];
        return this._strip();
    };
    BN.prototype.ior = function ior(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuor(num);
    };
    // Or `num` with `this`
    BN.prototype.or = function or(num) {
        if (this.length > num.length) return this.clone().ior(num);
        return num.clone().ior(this);
    };
    BN.prototype.uor = function uor(num) {
        if (this.length > num.length) return this.clone().iuor(num);
        return num.clone().iuor(this);
    };
    // And `num` with `this` in-place
    BN.prototype.iuand = function iuand(num) {
        // b = min-length(num, this)
        var b;
        if (this.length > num.length) b = num;
        else b = this;
        for(var i = 0; i < b.length; i++)this.words[i] = this.words[i] & num.words[i];
        this.length = b.length;
        return this._strip();
    };
    BN.prototype.iand = function iand(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuand(num);
    };
    // And `num` with `this`
    BN.prototype.and = function and(num) {
        if (this.length > num.length) return this.clone().iand(num);
        return num.clone().iand(this);
    };
    BN.prototype.uand = function uand(num) {
        if (this.length > num.length) return this.clone().iuand(num);
        return num.clone().iuand(this);
    };
    // Xor `num` with `this` in-place
    BN.prototype.iuxor = function iuxor(num) {
        // a.length > b.length
        var a;
        var b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        for(var i = 0; i < b.length; i++)this.words[i] = a.words[i] ^ b.words[i];
        if (this !== a) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = a.length;
        return this._strip();
    };
    BN.prototype.ixor = function ixor(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuxor(num);
    };
    // Xor `num` with `this`
    BN.prototype.xor = function xor(num) {
        if (this.length > num.length) return this.clone().ixor(num);
        return num.clone().ixor(this);
    };
    BN.prototype.uxor = function uxor(num) {
        if (this.length > num.length) return this.clone().iuxor(num);
        return num.clone().iuxor(this);
    };
    // Not ``this`` with ``width`` bitwidth
    BN.prototype.inotn = function inotn(width) {
        assert(typeof width === "number" && width >= 0);
        var bytesNeeded = Math.ceil(width / 26) | 0;
        var bitsLeft = width % 26;
        // Extend the buffer with leading zeroes
        this._expand(bytesNeeded);
        if (bitsLeft > 0) bytesNeeded--;
        // Handle complete words
        for(var i = 0; i < bytesNeeded; i++)this.words[i] = ~this.words[i] & 0x3ffffff;
        // Handle the residue
        if (bitsLeft > 0) this.words[i] = ~this.words[i] & 0x3ffffff >> 26 - bitsLeft;
        // And remove leading zeroes
        return this._strip();
    };
    BN.prototype.notn = function notn(width) {
        return this.clone().inotn(width);
    };
    // Set `bit` of `this`
    BN.prototype.setn = function setn(bit, val) {
        assert(typeof bit === "number" && bit >= 0);
        var off = bit / 26 | 0;
        var wbit = bit % 26;
        this._expand(off + 1);
        if (val) this.words[off] = this.words[off] | 1 << wbit;
        else this.words[off] = this.words[off] & ~(1 << wbit);
        return this._strip();
    };
    // Add `num` to `this` in-place
    BN.prototype.iadd = function iadd(num) {
        var r;
        // negative + positive
        if (this.negative !== 0 && num.negative === 0) {
            this.negative = 0;
            r = this.isub(num);
            this.negative ^= 1;
            return this._normSign();
        // positive + negative
        } else if (this.negative === 0 && num.negative !== 0) {
            num.negative = 0;
            r = this.isub(num);
            num.negative = 1;
            return r._normSign();
        }
        // a.length > b.length
        var a, b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) + (b.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        this.length = a.length;
        if (carry !== 0) {
            this.words[this.length] = carry;
            this.length++;
        // Copy the rest of the words
        } else if (a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        return this;
    };
    // Add `num` to `this`
    BN.prototype.add = function add(num) {
        var res;
        if (num.negative !== 0 && this.negative === 0) {
            num.negative = 0;
            res = this.sub(num);
            num.negative ^= 1;
            return res;
        } else if (num.negative === 0 && this.negative !== 0) {
            this.negative = 0;
            res = num.sub(this);
            this.negative = 1;
            return res;
        }
        if (this.length > num.length) return this.clone().iadd(num);
        return num.clone().iadd(this);
    };
    // Subtract `num` from `this` in-place
    BN.prototype.isub = function isub(num) {
        // this - (-num) = this + num
        if (num.negative !== 0) {
            num.negative = 0;
            var r = this.iadd(num);
            num.negative = 1;
            return r._normSign();
        // -this - num = -(this + num)
        } else if (this.negative !== 0) {
            this.negative = 0;
            this.iadd(num);
            this.negative = 1;
            return this._normSign();
        }
        // At this point both numbers are positive
        var cmp = this.cmp(num);
        // Optimization - zeroify
        if (cmp === 0) {
            this.negative = 0;
            this.length = 1;
            this.words[0] = 0;
            return this;
        }
        // a > b
        var a, b;
        if (cmp > 0) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) - (b.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        // Copy rest of the words
        if (carry === 0 && i < a.length && a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = Math.max(this.length, i);
        if (a !== this) this.negative = 1;
        return this._strip();
    };
    // Subtract `num` from `this`
    BN.prototype.sub = function sub(num) {
        return this.clone().isub(num);
    };
    function smallMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        var len = self.length + num.length | 0;
        out.length = len;
        len = len - 1 | 0;
        // Peel one iteration (compiler can't do it, because of code complexity)
        var a = self.words[0] | 0;
        var b = num.words[0] | 0;
        var r = a * b;
        var lo = r & 0x3ffffff;
        var carry = r / 0x4000000 | 0;
        out.words[0] = lo;
        for(var k = 1; k < len; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = carry >>> 26;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j | 0;
                a = self.words[i] | 0;
                b = num.words[j] | 0;
                r = a * b + rword;
                ncarry += r / 0x4000000 | 0;
                rword = r & 0x3ffffff;
            }
            out.words[k] = rword | 0;
            carry = ncarry | 0;
        }
        if (carry !== 0) out.words[k] = carry | 0;
        else out.length--;
        return out._strip();
    }
    // TODO(indutny): it may be reasonable to omit it for users who don't need
    // to work with 256-bit numbers, otherwise it gives 20% improvement for 256-bit
    // multiplication (like elliptic secp256k1).
    var comb10MulTo = function comb10MulTo(self, num, out) {
        var a = self.words;
        var b = num.words;
        var o = out.words;
        var c = 0;
        var lo;
        var mid;
        var hi;
        var a0 = a[0] | 0;
        var al0 = a0 & 0x1fff;
        var ah0 = a0 >>> 13;
        var a1 = a[1] | 0;
        var al1 = a1 & 0x1fff;
        var ah1 = a1 >>> 13;
        var a2 = a[2] | 0;
        var al2 = a2 & 0x1fff;
        var ah2 = a2 >>> 13;
        var a3 = a[3] | 0;
        var al3 = a3 & 0x1fff;
        var ah3 = a3 >>> 13;
        var a4 = a[4] | 0;
        var al4 = a4 & 0x1fff;
        var ah4 = a4 >>> 13;
        var a5 = a[5] | 0;
        var al5 = a5 & 0x1fff;
        var ah5 = a5 >>> 13;
        var a6 = a[6] | 0;
        var al6 = a6 & 0x1fff;
        var ah6 = a6 >>> 13;
        var a7 = a[7] | 0;
        var al7 = a7 & 0x1fff;
        var ah7 = a7 >>> 13;
        var a8 = a[8] | 0;
        var al8 = a8 & 0x1fff;
        var ah8 = a8 >>> 13;
        var a9 = a[9] | 0;
        var al9 = a9 & 0x1fff;
        var ah9 = a9 >>> 13;
        var b0 = b[0] | 0;
        var bl0 = b0 & 0x1fff;
        var bh0 = b0 >>> 13;
        var b1 = b[1] | 0;
        var bl1 = b1 & 0x1fff;
        var bh1 = b1 >>> 13;
        var b2 = b[2] | 0;
        var bl2 = b2 & 0x1fff;
        var bh2 = b2 >>> 13;
        var b3 = b[3] | 0;
        var bl3 = b3 & 0x1fff;
        var bh3 = b3 >>> 13;
        var b4 = b[4] | 0;
        var bl4 = b4 & 0x1fff;
        var bh4 = b4 >>> 13;
        var b5 = b[5] | 0;
        var bl5 = b5 & 0x1fff;
        var bh5 = b5 >>> 13;
        var b6 = b[6] | 0;
        var bl6 = b6 & 0x1fff;
        var bh6 = b6 >>> 13;
        var b7 = b[7] | 0;
        var bl7 = b7 & 0x1fff;
        var bh7 = b7 >>> 13;
        var b8 = b[8] | 0;
        var bl8 = b8 & 0x1fff;
        var bh8 = b8 >>> 13;
        var b9 = b[9] | 0;
        var bl9 = b9 & 0x1fff;
        var bh9 = b9 >>> 13;
        out.negative = self.negative ^ num.negative;
        out.length = 19;
        /* k = 0 */ lo = Math.imul(al0, bl0);
        mid = Math.imul(al0, bh0);
        mid = mid + Math.imul(ah0, bl0) | 0;
        hi = Math.imul(ah0, bh0);
        var w0 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w0 >>> 26) | 0;
        w0 &= 0x3ffffff;
        /* k = 1 */ lo = Math.imul(al1, bl0);
        mid = Math.imul(al1, bh0);
        mid = mid + Math.imul(ah1, bl0) | 0;
        hi = Math.imul(ah1, bh0);
        lo = lo + Math.imul(al0, bl1) | 0;
        mid = mid + Math.imul(al0, bh1) | 0;
        mid = mid + Math.imul(ah0, bl1) | 0;
        hi = hi + Math.imul(ah0, bh1) | 0;
        var w1 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w1 >>> 26) | 0;
        w1 &= 0x3ffffff;
        /* k = 2 */ lo = Math.imul(al2, bl0);
        mid = Math.imul(al2, bh0);
        mid = mid + Math.imul(ah2, bl0) | 0;
        hi = Math.imul(ah2, bh0);
        lo = lo + Math.imul(al1, bl1) | 0;
        mid = mid + Math.imul(al1, bh1) | 0;
        mid = mid + Math.imul(ah1, bl1) | 0;
        hi = hi + Math.imul(ah1, bh1) | 0;
        lo = lo + Math.imul(al0, bl2) | 0;
        mid = mid + Math.imul(al0, bh2) | 0;
        mid = mid + Math.imul(ah0, bl2) | 0;
        hi = hi + Math.imul(ah0, bh2) | 0;
        var w2 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w2 >>> 26) | 0;
        w2 &= 0x3ffffff;
        /* k = 3 */ lo = Math.imul(al3, bl0);
        mid = Math.imul(al3, bh0);
        mid = mid + Math.imul(ah3, bl0) | 0;
        hi = Math.imul(ah3, bh0);
        lo = lo + Math.imul(al2, bl1) | 0;
        mid = mid + Math.imul(al2, bh1) | 0;
        mid = mid + Math.imul(ah2, bl1) | 0;
        hi = hi + Math.imul(ah2, bh1) | 0;
        lo = lo + Math.imul(al1, bl2) | 0;
        mid = mid + Math.imul(al1, bh2) | 0;
        mid = mid + Math.imul(ah1, bl2) | 0;
        hi = hi + Math.imul(ah1, bh2) | 0;
        lo = lo + Math.imul(al0, bl3) | 0;
        mid = mid + Math.imul(al0, bh3) | 0;
        mid = mid + Math.imul(ah0, bl3) | 0;
        hi = hi + Math.imul(ah0, bh3) | 0;
        var w3 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w3 >>> 26) | 0;
        w3 &= 0x3ffffff;
        /* k = 4 */ lo = Math.imul(al4, bl0);
        mid = Math.imul(al4, bh0);
        mid = mid + Math.imul(ah4, bl0) | 0;
        hi = Math.imul(ah4, bh0);
        lo = lo + Math.imul(al3, bl1) | 0;
        mid = mid + Math.imul(al3, bh1) | 0;
        mid = mid + Math.imul(ah3, bl1) | 0;
        hi = hi + Math.imul(ah3, bh1) | 0;
        lo = lo + Math.imul(al2, bl2) | 0;
        mid = mid + Math.imul(al2, bh2) | 0;
        mid = mid + Math.imul(ah2, bl2) | 0;
        hi = hi + Math.imul(ah2, bh2) | 0;
        lo = lo + Math.imul(al1, bl3) | 0;
        mid = mid + Math.imul(al1, bh3) | 0;
        mid = mid + Math.imul(ah1, bl3) | 0;
        hi = hi + Math.imul(ah1, bh3) | 0;
        lo = lo + Math.imul(al0, bl4) | 0;
        mid = mid + Math.imul(al0, bh4) | 0;
        mid = mid + Math.imul(ah0, bl4) | 0;
        hi = hi + Math.imul(ah0, bh4) | 0;
        var w4 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w4 >>> 26) | 0;
        w4 &= 0x3ffffff;
        /* k = 5 */ lo = Math.imul(al5, bl0);
        mid = Math.imul(al5, bh0);
        mid = mid + Math.imul(ah5, bl0) | 0;
        hi = Math.imul(ah5, bh0);
        lo = lo + Math.imul(al4, bl1) | 0;
        mid = mid + Math.imul(al4, bh1) | 0;
        mid = mid + Math.imul(ah4, bl1) | 0;
        hi = hi + Math.imul(ah4, bh1) | 0;
        lo = lo + Math.imul(al3, bl2) | 0;
        mid = mid + Math.imul(al3, bh2) | 0;
        mid = mid + Math.imul(ah3, bl2) | 0;
        hi = hi + Math.imul(ah3, bh2) | 0;
        lo = lo + Math.imul(al2, bl3) | 0;
        mid = mid + Math.imul(al2, bh3) | 0;
        mid = mid + Math.imul(ah2, bl3) | 0;
        hi = hi + Math.imul(ah2, bh3) | 0;
        lo = lo + Math.imul(al1, bl4) | 0;
        mid = mid + Math.imul(al1, bh4) | 0;
        mid = mid + Math.imul(ah1, bl4) | 0;
        hi = hi + Math.imul(ah1, bh4) | 0;
        lo = lo + Math.imul(al0, bl5) | 0;
        mid = mid + Math.imul(al0, bh5) | 0;
        mid = mid + Math.imul(ah0, bl5) | 0;
        hi = hi + Math.imul(ah0, bh5) | 0;
        var w5 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w5 >>> 26) | 0;
        w5 &= 0x3ffffff;
        /* k = 6 */ lo = Math.imul(al6, bl0);
        mid = Math.imul(al6, bh0);
        mid = mid + Math.imul(ah6, bl0) | 0;
        hi = Math.imul(ah6, bh0);
        lo = lo + Math.imul(al5, bl1) | 0;
        mid = mid + Math.imul(al5, bh1) | 0;
        mid = mid + Math.imul(ah5, bl1) | 0;
        hi = hi + Math.imul(ah5, bh1) | 0;
        lo = lo + Math.imul(al4, bl2) | 0;
        mid = mid + Math.imul(al4, bh2) | 0;
        mid = mid + Math.imul(ah4, bl2) | 0;
        hi = hi + Math.imul(ah4, bh2) | 0;
        lo = lo + Math.imul(al3, bl3) | 0;
        mid = mid + Math.imul(al3, bh3) | 0;
        mid = mid + Math.imul(ah3, bl3) | 0;
        hi = hi + Math.imul(ah3, bh3) | 0;
        lo = lo + Math.imul(al2, bl4) | 0;
        mid = mid + Math.imul(al2, bh4) | 0;
        mid = mid + Math.imul(ah2, bl4) | 0;
        hi = hi + Math.imul(ah2, bh4) | 0;
        lo = lo + Math.imul(al1, bl5) | 0;
        mid = mid + Math.imul(al1, bh5) | 0;
        mid = mid + Math.imul(ah1, bl5) | 0;
        hi = hi + Math.imul(ah1, bh5) | 0;
        lo = lo + Math.imul(al0, bl6) | 0;
        mid = mid + Math.imul(al0, bh6) | 0;
        mid = mid + Math.imul(ah0, bl6) | 0;
        hi = hi + Math.imul(ah0, bh6) | 0;
        var w6 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w6 >>> 26) | 0;
        w6 &= 0x3ffffff;
        /* k = 7 */ lo = Math.imul(al7, bl0);
        mid = Math.imul(al7, bh0);
        mid = mid + Math.imul(ah7, bl0) | 0;
        hi = Math.imul(ah7, bh0);
        lo = lo + Math.imul(al6, bl1) | 0;
        mid = mid + Math.imul(al6, bh1) | 0;
        mid = mid + Math.imul(ah6, bl1) | 0;
        hi = hi + Math.imul(ah6, bh1) | 0;
        lo = lo + Math.imul(al5, bl2) | 0;
        mid = mid + Math.imul(al5, bh2) | 0;
        mid = mid + Math.imul(ah5, bl2) | 0;
        hi = hi + Math.imul(ah5, bh2) | 0;
        lo = lo + Math.imul(al4, bl3) | 0;
        mid = mid + Math.imul(al4, bh3) | 0;
        mid = mid + Math.imul(ah4, bl3) | 0;
        hi = hi + Math.imul(ah4, bh3) | 0;
        lo = lo + Math.imul(al3, bl4) | 0;
        mid = mid + Math.imul(al3, bh4) | 0;
        mid = mid + Math.imul(ah3, bl4) | 0;
        hi = hi + Math.imul(ah3, bh4) | 0;
        lo = lo + Math.imul(al2, bl5) | 0;
        mid = mid + Math.imul(al2, bh5) | 0;
        mid = mid + Math.imul(ah2, bl5) | 0;
        hi = hi + Math.imul(ah2, bh5) | 0;
        lo = lo + Math.imul(al1, bl6) | 0;
        mid = mid + Math.imul(al1, bh6) | 0;
        mid = mid + Math.imul(ah1, bl6) | 0;
        hi = hi + Math.imul(ah1, bh6) | 0;
        lo = lo + Math.imul(al0, bl7) | 0;
        mid = mid + Math.imul(al0, bh7) | 0;
        mid = mid + Math.imul(ah0, bl7) | 0;
        hi = hi + Math.imul(ah0, bh7) | 0;
        var w7 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w7 >>> 26) | 0;
        w7 &= 0x3ffffff;
        /* k = 8 */ lo = Math.imul(al8, bl0);
        mid = Math.imul(al8, bh0);
        mid = mid + Math.imul(ah8, bl0) | 0;
        hi = Math.imul(ah8, bh0);
        lo = lo + Math.imul(al7, bl1) | 0;
        mid = mid + Math.imul(al7, bh1) | 0;
        mid = mid + Math.imul(ah7, bl1) | 0;
        hi = hi + Math.imul(ah7, bh1) | 0;
        lo = lo + Math.imul(al6, bl2) | 0;
        mid = mid + Math.imul(al6, bh2) | 0;
        mid = mid + Math.imul(ah6, bl2) | 0;
        hi = hi + Math.imul(ah6, bh2) | 0;
        lo = lo + Math.imul(al5, bl3) | 0;
        mid = mid + Math.imul(al5, bh3) | 0;
        mid = mid + Math.imul(ah5, bl3) | 0;
        hi = hi + Math.imul(ah5, bh3) | 0;
        lo = lo + Math.imul(al4, bl4) | 0;
        mid = mid + Math.imul(al4, bh4) | 0;
        mid = mid + Math.imul(ah4, bl4) | 0;
        hi = hi + Math.imul(ah4, bh4) | 0;
        lo = lo + Math.imul(al3, bl5) | 0;
        mid = mid + Math.imul(al3, bh5) | 0;
        mid = mid + Math.imul(ah3, bl5) | 0;
        hi = hi + Math.imul(ah3, bh5) | 0;
        lo = lo + Math.imul(al2, bl6) | 0;
        mid = mid + Math.imul(al2, bh6) | 0;
        mid = mid + Math.imul(ah2, bl6) | 0;
        hi = hi + Math.imul(ah2, bh6) | 0;
        lo = lo + Math.imul(al1, bl7) | 0;
        mid = mid + Math.imul(al1, bh7) | 0;
        mid = mid + Math.imul(ah1, bl7) | 0;
        hi = hi + Math.imul(ah1, bh7) | 0;
        lo = lo + Math.imul(al0, bl8) | 0;
        mid = mid + Math.imul(al0, bh8) | 0;
        mid = mid + Math.imul(ah0, bl8) | 0;
        hi = hi + Math.imul(ah0, bh8) | 0;
        var w8 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w8 >>> 26) | 0;
        w8 &= 0x3ffffff;
        /* k = 9 */ lo = Math.imul(al9, bl0);
        mid = Math.imul(al9, bh0);
        mid = mid + Math.imul(ah9, bl0) | 0;
        hi = Math.imul(ah9, bh0);
        lo = lo + Math.imul(al8, bl1) | 0;
        mid = mid + Math.imul(al8, bh1) | 0;
        mid = mid + Math.imul(ah8, bl1) | 0;
        hi = hi + Math.imul(ah8, bh1) | 0;
        lo = lo + Math.imul(al7, bl2) | 0;
        mid = mid + Math.imul(al7, bh2) | 0;
        mid = mid + Math.imul(ah7, bl2) | 0;
        hi = hi + Math.imul(ah7, bh2) | 0;
        lo = lo + Math.imul(al6, bl3) | 0;
        mid = mid + Math.imul(al6, bh3) | 0;
        mid = mid + Math.imul(ah6, bl3) | 0;
        hi = hi + Math.imul(ah6, bh3) | 0;
        lo = lo + Math.imul(al5, bl4) | 0;
        mid = mid + Math.imul(al5, bh4) | 0;
        mid = mid + Math.imul(ah5, bl4) | 0;
        hi = hi + Math.imul(ah5, bh4) | 0;
        lo = lo + Math.imul(al4, bl5) | 0;
        mid = mid + Math.imul(al4, bh5) | 0;
        mid = mid + Math.imul(ah4, bl5) | 0;
        hi = hi + Math.imul(ah4, bh5) | 0;
        lo = lo + Math.imul(al3, bl6) | 0;
        mid = mid + Math.imul(al3, bh6) | 0;
        mid = mid + Math.imul(ah3, bl6) | 0;
        hi = hi + Math.imul(ah3, bh6) | 0;
        lo = lo + Math.imul(al2, bl7) | 0;
        mid = mid + Math.imul(al2, bh7) | 0;
        mid = mid + Math.imul(ah2, bl7) | 0;
        hi = hi + Math.imul(ah2, bh7) | 0;
        lo = lo + Math.imul(al1, bl8) | 0;
        mid = mid + Math.imul(al1, bh8) | 0;
        mid = mid + Math.imul(ah1, bl8) | 0;
        hi = hi + Math.imul(ah1, bh8) | 0;
        lo = lo + Math.imul(al0, bl9) | 0;
        mid = mid + Math.imul(al0, bh9) | 0;
        mid = mid + Math.imul(ah0, bl9) | 0;
        hi = hi + Math.imul(ah0, bh9) | 0;
        var w9 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w9 >>> 26) | 0;
        w9 &= 0x3ffffff;
        /* k = 10 */ lo = Math.imul(al9, bl1);
        mid = Math.imul(al9, bh1);
        mid = mid + Math.imul(ah9, bl1) | 0;
        hi = Math.imul(ah9, bh1);
        lo = lo + Math.imul(al8, bl2) | 0;
        mid = mid + Math.imul(al8, bh2) | 0;
        mid = mid + Math.imul(ah8, bl2) | 0;
        hi = hi + Math.imul(ah8, bh2) | 0;
        lo = lo + Math.imul(al7, bl3) | 0;
        mid = mid + Math.imul(al7, bh3) | 0;
        mid = mid + Math.imul(ah7, bl3) | 0;
        hi = hi + Math.imul(ah7, bh3) | 0;
        lo = lo + Math.imul(al6, bl4) | 0;
        mid = mid + Math.imul(al6, bh4) | 0;
        mid = mid + Math.imul(ah6, bl4) | 0;
        hi = hi + Math.imul(ah6, bh4) | 0;
        lo = lo + Math.imul(al5, bl5) | 0;
        mid = mid + Math.imul(al5, bh5) | 0;
        mid = mid + Math.imul(ah5, bl5) | 0;
        hi = hi + Math.imul(ah5, bh5) | 0;
        lo = lo + Math.imul(al4, bl6) | 0;
        mid = mid + Math.imul(al4, bh6) | 0;
        mid = mid + Math.imul(ah4, bl6) | 0;
        hi = hi + Math.imul(ah4, bh6) | 0;
        lo = lo + Math.imul(al3, bl7) | 0;
        mid = mid + Math.imul(al3, bh7) | 0;
        mid = mid + Math.imul(ah3, bl7) | 0;
        hi = hi + Math.imul(ah3, bh7) | 0;
        lo = lo + Math.imul(al2, bl8) | 0;
        mid = mid + Math.imul(al2, bh8) | 0;
        mid = mid + Math.imul(ah2, bl8) | 0;
        hi = hi + Math.imul(ah2, bh8) | 0;
        lo = lo + Math.imul(al1, bl9) | 0;
        mid = mid + Math.imul(al1, bh9) | 0;
        mid = mid + Math.imul(ah1, bl9) | 0;
        hi = hi + Math.imul(ah1, bh9) | 0;
        var w10 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w10 >>> 26) | 0;
        w10 &= 0x3ffffff;
        /* k = 11 */ lo = Math.imul(al9, bl2);
        mid = Math.imul(al9, bh2);
        mid = mid + Math.imul(ah9, bl2) | 0;
        hi = Math.imul(ah9, bh2);
        lo = lo + Math.imul(al8, bl3) | 0;
        mid = mid + Math.imul(al8, bh3) | 0;
        mid = mid + Math.imul(ah8, bl3) | 0;
        hi = hi + Math.imul(ah8, bh3) | 0;
        lo = lo + Math.imul(al7, bl4) | 0;
        mid = mid + Math.imul(al7, bh4) | 0;
        mid = mid + Math.imul(ah7, bl4) | 0;
        hi = hi + Math.imul(ah7, bh4) | 0;
        lo = lo + Math.imul(al6, bl5) | 0;
        mid = mid + Math.imul(al6, bh5) | 0;
        mid = mid + Math.imul(ah6, bl5) | 0;
        hi = hi + Math.imul(ah6, bh5) | 0;
        lo = lo + Math.imul(al5, bl6) | 0;
        mid = mid + Math.imul(al5, bh6) | 0;
        mid = mid + Math.imul(ah5, bl6) | 0;
        hi = hi + Math.imul(ah5, bh6) | 0;
        lo = lo + Math.imul(al4, bl7) | 0;
        mid = mid + Math.imul(al4, bh7) | 0;
        mid = mid + Math.imul(ah4, bl7) | 0;
        hi = hi + Math.imul(ah4, bh7) | 0;
        lo = lo + Math.imul(al3, bl8) | 0;
        mid = mid + Math.imul(al3, bh8) | 0;
        mid = mid + Math.imul(ah3, bl8) | 0;
        hi = hi + Math.imul(ah3, bh8) | 0;
        lo = lo + Math.imul(al2, bl9) | 0;
        mid = mid + Math.imul(al2, bh9) | 0;
        mid = mid + Math.imul(ah2, bl9) | 0;
        hi = hi + Math.imul(ah2, bh9) | 0;
        var w11 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w11 >>> 26) | 0;
        w11 &= 0x3ffffff;
        /* k = 12 */ lo = Math.imul(al9, bl3);
        mid = Math.imul(al9, bh3);
        mid = mid + Math.imul(ah9, bl3) | 0;
        hi = Math.imul(ah9, bh3);
        lo = lo + Math.imul(al8, bl4) | 0;
        mid = mid + Math.imul(al8, bh4) | 0;
        mid = mid + Math.imul(ah8, bl4) | 0;
        hi = hi + Math.imul(ah8, bh4) | 0;
        lo = lo + Math.imul(al7, bl5) | 0;
        mid = mid + Math.imul(al7, bh5) | 0;
        mid = mid + Math.imul(ah7, bl5) | 0;
        hi = hi + Math.imul(ah7, bh5) | 0;
        lo = lo + Math.imul(al6, bl6) | 0;
        mid = mid + Math.imul(al6, bh6) | 0;
        mid = mid + Math.imul(ah6, bl6) | 0;
        hi = hi + Math.imul(ah6, bh6) | 0;
        lo = lo + Math.imul(al5, bl7) | 0;
        mid = mid + Math.imul(al5, bh7) | 0;
        mid = mid + Math.imul(ah5, bl7) | 0;
        hi = hi + Math.imul(ah5, bh7) | 0;
        lo = lo + Math.imul(al4, bl8) | 0;
        mid = mid + Math.imul(al4, bh8) | 0;
        mid = mid + Math.imul(ah4, bl8) | 0;
        hi = hi + Math.imul(ah4, bh8) | 0;
        lo = lo + Math.imul(al3, bl9) | 0;
        mid = mid + Math.imul(al3, bh9) | 0;
        mid = mid + Math.imul(ah3, bl9) | 0;
        hi = hi + Math.imul(ah3, bh9) | 0;
        var w12 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w12 >>> 26) | 0;
        w12 &= 0x3ffffff;
        /* k = 13 */ lo = Math.imul(al9, bl4);
        mid = Math.imul(al9, bh4);
        mid = mid + Math.imul(ah9, bl4) | 0;
        hi = Math.imul(ah9, bh4);
        lo = lo + Math.imul(al8, bl5) | 0;
        mid = mid + Math.imul(al8, bh5) | 0;
        mid = mid + Math.imul(ah8, bl5) | 0;
        hi = hi + Math.imul(ah8, bh5) | 0;
        lo = lo + Math.imul(al7, bl6) | 0;
        mid = mid + Math.imul(al7, bh6) | 0;
        mid = mid + Math.imul(ah7, bl6) | 0;
        hi = hi + Math.imul(ah7, bh6) | 0;
        lo = lo + Math.imul(al6, bl7) | 0;
        mid = mid + Math.imul(al6, bh7) | 0;
        mid = mid + Math.imul(ah6, bl7) | 0;
        hi = hi + Math.imul(ah6, bh7) | 0;
        lo = lo + Math.imul(al5, bl8) | 0;
        mid = mid + Math.imul(al5, bh8) | 0;
        mid = mid + Math.imul(ah5, bl8) | 0;
        hi = hi + Math.imul(ah5, bh8) | 0;
        lo = lo + Math.imul(al4, bl9) | 0;
        mid = mid + Math.imul(al4, bh9) | 0;
        mid = mid + Math.imul(ah4, bl9) | 0;
        hi = hi + Math.imul(ah4, bh9) | 0;
        var w13 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w13 >>> 26) | 0;
        w13 &= 0x3ffffff;
        /* k = 14 */ lo = Math.imul(al9, bl5);
        mid = Math.imul(al9, bh5);
        mid = mid + Math.imul(ah9, bl5) | 0;
        hi = Math.imul(ah9, bh5);
        lo = lo + Math.imul(al8, bl6) | 0;
        mid = mid + Math.imul(al8, bh6) | 0;
        mid = mid + Math.imul(ah8, bl6) | 0;
        hi = hi + Math.imul(ah8, bh6) | 0;
        lo = lo + Math.imul(al7, bl7) | 0;
        mid = mid + Math.imul(al7, bh7) | 0;
        mid = mid + Math.imul(ah7, bl7) | 0;
        hi = hi + Math.imul(ah7, bh7) | 0;
        lo = lo + Math.imul(al6, bl8) | 0;
        mid = mid + Math.imul(al6, bh8) | 0;
        mid = mid + Math.imul(ah6, bl8) | 0;
        hi = hi + Math.imul(ah6, bh8) | 0;
        lo = lo + Math.imul(al5, bl9) | 0;
        mid = mid + Math.imul(al5, bh9) | 0;
        mid = mid + Math.imul(ah5, bl9) | 0;
        hi = hi + Math.imul(ah5, bh9) | 0;
        var w14 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w14 >>> 26) | 0;
        w14 &= 0x3ffffff;
        /* k = 15 */ lo = Math.imul(al9, bl6);
        mid = Math.imul(al9, bh6);
        mid = mid + Math.imul(ah9, bl6) | 0;
        hi = Math.imul(ah9, bh6);
        lo = lo + Math.imul(al8, bl7) | 0;
        mid = mid + Math.imul(al8, bh7) | 0;
        mid = mid + Math.imul(ah8, bl7) | 0;
        hi = hi + Math.imul(ah8, bh7) | 0;
        lo = lo + Math.imul(al7, bl8) | 0;
        mid = mid + Math.imul(al7, bh8) | 0;
        mid = mid + Math.imul(ah7, bl8) | 0;
        hi = hi + Math.imul(ah7, bh8) | 0;
        lo = lo + Math.imul(al6, bl9) | 0;
        mid = mid + Math.imul(al6, bh9) | 0;
        mid = mid + Math.imul(ah6, bl9) | 0;
        hi = hi + Math.imul(ah6, bh9) | 0;
        var w15 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w15 >>> 26) | 0;
        w15 &= 0x3ffffff;
        /* k = 16 */ lo = Math.imul(al9, bl7);
        mid = Math.imul(al9, bh7);
        mid = mid + Math.imul(ah9, bl7) | 0;
        hi = Math.imul(ah9, bh7);
        lo = lo + Math.imul(al8, bl8) | 0;
        mid = mid + Math.imul(al8, bh8) | 0;
        mid = mid + Math.imul(ah8, bl8) | 0;
        hi = hi + Math.imul(ah8, bh8) | 0;
        lo = lo + Math.imul(al7, bl9) | 0;
        mid = mid + Math.imul(al7, bh9) | 0;
        mid = mid + Math.imul(ah7, bl9) | 0;
        hi = hi + Math.imul(ah7, bh9) | 0;
        var w16 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w16 >>> 26) | 0;
        w16 &= 0x3ffffff;
        /* k = 17 */ lo = Math.imul(al9, bl8);
        mid = Math.imul(al9, bh8);
        mid = mid + Math.imul(ah9, bl8) | 0;
        hi = Math.imul(ah9, bh8);
        lo = lo + Math.imul(al8, bl9) | 0;
        mid = mid + Math.imul(al8, bh9) | 0;
        mid = mid + Math.imul(ah8, bl9) | 0;
        hi = hi + Math.imul(ah8, bh9) | 0;
        var w17 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w17 >>> 26) | 0;
        w17 &= 0x3ffffff;
        /* k = 18 */ lo = Math.imul(al9, bl9);
        mid = Math.imul(al9, bh9);
        mid = mid + Math.imul(ah9, bl9) | 0;
        hi = Math.imul(ah9, bh9);
        var w18 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w18 >>> 26) | 0;
        w18 &= 0x3ffffff;
        o[0] = w0;
        o[1] = w1;
        o[2] = w2;
        o[3] = w3;
        o[4] = w4;
        o[5] = w5;
        o[6] = w6;
        o[7] = w7;
        o[8] = w8;
        o[9] = w9;
        o[10] = w10;
        o[11] = w11;
        o[12] = w12;
        o[13] = w13;
        o[14] = w14;
        o[15] = w15;
        o[16] = w16;
        o[17] = w17;
        o[18] = w18;
        if (c !== 0) {
            o[19] = c;
            out.length++;
        }
        return out;
    };
    // Polyfill comb
    if (!Math.imul) comb10MulTo = smallMulTo;
    function bigMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        out.length = self.length + num.length;
        var carry = 0;
        var hncarry = 0;
        for(var k = 0; k < out.length - 1; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = hncarry;
            hncarry = 0;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j;
                var a = self.words[i] | 0;
                var b = num.words[j] | 0;
                var r = a * b;
                var lo = r & 0x3ffffff;
                ncarry = ncarry + (r / 0x4000000 | 0) | 0;
                lo = lo + rword | 0;
                rword = lo & 0x3ffffff;
                ncarry = ncarry + (lo >>> 26) | 0;
                hncarry += ncarry >>> 26;
                ncarry &= 0x3ffffff;
            }
            out.words[k] = rword;
            carry = ncarry;
            ncarry = hncarry;
        }
        if (carry !== 0) out.words[k] = carry;
        else out.length--;
        return out._strip();
    }
    function jumboMulTo(self, num, out) {
        // Temporary disable, see https://github.com/indutny/bn.js/issues/211
        // var fftm = new FFTM();
        // return fftm.mulp(self, num, out);
        return bigMulTo(self, num, out);
    }
    BN.prototype.mulTo = function mulTo(num, out) {
        var res;
        var len = this.length + num.length;
        if (this.length === 10 && num.length === 10) res = comb10MulTo(this, num, out);
        else if (len < 63) res = smallMulTo(this, num, out);
        else if (len < 1024) res = bigMulTo(this, num, out);
        else res = jumboMulTo(this, num, out);
        return res;
    };
    // Cooley-Tukey algorithm for FFT
    // slightly revisited to rely on looping instead of recursion
    function FFTM(x, y) {
        this.x = x;
        this.y = y;
    }
    FFTM.prototype.makeRBT = function makeRBT(N) {
        var t = new Array(N);
        var l = BN.prototype._countBits(N) - 1;
        for(var i = 0; i < N; i++)t[i] = this.revBin(i, l, N);
        return t;
    };
    // Returns binary-reversed representation of `x`
    FFTM.prototype.revBin = function revBin(x, l, N) {
        if (x === 0 || x === N - 1) return x;
        var rb = 0;
        for(var i = 0; i < l; i++){
            rb |= (x & 1) << l - i - 1;
            x >>= 1;
        }
        return rb;
    };
    // Performs "tweedling" phase, therefore 'emulating'
    // behaviour of the recursive algorithm
    FFTM.prototype.permute = function permute(rbt, rws, iws, rtws, itws, N) {
        for(var i = 0; i < N; i++){
            rtws[i] = rws[rbt[i]];
            itws[i] = iws[rbt[i]];
        }
    };
    FFTM.prototype.transform = function transform(rws, iws, rtws, itws, N, rbt) {
        this.permute(rbt, rws, iws, rtws, itws, N);
        for(var s = 1; s < N; s <<= 1){
            var l = s << 1;
            var rtwdf = Math.cos(2 * Math.PI / l);
            var itwdf = Math.sin(2 * Math.PI / l);
            for(var p = 0; p < N; p += l){
                var rtwdf_ = rtwdf;
                var itwdf_ = itwdf;
                for(var j = 0; j < s; j++){
                    var re = rtws[p + j];
                    var ie = itws[p + j];
                    var ro = rtws[p + j + s];
                    var io = itws[p + j + s];
                    var rx = rtwdf_ * ro - itwdf_ * io;
                    io = rtwdf_ * io + itwdf_ * ro;
                    ro = rx;
                    rtws[p + j] = re + ro;
                    itws[p + j] = ie + io;
                    rtws[p + j + s] = re - ro;
                    itws[p + j + s] = ie - io;
                    /* jshint maxdepth : false */ if (j !== l) {
                        rx = rtwdf * rtwdf_ - itwdf * itwdf_;
                        itwdf_ = rtwdf * itwdf_ + itwdf * rtwdf_;
                        rtwdf_ = rx;
                    }
                }
            }
        }
    };
    FFTM.prototype.guessLen13b = function guessLen13b(n, m) {
        var N = Math.max(m, n) | 1;
        var odd = N & 1;
        var i = 0;
        for(N = N / 2 | 0; N; N = N >>> 1)i++;
        return 1 << i + 1 + odd;
    };
    FFTM.prototype.conjugate = function conjugate(rws, iws, N) {
        if (N <= 1) return;
        for(var i = 0; i < N / 2; i++){
            var t = rws[i];
            rws[i] = rws[N - i - 1];
            rws[N - i - 1] = t;
            t = iws[i];
            iws[i] = -iws[N - i - 1];
            iws[N - i - 1] = -t;
        }
    };
    FFTM.prototype.normalize13b = function normalize13b(ws, N) {
        var carry = 0;
        for(var i = 0; i < N / 2; i++){
            var w = Math.round(ws[2 * i + 1] / N) * 0x2000 + Math.round(ws[2 * i] / N) + carry;
            ws[i] = w & 0x3ffffff;
            if (w < 0x4000000) carry = 0;
            else carry = w / 0x4000000 | 0;
        }
        return ws;
    };
    FFTM.prototype.convert13b = function convert13b(ws, len, rws, N) {
        var carry = 0;
        for(var i = 0; i < len; i++){
            carry = carry + (ws[i] | 0);
            rws[2 * i] = carry & 0x1fff;
            carry = carry >>> 13;
            rws[2 * i + 1] = carry & 0x1fff;
            carry = carry >>> 13;
        }
        // Pad with zeroes
        for(i = 2 * len; i < N; ++i)rws[i] = 0;
        assert(carry === 0);
        assert((carry & -8192) === 0);
    };
    FFTM.prototype.stub = function stub(N) {
        var ph = new Array(N);
        for(var i = 0; i < N; i++)ph[i] = 0;
        return ph;
    };
    FFTM.prototype.mulp = function mulp(x, y, out) {
        var N = 2 * this.guessLen13b(x.length, y.length);
        var rbt = this.makeRBT(N);
        var _ = this.stub(N);
        var rws = new Array(N);
        var rwst = new Array(N);
        var iwst = new Array(N);
        var nrws = new Array(N);
        var nrwst = new Array(N);
        var niwst = new Array(N);
        var rmws = out.words;
        rmws.length = N;
        this.convert13b(x.words, x.length, rws, N);
        this.convert13b(y.words, y.length, nrws, N);
        this.transform(rws, _, rwst, iwst, N, rbt);
        this.transform(nrws, _, nrwst, niwst, N, rbt);
        for(var i = 0; i < N; i++){
            var rx = rwst[i] * nrwst[i] - iwst[i] * niwst[i];
            iwst[i] = rwst[i] * niwst[i] + iwst[i] * nrwst[i];
            rwst[i] = rx;
        }
        this.conjugate(rwst, iwst, N);
        this.transform(rwst, iwst, rmws, _, N, rbt);
        this.conjugate(rmws, _, N);
        this.normalize13b(rmws, N);
        out.negative = x.negative ^ y.negative;
        out.length = x.length + y.length;
        return out._strip();
    };
    // Multiply `this` by `num`
    BN.prototype.mul = function mul(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return this.mulTo(num, out);
    };
    // Multiply employing FFT
    BN.prototype.mulf = function mulf(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return jumboMulTo(this, num, out);
    };
    // In-place Multiplication
    BN.prototype.imul = function imul(num) {
        return this.clone().mulTo(num, this);
    };
    BN.prototype.imuln = function imuln(num) {
        var isNegNum = num < 0;
        if (isNegNum) num = -num;
        assert(typeof num === "number");
        assert(num < 0x4000000);
        // Carry
        var carry = 0;
        for(var i = 0; i < this.length; i++){
            var w = (this.words[i] | 0) * num;
            var lo = (w & 0x3ffffff) + (carry & 0x3ffffff);
            carry >>= 26;
            carry += w / 0x4000000 | 0;
            // NOTE: lo is 27bit maximum
            carry += lo >>> 26;
            this.words[i] = lo & 0x3ffffff;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return isNegNum ? this.ineg() : this;
    };
    BN.prototype.muln = function muln(num) {
        return this.clone().imuln(num);
    };
    // `this` * `this`
    BN.prototype.sqr = function sqr() {
        return this.mul(this);
    };
    // `this` * `this` in-place
    BN.prototype.isqr = function isqr() {
        return this.imul(this.clone());
    };
    // Math.pow(`this`, `num`)
    BN.prototype.pow = function pow(num) {
        var w = toBitArray(num);
        if (w.length === 0) return new BN(1);
        // Skip leading zeroes
        var res = this;
        for(var i = 0; i < w.length; i++, res = res.sqr()){
            if (w[i] !== 0) break;
        }
        if (++i < w.length) for(var q = res.sqr(); i < w.length; i++, q = q.sqr()){
            if (w[i] === 0) continue;
            res = res.mul(q);
        }
        return res;
    };
    // Shift-left in-place
    BN.prototype.iushln = function iushln(bits) {
        assert(typeof bits === "number" && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        var carryMask = 0x3ffffff >>> 26 - r << 26 - r;
        var i;
        if (r !== 0) {
            var carry = 0;
            for(i = 0; i < this.length; i++){
                var newCarry = this.words[i] & carryMask;
                var c = (this.words[i] | 0) - newCarry << r;
                this.words[i] = c | carry;
                carry = newCarry >>> 26 - r;
            }
            if (carry) {
                this.words[i] = carry;
                this.length++;
            }
        }
        if (s !== 0) {
            for(i = this.length - 1; i >= 0; i--)this.words[i + s] = this.words[i];
            for(i = 0; i < s; i++)this.words[i] = 0;
            this.length += s;
        }
        return this._strip();
    };
    BN.prototype.ishln = function ishln(bits) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushln(bits);
    };
    // Shift-right in-place
    // NOTE: `hint` is a lowest bit before trailing zeroes
    // NOTE: if `extended` is present - it will be filled with destroyed bits
    BN.prototype.iushrn = function iushrn(bits, hint, extended) {
        assert(typeof bits === "number" && bits >= 0);
        var h;
        if (hint) h = (hint - hint % 26) / 26;
        else h = 0;
        var r = bits % 26;
        var s = Math.min((bits - r) / 26, this.length);
        var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
        var maskedWords = extended;
        h -= s;
        h = Math.max(0, h);
        // Extended mode, copy masked part
        if (maskedWords) {
            for(var i = 0; i < s; i++)maskedWords.words[i] = this.words[i];
            maskedWords.length = s;
        }
        if (s === 0) ;
        else if (this.length > s) {
            this.length -= s;
            for(i = 0; i < this.length; i++)this.words[i] = this.words[i + s];
        } else {
            this.words[0] = 0;
            this.length = 1;
        }
        var carry = 0;
        for(i = this.length - 1; i >= 0 && (carry !== 0 || i >= h); i--){
            var word = this.words[i] | 0;
            this.words[i] = carry << 26 - r | word >>> r;
            carry = word & mask;
        }
        // Push carried bits as a mask
        if (maskedWords && carry !== 0) maskedWords.words[maskedWords.length++] = carry;
        if (this.length === 0) {
            this.words[0] = 0;
            this.length = 1;
        }
        return this._strip();
    };
    BN.prototype.ishrn = function ishrn(bits, hint, extended) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushrn(bits, hint, extended);
    };
    // Shift-left
    BN.prototype.shln = function shln(bits) {
        return this.clone().ishln(bits);
    };
    BN.prototype.ushln = function ushln(bits) {
        return this.clone().iushln(bits);
    };
    // Shift-right
    BN.prototype.shrn = function shrn(bits) {
        return this.clone().ishrn(bits);
    };
    BN.prototype.ushrn = function ushrn(bits) {
        return this.clone().iushrn(bits);
    };
    // Test if n bit is set
    BN.prototype.testn = function testn(bit) {
        assert(typeof bit === "number" && bit >= 0);
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) return false;
        // Check bit and return
        var w = this.words[s];
        return !!(w & q);
    };
    // Return only lowers bits of number (in-place)
    BN.prototype.imaskn = function imaskn(bits) {
        assert(typeof bits === "number" && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        assert(this.negative === 0, "imaskn works only with positive numbers");
        if (this.length <= s) return this;
        if (r !== 0) s++;
        this.length = Math.min(s, this.length);
        if (r !== 0) {
            var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
            this.words[this.length - 1] &= mask;
        }
        return this._strip();
    };
    // Return only lowers bits of number
    BN.prototype.maskn = function maskn(bits) {
        return this.clone().imaskn(bits);
    };
    // Add plain number `num` to `this`
    BN.prototype.iaddn = function iaddn(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        if (num < 0) return this.isubn(-num);
        // Possible sign change
        if (this.negative !== 0) {
            if (this.length === 1 && (this.words[0] | 0) <= num) {
                this.words[0] = num - (this.words[0] | 0);
                this.negative = 0;
                return this;
            }
            this.negative = 0;
            this.isubn(num);
            this.negative = 1;
            return this;
        }
        // Add without checks
        return this._iaddn(num);
    };
    BN.prototype._iaddn = function _iaddn(num) {
        this.words[0] += num;
        // Carry
        for(var i = 0; i < this.length && this.words[i] >= 0x4000000; i++){
            this.words[i] -= 0x4000000;
            if (i === this.length - 1) this.words[i + 1] = 1;
            else this.words[i + 1]++;
        }
        this.length = Math.max(this.length, i + 1);
        return this;
    };
    // Subtract plain number `num` from `this`
    BN.prototype.isubn = function isubn(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        if (num < 0) return this.iaddn(-num);
        if (this.negative !== 0) {
            this.negative = 0;
            this.iaddn(num);
            this.negative = 1;
            return this;
        }
        this.words[0] -= num;
        if (this.length === 1 && this.words[0] < 0) {
            this.words[0] = -this.words[0];
            this.negative = 1;
        } else // Carry
        for(var i = 0; i < this.length && this.words[i] < 0; i++){
            this.words[i] += 0x4000000;
            this.words[i + 1] -= 1;
        }
        return this._strip();
    };
    BN.prototype.addn = function addn(num) {
        return this.clone().iaddn(num);
    };
    BN.prototype.subn = function subn(num) {
        return this.clone().isubn(num);
    };
    BN.prototype.iabs = function iabs() {
        this.negative = 0;
        return this;
    };
    BN.prototype.abs = function abs() {
        return this.clone().iabs();
    };
    BN.prototype._ishlnsubmul = function _ishlnsubmul(num, mul, shift) {
        var len = num.length + shift;
        var i;
        this._expand(len);
        var w;
        var carry = 0;
        for(i = 0; i < num.length; i++){
            w = (this.words[i + shift] | 0) + carry;
            var right = (num.words[i] | 0) * mul;
            w -= right & 0x3ffffff;
            carry = (w >> 26) - (right / 0x4000000 | 0);
            this.words[i + shift] = w & 0x3ffffff;
        }
        for(; i < this.length - shift; i++){
            w = (this.words[i + shift] | 0) + carry;
            carry = w >> 26;
            this.words[i + shift] = w & 0x3ffffff;
        }
        if (carry === 0) return this._strip();
        // Subtraction overflow
        assert(carry === -1);
        carry = 0;
        for(i = 0; i < this.length; i++){
            w = -(this.words[i] | 0) + carry;
            carry = w >> 26;
            this.words[i] = w & 0x3ffffff;
        }
        this.negative = 1;
        return this._strip();
    };
    BN.prototype._wordDiv = function _wordDiv(num, mode) {
        var shift = this.length - num.length;
        var a = this.clone();
        var b = num;
        // Normalize
        var bhi = b.words[b.length - 1] | 0;
        var bhiBits = this._countBits(bhi);
        shift = 26 - bhiBits;
        if (shift !== 0) {
            b = b.ushln(shift);
            a.iushln(shift);
            bhi = b.words[b.length - 1] | 0;
        }
        // Initialize quotient
        var m = a.length - b.length;
        var q;
        if (mode !== "mod") {
            q = new BN(null);
            q.length = m + 1;
            q.words = new Array(q.length);
            for(var i = 0; i < q.length; i++)q.words[i] = 0;
        }
        var diff = a.clone()._ishlnsubmul(b, 1, m);
        if (diff.negative === 0) {
            a = diff;
            if (q) q.words[m] = 1;
        }
        for(var j = m - 1; j >= 0; j--){
            var qj = (a.words[b.length + j] | 0) * 0x4000000 + (a.words[b.length + j - 1] | 0);
            // NOTE: (qj / bhi) is (0x3ffffff * 0x4000000 + 0x3ffffff) / 0x2000000 max
            // (0x7ffffff)
            qj = Math.min(qj / bhi | 0, 0x3ffffff);
            a._ishlnsubmul(b, qj, j);
            while(a.negative !== 0){
                qj--;
                a.negative = 0;
                a._ishlnsubmul(b, 1, j);
                if (!a.isZero()) a.negative ^= 1;
            }
            if (q) q.words[j] = qj;
        }
        if (q) q._strip();
        a._strip();
        // Denormalize
        if (mode !== "div" && shift !== 0) a.iushrn(shift);
        return {
            div: q || null,
            mod: a
        };
    };
    // NOTE: 1) `mode` can be set to `mod` to request mod only,
    //       to `div` to request div only, or be absent to
    //       request both div & mod
    //       2) `positive` is true if unsigned mod is requested
    BN.prototype.divmod = function divmod(num, mode, positive) {
        assert(!num.isZero());
        if (this.isZero()) return {
            div: new BN(0),
            mod: new BN(0)
        };
        var div, mod, res;
        if (this.negative !== 0 && num.negative === 0) {
            res = this.neg().divmod(num, mode);
            if (mode !== "mod") div = res.div.neg();
            if (mode !== "div") {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.iadd(num);
            }
            return {
                div: div,
                mod: mod
            };
        }
        if (this.negative === 0 && num.negative !== 0) {
            res = this.divmod(num.neg(), mode);
            if (mode !== "mod") div = res.div.neg();
            return {
                div: div,
                mod: res.mod
            };
        }
        if ((this.negative & num.negative) !== 0) {
            res = this.neg().divmod(num.neg(), mode);
            if (mode !== "div") {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.isub(num);
            }
            return {
                div: res.div,
                mod: mod
            };
        }
        // Both numbers are positive at this point
        // Strip both numbers to approximate shift value
        if (num.length > this.length || this.cmp(num) < 0) return {
            div: new BN(0),
            mod: this
        };
        // Very short reduction
        if (num.length === 1) {
            if (mode === "div") return {
                div: this.divn(num.words[0]),
                mod: null
            };
            if (mode === "mod") return {
                div: null,
                mod: new BN(this.modrn(num.words[0]))
            };
            return {
                div: this.divn(num.words[0]),
                mod: new BN(this.modrn(num.words[0]))
            };
        }
        return this._wordDiv(num, mode);
    };
    // Find `this` / `num`
    BN.prototype.div = function div(num) {
        return this.divmod(num, "div", false).div;
    };
    // Find `this` % `num`
    BN.prototype.mod = function mod(num) {
        return this.divmod(num, "mod", false).mod;
    };
    BN.prototype.umod = function umod(num) {
        return this.divmod(num, "mod", true).mod;
    };
    // Find Round(`this` / `num`)
    BN.prototype.divRound = function divRound(num) {
        var dm = this.divmod(num);
        // Fast case - exact division
        if (dm.mod.isZero()) return dm.div;
        var mod = dm.div.negative !== 0 ? dm.mod.isub(num) : dm.mod;
        var half = num.ushrn(1);
        var r2 = num.andln(1);
        var cmp = mod.cmp(half);
        // Round down
        if (cmp < 0 || r2 === 1 && cmp === 0) return dm.div;
        // Round up
        return dm.div.negative !== 0 ? dm.div.isubn(1) : dm.div.iaddn(1);
    };
    BN.prototype.modrn = function modrn(num) {
        var isNegNum = num < 0;
        if (isNegNum) num = -num;
        assert(num <= 0x3ffffff);
        var p = 67108864 % num;
        var acc = 0;
        for(var i = this.length - 1; i >= 0; i--)acc = (p * acc + (this.words[i] | 0)) % num;
        return isNegNum ? -acc : acc;
    };
    // WARNING: DEPRECATED
    BN.prototype.modn = function modn(num) {
        return this.modrn(num);
    };
    // In-place division by number
    BN.prototype.idivn = function idivn(num) {
        var isNegNum = num < 0;
        if (isNegNum) num = -num;
        assert(num <= 0x3ffffff);
        var carry = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var w = (this.words[i] | 0) + carry * 0x4000000;
            this.words[i] = w / num | 0;
            carry = w % num;
        }
        this._strip();
        return isNegNum ? this.ineg() : this;
    };
    BN.prototype.divn = function divn(num) {
        return this.clone().idivn(num);
    };
    BN.prototype.egcd = function egcd(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var x = this;
        var y = p.clone();
        if (x.negative !== 0) x = x.umod(p);
        else x = x.clone();
        // A * x + B * y = x
        var A = new BN(1);
        var B = new BN(0);
        // C * x + D * y = y
        var C = new BN(0);
        var D = new BN(1);
        var g = 0;
        while(x.isEven() && y.isEven()){
            x.iushrn(1);
            y.iushrn(1);
            ++g;
        }
        var yp = y.clone();
        var xp = x.clone();
        while(!x.isZero()){
            for(var i = 0, im = 1; (x.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                x.iushrn(i);
                while(i-- > 0){
                    if (A.isOdd() || B.isOdd()) {
                        A.iadd(yp);
                        B.isub(xp);
                    }
                    A.iushrn(1);
                    B.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (y.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                y.iushrn(j);
                while(j-- > 0){
                    if (C.isOdd() || D.isOdd()) {
                        C.iadd(yp);
                        D.isub(xp);
                    }
                    C.iushrn(1);
                    D.iushrn(1);
                }
            }
            if (x.cmp(y) >= 0) {
                x.isub(y);
                A.isub(C);
                B.isub(D);
            } else {
                y.isub(x);
                C.isub(A);
                D.isub(B);
            }
        }
        return {
            a: C,
            b: D,
            gcd: y.iushln(g)
        };
    };
    // This is reduced incarnation of the binary EEA
    // above, designated to invert members of the
    // _prime_ fields F(p) at a maximal speed
    BN.prototype._invmp = function _invmp(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var a = this;
        var b = p.clone();
        if (a.negative !== 0) a = a.umod(p);
        else a = a.clone();
        var x1 = new BN(1);
        var x2 = new BN(0);
        var delta = b.clone();
        while(a.cmpn(1) > 0 && b.cmpn(1) > 0){
            for(var i = 0, im = 1; (a.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                a.iushrn(i);
                while(i-- > 0){
                    if (x1.isOdd()) x1.iadd(delta);
                    x1.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (b.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                b.iushrn(j);
                while(j-- > 0){
                    if (x2.isOdd()) x2.iadd(delta);
                    x2.iushrn(1);
                }
            }
            if (a.cmp(b) >= 0) {
                a.isub(b);
                x1.isub(x2);
            } else {
                b.isub(a);
                x2.isub(x1);
            }
        }
        var res;
        if (a.cmpn(1) === 0) res = x1;
        else res = x2;
        if (res.cmpn(0) < 0) res.iadd(p);
        return res;
    };
    BN.prototype.gcd = function gcd(num) {
        if (this.isZero()) return num.abs();
        if (num.isZero()) return this.abs();
        var a = this.clone();
        var b = num.clone();
        a.negative = 0;
        b.negative = 0;
        // Remove common factor of two
        for(var shift = 0; a.isEven() && b.isEven(); shift++){
            a.iushrn(1);
            b.iushrn(1);
        }
        do {
            while(a.isEven())a.iushrn(1);
            while(b.isEven())b.iushrn(1);
            var r = a.cmp(b);
            if (r < 0) {
                // Swap `a` and `b` to make `a` always bigger than `b`
                var t = a;
                a = b;
                b = t;
            } else if (r === 0 || b.cmpn(1) === 0) break;
            a.isub(b);
        }while (true);
        return b.iushln(shift);
    };
    // Invert number in the field F(num)
    BN.prototype.invm = function invm(num) {
        return this.egcd(num).a.umod(num);
    };
    BN.prototype.isEven = function isEven() {
        return (this.words[0] & 1) === 0;
    };
    BN.prototype.isOdd = function isOdd() {
        return (this.words[0] & 1) === 1;
    };
    // And first word and num
    BN.prototype.andln = function andln(num) {
        return this.words[0] & num;
    };
    // Increment at the bit position in-line
    BN.prototype.bincn = function bincn(bit) {
        assert(typeof bit === "number");
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) {
            this._expand(s + 1);
            this.words[s] |= q;
            return this;
        }
        // Add bit and propagate, if needed
        var carry = q;
        for(var i = s; carry !== 0 && i < this.length; i++){
            var w = this.words[i] | 0;
            w += carry;
            carry = w >>> 26;
            w &= 0x3ffffff;
            this.words[i] = w;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return this;
    };
    BN.prototype.isZero = function isZero() {
        return this.length === 1 && this.words[0] === 0;
    };
    BN.prototype.cmpn = function cmpn(num) {
        var negative = num < 0;
        if (this.negative !== 0 && !negative) return -1;
        if (this.negative === 0 && negative) return 1;
        this._strip();
        var res;
        if (this.length > 1) res = 1;
        else {
            if (negative) num = -num;
            assert(num <= 0x3ffffff, "Number is too big");
            var w = this.words[0] | 0;
            res = w === num ? 0 : w < num ? -1 : 1;
        }
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Compare two numbers and return:
    // 1 - if `this` > `num`
    // 0 - if `this` == `num`
    // -1 - if `this` < `num`
    BN.prototype.cmp = function cmp(num) {
        if (this.negative !== 0 && num.negative === 0) return -1;
        if (this.negative === 0 && num.negative !== 0) return 1;
        var res = this.ucmp(num);
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Unsigned comparison
    BN.prototype.ucmp = function ucmp(num) {
        // At this point both numbers have the same sign
        if (this.length > num.length) return 1;
        if (this.length < num.length) return -1;
        var res = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var a = this.words[i] | 0;
            var b = num.words[i] | 0;
            if (a === b) continue;
            if (a < b) res = -1;
            else if (a > b) res = 1;
            break;
        }
        return res;
    };
    BN.prototype.gtn = function gtn(num) {
        return this.cmpn(num) === 1;
    };
    BN.prototype.gt = function gt(num) {
        return this.cmp(num) === 1;
    };
    BN.prototype.gten = function gten(num) {
        return this.cmpn(num) >= 0;
    };
    BN.prototype.gte = function gte(num) {
        return this.cmp(num) >= 0;
    };
    BN.prototype.ltn = function ltn(num) {
        return this.cmpn(num) === -1;
    };
    BN.prototype.lt = function lt(num) {
        return this.cmp(num) === -1;
    };
    BN.prototype.lten = function lten(num) {
        return this.cmpn(num) <= 0;
    };
    BN.prototype.lte = function lte(num) {
        return this.cmp(num) <= 0;
    };
    BN.prototype.eqn = function eqn(num) {
        return this.cmpn(num) === 0;
    };
    BN.prototype.eq = function eq(num) {
        return this.cmp(num) === 0;
    };
    //
    // A reduce context, could be using montgomery or something better, depending
    // on the `m` itself.
    //
    BN.red = function red(num) {
        return new Red(num);
    };
    BN.prototype.toRed = function toRed(ctx) {
        assert(!this.red, "Already a number in reduction context");
        assert(this.negative === 0, "red works only with positives");
        return ctx.convertTo(this)._forceRed(ctx);
    };
    BN.prototype.fromRed = function fromRed() {
        assert(this.red, "fromRed works only with numbers in reduction context");
        return this.red.convertFrom(this);
    };
    BN.prototype._forceRed = function _forceRed(ctx) {
        this.red = ctx;
        return this;
    };
    BN.prototype.forceRed = function forceRed(ctx) {
        assert(!this.red, "Already a number in reduction context");
        return this._forceRed(ctx);
    };
    BN.prototype.redAdd = function redAdd(num) {
        assert(this.red, "redAdd works only with red numbers");
        return this.red.add(this, num);
    };
    BN.prototype.redIAdd = function redIAdd(num) {
        assert(this.red, "redIAdd works only with red numbers");
        return this.red.iadd(this, num);
    };
    BN.prototype.redSub = function redSub(num) {
        assert(this.red, "redSub works only with red numbers");
        return this.red.sub(this, num);
    };
    BN.prototype.redISub = function redISub(num) {
        assert(this.red, "redISub works only with red numbers");
        return this.red.isub(this, num);
    };
    BN.prototype.redShl = function redShl(num) {
        assert(this.red, "redShl works only with red numbers");
        return this.red.shl(this, num);
    };
    BN.prototype.redMul = function redMul(num) {
        assert(this.red, "redMul works only with red numbers");
        this.red._verify2(this, num);
        return this.red.mul(this, num);
    };
    BN.prototype.redIMul = function redIMul(num) {
        assert(this.red, "redMul works only with red numbers");
        this.red._verify2(this, num);
        return this.red.imul(this, num);
    };
    BN.prototype.redSqr = function redSqr() {
        assert(this.red, "redSqr works only with red numbers");
        this.red._verify1(this);
        return this.red.sqr(this);
    };
    BN.prototype.redISqr = function redISqr() {
        assert(this.red, "redISqr works only with red numbers");
        this.red._verify1(this);
        return this.red.isqr(this);
    };
    // Square root over p
    BN.prototype.redSqrt = function redSqrt() {
        assert(this.red, "redSqrt works only with red numbers");
        this.red._verify1(this);
        return this.red.sqrt(this);
    };
    BN.prototype.redInvm = function redInvm() {
        assert(this.red, "redInvm works only with red numbers");
        this.red._verify1(this);
        return this.red.invm(this);
    };
    // Return negative clone of `this` % `red modulo`
    BN.prototype.redNeg = function redNeg() {
        assert(this.red, "redNeg works only with red numbers");
        this.red._verify1(this);
        return this.red.neg(this);
    };
    BN.prototype.redPow = function redPow(num) {
        assert(this.red && !num.red, "redPow(normalNum)");
        this.red._verify1(this);
        return this.red.pow(this, num);
    };
    // Prime numbers with efficient reduction
    var primes = {
        k256: null,
        p224: null,
        p192: null,
        p25519: null
    };
    // Pseudo-Mersenne prime
    function MPrime(name, p) {
        // P = 2 ^ N - K
        this.name = name;
        this.p = new BN(p, 16);
        this.n = this.p.bitLength();
        this.k = new BN(1).iushln(this.n).isub(this.p);
        this.tmp = this._tmp();
    }
    MPrime.prototype._tmp = function _tmp() {
        var tmp = new BN(null);
        tmp.words = new Array(Math.ceil(this.n / 13));
        return tmp;
    };
    MPrime.prototype.ireduce = function ireduce(num) {
        // Assumes that `num` is less than `P^2`
        // num = HI * (2 ^ N - K) + HI * K + LO = HI * K + LO (mod P)
        var r = num;
        var rlen;
        do {
            this.split(r, this.tmp);
            r = this.imulK(r);
            r = r.iadd(this.tmp);
            rlen = r.bitLength();
        }while (rlen > this.n);
        var cmp = rlen < this.n ? -1 : r.ucmp(this.p);
        if (cmp === 0) {
            r.words[0] = 0;
            r.length = 1;
        } else if (cmp > 0) r.isub(this.p);
        else if (r.strip !== undefined) // r is a BN v4 instance
        r.strip();
        else // r is a BN v5 instance
        r._strip();
        return r;
    };
    MPrime.prototype.split = function split(input, out) {
        input.iushrn(this.n, 0, out);
    };
    MPrime.prototype.imulK = function imulK(num) {
        return num.imul(this.k);
    };
    function K256() {
        MPrime.call(this, "k256", "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f");
    }
    inherits(K256, MPrime);
    K256.prototype.split = function split(input, output) {
        // 256 = 9 * 26 + 22
        var mask = 0x3fffff;
        var outLen = Math.min(input.length, 9);
        for(var i = 0; i < outLen; i++)output.words[i] = input.words[i];
        output.length = outLen;
        if (input.length <= 9) {
            input.words[0] = 0;
            input.length = 1;
            return;
        }
        // Shift by 9 limbs
        var prev = input.words[9];
        output.words[output.length++] = prev & mask;
        for(i = 10; i < input.length; i++){
            var next = input.words[i] | 0;
            input.words[i - 10] = (next & mask) << 4 | prev >>> 22;
            prev = next;
        }
        prev >>>= 22;
        input.words[i - 10] = prev;
        if (prev === 0 && input.length > 10) input.length -= 10;
        else input.length -= 9;
    };
    K256.prototype.imulK = function imulK(num) {
        // K = 0x1000003d1 = [ 0x40, 0x3d1 ]
        num.words[num.length] = 0;
        num.words[num.length + 1] = 0;
        num.length += 2;
        // bounded at: 0x40 * 0x3ffffff + 0x3d0 = 0x100000390
        var lo = 0;
        for(var i = 0; i < num.length; i++){
            var w = num.words[i] | 0;
            lo += w * 0x3d1;
            num.words[i] = lo & 0x3ffffff;
            lo = w * 0x40 + (lo / 0x4000000 | 0);
        }
        // Fast length reduction
        if (num.words[num.length - 1] === 0) {
            num.length--;
            if (num.words[num.length - 1] === 0) num.length--;
        }
        return num;
    };
    function P224() {
        MPrime.call(this, "p224", "ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001");
    }
    inherits(P224, MPrime);
    function P192() {
        MPrime.call(this, "p192", "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff");
    }
    inherits(P192, MPrime);
    function P25519() {
        // 2 ^ 255 - 19
        MPrime.call(this, "25519", "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed");
    }
    inherits(P25519, MPrime);
    P25519.prototype.imulK = function imulK(num) {
        // K = 0x13
        var carry = 0;
        for(var i = 0; i < num.length; i++){
            var hi = (num.words[i] | 0) * 0x13 + carry;
            var lo = hi & 0x3ffffff;
            hi >>>= 26;
            num.words[i] = lo;
            carry = hi;
        }
        if (carry !== 0) num.words[num.length++] = carry;
        return num;
    };
    // Exported mostly for testing purposes, use plain name instead
    BN._prime = function prime(name) {
        // Cached version of prime
        if (primes[name]) return primes[name];
        var prime;
        if (name === "k256") prime = new K256();
        else if (name === "p224") prime = new P224();
        else if (name === "p192") prime = new P192();
        else if (name === "p25519") prime = new P25519();
        else throw new Error("Unknown prime " + name);
        primes[name] = prime;
        return prime;
    };
    //
    // Base reduction engine
    //
    function Red(m) {
        if (typeof m === "string") {
            var prime = BN._prime(m);
            this.m = prime.p;
            this.prime = prime;
        } else {
            assert(m.gtn(1), "modulus must be greater than 1");
            this.m = m;
            this.prime = null;
        }
    }
    Red.prototype._verify1 = function _verify1(a) {
        assert(a.negative === 0, "red works only with positives");
        assert(a.red, "red works only with red numbers");
    };
    Red.prototype._verify2 = function _verify2(a, b) {
        assert((a.negative | b.negative) === 0, "red works only with positives");
        assert(a.red && a.red === b.red, "red works only with red numbers");
    };
    Red.prototype.imod = function imod(a) {
        if (this.prime) return this.prime.ireduce(a)._forceRed(this);
        move(a, a.umod(this.m)._forceRed(this));
        return a;
    };
    Red.prototype.neg = function neg(a) {
        if (a.isZero()) return a.clone();
        return this.m.sub(a)._forceRed(this);
    };
    Red.prototype.add = function add(a, b) {
        this._verify2(a, b);
        var res = a.add(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res._forceRed(this);
    };
    Red.prototype.iadd = function iadd(a, b) {
        this._verify2(a, b);
        var res = a.iadd(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res;
    };
    Red.prototype.sub = function sub(a, b) {
        this._verify2(a, b);
        var res = a.sub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res._forceRed(this);
    };
    Red.prototype.isub = function isub(a, b) {
        this._verify2(a, b);
        var res = a.isub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res;
    };
    Red.prototype.shl = function shl(a, num) {
        this._verify1(a);
        return this.imod(a.ushln(num));
    };
    Red.prototype.imul = function imul(a, b) {
        this._verify2(a, b);
        return this.imod(a.imul(b));
    };
    Red.prototype.mul = function mul(a, b) {
        this._verify2(a, b);
        return this.imod(a.mul(b));
    };
    Red.prototype.isqr = function isqr(a) {
        return this.imul(a, a.clone());
    };
    Red.prototype.sqr = function sqr(a) {
        return this.mul(a, a);
    };
    Red.prototype.sqrt = function sqrt(a) {
        if (a.isZero()) return a.clone();
        var mod3 = this.m.andln(3);
        assert(mod3 % 2 === 1);
        // Fast case
        if (mod3 === 3) {
            var pow = this.m.add(new BN(1)).iushrn(2);
            return this.pow(a, pow);
        }
        // Tonelli-Shanks algorithm (Totally unoptimized and slow)
        //
        // Find Q and S, that Q * 2 ^ S = (P - 1)
        var q = this.m.subn(1);
        var s = 0;
        while(!q.isZero() && q.andln(1) === 0){
            s++;
            q.iushrn(1);
        }
        assert(!q.isZero());
        var one = new BN(1).toRed(this);
        var nOne = one.redNeg();
        // Find quadratic non-residue
        // NOTE: Max is such because of generalized Riemann hypothesis.
        var lpow = this.m.subn(1).iushrn(1);
        var z = this.m.bitLength();
        z = new BN(2 * z * z).toRed(this);
        while(this.pow(z, lpow).cmp(nOne) !== 0)z.redIAdd(nOne);
        var c = this.pow(z, q);
        var r = this.pow(a, q.addn(1).iushrn(1));
        var t = this.pow(a, q);
        var m = s;
        while(t.cmp(one) !== 0){
            var tmp = t;
            for(var i = 0; tmp.cmp(one) !== 0; i++)tmp = tmp.redSqr();
            assert(i < m);
            var b = this.pow(c, new BN(1).iushln(m - i - 1));
            r = r.redMul(b);
            c = b.redSqr();
            t = t.redMul(c);
            m = i;
        }
        return r;
    };
    Red.prototype.invm = function invm(a) {
        var inv = a._invmp(this.m);
        if (inv.negative !== 0) {
            inv.negative = 0;
            return this.imod(inv).redNeg();
        } else return this.imod(inv);
    };
    Red.prototype.pow = function pow(a, num) {
        if (num.isZero()) return new BN(1).toRed(this);
        if (num.cmpn(1) === 0) return a.clone();
        var windowSize = 4;
        var wnd = new Array(1 << windowSize);
        wnd[0] = new BN(1).toRed(this);
        wnd[1] = a;
        for(var i = 2; i < wnd.length; i++)wnd[i] = this.mul(wnd[i - 1], a);
        var res = wnd[0];
        var current = 0;
        var currentLen = 0;
        var start = num.bitLength() % 26;
        if (start === 0) start = 26;
        for(i = num.length - 1; i >= 0; i--){
            var word = num.words[i];
            for(var j = start - 1; j >= 0; j--){
                var bit = word >> j & 1;
                if (res !== wnd[0]) res = this.sqr(res);
                if (bit === 0 && current === 0) {
                    currentLen = 0;
                    continue;
                }
                current <<= 1;
                current |= bit;
                currentLen++;
                if (currentLen !== windowSize && (i !== 0 || j !== 0)) continue;
                res = this.mul(res, wnd[current]);
                currentLen = 0;
                current = 0;
            }
            start = 26;
        }
        return res;
    };
    Red.prototype.convertTo = function convertTo(num) {
        var r = num.umod(this.m);
        return r === num ? r.clone() : r;
    };
    Red.prototype.convertFrom = function convertFrom(num) {
        var res = num.clone();
        res.red = null;
        return res;
    };
    //
    // Montgomery method engine
    //
    BN.mont = function mont(num) {
        return new Mont(num);
    };
    function Mont(m) {
        Red.call(this, m);
        this.shift = this.m.bitLength();
        if (this.shift % 26 !== 0) this.shift += 26 - this.shift % 26;
        this.r = new BN(1).iushln(this.shift);
        this.r2 = this.imod(this.r.sqr());
        this.rinv = this.r._invmp(this.m);
        this.minv = this.rinv.mul(this.r).isubn(1).div(this.m);
        this.minv = this.minv.umod(this.r);
        this.minv = this.r.sub(this.minv);
    }
    inherits(Mont, Red);
    Mont.prototype.convertTo = function convertTo(num) {
        return this.imod(num.ushln(this.shift));
    };
    Mont.prototype.convertFrom = function convertFrom(num) {
        var r = this.imod(num.mul(this.rinv));
        r.red = null;
        return r;
    };
    Mont.prototype.imul = function imul(a, b) {
        if (a.isZero() || b.isZero()) {
            a.words[0] = 0;
            a.length = 1;
            return a;
        }
        var t = a.imul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.mul = function mul(a, b) {
        if (a.isZero() || b.isZero()) return new BN(0)._forceRed(this);
        var t = a.mul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.invm = function invm(a) {
        // (AR)^-1 * R^2 = (A^-1 * R^-1) * R^2 = A^-1 * R
        var res = this.imod(a._invmp(this.m).mul(this.r2));
        return res._forceRed(this);
    };
})(module, this);

});

parcelRequire.register("lDrC1", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.findAttribute = module.exports.parseRawLog = module.exports.parseLogs = module.exports.parseLog = module.exports.parseEvent = module.exports.parseAttribute = void 0;

var $fZwG5 = parcelRequire("fZwG5");
function $fc02a8ba2241a5e3$var$parseAttribute(input) {
    if (!(0, $fZwG5.isNonNullObject)(input)) throw new Error("Attribute must be a non-null object");
    const { key: key, value: value } = input;
    if (typeof key !== "string" || !key) throw new Error("Attribute's key must be a non-empty string");
    if (typeof value !== "string" && typeof value !== "undefined") throw new Error("Attribute's value must be a string or unset");
    return {
        key: key,
        value: value || ""
    };
}
module.exports.parseAttribute = $fc02a8ba2241a5e3$var$parseAttribute;
function $fc02a8ba2241a5e3$var$parseEvent(input) {
    if (!(0, $fZwG5.isNonNullObject)(input)) throw new Error("Event must be a non-null object");
    const { type: type, attributes: attributes } = input;
    if (typeof type !== "string" || type === "") throw new Error(`Event type must be a non-empty string`);
    if (!Array.isArray(attributes)) throw new Error("Event's attributes must be an array");
    return {
        type: type,
        attributes: attributes.map($fc02a8ba2241a5e3$var$parseAttribute)
    };
}
module.exports.parseEvent = $fc02a8ba2241a5e3$var$parseEvent;
function $fc02a8ba2241a5e3$var$parseLog(input) {
    if (!(0, $fZwG5.isNonNullObject)(input)) throw new Error("Log must be a non-null object");
    const { msg_index: msg_index, log: log, events: events } = input;
    if (typeof msg_index !== "number") throw new Error("Log's msg_index must be a number");
    if (typeof log !== "string") throw new Error("Log's log must be a string");
    if (!Array.isArray(events)) throw new Error("Log's events must be an array");
    return {
        msg_index: msg_index,
        log: log,
        events: events.map($fc02a8ba2241a5e3$var$parseEvent)
    };
}
module.exports.parseLog = $fc02a8ba2241a5e3$var$parseLog;
function $fc02a8ba2241a5e3$var$parseLogs(input) {
    if (!Array.isArray(input)) throw new Error("Logs must be an array");
    return input.map($fc02a8ba2241a5e3$var$parseLog);
}
module.exports.parseLogs = $fc02a8ba2241a5e3$var$parseLogs;
function $fc02a8ba2241a5e3$var$parseRawLog(input = "[]") {
    const logsToParse = JSON.parse(input).map(({ events: events }, i)=>({
            msg_index: i,
            events: events,
            log: ""
        }));
    return $fc02a8ba2241a5e3$var$parseLogs(logsToParse);
}
module.exports.parseRawLog = $fc02a8ba2241a5e3$var$parseRawLog;
/**
 * Searches in logs for the first event of the given event type and in that event
 * for the first first attribute with the given attribute key.
 *
 * Throws if the attribute was not found.
 */ function $fc02a8ba2241a5e3$var$findAttribute(logs, eventType, attrKey) {
    const firstLogs = logs.find(()=>true);
    const out = firstLogs?.events.find((event)=>event.type === eventType)?.attributes.find((attr)=>attr.key === attrKey);
    if (!out) throw new Error(`Could not find attribute '${attrKey}' in first event of type '${eventType}' in first log.`);
    return out;
}
module.exports.findAttribute = $fc02a8ba2241a5e3$var$findAttribute;

});
parcelRequire.register("fZwG5", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.isUint8Array = module.exports.isNonNullObject = module.exports.isDefined = module.exports.sleep = module.exports.assertDefinedAndNotNull = module.exports.assertDefined = module.exports.assert = module.exports.arrayContentStartsWith = module.exports.arrayContentEquals = void 0;

var $biHQf = parcelRequire("biHQf");
Object.defineProperty(module.exports, "arrayContentEquals", {
    enumerable: true,
    get: function() {
        return $biHQf.arrayContentEquals;
    }
});
Object.defineProperty(module.exports, "arrayContentStartsWith", {
    enumerable: true,
    get: function() {
        return $biHQf.arrayContentStartsWith;
    }
});

var $esaxj = parcelRequire("esaxj");
Object.defineProperty(module.exports, "assert", {
    enumerable: true,
    get: function() {
        return $esaxj.assert;
    }
});
Object.defineProperty(module.exports, "assertDefined", {
    enumerable: true,
    get: function() {
        return $esaxj.assertDefined;
    }
});
Object.defineProperty(module.exports, "assertDefinedAndNotNull", {
    enumerable: true,
    get: function() {
        return $esaxj.assertDefinedAndNotNull;
    }
});

var $3ucR2 = parcelRequire("3ucR2");
Object.defineProperty(module.exports, "sleep", {
    enumerable: true,
    get: function() {
        return $3ucR2.sleep;
    }
});

var $NWqeT = parcelRequire("NWqeT");
Object.defineProperty(module.exports, "isDefined", {
    enumerable: true,
    get: function() {
        return $NWqeT.isDefined;
    }
});
Object.defineProperty(module.exports, "isNonNullObject", {
    enumerable: true,
    get: function() {
        return $NWqeT.isNonNullObject;
    }
});
Object.defineProperty(module.exports, "isUint8Array", {
    enumerable: true,
    get: function() {
        return $NWqeT.isUint8Array;
    }
});

});
parcelRequire.register("biHQf", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.arrayContentStartsWith = module.exports.arrayContentEquals = void 0;
/**
 * Compares the content of two arrays-like objects for equality.
 *
 * Equality is defined as having equal length and element values, where element equality means `===` returning `true`.
 *
 * This allows you to compare the content of a Buffer, Uint8Array or number[], ignoring the specific type.
 * As a consequence, this returns different results than Jasmine's `toEqual`, which ensures elements have the same type.
 */ function $83a362314b703021$var$arrayContentEquals(a, b) {
    if (a.length !== b.length) return false;
    for(let i = 0; i < a.length; ++i){
        if (a[i] !== b[i]) return false;
    }
    return true;
}
module.exports.arrayContentEquals = $83a362314b703021$var$arrayContentEquals;
/**
 * Checks if `a` starts with the contents of `b`.
 *
 * This requires equality of the element values, where element equality means `===` returning `true`.
 *
 * This allows you to compare the content of a Buffer, Uint8Array or number[], ignoring the specific type.
 * As a consequence, this returns different results than Jasmine's `toEqual`, which ensures elements have the same type.
 */ function $83a362314b703021$var$arrayContentStartsWith(a, b) {
    if (a.length < b.length) return false;
    for(let i = 0; i < b.length; ++i){
        if (a[i] !== b[i]) return false;
    }
    return true;
}
module.exports.arrayContentStartsWith = $83a362314b703021$var$arrayContentStartsWith;

});

parcelRequire.register("esaxj", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.assertDefinedAndNotNull = module.exports.assertDefined = module.exports.assert = void 0;
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
function $a85bda7b8eed6778$var$assert(condition, msg) {
    if (!condition) throw new Error(msg || "condition is not truthy");
}
module.exports.assert = $a85bda7b8eed6778$var$assert;
function $a85bda7b8eed6778$var$assertDefined(value, msg) {
    if (value === undefined) throw new Error(msg ?? "value is undefined");
}
module.exports.assertDefined = $a85bda7b8eed6778$var$assertDefined;
function $a85bda7b8eed6778$var$assertDefinedAndNotNull(value, msg) {
    if (value === undefined || value === null) throw new Error(msg ?? "value is undefined or null");
}
module.exports.assertDefinedAndNotNull = $a85bda7b8eed6778$var$assertDefinedAndNotNull;

});

parcelRequire.register("3ucR2", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.sleep = void 0;
async function $289e250feb063502$var$sleep(ms) {
    return new Promise((resolve)=>setTimeout(resolve, ms));
}
module.exports.sleep = $289e250feb063502$var$sleep;

});

parcelRequire.register("NWqeT", function(module, exports) {

var $ihoyg = parcelRequire("ihoyg");
var $0961e526fd6f2721$require$Buffer = $ihoyg.Buffer;
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.isDefined = module.exports.isUint8Array = module.exports.isNonNullObject = void 0;
/**
 * Checks if data is a non-null object (i.e. matches the TypeScript object type).
 *
 * Note: this returns true for arrays, which are objects in JavaScript
 * even though array and object are different types in JSON.
 *
 * @see https://www.typescriptlang.org/docs/handbook/basic-types.html#object
 */ // eslint-disable-next-line @typescript-eslint/ban-types
function $0961e526fd6f2721$var$isNonNullObject(data) {
    return typeof data === "object" && data !== null;
}
module.exports.isNonNullObject = $0961e526fd6f2721$var$isNonNullObject;
/**
 * Checks if data is an Uint8Array. Note: Buffer is treated as not a Uint8Array
 */ function $0961e526fd6f2721$var$isUint8Array(data) {
    if (!$0961e526fd6f2721$var$isNonNullObject(data)) return false;
    // Avoid instanceof check which is unreliable in some JS environments
    // https://medium.com/@simonwarta/limitations-of-the-instanceof-operator-f4bcdbe7a400
    // Use check that was discussed in https://github.com/crypto-browserify/pbkdf2/pull/81
    if (Object.prototype.toString.call(data) !== "[object Uint8Array]") return false;
    if (typeof $0961e526fd6f2721$require$Buffer !== "undefined" && typeof $0961e526fd6f2721$require$Buffer.isBuffer !== "undefined") {
        // Buffer.isBuffer is available at runtime
        if ($0961e526fd6f2721$require$Buffer.isBuffer(data)) return false;
    }
    return true;
}
module.exports.isUint8Array = $0961e526fd6f2721$var$isUint8Array;
/**
 * Checks if input is not undefined in a TypeScript-friendly way.
 *
 * This is convenient to use in e.g. `Array.filter` as it will convert
 * the type of a `Array<Foo | undefined>` to `Array<Foo>`.
 */ function $0961e526fd6f2721$var$isDefined(value) {
    return value !== undefined;
}
module.exports.isDefined = $0961e526fd6f2721$var$isDefined;

});



parcelRequire.register("8YbNk", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = $687d137ec0e9ea26$var$symbolObservablePonyfill;
function $687d137ec0e9ea26$var$symbolObservablePonyfill(root) {
    var result;
    var _Symbol = root.Symbol;
    if (typeof _Symbol === "function") {
        if (_Symbol.observable) result = _Symbol.observable;
        else {
            // This just needs to be something that won't trample other user's Symbol.for use
            // It also will guide people to the source of their issues, if this is problematic.
            // META: It's a resource locator!
            result = _Symbol["for"]("https://github.com/benlesh/symbol-observable");
            try {
                _Symbol.observable = result;
            } catch (err) {
            // Do nothing. In some environments, users have frozen `Symbol` for security reasons,
            // if it is frozen assigning to it will throw. In this case, we don't care, because
            // they will need to use the returned value from the ponyfill.
            }
        }
    } else result = "@@observable";
    return result;
}

});

parcelRequire.register("cqifw", function(module, exports) {
"use strict";
var $90b611aa4982c4db$var$toStr = Object.prototype.toString;
module.exports = function isArguments(value) {
    var str = $90b611aa4982c4db$var$toStr.call(value);
    var isArgs = str === "[object Arguments]";
    if (!isArgs) isArgs = str !== "[object Array]" && value !== null && typeof value === "object" && typeof value.length === "number" && value.length >= 0 && $90b611aa4982c4db$var$toStr.call(value.callee) === "[object Function]";
    return isArgs;
};

});

parcelRequire.register("2HCYb", function(module, exports) {
"use strict";
var $1f7dd37c88a3e4eb$var$keysShim;

if (!Object.keys) {
    // modified from https://github.com/es-shims/es5-shim
    var $1f7dd37c88a3e4eb$var$has = Object.prototype.hasOwnProperty;
    var $1f7dd37c88a3e4eb$var$toStr = Object.prototype.toString;
    var $1f7dd37c88a3e4eb$var$isArgs = (parcelRequire("cqifw")); // eslint-disable-line global-require
    var $1f7dd37c88a3e4eb$var$isEnumerable = Object.prototype.propertyIsEnumerable;
    var $1f7dd37c88a3e4eb$var$hasDontEnumBug = !$1f7dd37c88a3e4eb$var$isEnumerable.call({
        toString: null
    }, "toString");
    var $1f7dd37c88a3e4eb$var$hasProtoEnumBug = $1f7dd37c88a3e4eb$var$isEnumerable.call(function() {}, "prototype");
    var $1f7dd37c88a3e4eb$var$dontEnums = [
        "toString",
        "toLocaleString",
        "valueOf",
        "hasOwnProperty",
        "isPrototypeOf",
        "propertyIsEnumerable",
        "constructor"
    ];
    var $1f7dd37c88a3e4eb$var$equalsConstructorPrototype = function(o) {
        var ctor = o.constructor;
        return ctor && ctor.prototype === o;
    };
    var $1f7dd37c88a3e4eb$var$excludedKeys = {
        $applicationCache: true,
        $console: true,
        $external: true,
        $frame: true,
        $frameElement: true,
        $frames: true,
        $innerHeight: true,
        $innerWidth: true,
        $onmozfullscreenchange: true,
        $onmozfullscreenerror: true,
        $outerHeight: true,
        $outerWidth: true,
        $pageXOffset: true,
        $pageYOffset: true,
        $parent: true,
        $scrollLeft: true,
        $scrollTop: true,
        $scrollX: true,
        $scrollY: true,
        $self: true,
        $webkitIndexedDB: true,
        $webkitStorageInfo: true,
        $window: true
    };
    var $1f7dd37c88a3e4eb$var$hasAutomationEqualityBug = function() {
        /* global window */ if (typeof window === "undefined") return false;
        for(var k in window)try {
            if (!$1f7dd37c88a3e4eb$var$excludedKeys["$" + k] && $1f7dd37c88a3e4eb$var$has.call(window, k) && window[k] !== null && typeof window[k] === "object") try {
                $1f7dd37c88a3e4eb$var$equalsConstructorPrototype(window[k]);
            } catch (e) {
                return true;
            }
        } catch (e) {
            return true;
        }
        return false;
    }();
    var $1f7dd37c88a3e4eb$var$equalsConstructorPrototypeIfNotBuggy = function(o) {
        /* global window */ if (typeof window === "undefined" || !$1f7dd37c88a3e4eb$var$hasAutomationEqualityBug) return $1f7dd37c88a3e4eb$var$equalsConstructorPrototype(o);
        try {
            return $1f7dd37c88a3e4eb$var$equalsConstructorPrototype(o);
        } catch (e) {
            return false;
        }
    };
    $1f7dd37c88a3e4eb$var$keysShim = function keys(object) {
        var isObject = object !== null && typeof object === "object";
        var isFunction = $1f7dd37c88a3e4eb$var$toStr.call(object) === "[object Function]";
        var isArguments = $1f7dd37c88a3e4eb$var$isArgs(object);
        var isString = isObject && $1f7dd37c88a3e4eb$var$toStr.call(object) === "[object String]";
        var theKeys = [];
        if (!isObject && !isFunction && !isArguments) throw new TypeError("Object.keys called on a non-object");
        var skipProto = $1f7dd37c88a3e4eb$var$hasProtoEnumBug && isFunction;
        if (isString && object.length > 0 && !$1f7dd37c88a3e4eb$var$has.call(object, 0)) for(var i = 0; i < object.length; ++i)theKeys.push(String(i));
        if (isArguments && object.length > 0) for(var j = 0; j < object.length; ++j)theKeys.push(String(j));
        else {
            for(var name in object)if (!(skipProto && name === "prototype") && $1f7dd37c88a3e4eb$var$has.call(object, name)) theKeys.push(String(name));
        }
        if ($1f7dd37c88a3e4eb$var$hasDontEnumBug) {
            var skipConstructor = $1f7dd37c88a3e4eb$var$equalsConstructorPrototypeIfNotBuggy(object);
            for(var k = 0; k < $1f7dd37c88a3e4eb$var$dontEnums.length; ++k)if (!(skipConstructor && $1f7dd37c88a3e4eb$var$dontEnums[k] === "constructor") && $1f7dd37c88a3e4eb$var$has.call(object, $1f7dd37c88a3e4eb$var$dontEnums[k])) theKeys.push($1f7dd37c88a3e4eb$var$dontEnums[k]);
        }
        return theKeys;
    };
}
module.exports = $1f7dd37c88a3e4eb$var$keysShim;

});

parcelRequire.register("73hDB", function(module, exports) {
"use strict";

var $avqmt = parcelRequire("avqmt");
var $52267eb4294466ed$var$$defineProperty = $avqmt("%Object.defineProperty%", true);
var $52267eb4294466ed$var$hasPropertyDescriptors = function hasPropertyDescriptors() {
    if ($52267eb4294466ed$var$$defineProperty) try {
        $52267eb4294466ed$var$$defineProperty({}, "a", {
            value: 1
        });
        return true;
    } catch (e) {
        // IE 8 has a broken defineProperty
        return false;
    }
    return false;
};
$52267eb4294466ed$var$hasPropertyDescriptors.hasArrayLengthDefineBug = function hasArrayLengthDefineBug() {
    // node v0.6 has a bug where array lengths can be Set but not Defined
    if (!$52267eb4294466ed$var$hasPropertyDescriptors()) return null;
    try {
        return $52267eb4294466ed$var$$defineProperty([], "length", {
            value: 1
        }).length !== 1;
    } catch (e) {
        // In Firefox 4-22, defining length on an array throws an exception.
        return true;
    }
};
module.exports = $52267eb4294466ed$var$hasPropertyDescriptors;

});
parcelRequire.register("avqmt", function(module, exports) {
"use strict";
var $7a613f7503e09dde$var$undefined;
var $7a613f7503e09dde$var$$SyntaxError = SyntaxError;
var $7a613f7503e09dde$var$$Function = Function;
var $7a613f7503e09dde$var$$TypeError = TypeError;
// eslint-disable-next-line consistent-return
var $7a613f7503e09dde$var$getEvalledConstructor = function(expressionSyntax) {
    try {
        return $7a613f7503e09dde$var$$Function('"use strict"; return (' + expressionSyntax + ").constructor;")();
    } catch (e) {}
};
var $7a613f7503e09dde$var$$gOPD = Object.getOwnPropertyDescriptor;
if ($7a613f7503e09dde$var$$gOPD) try {
    $7a613f7503e09dde$var$$gOPD({}, "");
} catch (e) {
    $7a613f7503e09dde$var$$gOPD = null; // this is IE 8, which has a broken gOPD
}
var $7a613f7503e09dde$var$throwTypeError = function() {
    throw new $7a613f7503e09dde$var$$TypeError();
};
var $7a613f7503e09dde$var$ThrowTypeError = $7a613f7503e09dde$var$$gOPD ? function() {
    try {
        // eslint-disable-next-line no-unused-expressions, no-caller, no-restricted-properties
        arguments.callee; // IE 8 does not throw here
        return $7a613f7503e09dde$var$throwTypeError;
    } catch (calleeThrows) {
        try {
            // IE 8 throws on Object.getOwnPropertyDescriptor(arguments, '')
            return $7a613f7503e09dde$var$$gOPD(arguments, "callee").get;
        } catch (gOPDthrows) {
            return $7a613f7503e09dde$var$throwTypeError;
        }
    }
}() : $7a613f7503e09dde$var$throwTypeError;

var $7a613f7503e09dde$var$hasSymbols = (parcelRequire("5CmBX"))();

var $7a613f7503e09dde$var$hasProto = (parcelRequire("1q0DH"))();
var $7a613f7503e09dde$var$getProto = Object.getPrototypeOf || ($7a613f7503e09dde$var$hasProto ? function(x) {
    return x.__proto__;
} // eslint-disable-line no-proto
 : null);
var $7a613f7503e09dde$var$needsEval = {};
var $7a613f7503e09dde$var$TypedArray = typeof Uint8Array === "undefined" || !$7a613f7503e09dde$var$getProto ? $7a613f7503e09dde$var$undefined : $7a613f7503e09dde$var$getProto(Uint8Array);
var $7a613f7503e09dde$var$INTRINSICS = {
    "%AggregateError%": typeof AggregateError === "undefined" ? $7a613f7503e09dde$var$undefined : AggregateError,
    "%Array%": Array,
    "%ArrayBuffer%": typeof ArrayBuffer === "undefined" ? $7a613f7503e09dde$var$undefined : ArrayBuffer,
    "%ArrayIteratorPrototype%": $7a613f7503e09dde$var$hasSymbols && $7a613f7503e09dde$var$getProto ? $7a613f7503e09dde$var$getProto([][Symbol.iterator]()) : $7a613f7503e09dde$var$undefined,
    "%AsyncFromSyncIteratorPrototype%": $7a613f7503e09dde$var$undefined,
    "%AsyncFunction%": $7a613f7503e09dde$var$needsEval,
    "%AsyncGenerator%": $7a613f7503e09dde$var$needsEval,
    "%AsyncGeneratorFunction%": $7a613f7503e09dde$var$needsEval,
    "%AsyncIteratorPrototype%": $7a613f7503e09dde$var$needsEval,
    "%Atomics%": typeof Atomics === "undefined" ? $7a613f7503e09dde$var$undefined : Atomics,
    "%BigInt%": typeof BigInt === "undefined" ? $7a613f7503e09dde$var$undefined : BigInt,
    "%BigInt64Array%": typeof BigInt64Array === "undefined" ? $7a613f7503e09dde$var$undefined : BigInt64Array,
    "%BigUint64Array%": typeof BigUint64Array === "undefined" ? $7a613f7503e09dde$var$undefined : BigUint64Array,
    "%Boolean%": Boolean,
    "%DataView%": typeof DataView === "undefined" ? $7a613f7503e09dde$var$undefined : DataView,
    "%Date%": Date,
    "%decodeURI%": decodeURI,
    "%decodeURIComponent%": decodeURIComponent,
    "%encodeURI%": encodeURI,
    "%encodeURIComponent%": encodeURIComponent,
    "%Error%": Error,
    "%eval%": eval,
    "%EvalError%": EvalError,
    "%Float32Array%": typeof Float32Array === "undefined" ? $7a613f7503e09dde$var$undefined : Float32Array,
    "%Float64Array%": typeof Float64Array === "undefined" ? $7a613f7503e09dde$var$undefined : Float64Array,
    "%FinalizationRegistry%": typeof FinalizationRegistry === "undefined" ? $7a613f7503e09dde$var$undefined : FinalizationRegistry,
    "%Function%": $7a613f7503e09dde$var$$Function,
    "%GeneratorFunction%": $7a613f7503e09dde$var$needsEval,
    "%Int8Array%": typeof Int8Array === "undefined" ? $7a613f7503e09dde$var$undefined : Int8Array,
    "%Int16Array%": typeof Int16Array === "undefined" ? $7a613f7503e09dde$var$undefined : Int16Array,
    "%Int32Array%": typeof Int32Array === "undefined" ? $7a613f7503e09dde$var$undefined : Int32Array,
    "%isFinite%": isFinite,
    "%isNaN%": isNaN,
    "%IteratorPrototype%": $7a613f7503e09dde$var$hasSymbols && $7a613f7503e09dde$var$getProto ? $7a613f7503e09dde$var$getProto($7a613f7503e09dde$var$getProto([][Symbol.iterator]())) : $7a613f7503e09dde$var$undefined,
    "%JSON%": typeof JSON === "object" ? JSON : $7a613f7503e09dde$var$undefined,
    "%Map%": typeof Map === "undefined" ? $7a613f7503e09dde$var$undefined : Map,
    "%MapIteratorPrototype%": typeof Map === "undefined" || !$7a613f7503e09dde$var$hasSymbols || !$7a613f7503e09dde$var$getProto ? $7a613f7503e09dde$var$undefined : $7a613f7503e09dde$var$getProto(new Map()[Symbol.iterator]()),
    "%Math%": Math,
    "%Number%": Number,
    "%Object%": Object,
    "%parseFloat%": parseFloat,
    "%parseInt%": parseInt,
    "%Promise%": typeof Promise === "undefined" ? $7a613f7503e09dde$var$undefined : Promise,
    "%Proxy%": typeof Proxy === "undefined" ? $7a613f7503e09dde$var$undefined : Proxy,
    "%RangeError%": RangeError,
    "%ReferenceError%": ReferenceError,
    "%Reflect%": typeof Reflect === "undefined" ? $7a613f7503e09dde$var$undefined : Reflect,
    "%RegExp%": RegExp,
    "%Set%": typeof Set === "undefined" ? $7a613f7503e09dde$var$undefined : Set,
    "%SetIteratorPrototype%": typeof Set === "undefined" || !$7a613f7503e09dde$var$hasSymbols || !$7a613f7503e09dde$var$getProto ? $7a613f7503e09dde$var$undefined : $7a613f7503e09dde$var$getProto(new Set()[Symbol.iterator]()),
    "%SharedArrayBuffer%": typeof SharedArrayBuffer === "undefined" ? $7a613f7503e09dde$var$undefined : SharedArrayBuffer,
    "%String%": String,
    "%StringIteratorPrototype%": $7a613f7503e09dde$var$hasSymbols && $7a613f7503e09dde$var$getProto ? $7a613f7503e09dde$var$getProto(""[Symbol.iterator]()) : $7a613f7503e09dde$var$undefined,
    "%Symbol%": $7a613f7503e09dde$var$hasSymbols ? Symbol : $7a613f7503e09dde$var$undefined,
    "%SyntaxError%": $7a613f7503e09dde$var$$SyntaxError,
    "%ThrowTypeError%": $7a613f7503e09dde$var$ThrowTypeError,
    "%TypedArray%": $7a613f7503e09dde$var$TypedArray,
    "%TypeError%": $7a613f7503e09dde$var$$TypeError,
    "%Uint8Array%": typeof Uint8Array === "undefined" ? $7a613f7503e09dde$var$undefined : Uint8Array,
    "%Uint8ClampedArray%": typeof Uint8ClampedArray === "undefined" ? $7a613f7503e09dde$var$undefined : Uint8ClampedArray,
    "%Uint16Array%": typeof Uint16Array === "undefined" ? $7a613f7503e09dde$var$undefined : Uint16Array,
    "%Uint32Array%": typeof Uint32Array === "undefined" ? $7a613f7503e09dde$var$undefined : Uint32Array,
    "%URIError%": URIError,
    "%WeakMap%": typeof WeakMap === "undefined" ? $7a613f7503e09dde$var$undefined : WeakMap,
    "%WeakRef%": typeof WeakRef === "undefined" ? $7a613f7503e09dde$var$undefined : WeakRef,
    "%WeakSet%": typeof WeakSet === "undefined" ? $7a613f7503e09dde$var$undefined : WeakSet
};
if ($7a613f7503e09dde$var$getProto) try {
    null.error; // eslint-disable-line no-unused-expressions
} catch (e) {
    // https://github.com/tc39/proposal-shadowrealm/pull/384#issuecomment-1364264229
    var $7a613f7503e09dde$var$errorProto = $7a613f7503e09dde$var$getProto($7a613f7503e09dde$var$getProto(e));
    $7a613f7503e09dde$var$INTRINSICS["%Error.prototype%"] = $7a613f7503e09dde$var$errorProto;
}
var $7a613f7503e09dde$var$doEval = function doEval(name) {
    var value;
    if (name === "%AsyncFunction%") value = $7a613f7503e09dde$var$getEvalledConstructor("async function () {}");
    else if (name === "%GeneratorFunction%") value = $7a613f7503e09dde$var$getEvalledConstructor("function* () {}");
    else if (name === "%AsyncGeneratorFunction%") value = $7a613f7503e09dde$var$getEvalledConstructor("async function* () {}");
    else if (name === "%AsyncGenerator%") {
        var fn = doEval("%AsyncGeneratorFunction%");
        if (fn) value = fn.prototype;
    } else if (name === "%AsyncIteratorPrototype%") {
        var gen = doEval("%AsyncGenerator%");
        if (gen && $7a613f7503e09dde$var$getProto) value = $7a613f7503e09dde$var$getProto(gen.prototype);
    }
    $7a613f7503e09dde$var$INTRINSICS[name] = value;
    return value;
};
var $7a613f7503e09dde$var$LEGACY_ALIASES = {
    "%ArrayBufferPrototype%": [
        "ArrayBuffer",
        "prototype"
    ],
    "%ArrayPrototype%": [
        "Array",
        "prototype"
    ],
    "%ArrayProto_entries%": [
        "Array",
        "prototype",
        "entries"
    ],
    "%ArrayProto_forEach%": [
        "Array",
        "prototype",
        "forEach"
    ],
    "%ArrayProto_keys%": [
        "Array",
        "prototype",
        "keys"
    ],
    "%ArrayProto_values%": [
        "Array",
        "prototype",
        "values"
    ],
    "%AsyncFunctionPrototype%": [
        "AsyncFunction",
        "prototype"
    ],
    "%AsyncGenerator%": [
        "AsyncGeneratorFunction",
        "prototype"
    ],
    "%AsyncGeneratorPrototype%": [
        "AsyncGeneratorFunction",
        "prototype",
        "prototype"
    ],
    "%BooleanPrototype%": [
        "Boolean",
        "prototype"
    ],
    "%DataViewPrototype%": [
        "DataView",
        "prototype"
    ],
    "%DatePrototype%": [
        "Date",
        "prototype"
    ],
    "%ErrorPrototype%": [
        "Error",
        "prototype"
    ],
    "%EvalErrorPrototype%": [
        "EvalError",
        "prototype"
    ],
    "%Float32ArrayPrototype%": [
        "Float32Array",
        "prototype"
    ],
    "%Float64ArrayPrototype%": [
        "Float64Array",
        "prototype"
    ],
    "%FunctionPrototype%": [
        "Function",
        "prototype"
    ],
    "%Generator%": [
        "GeneratorFunction",
        "prototype"
    ],
    "%GeneratorPrototype%": [
        "GeneratorFunction",
        "prototype",
        "prototype"
    ],
    "%Int8ArrayPrototype%": [
        "Int8Array",
        "prototype"
    ],
    "%Int16ArrayPrototype%": [
        "Int16Array",
        "prototype"
    ],
    "%Int32ArrayPrototype%": [
        "Int32Array",
        "prototype"
    ],
    "%JSONParse%": [
        "JSON",
        "parse"
    ],
    "%JSONStringify%": [
        "JSON",
        "stringify"
    ],
    "%MapPrototype%": [
        "Map",
        "prototype"
    ],
    "%NumberPrototype%": [
        "Number",
        "prototype"
    ],
    "%ObjectPrototype%": [
        "Object",
        "prototype"
    ],
    "%ObjProto_toString%": [
        "Object",
        "prototype",
        "toString"
    ],
    "%ObjProto_valueOf%": [
        "Object",
        "prototype",
        "valueOf"
    ],
    "%PromisePrototype%": [
        "Promise",
        "prototype"
    ],
    "%PromiseProto_then%": [
        "Promise",
        "prototype",
        "then"
    ],
    "%Promise_all%": [
        "Promise",
        "all"
    ],
    "%Promise_reject%": [
        "Promise",
        "reject"
    ],
    "%Promise_resolve%": [
        "Promise",
        "resolve"
    ],
    "%RangeErrorPrototype%": [
        "RangeError",
        "prototype"
    ],
    "%ReferenceErrorPrototype%": [
        "ReferenceError",
        "prototype"
    ],
    "%RegExpPrototype%": [
        "RegExp",
        "prototype"
    ],
    "%SetPrototype%": [
        "Set",
        "prototype"
    ],
    "%SharedArrayBufferPrototype%": [
        "SharedArrayBuffer",
        "prototype"
    ],
    "%StringPrototype%": [
        "String",
        "prototype"
    ],
    "%SymbolPrototype%": [
        "Symbol",
        "prototype"
    ],
    "%SyntaxErrorPrototype%": [
        "SyntaxError",
        "prototype"
    ],
    "%TypedArrayPrototype%": [
        "TypedArray",
        "prototype"
    ],
    "%TypeErrorPrototype%": [
        "TypeError",
        "prototype"
    ],
    "%Uint8ArrayPrototype%": [
        "Uint8Array",
        "prototype"
    ],
    "%Uint8ClampedArrayPrototype%": [
        "Uint8ClampedArray",
        "prototype"
    ],
    "%Uint16ArrayPrototype%": [
        "Uint16Array",
        "prototype"
    ],
    "%Uint32ArrayPrototype%": [
        "Uint32Array",
        "prototype"
    ],
    "%URIErrorPrototype%": [
        "URIError",
        "prototype"
    ],
    "%WeakMapPrototype%": [
        "WeakMap",
        "prototype"
    ],
    "%WeakSetPrototype%": [
        "WeakSet",
        "prototype"
    ]
};

var $a7ABz = parcelRequire("a7ABz");

var $56d6a = parcelRequire("56d6a");
var $7a613f7503e09dde$var$$concat = $a7ABz.call(Function.call, Array.prototype.concat);
var $7a613f7503e09dde$var$$spliceApply = $a7ABz.call(Function.apply, Array.prototype.splice);
var $7a613f7503e09dde$var$$replace = $a7ABz.call(Function.call, String.prototype.replace);
var $7a613f7503e09dde$var$$strSlice = $a7ABz.call(Function.call, String.prototype.slice);
var $7a613f7503e09dde$var$$exec = $a7ABz.call(Function.call, RegExp.prototype.exec);
/* adapted from https://github.com/lodash/lodash/blob/4.17.15/dist/lodash.js#L6735-L6744 */ var $7a613f7503e09dde$var$rePropName = /[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g;
var $7a613f7503e09dde$var$reEscapeChar = /\\(\\)?/g; /** Used to match backslashes in property paths. */ 
var $7a613f7503e09dde$var$stringToPath = function stringToPath(string) {
    var first = $7a613f7503e09dde$var$$strSlice(string, 0, 1);
    var last = $7a613f7503e09dde$var$$strSlice(string, -1);
    if (first === "%" && last !== "%") throw new $7a613f7503e09dde$var$$SyntaxError("invalid intrinsic syntax, expected closing `%`");
    else if (last === "%" && first !== "%") throw new $7a613f7503e09dde$var$$SyntaxError("invalid intrinsic syntax, expected opening `%`");
    var result = [];
    $7a613f7503e09dde$var$$replace(string, $7a613f7503e09dde$var$rePropName, function(match, number, quote, subString) {
        result[result.length] = quote ? $7a613f7503e09dde$var$$replace(subString, $7a613f7503e09dde$var$reEscapeChar, "$1") : number || match;
    });
    return result;
};
/* end adaptation */ var $7a613f7503e09dde$var$getBaseIntrinsic = function getBaseIntrinsic(name, allowMissing) {
    var intrinsicName = name;
    var alias;
    if ($56d6a($7a613f7503e09dde$var$LEGACY_ALIASES, intrinsicName)) {
        alias = $7a613f7503e09dde$var$LEGACY_ALIASES[intrinsicName];
        intrinsicName = "%" + alias[0] + "%";
    }
    if ($56d6a($7a613f7503e09dde$var$INTRINSICS, intrinsicName)) {
        var value = $7a613f7503e09dde$var$INTRINSICS[intrinsicName];
        if (value === $7a613f7503e09dde$var$needsEval) value = $7a613f7503e09dde$var$doEval(intrinsicName);
        if (typeof value === "undefined" && !allowMissing) throw new $7a613f7503e09dde$var$$TypeError("intrinsic " + name + " exists, but is not available. Please file an issue!");
        return {
            alias: alias,
            name: intrinsicName,
            value: value
        };
    }
    throw new $7a613f7503e09dde$var$$SyntaxError("intrinsic " + name + " does not exist!");
};
module.exports = function GetIntrinsic(name, allowMissing) {
    if (typeof name !== "string" || name.length === 0) throw new $7a613f7503e09dde$var$$TypeError("intrinsic name must be a non-empty string");
    if (arguments.length > 1 && typeof allowMissing !== "boolean") throw new $7a613f7503e09dde$var$$TypeError('"allowMissing" argument must be a boolean');
    if ($7a613f7503e09dde$var$$exec(/^%?[^%]*%?$/, name) === null) throw new $7a613f7503e09dde$var$$SyntaxError("`%` may not be present anywhere but at the beginning and end of the intrinsic name");
    var parts = $7a613f7503e09dde$var$stringToPath(name);
    var intrinsicBaseName = parts.length > 0 ? parts[0] : "";
    var intrinsic = $7a613f7503e09dde$var$getBaseIntrinsic("%" + intrinsicBaseName + "%", allowMissing);
    var intrinsicRealName = intrinsic.name;
    var value = intrinsic.value;
    var skipFurtherCaching = false;
    var alias = intrinsic.alias;
    if (alias) {
        intrinsicBaseName = alias[0];
        $7a613f7503e09dde$var$$spliceApply(parts, $7a613f7503e09dde$var$$concat([
            0,
            1
        ], alias));
    }
    for(var i = 1, isOwn = true; i < parts.length; i += 1){
        var part = parts[i];
        var first = $7a613f7503e09dde$var$$strSlice(part, 0, 1);
        var last = $7a613f7503e09dde$var$$strSlice(part, -1);
        if ((first === '"' || first === "'" || first === "`" || last === '"' || last === "'" || last === "`") && first !== last) throw new $7a613f7503e09dde$var$$SyntaxError("property names with quotes must have matching quotes");
        if (part === "constructor" || !isOwn) skipFurtherCaching = true;
        intrinsicBaseName += "." + part;
        intrinsicRealName = "%" + intrinsicBaseName + "%";
        if ($56d6a($7a613f7503e09dde$var$INTRINSICS, intrinsicRealName)) value = $7a613f7503e09dde$var$INTRINSICS[intrinsicRealName];
        else if (value != null) {
            if (!(part in value)) {
                if (!allowMissing) throw new $7a613f7503e09dde$var$$TypeError("base intrinsic for " + name + " exists, but the property is not available.");
                return void 0;
            }
            if ($7a613f7503e09dde$var$$gOPD && i + 1 >= parts.length) {
                var desc = $7a613f7503e09dde$var$$gOPD(value, part);
                isOwn = !!desc;
                // By convention, when a data property is converted to an accessor
                // property to emulate a data property that does not suffer from
                // the override mistake, that accessor's getter is marked with
                // an `originalValue` property. Here, when we detect this, we
                // uphold the illusion by pretending to see that original data
                // property, i.e., returning the value rather than the getter
                // itself.
                if (isOwn && "get" in desc && !("originalValue" in desc.get)) value = desc.get;
                else value = value[part];
            } else {
                isOwn = $56d6a(value, part);
                value = value[part];
            }
            if (isOwn && !skipFurtherCaching) $7a613f7503e09dde$var$INTRINSICS[intrinsicRealName] = value;
        }
    }
    return value;
};

});
parcelRequire.register("5CmBX", function(module, exports) {
"use strict";
var $41720a79fda68d9e$var$origSymbol = typeof Symbol !== "undefined" && Symbol;

var $fNdnD = parcelRequire("fNdnD");
module.exports = function hasNativeSymbols() {
    if (typeof $41720a79fda68d9e$var$origSymbol !== "function") return false;
    if (typeof Symbol !== "function") return false;
    if (typeof $41720a79fda68d9e$var$origSymbol("foo") !== "symbol") return false;
    if (typeof Symbol("bar") !== "symbol") return false;
    return $fNdnD();
};

});
parcelRequire.register("fNdnD", function(module, exports) {
"use strict";
/* eslint complexity: [2, 18], max-statements: [2, 33] */ module.exports = function hasSymbols() {
    if (typeof Symbol !== "function" || typeof Object.getOwnPropertySymbols !== "function") return false;
    if (typeof Symbol.iterator === "symbol") return true;
    var obj = {};
    var sym = Symbol("test");
    var symObj = Object(sym);
    if (typeof sym === "string") return false;
    if (Object.prototype.toString.call(sym) !== "[object Symbol]") return false;
    if (Object.prototype.toString.call(symObj) !== "[object Symbol]") return false;
    // temp disabled per https://github.com/ljharb/object.assign/issues/17
    // if (sym instanceof Symbol) { return false; }
    // temp disabled per https://github.com/WebReflection/get-own-property-symbols/issues/4
    // if (!(symObj instanceof Symbol)) { return false; }
    // if (typeof Symbol.prototype.toString !== 'function') { return false; }
    // if (String(sym) !== Symbol.prototype.toString.call(sym)) { return false; }
    var symVal = 42;
    obj[sym] = symVal;
    for(sym in obj)return false;
     // eslint-disable-line no-restricted-syntax, no-unreachable-loop
    if (typeof Object.keys === "function" && Object.keys(obj).length !== 0) return false;
    if (typeof Object.getOwnPropertyNames === "function" && Object.getOwnPropertyNames(obj).length !== 0) return false;
    var syms = Object.getOwnPropertySymbols(obj);
    if (syms.length !== 1 || syms[0] !== sym) return false;
    if (!Object.prototype.propertyIsEnumerable.call(obj, sym)) return false;
    if (typeof Object.getOwnPropertyDescriptor === "function") {
        var descriptor = Object.getOwnPropertyDescriptor(obj, sym);
        if (descriptor.value !== symVal || descriptor.enumerable !== true) return false;
    }
    return true;
};

});


parcelRequire.register("1q0DH", function(module, exports) {
"use strict";
var $1088b720f9e31113$var$test = {
    foo: {}
};
var $1088b720f9e31113$var$$Object = Object;
module.exports = function hasProto() {
    return ({
        __proto__: $1088b720f9e31113$var$test
    }).foo === $1088b720f9e31113$var$test.foo && !(({
        __proto__: null
    }) instanceof $1088b720f9e31113$var$$Object);
};

});

parcelRequire.register("a7ABz", function(module, exports) {
"use strict";

var $cytJY = parcelRequire("cytJY");
module.exports = Function.prototype.bind || $cytJY;

});
parcelRequire.register("cytJY", function(module, exports) {
"use strict";
/* eslint no-invalid-this: 1 */ var $923fbadf1e720976$var$ERROR_MESSAGE = "Function.prototype.bind called on incompatible ";
var $923fbadf1e720976$var$slice = Array.prototype.slice;
var $923fbadf1e720976$var$toStr = Object.prototype.toString;
var $923fbadf1e720976$var$funcType = "[object Function]";
module.exports = function bind(that) {
    var target = this;
    if (typeof target !== "function" || $923fbadf1e720976$var$toStr.call(target) !== $923fbadf1e720976$var$funcType) throw new TypeError($923fbadf1e720976$var$ERROR_MESSAGE + target);
    var args = $923fbadf1e720976$var$slice.call(arguments, 1);
    var bound;
    var binder = function() {
        if (this instanceof bound) {
            var result = target.apply(this, args.concat($923fbadf1e720976$var$slice.call(arguments)));
            if (Object(result) === result) return result;
            return this;
        } else return target.apply(that, args.concat($923fbadf1e720976$var$slice.call(arguments)));
    };
    var boundLength = Math.max(0, target.length - args.length);
    var boundArgs = [];
    for(var i = 0; i < boundLength; i++)boundArgs.push("$" + i);
    bound = Function("binder", "return function (" + boundArgs.join(",") + "){ return binder.apply(this,arguments); }")(binder);
    if (target.prototype) {
        var Empty = function Empty() {};
        Empty.prototype = target.prototype;
        bound.prototype = new Empty();
        Empty.prototype = null;
    }
    return bound;
};

});


parcelRequire.register("56d6a", function(module, exports) {
"use strict";

var $a7ABz = parcelRequire("a7ABz");
module.exports = $a7ABz.call(Function.call, Object.prototype.hasOwnProperty);

});



parcelRequire.register("gt3mZ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.lastValue = module.exports.asArray = module.exports.countStream = module.exports.Reducer = void 0;
// Reducer takes a stream of events T and a ReducerFunc, that
// materializes a state of type U.
class $bfd1f7eda662cd09$var$Reducer {
    constructor(stream, reducer, initState){
        this.stream = stream;
        this.reducer = reducer;
        this.state = initState;
        this.completed = new Promise((resolve, reject)=>{
            const subscription = this.stream.subscribe({
                next: (evt)=>{
                    this.state = this.reducer(this.state, evt);
                },
                complete: ()=>{
                    resolve();
                    // this must happen after resolve, to ensure stream.subscribe() has finished
                    subscription.unsubscribe();
                },
                error: (err)=>{
                    reject(err);
                    // the stream already closed on error, but unsubscribe to be safe
                    subscription.unsubscribe();
                }
            });
        });
    }
    // value returns current materialized state
    value() {
        return this.state;
    }
    // finished resolves on completed stream, rejects on stream error
    async finished() {
        return this.completed;
    }
}
module.exports.Reducer = $bfd1f7eda662cd09$var$Reducer;
function $bfd1f7eda662cd09$var$increment(sum, _) {
    return sum + 1;
}
// countStream returns a reducer that contains current count
// of events on the stream
function $bfd1f7eda662cd09$var$countStream(stream) {
    return new $bfd1f7eda662cd09$var$Reducer(stream, $bfd1f7eda662cd09$var$increment, 0);
}
module.exports.countStream = $bfd1f7eda662cd09$var$countStream;
function $bfd1f7eda662cd09$var$append(list, evt) {
    return [
        ...list,
        evt
    ];
}
// asArray maintains an array containing all events that have
// occurred on the stream
function $bfd1f7eda662cd09$var$asArray(stream) {
    return new $bfd1f7eda662cd09$var$Reducer(stream, $bfd1f7eda662cd09$var$append, []);
}
module.exports.asArray = $bfd1f7eda662cd09$var$asArray;
function $bfd1f7eda662cd09$var$last(_, event) {
    return event;
}
// lastValue returns the last value read from the stream, or undefined if no values sent
function $bfd1f7eda662cd09$var$lastValue(stream) {
    return new $bfd1f7eda662cd09$var$Reducer(stream, $bfd1f7eda662cd09$var$last, undefined);
}
module.exports.lastValue = $bfd1f7eda662cd09$var$lastValue;

});

parcelRequire.register("fURH5", function(module, exports) {
// https://github.com/maxogden/websocket-stream/blob/48dc3ddf943e5ada668c31ccd94e9186f02fafbd/ws-fallback.js
var $b965bc7cbc003eeb$var$ws = null;
if (typeof WebSocket !== "undefined") $b965bc7cbc003eeb$var$ws = WebSocket;
else if (typeof MozWebSocket !== "undefined") $b965bc7cbc003eeb$var$ws = MozWebSocket;
else if (typeof $parcel$global !== "undefined") $b965bc7cbc003eeb$var$ws = $parcel$global.WebSocket || $parcel$global.MozWebSocket;
else if (typeof window !== "undefined") $b965bc7cbc003eeb$var$ws = window.WebSocket || window.MozWebSocket;
else if (typeof self !== "undefined") $b965bc7cbc003eeb$var$ws = self.WebSocket || self.MozWebSocket;
module.exports = $b965bc7cbc003eeb$var$ws;

});

parcelRequire.register("8Bok5", function(module, exports) {
"use strict";
// Note: all exports in this module are publicly available via
// `import { tendermint34 } from "@cosmjs/tendermint-rpc"`
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Tendermint34Client = module.exports.VoteType = module.exports.broadcastTxSyncSuccess = module.exports.broadcastTxCommitSuccess = module.exports.SubscriptionEventType = module.exports.Method = void 0;

var $kGR9o = parcelRequire("kGR9o");
Object.defineProperty(module.exports, "Method", {
    enumerable: true,
    get: function() {
        return $kGR9o.Method;
    }
});
Object.defineProperty(module.exports, "SubscriptionEventType", {
    enumerable: true,
    get: function() {
        return $kGR9o.SubscriptionEventType;
    }
});

var $c96TB = parcelRequire("c96TB");
Object.defineProperty(module.exports, "broadcastTxCommitSuccess", {
    enumerable: true,
    get: function() {
        return $c96TB.broadcastTxCommitSuccess;
    }
});
Object.defineProperty(module.exports, "broadcastTxSyncSuccess", {
    enumerable: true,
    get: function() {
        return $c96TB.broadcastTxSyncSuccess;
    }
});
Object.defineProperty(module.exports, "VoteType", {
    enumerable: true,
    get: function() {
        return $c96TB.VoteType;
    }
});

var $jvX6T = parcelRequire("jvX6T");
Object.defineProperty(module.exports, "Tendermint34Client", {
    enumerable: true,
    get: function() {
        return $jvX6T.Tendermint34Client;
    }
});

});
parcelRequire.register("kGR9o", function(module, exports) {
"use strict";
/* eslint-disable @typescript-eslint/naming-convention */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.buildQuery = module.exports.SubscriptionEventType = module.exports.Method = void 0;
/**
 * RPC methods as documented in https://docs.tendermint.com/master/rpc/
 *
 * Enum raw value must match the spelling in the "shell" example call (snake_case)
 */ var $f100f577f4bdf7ec$var$Method;
(function(Method) {
    Method["AbciInfo"] = "abci_info";
    Method["AbciQuery"] = "abci_query";
    Method["Block"] = "block";
    /** Get block headers for minHeight <= height <= maxHeight. */ Method["Blockchain"] = "blockchain";
    Method["BlockResults"] = "block_results";
    Method["BlockSearch"] = "block_search";
    Method["BroadcastTxAsync"] = "broadcast_tx_async";
    Method["BroadcastTxSync"] = "broadcast_tx_sync";
    Method["BroadcastTxCommit"] = "broadcast_tx_commit";
    Method["Commit"] = "commit";
    Method["Genesis"] = "genesis";
    Method["Health"] = "health";
    Method["NumUnconfirmedTxs"] = "num_unconfirmed_txs";
    Method["Status"] = "status";
    Method["Subscribe"] = "subscribe";
    Method["Tx"] = "tx";
    Method["TxSearch"] = "tx_search";
    Method["Validators"] = "validators";
    Method["Unsubscribe"] = "unsubscribe";
})($f100f577f4bdf7ec$var$Method = module.exports.Method || (module.exports.Method = {}));
/**
 * Raw values must match the tendermint event name
 *
 * @see https://godoc.org/github.com/tendermint/tendermint/types#pkg-constants
 */ var $f100f577f4bdf7ec$var$SubscriptionEventType;
(function(SubscriptionEventType) {
    SubscriptionEventType["NewBlock"] = "NewBlock";
    SubscriptionEventType["NewBlockHeader"] = "NewBlockHeader";
    SubscriptionEventType["Tx"] = "Tx";
})($f100f577f4bdf7ec$var$SubscriptionEventType = module.exports.SubscriptionEventType || (module.exports.SubscriptionEventType = {}));
function $f100f577f4bdf7ec$var$buildQuery(components) {
    const tags = components.tags ? components.tags : [];
    const tagComponents = tags.map((tag)=>`${tag.key}='${tag.value}'`);
    const rawComponents = components.raw ? [
        components.raw
    ] : [];
    return [
        ...tagComponents,
        ...rawComponents
    ].join(" AND ");
}
module.exports.buildQuery = $f100f577f4bdf7ec$var$buildQuery;

});

parcelRequire.register("c96TB", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.VoteType = module.exports.broadcastTxCommitSuccess = module.exports.broadcastTxSyncSuccess = void 0;
/**
 * Returns true iff transaction made it successfully into the transaction pool
 */ function $8d7bacaa47542359$var$broadcastTxSyncSuccess(res) {
    // code must be 0 on success
    return res.code === 0;
}
module.exports.broadcastTxSyncSuccess = $8d7bacaa47542359$var$broadcastTxSyncSuccess;
/**
 * Returns true iff transaction made it successfully into a block
 * (i.e. success in `check_tx` and `deliver_tx` field)
 */ function $8d7bacaa47542359$var$broadcastTxCommitSuccess(response) {
    // code must be 0 on success
    // deliverTx may be present but empty on failure
    return response.checkTx.code === 0 && !!response.deliverTx && response.deliverTx.code === 0;
}
module.exports.broadcastTxCommitSuccess = $8d7bacaa47542359$var$broadcastTxCommitSuccess;
/**
 * raw values from https://github.com/tendermint/tendermint/blob/dfa9a9a30a666132425b29454e90a472aa579a48/types/vote.go#L44
 */ var $8d7bacaa47542359$var$VoteType;
(function(VoteType) {
    VoteType[VoteType["PreVote"] = 1] = "PreVote";
    VoteType[VoteType["PreCommit"] = 2] = "PreCommit";
})($8d7bacaa47542359$var$VoteType = module.exports.VoteType || (module.exports.VoteType = {}));

});

parcelRequire.register("jvX6T", function(module, exports) {
"use strict";
var $e34ec39bbc80ee67$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $e34ec39bbc80ee67$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $e34ec39bbc80ee67$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $e34ec39bbc80ee67$var$__createBinding(result, mod, k);
    }
    $e34ec39bbc80ee67$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Tendermint34Client = void 0;

var $2O5kv = parcelRequire("2O5kv");

var $iPMHy = parcelRequire("iPMHy");

var $eIDXY = parcelRequire("eIDXY");

const $e34ec39bbc80ee67$var$requests = $e34ec39bbc80ee67$var$__importStar((parcelRequire("kGR9o")));
class $e34ec39bbc80ee67$var$Tendermint34Client {
    /**
     * Creates a new Tendermint client for the given endpoint.
     *
     * Uses HTTP when the URL schema is http or https. Uses WebSockets otherwise.
     */ static async connect(endpoint) {
        let rpcClient;
        if (typeof endpoint === "object") rpcClient = new $iPMHy.HttpClient(endpoint);
        else {
            const useHttp = endpoint.startsWith("http://") || endpoint.startsWith("https://");
            rpcClient = useHttp ? new $iPMHy.HttpClient(endpoint) : new $iPMHy.WebsocketClient(endpoint);
        }
        // For some very strange reason I don't understand, tests start to fail on some systems
        // (our CI) when skipping the status call before doing other queries. Sleeping a little
        // while did not help. Thus we query the version as a way to say "hi" to the backend,
        // even in cases where we don't use the result.
        const _version = await this.detectVersion(rpcClient);
        return $e34ec39bbc80ee67$var$Tendermint34Client.create(rpcClient);
    }
    /**
     * Creates a new Tendermint client given an RPC client.
     */ static async create(rpcClient) {
        return new $e34ec39bbc80ee67$var$Tendermint34Client(rpcClient);
    }
    static async detectVersion(client) {
        const req = (0, $2O5kv.createJsonRpcRequest)($e34ec39bbc80ee67$var$requests.Method.Status);
        const response = await client.execute(req);
        const result = response.result;
        if (!result || !result.node_info) throw new Error("Unrecognized format for status response");
        const version = result.node_info.version;
        if (typeof version !== "string") throw new Error("Unrecognized version format: must be string");
        return version;
    }
    /**
     * Use `Tendermint34Client.connect` or `Tendermint34Client.create` to create an instance.
     */ constructor(client){
        this.client = client;
        this.p = $eIDXY.adaptor34.params;
        this.r = $eIDXY.adaptor34.responses;
    }
    disconnect() {
        this.client.disconnect();
    }
    async abciInfo() {
        const query = {
            method: $e34ec39bbc80ee67$var$requests.Method.AbciInfo
        };
        return this.doCall(query, this.p.encodeAbciInfo, this.r.decodeAbciInfo);
    }
    async abciQuery(params) {
        const query = {
            params: params,
            method: $e34ec39bbc80ee67$var$requests.Method.AbciQuery
        };
        return this.doCall(query, this.p.encodeAbciQuery, this.r.decodeAbciQuery);
    }
    async block(height) {
        const query = {
            method: $e34ec39bbc80ee67$var$requests.Method.Block,
            params: {
                height: height
            }
        };
        return this.doCall(query, this.p.encodeBlock, this.r.decodeBlock);
    }
    async blockResults(height) {
        const query = {
            method: $e34ec39bbc80ee67$var$requests.Method.BlockResults,
            params: {
                height: height
            }
        };
        return this.doCall(query, this.p.encodeBlockResults, this.r.decodeBlockResults);
    }
    /**
     * Search for events that are in a block.
     *
     * NOTE
     * This method will error on any node that is running a Tendermint version lower than 0.34.9.
     *
     * @see https://docs.tendermint.com/master/rpc/#/Info/block_search
     */ async blockSearch(params) {
        const query = {
            params: params,
            method: $e34ec39bbc80ee67$var$requests.Method.BlockSearch
        };
        const resp = await this.doCall(query, this.p.encodeBlockSearch, this.r.decodeBlockSearch);
        return {
            ...resp,
            // make sure we sort by height, as tendermint may be sorting by string value of the height
            blocks: [
                ...resp.blocks
            ].sort((a, b)=>a.block.header.height - b.block.header.height)
        };
    }
    // this should paginate through all blockSearch options to ensure it returns all results.
    // starts with page 1 or whatever was provided (eg. to start on page 7)
    //
    // NOTE
    // This method will error on any node that is running a Tendermint version lower than 0.34.9.
    async blockSearchAll(params) {
        let page = params.page || 1;
        const blocks = [];
        let done = false;
        while(!done){
            const resp = await this.blockSearch({
                ...params,
                page: page
            });
            blocks.push(...resp.blocks);
            if (blocks.length < resp.totalCount) page++;
            else done = true;
        }
        // make sure we sort by height, as tendermint may be sorting by string value of the height
        // and the earlier items may be in a higher page than the later items
        blocks.sort((a, b)=>a.block.header.height - b.block.header.height);
        return {
            totalCount: blocks.length,
            blocks: blocks
        };
    }
    /**
     * Queries block headers filtered by minHeight <= height <= maxHeight.
     *
     * @param minHeight The minimum height to be included in the result. Defaults to 0.
     * @param maxHeight The maximum height to be included in the result. Defaults to infinity.
     */ async blockchain(minHeight, maxHeight) {
        const query = {
            method: $e34ec39bbc80ee67$var$requests.Method.Blockchain,
            params: {
                minHeight: minHeight,
                maxHeight: maxHeight
            }
        };
        return this.doCall(query, this.p.encodeBlockchain, this.r.decodeBlockchain);
    }
    /**
     * Broadcast transaction to mempool and wait for response
     *
     * @see https://docs.tendermint.com/master/rpc/#/Tx/broadcast_tx_sync
     */ async broadcastTxSync(params) {
        const query = {
            params: params,
            method: $e34ec39bbc80ee67$var$requests.Method.BroadcastTxSync
        };
        return this.doCall(query, this.p.encodeBroadcastTx, this.r.decodeBroadcastTxSync);
    }
    /**
     * Broadcast transaction to mempool and do not wait for result
     *
     * @see https://docs.tendermint.com/master/rpc/#/Tx/broadcast_tx_async
     */ async broadcastTxAsync(params) {
        const query = {
            params: params,
            method: $e34ec39bbc80ee67$var$requests.Method.BroadcastTxAsync
        };
        return this.doCall(query, this.p.encodeBroadcastTx, this.r.decodeBroadcastTxAsync);
    }
    /**
     * Broadcast transaction to mempool and wait for block
     *
     * @see https://docs.tendermint.com/master/rpc/#/Tx/broadcast_tx_commit
     */ async broadcastTxCommit(params) {
        const query = {
            params: params,
            method: $e34ec39bbc80ee67$var$requests.Method.BroadcastTxCommit
        };
        return this.doCall(query, this.p.encodeBroadcastTx, this.r.decodeBroadcastTxCommit);
    }
    async commit(height) {
        const query = {
            method: $e34ec39bbc80ee67$var$requests.Method.Commit,
            params: {
                height: height
            }
        };
        return this.doCall(query, this.p.encodeCommit, this.r.decodeCommit);
    }
    async genesis() {
        const query = {
            method: $e34ec39bbc80ee67$var$requests.Method.Genesis
        };
        return this.doCall(query, this.p.encodeGenesis, this.r.decodeGenesis);
    }
    async health() {
        const query = {
            method: $e34ec39bbc80ee67$var$requests.Method.Health
        };
        return this.doCall(query, this.p.encodeHealth, this.r.decodeHealth);
    }
    async numUnconfirmedTxs() {
        const query = {
            method: $e34ec39bbc80ee67$var$requests.Method.NumUnconfirmedTxs
        };
        return this.doCall(query, this.p.encodeNumUnconfirmedTxs, this.r.decodeNumUnconfirmedTxs);
    }
    async status() {
        const query = {
            method: $e34ec39bbc80ee67$var$requests.Method.Status
        };
        return this.doCall(query, this.p.encodeStatus, this.r.decodeStatus);
    }
    subscribeNewBlock() {
        const request = {
            method: $e34ec39bbc80ee67$var$requests.Method.Subscribe,
            query: {
                type: $e34ec39bbc80ee67$var$requests.SubscriptionEventType.NewBlock
            }
        };
        return this.subscribe(request, this.r.decodeNewBlockEvent);
    }
    subscribeNewBlockHeader() {
        const request = {
            method: $e34ec39bbc80ee67$var$requests.Method.Subscribe,
            query: {
                type: $e34ec39bbc80ee67$var$requests.SubscriptionEventType.NewBlockHeader
            }
        };
        return this.subscribe(request, this.r.decodeNewBlockHeaderEvent);
    }
    subscribeTx(query) {
        const request = {
            method: $e34ec39bbc80ee67$var$requests.Method.Subscribe,
            query: {
                type: $e34ec39bbc80ee67$var$requests.SubscriptionEventType.Tx,
                raw: query
            }
        };
        return this.subscribe(request, this.r.decodeTxEvent);
    }
    /**
     * Get a single transaction by hash
     *
     * @see https://docs.tendermint.com/master/rpc/#/Info/tx
     */ async tx(params) {
        const query = {
            params: params,
            method: $e34ec39bbc80ee67$var$requests.Method.Tx
        };
        return this.doCall(query, this.p.encodeTx, this.r.decodeTx);
    }
    /**
     * Search for transactions that are in a block
     *
     * @see https://docs.tendermint.com/master/rpc/#/Info/tx_search
     */ async txSearch(params) {
        const query = {
            params: params,
            method: $e34ec39bbc80ee67$var$requests.Method.TxSearch
        };
        return this.doCall(query, this.p.encodeTxSearch, this.r.decodeTxSearch);
    }
    // this should paginate through all txSearch options to ensure it returns all results.
    // starts with page 1 or whatever was provided (eg. to start on page 7)
    async txSearchAll(params) {
        let page = params.page || 1;
        const txs = [];
        let done = false;
        while(!done){
            const resp = await this.txSearch({
                ...params,
                page: page
            });
            txs.push(...resp.txs);
            if (txs.length < resp.totalCount) page++;
            else done = true;
        }
        return {
            totalCount: txs.length,
            txs: txs
        };
    }
    async validators(params) {
        const query = {
            method: $e34ec39bbc80ee67$var$requests.Method.Validators,
            params: params
        };
        return this.doCall(query, this.p.encodeValidators, this.r.decodeValidators);
    }
    async validatorsAll(height) {
        const validators = [];
        let page = 1;
        let done = false;
        let blockHeight = height;
        while(!done){
            const response = await this.validators({
                per_page: 50,
                height: blockHeight,
                page: page
            });
            validators.push(...response.validators);
            blockHeight = blockHeight || response.blockHeight;
            if (validators.length < response.total) page++;
            else done = true;
        }
        return {
            // NOTE: Default value is for type safety but this should always be set
            blockHeight: blockHeight ?? 0,
            count: validators.length,
            total: validators.length,
            validators: validators
        };
    }
    // doCall is a helper to handle the encode/call/decode logic
    async doCall(request, encode, decode) {
        const req = encode(request);
        const result = await this.client.execute(req);
        return decode(result);
    }
    subscribe(request, decode) {
        if (!(0, $iPMHy.instanceOfRpcStreamingClient)(this.client)) throw new Error("This RPC client type cannot subscribe to events");
        const req = this.p.encodeSubscribe(request);
        const eventStream = this.client.listen(req);
        return eventStream.map((event)=>{
            return decode(event);
        });
    }
}
module.exports.Tendermint34Client = $e34ec39bbc80ee67$var$Tendermint34Client;

});
parcelRequire.register("2O5kv", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.createJsonRpcRequest = void 0;
const $20b462a83f985b6a$var$numbersWithoutZero = "123456789";
/** generates a random numeric character  */ function $20b462a83f985b6a$var$randomNumericChar() {
    return $20b462a83f985b6a$var$numbersWithoutZero[Math.floor(Math.random() * $20b462a83f985b6a$var$numbersWithoutZero.length)];
}
/**
 * An (absolutely not cryptographically secure) random integer > 0.
 */ function $20b462a83f985b6a$var$randomId() {
    return parseInt(Array.from({
        length: 12
    }).map(()=>$20b462a83f985b6a$var$randomNumericChar()).join(""), 10);
}
/** Creates a JSON-RPC request with random ID */ // eslint-disable-next-line @typescript-eslint/ban-types
function $20b462a83f985b6a$var$createJsonRpcRequest(method, params) {
    const paramsCopy = params ? {
        ...params
    } : {};
    return {
        jsonrpc: "2.0",
        id: $20b462a83f985b6a$var$randomId(),
        method: method,
        params: paramsCopy
    };
}
module.exports.createJsonRpcRequest = $20b462a83f985b6a$var$createJsonRpcRequest;

});

parcelRequire.register("iPMHy", function(module, exports) {
"use strict";
// This folder contains Tendermint-specific RPC clients
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.WebsocketClient = module.exports.instanceOfRpcStreamingClient = module.exports.HttpClient = module.exports.HttpBatchClient = void 0;

var $2POu5 = parcelRequire("2POu5");
Object.defineProperty(module.exports, "HttpBatchClient", {
    enumerable: true,
    get: function() {
        return $2POu5.HttpBatchClient;
    }
});

var $egGjY = parcelRequire("egGjY");
Object.defineProperty(module.exports, "HttpClient", {
    enumerable: true,
    get: function() {
        return $egGjY.HttpClient;
    }
});

var $8d2qc = parcelRequire("8d2qc");
Object.defineProperty(module.exports, "instanceOfRpcStreamingClient", {
    enumerable: true,
    get: function() {
        return $8d2qc.instanceOfRpcStreamingClient;
    }
});

var $cH3Sa = parcelRequire("cH3Sa");
Object.defineProperty(module.exports, "WebsocketClient", {
    enumerable: true,
    get: function() {
        return $cH3Sa.WebsocketClient;
    }
});

});
parcelRequire.register("2POu5", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.HttpBatchClient = void 0;

var $gBmRC = parcelRequire("gBmRC");

var $ldhG0 = parcelRequire("ldhG0");

var $8d2qc = parcelRequire("8d2qc");
// Those values are private and can change any time.
// Does a user need to know them? I don't think so. You either set
// a custom value or leave the option field unset.
const $2107814aeca91461$var$defaultHttpBatchClientOptions = {
    dispatchInterval: 20,
    batchSizeLimit: 20
};
class $2107814aeca91461$var$HttpBatchClient {
    constructor(endpoint, options = {}){
        this.queue = [];
        this.options = {
            batchSizeLimit: options.batchSizeLimit ?? $2107814aeca91461$var$defaultHttpBatchClientOptions.batchSizeLimit,
            dispatchInterval: options.dispatchInterval ?? $2107814aeca91461$var$defaultHttpBatchClientOptions.dispatchInterval
        };
        if (typeof endpoint === "string") // accept host.name:port and assume http protocol
        this.url = (0, $8d2qc.hasProtocol)(endpoint) ? endpoint : "http://" + endpoint;
        else {
            this.url = endpoint.url;
            this.headers = endpoint.headers;
        }
        this.timer = setInterval(()=>this.tick(), options.dispatchInterval);
        this.validate();
    }
    disconnect() {
        this.timer && clearInterval(this.timer);
        this.timer = undefined;
    }
    async execute(request) {
        return new Promise((resolve, reject)=>{
            this.queue.push({
                request: request,
                resolve: resolve,
                reject: reject
            });
            if (this.queue.length >= this.options.batchSizeLimit) // this train is full, let's go
            this.tick();
        });
    }
    validate() {
        if (!this.options.batchSizeLimit || !Number.isSafeInteger(this.options.batchSizeLimit) || this.options.batchSizeLimit < 1) throw new Error("batchSizeLimit must be a safe integer >= 1");
    }
    /**
     * This is called in an interval where promise rejections cannot be handled.
     * So this is not async and HTTP errors need to be handled by the queued promises.
     */ tick() {
        // Avoid race conditions
        const batch = this.queue.splice(0, this.options.batchSizeLimit);
        if (!batch.length) return;
        const requests = batch.map((s)=>s.request);
        const requestIds = requests.map((request)=>request.id);
        (0, $ldhG0.http)("POST", this.url, this.headers, requests).then((raw)=>{
            // Requests with a single entry return as an object
            const arr = Array.isArray(raw) ? raw : [
                raw
            ];
            arr.forEach((el)=>{
                const req = batch.find((s)=>s.request.id === el.id);
                if (!req) return;
                const { reject: reject, resolve: resolve } = req;
                const response = (0, $gBmRC.parseJsonRpcResponse)(el);
                if ((0, $gBmRC.isJsonRpcErrorResponse)(response)) reject(new Error(JSON.stringify(response.error)));
                else resolve(response);
            });
        }, (error)=>{
            for (const requestId of requestIds){
                const req = batch.find((s)=>s.request.id === requestId);
                if (!req) return;
                req.reject(error);
            }
        });
    }
}
module.exports.HttpBatchClient = $2107814aeca91461$var$HttpBatchClient;

});
parcelRequire.register("gBmRC", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.jsonRpcCode = module.exports.isJsonRpcSuccessResponse = module.exports.isJsonRpcErrorResponse = module.exports.parseJsonRpcSuccessResponse = module.exports.parseJsonRpcResponse = module.exports.parseJsonRpcRequest = module.exports.parseJsonRpcId = module.exports.parseJsonRpcErrorResponse = module.exports.JsonRpcClient = module.exports.makeJsonRpcId = void 0;

var $4G5Ln = parcelRequire("4G5Ln");
Object.defineProperty(module.exports, "makeJsonRpcId", {
    enumerable: true,
    get: function() {
        return $4G5Ln.makeJsonRpcId;
    }
});

var $9z77B = parcelRequire("9z77B");
Object.defineProperty(module.exports, "JsonRpcClient", {
    enumerable: true,
    get: function() {
        return $9z77B.JsonRpcClient;
    }
});

var $g4V3Q = parcelRequire("g4V3Q");
Object.defineProperty(module.exports, "parseJsonRpcErrorResponse", {
    enumerable: true,
    get: function() {
        return $g4V3Q.parseJsonRpcErrorResponse;
    }
});
Object.defineProperty(module.exports, "parseJsonRpcId", {
    enumerable: true,
    get: function() {
        return $g4V3Q.parseJsonRpcId;
    }
});
Object.defineProperty(module.exports, "parseJsonRpcRequest", {
    enumerable: true,
    get: function() {
        return $g4V3Q.parseJsonRpcRequest;
    }
});
Object.defineProperty(module.exports, "parseJsonRpcResponse", {
    enumerable: true,
    get: function() {
        return $g4V3Q.parseJsonRpcResponse;
    }
});
Object.defineProperty(module.exports, "parseJsonRpcSuccessResponse", {
    enumerable: true,
    get: function() {
        return $g4V3Q.parseJsonRpcSuccessResponse;
    }
});

var $47ZKU = parcelRequire("47ZKU");
Object.defineProperty(module.exports, "isJsonRpcErrorResponse", {
    enumerable: true,
    get: function() {
        return $47ZKU.isJsonRpcErrorResponse;
    }
});
Object.defineProperty(module.exports, "isJsonRpcSuccessResponse", {
    enumerable: true,
    get: function() {
        return $47ZKU.isJsonRpcSuccessResponse;
    }
});
Object.defineProperty(module.exports, "jsonRpcCode", {
    enumerable: true,
    get: function() {
        return $47ZKU.jsonRpcCode;
    }
});

});
parcelRequire.register("4G5Ln", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.makeJsonRpcId = void 0;
// Start with 10001 to avoid possible collisions with all hand-selected values like e.g. 1,2,3,42,100
let $367f8e1f2233661c$var$counter = 10000;
/**
 * Creates a new ID to be used for creating a JSON-RPC request.
 *
 * Multiple calls of this produce unique values.
 *
 * The output may be any value compatible to JSON-RPC request IDs with an undefined output format and generation logic.
 */ function $367f8e1f2233661c$var$makeJsonRpcId() {
    return $367f8e1f2233661c$var$counter += 1;
}
module.exports.makeJsonRpcId = $367f8e1f2233661c$var$makeJsonRpcId;

});

parcelRequire.register("9z77B", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.JsonRpcClient = void 0;

var $8iJvX = parcelRequire("8iJvX");

var $47ZKU = parcelRequire("47ZKU");
/**
 * A thin wrapper that is used to bring together requests and responses by ID.
 *
 * Using this class is only advised for continous communication channels like
 * WebSockets or WebWorker messaging.
 */ class $6f6ce827eaf7eacf$var$JsonRpcClient {
    constructor(connection){
        this.connection = connection;
    }
    async run(request) {
        const filteredStream = this.connection.responseStream.filter((r)=>r.id === request.id);
        const pendingResponses = (0, $8iJvX.firstEvent)(filteredStream);
        this.connection.sendRequest(request);
        const response = await pendingResponses;
        if ((0, $47ZKU.isJsonRpcErrorResponse)(response)) {
            const error = response.error;
            throw new Error(`JSON RPC error: code=${error.code}; message='${error.message}'`);
        }
        return response;
    }
}
module.exports.JsonRpcClient = $6f6ce827eaf7eacf$var$JsonRpcClient;

});
parcelRequire.register("8iJvX", function(module, exports) {
"use strict";
var $60b34f60c9633461$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $60b34f60c9633461$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $60b34f60c9633461$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ValueAndUpdates = module.exports.toListPromise = module.exports.fromListPromise = module.exports.firstEvent = module.exports.dropDuplicates = module.exports.DefaultValueProducer = module.exports.concat = void 0;

var $892Mp = parcelRequire("892Mp");
Object.defineProperty(module.exports, "concat", {
    enumerable: true,
    get: function() {
        return $892Mp.concat;
    }
});

var $b9Q8k = parcelRequire("b9Q8k");
Object.defineProperty(module.exports, "DefaultValueProducer", {
    enumerable: true,
    get: function() {
        return $b9Q8k.DefaultValueProducer;
    }
});

var $icuEp = parcelRequire("icuEp");
Object.defineProperty(module.exports, "dropDuplicates", {
    enumerable: true,
    get: function() {
        return $icuEp.dropDuplicates;
    }
});

var $bTrax = parcelRequire("bTrax");
Object.defineProperty(module.exports, "firstEvent", {
    enumerable: true,
    get: function() {
        return $bTrax.firstEvent;
    }
});
Object.defineProperty(module.exports, "fromListPromise", {
    enumerable: true,
    get: function() {
        return $bTrax.fromListPromise;
    }
});
Object.defineProperty(module.exports, "toListPromise", {
    enumerable: true,
    get: function() {
        return $bTrax.toListPromise;
    }
});

$60b34f60c9633461$var$__exportStar((parcelRequire("gt3mZ")), module.exports);

var $lQJtF = parcelRequire("lQJtF");
Object.defineProperty(module.exports, "ValueAndUpdates", {
    enumerable: true,
    get: function() {
        return $lQJtF.ValueAndUpdates;
    }
});

});
parcelRequire.register("892Mp", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.concat = void 0;

var $kXS5t = parcelRequire("kXS5t");
/**
 * An implementation of concat that buffers all source stream events
 *
 * Marble diagram:
 *
 * ```text
 * --1--2---3---4-|
 * -a--b-c--d-|
 * --------X---------Y---------Z-
 *           concat
 * --1--2---3---4-abcdXY-------Z-
 * ```
 *
 * This is inspired by RxJS's concat as documented at http://rxmarbles.com/#concat and behaves
 * differently than xstream's concat as discussed in https://github.com/staltz/xstream/issues/170.
 *
 */ function $5ee152001b02170e$var$concat(...streams) {
    const subscriptions = new Array();
    const queues = new Array(); // one queue per stream
    const completedStreams = new Set();
    let activeStreamIndex = 0;
    function reset() {
        while(subscriptions.length > 0){
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            const subscription = subscriptions.shift();
            subscription.unsubscribe();
        }
        queues.length = 0;
        completedStreams.clear();
        activeStreamIndex = 0;
    }
    const producer = {
        start: (listener)=>{
            streams.forEach((_)=>queues.push([]));
            function emitAllQueuesEvents(streamIndex) {
                // eslint-disable-next-line no-constant-condition
                while(true){
                    const element = queues[streamIndex].shift();
                    if (element === undefined) return;
                    listener.next(element);
                }
            }
            function isDone() {
                return activeStreamIndex >= streams.length;
            }
            if (isDone()) {
                listener.complete();
                return;
            }
            streams.forEach((stream, index)=>{
                subscriptions.push(stream.subscribe({
                    next: (value)=>{
                        if (index === activeStreamIndex) listener.next(value);
                        else queues[index].push(value);
                    },
                    complete: ()=>{
                        completedStreams.add(index);
                        while(completedStreams.has(activeStreamIndex)){
                            // this stream completed: emit all and move on
                            emitAllQueuesEvents(activeStreamIndex);
                            activeStreamIndex++;
                        }
                        if (isDone()) listener.complete();
                        else // now active stream can have some events queued but did not yet complete
                        emitAllQueuesEvents(activeStreamIndex);
                    },
                    error: (error)=>{
                        listener.error(error);
                        reset();
                    }
                }));
            });
        },
        stop: ()=>{
            reset();
        }
    };
    return $kXS5t.Stream.create(producer);
}
module.exports.concat = $5ee152001b02170e$var$concat;

});
parcelRequire.register("kXS5t", function(module, exports) {
"use strict";
var $f43345ec9793d55d$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.NO_IL = module.exports.NO = module.exports.MemoryStream = module.exports.Stream = void 0;

var $d1iPW = parcelRequire("d1iPW");

var $k0eww = parcelRequire("k0eww");
var $f43345ec9793d55d$var$$$observable = $d1iPW.default($k0eww.getPolyfill());
var $f43345ec9793d55d$var$NO = {};
module.exports.NO = $f43345ec9793d55d$var$NO;
function $f43345ec9793d55d$var$noop() {}
function $f43345ec9793d55d$var$cp(a) {
    var l = a.length;
    var b = Array(l);
    for(var i = 0; i < l; ++i)b[i] = a[i];
    return b;
}
function $f43345ec9793d55d$var$and(f1, f2) {
    return function andFn(t) {
        return f1(t) && f2(t);
    };
}
function $f43345ec9793d55d$var$_try(c, t, u) {
    try {
        return c.f(t);
    } catch (e) {
        u._e(e);
        return $f43345ec9793d55d$var$NO;
    }
}
var $f43345ec9793d55d$var$NO_IL = {
    _n: $f43345ec9793d55d$var$noop,
    _e: $f43345ec9793d55d$var$noop,
    _c: $f43345ec9793d55d$var$noop
};
module.exports.NO_IL = $f43345ec9793d55d$var$NO_IL;
// mutates the input
function $f43345ec9793d55d$var$internalizeProducer(producer) {
    producer._start = function _start(il) {
        il.next = il._n;
        il.error = il._e;
        il.complete = il._c;
        this.start(il);
    };
    producer._stop = producer.stop;
}
var $f43345ec9793d55d$var$StreamSub = /** @class */ function() {
    function StreamSub(_stream, _listener) {
        this._stream = _stream;
        this._listener = _listener;
    }
    StreamSub.prototype.unsubscribe = function() {
        this._stream._remove(this._listener);
    };
    return StreamSub;
}();
var $f43345ec9793d55d$var$Observer = /** @class */ function() {
    function Observer(_listener) {
        this._listener = _listener;
    }
    Observer.prototype.next = function(value) {
        this._listener._n(value);
    };
    Observer.prototype.error = function(err) {
        this._listener._e(err);
    };
    Observer.prototype.complete = function() {
        this._listener._c();
    };
    return Observer;
}();
var $f43345ec9793d55d$var$FromObservable = /** @class */ function() {
    function FromObservable(observable) {
        this.type = "fromObservable";
        this.ins = observable;
        this.active = false;
    }
    FromObservable.prototype._start = function(out) {
        this.out = out;
        this.active = true;
        this._sub = this.ins.subscribe(new $f43345ec9793d55d$var$Observer(out));
        if (!this.active) this._sub.unsubscribe();
    };
    FromObservable.prototype._stop = function() {
        if (this._sub) this._sub.unsubscribe();
        this.active = false;
    };
    return FromObservable;
}();
var $f43345ec9793d55d$var$Merge = /** @class */ function() {
    function Merge(insArr) {
        this.type = "merge";
        this.insArr = insArr;
        this.out = $f43345ec9793d55d$var$NO;
        this.ac = 0;
    }
    Merge.prototype._start = function(out) {
        this.out = out;
        var s = this.insArr;
        var L = s.length;
        this.ac = L;
        for(var i = 0; i < L; i++)s[i]._add(this);
    };
    Merge.prototype._stop = function() {
        var s = this.insArr;
        var L = s.length;
        for(var i = 0; i < L; i++)s[i]._remove(this);
        this.out = $f43345ec9793d55d$var$NO;
    };
    Merge.prototype._n = function(t) {
        var u = this.out;
        if (u === $f43345ec9793d55d$var$NO) return;
        u._n(t);
    };
    Merge.prototype._e = function(err) {
        var u = this.out;
        if (u === $f43345ec9793d55d$var$NO) return;
        u._e(err);
    };
    Merge.prototype._c = function() {
        if (--this.ac <= 0) {
            var u = this.out;
            if (u === $f43345ec9793d55d$var$NO) return;
            u._c();
        }
    };
    return Merge;
}();
var $f43345ec9793d55d$var$CombineListener = /** @class */ function() {
    function CombineListener(i, out, p) {
        this.i = i;
        this.out = out;
        this.p = p;
        p.ils.push(this);
    }
    CombineListener.prototype._n = function(t) {
        var p = this.p, out = this.out;
        if (out === $f43345ec9793d55d$var$NO) return;
        if (p.up(t, this.i)) {
            var b = $f43345ec9793d55d$var$cp(p.vals);
            out._n(b);
        }
    };
    CombineListener.prototype._e = function(err) {
        var out = this.out;
        if (out === $f43345ec9793d55d$var$NO) return;
        out._e(err);
    };
    CombineListener.prototype._c = function() {
        var p = this.p;
        if (p.out === $f43345ec9793d55d$var$NO) return;
        if (--p.Nc === 0) p.out._c();
    };
    return CombineListener;
}();
var $f43345ec9793d55d$var$Combine = /** @class */ function() {
    function Combine(insArr) {
        this.type = "combine";
        this.insArr = insArr;
        this.out = $f43345ec9793d55d$var$NO;
        this.ils = [];
        this.Nc = this.Nn = 0;
        this.vals = [];
    }
    Combine.prototype.up = function(t, i) {
        var v = this.vals[i];
        var Nn = !this.Nn ? 0 : v === $f43345ec9793d55d$var$NO ? --this.Nn : this.Nn;
        this.vals[i] = t;
        return Nn === 0;
    };
    Combine.prototype._start = function(out) {
        this.out = out;
        var s = this.insArr;
        var n = this.Nc = this.Nn = s.length;
        var vals = this.vals = new Array(n);
        if (n === 0) {
            out._n([]);
            out._c();
        } else for(var i = 0; i < n; i++){
            vals[i] = $f43345ec9793d55d$var$NO;
            s[i]._add(new $f43345ec9793d55d$var$CombineListener(i, out, this));
        }
    };
    Combine.prototype._stop = function() {
        var s = this.insArr;
        var n = s.length;
        var ils = this.ils;
        for(var i = 0; i < n; i++)s[i]._remove(ils[i]);
        this.out = $f43345ec9793d55d$var$NO;
        this.ils = [];
        this.vals = [];
    };
    return Combine;
}();
var $f43345ec9793d55d$var$FromArray = /** @class */ function() {
    function FromArray(a) {
        this.type = "fromArray";
        this.a = a;
    }
    FromArray.prototype._start = function(out) {
        var a = this.a;
        for(var i = 0, n = a.length; i < n; i++)out._n(a[i]);
        out._c();
    };
    FromArray.prototype._stop = function() {};
    return FromArray;
}();
var $f43345ec9793d55d$var$FromPromise = /** @class */ function() {
    function FromPromise(p) {
        this.type = "fromPromise";
        this.on = false;
        this.p = p;
    }
    FromPromise.prototype._start = function(out) {
        var prod = this;
        this.on = true;
        this.p.then(function(v) {
            if (prod.on) {
                out._n(v);
                out._c();
            }
        }, function(e) {
            out._e(e);
        }).then($f43345ec9793d55d$var$noop, function(err) {
            setTimeout(function() {
                throw err;
            });
        });
    };
    FromPromise.prototype._stop = function() {
        this.on = false;
    };
    return FromPromise;
}();
var $f43345ec9793d55d$var$Periodic = /** @class */ function() {
    function Periodic(period) {
        this.type = "periodic";
        this.period = period;
        this.intervalID = -1;
        this.i = 0;
    }
    Periodic.prototype._start = function(out) {
        var self = this;
        function intervalHandler() {
            out._n(self.i++);
        }
        this.intervalID = setInterval(intervalHandler, this.period);
    };
    Periodic.prototype._stop = function() {
        if (this.intervalID !== -1) clearInterval(this.intervalID);
        this.intervalID = -1;
        this.i = 0;
    };
    return Periodic;
}();
var $f43345ec9793d55d$var$Debug = /** @class */ function() {
    function Debug(ins, arg) {
        this.type = "debug";
        this.ins = ins;
        this.out = $f43345ec9793d55d$var$NO;
        this.s = $f43345ec9793d55d$var$noop;
        this.l = "";
        if (typeof arg === "string") this.l = arg;
        else if (typeof arg === "function") this.s = arg;
    }
    Debug.prototype._start = function(out) {
        this.out = out;
        this.ins._add(this);
    };
    Debug.prototype._stop = function() {
        this.ins._remove(this);
        this.out = $f43345ec9793d55d$var$NO;
    };
    Debug.prototype._n = function(t) {
        var u = this.out;
        if (u === $f43345ec9793d55d$var$NO) return;
        var s = this.s, l = this.l;
        if (s !== $f43345ec9793d55d$var$noop) try {
            s(t);
        } catch (e) {
            u._e(e);
        }
        else if (l) console.log(l + ":", t);
        else console.log(t);
        u._n(t);
    };
    Debug.prototype._e = function(err) {
        var u = this.out;
        if (u === $f43345ec9793d55d$var$NO) return;
        u._e(err);
    };
    Debug.prototype._c = function() {
        var u = this.out;
        if (u === $f43345ec9793d55d$var$NO) return;
        u._c();
    };
    return Debug;
}();
var $f43345ec9793d55d$var$Drop = /** @class */ function() {
    function Drop(max, ins) {
        this.type = "drop";
        this.ins = ins;
        this.out = $f43345ec9793d55d$var$NO;
        this.max = max;
        this.dropped = 0;
    }
    Drop.prototype._start = function(out) {
        this.out = out;
        this.dropped = 0;
        this.ins._add(this);
    };
    Drop.prototype._stop = function() {
        this.ins._remove(this);
        this.out = $f43345ec9793d55d$var$NO;
    };
    Drop.prototype._n = function(t) {
        var u = this.out;
        if (u === $f43345ec9793d55d$var$NO) return;
        if (this.dropped++ >= this.max) u._n(t);
    };
    Drop.prototype._e = function(err) {
        var u = this.out;
        if (u === $f43345ec9793d55d$var$NO) return;
        u._e(err);
    };
    Drop.prototype._c = function() {
        var u = this.out;
        if (u === $f43345ec9793d55d$var$NO) return;
        u._c();
    };
    return Drop;
}();
var $f43345ec9793d55d$var$EndWhenListener = /** @class */ function() {
    function EndWhenListener(out, op) {
        this.out = out;
        this.op = op;
    }
    EndWhenListener.prototype._n = function() {
        this.op.end();
    };
    EndWhenListener.prototype._e = function(err) {
        this.out._e(err);
    };
    EndWhenListener.prototype._c = function() {
        this.op.end();
    };
    return EndWhenListener;
}();
var $f43345ec9793d55d$var$EndWhen = /** @class */ function() {
    function EndWhen(o, ins) {
        this.type = "endWhen";
        this.ins = ins;
        this.out = $f43345ec9793d55d$var$NO;
        this.o = o;
        this.oil = $f43345ec9793d55d$var$NO_IL;
    }
    EndWhen.prototype._start = function(out) {
        this.out = out;
        this.o._add(this.oil = new $f43345ec9793d55d$var$EndWhenListener(out, this));
        this.ins._add(this);
    };
    EndWhen.prototype._stop = function() {
        this.ins._remove(this);
        this.o._remove(this.oil);
        this.out = $f43345ec9793d55d$var$NO;
        this.oil = $f43345ec9793d55d$var$NO_IL;
    };
    EndWhen.prototype.end = function() {
        var u = this.out;
        if (u === $f43345ec9793d55d$var$NO) return;
        u._c();
    };
    EndWhen.prototype._n = function(t) {
        var u = this.out;
        if (u === $f43345ec9793d55d$var$NO) return;
        u._n(t);
    };
    EndWhen.prototype._e = function(err) {
        var u = this.out;
        if (u === $f43345ec9793d55d$var$NO) return;
        u._e(err);
    };
    EndWhen.prototype._c = function() {
        this.end();
    };
    return EndWhen;
}();
var $f43345ec9793d55d$var$Filter = /** @class */ function() {
    function Filter(passes, ins) {
        this.type = "filter";
        this.ins = ins;
        this.out = $f43345ec9793d55d$var$NO;
        this.f = passes;
    }
    Filter.prototype._start = function(out) {
        this.out = out;
        this.ins._add(this);
    };
    Filter.prototype._stop = function() {
        this.ins._remove(this);
        this.out = $f43345ec9793d55d$var$NO;
    };
    Filter.prototype._n = function(t) {
        var u = this.out;
        if (u === $f43345ec9793d55d$var$NO) return;
        var r = $f43345ec9793d55d$var$_try(this, t, u);
        if (r === $f43345ec9793d55d$var$NO || !r) return;
        u._n(t);
    };
    Filter.prototype._e = function(err) {
        var u = this.out;
        if (u === $f43345ec9793d55d$var$NO) return;
        u._e(err);
    };
    Filter.prototype._c = function() {
        var u = this.out;
        if (u === $f43345ec9793d55d$var$NO) return;
        u._c();
    };
    return Filter;
}();
var $f43345ec9793d55d$var$FlattenListener = /** @class */ function() {
    function FlattenListener(out, op) {
        this.out = out;
        this.op = op;
    }
    FlattenListener.prototype._n = function(t) {
        this.out._n(t);
    };
    FlattenListener.prototype._e = function(err) {
        this.out._e(err);
    };
    FlattenListener.prototype._c = function() {
        this.op.inner = $f43345ec9793d55d$var$NO;
        this.op.less();
    };
    return FlattenListener;
}();
var $f43345ec9793d55d$var$Flatten = /** @class */ function() {
    function Flatten(ins) {
        this.type = "flatten";
        this.ins = ins;
        this.out = $f43345ec9793d55d$var$NO;
        this.open = true;
        this.inner = $f43345ec9793d55d$var$NO;
        this.il = $f43345ec9793d55d$var$NO_IL;
    }
    Flatten.prototype._start = function(out) {
        this.out = out;
        this.open = true;
        this.inner = $f43345ec9793d55d$var$NO;
        this.il = $f43345ec9793d55d$var$NO_IL;
        this.ins._add(this);
    };
    Flatten.prototype._stop = function() {
        this.ins._remove(this);
        if (this.inner !== $f43345ec9793d55d$var$NO) this.inner._remove(this.il);
        this.out = $f43345ec9793d55d$var$NO;
        this.open = true;
        this.inner = $f43345ec9793d55d$var$NO;
        this.il = $f43345ec9793d55d$var$NO_IL;
    };
    Flatten.prototype.less = function() {
        var u = this.out;
        if (u === $f43345ec9793d55d$var$NO) return;
        if (!this.open && this.inner === $f43345ec9793d55d$var$NO) u._c();
    };
    Flatten.prototype._n = function(s) {
        var u = this.out;
        if (u === $f43345ec9793d55d$var$NO) return;
        var _a = this, inner = _a.inner, il = _a.il;
        if (inner !== $f43345ec9793d55d$var$NO && il !== $f43345ec9793d55d$var$NO_IL) inner._remove(il);
        (this.inner = s)._add(this.il = new $f43345ec9793d55d$var$FlattenListener(u, this));
    };
    Flatten.prototype._e = function(err) {
        var u = this.out;
        if (u === $f43345ec9793d55d$var$NO) return;
        u._e(err);
    };
    Flatten.prototype._c = function() {
        this.open = false;
        this.less();
    };
    return Flatten;
}();
var $f43345ec9793d55d$var$Fold = /** @class */ function() {
    function Fold(f, seed, ins) {
        var _this = this;
        this.type = "fold";
        this.ins = ins;
        this.out = $f43345ec9793d55d$var$NO;
        this.f = function(t) {
            return f(_this.acc, t);
        };
        this.acc = this.seed = seed;
    }
    Fold.prototype._start = function(out) {
        this.out = out;
        this.acc = this.seed;
        out._n(this.acc);
        this.ins._add(this);
    };
    Fold.prototype._stop = function() {
        this.ins._remove(this);
        this.out = $f43345ec9793d55d$var$NO;
        this.acc = this.seed;
    };
    Fold.prototype._n = function(t) {
        var u = this.out;
        if (u === $f43345ec9793d55d$var$NO) return;
        var r = $f43345ec9793d55d$var$_try(this, t, u);
        if (r === $f43345ec9793d55d$var$NO) return;
        u._n(this.acc = r);
    };
    Fold.prototype._e = function(err) {
        var u = this.out;
        if (u === $f43345ec9793d55d$var$NO) return;
        u._e(err);
    };
    Fold.prototype._c = function() {
        var u = this.out;
        if (u === $f43345ec9793d55d$var$NO) return;
        u._c();
    };
    return Fold;
}();
var $f43345ec9793d55d$var$Last = /** @class */ function() {
    function Last(ins) {
        this.type = "last";
        this.ins = ins;
        this.out = $f43345ec9793d55d$var$NO;
        this.has = false;
        this.val = $f43345ec9793d55d$var$NO;
    }
    Last.prototype._start = function(out) {
        this.out = out;
        this.has = false;
        this.ins._add(this);
    };
    Last.prototype._stop = function() {
        this.ins._remove(this);
        this.out = $f43345ec9793d55d$var$NO;
        this.val = $f43345ec9793d55d$var$NO;
    };
    Last.prototype._n = function(t) {
        this.has = true;
        this.val = t;
    };
    Last.prototype._e = function(err) {
        var u = this.out;
        if (u === $f43345ec9793d55d$var$NO) return;
        u._e(err);
    };
    Last.prototype._c = function() {
        var u = this.out;
        if (u === $f43345ec9793d55d$var$NO) return;
        if (this.has) {
            u._n(this.val);
            u._c();
        } else u._e(new Error("last() failed because input stream completed"));
    };
    return Last;
}();
var $f43345ec9793d55d$var$MapOp = /** @class */ function() {
    function MapOp(project, ins) {
        this.type = "map";
        this.ins = ins;
        this.out = $f43345ec9793d55d$var$NO;
        this.f = project;
    }
    MapOp.prototype._start = function(out) {
        this.out = out;
        this.ins._add(this);
    };
    MapOp.prototype._stop = function() {
        this.ins._remove(this);
        this.out = $f43345ec9793d55d$var$NO;
    };
    MapOp.prototype._n = function(t) {
        var u = this.out;
        if (u === $f43345ec9793d55d$var$NO) return;
        var r = $f43345ec9793d55d$var$_try(this, t, u);
        if (r === $f43345ec9793d55d$var$NO) return;
        u._n(r);
    };
    MapOp.prototype._e = function(err) {
        var u = this.out;
        if (u === $f43345ec9793d55d$var$NO) return;
        u._e(err);
    };
    MapOp.prototype._c = function() {
        var u = this.out;
        if (u === $f43345ec9793d55d$var$NO) return;
        u._c();
    };
    return MapOp;
}();
var $f43345ec9793d55d$var$Remember = /** @class */ function() {
    function Remember(ins) {
        this.type = "remember";
        this.ins = ins;
        this.out = $f43345ec9793d55d$var$NO;
    }
    Remember.prototype._start = function(out) {
        this.out = out;
        this.ins._add(out);
    };
    Remember.prototype._stop = function() {
        this.ins._remove(this.out);
        this.out = $f43345ec9793d55d$var$NO;
    };
    return Remember;
}();
var $f43345ec9793d55d$var$ReplaceError = /** @class */ function() {
    function ReplaceError(replacer, ins) {
        this.type = "replaceError";
        this.ins = ins;
        this.out = $f43345ec9793d55d$var$NO;
        this.f = replacer;
    }
    ReplaceError.prototype._start = function(out) {
        this.out = out;
        this.ins._add(this);
    };
    ReplaceError.prototype._stop = function() {
        this.ins._remove(this);
        this.out = $f43345ec9793d55d$var$NO;
    };
    ReplaceError.prototype._n = function(t) {
        var u = this.out;
        if (u === $f43345ec9793d55d$var$NO) return;
        u._n(t);
    };
    ReplaceError.prototype._e = function(err) {
        var u = this.out;
        if (u === $f43345ec9793d55d$var$NO) return;
        try {
            this.ins._remove(this);
            (this.ins = this.f(err))._add(this);
        } catch (e) {
            u._e(e);
        }
    };
    ReplaceError.prototype._c = function() {
        var u = this.out;
        if (u === $f43345ec9793d55d$var$NO) return;
        u._c();
    };
    return ReplaceError;
}();
var $f43345ec9793d55d$var$StartWith = /** @class */ function() {
    function StartWith(ins, val) {
        this.type = "startWith";
        this.ins = ins;
        this.out = $f43345ec9793d55d$var$NO;
        this.val = val;
    }
    StartWith.prototype._start = function(out) {
        this.out = out;
        this.out._n(this.val);
        this.ins._add(out);
    };
    StartWith.prototype._stop = function() {
        this.ins._remove(this.out);
        this.out = $f43345ec9793d55d$var$NO;
    };
    return StartWith;
}();
var $f43345ec9793d55d$var$Take = /** @class */ function() {
    function Take(max, ins) {
        this.type = "take";
        this.ins = ins;
        this.out = $f43345ec9793d55d$var$NO;
        this.max = max;
        this.taken = 0;
    }
    Take.prototype._start = function(out) {
        this.out = out;
        this.taken = 0;
        if (this.max <= 0) out._c();
        else this.ins._add(this);
    };
    Take.prototype._stop = function() {
        this.ins._remove(this);
        this.out = $f43345ec9793d55d$var$NO;
    };
    Take.prototype._n = function(t) {
        var u = this.out;
        if (u === $f43345ec9793d55d$var$NO) return;
        var m = ++this.taken;
        if (m < this.max) u._n(t);
        else if (m === this.max) {
            u._n(t);
            u._c();
        }
    };
    Take.prototype._e = function(err) {
        var u = this.out;
        if (u === $f43345ec9793d55d$var$NO) return;
        u._e(err);
    };
    Take.prototype._c = function() {
        var u = this.out;
        if (u === $f43345ec9793d55d$var$NO) return;
        u._c();
    };
    return Take;
}();
var $f43345ec9793d55d$var$Stream = /** @class */ function() {
    function Stream(producer) {
        this._prod = producer || $f43345ec9793d55d$var$NO;
        this._ils = [];
        this._stopID = $f43345ec9793d55d$var$NO;
        this._dl = $f43345ec9793d55d$var$NO;
        this._d = false;
        this._target = null;
        this._err = $f43345ec9793d55d$var$NO;
    }
    Stream.prototype._n = function(t) {
        var a = this._ils;
        var L = a.length;
        if (this._d) this._dl._n(t);
        if (L == 1) a[0]._n(t);
        else if (L == 0) return;
        else {
            var b = $f43345ec9793d55d$var$cp(a);
            for(var i = 0; i < L; i++)b[i]._n(t);
        }
    };
    Stream.prototype._e = function(err) {
        if (this._err !== $f43345ec9793d55d$var$NO) return;
        this._err = err;
        var a = this._ils;
        var L = a.length;
        this._x();
        if (this._d) this._dl._e(err);
        if (L == 1) a[0]._e(err);
        else if (L == 0) return;
        else {
            var b = $f43345ec9793d55d$var$cp(a);
            for(var i = 0; i < L; i++)b[i]._e(err);
        }
        if (!this._d && L == 0) throw this._err;
    };
    Stream.prototype._c = function() {
        var a = this._ils;
        var L = a.length;
        this._x();
        if (this._d) this._dl._c();
        if (L == 1) a[0]._c();
        else if (L == 0) return;
        else {
            var b = $f43345ec9793d55d$var$cp(a);
            for(var i = 0; i < L; i++)b[i]._c();
        }
    };
    Stream.prototype._x = function() {
        if (this._ils.length === 0) return;
        if (this._prod !== $f43345ec9793d55d$var$NO) this._prod._stop();
        this._err = $f43345ec9793d55d$var$NO;
        this._ils = [];
    };
    Stream.prototype._stopNow = function() {
        // WARNING: code that calls this method should
        // first check if this._prod is valid (not `NO`)
        this._prod._stop();
        this._err = $f43345ec9793d55d$var$NO;
        this._stopID = $f43345ec9793d55d$var$NO;
    };
    Stream.prototype._add = function(il) {
        var ta = this._target;
        if (ta) return ta._add(il);
        var a = this._ils;
        a.push(il);
        if (a.length > 1) return;
        if (this._stopID !== $f43345ec9793d55d$var$NO) {
            clearTimeout(this._stopID);
            this._stopID = $f43345ec9793d55d$var$NO;
        } else {
            var p = this._prod;
            if (p !== $f43345ec9793d55d$var$NO) p._start(this);
        }
    };
    Stream.prototype._remove = function(il) {
        var _this = this;
        var ta = this._target;
        if (ta) return ta._remove(il);
        var a = this._ils;
        var i = a.indexOf(il);
        if (i > -1) {
            a.splice(i, 1);
            if (this._prod !== $f43345ec9793d55d$var$NO && a.length <= 0) {
                this._err = $f43345ec9793d55d$var$NO;
                this._stopID = setTimeout(function() {
                    return _this._stopNow();
                });
            } else if (a.length === 1) this._pruneCycles();
        }
    };
    // If all paths stemming from `this` stream eventually end at `this`
    // stream, then we remove the single listener of `this` stream, to
    // force it to end its execution and dispose resources. This method
    // assumes as a precondition that this._ils has just one listener.
    Stream.prototype._pruneCycles = function() {
        if (this._hasNoSinks(this, [])) this._remove(this._ils[0]);
    };
    // Checks whether *there is no* path starting from `x` that leads to an end
    // listener (sink) in the stream graph, following edges A->B where B is a
    // listener of A. This means these paths constitute a cycle somehow. Is given
    // a trace of all visited nodes so far.
    Stream.prototype._hasNoSinks = function(x, trace) {
        if (trace.indexOf(x) !== -1) return true;
        else if (x.out === this) return true;
        else if (x.out && x.out !== $f43345ec9793d55d$var$NO) return this._hasNoSinks(x.out, trace.concat(x));
        else if (x._ils) {
            for(var i = 0, N = x._ils.length; i < N; i++)if (!this._hasNoSinks(x._ils[i], trace.concat(x))) return false;
            return true;
        } else return false;
    };
    Stream.prototype.ctor = function() {
        return this instanceof $f43345ec9793d55d$var$MemoryStream ? $f43345ec9793d55d$var$MemoryStream : Stream;
    };
    /**
     * Adds a Listener to the Stream.
     *
     * @param {Listener} listener
     */ Stream.prototype.addListener = function(listener) {
        listener._n = listener.next || $f43345ec9793d55d$var$noop;
        listener._e = listener.error || $f43345ec9793d55d$var$noop;
        listener._c = listener.complete || $f43345ec9793d55d$var$noop;
        this._add(listener);
    };
    /**
     * Removes a Listener from the Stream, assuming the Listener was added to it.
     *
     * @param {Listener<T>} listener
     */ Stream.prototype.removeListener = function(listener) {
        this._remove(listener);
    };
    /**
     * Adds a Listener to the Stream returning a Subscription to remove that
     * listener.
     *
     * @param {Listener} listener
     * @returns {Subscription}
     */ Stream.prototype.subscribe = function(listener) {
        this.addListener(listener);
        return new $f43345ec9793d55d$var$StreamSub(this, listener);
    };
    /**
     * Add interop between most.js and RxJS 5
     *
     * @returns {Stream}
     */ Stream.prototype[$f43345ec9793d55d$var$$$observable] = function() {
        return this;
    };
    /**
     * Creates a new Stream given a Producer.
     *
     * @factory true
     * @param {Producer} producer An optional Producer that dictates how to
     * start, generate events, and stop the Stream.
     * @return {Stream}
     */ Stream.create = function(producer) {
        if (producer) {
            if (typeof producer.start !== "function" || typeof producer.stop !== "function") throw new Error("producer requires both start and stop functions");
            $f43345ec9793d55d$var$internalizeProducer(producer); // mutates the input
        }
        return new Stream(producer);
    };
    /**
     * Creates a new MemoryStream given a Producer.
     *
     * @factory true
     * @param {Producer} producer An optional Producer that dictates how to
     * start, generate events, and stop the Stream.
     * @return {MemoryStream}
     */ Stream.createWithMemory = function(producer) {
        if (producer) $f43345ec9793d55d$var$internalizeProducer(producer); // mutates the input
        return new $f43345ec9793d55d$var$MemoryStream(producer);
    };
    /**
     * Creates a Stream that does nothing when started. It never emits any event.
     *
     * Marble diagram:
     *
     * ```text
     *          never
     * -----------------------
     * ```
     *
     * @factory true
     * @return {Stream}
     */ Stream.never = function() {
        return new Stream({
            _start: $f43345ec9793d55d$var$noop,
            _stop: $f43345ec9793d55d$var$noop
        });
    };
    /**
     * Creates a Stream that immediately emits the "complete" notification when
     * started, and that's it.
     *
     * Marble diagram:
     *
     * ```text
     * empty
     * -|
     * ```
     *
     * @factory true
     * @return {Stream}
     */ Stream.empty = function() {
        return new Stream({
            _start: function(il) {
                il._c();
            },
            _stop: $f43345ec9793d55d$var$noop
        });
    };
    /**
     * Creates a Stream that immediately emits an "error" notification with the
     * value you passed as the `error` argument when the stream starts, and that's
     * it.
     *
     * Marble diagram:
     *
     * ```text
     * throw(X)
     * -X
     * ```
     *
     * @factory true
     * @param error The error event to emit on the created stream.
     * @return {Stream}
     */ Stream.throw = function(error) {
        return new Stream({
            _start: function(il) {
                il._e(error);
            },
            _stop: $f43345ec9793d55d$var$noop
        });
    };
    /**
     * Creates a stream from an Array, Promise, or an Observable.
     *
     * @factory true
     * @param {Array|PromiseLike|Observable} input The input to make a stream from.
     * @return {Stream}
     */ Stream.from = function(input) {
        if (typeof input[$f43345ec9793d55d$var$$$observable] === "function") return Stream.fromObservable(input);
        else if (typeof input.then === "function") return Stream.fromPromise(input);
        else if (Array.isArray(input)) return Stream.fromArray(input);
        throw new TypeError("Type of input to from() must be an Array, Promise, or Observable");
    };
    /**
     * Creates a Stream that immediately emits the arguments that you give to
     * *of*, then completes.
     *
     * Marble diagram:
     *
     * ```text
     * of(1,2,3)
     * 123|
     * ```
     *
     * @factory true
     * @param a The first value you want to emit as an event on the stream.
     * @param b The second value you want to emit as an event on the stream. One
     * or more of these values may be given as arguments.
     * @return {Stream}
     */ Stream.of = function() {
        var items = [];
        for(var _i = 0; _i < arguments.length; _i++)items[_i] = arguments[_i];
        return Stream.fromArray(items);
    };
    /**
     * Converts an array to a stream. The returned stream will emit synchronously
     * all the items in the array, and then complete.
     *
     * Marble diagram:
     *
     * ```text
     * fromArray([1,2,3])
     * 123|
     * ```
     *
     * @factory true
     * @param {Array} array The array to be converted as a stream.
     * @return {Stream}
     */ Stream.fromArray = function(array) {
        return new Stream(new $f43345ec9793d55d$var$FromArray(array));
    };
    /**
     * Converts a promise to a stream. The returned stream will emit the resolved
     * value of the promise, and then complete. However, if the promise is
     * rejected, the stream will emit the corresponding error.
     *
     * Marble diagram:
     *
     * ```text
     * fromPromise( ----42 )
     * -----------------42|
     * ```
     *
     * @factory true
     * @param {PromiseLike} promise The promise to be converted as a stream.
     * @return {Stream}
     */ Stream.fromPromise = function(promise) {
        return new Stream(new $f43345ec9793d55d$var$FromPromise(promise));
    };
    /**
     * Converts an Observable into a Stream.
     *
     * @factory true
     * @param {any} observable The observable to be converted as a stream.
     * @return {Stream}
     */ Stream.fromObservable = function(obs) {
        if (obs.endWhen !== undefined) return obs;
        var o = typeof obs[$f43345ec9793d55d$var$$$observable] === "function" ? obs[$f43345ec9793d55d$var$$$observable]() : obs;
        return new Stream(new $f43345ec9793d55d$var$FromObservable(o));
    };
    /**
     * Creates a stream that periodically emits incremental numbers, every
     * `period` milliseconds.
     *
     * Marble diagram:
     *
     * ```text
     *     periodic(1000)
     * ---0---1---2---3---4---...
     * ```
     *
     * @factory true
     * @param {number} period The interval in milliseconds to use as a rate of
     * emission.
     * @return {Stream}
     */ Stream.periodic = function(period) {
        return new Stream(new $f43345ec9793d55d$var$Periodic(period));
    };
    Stream.prototype._map = function(project) {
        return new (this.ctor())(new $f43345ec9793d55d$var$MapOp(project, this));
    };
    /**
     * Transforms each event from the input Stream through a `project` function,
     * to get a Stream that emits those transformed events.
     *
     * Marble diagram:
     *
     * ```text
     * --1---3--5-----7------
     *    map(i => i * 10)
     * --10--30-50----70-----
     * ```
     *
     * @param {Function} project A function of type `(t: T) => U` that takes event
     * `t` of type `T` from the input Stream and produces an event of type `U`, to
     * be emitted on the output Stream.
     * @return {Stream}
     */ Stream.prototype.map = function(project) {
        return this._map(project);
    };
    /**
     * It's like `map`, but transforms each input event to always the same
     * constant value on the output Stream.
     *
     * Marble diagram:
     *
     * ```text
     * --1---3--5-----7-----
     *       mapTo(10)
     * --10--10-10----10----
     * ```
     *
     * @param projectedValue A value to emit on the output Stream whenever the
     * input Stream emits any value.
     * @return {Stream}
     */ Stream.prototype.mapTo = function(projectedValue) {
        var s = this.map(function() {
            return projectedValue;
        });
        var op = s._prod;
        op.type = "mapTo";
        return s;
    };
    /**
     * Only allows events that pass the test given by the `passes` argument.
     *
     * Each event from the input stream is given to the `passes` function. If the
     * function returns `true`, the event is forwarded to the output stream,
     * otherwise it is ignored and not forwarded.
     *
     * Marble diagram:
     *
     * ```text
     * --1---2--3-----4-----5---6--7-8--
     *     filter(i => i % 2 === 0)
     * ------2--------4---------6----8--
     * ```
     *
     * @param {Function} passes A function of type `(t: T) => boolean` that takes
     * an event from the input stream and checks if it passes, by returning a
     * boolean.
     * @return {Stream}
     */ Stream.prototype.filter = function(passes) {
        var p = this._prod;
        if (p instanceof $f43345ec9793d55d$var$Filter) return new Stream(new $f43345ec9793d55d$var$Filter($f43345ec9793d55d$var$and(p.f, passes), p.ins));
        return new Stream(new $f43345ec9793d55d$var$Filter(passes, this));
    };
    /**
     * Lets the first `amount` many events from the input stream pass to the
     * output stream, then makes the output stream complete.
     *
     * Marble diagram:
     *
     * ```text
     * --a---b--c----d---e--
     *    take(3)
     * --a---b--c|
     * ```
     *
     * @param {number} amount How many events to allow from the input stream
     * before completing the output stream.
     * @return {Stream}
     */ Stream.prototype.take = function(amount) {
        return new (this.ctor())(new $f43345ec9793d55d$var$Take(amount, this));
    };
    /**
     * Ignores the first `amount` many events from the input stream, and then
     * after that starts forwarding events from the input stream to the output
     * stream.
     *
     * Marble diagram:
     *
     * ```text
     * --a---b--c----d---e--
     *       drop(3)
     * --------------d---e--
     * ```
     *
     * @param {number} amount How many events to ignore from the input stream
     * before forwarding all events from the input stream to the output stream.
     * @return {Stream}
     */ Stream.prototype.drop = function(amount) {
        return new Stream(new $f43345ec9793d55d$var$Drop(amount, this));
    };
    /**
     * When the input stream completes, the output stream will emit the last event
     * emitted by the input stream, and then will also complete.
     *
     * Marble diagram:
     *
     * ```text
     * --a---b--c--d----|
     *       last()
     * -----------------d|
     * ```
     *
     * @return {Stream}
     */ Stream.prototype.last = function() {
        return new Stream(new $f43345ec9793d55d$var$Last(this));
    };
    /**
     * Prepends the given `initial` value to the sequence of events emitted by the
     * input stream. The returned stream is a MemoryStream, which means it is
     * already `remember()`'d.
     *
     * Marble diagram:
     *
     * ```text
     * ---1---2-----3---
     *   startWith(0)
     * 0--1---2-----3---
     * ```
     *
     * @param initial The value or event to prepend.
     * @return {MemoryStream}
     */ Stream.prototype.startWith = function(initial) {
        return new $f43345ec9793d55d$var$MemoryStream(new $f43345ec9793d55d$var$StartWith(this, initial));
    };
    /**
     * Uses another stream to determine when to complete the current stream.
     *
     * When the given `other` stream emits an event or completes, the output
     * stream will complete. Before that happens, the output stream will behaves
     * like the input stream.
     *
     * Marble diagram:
     *
     * ```text
     * ---1---2-----3--4----5----6---
     *   endWhen( --------a--b--| )
     * ---1---2-----3--4--|
     * ```
     *
     * @param other Some other stream that is used to know when should the output
     * stream of this operator complete.
     * @return {Stream}
     */ Stream.prototype.endWhen = function(other) {
        return new (this.ctor())(new $f43345ec9793d55d$var$EndWhen(other, this));
    };
    /**
     * "Folds" the stream onto itself.
     *
     * Combines events from the past throughout
     * the entire execution of the input stream, allowing you to accumulate them
     * together. It's essentially like `Array.prototype.reduce`. The returned
     * stream is a MemoryStream, which means it is already `remember()`'d.
     *
     * The output stream starts by emitting the `seed` which you give as argument.
     * Then, when an event happens on the input stream, it is combined with that
     * seed value through the `accumulate` function, and the output value is
     * emitted on the output stream. `fold` remembers that output value as `acc`
     * ("accumulator"), and then when a new input event `t` happens, `acc` will be
     * combined with that to produce the new `acc` and so forth.
     *
     * Marble diagram:
     *
     * ```text
     * ------1-----1--2----1----1------
     *   fold((acc, x) => acc + x, 3)
     * 3-----4-----5--7----8----9------
     * ```
     *
     * @param {Function} accumulate A function of type `(acc: R, t: T) => R` that
     * takes the previous accumulated value `acc` and the incoming event from the
     * input stream and produces the new accumulated value.
     * @param seed The initial accumulated value, of type `R`.
     * @return {MemoryStream}
     */ Stream.prototype.fold = function(accumulate, seed) {
        return new $f43345ec9793d55d$var$MemoryStream(new $f43345ec9793d55d$var$Fold(accumulate, seed, this));
    };
    /**
     * Replaces an error with another stream.
     *
     * When (and if) an error happens on the input stream, instead of forwarding
     * that error to the output stream, *replaceError* will call the `replace`
     * function which returns the stream that the output stream will replicate.
     * And, in case that new stream also emits an error, `replace` will be called
     * again to get another stream to start replicating.
     *
     * Marble diagram:
     *
     * ```text
     * --1---2-----3--4-----X
     *   replaceError( () => --10--| )
     * --1---2-----3--4--------10--|
     * ```
     *
     * @param {Function} replace A function of type `(err) => Stream` that takes
     * the error that occurred on the input stream or on the previous replacement
     * stream and returns a new stream. The output stream will behave like the
     * stream that this function returns.
     * @return {Stream}
     */ Stream.prototype.replaceError = function(replace) {
        return new (this.ctor())(new $f43345ec9793d55d$var$ReplaceError(replace, this));
    };
    /**
     * Flattens a "stream of streams", handling only one nested stream at a time
     * (no concurrency).
     *
     * If the input stream is a stream that emits streams, then this operator will
     * return an output stream which is a flat stream: emits regular events. The
     * flattening happens without concurrency. It works like this: when the input
     * stream emits a nested stream, *flatten* will start imitating that nested
     * one. However, as soon as the next nested stream is emitted on the input
     * stream, *flatten* will forget the previous nested one it was imitating, and
     * will start imitating the new nested one.
     *
     * Marble diagram:
     *
     * ```text
     * --+--------+---------------
     *   \        \
     *    \       ----1----2---3--
     *    --a--b----c----d--------
     *           flatten
     * -----a--b------1----2---3--
     * ```
     *
     * @return {Stream}
     */ Stream.prototype.flatten = function() {
        return new Stream(new $f43345ec9793d55d$var$Flatten(this));
    };
    /**
     * Passes the input stream to a custom operator, to produce an output stream.
     *
     * *compose* is a handy way of using an existing function in a chained style.
     * Instead of writing `outStream = f(inStream)` you can write
     * `outStream = inStream.compose(f)`.
     *
     * @param {function} operator A function that takes a stream as input and
     * returns a stream as well.
     * @return {Stream}
     */ Stream.prototype.compose = function(operator) {
        return operator(this);
    };
    /**
     * Returns an output stream that behaves like the input stream, but also
     * remembers the most recent event that happens on the input stream, so that a
     * newly added listener will immediately receive that memorised event.
     *
     * @return {MemoryStream}
     */ Stream.prototype.remember = function() {
        return new $f43345ec9793d55d$var$MemoryStream(new $f43345ec9793d55d$var$Remember(this));
    };
    /**
     * Returns an output stream that identically behaves like the input stream,
     * but also runs a `spy` function for each event, to help you debug your app.
     *
     * *debug* takes a `spy` function as argument, and runs that for each event
     * happening on the input stream. If you don't provide the `spy` argument,
     * then *debug* will just `console.log` each event. This helps you to
     * understand the flow of events through some operator chain.
     *
     * Please note that if the output stream has no listeners, then it will not
     * start, which means `spy` will never run because no actual event happens in
     * that case.
     *
     * Marble diagram:
     *
     * ```text
     * --1----2-----3-----4--
     *         debug
     * --1----2-----3-----4--
     * ```
     *
     * @param {function} labelOrSpy A string to use as the label when printing
     * debug information on the console, or a 'spy' function that takes an event
     * as argument, and does not need to return anything.
     * @return {Stream}
     */ Stream.prototype.debug = function(labelOrSpy) {
        return new (this.ctor())(new $f43345ec9793d55d$var$Debug(this, labelOrSpy));
    };
    /**
     * *imitate* changes this current Stream to emit the same events that the
     * `other` given Stream does. This method returns nothing.
     *
     * This method exists to allow one thing: **circular dependency of streams**.
     * For instance, let's imagine that for some reason you need to create a
     * circular dependency where stream `first$` depends on stream `second$`
     * which in turn depends on `first$`:
     *
     * <!-- skip-example -->
     * ```js
     * import delay from 'xstream/extra/delay'
     *
     * var first$ = second$.map(x => x * 10).take(3);
     * var second$ = first$.map(x => x + 1).startWith(1).compose(delay(100));
     * ```
     *
     * However, that is invalid JavaScript, because `second$` is undefined
     * on the first line. This is how *imitate* can help solve it:
     *
     * ```js
     * import delay from 'xstream/extra/delay'
     *
     * var secondProxy$ = xs.create();
     * var first$ = secondProxy$.map(x => x * 10).take(3);
     * var second$ = first$.map(x => x + 1).startWith(1).compose(delay(100));
     * secondProxy$.imitate(second$);
     * ```
     *
     * We create `secondProxy$` before the others, so it can be used in the
     * declaration of `first$`. Then, after both `first$` and `second$` are
     * defined, we hook `secondProxy$` with `second$` with `imitate()` to tell
     * that they are "the same". `imitate` will not trigger the start of any
     * stream, it just binds `secondProxy$` and `second$` together.
     *
     * The following is an example where `imitate()` is important in Cycle.js
     * applications. A parent component contains some child components. A child
     * has an action stream which is given to the parent to define its state:
     *
     * <!-- skip-example -->
     * ```js
     * const childActionProxy$ = xs.create();
     * const parent = Parent({...sources, childAction$: childActionProxy$});
     * const childAction$ = parent.state$.map(s => s.child.action$).flatten();
     * childActionProxy$.imitate(childAction$);
     * ```
     *
     * Note, though, that **`imitate()` does not support MemoryStreams**. If we
     * would attempt to imitate a MemoryStream in a circular dependency, we would
     * either get a race condition (where the symptom would be "nothing happens")
     * or an infinite cyclic emission of values. It's useful to think about
     * MemoryStreams as cells in a spreadsheet. It doesn't make any sense to
     * define a spreadsheet cell `A1` with a formula that depends on `B1` and
     * cell `B1` defined with a formula that depends on `A1`.
     *
     * If you find yourself wanting to use `imitate()` with a
     * MemoryStream, you should rework your code around `imitate()` to use a
     * Stream instead. Look for the stream in the circular dependency that
     * represents an event stream, and that would be a candidate for creating a
     * proxy Stream which then imitates the target Stream.
     *
     * @param {Stream} target The other stream to imitate on the current one. Must
     * not be a MemoryStream.
     */ Stream.prototype.imitate = function(target) {
        if (target instanceof $f43345ec9793d55d$var$MemoryStream) throw new Error("A MemoryStream was given to imitate(), but it only supports a Stream. Read more about this restriction here: https://github.com/staltz/xstream#faq");
        this._target = target;
        for(var ils = this._ils, N = ils.length, i = 0; i < N; i++)target._add(ils[i]);
        this._ils = [];
    };
    /**
     * Forces the Stream to emit the given value to its listeners.
     *
     * As the name indicates, if you use this, you are most likely doing something
     * The Wrong Way. Please try to understand the reactive way before using this
     * method. Use it only when you know what you are doing.
     *
     * @param value The "next" value you want to broadcast to all listeners of
     * this Stream.
     */ Stream.prototype.shamefullySendNext = function(value) {
        this._n(value);
    };
    /**
     * Forces the Stream to emit the given error to its listeners.
     *
     * As the name indicates, if you use this, you are most likely doing something
     * The Wrong Way. Please try to understand the reactive way before using this
     * method. Use it only when you know what you are doing.
     *
     * @param {any} error The error you want to broadcast to all the listeners of
     * this Stream.
     */ Stream.prototype.shamefullySendError = function(error) {
        this._e(error);
    };
    /**
     * Forces the Stream to emit the "completed" event to its listeners.
     *
     * As the name indicates, if you use this, you are most likely doing something
     * The Wrong Way. Please try to understand the reactive way before using this
     * method. Use it only when you know what you are doing.
     */ Stream.prototype.shamefullySendComplete = function() {
        this._c();
    };
    /**
     * Adds a "debug" listener to the stream. There can only be one debug
     * listener, that's why this is 'setDebugListener'. To remove the debug
     * listener, just call setDebugListener(null).
     *
     * A debug listener is like any other listener. The only difference is that a
     * debug listener is "stealthy": its presence/absence does not trigger the
     * start/stop of the stream (or the producer inside the stream). This is
     * useful so you can inspect what is going on without changing the behavior
     * of the program. If you have an idle stream and you add a normal listener to
     * it, the stream will start executing. But if you set a debug listener on an
     * idle stream, it won't start executing (not until the first normal listener
     * is added).
     *
     * As the name indicates, we don't recommend using this method to build app
     * logic. In fact, in most cases the debug operator works just fine. Only use
     * this one if you know what you're doing.
     *
     * @param {Listener<T>} listener
     */ Stream.prototype.setDebugListener = function(listener) {
        if (!listener) {
            this._d = false;
            this._dl = $f43345ec9793d55d$var$NO;
        } else {
            this._d = true;
            listener._n = listener.next || $f43345ec9793d55d$var$noop;
            listener._e = listener.error || $f43345ec9793d55d$var$noop;
            listener._c = listener.complete || $f43345ec9793d55d$var$noop;
            this._dl = listener;
        }
    };
    /**
     * Blends multiple streams together, emitting events from all of them
     * concurrently.
     *
     * *merge* takes multiple streams as arguments, and creates a stream that
     * behaves like each of the argument streams, in parallel.
     *
     * Marble diagram:
     *
     * ```text
     * --1----2-----3--------4---
     * ----a-----b----c---d------
     *            merge
     * --1-a--2--b--3-c---d--4---
     * ```
     *
     * @factory true
     * @param {Stream} stream1 A stream to merge together with other streams.
     * @param {Stream} stream2 A stream to merge together with other streams. Two
     * or more streams may be given as arguments.
     * @return {Stream}
     */ Stream.merge = function merge() {
        var streams = [];
        for(var _i = 0; _i < arguments.length; _i++)streams[_i] = arguments[_i];
        return new Stream(new $f43345ec9793d55d$var$Merge(streams));
    };
    /**
     * Combines multiple input streams together to return a stream whose events
     * are arrays that collect the latest events from each input stream.
     *
     * *combine* internally remembers the most recent event from each of the input
     * streams. When any of the input streams emits an event, that event together
     * with all the other saved events are combined into an array. That array will
     * be emitted on the output stream. It's essentially a way of joining together
     * the events from multiple streams.
     *
     * Marble diagram:
     *
     * ```text
     * --1----2-----3--------4---
     * ----a-----b-----c--d------
     *          combine
     * ----1a-2a-2b-3b-3c-3d-4d--
     * ```
     *
     * @factory true
     * @param {Stream} stream1 A stream to combine together with other streams.
     * @param {Stream} stream2 A stream to combine together with other streams.
     * Multiple streams, not just two, may be given as arguments.
     * @return {Stream}
     */ Stream.combine = function combine() {
        var streams = [];
        for(var _i = 0; _i < arguments.length; _i++)streams[_i] = arguments[_i];
        return new Stream(new $f43345ec9793d55d$var$Combine(streams));
    };
    return Stream;
}();
module.exports.Stream = $f43345ec9793d55d$var$Stream;
var $f43345ec9793d55d$var$MemoryStream = /** @class */ function(_super) {
    $f43345ec9793d55d$var$__extends(MemoryStream, _super);
    function MemoryStream(producer) {
        var _this = _super.call(this, producer) || this;
        _this._has = false;
        return _this;
    }
    MemoryStream.prototype._n = function(x) {
        this._v = x;
        this._has = true;
        _super.prototype._n.call(this, x);
    };
    MemoryStream.prototype._add = function(il) {
        var ta = this._target;
        if (ta) return ta._add(il);
        var a = this._ils;
        a.push(il);
        if (a.length > 1) {
            if (this._has) il._n(this._v);
            return;
        }
        if (this._stopID !== $f43345ec9793d55d$var$NO) {
            if (this._has) il._n(this._v);
            clearTimeout(this._stopID);
            this._stopID = $f43345ec9793d55d$var$NO;
        } else if (this._has) il._n(this._v);
        else {
            var p = this._prod;
            if (p !== $f43345ec9793d55d$var$NO) p._start(this);
        }
    };
    MemoryStream.prototype._stopNow = function() {
        this._has = false;
        _super.prototype._stopNow.call(this);
    };
    MemoryStream.prototype._x = function() {
        this._has = false;
        _super.prototype._x.call(this);
    };
    MemoryStream.prototype.map = function(project) {
        return this._map(project);
    };
    MemoryStream.prototype.mapTo = function(projectedValue) {
        return _super.prototype.mapTo.call(this, projectedValue);
    };
    MemoryStream.prototype.take = function(amount) {
        return _super.prototype.take.call(this, amount);
    };
    MemoryStream.prototype.endWhen = function(other) {
        return _super.prototype.endWhen.call(this, other);
    };
    MemoryStream.prototype.replaceError = function(replace) {
        return _super.prototype.replaceError.call(this, replace);
    };
    MemoryStream.prototype.remember = function() {
        return this;
    };
    MemoryStream.prototype.debug = function(labelOrSpy) {
        return _super.prototype.debug.call(this, labelOrSpy);
    };
    return MemoryStream;
}($f43345ec9793d55d$var$Stream);
module.exports.MemoryStream = $f43345ec9793d55d$var$MemoryStream;
var $f43345ec9793d55d$var$xs = $f43345ec9793d55d$var$Stream;
module.exports.default = $f43345ec9793d55d$var$xs;

});
parcelRequire.register("d1iPW", function(module, exports) {

module.exports = (parcelRequire("8YbNk"));

});

parcelRequire.register("k0eww", function(module, exports) {
"use strict";

var $5AcsX = parcelRequire("5AcsX");

var $c6AV3 = parcelRequire("c6AV3");

var $aJMZL = parcelRequire("aJMZL");

var $e0blU = parcelRequire("e0blU");
var $e8ff12cffcfeeec9$var$polyfill = $aJMZL();
var $e8ff12cffcfeeec9$var$getGlobal = function() {
    return $e8ff12cffcfeeec9$var$polyfill;
};
$5AcsX($e8ff12cffcfeeec9$var$getGlobal, {
    getPolyfill: $aJMZL,
    implementation: $c6AV3,
    shim: $e0blU
});
module.exports = $e8ff12cffcfeeec9$var$getGlobal;

});
parcelRequire.register("5AcsX", function(module, exports) {
"use strict";

var $lTDqP = parcelRequire("lTDqP");
var $4109fc0dc4761cef$var$hasSymbols = typeof Symbol === "function" && typeof Symbol("foo") === "symbol";
var $4109fc0dc4761cef$var$toStr = Object.prototype.toString;
var $4109fc0dc4761cef$var$concat = Array.prototype.concat;
var $4109fc0dc4761cef$var$origDefineProperty = Object.defineProperty;
var $4109fc0dc4761cef$var$isFunction = function(fn) {
    return typeof fn === "function" && $4109fc0dc4761cef$var$toStr.call(fn) === "[object Function]";
};

var $4109fc0dc4761cef$var$hasPropertyDescriptors = (parcelRequire("73hDB"))();
var $4109fc0dc4761cef$var$supportsDescriptors = $4109fc0dc4761cef$var$origDefineProperty && $4109fc0dc4761cef$var$hasPropertyDescriptors;
var $4109fc0dc4761cef$var$defineProperty = function(object, name, value, predicate) {
    if (name in object) {
        if (predicate === true) {
            if (object[name] === value) return;
        } else if (!$4109fc0dc4761cef$var$isFunction(predicate) || !predicate()) return;
    }
    if ($4109fc0dc4761cef$var$supportsDescriptors) $4109fc0dc4761cef$var$origDefineProperty(object, name, {
        configurable: true,
        enumerable: false,
        value: value,
        writable: true
    });
    else object[name] = value; // eslint-disable-line no-param-reassign
};
var $4109fc0dc4761cef$var$defineProperties = function(object, map) {
    var predicates = arguments.length > 2 ? arguments[2] : {};
    var props = $lTDqP(map);
    if ($4109fc0dc4761cef$var$hasSymbols) props = $4109fc0dc4761cef$var$concat.call(props, Object.getOwnPropertySymbols(map));
    for(var i = 0; i < props.length; i += 1)$4109fc0dc4761cef$var$defineProperty(object, props[i], map[props[i]], predicates[props[i]]);
};
$4109fc0dc4761cef$var$defineProperties.supportsDescriptors = !!$4109fc0dc4761cef$var$supportsDescriptors;
module.exports = $4109fc0dc4761cef$var$defineProperties;

});
parcelRequire.register("lTDqP", function(module, exports) {
"use strict";
var $ff0d52530ad179f5$var$slice = Array.prototype.slice;

var $cqifw = parcelRequire("cqifw");
var $ff0d52530ad179f5$var$origKeys = Object.keys;

var $ff0d52530ad179f5$var$keysShim = $ff0d52530ad179f5$var$origKeys ? function keys(o) {
    return $ff0d52530ad179f5$var$origKeys(o);
} : (parcelRequire("2HCYb"));
var $ff0d52530ad179f5$var$originalKeys = Object.keys;
$ff0d52530ad179f5$var$keysShim.shim = function shimObjectKeys() {
    if (Object.keys) {
        var keysWorksWithArguments = function() {
            // Safari 5.0 bug
            var args = Object.keys(arguments);
            return args && args.length === arguments.length;
        }(1, 2);
        if (!keysWorksWithArguments) Object.keys = function keys(object) {
            if ($cqifw(object)) return $ff0d52530ad179f5$var$originalKeys($ff0d52530ad179f5$var$slice.call(object));
            return $ff0d52530ad179f5$var$originalKeys(object);
        };
    } else Object.keys = $ff0d52530ad179f5$var$keysShim;
    return Object.keys || $ff0d52530ad179f5$var$keysShim;
};
module.exports = $ff0d52530ad179f5$var$keysShim;

});


parcelRequire.register("c6AV3", function(module, exports) {
/* eslint no-negated-condition: 0, no-new-func: 0 */ "use strict";
if (typeof self !== "undefined") module.exports = self;
else if (typeof window !== "undefined") module.exports = window;
else module.exports = Function("return this")();

});

parcelRequire.register("aJMZL", function(module, exports) {
"use strict";

var $c6AV3 = parcelRequire("c6AV3");
module.exports = function getPolyfill() {
    if (typeof $parcel$global !== "object" || !$parcel$global || $parcel$global.Math !== Math || $parcel$global.Array !== Array) return $c6AV3;
    return $parcel$global;
};

});

parcelRequire.register("e0blU", function(module, exports) {
"use strict";

var $5AcsX = parcelRequire("5AcsX");

var $aJMZL = parcelRequire("aJMZL");
module.exports = function shimGlobal() {
    var polyfill = $aJMZL();
    if ($5AcsX.supportsDescriptors) {
        var descriptor = Object.getOwnPropertyDescriptor(polyfill, "globalThis");
        if (!descriptor || descriptor.configurable && (descriptor.enumerable || !descriptor.writable || globalThis !== polyfill)) Object.defineProperty(polyfill, "globalThis", {
            configurable: true,
            enumerable: false,
            value: polyfill,
            writable: true
        });
    } else if (typeof globalThis !== "object" || globalThis !== polyfill) polyfill.globalThis = polyfill;
    return polyfill;
};

});




parcelRequire.register("b9Q8k", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DefaultValueProducer = void 0;
// allows pre-producing values before anyone is listening
class $81f8f992f7119666$var$DefaultValueProducer {
    get value() {
        return this.internalValue;
    }
    constructor(value, callbacks){
        this.callbacks = callbacks;
        this.internalValue = value;
    }
    /**
     * Update the current value.
     *
     * If producer is active (i.e. someone is listening), this emits an event.
     * If not, just the current value is updated.
     */ update(value) {
        this.internalValue = value;
        if (this.listener) this.listener.next(value);
    }
    /**
     * Produce an error
     */ // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
    error(error) {
        if (this.listener) this.listener.error(error);
    }
    /**
     * Called by the stream. Do not call this directly.
     */ start(listener) {
        this.listener = listener;
        listener.next(this.internalValue);
        if (this.callbacks) this.callbacks.onStarted();
    }
    /**
     * Called by the stream. Do not call this directly.
     */ stop() {
        if (this.callbacks) this.callbacks.onStop();
        this.listener = undefined;
    }
}
module.exports.DefaultValueProducer = $81f8f992f7119666$var$DefaultValueProducer;

});

parcelRequire.register("icuEp", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.dropDuplicates = void 0;
/**
 * Drops duplicate values in a stream.
 *
 * Marble diagram:
 *
 * ```text
 * -1-1-1-2-4-3-3-4--
 *   dropDuplicates
 * -1-----2-4-3------
 * ```
 *
 * Each value must be uniquely identified by a string given by
 * valueToKey(value).
 *
 * Internally this maintains a set of keys that have been processed already,
 * i.e. memory consumption and Set lookup times should be considered when
 * using this function.
 */ function $d4011f9b2eb6d827$var$dropDuplicates(valueToKey) {
    const operand = (instream)=>{
        const emittedKeys = new Set();
        const deduplicatedStream = instream.filter((value)=>!emittedKeys.has(valueToKey(value))).debug((value)=>emittedKeys.add(valueToKey(value)));
        return deduplicatedStream;
    };
    return operand;
}
module.exports.dropDuplicates = $d4011f9b2eb6d827$var$dropDuplicates;

});

parcelRequire.register("bTrax", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.firstEvent = module.exports.toListPromise = module.exports.fromListPromise = void 0;

var $kXS5t = parcelRequire("kXS5t");
/**
 * Emits one event for each list element as soon as the promise resolves
 */ function $8a89e7f633e7e5ff$var$fromListPromise(promise) {
    const producer = {
        start: (listener)=>{
            // the code in `start` runs as soon as anyone listens to the stream
            promise.then((iterable)=>{
                for (const element of iterable)listener.next(element);
                listener.complete();
            }).catch((error)=>listener.error(error));
        },
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        stop: ()=>{}
    };
    return $kXS5t.Stream.create(producer);
}
module.exports.fromListPromise = $8a89e7f633e7e5ff$var$fromListPromise;
/**
 * Listens to stream and collects events. When `count` events are collected,
 * the promise resolves with an array of events.
 *
 * Rejects if stream completes before `count` events are collected.
 */ async function $8a89e7f633e7e5ff$var$toListPromise(stream, count) {
    return new Promise((resolve, reject)=>{
        if (count === 0) {
            resolve([]);
            return;
        }
        const events = new Array();
        // take() unsubscribes from source stream automatically
        stream.take(count).subscribe({
            next: (event)=>{
                events.push(event);
                if (events.length === count) resolve(events);
            },
            complete: ()=>{
                reject(`Stream completed before all events could be collected. ` + `Collected ${events.length}, expected ${count}`);
            },
            error: (error)=>reject(error)
        });
    });
}
module.exports.toListPromise = $8a89e7f633e7e5ff$var$toListPromise;
/**
 * Listens to stream, collects one event and revolves.
 *
 * Rejects if stream completes before one event was fired.
 */ async function $8a89e7f633e7e5ff$var$firstEvent(stream) {
    return (await $8a89e7f633e7e5ff$var$toListPromise(stream, 1))[0];
}
module.exports.firstEvent = $8a89e7f633e7e5ff$var$firstEvent;

});

parcelRequire.register("lQJtF", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ValueAndUpdates = void 0;

var $kXS5t = parcelRequire("kXS5t");
/**
 * A read only wrapper around DefaultValueProducer that allows
 * to synchronously get the current value using the .value property
 * and listen to to updates by suscribing to the .updates stream
 */ class $fe81bb2e242fc862$var$ValueAndUpdates {
    get value() {
        return this.producer.value;
    }
    constructor(producer){
        this.producer = producer;
        this.updates = $kXS5t.MemoryStream.createWithMemory(this.producer);
    }
    /**
     * Resolves as soon as search value is found.
     *
     * @param search either a value or a function that must return true when found
     * @returns the value of the update that caused the search match
     */ async waitFor(search) {
        const searchImplementation = typeof search === "function" ? search : (value)=>value === search;
        return new Promise((resolve, reject)=>{
            const subscription = this.updates.subscribe({
                next: (newValue)=>{
                    if (searchImplementation(newValue)) {
                        resolve(newValue);
                        // MemoryStream.subscribe() calls next with the last value.
                        // Make async to ensure the subscription exists
                        setTimeout(()=>subscription.unsubscribe(), 0);
                    }
                },
                complete: ()=>{
                    subscription.unsubscribe();
                    reject("Update stream completed without expected value");
                },
                error: (error)=>{
                    reject(error);
                }
            });
        });
    }
}
module.exports.ValueAndUpdates = $fe81bb2e242fc862$var$ValueAndUpdates;

});


parcelRequire.register("47ZKU", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.jsonRpcCode = module.exports.isJsonRpcSuccessResponse = module.exports.isJsonRpcErrorResponse = void 0;
function $3017b83b9bd5b39f$var$isJsonRpcErrorResponse(response) {
    return typeof response.error === "object";
}
module.exports.isJsonRpcErrorResponse = $3017b83b9bd5b39f$var$isJsonRpcErrorResponse;
function $3017b83b9bd5b39f$var$isJsonRpcSuccessResponse(response) {
    return !$3017b83b9bd5b39f$var$isJsonRpcErrorResponse(response);
}
module.exports.isJsonRpcSuccessResponse = $3017b83b9bd5b39f$var$isJsonRpcSuccessResponse;
/**
 * Error codes as specified in JSON-RPC 2.0
 *
 * @see https://www.jsonrpc.org/specification#error_object
 */ module.exports.jsonRpcCode = {
    parseError: -32700,
    invalidRequest: -32600,
    methodNotFound: -32601,
    invalidParams: -32602,
    internalError: -32603,
    // server error (Reserved for implementation-defined server-errors.):
    // -32000 to -32099
    serverError: {
        default: -32000
    }
};

});


parcelRequire.register("g4V3Q", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.parseJsonRpcResponse = module.exports.parseJsonRpcSuccessResponse = module.exports.parseJsonRpcErrorResponse = module.exports.parseJsonRpcRequest = module.exports.parseJsonRpcId = void 0;

var $gt7DJ = parcelRequire("gt7DJ");
/**
 * Extracts ID field from request or response object.
 *
 * Returns `null` when no valid ID was found.
 */ function $bb494834b27b6dfc$var$parseJsonRpcId(data) {
    if (!(0, $gt7DJ.isJsonCompatibleDictionary)(data)) throw new Error("Data must be JSON compatible dictionary");
    const id = data.id;
    if (typeof id !== "number" && typeof id !== "string") return null;
    return id;
}
module.exports.parseJsonRpcId = $bb494834b27b6dfc$var$parseJsonRpcId;
function $bb494834b27b6dfc$var$parseJsonRpcRequest(data) {
    if (!(0, $gt7DJ.isJsonCompatibleDictionary)(data)) throw new Error("Data must be JSON compatible dictionary");
    if (data.jsonrpc !== "2.0") throw new Error(`Got unexpected jsonrpc version: ${data.jsonrpc}`);
    const id = $bb494834b27b6dfc$var$parseJsonRpcId(data);
    if (id === null) throw new Error("Invalid id field");
    const method = data.method;
    if (typeof method !== "string") throw new Error("Invalid method field");
    if (!(0, $gt7DJ.isJsonCompatibleArray)(data.params) && !(0, $gt7DJ.isJsonCompatibleDictionary)(data.params)) throw new Error("Invalid params field");
    return {
        jsonrpc: "2.0",
        id: id,
        method: method,
        params: data.params
    };
}
module.exports.parseJsonRpcRequest = $bb494834b27b6dfc$var$parseJsonRpcRequest;
function $bb494834b27b6dfc$var$parseError(error) {
    if (typeof error.code !== "number") throw new Error("Error property 'code' is not a number");
    if (typeof error.message !== "string") throw new Error("Error property 'message' is not a string");
    let maybeUndefinedData;
    if (error.data === undefined) maybeUndefinedData = undefined;
    else if ((0, $gt7DJ.isJsonCompatibleValue)(error.data)) maybeUndefinedData = error.data;
    else throw new Error("Error property 'data' is defined but not a JSON compatible value.");
    return {
        code: error.code,
        message: error.message,
        ...maybeUndefinedData !== undefined ? {
            data: maybeUndefinedData
        } : {}
    };
}
/** Throws if data is not a JsonRpcErrorResponse */ function $bb494834b27b6dfc$var$parseJsonRpcErrorResponse(data) {
    if (!(0, $gt7DJ.isJsonCompatibleDictionary)(data)) throw new Error("Data must be JSON compatible dictionary");
    if (data.jsonrpc !== "2.0") throw new Error(`Got unexpected jsonrpc version: ${JSON.stringify(data)}`);
    const id = data.id;
    if (typeof id !== "number" && typeof id !== "string" && id !== null) throw new Error("Invalid id field");
    if (typeof data.error === "undefined" || !(0, $gt7DJ.isJsonCompatibleDictionary)(data.error)) throw new Error("Invalid error field");
    return {
        jsonrpc: "2.0",
        id: id,
        error: $bb494834b27b6dfc$var$parseError(data.error)
    };
}
module.exports.parseJsonRpcErrorResponse = $bb494834b27b6dfc$var$parseJsonRpcErrorResponse;
/** Throws if data is not a JsonRpcSuccessResponse */ function $bb494834b27b6dfc$var$parseJsonRpcSuccessResponse(data) {
    if (!(0, $gt7DJ.isJsonCompatibleDictionary)(data)) throw new Error("Data must be JSON compatible dictionary");
    if (data.jsonrpc !== "2.0") throw new Error(`Got unexpected jsonrpc version: ${JSON.stringify(data)}`);
    const id = data.id;
    if (typeof id !== "number" && typeof id !== "string") throw new Error("Invalid id field");
    if (typeof data.result === "undefined") throw new Error("Invalid result field");
    const result = data.result;
    return {
        jsonrpc: "2.0",
        id: id,
        result: result
    };
}
module.exports.parseJsonRpcSuccessResponse = $bb494834b27b6dfc$var$parseJsonRpcSuccessResponse;
/**
 * Returns a JsonRpcErrorResponse if input can be parsed as a JSON-RPC error. Otherwise parses
 * input as JsonRpcSuccessResponse. Throws if input is neither a valid error nor success response.
 */ function $bb494834b27b6dfc$var$parseJsonRpcResponse(data) {
    let response;
    try {
        response = $bb494834b27b6dfc$var$parseJsonRpcErrorResponse(data);
    } catch (_) {
        response = $bb494834b27b6dfc$var$parseJsonRpcSuccessResponse(data);
    }
    return response;
}
module.exports.parseJsonRpcResponse = $bb494834b27b6dfc$var$parseJsonRpcResponse;

});
parcelRequire.register("gt7DJ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.isJsonCompatibleDictionary = module.exports.isJsonCompatibleArray = module.exports.isJsonCompatibleValue = void 0;
function $bfd547e4f681e612$var$isJsonCompatibleValue(value) {
    if (typeof value === "string" || typeof value === "number" || typeof value === "boolean" || value === null || // eslint-disable-next-line @typescript-eslint/no-use-before-define
    $bfd547e4f681e612$var$isJsonCompatibleArray(value) || // eslint-disable-next-line @typescript-eslint/no-use-before-define
    $bfd547e4f681e612$var$isJsonCompatibleDictionary(value)) return true;
    else return false;
}
module.exports.isJsonCompatibleValue = $bfd547e4f681e612$var$isJsonCompatibleValue;
function $bfd547e4f681e612$var$isJsonCompatibleArray(value) {
    if (!Array.isArray(value)) return false;
    for (const item of value){
        if (!$bfd547e4f681e612$var$isJsonCompatibleValue(item)) return false;
    }
    // all items okay
    return true;
}
module.exports.isJsonCompatibleArray = $bfd547e4f681e612$var$isJsonCompatibleArray;
function $bfd547e4f681e612$var$isJsonCompatibleDictionary(data) {
    if (typeof data !== "object" || data === null) // data must be a non-null object
    return false;
    // Exclude special kind of objects like Array, Date or Uint8Array
    // Object.prototype.toString() returns a specified value:
    // http://www.ecma-international.org/ecma-262/7.0/index.html#sec-object.prototype.tostring
    if (Object.prototype.toString.call(data) !== "[object Object]") return false;
    return Object.values(data).every($bfd547e4f681e612$var$isJsonCompatibleValue);
}
module.exports.isJsonCompatibleDictionary = $bfd547e4f681e612$var$isJsonCompatibleDictionary;

});



parcelRequire.register("ldhG0", function(module, exports) {
"use strict";
var $f7188610dfac1dc1$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.http = void 0;

const $f7188610dfac1dc1$var$axios_1 = $f7188610dfac1dc1$var$__importDefault((parcelRequire("2shzp")));
function $f7188610dfac1dc1$var$filterBadStatus(res) {
    if (res.status >= 400) throw new Error(`Bad status on response: ${res.status}`);
    return res;
}
/**
 * Node.js 18 comes with exprimental fetch support (https://nodejs.org/de/blog/announcements/v18-release-announce/).
 * This is nice, but the implementation does not yet work wekk for us. We
 * can just stick with axios on those systems for now.
 */ // eslint-disable-next-line @typescript-eslint/ban-types
function $f7188610dfac1dc1$var$isExperimental(nodeJsFunc) {
    // This works because we get this info in node 18:
    //
    // > fetch.toString()
    // 'async function fetch(input, init = undefined) {\n' +
    // "    emitExperimentalWarning('The Fetch API');\n" +
    // '    return lazyUndici().fetch(input, init);\n' +
    // '  }'
    return nodeJsFunc.toString().includes("emitExperimentalWarning");
}
/**
 * Helper to work around missing CORS support in Tendermint (https://github.com/tendermint/tendermint/pull/2800)
 *
 * For some reason, fetch does not complain about missing server-side CORS support.
 */ // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
async function $f7188610dfac1dc1$var$http(method, url, headers, request) {
    if (typeof fetch === "function" && !$f7188610dfac1dc1$var$isExperimental(fetch)) {
        const settings = {
            method: method,
            body: request ? JSON.stringify(request) : undefined,
            headers: {
                // eslint-disable-next-line @typescript-eslint/naming-convention
                "Content-Type": "application/json",
                ...headers
            }
        };
        return fetch(url, settings).then($f7188610dfac1dc1$var$filterBadStatus).then((res)=>res.json());
    } else return $f7188610dfac1dc1$var$axios_1.default.request({
        url: url,
        method: method,
        data: request,
        headers: headers
    }).then((res)=>res.data);
}
module.exports.http = $f7188610dfac1dc1$var$http;

});

parcelRequire.register("8d2qc", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.hasProtocol = module.exports.instanceOfRpcStreamingClient = void 0;
function $5fa16a86934dcba5$var$instanceOfRpcStreamingClient(client) {
    return typeof client.listen === "function";
}
module.exports.instanceOfRpcStreamingClient = $5fa16a86934dcba5$var$instanceOfRpcStreamingClient;
// Helpers for all RPC clients
function $5fa16a86934dcba5$var$hasProtocol(url) {
    return url.search("://") !== -1;
}
module.exports.hasProtocol = $5fa16a86934dcba5$var$hasProtocol;

});


parcelRequire.register("egGjY", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.HttpClient = void 0;

var $gBmRC = parcelRequire("gBmRC");

var $ldhG0 = parcelRequire("ldhG0");

var $8d2qc = parcelRequire("8d2qc");
class $a633636934ef91e0$var$HttpClient {
    constructor(endpoint){
        if (typeof endpoint === "string") // accept host.name:port and assume http protocol
        this.url = (0, $8d2qc.hasProtocol)(endpoint) ? endpoint : "http://" + endpoint;
        else {
            this.url = endpoint.url;
            this.headers = endpoint.headers;
        }
    }
    disconnect() {
    // nothing to be done
    }
    async execute(request) {
        const response = (0, $gBmRC.parseJsonRpcResponse)(await (0, $ldhG0.http)("POST", this.url, this.headers, request));
        if ((0, $gBmRC.isJsonRpcErrorResponse)(response)) throw new Error(JSON.stringify(response.error));
        return response;
    }
}
module.exports.HttpClient = $a633636934ef91e0$var$HttpClient;

});

parcelRequire.register("cH3Sa", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.WebsocketClient = void 0;

var $gBmRC = parcelRequire("gBmRC");

var $8ylyR = parcelRequire("8ylyR");

var $8iJvX = parcelRequire("8iJvX");

var $kXS5t = parcelRequire("kXS5t");

var $8d2qc = parcelRequire("8d2qc");
function $93dc81360bbadbea$var$defaultErrorHandler(error) {
    throw error;
}
function $93dc81360bbadbea$var$toJsonRpcResponse(message) {
    // this should never happen, but I want an alert if it does
    if (message.type !== "message") throw new Error(`Unexcepted message type on websocket: ${message.type}`);
    const jsonRpcEvent = (0, $gBmRC.parseJsonRpcResponse)(JSON.parse(message.data));
    return jsonRpcEvent;
}
class $93dc81360bbadbea$var$RpcEventProducer {
    constructor(request, socket){
        this.running = false;
        this.subscriptions = [];
        this.request = request;
        this.socket = socket;
    }
    /**
     * Implementation of Producer.start
     */ start(listener) {
        if (this.running) throw Error("Already started. Please stop first before restarting.");
        this.running = true;
        this.connectToClient(listener);
        this.socket.queueRequest(JSON.stringify(this.request));
    }
    /**
     * Implementation of Producer.stop
     *
     * Called by the stream when the stream's last listener stopped listening
     * or when the producer completed.
     */ stop() {
        this.running = false;
        // Tell the server we are done in order to save resources. We cannot wait for the result.
        // This may fail when socket connection is not open, thus ignore errors in queueRequest
        const endRequest = {
            ...this.request,
            method: "unsubscribe"
        };
        try {
            this.socket.queueRequest(JSON.stringify(endRequest));
        } catch (error) {
            if (error instanceof Error && error.message.match(/socket has disconnected/i)) ;
            else throw error;
        }
    }
    connectToClient(listener) {
        const responseStream = this.socket.events.map($93dc81360bbadbea$var$toJsonRpcResponse);
        // this should unsubscribe itself, so doesn't need to be removed explicitly
        const idSubscription = responseStream.filter((response)=>response.id === this.request.id).subscribe({
            next: (response)=>{
                if ((0, $gBmRC.isJsonRpcErrorResponse)(response)) {
                    this.closeSubscriptions();
                    listener.error(JSON.stringify(response.error));
                }
                idSubscription.unsubscribe();
            }
        });
        // this will fire on a response (success or error)
        // Tendermint adds an "#event" suffix for events that follow a previous subscription
        // https://github.com/tendermint/tendermint/blob/v0.23.0/rpc/core/events.go#L107
        const idEventSubscription = responseStream.filter((response)=>response.id === this.request.id).subscribe({
            next: (response)=>{
                if ((0, $gBmRC.isJsonRpcErrorResponse)(response)) {
                    this.closeSubscriptions();
                    listener.error(JSON.stringify(response.error));
                } else listener.next(response.result);
            }
        });
        // this will fire in case the websocket disconnects cleanly
        const nonResponseSubscription = responseStream.subscribe({
            error: (error)=>{
                this.closeSubscriptions();
                listener.error(error);
            },
            complete: ()=>{
                this.closeSubscriptions();
                listener.complete();
            }
        });
        this.subscriptions.push(idSubscription, idEventSubscription, nonResponseSubscription);
    }
    closeSubscriptions() {
        for (const subscription of this.subscriptions)subscription.unsubscribe();
        // clear unused subscriptions
        this.subscriptions = [];
    }
}
class $93dc81360bbadbea$var$WebsocketClient {
    constructor(baseUrl, onError = $93dc81360bbadbea$var$defaultErrorHandler){
        // Lazily create streams and use the same stream when listening to the same query twice.
        //
        // Creating streams is cheap since producer is not started as long as nobody listens to events. Thus this
        // map is never cleared and there is no need to do so. But unsubscribe all the subscriptions!
        this.subscriptionStreams = new Map();
        // accept host.name:port and assume ws protocol
        // make sure we don't end up with ...//websocket
        const path = baseUrl.endsWith("/") ? "websocket" : "/websocket";
        const cleanBaseUrl = (0, $8d2qc.hasProtocol)(baseUrl) ? baseUrl : "ws://" + baseUrl;
        this.url = cleanBaseUrl + path;
        this.socket = new $8ylyR.ReconnectingSocket(this.url);
        const errorSubscription = this.socket.events.subscribe({
            error: (error)=>{
                onError(error);
                errorSubscription.unsubscribe();
            }
        });
        this.jsonRpcResponseStream = this.socket.events.map($93dc81360bbadbea$var$toJsonRpcResponse);
        this.socket.connect();
    }
    async execute(request) {
        const pendingResponse = this.responseForRequestId(request.id);
        this.socket.queueRequest(JSON.stringify(request));
        const response = await pendingResponse;
        if ((0, $gBmRC.isJsonRpcErrorResponse)(response)) throw new Error(JSON.stringify(response.error));
        return response;
    }
    listen(request) {
        if (request.method !== "subscribe") throw new Error(`Request method must be "subscribe" to start event listening`);
        const query = request.params.query;
        if (typeof query !== "string") throw new Error("request.params.query must be a string");
        if (!this.subscriptionStreams.has(query)) {
            const producer = new $93dc81360bbadbea$var$RpcEventProducer(request, this.socket);
            const stream = $kXS5t.Stream.create(producer);
            this.subscriptionStreams.set(query, stream);
        }
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        return this.subscriptionStreams.get(query).filter((response)=>response.query !== undefined);
    }
    /**
     * Resolves as soon as websocket is connected. execute() queues requests automatically,
     * so this should be required for testing purposes only.
     */ async connected() {
        await this.socket.connectionStatus.waitFor($8ylyR.ConnectionStatus.Connected);
    }
    disconnect() {
        this.socket.disconnect();
    }
    async responseForRequestId(id) {
        return (0, $8iJvX.firstEvent)(this.jsonRpcResponseStream.filter((r)=>r.id === id));
    }
}
module.exports.WebsocketClient = $93dc81360bbadbea$var$WebsocketClient;

});
parcelRequire.register("8ylyR", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.StreamingSocket = module.exports.SocketWrapper = module.exports.ReconnectingSocket = module.exports.QueueingStreamingSocket = module.exports.ConnectionStatus = void 0;

var $97WWZ = parcelRequire("97WWZ");
Object.defineProperty(module.exports, "ConnectionStatus", {
    enumerable: true,
    get: function() {
        return $97WWZ.ConnectionStatus;
    }
});
Object.defineProperty(module.exports, "QueueingStreamingSocket", {
    enumerable: true,
    get: function() {
        return $97WWZ.QueueingStreamingSocket;
    }
});

var $7N71P = parcelRequire("7N71P");
Object.defineProperty(module.exports, "ReconnectingSocket", {
    enumerable: true,
    get: function() {
        return $7N71P.ReconnectingSocket;
    }
});

var $6WN20 = parcelRequire("6WN20");
Object.defineProperty(module.exports, "SocketWrapper", {
    enumerable: true,
    get: function() {
        return $6WN20.SocketWrapper;
    }
});

var $5R8RI = parcelRequire("5R8RI");
Object.defineProperty(module.exports, "StreamingSocket", {
    enumerable: true,
    get: function() {
        return $5R8RI.StreamingSocket;
    }
});

});
parcelRequire.register("97WWZ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.QueueingStreamingSocket = module.exports.ConnectionStatus = void 0;

var $8iJvX = parcelRequire("8iJvX");

var $kXS5t = parcelRequire("kXS5t");

var $5R8RI = parcelRequire("5R8RI");
var $6a527ed97e48fbc6$var$ConnectionStatus;
(function(ConnectionStatus) {
    ConnectionStatus[ConnectionStatus["Unconnected"] = 0] = "Unconnected";
    ConnectionStatus[ConnectionStatus["Connecting"] = 1] = "Connecting";
    ConnectionStatus[ConnectionStatus["Connected"] = 2] = "Connected";
    ConnectionStatus[ConnectionStatus["Disconnected"] = 3] = "Disconnected";
})($6a527ed97e48fbc6$var$ConnectionStatus = module.exports.ConnectionStatus || (module.exports.ConnectionStatus = {}));
/**
 * A wrapper around StreamingSocket that can queue requests.
 */ class $6a527ed97e48fbc6$var$QueueingStreamingSocket {
    constructor(url, timeout = 10000, reconnectedHandler){
        this.queue = [];
        this.isProcessingQueue = false;
        this.url = url;
        this.timeout = timeout;
        this.reconnectedHandler = reconnectedHandler;
        const eventProducer = {
            start: (listener)=>this.eventProducerListener = listener,
            stop: ()=>this.eventProducerListener = undefined
        };
        this.events = $kXS5t.Stream.create(eventProducer);
        this.connectionStatusProducer = new $8iJvX.DefaultValueProducer($6a527ed97e48fbc6$var$ConnectionStatus.Unconnected);
        this.connectionStatus = new $8iJvX.ValueAndUpdates(this.connectionStatusProducer);
        this.socket = new $5R8RI.StreamingSocket(this.url, this.timeout);
        this.socket.events.subscribe({
            next: (event)=>{
                if (!this.eventProducerListener) throw new Error("No event producer listener set");
                this.eventProducerListener.next(event);
            },
            error: ()=>this.connectionStatusProducer.update($6a527ed97e48fbc6$var$ConnectionStatus.Disconnected)
        });
    }
    connect() {
        this.connectionStatusProducer.update($6a527ed97e48fbc6$var$ConnectionStatus.Connecting);
        this.socket.connected.then(async ()=>{
            this.connectionStatusProducer.update($6a527ed97e48fbc6$var$ConnectionStatus.Connected);
            return this.processQueue();
        }, ()=>this.connectionStatusProducer.update($6a527ed97e48fbc6$var$ConnectionStatus.Disconnected));
        this.socket.connect();
    }
    disconnect() {
        this.connectionStatusProducer.update($6a527ed97e48fbc6$var$ConnectionStatus.Disconnected);
        this.socket.disconnect();
    }
    reconnect() {
        this.socket = new $5R8RI.StreamingSocket(this.url, this.timeout);
        this.socket.events.subscribe({
            next: (event)=>{
                if (!this.eventProducerListener) throw new Error("No event producer listener set");
                this.eventProducerListener.next(event);
            },
            error: ()=>this.connectionStatusProducer.update($6a527ed97e48fbc6$var$ConnectionStatus.Disconnected)
        });
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this.socket.connected.then(()=>{
            if (this.reconnectedHandler) this.reconnectedHandler();
        });
        this.connect();
    }
    getQueueLength() {
        return this.queue.length;
    }
    queueRequest(request) {
        this.queue.push(request);
        // We don’t need to wait for the queue to be processed.
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this.processQueue();
    }
    async processQueue() {
        if (this.isProcessingQueue || this.connectionStatus.value !== $6a527ed97e48fbc6$var$ConnectionStatus.Connected) return;
        this.isProcessingQueue = true;
        let request;
        while(request = this.queue.shift())try {
            await this.socket.send(request);
            this.isProcessingQueue = false;
        } catch (error) {
            // Probably the connection is down; will try again automatically when reconnected.
            this.queue.unshift(request);
            this.isProcessingQueue = false;
            return;
        }
    }
}
module.exports.QueueingStreamingSocket = $6a527ed97e48fbc6$var$QueueingStreamingSocket;

});
parcelRequire.register("5R8RI", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.StreamingSocket = void 0;

var $kXS5t = parcelRequire("kXS5t");

var $6WN20 = parcelRequire("6WN20");
/**
 * A WebSocket wrapper that exposes all events as a stream.
 *
 * This underlying socket will not be closed when the stream has no listeners
 */ class $4438c771c934460a$var$StreamingSocket {
    constructor(url, timeout = 10000){
        this.socket = new $6WN20.SocketWrapper(url, (event)=>{
            if (this.eventProducerListener) this.eventProducerListener.next(event);
        }, (errorEvent)=>{
            if (this.eventProducerListener) this.eventProducerListener.error(errorEvent);
        }, ()=>{
        // socket opened
        }, (closeEvent)=>{
            if (this.eventProducerListener) {
                if (closeEvent.wasClean) this.eventProducerListener.complete();
                else this.eventProducerListener.error("Socket was closed unclean");
            }
        }, timeout);
        this.connected = this.socket.connected;
        const eventProducer = {
            start: (listener)=>this.eventProducerListener = listener,
            stop: ()=>this.eventProducerListener = undefined
        };
        this.events = $kXS5t.Stream.create(eventProducer);
    }
    connect() {
        this.socket.connect();
    }
    disconnect() {
        this.socket.disconnect();
    }
    async send(data) {
        return this.socket.send(data);
    }
}
module.exports.StreamingSocket = $4438c771c934460a$var$StreamingSocket;

});
parcelRequire.register("6WN20", function(module, exports) {

var $4TNnu = parcelRequire("4TNnu");
"use strict";
var $50ee317c5a4529d5$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SocketWrapper = void 0;

const $50ee317c5a4529d5$var$isomorphic_ws_1 = $50ee317c5a4529d5$var$__importDefault((parcelRequire("fURH5")));
function $50ee317c5a4529d5$var$environmentIsNodeJs() {
    return typeof $4TNnu !== "undefined" && typeof $4TNnu.versions !== "undefined" && typeof $4TNnu.versions.node !== "undefined";
}
/**
 * A thin wrapper around isomorphic-ws' WebSocket class that adds
 * - constant message/error/open/close handlers
 * - explict connection via a connect() method
 * - type support for events
 * - handling of corner cases in the open and close behaviour
 */ class $50ee317c5a4529d5$var$SocketWrapper {
    constructor(url, messageHandler, errorHandler, openHandler, closeHandler, timeout = 10000){
        this.closed = false;
        this.connected = new Promise((resolve, reject)=>{
            this.connectedResolver = resolve;
            this.connectedRejecter = reject;
        });
        this.url = url;
        this.messageHandler = messageHandler;
        this.errorHandler = errorHandler;
        this.openHandler = openHandler;
        this.closeHandler = closeHandler;
        this.timeout = timeout;
    }
    /**
     * returns a promise that resolves when connection is open
     */ connect() {
        const socket = new $50ee317c5a4529d5$var$isomorphic_ws_1.default(this.url);
        socket.onerror = (error)=>{
            this.clearTimeout();
            if (this.errorHandler) this.errorHandler(error);
        };
        socket.onmessage = (messageEvent)=>{
            this.messageHandler({
                type: messageEvent.type,
                data: messageEvent.data
            });
        };
        socket.onopen = (_)=>{
            this.clearTimeout();
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            this.connectedResolver();
            if (this.openHandler) this.openHandler();
        };
        socket.onclose = (closeEvent)=>{
            this.closed = true;
            if (this.closeHandler) this.closeHandler(closeEvent);
        };
        const started = Date.now();
        this.timeoutId = setTimeout(()=>{
            socket.onmessage = ()=>0;
            socket.onerror = ()=>0;
            socket.onopen = ()=>0;
            socket.onclose = ()=>0;
            socket.close();
            this.socket = undefined;
            const elapsed = Math.floor(Date.now() - started);
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            this.connectedRejecter(`Connection attempt timed out after ${elapsed} ms`);
        }, this.timeout);
        this.socket = socket;
    }
    /**
     * Closes an established connection and aborts other connection states
     */ disconnect() {
        if (!this.socket) throw new Error("Socket undefined. This must be called after connecting.");
        this.clearTimeout();
        switch(this.socket.readyState){
            case $50ee317c5a4529d5$var$isomorphic_ws_1.default.OPEN:
                this.socket.close(1000 /* Normal Closure */ );
                break;
            case $50ee317c5a4529d5$var$isomorphic_ws_1.default.CLOSED:
                break;
            case $50ee317c5a4529d5$var$isomorphic_ws_1.default.CONNECTING:
                // imitate missing abort API
                this.socket.onopen = ()=>0;
                this.socket.onclose = ()=>0;
                this.socket.onerror = ()=>0;
                this.socket.onmessage = ()=>0;
                this.socket = undefined;
                if (this.closeHandler) this.closeHandler({
                    wasClean: false,
                    code: 4001
                });
                break;
            case $50ee317c5a4529d5$var$isomorphic_ws_1.default.CLOSING:
                break;
            default:
                throw new Error(`Unknown readyState: ${this.socket.readyState}`);
        }
    }
    async send(data) {
        return new Promise((resolve, reject)=>{
            if (!this.socket) throw new Error("Socket undefined. This must be called after connecting.");
            if (this.closed) throw new Error("Socket was closed, so no data can be sent anymore.");
            // this exception should be thrown by send() automatically according to
            // https://developer.mozilla.org/de/docs/Web/API/WebSocket#send() but it does not work in browsers
            if (this.socket.readyState !== $50ee317c5a4529d5$var$isomorphic_ws_1.default.OPEN) throw new Error("Websocket is not open");
            if ($50ee317c5a4529d5$var$environmentIsNodeJs()) this.socket.send(data, (err)=>err ? reject(err) : resolve());
            else {
                // Browser websocket send method does not accept a callback
                this.socket.send(data);
                resolve();
            }
        });
    }
    /**
     * Clears the timeout function, such that no timeout error will be raised anymore. This should be
     * called when the connection is established, a connection error occurred or the socket is disconnected.
     *
     * This method must not be called before `connect()`.
     * This method is idempotent.
     */ clearTimeout() {
        if (!this.timeoutId) throw new Error("Timeout ID not set. This should not happen and usually means connect() was not called.");
        // Note: do not unset this.timeoutId to allow multiple calls to this function
        clearTimeout(this.timeoutId);
    }
}
module.exports.SocketWrapper = $50ee317c5a4529d5$var$SocketWrapper;

});



parcelRequire.register("7N71P", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ReconnectingSocket = void 0;

var $kXS5t = parcelRequire("kXS5t");

var $97WWZ = parcelRequire("97WWZ");
/**
 * A wrapper around QueueingStreamingSocket that reconnects automatically.
 */ class $5ac28fb385fc9f70$var$ReconnectingSocket {
    /** Starts with a 0.1 second timeout, then doubles every attempt with a maximum timeout of 5 seconds. */ static calculateTimeout(index) {
        return Math.min(2 ** index * 100, 5000);
    }
    constructor(url, timeout = 10000, reconnectedHandler){
        this.unconnected = true;
        this.disconnected = false;
        this.timeoutIndex = 0;
        this.reconnectTimeout = null;
        const eventProducer = {
            start: (listener)=>this.eventProducerListener = listener,
            stop: ()=>this.eventProducerListener = undefined
        };
        this.events = $kXS5t.Stream.create(eventProducer);
        this.socket = new $97WWZ.QueueingStreamingSocket(url, timeout, reconnectedHandler);
        this.socket.events.subscribe({
            next: (event)=>{
                if (this.eventProducerListener) this.eventProducerListener.next(event);
            },
            error: (error)=>{
                if (this.eventProducerListener) this.eventProducerListener.error(error);
            }
        });
        this.connectionStatus = this.socket.connectionStatus;
        this.connectionStatus.updates.subscribe({
            next: (status)=>{
                if (status === $97WWZ.ConnectionStatus.Connected) this.timeoutIndex = 0;
                if (status === $97WWZ.ConnectionStatus.Disconnected) {
                    if (this.reconnectTimeout) {
                        clearTimeout(this.reconnectTimeout);
                        this.reconnectTimeout = null;
                    }
                    this.reconnectTimeout = setTimeout(()=>this.socket.reconnect(), $5ac28fb385fc9f70$var$ReconnectingSocket.calculateTimeout(this.timeoutIndex++));
                }
            }
        });
    }
    connect() {
        if (!this.unconnected) throw new Error("Cannot connect: socket has already connected");
        this.socket.connect();
        this.unconnected = false;
    }
    disconnect() {
        if (this.unconnected) throw new Error("Cannot disconnect: socket has not yet connected");
        this.socket.disconnect();
        if (this.eventProducerListener) this.eventProducerListener.complete();
        this.disconnected = true;
    }
    queueRequest(request) {
        if (this.disconnected) throw new Error("Cannot queue request: socket has disconnected");
        this.socket.queueRequest(request);
    }
}
module.exports.ReconnectingSocket = $5ac28fb385fc9f70$var$ReconnectingSocket;

});




parcelRequire.register("eIDXY", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.adaptor34 = void 0;

var $k2bcl = parcelRequire("k2bcl");

var $8f7Qz = parcelRequire("8f7Qz");

var $0r1XS = parcelRequire("0r1XS");
module.exports.adaptor34 = {
    params: $8f7Qz.Params,
    responses: $0r1XS.Responses,
    hashTx: $k2bcl.hashTx,
    hashBlock: $k2bcl.hashBlock
};

});
parcelRequire.register("k2bcl", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.hashBlock = module.exports.hashTx = void 0;

var $6f1ux = parcelRequire("6f1ux");

var $bANkA = parcelRequire("bANkA");
// hash is sha256
// https://github.com/tendermint/tendermint/blob/master/UPGRADING.md#v0260
function $e95cae3cb0504c29$var$hashTx(tx) {
    return (0, $6f1ux.sha256)(tx);
}
module.exports.hashTx = $e95cae3cb0504c29$var$hashTx;
function $e95cae3cb0504c29$var$getSplitPoint(n) {
    if (n < 1) throw new Error("Cannot split an empty tree");
    const largestPowerOf2 = 2 ** Math.floor(Math.log2(n));
    return largestPowerOf2 < n ? largestPowerOf2 : largestPowerOf2 / 2;
}
function $e95cae3cb0504c29$var$hashLeaf(leaf) {
    const hash = new $6f1ux.Sha256(Uint8Array.from([
        0
    ]));
    hash.update(leaf);
    return hash.digest();
}
function $e95cae3cb0504c29$var$hashInner(left, right) {
    const hash = new $6f1ux.Sha256(Uint8Array.from([
        1
    ]));
    hash.update(left);
    hash.update(right);
    return hash.digest();
}
// See https://github.com/tendermint/tendermint/blob/v0.31.8/docs/spec/blockchain/encoding.md#merkleroot
// Note: the hashes input may not actually be hashes, especially before a recursive call
function $e95cae3cb0504c29$var$hashTree(hashes) {
    switch(hashes.length){
        case 0:
            throw new Error("Cannot hash empty tree");
        case 1:
            return $e95cae3cb0504c29$var$hashLeaf(hashes[0]);
        default:
            {
                const slicePoint = $e95cae3cb0504c29$var$getSplitPoint(hashes.length);
                const left = $e95cae3cb0504c29$var$hashTree(hashes.slice(0, slicePoint));
                const right = $e95cae3cb0504c29$var$hashTree(hashes.slice(slicePoint));
                return $e95cae3cb0504c29$var$hashInner(left, right);
            }
    }
}
function $e95cae3cb0504c29$var$hashBlock(header) {
    if (!header.lastBlockId) throw new Error("Hashing a block header with no last block ID (i.e. header at height 1) is not supported. If you need this, contributions are welcome. Please add documentation and test vectors for this case.");
    const encodedFields = [
        (0, $bANkA.encodeVersion)(header.version),
        (0, $bANkA.encodeString)(header.chainId),
        (0, $bANkA.encodeUvarint)(header.height),
        (0, $bANkA.encodeTime)(header.time),
        (0, $bANkA.encodeBlockId)(header.lastBlockId),
        (0, $bANkA.encodeBytes)(header.lastCommitHash),
        (0, $bANkA.encodeBytes)(header.dataHash),
        (0, $bANkA.encodeBytes)(header.validatorsHash),
        (0, $bANkA.encodeBytes)(header.nextValidatorsHash),
        (0, $bANkA.encodeBytes)(header.consensusHash),
        (0, $bANkA.encodeBytes)(header.appHash),
        (0, $bANkA.encodeBytes)(header.lastResultsHash),
        (0, $bANkA.encodeBytes)(header.evidenceHash),
        (0, $bANkA.encodeBytes)(header.proposerAddress)
    ];
    return $e95cae3cb0504c29$var$hashTree(encodedFields);
}
module.exports.hashBlock = $e95cae3cb0504c29$var$hashBlock;

});
parcelRequire.register("6f1ux", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.stringToPath = module.exports.Slip10RawIndex = module.exports.slip10CurveFromString = module.exports.Slip10Curve = module.exports.Slip10 = module.exports.pathToString = module.exports.sha512 = module.exports.Sha512 = module.exports.sha256 = module.exports.Sha256 = module.exports.Secp256k1Signature = module.exports.ExtendedSecp256k1Signature = module.exports.Secp256k1 = module.exports.ripemd160 = module.exports.Ripemd160 = module.exports.Random = module.exports.Xchacha20poly1305Ietf = module.exports.xchacha20NonceLength = module.exports.isArgon2idOptions = module.exports.Ed25519Keypair = module.exports.Ed25519 = module.exports.Argon2id = module.exports.keccak256 = module.exports.Keccak256 = module.exports.Hmac = module.exports.EnglishMnemonic = module.exports.Bip39 = void 0;

var $akFY6 = parcelRequire("akFY6");
Object.defineProperty(module.exports, "Bip39", {
    enumerable: true,
    get: function() {
        return $akFY6.Bip39;
    }
});
Object.defineProperty(module.exports, "EnglishMnemonic", {
    enumerable: true,
    get: function() {
        return $akFY6.EnglishMnemonic;
    }
});

var $aYUxM = parcelRequire("aYUxM");
Object.defineProperty(module.exports, "Hmac", {
    enumerable: true,
    get: function() {
        return $aYUxM.Hmac;
    }
});

var $ieied = parcelRequire("ieied");
Object.defineProperty(module.exports, "Keccak256", {
    enumerable: true,
    get: function() {
        return $ieied.Keccak256;
    }
});
Object.defineProperty(module.exports, "keccak256", {
    enumerable: true,
    get: function() {
        return $ieied.keccak256;
    }
});

var $dBpJU = parcelRequire("dBpJU");
Object.defineProperty(module.exports, "Argon2id", {
    enumerable: true,
    get: function() {
        return $dBpJU.Argon2id;
    }
});
Object.defineProperty(module.exports, "Ed25519", {
    enumerable: true,
    get: function() {
        return $dBpJU.Ed25519;
    }
});
Object.defineProperty(module.exports, "Ed25519Keypair", {
    enumerable: true,
    get: function() {
        return $dBpJU.Ed25519Keypair;
    }
});
Object.defineProperty(module.exports, "isArgon2idOptions", {
    enumerable: true,
    get: function() {
        return $dBpJU.isArgon2idOptions;
    }
});
Object.defineProperty(module.exports, "xchacha20NonceLength", {
    enumerable: true,
    get: function() {
        return $dBpJU.xchacha20NonceLength;
    }
});
Object.defineProperty(module.exports, "Xchacha20poly1305Ietf", {
    enumerable: true,
    get: function() {
        return $dBpJU.Xchacha20poly1305Ietf;
    }
});

var $ar8bQ = parcelRequire("ar8bQ");
Object.defineProperty(module.exports, "Random", {
    enumerable: true,
    get: function() {
        return $ar8bQ.Random;
    }
});

var $epe0N = parcelRequire("epe0N");
Object.defineProperty(module.exports, "Ripemd160", {
    enumerable: true,
    get: function() {
        return $epe0N.Ripemd160;
    }
});
Object.defineProperty(module.exports, "ripemd160", {
    enumerable: true,
    get: function() {
        return $epe0N.ripemd160;
    }
});

var $bCyVM = parcelRequire("bCyVM");
Object.defineProperty(module.exports, "Secp256k1", {
    enumerable: true,
    get: function() {
        return $bCyVM.Secp256k1;
    }
});

var $hk7ao = parcelRequire("hk7ao");
Object.defineProperty(module.exports, "ExtendedSecp256k1Signature", {
    enumerable: true,
    get: function() {
        return $hk7ao.ExtendedSecp256k1Signature;
    }
});
Object.defineProperty(module.exports, "Secp256k1Signature", {
    enumerable: true,
    get: function() {
        return $hk7ao.Secp256k1Signature;
    }
});

var $dlig8 = parcelRequire("dlig8");
Object.defineProperty(module.exports, "Sha256", {
    enumerable: true,
    get: function() {
        return $dlig8.Sha256;
    }
});
Object.defineProperty(module.exports, "sha256", {
    enumerable: true,
    get: function() {
        return $dlig8.sha256;
    }
});
Object.defineProperty(module.exports, "Sha512", {
    enumerable: true,
    get: function() {
        return $dlig8.Sha512;
    }
});
Object.defineProperty(module.exports, "sha512", {
    enumerable: true,
    get: function() {
        return $dlig8.sha512;
    }
});

var $gCjJW = parcelRequire("gCjJW");
Object.defineProperty(module.exports, "pathToString", {
    enumerable: true,
    get: function() {
        return $gCjJW.pathToString;
    }
});
Object.defineProperty(module.exports, "Slip10", {
    enumerable: true,
    get: function() {
        return $gCjJW.Slip10;
    }
});
Object.defineProperty(module.exports, "Slip10Curve", {
    enumerable: true,
    get: function() {
        return $gCjJW.Slip10Curve;
    }
});
Object.defineProperty(module.exports, "slip10CurveFromString", {
    enumerable: true,
    get: function() {
        return $gCjJW.slip10CurveFromString;
    }
});
Object.defineProperty(module.exports, "Slip10RawIndex", {
    enumerable: true,
    get: function() {
        return $gCjJW.Slip10RawIndex;
    }
});
Object.defineProperty(module.exports, "stringToPath", {
    enumerable: true,
    get: function() {
        return $gCjJW.stringToPath;
    }
});

});
parcelRequire.register("akFY6", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Bip39 = module.exports.EnglishMnemonic = module.exports.mnemonicToEntropy = module.exports.entropyToMnemonic = void 0;

var $6XcLW = parcelRequire("6XcLW");

var $k7mTa = parcelRequire("k7mTa");

var $dlig8 = parcelRequire("dlig8");
const $785c53af8942025c$var$wordlist = [
    "abandon",
    "ability",
    "able",
    "about",
    "above",
    "absent",
    "absorb",
    "abstract",
    "absurd",
    "abuse",
    "access",
    "accident",
    "account",
    "accuse",
    "achieve",
    "acid",
    "acoustic",
    "acquire",
    "across",
    "act",
    "action",
    "actor",
    "actress",
    "actual",
    "adapt",
    "add",
    "addict",
    "address",
    "adjust",
    "admit",
    "adult",
    "advance",
    "advice",
    "aerobic",
    "affair",
    "afford",
    "afraid",
    "again",
    "age",
    "agent",
    "agree",
    "ahead",
    "aim",
    "air",
    "airport",
    "aisle",
    "alarm",
    "album",
    "alcohol",
    "alert",
    "alien",
    "all",
    "alley",
    "allow",
    "almost",
    "alone",
    "alpha",
    "already",
    "also",
    "alter",
    "always",
    "amateur",
    "amazing",
    "among",
    "amount",
    "amused",
    "analyst",
    "anchor",
    "ancient",
    "anger",
    "angle",
    "angry",
    "animal",
    "ankle",
    "announce",
    "annual",
    "another",
    "answer",
    "antenna",
    "antique",
    "anxiety",
    "any",
    "apart",
    "apology",
    "appear",
    "apple",
    "approve",
    "april",
    "arch",
    "arctic",
    "area",
    "arena",
    "argue",
    "arm",
    "armed",
    "armor",
    "army",
    "around",
    "arrange",
    "arrest",
    "arrive",
    "arrow",
    "art",
    "artefact",
    "artist",
    "artwork",
    "ask",
    "aspect",
    "assault",
    "asset",
    "assist",
    "assume",
    "asthma",
    "athlete",
    "atom",
    "attack",
    "attend",
    "attitude",
    "attract",
    "auction",
    "audit",
    "august",
    "aunt",
    "author",
    "auto",
    "autumn",
    "average",
    "avocado",
    "avoid",
    "awake",
    "aware",
    "away",
    "awesome",
    "awful",
    "awkward",
    "axis",
    "baby",
    "bachelor",
    "bacon",
    "badge",
    "bag",
    "balance",
    "balcony",
    "ball",
    "bamboo",
    "banana",
    "banner",
    "bar",
    "barely",
    "bargain",
    "barrel",
    "base",
    "basic",
    "basket",
    "battle",
    "beach",
    "bean",
    "beauty",
    "because",
    "become",
    "beef",
    "before",
    "begin",
    "behave",
    "behind",
    "believe",
    "below",
    "belt",
    "bench",
    "benefit",
    "best",
    "betray",
    "better",
    "between",
    "beyond",
    "bicycle",
    "bid",
    "bike",
    "bind",
    "biology",
    "bird",
    "birth",
    "bitter",
    "black",
    "blade",
    "blame",
    "blanket",
    "blast",
    "bleak",
    "bless",
    "blind",
    "blood",
    "blossom",
    "blouse",
    "blue",
    "blur",
    "blush",
    "board",
    "boat",
    "body",
    "boil",
    "bomb",
    "bone",
    "bonus",
    "book",
    "boost",
    "border",
    "boring",
    "borrow",
    "boss",
    "bottom",
    "bounce",
    "box",
    "boy",
    "bracket",
    "brain",
    "brand",
    "brass",
    "brave",
    "bread",
    "breeze",
    "brick",
    "bridge",
    "brief",
    "bright",
    "bring",
    "brisk",
    "broccoli",
    "broken",
    "bronze",
    "broom",
    "brother",
    "brown",
    "brush",
    "bubble",
    "buddy",
    "budget",
    "buffalo",
    "build",
    "bulb",
    "bulk",
    "bullet",
    "bundle",
    "bunker",
    "burden",
    "burger",
    "burst",
    "bus",
    "business",
    "busy",
    "butter",
    "buyer",
    "buzz",
    "cabbage",
    "cabin",
    "cable",
    "cactus",
    "cage",
    "cake",
    "call",
    "calm",
    "camera",
    "camp",
    "can",
    "canal",
    "cancel",
    "candy",
    "cannon",
    "canoe",
    "canvas",
    "canyon",
    "capable",
    "capital",
    "captain",
    "car",
    "carbon",
    "card",
    "cargo",
    "carpet",
    "carry",
    "cart",
    "case",
    "cash",
    "casino",
    "castle",
    "casual",
    "cat",
    "catalog",
    "catch",
    "category",
    "cattle",
    "caught",
    "cause",
    "caution",
    "cave",
    "ceiling",
    "celery",
    "cement",
    "census",
    "century",
    "cereal",
    "certain",
    "chair",
    "chalk",
    "champion",
    "change",
    "chaos",
    "chapter",
    "charge",
    "chase",
    "chat",
    "cheap",
    "check",
    "cheese",
    "chef",
    "cherry",
    "chest",
    "chicken",
    "chief",
    "child",
    "chimney",
    "choice",
    "choose",
    "chronic",
    "chuckle",
    "chunk",
    "churn",
    "cigar",
    "cinnamon",
    "circle",
    "citizen",
    "city",
    "civil",
    "claim",
    "clap",
    "clarify",
    "claw",
    "clay",
    "clean",
    "clerk",
    "clever",
    "click",
    "client",
    "cliff",
    "climb",
    "clinic",
    "clip",
    "clock",
    "clog",
    "close",
    "cloth",
    "cloud",
    "clown",
    "club",
    "clump",
    "cluster",
    "clutch",
    "coach",
    "coast",
    "coconut",
    "code",
    "coffee",
    "coil",
    "coin",
    "collect",
    "color",
    "column",
    "combine",
    "come",
    "comfort",
    "comic",
    "common",
    "company",
    "concert",
    "conduct",
    "confirm",
    "congress",
    "connect",
    "consider",
    "control",
    "convince",
    "cook",
    "cool",
    "copper",
    "copy",
    "coral",
    "core",
    "corn",
    "correct",
    "cost",
    "cotton",
    "couch",
    "country",
    "couple",
    "course",
    "cousin",
    "cover",
    "coyote",
    "crack",
    "cradle",
    "craft",
    "cram",
    "crane",
    "crash",
    "crater",
    "crawl",
    "crazy",
    "cream",
    "credit",
    "creek",
    "crew",
    "cricket",
    "crime",
    "crisp",
    "critic",
    "crop",
    "cross",
    "crouch",
    "crowd",
    "crucial",
    "cruel",
    "cruise",
    "crumble",
    "crunch",
    "crush",
    "cry",
    "crystal",
    "cube",
    "culture",
    "cup",
    "cupboard",
    "curious",
    "current",
    "curtain",
    "curve",
    "cushion",
    "custom",
    "cute",
    "cycle",
    "dad",
    "damage",
    "damp",
    "dance",
    "danger",
    "daring",
    "dash",
    "daughter",
    "dawn",
    "day",
    "deal",
    "debate",
    "debris",
    "decade",
    "december",
    "decide",
    "decline",
    "decorate",
    "decrease",
    "deer",
    "defense",
    "define",
    "defy",
    "degree",
    "delay",
    "deliver",
    "demand",
    "demise",
    "denial",
    "dentist",
    "deny",
    "depart",
    "depend",
    "deposit",
    "depth",
    "deputy",
    "derive",
    "describe",
    "desert",
    "design",
    "desk",
    "despair",
    "destroy",
    "detail",
    "detect",
    "develop",
    "device",
    "devote",
    "diagram",
    "dial",
    "diamond",
    "diary",
    "dice",
    "diesel",
    "diet",
    "differ",
    "digital",
    "dignity",
    "dilemma",
    "dinner",
    "dinosaur",
    "direct",
    "dirt",
    "disagree",
    "discover",
    "disease",
    "dish",
    "dismiss",
    "disorder",
    "display",
    "distance",
    "divert",
    "divide",
    "divorce",
    "dizzy",
    "doctor",
    "document",
    "dog",
    "doll",
    "dolphin",
    "domain",
    "donate",
    "donkey",
    "donor",
    "door",
    "dose",
    "double",
    "dove",
    "draft",
    "dragon",
    "drama",
    "drastic",
    "draw",
    "dream",
    "dress",
    "drift",
    "drill",
    "drink",
    "drip",
    "drive",
    "drop",
    "drum",
    "dry",
    "duck",
    "dumb",
    "dune",
    "during",
    "dust",
    "dutch",
    "duty",
    "dwarf",
    "dynamic",
    "eager",
    "eagle",
    "early",
    "earn",
    "earth",
    "easily",
    "east",
    "easy",
    "echo",
    "ecology",
    "economy",
    "edge",
    "edit",
    "educate",
    "effort",
    "egg",
    "eight",
    "either",
    "elbow",
    "elder",
    "electric",
    "elegant",
    "element",
    "elephant",
    "elevator",
    "elite",
    "else",
    "embark",
    "embody",
    "embrace",
    "emerge",
    "emotion",
    "employ",
    "empower",
    "empty",
    "enable",
    "enact",
    "end",
    "endless",
    "endorse",
    "enemy",
    "energy",
    "enforce",
    "engage",
    "engine",
    "enhance",
    "enjoy",
    "enlist",
    "enough",
    "enrich",
    "enroll",
    "ensure",
    "enter",
    "entire",
    "entry",
    "envelope",
    "episode",
    "equal",
    "equip",
    "era",
    "erase",
    "erode",
    "erosion",
    "error",
    "erupt",
    "escape",
    "essay",
    "essence",
    "estate",
    "eternal",
    "ethics",
    "evidence",
    "evil",
    "evoke",
    "evolve",
    "exact",
    "example",
    "excess",
    "exchange",
    "excite",
    "exclude",
    "excuse",
    "execute",
    "exercise",
    "exhaust",
    "exhibit",
    "exile",
    "exist",
    "exit",
    "exotic",
    "expand",
    "expect",
    "expire",
    "explain",
    "expose",
    "express",
    "extend",
    "extra",
    "eye",
    "eyebrow",
    "fabric",
    "face",
    "faculty",
    "fade",
    "faint",
    "faith",
    "fall",
    "false",
    "fame",
    "family",
    "famous",
    "fan",
    "fancy",
    "fantasy",
    "farm",
    "fashion",
    "fat",
    "fatal",
    "father",
    "fatigue",
    "fault",
    "favorite",
    "feature",
    "february",
    "federal",
    "fee",
    "feed",
    "feel",
    "female",
    "fence",
    "festival",
    "fetch",
    "fever",
    "few",
    "fiber",
    "fiction",
    "field",
    "figure",
    "file",
    "film",
    "filter",
    "final",
    "find",
    "fine",
    "finger",
    "finish",
    "fire",
    "firm",
    "first",
    "fiscal",
    "fish",
    "fit",
    "fitness",
    "fix",
    "flag",
    "flame",
    "flash",
    "flat",
    "flavor",
    "flee",
    "flight",
    "flip",
    "float",
    "flock",
    "floor",
    "flower",
    "fluid",
    "flush",
    "fly",
    "foam",
    "focus",
    "fog",
    "foil",
    "fold",
    "follow",
    "food",
    "foot",
    "force",
    "forest",
    "forget",
    "fork",
    "fortune",
    "forum",
    "forward",
    "fossil",
    "foster",
    "found",
    "fox",
    "fragile",
    "frame",
    "frequent",
    "fresh",
    "friend",
    "fringe",
    "frog",
    "front",
    "frost",
    "frown",
    "frozen",
    "fruit",
    "fuel",
    "fun",
    "funny",
    "furnace",
    "fury",
    "future",
    "gadget",
    "gain",
    "galaxy",
    "gallery",
    "game",
    "gap",
    "garage",
    "garbage",
    "garden",
    "garlic",
    "garment",
    "gas",
    "gasp",
    "gate",
    "gather",
    "gauge",
    "gaze",
    "general",
    "genius",
    "genre",
    "gentle",
    "genuine",
    "gesture",
    "ghost",
    "giant",
    "gift",
    "giggle",
    "ginger",
    "giraffe",
    "girl",
    "give",
    "glad",
    "glance",
    "glare",
    "glass",
    "glide",
    "glimpse",
    "globe",
    "gloom",
    "glory",
    "glove",
    "glow",
    "glue",
    "goat",
    "goddess",
    "gold",
    "good",
    "goose",
    "gorilla",
    "gospel",
    "gossip",
    "govern",
    "gown",
    "grab",
    "grace",
    "grain",
    "grant",
    "grape",
    "grass",
    "gravity",
    "great",
    "green",
    "grid",
    "grief",
    "grit",
    "grocery",
    "group",
    "grow",
    "grunt",
    "guard",
    "guess",
    "guide",
    "guilt",
    "guitar",
    "gun",
    "gym",
    "habit",
    "hair",
    "half",
    "hammer",
    "hamster",
    "hand",
    "happy",
    "harbor",
    "hard",
    "harsh",
    "harvest",
    "hat",
    "have",
    "hawk",
    "hazard",
    "head",
    "health",
    "heart",
    "heavy",
    "hedgehog",
    "height",
    "hello",
    "helmet",
    "help",
    "hen",
    "hero",
    "hidden",
    "high",
    "hill",
    "hint",
    "hip",
    "hire",
    "history",
    "hobby",
    "hockey",
    "hold",
    "hole",
    "holiday",
    "hollow",
    "home",
    "honey",
    "hood",
    "hope",
    "horn",
    "horror",
    "horse",
    "hospital",
    "host",
    "hotel",
    "hour",
    "hover",
    "hub",
    "huge",
    "human",
    "humble",
    "humor",
    "hundred",
    "hungry",
    "hunt",
    "hurdle",
    "hurry",
    "hurt",
    "husband",
    "hybrid",
    "ice",
    "icon",
    "idea",
    "identify",
    "idle",
    "ignore",
    "ill",
    "illegal",
    "illness",
    "image",
    "imitate",
    "immense",
    "immune",
    "impact",
    "impose",
    "improve",
    "impulse",
    "inch",
    "include",
    "income",
    "increase",
    "index",
    "indicate",
    "indoor",
    "industry",
    "infant",
    "inflict",
    "inform",
    "inhale",
    "inherit",
    "initial",
    "inject",
    "injury",
    "inmate",
    "inner",
    "innocent",
    "input",
    "inquiry",
    "insane",
    "insect",
    "inside",
    "inspire",
    "install",
    "intact",
    "interest",
    "into",
    "invest",
    "invite",
    "involve",
    "iron",
    "island",
    "isolate",
    "issue",
    "item",
    "ivory",
    "jacket",
    "jaguar",
    "jar",
    "jazz",
    "jealous",
    "jeans",
    "jelly",
    "jewel",
    "job",
    "join",
    "joke",
    "journey",
    "joy",
    "judge",
    "juice",
    "jump",
    "jungle",
    "junior",
    "junk",
    "just",
    "kangaroo",
    "keen",
    "keep",
    "ketchup",
    "key",
    "kick",
    "kid",
    "kidney",
    "kind",
    "kingdom",
    "kiss",
    "kit",
    "kitchen",
    "kite",
    "kitten",
    "kiwi",
    "knee",
    "knife",
    "knock",
    "know",
    "lab",
    "label",
    "labor",
    "ladder",
    "lady",
    "lake",
    "lamp",
    "language",
    "laptop",
    "large",
    "later",
    "latin",
    "laugh",
    "laundry",
    "lava",
    "law",
    "lawn",
    "lawsuit",
    "layer",
    "lazy",
    "leader",
    "leaf",
    "learn",
    "leave",
    "lecture",
    "left",
    "leg",
    "legal",
    "legend",
    "leisure",
    "lemon",
    "lend",
    "length",
    "lens",
    "leopard",
    "lesson",
    "letter",
    "level",
    "liar",
    "liberty",
    "library",
    "license",
    "life",
    "lift",
    "light",
    "like",
    "limb",
    "limit",
    "link",
    "lion",
    "liquid",
    "list",
    "little",
    "live",
    "lizard",
    "load",
    "loan",
    "lobster",
    "local",
    "lock",
    "logic",
    "lonely",
    "long",
    "loop",
    "lottery",
    "loud",
    "lounge",
    "love",
    "loyal",
    "lucky",
    "luggage",
    "lumber",
    "lunar",
    "lunch",
    "luxury",
    "lyrics",
    "machine",
    "mad",
    "magic",
    "magnet",
    "maid",
    "mail",
    "main",
    "major",
    "make",
    "mammal",
    "man",
    "manage",
    "mandate",
    "mango",
    "mansion",
    "manual",
    "maple",
    "marble",
    "march",
    "margin",
    "marine",
    "market",
    "marriage",
    "mask",
    "mass",
    "master",
    "match",
    "material",
    "math",
    "matrix",
    "matter",
    "maximum",
    "maze",
    "meadow",
    "mean",
    "measure",
    "meat",
    "mechanic",
    "medal",
    "media",
    "melody",
    "melt",
    "member",
    "memory",
    "mention",
    "menu",
    "mercy",
    "merge",
    "merit",
    "merry",
    "mesh",
    "message",
    "metal",
    "method",
    "middle",
    "midnight",
    "milk",
    "million",
    "mimic",
    "mind",
    "minimum",
    "minor",
    "minute",
    "miracle",
    "mirror",
    "misery",
    "miss",
    "mistake",
    "mix",
    "mixed",
    "mixture",
    "mobile",
    "model",
    "modify",
    "mom",
    "moment",
    "monitor",
    "monkey",
    "monster",
    "month",
    "moon",
    "moral",
    "more",
    "morning",
    "mosquito",
    "mother",
    "motion",
    "motor",
    "mountain",
    "mouse",
    "move",
    "movie",
    "much",
    "muffin",
    "mule",
    "multiply",
    "muscle",
    "museum",
    "mushroom",
    "music",
    "must",
    "mutual",
    "myself",
    "mystery",
    "myth",
    "naive",
    "name",
    "napkin",
    "narrow",
    "nasty",
    "nation",
    "nature",
    "near",
    "neck",
    "need",
    "negative",
    "neglect",
    "neither",
    "nephew",
    "nerve",
    "nest",
    "net",
    "network",
    "neutral",
    "never",
    "news",
    "next",
    "nice",
    "night",
    "noble",
    "noise",
    "nominee",
    "noodle",
    "normal",
    "north",
    "nose",
    "notable",
    "note",
    "nothing",
    "notice",
    "novel",
    "now",
    "nuclear",
    "number",
    "nurse",
    "nut",
    "oak",
    "obey",
    "object",
    "oblige",
    "obscure",
    "observe",
    "obtain",
    "obvious",
    "occur",
    "ocean",
    "october",
    "odor",
    "off",
    "offer",
    "office",
    "often",
    "oil",
    "okay",
    "old",
    "olive",
    "olympic",
    "omit",
    "once",
    "one",
    "onion",
    "online",
    "only",
    "open",
    "opera",
    "opinion",
    "oppose",
    "option",
    "orange",
    "orbit",
    "orchard",
    "order",
    "ordinary",
    "organ",
    "orient",
    "original",
    "orphan",
    "ostrich",
    "other",
    "outdoor",
    "outer",
    "output",
    "outside",
    "oval",
    "oven",
    "over",
    "own",
    "owner",
    "oxygen",
    "oyster",
    "ozone",
    "pact",
    "paddle",
    "page",
    "pair",
    "palace",
    "palm",
    "panda",
    "panel",
    "panic",
    "panther",
    "paper",
    "parade",
    "parent",
    "park",
    "parrot",
    "party",
    "pass",
    "patch",
    "path",
    "patient",
    "patrol",
    "pattern",
    "pause",
    "pave",
    "payment",
    "peace",
    "peanut",
    "pear",
    "peasant",
    "pelican",
    "pen",
    "penalty",
    "pencil",
    "people",
    "pepper",
    "perfect",
    "permit",
    "person",
    "pet",
    "phone",
    "photo",
    "phrase",
    "physical",
    "piano",
    "picnic",
    "picture",
    "piece",
    "pig",
    "pigeon",
    "pill",
    "pilot",
    "pink",
    "pioneer",
    "pipe",
    "pistol",
    "pitch",
    "pizza",
    "place",
    "planet",
    "plastic",
    "plate",
    "play",
    "please",
    "pledge",
    "pluck",
    "plug",
    "plunge",
    "poem",
    "poet",
    "point",
    "polar",
    "pole",
    "police",
    "pond",
    "pony",
    "pool",
    "popular",
    "portion",
    "position",
    "possible",
    "post",
    "potato",
    "pottery",
    "poverty",
    "powder",
    "power",
    "practice",
    "praise",
    "predict",
    "prefer",
    "prepare",
    "present",
    "pretty",
    "prevent",
    "price",
    "pride",
    "primary",
    "print",
    "priority",
    "prison",
    "private",
    "prize",
    "problem",
    "process",
    "produce",
    "profit",
    "program",
    "project",
    "promote",
    "proof",
    "property",
    "prosper",
    "protect",
    "proud",
    "provide",
    "public",
    "pudding",
    "pull",
    "pulp",
    "pulse",
    "pumpkin",
    "punch",
    "pupil",
    "puppy",
    "purchase",
    "purity",
    "purpose",
    "purse",
    "push",
    "put",
    "puzzle",
    "pyramid",
    "quality",
    "quantum",
    "quarter",
    "question",
    "quick",
    "quit",
    "quiz",
    "quote",
    "rabbit",
    "raccoon",
    "race",
    "rack",
    "radar",
    "radio",
    "rail",
    "rain",
    "raise",
    "rally",
    "ramp",
    "ranch",
    "random",
    "range",
    "rapid",
    "rare",
    "rate",
    "rather",
    "raven",
    "raw",
    "razor",
    "ready",
    "real",
    "reason",
    "rebel",
    "rebuild",
    "recall",
    "receive",
    "recipe",
    "record",
    "recycle",
    "reduce",
    "reflect",
    "reform",
    "refuse",
    "region",
    "regret",
    "regular",
    "reject",
    "relax",
    "release",
    "relief",
    "rely",
    "remain",
    "remember",
    "remind",
    "remove",
    "render",
    "renew",
    "rent",
    "reopen",
    "repair",
    "repeat",
    "replace",
    "report",
    "require",
    "rescue",
    "resemble",
    "resist",
    "resource",
    "response",
    "result",
    "retire",
    "retreat",
    "return",
    "reunion",
    "reveal",
    "review",
    "reward",
    "rhythm",
    "rib",
    "ribbon",
    "rice",
    "rich",
    "ride",
    "ridge",
    "rifle",
    "right",
    "rigid",
    "ring",
    "riot",
    "ripple",
    "risk",
    "ritual",
    "rival",
    "river",
    "road",
    "roast",
    "robot",
    "robust",
    "rocket",
    "romance",
    "roof",
    "rookie",
    "room",
    "rose",
    "rotate",
    "rough",
    "round",
    "route",
    "royal",
    "rubber",
    "rude",
    "rug",
    "rule",
    "run",
    "runway",
    "rural",
    "sad",
    "saddle",
    "sadness",
    "safe",
    "sail",
    "salad",
    "salmon",
    "salon",
    "salt",
    "salute",
    "same",
    "sample",
    "sand",
    "satisfy",
    "satoshi",
    "sauce",
    "sausage",
    "save",
    "say",
    "scale",
    "scan",
    "scare",
    "scatter",
    "scene",
    "scheme",
    "school",
    "science",
    "scissors",
    "scorpion",
    "scout",
    "scrap",
    "screen",
    "script",
    "scrub",
    "sea",
    "search",
    "season",
    "seat",
    "second",
    "secret",
    "section",
    "security",
    "seed",
    "seek",
    "segment",
    "select",
    "sell",
    "seminar",
    "senior",
    "sense",
    "sentence",
    "series",
    "service",
    "session",
    "settle",
    "setup",
    "seven",
    "shadow",
    "shaft",
    "shallow",
    "share",
    "shed",
    "shell",
    "sheriff",
    "shield",
    "shift",
    "shine",
    "ship",
    "shiver",
    "shock",
    "shoe",
    "shoot",
    "shop",
    "short",
    "shoulder",
    "shove",
    "shrimp",
    "shrug",
    "shuffle",
    "shy",
    "sibling",
    "sick",
    "side",
    "siege",
    "sight",
    "sign",
    "silent",
    "silk",
    "silly",
    "silver",
    "similar",
    "simple",
    "since",
    "sing",
    "siren",
    "sister",
    "situate",
    "six",
    "size",
    "skate",
    "sketch",
    "ski",
    "skill",
    "skin",
    "skirt",
    "skull",
    "slab",
    "slam",
    "sleep",
    "slender",
    "slice",
    "slide",
    "slight",
    "slim",
    "slogan",
    "slot",
    "slow",
    "slush",
    "small",
    "smart",
    "smile",
    "smoke",
    "smooth",
    "snack",
    "snake",
    "snap",
    "sniff",
    "snow",
    "soap",
    "soccer",
    "social",
    "sock",
    "soda",
    "soft",
    "solar",
    "soldier",
    "solid",
    "solution",
    "solve",
    "someone",
    "song",
    "soon",
    "sorry",
    "sort",
    "soul",
    "sound",
    "soup",
    "source",
    "south",
    "space",
    "spare",
    "spatial",
    "spawn",
    "speak",
    "special",
    "speed",
    "spell",
    "spend",
    "sphere",
    "spice",
    "spider",
    "spike",
    "spin",
    "spirit",
    "split",
    "spoil",
    "sponsor",
    "spoon",
    "sport",
    "spot",
    "spray",
    "spread",
    "spring",
    "spy",
    "square",
    "squeeze",
    "squirrel",
    "stable",
    "stadium",
    "staff",
    "stage",
    "stairs",
    "stamp",
    "stand",
    "start",
    "state",
    "stay",
    "steak",
    "steel",
    "stem",
    "step",
    "stereo",
    "stick",
    "still",
    "sting",
    "stock",
    "stomach",
    "stone",
    "stool",
    "story",
    "stove",
    "strategy",
    "street",
    "strike",
    "strong",
    "struggle",
    "student",
    "stuff",
    "stumble",
    "style",
    "subject",
    "submit",
    "subway",
    "success",
    "such",
    "sudden",
    "suffer",
    "sugar",
    "suggest",
    "suit",
    "summer",
    "sun",
    "sunny",
    "sunset",
    "super",
    "supply",
    "supreme",
    "sure",
    "surface",
    "surge",
    "surprise",
    "surround",
    "survey",
    "suspect",
    "sustain",
    "swallow",
    "swamp",
    "swap",
    "swarm",
    "swear",
    "sweet",
    "swift",
    "swim",
    "swing",
    "switch",
    "sword",
    "symbol",
    "symptom",
    "syrup",
    "system",
    "table",
    "tackle",
    "tag",
    "tail",
    "talent",
    "talk",
    "tank",
    "tape",
    "target",
    "task",
    "taste",
    "tattoo",
    "taxi",
    "teach",
    "team",
    "tell",
    "ten",
    "tenant",
    "tennis",
    "tent",
    "term",
    "test",
    "text",
    "thank",
    "that",
    "theme",
    "then",
    "theory",
    "there",
    "they",
    "thing",
    "this",
    "thought",
    "three",
    "thrive",
    "throw",
    "thumb",
    "thunder",
    "ticket",
    "tide",
    "tiger",
    "tilt",
    "timber",
    "time",
    "tiny",
    "tip",
    "tired",
    "tissue",
    "title",
    "toast",
    "tobacco",
    "today",
    "toddler",
    "toe",
    "together",
    "toilet",
    "token",
    "tomato",
    "tomorrow",
    "tone",
    "tongue",
    "tonight",
    "tool",
    "tooth",
    "top",
    "topic",
    "topple",
    "torch",
    "tornado",
    "tortoise",
    "toss",
    "total",
    "tourist",
    "toward",
    "tower",
    "town",
    "toy",
    "track",
    "trade",
    "traffic",
    "tragic",
    "train",
    "transfer",
    "trap",
    "trash",
    "travel",
    "tray",
    "treat",
    "tree",
    "trend",
    "trial",
    "tribe",
    "trick",
    "trigger",
    "trim",
    "trip",
    "trophy",
    "trouble",
    "truck",
    "true",
    "truly",
    "trumpet",
    "trust",
    "truth",
    "try",
    "tube",
    "tuition",
    "tumble",
    "tuna",
    "tunnel",
    "turkey",
    "turn",
    "turtle",
    "twelve",
    "twenty",
    "twice",
    "twin",
    "twist",
    "two",
    "type",
    "typical",
    "ugly",
    "umbrella",
    "unable",
    "unaware",
    "uncle",
    "uncover",
    "under",
    "undo",
    "unfair",
    "unfold",
    "unhappy",
    "uniform",
    "unique",
    "unit",
    "universe",
    "unknown",
    "unlock",
    "until",
    "unusual",
    "unveil",
    "update",
    "upgrade",
    "uphold",
    "upon",
    "upper",
    "upset",
    "urban",
    "urge",
    "usage",
    "use",
    "used",
    "useful",
    "useless",
    "usual",
    "utility",
    "vacant",
    "vacuum",
    "vague",
    "valid",
    "valley",
    "valve",
    "van",
    "vanish",
    "vapor",
    "various",
    "vast",
    "vault",
    "vehicle",
    "velvet",
    "vendor",
    "venture",
    "venue",
    "verb",
    "verify",
    "version",
    "very",
    "vessel",
    "veteran",
    "viable",
    "vibrant",
    "vicious",
    "victory",
    "video",
    "view",
    "village",
    "vintage",
    "violin",
    "virtual",
    "virus",
    "visa",
    "visit",
    "visual",
    "vital",
    "vivid",
    "vocal",
    "voice",
    "void",
    "volcano",
    "volume",
    "vote",
    "voyage",
    "wage",
    "wagon",
    "wait",
    "walk",
    "wall",
    "walnut",
    "want",
    "warfare",
    "warm",
    "warrior",
    "wash",
    "wasp",
    "waste",
    "water",
    "wave",
    "way",
    "wealth",
    "weapon",
    "wear",
    "weasel",
    "weather",
    "web",
    "wedding",
    "weekend",
    "weird",
    "welcome",
    "west",
    "wet",
    "whale",
    "what",
    "wheat",
    "wheel",
    "when",
    "where",
    "whip",
    "whisper",
    "wide",
    "width",
    "wife",
    "wild",
    "will",
    "win",
    "window",
    "wine",
    "wing",
    "wink",
    "winner",
    "winter",
    "wire",
    "wisdom",
    "wise",
    "wish",
    "witness",
    "wolf",
    "woman",
    "wonder",
    "wood",
    "wool",
    "word",
    "work",
    "world",
    "worry",
    "worth",
    "wrap",
    "wreck",
    "wrestle",
    "wrist",
    "write",
    "wrong",
    "yard",
    "year",
    "yellow",
    "you",
    "young",
    "youth",
    "zebra",
    "zero",
    "zone",
    "zoo"
];
function $785c53af8942025c$var$bytesToBitstring(bytes) {
    return Array.from(bytes).map((byte)=>byte.toString(2).padStart(8, "0")).join("");
}
function $785c53af8942025c$var$deriveChecksumBits(entropy) {
    const entropyLengthBits = entropy.length * 8; // "ENT" (in bits)
    const checksumLengthBits = entropyLengthBits / 32; // "CS" (in bits)
    const hash = (0, $dlig8.sha256)(entropy);
    return $785c53af8942025c$var$bytesToBitstring(hash).slice(0, checksumLengthBits);
}
function $785c53af8942025c$var$bitstringToByte(bin) {
    return parseInt(bin, 2);
}
const $785c53af8942025c$var$allowedEntropyLengths = [
    16,
    20,
    24,
    28,
    32
];
const $785c53af8942025c$var$allowedWordLengths = [
    12,
    15,
    18,
    21,
    24
];
function $785c53af8942025c$var$entropyToMnemonic(entropy) {
    if ($785c53af8942025c$var$allowedEntropyLengths.indexOf(entropy.length) === -1) throw new Error("invalid input length");
    const entropyBits = $785c53af8942025c$var$bytesToBitstring(entropy);
    const checksumBits = $785c53af8942025c$var$deriveChecksumBits(entropy);
    const bits = entropyBits + checksumBits;
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    const chunks = bits.match(/(.{11})/g);
    const words = chunks.map((binary)=>{
        const index = $785c53af8942025c$var$bitstringToByte(binary);
        return $785c53af8942025c$var$wordlist[index];
    });
    return words.join(" ");
}
module.exports.entropyToMnemonic = $785c53af8942025c$var$entropyToMnemonic;
const $785c53af8942025c$var$invalidNumberOfWorks = "Invalid number of words";
const $785c53af8942025c$var$wordNotInWordlist = "Found word that is not in the wordlist";
const $785c53af8942025c$var$invalidEntropy = "Invalid entropy";
const $785c53af8942025c$var$invalidChecksum = "Invalid mnemonic checksum";
function $785c53af8942025c$var$normalize(str) {
    return str.normalize("NFKD");
}
function $785c53af8942025c$var$mnemonicToEntropy(mnemonic) {
    const words = $785c53af8942025c$var$normalize(mnemonic).split(" ");
    if (!$785c53af8942025c$var$allowedWordLengths.includes(words.length)) throw new Error($785c53af8942025c$var$invalidNumberOfWorks);
    // convert word indices to 11 bit binary strings
    const bits = words.map((word)=>{
        const index = $785c53af8942025c$var$wordlist.indexOf(word);
        if (index === -1) throw new Error($785c53af8942025c$var$wordNotInWordlist);
        return index.toString(2).padStart(11, "0");
    }).join("");
    // split the binary string into ENT/CS
    const dividerIndex = Math.floor(bits.length / 33) * 32;
    const entropyBits = bits.slice(0, dividerIndex);
    const checksumBits = bits.slice(dividerIndex);
    // calculate the checksum and compare
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    const entropyBytes = entropyBits.match(/(.{1,8})/g).map($785c53af8942025c$var$bitstringToByte);
    if (entropyBytes.length < 16 || entropyBytes.length > 32 || entropyBytes.length % 4 !== 0) throw new Error($785c53af8942025c$var$invalidEntropy);
    const entropy = Uint8Array.from(entropyBytes);
    const newChecksum = $785c53af8942025c$var$deriveChecksumBits(entropy);
    if (newChecksum !== checksumBits) throw new Error($785c53af8942025c$var$invalidChecksum);
    return entropy;
}
module.exports.mnemonicToEntropy = $785c53af8942025c$var$mnemonicToEntropy;
class $785c53af8942025c$var$EnglishMnemonic {
    constructor(mnemonic){
        if (!$785c53af8942025c$var$EnglishMnemonic.mnemonicMatcher.test(mnemonic)) throw new Error("Invalid mnemonic format");
        const words = mnemonic.split(" ");
        const allowedWordsLengths = [
            12,
            15,
            18,
            21,
            24
        ];
        if (allowedWordsLengths.indexOf(words.length) === -1) throw new Error(`Invalid word count in mnemonic (allowed: ${allowedWordsLengths} got: ${words.length})`);
        for (const word of words){
            if ($785c53af8942025c$var$EnglishMnemonic.wordlist.indexOf(word) === -1) throw new Error("Mnemonic contains invalid word");
        }
        // Throws with informative error message if mnemonic is not valid
        $785c53af8942025c$var$mnemonicToEntropy(mnemonic);
        this.data = mnemonic;
    }
    toString() {
        return this.data;
    }
}
module.exports.EnglishMnemonic = $785c53af8942025c$var$EnglishMnemonic;
$785c53af8942025c$var$EnglishMnemonic.wordlist = $785c53af8942025c$var$wordlist;
// list of space separated lower case words (1 or more)
$785c53af8942025c$var$EnglishMnemonic.mnemonicMatcher = /^[a-z]+( [a-z]+)*$/;
class $785c53af8942025c$var$Bip39 {
    /**
     * Encodes raw entropy of length 16, 20, 24, 28 or 32 bytes as an English mnemonic between 12 and 24 words.
     *
     * | Entropy            | Words |
     * |--------------------|-------|
     * | 128 bit (16 bytes) |    12 |
     * | 160 bit (20 bytes) |    15 |
     * | 192 bit (24 bytes) |    18 |
     * | 224 bit (28 bytes) |    21 |
     * | 256 bit (32 bytes) |    24 |
     *
     *
     * @see https://github.com/bitcoin/bips/blob/master/bip-0039.mediawiki#generating-the-mnemonic
     * @param entropy The entropy to be encoded. This must be cryptographically secure.
     */ static encode(entropy) {
        return new $785c53af8942025c$var$EnglishMnemonic($785c53af8942025c$var$entropyToMnemonic(entropy));
    }
    static decode(mnemonic) {
        return $785c53af8942025c$var$mnemonicToEntropy(mnemonic.toString());
    }
    static async mnemonicToSeed(mnemonic, password) {
        const mnemonicBytes = (0, $6XcLW.toUtf8)($785c53af8942025c$var$normalize(mnemonic.toString()));
        const salt = "mnemonic" + (password ? $785c53af8942025c$var$normalize(password) : "");
        const saltBytes = (0, $6XcLW.toUtf8)(salt);
        return (0, $k7mTa.pbkdf2Sha512)(mnemonicBytes, saltBytes, 2048, 64);
    }
}
module.exports.Bip39 = $785c53af8942025c$var$Bip39;

});
parcelRequire.register("6XcLW", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.toUtf8 = module.exports.fromUtf8 = module.exports.toRfc3339 = module.exports.fromRfc3339 = module.exports.toHex = module.exports.fromHex = module.exports.toBech32 = module.exports.normalizeBech32 = module.exports.fromBech32 = module.exports.toBase64 = module.exports.fromBase64 = module.exports.toAscii = module.exports.fromAscii = void 0;

var $5R56u = parcelRequire("5R56u");
Object.defineProperty(module.exports, "fromAscii", {
    enumerable: true,
    get: function() {
        return $5R56u.fromAscii;
    }
});
Object.defineProperty(module.exports, "toAscii", {
    enumerable: true,
    get: function() {
        return $5R56u.toAscii;
    }
});

var $1B6LA = parcelRequire("1B6LA");
Object.defineProperty(module.exports, "fromBase64", {
    enumerable: true,
    get: function() {
        return $1B6LA.fromBase64;
    }
});
Object.defineProperty(module.exports, "toBase64", {
    enumerable: true,
    get: function() {
        return $1B6LA.toBase64;
    }
});

var $jGsk3 = parcelRequire("jGsk3");
Object.defineProperty(module.exports, "fromBech32", {
    enumerable: true,
    get: function() {
        return $jGsk3.fromBech32;
    }
});
Object.defineProperty(module.exports, "normalizeBech32", {
    enumerable: true,
    get: function() {
        return $jGsk3.normalizeBech32;
    }
});
Object.defineProperty(module.exports, "toBech32", {
    enumerable: true,
    get: function() {
        return $jGsk3.toBech32;
    }
});

var $3E9jN = parcelRequire("3E9jN");
Object.defineProperty(module.exports, "fromHex", {
    enumerable: true,
    get: function() {
        return $3E9jN.fromHex;
    }
});
Object.defineProperty(module.exports, "toHex", {
    enumerable: true,
    get: function() {
        return $3E9jN.toHex;
    }
});

var $1L9Pt = parcelRequire("1L9Pt");
Object.defineProperty(module.exports, "fromRfc3339", {
    enumerable: true,
    get: function() {
        return $1L9Pt.fromRfc3339;
    }
});
Object.defineProperty(module.exports, "toRfc3339", {
    enumerable: true,
    get: function() {
        return $1L9Pt.toRfc3339;
    }
});

var $jkGCB = parcelRequire("jkGCB");
Object.defineProperty(module.exports, "fromUtf8", {
    enumerable: true,
    get: function() {
        return $jkGCB.fromUtf8;
    }
});
Object.defineProperty(module.exports, "toUtf8", {
    enumerable: true,
    get: function() {
        return $jkGCB.toUtf8;
    }
});

});
parcelRequire.register("5R56u", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.fromAscii = module.exports.toAscii = void 0;
function $4435dc746c1d067d$var$toAscii(input) {
    const toNums = (str)=>str.split("").map((x)=>{
            const charCode = x.charCodeAt(0);
            // 0x00–0x1F control characters
            // 0x20–0x7E printable characters
            // 0x7F delete character
            // 0x80–0xFF out of 7 bit ascii range
            if (charCode < 0x20 || charCode > 0x7e) throw new Error("Cannot encode character that is out of printable ASCII range: " + charCode);
            return charCode;
        });
    return Uint8Array.from(toNums(input));
}
module.exports.toAscii = $4435dc746c1d067d$var$toAscii;
function $4435dc746c1d067d$var$fromAscii(data) {
    const fromNums = (listOfNumbers)=>listOfNumbers.map((x)=>{
            // 0x00–0x1F control characters
            // 0x20–0x7E printable characters
            // 0x7F delete character
            // 0x80–0xFF out of 7 bit ascii range
            if (x < 0x20 || x > 0x7e) throw new Error("Cannot decode character that is out of printable ASCII range: " + x);
            return String.fromCharCode(x);
        });
    return fromNums(Array.from(data)).join("");
}
module.exports.fromAscii = $4435dc746c1d067d$var$fromAscii;

});

parcelRequire.register("1B6LA", function(module, exports) {
"use strict";
var $129e7ed659e129ed$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $129e7ed659e129ed$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $129e7ed659e129ed$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $129e7ed659e129ed$var$__createBinding(result, mod, k);
    }
    $129e7ed659e129ed$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.fromBase64 = module.exports.toBase64 = void 0;

const $129e7ed659e129ed$var$base64js = $129e7ed659e129ed$var$__importStar((parcelRequire("hqZtu")));
function $129e7ed659e129ed$var$toBase64(data) {
    return $129e7ed659e129ed$var$base64js.fromByteArray(data);
}
module.exports.toBase64 = $129e7ed659e129ed$var$toBase64;
function $129e7ed659e129ed$var$fromBase64(base64String) {
    if (!base64String.match(/^[a-zA-Z0-9+/]*={0,2}$/)) throw new Error("Invalid base64 string format");
    return $129e7ed659e129ed$var$base64js.toByteArray(base64String);
}
module.exports.fromBase64 = $129e7ed659e129ed$var$fromBase64;

});

parcelRequire.register("jGsk3", function(module, exports) {
"use strict";
var $e547e8d22ee05a93$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $e547e8d22ee05a93$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $e547e8d22ee05a93$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $e547e8d22ee05a93$var$__createBinding(result, mod, k);
    }
    $e547e8d22ee05a93$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.normalizeBech32 = module.exports.fromBech32 = module.exports.toBech32 = void 0;

const $e547e8d22ee05a93$var$bech32 = $e547e8d22ee05a93$var$__importStar((parcelRequire("5wgCY")));
function $e547e8d22ee05a93$var$toBech32(prefix, data, limit) {
    const address = $e547e8d22ee05a93$var$bech32.encode(prefix, $e547e8d22ee05a93$var$bech32.toWords(data), limit);
    return address;
}
module.exports.toBech32 = $e547e8d22ee05a93$var$toBech32;
function $e547e8d22ee05a93$var$fromBech32(address, limit = Infinity) {
    const decodedAddress = $e547e8d22ee05a93$var$bech32.decode(address, limit);
    return {
        prefix: decodedAddress.prefix,
        data: new Uint8Array($e547e8d22ee05a93$var$bech32.fromWords(decodedAddress.words))
    };
}
module.exports.fromBech32 = $e547e8d22ee05a93$var$fromBech32;
/**
 * Takes a bech32 address and returns a normalized (i.e. lower case) representation of it.
 *
 * The input is validated along the way, which makes this significantly safer than
 * using `address.toLowerCase()`.
 */ function $e547e8d22ee05a93$var$normalizeBech32(address) {
    const { prefix: prefix, data: data } = $e547e8d22ee05a93$var$fromBech32(address);
    return $e547e8d22ee05a93$var$toBech32(prefix, data);
}
module.exports.normalizeBech32 = $e547e8d22ee05a93$var$normalizeBech32;

});

parcelRequire.register("3E9jN", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.fromHex = module.exports.toHex = void 0;
function $2a7c55ee5723a689$var$toHex(data) {
    let out = "";
    for (const byte of data)out += ("0" + byte.toString(16)).slice(-2);
    return out;
}
module.exports.toHex = $2a7c55ee5723a689$var$toHex;
function $2a7c55ee5723a689$var$fromHex(hexstring) {
    if (hexstring.length % 2 !== 0) throw new Error("hex string length must be a multiple of 2");
    const out = new Uint8Array(hexstring.length / 2);
    for(let i = 0; i < out.length; i++){
        const j = 2 * i;
        const hexByteAsString = hexstring.slice(j, j + 2);
        if (!hexByteAsString.match(/[0-9a-f]{2}/i)) throw new Error("hex string contains invalid characters");
        out[i] = parseInt(hexByteAsString, 16);
    }
    return out;
}
module.exports.fromHex = $2a7c55ee5723a689$var$fromHex;

});

parcelRequire.register("1L9Pt", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.toRfc3339 = module.exports.fromRfc3339 = void 0;
const $1481ce17dc2e6dd8$var$rfc3339Matcher = /^(\d{4})-(\d{2})-(\d{2})[T ](\d{2}):(\d{2}):(\d{2})(\.\d{1,9})?((?:[+-]\d{2}:\d{2})|Z)$/;
function $1481ce17dc2e6dd8$var$padded(integer, length = 2) {
    return integer.toString().padStart(length, "0");
}
function $1481ce17dc2e6dd8$var$fromRfc3339(str) {
    const matches = $1481ce17dc2e6dd8$var$rfc3339Matcher.exec(str);
    if (!matches) throw new Error("Date string is not in RFC3339 format");
    const year = +matches[1];
    const month = +matches[2];
    const day = +matches[3];
    const hour = +matches[4];
    const minute = +matches[5];
    const second = +matches[6];
    // fractional seconds match either undefined or a string like ".1", ".123456789"
    const milliSeconds = matches[7] ? Math.floor(+matches[7] * 1000) : 0;
    let tzOffsetSign;
    let tzOffsetHours;
    let tzOffsetMinutes;
    // if timezone is undefined, it must be Z or nothing (otherwise the group would have captured).
    if (matches[8] === "Z") {
        tzOffsetSign = 1;
        tzOffsetHours = 0;
        tzOffsetMinutes = 0;
    } else {
        tzOffsetSign = matches[8].substring(0, 1) === "-" ? -1 : 1;
        tzOffsetHours = +matches[8].substring(1, 3);
        tzOffsetMinutes = +matches[8].substring(4, 6);
    }
    const tzOffset = tzOffsetSign * (tzOffsetHours * 60 + tzOffsetMinutes) * 60; // seconds
    const timestamp = Date.UTC(year, month - 1, day, hour, minute, second, milliSeconds) - tzOffset * 1000;
    return new Date(timestamp);
}
module.exports.fromRfc3339 = $1481ce17dc2e6dd8$var$fromRfc3339;
function $1481ce17dc2e6dd8$var$toRfc3339(date) {
    const year = date.getUTCFullYear();
    const month = $1481ce17dc2e6dd8$var$padded(date.getUTCMonth() + 1);
    const day = $1481ce17dc2e6dd8$var$padded(date.getUTCDate());
    const hour = $1481ce17dc2e6dd8$var$padded(date.getUTCHours());
    const minute = $1481ce17dc2e6dd8$var$padded(date.getUTCMinutes());
    const second = $1481ce17dc2e6dd8$var$padded(date.getUTCSeconds());
    const ms = $1481ce17dc2e6dd8$var$padded(date.getUTCMilliseconds(), 3);
    return `${year}-${month}-${day}T${hour}:${minute}:${second}.${ms}Z`;
}
module.exports.toRfc3339 = $1481ce17dc2e6dd8$var$toRfc3339;

});

parcelRequire.register("jkGCB", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.fromUtf8 = module.exports.toUtf8 = void 0;
function $e130f258a2708cce$var$toUtf8(str) {
    return new TextEncoder().encode(str);
}
module.exports.toUtf8 = $e130f258a2708cce$var$toUtf8;
/**
 * Takes UTF-8 data and decodes it to a string.
 *
 * In lossy mode, the replacement character � is used to substitude invalid
 * encodings. By default lossy mode is off and invalid data will lead to exceptions.
 */ function $e130f258a2708cce$var$fromUtf8(data, lossy = false) {
    const fatal = !lossy;
    return new TextDecoder("utf-8", {
        fatal: fatal
    }).decode(data);
}
module.exports.fromUtf8 = $e130f258a2708cce$var$fromUtf8;

});


parcelRequire.register("k7mTa", function(module, exports) {
"use strict";
var $ea56375a06341861$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $ea56375a06341861$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $ea56375a06341861$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $ea56375a06341861$var$__createBinding(result, mod, k);
    }
    $ea56375a06341861$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.pbkdf2Sha512 = module.exports.pbkdf2Sha512Noble = module.exports.pbkdf2Sha512NodeCrypto = module.exports.pbkdf2Sha512Subtle = module.exports.getSubtle = module.exports.getNodeCrypto = void 0;

var $fZwG5 = parcelRequire("fZwG5");

var $bQlVj = parcelRequire("bQlVj");

var $fJ9Lg = parcelRequire("fJ9Lg");

/**
 * Returns the Node.js crypto module when available and `undefined`
 * otherwise.
 *
 * Detects an unimplemented fallback module from Webpack 5 and returns
 * `undefined` in that case.
 */ async function $ea56375a06341861$var$getNodeCrypto() {
    try {
        const nodeCrypto = await Promise.resolve().then(function() {
            return Promise.resolve((parcelRequire("aO8Ot")));
        }).then((res)=>$ea56375a06341861$var$__importStar(res));
        // We get `Object{default: Object{}}` as a fallback when using
        // `crypto: false` in Webpack 5, which we interprete as unavailable.
        if (typeof nodeCrypto === "object" && Object.keys(nodeCrypto).length <= 1) return undefined;
        return nodeCrypto;
    } catch  {
        return undefined;
    }
}
module.exports.getNodeCrypto = $ea56375a06341861$var$getNodeCrypto;
async function $ea56375a06341861$var$getSubtle() {
    // From Node.js 15 onwards, webcrypto is available in globalThis.
    // In version 15 and 16 this was stored under the webcrypto key.
    // With Node.js 17 it was moved to the same locations where browsers
    // make it available.
    // Loading `require("crypto")` here seems unnecessary since it only
    // causes issues with bundlers and does not increase compatibility.
    // Browsers and Node.js 17+
    let subtle = globalThis?.crypto?.subtle;
    // Node.js 15+
    if (!subtle) subtle = globalThis?.crypto?.webcrypto?.subtle;
    return subtle;
}
module.exports.getSubtle = $ea56375a06341861$var$getSubtle;
async function $ea56375a06341861$var$pbkdf2Sha512Subtle(// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
subtle, secret, salt, iterations, keylen) {
    (0, $fZwG5.assert)(subtle, "Argument subtle is falsy");
    (0, $fZwG5.assert)(typeof subtle === "object", "Argument subtle is not of type object");
    (0, $fZwG5.assert)(typeof subtle.importKey === "function", "subtle.importKey is not a function");
    (0, $fZwG5.assert)(typeof subtle.deriveBits === "function", "subtle.deriveBits is not a function");
    return subtle.importKey("raw", secret, {
        name: "PBKDF2"
    }, false, [
        "deriveBits"
    ]).then((key)=>subtle.deriveBits({
            name: "PBKDF2",
            salt: salt,
            iterations: iterations,
            hash: {
                name: "SHA-512"
            }
        }, key, keylen * 8).then((buffer)=>new Uint8Array(buffer)));
}
module.exports.pbkdf2Sha512Subtle = $ea56375a06341861$var$pbkdf2Sha512Subtle;
/**
 * Implements pbkdf2-sha512 using the Node.js crypro module (`import "crypto"`).
 * This does not use subtle from [Crypto](https://developer.mozilla.org/en-US/docs/Web/API/Crypto).
 */ async function $ea56375a06341861$var$pbkdf2Sha512NodeCrypto(// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
nodeCrypto, secret, salt, iterations, keylen) {
    (0, $fZwG5.assert)(nodeCrypto, "Argument nodeCrypto is falsy");
    (0, $fZwG5.assert)(typeof nodeCrypto === "object", "Argument nodeCrypto is not of type object");
    (0, $fZwG5.assert)(typeof nodeCrypto.pbkdf2 === "function", "nodeCrypto.pbkdf2 is not a function");
    return new Promise((resolve, reject)=>{
        nodeCrypto.pbkdf2(secret, salt, iterations, keylen, "sha512", (error, result)=>{
            if (error) reject(error);
            else resolve(Uint8Array.from(result));
        });
    });
}
module.exports.pbkdf2Sha512NodeCrypto = $ea56375a06341861$var$pbkdf2Sha512NodeCrypto;
async function $ea56375a06341861$var$pbkdf2Sha512Noble(secret, salt, iterations, keylen) {
    return (0, $bQlVj.pbkdf2Async)($fJ9Lg.sha512, secret, salt, {
        c: iterations,
        dkLen: keylen
    });
}
module.exports.pbkdf2Sha512Noble = $ea56375a06341861$var$pbkdf2Sha512Noble;
/**
 * A pbkdf2 implementation for BIP39. This is not exported at package level and thus a private API.
 */ async function $ea56375a06341861$var$pbkdf2Sha512(secret, salt, iterations, keylen) {
    const subtle = await $ea56375a06341861$var$getSubtle();
    if (subtle) return $ea56375a06341861$var$pbkdf2Sha512Subtle(subtle, secret, salt, iterations, keylen);
    else {
        const nodeCrypto = await $ea56375a06341861$var$getNodeCrypto();
        if (nodeCrypto) return $ea56375a06341861$var$pbkdf2Sha512NodeCrypto(nodeCrypto, secret, salt, iterations, keylen);
        else return $ea56375a06341861$var$pbkdf2Sha512Noble(secret, salt, iterations, keylen);
    }
}
module.exports.pbkdf2Sha512 = $ea56375a06341861$var$pbkdf2Sha512;

});

parcelRequire.register("dlig8", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.sha512 = module.exports.Sha512 = module.exports.sha256 = module.exports.Sha256 = void 0;

var $lrsL3 = parcelRequire("lrsL3");

var $fJ9Lg = parcelRequire("fJ9Lg");

var $a1Zu0 = parcelRequire("a1Zu0");
class $9b6b666b8c35c1db$var$Sha256 {
    constructor(firstData){
        this.blockSize = 64;
        this.impl = $lrsL3.sha256.create();
        if (firstData) this.update(firstData);
    }
    update(data) {
        this.impl.update((0, $a1Zu0.toRealUint8Array)(data));
        return this;
    }
    digest() {
        return this.impl.digest();
    }
}
module.exports.Sha256 = $9b6b666b8c35c1db$var$Sha256;
/** Convenience function equivalent to `new Sha256(data).digest()` */ function $9b6b666b8c35c1db$var$sha256(data) {
    return new $9b6b666b8c35c1db$var$Sha256(data).digest();
}
module.exports.sha256 = $9b6b666b8c35c1db$var$sha256;
class $9b6b666b8c35c1db$var$Sha512 {
    constructor(firstData){
        this.blockSize = 128;
        this.impl = $fJ9Lg.sha512.create();
        if (firstData) this.update(firstData);
    }
    update(data) {
        this.impl.update((0, $a1Zu0.toRealUint8Array)(data));
        return this;
    }
    digest() {
        return this.impl.digest();
    }
}
module.exports.Sha512 = $9b6b666b8c35c1db$var$Sha512;
/** Convenience function equivalent to `new Sha512(data).digest()` */ function $9b6b666b8c35c1db$var$sha512(data) {
    return new $9b6b666b8c35c1db$var$Sha512(data).digest();
}
module.exports.sha512 = $9b6b666b8c35c1db$var$sha512;

});
parcelRequire.register("a1Zu0", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.toRealUint8Array = void 0;
// See https://github.com/paulmillr/noble-hashes/issues/25 for why this is needed
function $74d9b09d36da64ea$var$toRealUint8Array(data) {
    if (data instanceof Uint8Array) return data;
    else return Uint8Array.from(data);
}
module.exports.toRealUint8Array = $74d9b09d36da64ea$var$toRealUint8Array;

});



parcelRequire.register("aYUxM", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Hmac = void 0;
class $7feb5e69dd39c80c$var$Hmac {
    constructor(hashFunctionConstructor, originalKey){
        // This implementation is based on https://en.wikipedia.org/wiki/HMAC#Implementation
        // with the addition of incremental hashing support. Thus part of the algorithm
        // is in the constructor and the rest in digest().
        const blockSize = new hashFunctionConstructor().blockSize;
        this.hash = (data)=>new hashFunctionConstructor().update(data).digest();
        let key = originalKey;
        if (key.length > blockSize) key = this.hash(key);
        if (key.length < blockSize) {
            const zeroPadding = new Uint8Array(blockSize - key.length);
            key = new Uint8Array([
                ...key,
                ...zeroPadding
            ]);
        }
        // eslint-disable-next-line no-bitwise
        this.oKeyPad = key.map((keyByte)=>keyByte ^ 0x5c);
        // eslint-disable-next-line no-bitwise
        this.iKeyPad = key.map((keyByte)=>keyByte ^ 0x36);
        this.messageHasher = new hashFunctionConstructor();
        this.blockSize = blockSize;
        this.update(this.iKeyPad);
    }
    update(data) {
        this.messageHasher.update(data);
        return this;
    }
    digest() {
        const innerHash = this.messageHasher.digest();
        return this.hash(new Uint8Array([
            ...this.oKeyPad,
            ...innerHash
        ]));
    }
}
module.exports.Hmac = $7feb5e69dd39c80c$var$Hmac;

});

parcelRequire.register("ieied", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.keccak256 = module.exports.Keccak256 = void 0;

var $jDAn2 = parcelRequire("jDAn2");

var $a1Zu0 = parcelRequire("a1Zu0");
class $d457ac90929771b3$var$Keccak256 {
    constructor(firstData){
        this.blockSize = 64;
        this.impl = $jDAn2.keccak_256.create();
        if (firstData) this.update(firstData);
    }
    update(data) {
        this.impl.update((0, $a1Zu0.toRealUint8Array)(data));
        return this;
    }
    digest() {
        return this.impl.digest();
    }
}
module.exports.Keccak256 = $d457ac90929771b3$var$Keccak256;
/** Convenience function equivalent to `new Keccak256(data).digest()` */ function $d457ac90929771b3$var$keccak256(data) {
    return new $d457ac90929771b3$var$Keccak256(data).digest();
}
module.exports.keccak256 = $d457ac90929771b3$var$keccak256;

});
parcelRequire.register("jDAn2", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.shake256 = module.exports.shake128 = module.exports.keccak_512 = module.exports.keccak_384 = module.exports.keccak_256 = module.exports.keccak_224 = module.exports.sha3_512 = module.exports.sha3_384 = module.exports.sha3_256 = module.exports.sha3_224 = module.exports.Keccak = module.exports.keccakP = void 0;

var $kjkVj = parcelRequire("kjkVj");

var $gXXaj = parcelRequire("gXXaj");

var $ebEok = parcelRequire("ebEok");
// SHA3 (keccak) is based on a new design: basically, the internal state is bigger than output size.
// It's called a sponge function.
// Various per round constants calculations
const [$e4bddf487eff4619$var$SHA3_PI, $e4bddf487eff4619$var$SHA3_ROTL, $e4bddf487eff4619$var$_SHA3_IOTA] = [
    [],
    [],
    []
];
const $e4bddf487eff4619$var$_0n = /* @__PURE__ */ BigInt(0);
const $e4bddf487eff4619$var$_1n = /* @__PURE__ */ BigInt(1);
const $e4bddf487eff4619$var$_2n = /* @__PURE__ */ BigInt(2);
const $e4bddf487eff4619$var$_7n = /* @__PURE__ */ BigInt(7);
const $e4bddf487eff4619$var$_256n = /* @__PURE__ */ BigInt(256);
const $e4bddf487eff4619$var$_0x71n = /* @__PURE__ */ BigInt(0x71);
for(let round = 0, R = $e4bddf487eff4619$var$_1n, x = 1, y = 0; round < 24; round++){
    // Pi
    [x, y] = [
        y,
        (2 * x + 3 * y) % 5
    ];
    $e4bddf487eff4619$var$SHA3_PI.push(2 * (5 * y + x));
    // Rotational
    $e4bddf487eff4619$var$SHA3_ROTL.push((round + 1) * (round + 2) / 2 % 64);
    // Iota
    let t = $e4bddf487eff4619$var$_0n;
    for(let j = 0; j < 7; j++){
        R = (R << $e4bddf487eff4619$var$_1n ^ (R >> $e4bddf487eff4619$var$_7n) * $e4bddf487eff4619$var$_0x71n) % $e4bddf487eff4619$var$_256n;
        if (R & $e4bddf487eff4619$var$_2n) t ^= $e4bddf487eff4619$var$_1n << ($e4bddf487eff4619$var$_1n << /* @__PURE__ */ BigInt(j)) - $e4bddf487eff4619$var$_1n;
    }
    $e4bddf487eff4619$var$_SHA3_IOTA.push(t);
}
const [$e4bddf487eff4619$var$SHA3_IOTA_H, $e4bddf487eff4619$var$SHA3_IOTA_L] = /* @__PURE__ */ (0, $gXXaj.split)($e4bddf487eff4619$var$_SHA3_IOTA, true);
// Left rotation (without 0, 32, 64)
const $e4bddf487eff4619$var$rotlH = (h, l, s)=>s > 32 ? (0, $gXXaj.rotlBH)(h, l, s) : (0, $gXXaj.rotlSH)(h, l, s);
const $e4bddf487eff4619$var$rotlL = (h, l, s)=>s > 32 ? (0, $gXXaj.rotlBL)(h, l, s) : (0, $gXXaj.rotlSL)(h, l, s);
// Same as keccakf1600, but allows to skip some rounds
function $e4bddf487eff4619$var$keccakP(s, rounds = 24) {
    const B = new Uint32Array(10);
    // NOTE: all indices are x2 since we store state as u32 instead of u64 (bigints to slow in js)
    for(let round = 24 - rounds; round < 24; round++){
        // Theta θ
        for(let x = 0; x < 10; x++)B[x] = s[x] ^ s[x + 10] ^ s[x + 20] ^ s[x + 30] ^ s[x + 40];
        for(let x = 0; x < 10; x += 2){
            const idx1 = (x + 8) % 10;
            const idx0 = (x + 2) % 10;
            const B0 = B[idx0];
            const B1 = B[idx0 + 1];
            const Th = $e4bddf487eff4619$var$rotlH(B0, B1, 1) ^ B[idx1];
            const Tl = $e4bddf487eff4619$var$rotlL(B0, B1, 1) ^ B[idx1 + 1];
            for(let y = 0; y < 50; y += 10){
                s[x + y] ^= Th;
                s[x + y + 1] ^= Tl;
            }
        }
        // Rho (ρ) and Pi (π)
        let curH = s[2];
        let curL = s[3];
        for(let t = 0; t < 24; t++){
            const shift = $e4bddf487eff4619$var$SHA3_ROTL[t];
            const Th = $e4bddf487eff4619$var$rotlH(curH, curL, shift);
            const Tl = $e4bddf487eff4619$var$rotlL(curH, curL, shift);
            const PI = $e4bddf487eff4619$var$SHA3_PI[t];
            curH = s[PI];
            curL = s[PI + 1];
            s[PI] = Th;
            s[PI + 1] = Tl;
        }
        // Chi (χ)
        for(let y = 0; y < 50; y += 10){
            for(let x = 0; x < 10; x++)B[x] = s[y + x];
            for(let x = 0; x < 10; x++)s[y + x] ^= ~B[(x + 2) % 10] & B[(x + 4) % 10];
        }
        // Iota (ι)
        s[0] ^= $e4bddf487eff4619$var$SHA3_IOTA_H[round];
        s[1] ^= $e4bddf487eff4619$var$SHA3_IOTA_L[round];
    }
    B.fill(0);
}
module.exports.keccakP = $e4bddf487eff4619$var$keccakP;
class $e4bddf487eff4619$var$Keccak extends $ebEok.Hash {
    // NOTE: we accept arguments in bytes instead of bits here.
    constructor(blockLen, suffix, outputLen, enableXOF = false, rounds = 24){
        super();
        this.blockLen = blockLen;
        this.suffix = suffix;
        this.outputLen = outputLen;
        this.enableXOF = enableXOF;
        this.rounds = rounds;
        this.pos = 0;
        this.posOut = 0;
        this.finished = false;
        this.destroyed = false;
        // Can be passed from user as dkLen
        (0, $kjkVj.number)(outputLen);
        // 1600 = 5x5 matrix of 64bit.  1600 bits === 200 bytes
        if (0 >= this.blockLen || this.blockLen >= 200) throw new Error("Sha3 supports only keccak-f1600 function");
        this.state = new Uint8Array(200);
        this.state32 = (0, $ebEok.u32)(this.state);
    }
    keccak() {
        $e4bddf487eff4619$var$keccakP(this.state32, this.rounds);
        this.posOut = 0;
        this.pos = 0;
    }
    update(data) {
        (0, $kjkVj.exists)(this);
        const { blockLen: blockLen, state: state } = this;
        data = (0, $ebEok.toBytes)(data);
        const len = data.length;
        for(let pos = 0; pos < len;){
            const take = Math.min(blockLen - this.pos, len - pos);
            for(let i = 0; i < take; i++)state[this.pos++] ^= data[pos++];
            if (this.pos === blockLen) this.keccak();
        }
        return this;
    }
    finish() {
        if (this.finished) return;
        this.finished = true;
        const { state: state, suffix: suffix, pos: pos, blockLen: blockLen } = this;
        // Do the padding
        state[pos] ^= suffix;
        if ((suffix & 0x80) !== 0 && pos === blockLen - 1) this.keccak();
        state[blockLen - 1] ^= 0x80;
        this.keccak();
    }
    writeInto(out) {
        (0, $kjkVj.exists)(this, false);
        (0, $kjkVj.bytes)(out);
        this.finish();
        const bufferOut = this.state;
        const { blockLen: blockLen } = this;
        for(let pos = 0, len = out.length; pos < len;){
            if (this.posOut >= blockLen) this.keccak();
            const take = Math.min(blockLen - this.posOut, len - pos);
            out.set(bufferOut.subarray(this.posOut, this.posOut + take), pos);
            this.posOut += take;
            pos += take;
        }
        return out;
    }
    xofInto(out) {
        // Sha3/Keccak usage with XOF is probably mistake, only SHAKE instances can do XOF
        if (!this.enableXOF) throw new Error("XOF is not possible for this instance");
        return this.writeInto(out);
    }
    xof(bytes) {
        (0, $kjkVj.number)(bytes);
        return this.xofInto(new Uint8Array(bytes));
    }
    digestInto(out) {
        (0, $kjkVj.output)(out, this);
        if (this.finished) throw new Error("digest() was already called");
        this.writeInto(out);
        this.destroy();
        return out;
    }
    digest() {
        return this.digestInto(new Uint8Array(this.outputLen));
    }
    destroy() {
        this.destroyed = true;
        this.state.fill(0);
    }
    _cloneInto(to) {
        const { blockLen: blockLen, suffix: suffix, outputLen: outputLen, rounds: rounds, enableXOF: enableXOF } = this;
        to || (to = new $e4bddf487eff4619$var$Keccak(blockLen, suffix, outputLen, enableXOF, rounds));
        to.state32.set(this.state32);
        to.pos = this.pos;
        to.posOut = this.posOut;
        to.finished = this.finished;
        to.rounds = rounds;
        // Suffix can change in cSHAKE
        to.suffix = suffix;
        to.outputLen = outputLen;
        to.enableXOF = enableXOF;
        to.destroyed = this.destroyed;
        return to;
    }
}
module.exports.Keccak = $e4bddf487eff4619$var$Keccak;
const $e4bddf487eff4619$var$gen = (suffix, blockLen, outputLen)=>(0, $ebEok.wrapConstructor)(()=>new $e4bddf487eff4619$var$Keccak(blockLen, suffix, outputLen));
module.exports.sha3_224 = $e4bddf487eff4619$var$gen(0x06, 144, 28);
/**
 * SHA3-256 hash function
 * @param message - that would be hashed
 */ module.exports.sha3_256 = $e4bddf487eff4619$var$gen(0x06, 136, 32);
module.exports.sha3_384 = $e4bddf487eff4619$var$gen(0x06, 104, 48);
module.exports.sha3_512 = $e4bddf487eff4619$var$gen(0x06, 72, 64);
module.exports.keccak_224 = $e4bddf487eff4619$var$gen(0x01, 144, 28);
/**
 * keccak-256 hash function. Different from SHA3-256.
 * @param message - that would be hashed
 */ module.exports.keccak_256 = $e4bddf487eff4619$var$gen(0x01, 136, 32);
module.exports.keccak_384 = $e4bddf487eff4619$var$gen(0x01, 104, 48);
module.exports.keccak_512 = $e4bddf487eff4619$var$gen(0x01, 72, 64);
const $e4bddf487eff4619$var$genShake = (suffix, blockLen, outputLen)=>(0, $ebEok.wrapXOFConstructorWithOpts)((opts = {})=>new $e4bddf487eff4619$var$Keccak(blockLen, suffix, opts.dkLen === undefined ? outputLen : opts.dkLen, true));
module.exports.shake128 = $e4bddf487eff4619$var$genShake(0x1f, 168, 16);
module.exports.shake256 = $e4bddf487eff4619$var$genShake(0x1f, 136, 32);

});


parcelRequire.register("dBpJU", function(module, exports) {
"use strict";
// Keep all classes requiring libsodium-js in one file as having multiple
// requiring of the libsodium-wrappers module currently crashes browsers
//
// libsodium.js API: https://gist.github.com/webmaster128/b2dbe6d54d36dd168c9fabf441b9b09c
var $9e72b261003a59f8$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Xchacha20poly1305Ietf = module.exports.xchacha20NonceLength = module.exports.Ed25519 = module.exports.Ed25519Keypair = module.exports.Argon2id = module.exports.isArgon2idOptions = void 0;

var $fZwG5 = parcelRequire("fZwG5");

// Using crypto_pwhash requires sumo. Once we migrate to a standalone
// Argon2 implementation, we can use the normal libsodium-wrappers
// again: https://github.com/cosmos/cosmjs/issues/1031
const $9e72b261003a59f8$var$libsodium_wrappers_sumo_1 = $9e72b261003a59f8$var$__importDefault((parcelRequire("8GcGB")));
function $9e72b261003a59f8$var$isArgon2idOptions(thing) {
    if (!(0, $fZwG5.isNonNullObject)(thing)) return false;
    if (typeof thing.outputLength !== "number") return false;
    if (typeof thing.opsLimit !== "number") return false;
    if (typeof thing.memLimitKib !== "number") return false;
    return true;
}
module.exports.isArgon2idOptions = $9e72b261003a59f8$var$isArgon2idOptions;
class $9e72b261003a59f8$var$Argon2id {
    static async execute(password, salt, options) {
        await $9e72b261003a59f8$var$libsodium_wrappers_sumo_1.default.ready;
        return $9e72b261003a59f8$var$libsodium_wrappers_sumo_1.default.crypto_pwhash(options.outputLength, password, salt, options.opsLimit, options.memLimitKib * 1024, $9e72b261003a59f8$var$libsodium_wrappers_sumo_1.default.crypto_pwhash_ALG_ARGON2ID13);
    }
}
module.exports.Argon2id = $9e72b261003a59f8$var$Argon2id;
class $9e72b261003a59f8$var$Ed25519Keypair {
    // a libsodium privkey has the format `<ed25519 privkey> + <ed25519 pubkey>`
    static fromLibsodiumPrivkey(libsodiumPrivkey) {
        if (libsodiumPrivkey.length !== 64) throw new Error(`Unexpected key length ${libsodiumPrivkey.length}. Must be 64.`);
        return new $9e72b261003a59f8$var$Ed25519Keypair(libsodiumPrivkey.slice(0, 32), libsodiumPrivkey.slice(32, 64));
    }
    constructor(privkey, pubkey){
        this.privkey = privkey;
        this.pubkey = pubkey;
    }
    toLibsodiumPrivkey() {
        return new Uint8Array([
            ...this.privkey,
            ...this.pubkey
        ]);
    }
}
module.exports.Ed25519Keypair = $9e72b261003a59f8$var$Ed25519Keypair;
class $9e72b261003a59f8$var$Ed25519 {
    /**
     * Generates a keypair deterministically from a given 32 bytes seed.
     *
     * This seed equals the Ed25519 private key.
     * For implementation details see crypto_sign_seed_keypair in
     * https://download.libsodium.org/doc/public-key_cryptography/public-key_signatures.html
     * and diagram on https://blog.mozilla.org/warner/2011/11/29/ed25519-keys/
     */ static async makeKeypair(seed) {
        await $9e72b261003a59f8$var$libsodium_wrappers_sumo_1.default.ready;
        const keypair = $9e72b261003a59f8$var$libsodium_wrappers_sumo_1.default.crypto_sign_seed_keypair(seed);
        return $9e72b261003a59f8$var$Ed25519Keypair.fromLibsodiumPrivkey(keypair.privateKey);
    }
    static async createSignature(message, keyPair) {
        await $9e72b261003a59f8$var$libsodium_wrappers_sumo_1.default.ready;
        return $9e72b261003a59f8$var$libsodium_wrappers_sumo_1.default.crypto_sign_detached(message, keyPair.toLibsodiumPrivkey());
    }
    static async verifySignature(signature, message, pubkey) {
        await $9e72b261003a59f8$var$libsodium_wrappers_sumo_1.default.ready;
        return $9e72b261003a59f8$var$libsodium_wrappers_sumo_1.default.crypto_sign_verify_detached(signature, message, pubkey);
    }
}
module.exports.Ed25519 = $9e72b261003a59f8$var$Ed25519;
/**
 * Nonce length in bytes for all flavours of XChaCha20.
 *
 * @see https://libsodium.gitbook.io/doc/advanced/stream_ciphers/xchacha20#notes
 */ module.exports.xchacha20NonceLength = 24;
class $9e72b261003a59f8$var$Xchacha20poly1305Ietf {
    static async encrypt(message, key, nonce) {
        await $9e72b261003a59f8$var$libsodium_wrappers_sumo_1.default.ready;
        const additionalData = null;
        return $9e72b261003a59f8$var$libsodium_wrappers_sumo_1.default.crypto_aead_xchacha20poly1305_ietf_encrypt(message, additionalData, null, nonce, key);
    }
    static async decrypt(ciphertext, key, nonce) {
        await $9e72b261003a59f8$var$libsodium_wrappers_sumo_1.default.ready;
        const additionalData = null;
        return $9e72b261003a59f8$var$libsodium_wrappers_sumo_1.default.crypto_aead_xchacha20poly1305_ietf_decrypt(null, ciphertext, additionalData, nonce, key);
    }
}
module.exports.Xchacha20poly1305Ietf = $9e72b261003a59f8$var$Xchacha20poly1305Ietf;

});

parcelRequire.register("ar8bQ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Random = void 0;

class $7992c760cf5bff16$var$Random {
    /**
     * Returns `count` cryptographically secure random bytes
     */ static getBytes(count) {
        try {
            const globalObject = typeof window === "object" ? window : self;
            const cryptoApi = typeof globalObject.crypto !== "undefined" ? globalObject.crypto : globalObject.msCrypto;
            const out = new Uint8Array(count);
            cryptoApi.getRandomValues(out);
            return out;
        } catch  {
            try {
                // eslint-disable-next-line @typescript-eslint/no-var-requires
                const crypto = (parcelRequire("aO8Ot"));
                return new Uint8Array([
                    ...crypto.randomBytes(count)
                ]);
            } catch  {
                throw new Error("No secure random number generator found");
            }
        }
    }
}
module.exports.Random = $7992c760cf5bff16$var$Random;

});

parcelRequire.register("epe0N", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ripemd160 = module.exports.Ripemd160 = void 0;

var $imJuD = parcelRequire("imJuD");

var $a1Zu0 = parcelRequire("a1Zu0");
class $a7ce44efed9f6209$var$Ripemd160 {
    constructor(firstData){
        this.blockSize = 64;
        this.impl = $imJuD.ripemd160.create();
        if (firstData) this.update(firstData);
    }
    update(data) {
        this.impl.update((0, $a1Zu0.toRealUint8Array)(data));
        return this;
    }
    digest() {
        return this.impl.digest();
    }
}
module.exports.Ripemd160 = $a7ce44efed9f6209$var$Ripemd160;
/** Convenience function equivalent to `new Ripemd160(data).digest()` */ function $a7ce44efed9f6209$var$ripemd160(data) {
    return new $a7ce44efed9f6209$var$Ripemd160(data).digest();
}
module.exports.ripemd160 = $a7ce44efed9f6209$var$ripemd160;

});
parcelRequire.register("imJuD", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ripemd160 = module.exports.RIPEMD160 = void 0;

var $lQ6Zm = parcelRequire("lQ6Zm");

var $ebEok = parcelRequire("ebEok");
// https://homes.esat.kuleuven.be/~bosselae/ripemd160.html
// https://homes.esat.kuleuven.be/~bosselae/ripemd160/pdf/AB-9601/AB-9601.pdf
const $d5ed9209f009742a$var$Rho = /* @__PURE__ */ new Uint8Array([
    7,
    4,
    13,
    1,
    10,
    6,
    15,
    3,
    12,
    0,
    9,
    5,
    2,
    14,
    11,
    8
]);
const $d5ed9209f009742a$var$Id = /* @__PURE__ */ Uint8Array.from({
    length: 16
}, (_, i)=>i);
const $d5ed9209f009742a$var$Pi = /* @__PURE__ */ $d5ed9209f009742a$var$Id.map((i)=>(9 * i + 5) % 16);
let $d5ed9209f009742a$var$idxL = [
    $d5ed9209f009742a$var$Id
];
let $d5ed9209f009742a$var$idxR = [
    $d5ed9209f009742a$var$Pi
];
for(let i = 0; i < 4; i++)for (let j of [
    $d5ed9209f009742a$var$idxL,
    $d5ed9209f009742a$var$idxR
])j.push(j[i].map((k)=>$d5ed9209f009742a$var$Rho[k]));
const $d5ed9209f009742a$var$shifts = /* @__PURE__ */ [
    [
        11,
        14,
        15,
        12,
        5,
        8,
        7,
        9,
        11,
        13,
        14,
        15,
        6,
        7,
        9,
        8
    ],
    [
        12,
        13,
        11,
        15,
        6,
        9,
        9,
        7,
        12,
        15,
        11,
        13,
        7,
        8,
        7,
        7
    ],
    [
        13,
        15,
        14,
        11,
        7,
        7,
        6,
        8,
        13,
        14,
        13,
        12,
        5,
        5,
        6,
        9
    ],
    [
        14,
        11,
        12,
        14,
        8,
        6,
        5,
        5,
        15,
        12,
        15,
        14,
        9,
        9,
        8,
        6
    ],
    [
        15,
        12,
        13,
        13,
        9,
        5,
        8,
        6,
        14,
        11,
        12,
        11,
        8,
        6,
        5,
        5
    ]
].map((i)=>new Uint8Array(i));
const $d5ed9209f009742a$var$shiftsL = /* @__PURE__ */ $d5ed9209f009742a$var$idxL.map((idx, i)=>idx.map((j)=>$d5ed9209f009742a$var$shifts[i][j]));
const $d5ed9209f009742a$var$shiftsR = /* @__PURE__ */ $d5ed9209f009742a$var$idxR.map((idx, i)=>idx.map((j)=>$d5ed9209f009742a$var$shifts[i][j]));
const $d5ed9209f009742a$var$Kl = /* @__PURE__ */ new Uint32Array([
    0x00000000,
    0x5a827999,
    0x6ed9eba1,
    0x8f1bbcdc,
    0xa953fd4e
]);
const $d5ed9209f009742a$var$Kr = /* @__PURE__ */ new Uint32Array([
    0x50a28be6,
    0x5c4dd124,
    0x6d703ef3,
    0x7a6d76e9,
    0x00000000
]);
// The rotate left (circular left shift) operation for uint32
const $d5ed9209f009742a$var$rotl = (word, shift)=>word << shift | word >>> 32 - shift;
// It's called f() in spec.
function $d5ed9209f009742a$var$f(group, x, y, z) {
    if (group === 0) return x ^ y ^ z;
    else if (group === 1) return x & y | ~x & z;
    else if (group === 2) return (x | ~y) ^ z;
    else if (group === 3) return x & z | y & ~z;
    else return x ^ (y | ~z);
}
// Temporary buffer, not used to store anything between runs
const $d5ed9209f009742a$var$BUF = /* @__PURE__ */ new Uint32Array(16);
class $d5ed9209f009742a$var$RIPEMD160 extends $lQ6Zm.SHA2 {
    constructor(){
        super(64, 20, 8, true);
        this.h0 = 1732584193;
        this.h1 = -271733879;
        this.h2 = -1732584194;
        this.h3 = 271733878;
        this.h4 = -1009589776;
    }
    get() {
        const { h0: h0, h1: h1, h2: h2, h3: h3, h4: h4 } = this;
        return [
            h0,
            h1,
            h2,
            h3,
            h4
        ];
    }
    set(h0, h1, h2, h3, h4) {
        this.h0 = h0 | 0;
        this.h1 = h1 | 0;
        this.h2 = h2 | 0;
        this.h3 = h3 | 0;
        this.h4 = h4 | 0;
    }
    process(view, offset) {
        for(let i = 0; i < 16; i++, offset += 4)$d5ed9209f009742a$var$BUF[i] = view.getUint32(offset, true);
        // prettier-ignore
        let al = this.h0 | 0, ar = al, bl = this.h1 | 0, br = bl, cl = this.h2 | 0, cr = cl, dl = this.h3 | 0, dr = dl, el = this.h4 | 0, er = el;
        // Instead of iterating 0 to 80, we split it into 5 groups
        // And use the groups in constants, functions, etc. Much simpler
        for(let group = 0; group < 5; group++){
            const rGroup = 4 - group;
            const hbl = $d5ed9209f009742a$var$Kl[group], hbr = $d5ed9209f009742a$var$Kr[group]; // prettier-ignore
            const rl = $d5ed9209f009742a$var$idxL[group], rr = $d5ed9209f009742a$var$idxR[group]; // prettier-ignore
            const sl = $d5ed9209f009742a$var$shiftsL[group], sr = $d5ed9209f009742a$var$shiftsR[group]; // prettier-ignore
            for(let i = 0; i < 16; i++){
                const tl = $d5ed9209f009742a$var$rotl(al + $d5ed9209f009742a$var$f(group, bl, cl, dl) + $d5ed9209f009742a$var$BUF[rl[i]] + hbl, sl[i]) + el | 0;
                al = el, el = dl, dl = $d5ed9209f009742a$var$rotl(cl, 10) | 0, cl = bl, bl = tl; // prettier-ignore
            }
            // 2 loops are 10% faster
            for(let i = 0; i < 16; i++){
                const tr = $d5ed9209f009742a$var$rotl(ar + $d5ed9209f009742a$var$f(rGroup, br, cr, dr) + $d5ed9209f009742a$var$BUF[rr[i]] + hbr, sr[i]) + er | 0;
                ar = er, er = dr, dr = $d5ed9209f009742a$var$rotl(cr, 10) | 0, cr = br, br = tr; // prettier-ignore
            }
        }
        // Add the compressed chunk to the current hash value
        this.set(this.h1 + cl + dr | 0, this.h2 + dl + er | 0, this.h3 + el + ar | 0, this.h4 + al + br | 0, this.h0 + bl + cr | 0);
    }
    roundClean() {
        $d5ed9209f009742a$var$BUF.fill(0);
    }
    destroy() {
        this.destroyed = true;
        this.buffer.fill(0);
        this.set(0, 0, 0, 0, 0);
    }
}
module.exports.RIPEMD160 = $d5ed9209f009742a$var$RIPEMD160;
/**
 * RIPEMD-160 - a hash function from 1990s.
 * @param message - msg that would be hashed
 */ module.exports.ripemd160 = (0, $ebEok.wrapConstructor)(()=>new $d5ed9209f009742a$var$RIPEMD160());

});


parcelRequire.register("bCyVM", function(module, exports) {
"use strict";
var $875e56da6d0aa1e0$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Secp256k1 = void 0;

var $6XcLW = parcelRequire("6XcLW");

const $875e56da6d0aa1e0$var$bn_js_1 = $875e56da6d0aa1e0$var$__importDefault((parcelRequire("8TyLy")));

const $875e56da6d0aa1e0$var$elliptic_1 = $875e56da6d0aa1e0$var$__importDefault((parcelRequire("8J1ou")));

var $hk7ao = parcelRequire("hk7ao");
const $875e56da6d0aa1e0$var$secp256k1 = new $875e56da6d0aa1e0$var$elliptic_1.default.ec("secp256k1");
const $875e56da6d0aa1e0$var$secp256k1N = new $875e56da6d0aa1e0$var$bn_js_1.default("FFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFEBAAEDCE6AF48A03BBFD25E8CD0364141", "hex");
class $875e56da6d0aa1e0$var$Secp256k1 {
    /**
     * Takes a 32 byte private key and returns a privkey/pubkey pair.
     *
     * The resulting pubkey is uncompressed. For the use in Cosmos it should
     * be compressed first using `Secp256k1.compressPubkey`.
     */ static async makeKeypair(privkey) {
        if (privkey.length !== 32) // is this check missing in secp256k1.validatePrivateKey?
        // https://github.com/bitjson/bitcoin-ts/issues/4
        throw new Error("input data is not a valid secp256k1 private key");
        const keypair = $875e56da6d0aa1e0$var$secp256k1.keyFromPrivate(privkey);
        if (keypair.validate().result !== true) throw new Error("input data is not a valid secp256k1 private key");
        // range test that is not part of the elliptic implementation
        const privkeyAsBigInteger = new $875e56da6d0aa1e0$var$bn_js_1.default(privkey);
        if (privkeyAsBigInteger.gte($875e56da6d0aa1e0$var$secp256k1N)) // not strictly smaller than N
        throw new Error("input data is not a valid secp256k1 private key");
        const out = {
            privkey: (0, $6XcLW.fromHex)(keypair.getPrivate("hex")),
            // encodes uncompressed as
            // - 1-byte prefix "04"
            // - 32-byte x coordinate
            // - 32-byte y coordinate
            pubkey: Uint8Array.from(keypair.getPublic("array"))
        };
        return out;
    }
    /**
     * Creates a signature that is
     * - deterministic (RFC 6979)
     * - lowS signature
     * - DER encoded
     */ static async createSignature(messageHash, privkey) {
        if (messageHash.length === 0) throw new Error("Message hash must not be empty");
        if (messageHash.length > 32) throw new Error("Message hash length must not exceed 32 bytes");
        const keypair = $875e56da6d0aa1e0$var$secp256k1.keyFromPrivate(privkey);
        // the `canonical` option ensures creation of lowS signature representations
        const { r: r, s: s, recoveryParam: recoveryParam } = keypair.sign(messageHash, {
            canonical: true
        });
        if (typeof recoveryParam !== "number") throw new Error("Recovery param missing");
        return new $hk7ao.ExtendedSecp256k1Signature(Uint8Array.from(r.toArray()), Uint8Array.from(s.toArray()), recoveryParam);
    }
    static async verifySignature(signature, messageHash, pubkey) {
        if (messageHash.length === 0) throw new Error("Message hash must not be empty");
        if (messageHash.length > 32) throw new Error("Message hash length must not exceed 32 bytes");
        const keypair = $875e56da6d0aa1e0$var$secp256k1.keyFromPublic(pubkey);
        // From https://github.com/indutny/elliptic:
        //
        //     Sign the message's hash (input must be an array, or a hex-string)
        //
        //     Signature MUST be either:
        //     1) DER-encoded signature as hex-string; or
        //     2) DER-encoded signature as buffer; or
        //     3) object with two hex-string properties (r and s); or
        //     4) object with two buffer properties (r and s)
        //
        // Uint8Array is not a Buffer, but elliptic seems to be happy with the interface
        // common to both types. Uint8Array is not an array of ints but the interface is
        // similar
        try {
            return keypair.verify(messageHash, signature.toDer());
        } catch (error) {
            return false;
        }
    }
    static recoverPubkey(signature, messageHash) {
        const signatureForElliptic = {
            r: (0, $6XcLW.toHex)(signature.r()),
            s: (0, $6XcLW.toHex)(signature.s())
        };
        const point = $875e56da6d0aa1e0$var$secp256k1.recoverPubKey(messageHash, signatureForElliptic, signature.recovery);
        const keypair = $875e56da6d0aa1e0$var$secp256k1.keyFromPublic(point);
        return (0, $6XcLW.fromHex)(keypair.getPublic(false, "hex"));
    }
    /**
     * Takes a compressed or uncompressed pubkey and return a compressed one.
     *
     * This function is idempotent.
     */ static compressPubkey(pubkey) {
        switch(pubkey.length){
            case 33:
                return pubkey;
            case 65:
                return Uint8Array.from($875e56da6d0aa1e0$var$secp256k1.keyFromPublic(pubkey).getPublic(true, "array"));
            default:
                throw new Error("Invalid pubkey length");
        }
    }
    /**
     * Takes a compressed or uncompressed pubkey and returns an uncompressed one.
     *
     * This function is idempotent.
     */ static uncompressPubkey(pubkey) {
        switch(pubkey.length){
            case 33:
                return Uint8Array.from($875e56da6d0aa1e0$var$secp256k1.keyFromPublic(pubkey).getPublic(false, "array"));
            case 65:
                return pubkey;
            default:
                throw new Error("Invalid pubkey length");
        }
    }
    static trimRecoveryByte(signature) {
        switch(signature.length){
            case 64:
                return signature;
            case 65:
                return signature.slice(0, 64);
            default:
                throw new Error("Invalid signature length");
        }
    }
}
module.exports.Secp256k1 = $875e56da6d0aa1e0$var$Secp256k1;

});
parcelRequire.register("hk7ao", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ExtendedSecp256k1Signature = module.exports.Secp256k1Signature = void 0;
function $c9c9dd13e628b6b7$var$trimLeadingNullBytes(inData) {
    let numberOfLeadingNullBytes = 0;
    for (const byte of inData){
        if (byte === 0x00) numberOfLeadingNullBytes++;
        else break;
    }
    return inData.slice(numberOfLeadingNullBytes);
}
const $c9c9dd13e628b6b7$var$derTagInteger = 0x02;
class $c9c9dd13e628b6b7$var$Secp256k1Signature {
    /**
     * Takes the pair of integers (r, s) as 2x32 byte of binary data.
     *
     * Note: This is the format Cosmos SDK uses natively.
     *
     * @param data a 64 byte value containing integers r and s.
     */ static fromFixedLength(data) {
        if (data.length !== 64) throw new Error(`Got invalid data length: ${data.length}. Expected 2x 32 bytes for the pair (r, s)`);
        return new $c9c9dd13e628b6b7$var$Secp256k1Signature($c9c9dd13e628b6b7$var$trimLeadingNullBytes(data.slice(0, 32)), $c9c9dd13e628b6b7$var$trimLeadingNullBytes(data.slice(32, 64)));
    }
    static fromDer(data) {
        let pos = 0;
        if (data[pos++] !== 0x30) throw new Error("Prefix 0x30 expected");
        const bodyLength = data[pos++];
        if (data.length - pos !== bodyLength) throw new Error("Data length mismatch detected");
        // r
        const rTag = data[pos++];
        if (rTag !== $c9c9dd13e628b6b7$var$derTagInteger) throw new Error("INTEGER tag expected");
        const rLength = data[pos++];
        if (rLength >= 0x80) throw new Error("Decoding length values above 127 not supported");
        const rData = data.slice(pos, pos + rLength);
        pos += rLength;
        // s
        const sTag = data[pos++];
        if (sTag !== $c9c9dd13e628b6b7$var$derTagInteger) throw new Error("INTEGER tag expected");
        const sLength = data[pos++];
        if (sLength >= 0x80) throw new Error("Decoding length values above 127 not supported");
        const sData = data.slice(pos, pos + sLength);
        pos += sLength;
        return new $c9c9dd13e628b6b7$var$Secp256k1Signature(// r/s data can contain leading 0 bytes to express integers being non-negative in DER
        $c9c9dd13e628b6b7$var$trimLeadingNullBytes(rData), $c9c9dd13e628b6b7$var$trimLeadingNullBytes(sData));
    }
    constructor(r, s){
        if (r.length > 32 || r.length === 0 || r[0] === 0x00) throw new Error("Unsigned integer r must be encoded as unpadded big endian.");
        if (s.length > 32 || s.length === 0 || s[0] === 0x00) throw new Error("Unsigned integer s must be encoded as unpadded big endian.");
        this.data = {
            r: r,
            s: s
        };
    }
    r(length) {
        if (length === undefined) return this.data.r;
        else {
            const paddingLength = length - this.data.r.length;
            if (paddingLength < 0) throw new Error("Length too small to hold parameter r");
            const padding = new Uint8Array(paddingLength);
            return new Uint8Array([
                ...padding,
                ...this.data.r
            ]);
        }
    }
    s(length) {
        if (length === undefined) return this.data.s;
        else {
            const paddingLength = length - this.data.s.length;
            if (paddingLength < 0) throw new Error("Length too small to hold parameter s");
            const padding = new Uint8Array(paddingLength);
            return new Uint8Array([
                ...padding,
                ...this.data.s
            ]);
        }
    }
    toFixedLength() {
        return new Uint8Array([
            ...this.r(32),
            ...this.s(32)
        ]);
    }
    toDer() {
        // DER supports negative integers but our data is unsigned. Thus we need to prepend
        // a leading 0 byte when the higest bit is set to differentiate nagative values
        const rEncoded = this.data.r[0] >= 0x80 ? new Uint8Array([
            0,
            ...this.data.r
        ]) : this.data.r;
        const sEncoded = this.data.s[0] >= 0x80 ? new Uint8Array([
            0,
            ...this.data.s
        ]) : this.data.s;
        const rLength = rEncoded.length;
        const sLength = sEncoded.length;
        const data = new Uint8Array([
            $c9c9dd13e628b6b7$var$derTagInteger,
            rLength,
            ...rEncoded,
            $c9c9dd13e628b6b7$var$derTagInteger,
            sLength,
            ...sEncoded
        ]);
        return new Uint8Array([
            0x30,
            data.length,
            ...data
        ]);
    }
}
module.exports.Secp256k1Signature = $c9c9dd13e628b6b7$var$Secp256k1Signature;
/**
 * A Secp256k1Signature plus the recovery parameter
 */ class $c9c9dd13e628b6b7$var$ExtendedSecp256k1Signature extends $c9c9dd13e628b6b7$var$Secp256k1Signature {
    /**
     * Decode extended signature from the simple fixed length encoding
     * described in toFixedLength().
     */ static fromFixedLength(data) {
        if (data.length !== 65) throw new Error(`Got invalid data length ${data.length}. Expected 32 + 32 + 1`);
        return new $c9c9dd13e628b6b7$var$ExtendedSecp256k1Signature($c9c9dd13e628b6b7$var$trimLeadingNullBytes(data.slice(0, 32)), $c9c9dd13e628b6b7$var$trimLeadingNullBytes(data.slice(32, 64)), data[64]);
    }
    constructor(r, s, recovery){
        super(r, s);
        if (!Number.isInteger(recovery)) throw new Error("The recovery parameter must be an integer.");
        if (recovery < 0 || recovery > 4) throw new Error("The recovery parameter must be one of 0, 1, 2, 3.");
        this.recovery = recovery;
    }
    /**
     * A simple custom encoding that encodes the extended signature as
     * r (32 bytes) | s (32 bytes) | recovery param (1 byte)
     * where | denotes concatenation of bonary data.
     */ toFixedLength() {
        return new Uint8Array([
            ...this.r(32),
            ...this.s(32),
            this.recovery
        ]);
    }
}
module.exports.ExtendedSecp256k1Signature = $c9c9dd13e628b6b7$var$ExtendedSecp256k1Signature;

});


parcelRequire.register("gCjJW", function(module, exports) {
"use strict";
var $c18f81e67c1dafd5$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.stringToPath = module.exports.pathToString = module.exports.Slip10 = module.exports.Slip10RawIndex = module.exports.slip10CurveFromString = module.exports.Slip10Curve = void 0;

var $6XcLW = parcelRequire("6XcLW");

var $7UsfE = parcelRequire("7UsfE");

const $c18f81e67c1dafd5$var$bn_js_1 = $c18f81e67c1dafd5$var$__importDefault((parcelRequire("8TyLy")));

const $c18f81e67c1dafd5$var$elliptic_1 = $c18f81e67c1dafd5$var$__importDefault((parcelRequire("8J1ou")));

var $aYUxM = parcelRequire("aYUxM");

var $dlig8 = parcelRequire("dlig8");
/**
 * Raw values must match the curve string in SLIP-0010 master key generation
 *
 * @see https://github.com/satoshilabs/slips/blob/master/slip-0010.md#master-key-generation
 */ var $c18f81e67c1dafd5$var$Slip10Curve;
(function(Slip10Curve) {
    Slip10Curve["Secp256k1"] = "Bitcoin seed";
    Slip10Curve["Ed25519"] = "ed25519 seed";
})($c18f81e67c1dafd5$var$Slip10Curve = module.exports.Slip10Curve || (module.exports.Slip10Curve = {}));
/**
 * Reverse mapping of Slip10Curve
 */ function $c18f81e67c1dafd5$var$slip10CurveFromString(curveString) {
    switch(curveString){
        case $c18f81e67c1dafd5$var$Slip10Curve.Ed25519:
            return $c18f81e67c1dafd5$var$Slip10Curve.Ed25519;
        case $c18f81e67c1dafd5$var$Slip10Curve.Secp256k1:
            return $c18f81e67c1dafd5$var$Slip10Curve.Secp256k1;
        default:
            throw new Error(`Unknown curve string: '${curveString}'`);
    }
}
module.exports.slip10CurveFromString = $c18f81e67c1dafd5$var$slip10CurveFromString;
class $c18f81e67c1dafd5$var$Slip10RawIndex extends $7UsfE.Uint32 {
    static hardened(hardenedIndex) {
        return new $c18f81e67c1dafd5$var$Slip10RawIndex(hardenedIndex + 2 ** 31);
    }
    static normal(normalIndex) {
        return new $c18f81e67c1dafd5$var$Slip10RawIndex(normalIndex);
    }
    isHardened() {
        return this.data >= 2 ** 31;
    }
}
module.exports.Slip10RawIndex = $c18f81e67c1dafd5$var$Slip10RawIndex;
const $c18f81e67c1dafd5$var$secp256k1 = new $c18f81e67c1dafd5$var$elliptic_1.default.ec("secp256k1");
// Universal private key derivation accoring to
// https://github.com/satoshilabs/slips/blob/master/slip-0010.md
class $c18f81e67c1dafd5$var$Slip10 {
    static derivePath(curve, seed, path) {
        let result = this.master(curve, seed);
        for (const rawIndex of path)result = this.child(curve, result.privkey, result.chainCode, rawIndex);
        return result;
    }
    static master(curve, seed) {
        const i = new $aYUxM.Hmac($dlig8.Sha512, (0, $6XcLW.toAscii)(curve)).update(seed).digest();
        const il = i.slice(0, 32);
        const ir = i.slice(32, 64);
        if (curve !== $c18f81e67c1dafd5$var$Slip10Curve.Ed25519 && (this.isZero(il) || this.isGteN(curve, il))) return this.master(curve, i);
        return {
            chainCode: ir,
            privkey: il
        };
    }
    static child(curve, parentPrivkey, parentChainCode, rawIndex) {
        let i;
        if (rawIndex.isHardened()) {
            const payload = new Uint8Array([
                0x00,
                ...parentPrivkey,
                ...rawIndex.toBytesBigEndian()
            ]);
            i = new $aYUxM.Hmac($dlig8.Sha512, parentChainCode).update(payload).digest();
        } else {
            if (curve === $c18f81e67c1dafd5$var$Slip10Curve.Ed25519) throw new Error("Normal keys are not allowed with ed25519");
            else {
                // Step 1 of https://github.com/satoshilabs/slips/blob/master/slip-0010.md#private-parent-key--private-child-key
                // Calculate I = HMAC-SHA512(Key = c_par, Data = ser_P(point(k_par)) || ser_32(i)).
                // where the functions point() and ser_p() are defined in BIP-0032
                const data = new Uint8Array([
                    ...$c18f81e67c1dafd5$var$Slip10.serializedPoint(curve, new $c18f81e67c1dafd5$var$bn_js_1.default(parentPrivkey)),
                    ...rawIndex.toBytesBigEndian()
                ]);
                i = new $aYUxM.Hmac($dlig8.Sha512, parentChainCode).update(data).digest();
            }
        }
        return this.childImpl(curve, parentPrivkey, parentChainCode, rawIndex, i);
    }
    /**
     * Implementation of ser_P(point(k_par)) from BIP-0032
     *
     * @see https://github.com/bitcoin/bips/blob/master/bip-0032.mediawiki
     */ static serializedPoint(curve, p) {
        switch(curve){
            case $c18f81e67c1dafd5$var$Slip10Curve.Secp256k1:
                return (0, $6XcLW.fromHex)($c18f81e67c1dafd5$var$secp256k1.g.mul(p).encodeCompressed("hex"));
            default:
                throw new Error("curve not supported");
        }
    }
    static childImpl(curve, parentPrivkey, parentChainCode, rawIndex, i) {
        // step 2 (of the Private parent key → private child key algorithm)
        const il = i.slice(0, 32);
        const ir = i.slice(32, 64);
        // step 3
        const returnChainCode = ir;
        // step 4
        if (curve === $c18f81e67c1dafd5$var$Slip10Curve.Ed25519) return {
            chainCode: returnChainCode,
            privkey: il
        };
        // step 5
        const n = this.n(curve);
        const returnChildKeyAsNumber = new $c18f81e67c1dafd5$var$bn_js_1.default(il).add(new $c18f81e67c1dafd5$var$bn_js_1.default(parentPrivkey)).mod(n);
        const returnChildKey = Uint8Array.from(returnChildKeyAsNumber.toArray("be", 32));
        // step 6
        if (this.isGteN(curve, il) || this.isZero(returnChildKey)) {
            const newI = new $aYUxM.Hmac($dlig8.Sha512, parentChainCode).update(new Uint8Array([
                0x01,
                ...ir,
                ...rawIndex.toBytesBigEndian()
            ])).digest();
            return this.childImpl(curve, parentPrivkey, parentChainCode, rawIndex, newI);
        }
        // step 7
        return {
            chainCode: returnChainCode,
            privkey: returnChildKey
        };
    }
    static isZero(privkey) {
        return privkey.every((byte)=>byte === 0);
    }
    static isGteN(curve, privkey) {
        const keyAsNumber = new $c18f81e67c1dafd5$var$bn_js_1.default(privkey);
        return keyAsNumber.gte(this.n(curve));
    }
    static n(curve) {
        switch(curve){
            case $c18f81e67c1dafd5$var$Slip10Curve.Secp256k1:
                return new $c18f81e67c1dafd5$var$bn_js_1.default("FFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFEBAAEDCE6AF48A03BBFD25E8CD0364141", 16);
            default:
                throw new Error("curve not supported");
        }
    }
}
module.exports.Slip10 = $c18f81e67c1dafd5$var$Slip10;
function $c18f81e67c1dafd5$var$pathToString(path) {
    return path.reduce((current, component)=>{
        const componentString = component.isHardened() ? `${component.toNumber() - 2 ** 31}'` : component.toString();
        return current + "/" + componentString;
    }, "m");
}
module.exports.pathToString = $c18f81e67c1dafd5$var$pathToString;
function $c18f81e67c1dafd5$var$stringToPath(input) {
    if (!input.startsWith("m")) throw new Error("Path string must start with 'm'");
    let rest = input.slice(1);
    const out = new Array();
    while(rest){
        const match = rest.match(/^\/([0-9]+)('?)/);
        if (!match) throw new Error("Syntax error while reading path component");
        const [fullMatch, numberString, apostrophe] = match;
        const value = $7UsfE.Uint53.fromString(numberString).toNumber();
        if (value >= 2 ** 31) throw new Error("Component value too high. Must not exceed 2**31-1.");
        if (apostrophe) out.push($c18f81e67c1dafd5$var$Slip10RawIndex.hardened(value));
        else out.push($c18f81e67c1dafd5$var$Slip10RawIndex.normal(value));
        rest = rest.slice(fullMatch.length);
    }
    return out;
}
module.exports.stringToPath = $c18f81e67c1dafd5$var$stringToPath;

});
parcelRequire.register("7UsfE", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Uint64 = module.exports.Uint53 = module.exports.Uint32 = module.exports.Int53 = module.exports.Decimal = void 0;

var $aN0Yc = parcelRequire("aN0Yc");
Object.defineProperty(module.exports, "Decimal", {
    enumerable: true,
    get: function() {
        return $aN0Yc.Decimal;
    }
});

var $cu7y7 = parcelRequire("cu7y7");
Object.defineProperty(module.exports, "Int53", {
    enumerable: true,
    get: function() {
        return $cu7y7.Int53;
    }
});
Object.defineProperty(module.exports, "Uint32", {
    enumerable: true,
    get: function() {
        return $cu7y7.Uint32;
    }
});
Object.defineProperty(module.exports, "Uint53", {
    enumerable: true,
    get: function() {
        return $cu7y7.Uint53;
    }
});
Object.defineProperty(module.exports, "Uint64", {
    enumerable: true,
    get: function() {
        return $cu7y7.Uint64;
    }
});

});
parcelRequire.register("aN0Yc", function(module, exports) {
"use strict";
var $7daf3b9767a78ba8$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Decimal = void 0;

const $7daf3b9767a78ba8$var$bn_js_1 = $7daf3b9767a78ba8$var$__importDefault((parcelRequire("lTJZ9")));
// Too large values lead to massive memory usage. Limit to something sensible.
// The largest value we need is 18 (Ether).
const $7daf3b9767a78ba8$var$maxFractionalDigits = 100;
/**
 * A type for arbitrary precision, non-negative decimals.
 *
 * Instances of this class are immutable.
 */ class $7daf3b9767a78ba8$var$Decimal {
    static fromUserInput(input, fractionalDigits) {
        $7daf3b9767a78ba8$var$Decimal.verifyFractionalDigits(fractionalDigits);
        const badCharacter = input.match(/[^0-9.]/);
        if (badCharacter) // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        throw new Error(`Invalid character at position ${badCharacter.index + 1}`);
        let whole;
        let fractional;
        if (input === "") {
            whole = "0";
            fractional = "";
        } else if (input.search(/\./) === -1) {
            // integer format, no separator
            whole = input;
            fractional = "";
        } else {
            const parts = input.split(".");
            switch(parts.length){
                case 0:
                case 1:
                    throw new Error("Fewer than two elements in split result. This must not happen here.");
                case 2:
                    if (!parts[1]) throw new Error("Fractional part missing");
                    whole = parts[0];
                    fractional = parts[1].replace(/0+$/, "");
                    break;
                default:
                    throw new Error("More than one separator found");
            }
        }
        if (fractional.length > fractionalDigits) throw new Error("Got more fractional digits than supported");
        const quantity = `${whole}${fractional.padEnd(fractionalDigits, "0")}`;
        return new $7daf3b9767a78ba8$var$Decimal(quantity, fractionalDigits);
    }
    static fromAtomics(atomics, fractionalDigits) {
        $7daf3b9767a78ba8$var$Decimal.verifyFractionalDigits(fractionalDigits);
        return new $7daf3b9767a78ba8$var$Decimal(atomics, fractionalDigits);
    }
    /**
     * Creates a Decimal with value 0.0 and the given number of fractial digits.
     *
     * Fractional digits are not relevant for the value but needed to be able
     * to perform arithmetic operations with other decimals.
     */ static zero(fractionalDigits) {
        $7daf3b9767a78ba8$var$Decimal.verifyFractionalDigits(fractionalDigits);
        return new $7daf3b9767a78ba8$var$Decimal("0", fractionalDigits);
    }
    /**
     * Creates a Decimal with value 1.0 and the given number of fractial digits.
     *
     * Fractional digits are not relevant for the value but needed to be able
     * to perform arithmetic operations with other decimals.
     */ static one(fractionalDigits) {
        $7daf3b9767a78ba8$var$Decimal.verifyFractionalDigits(fractionalDigits);
        return new $7daf3b9767a78ba8$var$Decimal("1" + "0".repeat(fractionalDigits), fractionalDigits);
    }
    static verifyFractionalDigits(fractionalDigits) {
        if (!Number.isInteger(fractionalDigits)) throw new Error("Fractional digits is not an integer");
        if (fractionalDigits < 0) throw new Error("Fractional digits must not be negative");
        if (fractionalDigits > $7daf3b9767a78ba8$var$maxFractionalDigits) throw new Error(`Fractional digits must not exceed ${$7daf3b9767a78ba8$var$maxFractionalDigits}`);
    }
    static compare(a, b) {
        if (a.fractionalDigits !== b.fractionalDigits) throw new Error("Fractional digits do not match");
        return a.data.atomics.cmp(new $7daf3b9767a78ba8$var$bn_js_1.default(b.atomics));
    }
    get atomics() {
        return this.data.atomics.toString();
    }
    get fractionalDigits() {
        return this.data.fractionalDigits;
    }
    constructor(atomics, fractionalDigits){
        if (!atomics.match(/^[0-9]+$/)) throw new Error("Invalid string format. Only non-negative integers in decimal representation supported.");
        this.data = {
            atomics: new $7daf3b9767a78ba8$var$bn_js_1.default(atomics),
            fractionalDigits: fractionalDigits
        };
    }
    /** Creates a new instance with the same value */ clone() {
        return new $7daf3b9767a78ba8$var$Decimal(this.atomics, this.fractionalDigits);
    }
    /** Returns the greatest decimal <= this which has no fractional part (rounding down) */ floor() {
        const factor = new $7daf3b9767a78ba8$var$bn_js_1.default(10).pow(new $7daf3b9767a78ba8$var$bn_js_1.default(this.data.fractionalDigits));
        const whole = this.data.atomics.div(factor);
        const fractional = this.data.atomics.mod(factor);
        if (fractional.isZero()) return this.clone();
        else return $7daf3b9767a78ba8$var$Decimal.fromAtomics(whole.mul(factor).toString(), this.fractionalDigits);
    }
    /** Returns the smallest decimal >= this which has no fractional part (rounding up) */ ceil() {
        const factor = new $7daf3b9767a78ba8$var$bn_js_1.default(10).pow(new $7daf3b9767a78ba8$var$bn_js_1.default(this.data.fractionalDigits));
        const whole = this.data.atomics.div(factor);
        const fractional = this.data.atomics.mod(factor);
        if (fractional.isZero()) return this.clone();
        else return $7daf3b9767a78ba8$var$Decimal.fromAtomics(whole.addn(1).mul(factor).toString(), this.fractionalDigits);
    }
    toString() {
        const factor = new $7daf3b9767a78ba8$var$bn_js_1.default(10).pow(new $7daf3b9767a78ba8$var$bn_js_1.default(this.data.fractionalDigits));
        const whole = this.data.atomics.div(factor);
        const fractional = this.data.atomics.mod(factor);
        if (fractional.isZero()) return whole.toString();
        else {
            const fullFractionalPart = fractional.toString().padStart(this.data.fractionalDigits, "0");
            const trimmedFractionalPart = fullFractionalPart.replace(/0+$/, "");
            return `${whole.toString()}.${trimmedFractionalPart}`;
        }
    }
    /**
     * Returns an approximation as a float type. Only use this if no
     * exact calculation is required.
     */ toFloatApproximation() {
        const out = Number(this.toString());
        if (Number.isNaN(out)) throw new Error("Conversion to number failed");
        return out;
    }
    /**
     * a.plus(b) returns a+b.
     *
     * Both values need to have the same fractional digits.
     */ plus(b) {
        if (this.fractionalDigits !== b.fractionalDigits) throw new Error("Fractional digits do not match");
        const sum = this.data.atomics.add(new $7daf3b9767a78ba8$var$bn_js_1.default(b.atomics));
        return new $7daf3b9767a78ba8$var$Decimal(sum.toString(), this.fractionalDigits);
    }
    /**
     * a.minus(b) returns a-b.
     *
     * Both values need to have the same fractional digits.
     * The resulting difference needs to be non-negative.
     */ minus(b) {
        if (this.fractionalDigits !== b.fractionalDigits) throw new Error("Fractional digits do not match");
        const difference = this.data.atomics.sub(new $7daf3b9767a78ba8$var$bn_js_1.default(b.atomics));
        if (difference.ltn(0)) throw new Error("Difference must not be negative");
        return new $7daf3b9767a78ba8$var$Decimal(difference.toString(), this.fractionalDigits);
    }
    /**
     * a.multiply(b) returns a*b.
     *
     * We only allow multiplication by unsigned integers to avoid rounding errors.
     */ multiply(b) {
        const product = this.data.atomics.mul(new $7daf3b9767a78ba8$var$bn_js_1.default(b.toString()));
        return new $7daf3b9767a78ba8$var$Decimal(product.toString(), this.fractionalDigits);
    }
    equals(b) {
        return $7daf3b9767a78ba8$var$Decimal.compare(this, b) === 0;
    }
    isLessThan(b) {
        return $7daf3b9767a78ba8$var$Decimal.compare(this, b) < 0;
    }
    isLessThanOrEqual(b) {
        return $7daf3b9767a78ba8$var$Decimal.compare(this, b) <= 0;
    }
    isGreaterThan(b) {
        return $7daf3b9767a78ba8$var$Decimal.compare(this, b) > 0;
    }
    isGreaterThanOrEqual(b) {
        return $7daf3b9767a78ba8$var$Decimal.compare(this, b) >= 0;
    }
}
module.exports.Decimal = $7daf3b9767a78ba8$var$Decimal;

});

parcelRequire.register("cu7y7", function(module, exports) {
"use strict";
var $916e247db6518593$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Uint64 = module.exports.Uint53 = module.exports.Int53 = module.exports.Uint32 = void 0;

/* eslint-disable no-bitwise */ const $916e247db6518593$var$bn_js_1 = $916e247db6518593$var$__importDefault((parcelRequire("lTJZ9")));
const $916e247db6518593$var$uint64MaxValue = new $916e247db6518593$var$bn_js_1.default("18446744073709551615", 10, "be");
class $916e247db6518593$var$Uint32 {
    /** @deprecated use Uint32.fromBytes */ static fromBigEndianBytes(bytes) {
        return $916e247db6518593$var$Uint32.fromBytes(bytes);
    }
    /**
     * Creates a Uint32 from a fixed length byte array.
     *
     * @param bytes a list of exactly 4 bytes
     * @param endianess defaults to big endian
     */ static fromBytes(bytes, endianess = "be") {
        if (bytes.length !== 4) throw new Error("Invalid input length. Expected 4 bytes.");
        for(let i = 0; i < bytes.length; ++i){
            if (!Number.isInteger(bytes[i]) || bytes[i] > 255 || bytes[i] < 0) throw new Error("Invalid value in byte. Found: " + bytes[i]);
        }
        const beBytes = endianess === "be" ? bytes : Array.from(bytes).reverse();
        // Use mulitiplication instead of shifting since bitwise operators are defined
        // on SIGNED int32 in JavaScript and we don't want to risk surprises
        return new $916e247db6518593$var$Uint32(beBytes[0] * 2 ** 24 + beBytes[1] * 2 ** 16 + beBytes[2] * 256 + beBytes[3]);
    }
    static fromString(str) {
        if (!str.match(/^[0-9]+$/)) throw new Error("Invalid string format");
        return new $916e247db6518593$var$Uint32(Number.parseInt(str, 10));
    }
    constructor(input){
        if (Number.isNaN(input)) throw new Error("Input is not a number");
        if (!Number.isInteger(input)) throw new Error("Input is not an integer");
        if (input < 0 || input > 4294967295) throw new Error("Input not in uint32 range: " + input.toString());
        this.data = input;
    }
    toBytesBigEndian() {
        // Use division instead of shifting since bitwise operators are defined
        // on SIGNED int32 in JavaScript and we don't want to risk surprises
        return new Uint8Array([
            Math.floor(this.data / 2 ** 24) & 0xff,
            Math.floor(this.data / 2 ** 16) & 0xff,
            Math.floor(this.data / 256) & 0xff,
            Math.floor(this.data / 1) & 0xff
        ]);
    }
    toBytesLittleEndian() {
        // Use division instead of shifting since bitwise operators are defined
        // on SIGNED int32 in JavaScript and we don't want to risk surprises
        return new Uint8Array([
            Math.floor(this.data / 1) & 0xff,
            Math.floor(this.data / 256) & 0xff,
            Math.floor(this.data / 2 ** 16) & 0xff,
            Math.floor(this.data / 2 ** 24) & 0xff
        ]);
    }
    toNumber() {
        return this.data;
    }
    toBigInt() {
        return BigInt(this.toNumber());
    }
    toString() {
        return this.data.toString();
    }
}
module.exports.Uint32 = $916e247db6518593$var$Uint32;
class $916e247db6518593$var$Int53 {
    static fromString(str) {
        if (!str.match(/^-?[0-9]+$/)) throw new Error("Invalid string format");
        return new $916e247db6518593$var$Int53(Number.parseInt(str, 10));
    }
    constructor(input){
        if (Number.isNaN(input)) throw new Error("Input is not a number");
        if (!Number.isInteger(input)) throw new Error("Input is not an integer");
        if (input < Number.MIN_SAFE_INTEGER || input > Number.MAX_SAFE_INTEGER) throw new Error("Input not in int53 range: " + input.toString());
        this.data = input;
    }
    toNumber() {
        return this.data;
    }
    toBigInt() {
        return BigInt(this.toNumber());
    }
    toString() {
        return this.data.toString();
    }
}
module.exports.Int53 = $916e247db6518593$var$Int53;
class $916e247db6518593$var$Uint53 {
    static fromString(str) {
        const signed = $916e247db6518593$var$Int53.fromString(str);
        return new $916e247db6518593$var$Uint53(signed.toNumber());
    }
    constructor(input){
        const signed = new $916e247db6518593$var$Int53(input);
        if (signed.toNumber() < 0) throw new Error("Input is negative");
        this.data = signed;
    }
    toNumber() {
        return this.data.toNumber();
    }
    toBigInt() {
        return BigInt(this.toNumber());
    }
    toString() {
        return this.data.toString();
    }
}
module.exports.Uint53 = $916e247db6518593$var$Uint53;
class $916e247db6518593$var$Uint64 {
    /** @deprecated use Uint64.fromBytes */ static fromBytesBigEndian(bytes) {
        return $916e247db6518593$var$Uint64.fromBytes(bytes);
    }
    /**
     * Creates a Uint64 from a fixed length byte array.
     *
     * @param bytes a list of exactly 8 bytes
     * @param endianess defaults to big endian
     */ static fromBytes(bytes, endianess = "be") {
        if (bytes.length !== 8) throw new Error("Invalid input length. Expected 8 bytes.");
        for(let i = 0; i < bytes.length; ++i){
            if (!Number.isInteger(bytes[i]) || bytes[i] > 255 || bytes[i] < 0) throw new Error("Invalid value in byte. Found: " + bytes[i]);
        }
        const beBytes = endianess === "be" ? Array.from(bytes) : Array.from(bytes).reverse();
        return new $916e247db6518593$var$Uint64(new $916e247db6518593$var$bn_js_1.default(beBytes));
    }
    static fromString(str) {
        if (!str.match(/^[0-9]+$/)) throw new Error("Invalid string format");
        return new $916e247db6518593$var$Uint64(new $916e247db6518593$var$bn_js_1.default(str, 10, "be"));
    }
    static fromNumber(input) {
        if (Number.isNaN(input)) throw new Error("Input is not a number");
        if (!Number.isInteger(input)) throw new Error("Input is not an integer");
        let bigint;
        try {
            bigint = new $916e247db6518593$var$bn_js_1.default(input);
        } catch  {
            throw new Error("Input is not a safe integer");
        }
        return new $916e247db6518593$var$Uint64(bigint);
    }
    constructor(data){
        if (data.isNeg()) throw new Error("Input is negative");
        if (data.gt($916e247db6518593$var$uint64MaxValue)) throw new Error("Input exceeds uint64 range");
        this.data = data;
    }
    toBytesBigEndian() {
        return Uint8Array.from(this.data.toArray("be", 8));
    }
    toBytesLittleEndian() {
        return Uint8Array.from(this.data.toArray("le", 8));
    }
    toString() {
        return this.data.toString(10);
    }
    toBigInt() {
        return BigInt(this.toString());
    }
    toNumber() {
        return this.data.toNumber();
    }
}
module.exports.Uint64 = $916e247db6518593$var$Uint64;
// Assign classes to unused variables in order to verify static interface conformance at compile time.
// Workaround for https://github.com/microsoft/TypeScript/issues/33892
const $916e247db6518593$var$_int53Class = $916e247db6518593$var$Int53;
const $916e247db6518593$var$_uint53Class = $916e247db6518593$var$Uint53;
const $916e247db6518593$var$_uint32Class = $916e247db6518593$var$Uint32;
const $916e247db6518593$var$_uint64Class = $916e247db6518593$var$Uint64;

});




parcelRequire.register("bANkA", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.encodeBlockId = module.exports.encodeVersion = module.exports.encodeBytes = module.exports.encodeTime = module.exports.encodeUvarint = module.exports.encodeString = module.exports.dictionaryToStringMap = module.exports.may = module.exports.assertNotEmpty = module.exports.assertObject = module.exports.assertArray = module.exports.assertNumber = module.exports.assertString = module.exports.assertBoolean = module.exports.assertSet = void 0;

var $6XcLW = parcelRequire("6XcLW");
/**
 * A runtime checker that ensures a given value is set (i.e. not undefined or null)
 *
 * This is used when you want to verify that data at runtime matches the expected type.
 */ function $8709529930405ca8$var$assertSet(value) {
    if (value === undefined) throw new Error("Value must not be undefined");
    if (value === null) throw new Error("Value must not be null");
    return value;
}
module.exports.assertSet = $8709529930405ca8$var$assertSet;
/**
 * A runtime checker that ensures a given value is a boolean
 *
 * This is used when you want to verify that data at runtime matches the expected type.
 * This implies assertSet.
 */ function $8709529930405ca8$var$assertBoolean(value) {
    $8709529930405ca8$var$assertSet(value);
    if (typeof value !== "boolean") throw new Error("Value must be a boolean");
    return value;
}
module.exports.assertBoolean = $8709529930405ca8$var$assertBoolean;
/**
 * A runtime checker that ensures a given value is a string.
 *
 * This is used when you want to verify that data at runtime matches the expected type.
 * This implies assertSet.
 */ function $8709529930405ca8$var$assertString(value) {
    $8709529930405ca8$var$assertSet(value);
    if (typeof value !== "string") throw new Error("Value must be a string");
    return value;
}
module.exports.assertString = $8709529930405ca8$var$assertString;
/**
 * A runtime checker that ensures a given value is a number
 *
 * This is used when you want to verify that data at runtime matches the expected type.
 * This implies assertSet.
 */ function $8709529930405ca8$var$assertNumber(value) {
    $8709529930405ca8$var$assertSet(value);
    if (typeof value !== "number") throw new Error("Value must be a number");
    return value;
}
module.exports.assertNumber = $8709529930405ca8$var$assertNumber;
/**
 * A runtime checker that ensures a given value is an array
 *
 * This is used when you want to verify that data at runtime matches the expected type.
 * This implies assertSet.
 */ function $8709529930405ca8$var$assertArray(value) {
    $8709529930405ca8$var$assertSet(value);
    if (!Array.isArray(value)) throw new Error("Value must be a an array");
    return value;
}
module.exports.assertArray = $8709529930405ca8$var$assertArray;
/**
 * A runtime checker that ensures a given value is an object in the sense of JSON
 * (an unordered collection of key–value pairs where the keys are strings)
 *
 * This is used when you want to verify that data at runtime matches the expected type.
 * This implies assertSet.
 */ function $8709529930405ca8$var$assertObject(value) {
    $8709529930405ca8$var$assertSet(value);
    if (typeof value !== "object") throw new Error("Value must be an object");
    // Exclude special kind of objects like Array, Date or Uint8Array
    // Object.prototype.toString() returns a specified value:
    // http://www.ecma-international.org/ecma-262/7.0/index.html#sec-object.prototype.tostring
    if (Object.prototype.toString.call(value) !== "[object Object]") throw new Error("Value must be a simple object");
    return value;
}
module.exports.assertObject = $8709529930405ca8$var$assertObject;
/**
 * Throws an error if value matches the empty value for the
 * given type (array/string of length 0, number of value 0, ...)
 *
 * Otherwise returns the value.
 *
 * This implies assertSet
 */ function $8709529930405ca8$var$assertNotEmpty(value) {
    $8709529930405ca8$var$assertSet(value);
    if (typeof value === "number" && value === 0) throw new Error("must provide a non-zero value");
    else if (value.length === 0) throw new Error("must provide a non-empty value");
    return value;
}
module.exports.assertNotEmpty = $8709529930405ca8$var$assertNotEmpty;
// may will run the transform if value is defined, otherwise returns undefined
function $8709529930405ca8$var$may(transform, value) {
    return value === undefined || value === null ? undefined : transform(value);
}
module.exports.may = $8709529930405ca8$var$may;
function $8709529930405ca8$var$dictionaryToStringMap(obj) {
    const out = new Map();
    for (const key of Object.keys(obj)){
        const value = obj[key];
        if (typeof value !== "string") throw new Error("Found dictionary value of type other than string");
        out.set(key, value);
    }
    return out;
}
module.exports.dictionaryToStringMap = $8709529930405ca8$var$dictionaryToStringMap;
// Encodings needed for hashing block headers
// Several of these functions are inspired by https://github.com/nomic-io/js-tendermint/blob/tendermint-0.30/src/
// See https://github.com/tendermint/go-amino/blob/v0.15.0/encoder.go#L193-L195
function $8709529930405ca8$var$encodeString(s) {
    const utf8 = (0, $6XcLW.toUtf8)(s);
    return Uint8Array.from([
        utf8.length,
        ...utf8
    ]);
}
module.exports.encodeString = $8709529930405ca8$var$encodeString;
// See https://github.com/tendermint/go-amino/blob/v0.15.0/encoder.go#L79-L87
function $8709529930405ca8$var$encodeUvarint(n) {
    return n >= 0x80 ? Uint8Array.from([
        n & 0xff | 0x80,
        ...$8709529930405ca8$var$encodeUvarint(n >> 7)
    ]) : Uint8Array.from([
        n & 0xff
    ]);
}
module.exports.encodeUvarint = $8709529930405ca8$var$encodeUvarint;
// See https://github.com/tendermint/go-amino/blob/v0.15.0/encoder.go#L134-L178
function $8709529930405ca8$var$encodeTime(time) {
    const milliseconds = time.getTime();
    const seconds = Math.floor(milliseconds / 1000);
    const secondsArray = seconds ? [
        0x08,
        ...$8709529930405ca8$var$encodeUvarint(seconds)
    ] : new Uint8Array();
    const nanoseconds = (time.nanoseconds || 0) + milliseconds % 1000 * 1e6;
    const nanosecondsArray = nanoseconds ? [
        0x10,
        ...$8709529930405ca8$var$encodeUvarint(nanoseconds)
    ] : new Uint8Array();
    return Uint8Array.from([
        ...secondsArray,
        ...nanosecondsArray
    ]);
}
module.exports.encodeTime = $8709529930405ca8$var$encodeTime;
// See https://github.com/tendermint/go-amino/blob/v0.15.0/encoder.go#L180-L187
function $8709529930405ca8$var$encodeBytes(bytes) {
    // Since we're only dealing with short byte arrays we don't need a full VarBuffer implementation yet
    if (bytes.length >= 0x80) throw new Error("Not implemented for byte arrays of length 128 or more");
    return bytes.length ? Uint8Array.from([
        bytes.length,
        ...bytes
    ]) : new Uint8Array();
}
module.exports.encodeBytes = $8709529930405ca8$var$encodeBytes;
function $8709529930405ca8$var$encodeVersion(version) {
    const blockArray = version.block ? Uint8Array.from([
        0x08,
        ...$8709529930405ca8$var$encodeUvarint(version.block)
    ]) : new Uint8Array();
    const appArray = version.app ? Uint8Array.from([
        0x10,
        ...$8709529930405ca8$var$encodeUvarint(version.app)
    ]) : new Uint8Array();
    return Uint8Array.from([
        ...blockArray,
        ...appArray
    ]);
}
module.exports.encodeVersion = $8709529930405ca8$var$encodeVersion;
function $8709529930405ca8$var$encodeBlockId(blockId) {
    return Uint8Array.from([
        0x0a,
        blockId.hash.length,
        ...blockId.hash,
        0x12,
        blockId.parts.hash.length + 4,
        0x08,
        blockId.parts.total,
        0x12,
        blockId.parts.hash.length,
        ...blockId.parts.hash
    ]);
}
module.exports.encodeBlockId = $8709529930405ca8$var$encodeBlockId;

});


parcelRequire.register("8f7Qz", function(module, exports) {
"use strict";
var $6005cfa98c07e43f$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $6005cfa98c07e43f$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $6005cfa98c07e43f$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $6005cfa98c07e43f$var$__createBinding(result, mod, k);
    }
    $6005cfa98c07e43f$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Params = void 0;

var $6XcLW = parcelRequire("6XcLW");

var $9EsCA = parcelRequire("9EsCA");

var $2O5kv = parcelRequire("2O5kv");

var $bANkA = parcelRequire("bANkA");

const $6005cfa98c07e43f$var$requests = $6005cfa98c07e43f$var$__importStar((parcelRequire("kGR9o")));
function $6005cfa98c07e43f$var$encodeHeightParam(param) {
    return {
        height: (0, $bANkA.may)($9EsCA.smallIntToApi, param.height)
    };
}
function $6005cfa98c07e43f$var$encodeBlockchainRequestParams(param) {
    return {
        minHeight: (0, $bANkA.may)($9EsCA.smallIntToApi, param.minHeight),
        maxHeight: (0, $bANkA.may)($9EsCA.smallIntToApi, param.maxHeight)
    };
}
function $6005cfa98c07e43f$var$encodeBlockSearchParams(params) {
    return {
        query: params.query,
        page: (0, $bANkA.may)($9EsCA.smallIntToApi, params.page),
        per_page: (0, $bANkA.may)($9EsCA.smallIntToApi, params.per_page),
        order_by: params.order_by
    };
}
function $6005cfa98c07e43f$var$encodeAbciQueryParams(params) {
    return {
        path: (0, $bANkA.assertNotEmpty)(params.path),
        data: (0, $6XcLW.toHex)(params.data),
        height: (0, $bANkA.may)($9EsCA.smallIntToApi, params.height),
        prove: params.prove
    };
}
function $6005cfa98c07e43f$var$encodeBroadcastTxParams(params) {
    return {
        tx: (0, $6XcLW.toBase64)((0, $bANkA.assertNotEmpty)(params.tx))
    };
}
function $6005cfa98c07e43f$var$encodeTxParams(params) {
    return {
        hash: (0, $6XcLW.toBase64)((0, $bANkA.assertNotEmpty)(params.hash)),
        prove: params.prove
    };
}
function $6005cfa98c07e43f$var$encodeTxSearchParams(params) {
    return {
        query: params.query,
        prove: params.prove,
        page: (0, $bANkA.may)($9EsCA.smallIntToApi, params.page),
        per_page: (0, $bANkA.may)($9EsCA.smallIntToApi, params.per_page),
        order_by: params.order_by
    };
}
function $6005cfa98c07e43f$var$encodeValidatorsParams(params) {
    return {
        height: (0, $bANkA.may)($9EsCA.smallIntToApi, params.height),
        page: (0, $bANkA.may)($9EsCA.smallIntToApi, params.page),
        per_page: (0, $bANkA.may)($9EsCA.smallIntToApi, params.per_page)
    };
}
class $6005cfa98c07e43f$var$Params {
    static encodeAbciInfo(req) {
        return (0, $2O5kv.createJsonRpcRequest)(req.method);
    }
    static encodeAbciQuery(req) {
        return (0, $2O5kv.createJsonRpcRequest)(req.method, $6005cfa98c07e43f$var$encodeAbciQueryParams(req.params));
    }
    static encodeBlock(req) {
        return (0, $2O5kv.createJsonRpcRequest)(req.method, $6005cfa98c07e43f$var$encodeHeightParam(req.params));
    }
    static encodeBlockchain(req) {
        return (0, $2O5kv.createJsonRpcRequest)(req.method, $6005cfa98c07e43f$var$encodeBlockchainRequestParams(req.params));
    }
    static encodeBlockResults(req) {
        return (0, $2O5kv.createJsonRpcRequest)(req.method, $6005cfa98c07e43f$var$encodeHeightParam(req.params));
    }
    static encodeBlockSearch(req) {
        return (0, $2O5kv.createJsonRpcRequest)(req.method, $6005cfa98c07e43f$var$encodeBlockSearchParams(req.params));
    }
    static encodeBroadcastTx(req) {
        return (0, $2O5kv.createJsonRpcRequest)(req.method, $6005cfa98c07e43f$var$encodeBroadcastTxParams(req.params));
    }
    static encodeCommit(req) {
        return (0, $2O5kv.createJsonRpcRequest)(req.method, $6005cfa98c07e43f$var$encodeHeightParam(req.params));
    }
    static encodeGenesis(req) {
        return (0, $2O5kv.createJsonRpcRequest)(req.method);
    }
    static encodeHealth(req) {
        return (0, $2O5kv.createJsonRpcRequest)(req.method);
    }
    static encodeNumUnconfirmedTxs(req) {
        return (0, $2O5kv.createJsonRpcRequest)(req.method);
    }
    static encodeStatus(req) {
        return (0, $2O5kv.createJsonRpcRequest)(req.method);
    }
    static encodeSubscribe(req) {
        const eventTag = {
            key: "tm.event",
            value: req.query.type
        };
        const query = $6005cfa98c07e43f$var$requests.buildQuery({
            tags: [
                eventTag
            ],
            raw: req.query.raw
        });
        return (0, $2O5kv.createJsonRpcRequest)("subscribe", {
            query: query
        });
    }
    static encodeTx(req) {
        return (0, $2O5kv.createJsonRpcRequest)(req.method, $6005cfa98c07e43f$var$encodeTxParams(req.params));
    }
    // TODO: encode params for query string???
    static encodeTxSearch(req) {
        return (0, $2O5kv.createJsonRpcRequest)(req.method, $6005cfa98c07e43f$var$encodeTxSearchParams(req.params));
    }
    static encodeValidators(req) {
        return (0, $2O5kv.createJsonRpcRequest)(req.method, $6005cfa98c07e43f$var$encodeValidatorsParams(req.params));
    }
}
module.exports.Params = $6005cfa98c07e43f$var$Params;

});
parcelRequire.register("9EsCA", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.smallIntToApi = module.exports.apiToBigInt = module.exports.apiToSmallInt = void 0;

var $7UsfE = parcelRequire("7UsfE");

var $bANkA = parcelRequire("bANkA");
/**
 * Takes an integer value from the Tendermint RPC API and
 * returns it as number.
 *
 * Only works within the safe integer range.
 */ function $706e0d194abaa38e$var$apiToSmallInt(input) {
    const asInt = typeof input === "number" ? new $7UsfE.Int53(input) : $7UsfE.Int53.fromString(input);
    return asInt.toNumber();
}
module.exports.apiToSmallInt = $706e0d194abaa38e$var$apiToSmallInt;
/**
 * Takes an integer value from the Tendermint RPC API and
 * returns it as BigInt.
 *
 * This supports the full uint64 and int64 ranges.
 */ function $706e0d194abaa38e$var$apiToBigInt(input) {
    (0, $bANkA.assertString)(input); // Runtime check on top of TypeScript just to be safe for semi-trusted API types
    if (!input.match(/^-?[0-9]+$/)) throw new Error("Invalid string format");
    return BigInt(input);
}
module.exports.apiToBigInt = $706e0d194abaa38e$var$apiToBigInt;
/**
 * Takes an integer in the safe integer range and returns
 * a string representation to be used in the Tendermint RPC API.
 */ function $706e0d194abaa38e$var$smallIntToApi(num) {
    return new $7UsfE.Int53(num).toString();
}
module.exports.smallIntToApi = $706e0d194abaa38e$var$smallIntToApi;

});


parcelRequire.register("0r1XS", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Responses = module.exports.decodeValidatorInfo = module.exports.decodeValidatorGenesis = module.exports.decodeValidatorUpdate = module.exports.decodeEvent = void 0;

var $6XcLW = parcelRequire("6XcLW");

var $fZwG5 = parcelRequire("fZwG5");

var $2Sgxm = parcelRequire("2Sgxm");

var $9EsCA = parcelRequire("9EsCA");

var $dVoCS = parcelRequire("dVoCS");

var $bANkA = parcelRequire("bANkA");

var $k2bcl = parcelRequire("k2bcl");
function $0014f7ef1fa9dbb6$var$decodeAbciInfo(data) {
    return {
        data: data.data,
        lastBlockHeight: (0, $bANkA.may)($9EsCA.apiToSmallInt, data.last_block_height),
        lastBlockAppHash: (0, $bANkA.may)($6XcLW.fromBase64, data.last_block_app_hash)
    };
}
function $0014f7ef1fa9dbb6$var$decodeQueryProof(data) {
    return {
        ops: data.ops.map((op)=>({
                type: op.type,
                key: (0, $6XcLW.fromBase64)(op.key),
                data: (0, $6XcLW.fromBase64)(op.data)
            }))
    };
}
function $0014f7ef1fa9dbb6$var$decodeAbciQuery(data) {
    return {
        key: (0, $6XcLW.fromBase64)((0, $bANkA.assertString)(data.key ?? "")),
        value: (0, $6XcLW.fromBase64)((0, $bANkA.assertString)(data.value ?? "")),
        proof: (0, $bANkA.may)($0014f7ef1fa9dbb6$var$decodeQueryProof, data.proofOps),
        height: (0, $bANkA.may)($9EsCA.apiToSmallInt, data.height),
        code: (0, $bANkA.may)($9EsCA.apiToSmallInt, data.code),
        codespace: (0, $bANkA.assertString)(data.codespace ?? ""),
        index: (0, $bANkA.may)($9EsCA.apiToSmallInt, data.index),
        log: data.log,
        info: (0, $bANkA.assertString)(data.info ?? "")
    };
}
function $0014f7ef1fa9dbb6$var$decodeAttribute(attribute) {
    return {
        key: (0, $6XcLW.fromBase64)((0, $bANkA.assertNotEmpty)(attribute.key)),
        value: (0, $6XcLW.fromBase64)((0, $bANkA.assertString)(attribute.value ?? ""))
    };
}
function $0014f7ef1fa9dbb6$var$decodeAttributes(attributes) {
    return (0, $bANkA.assertArray)(attributes).map($0014f7ef1fa9dbb6$var$decodeAttribute);
}
function $0014f7ef1fa9dbb6$var$decodeEvent(event) {
    return {
        type: event.type,
        attributes: event.attributes ? $0014f7ef1fa9dbb6$var$decodeAttributes(event.attributes) : []
    };
}
module.exports.decodeEvent = $0014f7ef1fa9dbb6$var$decodeEvent;
function $0014f7ef1fa9dbb6$var$decodeEvents(events) {
    return (0, $bANkA.assertArray)(events).map($0014f7ef1fa9dbb6$var$decodeEvent);
}
function $0014f7ef1fa9dbb6$var$decodeTxData(data) {
    return {
        code: (0, $9EsCA.apiToSmallInt)((0, $bANkA.assertNumber)(data.code ?? 0)),
        codespace: data.codespace,
        log: data.log,
        data: (0, $bANkA.may)($6XcLW.fromBase64, data.data),
        events: data.events ? $0014f7ef1fa9dbb6$var$decodeEvents(data.events) : [],
        gasWanted: (0, $9EsCA.apiToSmallInt)(data.gas_wanted ?? "0"),
        gasUsed: (0, $9EsCA.apiToSmallInt)(data.gas_used ?? "0")
    };
}
function $0014f7ef1fa9dbb6$var$decodePubkey(data) {
    if ("Sum" in data) {
        // we don't need to check type because we're checking algorithm
        const [[algorithm, value]] = Object.entries(data.Sum.value);
        (0, $fZwG5.assert)(algorithm === "ed25519" || algorithm === "secp256k1", `unknown pubkey type: ${algorithm}`);
        return {
            algorithm: algorithm,
            data: (0, $6XcLW.fromBase64)((0, $bANkA.assertNotEmpty)(value))
        };
    } else switch(data.type){
        // go-amino special code
        case "tendermint/PubKeyEd25519":
            return {
                algorithm: "ed25519",
                data: (0, $6XcLW.fromBase64)((0, $bANkA.assertNotEmpty)(data.value))
            };
        case "tendermint/PubKeySecp256k1":
            return {
                algorithm: "secp256k1",
                data: (0, $6XcLW.fromBase64)((0, $bANkA.assertNotEmpty)(data.value))
            };
        default:
            throw new Error(`unknown pubkey type: ${data.type}`);
    }
}
/**
 * Note: we do not parse block.time_iota_ms for now because of this CHANGELOG entry
 *
 * > Add time_iota_ms to block's consensus parameters (not exposed to the application)
 * https://github.com/tendermint/tendermint/blob/master/CHANGELOG.md#v0310
 */ function $0014f7ef1fa9dbb6$var$decodeBlockParams(data) {
    return {
        maxBytes: (0, $9EsCA.apiToSmallInt)((0, $bANkA.assertNotEmpty)(data.max_bytes)),
        maxGas: (0, $9EsCA.apiToSmallInt)((0, $bANkA.assertNotEmpty)(data.max_gas))
    };
}
function $0014f7ef1fa9dbb6$var$decodeEvidenceParams(data) {
    return {
        maxAgeNumBlocks: (0, $9EsCA.apiToSmallInt)((0, $bANkA.assertNotEmpty)(data.max_age_num_blocks)),
        maxAgeDuration: (0, $9EsCA.apiToSmallInt)((0, $bANkA.assertNotEmpty)(data.max_age_duration))
    };
}
function $0014f7ef1fa9dbb6$var$decodeConsensusParams(data) {
    return {
        block: $0014f7ef1fa9dbb6$var$decodeBlockParams((0, $bANkA.assertObject)(data.block)),
        evidence: $0014f7ef1fa9dbb6$var$decodeEvidenceParams((0, $bANkA.assertObject)(data.evidence))
    };
}
function $0014f7ef1fa9dbb6$var$decodeValidatorUpdate(data) {
    return {
        pubkey: $0014f7ef1fa9dbb6$var$decodePubkey((0, $bANkA.assertObject)(data.pub_key)),
        votingPower: (0, $9EsCA.apiToBigInt)(data.power ?? "0")
    };
}
module.exports.decodeValidatorUpdate = $0014f7ef1fa9dbb6$var$decodeValidatorUpdate;
function $0014f7ef1fa9dbb6$var$decodeBlockResults(data) {
    return {
        height: (0, $9EsCA.apiToSmallInt)((0, $bANkA.assertNotEmpty)(data.height)),
        results: (data.txs_results || []).map($0014f7ef1fa9dbb6$var$decodeTxData),
        validatorUpdates: (data.validator_updates || []).map($0014f7ef1fa9dbb6$var$decodeValidatorUpdate),
        consensusUpdates: (0, $bANkA.may)($0014f7ef1fa9dbb6$var$decodeConsensusParams, data.consensus_param_updates),
        beginBlockEvents: $0014f7ef1fa9dbb6$var$decodeEvents(data.begin_block_events || []),
        endBlockEvents: $0014f7ef1fa9dbb6$var$decodeEvents(data.end_block_events || [])
    };
}
function $0014f7ef1fa9dbb6$var$decodeBlockId(data) {
    return {
        hash: (0, $6XcLW.fromHex)((0, $bANkA.assertNotEmpty)(data.hash)),
        parts: {
            total: (0, $bANkA.assertNotEmpty)(data.parts.total),
            hash: (0, $6XcLW.fromHex)((0, $bANkA.assertNotEmpty)(data.parts.hash))
        }
    };
}
function $0014f7ef1fa9dbb6$var$decodeBlockVersion(data) {
    return {
        block: (0, $9EsCA.apiToSmallInt)(data.block),
        app: (0, $9EsCA.apiToSmallInt)(data.app ?? 0)
    };
}
function $0014f7ef1fa9dbb6$var$decodeHeader(data) {
    return {
        version: $0014f7ef1fa9dbb6$var$decodeBlockVersion(data.version),
        chainId: (0, $bANkA.assertNotEmpty)(data.chain_id),
        height: (0, $9EsCA.apiToSmallInt)((0, $bANkA.assertNotEmpty)(data.height)),
        time: (0, $2Sgxm.fromRfc3339WithNanoseconds)((0, $bANkA.assertNotEmpty)(data.time)),
        // When there is no last block ID (i.e. this block's height is 1), we get an empty structure like this:
        // { hash: '', parts: { total: 0, hash: '' } }
        lastBlockId: data.last_block_id.hash ? $0014f7ef1fa9dbb6$var$decodeBlockId(data.last_block_id) : null,
        lastCommitHash: (0, $6XcLW.fromHex)((0, $bANkA.assertSet)(data.last_commit_hash)),
        dataHash: (0, $6XcLW.fromHex)((0, $bANkA.assertSet)(data.data_hash)),
        validatorsHash: (0, $6XcLW.fromHex)((0, $bANkA.assertSet)(data.validators_hash)),
        nextValidatorsHash: (0, $6XcLW.fromHex)((0, $bANkA.assertSet)(data.next_validators_hash)),
        consensusHash: (0, $6XcLW.fromHex)((0, $bANkA.assertSet)(data.consensus_hash)),
        appHash: (0, $6XcLW.fromHex)((0, $bANkA.assertSet)(data.app_hash)),
        lastResultsHash: (0, $6XcLW.fromHex)((0, $bANkA.assertSet)(data.last_results_hash)),
        evidenceHash: (0, $6XcLW.fromHex)((0, $bANkA.assertSet)(data.evidence_hash)),
        proposerAddress: (0, $6XcLW.fromHex)((0, $bANkA.assertNotEmpty)(data.proposer_address))
    };
}
function $0014f7ef1fa9dbb6$var$decodeBlockMeta(data) {
    return {
        blockId: $0014f7ef1fa9dbb6$var$decodeBlockId(data.block_id),
        blockSize: (0, $9EsCA.apiToSmallInt)((0, $bANkA.assertNotEmpty)(data.block_size)),
        header: $0014f7ef1fa9dbb6$var$decodeHeader(data.header),
        numTxs: (0, $9EsCA.apiToSmallInt)((0, $bANkA.assertNotEmpty)(data.num_txs))
    };
}
function $0014f7ef1fa9dbb6$var$decodeBlockchain(data) {
    return {
        lastHeight: (0, $9EsCA.apiToSmallInt)((0, $bANkA.assertNotEmpty)(data.last_height)),
        blockMetas: (0, $bANkA.assertArray)(data.block_metas).map($0014f7ef1fa9dbb6$var$decodeBlockMeta)
    };
}
function $0014f7ef1fa9dbb6$var$decodeBroadcastTxSync(data) {
    return {
        ...$0014f7ef1fa9dbb6$var$decodeTxData(data),
        hash: (0, $6XcLW.fromHex)((0, $bANkA.assertNotEmpty)(data.hash))
    };
}
function $0014f7ef1fa9dbb6$var$decodeBroadcastTxCommit(data) {
    return {
        height: (0, $9EsCA.apiToSmallInt)(data.height),
        hash: (0, $6XcLW.fromHex)((0, $bANkA.assertNotEmpty)(data.hash)),
        checkTx: $0014f7ef1fa9dbb6$var$decodeTxData((0, $bANkA.assertObject)(data.check_tx)),
        deliverTx: (0, $bANkA.may)($0014f7ef1fa9dbb6$var$decodeTxData, data.deliver_tx)
    };
}
function $0014f7ef1fa9dbb6$var$decodeBlockIdFlag(blockIdFlag) {
    (0, $fZwG5.assert)(blockIdFlag in $dVoCS.BlockIdFlag);
    return blockIdFlag;
}
/**
 * In some cases a timestamp is optional and set to the value 0 in Go.
 * This can lead to strings like "0001-01-01T00:00:00Z" (see https://github.com/cosmos/cosmjs/issues/704#issuecomment-797122415).
 * This decoder tries to clean up such encoding from the API and turn them
 * into undefined values.
 */ function $0014f7ef1fa9dbb6$var$decodeOptionalTime(timestamp) {
    const nonZeroTime = timestamp && !timestamp.startsWith("0001-01-01");
    return nonZeroTime ? (0, $2Sgxm.fromRfc3339WithNanoseconds)(timestamp) : undefined;
}
function $0014f7ef1fa9dbb6$var$decodeCommitSignature(data) {
    return {
        blockIdFlag: $0014f7ef1fa9dbb6$var$decodeBlockIdFlag(data.block_id_flag),
        validatorAddress: data.validator_address ? (0, $6XcLW.fromHex)(data.validator_address) : undefined,
        timestamp: $0014f7ef1fa9dbb6$var$decodeOptionalTime(data.timestamp),
        signature: data.signature ? (0, $6XcLW.fromBase64)(data.signature) : undefined
    };
}
function $0014f7ef1fa9dbb6$var$decodeCommit(data) {
    return {
        blockId: $0014f7ef1fa9dbb6$var$decodeBlockId((0, $bANkA.assertObject)(data.block_id)),
        height: (0, $9EsCA.apiToSmallInt)((0, $bANkA.assertNotEmpty)(data.height)),
        round: (0, $9EsCA.apiToSmallInt)(data.round),
        signatures: (0, $bANkA.assertArray)(data.signatures).map($0014f7ef1fa9dbb6$var$decodeCommitSignature)
    };
}
function $0014f7ef1fa9dbb6$var$decodeCommitResponse(data) {
    return {
        canonical: (0, $bANkA.assertBoolean)(data.canonical),
        header: $0014f7ef1fa9dbb6$var$decodeHeader(data.signed_header.header),
        commit: $0014f7ef1fa9dbb6$var$decodeCommit(data.signed_header.commit)
    };
}
function $0014f7ef1fa9dbb6$var$decodeValidatorGenesis(data) {
    return {
        address: (0, $6XcLW.fromHex)((0, $bANkA.assertNotEmpty)(data.address)),
        pubkey: $0014f7ef1fa9dbb6$var$decodePubkey((0, $bANkA.assertObject)(data.pub_key)),
        votingPower: (0, $9EsCA.apiToBigInt)((0, $bANkA.assertNotEmpty)(data.power))
    };
}
module.exports.decodeValidatorGenesis = $0014f7ef1fa9dbb6$var$decodeValidatorGenesis;
function $0014f7ef1fa9dbb6$var$decodeGenesis(data) {
    return {
        genesisTime: (0, $2Sgxm.fromRfc3339WithNanoseconds)((0, $bANkA.assertNotEmpty)(data.genesis_time)),
        chainId: (0, $bANkA.assertNotEmpty)(data.chain_id),
        consensusParams: $0014f7ef1fa9dbb6$var$decodeConsensusParams(data.consensus_params),
        validators: data.validators ? (0, $bANkA.assertArray)(data.validators).map($0014f7ef1fa9dbb6$var$decodeValidatorGenesis) : [],
        appHash: (0, $6XcLW.fromHex)((0, $bANkA.assertSet)(data.app_hash)),
        appState: data.app_state
    };
}
function $0014f7ef1fa9dbb6$var$decodeValidatorInfo(data) {
    return {
        pubkey: $0014f7ef1fa9dbb6$var$decodePubkey((0, $bANkA.assertObject)(data.pub_key)),
        votingPower: (0, $9EsCA.apiToBigInt)((0, $bANkA.assertNotEmpty)(data.voting_power)),
        address: (0, $6XcLW.fromHex)((0, $bANkA.assertNotEmpty)(data.address)),
        proposerPriority: data.proposer_priority ? (0, $9EsCA.apiToSmallInt)(data.proposer_priority) : undefined
    };
}
module.exports.decodeValidatorInfo = $0014f7ef1fa9dbb6$var$decodeValidatorInfo;
function $0014f7ef1fa9dbb6$var$decodeNodeInfo(data) {
    return {
        id: (0, $6XcLW.fromHex)((0, $bANkA.assertNotEmpty)(data.id)),
        listenAddr: (0, $bANkA.assertNotEmpty)(data.listen_addr),
        network: (0, $bANkA.assertNotEmpty)(data.network),
        version: (0, $bANkA.assertString)(data.version),
        channels: (0, $bANkA.assertNotEmpty)(data.channels),
        moniker: (0, $bANkA.assertNotEmpty)(data.moniker),
        other: (0, $bANkA.dictionaryToStringMap)(data.other),
        protocolVersion: {
            app: (0, $9EsCA.apiToSmallInt)((0, $bANkA.assertNotEmpty)(data.protocol_version.app)),
            block: (0, $9EsCA.apiToSmallInt)((0, $bANkA.assertNotEmpty)(data.protocol_version.block)),
            p2p: (0, $9EsCA.apiToSmallInt)((0, $bANkA.assertNotEmpty)(data.protocol_version.p2p))
        }
    };
}
function $0014f7ef1fa9dbb6$var$decodeSyncInfo(data) {
    const earliestBlockHeight = data.earliest_block_height ? (0, $9EsCA.apiToSmallInt)(data.earliest_block_height) : undefined;
    const earliestBlockTime = data.earliest_block_time ? (0, $2Sgxm.fromRfc3339WithNanoseconds)(data.earliest_block_time) : undefined;
    return {
        earliestAppHash: data.earliest_app_hash ? (0, $6XcLW.fromHex)(data.earliest_app_hash) : undefined,
        earliestBlockHash: data.earliest_block_hash ? (0, $6XcLW.fromHex)(data.earliest_block_hash) : undefined,
        earliestBlockHeight: earliestBlockHeight || undefined,
        earliestBlockTime: earliestBlockTime?.getTime() ? earliestBlockTime : undefined,
        latestBlockHash: (0, $6XcLW.fromHex)((0, $bANkA.assertNotEmpty)(data.latest_block_hash)),
        latestAppHash: (0, $6XcLW.fromHex)((0, $bANkA.assertNotEmpty)(data.latest_app_hash)),
        latestBlockTime: (0, $2Sgxm.fromRfc3339WithNanoseconds)((0, $bANkA.assertNotEmpty)(data.latest_block_time)),
        latestBlockHeight: (0, $9EsCA.apiToSmallInt)((0, $bANkA.assertNotEmpty)(data.latest_block_height)),
        catchingUp: (0, $bANkA.assertBoolean)(data.catching_up)
    };
}
function $0014f7ef1fa9dbb6$var$decodeStatus(data) {
    return {
        nodeInfo: $0014f7ef1fa9dbb6$var$decodeNodeInfo(data.node_info),
        syncInfo: $0014f7ef1fa9dbb6$var$decodeSyncInfo(data.sync_info),
        validatorInfo: $0014f7ef1fa9dbb6$var$decodeValidatorInfo(data.validator_info)
    };
}
function $0014f7ef1fa9dbb6$var$decodeTxProof(data) {
    return {
        data: (0, $6XcLW.fromBase64)((0, $bANkA.assertNotEmpty)(data.data)),
        rootHash: (0, $6XcLW.fromHex)((0, $bANkA.assertNotEmpty)(data.root_hash)),
        proof: {
            total: (0, $9EsCA.apiToSmallInt)((0, $bANkA.assertNotEmpty)(data.proof.total)),
            index: (0, $9EsCA.apiToSmallInt)((0, $bANkA.assertNotEmpty)(data.proof.index)),
            leafHash: (0, $6XcLW.fromBase64)((0, $bANkA.assertNotEmpty)(data.proof.leaf_hash)),
            aunts: (0, $bANkA.assertArray)(data.proof.aunts).map($6XcLW.fromBase64)
        }
    };
}
function $0014f7ef1fa9dbb6$var$decodeTxResponse(data) {
    return {
        tx: (0, $6XcLW.fromBase64)((0, $bANkA.assertNotEmpty)(data.tx)),
        result: $0014f7ef1fa9dbb6$var$decodeTxData((0, $bANkA.assertObject)(data.tx_result)),
        height: (0, $9EsCA.apiToSmallInt)((0, $bANkA.assertNotEmpty)(data.height)),
        index: (0, $9EsCA.apiToSmallInt)((0, $bANkA.assertNumber)(data.index)),
        hash: (0, $6XcLW.fromHex)((0, $bANkA.assertNotEmpty)(data.hash)),
        proof: (0, $bANkA.may)($0014f7ef1fa9dbb6$var$decodeTxProof, data.proof)
    };
}
function $0014f7ef1fa9dbb6$var$decodeTxSearch(data) {
    return {
        totalCount: (0, $9EsCA.apiToSmallInt)((0, $bANkA.assertNotEmpty)(data.total_count)),
        txs: (0, $bANkA.assertArray)(data.txs).map($0014f7ef1fa9dbb6$var$decodeTxResponse)
    };
}
function $0014f7ef1fa9dbb6$var$decodeTxEvent(data) {
    const tx = (0, $6XcLW.fromBase64)((0, $bANkA.assertNotEmpty)(data.tx));
    return {
        tx: tx,
        hash: (0, $k2bcl.hashTx)(tx),
        result: $0014f7ef1fa9dbb6$var$decodeTxData(data.result),
        height: (0, $9EsCA.apiToSmallInt)((0, $bANkA.assertNotEmpty)(data.height))
    };
}
function $0014f7ef1fa9dbb6$var$decodeValidators(data) {
    return {
        blockHeight: (0, $9EsCA.apiToSmallInt)((0, $bANkA.assertNotEmpty)(data.block_height)),
        validators: (0, $bANkA.assertArray)(data.validators).map($0014f7ef1fa9dbb6$var$decodeValidatorInfo),
        count: (0, $9EsCA.apiToSmallInt)((0, $bANkA.assertNotEmpty)(data.count)),
        total: (0, $9EsCA.apiToSmallInt)((0, $bANkA.assertNotEmpty)(data.total))
    };
}
function $0014f7ef1fa9dbb6$var$decodeBlock(data) {
    return {
        header: $0014f7ef1fa9dbb6$var$decodeHeader((0, $bANkA.assertObject)(data.header)),
        // For the block at height 1, last commit is not set. This is represented in an empty object like this:
        // { height: '0', round: 0, block_id: { hash: '', parts: [Object] }, signatures: [] }
        lastCommit: data.last_commit.block_id.hash ? $0014f7ef1fa9dbb6$var$decodeCommit((0, $bANkA.assertObject)(data.last_commit)) : null,
        txs: data.data.txs ? (0, $bANkA.assertArray)(data.data.txs).map($6XcLW.fromBase64) : [],
        // Lift up .evidence.evidence to just .evidence
        // See https://github.com/tendermint/tendermint/issues/7697
        evidence: data.evidence?.evidence ?? []
    };
}
function $0014f7ef1fa9dbb6$var$decodeBlockResponse(data) {
    return {
        blockId: $0014f7ef1fa9dbb6$var$decodeBlockId(data.block_id),
        block: $0014f7ef1fa9dbb6$var$decodeBlock(data.block)
    };
}
function $0014f7ef1fa9dbb6$var$decodeBlockSearch(data) {
    return {
        totalCount: (0, $9EsCA.apiToSmallInt)((0, $bANkA.assertNotEmpty)(data.total_count)),
        blocks: (0, $bANkA.assertArray)(data.blocks).map($0014f7ef1fa9dbb6$var$decodeBlockResponse)
    };
}
function $0014f7ef1fa9dbb6$var$decodeNumUnconfirmedTxs(data) {
    return {
        total: (0, $9EsCA.apiToSmallInt)((0, $bANkA.assertNotEmpty)(data.total)),
        totalBytes: (0, $9EsCA.apiToSmallInt)((0, $bANkA.assertNotEmpty)(data.total_bytes))
    };
}
class $0014f7ef1fa9dbb6$var$Responses {
    static decodeAbciInfo(response) {
        return $0014f7ef1fa9dbb6$var$decodeAbciInfo((0, $bANkA.assertObject)(response.result.response));
    }
    static decodeAbciQuery(response) {
        return $0014f7ef1fa9dbb6$var$decodeAbciQuery((0, $bANkA.assertObject)(response.result.response));
    }
    static decodeBlock(response) {
        return $0014f7ef1fa9dbb6$var$decodeBlockResponse(response.result);
    }
    static decodeBlockResults(response) {
        return $0014f7ef1fa9dbb6$var$decodeBlockResults(response.result);
    }
    static decodeBlockSearch(response) {
        return $0014f7ef1fa9dbb6$var$decodeBlockSearch(response.result);
    }
    static decodeBlockchain(response) {
        return $0014f7ef1fa9dbb6$var$decodeBlockchain(response.result);
    }
    static decodeBroadcastTxSync(response) {
        return $0014f7ef1fa9dbb6$var$decodeBroadcastTxSync(response.result);
    }
    static decodeBroadcastTxAsync(response) {
        return $0014f7ef1fa9dbb6$var$Responses.decodeBroadcastTxSync(response);
    }
    static decodeBroadcastTxCommit(response) {
        return $0014f7ef1fa9dbb6$var$decodeBroadcastTxCommit(response.result);
    }
    static decodeCommit(response) {
        return $0014f7ef1fa9dbb6$var$decodeCommitResponse(response.result);
    }
    static decodeGenesis(response) {
        return $0014f7ef1fa9dbb6$var$decodeGenesis((0, $bANkA.assertObject)(response.result.genesis));
    }
    static decodeHealth() {
        return null;
    }
    static decodeNumUnconfirmedTxs(response) {
        return $0014f7ef1fa9dbb6$var$decodeNumUnconfirmedTxs(response.result);
    }
    static decodeStatus(response) {
        return $0014f7ef1fa9dbb6$var$decodeStatus(response.result);
    }
    static decodeNewBlockEvent(event) {
        return $0014f7ef1fa9dbb6$var$decodeBlock(event.data.value.block);
    }
    static decodeNewBlockHeaderEvent(event) {
        return $0014f7ef1fa9dbb6$var$decodeHeader(event.data.value.header);
    }
    static decodeTxEvent(event) {
        return $0014f7ef1fa9dbb6$var$decodeTxEvent(event.data.value.TxResult);
    }
    static decodeTx(response) {
        return $0014f7ef1fa9dbb6$var$decodeTxResponse(response.result);
    }
    static decodeTxSearch(response) {
        return $0014f7ef1fa9dbb6$var$decodeTxSearch(response.result);
    }
    static decodeValidators(response) {
        return $0014f7ef1fa9dbb6$var$decodeValidators(response.result);
    }
}
module.exports.Responses = $0014f7ef1fa9dbb6$var$Responses;

});
parcelRequire.register("2Sgxm", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DateTime = module.exports.toSeconds = module.exports.fromSeconds = module.exports.toRfc3339WithNanoseconds = module.exports.fromRfc3339WithNanoseconds = void 0;

var $6XcLW = parcelRequire("6XcLW");

var $7UsfE = parcelRequire("7UsfE");
function $217d73d9d603d539$var$fromRfc3339WithNanoseconds(dateTimeString) {
    const out = (0, $6XcLW.fromRfc3339)(dateTimeString);
    const nanosecondsMatch = dateTimeString.match(/\.(\d+)Z$/);
    const nanoseconds = nanosecondsMatch ? nanosecondsMatch[1].slice(3) : "";
    out.nanoseconds = parseInt(nanoseconds.padEnd(6, "0"), 10);
    return out;
}
module.exports.fromRfc3339WithNanoseconds = $217d73d9d603d539$var$fromRfc3339WithNanoseconds;
function $217d73d9d603d539$var$toRfc3339WithNanoseconds(dateTime) {
    const millisecondIso = dateTime.toISOString();
    const nanoseconds = dateTime.nanoseconds?.toString() ?? "";
    return `${millisecondIso.slice(0, -1)}${nanoseconds.padStart(6, "0")}Z`;
}
module.exports.toRfc3339WithNanoseconds = $217d73d9d603d539$var$toRfc3339WithNanoseconds;
function $217d73d9d603d539$var$fromSeconds(seconds, nanos = 0) {
    const checkedNanos = new $7UsfE.Uint32(nanos).toNumber();
    if (checkedNanos > 999999999) throw new Error("Nano seconds must not exceed 999999999");
    const out = new Date(seconds * 1000 + Math.floor(checkedNanos / 1000000));
    out.nanoseconds = checkedNanos % 1000000;
    return out;
}
module.exports.fromSeconds = $217d73d9d603d539$var$fromSeconds;
/**
 * Calculates the UNIX timestamp in seconds as well as the nanoseconds after the given second.
 *
 * This is useful when dealing with external systems like the protobuf type
 * [.google.protobuf.Timestamp](https://developers.google.com/protocol-buffers/docs/reference/google.protobuf#google.protobuf.Timestamp)
 * or any other system that does not use millisecond precision.
 */ function $217d73d9d603d539$var$toSeconds(date) {
    return {
        seconds: Math.floor(date.getTime() / 1000),
        nanos: date.getTime() % 1000 * 1000000 + (date.nanoseconds ?? 0)
    };
}
module.exports.toSeconds = $217d73d9d603d539$var$toSeconds;
/** @deprecated Use fromRfc3339WithNanoseconds/toRfc3339WithNanoseconds instead */ class $217d73d9d603d539$var$DateTime {
    /** @deprecated Use fromRfc3339WithNanoseconds instead */ static decode(dateTimeString) {
        return $217d73d9d603d539$var$fromRfc3339WithNanoseconds(dateTimeString);
    }
    /** @deprecated Use toRfc3339WithNanoseconds instead */ static encode(dateTime) {
        return $217d73d9d603d539$var$toRfc3339WithNanoseconds(dateTime);
    }
}
module.exports.DateTime = $217d73d9d603d539$var$DateTime;

});

parcelRequire.register("dVoCS", function(module, exports) {
"use strict";
// Types in this file are exported outside of the @cosmjs/tendermint-rpc package,
// e.g. as part of a request or response
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.BlockIdFlag = void 0;
var $a233b374bfa9184d$var$BlockIdFlag;
(function(BlockIdFlag) {
    BlockIdFlag[BlockIdFlag["Unknown"] = 0] = "Unknown";
    BlockIdFlag[BlockIdFlag["Absent"] = 1] = "Absent";
    BlockIdFlag[BlockIdFlag["Commit"] = 2] = "Commit";
    BlockIdFlag[BlockIdFlag["Nil"] = 3] = "Nil";
    BlockIdFlag[BlockIdFlag["Unrecognized"] = -1] = "Unrecognized";
})($a233b374bfa9184d$var$BlockIdFlag = module.exports.BlockIdFlag || (module.exports.BlockIdFlag = {}));

});





parcelRequire.register("bzMo4", function(module, exports) {
"use strict";
// Note: all exports in this module are publicly available via
// `import { tendermint37 } from "@cosmjs/tendermint-rpc"`
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Tendermint37Client = module.exports.VoteType = module.exports.broadcastTxSyncSuccess = module.exports.broadcastTxCommitSuccess = module.exports.SubscriptionEventType = module.exports.Method = void 0;

var $jinUz = parcelRequire("jinUz");
Object.defineProperty(module.exports, "Method", {
    enumerable: true,
    get: function() {
        return $jinUz.Method;
    }
});
Object.defineProperty(module.exports, "SubscriptionEventType", {
    enumerable: true,
    get: function() {
        return $jinUz.SubscriptionEventType;
    }
});

var $hRMyz = parcelRequire("hRMyz");
Object.defineProperty(module.exports, "broadcastTxCommitSuccess", {
    enumerable: true,
    get: function() {
        return $hRMyz.broadcastTxCommitSuccess;
    }
});
Object.defineProperty(module.exports, "broadcastTxSyncSuccess", {
    enumerable: true,
    get: function() {
        return $hRMyz.broadcastTxSyncSuccess;
    }
});
Object.defineProperty(module.exports, "VoteType", {
    enumerable: true,
    get: function() {
        return $hRMyz.VoteType;
    }
});

var $bryWE = parcelRequire("bryWE");
Object.defineProperty(module.exports, "Tendermint37Client", {
    enumerable: true,
    get: function() {
        return $bryWE.Tendermint37Client;
    }
});

});
parcelRequire.register("jinUz", function(module, exports) {
"use strict";
/* eslint-disable @typescript-eslint/naming-convention */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.buildQuery = module.exports.SubscriptionEventType = module.exports.Method = void 0;
/**
 * RPC methods as documented in https://docs.tendermint.com/master/rpc/
 *
 * Enum raw value must match the spelling in the "shell" example call (snake_case)
 */ var $e0c23f169b9ee1fc$var$Method;
(function(Method) {
    Method["AbciInfo"] = "abci_info";
    Method["AbciQuery"] = "abci_query";
    Method["Block"] = "block";
    /** Get block headers for minHeight <= height <= maxHeight. */ Method["Blockchain"] = "blockchain";
    Method["BlockResults"] = "block_results";
    Method["BlockSearch"] = "block_search";
    Method["BroadcastTxAsync"] = "broadcast_tx_async";
    Method["BroadcastTxSync"] = "broadcast_tx_sync";
    Method["BroadcastTxCommit"] = "broadcast_tx_commit";
    Method["Commit"] = "commit";
    Method["Genesis"] = "genesis";
    Method["Health"] = "health";
    Method["NumUnconfirmedTxs"] = "num_unconfirmed_txs";
    Method["Status"] = "status";
    Method["Subscribe"] = "subscribe";
    Method["Tx"] = "tx";
    Method["TxSearch"] = "tx_search";
    Method["Validators"] = "validators";
    Method["Unsubscribe"] = "unsubscribe";
})($e0c23f169b9ee1fc$var$Method = module.exports.Method || (module.exports.Method = {}));
/**
 * Raw values must match the tendermint event name
 *
 * @see https://godoc.org/github.com/tendermint/tendermint/types#pkg-constants
 */ var $e0c23f169b9ee1fc$var$SubscriptionEventType;
(function(SubscriptionEventType) {
    SubscriptionEventType["NewBlock"] = "NewBlock";
    SubscriptionEventType["NewBlockHeader"] = "NewBlockHeader";
    SubscriptionEventType["Tx"] = "Tx";
})($e0c23f169b9ee1fc$var$SubscriptionEventType = module.exports.SubscriptionEventType || (module.exports.SubscriptionEventType = {}));
function $e0c23f169b9ee1fc$var$buildQuery(components) {
    const tags = components.tags ? components.tags : [];
    const tagComponents = tags.map((tag)=>`${tag.key}='${tag.value}'`);
    const rawComponents = components.raw ? [
        components.raw
    ] : [];
    return [
        ...tagComponents,
        ...rawComponents
    ].join(" AND ");
}
module.exports.buildQuery = $e0c23f169b9ee1fc$var$buildQuery;

});

parcelRequire.register("hRMyz", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.VoteType = module.exports.broadcastTxCommitSuccess = module.exports.broadcastTxSyncSuccess = void 0;
/**
 * Returns true iff transaction made it successfully into the transaction pool
 */ function $d01d0d36f0c02a4d$var$broadcastTxSyncSuccess(res) {
    // code must be 0 on success
    return res.code === 0;
}
module.exports.broadcastTxSyncSuccess = $d01d0d36f0c02a4d$var$broadcastTxSyncSuccess;
/**
 * Returns true iff transaction made it successfully into a block
 * (i.e. success in `check_tx` and `deliver_tx` field)
 */ function $d01d0d36f0c02a4d$var$broadcastTxCommitSuccess(response) {
    // code must be 0 on success
    // deliverTx may be present but empty on failure
    return response.checkTx.code === 0 && !!response.deliverTx && response.deliverTx.code === 0;
}
module.exports.broadcastTxCommitSuccess = $d01d0d36f0c02a4d$var$broadcastTxCommitSuccess;
/**
 * raw values from https://github.com/tendermint/tendermint/blob/dfa9a9a30a666132425b29454e90a472aa579a48/types/vote.go#L44
 */ var $d01d0d36f0c02a4d$var$VoteType;
(function(VoteType) {
    VoteType[VoteType["PreVote"] = 1] = "PreVote";
    VoteType[VoteType["PreCommit"] = 2] = "PreCommit";
})($d01d0d36f0c02a4d$var$VoteType = module.exports.VoteType || (module.exports.VoteType = {}));

});

parcelRequire.register("bryWE", function(module, exports) {
"use strict";
var $854d52a6ca83738e$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $854d52a6ca83738e$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $854d52a6ca83738e$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $854d52a6ca83738e$var$__createBinding(result, mod, k);
    }
    $854d52a6ca83738e$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Tendermint37Client = void 0;

var $2O5kv = parcelRequire("2O5kv");

var $iPMHy = parcelRequire("iPMHy");

var $6tXZL = parcelRequire("6tXZL");

const $854d52a6ca83738e$var$requests = $854d52a6ca83738e$var$__importStar((parcelRequire("jinUz")));
class $854d52a6ca83738e$var$Tendermint37Client {
    /**
     * Creates a new Tendermint client for the given endpoint.
     *
     * Uses HTTP when the URL schema is http or https. Uses WebSockets otherwise.
     */ static async connect(endpoint) {
        let rpcClient;
        if (typeof endpoint === "object") rpcClient = new $iPMHy.HttpClient(endpoint);
        else {
            const useHttp = endpoint.startsWith("http://") || endpoint.startsWith("https://");
            rpcClient = useHttp ? new $iPMHy.HttpClient(endpoint) : new $iPMHy.WebsocketClient(endpoint);
        }
        // For some very strange reason I don't understand, tests start to fail on some systems
        // (our CI) when skipping the status call before doing other queries. Sleeping a little
        // while did not help. Thus we query the version as a way to say "hi" to the backend,
        // even in cases where we don't use the result.
        const _version = await this.detectVersion(rpcClient);
        return $854d52a6ca83738e$var$Tendermint37Client.create(rpcClient);
    }
    /**
     * Creates a new Tendermint client given an RPC client.
     */ static async create(rpcClient) {
        return new $854d52a6ca83738e$var$Tendermint37Client(rpcClient);
    }
    static async detectVersion(client) {
        const req = (0, $2O5kv.createJsonRpcRequest)($854d52a6ca83738e$var$requests.Method.Status);
        const response = await client.execute(req);
        const result = response.result;
        if (!result || !result.node_info) throw new Error("Unrecognized format for status response");
        const version = result.node_info.version;
        if (typeof version !== "string") throw new Error("Unrecognized version format: must be string");
        return version;
    }
    /**
     * Use `Tendermint37Client.connect` or `Tendermint37Client.create` to create an instance.
     */ constructor(client){
        this.client = client;
        this.p = $6tXZL.adaptor37.params;
        this.r = $6tXZL.adaptor37.responses;
    }
    disconnect() {
        this.client.disconnect();
    }
    async abciInfo() {
        const query = {
            method: $854d52a6ca83738e$var$requests.Method.AbciInfo
        };
        return this.doCall(query, this.p.encodeAbciInfo, this.r.decodeAbciInfo);
    }
    async abciQuery(params) {
        const query = {
            params: params,
            method: $854d52a6ca83738e$var$requests.Method.AbciQuery
        };
        return this.doCall(query, this.p.encodeAbciQuery, this.r.decodeAbciQuery);
    }
    async block(height) {
        const query = {
            method: $854d52a6ca83738e$var$requests.Method.Block,
            params: {
                height: height
            }
        };
        return this.doCall(query, this.p.encodeBlock, this.r.decodeBlock);
    }
    async blockResults(height) {
        const query = {
            method: $854d52a6ca83738e$var$requests.Method.BlockResults,
            params: {
                height: height
            }
        };
        return this.doCall(query, this.p.encodeBlockResults, this.r.decodeBlockResults);
    }
    /**
     * Search for events that are in a block.
     *
     * NOTE
     * This method will error on any node that is running a Tendermint version lower than 0.34.9.
     *
     * @see https://docs.tendermint.com/master/rpc/#/Info/block_search
     */ async blockSearch(params) {
        const query = {
            params: params,
            method: $854d52a6ca83738e$var$requests.Method.BlockSearch
        };
        const resp = await this.doCall(query, this.p.encodeBlockSearch, this.r.decodeBlockSearch);
        return {
            ...resp,
            // make sure we sort by height, as tendermint may be sorting by string value of the height
            blocks: [
                ...resp.blocks
            ].sort((a, b)=>a.block.header.height - b.block.header.height)
        };
    }
    // this should paginate through all blockSearch options to ensure it returns all results.
    // starts with page 1 or whatever was provided (eg. to start on page 7)
    //
    // NOTE
    // This method will error on any node that is running a Tendermint version lower than 0.34.9.
    async blockSearchAll(params) {
        let page = params.page || 1;
        const blocks = [];
        let done = false;
        while(!done){
            const resp = await this.blockSearch({
                ...params,
                page: page
            });
            blocks.push(...resp.blocks);
            if (blocks.length < resp.totalCount) page++;
            else done = true;
        }
        // make sure we sort by height, as tendermint may be sorting by string value of the height
        // and the earlier items may be in a higher page than the later items
        blocks.sort((a, b)=>a.block.header.height - b.block.header.height);
        return {
            totalCount: blocks.length,
            blocks: blocks
        };
    }
    /**
     * Queries block headers filtered by minHeight <= height <= maxHeight.
     *
     * @param minHeight The minimum height to be included in the result. Defaults to 0.
     * @param maxHeight The maximum height to be included in the result. Defaults to infinity.
     */ async blockchain(minHeight, maxHeight) {
        const query = {
            method: $854d52a6ca83738e$var$requests.Method.Blockchain,
            params: {
                minHeight: minHeight,
                maxHeight: maxHeight
            }
        };
        return this.doCall(query, this.p.encodeBlockchain, this.r.decodeBlockchain);
    }
    /**
     * Broadcast transaction to mempool and wait for response
     *
     * @see https://docs.tendermint.com/master/rpc/#/Tx/broadcast_tx_sync
     */ async broadcastTxSync(params) {
        const query = {
            params: params,
            method: $854d52a6ca83738e$var$requests.Method.BroadcastTxSync
        };
        return this.doCall(query, this.p.encodeBroadcastTx, this.r.decodeBroadcastTxSync);
    }
    /**
     * Broadcast transaction to mempool and do not wait for result
     *
     * @see https://docs.tendermint.com/master/rpc/#/Tx/broadcast_tx_async
     */ async broadcastTxAsync(params) {
        const query = {
            params: params,
            method: $854d52a6ca83738e$var$requests.Method.BroadcastTxAsync
        };
        return this.doCall(query, this.p.encodeBroadcastTx, this.r.decodeBroadcastTxAsync);
    }
    /**
     * Broadcast transaction to mempool and wait for block
     *
     * @see https://docs.tendermint.com/master/rpc/#/Tx/broadcast_tx_commit
     */ async broadcastTxCommit(params) {
        const query = {
            params: params,
            method: $854d52a6ca83738e$var$requests.Method.BroadcastTxCommit
        };
        return this.doCall(query, this.p.encodeBroadcastTx, this.r.decodeBroadcastTxCommit);
    }
    async commit(height) {
        const query = {
            method: $854d52a6ca83738e$var$requests.Method.Commit,
            params: {
                height: height
            }
        };
        return this.doCall(query, this.p.encodeCommit, this.r.decodeCommit);
    }
    async genesis() {
        const query = {
            method: $854d52a6ca83738e$var$requests.Method.Genesis
        };
        return this.doCall(query, this.p.encodeGenesis, this.r.decodeGenesis);
    }
    async health() {
        const query = {
            method: $854d52a6ca83738e$var$requests.Method.Health
        };
        return this.doCall(query, this.p.encodeHealth, this.r.decodeHealth);
    }
    async numUnconfirmedTxs() {
        const query = {
            method: $854d52a6ca83738e$var$requests.Method.NumUnconfirmedTxs
        };
        return this.doCall(query, this.p.encodeNumUnconfirmedTxs, this.r.decodeNumUnconfirmedTxs);
    }
    async status() {
        const query = {
            method: $854d52a6ca83738e$var$requests.Method.Status
        };
        return this.doCall(query, this.p.encodeStatus, this.r.decodeStatus);
    }
    subscribeNewBlock() {
        const request = {
            method: $854d52a6ca83738e$var$requests.Method.Subscribe,
            query: {
                type: $854d52a6ca83738e$var$requests.SubscriptionEventType.NewBlock
            }
        };
        return this.subscribe(request, this.r.decodeNewBlockEvent);
    }
    subscribeNewBlockHeader() {
        const request = {
            method: $854d52a6ca83738e$var$requests.Method.Subscribe,
            query: {
                type: $854d52a6ca83738e$var$requests.SubscriptionEventType.NewBlockHeader
            }
        };
        return this.subscribe(request, this.r.decodeNewBlockHeaderEvent);
    }
    subscribeTx(query) {
        const request = {
            method: $854d52a6ca83738e$var$requests.Method.Subscribe,
            query: {
                type: $854d52a6ca83738e$var$requests.SubscriptionEventType.Tx,
                raw: query
            }
        };
        return this.subscribe(request, this.r.decodeTxEvent);
    }
    /**
     * Get a single transaction by hash
     *
     * @see https://docs.tendermint.com/master/rpc/#/Info/tx
     */ async tx(params) {
        const query = {
            params: params,
            method: $854d52a6ca83738e$var$requests.Method.Tx
        };
        return this.doCall(query, this.p.encodeTx, this.r.decodeTx);
    }
    /**
     * Search for transactions that are in a block
     *
     * @see https://docs.tendermint.com/master/rpc/#/Info/tx_search
     */ async txSearch(params) {
        const query = {
            params: params,
            method: $854d52a6ca83738e$var$requests.Method.TxSearch
        };
        return this.doCall(query, this.p.encodeTxSearch, this.r.decodeTxSearch);
    }
    // this should paginate through all txSearch options to ensure it returns all results.
    // starts with page 1 or whatever was provided (eg. to start on page 7)
    async txSearchAll(params) {
        let page = params.page || 1;
        const txs = [];
        let done = false;
        while(!done){
            const resp = await this.txSearch({
                ...params,
                page: page
            });
            txs.push(...resp.txs);
            if (txs.length < resp.totalCount) page++;
            else done = true;
        }
        return {
            totalCount: txs.length,
            txs: txs
        };
    }
    async validators(params) {
        const query = {
            method: $854d52a6ca83738e$var$requests.Method.Validators,
            params: params
        };
        return this.doCall(query, this.p.encodeValidators, this.r.decodeValidators);
    }
    async validatorsAll(height) {
        const validators = [];
        let page = 1;
        let done = false;
        let blockHeight = height;
        while(!done){
            const response = await this.validators({
                per_page: 50,
                height: blockHeight,
                page: page
            });
            validators.push(...response.validators);
            blockHeight = blockHeight || response.blockHeight;
            if (validators.length < response.total) page++;
            else done = true;
        }
        return {
            // NOTE: Default value is for type safety but this should always be set
            blockHeight: blockHeight ?? 0,
            count: validators.length,
            total: validators.length,
            validators: validators
        };
    }
    // doCall is a helper to handle the encode/call/decode logic
    async doCall(request, encode, decode) {
        const req = encode(request);
        const result = await this.client.execute(req);
        return decode(result);
    }
    subscribe(request, decode) {
        if (!(0, $iPMHy.instanceOfRpcStreamingClient)(this.client)) throw new Error("This RPC client type cannot subscribe to events");
        const req = this.p.encodeSubscribe(request);
        const eventStream = this.client.listen(req);
        return eventStream.map((event)=>{
            return decode(event);
        });
    }
}
module.exports.Tendermint37Client = $854d52a6ca83738e$var$Tendermint37Client;

});
parcelRequire.register("6tXZL", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.adaptor37 = void 0;

var $14psD = parcelRequire("14psD");

var $3Brd9 = parcelRequire("3Brd9");

var $k2sdS = parcelRequire("k2sdS");
module.exports.adaptor37 = {
    params: $3Brd9.Params,
    responses: $k2sdS.Responses,
    hashTx: $14psD.hashTx,
    hashBlock: $14psD.hashBlock
};

});
parcelRequire.register("14psD", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.hashBlock = module.exports.hashTx = void 0;

var $6f1ux = parcelRequire("6f1ux");

var $1zfZz = parcelRequire("1zfZz");
// hash is sha256
// https://github.com/tendermint/tendermint/blob/master/UPGRADING.md#v0260
function $0c79ea2748ed3151$var$hashTx(tx) {
    return (0, $6f1ux.sha256)(tx);
}
module.exports.hashTx = $0c79ea2748ed3151$var$hashTx;
function $0c79ea2748ed3151$var$getSplitPoint(n) {
    if (n < 1) throw new Error("Cannot split an empty tree");
    const largestPowerOf2 = 2 ** Math.floor(Math.log2(n));
    return largestPowerOf2 < n ? largestPowerOf2 : largestPowerOf2 / 2;
}
function $0c79ea2748ed3151$var$hashLeaf(leaf) {
    const hash = new $6f1ux.Sha256(Uint8Array.from([
        0
    ]));
    hash.update(leaf);
    return hash.digest();
}
function $0c79ea2748ed3151$var$hashInner(left, right) {
    const hash = new $6f1ux.Sha256(Uint8Array.from([
        1
    ]));
    hash.update(left);
    hash.update(right);
    return hash.digest();
}
// See https://github.com/tendermint/tendermint/blob/v0.31.8/docs/spec/blockchain/encoding.md#merkleroot
// Note: the hashes input may not actually be hashes, especially before a recursive call
function $0c79ea2748ed3151$var$hashTree(hashes) {
    switch(hashes.length){
        case 0:
            throw new Error("Cannot hash empty tree");
        case 1:
            return $0c79ea2748ed3151$var$hashLeaf(hashes[0]);
        default:
            {
                const slicePoint = $0c79ea2748ed3151$var$getSplitPoint(hashes.length);
                const left = $0c79ea2748ed3151$var$hashTree(hashes.slice(0, slicePoint));
                const right = $0c79ea2748ed3151$var$hashTree(hashes.slice(slicePoint));
                return $0c79ea2748ed3151$var$hashInner(left, right);
            }
    }
}
function $0c79ea2748ed3151$var$hashBlock(header) {
    if (!header.lastBlockId) throw new Error("Hashing a block header with no last block ID (i.e. header at height 1) is not supported. If you need this, contributions are welcome. Please add documentation and test vectors for this case.");
    const encodedFields = [
        (0, $1zfZz.encodeVersion)(header.version),
        (0, $1zfZz.encodeString)(header.chainId),
        (0, $1zfZz.encodeUvarint)(header.height),
        (0, $1zfZz.encodeTime)(header.time),
        (0, $1zfZz.encodeBlockId)(header.lastBlockId),
        (0, $1zfZz.encodeBytes)(header.lastCommitHash),
        (0, $1zfZz.encodeBytes)(header.dataHash),
        (0, $1zfZz.encodeBytes)(header.validatorsHash),
        (0, $1zfZz.encodeBytes)(header.nextValidatorsHash),
        (0, $1zfZz.encodeBytes)(header.consensusHash),
        (0, $1zfZz.encodeBytes)(header.appHash),
        (0, $1zfZz.encodeBytes)(header.lastResultsHash),
        (0, $1zfZz.encodeBytes)(header.evidenceHash),
        (0, $1zfZz.encodeBytes)(header.proposerAddress)
    ];
    return $0c79ea2748ed3151$var$hashTree(encodedFields);
}
module.exports.hashBlock = $0c79ea2748ed3151$var$hashBlock;

});
parcelRequire.register("1zfZz", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.encodeBlockId = module.exports.encodeVersion = module.exports.encodeBytes = module.exports.encodeTime = module.exports.encodeUvarint = module.exports.encodeString = module.exports.dictionaryToStringMap = module.exports.may = module.exports.assertNotEmpty = module.exports.assertObject = module.exports.assertArray = module.exports.assertNumber = module.exports.assertString = module.exports.assertBoolean = module.exports.assertSet = void 0;

var $6XcLW = parcelRequire("6XcLW");
/**
 * A runtime checker that ensures a given value is set (i.e. not undefined or null)
 *
 * This is used when you want to verify that data at runtime matches the expected type.
 */ function $1245770a85d56a42$var$assertSet(value) {
    if (value === undefined) throw new Error("Value must not be undefined");
    if (value === null) throw new Error("Value must not be null");
    return value;
}
module.exports.assertSet = $1245770a85d56a42$var$assertSet;
/**
 * A runtime checker that ensures a given value is a boolean
 *
 * This is used when you want to verify that data at runtime matches the expected type.
 * This implies assertSet.
 */ function $1245770a85d56a42$var$assertBoolean(value) {
    $1245770a85d56a42$var$assertSet(value);
    if (typeof value !== "boolean") throw new Error("Value must be a boolean");
    return value;
}
module.exports.assertBoolean = $1245770a85d56a42$var$assertBoolean;
/**
 * A runtime checker that ensures a given value is a string.
 *
 * This is used when you want to verify that data at runtime matches the expected type.
 * This implies assertSet.
 */ function $1245770a85d56a42$var$assertString(value) {
    $1245770a85d56a42$var$assertSet(value);
    if (typeof value !== "string") throw new Error("Value must be a string");
    return value;
}
module.exports.assertString = $1245770a85d56a42$var$assertString;
/**
 * A runtime checker that ensures a given value is a number
 *
 * This is used when you want to verify that data at runtime matches the expected type.
 * This implies assertSet.
 */ function $1245770a85d56a42$var$assertNumber(value) {
    $1245770a85d56a42$var$assertSet(value);
    if (typeof value !== "number") throw new Error("Value must be a number");
    return value;
}
module.exports.assertNumber = $1245770a85d56a42$var$assertNumber;
/**
 * A runtime checker that ensures a given value is an array
 *
 * This is used when you want to verify that data at runtime matches the expected type.
 * This implies assertSet.
 */ function $1245770a85d56a42$var$assertArray(value) {
    $1245770a85d56a42$var$assertSet(value);
    if (!Array.isArray(value)) throw new Error("Value must be a an array");
    return value;
}
module.exports.assertArray = $1245770a85d56a42$var$assertArray;
/**
 * A runtime checker that ensures a given value is an object in the sense of JSON
 * (an unordered collection of key–value pairs where the keys are strings)
 *
 * This is used when you want to verify that data at runtime matches the expected type.
 * This implies assertSet.
 */ function $1245770a85d56a42$var$assertObject(value) {
    $1245770a85d56a42$var$assertSet(value);
    if (typeof value !== "object") throw new Error("Value must be an object");
    // Exclude special kind of objects like Array, Date or Uint8Array
    // Object.prototype.toString() returns a specified value:
    // http://www.ecma-international.org/ecma-262/7.0/index.html#sec-object.prototype.tostring
    if (Object.prototype.toString.call(value) !== "[object Object]") throw new Error("Value must be a simple object");
    return value;
}
module.exports.assertObject = $1245770a85d56a42$var$assertObject;
/**
 * Throws an error if value matches the empty value for the
 * given type (array/string of length 0, number of value 0, ...)
 *
 * Otherwise returns the value.
 *
 * This implies assertSet
 */ function $1245770a85d56a42$var$assertNotEmpty(value) {
    $1245770a85d56a42$var$assertSet(value);
    if (typeof value === "number" && value === 0) throw new Error("must provide a non-zero value");
    else if (value.length === 0) throw new Error("must provide a non-empty value");
    return value;
}
module.exports.assertNotEmpty = $1245770a85d56a42$var$assertNotEmpty;
// may will run the transform if value is defined, otherwise returns undefined
function $1245770a85d56a42$var$may(transform, value) {
    return value === undefined || value === null ? undefined : transform(value);
}
module.exports.may = $1245770a85d56a42$var$may;
function $1245770a85d56a42$var$dictionaryToStringMap(obj) {
    const out = new Map();
    for (const key of Object.keys(obj)){
        const value = obj[key];
        if (typeof value !== "string") throw new Error("Found dictionary value of type other than string");
        out.set(key, value);
    }
    return out;
}
module.exports.dictionaryToStringMap = $1245770a85d56a42$var$dictionaryToStringMap;
// Encodings needed for hashing block headers
// Several of these functions are inspired by https://github.com/nomic-io/js-tendermint/blob/tendermint-0.30/src/
// See https://github.com/tendermint/go-amino/blob/v0.15.0/encoder.go#L193-L195
function $1245770a85d56a42$var$encodeString(s) {
    const utf8 = (0, $6XcLW.toUtf8)(s);
    return Uint8Array.from([
        utf8.length,
        ...utf8
    ]);
}
module.exports.encodeString = $1245770a85d56a42$var$encodeString;
// See https://github.com/tendermint/go-amino/blob/v0.15.0/encoder.go#L79-L87
function $1245770a85d56a42$var$encodeUvarint(n) {
    return n >= 0x80 ? Uint8Array.from([
        n & 0xff | 0x80,
        ...$1245770a85d56a42$var$encodeUvarint(n >> 7)
    ]) : Uint8Array.from([
        n & 0xff
    ]);
}
module.exports.encodeUvarint = $1245770a85d56a42$var$encodeUvarint;
// See https://github.com/tendermint/go-amino/blob/v0.15.0/encoder.go#L134-L178
function $1245770a85d56a42$var$encodeTime(time) {
    const milliseconds = time.getTime();
    const seconds = Math.floor(milliseconds / 1000);
    const secondsArray = seconds ? [
        0x08,
        ...$1245770a85d56a42$var$encodeUvarint(seconds)
    ] : new Uint8Array();
    const nanoseconds = (time.nanoseconds || 0) + milliseconds % 1000 * 1e6;
    const nanosecondsArray = nanoseconds ? [
        0x10,
        ...$1245770a85d56a42$var$encodeUvarint(nanoseconds)
    ] : new Uint8Array();
    return Uint8Array.from([
        ...secondsArray,
        ...nanosecondsArray
    ]);
}
module.exports.encodeTime = $1245770a85d56a42$var$encodeTime;
// See https://github.com/tendermint/go-amino/blob/v0.15.0/encoder.go#L180-L187
function $1245770a85d56a42$var$encodeBytes(bytes) {
    // Since we're only dealing with short byte arrays we don't need a full VarBuffer implementation yet
    if (bytes.length >= 0x80) throw new Error("Not implemented for byte arrays of length 128 or more");
    return bytes.length ? Uint8Array.from([
        bytes.length,
        ...bytes
    ]) : new Uint8Array();
}
module.exports.encodeBytes = $1245770a85d56a42$var$encodeBytes;
function $1245770a85d56a42$var$encodeVersion(version) {
    const blockArray = version.block ? Uint8Array.from([
        0x08,
        ...$1245770a85d56a42$var$encodeUvarint(version.block)
    ]) : new Uint8Array();
    const appArray = version.app ? Uint8Array.from([
        0x10,
        ...$1245770a85d56a42$var$encodeUvarint(version.app)
    ]) : new Uint8Array();
    return Uint8Array.from([
        ...blockArray,
        ...appArray
    ]);
}
module.exports.encodeVersion = $1245770a85d56a42$var$encodeVersion;
function $1245770a85d56a42$var$encodeBlockId(blockId) {
    return Uint8Array.from([
        0x0a,
        blockId.hash.length,
        ...blockId.hash,
        0x12,
        blockId.parts.hash.length + 4,
        0x08,
        blockId.parts.total,
        0x12,
        blockId.parts.hash.length,
        ...blockId.parts.hash
    ]);
}
module.exports.encodeBlockId = $1245770a85d56a42$var$encodeBlockId;

});


parcelRequire.register("3Brd9", function(module, exports) {
"use strict";
var $29f9ef5951cb303c$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $29f9ef5951cb303c$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $29f9ef5951cb303c$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $29f9ef5951cb303c$var$__createBinding(result, mod, k);
    }
    $29f9ef5951cb303c$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Params = void 0;

var $6XcLW = parcelRequire("6XcLW");

var $9EsCA = parcelRequire("9EsCA");

var $2O5kv = parcelRequire("2O5kv");

var $1zfZz = parcelRequire("1zfZz");

const $29f9ef5951cb303c$var$requests = $29f9ef5951cb303c$var$__importStar((parcelRequire("jinUz")));
function $29f9ef5951cb303c$var$encodeHeightParam(param) {
    return {
        height: (0, $1zfZz.may)($9EsCA.smallIntToApi, param.height)
    };
}
function $29f9ef5951cb303c$var$encodeBlockchainRequestParams(param) {
    return {
        minHeight: (0, $1zfZz.may)($9EsCA.smallIntToApi, param.minHeight),
        maxHeight: (0, $1zfZz.may)($9EsCA.smallIntToApi, param.maxHeight)
    };
}
function $29f9ef5951cb303c$var$encodeBlockSearchParams(params) {
    return {
        query: params.query,
        page: (0, $1zfZz.may)($9EsCA.smallIntToApi, params.page),
        per_page: (0, $1zfZz.may)($9EsCA.smallIntToApi, params.per_page),
        order_by: params.order_by
    };
}
function $29f9ef5951cb303c$var$encodeAbciQueryParams(params) {
    return {
        path: (0, $1zfZz.assertNotEmpty)(params.path),
        data: (0, $6XcLW.toHex)(params.data),
        height: (0, $1zfZz.may)($9EsCA.smallIntToApi, params.height),
        prove: params.prove
    };
}
function $29f9ef5951cb303c$var$encodeBroadcastTxParams(params) {
    return {
        tx: (0, $6XcLW.toBase64)((0, $1zfZz.assertNotEmpty)(params.tx))
    };
}
function $29f9ef5951cb303c$var$encodeTxParams(params) {
    return {
        hash: (0, $6XcLW.toBase64)((0, $1zfZz.assertNotEmpty)(params.hash)),
        prove: params.prove
    };
}
function $29f9ef5951cb303c$var$encodeTxSearchParams(params) {
    return {
        query: params.query,
        prove: params.prove,
        page: (0, $1zfZz.may)($9EsCA.smallIntToApi, params.page),
        per_page: (0, $1zfZz.may)($9EsCA.smallIntToApi, params.per_page),
        order_by: params.order_by
    };
}
function $29f9ef5951cb303c$var$encodeValidatorsParams(params) {
    return {
        height: (0, $1zfZz.may)($9EsCA.smallIntToApi, params.height),
        page: (0, $1zfZz.may)($9EsCA.smallIntToApi, params.page),
        per_page: (0, $1zfZz.may)($9EsCA.smallIntToApi, params.per_page)
    };
}
class $29f9ef5951cb303c$var$Params {
    static encodeAbciInfo(req) {
        return (0, $2O5kv.createJsonRpcRequest)(req.method);
    }
    static encodeAbciQuery(req) {
        return (0, $2O5kv.createJsonRpcRequest)(req.method, $29f9ef5951cb303c$var$encodeAbciQueryParams(req.params));
    }
    static encodeBlock(req) {
        return (0, $2O5kv.createJsonRpcRequest)(req.method, $29f9ef5951cb303c$var$encodeHeightParam(req.params));
    }
    static encodeBlockchain(req) {
        return (0, $2O5kv.createJsonRpcRequest)(req.method, $29f9ef5951cb303c$var$encodeBlockchainRequestParams(req.params));
    }
    static encodeBlockResults(req) {
        return (0, $2O5kv.createJsonRpcRequest)(req.method, $29f9ef5951cb303c$var$encodeHeightParam(req.params));
    }
    static encodeBlockSearch(req) {
        return (0, $2O5kv.createJsonRpcRequest)(req.method, $29f9ef5951cb303c$var$encodeBlockSearchParams(req.params));
    }
    static encodeBroadcastTx(req) {
        return (0, $2O5kv.createJsonRpcRequest)(req.method, $29f9ef5951cb303c$var$encodeBroadcastTxParams(req.params));
    }
    static encodeCommit(req) {
        return (0, $2O5kv.createJsonRpcRequest)(req.method, $29f9ef5951cb303c$var$encodeHeightParam(req.params));
    }
    static encodeGenesis(req) {
        return (0, $2O5kv.createJsonRpcRequest)(req.method);
    }
    static encodeHealth(req) {
        return (0, $2O5kv.createJsonRpcRequest)(req.method);
    }
    static encodeNumUnconfirmedTxs(req) {
        return (0, $2O5kv.createJsonRpcRequest)(req.method);
    }
    static encodeStatus(req) {
        return (0, $2O5kv.createJsonRpcRequest)(req.method);
    }
    static encodeSubscribe(req) {
        const eventTag = {
            key: "tm.event",
            value: req.query.type
        };
        const query = $29f9ef5951cb303c$var$requests.buildQuery({
            tags: [
                eventTag
            ],
            raw: req.query.raw
        });
        return (0, $2O5kv.createJsonRpcRequest)("subscribe", {
            query: query
        });
    }
    static encodeTx(req) {
        return (0, $2O5kv.createJsonRpcRequest)(req.method, $29f9ef5951cb303c$var$encodeTxParams(req.params));
    }
    // TODO: encode params for query string???
    static encodeTxSearch(req) {
        return (0, $2O5kv.createJsonRpcRequest)(req.method, $29f9ef5951cb303c$var$encodeTxSearchParams(req.params));
    }
    static encodeValidators(req) {
        return (0, $2O5kv.createJsonRpcRequest)(req.method, $29f9ef5951cb303c$var$encodeValidatorsParams(req.params));
    }
}
module.exports.Params = $29f9ef5951cb303c$var$Params;

});

parcelRequire.register("k2sdS", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Responses = module.exports.decodeValidatorInfo = module.exports.decodeValidatorGenesis = module.exports.decodeValidatorUpdate = module.exports.decodeEvent = void 0;

var $6XcLW = parcelRequire("6XcLW");

var $fZwG5 = parcelRequire("fZwG5");

var $2Sgxm = parcelRequire("2Sgxm");

var $9EsCA = parcelRequire("9EsCA");

var $dVoCS = parcelRequire("dVoCS");

var $1zfZz = parcelRequire("1zfZz");

var $14psD = parcelRequire("14psD");
function $e969e30605916aec$var$decodeAbciInfo(data) {
    return {
        data: data.data,
        lastBlockHeight: (0, $1zfZz.may)($9EsCA.apiToSmallInt, data.last_block_height),
        lastBlockAppHash: (0, $1zfZz.may)($6XcLW.fromBase64, data.last_block_app_hash)
    };
}
function $e969e30605916aec$var$decodeQueryProof(data) {
    return {
        ops: data.ops.map((op)=>({
                type: op.type,
                key: (0, $6XcLW.fromBase64)(op.key),
                data: (0, $6XcLW.fromBase64)(op.data)
            }))
    };
}
function $e969e30605916aec$var$decodeAbciQuery(data) {
    return {
        key: (0, $6XcLW.fromBase64)((0, $1zfZz.assertString)(data.key ?? "")),
        value: (0, $6XcLW.fromBase64)((0, $1zfZz.assertString)(data.value ?? "")),
        proof: (0, $1zfZz.may)($e969e30605916aec$var$decodeQueryProof, data.proofOps),
        height: (0, $1zfZz.may)($9EsCA.apiToSmallInt, data.height),
        code: (0, $1zfZz.may)($9EsCA.apiToSmallInt, data.code),
        codespace: (0, $1zfZz.assertString)(data.codespace ?? ""),
        index: (0, $1zfZz.may)($9EsCA.apiToSmallInt, data.index),
        log: data.log,
        info: (0, $1zfZz.assertString)(data.info ?? "")
    };
}
function $e969e30605916aec$var$decodeEventAttribute(attribute) {
    return {
        key: (0, $1zfZz.assertNotEmpty)(attribute.key),
        value: attribute.value ?? ""
    };
}
function $e969e30605916aec$var$decodeAttributes(attributes) {
    return (0, $1zfZz.assertArray)(attributes).map($e969e30605916aec$var$decodeEventAttribute);
}
function $e969e30605916aec$var$decodeEvent(event) {
    return {
        type: event.type,
        attributes: event.attributes ? $e969e30605916aec$var$decodeAttributes(event.attributes) : []
    };
}
module.exports.decodeEvent = $e969e30605916aec$var$decodeEvent;
function $e969e30605916aec$var$decodeEvents(events) {
    return (0, $1zfZz.assertArray)(events).map($e969e30605916aec$var$decodeEvent);
}
function $e969e30605916aec$var$decodeTxData(data) {
    return {
        code: (0, $9EsCA.apiToSmallInt)((0, $1zfZz.assertNumber)(data.code ?? 0)),
        codespace: data.codespace,
        log: data.log,
        data: (0, $1zfZz.may)($6XcLW.fromBase64, data.data),
        events: data.events ? $e969e30605916aec$var$decodeEvents(data.events) : [],
        gasWanted: (0, $9EsCA.apiToSmallInt)(data.gas_wanted ?? "0"),
        gasUsed: (0, $9EsCA.apiToSmallInt)(data.gas_used ?? "0")
    };
}
function $e969e30605916aec$var$decodePubkey(data) {
    if ("Sum" in data) {
        // we don't need to check type because we're checking algorithm
        const [[algorithm, value]] = Object.entries(data.Sum.value);
        (0, $fZwG5.assert)(algorithm === "ed25519" || algorithm === "secp256k1", `unknown pubkey type: ${algorithm}`);
        return {
            algorithm: algorithm,
            data: (0, $6XcLW.fromBase64)((0, $1zfZz.assertNotEmpty)(value))
        };
    } else switch(data.type){
        // go-amino special code
        case "tendermint/PubKeyEd25519":
            return {
                algorithm: "ed25519",
                data: (0, $6XcLW.fromBase64)((0, $1zfZz.assertNotEmpty)(data.value))
            };
        case "tendermint/PubKeySecp256k1":
            return {
                algorithm: "secp256k1",
                data: (0, $6XcLW.fromBase64)((0, $1zfZz.assertNotEmpty)(data.value))
            };
        default:
            throw new Error(`unknown pubkey type: ${data.type}`);
    }
}
/**
 * Note: we do not parse block.time_iota_ms for now because of this CHANGELOG entry
 *
 * > Add time_iota_ms to block's consensus parameters (not exposed to the application)
 * https://github.com/tendermint/tendermint/blob/master/CHANGELOG.md#v0310
 */ function $e969e30605916aec$var$decodeBlockParams(data) {
    return {
        maxBytes: (0, $9EsCA.apiToSmallInt)((0, $1zfZz.assertNotEmpty)(data.max_bytes)),
        maxGas: (0, $9EsCA.apiToSmallInt)((0, $1zfZz.assertNotEmpty)(data.max_gas))
    };
}
function $e969e30605916aec$var$decodeEvidenceParams(data) {
    return {
        maxAgeNumBlocks: (0, $9EsCA.apiToSmallInt)((0, $1zfZz.assertNotEmpty)(data.max_age_num_blocks)),
        maxAgeDuration: (0, $9EsCA.apiToSmallInt)((0, $1zfZz.assertNotEmpty)(data.max_age_duration))
    };
}
function $e969e30605916aec$var$decodeConsensusParams(data) {
    return {
        block: $e969e30605916aec$var$decodeBlockParams((0, $1zfZz.assertObject)(data.block)),
        evidence: $e969e30605916aec$var$decodeEvidenceParams((0, $1zfZz.assertObject)(data.evidence))
    };
}
function $e969e30605916aec$var$decodeValidatorUpdate(data) {
    return {
        pubkey: $e969e30605916aec$var$decodePubkey((0, $1zfZz.assertObject)(data.pub_key)),
        votingPower: (0, $9EsCA.apiToBigInt)(data.power ?? "0")
    };
}
module.exports.decodeValidatorUpdate = $e969e30605916aec$var$decodeValidatorUpdate;
function $e969e30605916aec$var$decodeBlockResults(data) {
    return {
        height: (0, $9EsCA.apiToSmallInt)((0, $1zfZz.assertNotEmpty)(data.height)),
        results: (data.txs_results || []).map($e969e30605916aec$var$decodeTxData),
        validatorUpdates: (data.validator_updates || []).map($e969e30605916aec$var$decodeValidatorUpdate),
        consensusUpdates: (0, $1zfZz.may)($e969e30605916aec$var$decodeConsensusParams, data.consensus_param_updates),
        beginBlockEvents: $e969e30605916aec$var$decodeEvents(data.begin_block_events || []),
        endBlockEvents: $e969e30605916aec$var$decodeEvents(data.end_block_events || [])
    };
}
function $e969e30605916aec$var$decodeBlockId(data) {
    return {
        hash: (0, $6XcLW.fromHex)((0, $1zfZz.assertNotEmpty)(data.hash)),
        parts: {
            total: (0, $1zfZz.assertNotEmpty)(data.parts.total),
            hash: (0, $6XcLW.fromHex)((0, $1zfZz.assertNotEmpty)(data.parts.hash))
        }
    };
}
function $e969e30605916aec$var$decodeBlockVersion(data) {
    return {
        block: (0, $9EsCA.apiToSmallInt)(data.block),
        app: (0, $9EsCA.apiToSmallInt)(data.app ?? 0)
    };
}
function $e969e30605916aec$var$decodeHeader(data) {
    return {
        version: $e969e30605916aec$var$decodeBlockVersion(data.version),
        chainId: (0, $1zfZz.assertNotEmpty)(data.chain_id),
        height: (0, $9EsCA.apiToSmallInt)((0, $1zfZz.assertNotEmpty)(data.height)),
        time: (0, $2Sgxm.fromRfc3339WithNanoseconds)((0, $1zfZz.assertNotEmpty)(data.time)),
        // When there is no last block ID (i.e. this block's height is 1), we get an empty structure like this:
        // { hash: '', parts: { total: 0, hash: '' } }
        lastBlockId: data.last_block_id.hash ? $e969e30605916aec$var$decodeBlockId(data.last_block_id) : null,
        lastCommitHash: (0, $6XcLW.fromHex)((0, $1zfZz.assertSet)(data.last_commit_hash)),
        dataHash: (0, $6XcLW.fromHex)((0, $1zfZz.assertSet)(data.data_hash)),
        validatorsHash: (0, $6XcLW.fromHex)((0, $1zfZz.assertSet)(data.validators_hash)),
        nextValidatorsHash: (0, $6XcLW.fromHex)((0, $1zfZz.assertSet)(data.next_validators_hash)),
        consensusHash: (0, $6XcLW.fromHex)((0, $1zfZz.assertSet)(data.consensus_hash)),
        appHash: (0, $6XcLW.fromHex)((0, $1zfZz.assertSet)(data.app_hash)),
        lastResultsHash: (0, $6XcLW.fromHex)((0, $1zfZz.assertSet)(data.last_results_hash)),
        evidenceHash: (0, $6XcLW.fromHex)((0, $1zfZz.assertSet)(data.evidence_hash)),
        proposerAddress: (0, $6XcLW.fromHex)((0, $1zfZz.assertNotEmpty)(data.proposer_address))
    };
}
function $e969e30605916aec$var$decodeBlockMeta(data) {
    return {
        blockId: $e969e30605916aec$var$decodeBlockId(data.block_id),
        blockSize: (0, $9EsCA.apiToSmallInt)((0, $1zfZz.assertNotEmpty)(data.block_size)),
        header: $e969e30605916aec$var$decodeHeader(data.header),
        numTxs: (0, $9EsCA.apiToSmallInt)((0, $1zfZz.assertNotEmpty)(data.num_txs))
    };
}
function $e969e30605916aec$var$decodeBlockchain(data) {
    return {
        lastHeight: (0, $9EsCA.apiToSmallInt)((0, $1zfZz.assertNotEmpty)(data.last_height)),
        blockMetas: (0, $1zfZz.assertArray)(data.block_metas).map($e969e30605916aec$var$decodeBlockMeta)
    };
}
function $e969e30605916aec$var$decodeBroadcastTxSync(data) {
    return {
        ...$e969e30605916aec$var$decodeTxData(data),
        hash: (0, $6XcLW.fromHex)((0, $1zfZz.assertNotEmpty)(data.hash))
    };
}
function $e969e30605916aec$var$decodeBroadcastTxCommit(data) {
    return {
        height: (0, $9EsCA.apiToSmallInt)(data.height),
        hash: (0, $6XcLW.fromHex)((0, $1zfZz.assertNotEmpty)(data.hash)),
        checkTx: $e969e30605916aec$var$decodeTxData((0, $1zfZz.assertObject)(data.check_tx)),
        deliverTx: (0, $1zfZz.may)($e969e30605916aec$var$decodeTxData, data.deliver_tx)
    };
}
function $e969e30605916aec$var$decodeBlockIdFlag(blockIdFlag) {
    (0, $fZwG5.assert)(blockIdFlag in $dVoCS.BlockIdFlag);
    return blockIdFlag;
}
/**
 * In some cases a timestamp is optional and set to the value 0 in Go.
 * This can lead to strings like "0001-01-01T00:00:00Z" (see https://github.com/cosmos/cosmjs/issues/704#issuecomment-797122415).
 * This decoder tries to clean up such encoding from the API and turn them
 * into undefined values.
 */ function $e969e30605916aec$var$decodeOptionalTime(timestamp) {
    const nonZeroTime = timestamp && !timestamp.startsWith("0001-01-01");
    return nonZeroTime ? (0, $2Sgxm.fromRfc3339WithNanoseconds)(timestamp) : undefined;
}
function $e969e30605916aec$var$decodeCommitSignature(data) {
    return {
        blockIdFlag: $e969e30605916aec$var$decodeBlockIdFlag(data.block_id_flag),
        validatorAddress: data.validator_address ? (0, $6XcLW.fromHex)(data.validator_address) : undefined,
        timestamp: $e969e30605916aec$var$decodeOptionalTime(data.timestamp),
        signature: data.signature ? (0, $6XcLW.fromBase64)(data.signature) : undefined
    };
}
function $e969e30605916aec$var$decodeCommit(data) {
    return {
        blockId: $e969e30605916aec$var$decodeBlockId((0, $1zfZz.assertObject)(data.block_id)),
        height: (0, $9EsCA.apiToSmallInt)((0, $1zfZz.assertNotEmpty)(data.height)),
        round: (0, $9EsCA.apiToSmallInt)(data.round),
        signatures: (0, $1zfZz.assertArray)(data.signatures).map($e969e30605916aec$var$decodeCommitSignature)
    };
}
function $e969e30605916aec$var$decodeCommitResponse(data) {
    return {
        canonical: (0, $1zfZz.assertBoolean)(data.canonical),
        header: $e969e30605916aec$var$decodeHeader(data.signed_header.header),
        commit: $e969e30605916aec$var$decodeCommit(data.signed_header.commit)
    };
}
function $e969e30605916aec$var$decodeValidatorGenesis(data) {
    return {
        address: (0, $6XcLW.fromHex)((0, $1zfZz.assertNotEmpty)(data.address)),
        pubkey: $e969e30605916aec$var$decodePubkey((0, $1zfZz.assertObject)(data.pub_key)),
        votingPower: (0, $9EsCA.apiToBigInt)((0, $1zfZz.assertNotEmpty)(data.power))
    };
}
module.exports.decodeValidatorGenesis = $e969e30605916aec$var$decodeValidatorGenesis;
function $e969e30605916aec$var$decodeGenesis(data) {
    return {
        genesisTime: (0, $2Sgxm.fromRfc3339WithNanoseconds)((0, $1zfZz.assertNotEmpty)(data.genesis_time)),
        chainId: (0, $1zfZz.assertNotEmpty)(data.chain_id),
        consensusParams: $e969e30605916aec$var$decodeConsensusParams(data.consensus_params),
        validators: data.validators ? (0, $1zfZz.assertArray)(data.validators).map($e969e30605916aec$var$decodeValidatorGenesis) : [],
        appHash: (0, $6XcLW.fromHex)((0, $1zfZz.assertSet)(data.app_hash)),
        appState: data.app_state
    };
}
function $e969e30605916aec$var$decodeValidatorInfo(data) {
    return {
        pubkey: $e969e30605916aec$var$decodePubkey((0, $1zfZz.assertObject)(data.pub_key)),
        votingPower: (0, $9EsCA.apiToBigInt)((0, $1zfZz.assertNotEmpty)(data.voting_power)),
        address: (0, $6XcLW.fromHex)((0, $1zfZz.assertNotEmpty)(data.address)),
        proposerPriority: data.proposer_priority ? (0, $9EsCA.apiToSmallInt)(data.proposer_priority) : undefined
    };
}
module.exports.decodeValidatorInfo = $e969e30605916aec$var$decodeValidatorInfo;
function $e969e30605916aec$var$decodeNodeInfo(data) {
    return {
        id: (0, $6XcLW.fromHex)((0, $1zfZz.assertNotEmpty)(data.id)),
        listenAddr: (0, $1zfZz.assertNotEmpty)(data.listen_addr),
        network: (0, $1zfZz.assertNotEmpty)(data.network),
        version: (0, $1zfZz.assertString)(data.version),
        channels: (0, $1zfZz.assertNotEmpty)(data.channels),
        moniker: (0, $1zfZz.assertNotEmpty)(data.moniker),
        other: (0, $1zfZz.dictionaryToStringMap)(data.other),
        protocolVersion: {
            app: (0, $9EsCA.apiToSmallInt)((0, $1zfZz.assertNotEmpty)(data.protocol_version.app)),
            block: (0, $9EsCA.apiToSmallInt)((0, $1zfZz.assertNotEmpty)(data.protocol_version.block)),
            p2p: (0, $9EsCA.apiToSmallInt)((0, $1zfZz.assertNotEmpty)(data.protocol_version.p2p))
        }
    };
}
function $e969e30605916aec$var$decodeSyncInfo(data) {
    const earliestBlockHeight = data.earliest_block_height ? (0, $9EsCA.apiToSmallInt)(data.earliest_block_height) : undefined;
    const earliestBlockTime = data.earliest_block_time ? (0, $2Sgxm.fromRfc3339WithNanoseconds)(data.earliest_block_time) : undefined;
    return {
        earliestAppHash: data.earliest_app_hash ? (0, $6XcLW.fromHex)(data.earliest_app_hash) : undefined,
        earliestBlockHash: data.earliest_block_hash ? (0, $6XcLW.fromHex)(data.earliest_block_hash) : undefined,
        earliestBlockHeight: earliestBlockHeight || undefined,
        earliestBlockTime: earliestBlockTime?.getTime() ? earliestBlockTime : undefined,
        latestBlockHash: (0, $6XcLW.fromHex)((0, $1zfZz.assertNotEmpty)(data.latest_block_hash)),
        latestAppHash: (0, $6XcLW.fromHex)((0, $1zfZz.assertNotEmpty)(data.latest_app_hash)),
        latestBlockTime: (0, $2Sgxm.fromRfc3339WithNanoseconds)((0, $1zfZz.assertNotEmpty)(data.latest_block_time)),
        latestBlockHeight: (0, $9EsCA.apiToSmallInt)((0, $1zfZz.assertNotEmpty)(data.latest_block_height)),
        catchingUp: (0, $1zfZz.assertBoolean)(data.catching_up)
    };
}
function $e969e30605916aec$var$decodeStatus(data) {
    return {
        nodeInfo: $e969e30605916aec$var$decodeNodeInfo(data.node_info),
        syncInfo: $e969e30605916aec$var$decodeSyncInfo(data.sync_info),
        validatorInfo: $e969e30605916aec$var$decodeValidatorInfo(data.validator_info)
    };
}
function $e969e30605916aec$var$decodeTxProof(data) {
    return {
        data: (0, $6XcLW.fromBase64)((0, $1zfZz.assertNotEmpty)(data.data)),
        rootHash: (0, $6XcLW.fromHex)((0, $1zfZz.assertNotEmpty)(data.root_hash)),
        proof: {
            total: (0, $9EsCA.apiToSmallInt)((0, $1zfZz.assertNotEmpty)(data.proof.total)),
            index: (0, $9EsCA.apiToSmallInt)((0, $1zfZz.assertNotEmpty)(data.proof.index)),
            leafHash: (0, $6XcLW.fromBase64)((0, $1zfZz.assertNotEmpty)(data.proof.leaf_hash)),
            aunts: (0, $1zfZz.assertArray)(data.proof.aunts).map($6XcLW.fromBase64)
        }
    };
}
function $e969e30605916aec$var$decodeTxResponse(data) {
    return {
        tx: (0, $6XcLW.fromBase64)((0, $1zfZz.assertNotEmpty)(data.tx)),
        result: $e969e30605916aec$var$decodeTxData((0, $1zfZz.assertObject)(data.tx_result)),
        height: (0, $9EsCA.apiToSmallInt)((0, $1zfZz.assertNotEmpty)(data.height)),
        index: (0, $9EsCA.apiToSmallInt)((0, $1zfZz.assertNumber)(data.index)),
        hash: (0, $6XcLW.fromHex)((0, $1zfZz.assertNotEmpty)(data.hash)),
        proof: (0, $1zfZz.may)($e969e30605916aec$var$decodeTxProof, data.proof)
    };
}
function $e969e30605916aec$var$decodeTxSearch(data) {
    return {
        totalCount: (0, $9EsCA.apiToSmallInt)((0, $1zfZz.assertNotEmpty)(data.total_count)),
        txs: (0, $1zfZz.assertArray)(data.txs).map($e969e30605916aec$var$decodeTxResponse)
    };
}
function $e969e30605916aec$var$decodeTxEvent(data) {
    const tx = (0, $6XcLW.fromBase64)((0, $1zfZz.assertNotEmpty)(data.tx));
    return {
        tx: tx,
        hash: (0, $14psD.hashTx)(tx),
        result: $e969e30605916aec$var$decodeTxData(data.result),
        height: (0, $9EsCA.apiToSmallInt)((0, $1zfZz.assertNotEmpty)(data.height))
    };
}
function $e969e30605916aec$var$decodeValidators(data) {
    return {
        blockHeight: (0, $9EsCA.apiToSmallInt)((0, $1zfZz.assertNotEmpty)(data.block_height)),
        validators: (0, $1zfZz.assertArray)(data.validators).map($e969e30605916aec$var$decodeValidatorInfo),
        count: (0, $9EsCA.apiToSmallInt)((0, $1zfZz.assertNotEmpty)(data.count)),
        total: (0, $9EsCA.apiToSmallInt)((0, $1zfZz.assertNotEmpty)(data.total))
    };
}
function $e969e30605916aec$var$decodeBlock(data) {
    return {
        header: $e969e30605916aec$var$decodeHeader((0, $1zfZz.assertObject)(data.header)),
        // For the block at height 1, last commit is not set. This is represented in an empty object like this:
        // { height: '0', round: 0, block_id: { hash: '', parts: [Object] }, signatures: [] }
        lastCommit: data.last_commit.block_id.hash ? $e969e30605916aec$var$decodeCommit((0, $1zfZz.assertObject)(data.last_commit)) : null,
        txs: data.data.txs ? (0, $1zfZz.assertArray)(data.data.txs).map($6XcLW.fromBase64) : [],
        // Lift up .evidence.evidence to just .evidence
        // See https://github.com/tendermint/tendermint/issues/7697
        evidence: data.evidence?.evidence ?? []
    };
}
function $e969e30605916aec$var$decodeBlockResponse(data) {
    return {
        blockId: $e969e30605916aec$var$decodeBlockId(data.block_id),
        block: $e969e30605916aec$var$decodeBlock(data.block)
    };
}
function $e969e30605916aec$var$decodeBlockSearch(data) {
    return {
        totalCount: (0, $9EsCA.apiToSmallInt)((0, $1zfZz.assertNotEmpty)(data.total_count)),
        blocks: (0, $1zfZz.assertArray)(data.blocks).map($e969e30605916aec$var$decodeBlockResponse)
    };
}
function $e969e30605916aec$var$decodeNumUnconfirmedTxs(data) {
    return {
        total: (0, $9EsCA.apiToSmallInt)((0, $1zfZz.assertNotEmpty)(data.total)),
        totalBytes: (0, $9EsCA.apiToSmallInt)((0, $1zfZz.assertNotEmpty)(data.total_bytes))
    };
}
class $e969e30605916aec$var$Responses {
    static decodeAbciInfo(response) {
        return $e969e30605916aec$var$decodeAbciInfo((0, $1zfZz.assertObject)(response.result.response));
    }
    static decodeAbciQuery(response) {
        return $e969e30605916aec$var$decodeAbciQuery((0, $1zfZz.assertObject)(response.result.response));
    }
    static decodeBlock(response) {
        return $e969e30605916aec$var$decodeBlockResponse(response.result);
    }
    static decodeBlockResults(response) {
        return $e969e30605916aec$var$decodeBlockResults(response.result);
    }
    static decodeBlockSearch(response) {
        return $e969e30605916aec$var$decodeBlockSearch(response.result);
    }
    static decodeBlockchain(response) {
        return $e969e30605916aec$var$decodeBlockchain(response.result);
    }
    static decodeBroadcastTxSync(response) {
        return $e969e30605916aec$var$decodeBroadcastTxSync(response.result);
    }
    static decodeBroadcastTxAsync(response) {
        return $e969e30605916aec$var$Responses.decodeBroadcastTxSync(response);
    }
    static decodeBroadcastTxCommit(response) {
        return $e969e30605916aec$var$decodeBroadcastTxCommit(response.result);
    }
    static decodeCommit(response) {
        return $e969e30605916aec$var$decodeCommitResponse(response.result);
    }
    static decodeGenesis(response) {
        return $e969e30605916aec$var$decodeGenesis((0, $1zfZz.assertObject)(response.result.genesis));
    }
    static decodeHealth() {
        return null;
    }
    static decodeNumUnconfirmedTxs(response) {
        return $e969e30605916aec$var$decodeNumUnconfirmedTxs(response.result);
    }
    static decodeStatus(response) {
        return $e969e30605916aec$var$decodeStatus(response.result);
    }
    static decodeNewBlockEvent(event) {
        return $e969e30605916aec$var$decodeBlock(event.data.value.block);
    }
    static decodeNewBlockHeaderEvent(event) {
        return $e969e30605916aec$var$decodeHeader(event.data.value.header);
    }
    static decodeTxEvent(event) {
        return $e969e30605916aec$var$decodeTxEvent(event.data.value.TxResult);
    }
    static decodeTx(response) {
        return $e969e30605916aec$var$decodeTxResponse(response.result);
    }
    static decodeTxSearch(response) {
        return $e969e30605916aec$var$decodeTxSearch(response.result);
    }
    static decodeValidators(response) {
        return $e969e30605916aec$var$decodeValidators(response.result);
    }
}
module.exports.Responses = $e969e30605916aec$var$Responses;

});




parcelRequire.register("dTrds", function(module, exports) {
"use strict";
var $a1d585f91ec8a1a3$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.BaseAccount = void 0;

var $3zkAb = parcelRequire("3zkAb");
class $a1d585f91ec8a1a3$var$BaseAccount {
    constructor(type, address, accountNumber, sequence){
        this.type = type;
        this.address = address;
        this.accountNumber = accountNumber;
        this.sequence = sequence;
    }
    static fetchFromRest(instance, address, // If the account doesn't exist, the result from `auth/accounts` would not have the address.
    // In this case, if `defaultBech32Address` param is provided, this will use it instead of the result from rest.
    defaultBech32Address = false) {
        return $a1d585f91ec8a1a3$var$__awaiter(this, void 0, void 0, function*() {
            const result = yield instance.get(`auth/accounts/${address}`);
            return $a1d585f91ec8a1a3$var$BaseAccount.fromAminoJSON(result.data, defaultBech32Address ? address : "");
        });
    }
    static fromAminoJSON(obj, // If the account doesn't exist, the result from `auth/accounts` would not have the address.
    // In this case, if `defaultBech32Address` param is provided, this will use it instead of the result from rest.
    defaultBech32Address = "") {
        if ("height" in obj) obj = obj.result;
        const type = obj.type || "";
        let value = "value" in obj ? obj.value : obj;
        // If the chain modifies the account type, handle the case where the account type embeds the base account.
        // (Actually, the only existent case is ethermint, and this is the line for handling ethermint)
        const baseAccount = value.BaseAccount || value.baseAccount || value.base_account;
        if (baseAccount) value = baseAccount;
        // If the account is the vesting account that embeds the base vesting account,
        // the actual base account exists under the base vesting account.
        // But, this can be different according to the version of cosmos-sdk.
        // So, anyway, try to parse it by some ways...
        const baseVestingAccount = value.BaseVestingAccount || value.baseVestingAccount || value.base_vesting_account;
        if (baseVestingAccount) value = baseVestingAccount.BaseAccount || baseVestingAccount.baseAccount || baseVestingAccount.base_account;
        let address = value.address;
        if (!address) {
            if (!defaultBech32Address) throw new Error(`Account's address is unknown: ${JSON.stringify(obj)}`);
            address = defaultBech32Address;
        }
        const accountNumber = value.account_number;
        const sequence = value.sequence;
        return new $a1d585f91ec8a1a3$var$BaseAccount(type, address, new $3zkAb.Int(accountNumber !== null && accountNumber !== void 0 ? accountNumber : "0"), new $3zkAb.Int(sequence !== null && sequence !== void 0 ? sequence : "0"));
    }
    getType() {
        return this.type;
    }
    getAddress() {
        return this.address;
    }
    getAccountNumber() {
        return this.accountNumber;
    }
    getSequence() {
        return this.sequence;
    }
}
module.exports.BaseAccount = $a1d585f91ec8a1a3$var$BaseAccount;

});
parcelRequire.register("3zkAb", function(module, exports) {
"use strict";
var $29949b4273e83309$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, {
        enumerable: true,
        get: function() {
            return m[k];
        }
    });
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $29949b4273e83309$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $29949b4273e83309$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$29949b4273e83309$var$__exportStar((parcelRequire("iHEZr")), module.exports);

$29949b4273e83309$var$__exportStar((parcelRequire("alAPZ")), module.exports);

$29949b4273e83309$var$__exportStar((parcelRequire("4GgGj")), module.exports);

$29949b4273e83309$var$__exportStar((parcelRequire("9hZKW")), module.exports);

$29949b4273e83309$var$__exportStar((parcelRequire("cSmV0")), module.exports);

$29949b4273e83309$var$__exportStar((parcelRequire("k20Vo")), module.exports);

$29949b4273e83309$var$__exportStar((parcelRequire("hZyWy")), module.exports);

$29949b4273e83309$var$__exportStar((parcelRequire("cYm4M")), module.exports);

$29949b4273e83309$var$__exportStar((parcelRequire("fDbBK")), module.exports);

});
parcelRequire.register("iHEZr", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.IntPretty = void 0;

var $9hZKW = parcelRequire("9hZKW");

var $cSmV0 = parcelRequire("cSmV0");

var $hZyWy = parcelRequire("hZyWy");

var $k20Vo = parcelRequire("k20Vo");
class $d9dc09e80584e41f$var$IntPretty {
    constructor(num){
        this.floatingDecimalPointRight = 0;
        this._options = {
            maxDecimals: 0,
            trim: false,
            shrink: false,
            ready: true,
            locale: true,
            inequalitySymbol: false,
            inequalitySymbolSeparator: " "
        };
        if (typeof num === "object" && "toDec" in num) num = num.toDec();
        else if (!(num instanceof $cSmV0.Dec)) num = new $cSmV0.Dec(num);
        if (num.isZero()) {
            this.dec = num;
            return;
        }
        let dec = num;
        let decPrecision = 0;
        for(let i = 0; i < 18; i++){
            if (!dec.truncate().equals(new $9hZKW.Int(0)) && dec.equals(new $cSmV0.Dec(dec.truncate()))) break;
            dec = dec.mul(new $cSmV0.Dec(10));
            decPrecision++;
        }
        this.dec = num;
        this._options.maxDecimals = decPrecision;
    }
    get options() {
        return this._options;
    }
    moveDecimalPointLeft(delta) {
        const pretty = this.clone();
        pretty.floatingDecimalPointRight += -delta;
        return pretty;
    }
    moveDecimalPointRight(delta) {
        const pretty = this.clone();
        pretty.floatingDecimalPointRight += delta;
        return pretty;
    }
    /**
     * @deprecated Use`moveDecimalPointLeft`
     */ increasePrecision(delta) {
        return this.moveDecimalPointLeft(delta);
    }
    /**
     * @deprecated Use`moveDecimalPointRight`
     */ decreasePrecision(delta) {
        return this.moveDecimalPointRight(delta);
    }
    maxDecimals(max) {
        const pretty = this.clone();
        pretty._options.maxDecimals = max;
        return pretty;
    }
    inequalitySymbol(bool) {
        const pretty = this.clone();
        pretty._options.inequalitySymbol = bool;
        return pretty;
    }
    inequalitySymbolSeparator(str) {
        const pretty = this.clone();
        pretty._options.inequalitySymbolSeparator = str;
        return pretty;
    }
    trim(bool) {
        const pretty = this.clone();
        pretty._options.trim = bool;
        return pretty;
    }
    shrink(bool) {
        const pretty = this.clone();
        pretty._options.shrink = bool;
        return pretty;
    }
    locale(locale) {
        const pretty = this.clone();
        pretty._options.locale = locale;
        return pretty;
    }
    /**
     * Ready indicates the actual value is ready to show the users.
     * Even if the ready option is false, it expects that the value can be shown to users (probably as 0).
     * The method that returns prettied value may return `undefined` or `null` if the value is not ready.
     * But, alternatively, it can return the 0 value that can be shown the users anyway, but indicates that the value is not ready.
     * @param bool
     */ ready(bool) {
        const pretty = this.clone();
        pretty._options.ready = bool;
        return pretty;
    }
    get isReady() {
        return this._options.ready;
    }
    add(target) {
        if (!(target instanceof $cSmV0.Dec)) target = target.toDec();
        const pretty = new $d9dc09e80584e41f$var$IntPretty(this.toDec().add(target));
        pretty._options = Object.assign({}, this._options);
        return pretty;
    }
    sub(target) {
        if (!(target instanceof $cSmV0.Dec)) target = target.toDec();
        const pretty = new $d9dc09e80584e41f$var$IntPretty(this.toDec().sub(target));
        pretty._options = Object.assign({}, this._options);
        return pretty;
    }
    mul(target) {
        if (!(target instanceof $cSmV0.Dec)) target = target.toDec();
        const pretty = new $d9dc09e80584e41f$var$IntPretty(this.toDec().mul(target));
        pretty._options = Object.assign({}, this._options);
        return pretty;
    }
    quo(target) {
        if (!(target instanceof $cSmV0.Dec)) target = target.toDec();
        const pretty = new $d9dc09e80584e41f$var$IntPretty(this.toDec().quo(target));
        pretty._options = Object.assign({}, this._options);
        return pretty;
    }
    toDec() {
        if (this.floatingDecimalPointRight === 0) return this.dec;
        else if (this.floatingDecimalPointRight > 0) return this.dec.mulTruncate($hZyWy.DecUtils.getTenExponentN(this.floatingDecimalPointRight));
        else {
            // Since a decimal in Dec cannot exceed 18, it cannot be computed at once.
            let i = -this.floatingDecimalPointRight;
            let dec = this.dec;
            while(i > 0)if (i >= $cSmV0.Dec.precision) {
                dec = dec.mulTruncate($hZyWy.DecUtils.getTenExponentN(-$cSmV0.Dec.precision));
                i -= $cSmV0.Dec.precision;
            } else {
                dec = dec.mulTruncate($hZyWy.DecUtils.getTenExponentN(-(i % $cSmV0.Dec.precision)));
                break;
            }
            return dec;
        }
    }
    toString() {
        return this.toStringWithSymbols("", "");
    }
    toStringWithSymbols(prefix, suffix) {
        const dec = this.toDec();
        if (this._options.inequalitySymbol && !dec.isZero() && dec.abs().lt($hZyWy.DecUtils.getTenExponentN(-this._options.maxDecimals))) {
            const isNeg = dec.isNegative();
            return `${isNeg ? ">" : "<"}${this._options.inequalitySymbolSeparator}${isNeg ? "-" : ""}${prefix}${$hZyWy.DecUtils.getTenExponentN(-this._options.maxDecimals).toString(this._options.maxDecimals, this._options.locale)}${suffix}`;
        }
        let result;
        if (!this._options.shrink) result = dec.toString(this._options.maxDecimals, this._options.locale);
        else result = $k20Vo.CoinUtils.shrinkDecimals(dec, 0, this._options.maxDecimals, this._options.locale);
        if (this._options.trim) result = $hZyWy.DecUtils.trim(result);
        const isNeg = result.charAt(0) === "-";
        if (isNeg) result = result.slice(1);
        return `${isNeg ? "-" : ""}${prefix}${result}${suffix}`;
    }
    clone() {
        const pretty = new $d9dc09e80584e41f$var$IntPretty(this.dec);
        pretty.dec = this.dec;
        pretty.floatingDecimalPointRight = this.floatingDecimalPointRight;
        pretty._options = Object.assign({}, this._options);
        return pretty;
    }
}
module.exports.IntPretty = $d9dc09e80584e41f$var$IntPretty;

});
parcelRequire.register("9hZKW", function(module, exports) {
"use strict";
var $6c359b125abde327$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Uint = module.exports.Int = void 0;

const $6c359b125abde327$var$big_integer_1 = $6c359b125abde327$var$__importDefault((parcelRequire("8w8wf")));

var $cSmV0 = parcelRequire("cSmV0");

var $a8WWN = parcelRequire("a8WWN");
class $6c359b125abde327$var$Int {
    /**
     * @param int - Parse a number | bigInteger | string into a bigInt.
     */ constructor(int){
        if (typeof int === "number") int = int.toString();
        if (typeof int === "string") {
            if (!$a8WWN.isValidIntegerString(int)) {
                if ($a8WWN.isExponentDecString(int)) int = $a8WWN.exponentDecStringToDecString(int);
                else throw new Error(`invalid integer: ${int}`);
            }
            this.int = $6c359b125abde327$var$big_integer_1.default(int);
        } else if (typeof int === "bigint") this.int = $6c359b125abde327$var$big_integer_1.default(int);
        else this.int = $6c359b125abde327$var$big_integer_1.default(int);
        this.checkBitLen();
    }
    checkBitLen() {
        if (this.int.abs().gt($6c359b125abde327$var$Int.maxInt)) throw new Error(`Integer out of range ${this.int.toString()}`);
    }
    toString() {
        return this.int.toString(10);
    }
    isNegative() {
        return this.int.isNegative();
    }
    isPositive() {
        return this.int.isPositive();
    }
    isZero() {
        return this.int.eq($6c359b125abde327$var$big_integer_1.default(0));
    }
    equals(i) {
        return this.int.equals(i.int);
    }
    gt(i) {
        return this.int.gt(i.int);
    }
    gte(i) {
        return this.int.greaterOrEquals(i.int);
    }
    lt(i) {
        return this.int.lt(i.int);
    }
    lte(i) {
        return this.int.lesserOrEquals(i.int);
    }
    abs() {
        return new $6c359b125abde327$var$Int(this.int.abs());
    }
    absUInt() {
        return new $6c359b125abde327$var$Uint(this.int.abs());
    }
    add(i) {
        return new $6c359b125abde327$var$Int(this.int.add(i.int));
    }
    sub(i) {
        return new $6c359b125abde327$var$Int(this.int.subtract(i.int));
    }
    mul(i) {
        return new $6c359b125abde327$var$Int(this.int.multiply(i.int));
    }
    div(i) {
        return new $6c359b125abde327$var$Int(this.int.divide(i.int));
    }
    mod(i) {
        return new $6c359b125abde327$var$Int(this.int.mod(i.int));
    }
    neg() {
        return new $6c359b125abde327$var$Int(this.int.negate());
    }
    pow(i) {
        return new $6c359b125abde327$var$Int(this.int.pow(i.toBigNumber()));
    }
    toDec() {
        return new $cSmV0.Dec(this);
    }
    toBigNumber() {
        return this.int;
    }
}
module.exports.Int = $6c359b125abde327$var$Int;
// (2 ** 256) - 1
$6c359b125abde327$var$Int.maxInt = $6c359b125abde327$var$big_integer_1.default("115792089237316195423570985008687907853269984665640564039457584007913129639935");
class $6c359b125abde327$var$Uint {
    /**
     * @param uint - Parse a number | bigInteger | string into a bigUint.
     */ constructor(uint){
        if (typeof uint === "number") uint = uint.toString();
        if (typeof uint === "string") {
            if (!$a8WWN.isValidIntegerString(uint)) {
                if ($a8WWN.isExponentDecString(uint)) uint = $a8WWN.exponentDecStringToDecString(uint);
                else throw new Error(`invalid integer: ${uint}`);
            }
            this.uint = $6c359b125abde327$var$big_integer_1.default(uint);
        } else if (typeof uint === "bigint") this.uint = $6c359b125abde327$var$big_integer_1.default(uint);
        else this.uint = $6c359b125abde327$var$big_integer_1.default(uint);
        if (this.uint.isNegative()) throw new TypeError("Uint should not be negative");
        this.checkBitLen();
    }
    checkBitLen() {
        if (this.uint.abs().bitLength().gt(256)) throw new Error(`Integer out of range ${this.uint.toString()}`);
    }
    toString() {
        return this.uint.toString(10);
    }
    isZero() {
        return this.uint.eq($6c359b125abde327$var$big_integer_1.default(0));
    }
    equals(i) {
        return this.uint.equals(i.uint);
    }
    gt(i) {
        return this.uint.gt(i.uint);
    }
    gte(i) {
        return this.uint.greaterOrEquals(i.uint);
    }
    lt(i) {
        return this.uint.lt(i.uint);
    }
    lte(i) {
        return this.uint.lesserOrEquals(i.uint);
    }
    add(i) {
        return new $6c359b125abde327$var$Uint(this.uint.add(i.uint));
    }
    sub(i) {
        return new $6c359b125abde327$var$Uint(this.uint.subtract(i.uint));
    }
    mul(i) {
        return new $6c359b125abde327$var$Uint(this.uint.multiply(i.uint));
    }
    div(i) {
        return new $6c359b125abde327$var$Uint(this.uint.divide(i.uint));
    }
    mod(i) {
        return new $6c359b125abde327$var$Uint(this.uint.mod(i.uint));
    }
    pow(i) {
        return new $6c359b125abde327$var$Uint(this.uint.pow(i.toBigNumber()));
    }
    toDec() {
        return new $cSmV0.Dec(new $6c359b125abde327$var$Int(this.toString()));
    }
    toBigNumber() {
        return this.uint;
    }
}
module.exports.Uint = $6c359b125abde327$var$Uint;

});
parcelRequire.register("8w8wf", function(module, exports) {
var bigInt = function(undefined) {
    "use strict";
    var BASE = 1e7, LOG_BASE = 7, MAX_INT = 9007199254740992, MAX_INT_ARR = smallToArray(MAX_INT), DEFAULT_ALPHABET = "0123456789abcdefghijklmnopqrstuvwxyz";
    var supportsNativeBigInt = typeof BigInt === "function";
    function Integer(v, radix, alphabet, caseSensitive) {
        if (typeof v === "undefined") return Integer[0];
        if (typeof radix !== "undefined") return +radix === 10 && !alphabet ? parseValue(v) : parseBase(v, radix, alphabet, caseSensitive);
        return parseValue(v);
    }
    function BigInteger(value, sign) {
        this.value = value;
        this.sign = sign;
        this.isSmall = false;
    }
    BigInteger.prototype = Object.create(Integer.prototype);
    function SmallInteger(value) {
        this.value = value;
        this.sign = value < 0;
        this.isSmall = true;
    }
    SmallInteger.prototype = Object.create(Integer.prototype);
    function NativeBigInt(value) {
        this.value = value;
    }
    NativeBigInt.prototype = Object.create(Integer.prototype);
    function isPrecise(n) {
        return -MAX_INT < n && n < MAX_INT;
    }
    function smallToArray(n) {
        if (n < 1e7) return [
            n
        ];
        if (n < 1e14) return [
            n % 1e7,
            Math.floor(n / 1e7)
        ];
        return [
            n % 1e7,
            Math.floor(n / 1e7) % 1e7,
            Math.floor(n / 1e14)
        ];
    }
    function arrayToSmall(arr) {
        trim(arr);
        var length = arr.length;
        if (length < 4 && compareAbs(arr, MAX_INT_ARR) < 0) switch(length){
            case 0:
                return 0;
            case 1:
                return arr[0];
            case 2:
                return arr[0] + arr[1] * BASE;
            default:
                return arr[0] + (arr[1] + arr[2] * BASE) * BASE;
        }
        return arr;
    }
    function trim(v) {
        var i = v.length;
        while(v[--i] === 0);
        v.length = i + 1;
    }
    function createArray(length) {
        var x = new Array(length);
        var i = -1;
        while(++i < length)x[i] = 0;
        return x;
    }
    function truncate(n) {
        if (n > 0) return Math.floor(n);
        return Math.ceil(n);
    }
    function add(a, b) {
        var l_a = a.length, l_b = b.length, r = new Array(l_a), carry = 0, base = BASE, sum, i;
        for(i = 0; i < l_b; i++){
            sum = a[i] + b[i] + carry;
            carry = sum >= base ? 1 : 0;
            r[i] = sum - carry * base;
        }
        while(i < l_a){
            sum = a[i] + carry;
            carry = sum === base ? 1 : 0;
            r[i++] = sum - carry * base;
        }
        if (carry > 0) r.push(carry);
        return r;
    }
    function addAny(a, b) {
        if (a.length >= b.length) return add(a, b);
        return add(b, a);
    }
    function addSmall(a, carry) {
        var l = a.length, r = new Array(l), base = BASE, sum, i;
        for(i = 0; i < l; i++){
            sum = a[i] - base + carry;
            carry = Math.floor(sum / base);
            r[i] = sum - carry * base;
            carry += 1;
        }
        while(carry > 0){
            r[i++] = carry % base;
            carry = Math.floor(carry / base);
        }
        return r;
    }
    BigInteger.prototype.add = function(v) {
        var n = parseValue(v);
        if (this.sign !== n.sign) return this.subtract(n.negate());
        var a = this.value, b = n.value;
        if (n.isSmall) return new BigInteger(addSmall(a, Math.abs(b)), this.sign);
        return new BigInteger(addAny(a, b), this.sign);
    };
    BigInteger.prototype.plus = BigInteger.prototype.add;
    SmallInteger.prototype.add = function(v) {
        var n = parseValue(v);
        var a = this.value;
        if (a < 0 !== n.sign) return this.subtract(n.negate());
        var b = n.value;
        if (n.isSmall) {
            if (isPrecise(a + b)) return new SmallInteger(a + b);
            b = smallToArray(Math.abs(b));
        }
        return new BigInteger(addSmall(b, Math.abs(a)), a < 0);
    };
    SmallInteger.prototype.plus = SmallInteger.prototype.add;
    NativeBigInt.prototype.add = function(v) {
        return new NativeBigInt(this.value + parseValue(v).value);
    };
    NativeBigInt.prototype.plus = NativeBigInt.prototype.add;
    function subtract(a, b) {
        var a_l = a.length, b_l = b.length, r = new Array(a_l), borrow = 0, base = BASE, i, difference;
        for(i = 0; i < b_l; i++){
            difference = a[i] - borrow - b[i];
            if (difference < 0) {
                difference += base;
                borrow = 1;
            } else borrow = 0;
            r[i] = difference;
        }
        for(i = b_l; i < a_l; i++){
            difference = a[i] - borrow;
            if (difference < 0) difference += base;
            else {
                r[i++] = difference;
                break;
            }
            r[i] = difference;
        }
        for(; i < a_l; i++)r[i] = a[i];
        trim(r);
        return r;
    }
    function subtractAny(a, b, sign) {
        var value;
        if (compareAbs(a, b) >= 0) value = subtract(a, b);
        else {
            value = subtract(b, a);
            sign = !sign;
        }
        value = arrayToSmall(value);
        if (typeof value === "number") {
            if (sign) value = -value;
            return new SmallInteger(value);
        }
        return new BigInteger(value, sign);
    }
    function subtractSmall(a, b, sign) {
        var l = a.length, r = new Array(l), carry = -b, base = BASE, i, difference;
        for(i = 0; i < l; i++){
            difference = a[i] + carry;
            carry = Math.floor(difference / base);
            difference %= base;
            r[i] = difference < 0 ? difference + base : difference;
        }
        r = arrayToSmall(r);
        if (typeof r === "number") {
            if (sign) r = -r;
            return new SmallInteger(r);
        }
        return new BigInteger(r, sign);
    }
    BigInteger.prototype.subtract = function(v) {
        var n = parseValue(v);
        if (this.sign !== n.sign) return this.add(n.negate());
        var a = this.value, b = n.value;
        if (n.isSmall) return subtractSmall(a, Math.abs(b), this.sign);
        return subtractAny(a, b, this.sign);
    };
    BigInteger.prototype.minus = BigInteger.prototype.subtract;
    SmallInteger.prototype.subtract = function(v) {
        var n = parseValue(v);
        var a = this.value;
        if (a < 0 !== n.sign) return this.add(n.negate());
        var b = n.value;
        if (n.isSmall) return new SmallInteger(a - b);
        return subtractSmall(b, Math.abs(a), a >= 0);
    };
    SmallInteger.prototype.minus = SmallInteger.prototype.subtract;
    NativeBigInt.prototype.subtract = function(v) {
        return new NativeBigInt(this.value - parseValue(v).value);
    };
    NativeBigInt.prototype.minus = NativeBigInt.prototype.subtract;
    BigInteger.prototype.negate = function() {
        return new BigInteger(this.value, !this.sign);
    };
    SmallInteger.prototype.negate = function() {
        var sign = this.sign;
        var small = new SmallInteger(-this.value);
        small.sign = !sign;
        return small;
    };
    NativeBigInt.prototype.negate = function() {
        return new NativeBigInt(-this.value);
    };
    BigInteger.prototype.abs = function() {
        return new BigInteger(this.value, false);
    };
    SmallInteger.prototype.abs = function() {
        return new SmallInteger(Math.abs(this.value));
    };
    NativeBigInt.prototype.abs = function() {
        return new NativeBigInt(this.value >= 0 ? this.value : -this.value);
    };
    function multiplyLong(a, b) {
        var a_l = a.length, b_l = b.length, l = a_l + b_l, r = createArray(l), base = BASE, product, carry, i, a_i, b_j;
        for(i = 0; i < a_l; ++i){
            a_i = a[i];
            for(var j = 0; j < b_l; ++j){
                b_j = b[j];
                product = a_i * b_j + r[i + j];
                carry = Math.floor(product / base);
                r[i + j] = product - carry * base;
                r[i + j + 1] += carry;
            }
        }
        trim(r);
        return r;
    }
    function multiplySmall(a, b) {
        var l = a.length, r = new Array(l), base = BASE, carry = 0, product, i;
        for(i = 0; i < l; i++){
            product = a[i] * b + carry;
            carry = Math.floor(product / base);
            r[i] = product - carry * base;
        }
        while(carry > 0){
            r[i++] = carry % base;
            carry = Math.floor(carry / base);
        }
        return r;
    }
    function shiftLeft(x, n) {
        var r = [];
        while(n-- > 0)r.push(0);
        return r.concat(x);
    }
    function multiplyKaratsuba(x, y) {
        var n = Math.max(x.length, y.length);
        if (n <= 30) return multiplyLong(x, y);
        n = Math.ceil(n / 2);
        var b = x.slice(n), a = x.slice(0, n), d = y.slice(n), c = y.slice(0, n);
        var ac = multiplyKaratsuba(a, c), bd = multiplyKaratsuba(b, d), abcd = multiplyKaratsuba(addAny(a, b), addAny(c, d));
        var product = addAny(addAny(ac, shiftLeft(subtract(subtract(abcd, ac), bd), n)), shiftLeft(bd, 2 * n));
        trim(product);
        return product;
    }
    // The following function is derived from a surface fit of a graph plotting the performance difference
    // between long multiplication and karatsuba multiplication versus the lengths of the two arrays.
    function useKaratsuba(l1, l2) {
        return -0.012 * l1 - 0.012 * l2 + 0.000015 * l1 * l2 > 0;
    }
    BigInteger.prototype.multiply = function(v) {
        var n = parseValue(v), a = this.value, b = n.value, sign = this.sign !== n.sign, abs;
        if (n.isSmall) {
            if (b === 0) return Integer[0];
            if (b === 1) return this;
            if (b === -1) return this.negate();
            abs = Math.abs(b);
            if (abs < BASE) return new BigInteger(multiplySmall(a, abs), sign);
            b = smallToArray(abs);
        }
        if (useKaratsuba(a.length, b.length)) return new BigInteger(multiplyKaratsuba(a, b), sign);
        return new BigInteger(multiplyLong(a, b), sign);
    };
    BigInteger.prototype.times = BigInteger.prototype.multiply;
    function multiplySmallAndArray(a, b, sign) {
        if (a < BASE) return new BigInteger(multiplySmall(b, a), sign);
        return new BigInteger(multiplyLong(b, smallToArray(a)), sign);
    }
    SmallInteger.prototype._multiplyBySmall = function(a) {
        if (isPrecise(a.value * this.value)) return new SmallInteger(a.value * this.value);
        return multiplySmallAndArray(Math.abs(a.value), smallToArray(Math.abs(this.value)), this.sign !== a.sign);
    };
    BigInteger.prototype._multiplyBySmall = function(a) {
        if (a.value === 0) return Integer[0];
        if (a.value === 1) return this;
        if (a.value === -1) return this.negate();
        return multiplySmallAndArray(Math.abs(a.value), this.value, this.sign !== a.sign);
    };
    SmallInteger.prototype.multiply = function(v) {
        return parseValue(v)._multiplyBySmall(this);
    };
    SmallInteger.prototype.times = SmallInteger.prototype.multiply;
    NativeBigInt.prototype.multiply = function(v) {
        return new NativeBigInt(this.value * parseValue(v).value);
    };
    NativeBigInt.prototype.times = NativeBigInt.prototype.multiply;
    function square(a) {
        //console.assert(2 * BASE * BASE < MAX_INT);
        var l = a.length, r = createArray(l + l), base = BASE, product, carry, i, a_i, a_j;
        for(i = 0; i < l; i++){
            a_i = a[i];
            carry = 0 - a_i * a_i;
            for(var j = i; j < l; j++){
                a_j = a[j];
                product = 2 * (a_i * a_j) + r[i + j] + carry;
                carry = Math.floor(product / base);
                r[i + j] = product - carry * base;
            }
            r[i + l] = carry;
        }
        trim(r);
        return r;
    }
    BigInteger.prototype.square = function() {
        return new BigInteger(square(this.value), false);
    };
    SmallInteger.prototype.square = function() {
        var value = this.value * this.value;
        if (isPrecise(value)) return new SmallInteger(value);
        return new BigInteger(square(smallToArray(Math.abs(this.value))), false);
    };
    NativeBigInt.prototype.square = function(v) {
        return new NativeBigInt(this.value * this.value);
    };
    function divMod1(a, b) {
        var a_l = a.length, b_l = b.length, base = BASE, result = createArray(b.length), divisorMostSignificantDigit = b[b_l - 1], // normalization
        lambda = Math.ceil(base / (2 * divisorMostSignificantDigit)), remainder = multiplySmall(a, lambda), divisor = multiplySmall(b, lambda), quotientDigit, shift, carry, borrow, i, l, q;
        if (remainder.length <= a_l) remainder.push(0);
        divisor.push(0);
        divisorMostSignificantDigit = divisor[b_l - 1];
        for(shift = a_l - b_l; shift >= 0; shift--){
            quotientDigit = base - 1;
            if (remainder[shift + b_l] !== divisorMostSignificantDigit) quotientDigit = Math.floor((remainder[shift + b_l] * base + remainder[shift + b_l - 1]) / divisorMostSignificantDigit);
            // quotientDigit <= base - 1
            carry = 0;
            borrow = 0;
            l = divisor.length;
            for(i = 0; i < l; i++){
                carry += quotientDigit * divisor[i];
                q = Math.floor(carry / base);
                borrow += remainder[shift + i] - (carry - q * base);
                carry = q;
                if (borrow < 0) {
                    remainder[shift + i] = borrow + base;
                    borrow = -1;
                } else {
                    remainder[shift + i] = borrow;
                    borrow = 0;
                }
            }
            while(borrow !== 0){
                quotientDigit -= 1;
                carry = 0;
                for(i = 0; i < l; i++){
                    carry += remainder[shift + i] - base + divisor[i];
                    if (carry < 0) {
                        remainder[shift + i] = carry + base;
                        carry = 0;
                    } else {
                        remainder[shift + i] = carry;
                        carry = 1;
                    }
                }
                borrow += carry;
            }
            result[shift] = quotientDigit;
        }
        // denormalization
        remainder = divModSmall(remainder, lambda)[0];
        return [
            arrayToSmall(result),
            arrayToSmall(remainder)
        ];
    }
    function divMod2(a, b) {
        // Performs faster than divMod1 on larger input sizes.
        var a_l = a.length, b_l = b.length, result = [], part = [], base = BASE, guess, xlen, highx, highy, check;
        while(a_l){
            part.unshift(a[--a_l]);
            trim(part);
            if (compareAbs(part, b) < 0) {
                result.push(0);
                continue;
            }
            xlen = part.length;
            highx = part[xlen - 1] * base + part[xlen - 2];
            highy = b[b_l - 1] * base + b[b_l - 2];
            if (xlen > b_l) highx = (highx + 1) * base;
            guess = Math.ceil(highx / highy);
            do {
                check = multiplySmall(b, guess);
                if (compareAbs(check, part) <= 0) break;
                guess--;
            }while (guess);
            result.push(guess);
            part = subtract(part, check);
        }
        result.reverse();
        return [
            arrayToSmall(result),
            arrayToSmall(part)
        ];
    }
    function divModSmall(value, lambda) {
        var length = value.length, quotient = createArray(length), base = BASE, i, q, remainder, divisor;
        remainder = 0;
        for(i = length - 1; i >= 0; --i){
            divisor = remainder * base + value[i];
            q = truncate(divisor / lambda);
            remainder = divisor - q * lambda;
            quotient[i] = q | 0;
        }
        return [
            quotient,
            remainder | 0
        ];
    }
    function divModAny(self, v) {
        var value, n = parseValue(v);
        if (supportsNativeBigInt) return [
            new NativeBigInt(self.value / n.value),
            new NativeBigInt(self.value % n.value)
        ];
        var a = self.value, b = n.value;
        var quotient;
        if (b === 0) throw new Error("Cannot divide by zero");
        if (self.isSmall) {
            if (n.isSmall) return [
                new SmallInteger(truncate(a / b)),
                new SmallInteger(a % b)
            ];
            return [
                Integer[0],
                self
            ];
        }
        if (n.isSmall) {
            if (b === 1) return [
                self,
                Integer[0]
            ];
            if (b == -1) return [
                self.negate(),
                Integer[0]
            ];
            var abs = Math.abs(b);
            if (abs < BASE) {
                value = divModSmall(a, abs);
                quotient = arrayToSmall(value[0]);
                var remainder = value[1];
                if (self.sign) remainder = -remainder;
                if (typeof quotient === "number") {
                    if (self.sign !== n.sign) quotient = -quotient;
                    return [
                        new SmallInteger(quotient),
                        new SmallInteger(remainder)
                    ];
                }
                return [
                    new BigInteger(quotient, self.sign !== n.sign),
                    new SmallInteger(remainder)
                ];
            }
            b = smallToArray(abs);
        }
        var comparison = compareAbs(a, b);
        if (comparison === -1) return [
            Integer[0],
            self
        ];
        if (comparison === 0) return [
            Integer[self.sign === n.sign ? 1 : -1],
            Integer[0]
        ];
        // divMod1 is faster on smaller input sizes
        if (a.length + b.length <= 200) value = divMod1(a, b);
        else value = divMod2(a, b);
        quotient = value[0];
        var qSign = self.sign !== n.sign, mod = value[1], mSign = self.sign;
        if (typeof quotient === "number") {
            if (qSign) quotient = -quotient;
            quotient = new SmallInteger(quotient);
        } else quotient = new BigInteger(quotient, qSign);
        if (typeof mod === "number") {
            if (mSign) mod = -mod;
            mod = new SmallInteger(mod);
        } else mod = new BigInteger(mod, mSign);
        return [
            quotient,
            mod
        ];
    }
    BigInteger.prototype.divmod = function(v) {
        var result = divModAny(this, v);
        return {
            quotient: result[0],
            remainder: result[1]
        };
    };
    NativeBigInt.prototype.divmod = SmallInteger.prototype.divmod = BigInteger.prototype.divmod;
    BigInteger.prototype.divide = function(v) {
        return divModAny(this, v)[0];
    };
    NativeBigInt.prototype.over = NativeBigInt.prototype.divide = function(v) {
        return new NativeBigInt(this.value / parseValue(v).value);
    };
    SmallInteger.prototype.over = SmallInteger.prototype.divide = BigInteger.prototype.over = BigInteger.prototype.divide;
    BigInteger.prototype.mod = function(v) {
        return divModAny(this, v)[1];
    };
    NativeBigInt.prototype.mod = NativeBigInt.prototype.remainder = function(v) {
        return new NativeBigInt(this.value % parseValue(v).value);
    };
    SmallInteger.prototype.remainder = SmallInteger.prototype.mod = BigInteger.prototype.remainder = BigInteger.prototype.mod;
    BigInteger.prototype.pow = function(v) {
        var n = parseValue(v), a = this.value, b = n.value, value, x, y;
        if (b === 0) return Integer[1];
        if (a === 0) return Integer[0];
        if (a === 1) return Integer[1];
        if (a === -1) return n.isEven() ? Integer[1] : Integer[-1];
        if (n.sign) return Integer[0];
        if (!n.isSmall) throw new Error("The exponent " + n.toString() + " is too large.");
        if (this.isSmall) {
            if (isPrecise(value = Math.pow(a, b))) return new SmallInteger(truncate(value));
        }
        x = this;
        y = Integer[1];
        while(true){
            if (b & true) {
                y = y.times(x);
                --b;
            }
            if (b === 0) break;
            b /= 2;
            x = x.square();
        }
        return y;
    };
    SmallInteger.prototype.pow = BigInteger.prototype.pow;
    NativeBigInt.prototype.pow = function(v) {
        var n = parseValue(v);
        var a = this.value, b = n.value;
        var _0 = BigInt(0), _1 = BigInt(1), _2 = BigInt(2);
        if (b === _0) return Integer[1];
        if (a === _0) return Integer[0];
        if (a === _1) return Integer[1];
        if (a === BigInt(-1)) return n.isEven() ? Integer[1] : Integer[-1];
        if (n.isNegative()) return new NativeBigInt(_0);
        var x = this;
        var y = Integer[1];
        while(true){
            if ((b & _1) === _1) {
                y = y.times(x);
                --b;
            }
            if (b === _0) break;
            b /= _2;
            x = x.square();
        }
        return y;
    };
    BigInteger.prototype.modPow = function(exp, mod) {
        exp = parseValue(exp);
        mod = parseValue(mod);
        if (mod.isZero()) throw new Error("Cannot take modPow with modulus 0");
        var r = Integer[1], base = this.mod(mod);
        if (exp.isNegative()) {
            exp = exp.multiply(Integer[-1]);
            base = base.modInv(mod);
        }
        while(exp.isPositive()){
            if (base.isZero()) return Integer[0];
            if (exp.isOdd()) r = r.multiply(base).mod(mod);
            exp = exp.divide(2);
            base = base.square().mod(mod);
        }
        return r;
    };
    NativeBigInt.prototype.modPow = SmallInteger.prototype.modPow = BigInteger.prototype.modPow;
    function compareAbs(a, b) {
        if (a.length !== b.length) return a.length > b.length ? 1 : -1;
        for(var i = a.length - 1; i >= 0; i--){
            if (a[i] !== b[i]) return a[i] > b[i] ? 1 : -1;
        }
        return 0;
    }
    BigInteger.prototype.compareAbs = function(v) {
        var n = parseValue(v), a = this.value, b = n.value;
        if (n.isSmall) return 1;
        return compareAbs(a, b);
    };
    SmallInteger.prototype.compareAbs = function(v) {
        var n = parseValue(v), a = Math.abs(this.value), b = n.value;
        if (n.isSmall) {
            b = Math.abs(b);
            return a === b ? 0 : a > b ? 1 : -1;
        }
        return -1;
    };
    NativeBigInt.prototype.compareAbs = function(v) {
        var a = this.value;
        var b = parseValue(v).value;
        a = a >= 0 ? a : -a;
        b = b >= 0 ? b : -b;
        return a === b ? 0 : a > b ? 1 : -1;
    };
    BigInteger.prototype.compare = function(v) {
        // See discussion about comparison with Infinity:
        // https://github.com/peterolson/BigInteger.js/issues/61
        if (v === Infinity) return -1;
        if (v === -Infinity) return 1;
        var n = parseValue(v), a = this.value, b = n.value;
        if (this.sign !== n.sign) return n.sign ? 1 : -1;
        if (n.isSmall) return this.sign ? -1 : 1;
        return compareAbs(a, b) * (this.sign ? -1 : 1);
    };
    BigInteger.prototype.compareTo = BigInteger.prototype.compare;
    SmallInteger.prototype.compare = function(v) {
        if (v === Infinity) return -1;
        if (v === -Infinity) return 1;
        var n = parseValue(v), a = this.value, b = n.value;
        if (n.isSmall) return a == b ? 0 : a > b ? 1 : -1;
        if (a < 0 !== n.sign) return a < 0 ? -1 : 1;
        return a < 0 ? 1 : -1;
    };
    SmallInteger.prototype.compareTo = SmallInteger.prototype.compare;
    NativeBigInt.prototype.compare = function(v) {
        if (v === Infinity) return -1;
        if (v === -Infinity) return 1;
        var a = this.value;
        var b = parseValue(v).value;
        return a === b ? 0 : a > b ? 1 : -1;
    };
    NativeBigInt.prototype.compareTo = NativeBigInt.prototype.compare;
    BigInteger.prototype.equals = function(v) {
        return this.compare(v) === 0;
    };
    NativeBigInt.prototype.eq = NativeBigInt.prototype.equals = SmallInteger.prototype.eq = SmallInteger.prototype.equals = BigInteger.prototype.eq = BigInteger.prototype.equals;
    BigInteger.prototype.notEquals = function(v) {
        return this.compare(v) !== 0;
    };
    NativeBigInt.prototype.neq = NativeBigInt.prototype.notEquals = SmallInteger.prototype.neq = SmallInteger.prototype.notEquals = BigInteger.prototype.neq = BigInteger.prototype.notEquals;
    BigInteger.prototype.greater = function(v) {
        return this.compare(v) > 0;
    };
    NativeBigInt.prototype.gt = NativeBigInt.prototype.greater = SmallInteger.prototype.gt = SmallInteger.prototype.greater = BigInteger.prototype.gt = BigInteger.prototype.greater;
    BigInteger.prototype.lesser = function(v) {
        return this.compare(v) < 0;
    };
    NativeBigInt.prototype.lt = NativeBigInt.prototype.lesser = SmallInteger.prototype.lt = SmallInteger.prototype.lesser = BigInteger.prototype.lt = BigInteger.prototype.lesser;
    BigInteger.prototype.greaterOrEquals = function(v) {
        return this.compare(v) >= 0;
    };
    NativeBigInt.prototype.geq = NativeBigInt.prototype.greaterOrEquals = SmallInteger.prototype.geq = SmallInteger.prototype.greaterOrEquals = BigInteger.prototype.geq = BigInteger.prototype.greaterOrEquals;
    BigInteger.prototype.lesserOrEquals = function(v) {
        return this.compare(v) <= 0;
    };
    NativeBigInt.prototype.leq = NativeBigInt.prototype.lesserOrEquals = SmallInteger.prototype.leq = SmallInteger.prototype.lesserOrEquals = BigInteger.prototype.leq = BigInteger.prototype.lesserOrEquals;
    BigInteger.prototype.isEven = function() {
        return (this.value[0] & 1) === 0;
    };
    SmallInteger.prototype.isEven = function() {
        return (this.value & 1) === 0;
    };
    NativeBigInt.prototype.isEven = function() {
        return (this.value & BigInt(1)) === BigInt(0);
    };
    BigInteger.prototype.isOdd = function() {
        return (this.value[0] & 1) === 1;
    };
    SmallInteger.prototype.isOdd = function() {
        return (this.value & 1) === 1;
    };
    NativeBigInt.prototype.isOdd = function() {
        return (this.value & BigInt(1)) === BigInt(1);
    };
    BigInteger.prototype.isPositive = function() {
        return !this.sign;
    };
    SmallInteger.prototype.isPositive = function() {
        return this.value > 0;
    };
    NativeBigInt.prototype.isPositive = SmallInteger.prototype.isPositive;
    BigInteger.prototype.isNegative = function() {
        return this.sign;
    };
    SmallInteger.prototype.isNegative = function() {
        return this.value < 0;
    };
    NativeBigInt.prototype.isNegative = SmallInteger.prototype.isNegative;
    BigInteger.prototype.isUnit = function() {
        return false;
    };
    SmallInteger.prototype.isUnit = function() {
        return Math.abs(this.value) === 1;
    };
    NativeBigInt.prototype.isUnit = function() {
        return this.abs().value === BigInt(1);
    };
    BigInteger.prototype.isZero = function() {
        return false;
    };
    SmallInteger.prototype.isZero = function() {
        return this.value === 0;
    };
    NativeBigInt.prototype.isZero = function() {
        return this.value === BigInt(0);
    };
    BigInteger.prototype.isDivisibleBy = function(v) {
        var n = parseValue(v);
        if (n.isZero()) return false;
        if (n.isUnit()) return true;
        if (n.compareAbs(2) === 0) return this.isEven();
        return this.mod(n).isZero();
    };
    NativeBigInt.prototype.isDivisibleBy = SmallInteger.prototype.isDivisibleBy = BigInteger.prototype.isDivisibleBy;
    function isBasicPrime(v) {
        var n = v.abs();
        if (n.isUnit()) return false;
        if (n.equals(2) || n.equals(3) || n.equals(5)) return true;
        if (n.isEven() || n.isDivisibleBy(3) || n.isDivisibleBy(5)) return false;
        if (n.lesser(49)) return true;
    // we don't know if it's prime: let the other functions figure it out
    }
    function millerRabinTest(n, a) {
        var nPrev = n.prev(), b = nPrev, r = 0, d, t, i, x;
        while(b.isEven())b = b.divide(2), r++;
        next: for(i = 0; i < a.length; i++){
            if (n.lesser(a[i])) continue;
            x = bigInt(a[i]).modPow(b, n);
            if (x.isUnit() || x.equals(nPrev)) continue;
            for(d = r - 1; d != 0; d--){
                x = x.square().mod(n);
                if (x.isUnit()) return false;
                if (x.equals(nPrev)) continue next;
            }
            return false;
        }
        return true;
    }
    // Set "strict" to true to force GRH-supported lower bound of 2*log(N)^2
    BigInteger.prototype.isPrime = function(strict) {
        var isPrime = isBasicPrime(this);
        if (isPrime !== undefined) return isPrime;
        var n = this.abs();
        var bits = n.bitLength();
        if (bits <= 64) return millerRabinTest(n, [
            2,
            3,
            5,
            7,
            11,
            13,
            17,
            19,
            23,
            29,
            31,
            37
        ]);
        var logN = Math.log(2) * bits.toJSNumber();
        var t = Math.ceil(strict === true ? 2 * Math.pow(logN, 2) : logN);
        for(var a = [], i = 0; i < t; i++)a.push(bigInt(i + 2));
        return millerRabinTest(n, a);
    };
    NativeBigInt.prototype.isPrime = SmallInteger.prototype.isPrime = BigInteger.prototype.isPrime;
    BigInteger.prototype.isProbablePrime = function(iterations, rng) {
        var isPrime = isBasicPrime(this);
        if (isPrime !== undefined) return isPrime;
        var n = this.abs();
        var t = iterations === undefined ? 5 : iterations;
        for(var a = [], i = 0; i < t; i++)a.push(bigInt.randBetween(2, n.minus(2), rng));
        return millerRabinTest(n, a);
    };
    NativeBigInt.prototype.isProbablePrime = SmallInteger.prototype.isProbablePrime = BigInteger.prototype.isProbablePrime;
    BigInteger.prototype.modInv = function(n) {
        var t = bigInt.zero, newT = bigInt.one, r = parseValue(n), newR = this.abs(), q, lastT, lastR;
        while(!newR.isZero()){
            q = r.divide(newR);
            lastT = t;
            lastR = r;
            t = newT;
            r = newR;
            newT = lastT.subtract(q.multiply(newT));
            newR = lastR.subtract(q.multiply(newR));
        }
        if (!r.isUnit()) throw new Error(this.toString() + " and " + n.toString() + " are not co-prime");
        if (t.compare(0) === -1) t = t.add(n);
        if (this.isNegative()) return t.negate();
        return t;
    };
    NativeBigInt.prototype.modInv = SmallInteger.prototype.modInv = BigInteger.prototype.modInv;
    BigInteger.prototype.next = function() {
        var value = this.value;
        if (this.sign) return subtractSmall(value, 1, this.sign);
        return new BigInteger(addSmall(value, 1), this.sign);
    };
    SmallInteger.prototype.next = function() {
        var value = this.value;
        if (value + 1 < MAX_INT) return new SmallInteger(value + 1);
        return new BigInteger(MAX_INT_ARR, false);
    };
    NativeBigInt.prototype.next = function() {
        return new NativeBigInt(this.value + BigInt(1));
    };
    BigInteger.prototype.prev = function() {
        var value = this.value;
        if (this.sign) return new BigInteger(addSmall(value, 1), true);
        return subtractSmall(value, 1, this.sign);
    };
    SmallInteger.prototype.prev = function() {
        var value = this.value;
        if (value - 1 > -MAX_INT) return new SmallInteger(value - 1);
        return new BigInteger(MAX_INT_ARR, true);
    };
    NativeBigInt.prototype.prev = function() {
        return new NativeBigInt(this.value - BigInt(1));
    };
    var powersOfTwo = [
        1
    ];
    while(2 * powersOfTwo[powersOfTwo.length - 1] <= BASE)powersOfTwo.push(2 * powersOfTwo[powersOfTwo.length - 1]);
    var powers2Length = powersOfTwo.length, highestPower2 = powersOfTwo[powers2Length - 1];
    function shift_isSmall(n) {
        return Math.abs(n) <= BASE;
    }
    BigInteger.prototype.shiftLeft = function(v) {
        var n = parseValue(v).toJSNumber();
        if (!shift_isSmall(n)) throw new Error(String(n) + " is too large for shifting.");
        if (n < 0) return this.shiftRight(-n);
        var result = this;
        if (result.isZero()) return result;
        while(n >= powers2Length){
            result = result.multiply(highestPower2);
            n -= powers2Length - 1;
        }
        return result.multiply(powersOfTwo[n]);
    };
    NativeBigInt.prototype.shiftLeft = SmallInteger.prototype.shiftLeft = BigInteger.prototype.shiftLeft;
    BigInteger.prototype.shiftRight = function(v) {
        var remQuo;
        var n = parseValue(v).toJSNumber();
        if (!shift_isSmall(n)) throw new Error(String(n) + " is too large for shifting.");
        if (n < 0) return this.shiftLeft(-n);
        var result = this;
        while(n >= powers2Length){
            if (result.isZero() || result.isNegative() && result.isUnit()) return result;
            remQuo = divModAny(result, highestPower2);
            result = remQuo[1].isNegative() ? remQuo[0].prev() : remQuo[0];
            n -= powers2Length - 1;
        }
        remQuo = divModAny(result, powersOfTwo[n]);
        return remQuo[1].isNegative() ? remQuo[0].prev() : remQuo[0];
    };
    NativeBigInt.prototype.shiftRight = SmallInteger.prototype.shiftRight = BigInteger.prototype.shiftRight;
    function bitwise(x, y, fn) {
        y = parseValue(y);
        var xSign = x.isNegative(), ySign = y.isNegative();
        var xRem = xSign ? x.not() : x, yRem = ySign ? y.not() : y;
        var xDigit = 0, yDigit = 0;
        var xDivMod = null, yDivMod = null;
        var result = [];
        while(!xRem.isZero() || !yRem.isZero()){
            xDivMod = divModAny(xRem, highestPower2);
            xDigit = xDivMod[1].toJSNumber();
            if (xSign) xDigit = highestPower2 - 1 - xDigit; // two's complement for negative numbers
            yDivMod = divModAny(yRem, highestPower2);
            yDigit = yDivMod[1].toJSNumber();
            if (ySign) yDigit = highestPower2 - 1 - yDigit; // two's complement for negative numbers
            xRem = xDivMod[0];
            yRem = yDivMod[0];
            result.push(fn(xDigit, yDigit));
        }
        var sum = fn(xSign ? 1 : 0, ySign ? 1 : 0) !== 0 ? bigInt(-1) : bigInt(0);
        for(var i = result.length - 1; i >= 0; i -= 1)sum = sum.multiply(highestPower2).add(bigInt(result[i]));
        return sum;
    }
    BigInteger.prototype.not = function() {
        return this.negate().prev();
    };
    NativeBigInt.prototype.not = SmallInteger.prototype.not = BigInteger.prototype.not;
    BigInteger.prototype.and = function(n) {
        return bitwise(this, n, function(a, b) {
            return a & b;
        });
    };
    NativeBigInt.prototype.and = SmallInteger.prototype.and = BigInteger.prototype.and;
    BigInteger.prototype.or = function(n) {
        return bitwise(this, n, function(a, b) {
            return a | b;
        });
    };
    NativeBigInt.prototype.or = SmallInteger.prototype.or = BigInteger.prototype.or;
    BigInteger.prototype.xor = function(n) {
        return bitwise(this, n, function(a, b) {
            return a ^ b;
        });
    };
    NativeBigInt.prototype.xor = SmallInteger.prototype.xor = BigInteger.prototype.xor;
    var LOBMASK_I = 1073741824, LOBMASK_BI = (BASE & -BASE) * (BASE & -BASE) | LOBMASK_I;
    function roughLOB(n) {
        // SmallInteger: return Min(lowestOneBit(n), 1 << 30)
        // BigInteger: return Min(lowestOneBit(n), 1 << 14) [BASE=1e7]
        var v = n.value, x = typeof v === "number" ? v | LOBMASK_I : typeof v === "bigint" ? v | BigInt(LOBMASK_I) : v[0] + v[1] * BASE | LOBMASK_BI;
        return x & -x;
    }
    function integerLogarithm(value, base) {
        if (base.compareTo(value) <= 0) {
            var tmp = integerLogarithm(value, base.square(base));
            var p = tmp.p;
            var e = tmp.e;
            var t = p.multiply(base);
            return t.compareTo(value) <= 0 ? {
                p: t,
                e: e * 2 + 1
            } : {
                p: p,
                e: e * 2
            };
        }
        return {
            p: bigInt(1),
            e: 0
        };
    }
    BigInteger.prototype.bitLength = function() {
        var n = this;
        if (n.compareTo(bigInt(0)) < 0) n = n.negate().subtract(bigInt(1));
        if (n.compareTo(bigInt(0)) === 0) return bigInt(0);
        return bigInt(integerLogarithm(n, bigInt(2)).e).add(bigInt(1));
    };
    NativeBigInt.prototype.bitLength = SmallInteger.prototype.bitLength = BigInteger.prototype.bitLength;
    function max(a, b) {
        a = parseValue(a);
        b = parseValue(b);
        return a.greater(b) ? a : b;
    }
    function min(a, b) {
        a = parseValue(a);
        b = parseValue(b);
        return a.lesser(b) ? a : b;
    }
    function gcd(a, b) {
        a = parseValue(a).abs();
        b = parseValue(b).abs();
        if (a.equals(b)) return a;
        if (a.isZero()) return b;
        if (b.isZero()) return a;
        var c = Integer[1], d, t;
        while(a.isEven() && b.isEven()){
            d = min(roughLOB(a), roughLOB(b));
            a = a.divide(d);
            b = b.divide(d);
            c = c.multiply(d);
        }
        while(a.isEven())a = a.divide(roughLOB(a));
        do {
            while(b.isEven())b = b.divide(roughLOB(b));
            if (a.greater(b)) {
                t = b;
                b = a;
                a = t;
            }
            b = b.subtract(a);
        }while (!b.isZero());
        return c.isUnit() ? a : a.multiply(c);
    }
    function lcm(a, b) {
        a = parseValue(a).abs();
        b = parseValue(b).abs();
        return a.divide(gcd(a, b)).multiply(b);
    }
    function randBetween(a, b, rng) {
        a = parseValue(a);
        b = parseValue(b);
        var usedRNG = rng || Math.random;
        var low = min(a, b), high = max(a, b);
        var range = high.subtract(low).add(1);
        if (range.isSmall) return low.add(Math.floor(usedRNG() * range));
        var digits = toBase(range, BASE).value;
        var result = [], restricted = true;
        for(var i = 0; i < digits.length; i++){
            var top = restricted ? digits[i] + (i + 1 < digits.length ? digits[i + 1] / BASE : 0) : BASE;
            var digit = truncate(usedRNG() * top);
            result.push(digit);
            if (digit < digits[i]) restricted = false;
        }
        return low.add(Integer.fromArray(result, BASE, false));
    }
    var parseBase = function(text, base, alphabet, caseSensitive) {
        alphabet = alphabet || DEFAULT_ALPHABET;
        text = String(text);
        if (!caseSensitive) {
            text = text.toLowerCase();
            alphabet = alphabet.toLowerCase();
        }
        var length = text.length;
        var i;
        var absBase = Math.abs(base);
        var alphabetValues = {};
        for(i = 0; i < alphabet.length; i++)alphabetValues[alphabet[i]] = i;
        for(i = 0; i < length; i++){
            var c = text[i];
            if (c === "-") continue;
            if (c in alphabetValues) {
                if (alphabetValues[c] >= absBase) {
                    if (c === "1" && absBase === 1) continue;
                    throw new Error(c + " is not a valid digit in base " + base + ".");
                }
            }
        }
        base = parseValue(base);
        var digits = [];
        var isNegative = text[0] === "-";
        for(i = isNegative ? 1 : 0; i < text.length; i++){
            var c = text[i];
            if (c in alphabetValues) digits.push(parseValue(alphabetValues[c]));
            else if (c === "<") {
                var start = i;
                do i++;
                while (text[i] !== ">" && i < text.length);
                digits.push(parseValue(text.slice(start + 1, i)));
            } else throw new Error(c + " is not a valid character");
        }
        return parseBaseFromArray(digits, base, isNegative);
    };
    function parseBaseFromArray(digits, base, isNegative) {
        var val = Integer[0], pow = Integer[1], i;
        for(i = digits.length - 1; i >= 0; i--){
            val = val.add(digits[i].times(pow));
            pow = pow.times(base);
        }
        return isNegative ? val.negate() : val;
    }
    function stringify(digit, alphabet) {
        alphabet = alphabet || DEFAULT_ALPHABET;
        if (digit < alphabet.length) return alphabet[digit];
        return "<" + digit + ">";
    }
    function toBase(n, base) {
        base = bigInt(base);
        if (base.isZero()) {
            if (n.isZero()) return {
                value: [
                    0
                ],
                isNegative: false
            };
            throw new Error("Cannot convert nonzero numbers to base 0.");
        }
        if (base.equals(-1)) {
            if (n.isZero()) return {
                value: [
                    0
                ],
                isNegative: false
            };
            if (n.isNegative()) return {
                value: [].concat.apply([], Array.apply(null, Array(-n.toJSNumber())).map(Array.prototype.valueOf, [
                    1,
                    0
                ])),
                isNegative: false
            };
            var arr = Array.apply(null, Array(n.toJSNumber() - 1)).map(Array.prototype.valueOf, [
                0,
                1
            ]);
            arr.unshift([
                1
            ]);
            return {
                value: [].concat.apply([], arr),
                isNegative: false
            };
        }
        var neg = false;
        if (n.isNegative() && base.isPositive()) {
            neg = true;
            n = n.abs();
        }
        if (base.isUnit()) {
            if (n.isZero()) return {
                value: [
                    0
                ],
                isNegative: false
            };
            return {
                value: Array.apply(null, Array(n.toJSNumber())).map(Number.prototype.valueOf, 1),
                isNegative: neg
            };
        }
        var out = [];
        var left = n, divmod;
        while(left.isNegative() || left.compareAbs(base) >= 0){
            divmod = left.divmod(base);
            left = divmod.quotient;
            var digit = divmod.remainder;
            if (digit.isNegative()) {
                digit = base.minus(digit).abs();
                left = left.next();
            }
            out.push(digit.toJSNumber());
        }
        out.push(left.toJSNumber());
        return {
            value: out.reverse(),
            isNegative: neg
        };
    }
    function toBaseString(n, base, alphabet) {
        var arr = toBase(n, base);
        return (arr.isNegative ? "-" : "") + arr.value.map(function(x) {
            return stringify(x, alphabet);
        }).join("");
    }
    BigInteger.prototype.toArray = function(radix) {
        return toBase(this, radix);
    };
    SmallInteger.prototype.toArray = function(radix) {
        return toBase(this, radix);
    };
    NativeBigInt.prototype.toArray = function(radix) {
        return toBase(this, radix);
    };
    BigInteger.prototype.toString = function(radix, alphabet) {
        if (radix === undefined) radix = 10;
        if (radix !== 10 || alphabet) return toBaseString(this, radix, alphabet);
        var v = this.value, l = v.length, str = String(v[--l]), zeros = "0000000", digit;
        while(--l >= 0){
            digit = String(v[l]);
            str += zeros.slice(digit.length) + digit;
        }
        var sign = this.sign ? "-" : "";
        return sign + str;
    };
    SmallInteger.prototype.toString = function(radix, alphabet) {
        if (radix === undefined) radix = 10;
        if (radix != 10 || alphabet) return toBaseString(this, radix, alphabet);
        return String(this.value);
    };
    NativeBigInt.prototype.toString = SmallInteger.prototype.toString;
    NativeBigInt.prototype.toJSON = BigInteger.prototype.toJSON = SmallInteger.prototype.toJSON = function() {
        return this.toString();
    };
    BigInteger.prototype.valueOf = function() {
        return parseInt(this.toString(), 10);
    };
    BigInteger.prototype.toJSNumber = BigInteger.prototype.valueOf;
    SmallInteger.prototype.valueOf = function() {
        return this.value;
    };
    SmallInteger.prototype.toJSNumber = SmallInteger.prototype.valueOf;
    NativeBigInt.prototype.valueOf = NativeBigInt.prototype.toJSNumber = function() {
        return parseInt(this.toString(), 10);
    };
    function parseStringValue(v) {
        if (isPrecise(+v)) {
            var x = +v;
            if (x === truncate(x)) return supportsNativeBigInt ? new NativeBigInt(BigInt(x)) : new SmallInteger(x);
            throw new Error("Invalid integer: " + v);
        }
        var sign = v[0] === "-";
        if (sign) v = v.slice(1);
        var split = v.split(/e/i);
        if (split.length > 2) throw new Error("Invalid integer: " + split.join("e"));
        if (split.length === 2) {
            var exp = split[1];
            if (exp[0] === "+") exp = exp.slice(1);
            exp = +exp;
            if (exp !== truncate(exp) || !isPrecise(exp)) throw new Error("Invalid integer: " + exp + " is not a valid exponent.");
            var text = split[0];
            var decimalPlace = text.indexOf(".");
            if (decimalPlace >= 0) {
                exp -= text.length - decimalPlace - 1;
                text = text.slice(0, decimalPlace) + text.slice(decimalPlace + 1);
            }
            if (exp < 0) throw new Error("Cannot include negative exponent part for integers");
            text += new Array(exp + 1).join("0");
            v = text;
        }
        var isValid = /^([0-9][0-9]*)$/.test(v);
        if (!isValid) throw new Error("Invalid integer: " + v);
        if (supportsNativeBigInt) return new NativeBigInt(BigInt(sign ? "-" + v : v));
        var r = [], max = v.length, l = LOG_BASE, min = max - l;
        while(max > 0){
            r.push(+v.slice(min, max));
            min -= l;
            if (min < 0) min = 0;
            max -= l;
        }
        trim(r);
        return new BigInteger(r, sign);
    }
    function parseNumberValue(v) {
        if (supportsNativeBigInt) return new NativeBigInt(BigInt(v));
        if (isPrecise(v)) {
            if (v !== truncate(v)) throw new Error(v + " is not an integer.");
            return new SmallInteger(v);
        }
        return parseStringValue(v.toString());
    }
    function parseValue(v) {
        if (typeof v === "number") return parseNumberValue(v);
        if (typeof v === "string") return parseStringValue(v);
        if (typeof v === "bigint") return new NativeBigInt(v);
        return v;
    }
    // Pre-define numbers in range [-999,999]
    for(var i = 0; i < 1000; i++){
        Integer[i] = parseValue(i);
        if (i > 0) Integer[-i] = parseValue(-i);
    }
    // Backwards compatibility
    Integer.one = Integer[1];
    Integer.zero = Integer[0];
    Integer.minusOne = Integer[-1];
    Integer.max = max;
    Integer.min = min;
    Integer.gcd = gcd;
    Integer.lcm = lcm;
    Integer.isInstance = function(x) {
        return x instanceof BigInteger || x instanceof SmallInteger || x instanceof NativeBigInt;
    };
    Integer.randBetween = randBetween;
    Integer.fromArray = function(digits, base, isNegative) {
        return parseBaseFromArray(digits.map(parseValue), parseValue(base || 10), isNegative);
    };
    return Integer;
}();
// Node.js check
if (module.hasOwnProperty("exports")) module.exports = bigInt;
//amd check
if (typeof define === "function" && define.amd) define(function() {
    return bigInt;
});

});

parcelRequire.register("cSmV0", function(module, exports) {
"use strict";
var $95fc4e4e6117eb7b$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Dec = void 0;

const $95fc4e4e6117eb7b$var$big_integer_1 = $95fc4e4e6117eb7b$var$__importDefault((parcelRequire("8w8wf")));

var $9hZKW = parcelRequire("9hZKW");

var $k20Vo = parcelRequire("k20Vo");

var $a8WWN = parcelRequire("a8WWN");
class $95fc4e4e6117eb7b$var$Dec {
    /**
     * Create a new Dec from integer with decimal place at prec
     * @param int - Parse a number | bigInteger | string into a Dec.
     * If int is string and contains dot(.), prec is ignored and automatically calculated.
     * @param prec - Precision
     */ constructor(int, prec = 0){
        if (typeof int === "number") int = int.toString();
        if (typeof int === "string") {
            if (int.length === 0) throw new Error("empty string");
            if (!$a8WWN.isValidDecimalString(int)) {
                if ($a8WWN.isExponentDecString(int)) int = $a8WWN.exponentDecStringToDecString(int);
                else throw new Error(`invalid decimal: ${int}`);
            }
            // Even if an input with more than 18 decimals, it does not throw an error and ignores the rest.
            const reduced = $95fc4e4e6117eb7b$var$Dec.reduceDecimalsFromString(int);
            if (reduced.isDownToZero) // However, as a result, if the input becomes 0, a problem may occur in mul or quo. In this case, print a warning.
            console.log(`WARNING: Got ${int}. Dec can only handle up to 18 decimals. However, since the decimal point of the input exceeds 18 digits, the remainder is discarded. As a result, input becomes 0.`);
            int = reduced.res;
            if (int.indexOf(".") >= 0) {
                prec = int.length - int.indexOf(".") - 1;
                int = int.replace(".", "");
            }
            this.int = $95fc4e4e6117eb7b$var$big_integer_1.default(int);
        } else if (int instanceof $9hZKW.Int) this.int = $95fc4e4e6117eb7b$var$big_integer_1.default(int.toString());
        else if (typeof int === "bigint") this.int = $95fc4e4e6117eb7b$var$big_integer_1.default(int);
        else this.int = $95fc4e4e6117eb7b$var$big_integer_1.default(int);
        this.int = this.int.multiply($95fc4e4e6117eb7b$var$Dec.calcPrecisionMultiplier(prec));
        this.checkBitLen();
    }
    static calcPrecisionMultiplier(prec) {
        if (prec < 0) throw new Error("Invalid prec");
        if (prec > $95fc4e4e6117eb7b$var$Dec.precision) throw new Error("Too much precision");
        if ($95fc4e4e6117eb7b$var$Dec.precisionMultipliers[prec.toString()]) // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        return $95fc4e4e6117eb7b$var$Dec.precisionMultipliers[prec.toString()];
        const zerosToAdd = $95fc4e4e6117eb7b$var$Dec.precision - prec;
        const multiplier = $95fc4e4e6117eb7b$var$big_integer_1.default(10).pow(zerosToAdd);
        $95fc4e4e6117eb7b$var$Dec.precisionMultipliers[prec.toString()] = multiplier;
        return multiplier;
    }
    static reduceDecimalsFromString(str) {
        const decimalPointIndex = str.indexOf(".");
        if (decimalPointIndex < 0) return {
            res: str,
            isDownToZero: false
        };
        const exceededDecimals = str.length - 1 - decimalPointIndex - $95fc4e4e6117eb7b$var$Dec.precision;
        if (exceededDecimals <= 0) return {
            res: str,
            isDownToZero: false
        };
        const res = str.slice(0, str.length - exceededDecimals);
        return {
            res: res,
            isDownToZero: /^[0.]*$/.test(res)
        };
    }
    checkBitLen() {
        if (this.int.abs().gt($95fc4e4e6117eb7b$var$Dec.maxDec)) throw new Error(`Integer out of range ${this.int.toString()}`);
    }
    isZero() {
        return this.int.eq($95fc4e4e6117eb7b$var$big_integer_1.default(0));
    }
    isNegative() {
        return this.int.isNegative();
    }
    isPositive() {
        return this.int.isPositive();
    }
    equals(d2) {
        return this.int.eq(d2.int);
    }
    /**
     * Alias for the greater method.
     */ gt(d2) {
        return this.int.gt(d2.int);
    }
    /**
     * Alias for the greaterOrEquals method.
     */ gte(d2) {
        return this.int.geq(d2.int);
    }
    /**
     * Alias for the lesser method.
     */ lt(d2) {
        return this.int.lt(d2.int);
    }
    /**
     * Alias for the lesserOrEquals method.
     */ lte(d2) {
        return this.int.leq(d2.int);
    }
    /**
     * reverse the decimal sign.
     */ neg() {
        return new $95fc4e4e6117eb7b$var$Dec(this.int.negate(), $95fc4e4e6117eb7b$var$Dec.precision);
    }
    /**
     * Returns the absolute value of a decimals.
     */ abs() {
        return new $95fc4e4e6117eb7b$var$Dec(this.int.abs(), $95fc4e4e6117eb7b$var$Dec.precision);
    }
    add(d2) {
        return new $95fc4e4e6117eb7b$var$Dec(this.int.add(d2.int), $95fc4e4e6117eb7b$var$Dec.precision);
    }
    sub(d2) {
        return new $95fc4e4e6117eb7b$var$Dec(this.int.subtract(d2.int), $95fc4e4e6117eb7b$var$Dec.precision);
    }
    pow(n) {
        if (n.isZero()) return new $95fc4e4e6117eb7b$var$Dec(1);
        if (n.isNegative()) return new $95fc4e4e6117eb7b$var$Dec(1).quo(this.pow(n.abs()));
        let base = new $95fc4e4e6117eb7b$var$Dec(this.int, $95fc4e4e6117eb7b$var$Dec.precision);
        let tmp = new $95fc4e4e6117eb7b$var$Dec(1);
        for(let i = n; i.gt(new $9hZKW.Int(1)); i = i.div(new $9hZKW.Int(2))){
            if (!i.mod(new $9hZKW.Int(2)).isZero()) tmp = tmp.mul(base);
            base = base.mul(base);
        }
        return base.mul(tmp);
    }
    mul(d2) {
        return new $95fc4e4e6117eb7b$var$Dec(this.mulRaw(d2).chopPrecisionAndRound(), $95fc4e4e6117eb7b$var$Dec.precision);
    }
    mulTruncate(d2) {
        return new $95fc4e4e6117eb7b$var$Dec(this.mulRaw(d2).chopPrecisionAndTruncate(), $95fc4e4e6117eb7b$var$Dec.precision);
    }
    mulRaw(d2) {
        return new $95fc4e4e6117eb7b$var$Dec(this.int.multiply(d2.int), $95fc4e4e6117eb7b$var$Dec.precision);
    }
    quo(d2) {
        return new $95fc4e4e6117eb7b$var$Dec(this.quoRaw(d2).chopPrecisionAndRound(), $95fc4e4e6117eb7b$var$Dec.precision);
    }
    quoTruncate(d2) {
        return new $95fc4e4e6117eb7b$var$Dec(this.quoRaw(d2).chopPrecisionAndTruncate(), $95fc4e4e6117eb7b$var$Dec.precision);
    }
    quoRoundUp(d2) {
        return new $95fc4e4e6117eb7b$var$Dec(this.quoRaw(d2).chopPrecisionAndRoundUp(), $95fc4e4e6117eb7b$var$Dec.precision);
    }
    quoRaw(d2) {
        const precision = $95fc4e4e6117eb7b$var$Dec.calcPrecisionMultiplier(0);
        // multiply precision twice
        const mul = this.int.multiply(precision).multiply(precision);
        return new $95fc4e4e6117eb7b$var$Dec(mul.divide(d2.int), $95fc4e4e6117eb7b$var$Dec.precision);
    }
    isInteger() {
        const precision = $95fc4e4e6117eb7b$var$Dec.calcPrecisionMultiplier(0);
        return this.int.remainder(precision).equals($95fc4e4e6117eb7b$var$big_integer_1.default(0));
    }
    /**
     * Remove a Precision amount of rightmost digits and perform bankers rounding
     * on the remainder (gaussian rounding) on the digits which have been removed.
     */ chopPrecisionAndRound() {
        // Remove the negative and add it back when returning
        if (this.isNegative()) {
            const absoulteDec = this.abs();
            const choped = absoulteDec.chopPrecisionAndRound();
            return choped.negate();
        }
        const precision = $95fc4e4e6117eb7b$var$Dec.calcPrecisionMultiplier(0);
        const fivePrecision = precision.divide($95fc4e4e6117eb7b$var$big_integer_1.default(2));
        // Get the truncated quotient and remainder
        const { quotient: quotient, remainder: remainder } = this.int.divmod(precision);
        // If remainder is zero
        if (remainder.equals($95fc4e4e6117eb7b$var$big_integer_1.default(0))) return quotient;
        if (remainder.lt(fivePrecision)) return quotient;
        else if (remainder.gt(fivePrecision)) return quotient.add($95fc4e4e6117eb7b$var$big_integer_1.default(1));
        else {
            // always round to an even number
            if (quotient.divide($95fc4e4e6117eb7b$var$big_integer_1.default(2)).equals($95fc4e4e6117eb7b$var$big_integer_1.default(0))) return quotient;
            else return quotient.add($95fc4e4e6117eb7b$var$big_integer_1.default(1));
        }
    }
    chopPrecisionAndRoundUp() {
        // Remove the negative and add it back when returning
        if (this.isNegative()) {
            const absoulteDec = this.abs();
            // truncate since d is negative...
            const choped = absoulteDec.chopPrecisionAndTruncate();
            return choped.negate();
        }
        const precision = $95fc4e4e6117eb7b$var$Dec.calcPrecisionMultiplier(0);
        // Get the truncated quotient and remainder
        const { quotient: quotient, remainder: remainder } = this.int.divmod(precision);
        // If remainder is zero
        if (remainder.equals($95fc4e4e6117eb7b$var$big_integer_1.default(0))) return quotient;
        return quotient.add($95fc4e4e6117eb7b$var$big_integer_1.default(1));
    }
    /**
     * Similar to chopPrecisionAndRound, but always rounds down
     */ chopPrecisionAndTruncate() {
        const precision = $95fc4e4e6117eb7b$var$Dec.calcPrecisionMultiplier(0);
        return this.int.divide(precision);
    }
    toString(prec = $95fc4e4e6117eb7b$var$Dec.precision, locale = false) {
        const precision = $95fc4e4e6117eb7b$var$Dec.calcPrecisionMultiplier(0);
        const int = this.int.abs();
        const { quotient: integer, remainder: fraction } = int.divmod(precision);
        let fractionStr = fraction.toString(10);
        for(let i = 0, l = fractionStr.length; i < $95fc4e4e6117eb7b$var$Dec.precision - l; i++)fractionStr = "0" + fractionStr;
        fractionStr = fractionStr.substring(0, prec);
        const isNegative = this.isNegative() && !(integer.eq($95fc4e4e6117eb7b$var$big_integer_1.default(0)) && fractionStr.length === 0);
        const integerStr = locale ? // @ts-ignore
        $k20Vo.CoinUtils.integerStringToUSLocaleString(integer.toString()) : integer.toString();
        return `${isNegative ? "-" : ""}${integerStr}${fractionStr.length > 0 ? "." + fractionStr : ""}`;
    }
    round() {
        return new $9hZKW.Int(this.chopPrecisionAndRound());
    }
    roundUp() {
        return new $9hZKW.Int(this.chopPrecisionAndRoundUp());
    }
    truncate() {
        return new $9hZKW.Int(this.chopPrecisionAndTruncate());
    }
    roundDec() {
        return new $95fc4e4e6117eb7b$var$Dec(this.chopPrecisionAndRound(), 0);
    }
    roundUpDec() {
        return new $95fc4e4e6117eb7b$var$Dec(this.chopPrecisionAndRoundUp(), 0);
    }
    truncateDec() {
        return new $95fc4e4e6117eb7b$var$Dec(this.chopPrecisionAndTruncate(), 0);
    }
}
module.exports.Dec = $95fc4e4e6117eb7b$var$Dec;
$95fc4e4e6117eb7b$var$Dec.precision = 18;
// Bytes required to represent the above precision is 18.
// Ceiling[Log2[999 999 999 999 999 999]]
$95fc4e4e6117eb7b$var$Dec.decimalPrecisionBits = 60;
// Max bit length for `Dec` is 256 + 60(decimalPrecisionBits)
// The int in the `Dec` is handled as integer assuming that it has 18 precision.
// (2 ** (256 + 60) - 1)
$95fc4e4e6117eb7b$var$Dec.maxDec = $95fc4e4e6117eb7b$var$big_integer_1.default("133499189745056880149688856635597007162669032647290798121690100488888732861290034376435130433535");
$95fc4e4e6117eb7b$var$Dec.precisionMultipliers = {};

});
parcelRequire.register("k20Vo", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.CoinUtils = void 0;

var $4GgGj = parcelRequire("4GgGj");

var $9hZKW = parcelRequire("9hZKW");

var $cSmV0 = parcelRequire("cSmV0");

var $hZyWy = parcelRequire("hZyWy");
class $e954b62c02afd604$var$CoinUtils {
    static createCoinsFromPrimitives(coinPrimitives) {
        return coinPrimitives.map((primitive)=>{
            return new $4GgGj.Coin(primitive.denom, primitive.amount);
        });
    }
    static amountOf(coins, denom) {
        const coin = coins.find((coin)=>{
            return coin.denom === denom;
        });
        if (!coin) return new $9hZKW.Int(0);
        else return coin.amount;
    }
    static exclude(coins, demons) {
        return coins.filter((coin)=>{
            return demons.indexOf(coin.denom) === 0;
        });
    }
    static concat(...coins) {
        if (coins.length === 0) return [];
        const arr = coins.slice();
        const reducer = (accumulator, coin)=>{
            // Find the duplicated denom.
            const find = accumulator.find((c)=>c.denom === coin.denom);
            // If duplicated coin exists, add the amount to duplicated one.
            if (find) {
                const newCoin = new $4GgGj.Coin(find.denom, find.amount.add(coin.amount));
                accumulator.push(newCoin);
            } else {
                const newCoin = new $4GgGj.Coin(coin.denom, coin.amount);
                accumulator.push(newCoin);
            }
            return accumulator;
        };
        return arr.reduce(reducer, []);
    }
    static getCoinFromDecimals(currencies, decAmountStr, denom) {
        const currency = currencies.find((currency)=>{
            return currency.coinDenom === denom;
        });
        if (!currency) throw new Error("Invalid currency");
        let precision = new $cSmV0.Dec(1);
        for(let i = 0; i < currency.coinDecimals; i++)precision = precision.mul(new $cSmV0.Dec(10));
        let decAmount = new $cSmV0.Dec(decAmountStr);
        decAmount = decAmount.mul(precision);
        if (!new $cSmV0.Dec(decAmount.truncate()).equals(decAmount)) throw new Error("Can't divide anymore");
        return new $4GgGj.Coin(currency.coinMinimalDenom, decAmount.truncate());
    }
    static parseDecAndDenomFromCoin(currencies, coin) {
        let currency = currencies.find((currency)=>{
            return currency.coinMinimalDenom === coin.denom;
        });
        if (!currency) // If the currency is unknown, just use the raw currency.
        currency = {
            coinDecimals: 0,
            coinDenom: coin.denom,
            coinMinimalDenom: coin.denom
        };
        let precision = new $cSmV0.Dec(1);
        for(let i = 0; i < currency.coinDecimals; i++)precision = precision.mul(new $cSmV0.Dec(10));
        const decAmount = new $cSmV0.Dec(coin.amount).quoTruncate(precision);
        return {
            amount: decAmount.toString(currency.coinDecimals),
            denom: currency.coinDenom
        };
    }
    static shrinkDecimals(dec, minDecimals, maxDecimals, locale = false) {
        if (dec.equals(new $cSmV0.Dec(0))) return "0";
        const isNeg = dec.isNegative();
        const integer = dec.abs().truncate();
        const fraction = dec.abs().sub(new $cSmV0.Dec(integer));
        const decimals = Math.max(maxDecimals - integer.toString().length + 1, minDecimals);
        const fractionStr = decimals === 0 ? "" : fraction.toString(decimals).replace("0.", "");
        const integerStr = locale ? $e954b62c02afd604$var$CoinUtils.integerStringToUSLocaleString(integer.toString()) : integer.toString();
        return (isNeg ? "-" : "") + integerStr + (fractionStr.length > 0 ? "." : "") + fractionStr;
    }
    /**
     * Change the non-locale integer string to locale string.
     * Only support en-US format.
     * This method uses the BigInt if the environment supports the BigInt.
     * @param numberStr
     */ static integerStringToUSLocaleString(numberStr) {
        if (numberStr.indexOf(".") >= 0) throw new Error(`${numberStr} is not integer`);
        if (typeof BigInt !== "undefined") return BigInt(numberStr).toLocaleString("en-US");
        const integer = numberStr;
        const chunks = [];
        for(let i = integer.length; i > 0; i -= 3)chunks.push(integer.slice(Math.max(0, i - 3), i));
        return chunks.reverse().join(",");
    }
    static coinToTrimmedString(coin, currency, separator = " ") {
        const dec = new $cSmV0.Dec(coin.amount).quoTruncate($hZyWy.DecUtils.getPrecisionDec(currency.coinDecimals));
        return `${$hZyWy.DecUtils.trim(dec)}${separator}${currency.coinDenom}`;
    }
}
module.exports.CoinUtils = $e954b62c02afd604$var$CoinUtils;

});
parcelRequire.register("4GgGj", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Coin = void 0;

var $9hZKW = parcelRequire("9hZKW");
class $36880644d09b865b$var$Coin {
    constructor(denom, amount){
        this.denom = denom;
        this.amount = amount instanceof $9hZKW.Int ? amount : new $9hZKW.Int(amount);
    }
    static parse(str) {
        const re = new RegExp("([0-9]+)[ ]*([a-zA-Z]+)$");
        const execed = re.exec(str);
        if (!execed || execed.length !== 3) throw new Error("Invalid coin str");
        const denom = execed[2];
        const amount = execed[1];
        return new $36880644d09b865b$var$Coin(denom, amount);
    }
    toString() {
        return `${this.amount.toString()}${this.denom}`;
    }
}
module.exports.Coin = $36880644d09b865b$var$Coin;

});

parcelRequire.register("hZyWy", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DecUtils = void 0;

var $cSmV0 = parcelRequire("cSmV0");

var $9hZKW = parcelRequire("9hZKW");
class $d1933d2f9e6ea493$var$DecUtils {
    static trim(dec) {
        let decStr = typeof dec === "string" ? dec : dec.toString();
        if (decStr.indexOf(".") < 0) return decStr;
        for(let i = decStr.length - 1; i >= 0; i--){
            if (decStr[i] === "0") decStr = decStr.slice(0, i);
            else break;
        }
        if (decStr.length > 0) {
            if (decStr[decStr.length - 1] === ".") decStr = decStr.slice(0, decStr.length - 1);
        }
        return decStr;
    }
    static getTenExponentN(n) {
        if (n < -$cSmV0.Dec.precision) // Dec can only handle up to precision 18.
        // Anything less than 18 precision is 0, so there is a high probability of an error.
        throw new Error("Too little precision");
        if ($d1933d2f9e6ea493$var$DecUtils.tenExponentNs[n.toString()]) return $d1933d2f9e6ea493$var$DecUtils.tenExponentNs[n.toString()];
        const dec = new $cSmV0.Dec(10).pow(new $9hZKW.Int(n));
        $d1933d2f9e6ea493$var$DecUtils.tenExponentNs[n.toString()] = dec;
        return dec;
    }
    static getTenExponentNInPrecisionRange(n) {
        if (n > $cSmV0.Dec.precision) throw new Error("Too much precision");
        return $d1933d2f9e6ea493$var$DecUtils.getTenExponentN(n);
    }
    /**
     * @deprecated Use`getTenExponentNInPrecisionRange`
     */ static getPrecisionDec(precision) {
        return $d1933d2f9e6ea493$var$DecUtils.getTenExponentNInPrecisionRange(precision);
    }
}
module.exports.DecUtils = $d1933d2f9e6ea493$var$DecUtils;
$d1933d2f9e6ea493$var$DecUtils.tenExponentNs = {};

});


parcelRequire.register("a8WWN", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.exponentDecStringToDecString = module.exports.isExponentDecString = module.exports.isValidDecimalString = module.exports.isValidIntegerString = void 0;
const $7628606d84f7b13d$var$regexIntString = /^-?\d+$/;
const $7628606d84f7b13d$var$regexDecString = /^-?\d+.?\d*$/;
const $7628606d84f7b13d$var$regexExponentDecString = /^(-?)([\d.]+)e([-+])([\d]+)$/;
function $7628606d84f7b13d$var$isValidIntegerString(str) {
    return $7628606d84f7b13d$var$regexIntString.test(str);
}
module.exports.isValidIntegerString = $7628606d84f7b13d$var$isValidIntegerString;
function $7628606d84f7b13d$var$isValidDecimalString(str) {
    return $7628606d84f7b13d$var$regexDecString.test(str);
}
module.exports.isValidDecimalString = $7628606d84f7b13d$var$isValidDecimalString;
function $7628606d84f7b13d$var$isExponentDecString(str) {
    return $7628606d84f7b13d$var$regexExponentDecString.test(str);
}
module.exports.isExponentDecString = $7628606d84f7b13d$var$isExponentDecString;
function $7628606d84f7b13d$var$makeZerosStr(len) {
    let r = "";
    for(let i = 0; i < len; i++)r += "0";
    return r;
}
function $7628606d84f7b13d$var$removeHeadZeros(str) {
    while(str.length > 0 && str[0] === "0")str = str.slice(1);
    if (str.length === 0 || str[0] === ".") return "0" + str;
    return str;
}
function $7628606d84f7b13d$var$exponentDecStringToDecString(str) {
    const split = str.split($7628606d84f7b13d$var$regexExponentDecString);
    if (split.length !== 6) return str;
    const isNeg = split[1] === "-";
    let numStr = split[2];
    const numStrFractionIndex = numStr.indexOf(".");
    const exponentStr = split[4];
    let exponent = parseInt(exponentStr) * (split[3] === "-" ? -1 : 1);
    if (numStrFractionIndex >= 0) {
        const fractionLen = numStr.length - numStrFractionIndex - 1;
        exponent = exponent - fractionLen;
        numStr = $7628606d84f7b13d$var$removeHeadZeros(numStr.replace(".", ""));
    }
    const prefix = isNeg ? "-" : "";
    if (exponent < 0) {
        if (numStr.length > -exponent) {
            const fractionPosition = numStr.length + exponent;
            return prefix + (numStr.slice(0, fractionPosition) + "." + numStr.slice(fractionPosition));
        }
        return prefix + "0." + $7628606d84f7b13d$var$makeZerosStr(-(numStr.length + exponent)) + numStr;
    } else return prefix + numStr + $7628606d84f7b13d$var$makeZerosStr(exponent);
}
module.exports.exponentDecStringToDecString = $7628606d84f7b13d$var$exponentDecStringToDecString;

});




parcelRequire.register("alAPZ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.CoinPretty = void 0;

var $iHEZr = parcelRequire("iHEZr");

var $cSmV0 = parcelRequire("cSmV0");

var $hZyWy = parcelRequire("hZyWy");
class $788870baa7f882d3$var$CoinPretty {
    constructor(_currency, amount){
        this._currency = _currency;
        this.amount = amount;
        this._options = {
            separator: " ",
            upperCase: false,
            lowerCase: false,
            hideDenom: false
        };
        if (typeof this.amount === "object" && "toDec" in this.amount) this.amount = this.amount.toDec();
        else if (!(this.amount instanceof $cSmV0.Dec)) this.amount = new $cSmV0.Dec(this.amount);
        this.intPretty = new $iHEZr.IntPretty(this.amount.quoTruncate($hZyWy.DecUtils.getTenExponentNInPrecisionRange(_currency.coinDecimals))).maxDecimals(_currency.coinDecimals);
    }
    get options() {
        return Object.assign(Object.assign({}, this._options), this.intPretty.options);
    }
    get denom() {
        return this.currency.coinDenom;
    }
    get currency() {
        return this._currency;
    }
    setCurrency(currency) {
        const pretty = this.clone();
        pretty.intPretty = this.intPretty.moveDecimalPointRight(this._currency.coinDecimals - currency.coinDecimals);
        pretty._currency = currency;
        return pretty;
    }
    separator(str) {
        const pretty = this.clone();
        pretty._options.separator = str;
        return pretty;
    }
    upperCase(bool) {
        const pretty = this.clone();
        pretty._options.upperCase = bool;
        pretty._options.lowerCase = !bool;
        return pretty;
    }
    lowerCase(bool) {
        const pretty = this.clone();
        pretty._options.lowerCase = bool;
        pretty._options.upperCase = !bool;
        return pretty;
    }
    hideDenom(bool) {
        const pretty = this.clone();
        pretty._options.hideDenom = bool;
        return pretty;
    }
    moveDecimalPointLeft(delta) {
        const pretty = this.clone();
        pretty.intPretty = pretty.intPretty.moveDecimalPointLeft(delta);
        return pretty;
    }
    moveDecimalPointRight(delta) {
        const pretty = this.clone();
        pretty.intPretty = pretty.intPretty.moveDecimalPointRight(delta);
        return pretty;
    }
    /**
     * @deprecated Use`moveDecimalPointLeft`
     */ increasePrecision(delta) {
        return this.moveDecimalPointLeft(delta);
    }
    /**
     * @deprecated Use`moveDecimalPointRight`
     */ decreasePrecision(delta) {
        return this.moveDecimalPointRight(delta);
    }
    maxDecimals(max) {
        const pretty = this.clone();
        pretty.intPretty = pretty.intPretty.maxDecimals(max);
        return pretty;
    }
    inequalitySymbol(bool) {
        const pretty = this.clone();
        pretty.intPretty = pretty.intPretty.inequalitySymbol(bool);
        return pretty;
    }
    inequalitySymbolSeparator(str) {
        const pretty = this.clone();
        pretty.intPretty = pretty.intPretty.inequalitySymbolSeparator(str);
        return pretty;
    }
    trim(bool) {
        const pretty = this.clone();
        pretty.intPretty = pretty.intPretty.trim(bool);
        return pretty;
    }
    shrink(bool) {
        const pretty = this.clone();
        pretty.intPretty = pretty.intPretty.shrink(bool);
        return pretty;
    }
    locale(locale) {
        const pretty = this.clone();
        pretty.intPretty = pretty.intPretty.locale(locale);
        return pretty;
    }
    /**
     * Ready indicates the actual value is ready to show the users.
     * Even if the ready option is false, it expects that the value can be shown to users (probably as 0).
     * The method that returns prettied value may return `undefined` or `null` if the value is not ready.
     * But, alternatively, it can return the 0 value that can be shown the users anyway, but indicates that the value is not ready.
     * @param bool
     */ ready(bool) {
        const pretty = this.clone();
        pretty.intPretty = pretty.intPretty.ready(bool);
        return pretty;
    }
    get isReady() {
        return this.intPretty.isReady;
    }
    add(target) {
        const isCoinPretty = target instanceof $788870baa7f882d3$var$CoinPretty;
        if (isCoinPretty) {
            // If target is `CoinPretty` and it has different denom, do nothing.
            if ("currency" in target && this.currency.coinMinimalDenom !== target.currency.coinMinimalDenom) return this.clone();
        }
        if ("toDec" in target) target = target.toDec();
        const pretty = this.clone();
        pretty.intPretty = pretty.intPretty.add(isCoinPretty ? target : target.mul($hZyWy.DecUtils.getTenExponentNInPrecisionRange(-this._currency.coinDecimals)));
        return pretty;
    }
    sub(target) {
        const isCoinPretty = target instanceof $788870baa7f882d3$var$CoinPretty;
        if (isCoinPretty) {
            // If target is `CoinPretty` and it has different denom, do nothing.
            if ("currency" in target && this.currency.coinMinimalDenom !== target.currency.coinMinimalDenom) return this.clone();
        }
        if ("toDec" in target) target = target.toDec();
        const pretty = this.clone();
        pretty.intPretty = pretty.intPretty.sub(isCoinPretty ? target : target.mul($hZyWy.DecUtils.getTenExponentNInPrecisionRange(-this._currency.coinDecimals)));
        return pretty;
    }
    mul(target) {
        const pretty = this.clone();
        pretty.intPretty = pretty.intPretty.mul(target);
        return pretty;
    }
    quo(target) {
        const pretty = this.clone();
        pretty.intPretty = pretty.intPretty.quo(target);
        return pretty;
    }
    toDec() {
        return this.intPretty.toDec();
    }
    toCoin() {
        const amount = this.toDec().mulTruncate($hZyWy.DecUtils.getTenExponentNInPrecisionRange(this.currency.coinDecimals)).truncate();
        return {
            denom: this.currency.coinMinimalDenom,
            amount: amount.toString()
        };
    }
    toString() {
        let denom = this.denom;
        if (this._options.upperCase) denom = denom.toUpperCase();
        if (this._options.lowerCase) denom = denom.toLowerCase();
        let separator = this._options.separator;
        if (this._options.hideDenom) {
            denom = "";
            separator = "";
        }
        return this.intPretty.toStringWithSymbols("", `${separator}${denom}`);
    }
    clone() {
        const pretty = new $788870baa7f882d3$var$CoinPretty(this._currency, this.amount);
        pretty._options = Object.assign({}, this._options);
        pretty.intPretty = this.intPretty.clone();
        return pretty;
    }
}
module.exports.CoinPretty = $788870baa7f882d3$var$CoinPretty;

});

parcelRequire.register("cYm4M", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.PricePretty = void 0;

var $iHEZr = parcelRequire("iHEZr");

var $hZyWy = parcelRequire("hZyWy");
class $971c367a20613f18$var$PricePretty {
    constructor(_fiatCurrency, amount){
        this._fiatCurrency = _fiatCurrency;
        this.amount = amount;
        this._options = {
            separator: "",
            upperCase: false,
            lowerCase: false,
            locale: "en-US"
        };
        this.intPretty = new $iHEZr.IntPretty(amount).maxDecimals(_fiatCurrency.maxDecimals).shrink(true).trim(true).locale(false).inequalitySymbol(true);
        this._options.locale = _fiatCurrency.locale;
    }
    get options() {
        return Object.assign(Object.assign({}, this.intPretty.options), this._options);
    }
    get symbol() {
        return this._fiatCurrency.symbol;
    }
    get fiatCurrency() {
        return this._fiatCurrency;
    }
    separator(str) {
        const pretty = this.clone();
        pretty._options.separator = str;
        return pretty;
    }
    upperCase(bool) {
        const pretty = this.clone();
        pretty._options.upperCase = bool;
        pretty._options.lowerCase = !bool;
        return pretty;
    }
    lowerCase(bool) {
        const pretty = this.clone();
        pretty._options.lowerCase = bool;
        pretty._options.upperCase = !bool;
        return pretty;
    }
    moveDecimalPointLeft(delta) {
        const pretty = this.clone();
        pretty.intPretty = pretty.intPretty.moveDecimalPointLeft(delta);
        return pretty;
    }
    moveDecimalPointRight(delta) {
        const pretty = this.clone();
        pretty.intPretty = pretty.intPretty.moveDecimalPointRight(delta);
        return pretty;
    }
    /**
     * @deprecated Use`moveDecimalPointLeft`
     */ increasePrecision(delta) {
        return this.moveDecimalPointLeft(delta);
    }
    /**
     * @deprecated Use`moveDecimalPointRight`
     */ decreasePrecision(delta) {
        return this.moveDecimalPointRight(delta);
    }
    maxDecimals(max) {
        const pretty = this.clone();
        pretty.intPretty = pretty.intPretty.maxDecimals(max);
        return pretty;
    }
    inequalitySymbol(bool) {
        const pretty = this.clone();
        pretty.intPretty = pretty.intPretty.inequalitySymbol(bool);
        return pretty;
    }
    inequalitySymbolSeparator(str) {
        const pretty = this.clone();
        pretty.intPretty = pretty.intPretty.inequalitySymbolSeparator(str);
        return pretty;
    }
    trim(bool) {
        const pretty = this.clone();
        pretty.intPretty = pretty.intPretty.trim(bool);
        return pretty;
    }
    shrink(bool) {
        const pretty = this.clone();
        pretty.intPretty = pretty.intPretty.shrink(bool);
        return pretty;
    }
    locale(locale) {
        const pretty = this.clone();
        pretty._options.locale = locale;
        return pretty;
    }
    /**
     * Ready indicates the actual value is ready to show the users.
     * Even if the ready option is false, it expects that the value can be shown to users (probably as 0).
     * The method that returns prettied value may return `undefined` or `null` if the value is not ready.
     * But, alternatively, it can return the 0 value that can be shown the users anyway, but indicates that the value is not ready.
     * @param bool
     */ ready(bool) {
        const pretty = this.clone();
        pretty.intPretty = pretty.intPretty.ready(bool);
        return pretty;
    }
    get isReady() {
        return this.intPretty.isReady;
    }
    add(target) {
        const pretty = this.clone();
        pretty.intPretty = pretty.intPretty.add(target);
        return pretty;
    }
    sub(target) {
        const pretty = this.clone();
        pretty.intPretty = pretty.intPretty.sub(target);
        return pretty;
    }
    mul(target) {
        const pretty = this.clone();
        pretty.intPretty = pretty.intPretty.mul(target);
        return pretty;
    }
    quo(target) {
        const pretty = this.clone();
        pretty.intPretty = pretty.intPretty.quo(target);
        return pretty;
    }
    toDec() {
        return this.intPretty.toDec();
    }
    toString() {
        let symbol = this.symbol;
        if (this._options.upperCase) symbol = symbol.toUpperCase();
        if (this._options.lowerCase) symbol = symbol.toLowerCase();
        const dec = this.toDec();
        const options = this.options;
        if (options.inequalitySymbol && !dec.isZero() && dec.abs().lt($hZyWy.DecUtils.getTenExponentN(-options.maxDecimals))) return this.intPretty.toStringWithSymbols(`${symbol}${this._options.separator}`, "");
        let localeString = parseFloat(this.intPretty.toString()).toLocaleString(options.locale, {
            maximumFractionDigits: options.maxDecimals
        });
        const isNeg = localeString.charAt(0) === "-";
        if (isNeg) localeString = localeString.slice(1);
        return `${isNeg ? "-" : ""}${symbol}${this._options.separator}${localeString}`;
    }
    clone() {
        const pretty = new $971c367a20613f18$var$PricePretty(this._fiatCurrency, this.amount);
        pretty._options = Object.assign({}, this._options);
        pretty.intPretty = this.intPretty.clone();
        return pretty;
    }
}
module.exports.PricePretty = $971c367a20613f18$var$PricePretty;

});

parcelRequire.register("fDbBK", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.RatePretty = void 0;

var $iHEZr = parcelRequire("iHEZr");
/**
 * RatePretty treats `Dec` in rate form for easy calculation, and displays it as a percentage to the user by using toString().
 * By default, if the value is less than maxDeciamls, it is displayed using an inequality sign (Ex. < 0.001%)
 */ class $b61380a1fb89463e$var$RatePretty {
    constructor(amount){
        this.amount = amount;
        this._options = {
            separator: "",
            symbol: "%"
        };
        this.intPretty = new $iHEZr.IntPretty(amount);
        this.intPretty = this.intPretty.maxDecimals(3).shrink(false).trim(true).locale(true).inequalitySymbol(true);
    }
    get options() {
        return Object.assign(Object.assign({}, this.intPretty.options), this._options);
    }
    separator(str) {
        const pretty = this.clone();
        pretty._options.separator = str;
        return pretty;
    }
    symbol(str) {
        const pretty = this.clone();
        pretty._options.symbol = str;
        return pretty;
    }
    moveDecimalPointLeft(delta) {
        const pretty = this.clone();
        pretty.intPretty = pretty.intPretty.moveDecimalPointLeft(delta);
        return pretty;
    }
    moveDecimalPointRight(delta) {
        const pretty = this.clone();
        pretty.intPretty = pretty.intPretty.moveDecimalPointRight(delta);
        return pretty;
    }
    maxDecimals(max) {
        const pretty = this.clone();
        pretty.intPretty = pretty.intPretty.maxDecimals(max);
        return pretty;
    }
    inequalitySymbol(bool) {
        const pretty = this.clone();
        pretty.intPretty = pretty.intPretty.inequalitySymbol(bool);
        return pretty;
    }
    inequalitySymbolSeparator(str) {
        const pretty = this.clone();
        pretty.intPretty = pretty.intPretty.inequalitySymbolSeparator(str);
        return pretty;
    }
    trim(bool) {
        const pretty = this.clone();
        pretty.intPretty = pretty.intPretty.trim(bool);
        return pretty;
    }
    shrink(bool) {
        const pretty = this.clone();
        pretty.intPretty = pretty.intPretty.shrink(bool);
        return pretty;
    }
    locale(locale) {
        const pretty = this.clone();
        pretty.intPretty = pretty.intPretty.locale(locale);
        return pretty;
    }
    /**
     * Ready indicates the actual value is ready to show the users.
     * Even if the ready option is false, it expects that the value can be shown to users (probably as 0).
     * The method that returns prettied value may return `undefined` or `null` if the value is not ready.
     * But, alternatively, it can return the 0 value that can be shown the users anyway, but indicates that the value is not ready.
     * @param bool
     */ ready(bool) {
        const pretty = this.clone();
        pretty.intPretty = pretty.intPretty.ready(bool);
        return pretty;
    }
    get isReady() {
        return this.intPretty.isReady;
    }
    add(target) {
        const pretty = this.clone();
        pretty.intPretty = pretty.intPretty.add(target);
        return pretty;
    }
    sub(target) {
        const pretty = this.clone();
        pretty.intPretty = pretty.intPretty.sub(target);
        return pretty;
    }
    mul(target) {
        const pretty = this.clone();
        pretty.intPretty = pretty.intPretty.mul(target);
        return pretty;
    }
    quo(target) {
        const pretty = this.clone();
        pretty.intPretty = pretty.intPretty.quo(target);
        return pretty;
    }
    toDec() {
        return this.intPretty.toDec();
    }
    toString() {
        return this.intPretty.moveDecimalPointRight(2).toStringWithSymbols("", `${this._options.separator}${this._options.symbol}`);
    }
    clone() {
        const pretty = new $b61380a1fb89463e$var$RatePretty(this.amount);
        pretty._options = Object.assign({}, this._options);
        pretty.intPretty = this.intPretty.clone();
        return pretty;
    }
}
module.exports.RatePretty = $b61380a1fb89463e$var$RatePretty;

});



parcelRequire.register("lWBwx", function(module, exports) {
"use strict";
var $ff9c1f2cd9baf8af$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, {
        enumerable: true,
        get: function() {
            return m[k];
        }
    });
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $ff9c1f2cd9baf8af$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $ff9c1f2cd9baf8af$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $ff9c1f2cd9baf8af$var$__createBinding(result, mod, k);
    }
    $ff9c1f2cd9baf8af$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Bech32Address = void 0;

const $ff9c1f2cd9baf8af$var$bech32_1 = $ff9c1f2cd9baf8af$var$__importStar((parcelRequire("5wgCY")));
class $ff9c1f2cd9baf8af$var$Bech32Address {
    constructor(address){
        this.address = address;
    }
    static shortenAddress(bech32, maxCharacters) {
        if (maxCharacters >= bech32.length) return bech32;
        const i = bech32.indexOf("1");
        const prefix = bech32.slice(0, i);
        const address = bech32.slice(i + 1);
        maxCharacters -= prefix.length;
        maxCharacters -= 3; // For "..."
        maxCharacters -= 1; // For "1"
        if (maxCharacters <= 0) return "";
        const mid = Math.floor(address.length / 2);
        let former = address.slice(0, mid);
        let latter = address.slice(mid);
        while(maxCharacters < former.length + latter.length)if ((former.length + latter.length) % 2 === 1 && former.length > 0) former = former.slice(0, former.length - 1);
        else latter = latter.slice(1);
        return prefix + "1" + former + "..." + latter;
    }
    static fromBech32(bech32Address, prefix) {
        const decoded = $ff9c1f2cd9baf8af$var$bech32_1.default.decode(bech32Address);
        if (prefix && decoded.prefix !== prefix) throw new Error("Unmatched prefix");
        return new $ff9c1f2cd9baf8af$var$Bech32Address(new Uint8Array($ff9c1f2cd9baf8af$var$bech32_1.fromWords(decoded.words)));
    }
    static validate(bech32Address, prefix) {
        const { prefix: decodedPrefix } = $ff9c1f2cd9baf8af$var$bech32_1.default.decode(bech32Address);
        if (prefix && prefix !== decodedPrefix) throw new Error(`Unexpected prefix (expected: ${prefix}, actual: ${decodedPrefix})`);
    }
    static defaultBech32Config(mainPrefix, validatorPrefix = "val", consensusPrefix = "cons", publicPrefix = "pub", operatorPrefix = "oper") {
        return {
            bech32PrefixAccAddr: mainPrefix,
            bech32PrefixAccPub: mainPrefix + publicPrefix,
            bech32PrefixValAddr: mainPrefix + validatorPrefix + operatorPrefix,
            bech32PrefixValPub: mainPrefix + validatorPrefix + operatorPrefix + publicPrefix,
            bech32PrefixConsAddr: mainPrefix + validatorPrefix + consensusPrefix,
            bech32PrefixConsPub: mainPrefix + validatorPrefix + consensusPrefix + publicPrefix
        };
    }
    toBech32(prefix) {
        const words = $ff9c1f2cd9baf8af$var$bech32_1.default.toWords(this.address);
        return $ff9c1f2cd9baf8af$var$bech32_1.default.encode(prefix, words);
    }
}
module.exports.Bech32Address = $ff9c1f2cd9baf8af$var$Bech32Address;

});

parcelRequire.register("4Ve8M", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ChainIdHelper = void 0;
class $395774564c11ab2c$var$ChainIdHelper {
    static parse(chainId) {
        const split = chainId.split($395774564c11ab2c$var$ChainIdHelper.VersionFormatRegExp).filter(Boolean);
        if (split.length !== 2) return {
            identifier: chainId,
            version: 0
        };
        else return {
            identifier: split[0],
            version: parseInt(split[1])
        };
    }
    static hasChainVersion(chainId) {
        const version = $395774564c11ab2c$var$ChainIdHelper.parse(chainId);
        return version.identifier !== chainId;
    }
}
module.exports.ChainIdHelper = $395774564c11ab2c$var$ChainIdHelper;
// VersionFormatRegExp checks if a chainID is in the format required for parsing versions
// The chainID should be in the form: `{identifier}-{version}`
$395774564c11ab2c$var$ChainIdHelper.VersionFormatRegExp = /(.+)-([\d]+)/;

});

parcelRequire.register("3kRIM", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TendermintTxTracer = void 0;

var $apDzW = parcelRequire("apDzW");

var $cXZjT = parcelRequire("cXZjT");
class $26dce94b375b0bff$var$TendermintTxTracer {
    constructor(url, wsEndpoint, options = {}){
        this.url = url;
        this.wsEndpoint = wsEndpoint;
        this.options = options;
        this.newBlockSubscribes = [];
        // Key is "id" for jsonrpc
        this.txSubscribes = new Map();
        // Key is "id" for jsonrpc
        this.pendingQueries = new Map();
        this.listeners = {};
        this.onOpen = (e)=>{
            var _a;
            if (this.newBlockSubscribes.length > 0) this.sendSubscribeBlockRpc();
            for (const [id, tx] of this.txSubscribes)this.sendSubscribeTxRpc(id, tx.hash);
            for (const [id, query] of this.pendingQueries)this.sendQueryRpc(id, query.method, query.params);
            for (const listener of (_a = this.listeners.open) !== null && _a !== void 0 ? _a : [])listener(e);
        };
        this.onMessage = (e)=>{
            var _a, _b, _c, _d, _e, _f;
            for (const listener of (_a = this.listeners.message) !== null && _a !== void 0 ? _a : [])listener(e);
            if (e.data) try {
                const obj = JSON.parse(e.data);
                if (obj === null || obj === void 0 ? void 0 : obj.id) {
                    if (this.pendingQueries.has(obj.id)) {
                        if (obj.error) // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                        this.pendingQueries.get(obj.id).rejector(new Error(obj.error.data || obj.error.message));
                        else // XXX: I'm not sure why this happens, but somtimes the form of tx id delivered under the "tx_result" field.
                        if ((_b = obj.result) === null || _b === void 0 ? void 0 : _b.tx_result) // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                        this.pendingQueries.get(obj.id).resolver(obj.result.tx_result);
                        else // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                        this.pendingQueries.get(obj.id).resolver(obj.result);
                        this.pendingQueries.delete(obj.id);
                    }
                }
                if (((_d = (_c = obj === null || obj === void 0 ? void 0 : obj.result) === null || _c === void 0 ? void 0 : _c.data) === null || _d === void 0 ? void 0 : _d.type) === "tendermint/event/NewBlock") for (const handler of this.newBlockSubscribes)handler.handler(obj.result.data.value);
                if (((_f = (_e = obj === null || obj === void 0 ? void 0 : obj.result) === null || _e === void 0 ? void 0 : _e.data) === null || _f === void 0 ? void 0 : _f.type) === "tendermint/event/Tx") {
                    if (obj === null || obj === void 0 ? void 0 : obj.id) {
                        if (this.txSubscribes.has(obj.id)) {
                            if (obj.error) // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                            this.txSubscribes.get(obj.id).rejector(new Error(obj.error.data || obj.error.message));
                            else // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                            this.txSubscribes.get(obj.id).resolver(obj.result.data.value.TxResult.result);
                            this.txSubscribes.delete(obj.id);
                        }
                    }
                }
            } catch (e) {
                console.log(`Tendermint websocket jsonrpc response is not JSON: ${e.message || e.toString()}`);
            }
        };
        this.onClose = (e)=>{
            var _a;
            for (const listener of (_a = this.listeners.close) !== null && _a !== void 0 ? _a : [])listener(e);
        };
        this.ws = this.options.wsObject ? new this.options.wsObject(this.getWsEndpoint()) : new WebSocket(this.getWsEndpoint());
        this.ws.onopen = this.onOpen;
        this.ws.onmessage = this.onMessage;
        this.ws.onclose = this.onClose;
    }
    getWsEndpoint() {
        let url = this.url;
        if (url.startsWith("http")) url = url.replace("http", "ws");
        if (!url.endsWith(this.wsEndpoint)) {
            const wsEndpoint = this.wsEndpoint.startsWith("/") ? this.wsEndpoint : "/" + this.wsEndpoint;
            url = url.endsWith("/") ? url + wsEndpoint.slice(1) : url + wsEndpoint;
        }
        return url;
    }
    close() {
        this.ws.close();
    }
    get readyState() {
        switch(this.ws.readyState){
            case 0:
                return $apDzW.WsReadyState.CONNECTING;
            case 1:
                return $apDzW.WsReadyState.OPEN;
            case 2:
                return $apDzW.WsReadyState.CLOSING;
            case 3:
                return $apDzW.WsReadyState.CLOSED;
            default:
                return $apDzW.WsReadyState.NONE;
        }
    }
    addEventListener(type, listener) {
        if (!this.listeners[type]) this.listeners[type] = [];
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        this.listeners[type].push(listener);
    }
    subscribeBlock(handler) {
        this.newBlockSubscribes.push({
            handler: handler
        });
        if (this.newBlockSubscribes.length === 1) this.sendSubscribeBlockRpc();
    }
    sendSubscribeBlockRpc() {
        if (this.readyState === $apDzW.WsReadyState.OPEN) this.ws.send(JSON.stringify({
            jsonrpc: "2.0",
            method: "subscribe",
            params: [
                "tm.event='NewBlock'"
            ],
            id: 1
        }));
    }
    // Query the tx and subscribe the tx.
    traceTx(hash) {
        return new Promise((resolve)=>{
            // At first, try to query the tx at the same time of subscribing the tx.
            // But, the querying's error will be ignored.
            this.queryTx(hash).then(resolve).catch(()=>{
            // noop
            });
            this.subscribeTx(hash).then(resolve);
        }).then((tx)=>{
            // Occasionally, even if the subscribe tx event occurs, the state through query is not changed yet.
            // Perhaps it is because the block has not been committed yet even though the result of deliverTx in tendermint is complete.
            // This method is usually used to reflect the state change through query when tx is completed.
            // The simplest solution is to just add a little delay.
            return new Promise((resolve)=>{
                setTimeout(()=>resolve(tx), 100);
            });
        });
    }
    subscribeTx(hash) {
        const id = this.createRandomId();
        return new Promise((resolve, reject)=>{
            this.txSubscribes.set(id, {
                hash: hash,
                resolver: resolve,
                rejector: reject
            });
            this.sendSubscribeTxRpc(id, hash);
        });
    }
    sendSubscribeTxRpc(id, hash) {
        if (this.readyState === $apDzW.WsReadyState.OPEN) this.ws.send(JSON.stringify({
            jsonrpc: "2.0",
            method: "subscribe",
            params: [
                `tm.event='Tx' AND tx.hash='${$cXZjT.Buffer.from(hash).toString("hex").toUpperCase()}'`
            ],
            id: id
        }));
    }
    queryTx(hash) {
        return this.query("tx", [
            $cXZjT.Buffer.from(hash).toString("base64"),
            false
        ]);
    }
    query(method, params) {
        const id = this.createRandomId();
        return new Promise((resolve, reject)=>{
            this.pendingQueries.set(id, {
                method: method,
                params: params,
                resolver: resolve,
                rejector: reject
            });
            this.sendQueryRpc(id, method, params);
        });
    }
    sendQueryRpc(id, method, params) {
        if (this.readyState === $apDzW.WsReadyState.OPEN) this.ws.send(JSON.stringify({
            jsonrpc: "2.0",
            method: method,
            params: params,
            id: id
        }));
    }
    createRandomId() {
        return parseInt(Array.from({
            length: 6
        }).map(()=>Math.floor(Math.random() * 100)).join(""));
    }
}
module.exports.TendermintTxTracer = $26dce94b375b0bff$var$TendermintTxTracer;

});
parcelRequire.register("apDzW", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.WsReadyState = void 0;
var $794af0b3813c95b3$var$WsReadyState;
(function(WsReadyState) {
    WsReadyState[WsReadyState["CONNECTING"] = 0] = "CONNECTING";
    WsReadyState[WsReadyState["OPEN"] = 1] = "OPEN";
    WsReadyState[WsReadyState["CLOSING"] = 2] = "CLOSING";
    WsReadyState[WsReadyState["CLOSED"] = 3] = "CLOSED";
    // WS is not initialized or the ready state of WS is unknown
    WsReadyState[WsReadyState["NONE"] = 4] = "NONE";
})($794af0b3813c95b3$var$WsReadyState = module.exports.WsReadyState || (module.exports.WsReadyState = {}));

});

parcelRequire.register("cXZjT", function(module, exports) {

$parcel$export(module.exports, "Buffer", function () { return $970a8f8fcd914322$export$a143d493d941bafc; }, function (v) { return $970a8f8fcd914322$export$a143d493d941bafc = v; });
$parcel$export(module.exports, "INSPECT_MAX_BYTES", function () { return $970a8f8fcd914322$export$f99ded8fe4b79145; }, function (v) { return $970a8f8fcd914322$export$f99ded8fe4b79145 = v; });
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ var $970a8f8fcd914322$export$a143d493d941bafc;
var $970a8f8fcd914322$export$e4cf37d7f6fb9e0a;
var $970a8f8fcd914322$export$f99ded8fe4b79145;
var $970a8f8fcd914322$export$599f31c3813fae4d;
"use strict";

var $hqZtu = parcelRequire("hqZtu");

var $5WQj6 = parcelRequire("5WQj6");
const $970a8f8fcd914322$var$customInspectSymbol = typeof Symbol === "function" && typeof Symbol["for"] === "function" // eslint-disable-line dot-notation
 ? Symbol["for"]("nodejs.util.inspect.custom") // eslint-disable-line dot-notation
 : null;
$970a8f8fcd914322$export$a143d493d941bafc = $970a8f8fcd914322$var$Buffer;
$970a8f8fcd914322$export$e4cf37d7f6fb9e0a = $970a8f8fcd914322$var$SlowBuffer;
$970a8f8fcd914322$export$f99ded8fe4b79145 = 50;
const $970a8f8fcd914322$var$K_MAX_LENGTH = 0x7fffffff;
$970a8f8fcd914322$export$599f31c3813fae4d = $970a8f8fcd914322$var$K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ $970a8f8fcd914322$var$Buffer.TYPED_ARRAY_SUPPORT = $970a8f8fcd914322$var$typedArraySupport();
if (!$970a8f8fcd914322$var$Buffer.TYPED_ARRAY_SUPPORT && typeof console !== "undefined" && typeof console.error === "function") console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function $970a8f8fcd914322$var$typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        const arr = new Uint8Array(1);
        const proto = {
            foo: function() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty($970a8f8fcd914322$var$Buffer.prototype, "parent", {
    enumerable: true,
    get: function() {
        if (!$970a8f8fcd914322$var$Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty($970a8f8fcd914322$var$Buffer.prototype, "offset", {
    enumerable: true,
    get: function() {
        if (!$970a8f8fcd914322$var$Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function $970a8f8fcd914322$var$createBuffer(length) {
    if (length > $970a8f8fcd914322$var$K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    const buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, $970a8f8fcd914322$var$Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $970a8f8fcd914322$var$Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === "number") {
        if (typeof encodingOrOffset === "string") throw new TypeError('The "string" argument must be of type string. Received type number');
        return $970a8f8fcd914322$var$allocUnsafe(arg);
    }
    return $970a8f8fcd914322$var$from(arg, encodingOrOffset, length);
}
$970a8f8fcd914322$var$Buffer.poolSize = 8192 // not used by this implementation
;
function $970a8f8fcd914322$var$from(value, encodingOrOffset, length) {
    if (typeof value === "string") return $970a8f8fcd914322$var$fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return $970a8f8fcd914322$var$fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
    if ($970a8f8fcd914322$var$isInstance(value, ArrayBuffer) || value && $970a8f8fcd914322$var$isInstance(value.buffer, ArrayBuffer)) return $970a8f8fcd914322$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== "undefined" && ($970a8f8fcd914322$var$isInstance(value, SharedArrayBuffer) || value && $970a8f8fcd914322$var$isInstance(value.buffer, SharedArrayBuffer))) return $970a8f8fcd914322$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === "number") throw new TypeError('The "value" argument must not be of type number. Received type number');
    const valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return $970a8f8fcd914322$var$Buffer.from(valueOf, encodingOrOffset, length);
    const b = $970a8f8fcd914322$var$fromObject(value);
    if (b) return b;
    if (typeof Symbol !== "undefined" && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === "function") return $970a8f8fcd914322$var$Buffer.from(value[Symbol.toPrimitive]("string"), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $970a8f8fcd914322$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $970a8f8fcd914322$var$from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf($970a8f8fcd914322$var$Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf($970a8f8fcd914322$var$Buffer, Uint8Array);
function $970a8f8fcd914322$var$assertSize(size) {
    if (typeof size !== "number") throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function $970a8f8fcd914322$var$alloc(size, fill, encoding) {
    $970a8f8fcd914322$var$assertSize(size);
    if (size <= 0) return $970a8f8fcd914322$var$createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === "string" ? $970a8f8fcd914322$var$createBuffer(size).fill(fill, encoding) : $970a8f8fcd914322$var$createBuffer(size).fill(fill);
    return $970a8f8fcd914322$var$createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $970a8f8fcd914322$var$Buffer.alloc = function(size, fill, encoding) {
    return $970a8f8fcd914322$var$alloc(size, fill, encoding);
};
function $970a8f8fcd914322$var$allocUnsafe(size) {
    $970a8f8fcd914322$var$assertSize(size);
    return $970a8f8fcd914322$var$createBuffer(size < 0 ? 0 : $970a8f8fcd914322$var$checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $970a8f8fcd914322$var$Buffer.allocUnsafe = function(size) {
    return $970a8f8fcd914322$var$allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $970a8f8fcd914322$var$Buffer.allocUnsafeSlow = function(size) {
    return $970a8f8fcd914322$var$allocUnsafe(size);
};
function $970a8f8fcd914322$var$fromString(string, encoding) {
    if (typeof encoding !== "string" || encoding === "") encoding = "utf8";
    if (!$970a8f8fcd914322$var$Buffer.isEncoding(encoding)) throw new TypeError("Unknown encoding: " + encoding);
    const length = $970a8f8fcd914322$var$byteLength(string, encoding) | 0;
    let buf = $970a8f8fcd914322$var$createBuffer(length);
    const actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function $970a8f8fcd914322$var$fromArrayLike(array) {
    const length = array.length < 0 ? 0 : $970a8f8fcd914322$var$checked(array.length) | 0;
    const buf = $970a8f8fcd914322$var$createBuffer(length);
    for(let i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function $970a8f8fcd914322$var$fromArrayView(arrayView) {
    if ($970a8f8fcd914322$var$isInstance(arrayView, Uint8Array)) {
        const copy = new Uint8Array(arrayView);
        return $970a8f8fcd914322$var$fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return $970a8f8fcd914322$var$fromArrayLike(arrayView);
}
function $970a8f8fcd914322$var$fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    let buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, $970a8f8fcd914322$var$Buffer.prototype);
    return buf;
}
function $970a8f8fcd914322$var$fromObject(obj) {
    if ($970a8f8fcd914322$var$Buffer.isBuffer(obj)) {
        const len = $970a8f8fcd914322$var$checked(obj.length) | 0;
        const buf = $970a8f8fcd914322$var$createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== "number" || $970a8f8fcd914322$var$numberIsNaN(obj.length)) return $970a8f8fcd914322$var$createBuffer(0);
        return $970a8f8fcd914322$var$fromArrayLike(obj);
    }
    if (obj.type === "Buffer" && Array.isArray(obj.data)) return $970a8f8fcd914322$var$fromArrayLike(obj.data);
}
function $970a8f8fcd914322$var$checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $970a8f8fcd914322$var$K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $970a8f8fcd914322$var$K_MAX_LENGTH.toString(16) + " bytes");
    return length | 0;
}
function $970a8f8fcd914322$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $970a8f8fcd914322$var$Buffer.alloc(+length);
}
$970a8f8fcd914322$var$Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== $970a8f8fcd914322$var$Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
$970a8f8fcd914322$var$Buffer.compare = function compare(a, b) {
    if ($970a8f8fcd914322$var$isInstance(a, Uint8Array)) a = $970a8f8fcd914322$var$Buffer.from(a, a.offset, a.byteLength);
    if ($970a8f8fcd914322$var$isInstance(b, Uint8Array)) b = $970a8f8fcd914322$var$Buffer.from(b, b.offset, b.byteLength);
    if (!$970a8f8fcd914322$var$Buffer.isBuffer(a) || !$970a8f8fcd914322$var$Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    let x = a.length;
    let y = b.length;
    for(let i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$970a8f8fcd914322$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case "hex":
        case "utf8":
        case "utf-8":
        case "ascii":
        case "latin1":
        case "binary":
        case "base64":
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return true;
        default:
            return false;
    }
};
$970a8f8fcd914322$var$Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $970a8f8fcd914322$var$Buffer.alloc(0);
    let i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    const buffer = $970a8f8fcd914322$var$Buffer.allocUnsafe(length);
    let pos = 0;
    for(i = 0; i < list.length; ++i){
        let buf = list[i];
        if ($970a8f8fcd914322$var$isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) {
                if (!$970a8f8fcd914322$var$Buffer.isBuffer(buf)) buf = $970a8f8fcd914322$var$Buffer.from(buf);
                buf.copy(buffer, pos);
            } else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!$970a8f8fcd914322$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $970a8f8fcd914322$var$byteLength(string, encoding) {
    if ($970a8f8fcd914322$var$Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || $970a8f8fcd914322$var$isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== "string") throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string);
    const len = string.length;
    const mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    let loweredCase = false;
    for(;;)switch(encoding){
        case "ascii":
        case "latin1":
        case "binary":
            return len;
        case "utf8":
        case "utf-8":
            return $970a8f8fcd914322$var$utf8ToBytes(string).length;
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return len * 2;
        case "hex":
            return len >>> 1;
        case "base64":
            return $970a8f8fcd914322$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : $970a8f8fcd914322$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ("" + encoding).toLowerCase();
            loweredCase = true;
    }
}
$970a8f8fcd914322$var$Buffer.byteLength = $970a8f8fcd914322$var$byteLength;
function $970a8f8fcd914322$var$slowToString(encoding, start, end) {
    let loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return "";
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return "";
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return "";
    if (!encoding) encoding = "utf8";
    while(true)switch(encoding){
        case "hex":
            return $970a8f8fcd914322$var$hexSlice(this, start, end);
        case "utf8":
        case "utf-8":
            return $970a8f8fcd914322$var$utf8Slice(this, start, end);
        case "ascii":
            return $970a8f8fcd914322$var$asciiSlice(this, start, end);
        case "latin1":
        case "binary":
            return $970a8f8fcd914322$var$latin1Slice(this, start, end);
        case "base64":
            return $970a8f8fcd914322$var$base64Slice(this, start, end);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return $970a8f8fcd914322$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
            encoding = (encoding + "").toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
$970a8f8fcd914322$var$Buffer.prototype._isBuffer = true;
function $970a8f8fcd914322$var$swap(b, n, m) {
    const i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$970a8f8fcd914322$var$Buffer.prototype.swap16 = function swap16() {
    const len = this.length;
    if (len % 2 !== 0) throw new RangeError("Buffer size must be a multiple of 16-bits");
    for(let i = 0; i < len; i += 2)$970a8f8fcd914322$var$swap(this, i, i + 1);
    return this;
};
$970a8f8fcd914322$var$Buffer.prototype.swap32 = function swap32() {
    const len = this.length;
    if (len % 4 !== 0) throw new RangeError("Buffer size must be a multiple of 32-bits");
    for(let i = 0; i < len; i += 4){
        $970a8f8fcd914322$var$swap(this, i, i + 3);
        $970a8f8fcd914322$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$970a8f8fcd914322$var$Buffer.prototype.swap64 = function swap64() {
    const len = this.length;
    if (len % 8 !== 0) throw new RangeError("Buffer size must be a multiple of 64-bits");
    for(let i = 0; i < len; i += 8){
        $970a8f8fcd914322$var$swap(this, i, i + 7);
        $970a8f8fcd914322$var$swap(this, i + 1, i + 6);
        $970a8f8fcd914322$var$swap(this, i + 2, i + 5);
        $970a8f8fcd914322$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$970a8f8fcd914322$var$Buffer.prototype.toString = function toString() {
    const length = this.length;
    if (length === 0) return "";
    if (arguments.length === 0) return $970a8f8fcd914322$var$utf8Slice(this, 0, length);
    return $970a8f8fcd914322$var$slowToString.apply(this, arguments);
};
$970a8f8fcd914322$var$Buffer.prototype.toLocaleString = $970a8f8fcd914322$var$Buffer.prototype.toString;
$970a8f8fcd914322$var$Buffer.prototype.equals = function equals(b) {
    if (!$970a8f8fcd914322$var$Buffer.isBuffer(b)) throw new TypeError("Argument must be a Buffer");
    if (this === b) return true;
    return $970a8f8fcd914322$var$Buffer.compare(this, b) === 0;
};
$970a8f8fcd914322$var$Buffer.prototype.inspect = function inspect() {
    let str = "";
    const max = $970a8f8fcd914322$export$f99ded8fe4b79145;
    str = this.toString("hex", 0, max).replace(/(.{2})/g, "$1 ").trim();
    if (this.length > max) str += " ... ";
    return "<Buffer " + str + ">";
};
if ($970a8f8fcd914322$var$customInspectSymbol) $970a8f8fcd914322$var$Buffer.prototype[$970a8f8fcd914322$var$customInspectSymbol] = $970a8f8fcd914322$var$Buffer.prototype.inspect;
$970a8f8fcd914322$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if ($970a8f8fcd914322$var$isInstance(target, Uint8Array)) target = $970a8f8fcd914322$var$Buffer.from(target, target.offset, target.byteLength);
    if (!$970a8f8fcd914322$var$Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target);
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError("out of range index");
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    let x = thisEnd - thisStart;
    let y = end - start;
    const len = Math.min(x, y);
    const thisCopy = this.slice(thisStart, thisEnd);
    const targetCopy = target.slice(start, end);
    for(let i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $970a8f8fcd914322$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === "string") {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if ($970a8f8fcd914322$var$numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === "string") val = $970a8f8fcd914322$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($970a8f8fcd914322$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $970a8f8fcd914322$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === "number") {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === "function") {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $970a8f8fcd914322$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError("val must be string, number or Buffer");
}
function $970a8f8fcd914322$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    let indexSize = 1;
    let arrLength = arr.length;
    let valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === "ucs2" || encoding === "ucs-2" || encoding === "utf16le" || encoding === "utf-16le") {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    let i;
    if (dir) {
        let foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            let found = true;
            for(let j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$970a8f8fcd914322$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$970a8f8fcd914322$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $970a8f8fcd914322$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$970a8f8fcd914322$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $970a8f8fcd914322$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $970a8f8fcd914322$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    const remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    const strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    let i;
    for(i = 0; i < length; ++i){
        const parsed = parseInt(string.substr(i * 2, 2), 16);
        if ($970a8f8fcd914322$var$numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $970a8f8fcd914322$var$utf8Write(buf, string, offset, length) {
    return $970a8f8fcd914322$var$blitBuffer($970a8f8fcd914322$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $970a8f8fcd914322$var$asciiWrite(buf, string, offset, length) {
    return $970a8f8fcd914322$var$blitBuffer($970a8f8fcd914322$var$asciiToBytes(string), buf, offset, length);
}
function $970a8f8fcd914322$var$base64Write(buf, string, offset, length) {
    return $970a8f8fcd914322$var$blitBuffer($970a8f8fcd914322$var$base64ToBytes(string), buf, offset, length);
}
function $970a8f8fcd914322$var$ucs2Write(buf, string, offset, length) {
    return $970a8f8fcd914322$var$blitBuffer($970a8f8fcd914322$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$970a8f8fcd914322$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = "utf8";
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === "string") {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = "utf8";
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error("Buffer.write(string, encoding, offset[, length]) is no longer supported");
    const remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError("Attempt to write outside buffer bounds");
    if (!encoding) encoding = "utf8";
    let loweredCase = false;
    for(;;)switch(encoding){
        case "hex":
            return $970a8f8fcd914322$var$hexWrite(this, string, offset, length);
        case "utf8":
        case "utf-8":
            return $970a8f8fcd914322$var$utf8Write(this, string, offset, length);
        case "ascii":
        case "latin1":
        case "binary":
            return $970a8f8fcd914322$var$asciiWrite(this, string, offset, length);
        case "base64":
            // Warning: maxLength not taken into account in base64Write
            return $970a8f8fcd914322$var$base64Write(this, string, offset, length);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return $970a8f8fcd914322$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
            encoding = ("" + encoding).toLowerCase();
            loweredCase = true;
    }
};
$970a8f8fcd914322$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: "Buffer",
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $970a8f8fcd914322$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $hqZtu.fromByteArray(buf);
    else return $hqZtu.fromByteArray(buf.slice(start, end));
}
function $970a8f8fcd914322$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    const res = [];
    let i = start;
    while(i < end){
        const firstByte = buf[i];
        let codePoint = null;
        let bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            let secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $970a8f8fcd914322$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
const $970a8f8fcd914322$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $970a8f8fcd914322$var$decodeCodePointsArray(codePoints) {
    const len = codePoints.length;
    if (len <= $970a8f8fcd914322$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    let res = "";
    let i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $970a8f8fcd914322$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $970a8f8fcd914322$var$asciiSlice(buf, start, end) {
    let ret = "";
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $970a8f8fcd914322$var$latin1Slice(buf, start, end) {
    let ret = "";
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $970a8f8fcd914322$var$hexSlice(buf, start, end) {
    const len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    let out = "";
    for(let i = start; i < end; ++i)out += $970a8f8fcd914322$var$hexSliceLookupTable[buf[i]];
    return out;
}
function $970a8f8fcd914322$var$utf16leSlice(buf, start, end) {
    const bytes = buf.slice(start, end);
    let res = "";
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(let i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$970a8f8fcd914322$var$Buffer.prototype.slice = function slice(start, end) {
    const len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    const newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, $970a8f8fcd914322$var$Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $970a8f8fcd914322$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError("offset is not uint");
    if (offset + ext > length) throw new RangeError("Trying to access beyond buffer length");
}
$970a8f8fcd914322$var$Buffer.prototype.readUintLE = $970a8f8fcd914322$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $970a8f8fcd914322$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$970a8f8fcd914322$var$Buffer.prototype.readUintBE = $970a8f8fcd914322$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $970a8f8fcd914322$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset + --byteLength];
    let mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$970a8f8fcd914322$var$Buffer.prototype.readUint8 = $970a8f8fcd914322$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $970a8f8fcd914322$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$970a8f8fcd914322$var$Buffer.prototype.readUint16LE = $970a8f8fcd914322$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $970a8f8fcd914322$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$970a8f8fcd914322$var$Buffer.prototype.readUint16BE = $970a8f8fcd914322$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $970a8f8fcd914322$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$970a8f8fcd914322$var$Buffer.prototype.readUint32LE = $970a8f8fcd914322$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $970a8f8fcd914322$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$970a8f8fcd914322$var$Buffer.prototype.readUint32BE = $970a8f8fcd914322$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $970a8f8fcd914322$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$970a8f8fcd914322$var$Buffer.prototype.readBigUInt64LE = $970a8f8fcd914322$var$defineBigIntMethod(function readBigUInt64LE(offset) {
    offset = offset >>> 0;
    $970a8f8fcd914322$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $970a8f8fcd914322$var$boundsError(offset, this.length - 8);
    const lo = first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24;
    const hi = this[++offset] + this[++offset] * 256 + this[++offset] * 2 ** 16 + last * 2 ** 24;
    return BigInt(lo) + (BigInt(hi) << BigInt(32));
});
$970a8f8fcd914322$var$Buffer.prototype.readBigUInt64BE = $970a8f8fcd914322$var$defineBigIntMethod(function readBigUInt64BE(offset) {
    offset = offset >>> 0;
    $970a8f8fcd914322$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $970a8f8fcd914322$var$boundsError(offset, this.length - 8);
    const hi = first * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    const lo = this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last;
    return (BigInt(hi) << BigInt(32)) + BigInt(lo);
});
$970a8f8fcd914322$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $970a8f8fcd914322$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$970a8f8fcd914322$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $970a8f8fcd914322$var$checkOffset(offset, byteLength, this.length);
    let i = byteLength;
    let mul = 1;
    let val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$970a8f8fcd914322$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $970a8f8fcd914322$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$970a8f8fcd914322$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $970a8f8fcd914322$var$checkOffset(offset, 2, this.length);
    const val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$970a8f8fcd914322$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $970a8f8fcd914322$var$checkOffset(offset, 2, this.length);
    const val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$970a8f8fcd914322$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $970a8f8fcd914322$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$970a8f8fcd914322$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $970a8f8fcd914322$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$970a8f8fcd914322$var$Buffer.prototype.readBigInt64LE = $970a8f8fcd914322$var$defineBigIntMethod(function readBigInt64LE(offset) {
    offset = offset >>> 0;
    $970a8f8fcd914322$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $970a8f8fcd914322$var$boundsError(offset, this.length - 8);
    const val = this[offset + 4] + this[offset + 5] * 256 + this[offset + 6] * 2 ** 16 + (last << 24 // Overflow
    );
    return (BigInt(val) << BigInt(32)) + BigInt(first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24);
});
$970a8f8fcd914322$var$Buffer.prototype.readBigInt64BE = $970a8f8fcd914322$var$defineBigIntMethod(function readBigInt64BE(offset) {
    offset = offset >>> 0;
    $970a8f8fcd914322$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $970a8f8fcd914322$var$boundsError(offset, this.length - 8);
    const val = (first << 24) + // Overflow
    this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    return (BigInt(val) << BigInt(32)) + BigInt(this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last);
});
$970a8f8fcd914322$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $970a8f8fcd914322$var$checkOffset(offset, 4, this.length);
    return $5WQj6.read(this, offset, true, 23, 4);
};
$970a8f8fcd914322$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $970a8f8fcd914322$var$checkOffset(offset, 4, this.length);
    return $5WQj6.read(this, offset, false, 23, 4);
};
$970a8f8fcd914322$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $970a8f8fcd914322$var$checkOffset(offset, 8, this.length);
    return $5WQj6.read(this, offset, true, 52, 8);
};
$970a8f8fcd914322$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $970a8f8fcd914322$var$checkOffset(offset, 8, this.length);
    return $5WQj6.read(this, offset, false, 52, 8);
};
function $970a8f8fcd914322$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$970a8f8fcd914322$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError("Index out of range");
}
$970a8f8fcd914322$var$Buffer.prototype.writeUintLE = $970a8f8fcd914322$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $970a8f8fcd914322$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let mul = 1;
    let i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$970a8f8fcd914322$var$Buffer.prototype.writeUintBE = $970a8f8fcd914322$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $970a8f8fcd914322$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let i = byteLength - 1;
    let mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$970a8f8fcd914322$var$Buffer.prototype.writeUint8 = $970a8f8fcd914322$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $970a8f8fcd914322$var$checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
$970a8f8fcd914322$var$Buffer.prototype.writeUint16LE = $970a8f8fcd914322$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $970a8f8fcd914322$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$970a8f8fcd914322$var$Buffer.prototype.writeUint16BE = $970a8f8fcd914322$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $970a8f8fcd914322$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$970a8f8fcd914322$var$Buffer.prototype.writeUint32LE = $970a8f8fcd914322$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $970a8f8fcd914322$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
$970a8f8fcd914322$var$Buffer.prototype.writeUint32BE = $970a8f8fcd914322$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $970a8f8fcd914322$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function $970a8f8fcd914322$var$wrtBigUInt64LE(buf, value, offset, min, max) {
    $970a8f8fcd914322$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    return offset;
}
function $970a8f8fcd914322$var$wrtBigUInt64BE(buf, value, offset, min, max) {
    $970a8f8fcd914322$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset + 7] = lo;
    lo = lo >> 8;
    buf[offset + 6] = lo;
    lo = lo >> 8;
    buf[offset + 5] = lo;
    lo = lo >> 8;
    buf[offset + 4] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset + 3] = hi;
    hi = hi >> 8;
    buf[offset + 2] = hi;
    hi = hi >> 8;
    buf[offset + 1] = hi;
    hi = hi >> 8;
    buf[offset] = hi;
    return offset + 8;
}
$970a8f8fcd914322$var$Buffer.prototype.writeBigUInt64LE = $970a8f8fcd914322$var$defineBigIntMethod(function writeBigUInt64LE(value, offset = 0) {
    return $970a8f8fcd914322$var$wrtBigUInt64LE(this, value, offset, BigInt(0), BigInt("0xffffffffffffffff"));
});
$970a8f8fcd914322$var$Buffer.prototype.writeBigUInt64BE = $970a8f8fcd914322$var$defineBigIntMethod(function writeBigUInt64BE(value, offset = 0) {
    return $970a8f8fcd914322$var$wrtBigUInt64BE(this, value, offset, BigInt(0), BigInt("0xffffffffffffffff"));
});
$970a8f8fcd914322$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $970a8f8fcd914322$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = 0;
    let mul = 1;
    let sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$970a8f8fcd914322$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $970a8f8fcd914322$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = byteLength - 1;
    let mul = 1;
    let sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$970a8f8fcd914322$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $970a8f8fcd914322$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$970a8f8fcd914322$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $970a8f8fcd914322$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$970a8f8fcd914322$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $970a8f8fcd914322$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$970a8f8fcd914322$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $970a8f8fcd914322$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
$970a8f8fcd914322$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $970a8f8fcd914322$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
$970a8f8fcd914322$var$Buffer.prototype.writeBigInt64LE = $970a8f8fcd914322$var$defineBigIntMethod(function writeBigInt64LE(value, offset = 0) {
    return $970a8f8fcd914322$var$wrtBigUInt64LE(this, value, offset, -BigInt("0x8000000000000000"), BigInt("0x7fffffffffffffff"));
});
$970a8f8fcd914322$var$Buffer.prototype.writeBigInt64BE = $970a8f8fcd914322$var$defineBigIntMethod(function writeBigInt64BE(value, offset = 0) {
    return $970a8f8fcd914322$var$wrtBigUInt64BE(this, value, offset, -BigInt("0x8000000000000000"), BigInt("0x7fffffffffffffff"));
});
function $970a8f8fcd914322$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError("Index out of range");
    if (offset < 0) throw new RangeError("Index out of range");
}
function $970a8f8fcd914322$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $970a8f8fcd914322$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $5WQj6.write(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$970a8f8fcd914322$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $970a8f8fcd914322$var$writeFloat(this, value, offset, true, noAssert);
};
$970a8f8fcd914322$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $970a8f8fcd914322$var$writeFloat(this, value, offset, false, noAssert);
};
function $970a8f8fcd914322$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $970a8f8fcd914322$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $5WQj6.write(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$970a8f8fcd914322$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $970a8f8fcd914322$var$writeDouble(this, value, offset, true, noAssert);
};
$970a8f8fcd914322$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $970a8f8fcd914322$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$970a8f8fcd914322$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!$970a8f8fcd914322$var$Buffer.isBuffer(target)) throw new TypeError("argument should be a Buffer");
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError("targetStart out of bounds");
    if (start < 0 || start >= this.length) throw new RangeError("Index out of range");
    if (end < 0) throw new RangeError("sourceEnd out of bounds");
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    const len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === "function") // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$970a8f8fcd914322$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === "string") {
        if (typeof start === "string") {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === "string") {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== "string") throw new TypeError("encoding must be a string");
        if (typeof encoding === "string" && !$970a8f8fcd914322$var$Buffer.isEncoding(encoding)) throw new TypeError("Unknown encoding: " + encoding);
        if (val.length === 1) {
            const code = val.charCodeAt(0);
            if (encoding === "utf8" && code < 128 || encoding === "latin1") // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === "number") val = val & 255;
    else if (typeof val === "boolean") val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError("Out of range index");
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    let i;
    if (typeof val === "number") for(i = start; i < end; ++i)this[i] = val;
    else {
        const bytes = $970a8f8fcd914322$var$Buffer.isBuffer(val) ? val : $970a8f8fcd914322$var$Buffer.from(val, encoding);
        const len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// CUSTOM ERRORS
// =============
// Simplified versions from Node, changed for Buffer-only usage
const $970a8f8fcd914322$var$errors = {};
function $970a8f8fcd914322$var$E(sym, getMessage, Base) {
    $970a8f8fcd914322$var$errors[sym] = class NodeError extends Base {
        constructor(){
            super();
            Object.defineProperty(this, "message", {
                value: getMessage.apply(this, arguments),
                writable: true,
                configurable: true
            });
            // Add the error code to the name to include it in the stack trace.
            this.name = `${this.name} [${sym}]`;
            // Access the stack to generate the error message including the error code
            // from the name.
            this.stack // eslint-disable-line no-unused-expressions
            ;
            // Reset the name to the actual name.
            delete this.name;
        }
        get code() {
            return sym;
        }
        set code(value) {
            Object.defineProperty(this, "code", {
                configurable: true,
                enumerable: true,
                value: value,
                writable: true
            });
        }
        toString() {
            return `${this.name} [${sym}]: ${this.message}`;
        }
    };
}
$970a8f8fcd914322$var$E("ERR_BUFFER_OUT_OF_BOUNDS", function(name) {
    if (name) return `${name} is outside of buffer bounds`;
    return "Attempt to access memory outside buffer bounds";
}, RangeError);
$970a8f8fcd914322$var$E("ERR_INVALID_ARG_TYPE", function(name, actual) {
    return `The "${name}" argument must be of type number. Received type ${typeof actual}`;
}, TypeError);
$970a8f8fcd914322$var$E("ERR_OUT_OF_RANGE", function(str, range, input) {
    let msg = `The value of "${str}" is out of range.`;
    let received = input;
    if (Number.isInteger(input) && Math.abs(input) > 2 ** 32) received = $970a8f8fcd914322$var$addNumericalSeparator(String(input));
    else if (typeof input === "bigint") {
        received = String(input);
        if (input > BigInt(2) ** BigInt(32) || input < -(BigInt(2) ** BigInt(32))) received = $970a8f8fcd914322$var$addNumericalSeparator(received);
        received += "n";
    }
    msg += ` It must be ${range}. Received ${received}`;
    return msg;
}, RangeError);
function $970a8f8fcd914322$var$addNumericalSeparator(val) {
    let res = "";
    let i = val.length;
    const start = val[0] === "-" ? 1 : 0;
    for(; i >= start + 4; i -= 3)res = `_${val.slice(i - 3, i)}${res}`;
    return `${val.slice(0, i)}${res}`;
}
// CHECK FUNCTIONS
// ===============
function $970a8f8fcd914322$var$checkBounds(buf, offset, byteLength) {
    $970a8f8fcd914322$var$validateNumber(offset, "offset");
    if (buf[offset] === undefined || buf[offset + byteLength] === undefined) $970a8f8fcd914322$var$boundsError(offset, buf.length - (byteLength + 1));
}
function $970a8f8fcd914322$var$checkIntBI(value, min, max, buf, offset, byteLength) {
    if (value > max || value < min) {
        const n = typeof min === "bigint" ? "n" : "";
        let range;
        if (byteLength > 3) {
            if (min === 0 || min === BigInt(0)) range = `>= 0${n} and < 2${n} ** ${(byteLength + 1) * 8}${n}`;
            else range = `>= -(2${n} ** ${(byteLength + 1) * 8 - 1}${n}) and < 2 ** ` + `${(byteLength + 1) * 8 - 1}${n}`;
        } else range = `>= ${min}${n} and <= ${max}${n}`;
        throw new $970a8f8fcd914322$var$errors.ERR_OUT_OF_RANGE("value", range, value);
    }
    $970a8f8fcd914322$var$checkBounds(buf, offset, byteLength);
}
function $970a8f8fcd914322$var$validateNumber(value, name) {
    if (typeof value !== "number") throw new $970a8f8fcd914322$var$errors.ERR_INVALID_ARG_TYPE(name, "number", value);
}
function $970a8f8fcd914322$var$boundsError(value, length, type) {
    if (Math.floor(value) !== value) {
        $970a8f8fcd914322$var$validateNumber(value, type);
        throw new $970a8f8fcd914322$var$errors.ERR_OUT_OF_RANGE(type || "offset", "an integer", value);
    }
    if (length < 0) throw new $970a8f8fcd914322$var$errors.ERR_BUFFER_OUT_OF_BOUNDS();
    throw new $970a8f8fcd914322$var$errors.ERR_OUT_OF_RANGE(type || "offset", `>= ${type ? 1 : 0} and <= ${length}`, value);
}
// HELPER FUNCTIONS
// ================
const $970a8f8fcd914322$var$INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function $970a8f8fcd914322$var$base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split("=")[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace($970a8f8fcd914322$var$INVALID_BASE64_RE, "");
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return "";
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + "=";
    return str;
}
function $970a8f8fcd914322$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    let codePoint;
    const length = string.length;
    let leadSurrogate = null;
    const bytes = [];
    for(let i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error("Invalid code point");
    }
    return bytes;
}
function $970a8f8fcd914322$var$asciiToBytes(str) {
    const byteArray = [];
    for(let i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $970a8f8fcd914322$var$utf16leToBytes(str, units) {
    let c, hi, lo;
    const byteArray = [];
    for(let i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $970a8f8fcd914322$var$base64ToBytes(str) {
    return $hqZtu.toByteArray($970a8f8fcd914322$var$base64clean(str));
}
function $970a8f8fcd914322$var$blitBuffer(src, dst, offset, length) {
    let i;
    for(i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function $970a8f8fcd914322$var$isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function $970a8f8fcd914322$var$numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
const $970a8f8fcd914322$var$hexSliceLookupTable = function() {
    const alphabet = "0123456789abcdef";
    const table = new Array(256);
    for(let i = 0; i < 16; ++i){
        const i16 = i * 16;
        for(let j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();
// Return not function with Error if BigInt not supported
function $970a8f8fcd914322$var$defineBigIntMethod(fn) {
    return typeof BigInt === "undefined" ? $970a8f8fcd914322$var$BufferBigIntNotDefined : fn;
}
function $970a8f8fcd914322$var$BufferBigIntNotDefined() {
    throw new Error("BigInt not supported");
}

});


parcelRequire.register("cDipa", function(module, exports) {
"use strict";
var $93276766e1c4d3c8$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, {
        enumerable: true,
        get: function() {
            return m[k];
        }
    });
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $93276766e1c4d3c8$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $93276766e1c4d3c8$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$93276766e1c4d3c8$var$__exportStar((parcelRequire("7jGk0")), module.exports);

$93276766e1c4d3c8$var$__exportStar((parcelRequire("juMXV")), module.exports);

$93276766e1c4d3c8$var$__exportStar((parcelRequire("g0kvf")), module.exports);

$93276766e1c4d3c8$var$__exportStar((parcelRequire("5AbUo")), module.exports);

});
parcelRequire.register("7jGk0", function(module, exports) {
"use strict";
var $553b22f5c6975bda$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, {
        enumerable: true,
        get: function() {
            return m[k];
        }
    });
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $553b22f5c6975bda$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $553b22f5c6975bda$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.defaultProtoCodec = module.exports.ProtoCodec = void 0;

var $juMXV = parcelRequire("juMXV");

var $juMXV = parcelRequire("juMXV");


$553b22f5c6975bda$var$__exportStar((parcelRequire("dHVad")), module.exports);
class $553b22f5c6975bda$var$ProtoCodec {
    constructor(){
        this.typeUrlMap = new Map();
    }
    /**
     * Unpack the any to the registered message.
     * NOTE: If there is no matched message, it will not throw an error but return the `UnknownMessage` class.
     * @param iAny
     */ unpackAny(iAny) {
        const any = new $juMXV.google.protobuf.Any(iAny);
        if (!this.typeUrlMap.has(any.type_url)) return new (parcelRequire("dHVad")).UnknownMessage(any.type_url, any.value);
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        return this.typeUrlMap.get(any.type_url).decode(any.value);
    }
    registerAny(typeUrl, message) {
        this.typeUrlMap.set(typeUrl, message);
    }
}
module.exports.ProtoCodec = $553b22f5c6975bda$var$ProtoCodec;
module.exports.defaultProtoCodec = new $553b22f5c6975bda$var$ProtoCodec();
module.exports.defaultProtoCodec.registerAny("/cosmos.bank.v1beta1.MsgSend", $juMXV.cosmos.bank.v1beta1.MsgSend);
module.exports.defaultProtoCodec.registerAny("/cosmos.staking.v1beta1.MsgDelegate", $juMXV.cosmos.staking.v1beta1.MsgDelegate);
module.exports.defaultProtoCodec.registerAny("/cosmos.staking.v1beta1.MsgUndelegate", $juMXV.cosmos.staking.v1beta1.MsgUndelegate);
module.exports.defaultProtoCodec.registerAny("/cosmos.staking.v1beta1.MsgBeginRedelegate", $juMXV.cosmos.staking.v1beta1.MsgBeginRedelegate);
module.exports.defaultProtoCodec.registerAny("/cosmwasm.wasm.v1.MsgExecuteContract", $juMXV.cosmwasm.wasm.v1.MsgExecuteContract);

});
parcelRequire.register("juMXV", function(module, exports) {
"use strict";
var $e316cd36c242d13d$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, {
        enumerable: true,
        get: function() {
            return m[k];
        }
    });
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $e316cd36c242d13d$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $e316cd36c242d13d$var$__createBinding(exports1, m, p);
};
var $e316cd36c242d13d$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

const $e316cd36c242d13d$var$long_1 = $e316cd36c242d13d$var$__importDefault((parcelRequire("jRkuS")));

const $e316cd36c242d13d$var$minimal_1 = $e316cd36c242d13d$var$__importDefault((parcelRequire("fQBv0")));
$e316cd36c242d13d$var$minimal_1.default.util.Long = $e316cd36c242d13d$var$long_1.default;
$e316cd36c242d13d$var$minimal_1.default.configure();

$e316cd36c242d13d$var$__exportStar((parcelRequire("iEAuM")), module.exports);

});
parcelRequire.register("iEAuM", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.tendermint = module.exports.cosmwasm = module.exports.ibc = module.exports.google = module.exports.cosmos = void 0;

var $fQBv0 = parcelRequire("fQBv0");
const $d94845a59d001d47$var$$Reader = $fQBv0.Reader, $d94845a59d001d47$var$$Writer = $fQBv0.Writer, $d94845a59d001d47$var$$util = $fQBv0.util;
const $d94845a59d001d47$var$$root = {};
module.exports.cosmos = $d94845a59d001d47$var$$root.cosmos = (()=>{
    const cosmos = {};
    cosmos.bank = function() {
        const bank = {};
        bank.v1beta1 = function() {
            const v1beta1 = {};
            v1beta1.Params = function() {
                function Params(p) {
                    this.sendEnabled = [];
                    if (p) {
                        for(var ks = Object.keys(p), i = 0; i < ks.length; ++i)if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
                    }
                }
                Params.prototype.sendEnabled = $d94845a59d001d47$var$$util.emptyArray;
                Params.prototype.defaultSendEnabled = false;
                Params.create = function create(properties) {
                    return new Params(properties);
                };
                Params.encode = function encode(m, w) {
                    if (!w) w = $d94845a59d001d47$var$$Writer.create();
                    if (m.sendEnabled != null && m.sendEnabled.length) for(var i = 0; i < m.sendEnabled.length; ++i)$d94845a59d001d47$var$$root.cosmos.bank.v1beta1.SendEnabled.encode(m.sendEnabled[i], w.uint32(10).fork()).ldelim();
                    if (m.defaultSendEnabled != null && Object.hasOwnProperty.call(m, "defaultSendEnabled")) w.uint32(16).bool(m.defaultSendEnabled);
                    return w;
                };
                Params.decode = function decode(r, l) {
                    if (!(r instanceof $d94845a59d001d47$var$$Reader)) r = $d94845a59d001d47$var$$Reader.create(r);
                    var c = l === undefined ? r.len : r.pos + l, m = new $d94845a59d001d47$var$$root.cosmos.bank.v1beta1.Params();
                    while(r.pos < c){
                        var t = r.uint32();
                        switch(t >>> 3){
                            case 1:
                                if (!(m.sendEnabled && m.sendEnabled.length)) m.sendEnabled = [];
                                m.sendEnabled.push($d94845a59d001d47$var$$root.cosmos.bank.v1beta1.SendEnabled.decode(r, r.uint32()));
                                break;
                            case 2:
                                m.defaultSendEnabled = r.bool();
                                break;
                            default:
                                r.skipType(t & 7);
                                break;
                        }
                    }
                    return m;
                };
                Params.fromObject = function fromObject(d) {
                    if (d instanceof $d94845a59d001d47$var$$root.cosmos.bank.v1beta1.Params) return d;
                    var m = new $d94845a59d001d47$var$$root.cosmos.bank.v1beta1.Params();
                    if (d.sendEnabled) {
                        if (!Array.isArray(d.sendEnabled)) throw TypeError(".cosmos.bank.v1beta1.Params.sendEnabled: array expected");
                        m.sendEnabled = [];
                        for(var i = 0; i < d.sendEnabled.length; ++i){
                            if (typeof d.sendEnabled[i] !== "object") throw TypeError(".cosmos.bank.v1beta1.Params.sendEnabled: object expected");
                            m.sendEnabled[i] = $d94845a59d001d47$var$$root.cosmos.bank.v1beta1.SendEnabled.fromObject(d.sendEnabled[i]);
                        }
                    }
                    if (d.defaultSendEnabled != null) m.defaultSendEnabled = Boolean(d.defaultSendEnabled);
                    return m;
                };
                Params.toObject = function toObject(m, o) {
                    if (!o) o = {};
                    var d = {};
                    if (o.arrays || o.defaults) d.sendEnabled = [];
                    if (o.defaults) d.defaultSendEnabled = false;
                    if (m.sendEnabled && m.sendEnabled.length) {
                        d.sendEnabled = [];
                        for(var j = 0; j < m.sendEnabled.length; ++j)d.sendEnabled[j] = $d94845a59d001d47$var$$root.cosmos.bank.v1beta1.SendEnabled.toObject(m.sendEnabled[j], o);
                    }
                    if (m.defaultSendEnabled != null && m.hasOwnProperty("defaultSendEnabled")) d.defaultSendEnabled = m.defaultSendEnabled;
                    return d;
                };
                Params.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $fQBv0.util.toJSONOptions);
                };
                return Params;
            }();
            v1beta1.SendEnabled = function() {
                function SendEnabled(p) {
                    if (p) {
                        for(var ks = Object.keys(p), i = 0; i < ks.length; ++i)if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
                    }
                }
                SendEnabled.prototype.denom = "";
                SendEnabled.prototype.enabled = false;
                SendEnabled.create = function create(properties) {
                    return new SendEnabled(properties);
                };
                SendEnabled.encode = function encode(m, w) {
                    if (!w) w = $d94845a59d001d47$var$$Writer.create();
                    if (m.denom != null && Object.hasOwnProperty.call(m, "denom")) w.uint32(10).string(m.denom);
                    if (m.enabled != null && Object.hasOwnProperty.call(m, "enabled")) w.uint32(16).bool(m.enabled);
                    return w;
                };
                SendEnabled.decode = function decode(r, l) {
                    if (!(r instanceof $d94845a59d001d47$var$$Reader)) r = $d94845a59d001d47$var$$Reader.create(r);
                    var c = l === undefined ? r.len : r.pos + l, m = new $d94845a59d001d47$var$$root.cosmos.bank.v1beta1.SendEnabled();
                    while(r.pos < c){
                        var t = r.uint32();
                        switch(t >>> 3){
                            case 1:
                                m.denom = r.string();
                                break;
                            case 2:
                                m.enabled = r.bool();
                                break;
                            default:
                                r.skipType(t & 7);
                                break;
                        }
                    }
                    return m;
                };
                SendEnabled.fromObject = function fromObject(d) {
                    if (d instanceof $d94845a59d001d47$var$$root.cosmos.bank.v1beta1.SendEnabled) return d;
                    var m = new $d94845a59d001d47$var$$root.cosmos.bank.v1beta1.SendEnabled();
                    if (d.denom != null) m.denom = String(d.denom);
                    if (d.enabled != null) m.enabled = Boolean(d.enabled);
                    return m;
                };
                SendEnabled.toObject = function toObject(m, o) {
                    if (!o) o = {};
                    var d = {};
                    if (o.defaults) {
                        d.denom = "";
                        d.enabled = false;
                    }
                    if (m.denom != null && m.hasOwnProperty("denom")) d.denom = m.denom;
                    if (m.enabled != null && m.hasOwnProperty("enabled")) d.enabled = m.enabled;
                    return d;
                };
                SendEnabled.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $fQBv0.util.toJSONOptions);
                };
                return SendEnabled;
            }();
            v1beta1.Input = function() {
                function Input(p) {
                    this.coins = [];
                    if (p) {
                        for(var ks = Object.keys(p), i = 0; i < ks.length; ++i)if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
                    }
                }
                Input.prototype.address = "";
                Input.prototype.coins = $d94845a59d001d47$var$$util.emptyArray;
                Input.create = function create(properties) {
                    return new Input(properties);
                };
                Input.encode = function encode(m, w) {
                    if (!w) w = $d94845a59d001d47$var$$Writer.create();
                    if (m.address != null && Object.hasOwnProperty.call(m, "address")) w.uint32(10).string(m.address);
                    if (m.coins != null && m.coins.length) for(var i = 0; i < m.coins.length; ++i)$d94845a59d001d47$var$$root.cosmos.base.v1beta1.Coin.encode(m.coins[i], w.uint32(18).fork()).ldelim();
                    return w;
                };
                Input.decode = function decode(r, l) {
                    if (!(r instanceof $d94845a59d001d47$var$$Reader)) r = $d94845a59d001d47$var$$Reader.create(r);
                    var c = l === undefined ? r.len : r.pos + l, m = new $d94845a59d001d47$var$$root.cosmos.bank.v1beta1.Input();
                    while(r.pos < c){
                        var t = r.uint32();
                        switch(t >>> 3){
                            case 1:
                                m.address = r.string();
                                break;
                            case 2:
                                if (!(m.coins && m.coins.length)) m.coins = [];
                                m.coins.push($d94845a59d001d47$var$$root.cosmos.base.v1beta1.Coin.decode(r, r.uint32()));
                                break;
                            default:
                                r.skipType(t & 7);
                                break;
                        }
                    }
                    return m;
                };
                Input.fromObject = function fromObject(d) {
                    if (d instanceof $d94845a59d001d47$var$$root.cosmos.bank.v1beta1.Input) return d;
                    var m = new $d94845a59d001d47$var$$root.cosmos.bank.v1beta1.Input();
                    if (d.address != null) m.address = String(d.address);
                    if (d.coins) {
                        if (!Array.isArray(d.coins)) throw TypeError(".cosmos.bank.v1beta1.Input.coins: array expected");
                        m.coins = [];
                        for(var i = 0; i < d.coins.length; ++i){
                            if (typeof d.coins[i] !== "object") throw TypeError(".cosmos.bank.v1beta1.Input.coins: object expected");
                            m.coins[i] = $d94845a59d001d47$var$$root.cosmos.base.v1beta1.Coin.fromObject(d.coins[i]);
                        }
                    }
                    return m;
                };
                Input.toObject = function toObject(m, o) {
                    if (!o) o = {};
                    var d = {};
                    if (o.arrays || o.defaults) d.coins = [];
                    if (o.defaults) d.address = "";
                    if (m.address != null && m.hasOwnProperty("address")) d.address = m.address;
                    if (m.coins && m.coins.length) {
                        d.coins = [];
                        for(var j = 0; j < m.coins.length; ++j)d.coins[j] = $d94845a59d001d47$var$$root.cosmos.base.v1beta1.Coin.toObject(m.coins[j], o);
                    }
                    return d;
                };
                Input.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $fQBv0.util.toJSONOptions);
                };
                return Input;
            }();
            v1beta1.Output = function() {
                function Output(p) {
                    this.coins = [];
                    if (p) {
                        for(var ks = Object.keys(p), i = 0; i < ks.length; ++i)if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
                    }
                }
                Output.prototype.address = "";
                Output.prototype.coins = $d94845a59d001d47$var$$util.emptyArray;
                Output.create = function create(properties) {
                    return new Output(properties);
                };
                Output.encode = function encode(m, w) {
                    if (!w) w = $d94845a59d001d47$var$$Writer.create();
                    if (m.address != null && Object.hasOwnProperty.call(m, "address")) w.uint32(10).string(m.address);
                    if (m.coins != null && m.coins.length) for(var i = 0; i < m.coins.length; ++i)$d94845a59d001d47$var$$root.cosmos.base.v1beta1.Coin.encode(m.coins[i], w.uint32(18).fork()).ldelim();
                    return w;
                };
                Output.decode = function decode(r, l) {
                    if (!(r instanceof $d94845a59d001d47$var$$Reader)) r = $d94845a59d001d47$var$$Reader.create(r);
                    var c = l === undefined ? r.len : r.pos + l, m = new $d94845a59d001d47$var$$root.cosmos.bank.v1beta1.Output();
                    while(r.pos < c){
                        var t = r.uint32();
                        switch(t >>> 3){
                            case 1:
                                m.address = r.string();
                                break;
                            case 2:
                                if (!(m.coins && m.coins.length)) m.coins = [];
                                m.coins.push($d94845a59d001d47$var$$root.cosmos.base.v1beta1.Coin.decode(r, r.uint32()));
                                break;
                            default:
                                r.skipType(t & 7);
                                break;
                        }
                    }
                    return m;
                };
                Output.fromObject = function fromObject(d) {
                    if (d instanceof $d94845a59d001d47$var$$root.cosmos.bank.v1beta1.Output) return d;
                    var m = new $d94845a59d001d47$var$$root.cosmos.bank.v1beta1.Output();
                    if (d.address != null) m.address = String(d.address);
                    if (d.coins) {
                        if (!Array.isArray(d.coins)) throw TypeError(".cosmos.bank.v1beta1.Output.coins: array expected");
                        m.coins = [];
                        for(var i = 0; i < d.coins.length; ++i){
                            if (typeof d.coins[i] !== "object") throw TypeError(".cosmos.bank.v1beta1.Output.coins: object expected");
                            m.coins[i] = $d94845a59d001d47$var$$root.cosmos.base.v1beta1.Coin.fromObject(d.coins[i]);
                        }
                    }
                    return m;
                };
                Output.toObject = function toObject(m, o) {
                    if (!o) o = {};
                    var d = {};
                    if (o.arrays || o.defaults) d.coins = [];
                    if (o.defaults) d.address = "";
                    if (m.address != null && m.hasOwnProperty("address")) d.address = m.address;
                    if (m.coins && m.coins.length) {
                        d.coins = [];
                        for(var j = 0; j < m.coins.length; ++j)d.coins[j] = $d94845a59d001d47$var$$root.cosmos.base.v1beta1.Coin.toObject(m.coins[j], o);
                    }
                    return d;
                };
                Output.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $fQBv0.util.toJSONOptions);
                };
                return Output;
            }();
            v1beta1.Supply = function() {
                function Supply(p) {
                    this.total = [];
                    if (p) {
                        for(var ks = Object.keys(p), i = 0; i < ks.length; ++i)if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
                    }
                }
                Supply.prototype.total = $d94845a59d001d47$var$$util.emptyArray;
                Supply.create = function create(properties) {
                    return new Supply(properties);
                };
                Supply.encode = function encode(m, w) {
                    if (!w) w = $d94845a59d001d47$var$$Writer.create();
                    if (m.total != null && m.total.length) for(var i = 0; i < m.total.length; ++i)$d94845a59d001d47$var$$root.cosmos.base.v1beta1.Coin.encode(m.total[i], w.uint32(10).fork()).ldelim();
                    return w;
                };
                Supply.decode = function decode(r, l) {
                    if (!(r instanceof $d94845a59d001d47$var$$Reader)) r = $d94845a59d001d47$var$$Reader.create(r);
                    var c = l === undefined ? r.len : r.pos + l, m = new $d94845a59d001d47$var$$root.cosmos.bank.v1beta1.Supply();
                    while(r.pos < c){
                        var t = r.uint32();
                        switch(t >>> 3){
                            case 1:
                                if (!(m.total && m.total.length)) m.total = [];
                                m.total.push($d94845a59d001d47$var$$root.cosmos.base.v1beta1.Coin.decode(r, r.uint32()));
                                break;
                            default:
                                r.skipType(t & 7);
                                break;
                        }
                    }
                    return m;
                };
                Supply.fromObject = function fromObject(d) {
                    if (d instanceof $d94845a59d001d47$var$$root.cosmos.bank.v1beta1.Supply) return d;
                    var m = new $d94845a59d001d47$var$$root.cosmos.bank.v1beta1.Supply();
                    if (d.total) {
                        if (!Array.isArray(d.total)) throw TypeError(".cosmos.bank.v1beta1.Supply.total: array expected");
                        m.total = [];
                        for(var i = 0; i < d.total.length; ++i){
                            if (typeof d.total[i] !== "object") throw TypeError(".cosmos.bank.v1beta1.Supply.total: object expected");
                            m.total[i] = $d94845a59d001d47$var$$root.cosmos.base.v1beta1.Coin.fromObject(d.total[i]);
                        }
                    }
                    return m;
                };
                Supply.toObject = function toObject(m, o) {
                    if (!o) o = {};
                    var d = {};
                    if (o.arrays || o.defaults) d.total = [];
                    if (m.total && m.total.length) {
                        d.total = [];
                        for(var j = 0; j < m.total.length; ++j)d.total[j] = $d94845a59d001d47$var$$root.cosmos.base.v1beta1.Coin.toObject(m.total[j], o);
                    }
                    return d;
                };
                Supply.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $fQBv0.util.toJSONOptions);
                };
                return Supply;
            }();
            v1beta1.DenomUnit = function() {
                function DenomUnit(p) {
                    this.aliases = [];
                    if (p) {
                        for(var ks = Object.keys(p), i = 0; i < ks.length; ++i)if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
                    }
                }
                DenomUnit.prototype.denom = "";
                DenomUnit.prototype.exponent = 0;
                DenomUnit.prototype.aliases = $d94845a59d001d47$var$$util.emptyArray;
                DenomUnit.create = function create(properties) {
                    return new DenomUnit(properties);
                };
                DenomUnit.encode = function encode(m, w) {
                    if (!w) w = $d94845a59d001d47$var$$Writer.create();
                    if (m.denom != null && Object.hasOwnProperty.call(m, "denom")) w.uint32(10).string(m.denom);
                    if (m.exponent != null && Object.hasOwnProperty.call(m, "exponent")) w.uint32(16).uint32(m.exponent);
                    if (m.aliases != null && m.aliases.length) for(var i = 0; i < m.aliases.length; ++i)w.uint32(26).string(m.aliases[i]);
                    return w;
                };
                DenomUnit.decode = function decode(r, l) {
                    if (!(r instanceof $d94845a59d001d47$var$$Reader)) r = $d94845a59d001d47$var$$Reader.create(r);
                    var c = l === undefined ? r.len : r.pos + l, m = new $d94845a59d001d47$var$$root.cosmos.bank.v1beta1.DenomUnit();
                    while(r.pos < c){
                        var t = r.uint32();
                        switch(t >>> 3){
                            case 1:
                                m.denom = r.string();
                                break;
                            case 2:
                                m.exponent = r.uint32();
                                break;
                            case 3:
                                if (!(m.aliases && m.aliases.length)) m.aliases = [];
                                m.aliases.push(r.string());
                                break;
                            default:
                                r.skipType(t & 7);
                                break;
                        }
                    }
                    return m;
                };
                DenomUnit.fromObject = function fromObject(d) {
                    if (d instanceof $d94845a59d001d47$var$$root.cosmos.bank.v1beta1.DenomUnit) return d;
                    var m = new $d94845a59d001d47$var$$root.cosmos.bank.v1beta1.DenomUnit();
                    if (d.denom != null) m.denom = String(d.denom);
                    if (d.exponent != null) m.exponent = d.exponent >>> 0;
                    if (d.aliases) {
                        if (!Array.isArray(d.aliases)) throw TypeError(".cosmos.bank.v1beta1.DenomUnit.aliases: array expected");
                        m.aliases = [];
                        for(var i = 0; i < d.aliases.length; ++i)m.aliases[i] = String(d.aliases[i]);
                    }
                    return m;
                };
                DenomUnit.toObject = function toObject(m, o) {
                    if (!o) o = {};
                    var d = {};
                    if (o.arrays || o.defaults) d.aliases = [];
                    if (o.defaults) {
                        d.denom = "";
                        d.exponent = 0;
                    }
                    if (m.denom != null && m.hasOwnProperty("denom")) d.denom = m.denom;
                    if (m.exponent != null && m.hasOwnProperty("exponent")) d.exponent = m.exponent;
                    if (m.aliases && m.aliases.length) {
                        d.aliases = [];
                        for(var j = 0; j < m.aliases.length; ++j)d.aliases[j] = m.aliases[j];
                    }
                    return d;
                };
                DenomUnit.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $fQBv0.util.toJSONOptions);
                };
                return DenomUnit;
            }();
            v1beta1.Metadata = function() {
                function Metadata(p) {
                    this.denomUnits = [];
                    if (p) {
                        for(var ks = Object.keys(p), i = 0; i < ks.length; ++i)if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
                    }
                }
                Metadata.prototype.description = "";
                Metadata.prototype.denomUnits = $d94845a59d001d47$var$$util.emptyArray;
                Metadata.prototype.base = "";
                Metadata.prototype.display = "";
                Metadata.prototype.name = "";
                Metadata.prototype.symbol = "";
                Metadata.create = function create(properties) {
                    return new Metadata(properties);
                };
                Metadata.encode = function encode(m, w) {
                    if (!w) w = $d94845a59d001d47$var$$Writer.create();
                    if (m.description != null && Object.hasOwnProperty.call(m, "description")) w.uint32(10).string(m.description);
                    if (m.denomUnits != null && m.denomUnits.length) for(var i = 0; i < m.denomUnits.length; ++i)$d94845a59d001d47$var$$root.cosmos.bank.v1beta1.DenomUnit.encode(m.denomUnits[i], w.uint32(18).fork()).ldelim();
                    if (m.base != null && Object.hasOwnProperty.call(m, "base")) w.uint32(26).string(m.base);
                    if (m.display != null && Object.hasOwnProperty.call(m, "display")) w.uint32(34).string(m.display);
                    if (m.name != null && Object.hasOwnProperty.call(m, "name")) w.uint32(42).string(m.name);
                    if (m.symbol != null && Object.hasOwnProperty.call(m, "symbol")) w.uint32(50).string(m.symbol);
                    return w;
                };
                Metadata.decode = function decode(r, l) {
                    if (!(r instanceof $d94845a59d001d47$var$$Reader)) r = $d94845a59d001d47$var$$Reader.create(r);
                    var c = l === undefined ? r.len : r.pos + l, m = new $d94845a59d001d47$var$$root.cosmos.bank.v1beta1.Metadata();
                    while(r.pos < c){
                        var t = r.uint32();
                        switch(t >>> 3){
                            case 1:
                                m.description = r.string();
                                break;
                            case 2:
                                if (!(m.denomUnits && m.denomUnits.length)) m.denomUnits = [];
                                m.denomUnits.push($d94845a59d001d47$var$$root.cosmos.bank.v1beta1.DenomUnit.decode(r, r.uint32()));
                                break;
                            case 3:
                                m.base = r.string();
                                break;
                            case 4:
                                m.display = r.string();
                                break;
                            case 5:
                                m.name = r.string();
                                break;
                            case 6:
                                m.symbol = r.string();
                                break;
                            default:
                                r.skipType(t & 7);
                                break;
                        }
                    }
                    return m;
                };
                Metadata.fromObject = function fromObject(d) {
                    if (d instanceof $d94845a59d001d47$var$$root.cosmos.bank.v1beta1.Metadata) return d;
                    var m = new $d94845a59d001d47$var$$root.cosmos.bank.v1beta1.Metadata();
                    if (d.description != null) m.description = String(d.description);
                    if (d.denomUnits) {
                        if (!Array.isArray(d.denomUnits)) throw TypeError(".cosmos.bank.v1beta1.Metadata.denomUnits: array expected");
                        m.denomUnits = [];
                        for(var i = 0; i < d.denomUnits.length; ++i){
                            if (typeof d.denomUnits[i] !== "object") throw TypeError(".cosmos.bank.v1beta1.Metadata.denomUnits: object expected");
                            m.denomUnits[i] = $d94845a59d001d47$var$$root.cosmos.bank.v1beta1.DenomUnit.fromObject(d.denomUnits[i]);
                        }
                    }
                    if (d.base != null) m.base = String(d.base);
                    if (d.display != null) m.display = String(d.display);
                    if (d.name != null) m.name = String(d.name);
                    if (d.symbol != null) m.symbol = String(d.symbol);
                    return m;
                };
                Metadata.toObject = function toObject(m, o) {
                    if (!o) o = {};
                    var d = {};
                    if (o.arrays || o.defaults) d.denomUnits = [];
                    if (o.defaults) {
                        d.description = "";
                        d.base = "";
                        d.display = "";
                        d.name = "";
                        d.symbol = "";
                    }
                    if (m.description != null && m.hasOwnProperty("description")) d.description = m.description;
                    if (m.denomUnits && m.denomUnits.length) {
                        d.denomUnits = [];
                        for(var j = 0; j < m.denomUnits.length; ++j)d.denomUnits[j] = $d94845a59d001d47$var$$root.cosmos.bank.v1beta1.DenomUnit.toObject(m.denomUnits[j], o);
                    }
                    if (m.base != null && m.hasOwnProperty("base")) d.base = m.base;
                    if (m.display != null && m.hasOwnProperty("display")) d.display = m.display;
                    if (m.name != null && m.hasOwnProperty("name")) d.name = m.name;
                    if (m.symbol != null && m.hasOwnProperty("symbol")) d.symbol = m.symbol;
                    return d;
                };
                Metadata.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $fQBv0.util.toJSONOptions);
                };
                return Metadata;
            }();
            v1beta1.Msg = function() {
                function Msg(rpcImpl, requestDelimited, responseDelimited) {
                    $fQBv0.rpc.Service.call(this, rpcImpl, requestDelimited, responseDelimited);
                }
                (Msg.prototype = Object.create($fQBv0.rpc.Service.prototype)).constructor = Msg;
                Msg.create = function create(rpcImpl, requestDelimited, responseDelimited) {
                    return new this(rpcImpl, requestDelimited, responseDelimited);
                };
                Object.defineProperty(Msg.prototype.send = function send(request, callback) {
                    return this.rpcCall(send, $d94845a59d001d47$var$$root.cosmos.bank.v1beta1.MsgSend, $d94845a59d001d47$var$$root.cosmos.bank.v1beta1.MsgSendResponse, request, callback);
                }, "name", {
                    value: "Send"
                });
                Object.defineProperty(Msg.prototype.multiSend = function multiSend(request, callback) {
                    return this.rpcCall(multiSend, $d94845a59d001d47$var$$root.cosmos.bank.v1beta1.MsgMultiSend, $d94845a59d001d47$var$$root.cosmos.bank.v1beta1.MsgMultiSendResponse, request, callback);
                }, "name", {
                    value: "MultiSend"
                });
                return Msg;
            }();
            v1beta1.MsgSend = function() {
                function MsgSend(p) {
                    this.amount = [];
                    if (p) {
                        for(var ks = Object.keys(p), i = 0; i < ks.length; ++i)if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
                    }
                }
                MsgSend.prototype.fromAddress = "";
                MsgSend.prototype.toAddress = "";
                MsgSend.prototype.amount = $d94845a59d001d47$var$$util.emptyArray;
                MsgSend.create = function create(properties) {
                    return new MsgSend(properties);
                };
                MsgSend.encode = function encode(m, w) {
                    if (!w) w = $d94845a59d001d47$var$$Writer.create();
                    if (m.fromAddress != null && Object.hasOwnProperty.call(m, "fromAddress")) w.uint32(10).string(m.fromAddress);
                    if (m.toAddress != null && Object.hasOwnProperty.call(m, "toAddress")) w.uint32(18).string(m.toAddress);
                    if (m.amount != null && m.amount.length) for(var i = 0; i < m.amount.length; ++i)$d94845a59d001d47$var$$root.cosmos.base.v1beta1.Coin.encode(m.amount[i], w.uint32(26).fork()).ldelim();
                    return w;
                };
                MsgSend.decode = function decode(r, l) {
                    if (!(r instanceof $d94845a59d001d47$var$$Reader)) r = $d94845a59d001d47$var$$Reader.create(r);
                    var c = l === undefined ? r.len : r.pos + l, m = new $d94845a59d001d47$var$$root.cosmos.bank.v1beta1.MsgSend();
                    while(r.pos < c){
                        var t = r.uint32();
                        switch(t >>> 3){
                            case 1:
                                m.fromAddress = r.string();
                                break;
                            case 2:
                                m.toAddress = r.string();
                                break;
                            case 3:
                                if (!(m.amount && m.amount.length)) m.amount = [];
                                m.amount.push($d94845a59d001d47$var$$root.cosmos.base.v1beta1.Coin.decode(r, r.uint32()));
                                break;
                            default:
                                r.skipType(t & 7);
                                break;
                        }
                    }
                    return m;
                };
                MsgSend.fromObject = function fromObject(d) {
                    if (d instanceof $d94845a59d001d47$var$$root.cosmos.bank.v1beta1.MsgSend) return d;
                    var m = new $d94845a59d001d47$var$$root.cosmos.bank.v1beta1.MsgSend();
                    if (d.fromAddress != null) m.fromAddress = String(d.fromAddress);
                    if (d.toAddress != null) m.toAddress = String(d.toAddress);
                    if (d.amount) {
                        if (!Array.isArray(d.amount)) throw TypeError(".cosmos.bank.v1beta1.MsgSend.amount: array expected");
                        m.amount = [];
                        for(var i = 0; i < d.amount.length; ++i){
                            if (typeof d.amount[i] !== "object") throw TypeError(".cosmos.bank.v1beta1.MsgSend.amount: object expected");
                            m.amount[i] = $d94845a59d001d47$var$$root.cosmos.base.v1beta1.Coin.fromObject(d.amount[i]);
                        }
                    }
                    return m;
                };
                MsgSend.toObject = function toObject(m, o) {
                    if (!o) o = {};
                    var d = {};
                    if (o.arrays || o.defaults) d.amount = [];
                    if (o.defaults) {
                        d.fromAddress = "";
                        d.toAddress = "";
                    }
                    if (m.fromAddress != null && m.hasOwnProperty("fromAddress")) d.fromAddress = m.fromAddress;
                    if (m.toAddress != null && m.hasOwnProperty("toAddress")) d.toAddress = m.toAddress;
                    if (m.amount && m.amount.length) {
                        d.amount = [];
                        for(var j = 0; j < m.amount.length; ++j)d.amount[j] = $d94845a59d001d47$var$$root.cosmos.base.v1beta1.Coin.toObject(m.amount[j], o);
                    }
                    return d;
                };
                MsgSend.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $fQBv0.util.toJSONOptions);
                };
                return MsgSend;
            }();
            v1beta1.MsgSendResponse = function() {
                function MsgSendResponse(p) {
                    if (p) {
                        for(var ks = Object.keys(p), i = 0; i < ks.length; ++i)if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
                    }
                }
                MsgSendResponse.create = function create(properties) {
                    return new MsgSendResponse(properties);
                };
                MsgSendResponse.encode = function encode(m, w) {
                    if (!w) w = $d94845a59d001d47$var$$Writer.create();
                    return w;
                };
                MsgSendResponse.decode = function decode(r, l) {
                    if (!(r instanceof $d94845a59d001d47$var$$Reader)) r = $d94845a59d001d47$var$$Reader.create(r);
                    var c = l === undefined ? r.len : r.pos + l, m = new $d94845a59d001d47$var$$root.cosmos.bank.v1beta1.MsgSendResponse();
                    while(r.pos < c){
                        var t = r.uint32();
                        t;
                        r.skipType(t & 7);
                    }
                    return m;
                };
                MsgSendResponse.fromObject = function fromObject(d) {
                    if (d instanceof $d94845a59d001d47$var$$root.cosmos.bank.v1beta1.MsgSendResponse) return d;
                    return new $d94845a59d001d47$var$$root.cosmos.bank.v1beta1.MsgSendResponse();
                };
                MsgSendResponse.toObject = function toObject() {
                    return {};
                };
                MsgSendResponse.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $fQBv0.util.toJSONOptions);
                };
                return MsgSendResponse;
            }();
            v1beta1.MsgMultiSend = function() {
                function MsgMultiSend(p) {
                    this.inputs = [];
                    this.outputs = [];
                    if (p) {
                        for(var ks = Object.keys(p), i = 0; i < ks.length; ++i)if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
                    }
                }
                MsgMultiSend.prototype.inputs = $d94845a59d001d47$var$$util.emptyArray;
                MsgMultiSend.prototype.outputs = $d94845a59d001d47$var$$util.emptyArray;
                MsgMultiSend.create = function create(properties) {
                    return new MsgMultiSend(properties);
                };
                MsgMultiSend.encode = function encode(m, w) {
                    if (!w) w = $d94845a59d001d47$var$$Writer.create();
                    if (m.inputs != null && m.inputs.length) for(var i = 0; i < m.inputs.length; ++i)$d94845a59d001d47$var$$root.cosmos.bank.v1beta1.Input.encode(m.inputs[i], w.uint32(10).fork()).ldelim();
                    if (m.outputs != null && m.outputs.length) for(var i = 0; i < m.outputs.length; ++i)$d94845a59d001d47$var$$root.cosmos.bank.v1beta1.Output.encode(m.outputs[i], w.uint32(18).fork()).ldelim();
                    return w;
                };
                MsgMultiSend.decode = function decode(r, l) {
                    if (!(r instanceof $d94845a59d001d47$var$$Reader)) r = $d94845a59d001d47$var$$Reader.create(r);
                    var c = l === undefined ? r.len : r.pos + l, m = new $d94845a59d001d47$var$$root.cosmos.bank.v1beta1.MsgMultiSend();
                    while(r.pos < c){
                        var t = r.uint32();
                        switch(t >>> 3){
                            case 1:
                                if (!(m.inputs && m.inputs.length)) m.inputs = [];
                                m.inputs.push($d94845a59d001d47$var$$root.cosmos.bank.v1beta1.Input.decode(r, r.uint32()));
                                break;
                            case 2:
                                if (!(m.outputs && m.outputs.length)) m.outputs = [];
                                m.outputs.push($d94845a59d001d47$var$$root.cosmos.bank.v1beta1.Output.decode(r, r.uint32()));
                                break;
                            default:
                                r.skipType(t & 7);
                                break;
                        }
                    }
                    return m;
                };
                MsgMultiSend.fromObject = function fromObject(d) {
                    if (d instanceof $d94845a59d001d47$var$$root.cosmos.bank.v1beta1.MsgMultiSend) return d;
                    var m = new $d94845a59d001d47$var$$root.cosmos.bank.v1beta1.MsgMultiSend();
                    if (d.inputs) {
                        if (!Array.isArray(d.inputs)) throw TypeError(".cosmos.bank.v1beta1.MsgMultiSend.inputs: array expected");
                        m.inputs = [];
                        for(var i = 0; i < d.inputs.length; ++i){
                            if (typeof d.inputs[i] !== "object") throw TypeError(".cosmos.bank.v1beta1.MsgMultiSend.inputs: object expected");
                            m.inputs[i] = $d94845a59d001d47$var$$root.cosmos.bank.v1beta1.Input.fromObject(d.inputs[i]);
                        }
                    }
                    if (d.outputs) {
                        if (!Array.isArray(d.outputs)) throw TypeError(".cosmos.bank.v1beta1.MsgMultiSend.outputs: array expected");
                        m.outputs = [];
                        for(var i = 0; i < d.outputs.length; ++i){
                            if (typeof d.outputs[i] !== "object") throw TypeError(".cosmos.bank.v1beta1.MsgMultiSend.outputs: object expected");
                            m.outputs[i] = $d94845a59d001d47$var$$root.cosmos.bank.v1beta1.Output.fromObject(d.outputs[i]);
                        }
                    }
                    return m;
                };
                MsgMultiSend.toObject = function toObject(m, o) {
                    if (!o) o = {};
                    var d = {};
                    if (o.arrays || o.defaults) {
                        d.inputs = [];
                        d.outputs = [];
                    }
                    if (m.inputs && m.inputs.length) {
                        d.inputs = [];
                        for(var j = 0; j < m.inputs.length; ++j)d.inputs[j] = $d94845a59d001d47$var$$root.cosmos.bank.v1beta1.Input.toObject(m.inputs[j], o);
                    }
                    if (m.outputs && m.outputs.length) {
                        d.outputs = [];
                        for(var j = 0; j < m.outputs.length; ++j)d.outputs[j] = $d94845a59d001d47$var$$root.cosmos.bank.v1beta1.Output.toObject(m.outputs[j], o);
                    }
                    return d;
                };
                MsgMultiSend.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $fQBv0.util.toJSONOptions);
                };
                return MsgMultiSend;
            }();
            v1beta1.MsgMultiSendResponse = function() {
                function MsgMultiSendResponse(p) {
                    if (p) {
                        for(var ks = Object.keys(p), i = 0; i < ks.length; ++i)if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
                    }
                }
                MsgMultiSendResponse.create = function create(properties) {
                    return new MsgMultiSendResponse(properties);
                };
                MsgMultiSendResponse.encode = function encode(m, w) {
                    if (!w) w = $d94845a59d001d47$var$$Writer.create();
                    return w;
                };
                MsgMultiSendResponse.decode = function decode(r, l) {
                    if (!(r instanceof $d94845a59d001d47$var$$Reader)) r = $d94845a59d001d47$var$$Reader.create(r);
                    var c = l === undefined ? r.len : r.pos + l, m = new $d94845a59d001d47$var$$root.cosmos.bank.v1beta1.MsgMultiSendResponse();
                    while(r.pos < c){
                        var t = r.uint32();
                        t;
                        r.skipType(t & 7);
                    }
                    return m;
                };
                MsgMultiSendResponse.fromObject = function fromObject(d) {
                    if (d instanceof $d94845a59d001d47$var$$root.cosmos.bank.v1beta1.MsgMultiSendResponse) return d;
                    return new $d94845a59d001d47$var$$root.cosmos.bank.v1beta1.MsgMultiSendResponse();
                };
                MsgMultiSendResponse.toObject = function toObject() {
                    return {};
                };
                MsgMultiSendResponse.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $fQBv0.util.toJSONOptions);
                };
                return MsgMultiSendResponse;
            }();
            return v1beta1;
        }();
        return bank;
    }();
    cosmos.staking = function() {
        const staking = {};
        staking.v1beta1 = function() {
            const v1beta1 = {};
            v1beta1.Msg = function() {
                function Msg(rpcImpl, requestDelimited, responseDelimited) {
                    $fQBv0.rpc.Service.call(this, rpcImpl, requestDelimited, responseDelimited);
                }
                (Msg.prototype = Object.create($fQBv0.rpc.Service.prototype)).constructor = Msg;
                Msg.create = function create(rpcImpl, requestDelimited, responseDelimited) {
                    return new this(rpcImpl, requestDelimited, responseDelimited);
                };
                Object.defineProperty(Msg.prototype.delegate = function delegate(request, callback) {
                    return this.rpcCall(delegate, $d94845a59d001d47$var$$root.cosmos.staking.v1beta1.MsgDelegate, $d94845a59d001d47$var$$root.cosmos.staking.v1beta1.MsgDelegateResponse, request, callback);
                }, "name", {
                    value: "Delegate"
                });
                Object.defineProperty(Msg.prototype.beginRedelegate = function beginRedelegate(request, callback) {
                    return this.rpcCall(beginRedelegate, $d94845a59d001d47$var$$root.cosmos.staking.v1beta1.MsgBeginRedelegate, $d94845a59d001d47$var$$root.cosmos.staking.v1beta1.MsgBeginRedelegateResponse, request, callback);
                }, "name", {
                    value: "BeginRedelegate"
                });
                Object.defineProperty(Msg.prototype.undelegate = function undelegate(request, callback) {
                    return this.rpcCall(undelegate, $d94845a59d001d47$var$$root.cosmos.staking.v1beta1.MsgUndelegate, $d94845a59d001d47$var$$root.cosmos.staking.v1beta1.MsgUndelegateResponse, request, callback);
                }, "name", {
                    value: "Undelegate"
                });
                return Msg;
            }();
            v1beta1.MsgDelegate = function() {
                function MsgDelegate(p) {
                    if (p) {
                        for(var ks = Object.keys(p), i = 0; i < ks.length; ++i)if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
                    }
                }
                MsgDelegate.prototype.delegatorAddress = "";
                MsgDelegate.prototype.validatorAddress = "";
                MsgDelegate.prototype.amount = null;
                MsgDelegate.create = function create(properties) {
                    return new MsgDelegate(properties);
                };
                MsgDelegate.encode = function encode(m, w) {
                    if (!w) w = $d94845a59d001d47$var$$Writer.create();
                    if (m.delegatorAddress != null && Object.hasOwnProperty.call(m, "delegatorAddress")) w.uint32(10).string(m.delegatorAddress);
                    if (m.validatorAddress != null && Object.hasOwnProperty.call(m, "validatorAddress")) w.uint32(18).string(m.validatorAddress);
                    if (m.amount != null && Object.hasOwnProperty.call(m, "amount")) $d94845a59d001d47$var$$root.cosmos.base.v1beta1.Coin.encode(m.amount, w.uint32(26).fork()).ldelim();
                    return w;
                };
                MsgDelegate.decode = function decode(r, l) {
                    if (!(r instanceof $d94845a59d001d47$var$$Reader)) r = $d94845a59d001d47$var$$Reader.create(r);
                    var c = l === undefined ? r.len : r.pos + l, m = new $d94845a59d001d47$var$$root.cosmos.staking.v1beta1.MsgDelegate();
                    while(r.pos < c){
                        var t = r.uint32();
                        switch(t >>> 3){
                            case 1:
                                m.delegatorAddress = r.string();
                                break;
                            case 2:
                                m.validatorAddress = r.string();
                                break;
                            case 3:
                                m.amount = $d94845a59d001d47$var$$root.cosmos.base.v1beta1.Coin.decode(r, r.uint32());
                                break;
                            default:
                                r.skipType(t & 7);
                                break;
                        }
                    }
                    return m;
                };
                MsgDelegate.fromObject = function fromObject(d) {
                    if (d instanceof $d94845a59d001d47$var$$root.cosmos.staking.v1beta1.MsgDelegate) return d;
                    var m = new $d94845a59d001d47$var$$root.cosmos.staking.v1beta1.MsgDelegate();
                    if (d.delegatorAddress != null) m.delegatorAddress = String(d.delegatorAddress);
                    if (d.validatorAddress != null) m.validatorAddress = String(d.validatorAddress);
                    if (d.amount != null) {
                        if (typeof d.amount !== "object") throw TypeError(".cosmos.staking.v1beta1.MsgDelegate.amount: object expected");
                        m.amount = $d94845a59d001d47$var$$root.cosmos.base.v1beta1.Coin.fromObject(d.amount);
                    }
                    return m;
                };
                MsgDelegate.toObject = function toObject(m, o) {
                    if (!o) o = {};
                    var d = {};
                    if (o.defaults) {
                        d.delegatorAddress = "";
                        d.validatorAddress = "";
                        d.amount = null;
                    }
                    if (m.delegatorAddress != null && m.hasOwnProperty("delegatorAddress")) d.delegatorAddress = m.delegatorAddress;
                    if (m.validatorAddress != null && m.hasOwnProperty("validatorAddress")) d.validatorAddress = m.validatorAddress;
                    if (m.amount != null && m.hasOwnProperty("amount")) d.amount = $d94845a59d001d47$var$$root.cosmos.base.v1beta1.Coin.toObject(m.amount, o);
                    return d;
                };
                MsgDelegate.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $fQBv0.util.toJSONOptions);
                };
                return MsgDelegate;
            }();
            v1beta1.MsgDelegateResponse = function() {
                function MsgDelegateResponse(p) {
                    if (p) {
                        for(var ks = Object.keys(p), i = 0; i < ks.length; ++i)if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
                    }
                }
                MsgDelegateResponse.create = function create(properties) {
                    return new MsgDelegateResponse(properties);
                };
                MsgDelegateResponse.encode = function encode(m, w) {
                    if (!w) w = $d94845a59d001d47$var$$Writer.create();
                    return w;
                };
                MsgDelegateResponse.decode = function decode(r, l) {
                    if (!(r instanceof $d94845a59d001d47$var$$Reader)) r = $d94845a59d001d47$var$$Reader.create(r);
                    var c = l === undefined ? r.len : r.pos + l, m = new $d94845a59d001d47$var$$root.cosmos.staking.v1beta1.MsgDelegateResponse();
                    while(r.pos < c){
                        var t = r.uint32();
                        t;
                        r.skipType(t & 7);
                    }
                    return m;
                };
                MsgDelegateResponse.fromObject = function fromObject(d) {
                    if (d instanceof $d94845a59d001d47$var$$root.cosmos.staking.v1beta1.MsgDelegateResponse) return d;
                    return new $d94845a59d001d47$var$$root.cosmos.staking.v1beta1.MsgDelegateResponse();
                };
                MsgDelegateResponse.toObject = function toObject() {
                    return {};
                };
                MsgDelegateResponse.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $fQBv0.util.toJSONOptions);
                };
                return MsgDelegateResponse;
            }();
            v1beta1.MsgBeginRedelegate = function() {
                function MsgBeginRedelegate(p) {
                    if (p) {
                        for(var ks = Object.keys(p), i = 0; i < ks.length; ++i)if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
                    }
                }
                MsgBeginRedelegate.prototype.delegatorAddress = "";
                MsgBeginRedelegate.prototype.validatorSrcAddress = "";
                MsgBeginRedelegate.prototype.validatorDstAddress = "";
                MsgBeginRedelegate.prototype.amount = null;
                MsgBeginRedelegate.create = function create(properties) {
                    return new MsgBeginRedelegate(properties);
                };
                MsgBeginRedelegate.encode = function encode(m, w) {
                    if (!w) w = $d94845a59d001d47$var$$Writer.create();
                    if (m.delegatorAddress != null && Object.hasOwnProperty.call(m, "delegatorAddress")) w.uint32(10).string(m.delegatorAddress);
                    if (m.validatorSrcAddress != null && Object.hasOwnProperty.call(m, "validatorSrcAddress")) w.uint32(18).string(m.validatorSrcAddress);
                    if (m.validatorDstAddress != null && Object.hasOwnProperty.call(m, "validatorDstAddress")) w.uint32(26).string(m.validatorDstAddress);
                    if (m.amount != null && Object.hasOwnProperty.call(m, "amount")) $d94845a59d001d47$var$$root.cosmos.base.v1beta1.Coin.encode(m.amount, w.uint32(34).fork()).ldelim();
                    return w;
                };
                MsgBeginRedelegate.decode = function decode(r, l) {
                    if (!(r instanceof $d94845a59d001d47$var$$Reader)) r = $d94845a59d001d47$var$$Reader.create(r);
                    var c = l === undefined ? r.len : r.pos + l, m = new $d94845a59d001d47$var$$root.cosmos.staking.v1beta1.MsgBeginRedelegate();
                    while(r.pos < c){
                        var t = r.uint32();
                        switch(t >>> 3){
                            case 1:
                                m.delegatorAddress = r.string();
                                break;
                            case 2:
                                m.validatorSrcAddress = r.string();
                                break;
                            case 3:
                                m.validatorDstAddress = r.string();
                                break;
                            case 4:
                                m.amount = $d94845a59d001d47$var$$root.cosmos.base.v1beta1.Coin.decode(r, r.uint32());
                                break;
                            default:
                                r.skipType(t & 7);
                                break;
                        }
                    }
                    return m;
                };
                MsgBeginRedelegate.fromObject = function fromObject(d) {
                    if (d instanceof $d94845a59d001d47$var$$root.cosmos.staking.v1beta1.MsgBeginRedelegate) return d;
                    var m = new $d94845a59d001d47$var$$root.cosmos.staking.v1beta1.MsgBeginRedelegate();
                    if (d.delegatorAddress != null) m.delegatorAddress = String(d.delegatorAddress);
                    if (d.validatorSrcAddress != null) m.validatorSrcAddress = String(d.validatorSrcAddress);
                    if (d.validatorDstAddress != null) m.validatorDstAddress = String(d.validatorDstAddress);
                    if (d.amount != null) {
                        if (typeof d.amount !== "object") throw TypeError(".cosmos.staking.v1beta1.MsgBeginRedelegate.amount: object expected");
                        m.amount = $d94845a59d001d47$var$$root.cosmos.base.v1beta1.Coin.fromObject(d.amount);
                    }
                    return m;
                };
                MsgBeginRedelegate.toObject = function toObject(m, o) {
                    if (!o) o = {};
                    var d = {};
                    if (o.defaults) {
                        d.delegatorAddress = "";
                        d.validatorSrcAddress = "";
                        d.validatorDstAddress = "";
                        d.amount = null;
                    }
                    if (m.delegatorAddress != null && m.hasOwnProperty("delegatorAddress")) d.delegatorAddress = m.delegatorAddress;
                    if (m.validatorSrcAddress != null && m.hasOwnProperty("validatorSrcAddress")) d.validatorSrcAddress = m.validatorSrcAddress;
                    if (m.validatorDstAddress != null && m.hasOwnProperty("validatorDstAddress")) d.validatorDstAddress = m.validatorDstAddress;
                    if (m.amount != null && m.hasOwnProperty("amount")) d.amount = $d94845a59d001d47$var$$root.cosmos.base.v1beta1.Coin.toObject(m.amount, o);
                    return d;
                };
                MsgBeginRedelegate.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $fQBv0.util.toJSONOptions);
                };
                return MsgBeginRedelegate;
            }();
            v1beta1.MsgBeginRedelegateResponse = function() {
                function MsgBeginRedelegateResponse(p) {
                    if (p) {
                        for(var ks = Object.keys(p), i = 0; i < ks.length; ++i)if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
                    }
                }
                MsgBeginRedelegateResponse.prototype.completionTime = null;
                MsgBeginRedelegateResponse.create = function create(properties) {
                    return new MsgBeginRedelegateResponse(properties);
                };
                MsgBeginRedelegateResponse.encode = function encode(m, w) {
                    if (!w) w = $d94845a59d001d47$var$$Writer.create();
                    if (m.completionTime != null && Object.hasOwnProperty.call(m, "completionTime")) $d94845a59d001d47$var$$root.google.protobuf.Timestamp.encode(m.completionTime, w.uint32(10).fork()).ldelim();
                    return w;
                };
                MsgBeginRedelegateResponse.decode = function decode(r, l) {
                    if (!(r instanceof $d94845a59d001d47$var$$Reader)) r = $d94845a59d001d47$var$$Reader.create(r);
                    var c = l === undefined ? r.len : r.pos + l, m = new $d94845a59d001d47$var$$root.cosmos.staking.v1beta1.MsgBeginRedelegateResponse();
                    while(r.pos < c){
                        var t = r.uint32();
                        switch(t >>> 3){
                            case 1:
                                m.completionTime = $d94845a59d001d47$var$$root.google.protobuf.Timestamp.decode(r, r.uint32());
                                break;
                            default:
                                r.skipType(t & 7);
                                break;
                        }
                    }
                    return m;
                };
                MsgBeginRedelegateResponse.fromObject = function fromObject(d) {
                    if (d instanceof $d94845a59d001d47$var$$root.cosmos.staking.v1beta1.MsgBeginRedelegateResponse) return d;
                    var m = new $d94845a59d001d47$var$$root.cosmos.staking.v1beta1.MsgBeginRedelegateResponse();
                    if (d.completionTime != null) {
                        if (typeof d.completionTime !== "object") throw TypeError(".cosmos.staking.v1beta1.MsgBeginRedelegateResponse.completionTime: object expected");
                        m.completionTime = $d94845a59d001d47$var$$root.google.protobuf.Timestamp.fromObject(d.completionTime);
                    }
                    return m;
                };
                MsgBeginRedelegateResponse.toObject = function toObject(m, o) {
                    if (!o) o = {};
                    var d = {};
                    if (o.defaults) d.completionTime = null;
                    if (m.completionTime != null && m.hasOwnProperty("completionTime")) d.completionTime = $d94845a59d001d47$var$$root.google.protobuf.Timestamp.toObject(m.completionTime, o);
                    return d;
                };
                MsgBeginRedelegateResponse.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $fQBv0.util.toJSONOptions);
                };
                return MsgBeginRedelegateResponse;
            }();
            v1beta1.MsgUndelegate = function() {
                function MsgUndelegate(p) {
                    if (p) {
                        for(var ks = Object.keys(p), i = 0; i < ks.length; ++i)if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
                    }
                }
                MsgUndelegate.prototype.delegatorAddress = "";
                MsgUndelegate.prototype.validatorAddress = "";
                MsgUndelegate.prototype.amount = null;
                MsgUndelegate.create = function create(properties) {
                    return new MsgUndelegate(properties);
                };
                MsgUndelegate.encode = function encode(m, w) {
                    if (!w) w = $d94845a59d001d47$var$$Writer.create();
                    if (m.delegatorAddress != null && Object.hasOwnProperty.call(m, "delegatorAddress")) w.uint32(10).string(m.delegatorAddress);
                    if (m.validatorAddress != null && Object.hasOwnProperty.call(m, "validatorAddress")) w.uint32(18).string(m.validatorAddress);
                    if (m.amount != null && Object.hasOwnProperty.call(m, "amount")) $d94845a59d001d47$var$$root.cosmos.base.v1beta1.Coin.encode(m.amount, w.uint32(26).fork()).ldelim();
                    return w;
                };
                MsgUndelegate.decode = function decode(r, l) {
                    if (!(r instanceof $d94845a59d001d47$var$$Reader)) r = $d94845a59d001d47$var$$Reader.create(r);
                    var c = l === undefined ? r.len : r.pos + l, m = new $d94845a59d001d47$var$$root.cosmos.staking.v1beta1.MsgUndelegate();
                    while(r.pos < c){
                        var t = r.uint32();
                        switch(t >>> 3){
                            case 1:
                                m.delegatorAddress = r.string();
                                break;
                            case 2:
                                m.validatorAddress = r.string();
                                break;
                            case 3:
                                m.amount = $d94845a59d001d47$var$$root.cosmos.base.v1beta1.Coin.decode(r, r.uint32());
                                break;
                            default:
                                r.skipType(t & 7);
                                break;
                        }
                    }
                    return m;
                };
                MsgUndelegate.fromObject = function fromObject(d) {
                    if (d instanceof $d94845a59d001d47$var$$root.cosmos.staking.v1beta1.MsgUndelegate) return d;
                    var m = new $d94845a59d001d47$var$$root.cosmos.staking.v1beta1.MsgUndelegate();
                    if (d.delegatorAddress != null) m.delegatorAddress = String(d.delegatorAddress);
                    if (d.validatorAddress != null) m.validatorAddress = String(d.validatorAddress);
                    if (d.amount != null) {
                        if (typeof d.amount !== "object") throw TypeError(".cosmos.staking.v1beta1.MsgUndelegate.amount: object expected");
                        m.amount = $d94845a59d001d47$var$$root.cosmos.base.v1beta1.Coin.fromObject(d.amount);
                    }
                    return m;
                };
                MsgUndelegate.toObject = function toObject(m, o) {
                    if (!o) o = {};
                    var d = {};
                    if (o.defaults) {
                        d.delegatorAddress = "";
                        d.validatorAddress = "";
                        d.amount = null;
                    }
                    if (m.delegatorAddress != null && m.hasOwnProperty("delegatorAddress")) d.delegatorAddress = m.delegatorAddress;
                    if (m.validatorAddress != null && m.hasOwnProperty("validatorAddress")) d.validatorAddress = m.validatorAddress;
                    if (m.amount != null && m.hasOwnProperty("amount")) d.amount = $d94845a59d001d47$var$$root.cosmos.base.v1beta1.Coin.toObject(m.amount, o);
                    return d;
                };
                MsgUndelegate.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $fQBv0.util.toJSONOptions);
                };
                return MsgUndelegate;
            }();
            v1beta1.MsgUndelegateResponse = function() {
                function MsgUndelegateResponse(p) {
                    if (p) {
                        for(var ks = Object.keys(p), i = 0; i < ks.length; ++i)if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
                    }
                }
                MsgUndelegateResponse.prototype.completionTime = null;
                MsgUndelegateResponse.create = function create(properties) {
                    return new MsgUndelegateResponse(properties);
                };
                MsgUndelegateResponse.encode = function encode(m, w) {
                    if (!w) w = $d94845a59d001d47$var$$Writer.create();
                    if (m.completionTime != null && Object.hasOwnProperty.call(m, "completionTime")) $d94845a59d001d47$var$$root.google.protobuf.Timestamp.encode(m.completionTime, w.uint32(10).fork()).ldelim();
                    return w;
                };
                MsgUndelegateResponse.decode = function decode(r, l) {
                    if (!(r instanceof $d94845a59d001d47$var$$Reader)) r = $d94845a59d001d47$var$$Reader.create(r);
                    var c = l === undefined ? r.len : r.pos + l, m = new $d94845a59d001d47$var$$root.cosmos.staking.v1beta1.MsgUndelegateResponse();
                    while(r.pos < c){
                        var t = r.uint32();
                        switch(t >>> 3){
                            case 1:
                                m.completionTime = $d94845a59d001d47$var$$root.google.protobuf.Timestamp.decode(r, r.uint32());
                                break;
                            default:
                                r.skipType(t & 7);
                                break;
                        }
                    }
                    return m;
                };
                MsgUndelegateResponse.fromObject = function fromObject(d) {
                    if (d instanceof $d94845a59d001d47$var$$root.cosmos.staking.v1beta1.MsgUndelegateResponse) return d;
                    var m = new $d94845a59d001d47$var$$root.cosmos.staking.v1beta1.MsgUndelegateResponse();
                    if (d.completionTime != null) {
                        if (typeof d.completionTime !== "object") throw TypeError(".cosmos.staking.v1beta1.MsgUndelegateResponse.completionTime: object expected");
                        m.completionTime = $d94845a59d001d47$var$$root.google.protobuf.Timestamp.fromObject(d.completionTime);
                    }
                    return m;
                };
                MsgUndelegateResponse.toObject = function toObject(m, o) {
                    if (!o) o = {};
                    var d = {};
                    if (o.defaults) d.completionTime = null;
                    if (m.completionTime != null && m.hasOwnProperty("completionTime")) d.completionTime = $d94845a59d001d47$var$$root.google.protobuf.Timestamp.toObject(m.completionTime, o);
                    return d;
                };
                MsgUndelegateResponse.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $fQBv0.util.toJSONOptions);
                };
                return MsgUndelegateResponse;
            }();
            return v1beta1;
        }();
        return staking;
    }();
    cosmos.gov = function() {
        const gov = {};
        gov.v1beta1 = function() {
            const v1beta1 = {};
            v1beta1.VoteOption = function() {
                const valuesById = {}, values = Object.create(valuesById);
                values[valuesById[0] = "VOTE_OPTION_UNSPECIFIED"] = 0;
                values[valuesById[1] = "VOTE_OPTION_YES"] = 1;
                values[valuesById[2] = "VOTE_OPTION_ABSTAIN"] = 2;
                values[valuesById[3] = "VOTE_OPTION_NO"] = 3;
                values[valuesById[4] = "VOTE_OPTION_NO_WITH_VETO"] = 4;
                return values;
            }();
            v1beta1.Msg = function() {
                function Msg(rpcImpl, requestDelimited, responseDelimited) {
                    $fQBv0.rpc.Service.call(this, rpcImpl, requestDelimited, responseDelimited);
                }
                (Msg.prototype = Object.create($fQBv0.rpc.Service.prototype)).constructor = Msg;
                Msg.create = function create(rpcImpl, requestDelimited, responseDelimited) {
                    return new this(rpcImpl, requestDelimited, responseDelimited);
                };
                Object.defineProperty(Msg.prototype.vote = function vote(request, callback) {
                    return this.rpcCall(vote, $d94845a59d001d47$var$$root.cosmos.gov.v1beta1.MsgVote, $d94845a59d001d47$var$$root.cosmos.gov.v1beta1.MsgVoteResponse, request, callback);
                }, "name", {
                    value: "Vote"
                });
                Object.defineProperty(Msg.prototype.deposit = function deposit(request, callback) {
                    return this.rpcCall(deposit, $d94845a59d001d47$var$$root.cosmos.gov.v1beta1.MsgDeposit, $d94845a59d001d47$var$$root.cosmos.gov.v1beta1.MsgDepositResponse, request, callback);
                }, "name", {
                    value: "Deposit"
                });
                return Msg;
            }();
            v1beta1.MsgVote = function() {
                function MsgVote(p) {
                    if (p) {
                        for(var ks = Object.keys(p), i = 0; i < ks.length; ++i)if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
                    }
                }
                MsgVote.prototype.proposalId = $d94845a59d001d47$var$$util.Long ? $d94845a59d001d47$var$$util.Long.fromBits(0, 0, true) : 0;
                MsgVote.prototype.voter = "";
                MsgVote.prototype.option = 0;
                MsgVote.create = function create(properties) {
                    return new MsgVote(properties);
                };
                MsgVote.encode = function encode(m, w) {
                    if (!w) w = $d94845a59d001d47$var$$Writer.create();
                    if (m.proposalId != null && Object.hasOwnProperty.call(m, "proposalId")) w.uint32(8).uint64(m.proposalId);
                    if (m.voter != null && Object.hasOwnProperty.call(m, "voter")) w.uint32(18).string(m.voter);
                    if (m.option != null && Object.hasOwnProperty.call(m, "option")) w.uint32(24).int32(m.option);
                    return w;
                };
                MsgVote.decode = function decode(r, l) {
                    if (!(r instanceof $d94845a59d001d47$var$$Reader)) r = $d94845a59d001d47$var$$Reader.create(r);
                    var c = l === undefined ? r.len : r.pos + l, m = new $d94845a59d001d47$var$$root.cosmos.gov.v1beta1.MsgVote();
                    while(r.pos < c){
                        var t = r.uint32();
                        switch(t >>> 3){
                            case 1:
                                m.proposalId = r.uint64();
                                break;
                            case 2:
                                m.voter = r.string();
                                break;
                            case 3:
                                m.option = r.int32();
                                break;
                            default:
                                r.skipType(t & 7);
                                break;
                        }
                    }
                    return m;
                };
                MsgVote.fromObject = function fromObject(d) {
                    if (d instanceof $d94845a59d001d47$var$$root.cosmos.gov.v1beta1.MsgVote) return d;
                    var m = new $d94845a59d001d47$var$$root.cosmos.gov.v1beta1.MsgVote();
                    if (d.proposalId != null) {
                        if ($d94845a59d001d47$var$$util.Long) (m.proposalId = $d94845a59d001d47$var$$util.Long.fromValue(d.proposalId)).unsigned = true;
                        else if (typeof d.proposalId === "string") m.proposalId = parseInt(d.proposalId, 10);
                        else if (typeof d.proposalId === "number") m.proposalId = d.proposalId;
                        else if (typeof d.proposalId === "object") m.proposalId = new $d94845a59d001d47$var$$util.LongBits(d.proposalId.low >>> 0, d.proposalId.high >>> 0).toNumber(true);
                    }
                    if (d.voter != null) m.voter = String(d.voter);
                    switch(d.option){
                        case "VOTE_OPTION_UNSPECIFIED":
                        case 0:
                            m.option = 0;
                            break;
                        case "VOTE_OPTION_YES":
                        case 1:
                            m.option = 1;
                            break;
                        case "VOTE_OPTION_ABSTAIN":
                        case 2:
                            m.option = 2;
                            break;
                        case "VOTE_OPTION_NO":
                        case 3:
                            m.option = 3;
                            break;
                        case "VOTE_OPTION_NO_WITH_VETO":
                        case 4:
                            m.option = 4;
                            break;
                    }
                    return m;
                };
                MsgVote.toObject = function toObject(m, o) {
                    if (!o) o = {};
                    var d = {};
                    if (o.defaults) {
                        if ($d94845a59d001d47$var$$util.Long) {
                            var n = new $d94845a59d001d47$var$$util.Long(0, 0, true);
                            d.proposalId = o.longs === String ? n.toString() : o.longs === Number ? n.toNumber() : n;
                        } else d.proposalId = o.longs === String ? "0" : 0;
                        d.voter = "";
                        d.option = o.enums === String ? "VOTE_OPTION_UNSPECIFIED" : 0;
                    }
                    if (m.proposalId != null && m.hasOwnProperty("proposalId")) {
                        if (typeof m.proposalId === "number") d.proposalId = o.longs === String ? String(m.proposalId) : m.proposalId;
                        else d.proposalId = o.longs === String ? $d94845a59d001d47$var$$util.Long.prototype.toString.call(m.proposalId) : o.longs === Number ? new $d94845a59d001d47$var$$util.LongBits(m.proposalId.low >>> 0, m.proposalId.high >>> 0).toNumber(true) : m.proposalId;
                    }
                    if (m.voter != null && m.hasOwnProperty("voter")) d.voter = m.voter;
                    if (m.option != null && m.hasOwnProperty("option")) d.option = o.enums === String ? $d94845a59d001d47$var$$root.cosmos.gov.v1beta1.VoteOption[m.option] : m.option;
                    return d;
                };
                MsgVote.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $fQBv0.util.toJSONOptions);
                };
                return MsgVote;
            }();
            v1beta1.MsgVoteResponse = function() {
                function MsgVoteResponse(p) {
                    if (p) {
                        for(var ks = Object.keys(p), i = 0; i < ks.length; ++i)if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
                    }
                }
                MsgVoteResponse.create = function create(properties) {
                    return new MsgVoteResponse(properties);
                };
                MsgVoteResponse.encode = function encode(m, w) {
                    if (!w) w = $d94845a59d001d47$var$$Writer.create();
                    return w;
                };
                MsgVoteResponse.decode = function decode(r, l) {
                    if (!(r instanceof $d94845a59d001d47$var$$Reader)) r = $d94845a59d001d47$var$$Reader.create(r);
                    var c = l === undefined ? r.len : r.pos + l, m = new $d94845a59d001d47$var$$root.cosmos.gov.v1beta1.MsgVoteResponse();
                    while(r.pos < c){
                        var t = r.uint32();
                        t;
                        r.skipType(t & 7);
                    }
                    return m;
                };
                MsgVoteResponse.fromObject = function fromObject(d) {
                    if (d instanceof $d94845a59d001d47$var$$root.cosmos.gov.v1beta1.MsgVoteResponse) return d;
                    return new $d94845a59d001d47$var$$root.cosmos.gov.v1beta1.MsgVoteResponse();
                };
                MsgVoteResponse.toObject = function toObject() {
                    return {};
                };
                MsgVoteResponse.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $fQBv0.util.toJSONOptions);
                };
                return MsgVoteResponse;
            }();
            v1beta1.MsgDeposit = function() {
                function MsgDeposit(p) {
                    this.amount = [];
                    if (p) {
                        for(var ks = Object.keys(p), i = 0; i < ks.length; ++i)if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
                    }
                }
                MsgDeposit.prototype.proposalId = $d94845a59d001d47$var$$util.Long ? $d94845a59d001d47$var$$util.Long.fromBits(0, 0, true) : 0;
                MsgDeposit.prototype.depositor = "";
                MsgDeposit.prototype.amount = $d94845a59d001d47$var$$util.emptyArray;
                MsgDeposit.create = function create(properties) {
                    return new MsgDeposit(properties);
                };
                MsgDeposit.encode = function encode(m, w) {
                    if (!w) w = $d94845a59d001d47$var$$Writer.create();
                    if (m.proposalId != null && Object.hasOwnProperty.call(m, "proposalId")) w.uint32(8).uint64(m.proposalId);
                    if (m.depositor != null && Object.hasOwnProperty.call(m, "depositor")) w.uint32(18).string(m.depositor);
                    if (m.amount != null && m.amount.length) for(var i = 0; i < m.amount.length; ++i)$d94845a59d001d47$var$$root.cosmos.base.v1beta1.Coin.encode(m.amount[i], w.uint32(26).fork()).ldelim();
                    return w;
                };
                MsgDeposit.decode = function decode(r, l) {
                    if (!(r instanceof $d94845a59d001d47$var$$Reader)) r = $d94845a59d001d47$var$$Reader.create(r);
                    var c = l === undefined ? r.len : r.pos + l, m = new $d94845a59d001d47$var$$root.cosmos.gov.v1beta1.MsgDeposit();
                    while(r.pos < c){
                        var t = r.uint32();
                        switch(t >>> 3){
                            case 1:
                                m.proposalId = r.uint64();
                                break;
                            case 2:
                                m.depositor = r.string();
                                break;
                            case 3:
                                if (!(m.amount && m.amount.length)) m.amount = [];
                                m.amount.push($d94845a59d001d47$var$$root.cosmos.base.v1beta1.Coin.decode(r, r.uint32()));
                                break;
                            default:
                                r.skipType(t & 7);
                                break;
                        }
                    }
                    return m;
                };
                MsgDeposit.fromObject = function fromObject(d) {
                    if (d instanceof $d94845a59d001d47$var$$root.cosmos.gov.v1beta1.MsgDeposit) return d;
                    var m = new $d94845a59d001d47$var$$root.cosmos.gov.v1beta1.MsgDeposit();
                    if (d.proposalId != null) {
                        if ($d94845a59d001d47$var$$util.Long) (m.proposalId = $d94845a59d001d47$var$$util.Long.fromValue(d.proposalId)).unsigned = true;
                        else if (typeof d.proposalId === "string") m.proposalId = parseInt(d.proposalId, 10);
                        else if (typeof d.proposalId === "number") m.proposalId = d.proposalId;
                        else if (typeof d.proposalId === "object") m.proposalId = new $d94845a59d001d47$var$$util.LongBits(d.proposalId.low >>> 0, d.proposalId.high >>> 0).toNumber(true);
                    }
                    if (d.depositor != null) m.depositor = String(d.depositor);
                    if (d.amount) {
                        if (!Array.isArray(d.amount)) throw TypeError(".cosmos.gov.v1beta1.MsgDeposit.amount: array expected");
                        m.amount = [];
                        for(var i = 0; i < d.amount.length; ++i){
                            if (typeof d.amount[i] !== "object") throw TypeError(".cosmos.gov.v1beta1.MsgDeposit.amount: object expected");
                            m.amount[i] = $d94845a59d001d47$var$$root.cosmos.base.v1beta1.Coin.fromObject(d.amount[i]);
                        }
                    }
                    return m;
                };
                MsgDeposit.toObject = function toObject(m, o) {
                    if (!o) o = {};
                    var d = {};
                    if (o.arrays || o.defaults) d.amount = [];
                    if (o.defaults) {
                        if ($d94845a59d001d47$var$$util.Long) {
                            var n = new $d94845a59d001d47$var$$util.Long(0, 0, true);
                            d.proposalId = o.longs === String ? n.toString() : o.longs === Number ? n.toNumber() : n;
                        } else d.proposalId = o.longs === String ? "0" : 0;
                        d.depositor = "";
                    }
                    if (m.proposalId != null && m.hasOwnProperty("proposalId")) {
                        if (typeof m.proposalId === "number") d.proposalId = o.longs === String ? String(m.proposalId) : m.proposalId;
                        else d.proposalId = o.longs === String ? $d94845a59d001d47$var$$util.Long.prototype.toString.call(m.proposalId) : o.longs === Number ? new $d94845a59d001d47$var$$util.LongBits(m.proposalId.low >>> 0, m.proposalId.high >>> 0).toNumber(true) : m.proposalId;
                    }
                    if (m.depositor != null && m.hasOwnProperty("depositor")) d.depositor = m.depositor;
                    if (m.amount && m.amount.length) {
                        d.amount = [];
                        for(var j = 0; j < m.amount.length; ++j)d.amount[j] = $d94845a59d001d47$var$$root.cosmos.base.v1beta1.Coin.toObject(m.amount[j], o);
                    }
                    return d;
                };
                MsgDeposit.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $fQBv0.util.toJSONOptions);
                };
                return MsgDeposit;
            }();
            v1beta1.MsgDepositResponse = function() {
                function MsgDepositResponse(p) {
                    if (p) {
                        for(var ks = Object.keys(p), i = 0; i < ks.length; ++i)if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
                    }
                }
                MsgDepositResponse.create = function create(properties) {
                    return new MsgDepositResponse(properties);
                };
                MsgDepositResponse.encode = function encode(m, w) {
                    if (!w) w = $d94845a59d001d47$var$$Writer.create();
                    return w;
                };
                MsgDepositResponse.decode = function decode(r, l) {
                    if (!(r instanceof $d94845a59d001d47$var$$Reader)) r = $d94845a59d001d47$var$$Reader.create(r);
                    var c = l === undefined ? r.len : r.pos + l, m = new $d94845a59d001d47$var$$root.cosmos.gov.v1beta1.MsgDepositResponse();
                    while(r.pos < c){
                        var t = r.uint32();
                        t;
                        r.skipType(t & 7);
                    }
                    return m;
                };
                MsgDepositResponse.fromObject = function fromObject(d) {
                    if (d instanceof $d94845a59d001d47$var$$root.cosmos.gov.v1beta1.MsgDepositResponse) return d;
                    return new $d94845a59d001d47$var$$root.cosmos.gov.v1beta1.MsgDepositResponse();
                };
                MsgDepositResponse.toObject = function toObject() {
                    return {};
                };
                MsgDepositResponse.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $fQBv0.util.toJSONOptions);
                };
                return MsgDepositResponse;
            }();
            return v1beta1;
        }();
        return gov;
    }();
    cosmos.distribution = function() {
        const distribution = {};
        distribution.v1beta1 = function() {
            const v1beta1 = {};
            v1beta1.Msg = function() {
                function Msg(rpcImpl, requestDelimited, responseDelimited) {
                    $fQBv0.rpc.Service.call(this, rpcImpl, requestDelimited, responseDelimited);
                }
                (Msg.prototype = Object.create($fQBv0.rpc.Service.prototype)).constructor = Msg;
                Msg.create = function create(rpcImpl, requestDelimited, responseDelimited) {
                    return new this(rpcImpl, requestDelimited, responseDelimited);
                };
                Object.defineProperty(Msg.prototype.withdrawDelegatorReward = function withdrawDelegatorReward(request, callback) {
                    return this.rpcCall(withdrawDelegatorReward, $d94845a59d001d47$var$$root.cosmos.distribution.v1beta1.MsgWithdrawDelegatorReward, $d94845a59d001d47$var$$root.cosmos.distribution.v1beta1.MsgWithdrawDelegatorRewardResponse, request, callback);
                }, "name", {
                    value: "WithdrawDelegatorReward"
                });
                return Msg;
            }();
            v1beta1.MsgWithdrawDelegatorReward = function() {
                function MsgWithdrawDelegatorReward(p) {
                    if (p) {
                        for(var ks = Object.keys(p), i = 0; i < ks.length; ++i)if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
                    }
                }
                MsgWithdrawDelegatorReward.prototype.delegatorAddress = "";
                MsgWithdrawDelegatorReward.prototype.validatorAddress = "";
                MsgWithdrawDelegatorReward.create = function create(properties) {
                    return new MsgWithdrawDelegatorReward(properties);
                };
                MsgWithdrawDelegatorReward.encode = function encode(m, w) {
                    if (!w) w = $d94845a59d001d47$var$$Writer.create();
                    if (m.delegatorAddress != null && Object.hasOwnProperty.call(m, "delegatorAddress")) w.uint32(10).string(m.delegatorAddress);
                    if (m.validatorAddress != null && Object.hasOwnProperty.call(m, "validatorAddress")) w.uint32(18).string(m.validatorAddress);
                    return w;
                };
                MsgWithdrawDelegatorReward.decode = function decode(r, l) {
                    if (!(r instanceof $d94845a59d001d47$var$$Reader)) r = $d94845a59d001d47$var$$Reader.create(r);
                    var c = l === undefined ? r.len : r.pos + l, m = new $d94845a59d001d47$var$$root.cosmos.distribution.v1beta1.MsgWithdrawDelegatorReward();
                    while(r.pos < c){
                        var t = r.uint32();
                        switch(t >>> 3){
                            case 1:
                                m.delegatorAddress = r.string();
                                break;
                            case 2:
                                m.validatorAddress = r.string();
                                break;
                            default:
                                r.skipType(t & 7);
                                break;
                        }
                    }
                    return m;
                };
                MsgWithdrawDelegatorReward.fromObject = function fromObject(d) {
                    if (d instanceof $d94845a59d001d47$var$$root.cosmos.distribution.v1beta1.MsgWithdrawDelegatorReward) return d;
                    var m = new $d94845a59d001d47$var$$root.cosmos.distribution.v1beta1.MsgWithdrawDelegatorReward();
                    if (d.delegatorAddress != null) m.delegatorAddress = String(d.delegatorAddress);
                    if (d.validatorAddress != null) m.validatorAddress = String(d.validatorAddress);
                    return m;
                };
                MsgWithdrawDelegatorReward.toObject = function toObject(m, o) {
                    if (!o) o = {};
                    var d = {};
                    if (o.defaults) {
                        d.delegatorAddress = "";
                        d.validatorAddress = "";
                    }
                    if (m.delegatorAddress != null && m.hasOwnProperty("delegatorAddress")) d.delegatorAddress = m.delegatorAddress;
                    if (m.validatorAddress != null && m.hasOwnProperty("validatorAddress")) d.validatorAddress = m.validatorAddress;
                    return d;
                };
                MsgWithdrawDelegatorReward.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $fQBv0.util.toJSONOptions);
                };
                return MsgWithdrawDelegatorReward;
            }();
            v1beta1.MsgWithdrawDelegatorRewardResponse = function() {
                function MsgWithdrawDelegatorRewardResponse(p) {
                    if (p) {
                        for(var ks = Object.keys(p), i = 0; i < ks.length; ++i)if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
                    }
                }
                MsgWithdrawDelegatorRewardResponse.create = function create(properties) {
                    return new MsgWithdrawDelegatorRewardResponse(properties);
                };
                MsgWithdrawDelegatorRewardResponse.encode = function encode(m, w) {
                    if (!w) w = $d94845a59d001d47$var$$Writer.create();
                    return w;
                };
                MsgWithdrawDelegatorRewardResponse.decode = function decode(r, l) {
                    if (!(r instanceof $d94845a59d001d47$var$$Reader)) r = $d94845a59d001d47$var$$Reader.create(r);
                    var c = l === undefined ? r.len : r.pos + l, m = new $d94845a59d001d47$var$$root.cosmos.distribution.v1beta1.MsgWithdrawDelegatorRewardResponse();
                    while(r.pos < c){
                        var t = r.uint32();
                        t;
                        r.skipType(t & 7);
                    }
                    return m;
                };
                MsgWithdrawDelegatorRewardResponse.fromObject = function fromObject(d) {
                    if (d instanceof $d94845a59d001d47$var$$root.cosmos.distribution.v1beta1.MsgWithdrawDelegatorRewardResponse) return d;
                    return new $d94845a59d001d47$var$$root.cosmos.distribution.v1beta1.MsgWithdrawDelegatorRewardResponse();
                };
                MsgWithdrawDelegatorRewardResponse.toObject = function toObject() {
                    return {};
                };
                MsgWithdrawDelegatorRewardResponse.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $fQBv0.util.toJSONOptions);
                };
                return MsgWithdrawDelegatorRewardResponse;
            }();
            return v1beta1;
        }();
        return distribution;
    }();
    cosmos.base = function() {
        const base = {};
        base.v1beta1 = function() {
            const v1beta1 = {};
            v1beta1.Coin = function() {
                function Coin(p) {
                    if (p) {
                        for(var ks = Object.keys(p), i = 0; i < ks.length; ++i)if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
                    }
                }
                Coin.prototype.denom = "";
                Coin.prototype.amount = "";
                Coin.create = function create(properties) {
                    return new Coin(properties);
                };
                Coin.encode = function encode(m, w) {
                    if (!w) w = $d94845a59d001d47$var$$Writer.create();
                    if (m.denom != null && Object.hasOwnProperty.call(m, "denom")) w.uint32(10).string(m.denom);
                    if (m.amount != null && Object.hasOwnProperty.call(m, "amount")) w.uint32(18).string(m.amount);
                    return w;
                };
                Coin.decode = function decode(r, l) {
                    if (!(r instanceof $d94845a59d001d47$var$$Reader)) r = $d94845a59d001d47$var$$Reader.create(r);
                    var c = l === undefined ? r.len : r.pos + l, m = new $d94845a59d001d47$var$$root.cosmos.base.v1beta1.Coin();
                    while(r.pos < c){
                        var t = r.uint32();
                        switch(t >>> 3){
                            case 1:
                                m.denom = r.string();
                                break;
                            case 2:
                                m.amount = r.string();
                                break;
                            default:
                                r.skipType(t & 7);
                                break;
                        }
                    }
                    return m;
                };
                Coin.fromObject = function fromObject(d) {
                    if (d instanceof $d94845a59d001d47$var$$root.cosmos.base.v1beta1.Coin) return d;
                    var m = new $d94845a59d001d47$var$$root.cosmos.base.v1beta1.Coin();
                    if (d.denom != null) m.denom = String(d.denom);
                    if (d.amount != null) m.amount = String(d.amount);
                    return m;
                };
                Coin.toObject = function toObject(m, o) {
                    if (!o) o = {};
                    var d = {};
                    if (o.defaults) {
                        d.denom = "";
                        d.amount = "";
                    }
                    if (m.denom != null && m.hasOwnProperty("denom")) d.denom = m.denom;
                    if (m.amount != null && m.hasOwnProperty("amount")) d.amount = m.amount;
                    return d;
                };
                Coin.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $fQBv0.util.toJSONOptions);
                };
                return Coin;
            }();
            v1beta1.DecCoin = function() {
                function DecCoin(p) {
                    if (p) {
                        for(var ks = Object.keys(p), i = 0; i < ks.length; ++i)if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
                    }
                }
                DecCoin.prototype.denom = "";
                DecCoin.prototype.amount = "";
                DecCoin.create = function create(properties) {
                    return new DecCoin(properties);
                };
                DecCoin.encode = function encode(m, w) {
                    if (!w) w = $d94845a59d001d47$var$$Writer.create();
                    if (m.denom != null && Object.hasOwnProperty.call(m, "denom")) w.uint32(10).string(m.denom);
                    if (m.amount != null && Object.hasOwnProperty.call(m, "amount")) w.uint32(18).string(m.amount);
                    return w;
                };
                DecCoin.decode = function decode(r, l) {
                    if (!(r instanceof $d94845a59d001d47$var$$Reader)) r = $d94845a59d001d47$var$$Reader.create(r);
                    var c = l === undefined ? r.len : r.pos + l, m = new $d94845a59d001d47$var$$root.cosmos.base.v1beta1.DecCoin();
                    while(r.pos < c){
                        var t = r.uint32();
                        switch(t >>> 3){
                            case 1:
                                m.denom = r.string();
                                break;
                            case 2:
                                m.amount = r.string();
                                break;
                            default:
                                r.skipType(t & 7);
                                break;
                        }
                    }
                    return m;
                };
                DecCoin.fromObject = function fromObject(d) {
                    if (d instanceof $d94845a59d001d47$var$$root.cosmos.base.v1beta1.DecCoin) return d;
                    var m = new $d94845a59d001d47$var$$root.cosmos.base.v1beta1.DecCoin();
                    if (d.denom != null) m.denom = String(d.denom);
                    if (d.amount != null) m.amount = String(d.amount);
                    return m;
                };
                DecCoin.toObject = function toObject(m, o) {
                    if (!o) o = {};
                    var d = {};
                    if (o.defaults) {
                        d.denom = "";
                        d.amount = "";
                    }
                    if (m.denom != null && m.hasOwnProperty("denom")) d.denom = m.denom;
                    if (m.amount != null && m.hasOwnProperty("amount")) d.amount = m.amount;
                    return d;
                };
                DecCoin.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $fQBv0.util.toJSONOptions);
                };
                return DecCoin;
            }();
            v1beta1.IntProto = function() {
                function IntProto(p) {
                    if (p) {
                        for(var ks = Object.keys(p), i = 0; i < ks.length; ++i)if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
                    }
                }
                IntProto.prototype.int = "";
                IntProto.create = function create(properties) {
                    return new IntProto(properties);
                };
                IntProto.encode = function encode(m, w) {
                    if (!w) w = $d94845a59d001d47$var$$Writer.create();
                    if (m.int != null && Object.hasOwnProperty.call(m, "int")) w.uint32(10).string(m.int);
                    return w;
                };
                IntProto.decode = function decode(r, l) {
                    if (!(r instanceof $d94845a59d001d47$var$$Reader)) r = $d94845a59d001d47$var$$Reader.create(r);
                    var c = l === undefined ? r.len : r.pos + l, m = new $d94845a59d001d47$var$$root.cosmos.base.v1beta1.IntProto();
                    while(r.pos < c){
                        var t = r.uint32();
                        switch(t >>> 3){
                            case 1:
                                m.int = r.string();
                                break;
                            default:
                                r.skipType(t & 7);
                                break;
                        }
                    }
                    return m;
                };
                IntProto.fromObject = function fromObject(d) {
                    if (d instanceof $d94845a59d001d47$var$$root.cosmos.base.v1beta1.IntProto) return d;
                    var m = new $d94845a59d001d47$var$$root.cosmos.base.v1beta1.IntProto();
                    if (d.int != null) m.int = String(d.int);
                    return m;
                };
                IntProto.toObject = function toObject(m, o) {
                    if (!o) o = {};
                    var d = {};
                    if (o.defaults) d.int = "";
                    if (m.int != null && m.hasOwnProperty("int")) d.int = m.int;
                    return d;
                };
                IntProto.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $fQBv0.util.toJSONOptions);
                };
                return IntProto;
            }();
            v1beta1.DecProto = function() {
                function DecProto(p) {
                    if (p) {
                        for(var ks = Object.keys(p), i = 0; i < ks.length; ++i)if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
                    }
                }
                DecProto.prototype.dec = "";
                DecProto.create = function create(properties) {
                    return new DecProto(properties);
                };
                DecProto.encode = function encode(m, w) {
                    if (!w) w = $d94845a59d001d47$var$$Writer.create();
                    if (m.dec != null && Object.hasOwnProperty.call(m, "dec")) w.uint32(10).string(m.dec);
                    return w;
                };
                DecProto.decode = function decode(r, l) {
                    if (!(r instanceof $d94845a59d001d47$var$$Reader)) r = $d94845a59d001d47$var$$Reader.create(r);
                    var c = l === undefined ? r.len : r.pos + l, m = new $d94845a59d001d47$var$$root.cosmos.base.v1beta1.DecProto();
                    while(r.pos < c){
                        var t = r.uint32();
                        switch(t >>> 3){
                            case 1:
                                m.dec = r.string();
                                break;
                            default:
                                r.skipType(t & 7);
                                break;
                        }
                    }
                    return m;
                };
                DecProto.fromObject = function fromObject(d) {
                    if (d instanceof $d94845a59d001d47$var$$root.cosmos.base.v1beta1.DecProto) return d;
                    var m = new $d94845a59d001d47$var$$root.cosmos.base.v1beta1.DecProto();
                    if (d.dec != null) m.dec = String(d.dec);
                    return m;
                };
                DecProto.toObject = function toObject(m, o) {
                    if (!o) o = {};
                    var d = {};
                    if (o.defaults) d.dec = "";
                    if (m.dec != null && m.hasOwnProperty("dec")) d.dec = m.dec;
                    return d;
                };
                DecProto.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $fQBv0.util.toJSONOptions);
                };
                return DecProto;
            }();
            return v1beta1;
        }();
        base.abci = function() {
            const abci = {};
            abci.v1beta1 = function() {
                const v1beta1 = {};
                v1beta1.MsgData = function() {
                    function MsgData(p) {
                        if (p) {
                            for(var ks = Object.keys(p), i = 0; i < ks.length; ++i)if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
                        }
                    }
                    MsgData.prototype.msgType = "";
                    MsgData.prototype.data = $d94845a59d001d47$var$$util.newBuffer([]);
                    MsgData.create = function create(properties) {
                        return new MsgData(properties);
                    };
                    MsgData.encode = function encode(m, w) {
                        if (!w) w = $d94845a59d001d47$var$$Writer.create();
                        if (m.msgType != null && Object.hasOwnProperty.call(m, "msgType")) w.uint32(10).string(m.msgType);
                        if (m.data != null && Object.hasOwnProperty.call(m, "data")) w.uint32(18).bytes(m.data);
                        return w;
                    };
                    MsgData.decode = function decode(r, l) {
                        if (!(r instanceof $d94845a59d001d47$var$$Reader)) r = $d94845a59d001d47$var$$Reader.create(r);
                        var c = l === undefined ? r.len : r.pos + l, m = new $d94845a59d001d47$var$$root.cosmos.base.abci.v1beta1.MsgData();
                        while(r.pos < c){
                            var t = r.uint32();
                            switch(t >>> 3){
                                case 1:
                                    m.msgType = r.string();
                                    break;
                                case 2:
                                    m.data = r.bytes();
                                    break;
                                default:
                                    r.skipType(t & 7);
                                    break;
                            }
                        }
                        return m;
                    };
                    MsgData.fromObject = function fromObject(d) {
                        if (d instanceof $d94845a59d001d47$var$$root.cosmos.base.abci.v1beta1.MsgData) return d;
                        var m = new $d94845a59d001d47$var$$root.cosmos.base.abci.v1beta1.MsgData();
                        if (d.msgType != null) m.msgType = String(d.msgType);
                        if (d.data != null) {
                            if (typeof d.data === "string") $d94845a59d001d47$var$$util.base64.decode(d.data, m.data = $d94845a59d001d47$var$$util.newBuffer($d94845a59d001d47$var$$util.base64.length(d.data)), 0);
                            else if (d.data.length) m.data = d.data;
                        }
                        return m;
                    };
                    MsgData.toObject = function toObject(m, o) {
                        if (!o) o = {};
                        var d = {};
                        if (o.defaults) {
                            d.msgType = "";
                            if (o.bytes === String) d.data = "";
                            else {
                                d.data = [];
                                if (o.bytes !== Array) d.data = $d94845a59d001d47$var$$util.newBuffer(d.data);
                            }
                        }
                        if (m.msgType != null && m.hasOwnProperty("msgType")) d.msgType = m.msgType;
                        if (m.data != null && m.hasOwnProperty("data")) d.data = o.bytes === String ? $d94845a59d001d47$var$$util.base64.encode(m.data, 0, m.data.length) : o.bytes === Array ? Array.prototype.slice.call(m.data) : m.data;
                        return d;
                    };
                    MsgData.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $fQBv0.util.toJSONOptions);
                    };
                    return MsgData;
                }();
                v1beta1.TxMsgData = function() {
                    function TxMsgData(p) {
                        this.data = [];
                        if (p) {
                            for(var ks = Object.keys(p), i = 0; i < ks.length; ++i)if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
                        }
                    }
                    TxMsgData.prototype.data = $d94845a59d001d47$var$$util.emptyArray;
                    TxMsgData.create = function create(properties) {
                        return new TxMsgData(properties);
                    };
                    TxMsgData.encode = function encode(m, w) {
                        if (!w) w = $d94845a59d001d47$var$$Writer.create();
                        if (m.data != null && m.data.length) for(var i = 0; i < m.data.length; ++i)$d94845a59d001d47$var$$root.cosmos.base.abci.v1beta1.MsgData.encode(m.data[i], w.uint32(10).fork()).ldelim();
                        return w;
                    };
                    TxMsgData.decode = function decode(r, l) {
                        if (!(r instanceof $d94845a59d001d47$var$$Reader)) r = $d94845a59d001d47$var$$Reader.create(r);
                        var c = l === undefined ? r.len : r.pos + l, m = new $d94845a59d001d47$var$$root.cosmos.base.abci.v1beta1.TxMsgData();
                        while(r.pos < c){
                            var t = r.uint32();
                            switch(t >>> 3){
                                case 1:
                                    if (!(m.data && m.data.length)) m.data = [];
                                    m.data.push($d94845a59d001d47$var$$root.cosmos.base.abci.v1beta1.MsgData.decode(r, r.uint32()));
                                    break;
                                default:
                                    r.skipType(t & 7);
                                    break;
                            }
                        }
                        return m;
                    };
                    TxMsgData.fromObject = function fromObject(d) {
                        if (d instanceof $d94845a59d001d47$var$$root.cosmos.base.abci.v1beta1.TxMsgData) return d;
                        var m = new $d94845a59d001d47$var$$root.cosmos.base.abci.v1beta1.TxMsgData();
                        if (d.data) {
                            if (!Array.isArray(d.data)) throw TypeError(".cosmos.base.abci.v1beta1.TxMsgData.data: array expected");
                            m.data = [];
                            for(var i = 0; i < d.data.length; ++i){
                                if (typeof d.data[i] !== "object") throw TypeError(".cosmos.base.abci.v1beta1.TxMsgData.data: object expected");
                                m.data[i] = $d94845a59d001d47$var$$root.cosmos.base.abci.v1beta1.MsgData.fromObject(d.data[i]);
                            }
                        }
                        return m;
                    };
                    TxMsgData.toObject = function toObject(m, o) {
                        if (!o) o = {};
                        var d = {};
                        if (o.arrays || o.defaults) d.data = [];
                        if (m.data && m.data.length) {
                            d.data = [];
                            for(var j = 0; j < m.data.length; ++j)d.data[j] = $d94845a59d001d47$var$$root.cosmos.base.abci.v1beta1.MsgData.toObject(m.data[j], o);
                        }
                        return d;
                    };
                    TxMsgData.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $fQBv0.util.toJSONOptions);
                    };
                    return TxMsgData;
                }();
                return v1beta1;
            }();
            return abci;
        }();
        return base;
    }();
    cosmos.crypto = function() {
        const crypto = {};
        crypto.multisig = function() {
            const multisig = {};
            multisig.v1beta1 = function() {
                const v1beta1 = {};
                v1beta1.MultiSignature = function() {
                    function MultiSignature(p) {
                        this.signatures = [];
                        if (p) {
                            for(var ks = Object.keys(p), i = 0; i < ks.length; ++i)if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
                        }
                    }
                    MultiSignature.prototype.signatures = $d94845a59d001d47$var$$util.emptyArray;
                    MultiSignature.create = function create(properties) {
                        return new MultiSignature(properties);
                    };
                    MultiSignature.encode = function encode(m, w) {
                        if (!w) w = $d94845a59d001d47$var$$Writer.create();
                        if (m.signatures != null && m.signatures.length) for(var i = 0; i < m.signatures.length; ++i)w.uint32(10).bytes(m.signatures[i]);
                        return w;
                    };
                    MultiSignature.decode = function decode(r, l) {
                        if (!(r instanceof $d94845a59d001d47$var$$Reader)) r = $d94845a59d001d47$var$$Reader.create(r);
                        var c = l === undefined ? r.len : r.pos + l, m = new $d94845a59d001d47$var$$root.cosmos.crypto.multisig.v1beta1.MultiSignature();
                        while(r.pos < c){
                            var t = r.uint32();
                            switch(t >>> 3){
                                case 1:
                                    if (!(m.signatures && m.signatures.length)) m.signatures = [];
                                    m.signatures.push(r.bytes());
                                    break;
                                default:
                                    r.skipType(t & 7);
                                    break;
                            }
                        }
                        return m;
                    };
                    MultiSignature.fromObject = function fromObject(d) {
                        if (d instanceof $d94845a59d001d47$var$$root.cosmos.crypto.multisig.v1beta1.MultiSignature) return d;
                        var m = new $d94845a59d001d47$var$$root.cosmos.crypto.multisig.v1beta1.MultiSignature();
                        if (d.signatures) {
                            if (!Array.isArray(d.signatures)) throw TypeError(".cosmos.crypto.multisig.v1beta1.MultiSignature.signatures: array expected");
                            m.signatures = [];
                            for(var i = 0; i < d.signatures.length; ++i){
                                if (typeof d.signatures[i] === "string") $d94845a59d001d47$var$$util.base64.decode(d.signatures[i], m.signatures[i] = $d94845a59d001d47$var$$util.newBuffer($d94845a59d001d47$var$$util.base64.length(d.signatures[i])), 0);
                                else if (d.signatures[i].length) m.signatures[i] = d.signatures[i];
                            }
                        }
                        return m;
                    };
                    MultiSignature.toObject = function toObject(m, o) {
                        if (!o) o = {};
                        var d = {};
                        if (o.arrays || o.defaults) d.signatures = [];
                        if (m.signatures && m.signatures.length) {
                            d.signatures = [];
                            for(var j = 0; j < m.signatures.length; ++j)d.signatures[j] = o.bytes === String ? $d94845a59d001d47$var$$util.base64.encode(m.signatures[j], 0, m.signatures[j].length) : o.bytes === Array ? Array.prototype.slice.call(m.signatures[j]) : m.signatures[j];
                        }
                        return d;
                    };
                    MultiSignature.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $fQBv0.util.toJSONOptions);
                    };
                    return MultiSignature;
                }();
                v1beta1.CompactBitArray = function() {
                    function CompactBitArray(p) {
                        if (p) {
                            for(var ks = Object.keys(p), i = 0; i < ks.length; ++i)if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
                        }
                    }
                    CompactBitArray.prototype.extraBitsStored = 0;
                    CompactBitArray.prototype.elems = $d94845a59d001d47$var$$util.newBuffer([]);
                    CompactBitArray.create = function create(properties) {
                        return new CompactBitArray(properties);
                    };
                    CompactBitArray.encode = function encode(m, w) {
                        if (!w) w = $d94845a59d001d47$var$$Writer.create();
                        if (m.extraBitsStored != null && Object.hasOwnProperty.call(m, "extraBitsStored")) w.uint32(8).uint32(m.extraBitsStored);
                        if (m.elems != null && Object.hasOwnProperty.call(m, "elems")) w.uint32(18).bytes(m.elems);
                        return w;
                    };
                    CompactBitArray.decode = function decode(r, l) {
                        if (!(r instanceof $d94845a59d001d47$var$$Reader)) r = $d94845a59d001d47$var$$Reader.create(r);
                        var c = l === undefined ? r.len : r.pos + l, m = new $d94845a59d001d47$var$$root.cosmos.crypto.multisig.v1beta1.CompactBitArray();
                        while(r.pos < c){
                            var t = r.uint32();
                            switch(t >>> 3){
                                case 1:
                                    m.extraBitsStored = r.uint32();
                                    break;
                                case 2:
                                    m.elems = r.bytes();
                                    break;
                                default:
                                    r.skipType(t & 7);
                                    break;
                            }
                        }
                        return m;
                    };
                    CompactBitArray.fromObject = function fromObject(d) {
                        if (d instanceof $d94845a59d001d47$var$$root.cosmos.crypto.multisig.v1beta1.CompactBitArray) return d;
                        var m = new $d94845a59d001d47$var$$root.cosmos.crypto.multisig.v1beta1.CompactBitArray();
                        if (d.extraBitsStored != null) m.extraBitsStored = d.extraBitsStored >>> 0;
                        if (d.elems != null) {
                            if (typeof d.elems === "string") $d94845a59d001d47$var$$util.base64.decode(d.elems, m.elems = $d94845a59d001d47$var$$util.newBuffer($d94845a59d001d47$var$$util.base64.length(d.elems)), 0);
                            else if (d.elems.length) m.elems = d.elems;
                        }
                        return m;
                    };
                    CompactBitArray.toObject = function toObject(m, o) {
                        if (!o) o = {};
                        var d = {};
                        if (o.defaults) {
                            d.extraBitsStored = 0;
                            if (o.bytes === String) d.elems = "";
                            else {
                                d.elems = [];
                                if (o.bytes !== Array) d.elems = $d94845a59d001d47$var$$util.newBuffer(d.elems);
                            }
                        }
                        if (m.extraBitsStored != null && m.hasOwnProperty("extraBitsStored")) d.extraBitsStored = m.extraBitsStored;
                        if (m.elems != null && m.hasOwnProperty("elems")) d.elems = o.bytes === String ? $d94845a59d001d47$var$$util.base64.encode(m.elems, 0, m.elems.length) : o.bytes === Array ? Array.prototype.slice.call(m.elems) : m.elems;
                        return d;
                    };
                    CompactBitArray.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $fQBv0.util.toJSONOptions);
                    };
                    return CompactBitArray;
                }();
                return v1beta1;
            }();
            return multisig;
        }();
        crypto.secp256k1 = function() {
            const secp256k1 = {};
            secp256k1.PubKey = function() {
                function PubKey(p) {
                    if (p) {
                        for(var ks = Object.keys(p), i = 0; i < ks.length; ++i)if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
                    }
                }
                PubKey.prototype.key = $d94845a59d001d47$var$$util.newBuffer([]);
                PubKey.create = function create(properties) {
                    return new PubKey(properties);
                };
                PubKey.encode = function encode(m, w) {
                    if (!w) w = $d94845a59d001d47$var$$Writer.create();
                    if (m.key != null && Object.hasOwnProperty.call(m, "key")) w.uint32(10).bytes(m.key);
                    return w;
                };
                PubKey.decode = function decode(r, l) {
                    if (!(r instanceof $d94845a59d001d47$var$$Reader)) r = $d94845a59d001d47$var$$Reader.create(r);
                    var c = l === undefined ? r.len : r.pos + l, m = new $d94845a59d001d47$var$$root.cosmos.crypto.secp256k1.PubKey();
                    while(r.pos < c){
                        var t = r.uint32();
                        switch(t >>> 3){
                            case 1:
                                m.key = r.bytes();
                                break;
                            default:
                                r.skipType(t & 7);
                                break;
                        }
                    }
                    return m;
                };
                PubKey.fromObject = function fromObject(d) {
                    if (d instanceof $d94845a59d001d47$var$$root.cosmos.crypto.secp256k1.PubKey) return d;
                    var m = new $d94845a59d001d47$var$$root.cosmos.crypto.secp256k1.PubKey();
                    if (d.key != null) {
                        if (typeof d.key === "string") $d94845a59d001d47$var$$util.base64.decode(d.key, m.key = $d94845a59d001d47$var$$util.newBuffer($d94845a59d001d47$var$$util.base64.length(d.key)), 0);
                        else if (d.key.length) m.key = d.key;
                    }
                    return m;
                };
                PubKey.toObject = function toObject(m, o) {
                    if (!o) o = {};
                    var d = {};
                    if (o.defaults) {
                        if (o.bytes === String) d.key = "";
                        else {
                            d.key = [];
                            if (o.bytes !== Array) d.key = $d94845a59d001d47$var$$util.newBuffer(d.key);
                        }
                    }
                    if (m.key != null && m.hasOwnProperty("key")) d.key = o.bytes === String ? $d94845a59d001d47$var$$util.base64.encode(m.key, 0, m.key.length) : o.bytes === Array ? Array.prototype.slice.call(m.key) : m.key;
                    return d;
                };
                PubKey.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $fQBv0.util.toJSONOptions);
                };
                return PubKey;
            }();
            secp256k1.PrivKey = function() {
                function PrivKey(p) {
                    if (p) {
                        for(var ks = Object.keys(p), i = 0; i < ks.length; ++i)if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
                    }
                }
                PrivKey.prototype.key = $d94845a59d001d47$var$$util.newBuffer([]);
                PrivKey.create = function create(properties) {
                    return new PrivKey(properties);
                };
                PrivKey.encode = function encode(m, w) {
                    if (!w) w = $d94845a59d001d47$var$$Writer.create();
                    if (m.key != null && Object.hasOwnProperty.call(m, "key")) w.uint32(10).bytes(m.key);
                    return w;
                };
                PrivKey.decode = function decode(r, l) {
                    if (!(r instanceof $d94845a59d001d47$var$$Reader)) r = $d94845a59d001d47$var$$Reader.create(r);
                    var c = l === undefined ? r.len : r.pos + l, m = new $d94845a59d001d47$var$$root.cosmos.crypto.secp256k1.PrivKey();
                    while(r.pos < c){
                        var t = r.uint32();
                        switch(t >>> 3){
                            case 1:
                                m.key = r.bytes();
                                break;
                            default:
                                r.skipType(t & 7);
                                break;
                        }
                    }
                    return m;
                };
                PrivKey.fromObject = function fromObject(d) {
                    if (d instanceof $d94845a59d001d47$var$$root.cosmos.crypto.secp256k1.PrivKey) return d;
                    var m = new $d94845a59d001d47$var$$root.cosmos.crypto.secp256k1.PrivKey();
                    if (d.key != null) {
                        if (typeof d.key === "string") $d94845a59d001d47$var$$util.base64.decode(d.key, m.key = $d94845a59d001d47$var$$util.newBuffer($d94845a59d001d47$var$$util.base64.length(d.key)), 0);
                        else if (d.key.length) m.key = d.key;
                    }
                    return m;
                };
                PrivKey.toObject = function toObject(m, o) {
                    if (!o) o = {};
                    var d = {};
                    if (o.defaults) {
                        if (o.bytes === String) d.key = "";
                        else {
                            d.key = [];
                            if (o.bytes !== Array) d.key = $d94845a59d001d47$var$$util.newBuffer(d.key);
                        }
                    }
                    if (m.key != null && m.hasOwnProperty("key")) d.key = o.bytes === String ? $d94845a59d001d47$var$$util.base64.encode(m.key, 0, m.key.length) : o.bytes === Array ? Array.prototype.slice.call(m.key) : m.key;
                    return d;
                };
                PrivKey.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $fQBv0.util.toJSONOptions);
                };
                return PrivKey;
            }();
            return secp256k1;
        }();
        return crypto;
    }();
    cosmos.tx = function() {
        const tx = {};
        tx.v1beta1 = function() {
            const v1beta1 = {};
            v1beta1.Tx = function() {
                function Tx(p) {
                    this.signatures = [];
                    if (p) {
                        for(var ks = Object.keys(p), i = 0; i < ks.length; ++i)if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
                    }
                }
                Tx.prototype.body = null;
                Tx.prototype.authInfo = null;
                Tx.prototype.signatures = $d94845a59d001d47$var$$util.emptyArray;
                Tx.create = function create(properties) {
                    return new Tx(properties);
                };
                Tx.encode = function encode(m, w) {
                    if (!w) w = $d94845a59d001d47$var$$Writer.create();
                    if (m.body != null && Object.hasOwnProperty.call(m, "body")) $d94845a59d001d47$var$$root.cosmos.tx.v1beta1.TxBody.encode(m.body, w.uint32(10).fork()).ldelim();
                    if (m.authInfo != null && Object.hasOwnProperty.call(m, "authInfo")) $d94845a59d001d47$var$$root.cosmos.tx.v1beta1.AuthInfo.encode(m.authInfo, w.uint32(18).fork()).ldelim();
                    if (m.signatures != null && m.signatures.length) for(var i = 0; i < m.signatures.length; ++i)w.uint32(26).bytes(m.signatures[i]);
                    return w;
                };
                Tx.decode = function decode(r, l) {
                    if (!(r instanceof $d94845a59d001d47$var$$Reader)) r = $d94845a59d001d47$var$$Reader.create(r);
                    var c = l === undefined ? r.len : r.pos + l, m = new $d94845a59d001d47$var$$root.cosmos.tx.v1beta1.Tx();
                    while(r.pos < c){
                        var t = r.uint32();
                        switch(t >>> 3){
                            case 1:
                                m.body = $d94845a59d001d47$var$$root.cosmos.tx.v1beta1.TxBody.decode(r, r.uint32());
                                break;
                            case 2:
                                m.authInfo = $d94845a59d001d47$var$$root.cosmos.tx.v1beta1.AuthInfo.decode(r, r.uint32());
                                break;
                            case 3:
                                if (!(m.signatures && m.signatures.length)) m.signatures = [];
                                m.signatures.push(r.bytes());
                                break;
                            default:
                                r.skipType(t & 7);
                                break;
                        }
                    }
                    return m;
                };
                Tx.fromObject = function fromObject(d) {
                    if (d instanceof $d94845a59d001d47$var$$root.cosmos.tx.v1beta1.Tx) return d;
                    var m = new $d94845a59d001d47$var$$root.cosmos.tx.v1beta1.Tx();
                    if (d.body != null) {
                        if (typeof d.body !== "object") throw TypeError(".cosmos.tx.v1beta1.Tx.body: object expected");
                        m.body = $d94845a59d001d47$var$$root.cosmos.tx.v1beta1.TxBody.fromObject(d.body);
                    }
                    if (d.authInfo != null) {
                        if (typeof d.authInfo !== "object") throw TypeError(".cosmos.tx.v1beta1.Tx.authInfo: object expected");
                        m.authInfo = $d94845a59d001d47$var$$root.cosmos.tx.v1beta1.AuthInfo.fromObject(d.authInfo);
                    }
                    if (d.signatures) {
                        if (!Array.isArray(d.signatures)) throw TypeError(".cosmos.tx.v1beta1.Tx.signatures: array expected");
                        m.signatures = [];
                        for(var i = 0; i < d.signatures.length; ++i){
                            if (typeof d.signatures[i] === "string") $d94845a59d001d47$var$$util.base64.decode(d.signatures[i], m.signatures[i] = $d94845a59d001d47$var$$util.newBuffer($d94845a59d001d47$var$$util.base64.length(d.signatures[i])), 0);
                            else if (d.signatures[i].length) m.signatures[i] = d.signatures[i];
                        }
                    }
                    return m;
                };
                Tx.toObject = function toObject(m, o) {
                    if (!o) o = {};
                    var d = {};
                    if (o.arrays || o.defaults) d.signatures = [];
                    if (o.defaults) {
                        d.body = null;
                        d.authInfo = null;
                    }
                    if (m.body != null && m.hasOwnProperty("body")) d.body = $d94845a59d001d47$var$$root.cosmos.tx.v1beta1.TxBody.toObject(m.body, o);
                    if (m.authInfo != null && m.hasOwnProperty("authInfo")) d.authInfo = $d94845a59d001d47$var$$root.cosmos.tx.v1beta1.AuthInfo.toObject(m.authInfo, o);
                    if (m.signatures && m.signatures.length) {
                        d.signatures = [];
                        for(var j = 0; j < m.signatures.length; ++j)d.signatures[j] = o.bytes === String ? $d94845a59d001d47$var$$util.base64.encode(m.signatures[j], 0, m.signatures[j].length) : o.bytes === Array ? Array.prototype.slice.call(m.signatures[j]) : m.signatures[j];
                    }
                    return d;
                };
                Tx.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $fQBv0.util.toJSONOptions);
                };
                return Tx;
            }();
            v1beta1.TxRaw = function() {
                function TxRaw(p) {
                    this.signatures = [];
                    if (p) {
                        for(var ks = Object.keys(p), i = 0; i < ks.length; ++i)if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
                    }
                }
                TxRaw.prototype.bodyBytes = $d94845a59d001d47$var$$util.newBuffer([]);
                TxRaw.prototype.authInfoBytes = $d94845a59d001d47$var$$util.newBuffer([]);
                TxRaw.prototype.signatures = $d94845a59d001d47$var$$util.emptyArray;
                TxRaw.create = function create(properties) {
                    return new TxRaw(properties);
                };
                TxRaw.encode = function encode(m, w) {
                    if (!w) w = $d94845a59d001d47$var$$Writer.create();
                    if (m.bodyBytes != null && Object.hasOwnProperty.call(m, "bodyBytes")) w.uint32(10).bytes(m.bodyBytes);
                    if (m.authInfoBytes != null && Object.hasOwnProperty.call(m, "authInfoBytes")) w.uint32(18).bytes(m.authInfoBytes);
                    if (m.signatures != null && m.signatures.length) for(var i = 0; i < m.signatures.length; ++i)w.uint32(26).bytes(m.signatures[i]);
                    return w;
                };
                TxRaw.decode = function decode(r, l) {
                    if (!(r instanceof $d94845a59d001d47$var$$Reader)) r = $d94845a59d001d47$var$$Reader.create(r);
                    var c = l === undefined ? r.len : r.pos + l, m = new $d94845a59d001d47$var$$root.cosmos.tx.v1beta1.TxRaw();
                    while(r.pos < c){
                        var t = r.uint32();
                        switch(t >>> 3){
                            case 1:
                                m.bodyBytes = r.bytes();
                                break;
                            case 2:
                                m.authInfoBytes = r.bytes();
                                break;
                            case 3:
                                if (!(m.signatures && m.signatures.length)) m.signatures = [];
                                m.signatures.push(r.bytes());
                                break;
                            default:
                                r.skipType(t & 7);
                                break;
                        }
                    }
                    return m;
                };
                TxRaw.fromObject = function fromObject(d) {
                    if (d instanceof $d94845a59d001d47$var$$root.cosmos.tx.v1beta1.TxRaw) return d;
                    var m = new $d94845a59d001d47$var$$root.cosmos.tx.v1beta1.TxRaw();
                    if (d.bodyBytes != null) {
                        if (typeof d.bodyBytes === "string") $d94845a59d001d47$var$$util.base64.decode(d.bodyBytes, m.bodyBytes = $d94845a59d001d47$var$$util.newBuffer($d94845a59d001d47$var$$util.base64.length(d.bodyBytes)), 0);
                        else if (d.bodyBytes.length) m.bodyBytes = d.bodyBytes;
                    }
                    if (d.authInfoBytes != null) {
                        if (typeof d.authInfoBytes === "string") $d94845a59d001d47$var$$util.base64.decode(d.authInfoBytes, m.authInfoBytes = $d94845a59d001d47$var$$util.newBuffer($d94845a59d001d47$var$$util.base64.length(d.authInfoBytes)), 0);
                        else if (d.authInfoBytes.length) m.authInfoBytes = d.authInfoBytes;
                    }
                    if (d.signatures) {
                        if (!Array.isArray(d.signatures)) throw TypeError(".cosmos.tx.v1beta1.TxRaw.signatures: array expected");
                        m.signatures = [];
                        for(var i = 0; i < d.signatures.length; ++i){
                            if (typeof d.signatures[i] === "string") $d94845a59d001d47$var$$util.base64.decode(d.signatures[i], m.signatures[i] = $d94845a59d001d47$var$$util.newBuffer($d94845a59d001d47$var$$util.base64.length(d.signatures[i])), 0);
                            else if (d.signatures[i].length) m.signatures[i] = d.signatures[i];
                        }
                    }
                    return m;
                };
                TxRaw.toObject = function toObject(m, o) {
                    if (!o) o = {};
                    var d = {};
                    if (o.arrays || o.defaults) d.signatures = [];
                    if (o.defaults) {
                        if (o.bytes === String) d.bodyBytes = "";
                        else {
                            d.bodyBytes = [];
                            if (o.bytes !== Array) d.bodyBytes = $d94845a59d001d47$var$$util.newBuffer(d.bodyBytes);
                        }
                        if (o.bytes === String) d.authInfoBytes = "";
                        else {
                            d.authInfoBytes = [];
                            if (o.bytes !== Array) d.authInfoBytes = $d94845a59d001d47$var$$util.newBuffer(d.authInfoBytes);
                        }
                    }
                    if (m.bodyBytes != null && m.hasOwnProperty("bodyBytes")) d.bodyBytes = o.bytes === String ? $d94845a59d001d47$var$$util.base64.encode(m.bodyBytes, 0, m.bodyBytes.length) : o.bytes === Array ? Array.prototype.slice.call(m.bodyBytes) : m.bodyBytes;
                    if (m.authInfoBytes != null && m.hasOwnProperty("authInfoBytes")) d.authInfoBytes = o.bytes === String ? $d94845a59d001d47$var$$util.base64.encode(m.authInfoBytes, 0, m.authInfoBytes.length) : o.bytes === Array ? Array.prototype.slice.call(m.authInfoBytes) : m.authInfoBytes;
                    if (m.signatures && m.signatures.length) {
                        d.signatures = [];
                        for(var j = 0; j < m.signatures.length; ++j)d.signatures[j] = o.bytes === String ? $d94845a59d001d47$var$$util.base64.encode(m.signatures[j], 0, m.signatures[j].length) : o.bytes === Array ? Array.prototype.slice.call(m.signatures[j]) : m.signatures[j];
                    }
                    return d;
                };
                TxRaw.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $fQBv0.util.toJSONOptions);
                };
                return TxRaw;
            }();
            v1beta1.SignDoc = function() {
                function SignDoc(p) {
                    if (p) {
                        for(var ks = Object.keys(p), i = 0; i < ks.length; ++i)if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
                    }
                }
                SignDoc.prototype.bodyBytes = $d94845a59d001d47$var$$util.newBuffer([]);
                SignDoc.prototype.authInfoBytes = $d94845a59d001d47$var$$util.newBuffer([]);
                SignDoc.prototype.chainId = "";
                SignDoc.prototype.accountNumber = $d94845a59d001d47$var$$util.Long ? $d94845a59d001d47$var$$util.Long.fromBits(0, 0, true) : 0;
                SignDoc.create = function create(properties) {
                    return new SignDoc(properties);
                };
                SignDoc.encode = function encode(m, w) {
                    if (!w) w = $d94845a59d001d47$var$$Writer.create();
                    if (m.bodyBytes != null && Object.hasOwnProperty.call(m, "bodyBytes")) w.uint32(10).bytes(m.bodyBytes);
                    if (m.authInfoBytes != null && Object.hasOwnProperty.call(m, "authInfoBytes")) w.uint32(18).bytes(m.authInfoBytes);
                    if (m.chainId != null && Object.hasOwnProperty.call(m, "chainId")) w.uint32(26).string(m.chainId);
                    if (m.accountNumber != null && Object.hasOwnProperty.call(m, "accountNumber")) w.uint32(32).uint64(m.accountNumber);
                    return w;
                };
                SignDoc.decode = function decode(r, l) {
                    if (!(r instanceof $d94845a59d001d47$var$$Reader)) r = $d94845a59d001d47$var$$Reader.create(r);
                    var c = l === undefined ? r.len : r.pos + l, m = new $d94845a59d001d47$var$$root.cosmos.tx.v1beta1.SignDoc();
                    while(r.pos < c){
                        var t = r.uint32();
                        switch(t >>> 3){
                            case 1:
                                m.bodyBytes = r.bytes();
                                break;
                            case 2:
                                m.authInfoBytes = r.bytes();
                                break;
                            case 3:
                                m.chainId = r.string();
                                break;
                            case 4:
                                m.accountNumber = r.uint64();
                                break;
                            default:
                                r.skipType(t & 7);
                                break;
                        }
                    }
                    return m;
                };
                SignDoc.fromObject = function fromObject(d) {
                    if (d instanceof $d94845a59d001d47$var$$root.cosmos.tx.v1beta1.SignDoc) return d;
                    var m = new $d94845a59d001d47$var$$root.cosmos.tx.v1beta1.SignDoc();
                    if (d.bodyBytes != null) {
                        if (typeof d.bodyBytes === "string") $d94845a59d001d47$var$$util.base64.decode(d.bodyBytes, m.bodyBytes = $d94845a59d001d47$var$$util.newBuffer($d94845a59d001d47$var$$util.base64.length(d.bodyBytes)), 0);
                        else if (d.bodyBytes.length) m.bodyBytes = d.bodyBytes;
                    }
                    if (d.authInfoBytes != null) {
                        if (typeof d.authInfoBytes === "string") $d94845a59d001d47$var$$util.base64.decode(d.authInfoBytes, m.authInfoBytes = $d94845a59d001d47$var$$util.newBuffer($d94845a59d001d47$var$$util.base64.length(d.authInfoBytes)), 0);
                        else if (d.authInfoBytes.length) m.authInfoBytes = d.authInfoBytes;
                    }
                    if (d.chainId != null) m.chainId = String(d.chainId);
                    if (d.accountNumber != null) {
                        if ($d94845a59d001d47$var$$util.Long) (m.accountNumber = $d94845a59d001d47$var$$util.Long.fromValue(d.accountNumber)).unsigned = true;
                        else if (typeof d.accountNumber === "string") m.accountNumber = parseInt(d.accountNumber, 10);
                        else if (typeof d.accountNumber === "number") m.accountNumber = d.accountNumber;
                        else if (typeof d.accountNumber === "object") m.accountNumber = new $d94845a59d001d47$var$$util.LongBits(d.accountNumber.low >>> 0, d.accountNumber.high >>> 0).toNumber(true);
                    }
                    return m;
                };
                SignDoc.toObject = function toObject(m, o) {
                    if (!o) o = {};
                    var d = {};
                    if (o.defaults) {
                        if (o.bytes === String) d.bodyBytes = "";
                        else {
                            d.bodyBytes = [];
                            if (o.bytes !== Array) d.bodyBytes = $d94845a59d001d47$var$$util.newBuffer(d.bodyBytes);
                        }
                        if (o.bytes === String) d.authInfoBytes = "";
                        else {
                            d.authInfoBytes = [];
                            if (o.bytes !== Array) d.authInfoBytes = $d94845a59d001d47$var$$util.newBuffer(d.authInfoBytes);
                        }
                        d.chainId = "";
                        if ($d94845a59d001d47$var$$util.Long) {
                            var n = new $d94845a59d001d47$var$$util.Long(0, 0, true);
                            d.accountNumber = o.longs === String ? n.toString() : o.longs === Number ? n.toNumber() : n;
                        } else d.accountNumber = o.longs === String ? "0" : 0;
                    }
                    if (m.bodyBytes != null && m.hasOwnProperty("bodyBytes")) d.bodyBytes = o.bytes === String ? $d94845a59d001d47$var$$util.base64.encode(m.bodyBytes, 0, m.bodyBytes.length) : o.bytes === Array ? Array.prototype.slice.call(m.bodyBytes) : m.bodyBytes;
                    if (m.authInfoBytes != null && m.hasOwnProperty("authInfoBytes")) d.authInfoBytes = o.bytes === String ? $d94845a59d001d47$var$$util.base64.encode(m.authInfoBytes, 0, m.authInfoBytes.length) : o.bytes === Array ? Array.prototype.slice.call(m.authInfoBytes) : m.authInfoBytes;
                    if (m.chainId != null && m.hasOwnProperty("chainId")) d.chainId = m.chainId;
                    if (m.accountNumber != null && m.hasOwnProperty("accountNumber")) {
                        if (typeof m.accountNumber === "number") d.accountNumber = o.longs === String ? String(m.accountNumber) : m.accountNumber;
                        else d.accountNumber = o.longs === String ? $d94845a59d001d47$var$$util.Long.prototype.toString.call(m.accountNumber) : o.longs === Number ? new $d94845a59d001d47$var$$util.LongBits(m.accountNumber.low >>> 0, m.accountNumber.high >>> 0).toNumber(true) : m.accountNumber;
                    }
                    return d;
                };
                SignDoc.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $fQBv0.util.toJSONOptions);
                };
                return SignDoc;
            }();
            v1beta1.TxBody = function() {
                function TxBody(p) {
                    this.messages = [];
                    this.extensionOptions = [];
                    this.nonCriticalExtensionOptions = [];
                    if (p) {
                        for(var ks = Object.keys(p), i = 0; i < ks.length; ++i)if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
                    }
                }
                TxBody.prototype.messages = $d94845a59d001d47$var$$util.emptyArray;
                TxBody.prototype.memo = "";
                TxBody.prototype.timeoutHeight = $d94845a59d001d47$var$$util.Long ? $d94845a59d001d47$var$$util.Long.fromBits(0, 0, true) : 0;
                TxBody.prototype.extensionOptions = $d94845a59d001d47$var$$util.emptyArray;
                TxBody.prototype.nonCriticalExtensionOptions = $d94845a59d001d47$var$$util.emptyArray;
                TxBody.create = function create(properties) {
                    return new TxBody(properties);
                };
                TxBody.encode = function encode(m, w) {
                    if (!w) w = $d94845a59d001d47$var$$Writer.create();
                    if (m.messages != null && m.messages.length) for(var i = 0; i < m.messages.length; ++i)$d94845a59d001d47$var$$root.google.protobuf.Any.encode(m.messages[i], w.uint32(10).fork()).ldelim();
                    if (m.memo != null && Object.hasOwnProperty.call(m, "memo")) w.uint32(18).string(m.memo);
                    if (m.timeoutHeight != null && Object.hasOwnProperty.call(m, "timeoutHeight")) w.uint32(24).uint64(m.timeoutHeight);
                    if (m.extensionOptions != null && m.extensionOptions.length) for(var i = 0; i < m.extensionOptions.length; ++i)$d94845a59d001d47$var$$root.google.protobuf.Any.encode(m.extensionOptions[i], w.uint32(8186).fork()).ldelim();
                    if (m.nonCriticalExtensionOptions != null && m.nonCriticalExtensionOptions.length) for(var i = 0; i < m.nonCriticalExtensionOptions.length; ++i)$d94845a59d001d47$var$$root.google.protobuf.Any.encode(m.nonCriticalExtensionOptions[i], w.uint32(16378).fork()).ldelim();
                    return w;
                };
                TxBody.decode = function decode(r, l) {
                    if (!(r instanceof $d94845a59d001d47$var$$Reader)) r = $d94845a59d001d47$var$$Reader.create(r);
                    var c = l === undefined ? r.len : r.pos + l, m = new $d94845a59d001d47$var$$root.cosmos.tx.v1beta1.TxBody();
                    while(r.pos < c){
                        var t = r.uint32();
                        switch(t >>> 3){
                            case 1:
                                if (!(m.messages && m.messages.length)) m.messages = [];
                                m.messages.push($d94845a59d001d47$var$$root.google.protobuf.Any.decode(r, r.uint32()));
                                break;
                            case 2:
                                m.memo = r.string();
                                break;
                            case 3:
                                m.timeoutHeight = r.uint64();
                                break;
                            case 1023:
                                if (!(m.extensionOptions && m.extensionOptions.length)) m.extensionOptions = [];
                                m.extensionOptions.push($d94845a59d001d47$var$$root.google.protobuf.Any.decode(r, r.uint32()));
                                break;
                            case 2047:
                                if (!(m.nonCriticalExtensionOptions && m.nonCriticalExtensionOptions.length)) m.nonCriticalExtensionOptions = [];
                                m.nonCriticalExtensionOptions.push($d94845a59d001d47$var$$root.google.protobuf.Any.decode(r, r.uint32()));
                                break;
                            default:
                                r.skipType(t & 7);
                                break;
                        }
                    }
                    return m;
                };
                TxBody.fromObject = function fromObject(d) {
                    if (d instanceof $d94845a59d001d47$var$$root.cosmos.tx.v1beta1.TxBody) return d;
                    var m = new $d94845a59d001d47$var$$root.cosmos.tx.v1beta1.TxBody();
                    if (d.messages) {
                        if (!Array.isArray(d.messages)) throw TypeError(".cosmos.tx.v1beta1.TxBody.messages: array expected");
                        m.messages = [];
                        for(var i = 0; i < d.messages.length; ++i){
                            if (typeof d.messages[i] !== "object") throw TypeError(".cosmos.tx.v1beta1.TxBody.messages: object expected");
                            m.messages[i] = $d94845a59d001d47$var$$root.google.protobuf.Any.fromObject(d.messages[i]);
                        }
                    }
                    if (d.memo != null) m.memo = String(d.memo);
                    if (d.timeoutHeight != null) {
                        if ($d94845a59d001d47$var$$util.Long) (m.timeoutHeight = $d94845a59d001d47$var$$util.Long.fromValue(d.timeoutHeight)).unsigned = true;
                        else if (typeof d.timeoutHeight === "string") m.timeoutHeight = parseInt(d.timeoutHeight, 10);
                        else if (typeof d.timeoutHeight === "number") m.timeoutHeight = d.timeoutHeight;
                        else if (typeof d.timeoutHeight === "object") m.timeoutHeight = new $d94845a59d001d47$var$$util.LongBits(d.timeoutHeight.low >>> 0, d.timeoutHeight.high >>> 0).toNumber(true);
                    }
                    if (d.extensionOptions) {
                        if (!Array.isArray(d.extensionOptions)) throw TypeError(".cosmos.tx.v1beta1.TxBody.extensionOptions: array expected");
                        m.extensionOptions = [];
                        for(var i = 0; i < d.extensionOptions.length; ++i){
                            if (typeof d.extensionOptions[i] !== "object") throw TypeError(".cosmos.tx.v1beta1.TxBody.extensionOptions: object expected");
                            m.extensionOptions[i] = $d94845a59d001d47$var$$root.google.protobuf.Any.fromObject(d.extensionOptions[i]);
                        }
                    }
                    if (d.nonCriticalExtensionOptions) {
                        if (!Array.isArray(d.nonCriticalExtensionOptions)) throw TypeError(".cosmos.tx.v1beta1.TxBody.nonCriticalExtensionOptions: array expected");
                        m.nonCriticalExtensionOptions = [];
                        for(var i = 0; i < d.nonCriticalExtensionOptions.length; ++i){
                            if (typeof d.nonCriticalExtensionOptions[i] !== "object") throw TypeError(".cosmos.tx.v1beta1.TxBody.nonCriticalExtensionOptions: object expected");
                            m.nonCriticalExtensionOptions[i] = $d94845a59d001d47$var$$root.google.protobuf.Any.fromObject(d.nonCriticalExtensionOptions[i]);
                        }
                    }
                    return m;
                };
                TxBody.toObject = function toObject(m, o) {
                    if (!o) o = {};
                    var d = {};
                    if (o.arrays || o.defaults) {
                        d.messages = [];
                        d.extensionOptions = [];
                        d.nonCriticalExtensionOptions = [];
                    }
                    if (o.defaults) {
                        d.memo = "";
                        if ($d94845a59d001d47$var$$util.Long) {
                            var n = new $d94845a59d001d47$var$$util.Long(0, 0, true);
                            d.timeoutHeight = o.longs === String ? n.toString() : o.longs === Number ? n.toNumber() : n;
                        } else d.timeoutHeight = o.longs === String ? "0" : 0;
                    }
                    if (m.messages && m.messages.length) {
                        d.messages = [];
                        for(var j = 0; j < m.messages.length; ++j)d.messages[j] = $d94845a59d001d47$var$$root.google.protobuf.Any.toObject(m.messages[j], o);
                    }
                    if (m.memo != null && m.hasOwnProperty("memo")) d.memo = m.memo;
                    if (m.timeoutHeight != null && m.hasOwnProperty("timeoutHeight")) {
                        if (typeof m.timeoutHeight === "number") d.timeoutHeight = o.longs === String ? String(m.timeoutHeight) : m.timeoutHeight;
                        else d.timeoutHeight = o.longs === String ? $d94845a59d001d47$var$$util.Long.prototype.toString.call(m.timeoutHeight) : o.longs === Number ? new $d94845a59d001d47$var$$util.LongBits(m.timeoutHeight.low >>> 0, m.timeoutHeight.high >>> 0).toNumber(true) : m.timeoutHeight;
                    }
                    if (m.extensionOptions && m.extensionOptions.length) {
                        d.extensionOptions = [];
                        for(var j = 0; j < m.extensionOptions.length; ++j)d.extensionOptions[j] = $d94845a59d001d47$var$$root.google.protobuf.Any.toObject(m.extensionOptions[j], o);
                    }
                    if (m.nonCriticalExtensionOptions && m.nonCriticalExtensionOptions.length) {
                        d.nonCriticalExtensionOptions = [];
                        for(var j = 0; j < m.nonCriticalExtensionOptions.length; ++j)d.nonCriticalExtensionOptions[j] = $d94845a59d001d47$var$$root.google.protobuf.Any.toObject(m.nonCriticalExtensionOptions[j], o);
                    }
                    return d;
                };
                TxBody.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $fQBv0.util.toJSONOptions);
                };
                return TxBody;
            }();
            v1beta1.AuthInfo = function() {
                function AuthInfo(p) {
                    this.signerInfos = [];
                    if (p) {
                        for(var ks = Object.keys(p), i = 0; i < ks.length; ++i)if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
                    }
                }
                AuthInfo.prototype.signerInfos = $d94845a59d001d47$var$$util.emptyArray;
                AuthInfo.prototype.fee = null;
                AuthInfo.create = function create(properties) {
                    return new AuthInfo(properties);
                };
                AuthInfo.encode = function encode(m, w) {
                    if (!w) w = $d94845a59d001d47$var$$Writer.create();
                    if (m.signerInfos != null && m.signerInfos.length) for(var i = 0; i < m.signerInfos.length; ++i)$d94845a59d001d47$var$$root.cosmos.tx.v1beta1.SignerInfo.encode(m.signerInfos[i], w.uint32(10).fork()).ldelim();
                    if (m.fee != null && Object.hasOwnProperty.call(m, "fee")) $d94845a59d001d47$var$$root.cosmos.tx.v1beta1.Fee.encode(m.fee, w.uint32(18).fork()).ldelim();
                    return w;
                };
                AuthInfo.decode = function decode(r, l) {
                    if (!(r instanceof $d94845a59d001d47$var$$Reader)) r = $d94845a59d001d47$var$$Reader.create(r);
                    var c = l === undefined ? r.len : r.pos + l, m = new $d94845a59d001d47$var$$root.cosmos.tx.v1beta1.AuthInfo();
                    while(r.pos < c){
                        var t = r.uint32();
                        switch(t >>> 3){
                            case 1:
                                if (!(m.signerInfos && m.signerInfos.length)) m.signerInfos = [];
                                m.signerInfos.push($d94845a59d001d47$var$$root.cosmos.tx.v1beta1.SignerInfo.decode(r, r.uint32()));
                                break;
                            case 2:
                                m.fee = $d94845a59d001d47$var$$root.cosmos.tx.v1beta1.Fee.decode(r, r.uint32());
                                break;
                            default:
                                r.skipType(t & 7);
                                break;
                        }
                    }
                    return m;
                };
                AuthInfo.fromObject = function fromObject(d) {
                    if (d instanceof $d94845a59d001d47$var$$root.cosmos.tx.v1beta1.AuthInfo) return d;
                    var m = new $d94845a59d001d47$var$$root.cosmos.tx.v1beta1.AuthInfo();
                    if (d.signerInfos) {
                        if (!Array.isArray(d.signerInfos)) throw TypeError(".cosmos.tx.v1beta1.AuthInfo.signerInfos: array expected");
                        m.signerInfos = [];
                        for(var i = 0; i < d.signerInfos.length; ++i){
                            if (typeof d.signerInfos[i] !== "object") throw TypeError(".cosmos.tx.v1beta1.AuthInfo.signerInfos: object expected");
                            m.signerInfos[i] = $d94845a59d001d47$var$$root.cosmos.tx.v1beta1.SignerInfo.fromObject(d.signerInfos[i]);
                        }
                    }
                    if (d.fee != null) {
                        if (typeof d.fee !== "object") throw TypeError(".cosmos.tx.v1beta1.AuthInfo.fee: object expected");
                        m.fee = $d94845a59d001d47$var$$root.cosmos.tx.v1beta1.Fee.fromObject(d.fee);
                    }
                    return m;
                };
                AuthInfo.toObject = function toObject(m, o) {
                    if (!o) o = {};
                    var d = {};
                    if (o.arrays || o.defaults) d.signerInfos = [];
                    if (o.defaults) d.fee = null;
                    if (m.signerInfos && m.signerInfos.length) {
                        d.signerInfos = [];
                        for(var j = 0; j < m.signerInfos.length; ++j)d.signerInfos[j] = $d94845a59d001d47$var$$root.cosmos.tx.v1beta1.SignerInfo.toObject(m.signerInfos[j], o);
                    }
                    if (m.fee != null && m.hasOwnProperty("fee")) d.fee = $d94845a59d001d47$var$$root.cosmos.tx.v1beta1.Fee.toObject(m.fee, o);
                    return d;
                };
                AuthInfo.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $fQBv0.util.toJSONOptions);
                };
                return AuthInfo;
            }();
            v1beta1.SignerInfo = function() {
                function SignerInfo(p) {
                    if (p) {
                        for(var ks = Object.keys(p), i = 0; i < ks.length; ++i)if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
                    }
                }
                SignerInfo.prototype.publicKey = null;
                SignerInfo.prototype.modeInfo = null;
                SignerInfo.prototype.sequence = $d94845a59d001d47$var$$util.Long ? $d94845a59d001d47$var$$util.Long.fromBits(0, 0, true) : 0;
                SignerInfo.create = function create(properties) {
                    return new SignerInfo(properties);
                };
                SignerInfo.encode = function encode(m, w) {
                    if (!w) w = $d94845a59d001d47$var$$Writer.create();
                    if (m.publicKey != null && Object.hasOwnProperty.call(m, "publicKey")) $d94845a59d001d47$var$$root.google.protobuf.Any.encode(m.publicKey, w.uint32(10).fork()).ldelim();
                    if (m.modeInfo != null && Object.hasOwnProperty.call(m, "modeInfo")) $d94845a59d001d47$var$$root.cosmos.tx.v1beta1.ModeInfo.encode(m.modeInfo, w.uint32(18).fork()).ldelim();
                    if (m.sequence != null && Object.hasOwnProperty.call(m, "sequence")) w.uint32(24).uint64(m.sequence);
                    return w;
                };
                SignerInfo.decode = function decode(r, l) {
                    if (!(r instanceof $d94845a59d001d47$var$$Reader)) r = $d94845a59d001d47$var$$Reader.create(r);
                    var c = l === undefined ? r.len : r.pos + l, m = new $d94845a59d001d47$var$$root.cosmos.tx.v1beta1.SignerInfo();
                    while(r.pos < c){
                        var t = r.uint32();
                        switch(t >>> 3){
                            case 1:
                                m.publicKey = $d94845a59d001d47$var$$root.google.protobuf.Any.decode(r, r.uint32());
                                break;
                            case 2:
                                m.modeInfo = $d94845a59d001d47$var$$root.cosmos.tx.v1beta1.ModeInfo.decode(r, r.uint32());
                                break;
                            case 3:
                                m.sequence = r.uint64();
                                break;
                            default:
                                r.skipType(t & 7);
                                break;
                        }
                    }
                    return m;
                };
                SignerInfo.fromObject = function fromObject(d) {
                    if (d instanceof $d94845a59d001d47$var$$root.cosmos.tx.v1beta1.SignerInfo) return d;
                    var m = new $d94845a59d001d47$var$$root.cosmos.tx.v1beta1.SignerInfo();
                    if (d.publicKey != null) {
                        if (typeof d.publicKey !== "object") throw TypeError(".cosmos.tx.v1beta1.SignerInfo.publicKey: object expected");
                        m.publicKey = $d94845a59d001d47$var$$root.google.protobuf.Any.fromObject(d.publicKey);
                    }
                    if (d.modeInfo != null) {
                        if (typeof d.modeInfo !== "object") throw TypeError(".cosmos.tx.v1beta1.SignerInfo.modeInfo: object expected");
                        m.modeInfo = $d94845a59d001d47$var$$root.cosmos.tx.v1beta1.ModeInfo.fromObject(d.modeInfo);
                    }
                    if (d.sequence != null) {
                        if ($d94845a59d001d47$var$$util.Long) (m.sequence = $d94845a59d001d47$var$$util.Long.fromValue(d.sequence)).unsigned = true;
                        else if (typeof d.sequence === "string") m.sequence = parseInt(d.sequence, 10);
                        else if (typeof d.sequence === "number") m.sequence = d.sequence;
                        else if (typeof d.sequence === "object") m.sequence = new $d94845a59d001d47$var$$util.LongBits(d.sequence.low >>> 0, d.sequence.high >>> 0).toNumber(true);
                    }
                    return m;
                };
                SignerInfo.toObject = function toObject(m, o) {
                    if (!o) o = {};
                    var d = {};
                    if (o.defaults) {
                        d.publicKey = null;
                        d.modeInfo = null;
                        if ($d94845a59d001d47$var$$util.Long) {
                            var n = new $d94845a59d001d47$var$$util.Long(0, 0, true);
                            d.sequence = o.longs === String ? n.toString() : o.longs === Number ? n.toNumber() : n;
                        } else d.sequence = o.longs === String ? "0" : 0;
                    }
                    if (m.publicKey != null && m.hasOwnProperty("publicKey")) d.publicKey = $d94845a59d001d47$var$$root.google.protobuf.Any.toObject(m.publicKey, o);
                    if (m.modeInfo != null && m.hasOwnProperty("modeInfo")) d.modeInfo = $d94845a59d001d47$var$$root.cosmos.tx.v1beta1.ModeInfo.toObject(m.modeInfo, o);
                    if (m.sequence != null && m.hasOwnProperty("sequence")) {
                        if (typeof m.sequence === "number") d.sequence = o.longs === String ? String(m.sequence) : m.sequence;
                        else d.sequence = o.longs === String ? $d94845a59d001d47$var$$util.Long.prototype.toString.call(m.sequence) : o.longs === Number ? new $d94845a59d001d47$var$$util.LongBits(m.sequence.low >>> 0, m.sequence.high >>> 0).toNumber(true) : m.sequence;
                    }
                    return d;
                };
                SignerInfo.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $fQBv0.util.toJSONOptions);
                };
                return SignerInfo;
            }();
            v1beta1.ModeInfo = function() {
                function ModeInfo(p) {
                    if (p) {
                        for(var ks = Object.keys(p), i = 0; i < ks.length; ++i)if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
                    }
                }
                ModeInfo.prototype.single = null;
                ModeInfo.prototype.multi = null;
                let $oneOfFields;
                Object.defineProperty(ModeInfo.prototype, "sum", {
                    get: $d94845a59d001d47$var$$util.oneOfGetter($oneOfFields = [
                        "single",
                        "multi"
                    ]),
                    set: $d94845a59d001d47$var$$util.oneOfSetter($oneOfFields)
                });
                ModeInfo.create = function create(properties) {
                    return new ModeInfo(properties);
                };
                ModeInfo.encode = function encode(m, w) {
                    if (!w) w = $d94845a59d001d47$var$$Writer.create();
                    if (m.single != null && Object.hasOwnProperty.call(m, "single")) $d94845a59d001d47$var$$root.cosmos.tx.v1beta1.ModeInfo.Single.encode(m.single, w.uint32(10).fork()).ldelim();
                    if (m.multi != null && Object.hasOwnProperty.call(m, "multi")) $d94845a59d001d47$var$$root.cosmos.tx.v1beta1.ModeInfo.Multi.encode(m.multi, w.uint32(18).fork()).ldelim();
                    return w;
                };
                ModeInfo.decode = function decode(r, l) {
                    if (!(r instanceof $d94845a59d001d47$var$$Reader)) r = $d94845a59d001d47$var$$Reader.create(r);
                    var c = l === undefined ? r.len : r.pos + l, m = new $d94845a59d001d47$var$$root.cosmos.tx.v1beta1.ModeInfo();
                    while(r.pos < c){
                        var t = r.uint32();
                        switch(t >>> 3){
                            case 1:
                                m.single = $d94845a59d001d47$var$$root.cosmos.tx.v1beta1.ModeInfo.Single.decode(r, r.uint32());
                                break;
                            case 2:
                                m.multi = $d94845a59d001d47$var$$root.cosmos.tx.v1beta1.ModeInfo.Multi.decode(r, r.uint32());
                                break;
                            default:
                                r.skipType(t & 7);
                                break;
                        }
                    }
                    return m;
                };
                ModeInfo.fromObject = function fromObject(d) {
                    if (d instanceof $d94845a59d001d47$var$$root.cosmos.tx.v1beta1.ModeInfo) return d;
                    var m = new $d94845a59d001d47$var$$root.cosmos.tx.v1beta1.ModeInfo();
                    if (d.single != null) {
                        if (typeof d.single !== "object") throw TypeError(".cosmos.tx.v1beta1.ModeInfo.single: object expected");
                        m.single = $d94845a59d001d47$var$$root.cosmos.tx.v1beta1.ModeInfo.Single.fromObject(d.single);
                    }
                    if (d.multi != null) {
                        if (typeof d.multi !== "object") throw TypeError(".cosmos.tx.v1beta1.ModeInfo.multi: object expected");
                        m.multi = $d94845a59d001d47$var$$root.cosmos.tx.v1beta1.ModeInfo.Multi.fromObject(d.multi);
                    }
                    return m;
                };
                ModeInfo.toObject = function toObject(m, o) {
                    if (!o) o = {};
                    var d = {};
                    if (m.single != null && m.hasOwnProperty("single")) {
                        d.single = $d94845a59d001d47$var$$root.cosmos.tx.v1beta1.ModeInfo.Single.toObject(m.single, o);
                        if (o.oneofs) d.sum = "single";
                    }
                    if (m.multi != null && m.hasOwnProperty("multi")) {
                        d.multi = $d94845a59d001d47$var$$root.cosmos.tx.v1beta1.ModeInfo.Multi.toObject(m.multi, o);
                        if (o.oneofs) d.sum = "multi";
                    }
                    return d;
                };
                ModeInfo.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $fQBv0.util.toJSONOptions);
                };
                ModeInfo.Single = function() {
                    function Single(p) {
                        if (p) {
                            for(var ks = Object.keys(p), i = 0; i < ks.length; ++i)if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
                        }
                    }
                    Single.prototype.mode = 0;
                    Single.create = function create(properties) {
                        return new Single(properties);
                    };
                    Single.encode = function encode(m, w) {
                        if (!w) w = $d94845a59d001d47$var$$Writer.create();
                        if (m.mode != null && Object.hasOwnProperty.call(m, "mode")) w.uint32(8).int32(m.mode);
                        return w;
                    };
                    Single.decode = function decode(r, l) {
                        if (!(r instanceof $d94845a59d001d47$var$$Reader)) r = $d94845a59d001d47$var$$Reader.create(r);
                        var c = l === undefined ? r.len : r.pos + l, m = new $d94845a59d001d47$var$$root.cosmos.tx.v1beta1.ModeInfo.Single();
                        while(r.pos < c){
                            var t = r.uint32();
                            switch(t >>> 3){
                                case 1:
                                    m.mode = r.int32();
                                    break;
                                default:
                                    r.skipType(t & 7);
                                    break;
                            }
                        }
                        return m;
                    };
                    Single.fromObject = function fromObject(d) {
                        if (d instanceof $d94845a59d001d47$var$$root.cosmos.tx.v1beta1.ModeInfo.Single) return d;
                        var m = new $d94845a59d001d47$var$$root.cosmos.tx.v1beta1.ModeInfo.Single();
                        switch(d.mode){
                            case "SIGN_MODE_UNSPECIFIED":
                            case 0:
                                m.mode = 0;
                                break;
                            case "SIGN_MODE_DIRECT":
                            case 1:
                                m.mode = 1;
                                break;
                            case "SIGN_MODE_TEXTUAL":
                            case 2:
                                m.mode = 2;
                                break;
                            case "SIGN_MODE_LEGACY_AMINO_JSON":
                            case 127:
                                m.mode = 127;
                                break;
                        }
                        return m;
                    };
                    Single.toObject = function toObject(m, o) {
                        if (!o) o = {};
                        var d = {};
                        if (o.defaults) d.mode = o.enums === String ? "SIGN_MODE_UNSPECIFIED" : 0;
                        if (m.mode != null && m.hasOwnProperty("mode")) d.mode = o.enums === String ? $d94845a59d001d47$var$$root.cosmos.tx.signing.v1beta1.SignMode[m.mode] : m.mode;
                        return d;
                    };
                    Single.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $fQBv0.util.toJSONOptions);
                    };
                    return Single;
                }();
                ModeInfo.Multi = function() {
                    function Multi(p) {
                        this.modeInfos = [];
                        if (p) {
                            for(var ks = Object.keys(p), i = 0; i < ks.length; ++i)if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
                        }
                    }
                    Multi.prototype.bitarray = null;
                    Multi.prototype.modeInfos = $d94845a59d001d47$var$$util.emptyArray;
                    Multi.create = function create(properties) {
                        return new Multi(properties);
                    };
                    Multi.encode = function encode(m, w) {
                        if (!w) w = $d94845a59d001d47$var$$Writer.create();
                        if (m.bitarray != null && Object.hasOwnProperty.call(m, "bitarray")) $d94845a59d001d47$var$$root.cosmos.crypto.multisig.v1beta1.CompactBitArray.encode(m.bitarray, w.uint32(10).fork()).ldelim();
                        if (m.modeInfos != null && m.modeInfos.length) for(var i = 0; i < m.modeInfos.length; ++i)$d94845a59d001d47$var$$root.cosmos.tx.v1beta1.ModeInfo.encode(m.modeInfos[i], w.uint32(18).fork()).ldelim();
                        return w;
                    };
                    Multi.decode = function decode(r, l) {
                        if (!(r instanceof $d94845a59d001d47$var$$Reader)) r = $d94845a59d001d47$var$$Reader.create(r);
                        var c = l === undefined ? r.len : r.pos + l, m = new $d94845a59d001d47$var$$root.cosmos.tx.v1beta1.ModeInfo.Multi();
                        while(r.pos < c){
                            var t = r.uint32();
                            switch(t >>> 3){
                                case 1:
                                    m.bitarray = $d94845a59d001d47$var$$root.cosmos.crypto.multisig.v1beta1.CompactBitArray.decode(r, r.uint32());
                                    break;
                                case 2:
                                    if (!(m.modeInfos && m.modeInfos.length)) m.modeInfos = [];
                                    m.modeInfos.push($d94845a59d001d47$var$$root.cosmos.tx.v1beta1.ModeInfo.decode(r, r.uint32()));
                                    break;
                                default:
                                    r.skipType(t & 7);
                                    break;
                            }
                        }
                        return m;
                    };
                    Multi.fromObject = function fromObject(d) {
                        if (d instanceof $d94845a59d001d47$var$$root.cosmos.tx.v1beta1.ModeInfo.Multi) return d;
                        var m = new $d94845a59d001d47$var$$root.cosmos.tx.v1beta1.ModeInfo.Multi();
                        if (d.bitarray != null) {
                            if (typeof d.bitarray !== "object") throw TypeError(".cosmos.tx.v1beta1.ModeInfo.Multi.bitarray: object expected");
                            m.bitarray = $d94845a59d001d47$var$$root.cosmos.crypto.multisig.v1beta1.CompactBitArray.fromObject(d.bitarray);
                        }
                        if (d.modeInfos) {
                            if (!Array.isArray(d.modeInfos)) throw TypeError(".cosmos.tx.v1beta1.ModeInfo.Multi.modeInfos: array expected");
                            m.modeInfos = [];
                            for(var i = 0; i < d.modeInfos.length; ++i){
                                if (typeof d.modeInfos[i] !== "object") throw TypeError(".cosmos.tx.v1beta1.ModeInfo.Multi.modeInfos: object expected");
                                m.modeInfos[i] = $d94845a59d001d47$var$$root.cosmos.tx.v1beta1.ModeInfo.fromObject(d.modeInfos[i]);
                            }
                        }
                        return m;
                    };
                    Multi.toObject = function toObject(m, o) {
                        if (!o) o = {};
                        var d = {};
                        if (o.arrays || o.defaults) d.modeInfos = [];
                        if (o.defaults) d.bitarray = null;
                        if (m.bitarray != null && m.hasOwnProperty("bitarray")) d.bitarray = $d94845a59d001d47$var$$root.cosmos.crypto.multisig.v1beta1.CompactBitArray.toObject(m.bitarray, o);
                        if (m.modeInfos && m.modeInfos.length) {
                            d.modeInfos = [];
                            for(var j = 0; j < m.modeInfos.length; ++j)d.modeInfos[j] = $d94845a59d001d47$var$$root.cosmos.tx.v1beta1.ModeInfo.toObject(m.modeInfos[j], o);
                        }
                        return d;
                    };
                    Multi.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $fQBv0.util.toJSONOptions);
                    };
                    return Multi;
                }();
                return ModeInfo;
            }();
            v1beta1.Fee = function() {
                function Fee(p) {
                    this.amount = [];
                    if (p) {
                        for(var ks = Object.keys(p), i = 0; i < ks.length; ++i)if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
                    }
                }
                Fee.prototype.amount = $d94845a59d001d47$var$$util.emptyArray;
                Fee.prototype.gasLimit = $d94845a59d001d47$var$$util.Long ? $d94845a59d001d47$var$$util.Long.fromBits(0, 0, true) : 0;
                Fee.prototype.payer = "";
                Fee.prototype.granter = "";
                Fee.create = function create(properties) {
                    return new Fee(properties);
                };
                Fee.encode = function encode(m, w) {
                    if (!w) w = $d94845a59d001d47$var$$Writer.create();
                    if (m.amount != null && m.amount.length) for(var i = 0; i < m.amount.length; ++i)$d94845a59d001d47$var$$root.cosmos.base.v1beta1.Coin.encode(m.amount[i], w.uint32(10).fork()).ldelim();
                    if (m.gasLimit != null && Object.hasOwnProperty.call(m, "gasLimit")) w.uint32(16).uint64(m.gasLimit);
                    if (m.payer != null && Object.hasOwnProperty.call(m, "payer")) w.uint32(26).string(m.payer);
                    if (m.granter != null && Object.hasOwnProperty.call(m, "granter")) w.uint32(34).string(m.granter);
                    return w;
                };
                Fee.decode = function decode(r, l) {
                    if (!(r instanceof $d94845a59d001d47$var$$Reader)) r = $d94845a59d001d47$var$$Reader.create(r);
                    var c = l === undefined ? r.len : r.pos + l, m = new $d94845a59d001d47$var$$root.cosmos.tx.v1beta1.Fee();
                    while(r.pos < c){
                        var t = r.uint32();
                        switch(t >>> 3){
                            case 1:
                                if (!(m.amount && m.amount.length)) m.amount = [];
                                m.amount.push($d94845a59d001d47$var$$root.cosmos.base.v1beta1.Coin.decode(r, r.uint32()));
                                break;
                            case 2:
                                m.gasLimit = r.uint64();
                                break;
                            case 3:
                                m.payer = r.string();
                                break;
                            case 4:
                                m.granter = r.string();
                                break;
                            default:
                                r.skipType(t & 7);
                                break;
                        }
                    }
                    return m;
                };
                Fee.fromObject = function fromObject(d) {
                    if (d instanceof $d94845a59d001d47$var$$root.cosmos.tx.v1beta1.Fee) return d;
                    var m = new $d94845a59d001d47$var$$root.cosmos.tx.v1beta1.Fee();
                    if (d.amount) {
                        if (!Array.isArray(d.amount)) throw TypeError(".cosmos.tx.v1beta1.Fee.amount: array expected");
                        m.amount = [];
                        for(var i = 0; i < d.amount.length; ++i){
                            if (typeof d.amount[i] !== "object") throw TypeError(".cosmos.tx.v1beta1.Fee.amount: object expected");
                            m.amount[i] = $d94845a59d001d47$var$$root.cosmos.base.v1beta1.Coin.fromObject(d.amount[i]);
                        }
                    }
                    if (d.gasLimit != null) {
                        if ($d94845a59d001d47$var$$util.Long) (m.gasLimit = $d94845a59d001d47$var$$util.Long.fromValue(d.gasLimit)).unsigned = true;
                        else if (typeof d.gasLimit === "string") m.gasLimit = parseInt(d.gasLimit, 10);
                        else if (typeof d.gasLimit === "number") m.gasLimit = d.gasLimit;
                        else if (typeof d.gasLimit === "object") m.gasLimit = new $d94845a59d001d47$var$$util.LongBits(d.gasLimit.low >>> 0, d.gasLimit.high >>> 0).toNumber(true);
                    }
                    if (d.payer != null) m.payer = String(d.payer);
                    if (d.granter != null) m.granter = String(d.granter);
                    return m;
                };
                Fee.toObject = function toObject(m, o) {
                    if (!o) o = {};
                    var d = {};
                    if (o.arrays || o.defaults) d.amount = [];
                    if (o.defaults) {
                        if ($d94845a59d001d47$var$$util.Long) {
                            var n = new $d94845a59d001d47$var$$util.Long(0, 0, true);
                            d.gasLimit = o.longs === String ? n.toString() : o.longs === Number ? n.toNumber() : n;
                        } else d.gasLimit = o.longs === String ? "0" : 0;
                        d.payer = "";
                        d.granter = "";
                    }
                    if (m.amount && m.amount.length) {
                        d.amount = [];
                        for(var j = 0; j < m.amount.length; ++j)d.amount[j] = $d94845a59d001d47$var$$root.cosmos.base.v1beta1.Coin.toObject(m.amount[j], o);
                    }
                    if (m.gasLimit != null && m.hasOwnProperty("gasLimit")) {
                        if (typeof m.gasLimit === "number") d.gasLimit = o.longs === String ? String(m.gasLimit) : m.gasLimit;
                        else d.gasLimit = o.longs === String ? $d94845a59d001d47$var$$util.Long.prototype.toString.call(m.gasLimit) : o.longs === Number ? new $d94845a59d001d47$var$$util.LongBits(m.gasLimit.low >>> 0, m.gasLimit.high >>> 0).toNumber(true) : m.gasLimit;
                    }
                    if (m.payer != null && m.hasOwnProperty("payer")) d.payer = m.payer;
                    if (m.granter != null && m.hasOwnProperty("granter")) d.granter = m.granter;
                    return d;
                };
                Fee.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $fQBv0.util.toJSONOptions);
                };
                return Fee;
            }();
            return v1beta1;
        }();
        tx.signing = function() {
            const signing = {};
            signing.v1beta1 = function() {
                const v1beta1 = {};
                v1beta1.SignMode = function() {
                    const valuesById = {}, values = Object.create(valuesById);
                    values[valuesById[0] = "SIGN_MODE_UNSPECIFIED"] = 0;
                    values[valuesById[1] = "SIGN_MODE_DIRECT"] = 1;
                    values[valuesById[2] = "SIGN_MODE_TEXTUAL"] = 2;
                    values[valuesById[127] = "SIGN_MODE_LEGACY_AMINO_JSON"] = 127;
                    return values;
                }();
                v1beta1.SignatureDescriptors = function() {
                    function SignatureDescriptors(p) {
                        this.signatures = [];
                        if (p) {
                            for(var ks = Object.keys(p), i = 0; i < ks.length; ++i)if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
                        }
                    }
                    SignatureDescriptors.prototype.signatures = $d94845a59d001d47$var$$util.emptyArray;
                    SignatureDescriptors.create = function create(properties) {
                        return new SignatureDescriptors(properties);
                    };
                    SignatureDescriptors.encode = function encode(m, w) {
                        if (!w) w = $d94845a59d001d47$var$$Writer.create();
                        if (m.signatures != null && m.signatures.length) for(var i = 0; i < m.signatures.length; ++i)$d94845a59d001d47$var$$root.cosmos.tx.signing.v1beta1.SignatureDescriptor.encode(m.signatures[i], w.uint32(10).fork()).ldelim();
                        return w;
                    };
                    SignatureDescriptors.decode = function decode(r, l) {
                        if (!(r instanceof $d94845a59d001d47$var$$Reader)) r = $d94845a59d001d47$var$$Reader.create(r);
                        var c = l === undefined ? r.len : r.pos + l, m = new $d94845a59d001d47$var$$root.cosmos.tx.signing.v1beta1.SignatureDescriptors();
                        while(r.pos < c){
                            var t = r.uint32();
                            switch(t >>> 3){
                                case 1:
                                    if (!(m.signatures && m.signatures.length)) m.signatures = [];
                                    m.signatures.push($d94845a59d001d47$var$$root.cosmos.tx.signing.v1beta1.SignatureDescriptor.decode(r, r.uint32()));
                                    break;
                                default:
                                    r.skipType(t & 7);
                                    break;
                            }
                        }
                        return m;
                    };
                    SignatureDescriptors.fromObject = function fromObject(d) {
                        if (d instanceof $d94845a59d001d47$var$$root.cosmos.tx.signing.v1beta1.SignatureDescriptors) return d;
                        var m = new $d94845a59d001d47$var$$root.cosmos.tx.signing.v1beta1.SignatureDescriptors();
                        if (d.signatures) {
                            if (!Array.isArray(d.signatures)) throw TypeError(".cosmos.tx.signing.v1beta1.SignatureDescriptors.signatures: array expected");
                            m.signatures = [];
                            for(var i = 0; i < d.signatures.length; ++i){
                                if (typeof d.signatures[i] !== "object") throw TypeError(".cosmos.tx.signing.v1beta1.SignatureDescriptors.signatures: object expected");
                                m.signatures[i] = $d94845a59d001d47$var$$root.cosmos.tx.signing.v1beta1.SignatureDescriptor.fromObject(d.signatures[i]);
                            }
                        }
                        return m;
                    };
                    SignatureDescriptors.toObject = function toObject(m, o) {
                        if (!o) o = {};
                        var d = {};
                        if (o.arrays || o.defaults) d.signatures = [];
                        if (m.signatures && m.signatures.length) {
                            d.signatures = [];
                            for(var j = 0; j < m.signatures.length; ++j)d.signatures[j] = $d94845a59d001d47$var$$root.cosmos.tx.signing.v1beta1.SignatureDescriptor.toObject(m.signatures[j], o);
                        }
                        return d;
                    };
                    SignatureDescriptors.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $fQBv0.util.toJSONOptions);
                    };
                    return SignatureDescriptors;
                }();
                v1beta1.SignatureDescriptor = function() {
                    function SignatureDescriptor(p) {
                        if (p) {
                            for(var ks = Object.keys(p), i = 0; i < ks.length; ++i)if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
                        }
                    }
                    SignatureDescriptor.prototype.publicKey = null;
                    SignatureDescriptor.prototype.data = null;
                    SignatureDescriptor.prototype.sequence = $d94845a59d001d47$var$$util.Long ? $d94845a59d001d47$var$$util.Long.fromBits(0, 0, true) : 0;
                    SignatureDescriptor.create = function create(properties) {
                        return new SignatureDescriptor(properties);
                    };
                    SignatureDescriptor.encode = function encode(m, w) {
                        if (!w) w = $d94845a59d001d47$var$$Writer.create();
                        if (m.publicKey != null && Object.hasOwnProperty.call(m, "publicKey")) $d94845a59d001d47$var$$root.google.protobuf.Any.encode(m.publicKey, w.uint32(10).fork()).ldelim();
                        if (m.data != null && Object.hasOwnProperty.call(m, "data")) $d94845a59d001d47$var$$root.cosmos.tx.signing.v1beta1.SignatureDescriptor.Data.encode(m.data, w.uint32(18).fork()).ldelim();
                        if (m.sequence != null && Object.hasOwnProperty.call(m, "sequence")) w.uint32(24).uint64(m.sequence);
                        return w;
                    };
                    SignatureDescriptor.decode = function decode(r, l) {
                        if (!(r instanceof $d94845a59d001d47$var$$Reader)) r = $d94845a59d001d47$var$$Reader.create(r);
                        var c = l === undefined ? r.len : r.pos + l, m = new $d94845a59d001d47$var$$root.cosmos.tx.signing.v1beta1.SignatureDescriptor();
                        while(r.pos < c){
                            var t = r.uint32();
                            switch(t >>> 3){
                                case 1:
                                    m.publicKey = $d94845a59d001d47$var$$root.google.protobuf.Any.decode(r, r.uint32());
                                    break;
                                case 2:
                                    m.data = $d94845a59d001d47$var$$root.cosmos.tx.signing.v1beta1.SignatureDescriptor.Data.decode(r, r.uint32());
                                    break;
                                case 3:
                                    m.sequence = r.uint64();
                                    break;
                                default:
                                    r.skipType(t & 7);
                                    break;
                            }
                        }
                        return m;
                    };
                    SignatureDescriptor.fromObject = function fromObject(d) {
                        if (d instanceof $d94845a59d001d47$var$$root.cosmos.tx.signing.v1beta1.SignatureDescriptor) return d;
                        var m = new $d94845a59d001d47$var$$root.cosmos.tx.signing.v1beta1.SignatureDescriptor();
                        if (d.publicKey != null) {
                            if (typeof d.publicKey !== "object") throw TypeError(".cosmos.tx.signing.v1beta1.SignatureDescriptor.publicKey: object expected");
                            m.publicKey = $d94845a59d001d47$var$$root.google.protobuf.Any.fromObject(d.publicKey);
                        }
                        if (d.data != null) {
                            if (typeof d.data !== "object") throw TypeError(".cosmos.tx.signing.v1beta1.SignatureDescriptor.data: object expected");
                            m.data = $d94845a59d001d47$var$$root.cosmos.tx.signing.v1beta1.SignatureDescriptor.Data.fromObject(d.data);
                        }
                        if (d.sequence != null) {
                            if ($d94845a59d001d47$var$$util.Long) (m.sequence = $d94845a59d001d47$var$$util.Long.fromValue(d.sequence)).unsigned = true;
                            else if (typeof d.sequence === "string") m.sequence = parseInt(d.sequence, 10);
                            else if (typeof d.sequence === "number") m.sequence = d.sequence;
                            else if (typeof d.sequence === "object") m.sequence = new $d94845a59d001d47$var$$util.LongBits(d.sequence.low >>> 0, d.sequence.high >>> 0).toNumber(true);
                        }
                        return m;
                    };
                    SignatureDescriptor.toObject = function toObject(m, o) {
                        if (!o) o = {};
                        var d = {};
                        if (o.defaults) {
                            d.publicKey = null;
                            d.data = null;
                            if ($d94845a59d001d47$var$$util.Long) {
                                var n = new $d94845a59d001d47$var$$util.Long(0, 0, true);
                                d.sequence = o.longs === String ? n.toString() : o.longs === Number ? n.toNumber() : n;
                            } else d.sequence = o.longs === String ? "0" : 0;
                        }
                        if (m.publicKey != null && m.hasOwnProperty("publicKey")) d.publicKey = $d94845a59d001d47$var$$root.google.protobuf.Any.toObject(m.publicKey, o);
                        if (m.data != null && m.hasOwnProperty("data")) d.data = $d94845a59d001d47$var$$root.cosmos.tx.signing.v1beta1.SignatureDescriptor.Data.toObject(m.data, o);
                        if (m.sequence != null && m.hasOwnProperty("sequence")) {
                            if (typeof m.sequence === "number") d.sequence = o.longs === String ? String(m.sequence) : m.sequence;
                            else d.sequence = o.longs === String ? $d94845a59d001d47$var$$util.Long.prototype.toString.call(m.sequence) : o.longs === Number ? new $d94845a59d001d47$var$$util.LongBits(m.sequence.low >>> 0, m.sequence.high >>> 0).toNumber(true) : m.sequence;
                        }
                        return d;
                    };
                    SignatureDescriptor.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $fQBv0.util.toJSONOptions);
                    };
                    SignatureDescriptor.Data = function() {
                        function Data(p) {
                            if (p) {
                                for(var ks = Object.keys(p), i = 0; i < ks.length; ++i)if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
                            }
                        }
                        Data.prototype.single = null;
                        Data.prototype.multi = null;
                        let $oneOfFields;
                        Object.defineProperty(Data.prototype, "sum", {
                            get: $d94845a59d001d47$var$$util.oneOfGetter($oneOfFields = [
                                "single",
                                "multi"
                            ]),
                            set: $d94845a59d001d47$var$$util.oneOfSetter($oneOfFields)
                        });
                        Data.create = function create(properties) {
                            return new Data(properties);
                        };
                        Data.encode = function encode(m, w) {
                            if (!w) w = $d94845a59d001d47$var$$Writer.create();
                            if (m.single != null && Object.hasOwnProperty.call(m, "single")) $d94845a59d001d47$var$$root.cosmos.tx.signing.v1beta1.SignatureDescriptor.Data.Single.encode(m.single, w.uint32(10).fork()).ldelim();
                            if (m.multi != null && Object.hasOwnProperty.call(m, "multi")) $d94845a59d001d47$var$$root.cosmos.tx.signing.v1beta1.SignatureDescriptor.Data.Multi.encode(m.multi, w.uint32(18).fork()).ldelim();
                            return w;
                        };
                        Data.decode = function decode(r, l) {
                            if (!(r instanceof $d94845a59d001d47$var$$Reader)) r = $d94845a59d001d47$var$$Reader.create(r);
                            var c = l === undefined ? r.len : r.pos + l, m = new $d94845a59d001d47$var$$root.cosmos.tx.signing.v1beta1.SignatureDescriptor.Data();
                            while(r.pos < c){
                                var t = r.uint32();
                                switch(t >>> 3){
                                    case 1:
                                        m.single = $d94845a59d001d47$var$$root.cosmos.tx.signing.v1beta1.SignatureDescriptor.Data.Single.decode(r, r.uint32());
                                        break;
                                    case 2:
                                        m.multi = $d94845a59d001d47$var$$root.cosmos.tx.signing.v1beta1.SignatureDescriptor.Data.Multi.decode(r, r.uint32());
                                        break;
                                    default:
                                        r.skipType(t & 7);
                                        break;
                                }
                            }
                            return m;
                        };
                        Data.fromObject = function fromObject(d) {
                            if (d instanceof $d94845a59d001d47$var$$root.cosmos.tx.signing.v1beta1.SignatureDescriptor.Data) return d;
                            var m = new $d94845a59d001d47$var$$root.cosmos.tx.signing.v1beta1.SignatureDescriptor.Data();
                            if (d.single != null) {
                                if (typeof d.single !== "object") throw TypeError(".cosmos.tx.signing.v1beta1.SignatureDescriptor.Data.single: object expected");
                                m.single = $d94845a59d001d47$var$$root.cosmos.tx.signing.v1beta1.SignatureDescriptor.Data.Single.fromObject(d.single);
                            }
                            if (d.multi != null) {
                                if (typeof d.multi !== "object") throw TypeError(".cosmos.tx.signing.v1beta1.SignatureDescriptor.Data.multi: object expected");
                                m.multi = $d94845a59d001d47$var$$root.cosmos.tx.signing.v1beta1.SignatureDescriptor.Data.Multi.fromObject(d.multi);
                            }
                            return m;
                        };
                        Data.toObject = function toObject(m, o) {
                            if (!o) o = {};
                            var d = {};
                            if (m.single != null && m.hasOwnProperty("single")) {
                                d.single = $d94845a59d001d47$var$$root.cosmos.tx.signing.v1beta1.SignatureDescriptor.Data.Single.toObject(m.single, o);
                                if (o.oneofs) d.sum = "single";
                            }
                            if (m.multi != null && m.hasOwnProperty("multi")) {
                                d.multi = $d94845a59d001d47$var$$root.cosmos.tx.signing.v1beta1.SignatureDescriptor.Data.Multi.toObject(m.multi, o);
                                if (o.oneofs) d.sum = "multi";
                            }
                            return d;
                        };
                        Data.prototype.toJSON = function toJSON() {
                            return this.constructor.toObject(this, $fQBv0.util.toJSONOptions);
                        };
                        Data.Single = function() {
                            function Single(p) {
                                if (p) {
                                    for(var ks = Object.keys(p), i = 0; i < ks.length; ++i)if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
                                }
                            }
                            Single.prototype.mode = 0;
                            Single.prototype.signature = $d94845a59d001d47$var$$util.newBuffer([]);
                            Single.create = function create(properties) {
                                return new Single(properties);
                            };
                            Single.encode = function encode(m, w) {
                                if (!w) w = $d94845a59d001d47$var$$Writer.create();
                                if (m.mode != null && Object.hasOwnProperty.call(m, "mode")) w.uint32(8).int32(m.mode);
                                if (m.signature != null && Object.hasOwnProperty.call(m, "signature")) w.uint32(18).bytes(m.signature);
                                return w;
                            };
                            Single.decode = function decode(r, l) {
                                if (!(r instanceof $d94845a59d001d47$var$$Reader)) r = $d94845a59d001d47$var$$Reader.create(r);
                                var c = l === undefined ? r.len : r.pos + l, m = new $d94845a59d001d47$var$$root.cosmos.tx.signing.v1beta1.SignatureDescriptor.Data.Single();
                                while(r.pos < c){
                                    var t = r.uint32();
                                    switch(t >>> 3){
                                        case 1:
                                            m.mode = r.int32();
                                            break;
                                        case 2:
                                            m.signature = r.bytes();
                                            break;
                                        default:
                                            r.skipType(t & 7);
                                            break;
                                    }
                                }
                                return m;
                            };
                            Single.fromObject = function fromObject(d) {
                                if (d instanceof $d94845a59d001d47$var$$root.cosmos.tx.signing.v1beta1.SignatureDescriptor.Data.Single) return d;
                                var m = new $d94845a59d001d47$var$$root.cosmos.tx.signing.v1beta1.SignatureDescriptor.Data.Single();
                                switch(d.mode){
                                    case "SIGN_MODE_UNSPECIFIED":
                                    case 0:
                                        m.mode = 0;
                                        break;
                                    case "SIGN_MODE_DIRECT":
                                    case 1:
                                        m.mode = 1;
                                        break;
                                    case "SIGN_MODE_TEXTUAL":
                                    case 2:
                                        m.mode = 2;
                                        break;
                                    case "SIGN_MODE_LEGACY_AMINO_JSON":
                                    case 127:
                                        m.mode = 127;
                                        break;
                                }
                                if (d.signature != null) {
                                    if (typeof d.signature === "string") $d94845a59d001d47$var$$util.base64.decode(d.signature, m.signature = $d94845a59d001d47$var$$util.newBuffer($d94845a59d001d47$var$$util.base64.length(d.signature)), 0);
                                    else if (d.signature.length) m.signature = d.signature;
                                }
                                return m;
                            };
                            Single.toObject = function toObject(m, o) {
                                if (!o) o = {};
                                var d = {};
                                if (o.defaults) {
                                    d.mode = o.enums === String ? "SIGN_MODE_UNSPECIFIED" : 0;
                                    if (o.bytes === String) d.signature = "";
                                    else {
                                        d.signature = [];
                                        if (o.bytes !== Array) d.signature = $d94845a59d001d47$var$$util.newBuffer(d.signature);
                                    }
                                }
                                if (m.mode != null && m.hasOwnProperty("mode")) d.mode = o.enums === String ? $d94845a59d001d47$var$$root.cosmos.tx.signing.v1beta1.SignMode[m.mode] : m.mode;
                                if (m.signature != null && m.hasOwnProperty("signature")) d.signature = o.bytes === String ? $d94845a59d001d47$var$$util.base64.encode(m.signature, 0, m.signature.length) : o.bytes === Array ? Array.prototype.slice.call(m.signature) : m.signature;
                                return d;
                            };
                            Single.prototype.toJSON = function toJSON() {
                                return this.constructor.toObject(this, $fQBv0.util.toJSONOptions);
                            };
                            return Single;
                        }();
                        Data.Multi = function() {
                            function Multi(p) {
                                this.signatures = [];
                                if (p) {
                                    for(var ks = Object.keys(p), i = 0; i < ks.length; ++i)if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
                                }
                            }
                            Multi.prototype.bitarray = null;
                            Multi.prototype.signatures = $d94845a59d001d47$var$$util.emptyArray;
                            Multi.create = function create(properties) {
                                return new Multi(properties);
                            };
                            Multi.encode = function encode(m, w) {
                                if (!w) w = $d94845a59d001d47$var$$Writer.create();
                                if (m.bitarray != null && Object.hasOwnProperty.call(m, "bitarray")) $d94845a59d001d47$var$$root.cosmos.crypto.multisig.v1beta1.CompactBitArray.encode(m.bitarray, w.uint32(10).fork()).ldelim();
                                if (m.signatures != null && m.signatures.length) for(var i = 0; i < m.signatures.length; ++i)$d94845a59d001d47$var$$root.cosmos.tx.signing.v1beta1.SignatureDescriptor.Data.encode(m.signatures[i], w.uint32(18).fork()).ldelim();
                                return w;
                            };
                            Multi.decode = function decode(r, l) {
                                if (!(r instanceof $d94845a59d001d47$var$$Reader)) r = $d94845a59d001d47$var$$Reader.create(r);
                                var c = l === undefined ? r.len : r.pos + l, m = new $d94845a59d001d47$var$$root.cosmos.tx.signing.v1beta1.SignatureDescriptor.Data.Multi();
                                while(r.pos < c){
                                    var t = r.uint32();
                                    switch(t >>> 3){
                                        case 1:
                                            m.bitarray = $d94845a59d001d47$var$$root.cosmos.crypto.multisig.v1beta1.CompactBitArray.decode(r, r.uint32());
                                            break;
                                        case 2:
                                            if (!(m.signatures && m.signatures.length)) m.signatures = [];
                                            m.signatures.push($d94845a59d001d47$var$$root.cosmos.tx.signing.v1beta1.SignatureDescriptor.Data.decode(r, r.uint32()));
                                            break;
                                        default:
                                            r.skipType(t & 7);
                                            break;
                                    }
                                }
                                return m;
                            };
                            Multi.fromObject = function fromObject(d) {
                                if (d instanceof $d94845a59d001d47$var$$root.cosmos.tx.signing.v1beta1.SignatureDescriptor.Data.Multi) return d;
                                var m = new $d94845a59d001d47$var$$root.cosmos.tx.signing.v1beta1.SignatureDescriptor.Data.Multi();
                                if (d.bitarray != null) {
                                    if (typeof d.bitarray !== "object") throw TypeError(".cosmos.tx.signing.v1beta1.SignatureDescriptor.Data.Multi.bitarray: object expected");
                                    m.bitarray = $d94845a59d001d47$var$$root.cosmos.crypto.multisig.v1beta1.CompactBitArray.fromObject(d.bitarray);
                                }
                                if (d.signatures) {
                                    if (!Array.isArray(d.signatures)) throw TypeError(".cosmos.tx.signing.v1beta1.SignatureDescriptor.Data.Multi.signatures: array expected");
                                    m.signatures = [];
                                    for(var i = 0; i < d.signatures.length; ++i){
                                        if (typeof d.signatures[i] !== "object") throw TypeError(".cosmos.tx.signing.v1beta1.SignatureDescriptor.Data.Multi.signatures: object expected");
                                        m.signatures[i] = $d94845a59d001d47$var$$root.cosmos.tx.signing.v1beta1.SignatureDescriptor.Data.fromObject(d.signatures[i]);
                                    }
                                }
                                return m;
                            };
                            Multi.toObject = function toObject(m, o) {
                                if (!o) o = {};
                                var d = {};
                                if (o.arrays || o.defaults) d.signatures = [];
                                if (o.defaults) d.bitarray = null;
                                if (m.bitarray != null && m.hasOwnProperty("bitarray")) d.bitarray = $d94845a59d001d47$var$$root.cosmos.crypto.multisig.v1beta1.CompactBitArray.toObject(m.bitarray, o);
                                if (m.signatures && m.signatures.length) {
                                    d.signatures = [];
                                    for(var j = 0; j < m.signatures.length; ++j)d.signatures[j] = $d94845a59d001d47$var$$root.cosmos.tx.signing.v1beta1.SignatureDescriptor.Data.toObject(m.signatures[j], o);
                                }
                                return d;
                            };
                            Multi.prototype.toJSON = function toJSON() {
                                return this.constructor.toObject(this, $fQBv0.util.toJSONOptions);
                            };
                            return Multi;
                        }();
                        return Data;
                    }();
                    return SignatureDescriptor;
                }();
                return v1beta1;
            }();
            return signing;
        }();
        return tx;
    }();
    return cosmos;
})();
module.exports.google = $d94845a59d001d47$var$$root.google = (()=>{
    const google = {};
    google.protobuf = function() {
        const protobuf = {};
        protobuf.Any = function() {
            function Any(p) {
                if (p) {
                    for(var ks = Object.keys(p), i = 0; i < ks.length; ++i)if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
                }
            }
            Any.prototype.type_url = "";
            Any.prototype.value = $d94845a59d001d47$var$$util.newBuffer([]);
            Any.create = function create(properties) {
                return new Any(properties);
            };
            Any.encode = function encode(m, w) {
                if (!w) w = $d94845a59d001d47$var$$Writer.create();
                if (m.type_url != null && Object.hasOwnProperty.call(m, "type_url")) w.uint32(10).string(m.type_url);
                if (m.value != null && Object.hasOwnProperty.call(m, "value")) w.uint32(18).bytes(m.value);
                return w;
            };
            Any.decode = function decode(r, l) {
                if (!(r instanceof $d94845a59d001d47$var$$Reader)) r = $d94845a59d001d47$var$$Reader.create(r);
                var c = l === undefined ? r.len : r.pos + l, m = new $d94845a59d001d47$var$$root.google.protobuf.Any();
                while(r.pos < c){
                    var t = r.uint32();
                    switch(t >>> 3){
                        case 1:
                            m.type_url = r.string();
                            break;
                        case 2:
                            m.value = r.bytes();
                            break;
                        default:
                            r.skipType(t & 7);
                            break;
                    }
                }
                return m;
            };
            Any.fromObject = function fromObject(d) {
                if (d instanceof $d94845a59d001d47$var$$root.google.protobuf.Any) return d;
                var m = new $d94845a59d001d47$var$$root.google.protobuf.Any();
                if (d.type_url != null) m.type_url = String(d.type_url);
                if (d.value != null) {
                    if (typeof d.value === "string") $d94845a59d001d47$var$$util.base64.decode(d.value, m.value = $d94845a59d001d47$var$$util.newBuffer($d94845a59d001d47$var$$util.base64.length(d.value)), 0);
                    else if (d.value.length) m.value = d.value;
                }
                return m;
            };
            Any.toObject = function toObject(m, o) {
                if (!o) o = {};
                var d = {};
                if (o.defaults) {
                    d.type_url = "";
                    if (o.bytes === String) d.value = "";
                    else {
                        d.value = [];
                        if (o.bytes !== Array) d.value = $d94845a59d001d47$var$$util.newBuffer(d.value);
                    }
                }
                if (m.type_url != null && m.hasOwnProperty("type_url")) d.type_url = m.type_url;
                if (m.value != null && m.hasOwnProperty("value")) d.value = o.bytes === String ? $d94845a59d001d47$var$$util.base64.encode(m.value, 0, m.value.length) : o.bytes === Array ? Array.prototype.slice.call(m.value) : m.value;
                return d;
            };
            Any.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $fQBv0.util.toJSONOptions);
            };
            return Any;
        }();
        protobuf.Timestamp = function() {
            function Timestamp(p) {
                if (p) {
                    for(var ks = Object.keys(p), i = 0; i < ks.length; ++i)if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
                }
            }
            Timestamp.prototype.seconds = $d94845a59d001d47$var$$util.Long ? $d94845a59d001d47$var$$util.Long.fromBits(0, 0, false) : 0;
            Timestamp.prototype.nanos = 0;
            Timestamp.create = function create(properties) {
                return new Timestamp(properties);
            };
            Timestamp.encode = function encode(m, w) {
                if (!w) w = $d94845a59d001d47$var$$Writer.create();
                if (m.seconds != null && Object.hasOwnProperty.call(m, "seconds")) w.uint32(8).int64(m.seconds);
                if (m.nanos != null && Object.hasOwnProperty.call(m, "nanos")) w.uint32(16).int32(m.nanos);
                return w;
            };
            Timestamp.decode = function decode(r, l) {
                if (!(r instanceof $d94845a59d001d47$var$$Reader)) r = $d94845a59d001d47$var$$Reader.create(r);
                var c = l === undefined ? r.len : r.pos + l, m = new $d94845a59d001d47$var$$root.google.protobuf.Timestamp();
                while(r.pos < c){
                    var t = r.uint32();
                    switch(t >>> 3){
                        case 1:
                            m.seconds = r.int64();
                            break;
                        case 2:
                            m.nanos = r.int32();
                            break;
                        default:
                            r.skipType(t & 7);
                            break;
                    }
                }
                return m;
            };
            Timestamp.fromObject = function fromObject(d) {
                if (d instanceof $d94845a59d001d47$var$$root.google.protobuf.Timestamp) return d;
                var m = new $d94845a59d001d47$var$$root.google.protobuf.Timestamp();
                if (d.seconds != null) {
                    if ($d94845a59d001d47$var$$util.Long) (m.seconds = $d94845a59d001d47$var$$util.Long.fromValue(d.seconds)).unsigned = false;
                    else if (typeof d.seconds === "string") m.seconds = parseInt(d.seconds, 10);
                    else if (typeof d.seconds === "number") m.seconds = d.seconds;
                    else if (typeof d.seconds === "object") m.seconds = new $d94845a59d001d47$var$$util.LongBits(d.seconds.low >>> 0, d.seconds.high >>> 0).toNumber();
                }
                if (d.nanos != null) m.nanos = d.nanos | 0;
                return m;
            };
            Timestamp.toObject = function toObject(m, o) {
                if (!o) o = {};
                var d = {};
                if (o.defaults) {
                    if ($d94845a59d001d47$var$$util.Long) {
                        var n = new $d94845a59d001d47$var$$util.Long(0, 0, false);
                        d.seconds = o.longs === String ? n.toString() : o.longs === Number ? n.toNumber() : n;
                    } else d.seconds = o.longs === String ? "0" : 0;
                    d.nanos = 0;
                }
                if (m.seconds != null && m.hasOwnProperty("seconds")) {
                    if (typeof m.seconds === "number") d.seconds = o.longs === String ? String(m.seconds) : m.seconds;
                    else d.seconds = o.longs === String ? $d94845a59d001d47$var$$util.Long.prototype.toString.call(m.seconds) : o.longs === Number ? new $d94845a59d001d47$var$$util.LongBits(m.seconds.low >>> 0, m.seconds.high >>> 0).toNumber() : m.seconds;
                }
                if (m.nanos != null && m.hasOwnProperty("nanos")) d.nanos = m.nanos;
                return d;
            };
            Timestamp.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $fQBv0.util.toJSONOptions);
            };
            return Timestamp;
        }();
        return protobuf;
    }();
    return google;
})();
module.exports.ibc = $d94845a59d001d47$var$$root.ibc = (()=>{
    const ibc = {};
    ibc.applications = function() {
        const applications = {};
        applications.transfer = function() {
            const transfer = {};
            transfer.v1 = function() {
                const v1 = {};
                v1.Msg = function() {
                    function Msg(rpcImpl, requestDelimited, responseDelimited) {
                        $fQBv0.rpc.Service.call(this, rpcImpl, requestDelimited, responseDelimited);
                    }
                    (Msg.prototype = Object.create($fQBv0.rpc.Service.prototype)).constructor = Msg;
                    Msg.create = function create(rpcImpl, requestDelimited, responseDelimited) {
                        return new this(rpcImpl, requestDelimited, responseDelimited);
                    };
                    Object.defineProperty(Msg.prototype.transfer = function transfer(request, callback) {
                        return this.rpcCall(transfer, $d94845a59d001d47$var$$root.ibc.applications.transfer.v1.MsgTransfer, $d94845a59d001d47$var$$root.ibc.applications.transfer.v1.MsgTransferResponse, request, callback);
                    }, "name", {
                        value: "Transfer"
                    });
                    return Msg;
                }();
                v1.MsgTransfer = function() {
                    function MsgTransfer(p) {
                        if (p) {
                            for(var ks = Object.keys(p), i = 0; i < ks.length; ++i)if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
                        }
                    }
                    MsgTransfer.prototype.sourcePort = "";
                    MsgTransfer.prototype.sourceChannel = "";
                    MsgTransfer.prototype.token = null;
                    MsgTransfer.prototype.sender = "";
                    MsgTransfer.prototype.receiver = "";
                    MsgTransfer.prototype.timeoutHeight = null;
                    MsgTransfer.prototype.timeoutTimestamp = $d94845a59d001d47$var$$util.Long ? $d94845a59d001d47$var$$util.Long.fromBits(0, 0, true) : 0;
                    MsgTransfer.create = function create(properties) {
                        return new MsgTransfer(properties);
                    };
                    MsgTransfer.encode = function encode(m, w) {
                        if (!w) w = $d94845a59d001d47$var$$Writer.create();
                        if (m.sourcePort != null && Object.hasOwnProperty.call(m, "sourcePort")) w.uint32(10).string(m.sourcePort);
                        if (m.sourceChannel != null && Object.hasOwnProperty.call(m, "sourceChannel")) w.uint32(18).string(m.sourceChannel);
                        if (m.token != null && Object.hasOwnProperty.call(m, "token")) $d94845a59d001d47$var$$root.cosmos.base.v1beta1.Coin.encode(m.token, w.uint32(26).fork()).ldelim();
                        if (m.sender != null && Object.hasOwnProperty.call(m, "sender")) w.uint32(34).string(m.sender);
                        if (m.receiver != null && Object.hasOwnProperty.call(m, "receiver")) w.uint32(42).string(m.receiver);
                        if (m.timeoutHeight != null && Object.hasOwnProperty.call(m, "timeoutHeight")) $d94845a59d001d47$var$$root.ibc.core.client.v1.Height.encode(m.timeoutHeight, w.uint32(50).fork()).ldelim();
                        if (m.timeoutTimestamp != null && Object.hasOwnProperty.call(m, "timeoutTimestamp")) w.uint32(56).uint64(m.timeoutTimestamp);
                        return w;
                    };
                    MsgTransfer.decode = function decode(r, l) {
                        if (!(r instanceof $d94845a59d001d47$var$$Reader)) r = $d94845a59d001d47$var$$Reader.create(r);
                        var c = l === undefined ? r.len : r.pos + l, m = new $d94845a59d001d47$var$$root.ibc.applications.transfer.v1.MsgTransfer();
                        while(r.pos < c){
                            var t = r.uint32();
                            switch(t >>> 3){
                                case 1:
                                    m.sourcePort = r.string();
                                    break;
                                case 2:
                                    m.sourceChannel = r.string();
                                    break;
                                case 3:
                                    m.token = $d94845a59d001d47$var$$root.cosmos.base.v1beta1.Coin.decode(r, r.uint32());
                                    break;
                                case 4:
                                    m.sender = r.string();
                                    break;
                                case 5:
                                    m.receiver = r.string();
                                    break;
                                case 6:
                                    m.timeoutHeight = $d94845a59d001d47$var$$root.ibc.core.client.v1.Height.decode(r, r.uint32());
                                    break;
                                case 7:
                                    m.timeoutTimestamp = r.uint64();
                                    break;
                                default:
                                    r.skipType(t & 7);
                                    break;
                            }
                        }
                        return m;
                    };
                    MsgTransfer.fromObject = function fromObject(d) {
                        if (d instanceof $d94845a59d001d47$var$$root.ibc.applications.transfer.v1.MsgTransfer) return d;
                        var m = new $d94845a59d001d47$var$$root.ibc.applications.transfer.v1.MsgTransfer();
                        if (d.sourcePort != null) m.sourcePort = String(d.sourcePort);
                        if (d.sourceChannel != null) m.sourceChannel = String(d.sourceChannel);
                        if (d.token != null) {
                            if (typeof d.token !== "object") throw TypeError(".ibc.applications.transfer.v1.MsgTransfer.token: object expected");
                            m.token = $d94845a59d001d47$var$$root.cosmos.base.v1beta1.Coin.fromObject(d.token);
                        }
                        if (d.sender != null) m.sender = String(d.sender);
                        if (d.receiver != null) m.receiver = String(d.receiver);
                        if (d.timeoutHeight != null) {
                            if (typeof d.timeoutHeight !== "object") throw TypeError(".ibc.applications.transfer.v1.MsgTransfer.timeoutHeight: object expected");
                            m.timeoutHeight = $d94845a59d001d47$var$$root.ibc.core.client.v1.Height.fromObject(d.timeoutHeight);
                        }
                        if (d.timeoutTimestamp != null) {
                            if ($d94845a59d001d47$var$$util.Long) (m.timeoutTimestamp = $d94845a59d001d47$var$$util.Long.fromValue(d.timeoutTimestamp)).unsigned = true;
                            else if (typeof d.timeoutTimestamp === "string") m.timeoutTimestamp = parseInt(d.timeoutTimestamp, 10);
                            else if (typeof d.timeoutTimestamp === "number") m.timeoutTimestamp = d.timeoutTimestamp;
                            else if (typeof d.timeoutTimestamp === "object") m.timeoutTimestamp = new $d94845a59d001d47$var$$util.LongBits(d.timeoutTimestamp.low >>> 0, d.timeoutTimestamp.high >>> 0).toNumber(true);
                        }
                        return m;
                    };
                    MsgTransfer.toObject = function toObject(m, o) {
                        if (!o) o = {};
                        var d = {};
                        if (o.defaults) {
                            d.sourcePort = "";
                            d.sourceChannel = "";
                            d.token = null;
                            d.sender = "";
                            d.receiver = "";
                            d.timeoutHeight = null;
                            if ($d94845a59d001d47$var$$util.Long) {
                                var n = new $d94845a59d001d47$var$$util.Long(0, 0, true);
                                d.timeoutTimestamp = o.longs === String ? n.toString() : o.longs === Number ? n.toNumber() : n;
                            } else d.timeoutTimestamp = o.longs === String ? "0" : 0;
                        }
                        if (m.sourcePort != null && m.hasOwnProperty("sourcePort")) d.sourcePort = m.sourcePort;
                        if (m.sourceChannel != null && m.hasOwnProperty("sourceChannel")) d.sourceChannel = m.sourceChannel;
                        if (m.token != null && m.hasOwnProperty("token")) d.token = $d94845a59d001d47$var$$root.cosmos.base.v1beta1.Coin.toObject(m.token, o);
                        if (m.sender != null && m.hasOwnProperty("sender")) d.sender = m.sender;
                        if (m.receiver != null && m.hasOwnProperty("receiver")) d.receiver = m.receiver;
                        if (m.timeoutHeight != null && m.hasOwnProperty("timeoutHeight")) d.timeoutHeight = $d94845a59d001d47$var$$root.ibc.core.client.v1.Height.toObject(m.timeoutHeight, o);
                        if (m.timeoutTimestamp != null && m.hasOwnProperty("timeoutTimestamp")) {
                            if (typeof m.timeoutTimestamp === "number") d.timeoutTimestamp = o.longs === String ? String(m.timeoutTimestamp) : m.timeoutTimestamp;
                            else d.timeoutTimestamp = o.longs === String ? $d94845a59d001d47$var$$util.Long.prototype.toString.call(m.timeoutTimestamp) : o.longs === Number ? new $d94845a59d001d47$var$$util.LongBits(m.timeoutTimestamp.low >>> 0, m.timeoutTimestamp.high >>> 0).toNumber(true) : m.timeoutTimestamp;
                        }
                        return d;
                    };
                    MsgTransfer.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $fQBv0.util.toJSONOptions);
                    };
                    return MsgTransfer;
                }();
                v1.MsgTransferResponse = function() {
                    function MsgTransferResponse(p) {
                        if (p) {
                            for(var ks = Object.keys(p), i = 0; i < ks.length; ++i)if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
                        }
                    }
                    MsgTransferResponse.create = function create(properties) {
                        return new MsgTransferResponse(properties);
                    };
                    MsgTransferResponse.encode = function encode(m, w) {
                        if (!w) w = $d94845a59d001d47$var$$Writer.create();
                        return w;
                    };
                    MsgTransferResponse.decode = function decode(r, l) {
                        if (!(r instanceof $d94845a59d001d47$var$$Reader)) r = $d94845a59d001d47$var$$Reader.create(r);
                        var c = l === undefined ? r.len : r.pos + l, m = new $d94845a59d001d47$var$$root.ibc.applications.transfer.v1.MsgTransferResponse();
                        while(r.pos < c){
                            var t = r.uint32();
                            t;
                            r.skipType(t & 7);
                        }
                        return m;
                    };
                    MsgTransferResponse.fromObject = function fromObject(d) {
                        if (d instanceof $d94845a59d001d47$var$$root.ibc.applications.transfer.v1.MsgTransferResponse) return d;
                        return new $d94845a59d001d47$var$$root.ibc.applications.transfer.v1.MsgTransferResponse();
                    };
                    MsgTransferResponse.toObject = function toObject() {
                        return {};
                    };
                    MsgTransferResponse.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $fQBv0.util.toJSONOptions);
                    };
                    return MsgTransferResponse;
                }();
                return v1;
            }();
            return transfer;
        }();
        return applications;
    }();
    ibc.core = function() {
        const core = {};
        core.client = function() {
            const client = {};
            client.v1 = function() {
                const v1 = {};
                v1.Height = function() {
                    function Height(p) {
                        if (p) {
                            for(var ks = Object.keys(p), i = 0; i < ks.length; ++i)if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
                        }
                    }
                    Height.prototype.revisionNumber = $d94845a59d001d47$var$$util.Long ? $d94845a59d001d47$var$$util.Long.fromBits(0, 0, true) : 0;
                    Height.prototype.revisionHeight = $d94845a59d001d47$var$$util.Long ? $d94845a59d001d47$var$$util.Long.fromBits(0, 0, true) : 0;
                    Height.create = function create(properties) {
                        return new Height(properties);
                    };
                    Height.encode = function encode(m, w) {
                        if (!w) w = $d94845a59d001d47$var$$Writer.create();
                        if (m.revisionNumber != null && Object.hasOwnProperty.call(m, "revisionNumber")) w.uint32(8).uint64(m.revisionNumber);
                        if (m.revisionHeight != null && Object.hasOwnProperty.call(m, "revisionHeight")) w.uint32(16).uint64(m.revisionHeight);
                        return w;
                    };
                    Height.decode = function decode(r, l) {
                        if (!(r instanceof $d94845a59d001d47$var$$Reader)) r = $d94845a59d001d47$var$$Reader.create(r);
                        var c = l === undefined ? r.len : r.pos + l, m = new $d94845a59d001d47$var$$root.ibc.core.client.v1.Height();
                        while(r.pos < c){
                            var t = r.uint32();
                            switch(t >>> 3){
                                case 1:
                                    m.revisionNumber = r.uint64();
                                    break;
                                case 2:
                                    m.revisionHeight = r.uint64();
                                    break;
                                default:
                                    r.skipType(t & 7);
                                    break;
                            }
                        }
                        return m;
                    };
                    Height.fromObject = function fromObject(d) {
                        if (d instanceof $d94845a59d001d47$var$$root.ibc.core.client.v1.Height) return d;
                        var m = new $d94845a59d001d47$var$$root.ibc.core.client.v1.Height();
                        if (d.revisionNumber != null) {
                            if ($d94845a59d001d47$var$$util.Long) (m.revisionNumber = $d94845a59d001d47$var$$util.Long.fromValue(d.revisionNumber)).unsigned = true;
                            else if (typeof d.revisionNumber === "string") m.revisionNumber = parseInt(d.revisionNumber, 10);
                            else if (typeof d.revisionNumber === "number") m.revisionNumber = d.revisionNumber;
                            else if (typeof d.revisionNumber === "object") m.revisionNumber = new $d94845a59d001d47$var$$util.LongBits(d.revisionNumber.low >>> 0, d.revisionNumber.high >>> 0).toNumber(true);
                        }
                        if (d.revisionHeight != null) {
                            if ($d94845a59d001d47$var$$util.Long) (m.revisionHeight = $d94845a59d001d47$var$$util.Long.fromValue(d.revisionHeight)).unsigned = true;
                            else if (typeof d.revisionHeight === "string") m.revisionHeight = parseInt(d.revisionHeight, 10);
                            else if (typeof d.revisionHeight === "number") m.revisionHeight = d.revisionHeight;
                            else if (typeof d.revisionHeight === "object") m.revisionHeight = new $d94845a59d001d47$var$$util.LongBits(d.revisionHeight.low >>> 0, d.revisionHeight.high >>> 0).toNumber(true);
                        }
                        return m;
                    };
                    Height.toObject = function toObject(m, o) {
                        if (!o) o = {};
                        var d = {};
                        if (o.defaults) {
                            if ($d94845a59d001d47$var$$util.Long) {
                                var n = new $d94845a59d001d47$var$$util.Long(0, 0, true);
                                d.revisionNumber = o.longs === String ? n.toString() : o.longs === Number ? n.toNumber() : n;
                            } else d.revisionNumber = o.longs === String ? "0" : 0;
                            if ($d94845a59d001d47$var$$util.Long) {
                                var n = new $d94845a59d001d47$var$$util.Long(0, 0, true);
                                d.revisionHeight = o.longs === String ? n.toString() : o.longs === Number ? n.toNumber() : n;
                            } else d.revisionHeight = o.longs === String ? "0" : 0;
                        }
                        if (m.revisionNumber != null && m.hasOwnProperty("revisionNumber")) {
                            if (typeof m.revisionNumber === "number") d.revisionNumber = o.longs === String ? String(m.revisionNumber) : m.revisionNumber;
                            else d.revisionNumber = o.longs === String ? $d94845a59d001d47$var$$util.Long.prototype.toString.call(m.revisionNumber) : o.longs === Number ? new $d94845a59d001d47$var$$util.LongBits(m.revisionNumber.low >>> 0, m.revisionNumber.high >>> 0).toNumber(true) : m.revisionNumber;
                        }
                        if (m.revisionHeight != null && m.hasOwnProperty("revisionHeight")) {
                            if (typeof m.revisionHeight === "number") d.revisionHeight = o.longs === String ? String(m.revisionHeight) : m.revisionHeight;
                            else d.revisionHeight = o.longs === String ? $d94845a59d001d47$var$$util.Long.prototype.toString.call(m.revisionHeight) : o.longs === Number ? new $d94845a59d001d47$var$$util.LongBits(m.revisionHeight.low >>> 0, m.revisionHeight.high >>> 0).toNumber(true) : m.revisionHeight;
                        }
                        return d;
                    };
                    Height.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $fQBv0.util.toJSONOptions);
                    };
                    return Height;
                }();
                return v1;
            }();
            return client;
        }();
        return core;
    }();
    return ibc;
})();
module.exports.cosmwasm = $d94845a59d001d47$var$$root.cosmwasm = (()=>{
    const cosmwasm = {};
    cosmwasm.wasm = function() {
        const wasm = {};
        wasm.v1 = function() {
            const v1 = {};
            v1.MsgExecuteContract = function() {
                function MsgExecuteContract(p) {
                    this.funds = [];
                    if (p) {
                        for(var ks = Object.keys(p), i = 0; i < ks.length; ++i)if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
                    }
                }
                MsgExecuteContract.prototype.sender = "";
                MsgExecuteContract.prototype.contract = "";
                MsgExecuteContract.prototype.msg = $d94845a59d001d47$var$$util.newBuffer([]);
                MsgExecuteContract.prototype.funds = $d94845a59d001d47$var$$util.emptyArray;
                MsgExecuteContract.create = function create(properties) {
                    return new MsgExecuteContract(properties);
                };
                MsgExecuteContract.encode = function encode(m, w) {
                    if (!w) w = $d94845a59d001d47$var$$Writer.create();
                    if (m.sender != null && Object.hasOwnProperty.call(m, "sender")) w.uint32(10).string(m.sender);
                    if (m.contract != null && Object.hasOwnProperty.call(m, "contract")) w.uint32(18).string(m.contract);
                    if (m.msg != null && Object.hasOwnProperty.call(m, "msg")) w.uint32(26).bytes(m.msg);
                    if (m.funds != null && m.funds.length) for(var i = 0; i < m.funds.length; ++i)$d94845a59d001d47$var$$root.cosmos.base.v1beta1.Coin.encode(m.funds[i], w.uint32(42).fork()).ldelim();
                    return w;
                };
                MsgExecuteContract.decode = function decode(r, l) {
                    if (!(r instanceof $d94845a59d001d47$var$$Reader)) r = $d94845a59d001d47$var$$Reader.create(r);
                    var c = l === undefined ? r.len : r.pos + l, m = new $d94845a59d001d47$var$$root.cosmwasm.wasm.v1.MsgExecuteContract();
                    while(r.pos < c){
                        var t = r.uint32();
                        switch(t >>> 3){
                            case 1:
                                m.sender = r.string();
                                break;
                            case 2:
                                m.contract = r.string();
                                break;
                            case 3:
                                m.msg = r.bytes();
                                break;
                            case 5:
                                if (!(m.funds && m.funds.length)) m.funds = [];
                                m.funds.push($d94845a59d001d47$var$$root.cosmos.base.v1beta1.Coin.decode(r, r.uint32()));
                                break;
                            default:
                                r.skipType(t & 7);
                                break;
                        }
                    }
                    return m;
                };
                MsgExecuteContract.fromObject = function fromObject(d) {
                    if (d instanceof $d94845a59d001d47$var$$root.cosmwasm.wasm.v1.MsgExecuteContract) return d;
                    var m = new $d94845a59d001d47$var$$root.cosmwasm.wasm.v1.MsgExecuteContract();
                    if (d.sender != null) m.sender = String(d.sender);
                    if (d.contract != null) m.contract = String(d.contract);
                    if (d.msg != null) {
                        if (typeof d.msg === "string") $d94845a59d001d47$var$$util.base64.decode(d.msg, m.msg = $d94845a59d001d47$var$$util.newBuffer($d94845a59d001d47$var$$util.base64.length(d.msg)), 0);
                        else if (d.msg.length) m.msg = d.msg;
                    }
                    if (d.funds) {
                        if (!Array.isArray(d.funds)) throw TypeError(".cosmwasm.wasm.v1.MsgExecuteContract.funds: array expected");
                        m.funds = [];
                        for(var i = 0; i < d.funds.length; ++i){
                            if (typeof d.funds[i] !== "object") throw TypeError(".cosmwasm.wasm.v1.MsgExecuteContract.funds: object expected");
                            m.funds[i] = $d94845a59d001d47$var$$root.cosmos.base.v1beta1.Coin.fromObject(d.funds[i]);
                        }
                    }
                    return m;
                };
                MsgExecuteContract.toObject = function toObject(m, o) {
                    if (!o) o = {};
                    var d = {};
                    if (o.arrays || o.defaults) d.funds = [];
                    if (o.defaults) {
                        d.sender = "";
                        d.contract = "";
                        if (o.bytes === String) d.msg = "";
                        else {
                            d.msg = [];
                            if (o.bytes !== Array) d.msg = $d94845a59d001d47$var$$util.newBuffer(d.msg);
                        }
                    }
                    if (m.sender != null && m.hasOwnProperty("sender")) d.sender = m.sender;
                    if (m.contract != null && m.hasOwnProperty("contract")) d.contract = m.contract;
                    if (m.msg != null && m.hasOwnProperty("msg")) d.msg = o.bytes === String ? $d94845a59d001d47$var$$util.base64.encode(m.msg, 0, m.msg.length) : o.bytes === Array ? Array.prototype.slice.call(m.msg) : m.msg;
                    if (m.funds && m.funds.length) {
                        d.funds = [];
                        for(var j = 0; j < m.funds.length; ++j)d.funds[j] = $d94845a59d001d47$var$$root.cosmos.base.v1beta1.Coin.toObject(m.funds[j], o);
                    }
                    return d;
                };
                MsgExecuteContract.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $fQBv0.util.toJSONOptions);
                };
                return MsgExecuteContract;
            }();
            v1.MsgExecuteContractResponse = function() {
                function MsgExecuteContractResponse(p) {
                    if (p) {
                        for(var ks = Object.keys(p), i = 0; i < ks.length; ++i)if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
                    }
                }
                MsgExecuteContractResponse.prototype.data = $d94845a59d001d47$var$$util.newBuffer([]);
                MsgExecuteContractResponse.create = function create(properties) {
                    return new MsgExecuteContractResponse(properties);
                };
                MsgExecuteContractResponse.encode = function encode(m, w) {
                    if (!w) w = $d94845a59d001d47$var$$Writer.create();
                    if (m.data != null && Object.hasOwnProperty.call(m, "data")) w.uint32(10).bytes(m.data);
                    return w;
                };
                MsgExecuteContractResponse.decode = function decode(r, l) {
                    if (!(r instanceof $d94845a59d001d47$var$$Reader)) r = $d94845a59d001d47$var$$Reader.create(r);
                    var c = l === undefined ? r.len : r.pos + l, m = new $d94845a59d001d47$var$$root.cosmwasm.wasm.v1.MsgExecuteContractResponse();
                    while(r.pos < c){
                        var t = r.uint32();
                        switch(t >>> 3){
                            case 1:
                                m.data = r.bytes();
                                break;
                            default:
                                r.skipType(t & 7);
                                break;
                        }
                    }
                    return m;
                };
                MsgExecuteContractResponse.fromObject = function fromObject(d) {
                    if (d instanceof $d94845a59d001d47$var$$root.cosmwasm.wasm.v1.MsgExecuteContractResponse) return d;
                    var m = new $d94845a59d001d47$var$$root.cosmwasm.wasm.v1.MsgExecuteContractResponse();
                    if (d.data != null) {
                        if (typeof d.data === "string") $d94845a59d001d47$var$$util.base64.decode(d.data, m.data = $d94845a59d001d47$var$$util.newBuffer($d94845a59d001d47$var$$util.base64.length(d.data)), 0);
                        else if (d.data.length) m.data = d.data;
                    }
                    return m;
                };
                MsgExecuteContractResponse.toObject = function toObject(m, o) {
                    if (!o) o = {};
                    var d = {};
                    if (o.defaults) {
                        if (o.bytes === String) d.data = "";
                        else {
                            d.data = [];
                            if (o.bytes !== Array) d.data = $d94845a59d001d47$var$$util.newBuffer(d.data);
                        }
                    }
                    if (m.data != null && m.hasOwnProperty("data")) d.data = o.bytes === String ? $d94845a59d001d47$var$$util.base64.encode(m.data, 0, m.data.length) : o.bytes === Array ? Array.prototype.slice.call(m.data) : m.data;
                    return d;
                };
                MsgExecuteContractResponse.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $fQBv0.util.toJSONOptions);
                };
                return MsgExecuteContractResponse;
            }();
            return v1;
        }();
        return wasm;
    }();
    return cosmwasm;
})();
module.exports.tendermint = $d94845a59d001d47$var$$root.tendermint = (()=>{
    const tendermint = {};
    tendermint.crypto = function() {
        const crypto = {};
        crypto.PublicKey = function() {
            function PublicKey(p) {
                if (p) {
                    for(var ks = Object.keys(p), i = 0; i < ks.length; ++i)if (p[ks[i]] != null) this[ks[i]] = p[ks[i]];
                }
            }
            PublicKey.prototype.ed25519 = $d94845a59d001d47$var$$util.newBuffer([]);
            PublicKey.prototype.secp256k1 = $d94845a59d001d47$var$$util.newBuffer([]);
            let $oneOfFields;
            Object.defineProperty(PublicKey.prototype, "sum", {
                get: $d94845a59d001d47$var$$util.oneOfGetter($oneOfFields = [
                    "ed25519",
                    "secp256k1"
                ]),
                set: $d94845a59d001d47$var$$util.oneOfSetter($oneOfFields)
            });
            PublicKey.create = function create(properties) {
                return new PublicKey(properties);
            };
            PublicKey.encode = function encode(m, w) {
                if (!w) w = $d94845a59d001d47$var$$Writer.create();
                if (m.ed25519 != null && Object.hasOwnProperty.call(m, "ed25519")) w.uint32(10).bytes(m.ed25519);
                if (m.secp256k1 != null && Object.hasOwnProperty.call(m, "secp256k1")) w.uint32(18).bytes(m.secp256k1);
                return w;
            };
            PublicKey.decode = function decode(r, l) {
                if (!(r instanceof $d94845a59d001d47$var$$Reader)) r = $d94845a59d001d47$var$$Reader.create(r);
                var c = l === undefined ? r.len : r.pos + l, m = new $d94845a59d001d47$var$$root.tendermint.crypto.PublicKey();
                while(r.pos < c){
                    var t = r.uint32();
                    switch(t >>> 3){
                        case 1:
                            m.ed25519 = r.bytes();
                            break;
                        case 2:
                            m.secp256k1 = r.bytes();
                            break;
                        default:
                            r.skipType(t & 7);
                            break;
                    }
                }
                return m;
            };
            PublicKey.fromObject = function fromObject(d) {
                if (d instanceof $d94845a59d001d47$var$$root.tendermint.crypto.PublicKey) return d;
                var m = new $d94845a59d001d47$var$$root.tendermint.crypto.PublicKey();
                if (d.ed25519 != null) {
                    if (typeof d.ed25519 === "string") $d94845a59d001d47$var$$util.base64.decode(d.ed25519, m.ed25519 = $d94845a59d001d47$var$$util.newBuffer($d94845a59d001d47$var$$util.base64.length(d.ed25519)), 0);
                    else if (d.ed25519.length) m.ed25519 = d.ed25519;
                }
                if (d.secp256k1 != null) {
                    if (typeof d.secp256k1 === "string") $d94845a59d001d47$var$$util.base64.decode(d.secp256k1, m.secp256k1 = $d94845a59d001d47$var$$util.newBuffer($d94845a59d001d47$var$$util.base64.length(d.secp256k1)), 0);
                    else if (d.secp256k1.length) m.secp256k1 = d.secp256k1;
                }
                return m;
            };
            PublicKey.toObject = function toObject(m, o) {
                if (!o) o = {};
                var d = {};
                if (m.ed25519 != null && m.hasOwnProperty("ed25519")) {
                    d.ed25519 = o.bytes === String ? $d94845a59d001d47$var$$util.base64.encode(m.ed25519, 0, m.ed25519.length) : o.bytes === Array ? Array.prototype.slice.call(m.ed25519) : m.ed25519;
                    if (o.oneofs) d.sum = "ed25519";
                }
                if (m.secp256k1 != null && m.hasOwnProperty("secp256k1")) {
                    d.secp256k1 = o.bytes === String ? $d94845a59d001d47$var$$util.base64.encode(m.secp256k1, 0, m.secp256k1.length) : o.bytes === Array ? Array.prototype.slice.call(m.secp256k1) : m.secp256k1;
                    if (o.oneofs) d.sum = "secp256k1";
                }
                return d;
            };
            PublicKey.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $fQBv0.util.toJSONOptions);
            };
            return PublicKey;
        }();
        return crypto;
    }();
    return tendermint;
})();
module.exports = $d94845a59d001d47$var$$root;

});


parcelRequire.register("dHVad", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.UnknownMessage = void 0;

var $cXZjT = parcelRequire("cXZjT");
class $9faba20bf8621575$var$UnknownMessage {
    constructor(/** Any type_url. */ _typeUrl, /** Any value. */ _value){
        this._typeUrl = _typeUrl;
        this._value = _value;
    }
    get typeUrl() {
        return this._typeUrl;
    }
    get value() {
        return this._value;
    }
    toJSON() {
        return {
            type_url: this._typeUrl,
            value: $cXZjT.Buffer.from(this._value).toString("base64")
        };
    }
}
module.exports.UnknownMessage = $9faba20bf8621575$var$UnknownMessage;

});


parcelRequire.register("g0kvf", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ProtoSignDocDecoder = void 0;

var $juMXV = parcelRequire("juMXV");

var $7jGk0 = parcelRequire("7jGk0");
class $ba6c8ce2d120e456$var$ProtoSignDocDecoder {
    constructor(signDoc, protoCodec = $7jGk0.defaultProtoCodec){
        this.signDoc = signDoc;
        this.protoCodec = protoCodec;
    }
    static decode(bytes) {
        return new $ba6c8ce2d120e456$var$ProtoSignDocDecoder($juMXV.cosmos.tx.v1beta1.SignDoc.decode(bytes));
    }
    get txBody() {
        if (!this._txBody) this._txBody = $juMXV.cosmos.tx.v1beta1.TxBody.decode(this.signDoc.bodyBytes);
        return this._txBody;
    }
    get txMsgs() {
        const msgs = [];
        for (const msg of this.txBody.messages)msgs.push(this.protoCodec.unpackAny(msg));
        return msgs;
    }
    get authInfo() {
        if (!this._authInfo) this._authInfo = $juMXV.cosmos.tx.v1beta1.AuthInfo.decode(this.signDoc.authInfoBytes);
        return this._authInfo;
    }
    get chainId() {
        return this.signDoc.chainId;
    }
    get accountNumber() {
        return this.signDoc.accountNumber.toString();
    }
    toBytes() {
        return $juMXV.cosmos.tx.v1beta1.SignDoc.encode(this.signDoc).finish();
    }
    toJSON() {
        return {
            txBody: Object.assign(Object.assign({}, this.txBody.toJSON()), {
                messages: this.txMsgs.map((msg)=>{
                    if (msg && msg.toJSON) return msg.toJSON();
                    return msg;
                })
            }),
            authInfo: this.authInfo.toJSON(),
            chainId: this.chainId,
            accountNumber: this.accountNumber
        };
    }
}
module.exports.ProtoSignDocDecoder = $ba6c8ce2d120e456$var$ProtoSignDocDecoder;

});

parcelRequire.register("5AbUo", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SignDocWrapper = void 0;

var $g0kvf = parcelRequire("g0kvf");

var $juMXV = parcelRequire("juMXV");

var $SezG1 = parcelRequire("SezG1");
class $41098d5be6ed112f$var$SignDocWrapper {
    constructor(signDoc){
        this.signDoc = signDoc;
        if ("msgs" in signDoc) this.mode = "amino";
        else this.mode = "direct";
        if (this.mode === "amino") // Check that the sign doc is for ADR-36.
        // The validation should be performed on the background process.
        // So, here, we check once more, but the validation related to bech32 is considered to be done in the background process.
        this.isADR36SignDoc = $SezG1.checkAndValidateADR36AminoSignDoc(this.aminoSignDoc);
        else // Currently, only support amino sign doc for ADR-36
        this.isADR36SignDoc = false;
    }
    static fromAminoSignDoc(signDoc) {
        return new $41098d5be6ed112f$var$SignDocWrapper(signDoc);
    }
    static fromDirectSignDoc(signDoc) {
        return new $41098d5be6ed112f$var$SignDocWrapper(signDoc);
    }
    static fromDirectSignDocBytes(signDocBytes) {
        return new $41098d5be6ed112f$var$SignDocWrapper($juMXV.cosmos.tx.v1beta1.SignDoc.decode(signDocBytes));
    }
    clone() {
        return new $41098d5be6ed112f$var$SignDocWrapper(this.signDoc);
    }
    get protoSignDoc() {
        if (this.mode === "amino") throw new Error("Sign doc is encoded as Amino Json");
        if ("msgs" in this.signDoc) throw new Error("Unexpected error");
        if (!this._protoSignDoc) this._protoSignDoc = new $g0kvf.ProtoSignDocDecoder(this.signDoc);
        return this._protoSignDoc;
    }
    get aminoSignDoc() {
        if (this.mode === "direct") throw new Error("Sign doc is encoded as Protobuf");
        if (!("msgs" in this.signDoc)) throw new Error("Unexpected error");
        return this.signDoc;
    }
    get chainId() {
        if (this.mode === "direct") return this.protoSignDoc.chainId;
        return this.aminoSignDoc.chain_id;
    }
    get memo() {
        if (this.mode === "direct") return this.protoSignDoc.txBody.memo;
        return this.aminoSignDoc.memo;
    }
    get fees() {
        var _a, _b;
        if (this.mode === "direct") {
            const fees = [];
            for (const coinObj of (_b = (_a = this.protoSignDoc.authInfo.fee) === null || _a === void 0 ? void 0 : _a.amount) !== null && _b !== void 0 ? _b : []){
                if (coinObj.denom == null || coinObj.amount == null) throw new Error("Invalid fee");
                fees.push({
                    denom: coinObj.denom,
                    amount: coinObj.amount
                });
            }
            return fees;
        }
        return this.aminoSignDoc.fee.amount;
    }
    get gas() {
        var _a, _b, _c;
        if (this.mode === "direct") return (_c = (_b = (_a = this.protoSignDoc.authInfo.fee) === null || _a === void 0 ? void 0 : _a.gasLimit) === null || _b === void 0 ? void 0 : _b.toNumber()) !== null && _c !== void 0 ? _c : 0;
        return parseInt(this.aminoSignDoc.fee.gas);
    }
}
module.exports.SignDocWrapper = $41098d5be6ed112f$var$SignDocWrapper;

});
parcelRequire.register("SezG1", function(module, exports) {
"use strict";
var $0a30597052387768$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, {
        enumerable: true,
        get: function() {
            return m[k];
        }
    });
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $0a30597052387768$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $0a30597052387768$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$0a30597052387768$var$__exportStar((parcelRequire("6yIMA")), module.exports);

});
parcelRequire.register("6yIMA", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.verifyADR36Amino = module.exports.verifyADR36AminoSignDoc = module.exports.makeADR36AminoSignDoc = module.exports.checkAndValidateADR36AminoSignDoc = void 0;

var $2bxF5 = parcelRequire("2bxF5");

var $lWBwx = parcelRequire("lWBwx");

var $cXZjT = parcelRequire("cXZjT");

var $hkK8Z = parcelRequire("hkK8Z");
/**
 * Check the sign doc is for ADR-36.
 * If the sign doc is expected to be ADR-36, validate the sign doc and throw an error if the sign doc is valid ADR-36.
 * @param signDoc
 * @param bech32PrefixAccAddr If this argument is provided, validate the signer in the `MsgSignData` with this prefix.
 *                            If not, validate the signer in the `MsgSignData` without considering the bech32 prefix.
 */ function $4c68a7f214782361$var$checkAndValidateADR36AminoSignDoc(signDoc, bech32PrefixAccAddr) {
    const hasOnlyMsgSignData = (()=>{
        if (signDoc && signDoc.msgs && Array.isArray(signDoc.msgs) && signDoc.msgs.length === 1) {
            const msg = signDoc.msgs[0];
            return msg.type === "sign/MsgSignData";
        } else return false;
    })();
    if (!hasOnlyMsgSignData) return false;
    if (signDoc.chain_id !== "") throw new Error("Chain id should be empty string for ADR-36 signing");
    if (signDoc.memo !== "") throw new Error("Memo should be empty string for ADR-36 signing");
    if (signDoc.account_number !== "0") throw new Error('Account number should be "0" for ADR-36 signing');
    if (signDoc.sequence !== "0") throw new Error('Sequence should be "0" for ADR-36 signing');
    if (signDoc.fee.gas !== "0") throw new Error('Gas should be "0" for ADR-36 signing');
    if (signDoc.fee.amount.length !== 0) throw new Error("Fee amount should be empty array for ADR-36 signing");
    const msg = signDoc.msgs[0];
    if (msg.type !== "sign/MsgSignData") throw new Error(`Invalid type of ADR-36 sign msg: ${msg.type}`);
    if (!msg.value) throw new Error("Empty value in the msg");
    const signer = msg.value.signer;
    if (!signer) throw new Error("Empty signer in the ADR-36 msg");
    $lWBwx.Bech32Address.validate(signer, bech32PrefixAccAddr);
    const data = msg.value.data;
    if (!data) throw new Error("Empty data in the ADR-36 msg");
    const rawData = $cXZjT.Buffer.from(data, "base64");
    // Validate the data is encoded as base64.
    if (rawData.toString("base64") !== data) throw new Error("Data is not encoded by base64");
    if (rawData.length === 0) throw new Error("Empty data in the ADR-36 msg");
    return true;
}
module.exports.checkAndValidateADR36AminoSignDoc = $4c68a7f214782361$var$checkAndValidateADR36AminoSignDoc;
function $4c68a7f214782361$var$makeADR36AminoSignDoc(signer, data) {
    if (typeof data === "string") data = $cXZjT.Buffer.from(data).toString("base64");
    else data = $cXZjT.Buffer.from(data).toString("base64");
    return {
        chain_id: "",
        account_number: "0",
        sequence: "0",
        fee: {
            gas: "0",
            amount: []
        },
        msgs: [
            {
                type: "sign/MsgSignData",
                value: {
                    signer: signer,
                    data: data
                }
            }
        ],
        memo: ""
    };
}
module.exports.makeADR36AminoSignDoc = $4c68a7f214782361$var$makeADR36AminoSignDoc;
function $4c68a7f214782361$var$verifyADR36AminoSignDoc(bech32PrefixAccAddr, signDoc, pubKey, signature) {
    if (!$4c68a7f214782361$var$checkAndValidateADR36AminoSignDoc(signDoc, bech32PrefixAccAddr)) throw new Error("Invalid sign doc for ADR-36");
    const cryptoPubKey = new $hkK8Z.PubKeySecp256k1(pubKey);
    const expectedSigner = new $lWBwx.Bech32Address(cryptoPubKey.getAddress()).toBech32(bech32PrefixAccAddr);
    const signer = signDoc.msgs[0].value.signer;
    if (expectedSigner !== signer) throw new Error("Unmatched signer");
    const msg = $2bxF5.serializeSignDoc(signDoc);
    return cryptoPubKey.verify(msg, signature);
}
module.exports.verifyADR36AminoSignDoc = $4c68a7f214782361$var$verifyADR36AminoSignDoc;
function $4c68a7f214782361$var$verifyADR36Amino(bech32PrefixAccAddr, signer, data, pubKey, signature) {
    const signDoc = $4c68a7f214782361$var$makeADR36AminoSignDoc(signer, data);
    return $4c68a7f214782361$var$verifyADR36AminoSignDoc(bech32PrefixAccAddr, signDoc, pubKey, signature);
}
module.exports.verifyADR36Amino = $4c68a7f214782361$var$verifyADR36Amino;

});
parcelRequire.register("2bxF5", function(module, exports) {
"use strict";
var $1976b85824885300$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, {
        enumerable: true,
        get: function() {
            return m[k];
        }
    });
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $1976b85824885300$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $1976b85824885300$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $1976b85824885300$var$__createBinding(result, mod, k);
    }
    $1976b85824885300$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Secp256k1Wallet = module.exports.Secp256k1HdWallet = module.exports.extractKdfConfiguration = module.exports.executeKdf = module.exports.pubkeyType = module.exports.makeStdTx = module.exports.isWrappedStdTx = module.exports.isStdTx = module.exports.SigningCosmosClient = module.exports.decodeSignature = module.exports.encodeSecp256k1Signature = module.exports.findSequenceForSignedTx = module.exports.encodeSecp256k1Pubkey = module.exports.encodeBech32Pubkey = module.exports.encodeAminoPubkey = module.exports.decodeBech32Pubkey = module.exports.decodeAminoPubkey = module.exports.makeCosmoshubPath = module.exports.isMsgWithdrawValidatorCommission = module.exports.isMsgWithdrawDelegatorReward = module.exports.isMsgUndelegate = module.exports.isMsgSetWithdrawAddress = module.exports.isMsgSend = module.exports.isMsgMultiSend = module.exports.isMsgFundCommunityPool = module.exports.isMsgEditValidator = module.exports.isMsgDelegate = module.exports.isMsgCreateValidator = module.exports.isMsgBeginRedelegate = module.exports.uint64ToString = module.exports.uint64ToNumber = module.exports.setupSupplyExtension = module.exports.setupStakingExtension = module.exports.setupSlashingExtension = module.exports.setupMintExtension = module.exports.setupGovExtension = module.exports.setupDistributionExtension = module.exports.setupBankExtension = module.exports.setupAuthExtension = module.exports.normalizePubkey = module.exports.normalizeLcdApiArray = module.exports.LcdClient = module.exports.BroadcastMode = module.exports.GasPrice = module.exports.buildFeeTable = module.exports.serializeSignDoc = module.exports.makeSignDoc = module.exports.isSearchByTagsQuery = module.exports.isSearchBySentFromOrToQuery = module.exports.isSearchByHeightQuery = module.exports.isBroadcastTxSuccess = module.exports.isBroadcastTxFailure = module.exports.CosmosClient = module.exports.assertIsBroadcastTxSuccess = module.exports.parseCoins = module.exports.coins = module.exports.coin = module.exports.rawSecp256k1PubkeyToAddress = module.exports.pubkeyToAddress = module.exports.logs = void 0;

const $1976b85824885300$var$logs = $1976b85824885300$var$__importStar((parcelRequire("P5pAj")));
module.exports.logs = $1976b85824885300$var$logs;

var $cF9EI = parcelRequire("cF9EI");
Object.defineProperty(module.exports, "pubkeyToAddress", {
    enumerable: true,
    get: function() {
        return $cF9EI.pubkeyToAddress;
    }
});
Object.defineProperty(module.exports, "rawSecp256k1PubkeyToAddress", {
    enumerable: true,
    get: function() {
        return $cF9EI.rawSecp256k1PubkeyToAddress;
    }
});

var $g8Jau = parcelRequire("g8Jau");
Object.defineProperty(module.exports, "coin", {
    enumerable: true,
    get: function() {
        return $g8Jau.coin;
    }
});
Object.defineProperty(module.exports, "coins", {
    enumerable: true,
    get: function() {
        return $g8Jau.coins;
    }
});
Object.defineProperty(module.exports, "parseCoins", {
    enumerable: true,
    get: function() {
        return $g8Jau.parseCoins;
    }
});

var $1CFPF = parcelRequire("1CFPF");
Object.defineProperty(module.exports, "assertIsBroadcastTxSuccess", {
    enumerable: true,
    get: function() {
        return $1CFPF.assertIsBroadcastTxSuccess;
    }
});
Object.defineProperty(module.exports, "CosmosClient", {
    enumerable: true,
    get: function() {
        return $1CFPF.CosmosClient;
    }
});
Object.defineProperty(module.exports, "isBroadcastTxFailure", {
    enumerable: true,
    get: function() {
        return $1CFPF.isBroadcastTxFailure;
    }
});
Object.defineProperty(module.exports, "isBroadcastTxSuccess", {
    enumerable: true,
    get: function() {
        return $1CFPF.isBroadcastTxSuccess;
    }
});
Object.defineProperty(module.exports, "isSearchByHeightQuery", {
    enumerable: true,
    get: function() {
        return $1CFPF.isSearchByHeightQuery;
    }
});
Object.defineProperty(module.exports, "isSearchBySentFromOrToQuery", {
    enumerable: true,
    get: function() {
        return $1CFPF.isSearchBySentFromOrToQuery;
    }
});
Object.defineProperty(module.exports, "isSearchByTagsQuery", {
    enumerable: true,
    get: function() {
        return $1CFPF.isSearchByTagsQuery;
    }
});

var $axITl = parcelRequire("axITl");
Object.defineProperty(module.exports, "makeSignDoc", {
    enumerable: true,
    get: function() {
        return $axITl.makeSignDoc;
    }
});
Object.defineProperty(module.exports, "serializeSignDoc", {
    enumerable: true,
    get: function() {
        return $axITl.serializeSignDoc;
    }
});

var $3adpy = parcelRequire("3adpy");
Object.defineProperty(module.exports, "buildFeeTable", {
    enumerable: true,
    get: function() {
        return $3adpy.buildFeeTable;
    }
});
Object.defineProperty(module.exports, "GasPrice", {
    enumerable: true,
    get: function() {
        return $3adpy.GasPrice;
    }
});

var $9XjFJ = parcelRequire("9XjFJ");
Object.defineProperty(module.exports, "BroadcastMode", {
    enumerable: true,
    get: function() {
        return $9XjFJ.BroadcastMode;
    }
});
Object.defineProperty(module.exports, "LcdClient", {
    enumerable: true,
    get: function() {
        return $9XjFJ.LcdClient;
    }
});
Object.defineProperty(module.exports, "normalizeLcdApiArray", {
    enumerable: true,
    get: function() {
        return $9XjFJ.normalizeLcdApiArray;
    }
});
Object.defineProperty(module.exports, "normalizePubkey", {
    enumerable: true,
    get: function() {
        return $9XjFJ.normalizePubkey;
    }
});
Object.defineProperty(module.exports, "setupAuthExtension", {
    enumerable: true,
    get: function() {
        return $9XjFJ.setupAuthExtension;
    }
});
Object.defineProperty(module.exports, "setupBankExtension", {
    enumerable: true,
    get: function() {
        return $9XjFJ.setupBankExtension;
    }
});
Object.defineProperty(module.exports, "setupDistributionExtension", {
    enumerable: true,
    get: function() {
        return $9XjFJ.setupDistributionExtension;
    }
});
Object.defineProperty(module.exports, "setupGovExtension", {
    enumerable: true,
    get: function() {
        return $9XjFJ.setupGovExtension;
    }
});
Object.defineProperty(module.exports, "setupMintExtension", {
    enumerable: true,
    get: function() {
        return $9XjFJ.setupMintExtension;
    }
});
Object.defineProperty(module.exports, "setupSlashingExtension", {
    enumerable: true,
    get: function() {
        return $9XjFJ.setupSlashingExtension;
    }
});
Object.defineProperty(module.exports, "setupStakingExtension", {
    enumerable: true,
    get: function() {
        return $9XjFJ.setupStakingExtension;
    }
});
Object.defineProperty(module.exports, "setupSupplyExtension", {
    enumerable: true,
    get: function() {
        return $9XjFJ.setupSupplyExtension;
    }
});
Object.defineProperty(module.exports, "uint64ToNumber", {
    enumerable: true,
    get: function() {
        return $9XjFJ.uint64ToNumber;
    }
});
Object.defineProperty(module.exports, "uint64ToString", {
    enumerable: true,
    get: function() {
        return $9XjFJ.uint64ToString;
    }
});

var $9dUam = parcelRequire("9dUam");
Object.defineProperty(module.exports, "isMsgBeginRedelegate", {
    enumerable: true,
    get: function() {
        return $9dUam.isMsgBeginRedelegate;
    }
});
Object.defineProperty(module.exports, "isMsgCreateValidator", {
    enumerable: true,
    get: function() {
        return $9dUam.isMsgCreateValidator;
    }
});
Object.defineProperty(module.exports, "isMsgDelegate", {
    enumerable: true,
    get: function() {
        return $9dUam.isMsgDelegate;
    }
});
Object.defineProperty(module.exports, "isMsgEditValidator", {
    enumerable: true,
    get: function() {
        return $9dUam.isMsgEditValidator;
    }
});
Object.defineProperty(module.exports, "isMsgFundCommunityPool", {
    enumerable: true,
    get: function() {
        return $9dUam.isMsgFundCommunityPool;
    }
});
Object.defineProperty(module.exports, "isMsgMultiSend", {
    enumerable: true,
    get: function() {
        return $9dUam.isMsgMultiSend;
    }
});
Object.defineProperty(module.exports, "isMsgSend", {
    enumerable: true,
    get: function() {
        return $9dUam.isMsgSend;
    }
});
Object.defineProperty(module.exports, "isMsgSetWithdrawAddress", {
    enumerable: true,
    get: function() {
        return $9dUam.isMsgSetWithdrawAddress;
    }
});
Object.defineProperty(module.exports, "isMsgUndelegate", {
    enumerable: true,
    get: function() {
        return $9dUam.isMsgUndelegate;
    }
});
Object.defineProperty(module.exports, "isMsgWithdrawDelegatorReward", {
    enumerable: true,
    get: function() {
        return $9dUam.isMsgWithdrawDelegatorReward;
    }
});
Object.defineProperty(module.exports, "isMsgWithdrawValidatorCommission", {
    enumerable: true,
    get: function() {
        return $9dUam.isMsgWithdrawValidatorCommission;
    }
});

var $iT2DG = parcelRequire("iT2DG");
Object.defineProperty(module.exports, "makeCosmoshubPath", {
    enumerable: true,
    get: function() {
        return $iT2DG.makeCosmoshubPath;
    }
});

var $7rDC2 = parcelRequire("7rDC2");
Object.defineProperty(module.exports, "decodeAminoPubkey", {
    enumerable: true,
    get: function() {
        return $7rDC2.decodeAminoPubkey;
    }
});
Object.defineProperty(module.exports, "decodeBech32Pubkey", {
    enumerable: true,
    get: function() {
        return $7rDC2.decodeBech32Pubkey;
    }
});
Object.defineProperty(module.exports, "encodeAminoPubkey", {
    enumerable: true,
    get: function() {
        return $7rDC2.encodeAminoPubkey;
    }
});
Object.defineProperty(module.exports, "encodeBech32Pubkey", {
    enumerable: true,
    get: function() {
        return $7rDC2.encodeBech32Pubkey;
    }
});
Object.defineProperty(module.exports, "encodeSecp256k1Pubkey", {
    enumerable: true,
    get: function() {
        return $7rDC2.encodeSecp256k1Pubkey;
    }
});

var $7DFKe = parcelRequire("7DFKe");
Object.defineProperty(module.exports, "findSequenceForSignedTx", {
    enumerable: true,
    get: function() {
        return $7DFKe.findSequenceForSignedTx;
    }
});

var $5QnXl = parcelRequire("5QnXl");
Object.defineProperty(module.exports, "encodeSecp256k1Signature", {
    enumerable: true,
    get: function() {
        return $5QnXl.encodeSecp256k1Signature;
    }
});
Object.defineProperty(module.exports, "decodeSignature", {
    enumerable: true,
    get: function() {
        return $5QnXl.decodeSignature;
    }
});

var $eG3rn = parcelRequire("eG3rn");
Object.defineProperty(module.exports, "SigningCosmosClient", {
    enumerable: true,
    get: function() {
        return $eG3rn.SigningCosmosClient;
    }
});

var $cfACW = parcelRequire("cfACW");
Object.defineProperty(module.exports, "isStdTx", {
    enumerable: true,
    get: function() {
        return $cfACW.isStdTx;
    }
});
Object.defineProperty(module.exports, "isWrappedStdTx", {
    enumerable: true,
    get: function() {
        return $cfACW.isWrappedStdTx;
    }
});
Object.defineProperty(module.exports, "makeStdTx", {
    enumerable: true,
    get: function() {
        return $cfACW.makeStdTx;
    }
});

var $dbARm = parcelRequire("dbARm");
Object.defineProperty(module.exports, "pubkeyType", {
    enumerable: true,
    get: function() {
        return $dbARm.pubkeyType;
    }
});

var $5xZH4 = parcelRequire("5xZH4");
Object.defineProperty(module.exports, "executeKdf", {
    enumerable: true,
    get: function() {
        return $5xZH4.executeKdf;
    }
});

var $jzhTI = parcelRequire("jzhTI");
Object.defineProperty(module.exports, "extractKdfConfiguration", {
    enumerable: true,
    get: function() {
        return $jzhTI.extractKdfConfiguration;
    }
});
Object.defineProperty(module.exports, "Secp256k1HdWallet", {
    enumerable: true,
    get: function() {
        return $jzhTI.Secp256k1HdWallet;
    }
});

var $8Rl4Z = parcelRequire("8Rl4Z");
Object.defineProperty(module.exports, "Secp256k1Wallet", {
    enumerable: true,
    get: function() {
        return $8Rl4Z.Secp256k1Wallet;
    }
});

});
parcelRequire.register("P5pAj", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.findAttribute = module.exports.parseLogs = module.exports.parseLog = module.exports.parseEvent = module.exports.parseAttribute = void 0;

var $gYZZP = parcelRequire("gYZZP");
function $0998f62d54b07917$var$parseAttribute(input) {
    if (!$gYZZP.isNonNullObject(input)) throw new Error("Attribute must be a non-null object");
    const { key: key, value: value } = input;
    if (typeof key !== "string" || !key) throw new Error("Attribute's key must be a non-empty string");
    if (typeof value !== "string" && typeof value !== "undefined") throw new Error("Attribute's value must be a string or unset");
    return {
        key: key,
        value: value || ""
    };
}
module.exports.parseAttribute = $0998f62d54b07917$var$parseAttribute;
function $0998f62d54b07917$var$parseEvent(input) {
    if (!$gYZZP.isNonNullObject(input)) throw new Error("Event must be a non-null object");
    const { type: type, attributes: attributes } = input;
    if (typeof type !== "string" || type === "") throw new Error(`Event type must be a non-empty string`);
    if (!Array.isArray(attributes)) throw new Error("Event's attributes must be an array");
    return {
        type: type,
        attributes: attributes.map($0998f62d54b07917$var$parseAttribute)
    };
}
module.exports.parseEvent = $0998f62d54b07917$var$parseEvent;
function $0998f62d54b07917$var$parseLog(input) {
    if (!$gYZZP.isNonNullObject(input)) throw new Error("Log must be a non-null object");
    const { msg_index: msg_index, log: log, events: events } = input;
    if (typeof msg_index !== "number") throw new Error("Log's msg_index must be a number");
    if (typeof log !== "string") throw new Error("Log's log must be a string");
    if (!Array.isArray(events)) throw new Error("Log's events must be an array");
    return {
        msg_index: msg_index,
        log: log,
        events: events.map($0998f62d54b07917$var$parseEvent)
    };
}
module.exports.parseLog = $0998f62d54b07917$var$parseLog;
function $0998f62d54b07917$var$parseLogs(input) {
    if (!Array.isArray(input)) throw new Error("Logs must be an array");
    return input.map($0998f62d54b07917$var$parseLog);
}
module.exports.parseLogs = $0998f62d54b07917$var$parseLogs;
/**
 * Searches in logs for the first event of the given event type and in that event
 * for the first first attribute with the given attribute key.
 *
 * Throws if the attribute was not found.
 */ function $0998f62d54b07917$var$findAttribute(logs, eventType, attrKey) {
    var _a;
    const firstLogs = logs.find(()=>true);
    const out = (_a = firstLogs === null || firstLogs === void 0 ? void 0 : firstLogs.events.find((event)=>event.type === eventType)) === null || _a === void 0 ? void 0 : _a.attributes.find((attr)=>attr.key === attrKey);
    if (!out) throw new Error(`Could not find attribute '${attrKey}' in first event of type '${eventType}' in first log.`);
    return out;
}
module.exports.findAttribute = $0998f62d54b07917$var$findAttribute;

});
parcelRequire.register("gYZZP", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.isUint8Array = module.exports.isNonNullObject = module.exports.sleep = module.exports.assertDefinedAndNotNull = module.exports.assertDefined = module.exports.assert = module.exports.arrayContentEquals = void 0;

var $69SK1 = parcelRequire("69SK1");
Object.defineProperty(module.exports, "arrayContentEquals", {
    enumerable: true,
    get: function() {
        return $69SK1.arrayContentEquals;
    }
});

var $gb4LH = parcelRequire("gb4LH");
Object.defineProperty(module.exports, "assert", {
    enumerable: true,
    get: function() {
        return $gb4LH.assert;
    }
});
Object.defineProperty(module.exports, "assertDefined", {
    enumerable: true,
    get: function() {
        return $gb4LH.assertDefined;
    }
});
Object.defineProperty(module.exports, "assertDefinedAndNotNull", {
    enumerable: true,
    get: function() {
        return $gb4LH.assertDefinedAndNotNull;
    }
});

var $1Pn8P = parcelRequire("1Pn8P");
Object.defineProperty(module.exports, "sleep", {
    enumerable: true,
    get: function() {
        return $1Pn8P.sleep;
    }
});

var $JaMv6 = parcelRequire("JaMv6");
Object.defineProperty(module.exports, "isNonNullObject", {
    enumerable: true,
    get: function() {
        return $JaMv6.isNonNullObject;
    }
});
Object.defineProperty(module.exports, "isUint8Array", {
    enumerable: true,
    get: function() {
        return $JaMv6.isUint8Array;
    }
});

});
parcelRequire.register("69SK1", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.arrayContentEquals = void 0;
/**
 * Compares the content of two arrays-like objects for equality.
 *
 * Equality is defined as having equal length and element values, where element equality means `===` returning `true`.
 *
 * This allows you to compare the content of a Buffer, Uint8Array or number[], ignoring the specific type.
 * As a consequence, this returns different results than Jasmine's `toEqual`, which ensures elements have the same type.
 */ function $47be0bcc5976eed9$var$arrayContentEquals(a, b) {
    if (a.length !== b.length) return false;
    for(let i = 0; i < a.length; ++i){
        if (a[i] !== b[i]) return false;
    }
    return true;
}
module.exports.arrayContentEquals = $47be0bcc5976eed9$var$arrayContentEquals;

});

parcelRequire.register("gb4LH", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.assertDefinedAndNotNull = module.exports.assertDefined = module.exports.assert = void 0;
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
function $bc715f53fc9438b9$var$assert(condition, msg) {
    if (!condition) throw new Error(msg || "condition is not truthy");
}
module.exports.assert = $bc715f53fc9438b9$var$assert;
function $bc715f53fc9438b9$var$assertDefined(value, msg) {
    if (value === undefined) throw new Error(msg !== null && msg !== void 0 ? msg : "value is undefined");
}
module.exports.assertDefined = $bc715f53fc9438b9$var$assertDefined;
function $bc715f53fc9438b9$var$assertDefinedAndNotNull(value, msg) {
    if (value === undefined || value === null) throw new Error(msg !== null && msg !== void 0 ? msg : "value is undefined or null");
}
module.exports.assertDefinedAndNotNull = $bc715f53fc9438b9$var$assertDefinedAndNotNull;

});

parcelRequire.register("1Pn8P", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.sleep = void 0;
async function $154c8147b80b7392$var$sleep(ms) {
    return new Promise((resolve)=>setTimeout(resolve, ms));
}
module.exports.sleep = $154c8147b80b7392$var$sleep;

});

parcelRequire.register("JaMv6", function(module, exports) {

var $ihoyg = parcelRequire("ihoyg");
var $087c910504f2f675$require$Buffer = $ihoyg.Buffer;
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.isUint8Array = module.exports.isNonNullObject = void 0;
/**
 * Checks if data is a non-null object (i.e. matches the TypeScript object type).
 *
 * Note: this returns true for arrays, which are objects in JavaScript
 * even though array and object are different types in JSON.
 *
 * @see https://www.typescriptlang.org/docs/handbook/basic-types.html#object
 */ // eslint-disable-next-line @typescript-eslint/ban-types
function $087c910504f2f675$var$isNonNullObject(data) {
    return typeof data === "object" && data !== null;
}
module.exports.isNonNullObject = $087c910504f2f675$var$isNonNullObject;
/**
 * Checks if data is an Uint8Array. Note: Buffer is treated as not a Uint8Array
 */ function $087c910504f2f675$var$isUint8Array(data) {
    if (!$087c910504f2f675$var$isNonNullObject(data)) return false;
    // Avoid instanceof check which is unreliable in some JS environments
    // https://medium.com/@simonwarta/limitations-of-the-instanceof-operator-f4bcdbe7a400
    // Use check that was discussed in https://github.com/crypto-browserify/pbkdf2/pull/81
    if (Object.prototype.toString.call(data) !== "[object Uint8Array]") return false;
    if (typeof $087c910504f2f675$require$Buffer !== "undefined" && typeof $087c910504f2f675$require$Buffer.isBuffer !== "undefined") {
        // Buffer.isBuffer is available at runtime
        if ($087c910504f2f675$require$Buffer.isBuffer(data)) return false;
    }
    return true;
}
module.exports.isUint8Array = $087c910504f2f675$var$isUint8Array;

});



parcelRequire.register("cF9EI", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.pubkeyToAddress = module.exports.rawSecp256k1PubkeyToAddress = void 0;

var $3cQ9Q = parcelRequire("3cQ9Q");

var $5a6Ix = parcelRequire("5a6Ix");

var $dbARm = parcelRequire("dbARm");
function $9380cdcf55e87fa2$var$rawSecp256k1PubkeyToAddress(pubkeyRaw, prefix) {
    if (pubkeyRaw.length !== 33) throw new Error(`Invalid Secp256k1 pubkey length (compressed): ${pubkeyRaw.length}`);
    const hash1 = $3cQ9Q.sha256(pubkeyRaw);
    const hash2 = $3cQ9Q.ripemd160(hash1);
    return $5a6Ix.Bech32.encode(prefix, hash2);
}
module.exports.rawSecp256k1PubkeyToAddress = $9380cdcf55e87fa2$var$rawSecp256k1PubkeyToAddress;
// See https://github.com/tendermint/tendermint/blob/f2ada0a604b4c0763bda2f64fac53d506d3beca7/docs/spec/blockchain/encoding.md#public-key-cryptography
// This assumes we already have a cosmos-compressed pubkey
function $9380cdcf55e87fa2$var$pubkeyToAddress(pubkey, prefix) {
    const pubkeyBytes = $5a6Ix.fromBase64(pubkey.value);
    switch(pubkey.type){
        case $dbARm.pubkeyType.secp256k1:
            return $9380cdcf55e87fa2$var$rawSecp256k1PubkeyToAddress(pubkeyBytes, prefix);
        case $dbARm.pubkeyType.ed25519:
            {
                if (pubkeyBytes.length !== 32) throw new Error(`Invalid Ed25519 pubkey length: ${pubkeyBytes.length}`);
                const hash = $3cQ9Q.sha256(pubkeyBytes);
                return $5a6Ix.Bech32.encode(prefix, hash.slice(0, 20));
            }
        case $dbARm.pubkeyType.sr25519:
            {
                if (pubkeyBytes.length !== 32) throw new Error(`Invalid Sr25519 pubkey length: ${pubkeyBytes.length}`);
                const hash = $3cQ9Q.sha256(pubkeyBytes);
                return $5a6Ix.Bech32.encode(prefix, hash.slice(0, 20));
            }
        default:
            throw new Error("Unrecognized public key algorithm");
    }
}
module.exports.pubkeyToAddress = $9380cdcf55e87fa2$var$pubkeyToAddress;

});
parcelRequire.register("3cQ9Q", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.slip10CurveFromString = module.exports.Slip10RawIndex = module.exports.Slip10Curve = module.exports.Slip10 = module.exports.stringToPath = module.exports.pathToString = module.exports.sha512 = module.exports.Sha512 = module.exports.sha256 = module.exports.Sha256 = module.exports.sha1 = module.exports.Sha1 = module.exports.Secp256k1Signature = module.exports.ExtendedSecp256k1Signature = module.exports.Secp256k1 = module.exports.ripemd160 = module.exports.Ripemd160 = module.exports.Random = module.exports.Ed25519Keypair = module.exports.Ed25519 = module.exports.isArgon2idOptions = module.exports.Argon2id = module.exports.xchacha20NonceLength = module.exports.Xchacha20poly1305Ietf = module.exports.keccak256 = module.exports.Keccak256 = module.exports.Hmac = module.exports.EnglishMnemonic = module.exports.Bip39 = void 0;

var $jxpsK = parcelRequire("jxpsK");
Object.defineProperty(module.exports, "Bip39", {
    enumerable: true,
    get: function() {
        return $jxpsK.Bip39;
    }
});

var $3DiD3 = parcelRequire("3DiD3");
Object.defineProperty(module.exports, "EnglishMnemonic", {
    enumerable: true,
    get: function() {
        return $3DiD3.EnglishMnemonic;
    }
});

var $7hF4v = parcelRequire("7hF4v");
Object.defineProperty(module.exports, "Hmac", {
    enumerable: true,
    get: function() {
        return $7hF4v.Hmac;
    }
});

var $aeAO9 = parcelRequire("aeAO9");
Object.defineProperty(module.exports, "Keccak256", {
    enumerable: true,
    get: function() {
        return $aeAO9.Keccak256;
    }
});
Object.defineProperty(module.exports, "keccak256", {
    enumerable: true,
    get: function() {
        return $aeAO9.keccak256;
    }
});

var $g6P68 = parcelRequire("g6P68");
Object.defineProperty(module.exports, "Xchacha20poly1305Ietf", {
    enumerable: true,
    get: function() {
        return $g6P68.Xchacha20poly1305Ietf;
    }
});
Object.defineProperty(module.exports, "xchacha20NonceLength", {
    enumerable: true,
    get: function() {
        return $g6P68.xchacha20NonceLength;
    }
});
Object.defineProperty(module.exports, "Argon2id", {
    enumerable: true,
    get: function() {
        return $g6P68.Argon2id;
    }
});
Object.defineProperty(module.exports, "isArgon2idOptions", {
    enumerable: true,
    get: function() {
        return $g6P68.isArgon2idOptions;
    }
});
Object.defineProperty(module.exports, "Ed25519", {
    enumerable: true,
    get: function() {
        return $g6P68.Ed25519;
    }
});
Object.defineProperty(module.exports, "Ed25519Keypair", {
    enumerable: true,
    get: function() {
        return $g6P68.Ed25519Keypair;
    }
});

var $92Wnp = parcelRequire("92Wnp");
Object.defineProperty(module.exports, "Random", {
    enumerable: true,
    get: function() {
        return $92Wnp.Random;
    }
});

var $88X8r = parcelRequire("88X8r");
Object.defineProperty(module.exports, "Ripemd160", {
    enumerable: true,
    get: function() {
        return $88X8r.Ripemd160;
    }
});
Object.defineProperty(module.exports, "ripemd160", {
    enumerable: true,
    get: function() {
        return $88X8r.ripemd160;
    }
});

var $b0p5V = parcelRequire("b0p5V");
Object.defineProperty(module.exports, "Secp256k1", {
    enumerable: true,
    get: function() {
        return $b0p5V.Secp256k1;
    }
});

var $g8uts = parcelRequire("g8uts");
Object.defineProperty(module.exports, "ExtendedSecp256k1Signature", {
    enumerable: true,
    get: function() {
        return $g8uts.ExtendedSecp256k1Signature;
    }
});
Object.defineProperty(module.exports, "Secp256k1Signature", {
    enumerable: true,
    get: function() {
        return $g8uts.Secp256k1Signature;
    }
});

var $1tSAh = parcelRequire("1tSAh");
Object.defineProperty(module.exports, "Sha1", {
    enumerable: true,
    get: function() {
        return $1tSAh.Sha1;
    }
});
Object.defineProperty(module.exports, "sha1", {
    enumerable: true,
    get: function() {
        return $1tSAh.sha1;
    }
});
Object.defineProperty(module.exports, "Sha256", {
    enumerable: true,
    get: function() {
        return $1tSAh.Sha256;
    }
});
Object.defineProperty(module.exports, "sha256", {
    enumerable: true,
    get: function() {
        return $1tSAh.sha256;
    }
});
Object.defineProperty(module.exports, "Sha512", {
    enumerable: true,
    get: function() {
        return $1tSAh.Sha512;
    }
});
Object.defineProperty(module.exports, "sha512", {
    enumerable: true,
    get: function() {
        return $1tSAh.sha512;
    }
});

var $gZgao = parcelRequire("gZgao");
Object.defineProperty(module.exports, "pathToString", {
    enumerable: true,
    get: function() {
        return $gZgao.pathToString;
    }
});
Object.defineProperty(module.exports, "stringToPath", {
    enumerable: true,
    get: function() {
        return $gZgao.stringToPath;
    }
});
Object.defineProperty(module.exports, "Slip10", {
    enumerable: true,
    get: function() {
        return $gZgao.Slip10;
    }
});
Object.defineProperty(module.exports, "Slip10Curve", {
    enumerable: true,
    get: function() {
        return $gZgao.Slip10Curve;
    }
});
Object.defineProperty(module.exports, "Slip10RawIndex", {
    enumerable: true,
    get: function() {
        return $gZgao.Slip10RawIndex;
    }
});
Object.defineProperty(module.exports, "slip10CurveFromString", {
    enumerable: true,
    get: function() {
        return $gZgao.slip10CurveFromString;
    }
});

});
parcelRequire.register("jxpsK", function(module, exports) {
"use strict";
var $e394d9bb2590d003$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, {
        enumerable: true,
        get: function() {
            return m[k];
        }
    });
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $e394d9bb2590d003$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $e394d9bb2590d003$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $e394d9bb2590d003$var$__createBinding(result, mod, k);
    }
    $e394d9bb2590d003$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Bip39 = void 0;

var $5a6Ix = parcelRequire("5a6Ix");

const $e394d9bb2590d003$var$bip39 = $e394d9bb2590d003$var$__importStar((parcelRequire("5qnT8")));

var $1UZ5c = parcelRequire("1UZ5c");

const $e394d9bb2590d003$var$unorm = $e394d9bb2590d003$var$__importStar((parcelRequire("74K3y")));

var $3DiD3 = parcelRequire("3DiD3");
class $e394d9bb2590d003$var$Bip39 {
    /**
     * Encodes raw entropy of length 16, 20, 24, 28 or 32 bytes as an English mnemonic between 12 and 24 words.
     *
     * | Entropy            | Words |
     * |--------------------|-------|
     * | 128 bit (16 bytes) |    12 |
     * | 160 bit (20 bytes) |    15 |
     * | 192 bit (24 bytes) |    18 |
     * | 224 bit (28 bytes) |    21 |
     * | 256 bit (32 bytes) |    24 |
     *
     *
     * @see https://github.com/bitcoin/bips/blob/master/bip-0039.mediawiki#generating-the-mnemonic
     * @param entropy The entropy to be encoded. This must be cryptographically secure.
     */ static encode(entropy) {
        const allowedEntropyLengths = [
            16,
            20,
            24,
            28,
            32
        ];
        if (allowedEntropyLengths.indexOf(entropy.length) === -1) throw new Error("invalid input length");
        return new $3DiD3.EnglishMnemonic($e394d9bb2590d003$var$bip39.entropyToMnemonic($5a6Ix.toHex(entropy)));
    }
    static decode(mnemonic) {
        return $5a6Ix.fromHex($e394d9bb2590d003$var$bip39.mnemonicToEntropy(mnemonic.toString()));
    }
    static async mnemonicToSeed(mnemonic, password) {
        // reimplementation of bip39.mnemonicToSeed using the asynchronous
        // interface of https://www.npmjs.com/package/pbkdf2
        const mnemonicBytes = $5a6Ix.toUtf8($e394d9bb2590d003$var$unorm.nfkd(mnemonic.toString()));
        const salt = "mnemonic" + (password ? $e394d9bb2590d003$var$unorm.nfkd(password) : "");
        const saltBytes = $5a6Ix.toUtf8(salt);
        return this.pbkdf2(mnemonicBytes, saltBytes, 2048, 64, "sha512");
    }
    // convert pbkdf2's callback interface to Promise interface
    static async pbkdf2(secret, salt, iterations, keylen, digest) {
        return new Promise((resolve, reject)=>{
            $1UZ5c.pbkdf2(secret, salt, iterations, keylen, digest, (err, derivedKey)=>{
                if (err) reject(err);
                else resolve(new Uint8Array(derivedKey));
            });
        });
    }
}
module.exports.Bip39 = $e394d9bb2590d003$var$Bip39;

});
parcelRequire.register("5a6Ix", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.toUtf8 = module.exports.fromUtf8 = module.exports.toRfc3339 = module.exports.fromRfc3339 = module.exports.toHex = module.exports.fromHex = module.exports.Bech32 = module.exports.toBase64 = module.exports.fromBase64 = module.exports.toAscii = module.exports.fromAscii = void 0;

var $2xoQe = parcelRequire("2xoQe");
Object.defineProperty(module.exports, "fromAscii", {
    enumerable: true,
    get: function() {
        return $2xoQe.fromAscii;
    }
});
Object.defineProperty(module.exports, "toAscii", {
    enumerable: true,
    get: function() {
        return $2xoQe.toAscii;
    }
});

var $b8ot3 = parcelRequire("b8ot3");
Object.defineProperty(module.exports, "fromBase64", {
    enumerable: true,
    get: function() {
        return $b8ot3.fromBase64;
    }
});
Object.defineProperty(module.exports, "toBase64", {
    enumerable: true,
    get: function() {
        return $b8ot3.toBase64;
    }
});

var $amTR9 = parcelRequire("amTR9");
Object.defineProperty(module.exports, "Bech32", {
    enumerable: true,
    get: function() {
        return $amTR9.Bech32;
    }
});

var $khCjc = parcelRequire("khCjc");
Object.defineProperty(module.exports, "fromHex", {
    enumerable: true,
    get: function() {
        return $khCjc.fromHex;
    }
});
Object.defineProperty(module.exports, "toHex", {
    enumerable: true,
    get: function() {
        return $khCjc.toHex;
    }
});

var $ktY5c = parcelRequire("ktY5c");
Object.defineProperty(module.exports, "fromRfc3339", {
    enumerable: true,
    get: function() {
        return $ktY5c.fromRfc3339;
    }
});
Object.defineProperty(module.exports, "toRfc3339", {
    enumerable: true,
    get: function() {
        return $ktY5c.toRfc3339;
    }
});

var $g4SlF = parcelRequire("g4SlF");
Object.defineProperty(module.exports, "fromUtf8", {
    enumerable: true,
    get: function() {
        return $g4SlF.fromUtf8;
    }
});
Object.defineProperty(module.exports, "toUtf8", {
    enumerable: true,
    get: function() {
        return $g4SlF.toUtf8;
    }
});

});
parcelRequire.register("2xoQe", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.fromAscii = module.exports.toAscii = void 0;
function $1d91eed78ec22dfd$var$toAscii(input) {
    const toNums = (str)=>str.split("").map((x)=>{
            const charCode = x.charCodeAt(0);
            // 0x00–0x1F control characters
            // 0x20–0x7E printable characters
            // 0x7F delete character
            // 0x80–0xFF out of 7 bit ascii range
            if (charCode < 0x20 || charCode > 0x7e) throw new Error("Cannot encode character that is out of printable ASCII range: " + charCode);
            return charCode;
        });
    return Uint8Array.from(toNums(input));
}
module.exports.toAscii = $1d91eed78ec22dfd$var$toAscii;
function $1d91eed78ec22dfd$var$fromAscii(data) {
    const fromNums = (listOfNumbers)=>listOfNumbers.map((x)=>{
            // 0x00–0x1F control characters
            // 0x20–0x7E printable characters
            // 0x7F delete character
            // 0x80–0xFF out of 7 bit ascii range
            if (x < 0x20 || x > 0x7e) throw new Error("Cannot decode character that is out of printable ASCII range: " + x);
            return String.fromCharCode(x);
        });
    return fromNums(Array.from(data)).join("");
}
module.exports.fromAscii = $1d91eed78ec22dfd$var$fromAscii;

});

parcelRequire.register("b8ot3", function(module, exports) {
"use strict";
var $81b36bce31c67328$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, {
        enumerable: true,
        get: function() {
            return m[k];
        }
    });
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $81b36bce31c67328$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $81b36bce31c67328$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $81b36bce31c67328$var$__createBinding(result, mod, k);
    }
    $81b36bce31c67328$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.fromBase64 = module.exports.toBase64 = void 0;

const $81b36bce31c67328$var$base64js = $81b36bce31c67328$var$__importStar((parcelRequire("hqZtu")));
function $81b36bce31c67328$var$toBase64(data) {
    return $81b36bce31c67328$var$base64js.fromByteArray(data);
}
module.exports.toBase64 = $81b36bce31c67328$var$toBase64;
function $81b36bce31c67328$var$fromBase64(base64String) {
    if (!base64String.match(/^[a-zA-Z0-9+/]*={0,2}$/)) throw new Error("Invalid base64 string format");
    return $81b36bce31c67328$var$base64js.toByteArray(base64String);
}
module.exports.fromBase64 = $81b36bce31c67328$var$fromBase64;

});

parcelRequire.register("amTR9", function(module, exports) {
"use strict";
var $78c7495ef607796f$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, {
        enumerable: true,
        get: function() {
            return m[k];
        }
    });
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $78c7495ef607796f$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $78c7495ef607796f$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $78c7495ef607796f$var$__createBinding(result, mod, k);
    }
    $78c7495ef607796f$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Bech32 = void 0;

const $78c7495ef607796f$var$bech32 = $78c7495ef607796f$var$__importStar((parcelRequire("5wgCY")));
class $78c7495ef607796f$var$Bech32 {
    static encode(prefix, data, limit) {
        const address = $78c7495ef607796f$var$bech32.encode(prefix, $78c7495ef607796f$var$bech32.toWords(data), limit);
        return address;
    }
    static decode(address, limit = Infinity) {
        const decodedAddress = $78c7495ef607796f$var$bech32.decode(address, limit);
        return {
            prefix: decodedAddress.prefix,
            data: new Uint8Array($78c7495ef607796f$var$bech32.fromWords(decodedAddress.words))
        };
    }
}
module.exports.Bech32 = $78c7495ef607796f$var$Bech32;

});

parcelRequire.register("khCjc", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.fromHex = module.exports.toHex = void 0;
function $ec431c81fae52a65$var$toHex(data) {
    let out = "";
    for (const byte of data)out += ("0" + byte.toString(16)).slice(-2);
    return out;
}
module.exports.toHex = $ec431c81fae52a65$var$toHex;
function $ec431c81fae52a65$var$fromHex(hexstring) {
    if (hexstring.length % 2 !== 0) throw new Error("hex string length must be a multiple of 2");
    const listOfInts = [];
    for(let i = 0; i < hexstring.length; i += 2){
        const hexByteAsString = hexstring.substr(i, 2);
        if (!hexByteAsString.match(/[0-9a-f]{2}/i)) throw new Error("hex string contains invalid characters");
        listOfInts.push(parseInt(hexByteAsString, 16));
    }
    return new Uint8Array(listOfInts);
}
module.exports.fromHex = $ec431c81fae52a65$var$fromHex;

});

parcelRequire.register("ktY5c", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.toRfc3339 = module.exports.fromRfc3339 = void 0;
const $ee951f4460c21dc0$var$rfc3339Matcher = /^(\d{4})-(\d{2})-(\d{2})[T ](\d{2}):(\d{2}):(\d{2})(\.\d{1,9})?((?:[+-]\d{2}:\d{2})|Z)$/;
function $ee951f4460c21dc0$var$padded(integer, length = 2) {
    const filled = "00000" + integer.toString();
    return filled.substring(filled.length - length);
}
function $ee951f4460c21dc0$var$fromRfc3339(str) {
    const matches = $ee951f4460c21dc0$var$rfc3339Matcher.exec(str);
    if (!matches) throw new Error("Date string is not in RFC3339 format");
    const year = +matches[1];
    const month = +matches[2];
    const day = +matches[3];
    const hour = +matches[4];
    const minute = +matches[5];
    const second = +matches[6];
    // fractional seconds match either undefined or a string like ".1", ".123456789"
    const milliSeconds = matches[7] ? Math.floor(+matches[7] * 1000) : 0;
    let tzOffsetSign;
    let tzOffsetHours;
    let tzOffsetMinutes;
    // if timezone is undefined, it must be Z or nothing (otherwise the group would have captured).
    if (matches[8] === "Z") {
        tzOffsetSign = 1;
        tzOffsetHours = 0;
        tzOffsetMinutes = 0;
    } else {
        tzOffsetSign = matches[8].substring(0, 1) === "-" ? -1 : 1;
        tzOffsetHours = +matches[8].substring(1, 3);
        tzOffsetMinutes = +matches[8].substring(4, 6);
    }
    const tzOffset = tzOffsetSign * (tzOffsetHours * 60 + tzOffsetMinutes) * 60; // seconds
    const timestamp = Date.UTC(year, month - 1, day, hour, minute, second, milliSeconds) - tzOffset * 1000;
    return new Date(timestamp);
}
module.exports.fromRfc3339 = $ee951f4460c21dc0$var$fromRfc3339;
function $ee951f4460c21dc0$var$toRfc3339(date) {
    const year = date.getUTCFullYear();
    const month = $ee951f4460c21dc0$var$padded(date.getUTCMonth() + 1);
    const day = $ee951f4460c21dc0$var$padded(date.getUTCDate());
    const hour = $ee951f4460c21dc0$var$padded(date.getUTCHours());
    const minute = $ee951f4460c21dc0$var$padded(date.getUTCMinutes());
    const second = $ee951f4460c21dc0$var$padded(date.getUTCSeconds());
    const ms = $ee951f4460c21dc0$var$padded(date.getUTCMilliseconds(), 3);
    return `${year}-${month}-${day}T${hour}:${minute}:${second}.${ms}Z`;
}
module.exports.toRfc3339 = $ee951f4460c21dc0$var$toRfc3339;

});

parcelRequire.register("g4SlF", function(module, exports) {

var $ihoyg = parcelRequire("ihoyg");
var $bb472d86377299ed$require$Buffer = $ihoyg.Buffer;
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.fromUtf8 = module.exports.toUtf8 = void 0;
function $bb472d86377299ed$var$isValidUtf8(data) {
    const toStringAndBack = $bb472d86377299ed$require$Buffer.from($bb472d86377299ed$require$Buffer.from(data).toString("utf8"), "utf8");
    return $bb472d86377299ed$require$Buffer.compare($bb472d86377299ed$require$Buffer.from(data), toStringAndBack) === 0;
}
function $bb472d86377299ed$var$toUtf8(str) {
    // Browser and future nodejs (https://github.com/nodejs/node/issues/20365)
    if (typeof TextEncoder !== "undefined") return new TextEncoder().encode(str);
    // Use Buffer hack instead of nodejs util.TextEncoder to ensure
    // webpack does not bundle the util module for browsers.
    return new Uint8Array($bb472d86377299ed$require$Buffer.from(str, "utf8"));
}
module.exports.toUtf8 = $bb472d86377299ed$var$toUtf8;
function $bb472d86377299ed$var$fromUtf8(data) {
    // Browser and future nodejs (https://github.com/nodejs/node/issues/20365)
    if (typeof TextDecoder !== "undefined") return new TextDecoder("utf-8", {
        fatal: true
    }).decode(data);
    // Use Buffer hack instead of nodejs util.TextDecoder to ensure
    // webpack does not bundle the util module for browsers.
    // Buffer.toString has no fatal option
    if (!$bb472d86377299ed$var$isValidUtf8(data)) throw new Error("Invalid UTF8 data");
    return $bb472d86377299ed$require$Buffer.from(data).toString("utf8");
}
module.exports.fromUtf8 = $bb472d86377299ed$var$fromUtf8;

});


parcelRequire.register("74K3y", function(module, exports) {
(function(root) {
    "use strict";
    /***** unorm.js *****/ /*
 * UnicodeNormalizer 1.0.0
 * Copyright (c) 2008 Matsuza
 * Dual licensed under the MIT (MIT-LICENSE.txt) and GPL (GPL-LICENSE.txt) licenses.
 * $Date: 2008-06-05 16:44:17 +0200 (Thu, 05 Jun 2008) $
 * $Rev: 13309 $
 */ var DEFAULT_FEATURE = [
        null,
        0,
        {}
    ];
    var CACHE_THRESHOLD = 10;
    var SBase = 0xAC00, LBase = 0x1100, VBase = 0x1161, TBase = 0x11A7, LCount = 19, VCount = 21, TCount = 28;
    var NCount = VCount * TCount; // 588
    var SCount = LCount * NCount; // 11172
    var UChar = function(cp, feature) {
        this.codepoint = cp;
        this.feature = feature;
    };
    // Strategies
    var cache = {};
    var cacheCounter = [];
    for(var i = 0; i <= 0xFF; ++i)cacheCounter[i] = 0;
    function fromCache(next, cp, needFeature) {
        var ret = cache[cp];
        if (!ret) {
            ret = next(cp, needFeature);
            if (!!ret.feature && ++cacheCounter[cp >> 8 & 0xFF] > CACHE_THRESHOLD) cache[cp] = ret;
        }
        return ret;
    }
    function fromData(next, cp, needFeature) {
        var hash = cp & 0xFF00;
        var dunit = UChar.udata[hash] || {};
        var f = dunit[cp];
        return f ? new UChar(cp, f) : new UChar(cp, DEFAULT_FEATURE);
    }
    function fromCpOnly(next, cp, needFeature) {
        return !!needFeature ? next(cp, needFeature) : new UChar(cp, null);
    }
    function fromRuleBasedJamo(next, cp, needFeature) {
        var j;
        if (cp < LBase || LBase + LCount <= cp && cp < SBase || SBase + SCount < cp) return next(cp, needFeature);
        if (LBase <= cp && cp < LBase + LCount) {
            var c = {};
            var base = (cp - LBase) * VCount;
            for(j = 0; j < VCount; ++j)c[VBase + j] = SBase + TCount * (j + base);
            return new UChar(cp, [
                ,
                ,
                c
            ]);
        }
        var SIndex = cp - SBase;
        var TIndex = SIndex % TCount;
        var feature = [];
        if (TIndex !== 0) feature[0] = [
            SBase + SIndex - TIndex,
            TBase + TIndex
        ];
        else {
            feature[0] = [
                LBase + Math.floor(SIndex / NCount),
                VBase + Math.floor(SIndex % NCount / TCount)
            ];
            feature[2] = {};
            for(j = 1; j < TCount; ++j)feature[2][TBase + j] = cp + j;
        }
        return new UChar(cp, feature);
    }
    function fromCpFilter(next, cp, needFeature) {
        return cp < 60 || 13311 < cp && cp < 42607 ? new UChar(cp, DEFAULT_FEATURE) : next(cp, needFeature);
    }
    var strategies = [
        fromCpFilter,
        fromCache,
        fromCpOnly,
        fromRuleBasedJamo,
        fromData
    ];
    UChar.fromCharCode = strategies.reduceRight(function(next, strategy) {
        return function(cp, needFeature) {
            return strategy(next, cp, needFeature);
        };
    }, null);
    UChar.isHighSurrogate = function(cp) {
        return cp >= 0xD800 && cp <= 0xDBFF;
    };
    UChar.isLowSurrogate = function(cp) {
        return cp >= 0xDC00 && cp <= 0xDFFF;
    };
    UChar.prototype.prepFeature = function() {
        if (!this.feature) this.feature = UChar.fromCharCode(this.codepoint, true).feature;
    };
    UChar.prototype.toString = function() {
        if (this.codepoint < 0x10000) return String.fromCharCode(this.codepoint);
        else {
            var x = this.codepoint - 0x10000;
            return String.fromCharCode(Math.floor(x / 0x400) + 0xD800, x % 0x400 + 0xDC00);
        }
    };
    UChar.prototype.getDecomp = function() {
        this.prepFeature();
        return this.feature[0] || null;
    };
    UChar.prototype.isCompatibility = function() {
        this.prepFeature();
        return !!this.feature[1] && this.feature[1] & 256;
    };
    UChar.prototype.isExclude = function() {
        this.prepFeature();
        return !!this.feature[1] && this.feature[1] & 512;
    };
    UChar.prototype.getCanonicalClass = function() {
        this.prepFeature();
        return !!this.feature[1] ? this.feature[1] & 0xff : 0;
    };
    UChar.prototype.getComposite = function(following) {
        this.prepFeature();
        if (!this.feature[2]) return null;
        var cp = this.feature[2][following.codepoint];
        return cp ? UChar.fromCharCode(cp) : null;
    };
    var UCharIterator = function(str) {
        this.str = str;
        this.cursor = 0;
    };
    UCharIterator.prototype.next = function() {
        if (!!this.str && this.cursor < this.str.length) {
            var cp = this.str.charCodeAt(this.cursor++);
            var d;
            if (UChar.isHighSurrogate(cp) && this.cursor < this.str.length && UChar.isLowSurrogate(d = this.str.charCodeAt(this.cursor))) {
                cp = (cp - 0xD800) * 0x400 + (d - 0xDC00) + 0x10000;
                ++this.cursor;
            }
            return UChar.fromCharCode(cp);
        } else {
            this.str = null;
            return null;
        }
    };
    var RecursDecompIterator = function(it, cano) {
        this.it = it;
        this.canonical = cano;
        this.resBuf = [];
    };
    RecursDecompIterator.prototype.next = function() {
        function recursiveDecomp(cano, uchar) {
            var decomp = uchar.getDecomp();
            if (!!decomp && !(cano && uchar.isCompatibility())) {
                var ret = [];
                for(var i = 0; i < decomp.length; ++i){
                    var a = recursiveDecomp(cano, UChar.fromCharCode(decomp[i]));
                    ret = ret.concat(a);
                }
                return ret;
            } else return [
                uchar
            ];
        }
        if (this.resBuf.length === 0) {
            var uchar = this.it.next();
            if (!uchar) return null;
            this.resBuf = recursiveDecomp(this.canonical, uchar);
        }
        return this.resBuf.shift();
    };
    var DecompIterator = function(it) {
        this.it = it;
        this.resBuf = [];
    };
    DecompIterator.prototype.next = function() {
        var cc;
        if (this.resBuf.length === 0) do {
            var uchar = this.it.next();
            if (!uchar) break;
            cc = uchar.getCanonicalClass();
            var inspt = this.resBuf.length;
            if (cc !== 0) for(; inspt > 0; --inspt){
                var uchar2 = this.resBuf[inspt - 1];
                var cc2 = uchar2.getCanonicalClass();
                if (cc2 <= cc) break;
            }
            this.resBuf.splice(inspt, 0, uchar);
        }while (cc !== 0);
        return this.resBuf.shift();
    };
    var CompIterator = function(it) {
        this.it = it;
        this.procBuf = [];
        this.resBuf = [];
        this.lastClass = null;
    };
    CompIterator.prototype.next = function() {
        while(this.resBuf.length === 0){
            var uchar = this.it.next();
            if (!uchar) {
                this.resBuf = this.procBuf;
                this.procBuf = [];
                break;
            }
            if (this.procBuf.length === 0) {
                this.lastClass = uchar.getCanonicalClass();
                this.procBuf.push(uchar);
            } else {
                var starter = this.procBuf[0];
                var composite = starter.getComposite(uchar);
                var cc = uchar.getCanonicalClass();
                if (!!composite && (this.lastClass < cc || this.lastClass === 0)) this.procBuf[0] = composite;
                else {
                    if (cc === 0) {
                        this.resBuf = this.procBuf;
                        this.procBuf = [];
                    }
                    this.lastClass = cc;
                    this.procBuf.push(uchar);
                }
            }
        }
        return this.resBuf.shift();
    };
    var createIterator = function(mode, str) {
        switch(mode){
            case "NFD":
                return new DecompIterator(new RecursDecompIterator(new UCharIterator(str), true));
            case "NFKD":
                return new DecompIterator(new RecursDecompIterator(new UCharIterator(str), false));
            case "NFC":
                return new CompIterator(new DecompIterator(new RecursDecompIterator(new UCharIterator(str), true)));
            case "NFKC":
                return new CompIterator(new DecompIterator(new RecursDecompIterator(new UCharIterator(str), false)));
        }
        throw mode + " is invalid";
    };
    var normalize = function(mode, str) {
        var it = createIterator(mode, str);
        var ret = "";
        var uchar;
        while(!!(uchar = it.next()))ret += uchar.toString();
        return ret;
    };
    /* API functions */ function nfd(str) {
        return normalize("NFD", str);
    }
    function nfkd(str) {
        return normalize("NFKD", str);
    }
    function nfc(str) {
        return normalize("NFC", str);
    }
    function nfkc(str) {
        return normalize("NFKC", str);
    }
    /* Unicode data */ UChar.udata = {
        0: {
            60: [
                ,
                ,
                {
                    824: 8814
                }
            ],
            61: [
                ,
                ,
                {
                    824: 8800
                }
            ],
            62: [
                ,
                ,
                {
                    824: 8815
                }
            ],
            65: [
                ,
                ,
                {
                    768: 192,
                    769: 193,
                    770: 194,
                    771: 195,
                    772: 256,
                    774: 258,
                    775: 550,
                    776: 196,
                    777: 7842,
                    778: 197,
                    780: 461,
                    783: 512,
                    785: 514,
                    803: 7840,
                    805: 7680,
                    808: 260
                }
            ],
            66: [
                ,
                ,
                {
                    775: 7682,
                    803: 7684,
                    817: 7686
                }
            ],
            67: [
                ,
                ,
                {
                    769: 262,
                    770: 264,
                    775: 266,
                    780: 268,
                    807: 199
                }
            ],
            68: [
                ,
                ,
                {
                    775: 7690,
                    780: 270,
                    803: 7692,
                    807: 7696,
                    813: 7698,
                    817: 7694
                }
            ],
            69: [
                ,
                ,
                {
                    768: 200,
                    769: 201,
                    770: 202,
                    771: 7868,
                    772: 274,
                    774: 276,
                    775: 278,
                    776: 203,
                    777: 7866,
                    780: 282,
                    783: 516,
                    785: 518,
                    803: 7864,
                    807: 552,
                    808: 280,
                    813: 7704,
                    816: 7706
                }
            ],
            70: [
                ,
                ,
                {
                    775: 7710
                }
            ],
            71: [
                ,
                ,
                {
                    769: 500,
                    770: 284,
                    772: 7712,
                    774: 286,
                    775: 288,
                    780: 486,
                    807: 290
                }
            ],
            72: [
                ,
                ,
                {
                    770: 292,
                    775: 7714,
                    776: 7718,
                    780: 542,
                    803: 7716,
                    807: 7720,
                    814: 7722
                }
            ],
            73: [
                ,
                ,
                {
                    768: 204,
                    769: 205,
                    770: 206,
                    771: 296,
                    772: 298,
                    774: 300,
                    775: 304,
                    776: 207,
                    777: 7880,
                    780: 463,
                    783: 520,
                    785: 522,
                    803: 7882,
                    808: 302,
                    816: 7724
                }
            ],
            74: [
                ,
                ,
                {
                    770: 308
                }
            ],
            75: [
                ,
                ,
                {
                    769: 7728,
                    780: 488,
                    803: 7730,
                    807: 310,
                    817: 7732
                }
            ],
            76: [
                ,
                ,
                {
                    769: 313,
                    780: 317,
                    803: 7734,
                    807: 315,
                    813: 7740,
                    817: 7738
                }
            ],
            77: [
                ,
                ,
                {
                    769: 7742,
                    775: 7744,
                    803: 7746
                }
            ],
            78: [
                ,
                ,
                {
                    768: 504,
                    769: 323,
                    771: 209,
                    775: 7748,
                    780: 327,
                    803: 7750,
                    807: 325,
                    813: 7754,
                    817: 7752
                }
            ],
            79: [
                ,
                ,
                {
                    768: 210,
                    769: 211,
                    770: 212,
                    771: 213,
                    772: 332,
                    774: 334,
                    775: 558,
                    776: 214,
                    777: 7886,
                    779: 336,
                    780: 465,
                    783: 524,
                    785: 526,
                    795: 416,
                    803: 7884,
                    808: 490
                }
            ],
            80: [
                ,
                ,
                {
                    769: 7764,
                    775: 7766
                }
            ],
            82: [
                ,
                ,
                {
                    769: 340,
                    775: 7768,
                    780: 344,
                    783: 528,
                    785: 530,
                    803: 7770,
                    807: 342,
                    817: 7774
                }
            ],
            83: [
                ,
                ,
                {
                    769: 346,
                    770: 348,
                    775: 7776,
                    780: 352,
                    803: 7778,
                    806: 536,
                    807: 350
                }
            ],
            84: [
                ,
                ,
                {
                    775: 7786,
                    780: 356,
                    803: 7788,
                    806: 538,
                    807: 354,
                    813: 7792,
                    817: 7790
                }
            ],
            85: [
                ,
                ,
                {
                    768: 217,
                    769: 218,
                    770: 219,
                    771: 360,
                    772: 362,
                    774: 364,
                    776: 220,
                    777: 7910,
                    778: 366,
                    779: 368,
                    780: 467,
                    783: 532,
                    785: 534,
                    795: 431,
                    803: 7908,
                    804: 7794,
                    808: 370,
                    813: 7798,
                    816: 7796
                }
            ],
            86: [
                ,
                ,
                {
                    771: 7804,
                    803: 7806
                }
            ],
            87: [
                ,
                ,
                {
                    768: 7808,
                    769: 7810,
                    770: 372,
                    775: 7814,
                    776: 7812,
                    803: 7816
                }
            ],
            88: [
                ,
                ,
                {
                    775: 7818,
                    776: 7820
                }
            ],
            89: [
                ,
                ,
                {
                    768: 7922,
                    769: 221,
                    770: 374,
                    771: 7928,
                    772: 562,
                    775: 7822,
                    776: 376,
                    777: 7926,
                    803: 7924
                }
            ],
            90: [
                ,
                ,
                {
                    769: 377,
                    770: 7824,
                    775: 379,
                    780: 381,
                    803: 7826,
                    817: 7828
                }
            ],
            97: [
                ,
                ,
                {
                    768: 224,
                    769: 225,
                    770: 226,
                    771: 227,
                    772: 257,
                    774: 259,
                    775: 551,
                    776: 228,
                    777: 7843,
                    778: 229,
                    780: 462,
                    783: 513,
                    785: 515,
                    803: 7841,
                    805: 7681,
                    808: 261
                }
            ],
            98: [
                ,
                ,
                {
                    775: 7683,
                    803: 7685,
                    817: 7687
                }
            ],
            99: [
                ,
                ,
                {
                    769: 263,
                    770: 265,
                    775: 267,
                    780: 269,
                    807: 231
                }
            ],
            100: [
                ,
                ,
                {
                    775: 7691,
                    780: 271,
                    803: 7693,
                    807: 7697,
                    813: 7699,
                    817: 7695
                }
            ],
            101: [
                ,
                ,
                {
                    768: 232,
                    769: 233,
                    770: 234,
                    771: 7869,
                    772: 275,
                    774: 277,
                    775: 279,
                    776: 235,
                    777: 7867,
                    780: 283,
                    783: 517,
                    785: 519,
                    803: 7865,
                    807: 553,
                    808: 281,
                    813: 7705,
                    816: 7707
                }
            ],
            102: [
                ,
                ,
                {
                    775: 7711
                }
            ],
            103: [
                ,
                ,
                {
                    769: 501,
                    770: 285,
                    772: 7713,
                    774: 287,
                    775: 289,
                    780: 487,
                    807: 291
                }
            ],
            104: [
                ,
                ,
                {
                    770: 293,
                    775: 7715,
                    776: 7719,
                    780: 543,
                    803: 7717,
                    807: 7721,
                    814: 7723,
                    817: 7830
                }
            ],
            105: [
                ,
                ,
                {
                    768: 236,
                    769: 237,
                    770: 238,
                    771: 297,
                    772: 299,
                    774: 301,
                    776: 239,
                    777: 7881,
                    780: 464,
                    783: 521,
                    785: 523,
                    803: 7883,
                    808: 303,
                    816: 7725
                }
            ],
            106: [
                ,
                ,
                {
                    770: 309,
                    780: 496
                }
            ],
            107: [
                ,
                ,
                {
                    769: 7729,
                    780: 489,
                    803: 7731,
                    807: 311,
                    817: 7733
                }
            ],
            108: [
                ,
                ,
                {
                    769: 314,
                    780: 318,
                    803: 7735,
                    807: 316,
                    813: 7741,
                    817: 7739
                }
            ],
            109: [
                ,
                ,
                {
                    769: 7743,
                    775: 7745,
                    803: 7747
                }
            ],
            110: [
                ,
                ,
                {
                    768: 505,
                    769: 324,
                    771: 241,
                    775: 7749,
                    780: 328,
                    803: 7751,
                    807: 326,
                    813: 7755,
                    817: 7753
                }
            ],
            111: [
                ,
                ,
                {
                    768: 242,
                    769: 243,
                    770: 244,
                    771: 245,
                    772: 333,
                    774: 335,
                    775: 559,
                    776: 246,
                    777: 7887,
                    779: 337,
                    780: 466,
                    783: 525,
                    785: 527,
                    795: 417,
                    803: 7885,
                    808: 491
                }
            ],
            112: [
                ,
                ,
                {
                    769: 7765,
                    775: 7767
                }
            ],
            114: [
                ,
                ,
                {
                    769: 341,
                    775: 7769,
                    780: 345,
                    783: 529,
                    785: 531,
                    803: 7771,
                    807: 343,
                    817: 7775
                }
            ],
            115: [
                ,
                ,
                {
                    769: 347,
                    770: 349,
                    775: 7777,
                    780: 353,
                    803: 7779,
                    806: 537,
                    807: 351
                }
            ],
            116: [
                ,
                ,
                {
                    775: 7787,
                    776: 7831,
                    780: 357,
                    803: 7789,
                    806: 539,
                    807: 355,
                    813: 7793,
                    817: 7791
                }
            ],
            117: [
                ,
                ,
                {
                    768: 249,
                    769: 250,
                    770: 251,
                    771: 361,
                    772: 363,
                    774: 365,
                    776: 252,
                    777: 7911,
                    778: 367,
                    779: 369,
                    780: 468,
                    783: 533,
                    785: 535,
                    795: 432,
                    803: 7909,
                    804: 7795,
                    808: 371,
                    813: 7799,
                    816: 7797
                }
            ],
            118: [
                ,
                ,
                {
                    771: 7805,
                    803: 7807
                }
            ],
            119: [
                ,
                ,
                {
                    768: 7809,
                    769: 7811,
                    770: 373,
                    775: 7815,
                    776: 7813,
                    778: 7832,
                    803: 7817
                }
            ],
            120: [
                ,
                ,
                {
                    775: 7819,
                    776: 7821
                }
            ],
            121: [
                ,
                ,
                {
                    768: 7923,
                    769: 253,
                    770: 375,
                    771: 7929,
                    772: 563,
                    775: 7823,
                    776: 255,
                    777: 7927,
                    778: 7833,
                    803: 7925
                }
            ],
            122: [
                ,
                ,
                {
                    769: 378,
                    770: 7825,
                    775: 380,
                    780: 382,
                    803: 7827,
                    817: 7829
                }
            ],
            160: [
                [
                    32
                ],
                256
            ],
            168: [
                [
                    32,
                    776
                ],
                256,
                {
                    768: 8173,
                    769: 901,
                    834: 8129
                }
            ],
            170: [
                [
                    97
                ],
                256
            ],
            175: [
                [
                    32,
                    772
                ],
                256
            ],
            178: [
                [
                    50
                ],
                256
            ],
            179: [
                [
                    51
                ],
                256
            ],
            180: [
                [
                    32,
                    769
                ],
                256
            ],
            181: [
                [
                    956
                ],
                256
            ],
            184: [
                [
                    32,
                    807
                ],
                256
            ],
            185: [
                [
                    49
                ],
                256
            ],
            186: [
                [
                    111
                ],
                256
            ],
            188: [
                [
                    49,
                    8260,
                    52
                ],
                256
            ],
            189: [
                [
                    49,
                    8260,
                    50
                ],
                256
            ],
            190: [
                [
                    51,
                    8260,
                    52
                ],
                256
            ],
            192: [
                [
                    65,
                    768
                ]
            ],
            193: [
                [
                    65,
                    769
                ]
            ],
            194: [
                [
                    65,
                    770
                ],
                ,
                {
                    768: 7846,
                    769: 7844,
                    771: 7850,
                    777: 7848
                }
            ],
            195: [
                [
                    65,
                    771
                ]
            ],
            196: [
                [
                    65,
                    776
                ],
                ,
                {
                    772: 478
                }
            ],
            197: [
                [
                    65,
                    778
                ],
                ,
                {
                    769: 506
                }
            ],
            198: [
                ,
                ,
                {
                    769: 508,
                    772: 482
                }
            ],
            199: [
                [
                    67,
                    807
                ],
                ,
                {
                    769: 7688
                }
            ],
            200: [
                [
                    69,
                    768
                ]
            ],
            201: [
                [
                    69,
                    769
                ]
            ],
            202: [
                [
                    69,
                    770
                ],
                ,
                {
                    768: 7872,
                    769: 7870,
                    771: 7876,
                    777: 7874
                }
            ],
            203: [
                [
                    69,
                    776
                ]
            ],
            204: [
                [
                    73,
                    768
                ]
            ],
            205: [
                [
                    73,
                    769
                ]
            ],
            206: [
                [
                    73,
                    770
                ]
            ],
            207: [
                [
                    73,
                    776
                ],
                ,
                {
                    769: 7726
                }
            ],
            209: [
                [
                    78,
                    771
                ]
            ],
            210: [
                [
                    79,
                    768
                ]
            ],
            211: [
                [
                    79,
                    769
                ]
            ],
            212: [
                [
                    79,
                    770
                ],
                ,
                {
                    768: 7890,
                    769: 7888,
                    771: 7894,
                    777: 7892
                }
            ],
            213: [
                [
                    79,
                    771
                ],
                ,
                {
                    769: 7756,
                    772: 556,
                    776: 7758
                }
            ],
            214: [
                [
                    79,
                    776
                ],
                ,
                {
                    772: 554
                }
            ],
            216: [
                ,
                ,
                {
                    769: 510
                }
            ],
            217: [
                [
                    85,
                    768
                ]
            ],
            218: [
                [
                    85,
                    769
                ]
            ],
            219: [
                [
                    85,
                    770
                ]
            ],
            220: [
                [
                    85,
                    776
                ],
                ,
                {
                    768: 475,
                    769: 471,
                    772: 469,
                    780: 473
                }
            ],
            221: [
                [
                    89,
                    769
                ]
            ],
            224: [
                [
                    97,
                    768
                ]
            ],
            225: [
                [
                    97,
                    769
                ]
            ],
            226: [
                [
                    97,
                    770
                ],
                ,
                {
                    768: 7847,
                    769: 7845,
                    771: 7851,
                    777: 7849
                }
            ],
            227: [
                [
                    97,
                    771
                ]
            ],
            228: [
                [
                    97,
                    776
                ],
                ,
                {
                    772: 479
                }
            ],
            229: [
                [
                    97,
                    778
                ],
                ,
                {
                    769: 507
                }
            ],
            230: [
                ,
                ,
                {
                    769: 509,
                    772: 483
                }
            ],
            231: [
                [
                    99,
                    807
                ],
                ,
                {
                    769: 7689
                }
            ],
            232: [
                [
                    101,
                    768
                ]
            ],
            233: [
                [
                    101,
                    769
                ]
            ],
            234: [
                [
                    101,
                    770
                ],
                ,
                {
                    768: 7873,
                    769: 7871,
                    771: 7877,
                    777: 7875
                }
            ],
            235: [
                [
                    101,
                    776
                ]
            ],
            236: [
                [
                    105,
                    768
                ]
            ],
            237: [
                [
                    105,
                    769
                ]
            ],
            238: [
                [
                    105,
                    770
                ]
            ],
            239: [
                [
                    105,
                    776
                ],
                ,
                {
                    769: 7727
                }
            ],
            241: [
                [
                    110,
                    771
                ]
            ],
            242: [
                [
                    111,
                    768
                ]
            ],
            243: [
                [
                    111,
                    769
                ]
            ],
            244: [
                [
                    111,
                    770
                ],
                ,
                {
                    768: 7891,
                    769: 7889,
                    771: 7895,
                    777: 7893
                }
            ],
            245: [
                [
                    111,
                    771
                ],
                ,
                {
                    769: 7757,
                    772: 557,
                    776: 7759
                }
            ],
            246: [
                [
                    111,
                    776
                ],
                ,
                {
                    772: 555
                }
            ],
            248: [
                ,
                ,
                {
                    769: 511
                }
            ],
            249: [
                [
                    117,
                    768
                ]
            ],
            250: [
                [
                    117,
                    769
                ]
            ],
            251: [
                [
                    117,
                    770
                ]
            ],
            252: [
                [
                    117,
                    776
                ],
                ,
                {
                    768: 476,
                    769: 472,
                    772: 470,
                    780: 474
                }
            ],
            253: [
                [
                    121,
                    769
                ]
            ],
            255: [
                [
                    121,
                    776
                ]
            ]
        },
        256: {
            256: [
                [
                    65,
                    772
                ]
            ],
            257: [
                [
                    97,
                    772
                ]
            ],
            258: [
                [
                    65,
                    774
                ],
                ,
                {
                    768: 7856,
                    769: 7854,
                    771: 7860,
                    777: 7858
                }
            ],
            259: [
                [
                    97,
                    774
                ],
                ,
                {
                    768: 7857,
                    769: 7855,
                    771: 7861,
                    777: 7859
                }
            ],
            260: [
                [
                    65,
                    808
                ]
            ],
            261: [
                [
                    97,
                    808
                ]
            ],
            262: [
                [
                    67,
                    769
                ]
            ],
            263: [
                [
                    99,
                    769
                ]
            ],
            264: [
                [
                    67,
                    770
                ]
            ],
            265: [
                [
                    99,
                    770
                ]
            ],
            266: [
                [
                    67,
                    775
                ]
            ],
            267: [
                [
                    99,
                    775
                ]
            ],
            268: [
                [
                    67,
                    780
                ]
            ],
            269: [
                [
                    99,
                    780
                ]
            ],
            270: [
                [
                    68,
                    780
                ]
            ],
            271: [
                [
                    100,
                    780
                ]
            ],
            274: [
                [
                    69,
                    772
                ],
                ,
                {
                    768: 7700,
                    769: 7702
                }
            ],
            275: [
                [
                    101,
                    772
                ],
                ,
                {
                    768: 7701,
                    769: 7703
                }
            ],
            276: [
                [
                    69,
                    774
                ]
            ],
            277: [
                [
                    101,
                    774
                ]
            ],
            278: [
                [
                    69,
                    775
                ]
            ],
            279: [
                [
                    101,
                    775
                ]
            ],
            280: [
                [
                    69,
                    808
                ]
            ],
            281: [
                [
                    101,
                    808
                ]
            ],
            282: [
                [
                    69,
                    780
                ]
            ],
            283: [
                [
                    101,
                    780
                ]
            ],
            284: [
                [
                    71,
                    770
                ]
            ],
            285: [
                [
                    103,
                    770
                ]
            ],
            286: [
                [
                    71,
                    774
                ]
            ],
            287: [
                [
                    103,
                    774
                ]
            ],
            288: [
                [
                    71,
                    775
                ]
            ],
            289: [
                [
                    103,
                    775
                ]
            ],
            290: [
                [
                    71,
                    807
                ]
            ],
            291: [
                [
                    103,
                    807
                ]
            ],
            292: [
                [
                    72,
                    770
                ]
            ],
            293: [
                [
                    104,
                    770
                ]
            ],
            296: [
                [
                    73,
                    771
                ]
            ],
            297: [
                [
                    105,
                    771
                ]
            ],
            298: [
                [
                    73,
                    772
                ]
            ],
            299: [
                [
                    105,
                    772
                ]
            ],
            300: [
                [
                    73,
                    774
                ]
            ],
            301: [
                [
                    105,
                    774
                ]
            ],
            302: [
                [
                    73,
                    808
                ]
            ],
            303: [
                [
                    105,
                    808
                ]
            ],
            304: [
                [
                    73,
                    775
                ]
            ],
            306: [
                [
                    73,
                    74
                ],
                256
            ],
            307: [
                [
                    105,
                    106
                ],
                256
            ],
            308: [
                [
                    74,
                    770
                ]
            ],
            309: [
                [
                    106,
                    770
                ]
            ],
            310: [
                [
                    75,
                    807
                ]
            ],
            311: [
                [
                    107,
                    807
                ]
            ],
            313: [
                [
                    76,
                    769
                ]
            ],
            314: [
                [
                    108,
                    769
                ]
            ],
            315: [
                [
                    76,
                    807
                ]
            ],
            316: [
                [
                    108,
                    807
                ]
            ],
            317: [
                [
                    76,
                    780
                ]
            ],
            318: [
                [
                    108,
                    780
                ]
            ],
            319: [
                [
                    76,
                    183
                ],
                256
            ],
            320: [
                [
                    108,
                    183
                ],
                256
            ],
            323: [
                [
                    78,
                    769
                ]
            ],
            324: [
                [
                    110,
                    769
                ]
            ],
            325: [
                [
                    78,
                    807
                ]
            ],
            326: [
                [
                    110,
                    807
                ]
            ],
            327: [
                [
                    78,
                    780
                ]
            ],
            328: [
                [
                    110,
                    780
                ]
            ],
            329: [
                [
                    700,
                    110
                ],
                256
            ],
            332: [
                [
                    79,
                    772
                ],
                ,
                {
                    768: 7760,
                    769: 7762
                }
            ],
            333: [
                [
                    111,
                    772
                ],
                ,
                {
                    768: 7761,
                    769: 7763
                }
            ],
            334: [
                [
                    79,
                    774
                ]
            ],
            335: [
                [
                    111,
                    774
                ]
            ],
            336: [
                [
                    79,
                    779
                ]
            ],
            337: [
                [
                    111,
                    779
                ]
            ],
            340: [
                [
                    82,
                    769
                ]
            ],
            341: [
                [
                    114,
                    769
                ]
            ],
            342: [
                [
                    82,
                    807
                ]
            ],
            343: [
                [
                    114,
                    807
                ]
            ],
            344: [
                [
                    82,
                    780
                ]
            ],
            345: [
                [
                    114,
                    780
                ]
            ],
            346: [
                [
                    83,
                    769
                ],
                ,
                {
                    775: 7780
                }
            ],
            347: [
                [
                    115,
                    769
                ],
                ,
                {
                    775: 7781
                }
            ],
            348: [
                [
                    83,
                    770
                ]
            ],
            349: [
                [
                    115,
                    770
                ]
            ],
            350: [
                [
                    83,
                    807
                ]
            ],
            351: [
                [
                    115,
                    807
                ]
            ],
            352: [
                [
                    83,
                    780
                ],
                ,
                {
                    775: 7782
                }
            ],
            353: [
                [
                    115,
                    780
                ],
                ,
                {
                    775: 7783
                }
            ],
            354: [
                [
                    84,
                    807
                ]
            ],
            355: [
                [
                    116,
                    807
                ]
            ],
            356: [
                [
                    84,
                    780
                ]
            ],
            357: [
                [
                    116,
                    780
                ]
            ],
            360: [
                [
                    85,
                    771
                ],
                ,
                {
                    769: 7800
                }
            ],
            361: [
                [
                    117,
                    771
                ],
                ,
                {
                    769: 7801
                }
            ],
            362: [
                [
                    85,
                    772
                ],
                ,
                {
                    776: 7802
                }
            ],
            363: [
                [
                    117,
                    772
                ],
                ,
                {
                    776: 7803
                }
            ],
            364: [
                [
                    85,
                    774
                ]
            ],
            365: [
                [
                    117,
                    774
                ]
            ],
            366: [
                [
                    85,
                    778
                ]
            ],
            367: [
                [
                    117,
                    778
                ]
            ],
            368: [
                [
                    85,
                    779
                ]
            ],
            369: [
                [
                    117,
                    779
                ]
            ],
            370: [
                [
                    85,
                    808
                ]
            ],
            371: [
                [
                    117,
                    808
                ]
            ],
            372: [
                [
                    87,
                    770
                ]
            ],
            373: [
                [
                    119,
                    770
                ]
            ],
            374: [
                [
                    89,
                    770
                ]
            ],
            375: [
                [
                    121,
                    770
                ]
            ],
            376: [
                [
                    89,
                    776
                ]
            ],
            377: [
                [
                    90,
                    769
                ]
            ],
            378: [
                [
                    122,
                    769
                ]
            ],
            379: [
                [
                    90,
                    775
                ]
            ],
            380: [
                [
                    122,
                    775
                ]
            ],
            381: [
                [
                    90,
                    780
                ]
            ],
            382: [
                [
                    122,
                    780
                ]
            ],
            383: [
                [
                    115
                ],
                256,
                {
                    775: 7835
                }
            ],
            416: [
                [
                    79,
                    795
                ],
                ,
                {
                    768: 7900,
                    769: 7898,
                    771: 7904,
                    777: 7902,
                    803: 7906
                }
            ],
            417: [
                [
                    111,
                    795
                ],
                ,
                {
                    768: 7901,
                    769: 7899,
                    771: 7905,
                    777: 7903,
                    803: 7907
                }
            ],
            431: [
                [
                    85,
                    795
                ],
                ,
                {
                    768: 7914,
                    769: 7912,
                    771: 7918,
                    777: 7916,
                    803: 7920
                }
            ],
            432: [
                [
                    117,
                    795
                ],
                ,
                {
                    768: 7915,
                    769: 7913,
                    771: 7919,
                    777: 7917,
                    803: 7921
                }
            ],
            439: [
                ,
                ,
                {
                    780: 494
                }
            ],
            452: [
                [
                    68,
                    381
                ],
                256
            ],
            453: [
                [
                    68,
                    382
                ],
                256
            ],
            454: [
                [
                    100,
                    382
                ],
                256
            ],
            455: [
                [
                    76,
                    74
                ],
                256
            ],
            456: [
                [
                    76,
                    106
                ],
                256
            ],
            457: [
                [
                    108,
                    106
                ],
                256
            ],
            458: [
                [
                    78,
                    74
                ],
                256
            ],
            459: [
                [
                    78,
                    106
                ],
                256
            ],
            460: [
                [
                    110,
                    106
                ],
                256
            ],
            461: [
                [
                    65,
                    780
                ]
            ],
            462: [
                [
                    97,
                    780
                ]
            ],
            463: [
                [
                    73,
                    780
                ]
            ],
            464: [
                [
                    105,
                    780
                ]
            ],
            465: [
                [
                    79,
                    780
                ]
            ],
            466: [
                [
                    111,
                    780
                ]
            ],
            467: [
                [
                    85,
                    780
                ]
            ],
            468: [
                [
                    117,
                    780
                ]
            ],
            469: [
                [
                    220,
                    772
                ]
            ],
            470: [
                [
                    252,
                    772
                ]
            ],
            471: [
                [
                    220,
                    769
                ]
            ],
            472: [
                [
                    252,
                    769
                ]
            ],
            473: [
                [
                    220,
                    780
                ]
            ],
            474: [
                [
                    252,
                    780
                ]
            ],
            475: [
                [
                    220,
                    768
                ]
            ],
            476: [
                [
                    252,
                    768
                ]
            ],
            478: [
                [
                    196,
                    772
                ]
            ],
            479: [
                [
                    228,
                    772
                ]
            ],
            480: [
                [
                    550,
                    772
                ]
            ],
            481: [
                [
                    551,
                    772
                ]
            ],
            482: [
                [
                    198,
                    772
                ]
            ],
            483: [
                [
                    230,
                    772
                ]
            ],
            486: [
                [
                    71,
                    780
                ]
            ],
            487: [
                [
                    103,
                    780
                ]
            ],
            488: [
                [
                    75,
                    780
                ]
            ],
            489: [
                [
                    107,
                    780
                ]
            ],
            490: [
                [
                    79,
                    808
                ],
                ,
                {
                    772: 492
                }
            ],
            491: [
                [
                    111,
                    808
                ],
                ,
                {
                    772: 493
                }
            ],
            492: [
                [
                    490,
                    772
                ]
            ],
            493: [
                [
                    491,
                    772
                ]
            ],
            494: [
                [
                    439,
                    780
                ]
            ],
            495: [
                [
                    658,
                    780
                ]
            ],
            496: [
                [
                    106,
                    780
                ]
            ],
            497: [
                [
                    68,
                    90
                ],
                256
            ],
            498: [
                [
                    68,
                    122
                ],
                256
            ],
            499: [
                [
                    100,
                    122
                ],
                256
            ],
            500: [
                [
                    71,
                    769
                ]
            ],
            501: [
                [
                    103,
                    769
                ]
            ],
            504: [
                [
                    78,
                    768
                ]
            ],
            505: [
                [
                    110,
                    768
                ]
            ],
            506: [
                [
                    197,
                    769
                ]
            ],
            507: [
                [
                    229,
                    769
                ]
            ],
            508: [
                [
                    198,
                    769
                ]
            ],
            509: [
                [
                    230,
                    769
                ]
            ],
            510: [
                [
                    216,
                    769
                ]
            ],
            511: [
                [
                    248,
                    769
                ]
            ],
            66045: [
                ,
                220
            ]
        },
        512: {
            512: [
                [
                    65,
                    783
                ]
            ],
            513: [
                [
                    97,
                    783
                ]
            ],
            514: [
                [
                    65,
                    785
                ]
            ],
            515: [
                [
                    97,
                    785
                ]
            ],
            516: [
                [
                    69,
                    783
                ]
            ],
            517: [
                [
                    101,
                    783
                ]
            ],
            518: [
                [
                    69,
                    785
                ]
            ],
            519: [
                [
                    101,
                    785
                ]
            ],
            520: [
                [
                    73,
                    783
                ]
            ],
            521: [
                [
                    105,
                    783
                ]
            ],
            522: [
                [
                    73,
                    785
                ]
            ],
            523: [
                [
                    105,
                    785
                ]
            ],
            524: [
                [
                    79,
                    783
                ]
            ],
            525: [
                [
                    111,
                    783
                ]
            ],
            526: [
                [
                    79,
                    785
                ]
            ],
            527: [
                [
                    111,
                    785
                ]
            ],
            528: [
                [
                    82,
                    783
                ]
            ],
            529: [
                [
                    114,
                    783
                ]
            ],
            530: [
                [
                    82,
                    785
                ]
            ],
            531: [
                [
                    114,
                    785
                ]
            ],
            532: [
                [
                    85,
                    783
                ]
            ],
            533: [
                [
                    117,
                    783
                ]
            ],
            534: [
                [
                    85,
                    785
                ]
            ],
            535: [
                [
                    117,
                    785
                ]
            ],
            536: [
                [
                    83,
                    806
                ]
            ],
            537: [
                [
                    115,
                    806
                ]
            ],
            538: [
                [
                    84,
                    806
                ]
            ],
            539: [
                [
                    116,
                    806
                ]
            ],
            542: [
                [
                    72,
                    780
                ]
            ],
            543: [
                [
                    104,
                    780
                ]
            ],
            550: [
                [
                    65,
                    775
                ],
                ,
                {
                    772: 480
                }
            ],
            551: [
                [
                    97,
                    775
                ],
                ,
                {
                    772: 481
                }
            ],
            552: [
                [
                    69,
                    807
                ],
                ,
                {
                    774: 7708
                }
            ],
            553: [
                [
                    101,
                    807
                ],
                ,
                {
                    774: 7709
                }
            ],
            554: [
                [
                    214,
                    772
                ]
            ],
            555: [
                [
                    246,
                    772
                ]
            ],
            556: [
                [
                    213,
                    772
                ]
            ],
            557: [
                [
                    245,
                    772
                ]
            ],
            558: [
                [
                    79,
                    775
                ],
                ,
                {
                    772: 560
                }
            ],
            559: [
                [
                    111,
                    775
                ],
                ,
                {
                    772: 561
                }
            ],
            560: [
                [
                    558,
                    772
                ]
            ],
            561: [
                [
                    559,
                    772
                ]
            ],
            562: [
                [
                    89,
                    772
                ]
            ],
            563: [
                [
                    121,
                    772
                ]
            ],
            658: [
                ,
                ,
                {
                    780: 495
                }
            ],
            688: [
                [
                    104
                ],
                256
            ],
            689: [
                [
                    614
                ],
                256
            ],
            690: [
                [
                    106
                ],
                256
            ],
            691: [
                [
                    114
                ],
                256
            ],
            692: [
                [
                    633
                ],
                256
            ],
            693: [
                [
                    635
                ],
                256
            ],
            694: [
                [
                    641
                ],
                256
            ],
            695: [
                [
                    119
                ],
                256
            ],
            696: [
                [
                    121
                ],
                256
            ],
            728: [
                [
                    32,
                    774
                ],
                256
            ],
            729: [
                [
                    32,
                    775
                ],
                256
            ],
            730: [
                [
                    32,
                    778
                ],
                256
            ],
            731: [
                [
                    32,
                    808
                ],
                256
            ],
            732: [
                [
                    32,
                    771
                ],
                256
            ],
            733: [
                [
                    32,
                    779
                ],
                256
            ],
            736: [
                [
                    611
                ],
                256
            ],
            737: [
                [
                    108
                ],
                256
            ],
            738: [
                [
                    115
                ],
                256
            ],
            739: [
                [
                    120
                ],
                256
            ],
            740: [
                [
                    661
                ],
                256
            ],
            66272: [
                ,
                220
            ]
        },
        768: {
            768: [
                ,
                230
            ],
            769: [
                ,
                230
            ],
            770: [
                ,
                230
            ],
            771: [
                ,
                230
            ],
            772: [
                ,
                230
            ],
            773: [
                ,
                230
            ],
            774: [
                ,
                230
            ],
            775: [
                ,
                230
            ],
            776: [
                ,
                230,
                {
                    769: 836
                }
            ],
            777: [
                ,
                230
            ],
            778: [
                ,
                230
            ],
            779: [
                ,
                230
            ],
            780: [
                ,
                230
            ],
            781: [
                ,
                230
            ],
            782: [
                ,
                230
            ],
            783: [
                ,
                230
            ],
            784: [
                ,
                230
            ],
            785: [
                ,
                230
            ],
            786: [
                ,
                230
            ],
            787: [
                ,
                230
            ],
            788: [
                ,
                230
            ],
            789: [
                ,
                232
            ],
            790: [
                ,
                220
            ],
            791: [
                ,
                220
            ],
            792: [
                ,
                220
            ],
            793: [
                ,
                220
            ],
            794: [
                ,
                232
            ],
            795: [
                ,
                216
            ],
            796: [
                ,
                220
            ],
            797: [
                ,
                220
            ],
            798: [
                ,
                220
            ],
            799: [
                ,
                220
            ],
            800: [
                ,
                220
            ],
            801: [
                ,
                202
            ],
            802: [
                ,
                202
            ],
            803: [
                ,
                220
            ],
            804: [
                ,
                220
            ],
            805: [
                ,
                220
            ],
            806: [
                ,
                220
            ],
            807: [
                ,
                202
            ],
            808: [
                ,
                202
            ],
            809: [
                ,
                220
            ],
            810: [
                ,
                220
            ],
            811: [
                ,
                220
            ],
            812: [
                ,
                220
            ],
            813: [
                ,
                220
            ],
            814: [
                ,
                220
            ],
            815: [
                ,
                220
            ],
            816: [
                ,
                220
            ],
            817: [
                ,
                220
            ],
            818: [
                ,
                220
            ],
            819: [
                ,
                220
            ],
            820: [
                ,
                1
            ],
            821: [
                ,
                1
            ],
            822: [
                ,
                1
            ],
            823: [
                ,
                1
            ],
            824: [
                ,
                1
            ],
            825: [
                ,
                220
            ],
            826: [
                ,
                220
            ],
            827: [
                ,
                220
            ],
            828: [
                ,
                220
            ],
            829: [
                ,
                230
            ],
            830: [
                ,
                230
            ],
            831: [
                ,
                230
            ],
            832: [
                [
                    768
                ],
                230
            ],
            833: [
                [
                    769
                ],
                230
            ],
            834: [
                ,
                230
            ],
            835: [
                [
                    787
                ],
                230
            ],
            836: [
                [
                    776,
                    769
                ],
                230
            ],
            837: [
                ,
                240
            ],
            838: [
                ,
                230
            ],
            839: [
                ,
                220
            ],
            840: [
                ,
                220
            ],
            841: [
                ,
                220
            ],
            842: [
                ,
                230
            ],
            843: [
                ,
                230
            ],
            844: [
                ,
                230
            ],
            845: [
                ,
                220
            ],
            846: [
                ,
                220
            ],
            848: [
                ,
                230
            ],
            849: [
                ,
                230
            ],
            850: [
                ,
                230
            ],
            851: [
                ,
                220
            ],
            852: [
                ,
                220
            ],
            853: [
                ,
                220
            ],
            854: [
                ,
                220
            ],
            855: [
                ,
                230
            ],
            856: [
                ,
                232
            ],
            857: [
                ,
                220
            ],
            858: [
                ,
                220
            ],
            859: [
                ,
                230
            ],
            860: [
                ,
                233
            ],
            861: [
                ,
                234
            ],
            862: [
                ,
                234
            ],
            863: [
                ,
                233
            ],
            864: [
                ,
                234
            ],
            865: [
                ,
                234
            ],
            866: [
                ,
                233
            ],
            867: [
                ,
                230
            ],
            868: [
                ,
                230
            ],
            869: [
                ,
                230
            ],
            870: [
                ,
                230
            ],
            871: [
                ,
                230
            ],
            872: [
                ,
                230
            ],
            873: [
                ,
                230
            ],
            874: [
                ,
                230
            ],
            875: [
                ,
                230
            ],
            876: [
                ,
                230
            ],
            877: [
                ,
                230
            ],
            878: [
                ,
                230
            ],
            879: [
                ,
                230
            ],
            884: [
                [
                    697
                ]
            ],
            890: [
                [
                    32,
                    837
                ],
                256
            ],
            894: [
                [
                    59
                ]
            ],
            900: [
                [
                    32,
                    769
                ],
                256
            ],
            901: [
                [
                    168,
                    769
                ]
            ],
            902: [
                [
                    913,
                    769
                ]
            ],
            903: [
                [
                    183
                ]
            ],
            904: [
                [
                    917,
                    769
                ]
            ],
            905: [
                [
                    919,
                    769
                ]
            ],
            906: [
                [
                    921,
                    769
                ]
            ],
            908: [
                [
                    927,
                    769
                ]
            ],
            910: [
                [
                    933,
                    769
                ]
            ],
            911: [
                [
                    937,
                    769
                ]
            ],
            912: [
                [
                    970,
                    769
                ]
            ],
            913: [
                ,
                ,
                {
                    768: 8122,
                    769: 902,
                    772: 8121,
                    774: 8120,
                    787: 7944,
                    788: 7945,
                    837: 8124
                }
            ],
            917: [
                ,
                ,
                {
                    768: 8136,
                    769: 904,
                    787: 7960,
                    788: 7961
                }
            ],
            919: [
                ,
                ,
                {
                    768: 8138,
                    769: 905,
                    787: 7976,
                    788: 7977,
                    837: 8140
                }
            ],
            921: [
                ,
                ,
                {
                    768: 8154,
                    769: 906,
                    772: 8153,
                    774: 8152,
                    776: 938,
                    787: 7992,
                    788: 7993
                }
            ],
            927: [
                ,
                ,
                {
                    768: 8184,
                    769: 908,
                    787: 8008,
                    788: 8009
                }
            ],
            929: [
                ,
                ,
                {
                    788: 8172
                }
            ],
            933: [
                ,
                ,
                {
                    768: 8170,
                    769: 910,
                    772: 8169,
                    774: 8168,
                    776: 939,
                    788: 8025
                }
            ],
            937: [
                ,
                ,
                {
                    768: 8186,
                    769: 911,
                    787: 8040,
                    788: 8041,
                    837: 8188
                }
            ],
            938: [
                [
                    921,
                    776
                ]
            ],
            939: [
                [
                    933,
                    776
                ]
            ],
            940: [
                [
                    945,
                    769
                ],
                ,
                {
                    837: 8116
                }
            ],
            941: [
                [
                    949,
                    769
                ]
            ],
            942: [
                [
                    951,
                    769
                ],
                ,
                {
                    837: 8132
                }
            ],
            943: [
                [
                    953,
                    769
                ]
            ],
            944: [
                [
                    971,
                    769
                ]
            ],
            945: [
                ,
                ,
                {
                    768: 8048,
                    769: 940,
                    772: 8113,
                    774: 8112,
                    787: 7936,
                    788: 7937,
                    834: 8118,
                    837: 8115
                }
            ],
            949: [
                ,
                ,
                {
                    768: 8050,
                    769: 941,
                    787: 7952,
                    788: 7953
                }
            ],
            951: [
                ,
                ,
                {
                    768: 8052,
                    769: 942,
                    787: 7968,
                    788: 7969,
                    834: 8134,
                    837: 8131
                }
            ],
            953: [
                ,
                ,
                {
                    768: 8054,
                    769: 943,
                    772: 8145,
                    774: 8144,
                    776: 970,
                    787: 7984,
                    788: 7985,
                    834: 8150
                }
            ],
            959: [
                ,
                ,
                {
                    768: 8056,
                    769: 972,
                    787: 8000,
                    788: 8001
                }
            ],
            961: [
                ,
                ,
                {
                    787: 8164,
                    788: 8165
                }
            ],
            965: [
                ,
                ,
                {
                    768: 8058,
                    769: 973,
                    772: 8161,
                    774: 8160,
                    776: 971,
                    787: 8016,
                    788: 8017,
                    834: 8166
                }
            ],
            969: [
                ,
                ,
                {
                    768: 8060,
                    769: 974,
                    787: 8032,
                    788: 8033,
                    834: 8182,
                    837: 8179
                }
            ],
            970: [
                [
                    953,
                    776
                ],
                ,
                {
                    768: 8146,
                    769: 912,
                    834: 8151
                }
            ],
            971: [
                [
                    965,
                    776
                ],
                ,
                {
                    768: 8162,
                    769: 944,
                    834: 8167
                }
            ],
            972: [
                [
                    959,
                    769
                ]
            ],
            973: [
                [
                    965,
                    769
                ]
            ],
            974: [
                [
                    969,
                    769
                ],
                ,
                {
                    837: 8180
                }
            ],
            976: [
                [
                    946
                ],
                256
            ],
            977: [
                [
                    952
                ],
                256
            ],
            978: [
                [
                    933
                ],
                256,
                {
                    769: 979,
                    776: 980
                }
            ],
            979: [
                [
                    978,
                    769
                ]
            ],
            980: [
                [
                    978,
                    776
                ]
            ],
            981: [
                [
                    966
                ],
                256
            ],
            982: [
                [
                    960
                ],
                256
            ],
            1008: [
                [
                    954
                ],
                256
            ],
            1009: [
                [
                    961
                ],
                256
            ],
            1010: [
                [
                    962
                ],
                256
            ],
            1012: [
                [
                    920
                ],
                256
            ],
            1013: [
                [
                    949
                ],
                256
            ],
            1017: [
                [
                    931
                ],
                256
            ],
            66422: [
                ,
                230
            ],
            66423: [
                ,
                230
            ],
            66424: [
                ,
                230
            ],
            66425: [
                ,
                230
            ],
            66426: [
                ,
                230
            ]
        },
        1024: {
            1024: [
                [
                    1045,
                    768
                ]
            ],
            1025: [
                [
                    1045,
                    776
                ]
            ],
            1027: [
                [
                    1043,
                    769
                ]
            ],
            1030: [
                ,
                ,
                {
                    776: 1031
                }
            ],
            1031: [
                [
                    1030,
                    776
                ]
            ],
            1036: [
                [
                    1050,
                    769
                ]
            ],
            1037: [
                [
                    1048,
                    768
                ]
            ],
            1038: [
                [
                    1059,
                    774
                ]
            ],
            1040: [
                ,
                ,
                {
                    774: 1232,
                    776: 1234
                }
            ],
            1043: [
                ,
                ,
                {
                    769: 1027
                }
            ],
            1045: [
                ,
                ,
                {
                    768: 1024,
                    774: 1238,
                    776: 1025
                }
            ],
            1046: [
                ,
                ,
                {
                    774: 1217,
                    776: 1244
                }
            ],
            1047: [
                ,
                ,
                {
                    776: 1246
                }
            ],
            1048: [
                ,
                ,
                {
                    768: 1037,
                    772: 1250,
                    774: 1049,
                    776: 1252
                }
            ],
            1049: [
                [
                    1048,
                    774
                ]
            ],
            1050: [
                ,
                ,
                {
                    769: 1036
                }
            ],
            1054: [
                ,
                ,
                {
                    776: 1254
                }
            ],
            1059: [
                ,
                ,
                {
                    772: 1262,
                    774: 1038,
                    776: 1264,
                    779: 1266
                }
            ],
            1063: [
                ,
                ,
                {
                    776: 1268
                }
            ],
            1067: [
                ,
                ,
                {
                    776: 1272
                }
            ],
            1069: [
                ,
                ,
                {
                    776: 1260
                }
            ],
            1072: [
                ,
                ,
                {
                    774: 1233,
                    776: 1235
                }
            ],
            1075: [
                ,
                ,
                {
                    769: 1107
                }
            ],
            1077: [
                ,
                ,
                {
                    768: 1104,
                    774: 1239,
                    776: 1105
                }
            ],
            1078: [
                ,
                ,
                {
                    774: 1218,
                    776: 1245
                }
            ],
            1079: [
                ,
                ,
                {
                    776: 1247
                }
            ],
            1080: [
                ,
                ,
                {
                    768: 1117,
                    772: 1251,
                    774: 1081,
                    776: 1253
                }
            ],
            1081: [
                [
                    1080,
                    774
                ]
            ],
            1082: [
                ,
                ,
                {
                    769: 1116
                }
            ],
            1086: [
                ,
                ,
                {
                    776: 1255
                }
            ],
            1091: [
                ,
                ,
                {
                    772: 1263,
                    774: 1118,
                    776: 1265,
                    779: 1267
                }
            ],
            1095: [
                ,
                ,
                {
                    776: 1269
                }
            ],
            1099: [
                ,
                ,
                {
                    776: 1273
                }
            ],
            1101: [
                ,
                ,
                {
                    776: 1261
                }
            ],
            1104: [
                [
                    1077,
                    768
                ]
            ],
            1105: [
                [
                    1077,
                    776
                ]
            ],
            1107: [
                [
                    1075,
                    769
                ]
            ],
            1110: [
                ,
                ,
                {
                    776: 1111
                }
            ],
            1111: [
                [
                    1110,
                    776
                ]
            ],
            1116: [
                [
                    1082,
                    769
                ]
            ],
            1117: [
                [
                    1080,
                    768
                ]
            ],
            1118: [
                [
                    1091,
                    774
                ]
            ],
            1140: [
                ,
                ,
                {
                    783: 1142
                }
            ],
            1141: [
                ,
                ,
                {
                    783: 1143
                }
            ],
            1142: [
                [
                    1140,
                    783
                ]
            ],
            1143: [
                [
                    1141,
                    783
                ]
            ],
            1155: [
                ,
                230
            ],
            1156: [
                ,
                230
            ],
            1157: [
                ,
                230
            ],
            1158: [
                ,
                230
            ],
            1159: [
                ,
                230
            ],
            1217: [
                [
                    1046,
                    774
                ]
            ],
            1218: [
                [
                    1078,
                    774
                ]
            ],
            1232: [
                [
                    1040,
                    774
                ]
            ],
            1233: [
                [
                    1072,
                    774
                ]
            ],
            1234: [
                [
                    1040,
                    776
                ]
            ],
            1235: [
                [
                    1072,
                    776
                ]
            ],
            1238: [
                [
                    1045,
                    774
                ]
            ],
            1239: [
                [
                    1077,
                    774
                ]
            ],
            1240: [
                ,
                ,
                {
                    776: 1242
                }
            ],
            1241: [
                ,
                ,
                {
                    776: 1243
                }
            ],
            1242: [
                [
                    1240,
                    776
                ]
            ],
            1243: [
                [
                    1241,
                    776
                ]
            ],
            1244: [
                [
                    1046,
                    776
                ]
            ],
            1245: [
                [
                    1078,
                    776
                ]
            ],
            1246: [
                [
                    1047,
                    776
                ]
            ],
            1247: [
                [
                    1079,
                    776
                ]
            ],
            1250: [
                [
                    1048,
                    772
                ]
            ],
            1251: [
                [
                    1080,
                    772
                ]
            ],
            1252: [
                [
                    1048,
                    776
                ]
            ],
            1253: [
                [
                    1080,
                    776
                ]
            ],
            1254: [
                [
                    1054,
                    776
                ]
            ],
            1255: [
                [
                    1086,
                    776
                ]
            ],
            1256: [
                ,
                ,
                {
                    776: 1258
                }
            ],
            1257: [
                ,
                ,
                {
                    776: 1259
                }
            ],
            1258: [
                [
                    1256,
                    776
                ]
            ],
            1259: [
                [
                    1257,
                    776
                ]
            ],
            1260: [
                [
                    1069,
                    776
                ]
            ],
            1261: [
                [
                    1101,
                    776
                ]
            ],
            1262: [
                [
                    1059,
                    772
                ]
            ],
            1263: [
                [
                    1091,
                    772
                ]
            ],
            1264: [
                [
                    1059,
                    776
                ]
            ],
            1265: [
                [
                    1091,
                    776
                ]
            ],
            1266: [
                [
                    1059,
                    779
                ]
            ],
            1267: [
                [
                    1091,
                    779
                ]
            ],
            1268: [
                [
                    1063,
                    776
                ]
            ],
            1269: [
                [
                    1095,
                    776
                ]
            ],
            1272: [
                [
                    1067,
                    776
                ]
            ],
            1273: [
                [
                    1099,
                    776
                ]
            ]
        },
        1280: {
            1415: [
                [
                    1381,
                    1410
                ],
                256
            ],
            1425: [
                ,
                220
            ],
            1426: [
                ,
                230
            ],
            1427: [
                ,
                230
            ],
            1428: [
                ,
                230
            ],
            1429: [
                ,
                230
            ],
            1430: [
                ,
                220
            ],
            1431: [
                ,
                230
            ],
            1432: [
                ,
                230
            ],
            1433: [
                ,
                230
            ],
            1434: [
                ,
                222
            ],
            1435: [
                ,
                220
            ],
            1436: [
                ,
                230
            ],
            1437: [
                ,
                230
            ],
            1438: [
                ,
                230
            ],
            1439: [
                ,
                230
            ],
            1440: [
                ,
                230
            ],
            1441: [
                ,
                230
            ],
            1442: [
                ,
                220
            ],
            1443: [
                ,
                220
            ],
            1444: [
                ,
                220
            ],
            1445: [
                ,
                220
            ],
            1446: [
                ,
                220
            ],
            1447: [
                ,
                220
            ],
            1448: [
                ,
                230
            ],
            1449: [
                ,
                230
            ],
            1450: [
                ,
                220
            ],
            1451: [
                ,
                230
            ],
            1452: [
                ,
                230
            ],
            1453: [
                ,
                222
            ],
            1454: [
                ,
                228
            ],
            1455: [
                ,
                230
            ],
            1456: [
                ,
                10
            ],
            1457: [
                ,
                11
            ],
            1458: [
                ,
                12
            ],
            1459: [
                ,
                13
            ],
            1460: [
                ,
                14
            ],
            1461: [
                ,
                15
            ],
            1462: [
                ,
                16
            ],
            1463: [
                ,
                17
            ],
            1464: [
                ,
                18
            ],
            1465: [
                ,
                19
            ],
            1466: [
                ,
                19
            ],
            1467: [
                ,
                20
            ],
            1468: [
                ,
                21
            ],
            1469: [
                ,
                22
            ],
            1471: [
                ,
                23
            ],
            1473: [
                ,
                24
            ],
            1474: [
                ,
                25
            ],
            1476: [
                ,
                230
            ],
            1477: [
                ,
                220
            ],
            1479: [
                ,
                18
            ]
        },
        1536: {
            1552: [
                ,
                230
            ],
            1553: [
                ,
                230
            ],
            1554: [
                ,
                230
            ],
            1555: [
                ,
                230
            ],
            1556: [
                ,
                230
            ],
            1557: [
                ,
                230
            ],
            1558: [
                ,
                230
            ],
            1559: [
                ,
                230
            ],
            1560: [
                ,
                30
            ],
            1561: [
                ,
                31
            ],
            1562: [
                ,
                32
            ],
            1570: [
                [
                    1575,
                    1619
                ]
            ],
            1571: [
                [
                    1575,
                    1620
                ]
            ],
            1572: [
                [
                    1608,
                    1620
                ]
            ],
            1573: [
                [
                    1575,
                    1621
                ]
            ],
            1574: [
                [
                    1610,
                    1620
                ]
            ],
            1575: [
                ,
                ,
                {
                    1619: 1570,
                    1620: 1571,
                    1621: 1573
                }
            ],
            1608: [
                ,
                ,
                {
                    1620: 1572
                }
            ],
            1610: [
                ,
                ,
                {
                    1620: 1574
                }
            ],
            1611: [
                ,
                27
            ],
            1612: [
                ,
                28
            ],
            1613: [
                ,
                29
            ],
            1614: [
                ,
                30
            ],
            1615: [
                ,
                31
            ],
            1616: [
                ,
                32
            ],
            1617: [
                ,
                33
            ],
            1618: [
                ,
                34
            ],
            1619: [
                ,
                230
            ],
            1620: [
                ,
                230
            ],
            1621: [
                ,
                220
            ],
            1622: [
                ,
                220
            ],
            1623: [
                ,
                230
            ],
            1624: [
                ,
                230
            ],
            1625: [
                ,
                230
            ],
            1626: [
                ,
                230
            ],
            1627: [
                ,
                230
            ],
            1628: [
                ,
                220
            ],
            1629: [
                ,
                230
            ],
            1630: [
                ,
                230
            ],
            1631: [
                ,
                220
            ],
            1648: [
                ,
                35
            ],
            1653: [
                [
                    1575,
                    1652
                ],
                256
            ],
            1654: [
                [
                    1608,
                    1652
                ],
                256
            ],
            1655: [
                [
                    1735,
                    1652
                ],
                256
            ],
            1656: [
                [
                    1610,
                    1652
                ],
                256
            ],
            1728: [
                [
                    1749,
                    1620
                ]
            ],
            1729: [
                ,
                ,
                {
                    1620: 1730
                }
            ],
            1730: [
                [
                    1729,
                    1620
                ]
            ],
            1746: [
                ,
                ,
                {
                    1620: 1747
                }
            ],
            1747: [
                [
                    1746,
                    1620
                ]
            ],
            1749: [
                ,
                ,
                {
                    1620: 1728
                }
            ],
            1750: [
                ,
                230
            ],
            1751: [
                ,
                230
            ],
            1752: [
                ,
                230
            ],
            1753: [
                ,
                230
            ],
            1754: [
                ,
                230
            ],
            1755: [
                ,
                230
            ],
            1756: [
                ,
                230
            ],
            1759: [
                ,
                230
            ],
            1760: [
                ,
                230
            ],
            1761: [
                ,
                230
            ],
            1762: [
                ,
                230
            ],
            1763: [
                ,
                220
            ],
            1764: [
                ,
                230
            ],
            1767: [
                ,
                230
            ],
            1768: [
                ,
                230
            ],
            1770: [
                ,
                220
            ],
            1771: [
                ,
                230
            ],
            1772: [
                ,
                230
            ],
            1773: [
                ,
                220
            ]
        },
        1792: {
            1809: [
                ,
                36
            ],
            1840: [
                ,
                230
            ],
            1841: [
                ,
                220
            ],
            1842: [
                ,
                230
            ],
            1843: [
                ,
                230
            ],
            1844: [
                ,
                220
            ],
            1845: [
                ,
                230
            ],
            1846: [
                ,
                230
            ],
            1847: [
                ,
                220
            ],
            1848: [
                ,
                220
            ],
            1849: [
                ,
                220
            ],
            1850: [
                ,
                230
            ],
            1851: [
                ,
                220
            ],
            1852: [
                ,
                220
            ],
            1853: [
                ,
                230
            ],
            1854: [
                ,
                220
            ],
            1855: [
                ,
                230
            ],
            1856: [
                ,
                230
            ],
            1857: [
                ,
                230
            ],
            1858: [
                ,
                220
            ],
            1859: [
                ,
                230
            ],
            1860: [
                ,
                220
            ],
            1861: [
                ,
                230
            ],
            1862: [
                ,
                220
            ],
            1863: [
                ,
                230
            ],
            1864: [
                ,
                220
            ],
            1865: [
                ,
                230
            ],
            1866: [
                ,
                230
            ],
            2027: [
                ,
                230
            ],
            2028: [
                ,
                230
            ],
            2029: [
                ,
                230
            ],
            2030: [
                ,
                230
            ],
            2031: [
                ,
                230
            ],
            2032: [
                ,
                230
            ],
            2033: [
                ,
                230
            ],
            2034: [
                ,
                220
            ],
            2035: [
                ,
                230
            ]
        },
        2048: {
            2070: [
                ,
                230
            ],
            2071: [
                ,
                230
            ],
            2072: [
                ,
                230
            ],
            2073: [
                ,
                230
            ],
            2075: [
                ,
                230
            ],
            2076: [
                ,
                230
            ],
            2077: [
                ,
                230
            ],
            2078: [
                ,
                230
            ],
            2079: [
                ,
                230
            ],
            2080: [
                ,
                230
            ],
            2081: [
                ,
                230
            ],
            2082: [
                ,
                230
            ],
            2083: [
                ,
                230
            ],
            2085: [
                ,
                230
            ],
            2086: [
                ,
                230
            ],
            2087: [
                ,
                230
            ],
            2089: [
                ,
                230
            ],
            2090: [
                ,
                230
            ],
            2091: [
                ,
                230
            ],
            2092: [
                ,
                230
            ],
            2093: [
                ,
                230
            ],
            2137: [
                ,
                220
            ],
            2138: [
                ,
                220
            ],
            2139: [
                ,
                220
            ],
            2276: [
                ,
                230
            ],
            2277: [
                ,
                230
            ],
            2278: [
                ,
                220
            ],
            2279: [
                ,
                230
            ],
            2280: [
                ,
                230
            ],
            2281: [
                ,
                220
            ],
            2282: [
                ,
                230
            ],
            2283: [
                ,
                230
            ],
            2284: [
                ,
                230
            ],
            2285: [
                ,
                220
            ],
            2286: [
                ,
                220
            ],
            2287: [
                ,
                220
            ],
            2288: [
                ,
                27
            ],
            2289: [
                ,
                28
            ],
            2290: [
                ,
                29
            ],
            2291: [
                ,
                230
            ],
            2292: [
                ,
                230
            ],
            2293: [
                ,
                230
            ],
            2294: [
                ,
                220
            ],
            2295: [
                ,
                230
            ],
            2296: [
                ,
                230
            ],
            2297: [
                ,
                220
            ],
            2298: [
                ,
                220
            ],
            2299: [
                ,
                230
            ],
            2300: [
                ,
                230
            ],
            2301: [
                ,
                230
            ],
            2302: [
                ,
                230
            ],
            2303: [
                ,
                230
            ]
        },
        2304: {
            2344: [
                ,
                ,
                {
                    2364: 2345
                }
            ],
            2345: [
                [
                    2344,
                    2364
                ]
            ],
            2352: [
                ,
                ,
                {
                    2364: 2353
                }
            ],
            2353: [
                [
                    2352,
                    2364
                ]
            ],
            2355: [
                ,
                ,
                {
                    2364: 2356
                }
            ],
            2356: [
                [
                    2355,
                    2364
                ]
            ],
            2364: [
                ,
                7
            ],
            2381: [
                ,
                9
            ],
            2385: [
                ,
                230
            ],
            2386: [
                ,
                220
            ],
            2387: [
                ,
                230
            ],
            2388: [
                ,
                230
            ],
            2392: [
                [
                    2325,
                    2364
                ],
                512
            ],
            2393: [
                [
                    2326,
                    2364
                ],
                512
            ],
            2394: [
                [
                    2327,
                    2364
                ],
                512
            ],
            2395: [
                [
                    2332,
                    2364
                ],
                512
            ],
            2396: [
                [
                    2337,
                    2364
                ],
                512
            ],
            2397: [
                [
                    2338,
                    2364
                ],
                512
            ],
            2398: [
                [
                    2347,
                    2364
                ],
                512
            ],
            2399: [
                [
                    2351,
                    2364
                ],
                512
            ],
            2492: [
                ,
                7
            ],
            2503: [
                ,
                ,
                {
                    2494: 2507,
                    2519: 2508
                }
            ],
            2507: [
                [
                    2503,
                    2494
                ]
            ],
            2508: [
                [
                    2503,
                    2519
                ]
            ],
            2509: [
                ,
                9
            ],
            2524: [
                [
                    2465,
                    2492
                ],
                512
            ],
            2525: [
                [
                    2466,
                    2492
                ],
                512
            ],
            2527: [
                [
                    2479,
                    2492
                ],
                512
            ]
        },
        2560: {
            2611: [
                [
                    2610,
                    2620
                ],
                512
            ],
            2614: [
                [
                    2616,
                    2620
                ],
                512
            ],
            2620: [
                ,
                7
            ],
            2637: [
                ,
                9
            ],
            2649: [
                [
                    2582,
                    2620
                ],
                512
            ],
            2650: [
                [
                    2583,
                    2620
                ],
                512
            ],
            2651: [
                [
                    2588,
                    2620
                ],
                512
            ],
            2654: [
                [
                    2603,
                    2620
                ],
                512
            ],
            2748: [
                ,
                7
            ],
            2765: [
                ,
                9
            ],
            68109: [
                ,
                220
            ],
            68111: [
                ,
                230
            ],
            68152: [
                ,
                230
            ],
            68153: [
                ,
                1
            ],
            68154: [
                ,
                220
            ],
            68159: [
                ,
                9
            ],
            68325: [
                ,
                230
            ],
            68326: [
                ,
                220
            ]
        },
        2816: {
            2876: [
                ,
                7
            ],
            2887: [
                ,
                ,
                {
                    2878: 2891,
                    2902: 2888,
                    2903: 2892
                }
            ],
            2888: [
                [
                    2887,
                    2902
                ]
            ],
            2891: [
                [
                    2887,
                    2878
                ]
            ],
            2892: [
                [
                    2887,
                    2903
                ]
            ],
            2893: [
                ,
                9
            ],
            2908: [
                [
                    2849,
                    2876
                ],
                512
            ],
            2909: [
                [
                    2850,
                    2876
                ],
                512
            ],
            2962: [
                ,
                ,
                {
                    3031: 2964
                }
            ],
            2964: [
                [
                    2962,
                    3031
                ]
            ],
            3014: [
                ,
                ,
                {
                    3006: 3018,
                    3031: 3020
                }
            ],
            3015: [
                ,
                ,
                {
                    3006: 3019
                }
            ],
            3018: [
                [
                    3014,
                    3006
                ]
            ],
            3019: [
                [
                    3015,
                    3006
                ]
            ],
            3020: [
                [
                    3014,
                    3031
                ]
            ],
            3021: [
                ,
                9
            ]
        },
        3072: {
            3142: [
                ,
                ,
                {
                    3158: 3144
                }
            ],
            3144: [
                [
                    3142,
                    3158
                ]
            ],
            3149: [
                ,
                9
            ],
            3157: [
                ,
                84
            ],
            3158: [
                ,
                91
            ],
            3260: [
                ,
                7
            ],
            3263: [
                ,
                ,
                {
                    3285: 3264
                }
            ],
            3264: [
                [
                    3263,
                    3285
                ]
            ],
            3270: [
                ,
                ,
                {
                    3266: 3274,
                    3285: 3271,
                    3286: 3272
                }
            ],
            3271: [
                [
                    3270,
                    3285
                ]
            ],
            3272: [
                [
                    3270,
                    3286
                ]
            ],
            3274: [
                [
                    3270,
                    3266
                ],
                ,
                {
                    3285: 3275
                }
            ],
            3275: [
                [
                    3274,
                    3285
                ]
            ],
            3277: [
                ,
                9
            ]
        },
        3328: {
            3398: [
                ,
                ,
                {
                    3390: 3402,
                    3415: 3404
                }
            ],
            3399: [
                ,
                ,
                {
                    3390: 3403
                }
            ],
            3402: [
                [
                    3398,
                    3390
                ]
            ],
            3403: [
                [
                    3399,
                    3390
                ]
            ],
            3404: [
                [
                    3398,
                    3415
                ]
            ],
            3405: [
                ,
                9
            ],
            3530: [
                ,
                9
            ],
            3545: [
                ,
                ,
                {
                    3530: 3546,
                    3535: 3548,
                    3551: 3550
                }
            ],
            3546: [
                [
                    3545,
                    3530
                ]
            ],
            3548: [
                [
                    3545,
                    3535
                ],
                ,
                {
                    3530: 3549
                }
            ],
            3549: [
                [
                    3548,
                    3530
                ]
            ],
            3550: [
                [
                    3545,
                    3551
                ]
            ]
        },
        3584: {
            3635: [
                [
                    3661,
                    3634
                ],
                256
            ],
            3640: [
                ,
                103
            ],
            3641: [
                ,
                103
            ],
            3642: [
                ,
                9
            ],
            3656: [
                ,
                107
            ],
            3657: [
                ,
                107
            ],
            3658: [
                ,
                107
            ],
            3659: [
                ,
                107
            ],
            3763: [
                [
                    3789,
                    3762
                ],
                256
            ],
            3768: [
                ,
                118
            ],
            3769: [
                ,
                118
            ],
            3784: [
                ,
                122
            ],
            3785: [
                ,
                122
            ],
            3786: [
                ,
                122
            ],
            3787: [
                ,
                122
            ],
            3804: [
                [
                    3755,
                    3737
                ],
                256
            ],
            3805: [
                [
                    3755,
                    3745
                ],
                256
            ]
        },
        3840: {
            3852: [
                [
                    3851
                ],
                256
            ],
            3864: [
                ,
                220
            ],
            3865: [
                ,
                220
            ],
            3893: [
                ,
                220
            ],
            3895: [
                ,
                220
            ],
            3897: [
                ,
                216
            ],
            3907: [
                [
                    3906,
                    4023
                ],
                512
            ],
            3917: [
                [
                    3916,
                    4023
                ],
                512
            ],
            3922: [
                [
                    3921,
                    4023
                ],
                512
            ],
            3927: [
                [
                    3926,
                    4023
                ],
                512
            ],
            3932: [
                [
                    3931,
                    4023
                ],
                512
            ],
            3945: [
                [
                    3904,
                    4021
                ],
                512
            ],
            3953: [
                ,
                129
            ],
            3954: [
                ,
                130
            ],
            3955: [
                [
                    3953,
                    3954
                ],
                512
            ],
            3956: [
                ,
                132
            ],
            3957: [
                [
                    3953,
                    3956
                ],
                512
            ],
            3958: [
                [
                    4018,
                    3968
                ],
                512
            ],
            3959: [
                [
                    4018,
                    3969
                ],
                256
            ],
            3960: [
                [
                    4019,
                    3968
                ],
                512
            ],
            3961: [
                [
                    4019,
                    3969
                ],
                256
            ],
            3962: [
                ,
                130
            ],
            3963: [
                ,
                130
            ],
            3964: [
                ,
                130
            ],
            3965: [
                ,
                130
            ],
            3968: [
                ,
                130
            ],
            3969: [
                [
                    3953,
                    3968
                ],
                512
            ],
            3970: [
                ,
                230
            ],
            3971: [
                ,
                230
            ],
            3972: [
                ,
                9
            ],
            3974: [
                ,
                230
            ],
            3975: [
                ,
                230
            ],
            3987: [
                [
                    3986,
                    4023
                ],
                512
            ],
            3997: [
                [
                    3996,
                    4023
                ],
                512
            ],
            4002: [
                [
                    4001,
                    4023
                ],
                512
            ],
            4007: [
                [
                    4006,
                    4023
                ],
                512
            ],
            4012: [
                [
                    4011,
                    4023
                ],
                512
            ],
            4025: [
                [
                    3984,
                    4021
                ],
                512
            ],
            4038: [
                ,
                220
            ]
        },
        4096: {
            4133: [
                ,
                ,
                {
                    4142: 4134
                }
            ],
            4134: [
                [
                    4133,
                    4142
                ]
            ],
            4151: [
                ,
                7
            ],
            4153: [
                ,
                9
            ],
            4154: [
                ,
                9
            ],
            4237: [
                ,
                220
            ],
            4348: [
                [
                    4316
                ],
                256
            ],
            69702: [
                ,
                9
            ],
            69759: [
                ,
                9
            ],
            69785: [
                ,
                ,
                {
                    69818: 69786
                }
            ],
            69786: [
                [
                    69785,
                    69818
                ]
            ],
            69787: [
                ,
                ,
                {
                    69818: 69788
                }
            ],
            69788: [
                [
                    69787,
                    69818
                ]
            ],
            69797: [
                ,
                ,
                {
                    69818: 69803
                }
            ],
            69803: [
                [
                    69797,
                    69818
                ]
            ],
            69817: [
                ,
                9
            ],
            69818: [
                ,
                7
            ]
        },
        4352: {
            69888: [
                ,
                230
            ],
            69889: [
                ,
                230
            ],
            69890: [
                ,
                230
            ],
            69934: [
                [
                    69937,
                    69927
                ]
            ],
            69935: [
                [
                    69938,
                    69927
                ]
            ],
            69937: [
                ,
                ,
                {
                    69927: 69934
                }
            ],
            69938: [
                ,
                ,
                {
                    69927: 69935
                }
            ],
            69939: [
                ,
                9
            ],
            69940: [
                ,
                9
            ],
            70003: [
                ,
                7
            ],
            70080: [
                ,
                9
            ]
        },
        4608: {
            70197: [
                ,
                9
            ],
            70198: [
                ,
                7
            ],
            70377: [
                ,
                7
            ],
            70378: [
                ,
                9
            ]
        },
        4864: {
            4957: [
                ,
                230
            ],
            4958: [
                ,
                230
            ],
            4959: [
                ,
                230
            ],
            70460: [
                ,
                7
            ],
            70471: [
                ,
                ,
                {
                    70462: 70475,
                    70487: 70476
                }
            ],
            70475: [
                [
                    70471,
                    70462
                ]
            ],
            70476: [
                [
                    70471,
                    70487
                ]
            ],
            70477: [
                ,
                9
            ],
            70502: [
                ,
                230
            ],
            70503: [
                ,
                230
            ],
            70504: [
                ,
                230
            ],
            70505: [
                ,
                230
            ],
            70506: [
                ,
                230
            ],
            70507: [
                ,
                230
            ],
            70508: [
                ,
                230
            ],
            70512: [
                ,
                230
            ],
            70513: [
                ,
                230
            ],
            70514: [
                ,
                230
            ],
            70515: [
                ,
                230
            ],
            70516: [
                ,
                230
            ]
        },
        5120: {
            70841: [
                ,
                ,
                {
                    70832: 70844,
                    70842: 70843,
                    70845: 70846
                }
            ],
            70843: [
                [
                    70841,
                    70842
                ]
            ],
            70844: [
                [
                    70841,
                    70832
                ]
            ],
            70846: [
                [
                    70841,
                    70845
                ]
            ],
            70850: [
                ,
                9
            ],
            70851: [
                ,
                7
            ]
        },
        5376: {
            71096: [
                ,
                ,
                {
                    71087: 71098
                }
            ],
            71097: [
                ,
                ,
                {
                    71087: 71099
                }
            ],
            71098: [
                [
                    71096,
                    71087
                ]
            ],
            71099: [
                [
                    71097,
                    71087
                ]
            ],
            71103: [
                ,
                9
            ],
            71104: [
                ,
                7
            ]
        },
        5632: {
            71231: [
                ,
                9
            ],
            71350: [
                ,
                9
            ],
            71351: [
                ,
                7
            ]
        },
        5888: {
            5908: [
                ,
                9
            ],
            5940: [
                ,
                9
            ],
            6098: [
                ,
                9
            ],
            6109: [
                ,
                230
            ]
        },
        6144: {
            6313: [
                ,
                228
            ]
        },
        6400: {
            6457: [
                ,
                222
            ],
            6458: [
                ,
                230
            ],
            6459: [
                ,
                220
            ]
        },
        6656: {
            6679: [
                ,
                230
            ],
            6680: [
                ,
                220
            ],
            6752: [
                ,
                9
            ],
            6773: [
                ,
                230
            ],
            6774: [
                ,
                230
            ],
            6775: [
                ,
                230
            ],
            6776: [
                ,
                230
            ],
            6777: [
                ,
                230
            ],
            6778: [
                ,
                230
            ],
            6779: [
                ,
                230
            ],
            6780: [
                ,
                230
            ],
            6783: [
                ,
                220
            ],
            6832: [
                ,
                230
            ],
            6833: [
                ,
                230
            ],
            6834: [
                ,
                230
            ],
            6835: [
                ,
                230
            ],
            6836: [
                ,
                230
            ],
            6837: [
                ,
                220
            ],
            6838: [
                ,
                220
            ],
            6839: [
                ,
                220
            ],
            6840: [
                ,
                220
            ],
            6841: [
                ,
                220
            ],
            6842: [
                ,
                220
            ],
            6843: [
                ,
                230
            ],
            6844: [
                ,
                230
            ],
            6845: [
                ,
                220
            ]
        },
        6912: {
            6917: [
                ,
                ,
                {
                    6965: 6918
                }
            ],
            6918: [
                [
                    6917,
                    6965
                ]
            ],
            6919: [
                ,
                ,
                {
                    6965: 6920
                }
            ],
            6920: [
                [
                    6919,
                    6965
                ]
            ],
            6921: [
                ,
                ,
                {
                    6965: 6922
                }
            ],
            6922: [
                [
                    6921,
                    6965
                ]
            ],
            6923: [
                ,
                ,
                {
                    6965: 6924
                }
            ],
            6924: [
                [
                    6923,
                    6965
                ]
            ],
            6925: [
                ,
                ,
                {
                    6965: 6926
                }
            ],
            6926: [
                [
                    6925,
                    6965
                ]
            ],
            6929: [
                ,
                ,
                {
                    6965: 6930
                }
            ],
            6930: [
                [
                    6929,
                    6965
                ]
            ],
            6964: [
                ,
                7
            ],
            6970: [
                ,
                ,
                {
                    6965: 6971
                }
            ],
            6971: [
                [
                    6970,
                    6965
                ]
            ],
            6972: [
                ,
                ,
                {
                    6965: 6973
                }
            ],
            6973: [
                [
                    6972,
                    6965
                ]
            ],
            6974: [
                ,
                ,
                {
                    6965: 6976
                }
            ],
            6975: [
                ,
                ,
                {
                    6965: 6977
                }
            ],
            6976: [
                [
                    6974,
                    6965
                ]
            ],
            6977: [
                [
                    6975,
                    6965
                ]
            ],
            6978: [
                ,
                ,
                {
                    6965: 6979
                }
            ],
            6979: [
                [
                    6978,
                    6965
                ]
            ],
            6980: [
                ,
                9
            ],
            7019: [
                ,
                230
            ],
            7020: [
                ,
                220
            ],
            7021: [
                ,
                230
            ],
            7022: [
                ,
                230
            ],
            7023: [
                ,
                230
            ],
            7024: [
                ,
                230
            ],
            7025: [
                ,
                230
            ],
            7026: [
                ,
                230
            ],
            7027: [
                ,
                230
            ],
            7082: [
                ,
                9
            ],
            7083: [
                ,
                9
            ],
            7142: [
                ,
                7
            ],
            7154: [
                ,
                9
            ],
            7155: [
                ,
                9
            ]
        },
        7168: {
            7223: [
                ,
                7
            ],
            7376: [
                ,
                230
            ],
            7377: [
                ,
                230
            ],
            7378: [
                ,
                230
            ],
            7380: [
                ,
                1
            ],
            7381: [
                ,
                220
            ],
            7382: [
                ,
                220
            ],
            7383: [
                ,
                220
            ],
            7384: [
                ,
                220
            ],
            7385: [
                ,
                220
            ],
            7386: [
                ,
                230
            ],
            7387: [
                ,
                230
            ],
            7388: [
                ,
                220
            ],
            7389: [
                ,
                220
            ],
            7390: [
                ,
                220
            ],
            7391: [
                ,
                220
            ],
            7392: [
                ,
                230
            ],
            7394: [
                ,
                1
            ],
            7395: [
                ,
                1
            ],
            7396: [
                ,
                1
            ],
            7397: [
                ,
                1
            ],
            7398: [
                ,
                1
            ],
            7399: [
                ,
                1
            ],
            7400: [
                ,
                1
            ],
            7405: [
                ,
                220
            ],
            7412: [
                ,
                230
            ],
            7416: [
                ,
                230
            ],
            7417: [
                ,
                230
            ]
        },
        7424: {
            7468: [
                [
                    65
                ],
                256
            ],
            7469: [
                [
                    198
                ],
                256
            ],
            7470: [
                [
                    66
                ],
                256
            ],
            7472: [
                [
                    68
                ],
                256
            ],
            7473: [
                [
                    69
                ],
                256
            ],
            7474: [
                [
                    398
                ],
                256
            ],
            7475: [
                [
                    71
                ],
                256
            ],
            7476: [
                [
                    72
                ],
                256
            ],
            7477: [
                [
                    73
                ],
                256
            ],
            7478: [
                [
                    74
                ],
                256
            ],
            7479: [
                [
                    75
                ],
                256
            ],
            7480: [
                [
                    76
                ],
                256
            ],
            7481: [
                [
                    77
                ],
                256
            ],
            7482: [
                [
                    78
                ],
                256
            ],
            7484: [
                [
                    79
                ],
                256
            ],
            7485: [
                [
                    546
                ],
                256
            ],
            7486: [
                [
                    80
                ],
                256
            ],
            7487: [
                [
                    82
                ],
                256
            ],
            7488: [
                [
                    84
                ],
                256
            ],
            7489: [
                [
                    85
                ],
                256
            ],
            7490: [
                [
                    87
                ],
                256
            ],
            7491: [
                [
                    97
                ],
                256
            ],
            7492: [
                [
                    592
                ],
                256
            ],
            7493: [
                [
                    593
                ],
                256
            ],
            7494: [
                [
                    7426
                ],
                256
            ],
            7495: [
                [
                    98
                ],
                256
            ],
            7496: [
                [
                    100
                ],
                256
            ],
            7497: [
                [
                    101
                ],
                256
            ],
            7498: [
                [
                    601
                ],
                256
            ],
            7499: [
                [
                    603
                ],
                256
            ],
            7500: [
                [
                    604
                ],
                256
            ],
            7501: [
                [
                    103
                ],
                256
            ],
            7503: [
                [
                    107
                ],
                256
            ],
            7504: [
                [
                    109
                ],
                256
            ],
            7505: [
                [
                    331
                ],
                256
            ],
            7506: [
                [
                    111
                ],
                256
            ],
            7507: [
                [
                    596
                ],
                256
            ],
            7508: [
                [
                    7446
                ],
                256
            ],
            7509: [
                [
                    7447
                ],
                256
            ],
            7510: [
                [
                    112
                ],
                256
            ],
            7511: [
                [
                    116
                ],
                256
            ],
            7512: [
                [
                    117
                ],
                256
            ],
            7513: [
                [
                    7453
                ],
                256
            ],
            7514: [
                [
                    623
                ],
                256
            ],
            7515: [
                [
                    118
                ],
                256
            ],
            7516: [
                [
                    7461
                ],
                256
            ],
            7517: [
                [
                    946
                ],
                256
            ],
            7518: [
                [
                    947
                ],
                256
            ],
            7519: [
                [
                    948
                ],
                256
            ],
            7520: [
                [
                    966
                ],
                256
            ],
            7521: [
                [
                    967
                ],
                256
            ],
            7522: [
                [
                    105
                ],
                256
            ],
            7523: [
                [
                    114
                ],
                256
            ],
            7524: [
                [
                    117
                ],
                256
            ],
            7525: [
                [
                    118
                ],
                256
            ],
            7526: [
                [
                    946
                ],
                256
            ],
            7527: [
                [
                    947
                ],
                256
            ],
            7528: [
                [
                    961
                ],
                256
            ],
            7529: [
                [
                    966
                ],
                256
            ],
            7530: [
                [
                    967
                ],
                256
            ],
            7544: [
                [
                    1085
                ],
                256
            ],
            7579: [
                [
                    594
                ],
                256
            ],
            7580: [
                [
                    99
                ],
                256
            ],
            7581: [
                [
                    597
                ],
                256
            ],
            7582: [
                [
                    240
                ],
                256
            ],
            7583: [
                [
                    604
                ],
                256
            ],
            7584: [
                [
                    102
                ],
                256
            ],
            7585: [
                [
                    607
                ],
                256
            ],
            7586: [
                [
                    609
                ],
                256
            ],
            7587: [
                [
                    613
                ],
                256
            ],
            7588: [
                [
                    616
                ],
                256
            ],
            7589: [
                [
                    617
                ],
                256
            ],
            7590: [
                [
                    618
                ],
                256
            ],
            7591: [
                [
                    7547
                ],
                256
            ],
            7592: [
                [
                    669
                ],
                256
            ],
            7593: [
                [
                    621
                ],
                256
            ],
            7594: [
                [
                    7557
                ],
                256
            ],
            7595: [
                [
                    671
                ],
                256
            ],
            7596: [
                [
                    625
                ],
                256
            ],
            7597: [
                [
                    624
                ],
                256
            ],
            7598: [
                [
                    626
                ],
                256
            ],
            7599: [
                [
                    627
                ],
                256
            ],
            7600: [
                [
                    628
                ],
                256
            ],
            7601: [
                [
                    629
                ],
                256
            ],
            7602: [
                [
                    632
                ],
                256
            ],
            7603: [
                [
                    642
                ],
                256
            ],
            7604: [
                [
                    643
                ],
                256
            ],
            7605: [
                [
                    427
                ],
                256
            ],
            7606: [
                [
                    649
                ],
                256
            ],
            7607: [
                [
                    650
                ],
                256
            ],
            7608: [
                [
                    7452
                ],
                256
            ],
            7609: [
                [
                    651
                ],
                256
            ],
            7610: [
                [
                    652
                ],
                256
            ],
            7611: [
                [
                    122
                ],
                256
            ],
            7612: [
                [
                    656
                ],
                256
            ],
            7613: [
                [
                    657
                ],
                256
            ],
            7614: [
                [
                    658
                ],
                256
            ],
            7615: [
                [
                    952
                ],
                256
            ],
            7616: [
                ,
                230
            ],
            7617: [
                ,
                230
            ],
            7618: [
                ,
                220
            ],
            7619: [
                ,
                230
            ],
            7620: [
                ,
                230
            ],
            7621: [
                ,
                230
            ],
            7622: [
                ,
                230
            ],
            7623: [
                ,
                230
            ],
            7624: [
                ,
                230
            ],
            7625: [
                ,
                230
            ],
            7626: [
                ,
                220
            ],
            7627: [
                ,
                230
            ],
            7628: [
                ,
                230
            ],
            7629: [
                ,
                234
            ],
            7630: [
                ,
                214
            ],
            7631: [
                ,
                220
            ],
            7632: [
                ,
                202
            ],
            7633: [
                ,
                230
            ],
            7634: [
                ,
                230
            ],
            7635: [
                ,
                230
            ],
            7636: [
                ,
                230
            ],
            7637: [
                ,
                230
            ],
            7638: [
                ,
                230
            ],
            7639: [
                ,
                230
            ],
            7640: [
                ,
                230
            ],
            7641: [
                ,
                230
            ],
            7642: [
                ,
                230
            ],
            7643: [
                ,
                230
            ],
            7644: [
                ,
                230
            ],
            7645: [
                ,
                230
            ],
            7646: [
                ,
                230
            ],
            7647: [
                ,
                230
            ],
            7648: [
                ,
                230
            ],
            7649: [
                ,
                230
            ],
            7650: [
                ,
                230
            ],
            7651: [
                ,
                230
            ],
            7652: [
                ,
                230
            ],
            7653: [
                ,
                230
            ],
            7654: [
                ,
                230
            ],
            7655: [
                ,
                230
            ],
            7656: [
                ,
                230
            ],
            7657: [
                ,
                230
            ],
            7658: [
                ,
                230
            ],
            7659: [
                ,
                230
            ],
            7660: [
                ,
                230
            ],
            7661: [
                ,
                230
            ],
            7662: [
                ,
                230
            ],
            7663: [
                ,
                230
            ],
            7664: [
                ,
                230
            ],
            7665: [
                ,
                230
            ],
            7666: [
                ,
                230
            ],
            7667: [
                ,
                230
            ],
            7668: [
                ,
                230
            ],
            7669: [
                ,
                230
            ],
            7676: [
                ,
                233
            ],
            7677: [
                ,
                220
            ],
            7678: [
                ,
                230
            ],
            7679: [
                ,
                220
            ]
        },
        7680: {
            7680: [
                [
                    65,
                    805
                ]
            ],
            7681: [
                [
                    97,
                    805
                ]
            ],
            7682: [
                [
                    66,
                    775
                ]
            ],
            7683: [
                [
                    98,
                    775
                ]
            ],
            7684: [
                [
                    66,
                    803
                ]
            ],
            7685: [
                [
                    98,
                    803
                ]
            ],
            7686: [
                [
                    66,
                    817
                ]
            ],
            7687: [
                [
                    98,
                    817
                ]
            ],
            7688: [
                [
                    199,
                    769
                ]
            ],
            7689: [
                [
                    231,
                    769
                ]
            ],
            7690: [
                [
                    68,
                    775
                ]
            ],
            7691: [
                [
                    100,
                    775
                ]
            ],
            7692: [
                [
                    68,
                    803
                ]
            ],
            7693: [
                [
                    100,
                    803
                ]
            ],
            7694: [
                [
                    68,
                    817
                ]
            ],
            7695: [
                [
                    100,
                    817
                ]
            ],
            7696: [
                [
                    68,
                    807
                ]
            ],
            7697: [
                [
                    100,
                    807
                ]
            ],
            7698: [
                [
                    68,
                    813
                ]
            ],
            7699: [
                [
                    100,
                    813
                ]
            ],
            7700: [
                [
                    274,
                    768
                ]
            ],
            7701: [
                [
                    275,
                    768
                ]
            ],
            7702: [
                [
                    274,
                    769
                ]
            ],
            7703: [
                [
                    275,
                    769
                ]
            ],
            7704: [
                [
                    69,
                    813
                ]
            ],
            7705: [
                [
                    101,
                    813
                ]
            ],
            7706: [
                [
                    69,
                    816
                ]
            ],
            7707: [
                [
                    101,
                    816
                ]
            ],
            7708: [
                [
                    552,
                    774
                ]
            ],
            7709: [
                [
                    553,
                    774
                ]
            ],
            7710: [
                [
                    70,
                    775
                ]
            ],
            7711: [
                [
                    102,
                    775
                ]
            ],
            7712: [
                [
                    71,
                    772
                ]
            ],
            7713: [
                [
                    103,
                    772
                ]
            ],
            7714: [
                [
                    72,
                    775
                ]
            ],
            7715: [
                [
                    104,
                    775
                ]
            ],
            7716: [
                [
                    72,
                    803
                ]
            ],
            7717: [
                [
                    104,
                    803
                ]
            ],
            7718: [
                [
                    72,
                    776
                ]
            ],
            7719: [
                [
                    104,
                    776
                ]
            ],
            7720: [
                [
                    72,
                    807
                ]
            ],
            7721: [
                [
                    104,
                    807
                ]
            ],
            7722: [
                [
                    72,
                    814
                ]
            ],
            7723: [
                [
                    104,
                    814
                ]
            ],
            7724: [
                [
                    73,
                    816
                ]
            ],
            7725: [
                [
                    105,
                    816
                ]
            ],
            7726: [
                [
                    207,
                    769
                ]
            ],
            7727: [
                [
                    239,
                    769
                ]
            ],
            7728: [
                [
                    75,
                    769
                ]
            ],
            7729: [
                [
                    107,
                    769
                ]
            ],
            7730: [
                [
                    75,
                    803
                ]
            ],
            7731: [
                [
                    107,
                    803
                ]
            ],
            7732: [
                [
                    75,
                    817
                ]
            ],
            7733: [
                [
                    107,
                    817
                ]
            ],
            7734: [
                [
                    76,
                    803
                ],
                ,
                {
                    772: 7736
                }
            ],
            7735: [
                [
                    108,
                    803
                ],
                ,
                {
                    772: 7737
                }
            ],
            7736: [
                [
                    7734,
                    772
                ]
            ],
            7737: [
                [
                    7735,
                    772
                ]
            ],
            7738: [
                [
                    76,
                    817
                ]
            ],
            7739: [
                [
                    108,
                    817
                ]
            ],
            7740: [
                [
                    76,
                    813
                ]
            ],
            7741: [
                [
                    108,
                    813
                ]
            ],
            7742: [
                [
                    77,
                    769
                ]
            ],
            7743: [
                [
                    109,
                    769
                ]
            ],
            7744: [
                [
                    77,
                    775
                ]
            ],
            7745: [
                [
                    109,
                    775
                ]
            ],
            7746: [
                [
                    77,
                    803
                ]
            ],
            7747: [
                [
                    109,
                    803
                ]
            ],
            7748: [
                [
                    78,
                    775
                ]
            ],
            7749: [
                [
                    110,
                    775
                ]
            ],
            7750: [
                [
                    78,
                    803
                ]
            ],
            7751: [
                [
                    110,
                    803
                ]
            ],
            7752: [
                [
                    78,
                    817
                ]
            ],
            7753: [
                [
                    110,
                    817
                ]
            ],
            7754: [
                [
                    78,
                    813
                ]
            ],
            7755: [
                [
                    110,
                    813
                ]
            ],
            7756: [
                [
                    213,
                    769
                ]
            ],
            7757: [
                [
                    245,
                    769
                ]
            ],
            7758: [
                [
                    213,
                    776
                ]
            ],
            7759: [
                [
                    245,
                    776
                ]
            ],
            7760: [
                [
                    332,
                    768
                ]
            ],
            7761: [
                [
                    333,
                    768
                ]
            ],
            7762: [
                [
                    332,
                    769
                ]
            ],
            7763: [
                [
                    333,
                    769
                ]
            ],
            7764: [
                [
                    80,
                    769
                ]
            ],
            7765: [
                [
                    112,
                    769
                ]
            ],
            7766: [
                [
                    80,
                    775
                ]
            ],
            7767: [
                [
                    112,
                    775
                ]
            ],
            7768: [
                [
                    82,
                    775
                ]
            ],
            7769: [
                [
                    114,
                    775
                ]
            ],
            7770: [
                [
                    82,
                    803
                ],
                ,
                {
                    772: 7772
                }
            ],
            7771: [
                [
                    114,
                    803
                ],
                ,
                {
                    772: 7773
                }
            ],
            7772: [
                [
                    7770,
                    772
                ]
            ],
            7773: [
                [
                    7771,
                    772
                ]
            ],
            7774: [
                [
                    82,
                    817
                ]
            ],
            7775: [
                [
                    114,
                    817
                ]
            ],
            7776: [
                [
                    83,
                    775
                ]
            ],
            7777: [
                [
                    115,
                    775
                ]
            ],
            7778: [
                [
                    83,
                    803
                ],
                ,
                {
                    775: 7784
                }
            ],
            7779: [
                [
                    115,
                    803
                ],
                ,
                {
                    775: 7785
                }
            ],
            7780: [
                [
                    346,
                    775
                ]
            ],
            7781: [
                [
                    347,
                    775
                ]
            ],
            7782: [
                [
                    352,
                    775
                ]
            ],
            7783: [
                [
                    353,
                    775
                ]
            ],
            7784: [
                [
                    7778,
                    775
                ]
            ],
            7785: [
                [
                    7779,
                    775
                ]
            ],
            7786: [
                [
                    84,
                    775
                ]
            ],
            7787: [
                [
                    116,
                    775
                ]
            ],
            7788: [
                [
                    84,
                    803
                ]
            ],
            7789: [
                [
                    116,
                    803
                ]
            ],
            7790: [
                [
                    84,
                    817
                ]
            ],
            7791: [
                [
                    116,
                    817
                ]
            ],
            7792: [
                [
                    84,
                    813
                ]
            ],
            7793: [
                [
                    116,
                    813
                ]
            ],
            7794: [
                [
                    85,
                    804
                ]
            ],
            7795: [
                [
                    117,
                    804
                ]
            ],
            7796: [
                [
                    85,
                    816
                ]
            ],
            7797: [
                [
                    117,
                    816
                ]
            ],
            7798: [
                [
                    85,
                    813
                ]
            ],
            7799: [
                [
                    117,
                    813
                ]
            ],
            7800: [
                [
                    360,
                    769
                ]
            ],
            7801: [
                [
                    361,
                    769
                ]
            ],
            7802: [
                [
                    362,
                    776
                ]
            ],
            7803: [
                [
                    363,
                    776
                ]
            ],
            7804: [
                [
                    86,
                    771
                ]
            ],
            7805: [
                [
                    118,
                    771
                ]
            ],
            7806: [
                [
                    86,
                    803
                ]
            ],
            7807: [
                [
                    118,
                    803
                ]
            ],
            7808: [
                [
                    87,
                    768
                ]
            ],
            7809: [
                [
                    119,
                    768
                ]
            ],
            7810: [
                [
                    87,
                    769
                ]
            ],
            7811: [
                [
                    119,
                    769
                ]
            ],
            7812: [
                [
                    87,
                    776
                ]
            ],
            7813: [
                [
                    119,
                    776
                ]
            ],
            7814: [
                [
                    87,
                    775
                ]
            ],
            7815: [
                [
                    119,
                    775
                ]
            ],
            7816: [
                [
                    87,
                    803
                ]
            ],
            7817: [
                [
                    119,
                    803
                ]
            ],
            7818: [
                [
                    88,
                    775
                ]
            ],
            7819: [
                [
                    120,
                    775
                ]
            ],
            7820: [
                [
                    88,
                    776
                ]
            ],
            7821: [
                [
                    120,
                    776
                ]
            ],
            7822: [
                [
                    89,
                    775
                ]
            ],
            7823: [
                [
                    121,
                    775
                ]
            ],
            7824: [
                [
                    90,
                    770
                ]
            ],
            7825: [
                [
                    122,
                    770
                ]
            ],
            7826: [
                [
                    90,
                    803
                ]
            ],
            7827: [
                [
                    122,
                    803
                ]
            ],
            7828: [
                [
                    90,
                    817
                ]
            ],
            7829: [
                [
                    122,
                    817
                ]
            ],
            7830: [
                [
                    104,
                    817
                ]
            ],
            7831: [
                [
                    116,
                    776
                ]
            ],
            7832: [
                [
                    119,
                    778
                ]
            ],
            7833: [
                [
                    121,
                    778
                ]
            ],
            7834: [
                [
                    97,
                    702
                ],
                256
            ],
            7835: [
                [
                    383,
                    775
                ]
            ],
            7840: [
                [
                    65,
                    803
                ],
                ,
                {
                    770: 7852,
                    774: 7862
                }
            ],
            7841: [
                [
                    97,
                    803
                ],
                ,
                {
                    770: 7853,
                    774: 7863
                }
            ],
            7842: [
                [
                    65,
                    777
                ]
            ],
            7843: [
                [
                    97,
                    777
                ]
            ],
            7844: [
                [
                    194,
                    769
                ]
            ],
            7845: [
                [
                    226,
                    769
                ]
            ],
            7846: [
                [
                    194,
                    768
                ]
            ],
            7847: [
                [
                    226,
                    768
                ]
            ],
            7848: [
                [
                    194,
                    777
                ]
            ],
            7849: [
                [
                    226,
                    777
                ]
            ],
            7850: [
                [
                    194,
                    771
                ]
            ],
            7851: [
                [
                    226,
                    771
                ]
            ],
            7852: [
                [
                    7840,
                    770
                ]
            ],
            7853: [
                [
                    7841,
                    770
                ]
            ],
            7854: [
                [
                    258,
                    769
                ]
            ],
            7855: [
                [
                    259,
                    769
                ]
            ],
            7856: [
                [
                    258,
                    768
                ]
            ],
            7857: [
                [
                    259,
                    768
                ]
            ],
            7858: [
                [
                    258,
                    777
                ]
            ],
            7859: [
                [
                    259,
                    777
                ]
            ],
            7860: [
                [
                    258,
                    771
                ]
            ],
            7861: [
                [
                    259,
                    771
                ]
            ],
            7862: [
                [
                    7840,
                    774
                ]
            ],
            7863: [
                [
                    7841,
                    774
                ]
            ],
            7864: [
                [
                    69,
                    803
                ],
                ,
                {
                    770: 7878
                }
            ],
            7865: [
                [
                    101,
                    803
                ],
                ,
                {
                    770: 7879
                }
            ],
            7866: [
                [
                    69,
                    777
                ]
            ],
            7867: [
                [
                    101,
                    777
                ]
            ],
            7868: [
                [
                    69,
                    771
                ]
            ],
            7869: [
                [
                    101,
                    771
                ]
            ],
            7870: [
                [
                    202,
                    769
                ]
            ],
            7871: [
                [
                    234,
                    769
                ]
            ],
            7872: [
                [
                    202,
                    768
                ]
            ],
            7873: [
                [
                    234,
                    768
                ]
            ],
            7874: [
                [
                    202,
                    777
                ]
            ],
            7875: [
                [
                    234,
                    777
                ]
            ],
            7876: [
                [
                    202,
                    771
                ]
            ],
            7877: [
                [
                    234,
                    771
                ]
            ],
            7878: [
                [
                    7864,
                    770
                ]
            ],
            7879: [
                [
                    7865,
                    770
                ]
            ],
            7880: [
                [
                    73,
                    777
                ]
            ],
            7881: [
                [
                    105,
                    777
                ]
            ],
            7882: [
                [
                    73,
                    803
                ]
            ],
            7883: [
                [
                    105,
                    803
                ]
            ],
            7884: [
                [
                    79,
                    803
                ],
                ,
                {
                    770: 7896
                }
            ],
            7885: [
                [
                    111,
                    803
                ],
                ,
                {
                    770: 7897
                }
            ],
            7886: [
                [
                    79,
                    777
                ]
            ],
            7887: [
                [
                    111,
                    777
                ]
            ],
            7888: [
                [
                    212,
                    769
                ]
            ],
            7889: [
                [
                    244,
                    769
                ]
            ],
            7890: [
                [
                    212,
                    768
                ]
            ],
            7891: [
                [
                    244,
                    768
                ]
            ],
            7892: [
                [
                    212,
                    777
                ]
            ],
            7893: [
                [
                    244,
                    777
                ]
            ],
            7894: [
                [
                    212,
                    771
                ]
            ],
            7895: [
                [
                    244,
                    771
                ]
            ],
            7896: [
                [
                    7884,
                    770
                ]
            ],
            7897: [
                [
                    7885,
                    770
                ]
            ],
            7898: [
                [
                    416,
                    769
                ]
            ],
            7899: [
                [
                    417,
                    769
                ]
            ],
            7900: [
                [
                    416,
                    768
                ]
            ],
            7901: [
                [
                    417,
                    768
                ]
            ],
            7902: [
                [
                    416,
                    777
                ]
            ],
            7903: [
                [
                    417,
                    777
                ]
            ],
            7904: [
                [
                    416,
                    771
                ]
            ],
            7905: [
                [
                    417,
                    771
                ]
            ],
            7906: [
                [
                    416,
                    803
                ]
            ],
            7907: [
                [
                    417,
                    803
                ]
            ],
            7908: [
                [
                    85,
                    803
                ]
            ],
            7909: [
                [
                    117,
                    803
                ]
            ],
            7910: [
                [
                    85,
                    777
                ]
            ],
            7911: [
                [
                    117,
                    777
                ]
            ],
            7912: [
                [
                    431,
                    769
                ]
            ],
            7913: [
                [
                    432,
                    769
                ]
            ],
            7914: [
                [
                    431,
                    768
                ]
            ],
            7915: [
                [
                    432,
                    768
                ]
            ],
            7916: [
                [
                    431,
                    777
                ]
            ],
            7917: [
                [
                    432,
                    777
                ]
            ],
            7918: [
                [
                    431,
                    771
                ]
            ],
            7919: [
                [
                    432,
                    771
                ]
            ],
            7920: [
                [
                    431,
                    803
                ]
            ],
            7921: [
                [
                    432,
                    803
                ]
            ],
            7922: [
                [
                    89,
                    768
                ]
            ],
            7923: [
                [
                    121,
                    768
                ]
            ],
            7924: [
                [
                    89,
                    803
                ]
            ],
            7925: [
                [
                    121,
                    803
                ]
            ],
            7926: [
                [
                    89,
                    777
                ]
            ],
            7927: [
                [
                    121,
                    777
                ]
            ],
            7928: [
                [
                    89,
                    771
                ]
            ],
            7929: [
                [
                    121,
                    771
                ]
            ]
        },
        7936: {
            7936: [
                [
                    945,
                    787
                ],
                ,
                {
                    768: 7938,
                    769: 7940,
                    834: 7942,
                    837: 8064
                }
            ],
            7937: [
                [
                    945,
                    788
                ],
                ,
                {
                    768: 7939,
                    769: 7941,
                    834: 7943,
                    837: 8065
                }
            ],
            7938: [
                [
                    7936,
                    768
                ],
                ,
                {
                    837: 8066
                }
            ],
            7939: [
                [
                    7937,
                    768
                ],
                ,
                {
                    837: 8067
                }
            ],
            7940: [
                [
                    7936,
                    769
                ],
                ,
                {
                    837: 8068
                }
            ],
            7941: [
                [
                    7937,
                    769
                ],
                ,
                {
                    837: 8069
                }
            ],
            7942: [
                [
                    7936,
                    834
                ],
                ,
                {
                    837: 8070
                }
            ],
            7943: [
                [
                    7937,
                    834
                ],
                ,
                {
                    837: 8071
                }
            ],
            7944: [
                [
                    913,
                    787
                ],
                ,
                {
                    768: 7946,
                    769: 7948,
                    834: 7950,
                    837: 8072
                }
            ],
            7945: [
                [
                    913,
                    788
                ],
                ,
                {
                    768: 7947,
                    769: 7949,
                    834: 7951,
                    837: 8073
                }
            ],
            7946: [
                [
                    7944,
                    768
                ],
                ,
                {
                    837: 8074
                }
            ],
            7947: [
                [
                    7945,
                    768
                ],
                ,
                {
                    837: 8075
                }
            ],
            7948: [
                [
                    7944,
                    769
                ],
                ,
                {
                    837: 8076
                }
            ],
            7949: [
                [
                    7945,
                    769
                ],
                ,
                {
                    837: 8077
                }
            ],
            7950: [
                [
                    7944,
                    834
                ],
                ,
                {
                    837: 8078
                }
            ],
            7951: [
                [
                    7945,
                    834
                ],
                ,
                {
                    837: 8079
                }
            ],
            7952: [
                [
                    949,
                    787
                ],
                ,
                {
                    768: 7954,
                    769: 7956
                }
            ],
            7953: [
                [
                    949,
                    788
                ],
                ,
                {
                    768: 7955,
                    769: 7957
                }
            ],
            7954: [
                [
                    7952,
                    768
                ]
            ],
            7955: [
                [
                    7953,
                    768
                ]
            ],
            7956: [
                [
                    7952,
                    769
                ]
            ],
            7957: [
                [
                    7953,
                    769
                ]
            ],
            7960: [
                [
                    917,
                    787
                ],
                ,
                {
                    768: 7962,
                    769: 7964
                }
            ],
            7961: [
                [
                    917,
                    788
                ],
                ,
                {
                    768: 7963,
                    769: 7965
                }
            ],
            7962: [
                [
                    7960,
                    768
                ]
            ],
            7963: [
                [
                    7961,
                    768
                ]
            ],
            7964: [
                [
                    7960,
                    769
                ]
            ],
            7965: [
                [
                    7961,
                    769
                ]
            ],
            7968: [
                [
                    951,
                    787
                ],
                ,
                {
                    768: 7970,
                    769: 7972,
                    834: 7974,
                    837: 8080
                }
            ],
            7969: [
                [
                    951,
                    788
                ],
                ,
                {
                    768: 7971,
                    769: 7973,
                    834: 7975,
                    837: 8081
                }
            ],
            7970: [
                [
                    7968,
                    768
                ],
                ,
                {
                    837: 8082
                }
            ],
            7971: [
                [
                    7969,
                    768
                ],
                ,
                {
                    837: 8083
                }
            ],
            7972: [
                [
                    7968,
                    769
                ],
                ,
                {
                    837: 8084
                }
            ],
            7973: [
                [
                    7969,
                    769
                ],
                ,
                {
                    837: 8085
                }
            ],
            7974: [
                [
                    7968,
                    834
                ],
                ,
                {
                    837: 8086
                }
            ],
            7975: [
                [
                    7969,
                    834
                ],
                ,
                {
                    837: 8087
                }
            ],
            7976: [
                [
                    919,
                    787
                ],
                ,
                {
                    768: 7978,
                    769: 7980,
                    834: 7982,
                    837: 8088
                }
            ],
            7977: [
                [
                    919,
                    788
                ],
                ,
                {
                    768: 7979,
                    769: 7981,
                    834: 7983,
                    837: 8089
                }
            ],
            7978: [
                [
                    7976,
                    768
                ],
                ,
                {
                    837: 8090
                }
            ],
            7979: [
                [
                    7977,
                    768
                ],
                ,
                {
                    837: 8091
                }
            ],
            7980: [
                [
                    7976,
                    769
                ],
                ,
                {
                    837: 8092
                }
            ],
            7981: [
                [
                    7977,
                    769
                ],
                ,
                {
                    837: 8093
                }
            ],
            7982: [
                [
                    7976,
                    834
                ],
                ,
                {
                    837: 8094
                }
            ],
            7983: [
                [
                    7977,
                    834
                ],
                ,
                {
                    837: 8095
                }
            ],
            7984: [
                [
                    953,
                    787
                ],
                ,
                {
                    768: 7986,
                    769: 7988,
                    834: 7990
                }
            ],
            7985: [
                [
                    953,
                    788
                ],
                ,
                {
                    768: 7987,
                    769: 7989,
                    834: 7991
                }
            ],
            7986: [
                [
                    7984,
                    768
                ]
            ],
            7987: [
                [
                    7985,
                    768
                ]
            ],
            7988: [
                [
                    7984,
                    769
                ]
            ],
            7989: [
                [
                    7985,
                    769
                ]
            ],
            7990: [
                [
                    7984,
                    834
                ]
            ],
            7991: [
                [
                    7985,
                    834
                ]
            ],
            7992: [
                [
                    921,
                    787
                ],
                ,
                {
                    768: 7994,
                    769: 7996,
                    834: 7998
                }
            ],
            7993: [
                [
                    921,
                    788
                ],
                ,
                {
                    768: 7995,
                    769: 7997,
                    834: 7999
                }
            ],
            7994: [
                [
                    7992,
                    768
                ]
            ],
            7995: [
                [
                    7993,
                    768
                ]
            ],
            7996: [
                [
                    7992,
                    769
                ]
            ],
            7997: [
                [
                    7993,
                    769
                ]
            ],
            7998: [
                [
                    7992,
                    834
                ]
            ],
            7999: [
                [
                    7993,
                    834
                ]
            ],
            8000: [
                [
                    959,
                    787
                ],
                ,
                {
                    768: 8002,
                    769: 8004
                }
            ],
            8001: [
                [
                    959,
                    788
                ],
                ,
                {
                    768: 8003,
                    769: 8005
                }
            ],
            8002: [
                [
                    8000,
                    768
                ]
            ],
            8003: [
                [
                    8001,
                    768
                ]
            ],
            8004: [
                [
                    8000,
                    769
                ]
            ],
            8005: [
                [
                    8001,
                    769
                ]
            ],
            8008: [
                [
                    927,
                    787
                ],
                ,
                {
                    768: 8010,
                    769: 8012
                }
            ],
            8009: [
                [
                    927,
                    788
                ],
                ,
                {
                    768: 8011,
                    769: 8013
                }
            ],
            8010: [
                [
                    8008,
                    768
                ]
            ],
            8011: [
                [
                    8009,
                    768
                ]
            ],
            8012: [
                [
                    8008,
                    769
                ]
            ],
            8013: [
                [
                    8009,
                    769
                ]
            ],
            8016: [
                [
                    965,
                    787
                ],
                ,
                {
                    768: 8018,
                    769: 8020,
                    834: 8022
                }
            ],
            8017: [
                [
                    965,
                    788
                ],
                ,
                {
                    768: 8019,
                    769: 8021,
                    834: 8023
                }
            ],
            8018: [
                [
                    8016,
                    768
                ]
            ],
            8019: [
                [
                    8017,
                    768
                ]
            ],
            8020: [
                [
                    8016,
                    769
                ]
            ],
            8021: [
                [
                    8017,
                    769
                ]
            ],
            8022: [
                [
                    8016,
                    834
                ]
            ],
            8023: [
                [
                    8017,
                    834
                ]
            ],
            8025: [
                [
                    933,
                    788
                ],
                ,
                {
                    768: 8027,
                    769: 8029,
                    834: 8031
                }
            ],
            8027: [
                [
                    8025,
                    768
                ]
            ],
            8029: [
                [
                    8025,
                    769
                ]
            ],
            8031: [
                [
                    8025,
                    834
                ]
            ],
            8032: [
                [
                    969,
                    787
                ],
                ,
                {
                    768: 8034,
                    769: 8036,
                    834: 8038,
                    837: 8096
                }
            ],
            8033: [
                [
                    969,
                    788
                ],
                ,
                {
                    768: 8035,
                    769: 8037,
                    834: 8039,
                    837: 8097
                }
            ],
            8034: [
                [
                    8032,
                    768
                ],
                ,
                {
                    837: 8098
                }
            ],
            8035: [
                [
                    8033,
                    768
                ],
                ,
                {
                    837: 8099
                }
            ],
            8036: [
                [
                    8032,
                    769
                ],
                ,
                {
                    837: 8100
                }
            ],
            8037: [
                [
                    8033,
                    769
                ],
                ,
                {
                    837: 8101
                }
            ],
            8038: [
                [
                    8032,
                    834
                ],
                ,
                {
                    837: 8102
                }
            ],
            8039: [
                [
                    8033,
                    834
                ],
                ,
                {
                    837: 8103
                }
            ],
            8040: [
                [
                    937,
                    787
                ],
                ,
                {
                    768: 8042,
                    769: 8044,
                    834: 8046,
                    837: 8104
                }
            ],
            8041: [
                [
                    937,
                    788
                ],
                ,
                {
                    768: 8043,
                    769: 8045,
                    834: 8047,
                    837: 8105
                }
            ],
            8042: [
                [
                    8040,
                    768
                ],
                ,
                {
                    837: 8106
                }
            ],
            8043: [
                [
                    8041,
                    768
                ],
                ,
                {
                    837: 8107
                }
            ],
            8044: [
                [
                    8040,
                    769
                ],
                ,
                {
                    837: 8108
                }
            ],
            8045: [
                [
                    8041,
                    769
                ],
                ,
                {
                    837: 8109
                }
            ],
            8046: [
                [
                    8040,
                    834
                ],
                ,
                {
                    837: 8110
                }
            ],
            8047: [
                [
                    8041,
                    834
                ],
                ,
                {
                    837: 8111
                }
            ],
            8048: [
                [
                    945,
                    768
                ],
                ,
                {
                    837: 8114
                }
            ],
            8049: [
                [
                    940
                ]
            ],
            8050: [
                [
                    949,
                    768
                ]
            ],
            8051: [
                [
                    941
                ]
            ],
            8052: [
                [
                    951,
                    768
                ],
                ,
                {
                    837: 8130
                }
            ],
            8053: [
                [
                    942
                ]
            ],
            8054: [
                [
                    953,
                    768
                ]
            ],
            8055: [
                [
                    943
                ]
            ],
            8056: [
                [
                    959,
                    768
                ]
            ],
            8057: [
                [
                    972
                ]
            ],
            8058: [
                [
                    965,
                    768
                ]
            ],
            8059: [
                [
                    973
                ]
            ],
            8060: [
                [
                    969,
                    768
                ],
                ,
                {
                    837: 8178
                }
            ],
            8061: [
                [
                    974
                ]
            ],
            8064: [
                [
                    7936,
                    837
                ]
            ],
            8065: [
                [
                    7937,
                    837
                ]
            ],
            8066: [
                [
                    7938,
                    837
                ]
            ],
            8067: [
                [
                    7939,
                    837
                ]
            ],
            8068: [
                [
                    7940,
                    837
                ]
            ],
            8069: [
                [
                    7941,
                    837
                ]
            ],
            8070: [
                [
                    7942,
                    837
                ]
            ],
            8071: [
                [
                    7943,
                    837
                ]
            ],
            8072: [
                [
                    7944,
                    837
                ]
            ],
            8073: [
                [
                    7945,
                    837
                ]
            ],
            8074: [
                [
                    7946,
                    837
                ]
            ],
            8075: [
                [
                    7947,
                    837
                ]
            ],
            8076: [
                [
                    7948,
                    837
                ]
            ],
            8077: [
                [
                    7949,
                    837
                ]
            ],
            8078: [
                [
                    7950,
                    837
                ]
            ],
            8079: [
                [
                    7951,
                    837
                ]
            ],
            8080: [
                [
                    7968,
                    837
                ]
            ],
            8081: [
                [
                    7969,
                    837
                ]
            ],
            8082: [
                [
                    7970,
                    837
                ]
            ],
            8083: [
                [
                    7971,
                    837
                ]
            ],
            8084: [
                [
                    7972,
                    837
                ]
            ],
            8085: [
                [
                    7973,
                    837
                ]
            ],
            8086: [
                [
                    7974,
                    837
                ]
            ],
            8087: [
                [
                    7975,
                    837
                ]
            ],
            8088: [
                [
                    7976,
                    837
                ]
            ],
            8089: [
                [
                    7977,
                    837
                ]
            ],
            8090: [
                [
                    7978,
                    837
                ]
            ],
            8091: [
                [
                    7979,
                    837
                ]
            ],
            8092: [
                [
                    7980,
                    837
                ]
            ],
            8093: [
                [
                    7981,
                    837
                ]
            ],
            8094: [
                [
                    7982,
                    837
                ]
            ],
            8095: [
                [
                    7983,
                    837
                ]
            ],
            8096: [
                [
                    8032,
                    837
                ]
            ],
            8097: [
                [
                    8033,
                    837
                ]
            ],
            8098: [
                [
                    8034,
                    837
                ]
            ],
            8099: [
                [
                    8035,
                    837
                ]
            ],
            8100: [
                [
                    8036,
                    837
                ]
            ],
            8101: [
                [
                    8037,
                    837
                ]
            ],
            8102: [
                [
                    8038,
                    837
                ]
            ],
            8103: [
                [
                    8039,
                    837
                ]
            ],
            8104: [
                [
                    8040,
                    837
                ]
            ],
            8105: [
                [
                    8041,
                    837
                ]
            ],
            8106: [
                [
                    8042,
                    837
                ]
            ],
            8107: [
                [
                    8043,
                    837
                ]
            ],
            8108: [
                [
                    8044,
                    837
                ]
            ],
            8109: [
                [
                    8045,
                    837
                ]
            ],
            8110: [
                [
                    8046,
                    837
                ]
            ],
            8111: [
                [
                    8047,
                    837
                ]
            ],
            8112: [
                [
                    945,
                    774
                ]
            ],
            8113: [
                [
                    945,
                    772
                ]
            ],
            8114: [
                [
                    8048,
                    837
                ]
            ],
            8115: [
                [
                    945,
                    837
                ]
            ],
            8116: [
                [
                    940,
                    837
                ]
            ],
            8118: [
                [
                    945,
                    834
                ],
                ,
                {
                    837: 8119
                }
            ],
            8119: [
                [
                    8118,
                    837
                ]
            ],
            8120: [
                [
                    913,
                    774
                ]
            ],
            8121: [
                [
                    913,
                    772
                ]
            ],
            8122: [
                [
                    913,
                    768
                ]
            ],
            8123: [
                [
                    902
                ]
            ],
            8124: [
                [
                    913,
                    837
                ]
            ],
            8125: [
                [
                    32,
                    787
                ],
                256
            ],
            8126: [
                [
                    953
                ]
            ],
            8127: [
                [
                    32,
                    787
                ],
                256,
                {
                    768: 8141,
                    769: 8142,
                    834: 8143
                }
            ],
            8128: [
                [
                    32,
                    834
                ],
                256
            ],
            8129: [
                [
                    168,
                    834
                ]
            ],
            8130: [
                [
                    8052,
                    837
                ]
            ],
            8131: [
                [
                    951,
                    837
                ]
            ],
            8132: [
                [
                    942,
                    837
                ]
            ],
            8134: [
                [
                    951,
                    834
                ],
                ,
                {
                    837: 8135
                }
            ],
            8135: [
                [
                    8134,
                    837
                ]
            ],
            8136: [
                [
                    917,
                    768
                ]
            ],
            8137: [
                [
                    904
                ]
            ],
            8138: [
                [
                    919,
                    768
                ]
            ],
            8139: [
                [
                    905
                ]
            ],
            8140: [
                [
                    919,
                    837
                ]
            ],
            8141: [
                [
                    8127,
                    768
                ]
            ],
            8142: [
                [
                    8127,
                    769
                ]
            ],
            8143: [
                [
                    8127,
                    834
                ]
            ],
            8144: [
                [
                    953,
                    774
                ]
            ],
            8145: [
                [
                    953,
                    772
                ]
            ],
            8146: [
                [
                    970,
                    768
                ]
            ],
            8147: [
                [
                    912
                ]
            ],
            8150: [
                [
                    953,
                    834
                ]
            ],
            8151: [
                [
                    970,
                    834
                ]
            ],
            8152: [
                [
                    921,
                    774
                ]
            ],
            8153: [
                [
                    921,
                    772
                ]
            ],
            8154: [
                [
                    921,
                    768
                ]
            ],
            8155: [
                [
                    906
                ]
            ],
            8157: [
                [
                    8190,
                    768
                ]
            ],
            8158: [
                [
                    8190,
                    769
                ]
            ],
            8159: [
                [
                    8190,
                    834
                ]
            ],
            8160: [
                [
                    965,
                    774
                ]
            ],
            8161: [
                [
                    965,
                    772
                ]
            ],
            8162: [
                [
                    971,
                    768
                ]
            ],
            8163: [
                [
                    944
                ]
            ],
            8164: [
                [
                    961,
                    787
                ]
            ],
            8165: [
                [
                    961,
                    788
                ]
            ],
            8166: [
                [
                    965,
                    834
                ]
            ],
            8167: [
                [
                    971,
                    834
                ]
            ],
            8168: [
                [
                    933,
                    774
                ]
            ],
            8169: [
                [
                    933,
                    772
                ]
            ],
            8170: [
                [
                    933,
                    768
                ]
            ],
            8171: [
                [
                    910
                ]
            ],
            8172: [
                [
                    929,
                    788
                ]
            ],
            8173: [
                [
                    168,
                    768
                ]
            ],
            8174: [
                [
                    901
                ]
            ],
            8175: [
                [
                    96
                ]
            ],
            8178: [
                [
                    8060,
                    837
                ]
            ],
            8179: [
                [
                    969,
                    837
                ]
            ],
            8180: [
                [
                    974,
                    837
                ]
            ],
            8182: [
                [
                    969,
                    834
                ],
                ,
                {
                    837: 8183
                }
            ],
            8183: [
                [
                    8182,
                    837
                ]
            ],
            8184: [
                [
                    927,
                    768
                ]
            ],
            8185: [
                [
                    908
                ]
            ],
            8186: [
                [
                    937,
                    768
                ]
            ],
            8187: [
                [
                    911
                ]
            ],
            8188: [
                [
                    937,
                    837
                ]
            ],
            8189: [
                [
                    180
                ]
            ],
            8190: [
                [
                    32,
                    788
                ],
                256,
                {
                    768: 8157,
                    769: 8158,
                    834: 8159
                }
            ]
        },
        8192: {
            8192: [
                [
                    8194
                ]
            ],
            8193: [
                [
                    8195
                ]
            ],
            8194: [
                [
                    32
                ],
                256
            ],
            8195: [
                [
                    32
                ],
                256
            ],
            8196: [
                [
                    32
                ],
                256
            ],
            8197: [
                [
                    32
                ],
                256
            ],
            8198: [
                [
                    32
                ],
                256
            ],
            8199: [
                [
                    32
                ],
                256
            ],
            8200: [
                [
                    32
                ],
                256
            ],
            8201: [
                [
                    32
                ],
                256
            ],
            8202: [
                [
                    32
                ],
                256
            ],
            8209: [
                [
                    8208
                ],
                256
            ],
            8215: [
                [
                    32,
                    819
                ],
                256
            ],
            8228: [
                [
                    46
                ],
                256
            ],
            8229: [
                [
                    46,
                    46
                ],
                256
            ],
            8230: [
                [
                    46,
                    46,
                    46
                ],
                256
            ],
            8239: [
                [
                    32
                ],
                256
            ],
            8243: [
                [
                    8242,
                    8242
                ],
                256
            ],
            8244: [
                [
                    8242,
                    8242,
                    8242
                ],
                256
            ],
            8246: [
                [
                    8245,
                    8245
                ],
                256
            ],
            8247: [
                [
                    8245,
                    8245,
                    8245
                ],
                256
            ],
            8252: [
                [
                    33,
                    33
                ],
                256
            ],
            8254: [
                [
                    32,
                    773
                ],
                256
            ],
            8263: [
                [
                    63,
                    63
                ],
                256
            ],
            8264: [
                [
                    63,
                    33
                ],
                256
            ],
            8265: [
                [
                    33,
                    63
                ],
                256
            ],
            8279: [
                [
                    8242,
                    8242,
                    8242,
                    8242
                ],
                256
            ],
            8287: [
                [
                    32
                ],
                256
            ],
            8304: [
                [
                    48
                ],
                256
            ],
            8305: [
                [
                    105
                ],
                256
            ],
            8308: [
                [
                    52
                ],
                256
            ],
            8309: [
                [
                    53
                ],
                256
            ],
            8310: [
                [
                    54
                ],
                256
            ],
            8311: [
                [
                    55
                ],
                256
            ],
            8312: [
                [
                    56
                ],
                256
            ],
            8313: [
                [
                    57
                ],
                256
            ],
            8314: [
                [
                    43
                ],
                256
            ],
            8315: [
                [
                    8722
                ],
                256
            ],
            8316: [
                [
                    61
                ],
                256
            ],
            8317: [
                [
                    40
                ],
                256
            ],
            8318: [
                [
                    41
                ],
                256
            ],
            8319: [
                [
                    110
                ],
                256
            ],
            8320: [
                [
                    48
                ],
                256
            ],
            8321: [
                [
                    49
                ],
                256
            ],
            8322: [
                [
                    50
                ],
                256
            ],
            8323: [
                [
                    51
                ],
                256
            ],
            8324: [
                [
                    52
                ],
                256
            ],
            8325: [
                [
                    53
                ],
                256
            ],
            8326: [
                [
                    54
                ],
                256
            ],
            8327: [
                [
                    55
                ],
                256
            ],
            8328: [
                [
                    56
                ],
                256
            ],
            8329: [
                [
                    57
                ],
                256
            ],
            8330: [
                [
                    43
                ],
                256
            ],
            8331: [
                [
                    8722
                ],
                256
            ],
            8332: [
                [
                    61
                ],
                256
            ],
            8333: [
                [
                    40
                ],
                256
            ],
            8334: [
                [
                    41
                ],
                256
            ],
            8336: [
                [
                    97
                ],
                256
            ],
            8337: [
                [
                    101
                ],
                256
            ],
            8338: [
                [
                    111
                ],
                256
            ],
            8339: [
                [
                    120
                ],
                256
            ],
            8340: [
                [
                    601
                ],
                256
            ],
            8341: [
                [
                    104
                ],
                256
            ],
            8342: [
                [
                    107
                ],
                256
            ],
            8343: [
                [
                    108
                ],
                256
            ],
            8344: [
                [
                    109
                ],
                256
            ],
            8345: [
                [
                    110
                ],
                256
            ],
            8346: [
                [
                    112
                ],
                256
            ],
            8347: [
                [
                    115
                ],
                256
            ],
            8348: [
                [
                    116
                ],
                256
            ],
            8360: [
                [
                    82,
                    115
                ],
                256
            ],
            8400: [
                ,
                230
            ],
            8401: [
                ,
                230
            ],
            8402: [
                ,
                1
            ],
            8403: [
                ,
                1
            ],
            8404: [
                ,
                230
            ],
            8405: [
                ,
                230
            ],
            8406: [
                ,
                230
            ],
            8407: [
                ,
                230
            ],
            8408: [
                ,
                1
            ],
            8409: [
                ,
                1
            ],
            8410: [
                ,
                1
            ],
            8411: [
                ,
                230
            ],
            8412: [
                ,
                230
            ],
            8417: [
                ,
                230
            ],
            8421: [
                ,
                1
            ],
            8422: [
                ,
                1
            ],
            8423: [
                ,
                230
            ],
            8424: [
                ,
                220
            ],
            8425: [
                ,
                230
            ],
            8426: [
                ,
                1
            ],
            8427: [
                ,
                1
            ],
            8428: [
                ,
                220
            ],
            8429: [
                ,
                220
            ],
            8430: [
                ,
                220
            ],
            8431: [
                ,
                220
            ],
            8432: [
                ,
                230
            ]
        },
        8448: {
            8448: [
                [
                    97,
                    47,
                    99
                ],
                256
            ],
            8449: [
                [
                    97,
                    47,
                    115
                ],
                256
            ],
            8450: [
                [
                    67
                ],
                256
            ],
            8451: [
                [
                    176,
                    67
                ],
                256
            ],
            8453: [
                [
                    99,
                    47,
                    111
                ],
                256
            ],
            8454: [
                [
                    99,
                    47,
                    117
                ],
                256
            ],
            8455: [
                [
                    400
                ],
                256
            ],
            8457: [
                [
                    176,
                    70
                ],
                256
            ],
            8458: [
                [
                    103
                ],
                256
            ],
            8459: [
                [
                    72
                ],
                256
            ],
            8460: [
                [
                    72
                ],
                256
            ],
            8461: [
                [
                    72
                ],
                256
            ],
            8462: [
                [
                    104
                ],
                256
            ],
            8463: [
                [
                    295
                ],
                256
            ],
            8464: [
                [
                    73
                ],
                256
            ],
            8465: [
                [
                    73
                ],
                256
            ],
            8466: [
                [
                    76
                ],
                256
            ],
            8467: [
                [
                    108
                ],
                256
            ],
            8469: [
                [
                    78
                ],
                256
            ],
            8470: [
                [
                    78,
                    111
                ],
                256
            ],
            8473: [
                [
                    80
                ],
                256
            ],
            8474: [
                [
                    81
                ],
                256
            ],
            8475: [
                [
                    82
                ],
                256
            ],
            8476: [
                [
                    82
                ],
                256
            ],
            8477: [
                [
                    82
                ],
                256
            ],
            8480: [
                [
                    83,
                    77
                ],
                256
            ],
            8481: [
                [
                    84,
                    69,
                    76
                ],
                256
            ],
            8482: [
                [
                    84,
                    77
                ],
                256
            ],
            8484: [
                [
                    90
                ],
                256
            ],
            8486: [
                [
                    937
                ]
            ],
            8488: [
                [
                    90
                ],
                256
            ],
            8490: [
                [
                    75
                ]
            ],
            8491: [
                [
                    197
                ]
            ],
            8492: [
                [
                    66
                ],
                256
            ],
            8493: [
                [
                    67
                ],
                256
            ],
            8495: [
                [
                    101
                ],
                256
            ],
            8496: [
                [
                    69
                ],
                256
            ],
            8497: [
                [
                    70
                ],
                256
            ],
            8499: [
                [
                    77
                ],
                256
            ],
            8500: [
                [
                    111
                ],
                256
            ],
            8501: [
                [
                    1488
                ],
                256
            ],
            8502: [
                [
                    1489
                ],
                256
            ],
            8503: [
                [
                    1490
                ],
                256
            ],
            8504: [
                [
                    1491
                ],
                256
            ],
            8505: [
                [
                    105
                ],
                256
            ],
            8507: [
                [
                    70,
                    65,
                    88
                ],
                256
            ],
            8508: [
                [
                    960
                ],
                256
            ],
            8509: [
                [
                    947
                ],
                256
            ],
            8510: [
                [
                    915
                ],
                256
            ],
            8511: [
                [
                    928
                ],
                256
            ],
            8512: [
                [
                    8721
                ],
                256
            ],
            8517: [
                [
                    68
                ],
                256
            ],
            8518: [
                [
                    100
                ],
                256
            ],
            8519: [
                [
                    101
                ],
                256
            ],
            8520: [
                [
                    105
                ],
                256
            ],
            8521: [
                [
                    106
                ],
                256
            ],
            8528: [
                [
                    49,
                    8260,
                    55
                ],
                256
            ],
            8529: [
                [
                    49,
                    8260,
                    57
                ],
                256
            ],
            8530: [
                [
                    49,
                    8260,
                    49,
                    48
                ],
                256
            ],
            8531: [
                [
                    49,
                    8260,
                    51
                ],
                256
            ],
            8532: [
                [
                    50,
                    8260,
                    51
                ],
                256
            ],
            8533: [
                [
                    49,
                    8260,
                    53
                ],
                256
            ],
            8534: [
                [
                    50,
                    8260,
                    53
                ],
                256
            ],
            8535: [
                [
                    51,
                    8260,
                    53
                ],
                256
            ],
            8536: [
                [
                    52,
                    8260,
                    53
                ],
                256
            ],
            8537: [
                [
                    49,
                    8260,
                    54
                ],
                256
            ],
            8538: [
                [
                    53,
                    8260,
                    54
                ],
                256
            ],
            8539: [
                [
                    49,
                    8260,
                    56
                ],
                256
            ],
            8540: [
                [
                    51,
                    8260,
                    56
                ],
                256
            ],
            8541: [
                [
                    53,
                    8260,
                    56
                ],
                256
            ],
            8542: [
                [
                    55,
                    8260,
                    56
                ],
                256
            ],
            8543: [
                [
                    49,
                    8260
                ],
                256
            ],
            8544: [
                [
                    73
                ],
                256
            ],
            8545: [
                [
                    73,
                    73
                ],
                256
            ],
            8546: [
                [
                    73,
                    73,
                    73
                ],
                256
            ],
            8547: [
                [
                    73,
                    86
                ],
                256
            ],
            8548: [
                [
                    86
                ],
                256
            ],
            8549: [
                [
                    86,
                    73
                ],
                256
            ],
            8550: [
                [
                    86,
                    73,
                    73
                ],
                256
            ],
            8551: [
                [
                    86,
                    73,
                    73,
                    73
                ],
                256
            ],
            8552: [
                [
                    73,
                    88
                ],
                256
            ],
            8553: [
                [
                    88
                ],
                256
            ],
            8554: [
                [
                    88,
                    73
                ],
                256
            ],
            8555: [
                [
                    88,
                    73,
                    73
                ],
                256
            ],
            8556: [
                [
                    76
                ],
                256
            ],
            8557: [
                [
                    67
                ],
                256
            ],
            8558: [
                [
                    68
                ],
                256
            ],
            8559: [
                [
                    77
                ],
                256
            ],
            8560: [
                [
                    105
                ],
                256
            ],
            8561: [
                [
                    105,
                    105
                ],
                256
            ],
            8562: [
                [
                    105,
                    105,
                    105
                ],
                256
            ],
            8563: [
                [
                    105,
                    118
                ],
                256
            ],
            8564: [
                [
                    118
                ],
                256
            ],
            8565: [
                [
                    118,
                    105
                ],
                256
            ],
            8566: [
                [
                    118,
                    105,
                    105
                ],
                256
            ],
            8567: [
                [
                    118,
                    105,
                    105,
                    105
                ],
                256
            ],
            8568: [
                [
                    105,
                    120
                ],
                256
            ],
            8569: [
                [
                    120
                ],
                256
            ],
            8570: [
                [
                    120,
                    105
                ],
                256
            ],
            8571: [
                [
                    120,
                    105,
                    105
                ],
                256
            ],
            8572: [
                [
                    108
                ],
                256
            ],
            8573: [
                [
                    99
                ],
                256
            ],
            8574: [
                [
                    100
                ],
                256
            ],
            8575: [
                [
                    109
                ],
                256
            ],
            8585: [
                [
                    48,
                    8260,
                    51
                ],
                256
            ],
            8592: [
                ,
                ,
                {
                    824: 8602
                }
            ],
            8594: [
                ,
                ,
                {
                    824: 8603
                }
            ],
            8596: [
                ,
                ,
                {
                    824: 8622
                }
            ],
            8602: [
                [
                    8592,
                    824
                ]
            ],
            8603: [
                [
                    8594,
                    824
                ]
            ],
            8622: [
                [
                    8596,
                    824
                ]
            ],
            8653: [
                [
                    8656,
                    824
                ]
            ],
            8654: [
                [
                    8660,
                    824
                ]
            ],
            8655: [
                [
                    8658,
                    824
                ]
            ],
            8656: [
                ,
                ,
                {
                    824: 8653
                }
            ],
            8658: [
                ,
                ,
                {
                    824: 8655
                }
            ],
            8660: [
                ,
                ,
                {
                    824: 8654
                }
            ]
        },
        8704: {
            8707: [
                ,
                ,
                {
                    824: 8708
                }
            ],
            8708: [
                [
                    8707,
                    824
                ]
            ],
            8712: [
                ,
                ,
                {
                    824: 8713
                }
            ],
            8713: [
                [
                    8712,
                    824
                ]
            ],
            8715: [
                ,
                ,
                {
                    824: 8716
                }
            ],
            8716: [
                [
                    8715,
                    824
                ]
            ],
            8739: [
                ,
                ,
                {
                    824: 8740
                }
            ],
            8740: [
                [
                    8739,
                    824
                ]
            ],
            8741: [
                ,
                ,
                {
                    824: 8742
                }
            ],
            8742: [
                [
                    8741,
                    824
                ]
            ],
            8748: [
                [
                    8747,
                    8747
                ],
                256
            ],
            8749: [
                [
                    8747,
                    8747,
                    8747
                ],
                256
            ],
            8751: [
                [
                    8750,
                    8750
                ],
                256
            ],
            8752: [
                [
                    8750,
                    8750,
                    8750
                ],
                256
            ],
            8764: [
                ,
                ,
                {
                    824: 8769
                }
            ],
            8769: [
                [
                    8764,
                    824
                ]
            ],
            8771: [
                ,
                ,
                {
                    824: 8772
                }
            ],
            8772: [
                [
                    8771,
                    824
                ]
            ],
            8773: [
                ,
                ,
                {
                    824: 8775
                }
            ],
            8775: [
                [
                    8773,
                    824
                ]
            ],
            8776: [
                ,
                ,
                {
                    824: 8777
                }
            ],
            8777: [
                [
                    8776,
                    824
                ]
            ],
            8781: [
                ,
                ,
                {
                    824: 8813
                }
            ],
            8800: [
                [
                    61,
                    824
                ]
            ],
            8801: [
                ,
                ,
                {
                    824: 8802
                }
            ],
            8802: [
                [
                    8801,
                    824
                ]
            ],
            8804: [
                ,
                ,
                {
                    824: 8816
                }
            ],
            8805: [
                ,
                ,
                {
                    824: 8817
                }
            ],
            8813: [
                [
                    8781,
                    824
                ]
            ],
            8814: [
                [
                    60,
                    824
                ]
            ],
            8815: [
                [
                    62,
                    824
                ]
            ],
            8816: [
                [
                    8804,
                    824
                ]
            ],
            8817: [
                [
                    8805,
                    824
                ]
            ],
            8818: [
                ,
                ,
                {
                    824: 8820
                }
            ],
            8819: [
                ,
                ,
                {
                    824: 8821
                }
            ],
            8820: [
                [
                    8818,
                    824
                ]
            ],
            8821: [
                [
                    8819,
                    824
                ]
            ],
            8822: [
                ,
                ,
                {
                    824: 8824
                }
            ],
            8823: [
                ,
                ,
                {
                    824: 8825
                }
            ],
            8824: [
                [
                    8822,
                    824
                ]
            ],
            8825: [
                [
                    8823,
                    824
                ]
            ],
            8826: [
                ,
                ,
                {
                    824: 8832
                }
            ],
            8827: [
                ,
                ,
                {
                    824: 8833
                }
            ],
            8828: [
                ,
                ,
                {
                    824: 8928
                }
            ],
            8829: [
                ,
                ,
                {
                    824: 8929
                }
            ],
            8832: [
                [
                    8826,
                    824
                ]
            ],
            8833: [
                [
                    8827,
                    824
                ]
            ],
            8834: [
                ,
                ,
                {
                    824: 8836
                }
            ],
            8835: [
                ,
                ,
                {
                    824: 8837
                }
            ],
            8836: [
                [
                    8834,
                    824
                ]
            ],
            8837: [
                [
                    8835,
                    824
                ]
            ],
            8838: [
                ,
                ,
                {
                    824: 8840
                }
            ],
            8839: [
                ,
                ,
                {
                    824: 8841
                }
            ],
            8840: [
                [
                    8838,
                    824
                ]
            ],
            8841: [
                [
                    8839,
                    824
                ]
            ],
            8849: [
                ,
                ,
                {
                    824: 8930
                }
            ],
            8850: [
                ,
                ,
                {
                    824: 8931
                }
            ],
            8866: [
                ,
                ,
                {
                    824: 8876
                }
            ],
            8872: [
                ,
                ,
                {
                    824: 8877
                }
            ],
            8873: [
                ,
                ,
                {
                    824: 8878
                }
            ],
            8875: [
                ,
                ,
                {
                    824: 8879
                }
            ],
            8876: [
                [
                    8866,
                    824
                ]
            ],
            8877: [
                [
                    8872,
                    824
                ]
            ],
            8878: [
                [
                    8873,
                    824
                ]
            ],
            8879: [
                [
                    8875,
                    824
                ]
            ],
            8882: [
                ,
                ,
                {
                    824: 8938
                }
            ],
            8883: [
                ,
                ,
                {
                    824: 8939
                }
            ],
            8884: [
                ,
                ,
                {
                    824: 8940
                }
            ],
            8885: [
                ,
                ,
                {
                    824: 8941
                }
            ],
            8928: [
                [
                    8828,
                    824
                ]
            ],
            8929: [
                [
                    8829,
                    824
                ]
            ],
            8930: [
                [
                    8849,
                    824
                ]
            ],
            8931: [
                [
                    8850,
                    824
                ]
            ],
            8938: [
                [
                    8882,
                    824
                ]
            ],
            8939: [
                [
                    8883,
                    824
                ]
            ],
            8940: [
                [
                    8884,
                    824
                ]
            ],
            8941: [
                [
                    8885,
                    824
                ]
            ]
        },
        8960: {
            9001: [
                [
                    12296
                ]
            ],
            9002: [
                [
                    12297
                ]
            ]
        },
        9216: {
            9312: [
                [
                    49
                ],
                256
            ],
            9313: [
                [
                    50
                ],
                256
            ],
            9314: [
                [
                    51
                ],
                256
            ],
            9315: [
                [
                    52
                ],
                256
            ],
            9316: [
                [
                    53
                ],
                256
            ],
            9317: [
                [
                    54
                ],
                256
            ],
            9318: [
                [
                    55
                ],
                256
            ],
            9319: [
                [
                    56
                ],
                256
            ],
            9320: [
                [
                    57
                ],
                256
            ],
            9321: [
                [
                    49,
                    48
                ],
                256
            ],
            9322: [
                [
                    49,
                    49
                ],
                256
            ],
            9323: [
                [
                    49,
                    50
                ],
                256
            ],
            9324: [
                [
                    49,
                    51
                ],
                256
            ],
            9325: [
                [
                    49,
                    52
                ],
                256
            ],
            9326: [
                [
                    49,
                    53
                ],
                256
            ],
            9327: [
                [
                    49,
                    54
                ],
                256
            ],
            9328: [
                [
                    49,
                    55
                ],
                256
            ],
            9329: [
                [
                    49,
                    56
                ],
                256
            ],
            9330: [
                [
                    49,
                    57
                ],
                256
            ],
            9331: [
                [
                    50,
                    48
                ],
                256
            ],
            9332: [
                [
                    40,
                    49,
                    41
                ],
                256
            ],
            9333: [
                [
                    40,
                    50,
                    41
                ],
                256
            ],
            9334: [
                [
                    40,
                    51,
                    41
                ],
                256
            ],
            9335: [
                [
                    40,
                    52,
                    41
                ],
                256
            ],
            9336: [
                [
                    40,
                    53,
                    41
                ],
                256
            ],
            9337: [
                [
                    40,
                    54,
                    41
                ],
                256
            ],
            9338: [
                [
                    40,
                    55,
                    41
                ],
                256
            ],
            9339: [
                [
                    40,
                    56,
                    41
                ],
                256
            ],
            9340: [
                [
                    40,
                    57,
                    41
                ],
                256
            ],
            9341: [
                [
                    40,
                    49,
                    48,
                    41
                ],
                256
            ],
            9342: [
                [
                    40,
                    49,
                    49,
                    41
                ],
                256
            ],
            9343: [
                [
                    40,
                    49,
                    50,
                    41
                ],
                256
            ],
            9344: [
                [
                    40,
                    49,
                    51,
                    41
                ],
                256
            ],
            9345: [
                [
                    40,
                    49,
                    52,
                    41
                ],
                256
            ],
            9346: [
                [
                    40,
                    49,
                    53,
                    41
                ],
                256
            ],
            9347: [
                [
                    40,
                    49,
                    54,
                    41
                ],
                256
            ],
            9348: [
                [
                    40,
                    49,
                    55,
                    41
                ],
                256
            ],
            9349: [
                [
                    40,
                    49,
                    56,
                    41
                ],
                256
            ],
            9350: [
                [
                    40,
                    49,
                    57,
                    41
                ],
                256
            ],
            9351: [
                [
                    40,
                    50,
                    48,
                    41
                ],
                256
            ],
            9352: [
                [
                    49,
                    46
                ],
                256
            ],
            9353: [
                [
                    50,
                    46
                ],
                256
            ],
            9354: [
                [
                    51,
                    46
                ],
                256
            ],
            9355: [
                [
                    52,
                    46
                ],
                256
            ],
            9356: [
                [
                    53,
                    46
                ],
                256
            ],
            9357: [
                [
                    54,
                    46
                ],
                256
            ],
            9358: [
                [
                    55,
                    46
                ],
                256
            ],
            9359: [
                [
                    56,
                    46
                ],
                256
            ],
            9360: [
                [
                    57,
                    46
                ],
                256
            ],
            9361: [
                [
                    49,
                    48,
                    46
                ],
                256
            ],
            9362: [
                [
                    49,
                    49,
                    46
                ],
                256
            ],
            9363: [
                [
                    49,
                    50,
                    46
                ],
                256
            ],
            9364: [
                [
                    49,
                    51,
                    46
                ],
                256
            ],
            9365: [
                [
                    49,
                    52,
                    46
                ],
                256
            ],
            9366: [
                [
                    49,
                    53,
                    46
                ],
                256
            ],
            9367: [
                [
                    49,
                    54,
                    46
                ],
                256
            ],
            9368: [
                [
                    49,
                    55,
                    46
                ],
                256
            ],
            9369: [
                [
                    49,
                    56,
                    46
                ],
                256
            ],
            9370: [
                [
                    49,
                    57,
                    46
                ],
                256
            ],
            9371: [
                [
                    50,
                    48,
                    46
                ],
                256
            ],
            9372: [
                [
                    40,
                    97,
                    41
                ],
                256
            ],
            9373: [
                [
                    40,
                    98,
                    41
                ],
                256
            ],
            9374: [
                [
                    40,
                    99,
                    41
                ],
                256
            ],
            9375: [
                [
                    40,
                    100,
                    41
                ],
                256
            ],
            9376: [
                [
                    40,
                    101,
                    41
                ],
                256
            ],
            9377: [
                [
                    40,
                    102,
                    41
                ],
                256
            ],
            9378: [
                [
                    40,
                    103,
                    41
                ],
                256
            ],
            9379: [
                [
                    40,
                    104,
                    41
                ],
                256
            ],
            9380: [
                [
                    40,
                    105,
                    41
                ],
                256
            ],
            9381: [
                [
                    40,
                    106,
                    41
                ],
                256
            ],
            9382: [
                [
                    40,
                    107,
                    41
                ],
                256
            ],
            9383: [
                [
                    40,
                    108,
                    41
                ],
                256
            ],
            9384: [
                [
                    40,
                    109,
                    41
                ],
                256
            ],
            9385: [
                [
                    40,
                    110,
                    41
                ],
                256
            ],
            9386: [
                [
                    40,
                    111,
                    41
                ],
                256
            ],
            9387: [
                [
                    40,
                    112,
                    41
                ],
                256
            ],
            9388: [
                [
                    40,
                    113,
                    41
                ],
                256
            ],
            9389: [
                [
                    40,
                    114,
                    41
                ],
                256
            ],
            9390: [
                [
                    40,
                    115,
                    41
                ],
                256
            ],
            9391: [
                [
                    40,
                    116,
                    41
                ],
                256
            ],
            9392: [
                [
                    40,
                    117,
                    41
                ],
                256
            ],
            9393: [
                [
                    40,
                    118,
                    41
                ],
                256
            ],
            9394: [
                [
                    40,
                    119,
                    41
                ],
                256
            ],
            9395: [
                [
                    40,
                    120,
                    41
                ],
                256
            ],
            9396: [
                [
                    40,
                    121,
                    41
                ],
                256
            ],
            9397: [
                [
                    40,
                    122,
                    41
                ],
                256
            ],
            9398: [
                [
                    65
                ],
                256
            ],
            9399: [
                [
                    66
                ],
                256
            ],
            9400: [
                [
                    67
                ],
                256
            ],
            9401: [
                [
                    68
                ],
                256
            ],
            9402: [
                [
                    69
                ],
                256
            ],
            9403: [
                [
                    70
                ],
                256
            ],
            9404: [
                [
                    71
                ],
                256
            ],
            9405: [
                [
                    72
                ],
                256
            ],
            9406: [
                [
                    73
                ],
                256
            ],
            9407: [
                [
                    74
                ],
                256
            ],
            9408: [
                [
                    75
                ],
                256
            ],
            9409: [
                [
                    76
                ],
                256
            ],
            9410: [
                [
                    77
                ],
                256
            ],
            9411: [
                [
                    78
                ],
                256
            ],
            9412: [
                [
                    79
                ],
                256
            ],
            9413: [
                [
                    80
                ],
                256
            ],
            9414: [
                [
                    81
                ],
                256
            ],
            9415: [
                [
                    82
                ],
                256
            ],
            9416: [
                [
                    83
                ],
                256
            ],
            9417: [
                [
                    84
                ],
                256
            ],
            9418: [
                [
                    85
                ],
                256
            ],
            9419: [
                [
                    86
                ],
                256
            ],
            9420: [
                [
                    87
                ],
                256
            ],
            9421: [
                [
                    88
                ],
                256
            ],
            9422: [
                [
                    89
                ],
                256
            ],
            9423: [
                [
                    90
                ],
                256
            ],
            9424: [
                [
                    97
                ],
                256
            ],
            9425: [
                [
                    98
                ],
                256
            ],
            9426: [
                [
                    99
                ],
                256
            ],
            9427: [
                [
                    100
                ],
                256
            ],
            9428: [
                [
                    101
                ],
                256
            ],
            9429: [
                [
                    102
                ],
                256
            ],
            9430: [
                [
                    103
                ],
                256
            ],
            9431: [
                [
                    104
                ],
                256
            ],
            9432: [
                [
                    105
                ],
                256
            ],
            9433: [
                [
                    106
                ],
                256
            ],
            9434: [
                [
                    107
                ],
                256
            ],
            9435: [
                [
                    108
                ],
                256
            ],
            9436: [
                [
                    109
                ],
                256
            ],
            9437: [
                [
                    110
                ],
                256
            ],
            9438: [
                [
                    111
                ],
                256
            ],
            9439: [
                [
                    112
                ],
                256
            ],
            9440: [
                [
                    113
                ],
                256
            ],
            9441: [
                [
                    114
                ],
                256
            ],
            9442: [
                [
                    115
                ],
                256
            ],
            9443: [
                [
                    116
                ],
                256
            ],
            9444: [
                [
                    117
                ],
                256
            ],
            9445: [
                [
                    118
                ],
                256
            ],
            9446: [
                [
                    119
                ],
                256
            ],
            9447: [
                [
                    120
                ],
                256
            ],
            9448: [
                [
                    121
                ],
                256
            ],
            9449: [
                [
                    122
                ],
                256
            ],
            9450: [
                [
                    48
                ],
                256
            ]
        },
        10752: {
            10764: [
                [
                    8747,
                    8747,
                    8747,
                    8747
                ],
                256
            ],
            10868: [
                [
                    58,
                    58,
                    61
                ],
                256
            ],
            10869: [
                [
                    61,
                    61
                ],
                256
            ],
            10870: [
                [
                    61,
                    61,
                    61
                ],
                256
            ],
            10972: [
                [
                    10973,
                    824
                ],
                512
            ]
        },
        11264: {
            11388: [
                [
                    106
                ],
                256
            ],
            11389: [
                [
                    86
                ],
                256
            ],
            11503: [
                ,
                230
            ],
            11504: [
                ,
                230
            ],
            11505: [
                ,
                230
            ]
        },
        11520: {
            11631: [
                [
                    11617
                ],
                256
            ],
            11647: [
                ,
                9
            ],
            11744: [
                ,
                230
            ],
            11745: [
                ,
                230
            ],
            11746: [
                ,
                230
            ],
            11747: [
                ,
                230
            ],
            11748: [
                ,
                230
            ],
            11749: [
                ,
                230
            ],
            11750: [
                ,
                230
            ],
            11751: [
                ,
                230
            ],
            11752: [
                ,
                230
            ],
            11753: [
                ,
                230
            ],
            11754: [
                ,
                230
            ],
            11755: [
                ,
                230
            ],
            11756: [
                ,
                230
            ],
            11757: [
                ,
                230
            ],
            11758: [
                ,
                230
            ],
            11759: [
                ,
                230
            ],
            11760: [
                ,
                230
            ],
            11761: [
                ,
                230
            ],
            11762: [
                ,
                230
            ],
            11763: [
                ,
                230
            ],
            11764: [
                ,
                230
            ],
            11765: [
                ,
                230
            ],
            11766: [
                ,
                230
            ],
            11767: [
                ,
                230
            ],
            11768: [
                ,
                230
            ],
            11769: [
                ,
                230
            ],
            11770: [
                ,
                230
            ],
            11771: [
                ,
                230
            ],
            11772: [
                ,
                230
            ],
            11773: [
                ,
                230
            ],
            11774: [
                ,
                230
            ],
            11775: [
                ,
                230
            ]
        },
        11776: {
            11935: [
                [
                    27597
                ],
                256
            ],
            12019: [
                [
                    40863
                ],
                256
            ]
        },
        12032: {
            12032: [
                [
                    19968
                ],
                256
            ],
            12033: [
                [
                    20008
                ],
                256
            ],
            12034: [
                [
                    20022
                ],
                256
            ],
            12035: [
                [
                    20031
                ],
                256
            ],
            12036: [
                [
                    20057
                ],
                256
            ],
            12037: [
                [
                    20101
                ],
                256
            ],
            12038: [
                [
                    20108
                ],
                256
            ],
            12039: [
                [
                    20128
                ],
                256
            ],
            12040: [
                [
                    20154
                ],
                256
            ],
            12041: [
                [
                    20799
                ],
                256
            ],
            12042: [
                [
                    20837
                ],
                256
            ],
            12043: [
                [
                    20843
                ],
                256
            ],
            12044: [
                [
                    20866
                ],
                256
            ],
            12045: [
                [
                    20886
                ],
                256
            ],
            12046: [
                [
                    20907
                ],
                256
            ],
            12047: [
                [
                    20960
                ],
                256
            ],
            12048: [
                [
                    20981
                ],
                256
            ],
            12049: [
                [
                    20992
                ],
                256
            ],
            12050: [
                [
                    21147
                ],
                256
            ],
            12051: [
                [
                    21241
                ],
                256
            ],
            12052: [
                [
                    21269
                ],
                256
            ],
            12053: [
                [
                    21274
                ],
                256
            ],
            12054: [
                [
                    21304
                ],
                256
            ],
            12055: [
                [
                    21313
                ],
                256
            ],
            12056: [
                [
                    21340
                ],
                256
            ],
            12057: [
                [
                    21353
                ],
                256
            ],
            12058: [
                [
                    21378
                ],
                256
            ],
            12059: [
                [
                    21430
                ],
                256
            ],
            12060: [
                [
                    21448
                ],
                256
            ],
            12061: [
                [
                    21475
                ],
                256
            ],
            12062: [
                [
                    22231
                ],
                256
            ],
            12063: [
                [
                    22303
                ],
                256
            ],
            12064: [
                [
                    22763
                ],
                256
            ],
            12065: [
                [
                    22786
                ],
                256
            ],
            12066: [
                [
                    22794
                ],
                256
            ],
            12067: [
                [
                    22805
                ],
                256
            ],
            12068: [
                [
                    22823
                ],
                256
            ],
            12069: [
                [
                    22899
                ],
                256
            ],
            12070: [
                [
                    23376
                ],
                256
            ],
            12071: [
                [
                    23424
                ],
                256
            ],
            12072: [
                [
                    23544
                ],
                256
            ],
            12073: [
                [
                    23567
                ],
                256
            ],
            12074: [
                [
                    23586
                ],
                256
            ],
            12075: [
                [
                    23608
                ],
                256
            ],
            12076: [
                [
                    23662
                ],
                256
            ],
            12077: [
                [
                    23665
                ],
                256
            ],
            12078: [
                [
                    24027
                ],
                256
            ],
            12079: [
                [
                    24037
                ],
                256
            ],
            12080: [
                [
                    24049
                ],
                256
            ],
            12081: [
                [
                    24062
                ],
                256
            ],
            12082: [
                [
                    24178
                ],
                256
            ],
            12083: [
                [
                    24186
                ],
                256
            ],
            12084: [
                [
                    24191
                ],
                256
            ],
            12085: [
                [
                    24308
                ],
                256
            ],
            12086: [
                [
                    24318
                ],
                256
            ],
            12087: [
                [
                    24331
                ],
                256
            ],
            12088: [
                [
                    24339
                ],
                256
            ],
            12089: [
                [
                    24400
                ],
                256
            ],
            12090: [
                [
                    24417
                ],
                256
            ],
            12091: [
                [
                    24435
                ],
                256
            ],
            12092: [
                [
                    24515
                ],
                256
            ],
            12093: [
                [
                    25096
                ],
                256
            ],
            12094: [
                [
                    25142
                ],
                256
            ],
            12095: [
                [
                    25163
                ],
                256
            ],
            12096: [
                [
                    25903
                ],
                256
            ],
            12097: [
                [
                    25908
                ],
                256
            ],
            12098: [
                [
                    25991
                ],
                256
            ],
            12099: [
                [
                    26007
                ],
                256
            ],
            12100: [
                [
                    26020
                ],
                256
            ],
            12101: [
                [
                    26041
                ],
                256
            ],
            12102: [
                [
                    26080
                ],
                256
            ],
            12103: [
                [
                    26085
                ],
                256
            ],
            12104: [
                [
                    26352
                ],
                256
            ],
            12105: [
                [
                    26376
                ],
                256
            ],
            12106: [
                [
                    26408
                ],
                256
            ],
            12107: [
                [
                    27424
                ],
                256
            ],
            12108: [
                [
                    27490
                ],
                256
            ],
            12109: [
                [
                    27513
                ],
                256
            ],
            12110: [
                [
                    27571
                ],
                256
            ],
            12111: [
                [
                    27595
                ],
                256
            ],
            12112: [
                [
                    27604
                ],
                256
            ],
            12113: [
                [
                    27611
                ],
                256
            ],
            12114: [
                [
                    27663
                ],
                256
            ],
            12115: [
                [
                    27668
                ],
                256
            ],
            12116: [
                [
                    27700
                ],
                256
            ],
            12117: [
                [
                    28779
                ],
                256
            ],
            12118: [
                [
                    29226
                ],
                256
            ],
            12119: [
                [
                    29238
                ],
                256
            ],
            12120: [
                [
                    29243
                ],
                256
            ],
            12121: [
                [
                    29247
                ],
                256
            ],
            12122: [
                [
                    29255
                ],
                256
            ],
            12123: [
                [
                    29273
                ],
                256
            ],
            12124: [
                [
                    29275
                ],
                256
            ],
            12125: [
                [
                    29356
                ],
                256
            ],
            12126: [
                [
                    29572
                ],
                256
            ],
            12127: [
                [
                    29577
                ],
                256
            ],
            12128: [
                [
                    29916
                ],
                256
            ],
            12129: [
                [
                    29926
                ],
                256
            ],
            12130: [
                [
                    29976
                ],
                256
            ],
            12131: [
                [
                    29983
                ],
                256
            ],
            12132: [
                [
                    29992
                ],
                256
            ],
            12133: [
                [
                    30000
                ],
                256
            ],
            12134: [
                [
                    30091
                ],
                256
            ],
            12135: [
                [
                    30098
                ],
                256
            ],
            12136: [
                [
                    30326
                ],
                256
            ],
            12137: [
                [
                    30333
                ],
                256
            ],
            12138: [
                [
                    30382
                ],
                256
            ],
            12139: [
                [
                    30399
                ],
                256
            ],
            12140: [
                [
                    30446
                ],
                256
            ],
            12141: [
                [
                    30683
                ],
                256
            ],
            12142: [
                [
                    30690
                ],
                256
            ],
            12143: [
                [
                    30707
                ],
                256
            ],
            12144: [
                [
                    31034
                ],
                256
            ],
            12145: [
                [
                    31160
                ],
                256
            ],
            12146: [
                [
                    31166
                ],
                256
            ],
            12147: [
                [
                    31348
                ],
                256
            ],
            12148: [
                [
                    31435
                ],
                256
            ],
            12149: [
                [
                    31481
                ],
                256
            ],
            12150: [
                [
                    31859
                ],
                256
            ],
            12151: [
                [
                    31992
                ],
                256
            ],
            12152: [
                [
                    32566
                ],
                256
            ],
            12153: [
                [
                    32593
                ],
                256
            ],
            12154: [
                [
                    32650
                ],
                256
            ],
            12155: [
                [
                    32701
                ],
                256
            ],
            12156: [
                [
                    32769
                ],
                256
            ],
            12157: [
                [
                    32780
                ],
                256
            ],
            12158: [
                [
                    32786
                ],
                256
            ],
            12159: [
                [
                    32819
                ],
                256
            ],
            12160: [
                [
                    32895
                ],
                256
            ],
            12161: [
                [
                    32905
                ],
                256
            ],
            12162: [
                [
                    33251
                ],
                256
            ],
            12163: [
                [
                    33258
                ],
                256
            ],
            12164: [
                [
                    33267
                ],
                256
            ],
            12165: [
                [
                    33276
                ],
                256
            ],
            12166: [
                [
                    33292
                ],
                256
            ],
            12167: [
                [
                    33307
                ],
                256
            ],
            12168: [
                [
                    33311
                ],
                256
            ],
            12169: [
                [
                    33390
                ],
                256
            ],
            12170: [
                [
                    33394
                ],
                256
            ],
            12171: [
                [
                    33400
                ],
                256
            ],
            12172: [
                [
                    34381
                ],
                256
            ],
            12173: [
                [
                    34411
                ],
                256
            ],
            12174: [
                [
                    34880
                ],
                256
            ],
            12175: [
                [
                    34892
                ],
                256
            ],
            12176: [
                [
                    34915
                ],
                256
            ],
            12177: [
                [
                    35198
                ],
                256
            ],
            12178: [
                [
                    35211
                ],
                256
            ],
            12179: [
                [
                    35282
                ],
                256
            ],
            12180: [
                [
                    35328
                ],
                256
            ],
            12181: [
                [
                    35895
                ],
                256
            ],
            12182: [
                [
                    35910
                ],
                256
            ],
            12183: [
                [
                    35925
                ],
                256
            ],
            12184: [
                [
                    35960
                ],
                256
            ],
            12185: [
                [
                    35997
                ],
                256
            ],
            12186: [
                [
                    36196
                ],
                256
            ],
            12187: [
                [
                    36208
                ],
                256
            ],
            12188: [
                [
                    36275
                ],
                256
            ],
            12189: [
                [
                    36523
                ],
                256
            ],
            12190: [
                [
                    36554
                ],
                256
            ],
            12191: [
                [
                    36763
                ],
                256
            ],
            12192: [
                [
                    36784
                ],
                256
            ],
            12193: [
                [
                    36789
                ],
                256
            ],
            12194: [
                [
                    37009
                ],
                256
            ],
            12195: [
                [
                    37193
                ],
                256
            ],
            12196: [
                [
                    37318
                ],
                256
            ],
            12197: [
                [
                    37324
                ],
                256
            ],
            12198: [
                [
                    37329
                ],
                256
            ],
            12199: [
                [
                    38263
                ],
                256
            ],
            12200: [
                [
                    38272
                ],
                256
            ],
            12201: [
                [
                    38428
                ],
                256
            ],
            12202: [
                [
                    38582
                ],
                256
            ],
            12203: [
                [
                    38585
                ],
                256
            ],
            12204: [
                [
                    38632
                ],
                256
            ],
            12205: [
                [
                    38737
                ],
                256
            ],
            12206: [
                [
                    38750
                ],
                256
            ],
            12207: [
                [
                    38754
                ],
                256
            ],
            12208: [
                [
                    38761
                ],
                256
            ],
            12209: [
                [
                    38859
                ],
                256
            ],
            12210: [
                [
                    38893
                ],
                256
            ],
            12211: [
                [
                    38899
                ],
                256
            ],
            12212: [
                [
                    38913
                ],
                256
            ],
            12213: [
                [
                    39080
                ],
                256
            ],
            12214: [
                [
                    39131
                ],
                256
            ],
            12215: [
                [
                    39135
                ],
                256
            ],
            12216: [
                [
                    39318
                ],
                256
            ],
            12217: [
                [
                    39321
                ],
                256
            ],
            12218: [
                [
                    39340
                ],
                256
            ],
            12219: [
                [
                    39592
                ],
                256
            ],
            12220: [
                [
                    39640
                ],
                256
            ],
            12221: [
                [
                    39647
                ],
                256
            ],
            12222: [
                [
                    39717
                ],
                256
            ],
            12223: [
                [
                    39727
                ],
                256
            ],
            12224: [
                [
                    39730
                ],
                256
            ],
            12225: [
                [
                    39740
                ],
                256
            ],
            12226: [
                [
                    39770
                ],
                256
            ],
            12227: [
                [
                    40165
                ],
                256
            ],
            12228: [
                [
                    40565
                ],
                256
            ],
            12229: [
                [
                    40575
                ],
                256
            ],
            12230: [
                [
                    40613
                ],
                256
            ],
            12231: [
                [
                    40635
                ],
                256
            ],
            12232: [
                [
                    40643
                ],
                256
            ],
            12233: [
                [
                    40653
                ],
                256
            ],
            12234: [
                [
                    40657
                ],
                256
            ],
            12235: [
                [
                    40697
                ],
                256
            ],
            12236: [
                [
                    40701
                ],
                256
            ],
            12237: [
                [
                    40718
                ],
                256
            ],
            12238: [
                [
                    40723
                ],
                256
            ],
            12239: [
                [
                    40736
                ],
                256
            ],
            12240: [
                [
                    40763
                ],
                256
            ],
            12241: [
                [
                    40778
                ],
                256
            ],
            12242: [
                [
                    40786
                ],
                256
            ],
            12243: [
                [
                    40845
                ],
                256
            ],
            12244: [
                [
                    40860
                ],
                256
            ],
            12245: [
                [
                    40864
                ],
                256
            ]
        },
        12288: {
            12288: [
                [
                    32
                ],
                256
            ],
            12330: [
                ,
                218
            ],
            12331: [
                ,
                228
            ],
            12332: [
                ,
                232
            ],
            12333: [
                ,
                222
            ],
            12334: [
                ,
                224
            ],
            12335: [
                ,
                224
            ],
            12342: [
                [
                    12306
                ],
                256
            ],
            12344: [
                [
                    21313
                ],
                256
            ],
            12345: [
                [
                    21316
                ],
                256
            ],
            12346: [
                [
                    21317
                ],
                256
            ],
            12358: [
                ,
                ,
                {
                    12441: 12436
                }
            ],
            12363: [
                ,
                ,
                {
                    12441: 12364
                }
            ],
            12364: [
                [
                    12363,
                    12441
                ]
            ],
            12365: [
                ,
                ,
                {
                    12441: 12366
                }
            ],
            12366: [
                [
                    12365,
                    12441
                ]
            ],
            12367: [
                ,
                ,
                {
                    12441: 12368
                }
            ],
            12368: [
                [
                    12367,
                    12441
                ]
            ],
            12369: [
                ,
                ,
                {
                    12441: 12370
                }
            ],
            12370: [
                [
                    12369,
                    12441
                ]
            ],
            12371: [
                ,
                ,
                {
                    12441: 12372
                }
            ],
            12372: [
                [
                    12371,
                    12441
                ]
            ],
            12373: [
                ,
                ,
                {
                    12441: 12374
                }
            ],
            12374: [
                [
                    12373,
                    12441
                ]
            ],
            12375: [
                ,
                ,
                {
                    12441: 12376
                }
            ],
            12376: [
                [
                    12375,
                    12441
                ]
            ],
            12377: [
                ,
                ,
                {
                    12441: 12378
                }
            ],
            12378: [
                [
                    12377,
                    12441
                ]
            ],
            12379: [
                ,
                ,
                {
                    12441: 12380
                }
            ],
            12380: [
                [
                    12379,
                    12441
                ]
            ],
            12381: [
                ,
                ,
                {
                    12441: 12382
                }
            ],
            12382: [
                [
                    12381,
                    12441
                ]
            ],
            12383: [
                ,
                ,
                {
                    12441: 12384
                }
            ],
            12384: [
                [
                    12383,
                    12441
                ]
            ],
            12385: [
                ,
                ,
                {
                    12441: 12386
                }
            ],
            12386: [
                [
                    12385,
                    12441
                ]
            ],
            12388: [
                ,
                ,
                {
                    12441: 12389
                }
            ],
            12389: [
                [
                    12388,
                    12441
                ]
            ],
            12390: [
                ,
                ,
                {
                    12441: 12391
                }
            ],
            12391: [
                [
                    12390,
                    12441
                ]
            ],
            12392: [
                ,
                ,
                {
                    12441: 12393
                }
            ],
            12393: [
                [
                    12392,
                    12441
                ]
            ],
            12399: [
                ,
                ,
                {
                    12441: 12400,
                    12442: 12401
                }
            ],
            12400: [
                [
                    12399,
                    12441
                ]
            ],
            12401: [
                [
                    12399,
                    12442
                ]
            ],
            12402: [
                ,
                ,
                {
                    12441: 12403,
                    12442: 12404
                }
            ],
            12403: [
                [
                    12402,
                    12441
                ]
            ],
            12404: [
                [
                    12402,
                    12442
                ]
            ],
            12405: [
                ,
                ,
                {
                    12441: 12406,
                    12442: 12407
                }
            ],
            12406: [
                [
                    12405,
                    12441
                ]
            ],
            12407: [
                [
                    12405,
                    12442
                ]
            ],
            12408: [
                ,
                ,
                {
                    12441: 12409,
                    12442: 12410
                }
            ],
            12409: [
                [
                    12408,
                    12441
                ]
            ],
            12410: [
                [
                    12408,
                    12442
                ]
            ],
            12411: [
                ,
                ,
                {
                    12441: 12412,
                    12442: 12413
                }
            ],
            12412: [
                [
                    12411,
                    12441
                ]
            ],
            12413: [
                [
                    12411,
                    12442
                ]
            ],
            12436: [
                [
                    12358,
                    12441
                ]
            ],
            12441: [
                ,
                8
            ],
            12442: [
                ,
                8
            ],
            12443: [
                [
                    32,
                    12441
                ],
                256
            ],
            12444: [
                [
                    32,
                    12442
                ],
                256
            ],
            12445: [
                ,
                ,
                {
                    12441: 12446
                }
            ],
            12446: [
                [
                    12445,
                    12441
                ]
            ],
            12447: [
                [
                    12424,
                    12426
                ],
                256
            ],
            12454: [
                ,
                ,
                {
                    12441: 12532
                }
            ],
            12459: [
                ,
                ,
                {
                    12441: 12460
                }
            ],
            12460: [
                [
                    12459,
                    12441
                ]
            ],
            12461: [
                ,
                ,
                {
                    12441: 12462
                }
            ],
            12462: [
                [
                    12461,
                    12441
                ]
            ],
            12463: [
                ,
                ,
                {
                    12441: 12464
                }
            ],
            12464: [
                [
                    12463,
                    12441
                ]
            ],
            12465: [
                ,
                ,
                {
                    12441: 12466
                }
            ],
            12466: [
                [
                    12465,
                    12441
                ]
            ],
            12467: [
                ,
                ,
                {
                    12441: 12468
                }
            ],
            12468: [
                [
                    12467,
                    12441
                ]
            ],
            12469: [
                ,
                ,
                {
                    12441: 12470
                }
            ],
            12470: [
                [
                    12469,
                    12441
                ]
            ],
            12471: [
                ,
                ,
                {
                    12441: 12472
                }
            ],
            12472: [
                [
                    12471,
                    12441
                ]
            ],
            12473: [
                ,
                ,
                {
                    12441: 12474
                }
            ],
            12474: [
                [
                    12473,
                    12441
                ]
            ],
            12475: [
                ,
                ,
                {
                    12441: 12476
                }
            ],
            12476: [
                [
                    12475,
                    12441
                ]
            ],
            12477: [
                ,
                ,
                {
                    12441: 12478
                }
            ],
            12478: [
                [
                    12477,
                    12441
                ]
            ],
            12479: [
                ,
                ,
                {
                    12441: 12480
                }
            ],
            12480: [
                [
                    12479,
                    12441
                ]
            ],
            12481: [
                ,
                ,
                {
                    12441: 12482
                }
            ],
            12482: [
                [
                    12481,
                    12441
                ]
            ],
            12484: [
                ,
                ,
                {
                    12441: 12485
                }
            ],
            12485: [
                [
                    12484,
                    12441
                ]
            ],
            12486: [
                ,
                ,
                {
                    12441: 12487
                }
            ],
            12487: [
                [
                    12486,
                    12441
                ]
            ],
            12488: [
                ,
                ,
                {
                    12441: 12489
                }
            ],
            12489: [
                [
                    12488,
                    12441
                ]
            ],
            12495: [
                ,
                ,
                {
                    12441: 12496,
                    12442: 12497
                }
            ],
            12496: [
                [
                    12495,
                    12441
                ]
            ],
            12497: [
                [
                    12495,
                    12442
                ]
            ],
            12498: [
                ,
                ,
                {
                    12441: 12499,
                    12442: 12500
                }
            ],
            12499: [
                [
                    12498,
                    12441
                ]
            ],
            12500: [
                [
                    12498,
                    12442
                ]
            ],
            12501: [
                ,
                ,
                {
                    12441: 12502,
                    12442: 12503
                }
            ],
            12502: [
                [
                    12501,
                    12441
                ]
            ],
            12503: [
                [
                    12501,
                    12442
                ]
            ],
            12504: [
                ,
                ,
                {
                    12441: 12505,
                    12442: 12506
                }
            ],
            12505: [
                [
                    12504,
                    12441
                ]
            ],
            12506: [
                [
                    12504,
                    12442
                ]
            ],
            12507: [
                ,
                ,
                {
                    12441: 12508,
                    12442: 12509
                }
            ],
            12508: [
                [
                    12507,
                    12441
                ]
            ],
            12509: [
                [
                    12507,
                    12442
                ]
            ],
            12527: [
                ,
                ,
                {
                    12441: 12535
                }
            ],
            12528: [
                ,
                ,
                {
                    12441: 12536
                }
            ],
            12529: [
                ,
                ,
                {
                    12441: 12537
                }
            ],
            12530: [
                ,
                ,
                {
                    12441: 12538
                }
            ],
            12532: [
                [
                    12454,
                    12441
                ]
            ],
            12535: [
                [
                    12527,
                    12441
                ]
            ],
            12536: [
                [
                    12528,
                    12441
                ]
            ],
            12537: [
                [
                    12529,
                    12441
                ]
            ],
            12538: [
                [
                    12530,
                    12441
                ]
            ],
            12541: [
                ,
                ,
                {
                    12441: 12542
                }
            ],
            12542: [
                [
                    12541,
                    12441
                ]
            ],
            12543: [
                [
                    12467,
                    12488
                ],
                256
            ]
        },
        12544: {
            12593: [
                [
                    4352
                ],
                256
            ],
            12594: [
                [
                    4353
                ],
                256
            ],
            12595: [
                [
                    4522
                ],
                256
            ],
            12596: [
                [
                    4354
                ],
                256
            ],
            12597: [
                [
                    4524
                ],
                256
            ],
            12598: [
                [
                    4525
                ],
                256
            ],
            12599: [
                [
                    4355
                ],
                256
            ],
            12600: [
                [
                    4356
                ],
                256
            ],
            12601: [
                [
                    4357
                ],
                256
            ],
            12602: [
                [
                    4528
                ],
                256
            ],
            12603: [
                [
                    4529
                ],
                256
            ],
            12604: [
                [
                    4530
                ],
                256
            ],
            12605: [
                [
                    4531
                ],
                256
            ],
            12606: [
                [
                    4532
                ],
                256
            ],
            12607: [
                [
                    4533
                ],
                256
            ],
            12608: [
                [
                    4378
                ],
                256
            ],
            12609: [
                [
                    4358
                ],
                256
            ],
            12610: [
                [
                    4359
                ],
                256
            ],
            12611: [
                [
                    4360
                ],
                256
            ],
            12612: [
                [
                    4385
                ],
                256
            ],
            12613: [
                [
                    4361
                ],
                256
            ],
            12614: [
                [
                    4362
                ],
                256
            ],
            12615: [
                [
                    4363
                ],
                256
            ],
            12616: [
                [
                    4364
                ],
                256
            ],
            12617: [
                [
                    4365
                ],
                256
            ],
            12618: [
                [
                    4366
                ],
                256
            ],
            12619: [
                [
                    4367
                ],
                256
            ],
            12620: [
                [
                    4368
                ],
                256
            ],
            12621: [
                [
                    4369
                ],
                256
            ],
            12622: [
                [
                    4370
                ],
                256
            ],
            12623: [
                [
                    4449
                ],
                256
            ],
            12624: [
                [
                    4450
                ],
                256
            ],
            12625: [
                [
                    4451
                ],
                256
            ],
            12626: [
                [
                    4452
                ],
                256
            ],
            12627: [
                [
                    4453
                ],
                256
            ],
            12628: [
                [
                    4454
                ],
                256
            ],
            12629: [
                [
                    4455
                ],
                256
            ],
            12630: [
                [
                    4456
                ],
                256
            ],
            12631: [
                [
                    4457
                ],
                256
            ],
            12632: [
                [
                    4458
                ],
                256
            ],
            12633: [
                [
                    4459
                ],
                256
            ],
            12634: [
                [
                    4460
                ],
                256
            ],
            12635: [
                [
                    4461
                ],
                256
            ],
            12636: [
                [
                    4462
                ],
                256
            ],
            12637: [
                [
                    4463
                ],
                256
            ],
            12638: [
                [
                    4464
                ],
                256
            ],
            12639: [
                [
                    4465
                ],
                256
            ],
            12640: [
                [
                    4466
                ],
                256
            ],
            12641: [
                [
                    4467
                ],
                256
            ],
            12642: [
                [
                    4468
                ],
                256
            ],
            12643: [
                [
                    4469
                ],
                256
            ],
            12644: [
                [
                    4448
                ],
                256
            ],
            12645: [
                [
                    4372
                ],
                256
            ],
            12646: [
                [
                    4373
                ],
                256
            ],
            12647: [
                [
                    4551
                ],
                256
            ],
            12648: [
                [
                    4552
                ],
                256
            ],
            12649: [
                [
                    4556
                ],
                256
            ],
            12650: [
                [
                    4558
                ],
                256
            ],
            12651: [
                [
                    4563
                ],
                256
            ],
            12652: [
                [
                    4567
                ],
                256
            ],
            12653: [
                [
                    4569
                ],
                256
            ],
            12654: [
                [
                    4380
                ],
                256
            ],
            12655: [
                [
                    4573
                ],
                256
            ],
            12656: [
                [
                    4575
                ],
                256
            ],
            12657: [
                [
                    4381
                ],
                256
            ],
            12658: [
                [
                    4382
                ],
                256
            ],
            12659: [
                [
                    4384
                ],
                256
            ],
            12660: [
                [
                    4386
                ],
                256
            ],
            12661: [
                [
                    4387
                ],
                256
            ],
            12662: [
                [
                    4391
                ],
                256
            ],
            12663: [
                [
                    4393
                ],
                256
            ],
            12664: [
                [
                    4395
                ],
                256
            ],
            12665: [
                [
                    4396
                ],
                256
            ],
            12666: [
                [
                    4397
                ],
                256
            ],
            12667: [
                [
                    4398
                ],
                256
            ],
            12668: [
                [
                    4399
                ],
                256
            ],
            12669: [
                [
                    4402
                ],
                256
            ],
            12670: [
                [
                    4406
                ],
                256
            ],
            12671: [
                [
                    4416
                ],
                256
            ],
            12672: [
                [
                    4423
                ],
                256
            ],
            12673: [
                [
                    4428
                ],
                256
            ],
            12674: [
                [
                    4593
                ],
                256
            ],
            12675: [
                [
                    4594
                ],
                256
            ],
            12676: [
                [
                    4439
                ],
                256
            ],
            12677: [
                [
                    4440
                ],
                256
            ],
            12678: [
                [
                    4441
                ],
                256
            ],
            12679: [
                [
                    4484
                ],
                256
            ],
            12680: [
                [
                    4485
                ],
                256
            ],
            12681: [
                [
                    4488
                ],
                256
            ],
            12682: [
                [
                    4497
                ],
                256
            ],
            12683: [
                [
                    4498
                ],
                256
            ],
            12684: [
                [
                    4500
                ],
                256
            ],
            12685: [
                [
                    4510
                ],
                256
            ],
            12686: [
                [
                    4513
                ],
                256
            ],
            12690: [
                [
                    19968
                ],
                256
            ],
            12691: [
                [
                    20108
                ],
                256
            ],
            12692: [
                [
                    19977
                ],
                256
            ],
            12693: [
                [
                    22235
                ],
                256
            ],
            12694: [
                [
                    19978
                ],
                256
            ],
            12695: [
                [
                    20013
                ],
                256
            ],
            12696: [
                [
                    19979
                ],
                256
            ],
            12697: [
                [
                    30002
                ],
                256
            ],
            12698: [
                [
                    20057
                ],
                256
            ],
            12699: [
                [
                    19993
                ],
                256
            ],
            12700: [
                [
                    19969
                ],
                256
            ],
            12701: [
                [
                    22825
                ],
                256
            ],
            12702: [
                [
                    22320
                ],
                256
            ],
            12703: [
                [
                    20154
                ],
                256
            ]
        },
        12800: {
            12800: [
                [
                    40,
                    4352,
                    41
                ],
                256
            ],
            12801: [
                [
                    40,
                    4354,
                    41
                ],
                256
            ],
            12802: [
                [
                    40,
                    4355,
                    41
                ],
                256
            ],
            12803: [
                [
                    40,
                    4357,
                    41
                ],
                256
            ],
            12804: [
                [
                    40,
                    4358,
                    41
                ],
                256
            ],
            12805: [
                [
                    40,
                    4359,
                    41
                ],
                256
            ],
            12806: [
                [
                    40,
                    4361,
                    41
                ],
                256
            ],
            12807: [
                [
                    40,
                    4363,
                    41
                ],
                256
            ],
            12808: [
                [
                    40,
                    4364,
                    41
                ],
                256
            ],
            12809: [
                [
                    40,
                    4366,
                    41
                ],
                256
            ],
            12810: [
                [
                    40,
                    4367,
                    41
                ],
                256
            ],
            12811: [
                [
                    40,
                    4368,
                    41
                ],
                256
            ],
            12812: [
                [
                    40,
                    4369,
                    41
                ],
                256
            ],
            12813: [
                [
                    40,
                    4370,
                    41
                ],
                256
            ],
            12814: [
                [
                    40,
                    4352,
                    4449,
                    41
                ],
                256
            ],
            12815: [
                [
                    40,
                    4354,
                    4449,
                    41
                ],
                256
            ],
            12816: [
                [
                    40,
                    4355,
                    4449,
                    41
                ],
                256
            ],
            12817: [
                [
                    40,
                    4357,
                    4449,
                    41
                ],
                256
            ],
            12818: [
                [
                    40,
                    4358,
                    4449,
                    41
                ],
                256
            ],
            12819: [
                [
                    40,
                    4359,
                    4449,
                    41
                ],
                256
            ],
            12820: [
                [
                    40,
                    4361,
                    4449,
                    41
                ],
                256
            ],
            12821: [
                [
                    40,
                    4363,
                    4449,
                    41
                ],
                256
            ],
            12822: [
                [
                    40,
                    4364,
                    4449,
                    41
                ],
                256
            ],
            12823: [
                [
                    40,
                    4366,
                    4449,
                    41
                ],
                256
            ],
            12824: [
                [
                    40,
                    4367,
                    4449,
                    41
                ],
                256
            ],
            12825: [
                [
                    40,
                    4368,
                    4449,
                    41
                ],
                256
            ],
            12826: [
                [
                    40,
                    4369,
                    4449,
                    41
                ],
                256
            ],
            12827: [
                [
                    40,
                    4370,
                    4449,
                    41
                ],
                256
            ],
            12828: [
                [
                    40,
                    4364,
                    4462,
                    41
                ],
                256
            ],
            12829: [
                [
                    40,
                    4363,
                    4457,
                    4364,
                    4453,
                    4523,
                    41
                ],
                256
            ],
            12830: [
                [
                    40,
                    4363,
                    4457,
                    4370,
                    4462,
                    41
                ],
                256
            ],
            12832: [
                [
                    40,
                    19968,
                    41
                ],
                256
            ],
            12833: [
                [
                    40,
                    20108,
                    41
                ],
                256
            ],
            12834: [
                [
                    40,
                    19977,
                    41
                ],
                256
            ],
            12835: [
                [
                    40,
                    22235,
                    41
                ],
                256
            ],
            12836: [
                [
                    40,
                    20116,
                    41
                ],
                256
            ],
            12837: [
                [
                    40,
                    20845,
                    41
                ],
                256
            ],
            12838: [
                [
                    40,
                    19971,
                    41
                ],
                256
            ],
            12839: [
                [
                    40,
                    20843,
                    41
                ],
                256
            ],
            12840: [
                [
                    40,
                    20061,
                    41
                ],
                256
            ],
            12841: [
                [
                    40,
                    21313,
                    41
                ],
                256
            ],
            12842: [
                [
                    40,
                    26376,
                    41
                ],
                256
            ],
            12843: [
                [
                    40,
                    28779,
                    41
                ],
                256
            ],
            12844: [
                [
                    40,
                    27700,
                    41
                ],
                256
            ],
            12845: [
                [
                    40,
                    26408,
                    41
                ],
                256
            ],
            12846: [
                [
                    40,
                    37329,
                    41
                ],
                256
            ],
            12847: [
                [
                    40,
                    22303,
                    41
                ],
                256
            ],
            12848: [
                [
                    40,
                    26085,
                    41
                ],
                256
            ],
            12849: [
                [
                    40,
                    26666,
                    41
                ],
                256
            ],
            12850: [
                [
                    40,
                    26377,
                    41
                ],
                256
            ],
            12851: [
                [
                    40,
                    31038,
                    41
                ],
                256
            ],
            12852: [
                [
                    40,
                    21517,
                    41
                ],
                256
            ],
            12853: [
                [
                    40,
                    29305,
                    41
                ],
                256
            ],
            12854: [
                [
                    40,
                    36001,
                    41
                ],
                256
            ],
            12855: [
                [
                    40,
                    31069,
                    41
                ],
                256
            ],
            12856: [
                [
                    40,
                    21172,
                    41
                ],
                256
            ],
            12857: [
                [
                    40,
                    20195,
                    41
                ],
                256
            ],
            12858: [
                [
                    40,
                    21628,
                    41
                ],
                256
            ],
            12859: [
                [
                    40,
                    23398,
                    41
                ],
                256
            ],
            12860: [
                [
                    40,
                    30435,
                    41
                ],
                256
            ],
            12861: [
                [
                    40,
                    20225,
                    41
                ],
                256
            ],
            12862: [
                [
                    40,
                    36039,
                    41
                ],
                256
            ],
            12863: [
                [
                    40,
                    21332,
                    41
                ],
                256
            ],
            12864: [
                [
                    40,
                    31085,
                    41
                ],
                256
            ],
            12865: [
                [
                    40,
                    20241,
                    41
                ],
                256
            ],
            12866: [
                [
                    40,
                    33258,
                    41
                ],
                256
            ],
            12867: [
                [
                    40,
                    33267,
                    41
                ],
                256
            ],
            12868: [
                [
                    21839
                ],
                256
            ],
            12869: [
                [
                    24188
                ],
                256
            ],
            12870: [
                [
                    25991
                ],
                256
            ],
            12871: [
                [
                    31631
                ],
                256
            ],
            12880: [
                [
                    80,
                    84,
                    69
                ],
                256
            ],
            12881: [
                [
                    50,
                    49
                ],
                256
            ],
            12882: [
                [
                    50,
                    50
                ],
                256
            ],
            12883: [
                [
                    50,
                    51
                ],
                256
            ],
            12884: [
                [
                    50,
                    52
                ],
                256
            ],
            12885: [
                [
                    50,
                    53
                ],
                256
            ],
            12886: [
                [
                    50,
                    54
                ],
                256
            ],
            12887: [
                [
                    50,
                    55
                ],
                256
            ],
            12888: [
                [
                    50,
                    56
                ],
                256
            ],
            12889: [
                [
                    50,
                    57
                ],
                256
            ],
            12890: [
                [
                    51,
                    48
                ],
                256
            ],
            12891: [
                [
                    51,
                    49
                ],
                256
            ],
            12892: [
                [
                    51,
                    50
                ],
                256
            ],
            12893: [
                [
                    51,
                    51
                ],
                256
            ],
            12894: [
                [
                    51,
                    52
                ],
                256
            ],
            12895: [
                [
                    51,
                    53
                ],
                256
            ],
            12896: [
                [
                    4352
                ],
                256
            ],
            12897: [
                [
                    4354
                ],
                256
            ],
            12898: [
                [
                    4355
                ],
                256
            ],
            12899: [
                [
                    4357
                ],
                256
            ],
            12900: [
                [
                    4358
                ],
                256
            ],
            12901: [
                [
                    4359
                ],
                256
            ],
            12902: [
                [
                    4361
                ],
                256
            ],
            12903: [
                [
                    4363
                ],
                256
            ],
            12904: [
                [
                    4364
                ],
                256
            ],
            12905: [
                [
                    4366
                ],
                256
            ],
            12906: [
                [
                    4367
                ],
                256
            ],
            12907: [
                [
                    4368
                ],
                256
            ],
            12908: [
                [
                    4369
                ],
                256
            ],
            12909: [
                [
                    4370
                ],
                256
            ],
            12910: [
                [
                    4352,
                    4449
                ],
                256
            ],
            12911: [
                [
                    4354,
                    4449
                ],
                256
            ],
            12912: [
                [
                    4355,
                    4449
                ],
                256
            ],
            12913: [
                [
                    4357,
                    4449
                ],
                256
            ],
            12914: [
                [
                    4358,
                    4449
                ],
                256
            ],
            12915: [
                [
                    4359,
                    4449
                ],
                256
            ],
            12916: [
                [
                    4361,
                    4449
                ],
                256
            ],
            12917: [
                [
                    4363,
                    4449
                ],
                256
            ],
            12918: [
                [
                    4364,
                    4449
                ],
                256
            ],
            12919: [
                [
                    4366,
                    4449
                ],
                256
            ],
            12920: [
                [
                    4367,
                    4449
                ],
                256
            ],
            12921: [
                [
                    4368,
                    4449
                ],
                256
            ],
            12922: [
                [
                    4369,
                    4449
                ],
                256
            ],
            12923: [
                [
                    4370,
                    4449
                ],
                256
            ],
            12924: [
                [
                    4366,
                    4449,
                    4535,
                    4352,
                    4457
                ],
                256
            ],
            12925: [
                [
                    4364,
                    4462,
                    4363,
                    4468
                ],
                256
            ],
            12926: [
                [
                    4363,
                    4462
                ],
                256
            ],
            12928: [
                [
                    19968
                ],
                256
            ],
            12929: [
                [
                    20108
                ],
                256
            ],
            12930: [
                [
                    19977
                ],
                256
            ],
            12931: [
                [
                    22235
                ],
                256
            ],
            12932: [
                [
                    20116
                ],
                256
            ],
            12933: [
                [
                    20845
                ],
                256
            ],
            12934: [
                [
                    19971
                ],
                256
            ],
            12935: [
                [
                    20843
                ],
                256
            ],
            12936: [
                [
                    20061
                ],
                256
            ],
            12937: [
                [
                    21313
                ],
                256
            ],
            12938: [
                [
                    26376
                ],
                256
            ],
            12939: [
                [
                    28779
                ],
                256
            ],
            12940: [
                [
                    27700
                ],
                256
            ],
            12941: [
                [
                    26408
                ],
                256
            ],
            12942: [
                [
                    37329
                ],
                256
            ],
            12943: [
                [
                    22303
                ],
                256
            ],
            12944: [
                [
                    26085
                ],
                256
            ],
            12945: [
                [
                    26666
                ],
                256
            ],
            12946: [
                [
                    26377
                ],
                256
            ],
            12947: [
                [
                    31038
                ],
                256
            ],
            12948: [
                [
                    21517
                ],
                256
            ],
            12949: [
                [
                    29305
                ],
                256
            ],
            12950: [
                [
                    36001
                ],
                256
            ],
            12951: [
                [
                    31069
                ],
                256
            ],
            12952: [
                [
                    21172
                ],
                256
            ],
            12953: [
                [
                    31192
                ],
                256
            ],
            12954: [
                [
                    30007
                ],
                256
            ],
            12955: [
                [
                    22899
                ],
                256
            ],
            12956: [
                [
                    36969
                ],
                256
            ],
            12957: [
                [
                    20778
                ],
                256
            ],
            12958: [
                [
                    21360
                ],
                256
            ],
            12959: [
                [
                    27880
                ],
                256
            ],
            12960: [
                [
                    38917
                ],
                256
            ],
            12961: [
                [
                    20241
                ],
                256
            ],
            12962: [
                [
                    20889
                ],
                256
            ],
            12963: [
                [
                    27491
                ],
                256
            ],
            12964: [
                [
                    19978
                ],
                256
            ],
            12965: [
                [
                    20013
                ],
                256
            ],
            12966: [
                [
                    19979
                ],
                256
            ],
            12967: [
                [
                    24038
                ],
                256
            ],
            12968: [
                [
                    21491
                ],
                256
            ],
            12969: [
                [
                    21307
                ],
                256
            ],
            12970: [
                [
                    23447
                ],
                256
            ],
            12971: [
                [
                    23398
                ],
                256
            ],
            12972: [
                [
                    30435
                ],
                256
            ],
            12973: [
                [
                    20225
                ],
                256
            ],
            12974: [
                [
                    36039
                ],
                256
            ],
            12975: [
                [
                    21332
                ],
                256
            ],
            12976: [
                [
                    22812
                ],
                256
            ],
            12977: [
                [
                    51,
                    54
                ],
                256
            ],
            12978: [
                [
                    51,
                    55
                ],
                256
            ],
            12979: [
                [
                    51,
                    56
                ],
                256
            ],
            12980: [
                [
                    51,
                    57
                ],
                256
            ],
            12981: [
                [
                    52,
                    48
                ],
                256
            ],
            12982: [
                [
                    52,
                    49
                ],
                256
            ],
            12983: [
                [
                    52,
                    50
                ],
                256
            ],
            12984: [
                [
                    52,
                    51
                ],
                256
            ],
            12985: [
                [
                    52,
                    52
                ],
                256
            ],
            12986: [
                [
                    52,
                    53
                ],
                256
            ],
            12987: [
                [
                    52,
                    54
                ],
                256
            ],
            12988: [
                [
                    52,
                    55
                ],
                256
            ],
            12989: [
                [
                    52,
                    56
                ],
                256
            ],
            12990: [
                [
                    52,
                    57
                ],
                256
            ],
            12991: [
                [
                    53,
                    48
                ],
                256
            ],
            12992: [
                [
                    49,
                    26376
                ],
                256
            ],
            12993: [
                [
                    50,
                    26376
                ],
                256
            ],
            12994: [
                [
                    51,
                    26376
                ],
                256
            ],
            12995: [
                [
                    52,
                    26376
                ],
                256
            ],
            12996: [
                [
                    53,
                    26376
                ],
                256
            ],
            12997: [
                [
                    54,
                    26376
                ],
                256
            ],
            12998: [
                [
                    55,
                    26376
                ],
                256
            ],
            12999: [
                [
                    56,
                    26376
                ],
                256
            ],
            13000: [
                [
                    57,
                    26376
                ],
                256
            ],
            13001: [
                [
                    49,
                    48,
                    26376
                ],
                256
            ],
            13002: [
                [
                    49,
                    49,
                    26376
                ],
                256
            ],
            13003: [
                [
                    49,
                    50,
                    26376
                ],
                256
            ],
            13004: [
                [
                    72,
                    103
                ],
                256
            ],
            13005: [
                [
                    101,
                    114,
                    103
                ],
                256
            ],
            13006: [
                [
                    101,
                    86
                ],
                256
            ],
            13007: [
                [
                    76,
                    84,
                    68
                ],
                256
            ],
            13008: [
                [
                    12450
                ],
                256
            ],
            13009: [
                [
                    12452
                ],
                256
            ],
            13010: [
                [
                    12454
                ],
                256
            ],
            13011: [
                [
                    12456
                ],
                256
            ],
            13012: [
                [
                    12458
                ],
                256
            ],
            13013: [
                [
                    12459
                ],
                256
            ],
            13014: [
                [
                    12461
                ],
                256
            ],
            13015: [
                [
                    12463
                ],
                256
            ],
            13016: [
                [
                    12465
                ],
                256
            ],
            13017: [
                [
                    12467
                ],
                256
            ],
            13018: [
                [
                    12469
                ],
                256
            ],
            13019: [
                [
                    12471
                ],
                256
            ],
            13020: [
                [
                    12473
                ],
                256
            ],
            13021: [
                [
                    12475
                ],
                256
            ],
            13022: [
                [
                    12477
                ],
                256
            ],
            13023: [
                [
                    12479
                ],
                256
            ],
            13024: [
                [
                    12481
                ],
                256
            ],
            13025: [
                [
                    12484
                ],
                256
            ],
            13026: [
                [
                    12486
                ],
                256
            ],
            13027: [
                [
                    12488
                ],
                256
            ],
            13028: [
                [
                    12490
                ],
                256
            ],
            13029: [
                [
                    12491
                ],
                256
            ],
            13030: [
                [
                    12492
                ],
                256
            ],
            13031: [
                [
                    12493
                ],
                256
            ],
            13032: [
                [
                    12494
                ],
                256
            ],
            13033: [
                [
                    12495
                ],
                256
            ],
            13034: [
                [
                    12498
                ],
                256
            ],
            13035: [
                [
                    12501
                ],
                256
            ],
            13036: [
                [
                    12504
                ],
                256
            ],
            13037: [
                [
                    12507
                ],
                256
            ],
            13038: [
                [
                    12510
                ],
                256
            ],
            13039: [
                [
                    12511
                ],
                256
            ],
            13040: [
                [
                    12512
                ],
                256
            ],
            13041: [
                [
                    12513
                ],
                256
            ],
            13042: [
                [
                    12514
                ],
                256
            ],
            13043: [
                [
                    12516
                ],
                256
            ],
            13044: [
                [
                    12518
                ],
                256
            ],
            13045: [
                [
                    12520
                ],
                256
            ],
            13046: [
                [
                    12521
                ],
                256
            ],
            13047: [
                [
                    12522
                ],
                256
            ],
            13048: [
                [
                    12523
                ],
                256
            ],
            13049: [
                [
                    12524
                ],
                256
            ],
            13050: [
                [
                    12525
                ],
                256
            ],
            13051: [
                [
                    12527
                ],
                256
            ],
            13052: [
                [
                    12528
                ],
                256
            ],
            13053: [
                [
                    12529
                ],
                256
            ],
            13054: [
                [
                    12530
                ],
                256
            ]
        },
        13056: {
            13056: [
                [
                    12450,
                    12497,
                    12540,
                    12488
                ],
                256
            ],
            13057: [
                [
                    12450,
                    12523,
                    12501,
                    12449
                ],
                256
            ],
            13058: [
                [
                    12450,
                    12531,
                    12506,
                    12450
                ],
                256
            ],
            13059: [
                [
                    12450,
                    12540,
                    12523
                ],
                256
            ],
            13060: [
                [
                    12452,
                    12491,
                    12531,
                    12464
                ],
                256
            ],
            13061: [
                [
                    12452,
                    12531,
                    12481
                ],
                256
            ],
            13062: [
                [
                    12454,
                    12457,
                    12531
                ],
                256
            ],
            13063: [
                [
                    12456,
                    12473,
                    12463,
                    12540,
                    12489
                ],
                256
            ],
            13064: [
                [
                    12456,
                    12540,
                    12459,
                    12540
                ],
                256
            ],
            13065: [
                [
                    12458,
                    12531,
                    12473
                ],
                256
            ],
            13066: [
                [
                    12458,
                    12540,
                    12512
                ],
                256
            ],
            13067: [
                [
                    12459,
                    12452,
                    12522
                ],
                256
            ],
            13068: [
                [
                    12459,
                    12521,
                    12483,
                    12488
                ],
                256
            ],
            13069: [
                [
                    12459,
                    12525,
                    12522,
                    12540
                ],
                256
            ],
            13070: [
                [
                    12460,
                    12525,
                    12531
                ],
                256
            ],
            13071: [
                [
                    12460,
                    12531,
                    12510
                ],
                256
            ],
            13072: [
                [
                    12462,
                    12460
                ],
                256
            ],
            13073: [
                [
                    12462,
                    12491,
                    12540
                ],
                256
            ],
            13074: [
                [
                    12461,
                    12517,
                    12522,
                    12540
                ],
                256
            ],
            13075: [
                [
                    12462,
                    12523,
                    12480,
                    12540
                ],
                256
            ],
            13076: [
                [
                    12461,
                    12525
                ],
                256
            ],
            13077: [
                [
                    12461,
                    12525,
                    12464,
                    12521,
                    12512
                ],
                256
            ],
            13078: [
                [
                    12461,
                    12525,
                    12513,
                    12540,
                    12488,
                    12523
                ],
                256
            ],
            13079: [
                [
                    12461,
                    12525,
                    12527,
                    12483,
                    12488
                ],
                256
            ],
            13080: [
                [
                    12464,
                    12521,
                    12512
                ],
                256
            ],
            13081: [
                [
                    12464,
                    12521,
                    12512,
                    12488,
                    12531
                ],
                256
            ],
            13082: [
                [
                    12463,
                    12523,
                    12476,
                    12452,
                    12525
                ],
                256
            ],
            13083: [
                [
                    12463,
                    12525,
                    12540,
                    12493
                ],
                256
            ],
            13084: [
                [
                    12465,
                    12540,
                    12473
                ],
                256
            ],
            13085: [
                [
                    12467,
                    12523,
                    12490
                ],
                256
            ],
            13086: [
                [
                    12467,
                    12540,
                    12509
                ],
                256
            ],
            13087: [
                [
                    12469,
                    12452,
                    12463,
                    12523
                ],
                256
            ],
            13088: [
                [
                    12469,
                    12531,
                    12481,
                    12540,
                    12512
                ],
                256
            ],
            13089: [
                [
                    12471,
                    12522,
                    12531,
                    12464
                ],
                256
            ],
            13090: [
                [
                    12475,
                    12531,
                    12481
                ],
                256
            ],
            13091: [
                [
                    12475,
                    12531,
                    12488
                ],
                256
            ],
            13092: [
                [
                    12480,
                    12540,
                    12473
                ],
                256
            ],
            13093: [
                [
                    12487,
                    12471
                ],
                256
            ],
            13094: [
                [
                    12489,
                    12523
                ],
                256
            ],
            13095: [
                [
                    12488,
                    12531
                ],
                256
            ],
            13096: [
                [
                    12490,
                    12494
                ],
                256
            ],
            13097: [
                [
                    12494,
                    12483,
                    12488
                ],
                256
            ],
            13098: [
                [
                    12495,
                    12452,
                    12484
                ],
                256
            ],
            13099: [
                [
                    12497,
                    12540,
                    12475,
                    12531,
                    12488
                ],
                256
            ],
            13100: [
                [
                    12497,
                    12540,
                    12484
                ],
                256
            ],
            13101: [
                [
                    12496,
                    12540,
                    12524,
                    12523
                ],
                256
            ],
            13102: [
                [
                    12500,
                    12450,
                    12473,
                    12488,
                    12523
                ],
                256
            ],
            13103: [
                [
                    12500,
                    12463,
                    12523
                ],
                256
            ],
            13104: [
                [
                    12500,
                    12467
                ],
                256
            ],
            13105: [
                [
                    12499,
                    12523
                ],
                256
            ],
            13106: [
                [
                    12501,
                    12449,
                    12521,
                    12483,
                    12489
                ],
                256
            ],
            13107: [
                [
                    12501,
                    12451,
                    12540,
                    12488
                ],
                256
            ],
            13108: [
                [
                    12502,
                    12483,
                    12471,
                    12455,
                    12523
                ],
                256
            ],
            13109: [
                [
                    12501,
                    12521,
                    12531
                ],
                256
            ],
            13110: [
                [
                    12504,
                    12463,
                    12479,
                    12540,
                    12523
                ],
                256
            ],
            13111: [
                [
                    12506,
                    12477
                ],
                256
            ],
            13112: [
                [
                    12506,
                    12491,
                    12498
                ],
                256
            ],
            13113: [
                [
                    12504,
                    12523,
                    12484
                ],
                256
            ],
            13114: [
                [
                    12506,
                    12531,
                    12473
                ],
                256
            ],
            13115: [
                [
                    12506,
                    12540,
                    12472
                ],
                256
            ],
            13116: [
                [
                    12505,
                    12540,
                    12479
                ],
                256
            ],
            13117: [
                [
                    12509,
                    12452,
                    12531,
                    12488
                ],
                256
            ],
            13118: [
                [
                    12508,
                    12523,
                    12488
                ],
                256
            ],
            13119: [
                [
                    12507,
                    12531
                ],
                256
            ],
            13120: [
                [
                    12509,
                    12531,
                    12489
                ],
                256
            ],
            13121: [
                [
                    12507,
                    12540,
                    12523
                ],
                256
            ],
            13122: [
                [
                    12507,
                    12540,
                    12531
                ],
                256
            ],
            13123: [
                [
                    12510,
                    12452,
                    12463,
                    12525
                ],
                256
            ],
            13124: [
                [
                    12510,
                    12452,
                    12523
                ],
                256
            ],
            13125: [
                [
                    12510,
                    12483,
                    12495
                ],
                256
            ],
            13126: [
                [
                    12510,
                    12523,
                    12463
                ],
                256
            ],
            13127: [
                [
                    12510,
                    12531,
                    12471,
                    12519,
                    12531
                ],
                256
            ],
            13128: [
                [
                    12511,
                    12463,
                    12525,
                    12531
                ],
                256
            ],
            13129: [
                [
                    12511,
                    12522
                ],
                256
            ],
            13130: [
                [
                    12511,
                    12522,
                    12496,
                    12540,
                    12523
                ],
                256
            ],
            13131: [
                [
                    12513,
                    12460
                ],
                256
            ],
            13132: [
                [
                    12513,
                    12460,
                    12488,
                    12531
                ],
                256
            ],
            13133: [
                [
                    12513,
                    12540,
                    12488,
                    12523
                ],
                256
            ],
            13134: [
                [
                    12516,
                    12540,
                    12489
                ],
                256
            ],
            13135: [
                [
                    12516,
                    12540,
                    12523
                ],
                256
            ],
            13136: [
                [
                    12518,
                    12450,
                    12531
                ],
                256
            ],
            13137: [
                [
                    12522,
                    12483,
                    12488,
                    12523
                ],
                256
            ],
            13138: [
                [
                    12522,
                    12521
                ],
                256
            ],
            13139: [
                [
                    12523,
                    12500,
                    12540
                ],
                256
            ],
            13140: [
                [
                    12523,
                    12540,
                    12502,
                    12523
                ],
                256
            ],
            13141: [
                [
                    12524,
                    12512
                ],
                256
            ],
            13142: [
                [
                    12524,
                    12531,
                    12488,
                    12466,
                    12531
                ],
                256
            ],
            13143: [
                [
                    12527,
                    12483,
                    12488
                ],
                256
            ],
            13144: [
                [
                    48,
                    28857
                ],
                256
            ],
            13145: [
                [
                    49,
                    28857
                ],
                256
            ],
            13146: [
                [
                    50,
                    28857
                ],
                256
            ],
            13147: [
                [
                    51,
                    28857
                ],
                256
            ],
            13148: [
                [
                    52,
                    28857
                ],
                256
            ],
            13149: [
                [
                    53,
                    28857
                ],
                256
            ],
            13150: [
                [
                    54,
                    28857
                ],
                256
            ],
            13151: [
                [
                    55,
                    28857
                ],
                256
            ],
            13152: [
                [
                    56,
                    28857
                ],
                256
            ],
            13153: [
                [
                    57,
                    28857
                ],
                256
            ],
            13154: [
                [
                    49,
                    48,
                    28857
                ],
                256
            ],
            13155: [
                [
                    49,
                    49,
                    28857
                ],
                256
            ],
            13156: [
                [
                    49,
                    50,
                    28857
                ],
                256
            ],
            13157: [
                [
                    49,
                    51,
                    28857
                ],
                256
            ],
            13158: [
                [
                    49,
                    52,
                    28857
                ],
                256
            ],
            13159: [
                [
                    49,
                    53,
                    28857
                ],
                256
            ],
            13160: [
                [
                    49,
                    54,
                    28857
                ],
                256
            ],
            13161: [
                [
                    49,
                    55,
                    28857
                ],
                256
            ],
            13162: [
                [
                    49,
                    56,
                    28857
                ],
                256
            ],
            13163: [
                [
                    49,
                    57,
                    28857
                ],
                256
            ],
            13164: [
                [
                    50,
                    48,
                    28857
                ],
                256
            ],
            13165: [
                [
                    50,
                    49,
                    28857
                ],
                256
            ],
            13166: [
                [
                    50,
                    50,
                    28857
                ],
                256
            ],
            13167: [
                [
                    50,
                    51,
                    28857
                ],
                256
            ],
            13168: [
                [
                    50,
                    52,
                    28857
                ],
                256
            ],
            13169: [
                [
                    104,
                    80,
                    97
                ],
                256
            ],
            13170: [
                [
                    100,
                    97
                ],
                256
            ],
            13171: [
                [
                    65,
                    85
                ],
                256
            ],
            13172: [
                [
                    98,
                    97,
                    114
                ],
                256
            ],
            13173: [
                [
                    111,
                    86
                ],
                256
            ],
            13174: [
                [
                    112,
                    99
                ],
                256
            ],
            13175: [
                [
                    100,
                    109
                ],
                256
            ],
            13176: [
                [
                    100,
                    109,
                    178
                ],
                256
            ],
            13177: [
                [
                    100,
                    109,
                    179
                ],
                256
            ],
            13178: [
                [
                    73,
                    85
                ],
                256
            ],
            13179: [
                [
                    24179,
                    25104
                ],
                256
            ],
            13180: [
                [
                    26157,
                    21644
                ],
                256
            ],
            13181: [
                [
                    22823,
                    27491
                ],
                256
            ],
            13182: [
                [
                    26126,
                    27835
                ],
                256
            ],
            13183: [
                [
                    26666,
                    24335,
                    20250,
                    31038
                ],
                256
            ],
            13184: [
                [
                    112,
                    65
                ],
                256
            ],
            13185: [
                [
                    110,
                    65
                ],
                256
            ],
            13186: [
                [
                    956,
                    65
                ],
                256
            ],
            13187: [
                [
                    109,
                    65
                ],
                256
            ],
            13188: [
                [
                    107,
                    65
                ],
                256
            ],
            13189: [
                [
                    75,
                    66
                ],
                256
            ],
            13190: [
                [
                    77,
                    66
                ],
                256
            ],
            13191: [
                [
                    71,
                    66
                ],
                256
            ],
            13192: [
                [
                    99,
                    97,
                    108
                ],
                256
            ],
            13193: [
                [
                    107,
                    99,
                    97,
                    108
                ],
                256
            ],
            13194: [
                [
                    112,
                    70
                ],
                256
            ],
            13195: [
                [
                    110,
                    70
                ],
                256
            ],
            13196: [
                [
                    956,
                    70
                ],
                256
            ],
            13197: [
                [
                    956,
                    103
                ],
                256
            ],
            13198: [
                [
                    109,
                    103
                ],
                256
            ],
            13199: [
                [
                    107,
                    103
                ],
                256
            ],
            13200: [
                [
                    72,
                    122
                ],
                256
            ],
            13201: [
                [
                    107,
                    72,
                    122
                ],
                256
            ],
            13202: [
                [
                    77,
                    72,
                    122
                ],
                256
            ],
            13203: [
                [
                    71,
                    72,
                    122
                ],
                256
            ],
            13204: [
                [
                    84,
                    72,
                    122
                ],
                256
            ],
            13205: [
                [
                    956,
                    8467
                ],
                256
            ],
            13206: [
                [
                    109,
                    8467
                ],
                256
            ],
            13207: [
                [
                    100,
                    8467
                ],
                256
            ],
            13208: [
                [
                    107,
                    8467
                ],
                256
            ],
            13209: [
                [
                    102,
                    109
                ],
                256
            ],
            13210: [
                [
                    110,
                    109
                ],
                256
            ],
            13211: [
                [
                    956,
                    109
                ],
                256
            ],
            13212: [
                [
                    109,
                    109
                ],
                256
            ],
            13213: [
                [
                    99,
                    109
                ],
                256
            ],
            13214: [
                [
                    107,
                    109
                ],
                256
            ],
            13215: [
                [
                    109,
                    109,
                    178
                ],
                256
            ],
            13216: [
                [
                    99,
                    109,
                    178
                ],
                256
            ],
            13217: [
                [
                    109,
                    178
                ],
                256
            ],
            13218: [
                [
                    107,
                    109,
                    178
                ],
                256
            ],
            13219: [
                [
                    109,
                    109,
                    179
                ],
                256
            ],
            13220: [
                [
                    99,
                    109,
                    179
                ],
                256
            ],
            13221: [
                [
                    109,
                    179
                ],
                256
            ],
            13222: [
                [
                    107,
                    109,
                    179
                ],
                256
            ],
            13223: [
                [
                    109,
                    8725,
                    115
                ],
                256
            ],
            13224: [
                [
                    109,
                    8725,
                    115,
                    178
                ],
                256
            ],
            13225: [
                [
                    80,
                    97
                ],
                256
            ],
            13226: [
                [
                    107,
                    80,
                    97
                ],
                256
            ],
            13227: [
                [
                    77,
                    80,
                    97
                ],
                256
            ],
            13228: [
                [
                    71,
                    80,
                    97
                ],
                256
            ],
            13229: [
                [
                    114,
                    97,
                    100
                ],
                256
            ],
            13230: [
                [
                    114,
                    97,
                    100,
                    8725,
                    115
                ],
                256
            ],
            13231: [
                [
                    114,
                    97,
                    100,
                    8725,
                    115,
                    178
                ],
                256
            ],
            13232: [
                [
                    112,
                    115
                ],
                256
            ],
            13233: [
                [
                    110,
                    115
                ],
                256
            ],
            13234: [
                [
                    956,
                    115
                ],
                256
            ],
            13235: [
                [
                    109,
                    115
                ],
                256
            ],
            13236: [
                [
                    112,
                    86
                ],
                256
            ],
            13237: [
                [
                    110,
                    86
                ],
                256
            ],
            13238: [
                [
                    956,
                    86
                ],
                256
            ],
            13239: [
                [
                    109,
                    86
                ],
                256
            ],
            13240: [
                [
                    107,
                    86
                ],
                256
            ],
            13241: [
                [
                    77,
                    86
                ],
                256
            ],
            13242: [
                [
                    112,
                    87
                ],
                256
            ],
            13243: [
                [
                    110,
                    87
                ],
                256
            ],
            13244: [
                [
                    956,
                    87
                ],
                256
            ],
            13245: [
                [
                    109,
                    87
                ],
                256
            ],
            13246: [
                [
                    107,
                    87
                ],
                256
            ],
            13247: [
                [
                    77,
                    87
                ],
                256
            ],
            13248: [
                [
                    107,
                    937
                ],
                256
            ],
            13249: [
                [
                    77,
                    937
                ],
                256
            ],
            13250: [
                [
                    97,
                    46,
                    109,
                    46
                ],
                256
            ],
            13251: [
                [
                    66,
                    113
                ],
                256
            ],
            13252: [
                [
                    99,
                    99
                ],
                256
            ],
            13253: [
                [
                    99,
                    100
                ],
                256
            ],
            13254: [
                [
                    67,
                    8725,
                    107,
                    103
                ],
                256
            ],
            13255: [
                [
                    67,
                    111,
                    46
                ],
                256
            ],
            13256: [
                [
                    100,
                    66
                ],
                256
            ],
            13257: [
                [
                    71,
                    121
                ],
                256
            ],
            13258: [
                [
                    104,
                    97
                ],
                256
            ],
            13259: [
                [
                    72,
                    80
                ],
                256
            ],
            13260: [
                [
                    105,
                    110
                ],
                256
            ],
            13261: [
                [
                    75,
                    75
                ],
                256
            ],
            13262: [
                [
                    75,
                    77
                ],
                256
            ],
            13263: [
                [
                    107,
                    116
                ],
                256
            ],
            13264: [
                [
                    108,
                    109
                ],
                256
            ],
            13265: [
                [
                    108,
                    110
                ],
                256
            ],
            13266: [
                [
                    108,
                    111,
                    103
                ],
                256
            ],
            13267: [
                [
                    108,
                    120
                ],
                256
            ],
            13268: [
                [
                    109,
                    98
                ],
                256
            ],
            13269: [
                [
                    109,
                    105,
                    108
                ],
                256
            ],
            13270: [
                [
                    109,
                    111,
                    108
                ],
                256
            ],
            13271: [
                [
                    80,
                    72
                ],
                256
            ],
            13272: [
                [
                    112,
                    46,
                    109,
                    46
                ],
                256
            ],
            13273: [
                [
                    80,
                    80,
                    77
                ],
                256
            ],
            13274: [
                [
                    80,
                    82
                ],
                256
            ],
            13275: [
                [
                    115,
                    114
                ],
                256
            ],
            13276: [
                [
                    83,
                    118
                ],
                256
            ],
            13277: [
                [
                    87,
                    98
                ],
                256
            ],
            13278: [
                [
                    86,
                    8725,
                    109
                ],
                256
            ],
            13279: [
                [
                    65,
                    8725,
                    109
                ],
                256
            ],
            13280: [
                [
                    49,
                    26085
                ],
                256
            ],
            13281: [
                [
                    50,
                    26085
                ],
                256
            ],
            13282: [
                [
                    51,
                    26085
                ],
                256
            ],
            13283: [
                [
                    52,
                    26085
                ],
                256
            ],
            13284: [
                [
                    53,
                    26085
                ],
                256
            ],
            13285: [
                [
                    54,
                    26085
                ],
                256
            ],
            13286: [
                [
                    55,
                    26085
                ],
                256
            ],
            13287: [
                [
                    56,
                    26085
                ],
                256
            ],
            13288: [
                [
                    57,
                    26085
                ],
                256
            ],
            13289: [
                [
                    49,
                    48,
                    26085
                ],
                256
            ],
            13290: [
                [
                    49,
                    49,
                    26085
                ],
                256
            ],
            13291: [
                [
                    49,
                    50,
                    26085
                ],
                256
            ],
            13292: [
                [
                    49,
                    51,
                    26085
                ],
                256
            ],
            13293: [
                [
                    49,
                    52,
                    26085
                ],
                256
            ],
            13294: [
                [
                    49,
                    53,
                    26085
                ],
                256
            ],
            13295: [
                [
                    49,
                    54,
                    26085
                ],
                256
            ],
            13296: [
                [
                    49,
                    55,
                    26085
                ],
                256
            ],
            13297: [
                [
                    49,
                    56,
                    26085
                ],
                256
            ],
            13298: [
                [
                    49,
                    57,
                    26085
                ],
                256
            ],
            13299: [
                [
                    50,
                    48,
                    26085
                ],
                256
            ],
            13300: [
                [
                    50,
                    49,
                    26085
                ],
                256
            ],
            13301: [
                [
                    50,
                    50,
                    26085
                ],
                256
            ],
            13302: [
                [
                    50,
                    51,
                    26085
                ],
                256
            ],
            13303: [
                [
                    50,
                    52,
                    26085
                ],
                256
            ],
            13304: [
                [
                    50,
                    53,
                    26085
                ],
                256
            ],
            13305: [
                [
                    50,
                    54,
                    26085
                ],
                256
            ],
            13306: [
                [
                    50,
                    55,
                    26085
                ],
                256
            ],
            13307: [
                [
                    50,
                    56,
                    26085
                ],
                256
            ],
            13308: [
                [
                    50,
                    57,
                    26085
                ],
                256
            ],
            13309: [
                [
                    51,
                    48,
                    26085
                ],
                256
            ],
            13310: [
                [
                    51,
                    49,
                    26085
                ],
                256
            ],
            13311: [
                [
                    103,
                    97,
                    108
                ],
                256
            ]
        },
        27136: {
            92912: [
                ,
                1
            ],
            92913: [
                ,
                1
            ],
            92914: [
                ,
                1
            ],
            92915: [
                ,
                1
            ],
            92916: [
                ,
                1
            ]
        },
        27392: {
            92976: [
                ,
                230
            ],
            92977: [
                ,
                230
            ],
            92978: [
                ,
                230
            ],
            92979: [
                ,
                230
            ],
            92980: [
                ,
                230
            ],
            92981: [
                ,
                230
            ],
            92982: [
                ,
                230
            ]
        },
        42496: {
            42607: [
                ,
                230
            ],
            42612: [
                ,
                230
            ],
            42613: [
                ,
                230
            ],
            42614: [
                ,
                230
            ],
            42615: [
                ,
                230
            ],
            42616: [
                ,
                230
            ],
            42617: [
                ,
                230
            ],
            42618: [
                ,
                230
            ],
            42619: [
                ,
                230
            ],
            42620: [
                ,
                230
            ],
            42621: [
                ,
                230
            ],
            42652: [
                [
                    1098
                ],
                256
            ],
            42653: [
                [
                    1100
                ],
                256
            ],
            42655: [
                ,
                230
            ],
            42736: [
                ,
                230
            ],
            42737: [
                ,
                230
            ]
        },
        42752: {
            42864: [
                [
                    42863
                ],
                256
            ],
            43000: [
                [
                    294
                ],
                256
            ],
            43001: [
                [
                    339
                ],
                256
            ]
        },
        43008: {
            43014: [
                ,
                9
            ],
            43204: [
                ,
                9
            ],
            43232: [
                ,
                230
            ],
            43233: [
                ,
                230
            ],
            43234: [
                ,
                230
            ],
            43235: [
                ,
                230
            ],
            43236: [
                ,
                230
            ],
            43237: [
                ,
                230
            ],
            43238: [
                ,
                230
            ],
            43239: [
                ,
                230
            ],
            43240: [
                ,
                230
            ],
            43241: [
                ,
                230
            ],
            43242: [
                ,
                230
            ],
            43243: [
                ,
                230
            ],
            43244: [
                ,
                230
            ],
            43245: [
                ,
                230
            ],
            43246: [
                ,
                230
            ],
            43247: [
                ,
                230
            ],
            43248: [
                ,
                230
            ],
            43249: [
                ,
                230
            ]
        },
        43264: {
            43307: [
                ,
                220
            ],
            43308: [
                ,
                220
            ],
            43309: [
                ,
                220
            ],
            43347: [
                ,
                9
            ],
            43443: [
                ,
                7
            ],
            43456: [
                ,
                9
            ]
        },
        43520: {
            43696: [
                ,
                230
            ],
            43698: [
                ,
                230
            ],
            43699: [
                ,
                230
            ],
            43700: [
                ,
                220
            ],
            43703: [
                ,
                230
            ],
            43704: [
                ,
                230
            ],
            43710: [
                ,
                230
            ],
            43711: [
                ,
                230
            ],
            43713: [
                ,
                230
            ],
            43766: [
                ,
                9
            ]
        },
        43776: {
            43868: [
                [
                    42791
                ],
                256
            ],
            43869: [
                [
                    43831
                ],
                256
            ],
            43870: [
                [
                    619
                ],
                256
            ],
            43871: [
                [
                    43858
                ],
                256
            ],
            44013: [
                ,
                9
            ]
        },
        48128: {
            113822: [
                ,
                1
            ]
        },
        53504: {
            119134: [
                [
                    119127,
                    119141
                ],
                512
            ],
            119135: [
                [
                    119128,
                    119141
                ],
                512
            ],
            119136: [
                [
                    119135,
                    119150
                ],
                512
            ],
            119137: [
                [
                    119135,
                    119151
                ],
                512
            ],
            119138: [
                [
                    119135,
                    119152
                ],
                512
            ],
            119139: [
                [
                    119135,
                    119153
                ],
                512
            ],
            119140: [
                [
                    119135,
                    119154
                ],
                512
            ],
            119141: [
                ,
                216
            ],
            119142: [
                ,
                216
            ],
            119143: [
                ,
                1
            ],
            119144: [
                ,
                1
            ],
            119145: [
                ,
                1
            ],
            119149: [
                ,
                226
            ],
            119150: [
                ,
                216
            ],
            119151: [
                ,
                216
            ],
            119152: [
                ,
                216
            ],
            119153: [
                ,
                216
            ],
            119154: [
                ,
                216
            ],
            119163: [
                ,
                220
            ],
            119164: [
                ,
                220
            ],
            119165: [
                ,
                220
            ],
            119166: [
                ,
                220
            ],
            119167: [
                ,
                220
            ],
            119168: [
                ,
                220
            ],
            119169: [
                ,
                220
            ],
            119170: [
                ,
                220
            ],
            119173: [
                ,
                230
            ],
            119174: [
                ,
                230
            ],
            119175: [
                ,
                230
            ],
            119176: [
                ,
                230
            ],
            119177: [
                ,
                230
            ],
            119178: [
                ,
                220
            ],
            119179: [
                ,
                220
            ],
            119210: [
                ,
                230
            ],
            119211: [
                ,
                230
            ],
            119212: [
                ,
                230
            ],
            119213: [
                ,
                230
            ],
            119227: [
                [
                    119225,
                    119141
                ],
                512
            ],
            119228: [
                [
                    119226,
                    119141
                ],
                512
            ],
            119229: [
                [
                    119227,
                    119150
                ],
                512
            ],
            119230: [
                [
                    119228,
                    119150
                ],
                512
            ],
            119231: [
                [
                    119227,
                    119151
                ],
                512
            ],
            119232: [
                [
                    119228,
                    119151
                ],
                512
            ]
        },
        53760: {
            119362: [
                ,
                230
            ],
            119363: [
                ,
                230
            ],
            119364: [
                ,
                230
            ]
        },
        54272: {
            119808: [
                [
                    65
                ],
                256
            ],
            119809: [
                [
                    66
                ],
                256
            ],
            119810: [
                [
                    67
                ],
                256
            ],
            119811: [
                [
                    68
                ],
                256
            ],
            119812: [
                [
                    69
                ],
                256
            ],
            119813: [
                [
                    70
                ],
                256
            ],
            119814: [
                [
                    71
                ],
                256
            ],
            119815: [
                [
                    72
                ],
                256
            ],
            119816: [
                [
                    73
                ],
                256
            ],
            119817: [
                [
                    74
                ],
                256
            ],
            119818: [
                [
                    75
                ],
                256
            ],
            119819: [
                [
                    76
                ],
                256
            ],
            119820: [
                [
                    77
                ],
                256
            ],
            119821: [
                [
                    78
                ],
                256
            ],
            119822: [
                [
                    79
                ],
                256
            ],
            119823: [
                [
                    80
                ],
                256
            ],
            119824: [
                [
                    81
                ],
                256
            ],
            119825: [
                [
                    82
                ],
                256
            ],
            119826: [
                [
                    83
                ],
                256
            ],
            119827: [
                [
                    84
                ],
                256
            ],
            119828: [
                [
                    85
                ],
                256
            ],
            119829: [
                [
                    86
                ],
                256
            ],
            119830: [
                [
                    87
                ],
                256
            ],
            119831: [
                [
                    88
                ],
                256
            ],
            119832: [
                [
                    89
                ],
                256
            ],
            119833: [
                [
                    90
                ],
                256
            ],
            119834: [
                [
                    97
                ],
                256
            ],
            119835: [
                [
                    98
                ],
                256
            ],
            119836: [
                [
                    99
                ],
                256
            ],
            119837: [
                [
                    100
                ],
                256
            ],
            119838: [
                [
                    101
                ],
                256
            ],
            119839: [
                [
                    102
                ],
                256
            ],
            119840: [
                [
                    103
                ],
                256
            ],
            119841: [
                [
                    104
                ],
                256
            ],
            119842: [
                [
                    105
                ],
                256
            ],
            119843: [
                [
                    106
                ],
                256
            ],
            119844: [
                [
                    107
                ],
                256
            ],
            119845: [
                [
                    108
                ],
                256
            ],
            119846: [
                [
                    109
                ],
                256
            ],
            119847: [
                [
                    110
                ],
                256
            ],
            119848: [
                [
                    111
                ],
                256
            ],
            119849: [
                [
                    112
                ],
                256
            ],
            119850: [
                [
                    113
                ],
                256
            ],
            119851: [
                [
                    114
                ],
                256
            ],
            119852: [
                [
                    115
                ],
                256
            ],
            119853: [
                [
                    116
                ],
                256
            ],
            119854: [
                [
                    117
                ],
                256
            ],
            119855: [
                [
                    118
                ],
                256
            ],
            119856: [
                [
                    119
                ],
                256
            ],
            119857: [
                [
                    120
                ],
                256
            ],
            119858: [
                [
                    121
                ],
                256
            ],
            119859: [
                [
                    122
                ],
                256
            ],
            119860: [
                [
                    65
                ],
                256
            ],
            119861: [
                [
                    66
                ],
                256
            ],
            119862: [
                [
                    67
                ],
                256
            ],
            119863: [
                [
                    68
                ],
                256
            ],
            119864: [
                [
                    69
                ],
                256
            ],
            119865: [
                [
                    70
                ],
                256
            ],
            119866: [
                [
                    71
                ],
                256
            ],
            119867: [
                [
                    72
                ],
                256
            ],
            119868: [
                [
                    73
                ],
                256
            ],
            119869: [
                [
                    74
                ],
                256
            ],
            119870: [
                [
                    75
                ],
                256
            ],
            119871: [
                [
                    76
                ],
                256
            ],
            119872: [
                [
                    77
                ],
                256
            ],
            119873: [
                [
                    78
                ],
                256
            ],
            119874: [
                [
                    79
                ],
                256
            ],
            119875: [
                [
                    80
                ],
                256
            ],
            119876: [
                [
                    81
                ],
                256
            ],
            119877: [
                [
                    82
                ],
                256
            ],
            119878: [
                [
                    83
                ],
                256
            ],
            119879: [
                [
                    84
                ],
                256
            ],
            119880: [
                [
                    85
                ],
                256
            ],
            119881: [
                [
                    86
                ],
                256
            ],
            119882: [
                [
                    87
                ],
                256
            ],
            119883: [
                [
                    88
                ],
                256
            ],
            119884: [
                [
                    89
                ],
                256
            ],
            119885: [
                [
                    90
                ],
                256
            ],
            119886: [
                [
                    97
                ],
                256
            ],
            119887: [
                [
                    98
                ],
                256
            ],
            119888: [
                [
                    99
                ],
                256
            ],
            119889: [
                [
                    100
                ],
                256
            ],
            119890: [
                [
                    101
                ],
                256
            ],
            119891: [
                [
                    102
                ],
                256
            ],
            119892: [
                [
                    103
                ],
                256
            ],
            119894: [
                [
                    105
                ],
                256
            ],
            119895: [
                [
                    106
                ],
                256
            ],
            119896: [
                [
                    107
                ],
                256
            ],
            119897: [
                [
                    108
                ],
                256
            ],
            119898: [
                [
                    109
                ],
                256
            ],
            119899: [
                [
                    110
                ],
                256
            ],
            119900: [
                [
                    111
                ],
                256
            ],
            119901: [
                [
                    112
                ],
                256
            ],
            119902: [
                [
                    113
                ],
                256
            ],
            119903: [
                [
                    114
                ],
                256
            ],
            119904: [
                [
                    115
                ],
                256
            ],
            119905: [
                [
                    116
                ],
                256
            ],
            119906: [
                [
                    117
                ],
                256
            ],
            119907: [
                [
                    118
                ],
                256
            ],
            119908: [
                [
                    119
                ],
                256
            ],
            119909: [
                [
                    120
                ],
                256
            ],
            119910: [
                [
                    121
                ],
                256
            ],
            119911: [
                [
                    122
                ],
                256
            ],
            119912: [
                [
                    65
                ],
                256
            ],
            119913: [
                [
                    66
                ],
                256
            ],
            119914: [
                [
                    67
                ],
                256
            ],
            119915: [
                [
                    68
                ],
                256
            ],
            119916: [
                [
                    69
                ],
                256
            ],
            119917: [
                [
                    70
                ],
                256
            ],
            119918: [
                [
                    71
                ],
                256
            ],
            119919: [
                [
                    72
                ],
                256
            ],
            119920: [
                [
                    73
                ],
                256
            ],
            119921: [
                [
                    74
                ],
                256
            ],
            119922: [
                [
                    75
                ],
                256
            ],
            119923: [
                [
                    76
                ],
                256
            ],
            119924: [
                [
                    77
                ],
                256
            ],
            119925: [
                [
                    78
                ],
                256
            ],
            119926: [
                [
                    79
                ],
                256
            ],
            119927: [
                [
                    80
                ],
                256
            ],
            119928: [
                [
                    81
                ],
                256
            ],
            119929: [
                [
                    82
                ],
                256
            ],
            119930: [
                [
                    83
                ],
                256
            ],
            119931: [
                [
                    84
                ],
                256
            ],
            119932: [
                [
                    85
                ],
                256
            ],
            119933: [
                [
                    86
                ],
                256
            ],
            119934: [
                [
                    87
                ],
                256
            ],
            119935: [
                [
                    88
                ],
                256
            ],
            119936: [
                [
                    89
                ],
                256
            ],
            119937: [
                [
                    90
                ],
                256
            ],
            119938: [
                [
                    97
                ],
                256
            ],
            119939: [
                [
                    98
                ],
                256
            ],
            119940: [
                [
                    99
                ],
                256
            ],
            119941: [
                [
                    100
                ],
                256
            ],
            119942: [
                [
                    101
                ],
                256
            ],
            119943: [
                [
                    102
                ],
                256
            ],
            119944: [
                [
                    103
                ],
                256
            ],
            119945: [
                [
                    104
                ],
                256
            ],
            119946: [
                [
                    105
                ],
                256
            ],
            119947: [
                [
                    106
                ],
                256
            ],
            119948: [
                [
                    107
                ],
                256
            ],
            119949: [
                [
                    108
                ],
                256
            ],
            119950: [
                [
                    109
                ],
                256
            ],
            119951: [
                [
                    110
                ],
                256
            ],
            119952: [
                [
                    111
                ],
                256
            ],
            119953: [
                [
                    112
                ],
                256
            ],
            119954: [
                [
                    113
                ],
                256
            ],
            119955: [
                [
                    114
                ],
                256
            ],
            119956: [
                [
                    115
                ],
                256
            ],
            119957: [
                [
                    116
                ],
                256
            ],
            119958: [
                [
                    117
                ],
                256
            ],
            119959: [
                [
                    118
                ],
                256
            ],
            119960: [
                [
                    119
                ],
                256
            ],
            119961: [
                [
                    120
                ],
                256
            ],
            119962: [
                [
                    121
                ],
                256
            ],
            119963: [
                [
                    122
                ],
                256
            ],
            119964: [
                [
                    65
                ],
                256
            ],
            119966: [
                [
                    67
                ],
                256
            ],
            119967: [
                [
                    68
                ],
                256
            ],
            119970: [
                [
                    71
                ],
                256
            ],
            119973: [
                [
                    74
                ],
                256
            ],
            119974: [
                [
                    75
                ],
                256
            ],
            119977: [
                [
                    78
                ],
                256
            ],
            119978: [
                [
                    79
                ],
                256
            ],
            119979: [
                [
                    80
                ],
                256
            ],
            119980: [
                [
                    81
                ],
                256
            ],
            119982: [
                [
                    83
                ],
                256
            ],
            119983: [
                [
                    84
                ],
                256
            ],
            119984: [
                [
                    85
                ],
                256
            ],
            119985: [
                [
                    86
                ],
                256
            ],
            119986: [
                [
                    87
                ],
                256
            ],
            119987: [
                [
                    88
                ],
                256
            ],
            119988: [
                [
                    89
                ],
                256
            ],
            119989: [
                [
                    90
                ],
                256
            ],
            119990: [
                [
                    97
                ],
                256
            ],
            119991: [
                [
                    98
                ],
                256
            ],
            119992: [
                [
                    99
                ],
                256
            ],
            119993: [
                [
                    100
                ],
                256
            ],
            119995: [
                [
                    102
                ],
                256
            ],
            119997: [
                [
                    104
                ],
                256
            ],
            119998: [
                [
                    105
                ],
                256
            ],
            119999: [
                [
                    106
                ],
                256
            ],
            120000: [
                [
                    107
                ],
                256
            ],
            120001: [
                [
                    108
                ],
                256
            ],
            120002: [
                [
                    109
                ],
                256
            ],
            120003: [
                [
                    110
                ],
                256
            ],
            120005: [
                [
                    112
                ],
                256
            ],
            120006: [
                [
                    113
                ],
                256
            ],
            120007: [
                [
                    114
                ],
                256
            ],
            120008: [
                [
                    115
                ],
                256
            ],
            120009: [
                [
                    116
                ],
                256
            ],
            120010: [
                [
                    117
                ],
                256
            ],
            120011: [
                [
                    118
                ],
                256
            ],
            120012: [
                [
                    119
                ],
                256
            ],
            120013: [
                [
                    120
                ],
                256
            ],
            120014: [
                [
                    121
                ],
                256
            ],
            120015: [
                [
                    122
                ],
                256
            ],
            120016: [
                [
                    65
                ],
                256
            ],
            120017: [
                [
                    66
                ],
                256
            ],
            120018: [
                [
                    67
                ],
                256
            ],
            120019: [
                [
                    68
                ],
                256
            ],
            120020: [
                [
                    69
                ],
                256
            ],
            120021: [
                [
                    70
                ],
                256
            ],
            120022: [
                [
                    71
                ],
                256
            ],
            120023: [
                [
                    72
                ],
                256
            ],
            120024: [
                [
                    73
                ],
                256
            ],
            120025: [
                [
                    74
                ],
                256
            ],
            120026: [
                [
                    75
                ],
                256
            ],
            120027: [
                [
                    76
                ],
                256
            ],
            120028: [
                [
                    77
                ],
                256
            ],
            120029: [
                [
                    78
                ],
                256
            ],
            120030: [
                [
                    79
                ],
                256
            ],
            120031: [
                [
                    80
                ],
                256
            ],
            120032: [
                [
                    81
                ],
                256
            ],
            120033: [
                [
                    82
                ],
                256
            ],
            120034: [
                [
                    83
                ],
                256
            ],
            120035: [
                [
                    84
                ],
                256
            ],
            120036: [
                [
                    85
                ],
                256
            ],
            120037: [
                [
                    86
                ],
                256
            ],
            120038: [
                [
                    87
                ],
                256
            ],
            120039: [
                [
                    88
                ],
                256
            ],
            120040: [
                [
                    89
                ],
                256
            ],
            120041: [
                [
                    90
                ],
                256
            ],
            120042: [
                [
                    97
                ],
                256
            ],
            120043: [
                [
                    98
                ],
                256
            ],
            120044: [
                [
                    99
                ],
                256
            ],
            120045: [
                [
                    100
                ],
                256
            ],
            120046: [
                [
                    101
                ],
                256
            ],
            120047: [
                [
                    102
                ],
                256
            ],
            120048: [
                [
                    103
                ],
                256
            ],
            120049: [
                [
                    104
                ],
                256
            ],
            120050: [
                [
                    105
                ],
                256
            ],
            120051: [
                [
                    106
                ],
                256
            ],
            120052: [
                [
                    107
                ],
                256
            ],
            120053: [
                [
                    108
                ],
                256
            ],
            120054: [
                [
                    109
                ],
                256
            ],
            120055: [
                [
                    110
                ],
                256
            ],
            120056: [
                [
                    111
                ],
                256
            ],
            120057: [
                [
                    112
                ],
                256
            ],
            120058: [
                [
                    113
                ],
                256
            ],
            120059: [
                [
                    114
                ],
                256
            ],
            120060: [
                [
                    115
                ],
                256
            ],
            120061: [
                [
                    116
                ],
                256
            ],
            120062: [
                [
                    117
                ],
                256
            ],
            120063: [
                [
                    118
                ],
                256
            ]
        },
        54528: {
            120064: [
                [
                    119
                ],
                256
            ],
            120065: [
                [
                    120
                ],
                256
            ],
            120066: [
                [
                    121
                ],
                256
            ],
            120067: [
                [
                    122
                ],
                256
            ],
            120068: [
                [
                    65
                ],
                256
            ],
            120069: [
                [
                    66
                ],
                256
            ],
            120071: [
                [
                    68
                ],
                256
            ],
            120072: [
                [
                    69
                ],
                256
            ],
            120073: [
                [
                    70
                ],
                256
            ],
            120074: [
                [
                    71
                ],
                256
            ],
            120077: [
                [
                    74
                ],
                256
            ],
            120078: [
                [
                    75
                ],
                256
            ],
            120079: [
                [
                    76
                ],
                256
            ],
            120080: [
                [
                    77
                ],
                256
            ],
            120081: [
                [
                    78
                ],
                256
            ],
            120082: [
                [
                    79
                ],
                256
            ],
            120083: [
                [
                    80
                ],
                256
            ],
            120084: [
                [
                    81
                ],
                256
            ],
            120086: [
                [
                    83
                ],
                256
            ],
            120087: [
                [
                    84
                ],
                256
            ],
            120088: [
                [
                    85
                ],
                256
            ],
            120089: [
                [
                    86
                ],
                256
            ],
            120090: [
                [
                    87
                ],
                256
            ],
            120091: [
                [
                    88
                ],
                256
            ],
            120092: [
                [
                    89
                ],
                256
            ],
            120094: [
                [
                    97
                ],
                256
            ],
            120095: [
                [
                    98
                ],
                256
            ],
            120096: [
                [
                    99
                ],
                256
            ],
            120097: [
                [
                    100
                ],
                256
            ],
            120098: [
                [
                    101
                ],
                256
            ],
            120099: [
                [
                    102
                ],
                256
            ],
            120100: [
                [
                    103
                ],
                256
            ],
            120101: [
                [
                    104
                ],
                256
            ],
            120102: [
                [
                    105
                ],
                256
            ],
            120103: [
                [
                    106
                ],
                256
            ],
            120104: [
                [
                    107
                ],
                256
            ],
            120105: [
                [
                    108
                ],
                256
            ],
            120106: [
                [
                    109
                ],
                256
            ],
            120107: [
                [
                    110
                ],
                256
            ],
            120108: [
                [
                    111
                ],
                256
            ],
            120109: [
                [
                    112
                ],
                256
            ],
            120110: [
                [
                    113
                ],
                256
            ],
            120111: [
                [
                    114
                ],
                256
            ],
            120112: [
                [
                    115
                ],
                256
            ],
            120113: [
                [
                    116
                ],
                256
            ],
            120114: [
                [
                    117
                ],
                256
            ],
            120115: [
                [
                    118
                ],
                256
            ],
            120116: [
                [
                    119
                ],
                256
            ],
            120117: [
                [
                    120
                ],
                256
            ],
            120118: [
                [
                    121
                ],
                256
            ],
            120119: [
                [
                    122
                ],
                256
            ],
            120120: [
                [
                    65
                ],
                256
            ],
            120121: [
                [
                    66
                ],
                256
            ],
            120123: [
                [
                    68
                ],
                256
            ],
            120124: [
                [
                    69
                ],
                256
            ],
            120125: [
                [
                    70
                ],
                256
            ],
            120126: [
                [
                    71
                ],
                256
            ],
            120128: [
                [
                    73
                ],
                256
            ],
            120129: [
                [
                    74
                ],
                256
            ],
            120130: [
                [
                    75
                ],
                256
            ],
            120131: [
                [
                    76
                ],
                256
            ],
            120132: [
                [
                    77
                ],
                256
            ],
            120134: [
                [
                    79
                ],
                256
            ],
            120138: [
                [
                    83
                ],
                256
            ],
            120139: [
                [
                    84
                ],
                256
            ],
            120140: [
                [
                    85
                ],
                256
            ],
            120141: [
                [
                    86
                ],
                256
            ],
            120142: [
                [
                    87
                ],
                256
            ],
            120143: [
                [
                    88
                ],
                256
            ],
            120144: [
                [
                    89
                ],
                256
            ],
            120146: [
                [
                    97
                ],
                256
            ],
            120147: [
                [
                    98
                ],
                256
            ],
            120148: [
                [
                    99
                ],
                256
            ],
            120149: [
                [
                    100
                ],
                256
            ],
            120150: [
                [
                    101
                ],
                256
            ],
            120151: [
                [
                    102
                ],
                256
            ],
            120152: [
                [
                    103
                ],
                256
            ],
            120153: [
                [
                    104
                ],
                256
            ],
            120154: [
                [
                    105
                ],
                256
            ],
            120155: [
                [
                    106
                ],
                256
            ],
            120156: [
                [
                    107
                ],
                256
            ],
            120157: [
                [
                    108
                ],
                256
            ],
            120158: [
                [
                    109
                ],
                256
            ],
            120159: [
                [
                    110
                ],
                256
            ],
            120160: [
                [
                    111
                ],
                256
            ],
            120161: [
                [
                    112
                ],
                256
            ],
            120162: [
                [
                    113
                ],
                256
            ],
            120163: [
                [
                    114
                ],
                256
            ],
            120164: [
                [
                    115
                ],
                256
            ],
            120165: [
                [
                    116
                ],
                256
            ],
            120166: [
                [
                    117
                ],
                256
            ],
            120167: [
                [
                    118
                ],
                256
            ],
            120168: [
                [
                    119
                ],
                256
            ],
            120169: [
                [
                    120
                ],
                256
            ],
            120170: [
                [
                    121
                ],
                256
            ],
            120171: [
                [
                    122
                ],
                256
            ],
            120172: [
                [
                    65
                ],
                256
            ],
            120173: [
                [
                    66
                ],
                256
            ],
            120174: [
                [
                    67
                ],
                256
            ],
            120175: [
                [
                    68
                ],
                256
            ],
            120176: [
                [
                    69
                ],
                256
            ],
            120177: [
                [
                    70
                ],
                256
            ],
            120178: [
                [
                    71
                ],
                256
            ],
            120179: [
                [
                    72
                ],
                256
            ],
            120180: [
                [
                    73
                ],
                256
            ],
            120181: [
                [
                    74
                ],
                256
            ],
            120182: [
                [
                    75
                ],
                256
            ],
            120183: [
                [
                    76
                ],
                256
            ],
            120184: [
                [
                    77
                ],
                256
            ],
            120185: [
                [
                    78
                ],
                256
            ],
            120186: [
                [
                    79
                ],
                256
            ],
            120187: [
                [
                    80
                ],
                256
            ],
            120188: [
                [
                    81
                ],
                256
            ],
            120189: [
                [
                    82
                ],
                256
            ],
            120190: [
                [
                    83
                ],
                256
            ],
            120191: [
                [
                    84
                ],
                256
            ],
            120192: [
                [
                    85
                ],
                256
            ],
            120193: [
                [
                    86
                ],
                256
            ],
            120194: [
                [
                    87
                ],
                256
            ],
            120195: [
                [
                    88
                ],
                256
            ],
            120196: [
                [
                    89
                ],
                256
            ],
            120197: [
                [
                    90
                ],
                256
            ],
            120198: [
                [
                    97
                ],
                256
            ],
            120199: [
                [
                    98
                ],
                256
            ],
            120200: [
                [
                    99
                ],
                256
            ],
            120201: [
                [
                    100
                ],
                256
            ],
            120202: [
                [
                    101
                ],
                256
            ],
            120203: [
                [
                    102
                ],
                256
            ],
            120204: [
                [
                    103
                ],
                256
            ],
            120205: [
                [
                    104
                ],
                256
            ],
            120206: [
                [
                    105
                ],
                256
            ],
            120207: [
                [
                    106
                ],
                256
            ],
            120208: [
                [
                    107
                ],
                256
            ],
            120209: [
                [
                    108
                ],
                256
            ],
            120210: [
                [
                    109
                ],
                256
            ],
            120211: [
                [
                    110
                ],
                256
            ],
            120212: [
                [
                    111
                ],
                256
            ],
            120213: [
                [
                    112
                ],
                256
            ],
            120214: [
                [
                    113
                ],
                256
            ],
            120215: [
                [
                    114
                ],
                256
            ],
            120216: [
                [
                    115
                ],
                256
            ],
            120217: [
                [
                    116
                ],
                256
            ],
            120218: [
                [
                    117
                ],
                256
            ],
            120219: [
                [
                    118
                ],
                256
            ],
            120220: [
                [
                    119
                ],
                256
            ],
            120221: [
                [
                    120
                ],
                256
            ],
            120222: [
                [
                    121
                ],
                256
            ],
            120223: [
                [
                    122
                ],
                256
            ],
            120224: [
                [
                    65
                ],
                256
            ],
            120225: [
                [
                    66
                ],
                256
            ],
            120226: [
                [
                    67
                ],
                256
            ],
            120227: [
                [
                    68
                ],
                256
            ],
            120228: [
                [
                    69
                ],
                256
            ],
            120229: [
                [
                    70
                ],
                256
            ],
            120230: [
                [
                    71
                ],
                256
            ],
            120231: [
                [
                    72
                ],
                256
            ],
            120232: [
                [
                    73
                ],
                256
            ],
            120233: [
                [
                    74
                ],
                256
            ],
            120234: [
                [
                    75
                ],
                256
            ],
            120235: [
                [
                    76
                ],
                256
            ],
            120236: [
                [
                    77
                ],
                256
            ],
            120237: [
                [
                    78
                ],
                256
            ],
            120238: [
                [
                    79
                ],
                256
            ],
            120239: [
                [
                    80
                ],
                256
            ],
            120240: [
                [
                    81
                ],
                256
            ],
            120241: [
                [
                    82
                ],
                256
            ],
            120242: [
                [
                    83
                ],
                256
            ],
            120243: [
                [
                    84
                ],
                256
            ],
            120244: [
                [
                    85
                ],
                256
            ],
            120245: [
                [
                    86
                ],
                256
            ],
            120246: [
                [
                    87
                ],
                256
            ],
            120247: [
                [
                    88
                ],
                256
            ],
            120248: [
                [
                    89
                ],
                256
            ],
            120249: [
                [
                    90
                ],
                256
            ],
            120250: [
                [
                    97
                ],
                256
            ],
            120251: [
                [
                    98
                ],
                256
            ],
            120252: [
                [
                    99
                ],
                256
            ],
            120253: [
                [
                    100
                ],
                256
            ],
            120254: [
                [
                    101
                ],
                256
            ],
            120255: [
                [
                    102
                ],
                256
            ],
            120256: [
                [
                    103
                ],
                256
            ],
            120257: [
                [
                    104
                ],
                256
            ],
            120258: [
                [
                    105
                ],
                256
            ],
            120259: [
                [
                    106
                ],
                256
            ],
            120260: [
                [
                    107
                ],
                256
            ],
            120261: [
                [
                    108
                ],
                256
            ],
            120262: [
                [
                    109
                ],
                256
            ],
            120263: [
                [
                    110
                ],
                256
            ],
            120264: [
                [
                    111
                ],
                256
            ],
            120265: [
                [
                    112
                ],
                256
            ],
            120266: [
                [
                    113
                ],
                256
            ],
            120267: [
                [
                    114
                ],
                256
            ],
            120268: [
                [
                    115
                ],
                256
            ],
            120269: [
                [
                    116
                ],
                256
            ],
            120270: [
                [
                    117
                ],
                256
            ],
            120271: [
                [
                    118
                ],
                256
            ],
            120272: [
                [
                    119
                ],
                256
            ],
            120273: [
                [
                    120
                ],
                256
            ],
            120274: [
                [
                    121
                ],
                256
            ],
            120275: [
                [
                    122
                ],
                256
            ],
            120276: [
                [
                    65
                ],
                256
            ],
            120277: [
                [
                    66
                ],
                256
            ],
            120278: [
                [
                    67
                ],
                256
            ],
            120279: [
                [
                    68
                ],
                256
            ],
            120280: [
                [
                    69
                ],
                256
            ],
            120281: [
                [
                    70
                ],
                256
            ],
            120282: [
                [
                    71
                ],
                256
            ],
            120283: [
                [
                    72
                ],
                256
            ],
            120284: [
                [
                    73
                ],
                256
            ],
            120285: [
                [
                    74
                ],
                256
            ],
            120286: [
                [
                    75
                ],
                256
            ],
            120287: [
                [
                    76
                ],
                256
            ],
            120288: [
                [
                    77
                ],
                256
            ],
            120289: [
                [
                    78
                ],
                256
            ],
            120290: [
                [
                    79
                ],
                256
            ],
            120291: [
                [
                    80
                ],
                256
            ],
            120292: [
                [
                    81
                ],
                256
            ],
            120293: [
                [
                    82
                ],
                256
            ],
            120294: [
                [
                    83
                ],
                256
            ],
            120295: [
                [
                    84
                ],
                256
            ],
            120296: [
                [
                    85
                ],
                256
            ],
            120297: [
                [
                    86
                ],
                256
            ],
            120298: [
                [
                    87
                ],
                256
            ],
            120299: [
                [
                    88
                ],
                256
            ],
            120300: [
                [
                    89
                ],
                256
            ],
            120301: [
                [
                    90
                ],
                256
            ],
            120302: [
                [
                    97
                ],
                256
            ],
            120303: [
                [
                    98
                ],
                256
            ],
            120304: [
                [
                    99
                ],
                256
            ],
            120305: [
                [
                    100
                ],
                256
            ],
            120306: [
                [
                    101
                ],
                256
            ],
            120307: [
                [
                    102
                ],
                256
            ],
            120308: [
                [
                    103
                ],
                256
            ],
            120309: [
                [
                    104
                ],
                256
            ],
            120310: [
                [
                    105
                ],
                256
            ],
            120311: [
                [
                    106
                ],
                256
            ],
            120312: [
                [
                    107
                ],
                256
            ],
            120313: [
                [
                    108
                ],
                256
            ],
            120314: [
                [
                    109
                ],
                256
            ],
            120315: [
                [
                    110
                ],
                256
            ],
            120316: [
                [
                    111
                ],
                256
            ],
            120317: [
                [
                    112
                ],
                256
            ],
            120318: [
                [
                    113
                ],
                256
            ],
            120319: [
                [
                    114
                ],
                256
            ]
        },
        54784: {
            120320: [
                [
                    115
                ],
                256
            ],
            120321: [
                [
                    116
                ],
                256
            ],
            120322: [
                [
                    117
                ],
                256
            ],
            120323: [
                [
                    118
                ],
                256
            ],
            120324: [
                [
                    119
                ],
                256
            ],
            120325: [
                [
                    120
                ],
                256
            ],
            120326: [
                [
                    121
                ],
                256
            ],
            120327: [
                [
                    122
                ],
                256
            ],
            120328: [
                [
                    65
                ],
                256
            ],
            120329: [
                [
                    66
                ],
                256
            ],
            120330: [
                [
                    67
                ],
                256
            ],
            120331: [
                [
                    68
                ],
                256
            ],
            120332: [
                [
                    69
                ],
                256
            ],
            120333: [
                [
                    70
                ],
                256
            ],
            120334: [
                [
                    71
                ],
                256
            ],
            120335: [
                [
                    72
                ],
                256
            ],
            120336: [
                [
                    73
                ],
                256
            ],
            120337: [
                [
                    74
                ],
                256
            ],
            120338: [
                [
                    75
                ],
                256
            ],
            120339: [
                [
                    76
                ],
                256
            ],
            120340: [
                [
                    77
                ],
                256
            ],
            120341: [
                [
                    78
                ],
                256
            ],
            120342: [
                [
                    79
                ],
                256
            ],
            120343: [
                [
                    80
                ],
                256
            ],
            120344: [
                [
                    81
                ],
                256
            ],
            120345: [
                [
                    82
                ],
                256
            ],
            120346: [
                [
                    83
                ],
                256
            ],
            120347: [
                [
                    84
                ],
                256
            ],
            120348: [
                [
                    85
                ],
                256
            ],
            120349: [
                [
                    86
                ],
                256
            ],
            120350: [
                [
                    87
                ],
                256
            ],
            120351: [
                [
                    88
                ],
                256
            ],
            120352: [
                [
                    89
                ],
                256
            ],
            120353: [
                [
                    90
                ],
                256
            ],
            120354: [
                [
                    97
                ],
                256
            ],
            120355: [
                [
                    98
                ],
                256
            ],
            120356: [
                [
                    99
                ],
                256
            ],
            120357: [
                [
                    100
                ],
                256
            ],
            120358: [
                [
                    101
                ],
                256
            ],
            120359: [
                [
                    102
                ],
                256
            ],
            120360: [
                [
                    103
                ],
                256
            ],
            120361: [
                [
                    104
                ],
                256
            ],
            120362: [
                [
                    105
                ],
                256
            ],
            120363: [
                [
                    106
                ],
                256
            ],
            120364: [
                [
                    107
                ],
                256
            ],
            120365: [
                [
                    108
                ],
                256
            ],
            120366: [
                [
                    109
                ],
                256
            ],
            120367: [
                [
                    110
                ],
                256
            ],
            120368: [
                [
                    111
                ],
                256
            ],
            120369: [
                [
                    112
                ],
                256
            ],
            120370: [
                [
                    113
                ],
                256
            ],
            120371: [
                [
                    114
                ],
                256
            ],
            120372: [
                [
                    115
                ],
                256
            ],
            120373: [
                [
                    116
                ],
                256
            ],
            120374: [
                [
                    117
                ],
                256
            ],
            120375: [
                [
                    118
                ],
                256
            ],
            120376: [
                [
                    119
                ],
                256
            ],
            120377: [
                [
                    120
                ],
                256
            ],
            120378: [
                [
                    121
                ],
                256
            ],
            120379: [
                [
                    122
                ],
                256
            ],
            120380: [
                [
                    65
                ],
                256
            ],
            120381: [
                [
                    66
                ],
                256
            ],
            120382: [
                [
                    67
                ],
                256
            ],
            120383: [
                [
                    68
                ],
                256
            ],
            120384: [
                [
                    69
                ],
                256
            ],
            120385: [
                [
                    70
                ],
                256
            ],
            120386: [
                [
                    71
                ],
                256
            ],
            120387: [
                [
                    72
                ],
                256
            ],
            120388: [
                [
                    73
                ],
                256
            ],
            120389: [
                [
                    74
                ],
                256
            ],
            120390: [
                [
                    75
                ],
                256
            ],
            120391: [
                [
                    76
                ],
                256
            ],
            120392: [
                [
                    77
                ],
                256
            ],
            120393: [
                [
                    78
                ],
                256
            ],
            120394: [
                [
                    79
                ],
                256
            ],
            120395: [
                [
                    80
                ],
                256
            ],
            120396: [
                [
                    81
                ],
                256
            ],
            120397: [
                [
                    82
                ],
                256
            ],
            120398: [
                [
                    83
                ],
                256
            ],
            120399: [
                [
                    84
                ],
                256
            ],
            120400: [
                [
                    85
                ],
                256
            ],
            120401: [
                [
                    86
                ],
                256
            ],
            120402: [
                [
                    87
                ],
                256
            ],
            120403: [
                [
                    88
                ],
                256
            ],
            120404: [
                [
                    89
                ],
                256
            ],
            120405: [
                [
                    90
                ],
                256
            ],
            120406: [
                [
                    97
                ],
                256
            ],
            120407: [
                [
                    98
                ],
                256
            ],
            120408: [
                [
                    99
                ],
                256
            ],
            120409: [
                [
                    100
                ],
                256
            ],
            120410: [
                [
                    101
                ],
                256
            ],
            120411: [
                [
                    102
                ],
                256
            ],
            120412: [
                [
                    103
                ],
                256
            ],
            120413: [
                [
                    104
                ],
                256
            ],
            120414: [
                [
                    105
                ],
                256
            ],
            120415: [
                [
                    106
                ],
                256
            ],
            120416: [
                [
                    107
                ],
                256
            ],
            120417: [
                [
                    108
                ],
                256
            ],
            120418: [
                [
                    109
                ],
                256
            ],
            120419: [
                [
                    110
                ],
                256
            ],
            120420: [
                [
                    111
                ],
                256
            ],
            120421: [
                [
                    112
                ],
                256
            ],
            120422: [
                [
                    113
                ],
                256
            ],
            120423: [
                [
                    114
                ],
                256
            ],
            120424: [
                [
                    115
                ],
                256
            ],
            120425: [
                [
                    116
                ],
                256
            ],
            120426: [
                [
                    117
                ],
                256
            ],
            120427: [
                [
                    118
                ],
                256
            ],
            120428: [
                [
                    119
                ],
                256
            ],
            120429: [
                [
                    120
                ],
                256
            ],
            120430: [
                [
                    121
                ],
                256
            ],
            120431: [
                [
                    122
                ],
                256
            ],
            120432: [
                [
                    65
                ],
                256
            ],
            120433: [
                [
                    66
                ],
                256
            ],
            120434: [
                [
                    67
                ],
                256
            ],
            120435: [
                [
                    68
                ],
                256
            ],
            120436: [
                [
                    69
                ],
                256
            ],
            120437: [
                [
                    70
                ],
                256
            ],
            120438: [
                [
                    71
                ],
                256
            ],
            120439: [
                [
                    72
                ],
                256
            ],
            120440: [
                [
                    73
                ],
                256
            ],
            120441: [
                [
                    74
                ],
                256
            ],
            120442: [
                [
                    75
                ],
                256
            ],
            120443: [
                [
                    76
                ],
                256
            ],
            120444: [
                [
                    77
                ],
                256
            ],
            120445: [
                [
                    78
                ],
                256
            ],
            120446: [
                [
                    79
                ],
                256
            ],
            120447: [
                [
                    80
                ],
                256
            ],
            120448: [
                [
                    81
                ],
                256
            ],
            120449: [
                [
                    82
                ],
                256
            ],
            120450: [
                [
                    83
                ],
                256
            ],
            120451: [
                [
                    84
                ],
                256
            ],
            120452: [
                [
                    85
                ],
                256
            ],
            120453: [
                [
                    86
                ],
                256
            ],
            120454: [
                [
                    87
                ],
                256
            ],
            120455: [
                [
                    88
                ],
                256
            ],
            120456: [
                [
                    89
                ],
                256
            ],
            120457: [
                [
                    90
                ],
                256
            ],
            120458: [
                [
                    97
                ],
                256
            ],
            120459: [
                [
                    98
                ],
                256
            ],
            120460: [
                [
                    99
                ],
                256
            ],
            120461: [
                [
                    100
                ],
                256
            ],
            120462: [
                [
                    101
                ],
                256
            ],
            120463: [
                [
                    102
                ],
                256
            ],
            120464: [
                [
                    103
                ],
                256
            ],
            120465: [
                [
                    104
                ],
                256
            ],
            120466: [
                [
                    105
                ],
                256
            ],
            120467: [
                [
                    106
                ],
                256
            ],
            120468: [
                [
                    107
                ],
                256
            ],
            120469: [
                [
                    108
                ],
                256
            ],
            120470: [
                [
                    109
                ],
                256
            ],
            120471: [
                [
                    110
                ],
                256
            ],
            120472: [
                [
                    111
                ],
                256
            ],
            120473: [
                [
                    112
                ],
                256
            ],
            120474: [
                [
                    113
                ],
                256
            ],
            120475: [
                [
                    114
                ],
                256
            ],
            120476: [
                [
                    115
                ],
                256
            ],
            120477: [
                [
                    116
                ],
                256
            ],
            120478: [
                [
                    117
                ],
                256
            ],
            120479: [
                [
                    118
                ],
                256
            ],
            120480: [
                [
                    119
                ],
                256
            ],
            120481: [
                [
                    120
                ],
                256
            ],
            120482: [
                [
                    121
                ],
                256
            ],
            120483: [
                [
                    122
                ],
                256
            ],
            120484: [
                [
                    305
                ],
                256
            ],
            120485: [
                [
                    567
                ],
                256
            ],
            120488: [
                [
                    913
                ],
                256
            ],
            120489: [
                [
                    914
                ],
                256
            ],
            120490: [
                [
                    915
                ],
                256
            ],
            120491: [
                [
                    916
                ],
                256
            ],
            120492: [
                [
                    917
                ],
                256
            ],
            120493: [
                [
                    918
                ],
                256
            ],
            120494: [
                [
                    919
                ],
                256
            ],
            120495: [
                [
                    920
                ],
                256
            ],
            120496: [
                [
                    921
                ],
                256
            ],
            120497: [
                [
                    922
                ],
                256
            ],
            120498: [
                [
                    923
                ],
                256
            ],
            120499: [
                [
                    924
                ],
                256
            ],
            120500: [
                [
                    925
                ],
                256
            ],
            120501: [
                [
                    926
                ],
                256
            ],
            120502: [
                [
                    927
                ],
                256
            ],
            120503: [
                [
                    928
                ],
                256
            ],
            120504: [
                [
                    929
                ],
                256
            ],
            120505: [
                [
                    1012
                ],
                256
            ],
            120506: [
                [
                    931
                ],
                256
            ],
            120507: [
                [
                    932
                ],
                256
            ],
            120508: [
                [
                    933
                ],
                256
            ],
            120509: [
                [
                    934
                ],
                256
            ],
            120510: [
                [
                    935
                ],
                256
            ],
            120511: [
                [
                    936
                ],
                256
            ],
            120512: [
                [
                    937
                ],
                256
            ],
            120513: [
                [
                    8711
                ],
                256
            ],
            120514: [
                [
                    945
                ],
                256
            ],
            120515: [
                [
                    946
                ],
                256
            ],
            120516: [
                [
                    947
                ],
                256
            ],
            120517: [
                [
                    948
                ],
                256
            ],
            120518: [
                [
                    949
                ],
                256
            ],
            120519: [
                [
                    950
                ],
                256
            ],
            120520: [
                [
                    951
                ],
                256
            ],
            120521: [
                [
                    952
                ],
                256
            ],
            120522: [
                [
                    953
                ],
                256
            ],
            120523: [
                [
                    954
                ],
                256
            ],
            120524: [
                [
                    955
                ],
                256
            ],
            120525: [
                [
                    956
                ],
                256
            ],
            120526: [
                [
                    957
                ],
                256
            ],
            120527: [
                [
                    958
                ],
                256
            ],
            120528: [
                [
                    959
                ],
                256
            ],
            120529: [
                [
                    960
                ],
                256
            ],
            120530: [
                [
                    961
                ],
                256
            ],
            120531: [
                [
                    962
                ],
                256
            ],
            120532: [
                [
                    963
                ],
                256
            ],
            120533: [
                [
                    964
                ],
                256
            ],
            120534: [
                [
                    965
                ],
                256
            ],
            120535: [
                [
                    966
                ],
                256
            ],
            120536: [
                [
                    967
                ],
                256
            ],
            120537: [
                [
                    968
                ],
                256
            ],
            120538: [
                [
                    969
                ],
                256
            ],
            120539: [
                [
                    8706
                ],
                256
            ],
            120540: [
                [
                    1013
                ],
                256
            ],
            120541: [
                [
                    977
                ],
                256
            ],
            120542: [
                [
                    1008
                ],
                256
            ],
            120543: [
                [
                    981
                ],
                256
            ],
            120544: [
                [
                    1009
                ],
                256
            ],
            120545: [
                [
                    982
                ],
                256
            ],
            120546: [
                [
                    913
                ],
                256
            ],
            120547: [
                [
                    914
                ],
                256
            ],
            120548: [
                [
                    915
                ],
                256
            ],
            120549: [
                [
                    916
                ],
                256
            ],
            120550: [
                [
                    917
                ],
                256
            ],
            120551: [
                [
                    918
                ],
                256
            ],
            120552: [
                [
                    919
                ],
                256
            ],
            120553: [
                [
                    920
                ],
                256
            ],
            120554: [
                [
                    921
                ],
                256
            ],
            120555: [
                [
                    922
                ],
                256
            ],
            120556: [
                [
                    923
                ],
                256
            ],
            120557: [
                [
                    924
                ],
                256
            ],
            120558: [
                [
                    925
                ],
                256
            ],
            120559: [
                [
                    926
                ],
                256
            ],
            120560: [
                [
                    927
                ],
                256
            ],
            120561: [
                [
                    928
                ],
                256
            ],
            120562: [
                [
                    929
                ],
                256
            ],
            120563: [
                [
                    1012
                ],
                256
            ],
            120564: [
                [
                    931
                ],
                256
            ],
            120565: [
                [
                    932
                ],
                256
            ],
            120566: [
                [
                    933
                ],
                256
            ],
            120567: [
                [
                    934
                ],
                256
            ],
            120568: [
                [
                    935
                ],
                256
            ],
            120569: [
                [
                    936
                ],
                256
            ],
            120570: [
                [
                    937
                ],
                256
            ],
            120571: [
                [
                    8711
                ],
                256
            ],
            120572: [
                [
                    945
                ],
                256
            ],
            120573: [
                [
                    946
                ],
                256
            ],
            120574: [
                [
                    947
                ],
                256
            ],
            120575: [
                [
                    948
                ],
                256
            ]
        },
        55040: {
            120576: [
                [
                    949
                ],
                256
            ],
            120577: [
                [
                    950
                ],
                256
            ],
            120578: [
                [
                    951
                ],
                256
            ],
            120579: [
                [
                    952
                ],
                256
            ],
            120580: [
                [
                    953
                ],
                256
            ],
            120581: [
                [
                    954
                ],
                256
            ],
            120582: [
                [
                    955
                ],
                256
            ],
            120583: [
                [
                    956
                ],
                256
            ],
            120584: [
                [
                    957
                ],
                256
            ],
            120585: [
                [
                    958
                ],
                256
            ],
            120586: [
                [
                    959
                ],
                256
            ],
            120587: [
                [
                    960
                ],
                256
            ],
            120588: [
                [
                    961
                ],
                256
            ],
            120589: [
                [
                    962
                ],
                256
            ],
            120590: [
                [
                    963
                ],
                256
            ],
            120591: [
                [
                    964
                ],
                256
            ],
            120592: [
                [
                    965
                ],
                256
            ],
            120593: [
                [
                    966
                ],
                256
            ],
            120594: [
                [
                    967
                ],
                256
            ],
            120595: [
                [
                    968
                ],
                256
            ],
            120596: [
                [
                    969
                ],
                256
            ],
            120597: [
                [
                    8706
                ],
                256
            ],
            120598: [
                [
                    1013
                ],
                256
            ],
            120599: [
                [
                    977
                ],
                256
            ],
            120600: [
                [
                    1008
                ],
                256
            ],
            120601: [
                [
                    981
                ],
                256
            ],
            120602: [
                [
                    1009
                ],
                256
            ],
            120603: [
                [
                    982
                ],
                256
            ],
            120604: [
                [
                    913
                ],
                256
            ],
            120605: [
                [
                    914
                ],
                256
            ],
            120606: [
                [
                    915
                ],
                256
            ],
            120607: [
                [
                    916
                ],
                256
            ],
            120608: [
                [
                    917
                ],
                256
            ],
            120609: [
                [
                    918
                ],
                256
            ],
            120610: [
                [
                    919
                ],
                256
            ],
            120611: [
                [
                    920
                ],
                256
            ],
            120612: [
                [
                    921
                ],
                256
            ],
            120613: [
                [
                    922
                ],
                256
            ],
            120614: [
                [
                    923
                ],
                256
            ],
            120615: [
                [
                    924
                ],
                256
            ],
            120616: [
                [
                    925
                ],
                256
            ],
            120617: [
                [
                    926
                ],
                256
            ],
            120618: [
                [
                    927
                ],
                256
            ],
            120619: [
                [
                    928
                ],
                256
            ],
            120620: [
                [
                    929
                ],
                256
            ],
            120621: [
                [
                    1012
                ],
                256
            ],
            120622: [
                [
                    931
                ],
                256
            ],
            120623: [
                [
                    932
                ],
                256
            ],
            120624: [
                [
                    933
                ],
                256
            ],
            120625: [
                [
                    934
                ],
                256
            ],
            120626: [
                [
                    935
                ],
                256
            ],
            120627: [
                [
                    936
                ],
                256
            ],
            120628: [
                [
                    937
                ],
                256
            ],
            120629: [
                [
                    8711
                ],
                256
            ],
            120630: [
                [
                    945
                ],
                256
            ],
            120631: [
                [
                    946
                ],
                256
            ],
            120632: [
                [
                    947
                ],
                256
            ],
            120633: [
                [
                    948
                ],
                256
            ],
            120634: [
                [
                    949
                ],
                256
            ],
            120635: [
                [
                    950
                ],
                256
            ],
            120636: [
                [
                    951
                ],
                256
            ],
            120637: [
                [
                    952
                ],
                256
            ],
            120638: [
                [
                    953
                ],
                256
            ],
            120639: [
                [
                    954
                ],
                256
            ],
            120640: [
                [
                    955
                ],
                256
            ],
            120641: [
                [
                    956
                ],
                256
            ],
            120642: [
                [
                    957
                ],
                256
            ],
            120643: [
                [
                    958
                ],
                256
            ],
            120644: [
                [
                    959
                ],
                256
            ],
            120645: [
                [
                    960
                ],
                256
            ],
            120646: [
                [
                    961
                ],
                256
            ],
            120647: [
                [
                    962
                ],
                256
            ],
            120648: [
                [
                    963
                ],
                256
            ],
            120649: [
                [
                    964
                ],
                256
            ],
            120650: [
                [
                    965
                ],
                256
            ],
            120651: [
                [
                    966
                ],
                256
            ],
            120652: [
                [
                    967
                ],
                256
            ],
            120653: [
                [
                    968
                ],
                256
            ],
            120654: [
                [
                    969
                ],
                256
            ],
            120655: [
                [
                    8706
                ],
                256
            ],
            120656: [
                [
                    1013
                ],
                256
            ],
            120657: [
                [
                    977
                ],
                256
            ],
            120658: [
                [
                    1008
                ],
                256
            ],
            120659: [
                [
                    981
                ],
                256
            ],
            120660: [
                [
                    1009
                ],
                256
            ],
            120661: [
                [
                    982
                ],
                256
            ],
            120662: [
                [
                    913
                ],
                256
            ],
            120663: [
                [
                    914
                ],
                256
            ],
            120664: [
                [
                    915
                ],
                256
            ],
            120665: [
                [
                    916
                ],
                256
            ],
            120666: [
                [
                    917
                ],
                256
            ],
            120667: [
                [
                    918
                ],
                256
            ],
            120668: [
                [
                    919
                ],
                256
            ],
            120669: [
                [
                    920
                ],
                256
            ],
            120670: [
                [
                    921
                ],
                256
            ],
            120671: [
                [
                    922
                ],
                256
            ],
            120672: [
                [
                    923
                ],
                256
            ],
            120673: [
                [
                    924
                ],
                256
            ],
            120674: [
                [
                    925
                ],
                256
            ],
            120675: [
                [
                    926
                ],
                256
            ],
            120676: [
                [
                    927
                ],
                256
            ],
            120677: [
                [
                    928
                ],
                256
            ],
            120678: [
                [
                    929
                ],
                256
            ],
            120679: [
                [
                    1012
                ],
                256
            ],
            120680: [
                [
                    931
                ],
                256
            ],
            120681: [
                [
                    932
                ],
                256
            ],
            120682: [
                [
                    933
                ],
                256
            ],
            120683: [
                [
                    934
                ],
                256
            ],
            120684: [
                [
                    935
                ],
                256
            ],
            120685: [
                [
                    936
                ],
                256
            ],
            120686: [
                [
                    937
                ],
                256
            ],
            120687: [
                [
                    8711
                ],
                256
            ],
            120688: [
                [
                    945
                ],
                256
            ],
            120689: [
                [
                    946
                ],
                256
            ],
            120690: [
                [
                    947
                ],
                256
            ],
            120691: [
                [
                    948
                ],
                256
            ],
            120692: [
                [
                    949
                ],
                256
            ],
            120693: [
                [
                    950
                ],
                256
            ],
            120694: [
                [
                    951
                ],
                256
            ],
            120695: [
                [
                    952
                ],
                256
            ],
            120696: [
                [
                    953
                ],
                256
            ],
            120697: [
                [
                    954
                ],
                256
            ],
            120698: [
                [
                    955
                ],
                256
            ],
            120699: [
                [
                    956
                ],
                256
            ],
            120700: [
                [
                    957
                ],
                256
            ],
            120701: [
                [
                    958
                ],
                256
            ],
            120702: [
                [
                    959
                ],
                256
            ],
            120703: [
                [
                    960
                ],
                256
            ],
            120704: [
                [
                    961
                ],
                256
            ],
            120705: [
                [
                    962
                ],
                256
            ],
            120706: [
                [
                    963
                ],
                256
            ],
            120707: [
                [
                    964
                ],
                256
            ],
            120708: [
                [
                    965
                ],
                256
            ],
            120709: [
                [
                    966
                ],
                256
            ],
            120710: [
                [
                    967
                ],
                256
            ],
            120711: [
                [
                    968
                ],
                256
            ],
            120712: [
                [
                    969
                ],
                256
            ],
            120713: [
                [
                    8706
                ],
                256
            ],
            120714: [
                [
                    1013
                ],
                256
            ],
            120715: [
                [
                    977
                ],
                256
            ],
            120716: [
                [
                    1008
                ],
                256
            ],
            120717: [
                [
                    981
                ],
                256
            ],
            120718: [
                [
                    1009
                ],
                256
            ],
            120719: [
                [
                    982
                ],
                256
            ],
            120720: [
                [
                    913
                ],
                256
            ],
            120721: [
                [
                    914
                ],
                256
            ],
            120722: [
                [
                    915
                ],
                256
            ],
            120723: [
                [
                    916
                ],
                256
            ],
            120724: [
                [
                    917
                ],
                256
            ],
            120725: [
                [
                    918
                ],
                256
            ],
            120726: [
                [
                    919
                ],
                256
            ],
            120727: [
                [
                    920
                ],
                256
            ],
            120728: [
                [
                    921
                ],
                256
            ],
            120729: [
                [
                    922
                ],
                256
            ],
            120730: [
                [
                    923
                ],
                256
            ],
            120731: [
                [
                    924
                ],
                256
            ],
            120732: [
                [
                    925
                ],
                256
            ],
            120733: [
                [
                    926
                ],
                256
            ],
            120734: [
                [
                    927
                ],
                256
            ],
            120735: [
                [
                    928
                ],
                256
            ],
            120736: [
                [
                    929
                ],
                256
            ],
            120737: [
                [
                    1012
                ],
                256
            ],
            120738: [
                [
                    931
                ],
                256
            ],
            120739: [
                [
                    932
                ],
                256
            ],
            120740: [
                [
                    933
                ],
                256
            ],
            120741: [
                [
                    934
                ],
                256
            ],
            120742: [
                [
                    935
                ],
                256
            ],
            120743: [
                [
                    936
                ],
                256
            ],
            120744: [
                [
                    937
                ],
                256
            ],
            120745: [
                [
                    8711
                ],
                256
            ],
            120746: [
                [
                    945
                ],
                256
            ],
            120747: [
                [
                    946
                ],
                256
            ],
            120748: [
                [
                    947
                ],
                256
            ],
            120749: [
                [
                    948
                ],
                256
            ],
            120750: [
                [
                    949
                ],
                256
            ],
            120751: [
                [
                    950
                ],
                256
            ],
            120752: [
                [
                    951
                ],
                256
            ],
            120753: [
                [
                    952
                ],
                256
            ],
            120754: [
                [
                    953
                ],
                256
            ],
            120755: [
                [
                    954
                ],
                256
            ],
            120756: [
                [
                    955
                ],
                256
            ],
            120757: [
                [
                    956
                ],
                256
            ],
            120758: [
                [
                    957
                ],
                256
            ],
            120759: [
                [
                    958
                ],
                256
            ],
            120760: [
                [
                    959
                ],
                256
            ],
            120761: [
                [
                    960
                ],
                256
            ],
            120762: [
                [
                    961
                ],
                256
            ],
            120763: [
                [
                    962
                ],
                256
            ],
            120764: [
                [
                    963
                ],
                256
            ],
            120765: [
                [
                    964
                ],
                256
            ],
            120766: [
                [
                    965
                ],
                256
            ],
            120767: [
                [
                    966
                ],
                256
            ],
            120768: [
                [
                    967
                ],
                256
            ],
            120769: [
                [
                    968
                ],
                256
            ],
            120770: [
                [
                    969
                ],
                256
            ],
            120771: [
                [
                    8706
                ],
                256
            ],
            120772: [
                [
                    1013
                ],
                256
            ],
            120773: [
                [
                    977
                ],
                256
            ],
            120774: [
                [
                    1008
                ],
                256
            ],
            120775: [
                [
                    981
                ],
                256
            ],
            120776: [
                [
                    1009
                ],
                256
            ],
            120777: [
                [
                    982
                ],
                256
            ],
            120778: [
                [
                    988
                ],
                256
            ],
            120779: [
                [
                    989
                ],
                256
            ],
            120782: [
                [
                    48
                ],
                256
            ],
            120783: [
                [
                    49
                ],
                256
            ],
            120784: [
                [
                    50
                ],
                256
            ],
            120785: [
                [
                    51
                ],
                256
            ],
            120786: [
                [
                    52
                ],
                256
            ],
            120787: [
                [
                    53
                ],
                256
            ],
            120788: [
                [
                    54
                ],
                256
            ],
            120789: [
                [
                    55
                ],
                256
            ],
            120790: [
                [
                    56
                ],
                256
            ],
            120791: [
                [
                    57
                ],
                256
            ],
            120792: [
                [
                    48
                ],
                256
            ],
            120793: [
                [
                    49
                ],
                256
            ],
            120794: [
                [
                    50
                ],
                256
            ],
            120795: [
                [
                    51
                ],
                256
            ],
            120796: [
                [
                    52
                ],
                256
            ],
            120797: [
                [
                    53
                ],
                256
            ],
            120798: [
                [
                    54
                ],
                256
            ],
            120799: [
                [
                    55
                ],
                256
            ],
            120800: [
                [
                    56
                ],
                256
            ],
            120801: [
                [
                    57
                ],
                256
            ],
            120802: [
                [
                    48
                ],
                256
            ],
            120803: [
                [
                    49
                ],
                256
            ],
            120804: [
                [
                    50
                ],
                256
            ],
            120805: [
                [
                    51
                ],
                256
            ],
            120806: [
                [
                    52
                ],
                256
            ],
            120807: [
                [
                    53
                ],
                256
            ],
            120808: [
                [
                    54
                ],
                256
            ],
            120809: [
                [
                    55
                ],
                256
            ],
            120810: [
                [
                    56
                ],
                256
            ],
            120811: [
                [
                    57
                ],
                256
            ],
            120812: [
                [
                    48
                ],
                256
            ],
            120813: [
                [
                    49
                ],
                256
            ],
            120814: [
                [
                    50
                ],
                256
            ],
            120815: [
                [
                    51
                ],
                256
            ],
            120816: [
                [
                    52
                ],
                256
            ],
            120817: [
                [
                    53
                ],
                256
            ],
            120818: [
                [
                    54
                ],
                256
            ],
            120819: [
                [
                    55
                ],
                256
            ],
            120820: [
                [
                    56
                ],
                256
            ],
            120821: [
                [
                    57
                ],
                256
            ],
            120822: [
                [
                    48
                ],
                256
            ],
            120823: [
                [
                    49
                ],
                256
            ],
            120824: [
                [
                    50
                ],
                256
            ],
            120825: [
                [
                    51
                ],
                256
            ],
            120826: [
                [
                    52
                ],
                256
            ],
            120827: [
                [
                    53
                ],
                256
            ],
            120828: [
                [
                    54
                ],
                256
            ],
            120829: [
                [
                    55
                ],
                256
            ],
            120830: [
                [
                    56
                ],
                256
            ],
            120831: [
                [
                    57
                ],
                256
            ]
        },
        59392: {
            125136: [
                ,
                220
            ],
            125137: [
                ,
                220
            ],
            125138: [
                ,
                220
            ],
            125139: [
                ,
                220
            ],
            125140: [
                ,
                220
            ],
            125141: [
                ,
                220
            ],
            125142: [
                ,
                220
            ]
        },
        60928: {
            126464: [
                [
                    1575
                ],
                256
            ],
            126465: [
                [
                    1576
                ],
                256
            ],
            126466: [
                [
                    1580
                ],
                256
            ],
            126467: [
                [
                    1583
                ],
                256
            ],
            126469: [
                [
                    1608
                ],
                256
            ],
            126470: [
                [
                    1586
                ],
                256
            ],
            126471: [
                [
                    1581
                ],
                256
            ],
            126472: [
                [
                    1591
                ],
                256
            ],
            126473: [
                [
                    1610
                ],
                256
            ],
            126474: [
                [
                    1603
                ],
                256
            ],
            126475: [
                [
                    1604
                ],
                256
            ],
            126476: [
                [
                    1605
                ],
                256
            ],
            126477: [
                [
                    1606
                ],
                256
            ],
            126478: [
                [
                    1587
                ],
                256
            ],
            126479: [
                [
                    1593
                ],
                256
            ],
            126480: [
                [
                    1601
                ],
                256
            ],
            126481: [
                [
                    1589
                ],
                256
            ],
            126482: [
                [
                    1602
                ],
                256
            ],
            126483: [
                [
                    1585
                ],
                256
            ],
            126484: [
                [
                    1588
                ],
                256
            ],
            126485: [
                [
                    1578
                ],
                256
            ],
            126486: [
                [
                    1579
                ],
                256
            ],
            126487: [
                [
                    1582
                ],
                256
            ],
            126488: [
                [
                    1584
                ],
                256
            ],
            126489: [
                [
                    1590
                ],
                256
            ],
            126490: [
                [
                    1592
                ],
                256
            ],
            126491: [
                [
                    1594
                ],
                256
            ],
            126492: [
                [
                    1646
                ],
                256
            ],
            126493: [
                [
                    1722
                ],
                256
            ],
            126494: [
                [
                    1697
                ],
                256
            ],
            126495: [
                [
                    1647
                ],
                256
            ],
            126497: [
                [
                    1576
                ],
                256
            ],
            126498: [
                [
                    1580
                ],
                256
            ],
            126500: [
                [
                    1607
                ],
                256
            ],
            126503: [
                [
                    1581
                ],
                256
            ],
            126505: [
                [
                    1610
                ],
                256
            ],
            126506: [
                [
                    1603
                ],
                256
            ],
            126507: [
                [
                    1604
                ],
                256
            ],
            126508: [
                [
                    1605
                ],
                256
            ],
            126509: [
                [
                    1606
                ],
                256
            ],
            126510: [
                [
                    1587
                ],
                256
            ],
            126511: [
                [
                    1593
                ],
                256
            ],
            126512: [
                [
                    1601
                ],
                256
            ],
            126513: [
                [
                    1589
                ],
                256
            ],
            126514: [
                [
                    1602
                ],
                256
            ],
            126516: [
                [
                    1588
                ],
                256
            ],
            126517: [
                [
                    1578
                ],
                256
            ],
            126518: [
                [
                    1579
                ],
                256
            ],
            126519: [
                [
                    1582
                ],
                256
            ],
            126521: [
                [
                    1590
                ],
                256
            ],
            126523: [
                [
                    1594
                ],
                256
            ],
            126530: [
                [
                    1580
                ],
                256
            ],
            126535: [
                [
                    1581
                ],
                256
            ],
            126537: [
                [
                    1610
                ],
                256
            ],
            126539: [
                [
                    1604
                ],
                256
            ],
            126541: [
                [
                    1606
                ],
                256
            ],
            126542: [
                [
                    1587
                ],
                256
            ],
            126543: [
                [
                    1593
                ],
                256
            ],
            126545: [
                [
                    1589
                ],
                256
            ],
            126546: [
                [
                    1602
                ],
                256
            ],
            126548: [
                [
                    1588
                ],
                256
            ],
            126551: [
                [
                    1582
                ],
                256
            ],
            126553: [
                [
                    1590
                ],
                256
            ],
            126555: [
                [
                    1594
                ],
                256
            ],
            126557: [
                [
                    1722
                ],
                256
            ],
            126559: [
                [
                    1647
                ],
                256
            ],
            126561: [
                [
                    1576
                ],
                256
            ],
            126562: [
                [
                    1580
                ],
                256
            ],
            126564: [
                [
                    1607
                ],
                256
            ],
            126567: [
                [
                    1581
                ],
                256
            ],
            126568: [
                [
                    1591
                ],
                256
            ],
            126569: [
                [
                    1610
                ],
                256
            ],
            126570: [
                [
                    1603
                ],
                256
            ],
            126572: [
                [
                    1605
                ],
                256
            ],
            126573: [
                [
                    1606
                ],
                256
            ],
            126574: [
                [
                    1587
                ],
                256
            ],
            126575: [
                [
                    1593
                ],
                256
            ],
            126576: [
                [
                    1601
                ],
                256
            ],
            126577: [
                [
                    1589
                ],
                256
            ],
            126578: [
                [
                    1602
                ],
                256
            ],
            126580: [
                [
                    1588
                ],
                256
            ],
            126581: [
                [
                    1578
                ],
                256
            ],
            126582: [
                [
                    1579
                ],
                256
            ],
            126583: [
                [
                    1582
                ],
                256
            ],
            126585: [
                [
                    1590
                ],
                256
            ],
            126586: [
                [
                    1592
                ],
                256
            ],
            126587: [
                [
                    1594
                ],
                256
            ],
            126588: [
                [
                    1646
                ],
                256
            ],
            126590: [
                [
                    1697
                ],
                256
            ],
            126592: [
                [
                    1575
                ],
                256
            ],
            126593: [
                [
                    1576
                ],
                256
            ],
            126594: [
                [
                    1580
                ],
                256
            ],
            126595: [
                [
                    1583
                ],
                256
            ],
            126596: [
                [
                    1607
                ],
                256
            ],
            126597: [
                [
                    1608
                ],
                256
            ],
            126598: [
                [
                    1586
                ],
                256
            ],
            126599: [
                [
                    1581
                ],
                256
            ],
            126600: [
                [
                    1591
                ],
                256
            ],
            126601: [
                [
                    1610
                ],
                256
            ],
            126603: [
                [
                    1604
                ],
                256
            ],
            126604: [
                [
                    1605
                ],
                256
            ],
            126605: [
                [
                    1606
                ],
                256
            ],
            126606: [
                [
                    1587
                ],
                256
            ],
            126607: [
                [
                    1593
                ],
                256
            ],
            126608: [
                [
                    1601
                ],
                256
            ],
            126609: [
                [
                    1589
                ],
                256
            ],
            126610: [
                [
                    1602
                ],
                256
            ],
            126611: [
                [
                    1585
                ],
                256
            ],
            126612: [
                [
                    1588
                ],
                256
            ],
            126613: [
                [
                    1578
                ],
                256
            ],
            126614: [
                [
                    1579
                ],
                256
            ],
            126615: [
                [
                    1582
                ],
                256
            ],
            126616: [
                [
                    1584
                ],
                256
            ],
            126617: [
                [
                    1590
                ],
                256
            ],
            126618: [
                [
                    1592
                ],
                256
            ],
            126619: [
                [
                    1594
                ],
                256
            ],
            126625: [
                [
                    1576
                ],
                256
            ],
            126626: [
                [
                    1580
                ],
                256
            ],
            126627: [
                [
                    1583
                ],
                256
            ],
            126629: [
                [
                    1608
                ],
                256
            ],
            126630: [
                [
                    1586
                ],
                256
            ],
            126631: [
                [
                    1581
                ],
                256
            ],
            126632: [
                [
                    1591
                ],
                256
            ],
            126633: [
                [
                    1610
                ],
                256
            ],
            126635: [
                [
                    1604
                ],
                256
            ],
            126636: [
                [
                    1605
                ],
                256
            ],
            126637: [
                [
                    1606
                ],
                256
            ],
            126638: [
                [
                    1587
                ],
                256
            ],
            126639: [
                [
                    1593
                ],
                256
            ],
            126640: [
                [
                    1601
                ],
                256
            ],
            126641: [
                [
                    1589
                ],
                256
            ],
            126642: [
                [
                    1602
                ],
                256
            ],
            126643: [
                [
                    1585
                ],
                256
            ],
            126644: [
                [
                    1588
                ],
                256
            ],
            126645: [
                [
                    1578
                ],
                256
            ],
            126646: [
                [
                    1579
                ],
                256
            ],
            126647: [
                [
                    1582
                ],
                256
            ],
            126648: [
                [
                    1584
                ],
                256
            ],
            126649: [
                [
                    1590
                ],
                256
            ],
            126650: [
                [
                    1592
                ],
                256
            ],
            126651: [
                [
                    1594
                ],
                256
            ]
        },
        61696: {
            127232: [
                [
                    48,
                    46
                ],
                256
            ],
            127233: [
                [
                    48,
                    44
                ],
                256
            ],
            127234: [
                [
                    49,
                    44
                ],
                256
            ],
            127235: [
                [
                    50,
                    44
                ],
                256
            ],
            127236: [
                [
                    51,
                    44
                ],
                256
            ],
            127237: [
                [
                    52,
                    44
                ],
                256
            ],
            127238: [
                [
                    53,
                    44
                ],
                256
            ],
            127239: [
                [
                    54,
                    44
                ],
                256
            ],
            127240: [
                [
                    55,
                    44
                ],
                256
            ],
            127241: [
                [
                    56,
                    44
                ],
                256
            ],
            127242: [
                [
                    57,
                    44
                ],
                256
            ],
            127248: [
                [
                    40,
                    65,
                    41
                ],
                256
            ],
            127249: [
                [
                    40,
                    66,
                    41
                ],
                256
            ],
            127250: [
                [
                    40,
                    67,
                    41
                ],
                256
            ],
            127251: [
                [
                    40,
                    68,
                    41
                ],
                256
            ],
            127252: [
                [
                    40,
                    69,
                    41
                ],
                256
            ],
            127253: [
                [
                    40,
                    70,
                    41
                ],
                256
            ],
            127254: [
                [
                    40,
                    71,
                    41
                ],
                256
            ],
            127255: [
                [
                    40,
                    72,
                    41
                ],
                256
            ],
            127256: [
                [
                    40,
                    73,
                    41
                ],
                256
            ],
            127257: [
                [
                    40,
                    74,
                    41
                ],
                256
            ],
            127258: [
                [
                    40,
                    75,
                    41
                ],
                256
            ],
            127259: [
                [
                    40,
                    76,
                    41
                ],
                256
            ],
            127260: [
                [
                    40,
                    77,
                    41
                ],
                256
            ],
            127261: [
                [
                    40,
                    78,
                    41
                ],
                256
            ],
            127262: [
                [
                    40,
                    79,
                    41
                ],
                256
            ],
            127263: [
                [
                    40,
                    80,
                    41
                ],
                256
            ],
            127264: [
                [
                    40,
                    81,
                    41
                ],
                256
            ],
            127265: [
                [
                    40,
                    82,
                    41
                ],
                256
            ],
            127266: [
                [
                    40,
                    83,
                    41
                ],
                256
            ],
            127267: [
                [
                    40,
                    84,
                    41
                ],
                256
            ],
            127268: [
                [
                    40,
                    85,
                    41
                ],
                256
            ],
            127269: [
                [
                    40,
                    86,
                    41
                ],
                256
            ],
            127270: [
                [
                    40,
                    87,
                    41
                ],
                256
            ],
            127271: [
                [
                    40,
                    88,
                    41
                ],
                256
            ],
            127272: [
                [
                    40,
                    89,
                    41
                ],
                256
            ],
            127273: [
                [
                    40,
                    90,
                    41
                ],
                256
            ],
            127274: [
                [
                    12308,
                    83,
                    12309
                ],
                256
            ],
            127275: [
                [
                    67
                ],
                256
            ],
            127276: [
                [
                    82
                ],
                256
            ],
            127277: [
                [
                    67,
                    68
                ],
                256
            ],
            127278: [
                [
                    87,
                    90
                ],
                256
            ],
            127280: [
                [
                    65
                ],
                256
            ],
            127281: [
                [
                    66
                ],
                256
            ],
            127282: [
                [
                    67
                ],
                256
            ],
            127283: [
                [
                    68
                ],
                256
            ],
            127284: [
                [
                    69
                ],
                256
            ],
            127285: [
                [
                    70
                ],
                256
            ],
            127286: [
                [
                    71
                ],
                256
            ],
            127287: [
                [
                    72
                ],
                256
            ],
            127288: [
                [
                    73
                ],
                256
            ],
            127289: [
                [
                    74
                ],
                256
            ],
            127290: [
                [
                    75
                ],
                256
            ],
            127291: [
                [
                    76
                ],
                256
            ],
            127292: [
                [
                    77
                ],
                256
            ],
            127293: [
                [
                    78
                ],
                256
            ],
            127294: [
                [
                    79
                ],
                256
            ],
            127295: [
                [
                    80
                ],
                256
            ],
            127296: [
                [
                    81
                ],
                256
            ],
            127297: [
                [
                    82
                ],
                256
            ],
            127298: [
                [
                    83
                ],
                256
            ],
            127299: [
                [
                    84
                ],
                256
            ],
            127300: [
                [
                    85
                ],
                256
            ],
            127301: [
                [
                    86
                ],
                256
            ],
            127302: [
                [
                    87
                ],
                256
            ],
            127303: [
                [
                    88
                ],
                256
            ],
            127304: [
                [
                    89
                ],
                256
            ],
            127305: [
                [
                    90
                ],
                256
            ],
            127306: [
                [
                    72,
                    86
                ],
                256
            ],
            127307: [
                [
                    77,
                    86
                ],
                256
            ],
            127308: [
                [
                    83,
                    68
                ],
                256
            ],
            127309: [
                [
                    83,
                    83
                ],
                256
            ],
            127310: [
                [
                    80,
                    80,
                    86
                ],
                256
            ],
            127311: [
                [
                    87,
                    67
                ],
                256
            ],
            127338: [
                [
                    77,
                    67
                ],
                256
            ],
            127339: [
                [
                    77,
                    68
                ],
                256
            ],
            127376: [
                [
                    68,
                    74
                ],
                256
            ]
        },
        61952: {
            127488: [
                [
                    12411,
                    12363
                ],
                256
            ],
            127489: [
                [
                    12467,
                    12467
                ],
                256
            ],
            127490: [
                [
                    12469
                ],
                256
            ],
            127504: [
                [
                    25163
                ],
                256
            ],
            127505: [
                [
                    23383
                ],
                256
            ],
            127506: [
                [
                    21452
                ],
                256
            ],
            127507: [
                [
                    12487
                ],
                256
            ],
            127508: [
                [
                    20108
                ],
                256
            ],
            127509: [
                [
                    22810
                ],
                256
            ],
            127510: [
                [
                    35299
                ],
                256
            ],
            127511: [
                [
                    22825
                ],
                256
            ],
            127512: [
                [
                    20132
                ],
                256
            ],
            127513: [
                [
                    26144
                ],
                256
            ],
            127514: [
                [
                    28961
                ],
                256
            ],
            127515: [
                [
                    26009
                ],
                256
            ],
            127516: [
                [
                    21069
                ],
                256
            ],
            127517: [
                [
                    24460
                ],
                256
            ],
            127518: [
                [
                    20877
                ],
                256
            ],
            127519: [
                [
                    26032
                ],
                256
            ],
            127520: [
                [
                    21021
                ],
                256
            ],
            127521: [
                [
                    32066
                ],
                256
            ],
            127522: [
                [
                    29983
                ],
                256
            ],
            127523: [
                [
                    36009
                ],
                256
            ],
            127524: [
                [
                    22768
                ],
                256
            ],
            127525: [
                [
                    21561
                ],
                256
            ],
            127526: [
                [
                    28436
                ],
                256
            ],
            127527: [
                [
                    25237
                ],
                256
            ],
            127528: [
                [
                    25429
                ],
                256
            ],
            127529: [
                [
                    19968
                ],
                256
            ],
            127530: [
                [
                    19977
                ],
                256
            ],
            127531: [
                [
                    36938
                ],
                256
            ],
            127532: [
                [
                    24038
                ],
                256
            ],
            127533: [
                [
                    20013
                ],
                256
            ],
            127534: [
                [
                    21491
                ],
                256
            ],
            127535: [
                [
                    25351
                ],
                256
            ],
            127536: [
                [
                    36208
                ],
                256
            ],
            127537: [
                [
                    25171
                ],
                256
            ],
            127538: [
                [
                    31105
                ],
                256
            ],
            127539: [
                [
                    31354
                ],
                256
            ],
            127540: [
                [
                    21512
                ],
                256
            ],
            127541: [
                [
                    28288
                ],
                256
            ],
            127542: [
                [
                    26377
                ],
                256
            ],
            127543: [
                [
                    26376
                ],
                256
            ],
            127544: [
                [
                    30003
                ],
                256
            ],
            127545: [
                [
                    21106
                ],
                256
            ],
            127546: [
                [
                    21942
                ],
                256
            ],
            127552: [
                [
                    12308,
                    26412,
                    12309
                ],
                256
            ],
            127553: [
                [
                    12308,
                    19977,
                    12309
                ],
                256
            ],
            127554: [
                [
                    12308,
                    20108,
                    12309
                ],
                256
            ],
            127555: [
                [
                    12308,
                    23433,
                    12309
                ],
                256
            ],
            127556: [
                [
                    12308,
                    28857,
                    12309
                ],
                256
            ],
            127557: [
                [
                    12308,
                    25171,
                    12309
                ],
                256
            ],
            127558: [
                [
                    12308,
                    30423,
                    12309
                ],
                256
            ],
            127559: [
                [
                    12308,
                    21213,
                    12309
                ],
                256
            ],
            127560: [
                [
                    12308,
                    25943,
                    12309
                ],
                256
            ],
            127568: [
                [
                    24471
                ],
                256
            ],
            127569: [
                [
                    21487
                ],
                256
            ]
        },
        63488: {
            194560: [
                [
                    20029
                ]
            ],
            194561: [
                [
                    20024
                ]
            ],
            194562: [
                [
                    20033
                ]
            ],
            194563: [
                [
                    131362
                ]
            ],
            194564: [
                [
                    20320
                ]
            ],
            194565: [
                [
                    20398
                ]
            ],
            194566: [
                [
                    20411
                ]
            ],
            194567: [
                [
                    20482
                ]
            ],
            194568: [
                [
                    20602
                ]
            ],
            194569: [
                [
                    20633
                ]
            ],
            194570: [
                [
                    20711
                ]
            ],
            194571: [
                [
                    20687
                ]
            ],
            194572: [
                [
                    13470
                ]
            ],
            194573: [
                [
                    132666
                ]
            ],
            194574: [
                [
                    20813
                ]
            ],
            194575: [
                [
                    20820
                ]
            ],
            194576: [
                [
                    20836
                ]
            ],
            194577: [
                [
                    20855
                ]
            ],
            194578: [
                [
                    132380
                ]
            ],
            194579: [
                [
                    13497
                ]
            ],
            194580: [
                [
                    20839
                ]
            ],
            194581: [
                [
                    20877
                ]
            ],
            194582: [
                [
                    132427
                ]
            ],
            194583: [
                [
                    20887
                ]
            ],
            194584: [
                [
                    20900
                ]
            ],
            194585: [
                [
                    20172
                ]
            ],
            194586: [
                [
                    20908
                ]
            ],
            194587: [
                [
                    20917
                ]
            ],
            194588: [
                [
                    168415
                ]
            ],
            194589: [
                [
                    20981
                ]
            ],
            194590: [
                [
                    20995
                ]
            ],
            194591: [
                [
                    13535
                ]
            ],
            194592: [
                [
                    21051
                ]
            ],
            194593: [
                [
                    21062
                ]
            ],
            194594: [
                [
                    21106
                ]
            ],
            194595: [
                [
                    21111
                ]
            ],
            194596: [
                [
                    13589
                ]
            ],
            194597: [
                [
                    21191
                ]
            ],
            194598: [
                [
                    21193
                ]
            ],
            194599: [
                [
                    21220
                ]
            ],
            194600: [
                [
                    21242
                ]
            ],
            194601: [
                [
                    21253
                ]
            ],
            194602: [
                [
                    21254
                ]
            ],
            194603: [
                [
                    21271
                ]
            ],
            194604: [
                [
                    21321
                ]
            ],
            194605: [
                [
                    21329
                ]
            ],
            194606: [
                [
                    21338
                ]
            ],
            194607: [
                [
                    21363
                ]
            ],
            194608: [
                [
                    21373
                ]
            ],
            194609: [
                [
                    21375
                ]
            ],
            194610: [
                [
                    21375
                ]
            ],
            194611: [
                [
                    21375
                ]
            ],
            194612: [
                [
                    133676
                ]
            ],
            194613: [
                [
                    28784
                ]
            ],
            194614: [
                [
                    21450
                ]
            ],
            194615: [
                [
                    21471
                ]
            ],
            194616: [
                [
                    133987
                ]
            ],
            194617: [
                [
                    21483
                ]
            ],
            194618: [
                [
                    21489
                ]
            ],
            194619: [
                [
                    21510
                ]
            ],
            194620: [
                [
                    21662
                ]
            ],
            194621: [
                [
                    21560
                ]
            ],
            194622: [
                [
                    21576
                ]
            ],
            194623: [
                [
                    21608
                ]
            ],
            194624: [
                [
                    21666
                ]
            ],
            194625: [
                [
                    21750
                ]
            ],
            194626: [
                [
                    21776
                ]
            ],
            194627: [
                [
                    21843
                ]
            ],
            194628: [
                [
                    21859
                ]
            ],
            194629: [
                [
                    21892
                ]
            ],
            194630: [
                [
                    21892
                ]
            ],
            194631: [
                [
                    21913
                ]
            ],
            194632: [
                [
                    21931
                ]
            ],
            194633: [
                [
                    21939
                ]
            ],
            194634: [
                [
                    21954
                ]
            ],
            194635: [
                [
                    22294
                ]
            ],
            194636: [
                [
                    22022
                ]
            ],
            194637: [
                [
                    22295
                ]
            ],
            194638: [
                [
                    22097
                ]
            ],
            194639: [
                [
                    22132
                ]
            ],
            194640: [
                [
                    20999
                ]
            ],
            194641: [
                [
                    22766
                ]
            ],
            194642: [
                [
                    22478
                ]
            ],
            194643: [
                [
                    22516
                ]
            ],
            194644: [
                [
                    22541
                ]
            ],
            194645: [
                [
                    22411
                ]
            ],
            194646: [
                [
                    22578
                ]
            ],
            194647: [
                [
                    22577
                ]
            ],
            194648: [
                [
                    22700
                ]
            ],
            194649: [
                [
                    136420
                ]
            ],
            194650: [
                [
                    22770
                ]
            ],
            194651: [
                [
                    22775
                ]
            ],
            194652: [
                [
                    22790
                ]
            ],
            194653: [
                [
                    22810
                ]
            ],
            194654: [
                [
                    22818
                ]
            ],
            194655: [
                [
                    22882
                ]
            ],
            194656: [
                [
                    136872
                ]
            ],
            194657: [
                [
                    136938
                ]
            ],
            194658: [
                [
                    23020
                ]
            ],
            194659: [
                [
                    23067
                ]
            ],
            194660: [
                [
                    23079
                ]
            ],
            194661: [
                [
                    23000
                ]
            ],
            194662: [
                [
                    23142
                ]
            ],
            194663: [
                [
                    14062
                ]
            ],
            194664: [
                [
                    14076
                ]
            ],
            194665: [
                [
                    23304
                ]
            ],
            194666: [
                [
                    23358
                ]
            ],
            194667: [
                [
                    23358
                ]
            ],
            194668: [
                [
                    137672
                ]
            ],
            194669: [
                [
                    23491
                ]
            ],
            194670: [
                [
                    23512
                ]
            ],
            194671: [
                [
                    23527
                ]
            ],
            194672: [
                [
                    23539
                ]
            ],
            194673: [
                [
                    138008
                ]
            ],
            194674: [
                [
                    23551
                ]
            ],
            194675: [
                [
                    23558
                ]
            ],
            194676: [
                [
                    24403
                ]
            ],
            194677: [
                [
                    23586
                ]
            ],
            194678: [
                [
                    14209
                ]
            ],
            194679: [
                [
                    23648
                ]
            ],
            194680: [
                [
                    23662
                ]
            ],
            194681: [
                [
                    23744
                ]
            ],
            194682: [
                [
                    23693
                ]
            ],
            194683: [
                [
                    138724
                ]
            ],
            194684: [
                [
                    23875
                ]
            ],
            194685: [
                [
                    138726
                ]
            ],
            194686: [
                [
                    23918
                ]
            ],
            194687: [
                [
                    23915
                ]
            ],
            194688: [
                [
                    23932
                ]
            ],
            194689: [
                [
                    24033
                ]
            ],
            194690: [
                [
                    24034
                ]
            ],
            194691: [
                [
                    14383
                ]
            ],
            194692: [
                [
                    24061
                ]
            ],
            194693: [
                [
                    24104
                ]
            ],
            194694: [
                [
                    24125
                ]
            ],
            194695: [
                [
                    24169
                ]
            ],
            194696: [
                [
                    14434
                ]
            ],
            194697: [
                [
                    139651
                ]
            ],
            194698: [
                [
                    14460
                ]
            ],
            194699: [
                [
                    24240
                ]
            ],
            194700: [
                [
                    24243
                ]
            ],
            194701: [
                [
                    24246
                ]
            ],
            194702: [
                [
                    24266
                ]
            ],
            194703: [
                [
                    172946
                ]
            ],
            194704: [
                [
                    24318
                ]
            ],
            194705: [
                [
                    140081
                ]
            ],
            194706: [
                [
                    140081
                ]
            ],
            194707: [
                [
                    33281
                ]
            ],
            194708: [
                [
                    24354
                ]
            ],
            194709: [
                [
                    24354
                ]
            ],
            194710: [
                [
                    14535
                ]
            ],
            194711: [
                [
                    144056
                ]
            ],
            194712: [
                [
                    156122
                ]
            ],
            194713: [
                [
                    24418
                ]
            ],
            194714: [
                [
                    24427
                ]
            ],
            194715: [
                [
                    14563
                ]
            ],
            194716: [
                [
                    24474
                ]
            ],
            194717: [
                [
                    24525
                ]
            ],
            194718: [
                [
                    24535
                ]
            ],
            194719: [
                [
                    24569
                ]
            ],
            194720: [
                [
                    24705
                ]
            ],
            194721: [
                [
                    14650
                ]
            ],
            194722: [
                [
                    14620
                ]
            ],
            194723: [
                [
                    24724
                ]
            ],
            194724: [
                [
                    141012
                ]
            ],
            194725: [
                [
                    24775
                ]
            ],
            194726: [
                [
                    24904
                ]
            ],
            194727: [
                [
                    24908
                ]
            ],
            194728: [
                [
                    24910
                ]
            ],
            194729: [
                [
                    24908
                ]
            ],
            194730: [
                [
                    24954
                ]
            ],
            194731: [
                [
                    24974
                ]
            ],
            194732: [
                [
                    25010
                ]
            ],
            194733: [
                [
                    24996
                ]
            ],
            194734: [
                [
                    25007
                ]
            ],
            194735: [
                [
                    25054
                ]
            ],
            194736: [
                [
                    25074
                ]
            ],
            194737: [
                [
                    25078
                ]
            ],
            194738: [
                [
                    25104
                ]
            ],
            194739: [
                [
                    25115
                ]
            ],
            194740: [
                [
                    25181
                ]
            ],
            194741: [
                [
                    25265
                ]
            ],
            194742: [
                [
                    25300
                ]
            ],
            194743: [
                [
                    25424
                ]
            ],
            194744: [
                [
                    142092
                ]
            ],
            194745: [
                [
                    25405
                ]
            ],
            194746: [
                [
                    25340
                ]
            ],
            194747: [
                [
                    25448
                ]
            ],
            194748: [
                [
                    25475
                ]
            ],
            194749: [
                [
                    25572
                ]
            ],
            194750: [
                [
                    142321
                ]
            ],
            194751: [
                [
                    25634
                ]
            ],
            194752: [
                [
                    25541
                ]
            ],
            194753: [
                [
                    25513
                ]
            ],
            194754: [
                [
                    14894
                ]
            ],
            194755: [
                [
                    25705
                ]
            ],
            194756: [
                [
                    25726
                ]
            ],
            194757: [
                [
                    25757
                ]
            ],
            194758: [
                [
                    25719
                ]
            ],
            194759: [
                [
                    14956
                ]
            ],
            194760: [
                [
                    25935
                ]
            ],
            194761: [
                [
                    25964
                ]
            ],
            194762: [
                [
                    143370
                ]
            ],
            194763: [
                [
                    26083
                ]
            ],
            194764: [
                [
                    26360
                ]
            ],
            194765: [
                [
                    26185
                ]
            ],
            194766: [
                [
                    15129
                ]
            ],
            194767: [
                [
                    26257
                ]
            ],
            194768: [
                [
                    15112
                ]
            ],
            194769: [
                [
                    15076
                ]
            ],
            194770: [
                [
                    20882
                ]
            ],
            194771: [
                [
                    20885
                ]
            ],
            194772: [
                [
                    26368
                ]
            ],
            194773: [
                [
                    26268
                ]
            ],
            194774: [
                [
                    32941
                ]
            ],
            194775: [
                [
                    17369
                ]
            ],
            194776: [
                [
                    26391
                ]
            ],
            194777: [
                [
                    26395
                ]
            ],
            194778: [
                [
                    26401
                ]
            ],
            194779: [
                [
                    26462
                ]
            ],
            194780: [
                [
                    26451
                ]
            ],
            194781: [
                [
                    144323
                ]
            ],
            194782: [
                [
                    15177
                ]
            ],
            194783: [
                [
                    26618
                ]
            ],
            194784: [
                [
                    26501
                ]
            ],
            194785: [
                [
                    26706
                ]
            ],
            194786: [
                [
                    26757
                ]
            ],
            194787: [
                [
                    144493
                ]
            ],
            194788: [
                [
                    26766
                ]
            ],
            194789: [
                [
                    26655
                ]
            ],
            194790: [
                [
                    26900
                ]
            ],
            194791: [
                [
                    15261
                ]
            ],
            194792: [
                [
                    26946
                ]
            ],
            194793: [
                [
                    27043
                ]
            ],
            194794: [
                [
                    27114
                ]
            ],
            194795: [
                [
                    27304
                ]
            ],
            194796: [
                [
                    145059
                ]
            ],
            194797: [
                [
                    27355
                ]
            ],
            194798: [
                [
                    15384
                ]
            ],
            194799: [
                [
                    27425
                ]
            ],
            194800: [
                [
                    145575
                ]
            ],
            194801: [
                [
                    27476
                ]
            ],
            194802: [
                [
                    15438
                ]
            ],
            194803: [
                [
                    27506
                ]
            ],
            194804: [
                [
                    27551
                ]
            ],
            194805: [
                [
                    27578
                ]
            ],
            194806: [
                [
                    27579
                ]
            ],
            194807: [
                [
                    146061
                ]
            ],
            194808: [
                [
                    138507
                ]
            ],
            194809: [
                [
                    146170
                ]
            ],
            194810: [
                [
                    27726
                ]
            ],
            194811: [
                [
                    146620
                ]
            ],
            194812: [
                [
                    27839
                ]
            ],
            194813: [
                [
                    27853
                ]
            ],
            194814: [
                [
                    27751
                ]
            ],
            194815: [
                [
                    27926
                ]
            ]
        },
        63744: {
            63744: [
                [
                    35912
                ]
            ],
            63745: [
                [
                    26356
                ]
            ],
            63746: [
                [
                    36554
                ]
            ],
            63747: [
                [
                    36040
                ]
            ],
            63748: [
                [
                    28369
                ]
            ],
            63749: [
                [
                    20018
                ]
            ],
            63750: [
                [
                    21477
                ]
            ],
            63751: [
                [
                    40860
                ]
            ],
            63752: [
                [
                    40860
                ]
            ],
            63753: [
                [
                    22865
                ]
            ],
            63754: [
                [
                    37329
                ]
            ],
            63755: [
                [
                    21895
                ]
            ],
            63756: [
                [
                    22856
                ]
            ],
            63757: [
                [
                    25078
                ]
            ],
            63758: [
                [
                    30313
                ]
            ],
            63759: [
                [
                    32645
                ]
            ],
            63760: [
                [
                    34367
                ]
            ],
            63761: [
                [
                    34746
                ]
            ],
            63762: [
                [
                    35064
                ]
            ],
            63763: [
                [
                    37007
                ]
            ],
            63764: [
                [
                    27138
                ]
            ],
            63765: [
                [
                    27931
                ]
            ],
            63766: [
                [
                    28889
                ]
            ],
            63767: [
                [
                    29662
                ]
            ],
            63768: [
                [
                    33853
                ]
            ],
            63769: [
                [
                    37226
                ]
            ],
            63770: [
                [
                    39409
                ]
            ],
            63771: [
                [
                    20098
                ]
            ],
            63772: [
                [
                    21365
                ]
            ],
            63773: [
                [
                    27396
                ]
            ],
            63774: [
                [
                    29211
                ]
            ],
            63775: [
                [
                    34349
                ]
            ],
            63776: [
                [
                    40478
                ]
            ],
            63777: [
                [
                    23888
                ]
            ],
            63778: [
                [
                    28651
                ]
            ],
            63779: [
                [
                    34253
                ]
            ],
            63780: [
                [
                    35172
                ]
            ],
            63781: [
                [
                    25289
                ]
            ],
            63782: [
                [
                    33240
                ]
            ],
            63783: [
                [
                    34847
                ]
            ],
            63784: [
                [
                    24266
                ]
            ],
            63785: [
                [
                    26391
                ]
            ],
            63786: [
                [
                    28010
                ]
            ],
            63787: [
                [
                    29436
                ]
            ],
            63788: [
                [
                    37070
                ]
            ],
            63789: [
                [
                    20358
                ]
            ],
            63790: [
                [
                    20919
                ]
            ],
            63791: [
                [
                    21214
                ]
            ],
            63792: [
                [
                    25796
                ]
            ],
            63793: [
                [
                    27347
                ]
            ],
            63794: [
                [
                    29200
                ]
            ],
            63795: [
                [
                    30439
                ]
            ],
            63796: [
                [
                    32769
                ]
            ],
            63797: [
                [
                    34310
                ]
            ],
            63798: [
                [
                    34396
                ]
            ],
            63799: [
                [
                    36335
                ]
            ],
            63800: [
                [
                    38706
                ]
            ],
            63801: [
                [
                    39791
                ]
            ],
            63802: [
                [
                    40442
                ]
            ],
            63803: [
                [
                    30860
                ]
            ],
            63804: [
                [
                    31103
                ]
            ],
            63805: [
                [
                    32160
                ]
            ],
            63806: [
                [
                    33737
                ]
            ],
            63807: [
                [
                    37636
                ]
            ],
            63808: [
                [
                    40575
                ]
            ],
            63809: [
                [
                    35542
                ]
            ],
            63810: [
                [
                    22751
                ]
            ],
            63811: [
                [
                    24324
                ]
            ],
            63812: [
                [
                    31840
                ]
            ],
            63813: [
                [
                    32894
                ]
            ],
            63814: [
                [
                    29282
                ]
            ],
            63815: [
                [
                    30922
                ]
            ],
            63816: [
                [
                    36034
                ]
            ],
            63817: [
                [
                    38647
                ]
            ],
            63818: [
                [
                    22744
                ]
            ],
            63819: [
                [
                    23650
                ]
            ],
            63820: [
                [
                    27155
                ]
            ],
            63821: [
                [
                    28122
                ]
            ],
            63822: [
                [
                    28431
                ]
            ],
            63823: [
                [
                    32047
                ]
            ],
            63824: [
                [
                    32311
                ]
            ],
            63825: [
                [
                    38475
                ]
            ],
            63826: [
                [
                    21202
                ]
            ],
            63827: [
                [
                    32907
                ]
            ],
            63828: [
                [
                    20956
                ]
            ],
            63829: [
                [
                    20940
                ]
            ],
            63830: [
                [
                    31260
                ]
            ],
            63831: [
                [
                    32190
                ]
            ],
            63832: [
                [
                    33777
                ]
            ],
            63833: [
                [
                    38517
                ]
            ],
            63834: [
                [
                    35712
                ]
            ],
            63835: [
                [
                    25295
                ]
            ],
            63836: [
                [
                    27138
                ]
            ],
            63837: [
                [
                    35582
                ]
            ],
            63838: [
                [
                    20025
                ]
            ],
            63839: [
                [
                    23527
                ]
            ],
            63840: [
                [
                    24594
                ]
            ],
            63841: [
                [
                    29575
                ]
            ],
            63842: [
                [
                    30064
                ]
            ],
            63843: [
                [
                    21271
                ]
            ],
            63844: [
                [
                    30971
                ]
            ],
            63845: [
                [
                    20415
                ]
            ],
            63846: [
                [
                    24489
                ]
            ],
            63847: [
                [
                    19981
                ]
            ],
            63848: [
                [
                    27852
                ]
            ],
            63849: [
                [
                    25976
                ]
            ],
            63850: [
                [
                    32034
                ]
            ],
            63851: [
                [
                    21443
                ]
            ],
            63852: [
                [
                    22622
                ]
            ],
            63853: [
                [
                    30465
                ]
            ],
            63854: [
                [
                    33865
                ]
            ],
            63855: [
                [
                    35498
                ]
            ],
            63856: [
                [
                    27578
                ]
            ],
            63857: [
                [
                    36784
                ]
            ],
            63858: [
                [
                    27784
                ]
            ],
            63859: [
                [
                    25342
                ]
            ],
            63860: [
                [
                    33509
                ]
            ],
            63861: [
                [
                    25504
                ]
            ],
            63862: [
                [
                    30053
                ]
            ],
            63863: [
                [
                    20142
                ]
            ],
            63864: [
                [
                    20841
                ]
            ],
            63865: [
                [
                    20937
                ]
            ],
            63866: [
                [
                    26753
                ]
            ],
            63867: [
                [
                    31975
                ]
            ],
            63868: [
                [
                    33391
                ]
            ],
            63869: [
                [
                    35538
                ]
            ],
            63870: [
                [
                    37327
                ]
            ],
            63871: [
                [
                    21237
                ]
            ],
            63872: [
                [
                    21570
                ]
            ],
            63873: [
                [
                    22899
                ]
            ],
            63874: [
                [
                    24300
                ]
            ],
            63875: [
                [
                    26053
                ]
            ],
            63876: [
                [
                    28670
                ]
            ],
            63877: [
                [
                    31018
                ]
            ],
            63878: [
                [
                    38317
                ]
            ],
            63879: [
                [
                    39530
                ]
            ],
            63880: [
                [
                    40599
                ]
            ],
            63881: [
                [
                    40654
                ]
            ],
            63882: [
                [
                    21147
                ]
            ],
            63883: [
                [
                    26310
                ]
            ],
            63884: [
                [
                    27511
                ]
            ],
            63885: [
                [
                    36706
                ]
            ],
            63886: [
                [
                    24180
                ]
            ],
            63887: [
                [
                    24976
                ]
            ],
            63888: [
                [
                    25088
                ]
            ],
            63889: [
                [
                    25754
                ]
            ],
            63890: [
                [
                    28451
                ]
            ],
            63891: [
                [
                    29001
                ]
            ],
            63892: [
                [
                    29833
                ]
            ],
            63893: [
                [
                    31178
                ]
            ],
            63894: [
                [
                    32244
                ]
            ],
            63895: [
                [
                    32879
                ]
            ],
            63896: [
                [
                    36646
                ]
            ],
            63897: [
                [
                    34030
                ]
            ],
            63898: [
                [
                    36899
                ]
            ],
            63899: [
                [
                    37706
                ]
            ],
            63900: [
                [
                    21015
                ]
            ],
            63901: [
                [
                    21155
                ]
            ],
            63902: [
                [
                    21693
                ]
            ],
            63903: [
                [
                    28872
                ]
            ],
            63904: [
                [
                    35010
                ]
            ],
            63905: [
                [
                    35498
                ]
            ],
            63906: [
                [
                    24265
                ]
            ],
            63907: [
                [
                    24565
                ]
            ],
            63908: [
                [
                    25467
                ]
            ],
            63909: [
                [
                    27566
                ]
            ],
            63910: [
                [
                    31806
                ]
            ],
            63911: [
                [
                    29557
                ]
            ],
            63912: [
                [
                    20196
                ]
            ],
            63913: [
                [
                    22265
                ]
            ],
            63914: [
                [
                    23527
                ]
            ],
            63915: [
                [
                    23994
                ]
            ],
            63916: [
                [
                    24604
                ]
            ],
            63917: [
                [
                    29618
                ]
            ],
            63918: [
                [
                    29801
                ]
            ],
            63919: [
                [
                    32666
                ]
            ],
            63920: [
                [
                    32838
                ]
            ],
            63921: [
                [
                    37428
                ]
            ],
            63922: [
                [
                    38646
                ]
            ],
            63923: [
                [
                    38728
                ]
            ],
            63924: [
                [
                    38936
                ]
            ],
            63925: [
                [
                    20363
                ]
            ],
            63926: [
                [
                    31150
                ]
            ],
            63927: [
                [
                    37300
                ]
            ],
            63928: [
                [
                    38584
                ]
            ],
            63929: [
                [
                    24801
                ]
            ],
            63930: [
                [
                    20102
                ]
            ],
            63931: [
                [
                    20698
                ]
            ],
            63932: [
                [
                    23534
                ]
            ],
            63933: [
                [
                    23615
                ]
            ],
            63934: [
                [
                    26009
                ]
            ],
            63935: [
                [
                    27138
                ]
            ],
            63936: [
                [
                    29134
                ]
            ],
            63937: [
                [
                    30274
                ]
            ],
            63938: [
                [
                    34044
                ]
            ],
            63939: [
                [
                    36988
                ]
            ],
            63940: [
                [
                    40845
                ]
            ],
            63941: [
                [
                    26248
                ]
            ],
            63942: [
                [
                    38446
                ]
            ],
            63943: [
                [
                    21129
                ]
            ],
            63944: [
                [
                    26491
                ]
            ],
            63945: [
                [
                    26611
                ]
            ],
            63946: [
                [
                    27969
                ]
            ],
            63947: [
                [
                    28316
                ]
            ],
            63948: [
                [
                    29705
                ]
            ],
            63949: [
                [
                    30041
                ]
            ],
            63950: [
                [
                    30827
                ]
            ],
            63951: [
                [
                    32016
                ]
            ],
            63952: [
                [
                    39006
                ]
            ],
            63953: [
                [
                    20845
                ]
            ],
            63954: [
                [
                    25134
                ]
            ],
            63955: [
                [
                    38520
                ]
            ],
            63956: [
                [
                    20523
                ]
            ],
            63957: [
                [
                    23833
                ]
            ],
            63958: [
                [
                    28138
                ]
            ],
            63959: [
                [
                    36650
                ]
            ],
            63960: [
                [
                    24459
                ]
            ],
            63961: [
                [
                    24900
                ]
            ],
            63962: [
                [
                    26647
                ]
            ],
            63963: [
                [
                    29575
                ]
            ],
            63964: [
                [
                    38534
                ]
            ],
            63965: [
                [
                    21033
                ]
            ],
            63966: [
                [
                    21519
                ]
            ],
            63967: [
                [
                    23653
                ]
            ],
            63968: [
                [
                    26131
                ]
            ],
            63969: [
                [
                    26446
                ]
            ],
            63970: [
                [
                    26792
                ]
            ],
            63971: [
                [
                    27877
                ]
            ],
            63972: [
                [
                    29702
                ]
            ],
            63973: [
                [
                    30178
                ]
            ],
            63974: [
                [
                    32633
                ]
            ],
            63975: [
                [
                    35023
                ]
            ],
            63976: [
                [
                    35041
                ]
            ],
            63977: [
                [
                    37324
                ]
            ],
            63978: [
                [
                    38626
                ]
            ],
            63979: [
                [
                    21311
                ]
            ],
            63980: [
                [
                    28346
                ]
            ],
            63981: [
                [
                    21533
                ]
            ],
            63982: [
                [
                    29136
                ]
            ],
            63983: [
                [
                    29848
                ]
            ],
            63984: [
                [
                    34298
                ]
            ],
            63985: [
                [
                    38563
                ]
            ],
            63986: [
                [
                    40023
                ]
            ],
            63987: [
                [
                    40607
                ]
            ],
            63988: [
                [
                    26519
                ]
            ],
            63989: [
                [
                    28107
                ]
            ],
            63990: [
                [
                    33256
                ]
            ],
            63991: [
                [
                    31435
                ]
            ],
            63992: [
                [
                    31520
                ]
            ],
            63993: [
                [
                    31890
                ]
            ],
            63994: [
                [
                    29376
                ]
            ],
            63995: [
                [
                    28825
                ]
            ],
            63996: [
                [
                    35672
                ]
            ],
            63997: [
                [
                    20160
                ]
            ],
            63998: [
                [
                    33590
                ]
            ],
            63999: [
                [
                    21050
                ]
            ],
            194816: [
                [
                    27966
                ]
            ],
            194817: [
                [
                    28023
                ]
            ],
            194818: [
                [
                    27969
                ]
            ],
            194819: [
                [
                    28009
                ]
            ],
            194820: [
                [
                    28024
                ]
            ],
            194821: [
                [
                    28037
                ]
            ],
            194822: [
                [
                    146718
                ]
            ],
            194823: [
                [
                    27956
                ]
            ],
            194824: [
                [
                    28207
                ]
            ],
            194825: [
                [
                    28270
                ]
            ],
            194826: [
                [
                    15667
                ]
            ],
            194827: [
                [
                    28363
                ]
            ],
            194828: [
                [
                    28359
                ]
            ],
            194829: [
                [
                    147153
                ]
            ],
            194830: [
                [
                    28153
                ]
            ],
            194831: [
                [
                    28526
                ]
            ],
            194832: [
                [
                    147294
                ]
            ],
            194833: [
                [
                    147342
                ]
            ],
            194834: [
                [
                    28614
                ]
            ],
            194835: [
                [
                    28729
                ]
            ],
            194836: [
                [
                    28702
                ]
            ],
            194837: [
                [
                    28699
                ]
            ],
            194838: [
                [
                    15766
                ]
            ],
            194839: [
                [
                    28746
                ]
            ],
            194840: [
                [
                    28797
                ]
            ],
            194841: [
                [
                    28791
                ]
            ],
            194842: [
                [
                    28845
                ]
            ],
            194843: [
                [
                    132389
                ]
            ],
            194844: [
                [
                    28997
                ]
            ],
            194845: [
                [
                    148067
                ]
            ],
            194846: [
                [
                    29084
                ]
            ],
            194847: [
                [
                    148395
                ]
            ],
            194848: [
                [
                    29224
                ]
            ],
            194849: [
                [
                    29237
                ]
            ],
            194850: [
                [
                    29264
                ]
            ],
            194851: [
                [
                    149000
                ]
            ],
            194852: [
                [
                    29312
                ]
            ],
            194853: [
                [
                    29333
                ]
            ],
            194854: [
                [
                    149301
                ]
            ],
            194855: [
                [
                    149524
                ]
            ],
            194856: [
                [
                    29562
                ]
            ],
            194857: [
                [
                    29579
                ]
            ],
            194858: [
                [
                    16044
                ]
            ],
            194859: [
                [
                    29605
                ]
            ],
            194860: [
                [
                    16056
                ]
            ],
            194861: [
                [
                    16056
                ]
            ],
            194862: [
                [
                    29767
                ]
            ],
            194863: [
                [
                    29788
                ]
            ],
            194864: [
                [
                    29809
                ]
            ],
            194865: [
                [
                    29829
                ]
            ],
            194866: [
                [
                    29898
                ]
            ],
            194867: [
                [
                    16155
                ]
            ],
            194868: [
                [
                    29988
                ]
            ],
            194869: [
                [
                    150582
                ]
            ],
            194870: [
                [
                    30014
                ]
            ],
            194871: [
                [
                    150674
                ]
            ],
            194872: [
                [
                    30064
                ]
            ],
            194873: [
                [
                    139679
                ]
            ],
            194874: [
                [
                    30224
                ]
            ],
            194875: [
                [
                    151457
                ]
            ],
            194876: [
                [
                    151480
                ]
            ],
            194877: [
                [
                    151620
                ]
            ],
            194878: [
                [
                    16380
                ]
            ],
            194879: [
                [
                    16392
                ]
            ],
            194880: [
                [
                    30452
                ]
            ],
            194881: [
                [
                    151795
                ]
            ],
            194882: [
                [
                    151794
                ]
            ],
            194883: [
                [
                    151833
                ]
            ],
            194884: [
                [
                    151859
                ]
            ],
            194885: [
                [
                    30494
                ]
            ],
            194886: [
                [
                    30495
                ]
            ],
            194887: [
                [
                    30495
                ]
            ],
            194888: [
                [
                    30538
                ]
            ],
            194889: [
                [
                    16441
                ]
            ],
            194890: [
                [
                    30603
                ]
            ],
            194891: [
                [
                    16454
                ]
            ],
            194892: [
                [
                    16534
                ]
            ],
            194893: [
                [
                    152605
                ]
            ],
            194894: [
                [
                    30798
                ]
            ],
            194895: [
                [
                    30860
                ]
            ],
            194896: [
                [
                    30924
                ]
            ],
            194897: [
                [
                    16611
                ]
            ],
            194898: [
                [
                    153126
                ]
            ],
            194899: [
                [
                    31062
                ]
            ],
            194900: [
                [
                    153242
                ]
            ],
            194901: [
                [
                    153285
                ]
            ],
            194902: [
                [
                    31119
                ]
            ],
            194903: [
                [
                    31211
                ]
            ],
            194904: [
                [
                    16687
                ]
            ],
            194905: [
                [
                    31296
                ]
            ],
            194906: [
                [
                    31306
                ]
            ],
            194907: [
                [
                    31311
                ]
            ],
            194908: [
                [
                    153980
                ]
            ],
            194909: [
                [
                    154279
                ]
            ],
            194910: [
                [
                    154279
                ]
            ],
            194911: [
                [
                    31470
                ]
            ],
            194912: [
                [
                    16898
                ]
            ],
            194913: [
                [
                    154539
                ]
            ],
            194914: [
                [
                    31686
                ]
            ],
            194915: [
                [
                    31689
                ]
            ],
            194916: [
                [
                    16935
                ]
            ],
            194917: [
                [
                    154752
                ]
            ],
            194918: [
                [
                    31954
                ]
            ],
            194919: [
                [
                    17056
                ]
            ],
            194920: [
                [
                    31976
                ]
            ],
            194921: [
                [
                    31971
                ]
            ],
            194922: [
                [
                    32000
                ]
            ],
            194923: [
                [
                    155526
                ]
            ],
            194924: [
                [
                    32099
                ]
            ],
            194925: [
                [
                    17153
                ]
            ],
            194926: [
                [
                    32199
                ]
            ],
            194927: [
                [
                    32258
                ]
            ],
            194928: [
                [
                    32325
                ]
            ],
            194929: [
                [
                    17204
                ]
            ],
            194930: [
                [
                    156200
                ]
            ],
            194931: [
                [
                    156231
                ]
            ],
            194932: [
                [
                    17241
                ]
            ],
            194933: [
                [
                    156377
                ]
            ],
            194934: [
                [
                    32634
                ]
            ],
            194935: [
                [
                    156478
                ]
            ],
            194936: [
                [
                    32661
                ]
            ],
            194937: [
                [
                    32762
                ]
            ],
            194938: [
                [
                    32773
                ]
            ],
            194939: [
                [
                    156890
                ]
            ],
            194940: [
                [
                    156963
                ]
            ],
            194941: [
                [
                    32864
                ]
            ],
            194942: [
                [
                    157096
                ]
            ],
            194943: [
                [
                    32880
                ]
            ],
            194944: [
                [
                    144223
                ]
            ],
            194945: [
                [
                    17365
                ]
            ],
            194946: [
                [
                    32946
                ]
            ],
            194947: [
                [
                    33027
                ]
            ],
            194948: [
                [
                    17419
                ]
            ],
            194949: [
                [
                    33086
                ]
            ],
            194950: [
                [
                    23221
                ]
            ],
            194951: [
                [
                    157607
                ]
            ],
            194952: [
                [
                    157621
                ]
            ],
            194953: [
                [
                    144275
                ]
            ],
            194954: [
                [
                    144284
                ]
            ],
            194955: [
                [
                    33281
                ]
            ],
            194956: [
                [
                    33284
                ]
            ],
            194957: [
                [
                    36766
                ]
            ],
            194958: [
                [
                    17515
                ]
            ],
            194959: [
                [
                    33425
                ]
            ],
            194960: [
                [
                    33419
                ]
            ],
            194961: [
                [
                    33437
                ]
            ],
            194962: [
                [
                    21171
                ]
            ],
            194963: [
                [
                    33457
                ]
            ],
            194964: [
                [
                    33459
                ]
            ],
            194965: [
                [
                    33469
                ]
            ],
            194966: [
                [
                    33510
                ]
            ],
            194967: [
                [
                    158524
                ]
            ],
            194968: [
                [
                    33509
                ]
            ],
            194969: [
                [
                    33565
                ]
            ],
            194970: [
                [
                    33635
                ]
            ],
            194971: [
                [
                    33709
                ]
            ],
            194972: [
                [
                    33571
                ]
            ],
            194973: [
                [
                    33725
                ]
            ],
            194974: [
                [
                    33767
                ]
            ],
            194975: [
                [
                    33879
                ]
            ],
            194976: [
                [
                    33619
                ]
            ],
            194977: [
                [
                    33738
                ]
            ],
            194978: [
                [
                    33740
                ]
            ],
            194979: [
                [
                    33756
                ]
            ],
            194980: [
                [
                    158774
                ]
            ],
            194981: [
                [
                    159083
                ]
            ],
            194982: [
                [
                    158933
                ]
            ],
            194983: [
                [
                    17707
                ]
            ],
            194984: [
                [
                    34033
                ]
            ],
            194985: [
                [
                    34035
                ]
            ],
            194986: [
                [
                    34070
                ]
            ],
            194987: [
                [
                    160714
                ]
            ],
            194988: [
                [
                    34148
                ]
            ],
            194989: [
                [
                    159532
                ]
            ],
            194990: [
                [
                    17757
                ]
            ],
            194991: [
                [
                    17761
                ]
            ],
            194992: [
                [
                    159665
                ]
            ],
            194993: [
                [
                    159954
                ]
            ],
            194994: [
                [
                    17771
                ]
            ],
            194995: [
                [
                    34384
                ]
            ],
            194996: [
                [
                    34396
                ]
            ],
            194997: [
                [
                    34407
                ]
            ],
            194998: [
                [
                    34409
                ]
            ],
            194999: [
                [
                    34473
                ]
            ],
            195000: [
                [
                    34440
                ]
            ],
            195001: [
                [
                    34574
                ]
            ],
            195002: [
                [
                    34530
                ]
            ],
            195003: [
                [
                    34681
                ]
            ],
            195004: [
                [
                    34600
                ]
            ],
            195005: [
                [
                    34667
                ]
            ],
            195006: [
                [
                    34694
                ]
            ],
            195007: [
                [
                    17879
                ]
            ],
            195008: [
                [
                    34785
                ]
            ],
            195009: [
                [
                    34817
                ]
            ],
            195010: [
                [
                    17913
                ]
            ],
            195011: [
                [
                    34912
                ]
            ],
            195012: [
                [
                    34915
                ]
            ],
            195013: [
                [
                    161383
                ]
            ],
            195014: [
                [
                    35031
                ]
            ],
            195015: [
                [
                    35038
                ]
            ],
            195016: [
                [
                    17973
                ]
            ],
            195017: [
                [
                    35066
                ]
            ],
            195018: [
                [
                    13499
                ]
            ],
            195019: [
                [
                    161966
                ]
            ],
            195020: [
                [
                    162150
                ]
            ],
            195021: [
                [
                    18110
                ]
            ],
            195022: [
                [
                    18119
                ]
            ],
            195023: [
                [
                    35488
                ]
            ],
            195024: [
                [
                    35565
                ]
            ],
            195025: [
                [
                    35722
                ]
            ],
            195026: [
                [
                    35925
                ]
            ],
            195027: [
                [
                    162984
                ]
            ],
            195028: [
                [
                    36011
                ]
            ],
            195029: [
                [
                    36033
                ]
            ],
            195030: [
                [
                    36123
                ]
            ],
            195031: [
                [
                    36215
                ]
            ],
            195032: [
                [
                    163631
                ]
            ],
            195033: [
                [
                    133124
                ]
            ],
            195034: [
                [
                    36299
                ]
            ],
            195035: [
                [
                    36284
                ]
            ],
            195036: [
                [
                    36336
                ]
            ],
            195037: [
                [
                    133342
                ]
            ],
            195038: [
                [
                    36564
                ]
            ],
            195039: [
                [
                    36664
                ]
            ],
            195040: [
                [
                    165330
                ]
            ],
            195041: [
                [
                    165357
                ]
            ],
            195042: [
                [
                    37012
                ]
            ],
            195043: [
                [
                    37105
                ]
            ],
            195044: [
                [
                    37137
                ]
            ],
            195045: [
                [
                    165678
                ]
            ],
            195046: [
                [
                    37147
                ]
            ],
            195047: [
                [
                    37432
                ]
            ],
            195048: [
                [
                    37591
                ]
            ],
            195049: [
                [
                    37592
                ]
            ],
            195050: [
                [
                    37500
                ]
            ],
            195051: [
                [
                    37881
                ]
            ],
            195052: [
                [
                    37909
                ]
            ],
            195053: [
                [
                    166906
                ]
            ],
            195054: [
                [
                    38283
                ]
            ],
            195055: [
                [
                    18837
                ]
            ],
            195056: [
                [
                    38327
                ]
            ],
            195057: [
                [
                    167287
                ]
            ],
            195058: [
                [
                    18918
                ]
            ],
            195059: [
                [
                    38595
                ]
            ],
            195060: [
                [
                    23986
                ]
            ],
            195061: [
                [
                    38691
                ]
            ],
            195062: [
                [
                    168261
                ]
            ],
            195063: [
                [
                    168474
                ]
            ],
            195064: [
                [
                    19054
                ]
            ],
            195065: [
                [
                    19062
                ]
            ],
            195066: [
                [
                    38880
                ]
            ],
            195067: [
                [
                    168970
                ]
            ],
            195068: [
                [
                    19122
                ]
            ],
            195069: [
                [
                    169110
                ]
            ],
            195070: [
                [
                    38923
                ]
            ],
            195071: [
                [
                    38923
                ]
            ]
        },
        64000: {
            64000: [
                [
                    20999
                ]
            ],
            64001: [
                [
                    24230
                ]
            ],
            64002: [
                [
                    25299
                ]
            ],
            64003: [
                [
                    31958
                ]
            ],
            64004: [
                [
                    23429
                ]
            ],
            64005: [
                [
                    27934
                ]
            ],
            64006: [
                [
                    26292
                ]
            ],
            64007: [
                [
                    36667
                ]
            ],
            64008: [
                [
                    34892
                ]
            ],
            64009: [
                [
                    38477
                ]
            ],
            64010: [
                [
                    35211
                ]
            ],
            64011: [
                [
                    24275
                ]
            ],
            64012: [
                [
                    20800
                ]
            ],
            64013: [
                [
                    21952
                ]
            ],
            64016: [
                [
                    22618
                ]
            ],
            64018: [
                [
                    26228
                ]
            ],
            64021: [
                [
                    20958
                ]
            ],
            64022: [
                [
                    29482
                ]
            ],
            64023: [
                [
                    30410
                ]
            ],
            64024: [
                [
                    31036
                ]
            ],
            64025: [
                [
                    31070
                ]
            ],
            64026: [
                [
                    31077
                ]
            ],
            64027: [
                [
                    31119
                ]
            ],
            64028: [
                [
                    38742
                ]
            ],
            64029: [
                [
                    31934
                ]
            ],
            64030: [
                [
                    32701
                ]
            ],
            64032: [
                [
                    34322
                ]
            ],
            64034: [
                [
                    35576
                ]
            ],
            64037: [
                [
                    36920
                ]
            ],
            64038: [
                [
                    37117
                ]
            ],
            64042: [
                [
                    39151
                ]
            ],
            64043: [
                [
                    39164
                ]
            ],
            64044: [
                [
                    39208
                ]
            ],
            64045: [
                [
                    40372
                ]
            ],
            64046: [
                [
                    37086
                ]
            ],
            64047: [
                [
                    38583
                ]
            ],
            64048: [
                [
                    20398
                ]
            ],
            64049: [
                [
                    20711
                ]
            ],
            64050: [
                [
                    20813
                ]
            ],
            64051: [
                [
                    21193
                ]
            ],
            64052: [
                [
                    21220
                ]
            ],
            64053: [
                [
                    21329
                ]
            ],
            64054: [
                [
                    21917
                ]
            ],
            64055: [
                [
                    22022
                ]
            ],
            64056: [
                [
                    22120
                ]
            ],
            64057: [
                [
                    22592
                ]
            ],
            64058: [
                [
                    22696
                ]
            ],
            64059: [
                [
                    23652
                ]
            ],
            64060: [
                [
                    23662
                ]
            ],
            64061: [
                [
                    24724
                ]
            ],
            64062: [
                [
                    24936
                ]
            ],
            64063: [
                [
                    24974
                ]
            ],
            64064: [
                [
                    25074
                ]
            ],
            64065: [
                [
                    25935
                ]
            ],
            64066: [
                [
                    26082
                ]
            ],
            64067: [
                [
                    26257
                ]
            ],
            64068: [
                [
                    26757
                ]
            ],
            64069: [
                [
                    28023
                ]
            ],
            64070: [
                [
                    28186
                ]
            ],
            64071: [
                [
                    28450
                ]
            ],
            64072: [
                [
                    29038
                ]
            ],
            64073: [
                [
                    29227
                ]
            ],
            64074: [
                [
                    29730
                ]
            ],
            64075: [
                [
                    30865
                ]
            ],
            64076: [
                [
                    31038
                ]
            ],
            64077: [
                [
                    31049
                ]
            ],
            64078: [
                [
                    31048
                ]
            ],
            64079: [
                [
                    31056
                ]
            ],
            64080: [
                [
                    31062
                ]
            ],
            64081: [
                [
                    31069
                ]
            ],
            64082: [
                [
                    31117
                ]
            ],
            64083: [
                [
                    31118
                ]
            ],
            64084: [
                [
                    31296
                ]
            ],
            64085: [
                [
                    31361
                ]
            ],
            64086: [
                [
                    31680
                ]
            ],
            64087: [
                [
                    32244
                ]
            ],
            64088: [
                [
                    32265
                ]
            ],
            64089: [
                [
                    32321
                ]
            ],
            64090: [
                [
                    32626
                ]
            ],
            64091: [
                [
                    32773
                ]
            ],
            64092: [
                [
                    33261
                ]
            ],
            64093: [
                [
                    33401
                ]
            ],
            64094: [
                [
                    33401
                ]
            ],
            64095: [
                [
                    33879
                ]
            ],
            64096: [
                [
                    35088
                ]
            ],
            64097: [
                [
                    35222
                ]
            ],
            64098: [
                [
                    35585
                ]
            ],
            64099: [
                [
                    35641
                ]
            ],
            64100: [
                [
                    36051
                ]
            ],
            64101: [
                [
                    36104
                ]
            ],
            64102: [
                [
                    36790
                ]
            ],
            64103: [
                [
                    36920
                ]
            ],
            64104: [
                [
                    38627
                ]
            ],
            64105: [
                [
                    38911
                ]
            ],
            64106: [
                [
                    38971
                ]
            ],
            64107: [
                [
                    24693
                ]
            ],
            64108: [
                [
                    148206
                ]
            ],
            64109: [
                [
                    33304
                ]
            ],
            64112: [
                [
                    20006
                ]
            ],
            64113: [
                [
                    20917
                ]
            ],
            64114: [
                [
                    20840
                ]
            ],
            64115: [
                [
                    20352
                ]
            ],
            64116: [
                [
                    20805
                ]
            ],
            64117: [
                [
                    20864
                ]
            ],
            64118: [
                [
                    21191
                ]
            ],
            64119: [
                [
                    21242
                ]
            ],
            64120: [
                [
                    21917
                ]
            ],
            64121: [
                [
                    21845
                ]
            ],
            64122: [
                [
                    21913
                ]
            ],
            64123: [
                [
                    21986
                ]
            ],
            64124: [
                [
                    22618
                ]
            ],
            64125: [
                [
                    22707
                ]
            ],
            64126: [
                [
                    22852
                ]
            ],
            64127: [
                [
                    22868
                ]
            ],
            64128: [
                [
                    23138
                ]
            ],
            64129: [
                [
                    23336
                ]
            ],
            64130: [
                [
                    24274
                ]
            ],
            64131: [
                [
                    24281
                ]
            ],
            64132: [
                [
                    24425
                ]
            ],
            64133: [
                [
                    24493
                ]
            ],
            64134: [
                [
                    24792
                ]
            ],
            64135: [
                [
                    24910
                ]
            ],
            64136: [
                [
                    24840
                ]
            ],
            64137: [
                [
                    24974
                ]
            ],
            64138: [
                [
                    24928
                ]
            ],
            64139: [
                [
                    25074
                ]
            ],
            64140: [
                [
                    25140
                ]
            ],
            64141: [
                [
                    25540
                ]
            ],
            64142: [
                [
                    25628
                ]
            ],
            64143: [
                [
                    25682
                ]
            ],
            64144: [
                [
                    25942
                ]
            ],
            64145: [
                [
                    26228
                ]
            ],
            64146: [
                [
                    26391
                ]
            ],
            64147: [
                [
                    26395
                ]
            ],
            64148: [
                [
                    26454
                ]
            ],
            64149: [
                [
                    27513
                ]
            ],
            64150: [
                [
                    27578
                ]
            ],
            64151: [
                [
                    27969
                ]
            ],
            64152: [
                [
                    28379
                ]
            ],
            64153: [
                [
                    28363
                ]
            ],
            64154: [
                [
                    28450
                ]
            ],
            64155: [
                [
                    28702
                ]
            ],
            64156: [
                [
                    29038
                ]
            ],
            64157: [
                [
                    30631
                ]
            ],
            64158: [
                [
                    29237
                ]
            ],
            64159: [
                [
                    29359
                ]
            ],
            64160: [
                [
                    29482
                ]
            ],
            64161: [
                [
                    29809
                ]
            ],
            64162: [
                [
                    29958
                ]
            ],
            64163: [
                [
                    30011
                ]
            ],
            64164: [
                [
                    30237
                ]
            ],
            64165: [
                [
                    30239
                ]
            ],
            64166: [
                [
                    30410
                ]
            ],
            64167: [
                [
                    30427
                ]
            ],
            64168: [
                [
                    30452
                ]
            ],
            64169: [
                [
                    30538
                ]
            ],
            64170: [
                [
                    30528
                ]
            ],
            64171: [
                [
                    30924
                ]
            ],
            64172: [
                [
                    31409
                ]
            ],
            64173: [
                [
                    31680
                ]
            ],
            64174: [
                [
                    31867
                ]
            ],
            64175: [
                [
                    32091
                ]
            ],
            64176: [
                [
                    32244
                ]
            ],
            64177: [
                [
                    32574
                ]
            ],
            64178: [
                [
                    32773
                ]
            ],
            64179: [
                [
                    33618
                ]
            ],
            64180: [
                [
                    33775
                ]
            ],
            64181: [
                [
                    34681
                ]
            ],
            64182: [
                [
                    35137
                ]
            ],
            64183: [
                [
                    35206
                ]
            ],
            64184: [
                [
                    35222
                ]
            ],
            64185: [
                [
                    35519
                ]
            ],
            64186: [
                [
                    35576
                ]
            ],
            64187: [
                [
                    35531
                ]
            ],
            64188: [
                [
                    35585
                ]
            ],
            64189: [
                [
                    35582
                ]
            ],
            64190: [
                [
                    35565
                ]
            ],
            64191: [
                [
                    35641
                ]
            ],
            64192: [
                [
                    35722
                ]
            ],
            64193: [
                [
                    36104
                ]
            ],
            64194: [
                [
                    36664
                ]
            ],
            64195: [
                [
                    36978
                ]
            ],
            64196: [
                [
                    37273
                ]
            ],
            64197: [
                [
                    37494
                ]
            ],
            64198: [
                [
                    38524
                ]
            ],
            64199: [
                [
                    38627
                ]
            ],
            64200: [
                [
                    38742
                ]
            ],
            64201: [
                [
                    38875
                ]
            ],
            64202: [
                [
                    38911
                ]
            ],
            64203: [
                [
                    38923
                ]
            ],
            64204: [
                [
                    38971
                ]
            ],
            64205: [
                [
                    39698
                ]
            ],
            64206: [
                [
                    40860
                ]
            ],
            64207: [
                [
                    141386
                ]
            ],
            64208: [
                [
                    141380
                ]
            ],
            64209: [
                [
                    144341
                ]
            ],
            64210: [
                [
                    15261
                ]
            ],
            64211: [
                [
                    16408
                ]
            ],
            64212: [
                [
                    16441
                ]
            ],
            64213: [
                [
                    152137
                ]
            ],
            64214: [
                [
                    154832
                ]
            ],
            64215: [
                [
                    163539
                ]
            ],
            64216: [
                [
                    40771
                ]
            ],
            64217: [
                [
                    40846
                ]
            ],
            195072: [
                [
                    38953
                ]
            ],
            195073: [
                [
                    169398
                ]
            ],
            195074: [
                [
                    39138
                ]
            ],
            195075: [
                [
                    19251
                ]
            ],
            195076: [
                [
                    39209
                ]
            ],
            195077: [
                [
                    39335
                ]
            ],
            195078: [
                [
                    39362
                ]
            ],
            195079: [
                [
                    39422
                ]
            ],
            195080: [
                [
                    19406
                ]
            ],
            195081: [
                [
                    170800
                ]
            ],
            195082: [
                [
                    39698
                ]
            ],
            195083: [
                [
                    40000
                ]
            ],
            195084: [
                [
                    40189
                ]
            ],
            195085: [
                [
                    19662
                ]
            ],
            195086: [
                [
                    19693
                ]
            ],
            195087: [
                [
                    40295
                ]
            ],
            195088: [
                [
                    172238
                ]
            ],
            195089: [
                [
                    19704
                ]
            ],
            195090: [
                [
                    172293
                ]
            ],
            195091: [
                [
                    172558
                ]
            ],
            195092: [
                [
                    172689
                ]
            ],
            195093: [
                [
                    40635
                ]
            ],
            195094: [
                [
                    19798
                ]
            ],
            195095: [
                [
                    40697
                ]
            ],
            195096: [
                [
                    40702
                ]
            ],
            195097: [
                [
                    40709
                ]
            ],
            195098: [
                [
                    40719
                ]
            ],
            195099: [
                [
                    40726
                ]
            ],
            195100: [
                [
                    40763
                ]
            ],
            195101: [
                [
                    173568
                ]
            ]
        },
        64256: {
            64256: [
                [
                    102,
                    102
                ],
                256
            ],
            64257: [
                [
                    102,
                    105
                ],
                256
            ],
            64258: [
                [
                    102,
                    108
                ],
                256
            ],
            64259: [
                [
                    102,
                    102,
                    105
                ],
                256
            ],
            64260: [
                [
                    102,
                    102,
                    108
                ],
                256
            ],
            64261: [
                [
                    383,
                    116
                ],
                256
            ],
            64262: [
                [
                    115,
                    116
                ],
                256
            ],
            64275: [
                [
                    1396,
                    1398
                ],
                256
            ],
            64276: [
                [
                    1396,
                    1381
                ],
                256
            ],
            64277: [
                [
                    1396,
                    1387
                ],
                256
            ],
            64278: [
                [
                    1406,
                    1398
                ],
                256
            ],
            64279: [
                [
                    1396,
                    1389
                ],
                256
            ],
            64285: [
                [
                    1497,
                    1460
                ],
                512
            ],
            64286: [
                ,
                26
            ],
            64287: [
                [
                    1522,
                    1463
                ],
                512
            ],
            64288: [
                [
                    1506
                ],
                256
            ],
            64289: [
                [
                    1488
                ],
                256
            ],
            64290: [
                [
                    1491
                ],
                256
            ],
            64291: [
                [
                    1492
                ],
                256
            ],
            64292: [
                [
                    1499
                ],
                256
            ],
            64293: [
                [
                    1500
                ],
                256
            ],
            64294: [
                [
                    1501
                ],
                256
            ],
            64295: [
                [
                    1512
                ],
                256
            ],
            64296: [
                [
                    1514
                ],
                256
            ],
            64297: [
                [
                    43
                ],
                256
            ],
            64298: [
                [
                    1513,
                    1473
                ],
                512
            ],
            64299: [
                [
                    1513,
                    1474
                ],
                512
            ],
            64300: [
                [
                    64329,
                    1473
                ],
                512
            ],
            64301: [
                [
                    64329,
                    1474
                ],
                512
            ],
            64302: [
                [
                    1488,
                    1463
                ],
                512
            ],
            64303: [
                [
                    1488,
                    1464
                ],
                512
            ],
            64304: [
                [
                    1488,
                    1468
                ],
                512
            ],
            64305: [
                [
                    1489,
                    1468
                ],
                512
            ],
            64306: [
                [
                    1490,
                    1468
                ],
                512
            ],
            64307: [
                [
                    1491,
                    1468
                ],
                512
            ],
            64308: [
                [
                    1492,
                    1468
                ],
                512
            ],
            64309: [
                [
                    1493,
                    1468
                ],
                512
            ],
            64310: [
                [
                    1494,
                    1468
                ],
                512
            ],
            64312: [
                [
                    1496,
                    1468
                ],
                512
            ],
            64313: [
                [
                    1497,
                    1468
                ],
                512
            ],
            64314: [
                [
                    1498,
                    1468
                ],
                512
            ],
            64315: [
                [
                    1499,
                    1468
                ],
                512
            ],
            64316: [
                [
                    1500,
                    1468
                ],
                512
            ],
            64318: [
                [
                    1502,
                    1468
                ],
                512
            ],
            64320: [
                [
                    1504,
                    1468
                ],
                512
            ],
            64321: [
                [
                    1505,
                    1468
                ],
                512
            ],
            64323: [
                [
                    1507,
                    1468
                ],
                512
            ],
            64324: [
                [
                    1508,
                    1468
                ],
                512
            ],
            64326: [
                [
                    1510,
                    1468
                ],
                512
            ],
            64327: [
                [
                    1511,
                    1468
                ],
                512
            ],
            64328: [
                [
                    1512,
                    1468
                ],
                512
            ],
            64329: [
                [
                    1513,
                    1468
                ],
                512
            ],
            64330: [
                [
                    1514,
                    1468
                ],
                512
            ],
            64331: [
                [
                    1493,
                    1465
                ],
                512
            ],
            64332: [
                [
                    1489,
                    1471
                ],
                512
            ],
            64333: [
                [
                    1499,
                    1471
                ],
                512
            ],
            64334: [
                [
                    1508,
                    1471
                ],
                512
            ],
            64335: [
                [
                    1488,
                    1500
                ],
                256
            ],
            64336: [
                [
                    1649
                ],
                256
            ],
            64337: [
                [
                    1649
                ],
                256
            ],
            64338: [
                [
                    1659
                ],
                256
            ],
            64339: [
                [
                    1659
                ],
                256
            ],
            64340: [
                [
                    1659
                ],
                256
            ],
            64341: [
                [
                    1659
                ],
                256
            ],
            64342: [
                [
                    1662
                ],
                256
            ],
            64343: [
                [
                    1662
                ],
                256
            ],
            64344: [
                [
                    1662
                ],
                256
            ],
            64345: [
                [
                    1662
                ],
                256
            ],
            64346: [
                [
                    1664
                ],
                256
            ],
            64347: [
                [
                    1664
                ],
                256
            ],
            64348: [
                [
                    1664
                ],
                256
            ],
            64349: [
                [
                    1664
                ],
                256
            ],
            64350: [
                [
                    1658
                ],
                256
            ],
            64351: [
                [
                    1658
                ],
                256
            ],
            64352: [
                [
                    1658
                ],
                256
            ],
            64353: [
                [
                    1658
                ],
                256
            ],
            64354: [
                [
                    1663
                ],
                256
            ],
            64355: [
                [
                    1663
                ],
                256
            ],
            64356: [
                [
                    1663
                ],
                256
            ],
            64357: [
                [
                    1663
                ],
                256
            ],
            64358: [
                [
                    1657
                ],
                256
            ],
            64359: [
                [
                    1657
                ],
                256
            ],
            64360: [
                [
                    1657
                ],
                256
            ],
            64361: [
                [
                    1657
                ],
                256
            ],
            64362: [
                [
                    1700
                ],
                256
            ],
            64363: [
                [
                    1700
                ],
                256
            ],
            64364: [
                [
                    1700
                ],
                256
            ],
            64365: [
                [
                    1700
                ],
                256
            ],
            64366: [
                [
                    1702
                ],
                256
            ],
            64367: [
                [
                    1702
                ],
                256
            ],
            64368: [
                [
                    1702
                ],
                256
            ],
            64369: [
                [
                    1702
                ],
                256
            ],
            64370: [
                [
                    1668
                ],
                256
            ],
            64371: [
                [
                    1668
                ],
                256
            ],
            64372: [
                [
                    1668
                ],
                256
            ],
            64373: [
                [
                    1668
                ],
                256
            ],
            64374: [
                [
                    1667
                ],
                256
            ],
            64375: [
                [
                    1667
                ],
                256
            ],
            64376: [
                [
                    1667
                ],
                256
            ],
            64377: [
                [
                    1667
                ],
                256
            ],
            64378: [
                [
                    1670
                ],
                256
            ],
            64379: [
                [
                    1670
                ],
                256
            ],
            64380: [
                [
                    1670
                ],
                256
            ],
            64381: [
                [
                    1670
                ],
                256
            ],
            64382: [
                [
                    1671
                ],
                256
            ],
            64383: [
                [
                    1671
                ],
                256
            ],
            64384: [
                [
                    1671
                ],
                256
            ],
            64385: [
                [
                    1671
                ],
                256
            ],
            64386: [
                [
                    1677
                ],
                256
            ],
            64387: [
                [
                    1677
                ],
                256
            ],
            64388: [
                [
                    1676
                ],
                256
            ],
            64389: [
                [
                    1676
                ],
                256
            ],
            64390: [
                [
                    1678
                ],
                256
            ],
            64391: [
                [
                    1678
                ],
                256
            ],
            64392: [
                [
                    1672
                ],
                256
            ],
            64393: [
                [
                    1672
                ],
                256
            ],
            64394: [
                [
                    1688
                ],
                256
            ],
            64395: [
                [
                    1688
                ],
                256
            ],
            64396: [
                [
                    1681
                ],
                256
            ],
            64397: [
                [
                    1681
                ],
                256
            ],
            64398: [
                [
                    1705
                ],
                256
            ],
            64399: [
                [
                    1705
                ],
                256
            ],
            64400: [
                [
                    1705
                ],
                256
            ],
            64401: [
                [
                    1705
                ],
                256
            ],
            64402: [
                [
                    1711
                ],
                256
            ],
            64403: [
                [
                    1711
                ],
                256
            ],
            64404: [
                [
                    1711
                ],
                256
            ],
            64405: [
                [
                    1711
                ],
                256
            ],
            64406: [
                [
                    1715
                ],
                256
            ],
            64407: [
                [
                    1715
                ],
                256
            ],
            64408: [
                [
                    1715
                ],
                256
            ],
            64409: [
                [
                    1715
                ],
                256
            ],
            64410: [
                [
                    1713
                ],
                256
            ],
            64411: [
                [
                    1713
                ],
                256
            ],
            64412: [
                [
                    1713
                ],
                256
            ],
            64413: [
                [
                    1713
                ],
                256
            ],
            64414: [
                [
                    1722
                ],
                256
            ],
            64415: [
                [
                    1722
                ],
                256
            ],
            64416: [
                [
                    1723
                ],
                256
            ],
            64417: [
                [
                    1723
                ],
                256
            ],
            64418: [
                [
                    1723
                ],
                256
            ],
            64419: [
                [
                    1723
                ],
                256
            ],
            64420: [
                [
                    1728
                ],
                256
            ],
            64421: [
                [
                    1728
                ],
                256
            ],
            64422: [
                [
                    1729
                ],
                256
            ],
            64423: [
                [
                    1729
                ],
                256
            ],
            64424: [
                [
                    1729
                ],
                256
            ],
            64425: [
                [
                    1729
                ],
                256
            ],
            64426: [
                [
                    1726
                ],
                256
            ],
            64427: [
                [
                    1726
                ],
                256
            ],
            64428: [
                [
                    1726
                ],
                256
            ],
            64429: [
                [
                    1726
                ],
                256
            ],
            64430: [
                [
                    1746
                ],
                256
            ],
            64431: [
                [
                    1746
                ],
                256
            ],
            64432: [
                [
                    1747
                ],
                256
            ],
            64433: [
                [
                    1747
                ],
                256
            ],
            64467: [
                [
                    1709
                ],
                256
            ],
            64468: [
                [
                    1709
                ],
                256
            ],
            64469: [
                [
                    1709
                ],
                256
            ],
            64470: [
                [
                    1709
                ],
                256
            ],
            64471: [
                [
                    1735
                ],
                256
            ],
            64472: [
                [
                    1735
                ],
                256
            ],
            64473: [
                [
                    1734
                ],
                256
            ],
            64474: [
                [
                    1734
                ],
                256
            ],
            64475: [
                [
                    1736
                ],
                256
            ],
            64476: [
                [
                    1736
                ],
                256
            ],
            64477: [
                [
                    1655
                ],
                256
            ],
            64478: [
                [
                    1739
                ],
                256
            ],
            64479: [
                [
                    1739
                ],
                256
            ],
            64480: [
                [
                    1733
                ],
                256
            ],
            64481: [
                [
                    1733
                ],
                256
            ],
            64482: [
                [
                    1737
                ],
                256
            ],
            64483: [
                [
                    1737
                ],
                256
            ],
            64484: [
                [
                    1744
                ],
                256
            ],
            64485: [
                [
                    1744
                ],
                256
            ],
            64486: [
                [
                    1744
                ],
                256
            ],
            64487: [
                [
                    1744
                ],
                256
            ],
            64488: [
                [
                    1609
                ],
                256
            ],
            64489: [
                [
                    1609
                ],
                256
            ],
            64490: [
                [
                    1574,
                    1575
                ],
                256
            ],
            64491: [
                [
                    1574,
                    1575
                ],
                256
            ],
            64492: [
                [
                    1574,
                    1749
                ],
                256
            ],
            64493: [
                [
                    1574,
                    1749
                ],
                256
            ],
            64494: [
                [
                    1574,
                    1608
                ],
                256
            ],
            64495: [
                [
                    1574,
                    1608
                ],
                256
            ],
            64496: [
                [
                    1574,
                    1735
                ],
                256
            ],
            64497: [
                [
                    1574,
                    1735
                ],
                256
            ],
            64498: [
                [
                    1574,
                    1734
                ],
                256
            ],
            64499: [
                [
                    1574,
                    1734
                ],
                256
            ],
            64500: [
                [
                    1574,
                    1736
                ],
                256
            ],
            64501: [
                [
                    1574,
                    1736
                ],
                256
            ],
            64502: [
                [
                    1574,
                    1744
                ],
                256
            ],
            64503: [
                [
                    1574,
                    1744
                ],
                256
            ],
            64504: [
                [
                    1574,
                    1744
                ],
                256
            ],
            64505: [
                [
                    1574,
                    1609
                ],
                256
            ],
            64506: [
                [
                    1574,
                    1609
                ],
                256
            ],
            64507: [
                [
                    1574,
                    1609
                ],
                256
            ],
            64508: [
                [
                    1740
                ],
                256
            ],
            64509: [
                [
                    1740
                ],
                256
            ],
            64510: [
                [
                    1740
                ],
                256
            ],
            64511: [
                [
                    1740
                ],
                256
            ]
        },
        64512: {
            64512: [
                [
                    1574,
                    1580
                ],
                256
            ],
            64513: [
                [
                    1574,
                    1581
                ],
                256
            ],
            64514: [
                [
                    1574,
                    1605
                ],
                256
            ],
            64515: [
                [
                    1574,
                    1609
                ],
                256
            ],
            64516: [
                [
                    1574,
                    1610
                ],
                256
            ],
            64517: [
                [
                    1576,
                    1580
                ],
                256
            ],
            64518: [
                [
                    1576,
                    1581
                ],
                256
            ],
            64519: [
                [
                    1576,
                    1582
                ],
                256
            ],
            64520: [
                [
                    1576,
                    1605
                ],
                256
            ],
            64521: [
                [
                    1576,
                    1609
                ],
                256
            ],
            64522: [
                [
                    1576,
                    1610
                ],
                256
            ],
            64523: [
                [
                    1578,
                    1580
                ],
                256
            ],
            64524: [
                [
                    1578,
                    1581
                ],
                256
            ],
            64525: [
                [
                    1578,
                    1582
                ],
                256
            ],
            64526: [
                [
                    1578,
                    1605
                ],
                256
            ],
            64527: [
                [
                    1578,
                    1609
                ],
                256
            ],
            64528: [
                [
                    1578,
                    1610
                ],
                256
            ],
            64529: [
                [
                    1579,
                    1580
                ],
                256
            ],
            64530: [
                [
                    1579,
                    1605
                ],
                256
            ],
            64531: [
                [
                    1579,
                    1609
                ],
                256
            ],
            64532: [
                [
                    1579,
                    1610
                ],
                256
            ],
            64533: [
                [
                    1580,
                    1581
                ],
                256
            ],
            64534: [
                [
                    1580,
                    1605
                ],
                256
            ],
            64535: [
                [
                    1581,
                    1580
                ],
                256
            ],
            64536: [
                [
                    1581,
                    1605
                ],
                256
            ],
            64537: [
                [
                    1582,
                    1580
                ],
                256
            ],
            64538: [
                [
                    1582,
                    1581
                ],
                256
            ],
            64539: [
                [
                    1582,
                    1605
                ],
                256
            ],
            64540: [
                [
                    1587,
                    1580
                ],
                256
            ],
            64541: [
                [
                    1587,
                    1581
                ],
                256
            ],
            64542: [
                [
                    1587,
                    1582
                ],
                256
            ],
            64543: [
                [
                    1587,
                    1605
                ],
                256
            ],
            64544: [
                [
                    1589,
                    1581
                ],
                256
            ],
            64545: [
                [
                    1589,
                    1605
                ],
                256
            ],
            64546: [
                [
                    1590,
                    1580
                ],
                256
            ],
            64547: [
                [
                    1590,
                    1581
                ],
                256
            ],
            64548: [
                [
                    1590,
                    1582
                ],
                256
            ],
            64549: [
                [
                    1590,
                    1605
                ],
                256
            ],
            64550: [
                [
                    1591,
                    1581
                ],
                256
            ],
            64551: [
                [
                    1591,
                    1605
                ],
                256
            ],
            64552: [
                [
                    1592,
                    1605
                ],
                256
            ],
            64553: [
                [
                    1593,
                    1580
                ],
                256
            ],
            64554: [
                [
                    1593,
                    1605
                ],
                256
            ],
            64555: [
                [
                    1594,
                    1580
                ],
                256
            ],
            64556: [
                [
                    1594,
                    1605
                ],
                256
            ],
            64557: [
                [
                    1601,
                    1580
                ],
                256
            ],
            64558: [
                [
                    1601,
                    1581
                ],
                256
            ],
            64559: [
                [
                    1601,
                    1582
                ],
                256
            ],
            64560: [
                [
                    1601,
                    1605
                ],
                256
            ],
            64561: [
                [
                    1601,
                    1609
                ],
                256
            ],
            64562: [
                [
                    1601,
                    1610
                ],
                256
            ],
            64563: [
                [
                    1602,
                    1581
                ],
                256
            ],
            64564: [
                [
                    1602,
                    1605
                ],
                256
            ],
            64565: [
                [
                    1602,
                    1609
                ],
                256
            ],
            64566: [
                [
                    1602,
                    1610
                ],
                256
            ],
            64567: [
                [
                    1603,
                    1575
                ],
                256
            ],
            64568: [
                [
                    1603,
                    1580
                ],
                256
            ],
            64569: [
                [
                    1603,
                    1581
                ],
                256
            ],
            64570: [
                [
                    1603,
                    1582
                ],
                256
            ],
            64571: [
                [
                    1603,
                    1604
                ],
                256
            ],
            64572: [
                [
                    1603,
                    1605
                ],
                256
            ],
            64573: [
                [
                    1603,
                    1609
                ],
                256
            ],
            64574: [
                [
                    1603,
                    1610
                ],
                256
            ],
            64575: [
                [
                    1604,
                    1580
                ],
                256
            ],
            64576: [
                [
                    1604,
                    1581
                ],
                256
            ],
            64577: [
                [
                    1604,
                    1582
                ],
                256
            ],
            64578: [
                [
                    1604,
                    1605
                ],
                256
            ],
            64579: [
                [
                    1604,
                    1609
                ],
                256
            ],
            64580: [
                [
                    1604,
                    1610
                ],
                256
            ],
            64581: [
                [
                    1605,
                    1580
                ],
                256
            ],
            64582: [
                [
                    1605,
                    1581
                ],
                256
            ],
            64583: [
                [
                    1605,
                    1582
                ],
                256
            ],
            64584: [
                [
                    1605,
                    1605
                ],
                256
            ],
            64585: [
                [
                    1605,
                    1609
                ],
                256
            ],
            64586: [
                [
                    1605,
                    1610
                ],
                256
            ],
            64587: [
                [
                    1606,
                    1580
                ],
                256
            ],
            64588: [
                [
                    1606,
                    1581
                ],
                256
            ],
            64589: [
                [
                    1606,
                    1582
                ],
                256
            ],
            64590: [
                [
                    1606,
                    1605
                ],
                256
            ],
            64591: [
                [
                    1606,
                    1609
                ],
                256
            ],
            64592: [
                [
                    1606,
                    1610
                ],
                256
            ],
            64593: [
                [
                    1607,
                    1580
                ],
                256
            ],
            64594: [
                [
                    1607,
                    1605
                ],
                256
            ],
            64595: [
                [
                    1607,
                    1609
                ],
                256
            ],
            64596: [
                [
                    1607,
                    1610
                ],
                256
            ],
            64597: [
                [
                    1610,
                    1580
                ],
                256
            ],
            64598: [
                [
                    1610,
                    1581
                ],
                256
            ],
            64599: [
                [
                    1610,
                    1582
                ],
                256
            ],
            64600: [
                [
                    1610,
                    1605
                ],
                256
            ],
            64601: [
                [
                    1610,
                    1609
                ],
                256
            ],
            64602: [
                [
                    1610,
                    1610
                ],
                256
            ],
            64603: [
                [
                    1584,
                    1648
                ],
                256
            ],
            64604: [
                [
                    1585,
                    1648
                ],
                256
            ],
            64605: [
                [
                    1609,
                    1648
                ],
                256
            ],
            64606: [
                [
                    32,
                    1612,
                    1617
                ],
                256
            ],
            64607: [
                [
                    32,
                    1613,
                    1617
                ],
                256
            ],
            64608: [
                [
                    32,
                    1614,
                    1617
                ],
                256
            ],
            64609: [
                [
                    32,
                    1615,
                    1617
                ],
                256
            ],
            64610: [
                [
                    32,
                    1616,
                    1617
                ],
                256
            ],
            64611: [
                [
                    32,
                    1617,
                    1648
                ],
                256
            ],
            64612: [
                [
                    1574,
                    1585
                ],
                256
            ],
            64613: [
                [
                    1574,
                    1586
                ],
                256
            ],
            64614: [
                [
                    1574,
                    1605
                ],
                256
            ],
            64615: [
                [
                    1574,
                    1606
                ],
                256
            ],
            64616: [
                [
                    1574,
                    1609
                ],
                256
            ],
            64617: [
                [
                    1574,
                    1610
                ],
                256
            ],
            64618: [
                [
                    1576,
                    1585
                ],
                256
            ],
            64619: [
                [
                    1576,
                    1586
                ],
                256
            ],
            64620: [
                [
                    1576,
                    1605
                ],
                256
            ],
            64621: [
                [
                    1576,
                    1606
                ],
                256
            ],
            64622: [
                [
                    1576,
                    1609
                ],
                256
            ],
            64623: [
                [
                    1576,
                    1610
                ],
                256
            ],
            64624: [
                [
                    1578,
                    1585
                ],
                256
            ],
            64625: [
                [
                    1578,
                    1586
                ],
                256
            ],
            64626: [
                [
                    1578,
                    1605
                ],
                256
            ],
            64627: [
                [
                    1578,
                    1606
                ],
                256
            ],
            64628: [
                [
                    1578,
                    1609
                ],
                256
            ],
            64629: [
                [
                    1578,
                    1610
                ],
                256
            ],
            64630: [
                [
                    1579,
                    1585
                ],
                256
            ],
            64631: [
                [
                    1579,
                    1586
                ],
                256
            ],
            64632: [
                [
                    1579,
                    1605
                ],
                256
            ],
            64633: [
                [
                    1579,
                    1606
                ],
                256
            ],
            64634: [
                [
                    1579,
                    1609
                ],
                256
            ],
            64635: [
                [
                    1579,
                    1610
                ],
                256
            ],
            64636: [
                [
                    1601,
                    1609
                ],
                256
            ],
            64637: [
                [
                    1601,
                    1610
                ],
                256
            ],
            64638: [
                [
                    1602,
                    1609
                ],
                256
            ],
            64639: [
                [
                    1602,
                    1610
                ],
                256
            ],
            64640: [
                [
                    1603,
                    1575
                ],
                256
            ],
            64641: [
                [
                    1603,
                    1604
                ],
                256
            ],
            64642: [
                [
                    1603,
                    1605
                ],
                256
            ],
            64643: [
                [
                    1603,
                    1609
                ],
                256
            ],
            64644: [
                [
                    1603,
                    1610
                ],
                256
            ],
            64645: [
                [
                    1604,
                    1605
                ],
                256
            ],
            64646: [
                [
                    1604,
                    1609
                ],
                256
            ],
            64647: [
                [
                    1604,
                    1610
                ],
                256
            ],
            64648: [
                [
                    1605,
                    1575
                ],
                256
            ],
            64649: [
                [
                    1605,
                    1605
                ],
                256
            ],
            64650: [
                [
                    1606,
                    1585
                ],
                256
            ],
            64651: [
                [
                    1606,
                    1586
                ],
                256
            ],
            64652: [
                [
                    1606,
                    1605
                ],
                256
            ],
            64653: [
                [
                    1606,
                    1606
                ],
                256
            ],
            64654: [
                [
                    1606,
                    1609
                ],
                256
            ],
            64655: [
                [
                    1606,
                    1610
                ],
                256
            ],
            64656: [
                [
                    1609,
                    1648
                ],
                256
            ],
            64657: [
                [
                    1610,
                    1585
                ],
                256
            ],
            64658: [
                [
                    1610,
                    1586
                ],
                256
            ],
            64659: [
                [
                    1610,
                    1605
                ],
                256
            ],
            64660: [
                [
                    1610,
                    1606
                ],
                256
            ],
            64661: [
                [
                    1610,
                    1609
                ],
                256
            ],
            64662: [
                [
                    1610,
                    1610
                ],
                256
            ],
            64663: [
                [
                    1574,
                    1580
                ],
                256
            ],
            64664: [
                [
                    1574,
                    1581
                ],
                256
            ],
            64665: [
                [
                    1574,
                    1582
                ],
                256
            ],
            64666: [
                [
                    1574,
                    1605
                ],
                256
            ],
            64667: [
                [
                    1574,
                    1607
                ],
                256
            ],
            64668: [
                [
                    1576,
                    1580
                ],
                256
            ],
            64669: [
                [
                    1576,
                    1581
                ],
                256
            ],
            64670: [
                [
                    1576,
                    1582
                ],
                256
            ],
            64671: [
                [
                    1576,
                    1605
                ],
                256
            ],
            64672: [
                [
                    1576,
                    1607
                ],
                256
            ],
            64673: [
                [
                    1578,
                    1580
                ],
                256
            ],
            64674: [
                [
                    1578,
                    1581
                ],
                256
            ],
            64675: [
                [
                    1578,
                    1582
                ],
                256
            ],
            64676: [
                [
                    1578,
                    1605
                ],
                256
            ],
            64677: [
                [
                    1578,
                    1607
                ],
                256
            ],
            64678: [
                [
                    1579,
                    1605
                ],
                256
            ],
            64679: [
                [
                    1580,
                    1581
                ],
                256
            ],
            64680: [
                [
                    1580,
                    1605
                ],
                256
            ],
            64681: [
                [
                    1581,
                    1580
                ],
                256
            ],
            64682: [
                [
                    1581,
                    1605
                ],
                256
            ],
            64683: [
                [
                    1582,
                    1580
                ],
                256
            ],
            64684: [
                [
                    1582,
                    1605
                ],
                256
            ],
            64685: [
                [
                    1587,
                    1580
                ],
                256
            ],
            64686: [
                [
                    1587,
                    1581
                ],
                256
            ],
            64687: [
                [
                    1587,
                    1582
                ],
                256
            ],
            64688: [
                [
                    1587,
                    1605
                ],
                256
            ],
            64689: [
                [
                    1589,
                    1581
                ],
                256
            ],
            64690: [
                [
                    1589,
                    1582
                ],
                256
            ],
            64691: [
                [
                    1589,
                    1605
                ],
                256
            ],
            64692: [
                [
                    1590,
                    1580
                ],
                256
            ],
            64693: [
                [
                    1590,
                    1581
                ],
                256
            ],
            64694: [
                [
                    1590,
                    1582
                ],
                256
            ],
            64695: [
                [
                    1590,
                    1605
                ],
                256
            ],
            64696: [
                [
                    1591,
                    1581
                ],
                256
            ],
            64697: [
                [
                    1592,
                    1605
                ],
                256
            ],
            64698: [
                [
                    1593,
                    1580
                ],
                256
            ],
            64699: [
                [
                    1593,
                    1605
                ],
                256
            ],
            64700: [
                [
                    1594,
                    1580
                ],
                256
            ],
            64701: [
                [
                    1594,
                    1605
                ],
                256
            ],
            64702: [
                [
                    1601,
                    1580
                ],
                256
            ],
            64703: [
                [
                    1601,
                    1581
                ],
                256
            ],
            64704: [
                [
                    1601,
                    1582
                ],
                256
            ],
            64705: [
                [
                    1601,
                    1605
                ],
                256
            ],
            64706: [
                [
                    1602,
                    1581
                ],
                256
            ],
            64707: [
                [
                    1602,
                    1605
                ],
                256
            ],
            64708: [
                [
                    1603,
                    1580
                ],
                256
            ],
            64709: [
                [
                    1603,
                    1581
                ],
                256
            ],
            64710: [
                [
                    1603,
                    1582
                ],
                256
            ],
            64711: [
                [
                    1603,
                    1604
                ],
                256
            ],
            64712: [
                [
                    1603,
                    1605
                ],
                256
            ],
            64713: [
                [
                    1604,
                    1580
                ],
                256
            ],
            64714: [
                [
                    1604,
                    1581
                ],
                256
            ],
            64715: [
                [
                    1604,
                    1582
                ],
                256
            ],
            64716: [
                [
                    1604,
                    1605
                ],
                256
            ],
            64717: [
                [
                    1604,
                    1607
                ],
                256
            ],
            64718: [
                [
                    1605,
                    1580
                ],
                256
            ],
            64719: [
                [
                    1605,
                    1581
                ],
                256
            ],
            64720: [
                [
                    1605,
                    1582
                ],
                256
            ],
            64721: [
                [
                    1605,
                    1605
                ],
                256
            ],
            64722: [
                [
                    1606,
                    1580
                ],
                256
            ],
            64723: [
                [
                    1606,
                    1581
                ],
                256
            ],
            64724: [
                [
                    1606,
                    1582
                ],
                256
            ],
            64725: [
                [
                    1606,
                    1605
                ],
                256
            ],
            64726: [
                [
                    1606,
                    1607
                ],
                256
            ],
            64727: [
                [
                    1607,
                    1580
                ],
                256
            ],
            64728: [
                [
                    1607,
                    1605
                ],
                256
            ],
            64729: [
                [
                    1607,
                    1648
                ],
                256
            ],
            64730: [
                [
                    1610,
                    1580
                ],
                256
            ],
            64731: [
                [
                    1610,
                    1581
                ],
                256
            ],
            64732: [
                [
                    1610,
                    1582
                ],
                256
            ],
            64733: [
                [
                    1610,
                    1605
                ],
                256
            ],
            64734: [
                [
                    1610,
                    1607
                ],
                256
            ],
            64735: [
                [
                    1574,
                    1605
                ],
                256
            ],
            64736: [
                [
                    1574,
                    1607
                ],
                256
            ],
            64737: [
                [
                    1576,
                    1605
                ],
                256
            ],
            64738: [
                [
                    1576,
                    1607
                ],
                256
            ],
            64739: [
                [
                    1578,
                    1605
                ],
                256
            ],
            64740: [
                [
                    1578,
                    1607
                ],
                256
            ],
            64741: [
                [
                    1579,
                    1605
                ],
                256
            ],
            64742: [
                [
                    1579,
                    1607
                ],
                256
            ],
            64743: [
                [
                    1587,
                    1605
                ],
                256
            ],
            64744: [
                [
                    1587,
                    1607
                ],
                256
            ],
            64745: [
                [
                    1588,
                    1605
                ],
                256
            ],
            64746: [
                [
                    1588,
                    1607
                ],
                256
            ],
            64747: [
                [
                    1603,
                    1604
                ],
                256
            ],
            64748: [
                [
                    1603,
                    1605
                ],
                256
            ],
            64749: [
                [
                    1604,
                    1605
                ],
                256
            ],
            64750: [
                [
                    1606,
                    1605
                ],
                256
            ],
            64751: [
                [
                    1606,
                    1607
                ],
                256
            ],
            64752: [
                [
                    1610,
                    1605
                ],
                256
            ],
            64753: [
                [
                    1610,
                    1607
                ],
                256
            ],
            64754: [
                [
                    1600,
                    1614,
                    1617
                ],
                256
            ],
            64755: [
                [
                    1600,
                    1615,
                    1617
                ],
                256
            ],
            64756: [
                [
                    1600,
                    1616,
                    1617
                ],
                256
            ],
            64757: [
                [
                    1591,
                    1609
                ],
                256
            ],
            64758: [
                [
                    1591,
                    1610
                ],
                256
            ],
            64759: [
                [
                    1593,
                    1609
                ],
                256
            ],
            64760: [
                [
                    1593,
                    1610
                ],
                256
            ],
            64761: [
                [
                    1594,
                    1609
                ],
                256
            ],
            64762: [
                [
                    1594,
                    1610
                ],
                256
            ],
            64763: [
                [
                    1587,
                    1609
                ],
                256
            ],
            64764: [
                [
                    1587,
                    1610
                ],
                256
            ],
            64765: [
                [
                    1588,
                    1609
                ],
                256
            ],
            64766: [
                [
                    1588,
                    1610
                ],
                256
            ],
            64767: [
                [
                    1581,
                    1609
                ],
                256
            ]
        },
        64768: {
            64768: [
                [
                    1581,
                    1610
                ],
                256
            ],
            64769: [
                [
                    1580,
                    1609
                ],
                256
            ],
            64770: [
                [
                    1580,
                    1610
                ],
                256
            ],
            64771: [
                [
                    1582,
                    1609
                ],
                256
            ],
            64772: [
                [
                    1582,
                    1610
                ],
                256
            ],
            64773: [
                [
                    1589,
                    1609
                ],
                256
            ],
            64774: [
                [
                    1589,
                    1610
                ],
                256
            ],
            64775: [
                [
                    1590,
                    1609
                ],
                256
            ],
            64776: [
                [
                    1590,
                    1610
                ],
                256
            ],
            64777: [
                [
                    1588,
                    1580
                ],
                256
            ],
            64778: [
                [
                    1588,
                    1581
                ],
                256
            ],
            64779: [
                [
                    1588,
                    1582
                ],
                256
            ],
            64780: [
                [
                    1588,
                    1605
                ],
                256
            ],
            64781: [
                [
                    1588,
                    1585
                ],
                256
            ],
            64782: [
                [
                    1587,
                    1585
                ],
                256
            ],
            64783: [
                [
                    1589,
                    1585
                ],
                256
            ],
            64784: [
                [
                    1590,
                    1585
                ],
                256
            ],
            64785: [
                [
                    1591,
                    1609
                ],
                256
            ],
            64786: [
                [
                    1591,
                    1610
                ],
                256
            ],
            64787: [
                [
                    1593,
                    1609
                ],
                256
            ],
            64788: [
                [
                    1593,
                    1610
                ],
                256
            ],
            64789: [
                [
                    1594,
                    1609
                ],
                256
            ],
            64790: [
                [
                    1594,
                    1610
                ],
                256
            ],
            64791: [
                [
                    1587,
                    1609
                ],
                256
            ],
            64792: [
                [
                    1587,
                    1610
                ],
                256
            ],
            64793: [
                [
                    1588,
                    1609
                ],
                256
            ],
            64794: [
                [
                    1588,
                    1610
                ],
                256
            ],
            64795: [
                [
                    1581,
                    1609
                ],
                256
            ],
            64796: [
                [
                    1581,
                    1610
                ],
                256
            ],
            64797: [
                [
                    1580,
                    1609
                ],
                256
            ],
            64798: [
                [
                    1580,
                    1610
                ],
                256
            ],
            64799: [
                [
                    1582,
                    1609
                ],
                256
            ],
            64800: [
                [
                    1582,
                    1610
                ],
                256
            ],
            64801: [
                [
                    1589,
                    1609
                ],
                256
            ],
            64802: [
                [
                    1589,
                    1610
                ],
                256
            ],
            64803: [
                [
                    1590,
                    1609
                ],
                256
            ],
            64804: [
                [
                    1590,
                    1610
                ],
                256
            ],
            64805: [
                [
                    1588,
                    1580
                ],
                256
            ],
            64806: [
                [
                    1588,
                    1581
                ],
                256
            ],
            64807: [
                [
                    1588,
                    1582
                ],
                256
            ],
            64808: [
                [
                    1588,
                    1605
                ],
                256
            ],
            64809: [
                [
                    1588,
                    1585
                ],
                256
            ],
            64810: [
                [
                    1587,
                    1585
                ],
                256
            ],
            64811: [
                [
                    1589,
                    1585
                ],
                256
            ],
            64812: [
                [
                    1590,
                    1585
                ],
                256
            ],
            64813: [
                [
                    1588,
                    1580
                ],
                256
            ],
            64814: [
                [
                    1588,
                    1581
                ],
                256
            ],
            64815: [
                [
                    1588,
                    1582
                ],
                256
            ],
            64816: [
                [
                    1588,
                    1605
                ],
                256
            ],
            64817: [
                [
                    1587,
                    1607
                ],
                256
            ],
            64818: [
                [
                    1588,
                    1607
                ],
                256
            ],
            64819: [
                [
                    1591,
                    1605
                ],
                256
            ],
            64820: [
                [
                    1587,
                    1580
                ],
                256
            ],
            64821: [
                [
                    1587,
                    1581
                ],
                256
            ],
            64822: [
                [
                    1587,
                    1582
                ],
                256
            ],
            64823: [
                [
                    1588,
                    1580
                ],
                256
            ],
            64824: [
                [
                    1588,
                    1581
                ],
                256
            ],
            64825: [
                [
                    1588,
                    1582
                ],
                256
            ],
            64826: [
                [
                    1591,
                    1605
                ],
                256
            ],
            64827: [
                [
                    1592,
                    1605
                ],
                256
            ],
            64828: [
                [
                    1575,
                    1611
                ],
                256
            ],
            64829: [
                [
                    1575,
                    1611
                ],
                256
            ],
            64848: [
                [
                    1578,
                    1580,
                    1605
                ],
                256
            ],
            64849: [
                [
                    1578,
                    1581,
                    1580
                ],
                256
            ],
            64850: [
                [
                    1578,
                    1581,
                    1580
                ],
                256
            ],
            64851: [
                [
                    1578,
                    1581,
                    1605
                ],
                256
            ],
            64852: [
                [
                    1578,
                    1582,
                    1605
                ],
                256
            ],
            64853: [
                [
                    1578,
                    1605,
                    1580
                ],
                256
            ],
            64854: [
                [
                    1578,
                    1605,
                    1581
                ],
                256
            ],
            64855: [
                [
                    1578,
                    1605,
                    1582
                ],
                256
            ],
            64856: [
                [
                    1580,
                    1605,
                    1581
                ],
                256
            ],
            64857: [
                [
                    1580,
                    1605,
                    1581
                ],
                256
            ],
            64858: [
                [
                    1581,
                    1605,
                    1610
                ],
                256
            ],
            64859: [
                [
                    1581,
                    1605,
                    1609
                ],
                256
            ],
            64860: [
                [
                    1587,
                    1581,
                    1580
                ],
                256
            ],
            64861: [
                [
                    1587,
                    1580,
                    1581
                ],
                256
            ],
            64862: [
                [
                    1587,
                    1580,
                    1609
                ],
                256
            ],
            64863: [
                [
                    1587,
                    1605,
                    1581
                ],
                256
            ],
            64864: [
                [
                    1587,
                    1605,
                    1581
                ],
                256
            ],
            64865: [
                [
                    1587,
                    1605,
                    1580
                ],
                256
            ],
            64866: [
                [
                    1587,
                    1605,
                    1605
                ],
                256
            ],
            64867: [
                [
                    1587,
                    1605,
                    1605
                ],
                256
            ],
            64868: [
                [
                    1589,
                    1581,
                    1581
                ],
                256
            ],
            64869: [
                [
                    1589,
                    1581,
                    1581
                ],
                256
            ],
            64870: [
                [
                    1589,
                    1605,
                    1605
                ],
                256
            ],
            64871: [
                [
                    1588,
                    1581,
                    1605
                ],
                256
            ],
            64872: [
                [
                    1588,
                    1581,
                    1605
                ],
                256
            ],
            64873: [
                [
                    1588,
                    1580,
                    1610
                ],
                256
            ],
            64874: [
                [
                    1588,
                    1605,
                    1582
                ],
                256
            ],
            64875: [
                [
                    1588,
                    1605,
                    1582
                ],
                256
            ],
            64876: [
                [
                    1588,
                    1605,
                    1605
                ],
                256
            ],
            64877: [
                [
                    1588,
                    1605,
                    1605
                ],
                256
            ],
            64878: [
                [
                    1590,
                    1581,
                    1609
                ],
                256
            ],
            64879: [
                [
                    1590,
                    1582,
                    1605
                ],
                256
            ],
            64880: [
                [
                    1590,
                    1582,
                    1605
                ],
                256
            ],
            64881: [
                [
                    1591,
                    1605,
                    1581
                ],
                256
            ],
            64882: [
                [
                    1591,
                    1605,
                    1581
                ],
                256
            ],
            64883: [
                [
                    1591,
                    1605,
                    1605
                ],
                256
            ],
            64884: [
                [
                    1591,
                    1605,
                    1610
                ],
                256
            ],
            64885: [
                [
                    1593,
                    1580,
                    1605
                ],
                256
            ],
            64886: [
                [
                    1593,
                    1605,
                    1605
                ],
                256
            ],
            64887: [
                [
                    1593,
                    1605,
                    1605
                ],
                256
            ],
            64888: [
                [
                    1593,
                    1605,
                    1609
                ],
                256
            ],
            64889: [
                [
                    1594,
                    1605,
                    1605
                ],
                256
            ],
            64890: [
                [
                    1594,
                    1605,
                    1610
                ],
                256
            ],
            64891: [
                [
                    1594,
                    1605,
                    1609
                ],
                256
            ],
            64892: [
                [
                    1601,
                    1582,
                    1605
                ],
                256
            ],
            64893: [
                [
                    1601,
                    1582,
                    1605
                ],
                256
            ],
            64894: [
                [
                    1602,
                    1605,
                    1581
                ],
                256
            ],
            64895: [
                [
                    1602,
                    1605,
                    1605
                ],
                256
            ],
            64896: [
                [
                    1604,
                    1581,
                    1605
                ],
                256
            ],
            64897: [
                [
                    1604,
                    1581,
                    1610
                ],
                256
            ],
            64898: [
                [
                    1604,
                    1581,
                    1609
                ],
                256
            ],
            64899: [
                [
                    1604,
                    1580,
                    1580
                ],
                256
            ],
            64900: [
                [
                    1604,
                    1580,
                    1580
                ],
                256
            ],
            64901: [
                [
                    1604,
                    1582,
                    1605
                ],
                256
            ],
            64902: [
                [
                    1604,
                    1582,
                    1605
                ],
                256
            ],
            64903: [
                [
                    1604,
                    1605,
                    1581
                ],
                256
            ],
            64904: [
                [
                    1604,
                    1605,
                    1581
                ],
                256
            ],
            64905: [
                [
                    1605,
                    1581,
                    1580
                ],
                256
            ],
            64906: [
                [
                    1605,
                    1581,
                    1605
                ],
                256
            ],
            64907: [
                [
                    1605,
                    1581,
                    1610
                ],
                256
            ],
            64908: [
                [
                    1605,
                    1580,
                    1581
                ],
                256
            ],
            64909: [
                [
                    1605,
                    1580,
                    1605
                ],
                256
            ],
            64910: [
                [
                    1605,
                    1582,
                    1580
                ],
                256
            ],
            64911: [
                [
                    1605,
                    1582,
                    1605
                ],
                256
            ],
            64914: [
                [
                    1605,
                    1580,
                    1582
                ],
                256
            ],
            64915: [
                [
                    1607,
                    1605,
                    1580
                ],
                256
            ],
            64916: [
                [
                    1607,
                    1605,
                    1605
                ],
                256
            ],
            64917: [
                [
                    1606,
                    1581,
                    1605
                ],
                256
            ],
            64918: [
                [
                    1606,
                    1581,
                    1609
                ],
                256
            ],
            64919: [
                [
                    1606,
                    1580,
                    1605
                ],
                256
            ],
            64920: [
                [
                    1606,
                    1580,
                    1605
                ],
                256
            ],
            64921: [
                [
                    1606,
                    1580,
                    1609
                ],
                256
            ],
            64922: [
                [
                    1606,
                    1605,
                    1610
                ],
                256
            ],
            64923: [
                [
                    1606,
                    1605,
                    1609
                ],
                256
            ],
            64924: [
                [
                    1610,
                    1605,
                    1605
                ],
                256
            ],
            64925: [
                [
                    1610,
                    1605,
                    1605
                ],
                256
            ],
            64926: [
                [
                    1576,
                    1582,
                    1610
                ],
                256
            ],
            64927: [
                [
                    1578,
                    1580,
                    1610
                ],
                256
            ],
            64928: [
                [
                    1578,
                    1580,
                    1609
                ],
                256
            ],
            64929: [
                [
                    1578,
                    1582,
                    1610
                ],
                256
            ],
            64930: [
                [
                    1578,
                    1582,
                    1609
                ],
                256
            ],
            64931: [
                [
                    1578,
                    1605,
                    1610
                ],
                256
            ],
            64932: [
                [
                    1578,
                    1605,
                    1609
                ],
                256
            ],
            64933: [
                [
                    1580,
                    1605,
                    1610
                ],
                256
            ],
            64934: [
                [
                    1580,
                    1581,
                    1609
                ],
                256
            ],
            64935: [
                [
                    1580,
                    1605,
                    1609
                ],
                256
            ],
            64936: [
                [
                    1587,
                    1582,
                    1609
                ],
                256
            ],
            64937: [
                [
                    1589,
                    1581,
                    1610
                ],
                256
            ],
            64938: [
                [
                    1588,
                    1581,
                    1610
                ],
                256
            ],
            64939: [
                [
                    1590,
                    1581,
                    1610
                ],
                256
            ],
            64940: [
                [
                    1604,
                    1580,
                    1610
                ],
                256
            ],
            64941: [
                [
                    1604,
                    1605,
                    1610
                ],
                256
            ],
            64942: [
                [
                    1610,
                    1581,
                    1610
                ],
                256
            ],
            64943: [
                [
                    1610,
                    1580,
                    1610
                ],
                256
            ],
            64944: [
                [
                    1610,
                    1605,
                    1610
                ],
                256
            ],
            64945: [
                [
                    1605,
                    1605,
                    1610
                ],
                256
            ],
            64946: [
                [
                    1602,
                    1605,
                    1610
                ],
                256
            ],
            64947: [
                [
                    1606,
                    1581,
                    1610
                ],
                256
            ],
            64948: [
                [
                    1602,
                    1605,
                    1581
                ],
                256
            ],
            64949: [
                [
                    1604,
                    1581,
                    1605
                ],
                256
            ],
            64950: [
                [
                    1593,
                    1605,
                    1610
                ],
                256
            ],
            64951: [
                [
                    1603,
                    1605,
                    1610
                ],
                256
            ],
            64952: [
                [
                    1606,
                    1580,
                    1581
                ],
                256
            ],
            64953: [
                [
                    1605,
                    1582,
                    1610
                ],
                256
            ],
            64954: [
                [
                    1604,
                    1580,
                    1605
                ],
                256
            ],
            64955: [
                [
                    1603,
                    1605,
                    1605
                ],
                256
            ],
            64956: [
                [
                    1604,
                    1580,
                    1605
                ],
                256
            ],
            64957: [
                [
                    1606,
                    1580,
                    1581
                ],
                256
            ],
            64958: [
                [
                    1580,
                    1581,
                    1610
                ],
                256
            ],
            64959: [
                [
                    1581,
                    1580,
                    1610
                ],
                256
            ],
            64960: [
                [
                    1605,
                    1580,
                    1610
                ],
                256
            ],
            64961: [
                [
                    1601,
                    1605,
                    1610
                ],
                256
            ],
            64962: [
                [
                    1576,
                    1581,
                    1610
                ],
                256
            ],
            64963: [
                [
                    1603,
                    1605,
                    1605
                ],
                256
            ],
            64964: [
                [
                    1593,
                    1580,
                    1605
                ],
                256
            ],
            64965: [
                [
                    1589,
                    1605,
                    1605
                ],
                256
            ],
            64966: [
                [
                    1587,
                    1582,
                    1610
                ],
                256
            ],
            64967: [
                [
                    1606,
                    1580,
                    1610
                ],
                256
            ],
            65008: [
                [
                    1589,
                    1604,
                    1746
                ],
                256
            ],
            65009: [
                [
                    1602,
                    1604,
                    1746
                ],
                256
            ],
            65010: [
                [
                    1575,
                    1604,
                    1604,
                    1607
                ],
                256
            ],
            65011: [
                [
                    1575,
                    1603,
                    1576,
                    1585
                ],
                256
            ],
            65012: [
                [
                    1605,
                    1581,
                    1605,
                    1583
                ],
                256
            ],
            65013: [
                [
                    1589,
                    1604,
                    1593,
                    1605
                ],
                256
            ],
            65014: [
                [
                    1585,
                    1587,
                    1608,
                    1604
                ],
                256
            ],
            65015: [
                [
                    1593,
                    1604,
                    1610,
                    1607
                ],
                256
            ],
            65016: [
                [
                    1608,
                    1587,
                    1604,
                    1605
                ],
                256
            ],
            65017: [
                [
                    1589,
                    1604,
                    1609
                ],
                256
            ],
            65018: [
                [
                    1589,
                    1604,
                    1609,
                    32,
                    1575,
                    1604,
                    1604,
                    1607,
                    32,
                    1593,
                    1604,
                    1610,
                    1607,
                    32,
                    1608,
                    1587,
                    1604,
                    1605
                ],
                256
            ],
            65019: [
                [
                    1580,
                    1604,
                    32,
                    1580,
                    1604,
                    1575,
                    1604,
                    1607
                ],
                256
            ],
            65020: [
                [
                    1585,
                    1740,
                    1575,
                    1604
                ],
                256
            ]
        },
        65024: {
            65040: [
                [
                    44
                ],
                256
            ],
            65041: [
                [
                    12289
                ],
                256
            ],
            65042: [
                [
                    12290
                ],
                256
            ],
            65043: [
                [
                    58
                ],
                256
            ],
            65044: [
                [
                    59
                ],
                256
            ],
            65045: [
                [
                    33
                ],
                256
            ],
            65046: [
                [
                    63
                ],
                256
            ],
            65047: [
                [
                    12310
                ],
                256
            ],
            65048: [
                [
                    12311
                ],
                256
            ],
            65049: [
                [
                    8230
                ],
                256
            ],
            65056: [
                ,
                230
            ],
            65057: [
                ,
                230
            ],
            65058: [
                ,
                230
            ],
            65059: [
                ,
                230
            ],
            65060: [
                ,
                230
            ],
            65061: [
                ,
                230
            ],
            65062: [
                ,
                230
            ],
            65063: [
                ,
                220
            ],
            65064: [
                ,
                220
            ],
            65065: [
                ,
                220
            ],
            65066: [
                ,
                220
            ],
            65067: [
                ,
                220
            ],
            65068: [
                ,
                220
            ],
            65069: [
                ,
                220
            ],
            65072: [
                [
                    8229
                ],
                256
            ],
            65073: [
                [
                    8212
                ],
                256
            ],
            65074: [
                [
                    8211
                ],
                256
            ],
            65075: [
                [
                    95
                ],
                256
            ],
            65076: [
                [
                    95
                ],
                256
            ],
            65077: [
                [
                    40
                ],
                256
            ],
            65078: [
                [
                    41
                ],
                256
            ],
            65079: [
                [
                    123
                ],
                256
            ],
            65080: [
                [
                    125
                ],
                256
            ],
            65081: [
                [
                    12308
                ],
                256
            ],
            65082: [
                [
                    12309
                ],
                256
            ],
            65083: [
                [
                    12304
                ],
                256
            ],
            65084: [
                [
                    12305
                ],
                256
            ],
            65085: [
                [
                    12298
                ],
                256
            ],
            65086: [
                [
                    12299
                ],
                256
            ],
            65087: [
                [
                    12296
                ],
                256
            ],
            65088: [
                [
                    12297
                ],
                256
            ],
            65089: [
                [
                    12300
                ],
                256
            ],
            65090: [
                [
                    12301
                ],
                256
            ],
            65091: [
                [
                    12302
                ],
                256
            ],
            65092: [
                [
                    12303
                ],
                256
            ],
            65095: [
                [
                    91
                ],
                256
            ],
            65096: [
                [
                    93
                ],
                256
            ],
            65097: [
                [
                    8254
                ],
                256
            ],
            65098: [
                [
                    8254
                ],
                256
            ],
            65099: [
                [
                    8254
                ],
                256
            ],
            65100: [
                [
                    8254
                ],
                256
            ],
            65101: [
                [
                    95
                ],
                256
            ],
            65102: [
                [
                    95
                ],
                256
            ],
            65103: [
                [
                    95
                ],
                256
            ],
            65104: [
                [
                    44
                ],
                256
            ],
            65105: [
                [
                    12289
                ],
                256
            ],
            65106: [
                [
                    46
                ],
                256
            ],
            65108: [
                [
                    59
                ],
                256
            ],
            65109: [
                [
                    58
                ],
                256
            ],
            65110: [
                [
                    63
                ],
                256
            ],
            65111: [
                [
                    33
                ],
                256
            ],
            65112: [
                [
                    8212
                ],
                256
            ],
            65113: [
                [
                    40
                ],
                256
            ],
            65114: [
                [
                    41
                ],
                256
            ],
            65115: [
                [
                    123
                ],
                256
            ],
            65116: [
                [
                    125
                ],
                256
            ],
            65117: [
                [
                    12308
                ],
                256
            ],
            65118: [
                [
                    12309
                ],
                256
            ],
            65119: [
                [
                    35
                ],
                256
            ],
            65120: [
                [
                    38
                ],
                256
            ],
            65121: [
                [
                    42
                ],
                256
            ],
            65122: [
                [
                    43
                ],
                256
            ],
            65123: [
                [
                    45
                ],
                256
            ],
            65124: [
                [
                    60
                ],
                256
            ],
            65125: [
                [
                    62
                ],
                256
            ],
            65126: [
                [
                    61
                ],
                256
            ],
            65128: [
                [
                    92
                ],
                256
            ],
            65129: [
                [
                    36
                ],
                256
            ],
            65130: [
                [
                    37
                ],
                256
            ],
            65131: [
                [
                    64
                ],
                256
            ],
            65136: [
                [
                    32,
                    1611
                ],
                256
            ],
            65137: [
                [
                    1600,
                    1611
                ],
                256
            ],
            65138: [
                [
                    32,
                    1612
                ],
                256
            ],
            65140: [
                [
                    32,
                    1613
                ],
                256
            ],
            65142: [
                [
                    32,
                    1614
                ],
                256
            ],
            65143: [
                [
                    1600,
                    1614
                ],
                256
            ],
            65144: [
                [
                    32,
                    1615
                ],
                256
            ],
            65145: [
                [
                    1600,
                    1615
                ],
                256
            ],
            65146: [
                [
                    32,
                    1616
                ],
                256
            ],
            65147: [
                [
                    1600,
                    1616
                ],
                256
            ],
            65148: [
                [
                    32,
                    1617
                ],
                256
            ],
            65149: [
                [
                    1600,
                    1617
                ],
                256
            ],
            65150: [
                [
                    32,
                    1618
                ],
                256
            ],
            65151: [
                [
                    1600,
                    1618
                ],
                256
            ],
            65152: [
                [
                    1569
                ],
                256
            ],
            65153: [
                [
                    1570
                ],
                256
            ],
            65154: [
                [
                    1570
                ],
                256
            ],
            65155: [
                [
                    1571
                ],
                256
            ],
            65156: [
                [
                    1571
                ],
                256
            ],
            65157: [
                [
                    1572
                ],
                256
            ],
            65158: [
                [
                    1572
                ],
                256
            ],
            65159: [
                [
                    1573
                ],
                256
            ],
            65160: [
                [
                    1573
                ],
                256
            ],
            65161: [
                [
                    1574
                ],
                256
            ],
            65162: [
                [
                    1574
                ],
                256
            ],
            65163: [
                [
                    1574
                ],
                256
            ],
            65164: [
                [
                    1574
                ],
                256
            ],
            65165: [
                [
                    1575
                ],
                256
            ],
            65166: [
                [
                    1575
                ],
                256
            ],
            65167: [
                [
                    1576
                ],
                256
            ],
            65168: [
                [
                    1576
                ],
                256
            ],
            65169: [
                [
                    1576
                ],
                256
            ],
            65170: [
                [
                    1576
                ],
                256
            ],
            65171: [
                [
                    1577
                ],
                256
            ],
            65172: [
                [
                    1577
                ],
                256
            ],
            65173: [
                [
                    1578
                ],
                256
            ],
            65174: [
                [
                    1578
                ],
                256
            ],
            65175: [
                [
                    1578
                ],
                256
            ],
            65176: [
                [
                    1578
                ],
                256
            ],
            65177: [
                [
                    1579
                ],
                256
            ],
            65178: [
                [
                    1579
                ],
                256
            ],
            65179: [
                [
                    1579
                ],
                256
            ],
            65180: [
                [
                    1579
                ],
                256
            ],
            65181: [
                [
                    1580
                ],
                256
            ],
            65182: [
                [
                    1580
                ],
                256
            ],
            65183: [
                [
                    1580
                ],
                256
            ],
            65184: [
                [
                    1580
                ],
                256
            ],
            65185: [
                [
                    1581
                ],
                256
            ],
            65186: [
                [
                    1581
                ],
                256
            ],
            65187: [
                [
                    1581
                ],
                256
            ],
            65188: [
                [
                    1581
                ],
                256
            ],
            65189: [
                [
                    1582
                ],
                256
            ],
            65190: [
                [
                    1582
                ],
                256
            ],
            65191: [
                [
                    1582
                ],
                256
            ],
            65192: [
                [
                    1582
                ],
                256
            ],
            65193: [
                [
                    1583
                ],
                256
            ],
            65194: [
                [
                    1583
                ],
                256
            ],
            65195: [
                [
                    1584
                ],
                256
            ],
            65196: [
                [
                    1584
                ],
                256
            ],
            65197: [
                [
                    1585
                ],
                256
            ],
            65198: [
                [
                    1585
                ],
                256
            ],
            65199: [
                [
                    1586
                ],
                256
            ],
            65200: [
                [
                    1586
                ],
                256
            ],
            65201: [
                [
                    1587
                ],
                256
            ],
            65202: [
                [
                    1587
                ],
                256
            ],
            65203: [
                [
                    1587
                ],
                256
            ],
            65204: [
                [
                    1587
                ],
                256
            ],
            65205: [
                [
                    1588
                ],
                256
            ],
            65206: [
                [
                    1588
                ],
                256
            ],
            65207: [
                [
                    1588
                ],
                256
            ],
            65208: [
                [
                    1588
                ],
                256
            ],
            65209: [
                [
                    1589
                ],
                256
            ],
            65210: [
                [
                    1589
                ],
                256
            ],
            65211: [
                [
                    1589
                ],
                256
            ],
            65212: [
                [
                    1589
                ],
                256
            ],
            65213: [
                [
                    1590
                ],
                256
            ],
            65214: [
                [
                    1590
                ],
                256
            ],
            65215: [
                [
                    1590
                ],
                256
            ],
            65216: [
                [
                    1590
                ],
                256
            ],
            65217: [
                [
                    1591
                ],
                256
            ],
            65218: [
                [
                    1591
                ],
                256
            ],
            65219: [
                [
                    1591
                ],
                256
            ],
            65220: [
                [
                    1591
                ],
                256
            ],
            65221: [
                [
                    1592
                ],
                256
            ],
            65222: [
                [
                    1592
                ],
                256
            ],
            65223: [
                [
                    1592
                ],
                256
            ],
            65224: [
                [
                    1592
                ],
                256
            ],
            65225: [
                [
                    1593
                ],
                256
            ],
            65226: [
                [
                    1593
                ],
                256
            ],
            65227: [
                [
                    1593
                ],
                256
            ],
            65228: [
                [
                    1593
                ],
                256
            ],
            65229: [
                [
                    1594
                ],
                256
            ],
            65230: [
                [
                    1594
                ],
                256
            ],
            65231: [
                [
                    1594
                ],
                256
            ],
            65232: [
                [
                    1594
                ],
                256
            ],
            65233: [
                [
                    1601
                ],
                256
            ],
            65234: [
                [
                    1601
                ],
                256
            ],
            65235: [
                [
                    1601
                ],
                256
            ],
            65236: [
                [
                    1601
                ],
                256
            ],
            65237: [
                [
                    1602
                ],
                256
            ],
            65238: [
                [
                    1602
                ],
                256
            ],
            65239: [
                [
                    1602
                ],
                256
            ],
            65240: [
                [
                    1602
                ],
                256
            ],
            65241: [
                [
                    1603
                ],
                256
            ],
            65242: [
                [
                    1603
                ],
                256
            ],
            65243: [
                [
                    1603
                ],
                256
            ],
            65244: [
                [
                    1603
                ],
                256
            ],
            65245: [
                [
                    1604
                ],
                256
            ],
            65246: [
                [
                    1604
                ],
                256
            ],
            65247: [
                [
                    1604
                ],
                256
            ],
            65248: [
                [
                    1604
                ],
                256
            ],
            65249: [
                [
                    1605
                ],
                256
            ],
            65250: [
                [
                    1605
                ],
                256
            ],
            65251: [
                [
                    1605
                ],
                256
            ],
            65252: [
                [
                    1605
                ],
                256
            ],
            65253: [
                [
                    1606
                ],
                256
            ],
            65254: [
                [
                    1606
                ],
                256
            ],
            65255: [
                [
                    1606
                ],
                256
            ],
            65256: [
                [
                    1606
                ],
                256
            ],
            65257: [
                [
                    1607
                ],
                256
            ],
            65258: [
                [
                    1607
                ],
                256
            ],
            65259: [
                [
                    1607
                ],
                256
            ],
            65260: [
                [
                    1607
                ],
                256
            ],
            65261: [
                [
                    1608
                ],
                256
            ],
            65262: [
                [
                    1608
                ],
                256
            ],
            65263: [
                [
                    1609
                ],
                256
            ],
            65264: [
                [
                    1609
                ],
                256
            ],
            65265: [
                [
                    1610
                ],
                256
            ],
            65266: [
                [
                    1610
                ],
                256
            ],
            65267: [
                [
                    1610
                ],
                256
            ],
            65268: [
                [
                    1610
                ],
                256
            ],
            65269: [
                [
                    1604,
                    1570
                ],
                256
            ],
            65270: [
                [
                    1604,
                    1570
                ],
                256
            ],
            65271: [
                [
                    1604,
                    1571
                ],
                256
            ],
            65272: [
                [
                    1604,
                    1571
                ],
                256
            ],
            65273: [
                [
                    1604,
                    1573
                ],
                256
            ],
            65274: [
                [
                    1604,
                    1573
                ],
                256
            ],
            65275: [
                [
                    1604,
                    1575
                ],
                256
            ],
            65276: [
                [
                    1604,
                    1575
                ],
                256
            ]
        },
        65280: {
            65281: [
                [
                    33
                ],
                256
            ],
            65282: [
                [
                    34
                ],
                256
            ],
            65283: [
                [
                    35
                ],
                256
            ],
            65284: [
                [
                    36
                ],
                256
            ],
            65285: [
                [
                    37
                ],
                256
            ],
            65286: [
                [
                    38
                ],
                256
            ],
            65287: [
                [
                    39
                ],
                256
            ],
            65288: [
                [
                    40
                ],
                256
            ],
            65289: [
                [
                    41
                ],
                256
            ],
            65290: [
                [
                    42
                ],
                256
            ],
            65291: [
                [
                    43
                ],
                256
            ],
            65292: [
                [
                    44
                ],
                256
            ],
            65293: [
                [
                    45
                ],
                256
            ],
            65294: [
                [
                    46
                ],
                256
            ],
            65295: [
                [
                    47
                ],
                256
            ],
            65296: [
                [
                    48
                ],
                256
            ],
            65297: [
                [
                    49
                ],
                256
            ],
            65298: [
                [
                    50
                ],
                256
            ],
            65299: [
                [
                    51
                ],
                256
            ],
            65300: [
                [
                    52
                ],
                256
            ],
            65301: [
                [
                    53
                ],
                256
            ],
            65302: [
                [
                    54
                ],
                256
            ],
            65303: [
                [
                    55
                ],
                256
            ],
            65304: [
                [
                    56
                ],
                256
            ],
            65305: [
                [
                    57
                ],
                256
            ],
            65306: [
                [
                    58
                ],
                256
            ],
            65307: [
                [
                    59
                ],
                256
            ],
            65308: [
                [
                    60
                ],
                256
            ],
            65309: [
                [
                    61
                ],
                256
            ],
            65310: [
                [
                    62
                ],
                256
            ],
            65311: [
                [
                    63
                ],
                256
            ],
            65312: [
                [
                    64
                ],
                256
            ],
            65313: [
                [
                    65
                ],
                256
            ],
            65314: [
                [
                    66
                ],
                256
            ],
            65315: [
                [
                    67
                ],
                256
            ],
            65316: [
                [
                    68
                ],
                256
            ],
            65317: [
                [
                    69
                ],
                256
            ],
            65318: [
                [
                    70
                ],
                256
            ],
            65319: [
                [
                    71
                ],
                256
            ],
            65320: [
                [
                    72
                ],
                256
            ],
            65321: [
                [
                    73
                ],
                256
            ],
            65322: [
                [
                    74
                ],
                256
            ],
            65323: [
                [
                    75
                ],
                256
            ],
            65324: [
                [
                    76
                ],
                256
            ],
            65325: [
                [
                    77
                ],
                256
            ],
            65326: [
                [
                    78
                ],
                256
            ],
            65327: [
                [
                    79
                ],
                256
            ],
            65328: [
                [
                    80
                ],
                256
            ],
            65329: [
                [
                    81
                ],
                256
            ],
            65330: [
                [
                    82
                ],
                256
            ],
            65331: [
                [
                    83
                ],
                256
            ],
            65332: [
                [
                    84
                ],
                256
            ],
            65333: [
                [
                    85
                ],
                256
            ],
            65334: [
                [
                    86
                ],
                256
            ],
            65335: [
                [
                    87
                ],
                256
            ],
            65336: [
                [
                    88
                ],
                256
            ],
            65337: [
                [
                    89
                ],
                256
            ],
            65338: [
                [
                    90
                ],
                256
            ],
            65339: [
                [
                    91
                ],
                256
            ],
            65340: [
                [
                    92
                ],
                256
            ],
            65341: [
                [
                    93
                ],
                256
            ],
            65342: [
                [
                    94
                ],
                256
            ],
            65343: [
                [
                    95
                ],
                256
            ],
            65344: [
                [
                    96
                ],
                256
            ],
            65345: [
                [
                    97
                ],
                256
            ],
            65346: [
                [
                    98
                ],
                256
            ],
            65347: [
                [
                    99
                ],
                256
            ],
            65348: [
                [
                    100
                ],
                256
            ],
            65349: [
                [
                    101
                ],
                256
            ],
            65350: [
                [
                    102
                ],
                256
            ],
            65351: [
                [
                    103
                ],
                256
            ],
            65352: [
                [
                    104
                ],
                256
            ],
            65353: [
                [
                    105
                ],
                256
            ],
            65354: [
                [
                    106
                ],
                256
            ],
            65355: [
                [
                    107
                ],
                256
            ],
            65356: [
                [
                    108
                ],
                256
            ],
            65357: [
                [
                    109
                ],
                256
            ],
            65358: [
                [
                    110
                ],
                256
            ],
            65359: [
                [
                    111
                ],
                256
            ],
            65360: [
                [
                    112
                ],
                256
            ],
            65361: [
                [
                    113
                ],
                256
            ],
            65362: [
                [
                    114
                ],
                256
            ],
            65363: [
                [
                    115
                ],
                256
            ],
            65364: [
                [
                    116
                ],
                256
            ],
            65365: [
                [
                    117
                ],
                256
            ],
            65366: [
                [
                    118
                ],
                256
            ],
            65367: [
                [
                    119
                ],
                256
            ],
            65368: [
                [
                    120
                ],
                256
            ],
            65369: [
                [
                    121
                ],
                256
            ],
            65370: [
                [
                    122
                ],
                256
            ],
            65371: [
                [
                    123
                ],
                256
            ],
            65372: [
                [
                    124
                ],
                256
            ],
            65373: [
                [
                    125
                ],
                256
            ],
            65374: [
                [
                    126
                ],
                256
            ],
            65375: [
                [
                    10629
                ],
                256
            ],
            65376: [
                [
                    10630
                ],
                256
            ],
            65377: [
                [
                    12290
                ],
                256
            ],
            65378: [
                [
                    12300
                ],
                256
            ],
            65379: [
                [
                    12301
                ],
                256
            ],
            65380: [
                [
                    12289
                ],
                256
            ],
            65381: [
                [
                    12539
                ],
                256
            ],
            65382: [
                [
                    12530
                ],
                256
            ],
            65383: [
                [
                    12449
                ],
                256
            ],
            65384: [
                [
                    12451
                ],
                256
            ],
            65385: [
                [
                    12453
                ],
                256
            ],
            65386: [
                [
                    12455
                ],
                256
            ],
            65387: [
                [
                    12457
                ],
                256
            ],
            65388: [
                [
                    12515
                ],
                256
            ],
            65389: [
                [
                    12517
                ],
                256
            ],
            65390: [
                [
                    12519
                ],
                256
            ],
            65391: [
                [
                    12483
                ],
                256
            ],
            65392: [
                [
                    12540
                ],
                256
            ],
            65393: [
                [
                    12450
                ],
                256
            ],
            65394: [
                [
                    12452
                ],
                256
            ],
            65395: [
                [
                    12454
                ],
                256
            ],
            65396: [
                [
                    12456
                ],
                256
            ],
            65397: [
                [
                    12458
                ],
                256
            ],
            65398: [
                [
                    12459
                ],
                256
            ],
            65399: [
                [
                    12461
                ],
                256
            ],
            65400: [
                [
                    12463
                ],
                256
            ],
            65401: [
                [
                    12465
                ],
                256
            ],
            65402: [
                [
                    12467
                ],
                256
            ],
            65403: [
                [
                    12469
                ],
                256
            ],
            65404: [
                [
                    12471
                ],
                256
            ],
            65405: [
                [
                    12473
                ],
                256
            ],
            65406: [
                [
                    12475
                ],
                256
            ],
            65407: [
                [
                    12477
                ],
                256
            ],
            65408: [
                [
                    12479
                ],
                256
            ],
            65409: [
                [
                    12481
                ],
                256
            ],
            65410: [
                [
                    12484
                ],
                256
            ],
            65411: [
                [
                    12486
                ],
                256
            ],
            65412: [
                [
                    12488
                ],
                256
            ],
            65413: [
                [
                    12490
                ],
                256
            ],
            65414: [
                [
                    12491
                ],
                256
            ],
            65415: [
                [
                    12492
                ],
                256
            ],
            65416: [
                [
                    12493
                ],
                256
            ],
            65417: [
                [
                    12494
                ],
                256
            ],
            65418: [
                [
                    12495
                ],
                256
            ],
            65419: [
                [
                    12498
                ],
                256
            ],
            65420: [
                [
                    12501
                ],
                256
            ],
            65421: [
                [
                    12504
                ],
                256
            ],
            65422: [
                [
                    12507
                ],
                256
            ],
            65423: [
                [
                    12510
                ],
                256
            ],
            65424: [
                [
                    12511
                ],
                256
            ],
            65425: [
                [
                    12512
                ],
                256
            ],
            65426: [
                [
                    12513
                ],
                256
            ],
            65427: [
                [
                    12514
                ],
                256
            ],
            65428: [
                [
                    12516
                ],
                256
            ],
            65429: [
                [
                    12518
                ],
                256
            ],
            65430: [
                [
                    12520
                ],
                256
            ],
            65431: [
                [
                    12521
                ],
                256
            ],
            65432: [
                [
                    12522
                ],
                256
            ],
            65433: [
                [
                    12523
                ],
                256
            ],
            65434: [
                [
                    12524
                ],
                256
            ],
            65435: [
                [
                    12525
                ],
                256
            ],
            65436: [
                [
                    12527
                ],
                256
            ],
            65437: [
                [
                    12531
                ],
                256
            ],
            65438: [
                [
                    12441
                ],
                256
            ],
            65439: [
                [
                    12442
                ],
                256
            ],
            65440: [
                [
                    12644
                ],
                256
            ],
            65441: [
                [
                    12593
                ],
                256
            ],
            65442: [
                [
                    12594
                ],
                256
            ],
            65443: [
                [
                    12595
                ],
                256
            ],
            65444: [
                [
                    12596
                ],
                256
            ],
            65445: [
                [
                    12597
                ],
                256
            ],
            65446: [
                [
                    12598
                ],
                256
            ],
            65447: [
                [
                    12599
                ],
                256
            ],
            65448: [
                [
                    12600
                ],
                256
            ],
            65449: [
                [
                    12601
                ],
                256
            ],
            65450: [
                [
                    12602
                ],
                256
            ],
            65451: [
                [
                    12603
                ],
                256
            ],
            65452: [
                [
                    12604
                ],
                256
            ],
            65453: [
                [
                    12605
                ],
                256
            ],
            65454: [
                [
                    12606
                ],
                256
            ],
            65455: [
                [
                    12607
                ],
                256
            ],
            65456: [
                [
                    12608
                ],
                256
            ],
            65457: [
                [
                    12609
                ],
                256
            ],
            65458: [
                [
                    12610
                ],
                256
            ],
            65459: [
                [
                    12611
                ],
                256
            ],
            65460: [
                [
                    12612
                ],
                256
            ],
            65461: [
                [
                    12613
                ],
                256
            ],
            65462: [
                [
                    12614
                ],
                256
            ],
            65463: [
                [
                    12615
                ],
                256
            ],
            65464: [
                [
                    12616
                ],
                256
            ],
            65465: [
                [
                    12617
                ],
                256
            ],
            65466: [
                [
                    12618
                ],
                256
            ],
            65467: [
                [
                    12619
                ],
                256
            ],
            65468: [
                [
                    12620
                ],
                256
            ],
            65469: [
                [
                    12621
                ],
                256
            ],
            65470: [
                [
                    12622
                ],
                256
            ],
            65474: [
                [
                    12623
                ],
                256
            ],
            65475: [
                [
                    12624
                ],
                256
            ],
            65476: [
                [
                    12625
                ],
                256
            ],
            65477: [
                [
                    12626
                ],
                256
            ],
            65478: [
                [
                    12627
                ],
                256
            ],
            65479: [
                [
                    12628
                ],
                256
            ],
            65482: [
                [
                    12629
                ],
                256
            ],
            65483: [
                [
                    12630
                ],
                256
            ],
            65484: [
                [
                    12631
                ],
                256
            ],
            65485: [
                [
                    12632
                ],
                256
            ],
            65486: [
                [
                    12633
                ],
                256
            ],
            65487: [
                [
                    12634
                ],
                256
            ],
            65490: [
                [
                    12635
                ],
                256
            ],
            65491: [
                [
                    12636
                ],
                256
            ],
            65492: [
                [
                    12637
                ],
                256
            ],
            65493: [
                [
                    12638
                ],
                256
            ],
            65494: [
                [
                    12639
                ],
                256
            ],
            65495: [
                [
                    12640
                ],
                256
            ],
            65498: [
                [
                    12641
                ],
                256
            ],
            65499: [
                [
                    12642
                ],
                256
            ],
            65500: [
                [
                    12643
                ],
                256
            ],
            65504: [
                [
                    162
                ],
                256
            ],
            65505: [
                [
                    163
                ],
                256
            ],
            65506: [
                [
                    172
                ],
                256
            ],
            65507: [
                [
                    175
                ],
                256
            ],
            65508: [
                [
                    166
                ],
                256
            ],
            65509: [
                [
                    165
                ],
                256
            ],
            65510: [
                [
                    8361
                ],
                256
            ],
            65512: [
                [
                    9474
                ],
                256
            ],
            65513: [
                [
                    8592
                ],
                256
            ],
            65514: [
                [
                    8593
                ],
                256
            ],
            65515: [
                [
                    8594
                ],
                256
            ],
            65516: [
                [
                    8595
                ],
                256
            ],
            65517: [
                [
                    9632
                ],
                256
            ],
            65518: [
                [
                    9675
                ],
                256
            ]
        }
    };
    /***** Module to export */ var unorm = {
        nfc: nfc,
        nfd: nfd,
        nfkc: nfkc,
        nfkd: nfkd
    };
    module.exports = unorm;
    /***** Export as shim for String::normalize method *****/ /*
      http://wiki.ecmascript.org/doku.php?id=harmony:specification_drafts#november_8_2013_draft_rev_21

      21.1.3.12 String.prototype.normalize(form="NFC")
      When the normalize method is called with one argument form, the following steps are taken:

      1. Let O be CheckObjectCoercible(this value).
      2. Let S be ToString(O).
      3. ReturnIfAbrupt(S).
      4. If form is not provided or undefined let form be "NFC".
      5. Let f be ToString(form).
      6. ReturnIfAbrupt(f).
      7. If f is not one of "NFC", "NFD", "NFKC", or "NFKD", then throw a RangeError Exception.
      8. Let ns be the String value is the result of normalizing S into the normalization form named by f as specified in Unicode Standard Annex #15, UnicodeNormalizatoin Forms.
      9. Return ns.

      The length property of the normalize method is 0.

      *NOTE* The normalize function is intentionally generic; it does not require that its this value be a String object. Therefore it can be transferred to other kinds of objects for use as a method.
   */ unorm.shimApplied = false;
    if (!String.prototype.normalize) {
        Object.defineProperty(String.prototype, "normalize", {
            enumerable: false,
            configurable: true,
            writable: true,
            value: function normalize() {
                var str = "" + this;
                var form = arguments[0] === undefined ? "NFC" : arguments[0];
                if (this === null || this === undefined) throw new TypeError("Cannot call method on " + Object.prototype.toString.call(this));
                if (form === "NFC") return unorm.nfc(str);
                else if (form === "NFD") return unorm.nfd(str);
                else if (form === "NFKC") return unorm.nfkc(str);
                else if (form === "NFKD") return unorm.nfkd(str);
                else throw new RangeError("Invalid normalization form: " + form);
            }
        });
        unorm.shimApplied = true;
    }
})(module.exports);

});

parcelRequire.register("3DiD3", function(module, exports) {
"use strict";
var $2a5376ef00db0dea$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, {
        enumerable: true,
        get: function() {
            return m[k];
        }
    });
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $2a5376ef00db0dea$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $2a5376ef00db0dea$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $2a5376ef00db0dea$var$__createBinding(result, mod, k);
    }
    $2a5376ef00db0dea$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.EnglishMnemonic = void 0;

const $2a5376ef00db0dea$var$bip39 = $2a5376ef00db0dea$var$__importStar((parcelRequire("5qnT8")));
class $2a5376ef00db0dea$var$EnglishMnemonic {
    constructor(mnemonic){
        if (!$2a5376ef00db0dea$var$EnglishMnemonic.mnemonicMatcher.test(mnemonic)) throw new Error("Invalid mnemonic format");
        const words = mnemonic.split(" ");
        const allowedWordsLengths = [
            12,
            15,
            18,
            21,
            24
        ];
        if (allowedWordsLengths.indexOf(words.length) === -1) throw new Error(`Invalid word count in mnemonic (allowed: ${allowedWordsLengths} got: ${words.length})`);
        for (const word of words){
            if ($2a5376ef00db0dea$var$EnglishMnemonic.wordlist.indexOf(word) === -1) throw new Error("Mnemonic contains invalid word");
        }
        // Throws with informative error message if mnemonic is not valid
        $2a5376ef00db0dea$var$bip39.mnemonicToEntropy(mnemonic);
        this.data = mnemonic;
    }
    toString() {
        return this.data;
    }
}
module.exports.EnglishMnemonic = $2a5376ef00db0dea$var$EnglishMnemonic;
$2a5376ef00db0dea$var$EnglishMnemonic.wordlist = $2a5376ef00db0dea$var$bip39.wordlists.english;
// list of space separated lower case words (1 or more)
$2a5376ef00db0dea$var$EnglishMnemonic.mnemonicMatcher = /^[a-z]+( [a-z]+)*$/;

});


parcelRequire.register("7hF4v", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Hmac = void 0;
class $54d9faf009319ff9$var$Hmac {
    constructor(hashFunctionConstructor, originalKey){
        // This implementation is based on https://en.wikipedia.org/wiki/HMAC#Implementation
        // with the addition of incremental hashing support. Thus part of the algorithm
        // is in the constructor and the rest in digest().
        const blockSize = new hashFunctionConstructor().blockSize;
        this.hash = (data)=>new hashFunctionConstructor().update(data).digest();
        let key = originalKey;
        if (key.length > blockSize) key = this.hash(key);
        if (key.length < blockSize) {
            const zeroPadding = new Uint8Array(blockSize - key.length);
            key = new Uint8Array([
                ...key,
                ...zeroPadding
            ]);
        }
        // eslint-disable-next-line no-bitwise
        this.oKeyPad = key.map((keyByte)=>keyByte ^ 0x5c);
        // eslint-disable-next-line no-bitwise
        this.iKeyPad = key.map((keyByte)=>keyByte ^ 0x36);
        this.messageHasher = new hashFunctionConstructor();
        this.blockSize = blockSize;
        this.update(this.iKeyPad);
    }
    update(data) {
        this.messageHasher.update(data);
        return this;
    }
    digest() {
        const innerHash = this.messageHasher.digest();
        return this.hash(new Uint8Array([
            ...this.oKeyPad,
            ...innerHash
        ]));
    }
}
module.exports.Hmac = $54d9faf009319ff9$var$Hmac;

});

parcelRequire.register("aeAO9", function(module, exports) {
"use strict";
var $7737c37b0e7204b0$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.keccak256 = module.exports.Keccak256 = void 0;

const $7737c37b0e7204b0$var$js_sha3_1 = $7737c37b0e7204b0$var$__importDefault((parcelRequire("baOVG")));
class $7737c37b0e7204b0$var$Keccak256 {
    constructor(firstData){
        this.blockSize = 64;
        this.impl = $7737c37b0e7204b0$var$js_sha3_1.default.keccak256.create();
        if (firstData) this.update(firstData);
    }
    update(data) {
        this.impl.update(data);
        return this;
    }
    digest() {
        return new Uint8Array(this.impl.digest());
    }
}
module.exports.Keccak256 = $7737c37b0e7204b0$var$Keccak256;
/** Convenience function equivalent to `new Keccak256(data).digest()` */ function $7737c37b0e7204b0$var$keccak256(data) {
    return new $7737c37b0e7204b0$var$Keccak256(data).digest();
}
module.exports.keccak256 = $7737c37b0e7204b0$var$keccak256;

});

parcelRequire.register("g6P68", function(module, exports) {
"use strict";
// Keep all classes requiring libsodium-js in one file as having multiple
// requiring of the libsodium-wrappers module currently crashes browsers
//
// libsodium.js API: https://gist.github.com/webmaster128/b2dbe6d54d36dd168c9fabf441b9b09c
var $bba4d7da45c0902b$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Xchacha20poly1305Ietf = module.exports.xchacha20NonceLength = module.exports.Ed25519 = module.exports.Ed25519Keypair = module.exports.Argon2id = module.exports.isArgon2idOptions = void 0;

var $gYZZP = parcelRequire("gYZZP");

const $bba4d7da45c0902b$var$libsodium_wrappers_1 = $bba4d7da45c0902b$var$__importDefault((parcelRequire("dFkC5")));
function $bba4d7da45c0902b$var$isArgon2idOptions(thing) {
    if (!$gYZZP.isNonNullObject(thing)) return false;
    if (typeof thing.outputLength !== "number") return false;
    if (typeof thing.opsLimit !== "number") return false;
    if (typeof thing.memLimitKib !== "number") return false;
    return true;
}
module.exports.isArgon2idOptions = $bba4d7da45c0902b$var$isArgon2idOptions;
class $bba4d7da45c0902b$var$Argon2id {
    static async execute(password, salt, options) {
        await $bba4d7da45c0902b$var$libsodium_wrappers_1.default.ready;
        return $bba4d7da45c0902b$var$libsodium_wrappers_1.default.crypto_pwhash(options.outputLength, password, salt, options.opsLimit, options.memLimitKib * 1024, $bba4d7da45c0902b$var$libsodium_wrappers_1.default.crypto_pwhash_ALG_ARGON2ID13);
    }
}
module.exports.Argon2id = $bba4d7da45c0902b$var$Argon2id;
class $bba4d7da45c0902b$var$Ed25519Keypair {
    constructor(privkey, pubkey){
        this.privkey = privkey;
        this.pubkey = pubkey;
    }
    // a libsodium privkey has the format `<ed25519 privkey> + <ed25519 pubkey>`
    static fromLibsodiumPrivkey(libsodiumPrivkey) {
        if (libsodiumPrivkey.length !== 64) throw new Error(`Unexpected key length ${libsodiumPrivkey.length}. Must be 64.`);
        return new $bba4d7da45c0902b$var$Ed25519Keypair(libsodiumPrivkey.slice(0, 32), libsodiumPrivkey.slice(32, 64));
    }
    toLibsodiumPrivkey() {
        return new Uint8Array([
            ...this.privkey,
            ...this.pubkey
        ]);
    }
}
module.exports.Ed25519Keypair = $bba4d7da45c0902b$var$Ed25519Keypair;
class $bba4d7da45c0902b$var$Ed25519 {
    /**
     * Generates a keypair deterministically from a given 32 bytes seed.
     *
     * This seed equals the Ed25519 private key.
     * For implementation details see crypto_sign_seed_keypair in
     * https://download.libsodium.org/doc/public-key_cryptography/public-key_signatures.html
     * and diagram on https://blog.mozilla.org/warner/2011/11/29/ed25519-keys/
     */ static async makeKeypair(seed) {
        await $bba4d7da45c0902b$var$libsodium_wrappers_1.default.ready;
        const keypair = $bba4d7da45c0902b$var$libsodium_wrappers_1.default.crypto_sign_seed_keypair(seed);
        return $bba4d7da45c0902b$var$Ed25519Keypair.fromLibsodiumPrivkey(keypair.privateKey);
    }
    static async createSignature(message, keyPair) {
        await $bba4d7da45c0902b$var$libsodium_wrappers_1.default.ready;
        return $bba4d7da45c0902b$var$libsodium_wrappers_1.default.crypto_sign_detached(message, keyPair.toLibsodiumPrivkey());
    }
    static async verifySignature(signature, message, pubkey) {
        await $bba4d7da45c0902b$var$libsodium_wrappers_1.default.ready;
        return $bba4d7da45c0902b$var$libsodium_wrappers_1.default.crypto_sign_verify_detached(signature, message, pubkey);
    }
}
module.exports.Ed25519 = $bba4d7da45c0902b$var$Ed25519;
/**
 * Nonce length in bytes for all flavours of XChaCha20.
 *
 * @see https://libsodium.gitbook.io/doc/advanced/stream_ciphers/xchacha20#notes
 */ module.exports.xchacha20NonceLength = 24;
class $bba4d7da45c0902b$var$Xchacha20poly1305Ietf {
    static async encrypt(message, key, nonce) {
        await $bba4d7da45c0902b$var$libsodium_wrappers_1.default.ready;
        const additionalData = null;
        return $bba4d7da45c0902b$var$libsodium_wrappers_1.default.crypto_aead_xchacha20poly1305_ietf_encrypt(message, additionalData, null, nonce, key);
    }
    static async decrypt(ciphertext, key, nonce) {
        await $bba4d7da45c0902b$var$libsodium_wrappers_1.default.ready;
        const additionalData = null;
        return $bba4d7da45c0902b$var$libsodium_wrappers_1.default.crypto_aead_xchacha20poly1305_ietf_decrypt(null, ciphertext, additionalData, nonce, key);
    }
}
module.exports.Xchacha20poly1305Ietf = $bba4d7da45c0902b$var$Xchacha20poly1305Ietf;

});

parcelRequire.register("92Wnp", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Random = void 0;

class $69619554f1edc8db$var$Random {
    /**
     * Returns `count` cryptographically secure random bytes
     */ static getBytes(count) {
        try {
            const globalObject = typeof window === "object" ? window : self;
            const cryptoApi = typeof globalObject.crypto !== "undefined" ? globalObject.crypto : globalObject.msCrypto;
            const out = new Uint8Array(count);
            cryptoApi.getRandomValues(out);
            return out;
        } catch (_a) {
            try {
                // eslint-disable-next-line @typescript-eslint/no-var-requires
                const crypto = (parcelRequire("aO8Ot"));
                return new Uint8Array([
                    ...crypto.randomBytes(count)
                ]);
            } catch (_b) {
                throw new Error("No secure random number generator found");
            }
        }
    }
}
module.exports.Random = $69619554f1edc8db$var$Random;

});

parcelRequire.register("88X8r", function(module, exports) {

var $ihoyg = parcelRequire("ihoyg");
var $5edcf11c8259c76a$require$Buffer = $ihoyg.Buffer;
"use strict";
var $5edcf11c8259c76a$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ripemd160 = module.exports.Ripemd160 = void 0;

const $5edcf11c8259c76a$var$ripemd160_1 = $5edcf11c8259c76a$var$__importDefault((parcelRequire("cjuEr")));
class $5edcf11c8259c76a$var$Ripemd160 {
    constructor(firstData){
        this.blockSize = 64;
        this.impl = new $5edcf11c8259c76a$var$ripemd160_1.default();
        if (firstData) this.update(firstData);
    }
    update(data) {
        this.impl.update($5edcf11c8259c76a$require$Buffer.from(data));
        return this;
    }
    digest() {
        return Uint8Array.from(this.impl.digest());
    }
}
module.exports.Ripemd160 = $5edcf11c8259c76a$var$Ripemd160;
/** Convenience function equivalent to `new Ripemd160(data).digest()` */ function $5edcf11c8259c76a$var$ripemd160(data) {
    return new $5edcf11c8259c76a$var$Ripemd160(data).digest();
}
module.exports.ripemd160 = $5edcf11c8259c76a$var$ripemd160;

});

parcelRequire.register("b0p5V", function(module, exports) {
"use strict";
var $8033290d9683dbb5$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Secp256k1 = void 0;

var $5a6Ix = parcelRequire("5a6Ix");

const $8033290d9683dbb5$var$bn_js_1 = $8033290d9683dbb5$var$__importDefault((parcelRequire("7vYz3")));

const $8033290d9683dbb5$var$elliptic_1 = $8033290d9683dbb5$var$__importDefault((parcelRequire("8J1ou")));

var $g8uts = parcelRequire("g8uts");
const $8033290d9683dbb5$var$secp256k1 = new $8033290d9683dbb5$var$elliptic_1.default.ec("secp256k1");
const $8033290d9683dbb5$var$secp256k1N = new $8033290d9683dbb5$var$bn_js_1.default("FFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFEBAAEDCE6AF48A03BBFD25E8CD0364141", "hex");
class $8033290d9683dbb5$var$Secp256k1 {
    static async makeKeypair(privkey) {
        if (privkey.length !== 32) // is this check missing in secp256k1.validatePrivateKey?
        // https://github.com/bitjson/bitcoin-ts/issues/4
        throw new Error("input data is not a valid secp256k1 private key");
        const keypair = $8033290d9683dbb5$var$secp256k1.keyFromPrivate(privkey);
        if (keypair.validate().result !== true) throw new Error("input data is not a valid secp256k1 private key");
        // range test that is not part of the elliptic implementation
        const privkeyAsBigInteger = new $8033290d9683dbb5$var$bn_js_1.default(privkey);
        if (privkeyAsBigInteger.gte($8033290d9683dbb5$var$secp256k1N)) // not strictly smaller than N
        throw new Error("input data is not a valid secp256k1 private key");
        const out = {
            privkey: $5a6Ix.fromHex(keypair.getPrivate("hex")),
            // encodes uncompressed as
            // - 1-byte prefix "04"
            // - 32-byte x coordinate
            // - 32-byte y coordinate
            pubkey: Uint8Array.from(keypair.getPublic("array"))
        };
        return out;
    }
    // Creates a signature that is
    // - deterministic (RFC 6979)
    // - lowS signature
    // - DER encoded
    static async createSignature(messageHash, privkey) {
        if (messageHash.length === 0) throw new Error("Message hash must not be empty");
        if (messageHash.length > 32) throw new Error("Message hash length must not exceed 32 bytes");
        const keypair = $8033290d9683dbb5$var$secp256k1.keyFromPrivate(privkey);
        // the `canonical` option ensures creation of lowS signature representations
        const { r: r, s: s, recoveryParam: recoveryParam } = keypair.sign(messageHash, {
            canonical: true
        });
        if (typeof recoveryParam !== "number") throw new Error("Recovery param missing");
        return new $g8uts.ExtendedSecp256k1Signature(Uint8Array.from(r.toArray()), Uint8Array.from(s.toArray()), recoveryParam);
    }
    static async verifySignature(signature, messageHash, pubkey) {
        if (messageHash.length === 0) throw new Error("Message hash must not be empty");
        if (messageHash.length > 32) throw new Error("Message hash length must not exceed 32 bytes");
        const keypair = $8033290d9683dbb5$var$secp256k1.keyFromPublic(pubkey);
        // From https://github.com/indutny/elliptic:
        //
        //     Sign the message's hash (input must be an array, or a hex-string)
        //
        //     Signature MUST be either:
        //     1) DER-encoded signature as hex-string; or
        //     2) DER-encoded signature as buffer; or
        //     3) object with two hex-string properties (r and s); or
        //     4) object with two buffer properties (r and s)
        //
        // Uint8Array is not a Buffer, but elliptic seems to be happy with the interface
        // common to both types. Uint8Array is not an array of ints but the interface is
        // similar
        try {
            return keypair.verify(messageHash, signature.toDer());
        } catch (error) {
            return false;
        }
    }
    static recoverPubkey(signature, messageHash) {
        const signatureForElliptic = {
            r: $5a6Ix.toHex(signature.r()),
            s: $5a6Ix.toHex(signature.s())
        };
        const point = $8033290d9683dbb5$var$secp256k1.recoverPubKey(messageHash, signatureForElliptic, signature.recovery);
        const keypair = $8033290d9683dbb5$var$secp256k1.keyFromPublic(point);
        return $5a6Ix.fromHex(keypair.getPublic(false, "hex"));
    }
    static compressPubkey(pubkey) {
        switch(pubkey.length){
            case 33:
                return pubkey;
            case 65:
                return Uint8Array.from($8033290d9683dbb5$var$secp256k1.keyFromPublic(pubkey).getPublic(true, "array"));
            default:
                throw new Error("Invalid pubkey length");
        }
    }
    static trimRecoveryByte(signature) {
        switch(signature.length){
            case 64:
                return signature;
            case 65:
                return signature.slice(0, 64);
            default:
                throw new Error("Invalid signature length");
        }
    }
}
module.exports.Secp256k1 = $8033290d9683dbb5$var$Secp256k1;

});
parcelRequire.register("g8uts", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ExtendedSecp256k1Signature = module.exports.Secp256k1Signature = void 0;
function $bbf5083704d1300d$var$trimLeadingNullBytes(inData) {
    let numberOfLeadingNullBytes = 0;
    for (const byte of inData){
        if (byte === 0x00) numberOfLeadingNullBytes++;
        else break;
    }
    return inData.slice(numberOfLeadingNullBytes);
}
const $bbf5083704d1300d$var$derTagInteger = 0x02;
class $bbf5083704d1300d$var$Secp256k1Signature {
    constructor(r, s){
        if (r.length > 32 || r.length === 0 || r[0] === 0x00) throw new Error("Unsigned integer r must be encoded as unpadded big endian.");
        if (s.length > 32 || s.length === 0 || s[0] === 0x00) throw new Error("Unsigned integer s must be encoded as unpadded big endian.");
        this.data = {
            r: r,
            s: s
        };
    }
    /**
     * Takes the pair of integers (r, s) as 2x32 byte of binary data.
     *
     * Note: This is the format Cosmos SDK uses natively.
     *
     * @param data a 64 byte value containing integers r and s.
     */ static fromFixedLength(data) {
        if (data.length !== 64) throw new Error(`Got invalid data length: ${data.length}. Expected 2x 32 bytes for the pair (r, s)`);
        return new $bbf5083704d1300d$var$Secp256k1Signature($bbf5083704d1300d$var$trimLeadingNullBytes(data.slice(0, 32)), $bbf5083704d1300d$var$trimLeadingNullBytes(data.slice(32, 64)));
    }
    static fromDer(data) {
        let pos = 0;
        if (data[pos++] !== 0x30) throw new Error("Prefix 0x30 expected");
        const bodyLength = data[pos++];
        if (data.length - pos !== bodyLength) throw new Error("Data length mismatch detected");
        // r
        const rTag = data[pos++];
        if (rTag !== $bbf5083704d1300d$var$derTagInteger) throw new Error("INTEGER tag expected");
        const rLength = data[pos++];
        if (rLength >= 0x80) throw new Error("Decoding length values above 127 not supported");
        const rData = data.slice(pos, pos + rLength);
        pos += rLength;
        // s
        const sTag = data[pos++];
        if (sTag !== $bbf5083704d1300d$var$derTagInteger) throw new Error("INTEGER tag expected");
        const sLength = data[pos++];
        if (sLength >= 0x80) throw new Error("Decoding length values above 127 not supported");
        const sData = data.slice(pos, pos + sLength);
        pos += sLength;
        return new $bbf5083704d1300d$var$Secp256k1Signature(// r/s data can contain leading 0 bytes to express integers being non-negative in DER
        $bbf5083704d1300d$var$trimLeadingNullBytes(rData), $bbf5083704d1300d$var$trimLeadingNullBytes(sData));
    }
    r(length) {
        if (length === undefined) return this.data.r;
        else {
            const paddingLength = length - this.data.r.length;
            if (paddingLength < 0) throw new Error("Length too small to hold parameter r");
            const padding = new Uint8Array(paddingLength);
            return new Uint8Array([
                ...padding,
                ...this.data.r
            ]);
        }
    }
    s(length) {
        if (length === undefined) return this.data.s;
        else {
            const paddingLength = length - this.data.s.length;
            if (paddingLength < 0) throw new Error("Length too small to hold parameter s");
            const padding = new Uint8Array(paddingLength);
            return new Uint8Array([
                ...padding,
                ...this.data.s
            ]);
        }
    }
    toFixedLength() {
        return new Uint8Array([
            ...this.r(32),
            ...this.s(32)
        ]);
    }
    toDer() {
        // DER supports negative integers but our data is unsigned. Thus we need to prepend
        // a leading 0 byte when the higest bit is set to differentiate nagative values
        const rEncoded = this.data.r[0] >= 0x80 ? new Uint8Array([
            0,
            ...this.data.r
        ]) : this.data.r;
        const sEncoded = this.data.s[0] >= 0x80 ? new Uint8Array([
            0,
            ...this.data.s
        ]) : this.data.s;
        const rLength = rEncoded.length;
        const sLength = sEncoded.length;
        const data = new Uint8Array([
            $bbf5083704d1300d$var$derTagInteger,
            rLength,
            ...rEncoded,
            $bbf5083704d1300d$var$derTagInteger,
            sLength,
            ...sEncoded
        ]);
        return new Uint8Array([
            0x30,
            data.length,
            ...data
        ]);
    }
}
module.exports.Secp256k1Signature = $bbf5083704d1300d$var$Secp256k1Signature;
/**
 * A Secp256k1Signature plus the recovery parameter
 */ class $bbf5083704d1300d$var$ExtendedSecp256k1Signature extends $bbf5083704d1300d$var$Secp256k1Signature {
    constructor(r, s, recovery){
        super(r, s);
        if (!Number.isInteger(recovery)) throw new Error("The recovery parameter must be an integer.");
        if (recovery < 0 || recovery > 4) throw new Error("The recovery parameter must be one of 0, 1, 2, 3.");
        this.recovery = recovery;
    }
    /**
     * Decode extended signature from the simple fixed length encoding
     * described in toFixedLength().
     */ static fromFixedLength(data) {
        if (data.length !== 65) throw new Error(`Got invalid data length ${data.length}. Expected 32 + 32 + 1`);
        return new $bbf5083704d1300d$var$ExtendedSecp256k1Signature($bbf5083704d1300d$var$trimLeadingNullBytes(data.slice(0, 32)), $bbf5083704d1300d$var$trimLeadingNullBytes(data.slice(32, 64)), data[64]);
    }
    /**
     * A simple custom encoding that encodes the extended signature as
     * r (32 bytes) | s (32 bytes) | recovery param (1 byte)
     * where | denotes concatenation of bonary data.
     */ toFixedLength() {
        return new Uint8Array([
            ...this.r(32),
            ...this.s(32),
            this.recovery
        ]);
    }
}
module.exports.ExtendedSecp256k1Signature = $bbf5083704d1300d$var$ExtendedSecp256k1Signature;

});


parcelRequire.register("1tSAh", function(module, exports) {
"use strict";
var $1142d72cf205c336$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.sha512 = module.exports.Sha512 = module.exports.sha256 = module.exports.Sha256 = module.exports.sha1 = module.exports.Sha1 = void 0;

const $1142d72cf205c336$var$sha_js_1 = $1142d72cf205c336$var$__importDefault((parcelRequire("fkJVr")));
class $1142d72cf205c336$var$Sha1 {
    constructor(firstData){
        this.blockSize = 64;
        this.impl = $1142d72cf205c336$var$sha_js_1.default("sha1");
        if (firstData) this.update(firstData);
    }
    update(data) {
        this.impl.update(data);
        return this;
    }
    digest() {
        return new Uint8Array(this.impl.digest());
    }
}
module.exports.Sha1 = $1142d72cf205c336$var$Sha1;
/** Convenience function equivalent to `new Sha1(data).digest()` */ function $1142d72cf205c336$var$sha1(data) {
    return new $1142d72cf205c336$var$Sha1(data).digest();
}
module.exports.sha1 = $1142d72cf205c336$var$sha1;
class $1142d72cf205c336$var$Sha256 {
    constructor(firstData){
        this.blockSize = 64;
        this.impl = $1142d72cf205c336$var$sha_js_1.default("sha256");
        if (firstData) this.update(firstData);
    }
    update(data) {
        this.impl.update(data);
        return this;
    }
    digest() {
        return new Uint8Array(this.impl.digest());
    }
}
module.exports.Sha256 = $1142d72cf205c336$var$Sha256;
/** Convenience function equivalent to `new Sha256(data).digest()` */ function $1142d72cf205c336$var$sha256(data) {
    return new $1142d72cf205c336$var$Sha256(data).digest();
}
module.exports.sha256 = $1142d72cf205c336$var$sha256;
class $1142d72cf205c336$var$Sha512 {
    constructor(firstData){
        this.blockSize = 128;
        this.impl = $1142d72cf205c336$var$sha_js_1.default("sha512");
        if (firstData) this.update(firstData);
    }
    update(data) {
        this.impl.update(data);
        return this;
    }
    digest() {
        return new Uint8Array(this.impl.digest());
    }
}
module.exports.Sha512 = $1142d72cf205c336$var$Sha512;
/** Convenience function equivalent to `new Sha512(data).digest()` */ function $1142d72cf205c336$var$sha512(data) {
    return new $1142d72cf205c336$var$Sha512(data).digest();
}
module.exports.sha512 = $1142d72cf205c336$var$sha512;

});

parcelRequire.register("gZgao", function(module, exports) {
"use strict";
var $c5dee239d2889113$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.stringToPath = module.exports.pathToString = module.exports.Slip10 = module.exports.Slip10RawIndex = module.exports.slip10CurveFromString = module.exports.Slip10Curve = void 0;

var $5a6Ix = parcelRequire("5a6Ix");

var $2lWwp = parcelRequire("2lWwp");

const $c5dee239d2889113$var$bn_js_1 = $c5dee239d2889113$var$__importDefault((parcelRequire("7vYz3")));

const $c5dee239d2889113$var$elliptic_1 = $c5dee239d2889113$var$__importDefault((parcelRequire("8J1ou")));

var $7hF4v = parcelRequire("7hF4v");

var $1tSAh = parcelRequire("1tSAh");
/**
 * Raw values must match the curve string in SLIP-0010 master key generation
 *
 * @see https://github.com/satoshilabs/slips/blob/master/slip-0010.md#master-key-generation
 */ var $c5dee239d2889113$var$Slip10Curve;
(function(Slip10Curve) {
    Slip10Curve["Secp256k1"] = "Bitcoin seed";
    Slip10Curve["Ed25519"] = "ed25519 seed";
})($c5dee239d2889113$var$Slip10Curve = module.exports.Slip10Curve || (module.exports.Slip10Curve = {}));
/**
 * Reverse mapping of Slip10Curve
 */ function $c5dee239d2889113$var$slip10CurveFromString(curveString) {
    switch(curveString){
        case $c5dee239d2889113$var$Slip10Curve.Ed25519:
            return $c5dee239d2889113$var$Slip10Curve.Ed25519;
        case $c5dee239d2889113$var$Slip10Curve.Secp256k1:
            return $c5dee239d2889113$var$Slip10Curve.Secp256k1;
        default:
            throw new Error(`Unknown curve string: '${curveString}'`);
    }
}
module.exports.slip10CurveFromString = $c5dee239d2889113$var$slip10CurveFromString;
class $c5dee239d2889113$var$Slip10RawIndex extends $2lWwp.Uint32 {
    static hardened(hardenedIndex) {
        return new $c5dee239d2889113$var$Slip10RawIndex(hardenedIndex + 2 ** 31);
    }
    static normal(normalIndex) {
        return new $c5dee239d2889113$var$Slip10RawIndex(normalIndex);
    }
    isHardened() {
        return this.data >= 2 ** 31;
    }
}
module.exports.Slip10RawIndex = $c5dee239d2889113$var$Slip10RawIndex;
const $c5dee239d2889113$var$secp256k1 = new $c5dee239d2889113$var$elliptic_1.default.ec("secp256k1");
// Universal private key derivation accoring to
// https://github.com/satoshilabs/slips/blob/master/slip-0010.md
class $c5dee239d2889113$var$Slip10 {
    static derivePath(curve, seed, path) {
        let result = this.master(curve, seed);
        for (const rawIndex of path)result = this.child(curve, result.privkey, result.chainCode, rawIndex);
        return result;
    }
    static master(curve, seed) {
        const i = new $7hF4v.Hmac($1tSAh.Sha512, $5a6Ix.toAscii(curve)).update(seed).digest();
        const il = i.slice(0, 32);
        const ir = i.slice(32, 64);
        if (curve !== $c5dee239d2889113$var$Slip10Curve.Ed25519 && (this.isZero(il) || this.isGteN(curve, il))) return this.master(curve, i);
        return {
            chainCode: ir,
            privkey: il
        };
    }
    static child(curve, parentPrivkey, parentChainCode, rawIndex) {
        let i;
        if (rawIndex.isHardened()) {
            const payload = new Uint8Array([
                0x00,
                ...parentPrivkey,
                ...rawIndex.toBytesBigEndian()
            ]);
            i = new $7hF4v.Hmac($1tSAh.Sha512, parentChainCode).update(payload).digest();
        } else {
            if (curve === $c5dee239d2889113$var$Slip10Curve.Ed25519) throw new Error("Normal keys are not allowed with ed25519");
            else {
                // Step 1 of https://github.com/satoshilabs/slips/blob/master/slip-0010.md#private-parent-key--private-child-key
                // Calculate I = HMAC-SHA512(Key = c_par, Data = ser_P(point(k_par)) || ser_32(i)).
                // where the functions point() and ser_p() are defined in BIP-0032
                const data = new Uint8Array([
                    ...$c5dee239d2889113$var$Slip10.serializedPoint(curve, new $c5dee239d2889113$var$bn_js_1.default(parentPrivkey)),
                    ...rawIndex.toBytesBigEndian()
                ]);
                i = new $7hF4v.Hmac($1tSAh.Sha512, parentChainCode).update(data).digest();
            }
        }
        return this.childImpl(curve, parentPrivkey, parentChainCode, rawIndex, i);
    }
    /**
     * Implementation of ser_P(point(k_par)) from BIP-0032
     *
     * @see https://github.com/bitcoin/bips/blob/master/bip-0032.mediawiki
     */ static serializedPoint(curve, p) {
        switch(curve){
            case $c5dee239d2889113$var$Slip10Curve.Secp256k1:
                return $5a6Ix.fromHex($c5dee239d2889113$var$secp256k1.g.mul(p).encodeCompressed("hex"));
            default:
                throw new Error("curve not supported");
        }
    }
    static childImpl(curve, parentPrivkey, parentChainCode, rawIndex, i) {
        // step 2 (of the Private parent key → private child key algorithm)
        const il = i.slice(0, 32);
        const ir = i.slice(32, 64);
        // step 3
        const returnChainCode = ir;
        // step 4
        if (curve === $c5dee239d2889113$var$Slip10Curve.Ed25519) return {
            chainCode: returnChainCode,
            privkey: il
        };
        // step 5
        const n = this.n(curve);
        const returnChildKeyAsNumber = new $c5dee239d2889113$var$bn_js_1.default(il).add(new $c5dee239d2889113$var$bn_js_1.default(parentPrivkey)).mod(n);
        const returnChildKey = Uint8Array.from(returnChildKeyAsNumber.toArray("be", 32));
        // step 6
        if (this.isGteN(curve, il) || this.isZero(returnChildKey)) {
            const newI = new $7hF4v.Hmac($1tSAh.Sha512, parentChainCode).update(new Uint8Array([
                0x01,
                ...ir,
                ...rawIndex.toBytesBigEndian()
            ])).digest();
            return this.childImpl(curve, parentPrivkey, parentChainCode, rawIndex, newI);
        }
        // step 7
        return {
            chainCode: returnChainCode,
            privkey: returnChildKey
        };
    }
    static isZero(privkey) {
        return privkey.every((byte)=>byte === 0);
    }
    static isGteN(curve, privkey) {
        const keyAsNumber = new $c5dee239d2889113$var$bn_js_1.default(privkey);
        return keyAsNumber.gte(this.n(curve));
    }
    static n(curve) {
        switch(curve){
            case $c5dee239d2889113$var$Slip10Curve.Secp256k1:
                return new $c5dee239d2889113$var$bn_js_1.default("FFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFEBAAEDCE6AF48A03BBFD25E8CD0364141", 16);
            default:
                throw new Error("curve not supported");
        }
    }
}
module.exports.Slip10 = $c5dee239d2889113$var$Slip10;
function $c5dee239d2889113$var$pathToString(path) {
    return path.reduce((current, component)=>{
        const componentString = component.isHardened() ? `${component.toNumber() - 2 ** 31}'` : component.toString();
        return current + "/" + componentString;
    }, "m");
}
module.exports.pathToString = $c5dee239d2889113$var$pathToString;
function $c5dee239d2889113$var$stringToPath(input) {
    if (!input.startsWith("m")) throw new Error("Path string must start with 'm'");
    let rest = input.slice(1);
    const out = new Array();
    while(rest){
        const match = rest.match(/^\/([0-9]+)('?)/);
        if (!match) throw new Error("Syntax error while reading path component");
        const [fullMatch, numberString, apostrophe] = match;
        const value = $2lWwp.Uint53.fromString(numberString).toNumber();
        if (value >= 2 ** 31) throw new Error("Component value too high. Must not exceed 2**31-1.");
        if (apostrophe) out.push($c5dee239d2889113$var$Slip10RawIndex.hardened(value));
        else out.push($c5dee239d2889113$var$Slip10RawIndex.normal(value));
        rest = rest.slice(fullMatch.length);
    }
    return out;
}
module.exports.stringToPath = $c5dee239d2889113$var$stringToPath;

});
parcelRequire.register("2lWwp", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Uint64 = module.exports.Uint53 = module.exports.Uint32 = module.exports.Int53 = module.exports.Decimal = void 0;

var $cD7dH = parcelRequire("cD7dH");
Object.defineProperty(module.exports, "Decimal", {
    enumerable: true,
    get: function() {
        return $cD7dH.Decimal;
    }
});

var $beE5F = parcelRequire("beE5F");
Object.defineProperty(module.exports, "Int53", {
    enumerable: true,
    get: function() {
        return $beE5F.Int53;
    }
});
Object.defineProperty(module.exports, "Uint32", {
    enumerable: true,
    get: function() {
        return $beE5F.Uint32;
    }
});
Object.defineProperty(module.exports, "Uint53", {
    enumerable: true,
    get: function() {
        return $beE5F.Uint53;
    }
});
Object.defineProperty(module.exports, "Uint64", {
    enumerable: true,
    get: function() {
        return $beE5F.Uint64;
    }
});

});
parcelRequire.register("cD7dH", function(module, exports) {
"use strict";
var $931eba43e1c6e444$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Decimal = void 0;

const $931eba43e1c6e444$var$bn_js_1 = $931eba43e1c6e444$var$__importDefault((parcelRequire("7vYz3")));
// Too large values lead to massive memory usage. Limit to something sensible.
// The largest value we need is 18 (Ether).
const $931eba43e1c6e444$var$maxFractionalDigits = 100;
/**
 * A type for arbitrary precision, non-negative decimals.
 *
 * Instances of this class are immutable.
 */ class $931eba43e1c6e444$var$Decimal {
    constructor(atomics, fractionalDigits){
        this.data = {
            atomics: new $931eba43e1c6e444$var$bn_js_1.default(atomics),
            fractionalDigits: fractionalDigits
        };
    }
    static fromUserInput(input, fractionalDigits) {
        $931eba43e1c6e444$var$Decimal.verifyFractionalDigits(fractionalDigits);
        const badCharacter = input.match(/[^0-9.]/);
        if (badCharacter) // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        throw new Error(`Invalid character at position ${badCharacter.index + 1}`);
        let whole;
        let fractional;
        if (input.search(/\./) === -1) {
            // integer format, no separator
            whole = input;
            fractional = "";
        } else {
            const parts = input.split(".");
            switch(parts.length){
                case 0:
                case 1:
                    throw new Error("Fewer than two elements in split result. This must not happen here.");
                case 2:
                    if (!parts[1]) throw new Error("Fractional part missing");
                    whole = parts[0];
                    fractional = parts[1].replace(/0+$/, "");
                    break;
                default:
                    throw new Error("More than one separator found");
            }
        }
        if (fractional.length > fractionalDigits) throw new Error("Got more fractional digits than supported");
        const quantity = `${whole}${fractional.padEnd(fractionalDigits, "0")}`;
        return new $931eba43e1c6e444$var$Decimal(quantity, fractionalDigits);
    }
    static fromAtomics(atomics, fractionalDigits) {
        $931eba43e1c6e444$var$Decimal.verifyFractionalDigits(fractionalDigits);
        return new $931eba43e1c6e444$var$Decimal(atomics, fractionalDigits);
    }
    static verifyFractionalDigits(fractionalDigits) {
        if (!Number.isInteger(fractionalDigits)) throw new Error("Fractional digits is not an integer");
        if (fractionalDigits < 0) throw new Error("Fractional digits must not be negative");
        if (fractionalDigits > $931eba43e1c6e444$var$maxFractionalDigits) throw new Error(`Fractional digits must not exceed ${$931eba43e1c6e444$var$maxFractionalDigits}`);
    }
    static compare(a, b) {
        if (a.fractionalDigits !== b.fractionalDigits) throw new Error("Fractional digits do not match");
        return a.data.atomics.cmp(new $931eba43e1c6e444$var$bn_js_1.default(b.atomics));
    }
    get atomics() {
        return this.data.atomics.toString();
    }
    get fractionalDigits() {
        return this.data.fractionalDigits;
    }
    toString() {
        const factor = new $931eba43e1c6e444$var$bn_js_1.default(10).pow(new $931eba43e1c6e444$var$bn_js_1.default(this.data.fractionalDigits));
        const whole = this.data.atomics.div(factor);
        const fractional = this.data.atomics.mod(factor);
        if (fractional.isZero()) return whole.toString();
        else {
            const fullFractionalPart = fractional.toString().padStart(this.data.fractionalDigits, "0");
            const trimmedFractionalPart = fullFractionalPart.replace(/0+$/, "");
            return `${whole.toString()}.${trimmedFractionalPart}`;
        }
    }
    /**
     * Returns an approximation as a float type. Only use this if no
     * exact calculation is required.
     */ toFloatApproximation() {
        const out = Number(this.toString());
        if (Number.isNaN(out)) throw new Error("Conversion to number failed");
        return out;
    }
    /**
     * a.plus(b) returns a+b.
     *
     * Both values need to have the same fractional digits.
     */ plus(b) {
        if (this.fractionalDigits !== b.fractionalDigits) throw new Error("Fractional digits do not match");
        const sum = this.data.atomics.add(new $931eba43e1c6e444$var$bn_js_1.default(b.atomics));
        return new $931eba43e1c6e444$var$Decimal(sum.toString(), this.fractionalDigits);
    }
    /**
     * a.minus(b) returns a-b.
     *
     * Both values need to have the same fractional digits.
     * The resulting difference needs to be non-negative.
     */ minus(b) {
        if (this.fractionalDigits !== b.fractionalDigits) throw new Error("Fractional digits do not match");
        const difference = this.data.atomics.sub(new $931eba43e1c6e444$var$bn_js_1.default(b.atomics));
        if (difference.ltn(0)) throw new Error("Difference must not be negative");
        return new $931eba43e1c6e444$var$Decimal(difference.toString(), this.fractionalDigits);
    }
    /**
     * a.multiply(b) returns a*b.
     *
     * We only allow multiplication by unsigned integers to avoid rounding errors.
     */ multiply(b) {
        const product = this.data.atomics.mul(new $931eba43e1c6e444$var$bn_js_1.default(b.toString()));
        return new $931eba43e1c6e444$var$Decimal(product.toString(), this.fractionalDigits);
    }
    equals(b) {
        return $931eba43e1c6e444$var$Decimal.compare(this, b) === 0;
    }
    isLessThan(b) {
        return $931eba43e1c6e444$var$Decimal.compare(this, b) < 0;
    }
    isLessThanOrEqual(b) {
        return $931eba43e1c6e444$var$Decimal.compare(this, b) <= 0;
    }
    isGreaterThan(b) {
        return $931eba43e1c6e444$var$Decimal.compare(this, b) > 0;
    }
    isGreaterThanOrEqual(b) {
        return $931eba43e1c6e444$var$Decimal.compare(this, b) >= 0;
    }
}
module.exports.Decimal = $931eba43e1c6e444$var$Decimal;

});

parcelRequire.register("beE5F", function(module, exports) {
"use strict";
var $82e019a4b2a6d7cd$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Uint64 = module.exports.Uint53 = module.exports.Int53 = module.exports.Uint32 = void 0;

/* eslint-disable no-bitwise */ const $82e019a4b2a6d7cd$var$bn_js_1 = $82e019a4b2a6d7cd$var$__importDefault((parcelRequire("7vYz3")));
const $82e019a4b2a6d7cd$var$uint64MaxValue = new $82e019a4b2a6d7cd$var$bn_js_1.default("18446744073709551615", 10, "be");
class $82e019a4b2a6d7cd$var$Uint32 {
    constructor(input){
        if (Number.isNaN(input)) throw new Error("Input is not a number");
        if (!Number.isInteger(input)) throw new Error("Input is not an integer");
        if (input < 0 || input > 4294967295) throw new Error("Input not in uint32 range: " + input.toString());
        this.data = input;
    }
    /** @deprecated use Uint32.fromBytes */ static fromBigEndianBytes(bytes) {
        return $82e019a4b2a6d7cd$var$Uint32.fromBytes(bytes);
    }
    /**
     * Creates a Uint32 from a fixed length byte array.
     *
     * @param bytes a list of exactly 4 bytes
     * @param endianess defaults to big endian
     */ static fromBytes(bytes, endianess = "be") {
        if (bytes.length !== 4) throw new Error("Invalid input length. Expected 4 bytes.");
        for(let i = 0; i < bytes.length; ++i){
            if (!Number.isInteger(bytes[i]) || bytes[i] > 255 || bytes[i] < 0) throw new Error("Invalid value in byte. Found: " + bytes[i]);
        }
        const beBytes = endianess === "be" ? bytes : Array.from(bytes).reverse();
        // Use mulitiplication instead of shifting since bitwise operators are defined
        // on SIGNED int32 in JavaScript and we don't want to risk surprises
        return new $82e019a4b2a6d7cd$var$Uint32(beBytes[0] * 2 ** 24 + beBytes[1] * 2 ** 16 + beBytes[2] * 256 + beBytes[3]);
    }
    static fromString(str) {
        if (!str.match(/^[0-9]+$/)) throw new Error("Invalid string format");
        return new $82e019a4b2a6d7cd$var$Uint32(Number.parseInt(str, 10));
    }
    toBytesBigEndian() {
        // Use division instead of shifting since bitwise operators are defined
        // on SIGNED int32 in JavaScript and we don't want to risk surprises
        return new Uint8Array([
            Math.floor(this.data / 2 ** 24) & 0xff,
            Math.floor(this.data / 2 ** 16) & 0xff,
            Math.floor(this.data / 256) & 0xff,
            Math.floor(this.data / 1) & 0xff
        ]);
    }
    toBytesLittleEndian() {
        // Use division instead of shifting since bitwise operators are defined
        // on SIGNED int32 in JavaScript and we don't want to risk surprises
        return new Uint8Array([
            Math.floor(this.data / 1) & 0xff,
            Math.floor(this.data / 256) & 0xff,
            Math.floor(this.data / 2 ** 16) & 0xff,
            Math.floor(this.data / 2 ** 24) & 0xff
        ]);
    }
    toNumber() {
        return this.data;
    }
    toString() {
        return this.data.toString();
    }
}
module.exports.Uint32 = $82e019a4b2a6d7cd$var$Uint32;
class $82e019a4b2a6d7cd$var$Int53 {
    constructor(input){
        if (Number.isNaN(input)) throw new Error("Input is not a number");
        if (!Number.isInteger(input)) throw new Error("Input is not an integer");
        if (input < Number.MIN_SAFE_INTEGER || input > Number.MAX_SAFE_INTEGER) throw new Error("Input not in int53 range: " + input.toString());
        this.data = input;
    }
    static fromString(str) {
        if (!str.match(/^-?[0-9]+$/)) throw new Error("Invalid string format");
        return new $82e019a4b2a6d7cd$var$Int53(Number.parseInt(str, 10));
    }
    toNumber() {
        return this.data;
    }
    toString() {
        return this.data.toString();
    }
}
module.exports.Int53 = $82e019a4b2a6d7cd$var$Int53;
class $82e019a4b2a6d7cd$var$Uint53 {
    constructor(input){
        const signed = new $82e019a4b2a6d7cd$var$Int53(input);
        if (signed.toNumber() < 0) throw new Error("Input is negative");
        this.data = signed;
    }
    static fromString(str) {
        const signed = $82e019a4b2a6d7cd$var$Int53.fromString(str);
        return new $82e019a4b2a6d7cd$var$Uint53(signed.toNumber());
    }
    toNumber() {
        return this.data.toNumber();
    }
    toString() {
        return this.data.toString();
    }
}
module.exports.Uint53 = $82e019a4b2a6d7cd$var$Uint53;
class $82e019a4b2a6d7cd$var$Uint64 {
    constructor(data){
        if (data.isNeg()) throw new Error("Input is negative");
        if (data.gt($82e019a4b2a6d7cd$var$uint64MaxValue)) throw new Error("Input exceeds uint64 range");
        this.data = data;
    }
    /** @deprecated use Uint64.fromBytes */ static fromBytesBigEndian(bytes) {
        return $82e019a4b2a6d7cd$var$Uint64.fromBytes(bytes);
    }
    /**
     * Creates a Uint64 from a fixed length byte array.
     *
     * @param bytes a list of exactly 8 bytes
     * @param endianess defaults to big endian
     */ static fromBytes(bytes, endianess = "be") {
        if (bytes.length !== 8) throw new Error("Invalid input length. Expected 8 bytes.");
        for(let i = 0; i < bytes.length; ++i){
            if (!Number.isInteger(bytes[i]) || bytes[i] > 255 || bytes[i] < 0) throw new Error("Invalid value in byte. Found: " + bytes[i]);
        }
        const beBytes = endianess === "be" ? Array.from(bytes) : Array.from(bytes).reverse();
        return new $82e019a4b2a6d7cd$var$Uint64(new $82e019a4b2a6d7cd$var$bn_js_1.default(beBytes));
    }
    static fromString(str) {
        if (!str.match(/^[0-9]+$/)) throw new Error("Invalid string format");
        return new $82e019a4b2a6d7cd$var$Uint64(new $82e019a4b2a6d7cd$var$bn_js_1.default(str, 10, "be"));
    }
    static fromNumber(input) {
        if (Number.isNaN(input)) throw new Error("Input is not a number");
        if (!Number.isInteger(input)) throw new Error("Input is not an integer");
        let bigint;
        try {
            bigint = new $82e019a4b2a6d7cd$var$bn_js_1.default(input);
        } catch (_a) {
            throw new Error("Input is not a safe integer");
        }
        return new $82e019a4b2a6d7cd$var$Uint64(bigint);
    }
    toBytesBigEndian() {
        return Uint8Array.from(this.data.toArray("be", 8));
    }
    toBytesLittleEndian() {
        return Uint8Array.from(this.data.toArray("le", 8));
    }
    toString() {
        return this.data.toString(10);
    }
    toNumber() {
        return this.data.toNumber();
    }
}
module.exports.Uint64 = $82e019a4b2a6d7cd$var$Uint64;
// Assign classes to unused variables in order to verify static interface conformance at compile time.
// Workaround for https://github.com/microsoft/TypeScript/issues/33892
const $82e019a4b2a6d7cd$var$_int53Class = $82e019a4b2a6d7cd$var$Int53;
const $82e019a4b2a6d7cd$var$_uint53Class = $82e019a4b2a6d7cd$var$Uint53;
const $82e019a4b2a6d7cd$var$_uint32Class = $82e019a4b2a6d7cd$var$Uint32;
const $82e019a4b2a6d7cd$var$_uint64Class = $82e019a4b2a6d7cd$var$Uint64;

});




parcelRequire.register("dbARm", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.pubkeyType = void 0;
module.exports.pubkeyType = {
    /** @see https://github.com/tendermint/tendermint/blob/v0.33.0/crypto/ed25519/ed25519.go#L22 */ secp256k1: "tendermint/PubKeySecp256k1",
    /** @see https://github.com/tendermint/tendermint/blob/v0.33.0/crypto/secp256k1/secp256k1.go#L23 */ ed25519: "tendermint/PubKeyEd25519",
    /** @see https://github.com/tendermint/tendermint/blob/v0.33.0/crypto/sr25519/codec.go#L12 */ sr25519: "tendermint/PubKeySr25519"
};

});


parcelRequire.register("g8Jau", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.parseCoins = module.exports.coins = module.exports.coin = void 0;

var $2lWwp = parcelRequire("2lWwp");
/** Creates a coin */ function $bc006e2409bb6db9$var$coin(amount, denom) {
    return {
        amount: new $2lWwp.Uint53(amount).toString(),
        denom: denom
    };
}
module.exports.coin = $bc006e2409bb6db9$var$coin;
/** Creates a list of coins with one element */ function $bc006e2409bb6db9$var$coins(amount, denom) {
    return [
        $bc006e2409bb6db9$var$coin(amount, denom)
    ];
}
module.exports.coins = $bc006e2409bb6db9$var$coins;
/**
 * Takes a coins list like "819966000ucosm,700000000ustake" and parses it
 */ function $bc006e2409bb6db9$var$parseCoins(input) {
    return input.replace(/\s/g, "").split(",").filter(Boolean).map((part)=>{
        const match = part.match(/^([0-9]+)([a-zA-Z]+)/);
        if (!match) throw new Error("Got an invalid coin string");
        return {
            amount: $2lWwp.Uint64.fromString(match[1]).toString(),
            denom: match[2]
        };
    });
}
module.exports.parseCoins = $bc006e2409bb6db9$var$parseCoins;

});

parcelRequire.register("1CFPF", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.CosmosClient = module.exports.isSearchByTagsQuery = module.exports.isSearchBySentFromOrToQuery = module.exports.isSearchByHeightQuery = module.exports.assertIsBroadcastTxSuccess = module.exports.isBroadcastTxSuccess = module.exports.isBroadcastTxFailure = void 0;

var $3cQ9Q = parcelRequire("3cQ9Q");

var $5a6Ix = parcelRequire("5a6Ix");

var $2lWwp = parcelRequire("2lWwp");

var $9XjFJ = parcelRequire("9XjFJ");

var $P5pAj = parcelRequire("P5pAj");
function $12e9ca163407f0b5$var$isBroadcastTxFailure(result) {
    return !!result.code;
}
module.exports.isBroadcastTxFailure = $12e9ca163407f0b5$var$isBroadcastTxFailure;
function $12e9ca163407f0b5$var$isBroadcastTxSuccess(result) {
    return !$12e9ca163407f0b5$var$isBroadcastTxFailure(result);
}
module.exports.isBroadcastTxSuccess = $12e9ca163407f0b5$var$isBroadcastTxSuccess;
/**
 * Ensures the given result is a success. Throws a detailed error message otherwise.
 */ function $12e9ca163407f0b5$var$assertIsBroadcastTxSuccess(result) {
    if ($12e9ca163407f0b5$var$isBroadcastTxFailure(result)) throw new Error(`Error when broadcasting tx ${result.transactionHash} at height ${result.height}. Code: ${result.code}; Raw log: ${result.rawLog}`);
}
module.exports.assertIsBroadcastTxSuccess = $12e9ca163407f0b5$var$assertIsBroadcastTxSuccess;
function $12e9ca163407f0b5$var$isSearchByHeightQuery(query) {
    return query.height !== undefined;
}
module.exports.isSearchByHeightQuery = $12e9ca163407f0b5$var$isSearchByHeightQuery;
function $12e9ca163407f0b5$var$isSearchBySentFromOrToQuery(query) {
    return query.sentFromOrTo !== undefined;
}
module.exports.isSearchBySentFromOrToQuery = $12e9ca163407f0b5$var$isSearchBySentFromOrToQuery;
function $12e9ca163407f0b5$var$isSearchByTagsQuery(query) {
    return query.tags !== undefined;
}
module.exports.isSearchByTagsQuery = $12e9ca163407f0b5$var$isSearchByTagsQuery;
class $12e9ca163407f0b5$var$CosmosClient {
    /**
     * Creates a new client to interact with a CosmWasm blockchain.
     *
     * This instance does a lot of caching. In order to benefit from that you should try to use one instance
     * for the lifetime of your application. When switching backends, a new instance must be created.
     *
     * @param apiUrl The URL of a Cosmos SDK light client daemon API (sometimes called REST server or REST API)
     * @param broadcastMode Defines at which point of the transaction processing the broadcastTx method returns
     */ constructor(apiUrl, broadcastMode = $9XjFJ.BroadcastMode.Block){
        this.lcdClient = $9XjFJ.LcdClient.withExtensions({
            apiUrl: apiUrl,
            broadcastMode: broadcastMode
        }, $9XjFJ.setupAuthExtension);
    }
    async getChainId() {
        if (!this.chainId) {
            const response = await this.lcdClient.nodeInfo();
            const chainId = response.node_info.network;
            if (!chainId) throw new Error("Chain ID must not be empty");
            this.chainId = chainId;
        }
        return this.chainId;
    }
    async getHeight() {
        if (this.anyValidAddress) {
            const { height: height } = await this.lcdClient.auth.account(this.anyValidAddress);
            return parseInt(height, 10);
        } else {
            // Note: this gets inefficient when blocks contain a lot of transactions since it
            // requires downloading and deserializing all transactions in the block.
            const latest = await this.lcdClient.blocksLatest();
            return parseInt(latest.block.header.height, 10);
        }
    }
    /**
     * Returns a 32 byte upper-case hex transaction hash (typically used as the transaction ID)
     */ async getIdentifier(tx) {
        // We consult the REST API because we don't have a local amino encoder
        const response = await this.lcdClient.encodeTx(tx);
        const hash = $3cQ9Q.sha256($5a6Ix.fromBase64(response.tx));
        return $5a6Ix.toHex(hash).toUpperCase();
    }
    /**
     * Returns account number and sequence.
     *
     * Throws if the account does not exist on chain.
     *
     * @param address returns data for this address. When unset, the client's sender adddress is used.
     */ async getSequence(address) {
        const account = await this.getAccount(address);
        if (!account) throw new Error("Account does not exist on chain. Send some tokens there before trying to query sequence.");
        return {
            accountNumber: account.accountNumber,
            sequence: account.sequence
        };
    }
    async getAccount(address) {
        const account = await this.lcdClient.auth.account(address);
        const value = account.result.value;
        if (value.address === "") return undefined;
        else {
            this.anyValidAddress = value.address;
            return {
                address: value.address,
                balance: value.coins,
                pubkey: $9XjFJ.normalizePubkey(value.public_key) || undefined,
                accountNumber: $9XjFJ.uint64ToNumber(value.account_number),
                sequence: $9XjFJ.uint64ToNumber(value.sequence)
            };
        }
    }
    /**
     * Gets block header and meta
     *
     * @param height The height of the block. If undefined, the latest height is used.
     */ async getBlock(height) {
        const response = height !== undefined ? await this.lcdClient.blocks(height) : await this.lcdClient.blocksLatest();
        return {
            id: response.block_id.hash,
            header: {
                version: response.block.header.version,
                time: response.block.header.time,
                height: parseInt(response.block.header.height, 10),
                chainId: response.block.header.chain_id
            },
            txs: (response.block.data.txs || []).map($5a6Ix.fromBase64)
        };
    }
    async getTx(id) {
        var _a;
        const results = await this.txsQuery(`tx.hash=${id}`);
        return (_a = results[0]) !== null && _a !== void 0 ? _a : null;
    }
    async searchTx(query, filter = {}) {
        const minHeight = filter.minHeight || 0;
        const maxHeight = filter.maxHeight || Number.MAX_SAFE_INTEGER;
        if (maxHeight < minHeight) return []; // optional optimization
        function withFilters(originalQuery) {
            return `${originalQuery}&tx.minheight=${minHeight}&tx.maxheight=${maxHeight}`;
        }
        let txs;
        if ($12e9ca163407f0b5$var$isSearchByHeightQuery(query)) {
            // optional optimization to avoid network request
            if (query.height < minHeight || query.height > maxHeight) txs = [];
            else txs = await this.txsQuery(`tx.height=${query.height}`);
        } else if ($12e9ca163407f0b5$var$isSearchBySentFromOrToQuery(query)) {
            // We cannot get both in one request (see https://github.com/cosmos/gaia/issues/75)
            const sentQuery = withFilters(`message.module=bank&message.sender=${query.sentFromOrTo}`);
            const receivedQuery = withFilters(`message.module=bank&transfer.recipient=${query.sentFromOrTo}`);
            const sent = await this.txsQuery(sentQuery);
            const received = await this.txsQuery(receivedQuery);
            const sentHashes = sent.map((t)=>t.hash);
            txs = [
                ...sent,
                ...received.filter((t)=>!sentHashes.includes(t.hash))
            ];
        } else if ($12e9ca163407f0b5$var$isSearchByTagsQuery(query)) {
            const rawQuery = withFilters(query.tags.map((t)=>`${t.key}=${t.value}`).join("&"));
            txs = await this.txsQuery(rawQuery);
        } else throw new Error("Unknown query type");
        // backend sometimes messes up with min/max height filtering
        const filtered = txs.filter((tx)=>tx.height >= minHeight && tx.height <= maxHeight);
        return filtered;
    }
    async broadcastTx(tx) {
        const result = await this.lcdClient.broadcastTx(tx);
        if (!result.txhash.match(/^([0-9A-F][0-9A-F])+$/)) throw new Error("Received ill-formatted txhash. Must be non-empty upper-case hex");
        return result.code !== undefined ? {
            height: $2lWwp.Uint53.fromString(result.height).toNumber(),
            transactionHash: result.txhash,
            code: result.code,
            rawLog: result.raw_log || ""
        } : {
            logs: result.logs ? $P5pAj.parseLogs(result.logs) : [],
            rawLog: result.raw_log || "",
            transactionHash: result.txhash,
            data: result.data ? $5a6Ix.fromHex(result.data) : undefined
        };
    }
    async txsQuery(query) {
        // TODO: we need proper pagination support
        const limit = 100;
        const result = await this.lcdClient.txsQuery(`${query}&limit=${limit}`);
        const pages = parseInt(result.page_total, 10);
        if (pages > 1) throw new Error(`Found more results on the backend than we can process currently. Results: ${result.total_count}, supported: ${limit}`);
        return result.txs.map((restItem)=>({
                height: parseInt(restItem.height, 10),
                hash: restItem.txhash,
                code: restItem.code || 0,
                rawLog: restItem.raw_log,
                logs: $P5pAj.parseLogs(restItem.logs || []),
                tx: restItem.tx,
                timestamp: restItem.timestamp
            }));
    }
}
module.exports.CosmosClient = $12e9ca163407f0b5$var$CosmosClient;

});
parcelRequire.register("9XjFJ", function(module, exports) {
"use strict";
//
// Standard modules (see tracking issue https://github.com/cosmos/cosmjs/issues/276)
//
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.uint64ToString = module.exports.uint64ToNumber = module.exports.normalizePubkey = module.exports.normalizeLcdApiArray = module.exports.LcdClient = module.exports.BroadcastMode = module.exports.setupSupplyExtension = module.exports.setupStakingExtension = module.exports.setupSlashingExtension = module.exports.setupMintExtension = module.exports.setupGovExtension = module.exports.setupDistributionExtension = module.exports.setupBankExtension = module.exports.setupAuthExtension = void 0;

var $3SkdG = parcelRequire("3SkdG");
Object.defineProperty(module.exports, "setupAuthExtension", {
    enumerable: true,
    get: function() {
        return $3SkdG.setupAuthExtension;
    }
});

var $593NG = parcelRequire("593NG");
Object.defineProperty(module.exports, "setupBankExtension", {
    enumerable: true,
    get: function() {
        return $593NG.setupBankExtension;
    }
});

var $16veE = parcelRequire("16veE");
Object.defineProperty(module.exports, "setupDistributionExtension", {
    enumerable: true,
    get: function() {
        return $16veE.setupDistributionExtension;
    }
});

var $hIzA9 = parcelRequire("hIzA9");
Object.defineProperty(module.exports, "setupGovExtension", {
    enumerable: true,
    get: function() {
        return $hIzA9.setupGovExtension;
    }
});

var $dUh90 = parcelRequire("dUh90");
Object.defineProperty(module.exports, "setupMintExtension", {
    enumerable: true,
    get: function() {
        return $dUh90.setupMintExtension;
    }
});

var $d9LWm = parcelRequire("d9LWm");
Object.defineProperty(module.exports, "setupSlashingExtension", {
    enumerable: true,
    get: function() {
        return $d9LWm.setupSlashingExtension;
    }
});

var $4DG8H = parcelRequire("4DG8H");
Object.defineProperty(module.exports, "setupStakingExtension", {
    enumerable: true,
    get: function() {
        return $4DG8H.setupStakingExtension;
    }
});

var $fDaYD = parcelRequire("fDaYD");
Object.defineProperty(module.exports, "setupSupplyExtension", {
    enumerable: true,
    get: function() {
        return $fDaYD.setupSupplyExtension;
    }
});

var $cEOn1 = parcelRequire("cEOn1");
Object.defineProperty(module.exports, "BroadcastMode", {
    enumerable: true,
    get: function() {
        return $cEOn1.BroadcastMode;
    }
});

var $c27b1 = parcelRequire("c27b1");
Object.defineProperty(module.exports, "LcdClient", {
    enumerable: true,
    get: function() {
        return $c27b1.LcdClient;
    }
});
Object.defineProperty(module.exports, "normalizeLcdApiArray", {
    enumerable: true,
    get: function() {
        return $c27b1.normalizeLcdApiArray;
    }
});

var $h2NPp = parcelRequire("h2NPp");
Object.defineProperty(module.exports, "normalizePubkey", {
    enumerable: true,
    get: function() {
        return $h2NPp.normalizePubkey;
    }
});
Object.defineProperty(module.exports, "uint64ToNumber", {
    enumerable: true,
    get: function() {
        return $h2NPp.uint64ToNumber;
    }
});
Object.defineProperty(module.exports, "uint64ToString", {
    enumerable: true,
    get: function() {
        return $h2NPp.uint64ToString;
    }
});

});
parcelRequire.register("3SkdG", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.setupAuthExtension = void 0;
function $2d261974053c657c$var$setupAuthExtension(base) {
    return {
        auth: {
            account: async (address)=>{
                const path = `/auth/accounts/${address}`;
                const responseData = await base.get(path);
                if (responseData.result.type !== "cosmos-sdk/Account") throw new Error("Unexpected response data format");
                return responseData;
            }
        }
    };
}
module.exports.setupAuthExtension = $2d261974053c657c$var$setupAuthExtension;

});

parcelRequire.register("593NG", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.setupBankExtension = void 0;
function $3bf0bdac0845a163$var$setupBankExtension(base) {
    return {
        bank: {
            balances: async (address)=>{
                const path = `/bank/balances/${address}`;
                return base.get(path);
            }
        }
    };
}
module.exports.setupBankExtension = $3bf0bdac0845a163$var$setupBankExtension;

});

parcelRequire.register("16veE", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.setupDistributionExtension = void 0;
function $0cde94ade33b47ae$var$setupDistributionExtension(base) {
    return {
        distribution: {
            delegatorRewards: async (delegatorAddress)=>base.get(`/distribution/delegators/${delegatorAddress}/rewards`),
            delegatorReward: async (delegatorAddress, validatorAddress)=>base.get(`/distribution/delegators/${delegatorAddress}/rewards/${validatorAddress}`),
            withdrawAddress: async (delegatorAddress)=>base.get(`/distribution/delegators/${delegatorAddress}/withdraw_address`),
            validator: async (validatorAddress)=>base.get(`/distribution/validators/${validatorAddress}`),
            validatorRewards: async (validatorAddress)=>base.get(`/distribution/validators/${validatorAddress}/rewards`),
            validatorOutstandingRewards: async (validatorAddress)=>base.get(`/distribution/validators/${validatorAddress}/outstanding_rewards`),
            parameters: async ()=>base.get(`/distribution/parameters`),
            communityPool: async ()=>base.get(`/distribution/community_pool`)
        }
    };
}
module.exports.setupDistributionExtension = $0cde94ade33b47ae$var$setupDistributionExtension;

});

parcelRequire.register("hIzA9", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.setupGovExtension = module.exports.GovParametersType = void 0;
var $ce622596adec4214$var$GovParametersType;
(function(GovParametersType) {
    GovParametersType["Deposit"] = "deposit";
    GovParametersType["Tallying"] = "tallying";
    GovParametersType["Voting"] = "voting";
})($ce622596adec4214$var$GovParametersType = module.exports.GovParametersType || (module.exports.GovParametersType = {}));
function $ce622596adec4214$var$setupGovExtension(base) {
    return {
        gov: {
            parameters: async (parametersType)=>base.get(`/gov/parameters/${parametersType}`),
            proposals: async ()=>base.get("/gov/proposals"),
            proposal: async (proposalId)=>base.get(`/gov/proposals/${proposalId}`),
            proposer: async (proposalId)=>base.get(`/gov/proposals/${proposalId}/proposer`),
            deposits: async (proposalId)=>base.get(`/gov/proposals/${proposalId}/deposits`),
            deposit: async (proposalId, depositorAddress)=>base.get(`/gov/proposals/${proposalId}/deposits/${depositorAddress}`),
            tally: async (proposalId)=>base.get(`/gov/proposals/${proposalId}/tally`),
            votes: async (proposalId)=>base.get(`/gov/proposals/${proposalId}/votes`),
            vote: async (proposalId, voterAddress)=>base.get(`/gov/proposals/${proposalId}/votes/${voterAddress}`)
        }
    };
}
module.exports.setupGovExtension = $ce622596adec4214$var$setupGovExtension;

});

parcelRequire.register("dUh90", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.setupMintExtension = void 0;
function $a1fdcdce0537c022$var$setupMintExtension(base) {
    return {
        mint: {
            parameters: async ()=>base.get(`/minting/parameters`),
            inflation: async ()=>base.get(`/minting/inflation`),
            annualProvisions: async ()=>base.get(`/minting/annual-provisions`)
        }
    };
}
module.exports.setupMintExtension = $a1fdcdce0537c022$var$setupMintExtension;

});

parcelRequire.register("d9LWm", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.setupSlashingExtension = void 0;
function $99414d8beae0d2d4$var$setupSlashingExtension(base) {
    return {
        slashing: {
            signingInfos: async ()=>{
                return base.get(`/slashing/signing_infos`);
            },
            parameters: async ()=>{
                return base.get(`/slashing/parameters`);
            }
        }
    };
}
module.exports.setupSlashingExtension = $99414d8beae0d2d4$var$setupSlashingExtension;

});

parcelRequire.register("4DG8H", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.setupStakingExtension = module.exports.BondStatus = void 0;
/**
 * Numeric bonding status
 *
 * @see https://github.com/cosmos/cosmos-sdk/blob/v0.38.5/types/staking.go#L43-L49
 */ var $360b7deb55fa3eb4$var$BondStatus;
(function(BondStatus) {
    BondStatus[BondStatus["Unbonded"] = 0] = "Unbonded";
    BondStatus[BondStatus["Unbonding"] = 1] = "Unbonding";
    BondStatus[BondStatus["Bonded"] = 2] = "Bonded";
})($360b7deb55fa3eb4$var$BondStatus = module.exports.BondStatus || (module.exports.BondStatus = {}));
function $360b7deb55fa3eb4$var$setupStakingExtension(base) {
    return {
        staking: {
            delegatorDelegations: async (delegatorAddress)=>base.get(`/staking/delegators/${delegatorAddress}/delegations`),
            delegatorUnbondingDelegations: async (delegatorAddress)=>base.get(`/staking/delegators/${delegatorAddress}/unbonding_delegations`),
            delegatorTransactions: async (delegatorAddress)=>base.get(`/staking/delegators/${delegatorAddress}/txs`),
            delegatorValidators: async (delegatorAddress)=>base.get(`/staking/delegators/${delegatorAddress}/validators`),
            delegatorValidator: async (delegatorAddress, validatorAddress)=>base.get(`/staking/delegators/${delegatorAddress}/validators/${validatorAddress}`),
            delegation: async (delegatorAddress, validatorAddress)=>base.get(`/staking/delegators/${delegatorAddress}/delegations/${validatorAddress}`),
            unbondingDelegation: async (delegatorAddress, validatorAddress)=>base.get(`/staking/delegators/${delegatorAddress}/unbonding_delegations/${validatorAddress}`),
            redelegations: async ()=>base.get(`/staking/redelegations`),
            validators: async (params)=>base.get(`/staking/validators`, params),
            validator: async (validatorAddress)=>base.get(`/staking/validators/${validatorAddress}`),
            validatorDelegations: async (validatorAddress)=>base.get(`/staking/validators/${validatorAddress}/delegations`),
            validatorUnbondingDelegations: async (validatorAddress)=>base.get(`/staking/validators/${validatorAddress}/unbonding_delegations`),
            historicalInfo: async (height)=>base.get(`/staking/historical_info/${height}`),
            pool: async ()=>base.get(`/staking/pool`),
            parameters: async ()=>base.get(`/staking/parameters`)
        }
    };
}
module.exports.setupStakingExtension = $360b7deb55fa3eb4$var$setupStakingExtension;

});

parcelRequire.register("fDaYD", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.setupSupplyExtension = void 0;
function $b6130355df933d4d$var$setupSupplyExtension(base) {
    return {
        supply: {
            totalAll: async ()=>{
                return base.get(`/supply/total`);
            },
            total: async (denom)=>{
                return base.get(`/supply/total/${denom}`);
            }
        }
    };
}
module.exports.setupSupplyExtension = $b6130355df933d4d$var$setupSupplyExtension;

});

parcelRequire.register("cEOn1", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.BroadcastMode = void 0;
/**
 * The mode used to send transaction
 *
 * @see https://cosmos.network/rpc/#/Transactions/post_txs
 */ var $93704afaecfb40d5$var$BroadcastMode;
(function(BroadcastMode) {
    /** Return after tx commit */ BroadcastMode["Block"] = "block";
    /** Return after CheckTx */ BroadcastMode["Sync"] = "sync";
    /** Return right away */ BroadcastMode["Async"] = "async";
})($93704afaecfb40d5$var$BroadcastMode = module.exports.BroadcastMode || (module.exports.BroadcastMode = {}));

});

parcelRequire.register("c27b1", function(module, exports) {
"use strict";
var $8c2b3d191054f76a$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.LcdClient = module.exports.normalizeLcdApiArray = void 0;

var $gYZZP = parcelRequire("gYZZP");

const $8c2b3d191054f76a$var$axios_1 = $8c2b3d191054f76a$var$__importDefault((parcelRequire("2shzp")));

var $cEOn1 = parcelRequire("cEOn1");
function $8c2b3d191054f76a$var$normalizeLcdApiArray(backend) {
    return backend || [];
}
module.exports.normalizeLcdApiArray = $8c2b3d191054f76a$var$normalizeLcdApiArray;
// We want to get message data from 500 errors
// https://stackoverflow.com/questions/56577124/how-to-handle-500-error-message-with-axios
// this should be chained to catch one error and throw a more informative one
function $8c2b3d191054f76a$var$parseAxiosError(err) {
    var _a;
    // use the error message sent from server, not default 500 msg
    if ((_a = err.response) === null || _a === void 0 ? void 0 : _a.data) {
        let errorText;
        const data = err.response.data;
        // expect { error: string }, but otherwise dump
        if (data.error && typeof data.error === "string") errorText = data.error;
        else if (typeof data === "string") errorText = data;
        else errorText = JSON.stringify(data);
        throw new Error(`${errorText} (HTTP ${err.response.status})`);
    } else throw err;
}
/**
 * A client to the LCD's (light client daemon) API.
 * This light client connects to Tendermint (i.e. the chain), encodes/decodes Amino data for us and provides a convenient JSON interface.
 *
 * This _JSON over HTTP_ API is sometimes referred to as "REST" or "RPC", which are both misleading terms
 * for the same thing.
 *
 * Please note that the client to the LCD can not verify light client proofs. When using this,
 * you need to trust the API provider as well as the network connection between client and API.
 *
 * @see https://cosmos.network/rpc
 */ class $8c2b3d191054f76a$var$LcdClient {
    /**
     * Creates a new client to interact with a Cosmos SDK light client daemon.
     * This class tries to be a direct mapping onto the API. Some basic decoding and normalizatin is done
     * but things like caching are done at a higher level.
     *
     * When building apps, you should not need to use this class directly. If you do, this indicates a missing feature
     * in higher level components. Feel free to raise an issue in this case.
     *
     * @param apiUrl The URL of a Cosmos SDK light client daemon API (sometimes called REST server or REST API)
     * @param broadcastMode Defines at which point of the transaction processing the broadcastTx method returns
     */ constructor(apiUrl, broadcastMode = $cEOn1.BroadcastMode.Block){
        const headers = {
            post: {
                "Content-Type": "application/json"
            }
        };
        this.client = $8c2b3d191054f76a$var$axios_1.default.create({
            baseURL: apiUrl,
            headers: headers
        });
        this.broadcastMode = broadcastMode;
    }
    static withExtensions(options, ...extensionSetups) {
        const client = new $8c2b3d191054f76a$var$LcdClient(options.apiUrl, options.broadcastMode);
        const extensions = extensionSetups.map((setupExtension)=>setupExtension(client));
        for (const extension of extensions){
            $gYZZP.assert($gYZZP.isNonNullObject(extension), `Extension must be a non-null object`);
            for (const [moduleKey, moduleValue] of Object.entries(extension)){
                $gYZZP.assert($gYZZP.isNonNullObject(moduleValue), `Module must be a non-null object. Found type ${typeof moduleValue} for module "${moduleKey}".`);
                const current = client[moduleKey] || {};
                client[moduleKey] = Object.assign(Object.assign({}, current), moduleValue);
            }
        }
        return client;
    }
    async get(path, params) {
        const { data: data } = await this.client.get(path, {
            params: params
        }).catch($8c2b3d191054f76a$var$parseAxiosError);
        if (data === null) throw new Error("Received null response from server");
        return data;
    }
    // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
    async post(path, params) {
        if (!$gYZZP.isNonNullObject(params)) throw new Error("Got unexpected type of params. Expected object.");
        const { data: data } = await this.client.post(path, params).catch($8c2b3d191054f76a$var$parseAxiosError);
        if (data === null) throw new Error("Received null response from server");
        return data;
    }
    // The /blocks endpoints
    async blocksLatest() {
        const responseData = await this.get("/blocks/latest");
        if (!responseData.block) throw new Error("Unexpected response data format");
        return responseData;
    }
    async blocks(height) {
        const responseData = await this.get(`/blocks/${height}`);
        if (!responseData.block) throw new Error("Unexpected response data format");
        return responseData;
    }
    // The /node_info endpoint
    async nodeInfo() {
        const responseData = await this.get("/node_info");
        if (!responseData.node_info) throw new Error("Unexpected response data format");
        return responseData;
    }
    // The /txs endpoints
    async txById(id) {
        const responseData = await this.get(`/txs/${id}`);
        if (!responseData.tx) throw new Error("Unexpected response data format");
        return responseData;
    }
    async txsQuery(query) {
        const responseData = await this.get(`/txs?${query}`);
        if (!responseData.txs) throw new Error("Unexpected response data format");
        return responseData;
    }
    /** returns the amino-encoding of the transaction performed by the server */ async encodeTx(tx) {
        const responseData = await this.post("/txs/encode", tx);
        if (!responseData.tx) throw new Error("Unexpected response data format");
        return responseData;
    }
    /**
     * Broadcasts a signed transaction to the transaction pool.
     * Depending on the client's broadcast mode, this might or might
     * wait for checkTx or deliverTx to be executed before returning.
     *
     * @param tx a signed transaction as StdTx (i.e. not wrapped in type/value container)
     */ async broadcastTx(tx) {
        const params = {
            tx: tx,
            mode: this.broadcastMode
        };
        const responseData = await this.post("/txs", params);
        if (!responseData.txhash) throw new Error("Unexpected response data format");
        return responseData;
    }
}
module.exports.LcdClient = $8c2b3d191054f76a$var$LcdClient;

});

parcelRequire.register("h2NPp", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.normalizePubkey = module.exports.uint64ToString = module.exports.uint64ToNumber = void 0;

var $2lWwp = parcelRequire("2lWwp");

var $7rDC2 = parcelRequire("7rDC2");
/**
 * Converts an integer expressed as number or string to a number.
 * Throws if input is not a valid uint64 or if the value exceeds MAX_SAFE_INTEGER.
 *
 * This is needed for supporting Comsos SDK 0.37/0.38/0.39 with one client.
 */ function $c6894666fdde6a6b$var$uint64ToNumber(input) {
    const value = typeof input === "number" ? $2lWwp.Uint64.fromNumber(input) : $2lWwp.Uint64.fromString(input);
    return value.toNumber();
}
module.exports.uint64ToNumber = $c6894666fdde6a6b$var$uint64ToNumber;
/**
 * Converts an integer expressed as number or string to a string.
 * Throws if input is not a valid uint64.
 *
 * This is needed for supporting Comsos SDK 0.37/0.38/0.39 with one client.
 */ function $c6894666fdde6a6b$var$uint64ToString(input) {
    const value = typeof input === "number" ? $2lWwp.Uint64.fromNumber(input) : $2lWwp.Uint64.fromString(input);
    return value.toString();
}
module.exports.uint64ToString = $c6894666fdde6a6b$var$uint64ToString;
/**
 * Normalizes a pubkey as in `BaseAccount.public_key` to allow supporting
 * Comsos SDK 0.37–0.39.
 *
 * Returns null when unset.
 */ function $c6894666fdde6a6b$var$normalizePubkey(input) {
    if (!input) return null;
    if (typeof input === "string") return $7rDC2.decodeBech32Pubkey(input);
    return input;
}
module.exports.normalizePubkey = $c6894666fdde6a6b$var$normalizePubkey;

});
parcelRequire.register("7rDC2", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.encodeBech32Pubkey = module.exports.encodeAminoPubkey = module.exports.decodeBech32Pubkey = module.exports.decodeAminoPubkey = module.exports.encodeSecp256k1Pubkey = void 0;

var $5a6Ix = parcelRequire("5a6Ix");

var $gYZZP = parcelRequire("gYZZP");

var $dbARm = parcelRequire("dbARm");
function $56b9c8399a5e6a3e$var$encodeSecp256k1Pubkey(pubkey) {
    if (pubkey.length !== 33 || pubkey[0] !== 0x02 && pubkey[0] !== 0x03) throw new Error("Public key must be compressed secp256k1, i.e. 33 bytes starting with 0x02 or 0x03");
    return {
        type: $dbARm.pubkeyType.secp256k1,
        value: $5a6Ix.toBase64(pubkey)
    };
}
module.exports.encodeSecp256k1Pubkey = $56b9c8399a5e6a3e$var$encodeSecp256k1Pubkey;
// As discussed in https://github.com/binance-chain/javascript-sdk/issues/163
// Prefixes listed here: https://github.com/tendermint/tendermint/blob/d419fffe18531317c28c29a292ad7d253f6cafdf/docs/spec/blockchain/encoding.md#public-key-cryptography
// Last bytes is varint-encoded length prefix
const $56b9c8399a5e6a3e$var$pubkeyAminoPrefixSecp256k1 = $5a6Ix.fromHex("eb5ae98721");
const $56b9c8399a5e6a3e$var$pubkeyAminoPrefixEd25519 = $5a6Ix.fromHex("1624de6420");
const $56b9c8399a5e6a3e$var$pubkeyAminoPrefixSr25519 = $5a6Ix.fromHex("0dfb1005");
const $56b9c8399a5e6a3e$var$pubkeyAminoPrefixLength = $56b9c8399a5e6a3e$var$pubkeyAminoPrefixSecp256k1.length;
/**
 * Decodes a pubkey in the Amino binary format to a type/value object.
 */ function $56b9c8399a5e6a3e$var$decodeAminoPubkey(data) {
    const aminoPrefix = data.slice(0, $56b9c8399a5e6a3e$var$pubkeyAminoPrefixLength);
    const rest = data.slice($56b9c8399a5e6a3e$var$pubkeyAminoPrefixLength);
    if ($gYZZP.arrayContentEquals(aminoPrefix, $56b9c8399a5e6a3e$var$pubkeyAminoPrefixSecp256k1)) {
        if (rest.length !== 33) throw new Error("Invalid rest data length. Expected 33 bytes (compressed secp256k1 pubkey).");
        return {
            type: $dbARm.pubkeyType.secp256k1,
            value: $5a6Ix.toBase64(rest)
        };
    } else if ($gYZZP.arrayContentEquals(aminoPrefix, $56b9c8399a5e6a3e$var$pubkeyAminoPrefixEd25519)) {
        if (rest.length !== 32) throw new Error("Invalid rest data length. Expected 32 bytes (Ed25519 pubkey).");
        return {
            type: $dbARm.pubkeyType.ed25519,
            value: $5a6Ix.toBase64(rest)
        };
    } else if ($gYZZP.arrayContentEquals(aminoPrefix, $56b9c8399a5e6a3e$var$pubkeyAminoPrefixSr25519)) {
        if (rest.length !== 32) throw new Error("Invalid rest data length. Expected 32 bytes (Sr25519 pubkey).");
        return {
            type: $dbARm.pubkeyType.sr25519,
            value: $5a6Ix.toBase64(rest)
        };
    } else throw new Error("Unsupported Pubkey type. Amino prefix: " + $5a6Ix.toHex(aminoPrefix));
}
module.exports.decodeAminoPubkey = $56b9c8399a5e6a3e$var$decodeAminoPubkey;
/**
 * Decodes a bech32 pubkey to Amino binary, which is then decoded to a type/value object.
 * The bech32 prefix is ignored and discareded.
 *
 * @param bechEncoded the bech32 encoded pubkey
 */ function $56b9c8399a5e6a3e$var$decodeBech32Pubkey(bechEncoded) {
    const { data: data } = $5a6Ix.Bech32.decode(bechEncoded);
    return $56b9c8399a5e6a3e$var$decodeAminoPubkey(data);
}
module.exports.decodeBech32Pubkey = $56b9c8399a5e6a3e$var$decodeBech32Pubkey;
/**
 * Encodes a public key to binary Amino.
 */ function $56b9c8399a5e6a3e$var$encodeAminoPubkey(pubkey) {
    let aminoPrefix;
    switch(pubkey.type){
        // Note: please don't add cases here without writing additional unit tests
        case $dbARm.pubkeyType.secp256k1:
            aminoPrefix = $56b9c8399a5e6a3e$var$pubkeyAminoPrefixSecp256k1;
            break;
        case $dbARm.pubkeyType.ed25519:
            aminoPrefix = $56b9c8399a5e6a3e$var$pubkeyAminoPrefixEd25519;
            break;
        default:
            throw new Error("Unsupported pubkey type");
    }
    return new Uint8Array([
        ...aminoPrefix,
        ...$5a6Ix.fromBase64(pubkey.value)
    ]);
}
module.exports.encodeAminoPubkey = $56b9c8399a5e6a3e$var$encodeAminoPubkey;
/**
 * Encodes a public key to binary Amino and then to bech32.
 *
 * @param pubkey the public key to encode
 * @param prefix the bech32 prefix (human readable part)
 */ function $56b9c8399a5e6a3e$var$encodeBech32Pubkey(pubkey, prefix) {
    return $5a6Ix.Bech32.encode(prefix, $56b9c8399a5e6a3e$var$encodeAminoPubkey(pubkey));
}
module.exports.encodeBech32Pubkey = $56b9c8399a5e6a3e$var$encodeBech32Pubkey;

});




parcelRequire.register("axITl", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.serializeSignDoc = module.exports.makeSignDoc = module.exports.sortedJsonStringify = void 0;

var $5a6Ix = parcelRequire("5a6Ix");

var $2lWwp = parcelRequire("2lWwp");
function $7acfcf0120a4fa14$var$sortedObject(obj) {
    if (typeof obj !== "object" || obj === null) return obj;
    if (Array.isArray(obj)) return obj.map($7acfcf0120a4fa14$var$sortedObject);
    const sortedKeys = Object.keys(obj).sort();
    const result = {};
    // NOTE: Use forEach instead of reduce for performance with large objects eg Wasm code
    sortedKeys.forEach((key)=>{
        result[key] = $7acfcf0120a4fa14$var$sortedObject(obj[key]);
    });
    return result;
}
/** Returns a JSON string with objects sorted by key */ // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
function $7acfcf0120a4fa14$var$sortedJsonStringify(obj) {
    return JSON.stringify($7acfcf0120a4fa14$var$sortedObject(obj));
}
module.exports.sortedJsonStringify = $7acfcf0120a4fa14$var$sortedJsonStringify;
function $7acfcf0120a4fa14$var$makeSignDoc(msgs, fee, chainId, memo, accountNumber, sequence) {
    return {
        chain_id: chainId,
        account_number: $2lWwp.Uint53.fromString(accountNumber.toString()).toString(),
        sequence: $2lWwp.Uint53.fromString(sequence.toString()).toString(),
        fee: fee,
        msgs: msgs,
        memo: memo || ""
    };
}
module.exports.makeSignDoc = $7acfcf0120a4fa14$var$makeSignDoc;
function $7acfcf0120a4fa14$var$serializeSignDoc(signDoc) {
    return $5a6Ix.toUtf8($7acfcf0120a4fa14$var$sortedJsonStringify(signDoc));
}
module.exports.serializeSignDoc = $7acfcf0120a4fa14$var$serializeSignDoc;

});

parcelRequire.register("3adpy", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.buildFeeTable = module.exports.GasPrice = void 0;

var $2lWwp = parcelRequire("2lWwp");

var $g8Jau = parcelRequire("g8Jau");
class $24dcb574f26d9e84$var$GasPrice {
    constructor(amount, denom){
        this.amount = amount;
        this.denom = denom;
    }
    static fromString(gasPrice) {
        const matchResult = gasPrice.match(/^(?<amount>.+?)(?<denom>[a-z]+)$/);
        if (!matchResult) throw new Error("Invalid gas price string");
        const { amount: amount, denom: denom } = matchResult.groups;
        if (denom.length < 3 || denom.length > 127) throw new Error("Gas price denomination must be between 3 and 127 characters");
        const fractionalDigits = 18;
        const decimalAmount = $2lWwp.Decimal.fromUserInput(amount, fractionalDigits);
        return new $24dcb574f26d9e84$var$GasPrice(decimalAmount, denom);
    }
}
module.exports.GasPrice = $24dcb574f26d9e84$var$GasPrice;
function $24dcb574f26d9e84$var$calculateFee(gasLimit, { denom: denom, amount: gasPriceAmount }) {
    const amount = Math.ceil(gasPriceAmount.multiply(new $2lWwp.Uint53(gasLimit)).toFloatApproximation());
    return {
        amount: $g8Jau.coins(amount, denom),
        gas: gasLimit.toString()
    };
}
function $24dcb574f26d9e84$var$buildFeeTable(gasPrice, defaultGasLimits, gasLimits) {
    return Object.entries(defaultGasLimits).reduce((feeTable, [type, defaultGasLimit])=>Object.assign(Object.assign({}, feeTable), {
            [type]: $24dcb574f26d9e84$var$calculateFee(gasLimits[type] || defaultGasLimit, gasPrice)
        }), {});
}
module.exports.buildFeeTable = $24dcb574f26d9e84$var$buildFeeTable;

});

parcelRequire.register("9dUam", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.isMsgUndelegate = module.exports.isMsgBeginRedelegate = module.exports.isMsgDelegate = module.exports.isMsgEditValidator = module.exports.isMsgCreateValidator = module.exports.isMsgUnjail = module.exports.isMsgDeposit = module.exports.isMsgVote = module.exports.isMsgSubmitProposal = module.exports.isMsgSubmitEvidence = module.exports.isMsgFundCommunityPool = module.exports.isMsgWithdrawValidatorCommission = module.exports.isMsgWithdrawDelegatorReward = module.exports.isMsgSetWithdrawAddress = module.exports.isMsgVerifyInvariant = module.exports.isMsgMultiSend = module.exports.isMsgSend = void 0;
function $6b70e56544db483a$var$isMsgSend(msg) {
    return msg.type === "cosmos-sdk/MsgSend";
}
module.exports.isMsgSend = $6b70e56544db483a$var$isMsgSend;
function $6b70e56544db483a$var$isMsgMultiSend(msg) {
    return msg.type === "cosmos-sdk/MsgMultiSend";
}
module.exports.isMsgMultiSend = $6b70e56544db483a$var$isMsgMultiSend;
function $6b70e56544db483a$var$isMsgVerifyInvariant(msg) {
    return msg.type === "cosmos-sdk/MsgVerifyInvariant";
}
module.exports.isMsgVerifyInvariant = $6b70e56544db483a$var$isMsgVerifyInvariant;
function $6b70e56544db483a$var$isMsgSetWithdrawAddress(msg) {
    // NOTE: Type string and names diverge here!
    return msg.type === "cosmos-sdk/MsgModifyWithdrawAddress";
}
module.exports.isMsgSetWithdrawAddress = $6b70e56544db483a$var$isMsgSetWithdrawAddress;
function $6b70e56544db483a$var$isMsgWithdrawDelegatorReward(msg) {
    // NOTE: Type string and names diverge here!
    return msg.type === "cosmos-sdk/MsgWithdrawDelegationReward";
}
module.exports.isMsgWithdrawDelegatorReward = $6b70e56544db483a$var$isMsgWithdrawDelegatorReward;
function $6b70e56544db483a$var$isMsgWithdrawValidatorCommission(msg) {
    return msg.type === "cosmos-sdk/MsgWithdrawValidatorCommission";
}
module.exports.isMsgWithdrawValidatorCommission = $6b70e56544db483a$var$isMsgWithdrawValidatorCommission;
function $6b70e56544db483a$var$isMsgFundCommunityPool(msg) {
    return msg.type === "cosmos-sdk/MsgFundCommunityPool";
}
module.exports.isMsgFundCommunityPool = $6b70e56544db483a$var$isMsgFundCommunityPool;
function $6b70e56544db483a$var$isMsgSubmitEvidence(msg) {
    return msg.type === "cosmos-sdk/MsgSubmitEvidence";
}
module.exports.isMsgSubmitEvidence = $6b70e56544db483a$var$isMsgSubmitEvidence;
function $6b70e56544db483a$var$isMsgSubmitProposal(msg) {
    return msg.type === "cosmos-sdk/MsgSubmitProposal";
}
module.exports.isMsgSubmitProposal = $6b70e56544db483a$var$isMsgSubmitProposal;
var $6b70e56544db483a$var$VoteOption;
(function(VoteOption) {
    VoteOption[VoteOption["VoteOptionUnspecified"] = 0] = "VoteOptionUnspecified";
    VoteOption[VoteOption["VoteOptionYes"] = 1] = "VoteOptionYes";
    VoteOption[VoteOption["VoteOptionAbstain"] = 2] = "VoteOptionAbstain";
    VoteOption[VoteOption["VoteOptionNo"] = 3] = "VoteOptionNo";
    VoteOption[VoteOption["VoteOptionNoWithVeto"] = 4] = "VoteOptionNoWithVeto";
})($6b70e56544db483a$var$VoteOption || ($6b70e56544db483a$var$VoteOption = {}));
function $6b70e56544db483a$var$isMsgVote(msg) {
    return msg.type === "cosmos-sdk/MsgVote";
}
module.exports.isMsgVote = $6b70e56544db483a$var$isMsgVote;
function $6b70e56544db483a$var$isMsgDeposit(msg) {
    return msg.type === "cosmos-sdk/MsgDeposit";
}
module.exports.isMsgDeposit = $6b70e56544db483a$var$isMsgDeposit;
function $6b70e56544db483a$var$isMsgUnjail(msg) {
    return msg.type === "cosmos-sdk/MsgUnjail";
}
module.exports.isMsgUnjail = $6b70e56544db483a$var$isMsgUnjail;
function $6b70e56544db483a$var$isMsgCreateValidator(msg) {
    return msg.type === "cosmos-sdk/MsgCreateValidator";
}
module.exports.isMsgCreateValidator = $6b70e56544db483a$var$isMsgCreateValidator;
function $6b70e56544db483a$var$isMsgEditValidator(msg) {
    return msg.type === "cosmos-sdk/MsgEditValidator";
}
module.exports.isMsgEditValidator = $6b70e56544db483a$var$isMsgEditValidator;
function $6b70e56544db483a$var$isMsgDelegate(msg) {
    return msg.type === "cosmos-sdk/MsgDelegate";
}
module.exports.isMsgDelegate = $6b70e56544db483a$var$isMsgDelegate;
function $6b70e56544db483a$var$isMsgBeginRedelegate(msg) {
    return msg.type === "cosmos-sdk/MsgBeginRedelegate";
}
module.exports.isMsgBeginRedelegate = $6b70e56544db483a$var$isMsgBeginRedelegate;
function $6b70e56544db483a$var$isMsgUndelegate(msg) {
    return msg.type === "cosmos-sdk/MsgUndelegate";
}
module.exports.isMsgUndelegate = $6b70e56544db483a$var$isMsgUndelegate; // upgrade (no messages) - see https://github.com/cosmos/cosmos-sdk/blob/efa73c7/proto/cosmos/upgrade/upgrade.proto

});

parcelRequire.register("iT2DG", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.makeCosmoshubPath = void 0;

var $3cQ9Q = parcelRequire("3cQ9Q");
/**
 * The Cosmos Hub derivation path in the form `m/44'/118'/0'/0/a`
 * with 0-based account index `a`.
 */ function $dbff69200f5cb777$var$makeCosmoshubPath(a) {
    return [
        $3cQ9Q.Slip10RawIndex.hardened(44),
        $3cQ9Q.Slip10RawIndex.hardened(118),
        $3cQ9Q.Slip10RawIndex.hardened(0),
        $3cQ9Q.Slip10RawIndex.normal(0),
        $3cQ9Q.Slip10RawIndex.normal(a)
    ];
}
module.exports.makeCosmoshubPath = $dbff69200f5cb777$var$makeCosmoshubPath;

});

parcelRequire.register("7DFKe", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.findSequenceForSignedTx = void 0;

var $3cQ9Q = parcelRequire("3cQ9Q");

var $axITl = parcelRequire("axITl");

var $5QnXl = parcelRequire("5QnXl");
/**
 * Serach for sequence s with `min` <= `s` < `upperBound` to find the sequence that was used to sign the transaction
 *
 * @param tx The signed transaction
 * @param chainId The chain ID for which this transaction was signed
 * @param accountNumber The account number for which this transaction was signed
 * @param upperBound The upper bound for the testing, i.e. sequence must be lower than this value
 * @param min The lowest sequence that is tested
 *
 * @returns the sequence if a match was found and undefined otherwise
 */ async function $58fc8e8f035dd7eb$var$findSequenceForSignedTx(tx, chainId, accountNumber, upperBound, min = 0) {
    const firstSignature = tx.value.signatures.find(()=>true);
    if (!firstSignature) throw new Error("Signature missing in tx");
    const { pubkey: pubkey, signature: signature } = $5QnXl.decodeSignature(firstSignature);
    const secp256keSignature = $3cQ9Q.Secp256k1Signature.fromFixedLength(signature);
    for(let s = min; s < upperBound; s++){
        // console.log(`Trying sequence ${s}`);
        const signBytes = $axITl.serializeSignDoc($axITl.makeSignDoc(tx.value.msg, tx.value.fee, chainId, tx.value.memo || "", accountNumber, s));
        const prehashed = $3cQ9Q.sha256(signBytes);
        const valid = await $3cQ9Q.Secp256k1.verifySignature(secp256keSignature, prehashed, pubkey);
        if (valid) return s;
    }
    return undefined;
}
module.exports.findSequenceForSignedTx = $58fc8e8f035dd7eb$var$findSequenceForSignedTx;

});
parcelRequire.register("5QnXl", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.decodeSignature = module.exports.encodeSecp256k1Signature = void 0;

var $5a6Ix = parcelRequire("5a6Ix");

var $7rDC2 = parcelRequire("7rDC2");

var $dbARm = parcelRequire("dbARm");
/**
 * Takes a binary pubkey and signature to create a signature object
 *
 * @param pubkey a compressed secp256k1 public key
 * @param signature a 64 byte fixed length representation of secp256k1 signature components r and s
 */ function $4414644c6b946cad$var$encodeSecp256k1Signature(pubkey, signature) {
    if (signature.length !== 64) throw new Error("Signature must be 64 bytes long. Cosmos SDK uses a 2x32 byte fixed length encoding for the secp256k1 signature integers r and s.");
    return {
        pub_key: $7rDC2.encodeSecp256k1Pubkey(pubkey),
        signature: $5a6Ix.toBase64(signature)
    };
}
module.exports.encodeSecp256k1Signature = $4414644c6b946cad$var$encodeSecp256k1Signature;
function $4414644c6b946cad$var$decodeSignature(signature) {
    switch(signature.pub_key.type){
        // Note: please don't add cases here without writing additional unit tests
        case $dbARm.pubkeyType.secp256k1:
            return {
                pubkey: $5a6Ix.fromBase64(signature.pub_key.value),
                signature: $5a6Ix.fromBase64(signature.signature)
            };
        default:
            throw new Error("Unsupported pubkey type");
    }
}
module.exports.decodeSignature = $4414644c6b946cad$var$decodeSignature;

});


parcelRequire.register("eG3rn", function(module, exports) {
"use strict";
var $aaf7a82cfbaf85ed$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SigningCosmosClient = void 0;

/* eslint-disable @typescript-eslint/naming-convention */ const $aaf7a82cfbaf85ed$var$fast_deep_equal_1 = $aaf7a82cfbaf85ed$var$__importDefault((parcelRequire("iLExI")));

var $1CFPF = parcelRequire("1CFPF");

var $axITl = parcelRequire("axITl");

var $3adpy = parcelRequire("3adpy");

var $9XjFJ = parcelRequire("9XjFJ");

var $cfACW = parcelRequire("cfACW");
const $aaf7a82cfbaf85ed$var$defaultGasPrice = $3adpy.GasPrice.fromString("0.025ucosm");
const $aaf7a82cfbaf85ed$var$defaultGasLimits = {
    send: 80000
};
class $aaf7a82cfbaf85ed$var$SigningCosmosClient extends $1CFPF.CosmosClient {
    /**
     * Creates a new client with signing capability to interact with a Cosmos SDK blockchain. This is the bigger brother of CosmosClient.
     *
     * This instance does a lot of caching. In order to benefit from that you should try to use one instance
     * for the lifetime of your application. When switching backends, a new instance must be created.
     *
     * @param apiUrl The URL of a Cosmos SDK light client daemon API (sometimes called REST server or REST API)
     * @param signerAddress The address that will sign transactions using this instance. The `signer` must be able to sign with this address.
     * @param signer An implementation of OfflineSigner which can provide signatures for transactions, potentially requiring user input.
     * @param gasPrice The price paid per unit of gas
     * @param gasLimits Custom overrides for gas limits related to specific transaction types
     * @param broadcastMode Defines at which point of the transaction processing the broadcastTx method returns
     */ constructor(apiUrl, signerAddress, signer, gasPrice = $aaf7a82cfbaf85ed$var$defaultGasPrice, gasLimits = {}, broadcastMode = $9XjFJ.BroadcastMode.Block){
        super(apiUrl, broadcastMode);
        this.anyValidAddress = signerAddress;
        this.signerAddress = signerAddress;
        this.signer = signer;
        this.fees = $3adpy.buildFeeTable(gasPrice, $aaf7a82cfbaf85ed$var$defaultGasLimits, gasLimits);
    }
    async getSequence(address) {
        return super.getSequence(address || this.signerAddress);
    }
    async getAccount(address) {
        return super.getAccount(address || this.signerAddress);
    }
    async sendTokens(recipientAddress, transferAmount, memo = "") {
        const sendMsg = {
            type: "cosmos-sdk/MsgSend",
            value: {
                from_address: this.signerAddress,
                to_address: recipientAddress,
                amount: transferAmount
            }
        };
        return this.signAndBroadcast([
            sendMsg
        ], this.fees.send, memo);
    }
    /**
     * Gets account number and sequence from the API, creates a sign doc,
     * creates a single signature, assembles the signed transaction and broadcasts it.
     */ async signAndBroadcast(msgs, fee, memo = "") {
        const signedTx = await this.sign(msgs, fee, memo);
        return this.broadcastTx(signedTx);
    }
    /**
     * Gets account number and sequence from the API, creates a sign doc,
     * creates a single signature and assembles the signed transaction.
     */ async sign(msgs, fee, memo = "") {
        const { accountNumber: accountNumber, sequence: sequence } = await this.getSequence();
        const chainId = await this.getChainId();
        const signDoc = $axITl.makeSignDoc(msgs, fee, chainId, memo, accountNumber, sequence);
        const { signed: signed, signature: signature } = await this.signer.signAmino(this.signerAddress, signDoc);
        return $cfACW.makeStdTx(signed, signature);
    }
    /**
     * Gets account number and sequence from the API, creates a sign doc,
     * creates a single signature and appends it to the existing signatures.
     */ async appendSignature(signedTx) {
        const { msg: msgs, fee: fee, memo: memo } = signedTx;
        const { accountNumber: accountNumber, sequence: sequence } = await this.getSequence();
        const chainId = await this.getChainId();
        const signDoc = $axITl.makeSignDoc(msgs, fee, chainId, memo, accountNumber, sequence);
        const { signed: signed, signature: additionalSignature } = await this.signer.signAmino(this.signerAddress, signDoc);
        if (!$aaf7a82cfbaf85ed$var$fast_deep_equal_1.default(signDoc, signed)) throw new Error("The signed document differs from the one of the original transaction. This is not allowed since the resulting transaction will be invalid.");
        return $cfACW.makeStdTx(signed, [
            ...signedTx.signatures,
            additionalSignature
        ]);
    }
}
module.exports.SigningCosmosClient = $aaf7a82cfbaf85ed$var$SigningCosmosClient;

});
parcelRequire.register("cfACW", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.isWrappedStdTx = module.exports.makeStdTx = module.exports.isStdTx = void 0;
function $8eb34c241e64be42$var$isStdTx(txValue) {
    const { memo: memo, msg: msg, fee: fee, signatures: signatures } = txValue;
    return typeof memo === "string" && Array.isArray(msg) && typeof fee === "object" && Array.isArray(signatures);
}
module.exports.isStdTx = $8eb34c241e64be42$var$isStdTx;
function $8eb34c241e64be42$var$makeStdTx(content, signatures) {
    return {
        msg: content.msgs,
        fee: content.fee,
        memo: content.memo,
        signatures: Array.isArray(signatures) ? signatures : [
            signatures
        ]
    };
}
module.exports.makeStdTx = $8eb34c241e64be42$var$makeStdTx;
function $8eb34c241e64be42$var$isWrappedStdTx(wrapped) {
    return wrapped.type === "cosmos-sdk/StdTx" && $8eb34c241e64be42$var$isStdTx(wrapped.value);
}
module.exports.isWrappedStdTx = $8eb34c241e64be42$var$isWrappedStdTx;

});


parcelRequire.register("5xZH4", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.decrypt = module.exports.encrypt = module.exports.supportedAlgorithms = module.exports.executeKdf = module.exports.cosmjsSalt = void 0;

var $3cQ9Q = parcelRequire("3cQ9Q");

var $5a6Ix = parcelRequire("5a6Ix");
/**
 * A fixed salt is chosen to archive a deterministic password to key derivation.
 * This reduces the scope of a potential rainbow attack to all CosmJS users.
 * Must be 16 bytes due to implementation limitations.
 */ module.exports.cosmjsSalt = $5a6Ix.toAscii("The CosmJS salt.");
async function $409fe3e318488f4b$var$executeKdf(password, configuration) {
    switch(configuration.algorithm){
        case "argon2id":
            {
                const options = configuration.params;
                if (!$3cQ9Q.isArgon2idOptions(options)) throw new Error("Invalid format of argon2id params");
                return $3cQ9Q.Argon2id.execute(password, module.exports.cosmjsSalt, options);
            }
        default:
            throw new Error("Unsupported KDF algorithm");
    }
}
module.exports.executeKdf = $409fe3e318488f4b$var$executeKdf;
module.exports.supportedAlgorithms = {
    xchacha20poly1305Ietf: "xchacha20poly1305-ietf"
};
async function $409fe3e318488f4b$var$encrypt(plaintext, encryptionKey, config) {
    switch(config.algorithm){
        case module.exports.supportedAlgorithms.xchacha20poly1305Ietf:
            {
                const nonce = $3cQ9Q.Random.getBytes($3cQ9Q.xchacha20NonceLength);
                // Prepend fixed-length nonce to ciphertext as suggested in the example from https://github.com/jedisct1/libsodium.js#api
                return new Uint8Array([
                    ...nonce,
                    ...await $3cQ9Q.Xchacha20poly1305Ietf.encrypt(plaintext, encryptionKey, nonce)
                ]);
            }
        default:
            throw new Error(`Unsupported encryption algorithm: '${config.algorithm}'`);
    }
}
module.exports.encrypt = $409fe3e318488f4b$var$encrypt;
async function $409fe3e318488f4b$var$decrypt(ciphertext, encryptionKey, config) {
    switch(config.algorithm){
        case module.exports.supportedAlgorithms.xchacha20poly1305Ietf:
            {
                const nonce = ciphertext.slice(0, $3cQ9Q.xchacha20NonceLength);
                return $3cQ9Q.Xchacha20poly1305Ietf.decrypt(ciphertext.slice($3cQ9Q.xchacha20NonceLength), encryptionKey, nonce);
            }
        default:
            throw new Error(`Unsupported encryption algorithm: '${config.algorithm}'`);
    }
}
module.exports.decrypt = $409fe3e318488f4b$var$decrypt;

});

parcelRequire.register("jzhTI", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Secp256k1HdWallet = module.exports.extractKdfConfiguration = void 0;

var $3cQ9Q = parcelRequire("3cQ9Q");

var $5a6Ix = parcelRequire("5a6Ix");

var $gYZZP = parcelRequire("gYZZP");

var $cF9EI = parcelRequire("cF9EI");

var $axITl = parcelRequire("axITl");

var $iT2DG = parcelRequire("iT2DG");

var $5QnXl = parcelRequire("5QnXl");

var $5xZH4 = parcelRequire("5xZH4");
const $e3ef2b4fba5fe8d2$var$serializationTypeV1 = "secp256k1wallet-v1";
/**
 * A KDF configuration that is not very strong but can be used on the main thread.
 * It takes about 1 second in Node.js 12.15 and should have similar runtimes in other modern Wasm hosts.
 */ const $e3ef2b4fba5fe8d2$var$basicPasswordHashingOptions = {
    algorithm: "argon2id",
    params: {
        outputLength: 32,
        opsLimit: 20,
        memLimitKib: 12288
    }
};
function $e3ef2b4fba5fe8d2$var$isDerivationJson(thing) {
    if (!$gYZZP.isNonNullObject(thing)) return false;
    if (typeof thing.hdPath !== "string") return false;
    if (typeof thing.prefix !== "string") return false;
    return true;
}
function $e3ef2b4fba5fe8d2$var$extractKdfConfigurationV1(doc) {
    return doc.kdf;
}
function $e3ef2b4fba5fe8d2$var$extractKdfConfiguration(serialization) {
    const root = JSON.parse(serialization);
    if (!$gYZZP.isNonNullObject(root)) throw new Error("Root document is not an object.");
    switch(root.type){
        case $e3ef2b4fba5fe8d2$var$serializationTypeV1:
            return $e3ef2b4fba5fe8d2$var$extractKdfConfigurationV1(root);
        default:
            throw new Error("Unsupported serialization type");
    }
}
module.exports.extractKdfConfiguration = $e3ef2b4fba5fe8d2$var$extractKdfConfiguration;
class $e3ef2b4fba5fe8d2$var$Secp256k1HdWallet {
    constructor(mnemonic, hdPath, privkey, pubkey, prefix){
        this.secret = mnemonic;
        this.accounts = [
            {
                hdPath: hdPath,
                prefix: prefix
            }
        ];
        this.privkey = privkey;
        this.pubkey = pubkey;
    }
    /**
     * Restores a wallet from the given BIP39 mnemonic.
     *
     * @param mnemonic Any valid English mnemonic.
     * @param hdPath The BIP-32/SLIP-10 derivation path. Defaults to the Cosmos Hub/ATOM path `m/44'/118'/0'/0/0`.
     * @param prefix The bech32 address prefix (human readable part). Defaults to "cosmos".
     */ static async fromMnemonic(mnemonic, hdPath = $iT2DG.makeCosmoshubPath(0), prefix = "cosmos") {
        const mnemonicChecked = new $3cQ9Q.EnglishMnemonic(mnemonic);
        const seed = await $3cQ9Q.Bip39.mnemonicToSeed(mnemonicChecked);
        const { privkey: privkey } = $3cQ9Q.Slip10.derivePath($3cQ9Q.Slip10Curve.Secp256k1, seed, hdPath);
        const uncompressed = (await $3cQ9Q.Secp256k1.makeKeypair(privkey)).pubkey;
        return new $e3ef2b4fba5fe8d2$var$Secp256k1HdWallet(mnemonicChecked, hdPath, privkey, $3cQ9Q.Secp256k1.compressPubkey(uncompressed), prefix);
    }
    /**
     * Generates a new wallet with a BIP39 mnemonic of the given length.
     *
     * @param length The number of words in the mnemonic (12, 15, 18, 21 or 24).
     * @param hdPath The BIP-32/SLIP-10 derivation path. Defaults to the Cosmos Hub/ATOM path `m/44'/118'/0'/0/0`.
     * @param prefix The bech32 address prefix (human readable part). Defaults to "cosmos".
     */ static async generate(length = 12, hdPath = $iT2DG.makeCosmoshubPath(0), prefix = "cosmos") {
        const entropyLength = 4 * Math.floor(11 * length / 33);
        const entropy = $3cQ9Q.Random.getBytes(entropyLength);
        const mnemonic = $3cQ9Q.Bip39.encode(entropy);
        return $e3ef2b4fba5fe8d2$var$Secp256k1HdWallet.fromMnemonic(mnemonic.toString(), hdPath, prefix);
    }
    /**
     * Restores a wallet from an encrypted serialization.
     *
     * @param password The user provided password used to generate an encryption key via a KDF.
     *                 This is not normalized internally (see "Unicode normalization" to learn more).
     */ static async deserialize(serialization, password) {
        const root = JSON.parse(serialization);
        if (!$gYZZP.isNonNullObject(root)) throw new Error("Root document is not an object.");
        switch(root.type){
            case $e3ef2b4fba5fe8d2$var$serializationTypeV1:
                return $e3ef2b4fba5fe8d2$var$Secp256k1HdWallet.deserializeTypeV1(serialization, password);
            default:
                throw new Error("Unsupported serialization type");
        }
    }
    /**
     * Restores a wallet from an encrypted serialization.
     *
     * This is an advanced alternative to calling `deserialize(serialization, password)` directly, which allows
     * you to offload the KDF execution to a non-UI thread (e.g. in a WebWorker).
     *
     * The caller is responsible for ensuring the key was derived with the given KDF configuration. This can be
     * done using `extractKdfConfiguration(serialization)` and `executeKdf(password, kdfConfiguration)` from this package.
     */ static async deserializeWithEncryptionKey(serialization, encryptionKey) {
        const root = JSON.parse(serialization);
        if (!$gYZZP.isNonNullObject(root)) throw new Error("Root document is not an object.");
        const untypedRoot = root;
        switch(untypedRoot.type){
            case $e3ef2b4fba5fe8d2$var$serializationTypeV1:
                {
                    const decryptedBytes = await $5xZH4.decrypt($5a6Ix.fromBase64(untypedRoot.data), encryptionKey, untypedRoot.encryption);
                    const decryptedDocument = JSON.parse($5a6Ix.fromUtf8(decryptedBytes));
                    const { mnemonic: mnemonic, accounts: accounts } = decryptedDocument;
                    $gYZZP.assert(typeof mnemonic === "string");
                    if (!Array.isArray(accounts)) throw new Error("Property 'accounts' is not an array");
                    if (accounts.length !== 1) throw new Error("Property 'accounts' only supports one entry");
                    const account = accounts[0];
                    if (!$e3ef2b4fba5fe8d2$var$isDerivationJson(account)) throw new Error("Account is not in the correct format.");
                    return $e3ef2b4fba5fe8d2$var$Secp256k1HdWallet.fromMnemonic(mnemonic, $3cQ9Q.stringToPath(account.hdPath), account.prefix);
                }
            default:
                throw new Error("Unsupported serialization type");
        }
    }
    static async deserializeTypeV1(serialization, password) {
        const root = JSON.parse(serialization);
        if (!$gYZZP.isNonNullObject(root)) throw new Error("Root document is not an object.");
        const encryptionKey = await $5xZH4.executeKdf(password, root.kdf);
        return $e3ef2b4fba5fe8d2$var$Secp256k1HdWallet.deserializeWithEncryptionKey(serialization, encryptionKey);
    }
    get mnemonic() {
        return this.secret.toString();
    }
    get address() {
        return $cF9EI.rawSecp256k1PubkeyToAddress(this.pubkey, this.accounts[0].prefix);
    }
    async getAccounts() {
        return [
            {
                algo: "secp256k1",
                address: this.address,
                pubkey: this.pubkey
            }
        ];
    }
    async signAmino(signerAddress, signDoc) {
        if (signerAddress !== this.address) throw new Error(`Address ${signerAddress} not found in wallet`);
        const message = $3cQ9Q.sha256($axITl.serializeSignDoc(signDoc));
        const signature = await $3cQ9Q.Secp256k1.createSignature(message, this.privkey);
        const signatureBytes = new Uint8Array([
            ...signature.r(32),
            ...signature.s(32)
        ]);
        return {
            signed: signDoc,
            signature: $5QnXl.encodeSecp256k1Signature(this.pubkey, signatureBytes)
        };
    }
    /**
     * Generates an encrypted serialization of this wallet.
     *
     * @param password The user provided password used to generate an encryption key via a KDF.
     *                 This is not normalized internally (see "Unicode normalization" to learn more).
     */ async serialize(password) {
        const kdfConfiguration = $e3ef2b4fba5fe8d2$var$basicPasswordHashingOptions;
        const encryptionKey = await $5xZH4.executeKdf(password, kdfConfiguration);
        return this.serializeWithEncryptionKey(encryptionKey, kdfConfiguration);
    }
    /**
     * Generates an encrypted serialization of this wallet.
     *
     * This is an advanced alternative to calling `serialize(password)` directly, which allows you to
     * offload the KDF execution to a non-UI thread (e.g. in a WebWorker).
     *
     * The caller is responsible for ensuring the key was derived with the given KDF options. If this
     * is not the case, the wallet cannot be restored with the original password.
     */ async serializeWithEncryptionKey(encryptionKey, kdfConfiguration) {
        const dataToEncrypt = {
            mnemonic: this.mnemonic,
            accounts: this.accounts.map((account)=>({
                    hdPath: $3cQ9Q.pathToString(account.hdPath),
                    prefix: account.prefix
                }))
        };
        const dataToEncryptRaw = $5a6Ix.toUtf8(JSON.stringify(dataToEncrypt));
        const encryptionConfiguration = {
            algorithm: $5xZH4.supportedAlgorithms.xchacha20poly1305Ietf
        };
        const encryptedData = await $5xZH4.encrypt(dataToEncryptRaw, encryptionKey, encryptionConfiguration);
        const out = {
            type: $e3ef2b4fba5fe8d2$var$serializationTypeV1,
            kdf: kdfConfiguration,
            encryption: encryptionConfiguration,
            data: $5a6Ix.toBase64(encryptedData)
        };
        return JSON.stringify(out);
    }
}
module.exports.Secp256k1HdWallet = $e3ef2b4fba5fe8d2$var$Secp256k1HdWallet;

});

parcelRequire.register("8Rl4Z", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Secp256k1Wallet = void 0;

var $3cQ9Q = parcelRequire("3cQ9Q");

var $cF9EI = parcelRequire("cF9EI");

var $axITl = parcelRequire("axITl");

var $5QnXl = parcelRequire("5QnXl");
/**
 * A wallet that holds a single secp256k1 keypair.
 *
 * If you want to work with BIP39 mnemonics and multiple accounts, use Secp256k1HdWallet.
 */ class $67339fef64b06962$var$Secp256k1Wallet {
    constructor(privkey, pubkey, prefix){
        this.privkey = privkey;
        this.pubkey = pubkey;
        this.prefix = prefix;
    }
    /**
     * Creates a Secp256k1Wallet from the given private key
     *
     * @param privkey The private key.
     * @param prefix The bech32 address prefix (human readable part). Defaults to "cosmos".
     */ static async fromKey(privkey, prefix = "cosmos") {
        const uncompressed = (await $3cQ9Q.Secp256k1.makeKeypair(privkey)).pubkey;
        return new $67339fef64b06962$var$Secp256k1Wallet(privkey, $3cQ9Q.Secp256k1.compressPubkey(uncompressed), prefix);
    }
    get address() {
        return $cF9EI.rawSecp256k1PubkeyToAddress(this.pubkey, this.prefix);
    }
    async getAccounts() {
        return [
            {
                algo: "secp256k1",
                address: this.address,
                pubkey: this.pubkey
            }
        ];
    }
    async signAmino(signerAddress, signDoc) {
        if (signerAddress !== this.address) throw new Error(`Address ${signerAddress} not found in wallet`);
        const message = new $3cQ9Q.Sha256($axITl.serializeSignDoc(signDoc)).digest();
        const signature = await $3cQ9Q.Secp256k1.createSignature(message, this.privkey);
        const signatureBytes = new Uint8Array([
            ...signature.r(32),
            ...signature.s(32)
        ]);
        return {
            signed: signDoc,
            signature: $5QnXl.encodeSecp256k1Signature(this.pubkey, signatureBytes)
        };
    }
}
module.exports.Secp256k1Wallet = $67339fef64b06962$var$Secp256k1Wallet;

});


parcelRequire.register("hkK8Z", function(module, exports) {
"use strict";
var $c9e81926954056aa$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, {
        enumerable: true,
        get: function() {
            return m[k];
        }
    });
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $c9e81926954056aa$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $c9e81926954056aa$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$c9e81926954056aa$var$__exportStar((parcelRequire("ewTme")), module.exports);

$c9e81926954056aa$var$__exportStar((parcelRequire("eMsup")), module.exports);

$c9e81926954056aa$var$__exportStar((parcelRequire("i1G9i")), module.exports);

});
parcelRequire.register("ewTme", function(module, exports) {
"use strict";
var $a93efeb1ff5efce6$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Mnemonic = void 0;

var $5qnT8 = parcelRequire("5qnT8");

var $8AB7q = parcelRequire("8AB7q");

var $je616 = parcelRequire("je616");
class $a93efeb1ff5efce6$var$Mnemonic {
    static generateWallet(rng, path = `m/44'/118'/0'/0/0`, password = "", strength = 256) {
        return $a93efeb1ff5efce6$var$__awaiter(this, void 0, void 0, function*() {
            const mnemonic = yield $a93efeb1ff5efce6$var$Mnemonic.generateSeed(rng, strength);
            const privKey = $a93efeb1ff5efce6$var$Mnemonic.generateWalletFromMnemonic(mnemonic, path, password);
            return {
                privKey: privKey,
                mnemonic: mnemonic
            };
        });
    }
    static validateMnemonic(mnemonic) {
        $5qnT8.validateMnemonic(mnemonic);
    }
    static generateSeed(rng, strength = 128) {
        return $a93efeb1ff5efce6$var$__awaiter(this, void 0, void 0, function*() {
            if (strength % 32 !== 0) throw new TypeError("invalid entropy");
            let bytes = new Uint8Array(strength / 8);
            bytes = yield rng(bytes);
            return $5qnT8.entropyToMnemonic($je616.Buffer.from(bytes).toString("hex"));
        });
    }
    static generateWalletFromMnemonic(mnemonic, path = `m/44'/118'/0'/0/0`, password = "") {
        const seed = $5qnT8.mnemonicToSeedSync(mnemonic, password);
        const masterKey = $8AB7q.fromSeed(seed);
        const hd = masterKey.derivePath(path);
        const privateKey = hd.privateKey;
        if (!privateKey) throw new Error("null hd key");
        return privateKey;
    }
}
module.exports.Mnemonic = $a93efeb1ff5efce6$var$Mnemonic;

});
parcelRequire.register("8AB7q", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $jzgQH = parcelRequire("jzgQH");
module.exports.fromSeed = $jzgQH.fromSeed;
module.exports.fromBase58 = $jzgQH.fromBase58;
module.exports.fromPublicKey = $jzgQH.fromPublicKey;
module.exports.fromPrivateKey = $jzgQH.fromPrivateKey;

});
parcelRequire.register("jzgQH", function(module, exports) {

var $ihoyg = parcelRequire("ihoyg");
var $e3ee5b147894d49f$require$Buffer = $ihoyg.Buffer;
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $fuOE5 = parcelRequire("fuOE5");

var $1Vf4C = parcelRequire("1Vf4C");

var $bAAqK = parcelRequire("bAAqK");

var $bDP98 = parcelRequire("bDP98");

var $bTFmB = parcelRequire("bTFmB");
const $e3ee5b147894d49f$var$UINT256_TYPE = $bDP98.BufferN(32);
const $e3ee5b147894d49f$var$NETWORK_TYPE = $bDP98.compile({
    wif: $bDP98.UInt8,
    bip32: {
        public: $bDP98.UInt32,
        private: $bDP98.UInt32
    }
});
const $e3ee5b147894d49f$var$BITCOIN = {
    messagePrefix: "\x18Bitcoin Signed Message:\n",
    bech32: "bc",
    bip32: {
        public: 0x0488b21e,
        private: 0x0488ade4
    },
    pubKeyHash: 0x00,
    scriptHash: 0x05,
    wif: 0x80
};
const $e3ee5b147894d49f$var$HIGHEST_BIT = 0x80000000;
const $e3ee5b147894d49f$var$UINT31_MAX = Math.pow(2, 31) - 1;
function $e3ee5b147894d49f$var$BIP32Path(value) {
    return $bDP98.String(value) && value.match(/^(m\/)?(\d+'?\/)*\d+'?$/) !== null;
}
function $e3ee5b147894d49f$var$UInt31(value) {
    return $bDP98.UInt32(value) && value <= $e3ee5b147894d49f$var$UINT31_MAX;
}
class $e3ee5b147894d49f$var$BIP32 {
    constructor(__D, __Q, chainCode, network, __DEPTH = 0, __INDEX = 0, __PARENT_FINGERPRINT = 0x00000000){
        this.__D = __D;
        this.__Q = __Q;
        this.chainCode = chainCode;
        this.network = network;
        this.__DEPTH = __DEPTH;
        this.__INDEX = __INDEX;
        this.__PARENT_FINGERPRINT = __PARENT_FINGERPRINT;
        $bDP98($e3ee5b147894d49f$var$NETWORK_TYPE, network);
        this.lowR = false;
    }
    get depth() {
        return this.__DEPTH;
    }
    get index() {
        return this.__INDEX;
    }
    get parentFingerprint() {
        return this.__PARENT_FINGERPRINT;
    }
    get publicKey() {
        if (this.__Q === undefined) this.__Q = $bAAqK.pointFromScalar(this.__D, true);
        return this.__Q;
    }
    get privateKey() {
        return this.__D;
    }
    get identifier() {
        return $fuOE5.hash160(this.publicKey);
    }
    get fingerprint() {
        return this.identifier.slice(0, 4);
    }
    get compressed() {
        return true;
    }
    // Private === not neutered
    // Public === neutered
    isNeutered() {
        return this.__D === undefined;
    }
    neutered() {
        return $e3ee5b147894d49f$var$fromPublicKeyLocal(this.publicKey, this.chainCode, this.network, this.depth, this.index, this.parentFingerprint);
    }
    toBase58() {
        const network = this.network;
        const version = !this.isNeutered() ? network.bip32.private : network.bip32.public;
        const buffer = $e3ee5b147894d49f$require$Buffer.allocUnsafe(78);
        // 4 bytes: version bytes
        buffer.writeUInt32BE(version, 0);
        // 1 byte: depth: 0x00 for master nodes, 0x01 for level-1 descendants, ....
        buffer.writeUInt8(this.depth, 4);
        // 4 bytes: the fingerprint of the parent's key (0x00000000 if master key)
        buffer.writeUInt32BE(this.parentFingerprint, 5);
        // 4 bytes: child number. This is the number i in xi = xpar/i, with xi the key being serialized.
        // This is encoded in big endian. (0x00000000 if master key)
        buffer.writeUInt32BE(this.index, 9);
        // 32 bytes: the chain code
        this.chainCode.copy(buffer, 13);
        // 33 bytes: the public key or private key data
        if (!this.isNeutered()) {
            // 0x00 + k for private keys
            buffer.writeUInt8(0, 45);
            this.privateKey.copy(buffer, 46);
        // 33 bytes: the public key
        } else // X9.62 encoding for public keys
        this.publicKey.copy(buffer, 45);
        return $1Vf4C.encode(buffer);
    }
    toWIF() {
        if (!this.privateKey) throw new TypeError("Missing private key");
        return $bTFmB.encode(this.network.wif, this.privateKey, true);
    }
    // https://github.com/bitcoin/bips/blob/master/bip-0032.mediawiki#child-key-derivation-ckd-functions
    derive(index) {
        $bDP98($bDP98.UInt32, index);
        const isHardened = index >= $e3ee5b147894d49f$var$HIGHEST_BIT;
        const data = $e3ee5b147894d49f$require$Buffer.allocUnsafe(37);
        // Hardened child
        if (isHardened) {
            if (this.isNeutered()) throw new TypeError("Missing private key for hardened child key");
            // data = 0x00 || ser256(kpar) || ser32(index)
            data[0] = 0x00;
            this.privateKey.copy(data, 1);
            data.writeUInt32BE(index, 33);
        // Normal child
        } else {
            // data = serP(point(kpar)) || ser32(index)
            //      = serP(Kpar) || ser32(index)
            this.publicKey.copy(data, 0);
            data.writeUInt32BE(index, 33);
        }
        const I = $fuOE5.hmacSHA512(this.chainCode, data);
        const IL = I.slice(0, 32);
        const IR = I.slice(32);
        // if parse256(IL) >= n, proceed with the next value for i
        if (!$bAAqK.isPrivate(IL)) return this.derive(index + 1);
        // Private parent key -> private child key
        let hd;
        if (!this.isNeutered()) {
            // ki = parse256(IL) + kpar (mod n)
            const ki = $bAAqK.privateAdd(this.privateKey, IL);
            // In case ki == 0, proceed with the next value for i
            if (ki == null) return this.derive(index + 1);
            hd = $e3ee5b147894d49f$var$fromPrivateKeyLocal(ki, IR, this.network, this.depth + 1, index, this.fingerprint.readUInt32BE(0));
        // Public parent key -> public child key
        } else {
            // Ki = point(parse256(IL)) + Kpar
            //    = G*IL + Kpar
            const Ki = $bAAqK.pointAddScalar(this.publicKey, IL, true);
            // In case Ki is the point at infinity, proceed with the next value for i
            if (Ki === null) return this.derive(index + 1);
            hd = $e3ee5b147894d49f$var$fromPublicKeyLocal(Ki, IR, this.network, this.depth + 1, index, this.fingerprint.readUInt32BE(0));
        }
        return hd;
    }
    deriveHardened(index) {
        $bDP98($e3ee5b147894d49f$var$UInt31, index);
        // Only derives hardened private keys by default
        return this.derive(index + $e3ee5b147894d49f$var$HIGHEST_BIT);
    }
    derivePath(path) {
        $bDP98($e3ee5b147894d49f$var$BIP32Path, path);
        let splitPath = path.split("/");
        if (splitPath[0] === "m") {
            if (this.parentFingerprint) throw new TypeError("Expected master, got child");
            splitPath = splitPath.slice(1);
        }
        return splitPath.reduce((prevHd, indexStr)=>{
            let index;
            if (indexStr.slice(-1) === `'`) {
                index = parseInt(indexStr.slice(0, -1), 10);
                return prevHd.deriveHardened(index);
            } else {
                index = parseInt(indexStr, 10);
                return prevHd.derive(index);
            }
        }, this);
    }
    sign(hash, lowR) {
        if (!this.privateKey) throw new Error("Missing private key");
        if (lowR === undefined) lowR = this.lowR;
        if (lowR === false) return $bAAqK.sign(hash, this.privateKey);
        else {
            let sig = $bAAqK.sign(hash, this.privateKey);
            const extraData = $e3ee5b147894d49f$require$Buffer.alloc(32, 0);
            let counter = 0;
            // if first try is lowR, skip the loop
            // for second try and on, add extra entropy counting up
            while(sig[0] > 0x7f){
                counter++;
                extraData.writeUIntLE(counter, 0, 6);
                sig = $bAAqK.signWithEntropy(hash, this.privateKey, extraData);
            }
            return sig;
        }
    }
    verify(hash, signature) {
        return $bAAqK.verify(hash, this.publicKey, signature);
    }
}
function $e3ee5b147894d49f$var$fromBase58(inString, network) {
    const buffer = $1Vf4C.decode(inString);
    if (buffer.length !== 78) throw new TypeError("Invalid buffer length");
    network = network || $e3ee5b147894d49f$var$BITCOIN;
    // 4 bytes: version bytes
    const version = buffer.readUInt32BE(0);
    if (version !== network.bip32.private && version !== network.bip32.public) throw new TypeError("Invalid network version");
    // 1 byte: depth: 0x00 for master nodes, 0x01 for level-1 descendants, ...
    const depth = buffer[4];
    // 4 bytes: the fingerprint of the parent's key (0x00000000 if master key)
    const parentFingerprint = buffer.readUInt32BE(5);
    if (depth === 0) {
        if (parentFingerprint !== 0x00000000) throw new TypeError("Invalid parent fingerprint");
    }
    // 4 bytes: child number. This is the number i in xi = xpar/i, with xi the key being serialized.
    // This is encoded in MSB order. (0x00000000 if master key)
    const index = buffer.readUInt32BE(9);
    if (depth === 0 && index !== 0) throw new TypeError("Invalid index");
    // 32 bytes: the chain code
    const chainCode = buffer.slice(13, 45);
    let hd;
    // 33 bytes: private key data (0x00 + k)
    if (version === network.bip32.private) {
        if (buffer.readUInt8(45) !== 0x00) throw new TypeError("Invalid private key");
        const k = buffer.slice(46, 78);
        hd = $e3ee5b147894d49f$var$fromPrivateKeyLocal(k, chainCode, network, depth, index, parentFingerprint);
    // 33 bytes: public key data (0x02 + X or 0x03 + X)
    } else {
        const X = buffer.slice(45, 78);
        hd = $e3ee5b147894d49f$var$fromPublicKeyLocal(X, chainCode, network, depth, index, parentFingerprint);
    }
    return hd;
}
module.exports.fromBase58 = $e3ee5b147894d49f$var$fromBase58;
function $e3ee5b147894d49f$var$fromPrivateKey(privateKey, chainCode, network) {
    return $e3ee5b147894d49f$var$fromPrivateKeyLocal(privateKey, chainCode, network);
}
module.exports.fromPrivateKey = $e3ee5b147894d49f$var$fromPrivateKey;
function $e3ee5b147894d49f$var$fromPrivateKeyLocal(privateKey, chainCode, network, depth, index, parentFingerprint) {
    $bDP98({
        privateKey: $e3ee5b147894d49f$var$UINT256_TYPE,
        chainCode: $e3ee5b147894d49f$var$UINT256_TYPE
    }, {
        privateKey: privateKey,
        chainCode: chainCode
    });
    network = network || $e3ee5b147894d49f$var$BITCOIN;
    if (!$bAAqK.isPrivate(privateKey)) throw new TypeError("Private key not in range [1, n)");
    return new $e3ee5b147894d49f$var$BIP32(privateKey, undefined, chainCode, network, depth, index, parentFingerprint);
}
function $e3ee5b147894d49f$var$fromPublicKey(publicKey, chainCode, network) {
    return $e3ee5b147894d49f$var$fromPublicKeyLocal(publicKey, chainCode, network);
}
module.exports.fromPublicKey = $e3ee5b147894d49f$var$fromPublicKey;
function $e3ee5b147894d49f$var$fromPublicKeyLocal(publicKey, chainCode, network, depth, index, parentFingerprint) {
    $bDP98({
        publicKey: $bDP98.BufferN(33),
        chainCode: $e3ee5b147894d49f$var$UINT256_TYPE
    }, {
        publicKey: publicKey,
        chainCode: chainCode
    });
    network = network || $e3ee5b147894d49f$var$BITCOIN;
    // verify the X coordinate is a point on the curve
    if (!$bAAqK.isPoint(publicKey)) throw new TypeError("Point is not on the curve");
    return new $e3ee5b147894d49f$var$BIP32(undefined, publicKey, chainCode, network, depth, index, parentFingerprint);
}
function $e3ee5b147894d49f$var$fromSeed(seed, network) {
    $bDP98($bDP98.Buffer, seed);
    if (seed.length < 16) throw new TypeError("Seed should be at least 128 bits");
    if (seed.length > 64) throw new TypeError("Seed should be at most 512 bits");
    network = network || $e3ee5b147894d49f$var$BITCOIN;
    const I = $fuOE5.hmacSHA512($e3ee5b147894d49f$require$Buffer.from("Bitcoin seed", "utf8"), seed);
    const IL = I.slice(0, 32);
    const IR = I.slice(32);
    return $e3ee5b147894d49f$var$fromPrivateKey(IL, IR, network);
}
module.exports.fromSeed = $e3ee5b147894d49f$var$fromSeed;

});
parcelRequire.register("fuOE5", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $3FiLE = parcelRequire("3FiLE");

var $cUvgf = parcelRequire("cUvgf");
function $b480f183ee1f31a5$var$hash160(buffer) {
    const sha256Hash = $3FiLE("sha256").update(buffer).digest();
    try {
        return $3FiLE("rmd160").update(sha256Hash).digest();
    } catch (err) {
        return $3FiLE("ripemd160").update(sha256Hash).digest();
    }
}
module.exports.hash160 = $b480f183ee1f31a5$var$hash160;
function $b480f183ee1f31a5$var$hmacSHA512(key, data) {
    return $cUvgf("sha512", key).update(data).digest();
}
module.exports.hmacSHA512 = $b480f183ee1f31a5$var$hmacSHA512;

});

parcelRequire.register("1Vf4C", function(module, exports) {
"use strict";

var $3FiLE = parcelRequire("3FiLE");

var $g1FRD = parcelRequire("g1FRD");
// SHA256(SHA256(buffer))
function $1666ce9de42769b3$var$sha256x2(buffer) {
    var tmp = $3FiLE("sha256").update(buffer).digest();
    return $3FiLE("sha256").update(tmp).digest();
}
module.exports = $g1FRD($1666ce9de42769b3$var$sha256x2);

});
parcelRequire.register("g1FRD", function(module, exports) {
"use strict";

var $hZS7n = parcelRequire("hZS7n");

var $6U9mG = parcelRequire("6U9mG");
var $baad36aa31fd3816$require$Buffer = $6U9mG.Buffer;
module.exports = function(checksumFn) {
    // Encode a buffer as a base58-check encoded string
    function encode(payload) {
        var checksum = checksumFn(payload);
        return $hZS7n.encode($baad36aa31fd3816$require$Buffer.concat([
            payload,
            checksum
        ], payload.length + 4));
    }
    function decodeRaw(buffer) {
        var payload = buffer.slice(0, -4);
        var checksum = buffer.slice(-4);
        var newChecksum = checksumFn(payload);
        if (checksum[0] ^ newChecksum[0] | checksum[1] ^ newChecksum[1] | checksum[2] ^ newChecksum[2] | checksum[3] ^ newChecksum[3]) return;
        return payload;
    }
    // Decode a base58-check encoded string to a buffer, no result if checksum is wrong
    function decodeUnsafe(string) {
        var buffer = $hZS7n.decodeUnsafe(string);
        if (!buffer) return;
        return decodeRaw(buffer);
    }
    function decode(string) {
        var buffer = $hZS7n.decode(string);
        var payload = decodeRaw(buffer, checksumFn);
        if (!payload) throw new Error("Invalid checksum");
        return payload;
    }
    return {
        encode: encode,
        decode: decode,
        decodeUnsafe: decodeUnsafe
    };
};

});
parcelRequire.register("hZS7n", function(module, exports) {

var $kG2My = parcelRequire("kG2My");
var $d1a21cdb0a134c34$var$ALPHABET = "123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz";
module.exports = $kG2My($d1a21cdb0a134c34$var$ALPHABET);

});
parcelRequire.register("kG2My", function(module, exports) {
"use strict";

var $6U9mG = parcelRequire("6U9mG");
var $f0d9e357f46e8580$require$_Buffer = $6U9mG.Buffer;
function $f0d9e357f46e8580$var$base(ALPHABET) {
    if (ALPHABET.length >= 255) throw new TypeError("Alphabet too long");
    var BASE_MAP = new Uint8Array(256);
    for(var j = 0; j < BASE_MAP.length; j++)BASE_MAP[j] = 255;
    for(var i = 0; i < ALPHABET.length; i++){
        var x = ALPHABET.charAt(i);
        var xc = x.charCodeAt(0);
        if (BASE_MAP[xc] !== 255) throw new TypeError(x + " is ambiguous");
        BASE_MAP[xc] = i;
    }
    var BASE = ALPHABET.length;
    var LEADER = ALPHABET.charAt(0);
    var FACTOR = Math.log(BASE) / Math.log(256) // log(BASE) / log(256), rounded up
    ;
    var iFACTOR = Math.log(256) / Math.log(BASE) // log(256) / log(BASE), rounded up
    ;
    function encode(source) {
        if (Array.isArray(source) || source instanceof Uint8Array) source = $f0d9e357f46e8580$require$_Buffer.from(source);
        if (!$f0d9e357f46e8580$require$_Buffer.isBuffer(source)) throw new TypeError("Expected Buffer");
        if (source.length === 0) return "";
        // Skip & count leading zeroes.
        var zeroes = 0;
        var length = 0;
        var pbegin = 0;
        var pend = source.length;
        while(pbegin !== pend && source[pbegin] === 0){
            pbegin++;
            zeroes++;
        }
        // Allocate enough space in big-endian base58 representation.
        var size = (pend - pbegin) * iFACTOR + 1 >>> 0;
        var b58 = new Uint8Array(size);
        // Process the bytes.
        while(pbegin !== pend){
            var carry = source[pbegin];
            // Apply "b58 = b58 * 256 + ch".
            var i = 0;
            for(var it1 = size - 1; (carry !== 0 || i < length) && it1 !== -1; it1--, i++){
                carry += 256 * b58[it1] >>> 0;
                b58[it1] = carry % BASE >>> 0;
                carry = carry / BASE >>> 0;
            }
            if (carry !== 0) throw new Error("Non-zero carry");
            length = i;
            pbegin++;
        }
        // Skip leading zeroes in base58 result.
        var it2 = size - length;
        while(it2 !== size && b58[it2] === 0)it2++;
        // Translate the result into a string.
        var str = LEADER.repeat(zeroes);
        for(; it2 < size; ++it2)str += ALPHABET.charAt(b58[it2]);
        return str;
    }
    function decodeUnsafe(source) {
        if (typeof source !== "string") throw new TypeError("Expected String");
        if (source.length === 0) return $f0d9e357f46e8580$require$_Buffer.alloc(0);
        var psz = 0;
        // Skip and count leading '1's.
        var zeroes = 0;
        var length = 0;
        while(source[psz] === LEADER){
            zeroes++;
            psz++;
        }
        // Allocate enough space in big-endian base256 representation.
        var size = (source.length - psz) * FACTOR + 1 >>> 0 // log(58) / log(256), rounded up.
        ;
        var b256 = new Uint8Array(size);
        // Process the characters.
        while(source[psz]){
            // Decode character
            var carry = BASE_MAP[source.charCodeAt(psz)];
            // Invalid character
            if (carry === 255) return;
            var i = 0;
            for(var it3 = size - 1; (carry !== 0 || i < length) && it3 !== -1; it3--, i++){
                carry += BASE * b256[it3] >>> 0;
                b256[it3] = carry % 256 >>> 0;
                carry = carry / 256 >>> 0;
            }
            if (carry !== 0) throw new Error("Non-zero carry");
            length = i;
            psz++;
        }
        // Skip leading zeroes in b256.
        var it4 = size - length;
        while(it4 !== size && b256[it4] === 0)it4++;
        var vch = $f0d9e357f46e8580$require$_Buffer.allocUnsafe(zeroes + (size - it4));
        vch.fill(0x00, 0, zeroes);
        var j = zeroes;
        while(it4 !== size)vch[j++] = b256[it4++];
        return vch;
    }
    function decode(string) {
        var buffer = decodeUnsafe(string);
        if (buffer) return buffer;
        throw new Error("Non-base" + BASE + " character");
    }
    return {
        encode: encode,
        decodeUnsafe: decodeUnsafe,
        decode: decode
    };
}
module.exports = $f0d9e357f46e8580$var$base;

});




parcelRequire.register("bAAqK", function(module, exports) {

var $ihoyg = parcelRequire("ihoyg");
var $86ff50d9446c20a0$require$Buffer = $ihoyg.Buffer;

var $7vYz3 = parcelRequire("7vYz3");

var $8J1ou = parcelRequire("8J1ou");
var $86ff50d9446c20a0$require$EC = $8J1ou.ec;
const $86ff50d9446c20a0$var$secp256k1 = new $86ff50d9446c20a0$require$EC("secp256k1");

var $6JcDT = parcelRequire("6JcDT");
const $86ff50d9446c20a0$var$ZERO32 = $86ff50d9446c20a0$require$Buffer.alloc(32, 0);
const $86ff50d9446c20a0$var$EC_GROUP_ORDER = $86ff50d9446c20a0$require$Buffer.from("fffffffffffffffffffffffffffffffebaaedce6af48a03bbfd25e8cd0364141", "hex");
const $86ff50d9446c20a0$var$EC_P = $86ff50d9446c20a0$require$Buffer.from("fffffffffffffffffffffffffffffffffffffffffffffffffffffffefffffc2f", "hex");
const $86ff50d9446c20a0$var$n = $86ff50d9446c20a0$var$secp256k1.curve.n;
const $86ff50d9446c20a0$var$nDiv2 = $86ff50d9446c20a0$var$n.shrn(1);
const $86ff50d9446c20a0$var$G = $86ff50d9446c20a0$var$secp256k1.curve.g;
const $86ff50d9446c20a0$var$THROW_BAD_PRIVATE = "Expected Private";
const $86ff50d9446c20a0$var$THROW_BAD_POINT = "Expected Point";
const $86ff50d9446c20a0$var$THROW_BAD_TWEAK = "Expected Tweak";
const $86ff50d9446c20a0$var$THROW_BAD_HASH = "Expected Hash";
const $86ff50d9446c20a0$var$THROW_BAD_SIGNATURE = "Expected Signature";
const $86ff50d9446c20a0$var$THROW_BAD_EXTRA_DATA = "Expected Extra Data (32 bytes)";
function $86ff50d9446c20a0$var$isScalar(x) {
    return $86ff50d9446c20a0$require$Buffer.isBuffer(x) && x.length === 32;
}
function $86ff50d9446c20a0$var$isOrderScalar(x) {
    if (!$86ff50d9446c20a0$var$isScalar(x)) return false;
    return x.compare($86ff50d9446c20a0$var$EC_GROUP_ORDER) < 0 // < G
    ;
}
function $86ff50d9446c20a0$var$isPoint(p) {
    if (!$86ff50d9446c20a0$require$Buffer.isBuffer(p)) return false;
    if (p.length < 33) return false;
    const t = p[0];
    const x = p.slice(1, 33);
    if (x.compare($86ff50d9446c20a0$var$ZERO32) === 0) return false;
    if (x.compare($86ff50d9446c20a0$var$EC_P) >= 0) return false;
    if ((t === 0x02 || t === 0x03) && p.length === 33) {
        try {
            $86ff50d9446c20a0$var$decodeFrom(p);
        } catch (e) {
            return false;
        } // TODO: temporary
        return true;
    }
    const y = p.slice(33);
    if (y.compare($86ff50d9446c20a0$var$ZERO32) === 0) return false;
    if (y.compare($86ff50d9446c20a0$var$EC_P) >= 0) return false;
    if (t === 0x04 && p.length === 65) return true;
    return false;
}
function $86ff50d9446c20a0$var$__isPointCompressed(p) {
    return p[0] !== 0x04;
}
function $86ff50d9446c20a0$var$isPointCompressed(p) {
    if (!$86ff50d9446c20a0$var$isPoint(p)) return false;
    return $86ff50d9446c20a0$var$__isPointCompressed(p);
}
function $86ff50d9446c20a0$var$isPrivate(x) {
    if (!$86ff50d9446c20a0$var$isScalar(x)) return false;
    return x.compare($86ff50d9446c20a0$var$ZERO32) > 0 && // > 0
    x.compare($86ff50d9446c20a0$var$EC_GROUP_ORDER) < 0 // < G
    ;
}
function $86ff50d9446c20a0$var$isSignature(value) {
    const r = value.slice(0, 32);
    const s = value.slice(32, 64);
    return $86ff50d9446c20a0$require$Buffer.isBuffer(value) && value.length === 64 && r.compare($86ff50d9446c20a0$var$EC_GROUP_ORDER) < 0 && s.compare($86ff50d9446c20a0$var$EC_GROUP_ORDER) < 0;
}
function $86ff50d9446c20a0$var$assumeCompression(value, pubkey) {
    if (value === undefined && pubkey !== undefined) return $86ff50d9446c20a0$var$__isPointCompressed(pubkey);
    if (value === undefined) return true;
    return value;
}
function $86ff50d9446c20a0$var$fromBuffer(d) {
    return new $7vYz3(d);
}
function $86ff50d9446c20a0$var$toBuffer(d) {
    return d.toArrayLike($86ff50d9446c20a0$require$Buffer, "be", 32);
}
function $86ff50d9446c20a0$var$decodeFrom(P) {
    return $86ff50d9446c20a0$var$secp256k1.curve.decodePoint(P);
}
function $86ff50d9446c20a0$var$getEncoded(P, compressed) {
    return $86ff50d9446c20a0$require$Buffer.from(P._encode(compressed));
}
function $86ff50d9446c20a0$var$pointAdd(pA, pB, __compressed) {
    if (!$86ff50d9446c20a0$var$isPoint(pA)) throw new TypeError($86ff50d9446c20a0$var$THROW_BAD_POINT);
    if (!$86ff50d9446c20a0$var$isPoint(pB)) throw new TypeError($86ff50d9446c20a0$var$THROW_BAD_POINT);
    const a = $86ff50d9446c20a0$var$decodeFrom(pA);
    const b = $86ff50d9446c20a0$var$decodeFrom(pB);
    const pp = a.add(b);
    if (pp.isInfinity()) return null;
    const compressed = $86ff50d9446c20a0$var$assumeCompression(__compressed, pA);
    return $86ff50d9446c20a0$var$getEncoded(pp, compressed);
}
function $86ff50d9446c20a0$var$pointAddScalar(p, tweak, __compressed) {
    if (!$86ff50d9446c20a0$var$isPoint(p)) throw new TypeError($86ff50d9446c20a0$var$THROW_BAD_POINT);
    if (!$86ff50d9446c20a0$var$isOrderScalar(tweak)) throw new TypeError($86ff50d9446c20a0$var$THROW_BAD_TWEAK);
    const compressed = $86ff50d9446c20a0$var$assumeCompression(__compressed, p);
    const pp = $86ff50d9446c20a0$var$decodeFrom(p);
    if (tweak.compare($86ff50d9446c20a0$var$ZERO32) === 0) return $86ff50d9446c20a0$var$getEncoded(pp, compressed);
    const tt = $86ff50d9446c20a0$var$fromBuffer(tweak);
    const qq = $86ff50d9446c20a0$var$G.mul(tt);
    const uu = pp.add(qq);
    if (uu.isInfinity()) return null;
    return $86ff50d9446c20a0$var$getEncoded(uu, compressed);
}
function $86ff50d9446c20a0$var$pointCompress(p, __compressed) {
    if (!$86ff50d9446c20a0$var$isPoint(p)) throw new TypeError($86ff50d9446c20a0$var$THROW_BAD_POINT);
    const pp = $86ff50d9446c20a0$var$decodeFrom(p);
    if (pp.isInfinity()) throw new TypeError($86ff50d9446c20a0$var$THROW_BAD_POINT);
    const compressed = $86ff50d9446c20a0$var$assumeCompression(__compressed, p);
    return $86ff50d9446c20a0$var$getEncoded(pp, compressed);
}
function $86ff50d9446c20a0$var$pointFromScalar(d, __compressed) {
    if (!$86ff50d9446c20a0$var$isPrivate(d)) throw new TypeError($86ff50d9446c20a0$var$THROW_BAD_PRIVATE);
    const dd = $86ff50d9446c20a0$var$fromBuffer(d);
    const pp = $86ff50d9446c20a0$var$G.mul(dd);
    if (pp.isInfinity()) return null;
    const compressed = $86ff50d9446c20a0$var$assumeCompression(__compressed);
    return $86ff50d9446c20a0$var$getEncoded(pp, compressed);
}
function $86ff50d9446c20a0$var$pointMultiply(p, tweak, __compressed) {
    if (!$86ff50d9446c20a0$var$isPoint(p)) throw new TypeError($86ff50d9446c20a0$var$THROW_BAD_POINT);
    if (!$86ff50d9446c20a0$var$isOrderScalar(tweak)) throw new TypeError($86ff50d9446c20a0$var$THROW_BAD_TWEAK);
    const compressed = $86ff50d9446c20a0$var$assumeCompression(__compressed, p);
    const pp = $86ff50d9446c20a0$var$decodeFrom(p);
    const tt = $86ff50d9446c20a0$var$fromBuffer(tweak);
    const qq = pp.mul(tt);
    if (qq.isInfinity()) return null;
    return $86ff50d9446c20a0$var$getEncoded(qq, compressed);
}
function $86ff50d9446c20a0$var$privateAdd(d, tweak) {
    if (!$86ff50d9446c20a0$var$isPrivate(d)) throw new TypeError($86ff50d9446c20a0$var$THROW_BAD_PRIVATE);
    if (!$86ff50d9446c20a0$var$isOrderScalar(tweak)) throw new TypeError($86ff50d9446c20a0$var$THROW_BAD_TWEAK);
    const dd = $86ff50d9446c20a0$var$fromBuffer(d);
    const tt = $86ff50d9446c20a0$var$fromBuffer(tweak);
    const dt = $86ff50d9446c20a0$var$toBuffer(dd.add(tt).umod($86ff50d9446c20a0$var$n));
    if (!$86ff50d9446c20a0$var$isPrivate(dt)) return null;
    return dt;
}
function $86ff50d9446c20a0$var$privateSub(d, tweak) {
    if (!$86ff50d9446c20a0$var$isPrivate(d)) throw new TypeError($86ff50d9446c20a0$var$THROW_BAD_PRIVATE);
    if (!$86ff50d9446c20a0$var$isOrderScalar(tweak)) throw new TypeError($86ff50d9446c20a0$var$THROW_BAD_TWEAK);
    const dd = $86ff50d9446c20a0$var$fromBuffer(d);
    const tt = $86ff50d9446c20a0$var$fromBuffer(tweak);
    const dt = $86ff50d9446c20a0$var$toBuffer(dd.sub(tt).umod($86ff50d9446c20a0$var$n));
    if (!$86ff50d9446c20a0$var$isPrivate(dt)) return null;
    return dt;
}
function $86ff50d9446c20a0$var$sign(hash, x) {
    return $86ff50d9446c20a0$var$__sign(hash, x);
}
function $86ff50d9446c20a0$var$signWithEntropy(hash, x, addData) {
    return $86ff50d9446c20a0$var$__sign(hash, x, addData);
}
function $86ff50d9446c20a0$var$__sign(hash, x, addData) {
    if (!$86ff50d9446c20a0$var$isScalar(hash)) throw new TypeError($86ff50d9446c20a0$var$THROW_BAD_HASH);
    if (!$86ff50d9446c20a0$var$isPrivate(x)) throw new TypeError($86ff50d9446c20a0$var$THROW_BAD_PRIVATE);
    if (addData !== undefined && !$86ff50d9446c20a0$var$isScalar(addData)) throw new TypeError($86ff50d9446c20a0$var$THROW_BAD_EXTRA_DATA);
    const d = $86ff50d9446c20a0$var$fromBuffer(x);
    const e = $86ff50d9446c20a0$var$fromBuffer(hash);
    let r, s;
    const checkSig = function(k) {
        const kI = $86ff50d9446c20a0$var$fromBuffer(k);
        const Q = $86ff50d9446c20a0$var$G.mul(kI);
        if (Q.isInfinity()) return false;
        r = Q.x.umod($86ff50d9446c20a0$var$n);
        if (r.isZero() === 0) return false;
        s = kI.invm($86ff50d9446c20a0$var$n).mul(e.add(d.mul(r))).umod($86ff50d9446c20a0$var$n);
        if (s.isZero() === 0) return false;
        return true;
    };
    $6JcDT(hash, x, checkSig, $86ff50d9446c20a0$var$isPrivate, addData);
    // enforce low S values, see bip62: 'low s values in signatures'
    if (s.cmp($86ff50d9446c20a0$var$nDiv2) > 0) s = $86ff50d9446c20a0$var$n.sub(s);
    const buffer = $86ff50d9446c20a0$require$Buffer.allocUnsafe(64);
    $86ff50d9446c20a0$var$toBuffer(r).copy(buffer, 0);
    $86ff50d9446c20a0$var$toBuffer(s).copy(buffer, 32);
    return buffer;
}
function $86ff50d9446c20a0$var$verify(hash, q, signature, strict) {
    if (!$86ff50d9446c20a0$var$isScalar(hash)) throw new TypeError($86ff50d9446c20a0$var$THROW_BAD_HASH);
    if (!$86ff50d9446c20a0$var$isPoint(q)) throw new TypeError($86ff50d9446c20a0$var$THROW_BAD_POINT);
    // 1.4.1 Enforce r and s are both integers in the interval [1, n − 1] (1, isSignature enforces '< n - 1')
    if (!$86ff50d9446c20a0$var$isSignature(signature)) throw new TypeError($86ff50d9446c20a0$var$THROW_BAD_SIGNATURE);
    const Q = $86ff50d9446c20a0$var$decodeFrom(q);
    const r = $86ff50d9446c20a0$var$fromBuffer(signature.slice(0, 32));
    const s = $86ff50d9446c20a0$var$fromBuffer(signature.slice(32, 64));
    if (strict && s.cmp($86ff50d9446c20a0$var$nDiv2) > 0) return false;
    // 1.4.1 Enforce r and s are both integers in the interval [1, n − 1] (2, enforces '> 0')
    if (r.gtn(0) <= 0 /* || r.compareTo(n) >= 0 */ ) return false;
    if (s.gtn(0) <= 0 /* || s.compareTo(n) >= 0 */ ) return false;
    // 1.4.2 H = Hash(M), already done by the user
    // 1.4.3 e = H
    const e = $86ff50d9446c20a0$var$fromBuffer(hash);
    // Compute s^-1
    const sInv = s.invm($86ff50d9446c20a0$var$n);
    // 1.4.4 Compute u1 = es^−1 mod n
    //               u2 = rs^−1 mod n
    const u1 = e.mul(sInv).umod($86ff50d9446c20a0$var$n);
    const u2 = r.mul(sInv).umod($86ff50d9446c20a0$var$n);
    // 1.4.5 Compute R = (xR, yR)
    //               R = u1G + u2Q
    const R = $86ff50d9446c20a0$var$G.mulAdd(u1, Q, u2);
    // 1.4.5 (cont.) Enforce R is not at infinity
    if (R.isInfinity()) return false;
    // 1.4.6 Convert the field element R.x to an integer
    const xR = R.x;
    // 1.4.7 Set v = xR mod n
    const v = xR.umod($86ff50d9446c20a0$var$n);
    // 1.4.8 If v = r, output "valid", and if v != r, output "invalid"
    return v.eq(r);
}
module.exports = {
    isPoint: $86ff50d9446c20a0$var$isPoint,
    isPointCompressed: $86ff50d9446c20a0$var$isPointCompressed,
    isPrivate: $86ff50d9446c20a0$var$isPrivate,
    pointAdd: $86ff50d9446c20a0$var$pointAdd,
    pointAddScalar: $86ff50d9446c20a0$var$pointAddScalar,
    pointCompress: $86ff50d9446c20a0$var$pointCompress,
    pointFromScalar: $86ff50d9446c20a0$var$pointFromScalar,
    pointMultiply: $86ff50d9446c20a0$var$pointMultiply,
    privateAdd: $86ff50d9446c20a0$var$privateAdd,
    privateSub: $86ff50d9446c20a0$var$privateSub,
    sign: $86ff50d9446c20a0$var$sign,
    signWithEntropy: $86ff50d9446c20a0$var$signWithEntropy,
    verify: $86ff50d9446c20a0$var$verify
};

});
parcelRequire.register("6JcDT", function(module, exports) {

var $ihoyg = parcelRequire("ihoyg");
var $0143a0025c0142a7$require$Buffer = $ihoyg.Buffer;

var $cUvgf = parcelRequire("cUvgf");
const $0143a0025c0142a7$var$ONE1 = $0143a0025c0142a7$require$Buffer.alloc(1, 1);
const $0143a0025c0142a7$var$ZERO1 = $0143a0025c0142a7$require$Buffer.alloc(1, 0);
// https://tools.ietf.org/html/rfc6979#section-3.2
function $0143a0025c0142a7$var$deterministicGenerateK(hash, x, checkSig, isPrivate, extraEntropy) {
    // Step A, ignored as hash already provided
    // Step B
    // Step C
    let k = $0143a0025c0142a7$require$Buffer.alloc(32, 0);
    let v = $0143a0025c0142a7$require$Buffer.alloc(32, 1);
    // Step D
    k = $cUvgf("sha256", k).update(v).update($0143a0025c0142a7$var$ZERO1).update(x).update(hash).update(extraEntropy || "").digest();
    // Step E
    v = $cUvgf("sha256", k).update(v).digest();
    // Step F
    k = $cUvgf("sha256", k).update(v).update($0143a0025c0142a7$var$ONE1).update(x).update(hash).update(extraEntropy || "").digest();
    // Step G
    v = $cUvgf("sha256", k).update(v).digest();
    // Step H1/H2a, ignored as tlen === qlen (256 bit)
    // Step H2b
    v = $cUvgf("sha256", k).update(v).digest();
    let T = v;
    // Step H3, repeat until T is within the interval [1, n - 1] and is suitable for ECDSA
    while(!isPrivate(T) || !checkSig(T)){
        k = $cUvgf("sha256", k).update(v).update($0143a0025c0142a7$var$ZERO1).digest();
        v = $cUvgf("sha256", k).update(v).digest();
        // Step H1/H2a, again, ignored as tlen === qlen (256 bit)
        // Step H2b again
        v = $cUvgf("sha256", k).update(v).digest();
        T = v;
    }
    return T;
}
module.exports = $0143a0025c0142a7$var$deterministicGenerateK;

});


parcelRequire.register("bDP98", function(module, exports) {

var $5PqjV = parcelRequire("5PqjV");

var $WjcEN = parcelRequire("WjcEN");
// short-hand
var $879b02cdd754e3b5$var$tfJSON = $5PqjV.tfJSON;
var $879b02cdd754e3b5$var$TfTypeError = $5PqjV.TfTypeError;
var $879b02cdd754e3b5$var$TfPropertyTypeError = $5PqjV.TfPropertyTypeError;
var $879b02cdd754e3b5$var$tfSubError = $5PqjV.tfSubError;
var $879b02cdd754e3b5$var$getValueTypeName = $5PqjV.getValueTypeName;
var $879b02cdd754e3b5$var$TYPES = {
    arrayOf: function arrayOf(type, options) {
        type = $879b02cdd754e3b5$var$compile(type);
        options = options || {};
        function _arrayOf(array, strict) {
            if (!$WjcEN.Array(array)) return false;
            if ($WjcEN.Nil(array)) return false;
            if (options.minLength !== undefined && array.length < options.minLength) return false;
            if (options.maxLength !== undefined && array.length > options.maxLength) return false;
            if (options.length !== undefined && array.length !== options.length) return false;
            return array.every(function(value, i) {
                try {
                    return $879b02cdd754e3b5$var$typeforce(type, value, strict);
                } catch (e) {
                    throw $879b02cdd754e3b5$var$tfSubError(e, i);
                }
            });
        }
        _arrayOf.toJSON = function() {
            var str = "[" + $879b02cdd754e3b5$var$tfJSON(type) + "]";
            if (options.length !== undefined) str += "{" + options.length + "}";
            else if (options.minLength !== undefined || options.maxLength !== undefined) str += "{" + (options.minLength === undefined ? 0 : options.minLength) + "," + (options.maxLength === undefined ? Infinity : options.maxLength) + "}";
            return str;
        };
        return _arrayOf;
    },
    maybe: function maybe(type) {
        type = $879b02cdd754e3b5$var$compile(type);
        function _maybe(value, strict) {
            return $WjcEN.Nil(value) || type(value, strict, maybe);
        }
        _maybe.toJSON = function() {
            return "?" + $879b02cdd754e3b5$var$tfJSON(type);
        };
        return _maybe;
    },
    map: function map(propertyType, propertyKeyType) {
        propertyType = $879b02cdd754e3b5$var$compile(propertyType);
        if (propertyKeyType) propertyKeyType = $879b02cdd754e3b5$var$compile(propertyKeyType);
        function _map(value, strict) {
            if (!$WjcEN.Object(value)) return false;
            if ($WjcEN.Nil(value)) return false;
            for(var propertyName in value){
                try {
                    if (propertyKeyType) $879b02cdd754e3b5$var$typeforce(propertyKeyType, propertyName, strict);
                } catch (e) {
                    throw $879b02cdd754e3b5$var$tfSubError(e, propertyName, "key");
                }
                try {
                    var propertyValue = value[propertyName];
                    $879b02cdd754e3b5$var$typeforce(propertyType, propertyValue, strict);
                } catch (e) {
                    throw $879b02cdd754e3b5$var$tfSubError(e, propertyName);
                }
            }
            return true;
        }
        if (propertyKeyType) _map.toJSON = function() {
            return "{" + $879b02cdd754e3b5$var$tfJSON(propertyKeyType) + ": " + $879b02cdd754e3b5$var$tfJSON(propertyType) + "}";
        };
        else _map.toJSON = function() {
            return "{" + $879b02cdd754e3b5$var$tfJSON(propertyType) + "}";
        };
        return _map;
    },
    object: function object(uncompiled) {
        var type = {};
        for(var typePropertyName in uncompiled)type[typePropertyName] = $879b02cdd754e3b5$var$compile(uncompiled[typePropertyName]);
        function _object(value, strict) {
            if (!$WjcEN.Object(value)) return false;
            if ($WjcEN.Nil(value)) return false;
            var propertyName;
            try {
                for(propertyName in type){
                    var propertyType = type[propertyName];
                    var propertyValue = value[propertyName];
                    $879b02cdd754e3b5$var$typeforce(propertyType, propertyValue, strict);
                }
            } catch (e) {
                throw $879b02cdd754e3b5$var$tfSubError(e, propertyName);
            }
            if (strict) for(propertyName in value){
                if (type[propertyName]) continue;
                throw new $879b02cdd754e3b5$var$TfPropertyTypeError(undefined, propertyName);
            }
            return true;
        }
        _object.toJSON = function() {
            return $879b02cdd754e3b5$var$tfJSON(type);
        };
        return _object;
    },
    anyOf: function anyOf() {
        var types = [].slice.call(arguments).map($879b02cdd754e3b5$var$compile);
        function _anyOf(value, strict) {
            return types.some(function(type) {
                try {
                    return $879b02cdd754e3b5$var$typeforce(type, value, strict);
                } catch (e) {
                    return false;
                }
            });
        }
        _anyOf.toJSON = function() {
            return types.map($879b02cdd754e3b5$var$tfJSON).join("|");
        };
        return _anyOf;
    },
    allOf: function allOf() {
        var types = [].slice.call(arguments).map($879b02cdd754e3b5$var$compile);
        function _allOf(value, strict) {
            return types.every(function(type) {
                try {
                    return $879b02cdd754e3b5$var$typeforce(type, value, strict);
                } catch (e) {
                    return false;
                }
            });
        }
        _allOf.toJSON = function() {
            return types.map($879b02cdd754e3b5$var$tfJSON).join(" & ");
        };
        return _allOf;
    },
    quacksLike: function quacksLike(type) {
        function _quacksLike(value) {
            return type === $879b02cdd754e3b5$var$getValueTypeName(value);
        }
        _quacksLike.toJSON = function() {
            return type;
        };
        return _quacksLike;
    },
    tuple: function tuple() {
        var types = [].slice.call(arguments).map($879b02cdd754e3b5$var$compile);
        function _tuple(values, strict) {
            if ($WjcEN.Nil(values)) return false;
            if ($WjcEN.Nil(values.length)) return false;
            if (strict && values.length !== types.length) return false;
            return types.every(function(type, i) {
                try {
                    return $879b02cdd754e3b5$var$typeforce(type, values[i], strict);
                } catch (e) {
                    throw $879b02cdd754e3b5$var$tfSubError(e, i);
                }
            });
        }
        _tuple.toJSON = function() {
            return "(" + types.map($879b02cdd754e3b5$var$tfJSON).join(", ") + ")";
        };
        return _tuple;
    },
    value: function value(expected) {
        function _value(actual) {
            return actual === expected;
        }
        _value.toJSON = function() {
            return expected;
        };
        return _value;
    }
};
// TODO: deprecate
$879b02cdd754e3b5$var$TYPES.oneOf = $879b02cdd754e3b5$var$TYPES.anyOf;
function $879b02cdd754e3b5$var$compile(type) {
    if ($WjcEN.String(type)) {
        if (type[0] === "?") return $879b02cdd754e3b5$var$TYPES.maybe(type.slice(1));
        return $WjcEN[type] || $879b02cdd754e3b5$var$TYPES.quacksLike(type);
    } else if (type && $WjcEN.Object(type)) {
        if ($WjcEN.Array(type)) {
            if (type.length !== 1) throw new TypeError("Expected compile() parameter of type Array of length 1");
            return $879b02cdd754e3b5$var$TYPES.arrayOf(type[0]);
        }
        return $879b02cdd754e3b5$var$TYPES.object(type);
    } else if ($WjcEN.Function(type)) return type;
    return $879b02cdd754e3b5$var$TYPES.value(type);
}
function $879b02cdd754e3b5$var$typeforce(type, value, strict, surrogate) {
    if ($WjcEN.Function(type)) {
        if (type(value, strict)) return true;
        throw new $879b02cdd754e3b5$var$TfTypeError(surrogate || type, value);
    }
    // JIT
    return $879b02cdd754e3b5$var$typeforce($879b02cdd754e3b5$var$compile(type), value, strict);
}
// assign types to typeforce function
for(var $879b02cdd754e3b5$var$typeName in $WjcEN)$879b02cdd754e3b5$var$typeforce[$879b02cdd754e3b5$var$typeName] = $WjcEN[$879b02cdd754e3b5$var$typeName];
for($879b02cdd754e3b5$var$typeName in $879b02cdd754e3b5$var$TYPES)$879b02cdd754e3b5$var$typeforce[$879b02cdd754e3b5$var$typeName] = $879b02cdd754e3b5$var$TYPES[$879b02cdd754e3b5$var$typeName];

var $i4G8Y = parcelRequire("i4G8Y");
for($879b02cdd754e3b5$var$typeName in $i4G8Y)$879b02cdd754e3b5$var$typeforce[$879b02cdd754e3b5$var$typeName] = $i4G8Y[$879b02cdd754e3b5$var$typeName];
$879b02cdd754e3b5$var$typeforce.compile = $879b02cdd754e3b5$var$compile;
$879b02cdd754e3b5$var$typeforce.TfTypeError = $879b02cdd754e3b5$var$TfTypeError;
$879b02cdd754e3b5$var$typeforce.TfPropertyTypeError = $879b02cdd754e3b5$var$TfPropertyTypeError;
module.exports = $879b02cdd754e3b5$var$typeforce;

});
parcelRequire.register("5PqjV", function(module, exports) {

var $WjcEN = parcelRequire("WjcEN");
function $43e621d6b47985c7$var$getTypeName(fn) {
    return fn.name || fn.toString().match(/function (.*?)\s*\(/)[1];
}
function $43e621d6b47985c7$var$getValueTypeName(value) {
    return $WjcEN.Nil(value) ? "" : $43e621d6b47985c7$var$getTypeName(value.constructor);
}
function $43e621d6b47985c7$var$getValue(value) {
    if ($WjcEN.Function(value)) return "";
    if ($WjcEN.String(value)) return JSON.stringify(value);
    if (value && $WjcEN.Object(value)) return "";
    return value;
}
function $43e621d6b47985c7$var$captureStackTrace(e, t) {
    if (Error.captureStackTrace) Error.captureStackTrace(e, t);
}
function $43e621d6b47985c7$var$tfJSON(type) {
    if ($WjcEN.Function(type)) return type.toJSON ? type.toJSON() : $43e621d6b47985c7$var$getTypeName(type);
    if ($WjcEN.Array(type)) return "Array";
    if (type && $WjcEN.Object(type)) return "Object";
    return type !== undefined ? type : "";
}
function $43e621d6b47985c7$var$tfErrorString(type, value, valueTypeName) {
    var valueJson = $43e621d6b47985c7$var$getValue(value);
    return "Expected " + $43e621d6b47985c7$var$tfJSON(type) + ", got" + (valueTypeName !== "" ? " " + valueTypeName : "") + (valueJson !== "" ? " " + valueJson : "");
}
function $43e621d6b47985c7$var$TfTypeError(type, value, valueTypeName) {
    valueTypeName = valueTypeName || $43e621d6b47985c7$var$getValueTypeName(value);
    this.message = $43e621d6b47985c7$var$tfErrorString(type, value, valueTypeName);
    $43e621d6b47985c7$var$captureStackTrace(this, $43e621d6b47985c7$var$TfTypeError);
    this.__type = type;
    this.__value = value;
    this.__valueTypeName = valueTypeName;
}
$43e621d6b47985c7$var$TfTypeError.prototype = Object.create(Error.prototype);
$43e621d6b47985c7$var$TfTypeError.prototype.constructor = $43e621d6b47985c7$var$TfTypeError;
function $43e621d6b47985c7$var$tfPropertyErrorString(type, label, name, value, valueTypeName) {
    var description = '" of type ';
    if (label === "key") description = '" with key type ';
    return $43e621d6b47985c7$var$tfErrorString('property "' + $43e621d6b47985c7$var$tfJSON(name) + description + $43e621d6b47985c7$var$tfJSON(type), value, valueTypeName);
}
function $43e621d6b47985c7$var$TfPropertyTypeError(type, property, label, value, valueTypeName) {
    if (type) {
        valueTypeName = valueTypeName || $43e621d6b47985c7$var$getValueTypeName(value);
        this.message = $43e621d6b47985c7$var$tfPropertyErrorString(type, label, property, value, valueTypeName);
    } else this.message = 'Unexpected property "' + property + '"';
    $43e621d6b47985c7$var$captureStackTrace(this, $43e621d6b47985c7$var$TfTypeError);
    this.__label = label;
    this.__property = property;
    this.__type = type;
    this.__value = value;
    this.__valueTypeName = valueTypeName;
}
$43e621d6b47985c7$var$TfPropertyTypeError.prototype = Object.create(Error.prototype);
$43e621d6b47985c7$var$TfPropertyTypeError.prototype.constructor = $43e621d6b47985c7$var$TfTypeError;
function $43e621d6b47985c7$var$tfCustomError(expected, actual) {
    return new $43e621d6b47985c7$var$TfTypeError(expected, {}, actual);
}
function $43e621d6b47985c7$var$tfSubError(e, property, label) {
    // sub child?
    if (e instanceof $43e621d6b47985c7$var$TfPropertyTypeError) {
        property = property + "." + e.__property;
        e = new $43e621d6b47985c7$var$TfPropertyTypeError(e.__type, property, e.__label, e.__value, e.__valueTypeName);
    // child?
    } else if (e instanceof $43e621d6b47985c7$var$TfTypeError) e = new $43e621d6b47985c7$var$TfPropertyTypeError(e.__type, property, label, e.__value, e.__valueTypeName);
    $43e621d6b47985c7$var$captureStackTrace(e);
    return e;
}
module.exports = {
    TfTypeError: $43e621d6b47985c7$var$TfTypeError,
    TfPropertyTypeError: $43e621d6b47985c7$var$TfPropertyTypeError,
    tfCustomError: $43e621d6b47985c7$var$tfCustomError,
    tfSubError: $43e621d6b47985c7$var$tfSubError,
    tfJSON: $43e621d6b47985c7$var$tfJSON,
    getValueTypeName: $43e621d6b47985c7$var$getValueTypeName
};

});
parcelRequire.register("WjcEN", function(module, exports) {
var $0af4503d1812f988$var$types = {
    Array: function(value) {
        return value !== null && value !== undefined && value.constructor === Array;
    },
    Boolean: function(value) {
        return typeof value === "boolean";
    },
    Function: function(value) {
        return typeof value === "function";
    },
    Nil: function(value) {
        return value === undefined || value === null;
    },
    Number: function(value) {
        return typeof value === "number";
    },
    Object: function(value) {
        return typeof value === "object";
    },
    String: function(value) {
        return typeof value === "string";
    },
    "": function() {
        return true;
    }
};
// TODO: deprecate
$0af4503d1812f988$var$types.Null = $0af4503d1812f988$var$types.Nil;
for(var $0af4503d1812f988$var$typeName in $0af4503d1812f988$var$types)$0af4503d1812f988$var$types[$0af4503d1812f988$var$typeName].toJSON = (function(t) {
    return t;
}).bind(null, $0af4503d1812f988$var$typeName);
module.exports = $0af4503d1812f988$var$types;

});


parcelRequire.register("i4G8Y", function(module, exports) {

var $ihoyg = parcelRequire("ihoyg");
var $03654fa7a69bc7e8$require$Buffer = $ihoyg.Buffer;

var $WjcEN = parcelRequire("WjcEN");

var $5PqjV = parcelRequire("5PqjV");
function $03654fa7a69bc7e8$var$_Buffer(value) {
    return $03654fa7a69bc7e8$require$Buffer.isBuffer(value);
}
function $03654fa7a69bc7e8$var$Hex(value) {
    return typeof value === "string" && /^([0-9a-f]{2})+$/i.test(value);
}
function $03654fa7a69bc7e8$var$_LengthN(type, length) {
    var name = type.toJSON();
    function Length(value) {
        if (!type(value)) return false;
        if (value.length === length) return true;
        throw $5PqjV.tfCustomError(name + "(Length: " + length + ")", name + "(Length: " + value.length + ")");
    }
    Length.toJSON = function() {
        return name;
    };
    return Length;
}
var $03654fa7a69bc7e8$var$_ArrayN = $03654fa7a69bc7e8$var$_LengthN.bind(null, $WjcEN.Array);
var $03654fa7a69bc7e8$var$_BufferN = $03654fa7a69bc7e8$var$_LengthN.bind(null, $03654fa7a69bc7e8$var$_Buffer);
var $03654fa7a69bc7e8$var$_HexN = $03654fa7a69bc7e8$var$_LengthN.bind(null, $03654fa7a69bc7e8$var$Hex);
var $03654fa7a69bc7e8$var$_StringN = $03654fa7a69bc7e8$var$_LengthN.bind(null, $WjcEN.String);
function $03654fa7a69bc7e8$var$Range(a, b, f) {
    f = f || $WjcEN.Number;
    function _range(value, strict) {
        return f(value, strict) && value > a && value < b;
    }
    _range.toJSON = function() {
        return `${f.toJSON()} between [${a}, ${b}]`;
    };
    return _range;
}
var $03654fa7a69bc7e8$var$INT53_MAX = Math.pow(2, 53) - 1;
function $03654fa7a69bc7e8$var$Finite(value) {
    return typeof value === "number" && isFinite(value);
}
function $03654fa7a69bc7e8$var$Int8(value) {
    return value << 24 >> 24 === value;
}
function $03654fa7a69bc7e8$var$Int16(value) {
    return value << 16 >> 16 === value;
}
function $03654fa7a69bc7e8$var$Int32(value) {
    return (value | 0) === value;
}
function $03654fa7a69bc7e8$var$Int53(value) {
    return typeof value === "number" && value >= -$03654fa7a69bc7e8$var$INT53_MAX && value <= $03654fa7a69bc7e8$var$INT53_MAX && Math.floor(value) === value;
}
function $03654fa7a69bc7e8$var$UInt8(value) {
    return (value & 0xff) === value;
}
function $03654fa7a69bc7e8$var$UInt16(value) {
    return (value & 0xffff) === value;
}
function $03654fa7a69bc7e8$var$UInt32(value) {
    return value >>> 0 === value;
}
function $03654fa7a69bc7e8$var$UInt53(value) {
    return typeof value === "number" && value >= 0 && value <= $03654fa7a69bc7e8$var$INT53_MAX && Math.floor(value) === value;
}
var $03654fa7a69bc7e8$var$types = {
    ArrayN: $03654fa7a69bc7e8$var$_ArrayN,
    Buffer: $03654fa7a69bc7e8$var$_Buffer,
    BufferN: $03654fa7a69bc7e8$var$_BufferN,
    Finite: $03654fa7a69bc7e8$var$Finite,
    Hex: $03654fa7a69bc7e8$var$Hex,
    HexN: $03654fa7a69bc7e8$var$_HexN,
    Int8: $03654fa7a69bc7e8$var$Int8,
    Int16: $03654fa7a69bc7e8$var$Int16,
    Int32: $03654fa7a69bc7e8$var$Int32,
    Int53: $03654fa7a69bc7e8$var$Int53,
    Range: $03654fa7a69bc7e8$var$Range,
    StringN: $03654fa7a69bc7e8$var$_StringN,
    UInt8: $03654fa7a69bc7e8$var$UInt8,
    UInt16: $03654fa7a69bc7e8$var$UInt16,
    UInt32: $03654fa7a69bc7e8$var$UInt32,
    UInt53: $03654fa7a69bc7e8$var$UInt53
};
for(var $03654fa7a69bc7e8$var$typeName in $03654fa7a69bc7e8$var$types)$03654fa7a69bc7e8$var$types[$03654fa7a69bc7e8$var$typeName].toJSON = (function(t) {
    return t;
}).bind(null, $03654fa7a69bc7e8$var$typeName);
module.exports = $03654fa7a69bc7e8$var$types;

});


parcelRequire.register("bTFmB", function(module, exports) {

var $ihoyg = parcelRequire("ihoyg");
var $8a94eab3b5d39034$require$Buffer = $ihoyg.Buffer;

var $1Vf4C = parcelRequire("1Vf4C");
function $8a94eab3b5d39034$var$decodeRaw(buffer, version) {
    // check version only if defined
    if (version !== undefined && buffer[0] !== version) throw new Error("Invalid network version");
    // uncompressed
    if (buffer.length === 33) return {
        version: buffer[0],
        privateKey: buffer.slice(1, 33),
        compressed: false
    };
    // invalid length
    if (buffer.length !== 34) throw new Error("Invalid WIF length");
    // invalid compression flag
    if (buffer[33] !== 0x01) throw new Error("Invalid compression flag");
    return {
        version: buffer[0],
        privateKey: buffer.slice(1, 33),
        compressed: true
    };
}
function $8a94eab3b5d39034$var$encodeRaw(version, privateKey, compressed) {
    var result = new $8a94eab3b5d39034$require$Buffer(compressed ? 34 : 33);
    result.writeUInt8(version, 0);
    privateKey.copy(result, 1);
    if (compressed) result[33] = 0x01;
    return result;
}
function $8a94eab3b5d39034$var$decode(string, version) {
    return $8a94eab3b5d39034$var$decodeRaw($1Vf4C.decode(string), version);
}
function $8a94eab3b5d39034$var$encode(version, privateKey, compressed) {
    if (typeof version === "number") return $1Vf4C.encode($8a94eab3b5d39034$var$encodeRaw(version, privateKey, compressed));
    return $1Vf4C.encode($8a94eab3b5d39034$var$encodeRaw(version.version, version.privateKey, version.compressed));
}
module.exports = {
    decode: $8a94eab3b5d39034$var$decode,
    decodeRaw: $8a94eab3b5d39034$var$decodeRaw,
    encode: $8a94eab3b5d39034$var$encode,
    encodeRaw: $8a94eab3b5d39034$var$encodeRaw
};

});



parcelRequire.register("je616", function(module, exports) {

$parcel$export(module.exports, "Buffer", function () { return $dff3fdeef02c8049$export$a143d493d941bafc; }, function (v) { return $dff3fdeef02c8049$export$a143d493d941bafc = v; });
$parcel$export(module.exports, "INSPECT_MAX_BYTES", function () { return $dff3fdeef02c8049$export$f99ded8fe4b79145; }, function (v) { return $dff3fdeef02c8049$export$f99ded8fe4b79145 = v; });
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ var $dff3fdeef02c8049$export$a143d493d941bafc;
var $dff3fdeef02c8049$export$e4cf37d7f6fb9e0a;
var $dff3fdeef02c8049$export$f99ded8fe4b79145;
var $dff3fdeef02c8049$export$599f31c3813fae4d;
"use strict";

var $hqZtu = parcelRequire("hqZtu");

var $5WQj6 = parcelRequire("5WQj6");
const $dff3fdeef02c8049$var$customInspectSymbol = typeof Symbol === "function" && typeof Symbol["for"] === "function" // eslint-disable-line dot-notation
 ? Symbol["for"]("nodejs.util.inspect.custom") // eslint-disable-line dot-notation
 : null;
$dff3fdeef02c8049$export$a143d493d941bafc = $dff3fdeef02c8049$var$Buffer;
$dff3fdeef02c8049$export$e4cf37d7f6fb9e0a = $dff3fdeef02c8049$var$SlowBuffer;
$dff3fdeef02c8049$export$f99ded8fe4b79145 = 50;
const $dff3fdeef02c8049$var$K_MAX_LENGTH = 0x7fffffff;
$dff3fdeef02c8049$export$599f31c3813fae4d = $dff3fdeef02c8049$var$K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ $dff3fdeef02c8049$var$Buffer.TYPED_ARRAY_SUPPORT = $dff3fdeef02c8049$var$typedArraySupport();
if (!$dff3fdeef02c8049$var$Buffer.TYPED_ARRAY_SUPPORT && typeof console !== "undefined" && typeof console.error === "function") console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function $dff3fdeef02c8049$var$typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        const arr = new Uint8Array(1);
        const proto = {
            foo: function() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty($dff3fdeef02c8049$var$Buffer.prototype, "parent", {
    enumerable: true,
    get: function() {
        if (!$dff3fdeef02c8049$var$Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty($dff3fdeef02c8049$var$Buffer.prototype, "offset", {
    enumerable: true,
    get: function() {
        if (!$dff3fdeef02c8049$var$Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function $dff3fdeef02c8049$var$createBuffer(length) {
    if (length > $dff3fdeef02c8049$var$K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    const buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, $dff3fdeef02c8049$var$Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $dff3fdeef02c8049$var$Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === "number") {
        if (typeof encodingOrOffset === "string") throw new TypeError('The "string" argument must be of type string. Received type number');
        return $dff3fdeef02c8049$var$allocUnsafe(arg);
    }
    return $dff3fdeef02c8049$var$from(arg, encodingOrOffset, length);
}
$dff3fdeef02c8049$var$Buffer.poolSize = 8192 // not used by this implementation
;
function $dff3fdeef02c8049$var$from(value, encodingOrOffset, length) {
    if (typeof value === "string") return $dff3fdeef02c8049$var$fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return $dff3fdeef02c8049$var$fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
    if ($dff3fdeef02c8049$var$isInstance(value, ArrayBuffer) || value && $dff3fdeef02c8049$var$isInstance(value.buffer, ArrayBuffer)) return $dff3fdeef02c8049$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== "undefined" && ($dff3fdeef02c8049$var$isInstance(value, SharedArrayBuffer) || value && $dff3fdeef02c8049$var$isInstance(value.buffer, SharedArrayBuffer))) return $dff3fdeef02c8049$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === "number") throw new TypeError('The "value" argument must not be of type number. Received type number');
    const valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return $dff3fdeef02c8049$var$Buffer.from(valueOf, encodingOrOffset, length);
    const b = $dff3fdeef02c8049$var$fromObject(value);
    if (b) return b;
    if (typeof Symbol !== "undefined" && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === "function") return $dff3fdeef02c8049$var$Buffer.from(value[Symbol.toPrimitive]("string"), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $dff3fdeef02c8049$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $dff3fdeef02c8049$var$from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf($dff3fdeef02c8049$var$Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf($dff3fdeef02c8049$var$Buffer, Uint8Array);
function $dff3fdeef02c8049$var$assertSize(size) {
    if (typeof size !== "number") throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function $dff3fdeef02c8049$var$alloc(size, fill, encoding) {
    $dff3fdeef02c8049$var$assertSize(size);
    if (size <= 0) return $dff3fdeef02c8049$var$createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === "string" ? $dff3fdeef02c8049$var$createBuffer(size).fill(fill, encoding) : $dff3fdeef02c8049$var$createBuffer(size).fill(fill);
    return $dff3fdeef02c8049$var$createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $dff3fdeef02c8049$var$Buffer.alloc = function(size, fill, encoding) {
    return $dff3fdeef02c8049$var$alloc(size, fill, encoding);
};
function $dff3fdeef02c8049$var$allocUnsafe(size) {
    $dff3fdeef02c8049$var$assertSize(size);
    return $dff3fdeef02c8049$var$createBuffer(size < 0 ? 0 : $dff3fdeef02c8049$var$checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $dff3fdeef02c8049$var$Buffer.allocUnsafe = function(size) {
    return $dff3fdeef02c8049$var$allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $dff3fdeef02c8049$var$Buffer.allocUnsafeSlow = function(size) {
    return $dff3fdeef02c8049$var$allocUnsafe(size);
};
function $dff3fdeef02c8049$var$fromString(string, encoding) {
    if (typeof encoding !== "string" || encoding === "") encoding = "utf8";
    if (!$dff3fdeef02c8049$var$Buffer.isEncoding(encoding)) throw new TypeError("Unknown encoding: " + encoding);
    const length = $dff3fdeef02c8049$var$byteLength(string, encoding) | 0;
    let buf = $dff3fdeef02c8049$var$createBuffer(length);
    const actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function $dff3fdeef02c8049$var$fromArrayLike(array) {
    const length = array.length < 0 ? 0 : $dff3fdeef02c8049$var$checked(array.length) | 0;
    const buf = $dff3fdeef02c8049$var$createBuffer(length);
    for(let i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function $dff3fdeef02c8049$var$fromArrayView(arrayView) {
    if ($dff3fdeef02c8049$var$isInstance(arrayView, Uint8Array)) {
        const copy = new Uint8Array(arrayView);
        return $dff3fdeef02c8049$var$fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return $dff3fdeef02c8049$var$fromArrayLike(arrayView);
}
function $dff3fdeef02c8049$var$fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    let buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, $dff3fdeef02c8049$var$Buffer.prototype);
    return buf;
}
function $dff3fdeef02c8049$var$fromObject(obj) {
    if ($dff3fdeef02c8049$var$Buffer.isBuffer(obj)) {
        const len = $dff3fdeef02c8049$var$checked(obj.length) | 0;
        const buf = $dff3fdeef02c8049$var$createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== "number" || $dff3fdeef02c8049$var$numberIsNaN(obj.length)) return $dff3fdeef02c8049$var$createBuffer(0);
        return $dff3fdeef02c8049$var$fromArrayLike(obj);
    }
    if (obj.type === "Buffer" && Array.isArray(obj.data)) return $dff3fdeef02c8049$var$fromArrayLike(obj.data);
}
function $dff3fdeef02c8049$var$checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $dff3fdeef02c8049$var$K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $dff3fdeef02c8049$var$K_MAX_LENGTH.toString(16) + " bytes");
    return length | 0;
}
function $dff3fdeef02c8049$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $dff3fdeef02c8049$var$Buffer.alloc(+length);
}
$dff3fdeef02c8049$var$Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== $dff3fdeef02c8049$var$Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
$dff3fdeef02c8049$var$Buffer.compare = function compare(a, b) {
    if ($dff3fdeef02c8049$var$isInstance(a, Uint8Array)) a = $dff3fdeef02c8049$var$Buffer.from(a, a.offset, a.byteLength);
    if ($dff3fdeef02c8049$var$isInstance(b, Uint8Array)) b = $dff3fdeef02c8049$var$Buffer.from(b, b.offset, b.byteLength);
    if (!$dff3fdeef02c8049$var$Buffer.isBuffer(a) || !$dff3fdeef02c8049$var$Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    let x = a.length;
    let y = b.length;
    for(let i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$dff3fdeef02c8049$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case "hex":
        case "utf8":
        case "utf-8":
        case "ascii":
        case "latin1":
        case "binary":
        case "base64":
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return true;
        default:
            return false;
    }
};
$dff3fdeef02c8049$var$Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $dff3fdeef02c8049$var$Buffer.alloc(0);
    let i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    const buffer = $dff3fdeef02c8049$var$Buffer.allocUnsafe(length);
    let pos = 0;
    for(i = 0; i < list.length; ++i){
        let buf = list[i];
        if ($dff3fdeef02c8049$var$isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) {
                if (!$dff3fdeef02c8049$var$Buffer.isBuffer(buf)) buf = $dff3fdeef02c8049$var$Buffer.from(buf);
                buf.copy(buffer, pos);
            } else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!$dff3fdeef02c8049$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $dff3fdeef02c8049$var$byteLength(string, encoding) {
    if ($dff3fdeef02c8049$var$Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || $dff3fdeef02c8049$var$isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== "string") throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string);
    const len = string.length;
    const mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    let loweredCase = false;
    for(;;)switch(encoding){
        case "ascii":
        case "latin1":
        case "binary":
            return len;
        case "utf8":
        case "utf-8":
            return $dff3fdeef02c8049$var$utf8ToBytes(string).length;
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return len * 2;
        case "hex":
            return len >>> 1;
        case "base64":
            return $dff3fdeef02c8049$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : $dff3fdeef02c8049$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ("" + encoding).toLowerCase();
            loweredCase = true;
    }
}
$dff3fdeef02c8049$var$Buffer.byteLength = $dff3fdeef02c8049$var$byteLength;
function $dff3fdeef02c8049$var$slowToString(encoding, start, end) {
    let loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return "";
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return "";
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return "";
    if (!encoding) encoding = "utf8";
    while(true)switch(encoding){
        case "hex":
            return $dff3fdeef02c8049$var$hexSlice(this, start, end);
        case "utf8":
        case "utf-8":
            return $dff3fdeef02c8049$var$utf8Slice(this, start, end);
        case "ascii":
            return $dff3fdeef02c8049$var$asciiSlice(this, start, end);
        case "latin1":
        case "binary":
            return $dff3fdeef02c8049$var$latin1Slice(this, start, end);
        case "base64":
            return $dff3fdeef02c8049$var$base64Slice(this, start, end);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return $dff3fdeef02c8049$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
            encoding = (encoding + "").toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
$dff3fdeef02c8049$var$Buffer.prototype._isBuffer = true;
function $dff3fdeef02c8049$var$swap(b, n, m) {
    const i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$dff3fdeef02c8049$var$Buffer.prototype.swap16 = function swap16() {
    const len = this.length;
    if (len % 2 !== 0) throw new RangeError("Buffer size must be a multiple of 16-bits");
    for(let i = 0; i < len; i += 2)$dff3fdeef02c8049$var$swap(this, i, i + 1);
    return this;
};
$dff3fdeef02c8049$var$Buffer.prototype.swap32 = function swap32() {
    const len = this.length;
    if (len % 4 !== 0) throw new RangeError("Buffer size must be a multiple of 32-bits");
    for(let i = 0; i < len; i += 4){
        $dff3fdeef02c8049$var$swap(this, i, i + 3);
        $dff3fdeef02c8049$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$dff3fdeef02c8049$var$Buffer.prototype.swap64 = function swap64() {
    const len = this.length;
    if (len % 8 !== 0) throw new RangeError("Buffer size must be a multiple of 64-bits");
    for(let i = 0; i < len; i += 8){
        $dff3fdeef02c8049$var$swap(this, i, i + 7);
        $dff3fdeef02c8049$var$swap(this, i + 1, i + 6);
        $dff3fdeef02c8049$var$swap(this, i + 2, i + 5);
        $dff3fdeef02c8049$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$dff3fdeef02c8049$var$Buffer.prototype.toString = function toString() {
    const length = this.length;
    if (length === 0) return "";
    if (arguments.length === 0) return $dff3fdeef02c8049$var$utf8Slice(this, 0, length);
    return $dff3fdeef02c8049$var$slowToString.apply(this, arguments);
};
$dff3fdeef02c8049$var$Buffer.prototype.toLocaleString = $dff3fdeef02c8049$var$Buffer.prototype.toString;
$dff3fdeef02c8049$var$Buffer.prototype.equals = function equals(b) {
    if (!$dff3fdeef02c8049$var$Buffer.isBuffer(b)) throw new TypeError("Argument must be a Buffer");
    if (this === b) return true;
    return $dff3fdeef02c8049$var$Buffer.compare(this, b) === 0;
};
$dff3fdeef02c8049$var$Buffer.prototype.inspect = function inspect() {
    let str = "";
    const max = $dff3fdeef02c8049$export$f99ded8fe4b79145;
    str = this.toString("hex", 0, max).replace(/(.{2})/g, "$1 ").trim();
    if (this.length > max) str += " ... ";
    return "<Buffer " + str + ">";
};
if ($dff3fdeef02c8049$var$customInspectSymbol) $dff3fdeef02c8049$var$Buffer.prototype[$dff3fdeef02c8049$var$customInspectSymbol] = $dff3fdeef02c8049$var$Buffer.prototype.inspect;
$dff3fdeef02c8049$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if ($dff3fdeef02c8049$var$isInstance(target, Uint8Array)) target = $dff3fdeef02c8049$var$Buffer.from(target, target.offset, target.byteLength);
    if (!$dff3fdeef02c8049$var$Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target);
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError("out of range index");
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    let x = thisEnd - thisStart;
    let y = end - start;
    const len = Math.min(x, y);
    const thisCopy = this.slice(thisStart, thisEnd);
    const targetCopy = target.slice(start, end);
    for(let i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $dff3fdeef02c8049$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === "string") {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if ($dff3fdeef02c8049$var$numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === "string") val = $dff3fdeef02c8049$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($dff3fdeef02c8049$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $dff3fdeef02c8049$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === "number") {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === "function") {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $dff3fdeef02c8049$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError("val must be string, number or Buffer");
}
function $dff3fdeef02c8049$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    let indexSize = 1;
    let arrLength = arr.length;
    let valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === "ucs2" || encoding === "ucs-2" || encoding === "utf16le" || encoding === "utf-16le") {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    let i;
    if (dir) {
        let foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            let found = true;
            for(let j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$dff3fdeef02c8049$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$dff3fdeef02c8049$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $dff3fdeef02c8049$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$dff3fdeef02c8049$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $dff3fdeef02c8049$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $dff3fdeef02c8049$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    const remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    const strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    let i;
    for(i = 0; i < length; ++i){
        const parsed = parseInt(string.substr(i * 2, 2), 16);
        if ($dff3fdeef02c8049$var$numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $dff3fdeef02c8049$var$utf8Write(buf, string, offset, length) {
    return $dff3fdeef02c8049$var$blitBuffer($dff3fdeef02c8049$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $dff3fdeef02c8049$var$asciiWrite(buf, string, offset, length) {
    return $dff3fdeef02c8049$var$blitBuffer($dff3fdeef02c8049$var$asciiToBytes(string), buf, offset, length);
}
function $dff3fdeef02c8049$var$base64Write(buf, string, offset, length) {
    return $dff3fdeef02c8049$var$blitBuffer($dff3fdeef02c8049$var$base64ToBytes(string), buf, offset, length);
}
function $dff3fdeef02c8049$var$ucs2Write(buf, string, offset, length) {
    return $dff3fdeef02c8049$var$blitBuffer($dff3fdeef02c8049$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$dff3fdeef02c8049$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = "utf8";
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === "string") {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = "utf8";
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error("Buffer.write(string, encoding, offset[, length]) is no longer supported");
    const remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError("Attempt to write outside buffer bounds");
    if (!encoding) encoding = "utf8";
    let loweredCase = false;
    for(;;)switch(encoding){
        case "hex":
            return $dff3fdeef02c8049$var$hexWrite(this, string, offset, length);
        case "utf8":
        case "utf-8":
            return $dff3fdeef02c8049$var$utf8Write(this, string, offset, length);
        case "ascii":
        case "latin1":
        case "binary":
            return $dff3fdeef02c8049$var$asciiWrite(this, string, offset, length);
        case "base64":
            // Warning: maxLength not taken into account in base64Write
            return $dff3fdeef02c8049$var$base64Write(this, string, offset, length);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return $dff3fdeef02c8049$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
            encoding = ("" + encoding).toLowerCase();
            loweredCase = true;
    }
};
$dff3fdeef02c8049$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: "Buffer",
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $dff3fdeef02c8049$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $hqZtu.fromByteArray(buf);
    else return $hqZtu.fromByteArray(buf.slice(start, end));
}
function $dff3fdeef02c8049$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    const res = [];
    let i = start;
    while(i < end){
        const firstByte = buf[i];
        let codePoint = null;
        let bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            let secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $dff3fdeef02c8049$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
const $dff3fdeef02c8049$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $dff3fdeef02c8049$var$decodeCodePointsArray(codePoints) {
    const len = codePoints.length;
    if (len <= $dff3fdeef02c8049$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    let res = "";
    let i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $dff3fdeef02c8049$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $dff3fdeef02c8049$var$asciiSlice(buf, start, end) {
    let ret = "";
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $dff3fdeef02c8049$var$latin1Slice(buf, start, end) {
    let ret = "";
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $dff3fdeef02c8049$var$hexSlice(buf, start, end) {
    const len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    let out = "";
    for(let i = start; i < end; ++i)out += $dff3fdeef02c8049$var$hexSliceLookupTable[buf[i]];
    return out;
}
function $dff3fdeef02c8049$var$utf16leSlice(buf, start, end) {
    const bytes = buf.slice(start, end);
    let res = "";
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(let i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$dff3fdeef02c8049$var$Buffer.prototype.slice = function slice(start, end) {
    const len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    const newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, $dff3fdeef02c8049$var$Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $dff3fdeef02c8049$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError("offset is not uint");
    if (offset + ext > length) throw new RangeError("Trying to access beyond buffer length");
}
$dff3fdeef02c8049$var$Buffer.prototype.readUintLE = $dff3fdeef02c8049$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $dff3fdeef02c8049$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$dff3fdeef02c8049$var$Buffer.prototype.readUintBE = $dff3fdeef02c8049$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $dff3fdeef02c8049$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset + --byteLength];
    let mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$dff3fdeef02c8049$var$Buffer.prototype.readUint8 = $dff3fdeef02c8049$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $dff3fdeef02c8049$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$dff3fdeef02c8049$var$Buffer.prototype.readUint16LE = $dff3fdeef02c8049$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $dff3fdeef02c8049$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$dff3fdeef02c8049$var$Buffer.prototype.readUint16BE = $dff3fdeef02c8049$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $dff3fdeef02c8049$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$dff3fdeef02c8049$var$Buffer.prototype.readUint32LE = $dff3fdeef02c8049$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $dff3fdeef02c8049$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$dff3fdeef02c8049$var$Buffer.prototype.readUint32BE = $dff3fdeef02c8049$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $dff3fdeef02c8049$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$dff3fdeef02c8049$var$Buffer.prototype.readBigUInt64LE = $dff3fdeef02c8049$var$defineBigIntMethod(function readBigUInt64LE(offset) {
    offset = offset >>> 0;
    $dff3fdeef02c8049$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $dff3fdeef02c8049$var$boundsError(offset, this.length - 8);
    const lo = first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24;
    const hi = this[++offset] + this[++offset] * 256 + this[++offset] * 2 ** 16 + last * 2 ** 24;
    return BigInt(lo) + (BigInt(hi) << BigInt(32));
});
$dff3fdeef02c8049$var$Buffer.prototype.readBigUInt64BE = $dff3fdeef02c8049$var$defineBigIntMethod(function readBigUInt64BE(offset) {
    offset = offset >>> 0;
    $dff3fdeef02c8049$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $dff3fdeef02c8049$var$boundsError(offset, this.length - 8);
    const hi = first * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    const lo = this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last;
    return (BigInt(hi) << BigInt(32)) + BigInt(lo);
});
$dff3fdeef02c8049$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $dff3fdeef02c8049$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$dff3fdeef02c8049$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $dff3fdeef02c8049$var$checkOffset(offset, byteLength, this.length);
    let i = byteLength;
    let mul = 1;
    let val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$dff3fdeef02c8049$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $dff3fdeef02c8049$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$dff3fdeef02c8049$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $dff3fdeef02c8049$var$checkOffset(offset, 2, this.length);
    const val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$dff3fdeef02c8049$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $dff3fdeef02c8049$var$checkOffset(offset, 2, this.length);
    const val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$dff3fdeef02c8049$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $dff3fdeef02c8049$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$dff3fdeef02c8049$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $dff3fdeef02c8049$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$dff3fdeef02c8049$var$Buffer.prototype.readBigInt64LE = $dff3fdeef02c8049$var$defineBigIntMethod(function readBigInt64LE(offset) {
    offset = offset >>> 0;
    $dff3fdeef02c8049$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $dff3fdeef02c8049$var$boundsError(offset, this.length - 8);
    const val = this[offset + 4] + this[offset + 5] * 256 + this[offset + 6] * 2 ** 16 + (last << 24 // Overflow
    );
    return (BigInt(val) << BigInt(32)) + BigInt(first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24);
});
$dff3fdeef02c8049$var$Buffer.prototype.readBigInt64BE = $dff3fdeef02c8049$var$defineBigIntMethod(function readBigInt64BE(offset) {
    offset = offset >>> 0;
    $dff3fdeef02c8049$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $dff3fdeef02c8049$var$boundsError(offset, this.length - 8);
    const val = (first << 24) + // Overflow
    this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    return (BigInt(val) << BigInt(32)) + BigInt(this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last);
});
$dff3fdeef02c8049$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $dff3fdeef02c8049$var$checkOffset(offset, 4, this.length);
    return $5WQj6.read(this, offset, true, 23, 4);
};
$dff3fdeef02c8049$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $dff3fdeef02c8049$var$checkOffset(offset, 4, this.length);
    return $5WQj6.read(this, offset, false, 23, 4);
};
$dff3fdeef02c8049$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $dff3fdeef02c8049$var$checkOffset(offset, 8, this.length);
    return $5WQj6.read(this, offset, true, 52, 8);
};
$dff3fdeef02c8049$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $dff3fdeef02c8049$var$checkOffset(offset, 8, this.length);
    return $5WQj6.read(this, offset, false, 52, 8);
};
function $dff3fdeef02c8049$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$dff3fdeef02c8049$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError("Index out of range");
}
$dff3fdeef02c8049$var$Buffer.prototype.writeUintLE = $dff3fdeef02c8049$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $dff3fdeef02c8049$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let mul = 1;
    let i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$dff3fdeef02c8049$var$Buffer.prototype.writeUintBE = $dff3fdeef02c8049$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $dff3fdeef02c8049$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let i = byteLength - 1;
    let mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$dff3fdeef02c8049$var$Buffer.prototype.writeUint8 = $dff3fdeef02c8049$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $dff3fdeef02c8049$var$checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
$dff3fdeef02c8049$var$Buffer.prototype.writeUint16LE = $dff3fdeef02c8049$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $dff3fdeef02c8049$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$dff3fdeef02c8049$var$Buffer.prototype.writeUint16BE = $dff3fdeef02c8049$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $dff3fdeef02c8049$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$dff3fdeef02c8049$var$Buffer.prototype.writeUint32LE = $dff3fdeef02c8049$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $dff3fdeef02c8049$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
$dff3fdeef02c8049$var$Buffer.prototype.writeUint32BE = $dff3fdeef02c8049$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $dff3fdeef02c8049$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function $dff3fdeef02c8049$var$wrtBigUInt64LE(buf, value, offset, min, max) {
    $dff3fdeef02c8049$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    return offset;
}
function $dff3fdeef02c8049$var$wrtBigUInt64BE(buf, value, offset, min, max) {
    $dff3fdeef02c8049$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset + 7] = lo;
    lo = lo >> 8;
    buf[offset + 6] = lo;
    lo = lo >> 8;
    buf[offset + 5] = lo;
    lo = lo >> 8;
    buf[offset + 4] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset + 3] = hi;
    hi = hi >> 8;
    buf[offset + 2] = hi;
    hi = hi >> 8;
    buf[offset + 1] = hi;
    hi = hi >> 8;
    buf[offset] = hi;
    return offset + 8;
}
$dff3fdeef02c8049$var$Buffer.prototype.writeBigUInt64LE = $dff3fdeef02c8049$var$defineBigIntMethod(function writeBigUInt64LE(value, offset = 0) {
    return $dff3fdeef02c8049$var$wrtBigUInt64LE(this, value, offset, BigInt(0), BigInt("0xffffffffffffffff"));
});
$dff3fdeef02c8049$var$Buffer.prototype.writeBigUInt64BE = $dff3fdeef02c8049$var$defineBigIntMethod(function writeBigUInt64BE(value, offset = 0) {
    return $dff3fdeef02c8049$var$wrtBigUInt64BE(this, value, offset, BigInt(0), BigInt("0xffffffffffffffff"));
});
$dff3fdeef02c8049$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $dff3fdeef02c8049$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = 0;
    let mul = 1;
    let sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$dff3fdeef02c8049$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $dff3fdeef02c8049$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = byteLength - 1;
    let mul = 1;
    let sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$dff3fdeef02c8049$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $dff3fdeef02c8049$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$dff3fdeef02c8049$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $dff3fdeef02c8049$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$dff3fdeef02c8049$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $dff3fdeef02c8049$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$dff3fdeef02c8049$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $dff3fdeef02c8049$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
$dff3fdeef02c8049$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $dff3fdeef02c8049$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
$dff3fdeef02c8049$var$Buffer.prototype.writeBigInt64LE = $dff3fdeef02c8049$var$defineBigIntMethod(function writeBigInt64LE(value, offset = 0) {
    return $dff3fdeef02c8049$var$wrtBigUInt64LE(this, value, offset, -BigInt("0x8000000000000000"), BigInt("0x7fffffffffffffff"));
});
$dff3fdeef02c8049$var$Buffer.prototype.writeBigInt64BE = $dff3fdeef02c8049$var$defineBigIntMethod(function writeBigInt64BE(value, offset = 0) {
    return $dff3fdeef02c8049$var$wrtBigUInt64BE(this, value, offset, -BigInt("0x8000000000000000"), BigInt("0x7fffffffffffffff"));
});
function $dff3fdeef02c8049$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError("Index out of range");
    if (offset < 0) throw new RangeError("Index out of range");
}
function $dff3fdeef02c8049$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $dff3fdeef02c8049$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $5WQj6.write(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$dff3fdeef02c8049$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $dff3fdeef02c8049$var$writeFloat(this, value, offset, true, noAssert);
};
$dff3fdeef02c8049$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $dff3fdeef02c8049$var$writeFloat(this, value, offset, false, noAssert);
};
function $dff3fdeef02c8049$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $dff3fdeef02c8049$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $5WQj6.write(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$dff3fdeef02c8049$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $dff3fdeef02c8049$var$writeDouble(this, value, offset, true, noAssert);
};
$dff3fdeef02c8049$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $dff3fdeef02c8049$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$dff3fdeef02c8049$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!$dff3fdeef02c8049$var$Buffer.isBuffer(target)) throw new TypeError("argument should be a Buffer");
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError("targetStart out of bounds");
    if (start < 0 || start >= this.length) throw new RangeError("Index out of range");
    if (end < 0) throw new RangeError("sourceEnd out of bounds");
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    const len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === "function") // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$dff3fdeef02c8049$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === "string") {
        if (typeof start === "string") {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === "string") {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== "string") throw new TypeError("encoding must be a string");
        if (typeof encoding === "string" && !$dff3fdeef02c8049$var$Buffer.isEncoding(encoding)) throw new TypeError("Unknown encoding: " + encoding);
        if (val.length === 1) {
            const code = val.charCodeAt(0);
            if (encoding === "utf8" && code < 128 || encoding === "latin1") // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === "number") val = val & 255;
    else if (typeof val === "boolean") val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError("Out of range index");
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    let i;
    if (typeof val === "number") for(i = start; i < end; ++i)this[i] = val;
    else {
        const bytes = $dff3fdeef02c8049$var$Buffer.isBuffer(val) ? val : $dff3fdeef02c8049$var$Buffer.from(val, encoding);
        const len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// CUSTOM ERRORS
// =============
// Simplified versions from Node, changed for Buffer-only usage
const $dff3fdeef02c8049$var$errors = {};
function $dff3fdeef02c8049$var$E(sym, getMessage, Base) {
    $dff3fdeef02c8049$var$errors[sym] = class NodeError extends Base {
        constructor(){
            super();
            Object.defineProperty(this, "message", {
                value: getMessage.apply(this, arguments),
                writable: true,
                configurable: true
            });
            // Add the error code to the name to include it in the stack trace.
            this.name = `${this.name} [${sym}]`;
            // Access the stack to generate the error message including the error code
            // from the name.
            this.stack // eslint-disable-line no-unused-expressions
            ;
            // Reset the name to the actual name.
            delete this.name;
        }
        get code() {
            return sym;
        }
        set code(value) {
            Object.defineProperty(this, "code", {
                configurable: true,
                enumerable: true,
                value: value,
                writable: true
            });
        }
        toString() {
            return `${this.name} [${sym}]: ${this.message}`;
        }
    };
}
$dff3fdeef02c8049$var$E("ERR_BUFFER_OUT_OF_BOUNDS", function(name) {
    if (name) return `${name} is outside of buffer bounds`;
    return "Attempt to access memory outside buffer bounds";
}, RangeError);
$dff3fdeef02c8049$var$E("ERR_INVALID_ARG_TYPE", function(name, actual) {
    return `The "${name}" argument must be of type number. Received type ${typeof actual}`;
}, TypeError);
$dff3fdeef02c8049$var$E("ERR_OUT_OF_RANGE", function(str, range, input) {
    let msg = `The value of "${str}" is out of range.`;
    let received = input;
    if (Number.isInteger(input) && Math.abs(input) > 2 ** 32) received = $dff3fdeef02c8049$var$addNumericalSeparator(String(input));
    else if (typeof input === "bigint") {
        received = String(input);
        if (input > BigInt(2) ** BigInt(32) || input < -(BigInt(2) ** BigInt(32))) received = $dff3fdeef02c8049$var$addNumericalSeparator(received);
        received += "n";
    }
    msg += ` It must be ${range}. Received ${received}`;
    return msg;
}, RangeError);
function $dff3fdeef02c8049$var$addNumericalSeparator(val) {
    let res = "";
    let i = val.length;
    const start = val[0] === "-" ? 1 : 0;
    for(; i >= start + 4; i -= 3)res = `_${val.slice(i - 3, i)}${res}`;
    return `${val.slice(0, i)}${res}`;
}
// CHECK FUNCTIONS
// ===============
function $dff3fdeef02c8049$var$checkBounds(buf, offset, byteLength) {
    $dff3fdeef02c8049$var$validateNumber(offset, "offset");
    if (buf[offset] === undefined || buf[offset + byteLength] === undefined) $dff3fdeef02c8049$var$boundsError(offset, buf.length - (byteLength + 1));
}
function $dff3fdeef02c8049$var$checkIntBI(value, min, max, buf, offset, byteLength) {
    if (value > max || value < min) {
        const n = typeof min === "bigint" ? "n" : "";
        let range;
        if (byteLength > 3) {
            if (min === 0 || min === BigInt(0)) range = `>= 0${n} and < 2${n} ** ${(byteLength + 1) * 8}${n}`;
            else range = `>= -(2${n} ** ${(byteLength + 1) * 8 - 1}${n}) and < 2 ** ` + `${(byteLength + 1) * 8 - 1}${n}`;
        } else range = `>= ${min}${n} and <= ${max}${n}`;
        throw new $dff3fdeef02c8049$var$errors.ERR_OUT_OF_RANGE("value", range, value);
    }
    $dff3fdeef02c8049$var$checkBounds(buf, offset, byteLength);
}
function $dff3fdeef02c8049$var$validateNumber(value, name) {
    if (typeof value !== "number") throw new $dff3fdeef02c8049$var$errors.ERR_INVALID_ARG_TYPE(name, "number", value);
}
function $dff3fdeef02c8049$var$boundsError(value, length, type) {
    if (Math.floor(value) !== value) {
        $dff3fdeef02c8049$var$validateNumber(value, type);
        throw new $dff3fdeef02c8049$var$errors.ERR_OUT_OF_RANGE(type || "offset", "an integer", value);
    }
    if (length < 0) throw new $dff3fdeef02c8049$var$errors.ERR_BUFFER_OUT_OF_BOUNDS();
    throw new $dff3fdeef02c8049$var$errors.ERR_OUT_OF_RANGE(type || "offset", `>= ${type ? 1 : 0} and <= ${length}`, value);
}
// HELPER FUNCTIONS
// ================
const $dff3fdeef02c8049$var$INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function $dff3fdeef02c8049$var$base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split("=")[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace($dff3fdeef02c8049$var$INVALID_BASE64_RE, "");
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return "";
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + "=";
    return str;
}
function $dff3fdeef02c8049$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    let codePoint;
    const length = string.length;
    let leadSurrogate = null;
    const bytes = [];
    for(let i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error("Invalid code point");
    }
    return bytes;
}
function $dff3fdeef02c8049$var$asciiToBytes(str) {
    const byteArray = [];
    for(let i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $dff3fdeef02c8049$var$utf16leToBytes(str, units) {
    let c, hi, lo;
    const byteArray = [];
    for(let i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $dff3fdeef02c8049$var$base64ToBytes(str) {
    return $hqZtu.toByteArray($dff3fdeef02c8049$var$base64clean(str));
}
function $dff3fdeef02c8049$var$blitBuffer(src, dst, offset, length) {
    let i;
    for(i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function $dff3fdeef02c8049$var$isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function $dff3fdeef02c8049$var$numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
const $dff3fdeef02c8049$var$hexSliceLookupTable = function() {
    const alphabet = "0123456789abcdef";
    const table = new Array(256);
    for(let i = 0; i < 16; ++i){
        const i16 = i * 16;
        for(let j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();
// Return not function with Error if BigInt not supported
function $dff3fdeef02c8049$var$defineBigIntMethod(fn) {
    return typeof BigInt === "undefined" ? $dff3fdeef02c8049$var$BufferBigIntNotDefined : fn;
}
function $dff3fdeef02c8049$var$BufferBigIntNotDefined() {
    throw new Error("BigInt not supported");
}

});


parcelRequire.register("eMsup", function(module, exports) {
"use strict";
var $ac2ba5ca5607cf24$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.PubKeySecp256k1 = module.exports.PrivKeySecp256k1 = void 0;

var $8J1ou = parcelRequire("8J1ou");

const $ac2ba5ca5607cf24$var$crypto_js_1 = $ac2ba5ca5607cf24$var$__importDefault((parcelRequire("kWcCv")));

var $je616 = parcelRequire("je616");
class $ac2ba5ca5607cf24$var$PrivKeySecp256k1 {
    constructor(privKey){
        this.privKey = privKey;
    }
    static generateRandomKey() {
        const secp256k1 = new $8J1ou.ec("secp256k1");
        return new $ac2ba5ca5607cf24$var$PrivKeySecp256k1($je616.Buffer.from(secp256k1.genKeyPair().getPrivate().toArray()));
    }
    toBytes() {
        return new Uint8Array(this.privKey);
    }
    getPubKey() {
        const secp256k1 = new $8J1ou.ec("secp256k1");
        const key = secp256k1.keyFromPrivate(this.privKey);
        return new $ac2ba5ca5607cf24$var$PubKeySecp256k1(new Uint8Array(key.getPublic().encodeCompressed("array")));
    }
    sign(msg) {
        const secp256k1 = new $8J1ou.ec("secp256k1");
        const key = secp256k1.keyFromPrivate(this.privKey);
        const hash = $ac2ba5ca5607cf24$var$crypto_js_1.default.SHA256($ac2ba5ca5607cf24$var$crypto_js_1.default.lib.WordArray.create(msg)).toString();
        const signature = key.sign($je616.Buffer.from(hash, "hex"), {
            canonical: true
        });
        return new Uint8Array(signature.r.toArray("be", 32).concat(signature.s.toArray("be", 32)));
    }
}
module.exports.PrivKeySecp256k1 = $ac2ba5ca5607cf24$var$PrivKeySecp256k1;
class $ac2ba5ca5607cf24$var$PubKeySecp256k1 {
    constructor(pubKey){
        this.pubKey = pubKey;
    }
    toBytes() {
        return new Uint8Array(this.pubKey);
    }
    getAddress() {
        let hash = $ac2ba5ca5607cf24$var$crypto_js_1.default.SHA256($ac2ba5ca5607cf24$var$crypto_js_1.default.lib.WordArray.create(this.pubKey)).toString();
        hash = $ac2ba5ca5607cf24$var$crypto_js_1.default.RIPEMD160($ac2ba5ca5607cf24$var$crypto_js_1.default.enc.Hex.parse(hash)).toString();
        return new Uint8Array($je616.Buffer.from(hash, "hex"));
    }
    toKeyPair() {
        const secp256k1 = new $8J1ou.ec("secp256k1");
        return secp256k1.keyFromPublic($je616.Buffer.from(this.pubKey).toString("hex"), "hex");
    }
    verify(msg, signature) {
        const hash = $ac2ba5ca5607cf24$var$crypto_js_1.default.SHA256($ac2ba5ca5607cf24$var$crypto_js_1.default.lib.WordArray.create(msg)).toString();
        const secp256k1 = new $8J1ou.ec("secp256k1");
        let r = signature.slice(0, 32);
        let s = signature.slice(32);
        const rIsNegative = r[0] >= 0x80;
        const sIsNegative = s[0] >= 0x80;
        if (rIsNegative) r = new Uint8Array([
            0,
            ...r
        ]);
        if (sIsNegative) s = new Uint8Array([
            0,
            ...s
        ]);
        // Der encoding
        const derData = new Uint8Array([
            0x02,
            r.length,
            ...r,
            0x02,
            s.length,
            ...s
        ]);
        return secp256k1.verify($je616.Buffer.from(hash, "hex"), new Uint8Array([
            0x30,
            derData.length,
            ...derData
        ]), this.toKeyPair());
    }
}
module.exports.PubKeySecp256k1 = $ac2ba5ca5607cf24$var$PubKeySecp256k1;

});
parcelRequire.register("kWcCv", function(module, exports) {



































(function(root, factory, undef) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("cfaDk")), (parcelRequire("gn80J")), (parcelRequire("9PUgX")), (parcelRequire("gu0dW")), (parcelRequire("500SS")), (parcelRequire("8aX4Y")), (parcelRequire("6oXxt")), (parcelRequire("lqaMD")), (parcelRequire("hNROW")), (parcelRequire("kgfdC")), (parcelRequire("6PaKQ")), (parcelRequire("bZEkw")), (parcelRequire("AFosI")), (parcelRequire("bIitx")), (parcelRequire("7ft6W")), (parcelRequire("as0jN")), (parcelRequire("ioEPr")), (parcelRequire("fctwD")), (parcelRequire("kvEE5")), (parcelRequire("4phbY")), (parcelRequire("5AuZH")), (parcelRequire("9xxh3")), (parcelRequire("hsvIJ")), (parcelRequire("cIj8k")), (parcelRequire("3XsJo")), (parcelRequire("4cP0m")), (parcelRequire("1bHm1")), (parcelRequire("5oWlT")), (parcelRequire("eSHMm")), (parcelRequire("3H9rt")), (parcelRequire("2QWZ2")), (parcelRequire("1sYM8")), (parcelRequire("hUv46")), (parcelRequire("3ybbi")), (parcelRequire("f4sF8")));
})(this, function(CryptoJS) {
    return CryptoJS;
});

});
parcelRequire.register("cfaDk", function(module, exports) {

(function(root, factory) {
    // CommonJS
    module.exports = exports = factory();
})(this, function() {
    /*globals window, global, require*/ /**
	 * CryptoJS core components.
	 */ var CryptoJS = CryptoJS || function(Math1, undefined) {
        var crypto;
        // Native crypto from window (Browser)
        if (typeof window !== "undefined" && window.crypto) crypto = window.crypto;
        // Native crypto in web worker (Browser)
        if (typeof self !== "undefined" && self.crypto) crypto = self.crypto;
        // Native crypto from worker
        if (typeof globalThis !== "undefined" && globalThis.crypto) crypto = globalThis.crypto;
        // Native (experimental IE 11) crypto from window (Browser)
        if (!crypto && typeof window !== "undefined" && window.msCrypto) crypto = window.msCrypto;
        // Native crypto from global (NodeJS)
        if (!crypto && typeof $parcel$global !== "undefined" && $parcel$global.crypto) crypto = $parcel$global.crypto;
        // Native crypto import via require (NodeJS)
        if (!crypto && true) try {
            crypto = (parcelRequire("5Io6y"));
        } catch (err) {}
        /*
	     * Cryptographically secure pseudorandom number generator
	     *
	     * As Math.random() is cryptographically not safe to use
	     */ var cryptoSecureRandomInt = function() {
            if (crypto) {
                // Use getRandomValues method (Browser)
                if (typeof crypto.getRandomValues === "function") try {
                    return crypto.getRandomValues(new Uint32Array(1))[0];
                } catch (err) {}
                // Use randomBytes method (NodeJS)
                if (typeof crypto.randomBytes === "function") try {
                    return crypto.randomBytes(4).readInt32LE();
                } catch (err) {}
            }
            throw new Error("Native crypto module could not be used to get secure random number.");
        };
        /*
	     * Local polyfill of Object.create

	     */ var create = Object.create || function() {
            function F() {}
            return function(obj) {
                var subtype;
                F.prototype = obj;
                subtype = new F();
                F.prototype = null;
                return subtype;
            };
        }();
        /**
	     * CryptoJS namespace.
	     */ var C = {};
        /**
	     * Library namespace.
	     */ var C_lib = C.lib = {};
        /**
	     * Base object for prototypal inheritance.
	     */ var Base = C_lib.Base = function() {
            return {
                /**
	             * Creates a new object that inherits from this object.
	             *
	             * @param {Object} overrides Properties to copy into the new object.
	             *
	             * @return {Object} The new object.
	             *
	             * @static
	             *
	             * @example
	             *
	             *     var MyType = CryptoJS.lib.Base.extend({
	             *         field: 'value',
	             *
	             *         method: function () {
	             *         }
	             *     });
	             */ extend: function(overrides) {
                    // Spawn
                    var subtype = create(this);
                    // Augment
                    if (overrides) subtype.mixIn(overrides);
                    // Create default initializer
                    if (!subtype.hasOwnProperty("init") || this.init === subtype.init) subtype.init = function() {
                        subtype.$super.init.apply(this, arguments);
                    };
                    // Initializer's prototype is the subtype object
                    subtype.init.prototype = subtype;
                    // Reference supertype
                    subtype.$super = this;
                    return subtype;
                },
                /**
	             * Extends this object and runs the init method.
	             * Arguments to create() will be passed to init().
	             *
	             * @return {Object} The new object.
	             *
	             * @static
	             *
	             * @example
	             *
	             *     var instance = MyType.create();
	             */ create: function() {
                    var instance = this.extend();
                    instance.init.apply(instance, arguments);
                    return instance;
                },
                /**
	             * Initializes a newly created object.
	             * Override this method to add some logic when your objects are created.
	             *
	             * @example
	             *
	             *     var MyType = CryptoJS.lib.Base.extend({
	             *         init: function () {
	             *             // ...
	             *         }
	             *     });
	             */ init: function() {},
                /**
	             * Copies properties into this object.
	             *
	             * @param {Object} properties The properties to mix in.
	             *
	             * @example
	             *
	             *     MyType.mixIn({
	             *         field: 'value'
	             *     });
	             */ mixIn: function(properties) {
                    for(var propertyName in properties)if (properties.hasOwnProperty(propertyName)) this[propertyName] = properties[propertyName];
                    // IE won't copy toString using the loop above
                    if (properties.hasOwnProperty("toString")) this.toString = properties.toString;
                },
                /**
	             * Creates a copy of this object.
	             *
	             * @return {Object} The clone.
	             *
	             * @example
	             *
	             *     var clone = instance.clone();
	             */ clone: function() {
                    return this.init.prototype.extend(this);
                }
            };
        }();
        /**
	     * An array of 32-bit words.
	     *
	     * @property {Array} words The array of 32-bit words.
	     * @property {number} sigBytes The number of significant bytes in this word array.
	     */ var WordArray = C_lib.WordArray = Base.extend({
            /**
	         * Initializes a newly created word array.
	         *
	         * @param {Array} words (Optional) An array of 32-bit words.
	         * @param {number} sigBytes (Optional) The number of significant bytes in the words.
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.lib.WordArray.create();
	         *     var wordArray = CryptoJS.lib.WordArray.create([0x00010203, 0x04050607]);
	         *     var wordArray = CryptoJS.lib.WordArray.create([0x00010203, 0x04050607], 6);
	         */ init: function(words, sigBytes) {
                words = this.words = words || [];
                if (sigBytes != undefined) this.sigBytes = sigBytes;
                else this.sigBytes = words.length * 4;
            },
            /**
	         * Converts this word array to a string.
	         *
	         * @param {Encoder} encoder (Optional) The encoding strategy to use. Default: CryptoJS.enc.Hex
	         *
	         * @return {string} The stringified word array.
	         *
	         * @example
	         *
	         *     var string = wordArray + '';
	         *     var string = wordArray.toString();
	         *     var string = wordArray.toString(CryptoJS.enc.Utf8);
	         */ toString: function(encoder) {
                return (encoder || Hex).stringify(this);
            },
            /**
	         * Concatenates a word array to this word array.
	         *
	         * @param {WordArray} wordArray The word array to append.
	         *
	         * @return {WordArray} This word array.
	         *
	         * @example
	         *
	         *     wordArray1.concat(wordArray2);
	         */ concat: function(wordArray) {
                // Shortcuts
                var thisWords = this.words;
                var thatWords = wordArray.words;
                var thisSigBytes = this.sigBytes;
                var thatSigBytes = wordArray.sigBytes;
                // Clamp excess bits
                this.clamp();
                // Concat
                if (thisSigBytes % 4) // Copy one byte at a time
                for(var i = 0; i < thatSigBytes; i++){
                    var thatByte = thatWords[i >>> 2] >>> 24 - i % 4 * 8 & 0xff;
                    thisWords[thisSigBytes + i >>> 2] |= thatByte << 24 - (thisSigBytes + i) % 4 * 8;
                }
                else // Copy one word at a time
                for(var j = 0; j < thatSigBytes; j += 4)thisWords[thisSigBytes + j >>> 2] = thatWords[j >>> 2];
                this.sigBytes += thatSigBytes;
                // Chainable
                return this;
            },
            /**
	         * Removes insignificant bits.
	         *
	         * @example
	         *
	         *     wordArray.clamp();
	         */ clamp: function() {
                // Shortcuts
                var words = this.words;
                var sigBytes = this.sigBytes;
                // Clamp
                words[sigBytes >>> 2] &= 0xffffffff << 32 - sigBytes % 4 * 8;
                words.length = Math1.ceil(sigBytes / 4);
            },
            /**
	         * Creates a copy of this word array.
	         *
	         * @return {WordArray} The clone.
	         *
	         * @example
	         *
	         *     var clone = wordArray.clone();
	         */ clone: function() {
                var clone = Base.clone.call(this);
                clone.words = this.words.slice(0);
                return clone;
            },
            /**
	         * Creates a word array filled with random bytes.
	         *
	         * @param {number} nBytes The number of random bytes to generate.
	         *
	         * @return {WordArray} The random word array.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.lib.WordArray.random(16);
	         */ random: function(nBytes) {
                var words = [];
                for(var i = 0; i < nBytes; i += 4)words.push(cryptoSecureRandomInt());
                return new WordArray.init(words, nBytes);
            }
        });
        /**
	     * Encoder namespace.
	     */ var C_enc = C.enc = {};
        /**
	     * Hex encoding strategy.
	     */ var Hex = C_enc.Hex = {
            /**
	         * Converts a word array to a hex string.
	         *
	         * @param {WordArray} wordArray The word array.
	         *
	         * @return {string} The hex string.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var hexString = CryptoJS.enc.Hex.stringify(wordArray);
	         */ stringify: function(wordArray) {
                // Shortcuts
                var words = wordArray.words;
                var sigBytes = wordArray.sigBytes;
                // Convert
                var hexChars = [];
                for(var i = 0; i < sigBytes; i++){
                    var bite = words[i >>> 2] >>> 24 - i % 4 * 8 & 0xff;
                    hexChars.push((bite >>> 4).toString(16));
                    hexChars.push((bite & 0x0f).toString(16));
                }
                return hexChars.join("");
            },
            /**
	         * Converts a hex string to a word array.
	         *
	         * @param {string} hexStr The hex string.
	         *
	         * @return {WordArray} The word array.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.enc.Hex.parse(hexString);
	         */ parse: function(hexStr) {
                // Shortcut
                var hexStrLength = hexStr.length;
                // Convert
                var words = [];
                for(var i = 0; i < hexStrLength; i += 2)words[i >>> 3] |= parseInt(hexStr.substr(i, 2), 16) << 24 - i % 8 * 4;
                return new WordArray.init(words, hexStrLength / 2);
            }
        };
        /**
	     * Latin1 encoding strategy.
	     */ var Latin1 = C_enc.Latin1 = {
            /**
	         * Converts a word array to a Latin1 string.
	         *
	         * @param {WordArray} wordArray The word array.
	         *
	         * @return {string} The Latin1 string.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var latin1String = CryptoJS.enc.Latin1.stringify(wordArray);
	         */ stringify: function(wordArray) {
                // Shortcuts
                var words = wordArray.words;
                var sigBytes = wordArray.sigBytes;
                // Convert
                var latin1Chars = [];
                for(var i = 0; i < sigBytes; i++){
                    var bite = words[i >>> 2] >>> 24 - i % 4 * 8 & 0xff;
                    latin1Chars.push(String.fromCharCode(bite));
                }
                return latin1Chars.join("");
            },
            /**
	         * Converts a Latin1 string to a word array.
	         *
	         * @param {string} latin1Str The Latin1 string.
	         *
	         * @return {WordArray} The word array.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.enc.Latin1.parse(latin1String);
	         */ parse: function(latin1Str) {
                // Shortcut
                var latin1StrLength = latin1Str.length;
                // Convert
                var words = [];
                for(var i = 0; i < latin1StrLength; i++)words[i >>> 2] |= (latin1Str.charCodeAt(i) & 0xff) << 24 - i % 4 * 8;
                return new WordArray.init(words, latin1StrLength);
            }
        };
        /**
	     * UTF-8 encoding strategy.
	     */ var Utf8 = C_enc.Utf8 = {
            /**
	         * Converts a word array to a UTF-8 string.
	         *
	         * @param {WordArray} wordArray The word array.
	         *
	         * @return {string} The UTF-8 string.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var utf8String = CryptoJS.enc.Utf8.stringify(wordArray);
	         */ stringify: function(wordArray) {
                try {
                    return decodeURIComponent(escape(Latin1.stringify(wordArray)));
                } catch (e) {
                    throw new Error("Malformed UTF-8 data");
                }
            },
            /**
	         * Converts a UTF-8 string to a word array.
	         *
	         * @param {string} utf8Str The UTF-8 string.
	         *
	         * @return {WordArray} The word array.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.enc.Utf8.parse(utf8String);
	         */ parse: function(utf8Str) {
                return Latin1.parse(unescape(encodeURIComponent(utf8Str)));
            }
        };
        /**
	     * Abstract buffered block algorithm template.
	     *
	     * The property blockSize must be implemented in a concrete subtype.
	     *
	     * @property {number} _minBufferSize The number of blocks that should be kept unprocessed in the buffer. Default: 0
	     */ var BufferedBlockAlgorithm = C_lib.BufferedBlockAlgorithm = Base.extend({
            /**
	         * Resets this block algorithm's data buffer to its initial state.
	         *
	         * @example
	         *
	         *     bufferedBlockAlgorithm.reset();
	         */ reset: function() {
                // Initial values
                this._data = new WordArray.init();
                this._nDataBytes = 0;
            },
            /**
	         * Adds new data to this block algorithm's buffer.
	         *
	         * @param {WordArray|string} data The data to append. Strings are converted to a WordArray using UTF-8.
	         *
	         * @example
	         *
	         *     bufferedBlockAlgorithm._append('data');
	         *     bufferedBlockAlgorithm._append(wordArray);
	         */ _append: function(data) {
                // Convert string to WordArray, else assume WordArray already
                if (typeof data == "string") data = Utf8.parse(data);
                // Append
                this._data.concat(data);
                this._nDataBytes += data.sigBytes;
            },
            /**
	         * Processes available data blocks.
	         *
	         * This method invokes _doProcessBlock(offset), which must be implemented by a concrete subtype.
	         *
	         * @param {boolean} doFlush Whether all blocks and partial blocks should be processed.
	         *
	         * @return {WordArray} The processed data.
	         *
	         * @example
	         *
	         *     var processedData = bufferedBlockAlgorithm._process();
	         *     var processedData = bufferedBlockAlgorithm._process(!!'flush');
	         */ _process: function(doFlush) {
                var processedWords;
                // Shortcuts
                var data = this._data;
                var dataWords = data.words;
                var dataSigBytes = data.sigBytes;
                var blockSize = this.blockSize;
                var blockSizeBytes = blockSize * 4;
                // Count blocks ready
                var nBlocksReady = dataSigBytes / blockSizeBytes;
                if (doFlush) // Round up to include partial blocks
                nBlocksReady = Math1.ceil(nBlocksReady);
                else // Round down to include only full blocks,
                // less the number of blocks that must remain in the buffer
                nBlocksReady = Math1.max((nBlocksReady | 0) - this._minBufferSize, 0);
                // Count words ready
                var nWordsReady = nBlocksReady * blockSize;
                // Count bytes ready
                var nBytesReady = Math1.min(nWordsReady * 4, dataSigBytes);
                // Process blocks
                if (nWordsReady) {
                    for(var offset = 0; offset < nWordsReady; offset += blockSize)// Perform concrete-algorithm logic
                    this._doProcessBlock(dataWords, offset);
                    // Remove processed words
                    processedWords = dataWords.splice(0, nWordsReady);
                    data.sigBytes -= nBytesReady;
                }
                // Return processed words
                return new WordArray.init(processedWords, nBytesReady);
            },
            /**
	         * Creates a copy of this object.
	         *
	         * @return {Object} The clone.
	         *
	         * @example
	         *
	         *     var clone = bufferedBlockAlgorithm.clone();
	         */ clone: function() {
                var clone = Base.clone.call(this);
                clone._data = this._data.clone();
                return clone;
            },
            _minBufferSize: 0
        });
        /**
	     * Abstract hasher template.
	     *
	     * @property {number} blockSize The number of 32-bit words this hasher operates on. Default: 16 (512 bits)
	     */ var Hasher = C_lib.Hasher = BufferedBlockAlgorithm.extend({
            /**
	         * Configuration options.
	         */ cfg: Base.extend(),
            /**
	         * Initializes a newly created hasher.
	         *
	         * @param {Object} cfg (Optional) The configuration options to use for this hash computation.
	         *
	         * @example
	         *
	         *     var hasher = CryptoJS.algo.SHA256.create();
	         */ init: function(cfg) {
                // Apply config defaults
                this.cfg = this.cfg.extend(cfg);
                // Set initial values
                this.reset();
            },
            /**
	         * Resets this hasher to its initial state.
	         *
	         * @example
	         *
	         *     hasher.reset();
	         */ reset: function() {
                // Reset data buffer
                BufferedBlockAlgorithm.reset.call(this);
                // Perform concrete-hasher logic
                this._doReset();
            },
            /**
	         * Updates this hasher with a message.
	         *
	         * @param {WordArray|string} messageUpdate The message to append.
	         *
	         * @return {Hasher} This hasher.
	         *
	         * @example
	         *
	         *     hasher.update('message');
	         *     hasher.update(wordArray);
	         */ update: function(messageUpdate) {
                // Append
                this._append(messageUpdate);
                // Update the hash
                this._process();
                // Chainable
                return this;
            },
            /**
	         * Finalizes the hash computation.
	         * Note that the finalize operation is effectively a destructive, read-once operation.
	         *
	         * @param {WordArray|string} messageUpdate (Optional) A final message update.
	         *
	         * @return {WordArray} The hash.
	         *
	         * @example
	         *
	         *     var hash = hasher.finalize();
	         *     var hash = hasher.finalize('message');
	         *     var hash = hasher.finalize(wordArray);
	         */ finalize: function(messageUpdate) {
                // Final message update
                if (messageUpdate) this._append(messageUpdate);
                // Perform concrete-hasher logic
                var hash = this._doFinalize();
                return hash;
            },
            blockSize: 16,
            /**
	         * Creates a shortcut function to a hasher's object interface.
	         *
	         * @param {Hasher} hasher The hasher to create a helper for.
	         *
	         * @return {Function} The shortcut function.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var SHA256 = CryptoJS.lib.Hasher._createHelper(CryptoJS.algo.SHA256);
	         */ _createHelper: function(hasher) {
                return function(message, cfg) {
                    return new hasher.init(cfg).finalize(message);
                };
            },
            /**
	         * Creates a shortcut function to the HMAC's object interface.
	         *
	         * @param {Hasher} hasher The hasher to use in this HMAC helper.
	         *
	         * @return {Function} The shortcut function.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var HmacSHA256 = CryptoJS.lib.Hasher._createHmacHelper(CryptoJS.algo.SHA256);
	         */ _createHmacHelper: function(hasher) {
                return function(message, key) {
                    return new C_algo.HMAC.init(hasher, key).finalize(message);
                };
            }
        });
        /**
	     * Algorithm namespace.
	     */ var C_algo = C.algo = {};
        return C;
    }(Math);
    return CryptoJS;
});

});

parcelRequire.register("gn80J", function(module, exports) {

(function(root, factory) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("cfaDk")));
})(this, function(CryptoJS) {
    (function(undefined) {
        // Shortcuts
        var C = CryptoJS;
        var C_lib = C.lib;
        var Base = C_lib.Base;
        var X32WordArray = C_lib.WordArray;
        /**
	     * x64 namespace.
	     */ var C_x64 = C.x64 = {};
        /**
	     * A 64-bit word.
	     */ var X64Word = C_x64.Word = Base.extend({
            /**
	         * Initializes a newly created 64-bit word.
	         *
	         * @param {number} high The high 32 bits.
	         * @param {number} low The low 32 bits.
	         *
	         * @example
	         *
	         *     var x64Word = CryptoJS.x64.Word.create(0x00010203, 0x04050607);
	         */ init: function(high, low) {
                this.high = high;
                this.low = low;
            }
        });
        /**
	     * An array of 64-bit words.
	     *
	     * @property {Array} words The array of CryptoJS.x64.Word objects.
	     * @property {number} sigBytes The number of significant bytes in this word array.
	     */ var X64WordArray = C_x64.WordArray = Base.extend({
            /**
	         * Initializes a newly created word array.
	         *
	         * @param {Array} words (Optional) An array of CryptoJS.x64.Word objects.
	         * @param {number} sigBytes (Optional) The number of significant bytes in the words.
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.x64.WordArray.create();
	         *
	         *     var wordArray = CryptoJS.x64.WordArray.create([
	         *         CryptoJS.x64.Word.create(0x00010203, 0x04050607),
	         *         CryptoJS.x64.Word.create(0x18191a1b, 0x1c1d1e1f)
	         *     ]);
	         *
	         *     var wordArray = CryptoJS.x64.WordArray.create([
	         *         CryptoJS.x64.Word.create(0x00010203, 0x04050607),
	         *         CryptoJS.x64.Word.create(0x18191a1b, 0x1c1d1e1f)
	         *     ], 10);
	         */ init: function(words, sigBytes) {
                words = this.words = words || [];
                if (sigBytes != undefined) this.sigBytes = sigBytes;
                else this.sigBytes = words.length * 8;
            },
            /**
	         * Converts this 64-bit word array to a 32-bit word array.
	         *
	         * @return {CryptoJS.lib.WordArray} This word array's data as a 32-bit word array.
	         *
	         * @example
	         *
	         *     var x32WordArray = x64WordArray.toX32();
	         */ toX32: function() {
                // Shortcuts
                var x64Words = this.words;
                var x64WordsLength = x64Words.length;
                // Convert
                var x32Words = [];
                for(var i = 0; i < x64WordsLength; i++){
                    var x64Word = x64Words[i];
                    x32Words.push(x64Word.high);
                    x32Words.push(x64Word.low);
                }
                return X32WordArray.create(x32Words, this.sigBytes);
            },
            /**
	         * Creates a copy of this word array.
	         *
	         * @return {X64WordArray} The clone.
	         *
	         * @example
	         *
	         *     var clone = x64WordArray.clone();
	         */ clone: function() {
                var clone = Base.clone.call(this);
                // Clone "words" array
                var words = clone.words = this.words.slice(0);
                // Clone each X64Word object
                var wordsLength = words.length;
                for(var i = 0; i < wordsLength; i++)words[i] = words[i].clone();
                return clone;
            }
        });
    })();
    return CryptoJS;
});

});

parcelRequire.register("9PUgX", function(module, exports) {

(function(root, factory) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("cfaDk")));
})(this, function(CryptoJS) {
    (function() {
        // Check if typed arrays are supported
        if (typeof ArrayBuffer != "function") return;
        // Shortcuts
        var C = CryptoJS;
        var C_lib = C.lib;
        var WordArray = C_lib.WordArray;
        // Reference original init
        var superInit = WordArray.init;
        // Augment WordArray.init to handle typed arrays
        var subInit = WordArray.init = function(typedArray) {
            // Convert buffers to uint8
            if (typedArray instanceof ArrayBuffer) typedArray = new Uint8Array(typedArray);
            // Convert other array views to uint8
            if (typedArray instanceof Int8Array || typeof Uint8ClampedArray !== "undefined" && typedArray instanceof Uint8ClampedArray || typedArray instanceof Int16Array || typedArray instanceof Uint16Array || typedArray instanceof Int32Array || typedArray instanceof Uint32Array || typedArray instanceof Float32Array || typedArray instanceof Float64Array) typedArray = new Uint8Array(typedArray.buffer, typedArray.byteOffset, typedArray.byteLength);
            // Handle Uint8Array
            if (typedArray instanceof Uint8Array) {
                // Shortcut
                var typedArrayByteLength = typedArray.byteLength;
                // Extract bytes
                var words = [];
                for(var i = 0; i < typedArrayByteLength; i++)words[i >>> 2] |= typedArray[i] << 24 - i % 4 * 8;
                // Initialize this word array
                superInit.call(this, words, typedArrayByteLength);
            } else // Else call normal init
            superInit.apply(this, arguments);
        };
        subInit.prototype = WordArray;
    })();
    return CryptoJS.lib.WordArray;
});

});

parcelRequire.register("gu0dW", function(module, exports) {

(function(root, factory) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("cfaDk")));
})(this, function(CryptoJS) {
    (function() {
        // Shortcuts
        var C = CryptoJS;
        var C_lib = C.lib;
        var WordArray = C_lib.WordArray;
        var C_enc = C.enc;
        /**
	     * UTF-16 BE encoding strategy.
	     */ var Utf16BE = C_enc.Utf16 = C_enc.Utf16BE = {
            /**
	         * Converts a word array to a UTF-16 BE string.
	         *
	         * @param {WordArray} wordArray The word array.
	         *
	         * @return {string} The UTF-16 BE string.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var utf16String = CryptoJS.enc.Utf16.stringify(wordArray);
	         */ stringify: function(wordArray) {
                // Shortcuts
                var words = wordArray.words;
                var sigBytes = wordArray.sigBytes;
                // Convert
                var utf16Chars = [];
                for(var i = 0; i < sigBytes; i += 2){
                    var codePoint = words[i >>> 2] >>> 16 - i % 4 * 8 & 0xffff;
                    utf16Chars.push(String.fromCharCode(codePoint));
                }
                return utf16Chars.join("");
            },
            /**
	         * Converts a UTF-16 BE string to a word array.
	         *
	         * @param {string} utf16Str The UTF-16 BE string.
	         *
	         * @return {WordArray} The word array.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.enc.Utf16.parse(utf16String);
	         */ parse: function(utf16Str) {
                // Shortcut
                var utf16StrLength = utf16Str.length;
                // Convert
                var words = [];
                for(var i = 0; i < utf16StrLength; i++)words[i >>> 1] |= utf16Str.charCodeAt(i) << 16 - i % 2 * 16;
                return WordArray.create(words, utf16StrLength * 2);
            }
        };
        /**
	     * UTF-16 LE encoding strategy.
	     */ C_enc.Utf16LE = {
            /**
	         * Converts a word array to a UTF-16 LE string.
	         *
	         * @param {WordArray} wordArray The word array.
	         *
	         * @return {string} The UTF-16 LE string.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var utf16Str = CryptoJS.enc.Utf16LE.stringify(wordArray);
	         */ stringify: function(wordArray) {
                // Shortcuts
                var words = wordArray.words;
                var sigBytes = wordArray.sigBytes;
                // Convert
                var utf16Chars = [];
                for(var i = 0; i < sigBytes; i += 2){
                    var codePoint = swapEndian(words[i >>> 2] >>> 16 - i % 4 * 8 & 0xffff);
                    utf16Chars.push(String.fromCharCode(codePoint));
                }
                return utf16Chars.join("");
            },
            /**
	         * Converts a UTF-16 LE string to a word array.
	         *
	         * @param {string} utf16Str The UTF-16 LE string.
	         *
	         * @return {WordArray} The word array.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.enc.Utf16LE.parse(utf16Str);
	         */ parse: function(utf16Str) {
                // Shortcut
                var utf16StrLength = utf16Str.length;
                // Convert
                var words = [];
                for(var i = 0; i < utf16StrLength; i++)words[i >>> 1] |= swapEndian(utf16Str.charCodeAt(i) << 16 - i % 2 * 16);
                return WordArray.create(words, utf16StrLength * 2);
            }
        };
        function swapEndian(word) {
            return word << 8 & 0xff00ff00 | word >>> 8 & 0x00ff00ff;
        }
    })();
    return CryptoJS.enc.Utf16;
});

});

parcelRequire.register("500SS", function(module, exports) {

(function(root, factory) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("cfaDk")));
})(this, function(CryptoJS) {
    (function() {
        // Shortcuts
        var C = CryptoJS;
        var C_lib = C.lib;
        var WordArray = C_lib.WordArray;
        var C_enc = C.enc;
        /**
	     * Base64 encoding strategy.
	     */ var Base64 = C_enc.Base64 = {
            /**
	         * Converts a word array to a Base64 string.
	         *
	         * @param {WordArray} wordArray The word array.
	         *
	         * @return {string} The Base64 string.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var base64String = CryptoJS.enc.Base64.stringify(wordArray);
	         */ stringify: function(wordArray) {
                // Shortcuts
                var words = wordArray.words;
                var sigBytes = wordArray.sigBytes;
                var map = this._map;
                // Clamp excess bits
                wordArray.clamp();
                // Convert
                var base64Chars = [];
                for(var i = 0; i < sigBytes; i += 3){
                    var byte1 = words[i >>> 2] >>> 24 - i % 4 * 8 & 0xff;
                    var byte2 = words[i + 1 >>> 2] >>> 24 - (i + 1) % 4 * 8 & 0xff;
                    var byte3 = words[i + 2 >>> 2] >>> 24 - (i + 2) % 4 * 8 & 0xff;
                    var triplet = byte1 << 16 | byte2 << 8 | byte3;
                    for(var j = 0; j < 4 && i + j * 0.75 < sigBytes; j++)base64Chars.push(map.charAt(triplet >>> 6 * (3 - j) & 0x3f));
                }
                // Add padding
                var paddingChar = map.charAt(64);
                if (paddingChar) while(base64Chars.length % 4)base64Chars.push(paddingChar);
                return base64Chars.join("");
            },
            /**
	         * Converts a Base64 string to a word array.
	         *
	         * @param {string} base64Str The Base64 string.
	         *
	         * @return {WordArray} The word array.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.enc.Base64.parse(base64String);
	         */ parse: function(base64Str) {
                // Shortcuts
                var base64StrLength = base64Str.length;
                var map = this._map;
                var reverseMap = this._reverseMap;
                if (!reverseMap) {
                    reverseMap = this._reverseMap = [];
                    for(var j = 0; j < map.length; j++)reverseMap[map.charCodeAt(j)] = j;
                }
                // Ignore padding
                var paddingChar = map.charAt(64);
                if (paddingChar) {
                    var paddingIndex = base64Str.indexOf(paddingChar);
                    if (paddingIndex !== -1) base64StrLength = paddingIndex;
                }
                // Convert
                return parseLoop(base64Str, base64StrLength, reverseMap);
            },
            _map: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/="
        };
        function parseLoop(base64Str, base64StrLength, reverseMap) {
            var words = [];
            var nBytes = 0;
            for(var i = 0; i < base64StrLength; i++)if (i % 4) {
                var bits1 = reverseMap[base64Str.charCodeAt(i - 1)] << i % 4 * 2;
                var bits2 = reverseMap[base64Str.charCodeAt(i)] >>> 6 - i % 4 * 2;
                var bitsCombined = bits1 | bits2;
                words[nBytes >>> 2] |= bitsCombined << 24 - nBytes % 4 * 8;
                nBytes++;
            }
            return WordArray.create(words, nBytes);
        }
    })();
    return CryptoJS.enc.Base64;
});

});

parcelRequire.register("8aX4Y", function(module, exports) {

(function(root, factory) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("cfaDk")));
})(this, function(CryptoJS) {
    (function() {
        // Shortcuts
        var C = CryptoJS;
        var C_lib = C.lib;
        var WordArray = C_lib.WordArray;
        var C_enc = C.enc;
        /**
	     * Base64url encoding strategy.
	     */ var Base64url = C_enc.Base64url = {
            /**
	         * Converts a word array to a Base64url string.
	         *
	         * @param {WordArray} wordArray The word array.
	         *
	         * @param {boolean} urlSafe Whether to use url safe
	         *
	         * @return {string} The Base64url string.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var base64String = CryptoJS.enc.Base64url.stringify(wordArray);
	         */ stringify: function(wordArray, urlSafe) {
                if (urlSafe === undefined) urlSafe = true;
                // Shortcuts
                var words = wordArray.words;
                var sigBytes = wordArray.sigBytes;
                var map = urlSafe ? this._safe_map : this._map;
                // Clamp excess bits
                wordArray.clamp();
                // Convert
                var base64Chars = [];
                for(var i = 0; i < sigBytes; i += 3){
                    var byte1 = words[i >>> 2] >>> 24 - i % 4 * 8 & 0xff;
                    var byte2 = words[i + 1 >>> 2] >>> 24 - (i + 1) % 4 * 8 & 0xff;
                    var byte3 = words[i + 2 >>> 2] >>> 24 - (i + 2) % 4 * 8 & 0xff;
                    var triplet = byte1 << 16 | byte2 << 8 | byte3;
                    for(var j = 0; j < 4 && i + j * 0.75 < sigBytes; j++)base64Chars.push(map.charAt(triplet >>> 6 * (3 - j) & 0x3f));
                }
                // Add padding
                var paddingChar = map.charAt(64);
                if (paddingChar) while(base64Chars.length % 4)base64Chars.push(paddingChar);
                return base64Chars.join("");
            },
            /**
	         * Converts a Base64url string to a word array.
	         *
	         * @param {string} base64Str The Base64url string.
	         *
	         * @param {boolean} urlSafe Whether to use url safe
	         *
	         * @return {WordArray} The word array.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.enc.Base64url.parse(base64String);
	         */ parse: function(base64Str, urlSafe) {
                if (urlSafe === undefined) urlSafe = true;
                // Shortcuts
                var base64StrLength = base64Str.length;
                var map = urlSafe ? this._safe_map : this._map;
                var reverseMap = this._reverseMap;
                if (!reverseMap) {
                    reverseMap = this._reverseMap = [];
                    for(var j = 0; j < map.length; j++)reverseMap[map.charCodeAt(j)] = j;
                }
                // Ignore padding
                var paddingChar = map.charAt(64);
                if (paddingChar) {
                    var paddingIndex = base64Str.indexOf(paddingChar);
                    if (paddingIndex !== -1) base64StrLength = paddingIndex;
                }
                // Convert
                return parseLoop(base64Str, base64StrLength, reverseMap);
            },
            _map: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=",
            _safe_map: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-_"
        };
        function parseLoop(base64Str, base64StrLength, reverseMap) {
            var words = [];
            var nBytes = 0;
            for(var i = 0; i < base64StrLength; i++)if (i % 4) {
                var bits1 = reverseMap[base64Str.charCodeAt(i - 1)] << i % 4 * 2;
                var bits2 = reverseMap[base64Str.charCodeAt(i)] >>> 6 - i % 4 * 2;
                var bitsCombined = bits1 | bits2;
                words[nBytes >>> 2] |= bitsCombined << 24 - nBytes % 4 * 8;
                nBytes++;
            }
            return WordArray.create(words, nBytes);
        }
    })();
    return CryptoJS.enc.Base64url;
});

});

parcelRequire.register("6oXxt", function(module, exports) {

(function(root, factory) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("cfaDk")));
})(this, function(CryptoJS) {
    (function(Math1) {
        // Shortcuts
        var C = CryptoJS;
        var C_lib = C.lib;
        var WordArray = C_lib.WordArray;
        var Hasher = C_lib.Hasher;
        var C_algo = C.algo;
        // Constants table
        var T = [];
        // Compute constants
        (function() {
            for(var i = 0; i < 64; i++)T[i] = Math1.abs(Math1.sin(i + 1)) * 0x100000000 | 0;
        })();
        /**
	     * MD5 hash algorithm.
	     */ var MD5 = C_algo.MD5 = Hasher.extend({
            _doReset: function() {
                this._hash = new WordArray.init([
                    0x67452301,
                    0xefcdab89,
                    0x98badcfe,
                    0x10325476
                ]);
            },
            _doProcessBlock: function(M, offset) {
                // Swap endian
                for(var i = 0; i < 16; i++){
                    // Shortcuts
                    var offset_i = offset + i;
                    var M_offset_i = M[offset_i];
                    M[offset_i] = (M_offset_i << 8 | M_offset_i >>> 24) & 0x00ff00ff | (M_offset_i << 24 | M_offset_i >>> 8) & 0xff00ff00;
                }
                // Shortcuts
                var H = this._hash.words;
                var M_offset_0 = M[offset + 0];
                var M_offset_1 = M[offset + 1];
                var M_offset_2 = M[offset + 2];
                var M_offset_3 = M[offset + 3];
                var M_offset_4 = M[offset + 4];
                var M_offset_5 = M[offset + 5];
                var M_offset_6 = M[offset + 6];
                var M_offset_7 = M[offset + 7];
                var M_offset_8 = M[offset + 8];
                var M_offset_9 = M[offset + 9];
                var M_offset_10 = M[offset + 10];
                var M_offset_11 = M[offset + 11];
                var M_offset_12 = M[offset + 12];
                var M_offset_13 = M[offset + 13];
                var M_offset_14 = M[offset + 14];
                var M_offset_15 = M[offset + 15];
                // Working variables
                var a = H[0];
                var b = H[1];
                var c = H[2];
                var d = H[3];
                // Computation
                a = FF(a, b, c, d, M_offset_0, 7, T[0]);
                d = FF(d, a, b, c, M_offset_1, 12, T[1]);
                c = FF(c, d, a, b, M_offset_2, 17, T[2]);
                b = FF(b, c, d, a, M_offset_3, 22, T[3]);
                a = FF(a, b, c, d, M_offset_4, 7, T[4]);
                d = FF(d, a, b, c, M_offset_5, 12, T[5]);
                c = FF(c, d, a, b, M_offset_6, 17, T[6]);
                b = FF(b, c, d, a, M_offset_7, 22, T[7]);
                a = FF(a, b, c, d, M_offset_8, 7, T[8]);
                d = FF(d, a, b, c, M_offset_9, 12, T[9]);
                c = FF(c, d, a, b, M_offset_10, 17, T[10]);
                b = FF(b, c, d, a, M_offset_11, 22, T[11]);
                a = FF(a, b, c, d, M_offset_12, 7, T[12]);
                d = FF(d, a, b, c, M_offset_13, 12, T[13]);
                c = FF(c, d, a, b, M_offset_14, 17, T[14]);
                b = FF(b, c, d, a, M_offset_15, 22, T[15]);
                a = GG(a, b, c, d, M_offset_1, 5, T[16]);
                d = GG(d, a, b, c, M_offset_6, 9, T[17]);
                c = GG(c, d, a, b, M_offset_11, 14, T[18]);
                b = GG(b, c, d, a, M_offset_0, 20, T[19]);
                a = GG(a, b, c, d, M_offset_5, 5, T[20]);
                d = GG(d, a, b, c, M_offset_10, 9, T[21]);
                c = GG(c, d, a, b, M_offset_15, 14, T[22]);
                b = GG(b, c, d, a, M_offset_4, 20, T[23]);
                a = GG(a, b, c, d, M_offset_9, 5, T[24]);
                d = GG(d, a, b, c, M_offset_14, 9, T[25]);
                c = GG(c, d, a, b, M_offset_3, 14, T[26]);
                b = GG(b, c, d, a, M_offset_8, 20, T[27]);
                a = GG(a, b, c, d, M_offset_13, 5, T[28]);
                d = GG(d, a, b, c, M_offset_2, 9, T[29]);
                c = GG(c, d, a, b, M_offset_7, 14, T[30]);
                b = GG(b, c, d, a, M_offset_12, 20, T[31]);
                a = HH(a, b, c, d, M_offset_5, 4, T[32]);
                d = HH(d, a, b, c, M_offset_8, 11, T[33]);
                c = HH(c, d, a, b, M_offset_11, 16, T[34]);
                b = HH(b, c, d, a, M_offset_14, 23, T[35]);
                a = HH(a, b, c, d, M_offset_1, 4, T[36]);
                d = HH(d, a, b, c, M_offset_4, 11, T[37]);
                c = HH(c, d, a, b, M_offset_7, 16, T[38]);
                b = HH(b, c, d, a, M_offset_10, 23, T[39]);
                a = HH(a, b, c, d, M_offset_13, 4, T[40]);
                d = HH(d, a, b, c, M_offset_0, 11, T[41]);
                c = HH(c, d, a, b, M_offset_3, 16, T[42]);
                b = HH(b, c, d, a, M_offset_6, 23, T[43]);
                a = HH(a, b, c, d, M_offset_9, 4, T[44]);
                d = HH(d, a, b, c, M_offset_12, 11, T[45]);
                c = HH(c, d, a, b, M_offset_15, 16, T[46]);
                b = HH(b, c, d, a, M_offset_2, 23, T[47]);
                a = II(a, b, c, d, M_offset_0, 6, T[48]);
                d = II(d, a, b, c, M_offset_7, 10, T[49]);
                c = II(c, d, a, b, M_offset_14, 15, T[50]);
                b = II(b, c, d, a, M_offset_5, 21, T[51]);
                a = II(a, b, c, d, M_offset_12, 6, T[52]);
                d = II(d, a, b, c, M_offset_3, 10, T[53]);
                c = II(c, d, a, b, M_offset_10, 15, T[54]);
                b = II(b, c, d, a, M_offset_1, 21, T[55]);
                a = II(a, b, c, d, M_offset_8, 6, T[56]);
                d = II(d, a, b, c, M_offset_15, 10, T[57]);
                c = II(c, d, a, b, M_offset_6, 15, T[58]);
                b = II(b, c, d, a, M_offset_13, 21, T[59]);
                a = II(a, b, c, d, M_offset_4, 6, T[60]);
                d = II(d, a, b, c, M_offset_11, 10, T[61]);
                c = II(c, d, a, b, M_offset_2, 15, T[62]);
                b = II(b, c, d, a, M_offset_9, 21, T[63]);
                // Intermediate hash value
                H[0] = H[0] + a | 0;
                H[1] = H[1] + b | 0;
                H[2] = H[2] + c | 0;
                H[3] = H[3] + d | 0;
            },
            _doFinalize: function() {
                // Shortcuts
                var data = this._data;
                var dataWords = data.words;
                var nBitsTotal = this._nDataBytes * 8;
                var nBitsLeft = data.sigBytes * 8;
                // Add padding
                dataWords[nBitsLeft >>> 5] |= 0x80 << 24 - nBitsLeft % 32;
                var nBitsTotalH = Math1.floor(nBitsTotal / 0x100000000);
                var nBitsTotalL = nBitsTotal;
                dataWords[(nBitsLeft + 64 >>> 9 << 4) + 15] = (nBitsTotalH << 8 | nBitsTotalH >>> 24) & 0x00ff00ff | (nBitsTotalH << 24 | nBitsTotalH >>> 8) & 0xff00ff00;
                dataWords[(nBitsLeft + 64 >>> 9 << 4) + 14] = (nBitsTotalL << 8 | nBitsTotalL >>> 24) & 0x00ff00ff | (nBitsTotalL << 24 | nBitsTotalL >>> 8) & 0xff00ff00;
                data.sigBytes = (dataWords.length + 1) * 4;
                // Hash final blocks
                this._process();
                // Shortcuts
                var hash = this._hash;
                var H = hash.words;
                // Swap endian
                for(var i = 0; i < 4; i++){
                    // Shortcut
                    var H_i = H[i];
                    H[i] = (H_i << 8 | H_i >>> 24) & 0x00ff00ff | (H_i << 24 | H_i >>> 8) & 0xff00ff00;
                }
                // Return final computed hash
                return hash;
            },
            clone: function() {
                var clone = Hasher.clone.call(this);
                clone._hash = this._hash.clone();
                return clone;
            }
        });
        function FF(a, b, c, d, x, s, t) {
            var n = a + (b & c | ~b & d) + x + t;
            return (n << s | n >>> 32 - s) + b;
        }
        function GG(a, b, c, d, x, s, t) {
            var n = a + (b & d | c & ~d) + x + t;
            return (n << s | n >>> 32 - s) + b;
        }
        function HH(a, b, c, d, x, s, t) {
            var n = a + (b ^ c ^ d) + x + t;
            return (n << s | n >>> 32 - s) + b;
        }
        function II(a, b, c, d, x, s, t) {
            var n = a + (c ^ (b | ~d)) + x + t;
            return (n << s | n >>> 32 - s) + b;
        }
        /**
	     * Shortcut function to the hasher's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     *
	     * @return {WordArray} The hash.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hash = CryptoJS.MD5('message');
	     *     var hash = CryptoJS.MD5(wordArray);
	     */ C.MD5 = Hasher._createHelper(MD5);
        /**
	     * Shortcut function to the HMAC's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     * @param {WordArray|string} key The secret key.
	     *
	     * @return {WordArray} The HMAC.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hmac = CryptoJS.HmacMD5(message, key);
	     */ C.HmacMD5 = Hasher._createHmacHelper(MD5);
    })(Math);
    return CryptoJS.MD5;
});

});

parcelRequire.register("lqaMD", function(module, exports) {

(function(root, factory) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("cfaDk")));
})(this, function(CryptoJS) {
    (function() {
        // Shortcuts
        var C = CryptoJS;
        var C_lib = C.lib;
        var WordArray = C_lib.WordArray;
        var Hasher = C_lib.Hasher;
        var C_algo = C.algo;
        // Reusable object
        var W = [];
        /**
	     * SHA-1 hash algorithm.
	     */ var SHA1 = C_algo.SHA1 = Hasher.extend({
            _doReset: function() {
                this._hash = new WordArray.init([
                    0x67452301,
                    0xefcdab89,
                    0x98badcfe,
                    0x10325476,
                    0xc3d2e1f0
                ]);
            },
            _doProcessBlock: function(M, offset) {
                // Shortcut
                var H = this._hash.words;
                // Working variables
                var a = H[0];
                var b = H[1];
                var c = H[2];
                var d = H[3];
                var e = H[4];
                // Computation
                for(var i = 0; i < 80; i++){
                    if (i < 16) W[i] = M[offset + i] | 0;
                    else {
                        var n = W[i - 3] ^ W[i - 8] ^ W[i - 14] ^ W[i - 16];
                        W[i] = n << 1 | n >>> 31;
                    }
                    var t = (a << 5 | a >>> 27) + e + W[i];
                    if (i < 20) t += (b & c | ~b & d) + 0x5a827999;
                    else if (i < 40) t += (b ^ c ^ d) + 0x6ed9eba1;
                    else if (i < 60) t += (b & c | b & d | c & d) - 0x70e44324;
                    else t += (b ^ c ^ d) - 0x359d3e2a;
                    e = d;
                    d = c;
                    c = b << 30 | b >>> 2;
                    b = a;
                    a = t;
                }
                // Intermediate hash value
                H[0] = H[0] + a | 0;
                H[1] = H[1] + b | 0;
                H[2] = H[2] + c | 0;
                H[3] = H[3] + d | 0;
                H[4] = H[4] + e | 0;
            },
            _doFinalize: function() {
                // Shortcuts
                var data = this._data;
                var dataWords = data.words;
                var nBitsTotal = this._nDataBytes * 8;
                var nBitsLeft = data.sigBytes * 8;
                // Add padding
                dataWords[nBitsLeft >>> 5] |= 0x80 << 24 - nBitsLeft % 32;
                dataWords[(nBitsLeft + 64 >>> 9 << 4) + 14] = Math.floor(nBitsTotal / 0x100000000);
                dataWords[(nBitsLeft + 64 >>> 9 << 4) + 15] = nBitsTotal;
                data.sigBytes = dataWords.length * 4;
                // Hash final blocks
                this._process();
                // Return final computed hash
                return this._hash;
            },
            clone: function() {
                var clone = Hasher.clone.call(this);
                clone._hash = this._hash.clone();
                return clone;
            }
        });
        /**
	     * Shortcut function to the hasher's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     *
	     * @return {WordArray} The hash.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hash = CryptoJS.SHA1('message');
	     *     var hash = CryptoJS.SHA1(wordArray);
	     */ C.SHA1 = Hasher._createHelper(SHA1);
        /**
	     * Shortcut function to the HMAC's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     * @param {WordArray|string} key The secret key.
	     *
	     * @return {WordArray} The HMAC.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hmac = CryptoJS.HmacSHA1(message, key);
	     */ C.HmacSHA1 = Hasher._createHmacHelper(SHA1);
    })();
    return CryptoJS.SHA1;
});

});

parcelRequire.register("hNROW", function(module, exports) {

(function(root, factory) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("cfaDk")));
})(this, function(CryptoJS) {
    (function(Math1) {
        // Shortcuts
        var C = CryptoJS;
        var C_lib = C.lib;
        var WordArray = C_lib.WordArray;
        var Hasher = C_lib.Hasher;
        var C_algo = C.algo;
        // Initialization and round constants tables
        var H = [];
        var K = [];
        // Compute constants
        (function() {
            function isPrime(n) {
                var sqrtN = Math1.sqrt(n);
                for(var factor = 2; factor <= sqrtN; factor++){
                    if (!(n % factor)) return false;
                }
                return true;
            }
            function getFractionalBits(n) {
                return (n - (n | 0)) * 0x100000000 | 0;
            }
            var n = 2;
            var nPrime = 0;
            while(nPrime < 64){
                if (isPrime(n)) {
                    if (nPrime < 8) H[nPrime] = getFractionalBits(Math1.pow(n, 0.5));
                    K[nPrime] = getFractionalBits(Math1.pow(n, 1 / 3));
                    nPrime++;
                }
                n++;
            }
        })();
        // Reusable object
        var W = [];
        /**
	     * SHA-256 hash algorithm.
	     */ var SHA256 = C_algo.SHA256 = Hasher.extend({
            _doReset: function() {
                this._hash = new WordArray.init(H.slice(0));
            },
            _doProcessBlock: function(M, offset) {
                // Shortcut
                var H = this._hash.words;
                // Working variables
                var a = H[0];
                var b = H[1];
                var c = H[2];
                var d = H[3];
                var e = H[4];
                var f = H[5];
                var g = H[6];
                var h = H[7];
                // Computation
                for(var i = 0; i < 64; i++){
                    if (i < 16) W[i] = M[offset + i] | 0;
                    else {
                        var gamma0x = W[i - 15];
                        var gamma0 = (gamma0x << 25 | gamma0x >>> 7) ^ (gamma0x << 14 | gamma0x >>> 18) ^ gamma0x >>> 3;
                        var gamma1x = W[i - 2];
                        var gamma1 = (gamma1x << 15 | gamma1x >>> 17) ^ (gamma1x << 13 | gamma1x >>> 19) ^ gamma1x >>> 10;
                        W[i] = gamma0 + W[i - 7] + gamma1 + W[i - 16];
                    }
                    var ch = e & f ^ ~e & g;
                    var maj = a & b ^ a & c ^ b & c;
                    var sigma0 = (a << 30 | a >>> 2) ^ (a << 19 | a >>> 13) ^ (a << 10 | a >>> 22);
                    var sigma1 = (e << 26 | e >>> 6) ^ (e << 21 | e >>> 11) ^ (e << 7 | e >>> 25);
                    var t1 = h + sigma1 + ch + K[i] + W[i];
                    var t2 = sigma0 + maj;
                    h = g;
                    g = f;
                    f = e;
                    e = d + t1 | 0;
                    d = c;
                    c = b;
                    b = a;
                    a = t1 + t2 | 0;
                }
                // Intermediate hash value
                H[0] = H[0] + a | 0;
                H[1] = H[1] + b | 0;
                H[2] = H[2] + c | 0;
                H[3] = H[3] + d | 0;
                H[4] = H[4] + e | 0;
                H[5] = H[5] + f | 0;
                H[6] = H[6] + g | 0;
                H[7] = H[7] + h | 0;
            },
            _doFinalize: function() {
                // Shortcuts
                var data = this._data;
                var dataWords = data.words;
                var nBitsTotal = this._nDataBytes * 8;
                var nBitsLeft = data.sigBytes * 8;
                // Add padding
                dataWords[nBitsLeft >>> 5] |= 0x80 << 24 - nBitsLeft % 32;
                dataWords[(nBitsLeft + 64 >>> 9 << 4) + 14] = Math1.floor(nBitsTotal / 0x100000000);
                dataWords[(nBitsLeft + 64 >>> 9 << 4) + 15] = nBitsTotal;
                data.sigBytes = dataWords.length * 4;
                // Hash final blocks
                this._process();
                // Return final computed hash
                return this._hash;
            },
            clone: function() {
                var clone = Hasher.clone.call(this);
                clone._hash = this._hash.clone();
                return clone;
            }
        });
        /**
	     * Shortcut function to the hasher's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     *
	     * @return {WordArray} The hash.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hash = CryptoJS.SHA256('message');
	     *     var hash = CryptoJS.SHA256(wordArray);
	     */ C.SHA256 = Hasher._createHelper(SHA256);
        /**
	     * Shortcut function to the HMAC's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     * @param {WordArray|string} key The secret key.
	     *
	     * @return {WordArray} The HMAC.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hmac = CryptoJS.HmacSHA256(message, key);
	     */ C.HmacSHA256 = Hasher._createHmacHelper(SHA256);
    })(Math);
    return CryptoJS.SHA256;
});

});

parcelRequire.register("kgfdC", function(module, exports) {


(function(root, factory, undef) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("cfaDk")), (parcelRequire("hNROW")));
})(this, function(CryptoJS) {
    (function() {
        // Shortcuts
        var C = CryptoJS;
        var C_lib = C.lib;
        var WordArray = C_lib.WordArray;
        var C_algo = C.algo;
        var SHA256 = C_algo.SHA256;
        /**
	     * SHA-224 hash algorithm.
	     */ var SHA224 = C_algo.SHA224 = SHA256.extend({
            _doReset: function() {
                this._hash = new WordArray.init([
                    0xc1059ed8,
                    0x367cd507,
                    0x3070dd17,
                    0xf70e5939,
                    0xffc00b31,
                    0x68581511,
                    0x64f98fa7,
                    0xbefa4fa4
                ]);
            },
            _doFinalize: function() {
                var hash = SHA256._doFinalize.call(this);
                hash.sigBytes -= 4;
                return hash;
            }
        });
        /**
	     * Shortcut function to the hasher's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     *
	     * @return {WordArray} The hash.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hash = CryptoJS.SHA224('message');
	     *     var hash = CryptoJS.SHA224(wordArray);
	     */ C.SHA224 = SHA256._createHelper(SHA224);
        /**
	     * Shortcut function to the HMAC's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     * @param {WordArray|string} key The secret key.
	     *
	     * @return {WordArray} The HMAC.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hmac = CryptoJS.HmacSHA224(message, key);
	     */ C.HmacSHA224 = SHA256._createHmacHelper(SHA224);
    })();
    return CryptoJS.SHA224;
});

});

parcelRequire.register("6PaKQ", function(module, exports) {


(function(root, factory, undef) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("cfaDk")), (parcelRequire("gn80J")));
})(this, function(CryptoJS) {
    (function() {
        // Shortcuts
        var C = CryptoJS;
        var C_lib = C.lib;
        var Hasher = C_lib.Hasher;
        var C_x64 = C.x64;
        var X64Word = C_x64.Word;
        var X64WordArray = C_x64.WordArray;
        var C_algo = C.algo;
        function X64Word_create() {
            return X64Word.create.apply(X64Word, arguments);
        }
        // Constants
        var K = [
            X64Word_create(0x428a2f98, 0xd728ae22),
            X64Word_create(0x71374491, 0x23ef65cd),
            X64Word_create(0xb5c0fbcf, 0xec4d3b2f),
            X64Word_create(0xe9b5dba5, 0x8189dbbc),
            X64Word_create(0x3956c25b, 0xf348b538),
            X64Word_create(0x59f111f1, 0xb605d019),
            X64Word_create(0x923f82a4, 0xaf194f9b),
            X64Word_create(0xab1c5ed5, 0xda6d8118),
            X64Word_create(0xd807aa98, 0xa3030242),
            X64Word_create(0x12835b01, 0x45706fbe),
            X64Word_create(0x243185be, 0x4ee4b28c),
            X64Word_create(0x550c7dc3, 0xd5ffb4e2),
            X64Word_create(0x72be5d74, 0xf27b896f),
            X64Word_create(0x80deb1fe, 0x3b1696b1),
            X64Word_create(0x9bdc06a7, 0x25c71235),
            X64Word_create(0xc19bf174, 0xcf692694),
            X64Word_create(0xe49b69c1, 0x9ef14ad2),
            X64Word_create(0xefbe4786, 0x384f25e3),
            X64Word_create(0x0fc19dc6, 0x8b8cd5b5),
            X64Word_create(0x240ca1cc, 0x77ac9c65),
            X64Word_create(0x2de92c6f, 0x592b0275),
            X64Word_create(0x4a7484aa, 0x6ea6e483),
            X64Word_create(0x5cb0a9dc, 0xbd41fbd4),
            X64Word_create(0x76f988da, 0x831153b5),
            X64Word_create(0x983e5152, 0xee66dfab),
            X64Word_create(0xa831c66d, 0x2db43210),
            X64Word_create(0xb00327c8, 0x98fb213f),
            X64Word_create(0xbf597fc7, 0xbeef0ee4),
            X64Word_create(0xc6e00bf3, 0x3da88fc2),
            X64Word_create(0xd5a79147, 0x930aa725),
            X64Word_create(0x06ca6351, 0xe003826f),
            X64Word_create(0x14292967, 0x0a0e6e70),
            X64Word_create(0x27b70a85, 0x46d22ffc),
            X64Word_create(0x2e1b2138, 0x5c26c926),
            X64Word_create(0x4d2c6dfc, 0x5ac42aed),
            X64Word_create(0x53380d13, 0x9d95b3df),
            X64Word_create(0x650a7354, 0x8baf63de),
            X64Word_create(0x766a0abb, 0x3c77b2a8),
            X64Word_create(0x81c2c92e, 0x47edaee6),
            X64Word_create(0x92722c85, 0x1482353b),
            X64Word_create(0xa2bfe8a1, 0x4cf10364),
            X64Word_create(0xa81a664b, 0xbc423001),
            X64Word_create(0xc24b8b70, 0xd0f89791),
            X64Word_create(0xc76c51a3, 0x0654be30),
            X64Word_create(0xd192e819, 0xd6ef5218),
            X64Word_create(0xd6990624, 0x5565a910),
            X64Word_create(0xf40e3585, 0x5771202a),
            X64Word_create(0x106aa070, 0x32bbd1b8),
            X64Word_create(0x19a4c116, 0xb8d2d0c8),
            X64Word_create(0x1e376c08, 0x5141ab53),
            X64Word_create(0x2748774c, 0xdf8eeb99),
            X64Word_create(0x34b0bcb5, 0xe19b48a8),
            X64Word_create(0x391c0cb3, 0xc5c95a63),
            X64Word_create(0x4ed8aa4a, 0xe3418acb),
            X64Word_create(0x5b9cca4f, 0x7763e373),
            X64Word_create(0x682e6ff3, 0xd6b2b8a3),
            X64Word_create(0x748f82ee, 0x5defb2fc),
            X64Word_create(0x78a5636f, 0x43172f60),
            X64Word_create(0x84c87814, 0xa1f0ab72),
            X64Word_create(0x8cc70208, 0x1a6439ec),
            X64Word_create(0x90befffa, 0x23631e28),
            X64Word_create(0xa4506ceb, 0xde82bde9),
            X64Word_create(0xbef9a3f7, 0xb2c67915),
            X64Word_create(0xc67178f2, 0xe372532b),
            X64Word_create(0xca273ece, 0xea26619c),
            X64Word_create(0xd186b8c7, 0x21c0c207),
            X64Word_create(0xeada7dd6, 0xcde0eb1e),
            X64Word_create(0xf57d4f7f, 0xee6ed178),
            X64Word_create(0x06f067aa, 0x72176fba),
            X64Word_create(0x0a637dc5, 0xa2c898a6),
            X64Word_create(0x113f9804, 0xbef90dae),
            X64Word_create(0x1b710b35, 0x131c471b),
            X64Word_create(0x28db77f5, 0x23047d84),
            X64Word_create(0x32caab7b, 0x40c72493),
            X64Word_create(0x3c9ebe0a, 0x15c9bebc),
            X64Word_create(0x431d67c4, 0x9c100d4c),
            X64Word_create(0x4cc5d4be, 0xcb3e42b6),
            X64Word_create(0x597f299c, 0xfc657e2a),
            X64Word_create(0x5fcb6fab, 0x3ad6faec),
            X64Word_create(0x6c44198c, 0x4a475817)
        ];
        // Reusable objects
        var W = [];
        (function() {
            for(var i = 0; i < 80; i++)W[i] = X64Word_create();
        })();
        /**
	     * SHA-512 hash algorithm.
	     */ var SHA512 = C_algo.SHA512 = Hasher.extend({
            _doReset: function() {
                this._hash = new X64WordArray.init([
                    new X64Word.init(0x6a09e667, 0xf3bcc908),
                    new X64Word.init(0xbb67ae85, 0x84caa73b),
                    new X64Word.init(0x3c6ef372, 0xfe94f82b),
                    new X64Word.init(0xa54ff53a, 0x5f1d36f1),
                    new X64Word.init(0x510e527f, 0xade682d1),
                    new X64Word.init(0x9b05688c, 0x2b3e6c1f),
                    new X64Word.init(0x1f83d9ab, 0xfb41bd6b),
                    new X64Word.init(0x5be0cd19, 0x137e2179)
                ]);
            },
            _doProcessBlock: function(M, offset) {
                // Shortcuts
                var H = this._hash.words;
                var H0 = H[0];
                var H1 = H[1];
                var H2 = H[2];
                var H3 = H[3];
                var H4 = H[4];
                var H5 = H[5];
                var H6 = H[6];
                var H7 = H[7];
                var H0h = H0.high;
                var H0l = H0.low;
                var H1h = H1.high;
                var H1l = H1.low;
                var H2h = H2.high;
                var H2l = H2.low;
                var H3h = H3.high;
                var H3l = H3.low;
                var H4h = H4.high;
                var H4l = H4.low;
                var H5h = H5.high;
                var H5l = H5.low;
                var H6h = H6.high;
                var H6l = H6.low;
                var H7h = H7.high;
                var H7l = H7.low;
                // Working variables
                var ah = H0h;
                var al = H0l;
                var bh = H1h;
                var bl = H1l;
                var ch = H2h;
                var cl = H2l;
                var dh = H3h;
                var dl = H3l;
                var eh = H4h;
                var el = H4l;
                var fh = H5h;
                var fl = H5l;
                var gh = H6h;
                var gl = H6l;
                var hh = H7h;
                var hl = H7l;
                // Rounds
                for(var i = 0; i < 80; i++){
                    var Wil;
                    var Wih;
                    // Shortcut
                    var Wi = W[i];
                    // Extend message
                    if (i < 16) {
                        Wih = Wi.high = M[offset + i * 2] | 0;
                        Wil = Wi.low = M[offset + i * 2 + 1] | 0;
                    } else {
                        // Gamma0
                        var gamma0x = W[i - 15];
                        var gamma0xh = gamma0x.high;
                        var gamma0xl = gamma0x.low;
                        var gamma0h = (gamma0xh >>> 1 | gamma0xl << 31) ^ (gamma0xh >>> 8 | gamma0xl << 24) ^ gamma0xh >>> 7;
                        var gamma0l = (gamma0xl >>> 1 | gamma0xh << 31) ^ (gamma0xl >>> 8 | gamma0xh << 24) ^ (gamma0xl >>> 7 | gamma0xh << 25);
                        // Gamma1
                        var gamma1x = W[i - 2];
                        var gamma1xh = gamma1x.high;
                        var gamma1xl = gamma1x.low;
                        var gamma1h = (gamma1xh >>> 19 | gamma1xl << 13) ^ (gamma1xh << 3 | gamma1xl >>> 29) ^ gamma1xh >>> 6;
                        var gamma1l = (gamma1xl >>> 19 | gamma1xh << 13) ^ (gamma1xl << 3 | gamma1xh >>> 29) ^ (gamma1xl >>> 6 | gamma1xh << 26);
                        // W[i] = gamma0 + W[i - 7] + gamma1 + W[i - 16]
                        var Wi7 = W[i - 7];
                        var Wi7h = Wi7.high;
                        var Wi7l = Wi7.low;
                        var Wi16 = W[i - 16];
                        var Wi16h = Wi16.high;
                        var Wi16l = Wi16.low;
                        Wil = gamma0l + Wi7l;
                        Wih = gamma0h + Wi7h + (Wil >>> 0 < gamma0l >>> 0 ? 1 : 0);
                        Wil = Wil + gamma1l;
                        Wih = Wih + gamma1h + (Wil >>> 0 < gamma1l >>> 0 ? 1 : 0);
                        Wil = Wil + Wi16l;
                        Wih = Wih + Wi16h + (Wil >>> 0 < Wi16l >>> 0 ? 1 : 0);
                        Wi.high = Wih;
                        Wi.low = Wil;
                    }
                    var chh = eh & fh ^ ~eh & gh;
                    var chl = el & fl ^ ~el & gl;
                    var majh = ah & bh ^ ah & ch ^ bh & ch;
                    var majl = al & bl ^ al & cl ^ bl & cl;
                    var sigma0h = (ah >>> 28 | al << 4) ^ (ah << 30 | al >>> 2) ^ (ah << 25 | al >>> 7);
                    var sigma0l = (al >>> 28 | ah << 4) ^ (al << 30 | ah >>> 2) ^ (al << 25 | ah >>> 7);
                    var sigma1h = (eh >>> 14 | el << 18) ^ (eh >>> 18 | el << 14) ^ (eh << 23 | el >>> 9);
                    var sigma1l = (el >>> 14 | eh << 18) ^ (el >>> 18 | eh << 14) ^ (el << 23 | eh >>> 9);
                    // t1 = h + sigma1 + ch + K[i] + W[i]
                    var Ki = K[i];
                    var Kih = Ki.high;
                    var Kil = Ki.low;
                    var t1l = hl + sigma1l;
                    var t1h = hh + sigma1h + (t1l >>> 0 < hl >>> 0 ? 1 : 0);
                    var t1l = t1l + chl;
                    var t1h = t1h + chh + (t1l >>> 0 < chl >>> 0 ? 1 : 0);
                    var t1l = t1l + Kil;
                    var t1h = t1h + Kih + (t1l >>> 0 < Kil >>> 0 ? 1 : 0);
                    var t1l = t1l + Wil;
                    var t1h = t1h + Wih + (t1l >>> 0 < Wil >>> 0 ? 1 : 0);
                    // t2 = sigma0 + maj
                    var t2l = sigma0l + majl;
                    var t2h = sigma0h + majh + (t2l >>> 0 < sigma0l >>> 0 ? 1 : 0);
                    // Update working variables
                    hh = gh;
                    hl = gl;
                    gh = fh;
                    gl = fl;
                    fh = eh;
                    fl = el;
                    el = dl + t1l | 0;
                    eh = dh + t1h + (el >>> 0 < dl >>> 0 ? 1 : 0) | 0;
                    dh = ch;
                    dl = cl;
                    ch = bh;
                    cl = bl;
                    bh = ah;
                    bl = al;
                    al = t1l + t2l | 0;
                    ah = t1h + t2h + (al >>> 0 < t1l >>> 0 ? 1 : 0) | 0;
                }
                // Intermediate hash value
                H0l = H0.low = H0l + al;
                H0.high = H0h + ah + (H0l >>> 0 < al >>> 0 ? 1 : 0);
                H1l = H1.low = H1l + bl;
                H1.high = H1h + bh + (H1l >>> 0 < bl >>> 0 ? 1 : 0);
                H2l = H2.low = H2l + cl;
                H2.high = H2h + ch + (H2l >>> 0 < cl >>> 0 ? 1 : 0);
                H3l = H3.low = H3l + dl;
                H3.high = H3h + dh + (H3l >>> 0 < dl >>> 0 ? 1 : 0);
                H4l = H4.low = H4l + el;
                H4.high = H4h + eh + (H4l >>> 0 < el >>> 0 ? 1 : 0);
                H5l = H5.low = H5l + fl;
                H5.high = H5h + fh + (H5l >>> 0 < fl >>> 0 ? 1 : 0);
                H6l = H6.low = H6l + gl;
                H6.high = H6h + gh + (H6l >>> 0 < gl >>> 0 ? 1 : 0);
                H7l = H7.low = H7l + hl;
                H7.high = H7h + hh + (H7l >>> 0 < hl >>> 0 ? 1 : 0);
            },
            _doFinalize: function() {
                // Shortcuts
                var data = this._data;
                var dataWords = data.words;
                var nBitsTotal = this._nDataBytes * 8;
                var nBitsLeft = data.sigBytes * 8;
                // Add padding
                dataWords[nBitsLeft >>> 5] |= 0x80 << 24 - nBitsLeft % 32;
                dataWords[(nBitsLeft + 128 >>> 10 << 5) + 30] = Math.floor(nBitsTotal / 0x100000000);
                dataWords[(nBitsLeft + 128 >>> 10 << 5) + 31] = nBitsTotal;
                data.sigBytes = dataWords.length * 4;
                // Hash final blocks
                this._process();
                // Convert hash to 32-bit word array before returning
                var hash = this._hash.toX32();
                // Return final computed hash
                return hash;
            },
            clone: function() {
                var clone = Hasher.clone.call(this);
                clone._hash = this._hash.clone();
                return clone;
            },
            blockSize: 32
        });
        /**
	     * Shortcut function to the hasher's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     *
	     * @return {WordArray} The hash.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hash = CryptoJS.SHA512('message');
	     *     var hash = CryptoJS.SHA512(wordArray);
	     */ C.SHA512 = Hasher._createHelper(SHA512);
        /**
	     * Shortcut function to the HMAC's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     * @param {WordArray|string} key The secret key.
	     *
	     * @return {WordArray} The HMAC.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hmac = CryptoJS.HmacSHA512(message, key);
	     */ C.HmacSHA512 = Hasher._createHmacHelper(SHA512);
    })();
    return CryptoJS.SHA512;
});

});

parcelRequire.register("bZEkw", function(module, exports) {



(function(root, factory, undef) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("cfaDk")), (parcelRequire("gn80J")), (parcelRequire("6PaKQ")));
})(this, function(CryptoJS) {
    (function() {
        // Shortcuts
        var C = CryptoJS;
        var C_x64 = C.x64;
        var X64Word = C_x64.Word;
        var X64WordArray = C_x64.WordArray;
        var C_algo = C.algo;
        var SHA512 = C_algo.SHA512;
        /**
	     * SHA-384 hash algorithm.
	     */ var SHA384 = C_algo.SHA384 = SHA512.extend({
            _doReset: function() {
                this._hash = new X64WordArray.init([
                    new X64Word.init(0xcbbb9d5d, 0xc1059ed8),
                    new X64Word.init(0x629a292a, 0x367cd507),
                    new X64Word.init(0x9159015a, 0x3070dd17),
                    new X64Word.init(0x152fecd8, 0xf70e5939),
                    new X64Word.init(0x67332667, 0xffc00b31),
                    new X64Word.init(0x8eb44a87, 0x68581511),
                    new X64Word.init(0xdb0c2e0d, 0x64f98fa7),
                    new X64Word.init(0x47b5481d, 0xbefa4fa4)
                ]);
            },
            _doFinalize: function() {
                var hash = SHA512._doFinalize.call(this);
                hash.sigBytes -= 16;
                return hash;
            }
        });
        /**
	     * Shortcut function to the hasher's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     *
	     * @return {WordArray} The hash.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hash = CryptoJS.SHA384('message');
	     *     var hash = CryptoJS.SHA384(wordArray);
	     */ C.SHA384 = SHA512._createHelper(SHA384);
        /**
	     * Shortcut function to the HMAC's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     * @param {WordArray|string} key The secret key.
	     *
	     * @return {WordArray} The HMAC.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hmac = CryptoJS.HmacSHA384(message, key);
	     */ C.HmacSHA384 = SHA512._createHmacHelper(SHA384);
    })();
    return CryptoJS.SHA384;
});

});

parcelRequire.register("AFosI", function(module, exports) {


(function(root, factory, undef) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("cfaDk")), (parcelRequire("gn80J")));
})(this, function(CryptoJS) {
    (function(Math1) {
        // Shortcuts
        var C = CryptoJS;
        var C_lib = C.lib;
        var WordArray = C_lib.WordArray;
        var Hasher = C_lib.Hasher;
        var C_x64 = C.x64;
        var X64Word = C_x64.Word;
        var C_algo = C.algo;
        // Constants tables
        var RHO_OFFSETS = [];
        var PI_INDEXES = [];
        var ROUND_CONSTANTS = [];
        // Compute Constants
        (function() {
            // Compute rho offset constants
            var x = 1, y = 0;
            for(var t = 0; t < 24; t++){
                RHO_OFFSETS[x + 5 * y] = (t + 1) * (t + 2) / 2 % 64;
                var newX = y % 5;
                var newY = (2 * x + 3 * y) % 5;
                x = newX;
                y = newY;
            }
            // Compute pi index constants
            for(var x = 0; x < 5; x++)for(var y = 0; y < 5; y++)PI_INDEXES[x + 5 * y] = y + (2 * x + 3 * y) % 5 * 5;
            // Compute round constants
            var LFSR = 0x01;
            for(var i = 0; i < 24; i++){
                var roundConstantMsw = 0;
                var roundConstantLsw = 0;
                for(var j = 0; j < 7; j++){
                    if (LFSR & 0x01) {
                        var bitPosition = (1 << j) - 1;
                        if (bitPosition < 32) roundConstantLsw ^= 1 << bitPosition;
                        else roundConstantMsw ^= 1 << bitPosition - 32;
                    }
                    // Compute next LFSR
                    if (LFSR & 0x80) // Primitive polynomial over GF(2): x^8 + x^6 + x^5 + x^4 + 1
                    LFSR = LFSR << 1 ^ 0x71;
                    else LFSR <<= 1;
                }
                ROUND_CONSTANTS[i] = X64Word.create(roundConstantMsw, roundConstantLsw);
            }
        })();
        // Reusable objects for temporary values
        var T = [];
        (function() {
            for(var i = 0; i < 25; i++)T[i] = X64Word.create();
        })();
        /**
	     * SHA-3 hash algorithm.
	     */ var SHA3 = C_algo.SHA3 = Hasher.extend({
            /**
	         * Configuration options.
	         *
	         * @property {number} outputLength
	         *   The desired number of bits in the output hash.
	         *   Only values permitted are: 224, 256, 384, 512.
	         *   Default: 512
	         */ cfg: Hasher.cfg.extend({
                outputLength: 512
            }),
            _doReset: function() {
                var state = this._state = [];
                for(var i = 0; i < 25; i++)state[i] = new X64Word.init();
                this.blockSize = (1600 - 2 * this.cfg.outputLength) / 32;
            },
            _doProcessBlock: function(M, offset) {
                // Shortcuts
                var state = this._state;
                var nBlockSizeLanes = this.blockSize / 2;
                // Absorb
                for(var i = 0; i < nBlockSizeLanes; i++){
                    // Shortcuts
                    var M2i = M[offset + 2 * i];
                    var M2i1 = M[offset + 2 * i + 1];
                    // Swap endian
                    M2i = (M2i << 8 | M2i >>> 24) & 0x00ff00ff | (M2i << 24 | M2i >>> 8) & 0xff00ff00;
                    M2i1 = (M2i1 << 8 | M2i1 >>> 24) & 0x00ff00ff | (M2i1 << 24 | M2i1 >>> 8) & 0xff00ff00;
                    // Absorb message into state
                    var lane = state[i];
                    lane.high ^= M2i1;
                    lane.low ^= M2i;
                }
                // Rounds
                for(var round = 0; round < 24; round++){
                    // Theta
                    for(var x = 0; x < 5; x++){
                        // Mix column lanes
                        var tMsw = 0, tLsw = 0;
                        for(var y = 0; y < 5; y++){
                            var lane = state[x + 5 * y];
                            tMsw ^= lane.high;
                            tLsw ^= lane.low;
                        }
                        // Temporary values
                        var Tx = T[x];
                        Tx.high = tMsw;
                        Tx.low = tLsw;
                    }
                    for(var x = 0; x < 5; x++){
                        // Shortcuts
                        var Tx4 = T[(x + 4) % 5];
                        var Tx1 = T[(x + 1) % 5];
                        var Tx1Msw = Tx1.high;
                        var Tx1Lsw = Tx1.low;
                        // Mix surrounding columns
                        var tMsw = Tx4.high ^ (Tx1Msw << 1 | Tx1Lsw >>> 31);
                        var tLsw = Tx4.low ^ (Tx1Lsw << 1 | Tx1Msw >>> 31);
                        for(var y = 0; y < 5; y++){
                            var lane = state[x + 5 * y];
                            lane.high ^= tMsw;
                            lane.low ^= tLsw;
                        }
                    }
                    // Rho Pi
                    for(var laneIndex = 1; laneIndex < 25; laneIndex++){
                        var tMsw;
                        var tLsw;
                        // Shortcuts
                        var lane = state[laneIndex];
                        var laneMsw = lane.high;
                        var laneLsw = lane.low;
                        var rhoOffset = RHO_OFFSETS[laneIndex];
                        // Rotate lanes
                        if (rhoOffset < 32) {
                            tMsw = laneMsw << rhoOffset | laneLsw >>> 32 - rhoOffset;
                            tLsw = laneLsw << rhoOffset | laneMsw >>> 32 - rhoOffset;
                        } else /* if (rhoOffset >= 32) */ {
                            tMsw = laneLsw << rhoOffset - 32 | laneMsw >>> 64 - rhoOffset;
                            tLsw = laneMsw << rhoOffset - 32 | laneLsw >>> 64 - rhoOffset;
                        }
                        // Transpose lanes
                        var TPiLane = T[PI_INDEXES[laneIndex]];
                        TPiLane.high = tMsw;
                        TPiLane.low = tLsw;
                    }
                    // Rho pi at x = y = 0
                    var T0 = T[0];
                    var state0 = state[0];
                    T0.high = state0.high;
                    T0.low = state0.low;
                    // Chi
                    for(var x = 0; x < 5; x++)for(var y = 0; y < 5; y++){
                        // Shortcuts
                        var laneIndex = x + 5 * y;
                        var lane = state[laneIndex];
                        var TLane = T[laneIndex];
                        var Tx1Lane = T[(x + 1) % 5 + 5 * y];
                        var Tx2Lane = T[(x + 2) % 5 + 5 * y];
                        // Mix rows
                        lane.high = TLane.high ^ ~Tx1Lane.high & Tx2Lane.high;
                        lane.low = TLane.low ^ ~Tx1Lane.low & Tx2Lane.low;
                    }
                    // Iota
                    var lane = state[0];
                    var roundConstant = ROUND_CONSTANTS[round];
                    lane.high ^= roundConstant.high;
                    lane.low ^= roundConstant.low;
                }
            },
            _doFinalize: function() {
                // Shortcuts
                var data = this._data;
                var dataWords = data.words;
                var nBitsTotal = this._nDataBytes * 8;
                var nBitsLeft = data.sigBytes * 8;
                var blockSizeBits = this.blockSize * 32;
                // Add padding
                dataWords[nBitsLeft >>> 5] |= 0x1 << 24 - nBitsLeft % 32;
                dataWords[(Math1.ceil((nBitsLeft + 1) / blockSizeBits) * blockSizeBits >>> 5) - 1] |= 0x80;
                data.sigBytes = dataWords.length * 4;
                // Hash final blocks
                this._process();
                // Shortcuts
                var state = this._state;
                var outputLengthBytes = this.cfg.outputLength / 8;
                var outputLengthLanes = outputLengthBytes / 8;
                // Squeeze
                var hashWords = [];
                for(var i = 0; i < outputLengthLanes; i++){
                    // Shortcuts
                    var lane = state[i];
                    var laneMsw = lane.high;
                    var laneLsw = lane.low;
                    // Swap endian
                    laneMsw = (laneMsw << 8 | laneMsw >>> 24) & 0x00ff00ff | (laneMsw << 24 | laneMsw >>> 8) & 0xff00ff00;
                    laneLsw = (laneLsw << 8 | laneLsw >>> 24) & 0x00ff00ff | (laneLsw << 24 | laneLsw >>> 8) & 0xff00ff00;
                    // Squeeze state to retrieve hash
                    hashWords.push(laneLsw);
                    hashWords.push(laneMsw);
                }
                // Return final computed hash
                return new WordArray.init(hashWords, outputLengthBytes);
            },
            clone: function() {
                var clone = Hasher.clone.call(this);
                var state = clone._state = this._state.slice(0);
                for(var i = 0; i < 25; i++)state[i] = state[i].clone();
                return clone;
            }
        });
        /**
	     * Shortcut function to the hasher's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     *
	     * @return {WordArray} The hash.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hash = CryptoJS.SHA3('message');
	     *     var hash = CryptoJS.SHA3(wordArray);
	     */ C.SHA3 = Hasher._createHelper(SHA3);
        /**
	     * Shortcut function to the HMAC's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     * @param {WordArray|string} key The secret key.
	     *
	     * @return {WordArray} The HMAC.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hmac = CryptoJS.HmacSHA3(message, key);
	     */ C.HmacSHA3 = Hasher._createHmacHelper(SHA3);
    })(Math);
    return CryptoJS.SHA3;
});

});

parcelRequire.register("bIitx", function(module, exports) {

(function(root, factory) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("cfaDk")));
})(this, function(CryptoJS) {
    /** @preserve
	(c) 2012 by Cédric Mesnil. All rights reserved.

	Redistribution and use in source and binary forms, with or without modification, are permitted provided that the following conditions are met:

	    - Redistributions of source code must retain the above copyright notice, this list of conditions and the following disclaimer.
	    - Redistributions in binary form must reproduce the above copyright notice, this list of conditions and the following disclaimer in the documentation and/or other materials provided with the distribution.

	THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
	*/ (function(Math1) {
        // Shortcuts
        var C = CryptoJS;
        var C_lib = C.lib;
        var WordArray = C_lib.WordArray;
        var Hasher = C_lib.Hasher;
        var C_algo = C.algo;
        // Constants table
        var _zl = WordArray.create([
            0,
            1,
            2,
            3,
            4,
            5,
            6,
            7,
            8,
            9,
            10,
            11,
            12,
            13,
            14,
            15,
            7,
            4,
            13,
            1,
            10,
            6,
            15,
            3,
            12,
            0,
            9,
            5,
            2,
            14,
            11,
            8,
            3,
            10,
            14,
            4,
            9,
            15,
            8,
            1,
            2,
            7,
            0,
            6,
            13,
            11,
            5,
            12,
            1,
            9,
            11,
            10,
            0,
            8,
            12,
            4,
            13,
            3,
            7,
            15,
            14,
            5,
            6,
            2,
            4,
            0,
            5,
            9,
            7,
            12,
            2,
            10,
            14,
            1,
            3,
            8,
            11,
            6,
            15,
            13
        ]);
        var _zr = WordArray.create([
            5,
            14,
            7,
            0,
            9,
            2,
            11,
            4,
            13,
            6,
            15,
            8,
            1,
            10,
            3,
            12,
            6,
            11,
            3,
            7,
            0,
            13,
            5,
            10,
            14,
            15,
            8,
            12,
            4,
            9,
            1,
            2,
            15,
            5,
            1,
            3,
            7,
            14,
            6,
            9,
            11,
            8,
            12,
            2,
            10,
            0,
            4,
            13,
            8,
            6,
            4,
            1,
            3,
            11,
            15,
            0,
            5,
            12,
            2,
            13,
            9,
            7,
            10,
            14,
            12,
            15,
            10,
            4,
            1,
            5,
            8,
            7,
            6,
            2,
            13,
            14,
            0,
            3,
            9,
            11
        ]);
        var _sl = WordArray.create([
            11,
            14,
            15,
            12,
            5,
            8,
            7,
            9,
            11,
            13,
            14,
            15,
            6,
            7,
            9,
            8,
            7,
            6,
            8,
            13,
            11,
            9,
            7,
            15,
            7,
            12,
            15,
            9,
            11,
            7,
            13,
            12,
            11,
            13,
            6,
            7,
            14,
            9,
            13,
            15,
            14,
            8,
            13,
            6,
            5,
            12,
            7,
            5,
            11,
            12,
            14,
            15,
            14,
            15,
            9,
            8,
            9,
            14,
            5,
            6,
            8,
            6,
            5,
            12,
            9,
            15,
            5,
            11,
            6,
            8,
            13,
            12,
            5,
            12,
            13,
            14,
            11,
            8,
            5,
            6
        ]);
        var _sr = WordArray.create([
            8,
            9,
            9,
            11,
            13,
            15,
            15,
            5,
            7,
            7,
            8,
            11,
            14,
            14,
            12,
            6,
            9,
            13,
            15,
            7,
            12,
            8,
            9,
            11,
            7,
            7,
            12,
            7,
            6,
            15,
            13,
            11,
            9,
            7,
            15,
            11,
            8,
            6,
            6,
            14,
            12,
            13,
            5,
            14,
            13,
            13,
            7,
            5,
            15,
            5,
            8,
            11,
            14,
            14,
            6,
            14,
            6,
            9,
            12,
            9,
            12,
            5,
            15,
            8,
            8,
            5,
            12,
            9,
            12,
            5,
            14,
            6,
            8,
            13,
            6,
            5,
            15,
            13,
            11,
            11
        ]);
        var _hl = WordArray.create([
            0x00000000,
            0x5A827999,
            0x6ED9EBA1,
            0x8F1BBCDC,
            0xA953FD4E
        ]);
        var _hr = WordArray.create([
            0x50A28BE6,
            0x5C4DD124,
            0x6D703EF3,
            0x7A6D76E9,
            0x00000000
        ]);
        /**
	     * RIPEMD160 hash algorithm.
	     */ var RIPEMD160 = C_algo.RIPEMD160 = Hasher.extend({
            _doReset: function() {
                this._hash = WordArray.create([
                    0x67452301,
                    0xEFCDAB89,
                    0x98BADCFE,
                    0x10325476,
                    0xC3D2E1F0
                ]);
            },
            _doProcessBlock: function(M, offset) {
                // Swap endian
                for(var i = 0; i < 16; i++){
                    // Shortcuts
                    var offset_i = offset + i;
                    var M_offset_i = M[offset_i];
                    // Swap
                    M[offset_i] = (M_offset_i << 8 | M_offset_i >>> 24) & 0x00ff00ff | (M_offset_i << 24 | M_offset_i >>> 8) & 0xff00ff00;
                }
                // Shortcut
                var H = this._hash.words;
                var hl = _hl.words;
                var hr = _hr.words;
                var zl = _zl.words;
                var zr = _zr.words;
                var sl = _sl.words;
                var sr = _sr.words;
                // Working variables
                var al, bl, cl, dl, el;
                var ar, br, cr, dr, er;
                ar = al = H[0];
                br = bl = H[1];
                cr = cl = H[2];
                dr = dl = H[3];
                er = el = H[4];
                // Computation
                var t;
                for(var i = 0; i < 80; i += 1){
                    t = al + M[offset + zl[i]] | 0;
                    if (i < 16) t += f1(bl, cl, dl) + hl[0];
                    else if (i < 32) t += f2(bl, cl, dl) + hl[1];
                    else if (i < 48) t += f3(bl, cl, dl) + hl[2];
                    else if (i < 64) t += f4(bl, cl, dl) + hl[3];
                    else t += f5(bl, cl, dl) + hl[4];
                    t = t | 0;
                    t = rotl(t, sl[i]);
                    t = t + el | 0;
                    al = el;
                    el = dl;
                    dl = rotl(cl, 10);
                    cl = bl;
                    bl = t;
                    t = ar + M[offset + zr[i]] | 0;
                    if (i < 16) t += f5(br, cr, dr) + hr[0];
                    else if (i < 32) t += f4(br, cr, dr) + hr[1];
                    else if (i < 48) t += f3(br, cr, dr) + hr[2];
                    else if (i < 64) t += f2(br, cr, dr) + hr[3];
                    else t += f1(br, cr, dr) + hr[4];
                    t = t | 0;
                    t = rotl(t, sr[i]);
                    t = t + er | 0;
                    ar = er;
                    er = dr;
                    dr = rotl(cr, 10);
                    cr = br;
                    br = t;
                }
                // Intermediate hash value
                t = H[1] + cl + dr | 0;
                H[1] = H[2] + dl + er | 0;
                H[2] = H[3] + el + ar | 0;
                H[3] = H[4] + al + br | 0;
                H[4] = H[0] + bl + cr | 0;
                H[0] = t;
            },
            _doFinalize: function() {
                // Shortcuts
                var data = this._data;
                var dataWords = data.words;
                var nBitsTotal = this._nDataBytes * 8;
                var nBitsLeft = data.sigBytes * 8;
                // Add padding
                dataWords[nBitsLeft >>> 5] |= 0x80 << 24 - nBitsLeft % 32;
                dataWords[(nBitsLeft + 64 >>> 9 << 4) + 14] = (nBitsTotal << 8 | nBitsTotal >>> 24) & 0x00ff00ff | (nBitsTotal << 24 | nBitsTotal >>> 8) & 0xff00ff00;
                data.sigBytes = (dataWords.length + 1) * 4;
                // Hash final blocks
                this._process();
                // Shortcuts
                var hash = this._hash;
                var H = hash.words;
                // Swap endian
                for(var i = 0; i < 5; i++){
                    // Shortcut
                    var H_i = H[i];
                    // Swap
                    H[i] = (H_i << 8 | H_i >>> 24) & 0x00ff00ff | (H_i << 24 | H_i >>> 8) & 0xff00ff00;
                }
                // Return final computed hash
                return hash;
            },
            clone: function() {
                var clone = Hasher.clone.call(this);
                clone._hash = this._hash.clone();
                return clone;
            }
        });
        function f1(x, y, z) {
            return x ^ y ^ z;
        }
        function f2(x, y, z) {
            return x & y | ~x & z;
        }
        function f3(x, y, z) {
            return (x | ~y) ^ z;
        }
        function f4(x, y, z) {
            return x & z | y & ~z;
        }
        function f5(x, y, z) {
            return x ^ (y | ~z);
        }
        function rotl(x, n) {
            return x << n | x >>> 32 - n;
        }
        /**
	     * Shortcut function to the hasher's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     *
	     * @return {WordArray} The hash.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hash = CryptoJS.RIPEMD160('message');
	     *     var hash = CryptoJS.RIPEMD160(wordArray);
	     */ C.RIPEMD160 = Hasher._createHelper(RIPEMD160);
        /**
	     * Shortcut function to the HMAC's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     * @param {WordArray|string} key The secret key.
	     *
	     * @return {WordArray} The HMAC.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hmac = CryptoJS.HmacRIPEMD160(message, key);
	     */ C.HmacRIPEMD160 = Hasher._createHmacHelper(RIPEMD160);
    })(Math);
    return CryptoJS.RIPEMD160;
});

});

parcelRequire.register("7ft6W", function(module, exports) {

(function(root, factory) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("cfaDk")));
})(this, function(CryptoJS) {
    (function() {
        // Shortcuts
        var C = CryptoJS;
        var C_lib = C.lib;
        var Base = C_lib.Base;
        var C_enc = C.enc;
        var Utf8 = C_enc.Utf8;
        var C_algo = C.algo;
        /**
	     * HMAC algorithm.
	     */ var HMAC = C_algo.HMAC = Base.extend({
            /**
	         * Initializes a newly created HMAC.
	         *
	         * @param {Hasher} hasher The hash algorithm to use.
	         * @param {WordArray|string} key The secret key.
	         *
	         * @example
	         *
	         *     var hmacHasher = CryptoJS.algo.HMAC.create(CryptoJS.algo.SHA256, key);
	         */ init: function(hasher, key) {
                // Init hasher
                hasher = this._hasher = new hasher.init();
                // Convert string to WordArray, else assume WordArray already
                if (typeof key == "string") key = Utf8.parse(key);
                // Shortcuts
                var hasherBlockSize = hasher.blockSize;
                var hasherBlockSizeBytes = hasherBlockSize * 4;
                // Allow arbitrary length keys
                if (key.sigBytes > hasherBlockSizeBytes) key = hasher.finalize(key);
                // Clamp excess bits
                key.clamp();
                // Clone key for inner and outer pads
                var oKey = this._oKey = key.clone();
                var iKey = this._iKey = key.clone();
                // Shortcuts
                var oKeyWords = oKey.words;
                var iKeyWords = iKey.words;
                // XOR keys with pad constants
                for(var i = 0; i < hasherBlockSize; i++){
                    oKeyWords[i] ^= 0x5c5c5c5c;
                    iKeyWords[i] ^= 0x36363636;
                }
                oKey.sigBytes = iKey.sigBytes = hasherBlockSizeBytes;
                // Set initial values
                this.reset();
            },
            /**
	         * Resets this HMAC to its initial state.
	         *
	         * @example
	         *
	         *     hmacHasher.reset();
	         */ reset: function() {
                // Shortcut
                var hasher = this._hasher;
                // Reset
                hasher.reset();
                hasher.update(this._iKey);
            },
            /**
	         * Updates this HMAC with a message.
	         *
	         * @param {WordArray|string} messageUpdate The message to append.
	         *
	         * @return {HMAC} This HMAC instance.
	         *
	         * @example
	         *
	         *     hmacHasher.update('message');
	         *     hmacHasher.update(wordArray);
	         */ update: function(messageUpdate) {
                this._hasher.update(messageUpdate);
                // Chainable
                return this;
            },
            /**
	         * Finalizes the HMAC computation.
	         * Note that the finalize operation is effectively a destructive, read-once operation.
	         *
	         * @param {WordArray|string} messageUpdate (Optional) A final message update.
	         *
	         * @return {WordArray} The HMAC.
	         *
	         * @example
	         *
	         *     var hmac = hmacHasher.finalize();
	         *     var hmac = hmacHasher.finalize('message');
	         *     var hmac = hmacHasher.finalize(wordArray);
	         */ finalize: function(messageUpdate) {
                // Shortcut
                var hasher = this._hasher;
                // Compute HMAC
                var innerHash = hasher.finalize(messageUpdate);
                hasher.reset();
                var hmac = hasher.finalize(this._oKey.clone().concat(innerHash));
                return hmac;
            }
        });
    })();
});

});

parcelRequire.register("as0jN", function(module, exports) {



(function(root, factory, undef) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("cfaDk")), (parcelRequire("hNROW")), (parcelRequire("7ft6W")));
})(this, function(CryptoJS) {
    (function() {
        // Shortcuts
        var C = CryptoJS;
        var C_lib = C.lib;
        var Base = C_lib.Base;
        var WordArray = C_lib.WordArray;
        var C_algo = C.algo;
        var SHA256 = C_algo.SHA256;
        var HMAC = C_algo.HMAC;
        /**
	     * Password-Based Key Derivation Function 2 algorithm.
	     */ var PBKDF2 = C_algo.PBKDF2 = Base.extend({
            /**
	         * Configuration options.
	         *
	         * @property {number} keySize The key size in words to generate. Default: 4 (128 bits)
	         * @property {Hasher} hasher The hasher to use. Default: SHA256
	         * @property {number} iterations The number of iterations to perform. Default: 250000
	         */ cfg: Base.extend({
                keySize: 4,
                hasher: SHA256,
                iterations: 250000
            }),
            /**
	         * Initializes a newly created key derivation function.
	         *
	         * @param {Object} cfg (Optional) The configuration options to use for the derivation.
	         *
	         * @example
	         *
	         *     var kdf = CryptoJS.algo.PBKDF2.create();
	         *     var kdf = CryptoJS.algo.PBKDF2.create({ keySize: 8 });
	         *     var kdf = CryptoJS.algo.PBKDF2.create({ keySize: 8, iterations: 1000 });
	         */ init: function(cfg) {
                this.cfg = this.cfg.extend(cfg);
            },
            /**
	         * Computes the Password-Based Key Derivation Function 2.
	         *
	         * @param {WordArray|string} password The password.
	         * @param {WordArray|string} salt A salt.
	         *
	         * @return {WordArray} The derived key.
	         *
	         * @example
	         *
	         *     var key = kdf.compute(password, salt);
	         */ compute: function(password, salt) {
                // Shortcut
                var cfg = this.cfg;
                // Init HMAC
                var hmac = HMAC.create(cfg.hasher, password);
                // Initial values
                var derivedKey = WordArray.create();
                var blockIndex = WordArray.create([
                    0x00000001
                ]);
                // Shortcuts
                var derivedKeyWords = derivedKey.words;
                var blockIndexWords = blockIndex.words;
                var keySize = cfg.keySize;
                var iterations = cfg.iterations;
                // Generate key
                while(derivedKeyWords.length < keySize){
                    var block = hmac.update(salt).finalize(blockIndex);
                    hmac.reset();
                    // Shortcuts
                    var blockWords = block.words;
                    var blockWordsLength = blockWords.length;
                    // Iterations
                    var intermediate = block;
                    for(var i = 1; i < iterations; i++){
                        intermediate = hmac.finalize(intermediate);
                        hmac.reset();
                        // Shortcut
                        var intermediateWords = intermediate.words;
                        // XOR intermediate with block
                        for(var j = 0; j < blockWordsLength; j++)blockWords[j] ^= intermediateWords[j];
                    }
                    derivedKey.concat(block);
                    blockIndexWords[0]++;
                }
                derivedKey.sigBytes = keySize * 4;
                return derivedKey;
            }
        });
        /**
	     * Computes the Password-Based Key Derivation Function 2.
	     *
	     * @param {WordArray|string} password The password.
	     * @param {WordArray|string} salt A salt.
	     * @param {Object} cfg (Optional) The configuration options to use for this computation.
	     *
	     * @return {WordArray} The derived key.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var key = CryptoJS.PBKDF2(password, salt);
	     *     var key = CryptoJS.PBKDF2(password, salt, { keySize: 8 });
	     *     var key = CryptoJS.PBKDF2(password, salt, { keySize: 8, iterations: 1000 });
	     */ C.PBKDF2 = function(password, salt, cfg) {
            return PBKDF2.create(cfg).compute(password, salt);
        };
    })();
    return CryptoJS.PBKDF2;
});

});

parcelRequire.register("ioEPr", function(module, exports) {



(function(root, factory, undef) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("cfaDk")), (parcelRequire("lqaMD")), (parcelRequire("7ft6W")));
})(this, function(CryptoJS) {
    (function() {
        // Shortcuts
        var C = CryptoJS;
        var C_lib = C.lib;
        var Base = C_lib.Base;
        var WordArray = C_lib.WordArray;
        var C_algo = C.algo;
        var MD5 = C_algo.MD5;
        /**
	     * This key derivation function is meant to conform with EVP_BytesToKey.
	     * www.openssl.org/docs/crypto/EVP_BytesToKey.html
	     */ var EvpKDF = C_algo.EvpKDF = Base.extend({
            /**
	         * Configuration options.
	         *
	         * @property {number} keySize The key size in words to generate. Default: 4 (128 bits)
	         * @property {Hasher} hasher The hash algorithm to use. Default: MD5
	         * @property {number} iterations The number of iterations to perform. Default: 1
	         */ cfg: Base.extend({
                keySize: 4,
                hasher: MD5,
                iterations: 1
            }),
            /**
	         * Initializes a newly created key derivation function.
	         *
	         * @param {Object} cfg (Optional) The configuration options to use for the derivation.
	         *
	         * @example
	         *
	         *     var kdf = CryptoJS.algo.EvpKDF.create();
	         *     var kdf = CryptoJS.algo.EvpKDF.create({ keySize: 8 });
	         *     var kdf = CryptoJS.algo.EvpKDF.create({ keySize: 8, iterations: 1000 });
	         */ init: function(cfg) {
                this.cfg = this.cfg.extend(cfg);
            },
            /**
	         * Derives a key from a password.
	         *
	         * @param {WordArray|string} password The password.
	         * @param {WordArray|string} salt A salt.
	         *
	         * @return {WordArray} The derived key.
	         *
	         * @example
	         *
	         *     var key = kdf.compute(password, salt);
	         */ compute: function(password, salt) {
                var block;
                // Shortcut
                var cfg = this.cfg;
                // Init hasher
                var hasher = cfg.hasher.create();
                // Initial values
                var derivedKey = WordArray.create();
                // Shortcuts
                var derivedKeyWords = derivedKey.words;
                var keySize = cfg.keySize;
                var iterations = cfg.iterations;
                // Generate key
                while(derivedKeyWords.length < keySize){
                    if (block) hasher.update(block);
                    block = hasher.update(password).finalize(salt);
                    hasher.reset();
                    // Iterations
                    for(var i = 1; i < iterations; i++){
                        block = hasher.finalize(block);
                        hasher.reset();
                    }
                    derivedKey.concat(block);
                }
                derivedKey.sigBytes = keySize * 4;
                return derivedKey;
            }
        });
        /**
	     * Derives a key from a password.
	     *
	     * @param {WordArray|string} password The password.
	     * @param {WordArray|string} salt A salt.
	     * @param {Object} cfg (Optional) The configuration options to use for this computation.
	     *
	     * @return {WordArray} The derived key.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var key = CryptoJS.EvpKDF(password, salt);
	     *     var key = CryptoJS.EvpKDF(password, salt, { keySize: 8 });
	     *     var key = CryptoJS.EvpKDF(password, salt, { keySize: 8, iterations: 1000 });
	     */ C.EvpKDF = function(password, salt, cfg) {
            return EvpKDF.create(cfg).compute(password, salt);
        };
    })();
    return CryptoJS.EvpKDF;
});

});

parcelRequire.register("fctwD", function(module, exports) {


(function(root, factory, undef) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("cfaDk")), (parcelRequire("ioEPr")));
})(this, function(CryptoJS) {
    /**
	 * Cipher core components.
	 */ CryptoJS.lib.Cipher || function(undefined) {
        // Shortcuts
        var C = CryptoJS;
        var C_lib = C.lib;
        var Base = C_lib.Base;
        var WordArray = C_lib.WordArray;
        var BufferedBlockAlgorithm = C_lib.BufferedBlockAlgorithm;
        var C_enc = C.enc;
        var Utf8 = C_enc.Utf8;
        var Base64 = C_enc.Base64;
        var C_algo = C.algo;
        var EvpKDF = C_algo.EvpKDF;
        /**
	     * Abstract base cipher template.
	     *
	     * @property {number} keySize This cipher's key size. Default: 4 (128 bits)
	     * @property {number} ivSize This cipher's IV size. Default: 4 (128 bits)
	     * @property {number} _ENC_XFORM_MODE A constant representing encryption mode.
	     * @property {number} _DEC_XFORM_MODE A constant representing decryption mode.
	     */ var Cipher = C_lib.Cipher = BufferedBlockAlgorithm.extend({
            /**
	         * Configuration options.
	         *
	         * @property {WordArray} iv The IV to use for this operation.
	         */ cfg: Base.extend(),
            /**
	         * Creates this cipher in encryption mode.
	         *
	         * @param {WordArray} key The key.
	         * @param {Object} cfg (Optional) The configuration options to use for this operation.
	         *
	         * @return {Cipher} A cipher instance.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var cipher = CryptoJS.algo.AES.createEncryptor(keyWordArray, { iv: ivWordArray });
	         */ createEncryptor: function(key, cfg) {
                return this.create(this._ENC_XFORM_MODE, key, cfg);
            },
            /**
	         * Creates this cipher in decryption mode.
	         *
	         * @param {WordArray} key The key.
	         * @param {Object} cfg (Optional) The configuration options to use for this operation.
	         *
	         * @return {Cipher} A cipher instance.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var cipher = CryptoJS.algo.AES.createDecryptor(keyWordArray, { iv: ivWordArray });
	         */ createDecryptor: function(key, cfg) {
                return this.create(this._DEC_XFORM_MODE, key, cfg);
            },
            /**
	         * Initializes a newly created cipher.
	         *
	         * @param {number} xformMode Either the encryption or decryption transormation mode constant.
	         * @param {WordArray} key The key.
	         * @param {Object} cfg (Optional) The configuration options to use for this operation.
	         *
	         * @example
	         *
	         *     var cipher = CryptoJS.algo.AES.create(CryptoJS.algo.AES._ENC_XFORM_MODE, keyWordArray, { iv: ivWordArray });
	         */ init: function(xformMode, key, cfg) {
                // Apply config defaults
                this.cfg = this.cfg.extend(cfg);
                // Store transform mode and key
                this._xformMode = xformMode;
                this._key = key;
                // Set initial values
                this.reset();
            },
            /**
	         * Resets this cipher to its initial state.
	         *
	         * @example
	         *
	         *     cipher.reset();
	         */ reset: function() {
                // Reset data buffer
                BufferedBlockAlgorithm.reset.call(this);
                // Perform concrete-cipher logic
                this._doReset();
            },
            /**
	         * Adds data to be encrypted or decrypted.
	         *
	         * @param {WordArray|string} dataUpdate The data to encrypt or decrypt.
	         *
	         * @return {WordArray} The data after processing.
	         *
	         * @example
	         *
	         *     var encrypted = cipher.process('data');
	         *     var encrypted = cipher.process(wordArray);
	         */ process: function(dataUpdate) {
                // Append
                this._append(dataUpdate);
                // Process available blocks
                return this._process();
            },
            /**
	         * Finalizes the encryption or decryption process.
	         * Note that the finalize operation is effectively a destructive, read-once operation.
	         *
	         * @param {WordArray|string} dataUpdate The final data to encrypt or decrypt.
	         *
	         * @return {WordArray} The data after final processing.
	         *
	         * @example
	         *
	         *     var encrypted = cipher.finalize();
	         *     var encrypted = cipher.finalize('data');
	         *     var encrypted = cipher.finalize(wordArray);
	         */ finalize: function(dataUpdate) {
                // Final data update
                if (dataUpdate) this._append(dataUpdate);
                // Perform concrete-cipher logic
                var finalProcessedData = this._doFinalize();
                return finalProcessedData;
            },
            keySize: 4,
            ivSize: 4,
            _ENC_XFORM_MODE: 1,
            _DEC_XFORM_MODE: 2,
            /**
	         * Creates shortcut functions to a cipher's object interface.
	         *
	         * @param {Cipher} cipher The cipher to create a helper for.
	         *
	         * @return {Object} An object with encrypt and decrypt shortcut functions.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var AES = CryptoJS.lib.Cipher._createHelper(CryptoJS.algo.AES);
	         */ _createHelper: function() {
                function selectCipherStrategy(key) {
                    if (typeof key == "string") return PasswordBasedCipher;
                    else return SerializableCipher;
                }
                return function(cipher) {
                    return {
                        encrypt: function(message, key, cfg) {
                            return selectCipherStrategy(key).encrypt(cipher, message, key, cfg);
                        },
                        decrypt: function(ciphertext, key, cfg) {
                            return selectCipherStrategy(key).decrypt(cipher, ciphertext, key, cfg);
                        }
                    };
                };
            }()
        });
        /**
	     * Abstract base stream cipher template.
	     *
	     * @property {number} blockSize The number of 32-bit words this cipher operates on. Default: 1 (32 bits)
	     */ var StreamCipher = C_lib.StreamCipher = Cipher.extend({
            _doFinalize: function() {
                // Process partial blocks
                var finalProcessedBlocks = this._process(true);
                return finalProcessedBlocks;
            },
            blockSize: 1
        });
        /**
	     * Mode namespace.
	     */ var C_mode = C.mode = {};
        /**
	     * Abstract base block cipher mode template.
	     */ var BlockCipherMode = C_lib.BlockCipherMode = Base.extend({
            /**
	         * Creates this mode for encryption.
	         *
	         * @param {Cipher} cipher A block cipher instance.
	         * @param {Array} iv The IV words.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var mode = CryptoJS.mode.CBC.createEncryptor(cipher, iv.words);
	         */ createEncryptor: function(cipher, iv) {
                return this.Encryptor.create(cipher, iv);
            },
            /**
	         * Creates this mode for decryption.
	         *
	         * @param {Cipher} cipher A block cipher instance.
	         * @param {Array} iv The IV words.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var mode = CryptoJS.mode.CBC.createDecryptor(cipher, iv.words);
	         */ createDecryptor: function(cipher, iv) {
                return this.Decryptor.create(cipher, iv);
            },
            /**
	         * Initializes a newly created mode.
	         *
	         * @param {Cipher} cipher A block cipher instance.
	         * @param {Array} iv The IV words.
	         *
	         * @example
	         *
	         *     var mode = CryptoJS.mode.CBC.Encryptor.create(cipher, iv.words);
	         */ init: function(cipher, iv) {
                this._cipher = cipher;
                this._iv = iv;
            }
        });
        /**
	     * Cipher Block Chaining mode.
	     */ var CBC = C_mode.CBC = function() {
            /**
	         * Abstract base CBC mode.
	         */ var CBC = BlockCipherMode.extend();
            /**
	         * CBC encryptor.
	         */ CBC.Encryptor = CBC.extend({
                /**
	             * Processes the data block at offset.
	             *
	             * @param {Array} words The data words to operate on.
	             * @param {number} offset The offset where the block starts.
	             *
	             * @example
	             *
	             *     mode.processBlock(data.words, offset);
	             */ processBlock: function(words, offset) {
                    // Shortcuts
                    var cipher = this._cipher;
                    var blockSize = cipher.blockSize;
                    // XOR and encrypt
                    xorBlock.call(this, words, offset, blockSize);
                    cipher.encryptBlock(words, offset);
                    // Remember this block to use with next block
                    this._prevBlock = words.slice(offset, offset + blockSize);
                }
            });
            /**
	         * CBC decryptor.
	         */ CBC.Decryptor = CBC.extend({
                /**
	             * Processes the data block at offset.
	             *
	             * @param {Array} words The data words to operate on.
	             * @param {number} offset The offset where the block starts.
	             *
	             * @example
	             *
	             *     mode.processBlock(data.words, offset);
	             */ processBlock: function(words, offset) {
                    // Shortcuts
                    var cipher = this._cipher;
                    var blockSize = cipher.blockSize;
                    // Remember this block to use with next block
                    var thisBlock = words.slice(offset, offset + blockSize);
                    // Decrypt and XOR
                    cipher.decryptBlock(words, offset);
                    xorBlock.call(this, words, offset, blockSize);
                    // This block becomes the previous block
                    this._prevBlock = thisBlock;
                }
            });
            function xorBlock(words, offset, blockSize) {
                var block;
                // Shortcut
                var iv = this._iv;
                // Choose mixing block
                if (iv) {
                    block = iv;
                    // Remove IV for subsequent blocks
                    this._iv = undefined;
                } else block = this._prevBlock;
                // XOR blocks
                for(var i = 0; i < blockSize; i++)words[offset + i] ^= block[i];
            }
            return CBC;
        }();
        /**
	     * Padding namespace.
	     */ var C_pad = C.pad = {};
        /**
	     * PKCS #5/7 padding strategy.
	     */ var Pkcs7 = C_pad.Pkcs7 = {
            /**
	         * Pads data using the algorithm defined in PKCS #5/7.
	         *
	         * @param {WordArray} data The data to pad.
	         * @param {number} blockSize The multiple that the data should be padded to.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     CryptoJS.pad.Pkcs7.pad(wordArray, 4);
	         */ pad: function(data, blockSize) {
                // Shortcut
                var blockSizeBytes = blockSize * 4;
                // Count padding bytes
                var nPaddingBytes = blockSizeBytes - data.sigBytes % blockSizeBytes;
                // Create padding word
                var paddingWord = nPaddingBytes << 24 | nPaddingBytes << 16 | nPaddingBytes << 8 | nPaddingBytes;
                // Create padding
                var paddingWords = [];
                for(var i = 0; i < nPaddingBytes; i += 4)paddingWords.push(paddingWord);
                var padding = WordArray.create(paddingWords, nPaddingBytes);
                // Add padding
                data.concat(padding);
            },
            /**
	         * Unpads data that had been padded using the algorithm defined in PKCS #5/7.
	         *
	         * @param {WordArray} data The data to unpad.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     CryptoJS.pad.Pkcs7.unpad(wordArray);
	         */ unpad: function(data) {
                // Get number of padding bytes from last byte
                var nPaddingBytes = data.words[data.sigBytes - 1 >>> 2] & 0xff;
                // Remove padding
                data.sigBytes -= nPaddingBytes;
            }
        };
        /**
	     * Abstract base block cipher template.
	     *
	     * @property {number} blockSize The number of 32-bit words this cipher operates on. Default: 4 (128 bits)
	     */ var BlockCipher = C_lib.BlockCipher = Cipher.extend({
            /**
	         * Configuration options.
	         *
	         * @property {Mode} mode The block mode to use. Default: CBC
	         * @property {Padding} padding The padding strategy to use. Default: Pkcs7
	         */ cfg: Cipher.cfg.extend({
                mode: CBC,
                padding: Pkcs7
            }),
            reset: function() {
                var modeCreator;
                // Reset cipher
                Cipher.reset.call(this);
                // Shortcuts
                var cfg = this.cfg;
                var iv = cfg.iv;
                var mode = cfg.mode;
                // Reset block mode
                if (this._xformMode == this._ENC_XFORM_MODE) modeCreator = mode.createEncryptor;
                else /* if (this._xformMode == this._DEC_XFORM_MODE) */ {
                    modeCreator = mode.createDecryptor;
                    // Keep at least one block in the buffer for unpadding
                    this._minBufferSize = 1;
                }
                if (this._mode && this._mode.__creator == modeCreator) this._mode.init(this, iv && iv.words);
                else {
                    this._mode = modeCreator.call(mode, this, iv && iv.words);
                    this._mode.__creator = modeCreator;
                }
            },
            _doProcessBlock: function(words, offset) {
                this._mode.processBlock(words, offset);
            },
            _doFinalize: function() {
                var finalProcessedBlocks;
                // Shortcut
                var padding = this.cfg.padding;
                // Finalize
                if (this._xformMode == this._ENC_XFORM_MODE) {
                    // Pad data
                    padding.pad(this._data, this.blockSize);
                    // Process final blocks
                    finalProcessedBlocks = this._process(true);
                } else /* if (this._xformMode == this._DEC_XFORM_MODE) */ {
                    // Process final blocks
                    finalProcessedBlocks = this._process(true);
                    // Unpad data
                    padding.unpad(finalProcessedBlocks);
                }
                return finalProcessedBlocks;
            },
            blockSize: 4
        });
        /**
	     * A collection of cipher parameters.
	     *
	     * @property {WordArray} ciphertext The raw ciphertext.
	     * @property {WordArray} key The key to this ciphertext.
	     * @property {WordArray} iv The IV used in the ciphering operation.
	     * @property {WordArray} salt The salt used with a key derivation function.
	     * @property {Cipher} algorithm The cipher algorithm.
	     * @property {Mode} mode The block mode used in the ciphering operation.
	     * @property {Padding} padding The padding scheme used in the ciphering operation.
	     * @property {number} blockSize The block size of the cipher.
	     * @property {Format} formatter The default formatting strategy to convert this cipher params object to a string.
	     */ var CipherParams = C_lib.CipherParams = Base.extend({
            /**
	         * Initializes a newly created cipher params object.
	         *
	         * @param {Object} cipherParams An object with any of the possible cipher parameters.
	         *
	         * @example
	         *
	         *     var cipherParams = CryptoJS.lib.CipherParams.create({
	         *         ciphertext: ciphertextWordArray,
	         *         key: keyWordArray,
	         *         iv: ivWordArray,
	         *         salt: saltWordArray,
	         *         algorithm: CryptoJS.algo.AES,
	         *         mode: CryptoJS.mode.CBC,
	         *         padding: CryptoJS.pad.PKCS7,
	         *         blockSize: 4,
	         *         formatter: CryptoJS.format.OpenSSL
	         *     });
	         */ init: function(cipherParams) {
                this.mixIn(cipherParams);
            },
            /**
	         * Converts this cipher params object to a string.
	         *
	         * @param {Format} formatter (Optional) The formatting strategy to use.
	         *
	         * @return {string} The stringified cipher params.
	         *
	         * @throws Error If neither the formatter nor the default formatter is set.
	         *
	         * @example
	         *
	         *     var string = cipherParams + '';
	         *     var string = cipherParams.toString();
	         *     var string = cipherParams.toString(CryptoJS.format.OpenSSL);
	         */ toString: function(formatter) {
                return (formatter || this.formatter).stringify(this);
            }
        });
        /**
	     * Format namespace.
	     */ var C_format = C.format = {};
        /**
	     * OpenSSL formatting strategy.
	     */ var OpenSSLFormatter = C_format.OpenSSL = {
            /**
	         * Converts a cipher params object to an OpenSSL-compatible string.
	         *
	         * @param {CipherParams} cipherParams The cipher params object.
	         *
	         * @return {string} The OpenSSL-compatible string.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var openSSLString = CryptoJS.format.OpenSSL.stringify(cipherParams);
	         */ stringify: function(cipherParams) {
                var wordArray;
                // Shortcuts
                var ciphertext = cipherParams.ciphertext;
                var salt = cipherParams.salt;
                // Format
                if (salt) wordArray = WordArray.create([
                    0x53616c74,
                    0x65645f5f
                ]).concat(salt).concat(ciphertext);
                else wordArray = ciphertext;
                return wordArray.toString(Base64);
            },
            /**
	         * Converts an OpenSSL-compatible string to a cipher params object.
	         *
	         * @param {string} openSSLStr The OpenSSL-compatible string.
	         *
	         * @return {CipherParams} The cipher params object.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var cipherParams = CryptoJS.format.OpenSSL.parse(openSSLString);
	         */ parse: function(openSSLStr) {
                var salt;
                // Parse base64
                var ciphertext = Base64.parse(openSSLStr);
                // Shortcut
                var ciphertextWords = ciphertext.words;
                // Test for salt
                if (ciphertextWords[0] == 0x53616c74 && ciphertextWords[1] == 0x65645f5f) {
                    // Extract salt
                    salt = WordArray.create(ciphertextWords.slice(2, 4));
                    // Remove salt from ciphertext
                    ciphertextWords.splice(0, 4);
                    ciphertext.sigBytes -= 16;
                }
                return CipherParams.create({
                    ciphertext: ciphertext,
                    salt: salt
                });
            }
        };
        /**
	     * A cipher wrapper that returns ciphertext as a serializable cipher params object.
	     */ var SerializableCipher = C_lib.SerializableCipher = Base.extend({
            /**
	         * Configuration options.
	         *
	         * @property {Formatter} format The formatting strategy to convert cipher param objects to and from a string. Default: OpenSSL
	         */ cfg: Base.extend({
                format: OpenSSLFormatter
            }),
            /**
	         * Encrypts a message.
	         *
	         * @param {Cipher} cipher The cipher algorithm to use.
	         * @param {WordArray|string} message The message to encrypt.
	         * @param {WordArray} key The key.
	         * @param {Object} cfg (Optional) The configuration options to use for this operation.
	         *
	         * @return {CipherParams} A cipher params object.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var ciphertextParams = CryptoJS.lib.SerializableCipher.encrypt(CryptoJS.algo.AES, message, key);
	         *     var ciphertextParams = CryptoJS.lib.SerializableCipher.encrypt(CryptoJS.algo.AES, message, key, { iv: iv });
	         *     var ciphertextParams = CryptoJS.lib.SerializableCipher.encrypt(CryptoJS.algo.AES, message, key, { iv: iv, format: CryptoJS.format.OpenSSL });
	         */ encrypt: function(cipher, message, key, cfg) {
                // Apply config defaults
                cfg = this.cfg.extend(cfg);
                // Encrypt
                var encryptor = cipher.createEncryptor(key, cfg);
                var ciphertext = encryptor.finalize(message);
                // Shortcut
                var cipherCfg = encryptor.cfg;
                // Create and return serializable cipher params
                return CipherParams.create({
                    ciphertext: ciphertext,
                    key: key,
                    iv: cipherCfg.iv,
                    algorithm: cipher,
                    mode: cipherCfg.mode,
                    padding: cipherCfg.padding,
                    blockSize: cipher.blockSize,
                    formatter: cfg.format
                });
            },
            /**
	         * Decrypts serialized ciphertext.
	         *
	         * @param {Cipher} cipher The cipher algorithm to use.
	         * @param {CipherParams|string} ciphertext The ciphertext to decrypt.
	         * @param {WordArray} key The key.
	         * @param {Object} cfg (Optional) The configuration options to use for this operation.
	         *
	         * @return {WordArray} The plaintext.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var plaintext = CryptoJS.lib.SerializableCipher.decrypt(CryptoJS.algo.AES, formattedCiphertext, key, { iv: iv, format: CryptoJS.format.OpenSSL });
	         *     var plaintext = CryptoJS.lib.SerializableCipher.decrypt(CryptoJS.algo.AES, ciphertextParams, key, { iv: iv, format: CryptoJS.format.OpenSSL });
	         */ decrypt: function(cipher, ciphertext, key, cfg) {
                // Apply config defaults
                cfg = this.cfg.extend(cfg);
                // Convert string to CipherParams
                ciphertext = this._parse(ciphertext, cfg.format);
                // Decrypt
                var plaintext = cipher.createDecryptor(key, cfg).finalize(ciphertext.ciphertext);
                return plaintext;
            },
            /**
	         * Converts serialized ciphertext to CipherParams,
	         * else assumed CipherParams already and returns ciphertext unchanged.
	         *
	         * @param {CipherParams|string} ciphertext The ciphertext.
	         * @param {Formatter} format The formatting strategy to use to parse serialized ciphertext.
	         *
	         * @return {CipherParams} The unserialized ciphertext.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var ciphertextParams = CryptoJS.lib.SerializableCipher._parse(ciphertextStringOrParams, format);
	         */ _parse: function(ciphertext, format) {
                if (typeof ciphertext == "string") return format.parse(ciphertext, this);
                else return ciphertext;
            }
        });
        /**
	     * Key derivation function namespace.
	     */ var C_kdf = C.kdf = {};
        /**
	     * OpenSSL key derivation function.
	     */ var OpenSSLKdf = C_kdf.OpenSSL = {
            /**
	         * Derives a key and IV from a password.
	         *
	         * @param {string} password The password to derive from.
	         * @param {number} keySize The size in words of the key to generate.
	         * @param {number} ivSize The size in words of the IV to generate.
	         * @param {WordArray|string} salt (Optional) A 64-bit salt to use. If omitted, a salt will be generated randomly.
	         *
	         * @return {CipherParams} A cipher params object with the key, IV, and salt.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var derivedParams = CryptoJS.kdf.OpenSSL.execute('Password', 256/32, 128/32);
	         *     var derivedParams = CryptoJS.kdf.OpenSSL.execute('Password', 256/32, 128/32, 'saltsalt');
	         */ execute: function(password, keySize, ivSize, salt, hasher) {
                // Generate random salt
                if (!salt) salt = WordArray.random(8);
                // Derive key and IV
                if (!hasher) var key = EvpKDF.create({
                    keySize: keySize + ivSize
                }).compute(password, salt);
                else var key = EvpKDF.create({
                    keySize: keySize + ivSize,
                    hasher: hasher
                }).compute(password, salt);
                // Separate key and IV
                var iv = WordArray.create(key.words.slice(keySize), ivSize * 4);
                key.sigBytes = keySize * 4;
                // Return params
                return CipherParams.create({
                    key: key,
                    iv: iv,
                    salt: salt
                });
            }
        };
        /**
	     * A serializable cipher wrapper that derives the key from a password,
	     * and returns ciphertext as a serializable cipher params object.
	     */ var PasswordBasedCipher = C_lib.PasswordBasedCipher = SerializableCipher.extend({
            /**
	         * Configuration options.
	         *
	         * @property {KDF} kdf The key derivation function to use to generate a key and IV from a password. Default: OpenSSL
	         */ cfg: SerializableCipher.cfg.extend({
                kdf: OpenSSLKdf
            }),
            /**
	         * Encrypts a message using a password.
	         *
	         * @param {Cipher} cipher The cipher algorithm to use.
	         * @param {WordArray|string} message The message to encrypt.
	         * @param {string} password The password.
	         * @param {Object} cfg (Optional) The configuration options to use for this operation.
	         *
	         * @return {CipherParams} A cipher params object.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var ciphertextParams = CryptoJS.lib.PasswordBasedCipher.encrypt(CryptoJS.algo.AES, message, 'password');
	         *     var ciphertextParams = CryptoJS.lib.PasswordBasedCipher.encrypt(CryptoJS.algo.AES, message, 'password', { format: CryptoJS.format.OpenSSL });
	         */ encrypt: function(cipher, message, password, cfg) {
                // Apply config defaults
                cfg = this.cfg.extend(cfg);
                // Derive key and other params
                var derivedParams = cfg.kdf.execute(password, cipher.keySize, cipher.ivSize, cfg.salt, cfg.hasher);
                // Add IV to config
                cfg.iv = derivedParams.iv;
                // Encrypt
                var ciphertext = SerializableCipher.encrypt.call(this, cipher, message, derivedParams.key, cfg);
                // Mix in derived params
                ciphertext.mixIn(derivedParams);
                return ciphertext;
            },
            /**
	         * Decrypts serialized ciphertext using a password.
	         *
	         * @param {Cipher} cipher The cipher algorithm to use.
	         * @param {CipherParams|string} ciphertext The ciphertext to decrypt.
	         * @param {string} password The password.
	         * @param {Object} cfg (Optional) The configuration options to use for this operation.
	         *
	         * @return {WordArray} The plaintext.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var plaintext = CryptoJS.lib.PasswordBasedCipher.decrypt(CryptoJS.algo.AES, formattedCiphertext, 'password', { format: CryptoJS.format.OpenSSL });
	         *     var plaintext = CryptoJS.lib.PasswordBasedCipher.decrypt(CryptoJS.algo.AES, ciphertextParams, 'password', { format: CryptoJS.format.OpenSSL });
	         */ decrypt: function(cipher, ciphertext, password, cfg) {
                // Apply config defaults
                cfg = this.cfg.extend(cfg);
                // Convert string to CipherParams
                ciphertext = this._parse(ciphertext, cfg.format);
                // Derive key and other params
                var derivedParams = cfg.kdf.execute(password, cipher.keySize, cipher.ivSize, ciphertext.salt, cfg.hasher);
                // Add IV to config
                cfg.iv = derivedParams.iv;
                // Decrypt
                var plaintext = SerializableCipher.decrypt.call(this, cipher, ciphertext, derivedParams.key, cfg);
                return plaintext;
            }
        });
    }();
});

});

parcelRequire.register("kvEE5", function(module, exports) {


(function(root, factory, undef) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("cfaDk")), (parcelRequire("fctwD")));
})(this, function(CryptoJS) {
    /**
	 * Cipher Feedback block mode.
	 */ CryptoJS.mode.CFB = function() {
        var CFB = CryptoJS.lib.BlockCipherMode.extend();
        CFB.Encryptor = CFB.extend({
            processBlock: function(words, offset) {
                // Shortcuts
                var cipher = this._cipher;
                var blockSize = cipher.blockSize;
                generateKeystreamAndEncrypt.call(this, words, offset, blockSize, cipher);
                // Remember this block to use with next block
                this._prevBlock = words.slice(offset, offset + blockSize);
            }
        });
        CFB.Decryptor = CFB.extend({
            processBlock: function(words, offset) {
                // Shortcuts
                var cipher = this._cipher;
                var blockSize = cipher.blockSize;
                // Remember this block to use with next block
                var thisBlock = words.slice(offset, offset + blockSize);
                generateKeystreamAndEncrypt.call(this, words, offset, blockSize, cipher);
                // This block becomes the previous block
                this._prevBlock = thisBlock;
            }
        });
        function generateKeystreamAndEncrypt(words, offset, blockSize, cipher) {
            var keystream;
            // Shortcut
            var iv = this._iv;
            // Generate keystream
            if (iv) {
                keystream = iv.slice(0);
                // Remove IV for subsequent blocks
                this._iv = undefined;
            } else keystream = this._prevBlock;
            cipher.encryptBlock(keystream, 0);
            // Encrypt
            for(var i = 0; i < blockSize; i++)words[offset + i] ^= keystream[i];
        }
        return CFB;
    }();
    return CryptoJS.mode.CFB;
});

});

parcelRequire.register("4phbY", function(module, exports) {


(function(root, factory, undef) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("cfaDk")), (parcelRequire("fctwD")));
})(this, function(CryptoJS) {
    /**
	 * Counter block mode.
	 */ CryptoJS.mode.CTR = function() {
        var CTR = CryptoJS.lib.BlockCipherMode.extend();
        var Encryptor = CTR.Encryptor = CTR.extend({
            processBlock: function(words, offset) {
                // Shortcuts
                var cipher = this._cipher;
                var blockSize = cipher.blockSize;
                var iv = this._iv;
                var counter = this._counter;
                // Generate keystream
                if (iv) {
                    counter = this._counter = iv.slice(0);
                    // Remove IV for subsequent blocks
                    this._iv = undefined;
                }
                var keystream = counter.slice(0);
                cipher.encryptBlock(keystream, 0);
                // Increment counter
                counter[blockSize - 1] = counter[blockSize - 1] + 1 | 0;
                // Encrypt
                for(var i = 0; i < blockSize; i++)words[offset + i] ^= keystream[i];
            }
        });
        CTR.Decryptor = Encryptor;
        return CTR;
    }();
    return CryptoJS.mode.CTR;
});

});

parcelRequire.register("5AuZH", function(module, exports) {


(function(root, factory, undef) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("cfaDk")), (parcelRequire("fctwD")));
})(this, function(CryptoJS) {
    /** @preserve
	 * Counter block mode compatible with  Dr Brian Gladman fileenc.c
	 * derived from CryptoJS.mode.CTR
	 * Jan Hruby jhruby.web@gmail.com
	 */ CryptoJS.mode.CTRGladman = function() {
        var CTRGladman = CryptoJS.lib.BlockCipherMode.extend();
        function incWord(word) {
            if ((word >> 24 & 0xff) === 0xff) {
                var b1 = word >> 16 & 0xff;
                var b2 = word >> 8 & 0xff;
                var b3 = word & 0xff;
                if (b1 === 0xff) {
                    b1 = 0;
                    if (b2 === 0xff) {
                        b2 = 0;
                        if (b3 === 0xff) b3 = 0;
                        else ++b3;
                    } else ++b2;
                } else ++b1;
                word = 0;
                word += b1 << 16;
                word += b2 << 8;
                word += b3;
            } else word += 16777216;
            return word;
        }
        function incCounter(counter) {
            if ((counter[0] = incWord(counter[0])) === 0) // encr_data in fileenc.c from  Dr Brian Gladman's counts only with DWORD j < 8
            counter[1] = incWord(counter[1]);
            return counter;
        }
        var Encryptor = CTRGladman.Encryptor = CTRGladman.extend({
            processBlock: function(words, offset) {
                // Shortcuts
                var cipher = this._cipher;
                var blockSize = cipher.blockSize;
                var iv = this._iv;
                var counter = this._counter;
                // Generate keystream
                if (iv) {
                    counter = this._counter = iv.slice(0);
                    // Remove IV for subsequent blocks
                    this._iv = undefined;
                }
                incCounter(counter);
                var keystream = counter.slice(0);
                cipher.encryptBlock(keystream, 0);
                // Encrypt
                for(var i = 0; i < blockSize; i++)words[offset + i] ^= keystream[i];
            }
        });
        CTRGladman.Decryptor = Encryptor;
        return CTRGladman;
    }();
    return CryptoJS.mode.CTRGladman;
});

});

parcelRequire.register("9xxh3", function(module, exports) {


(function(root, factory, undef) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("cfaDk")), (parcelRequire("fctwD")));
})(this, function(CryptoJS) {
    /**
	 * Output Feedback block mode.
	 */ CryptoJS.mode.OFB = function() {
        var OFB = CryptoJS.lib.BlockCipherMode.extend();
        var Encryptor = OFB.Encryptor = OFB.extend({
            processBlock: function(words, offset) {
                // Shortcuts
                var cipher = this._cipher;
                var blockSize = cipher.blockSize;
                var iv = this._iv;
                var keystream = this._keystream;
                // Generate keystream
                if (iv) {
                    keystream = this._keystream = iv.slice(0);
                    // Remove IV for subsequent blocks
                    this._iv = undefined;
                }
                cipher.encryptBlock(keystream, 0);
                // Encrypt
                for(var i = 0; i < blockSize; i++)words[offset + i] ^= keystream[i];
            }
        });
        OFB.Decryptor = Encryptor;
        return OFB;
    }();
    return CryptoJS.mode.OFB;
});

});

parcelRequire.register("hsvIJ", function(module, exports) {


(function(root, factory, undef) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("cfaDk")), (parcelRequire("fctwD")));
})(this, function(CryptoJS) {
    /**
	 * Electronic Codebook block mode.
	 */ CryptoJS.mode.ECB = function() {
        var ECB = CryptoJS.lib.BlockCipherMode.extend();
        ECB.Encryptor = ECB.extend({
            processBlock: function(words, offset) {
                this._cipher.encryptBlock(words, offset);
            }
        });
        ECB.Decryptor = ECB.extend({
            processBlock: function(words, offset) {
                this._cipher.decryptBlock(words, offset);
            }
        });
        return ECB;
    }();
    return CryptoJS.mode.ECB;
});

});

parcelRequire.register("cIj8k", function(module, exports) {


(function(root, factory, undef) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("cfaDk")), (parcelRequire("fctwD")));
})(this, function(CryptoJS) {
    /**
	 * ANSI X.923 padding strategy.
	 */ CryptoJS.pad.AnsiX923 = {
        pad: function(data, blockSize) {
            // Shortcuts
            var dataSigBytes = data.sigBytes;
            var blockSizeBytes = blockSize * 4;
            // Count padding bytes
            var nPaddingBytes = blockSizeBytes - dataSigBytes % blockSizeBytes;
            // Compute last byte position
            var lastBytePos = dataSigBytes + nPaddingBytes - 1;
            // Pad
            data.clamp();
            data.words[lastBytePos >>> 2] |= nPaddingBytes << 24 - lastBytePos % 4 * 8;
            data.sigBytes += nPaddingBytes;
        },
        unpad: function(data) {
            // Get number of padding bytes from last byte
            var nPaddingBytes = data.words[data.sigBytes - 1 >>> 2] & 0xff;
            // Remove padding
            data.sigBytes -= nPaddingBytes;
        }
    };
    return CryptoJS.pad.Ansix923;
});

});

parcelRequire.register("3XsJo", function(module, exports) {


(function(root, factory, undef) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("cfaDk")), (parcelRequire("fctwD")));
})(this, function(CryptoJS) {
    /**
	 * ISO 10126 padding strategy.
	 */ CryptoJS.pad.Iso10126 = {
        pad: function(data, blockSize) {
            // Shortcut
            var blockSizeBytes = blockSize * 4;
            // Count padding bytes
            var nPaddingBytes = blockSizeBytes - data.sigBytes % blockSizeBytes;
            // Pad
            data.concat(CryptoJS.lib.WordArray.random(nPaddingBytes - 1)).concat(CryptoJS.lib.WordArray.create([
                nPaddingBytes << 24
            ], 1));
        },
        unpad: function(data) {
            // Get number of padding bytes from last byte
            var nPaddingBytes = data.words[data.sigBytes - 1 >>> 2] & 0xff;
            // Remove padding
            data.sigBytes -= nPaddingBytes;
        }
    };
    return CryptoJS.pad.Iso10126;
});

});

parcelRequire.register("4cP0m", function(module, exports) {


(function(root, factory, undef) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("cfaDk")), (parcelRequire("fctwD")));
})(this, function(CryptoJS) {
    /**
	 * ISO/IEC 9797-1 Padding Method 2.
	 */ CryptoJS.pad.Iso97971 = {
        pad: function(data, blockSize) {
            // Add 0x80 byte
            data.concat(CryptoJS.lib.WordArray.create([
                0x80000000
            ], 1));
            // Zero pad the rest
            CryptoJS.pad.ZeroPadding.pad(data, blockSize);
        },
        unpad: function(data) {
            // Remove zero padding
            CryptoJS.pad.ZeroPadding.unpad(data);
            // Remove one more byte -- the 0x80 byte
            data.sigBytes--;
        }
    };
    return CryptoJS.pad.Iso97971;
});

});

parcelRequire.register("1bHm1", function(module, exports) {


(function(root, factory, undef) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("cfaDk")), (parcelRequire("fctwD")));
})(this, function(CryptoJS) {
    /**
	 * Zero padding strategy.
	 */ CryptoJS.pad.ZeroPadding = {
        pad: function(data, blockSize) {
            // Shortcut
            var blockSizeBytes = blockSize * 4;
            // Pad
            data.clamp();
            data.sigBytes += blockSizeBytes - (data.sigBytes % blockSizeBytes || blockSizeBytes);
        },
        unpad: function(data) {
            // Shortcut
            var dataWords = data.words;
            // Unpad
            var i = data.sigBytes - 1;
            for(var i = data.sigBytes - 1; i >= 0; i--)if (dataWords[i >>> 2] >>> 24 - i % 4 * 8 & 0xff) {
                data.sigBytes = i + 1;
                break;
            }
        }
    };
    return CryptoJS.pad.ZeroPadding;
});

});

parcelRequire.register("5oWlT", function(module, exports) {


(function(root, factory, undef) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("cfaDk")), (parcelRequire("fctwD")));
})(this, function(CryptoJS) {
    /**
	 * A noop padding strategy.
	 */ CryptoJS.pad.NoPadding = {
        pad: function() {},
        unpad: function() {}
    };
    return CryptoJS.pad.NoPadding;
});

});

parcelRequire.register("eSHMm", function(module, exports) {


(function(root, factory, undef) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("cfaDk")), (parcelRequire("fctwD")));
})(this, function(CryptoJS) {
    (function(undefined) {
        // Shortcuts
        var C = CryptoJS;
        var C_lib = C.lib;
        var CipherParams = C_lib.CipherParams;
        var C_enc = C.enc;
        var Hex = C_enc.Hex;
        var C_format = C.format;
        var HexFormatter = C_format.Hex = {
            /**
	         * Converts the ciphertext of a cipher params object to a hexadecimally encoded string.
	         *
	         * @param {CipherParams} cipherParams The cipher params object.
	         *
	         * @return {string} The hexadecimally encoded string.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var hexString = CryptoJS.format.Hex.stringify(cipherParams);
	         */ stringify: function(cipherParams) {
                return cipherParams.ciphertext.toString(Hex);
            },
            /**
	         * Converts a hexadecimally encoded ciphertext string to a cipher params object.
	         *
	         * @param {string} input The hexadecimally encoded string.
	         *
	         * @return {CipherParams} The cipher params object.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var cipherParams = CryptoJS.format.Hex.parse(hexString);
	         */ parse: function(input) {
                var ciphertext = Hex.parse(input);
                return CipherParams.create({
                    ciphertext: ciphertext
                });
            }
        };
    })();
    return CryptoJS.format.Hex;
});

});

parcelRequire.register("3H9rt", function(module, exports) {





(function(root, factory, undef) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("cfaDk")), (parcelRequire("500SS")), (parcelRequire("6oXxt")), (parcelRequire("ioEPr")), (parcelRequire("fctwD")));
})(this, function(CryptoJS) {
    (function() {
        // Shortcuts
        var C = CryptoJS;
        var C_lib = C.lib;
        var BlockCipher = C_lib.BlockCipher;
        var C_algo = C.algo;
        // Lookup tables
        var SBOX = [];
        var INV_SBOX = [];
        var SUB_MIX_0 = [];
        var SUB_MIX_1 = [];
        var SUB_MIX_2 = [];
        var SUB_MIX_3 = [];
        var INV_SUB_MIX_0 = [];
        var INV_SUB_MIX_1 = [];
        var INV_SUB_MIX_2 = [];
        var INV_SUB_MIX_3 = [];
        // Compute lookup tables
        (function() {
            // Compute double table
            var d = [];
            for(var i = 0; i < 256; i++)if (i < 128) d[i] = i << 1;
            else d[i] = i << 1 ^ 0x11b;
            // Walk GF(2^8)
            var x = 0;
            var xi = 0;
            for(var i = 0; i < 256; i++){
                // Compute sbox
                var sx = xi ^ xi << 1 ^ xi << 2 ^ xi << 3 ^ xi << 4;
                sx = sx >>> 8 ^ sx & 0xff ^ 0x63;
                SBOX[x] = sx;
                INV_SBOX[sx] = x;
                // Compute multiplication
                var x2 = d[x];
                var x4 = d[x2];
                var x8 = d[x4];
                // Compute sub bytes, mix columns tables
                var t = d[sx] * 0x101 ^ sx * 0x1010100;
                SUB_MIX_0[x] = t << 24 | t >>> 8;
                SUB_MIX_1[x] = t << 16 | t >>> 16;
                SUB_MIX_2[x] = t << 8 | t >>> 24;
                SUB_MIX_3[x] = t;
                // Compute inv sub bytes, inv mix columns tables
                var t = x8 * 0x1010101 ^ x4 * 0x10001 ^ x2 * 0x101 ^ x * 0x1010100;
                INV_SUB_MIX_0[sx] = t << 24 | t >>> 8;
                INV_SUB_MIX_1[sx] = t << 16 | t >>> 16;
                INV_SUB_MIX_2[sx] = t << 8 | t >>> 24;
                INV_SUB_MIX_3[sx] = t;
                // Compute next counter
                if (!x) x = xi = 1;
                else {
                    x = x2 ^ d[d[d[x8 ^ x2]]];
                    xi ^= d[d[xi]];
                }
            }
        })();
        // Precomputed Rcon lookup
        var RCON = [
            0x00,
            0x01,
            0x02,
            0x04,
            0x08,
            0x10,
            0x20,
            0x40,
            0x80,
            0x1b,
            0x36
        ];
        /**
	     * AES block cipher algorithm.
	     */ var AES = C_algo.AES = BlockCipher.extend({
            _doReset: function() {
                var t;
                // Skip reset of nRounds has been set before and key did not change
                if (this._nRounds && this._keyPriorReset === this._key) return;
                // Shortcuts
                var key = this._keyPriorReset = this._key;
                var keyWords = key.words;
                var keySize = key.sigBytes / 4;
                // Compute number of rounds
                var nRounds = this._nRounds = keySize + 6;
                // Compute number of key schedule rows
                var ksRows = (nRounds + 1) * 4;
                // Compute key schedule
                var keySchedule = this._keySchedule = [];
                for(var ksRow = 0; ksRow < ksRows; ksRow++)if (ksRow < keySize) keySchedule[ksRow] = keyWords[ksRow];
                else {
                    t = keySchedule[ksRow - 1];
                    if (!(ksRow % keySize)) {
                        // Rot word
                        t = t << 8 | t >>> 24;
                        // Sub word
                        t = SBOX[t >>> 24] << 24 | SBOX[t >>> 16 & 0xff] << 16 | SBOX[t >>> 8 & 0xff] << 8 | SBOX[t & 0xff];
                        // Mix Rcon
                        t ^= RCON[ksRow / keySize | 0] << 24;
                    } else if (keySize > 6 && ksRow % keySize == 4) // Sub word
                    t = SBOX[t >>> 24] << 24 | SBOX[t >>> 16 & 0xff] << 16 | SBOX[t >>> 8 & 0xff] << 8 | SBOX[t & 0xff];
                    keySchedule[ksRow] = keySchedule[ksRow - keySize] ^ t;
                }
                // Compute inv key schedule
                var invKeySchedule = this._invKeySchedule = [];
                for(var invKsRow = 0; invKsRow < ksRows; invKsRow++){
                    var ksRow = ksRows - invKsRow;
                    if (invKsRow % 4) var t = keySchedule[ksRow];
                    else var t = keySchedule[ksRow - 4];
                    if (invKsRow < 4 || ksRow <= 4) invKeySchedule[invKsRow] = t;
                    else invKeySchedule[invKsRow] = INV_SUB_MIX_0[SBOX[t >>> 24]] ^ INV_SUB_MIX_1[SBOX[t >>> 16 & 0xff]] ^ INV_SUB_MIX_2[SBOX[t >>> 8 & 0xff]] ^ INV_SUB_MIX_3[SBOX[t & 0xff]];
                }
            },
            encryptBlock: function(M, offset) {
                this._doCryptBlock(M, offset, this._keySchedule, SUB_MIX_0, SUB_MIX_1, SUB_MIX_2, SUB_MIX_3, SBOX);
            },
            decryptBlock: function(M, offset) {
                // Swap 2nd and 4th rows
                var t = M[offset + 1];
                M[offset + 1] = M[offset + 3];
                M[offset + 3] = t;
                this._doCryptBlock(M, offset, this._invKeySchedule, INV_SUB_MIX_0, INV_SUB_MIX_1, INV_SUB_MIX_2, INV_SUB_MIX_3, INV_SBOX);
                // Inv swap 2nd and 4th rows
                var t = M[offset + 1];
                M[offset + 1] = M[offset + 3];
                M[offset + 3] = t;
            },
            _doCryptBlock: function(M, offset, keySchedule, SUB_MIX_0, SUB_MIX_1, SUB_MIX_2, SUB_MIX_3, SBOX) {
                // Shortcut
                var nRounds = this._nRounds;
                // Get input, add round key
                var s0 = M[offset] ^ keySchedule[0];
                var s1 = M[offset + 1] ^ keySchedule[1];
                var s2 = M[offset + 2] ^ keySchedule[2];
                var s3 = M[offset + 3] ^ keySchedule[3];
                // Key schedule row counter
                var ksRow = 4;
                // Rounds
                for(var round = 1; round < nRounds; round++){
                    // Shift rows, sub bytes, mix columns, add round key
                    var t0 = SUB_MIX_0[s0 >>> 24] ^ SUB_MIX_1[s1 >>> 16 & 0xff] ^ SUB_MIX_2[s2 >>> 8 & 0xff] ^ SUB_MIX_3[s3 & 0xff] ^ keySchedule[ksRow++];
                    var t1 = SUB_MIX_0[s1 >>> 24] ^ SUB_MIX_1[s2 >>> 16 & 0xff] ^ SUB_MIX_2[s3 >>> 8 & 0xff] ^ SUB_MIX_3[s0 & 0xff] ^ keySchedule[ksRow++];
                    var t2 = SUB_MIX_0[s2 >>> 24] ^ SUB_MIX_1[s3 >>> 16 & 0xff] ^ SUB_MIX_2[s0 >>> 8 & 0xff] ^ SUB_MIX_3[s1 & 0xff] ^ keySchedule[ksRow++];
                    var t3 = SUB_MIX_0[s3 >>> 24] ^ SUB_MIX_1[s0 >>> 16 & 0xff] ^ SUB_MIX_2[s1 >>> 8 & 0xff] ^ SUB_MIX_3[s2 & 0xff] ^ keySchedule[ksRow++];
                    // Update state
                    s0 = t0;
                    s1 = t1;
                    s2 = t2;
                    s3 = t3;
                }
                // Shift rows, sub bytes, add round key
                var t0 = (SBOX[s0 >>> 24] << 24 | SBOX[s1 >>> 16 & 0xff] << 16 | SBOX[s2 >>> 8 & 0xff] << 8 | SBOX[s3 & 0xff]) ^ keySchedule[ksRow++];
                var t1 = (SBOX[s1 >>> 24] << 24 | SBOX[s2 >>> 16 & 0xff] << 16 | SBOX[s3 >>> 8 & 0xff] << 8 | SBOX[s0 & 0xff]) ^ keySchedule[ksRow++];
                var t2 = (SBOX[s2 >>> 24] << 24 | SBOX[s3 >>> 16 & 0xff] << 16 | SBOX[s0 >>> 8 & 0xff] << 8 | SBOX[s1 & 0xff]) ^ keySchedule[ksRow++];
                var t3 = (SBOX[s3 >>> 24] << 24 | SBOX[s0 >>> 16 & 0xff] << 16 | SBOX[s1 >>> 8 & 0xff] << 8 | SBOX[s2 & 0xff]) ^ keySchedule[ksRow++];
                // Set output
                M[offset] = t0;
                M[offset + 1] = t1;
                M[offset + 2] = t2;
                M[offset + 3] = t3;
            },
            keySize: 8
        });
        /**
	     * Shortcut functions to the cipher's object interface.
	     *
	     * @example
	     *
	     *     var ciphertext = CryptoJS.AES.encrypt(message, key, cfg);
	     *     var plaintext  = CryptoJS.AES.decrypt(ciphertext, key, cfg);
	     */ C.AES = BlockCipher._createHelper(AES);
    })();
    return CryptoJS.AES;
});

});

parcelRequire.register("2QWZ2", function(module, exports) {





(function(root, factory, undef) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("cfaDk")), (parcelRequire("500SS")), (parcelRequire("6oXxt")), (parcelRequire("ioEPr")), (parcelRequire("fctwD")));
})(this, function(CryptoJS) {
    (function() {
        // Shortcuts
        var C = CryptoJS;
        var C_lib = C.lib;
        var WordArray = C_lib.WordArray;
        var BlockCipher = C_lib.BlockCipher;
        var C_algo = C.algo;
        // Permuted Choice 1 constants
        var PC1 = [
            57,
            49,
            41,
            33,
            25,
            17,
            9,
            1,
            58,
            50,
            42,
            34,
            26,
            18,
            10,
            2,
            59,
            51,
            43,
            35,
            27,
            19,
            11,
            3,
            60,
            52,
            44,
            36,
            63,
            55,
            47,
            39,
            31,
            23,
            15,
            7,
            62,
            54,
            46,
            38,
            30,
            22,
            14,
            6,
            61,
            53,
            45,
            37,
            29,
            21,
            13,
            5,
            28,
            20,
            12,
            4
        ];
        // Permuted Choice 2 constants
        var PC2 = [
            14,
            17,
            11,
            24,
            1,
            5,
            3,
            28,
            15,
            6,
            21,
            10,
            23,
            19,
            12,
            4,
            26,
            8,
            16,
            7,
            27,
            20,
            13,
            2,
            41,
            52,
            31,
            37,
            47,
            55,
            30,
            40,
            51,
            45,
            33,
            48,
            44,
            49,
            39,
            56,
            34,
            53,
            46,
            42,
            50,
            36,
            29,
            32
        ];
        // Cumulative bit shift constants
        var BIT_SHIFTS = [
            1,
            2,
            4,
            6,
            8,
            10,
            12,
            14,
            15,
            17,
            19,
            21,
            23,
            25,
            27,
            28
        ];
        // SBOXes and round permutation constants
        var SBOX_P = [
            {
                0x0: 0x808200,
                0x10000000: 0x8000,
                0x20000000: 0x808002,
                0x30000000: 0x2,
                0x40000000: 0x200,
                0x50000000: 0x808202,
                0x60000000: 0x800202,
                0x70000000: 0x800000,
                0x80000000: 0x202,
                0x90000000: 0x800200,
                0xa0000000: 0x8200,
                0xb0000000: 0x808000,
                0xc0000000: 0x8002,
                0xd0000000: 0x800002,
                0xe0000000: 0x0,
                0xf0000000: 0x8202,
                0x8000000: 0x0,
                0x18000000: 0x808202,
                0x28000000: 0x8202,
                0x38000000: 0x8000,
                0x48000000: 0x808200,
                0x58000000: 0x200,
                0x68000000: 0x808002,
                0x78000000: 0x2,
                0x88000000: 0x800200,
                0x98000000: 0x8200,
                0xa8000000: 0x808000,
                0xb8000000: 0x800202,
                0xc8000000: 0x800002,
                0xd8000000: 0x8002,
                0xe8000000: 0x202,
                0xf8000000: 0x800000,
                0x1: 0x8000,
                0x10000001: 0x2,
                0x20000001: 0x808200,
                0x30000001: 0x800000,
                0x40000001: 0x808002,
                0x50000001: 0x8200,
                0x60000001: 0x200,
                0x70000001: 0x800202,
                0x80000001: 0x808202,
                0x90000001: 0x808000,
                0xa0000001: 0x800002,
                0xb0000001: 0x8202,
                0xc0000001: 0x202,
                0xd0000001: 0x800200,
                0xe0000001: 0x8002,
                0xf0000001: 0x0,
                0x8000001: 0x808202,
                0x18000001: 0x808000,
                0x28000001: 0x800000,
                0x38000001: 0x200,
                0x48000001: 0x8000,
                0x58000001: 0x800002,
                0x68000001: 0x2,
                0x78000001: 0x8202,
                0x88000001: 0x8002,
                0x98000001: 0x800202,
                0xa8000001: 0x202,
                0xb8000001: 0x808200,
                0xc8000001: 0x800200,
                0xd8000001: 0x0,
                0xe8000001: 0x8200,
                0xf8000001: 0x808002
            },
            {
                0x0: 0x40084010,
                0x1000000: 0x4000,
                0x2000000: 0x80000,
                0x3000000: 0x40080010,
                0x4000000: 0x40000010,
                0x5000000: 0x40084000,
                0x6000000: 0x40004000,
                0x7000000: 0x10,
                0x8000000: 0x84000,
                0x9000000: 0x40004010,
                0xa000000: 0x40000000,
                0xb000000: 0x84010,
                0xc000000: 0x80010,
                0xd000000: 0x0,
                0xe000000: 0x4010,
                0xf000000: 0x40080000,
                0x800000: 0x40004000,
                0x1800000: 0x84010,
                0x2800000: 0x10,
                0x3800000: 0x40004010,
                0x4800000: 0x40084010,
                0x5800000: 0x40000000,
                0x6800000: 0x80000,
                0x7800000: 0x40080010,
                0x8800000: 0x80010,
                0x9800000: 0x0,
                0xa800000: 0x4000,
                0xb800000: 0x40080000,
                0xc800000: 0x40000010,
                0xd800000: 0x84000,
                0xe800000: 0x40084000,
                0xf800000: 0x4010,
                0x10000000: 0x0,
                0x11000000: 0x40080010,
                0x12000000: 0x40004010,
                0x13000000: 0x40084000,
                0x14000000: 0x40080000,
                0x15000000: 0x10,
                0x16000000: 0x84010,
                0x17000000: 0x4000,
                0x18000000: 0x4010,
                0x19000000: 0x80000,
                0x1a000000: 0x80010,
                0x1b000000: 0x40000010,
                0x1c000000: 0x84000,
                0x1d000000: 0x40004000,
                0x1e000000: 0x40000000,
                0x1f000000: 0x40084010,
                0x10800000: 0x84010,
                0x11800000: 0x80000,
                0x12800000: 0x40080000,
                0x13800000: 0x4000,
                0x14800000: 0x40004000,
                0x15800000: 0x40084010,
                0x16800000: 0x10,
                0x17800000: 0x40000000,
                0x18800000: 0x40084000,
                0x19800000: 0x40000010,
                0x1a800000: 0x40004010,
                0x1b800000: 0x80010,
                0x1c800000: 0x0,
                0x1d800000: 0x4010,
                0x1e800000: 0x40080010,
                0x1f800000: 0x84000
            },
            {
                0x0: 0x104,
                0x100000: 0x0,
                0x200000: 0x4000100,
                0x300000: 0x10104,
                0x400000: 0x10004,
                0x500000: 0x4000004,
                0x600000: 0x4010104,
                0x700000: 0x4010000,
                0x800000: 0x4000000,
                0x900000: 0x4010100,
                0xa00000: 0x10100,
                0xb00000: 0x4010004,
                0xc00000: 0x4000104,
                0xd00000: 0x10000,
                0xe00000: 0x4,
                0xf00000: 0x100,
                0x80000: 0x4010100,
                0x180000: 0x4010004,
                0x280000: 0x0,
                0x380000: 0x4000100,
                0x480000: 0x4000004,
                0x580000: 0x10000,
                0x680000: 0x10004,
                0x780000: 0x104,
                0x880000: 0x4,
                0x980000: 0x100,
                0xa80000: 0x4010000,
                0xb80000: 0x10104,
                0xc80000: 0x10100,
                0xd80000: 0x4000104,
                0xe80000: 0x4010104,
                0xf80000: 0x4000000,
                0x1000000: 0x4010100,
                0x1100000: 0x10004,
                0x1200000: 0x10000,
                0x1300000: 0x4000100,
                0x1400000: 0x100,
                0x1500000: 0x4010104,
                0x1600000: 0x4000004,
                0x1700000: 0x0,
                0x1800000: 0x4000104,
                0x1900000: 0x4000000,
                0x1a00000: 0x4,
                0x1b00000: 0x10100,
                0x1c00000: 0x4010000,
                0x1d00000: 0x104,
                0x1e00000: 0x10104,
                0x1f00000: 0x4010004,
                0x1080000: 0x4000000,
                0x1180000: 0x104,
                0x1280000: 0x4010100,
                0x1380000: 0x0,
                0x1480000: 0x10004,
                0x1580000: 0x4000100,
                0x1680000: 0x100,
                0x1780000: 0x4010004,
                0x1880000: 0x10000,
                0x1980000: 0x4010104,
                0x1a80000: 0x10104,
                0x1b80000: 0x4000004,
                0x1c80000: 0x4000104,
                0x1d80000: 0x4010000,
                0x1e80000: 0x4,
                0x1f80000: 0x10100
            },
            {
                0x0: 0x80401000,
                0x10000: 0x80001040,
                0x20000: 0x401040,
                0x30000: 0x80400000,
                0x40000: 0x0,
                0x50000: 0x401000,
                0x60000: 0x80000040,
                0x70000: 0x400040,
                0x80000: 0x80000000,
                0x90000: 0x400000,
                0xa0000: 0x40,
                0xb0000: 0x80001000,
                0xc0000: 0x80400040,
                0xd0000: 0x1040,
                0xe0000: 0x1000,
                0xf0000: 0x80401040,
                0x8000: 0x80001040,
                0x18000: 0x40,
                0x28000: 0x80400040,
                0x38000: 0x80001000,
                0x48000: 0x401000,
                0x58000: 0x80401040,
                0x68000: 0x0,
                0x78000: 0x80400000,
                0x88000: 0x1000,
                0x98000: 0x80401000,
                0xa8000: 0x400000,
                0xb8000: 0x1040,
                0xc8000: 0x80000000,
                0xd8000: 0x400040,
                0xe8000: 0x401040,
                0xf8000: 0x80000040,
                0x100000: 0x400040,
                0x110000: 0x401000,
                0x120000: 0x80000040,
                0x130000: 0x0,
                0x140000: 0x1040,
                0x150000: 0x80400040,
                0x160000: 0x80401000,
                0x170000: 0x80001040,
                0x180000: 0x80401040,
                0x190000: 0x80000000,
                0x1a0000: 0x80400000,
                0x1b0000: 0x401040,
                0x1c0000: 0x80001000,
                0x1d0000: 0x400000,
                0x1e0000: 0x40,
                0x1f0000: 0x1000,
                0x108000: 0x80400000,
                0x118000: 0x80401040,
                0x128000: 0x0,
                0x138000: 0x401000,
                0x148000: 0x400040,
                0x158000: 0x80000000,
                0x168000: 0x80001040,
                0x178000: 0x40,
                0x188000: 0x80000040,
                0x198000: 0x1000,
                0x1a8000: 0x80001000,
                0x1b8000: 0x80400040,
                0x1c8000: 0x1040,
                0x1d8000: 0x80401000,
                0x1e8000: 0x400000,
                0x1f8000: 0x401040
            },
            {
                0x0: 0x80,
                0x1000: 0x1040000,
                0x2000: 0x40000,
                0x3000: 0x20000000,
                0x4000: 0x20040080,
                0x5000: 0x1000080,
                0x6000: 0x21000080,
                0x7000: 0x40080,
                0x8000: 0x1000000,
                0x9000: 0x20040000,
                0xa000: 0x20000080,
                0xb000: 0x21040080,
                0xc000: 0x21040000,
                0xd000: 0x0,
                0xe000: 0x1040080,
                0xf000: 0x21000000,
                0x800: 0x1040080,
                0x1800: 0x21000080,
                0x2800: 0x80,
                0x3800: 0x1040000,
                0x4800: 0x40000,
                0x5800: 0x20040080,
                0x6800: 0x21040000,
                0x7800: 0x20000000,
                0x8800: 0x20040000,
                0x9800: 0x0,
                0xa800: 0x21040080,
                0xb800: 0x1000080,
                0xc800: 0x20000080,
                0xd800: 0x21000000,
                0xe800: 0x1000000,
                0xf800: 0x40080,
                0x10000: 0x40000,
                0x11000: 0x80,
                0x12000: 0x20000000,
                0x13000: 0x21000080,
                0x14000: 0x1000080,
                0x15000: 0x21040000,
                0x16000: 0x20040080,
                0x17000: 0x1000000,
                0x18000: 0x21040080,
                0x19000: 0x21000000,
                0x1a000: 0x1040000,
                0x1b000: 0x20040000,
                0x1c000: 0x40080,
                0x1d000: 0x20000080,
                0x1e000: 0x0,
                0x1f000: 0x1040080,
                0x10800: 0x21000080,
                0x11800: 0x1000000,
                0x12800: 0x1040000,
                0x13800: 0x20040080,
                0x14800: 0x20000000,
                0x15800: 0x1040080,
                0x16800: 0x80,
                0x17800: 0x21040000,
                0x18800: 0x40080,
                0x19800: 0x21040080,
                0x1a800: 0x0,
                0x1b800: 0x21000000,
                0x1c800: 0x1000080,
                0x1d800: 0x40000,
                0x1e800: 0x20040000,
                0x1f800: 0x20000080
            },
            {
                0x0: 0x10000008,
                0x100: 0x2000,
                0x200: 0x10200000,
                0x300: 0x10202008,
                0x400: 0x10002000,
                0x500: 0x200000,
                0x600: 0x200008,
                0x700: 0x10000000,
                0x800: 0x0,
                0x900: 0x10002008,
                0xa00: 0x202000,
                0xb00: 0x8,
                0xc00: 0x10200008,
                0xd00: 0x202008,
                0xe00: 0x2008,
                0xf00: 0x10202000,
                0x80: 0x10200000,
                0x180: 0x10202008,
                0x280: 0x8,
                0x380: 0x200000,
                0x480: 0x202008,
                0x580: 0x10000008,
                0x680: 0x10002000,
                0x780: 0x2008,
                0x880: 0x200008,
                0x980: 0x2000,
                0xa80: 0x10002008,
                0xb80: 0x10200008,
                0xc80: 0x0,
                0xd80: 0x10202000,
                0xe80: 0x202000,
                0xf80: 0x10000000,
                0x1000: 0x10002000,
                0x1100: 0x10200008,
                0x1200: 0x10202008,
                0x1300: 0x2008,
                0x1400: 0x200000,
                0x1500: 0x10000000,
                0x1600: 0x10000008,
                0x1700: 0x202000,
                0x1800: 0x202008,
                0x1900: 0x0,
                0x1a00: 0x8,
                0x1b00: 0x10200000,
                0x1c00: 0x2000,
                0x1d00: 0x10002008,
                0x1e00: 0x10202000,
                0x1f00: 0x200008,
                0x1080: 0x8,
                0x1180: 0x202000,
                0x1280: 0x200000,
                0x1380: 0x10000008,
                0x1480: 0x10002000,
                0x1580: 0x2008,
                0x1680: 0x10202008,
                0x1780: 0x10200000,
                0x1880: 0x10202000,
                0x1980: 0x10200008,
                0x1a80: 0x2000,
                0x1b80: 0x202008,
                0x1c80: 0x200008,
                0x1d80: 0x0,
                0x1e80: 0x10000000,
                0x1f80: 0x10002008
            },
            {
                0x0: 0x100000,
                0x10: 0x2000401,
                0x20: 0x400,
                0x30: 0x100401,
                0x40: 0x2100401,
                0x50: 0x0,
                0x60: 0x1,
                0x70: 0x2100001,
                0x80: 0x2000400,
                0x90: 0x100001,
                0xa0: 0x2000001,
                0xb0: 0x2100400,
                0xc0: 0x2100000,
                0xd0: 0x401,
                0xe0: 0x100400,
                0xf0: 0x2000000,
                0x8: 0x2100001,
                0x18: 0x0,
                0x28: 0x2000401,
                0x38: 0x2100400,
                0x48: 0x100000,
                0x58: 0x2000001,
                0x68: 0x2000000,
                0x78: 0x401,
                0x88: 0x100401,
                0x98: 0x2000400,
                0xa8: 0x2100000,
                0xb8: 0x100001,
                0xc8: 0x400,
                0xd8: 0x2100401,
                0xe8: 0x1,
                0xf8: 0x100400,
                0x100: 0x2000000,
                0x110: 0x100000,
                0x120: 0x2000401,
                0x130: 0x2100001,
                0x140: 0x100001,
                0x150: 0x2000400,
                0x160: 0x2100400,
                0x170: 0x100401,
                0x180: 0x401,
                0x190: 0x2100401,
                0x1a0: 0x100400,
                0x1b0: 0x1,
                0x1c0: 0x0,
                0x1d0: 0x2100000,
                0x1e0: 0x2000001,
                0x1f0: 0x400,
                0x108: 0x100400,
                0x118: 0x2000401,
                0x128: 0x2100001,
                0x138: 0x1,
                0x148: 0x2000000,
                0x158: 0x100000,
                0x168: 0x401,
                0x178: 0x2100400,
                0x188: 0x2000001,
                0x198: 0x2100000,
                0x1a8: 0x0,
                0x1b8: 0x2100401,
                0x1c8: 0x100401,
                0x1d8: 0x400,
                0x1e8: 0x2000400,
                0x1f8: 0x100001
            },
            {
                0x0: 0x8000820,
                0x1: 0x20000,
                0x2: 0x8000000,
                0x3: 0x20,
                0x4: 0x20020,
                0x5: 0x8020820,
                0x6: 0x8020800,
                0x7: 0x800,
                0x8: 0x8020000,
                0x9: 0x8000800,
                0xa: 0x20800,
                0xb: 0x8020020,
                0xc: 0x820,
                0xd: 0x0,
                0xe: 0x8000020,
                0xf: 0x20820,
                0x80000000: 0x800,
                0x80000001: 0x8020820,
                0x80000002: 0x8000820,
                0x80000003: 0x8000000,
                0x80000004: 0x8020000,
                0x80000005: 0x20800,
                0x80000006: 0x20820,
                0x80000007: 0x20,
                0x80000008: 0x8000020,
                0x80000009: 0x820,
                0x8000000a: 0x20020,
                0x8000000b: 0x8020800,
                0x8000000c: 0x0,
                0x8000000d: 0x8020020,
                0x8000000e: 0x8000800,
                0x8000000f: 0x20000,
                0x10: 0x20820,
                0x11: 0x8020800,
                0x12: 0x20,
                0x13: 0x800,
                0x14: 0x8000800,
                0x15: 0x8000020,
                0x16: 0x8020020,
                0x17: 0x20000,
                0x18: 0x0,
                0x19: 0x20020,
                0x1a: 0x8020000,
                0x1b: 0x8000820,
                0x1c: 0x8020820,
                0x1d: 0x20800,
                0x1e: 0x820,
                0x1f: 0x8000000,
                0x80000010: 0x20000,
                0x80000011: 0x800,
                0x80000012: 0x8020020,
                0x80000013: 0x20820,
                0x80000014: 0x20,
                0x80000015: 0x8020000,
                0x80000016: 0x8000000,
                0x80000017: 0x8000820,
                0x80000018: 0x8020820,
                0x80000019: 0x8000020,
                0x8000001a: 0x8000800,
                0x8000001b: 0x0,
                0x8000001c: 0x20800,
                0x8000001d: 0x820,
                0x8000001e: 0x20020,
                0x8000001f: 0x8020800
            }
        ];
        // Masks that select the SBOX input
        var SBOX_MASK = [
            0xf8000001,
            0x1f800000,
            0x01f80000,
            0x001f8000,
            0x0001f800,
            0x00001f80,
            0x000001f8,
            0x8000001f
        ];
        /**
	     * DES block cipher algorithm.
	     */ var DES = C_algo.DES = BlockCipher.extend({
            _doReset: function() {
                // Shortcuts
                var key = this._key;
                var keyWords = key.words;
                // Select 56 bits according to PC1
                var keyBits = [];
                for(var i = 0; i < 56; i++){
                    var keyBitPos = PC1[i] - 1;
                    keyBits[i] = keyWords[keyBitPos >>> 5] >>> 31 - keyBitPos % 32 & 1;
                }
                // Assemble 16 subkeys
                var subKeys = this._subKeys = [];
                for(var nSubKey = 0; nSubKey < 16; nSubKey++){
                    // Create subkey
                    var subKey = subKeys[nSubKey] = [];
                    // Shortcut
                    var bitShift = BIT_SHIFTS[nSubKey];
                    // Select 48 bits according to PC2
                    for(var i = 0; i < 24; i++){
                        // Select from the left 28 key bits
                        subKey[i / 6 | 0] |= keyBits[(PC2[i] - 1 + bitShift) % 28] << 31 - i % 6;
                        // Select from the right 28 key bits
                        subKey[4 + (i / 6 | 0)] |= keyBits[28 + (PC2[i + 24] - 1 + bitShift) % 28] << 31 - i % 6;
                    }
                    // Since each subkey is applied to an expanded 32-bit input,
                    // the subkey can be broken into 8 values scaled to 32-bits,
                    // which allows the key to be used without expansion
                    subKey[0] = subKey[0] << 1 | subKey[0] >>> 31;
                    for(var i = 1; i < 7; i++)subKey[i] = subKey[i] >>> (i - 1) * 4 + 3;
                    subKey[7] = subKey[7] << 5 | subKey[7] >>> 27;
                }
                // Compute inverse subkeys
                var invSubKeys = this._invSubKeys = [];
                for(var i = 0; i < 16; i++)invSubKeys[i] = subKeys[15 - i];
            },
            encryptBlock: function(M, offset) {
                this._doCryptBlock(M, offset, this._subKeys);
            },
            decryptBlock: function(M, offset) {
                this._doCryptBlock(M, offset, this._invSubKeys);
            },
            _doCryptBlock: function(M, offset, subKeys) {
                // Get input
                this._lBlock = M[offset];
                this._rBlock = M[offset + 1];
                // Initial permutation
                exchangeLR.call(this, 4, 0x0f0f0f0f);
                exchangeLR.call(this, 16, 0x0000ffff);
                exchangeRL.call(this, 2, 0x33333333);
                exchangeRL.call(this, 8, 0x00ff00ff);
                exchangeLR.call(this, 1, 0x55555555);
                // Rounds
                for(var round = 0; round < 16; round++){
                    // Shortcuts
                    var subKey = subKeys[round];
                    var lBlock = this._lBlock;
                    var rBlock = this._rBlock;
                    // Feistel function
                    var f = 0;
                    for(var i = 0; i < 8; i++)f |= SBOX_P[i][((rBlock ^ subKey[i]) & SBOX_MASK[i]) >>> 0];
                    this._lBlock = rBlock;
                    this._rBlock = lBlock ^ f;
                }
                // Undo swap from last round
                var t = this._lBlock;
                this._lBlock = this._rBlock;
                this._rBlock = t;
                // Final permutation
                exchangeLR.call(this, 1, 0x55555555);
                exchangeRL.call(this, 8, 0x00ff00ff);
                exchangeRL.call(this, 2, 0x33333333);
                exchangeLR.call(this, 16, 0x0000ffff);
                exchangeLR.call(this, 4, 0x0f0f0f0f);
                // Set output
                M[offset] = this._lBlock;
                M[offset + 1] = this._rBlock;
            },
            keySize: 2,
            ivSize: 2,
            blockSize: 2
        });
        // Swap bits across the left and right words
        function exchangeLR(offset, mask) {
            var t = (this._lBlock >>> offset ^ this._rBlock) & mask;
            this._rBlock ^= t;
            this._lBlock ^= t << offset;
        }
        function exchangeRL(offset, mask) {
            var t = (this._rBlock >>> offset ^ this._lBlock) & mask;
            this._lBlock ^= t;
            this._rBlock ^= t << offset;
        }
        /**
	     * Shortcut functions to the cipher's object interface.
	     *
	     * @example
	     *
	     *     var ciphertext = CryptoJS.DES.encrypt(message, key, cfg);
	     *     var plaintext  = CryptoJS.DES.decrypt(ciphertext, key, cfg);
	     */ C.DES = BlockCipher._createHelper(DES);
        /**
	     * Triple-DES block cipher algorithm.
	     */ var TripleDES = C_algo.TripleDES = BlockCipher.extend({
            _doReset: function() {
                // Shortcuts
                var key = this._key;
                var keyWords = key.words;
                // Make sure the key length is valid (64, 128 or >= 192 bit)
                if (keyWords.length !== 2 && keyWords.length !== 4 && keyWords.length < 6) throw new Error("Invalid key length - 3DES requires the key length to be 64, 128, 192 or >192.");
                // Extend the key according to the keying options defined in 3DES standard
                var key1 = keyWords.slice(0, 2);
                var key2 = keyWords.length < 4 ? keyWords.slice(0, 2) : keyWords.slice(2, 4);
                var key3 = keyWords.length < 6 ? keyWords.slice(0, 2) : keyWords.slice(4, 6);
                // Create DES instances
                this._des1 = DES.createEncryptor(WordArray.create(key1));
                this._des2 = DES.createEncryptor(WordArray.create(key2));
                this._des3 = DES.createEncryptor(WordArray.create(key3));
            },
            encryptBlock: function(M, offset) {
                this._des1.encryptBlock(M, offset);
                this._des2.decryptBlock(M, offset);
                this._des3.encryptBlock(M, offset);
            },
            decryptBlock: function(M, offset) {
                this._des3.decryptBlock(M, offset);
                this._des2.encryptBlock(M, offset);
                this._des1.decryptBlock(M, offset);
            },
            keySize: 6,
            ivSize: 2,
            blockSize: 2
        });
        /**
	     * Shortcut functions to the cipher's object interface.
	     *
	     * @example
	     *
	     *     var ciphertext = CryptoJS.TripleDES.encrypt(message, key, cfg);
	     *     var plaintext  = CryptoJS.TripleDES.decrypt(ciphertext, key, cfg);
	     */ C.TripleDES = BlockCipher._createHelper(TripleDES);
    })();
    return CryptoJS.TripleDES;
});

});

parcelRequire.register("1sYM8", function(module, exports) {





(function(root, factory, undef) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("cfaDk")), (parcelRequire("500SS")), (parcelRequire("6oXxt")), (parcelRequire("ioEPr")), (parcelRequire("fctwD")));
})(this, function(CryptoJS) {
    (function() {
        // Shortcuts
        var C = CryptoJS;
        var C_lib = C.lib;
        var StreamCipher = C_lib.StreamCipher;
        var C_algo = C.algo;
        /**
	     * RC4 stream cipher algorithm.
	     */ var RC4 = C_algo.RC4 = StreamCipher.extend({
            _doReset: function() {
                // Shortcuts
                var key = this._key;
                var keyWords = key.words;
                var keySigBytes = key.sigBytes;
                // Init sbox
                var S = this._S = [];
                for(var i = 0; i < 256; i++)S[i] = i;
                // Key setup
                for(var i = 0, j = 0; i < 256; i++){
                    var keyByteIndex = i % keySigBytes;
                    var keyByte = keyWords[keyByteIndex >>> 2] >>> 24 - keyByteIndex % 4 * 8 & 0xff;
                    j = (j + S[i] + keyByte) % 256;
                    // Swap
                    var t = S[i];
                    S[i] = S[j];
                    S[j] = t;
                }
                // Counters
                this._i = this._j = 0;
            },
            _doProcessBlock: function(M, offset) {
                M[offset] ^= generateKeystreamWord.call(this);
            },
            keySize: 8,
            ivSize: 0
        });
        function generateKeystreamWord() {
            // Shortcuts
            var S = this._S;
            var i = this._i;
            var j = this._j;
            // Generate keystream word
            var keystreamWord = 0;
            for(var n = 0; n < 4; n++){
                i = (i + 1) % 256;
                j = (j + S[i]) % 256;
                // Swap
                var t = S[i];
                S[i] = S[j];
                S[j] = t;
                keystreamWord |= S[(S[i] + S[j]) % 256] << 24 - n * 8;
            }
            // Update counters
            this._i = i;
            this._j = j;
            return keystreamWord;
        }
        /**
	     * Shortcut functions to the cipher's object interface.
	     *
	     * @example
	     *
	     *     var ciphertext = CryptoJS.RC4.encrypt(message, key, cfg);
	     *     var plaintext  = CryptoJS.RC4.decrypt(ciphertext, key, cfg);
	     */ C.RC4 = StreamCipher._createHelper(RC4);
        /**
	     * Modified RC4 stream cipher algorithm.
	     */ var RC4Drop = C_algo.RC4Drop = RC4.extend({
            /**
	         * Configuration options.
	         *
	         * @property {number} drop The number of keystream words to drop. Default 192
	         */ cfg: RC4.cfg.extend({
                drop: 192
            }),
            _doReset: function() {
                RC4._doReset.call(this);
                // Drop
                for(var i = this.cfg.drop; i > 0; i--)generateKeystreamWord.call(this);
            }
        });
        /**
	     * Shortcut functions to the cipher's object interface.
	     *
	     * @example
	     *
	     *     var ciphertext = CryptoJS.RC4Drop.encrypt(message, key, cfg);
	     *     var plaintext  = CryptoJS.RC4Drop.decrypt(ciphertext, key, cfg);
	     */ C.RC4Drop = StreamCipher._createHelper(RC4Drop);
    })();
    return CryptoJS.RC4;
});

});

parcelRequire.register("hUv46", function(module, exports) {





(function(root, factory, undef) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("cfaDk")), (parcelRequire("500SS")), (parcelRequire("6oXxt")), (parcelRequire("ioEPr")), (parcelRequire("fctwD")));
})(this, function(CryptoJS) {
    (function() {
        // Shortcuts
        var C = CryptoJS;
        var C_lib = C.lib;
        var StreamCipher = C_lib.StreamCipher;
        var C_algo = C.algo;
        // Reusable objects
        var S = [];
        var C_ = [];
        var G = [];
        /**
	     * Rabbit stream cipher algorithm
	     */ var Rabbit = C_algo.Rabbit = StreamCipher.extend({
            _doReset: function() {
                // Shortcuts
                var K = this._key.words;
                var iv = this.cfg.iv;
                // Swap endian
                for(var i = 0; i < 4; i++)K[i] = (K[i] << 8 | K[i] >>> 24) & 0x00ff00ff | (K[i] << 24 | K[i] >>> 8) & 0xff00ff00;
                // Generate initial state values
                var X = this._X = [
                    K[0],
                    K[3] << 16 | K[2] >>> 16,
                    K[1],
                    K[0] << 16 | K[3] >>> 16,
                    K[2],
                    K[1] << 16 | K[0] >>> 16,
                    K[3],
                    K[2] << 16 | K[1] >>> 16
                ];
                // Generate initial counter values
                var C = this._C = [
                    K[2] << 16 | K[2] >>> 16,
                    K[0] & 0xffff0000 | K[1] & 0x0000ffff,
                    K[3] << 16 | K[3] >>> 16,
                    K[1] & 0xffff0000 | K[2] & 0x0000ffff,
                    K[0] << 16 | K[0] >>> 16,
                    K[2] & 0xffff0000 | K[3] & 0x0000ffff,
                    K[1] << 16 | K[1] >>> 16,
                    K[3] & 0xffff0000 | K[0] & 0x0000ffff
                ];
                // Carry bit
                this._b = 0;
                // Iterate the system four times
                for(var i = 0; i < 4; i++)nextState.call(this);
                // Modify the counters
                for(var i = 0; i < 8; i++)C[i] ^= X[i + 4 & 7];
                // IV setup
                if (iv) {
                    // Shortcuts
                    var IV = iv.words;
                    var IV_0 = IV[0];
                    var IV_1 = IV[1];
                    // Generate four subvectors
                    var i0 = (IV_0 << 8 | IV_0 >>> 24) & 0x00ff00ff | (IV_0 << 24 | IV_0 >>> 8) & 0xff00ff00;
                    var i2 = (IV_1 << 8 | IV_1 >>> 24) & 0x00ff00ff | (IV_1 << 24 | IV_1 >>> 8) & 0xff00ff00;
                    var i1 = i0 >>> 16 | i2 & 0xffff0000;
                    var i3 = i2 << 16 | i0 & 0x0000ffff;
                    // Modify counter values
                    C[0] ^= i0;
                    C[1] ^= i1;
                    C[2] ^= i2;
                    C[3] ^= i3;
                    C[4] ^= i0;
                    C[5] ^= i1;
                    C[6] ^= i2;
                    C[7] ^= i3;
                    // Iterate the system four times
                    for(var i = 0; i < 4; i++)nextState.call(this);
                }
            },
            _doProcessBlock: function(M, offset) {
                // Shortcut
                var X = this._X;
                // Iterate the system
                nextState.call(this);
                // Generate four keystream words
                S[0] = X[0] ^ X[5] >>> 16 ^ X[3] << 16;
                S[1] = X[2] ^ X[7] >>> 16 ^ X[5] << 16;
                S[2] = X[4] ^ X[1] >>> 16 ^ X[7] << 16;
                S[3] = X[6] ^ X[3] >>> 16 ^ X[1] << 16;
                for(var i = 0; i < 4; i++){
                    // Swap endian
                    S[i] = (S[i] << 8 | S[i] >>> 24) & 0x00ff00ff | (S[i] << 24 | S[i] >>> 8) & 0xff00ff00;
                    // Encrypt
                    M[offset + i] ^= S[i];
                }
            },
            blockSize: 4,
            ivSize: 2
        });
        function nextState() {
            // Shortcuts
            var X = this._X;
            var C = this._C;
            // Save old counter values
            for(var i = 0; i < 8; i++)C_[i] = C[i];
            // Calculate new counter values
            C[0] = C[0] + 0x4d34d34d + this._b | 0;
            C[1] = C[1] + 0xd34d34d3 + (C[0] >>> 0 < C_[0] >>> 0 ? 1 : 0) | 0;
            C[2] = C[2] + 0x34d34d34 + (C[1] >>> 0 < C_[1] >>> 0 ? 1 : 0) | 0;
            C[3] = C[3] + 0x4d34d34d + (C[2] >>> 0 < C_[2] >>> 0 ? 1 : 0) | 0;
            C[4] = C[4] + 0xd34d34d3 + (C[3] >>> 0 < C_[3] >>> 0 ? 1 : 0) | 0;
            C[5] = C[5] + 0x34d34d34 + (C[4] >>> 0 < C_[4] >>> 0 ? 1 : 0) | 0;
            C[6] = C[6] + 0x4d34d34d + (C[5] >>> 0 < C_[5] >>> 0 ? 1 : 0) | 0;
            C[7] = C[7] + 0xd34d34d3 + (C[6] >>> 0 < C_[6] >>> 0 ? 1 : 0) | 0;
            this._b = C[7] >>> 0 < C_[7] >>> 0 ? 1 : 0;
            // Calculate the g-values
            for(var i = 0; i < 8; i++){
                var gx = X[i] + C[i];
                // Construct high and low argument for squaring
                var ga = gx & 0xffff;
                var gb = gx >>> 16;
                // Calculate high and low result of squaring
                var gh = ((ga * ga >>> 17) + ga * gb >>> 15) + gb * gb;
                var gl = ((gx & 0xffff0000) * gx | 0) + ((gx & 0x0000ffff) * gx | 0);
                // High XOR low
                G[i] = gh ^ gl;
            }
            // Calculate new state values
            X[0] = G[0] + (G[7] << 16 | G[7] >>> 16) + (G[6] << 16 | G[6] >>> 16) | 0;
            X[1] = G[1] + (G[0] << 8 | G[0] >>> 24) + G[7] | 0;
            X[2] = G[2] + (G[1] << 16 | G[1] >>> 16) + (G[0] << 16 | G[0] >>> 16) | 0;
            X[3] = G[3] + (G[2] << 8 | G[2] >>> 24) + G[1] | 0;
            X[4] = G[4] + (G[3] << 16 | G[3] >>> 16) + (G[2] << 16 | G[2] >>> 16) | 0;
            X[5] = G[5] + (G[4] << 8 | G[4] >>> 24) + G[3] | 0;
            X[6] = G[6] + (G[5] << 16 | G[5] >>> 16) + (G[4] << 16 | G[4] >>> 16) | 0;
            X[7] = G[7] + (G[6] << 8 | G[6] >>> 24) + G[5] | 0;
        }
        /**
	     * Shortcut functions to the cipher's object interface.
	     *
	     * @example
	     *
	     *     var ciphertext = CryptoJS.Rabbit.encrypt(message, key, cfg);
	     *     var plaintext  = CryptoJS.Rabbit.decrypt(ciphertext, key, cfg);
	     */ C.Rabbit = StreamCipher._createHelper(Rabbit);
    })();
    return CryptoJS.Rabbit;
});

});

parcelRequire.register("3ybbi", function(module, exports) {





(function(root, factory, undef) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("cfaDk")), (parcelRequire("500SS")), (parcelRequire("6oXxt")), (parcelRequire("ioEPr")), (parcelRequire("fctwD")));
})(this, function(CryptoJS) {
    (function() {
        // Shortcuts
        var C = CryptoJS;
        var C_lib = C.lib;
        var StreamCipher = C_lib.StreamCipher;
        var C_algo = C.algo;
        // Reusable objects
        var S = [];
        var C_ = [];
        var G = [];
        /**
	     * Rabbit stream cipher algorithm.
	     *
	     * This is a legacy version that neglected to convert the key to little-endian.
	     * This error doesn't affect the cipher's security,
	     * but it does affect its compatibility with other implementations.
	     */ var RabbitLegacy = C_algo.RabbitLegacy = StreamCipher.extend({
            _doReset: function() {
                // Shortcuts
                var K = this._key.words;
                var iv = this.cfg.iv;
                // Generate initial state values
                var X = this._X = [
                    K[0],
                    K[3] << 16 | K[2] >>> 16,
                    K[1],
                    K[0] << 16 | K[3] >>> 16,
                    K[2],
                    K[1] << 16 | K[0] >>> 16,
                    K[3],
                    K[2] << 16 | K[1] >>> 16
                ];
                // Generate initial counter values
                var C = this._C = [
                    K[2] << 16 | K[2] >>> 16,
                    K[0] & 0xffff0000 | K[1] & 0x0000ffff,
                    K[3] << 16 | K[3] >>> 16,
                    K[1] & 0xffff0000 | K[2] & 0x0000ffff,
                    K[0] << 16 | K[0] >>> 16,
                    K[2] & 0xffff0000 | K[3] & 0x0000ffff,
                    K[1] << 16 | K[1] >>> 16,
                    K[3] & 0xffff0000 | K[0] & 0x0000ffff
                ];
                // Carry bit
                this._b = 0;
                // Iterate the system four times
                for(var i = 0; i < 4; i++)nextState.call(this);
                // Modify the counters
                for(var i = 0; i < 8; i++)C[i] ^= X[i + 4 & 7];
                // IV setup
                if (iv) {
                    // Shortcuts
                    var IV = iv.words;
                    var IV_0 = IV[0];
                    var IV_1 = IV[1];
                    // Generate four subvectors
                    var i0 = (IV_0 << 8 | IV_0 >>> 24) & 0x00ff00ff | (IV_0 << 24 | IV_0 >>> 8) & 0xff00ff00;
                    var i2 = (IV_1 << 8 | IV_1 >>> 24) & 0x00ff00ff | (IV_1 << 24 | IV_1 >>> 8) & 0xff00ff00;
                    var i1 = i0 >>> 16 | i2 & 0xffff0000;
                    var i3 = i2 << 16 | i0 & 0x0000ffff;
                    // Modify counter values
                    C[0] ^= i0;
                    C[1] ^= i1;
                    C[2] ^= i2;
                    C[3] ^= i3;
                    C[4] ^= i0;
                    C[5] ^= i1;
                    C[6] ^= i2;
                    C[7] ^= i3;
                    // Iterate the system four times
                    for(var i = 0; i < 4; i++)nextState.call(this);
                }
            },
            _doProcessBlock: function(M, offset) {
                // Shortcut
                var X = this._X;
                // Iterate the system
                nextState.call(this);
                // Generate four keystream words
                S[0] = X[0] ^ X[5] >>> 16 ^ X[3] << 16;
                S[1] = X[2] ^ X[7] >>> 16 ^ X[5] << 16;
                S[2] = X[4] ^ X[1] >>> 16 ^ X[7] << 16;
                S[3] = X[6] ^ X[3] >>> 16 ^ X[1] << 16;
                for(var i = 0; i < 4; i++){
                    // Swap endian
                    S[i] = (S[i] << 8 | S[i] >>> 24) & 0x00ff00ff | (S[i] << 24 | S[i] >>> 8) & 0xff00ff00;
                    // Encrypt
                    M[offset + i] ^= S[i];
                }
            },
            blockSize: 4,
            ivSize: 2
        });
        function nextState() {
            // Shortcuts
            var X = this._X;
            var C = this._C;
            // Save old counter values
            for(var i = 0; i < 8; i++)C_[i] = C[i];
            // Calculate new counter values
            C[0] = C[0] + 0x4d34d34d + this._b | 0;
            C[1] = C[1] + 0xd34d34d3 + (C[0] >>> 0 < C_[0] >>> 0 ? 1 : 0) | 0;
            C[2] = C[2] + 0x34d34d34 + (C[1] >>> 0 < C_[1] >>> 0 ? 1 : 0) | 0;
            C[3] = C[3] + 0x4d34d34d + (C[2] >>> 0 < C_[2] >>> 0 ? 1 : 0) | 0;
            C[4] = C[4] + 0xd34d34d3 + (C[3] >>> 0 < C_[3] >>> 0 ? 1 : 0) | 0;
            C[5] = C[5] + 0x34d34d34 + (C[4] >>> 0 < C_[4] >>> 0 ? 1 : 0) | 0;
            C[6] = C[6] + 0x4d34d34d + (C[5] >>> 0 < C_[5] >>> 0 ? 1 : 0) | 0;
            C[7] = C[7] + 0xd34d34d3 + (C[6] >>> 0 < C_[6] >>> 0 ? 1 : 0) | 0;
            this._b = C[7] >>> 0 < C_[7] >>> 0 ? 1 : 0;
            // Calculate the g-values
            for(var i = 0; i < 8; i++){
                var gx = X[i] + C[i];
                // Construct high and low argument for squaring
                var ga = gx & 0xffff;
                var gb = gx >>> 16;
                // Calculate high and low result of squaring
                var gh = ((ga * ga >>> 17) + ga * gb >>> 15) + gb * gb;
                var gl = ((gx & 0xffff0000) * gx | 0) + ((gx & 0x0000ffff) * gx | 0);
                // High XOR low
                G[i] = gh ^ gl;
            }
            // Calculate new state values
            X[0] = G[0] + (G[7] << 16 | G[7] >>> 16) + (G[6] << 16 | G[6] >>> 16) | 0;
            X[1] = G[1] + (G[0] << 8 | G[0] >>> 24) + G[7] | 0;
            X[2] = G[2] + (G[1] << 16 | G[1] >>> 16) + (G[0] << 16 | G[0] >>> 16) | 0;
            X[3] = G[3] + (G[2] << 8 | G[2] >>> 24) + G[1] | 0;
            X[4] = G[4] + (G[3] << 16 | G[3] >>> 16) + (G[2] << 16 | G[2] >>> 16) | 0;
            X[5] = G[5] + (G[4] << 8 | G[4] >>> 24) + G[3] | 0;
            X[6] = G[6] + (G[5] << 16 | G[5] >>> 16) + (G[4] << 16 | G[4] >>> 16) | 0;
            X[7] = G[7] + (G[6] << 8 | G[6] >>> 24) + G[5] | 0;
        }
        /**
	     * Shortcut functions to the cipher's object interface.
	     *
	     * @example
	     *
	     *     var ciphertext = CryptoJS.RabbitLegacy.encrypt(message, key, cfg);
	     *     var plaintext  = CryptoJS.RabbitLegacy.decrypt(ciphertext, key, cfg);
	     */ C.RabbitLegacy = StreamCipher._createHelper(RabbitLegacy);
    })();
    return CryptoJS.RabbitLegacy;
});

});

parcelRequire.register("f4sF8", function(module, exports) {





(function(root, factory, undef) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("cfaDk")), (parcelRequire("500SS")), (parcelRequire("6oXxt")), (parcelRequire("ioEPr")), (parcelRequire("fctwD")));
})(this, function(CryptoJS) {
    (function() {
        // Shortcuts
        var C = CryptoJS;
        var C_lib = C.lib;
        var BlockCipher = C_lib.BlockCipher;
        var C_algo = C.algo;
        const N = 16;
        //Origin pbox and sbox, derived from PI
        const ORIG_P = [
            0x243F6A88,
            0x85A308D3,
            0x13198A2E,
            0x03707344,
            0xA4093822,
            0x299F31D0,
            0x082EFA98,
            0xEC4E6C89,
            0x452821E6,
            0x38D01377,
            0xBE5466CF,
            0x34E90C6C,
            0xC0AC29B7,
            0xC97C50DD,
            0x3F84D5B5,
            0xB5470917,
            0x9216D5D9,
            0x8979FB1B
        ];
        const ORIG_S = [
            [
                0xD1310BA6,
                0x98DFB5AC,
                0x2FFD72DB,
                0xD01ADFB7,
                0xB8E1AFED,
                0x6A267E96,
                0xBA7C9045,
                0xF12C7F99,
                0x24A19947,
                0xB3916CF7,
                0x0801F2E2,
                0x858EFC16,
                0x636920D8,
                0x71574E69,
                0xA458FEA3,
                0xF4933D7E,
                0x0D95748F,
                0x728EB658,
                0x718BCD58,
                0x82154AEE,
                0x7B54A41D,
                0xC25A59B5,
                0x9C30D539,
                0x2AF26013,
                0xC5D1B023,
                0x286085F0,
                0xCA417918,
                0xB8DB38EF,
                0x8E79DCB0,
                0x603A180E,
                0x6C9E0E8B,
                0xB01E8A3E,
                0xD71577C1,
                0xBD314B27,
                0x78AF2FDA,
                0x55605C60,
                0xE65525F3,
                0xAA55AB94,
                0x57489862,
                0x63E81440,
                0x55CA396A,
                0x2AAB10B6,
                0xB4CC5C34,
                0x1141E8CE,
                0xA15486AF,
                0x7C72E993,
                0xB3EE1411,
                0x636FBC2A,
                0x2BA9C55D,
                0x741831F6,
                0xCE5C3E16,
                0x9B87931E,
                0xAFD6BA33,
                0x6C24CF5C,
                0x7A325381,
                0x28958677,
                0x3B8F4898,
                0x6B4BB9AF,
                0xC4BFE81B,
                0x66282193,
                0x61D809CC,
                0xFB21A991,
                0x487CAC60,
                0x5DEC8032,
                0xEF845D5D,
                0xE98575B1,
                0xDC262302,
                0xEB651B88,
                0x23893E81,
                0xD396ACC5,
                0x0F6D6FF3,
                0x83F44239,
                0x2E0B4482,
                0xA4842004,
                0x69C8F04A,
                0x9E1F9B5E,
                0x21C66842,
                0xF6E96C9A,
                0x670C9C61,
                0xABD388F0,
                0x6A51A0D2,
                0xD8542F68,
                0x960FA728,
                0xAB5133A3,
                0x6EEF0B6C,
                0x137A3BE4,
                0xBA3BF050,
                0x7EFB2A98,
                0xA1F1651D,
                0x39AF0176,
                0x66CA593E,
                0x82430E88,
                0x8CEE8619,
                0x456F9FB4,
                0x7D84A5C3,
                0x3B8B5EBE,
                0xE06F75D8,
                0x85C12073,
                0x401A449F,
                0x56C16AA6,
                0x4ED3AA62,
                0x363F7706,
                0x1BFEDF72,
                0x429B023D,
                0x37D0D724,
                0xD00A1248,
                0xDB0FEAD3,
                0x49F1C09B,
                0x075372C9,
                0x80991B7B,
                0x25D479D8,
                0xF6E8DEF7,
                0xE3FE501A,
                0xB6794C3B,
                0x976CE0BD,
                0x04C006BA,
                0xC1A94FB6,
                0x409F60C4,
                0x5E5C9EC2,
                0x196A2463,
                0x68FB6FAF,
                0x3E6C53B5,
                0x1339B2EB,
                0x3B52EC6F,
                0x6DFC511F,
                0x9B30952C,
                0xCC814544,
                0xAF5EBD09,
                0xBEE3D004,
                0xDE334AFD,
                0x660F2807,
                0x192E4BB3,
                0xC0CBA857,
                0x45C8740F,
                0xD20B5F39,
                0xB9D3FBDB,
                0x5579C0BD,
                0x1A60320A,
                0xD6A100C6,
                0x402C7279,
                0x679F25FE,
                0xFB1FA3CC,
                0x8EA5E9F8,
                0xDB3222F8,
                0x3C7516DF,
                0xFD616B15,
                0x2F501EC8,
                0xAD0552AB,
                0x323DB5FA,
                0xFD238760,
                0x53317B48,
                0x3E00DF82,
                0x9E5C57BB,
                0xCA6F8CA0,
                0x1A87562E,
                0xDF1769DB,
                0xD542A8F6,
                0x287EFFC3,
                0xAC6732C6,
                0x8C4F5573,
                0x695B27B0,
                0xBBCA58C8,
                0xE1FFA35D,
                0xB8F011A0,
                0x10FA3D98,
                0xFD2183B8,
                0x4AFCB56C,
                0x2DD1D35B,
                0x9A53E479,
                0xB6F84565,
                0xD28E49BC,
                0x4BFB9790,
                0xE1DDF2DA,
                0xA4CB7E33,
                0x62FB1341,
                0xCEE4C6E8,
                0xEF20CADA,
                0x36774C01,
                0xD07E9EFE,
                0x2BF11FB4,
                0x95DBDA4D,
                0xAE909198,
                0xEAAD8E71,
                0x6B93D5A0,
                0xD08ED1D0,
                0xAFC725E0,
                0x8E3C5B2F,
                0x8E7594B7,
                0x8FF6E2FB,
                0xF2122B64,
                0x8888B812,
                0x900DF01C,
                0x4FAD5EA0,
                0x688FC31C,
                0xD1CFF191,
                0xB3A8C1AD,
                0x2F2F2218,
                0xBE0E1777,
                0xEA752DFE,
                0x8B021FA1,
                0xE5A0CC0F,
                0xB56F74E8,
                0x18ACF3D6,
                0xCE89E299,
                0xB4A84FE0,
                0xFD13E0B7,
                0x7CC43B81,
                0xD2ADA8D9,
                0x165FA266,
                0x80957705,
                0x93CC7314,
                0x211A1477,
                0xE6AD2065,
                0x77B5FA86,
                0xC75442F5,
                0xFB9D35CF,
                0xEBCDAF0C,
                0x7B3E89A0,
                0xD6411BD3,
                0xAE1E7E49,
                0x00250E2D,
                0x2071B35E,
                0x226800BB,
                0x57B8E0AF,
                0x2464369B,
                0xF009B91E,
                0x5563911D,
                0x59DFA6AA,
                0x78C14389,
                0xD95A537F,
                0x207D5BA2,
                0x02E5B9C5,
                0x83260376,
                0x6295CFA9,
                0x11C81968,
                0x4E734A41,
                0xB3472DCA,
                0x7B14A94A,
                0x1B510052,
                0x9A532915,
                0xD60F573F,
                0xBC9BC6E4,
                0x2B60A476,
                0x81E67400,
                0x08BA6FB5,
                0x571BE91F,
                0xF296EC6B,
                0x2A0DD915,
                0xB6636521,
                0xE7B9F9B6,
                0xFF34052E,
                0xC5855664,
                0x53B02D5D,
                0xA99F8FA1,
                0x08BA4799,
                0x6E85076A
            ],
            [
                0x4B7A70E9,
                0xB5B32944,
                0xDB75092E,
                0xC4192623,
                0xAD6EA6B0,
                0x49A7DF7D,
                0x9CEE60B8,
                0x8FEDB266,
                0xECAA8C71,
                0x699A17FF,
                0x5664526C,
                0xC2B19EE1,
                0x193602A5,
                0x75094C29,
                0xA0591340,
                0xE4183A3E,
                0x3F54989A,
                0x5B429D65,
                0x6B8FE4D6,
                0x99F73FD6,
                0xA1D29C07,
                0xEFE830F5,
                0x4D2D38E6,
                0xF0255DC1,
                0x4CDD2086,
                0x8470EB26,
                0x6382E9C6,
                0x021ECC5E,
                0x09686B3F,
                0x3EBAEFC9,
                0x3C971814,
                0x6B6A70A1,
                0x687F3584,
                0x52A0E286,
                0xB79C5305,
                0xAA500737,
                0x3E07841C,
                0x7FDEAE5C,
                0x8E7D44EC,
                0x5716F2B8,
                0xB03ADA37,
                0xF0500C0D,
                0xF01C1F04,
                0x0200B3FF,
                0xAE0CF51A,
                0x3CB574B2,
                0x25837A58,
                0xDC0921BD,
                0xD19113F9,
                0x7CA92FF6,
                0x94324773,
                0x22F54701,
                0x3AE5E581,
                0x37C2DADC,
                0xC8B57634,
                0x9AF3DDA7,
                0xA9446146,
                0x0FD0030E,
                0xECC8C73E,
                0xA4751E41,
                0xE238CD99,
                0x3BEA0E2F,
                0x3280BBA1,
                0x183EB331,
                0x4E548B38,
                0x4F6DB908,
                0x6F420D03,
                0xF60A04BF,
                0x2CB81290,
                0x24977C79,
                0x5679B072,
                0xBCAF89AF,
                0xDE9A771F,
                0xD9930810,
                0xB38BAE12,
                0xDCCF3F2E,
                0x5512721F,
                0x2E6B7124,
                0x501ADDE6,
                0x9F84CD87,
                0x7A584718,
                0x7408DA17,
                0xBC9F9ABC,
                0xE94B7D8C,
                0xEC7AEC3A,
                0xDB851DFA,
                0x63094366,
                0xC464C3D2,
                0xEF1C1847,
                0x3215D908,
                0xDD433B37,
                0x24C2BA16,
                0x12A14D43,
                0x2A65C451,
                0x50940002,
                0x133AE4DD,
                0x71DFF89E,
                0x10314E55,
                0x81AC77D6,
                0x5F11199B,
                0x043556F1,
                0xD7A3C76B,
                0x3C11183B,
                0x5924A509,
                0xF28FE6ED,
                0x97F1FBFA,
                0x9EBABF2C,
                0x1E153C6E,
                0x86E34570,
                0xEAE96FB1,
                0x860E5E0A,
                0x5A3E2AB3,
                0x771FE71C,
                0x4E3D06FA,
                0x2965DCB9,
                0x99E71D0F,
                0x803E89D6,
                0x5266C825,
                0x2E4CC978,
                0x9C10B36A,
                0xC6150EBA,
                0x94E2EA78,
                0xA5FC3C53,
                0x1E0A2DF4,
                0xF2F74EA7,
                0x361D2B3D,
                0x1939260F,
                0x19C27960,
                0x5223A708,
                0xF71312B6,
                0xEBADFE6E,
                0xEAC31F66,
                0xE3BC4595,
                0xA67BC883,
                0xB17F37D1,
                0x018CFF28,
                0xC332DDEF,
                0xBE6C5AA5,
                0x65582185,
                0x68AB9802,
                0xEECEA50F,
                0xDB2F953B,
                0x2AEF7DAD,
                0x5B6E2F84,
                0x1521B628,
                0x29076170,
                0xECDD4775,
                0x619F1510,
                0x13CCA830,
                0xEB61BD96,
                0x0334FE1E,
                0xAA0363CF,
                0xB5735C90,
                0x4C70A239,
                0xD59E9E0B,
                0xCBAADE14,
                0xEECC86BC,
                0x60622CA7,
                0x9CAB5CAB,
                0xB2F3846E,
                0x648B1EAF,
                0x19BDF0CA,
                0xA02369B9,
                0x655ABB50,
                0x40685A32,
                0x3C2AB4B3,
                0x319EE9D5,
                0xC021B8F7,
                0x9B540B19,
                0x875FA099,
                0x95F7997E,
                0x623D7DA8,
                0xF837889A,
                0x97E32D77,
                0x11ED935F,
                0x16681281,
                0x0E358829,
                0xC7E61FD6,
                0x96DEDFA1,
                0x7858BA99,
                0x57F584A5,
                0x1B227263,
                0x9B83C3FF,
                0x1AC24696,
                0xCDB30AEB,
                0x532E3054,
                0x8FD948E4,
                0x6DBC3128,
                0x58EBF2EF,
                0x34C6FFEA,
                0xFE28ED61,
                0xEE7C3C73,
                0x5D4A14D9,
                0xE864B7E3,
                0x42105D14,
                0x203E13E0,
                0x45EEE2B6,
                0xA3AAABEA,
                0xDB6C4F15,
                0xFACB4FD0,
                0xC742F442,
                0xEF6ABBB5,
                0x654F3B1D,
                0x41CD2105,
                0xD81E799E,
                0x86854DC7,
                0xE44B476A,
                0x3D816250,
                0xCF62A1F2,
                0x5B8D2646,
                0xFC8883A0,
                0xC1C7B6A3,
                0x7F1524C3,
                0x69CB7492,
                0x47848A0B,
                0x5692B285,
                0x095BBF00,
                0xAD19489D,
                0x1462B174,
                0x23820E00,
                0x58428D2A,
                0x0C55F5EA,
                0x1DADF43E,
                0x233F7061,
                0x3372F092,
                0x8D937E41,
                0xD65FECF1,
                0x6C223BDB,
                0x7CDE3759,
                0xCBEE7460,
                0x4085F2A7,
                0xCE77326E,
                0xA6078084,
                0x19F8509E,
                0xE8EFD855,
                0x61D99735,
                0xA969A7AA,
                0xC50C06C2,
                0x5A04ABFC,
                0x800BCADC,
                0x9E447A2E,
                0xC3453484,
                0xFDD56705,
                0x0E1E9EC9,
                0xDB73DBD3,
                0x105588CD,
                0x675FDA79,
                0xE3674340,
                0xC5C43465,
                0x713E38D8,
                0x3D28F89E,
                0xF16DFF20,
                0x153E21E7,
                0x8FB03D4A,
                0xE6E39F2B,
                0xDB83ADF7
            ],
            [
                0xE93D5A68,
                0x948140F7,
                0xF64C261C,
                0x94692934,
                0x411520F7,
                0x7602D4F7,
                0xBCF46B2E,
                0xD4A20068,
                0xD4082471,
                0x3320F46A,
                0x43B7D4B7,
                0x500061AF,
                0x1E39F62E,
                0x97244546,
                0x14214F74,
                0xBF8B8840,
                0x4D95FC1D,
                0x96B591AF,
                0x70F4DDD3,
                0x66A02F45,
                0xBFBC09EC,
                0x03BD9785,
                0x7FAC6DD0,
                0x31CB8504,
                0x96EB27B3,
                0x55FD3941,
                0xDA2547E6,
                0xABCA0A9A,
                0x28507825,
                0x530429F4,
                0x0A2C86DA,
                0xE9B66DFB,
                0x68DC1462,
                0xD7486900,
                0x680EC0A4,
                0x27A18DEE,
                0x4F3FFEA2,
                0xE887AD8C,
                0xB58CE006,
                0x7AF4D6B6,
                0xAACE1E7C,
                0xD3375FEC,
                0xCE78A399,
                0x406B2A42,
                0x20FE9E35,
                0xD9F385B9,
                0xEE39D7AB,
                0x3B124E8B,
                0x1DC9FAF7,
                0x4B6D1856,
                0x26A36631,
                0xEAE397B2,
                0x3A6EFA74,
                0xDD5B4332,
                0x6841E7F7,
                0xCA7820FB,
                0xFB0AF54E,
                0xD8FEB397,
                0x454056AC,
                0xBA489527,
                0x55533A3A,
                0x20838D87,
                0xFE6BA9B7,
                0xD096954B,
                0x55A867BC,
                0xA1159A58,
                0xCCA92963,
                0x99E1DB33,
                0xA62A4A56,
                0x3F3125F9,
                0x5EF47E1C,
                0x9029317C,
                0xFDF8E802,
                0x04272F70,
                0x80BB155C,
                0x05282CE3,
                0x95C11548,
                0xE4C66D22,
                0x48C1133F,
                0xC70F86DC,
                0x07F9C9EE,
                0x41041F0F,
                0x404779A4,
                0x5D886E17,
                0x325F51EB,
                0xD59BC0D1,
                0xF2BCC18F,
                0x41113564,
                0x257B7834,
                0x602A9C60,
                0xDFF8E8A3,
                0x1F636C1B,
                0x0E12B4C2,
                0x02E1329E,
                0xAF664FD1,
                0xCAD18115,
                0x6B2395E0,
                0x333E92E1,
                0x3B240B62,
                0xEEBEB922,
                0x85B2A20E,
                0xE6BA0D99,
                0xDE720C8C,
                0x2DA2F728,
                0xD0127845,
                0x95B794FD,
                0x647D0862,
                0xE7CCF5F0,
                0x5449A36F,
                0x877D48FA,
                0xC39DFD27,
                0xF33E8D1E,
                0x0A476341,
                0x992EFF74,
                0x3A6F6EAB,
                0xF4F8FD37,
                0xA812DC60,
                0xA1EBDDF8,
                0x991BE14C,
                0xDB6E6B0D,
                0xC67B5510,
                0x6D672C37,
                0x2765D43B,
                0xDCD0E804,
                0xF1290DC7,
                0xCC00FFA3,
                0xB5390F92,
                0x690FED0B,
                0x667B9FFB,
                0xCEDB7D9C,
                0xA091CF0B,
                0xD9155EA3,
                0xBB132F88,
                0x515BAD24,
                0x7B9479BF,
                0x763BD6EB,
                0x37392EB3,
                0xCC115979,
                0x8026E297,
                0xF42E312D,
                0x6842ADA7,
                0xC66A2B3B,
                0x12754CCC,
                0x782EF11C,
                0x6A124237,
                0xB79251E7,
                0x06A1BBE6,
                0x4BFB6350,
                0x1A6B1018,
                0x11CAEDFA,
                0x3D25BDD8,
                0xE2E1C3C9,
                0x44421659,
                0x0A121386,
                0xD90CEC6E,
                0xD5ABEA2A,
                0x64AF674E,
                0xDA86A85F,
                0xBEBFE988,
                0x64E4C3FE,
                0x9DBC8057,
                0xF0F7C086,
                0x60787BF8,
                0x6003604D,
                0xD1FD8346,
                0xF6381FB0,
                0x7745AE04,
                0xD736FCCC,
                0x83426B33,
                0xF01EAB71,
                0xB0804187,
                0x3C005E5F,
                0x77A057BE,
                0xBDE8AE24,
                0x55464299,
                0xBF582E61,
                0x4E58F48F,
                0xF2DDFDA2,
                0xF474EF38,
                0x8789BDC2,
                0x5366F9C3,
                0xC8B38E74,
                0xB475F255,
                0x46FCD9B9,
                0x7AEB2661,
                0x8B1DDF84,
                0x846A0E79,
                0x915F95E2,
                0x466E598E,
                0x20B45770,
                0x8CD55591,
                0xC902DE4C,
                0xB90BACE1,
                0xBB8205D0,
                0x11A86248,
                0x7574A99E,
                0xB77F19B6,
                0xE0A9DC09,
                0x662D09A1,
                0xC4324633,
                0xE85A1F02,
                0x09F0BE8C,
                0x4A99A025,
                0x1D6EFE10,
                0x1AB93D1D,
                0x0BA5A4DF,
                0xA186F20F,
                0x2868F169,
                0xDCB7DA83,
                0x573906FE,
                0xA1E2CE9B,
                0x4FCD7F52,
                0x50115E01,
                0xA70683FA,
                0xA002B5C4,
                0x0DE6D027,
                0x9AF88C27,
                0x773F8641,
                0xC3604C06,
                0x61A806B5,
                0xF0177A28,
                0xC0F586E0,
                0x006058AA,
                0x30DC7D62,
                0x11E69ED7,
                0x2338EA63,
                0x53C2DD94,
                0xC2C21634,
                0xBBCBEE56,
                0x90BCB6DE,
                0xEBFC7DA1,
                0xCE591D76,
                0x6F05E409,
                0x4B7C0188,
                0x39720A3D,
                0x7C927C24,
                0x86E3725F,
                0x724D9DB9,
                0x1AC15BB4,
                0xD39EB8FC,
                0xED545578,
                0x08FCA5B5,
                0xD83D7CD3,
                0x4DAD0FC4,
                0x1E50EF5E,
                0xB161E6F8,
                0xA28514D9,
                0x6C51133C,
                0x6FD5C7E7,
                0x56E14EC4,
                0x362ABFCE,
                0xDDC6C837,
                0xD79A3234,
                0x92638212,
                0x670EFA8E,
                0x406000E0
            ],
            [
                0x3A39CE37,
                0xD3FAF5CF,
                0xABC27737,
                0x5AC52D1B,
                0x5CB0679E,
                0x4FA33742,
                0xD3822740,
                0x99BC9BBE,
                0xD5118E9D,
                0xBF0F7315,
                0xD62D1C7E,
                0xC700C47B,
                0xB78C1B6B,
                0x21A19045,
                0xB26EB1BE,
                0x6A366EB4,
                0x5748AB2F,
                0xBC946E79,
                0xC6A376D2,
                0x6549C2C8,
                0x530FF8EE,
                0x468DDE7D,
                0xD5730A1D,
                0x4CD04DC6,
                0x2939BBDB,
                0xA9BA4650,
                0xAC9526E8,
                0xBE5EE304,
                0xA1FAD5F0,
                0x6A2D519A,
                0x63EF8CE2,
                0x9A86EE22,
                0xC089C2B8,
                0x43242EF6,
                0xA51E03AA,
                0x9CF2D0A4,
                0x83C061BA,
                0x9BE96A4D,
                0x8FE51550,
                0xBA645BD6,
                0x2826A2F9,
                0xA73A3AE1,
                0x4BA99586,
                0xEF5562E9,
                0xC72FEFD3,
                0xF752F7DA,
                0x3F046F69,
                0x77FA0A59,
                0x80E4A915,
                0x87B08601,
                0x9B09E6AD,
                0x3B3EE593,
                0xE990FD5A,
                0x9E34D797,
                0x2CF0B7D9,
                0x022B8B51,
                0x96D5AC3A,
                0x017DA67D,
                0xD1CF3ED6,
                0x7C7D2D28,
                0x1F9F25CF,
                0xADF2B89B,
                0x5AD6B472,
                0x5A88F54C,
                0xE029AC71,
                0xE019A5E6,
                0x47B0ACFD,
                0xED93FA9B,
                0xE8D3C48D,
                0x283B57CC,
                0xF8D56629,
                0x79132E28,
                0x785F0191,
                0xED756055,
                0xF7960E44,
                0xE3D35E8C,
                0x15056DD4,
                0x88F46DBA,
                0x03A16125,
                0x0564F0BD,
                0xC3EB9E15,
                0x3C9057A2,
                0x97271AEC,
                0xA93A072A,
                0x1B3F6D9B,
                0x1E6321F5,
                0xF59C66FB,
                0x26DCF319,
                0x7533D928,
                0xB155FDF5,
                0x03563482,
                0x8ABA3CBB,
                0x28517711,
                0xC20AD9F8,
                0xABCC5167,
                0xCCAD925F,
                0x4DE81751,
                0x3830DC8E,
                0x379D5862,
                0x9320F991,
                0xEA7A90C2,
                0xFB3E7BCE,
                0x5121CE64,
                0x774FBE32,
                0xA8B6E37E,
                0xC3293D46,
                0x48DE5369,
                0x6413E680,
                0xA2AE0810,
                0xDD6DB224,
                0x69852DFD,
                0x09072166,
                0xB39A460A,
                0x6445C0DD,
                0x586CDECF,
                0x1C20C8AE,
                0x5BBEF7DD,
                0x1B588D40,
                0xCCD2017F,
                0x6BB4E3BB,
                0xDDA26A7E,
                0x3A59FF45,
                0x3E350A44,
                0xBCB4CDD5,
                0x72EACEA8,
                0xFA6484BB,
                0x8D6612AE,
                0xBF3C6F47,
                0xD29BE463,
                0x542F5D9E,
                0xAEC2771B,
                0xF64E6370,
                0x740E0D8D,
                0xE75B1357,
                0xF8721671,
                0xAF537D5D,
                0x4040CB08,
                0x4EB4E2CC,
                0x34D2466A,
                0x0115AF84,
                0xE1B00428,
                0x95983A1D,
                0x06B89FB4,
                0xCE6EA048,
                0x6F3F3B82,
                0x3520AB82,
                0x011A1D4B,
                0x277227F8,
                0x611560B1,
                0xE7933FDC,
                0xBB3A792B,
                0x344525BD,
                0xA08839E1,
                0x51CE794B,
                0x2F32C9B7,
                0xA01FBAC9,
                0xE01CC87E,
                0xBCC7D1F6,
                0xCF0111C3,
                0xA1E8AAC7,
                0x1A908749,
                0xD44FBD9A,
                0xD0DADECB,
                0xD50ADA38,
                0x0339C32A,
                0xC6913667,
                0x8DF9317C,
                0xE0B12B4F,
                0xF79E59B7,
                0x43F5BB3A,
                0xF2D519FF,
                0x27D9459C,
                0xBF97222C,
                0x15E6FC2A,
                0x0F91FC71,
                0x9B941525,
                0xFAE59361,
                0xCEB69CEB,
                0xC2A86459,
                0x12BAA8D1,
                0xB6C1075E,
                0xE3056A0C,
                0x10D25065,
                0xCB03A442,
                0xE0EC6E0E,
                0x1698DB3B,
                0x4C98A0BE,
                0x3278E964,
                0x9F1F9532,
                0xE0D392DF,
                0xD3A0342B,
                0x8971F21E,
                0x1B0A7441,
                0x4BA3348C,
                0xC5BE7120,
                0xC37632D8,
                0xDF359F8D,
                0x9B992F2E,
                0xE60B6F47,
                0x0FE3F11D,
                0xE54CDA54,
                0x1EDAD891,
                0xCE6279CF,
                0xCD3E7E6F,
                0x1618B166,
                0xFD2C1D05,
                0x848FD2C5,
                0xF6FB2299,
                0xF523F357,
                0xA6327623,
                0x93A83531,
                0x56CCCD02,
                0xACF08162,
                0x5A75EBB5,
                0x6E163697,
                0x88D273CC,
                0xDE966292,
                0x81B949D0,
                0x4C50901B,
                0x71C65614,
                0xE6C6C7BD,
                0x327A140A,
                0x45E1D006,
                0xC3F27B9A,
                0xC9AA53FD,
                0x62A80F00,
                0xBB25BFE2,
                0x35BDD2F6,
                0x71126905,
                0xB2040222,
                0xB6CBCF7C,
                0xCD769C2B,
                0x53113EC0,
                0x1640E3D3,
                0x38ABBD60,
                0x2547ADF0,
                0xBA38209C,
                0xF746CE76,
                0x77AFA1C5,
                0x20756060,
                0x85CBFE4E,
                0x8AE88DD8,
                0x7AAAF9B0,
                0x4CF9AA7E,
                0x1948C25C,
                0x02FB8A8C,
                0x01C36AE4,
                0xD6EBE1F9,
                0x90D4F869,
                0xA65CDEA0,
                0x3F09252D,
                0xC208E69F,
                0xB74E6132,
                0xCE77E25B,
                0x578FDFE3,
                0x3AC372E6
            ]
        ];
        var BLOWFISH_CTX = {
            pbox: [],
            sbox: []
        };
        function F(ctx, x) {
            let a = x >> 24 & 0xFF;
            let b = x >> 16 & 0xFF;
            let c = x >> 8 & 0xFF;
            let d = x & 0xFF;
            let y = ctx.sbox[0][a] + ctx.sbox[1][b];
            y = y ^ ctx.sbox[2][c];
            y = y + ctx.sbox[3][d];
            return y;
        }
        function BlowFish_Encrypt(ctx, left, right) {
            let Xl = left;
            let Xr = right;
            let temp;
            for(let i = 0; i < N; ++i){
                Xl = Xl ^ ctx.pbox[i];
                Xr = F(ctx, Xl) ^ Xr;
                temp = Xl;
                Xl = Xr;
                Xr = temp;
            }
            temp = Xl;
            Xl = Xr;
            Xr = temp;
            Xr = Xr ^ ctx.pbox[N];
            Xl = Xl ^ ctx.pbox[N + 1];
            return {
                left: Xl,
                right: Xr
            };
        }
        function BlowFish_Decrypt(ctx, left, right) {
            let Xl = left;
            let Xr = right;
            let temp;
            for(let i = N + 1; i > 1; --i){
                Xl = Xl ^ ctx.pbox[i];
                Xr = F(ctx, Xl) ^ Xr;
                temp = Xl;
                Xl = Xr;
                Xr = temp;
            }
            temp = Xl;
            Xl = Xr;
            Xr = temp;
            Xr = Xr ^ ctx.pbox[1];
            Xl = Xl ^ ctx.pbox[0];
            return {
                left: Xl,
                right: Xr
            };
        }
        /**
	     * Initialization ctx's pbox and sbox.
	     *
	     * @param {Object} ctx The object has pbox and sbox.
	     * @param {Array} key An array of 32-bit words.
	     * @param {int} keysize The length of the key.
	     *
	     * @example
	     *
	     *     BlowFishInit(BLOWFISH_CTX, key, 128/32);
	     */ function BlowFishInit(ctx, key, keysize) {
            for(let Row = 0; Row < 4; Row++){
                ctx.sbox[Row] = [];
                for(let Col = 0; Col < 256; Col++)ctx.sbox[Row][Col] = ORIG_S[Row][Col];
            }
            let keyIndex = 0;
            for(let index = 0; index < N + 2; index++){
                ctx.pbox[index] = ORIG_P[index] ^ key[keyIndex];
                keyIndex++;
                if (keyIndex >= keysize) keyIndex = 0;
            }
            let Data1 = 0;
            let Data2 = 0;
            let res = 0;
            for(let i = 0; i < N + 2; i += 2){
                res = BlowFish_Encrypt(ctx, Data1, Data2);
                Data1 = res.left;
                Data2 = res.right;
                ctx.pbox[i] = Data1;
                ctx.pbox[i + 1] = Data2;
            }
            for(let i = 0; i < 4; i++)for(let j = 0; j < 256; j += 2){
                res = BlowFish_Encrypt(ctx, Data1, Data2);
                Data1 = res.left;
                Data2 = res.right;
                ctx.sbox[i][j] = Data1;
                ctx.sbox[i][j + 1] = Data2;
            }
            return true;
        }
        /**
	     * Blowfish block cipher algorithm.
	     */ var Blowfish = C_algo.Blowfish = BlockCipher.extend({
            _doReset: function() {
                // Skip reset of nRounds has been set before and key did not change
                if (this._keyPriorReset === this._key) return;
                // Shortcuts
                var key = this._keyPriorReset = this._key;
                var keyWords = key.words;
                var keySize = key.sigBytes / 4;
                //Initialization pbox and sbox
                BlowFishInit(BLOWFISH_CTX, keyWords, keySize);
            },
            encryptBlock: function(M, offset) {
                var res = BlowFish_Encrypt(BLOWFISH_CTX, M[offset], M[offset + 1]);
                M[offset] = res.left;
                M[offset + 1] = res.right;
            },
            decryptBlock: function(M, offset) {
                var res = BlowFish_Decrypt(BLOWFISH_CTX, M[offset], M[offset + 1]);
                M[offset] = res.left;
                M[offset + 1] = res.right;
            },
            blockSize: 2,
            keySize: 4,
            ivSize: 2
        });
        /**
	     * Shortcut functions to the cipher's object interface.
	     *
	     * @example
	     *
	     *     var ciphertext = CryptoJS.Blowfish.encrypt(message, key, cfg);
	     *     var plaintext  = CryptoJS.Blowfish.decrypt(ciphertext, key, cfg);
	     */ C.Blowfish = BlockCipher._createHelper(Blowfish);
    })();
    return CryptoJS.Blowfish;
});

});



parcelRequire.register("i1G9i", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Hash = void 0;

var $fkJVr = parcelRequire("fkJVr");
class $d1f903e0ae54b644$var$Hash {
    static sha256(data) {
        return new Uint8Array(new $fkJVr.sha256().update(data).digest());
    }
    static truncHashPortion(str, firstCharCount = str.length, endCharCount = 0) {
        return str.substring(0, firstCharCount) + "…" + str.substring(str.length - endCharCount, str.length);
    }
}
module.exports.Hash = $d1f903e0ae54b644$var$Hash;

});






parcelRequire.register("24cgb", function(module, exports) {
module.exports = $1815771047f19273$var$Long;
/**
 * wasm optimizations, to do native i64 multiplication and divide
 */ var $1815771047f19273$var$wasm = null;
try {
    $1815771047f19273$var$wasm = new WebAssembly.Instance(new WebAssembly.Module(new Uint8Array([
        0,
        97,
        115,
        109,
        1,
        0,
        0,
        0,
        1,
        13,
        2,
        96,
        0,
        1,
        127,
        96,
        4,
        127,
        127,
        127,
        127,
        1,
        127,
        3,
        7,
        6,
        0,
        1,
        1,
        1,
        1,
        1,
        6,
        6,
        1,
        127,
        1,
        65,
        0,
        11,
        7,
        50,
        6,
        3,
        109,
        117,
        108,
        0,
        1,
        5,
        100,
        105,
        118,
        95,
        115,
        0,
        2,
        5,
        100,
        105,
        118,
        95,
        117,
        0,
        3,
        5,
        114,
        101,
        109,
        95,
        115,
        0,
        4,
        5,
        114,
        101,
        109,
        95,
        117,
        0,
        5,
        8,
        103,
        101,
        116,
        95,
        104,
        105,
        103,
        104,
        0,
        0,
        10,
        191,
        1,
        6,
        4,
        0,
        35,
        0,
        11,
        36,
        1,
        1,
        126,
        32,
        0,
        173,
        32,
        1,
        173,
        66,
        32,
        134,
        132,
        32,
        2,
        173,
        32,
        3,
        173,
        66,
        32,
        134,
        132,
        126,
        34,
        4,
        66,
        32,
        135,
        167,
        36,
        0,
        32,
        4,
        167,
        11,
        36,
        1,
        1,
        126,
        32,
        0,
        173,
        32,
        1,
        173,
        66,
        32,
        134,
        132,
        32,
        2,
        173,
        32,
        3,
        173,
        66,
        32,
        134,
        132,
        127,
        34,
        4,
        66,
        32,
        135,
        167,
        36,
        0,
        32,
        4,
        167,
        11,
        36,
        1,
        1,
        126,
        32,
        0,
        173,
        32,
        1,
        173,
        66,
        32,
        134,
        132,
        32,
        2,
        173,
        32,
        3,
        173,
        66,
        32,
        134,
        132,
        128,
        34,
        4,
        66,
        32,
        135,
        167,
        36,
        0,
        32,
        4,
        167,
        11,
        36,
        1,
        1,
        126,
        32,
        0,
        173,
        32,
        1,
        173,
        66,
        32,
        134,
        132,
        32,
        2,
        173,
        32,
        3,
        173,
        66,
        32,
        134,
        132,
        129,
        34,
        4,
        66,
        32,
        135,
        167,
        36,
        0,
        32,
        4,
        167,
        11,
        36,
        1,
        1,
        126,
        32,
        0,
        173,
        32,
        1,
        173,
        66,
        32,
        134,
        132,
        32,
        2,
        173,
        32,
        3,
        173,
        66,
        32,
        134,
        132,
        130,
        34,
        4,
        66,
        32,
        135,
        167,
        36,
        0,
        32,
        4,
        167,
        11
    ])), {}).exports;
} catch (e) {
// no wasm support :(
}
/**
 * Constructs a 64 bit two's-complement integer, given its low and high 32 bit values as *signed* integers.
 *  See the from* functions below for more convenient ways of constructing Longs.
 * @exports Long
 * @class A Long class for representing a 64 bit two's-complement integer value.
 * @param {number} low The low (signed) 32 bits of the long
 * @param {number} high The high (signed) 32 bits of the long
 * @param {boolean=} unsigned Whether unsigned or not, defaults to signed
 * @constructor
 */ function $1815771047f19273$var$Long(low, high, unsigned) {
    /**
     * The low 32 bits as a signed value.
     * @type {number}
     */ this.low = low | 0;
    /**
     * The high 32 bits as a signed value.
     * @type {number}
     */ this.high = high | 0;
    /**
     * Whether unsigned or not.
     * @type {boolean}
     */ this.unsigned = !!unsigned;
}
// The internal representation of a long is the two given signed, 32-bit values.
// We use 32-bit pieces because these are the size of integers on which
// Javascript performs bit-operations.  For operations like addition and
// multiplication, we split each number into 16 bit pieces, which can easily be
// multiplied within Javascript's floating-point representation without overflow
// or change in sign.
//
// In the algorithms below, we frequently reduce the negative case to the
// positive case by negating the input(s) and then post-processing the result.
// Note that we must ALWAYS check specially whether those values are MIN_VALUE
// (-2^63) because -MIN_VALUE == MIN_VALUE (since 2^63 cannot be represented as
// a positive number, it overflows back into a negative).  Not handling this
// case would often result in infinite recursion.
//
// Common constant values ZERO, ONE, NEG_ONE, etc. are defined below the from*
// methods on which they depend.
/**
 * An indicator used to reliably determine if an object is a Long or not.
 * @type {boolean}
 * @const
 * @private
 */ $1815771047f19273$var$Long.prototype.__isLong__;
Object.defineProperty($1815771047f19273$var$Long.prototype, "__isLong__", {
    value: true
});
/**
 * @function
 * @param {*} obj Object
 * @returns {boolean}
 * @inner
 */ function $1815771047f19273$var$isLong(obj) {
    return (obj && obj["__isLong__"]) === true;
}
/**
 * Tests if the specified object is a Long.
 * @function
 * @param {*} obj Object
 * @returns {boolean}
 */ $1815771047f19273$var$Long.isLong = $1815771047f19273$var$isLong;
/**
 * A cache of the Long representations of small integer values.
 * @type {!Object}
 * @inner
 */ var $1815771047f19273$var$INT_CACHE = {};
/**
 * A cache of the Long representations of small unsigned integer values.
 * @type {!Object}
 * @inner
 */ var $1815771047f19273$var$UINT_CACHE = {};
/**
 * @param {number} value
 * @param {boolean=} unsigned
 * @returns {!Long}
 * @inner
 */ function $1815771047f19273$var$fromInt(value, unsigned) {
    var obj, cachedObj, cache;
    if (unsigned) {
        value >>>= 0;
        if (cache = 0 <= value && value < 256) {
            cachedObj = $1815771047f19273$var$UINT_CACHE[value];
            if (cachedObj) return cachedObj;
        }
        obj = $1815771047f19273$var$fromBits(value, (value | 0) < 0 ? -1 : 0, true);
        if (cache) $1815771047f19273$var$UINT_CACHE[value] = obj;
        return obj;
    } else {
        value |= 0;
        if (cache = -128 <= value && value < 128) {
            cachedObj = $1815771047f19273$var$INT_CACHE[value];
            if (cachedObj) return cachedObj;
        }
        obj = $1815771047f19273$var$fromBits(value, value < 0 ? -1 : 0, false);
        if (cache) $1815771047f19273$var$INT_CACHE[value] = obj;
        return obj;
    }
}
/**
 * Returns a Long representing the given 32 bit integer value.
 * @function
 * @param {number} value The 32 bit integer in question
 * @param {boolean=} unsigned Whether unsigned or not, defaults to signed
 * @returns {!Long} The corresponding Long value
 */ $1815771047f19273$var$Long.fromInt = $1815771047f19273$var$fromInt;
/**
 * @param {number} value
 * @param {boolean=} unsigned
 * @returns {!Long}
 * @inner
 */ function $1815771047f19273$var$fromNumber(value, unsigned) {
    if (isNaN(value)) return unsigned ? $1815771047f19273$var$UZERO : $1815771047f19273$var$ZERO;
    if (unsigned) {
        if (value < 0) return $1815771047f19273$var$UZERO;
        if (value >= $1815771047f19273$var$TWO_PWR_64_DBL) return $1815771047f19273$var$MAX_UNSIGNED_VALUE;
    } else {
        if (value <= -$1815771047f19273$var$TWO_PWR_63_DBL) return $1815771047f19273$var$MIN_VALUE;
        if (value + 1 >= $1815771047f19273$var$TWO_PWR_63_DBL) return $1815771047f19273$var$MAX_VALUE;
    }
    if (value < 0) return $1815771047f19273$var$fromNumber(-value, unsigned).neg();
    return $1815771047f19273$var$fromBits(value % $1815771047f19273$var$TWO_PWR_32_DBL | 0, value / $1815771047f19273$var$TWO_PWR_32_DBL | 0, unsigned);
}
/**
 * Returns a Long representing the given value, provided that it is a finite number. Otherwise, zero is returned.
 * @function
 * @param {number} value The number in question
 * @param {boolean=} unsigned Whether unsigned or not, defaults to signed
 * @returns {!Long} The corresponding Long value
 */ $1815771047f19273$var$Long.fromNumber = $1815771047f19273$var$fromNumber;
/**
 * @param {number} lowBits
 * @param {number} highBits
 * @param {boolean=} unsigned
 * @returns {!Long}
 * @inner
 */ function $1815771047f19273$var$fromBits(lowBits, highBits, unsigned) {
    return new $1815771047f19273$var$Long(lowBits, highBits, unsigned);
}
/**
 * Returns a Long representing the 64 bit integer that comes by concatenating the given low and high bits. Each is
 *  assumed to use 32 bits.
 * @function
 * @param {number} lowBits The low 32 bits
 * @param {number} highBits The high 32 bits
 * @param {boolean=} unsigned Whether unsigned or not, defaults to signed
 * @returns {!Long} The corresponding Long value
 */ $1815771047f19273$var$Long.fromBits = $1815771047f19273$var$fromBits;
/**
 * @function
 * @param {number} base
 * @param {number} exponent
 * @returns {number}
 * @inner
 */ var $1815771047f19273$var$pow_dbl = Math.pow; // Used 4 times (4*8 to 15+4)
/**
 * @param {string} str
 * @param {(boolean|number)=} unsigned
 * @param {number=} radix
 * @returns {!Long}
 * @inner
 */ function $1815771047f19273$var$fromString(str, unsigned, radix) {
    if (str.length === 0) throw Error("empty string");
    if (str === "NaN" || str === "Infinity" || str === "+Infinity" || str === "-Infinity") return $1815771047f19273$var$ZERO;
    if (typeof unsigned === "number") // For goog.math.long compatibility
    radix = unsigned, unsigned = false;
    else unsigned = !!unsigned;
    radix = radix || 10;
    if (radix < 2 || 36 < radix) throw RangeError("radix");
    var p;
    if ((p = str.indexOf("-")) > 0) throw Error("interior hyphen");
    else if (p === 0) return $1815771047f19273$var$fromString(str.substring(1), unsigned, radix).neg();
    // Do several (8) digits each time through the loop, so as to
    // minimize the calls to the very expensive emulated div.
    var radixToPower = $1815771047f19273$var$fromNumber($1815771047f19273$var$pow_dbl(radix, 8));
    var result = $1815771047f19273$var$ZERO;
    for(var i = 0; i < str.length; i += 8){
        var size = Math.min(8, str.length - i), value = parseInt(str.substring(i, i + size), radix);
        if (size < 8) {
            var power = $1815771047f19273$var$fromNumber($1815771047f19273$var$pow_dbl(radix, size));
            result = result.mul(power).add($1815771047f19273$var$fromNumber(value));
        } else {
            result = result.mul(radixToPower);
            result = result.add($1815771047f19273$var$fromNumber(value));
        }
    }
    result.unsigned = unsigned;
    return result;
}
/**
 * Returns a Long representation of the given string, written using the specified radix.
 * @function
 * @param {string} str The textual representation of the Long
 * @param {(boolean|number)=} unsigned Whether unsigned or not, defaults to signed
 * @param {number=} radix The radix in which the text is written (2-36), defaults to 10
 * @returns {!Long} The corresponding Long value
 */ $1815771047f19273$var$Long.fromString = $1815771047f19273$var$fromString;
/**
 * @function
 * @param {!Long|number|string|!{low: number, high: number, unsigned: boolean}} val
 * @param {boolean=} unsigned
 * @returns {!Long}
 * @inner
 */ function $1815771047f19273$var$fromValue(val, unsigned) {
    if (typeof val === "number") return $1815771047f19273$var$fromNumber(val, unsigned);
    if (typeof val === "string") return $1815771047f19273$var$fromString(val, unsigned);
    // Throws for non-objects, converts non-instanceof Long:
    return $1815771047f19273$var$fromBits(val.low, val.high, typeof unsigned === "boolean" ? unsigned : val.unsigned);
}
/**
 * Converts the specified value to a Long using the appropriate from* function for its type.
 * @function
 * @param {!Long|number|string|!{low: number, high: number, unsigned: boolean}} val Value
 * @param {boolean=} unsigned Whether unsigned or not, defaults to signed
 * @returns {!Long}
 */ $1815771047f19273$var$Long.fromValue = $1815771047f19273$var$fromValue;
// NOTE: the compiler should inline these constant values below and then remove these variables, so there should be
// no runtime penalty for these.
/**
 * @type {number}
 * @const
 * @inner
 */ var $1815771047f19273$var$TWO_PWR_16_DBL = 65536;
/**
 * @type {number}
 * @const
 * @inner
 */ var $1815771047f19273$var$TWO_PWR_24_DBL = 16777216;
/**
 * @type {number}
 * @const
 * @inner
 */ var $1815771047f19273$var$TWO_PWR_32_DBL = $1815771047f19273$var$TWO_PWR_16_DBL * $1815771047f19273$var$TWO_PWR_16_DBL;
/**
 * @type {number}
 * @const
 * @inner
 */ var $1815771047f19273$var$TWO_PWR_64_DBL = $1815771047f19273$var$TWO_PWR_32_DBL * $1815771047f19273$var$TWO_PWR_32_DBL;
/**
 * @type {number}
 * @const
 * @inner
 */ var $1815771047f19273$var$TWO_PWR_63_DBL = $1815771047f19273$var$TWO_PWR_64_DBL / 2;
/**
 * @type {!Long}
 * @const
 * @inner
 */ var $1815771047f19273$var$TWO_PWR_24 = $1815771047f19273$var$fromInt($1815771047f19273$var$TWO_PWR_24_DBL);
/**
 * @type {!Long}
 * @inner
 */ var $1815771047f19273$var$ZERO = $1815771047f19273$var$fromInt(0);
/**
 * Signed zero.
 * @type {!Long}
 */ $1815771047f19273$var$Long.ZERO = $1815771047f19273$var$ZERO;
/**
 * @type {!Long}
 * @inner
 */ var $1815771047f19273$var$UZERO = $1815771047f19273$var$fromInt(0, true);
/**
 * Unsigned zero.
 * @type {!Long}
 */ $1815771047f19273$var$Long.UZERO = $1815771047f19273$var$UZERO;
/**
 * @type {!Long}
 * @inner
 */ var $1815771047f19273$var$ONE = $1815771047f19273$var$fromInt(1);
/**
 * Signed one.
 * @type {!Long}
 */ $1815771047f19273$var$Long.ONE = $1815771047f19273$var$ONE;
/**
 * @type {!Long}
 * @inner
 */ var $1815771047f19273$var$UONE = $1815771047f19273$var$fromInt(1, true);
/**
 * Unsigned one.
 * @type {!Long}
 */ $1815771047f19273$var$Long.UONE = $1815771047f19273$var$UONE;
/**
 * @type {!Long}
 * @inner
 */ var $1815771047f19273$var$NEG_ONE = $1815771047f19273$var$fromInt(-1);
/**
 * Signed negative one.
 * @type {!Long}
 */ $1815771047f19273$var$Long.NEG_ONE = $1815771047f19273$var$NEG_ONE;
/**
 * @type {!Long}
 * @inner
 */ var $1815771047f19273$var$MAX_VALUE = $1815771047f19273$var$fromBits(-1, 2147483647, false);
/**
 * Maximum signed value.
 * @type {!Long}
 */ $1815771047f19273$var$Long.MAX_VALUE = $1815771047f19273$var$MAX_VALUE;
/**
 * @type {!Long}
 * @inner
 */ var $1815771047f19273$var$MAX_UNSIGNED_VALUE = $1815771047f19273$var$fromBits(-1, -1, true);
/**
 * Maximum unsigned value.
 * @type {!Long}
 */ $1815771047f19273$var$Long.MAX_UNSIGNED_VALUE = $1815771047f19273$var$MAX_UNSIGNED_VALUE;
/**
 * @type {!Long}
 * @inner
 */ var $1815771047f19273$var$MIN_VALUE = $1815771047f19273$var$fromBits(0, -2147483648, false);
/**
 * Minimum signed value.
 * @type {!Long}
 */ $1815771047f19273$var$Long.MIN_VALUE = $1815771047f19273$var$MIN_VALUE;
/**
 * @alias Long.prototype
 * @inner
 */ var $1815771047f19273$var$LongPrototype = $1815771047f19273$var$Long.prototype;
/**
 * Converts the Long to a 32 bit integer, assuming it is a 32 bit integer.
 * @returns {number}
 */ $1815771047f19273$var$LongPrototype.toInt = function toInt() {
    return this.unsigned ? this.low >>> 0 : this.low;
};
/**
 * Converts the Long to a the nearest floating-point representation of this value (double, 53 bit mantissa).
 * @returns {number}
 */ $1815771047f19273$var$LongPrototype.toNumber = function toNumber() {
    if (this.unsigned) return (this.high >>> 0) * $1815771047f19273$var$TWO_PWR_32_DBL + (this.low >>> 0);
    return this.high * $1815771047f19273$var$TWO_PWR_32_DBL + (this.low >>> 0);
};
/**
 * Converts the Long to a string written in the specified radix.
 * @param {number=} radix Radix (2-36), defaults to 10
 * @returns {string}
 * @override
 * @throws {RangeError} If `radix` is out of range
 */ $1815771047f19273$var$LongPrototype.toString = function toString(radix) {
    radix = radix || 10;
    if (radix < 2 || 36 < radix) throw RangeError("radix");
    if (this.isZero()) return "0";
    if (this.isNegative()) {
        if (this.eq($1815771047f19273$var$MIN_VALUE)) {
            // We need to change the Long value before it can be negated, so we remove
            // the bottom-most digit in this base and then recurse to do the rest.
            var radixLong = $1815771047f19273$var$fromNumber(radix), div = this.div(radixLong), rem1 = div.mul(radixLong).sub(this);
            return div.toString(radix) + rem1.toInt().toString(radix);
        } else return "-" + this.neg().toString(radix);
    }
    // Do several (6) digits each time through the loop, so as to
    // minimize the calls to the very expensive emulated div.
    var radixToPower = $1815771047f19273$var$fromNumber($1815771047f19273$var$pow_dbl(radix, 6), this.unsigned), rem = this;
    var result = "";
    while(true){
        var remDiv = rem.div(radixToPower), intval = rem.sub(remDiv.mul(radixToPower)).toInt() >>> 0, digits = intval.toString(radix);
        rem = remDiv;
        if (rem.isZero()) return digits + result;
        else {
            while(digits.length < 6)digits = "0" + digits;
            result = "" + digits + result;
        }
    }
};
/**
 * Gets the high 32 bits as a signed integer.
 * @returns {number} Signed high bits
 */ $1815771047f19273$var$LongPrototype.getHighBits = function getHighBits() {
    return this.high;
};
/**
 * Gets the high 32 bits as an unsigned integer.
 * @returns {number} Unsigned high bits
 */ $1815771047f19273$var$LongPrototype.getHighBitsUnsigned = function getHighBitsUnsigned() {
    return this.high >>> 0;
};
/**
 * Gets the low 32 bits as a signed integer.
 * @returns {number} Signed low bits
 */ $1815771047f19273$var$LongPrototype.getLowBits = function getLowBits() {
    return this.low;
};
/**
 * Gets the low 32 bits as an unsigned integer.
 * @returns {number} Unsigned low bits
 */ $1815771047f19273$var$LongPrototype.getLowBitsUnsigned = function getLowBitsUnsigned() {
    return this.low >>> 0;
};
/**
 * Gets the number of bits needed to represent the absolute value of this Long.
 * @returns {number}
 */ $1815771047f19273$var$LongPrototype.getNumBitsAbs = function getNumBitsAbs() {
    if (this.isNegative()) return this.eq($1815771047f19273$var$MIN_VALUE) ? 64 : this.neg().getNumBitsAbs();
    var val = this.high != 0 ? this.high : this.low;
    for(var bit = 31; bit > 0; bit--)if ((val & 1 << bit) != 0) break;
    return this.high != 0 ? bit + 33 : bit + 1;
};
/**
 * Tests if this Long's value equals zero.
 * @returns {boolean}
 */ $1815771047f19273$var$LongPrototype.isZero = function isZero() {
    return this.high === 0 && this.low === 0;
};
/**
 * Tests if this Long's value equals zero. This is an alias of {@link Long#isZero}.
 * @returns {boolean}
 */ $1815771047f19273$var$LongPrototype.eqz = $1815771047f19273$var$LongPrototype.isZero;
/**
 * Tests if this Long's value is negative.
 * @returns {boolean}
 */ $1815771047f19273$var$LongPrototype.isNegative = function isNegative() {
    return !this.unsigned && this.high < 0;
};
/**
 * Tests if this Long's value is positive.
 * @returns {boolean}
 */ $1815771047f19273$var$LongPrototype.isPositive = function isPositive() {
    return this.unsigned || this.high >= 0;
};
/**
 * Tests if this Long's value is odd.
 * @returns {boolean}
 */ $1815771047f19273$var$LongPrototype.isOdd = function isOdd() {
    return (this.low & 1) === 1;
};
/**
 * Tests if this Long's value is even.
 * @returns {boolean}
 */ $1815771047f19273$var$LongPrototype.isEven = function isEven() {
    return (this.low & 1) === 0;
};
/**
 * Tests if this Long's value equals the specified's.
 * @param {!Long|number|string} other Other value
 * @returns {boolean}
 */ $1815771047f19273$var$LongPrototype.equals = function equals(other) {
    if (!$1815771047f19273$var$isLong(other)) other = $1815771047f19273$var$fromValue(other);
    if (this.unsigned !== other.unsigned && this.high >>> 31 === 1 && other.high >>> 31 === 1) return false;
    return this.high === other.high && this.low === other.low;
};
/**
 * Tests if this Long's value equals the specified's. This is an alias of {@link Long#equals}.
 * @function
 * @param {!Long|number|string} other Other value
 * @returns {boolean}
 */ $1815771047f19273$var$LongPrototype.eq = $1815771047f19273$var$LongPrototype.equals;
/**
 * Tests if this Long's value differs from the specified's.
 * @param {!Long|number|string} other Other value
 * @returns {boolean}
 */ $1815771047f19273$var$LongPrototype.notEquals = function notEquals(other) {
    return !this.eq(/* validates */ other);
};
/**
 * Tests if this Long's value differs from the specified's. This is an alias of {@link Long#notEquals}.
 * @function
 * @param {!Long|number|string} other Other value
 * @returns {boolean}
 */ $1815771047f19273$var$LongPrototype.neq = $1815771047f19273$var$LongPrototype.notEquals;
/**
 * Tests if this Long's value differs from the specified's. This is an alias of {@link Long#notEquals}.
 * @function
 * @param {!Long|number|string} other Other value
 * @returns {boolean}
 */ $1815771047f19273$var$LongPrototype.ne = $1815771047f19273$var$LongPrototype.notEquals;
/**
 * Tests if this Long's value is less than the specified's.
 * @param {!Long|number|string} other Other value
 * @returns {boolean}
 */ $1815771047f19273$var$LongPrototype.lessThan = function lessThan(other) {
    return this.comp(/* validates */ other) < 0;
};
/**
 * Tests if this Long's value is less than the specified's. This is an alias of {@link Long#lessThan}.
 * @function
 * @param {!Long|number|string} other Other value
 * @returns {boolean}
 */ $1815771047f19273$var$LongPrototype.lt = $1815771047f19273$var$LongPrototype.lessThan;
/**
 * Tests if this Long's value is less than or equal the specified's.
 * @param {!Long|number|string} other Other value
 * @returns {boolean}
 */ $1815771047f19273$var$LongPrototype.lessThanOrEqual = function lessThanOrEqual(other) {
    return this.comp(/* validates */ other) <= 0;
};
/**
 * Tests if this Long's value is less than or equal the specified's. This is an alias of {@link Long#lessThanOrEqual}.
 * @function
 * @param {!Long|number|string} other Other value
 * @returns {boolean}
 */ $1815771047f19273$var$LongPrototype.lte = $1815771047f19273$var$LongPrototype.lessThanOrEqual;
/**
 * Tests if this Long's value is less than or equal the specified's. This is an alias of {@link Long#lessThanOrEqual}.
 * @function
 * @param {!Long|number|string} other Other value
 * @returns {boolean}
 */ $1815771047f19273$var$LongPrototype.le = $1815771047f19273$var$LongPrototype.lessThanOrEqual;
/**
 * Tests if this Long's value is greater than the specified's.
 * @param {!Long|number|string} other Other value
 * @returns {boolean}
 */ $1815771047f19273$var$LongPrototype.greaterThan = function greaterThan(other) {
    return this.comp(/* validates */ other) > 0;
};
/**
 * Tests if this Long's value is greater than the specified's. This is an alias of {@link Long#greaterThan}.
 * @function
 * @param {!Long|number|string} other Other value
 * @returns {boolean}
 */ $1815771047f19273$var$LongPrototype.gt = $1815771047f19273$var$LongPrototype.greaterThan;
/**
 * Tests if this Long's value is greater than or equal the specified's.
 * @param {!Long|number|string} other Other value
 * @returns {boolean}
 */ $1815771047f19273$var$LongPrototype.greaterThanOrEqual = function greaterThanOrEqual(other) {
    return this.comp(/* validates */ other) >= 0;
};
/**
 * Tests if this Long's value is greater than or equal the specified's. This is an alias of {@link Long#greaterThanOrEqual}.
 * @function
 * @param {!Long|number|string} other Other value
 * @returns {boolean}
 */ $1815771047f19273$var$LongPrototype.gte = $1815771047f19273$var$LongPrototype.greaterThanOrEqual;
/**
 * Tests if this Long's value is greater than or equal the specified's. This is an alias of {@link Long#greaterThanOrEqual}.
 * @function
 * @param {!Long|number|string} other Other value
 * @returns {boolean}
 */ $1815771047f19273$var$LongPrototype.ge = $1815771047f19273$var$LongPrototype.greaterThanOrEqual;
/**
 * Compares this Long's value with the specified's.
 * @param {!Long|number|string} other Other value
 * @returns {number} 0 if they are the same, 1 if the this is greater and -1
 *  if the given one is greater
 */ $1815771047f19273$var$LongPrototype.compare = function compare(other) {
    if (!$1815771047f19273$var$isLong(other)) other = $1815771047f19273$var$fromValue(other);
    if (this.eq(other)) return 0;
    var thisNeg = this.isNegative(), otherNeg = other.isNegative();
    if (thisNeg && !otherNeg) return -1;
    if (!thisNeg && otherNeg) return 1;
    // At this point the sign bits are the same
    if (!this.unsigned) return this.sub(other).isNegative() ? -1 : 1;
    // Both are positive if at least one is unsigned
    return other.high >>> 0 > this.high >>> 0 || other.high === this.high && other.low >>> 0 > this.low >>> 0 ? -1 : 1;
};
/**
 * Compares this Long's value with the specified's. This is an alias of {@link Long#compare}.
 * @function
 * @param {!Long|number|string} other Other value
 * @returns {number} 0 if they are the same, 1 if the this is greater and -1
 *  if the given one is greater
 */ $1815771047f19273$var$LongPrototype.comp = $1815771047f19273$var$LongPrototype.compare;
/**
 * Negates this Long's value.
 * @returns {!Long} Negated Long
 */ $1815771047f19273$var$LongPrototype.negate = function negate() {
    if (!this.unsigned && this.eq($1815771047f19273$var$MIN_VALUE)) return $1815771047f19273$var$MIN_VALUE;
    return this.not().add($1815771047f19273$var$ONE);
};
/**
 * Negates this Long's value. This is an alias of {@link Long#negate}.
 * @function
 * @returns {!Long} Negated Long
 */ $1815771047f19273$var$LongPrototype.neg = $1815771047f19273$var$LongPrototype.negate;
/**
 * Returns the sum of this and the specified Long.
 * @param {!Long|number|string} addend Addend
 * @returns {!Long} Sum
 */ $1815771047f19273$var$LongPrototype.add = function add(addend) {
    if (!$1815771047f19273$var$isLong(addend)) addend = $1815771047f19273$var$fromValue(addend);
    // Divide each number into 4 chunks of 16 bits, and then sum the chunks.
    var a48 = this.high >>> 16;
    var a32 = this.high & 0xFFFF;
    var a16 = this.low >>> 16;
    var a00 = this.low & 0xFFFF;
    var b48 = addend.high >>> 16;
    var b32 = addend.high & 0xFFFF;
    var b16 = addend.low >>> 16;
    var b00 = addend.low & 0xFFFF;
    var c48 = 0, c32 = 0, c16 = 0, c00 = 0;
    c00 += a00 + b00;
    c16 += c00 >>> 16;
    c00 &= 0xFFFF;
    c16 += a16 + b16;
    c32 += c16 >>> 16;
    c16 &= 0xFFFF;
    c32 += a32 + b32;
    c48 += c32 >>> 16;
    c32 &= 0xFFFF;
    c48 += a48 + b48;
    c48 &= 0xFFFF;
    return $1815771047f19273$var$fromBits(c16 << 16 | c00, c48 << 16 | c32, this.unsigned);
};
/**
 * Returns the difference of this and the specified Long.
 * @param {!Long|number|string} subtrahend Subtrahend
 * @returns {!Long} Difference
 */ $1815771047f19273$var$LongPrototype.subtract = function subtract(subtrahend) {
    if (!$1815771047f19273$var$isLong(subtrahend)) subtrahend = $1815771047f19273$var$fromValue(subtrahend);
    return this.add(subtrahend.neg());
};
/**
 * Returns the difference of this and the specified Long. This is an alias of {@link Long#subtract}.
 * @function
 * @param {!Long|number|string} subtrahend Subtrahend
 * @returns {!Long} Difference
 */ $1815771047f19273$var$LongPrototype.sub = $1815771047f19273$var$LongPrototype.subtract;
/**
 * Returns the product of this and the specified Long.
 * @param {!Long|number|string} multiplier Multiplier
 * @returns {!Long} Product
 */ $1815771047f19273$var$LongPrototype.multiply = function multiply(multiplier) {
    if (this.isZero()) return $1815771047f19273$var$ZERO;
    if (!$1815771047f19273$var$isLong(multiplier)) multiplier = $1815771047f19273$var$fromValue(multiplier);
    // use wasm support if present
    if ($1815771047f19273$var$wasm) {
        var low = $1815771047f19273$var$wasm.mul(this.low, this.high, multiplier.low, multiplier.high);
        return $1815771047f19273$var$fromBits(low, $1815771047f19273$var$wasm.get_high(), this.unsigned);
    }
    if (multiplier.isZero()) return $1815771047f19273$var$ZERO;
    if (this.eq($1815771047f19273$var$MIN_VALUE)) return multiplier.isOdd() ? $1815771047f19273$var$MIN_VALUE : $1815771047f19273$var$ZERO;
    if (multiplier.eq($1815771047f19273$var$MIN_VALUE)) return this.isOdd() ? $1815771047f19273$var$MIN_VALUE : $1815771047f19273$var$ZERO;
    if (this.isNegative()) {
        if (multiplier.isNegative()) return this.neg().mul(multiplier.neg());
        else return this.neg().mul(multiplier).neg();
    } else if (multiplier.isNegative()) return this.mul(multiplier.neg()).neg();
    // If both longs are small, use float multiplication
    if (this.lt($1815771047f19273$var$TWO_PWR_24) && multiplier.lt($1815771047f19273$var$TWO_PWR_24)) return $1815771047f19273$var$fromNumber(this.toNumber() * multiplier.toNumber(), this.unsigned);
    // Divide each long into 4 chunks of 16 bits, and then add up 4x4 products.
    // We can skip products that would overflow.
    var a48 = this.high >>> 16;
    var a32 = this.high & 0xFFFF;
    var a16 = this.low >>> 16;
    var a00 = this.low & 0xFFFF;
    var b48 = multiplier.high >>> 16;
    var b32 = multiplier.high & 0xFFFF;
    var b16 = multiplier.low >>> 16;
    var b00 = multiplier.low & 0xFFFF;
    var c48 = 0, c32 = 0, c16 = 0, c00 = 0;
    c00 += a00 * b00;
    c16 += c00 >>> 16;
    c00 &= 0xFFFF;
    c16 += a16 * b00;
    c32 += c16 >>> 16;
    c16 &= 0xFFFF;
    c16 += a00 * b16;
    c32 += c16 >>> 16;
    c16 &= 0xFFFF;
    c32 += a32 * b00;
    c48 += c32 >>> 16;
    c32 &= 0xFFFF;
    c32 += a16 * b16;
    c48 += c32 >>> 16;
    c32 &= 0xFFFF;
    c32 += a00 * b32;
    c48 += c32 >>> 16;
    c32 &= 0xFFFF;
    c48 += a48 * b00 + a32 * b16 + a16 * b32 + a00 * b48;
    c48 &= 0xFFFF;
    return $1815771047f19273$var$fromBits(c16 << 16 | c00, c48 << 16 | c32, this.unsigned);
};
/**
 * Returns the product of this and the specified Long. This is an alias of {@link Long#multiply}.
 * @function
 * @param {!Long|number|string} multiplier Multiplier
 * @returns {!Long} Product
 */ $1815771047f19273$var$LongPrototype.mul = $1815771047f19273$var$LongPrototype.multiply;
/**
 * Returns this Long divided by the specified. The result is signed if this Long is signed or
 *  unsigned if this Long is unsigned.
 * @param {!Long|number|string} divisor Divisor
 * @returns {!Long} Quotient
 */ $1815771047f19273$var$LongPrototype.divide = function divide(divisor) {
    if (!$1815771047f19273$var$isLong(divisor)) divisor = $1815771047f19273$var$fromValue(divisor);
    if (divisor.isZero()) throw Error("division by zero");
    // use wasm support if present
    if ($1815771047f19273$var$wasm) {
        // guard against signed division overflow: the largest
        // negative number / -1 would be 1 larger than the largest
        // positive number, due to two's complement.
        if (!this.unsigned && this.high === -2147483648 && divisor.low === -1 && divisor.high === -1) // be consistent with non-wasm code path
        return this;
        var low = (this.unsigned ? $1815771047f19273$var$wasm.div_u : $1815771047f19273$var$wasm.div_s)(this.low, this.high, divisor.low, divisor.high);
        return $1815771047f19273$var$fromBits(low, $1815771047f19273$var$wasm.get_high(), this.unsigned);
    }
    if (this.isZero()) return this.unsigned ? $1815771047f19273$var$UZERO : $1815771047f19273$var$ZERO;
    var approx, rem, res;
    if (!this.unsigned) {
        // This section is only relevant for signed longs and is derived from the
        // closure library as a whole.
        if (this.eq($1815771047f19273$var$MIN_VALUE)) {
            if (divisor.eq($1815771047f19273$var$ONE) || divisor.eq($1815771047f19273$var$NEG_ONE)) return $1815771047f19273$var$MIN_VALUE; // recall that -MIN_VALUE == MIN_VALUE
            else if (divisor.eq($1815771047f19273$var$MIN_VALUE)) return $1815771047f19273$var$ONE;
            else {
                // At this point, we have |other| >= 2, so |this/other| < |MIN_VALUE|.
                var halfThis = this.shr(1);
                approx = halfThis.div(divisor).shl(1);
                if (approx.eq($1815771047f19273$var$ZERO)) return divisor.isNegative() ? $1815771047f19273$var$ONE : $1815771047f19273$var$NEG_ONE;
                else {
                    rem = this.sub(divisor.mul(approx));
                    res = approx.add(rem.div(divisor));
                    return res;
                }
            }
        } else if (divisor.eq($1815771047f19273$var$MIN_VALUE)) return this.unsigned ? $1815771047f19273$var$UZERO : $1815771047f19273$var$ZERO;
        if (this.isNegative()) {
            if (divisor.isNegative()) return this.neg().div(divisor.neg());
            return this.neg().div(divisor).neg();
        } else if (divisor.isNegative()) return this.div(divisor.neg()).neg();
        res = $1815771047f19273$var$ZERO;
    } else {
        // The algorithm below has not been made for unsigned longs. It's therefore
        // required to take special care of the MSB prior to running it.
        if (!divisor.unsigned) divisor = divisor.toUnsigned();
        if (divisor.gt(this)) return $1815771047f19273$var$UZERO;
        if (divisor.gt(this.shru(1))) return $1815771047f19273$var$UONE;
        res = $1815771047f19273$var$UZERO;
    }
    // Repeat the following until the remainder is less than other:  find a
    // floating-point that approximates remainder / other *from below*, add this
    // into the result, and subtract it from the remainder.  It is critical that
    // the approximate value is less than or equal to the real value so that the
    // remainder never becomes negative.
    rem = this;
    while(rem.gte(divisor)){
        // Approximate the result of division. This may be a little greater or
        // smaller than the actual value.
        approx = Math.max(1, Math.floor(rem.toNumber() / divisor.toNumber()));
        // We will tweak the approximate result by changing it in the 48-th digit or
        // the smallest non-fractional digit, whichever is larger.
        var log2 = Math.ceil(Math.log(approx) / Math.LN2), delta = log2 <= 48 ? 1 : $1815771047f19273$var$pow_dbl(2, log2 - 48), // Decrease the approximation until it is smaller than the remainder.  Note
        // that if it is too large, the product overflows and is negative.
        approxRes = $1815771047f19273$var$fromNumber(approx), approxRem = approxRes.mul(divisor);
        while(approxRem.isNegative() || approxRem.gt(rem)){
            approx -= delta;
            approxRes = $1815771047f19273$var$fromNumber(approx, this.unsigned);
            approxRem = approxRes.mul(divisor);
        }
        // We know the answer can't be zero... and actually, zero would cause
        // infinite recursion since we would make no progress.
        if (approxRes.isZero()) approxRes = $1815771047f19273$var$ONE;
        res = res.add(approxRes);
        rem = rem.sub(approxRem);
    }
    return res;
};
/**
 * Returns this Long divided by the specified. This is an alias of {@link Long#divide}.
 * @function
 * @param {!Long|number|string} divisor Divisor
 * @returns {!Long} Quotient
 */ $1815771047f19273$var$LongPrototype.div = $1815771047f19273$var$LongPrototype.divide;
/**
 * Returns this Long modulo the specified.
 * @param {!Long|number|string} divisor Divisor
 * @returns {!Long} Remainder
 */ $1815771047f19273$var$LongPrototype.modulo = function modulo(divisor) {
    if (!$1815771047f19273$var$isLong(divisor)) divisor = $1815771047f19273$var$fromValue(divisor);
    // use wasm support if present
    if ($1815771047f19273$var$wasm) {
        var low = (this.unsigned ? $1815771047f19273$var$wasm.rem_u : $1815771047f19273$var$wasm.rem_s)(this.low, this.high, divisor.low, divisor.high);
        return $1815771047f19273$var$fromBits(low, $1815771047f19273$var$wasm.get_high(), this.unsigned);
    }
    return this.sub(this.div(divisor).mul(divisor));
};
/**
 * Returns this Long modulo the specified. This is an alias of {@link Long#modulo}.
 * @function
 * @param {!Long|number|string} divisor Divisor
 * @returns {!Long} Remainder
 */ $1815771047f19273$var$LongPrototype.mod = $1815771047f19273$var$LongPrototype.modulo;
/**
 * Returns this Long modulo the specified. This is an alias of {@link Long#modulo}.
 * @function
 * @param {!Long|number|string} divisor Divisor
 * @returns {!Long} Remainder
 */ $1815771047f19273$var$LongPrototype.rem = $1815771047f19273$var$LongPrototype.modulo;
/**
 * Returns the bitwise NOT of this Long.
 * @returns {!Long}
 */ $1815771047f19273$var$LongPrototype.not = function not() {
    return $1815771047f19273$var$fromBits(~this.low, ~this.high, this.unsigned);
};
/**
 * Returns the bitwise AND of this Long and the specified.
 * @param {!Long|number|string} other Other Long
 * @returns {!Long}
 */ $1815771047f19273$var$LongPrototype.and = function and(other) {
    if (!$1815771047f19273$var$isLong(other)) other = $1815771047f19273$var$fromValue(other);
    return $1815771047f19273$var$fromBits(this.low & other.low, this.high & other.high, this.unsigned);
};
/**
 * Returns the bitwise OR of this Long and the specified.
 * @param {!Long|number|string} other Other Long
 * @returns {!Long}
 */ $1815771047f19273$var$LongPrototype.or = function or(other) {
    if (!$1815771047f19273$var$isLong(other)) other = $1815771047f19273$var$fromValue(other);
    return $1815771047f19273$var$fromBits(this.low | other.low, this.high | other.high, this.unsigned);
};
/**
 * Returns the bitwise XOR of this Long and the given one.
 * @param {!Long|number|string} other Other Long
 * @returns {!Long}
 */ $1815771047f19273$var$LongPrototype.xor = function xor(other) {
    if (!$1815771047f19273$var$isLong(other)) other = $1815771047f19273$var$fromValue(other);
    return $1815771047f19273$var$fromBits(this.low ^ other.low, this.high ^ other.high, this.unsigned);
};
/**
 * Returns this Long with bits shifted to the left by the given amount.
 * @param {number|!Long} numBits Number of bits
 * @returns {!Long} Shifted Long
 */ $1815771047f19273$var$LongPrototype.shiftLeft = function shiftLeft(numBits) {
    if ($1815771047f19273$var$isLong(numBits)) numBits = numBits.toInt();
    if ((numBits &= 63) === 0) return this;
    else if (numBits < 32) return $1815771047f19273$var$fromBits(this.low << numBits, this.high << numBits | this.low >>> 32 - numBits, this.unsigned);
    else return $1815771047f19273$var$fromBits(0, this.low << numBits - 32, this.unsigned);
};
/**
 * Returns this Long with bits shifted to the left by the given amount. This is an alias of {@link Long#shiftLeft}.
 * @function
 * @param {number|!Long} numBits Number of bits
 * @returns {!Long} Shifted Long
 */ $1815771047f19273$var$LongPrototype.shl = $1815771047f19273$var$LongPrototype.shiftLeft;
/**
 * Returns this Long with bits arithmetically shifted to the right by the given amount.
 * @param {number|!Long} numBits Number of bits
 * @returns {!Long} Shifted Long
 */ $1815771047f19273$var$LongPrototype.shiftRight = function shiftRight(numBits) {
    if ($1815771047f19273$var$isLong(numBits)) numBits = numBits.toInt();
    if ((numBits &= 63) === 0) return this;
    else if (numBits < 32) return $1815771047f19273$var$fromBits(this.low >>> numBits | this.high << 32 - numBits, this.high >> numBits, this.unsigned);
    else return $1815771047f19273$var$fromBits(this.high >> numBits - 32, this.high >= 0 ? 0 : -1, this.unsigned);
};
/**
 * Returns this Long with bits arithmetically shifted to the right by the given amount. This is an alias of {@link Long#shiftRight}.
 * @function
 * @param {number|!Long} numBits Number of bits
 * @returns {!Long} Shifted Long
 */ $1815771047f19273$var$LongPrototype.shr = $1815771047f19273$var$LongPrototype.shiftRight;
/**
 * Returns this Long with bits logically shifted to the right by the given amount.
 * @param {number|!Long} numBits Number of bits
 * @returns {!Long} Shifted Long
 */ $1815771047f19273$var$LongPrototype.shiftRightUnsigned = function shiftRightUnsigned(numBits) {
    if ($1815771047f19273$var$isLong(numBits)) numBits = numBits.toInt();
    numBits &= 63;
    if (numBits === 0) return this;
    else {
        var high = this.high;
        if (numBits < 32) {
            var low = this.low;
            return $1815771047f19273$var$fromBits(low >>> numBits | high << 32 - numBits, high >>> numBits, this.unsigned);
        } else if (numBits === 32) return $1815771047f19273$var$fromBits(high, 0, this.unsigned);
        else return $1815771047f19273$var$fromBits(high >>> numBits - 32, 0, this.unsigned);
    }
};
/**
 * Returns this Long with bits logically shifted to the right by the given amount. This is an alias of {@link Long#shiftRightUnsigned}.
 * @function
 * @param {number|!Long} numBits Number of bits
 * @returns {!Long} Shifted Long
 */ $1815771047f19273$var$LongPrototype.shru = $1815771047f19273$var$LongPrototype.shiftRightUnsigned;
/**
 * Returns this Long with bits logically shifted to the right by the given amount. This is an alias of {@link Long#shiftRightUnsigned}.
 * @function
 * @param {number|!Long} numBits Number of bits
 * @returns {!Long} Shifted Long
 */ $1815771047f19273$var$LongPrototype.shr_u = $1815771047f19273$var$LongPrototype.shiftRightUnsigned;
/**
 * Converts this Long to signed.
 * @returns {!Long} Signed long
 */ $1815771047f19273$var$LongPrototype.toSigned = function toSigned() {
    if (!this.unsigned) return this;
    return $1815771047f19273$var$fromBits(this.low, this.high, false);
};
/**
 * Converts this Long to unsigned.
 * @returns {!Long} Unsigned long
 */ $1815771047f19273$var$LongPrototype.toUnsigned = function toUnsigned() {
    if (this.unsigned) return this;
    return $1815771047f19273$var$fromBits(this.low, this.high, true);
};
/**
 * Converts this Long to its byte representation.
 * @param {boolean=} le Whether little or big endian, defaults to big endian
 * @returns {!Array.<number>} Byte representation
 */ $1815771047f19273$var$LongPrototype.toBytes = function toBytes(le) {
    return le ? this.toBytesLE() : this.toBytesBE();
};
/**
 * Converts this Long to its little endian byte representation.
 * @returns {!Array.<number>} Little endian byte representation
 */ $1815771047f19273$var$LongPrototype.toBytesLE = function toBytesLE() {
    var hi = this.high, lo = this.low;
    return [
        lo & 0xff,
        lo >>> 8 & 0xff,
        lo >>> 16 & 0xff,
        lo >>> 24,
        hi & 0xff,
        hi >>> 8 & 0xff,
        hi >>> 16 & 0xff,
        hi >>> 24
    ];
};
/**
 * Converts this Long to its big endian byte representation.
 * @returns {!Array.<number>} Big endian byte representation
 */ $1815771047f19273$var$LongPrototype.toBytesBE = function toBytesBE() {
    var hi = this.high, lo = this.low;
    return [
        hi >>> 24,
        hi >>> 16 & 0xff,
        hi >>> 8 & 0xff,
        hi & 0xff,
        lo >>> 24,
        lo >>> 16 & 0xff,
        lo >>> 8 & 0xff,
        lo & 0xff
    ];
};
/**
 * Creates a Long from its byte representation.
 * @param {!Array.<number>} bytes Byte representation
 * @param {boolean=} unsigned Whether unsigned or not, defaults to signed
 * @param {boolean=} le Whether little or big endian, defaults to big endian
 * @returns {Long} The corresponding Long value
 */ $1815771047f19273$var$Long.fromBytes = function fromBytes(bytes, unsigned, le) {
    return le ? $1815771047f19273$var$Long.fromBytesLE(bytes, unsigned) : $1815771047f19273$var$Long.fromBytesBE(bytes, unsigned);
};
/**
 * Creates a Long from its little endian byte representation.
 * @param {!Array.<number>} bytes Little endian byte representation
 * @param {boolean=} unsigned Whether unsigned or not, defaults to signed
 * @returns {Long} The corresponding Long value
 */ $1815771047f19273$var$Long.fromBytesLE = function fromBytesLE(bytes, unsigned) {
    return new $1815771047f19273$var$Long(bytes[0] | bytes[1] << 8 | bytes[2] << 16 | bytes[3] << 24, bytes[4] | bytes[5] << 8 | bytes[6] << 16 | bytes[7] << 24, unsigned);
};
/**
 * Creates a Long from its big endian byte representation.
 * @param {!Array.<number>} bytes Big endian byte representation
 * @param {boolean=} unsigned Whether unsigned or not, defaults to signed
 * @returns {Long} The corresponding Long value
 */ $1815771047f19273$var$Long.fromBytesBE = function fromBytesBE(bytes, unsigned) {
    return new $1815771047f19273$var$Long(bytes[4] << 24 | bytes[5] << 16 | bytes[6] << 8 | bytes[7], bytes[0] << 24 | bytes[1] << 16 | bytes[2] << 8 | bytes[3], unsigned);
};

});

parcelRequire.register("fnQBP", function(module, exports) {

(function(module1, exports) {
    "use strict";
    // Utils
    function assert(val, msg) {
        if (!val) throw new Error(msg || "Assertion failed");
    }
    // Could use `inherits` module, but don't want to move from single file
    // architecture yet.
    function inherits(ctor, superCtor) {
        ctor.super_ = superCtor;
        var TempCtor = function() {};
        TempCtor.prototype = superCtor.prototype;
        ctor.prototype = new TempCtor();
        ctor.prototype.constructor = ctor;
    }
    // BN
    function BN(number, base, endian) {
        if (BN.isBN(number)) return number;
        this.negative = 0;
        this.words = null;
        this.length = 0;
        // Reduction context
        this.red = null;
        if (number !== null) {
            if (base === "le" || base === "be") {
                endian = base;
                base = 10;
            }
            this._init(number || 0, base || 10, endian || "be");
        }
    }
    if (typeof module1 === "object") module1.exports = BN;
    else exports.BN = BN;
    BN.BN = BN;
    BN.wordSize = 26;
    var Buffer;
    try {
        if (typeof window !== "undefined" && typeof window.Buffer !== "undefined") Buffer = window.Buffer;
        else Buffer = (parcelRequire("5Io6y")).Buffer;
    } catch (e) {}
    BN.isBN = function isBN(num) {
        if (num instanceof BN) return true;
        return num !== null && typeof num === "object" && num.constructor.wordSize === BN.wordSize && Array.isArray(num.words);
    };
    BN.max = function max(left, right) {
        if (left.cmp(right) > 0) return left;
        return right;
    };
    BN.min = function min(left, right) {
        if (left.cmp(right) < 0) return left;
        return right;
    };
    BN.prototype._init = function init(number, base, endian) {
        if (typeof number === "number") return this._initNumber(number, base, endian);
        if (typeof number === "object") return this._initArray(number, base, endian);
        if (base === "hex") base = 16;
        assert(base === (base | 0) && base >= 2 && base <= 36);
        number = number.toString().replace(/\s+/g, "");
        var start = 0;
        if (number[0] === "-") {
            start++;
            this.negative = 1;
        }
        if (start < number.length) {
            if (base === 16) this._parseHex(number, start, endian);
            else {
                this._parseBase(number, base, start);
                if (endian === "le") this._initArray(this.toArray(), base, endian);
            }
        }
    };
    BN.prototype._initNumber = function _initNumber(number, base, endian) {
        if (number < 0) {
            this.negative = 1;
            number = -number;
        }
        if (number < 0x4000000) {
            this.words = [
                number & 0x3ffffff
            ];
            this.length = 1;
        } else if (number < 0x10000000000000) {
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff
            ];
            this.length = 2;
        } else {
            assert(number < 0x20000000000000); // 2 ^ 53 (unsafe)
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff,
                1
            ];
            this.length = 3;
        }
        if (endian !== "le") return;
        // Reverse the bytes
        this._initArray(this.toArray(), base, endian);
    };
    BN.prototype._initArray = function _initArray(number, base, endian) {
        // Perhaps a Uint8Array
        assert(typeof number.length === "number");
        if (number.length <= 0) {
            this.words = [
                0
            ];
            this.length = 1;
            return this;
        }
        this.length = Math.ceil(number.length / 3);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        var j, w;
        var off = 0;
        if (endian === "be") for(i = number.length - 1, j = 0; i >= 0; i -= 3){
            w = number[i] | number[i - 1] << 8 | number[i - 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        else if (endian === "le") for(i = 0, j = 0; i < number.length; i += 3){
            w = number[i] | number[i + 1] << 8 | number[i + 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        return this._strip();
    };
    function parseHex4Bits(string, index) {
        var c = string.charCodeAt(index);
        // '0' - '9'
        if (c >= 48 && c <= 57) return c - 48;
        else if (c >= 65 && c <= 70) return c - 55;
        else if (c >= 97 && c <= 102) return c - 87;
        else assert(false, "Invalid character in " + string);
    }
    function parseHexByte(string, lowerBound, index) {
        var r = parseHex4Bits(string, index);
        if (index - 1 >= lowerBound) r |= parseHex4Bits(string, index - 1) << 4;
        return r;
    }
    BN.prototype._parseHex = function _parseHex(number, start, endian) {
        // Create possibly bigger array to ensure that it fits the number
        this.length = Math.ceil((number.length - start) / 6);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        // 24-bits chunks
        var off = 0;
        var j = 0;
        var w;
        if (endian === "be") for(i = number.length - 1; i >= start; i -= 2){
            w = parseHexByte(number, start, i) << off;
            this.words[j] |= w & 0x3ffffff;
            if (off >= 18) {
                off -= 18;
                j += 1;
                this.words[j] |= w >>> 26;
            } else off += 8;
        }
        else {
            var parseLength = number.length - start;
            for(i = parseLength % 2 === 0 ? start + 1 : start; i < number.length; i += 2){
                w = parseHexByte(number, start, i) << off;
                this.words[j] |= w & 0x3ffffff;
                if (off >= 18) {
                    off -= 18;
                    j += 1;
                    this.words[j] |= w >>> 26;
                } else off += 8;
            }
        }
        this._strip();
    };
    function parseBase(str, start, end, mul) {
        var r = 0;
        var b = 0;
        var len = Math.min(str.length, end);
        for(var i = start; i < len; i++){
            var c = str.charCodeAt(i) - 48;
            r *= mul;
            // 'a'
            if (c >= 49) b = c - 49 + 0xa;
            else if (c >= 17) b = c - 17 + 0xa;
            else b = c;
            assert(c >= 0 && b < mul, "Invalid character");
            r += b;
        }
        return r;
    }
    BN.prototype._parseBase = function _parseBase(number, base, start) {
        // Initialize as zero
        this.words = [
            0
        ];
        this.length = 1;
        // Find length of limb in base
        for(var limbLen = 0, limbPow = 1; limbPow <= 0x3ffffff; limbPow *= base)limbLen++;
        limbLen--;
        limbPow = limbPow / base | 0;
        var total = number.length - start;
        var mod = total % limbLen;
        var end = Math.min(total, total - mod) + start;
        var word = 0;
        for(var i = start; i < end; i += limbLen){
            word = parseBase(number, i, i + limbLen, base);
            this.imuln(limbPow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        if (mod !== 0) {
            var pow = 1;
            word = parseBase(number, i, number.length, base);
            for(i = 0; i < mod; i++)pow *= base;
            this.imuln(pow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        this._strip();
    };
    BN.prototype.copy = function copy(dest) {
        dest.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)dest.words[i] = this.words[i];
        dest.length = this.length;
        dest.negative = this.negative;
        dest.red = this.red;
    };
    function move(dest, src) {
        dest.words = src.words;
        dest.length = src.length;
        dest.negative = src.negative;
        dest.red = src.red;
    }
    BN.prototype._move = function _move(dest) {
        move(dest, this);
    };
    BN.prototype.clone = function clone() {
        var r = new BN(null);
        this.copy(r);
        return r;
    };
    BN.prototype._expand = function _expand(size) {
        while(this.length < size)this.words[this.length++] = 0;
        return this;
    };
    // Remove leading `0` from `this`
    BN.prototype._strip = function strip() {
        while(this.length > 1 && this.words[this.length - 1] === 0)this.length--;
        return this._normSign();
    };
    BN.prototype._normSign = function _normSign() {
        // -0 = 0
        if (this.length === 1 && this.words[0] === 0) this.negative = 0;
        return this;
    };
    // Check Symbol.for because not everywhere where Symbol defined
    // See https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Symbol#Browser_compatibility
    if (typeof Symbol !== "undefined" && typeof Symbol.for === "function") try {
        BN.prototype[Symbol.for("nodejs.util.inspect.custom")] = inspect;
    } catch (e) {
        BN.prototype.inspect = inspect;
    }
    else BN.prototype.inspect = inspect;
    function inspect() {
        return (this.red ? "<BN-R: " : "<BN: ") + this.toString(16) + ">";
    }
    /*

  var zeros = [];
  var groupSizes = [];
  var groupBases = [];

  var s = '';
  var i = -1;
  while (++i < BN.wordSize) {
    zeros[i] = s;
    s += '0';
  }
  groupSizes[0] = 0;
  groupSizes[1] = 0;
  groupBases[0] = 0;
  groupBases[1] = 0;
  var base = 2 - 1;
  while (++base < 36 + 1) {
    var groupSize = 0;
    var groupBase = 1;
    while (groupBase < (1 << BN.wordSize) / base) {
      groupBase *= base;
      groupSize += 1;
    }
    groupSizes[base] = groupSize;
    groupBases[base] = groupBase;
  }

  */ var zeros = [
        "",
        "0",
        "00",
        "000",
        "0000",
        "00000",
        "000000",
        "0000000",
        "00000000",
        "000000000",
        "0000000000",
        "00000000000",
        "000000000000",
        "0000000000000",
        "00000000000000",
        "000000000000000",
        "0000000000000000",
        "00000000000000000",
        "000000000000000000",
        "0000000000000000000",
        "00000000000000000000",
        "000000000000000000000",
        "0000000000000000000000",
        "00000000000000000000000",
        "000000000000000000000000",
        "0000000000000000000000000"
    ];
    var groupSizes = [
        0,
        0,
        25,
        16,
        12,
        11,
        10,
        9,
        8,
        8,
        7,
        7,
        7,
        7,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5
    ];
    var groupBases = [
        0,
        0,
        33554432,
        43046721,
        16777216,
        48828125,
        60466176,
        40353607,
        16777216,
        43046721,
        10000000,
        19487171,
        35831808,
        62748517,
        7529536,
        11390625,
        16777216,
        24137569,
        34012224,
        47045881,
        64000000,
        4084101,
        5153632,
        6436343,
        7962624,
        9765625,
        11881376,
        14348907,
        17210368,
        20511149,
        24300000,
        28629151,
        33554432,
        39135393,
        45435424,
        52521875,
        60466176
    ];
    BN.prototype.toString = function toString(base, padding) {
        base = base || 10;
        padding = padding | 0 || 1;
        var out;
        if (base === 16 || base === "hex") {
            out = "";
            var off = 0;
            var carry = 0;
            for(var i = 0; i < this.length; i++){
                var w = this.words[i];
                var word = ((w << off | carry) & 0xffffff).toString(16);
                carry = w >>> 24 - off & 0xffffff;
                off += 2;
                if (off >= 26) {
                    off -= 26;
                    i--;
                }
                if (carry !== 0 || i !== this.length - 1) out = zeros[6 - word.length] + word + out;
                else out = word + out;
            }
            if (carry !== 0) out = carry.toString(16) + out;
            while(out.length % padding !== 0)out = "0" + out;
            if (this.negative !== 0) out = "-" + out;
            return out;
        }
        if (base === (base | 0) && base >= 2 && base <= 36) {
            // var groupSize = Math.floor(BN.wordSize * Math.LN2 / Math.log(base));
            var groupSize = groupSizes[base];
            // var groupBase = Math.pow(base, groupSize);
            var groupBase = groupBases[base];
            out = "";
            var c = this.clone();
            c.negative = 0;
            while(!c.isZero()){
                var r = c.modrn(groupBase).toString(base);
                c = c.idivn(groupBase);
                if (!c.isZero()) out = zeros[groupSize - r.length] + r + out;
                else out = r + out;
            }
            if (this.isZero()) out = "0" + out;
            while(out.length % padding !== 0)out = "0" + out;
            if (this.negative !== 0) out = "-" + out;
            return out;
        }
        assert(false, "Base should be between 2 and 36");
    };
    BN.prototype.toNumber = function toNumber() {
        var ret = this.words[0];
        if (this.length === 2) ret += this.words[1] * 0x4000000;
        else if (this.length === 3 && this.words[2] === 0x01) // NOTE: at this stage it is known that the top bit is set
        ret += 0x10000000000000 + this.words[1] * 0x4000000;
        else if (this.length > 2) assert(false, "Number can only safely store up to 53 bits");
        return this.negative !== 0 ? -ret : ret;
    };
    BN.prototype.toJSON = function toJSON() {
        return this.toString(16, 2);
    };
    if (Buffer) BN.prototype.toBuffer = function toBuffer(endian, length) {
        return this.toArrayLike(Buffer, endian, length);
    };
    BN.prototype.toArray = function toArray(endian, length) {
        return this.toArrayLike(Array, endian, length);
    };
    var allocate = function allocate(ArrayType, size) {
        if (ArrayType.allocUnsafe) return ArrayType.allocUnsafe(size);
        return new ArrayType(size);
    };
    BN.prototype.toArrayLike = function toArrayLike(ArrayType, endian, length) {
        this._strip();
        var byteLength = this.byteLength();
        var reqLength = length || Math.max(1, byteLength);
        assert(byteLength <= reqLength, "byte array longer than desired length");
        assert(reqLength > 0, "Requested array length <= 0");
        var res = allocate(ArrayType, reqLength);
        var postfix = endian === "le" ? "LE" : "BE";
        this["_toArrayLike" + postfix](res, byteLength);
        return res;
    };
    BN.prototype._toArrayLikeLE = function _toArrayLikeLE(res, byteLength) {
        var position = 0;
        var carry = 0;
        for(var i = 0, shift = 0; i < this.length; i++){
            var word = this.words[i] << shift | carry;
            res[position++] = word & 0xff;
            if (position < res.length) res[position++] = word >> 8 & 0xff;
            if (position < res.length) res[position++] = word >> 16 & 0xff;
            if (shift === 6) {
                if (position < res.length) res[position++] = word >> 24 & 0xff;
                carry = 0;
                shift = 0;
            } else {
                carry = word >>> 24;
                shift += 2;
            }
        }
        if (position < res.length) {
            res[position++] = carry;
            while(position < res.length)res[position++] = 0;
        }
    };
    BN.prototype._toArrayLikeBE = function _toArrayLikeBE(res, byteLength) {
        var position = res.length - 1;
        var carry = 0;
        for(var i = 0, shift = 0; i < this.length; i++){
            var word = this.words[i] << shift | carry;
            res[position--] = word & 0xff;
            if (position >= 0) res[position--] = word >> 8 & 0xff;
            if (position >= 0) res[position--] = word >> 16 & 0xff;
            if (shift === 6) {
                if (position >= 0) res[position--] = word >> 24 & 0xff;
                carry = 0;
                shift = 0;
            } else {
                carry = word >>> 24;
                shift += 2;
            }
        }
        if (position >= 0) {
            res[position--] = carry;
            while(position >= 0)res[position--] = 0;
        }
    };
    if (Math.clz32) BN.prototype._countBits = function _countBits(w) {
        return 32 - Math.clz32(w);
    };
    else BN.prototype._countBits = function _countBits(w) {
        var t = w;
        var r = 0;
        if (t >= 0x1000) {
            r += 13;
            t >>>= 13;
        }
        if (t >= 0x40) {
            r += 7;
            t >>>= 7;
        }
        if (t >= 0x8) {
            r += 4;
            t >>>= 4;
        }
        if (t >= 0x02) {
            r += 2;
            t >>>= 2;
        }
        return r + t;
    };
    BN.prototype._zeroBits = function _zeroBits(w) {
        // Short-cut
        if (w === 0) return 26;
        var t = w;
        var r = 0;
        if ((t & 0x1fff) === 0) {
            r += 13;
            t >>>= 13;
        }
        if ((t & 0x7f) === 0) {
            r += 7;
            t >>>= 7;
        }
        if ((t & 0xf) === 0) {
            r += 4;
            t >>>= 4;
        }
        if ((t & 0x3) === 0) {
            r += 2;
            t >>>= 2;
        }
        if ((t & 0x1) === 0) r++;
        return r;
    };
    // Return number of used bits in a BN
    BN.prototype.bitLength = function bitLength() {
        var w = this.words[this.length - 1];
        var hi = this._countBits(w);
        return (this.length - 1) * 26 + hi;
    };
    function toBitArray(num) {
        var w = new Array(num.bitLength());
        for(var bit = 0; bit < w.length; bit++){
            var off = bit / 26 | 0;
            var wbit = bit % 26;
            w[bit] = num.words[off] >>> wbit & 0x01;
        }
        return w;
    }
    // Number of trailing zero bits
    BN.prototype.zeroBits = function zeroBits() {
        if (this.isZero()) return 0;
        var r = 0;
        for(var i = 0; i < this.length; i++){
            var b = this._zeroBits(this.words[i]);
            r += b;
            if (b !== 26) break;
        }
        return r;
    };
    BN.prototype.byteLength = function byteLength() {
        return Math.ceil(this.bitLength() / 8);
    };
    BN.prototype.toTwos = function toTwos(width) {
        if (this.negative !== 0) return this.abs().inotn(width).iaddn(1);
        return this.clone();
    };
    BN.prototype.fromTwos = function fromTwos(width) {
        if (this.testn(width - 1)) return this.notn(width).iaddn(1).ineg();
        return this.clone();
    };
    BN.prototype.isNeg = function isNeg() {
        return this.negative !== 0;
    };
    // Return negative clone of `this`
    BN.prototype.neg = function neg() {
        return this.clone().ineg();
    };
    BN.prototype.ineg = function ineg() {
        if (!this.isZero()) this.negative ^= 1;
        return this;
    };
    // Or `num` with `this` in-place
    BN.prototype.iuor = function iuor(num) {
        while(this.length < num.length)this.words[this.length++] = 0;
        for(var i = 0; i < num.length; i++)this.words[i] = this.words[i] | num.words[i];
        return this._strip();
    };
    BN.prototype.ior = function ior(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuor(num);
    };
    // Or `num` with `this`
    BN.prototype.or = function or(num) {
        if (this.length > num.length) return this.clone().ior(num);
        return num.clone().ior(this);
    };
    BN.prototype.uor = function uor(num) {
        if (this.length > num.length) return this.clone().iuor(num);
        return num.clone().iuor(this);
    };
    // And `num` with `this` in-place
    BN.prototype.iuand = function iuand(num) {
        // b = min-length(num, this)
        var b;
        if (this.length > num.length) b = num;
        else b = this;
        for(var i = 0; i < b.length; i++)this.words[i] = this.words[i] & num.words[i];
        this.length = b.length;
        return this._strip();
    };
    BN.prototype.iand = function iand(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuand(num);
    };
    // And `num` with `this`
    BN.prototype.and = function and(num) {
        if (this.length > num.length) return this.clone().iand(num);
        return num.clone().iand(this);
    };
    BN.prototype.uand = function uand(num) {
        if (this.length > num.length) return this.clone().iuand(num);
        return num.clone().iuand(this);
    };
    // Xor `num` with `this` in-place
    BN.prototype.iuxor = function iuxor(num) {
        // a.length > b.length
        var a;
        var b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        for(var i = 0; i < b.length; i++)this.words[i] = a.words[i] ^ b.words[i];
        if (this !== a) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = a.length;
        return this._strip();
    };
    BN.prototype.ixor = function ixor(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuxor(num);
    };
    // Xor `num` with `this`
    BN.prototype.xor = function xor(num) {
        if (this.length > num.length) return this.clone().ixor(num);
        return num.clone().ixor(this);
    };
    BN.prototype.uxor = function uxor(num) {
        if (this.length > num.length) return this.clone().iuxor(num);
        return num.clone().iuxor(this);
    };
    // Not ``this`` with ``width`` bitwidth
    BN.prototype.inotn = function inotn(width) {
        assert(typeof width === "number" && width >= 0);
        var bytesNeeded = Math.ceil(width / 26) | 0;
        var bitsLeft = width % 26;
        // Extend the buffer with leading zeroes
        this._expand(bytesNeeded);
        if (bitsLeft > 0) bytesNeeded--;
        // Handle complete words
        for(var i = 0; i < bytesNeeded; i++)this.words[i] = ~this.words[i] & 0x3ffffff;
        // Handle the residue
        if (bitsLeft > 0) this.words[i] = ~this.words[i] & 0x3ffffff >> 26 - bitsLeft;
        // And remove leading zeroes
        return this._strip();
    };
    BN.prototype.notn = function notn(width) {
        return this.clone().inotn(width);
    };
    // Set `bit` of `this`
    BN.prototype.setn = function setn(bit, val) {
        assert(typeof bit === "number" && bit >= 0);
        var off = bit / 26 | 0;
        var wbit = bit % 26;
        this._expand(off + 1);
        if (val) this.words[off] = this.words[off] | 1 << wbit;
        else this.words[off] = this.words[off] & ~(1 << wbit);
        return this._strip();
    };
    // Add `num` to `this` in-place
    BN.prototype.iadd = function iadd(num) {
        var r;
        // negative + positive
        if (this.negative !== 0 && num.negative === 0) {
            this.negative = 0;
            r = this.isub(num);
            this.negative ^= 1;
            return this._normSign();
        // positive + negative
        } else if (this.negative === 0 && num.negative !== 0) {
            num.negative = 0;
            r = this.isub(num);
            num.negative = 1;
            return r._normSign();
        }
        // a.length > b.length
        var a, b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) + (b.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        this.length = a.length;
        if (carry !== 0) {
            this.words[this.length] = carry;
            this.length++;
        // Copy the rest of the words
        } else if (a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        return this;
    };
    // Add `num` to `this`
    BN.prototype.add = function add(num) {
        var res;
        if (num.negative !== 0 && this.negative === 0) {
            num.negative = 0;
            res = this.sub(num);
            num.negative ^= 1;
            return res;
        } else if (num.negative === 0 && this.negative !== 0) {
            this.negative = 0;
            res = num.sub(this);
            this.negative = 1;
            return res;
        }
        if (this.length > num.length) return this.clone().iadd(num);
        return num.clone().iadd(this);
    };
    // Subtract `num` from `this` in-place
    BN.prototype.isub = function isub(num) {
        // this - (-num) = this + num
        if (num.negative !== 0) {
            num.negative = 0;
            var r = this.iadd(num);
            num.negative = 1;
            return r._normSign();
        // -this - num = -(this + num)
        } else if (this.negative !== 0) {
            this.negative = 0;
            this.iadd(num);
            this.negative = 1;
            return this._normSign();
        }
        // At this point both numbers are positive
        var cmp = this.cmp(num);
        // Optimization - zeroify
        if (cmp === 0) {
            this.negative = 0;
            this.length = 1;
            this.words[0] = 0;
            return this;
        }
        // a > b
        var a, b;
        if (cmp > 0) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) - (b.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        // Copy rest of the words
        if (carry === 0 && i < a.length && a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = Math.max(this.length, i);
        if (a !== this) this.negative = 1;
        return this._strip();
    };
    // Subtract `num` from `this`
    BN.prototype.sub = function sub(num) {
        return this.clone().isub(num);
    };
    function smallMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        var len = self.length + num.length | 0;
        out.length = len;
        len = len - 1 | 0;
        // Peel one iteration (compiler can't do it, because of code complexity)
        var a = self.words[0] | 0;
        var b = num.words[0] | 0;
        var r = a * b;
        var lo = r & 0x3ffffff;
        var carry = r / 0x4000000 | 0;
        out.words[0] = lo;
        for(var k = 1; k < len; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = carry >>> 26;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j | 0;
                a = self.words[i] | 0;
                b = num.words[j] | 0;
                r = a * b + rword;
                ncarry += r / 0x4000000 | 0;
                rword = r & 0x3ffffff;
            }
            out.words[k] = rword | 0;
            carry = ncarry | 0;
        }
        if (carry !== 0) out.words[k] = carry | 0;
        else out.length--;
        return out._strip();
    }
    // TODO(indutny): it may be reasonable to omit it for users who don't need
    // to work with 256-bit numbers, otherwise it gives 20% improvement for 256-bit
    // multiplication (like elliptic secp256k1).
    var comb10MulTo = function comb10MulTo(self, num, out) {
        var a = self.words;
        var b = num.words;
        var o = out.words;
        var c = 0;
        var lo;
        var mid;
        var hi;
        var a0 = a[0] | 0;
        var al0 = a0 & 0x1fff;
        var ah0 = a0 >>> 13;
        var a1 = a[1] | 0;
        var al1 = a1 & 0x1fff;
        var ah1 = a1 >>> 13;
        var a2 = a[2] | 0;
        var al2 = a2 & 0x1fff;
        var ah2 = a2 >>> 13;
        var a3 = a[3] | 0;
        var al3 = a3 & 0x1fff;
        var ah3 = a3 >>> 13;
        var a4 = a[4] | 0;
        var al4 = a4 & 0x1fff;
        var ah4 = a4 >>> 13;
        var a5 = a[5] | 0;
        var al5 = a5 & 0x1fff;
        var ah5 = a5 >>> 13;
        var a6 = a[6] | 0;
        var al6 = a6 & 0x1fff;
        var ah6 = a6 >>> 13;
        var a7 = a[7] | 0;
        var al7 = a7 & 0x1fff;
        var ah7 = a7 >>> 13;
        var a8 = a[8] | 0;
        var al8 = a8 & 0x1fff;
        var ah8 = a8 >>> 13;
        var a9 = a[9] | 0;
        var al9 = a9 & 0x1fff;
        var ah9 = a9 >>> 13;
        var b0 = b[0] | 0;
        var bl0 = b0 & 0x1fff;
        var bh0 = b0 >>> 13;
        var b1 = b[1] | 0;
        var bl1 = b1 & 0x1fff;
        var bh1 = b1 >>> 13;
        var b2 = b[2] | 0;
        var bl2 = b2 & 0x1fff;
        var bh2 = b2 >>> 13;
        var b3 = b[3] | 0;
        var bl3 = b3 & 0x1fff;
        var bh3 = b3 >>> 13;
        var b4 = b[4] | 0;
        var bl4 = b4 & 0x1fff;
        var bh4 = b4 >>> 13;
        var b5 = b[5] | 0;
        var bl5 = b5 & 0x1fff;
        var bh5 = b5 >>> 13;
        var b6 = b[6] | 0;
        var bl6 = b6 & 0x1fff;
        var bh6 = b6 >>> 13;
        var b7 = b[7] | 0;
        var bl7 = b7 & 0x1fff;
        var bh7 = b7 >>> 13;
        var b8 = b[8] | 0;
        var bl8 = b8 & 0x1fff;
        var bh8 = b8 >>> 13;
        var b9 = b[9] | 0;
        var bl9 = b9 & 0x1fff;
        var bh9 = b9 >>> 13;
        out.negative = self.negative ^ num.negative;
        out.length = 19;
        /* k = 0 */ lo = Math.imul(al0, bl0);
        mid = Math.imul(al0, bh0);
        mid = mid + Math.imul(ah0, bl0) | 0;
        hi = Math.imul(ah0, bh0);
        var w0 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w0 >>> 26) | 0;
        w0 &= 0x3ffffff;
        /* k = 1 */ lo = Math.imul(al1, bl0);
        mid = Math.imul(al1, bh0);
        mid = mid + Math.imul(ah1, bl0) | 0;
        hi = Math.imul(ah1, bh0);
        lo = lo + Math.imul(al0, bl1) | 0;
        mid = mid + Math.imul(al0, bh1) | 0;
        mid = mid + Math.imul(ah0, bl1) | 0;
        hi = hi + Math.imul(ah0, bh1) | 0;
        var w1 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w1 >>> 26) | 0;
        w1 &= 0x3ffffff;
        /* k = 2 */ lo = Math.imul(al2, bl0);
        mid = Math.imul(al2, bh0);
        mid = mid + Math.imul(ah2, bl0) | 0;
        hi = Math.imul(ah2, bh0);
        lo = lo + Math.imul(al1, bl1) | 0;
        mid = mid + Math.imul(al1, bh1) | 0;
        mid = mid + Math.imul(ah1, bl1) | 0;
        hi = hi + Math.imul(ah1, bh1) | 0;
        lo = lo + Math.imul(al0, bl2) | 0;
        mid = mid + Math.imul(al0, bh2) | 0;
        mid = mid + Math.imul(ah0, bl2) | 0;
        hi = hi + Math.imul(ah0, bh2) | 0;
        var w2 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w2 >>> 26) | 0;
        w2 &= 0x3ffffff;
        /* k = 3 */ lo = Math.imul(al3, bl0);
        mid = Math.imul(al3, bh0);
        mid = mid + Math.imul(ah3, bl0) | 0;
        hi = Math.imul(ah3, bh0);
        lo = lo + Math.imul(al2, bl1) | 0;
        mid = mid + Math.imul(al2, bh1) | 0;
        mid = mid + Math.imul(ah2, bl1) | 0;
        hi = hi + Math.imul(ah2, bh1) | 0;
        lo = lo + Math.imul(al1, bl2) | 0;
        mid = mid + Math.imul(al1, bh2) | 0;
        mid = mid + Math.imul(ah1, bl2) | 0;
        hi = hi + Math.imul(ah1, bh2) | 0;
        lo = lo + Math.imul(al0, bl3) | 0;
        mid = mid + Math.imul(al0, bh3) | 0;
        mid = mid + Math.imul(ah0, bl3) | 0;
        hi = hi + Math.imul(ah0, bh3) | 0;
        var w3 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w3 >>> 26) | 0;
        w3 &= 0x3ffffff;
        /* k = 4 */ lo = Math.imul(al4, bl0);
        mid = Math.imul(al4, bh0);
        mid = mid + Math.imul(ah4, bl0) | 0;
        hi = Math.imul(ah4, bh0);
        lo = lo + Math.imul(al3, bl1) | 0;
        mid = mid + Math.imul(al3, bh1) | 0;
        mid = mid + Math.imul(ah3, bl1) | 0;
        hi = hi + Math.imul(ah3, bh1) | 0;
        lo = lo + Math.imul(al2, bl2) | 0;
        mid = mid + Math.imul(al2, bh2) | 0;
        mid = mid + Math.imul(ah2, bl2) | 0;
        hi = hi + Math.imul(ah2, bh2) | 0;
        lo = lo + Math.imul(al1, bl3) | 0;
        mid = mid + Math.imul(al1, bh3) | 0;
        mid = mid + Math.imul(ah1, bl3) | 0;
        hi = hi + Math.imul(ah1, bh3) | 0;
        lo = lo + Math.imul(al0, bl4) | 0;
        mid = mid + Math.imul(al0, bh4) | 0;
        mid = mid + Math.imul(ah0, bl4) | 0;
        hi = hi + Math.imul(ah0, bh4) | 0;
        var w4 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w4 >>> 26) | 0;
        w4 &= 0x3ffffff;
        /* k = 5 */ lo = Math.imul(al5, bl0);
        mid = Math.imul(al5, bh0);
        mid = mid + Math.imul(ah5, bl0) | 0;
        hi = Math.imul(ah5, bh0);
        lo = lo + Math.imul(al4, bl1) | 0;
        mid = mid + Math.imul(al4, bh1) | 0;
        mid = mid + Math.imul(ah4, bl1) | 0;
        hi = hi + Math.imul(ah4, bh1) | 0;
        lo = lo + Math.imul(al3, bl2) | 0;
        mid = mid + Math.imul(al3, bh2) | 0;
        mid = mid + Math.imul(ah3, bl2) | 0;
        hi = hi + Math.imul(ah3, bh2) | 0;
        lo = lo + Math.imul(al2, bl3) | 0;
        mid = mid + Math.imul(al2, bh3) | 0;
        mid = mid + Math.imul(ah2, bl3) | 0;
        hi = hi + Math.imul(ah2, bh3) | 0;
        lo = lo + Math.imul(al1, bl4) | 0;
        mid = mid + Math.imul(al1, bh4) | 0;
        mid = mid + Math.imul(ah1, bl4) | 0;
        hi = hi + Math.imul(ah1, bh4) | 0;
        lo = lo + Math.imul(al0, bl5) | 0;
        mid = mid + Math.imul(al0, bh5) | 0;
        mid = mid + Math.imul(ah0, bl5) | 0;
        hi = hi + Math.imul(ah0, bh5) | 0;
        var w5 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w5 >>> 26) | 0;
        w5 &= 0x3ffffff;
        /* k = 6 */ lo = Math.imul(al6, bl0);
        mid = Math.imul(al6, bh0);
        mid = mid + Math.imul(ah6, bl0) | 0;
        hi = Math.imul(ah6, bh0);
        lo = lo + Math.imul(al5, bl1) | 0;
        mid = mid + Math.imul(al5, bh1) | 0;
        mid = mid + Math.imul(ah5, bl1) | 0;
        hi = hi + Math.imul(ah5, bh1) | 0;
        lo = lo + Math.imul(al4, bl2) | 0;
        mid = mid + Math.imul(al4, bh2) | 0;
        mid = mid + Math.imul(ah4, bl2) | 0;
        hi = hi + Math.imul(ah4, bh2) | 0;
        lo = lo + Math.imul(al3, bl3) | 0;
        mid = mid + Math.imul(al3, bh3) | 0;
        mid = mid + Math.imul(ah3, bl3) | 0;
        hi = hi + Math.imul(ah3, bh3) | 0;
        lo = lo + Math.imul(al2, bl4) | 0;
        mid = mid + Math.imul(al2, bh4) | 0;
        mid = mid + Math.imul(ah2, bl4) | 0;
        hi = hi + Math.imul(ah2, bh4) | 0;
        lo = lo + Math.imul(al1, bl5) | 0;
        mid = mid + Math.imul(al1, bh5) | 0;
        mid = mid + Math.imul(ah1, bl5) | 0;
        hi = hi + Math.imul(ah1, bh5) | 0;
        lo = lo + Math.imul(al0, bl6) | 0;
        mid = mid + Math.imul(al0, bh6) | 0;
        mid = mid + Math.imul(ah0, bl6) | 0;
        hi = hi + Math.imul(ah0, bh6) | 0;
        var w6 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w6 >>> 26) | 0;
        w6 &= 0x3ffffff;
        /* k = 7 */ lo = Math.imul(al7, bl0);
        mid = Math.imul(al7, bh0);
        mid = mid + Math.imul(ah7, bl0) | 0;
        hi = Math.imul(ah7, bh0);
        lo = lo + Math.imul(al6, bl1) | 0;
        mid = mid + Math.imul(al6, bh1) | 0;
        mid = mid + Math.imul(ah6, bl1) | 0;
        hi = hi + Math.imul(ah6, bh1) | 0;
        lo = lo + Math.imul(al5, bl2) | 0;
        mid = mid + Math.imul(al5, bh2) | 0;
        mid = mid + Math.imul(ah5, bl2) | 0;
        hi = hi + Math.imul(ah5, bh2) | 0;
        lo = lo + Math.imul(al4, bl3) | 0;
        mid = mid + Math.imul(al4, bh3) | 0;
        mid = mid + Math.imul(ah4, bl3) | 0;
        hi = hi + Math.imul(ah4, bh3) | 0;
        lo = lo + Math.imul(al3, bl4) | 0;
        mid = mid + Math.imul(al3, bh4) | 0;
        mid = mid + Math.imul(ah3, bl4) | 0;
        hi = hi + Math.imul(ah3, bh4) | 0;
        lo = lo + Math.imul(al2, bl5) | 0;
        mid = mid + Math.imul(al2, bh5) | 0;
        mid = mid + Math.imul(ah2, bl5) | 0;
        hi = hi + Math.imul(ah2, bh5) | 0;
        lo = lo + Math.imul(al1, bl6) | 0;
        mid = mid + Math.imul(al1, bh6) | 0;
        mid = mid + Math.imul(ah1, bl6) | 0;
        hi = hi + Math.imul(ah1, bh6) | 0;
        lo = lo + Math.imul(al0, bl7) | 0;
        mid = mid + Math.imul(al0, bh7) | 0;
        mid = mid + Math.imul(ah0, bl7) | 0;
        hi = hi + Math.imul(ah0, bh7) | 0;
        var w7 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w7 >>> 26) | 0;
        w7 &= 0x3ffffff;
        /* k = 8 */ lo = Math.imul(al8, bl0);
        mid = Math.imul(al8, bh0);
        mid = mid + Math.imul(ah8, bl0) | 0;
        hi = Math.imul(ah8, bh0);
        lo = lo + Math.imul(al7, bl1) | 0;
        mid = mid + Math.imul(al7, bh1) | 0;
        mid = mid + Math.imul(ah7, bl1) | 0;
        hi = hi + Math.imul(ah7, bh1) | 0;
        lo = lo + Math.imul(al6, bl2) | 0;
        mid = mid + Math.imul(al6, bh2) | 0;
        mid = mid + Math.imul(ah6, bl2) | 0;
        hi = hi + Math.imul(ah6, bh2) | 0;
        lo = lo + Math.imul(al5, bl3) | 0;
        mid = mid + Math.imul(al5, bh3) | 0;
        mid = mid + Math.imul(ah5, bl3) | 0;
        hi = hi + Math.imul(ah5, bh3) | 0;
        lo = lo + Math.imul(al4, bl4) | 0;
        mid = mid + Math.imul(al4, bh4) | 0;
        mid = mid + Math.imul(ah4, bl4) | 0;
        hi = hi + Math.imul(ah4, bh4) | 0;
        lo = lo + Math.imul(al3, bl5) | 0;
        mid = mid + Math.imul(al3, bh5) | 0;
        mid = mid + Math.imul(ah3, bl5) | 0;
        hi = hi + Math.imul(ah3, bh5) | 0;
        lo = lo + Math.imul(al2, bl6) | 0;
        mid = mid + Math.imul(al2, bh6) | 0;
        mid = mid + Math.imul(ah2, bl6) | 0;
        hi = hi + Math.imul(ah2, bh6) | 0;
        lo = lo + Math.imul(al1, bl7) | 0;
        mid = mid + Math.imul(al1, bh7) | 0;
        mid = mid + Math.imul(ah1, bl7) | 0;
        hi = hi + Math.imul(ah1, bh7) | 0;
        lo = lo + Math.imul(al0, bl8) | 0;
        mid = mid + Math.imul(al0, bh8) | 0;
        mid = mid + Math.imul(ah0, bl8) | 0;
        hi = hi + Math.imul(ah0, bh8) | 0;
        var w8 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w8 >>> 26) | 0;
        w8 &= 0x3ffffff;
        /* k = 9 */ lo = Math.imul(al9, bl0);
        mid = Math.imul(al9, bh0);
        mid = mid + Math.imul(ah9, bl0) | 0;
        hi = Math.imul(ah9, bh0);
        lo = lo + Math.imul(al8, bl1) | 0;
        mid = mid + Math.imul(al8, bh1) | 0;
        mid = mid + Math.imul(ah8, bl1) | 0;
        hi = hi + Math.imul(ah8, bh1) | 0;
        lo = lo + Math.imul(al7, bl2) | 0;
        mid = mid + Math.imul(al7, bh2) | 0;
        mid = mid + Math.imul(ah7, bl2) | 0;
        hi = hi + Math.imul(ah7, bh2) | 0;
        lo = lo + Math.imul(al6, bl3) | 0;
        mid = mid + Math.imul(al6, bh3) | 0;
        mid = mid + Math.imul(ah6, bl3) | 0;
        hi = hi + Math.imul(ah6, bh3) | 0;
        lo = lo + Math.imul(al5, bl4) | 0;
        mid = mid + Math.imul(al5, bh4) | 0;
        mid = mid + Math.imul(ah5, bl4) | 0;
        hi = hi + Math.imul(ah5, bh4) | 0;
        lo = lo + Math.imul(al4, bl5) | 0;
        mid = mid + Math.imul(al4, bh5) | 0;
        mid = mid + Math.imul(ah4, bl5) | 0;
        hi = hi + Math.imul(ah4, bh5) | 0;
        lo = lo + Math.imul(al3, bl6) | 0;
        mid = mid + Math.imul(al3, bh6) | 0;
        mid = mid + Math.imul(ah3, bl6) | 0;
        hi = hi + Math.imul(ah3, bh6) | 0;
        lo = lo + Math.imul(al2, bl7) | 0;
        mid = mid + Math.imul(al2, bh7) | 0;
        mid = mid + Math.imul(ah2, bl7) | 0;
        hi = hi + Math.imul(ah2, bh7) | 0;
        lo = lo + Math.imul(al1, bl8) | 0;
        mid = mid + Math.imul(al1, bh8) | 0;
        mid = mid + Math.imul(ah1, bl8) | 0;
        hi = hi + Math.imul(ah1, bh8) | 0;
        lo = lo + Math.imul(al0, bl9) | 0;
        mid = mid + Math.imul(al0, bh9) | 0;
        mid = mid + Math.imul(ah0, bl9) | 0;
        hi = hi + Math.imul(ah0, bh9) | 0;
        var w9 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w9 >>> 26) | 0;
        w9 &= 0x3ffffff;
        /* k = 10 */ lo = Math.imul(al9, bl1);
        mid = Math.imul(al9, bh1);
        mid = mid + Math.imul(ah9, bl1) | 0;
        hi = Math.imul(ah9, bh1);
        lo = lo + Math.imul(al8, bl2) | 0;
        mid = mid + Math.imul(al8, bh2) | 0;
        mid = mid + Math.imul(ah8, bl2) | 0;
        hi = hi + Math.imul(ah8, bh2) | 0;
        lo = lo + Math.imul(al7, bl3) | 0;
        mid = mid + Math.imul(al7, bh3) | 0;
        mid = mid + Math.imul(ah7, bl3) | 0;
        hi = hi + Math.imul(ah7, bh3) | 0;
        lo = lo + Math.imul(al6, bl4) | 0;
        mid = mid + Math.imul(al6, bh4) | 0;
        mid = mid + Math.imul(ah6, bl4) | 0;
        hi = hi + Math.imul(ah6, bh4) | 0;
        lo = lo + Math.imul(al5, bl5) | 0;
        mid = mid + Math.imul(al5, bh5) | 0;
        mid = mid + Math.imul(ah5, bl5) | 0;
        hi = hi + Math.imul(ah5, bh5) | 0;
        lo = lo + Math.imul(al4, bl6) | 0;
        mid = mid + Math.imul(al4, bh6) | 0;
        mid = mid + Math.imul(ah4, bl6) | 0;
        hi = hi + Math.imul(ah4, bh6) | 0;
        lo = lo + Math.imul(al3, bl7) | 0;
        mid = mid + Math.imul(al3, bh7) | 0;
        mid = mid + Math.imul(ah3, bl7) | 0;
        hi = hi + Math.imul(ah3, bh7) | 0;
        lo = lo + Math.imul(al2, bl8) | 0;
        mid = mid + Math.imul(al2, bh8) | 0;
        mid = mid + Math.imul(ah2, bl8) | 0;
        hi = hi + Math.imul(ah2, bh8) | 0;
        lo = lo + Math.imul(al1, bl9) | 0;
        mid = mid + Math.imul(al1, bh9) | 0;
        mid = mid + Math.imul(ah1, bl9) | 0;
        hi = hi + Math.imul(ah1, bh9) | 0;
        var w10 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w10 >>> 26) | 0;
        w10 &= 0x3ffffff;
        /* k = 11 */ lo = Math.imul(al9, bl2);
        mid = Math.imul(al9, bh2);
        mid = mid + Math.imul(ah9, bl2) | 0;
        hi = Math.imul(ah9, bh2);
        lo = lo + Math.imul(al8, bl3) | 0;
        mid = mid + Math.imul(al8, bh3) | 0;
        mid = mid + Math.imul(ah8, bl3) | 0;
        hi = hi + Math.imul(ah8, bh3) | 0;
        lo = lo + Math.imul(al7, bl4) | 0;
        mid = mid + Math.imul(al7, bh4) | 0;
        mid = mid + Math.imul(ah7, bl4) | 0;
        hi = hi + Math.imul(ah7, bh4) | 0;
        lo = lo + Math.imul(al6, bl5) | 0;
        mid = mid + Math.imul(al6, bh5) | 0;
        mid = mid + Math.imul(ah6, bl5) | 0;
        hi = hi + Math.imul(ah6, bh5) | 0;
        lo = lo + Math.imul(al5, bl6) | 0;
        mid = mid + Math.imul(al5, bh6) | 0;
        mid = mid + Math.imul(ah5, bl6) | 0;
        hi = hi + Math.imul(ah5, bh6) | 0;
        lo = lo + Math.imul(al4, bl7) | 0;
        mid = mid + Math.imul(al4, bh7) | 0;
        mid = mid + Math.imul(ah4, bl7) | 0;
        hi = hi + Math.imul(ah4, bh7) | 0;
        lo = lo + Math.imul(al3, bl8) | 0;
        mid = mid + Math.imul(al3, bh8) | 0;
        mid = mid + Math.imul(ah3, bl8) | 0;
        hi = hi + Math.imul(ah3, bh8) | 0;
        lo = lo + Math.imul(al2, bl9) | 0;
        mid = mid + Math.imul(al2, bh9) | 0;
        mid = mid + Math.imul(ah2, bl9) | 0;
        hi = hi + Math.imul(ah2, bh9) | 0;
        var w11 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w11 >>> 26) | 0;
        w11 &= 0x3ffffff;
        /* k = 12 */ lo = Math.imul(al9, bl3);
        mid = Math.imul(al9, bh3);
        mid = mid + Math.imul(ah9, bl3) | 0;
        hi = Math.imul(ah9, bh3);
        lo = lo + Math.imul(al8, bl4) | 0;
        mid = mid + Math.imul(al8, bh4) | 0;
        mid = mid + Math.imul(ah8, bl4) | 0;
        hi = hi + Math.imul(ah8, bh4) | 0;
        lo = lo + Math.imul(al7, bl5) | 0;
        mid = mid + Math.imul(al7, bh5) | 0;
        mid = mid + Math.imul(ah7, bl5) | 0;
        hi = hi + Math.imul(ah7, bh5) | 0;
        lo = lo + Math.imul(al6, bl6) | 0;
        mid = mid + Math.imul(al6, bh6) | 0;
        mid = mid + Math.imul(ah6, bl6) | 0;
        hi = hi + Math.imul(ah6, bh6) | 0;
        lo = lo + Math.imul(al5, bl7) | 0;
        mid = mid + Math.imul(al5, bh7) | 0;
        mid = mid + Math.imul(ah5, bl7) | 0;
        hi = hi + Math.imul(ah5, bh7) | 0;
        lo = lo + Math.imul(al4, bl8) | 0;
        mid = mid + Math.imul(al4, bh8) | 0;
        mid = mid + Math.imul(ah4, bl8) | 0;
        hi = hi + Math.imul(ah4, bh8) | 0;
        lo = lo + Math.imul(al3, bl9) | 0;
        mid = mid + Math.imul(al3, bh9) | 0;
        mid = mid + Math.imul(ah3, bl9) | 0;
        hi = hi + Math.imul(ah3, bh9) | 0;
        var w12 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w12 >>> 26) | 0;
        w12 &= 0x3ffffff;
        /* k = 13 */ lo = Math.imul(al9, bl4);
        mid = Math.imul(al9, bh4);
        mid = mid + Math.imul(ah9, bl4) | 0;
        hi = Math.imul(ah9, bh4);
        lo = lo + Math.imul(al8, bl5) | 0;
        mid = mid + Math.imul(al8, bh5) | 0;
        mid = mid + Math.imul(ah8, bl5) | 0;
        hi = hi + Math.imul(ah8, bh5) | 0;
        lo = lo + Math.imul(al7, bl6) | 0;
        mid = mid + Math.imul(al7, bh6) | 0;
        mid = mid + Math.imul(ah7, bl6) | 0;
        hi = hi + Math.imul(ah7, bh6) | 0;
        lo = lo + Math.imul(al6, bl7) | 0;
        mid = mid + Math.imul(al6, bh7) | 0;
        mid = mid + Math.imul(ah6, bl7) | 0;
        hi = hi + Math.imul(ah6, bh7) | 0;
        lo = lo + Math.imul(al5, bl8) | 0;
        mid = mid + Math.imul(al5, bh8) | 0;
        mid = mid + Math.imul(ah5, bl8) | 0;
        hi = hi + Math.imul(ah5, bh8) | 0;
        lo = lo + Math.imul(al4, bl9) | 0;
        mid = mid + Math.imul(al4, bh9) | 0;
        mid = mid + Math.imul(ah4, bl9) | 0;
        hi = hi + Math.imul(ah4, bh9) | 0;
        var w13 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w13 >>> 26) | 0;
        w13 &= 0x3ffffff;
        /* k = 14 */ lo = Math.imul(al9, bl5);
        mid = Math.imul(al9, bh5);
        mid = mid + Math.imul(ah9, bl5) | 0;
        hi = Math.imul(ah9, bh5);
        lo = lo + Math.imul(al8, bl6) | 0;
        mid = mid + Math.imul(al8, bh6) | 0;
        mid = mid + Math.imul(ah8, bl6) | 0;
        hi = hi + Math.imul(ah8, bh6) | 0;
        lo = lo + Math.imul(al7, bl7) | 0;
        mid = mid + Math.imul(al7, bh7) | 0;
        mid = mid + Math.imul(ah7, bl7) | 0;
        hi = hi + Math.imul(ah7, bh7) | 0;
        lo = lo + Math.imul(al6, bl8) | 0;
        mid = mid + Math.imul(al6, bh8) | 0;
        mid = mid + Math.imul(ah6, bl8) | 0;
        hi = hi + Math.imul(ah6, bh8) | 0;
        lo = lo + Math.imul(al5, bl9) | 0;
        mid = mid + Math.imul(al5, bh9) | 0;
        mid = mid + Math.imul(ah5, bl9) | 0;
        hi = hi + Math.imul(ah5, bh9) | 0;
        var w14 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w14 >>> 26) | 0;
        w14 &= 0x3ffffff;
        /* k = 15 */ lo = Math.imul(al9, bl6);
        mid = Math.imul(al9, bh6);
        mid = mid + Math.imul(ah9, bl6) | 0;
        hi = Math.imul(ah9, bh6);
        lo = lo + Math.imul(al8, bl7) | 0;
        mid = mid + Math.imul(al8, bh7) | 0;
        mid = mid + Math.imul(ah8, bl7) | 0;
        hi = hi + Math.imul(ah8, bh7) | 0;
        lo = lo + Math.imul(al7, bl8) | 0;
        mid = mid + Math.imul(al7, bh8) | 0;
        mid = mid + Math.imul(ah7, bl8) | 0;
        hi = hi + Math.imul(ah7, bh8) | 0;
        lo = lo + Math.imul(al6, bl9) | 0;
        mid = mid + Math.imul(al6, bh9) | 0;
        mid = mid + Math.imul(ah6, bl9) | 0;
        hi = hi + Math.imul(ah6, bh9) | 0;
        var w15 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w15 >>> 26) | 0;
        w15 &= 0x3ffffff;
        /* k = 16 */ lo = Math.imul(al9, bl7);
        mid = Math.imul(al9, bh7);
        mid = mid + Math.imul(ah9, bl7) | 0;
        hi = Math.imul(ah9, bh7);
        lo = lo + Math.imul(al8, bl8) | 0;
        mid = mid + Math.imul(al8, bh8) | 0;
        mid = mid + Math.imul(ah8, bl8) | 0;
        hi = hi + Math.imul(ah8, bh8) | 0;
        lo = lo + Math.imul(al7, bl9) | 0;
        mid = mid + Math.imul(al7, bh9) | 0;
        mid = mid + Math.imul(ah7, bl9) | 0;
        hi = hi + Math.imul(ah7, bh9) | 0;
        var w16 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w16 >>> 26) | 0;
        w16 &= 0x3ffffff;
        /* k = 17 */ lo = Math.imul(al9, bl8);
        mid = Math.imul(al9, bh8);
        mid = mid + Math.imul(ah9, bl8) | 0;
        hi = Math.imul(ah9, bh8);
        lo = lo + Math.imul(al8, bl9) | 0;
        mid = mid + Math.imul(al8, bh9) | 0;
        mid = mid + Math.imul(ah8, bl9) | 0;
        hi = hi + Math.imul(ah8, bh9) | 0;
        var w17 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w17 >>> 26) | 0;
        w17 &= 0x3ffffff;
        /* k = 18 */ lo = Math.imul(al9, bl9);
        mid = Math.imul(al9, bh9);
        mid = mid + Math.imul(ah9, bl9) | 0;
        hi = Math.imul(ah9, bh9);
        var w18 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w18 >>> 26) | 0;
        w18 &= 0x3ffffff;
        o[0] = w0;
        o[1] = w1;
        o[2] = w2;
        o[3] = w3;
        o[4] = w4;
        o[5] = w5;
        o[6] = w6;
        o[7] = w7;
        o[8] = w8;
        o[9] = w9;
        o[10] = w10;
        o[11] = w11;
        o[12] = w12;
        o[13] = w13;
        o[14] = w14;
        o[15] = w15;
        o[16] = w16;
        o[17] = w17;
        o[18] = w18;
        if (c !== 0) {
            o[19] = c;
            out.length++;
        }
        return out;
    };
    // Polyfill comb
    if (!Math.imul) comb10MulTo = smallMulTo;
    function bigMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        out.length = self.length + num.length;
        var carry = 0;
        var hncarry = 0;
        for(var k = 0; k < out.length - 1; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = hncarry;
            hncarry = 0;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j;
                var a = self.words[i] | 0;
                var b = num.words[j] | 0;
                var r = a * b;
                var lo = r & 0x3ffffff;
                ncarry = ncarry + (r / 0x4000000 | 0) | 0;
                lo = lo + rword | 0;
                rword = lo & 0x3ffffff;
                ncarry = ncarry + (lo >>> 26) | 0;
                hncarry += ncarry >>> 26;
                ncarry &= 0x3ffffff;
            }
            out.words[k] = rword;
            carry = ncarry;
            ncarry = hncarry;
        }
        if (carry !== 0) out.words[k] = carry;
        else out.length--;
        return out._strip();
    }
    function jumboMulTo(self, num, out) {
        // Temporary disable, see https://github.com/indutny/bn.js/issues/211
        // var fftm = new FFTM();
        // return fftm.mulp(self, num, out);
        return bigMulTo(self, num, out);
    }
    BN.prototype.mulTo = function mulTo(num, out) {
        var res;
        var len = this.length + num.length;
        if (this.length === 10 && num.length === 10) res = comb10MulTo(this, num, out);
        else if (len < 63) res = smallMulTo(this, num, out);
        else if (len < 1024) res = bigMulTo(this, num, out);
        else res = jumboMulTo(this, num, out);
        return res;
    };
    // Cooley-Tukey algorithm for FFT
    // slightly revisited to rely on looping instead of recursion
    function FFTM(x, y) {
        this.x = x;
        this.y = y;
    }
    FFTM.prototype.makeRBT = function makeRBT(N) {
        var t = new Array(N);
        var l = BN.prototype._countBits(N) - 1;
        for(var i = 0; i < N; i++)t[i] = this.revBin(i, l, N);
        return t;
    };
    // Returns binary-reversed representation of `x`
    FFTM.prototype.revBin = function revBin(x, l, N) {
        if (x === 0 || x === N - 1) return x;
        var rb = 0;
        for(var i = 0; i < l; i++){
            rb |= (x & 1) << l - i - 1;
            x >>= 1;
        }
        return rb;
    };
    // Performs "tweedling" phase, therefore 'emulating'
    // behaviour of the recursive algorithm
    FFTM.prototype.permute = function permute(rbt, rws, iws, rtws, itws, N) {
        for(var i = 0; i < N; i++){
            rtws[i] = rws[rbt[i]];
            itws[i] = iws[rbt[i]];
        }
    };
    FFTM.prototype.transform = function transform(rws, iws, rtws, itws, N, rbt) {
        this.permute(rbt, rws, iws, rtws, itws, N);
        for(var s = 1; s < N; s <<= 1){
            var l = s << 1;
            var rtwdf = Math.cos(2 * Math.PI / l);
            var itwdf = Math.sin(2 * Math.PI / l);
            for(var p = 0; p < N; p += l){
                var rtwdf_ = rtwdf;
                var itwdf_ = itwdf;
                for(var j = 0; j < s; j++){
                    var re = rtws[p + j];
                    var ie = itws[p + j];
                    var ro = rtws[p + j + s];
                    var io = itws[p + j + s];
                    var rx = rtwdf_ * ro - itwdf_ * io;
                    io = rtwdf_ * io + itwdf_ * ro;
                    ro = rx;
                    rtws[p + j] = re + ro;
                    itws[p + j] = ie + io;
                    rtws[p + j + s] = re - ro;
                    itws[p + j + s] = ie - io;
                    /* jshint maxdepth : false */ if (j !== l) {
                        rx = rtwdf * rtwdf_ - itwdf * itwdf_;
                        itwdf_ = rtwdf * itwdf_ + itwdf * rtwdf_;
                        rtwdf_ = rx;
                    }
                }
            }
        }
    };
    FFTM.prototype.guessLen13b = function guessLen13b(n, m) {
        var N = Math.max(m, n) | 1;
        var odd = N & 1;
        var i = 0;
        for(N = N / 2 | 0; N; N = N >>> 1)i++;
        return 1 << i + 1 + odd;
    };
    FFTM.prototype.conjugate = function conjugate(rws, iws, N) {
        if (N <= 1) return;
        for(var i = 0; i < N / 2; i++){
            var t = rws[i];
            rws[i] = rws[N - i - 1];
            rws[N - i - 1] = t;
            t = iws[i];
            iws[i] = -iws[N - i - 1];
            iws[N - i - 1] = -t;
        }
    };
    FFTM.prototype.normalize13b = function normalize13b(ws, N) {
        var carry = 0;
        for(var i = 0; i < N / 2; i++){
            var w = Math.round(ws[2 * i + 1] / N) * 0x2000 + Math.round(ws[2 * i] / N) + carry;
            ws[i] = w & 0x3ffffff;
            if (w < 0x4000000) carry = 0;
            else carry = w / 0x4000000 | 0;
        }
        return ws;
    };
    FFTM.prototype.convert13b = function convert13b(ws, len, rws, N) {
        var carry = 0;
        for(var i = 0; i < len; i++){
            carry = carry + (ws[i] | 0);
            rws[2 * i] = carry & 0x1fff;
            carry = carry >>> 13;
            rws[2 * i + 1] = carry & 0x1fff;
            carry = carry >>> 13;
        }
        // Pad with zeroes
        for(i = 2 * len; i < N; ++i)rws[i] = 0;
        assert(carry === 0);
        assert((carry & -8192) === 0);
    };
    FFTM.prototype.stub = function stub(N) {
        var ph = new Array(N);
        for(var i = 0; i < N; i++)ph[i] = 0;
        return ph;
    };
    FFTM.prototype.mulp = function mulp(x, y, out) {
        var N = 2 * this.guessLen13b(x.length, y.length);
        var rbt = this.makeRBT(N);
        var _ = this.stub(N);
        var rws = new Array(N);
        var rwst = new Array(N);
        var iwst = new Array(N);
        var nrws = new Array(N);
        var nrwst = new Array(N);
        var niwst = new Array(N);
        var rmws = out.words;
        rmws.length = N;
        this.convert13b(x.words, x.length, rws, N);
        this.convert13b(y.words, y.length, nrws, N);
        this.transform(rws, _, rwst, iwst, N, rbt);
        this.transform(nrws, _, nrwst, niwst, N, rbt);
        for(var i = 0; i < N; i++){
            var rx = rwst[i] * nrwst[i] - iwst[i] * niwst[i];
            iwst[i] = rwst[i] * niwst[i] + iwst[i] * nrwst[i];
            rwst[i] = rx;
        }
        this.conjugate(rwst, iwst, N);
        this.transform(rwst, iwst, rmws, _, N, rbt);
        this.conjugate(rmws, _, N);
        this.normalize13b(rmws, N);
        out.negative = x.negative ^ y.negative;
        out.length = x.length + y.length;
        return out._strip();
    };
    // Multiply `this` by `num`
    BN.prototype.mul = function mul(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return this.mulTo(num, out);
    };
    // Multiply employing FFT
    BN.prototype.mulf = function mulf(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return jumboMulTo(this, num, out);
    };
    // In-place Multiplication
    BN.prototype.imul = function imul(num) {
        return this.clone().mulTo(num, this);
    };
    BN.prototype.imuln = function imuln(num) {
        var isNegNum = num < 0;
        if (isNegNum) num = -num;
        assert(typeof num === "number");
        assert(num < 0x4000000);
        // Carry
        var carry = 0;
        for(var i = 0; i < this.length; i++){
            var w = (this.words[i] | 0) * num;
            var lo = (w & 0x3ffffff) + (carry & 0x3ffffff);
            carry >>= 26;
            carry += w / 0x4000000 | 0;
            // NOTE: lo is 27bit maximum
            carry += lo >>> 26;
            this.words[i] = lo & 0x3ffffff;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return isNegNum ? this.ineg() : this;
    };
    BN.prototype.muln = function muln(num) {
        return this.clone().imuln(num);
    };
    // `this` * `this`
    BN.prototype.sqr = function sqr() {
        return this.mul(this);
    };
    // `this` * `this` in-place
    BN.prototype.isqr = function isqr() {
        return this.imul(this.clone());
    };
    // Math.pow(`this`, `num`)
    BN.prototype.pow = function pow(num) {
        var w = toBitArray(num);
        if (w.length === 0) return new BN(1);
        // Skip leading zeroes
        var res = this;
        for(var i = 0; i < w.length; i++, res = res.sqr()){
            if (w[i] !== 0) break;
        }
        if (++i < w.length) for(var q = res.sqr(); i < w.length; i++, q = q.sqr()){
            if (w[i] === 0) continue;
            res = res.mul(q);
        }
        return res;
    };
    // Shift-left in-place
    BN.prototype.iushln = function iushln(bits) {
        assert(typeof bits === "number" && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        var carryMask = 0x3ffffff >>> 26 - r << 26 - r;
        var i;
        if (r !== 0) {
            var carry = 0;
            for(i = 0; i < this.length; i++){
                var newCarry = this.words[i] & carryMask;
                var c = (this.words[i] | 0) - newCarry << r;
                this.words[i] = c | carry;
                carry = newCarry >>> 26 - r;
            }
            if (carry) {
                this.words[i] = carry;
                this.length++;
            }
        }
        if (s !== 0) {
            for(i = this.length - 1; i >= 0; i--)this.words[i + s] = this.words[i];
            for(i = 0; i < s; i++)this.words[i] = 0;
            this.length += s;
        }
        return this._strip();
    };
    BN.prototype.ishln = function ishln(bits) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushln(bits);
    };
    // Shift-right in-place
    // NOTE: `hint` is a lowest bit before trailing zeroes
    // NOTE: if `extended` is present - it will be filled with destroyed bits
    BN.prototype.iushrn = function iushrn(bits, hint, extended) {
        assert(typeof bits === "number" && bits >= 0);
        var h;
        if (hint) h = (hint - hint % 26) / 26;
        else h = 0;
        var r = bits % 26;
        var s = Math.min((bits - r) / 26, this.length);
        var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
        var maskedWords = extended;
        h -= s;
        h = Math.max(0, h);
        // Extended mode, copy masked part
        if (maskedWords) {
            for(var i = 0; i < s; i++)maskedWords.words[i] = this.words[i];
            maskedWords.length = s;
        }
        if (s === 0) ;
        else if (this.length > s) {
            this.length -= s;
            for(i = 0; i < this.length; i++)this.words[i] = this.words[i + s];
        } else {
            this.words[0] = 0;
            this.length = 1;
        }
        var carry = 0;
        for(i = this.length - 1; i >= 0 && (carry !== 0 || i >= h); i--){
            var word = this.words[i] | 0;
            this.words[i] = carry << 26 - r | word >>> r;
            carry = word & mask;
        }
        // Push carried bits as a mask
        if (maskedWords && carry !== 0) maskedWords.words[maskedWords.length++] = carry;
        if (this.length === 0) {
            this.words[0] = 0;
            this.length = 1;
        }
        return this._strip();
    };
    BN.prototype.ishrn = function ishrn(bits, hint, extended) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushrn(bits, hint, extended);
    };
    // Shift-left
    BN.prototype.shln = function shln(bits) {
        return this.clone().ishln(bits);
    };
    BN.prototype.ushln = function ushln(bits) {
        return this.clone().iushln(bits);
    };
    // Shift-right
    BN.prototype.shrn = function shrn(bits) {
        return this.clone().ishrn(bits);
    };
    BN.prototype.ushrn = function ushrn(bits) {
        return this.clone().iushrn(bits);
    };
    // Test if n bit is set
    BN.prototype.testn = function testn(bit) {
        assert(typeof bit === "number" && bit >= 0);
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) return false;
        // Check bit and return
        var w = this.words[s];
        return !!(w & q);
    };
    // Return only lowers bits of number (in-place)
    BN.prototype.imaskn = function imaskn(bits) {
        assert(typeof bits === "number" && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        assert(this.negative === 0, "imaskn works only with positive numbers");
        if (this.length <= s) return this;
        if (r !== 0) s++;
        this.length = Math.min(s, this.length);
        if (r !== 0) {
            var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
            this.words[this.length - 1] &= mask;
        }
        return this._strip();
    };
    // Return only lowers bits of number
    BN.prototype.maskn = function maskn(bits) {
        return this.clone().imaskn(bits);
    };
    // Add plain number `num` to `this`
    BN.prototype.iaddn = function iaddn(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        if (num < 0) return this.isubn(-num);
        // Possible sign change
        if (this.negative !== 0) {
            if (this.length === 1 && (this.words[0] | 0) <= num) {
                this.words[0] = num - (this.words[0] | 0);
                this.negative = 0;
                return this;
            }
            this.negative = 0;
            this.isubn(num);
            this.negative = 1;
            return this;
        }
        // Add without checks
        return this._iaddn(num);
    };
    BN.prototype._iaddn = function _iaddn(num) {
        this.words[0] += num;
        // Carry
        for(var i = 0; i < this.length && this.words[i] >= 0x4000000; i++){
            this.words[i] -= 0x4000000;
            if (i === this.length - 1) this.words[i + 1] = 1;
            else this.words[i + 1]++;
        }
        this.length = Math.max(this.length, i + 1);
        return this;
    };
    // Subtract plain number `num` from `this`
    BN.prototype.isubn = function isubn(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        if (num < 0) return this.iaddn(-num);
        if (this.negative !== 0) {
            this.negative = 0;
            this.iaddn(num);
            this.negative = 1;
            return this;
        }
        this.words[0] -= num;
        if (this.length === 1 && this.words[0] < 0) {
            this.words[0] = -this.words[0];
            this.negative = 1;
        } else // Carry
        for(var i = 0; i < this.length && this.words[i] < 0; i++){
            this.words[i] += 0x4000000;
            this.words[i + 1] -= 1;
        }
        return this._strip();
    };
    BN.prototype.addn = function addn(num) {
        return this.clone().iaddn(num);
    };
    BN.prototype.subn = function subn(num) {
        return this.clone().isubn(num);
    };
    BN.prototype.iabs = function iabs() {
        this.negative = 0;
        return this;
    };
    BN.prototype.abs = function abs() {
        return this.clone().iabs();
    };
    BN.prototype._ishlnsubmul = function _ishlnsubmul(num, mul, shift) {
        var len = num.length + shift;
        var i;
        this._expand(len);
        var w;
        var carry = 0;
        for(i = 0; i < num.length; i++){
            w = (this.words[i + shift] | 0) + carry;
            var right = (num.words[i] | 0) * mul;
            w -= right & 0x3ffffff;
            carry = (w >> 26) - (right / 0x4000000 | 0);
            this.words[i + shift] = w & 0x3ffffff;
        }
        for(; i < this.length - shift; i++){
            w = (this.words[i + shift] | 0) + carry;
            carry = w >> 26;
            this.words[i + shift] = w & 0x3ffffff;
        }
        if (carry === 0) return this._strip();
        // Subtraction overflow
        assert(carry === -1);
        carry = 0;
        for(i = 0; i < this.length; i++){
            w = -(this.words[i] | 0) + carry;
            carry = w >> 26;
            this.words[i] = w & 0x3ffffff;
        }
        this.negative = 1;
        return this._strip();
    };
    BN.prototype._wordDiv = function _wordDiv(num, mode) {
        var shift = this.length - num.length;
        var a = this.clone();
        var b = num;
        // Normalize
        var bhi = b.words[b.length - 1] | 0;
        var bhiBits = this._countBits(bhi);
        shift = 26 - bhiBits;
        if (shift !== 0) {
            b = b.ushln(shift);
            a.iushln(shift);
            bhi = b.words[b.length - 1] | 0;
        }
        // Initialize quotient
        var m = a.length - b.length;
        var q;
        if (mode !== "mod") {
            q = new BN(null);
            q.length = m + 1;
            q.words = new Array(q.length);
            for(var i = 0; i < q.length; i++)q.words[i] = 0;
        }
        var diff = a.clone()._ishlnsubmul(b, 1, m);
        if (diff.negative === 0) {
            a = diff;
            if (q) q.words[m] = 1;
        }
        for(var j = m - 1; j >= 0; j--){
            var qj = (a.words[b.length + j] | 0) * 0x4000000 + (a.words[b.length + j - 1] | 0);
            // NOTE: (qj / bhi) is (0x3ffffff * 0x4000000 + 0x3ffffff) / 0x2000000 max
            // (0x7ffffff)
            qj = Math.min(qj / bhi | 0, 0x3ffffff);
            a._ishlnsubmul(b, qj, j);
            while(a.negative !== 0){
                qj--;
                a.negative = 0;
                a._ishlnsubmul(b, 1, j);
                if (!a.isZero()) a.negative ^= 1;
            }
            if (q) q.words[j] = qj;
        }
        if (q) q._strip();
        a._strip();
        // Denormalize
        if (mode !== "div" && shift !== 0) a.iushrn(shift);
        return {
            div: q || null,
            mod: a
        };
    };
    // NOTE: 1) `mode` can be set to `mod` to request mod only,
    //       to `div` to request div only, or be absent to
    //       request both div & mod
    //       2) `positive` is true if unsigned mod is requested
    BN.prototype.divmod = function divmod(num, mode, positive) {
        assert(!num.isZero());
        if (this.isZero()) return {
            div: new BN(0),
            mod: new BN(0)
        };
        var div, mod, res;
        if (this.negative !== 0 && num.negative === 0) {
            res = this.neg().divmod(num, mode);
            if (mode !== "mod") div = res.div.neg();
            if (mode !== "div") {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.iadd(num);
            }
            return {
                div: div,
                mod: mod
            };
        }
        if (this.negative === 0 && num.negative !== 0) {
            res = this.divmod(num.neg(), mode);
            if (mode !== "mod") div = res.div.neg();
            return {
                div: div,
                mod: res.mod
            };
        }
        if ((this.negative & num.negative) !== 0) {
            res = this.neg().divmod(num.neg(), mode);
            if (mode !== "div") {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.isub(num);
            }
            return {
                div: res.div,
                mod: mod
            };
        }
        // Both numbers are positive at this point
        // Strip both numbers to approximate shift value
        if (num.length > this.length || this.cmp(num) < 0) return {
            div: new BN(0),
            mod: this
        };
        // Very short reduction
        if (num.length === 1) {
            if (mode === "div") return {
                div: this.divn(num.words[0]),
                mod: null
            };
            if (mode === "mod") return {
                div: null,
                mod: new BN(this.modrn(num.words[0]))
            };
            return {
                div: this.divn(num.words[0]),
                mod: new BN(this.modrn(num.words[0]))
            };
        }
        return this._wordDiv(num, mode);
    };
    // Find `this` / `num`
    BN.prototype.div = function div(num) {
        return this.divmod(num, "div", false).div;
    };
    // Find `this` % `num`
    BN.prototype.mod = function mod(num) {
        return this.divmod(num, "mod", false).mod;
    };
    BN.prototype.umod = function umod(num) {
        return this.divmod(num, "mod", true).mod;
    };
    // Find Round(`this` / `num`)
    BN.prototype.divRound = function divRound(num) {
        var dm = this.divmod(num);
        // Fast case - exact division
        if (dm.mod.isZero()) return dm.div;
        var mod = dm.div.negative !== 0 ? dm.mod.isub(num) : dm.mod;
        var half = num.ushrn(1);
        var r2 = num.andln(1);
        var cmp = mod.cmp(half);
        // Round down
        if (cmp < 0 || r2 === 1 && cmp === 0) return dm.div;
        // Round up
        return dm.div.negative !== 0 ? dm.div.isubn(1) : dm.div.iaddn(1);
    };
    BN.prototype.modrn = function modrn(num) {
        var isNegNum = num < 0;
        if (isNegNum) num = -num;
        assert(num <= 0x3ffffff);
        var p = 67108864 % num;
        var acc = 0;
        for(var i = this.length - 1; i >= 0; i--)acc = (p * acc + (this.words[i] | 0)) % num;
        return isNegNum ? -acc : acc;
    };
    // WARNING: DEPRECATED
    BN.prototype.modn = function modn(num) {
        return this.modrn(num);
    };
    // In-place division by number
    BN.prototype.idivn = function idivn(num) {
        var isNegNum = num < 0;
        if (isNegNum) num = -num;
        assert(num <= 0x3ffffff);
        var carry = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var w = (this.words[i] | 0) + carry * 0x4000000;
            this.words[i] = w / num | 0;
            carry = w % num;
        }
        this._strip();
        return isNegNum ? this.ineg() : this;
    };
    BN.prototype.divn = function divn(num) {
        return this.clone().idivn(num);
    };
    BN.prototype.egcd = function egcd(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var x = this;
        var y = p.clone();
        if (x.negative !== 0) x = x.umod(p);
        else x = x.clone();
        // A * x + B * y = x
        var A = new BN(1);
        var B = new BN(0);
        // C * x + D * y = y
        var C = new BN(0);
        var D = new BN(1);
        var g = 0;
        while(x.isEven() && y.isEven()){
            x.iushrn(1);
            y.iushrn(1);
            ++g;
        }
        var yp = y.clone();
        var xp = x.clone();
        while(!x.isZero()){
            for(var i = 0, im = 1; (x.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                x.iushrn(i);
                while(i-- > 0){
                    if (A.isOdd() || B.isOdd()) {
                        A.iadd(yp);
                        B.isub(xp);
                    }
                    A.iushrn(1);
                    B.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (y.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                y.iushrn(j);
                while(j-- > 0){
                    if (C.isOdd() || D.isOdd()) {
                        C.iadd(yp);
                        D.isub(xp);
                    }
                    C.iushrn(1);
                    D.iushrn(1);
                }
            }
            if (x.cmp(y) >= 0) {
                x.isub(y);
                A.isub(C);
                B.isub(D);
            } else {
                y.isub(x);
                C.isub(A);
                D.isub(B);
            }
        }
        return {
            a: C,
            b: D,
            gcd: y.iushln(g)
        };
    };
    // This is reduced incarnation of the binary EEA
    // above, designated to invert members of the
    // _prime_ fields F(p) at a maximal speed
    BN.prototype._invmp = function _invmp(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var a = this;
        var b = p.clone();
        if (a.negative !== 0) a = a.umod(p);
        else a = a.clone();
        var x1 = new BN(1);
        var x2 = new BN(0);
        var delta = b.clone();
        while(a.cmpn(1) > 0 && b.cmpn(1) > 0){
            for(var i = 0, im = 1; (a.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                a.iushrn(i);
                while(i-- > 0){
                    if (x1.isOdd()) x1.iadd(delta);
                    x1.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (b.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                b.iushrn(j);
                while(j-- > 0){
                    if (x2.isOdd()) x2.iadd(delta);
                    x2.iushrn(1);
                }
            }
            if (a.cmp(b) >= 0) {
                a.isub(b);
                x1.isub(x2);
            } else {
                b.isub(a);
                x2.isub(x1);
            }
        }
        var res;
        if (a.cmpn(1) === 0) res = x1;
        else res = x2;
        if (res.cmpn(0) < 0) res.iadd(p);
        return res;
    };
    BN.prototype.gcd = function gcd(num) {
        if (this.isZero()) return num.abs();
        if (num.isZero()) return this.abs();
        var a = this.clone();
        var b = num.clone();
        a.negative = 0;
        b.negative = 0;
        // Remove common factor of two
        for(var shift = 0; a.isEven() && b.isEven(); shift++){
            a.iushrn(1);
            b.iushrn(1);
        }
        do {
            while(a.isEven())a.iushrn(1);
            while(b.isEven())b.iushrn(1);
            var r = a.cmp(b);
            if (r < 0) {
                // Swap `a` and `b` to make `a` always bigger than `b`
                var t = a;
                a = b;
                b = t;
            } else if (r === 0 || b.cmpn(1) === 0) break;
            a.isub(b);
        }while (true);
        return b.iushln(shift);
    };
    // Invert number in the field F(num)
    BN.prototype.invm = function invm(num) {
        return this.egcd(num).a.umod(num);
    };
    BN.prototype.isEven = function isEven() {
        return (this.words[0] & 1) === 0;
    };
    BN.prototype.isOdd = function isOdd() {
        return (this.words[0] & 1) === 1;
    };
    // And first word and num
    BN.prototype.andln = function andln(num) {
        return this.words[0] & num;
    };
    // Increment at the bit position in-line
    BN.prototype.bincn = function bincn(bit) {
        assert(typeof bit === "number");
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) {
            this._expand(s + 1);
            this.words[s] |= q;
            return this;
        }
        // Add bit and propagate, if needed
        var carry = q;
        for(var i = s; carry !== 0 && i < this.length; i++){
            var w = this.words[i] | 0;
            w += carry;
            carry = w >>> 26;
            w &= 0x3ffffff;
            this.words[i] = w;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return this;
    };
    BN.prototype.isZero = function isZero() {
        return this.length === 1 && this.words[0] === 0;
    };
    BN.prototype.cmpn = function cmpn(num) {
        var negative = num < 0;
        if (this.negative !== 0 && !negative) return -1;
        if (this.negative === 0 && negative) return 1;
        this._strip();
        var res;
        if (this.length > 1) res = 1;
        else {
            if (negative) num = -num;
            assert(num <= 0x3ffffff, "Number is too big");
            var w = this.words[0] | 0;
            res = w === num ? 0 : w < num ? -1 : 1;
        }
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Compare two numbers and return:
    // 1 - if `this` > `num`
    // 0 - if `this` == `num`
    // -1 - if `this` < `num`
    BN.prototype.cmp = function cmp(num) {
        if (this.negative !== 0 && num.negative === 0) return -1;
        if (this.negative === 0 && num.negative !== 0) return 1;
        var res = this.ucmp(num);
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Unsigned comparison
    BN.prototype.ucmp = function ucmp(num) {
        // At this point both numbers have the same sign
        if (this.length > num.length) return 1;
        if (this.length < num.length) return -1;
        var res = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var a = this.words[i] | 0;
            var b = num.words[i] | 0;
            if (a === b) continue;
            if (a < b) res = -1;
            else if (a > b) res = 1;
            break;
        }
        return res;
    };
    BN.prototype.gtn = function gtn(num) {
        return this.cmpn(num) === 1;
    };
    BN.prototype.gt = function gt(num) {
        return this.cmp(num) === 1;
    };
    BN.prototype.gten = function gten(num) {
        return this.cmpn(num) >= 0;
    };
    BN.prototype.gte = function gte(num) {
        return this.cmp(num) >= 0;
    };
    BN.prototype.ltn = function ltn(num) {
        return this.cmpn(num) === -1;
    };
    BN.prototype.lt = function lt(num) {
        return this.cmp(num) === -1;
    };
    BN.prototype.lten = function lten(num) {
        return this.cmpn(num) <= 0;
    };
    BN.prototype.lte = function lte(num) {
        return this.cmp(num) <= 0;
    };
    BN.prototype.eqn = function eqn(num) {
        return this.cmpn(num) === 0;
    };
    BN.prototype.eq = function eq(num) {
        return this.cmp(num) === 0;
    };
    //
    // A reduce context, could be using montgomery or something better, depending
    // on the `m` itself.
    //
    BN.red = function red(num) {
        return new Red(num);
    };
    BN.prototype.toRed = function toRed(ctx) {
        assert(!this.red, "Already a number in reduction context");
        assert(this.negative === 0, "red works only with positives");
        return ctx.convertTo(this)._forceRed(ctx);
    };
    BN.prototype.fromRed = function fromRed() {
        assert(this.red, "fromRed works only with numbers in reduction context");
        return this.red.convertFrom(this);
    };
    BN.prototype._forceRed = function _forceRed(ctx) {
        this.red = ctx;
        return this;
    };
    BN.prototype.forceRed = function forceRed(ctx) {
        assert(!this.red, "Already a number in reduction context");
        return this._forceRed(ctx);
    };
    BN.prototype.redAdd = function redAdd(num) {
        assert(this.red, "redAdd works only with red numbers");
        return this.red.add(this, num);
    };
    BN.prototype.redIAdd = function redIAdd(num) {
        assert(this.red, "redIAdd works only with red numbers");
        return this.red.iadd(this, num);
    };
    BN.prototype.redSub = function redSub(num) {
        assert(this.red, "redSub works only with red numbers");
        return this.red.sub(this, num);
    };
    BN.prototype.redISub = function redISub(num) {
        assert(this.red, "redISub works only with red numbers");
        return this.red.isub(this, num);
    };
    BN.prototype.redShl = function redShl(num) {
        assert(this.red, "redShl works only with red numbers");
        return this.red.shl(this, num);
    };
    BN.prototype.redMul = function redMul(num) {
        assert(this.red, "redMul works only with red numbers");
        this.red._verify2(this, num);
        return this.red.mul(this, num);
    };
    BN.prototype.redIMul = function redIMul(num) {
        assert(this.red, "redMul works only with red numbers");
        this.red._verify2(this, num);
        return this.red.imul(this, num);
    };
    BN.prototype.redSqr = function redSqr() {
        assert(this.red, "redSqr works only with red numbers");
        this.red._verify1(this);
        return this.red.sqr(this);
    };
    BN.prototype.redISqr = function redISqr() {
        assert(this.red, "redISqr works only with red numbers");
        this.red._verify1(this);
        return this.red.isqr(this);
    };
    // Square root over p
    BN.prototype.redSqrt = function redSqrt() {
        assert(this.red, "redSqrt works only with red numbers");
        this.red._verify1(this);
        return this.red.sqrt(this);
    };
    BN.prototype.redInvm = function redInvm() {
        assert(this.red, "redInvm works only with red numbers");
        this.red._verify1(this);
        return this.red.invm(this);
    };
    // Return negative clone of `this` % `red modulo`
    BN.prototype.redNeg = function redNeg() {
        assert(this.red, "redNeg works only with red numbers");
        this.red._verify1(this);
        return this.red.neg(this);
    };
    BN.prototype.redPow = function redPow(num) {
        assert(this.red && !num.red, "redPow(normalNum)");
        this.red._verify1(this);
        return this.red.pow(this, num);
    };
    // Prime numbers with efficient reduction
    var primes = {
        k256: null,
        p224: null,
        p192: null,
        p25519: null
    };
    // Pseudo-Mersenne prime
    function MPrime(name, p) {
        // P = 2 ^ N - K
        this.name = name;
        this.p = new BN(p, 16);
        this.n = this.p.bitLength();
        this.k = new BN(1).iushln(this.n).isub(this.p);
        this.tmp = this._tmp();
    }
    MPrime.prototype._tmp = function _tmp() {
        var tmp = new BN(null);
        tmp.words = new Array(Math.ceil(this.n / 13));
        return tmp;
    };
    MPrime.prototype.ireduce = function ireduce(num) {
        // Assumes that `num` is less than `P^2`
        // num = HI * (2 ^ N - K) + HI * K + LO = HI * K + LO (mod P)
        var r = num;
        var rlen;
        do {
            this.split(r, this.tmp);
            r = this.imulK(r);
            r = r.iadd(this.tmp);
            rlen = r.bitLength();
        }while (rlen > this.n);
        var cmp = rlen < this.n ? -1 : r.ucmp(this.p);
        if (cmp === 0) {
            r.words[0] = 0;
            r.length = 1;
        } else if (cmp > 0) r.isub(this.p);
        else if (r.strip !== undefined) // r is a BN v4 instance
        r.strip();
        else // r is a BN v5 instance
        r._strip();
        return r;
    };
    MPrime.prototype.split = function split(input, out) {
        input.iushrn(this.n, 0, out);
    };
    MPrime.prototype.imulK = function imulK(num) {
        return num.imul(this.k);
    };
    function K256() {
        MPrime.call(this, "k256", "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f");
    }
    inherits(K256, MPrime);
    K256.prototype.split = function split(input, output) {
        // 256 = 9 * 26 + 22
        var mask = 0x3fffff;
        var outLen = Math.min(input.length, 9);
        for(var i = 0; i < outLen; i++)output.words[i] = input.words[i];
        output.length = outLen;
        if (input.length <= 9) {
            input.words[0] = 0;
            input.length = 1;
            return;
        }
        // Shift by 9 limbs
        var prev = input.words[9];
        output.words[output.length++] = prev & mask;
        for(i = 10; i < input.length; i++){
            var next = input.words[i] | 0;
            input.words[i - 10] = (next & mask) << 4 | prev >>> 22;
            prev = next;
        }
        prev >>>= 22;
        input.words[i - 10] = prev;
        if (prev === 0 && input.length > 10) input.length -= 10;
        else input.length -= 9;
    };
    K256.prototype.imulK = function imulK(num) {
        // K = 0x1000003d1 = [ 0x40, 0x3d1 ]
        num.words[num.length] = 0;
        num.words[num.length + 1] = 0;
        num.length += 2;
        // bounded at: 0x40 * 0x3ffffff + 0x3d0 = 0x100000390
        var lo = 0;
        for(var i = 0; i < num.length; i++){
            var w = num.words[i] | 0;
            lo += w * 0x3d1;
            num.words[i] = lo & 0x3ffffff;
            lo = w * 0x40 + (lo / 0x4000000 | 0);
        }
        // Fast length reduction
        if (num.words[num.length - 1] === 0) {
            num.length--;
            if (num.words[num.length - 1] === 0) num.length--;
        }
        return num;
    };
    function P224() {
        MPrime.call(this, "p224", "ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001");
    }
    inherits(P224, MPrime);
    function P192() {
        MPrime.call(this, "p192", "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff");
    }
    inherits(P192, MPrime);
    function P25519() {
        // 2 ^ 255 - 19
        MPrime.call(this, "25519", "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed");
    }
    inherits(P25519, MPrime);
    P25519.prototype.imulK = function imulK(num) {
        // K = 0x13
        var carry = 0;
        for(var i = 0; i < num.length; i++){
            var hi = (num.words[i] | 0) * 0x13 + carry;
            var lo = hi & 0x3ffffff;
            hi >>>= 26;
            num.words[i] = lo;
            carry = hi;
        }
        if (carry !== 0) num.words[num.length++] = carry;
        return num;
    };
    // Exported mostly for testing purposes, use plain name instead
    BN._prime = function prime(name) {
        // Cached version of prime
        if (primes[name]) return primes[name];
        var prime;
        if (name === "k256") prime = new K256();
        else if (name === "p224") prime = new P224();
        else if (name === "p192") prime = new P192();
        else if (name === "p25519") prime = new P25519();
        else throw new Error("Unknown prime " + name);
        primes[name] = prime;
        return prime;
    };
    //
    // Base reduction engine
    //
    function Red(m) {
        if (typeof m === "string") {
            var prime = BN._prime(m);
            this.m = prime.p;
            this.prime = prime;
        } else {
            assert(m.gtn(1), "modulus must be greater than 1");
            this.m = m;
            this.prime = null;
        }
    }
    Red.prototype._verify1 = function _verify1(a) {
        assert(a.negative === 0, "red works only with positives");
        assert(a.red, "red works only with red numbers");
    };
    Red.prototype._verify2 = function _verify2(a, b) {
        assert((a.negative | b.negative) === 0, "red works only with positives");
        assert(a.red && a.red === b.red, "red works only with red numbers");
    };
    Red.prototype.imod = function imod(a) {
        if (this.prime) return this.prime.ireduce(a)._forceRed(this);
        move(a, a.umod(this.m)._forceRed(this));
        return a;
    };
    Red.prototype.neg = function neg(a) {
        if (a.isZero()) return a.clone();
        return this.m.sub(a)._forceRed(this);
    };
    Red.prototype.add = function add(a, b) {
        this._verify2(a, b);
        var res = a.add(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res._forceRed(this);
    };
    Red.prototype.iadd = function iadd(a, b) {
        this._verify2(a, b);
        var res = a.iadd(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res;
    };
    Red.prototype.sub = function sub(a, b) {
        this._verify2(a, b);
        var res = a.sub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res._forceRed(this);
    };
    Red.prototype.isub = function isub(a, b) {
        this._verify2(a, b);
        var res = a.isub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res;
    };
    Red.prototype.shl = function shl(a, num) {
        this._verify1(a);
        return this.imod(a.ushln(num));
    };
    Red.prototype.imul = function imul(a, b) {
        this._verify2(a, b);
        return this.imod(a.imul(b));
    };
    Red.prototype.mul = function mul(a, b) {
        this._verify2(a, b);
        return this.imod(a.mul(b));
    };
    Red.prototype.isqr = function isqr(a) {
        return this.imul(a, a.clone());
    };
    Red.prototype.sqr = function sqr(a) {
        return this.mul(a, a);
    };
    Red.prototype.sqrt = function sqrt(a) {
        if (a.isZero()) return a.clone();
        var mod3 = this.m.andln(3);
        assert(mod3 % 2 === 1);
        // Fast case
        if (mod3 === 3) {
            var pow = this.m.add(new BN(1)).iushrn(2);
            return this.pow(a, pow);
        }
        // Tonelli-Shanks algorithm (Totally unoptimized and slow)
        //
        // Find Q and S, that Q * 2 ^ S = (P - 1)
        var q = this.m.subn(1);
        var s = 0;
        while(!q.isZero() && q.andln(1) === 0){
            s++;
            q.iushrn(1);
        }
        assert(!q.isZero());
        var one = new BN(1).toRed(this);
        var nOne = one.redNeg();
        // Find quadratic non-residue
        // NOTE: Max is such because of generalized Riemann hypothesis.
        var lpow = this.m.subn(1).iushrn(1);
        var z = this.m.bitLength();
        z = new BN(2 * z * z).toRed(this);
        while(this.pow(z, lpow).cmp(nOne) !== 0)z.redIAdd(nOne);
        var c = this.pow(z, q);
        var r = this.pow(a, q.addn(1).iushrn(1));
        var t = this.pow(a, q);
        var m = s;
        while(t.cmp(one) !== 0){
            var tmp = t;
            for(var i = 0; tmp.cmp(one) !== 0; i++)tmp = tmp.redSqr();
            assert(i < m);
            var b = this.pow(c, new BN(1).iushln(m - i - 1));
            r = r.redMul(b);
            c = b.redSqr();
            t = t.redMul(c);
            m = i;
        }
        return r;
    };
    Red.prototype.invm = function invm(a) {
        var inv = a._invmp(this.m);
        if (inv.negative !== 0) {
            inv.negative = 0;
            return this.imod(inv).redNeg();
        } else return this.imod(inv);
    };
    Red.prototype.pow = function pow(a, num) {
        if (num.isZero()) return new BN(1).toRed(this);
        if (num.cmpn(1) === 0) return a.clone();
        var windowSize = 4;
        var wnd = new Array(1 << windowSize);
        wnd[0] = new BN(1).toRed(this);
        wnd[1] = a;
        for(var i = 2; i < wnd.length; i++)wnd[i] = this.mul(wnd[i - 1], a);
        var res = wnd[0];
        var current = 0;
        var currentLen = 0;
        var start = num.bitLength() % 26;
        if (start === 0) start = 26;
        for(i = num.length - 1; i >= 0; i--){
            var word = num.words[i];
            for(var j = start - 1; j >= 0; j--){
                var bit = word >> j & 1;
                if (res !== wnd[0]) res = this.sqr(res);
                if (bit === 0 && current === 0) {
                    currentLen = 0;
                    continue;
                }
                current <<= 1;
                current |= bit;
                currentLen++;
                if (currentLen !== windowSize && (i !== 0 || j !== 0)) continue;
                res = this.mul(res, wnd[current]);
                currentLen = 0;
                current = 0;
            }
            start = 26;
        }
        return res;
    };
    Red.prototype.convertTo = function convertTo(num) {
        var r = num.umod(this.m);
        return r === num ? r.clone() : r;
    };
    Red.prototype.convertFrom = function convertFrom(num) {
        var res = num.clone();
        res.red = null;
        return res;
    };
    //
    // Montgomery method engine
    //
    BN.mont = function mont(num) {
        return new Mont(num);
    };
    function Mont(m) {
        Red.call(this, m);
        this.shift = this.m.bitLength();
        if (this.shift % 26 !== 0) this.shift += 26 - this.shift % 26;
        this.r = new BN(1).iushln(this.shift);
        this.r2 = this.imod(this.r.sqr());
        this.rinv = this.r._invmp(this.m);
        this.minv = this.rinv.mul(this.r).isubn(1).div(this.m);
        this.minv = this.minv.umod(this.r);
        this.minv = this.r.sub(this.minv);
    }
    inherits(Mont, Red);
    Mont.prototype.convertTo = function convertTo(num) {
        return this.imod(num.ushln(this.shift));
    };
    Mont.prototype.convertFrom = function convertFrom(num) {
        var r = this.imod(num.mul(this.rinv));
        r.red = null;
        return r;
    };
    Mont.prototype.imul = function imul(a, b) {
        if (a.isZero() || b.isZero()) {
            a.words[0] = 0;
            a.length = 1;
            return a;
        }
        var t = a.imul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.mul = function mul(a, b) {
        if (a.isZero() || b.isZero()) return new BN(0)._forceRed(this);
        var t = a.mul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.invm = function invm(a) {
        // (AR)^-1 * R^2 = (A^-1 * R^-1) * R^2 = A^-1 * R
        var res = this.imod(a._invmp(this.m).mul(this.r2));
        return res._forceRed(this);
    };
})(module, this);

});

parcelRequire.register("jAZWd", function(module, exports) {

(function(module1, exports) {
    "use strict";
    // Utils
    function assert(val, msg) {
        if (!val) throw new Error(msg || "Assertion failed");
    }
    // Could use `inherits` module, but don't want to move from single file
    // architecture yet.
    function inherits(ctor, superCtor) {
        ctor.super_ = superCtor;
        var TempCtor = function() {};
        TempCtor.prototype = superCtor.prototype;
        ctor.prototype = new TempCtor();
        ctor.prototype.constructor = ctor;
    }
    // BN
    function BN(number, base, endian) {
        if (BN.isBN(number)) return number;
        this.negative = 0;
        this.words = null;
        this.length = 0;
        // Reduction context
        this.red = null;
        if (number !== null) {
            if (base === "le" || base === "be") {
                endian = base;
                base = 10;
            }
            this._init(number || 0, base || 10, endian || "be");
        }
    }
    if (typeof module1 === "object") module1.exports = BN;
    else exports.BN = BN;
    BN.BN = BN;
    BN.wordSize = 26;
    var Buffer;
    try {
        if (typeof window !== "undefined" && typeof window.Buffer !== "undefined") Buffer = window.Buffer;
        else Buffer = (parcelRequire("5Io6y")).Buffer;
    } catch (e) {}
    BN.isBN = function isBN(num) {
        if (num instanceof BN) return true;
        return num !== null && typeof num === "object" && num.constructor.wordSize === BN.wordSize && Array.isArray(num.words);
    };
    BN.max = function max(left, right) {
        if (left.cmp(right) > 0) return left;
        return right;
    };
    BN.min = function min(left, right) {
        if (left.cmp(right) < 0) return left;
        return right;
    };
    BN.prototype._init = function init(number, base, endian) {
        if (typeof number === "number") return this._initNumber(number, base, endian);
        if (typeof number === "object") return this._initArray(number, base, endian);
        if (base === "hex") base = 16;
        assert(base === (base | 0) && base >= 2 && base <= 36);
        number = number.toString().replace(/\s+/g, "");
        var start = 0;
        if (number[0] === "-") {
            start++;
            this.negative = 1;
        }
        if (start < number.length) {
            if (base === 16) this._parseHex(number, start, endian);
            else {
                this._parseBase(number, base, start);
                if (endian === "le") this._initArray(this.toArray(), base, endian);
            }
        }
    };
    BN.prototype._initNumber = function _initNumber(number, base, endian) {
        if (number < 0) {
            this.negative = 1;
            number = -number;
        }
        if (number < 0x4000000) {
            this.words = [
                number & 0x3ffffff
            ];
            this.length = 1;
        } else if (number < 0x10000000000000) {
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff
            ];
            this.length = 2;
        } else {
            assert(number < 0x20000000000000); // 2 ^ 53 (unsafe)
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff,
                1
            ];
            this.length = 3;
        }
        if (endian !== "le") return;
        // Reverse the bytes
        this._initArray(this.toArray(), base, endian);
    };
    BN.prototype._initArray = function _initArray(number, base, endian) {
        // Perhaps a Uint8Array
        assert(typeof number.length === "number");
        if (number.length <= 0) {
            this.words = [
                0
            ];
            this.length = 1;
            return this;
        }
        this.length = Math.ceil(number.length / 3);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        var j, w;
        var off = 0;
        if (endian === "be") for(i = number.length - 1, j = 0; i >= 0; i -= 3){
            w = number[i] | number[i - 1] << 8 | number[i - 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        else if (endian === "le") for(i = 0, j = 0; i < number.length; i += 3){
            w = number[i] | number[i + 1] << 8 | number[i + 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        return this._strip();
    };
    function parseHex4Bits(string, index) {
        var c = string.charCodeAt(index);
        // '0' - '9'
        if (c >= 48 && c <= 57) return c - 48;
        else if (c >= 65 && c <= 70) return c - 55;
        else if (c >= 97 && c <= 102) return c - 87;
        else assert(false, "Invalid character in " + string);
    }
    function parseHexByte(string, lowerBound, index) {
        var r = parseHex4Bits(string, index);
        if (index - 1 >= lowerBound) r |= parseHex4Bits(string, index - 1) << 4;
        return r;
    }
    BN.prototype._parseHex = function _parseHex(number, start, endian) {
        // Create possibly bigger array to ensure that it fits the number
        this.length = Math.ceil((number.length - start) / 6);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        // 24-bits chunks
        var off = 0;
        var j = 0;
        var w;
        if (endian === "be") for(i = number.length - 1; i >= start; i -= 2){
            w = parseHexByte(number, start, i) << off;
            this.words[j] |= w & 0x3ffffff;
            if (off >= 18) {
                off -= 18;
                j += 1;
                this.words[j] |= w >>> 26;
            } else off += 8;
        }
        else {
            var parseLength = number.length - start;
            for(i = parseLength % 2 === 0 ? start + 1 : start; i < number.length; i += 2){
                w = parseHexByte(number, start, i) << off;
                this.words[j] |= w & 0x3ffffff;
                if (off >= 18) {
                    off -= 18;
                    j += 1;
                    this.words[j] |= w >>> 26;
                } else off += 8;
            }
        }
        this._strip();
    };
    function parseBase(str, start, end, mul) {
        var r = 0;
        var b = 0;
        var len = Math.min(str.length, end);
        for(var i = start; i < len; i++){
            var c = str.charCodeAt(i) - 48;
            r *= mul;
            // 'a'
            if (c >= 49) b = c - 49 + 0xa;
            else if (c >= 17) b = c - 17 + 0xa;
            else b = c;
            assert(c >= 0 && b < mul, "Invalid character");
            r += b;
        }
        return r;
    }
    BN.prototype._parseBase = function _parseBase(number, base, start) {
        // Initialize as zero
        this.words = [
            0
        ];
        this.length = 1;
        // Find length of limb in base
        for(var limbLen = 0, limbPow = 1; limbPow <= 0x3ffffff; limbPow *= base)limbLen++;
        limbLen--;
        limbPow = limbPow / base | 0;
        var total = number.length - start;
        var mod = total % limbLen;
        var end = Math.min(total, total - mod) + start;
        var word = 0;
        for(var i = start; i < end; i += limbLen){
            word = parseBase(number, i, i + limbLen, base);
            this.imuln(limbPow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        if (mod !== 0) {
            var pow = 1;
            word = parseBase(number, i, number.length, base);
            for(i = 0; i < mod; i++)pow *= base;
            this.imuln(pow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        this._strip();
    };
    BN.prototype.copy = function copy(dest) {
        dest.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)dest.words[i] = this.words[i];
        dest.length = this.length;
        dest.negative = this.negative;
        dest.red = this.red;
    };
    function move(dest, src) {
        dest.words = src.words;
        dest.length = src.length;
        dest.negative = src.negative;
        dest.red = src.red;
    }
    BN.prototype._move = function _move(dest) {
        move(dest, this);
    };
    BN.prototype.clone = function clone() {
        var r = new BN(null);
        this.copy(r);
        return r;
    };
    BN.prototype._expand = function _expand(size) {
        while(this.length < size)this.words[this.length++] = 0;
        return this;
    };
    // Remove leading `0` from `this`
    BN.prototype._strip = function strip() {
        while(this.length > 1 && this.words[this.length - 1] === 0)this.length--;
        return this._normSign();
    };
    BN.prototype._normSign = function _normSign() {
        // -0 = 0
        if (this.length === 1 && this.words[0] === 0) this.negative = 0;
        return this;
    };
    // Check Symbol.for because not everywhere where Symbol defined
    // See https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Symbol#Browser_compatibility
    if (typeof Symbol !== "undefined" && typeof Symbol.for === "function") try {
        BN.prototype[Symbol.for("nodejs.util.inspect.custom")] = inspect;
    } catch (e) {
        BN.prototype.inspect = inspect;
    }
    else BN.prototype.inspect = inspect;
    function inspect() {
        return (this.red ? "<BN-R: " : "<BN: ") + this.toString(16) + ">";
    }
    /*

  var zeros = [];
  var groupSizes = [];
  var groupBases = [];

  var s = '';
  var i = -1;
  while (++i < BN.wordSize) {
    zeros[i] = s;
    s += '0';
  }
  groupSizes[0] = 0;
  groupSizes[1] = 0;
  groupBases[0] = 0;
  groupBases[1] = 0;
  var base = 2 - 1;
  while (++base < 36 + 1) {
    var groupSize = 0;
    var groupBase = 1;
    while (groupBase < (1 << BN.wordSize) / base) {
      groupBase *= base;
      groupSize += 1;
    }
    groupSizes[base] = groupSize;
    groupBases[base] = groupBase;
  }

  */ var zeros = [
        "",
        "0",
        "00",
        "000",
        "0000",
        "00000",
        "000000",
        "0000000",
        "00000000",
        "000000000",
        "0000000000",
        "00000000000",
        "000000000000",
        "0000000000000",
        "00000000000000",
        "000000000000000",
        "0000000000000000",
        "00000000000000000",
        "000000000000000000",
        "0000000000000000000",
        "00000000000000000000",
        "000000000000000000000",
        "0000000000000000000000",
        "00000000000000000000000",
        "000000000000000000000000",
        "0000000000000000000000000"
    ];
    var groupSizes = [
        0,
        0,
        25,
        16,
        12,
        11,
        10,
        9,
        8,
        8,
        7,
        7,
        7,
        7,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5
    ];
    var groupBases = [
        0,
        0,
        33554432,
        43046721,
        16777216,
        48828125,
        60466176,
        40353607,
        16777216,
        43046721,
        10000000,
        19487171,
        35831808,
        62748517,
        7529536,
        11390625,
        16777216,
        24137569,
        34012224,
        47045881,
        64000000,
        4084101,
        5153632,
        6436343,
        7962624,
        9765625,
        11881376,
        14348907,
        17210368,
        20511149,
        24300000,
        28629151,
        33554432,
        39135393,
        45435424,
        52521875,
        60466176
    ];
    BN.prototype.toString = function toString(base, padding) {
        base = base || 10;
        padding = padding | 0 || 1;
        var out;
        if (base === 16 || base === "hex") {
            out = "";
            var off = 0;
            var carry = 0;
            for(var i = 0; i < this.length; i++){
                var w = this.words[i];
                var word = ((w << off | carry) & 0xffffff).toString(16);
                carry = w >>> 24 - off & 0xffffff;
                off += 2;
                if (off >= 26) {
                    off -= 26;
                    i--;
                }
                if (carry !== 0 || i !== this.length - 1) out = zeros[6 - word.length] + word + out;
                else out = word + out;
            }
            if (carry !== 0) out = carry.toString(16) + out;
            while(out.length % padding !== 0)out = "0" + out;
            if (this.negative !== 0) out = "-" + out;
            return out;
        }
        if (base === (base | 0) && base >= 2 && base <= 36) {
            // var groupSize = Math.floor(BN.wordSize * Math.LN2 / Math.log(base));
            var groupSize = groupSizes[base];
            // var groupBase = Math.pow(base, groupSize);
            var groupBase = groupBases[base];
            out = "";
            var c = this.clone();
            c.negative = 0;
            while(!c.isZero()){
                var r = c.modrn(groupBase).toString(base);
                c = c.idivn(groupBase);
                if (!c.isZero()) out = zeros[groupSize - r.length] + r + out;
                else out = r + out;
            }
            if (this.isZero()) out = "0" + out;
            while(out.length % padding !== 0)out = "0" + out;
            if (this.negative !== 0) out = "-" + out;
            return out;
        }
        assert(false, "Base should be between 2 and 36");
    };
    BN.prototype.toNumber = function toNumber() {
        var ret = this.words[0];
        if (this.length === 2) ret += this.words[1] * 0x4000000;
        else if (this.length === 3 && this.words[2] === 0x01) // NOTE: at this stage it is known that the top bit is set
        ret += 0x10000000000000 + this.words[1] * 0x4000000;
        else if (this.length > 2) assert(false, "Number can only safely store up to 53 bits");
        return this.negative !== 0 ? -ret : ret;
    };
    BN.prototype.toJSON = function toJSON() {
        return this.toString(16, 2);
    };
    if (Buffer) BN.prototype.toBuffer = function toBuffer(endian, length) {
        return this.toArrayLike(Buffer, endian, length);
    };
    BN.prototype.toArray = function toArray(endian, length) {
        return this.toArrayLike(Array, endian, length);
    };
    var allocate = function allocate(ArrayType, size) {
        if (ArrayType.allocUnsafe) return ArrayType.allocUnsafe(size);
        return new ArrayType(size);
    };
    BN.prototype.toArrayLike = function toArrayLike(ArrayType, endian, length) {
        this._strip();
        var byteLength = this.byteLength();
        var reqLength = length || Math.max(1, byteLength);
        assert(byteLength <= reqLength, "byte array longer than desired length");
        assert(reqLength > 0, "Requested array length <= 0");
        var res = allocate(ArrayType, reqLength);
        var postfix = endian === "le" ? "LE" : "BE";
        this["_toArrayLike" + postfix](res, byteLength);
        return res;
    };
    BN.prototype._toArrayLikeLE = function _toArrayLikeLE(res, byteLength) {
        var position = 0;
        var carry = 0;
        for(var i = 0, shift = 0; i < this.length; i++){
            var word = this.words[i] << shift | carry;
            res[position++] = word & 0xff;
            if (position < res.length) res[position++] = word >> 8 & 0xff;
            if (position < res.length) res[position++] = word >> 16 & 0xff;
            if (shift === 6) {
                if (position < res.length) res[position++] = word >> 24 & 0xff;
                carry = 0;
                shift = 0;
            } else {
                carry = word >>> 24;
                shift += 2;
            }
        }
        if (position < res.length) {
            res[position++] = carry;
            while(position < res.length)res[position++] = 0;
        }
    };
    BN.prototype._toArrayLikeBE = function _toArrayLikeBE(res, byteLength) {
        var position = res.length - 1;
        var carry = 0;
        for(var i = 0, shift = 0; i < this.length; i++){
            var word = this.words[i] << shift | carry;
            res[position--] = word & 0xff;
            if (position >= 0) res[position--] = word >> 8 & 0xff;
            if (position >= 0) res[position--] = word >> 16 & 0xff;
            if (shift === 6) {
                if (position >= 0) res[position--] = word >> 24 & 0xff;
                carry = 0;
                shift = 0;
            } else {
                carry = word >>> 24;
                shift += 2;
            }
        }
        if (position >= 0) {
            res[position--] = carry;
            while(position >= 0)res[position--] = 0;
        }
    };
    if (Math.clz32) BN.prototype._countBits = function _countBits(w) {
        return 32 - Math.clz32(w);
    };
    else BN.prototype._countBits = function _countBits(w) {
        var t = w;
        var r = 0;
        if (t >= 0x1000) {
            r += 13;
            t >>>= 13;
        }
        if (t >= 0x40) {
            r += 7;
            t >>>= 7;
        }
        if (t >= 0x8) {
            r += 4;
            t >>>= 4;
        }
        if (t >= 0x02) {
            r += 2;
            t >>>= 2;
        }
        return r + t;
    };
    BN.prototype._zeroBits = function _zeroBits(w) {
        // Short-cut
        if (w === 0) return 26;
        var t = w;
        var r = 0;
        if ((t & 0x1fff) === 0) {
            r += 13;
            t >>>= 13;
        }
        if ((t & 0x7f) === 0) {
            r += 7;
            t >>>= 7;
        }
        if ((t & 0xf) === 0) {
            r += 4;
            t >>>= 4;
        }
        if ((t & 0x3) === 0) {
            r += 2;
            t >>>= 2;
        }
        if ((t & 0x1) === 0) r++;
        return r;
    };
    // Return number of used bits in a BN
    BN.prototype.bitLength = function bitLength() {
        var w = this.words[this.length - 1];
        var hi = this._countBits(w);
        return (this.length - 1) * 26 + hi;
    };
    function toBitArray(num) {
        var w = new Array(num.bitLength());
        for(var bit = 0; bit < w.length; bit++){
            var off = bit / 26 | 0;
            var wbit = bit % 26;
            w[bit] = num.words[off] >>> wbit & 0x01;
        }
        return w;
    }
    // Number of trailing zero bits
    BN.prototype.zeroBits = function zeroBits() {
        if (this.isZero()) return 0;
        var r = 0;
        for(var i = 0; i < this.length; i++){
            var b = this._zeroBits(this.words[i]);
            r += b;
            if (b !== 26) break;
        }
        return r;
    };
    BN.prototype.byteLength = function byteLength() {
        return Math.ceil(this.bitLength() / 8);
    };
    BN.prototype.toTwos = function toTwos(width) {
        if (this.negative !== 0) return this.abs().inotn(width).iaddn(1);
        return this.clone();
    };
    BN.prototype.fromTwos = function fromTwos(width) {
        if (this.testn(width - 1)) return this.notn(width).iaddn(1).ineg();
        return this.clone();
    };
    BN.prototype.isNeg = function isNeg() {
        return this.negative !== 0;
    };
    // Return negative clone of `this`
    BN.prototype.neg = function neg() {
        return this.clone().ineg();
    };
    BN.prototype.ineg = function ineg() {
        if (!this.isZero()) this.negative ^= 1;
        return this;
    };
    // Or `num` with `this` in-place
    BN.prototype.iuor = function iuor(num) {
        while(this.length < num.length)this.words[this.length++] = 0;
        for(var i = 0; i < num.length; i++)this.words[i] = this.words[i] | num.words[i];
        return this._strip();
    };
    BN.prototype.ior = function ior(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuor(num);
    };
    // Or `num` with `this`
    BN.prototype.or = function or(num) {
        if (this.length > num.length) return this.clone().ior(num);
        return num.clone().ior(this);
    };
    BN.prototype.uor = function uor(num) {
        if (this.length > num.length) return this.clone().iuor(num);
        return num.clone().iuor(this);
    };
    // And `num` with `this` in-place
    BN.prototype.iuand = function iuand(num) {
        // b = min-length(num, this)
        var b;
        if (this.length > num.length) b = num;
        else b = this;
        for(var i = 0; i < b.length; i++)this.words[i] = this.words[i] & num.words[i];
        this.length = b.length;
        return this._strip();
    };
    BN.prototype.iand = function iand(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuand(num);
    };
    // And `num` with `this`
    BN.prototype.and = function and(num) {
        if (this.length > num.length) return this.clone().iand(num);
        return num.clone().iand(this);
    };
    BN.prototype.uand = function uand(num) {
        if (this.length > num.length) return this.clone().iuand(num);
        return num.clone().iuand(this);
    };
    // Xor `num` with `this` in-place
    BN.prototype.iuxor = function iuxor(num) {
        // a.length > b.length
        var a;
        var b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        for(var i = 0; i < b.length; i++)this.words[i] = a.words[i] ^ b.words[i];
        if (this !== a) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = a.length;
        return this._strip();
    };
    BN.prototype.ixor = function ixor(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuxor(num);
    };
    // Xor `num` with `this`
    BN.prototype.xor = function xor(num) {
        if (this.length > num.length) return this.clone().ixor(num);
        return num.clone().ixor(this);
    };
    BN.prototype.uxor = function uxor(num) {
        if (this.length > num.length) return this.clone().iuxor(num);
        return num.clone().iuxor(this);
    };
    // Not ``this`` with ``width`` bitwidth
    BN.prototype.inotn = function inotn(width) {
        assert(typeof width === "number" && width >= 0);
        var bytesNeeded = Math.ceil(width / 26) | 0;
        var bitsLeft = width % 26;
        // Extend the buffer with leading zeroes
        this._expand(bytesNeeded);
        if (bitsLeft > 0) bytesNeeded--;
        // Handle complete words
        for(var i = 0; i < bytesNeeded; i++)this.words[i] = ~this.words[i] & 0x3ffffff;
        // Handle the residue
        if (bitsLeft > 0) this.words[i] = ~this.words[i] & 0x3ffffff >> 26 - bitsLeft;
        // And remove leading zeroes
        return this._strip();
    };
    BN.prototype.notn = function notn(width) {
        return this.clone().inotn(width);
    };
    // Set `bit` of `this`
    BN.prototype.setn = function setn(bit, val) {
        assert(typeof bit === "number" && bit >= 0);
        var off = bit / 26 | 0;
        var wbit = bit % 26;
        this._expand(off + 1);
        if (val) this.words[off] = this.words[off] | 1 << wbit;
        else this.words[off] = this.words[off] & ~(1 << wbit);
        return this._strip();
    };
    // Add `num` to `this` in-place
    BN.prototype.iadd = function iadd(num) {
        var r;
        // negative + positive
        if (this.negative !== 0 && num.negative === 0) {
            this.negative = 0;
            r = this.isub(num);
            this.negative ^= 1;
            return this._normSign();
        // positive + negative
        } else if (this.negative === 0 && num.negative !== 0) {
            num.negative = 0;
            r = this.isub(num);
            num.negative = 1;
            return r._normSign();
        }
        // a.length > b.length
        var a, b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) + (b.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        this.length = a.length;
        if (carry !== 0) {
            this.words[this.length] = carry;
            this.length++;
        // Copy the rest of the words
        } else if (a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        return this;
    };
    // Add `num` to `this`
    BN.prototype.add = function add(num) {
        var res;
        if (num.negative !== 0 && this.negative === 0) {
            num.negative = 0;
            res = this.sub(num);
            num.negative ^= 1;
            return res;
        } else if (num.negative === 0 && this.negative !== 0) {
            this.negative = 0;
            res = num.sub(this);
            this.negative = 1;
            return res;
        }
        if (this.length > num.length) return this.clone().iadd(num);
        return num.clone().iadd(this);
    };
    // Subtract `num` from `this` in-place
    BN.prototype.isub = function isub(num) {
        // this - (-num) = this + num
        if (num.negative !== 0) {
            num.negative = 0;
            var r = this.iadd(num);
            num.negative = 1;
            return r._normSign();
        // -this - num = -(this + num)
        } else if (this.negative !== 0) {
            this.negative = 0;
            this.iadd(num);
            this.negative = 1;
            return this._normSign();
        }
        // At this point both numbers are positive
        var cmp = this.cmp(num);
        // Optimization - zeroify
        if (cmp === 0) {
            this.negative = 0;
            this.length = 1;
            this.words[0] = 0;
            return this;
        }
        // a > b
        var a, b;
        if (cmp > 0) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) - (b.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        // Copy rest of the words
        if (carry === 0 && i < a.length && a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = Math.max(this.length, i);
        if (a !== this) this.negative = 1;
        return this._strip();
    };
    // Subtract `num` from `this`
    BN.prototype.sub = function sub(num) {
        return this.clone().isub(num);
    };
    function smallMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        var len = self.length + num.length | 0;
        out.length = len;
        len = len - 1 | 0;
        // Peel one iteration (compiler can't do it, because of code complexity)
        var a = self.words[0] | 0;
        var b = num.words[0] | 0;
        var r = a * b;
        var lo = r & 0x3ffffff;
        var carry = r / 0x4000000 | 0;
        out.words[0] = lo;
        for(var k = 1; k < len; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = carry >>> 26;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j | 0;
                a = self.words[i] | 0;
                b = num.words[j] | 0;
                r = a * b + rword;
                ncarry += r / 0x4000000 | 0;
                rword = r & 0x3ffffff;
            }
            out.words[k] = rword | 0;
            carry = ncarry | 0;
        }
        if (carry !== 0) out.words[k] = carry | 0;
        else out.length--;
        return out._strip();
    }
    // TODO(indutny): it may be reasonable to omit it for users who don't need
    // to work with 256-bit numbers, otherwise it gives 20% improvement for 256-bit
    // multiplication (like elliptic secp256k1).
    var comb10MulTo = function comb10MulTo(self, num, out) {
        var a = self.words;
        var b = num.words;
        var o = out.words;
        var c = 0;
        var lo;
        var mid;
        var hi;
        var a0 = a[0] | 0;
        var al0 = a0 & 0x1fff;
        var ah0 = a0 >>> 13;
        var a1 = a[1] | 0;
        var al1 = a1 & 0x1fff;
        var ah1 = a1 >>> 13;
        var a2 = a[2] | 0;
        var al2 = a2 & 0x1fff;
        var ah2 = a2 >>> 13;
        var a3 = a[3] | 0;
        var al3 = a3 & 0x1fff;
        var ah3 = a3 >>> 13;
        var a4 = a[4] | 0;
        var al4 = a4 & 0x1fff;
        var ah4 = a4 >>> 13;
        var a5 = a[5] | 0;
        var al5 = a5 & 0x1fff;
        var ah5 = a5 >>> 13;
        var a6 = a[6] | 0;
        var al6 = a6 & 0x1fff;
        var ah6 = a6 >>> 13;
        var a7 = a[7] | 0;
        var al7 = a7 & 0x1fff;
        var ah7 = a7 >>> 13;
        var a8 = a[8] | 0;
        var al8 = a8 & 0x1fff;
        var ah8 = a8 >>> 13;
        var a9 = a[9] | 0;
        var al9 = a9 & 0x1fff;
        var ah9 = a9 >>> 13;
        var b0 = b[0] | 0;
        var bl0 = b0 & 0x1fff;
        var bh0 = b0 >>> 13;
        var b1 = b[1] | 0;
        var bl1 = b1 & 0x1fff;
        var bh1 = b1 >>> 13;
        var b2 = b[2] | 0;
        var bl2 = b2 & 0x1fff;
        var bh2 = b2 >>> 13;
        var b3 = b[3] | 0;
        var bl3 = b3 & 0x1fff;
        var bh3 = b3 >>> 13;
        var b4 = b[4] | 0;
        var bl4 = b4 & 0x1fff;
        var bh4 = b4 >>> 13;
        var b5 = b[5] | 0;
        var bl5 = b5 & 0x1fff;
        var bh5 = b5 >>> 13;
        var b6 = b[6] | 0;
        var bl6 = b6 & 0x1fff;
        var bh6 = b6 >>> 13;
        var b7 = b[7] | 0;
        var bl7 = b7 & 0x1fff;
        var bh7 = b7 >>> 13;
        var b8 = b[8] | 0;
        var bl8 = b8 & 0x1fff;
        var bh8 = b8 >>> 13;
        var b9 = b[9] | 0;
        var bl9 = b9 & 0x1fff;
        var bh9 = b9 >>> 13;
        out.negative = self.negative ^ num.negative;
        out.length = 19;
        /* k = 0 */ lo = Math.imul(al0, bl0);
        mid = Math.imul(al0, bh0);
        mid = mid + Math.imul(ah0, bl0) | 0;
        hi = Math.imul(ah0, bh0);
        var w0 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w0 >>> 26) | 0;
        w0 &= 0x3ffffff;
        /* k = 1 */ lo = Math.imul(al1, bl0);
        mid = Math.imul(al1, bh0);
        mid = mid + Math.imul(ah1, bl0) | 0;
        hi = Math.imul(ah1, bh0);
        lo = lo + Math.imul(al0, bl1) | 0;
        mid = mid + Math.imul(al0, bh1) | 0;
        mid = mid + Math.imul(ah0, bl1) | 0;
        hi = hi + Math.imul(ah0, bh1) | 0;
        var w1 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w1 >>> 26) | 0;
        w1 &= 0x3ffffff;
        /* k = 2 */ lo = Math.imul(al2, bl0);
        mid = Math.imul(al2, bh0);
        mid = mid + Math.imul(ah2, bl0) | 0;
        hi = Math.imul(ah2, bh0);
        lo = lo + Math.imul(al1, bl1) | 0;
        mid = mid + Math.imul(al1, bh1) | 0;
        mid = mid + Math.imul(ah1, bl1) | 0;
        hi = hi + Math.imul(ah1, bh1) | 0;
        lo = lo + Math.imul(al0, bl2) | 0;
        mid = mid + Math.imul(al0, bh2) | 0;
        mid = mid + Math.imul(ah0, bl2) | 0;
        hi = hi + Math.imul(ah0, bh2) | 0;
        var w2 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w2 >>> 26) | 0;
        w2 &= 0x3ffffff;
        /* k = 3 */ lo = Math.imul(al3, bl0);
        mid = Math.imul(al3, bh0);
        mid = mid + Math.imul(ah3, bl0) | 0;
        hi = Math.imul(ah3, bh0);
        lo = lo + Math.imul(al2, bl1) | 0;
        mid = mid + Math.imul(al2, bh1) | 0;
        mid = mid + Math.imul(ah2, bl1) | 0;
        hi = hi + Math.imul(ah2, bh1) | 0;
        lo = lo + Math.imul(al1, bl2) | 0;
        mid = mid + Math.imul(al1, bh2) | 0;
        mid = mid + Math.imul(ah1, bl2) | 0;
        hi = hi + Math.imul(ah1, bh2) | 0;
        lo = lo + Math.imul(al0, bl3) | 0;
        mid = mid + Math.imul(al0, bh3) | 0;
        mid = mid + Math.imul(ah0, bl3) | 0;
        hi = hi + Math.imul(ah0, bh3) | 0;
        var w3 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w3 >>> 26) | 0;
        w3 &= 0x3ffffff;
        /* k = 4 */ lo = Math.imul(al4, bl0);
        mid = Math.imul(al4, bh0);
        mid = mid + Math.imul(ah4, bl0) | 0;
        hi = Math.imul(ah4, bh0);
        lo = lo + Math.imul(al3, bl1) | 0;
        mid = mid + Math.imul(al3, bh1) | 0;
        mid = mid + Math.imul(ah3, bl1) | 0;
        hi = hi + Math.imul(ah3, bh1) | 0;
        lo = lo + Math.imul(al2, bl2) | 0;
        mid = mid + Math.imul(al2, bh2) | 0;
        mid = mid + Math.imul(ah2, bl2) | 0;
        hi = hi + Math.imul(ah2, bh2) | 0;
        lo = lo + Math.imul(al1, bl3) | 0;
        mid = mid + Math.imul(al1, bh3) | 0;
        mid = mid + Math.imul(ah1, bl3) | 0;
        hi = hi + Math.imul(ah1, bh3) | 0;
        lo = lo + Math.imul(al0, bl4) | 0;
        mid = mid + Math.imul(al0, bh4) | 0;
        mid = mid + Math.imul(ah0, bl4) | 0;
        hi = hi + Math.imul(ah0, bh4) | 0;
        var w4 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w4 >>> 26) | 0;
        w4 &= 0x3ffffff;
        /* k = 5 */ lo = Math.imul(al5, bl0);
        mid = Math.imul(al5, bh0);
        mid = mid + Math.imul(ah5, bl0) | 0;
        hi = Math.imul(ah5, bh0);
        lo = lo + Math.imul(al4, bl1) | 0;
        mid = mid + Math.imul(al4, bh1) | 0;
        mid = mid + Math.imul(ah4, bl1) | 0;
        hi = hi + Math.imul(ah4, bh1) | 0;
        lo = lo + Math.imul(al3, bl2) | 0;
        mid = mid + Math.imul(al3, bh2) | 0;
        mid = mid + Math.imul(ah3, bl2) | 0;
        hi = hi + Math.imul(ah3, bh2) | 0;
        lo = lo + Math.imul(al2, bl3) | 0;
        mid = mid + Math.imul(al2, bh3) | 0;
        mid = mid + Math.imul(ah2, bl3) | 0;
        hi = hi + Math.imul(ah2, bh3) | 0;
        lo = lo + Math.imul(al1, bl4) | 0;
        mid = mid + Math.imul(al1, bh4) | 0;
        mid = mid + Math.imul(ah1, bl4) | 0;
        hi = hi + Math.imul(ah1, bh4) | 0;
        lo = lo + Math.imul(al0, bl5) | 0;
        mid = mid + Math.imul(al0, bh5) | 0;
        mid = mid + Math.imul(ah0, bl5) | 0;
        hi = hi + Math.imul(ah0, bh5) | 0;
        var w5 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w5 >>> 26) | 0;
        w5 &= 0x3ffffff;
        /* k = 6 */ lo = Math.imul(al6, bl0);
        mid = Math.imul(al6, bh0);
        mid = mid + Math.imul(ah6, bl0) | 0;
        hi = Math.imul(ah6, bh0);
        lo = lo + Math.imul(al5, bl1) | 0;
        mid = mid + Math.imul(al5, bh1) | 0;
        mid = mid + Math.imul(ah5, bl1) | 0;
        hi = hi + Math.imul(ah5, bh1) | 0;
        lo = lo + Math.imul(al4, bl2) | 0;
        mid = mid + Math.imul(al4, bh2) | 0;
        mid = mid + Math.imul(ah4, bl2) | 0;
        hi = hi + Math.imul(ah4, bh2) | 0;
        lo = lo + Math.imul(al3, bl3) | 0;
        mid = mid + Math.imul(al3, bh3) | 0;
        mid = mid + Math.imul(ah3, bl3) | 0;
        hi = hi + Math.imul(ah3, bh3) | 0;
        lo = lo + Math.imul(al2, bl4) | 0;
        mid = mid + Math.imul(al2, bh4) | 0;
        mid = mid + Math.imul(ah2, bl4) | 0;
        hi = hi + Math.imul(ah2, bh4) | 0;
        lo = lo + Math.imul(al1, bl5) | 0;
        mid = mid + Math.imul(al1, bh5) | 0;
        mid = mid + Math.imul(ah1, bl5) | 0;
        hi = hi + Math.imul(ah1, bh5) | 0;
        lo = lo + Math.imul(al0, bl6) | 0;
        mid = mid + Math.imul(al0, bh6) | 0;
        mid = mid + Math.imul(ah0, bl6) | 0;
        hi = hi + Math.imul(ah0, bh6) | 0;
        var w6 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w6 >>> 26) | 0;
        w6 &= 0x3ffffff;
        /* k = 7 */ lo = Math.imul(al7, bl0);
        mid = Math.imul(al7, bh0);
        mid = mid + Math.imul(ah7, bl0) | 0;
        hi = Math.imul(ah7, bh0);
        lo = lo + Math.imul(al6, bl1) | 0;
        mid = mid + Math.imul(al6, bh1) | 0;
        mid = mid + Math.imul(ah6, bl1) | 0;
        hi = hi + Math.imul(ah6, bh1) | 0;
        lo = lo + Math.imul(al5, bl2) | 0;
        mid = mid + Math.imul(al5, bh2) | 0;
        mid = mid + Math.imul(ah5, bl2) | 0;
        hi = hi + Math.imul(ah5, bh2) | 0;
        lo = lo + Math.imul(al4, bl3) | 0;
        mid = mid + Math.imul(al4, bh3) | 0;
        mid = mid + Math.imul(ah4, bl3) | 0;
        hi = hi + Math.imul(ah4, bh3) | 0;
        lo = lo + Math.imul(al3, bl4) | 0;
        mid = mid + Math.imul(al3, bh4) | 0;
        mid = mid + Math.imul(ah3, bl4) | 0;
        hi = hi + Math.imul(ah3, bh4) | 0;
        lo = lo + Math.imul(al2, bl5) | 0;
        mid = mid + Math.imul(al2, bh5) | 0;
        mid = mid + Math.imul(ah2, bl5) | 0;
        hi = hi + Math.imul(ah2, bh5) | 0;
        lo = lo + Math.imul(al1, bl6) | 0;
        mid = mid + Math.imul(al1, bh6) | 0;
        mid = mid + Math.imul(ah1, bl6) | 0;
        hi = hi + Math.imul(ah1, bh6) | 0;
        lo = lo + Math.imul(al0, bl7) | 0;
        mid = mid + Math.imul(al0, bh7) | 0;
        mid = mid + Math.imul(ah0, bl7) | 0;
        hi = hi + Math.imul(ah0, bh7) | 0;
        var w7 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w7 >>> 26) | 0;
        w7 &= 0x3ffffff;
        /* k = 8 */ lo = Math.imul(al8, bl0);
        mid = Math.imul(al8, bh0);
        mid = mid + Math.imul(ah8, bl0) | 0;
        hi = Math.imul(ah8, bh0);
        lo = lo + Math.imul(al7, bl1) | 0;
        mid = mid + Math.imul(al7, bh1) | 0;
        mid = mid + Math.imul(ah7, bl1) | 0;
        hi = hi + Math.imul(ah7, bh1) | 0;
        lo = lo + Math.imul(al6, bl2) | 0;
        mid = mid + Math.imul(al6, bh2) | 0;
        mid = mid + Math.imul(ah6, bl2) | 0;
        hi = hi + Math.imul(ah6, bh2) | 0;
        lo = lo + Math.imul(al5, bl3) | 0;
        mid = mid + Math.imul(al5, bh3) | 0;
        mid = mid + Math.imul(ah5, bl3) | 0;
        hi = hi + Math.imul(ah5, bh3) | 0;
        lo = lo + Math.imul(al4, bl4) | 0;
        mid = mid + Math.imul(al4, bh4) | 0;
        mid = mid + Math.imul(ah4, bl4) | 0;
        hi = hi + Math.imul(ah4, bh4) | 0;
        lo = lo + Math.imul(al3, bl5) | 0;
        mid = mid + Math.imul(al3, bh5) | 0;
        mid = mid + Math.imul(ah3, bl5) | 0;
        hi = hi + Math.imul(ah3, bh5) | 0;
        lo = lo + Math.imul(al2, bl6) | 0;
        mid = mid + Math.imul(al2, bh6) | 0;
        mid = mid + Math.imul(ah2, bl6) | 0;
        hi = hi + Math.imul(ah2, bh6) | 0;
        lo = lo + Math.imul(al1, bl7) | 0;
        mid = mid + Math.imul(al1, bh7) | 0;
        mid = mid + Math.imul(ah1, bl7) | 0;
        hi = hi + Math.imul(ah1, bh7) | 0;
        lo = lo + Math.imul(al0, bl8) | 0;
        mid = mid + Math.imul(al0, bh8) | 0;
        mid = mid + Math.imul(ah0, bl8) | 0;
        hi = hi + Math.imul(ah0, bh8) | 0;
        var w8 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w8 >>> 26) | 0;
        w8 &= 0x3ffffff;
        /* k = 9 */ lo = Math.imul(al9, bl0);
        mid = Math.imul(al9, bh0);
        mid = mid + Math.imul(ah9, bl0) | 0;
        hi = Math.imul(ah9, bh0);
        lo = lo + Math.imul(al8, bl1) | 0;
        mid = mid + Math.imul(al8, bh1) | 0;
        mid = mid + Math.imul(ah8, bl1) | 0;
        hi = hi + Math.imul(ah8, bh1) | 0;
        lo = lo + Math.imul(al7, bl2) | 0;
        mid = mid + Math.imul(al7, bh2) | 0;
        mid = mid + Math.imul(ah7, bl2) | 0;
        hi = hi + Math.imul(ah7, bh2) | 0;
        lo = lo + Math.imul(al6, bl3) | 0;
        mid = mid + Math.imul(al6, bh3) | 0;
        mid = mid + Math.imul(ah6, bl3) | 0;
        hi = hi + Math.imul(ah6, bh3) | 0;
        lo = lo + Math.imul(al5, bl4) | 0;
        mid = mid + Math.imul(al5, bh4) | 0;
        mid = mid + Math.imul(ah5, bl4) | 0;
        hi = hi + Math.imul(ah5, bh4) | 0;
        lo = lo + Math.imul(al4, bl5) | 0;
        mid = mid + Math.imul(al4, bh5) | 0;
        mid = mid + Math.imul(ah4, bl5) | 0;
        hi = hi + Math.imul(ah4, bh5) | 0;
        lo = lo + Math.imul(al3, bl6) | 0;
        mid = mid + Math.imul(al3, bh6) | 0;
        mid = mid + Math.imul(ah3, bl6) | 0;
        hi = hi + Math.imul(ah3, bh6) | 0;
        lo = lo + Math.imul(al2, bl7) | 0;
        mid = mid + Math.imul(al2, bh7) | 0;
        mid = mid + Math.imul(ah2, bl7) | 0;
        hi = hi + Math.imul(ah2, bh7) | 0;
        lo = lo + Math.imul(al1, bl8) | 0;
        mid = mid + Math.imul(al1, bh8) | 0;
        mid = mid + Math.imul(ah1, bl8) | 0;
        hi = hi + Math.imul(ah1, bh8) | 0;
        lo = lo + Math.imul(al0, bl9) | 0;
        mid = mid + Math.imul(al0, bh9) | 0;
        mid = mid + Math.imul(ah0, bl9) | 0;
        hi = hi + Math.imul(ah0, bh9) | 0;
        var w9 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w9 >>> 26) | 0;
        w9 &= 0x3ffffff;
        /* k = 10 */ lo = Math.imul(al9, bl1);
        mid = Math.imul(al9, bh1);
        mid = mid + Math.imul(ah9, bl1) | 0;
        hi = Math.imul(ah9, bh1);
        lo = lo + Math.imul(al8, bl2) | 0;
        mid = mid + Math.imul(al8, bh2) | 0;
        mid = mid + Math.imul(ah8, bl2) | 0;
        hi = hi + Math.imul(ah8, bh2) | 0;
        lo = lo + Math.imul(al7, bl3) | 0;
        mid = mid + Math.imul(al7, bh3) | 0;
        mid = mid + Math.imul(ah7, bl3) | 0;
        hi = hi + Math.imul(ah7, bh3) | 0;
        lo = lo + Math.imul(al6, bl4) | 0;
        mid = mid + Math.imul(al6, bh4) | 0;
        mid = mid + Math.imul(ah6, bl4) | 0;
        hi = hi + Math.imul(ah6, bh4) | 0;
        lo = lo + Math.imul(al5, bl5) | 0;
        mid = mid + Math.imul(al5, bh5) | 0;
        mid = mid + Math.imul(ah5, bl5) | 0;
        hi = hi + Math.imul(ah5, bh5) | 0;
        lo = lo + Math.imul(al4, bl6) | 0;
        mid = mid + Math.imul(al4, bh6) | 0;
        mid = mid + Math.imul(ah4, bl6) | 0;
        hi = hi + Math.imul(ah4, bh6) | 0;
        lo = lo + Math.imul(al3, bl7) | 0;
        mid = mid + Math.imul(al3, bh7) | 0;
        mid = mid + Math.imul(ah3, bl7) | 0;
        hi = hi + Math.imul(ah3, bh7) | 0;
        lo = lo + Math.imul(al2, bl8) | 0;
        mid = mid + Math.imul(al2, bh8) | 0;
        mid = mid + Math.imul(ah2, bl8) | 0;
        hi = hi + Math.imul(ah2, bh8) | 0;
        lo = lo + Math.imul(al1, bl9) | 0;
        mid = mid + Math.imul(al1, bh9) | 0;
        mid = mid + Math.imul(ah1, bl9) | 0;
        hi = hi + Math.imul(ah1, bh9) | 0;
        var w10 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w10 >>> 26) | 0;
        w10 &= 0x3ffffff;
        /* k = 11 */ lo = Math.imul(al9, bl2);
        mid = Math.imul(al9, bh2);
        mid = mid + Math.imul(ah9, bl2) | 0;
        hi = Math.imul(ah9, bh2);
        lo = lo + Math.imul(al8, bl3) | 0;
        mid = mid + Math.imul(al8, bh3) | 0;
        mid = mid + Math.imul(ah8, bl3) | 0;
        hi = hi + Math.imul(ah8, bh3) | 0;
        lo = lo + Math.imul(al7, bl4) | 0;
        mid = mid + Math.imul(al7, bh4) | 0;
        mid = mid + Math.imul(ah7, bl4) | 0;
        hi = hi + Math.imul(ah7, bh4) | 0;
        lo = lo + Math.imul(al6, bl5) | 0;
        mid = mid + Math.imul(al6, bh5) | 0;
        mid = mid + Math.imul(ah6, bl5) | 0;
        hi = hi + Math.imul(ah6, bh5) | 0;
        lo = lo + Math.imul(al5, bl6) | 0;
        mid = mid + Math.imul(al5, bh6) | 0;
        mid = mid + Math.imul(ah5, bl6) | 0;
        hi = hi + Math.imul(ah5, bh6) | 0;
        lo = lo + Math.imul(al4, bl7) | 0;
        mid = mid + Math.imul(al4, bh7) | 0;
        mid = mid + Math.imul(ah4, bl7) | 0;
        hi = hi + Math.imul(ah4, bh7) | 0;
        lo = lo + Math.imul(al3, bl8) | 0;
        mid = mid + Math.imul(al3, bh8) | 0;
        mid = mid + Math.imul(ah3, bl8) | 0;
        hi = hi + Math.imul(ah3, bh8) | 0;
        lo = lo + Math.imul(al2, bl9) | 0;
        mid = mid + Math.imul(al2, bh9) | 0;
        mid = mid + Math.imul(ah2, bl9) | 0;
        hi = hi + Math.imul(ah2, bh9) | 0;
        var w11 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w11 >>> 26) | 0;
        w11 &= 0x3ffffff;
        /* k = 12 */ lo = Math.imul(al9, bl3);
        mid = Math.imul(al9, bh3);
        mid = mid + Math.imul(ah9, bl3) | 0;
        hi = Math.imul(ah9, bh3);
        lo = lo + Math.imul(al8, bl4) | 0;
        mid = mid + Math.imul(al8, bh4) | 0;
        mid = mid + Math.imul(ah8, bl4) | 0;
        hi = hi + Math.imul(ah8, bh4) | 0;
        lo = lo + Math.imul(al7, bl5) | 0;
        mid = mid + Math.imul(al7, bh5) | 0;
        mid = mid + Math.imul(ah7, bl5) | 0;
        hi = hi + Math.imul(ah7, bh5) | 0;
        lo = lo + Math.imul(al6, bl6) | 0;
        mid = mid + Math.imul(al6, bh6) | 0;
        mid = mid + Math.imul(ah6, bl6) | 0;
        hi = hi + Math.imul(ah6, bh6) | 0;
        lo = lo + Math.imul(al5, bl7) | 0;
        mid = mid + Math.imul(al5, bh7) | 0;
        mid = mid + Math.imul(ah5, bl7) | 0;
        hi = hi + Math.imul(ah5, bh7) | 0;
        lo = lo + Math.imul(al4, bl8) | 0;
        mid = mid + Math.imul(al4, bh8) | 0;
        mid = mid + Math.imul(ah4, bl8) | 0;
        hi = hi + Math.imul(ah4, bh8) | 0;
        lo = lo + Math.imul(al3, bl9) | 0;
        mid = mid + Math.imul(al3, bh9) | 0;
        mid = mid + Math.imul(ah3, bl9) | 0;
        hi = hi + Math.imul(ah3, bh9) | 0;
        var w12 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w12 >>> 26) | 0;
        w12 &= 0x3ffffff;
        /* k = 13 */ lo = Math.imul(al9, bl4);
        mid = Math.imul(al9, bh4);
        mid = mid + Math.imul(ah9, bl4) | 0;
        hi = Math.imul(ah9, bh4);
        lo = lo + Math.imul(al8, bl5) | 0;
        mid = mid + Math.imul(al8, bh5) | 0;
        mid = mid + Math.imul(ah8, bl5) | 0;
        hi = hi + Math.imul(ah8, bh5) | 0;
        lo = lo + Math.imul(al7, bl6) | 0;
        mid = mid + Math.imul(al7, bh6) | 0;
        mid = mid + Math.imul(ah7, bl6) | 0;
        hi = hi + Math.imul(ah7, bh6) | 0;
        lo = lo + Math.imul(al6, bl7) | 0;
        mid = mid + Math.imul(al6, bh7) | 0;
        mid = mid + Math.imul(ah6, bl7) | 0;
        hi = hi + Math.imul(ah6, bh7) | 0;
        lo = lo + Math.imul(al5, bl8) | 0;
        mid = mid + Math.imul(al5, bh8) | 0;
        mid = mid + Math.imul(ah5, bl8) | 0;
        hi = hi + Math.imul(ah5, bh8) | 0;
        lo = lo + Math.imul(al4, bl9) | 0;
        mid = mid + Math.imul(al4, bh9) | 0;
        mid = mid + Math.imul(ah4, bl9) | 0;
        hi = hi + Math.imul(ah4, bh9) | 0;
        var w13 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w13 >>> 26) | 0;
        w13 &= 0x3ffffff;
        /* k = 14 */ lo = Math.imul(al9, bl5);
        mid = Math.imul(al9, bh5);
        mid = mid + Math.imul(ah9, bl5) | 0;
        hi = Math.imul(ah9, bh5);
        lo = lo + Math.imul(al8, bl6) | 0;
        mid = mid + Math.imul(al8, bh6) | 0;
        mid = mid + Math.imul(ah8, bl6) | 0;
        hi = hi + Math.imul(ah8, bh6) | 0;
        lo = lo + Math.imul(al7, bl7) | 0;
        mid = mid + Math.imul(al7, bh7) | 0;
        mid = mid + Math.imul(ah7, bl7) | 0;
        hi = hi + Math.imul(ah7, bh7) | 0;
        lo = lo + Math.imul(al6, bl8) | 0;
        mid = mid + Math.imul(al6, bh8) | 0;
        mid = mid + Math.imul(ah6, bl8) | 0;
        hi = hi + Math.imul(ah6, bh8) | 0;
        lo = lo + Math.imul(al5, bl9) | 0;
        mid = mid + Math.imul(al5, bh9) | 0;
        mid = mid + Math.imul(ah5, bl9) | 0;
        hi = hi + Math.imul(ah5, bh9) | 0;
        var w14 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w14 >>> 26) | 0;
        w14 &= 0x3ffffff;
        /* k = 15 */ lo = Math.imul(al9, bl6);
        mid = Math.imul(al9, bh6);
        mid = mid + Math.imul(ah9, bl6) | 0;
        hi = Math.imul(ah9, bh6);
        lo = lo + Math.imul(al8, bl7) | 0;
        mid = mid + Math.imul(al8, bh7) | 0;
        mid = mid + Math.imul(ah8, bl7) | 0;
        hi = hi + Math.imul(ah8, bh7) | 0;
        lo = lo + Math.imul(al7, bl8) | 0;
        mid = mid + Math.imul(al7, bh8) | 0;
        mid = mid + Math.imul(ah7, bl8) | 0;
        hi = hi + Math.imul(ah7, bh8) | 0;
        lo = lo + Math.imul(al6, bl9) | 0;
        mid = mid + Math.imul(al6, bh9) | 0;
        mid = mid + Math.imul(ah6, bl9) | 0;
        hi = hi + Math.imul(ah6, bh9) | 0;
        var w15 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w15 >>> 26) | 0;
        w15 &= 0x3ffffff;
        /* k = 16 */ lo = Math.imul(al9, bl7);
        mid = Math.imul(al9, bh7);
        mid = mid + Math.imul(ah9, bl7) | 0;
        hi = Math.imul(ah9, bh7);
        lo = lo + Math.imul(al8, bl8) | 0;
        mid = mid + Math.imul(al8, bh8) | 0;
        mid = mid + Math.imul(ah8, bl8) | 0;
        hi = hi + Math.imul(ah8, bh8) | 0;
        lo = lo + Math.imul(al7, bl9) | 0;
        mid = mid + Math.imul(al7, bh9) | 0;
        mid = mid + Math.imul(ah7, bl9) | 0;
        hi = hi + Math.imul(ah7, bh9) | 0;
        var w16 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w16 >>> 26) | 0;
        w16 &= 0x3ffffff;
        /* k = 17 */ lo = Math.imul(al9, bl8);
        mid = Math.imul(al9, bh8);
        mid = mid + Math.imul(ah9, bl8) | 0;
        hi = Math.imul(ah9, bh8);
        lo = lo + Math.imul(al8, bl9) | 0;
        mid = mid + Math.imul(al8, bh9) | 0;
        mid = mid + Math.imul(ah8, bl9) | 0;
        hi = hi + Math.imul(ah8, bh9) | 0;
        var w17 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w17 >>> 26) | 0;
        w17 &= 0x3ffffff;
        /* k = 18 */ lo = Math.imul(al9, bl9);
        mid = Math.imul(al9, bh9);
        mid = mid + Math.imul(ah9, bl9) | 0;
        hi = Math.imul(ah9, bh9);
        var w18 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w18 >>> 26) | 0;
        w18 &= 0x3ffffff;
        o[0] = w0;
        o[1] = w1;
        o[2] = w2;
        o[3] = w3;
        o[4] = w4;
        o[5] = w5;
        o[6] = w6;
        o[7] = w7;
        o[8] = w8;
        o[9] = w9;
        o[10] = w10;
        o[11] = w11;
        o[12] = w12;
        o[13] = w13;
        o[14] = w14;
        o[15] = w15;
        o[16] = w16;
        o[17] = w17;
        o[18] = w18;
        if (c !== 0) {
            o[19] = c;
            out.length++;
        }
        return out;
    };
    // Polyfill comb
    if (!Math.imul) comb10MulTo = smallMulTo;
    function bigMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        out.length = self.length + num.length;
        var carry = 0;
        var hncarry = 0;
        for(var k = 0; k < out.length - 1; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = hncarry;
            hncarry = 0;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j;
                var a = self.words[i] | 0;
                var b = num.words[j] | 0;
                var r = a * b;
                var lo = r & 0x3ffffff;
                ncarry = ncarry + (r / 0x4000000 | 0) | 0;
                lo = lo + rword | 0;
                rword = lo & 0x3ffffff;
                ncarry = ncarry + (lo >>> 26) | 0;
                hncarry += ncarry >>> 26;
                ncarry &= 0x3ffffff;
            }
            out.words[k] = rword;
            carry = ncarry;
            ncarry = hncarry;
        }
        if (carry !== 0) out.words[k] = carry;
        else out.length--;
        return out._strip();
    }
    function jumboMulTo(self, num, out) {
        // Temporary disable, see https://github.com/indutny/bn.js/issues/211
        // var fftm = new FFTM();
        // return fftm.mulp(self, num, out);
        return bigMulTo(self, num, out);
    }
    BN.prototype.mulTo = function mulTo(num, out) {
        var res;
        var len = this.length + num.length;
        if (this.length === 10 && num.length === 10) res = comb10MulTo(this, num, out);
        else if (len < 63) res = smallMulTo(this, num, out);
        else if (len < 1024) res = bigMulTo(this, num, out);
        else res = jumboMulTo(this, num, out);
        return res;
    };
    // Cooley-Tukey algorithm for FFT
    // slightly revisited to rely on looping instead of recursion
    function FFTM(x, y) {
        this.x = x;
        this.y = y;
    }
    FFTM.prototype.makeRBT = function makeRBT(N) {
        var t = new Array(N);
        var l = BN.prototype._countBits(N) - 1;
        for(var i = 0; i < N; i++)t[i] = this.revBin(i, l, N);
        return t;
    };
    // Returns binary-reversed representation of `x`
    FFTM.prototype.revBin = function revBin(x, l, N) {
        if (x === 0 || x === N - 1) return x;
        var rb = 0;
        for(var i = 0; i < l; i++){
            rb |= (x & 1) << l - i - 1;
            x >>= 1;
        }
        return rb;
    };
    // Performs "tweedling" phase, therefore 'emulating'
    // behaviour of the recursive algorithm
    FFTM.prototype.permute = function permute(rbt, rws, iws, rtws, itws, N) {
        for(var i = 0; i < N; i++){
            rtws[i] = rws[rbt[i]];
            itws[i] = iws[rbt[i]];
        }
    };
    FFTM.prototype.transform = function transform(rws, iws, rtws, itws, N, rbt) {
        this.permute(rbt, rws, iws, rtws, itws, N);
        for(var s = 1; s < N; s <<= 1){
            var l = s << 1;
            var rtwdf = Math.cos(2 * Math.PI / l);
            var itwdf = Math.sin(2 * Math.PI / l);
            for(var p = 0; p < N; p += l){
                var rtwdf_ = rtwdf;
                var itwdf_ = itwdf;
                for(var j = 0; j < s; j++){
                    var re = rtws[p + j];
                    var ie = itws[p + j];
                    var ro = rtws[p + j + s];
                    var io = itws[p + j + s];
                    var rx = rtwdf_ * ro - itwdf_ * io;
                    io = rtwdf_ * io + itwdf_ * ro;
                    ro = rx;
                    rtws[p + j] = re + ro;
                    itws[p + j] = ie + io;
                    rtws[p + j + s] = re - ro;
                    itws[p + j + s] = ie - io;
                    /* jshint maxdepth : false */ if (j !== l) {
                        rx = rtwdf * rtwdf_ - itwdf * itwdf_;
                        itwdf_ = rtwdf * itwdf_ + itwdf * rtwdf_;
                        rtwdf_ = rx;
                    }
                }
            }
        }
    };
    FFTM.prototype.guessLen13b = function guessLen13b(n, m) {
        var N = Math.max(m, n) | 1;
        var odd = N & 1;
        var i = 0;
        for(N = N / 2 | 0; N; N = N >>> 1)i++;
        return 1 << i + 1 + odd;
    };
    FFTM.prototype.conjugate = function conjugate(rws, iws, N) {
        if (N <= 1) return;
        for(var i = 0; i < N / 2; i++){
            var t = rws[i];
            rws[i] = rws[N - i - 1];
            rws[N - i - 1] = t;
            t = iws[i];
            iws[i] = -iws[N - i - 1];
            iws[N - i - 1] = -t;
        }
    };
    FFTM.prototype.normalize13b = function normalize13b(ws, N) {
        var carry = 0;
        for(var i = 0; i < N / 2; i++){
            var w = Math.round(ws[2 * i + 1] / N) * 0x2000 + Math.round(ws[2 * i] / N) + carry;
            ws[i] = w & 0x3ffffff;
            if (w < 0x4000000) carry = 0;
            else carry = w / 0x4000000 | 0;
        }
        return ws;
    };
    FFTM.prototype.convert13b = function convert13b(ws, len, rws, N) {
        var carry = 0;
        for(var i = 0; i < len; i++){
            carry = carry + (ws[i] | 0);
            rws[2 * i] = carry & 0x1fff;
            carry = carry >>> 13;
            rws[2 * i + 1] = carry & 0x1fff;
            carry = carry >>> 13;
        }
        // Pad with zeroes
        for(i = 2 * len; i < N; ++i)rws[i] = 0;
        assert(carry === 0);
        assert((carry & -8192) === 0);
    };
    FFTM.prototype.stub = function stub(N) {
        var ph = new Array(N);
        for(var i = 0; i < N; i++)ph[i] = 0;
        return ph;
    };
    FFTM.prototype.mulp = function mulp(x, y, out) {
        var N = 2 * this.guessLen13b(x.length, y.length);
        var rbt = this.makeRBT(N);
        var _ = this.stub(N);
        var rws = new Array(N);
        var rwst = new Array(N);
        var iwst = new Array(N);
        var nrws = new Array(N);
        var nrwst = new Array(N);
        var niwst = new Array(N);
        var rmws = out.words;
        rmws.length = N;
        this.convert13b(x.words, x.length, rws, N);
        this.convert13b(y.words, y.length, nrws, N);
        this.transform(rws, _, rwst, iwst, N, rbt);
        this.transform(nrws, _, nrwst, niwst, N, rbt);
        for(var i = 0; i < N; i++){
            var rx = rwst[i] * nrwst[i] - iwst[i] * niwst[i];
            iwst[i] = rwst[i] * niwst[i] + iwst[i] * nrwst[i];
            rwst[i] = rx;
        }
        this.conjugate(rwst, iwst, N);
        this.transform(rwst, iwst, rmws, _, N, rbt);
        this.conjugate(rmws, _, N);
        this.normalize13b(rmws, N);
        out.negative = x.negative ^ y.negative;
        out.length = x.length + y.length;
        return out._strip();
    };
    // Multiply `this` by `num`
    BN.prototype.mul = function mul(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return this.mulTo(num, out);
    };
    // Multiply employing FFT
    BN.prototype.mulf = function mulf(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return jumboMulTo(this, num, out);
    };
    // In-place Multiplication
    BN.prototype.imul = function imul(num) {
        return this.clone().mulTo(num, this);
    };
    BN.prototype.imuln = function imuln(num) {
        var isNegNum = num < 0;
        if (isNegNum) num = -num;
        assert(typeof num === "number");
        assert(num < 0x4000000);
        // Carry
        var carry = 0;
        for(var i = 0; i < this.length; i++){
            var w = (this.words[i] | 0) * num;
            var lo = (w & 0x3ffffff) + (carry & 0x3ffffff);
            carry >>= 26;
            carry += w / 0x4000000 | 0;
            // NOTE: lo is 27bit maximum
            carry += lo >>> 26;
            this.words[i] = lo & 0x3ffffff;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return isNegNum ? this.ineg() : this;
    };
    BN.prototype.muln = function muln(num) {
        return this.clone().imuln(num);
    };
    // `this` * `this`
    BN.prototype.sqr = function sqr() {
        return this.mul(this);
    };
    // `this` * `this` in-place
    BN.prototype.isqr = function isqr() {
        return this.imul(this.clone());
    };
    // Math.pow(`this`, `num`)
    BN.prototype.pow = function pow(num) {
        var w = toBitArray(num);
        if (w.length === 0) return new BN(1);
        // Skip leading zeroes
        var res = this;
        for(var i = 0; i < w.length; i++, res = res.sqr()){
            if (w[i] !== 0) break;
        }
        if (++i < w.length) for(var q = res.sqr(); i < w.length; i++, q = q.sqr()){
            if (w[i] === 0) continue;
            res = res.mul(q);
        }
        return res;
    };
    // Shift-left in-place
    BN.prototype.iushln = function iushln(bits) {
        assert(typeof bits === "number" && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        var carryMask = 0x3ffffff >>> 26 - r << 26 - r;
        var i;
        if (r !== 0) {
            var carry = 0;
            for(i = 0; i < this.length; i++){
                var newCarry = this.words[i] & carryMask;
                var c = (this.words[i] | 0) - newCarry << r;
                this.words[i] = c | carry;
                carry = newCarry >>> 26 - r;
            }
            if (carry) {
                this.words[i] = carry;
                this.length++;
            }
        }
        if (s !== 0) {
            for(i = this.length - 1; i >= 0; i--)this.words[i + s] = this.words[i];
            for(i = 0; i < s; i++)this.words[i] = 0;
            this.length += s;
        }
        return this._strip();
    };
    BN.prototype.ishln = function ishln(bits) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushln(bits);
    };
    // Shift-right in-place
    // NOTE: `hint` is a lowest bit before trailing zeroes
    // NOTE: if `extended` is present - it will be filled with destroyed bits
    BN.prototype.iushrn = function iushrn(bits, hint, extended) {
        assert(typeof bits === "number" && bits >= 0);
        var h;
        if (hint) h = (hint - hint % 26) / 26;
        else h = 0;
        var r = bits % 26;
        var s = Math.min((bits - r) / 26, this.length);
        var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
        var maskedWords = extended;
        h -= s;
        h = Math.max(0, h);
        // Extended mode, copy masked part
        if (maskedWords) {
            for(var i = 0; i < s; i++)maskedWords.words[i] = this.words[i];
            maskedWords.length = s;
        }
        if (s === 0) ;
        else if (this.length > s) {
            this.length -= s;
            for(i = 0; i < this.length; i++)this.words[i] = this.words[i + s];
        } else {
            this.words[0] = 0;
            this.length = 1;
        }
        var carry = 0;
        for(i = this.length - 1; i >= 0 && (carry !== 0 || i >= h); i--){
            var word = this.words[i] | 0;
            this.words[i] = carry << 26 - r | word >>> r;
            carry = word & mask;
        }
        // Push carried bits as a mask
        if (maskedWords && carry !== 0) maskedWords.words[maskedWords.length++] = carry;
        if (this.length === 0) {
            this.words[0] = 0;
            this.length = 1;
        }
        return this._strip();
    };
    BN.prototype.ishrn = function ishrn(bits, hint, extended) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushrn(bits, hint, extended);
    };
    // Shift-left
    BN.prototype.shln = function shln(bits) {
        return this.clone().ishln(bits);
    };
    BN.prototype.ushln = function ushln(bits) {
        return this.clone().iushln(bits);
    };
    // Shift-right
    BN.prototype.shrn = function shrn(bits) {
        return this.clone().ishrn(bits);
    };
    BN.prototype.ushrn = function ushrn(bits) {
        return this.clone().iushrn(bits);
    };
    // Test if n bit is set
    BN.prototype.testn = function testn(bit) {
        assert(typeof bit === "number" && bit >= 0);
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) return false;
        // Check bit and return
        var w = this.words[s];
        return !!(w & q);
    };
    // Return only lowers bits of number (in-place)
    BN.prototype.imaskn = function imaskn(bits) {
        assert(typeof bits === "number" && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        assert(this.negative === 0, "imaskn works only with positive numbers");
        if (this.length <= s) return this;
        if (r !== 0) s++;
        this.length = Math.min(s, this.length);
        if (r !== 0) {
            var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
            this.words[this.length - 1] &= mask;
        }
        return this._strip();
    };
    // Return only lowers bits of number
    BN.prototype.maskn = function maskn(bits) {
        return this.clone().imaskn(bits);
    };
    // Add plain number `num` to `this`
    BN.prototype.iaddn = function iaddn(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        if (num < 0) return this.isubn(-num);
        // Possible sign change
        if (this.negative !== 0) {
            if (this.length === 1 && (this.words[0] | 0) <= num) {
                this.words[0] = num - (this.words[0] | 0);
                this.negative = 0;
                return this;
            }
            this.negative = 0;
            this.isubn(num);
            this.negative = 1;
            return this;
        }
        // Add without checks
        return this._iaddn(num);
    };
    BN.prototype._iaddn = function _iaddn(num) {
        this.words[0] += num;
        // Carry
        for(var i = 0; i < this.length && this.words[i] >= 0x4000000; i++){
            this.words[i] -= 0x4000000;
            if (i === this.length - 1) this.words[i + 1] = 1;
            else this.words[i + 1]++;
        }
        this.length = Math.max(this.length, i + 1);
        return this;
    };
    // Subtract plain number `num` from `this`
    BN.prototype.isubn = function isubn(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        if (num < 0) return this.iaddn(-num);
        if (this.negative !== 0) {
            this.negative = 0;
            this.iaddn(num);
            this.negative = 1;
            return this;
        }
        this.words[0] -= num;
        if (this.length === 1 && this.words[0] < 0) {
            this.words[0] = -this.words[0];
            this.negative = 1;
        } else // Carry
        for(var i = 0; i < this.length && this.words[i] < 0; i++){
            this.words[i] += 0x4000000;
            this.words[i + 1] -= 1;
        }
        return this._strip();
    };
    BN.prototype.addn = function addn(num) {
        return this.clone().iaddn(num);
    };
    BN.prototype.subn = function subn(num) {
        return this.clone().isubn(num);
    };
    BN.prototype.iabs = function iabs() {
        this.negative = 0;
        return this;
    };
    BN.prototype.abs = function abs() {
        return this.clone().iabs();
    };
    BN.prototype._ishlnsubmul = function _ishlnsubmul(num, mul, shift) {
        var len = num.length + shift;
        var i;
        this._expand(len);
        var w;
        var carry = 0;
        for(i = 0; i < num.length; i++){
            w = (this.words[i + shift] | 0) + carry;
            var right = (num.words[i] | 0) * mul;
            w -= right & 0x3ffffff;
            carry = (w >> 26) - (right / 0x4000000 | 0);
            this.words[i + shift] = w & 0x3ffffff;
        }
        for(; i < this.length - shift; i++){
            w = (this.words[i + shift] | 0) + carry;
            carry = w >> 26;
            this.words[i + shift] = w & 0x3ffffff;
        }
        if (carry === 0) return this._strip();
        // Subtraction overflow
        assert(carry === -1);
        carry = 0;
        for(i = 0; i < this.length; i++){
            w = -(this.words[i] | 0) + carry;
            carry = w >> 26;
            this.words[i] = w & 0x3ffffff;
        }
        this.negative = 1;
        return this._strip();
    };
    BN.prototype._wordDiv = function _wordDiv(num, mode) {
        var shift = this.length - num.length;
        var a = this.clone();
        var b = num;
        // Normalize
        var bhi = b.words[b.length - 1] | 0;
        var bhiBits = this._countBits(bhi);
        shift = 26 - bhiBits;
        if (shift !== 0) {
            b = b.ushln(shift);
            a.iushln(shift);
            bhi = b.words[b.length - 1] | 0;
        }
        // Initialize quotient
        var m = a.length - b.length;
        var q;
        if (mode !== "mod") {
            q = new BN(null);
            q.length = m + 1;
            q.words = new Array(q.length);
            for(var i = 0; i < q.length; i++)q.words[i] = 0;
        }
        var diff = a.clone()._ishlnsubmul(b, 1, m);
        if (diff.negative === 0) {
            a = diff;
            if (q) q.words[m] = 1;
        }
        for(var j = m - 1; j >= 0; j--){
            var qj = (a.words[b.length + j] | 0) * 0x4000000 + (a.words[b.length + j - 1] | 0);
            // NOTE: (qj / bhi) is (0x3ffffff * 0x4000000 + 0x3ffffff) / 0x2000000 max
            // (0x7ffffff)
            qj = Math.min(qj / bhi | 0, 0x3ffffff);
            a._ishlnsubmul(b, qj, j);
            while(a.negative !== 0){
                qj--;
                a.negative = 0;
                a._ishlnsubmul(b, 1, j);
                if (!a.isZero()) a.negative ^= 1;
            }
            if (q) q.words[j] = qj;
        }
        if (q) q._strip();
        a._strip();
        // Denormalize
        if (mode !== "div" && shift !== 0) a.iushrn(shift);
        return {
            div: q || null,
            mod: a
        };
    };
    // NOTE: 1) `mode` can be set to `mod` to request mod only,
    //       to `div` to request div only, or be absent to
    //       request both div & mod
    //       2) `positive` is true if unsigned mod is requested
    BN.prototype.divmod = function divmod(num, mode, positive) {
        assert(!num.isZero());
        if (this.isZero()) return {
            div: new BN(0),
            mod: new BN(0)
        };
        var div, mod, res;
        if (this.negative !== 0 && num.negative === 0) {
            res = this.neg().divmod(num, mode);
            if (mode !== "mod") div = res.div.neg();
            if (mode !== "div") {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.iadd(num);
            }
            return {
                div: div,
                mod: mod
            };
        }
        if (this.negative === 0 && num.negative !== 0) {
            res = this.divmod(num.neg(), mode);
            if (mode !== "mod") div = res.div.neg();
            return {
                div: div,
                mod: res.mod
            };
        }
        if ((this.negative & num.negative) !== 0) {
            res = this.neg().divmod(num.neg(), mode);
            if (mode !== "div") {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.isub(num);
            }
            return {
                div: res.div,
                mod: mod
            };
        }
        // Both numbers are positive at this point
        // Strip both numbers to approximate shift value
        if (num.length > this.length || this.cmp(num) < 0) return {
            div: new BN(0),
            mod: this
        };
        // Very short reduction
        if (num.length === 1) {
            if (mode === "div") return {
                div: this.divn(num.words[0]),
                mod: null
            };
            if (mode === "mod") return {
                div: null,
                mod: new BN(this.modrn(num.words[0]))
            };
            return {
                div: this.divn(num.words[0]),
                mod: new BN(this.modrn(num.words[0]))
            };
        }
        return this._wordDiv(num, mode);
    };
    // Find `this` / `num`
    BN.prototype.div = function div(num) {
        return this.divmod(num, "div", false).div;
    };
    // Find `this` % `num`
    BN.prototype.mod = function mod(num) {
        return this.divmod(num, "mod", false).mod;
    };
    BN.prototype.umod = function umod(num) {
        return this.divmod(num, "mod", true).mod;
    };
    // Find Round(`this` / `num`)
    BN.prototype.divRound = function divRound(num) {
        var dm = this.divmod(num);
        // Fast case - exact division
        if (dm.mod.isZero()) return dm.div;
        var mod = dm.div.negative !== 0 ? dm.mod.isub(num) : dm.mod;
        var half = num.ushrn(1);
        var r2 = num.andln(1);
        var cmp = mod.cmp(half);
        // Round down
        if (cmp < 0 || r2 === 1 && cmp === 0) return dm.div;
        // Round up
        return dm.div.negative !== 0 ? dm.div.isubn(1) : dm.div.iaddn(1);
    };
    BN.prototype.modrn = function modrn(num) {
        var isNegNum = num < 0;
        if (isNegNum) num = -num;
        assert(num <= 0x3ffffff);
        var p = 67108864 % num;
        var acc = 0;
        for(var i = this.length - 1; i >= 0; i--)acc = (p * acc + (this.words[i] | 0)) % num;
        return isNegNum ? -acc : acc;
    };
    // WARNING: DEPRECATED
    BN.prototype.modn = function modn(num) {
        return this.modrn(num);
    };
    // In-place division by number
    BN.prototype.idivn = function idivn(num) {
        var isNegNum = num < 0;
        if (isNegNum) num = -num;
        assert(num <= 0x3ffffff);
        var carry = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var w = (this.words[i] | 0) + carry * 0x4000000;
            this.words[i] = w / num | 0;
            carry = w % num;
        }
        this._strip();
        return isNegNum ? this.ineg() : this;
    };
    BN.prototype.divn = function divn(num) {
        return this.clone().idivn(num);
    };
    BN.prototype.egcd = function egcd(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var x = this;
        var y = p.clone();
        if (x.negative !== 0) x = x.umod(p);
        else x = x.clone();
        // A * x + B * y = x
        var A = new BN(1);
        var B = new BN(0);
        // C * x + D * y = y
        var C = new BN(0);
        var D = new BN(1);
        var g = 0;
        while(x.isEven() && y.isEven()){
            x.iushrn(1);
            y.iushrn(1);
            ++g;
        }
        var yp = y.clone();
        var xp = x.clone();
        while(!x.isZero()){
            for(var i = 0, im = 1; (x.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                x.iushrn(i);
                while(i-- > 0){
                    if (A.isOdd() || B.isOdd()) {
                        A.iadd(yp);
                        B.isub(xp);
                    }
                    A.iushrn(1);
                    B.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (y.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                y.iushrn(j);
                while(j-- > 0){
                    if (C.isOdd() || D.isOdd()) {
                        C.iadd(yp);
                        D.isub(xp);
                    }
                    C.iushrn(1);
                    D.iushrn(1);
                }
            }
            if (x.cmp(y) >= 0) {
                x.isub(y);
                A.isub(C);
                B.isub(D);
            } else {
                y.isub(x);
                C.isub(A);
                D.isub(B);
            }
        }
        return {
            a: C,
            b: D,
            gcd: y.iushln(g)
        };
    };
    // This is reduced incarnation of the binary EEA
    // above, designated to invert members of the
    // _prime_ fields F(p) at a maximal speed
    BN.prototype._invmp = function _invmp(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var a = this;
        var b = p.clone();
        if (a.negative !== 0) a = a.umod(p);
        else a = a.clone();
        var x1 = new BN(1);
        var x2 = new BN(0);
        var delta = b.clone();
        while(a.cmpn(1) > 0 && b.cmpn(1) > 0){
            for(var i = 0, im = 1; (a.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                a.iushrn(i);
                while(i-- > 0){
                    if (x1.isOdd()) x1.iadd(delta);
                    x1.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (b.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                b.iushrn(j);
                while(j-- > 0){
                    if (x2.isOdd()) x2.iadd(delta);
                    x2.iushrn(1);
                }
            }
            if (a.cmp(b) >= 0) {
                a.isub(b);
                x1.isub(x2);
            } else {
                b.isub(a);
                x2.isub(x1);
            }
        }
        var res;
        if (a.cmpn(1) === 0) res = x1;
        else res = x2;
        if (res.cmpn(0) < 0) res.iadd(p);
        return res;
    };
    BN.prototype.gcd = function gcd(num) {
        if (this.isZero()) return num.abs();
        if (num.isZero()) return this.abs();
        var a = this.clone();
        var b = num.clone();
        a.negative = 0;
        b.negative = 0;
        // Remove common factor of two
        for(var shift = 0; a.isEven() && b.isEven(); shift++){
            a.iushrn(1);
            b.iushrn(1);
        }
        do {
            while(a.isEven())a.iushrn(1);
            while(b.isEven())b.iushrn(1);
            var r = a.cmp(b);
            if (r < 0) {
                // Swap `a` and `b` to make `a` always bigger than `b`
                var t = a;
                a = b;
                b = t;
            } else if (r === 0 || b.cmpn(1) === 0) break;
            a.isub(b);
        }while (true);
        return b.iushln(shift);
    };
    // Invert number in the field F(num)
    BN.prototype.invm = function invm(num) {
        return this.egcd(num).a.umod(num);
    };
    BN.prototype.isEven = function isEven() {
        return (this.words[0] & 1) === 0;
    };
    BN.prototype.isOdd = function isOdd() {
        return (this.words[0] & 1) === 1;
    };
    // And first word and num
    BN.prototype.andln = function andln(num) {
        return this.words[0] & num;
    };
    // Increment at the bit position in-line
    BN.prototype.bincn = function bincn(bit) {
        assert(typeof bit === "number");
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) {
            this._expand(s + 1);
            this.words[s] |= q;
            return this;
        }
        // Add bit and propagate, if needed
        var carry = q;
        for(var i = s; carry !== 0 && i < this.length; i++){
            var w = this.words[i] | 0;
            w += carry;
            carry = w >>> 26;
            w &= 0x3ffffff;
            this.words[i] = w;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return this;
    };
    BN.prototype.isZero = function isZero() {
        return this.length === 1 && this.words[0] === 0;
    };
    BN.prototype.cmpn = function cmpn(num) {
        var negative = num < 0;
        if (this.negative !== 0 && !negative) return -1;
        if (this.negative === 0 && negative) return 1;
        this._strip();
        var res;
        if (this.length > 1) res = 1;
        else {
            if (negative) num = -num;
            assert(num <= 0x3ffffff, "Number is too big");
            var w = this.words[0] | 0;
            res = w === num ? 0 : w < num ? -1 : 1;
        }
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Compare two numbers and return:
    // 1 - if `this` > `num`
    // 0 - if `this` == `num`
    // -1 - if `this` < `num`
    BN.prototype.cmp = function cmp(num) {
        if (this.negative !== 0 && num.negative === 0) return -1;
        if (this.negative === 0 && num.negative !== 0) return 1;
        var res = this.ucmp(num);
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Unsigned comparison
    BN.prototype.ucmp = function ucmp(num) {
        // At this point both numbers have the same sign
        if (this.length > num.length) return 1;
        if (this.length < num.length) return -1;
        var res = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var a = this.words[i] | 0;
            var b = num.words[i] | 0;
            if (a === b) continue;
            if (a < b) res = -1;
            else if (a > b) res = 1;
            break;
        }
        return res;
    };
    BN.prototype.gtn = function gtn(num) {
        return this.cmpn(num) === 1;
    };
    BN.prototype.gt = function gt(num) {
        return this.cmp(num) === 1;
    };
    BN.prototype.gten = function gten(num) {
        return this.cmpn(num) >= 0;
    };
    BN.prototype.gte = function gte(num) {
        return this.cmp(num) >= 0;
    };
    BN.prototype.ltn = function ltn(num) {
        return this.cmpn(num) === -1;
    };
    BN.prototype.lt = function lt(num) {
        return this.cmp(num) === -1;
    };
    BN.prototype.lten = function lten(num) {
        return this.cmpn(num) <= 0;
    };
    BN.prototype.lte = function lte(num) {
        return this.cmp(num) <= 0;
    };
    BN.prototype.eqn = function eqn(num) {
        return this.cmpn(num) === 0;
    };
    BN.prototype.eq = function eq(num) {
        return this.cmp(num) === 0;
    };
    //
    // A reduce context, could be using montgomery or something better, depending
    // on the `m` itself.
    //
    BN.red = function red(num) {
        return new Red(num);
    };
    BN.prototype.toRed = function toRed(ctx) {
        assert(!this.red, "Already a number in reduction context");
        assert(this.negative === 0, "red works only with positives");
        return ctx.convertTo(this)._forceRed(ctx);
    };
    BN.prototype.fromRed = function fromRed() {
        assert(this.red, "fromRed works only with numbers in reduction context");
        return this.red.convertFrom(this);
    };
    BN.prototype._forceRed = function _forceRed(ctx) {
        this.red = ctx;
        return this;
    };
    BN.prototype.forceRed = function forceRed(ctx) {
        assert(!this.red, "Already a number in reduction context");
        return this._forceRed(ctx);
    };
    BN.prototype.redAdd = function redAdd(num) {
        assert(this.red, "redAdd works only with red numbers");
        return this.red.add(this, num);
    };
    BN.prototype.redIAdd = function redIAdd(num) {
        assert(this.red, "redIAdd works only with red numbers");
        return this.red.iadd(this, num);
    };
    BN.prototype.redSub = function redSub(num) {
        assert(this.red, "redSub works only with red numbers");
        return this.red.sub(this, num);
    };
    BN.prototype.redISub = function redISub(num) {
        assert(this.red, "redISub works only with red numbers");
        return this.red.isub(this, num);
    };
    BN.prototype.redShl = function redShl(num) {
        assert(this.red, "redShl works only with red numbers");
        return this.red.shl(this, num);
    };
    BN.prototype.redMul = function redMul(num) {
        assert(this.red, "redMul works only with red numbers");
        this.red._verify2(this, num);
        return this.red.mul(this, num);
    };
    BN.prototype.redIMul = function redIMul(num) {
        assert(this.red, "redMul works only with red numbers");
        this.red._verify2(this, num);
        return this.red.imul(this, num);
    };
    BN.prototype.redSqr = function redSqr() {
        assert(this.red, "redSqr works only with red numbers");
        this.red._verify1(this);
        return this.red.sqr(this);
    };
    BN.prototype.redISqr = function redISqr() {
        assert(this.red, "redISqr works only with red numbers");
        this.red._verify1(this);
        return this.red.isqr(this);
    };
    // Square root over p
    BN.prototype.redSqrt = function redSqrt() {
        assert(this.red, "redSqrt works only with red numbers");
        this.red._verify1(this);
        return this.red.sqrt(this);
    };
    BN.prototype.redInvm = function redInvm() {
        assert(this.red, "redInvm works only with red numbers");
        this.red._verify1(this);
        return this.red.invm(this);
    };
    // Return negative clone of `this` % `red modulo`
    BN.prototype.redNeg = function redNeg() {
        assert(this.red, "redNeg works only with red numbers");
        this.red._verify1(this);
        return this.red.neg(this);
    };
    BN.prototype.redPow = function redPow(num) {
        assert(this.red && !num.red, "redPow(normalNum)");
        this.red._verify1(this);
        return this.red.pow(this, num);
    };
    // Prime numbers with efficient reduction
    var primes = {
        k256: null,
        p224: null,
        p192: null,
        p25519: null
    };
    // Pseudo-Mersenne prime
    function MPrime(name, p) {
        // P = 2 ^ N - K
        this.name = name;
        this.p = new BN(p, 16);
        this.n = this.p.bitLength();
        this.k = new BN(1).iushln(this.n).isub(this.p);
        this.tmp = this._tmp();
    }
    MPrime.prototype._tmp = function _tmp() {
        var tmp = new BN(null);
        tmp.words = new Array(Math.ceil(this.n / 13));
        return tmp;
    };
    MPrime.prototype.ireduce = function ireduce(num) {
        // Assumes that `num` is less than `P^2`
        // num = HI * (2 ^ N - K) + HI * K + LO = HI * K + LO (mod P)
        var r = num;
        var rlen;
        do {
            this.split(r, this.tmp);
            r = this.imulK(r);
            r = r.iadd(this.tmp);
            rlen = r.bitLength();
        }while (rlen > this.n);
        var cmp = rlen < this.n ? -1 : r.ucmp(this.p);
        if (cmp === 0) {
            r.words[0] = 0;
            r.length = 1;
        } else if (cmp > 0) r.isub(this.p);
        else if (r.strip !== undefined) // r is a BN v4 instance
        r.strip();
        else // r is a BN v5 instance
        r._strip();
        return r;
    };
    MPrime.prototype.split = function split(input, out) {
        input.iushrn(this.n, 0, out);
    };
    MPrime.prototype.imulK = function imulK(num) {
        return num.imul(this.k);
    };
    function K256() {
        MPrime.call(this, "k256", "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f");
    }
    inherits(K256, MPrime);
    K256.prototype.split = function split(input, output) {
        // 256 = 9 * 26 + 22
        var mask = 0x3fffff;
        var outLen = Math.min(input.length, 9);
        for(var i = 0; i < outLen; i++)output.words[i] = input.words[i];
        output.length = outLen;
        if (input.length <= 9) {
            input.words[0] = 0;
            input.length = 1;
            return;
        }
        // Shift by 9 limbs
        var prev = input.words[9];
        output.words[output.length++] = prev & mask;
        for(i = 10; i < input.length; i++){
            var next = input.words[i] | 0;
            input.words[i - 10] = (next & mask) << 4 | prev >>> 22;
            prev = next;
        }
        prev >>>= 22;
        input.words[i - 10] = prev;
        if (prev === 0 && input.length > 10) input.length -= 10;
        else input.length -= 9;
    };
    K256.prototype.imulK = function imulK(num) {
        // K = 0x1000003d1 = [ 0x40, 0x3d1 ]
        num.words[num.length] = 0;
        num.words[num.length + 1] = 0;
        num.length += 2;
        // bounded at: 0x40 * 0x3ffffff + 0x3d0 = 0x100000390
        var lo = 0;
        for(var i = 0; i < num.length; i++){
            var w = num.words[i] | 0;
            lo += w * 0x3d1;
            num.words[i] = lo & 0x3ffffff;
            lo = w * 0x40 + (lo / 0x4000000 | 0);
        }
        // Fast length reduction
        if (num.words[num.length - 1] === 0) {
            num.length--;
            if (num.words[num.length - 1] === 0) num.length--;
        }
        return num;
    };
    function P224() {
        MPrime.call(this, "p224", "ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001");
    }
    inherits(P224, MPrime);
    function P192() {
        MPrime.call(this, "p192", "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff");
    }
    inherits(P192, MPrime);
    function P25519() {
        // 2 ^ 255 - 19
        MPrime.call(this, "25519", "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed");
    }
    inherits(P25519, MPrime);
    P25519.prototype.imulK = function imulK(num) {
        // K = 0x13
        var carry = 0;
        for(var i = 0; i < num.length; i++){
            var hi = (num.words[i] | 0) * 0x13 + carry;
            var lo = hi & 0x3ffffff;
            hi >>>= 26;
            num.words[i] = lo;
            carry = hi;
        }
        if (carry !== 0) num.words[num.length++] = carry;
        return num;
    };
    // Exported mostly for testing purposes, use plain name instead
    BN._prime = function prime(name) {
        // Cached version of prime
        if (primes[name]) return primes[name];
        var prime;
        if (name === "k256") prime = new K256();
        else if (name === "p224") prime = new P224();
        else if (name === "p192") prime = new P192();
        else if (name === "p25519") prime = new P25519();
        else throw new Error("Unknown prime " + name);
        primes[name] = prime;
        return prime;
    };
    //
    // Base reduction engine
    //
    function Red(m) {
        if (typeof m === "string") {
            var prime = BN._prime(m);
            this.m = prime.p;
            this.prime = prime;
        } else {
            assert(m.gtn(1), "modulus must be greater than 1");
            this.m = m;
            this.prime = null;
        }
    }
    Red.prototype._verify1 = function _verify1(a) {
        assert(a.negative === 0, "red works only with positives");
        assert(a.red, "red works only with red numbers");
    };
    Red.prototype._verify2 = function _verify2(a, b) {
        assert((a.negative | b.negative) === 0, "red works only with positives");
        assert(a.red && a.red === b.red, "red works only with red numbers");
    };
    Red.prototype.imod = function imod(a) {
        if (this.prime) return this.prime.ireduce(a)._forceRed(this);
        move(a, a.umod(this.m)._forceRed(this));
        return a;
    };
    Red.prototype.neg = function neg(a) {
        if (a.isZero()) return a.clone();
        return this.m.sub(a)._forceRed(this);
    };
    Red.prototype.add = function add(a, b) {
        this._verify2(a, b);
        var res = a.add(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res._forceRed(this);
    };
    Red.prototype.iadd = function iadd(a, b) {
        this._verify2(a, b);
        var res = a.iadd(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res;
    };
    Red.prototype.sub = function sub(a, b) {
        this._verify2(a, b);
        var res = a.sub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res._forceRed(this);
    };
    Red.prototype.isub = function isub(a, b) {
        this._verify2(a, b);
        var res = a.isub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res;
    };
    Red.prototype.shl = function shl(a, num) {
        this._verify1(a);
        return this.imod(a.ushln(num));
    };
    Red.prototype.imul = function imul(a, b) {
        this._verify2(a, b);
        return this.imod(a.imul(b));
    };
    Red.prototype.mul = function mul(a, b) {
        this._verify2(a, b);
        return this.imod(a.mul(b));
    };
    Red.prototype.isqr = function isqr(a) {
        return this.imul(a, a.clone());
    };
    Red.prototype.sqr = function sqr(a) {
        return this.mul(a, a);
    };
    Red.prototype.sqrt = function sqrt(a) {
        if (a.isZero()) return a.clone();
        var mod3 = this.m.andln(3);
        assert(mod3 % 2 === 1);
        // Fast case
        if (mod3 === 3) {
            var pow = this.m.add(new BN(1)).iushrn(2);
            return this.pow(a, pow);
        }
        // Tonelli-Shanks algorithm (Totally unoptimized and slow)
        //
        // Find Q and S, that Q * 2 ^ S = (P - 1)
        var q = this.m.subn(1);
        var s = 0;
        while(!q.isZero() && q.andln(1) === 0){
            s++;
            q.iushrn(1);
        }
        assert(!q.isZero());
        var one = new BN(1).toRed(this);
        var nOne = one.redNeg();
        // Find quadratic non-residue
        // NOTE: Max is such because of generalized Riemann hypothesis.
        var lpow = this.m.subn(1).iushrn(1);
        var z = this.m.bitLength();
        z = new BN(2 * z * z).toRed(this);
        while(this.pow(z, lpow).cmp(nOne) !== 0)z.redIAdd(nOne);
        var c = this.pow(z, q);
        var r = this.pow(a, q.addn(1).iushrn(1));
        var t = this.pow(a, q);
        var m = s;
        while(t.cmp(one) !== 0){
            var tmp = t;
            for(var i = 0; tmp.cmp(one) !== 0; i++)tmp = tmp.redSqr();
            assert(i < m);
            var b = this.pow(c, new BN(1).iushln(m - i - 1));
            r = r.redMul(b);
            c = b.redSqr();
            t = t.redMul(c);
            m = i;
        }
        return r;
    };
    Red.prototype.invm = function invm(a) {
        var inv = a._invmp(this.m);
        if (inv.negative !== 0) {
            inv.negative = 0;
            return this.imod(inv).redNeg();
        } else return this.imod(inv);
    };
    Red.prototype.pow = function pow(a, num) {
        if (num.isZero()) return new BN(1).toRed(this);
        if (num.cmpn(1) === 0) return a.clone();
        var windowSize = 4;
        var wnd = new Array(1 << windowSize);
        wnd[0] = new BN(1).toRed(this);
        wnd[1] = a;
        for(var i = 2; i < wnd.length; i++)wnd[i] = this.mul(wnd[i - 1], a);
        var res = wnd[0];
        var current = 0;
        var currentLen = 0;
        var start = num.bitLength() % 26;
        if (start === 0) start = 26;
        for(i = num.length - 1; i >= 0; i--){
            var word = num.words[i];
            for(var j = start - 1; j >= 0; j--){
                var bit = word >> j & 1;
                if (res !== wnd[0]) res = this.sqr(res);
                if (bit === 0 && current === 0) {
                    currentLen = 0;
                    continue;
                }
                current <<= 1;
                current |= bit;
                currentLen++;
                if (currentLen !== windowSize && (i !== 0 || j !== 0)) continue;
                res = this.mul(res, wnd[current]);
                currentLen = 0;
                current = 0;
            }
            start = 26;
        }
        return res;
    };
    Red.prototype.convertTo = function convertTo(num) {
        var r = num.umod(this.m);
        return r === num ? r.clone() : r;
    };
    Red.prototype.convertFrom = function convertFrom(num) {
        var res = num.clone();
        res.red = null;
        return res;
    };
    //
    // Montgomery method engine
    //
    BN.mont = function mont(num) {
        return new Mont(num);
    };
    function Mont(m) {
        Red.call(this, m);
        this.shift = this.m.bitLength();
        if (this.shift % 26 !== 0) this.shift += 26 - this.shift % 26;
        this.r = new BN(1).iushln(this.shift);
        this.r2 = this.imod(this.r.sqr());
        this.rinv = this.r._invmp(this.m);
        this.minv = this.rinv.mul(this.r).isubn(1).div(this.m);
        this.minv = this.minv.umod(this.r);
        this.minv = this.r.sub(this.minv);
    }
    inherits(Mont, Red);
    Mont.prototype.convertTo = function convertTo(num) {
        return this.imod(num.ushln(this.shift));
    };
    Mont.prototype.convertFrom = function convertFrom(num) {
        var r = this.imod(num.mul(this.rinv));
        r.red = null;
        return r;
    };
    Mont.prototype.imul = function imul(a, b) {
        if (a.isZero() || b.isZero()) {
            a.words[0] = 0;
            a.length = 1;
            return a;
        }
        var t = a.imul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.mul = function mul(a, b) {
        if (a.isZero() || b.isZero()) return new BN(0)._forceRed(this);
        var t = a.mul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.invm = function invm(a) {
        // (AR)^-1 * R^2 = (A^-1 * R^-1) * R^2 = A^-1 * R
        var res = this.imod(a._invmp(this.m).mul(this.r2));
        return res._forceRed(this);
    };
})(module, this);

});

parcelRequire.register("9vosj", function(module, exports) {

$parcel$export(module.exports, "TextEncoder", function () { return $6eb9fab1eab3180d$export$88fb0cfd153261a7; }, function (v) { return $6eb9fab1eab3180d$export$88fb0cfd153261a7 = v; });
$parcel$export(module.exports, "TextDecoder", function () { return $6eb9fab1eab3180d$export$9c6b53e35bc51b5c; }, function (v) { return $6eb9fab1eab3180d$export$9c6b53e35bc51b5c = v; });
var $6eb9fab1eab3180d$export$88fb0cfd153261a7;
var $6eb9fab1eab3180d$export$9c6b53e35bc51b5c;
"use strict";
// This is free and unencumbered software released into the public domain.
// See LICENSE.md for more information.
//
// Utilities
//
/**
 * @param {number} a The number to test.
 * @param {number} min The minimum value in the range, inclusive.
 * @param {number} max The maximum value in the range, inclusive.
 * @return {boolean} True if a >= min and a <= max.
 */ function $6eb9fab1eab3180d$var$inRange(a, min, max) {
    return min <= a && a <= max;
}
/**
 * @param {*} o
 * @return {Object}
 */ function $6eb9fab1eab3180d$var$ToDictionary(o) {
    if (o === undefined) return {};
    if (o === Object(o)) return o;
    throw TypeError("Could not convert argument to dictionary");
}
/**
 * @param {string} string Input string of UTF-16 code units.
 * @return {!Array.<number>} Code points.
 */ function $6eb9fab1eab3180d$var$stringToCodePoints(string) {
    // https://heycam.github.io/webidl/#dfn-obtain-unicode
    // 1. Let S be the DOMString value.
    var s = String(string);
    // 2. Let n be the length of S.
    var n = s.length;
    // 3. Initialize i to 0.
    var i = 0;
    // 4. Initialize U to be an empty sequence of Unicode characters.
    var u = [];
    // 5. While i < n:
    while(i < n){
        // 1. Let c be the code unit in S at index i.
        var c = s.charCodeAt(i);
        // 2. Depending on the value of c:
        // c < 0xD800 or c > 0xDFFF
        if (c < 0xD800 || c > 0xDFFF) // Append to U the Unicode character with code point c.
        u.push(c);
        else if (0xDC00 <= c && c <= 0xDFFF) // Append to U a U+FFFD REPLACEMENT CHARACTER.
        u.push(0xFFFD);
        else if (0xD800 <= c && c <= 0xDBFF) {
            // 1. If i = n−1, then append to U a U+FFFD REPLACEMENT
            // CHARACTER.
            if (i === n - 1) u.push(0xFFFD);
            else {
                // 1. Let d be the code unit in S at index i+1.
                var d = string.charCodeAt(i + 1);
                // 2. If 0xDC00 ≤ d ≤ 0xDFFF, then:
                if (0xDC00 <= d && d <= 0xDFFF) {
                    // 1. Let a be c & 0x3FF.
                    var a = c & 0x3FF;
                    // 2. Let b be d & 0x3FF.
                    var b = d & 0x3FF;
                    // 3. Append to U the Unicode character with code point
                    // 2^16+2^10*a+b.
                    u.push(0x10000 + (a << 10) + b);
                    // 4. Set i to i+1.
                    i += 1;
                } else u.push(0xFFFD);
            }
        }
        // 3. Set i to i+1.
        i += 1;
    }
    // 6. Return U.
    return u;
}
/**
 * @param {!Array.<number>} code_points Array of code points.
 * @return {string} string String of UTF-16 code units.
 */ function $6eb9fab1eab3180d$var$codePointsToString(code_points) {
    var s = "";
    for(var i = 0; i < code_points.length; ++i){
        var cp = code_points[i];
        if (cp <= 0xFFFF) s += String.fromCharCode(cp);
        else {
            cp -= 0x10000;
            s += String.fromCharCode((cp >> 10) + 0xD800, (cp & 0x3FF) + 0xDC00);
        }
    }
    return s;
}
//
// Implementation of Encoding specification
// https://encoding.spec.whatwg.org/
//
//
// 3. Terminology
//
/**
 * End-of-stream is a special token that signifies no more tokens
 * are in the stream.
 * @const
 */ var $6eb9fab1eab3180d$var$end_of_stream = -1;
/**
 * A stream represents an ordered sequence of tokens.
 *
 * @constructor
 * @param {!(Array.<number>|Uint8Array)} tokens Array of tokens that provide the
 * stream.
 */ function $6eb9fab1eab3180d$var$Stream(tokens) {
    /** @type {!Array.<number>} */ this.tokens = [].slice.call(tokens);
}
$6eb9fab1eab3180d$var$Stream.prototype = {
    /**
   * @return {boolean} True if end-of-stream has been hit.
   */ endOfStream: function() {
        return !this.tokens.length;
    },
    /**
   * When a token is read from a stream, the first token in the
   * stream must be returned and subsequently removed, and
   * end-of-stream must be returned otherwise.
   *
   * @return {number} Get the next token from the stream, or
   * end_of_stream.
   */ read: function() {
        if (!this.tokens.length) return $6eb9fab1eab3180d$var$end_of_stream;
        return this.tokens.shift();
    },
    /**
   * When one or more tokens are prepended to a stream, those tokens
   * must be inserted, in given order, before the first token in the
   * stream.
   *
   * @param {(number|!Array.<number>)} token The token(s) to prepend to the stream.
   */ prepend: function(token) {
        if (Array.isArray(token)) {
            var tokens = /**@type {!Array.<number>}*/ token;
            while(tokens.length)this.tokens.unshift(tokens.pop());
        } else this.tokens.unshift(token);
    },
    /**
   * When one or more tokens are pushed to a stream, those tokens
   * must be inserted, in given order, after the last token in the
   * stream.
   *
   * @param {(number|!Array.<number>)} token The tokens(s) to prepend to the stream.
   */ push: function(token) {
        if (Array.isArray(token)) {
            var tokens = /**@type {!Array.<number>}*/ token;
            while(tokens.length)this.tokens.push(tokens.shift());
        } else this.tokens.push(token);
    }
};
//
// 4. Encodings
//
// 4.1 Encoders and decoders
/** @const */ var $6eb9fab1eab3180d$var$finished = -1;
/**
 * @param {boolean} fatal If true, decoding errors raise an exception.
 * @param {number=} opt_code_point Override the standard fallback code point.
 * @return {number} The code point to insert on a decoding error.
 */ function $6eb9fab1eab3180d$var$decoderError(fatal, opt_code_point) {
    if (fatal) throw TypeError("Decoder error");
    return opt_code_point || 0xFFFD;
}
//
// 7. API
//
/** @const */ var $6eb9fab1eab3180d$var$DEFAULT_ENCODING = "utf-8";
// 7.1 Interface TextDecoder
/**
 * @constructor
 * @param {string=} encoding The label of the encoding;
 *     defaults to 'utf-8'.
 * @param {Object=} options
 */ function $6eb9fab1eab3180d$var$TextDecoder(encoding, options) {
    if (!(this instanceof $6eb9fab1eab3180d$var$TextDecoder)) return new $6eb9fab1eab3180d$var$TextDecoder(encoding, options);
    encoding = encoding !== undefined ? String(encoding).toLowerCase() : $6eb9fab1eab3180d$var$DEFAULT_ENCODING;
    if (encoding !== $6eb9fab1eab3180d$var$DEFAULT_ENCODING) throw new Error("Encoding not supported. Only utf-8 is supported");
    options = $6eb9fab1eab3180d$var$ToDictionary(options);
    /** @private @type {boolean} */ this._streaming = false;
    /** @private @type {boolean} */ this._BOMseen = false;
    /** @private @type {?Decoder} */ this._decoder = null;
    /** @private @type {boolean} */ this._fatal = Boolean(options["fatal"]);
    /** @private @type {boolean} */ this._ignoreBOM = Boolean(options["ignoreBOM"]);
    Object.defineProperty(this, "encoding", {
        value: "utf-8"
    });
    Object.defineProperty(this, "fatal", {
        value: this._fatal
    });
    Object.defineProperty(this, "ignoreBOM", {
        value: this._ignoreBOM
    });
}
$6eb9fab1eab3180d$var$TextDecoder.prototype = {
    /**
   * @param {ArrayBufferView=} input The buffer of bytes to decode.
   * @param {Object=} options
   * @return {string} The decoded string.
   */ decode: function decode(input, options) {
        var bytes;
        if (typeof input === "object" && input instanceof ArrayBuffer) bytes = new Uint8Array(input);
        else if (typeof input === "object" && "buffer" in input && input.buffer instanceof ArrayBuffer) bytes = new Uint8Array(input.buffer, input.byteOffset, input.byteLength);
        else bytes = new Uint8Array(0);
        options = $6eb9fab1eab3180d$var$ToDictionary(options);
        if (!this._streaming) {
            this._decoder = new $6eb9fab1eab3180d$var$UTF8Decoder({
                fatal: this._fatal
            });
            this._BOMseen = false;
        }
        this._streaming = Boolean(options["stream"]);
        var input_stream = new $6eb9fab1eab3180d$var$Stream(bytes);
        var code_points = [];
        /** @type {?(number|!Array.<number>)} */ var result;
        while(!input_stream.endOfStream()){
            result = this._decoder.handler(input_stream, input_stream.read());
            if (result === $6eb9fab1eab3180d$var$finished) break;
            if (result === null) continue;
            if (Array.isArray(result)) code_points.push.apply(code_points, /**@type {!Array.<number>}*/ result);
            else code_points.push(result);
        }
        if (!this._streaming) {
            do {
                result = this._decoder.handler(input_stream, input_stream.read());
                if (result === $6eb9fab1eab3180d$var$finished) break;
                if (result === null) continue;
                if (Array.isArray(result)) code_points.push.apply(code_points, /**@type {!Array.<number>}*/ result);
                else code_points.push(result);
            }while (!input_stream.endOfStream());
            this._decoder = null;
        }
        if (code_points.length) // If encoding is one of utf-8, utf-16be, and utf-16le, and
        // ignore BOM flag and BOM seen flag are unset, run these
        // subsubsteps:
        {
            if ([
                "utf-8"
            ].indexOf(this.encoding) !== -1 && !this._ignoreBOM && !this._BOMseen) {
                // If token is U+FEFF, set BOM seen flag.
                if (code_points[0] === 0xFEFF) {
                    this._BOMseen = true;
                    code_points.shift();
                } else // Otherwise, if token is not end-of-stream, set BOM seen
                // flag and append token to output.
                this._BOMseen = true;
            }
        }
        return $6eb9fab1eab3180d$var$codePointsToString(code_points);
    }
};
// 7.2 Interface TextEncoder
/**
 * @constructor
 * @param {string=} encoding The label of the encoding;
 *     defaults to 'utf-8'.
 * @param {Object=} options
 */ function $6eb9fab1eab3180d$var$TextEncoder(encoding, options) {
    if (!(this instanceof $6eb9fab1eab3180d$var$TextEncoder)) return new $6eb9fab1eab3180d$var$TextEncoder(encoding, options);
    encoding = encoding !== undefined ? String(encoding).toLowerCase() : $6eb9fab1eab3180d$var$DEFAULT_ENCODING;
    if (encoding !== $6eb9fab1eab3180d$var$DEFAULT_ENCODING) throw new Error("Encoding not supported. Only utf-8 is supported");
    options = $6eb9fab1eab3180d$var$ToDictionary(options);
    /** @private @type {boolean} */ this._streaming = false;
    /** @private @type {?Encoder} */ this._encoder = null;
    /** @private @type {{fatal: boolean}} */ this._options = {
        fatal: Boolean(options["fatal"])
    };
    Object.defineProperty(this, "encoding", {
        value: "utf-8"
    });
}
$6eb9fab1eab3180d$var$TextEncoder.prototype = {
    /**
   * @param {string=} opt_string The string to encode.
   * @param {Object=} options
   * @return {Uint8Array} Encoded bytes, as a Uint8Array.
   */ encode: function encode(opt_string, options) {
        opt_string = opt_string ? String(opt_string) : "";
        options = $6eb9fab1eab3180d$var$ToDictionary(options);
        // NOTE: This option is nonstandard. None of the encodings
        // permitted for encoding (i.e. UTF-8, UTF-16) are stateful,
        // so streaming is not necessary.
        if (!this._streaming) this._encoder = new $6eb9fab1eab3180d$var$UTF8Encoder(this._options);
        this._streaming = Boolean(options["stream"]);
        var bytes = [];
        var input_stream = new $6eb9fab1eab3180d$var$Stream($6eb9fab1eab3180d$var$stringToCodePoints(opt_string));
        /** @type {?(number|!Array.<number>)} */ var result;
        while(!input_stream.endOfStream()){
            result = this._encoder.handler(input_stream, input_stream.read());
            if (result === $6eb9fab1eab3180d$var$finished) break;
            if (Array.isArray(result)) bytes.push.apply(bytes, /**@type {!Array.<number>}*/ result);
            else bytes.push(result);
        }
        if (!this._streaming) {
            while(true){
                result = this._encoder.handler(input_stream, input_stream.read());
                if (result === $6eb9fab1eab3180d$var$finished) break;
                if (Array.isArray(result)) bytes.push.apply(bytes, /**@type {!Array.<number>}*/ result);
                else bytes.push(result);
            }
            this._encoder = null;
        }
        return new Uint8Array(bytes);
    }
};
//
// 8. The encoding
//
// 8.1 utf-8
/**
 * @constructor
 * @implements {Decoder}
 * @param {{fatal: boolean}} options
 */ function $6eb9fab1eab3180d$var$UTF8Decoder(options) {
    var fatal = options.fatal;
    // utf-8's decoder's has an associated utf-8 code point, utf-8
    // bytes seen, and utf-8 bytes needed (all initially 0), a utf-8
    // lower boundary (initially 0x80), and a utf-8 upper boundary
    // (initially 0xBF).
    var /** @type {number} */ utf8_code_point = 0, /** @type {number} */ utf8_bytes_seen = 0, /** @type {number} */ utf8_bytes_needed = 0, /** @type {number} */ utf8_lower_boundary = 0x80, /** @type {number} */ utf8_upper_boundary = 0xBF;
    /**
   * @param {Stream} stream The stream of bytes being decoded.
   * @param {number} bite The next byte read from the stream.
   * @return {?(number|!Array.<number>)} The next code point(s)
   *     decoded, or null if not enough data exists in the input
   *     stream to decode a complete code point.
   */ this.handler = function(stream, bite) {
        // 1. If byte is end-of-stream and utf-8 bytes needed is not 0,
        // set utf-8 bytes needed to 0 and return error.
        if (bite === $6eb9fab1eab3180d$var$end_of_stream && utf8_bytes_needed !== 0) {
            utf8_bytes_needed = 0;
            return $6eb9fab1eab3180d$var$decoderError(fatal);
        }
        // 2. If byte is end-of-stream, return finished.
        if (bite === $6eb9fab1eab3180d$var$end_of_stream) return $6eb9fab1eab3180d$var$finished;
        // 3. If utf-8 bytes needed is 0, based on byte:
        if (utf8_bytes_needed === 0) {
            // 0x00 to 0x7F
            if ($6eb9fab1eab3180d$var$inRange(bite, 0x00, 0x7F)) // Return a code point whose value is byte.
            return bite;
            // 0xC2 to 0xDF
            if ($6eb9fab1eab3180d$var$inRange(bite, 0xC2, 0xDF)) {
                // Set utf-8 bytes needed to 1 and utf-8 code point to byte
                // − 0xC0.
                utf8_bytes_needed = 1;
                utf8_code_point = bite - 0xC0;
            } else if ($6eb9fab1eab3180d$var$inRange(bite, 0xE0, 0xEF)) {
                // 1. If byte is 0xE0, set utf-8 lower boundary to 0xA0.
                if (bite === 0xE0) utf8_lower_boundary = 0xA0;
                // 2. If byte is 0xED, set utf-8 upper boundary to 0x9F.
                if (bite === 0xED) utf8_upper_boundary = 0x9F;
                // 3. Set utf-8 bytes needed to 2 and utf-8 code point to
                // byte − 0xE0.
                utf8_bytes_needed = 2;
                utf8_code_point = bite - 0xE0;
            } else if ($6eb9fab1eab3180d$var$inRange(bite, 0xF0, 0xF4)) {
                // 1. If byte is 0xF0, set utf-8 lower boundary to 0x90.
                if (bite === 0xF0) utf8_lower_boundary = 0x90;
                // 2. If byte is 0xF4, set utf-8 upper boundary to 0x8F.
                if (bite === 0xF4) utf8_upper_boundary = 0x8F;
                // 3. Set utf-8 bytes needed to 3 and utf-8 code point to
                // byte − 0xF0.
                utf8_bytes_needed = 3;
                utf8_code_point = bite - 0xF0;
            } else // Return error.
            return $6eb9fab1eab3180d$var$decoderError(fatal);
            // Then (byte is in the range 0xC2 to 0xF4) set utf-8 code
            // point to utf-8 code point << (6 × utf-8 bytes needed) and
            // return continue.
            utf8_code_point = utf8_code_point << 6 * utf8_bytes_needed;
            return null;
        }
        // 4. If byte is not in the range utf-8 lower boundary to utf-8
        // upper boundary, run these substeps:
        if (!$6eb9fab1eab3180d$var$inRange(bite, utf8_lower_boundary, utf8_upper_boundary)) {
            // 1. Set utf-8 code point, utf-8 bytes needed, and utf-8
            // bytes seen to 0, set utf-8 lower boundary to 0x80, and set
            // utf-8 upper boundary to 0xBF.
            utf8_code_point = utf8_bytes_needed = utf8_bytes_seen = 0;
            utf8_lower_boundary = 0x80;
            utf8_upper_boundary = 0xBF;
            // 2. Prepend byte to stream.
            stream.prepend(bite);
            // 3. Return error.
            return $6eb9fab1eab3180d$var$decoderError(fatal);
        }
        // 5. Set utf-8 lower boundary to 0x80 and utf-8 upper boundary
        // to 0xBF.
        utf8_lower_boundary = 0x80;
        utf8_upper_boundary = 0xBF;
        // 6. Increase utf-8 bytes seen by one and set utf-8 code point
        // to utf-8 code point + (byte − 0x80) << (6 × (utf-8 bytes
        // needed − utf-8 bytes seen)).
        utf8_bytes_seen += 1;
        utf8_code_point += bite - 0x80 << 6 * (utf8_bytes_needed - utf8_bytes_seen);
        // 7. If utf-8 bytes seen is not equal to utf-8 bytes needed,
        // continue.
        if (utf8_bytes_seen !== utf8_bytes_needed) return null;
        // 8. Let code point be utf-8 code point.
        var code_point = utf8_code_point;
        // 9. Set utf-8 code point, utf-8 bytes needed, and utf-8 bytes
        // seen to 0.
        utf8_code_point = utf8_bytes_needed = utf8_bytes_seen = 0;
        // 10. Return a code point whose value is code point.
        return code_point;
    };
}
/**
 * @constructor
 * @implements {Encoder}
 * @param {{fatal: boolean}} options
 */ function $6eb9fab1eab3180d$var$UTF8Encoder(options) {
    var fatal = options.fatal;
    /**
   * @param {Stream} stream Input stream.
   * @param {number} code_point Next code point read from the stream.
   * @return {(number|!Array.<number>)} Byte(s) to emit.
   */ this.handler = function(stream, code_point) {
        // 1. If code point is end-of-stream, return finished.
        if (code_point === $6eb9fab1eab3180d$var$end_of_stream) return $6eb9fab1eab3180d$var$finished;
        // 2. If code point is in the range U+0000 to U+007F, return a
        // byte whose value is code point.
        if ($6eb9fab1eab3180d$var$inRange(code_point, 0x0000, 0x007f)) return code_point;
        // 3. Set count and offset based on the range code point is in:
        var count, offset;
        // U+0080 to U+07FF:    1 and 0xC0
        if ($6eb9fab1eab3180d$var$inRange(code_point, 0x0080, 0x07FF)) {
            count = 1;
            offset = 0xC0;
        } else if ($6eb9fab1eab3180d$var$inRange(code_point, 0x0800, 0xFFFF)) {
            count = 2;
            offset = 0xE0;
        } else if ($6eb9fab1eab3180d$var$inRange(code_point, 0x10000, 0x10FFFF)) {
            count = 3;
            offset = 0xF0;
        }
        // 4.Let bytes be a byte sequence whose first byte is (code
        // point >> (6 × count)) + offset.
        var bytes = [
            (code_point >> 6 * count) + offset
        ];
        // 5. Run these substeps while count is greater than 0:
        while(count > 0){
            // 1. Set temp to code point >> (6 × (count − 1)).
            var temp = code_point >> 6 * (count - 1);
            // 2. Append to bytes 0x80 | (temp & 0x3F).
            bytes.push(0x80 | temp & 0x3F);
            // 3. Decrease count by one.
            count -= 1;
        }
        // 6. Return bytes bytes, in order.
        return bytes;
    };
}
$6eb9fab1eab3180d$export$88fb0cfd153261a7 = $6eb9fab1eab3180d$var$TextEncoder;
$6eb9fab1eab3180d$export$9c6b53e35bc51b5c = $6eb9fab1eab3180d$var$TextDecoder;

});

parcelRequire.register("iETYi", function(module, exports) {
// TODO(Babel 8): Remove this file.

var $d957612f7fca831b$var$runtime = (parcelRequire("6n0Eo"))();
module.exports = $d957612f7fca831b$var$runtime;
// Copied from https://github.com/facebook/regenerator/blob/main/packages/runtime/runtime.js#L736=
try {
    regeneratorRuntime = $d957612f7fca831b$var$runtime;
} catch (accidentalStrictMode) {
    if (typeof globalThis === "object") globalThis.regeneratorRuntime = $d957612f7fca831b$var$runtime;
    else Function("r", "regeneratorRuntime = r")($d957612f7fca831b$var$runtime);
}

});
parcelRequire.register("6n0Eo", function(module, exports) {

var $5m0al = parcelRequire("5m0al");
var $4a35654061170353$var$_typeof = $5m0al.default;
function $4a35654061170353$var$_regeneratorRuntime() {
    "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ 
    module.exports = $4a35654061170353$var$_regeneratorRuntime = function _regeneratorRuntime() {
        return e;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports;
    var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function(t, e, r) {
        t[e] = r.value;
    }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag";
    function define(t, e, r) {
        return Object.defineProperty(t, e, {
            value: r,
            enumerable: !0,
            configurable: !0,
            writable: !0
        }), t[e];
    }
    try {
        define({}, "");
    } catch (t) {
        define = function define(t, e, r) {
            return t[e] = r;
        };
    }
    function wrap(t, e, r, n) {
        var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []);
        return o(a, "_invoke", {
            value: makeInvokeMethod(t, r, c)
        }), a;
    }
    function tryCatch(t, e, r) {
        try {
            return {
                type: "normal",
                arg: t.call(e, r)
            };
        } catch (t) {
            return {
                type: "throw",
                arg: t
            };
        }
    }
    e.wrap = wrap;
    var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {};
    function Generator() {}
    function GeneratorFunction() {}
    function GeneratorFunctionPrototype() {}
    var p = {};
    define(p, a, function() {
        return this;
    });
    var d = Object.getPrototypeOf, v = d && d(d(values([])));
    v && v !== r && n.call(v, a) && (p = v);
    var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p);
    function defineIteratorMethods(t) {
        [
            "next",
            "throw",
            "return"
        ].forEach(function(e) {
            define(t, e, function(t) {
                return this._invoke(e, t);
            });
        });
    }
    function AsyncIterator(t, e) {
        function invoke(r, o, i, a) {
            var c = tryCatch(t[r], t, o);
            if ("throw" !== c.type) {
                var u = c.arg, h = u.value;
                return h && "object" == $4a35654061170353$var$_typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function(t) {
                    invoke("next", t, i, a);
                }, function(t) {
                    invoke("throw", t, i, a);
                }) : e.resolve(h).then(function(t) {
                    u.value = t, i(u);
                }, function(t) {
                    return invoke("throw", t, i, a);
                });
            }
            a(c.arg);
        }
        var r;
        o(this, "_invoke", {
            value: function value(t, n) {
                function callInvokeWithMethodAndArg() {
                    return new e(function(e, r) {
                        invoke(t, n, e, r);
                    });
                }
                return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
            }
        });
    }
    function makeInvokeMethod(e, r, n) {
        var o = h;
        return function(i, a) {
            if (o === f) throw new Error("Generator is already running");
            if (o === s) {
                if ("throw" === i) throw a;
                return {
                    value: t,
                    done: !0
                };
            }
            for(n.method = i, n.arg = a;;){
                var c = n.delegate;
                if (c) {
                    var u = maybeInvokeDelegate(c, n);
                    if (u) {
                        if (u === y) continue;
                        return u;
                    }
                }
                if ("next" === n.method) n.sent = n._sent = n.arg;
                else if ("throw" === n.method) {
                    if (o === h) throw o = s, n.arg;
                    n.dispatchException(n.arg);
                } else "return" === n.method && n.abrupt("return", n.arg);
                o = f;
                var p = tryCatch(e, r, n);
                if ("normal" === p.type) {
                    if (o = n.done ? s : l, p.arg === y) continue;
                    return {
                        value: p.arg,
                        done: n.done
                    };
                }
                "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg);
            }
        };
    }
    function maybeInvokeDelegate(e, r) {
        var n = r.method, o = e.iterator[n];
        if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y;
        var i = tryCatch(o, e.iterator, r.arg);
        if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y;
        var a = i.arg;
        return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y);
    }
    function pushTryEntry(t) {
        var e = {
            tryLoc: t[0]
        };
        1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e);
    }
    function resetTryEntry(t) {
        var e = t.completion || {};
        e.type = "normal", delete e.arg, t.completion = e;
    }
    function Context(t) {
        this.tryEntries = [
            {
                tryLoc: "root"
            }
        ], t.forEach(pushTryEntry, this), this.reset(!0);
    }
    function values(e) {
        if (e || "" === e) {
            var r = e[a];
            if (r) return r.call(e);
            if ("function" == typeof e.next) return e;
            if (!isNaN(e.length)) {
                var o = -1, i = function next() {
                    for(; ++o < e.length;)if (n.call(e, o)) return next.value = e[o], next.done = !1, next;
                    return next.value = t, next.done = !0, next;
                };
                return i.next = i;
            }
        }
        throw new TypeError($4a35654061170353$var$_typeof(e) + " is not iterable");
    }
    return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", {
        value: GeneratorFunctionPrototype,
        configurable: !0
    }), o(GeneratorFunctionPrototype, "constructor", {
        value: GeneratorFunction,
        configurable: !0
    }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function(t) {
        var e = "function" == typeof t && t.constructor;
        return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name));
    }, e.mark = function(t) {
        return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t;
    }, e.awrap = function(t) {
        return {
            __await: t
        };
    }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function() {
        return this;
    }), e.AsyncIterator = AsyncIterator, e.async = function(t, r, n, o, i) {
        void 0 === i && (i = Promise);
        var a = new AsyncIterator(wrap(t, r, n, o), i);
        return e.isGeneratorFunction(r) ? a : a.next().then(function(t) {
            return t.done ? t.value : a.next();
        });
    }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function() {
        return this;
    }), define(g, "toString", function() {
        return "[object Generator]";
    }), e.keys = function(t) {
        var e = Object(t), r = [];
        for(var n in e)r.push(n);
        return r.reverse(), function next() {
            for(; r.length;){
                var t = r.pop();
                if (t in e) return next.value = t, next.done = !1, next;
            }
            return next.done = !0, next;
        };
    }, e.values = values, Context.prototype = {
        constructor: Context,
        reset: function reset(e) {
            if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for(var r in this)"t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t);
        },
        stop: function stop() {
            this.done = !0;
            var t = this.tryEntries[0].completion;
            if ("throw" === t.type) throw t.arg;
            return this.rval;
        },
        dispatchException: function dispatchException(e) {
            if (this.done) throw e;
            var r = this;
            function handle(n, o) {
                return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o;
            }
            for(var o = this.tryEntries.length - 1; o >= 0; --o){
                var i = this.tryEntries[o], a = i.completion;
                if ("root" === i.tryLoc) return handle("end");
                if (i.tryLoc <= this.prev) {
                    var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc");
                    if (c && u) {
                        if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
                        if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
                    } else if (c) {
                        if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
                    } else {
                        if (!u) throw new Error("try statement without catch or finally");
                        if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
                    }
                }
            }
        },
        abrupt: function abrupt(t, e) {
            for(var r = this.tryEntries.length - 1; r >= 0; --r){
                var o = this.tryEntries[r];
                if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) {
                    var i = o;
                    break;
                }
            }
            i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null);
            var a = i ? i.completion : {};
            return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a);
        },
        complete: function complete(t, e) {
            if ("throw" === t.type) throw t.arg;
            return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y;
        },
        finish: function finish(t) {
            for(var e = this.tryEntries.length - 1; e >= 0; --e){
                var r = this.tryEntries[e];
                if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y;
            }
        },
        "catch": function _catch(t) {
            for(var e = this.tryEntries.length - 1; e >= 0; --e){
                var r = this.tryEntries[e];
                if (r.tryLoc === t) {
                    var n = r.completion;
                    if ("throw" === n.type) {
                        var o = n.arg;
                        resetTryEntry(r);
                    }
                    return o;
                }
            }
            throw new Error("illegal catch attempt");
        },
        delegateYield: function delegateYield(e, r, n) {
            return this.delegate = {
                iterator: values(e),
                resultName: r,
                nextLoc: n
            }, "next" === this.method && (this.arg = t), y;
        }
    }, e;
}
module.exports = $4a35654061170353$var$_regeneratorRuntime, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRequire.register("5m0al", function(module, exports) {
function $3e5f22c8baa8173c$var$_typeof(o) {
    "@babel/helpers - typeof";
    return module.exports = $3e5f22c8baa8173c$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, $3e5f22c8baa8173c$var$_typeof(o);
}
module.exports = $3e5f22c8baa8173c$var$_typeof, module.exports.__esModule = true, module.exports["default"] = module.exports;

});



parcelRequire.register("fxszz", function(module, exports) {
function $b5001a03c054fb6d$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) resolve(value);
    else Promise.resolve(value).then(_next, _throw);
}
function $b5001a03c054fb6d$var$_asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                $b5001a03c054fb6d$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                $b5001a03c054fb6d$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
module.exports = $b5001a03c054fb6d$var$_asyncToGenerator, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRequire.register("96Ltc", function(module, exports) {
function $6a197f20cf893217$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
module.exports = $6a197f20cf893217$var$_classCallCheck, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRequire.register("8LpR2", function(module, exports) {

var $2KB5b = parcelRequire("2KB5b");
function $6616c4af4b94608b$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $2KB5b(descriptor.key), descriptor);
    }
}
function $6616c4af4b94608b$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $6616c4af4b94608b$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $6616c4af4b94608b$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
module.exports = $6616c4af4b94608b$var$_createClass, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRequire.register("2KB5b", function(module, exports) {

var $5m0al = parcelRequire("5m0al");
var $200ca474d61fb69f$var$_typeof = $5m0al.default;

var $cQqCP = parcelRequire("cQqCP");
function $200ca474d61fb69f$var$toPropertyKey(t) {
    var i = $cQqCP(t, "string");
    return "symbol" == $200ca474d61fb69f$var$_typeof(i) ? i : String(i);
}
module.exports = $200ca474d61fb69f$var$toPropertyKey, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRequire.register("cQqCP", function(module, exports) {

var $5m0al = parcelRequire("5m0al");
var $959efe92a2ba6a20$var$_typeof = $5m0al.default;
function $959efe92a2ba6a20$var$toPrimitive(t, r) {
    if ("object" != $959efe92a2ba6a20$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $959efe92a2ba6a20$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
module.exports = $959efe92a2ba6a20$var$toPrimitive, module.exports.__esModule = true, module.exports["default"] = module.exports;

});



parcelRequire.register("9f5Dq", function(module, exports) {

var $k4iGj = parcelRequire("k4iGj");
function $6ba9e2bdb388138a$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $k4iGj(subClass, superClass);
}
module.exports = $6ba9e2bdb388138a$var$_inherits, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRequire.register("k4iGj", function(module, exports) {
function $e9c2ac1c435b9d1a$var$_setPrototypeOf(o, p) {
    module.exports = $e9c2ac1c435b9d1a$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports;
    return $e9c2ac1c435b9d1a$var$_setPrototypeOf(o, p);
}
module.exports = $e9c2ac1c435b9d1a$var$_setPrototypeOf, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRequire.register("iPNqH", function(module, exports) {

var $5m0al = parcelRequire("5m0al");
var $db6355207c04507c$var$_typeof = $5m0al.default;

var $iyKoC = parcelRequire("iyKoC");
function $db6355207c04507c$var$_possibleConstructorReturn(self, call) {
    if (call && ($db6355207c04507c$var$_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $iyKoC(self);
}
module.exports = $db6355207c04507c$var$_possibleConstructorReturn, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRequire.register("iyKoC", function(module, exports) {
function $d82f6440862d079b$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
module.exports = $d82f6440862d079b$var$_assertThisInitialized, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRequire.register("iAciy", function(module, exports) {
function $d87520f2b1a92221$var$_getPrototypeOf(o) {
    module.exports = $d87520f2b1a92221$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    }, module.exports.__esModule = true, module.exports["default"] = module.exports;
    return $d87520f2b1a92221$var$_getPrototypeOf(o);
}
module.exports = $d87520f2b1a92221$var$_getPrototypeOf, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRequire.register("8TKuU", function(module, exports) {

var $dnnhb = parcelRequire("dnnhb");

var $lAPp0 = parcelRequire("lAPp0");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Built-in value references. */ var Buffer = moduleExports ? $dnnhb.Buffer : undefined;
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;
/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */ var isBuffer = nativeIsBuffer || $lAPp0;
module.exports = isBuffer;

});
parcelRequire.register("dnnhb", function(module, exports) {

var $8vz42 = parcelRequire("8vz42");
/** Detect free variable `self`. */ var $9bcf7a804d00ded1$var$freeSelf = typeof self == "object" && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var $9bcf7a804d00ded1$var$root = $8vz42 || $9bcf7a804d00ded1$var$freeSelf || Function("return this")();
module.exports = $9bcf7a804d00ded1$var$root;

});
parcelRequire.register("8vz42", function(module, exports) {
/** Detect free variable `global` from Node.js. */ var $631c6b00c6701f20$var$freeGlobal = typeof $parcel$global == "object" && $parcel$global && $parcel$global.Object === Object && $parcel$global;
module.exports = $631c6b00c6701f20$var$freeGlobal;

});


parcelRequire.register("lAPp0", function(module, exports) {
/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */ function $fb84d52c0f9b5c17$var$stubFalse() {
    return false;
}
module.exports = $fb84d52c0f9b5c17$var$stubFalse;

});


parcelRequire.register("1mm29", function(module, exports) {

var $8vz42 = parcelRequire("8vz42");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Detect free variable `process` from Node.js. */ var freeProcess = moduleExports && $8vz42.process;
/** Used to access faster Node.js helpers. */ var nodeUtil = function() {
    try {
        // Use `util.types` for Node.js 10+.
        var types = freeModule && freeModule.require && freeModule.require("util").types;
        if (types) return types;
        // Legacy `process.binding('util')` for Node.js < 10.
        return freeProcess && freeProcess.binding && freeProcess.binding("util");
    } catch (e) {}
}();
module.exports = nodeUtil;

});

parcelRequire.register("1JdxE", function(module, exports) {

var $dnnhb = parcelRequire("dnnhb");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Built-in value references. */ var Buffer = moduleExports ? $dnnhb.Buffer : undefined, allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined;
/**
 * Creates a clone of  `buffer`.
 *
 * @private
 * @param {Buffer} buffer The buffer to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Buffer} Returns the cloned buffer.
 */ function cloneBuffer(buffer, isDeep) {
    if (isDeep) return buffer.slice();
    var length = buffer.length, result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
    buffer.copy(result);
    return result;
}
module.exports = cloneBuffer;

});

parcelRequire.register("2tbKl", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";

var $c3YnH = parcelRequire("c3YnH");
function $1cc766ccf0672393$var$emptyFunction() {}
function $1cc766ccf0672393$var$emptyFunctionWithReset() {}
$1cc766ccf0672393$var$emptyFunctionWithReset.resetWarningCache = $1cc766ccf0672393$var$emptyFunction;
module.exports = function() {
    function shim(props, propName, componentName, location, propFullName, secret) {
        if (secret === $c3YnH) // It is still safe when called from React.
        return;
        var err = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
        err.name = "Invariant Violation";
        throw err;
    }
    shim.isRequired = shim;
    function getShim() {
        return shim;
    }
    // Important!
    // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
    var ReactPropTypes = {
        array: shim,
        bigint: shim,
        bool: shim,
        func: shim,
        number: shim,
        object: shim,
        string: shim,
        symbol: shim,
        any: shim,
        arrayOf: getShim,
        element: shim,
        elementType: shim,
        instanceOf: getShim,
        node: shim,
        objectOf: getShim,
        oneOf: getShim,
        oneOfType: getShim,
        shape: getShim,
        exact: getShim,
        checkPropTypes: $1cc766ccf0672393$var$emptyFunctionWithReset,
        resetWarningCache: $1cc766ccf0672393$var$emptyFunction
    };
    ReactPropTypes.PropTypes = ReactPropTypes;
    return ReactPropTypes;
};

});
parcelRequire.register("c3YnH", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
var $8c849a51633fc8b0$var$ReactPropTypesSecret = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
module.exports = $8c849a51633fc8b0$var$ReactPropTypesSecret;

});


parcelRequire.register("bcoTo", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $021aa5aca9b47e9e$export$2e2bcd8739ae039; });

var $6AhZS = parcelRequire("6AhZS");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Built-in value references. */ var Buffer = moduleExports ? (0, $6AhZS.default).Buffer : undefined, allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined;
/**
 * Creates a clone of  `buffer`.
 *
 * @private
 * @param {Buffer} buffer The buffer to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Buffer} Returns the cloned buffer.
 */ function cloneBuffer(buffer, isDeep) {
    if (isDeep) return buffer.slice();
    var length = buffer.length, result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
    buffer.copy(result);
    return result;
}
var $021aa5aca9b47e9e$export$2e2bcd8739ae039 = cloneBuffer;

});
parcelRequire.register("6AhZS", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4cb410b494b5bfba$export$2e2bcd8739ae039; });

var $g6iKt = parcelRequire("g6iKt");
/** Detect free variable `self`. */ var $4cb410b494b5bfba$var$freeSelf = typeof self == "object" && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var $4cb410b494b5bfba$var$root = (0, $g6iKt.default) || $4cb410b494b5bfba$var$freeSelf || Function("return this")();
var $4cb410b494b5bfba$export$2e2bcd8739ae039 = $4cb410b494b5bfba$var$root;

});
parcelRequire.register("g6iKt", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $bb8bbff47a3b420b$export$2e2bcd8739ae039; });
/** Detect free variable `global` from Node.js. */ var $bb8bbff47a3b420b$var$freeGlobal = typeof $parcel$global == "object" && $parcel$global && $parcel$global.Object === Object && $parcel$global;
var $bb8bbff47a3b420b$export$2e2bcd8739ae039 = $bb8bbff47a3b420b$var$freeGlobal;

});



parcelRequire.register("h0k3u", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c611fe4b92607a0d$export$2e2bcd8739ae039; });

var $6AhZS = parcelRequire("6AhZS");

var $86exc = parcelRequire("86exc");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Built-in value references. */ var Buffer = moduleExports ? (0, $6AhZS.default).Buffer : undefined;
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;
/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */ var isBuffer = nativeIsBuffer || (0, $86exc.default);
var $c611fe4b92607a0d$export$2e2bcd8739ae039 = isBuffer;

});
parcelRequire.register("86exc", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5e5a287dab114ff7$export$2e2bcd8739ae039; });
/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */ function $5e5a287dab114ff7$var$stubFalse() {
    return false;
}
var $5e5a287dab114ff7$export$2e2bcd8739ae039 = $5e5a287dab114ff7$var$stubFalse;

});


parcelRequire.register("gLfdj", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c33cd6441f500087$export$2e2bcd8739ae039; });

var $g6iKt = parcelRequire("g6iKt");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Detect free variable `process` from Node.js. */ var freeProcess = moduleExports && (0, $g6iKt.default).process;
/** Used to access faster Node.js helpers. */ var nodeUtil = function() {
    try {
        // Use `util.types` for Node.js 10+.
        var types = freeModule && freeModule.require && freeModule.require("util").types;
        if (types) return types;
        // Legacy `process.binding('util')` for Node.js < 10.
        return freeProcess && freeProcess.binding && freeProcess.binding("util");
    } catch (e) {}
}();
var $c33cd6441f500087$export$2e2bcd8739ae039 = nodeUtil;

});

var $d4dab640dcbe486c$exports = {};
"use strict";

$d4dab640dcbe486c$exports = (parcelRequire("0qhf8"));



var $bh6RR = parcelRequire("bh6RR");
var $47cfd4084854a574$exports = {};
"use strict";
function $47cfd4084854a574$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === "undefined" || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== "function") return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($47cfd4084854a574$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$47cfd4084854a574$var$checkDCE();

$47cfd4084854a574$exports = (parcelRequire("foRq4"));





var $bh6RR = parcelRequire("bh6RR");

var $ff1daf8f4a7e77e9$exports = {};
$parcel$export($ff1daf8f4a7e77e9$exports, "isEvmBlockchain", function () { return $94f51709582f134d$export$9d749b8b357dfab2; });
$parcel$export($ff1daf8f4a7e77e9$exports, "isEvmBlockchain", function () { return $ed2da9cee517980c$exports.isEvmBlockchain; });












/**
 * Routing Result Type
 *
 */ var $82fccfe07efc21a4$export$9244fb3192b4c649;
(function(RoutingResultType) {
    RoutingResultType["OK"] = "OK";
    RoutingResultType["HIGH_IMPACT"] = "HIGH_IMPACT";
    RoutingResultType["NO_ROUTE"] = "NO_ROUTE";
    RoutingResultType["INPUT_LIMIT_ISSUE"] = "INPUT_LIMIT_ISSUE";
})($82fccfe07efc21a4$export$9244fb3192b4c649 || ($82fccfe07efc21a4$export$9244fb3192b4c649 = {}));


/**
 * The type of transaction
 */ var $31da5b085b713a2f$export$d513b00599f845d4;
(function(TransactionType) {
    TransactionType["EVM"] = "EVM";
    TransactionType["TRANSFER"] = "TRANSFER";
    TransactionType["COSMOS"] = "COSMOS";
    TransactionType["SOLANA"] = "SOLANA";
    TransactionType["TRON"] = "TRON";
    TransactionType["STARKNET"] = "STARKNET";
    TransactionType["TON"] = "TON";
})($31da5b085b713a2f$export$d513b00599f845d4 || ($31da5b085b713a2f$export$d513b00599f845d4 = {}));
var $31da5b085b713a2f$export$d5c0ec10a1bea971;
(function(GenericTransactionType) {
    GenericTransactionType["EVM"] = "EVM";
    GenericTransactionType["TRANSFER"] = "TRANSFER";
    GenericTransactionType["COSMOS"] = "COSMOS";
    GenericTransactionType["SOLANA"] = "SOLANA";
})($31da5b085b713a2f$export$d5c0ec10a1bea971 || ($31da5b085b713a2f$export$d5c0ec10a1bea971 = {}));
function $31da5b085b713a2f$export$882b4f79e45cc211(value) {
    return [
        "TX_FAIL",
        "TX_EXPIRED",
        "FETCH_TX_FAILED",
        "USER_REJECT",
        "USER_CANCEL",
        "USER_CANCELED_TX",
        "CALL_WALLET_FAILED",
        "SEND_TX_FAILED",
        "CALL_OR_SEND_FAILED",
        "TX_FAILED_IN_BLOCKCHAIN",
        "CLIENT_UNEXPECTED_BEHAVIOUR",
        "INSUFFICIENT_APPROVE"
    ].includes(value);
}
var $31da5b085b713a2f$export$7c391bd3b61d2374;
(function(TransactionStatus) {
    TransactionStatus["FAILED"] = "failed";
    TransactionStatus["RUNNING"] = "running";
    TransactionStatus["SUCCESS"] = "success";
})($31da5b085b713a2f$export$7c391bd3b61d2374 || ($31da5b085b713a2f$export$7c391bd3b61d2374 = {}));





var $55dca55f466537b8$export$16073528a91c8d2a = function(transaction) {
    return transaction.type === (0, $31da5b085b713a2f$export$d513b00599f845d4).COSMOS;
};



var $2bc46bf5a9b82c4a$export$b1818bc93202fd47 = function(transaction) {
    return transaction.type === (0, $31da5b085b713a2f$export$d513b00599f845d4).SOLANA;
};



var $b95611aa8f25fa5d$export$a6e014f972e5c64c = function(transaction) {
    return transaction.type === (0, $31da5b085b713a2f$export$d513b00599f845d4).TRANSFER;
};



var $fe464f2e46069486$export$fd5286d9851f07f6 = function(transaction) {
    return transaction.type === (0, $31da5b085b713a2f$export$d513b00599f845d4).STARKNET;
};



var $ad3f8bfab7bcf332$export$9fd5291d9179852a = function(transaction) {
    return transaction.type === (0, $31da5b085b713a2f$export$d513b00599f845d4).TRON;
};



var $05133e880b78612d$export$6ef804aee1395a14;
(function(TonChainID) {
    TonChainID["MAINNET"] = "-239";
    TonChainID["TESTNET"] = "-3";
})($05133e880b78612d$export$6ef804aee1395a14 || ($05133e880b78612d$export$6ef804aee1395a14 = {}));
var $05133e880b78612d$export$232916af2d90d322 = function(transaction) {
    return transaction.type === (0, $31da5b085b713a2f$export$d513b00599f845d4).TON;
};




var $94f51709582f134d$export$9d749b8b357dfab2 = function(blockchainMeta) {
    return blockchainMeta.type === "EVM";
};
var $94f51709582f134d$export$d917e9e8a70036a6 = function(blockchainMeta) {
    return blockchainMeta.type === "COSMOS";
};
var $94f51709582f134d$export$ff5a0a65a8982bf2 = function(blockchainMeta) {
    return blockchainMeta.type === "SOLANA";
};
var $94f51709582f134d$export$744fa0907a94ca40 = function(blockchainMeta) {
    return blockchainMeta.type === "TRON";
};
var $94f51709582f134d$export$83b5ebc3a9031095 = function(blockchainMeta) {
    return blockchainMeta.type === "TRANSFER";
};
var $94f51709582f134d$export$80db8fd9e7a31db2 = function(blockchainMeta) {
    return blockchainMeta.type === "STARKNET";
};
var $94f51709582f134d$export$9500a92ad5d775aa = function(blockchainMeta) {
    return blockchainMeta.type === "TON";
};
var $94f51709582f134d$export$e2a694e57950e88e = function(blockchains) {
    return blockchains.filter($94f51709582f134d$export$9d749b8b357dfab2);
};
var $94f51709582f134d$export$11a35c42f4dd4832 = function(blockchains) {
    return blockchains.filter($94f51709582f134d$export$ff5a0a65a8982bf2);
};
var $94f51709582f134d$export$e1f5443c7a926d0f = function(blockchains) {
    return blockchains.filter($94f51709582f134d$export$80db8fd9e7a31db2);
};
var $94f51709582f134d$export$61a2144ef91f3622 = function(blockchains) {
    return blockchains.filter($94f51709582f134d$export$744fa0907a94ca40);
};
var $94f51709582f134d$export$7a136f0d6bb0d722 = function(blockchains) {
    return blockchains.filter($94f51709582f134d$export$d917e9e8a70036a6);
};
var $94f51709582f134d$export$80dff8c560b1e7ce = function(blockchains) {
    return blockchains.filter($94f51709582f134d$export$83b5ebc3a9031095);
};
var $94f51709582f134d$export$e38bf62be0c23ec5 = function(blockchains) {
    return blockchains.filter($94f51709582f134d$export$9500a92ad5d775aa);
};










var $f04262b88745246c$export$b9109202fe95a066 = function(transaction) {
    return transaction.type === (0, $31da5b085b713a2f$export$d513b00599f845d4).EVM;
};





































var $d7d4bf8dbb813ef7$export$b9109202fe95a066 = function(transaction) {
    return transaction.type === (0, $31da5b085b713a2f$export$d513b00599f845d4).EVM;
};













var $ed2da9cee517980c$exports = {};
var $ed2da9cee517980c$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $ed2da9cee517980c$export$1105a941ceaa4b25;
(function(SignerErrorCode) {
    SignerErrorCode["REJECTED_BY_USER"] = "REJECTED_BY_USER";
    SignerErrorCode["SIGN_TX_ERROR"] = "SIGN_TX_ERROR";
    SignerErrorCode["SEND_TX_ERROR"] = "SEND_TX_ERROR";
    SignerErrorCode["TX_FAILED_IN_BLOCKCHAIN"] = "TX_FAILED_IN_BLOCKCHAIN";
    SignerErrorCode["OPERATION_UNSUPPORTED"] = "OPERATION_UNSUPPORTED";
    SignerErrorCode["UNEXPECTED_BEHAVIOUR"] = "UNEXPECTED_BEHAVIOUR";
    SignerErrorCode["NOT_IMPLEMENTED"] = "NOT_IMPLEMENTED";
})($ed2da9cee517980c$export$1105a941ceaa4b25 || ($ed2da9cee517980c$export$1105a941ceaa4b25 = {}));
var $ed2da9cee517980c$export$618932a85b762ea3;
(function(RPCErrorCode) {
    RPCErrorCode["REJECTION"] = "REJECTION";
    RPCErrorCode["UNDER_PRICED"] = "UNDER_PRICED";
    RPCErrorCode["OUT_OF_GAS"] = "OUT_OF_GAS";
    RPCErrorCode["CALL_EXCEPTION"] = "CALL_EXCEPTION";
    RPCErrorCode["INSUFFICIENT_FUNDS"] = "INSUFFICIENT_FUNDS";
    RPCErrorCode["INTERNAL"] = "INTERNAL";
    RPCErrorCode["SLIPPAGE"] = "SLIPPAGE";
    RPCErrorCode["UNKNOWN_ERROR"] = "UNKNOWN";
})($ed2da9cee517980c$export$618932a85b762ea3 || ($ed2da9cee517980c$export$618932a85b762ea3 = {}));
function $ed2da9cee517980c$export$be10b575629ad8f(value) {
    return Object.keys($ed2da9cee517980c$export$1105a941ceaa4b25).includes(value);
}
function $ed2da9cee517980c$export$714f3eb4b9ca37c5(code) {
    var _a;
    var errorMap = (_a = {}, _a[$ed2da9cee517980c$export$1105a941ceaa4b25.REJECTED_BY_USER] = "User rejected the transaction", _a[$ed2da9cee517980c$export$1105a941ceaa4b25.SIGN_TX_ERROR] = "Error signing the transaction", _a[$ed2da9cee517980c$export$1105a941ceaa4b25.SEND_TX_ERROR] = "Error sending the transaction", _a[$ed2da9cee517980c$export$1105a941ceaa4b25.NOT_IMPLEMENTED] = "Operation not implemented", _a[$ed2da9cee517980c$export$1105a941ceaa4b25.OPERATION_UNSUPPORTED] = "Unsupported operation", _a[$ed2da9cee517980c$export$1105a941ceaa4b25.TX_FAILED_IN_BLOCKCHAIN] = "Transaction failed in blockchain", _a[$ed2da9cee517980c$export$1105a941ceaa4b25.UNEXPECTED_BEHAVIOUR] = "Unexpected error", _a);
    return errorMap[code];
}
var $ed2da9cee517980c$export$7cc7da8fa05ccee8 = /** @class */ function(_super) {
    $ed2da9cee517980c$var$__extends(SignerError, _super);
    function SignerError(code, m, root, rpcCode, trace) {
        var _this = _super.call(this, m || $ed2da9cee517980c$export$714f3eb4b9ca37c5(code)) || this;
        _this._isSignerError = true;
        Object.setPrototypeOf(_this, SignerError.prototype);
        SignerError.prototype._isSignerError = true;
        _this.code = code;
        _this.root = root;
        _this.rpcCode = rpcCode;
        _this.trace = trace;
        if (_this.code === $ed2da9cee517980c$export$1105a941ceaa4b25.REJECTED_BY_USER || SignerError.isRejectedError(root)) {
            _this.code = $ed2da9cee517980c$export$1105a941ceaa4b25.REJECTED_BY_USER;
            _this.message = "User rejected the transaction";
            _this.root = undefined;
        }
        return _this;
    }
    SignerError.isSignerError = function(obj) {
        return obj instanceof SignerError || Object.prototype.hasOwnProperty.call(obj, "_isSignerError");
    };
    SignerError.isRejectedError = function(error) {
        var POSSIBLE_REJECTION_ERRORS = [
            "rejected by user",
            "rejected by the user",
            "user canceled",
            "user rejected",
            "user denied",
            "request rejected",
            "user abort",
            "declined by user"
        ];
        if (!!error && typeof error === "string") for(var _i = 0, POSSIBLE_REJECTION_ERRORS_1 = POSSIBLE_REJECTION_ERRORS; _i < POSSIBLE_REJECTION_ERRORS_1.length; _i++){
            var msg = POSSIBLE_REJECTION_ERRORS_1[_i];
            if (error.toLowerCase().includes(msg.toLowerCase())) return true;
        }
        else if (!!error && typeof error === "object") {
            if ((error === null || error === void 0 ? void 0 : error.code) === 4001) return true;
            for(var _a = 0, POSSIBLE_REJECTION_ERRORS_2 = POSSIBLE_REJECTION_ERRORS; _a < POSSIBLE_REJECTION_ERRORS_2.length; _a++){
                var msg = POSSIBLE_REJECTION_ERRORS_2[_a];
                if (JSON.stringify(error).toLowerCase().includes(msg.toLowerCase()) || ((error === null || error === void 0 ? void 0 : error.message) || "").toLowerCase().includes(msg.toLowerCase())) return true;
            }
        }
        return false;
    };
    SignerError.UnsupportedError = function(operation) {
        return new SignerError($ed2da9cee517980c$export$1105a941ceaa4b25.OPERATION_UNSUPPORTED, "'".concat(operation, "' is not supported by the signer"));
    };
    SignerError.UnimplementedError = function(operation) {
        return new SignerError($ed2da9cee517980c$export$1105a941ceaa4b25.NOT_IMPLEMENTED, "'".concat(operation, "' is not implemented by the signer"));
    };
    SignerError.AssertionFailed = function(m) {
        return new SignerError($ed2da9cee517980c$export$1105a941ceaa4b25.UNEXPECTED_BEHAVIOUR, "Assertion failed: " + m);
    };
    SignerError.prototype.getErrorDetail = function() {
        var _a;
        if (this.code === $ed2da9cee517980c$export$1105a941ceaa4b25.REJECTED_BY_USER) return {
            code: this.code,
            message: this.message,
            detail: ((_a = this.root) === null || _a === void 0 ? void 0 : _a.message) || "User rejected the transaction"
        };
        var rawMessage = typeof this.root === "object" && this.root && this.root.error ? this.root.error : JSON.stringify(this.root);
        var rootStr = typeof this.root === "string" ? this.root : this.root instanceof Error ? this.root.message : rawMessage;
        return {
            code: this.code,
            message: this.message,
            detail: rootStr
        };
    };
    return SignerError;
}(Error);


var $f8e6a490d9d0f60c$export$2006fb7614e99307 = /** @class */ function() {
    function DefaultSignerFactory() {
        this.signers = {};
        this.signers = {};
    }
    DefaultSignerFactory.prototype.registerSigner = function(txType, signer) {
        this.signers[txType] = signer;
    };
    DefaultSignerFactory.prototype.getSigner = function(txType) {
        if (this.signers && txType in this.signers) {
            var signer = this.signers[txType];
            if (!!signer) return signer;
        }
        throw new Error("Signer not found for " + txType);
    };
    return DefaultSignerFactory;
}();




var $f31ff4d75e2a780f$export$b1569e7f9d4064a9;
(function(PendingSwapNetworkStatus) {
    PendingSwapNetworkStatus["WaitingForConnectingWallet"] = "waitingForConnectingWallet";
    PendingSwapNetworkStatus["WaitingForQueue"] = "waitingForQueue";
    PendingSwapNetworkStatus["WaitingForNetworkChange"] = "waitingForNetworkChange";
    PendingSwapNetworkStatus["NetworkChanged"] = "networkChanged";
})($f31ff4d75e2a780f$export$b1569e7f9d4064a9 || ($f31ff4d75e2a780f$export$b1569e7f9d4064a9 = {}));
var $f31ff4d75e2a780f$export$bb45678bd9ad9127;
(function(MessageSeverity) {
    MessageSeverity["error"] = "error";
    MessageSeverity["warning"] = "warning";
    MessageSeverity["info"] = "info";
    MessageSeverity["success"] = "success";
})($f31ff4d75e2a780f$export$bb45678bd9ad9127 || ($f31ff4d75e2a780f$export$bb45678bd9ad9127 = {}));











var $ihoyg = parcelRequire("ihoyg");
var $e1583655d0761748$require$Buffer = $ihoyg.Buffer;
var $e1583655d0761748$var$N = Object.defineProperty;
var $e1583655d0761748$var$a = (e, n)=>$e1583655d0761748$var$N(e, "name", {
        value: n,
        configurable: !0
    });
var $e1583655d0761748$export$3fce19fdf0c5de73 = false, $e1583655d0761748$export$dfe7f2fe52a04245 = $e1583655d0761748$var$a((e, n)=>(e = typeof e == "string" && e.startsWith("0x") ? parseInt(e) : e, Object.values($e1583655d0761748$export$2e8191f482a38ccd).includes(String(e)) ? e : e === "Binance-Chain-Tigris" ? "BNB" : n.filter((o)=>!!o.chainId).find((o)=>(o.chainId?.startsWith("0x") ? parseInt(o.chainId) : o.chainId) == e)?.name || null), "getBlockChainNameFromId"), $e1583655d0761748$export$d840d807f640aaf5 = $e1583655d0761748$var$a((e, n)=>n[e]?.chainId || null, "getBlockchainChainIdByName"), $e1583655d0761748$export$c44b02fb03dbac82 = $e1583655d0761748$var$a((e)=>$e1583655d0761748$require$Buffer.from(e).toString("hex"), "uint8ArrayToHex"), $e1583655d0761748$export$b80cfa133c9c182d = ((s)=>(s.DEFAULT = "default", s.META_MASK = "metamask", s.WALLET_CONNECT_2 = "wallet-connect-2", s.TRUST_WALLET = "trust-wallet", s.KEPLR = "keplr", s.PHANTOM = "phantom", s.BITGET = "bitget", s.TRON_LINK = "tron-link", s.COINBASE = "coinbase", s.XDEFI = "xdefi", s.CLOVER = "clover", s.ARGENTX = "argentx", s.FRONTIER = "frontier", s.COSMOSTATION = "cosmostation", s.COIN98 = "coin98", s.SAFEPAL = "safepal", s.SAFE = "safe", s.TOKEN_POCKET = "token-pocket", s.BRAVE = "brave", s.BRAAVOS = "braavos", s.MATH = "math", s.EXODUS = "exodus", s.OKX = "okx", s.HALO = "halo", s.LEAP = "leap", s.LEAP_COSMOS = "leap-cosmos", s.STATION = "station", s.ENKRYPT = "enkrypt", s.TAHO = "taho", s.MY_TON_WALLET = "mytonwallet", s))($e1583655d0761748$export$b80cfa133c9c182d || {}), $e1583655d0761748$export$2e8191f482a38ccd = ((r)=>(r.BTC = "BTC", r.BSC = "BSC", r.LTC = "LTC", r.THORCHAIN = "THOR", r.BCH = "BCH", r.BINANCE = "BNB", r.ETHEREUM = "ETH", r.POLYGON = "POLYGON", r.TERRA = "TERRA", r.POLKADOT = "", r.TRON = "TRON", r.DOGE = "DOGE", r.HARMONY = "HARMONY", r.AVAX_CCHAIN = "AVAX_CCHAIN", r.FANTOM = "FANTOM", r.MOONBEAM = "MOONBEAM", r.ARBITRUM = "ARBITRUM", r.BOBA = "BOBA", r.OPTIMISM = "OPTIMISM", r.FUSE = "FUSE", r.CRONOS = "CRONOS", r.SOLANA = "SOLANA", r.MOONRIVER = "MOONRIVER", r.GNOSIS = "GNOSIS", r.COSMOS = "COSMOS", r.OSMOSIS = "OSMOSIS", r.AKASH = "AKASH", r.IRIS = "IRIS", r.PERSISTENCE = "PERSISTENCE", r.SENTINEL = "SENTINEL", r.REGEN = "REGEN", r.CRYPTO_ORG = "CRYPTO_ORG", r.SIF = "SIF", r.CHIHUAHUA = "CHIHUAHUA", r.JUNO = "JUNO", r.KUJIRA = "KUJIRA", r.STARNAME = "STARNAME", r.COMDEX = "COMDEX", r.STARGAZE = "STARGAZE", r.DESMOS = "DESMOS", r.BITCANNA = "BITCANNA", r.SECRET = "SECRET", r.INJECTIVE = "INJECTIVE", r.LUMNETWORK = "LUMNETWORK", r.BANDCHAIN = "BANDCHAIN", r.EMONEY = "EMONEY", r.BITSONG = "BITSONG", r.KI = "KI", r.MEDIBLOC = "MEDIBLOC", r.KONSTELLATION = "KONSTELLATION", r.UMEE = "UMEE", r.STARKNET = "STARKNET", r.TON = "TON", r.Unknown = "Unkown", r))($e1583655d0761748$export$2e8191f482a38ccd || {}), $e1583655d0761748$export$7289d9aba3deaf99 = [
    "BTC",
    "LTC",
    "THOR",
    "BCH",
    "BNB"
], $e1583655d0761748$export$12e8aeb69ff35d9 = [
    "keplr",
    "cosmostation",
    "leap-cosmos"
];
function $e1583655d0761748$export$6c40052bed430212(e) {
    let n;
    if (e == null || typeof e != "object") return e;
    if (e instanceof Date) return n = new Date, n.setTime(e.getTime()), n;
    if (e instanceof Array) {
        n = [];
        for(let t = 0, o = e.length; t < o; t++)n[t] = $e1583655d0761748$export$6c40052bed430212(e[t]);
        return n;
    }
    if (e instanceof Object) {
        n = {};
        for(let t in e)Object.prototype.hasOwnProperty.call(e, t) && (n[t] = $e1583655d0761748$export$6c40052bed430212(e[t]));
        return n;
    }
    throw new Error("Unable to copy obj! Its type isn't supported.");
}
$e1583655d0761748$var$a($e1583655d0761748$export$6c40052bed430212, "deepCopy");
async function $e1583655d0761748$export$56ce9af15430dcbb(e, n, t) {
    let o = t[n];
    try {
        await e.request({
            method: "wallet_switchEthereumChain",
            params: [
                {
                    chainId: o?.chainId
                }
            ]
        });
    } catch (i) {
        let u = i;
        if (o) (u.code === 4902 || !u.code) && await e.request({
            method: "wallet_addEthereumChain",
            params: [
                o
            ]
        });
        else throw new Error(`It seems you don't have ${n} network on your wallet. Please add it manually.`);
        throw i;
    }
}
$e1583655d0761748$var$a($e1583655d0761748$export$56ce9af15430dcbb, "switchOrAddNetworkForMetamaskCompatibleWallets");
async function $e1583655d0761748$export$83e74882c5df8fe1(e, n) {
    let t = new Promise((o, i)=>{
        setTimeout(()=>{
            i("Timeout!");
        }, n);
    });
    return Promise.race([
        e,
        t
    ]);
}
$e1583655d0761748$var$a($e1583655d0761748$export$83e74882c5df8fe1, "timeout");
var $e1583655d0761748$export$f0e13d51b5c692b6 = $e1583655d0761748$var$a((e)=>e.reduce((n, t)=>(n[t.name] = {
            chainName: t.info.chainName,
            chainId: t.chainId,
            nativeCurrency: t.info.nativeCurrency,
            rpcUrls: t.info.rpcUrls,
            blockExplorerUrls: t.info.blockExplorerUrls
        }, n), {}), "convertEvmBlockchainMetaToEvmChainInfo"), $e1583655d0761748$export$6965bcf5cb20b5b5 = $e1583655d0761748$var$a((e)=>Object.fromEntries(new Map(Object.keys(e).map((n)=>{
        let t = e[n];
        return t ? [
            parseInt(t.chainId),
            t.rpcUrls[0]
        ] : [
            0,
            ""
        ];
    }))), "evmChainsToRpcMap"), $e1583655d0761748$export$a009f0f0c363aa6c = $e1583655d0761748$var$a(async ({ instance: e })=>({
        accounts: [
            (await e.connect()).publicKey.toString()
        ],
        chainId: "SOLANA"
    }), "getSolanaAccounts");
function $e1583655d0761748$export$bc1a75e20816804a(e = "coinbase") {
    let { ethereum: n, coinbaseSolana: t } = window, o = new Map;
    if (n) {
        let i = e === "metamask" ? "isMetaMask" : "isCoinbaseWallet";
        if (e === "coinbase" && n[i]) o.set("ETH", n);
        else if (n.providers?.length) {
            let u = n.providers.find((c)=>c[i]);
            o.set("ETH", u);
        }
    }
    return t && e === "coinbase" && o.set("SOLANA", t), o.size === 0 ? null : e === "metamask" ? o.get("ETH") : o;
}
$e1583655d0761748$var$a($e1583655d0761748$export$bc1a75e20816804a, "getCoinbaseInstance");
function $e1583655d0761748$export$83c5a315dd1cff42(e) {
    return e.sort((n, t)=>Number(t.connected) - Number(n.connected) || Number(t.extensionAvailable) - Number(n.extensionAvailable));
}
$e1583655d0761748$var$a($e1583655d0761748$export$83c5a315dd1cff42, "sortWalletsBasedOnState");
function $e1583655d0761748$var$x() {
    let e = !1, n = navigator;
    return n.brave && n.brave.isBrave && n.brave.isBrave().then((t)=>{
        t && (e = !0);
    }), e;
}
$e1583655d0761748$var$a($e1583655d0761748$var$x, "isBrave");
function $e1583655d0761748$export$fd0008baca2bf83d(e) {
    if (typeof e != "object") return e;
    let n;
    return $e1583655d0761748$var$x() ? n = e.BRAVE : navigator.userAgent?.toLowerCase().indexOf("chrome") !== -1 ? n = e.CHROME : navigator.userAgent?.toLowerCase().indexOf("firefox") !== -1 ? n = e.FIREFOX : navigator.userAgent?.toLowerCase().indexOf("edge") !== -1 && (n = e.EDGE), n || e.DEFAULT;
}
$e1583655d0761748$var$a($e1583655d0761748$export$fd0008baca2bf83d, "detectInstallLink");
function $e1583655d0761748$export$486f06d416851c61() {
    return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
}
$e1583655d0761748$var$a($e1583655d0761748$export$486f06d416851c61, "detectMobileScreens");
function $e1583655d0761748$export$7925cdcd51d3102(e) {
    let t = (e?.split(":")[0] || "").split("-"), o = t[t.length - 1], i = t.slice(0, -1);
    return i[i.length - 1] === o && i.pop(), [
        i.join("-"),
        o
    ];
}
$e1583655d0761748$var$a($e1583655d0761748$export$7925cdcd51d3102, "splitWalletNetwork");
async function $e1583655d0761748$export$785cd5e95d0717c1(e) {
    let [n, t] = await Promise.all([
        e.request({
            method: "eth_requestAccounts"
        }),
        e.request({
            method: "eth_chainId"
        })
    ]);
    return {
        accounts: n,
        chainId: t
    };
}
$e1583655d0761748$var$a($e1583655d0761748$export$785cd5e95d0717c1, "getEvmAccounts");
var $e1583655d0761748$export$dae4ecb17c5c4020 = $e1583655d0761748$var$a(({ instance: e, state: n, updateChainId: t, updateAccounts: o })=>{
    let i = $e1583655d0761748$var$a((l)=>{
        n.connected && o(l);
    }, "handleAccountsChanged"), u = $e1583655d0761748$var$a((l)=>{
        t(l);
    }, "handleChainChanged");
    return e?.on("accountsChanged", i), e?.on("chainChanged", u), $e1583655d0761748$var$a(()=>{
        e?.off("chainChanged", i), e?.off("accountsChanged", u);
    }, "cleanup");
}, "subscribeToEvm"), $e1583655d0761748$export$4e65aae37dd4fc2c = $e1583655d0761748$var$a(async ({ instance: e })=>{
    try {
        return !!(await e.request({
            method: "eth_accounts"
        })).length;
    } catch  {
        return !1;
    }
}, "canEagerlyConnectToEvm"), $e1583655d0761748$export$394219efce660c44 = $e1583655d0761748$var$a(async ({ instance: e, network: n, meta: t })=>{
    let o = t.filter((0, $94f51709582f134d$export$9d749b8b357dfab2)), i = $e1583655d0761748$export$2029b78bc980a576(e, "ETH");
    await $e1583655d0761748$export$56ce9af15430dcbb(i, n, $e1583655d0761748$export$f0e13d51b5c692b6(o));
}, "switchNetworkForEvm"), $e1583655d0761748$export$86abff8ce014c125 = $e1583655d0761748$var$a(({ network: e, meta: n })=>$e1583655d0761748$export$9c76cdd331bb450e(n).includes(e), "canSwitchNetworkToEvm");
function $e1583655d0761748$export$9c76cdd331bb450e(e) {
    return e.filter((0, $94f51709582f134d$export$9d749b8b357dfab2)).map((n)=>n.name);
}
$e1583655d0761748$var$a($e1583655d0761748$export$9c76cdd331bb450e, "evmNetworkNames");
function $e1583655d0761748$export$d1cfcb1ce8ae2e4e(e, n) {
    return e && $e1583655d0761748$export$9c76cdd331bb450e(n).includes(e) ? "ETH" : null;
}
$e1583655d0761748$var$a($e1583655d0761748$export$d1cfcb1ce8ae2e4e, "getEthChainsInstance");
function $e1583655d0761748$var$B(e, n) {
    return e ? $e1583655d0761748$export$9c76cdd331bb450e(n).includes(e) : !1;
}
$e1583655d0761748$var$a($e1583655d0761748$var$B, "isEvmNetwork");
function $e1583655d0761748$export$b1eab42bc9b6c7a3(e, n, t) {
    t = t || "ETH";
    let o = $e1583655d0761748$var$B(t, n) ? $e1583655d0761748$export$d1cfcb1ce8ae2e4e(t, n) : t;
    return e && o ? e.get(o) : null;
}
$e1583655d0761748$var$a($e1583655d0761748$export$b1eab42bc9b6c7a3, "chooseInstance");
function $e1583655d0761748$export$2029b78bc980a576(e, n) {
    return e.size ? e.get(n) : e;
}
$e1583655d0761748$var$a($e1583655d0761748$export$2029b78bc980a576, "getNetworkInstance");
function $e1583655d0761748$export$2515b173249f2353(e, n) {
    return n && e[n] ? e[n].size ? e[n].get("ETH") : e[n] : null;
}
$e1583655d0761748$var$a($e1583655d0761748$export$2515b173249f2353, "getEvmProvider");
var $e1583655d0761748$var$v = $e1583655d0761748$var$a((e)=>e.filter((n)=>!n.info?.experimental).map((n)=>n.chainId).filter((n)=>!!n), "getCosmosMainChainsIds"), $e1583655d0761748$var$R = $e1583655d0761748$var$a((e)=>e.filter((n)=>n.info?.experimental).map((n)=>n.chainId).filter((n)=>!!n), "getCosmosMiscChainsIds"), $e1583655d0761748$export$9a5d8b9457d52deb = $e1583655d0761748$var$a((e)=>e.filter((n)=>!!n.info).filter((n)=>!!n.chainId).reduce((n, t)=>{
        let o = $e1583655d0761748$export$6c40052bed430212(t.info);
        o.stakeCurrency.coinImageUrl = window.location.origin + o.stakeCurrency.coinImageUrl, o.currencies = o.currencies.map((c)=>({
                ...c,
                coinImageUrl: window.location.origin + c.coinImageUrl
            })), o.feeCurrencies = o.feeCurrencies.map((c)=>({
                ...c,
                coinImageUrl: window.location.origin + c.coinImageUrl
            })), o.gasPriceStep || delete o.gasPriceStep;
        let { experimental: i, ...u } = o;
        return n[t.name] = {
            id: t.chainId,
            info: {
                ...u,
                chainId: t.chainId
            },
            experimental: i
        }, n;
    }, {}), "getCosmosExperimentalChainInfo");
async function $e1583655d0761748$var$P({ desiredChainIds: e, instance: n }) {
    let t = e.map((c)=>({
            signer: n.getOfflineSigner(c),
            chainId: c
        })).filter(Boolean), o = t.map(({ signer: c })=>c.getAccounts()), i = await Promise.allSettled(o), u = [];
    return i.forEach((c, l)=>{
        if (c.status !== "fulfilled") return;
        let m = c.value, { chainId: h } = t[l], E = m.map((f)=>f.address);
        u.push({
            accounts: E,
            chainId: h
        });
    }), u;
}
$e1583655d0761748$var$a($e1583655d0761748$var$P, "getMainAccounts");
async function $e1583655d0761748$var$k({ excludedChain: e, instance: n, meta: t }) {
    let o = $e1583655d0761748$var$R(t).filter((l)=>l !== e).map((l)=>({
            signer: n.getOfflineSigner(l),
            chainId: l
        })), i = o.map(async ({ signer: l })=>l.getAccounts()), u = await Promise.allSettled(i), c = [];
    return u.forEach((l, m)=>{
        if (l.status !== "fulfilled") return;
        let h = l.value, { chainId: E } = o[m], f = h.map((S)=>S.address);
        c.push({
            accounts: f,
            chainId: E
        });
    }), c;
}
$e1583655d0761748$var$a($e1583655d0761748$var$k, "tryRequestMiscAccounts");
var $e1583655d0761748$export$d4d8333f992ebe8c = $e1583655d0761748$var$a(async ({ instance: e, network: n, meta: t })=>{
    let o = n ? $e1583655d0761748$export$9a5d8b9457d52deb(t)[n] : null;
    if (n && !o) throw new Error(`You need to add ${n} to "COSMOS_EXPERIMENTAL_CHAINS_INFO" first.`);
    o && await e.experimentalSuggestChain(o.info);
    let i = $e1583655d0761748$var$v(t);
    o && i.push(o.id), i = Array.from(new Set(i)).filter(Boolean), await e.enable(i);
    let u = await $e1583655d0761748$var$P({
        desiredChainIds: i,
        instance: e
    }), c = o ? o.id : void 0, l = c ? await $e1583655d0761748$var$k({
        instance: e,
        meta: t,
        excludedChain: c
    }) : [];
    return [
        ...u,
        ...l
    ];
}, "getCosmosAccounts"), $e1583655d0761748$export$d873bd134feb393 = $e1583655d0761748$var$a(async (e)=>{
    let { instance: n, meta: t, network: o } = e, i = o ? $e1583655d0761748$export$9a5d8b9457d52deb(t)[o] : null;
    if (!i) throw new Error(`You need to add ${o} to "COSMOS_EXPERIMENTAL_CHAINS_INFO" first.`);
    await n.experimentalSuggestChain(i.info);
}, "suggestCosmosChain");


var $b084149028ad4f70$var$S = Object.defineProperty;
var $b084149028ad4f70$var$a = (s, t)=>$b084149028ad4f70$var$S(s, "name", {
        value: t,
        configurable: !0
    });
var $b084149028ad4f70$export$ada873a34909da65 = ((i)=>(i.CONNECTED = "connected", i.CONNECTING = "connecting", i.REACHABLE = "reachable", i.INSTALLED = "installed", i.ACCOUNTS = "accounts", i.NETWORK = "network", i))($b084149028ad4f70$export$ada873a34909da65 || {});
var $b084149028ad4f70$export$e01a546649d7a495 = class {
    getItem(t) {
        let e = localStorage.getItem(t);
        return e ? JSON.parse(e) : null;
    }
    setItem(t, e) {
        localStorage.setItem(t, JSON.stringify(e));
    }
    removeItem(t) {
        localStorage.removeItem(t);
    }
};
$b084149028ad4f70$var$a($b084149028ad4f70$export$e01a546649d7a495, "Persistor");
function $b084149028ad4f70$export$ca83cb3e52fc14f2(s, t) {
    return `${t || ""}:${s}`;
}
$b084149028ad4f70$var$a($b084149028ad4f70$export$ca83cb3e52fc14f2, "formatAddressWithNetwork");
function $b084149028ad4f70$export$63b32f891f8e164c(s, t) {
    return s ? s.map((e)=>$b084149028ad4f70$export$ca83cb3e52fc14f2(e, t)) : [];
}
$b084149028ad4f70$var$a($b084149028ad4f70$export$63b32f891f8e164c, "accountAddressesWithNetwork");
function $b084149028ad4f70$export$f571c5c1576ed25e(s) {
    let [t, e] = s.split(":");
    return {
        network: t,
        address: e
    };
}
$b084149028ad4f70$var$a($b084149028ad4f70$export$f571c5c1576ed25e, "readAccountAddress");
function $b084149028ad4f70$export$bfabd3ae82f8899f(s) {
    let { checkInstallation: t = !0 } = s.config;
    return t;
}
$b084149028ad4f70$var$a($b084149028ad4f70$export$bfabd3ae82f8899f, "needsCheckInstallation");
var $b084149028ad4f70$var$k = class {
    constructor(t, e){
        this.actions = e, this.options = t, this.provider = null, this.info = {
            supportedBlockchains: [],
            isContractWallet: !1
        }, this.state = {
            connected: !1,
            connecting: !1,
            reachable: !1,
            installed: !1,
            accounts: null,
            network: null
        }, $b084149028ad4f70$export$bfabd3ae82f8899f(t) || this.setInstalledAs(!0);
    }
    async suggestAndConnect(t) {
        return this.actions.suggest && await this.actions.suggest({
            instance: this.provider,
            meta: this.info.supportedBlockchains,
            network: t
        }), await this.connect(t);
    }
    async connect(t) {
        if (this.state.connecting) throw new Error("Connecting...");
        let e = await this.getConnectionFromState(), n = this.state.network, o = t || n || this.options.config.defaultNetwork;
        if (e) {
            let l = n !== o && !!o;
            if (n === o) return e;
            let r = !0;
            if (this.actions.canSwitchNetworkTo && (r = this.actions.canSwitchNetworkTo({
                provider: this.provider,
                meta: this.info.supportedBlockchains,
                network: o || ""
            })), l && r && this.actions.switchNetwork) return await this.actions.switchNetwork({
                instance: this.provider,
                meta: this.info.supportedBlockchains,
                network: o,
                newInstance: this.tryGetInstance.bind(this),
                getState: this.getState.bind(this)
            }), o !== this.state.network && !this.options.config.isAsyncSwitchNetwork && this.updateState({
                network: t
            }), {
                accounts: e.accounts,
                network: o,
                provider: this.provider
            };
        }
        let c = await this.tryGetInstance({
            network: t
        });
        this.updateState({
            connecting: !0
        }), this.setInstalledAs(!0);
        try {
            var i = await this.actions.connect({
                instance: c,
                network: o || void 0,
                meta: this.info.supportedBlockchains || []
            });
        } catch (l) {
            throw this.resetState(), l;
        }
        this.updateState({
            connected: !0,
            reachable: !0,
            connecting: !1
        });
        let h = [], g = null;
        if (Array.isArray(i)) h = i.flatMap((r)=>{
            let m = r.chainId || (0, $e1583655d0761748$export$2e8191f482a38ccd).Unknown, I = (0, $e1583655d0761748$export$dfe7f2fe52a04245)(m, this.info.supportedBlockchains) || (0, $e1583655d0761748$export$2e8191f482a38ccd).Unknown;
            return $b084149028ad4f70$export$63b32f891f8e164c(r.accounts, I);
        }).filter(Boolean), g = o || this.options.config.defaultNetwork;
        else {
            let l = i.chainId || (0, $e1583655d0761748$export$2e8191f482a38ccd).Unknown, r = (0, $e1583655d0761748$export$dfe7f2fe52a04245)(l, this.info.supportedBlockchains) || (0, $e1583655d0761748$export$2e8191f482a38ccd).Unknown;
            h = $b084149028ad4f70$export$63b32f891f8e164c(i.accounts, r), g = r;
        }
        return h.length > 0 && this.updateState({
            accounts: h,
            network: g
        }), {
            accounts: this.state.accounts,
            network: this.state.network,
            provider: this.provider
        };
    }
    async disconnect() {
        this.resetState(), this.actions.disconnect && this.actions.disconnect({
            instance: this.provider,
            destroyInstance: ()=>{
                this.setProvider(null);
            }
        });
    }
    async eagerConnect() {
        let t = await this.tryGetInstance({
            network: void 0
        }), { canEagerConnect: e } = this.actions, n = `can't restore connection for ${this.options.config.type} .`;
        if (e) {
            if (await e({
                instance: t,
                meta: this.info.supportedBlockchains
            })) return this.connect();
            throw new Error(n);
        } else throw new Error(n);
    }
    getSigners(t) {
        return this.actions.getSigners(t);
    }
    getWalletInfo(t) {
        return this.actions.getWalletInfo(t);
    }
    canSwitchNetworkTo(t, e) {
        let n = this.actions.canSwitchNetworkTo;
        return n ? n({
            network: t,
            meta: this.info.supportedBlockchains,
            provider: e
        }) : !1;
    }
    onInit() {
        this.options.config.isAsyncInstance ? $b084149028ad4f70$export$bfabd3ae82f8899f(this.options) && this.actions.getInstance().then((t)=>{
            t && this.setInstalledAs(!0);
        }) : this.actions.getInstance() && !this.state.installed && this.setInstalledAs(!0);
    }
    setProvider(t) {
        if (this.provider = t, t && this.actions.subscribe) {
            let e = this.actions.subscribe({
                instance: t,
                state: this.state,
                meta: this.info.supportedBlockchains,
                connect: this.connect.bind(this),
                disconnect: this.disconnect.bind(this),
                updateAccounts: (n, o)=>{
                    let c = this.state.network;
                    o && (c = (0, $e1583655d0761748$export$dfe7f2fe52a04245)(o, this.info.supportedBlockchains) || (0, $e1583655d0761748$export$2e8191f482a38ccd).Unknown);
                    let i = $b084149028ad4f70$export$63b32f891f8e164c(n, c);
                    i.length > 0 && this.updateState({
                        accounts: i
                    });
                },
                updateChainId: this.updateChainId.bind(this)
            });
            this.cleanupSubscribe = e;
        } else !t && this.cleanupSubscribe && this.cleanupSubscribe();
    }
    setInfo(t) {
        typeof t.supportedBlockchains < "u" && (this.info.supportedBlockchains = t.supportedBlockchains), typeof t.isContractWallet < "u" && (this.info.isContractWallet = t.isContractWallet);
    }
    setHandler(t) {
        this.options.handler = t;
    }
    getState() {
        return this.state;
    }
    updateState(t) {
        let e = [];
        typeof t.connected < "u" && (this.state.connected = t.connected, e.push([
            "connected",
            t.connected
        ])), typeof t.connecting < "u" && (this.state.connecting = t.connecting, e.push([
            "connecting",
            t.connecting
        ])), typeof t.reachable < "u" && (this.state.reachable = t.reachable, e.push([
            "reachable",
            t.reachable
        ])), typeof t.installed < "u" && (this.state.installed = t.installed, e.push([
            "installed",
            t.installed
        ])), typeof t.accounts < "u" && (this.state.accounts = t.accounts, e.push([
            "accounts",
            t.accounts
        ])), typeof t.network < "u" && (this.state.network = t.network, e.push([
            "network",
            t.network
        ]));
        let n = this.getState();
        e.forEach(([o, c])=>{
            let i = {
                supportedBlockchains: this.info.supportedBlockchains,
                isContractWallet: this.info.isContractWallet
            };
            this.options.handler(this.options.config.type, o, c, n, i);
        });
    }
    resetState() {
        this.updateState({
            connected: !1,
            connecting: !1,
            reachable: !1,
            accounts: null,
            network: null
        });
    }
    async getConnectionFromState() {
        return this.state.connected && this.provider ? {
            accounts: this.state.accounts,
            network: this.state.network,
            provider: this.provider
        } : null;
    }
    updateChainId(t) {
        let e = t ? (0, $e1583655d0761748$export$dfe7f2fe52a04245)(t, this.info.supportedBlockchains) : (0, $e1583655d0761748$export$2e8191f482a38ccd).Unknown;
        this.updateState({
            network: e
        });
    }
    setInstalledAs(t) {
        !$b084149028ad4f70$export$bfabd3ae82f8899f(this.options) && t === !1 || this.updateState({
            installed: t
        });
    }
    async tryGetInstance({ network: t, force: e }) {
        let n = null;
        if (this.setProvider(null), this.options.config.isAsyncInstance) {
            let o = {
                currentProvider: this.provider,
                meta: this.info.supportedBlockchains,
                force: e || !1,
                updateChainId: this.updateChainId.bind(this),
                getState: this.getState.bind(this)
            };
            t && (o.network = t), n = await this.actions.getInstance(o);
        } else n = this.actions.getInstance();
        if (!n) {
            this.setInstalledAs(!1), this.resetState();
            let o = `It seems your selected wallet (${this.options.config.type}) isn't installed.`;
            throw new Error(o);
        }
        return this.setProvider(n), n;
    }
};
$b084149028ad4f70$var$a($b084149028ad4f70$var$k, "Wallet");
var $b084149028ad4f70$export$2e2bcd8739ae039 = $b084149028ad4f70$var$k;



var $bh6RR = parcelRequire("bh6RR");
var $839aac193bf3ec6e$var$N = Object.defineProperty;
var $839aac193bf3ec6e$var$c = (e, t)=>$839aac193bf3ec6e$var$N(e, "name", {
        value: t,
        configurable: !0
    });
var $839aac193bf3ec6e$var$u = "last-connected-wallets";
function $839aac193bf3ec6e$export$7877a478dd30fd3d(e, t) {
    return e.find((s)=>s.type === t) || null;
}
$839aac193bf3ec6e$var$c($839aac193bf3ec6e$export$7877a478dd30fd3d, "choose");
var $839aac193bf3ec6e$export$583dd06ffb7665f8 = {
    connected: !1,
    connecting: !1,
    reachable: !1,
    installed: !1,
    accounts: null,
    network: null
};
function $839aac193bf3ec6e$export$84400326cfb82ab2(e, t) {
    if (t.type === "new_state") {
        let s = e[t.wallet];
        return s ? {
            ...e,
            [t.wallet]: {
                ...s,
                [t.name]: t.value
            }
        } : {
            ...e,
            [t.wallet]: {
                ...$839aac193bf3ec6e$export$583dd06ffb7665f8,
                [t.name]: t.value
            }
        };
    }
    return e;
}
$839aac193bf3ec6e$var$c($839aac193bf3ec6e$export$84400326cfb82ab2, "state_reducer");
function $839aac193bf3ec6e$export$5ae027e423e49e34(e) {
    return Object.entries(e).filter(([, t])=>t?.connected).map(([t])=>t);
}
$839aac193bf3ec6e$var$c($839aac193bf3ec6e$export$5ae027e423e49e34, "connectedWallets");
function $839aac193bf3ec6e$export$fa8b8bfe0657110e(e) {
    return Object.entries(e).map(([t])=>t);
}
$839aac193bf3ec6e$var$c($839aac193bf3ec6e$export$fa8b8bfe0657110e, "availableWallets");
function $839aac193bf3ec6e$export$927cec00467ddd76(e) {
    let t = new Map;
    return e.forEach((s)=>{
        let { config: l, ...o } = s;
        t.set(l.type, {
            actions: o,
            config: l
        });
    }), t;
}
$839aac193bf3ec6e$var$c($839aac193bf3ec6e$export$927cec00467ddd76, "checkWalletProviders");
function $839aac193bf3ec6e$export$aefee5ebe1dcfd9e(e) {
    return e?.constructor?.name === "AsyncFunction";
}
$839aac193bf3ec6e$var$c($839aac193bf3ec6e$export$aefee5ebe1dcfd9e, "isAsync");
function $839aac193bf3ec6e$export$bfabd3ae82f8899f(e) {
    let { checkInstallation: t = !0 } = e.config;
    return t;
}
$839aac193bf3ec6e$var$c($839aac193bf3ec6e$export$bfabd3ae82f8899f, "needsCheckInstallation");
async function $839aac193bf3ec6e$export$567be3f12e4409f4({ type: e, walletActions: t, getState: s }) {
    if (t.canEagerConnect) {
        let l = new (0, $b084149028ad4f70$export$e01a546649d7a495), o = l.getItem($839aac193bf3ec6e$var$u);
        o?.find((i)=>!s(i).connected) && $839aac193bf3ec6e$export$68f445eb81c96373();
        let d = !!o?.find((i)=>i === e);
        o && !d ? l.setItem($839aac193bf3ec6e$var$u, o.concat(e)) : l.setItem($839aac193bf3ec6e$var$u, [
            e
        ]);
    }
}
$839aac193bf3ec6e$var$c($839aac193bf3ec6e$export$567be3f12e4409f4, "tryPersistWallet");
function $839aac193bf3ec6e$export$967c813e2e19faa4({ type: e, walletActions: t }) {
    if (t.canEagerConnect) {
        let s = new (0, $b084149028ad4f70$export$e01a546649d7a495), l = s.getItem($839aac193bf3ec6e$var$u);
        l && s.setItem($839aac193bf3ec6e$var$u, l.filter((o)=>o !== e));
    }
}
$839aac193bf3ec6e$var$c($839aac193bf3ec6e$export$967c813e2e19faa4, "tryRemoveWalletFromPersistance");
function $839aac193bf3ec6e$export$68f445eb81c96373() {
    let e = new (0, $b084149028ad4f70$export$e01a546649d7a495);
    e.getItem($839aac193bf3ec6e$var$u) && e.removeItem($839aac193bf3ec6e$var$u);
}
$839aac193bf3ec6e$var$c($839aac193bf3ec6e$export$68f445eb81c96373, "clearPersistance");
async function $839aac193bf3ec6e$export$392c2457b7907874(e, t) {
    let s = new (0, $b084149028ad4f70$export$e01a546649d7a495), l = s.getItem($839aac193bf3ec6e$var$u);
    if (l && l.length) {
        let o = [];
        l.forEach((i)=>{
            let n = e.get(i);
            if (n) {
                let r = t(n);
                o.push({
                    walletType: i,
                    eagerConnect: r.eagerConnect.bind(r)
                });
            }
        });
        let w = await Promise.allSettled(o.map(({ eagerConnect: i })=>i()));
        if (!!w.find(({ status: i })=>i === "fulfilled")) {
            let i = [];
            w.forEach(({ status: n }, r)=>{
                n === "rejected" && i.push(o[r].walletType);
            }), i.length && s.setItem($839aac193bf3ec6e$var$u, l.filter((n)=>!i.includes(n)));
        }
    }
}
$839aac193bf3ec6e$var$c($839aac193bf3ec6e$export$392c2457b7907874, "autoConnect");
function $839aac193bf3ec6e$export$a94115b6ef8724e(e, t) {
    return $839aac193bf3ec6e$var$c((l, o, w, d, i)=>{
        e({
            type: "new_state",
            wallet: l,
            name: o,
            value: w
        }), t && t(l, o, w, d, i);
    }, "handler");
}
$839aac193bf3ec6e$var$c($839aac193bf3ec6e$export$a94115b6ef8724e, "makeEventHandler");
var $839aac193bf3ec6e$var$f = "Context hasn't been initialized yet.", $839aac193bf3ec6e$var$B = {
    async connect () {
        throw new Error($839aac193bf3ec6e$var$f);
    },
    async disconnect () {
        throw new Error($839aac193bf3ec6e$var$f);
    },
    async disconnectAll () {
        throw new Error($839aac193bf3ec6e$var$f);
    },
    async suggestAndConnect () {
        throw new Error($839aac193bf3ec6e$var$f);
    },
    state () {
        throw new Error($839aac193bf3ec6e$var$f);
    },
    canSwitchNetworkTo () {
        throw new Error($839aac193bf3ec6e$var$f);
    },
    providers () {
        throw new Error($839aac193bf3ec6e$var$f);
    },
    getWalletInfo () {
        throw new Error($839aac193bf3ec6e$var$f);
    },
    getSigners () {
        throw new Error($839aac193bf3ec6e$var$f);
    }
}, $839aac193bf3ec6e$var$h = (0, $bh6RR.createContext)($839aac193bf3ec6e$var$B);
function $839aac193bf3ec6e$var$A(e) {
    let t = (0, $bh6RR.useRef)({});
    function s(l) {
        let o = l.config.type;
        return typeof t.current[o] > "u" && (t.current[o] = new (0, $b084149028ad4f70$export$2e2bcd8739ae039)({
            config: l.config,
            handler: e
        }, l.actions)), t.current[o];
    }
    return $839aac193bf3ec6e$var$c(s, "updater"), s;
}
$839aac193bf3ec6e$var$c($839aac193bf3ec6e$var$A, "useInitializers");
function $839aac193bf3ec6e$export$934951b5ed2ebf82() {
    let e = (0, $bh6RR.useContext)($839aac193bf3ec6e$var$h);
    if (!e) throw Error("useWallet can only be used within the Provider component");
    return e;
}
$839aac193bf3ec6e$var$c($839aac193bf3ec6e$export$934951b5ed2ebf82, "useWallets");
function $839aac193bf3ec6e$var$D(e) {
    let [t, s] = (0, $bh6RR.useReducer)($839aac193bf3ec6e$export$84400326cfb82ab2, {}), l = (0, $bh6RR.useRef)(!1), o = $839aac193bf3ec6e$var$A($839aac193bf3ec6e$export$a94115b6ef8724e(s, e.onUpdateState)), w = e.providers, d = $839aac193bf3ec6e$export$927cec00467ddd76(w), i = {
        async connect (n, r) {
            let a = d.get(n);
            if (!a) throw new Error(`You should add ${n} to provider first.`);
            let y = await o(a).connect(r);
            return e.autoConnect && $839aac193bf3ec6e$export$567be3f12e4409f4({
                type: n,
                walletActions: a.actions,
                getState: i.state
            }), y;
        },
        async disconnect (n) {
            let r = d.get(n);
            if (!r) throw new Error(`You should add ${n} to provider first.`);
            await o(r).disconnect(), e.autoConnect && $839aac193bf3ec6e$export$967c813e2e19faa4({
                type: n,
                walletActions: r.actions
            });
        },
        async disconnectAll () {
            let n = [];
            return $839aac193bf3ec6e$export$5ae027e423e49e34(t).forEach((r)=>{
                let a = d.get(r);
                if (a) {
                    let p = o(a);
                    n.push(p.disconnect());
                }
            }), e.autoConnect && $839aac193bf3ec6e$export$68f445eb81c96373(), await Promise.allSettled(n);
        },
        async suggestAndConnect (n, r) {
            let a = d.get(n);
            if (!a) throw new Error(`You should add ${n} to provider first.`);
            return await o(a).suggestAndConnect(r);
        },
        state (n) {
            return t[n] || $839aac193bf3ec6e$export$583dd06ffb7665f8;
        },
        canSwitchNetworkTo (n, r) {
            let a = d.get(n);
            if (!a) return !1;
            let p = o(a);
            return p.canSwitchNetworkTo ? p.canSwitchNetworkTo(r, p.provider) : !1;
        },
        providers () {
            let n = {};
            return $839aac193bf3ec6e$export$fa8b8bfe0657110e(t).forEach((r)=>{
                let a = d.get(r);
                if (a) {
                    let p = o(a);
                    n[r] = p.provider;
                }
            }), n;
        },
        getWalletInfo (n) {
            let r = d.get(n);
            if (!r) throw new Error(`You should add ${n} to provider first.`);
            return r.actions.getWalletInfo(e.allBlockChains || []);
        },
        getSigners (n) {
            let r = d.get(n);
            if (!r) throw new Error(`You should add ${n} to provider first.`);
            let a = o(r), p = a.provider;
            return a.getSigners(p);
        }
    };
    return (0, $bh6RR.useEffect)(()=>{
        d.forEach((n)=>{
            let r = o(n), a = $839aac193bf3ec6e$var$c(()=>{
                r.onInit && r.onInit();
            }, "runOnInit"), p = $839aac193bf3ec6e$var$c((y)=>{
                y.target && y.target.readyState === "complete" && (a(), document.removeEventListener("readystatechange", p));
            }, "initWhenPageIsReady");
            a(), document.addEventListener("readystatechange", p);
        });
    }, []), (0, $bh6RR.useEffect)(()=>{
        e.allBlockChains && d.forEach((r)=>{
            let a = o(r), p = a.getWalletInfo(e.allBlockChains || []);
            a.setInfo({
                supportedBlockchains: p.supportedChains,
                isContractWallet: !!p.isContractWallet
            });
        });
    }, [
        e.allBlockChains
    ]), (0, $bh6RR.useEffect)(()=>{
        d.forEach((n)=>{
            o(n).setHandler($839aac193bf3ec6e$export$a94115b6ef8724e(s, e.onUpdateState));
        });
    }, [
        e.onUpdateState
    ]), (0, $bh6RR.useEffect)(()=>{
        e.allBlockChains && e.allBlockChains.length && e.autoConnect && !l.current && (l.current = !0, (async ()=>await $839aac193bf3ec6e$export$392c2457b7907874(d, o))());
    }, [
        e.autoConnect,
        e.allBlockChains
    ]), (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($839aac193bf3ec6e$var$h.Provider, {
        value: i
    }, e.children);
}
$839aac193bf3ec6e$var$c($839aac193bf3ec6e$var$D, "Provider");
var $839aac193bf3ec6e$export$2881499e37b75b9a = $839aac193bf3ec6e$var$D;


var $f5669291906fba67$exports = {};

$parcel$export($f5669291906fba67$exports, "config", function () { return $f5669291906fba67$export$e506a1d27d1eaa20; });
$parcel$export($f5669291906fba67$exports, "getInstance", function () { return $f5669291906fba67$export$8bedcca5bbd73999; });
$parcel$export($f5669291906fba67$exports, "connect", function () { return $f5669291906fba67$export$64605811ab45167f; });
$parcel$export($f5669291906fba67$exports, "subscribe", function () { return $f5669291906fba67$export$ec068583843480e7; });
$parcel$export($f5669291906fba67$exports, "switchNetwork", function () { return $f5669291906fba67$export$f3473d805e486329; });
$parcel$export($f5669291906fba67$exports, "canSwitchNetworkTo", function () { return $f5669291906fba67$export$3b3cf9ab9019de20; });
$parcel$export($f5669291906fba67$exports, "getSigners", function () { return $f5669291906fba67$export$6352a17a50193ded; });
$parcel$export($f5669291906fba67$exports, "canEagerConnect", function () { return $f5669291906fba67$export$be9f3c5ed1d25e42; });
$parcel$export($f5669291906fba67$exports, "getWalletInfo", function () { return $f5669291906fba67$export$e5b9d96c6aeb3ff7; });

var $735c534a2f96a593$exports = {};
$parcel$export($735c534a2f96a593$exports, "cosmosBlockchains", function () { return $cd8bb37a306c2b01$export$7a136f0d6bb0d722; });
$parcel$export($735c534a2f96a593$exports, "evmBlockchains", function () { return $cd8bb37a306c2b01$export$e2a694e57950e88e; });
$parcel$export($735c534a2f96a593$exports, "isCosmosBlockchain", function () { return $cd8bb37a306c2b01$export$d917e9e8a70036a6; });
$parcel$export($735c534a2f96a593$exports, "isEvmBlockchain", function () { return $cd8bb37a306c2b01$export$9d749b8b357dfab2; });
$parcel$export($735c534a2f96a593$exports, "solanaBlockchain", function () { return $cd8bb37a306c2b01$export$11a35c42f4dd4832; });
$parcel$export($735c534a2f96a593$exports, "TransactionType", function () { return $6fc89aa3c0b05299$export$d513b00599f845d4; });
$parcel$export($735c534a2f96a593$exports, "tronBlockchain", function () { return $cd8bb37a306c2b01$export$61a2144ef91f3622; });












/**
 * Routing Result Type
 *
 */ var $e6f5e807863367da$export$9244fb3192b4c649;
(function(RoutingResultType) {
    RoutingResultType["OK"] = "OK";
    RoutingResultType["HIGH_IMPACT"] = "HIGH_IMPACT";
    RoutingResultType["NO_ROUTE"] = "NO_ROUTE";
    RoutingResultType["INPUT_LIMIT_ISSUE"] = "INPUT_LIMIT_ISSUE";
})($e6f5e807863367da$export$9244fb3192b4c649 || ($e6f5e807863367da$export$9244fb3192b4c649 = {}));


/**
 * The type of transaction
 */ var $6fc89aa3c0b05299$export$d513b00599f845d4;
(function(TransactionType) {
    TransactionType["EVM"] = "EVM";
    TransactionType["TRANSFER"] = "TRANSFER";
    TransactionType["COSMOS"] = "COSMOS";
    TransactionType["SOLANA"] = "SOLANA";
    TransactionType["TRON"] = "TRON";
    TransactionType["STARKNET"] = "STARKNET";
    TransactionType["TON"] = "TON";
})($6fc89aa3c0b05299$export$d513b00599f845d4 || ($6fc89aa3c0b05299$export$d513b00599f845d4 = {}));
var $6fc89aa3c0b05299$export$d5c0ec10a1bea971;
(function(GenericTransactionType) {
    GenericTransactionType["EVM"] = "EVM";
    GenericTransactionType["TRANSFER"] = "TRANSFER";
    GenericTransactionType["COSMOS"] = "COSMOS";
    GenericTransactionType["SOLANA"] = "SOLANA";
})($6fc89aa3c0b05299$export$d5c0ec10a1bea971 || ($6fc89aa3c0b05299$export$d5c0ec10a1bea971 = {}));
function $6fc89aa3c0b05299$export$882b4f79e45cc211(value) {
    return [
        "TX_FAIL",
        "TX_EXPIRED",
        "FETCH_TX_FAILED",
        "USER_REJECT",
        "USER_CANCEL",
        "USER_CANCELED_TX",
        "CALL_WALLET_FAILED",
        "SEND_TX_FAILED",
        "CALL_OR_SEND_FAILED",
        "TX_FAILED_IN_BLOCKCHAIN",
        "CLIENT_UNEXPECTED_BEHAVIOUR",
        "INSUFFICIENT_APPROVE"
    ].includes(value);
}
var $6fc89aa3c0b05299$export$7c391bd3b61d2374;
(function(TransactionStatus) {
    TransactionStatus["FAILED"] = "failed";
    TransactionStatus["RUNNING"] = "running";
    TransactionStatus["SUCCESS"] = "success";
})($6fc89aa3c0b05299$export$7c391bd3b61d2374 || ($6fc89aa3c0b05299$export$7c391bd3b61d2374 = {}));





var $b22703f608461047$export$16073528a91c8d2a = function(transaction) {
    return transaction.type === (0, $6fc89aa3c0b05299$export$d513b00599f845d4).COSMOS;
};



var $fc55b41765145bb6$export$b1818bc93202fd47 = function(transaction) {
    return transaction.type === (0, $6fc89aa3c0b05299$export$d513b00599f845d4).SOLANA;
};



var $a6bea102f63ac66f$export$a6e014f972e5c64c = function(transaction) {
    return transaction.type === (0, $6fc89aa3c0b05299$export$d513b00599f845d4).TRANSFER;
};



var $b37d17c2cdcfd950$export$fd5286d9851f07f6 = function(transaction) {
    return transaction.type === (0, $6fc89aa3c0b05299$export$d513b00599f845d4).STARKNET;
};



var $8ab34db4cfd56cbf$export$9fd5291d9179852a = function(transaction) {
    return transaction.type === (0, $6fc89aa3c0b05299$export$d513b00599f845d4).TRON;
};



var $f6196e7f50fa730a$export$6ef804aee1395a14;
(function(TonChainID) {
    TonChainID["MAINNET"] = "-239";
    TonChainID["TESTNET"] = "-3";
})($f6196e7f50fa730a$export$6ef804aee1395a14 || ($f6196e7f50fa730a$export$6ef804aee1395a14 = {}));
var $f6196e7f50fa730a$export$232916af2d90d322 = function(transaction) {
    return transaction.type === (0, $6fc89aa3c0b05299$export$d513b00599f845d4).TON;
};




var $cd8bb37a306c2b01$export$9d749b8b357dfab2 = function(blockchainMeta) {
    return blockchainMeta.type === "EVM";
};
var $cd8bb37a306c2b01$export$d917e9e8a70036a6 = function(blockchainMeta) {
    return blockchainMeta.type === "COSMOS";
};
var $cd8bb37a306c2b01$export$ff5a0a65a8982bf2 = function(blockchainMeta) {
    return blockchainMeta.type === "SOLANA";
};
var $cd8bb37a306c2b01$export$744fa0907a94ca40 = function(blockchainMeta) {
    return blockchainMeta.type === "TRON";
};
var $cd8bb37a306c2b01$export$83b5ebc3a9031095 = function(blockchainMeta) {
    return blockchainMeta.type === "TRANSFER";
};
var $cd8bb37a306c2b01$export$80db8fd9e7a31db2 = function(blockchainMeta) {
    return blockchainMeta.type === "STARKNET";
};
var $cd8bb37a306c2b01$export$9500a92ad5d775aa = function(blockchainMeta) {
    return blockchainMeta.type === "TON";
};
var $cd8bb37a306c2b01$export$e2a694e57950e88e = function(blockchains) {
    return blockchains.filter($cd8bb37a306c2b01$export$9d749b8b357dfab2);
};
var $cd8bb37a306c2b01$export$11a35c42f4dd4832 = function(blockchains) {
    return blockchains.filter($cd8bb37a306c2b01$export$ff5a0a65a8982bf2);
};
var $cd8bb37a306c2b01$export$e1f5443c7a926d0f = function(blockchains) {
    return blockchains.filter($cd8bb37a306c2b01$export$80db8fd9e7a31db2);
};
var $cd8bb37a306c2b01$export$61a2144ef91f3622 = function(blockchains) {
    return blockchains.filter($cd8bb37a306c2b01$export$744fa0907a94ca40);
};
var $cd8bb37a306c2b01$export$7a136f0d6bb0d722 = function(blockchains) {
    return blockchains.filter($cd8bb37a306c2b01$export$d917e9e8a70036a6);
};
var $cd8bb37a306c2b01$export$80dff8c560b1e7ce = function(blockchains) {
    return blockchains.filter($cd8bb37a306c2b01$export$83b5ebc3a9031095);
};
var $cd8bb37a306c2b01$export$e38bf62be0c23ec5 = function(blockchains) {
    return blockchains.filter($cd8bb37a306c2b01$export$9500a92ad5d775aa);
};










var $e19d74b5ae43de4e$export$b9109202fe95a066 = function(transaction) {
    return transaction.type === (0, $6fc89aa3c0b05299$export$d513b00599f845d4).EVM;
};





































var $9cc115f359bcfe1a$export$b9109202fe95a066 = function(transaction) {
    return transaction.type === (0, $6fc89aa3c0b05299$export$d513b00599f845d4).EVM;
};
















var $764d3a7fdc7c6c54$exports = {};
$parcel$export($764d3a7fdc7c6c54$exports, "DefaultSignerFactory", function () { return $b0f7ab1c178913fc$export$2006fb7614e99307; });
var $6bf9e406f810d981$exports = {};

$parcel$export($6bf9e406f810d981$exports, "SignerErrorCode", function () { return $6bf9e406f810d981$export$1105a941ceaa4b25; });
$parcel$export($6bf9e406f810d981$exports, "RPCErrorCode", function () { return $6bf9e406f810d981$export$618932a85b762ea3; });
$parcel$export($6bf9e406f810d981$exports, "SignerError", function () { return $6bf9e406f810d981$export$7cc7da8fa05ccee8; });
var $6bf9e406f810d981$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $6bf9e406f810d981$export$1105a941ceaa4b25;
(function(SignerErrorCode) {
    SignerErrorCode["REJECTED_BY_USER"] = "REJECTED_BY_USER";
    SignerErrorCode["SIGN_TX_ERROR"] = "SIGN_TX_ERROR";
    SignerErrorCode["SEND_TX_ERROR"] = "SEND_TX_ERROR";
    SignerErrorCode["TX_FAILED_IN_BLOCKCHAIN"] = "TX_FAILED_IN_BLOCKCHAIN";
    SignerErrorCode["OPERATION_UNSUPPORTED"] = "OPERATION_UNSUPPORTED";
    SignerErrorCode["UNEXPECTED_BEHAVIOUR"] = "UNEXPECTED_BEHAVIOUR";
    SignerErrorCode["NOT_IMPLEMENTED"] = "NOT_IMPLEMENTED";
})($6bf9e406f810d981$export$1105a941ceaa4b25 || ($6bf9e406f810d981$export$1105a941ceaa4b25 = {}));
var $6bf9e406f810d981$export$618932a85b762ea3;
(function(RPCErrorCode) {
    RPCErrorCode["REJECTION"] = "REJECTION";
    RPCErrorCode["UNDER_PRICED"] = "UNDER_PRICED";
    RPCErrorCode["OUT_OF_GAS"] = "OUT_OF_GAS";
    RPCErrorCode["CALL_EXCEPTION"] = "CALL_EXCEPTION";
    RPCErrorCode["INSUFFICIENT_FUNDS"] = "INSUFFICIENT_FUNDS";
    RPCErrorCode["INTERNAL"] = "INTERNAL";
    RPCErrorCode["SLIPPAGE"] = "SLIPPAGE";
    RPCErrorCode["UNKNOWN_ERROR"] = "UNKNOWN";
})($6bf9e406f810d981$export$618932a85b762ea3 || ($6bf9e406f810d981$export$618932a85b762ea3 = {}));
function $6bf9e406f810d981$export$be10b575629ad8f(value) {
    return Object.keys($6bf9e406f810d981$export$1105a941ceaa4b25).includes(value);
}
function $6bf9e406f810d981$export$714f3eb4b9ca37c5(code) {
    var _a;
    var errorMap = (_a = {}, _a[$6bf9e406f810d981$export$1105a941ceaa4b25.REJECTED_BY_USER] = "User rejected the transaction", _a[$6bf9e406f810d981$export$1105a941ceaa4b25.SIGN_TX_ERROR] = "Error signing the transaction", _a[$6bf9e406f810d981$export$1105a941ceaa4b25.SEND_TX_ERROR] = "Error sending the transaction", _a[$6bf9e406f810d981$export$1105a941ceaa4b25.NOT_IMPLEMENTED] = "Operation not implemented", _a[$6bf9e406f810d981$export$1105a941ceaa4b25.OPERATION_UNSUPPORTED] = "Unsupported operation", _a[$6bf9e406f810d981$export$1105a941ceaa4b25.TX_FAILED_IN_BLOCKCHAIN] = "Transaction failed in blockchain", _a[$6bf9e406f810d981$export$1105a941ceaa4b25.UNEXPECTED_BEHAVIOUR] = "Unexpected error", _a);
    return errorMap[code];
}
var $6bf9e406f810d981$export$7cc7da8fa05ccee8 = /** @class */ function(_super) {
    $6bf9e406f810d981$var$__extends(SignerError, _super);
    function SignerError(code, m, root, rpcCode, trace) {
        var _this = _super.call(this, m || $6bf9e406f810d981$export$714f3eb4b9ca37c5(code)) || this;
        _this._isSignerError = true;
        Object.setPrototypeOf(_this, SignerError.prototype);
        SignerError.prototype._isSignerError = true;
        _this.code = code;
        _this.root = root;
        _this.rpcCode = rpcCode;
        _this.trace = trace;
        if (_this.code === $6bf9e406f810d981$export$1105a941ceaa4b25.REJECTED_BY_USER || SignerError.isRejectedError(root)) {
            _this.code = $6bf9e406f810d981$export$1105a941ceaa4b25.REJECTED_BY_USER;
            _this.message = "User rejected the transaction";
            _this.root = undefined;
        }
        return _this;
    }
    SignerError.isSignerError = function(obj) {
        return obj instanceof SignerError || Object.prototype.hasOwnProperty.call(obj, "_isSignerError");
    };
    SignerError.isRejectedError = function(error) {
        var POSSIBLE_REJECTION_ERRORS = [
            "rejected by user",
            "rejected by the user",
            "user canceled",
            "user rejected",
            "user denied",
            "request rejected",
            "user abort",
            "declined by user"
        ];
        if (!!error && typeof error === "string") for(var _i = 0, POSSIBLE_REJECTION_ERRORS_1 = POSSIBLE_REJECTION_ERRORS; _i < POSSIBLE_REJECTION_ERRORS_1.length; _i++){
            var msg = POSSIBLE_REJECTION_ERRORS_1[_i];
            if (error.toLowerCase().includes(msg.toLowerCase())) return true;
        }
        else if (!!error && typeof error === "object") {
            if ((error === null || error === void 0 ? void 0 : error.code) === 4001) return true;
            for(var _a = 0, POSSIBLE_REJECTION_ERRORS_2 = POSSIBLE_REJECTION_ERRORS; _a < POSSIBLE_REJECTION_ERRORS_2.length; _a++){
                var msg = POSSIBLE_REJECTION_ERRORS_2[_a];
                if (JSON.stringify(error).toLowerCase().includes(msg.toLowerCase()) || ((error === null || error === void 0 ? void 0 : error.message) || "").toLowerCase().includes(msg.toLowerCase())) return true;
            }
        }
        return false;
    };
    SignerError.UnsupportedError = function(operation) {
        return new SignerError($6bf9e406f810d981$export$1105a941ceaa4b25.OPERATION_UNSUPPORTED, "'".concat(operation, "' is not supported by the signer"));
    };
    SignerError.UnimplementedError = function(operation) {
        return new SignerError($6bf9e406f810d981$export$1105a941ceaa4b25.NOT_IMPLEMENTED, "'".concat(operation, "' is not implemented by the signer"));
    };
    SignerError.AssertionFailed = function(m) {
        return new SignerError($6bf9e406f810d981$export$1105a941ceaa4b25.UNEXPECTED_BEHAVIOUR, "Assertion failed: " + m);
    };
    SignerError.prototype.getErrorDetail = function() {
        var _a;
        if (this.code === $6bf9e406f810d981$export$1105a941ceaa4b25.REJECTED_BY_USER) return {
            code: this.code,
            message: this.message,
            detail: ((_a = this.root) === null || _a === void 0 ? void 0 : _a.message) || "User rejected the transaction"
        };
        var rawMessage = typeof this.root === "object" && this.root && this.root.error ? this.root.error : JSON.stringify(this.root);
        var rootStr = typeof this.root === "string" ? this.root : this.root instanceof Error ? this.root.message : rawMessage;
        return {
            code: this.code,
            message: this.message,
            detail: rootStr
        };
    };
    return SignerError;
}(Error);


var $b0f7ab1c178913fc$export$2006fb7614e99307 = /** @class */ function() {
    function DefaultSignerFactory() {
        this.signers = {};
        this.signers = {};
    }
    DefaultSignerFactory.prototype.registerSigner = function(txType, signer) {
        this.signers[txType] = signer;
    };
    DefaultSignerFactory.prototype.getSigner = function(txType) {
        if (this.signers && txType in this.signers) {
            var signer = this.signers[txType];
            if (!!signer) return signer;
        }
        throw new Error("Signer not found for " + txType);
    };
    return DefaultSignerFactory;
}();


$parcel$exportWildcard($764d3a7fdc7c6c54$exports, $6bf9e406f810d981$exports);


var $ea070b5dc0dc0a6d$export$b1569e7f9d4064a9;
(function(PendingSwapNetworkStatus) {
    PendingSwapNetworkStatus["WaitingForConnectingWallet"] = "waitingForConnectingWallet";
    PendingSwapNetworkStatus["WaitingForQueue"] = "waitingForQueue";
    PendingSwapNetworkStatus["WaitingForNetworkChange"] = "waitingForNetworkChange";
    PendingSwapNetworkStatus["NetworkChanged"] = "networkChanged";
})($ea070b5dc0dc0a6d$export$b1569e7f9d4064a9 || ($ea070b5dc0dc0a6d$export$b1569e7f9d4064a9 = {}));
var $ea070b5dc0dc0a6d$export$bb45678bd9ad9127;
(function(MessageSeverity) {
    MessageSeverity["error"] = "error";
    MessageSeverity["warning"] = "warning";
    MessageSeverity["info"] = "info";
    MessageSeverity["success"] = "success";
})($ea070b5dc0dc0a6d$export$bb45678bd9ad9127 || ($ea070b5dc0dc0a6d$export$bb45678bd9ad9127 = {}));








$parcel$exportWildcard($735c534a2f96a593$exports, $764d3a7fdc7c6c54$exports);



var $ihoyg = parcelRequire("ihoyg");
var $c7b1ddb572c90b38$require$Buffer = $ihoyg.Buffer;
var $c7b1ddb572c90b38$var$M = Object.defineProperty;
var $c7b1ddb572c90b38$var$a = (e, n)=>$c7b1ddb572c90b38$var$M(e, "name", {
        value: n,
        configurable: !0
    });
var $c7b1ddb572c90b38$export$3fce19fdf0c5de73 = false, $c7b1ddb572c90b38$export$dfe7f2fe52a04245 = $c7b1ddb572c90b38$var$a((e, n)=>(e = typeof e == "string" && e.startsWith("0x") ? parseInt(e) : e, Object.values($c7b1ddb572c90b38$export$2e8191f482a38ccd).includes(String(e)) ? e : e === "Binance-Chain-Tigris" ? "BNB" : n.filter((r)=>!!r.chainId).find((r)=>(r.chainId?.startsWith("0x") ? parseInt(r.chainId) : r.chainId) == e)?.name || null), "getBlockChainNameFromId"), $c7b1ddb572c90b38$export$d840d807f640aaf5 = $c7b1ddb572c90b38$var$a((e, n)=>n[e]?.chainId || null, "getBlockchainChainIdByName"), $c7b1ddb572c90b38$export$c44b02fb03dbac82 = $c7b1ddb572c90b38$var$a((e)=>$c7b1ddb572c90b38$require$Buffer.from(e).toString("hex"), "uint8ArrayToHex"), $c7b1ddb572c90b38$export$b80cfa133c9c182d = ((s)=>(s.DEFAULT = "default", s.META_MASK = "metamask", s.WALLET_CONNECT_2 = "wallet-connect-2", s.TRUST_WALLET = "trust-wallet", s.KEPLR = "keplr", s.PHANTOM = "phantom", s.BITGET = "bitget", s.TRON_LINK = "tron-link", s.COINBASE = "coinbase", s.XDEFI = "xdefi", s.CLOVER = "clover", s.ARGENTX = "argentx", s.FRONTIER = "frontier", s.COSMOSTATION = "cosmostation", s.COIN98 = "coin98", s.SAFEPAL = "safepal", s.SAFE = "safe", s.TOKEN_POCKET = "token-pocket", s.BRAVE = "brave", s.BRAAVOS = "braavos", s.MATH = "math", s.EXODUS = "exodus", s.OKX = "okx", s.HALO = "halo", s.LEAP = "leap", s.LEAP_COSMOS = "leap-cosmos", s.STATION = "station", s.ENKRYPT = "enkrypt", s.TAHO = "taho", s.MY_TON_WALLET = "mytonwallet", s))($c7b1ddb572c90b38$export$b80cfa133c9c182d || {}), $c7b1ddb572c90b38$export$2e8191f482a38ccd = ((o)=>(o.BTC = "BTC", o.BSC = "BSC", o.LTC = "LTC", o.THORCHAIN = "THOR", o.BCH = "BCH", o.BINANCE = "BNB", o.ETHEREUM = "ETH", o.POLYGON = "POLYGON", o.TERRA = "TERRA", o.POLKADOT = "", o.TRON = "TRON", o.DOGE = "DOGE", o.HARMONY = "HARMONY", o.AVAX_CCHAIN = "AVAX_CCHAIN", o.FANTOM = "FANTOM", o.MOONBEAM = "MOONBEAM", o.ARBITRUM = "ARBITRUM", o.BOBA = "BOBA", o.OPTIMISM = "OPTIMISM", o.FUSE = "FUSE", o.CRONOS = "CRONOS", o.SOLANA = "SOLANA", o.MOONRIVER = "MOONRIVER", o.GNOSIS = "GNOSIS", o.COSMOS = "COSMOS", o.OSMOSIS = "OSMOSIS", o.AXELAR = "AXELAR", o.MARS = "MARS", o.STRIDE = "STRIDE", o.MAYA = "MAYA", o.AKASH = "AKASH", o.IRIS = "IRIS", o.PERSISTENCE = "PERSISTENCE", o.SENTINEL = "SENTINEL", o.REGEN = "REGEN", o.CRYPTO_ORG = "CRYPTO_ORG", o.SIF = "SIF", o.CHIHUAHUA = "CHIHUAHUA", o.JUNO = "JUNO", o.KUJIRA = "KUJIRA", o.STARNAME = "STARNAME", o.COMDEX = "COMDEX", o.STARGAZE = "STARGAZE", o.DESMOS = "DESMOS", o.BITCANNA = "BITCANNA", o.SECRET = "SECRET", o.INJECTIVE = "INJECTIVE", o.LUMNETWORK = "LUMNETWORK", o.BANDCHAIN = "BANDCHAIN", o.EMONEY = "EMONEY", o.BITSONG = "BITSONG", o.KI = "KI", o.MEDIBLOC = "MEDIBLOC", o.KONSTELLATION = "KONSTELLATION", o.UMEE = "UMEE", o.STARKNET = "STARKNET", o.TON = "TON", o.Unknown = "Unkown", o))($c7b1ddb572c90b38$export$2e8191f482a38ccd || {}), $c7b1ddb572c90b38$export$7289d9aba3deaf99 = [
    "BTC",
    "LTC",
    "THOR",
    "BCH",
    "BNB",
    "MAYA",
    "DOGE"
], $c7b1ddb572c90b38$export$12e8aeb69ff35d9 = [
    "keplr",
    "cosmostation",
    "leap-cosmos"
], $c7b1ddb572c90b38$export$832fb1b437e459ec = "https://cosmos-rpc.polkachu.com";
function $c7b1ddb572c90b38$export$6c40052bed430212(e) {
    let n;
    if (e == null || typeof e != "object") return e;
    if (e instanceof Date) return n = new Date, n.setTime(e.getTime()), n;
    if (e instanceof Array) {
        n = [];
        for(let t = 0, r = e.length; t < r; t++)n[t] = $c7b1ddb572c90b38$export$6c40052bed430212(e[t]);
        return n;
    }
    if (e instanceof Object) {
        n = {};
        for(let t in e)Object.prototype.hasOwnProperty.call(e, t) && (n[t] = $c7b1ddb572c90b38$export$6c40052bed430212(e[t]));
        return n;
    }
    throw new Error("Unable to copy obj! Its type isn't supported.");
}
$c7b1ddb572c90b38$var$a($c7b1ddb572c90b38$export$6c40052bed430212, "deepCopy");
async function $c7b1ddb572c90b38$export$56ce9af15430dcbb(e, n, t) {
    let r = t[n];
    try {
        await e.request({
            method: "wallet_switchEthereumChain",
            params: [
                {
                    chainId: r?.chainId
                }
            ]
        });
    } catch (i) {
        let u = i;
        if (r) (u.code === 4902 || !u.code) && await e.request({
            method: "wallet_addEthereumChain",
            params: [
                r
            ]
        });
        else throw new Error(`It seems you don't have ${n} network on your wallet. Please add it manually.`);
        throw i;
    }
}
$c7b1ddb572c90b38$var$a($c7b1ddb572c90b38$export$56ce9af15430dcbb, "switchOrAddNetworkForMetamaskCompatibleWallets");
async function $c7b1ddb572c90b38$export$83e74882c5df8fe1(e, n) {
    let t = new Promise((r, i)=>{
        setTimeout(()=>{
            i("Timeout!");
        }, n);
    });
    return Promise.race([
        e,
        t
    ]);
}
$c7b1ddb572c90b38$var$a($c7b1ddb572c90b38$export$83e74882c5df8fe1, "timeout");
var $c7b1ddb572c90b38$export$f0e13d51b5c692b6 = $c7b1ddb572c90b38$var$a((e)=>e.reduce((n, t)=>(n[t.name] = {
            chainName: t.info.chainName,
            chainId: t.chainId,
            nativeCurrency: t.info.nativeCurrency,
            rpcUrls: t.info.rpcUrls,
            blockExplorerUrls: t.info.blockExplorerUrls
        }, n), {}), "convertEvmBlockchainMetaToEvmChainInfo"), $c7b1ddb572c90b38$export$6965bcf5cb20b5b5 = $c7b1ddb572c90b38$var$a((e)=>Object.fromEntries(new Map(Object.keys(e).map((n)=>{
        let t = e[n];
        return t ? [
            parseInt(t.chainId),
            t.rpcUrls[0]
        ] : [
            0,
            ""
        ];
    }))), "evmChainsToRpcMap"), $c7b1ddb572c90b38$export$a009f0f0c363aa6c = $c7b1ddb572c90b38$var$a(async ({ instance: e })=>({
        accounts: [
            (await e.connect()).publicKey.toString()
        ],
        chainId: "SOLANA"
    }), "getSolanaAccounts");
function $c7b1ddb572c90b38$export$bc1a75e20816804a(e = "coinbase") {
    let { ethereum: n, coinbaseSolana: t } = window, r = new Map;
    if (n) {
        let i = e === "metamask" ? "isMetaMask" : "isCoinbaseWallet";
        if (e === "coinbase" && n[i]) r.set("ETH", n);
        else if (n.providers?.length) {
            let u = n.providers.find((c)=>c[i]);
            r.set("ETH", u);
        }
    }
    return t && e === "coinbase" && r.set("SOLANA", t), r.size === 0 ? null : e === "metamask" ? r.get("ETH") : r;
}
$c7b1ddb572c90b38$var$a($c7b1ddb572c90b38$export$bc1a75e20816804a, "getCoinbaseInstance");
function $c7b1ddb572c90b38$export$83c5a315dd1cff42(e) {
    return e.sort((n, t)=>Number(t.connected) - Number(n.connected) || Number(t.extensionAvailable) - Number(n.extensionAvailable));
}
$c7b1ddb572c90b38$var$a($c7b1ddb572c90b38$export$83c5a315dd1cff42, "sortWalletsBasedOnState");
function $c7b1ddb572c90b38$var$x() {
    let e = !1, n = navigator;
    return n.brave && n.brave.isBrave && n.brave.isBrave().then((t)=>{
        t && (e = !0);
    }), e;
}
$c7b1ddb572c90b38$var$a($c7b1ddb572c90b38$var$x, "isBrave");
function $c7b1ddb572c90b38$export$fd0008baca2bf83d(e) {
    if (typeof e != "object") return e;
    let n;
    return $c7b1ddb572c90b38$var$x() ? n = e.BRAVE : navigator.userAgent?.toLowerCase().indexOf("chrome") !== -1 ? n = e.CHROME : navigator.userAgent?.toLowerCase().indexOf("firefox") !== -1 ? n = e.FIREFOX : navigator.userAgent?.toLowerCase().indexOf("edge") !== -1 && (n = e.EDGE), n || e.DEFAULT;
}
$c7b1ddb572c90b38$var$a($c7b1ddb572c90b38$export$fd0008baca2bf83d, "detectInstallLink");
function $c7b1ddb572c90b38$export$486f06d416851c61() {
    return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
}
$c7b1ddb572c90b38$var$a($c7b1ddb572c90b38$export$486f06d416851c61, "detectMobileScreens");
function $c7b1ddb572c90b38$export$7925cdcd51d3102(e) {
    let t = (e?.split(":")[0] || "").split("-"), r = t[t.length - 1], i = t.slice(0, -1);
    return i[i.length - 1] === r && i.pop(), [
        i.join("-"),
        r
    ];
}
$c7b1ddb572c90b38$var$a($c7b1ddb572c90b38$export$7925cdcd51d3102, "splitWalletNetwork");
async function $c7b1ddb572c90b38$export$785cd5e95d0717c1(e) {
    let [n, t] = await Promise.all([
        e.request({
            method: "eth_requestAccounts"
        }),
        e.request({
            method: "eth_chainId"
        })
    ]);
    return {
        accounts: n,
        chainId: t
    };
}
$c7b1ddb572c90b38$var$a($c7b1ddb572c90b38$export$785cd5e95d0717c1, "getEvmAccounts");
var $c7b1ddb572c90b38$export$dae4ecb17c5c4020 = $c7b1ddb572c90b38$var$a(({ instance: e, state: n, updateChainId: t, updateAccounts: r })=>{
    let i = $c7b1ddb572c90b38$var$a((l)=>{
        n.connected && r(l);
    }, "handleAccountsChanged"), u = $c7b1ddb572c90b38$var$a((l)=>{
        t(l);
    }, "handleChainChanged");
    return e?.on("accountsChanged", i), e?.on("chainChanged", u), $c7b1ddb572c90b38$var$a(()=>{
        e?.off("accountsChanged", i), e?.off("chainChanged", u);
    }, "cleanup");
}, "subscribeToEvm"), $c7b1ddb572c90b38$export$4e65aae37dd4fc2c = $c7b1ddb572c90b38$var$a(async ({ instance: e })=>{
    try {
        return !!(await e.request({
            method: "eth_accounts"
        })).length;
    } catch  {
        return !1;
    }
}, "canEagerlyConnectToEvm"), $c7b1ddb572c90b38$export$394219efce660c44 = $c7b1ddb572c90b38$var$a(async ({ instance: e, network: n, meta: t })=>{
    let r = t.filter((0, $cd8bb37a306c2b01$export$9d749b8b357dfab2)), i = $c7b1ddb572c90b38$export$2029b78bc980a576(e, "ETH");
    await $c7b1ddb572c90b38$export$56ce9af15430dcbb(i, n, $c7b1ddb572c90b38$export$f0e13d51b5c692b6(r));
}, "switchNetworkForEvm"), $c7b1ddb572c90b38$export$86abff8ce014c125 = $c7b1ddb572c90b38$var$a(({ network: e, meta: n })=>$c7b1ddb572c90b38$export$9c76cdd331bb450e(n).includes(e), "canSwitchNetworkToEvm");
function $c7b1ddb572c90b38$export$9c76cdd331bb450e(e) {
    return e.filter((0, $cd8bb37a306c2b01$export$9d749b8b357dfab2)).map((n)=>n.name);
}
$c7b1ddb572c90b38$var$a($c7b1ddb572c90b38$export$9c76cdd331bb450e, "evmNetworkNames");
function $c7b1ddb572c90b38$export$d1cfcb1ce8ae2e4e(e, n) {
    return e && $c7b1ddb572c90b38$export$9c76cdd331bb450e(n).includes(e) ? "ETH" : null;
}
$c7b1ddb572c90b38$var$a($c7b1ddb572c90b38$export$d1cfcb1ce8ae2e4e, "getEthChainsInstance");
function $c7b1ddb572c90b38$var$T(e, n) {
    return e ? $c7b1ddb572c90b38$export$9c76cdd331bb450e(n).includes(e) : !1;
}
$c7b1ddb572c90b38$var$a($c7b1ddb572c90b38$var$T, "isEvmNetwork");
function $c7b1ddb572c90b38$export$b1eab42bc9b6c7a3(e, n, t) {
    t = t || "ETH";
    let r = $c7b1ddb572c90b38$var$T(t, n) ? $c7b1ddb572c90b38$export$d1cfcb1ce8ae2e4e(t, n) : t;
    return e && r ? e.get(r) : null;
}
$c7b1ddb572c90b38$var$a($c7b1ddb572c90b38$export$b1eab42bc9b6c7a3, "chooseInstance");
function $c7b1ddb572c90b38$export$2029b78bc980a576(e, n) {
    return e.size ? e.get(n) : e;
}
$c7b1ddb572c90b38$var$a($c7b1ddb572c90b38$export$2029b78bc980a576, "getNetworkInstance");
function $c7b1ddb572c90b38$export$2515b173249f2353(e, n) {
    return n && e[n] ? e[n].size ? e[n].get("ETH") : e[n] : null;
}
$c7b1ddb572c90b38$var$a($c7b1ddb572c90b38$export$2515b173249f2353, "getEvmProvider");
var $c7b1ddb572c90b38$var$R = $c7b1ddb572c90b38$var$a((e)=>e.filter((n)=>!n.info?.experimental).map((n)=>n.chainId).filter((n)=>!!n), "getCosmosMainChainsIds"), $c7b1ddb572c90b38$var$v = $c7b1ddb572c90b38$var$a((e)=>e.filter((n)=>n.info?.experimental).map((n)=>n.chainId).filter((n)=>!!n), "getCosmosMiscChainsIds"), $c7b1ddb572c90b38$export$9a5d8b9457d52deb = $c7b1ddb572c90b38$var$a((e)=>e.filter((n)=>!!n.info).filter((n)=>!!n.chainId).reduce((n, t)=>{
        let r = $c7b1ddb572c90b38$export$6c40052bed430212(t.info);
        r.stakeCurrency.coinImageUrl = window.location.origin + r.stakeCurrency.coinImageUrl, r.currencies = r.currencies.map((c)=>({
                ...c,
                coinImageUrl: window.location.origin + c.coinImageUrl
            })), r.feeCurrencies = r.feeCurrencies.map((c)=>({
                ...c,
                coinImageUrl: window.location.origin + c.coinImageUrl
            })), r.gasPriceStep || delete r.gasPriceStep;
        let { experimental: i, ...u } = r;
        return n[t.name] = {
            id: t.chainId,
            info: {
                ...u,
                chainId: t.chainId
            },
            experimental: i
        }, n;
    }, {}), "getCosmosExperimentalChainInfo");
async function $c7b1ddb572c90b38$var$P({ desiredChainIds: e, instance: n }) {
    let t = e.map((c)=>({
            signer: n.getOfflineSigner(c),
            chainId: c
        })).filter(Boolean), r = t.map(({ signer: c })=>c.getAccounts()), i = await Promise.allSettled(r), u = [];
    return i.forEach((c, l)=>{
        if (c.status !== "fulfilled") return;
        let m = c.value, { chainId: E } = t[l], h = m.map((C)=>C.address);
        u.push({
            accounts: h,
            chainId: E
        });
    }), u;
}
$c7b1ddb572c90b38$var$a($c7b1ddb572c90b38$var$P, "getMainAccounts");
async function $c7b1ddb572c90b38$var$b({ excludedChain: e, instance: n, meta: t }) {
    let r = $c7b1ddb572c90b38$var$v(t).filter((l)=>l !== e).map((l)=>({
            signer: n.getOfflineSigner(l),
            chainId: l
        })), i = r.map(async ({ signer: l })=>l.getAccounts()), u = await Promise.allSettled(i), c = [];
    return u.forEach((l, m)=>{
        if (l.status !== "fulfilled") return;
        let E = l.value, { chainId: h } = r[m], C = E.map((S)=>S.address);
        c.push({
            accounts: C,
            chainId: h
        });
    }), c;
}
$c7b1ddb572c90b38$var$a($c7b1ddb572c90b38$var$b, "tryRequestMiscAccounts");
var $c7b1ddb572c90b38$export$d4d8333f992ebe8c = $c7b1ddb572c90b38$var$a(async ({ instance: e, network: n, meta: t })=>{
    let r = n ? $c7b1ddb572c90b38$export$9a5d8b9457d52deb(t)[n] : null;
    if (n && !r) throw new Error(`You need to add ${n} to "COSMOS_EXPERIMENTAL_CHAINS_INFO" first.`);
    r && await e.experimentalSuggestChain(r.info);
    let i = $c7b1ddb572c90b38$var$R(t);
    r && i.push(r.id), i = Array.from(new Set(i)).filter(Boolean), await e.enable(i);
    let u = await $c7b1ddb572c90b38$var$P({
        desiredChainIds: i,
        instance: e
    }), c = r ? r.id : void 0, l = c ? await $c7b1ddb572c90b38$var$b({
        instance: e,
        meta: t,
        excludedChain: c
    }) : [];
    return [
        ...u,
        ...l
    ];
}, "getCosmosAccounts"), $c7b1ddb572c90b38$export$d873bd134feb393 = $c7b1ddb572c90b38$var$a(async (e)=>{
    let { instance: n, meta: t, network: r } = e, i = r ? $c7b1ddb572c90b38$export$9a5d8b9457d52deb(t)[r] : null;
    if (!i) throw new Error(`You need to add ${r} to "COSMOS_EXPERIMENTAL_CHAINS_INFO" first.`);
    await n.experimentalSuggestChain(i.info);
}, "suggestCosmosChain");



var $6b2231007a47a4de$exports = {};

$parcel$export($6b2231007a47a4de$exports, "getDefaultProvider", function () { return $6b2231007a47a4de$export$4f77a1d3c1ac6642; });
$parcel$export($6b2231007a47a4de$exports, "Provider", function () { return $9f78b76a8aa61745$exports.Provider; });
$parcel$export($6b2231007a47a4de$exports, "BaseProvider", function () { return $fa2219aa02c3e62e$exports.BaseProvider; });
$parcel$export($6b2231007a47a4de$exports, "Resolver", function () { return $fa2219aa02c3e62e$exports.Resolver; });
$parcel$export($6b2231007a47a4de$exports, "UrlJsonRpcProvider", function () { return $94a45602d091e5d2$exports.UrlJsonRpcProvider; });
$parcel$export($6b2231007a47a4de$exports, "FallbackProvider", function () { return $679b99176172981c$exports.FallbackProvider; });
$parcel$export($6b2231007a47a4de$exports, "AlchemyProvider", function () { return $5142047284b3daba$export$999cc40da3fbc6f; });
$parcel$export($6b2231007a47a4de$exports, "AlchemyWebSocketProvider", function () { return $5142047284b3daba$export$f6c13301c7b76371; });
$parcel$export($6b2231007a47a4de$exports, "AnkrProvider", function () { return $27dd6519e1beec55$export$72783b2aefa72a45; });
$parcel$export($6b2231007a47a4de$exports, "CloudflareProvider", function () { return $819ad3a08ca08517$exports.CloudflareProvider; });
$parcel$export($6b2231007a47a4de$exports, "EtherscanProvider", function () { return $dce3608ad1ddcc3f$exports.EtherscanProvider; });
$parcel$export($6b2231007a47a4de$exports, "InfuraProvider", function () { return $2f517ba1fc7b9c0f$export$60ff1a559b5c6ebd; });
$parcel$export($6b2231007a47a4de$exports, "InfuraWebSocketProvider", function () { return $2f517ba1fc7b9c0f$export$dd168a807d60da4f; });
$parcel$export($6b2231007a47a4de$exports, "JsonRpcProvider", function () { return $9609e75996f2bd40$exports.JsonRpcProvider; });
$parcel$export($6b2231007a47a4de$exports, "JsonRpcBatchProvider", function () { return $0e9822498cccaf3d$export$5a16092bf20edf97; });
$parcel$export($6b2231007a47a4de$exports, "NodesmithProvider", function () { return $5698d1b59ff58cae$export$8235cbce3ce273bd; });
$parcel$export($6b2231007a47a4de$exports, "PocketProvider", function () { return $329bf708d9366864$export$58bb47e42f6b092e; });
$parcel$export($6b2231007a47a4de$exports, "StaticJsonRpcProvider", function () { return $94a45602d091e5d2$exports.StaticJsonRpcProvider; });
$parcel$export($6b2231007a47a4de$exports, "Web3Provider", function () { return $ea752ed8b721343a$export$d05096c9fd9d936d; });
$parcel$export($6b2231007a47a4de$exports, "WebSocketProvider", function () { return $d1a04efa16266f30$exports.WebSocketProvider; });
$parcel$export($6b2231007a47a4de$exports, "IpcProvider", function () { return $f8338370fa8a55b7$export$fbe151f90a1ece01; });
$parcel$export($6b2231007a47a4de$exports, "JsonRpcSigner", function () { return $9609e75996f2bd40$exports.JsonRpcSigner; });
$parcel$export($6b2231007a47a4de$exports, "getNetwork", function () { return $e6278266fc0cd090$export$7de4970ebfd8206d; });
$parcel$export($6b2231007a47a4de$exports, "isCommunityResource", function () { return $23494291de5f329b$export$d93d5f61c2498b6; });
$parcel$export($6b2231007a47a4de$exports, "isCommunityResourcable", function () { return $23494291de5f329b$export$3091239f5b20b896; });
$parcel$export($6b2231007a47a4de$exports, "showThrottleMessage", function () { return $23494291de5f329b$export$4c41bd49e82e82ab; });
$parcel$export($6b2231007a47a4de$exports, "Formatter", function () { return $23494291de5f329b$export$a06636add2a09fd8; });
var $9f78b76a8aa61745$exports = {};

$parcel$export($9f78b76a8aa61745$exports, "ForkEvent", function () { return $9f78b76a8aa61745$export$406ece1549ccd00e; });
$parcel$export($9f78b76a8aa61745$exports, "Provider", function () { return $9f78b76a8aa61745$export$2881499e37b75b9a; });

var $iA132 = parcelRequire("iA132");
const $2d777fddba578925$export$83d89fbfd8236492 = "logger/5.7.0";


"use strict";
let $5f596c9584f643ae$var$_permanentCensorErrors = false;
let $5f596c9584f643ae$var$_censorErrors = false;
const $5f596c9584f643ae$var$LogLevels = {
    debug: 1,
    "default": 2,
    info: 2,
    warning: 3,
    error: 4,
    off: 5
};
let $5f596c9584f643ae$var$_logLevel = $5f596c9584f643ae$var$LogLevels["default"];
let $5f596c9584f643ae$var$_globalLogger = null;
function $5f596c9584f643ae$var$_checkNormalize() {
    try {
        const missing = [];
        // Make sure all forms of normalization are supported
        [
            "NFD",
            "NFC",
            "NFKD",
            "NFKC"
        ].forEach((form)=>{
            try {
                if ("test".normalize(form) !== "test") throw new Error("bad normalize");
            } catch (error) {
                missing.push(form);
            }
        });
        if (missing.length) throw new Error("missing " + missing.join(", "));
        if (String.fromCharCode(0xe9).normalize("NFD") !== String.fromCharCode(0x65, 0x0301)) throw new Error("broken implementation");
    } catch (error) {
        return error.message;
    }
    return null;
}
const $5f596c9584f643ae$var$_normalizeError = $5f596c9584f643ae$var$_checkNormalize();
var $5f596c9584f643ae$export$243e62d78d3b544d;
(function(LogLevel) {
    LogLevel["DEBUG"] = "DEBUG";
    LogLevel["INFO"] = "INFO";
    LogLevel["WARNING"] = "WARNING";
    LogLevel["ERROR"] = "ERROR";
    LogLevel["OFF"] = "OFF";
})($5f596c9584f643ae$export$243e62d78d3b544d || ($5f596c9584f643ae$export$243e62d78d3b544d = {}));
var $5f596c9584f643ae$export$d4e71bc0b80dc0fb;
(function(ErrorCode) {
    ///////////////////
    // Generic Errors
    // Unknown Error
    ErrorCode["UNKNOWN_ERROR"] = "UNKNOWN_ERROR";
    // Not Implemented
    ErrorCode["NOT_IMPLEMENTED"] = "NOT_IMPLEMENTED";
    // Unsupported Operation
    //   - operation
    ErrorCode["UNSUPPORTED_OPERATION"] = "UNSUPPORTED_OPERATION";
    // Network Error (i.e. Ethereum Network, such as an invalid chain ID)
    //   - event ("noNetwork" is not re-thrown in provider.ready; otherwise thrown)
    ErrorCode["NETWORK_ERROR"] = "NETWORK_ERROR";
    // Some sort of bad response from the server
    ErrorCode["SERVER_ERROR"] = "SERVER_ERROR";
    // Timeout
    ErrorCode["TIMEOUT"] = "TIMEOUT";
    ///////////////////
    // Operational  Errors
    // Buffer Overrun
    ErrorCode["BUFFER_OVERRUN"] = "BUFFER_OVERRUN";
    // Numeric Fault
    //   - operation: the operation being executed
    //   - fault: the reason this faulted
    ErrorCode["NUMERIC_FAULT"] = "NUMERIC_FAULT";
    ///////////////////
    // Argument Errors
    // Missing new operator to an object
    //  - name: The name of the class
    ErrorCode["MISSING_NEW"] = "MISSING_NEW";
    // Invalid argument (e.g. value is incompatible with type) to a function:
    //   - argument: The argument name that was invalid
    //   - value: The value of the argument
    ErrorCode["INVALID_ARGUMENT"] = "INVALID_ARGUMENT";
    // Missing argument to a function:
    //   - count: The number of arguments received
    //   - expectedCount: The number of arguments expected
    ErrorCode["MISSING_ARGUMENT"] = "MISSING_ARGUMENT";
    // Too many arguments
    //   - count: The number of arguments received
    //   - expectedCount: The number of arguments expected
    ErrorCode["UNEXPECTED_ARGUMENT"] = "UNEXPECTED_ARGUMENT";
    ///////////////////
    // Blockchain Errors
    // Call exception
    //  - transaction: the transaction
    //  - address?: the contract address
    //  - args?: The arguments passed into the function
    //  - method?: The Solidity method signature
    //  - errorSignature?: The EIP848 error signature
    //  - errorArgs?: The EIP848 error parameters
    //  - reason: The reason (only for EIP848 "Error(string)")
    ErrorCode["CALL_EXCEPTION"] = "CALL_EXCEPTION";
    // Insufficient funds (< value + gasLimit * gasPrice)
    //   - transaction: the transaction attempted
    ErrorCode["INSUFFICIENT_FUNDS"] = "INSUFFICIENT_FUNDS";
    // Nonce has already been used
    //   - transaction: the transaction attempted
    ErrorCode["NONCE_EXPIRED"] = "NONCE_EXPIRED";
    // The replacement fee for the transaction is too low
    //   - transaction: the transaction attempted
    ErrorCode["REPLACEMENT_UNDERPRICED"] = "REPLACEMENT_UNDERPRICED";
    // The gas limit could not be estimated
    //   - transaction: the transaction passed to estimateGas
    ErrorCode["UNPREDICTABLE_GAS_LIMIT"] = "UNPREDICTABLE_GAS_LIMIT";
    // The transaction was replaced by one with a higher gas price
    //   - reason: "cancelled", "replaced" or "repriced"
    //   - cancelled: true if reason == "cancelled" or reason == "replaced")
    //   - hash: original transaction hash
    //   - replacement: the full TransactionsResponse for the replacement
    //   - receipt: the receipt of the replacement
    ErrorCode["TRANSACTION_REPLACED"] = "TRANSACTION_REPLACED";
    ///////////////////
    // Interaction Errors
    // The user rejected the action, such as signing a message or sending
    // a transaction
    ErrorCode["ACTION_REJECTED"] = "ACTION_REJECTED";
})($5f596c9584f643ae$export$d4e71bc0b80dc0fb || ($5f596c9584f643ae$export$d4e71bc0b80dc0fb = {}));
const $5f596c9584f643ae$var$HEX = "0123456789abcdef";
class $5f596c9584f643ae$export$efa9a398d6368992 {
    constructor(version){
        Object.defineProperty(this, "version", {
            enumerable: true,
            value: version,
            writable: false
        });
    }
    _log(logLevel, args) {
        const level = logLevel.toLowerCase();
        if ($5f596c9584f643ae$var$LogLevels[level] == null) this.throwArgumentError("invalid log level name", "logLevel", logLevel);
        if ($5f596c9584f643ae$var$_logLevel > $5f596c9584f643ae$var$LogLevels[level]) return;
        console.log.apply(console, args);
    }
    debug(...args) {
        this._log($5f596c9584f643ae$export$efa9a398d6368992.levels.DEBUG, args);
    }
    info(...args) {
        this._log($5f596c9584f643ae$export$efa9a398d6368992.levels.INFO, args);
    }
    warn(...args) {
        this._log($5f596c9584f643ae$export$efa9a398d6368992.levels.WARNING, args);
    }
    makeError(message, code, params) {
        // Errors are being censored
        if ($5f596c9584f643ae$var$_censorErrors) return this.makeError("censored error", code, {});
        if (!code) code = $5f596c9584f643ae$export$efa9a398d6368992.errors.UNKNOWN_ERROR;
        if (!params) params = {};
        const messageDetails = [];
        Object.keys(params).forEach((key)=>{
            const value = params[key];
            try {
                if (value instanceof Uint8Array) {
                    let hex = "";
                    for(let i = 0; i < value.length; i++){
                        hex += $5f596c9584f643ae$var$HEX[value[i] >> 4];
                        hex += $5f596c9584f643ae$var$HEX[value[i] & 0x0f];
                    }
                    messageDetails.push(key + "=Uint8Array(0x" + hex + ")");
                } else messageDetails.push(key + "=" + JSON.stringify(value));
            } catch (error) {
                messageDetails.push(key + "=" + JSON.stringify(params[key].toString()));
            }
        });
        messageDetails.push(`code=${code}`);
        messageDetails.push(`version=${this.version}`);
        const reason = message;
        let url = "";
        switch(code){
            case $5f596c9584f643ae$export$d4e71bc0b80dc0fb.NUMERIC_FAULT:
                {
                    url = "NUMERIC_FAULT";
                    const fault = message;
                    switch(fault){
                        case "overflow":
                        case "underflow":
                        case "division-by-zero":
                            url += "-" + fault;
                            break;
                        case "negative-power":
                        case "negative-width":
                            url += "-unsupported";
                            break;
                        case "unbound-bitwise-result":
                            url += "-unbound-result";
                            break;
                    }
                    break;
                }
            case $5f596c9584f643ae$export$d4e71bc0b80dc0fb.CALL_EXCEPTION:
            case $5f596c9584f643ae$export$d4e71bc0b80dc0fb.INSUFFICIENT_FUNDS:
            case $5f596c9584f643ae$export$d4e71bc0b80dc0fb.MISSING_NEW:
            case $5f596c9584f643ae$export$d4e71bc0b80dc0fb.NONCE_EXPIRED:
            case $5f596c9584f643ae$export$d4e71bc0b80dc0fb.REPLACEMENT_UNDERPRICED:
            case $5f596c9584f643ae$export$d4e71bc0b80dc0fb.TRANSACTION_REPLACED:
            case $5f596c9584f643ae$export$d4e71bc0b80dc0fb.UNPREDICTABLE_GAS_LIMIT:
                url = code;
                break;
        }
        if (url) message += " [ See: https://links.ethers.org/v5-errors-" + url + " ]";
        if (messageDetails.length) message += " (" + messageDetails.join(", ") + ")";
        // @TODO: Any??
        const error = new Error(message);
        error.reason = reason;
        error.code = code;
        Object.keys(params).forEach(function(key) {
            error[key] = params[key];
        });
        return error;
    }
    throwError(message, code, params) {
        throw this.makeError(message, code, params);
    }
    throwArgumentError(message, name, value) {
        return this.throwError(message, $5f596c9584f643ae$export$efa9a398d6368992.errors.INVALID_ARGUMENT, {
            argument: name,
            value: value
        });
    }
    assert(condition, message, code, params) {
        if (!!condition) return;
        this.throwError(message, code, params);
    }
    assertArgument(condition, message, name, value) {
        if (!!condition) return;
        this.throwArgumentError(message, name, value);
    }
    checkNormalize(message) {
        if (message == null) message = "platform missing String.prototype.normalize";
        if ($5f596c9584f643ae$var$_normalizeError) this.throwError("platform missing String.prototype.normalize", $5f596c9584f643ae$export$efa9a398d6368992.errors.UNSUPPORTED_OPERATION, {
            operation: "String.prototype.normalize",
            form: $5f596c9584f643ae$var$_normalizeError
        });
    }
    checkSafeUint53(value, message) {
        if (typeof value !== "number") return;
        if (message == null) message = "value not safe";
        if (value < 0 || value >= 0x1fffffffffffff) this.throwError(message, $5f596c9584f643ae$export$efa9a398d6368992.errors.NUMERIC_FAULT, {
            operation: "checkSafeInteger",
            fault: "out-of-safe-range",
            value: value
        });
        if (value % 1) this.throwError(message, $5f596c9584f643ae$export$efa9a398d6368992.errors.NUMERIC_FAULT, {
            operation: "checkSafeInteger",
            fault: "non-integer",
            value: value
        });
    }
    checkArgumentCount(count, expectedCount, message) {
        if (message) message = ": " + message;
        else message = "";
        if (count < expectedCount) this.throwError("missing argument" + message, $5f596c9584f643ae$export$efa9a398d6368992.errors.MISSING_ARGUMENT, {
            count: count,
            expectedCount: expectedCount
        });
        if (count > expectedCount) this.throwError("too many arguments" + message, $5f596c9584f643ae$export$efa9a398d6368992.errors.UNEXPECTED_ARGUMENT, {
            count: count,
            expectedCount: expectedCount
        });
    }
    checkNew(target, kind) {
        if (target === Object || target == null) this.throwError("missing new", $5f596c9584f643ae$export$efa9a398d6368992.errors.MISSING_NEW, {
            name: kind.name
        });
    }
    checkAbstract(target, kind) {
        if (target === kind) this.throwError("cannot instantiate abstract class " + JSON.stringify(kind.name) + " directly; use a sub-class", $5f596c9584f643ae$export$efa9a398d6368992.errors.UNSUPPORTED_OPERATION, {
            name: target.name,
            operation: "new"
        });
        else if (target === Object || target == null) this.throwError("missing new", $5f596c9584f643ae$export$efa9a398d6368992.errors.MISSING_NEW, {
            name: kind.name
        });
    }
    static globalLogger() {
        if (!$5f596c9584f643ae$var$_globalLogger) $5f596c9584f643ae$var$_globalLogger = new $5f596c9584f643ae$export$efa9a398d6368992((0, $2d777fddba578925$export$83d89fbfd8236492));
        return $5f596c9584f643ae$var$_globalLogger;
    }
    static setCensorship(censorship, permanent) {
        if (!censorship && permanent) this.globalLogger().throwError("cannot permanently disable censorship", $5f596c9584f643ae$export$efa9a398d6368992.errors.UNSUPPORTED_OPERATION, {
            operation: "setCensorship"
        });
        if ($5f596c9584f643ae$var$_permanentCensorErrors) {
            if (!censorship) return;
            this.globalLogger().throwError("error censorship permanent", $5f596c9584f643ae$export$efa9a398d6368992.errors.UNSUPPORTED_OPERATION, {
                operation: "setCensorship"
            });
        }
        $5f596c9584f643ae$var$_censorErrors = !!censorship;
        $5f596c9584f643ae$var$_permanentCensorErrors = !!permanent;
    }
    static setLogLevel(logLevel) {
        const level = $5f596c9584f643ae$var$LogLevels[logLevel.toLowerCase()];
        if (level == null) {
            $5f596c9584f643ae$export$efa9a398d6368992.globalLogger().warn("invalid log level - " + logLevel);
            return;
        }
        $5f596c9584f643ae$var$_logLevel = level;
    }
    static from(version) {
        return new $5f596c9584f643ae$export$efa9a398d6368992(version);
    }
}
$5f596c9584f643ae$export$efa9a398d6368992.errors = $5f596c9584f643ae$export$d4e71bc0b80dc0fb;
$5f596c9584f643ae$export$efa9a398d6368992.levels = $5f596c9584f643ae$export$243e62d78d3b544d;


const $e1816841dbe8857e$export$83d89fbfd8236492 = "bytes/5.7.0";


"use strict";
const $06d75ae17ce69367$var$logger = new (0, $5f596c9584f643ae$export$efa9a398d6368992)((0, $e1816841dbe8857e$export$83d89fbfd8236492));
///////////////////////////////
function $06d75ae17ce69367$var$isHexable(value) {
    return !!value.toHexString;
}
function $06d75ae17ce69367$var$addSlice(array) {
    if (array.slice) return array;
    array.slice = function() {
        const args = Array.prototype.slice.call(arguments);
        return $06d75ae17ce69367$var$addSlice(new Uint8Array(Array.prototype.slice.apply(array, args)));
    };
    return array;
}
function $06d75ae17ce69367$export$9a14abb1a440cd5e(value) {
    return $06d75ae17ce69367$export$b02a40aff8e4ad18(value) && !(value.length % 2) || $06d75ae17ce69367$export$c6fabfbfd097fc30(value);
}
function $06d75ae17ce69367$var$isInteger(value) {
    return typeof value === "number" && value == value && value % 1 === 0;
}
function $06d75ae17ce69367$export$c6fabfbfd097fc30(value) {
    if (value == null) return false;
    if (value.constructor === Uint8Array) return true;
    if (typeof value === "string") return false;
    if (!$06d75ae17ce69367$var$isInteger(value.length) || value.length < 0) return false;
    for(let i = 0; i < value.length; i++){
        const v = value[i];
        if (!$06d75ae17ce69367$var$isInteger(v) || v < 0 || v >= 256) return false;
    }
    return true;
}
function $06d75ae17ce69367$export$3131421a7d01b4fb(value, options) {
    if (!options) options = {};
    if (typeof value === "number") {
        $06d75ae17ce69367$var$logger.checkSafeUint53(value, "invalid arrayify value");
        const result = [];
        while(value){
            result.unshift(value & 0xff);
            value = parseInt(String(value / 256));
        }
        if (result.length === 0) result.push(0);
        return $06d75ae17ce69367$var$addSlice(new Uint8Array(result));
    }
    if (options.allowMissingPrefix && typeof value === "string" && value.substring(0, 2) !== "0x") value = "0x" + value;
    if ($06d75ae17ce69367$var$isHexable(value)) value = value.toHexString();
    if ($06d75ae17ce69367$export$b02a40aff8e4ad18(value)) {
        let hex = value.substring(2);
        if (hex.length % 2) {
            if (options.hexPad === "left") hex = "0" + hex;
            else if (options.hexPad === "right") hex += "0";
            else $06d75ae17ce69367$var$logger.throwArgumentError("hex data is odd-length", "value", value);
        }
        const result = [];
        for(let i = 0; i < hex.length; i += 2)result.push(parseInt(hex.substring(i, i + 2), 16));
        return $06d75ae17ce69367$var$addSlice(new Uint8Array(result));
    }
    if ($06d75ae17ce69367$export$c6fabfbfd097fc30(value)) return $06d75ae17ce69367$var$addSlice(new Uint8Array(value));
    return $06d75ae17ce69367$var$logger.throwArgumentError("invalid arrayify value", "value", value);
}
function $06d75ae17ce69367$export$ee1b3e54f0441b22(items) {
    const objects = items.map((item)=>$06d75ae17ce69367$export$3131421a7d01b4fb(item));
    const length = objects.reduce((accum, item)=>accum + item.length, 0);
    const result = new Uint8Array(length);
    objects.reduce((offset, object)=>{
        result.set(object, offset);
        return offset + object.length;
    }, 0);
    return $06d75ae17ce69367$var$addSlice(result);
}
function $06d75ae17ce69367$export$a8f4574d0e56446c(value) {
    let result = $06d75ae17ce69367$export$3131421a7d01b4fb(value);
    if (result.length === 0) return result;
    // Find the first non-zero entry
    let start = 0;
    while(start < result.length && result[start] === 0)start++;
    // If we started with zeros, strip them
    if (start) result = result.slice(start);
    return result;
}
function $06d75ae17ce69367$export$3cdc770bf8b2ed3d(value, length) {
    value = $06d75ae17ce69367$export$3131421a7d01b4fb(value);
    if (value.length > length) $06d75ae17ce69367$var$logger.throwArgumentError("value out of range", "value", arguments[0]);
    const result = new Uint8Array(length);
    result.set(value, length - value.length);
    return $06d75ae17ce69367$var$addSlice(result);
}
function $06d75ae17ce69367$export$b02a40aff8e4ad18(value, length) {
    if (typeof value !== "string" || !value.match(/^0x[0-9A-Fa-f]*$/)) return false;
    if (length && value.length !== 2 + 2 * length) return false;
    return true;
}
const $06d75ae17ce69367$var$HexCharacters = "0123456789abcdef";
function $06d75ae17ce69367$export$2b0d6b5fbe698c70(value, options) {
    if (!options) options = {};
    if (typeof value === "number") {
        $06d75ae17ce69367$var$logger.checkSafeUint53(value, "invalid hexlify value");
        let hex = "";
        while(value){
            hex = $06d75ae17ce69367$var$HexCharacters[value & 0xf] + hex;
            value = Math.floor(value / 16);
        }
        if (hex.length) {
            if (hex.length % 2) hex = "0" + hex;
            return "0x" + hex;
        }
        return "0x00";
    }
    if (typeof value === "bigint") {
        value = value.toString(16);
        if (value.length % 2) return "0x0" + value;
        return "0x" + value;
    }
    if (options.allowMissingPrefix && typeof value === "string" && value.substring(0, 2) !== "0x") value = "0x" + value;
    if ($06d75ae17ce69367$var$isHexable(value)) return value.toHexString();
    if ($06d75ae17ce69367$export$b02a40aff8e4ad18(value)) {
        if (value.length % 2) {
            if (options.hexPad === "left") value = "0x0" + value.substring(2);
            else if (options.hexPad === "right") value += "0";
            else $06d75ae17ce69367$var$logger.throwArgumentError("hex data is odd-length", "value", value);
        }
        return value.toLowerCase();
    }
    if ($06d75ae17ce69367$export$c6fabfbfd097fc30(value)) {
        let result = "0x";
        for(let i = 0; i < value.length; i++){
            let v = value[i];
            result += $06d75ae17ce69367$var$HexCharacters[(v & 0xf0) >> 4] + $06d75ae17ce69367$var$HexCharacters[v & 0x0f];
        }
        return result;
    }
    return $06d75ae17ce69367$var$logger.throwArgumentError("invalid hexlify value", "value", value);
}
function $06d75ae17ce69367$export$13882f896d3c0683(data) {
    if (typeof data !== "string") data = $06d75ae17ce69367$export$2b0d6b5fbe698c70(data);
    else if (!$06d75ae17ce69367$export$b02a40aff8e4ad18(data) || data.length % 2) return null;
    return (data.length - 2) / 2;
}
function $06d75ae17ce69367$export$15da666eba198c18(data, offset, endOffset) {
    if (typeof data !== "string") data = $06d75ae17ce69367$export$2b0d6b5fbe698c70(data);
    else if (!$06d75ae17ce69367$export$b02a40aff8e4ad18(data) || data.length % 2) $06d75ae17ce69367$var$logger.throwArgumentError("invalid hexData", "value", data);
    offset = 2 + 2 * offset;
    if (endOffset != null) return "0x" + data.substring(offset, 2 + 2 * endOffset);
    return "0x" + data.substring(offset);
}
function $06d75ae17ce69367$export$6d4b99629b38754a(items) {
    let result = "0x";
    items.forEach((item)=>{
        result += $06d75ae17ce69367$export$2b0d6b5fbe698c70(item).substring(2);
    });
    return result;
}
function $06d75ae17ce69367$export$6916af760a341dd3(value) {
    const trimmed = $06d75ae17ce69367$export$967bc0082a978949($06d75ae17ce69367$export$2b0d6b5fbe698c70(value, {
        hexPad: "left"
    }));
    if (trimmed === "0x") return "0x0";
    return trimmed;
}
function $06d75ae17ce69367$export$967bc0082a978949(value) {
    if (typeof value !== "string") value = $06d75ae17ce69367$export$2b0d6b5fbe698c70(value);
    if (!$06d75ae17ce69367$export$b02a40aff8e4ad18(value)) $06d75ae17ce69367$var$logger.throwArgumentError("invalid hex string", "value", value);
    value = value.substring(2);
    let offset = 0;
    while(offset < value.length && value[offset] === "0")offset++;
    return "0x" + value.substring(offset);
}
function $06d75ae17ce69367$export$e9c46a54370b47e8(value, length) {
    if (typeof value !== "string") value = $06d75ae17ce69367$export$2b0d6b5fbe698c70(value);
    else if (!$06d75ae17ce69367$export$b02a40aff8e4ad18(value)) $06d75ae17ce69367$var$logger.throwArgumentError("invalid hex string", "value", value);
    if (value.length > 2 * length + 2) $06d75ae17ce69367$var$logger.throwArgumentError("value out of range", "value", arguments[1]);
    while(value.length < 2 * length + 2)value = "0x0" + value.substring(2);
    return value;
}
function $06d75ae17ce69367$export$7fb170f1e457988f(signature) {
    const result = {
        r: "0x",
        s: "0x",
        _vs: "0x",
        recoveryParam: 0,
        v: 0,
        yParityAndS: "0x",
        compact: "0x"
    };
    if ($06d75ae17ce69367$export$9a14abb1a440cd5e(signature)) {
        let bytes = $06d75ae17ce69367$export$3131421a7d01b4fb(signature);
        // Get the r, s and v
        if (bytes.length === 64) {
            // EIP-2098; pull the v from the top bit of s and clear it
            result.v = 27 + (bytes[32] >> 7);
            bytes[32] &= 0x7f;
            result.r = $06d75ae17ce69367$export$2b0d6b5fbe698c70(bytes.slice(0, 32));
            result.s = $06d75ae17ce69367$export$2b0d6b5fbe698c70(bytes.slice(32, 64));
        } else if (bytes.length === 65) {
            result.r = $06d75ae17ce69367$export$2b0d6b5fbe698c70(bytes.slice(0, 32));
            result.s = $06d75ae17ce69367$export$2b0d6b5fbe698c70(bytes.slice(32, 64));
            result.v = bytes[64];
        } else $06d75ae17ce69367$var$logger.throwArgumentError("invalid signature string", "signature", signature);
        // Allow a recid to be used as the v
        if (result.v < 27) {
            if (result.v === 0 || result.v === 1) result.v += 27;
            else $06d75ae17ce69367$var$logger.throwArgumentError("signature invalid v byte", "signature", signature);
        }
        // Compute recoveryParam from v
        result.recoveryParam = 1 - result.v % 2;
        // Compute _vs from recoveryParam and s
        if (result.recoveryParam) bytes[32] |= 0x80;
        result._vs = $06d75ae17ce69367$export$2b0d6b5fbe698c70(bytes.slice(32, 64));
    } else {
        result.r = signature.r;
        result.s = signature.s;
        result.v = signature.v;
        result.recoveryParam = signature.recoveryParam;
        result._vs = signature._vs;
        // If the _vs is available, use it to populate missing s, v and recoveryParam
        // and verify non-missing s, v and recoveryParam
        if (result._vs != null) {
            const vs = $06d75ae17ce69367$export$3cdc770bf8b2ed3d($06d75ae17ce69367$export$3131421a7d01b4fb(result._vs), 32);
            result._vs = $06d75ae17ce69367$export$2b0d6b5fbe698c70(vs);
            // Set or check the recid
            const recoveryParam = vs[0] >= 128 ? 1 : 0;
            if (result.recoveryParam == null) result.recoveryParam = recoveryParam;
            else if (result.recoveryParam !== recoveryParam) $06d75ae17ce69367$var$logger.throwArgumentError("signature recoveryParam mismatch _vs", "signature", signature);
            // Set or check the s
            vs[0] &= 0x7f;
            const s = $06d75ae17ce69367$export$2b0d6b5fbe698c70(vs);
            if (result.s == null) result.s = s;
            else if (result.s !== s) $06d75ae17ce69367$var$logger.throwArgumentError("signature v mismatch _vs", "signature", signature);
        }
        // Use recid and v to populate each other
        if (result.recoveryParam == null) {
            if (result.v == null) $06d75ae17ce69367$var$logger.throwArgumentError("signature missing v and recoveryParam", "signature", signature);
            else if (result.v === 0 || result.v === 1) result.recoveryParam = result.v;
            else result.recoveryParam = 1 - result.v % 2;
        } else if (result.v == null) result.v = 27 + result.recoveryParam;
        else {
            const recId = result.v === 0 || result.v === 1 ? result.v : 1 - result.v % 2;
            if (result.recoveryParam !== recId) $06d75ae17ce69367$var$logger.throwArgumentError("signature recoveryParam mismatch v", "signature", signature);
        }
        if (result.r == null || !$06d75ae17ce69367$export$b02a40aff8e4ad18(result.r)) $06d75ae17ce69367$var$logger.throwArgumentError("signature missing or invalid r", "signature", signature);
        else result.r = $06d75ae17ce69367$export$e9c46a54370b47e8(result.r, 32);
        if (result.s == null || !$06d75ae17ce69367$export$b02a40aff8e4ad18(result.s)) $06d75ae17ce69367$var$logger.throwArgumentError("signature missing or invalid s", "signature", signature);
        else result.s = $06d75ae17ce69367$export$e9c46a54370b47e8(result.s, 32);
        const vs = $06d75ae17ce69367$export$3131421a7d01b4fb(result.s);
        if (vs[0] >= 128) $06d75ae17ce69367$var$logger.throwArgumentError("signature s out of range", "signature", signature);
        if (result.recoveryParam) vs[0] |= 0x80;
        const _vs = $06d75ae17ce69367$export$2b0d6b5fbe698c70(vs);
        if (result._vs) {
            if (!$06d75ae17ce69367$export$b02a40aff8e4ad18(result._vs)) $06d75ae17ce69367$var$logger.throwArgumentError("signature invalid _vs", "signature", signature);
            result._vs = $06d75ae17ce69367$export$e9c46a54370b47e8(result._vs, 32);
        }
        // Set or check the _vs
        if (result._vs == null) result._vs = _vs;
        else if (result._vs !== _vs) $06d75ae17ce69367$var$logger.throwArgumentError("signature _vs mismatch v and s", "signature", signature);
    }
    result.yParityAndS = result._vs;
    result.compact = result.r + result.yParityAndS.substring(2);
    return result;
}
function $06d75ae17ce69367$export$71bb9d78a59bbe25(signature) {
    signature = $06d75ae17ce69367$export$7fb170f1e457988f(signature);
    return $06d75ae17ce69367$export$2b0d6b5fbe698c70($06d75ae17ce69367$export$ee1b3e54f0441b22([
        signature.r,
        signature.s,
        signature.recoveryParam ? "0x1c" : "0x1b"
    ]));
}



const $d6c9c8115f7af803$export$83d89fbfd8236492 = "bignumber/5.7.0";


"use strict";
var $a87aa97415e1b917$var$BN = (0, (/*@__PURE__*/$parcel$interopDefault($iA132))).BN;
const $a87aa97415e1b917$var$logger = new (0, $5f596c9584f643ae$export$efa9a398d6368992)((0, $d6c9c8115f7af803$export$83d89fbfd8236492));
const $a87aa97415e1b917$var$_constructorGuard = {};
const $a87aa97415e1b917$var$MAX_SAFE = 0x1fffffffffffff;
function $a87aa97415e1b917$export$a3d0a7fa9b65683b(value) {
    return value != null && ($a87aa97415e1b917$export$d97aa349ed20696.isBigNumber(value) || typeof value === "number" && value % 1 === 0 || typeof value === "string" && !!value.match(/^-?[0-9]+$/) || (0, $06d75ae17ce69367$export$b02a40aff8e4ad18)(value) || typeof value === "bigint" || (0, $06d75ae17ce69367$export$c6fabfbfd097fc30)(value));
}
// Only warn about passing 10 into radix once
let $a87aa97415e1b917$var$_warnedToStringRadix = false;
class $a87aa97415e1b917$export$d97aa349ed20696 {
    constructor(constructorGuard, hex){
        if (constructorGuard !== $a87aa97415e1b917$var$_constructorGuard) $a87aa97415e1b917$var$logger.throwError("cannot call constructor directly; use BigNumber.from", (0, $5f596c9584f643ae$export$efa9a398d6368992).errors.UNSUPPORTED_OPERATION, {
            operation: "new (BigNumber)"
        });
        this._hex = hex;
        this._isBigNumber = true;
        Object.freeze(this);
    }
    fromTwos(value) {
        return $a87aa97415e1b917$var$toBigNumber($a87aa97415e1b917$var$toBN(this).fromTwos(value));
    }
    toTwos(value) {
        return $a87aa97415e1b917$var$toBigNumber($a87aa97415e1b917$var$toBN(this).toTwos(value));
    }
    abs() {
        if (this._hex[0] === "-") return $a87aa97415e1b917$export$d97aa349ed20696.from(this._hex.substring(1));
        return this;
    }
    add(other) {
        return $a87aa97415e1b917$var$toBigNumber($a87aa97415e1b917$var$toBN(this).add($a87aa97415e1b917$var$toBN(other)));
    }
    sub(other) {
        return $a87aa97415e1b917$var$toBigNumber($a87aa97415e1b917$var$toBN(this).sub($a87aa97415e1b917$var$toBN(other)));
    }
    div(other) {
        const o = $a87aa97415e1b917$export$d97aa349ed20696.from(other);
        if (o.isZero()) $a87aa97415e1b917$var$throwFault("division-by-zero", "div");
        return $a87aa97415e1b917$var$toBigNumber($a87aa97415e1b917$var$toBN(this).div($a87aa97415e1b917$var$toBN(other)));
    }
    mul(other) {
        return $a87aa97415e1b917$var$toBigNumber($a87aa97415e1b917$var$toBN(this).mul($a87aa97415e1b917$var$toBN(other)));
    }
    mod(other) {
        const value = $a87aa97415e1b917$var$toBN(other);
        if (value.isNeg()) $a87aa97415e1b917$var$throwFault("division-by-zero", "mod");
        return $a87aa97415e1b917$var$toBigNumber($a87aa97415e1b917$var$toBN(this).umod(value));
    }
    pow(other) {
        const value = $a87aa97415e1b917$var$toBN(other);
        if (value.isNeg()) $a87aa97415e1b917$var$throwFault("negative-power", "pow");
        return $a87aa97415e1b917$var$toBigNumber($a87aa97415e1b917$var$toBN(this).pow(value));
    }
    and(other) {
        const value = $a87aa97415e1b917$var$toBN(other);
        if (this.isNegative() || value.isNeg()) $a87aa97415e1b917$var$throwFault("unbound-bitwise-result", "and");
        return $a87aa97415e1b917$var$toBigNumber($a87aa97415e1b917$var$toBN(this).and(value));
    }
    or(other) {
        const value = $a87aa97415e1b917$var$toBN(other);
        if (this.isNegative() || value.isNeg()) $a87aa97415e1b917$var$throwFault("unbound-bitwise-result", "or");
        return $a87aa97415e1b917$var$toBigNumber($a87aa97415e1b917$var$toBN(this).or(value));
    }
    xor(other) {
        const value = $a87aa97415e1b917$var$toBN(other);
        if (this.isNegative() || value.isNeg()) $a87aa97415e1b917$var$throwFault("unbound-bitwise-result", "xor");
        return $a87aa97415e1b917$var$toBigNumber($a87aa97415e1b917$var$toBN(this).xor(value));
    }
    mask(value) {
        if (this.isNegative() || value < 0) $a87aa97415e1b917$var$throwFault("negative-width", "mask");
        return $a87aa97415e1b917$var$toBigNumber($a87aa97415e1b917$var$toBN(this).maskn(value));
    }
    shl(value) {
        if (this.isNegative() || value < 0) $a87aa97415e1b917$var$throwFault("negative-width", "shl");
        return $a87aa97415e1b917$var$toBigNumber($a87aa97415e1b917$var$toBN(this).shln(value));
    }
    shr(value) {
        if (this.isNegative() || value < 0) $a87aa97415e1b917$var$throwFault("negative-width", "shr");
        return $a87aa97415e1b917$var$toBigNumber($a87aa97415e1b917$var$toBN(this).shrn(value));
    }
    eq(other) {
        return $a87aa97415e1b917$var$toBN(this).eq($a87aa97415e1b917$var$toBN(other));
    }
    lt(other) {
        return $a87aa97415e1b917$var$toBN(this).lt($a87aa97415e1b917$var$toBN(other));
    }
    lte(other) {
        return $a87aa97415e1b917$var$toBN(this).lte($a87aa97415e1b917$var$toBN(other));
    }
    gt(other) {
        return $a87aa97415e1b917$var$toBN(this).gt($a87aa97415e1b917$var$toBN(other));
    }
    gte(other) {
        return $a87aa97415e1b917$var$toBN(this).gte($a87aa97415e1b917$var$toBN(other));
    }
    isNegative() {
        return this._hex[0] === "-";
    }
    isZero() {
        return $a87aa97415e1b917$var$toBN(this).isZero();
    }
    toNumber() {
        try {
            return $a87aa97415e1b917$var$toBN(this).toNumber();
        } catch (error) {
            $a87aa97415e1b917$var$throwFault("overflow", "toNumber", this.toString());
        }
        return null;
    }
    toBigInt() {
        try {
            return BigInt(this.toString());
        } catch (e) {}
        return $a87aa97415e1b917$var$logger.throwError("this platform does not support BigInt", (0, $5f596c9584f643ae$export$efa9a398d6368992).errors.UNSUPPORTED_OPERATION, {
            value: this.toString()
        });
    }
    toString() {
        // Lots of people expect this, which we do not support, so check (See: #889)
        if (arguments.length > 0) {
            if (arguments[0] === 10) {
                if (!$a87aa97415e1b917$var$_warnedToStringRadix) {
                    $a87aa97415e1b917$var$_warnedToStringRadix = true;
                    $a87aa97415e1b917$var$logger.warn("BigNumber.toString does not accept any parameters; base-10 is assumed");
                }
            } else if (arguments[0] === 16) $a87aa97415e1b917$var$logger.throwError("BigNumber.toString does not accept any parameters; use bigNumber.toHexString()", (0, $5f596c9584f643ae$export$efa9a398d6368992).errors.UNEXPECTED_ARGUMENT, {});
            else $a87aa97415e1b917$var$logger.throwError("BigNumber.toString does not accept parameters", (0, $5f596c9584f643ae$export$efa9a398d6368992).errors.UNEXPECTED_ARGUMENT, {});
        }
        return $a87aa97415e1b917$var$toBN(this).toString(10);
    }
    toHexString() {
        return this._hex;
    }
    toJSON(key) {
        return {
            type: "BigNumber",
            hex: this.toHexString()
        };
    }
    static from(value) {
        if (value instanceof $a87aa97415e1b917$export$d97aa349ed20696) return value;
        if (typeof value === "string") {
            if (value.match(/^-?0x[0-9a-f]+$/i)) return new $a87aa97415e1b917$export$d97aa349ed20696($a87aa97415e1b917$var$_constructorGuard, $a87aa97415e1b917$var$toHex(value));
            if (value.match(/^-?[0-9]+$/)) return new $a87aa97415e1b917$export$d97aa349ed20696($a87aa97415e1b917$var$_constructorGuard, $a87aa97415e1b917$var$toHex(new $a87aa97415e1b917$var$BN(value)));
            return $a87aa97415e1b917$var$logger.throwArgumentError("invalid BigNumber string", "value", value);
        }
        if (typeof value === "number") {
            if (value % 1) $a87aa97415e1b917$var$throwFault("underflow", "BigNumber.from", value);
            if (value >= $a87aa97415e1b917$var$MAX_SAFE || value <= -$a87aa97415e1b917$var$MAX_SAFE) $a87aa97415e1b917$var$throwFault("overflow", "BigNumber.from", value);
            return $a87aa97415e1b917$export$d97aa349ed20696.from(String(value));
        }
        const anyValue = value;
        if (typeof anyValue === "bigint") return $a87aa97415e1b917$export$d97aa349ed20696.from(anyValue.toString());
        if ((0, $06d75ae17ce69367$export$c6fabfbfd097fc30)(anyValue)) return $a87aa97415e1b917$export$d97aa349ed20696.from((0, $06d75ae17ce69367$export$2b0d6b5fbe698c70)(anyValue));
        if (anyValue) {
            // Hexable interface (takes priority)
            if (anyValue.toHexString) {
                const hex = anyValue.toHexString();
                if (typeof hex === "string") return $a87aa97415e1b917$export$d97aa349ed20696.from(hex);
            } else {
                // For now, handle legacy JSON-ified values (goes away in v6)
                let hex = anyValue._hex;
                // New-form JSON
                if (hex == null && anyValue.type === "BigNumber") hex = anyValue.hex;
                if (typeof hex === "string") {
                    if ((0, $06d75ae17ce69367$export$b02a40aff8e4ad18)(hex) || hex[0] === "-" && (0, $06d75ae17ce69367$export$b02a40aff8e4ad18)(hex.substring(1))) return $a87aa97415e1b917$export$d97aa349ed20696.from(hex);
                }
            }
        }
        return $a87aa97415e1b917$var$logger.throwArgumentError("invalid BigNumber value", "value", value);
    }
    static isBigNumber(value) {
        return !!(value && value._isBigNumber);
    }
}
// Normalize the hex string
function $a87aa97415e1b917$var$toHex(value) {
    // For BN, call on the hex string
    if (typeof value !== "string") return $a87aa97415e1b917$var$toHex(value.toString(16));
    // If negative, prepend the negative sign to the normalized positive value
    if (value[0] === "-") {
        // Strip off the negative sign
        value = value.substring(1);
        // Cannot have multiple negative signs (e.g. "--0x04")
        if (value[0] === "-") $a87aa97415e1b917$var$logger.throwArgumentError("invalid hex", "value", value);
        // Call toHex on the positive component
        value = $a87aa97415e1b917$var$toHex(value);
        // Do not allow "-0x00"
        if (value === "0x00") return value;
        // Negate the value
        return "-" + value;
    }
    // Add a "0x" prefix if missing
    if (value.substring(0, 2) !== "0x") value = "0x" + value;
    // Normalize zero
    if (value === "0x") return "0x00";
    // Make the string even length
    if (value.length % 2) value = "0x0" + value.substring(2);
    // Trim to smallest even-length string
    while(value.length > 4 && value.substring(0, 4) === "0x00")value = "0x" + value.substring(4);
    return value;
}
function $a87aa97415e1b917$var$toBigNumber(value) {
    return $a87aa97415e1b917$export$d97aa349ed20696.from($a87aa97415e1b917$var$toHex(value));
}
function $a87aa97415e1b917$var$toBN(value) {
    const hex = $a87aa97415e1b917$export$d97aa349ed20696.from(value).toHexString();
    if (hex[0] === "-") return new $a87aa97415e1b917$var$BN("-" + hex.substring(3), 16);
    return new $a87aa97415e1b917$var$BN(hex.substring(2), 16);
}
function $a87aa97415e1b917$var$throwFault(fault, operation, value) {
    const params = {
        fault: fault,
        operation: operation
    };
    if (value != null) params.value = value;
    return $a87aa97415e1b917$var$logger.throwError(fault, (0, $5f596c9584f643ae$export$efa9a398d6368992).errors.NUMERIC_FAULT, params);
}
function $a87aa97415e1b917$export$51e4a08295f7770f(value) {
    return new $a87aa97415e1b917$var$BN(value, 36).toString(16);
}
function $a87aa97415e1b917$export$1293db5d29c264ff(value) {
    return new $a87aa97415e1b917$var$BN(value, 16).toString(36);
}



var $d2d9b472f7878d5e$exports = {};

$parcel$export($d2d9b472f7878d5e$exports, "defineReadOnly", function () { return $d2d9b472f7878d5e$export$104236534534f9be; });
$parcel$export($d2d9b472f7878d5e$exports, "getStatic", function () { return $d2d9b472f7878d5e$export$f695fbbf3cdaaf47; });
$parcel$export($d2d9b472f7878d5e$exports, "resolveProperties", function () { return $d2d9b472f7878d5e$export$d503dd157d963b60; });
$parcel$export($d2d9b472f7878d5e$exports, "checkProperties", function () { return $d2d9b472f7878d5e$export$ae5a316ba623b73a; });
$parcel$export($d2d9b472f7878d5e$exports, "shallowCopy", function () { return $d2d9b472f7878d5e$export$9c13236873b118a5; });
$parcel$export($d2d9b472f7878d5e$exports, "deepCopy", function () { return $d2d9b472f7878d5e$export$6c40052bed430212; });
$parcel$export($d2d9b472f7878d5e$exports, "Description", function () { return $d2d9b472f7878d5e$export$393edc798c47379d; });

const $814fd87c70d37554$export$83d89fbfd8236492 = "properties/5.7.0";


"use strict";
var $d2d9b472f7878d5e$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
const $d2d9b472f7878d5e$var$logger = new (0, $5f596c9584f643ae$export$efa9a398d6368992)((0, $814fd87c70d37554$export$83d89fbfd8236492));
function $d2d9b472f7878d5e$export$104236534534f9be(object, name, value) {
    Object.defineProperty(object, name, {
        enumerable: true,
        value: value,
        writable: false
    });
}
function $d2d9b472f7878d5e$export$f695fbbf3cdaaf47(ctor, key) {
    for(let i = 0; i < 32; i++){
        if (ctor[key]) return ctor[key];
        if (!ctor.prototype || typeof ctor.prototype !== "object") break;
        ctor = Object.getPrototypeOf(ctor.prototype).constructor;
    }
    return null;
}
function $d2d9b472f7878d5e$export$d503dd157d963b60(object) {
    return $d2d9b472f7878d5e$var$__awaiter(this, void 0, void 0, function*() {
        const promises = Object.keys(object).map((key)=>{
            const value = object[key];
            return Promise.resolve(value).then((v)=>({
                    key: key,
                    value: v
                }));
        });
        const results = yield Promise.all(promises);
        return results.reduce((accum, result)=>{
            accum[result.key] = result.value;
            return accum;
        }, {});
    });
}
function $d2d9b472f7878d5e$export$ae5a316ba623b73a(object, properties) {
    if (!object || typeof object !== "object") $d2d9b472f7878d5e$var$logger.throwArgumentError("invalid object", "object", object);
    Object.keys(object).forEach((key)=>{
        if (!properties[key]) $d2d9b472f7878d5e$var$logger.throwArgumentError("invalid object key - " + key, "transaction:" + key, object);
    });
}
function $d2d9b472f7878d5e$export$9c13236873b118a5(object) {
    const result = {};
    for(const key in object)result[key] = object[key];
    return result;
}
const $d2d9b472f7878d5e$var$opaque = {
    bigint: true,
    boolean: true,
    "function": true,
    number: true,
    string: true
};
function $d2d9b472f7878d5e$var$_isFrozen(object) {
    // Opaque objects are not mutable, so safe to copy by assignment
    if (object === undefined || object === null || $d2d9b472f7878d5e$var$opaque[typeof object]) return true;
    if (Array.isArray(object) || typeof object === "object") {
        if (!Object.isFrozen(object)) return false;
        const keys = Object.keys(object);
        for(let i = 0; i < keys.length; i++){
            let value = null;
            try {
                value = object[keys[i]];
            } catch (error) {
                continue;
            }
            if (!$d2d9b472f7878d5e$var$_isFrozen(value)) return false;
        }
        return true;
    }
    return $d2d9b472f7878d5e$var$logger.throwArgumentError(`Cannot deepCopy ${typeof object}`, "object", object);
}
// Returns a new copy of object, such that no properties may be replaced.
// New properties may be added only to objects.
function $d2d9b472f7878d5e$var$_deepCopy(object) {
    if ($d2d9b472f7878d5e$var$_isFrozen(object)) return object;
    // Arrays are mutable, so we need to create a copy
    if (Array.isArray(object)) return Object.freeze(object.map((item)=>$d2d9b472f7878d5e$export$6c40052bed430212(item)));
    if (typeof object === "object") {
        const result = {};
        for(const key in object){
            const value = object[key];
            if (value === undefined) continue;
            $d2d9b472f7878d5e$export$104236534534f9be(result, key, $d2d9b472f7878d5e$export$6c40052bed430212(value));
        }
        return result;
    }
    return $d2d9b472f7878d5e$var$logger.throwArgumentError(`Cannot deepCopy ${typeof object}`, "object", object);
}
function $d2d9b472f7878d5e$export$6c40052bed430212(object) {
    return $d2d9b472f7878d5e$var$_deepCopy(object);
}
class $d2d9b472f7878d5e$export$393edc798c47379d {
    constructor(info){
        for(const key in info)this[key] = $d2d9b472f7878d5e$export$6c40052bed430212(info[key]);
    }
}



const $54c4d53839b76b1a$export$83d89fbfd8236492 = "abstract-provider/5.7.0";


"use strict";
var $9f78b76a8aa61745$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
const $9f78b76a8aa61745$var$logger = new (0, $5f596c9584f643ae$export$efa9a398d6368992)((0, $54c4d53839b76b1a$export$83d89fbfd8236492));
class $9f78b76a8aa61745$export$406ece1549ccd00e extends (0, $d2d9b472f7878d5e$exports.Description) {
    static isForkEvent(value) {
        return !!(value && value._isForkEvent);
    }
}
class $9f78b76a8aa61745$export$5b2cada8494f9d99 extends $9f78b76a8aa61745$export$406ece1549ccd00e {
    constructor(blockHash, expiry){
        if (!(0, $06d75ae17ce69367$export$b02a40aff8e4ad18)(blockHash, 32)) $9f78b76a8aa61745$var$logger.throwArgumentError("invalid blockHash", "blockHash", blockHash);
        super({
            _isForkEvent: true,
            _isBlockForkEvent: true,
            expiry: expiry || 0,
            blockHash: blockHash
        });
    }
}
class $9f78b76a8aa61745$export$26bcd61a55716c98 extends $9f78b76a8aa61745$export$406ece1549ccd00e {
    constructor(hash, expiry){
        if (!(0, $06d75ae17ce69367$export$b02a40aff8e4ad18)(hash, 32)) $9f78b76a8aa61745$var$logger.throwArgumentError("invalid transaction hash", "hash", hash);
        super({
            _isForkEvent: true,
            _isTransactionForkEvent: true,
            expiry: expiry || 0,
            hash: hash
        });
    }
}
class $9f78b76a8aa61745$export$8f8609bfee47c93 extends $9f78b76a8aa61745$export$406ece1549ccd00e {
    constructor(beforeHash, afterHash, expiry){
        if (!(0, $06d75ae17ce69367$export$b02a40aff8e4ad18)(beforeHash, 32)) $9f78b76a8aa61745$var$logger.throwArgumentError("invalid transaction hash", "beforeHash", beforeHash);
        if (!(0, $06d75ae17ce69367$export$b02a40aff8e4ad18)(afterHash, 32)) $9f78b76a8aa61745$var$logger.throwArgumentError("invalid transaction hash", "afterHash", afterHash);
        super({
            _isForkEvent: true,
            _isTransactionOrderForkEvent: true,
            expiry: expiry || 0,
            beforeHash: beforeHash,
            afterHash: afterHash
        });
    }
}
class $9f78b76a8aa61745$export$2881499e37b75b9a {
    constructor(){
        $9f78b76a8aa61745$var$logger.checkAbstract(new.target, $9f78b76a8aa61745$export$2881499e37b75b9a);
        (0, $d2d9b472f7878d5e$exports.defineReadOnly)(this, "_isProvider", true);
    }
    getFeeData() {
        return $9f78b76a8aa61745$var$__awaiter(this, void 0, void 0, function*() {
            const { block: block, gasPrice: gasPrice } = yield (0, $d2d9b472f7878d5e$exports.resolveProperties)({
                block: this.getBlock("latest"),
                gasPrice: this.getGasPrice().catch((error)=>{
                    // @TODO: Why is this now failing on Calaveras?
                    //console.log(error);
                    return null;
                })
            });
            let lastBaseFeePerGas = null, maxFeePerGas = null, maxPriorityFeePerGas = null;
            if (block && block.baseFeePerGas) {
                // We may want to compute this more accurately in the future,
                // using the formula "check if the base fee is correct".
                // See: https://eips.ethereum.org/EIPS/eip-1559
                lastBaseFeePerGas = block.baseFeePerGas;
                maxPriorityFeePerGas = (0, $a87aa97415e1b917$export$d97aa349ed20696).from("1500000000");
                maxFeePerGas = block.baseFeePerGas.mul(2).add(maxPriorityFeePerGas);
            }
            return {
                lastBaseFeePerGas: lastBaseFeePerGas,
                maxFeePerGas: maxFeePerGas,
                maxPriorityFeePerGas: maxPriorityFeePerGas,
                gasPrice: gasPrice
            };
        });
    }
    // Alias for "on"
    addListener(eventName, listener) {
        return this.on(eventName, listener);
    }
    // Alias for "off"
    removeListener(eventName, listener) {
        return this.off(eventName, listener);
    }
    static isProvider(value) {
        return !!(value && value._isProvider);
    }
}



const $a0a1786b004c6828$export$83d89fbfd8236492 = "networks/5.7.1";


"use strict";
const $e6278266fc0cd090$var$logger = new (0, $5f596c9584f643ae$export$efa9a398d6368992)((0, $a0a1786b004c6828$export$83d89fbfd8236492));
function $e6278266fc0cd090$var$isRenetworkable(value) {
    return value && typeof value.renetwork === "function";
}
function $e6278266fc0cd090$var$ethDefaultProvider(network) {
    const func = function(providers, options) {
        if (options == null) options = {};
        const providerList = [];
        if (providers.InfuraProvider && options.infura !== "-") try {
            providerList.push(new providers.InfuraProvider(network, options.infura));
        } catch (error) {}
        if (providers.EtherscanProvider && options.etherscan !== "-") try {
            providerList.push(new providers.EtherscanProvider(network, options.etherscan));
        } catch (error) {}
        if (providers.AlchemyProvider && options.alchemy !== "-") try {
            providerList.push(new providers.AlchemyProvider(network, options.alchemy));
        } catch (error) {}
        if (providers.PocketProvider && options.pocket !== "-") {
            // These networks are currently faulty on Pocket as their
            // network does not handle the Berlin hardfork, which is
            // live on these ones.
            // @TODO: This goes away once Pocket has upgraded their nodes
            const skip = [
                "goerli",
                "ropsten",
                "rinkeby",
                "sepolia"
            ];
            try {
                const provider = new providers.PocketProvider(network, options.pocket);
                if (provider.network && skip.indexOf(provider.network.name) === -1) providerList.push(provider);
            } catch (error) {}
        }
        if (providers.CloudflareProvider && options.cloudflare !== "-") try {
            providerList.push(new providers.CloudflareProvider(network));
        } catch (error) {}
        if (providers.AnkrProvider && options.ankr !== "-") try {
            const skip = [
                "ropsten"
            ];
            const provider = new providers.AnkrProvider(network, options.ankr);
            if (provider.network && skip.indexOf(provider.network.name) === -1) providerList.push(provider);
        } catch (error) {}
        if (providerList.length === 0) return null;
        if (providers.FallbackProvider) {
            let quorum = 1;
            if (options.quorum != null) quorum = options.quorum;
            else if (network === "homestead") quorum = 2;
            return new providers.FallbackProvider(providerList, quorum);
        }
        return providerList[0];
    };
    func.renetwork = function(network) {
        return $e6278266fc0cd090$var$ethDefaultProvider(network);
    };
    return func;
}
function $e6278266fc0cd090$var$etcDefaultProvider(url, network) {
    const func = function(providers, options) {
        if (providers.JsonRpcProvider) return new providers.JsonRpcProvider(url, network);
        return null;
    };
    func.renetwork = function(network) {
        return $e6278266fc0cd090$var$etcDefaultProvider(url, network);
    };
    return func;
}
const $e6278266fc0cd090$var$homestead = {
    chainId: 1,
    ensAddress: "0x00000000000C2E074eC69A0dFb2997BA6C7d2e1e",
    name: "homestead",
    _defaultProvider: $e6278266fc0cd090$var$ethDefaultProvider("homestead")
};
const $e6278266fc0cd090$var$ropsten = {
    chainId: 3,
    ensAddress: "0x00000000000C2E074eC69A0dFb2997BA6C7d2e1e",
    name: "ropsten",
    _defaultProvider: $e6278266fc0cd090$var$ethDefaultProvider("ropsten")
};
const $e6278266fc0cd090$var$classicMordor = {
    chainId: 63,
    name: "classicMordor",
    _defaultProvider: $e6278266fc0cd090$var$etcDefaultProvider("https://www.ethercluster.com/mordor", "classicMordor")
};
// See: https://chainlist.org
const $e6278266fc0cd090$var$networks = {
    unspecified: {
        chainId: 0,
        name: "unspecified"
    },
    homestead: $e6278266fc0cd090$var$homestead,
    mainnet: $e6278266fc0cd090$var$homestead,
    morden: {
        chainId: 2,
        name: "morden"
    },
    ropsten: $e6278266fc0cd090$var$ropsten,
    testnet: $e6278266fc0cd090$var$ropsten,
    rinkeby: {
        chainId: 4,
        ensAddress: "0x00000000000C2E074eC69A0dFb2997BA6C7d2e1e",
        name: "rinkeby",
        _defaultProvider: $e6278266fc0cd090$var$ethDefaultProvider("rinkeby")
    },
    kovan: {
        chainId: 42,
        name: "kovan",
        _defaultProvider: $e6278266fc0cd090$var$ethDefaultProvider("kovan")
    },
    goerli: {
        chainId: 5,
        ensAddress: "0x00000000000C2E074eC69A0dFb2997BA6C7d2e1e",
        name: "goerli",
        _defaultProvider: $e6278266fc0cd090$var$ethDefaultProvider("goerli")
    },
    kintsugi: {
        chainId: 1337702,
        name: "kintsugi"
    },
    sepolia: {
        chainId: 11155111,
        name: "sepolia",
        _defaultProvider: $e6278266fc0cd090$var$ethDefaultProvider("sepolia")
    },
    // ETC (See: #351)
    classic: {
        chainId: 61,
        name: "classic",
        _defaultProvider: $e6278266fc0cd090$var$etcDefaultProvider("https://www.ethercluster.com/etc", "classic")
    },
    classicMorden: {
        chainId: 62,
        name: "classicMorden"
    },
    classicMordor: $e6278266fc0cd090$var$classicMordor,
    classicTestnet: $e6278266fc0cd090$var$classicMordor,
    classicKotti: {
        chainId: 6,
        name: "classicKotti",
        _defaultProvider: $e6278266fc0cd090$var$etcDefaultProvider("https://www.ethercluster.com/kotti", "classicKotti")
    },
    xdai: {
        chainId: 100,
        name: "xdai"
    },
    matic: {
        chainId: 137,
        name: "matic",
        _defaultProvider: $e6278266fc0cd090$var$ethDefaultProvider("matic")
    },
    maticmum: {
        chainId: 80001,
        name: "maticmum"
    },
    optimism: {
        chainId: 10,
        name: "optimism",
        _defaultProvider: $e6278266fc0cd090$var$ethDefaultProvider("optimism")
    },
    "optimism-kovan": {
        chainId: 69,
        name: "optimism-kovan"
    },
    "optimism-goerli": {
        chainId: 420,
        name: "optimism-goerli"
    },
    arbitrum: {
        chainId: 42161,
        name: "arbitrum"
    },
    "arbitrum-rinkeby": {
        chainId: 421611,
        name: "arbitrum-rinkeby"
    },
    "arbitrum-goerli": {
        chainId: 421613,
        name: "arbitrum-goerli"
    },
    bnb: {
        chainId: 56,
        name: "bnb"
    },
    bnbt: {
        chainId: 97,
        name: "bnbt"
    }
};
function $e6278266fc0cd090$export$7de4970ebfd8206d(network) {
    // No network (null)
    if (network == null) return null;
    if (typeof network === "number") {
        for(const name in $e6278266fc0cd090$var$networks){
            const standard = $e6278266fc0cd090$var$networks[name];
            if (standard.chainId === network) return {
                name: standard.name,
                chainId: standard.chainId,
                ensAddress: standard.ensAddress || null,
                _defaultProvider: standard._defaultProvider || null
            };
        }
        return {
            chainId: network,
            name: "unknown"
        };
    }
    if (typeof network === "string") {
        const standard = $e6278266fc0cd090$var$networks[network];
        if (standard == null) return null;
        return {
            name: standard.name,
            chainId: standard.chainId,
            ensAddress: standard.ensAddress,
            _defaultProvider: standard._defaultProvider || null
        };
    }
    const standard = $e6278266fc0cd090$var$networks[network.name];
    // Not a standard network; check that it is a valid network in general
    if (!standard) {
        if (typeof network.chainId !== "number") $e6278266fc0cd090$var$logger.throwArgumentError("invalid network chainId", "network", network);
        return network;
    }
    // Make sure the chainId matches the expected network chainId (or is 0; disable EIP-155)
    if (network.chainId !== 0 && network.chainId !== standard.chainId) $e6278266fc0cd090$var$logger.throwArgumentError("network chainId mismatch", "network", network);
    // @TODO: In the next major version add an attach function to a defaultProvider
    // class and move the _defaultProvider internal to this file (extend Network)
    let defaultProvider = network._defaultProvider || null;
    if (defaultProvider == null && standard._defaultProvider) {
        if ($e6278266fc0cd090$var$isRenetworkable(standard._defaultProvider)) defaultProvider = standard._defaultProvider.renetwork(network);
        else defaultProvider = standard._defaultProvider;
    }
    // Standard Network (allow overriding the ENS address)
    return {
        name: network.name,
        chainId: standard.chainId,
        ensAddress: network.ensAddress || standard.ensAddress || null,
        _defaultProvider: defaultProvider
    };
}


var $fa2219aa02c3e62e$exports = {};

$parcel$export($fa2219aa02c3e62e$exports, "Resolver", function () { return $fa2219aa02c3e62e$export$8b4c839865b08288; });
$parcel$export($fa2219aa02c3e62e$exports, "BaseProvider", function () { return $fa2219aa02c3e62e$export$ff3f6dd83125ac45; });


"use strict";
function $197fdee3ede33bf0$export$2f872c0f2117be69(textData) {
    textData = atob(textData);
    const data = [];
    for(let i = 0; i < textData.length; i++)data.push(textData.charCodeAt(i));
    return (0, $06d75ae17ce69367$export$3131421a7d01b4fb)(data);
}
function $197fdee3ede33bf0$export$c564cdbbe6da493(data) {
    data = (0, $06d75ae17ce69367$export$3131421a7d01b4fb)(data);
    let textData = "";
    for(let i = 0; i < data.length; i++)textData += String.fromCharCode(data[i]);
    return btoa(textData);
}


/**
 * var basex = require("base-x");
 *
 * This implementation is heavily based on base-x. The main reason to
 * deviate was to prevent the dependency of Buffer.
 *
 * Contributors:
 *
 * base-x encoding
 * Forked from https://github.com/cryptocoinjs/bs58
 * Originally written by Mike Hearn for BitcoinJ
 * Copyright (c) 2011 Google Inc
 * Ported to JavaScript by Stefan Thomas
 * Merged Buffer refactorings from base58-native by Stephen Pair
 * Copyright (c) 2013 BitPay Inc
 *
 * The MIT License (MIT)
 *
 * Copyright base-x contributors (c) 2016
 *
 * Permission is hereby granted, free of charge, to any person obtaining a
 * copy of this software and associated documentation files (the "Software"),
 * to deal in the Software without restriction, including without limitation
 * the rights to use, copy, modify, merge, publish, distribute, sublicense,
 * and/or sell copies of the Software, and to permit persons to whom the
 * Software is furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.

 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING
 * FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS
 * IN THE SOFTWARE.
 *
 */ 

class $4f9292cbf9a48447$export$240043ab8e806ec7 {
    constructor(alphabet){
        (0, $d2d9b472f7878d5e$exports.defineReadOnly)(this, "alphabet", alphabet);
        (0, $d2d9b472f7878d5e$exports.defineReadOnly)(this, "base", alphabet.length);
        (0, $d2d9b472f7878d5e$exports.defineReadOnly)(this, "_alphabetMap", {});
        (0, $d2d9b472f7878d5e$exports.defineReadOnly)(this, "_leader", alphabet.charAt(0));
        // pre-compute lookup table
        for(let i = 0; i < alphabet.length; i++)this._alphabetMap[alphabet.charAt(i)] = i;
    }
    encode(value) {
        let source = (0, $06d75ae17ce69367$export$3131421a7d01b4fb)(value);
        if (source.length === 0) return "";
        let digits = [
            0
        ];
        for(let i = 0; i < source.length; ++i){
            let carry = source[i];
            for(let j = 0; j < digits.length; ++j){
                carry += digits[j] << 8;
                digits[j] = carry % this.base;
                carry = carry / this.base | 0;
            }
            while(carry > 0){
                digits.push(carry % this.base);
                carry = carry / this.base | 0;
            }
        }
        let string = "";
        // deal with leading zeros
        for(let k = 0; source[k] === 0 && k < source.length - 1; ++k)string += this._leader;
        // convert digits to a string
        for(let q = digits.length - 1; q >= 0; --q)string += this.alphabet[digits[q]];
        return string;
    }
    decode(value) {
        if (typeof value !== "string") throw new TypeError("Expected String");
        let bytes = [];
        if (value.length === 0) return new Uint8Array(bytes);
        bytes.push(0);
        for(let i = 0; i < value.length; i++){
            let byte = this._alphabetMap[value[i]];
            if (byte === undefined) throw new Error("Non-base" + this.base + " character");
            let carry = byte;
            for(let j = 0; j < bytes.length; ++j){
                carry += bytes[j] * this.base;
                bytes[j] = carry & 0xff;
                carry >>= 8;
            }
            while(carry > 0){
                bytes.push(carry & 0xff);
                carry >>= 8;
            }
        }
        // deal with leading zeros
        for(let k = 0; value[k] === this._leader && k < value.length - 1; ++k)bytes.push(0);
        return (0, $06d75ae17ce69367$export$3131421a7d01b4fb)(new Uint8Array(bytes.reverse()));
    }
}
const $4f9292cbf9a48447$export$cfabb2852920f5ec = new $4f9292cbf9a48447$export$240043ab8e806ec7("abcdefghijklmnopqrstuvwxyz234567");
const $4f9292cbf9a48447$export$45a587635c9954b2 = new $4f9292cbf9a48447$export$240043ab8e806ec7("123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz");
 //console.log(Base58.decode("Qmd2V777o5XvJbYMeMb8k2nU5f8d3ciUQ5YpYuWhzv8iDj"))
 //console.log(Base58.encode(Base58.decode("Qmd2V777o5XvJbYMeMb8k2nU5f8d3ciUQ5YpYuWhzv8iDj")))




const $0c009a6d1ae8a424$export$71c2e4e213dcb7f2 = "0x0000000000000000000000000000000000000000000000000000000000000000";





const $0a08796bc83cbef6$export$83d89fbfd8236492 = "strings/5.7.0";


"use strict";
const $7bbf1261c840221b$var$logger = new (0, $5f596c9584f643ae$export$efa9a398d6368992)((0, $0a08796bc83cbef6$export$83d89fbfd8236492));
var $7bbf1261c840221b$export$c6986442964129f5;
(function(UnicodeNormalizationForm) {
    UnicodeNormalizationForm["current"] = "";
    UnicodeNormalizationForm["NFC"] = "NFC";
    UnicodeNormalizationForm["NFD"] = "NFD";
    UnicodeNormalizationForm["NFKC"] = "NFKC";
    UnicodeNormalizationForm["NFKD"] = "NFKD";
})($7bbf1261c840221b$export$c6986442964129f5 || ($7bbf1261c840221b$export$c6986442964129f5 = {}));
var $7bbf1261c840221b$export$c285fa6ac15ff6a6;
(function(Utf8ErrorReason) {
    // A continuation byte was present where there was nothing to continue
    // - offset = the index the codepoint began in
    Utf8ErrorReason["UNEXPECTED_CONTINUE"] = "unexpected continuation byte";
    // An invalid (non-continuation) byte to start a UTF-8 codepoint was found
    // - offset = the index the codepoint began in
    Utf8ErrorReason["BAD_PREFIX"] = "bad codepoint prefix";
    // The string is too short to process the expected codepoint
    // - offset = the index the codepoint began in
    Utf8ErrorReason["OVERRUN"] = "string overrun";
    // A missing continuation byte was expected but not found
    // - offset = the index the continuation byte was expected at
    Utf8ErrorReason["MISSING_CONTINUE"] = "missing continuation byte";
    // The computed code point is outside the range for UTF-8
    // - offset       = start of this codepoint
    // - badCodepoint = the computed codepoint; outside the UTF-8 range
    Utf8ErrorReason["OUT_OF_RANGE"] = "out of UTF-8 range";
    // UTF-8 strings may not contain UTF-16 surrogate pairs
    // - offset       = start of this codepoint
    // - badCodepoint = the computed codepoint; inside the UTF-16 surrogate range
    Utf8ErrorReason["UTF16_SURROGATE"] = "UTF-16 surrogate";
    // The string is an overlong representation
    // - offset       = start of this codepoint
    // - badCodepoint = the computed codepoint; already bounds checked
    Utf8ErrorReason["OVERLONG"] = "overlong representation";
})($7bbf1261c840221b$export$c285fa6ac15ff6a6 || ($7bbf1261c840221b$export$c285fa6ac15ff6a6 = {}));
function $7bbf1261c840221b$var$errorFunc(reason, offset, bytes, output, badCodepoint) {
    return $7bbf1261c840221b$var$logger.throwArgumentError(`invalid codepoint at offset ${offset}; ${reason}`, "bytes", bytes);
}
function $7bbf1261c840221b$var$ignoreFunc(reason, offset, bytes, output, badCodepoint) {
    // If there is an invalid prefix (including stray continuation), skip any additional continuation bytes
    if (reason === $7bbf1261c840221b$export$c285fa6ac15ff6a6.BAD_PREFIX || reason === $7bbf1261c840221b$export$c285fa6ac15ff6a6.UNEXPECTED_CONTINUE) {
        let i = 0;
        for(let o = offset + 1; o < bytes.length; o++){
            if (bytes[o] >> 6 !== 0x02) break;
            i++;
        }
        return i;
    }
    // This byte runs us past the end of the string, so just jump to the end
    // (but the first byte was read already read and therefore skipped)
    if (reason === $7bbf1261c840221b$export$c285fa6ac15ff6a6.OVERRUN) return bytes.length - offset - 1;
    // Nothing to skip
    return 0;
}
function $7bbf1261c840221b$var$replaceFunc(reason, offset, bytes, output, badCodepoint) {
    // Overlong representations are otherwise "valid" code points; just non-deistingtished
    if (reason === $7bbf1261c840221b$export$c285fa6ac15ff6a6.OVERLONG) {
        output.push(badCodepoint);
        return 0;
    }
    // Put the replacement character into the output
    output.push(0xfffd);
    // Otherwise, process as if ignoring errors
    return $7bbf1261c840221b$var$ignoreFunc(reason, offset, bytes, output, badCodepoint);
}
const $7bbf1261c840221b$export$c6e2180c5bb5bc05 = Object.freeze({
    error: $7bbf1261c840221b$var$errorFunc,
    ignore: $7bbf1261c840221b$var$ignoreFunc,
    replace: $7bbf1261c840221b$var$replaceFunc
});
// http://stackoverflow.com/questions/13356493/decode-utf-8-with-javascript#13691499
function $7bbf1261c840221b$var$getUtf8CodePoints(bytes, onError) {
    if (onError == null) onError = $7bbf1261c840221b$export$c6e2180c5bb5bc05.error;
    bytes = (0, $06d75ae17ce69367$export$3131421a7d01b4fb)(bytes);
    const result = [];
    let i = 0;
    // Invalid bytes are ignored
    while(i < bytes.length){
        const c = bytes[i++];
        // 0xxx xxxx
        if (c >> 7 === 0) {
            result.push(c);
            continue;
        }
        // Multibyte; how many bytes left for this character?
        let extraLength = null;
        let overlongMask = null;
        // 110x xxxx 10xx xxxx
        if ((c & 0xe0) === 0xc0) {
            extraLength = 1;
            overlongMask = 0x7f;
        // 1110 xxxx 10xx xxxx 10xx xxxx
        } else if ((c & 0xf0) === 0xe0) {
            extraLength = 2;
            overlongMask = 0x7ff;
        // 1111 0xxx 10xx xxxx 10xx xxxx 10xx xxxx
        } else if ((c & 0xf8) === 0xf0) {
            extraLength = 3;
            overlongMask = 0xffff;
        } else {
            if ((c & 0xc0) === 0x80) i += onError($7bbf1261c840221b$export$c285fa6ac15ff6a6.UNEXPECTED_CONTINUE, i - 1, bytes, result);
            else i += onError($7bbf1261c840221b$export$c285fa6ac15ff6a6.BAD_PREFIX, i - 1, bytes, result);
            continue;
        }
        // Do we have enough bytes in our data?
        if (i - 1 + extraLength >= bytes.length) {
            i += onError($7bbf1261c840221b$export$c285fa6ac15ff6a6.OVERRUN, i - 1, bytes, result);
            continue;
        }
        // Remove the length prefix from the char
        let res = c & (1 << 8 - extraLength - 1) - 1;
        for(let j = 0; j < extraLength; j++){
            let nextChar = bytes[i];
            // Invalid continuation byte
            if ((nextChar & 0xc0) != 0x80) {
                i += onError($7bbf1261c840221b$export$c285fa6ac15ff6a6.MISSING_CONTINUE, i, bytes, result);
                res = null;
                break;
            }
            res = res << 6 | nextChar & 0x3f;
            i++;
        }
        // See above loop for invalid continuation byte
        if (res === null) continue;
        // Maximum code point
        if (res > 0x10ffff) {
            i += onError($7bbf1261c840221b$export$c285fa6ac15ff6a6.OUT_OF_RANGE, i - 1 - extraLength, bytes, result, res);
            continue;
        }
        // Reserved for UTF-16 surrogate halves
        if (res >= 0xd800 && res <= 0xdfff) {
            i += onError($7bbf1261c840221b$export$c285fa6ac15ff6a6.UTF16_SURROGATE, i - 1 - extraLength, bytes, result, res);
            continue;
        }
        // Check for overlong sequences (more bytes than needed)
        if (res <= overlongMask) {
            i += onError($7bbf1261c840221b$export$c285fa6ac15ff6a6.OVERLONG, i - 1 - extraLength, bytes, result, res);
            continue;
        }
        result.push(res);
    }
    return result;
}
function $7bbf1261c840221b$export$8feeb310b4b4752f(str, form = $7bbf1261c840221b$export$c6986442964129f5.current) {
    if (form != $7bbf1261c840221b$export$c6986442964129f5.current) {
        $7bbf1261c840221b$var$logger.checkNormalize();
        str = str.normalize(form);
    }
    let result = [];
    for(let i = 0; i < str.length; i++){
        const c = str.charCodeAt(i);
        if (c < 0x80) result.push(c);
        else if (c < 0x800) {
            result.push(c >> 6 | 0xc0);
            result.push(c & 0x3f | 0x80);
        } else if ((c & 0xfc00) == 0xd800) {
            i++;
            const c2 = str.charCodeAt(i);
            if (i >= str.length || (c2 & 0xfc00) !== 0xdc00) throw new Error("invalid utf-8 string");
            // Surrogate Pair
            const pair = 0x10000 + ((c & 0x03ff) << 10) + (c2 & 0x03ff);
            result.push(pair >> 18 | 0xf0);
            result.push(pair >> 12 & 0x3f | 0x80);
            result.push(pair >> 6 & 0x3f | 0x80);
            result.push(pair & 0x3f | 0x80);
        } else {
            result.push(c >> 12 | 0xe0);
            result.push(c >> 6 & 0x3f | 0x80);
            result.push(c & 0x3f | 0x80);
        }
    }
    return (0, $06d75ae17ce69367$export$3131421a7d01b4fb)(result);
}
function $7bbf1261c840221b$var$escapeChar(value) {
    const hex = "0000" + value.toString(16);
    return "\\u" + hex.substring(hex.length - 4);
}
function $7bbf1261c840221b$export$a7a0ec15960b9055(bytes, onError) {
    return '"' + $7bbf1261c840221b$var$getUtf8CodePoints(bytes, onError).map((codePoint)=>{
        if (codePoint < 256) {
            switch(codePoint){
                case 8:
                    return "\\b";
                case 9:
                    return "\\t";
                case 10:
                    return "\\n";
                case 13:
                    return "\\r";
                case 34:
                    return '\\"';
                case 92:
                    return "\\\\";
            }
            if (codePoint >= 32 && codePoint < 127) return String.fromCharCode(codePoint);
        }
        if (codePoint <= 0xffff) return $7bbf1261c840221b$var$escapeChar(codePoint);
        codePoint -= 0x10000;
        return $7bbf1261c840221b$var$escapeChar((codePoint >> 10 & 0x3ff) + 0xd800) + $7bbf1261c840221b$var$escapeChar((codePoint & 0x3ff) + 0xdc00);
    }).join("") + '"';
}
function $7bbf1261c840221b$export$232e1dab03132235(codePoints) {
    return codePoints.map((codePoint)=>{
        if (codePoint <= 0xffff) return String.fromCharCode(codePoint);
        codePoint -= 0x10000;
        return String.fromCharCode((codePoint >> 10 & 0x3ff) + 0xd800, (codePoint & 0x3ff) + 0xdc00);
    }).join("");
}
function $7bbf1261c840221b$export$7643a1dc2c38d5eb(bytes, onError) {
    return $7bbf1261c840221b$export$232e1dab03132235($7bbf1261c840221b$var$getUtf8CodePoints(bytes, onError));
}
function $7bbf1261c840221b$export$ae470a36a31b28c2(str, form = $7bbf1261c840221b$export$c6986442964129f5.current) {
    return $7bbf1261c840221b$var$getUtf8CodePoints($7bbf1261c840221b$export$8feeb310b4b4752f(str, form));
}



var $baOVG = parcelRequire("baOVG");

"use strict";
function $62e3396d458230e9$export$f8151fce47ad1c35(data) {
    return "0x" + (0, (/*@__PURE__*/$parcel$interopDefault($baOVG))).keccak_256((0, $06d75ae17ce69367$export$3131421a7d01b4fb)(data));
}



const $3f74d983611b69f1$export$83d89fbfd8236492 = "hash/5.7.0";


/**
 * MIT License
 *
 * Copyright (c) 2021 Andrew Raffensperger
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 *
 * This is a near carbon-copy of the original source (link below) with the
 * TypeScript typings added and a few tweaks to make it ES3-compatible.
 *
 * See: https://github.com/adraffy/ens-normalize.js
 */ 
/**
 * MIT License
 *
 * Copyright (c) 2021 Andrew Raffensperger
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 *
 * This is a near carbon-copy of the original source (link below) with the
 * TypeScript typings added and a few tweaks to make it ES3-compatible.
 *
 * See: https://github.com/adraffy/ens-normalize.js
 */ 
/**
 * MIT License
 *
 * Copyright (c) 2021 Andrew Raffensperger
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 *
 * This is a near carbon-copy of the original source (link below) with the
 * TypeScript typings added and a few tweaks to make it ES3-compatible.
 *
 * See: https://github.com/adraffy/ens-normalize.js
 */ // https://github.com/behnammodi/polyfill/blob/master/array.polyfill.js
function $27e1c16409ffff0a$var$flat(array, depth) {
    if (depth == null) depth = 1;
    const result = [];
    const forEach = result.forEach;
    const flatDeep = function(arr, depth) {
        forEach.call(arr, function(val) {
            if (depth > 0 && Array.isArray(val)) flatDeep(val, depth - 1);
            else result.push(val);
        });
    };
    flatDeep(array, depth);
    return result;
}
function $27e1c16409ffff0a$var$fromEntries(array) {
    const result = {};
    for(let i = 0; i < array.length; i++){
        const value = array[i];
        result[value[0]] = value[1];
    }
    return result;
}
function $27e1c16409ffff0a$export$956eeed0f8f2ceff(bytes) {
    let pos = 0;
    function u16() {
        return bytes[pos++] << 8 | bytes[pos++];
    }
    // decode the frequency table
    let symbol_count = u16();
    let total = 1;
    let acc = [
        0,
        1
    ]; // first symbol has frequency 1
    for(let i = 1; i < symbol_count; i++)acc.push(total += u16());
    // skip the sized-payload that the last 3 symbols index into
    let skip = u16();
    let pos_payload = pos;
    pos += skip;
    let read_width = 0;
    let read_buffer = 0;
    function read_bit() {
        if (read_width == 0) {
            // this will read beyond end of buffer
            // but (undefined|0) => zero pad
            read_buffer = read_buffer << 8 | bytes[pos++];
            read_width = 8;
        }
        return read_buffer >> --read_width & 1;
    }
    const N = 31;
    const FULL = Math.pow(2, N);
    const HALF = FULL >>> 1;
    const QRTR = HALF >> 1;
    const MASK = FULL - 1;
    // fill register
    let register = 0;
    for(let i = 0; i < N; i++)register = register << 1 | read_bit();
    let symbols = [];
    let low = 0;
    let range = FULL; // treat like a float
    while(true){
        let value = Math.floor(((register - low + 1) * total - 1) / range);
        let start = 0;
        let end = symbol_count;
        while(end - start > 1){
            let mid = start + end >>> 1;
            if (value < acc[mid]) end = mid;
            else start = mid;
        }
        if (start == 0) break; // first symbol is end mark
        symbols.push(start);
        let a = low + Math.floor(range * acc[start] / total);
        let b = low + Math.floor(range * acc[start + 1] / total) - 1;
        while(((a ^ b) & HALF) == 0){
            register = register << 1 & MASK | read_bit();
            a = a << 1 & MASK;
            b = b << 1 & MASK | 1;
        }
        while(a & ~b & QRTR){
            register = register & HALF | register << 1 & MASK >>> 1 | read_bit();
            a = a << 1 ^ HALF;
            b = (b ^ HALF) << 1 | HALF | 1;
        }
        low = a;
        range = 1 + b - a;
    }
    let offset = symbol_count - 4;
    return symbols.map((x)=>{
        switch(x - offset){
            case 3:
                return offset + 0x10100 + (bytes[pos_payload++] << 16 | bytes[pos_payload++] << 8 | bytes[pos_payload++]);
            case 2:
                return offset + 0x100 + (bytes[pos_payload++] << 8 | bytes[pos_payload++]);
            case 1:
                return offset + bytes[pos_payload++];
            default:
                return x - 1;
        }
    });
}
function $27e1c16409ffff0a$export$2cda812f22276871(v) {
    let pos = 0;
    return ()=>v[pos++];
}
function $27e1c16409ffff0a$export$671d8b4ebc0c42ad(bytes) {
    return $27e1c16409ffff0a$export$2cda812f22276871($27e1c16409ffff0a$export$956eeed0f8f2ceff(bytes));
}
function $27e1c16409ffff0a$export$a785de3a2a8dd1aa(i) {
    return i & 1 ? ~i >> 1 : i >> 1;
}
function $27e1c16409ffff0a$var$read_counts(n, next) {
    let v = Array(n);
    for(let i = 0; i < n; i++)v[i] = 1 + next();
    return v;
}
function $27e1c16409ffff0a$var$read_ascending(n, next) {
    let v = Array(n);
    for(let i = 0, x = -1; i < n; i++)v[i] = x += 1 + next();
    return v;
}
function $27e1c16409ffff0a$var$read_deltas(n, next) {
    let v = Array(n);
    for(let i = 0, x = 0; i < n; i++)v[i] = x += $27e1c16409ffff0a$export$a785de3a2a8dd1aa(next());
    return v;
}
function $27e1c16409ffff0a$export$9303bf4e1ede4914(next, lookup) {
    let v = $27e1c16409ffff0a$var$read_ascending(next(), next);
    let n = next();
    let vX = $27e1c16409ffff0a$var$read_ascending(n, next);
    let vN = $27e1c16409ffff0a$var$read_counts(n, next);
    for(let i = 0; i < n; i++)for(let j = 0; j < vN[i]; j++)v.push(vX[i] + j);
    return lookup ? v.map((x)=>lookup[x]) : v;
}
function $27e1c16409ffff0a$export$824d00fb01c38bd9(next) {
    let ret = [];
    while(true){
        let w = next();
        if (w == 0) break;
        ret.push($27e1c16409ffff0a$var$read_linear_table(w, next));
    }
    while(true){
        let w = next() - 1;
        if (w < 0) break;
        ret.push($27e1c16409ffff0a$var$read_replacement_table(w, next));
    }
    return $27e1c16409ffff0a$var$fromEntries($27e1c16409ffff0a$var$flat(ret));
}
function $27e1c16409ffff0a$export$e9011071590ab431(next) {
    let v = [];
    while(true){
        let i = next();
        if (i == 0) break;
        v.push(i);
    }
    return v;
}
function $27e1c16409ffff0a$var$read_transposed(n, w, next) {
    let m = Array(n).fill(undefined).map(()=>[]);
    for(let i = 0; i < w; i++)$27e1c16409ffff0a$var$read_deltas(n, next).forEach((x, j)=>m[j].push(x));
    return m;
}
function $27e1c16409ffff0a$var$read_linear_table(w, next) {
    let dx = 1 + next();
    let dy = next();
    let vN = $27e1c16409ffff0a$export$e9011071590ab431(next);
    let m = $27e1c16409ffff0a$var$read_transposed(vN.length, 1 + w, next);
    return $27e1c16409ffff0a$var$flat(m.map((v, i)=>{
        const x = v[0], ys = v.slice(1);
        //let [x, ...ys] = v;
        //return Array(vN[i]).fill().map((_, j) => {
        return Array(vN[i]).fill(undefined).map((_, j)=>{
            let j_dy = j * dy;
            return [
                x + j * dx,
                ys.map((y)=>y + j_dy)
            ];
        });
    }));
}
function $27e1c16409ffff0a$var$read_replacement_table(w, next) {
    let n = 1 + next();
    let m = $27e1c16409ffff0a$var$read_transposed(n, 1 + w, next);
    return m.map((v)=>[
            v[0],
            v.slice(1)
        ]);
}
function $27e1c16409ffff0a$export$d7b24c6ce369e1b7(next) {
    let sorted = $27e1c16409ffff0a$export$9303bf4e1ede4914(next).sort((a, b)=>a - b);
    return read();
    function read() {
        let branches = [];
        while(true){
            let keys = $27e1c16409ffff0a$export$9303bf4e1ede4914(next, sorted);
            if (keys.length == 0) break;
            branches.push({
                set: new Set(keys),
                node: read()
            });
        }
        branches.sort((a, b)=>b.set.size - a.set.size); // sort by likelihood
        let temp = next();
        let valid = temp % 3;
        temp = temp / 3 | 0;
        let fe0f = !!(temp & 1);
        temp >>= 1;
        let save = temp == 1;
        let check = temp == 2;
        return {
            branches: branches,
            valid: valid,
            fe0f: fe0f,
            save: save,
            check: check
        };
    }
}


function $584fcc90974ab591$export$7a171f172be0782e() {
    return (0, $27e1c16409ffff0a$export$671d8b4ebc0c42ad)((0, $197fdee3ede33bf0$export$2f872c0f2117be69)("AEQF2AO2DEsA2wIrAGsBRABxAN8AZwCcAEwAqgA0AGwAUgByADcATAAVAFYAIQAyACEAKAAYAFgAGwAjABQAMAAmADIAFAAfABQAKwATACoADgAbAA8AHQAYABoAGQAxADgALAAoADwAEwA9ABMAGgARAA4ADwAWABMAFgAIAA8AHgQXBYMA5BHJAS8JtAYoAe4AExozi0UAH21tAaMnBT8CrnIyhrMDhRgDygIBUAEHcoFHUPe8AXBjAewCjgDQR8IICIcEcQLwATXCDgzvHwBmBoHNAqsBdBcUAykgDhAMShskMgo8AY8jqAQfAUAfHw8BDw87MioGlCIPBwZCa4ELatMAAMspJVgsDl8AIhckSg8XAHdvTwBcIQEiDT4OPhUqbyECAEoAS34Aej8Ybx83JgT/Xw8gHxZ/7w8RICxPHA9vBw+Pfw8PHwAPFv+fAsAvCc8vEr8ivwD/EQ8Bol8OEBa/A78hrwAPCU8vESNvvwWfHwNfAVoDHr+ZAAED34YaAdJPAK7PLwSEgDLHAGo1Pz8Pvx9fUwMrpb8O/58VTzAPIBoXIyQJNF8hpwIVAT8YGAUADDNBaX3RAMomJCg9EhUeA29MABsZBTMNJipjOhc19gcIDR8bBwQHEggCWi6DIgLuAQYA+BAFCha3A5XiAEsqM7UFFgFLhAMjFTMYE1Klnw74nRVBG/ASCm0BYRN/BrsU3VoWy+S0vV8LQx+vN8gF2AC2AK5EAWwApgYDKmAAroQ0NDQ0AT+OCg7wAAIHRAbpNgVcBV0APTA5BfbPFgMLzcYL/QqqA82eBALKCjQCjqYCht0/k2+OAsXQAoP3ASTKDgDw6ACKAUYCMpIKJpRaAE4A5womABzZvs0REEKiACIQAd5QdAECAj4Ywg/wGqY2AVgAYADYvAoCGAEubA0gvAY2ALAAbpbvqpyEAGAEpgQAJgAG7gAgAEACmghUFwCqAMpAINQIwC4DthRAAPcycKgApoIdABwBfCisABoATwBqASIAvhnSBP8aH/ECeAKXAq40NjgDBTwFYQU6AXs3oABgAD4XNgmcCY1eCl5tIFZeUqGgyoNHABgAEQAaABNwWQAmABMATPMa3T34ADldyprmM1M2XociUQgLzvwAXT3xABgAEQAaABNwIGFAnADD8AAgAD4BBJWzaCcIAIEBFMAWwKoAAdq9BWAF5wLQpALEtQAKUSGkahR4GnJM+gsAwCgeFAiUAECQ0BQuL8AAIAAAADKeIheclvFqQAAETr4iAMxIARMgAMIoHhQIAn0E0pDQFC4HhznoAAAAIAI2C0/4lvFqQAAETgBJJwYCAy4ABgYAFAA8MBKYEH4eRhTkAjYeFcgACAYAeABsOqyQ5gRwDayqugEgaIIAtgoACgDmEABmBAWGme5OBJJA2m4cDeoAmITWAXwrMgOgAGwBCh6CBXYF1Tzg1wKAAFdiuABRAFwAXQBsAG8AdgBrAHYAbwCEAHEwfxQBVE5TEQADVFhTBwBDANILAqcCzgLTApQCrQL6vAAMAL8APLhNBKkE6glGKTAU4Dr4N2EYEwBCkABKk8rHAbYBmwIoAiU4Ajf/Aq4CowCAANIChzgaNBsCsTgeODcFXrgClQKdAqQBiQGYAqsCsjTsNHsfNPA0ixsAWTWiOAMFPDQSNCk2BDZHNow2TTZUNhk28Jk9VzI3QkEoAoICoQKwAqcAQAAxBV4FXbS9BW47YkIXP1ciUqs05DS/FwABUwJW11e6nHuYZmSh/RAYA8oMKvZ8KASoUAJYWAJ6ILAsAZSoqjpgA0ocBIhmDgDWAAawRDQoAAcuAj5iAHABZiR2AIgiHgCaAU68ACxuHAG0ygM8MiZIAlgBdF4GagJqAPZOHAMuBgoATkYAsABiAHgAMLoGDPj0HpKEBAAOJgAuALggTAHWAeAMEDbd20Uege0ADwAWADkAQgA9OHd+2MUQZBBhBgNNDkxxPxUQArEPqwvqERoM1irQ090ANK4H8ANYB/ADWANYB/AH8ANYB/ADWANYA1gDWBwP8B/YxRBkD00EcgWTBZAE2wiIJk4RhgctCNdUEnQjHEwDSgEBIypJITuYMxAlR0wRTQgIATZHbKx9PQNMMbBU+pCnA9AyVDlxBgMedhKlAC8PeCE1uk6DekxxpQpQT7NX9wBFBgASqwAS5gBJDSgAUCwGPQBI4zTYABNGAE2bAE3KAExdGABKaAbgAFBXAFCOAFBJABI2SWdObALDOq0//QomCZhvwHdTBkIQHCemEPgMNAG2ATwN7kvZBPIGPATKH34ZGg/OlZ0Ipi3eDO4m5C6igFsj9iqEBe5L9TzeC05RaQ9aC2YJ5DpkgU8DIgEOIowK3g06CG4Q9ArKbA3mEUYHOgPWSZsApgcCCxIdNhW2JhFirQsKOXgG/Br3C5AmsBMqev0F1BoiBk4BKhsAANAu6IWxWjJcHU9gBgQLJiPIFKlQIQ0mQLh4SRocBxYlqgKSQ3FKiFE3HpQh9zw+DWcuFFF9B/Y8BhlQC4I8n0asRQ8R0z6OPUkiSkwtBDaALDAnjAnQD4YMunxzAVoJIgmyDHITMhEYN8YIOgcaLpclJxYIIkaWYJsE+KAD9BPSAwwFQAlCBxQDthwuEy8VKgUOgSXYAvQ21i60ApBWgQEYBcwPJh/gEFFH4Q7qCJwCZgOEJewALhUiABginAhEZABgj9lTBi7MCMhqbSN1A2gU6GIRdAeSDlgHqBw0FcAc4nDJXgyGCSiksAlcAXYJmgFgBOQICjVcjKEgQmdUi1kYnCBiQUBd/QIyDGYVoES+h3kCjA9sEhwBNgF0BzoNAgJ4Ee4RbBCWCOyGBTW2M/k6JgRQIYQgEgooA1BszwsoJvoM+WoBpBJjAw00PnfvZ6xgtyUX/gcaMsZBYSHyC5NPzgydGsIYQ1QvGeUHwAP0GvQn60FYBgADpAQUOk4z7wS+C2oIjAlAAEoOpBgH2BhrCnKM0QEyjAG4mgNYkoQCcJAGOAcMAGgMiAV65gAeAqgIpAAGANADWAA6Aq4HngAaAIZCAT4DKDABIuYCkAOUCDLMAZYwAfQqBBzEDBYA+DhuSwLDsgKAa2ajBd5ZAo8CSjYBTiYEBk9IUgOwcuIA3ABMBhTgSAEWrEvMG+REAeBwLADIAPwABjYHBkIBzgH0bgC4AWALMgmjtLYBTuoqAIQAFmwB2AKKAN4ANgCA8gFUAE4FWvoF1AJQSgESMhksWGIBvAMgATQBDgB6BsyOpsoIIARuB9QCEBwV4gLvLwe2AgMi4BPOQsYCvd9WADIXUu5eZwqoCqdeaAC0YTQHMnM9UQAPH6k+yAdy/BZIiQImSwBQ5gBQQzSaNTFWSTYBpwGqKQK38AFtqwBI/wK37gK3rQK3sAK6280C0gK33AK3zxAAUEIAUD9SklKDArekArw5AEQAzAHCO147WTteO1k7XjtZO147WTteO1kDmChYI03AVU0oJqkKbV9GYewMpw3VRMk6ShPcYFJgMxPJLbgUwhXPJVcZPhq9JwYl5VUKDwUt1GYxCC00dhe9AEApaYNCY4ceMQpMHOhTklT5LRwAskujM7ANrRsWREEFSHXuYisWDwojAmSCAmJDXE6wXDchAqH4AmiZAmYKAp+FOBwMAmY8AmYnBG8EgAN/FAN+kzkHOXgYOYM6JCQCbB4CMjc4CwJtyAJtr/CLADRoRiwBaADfAOIASwYHmQyOAP8MwwAOtgJ3MAJ2o0ACeUxEAni7Hl3cRa9G9AJ8QAJ6yQJ9CgJ88UgBSH5kJQAsFklZSlwWGErNAtECAtDNSygDiFADh+dExpEzAvKiXQQDA69Lz0wuJgTQTU1NsAKLQAKK2cIcCB5EaAa4Ao44Ao5dQZiCAo7aAo5deVG1UzYLUtVUhgKT/AKTDQDqAB1VH1WwVdEHLBwplocy4nhnRTw6ApegAu+zWCKpAFomApaQApZ9nQCqWa1aCoJOADwClrYClk9cRVzSApnMApllXMtdCBoCnJw5wzqeApwXAp+cAp65iwAeEDIrEAKd8gKekwC2PmE1YfACntQCoG8BqgKeoCACnk+mY8lkKCYsAiewAiZ/AqD8AqBN2AKmMAKlzwKoAAB+AqfzaH1osgAESmodatICrOQCrK8CrWgCrQMCVx4CVd0CseLYAx9PbJgCsr4OArLpGGzhbWRtSWADJc4Ctl08QG6RAylGArhfArlIFgK5K3hwN3DiAr0aAy2zAzISAr6JcgMDM3ICvhtzI3NQAsPMAsMFc4N0TDZGdOEDPKgDPJsDPcACxX0CxkgCxhGKAshqUgLIRQLJUALJLwJkngLd03h6YniveSZL0QMYpGcDAmH1GfSVJXsMXpNevBICz2wCz20wTFTT9BSgAMeuAs90ASrrA04TfkwGAtwoAtuLAtJQA1JdA1NgAQIDVY2AikABzBfuYUZ2AILPg44C2sgC2d+EEYRKpz0DhqYAMANkD4ZyWvoAVgLfZgLeuXR4AuIw7RUB8zEoAfScAfLTiALr9ALpcXoAAur6AurlAPpIAboC7ooC652Wq5cEAu5AA4XhmHpw4XGiAvMEAGoDjheZlAL3FAORbwOSiAL3mQL52gL4Z5odmqy8OJsfA52EAv77ARwAOp8dn7QDBY4DpmsDptoA0sYDBmuhiaIGCgMMSgFgASACtgNGAJwEgLpoBgC8BGzAEowcggCEDC6kdjoAJAM0C5IKRoABZCgiAIzw3AYBLACkfng9ogigkgNmWAN6AEQCvrkEVqTGAwCsBRbAA+4iQkMCHR072jI2PTbUNsk2RjY5NvA23TZKNiU3EDcZN5I+RTxDRTBCJkK5VBYKFhZfwQCWygU3AJBRHpu+OytgNxa61A40GMsYjsn7BVwFXQVcBV0FaAVdBVwFXQVcBV0FXAVdBVwFXUsaCNyKAK4AAQUHBwKU7oICoW1e7jAEzgPxA+YDwgCkBFDAwADABKzAAOxFLhitA1UFTDeyPkM+bj51QkRCuwTQWWQ8X+0AWBYzsACNA8xwzAGm7EZ/QisoCTAbLDs6fnLfb8H2GccsbgFw13M1HAVkBW/Jxsm9CNRO8E8FDD0FBQw9FkcClOYCoMFegpDfADgcMiA2AJQACB8AsigKAIzIEAJKeBIApY5yPZQIAKQiHb4fvj5BKSRPQrZCOz0oXyxgOywfKAnGbgMClQaCAkILXgdeCD9IIGUgQj5fPoY+dT52Ao5CM0dAX9BTVG9SDzFwWTQAbxBzJF/lOEIQQglCCkKJIAls5AcClQICoKPMODEFxhi6KSAbiyfIRrMjtCgdWCAkPlFBIitCsEJRzAbMAV/OEyQzDg0OAQQEJ36i328/Mk9AybDJsQlq3tDRApUKAkFzXf1d/j9uALYP6hCoFgCTGD8kPsFKQiobrm0+zj0KSD8kPnVCRBwMDyJRTHFgMTJa5rwXQiQ2YfI/JD7BMEJEHGINTw4TOFlIRzwJO0icMQpyPyQ+wzJCRBv6DVgnKB01NgUKj2bwYzMqCoBkznBgEF+zYDIocwRIX+NgHj4HICNfh2C4CwdwFWpTG/lgUhYGAwRfv2Ts8mAaXzVgml/XYIJfuWC4HI1gUF9pYJZgMR6ilQHMAOwLAlDRefC0in4AXAEJA6PjCwc0IamOANMMCAECRQDFNRTZBgd+CwQlRA+r6+gLBDEFBnwUBXgKATIArwAGRAAHA3cDdAN2A3kDdwN9A3oDdQN7A30DfAN4A3oDfQAYEAAlAtYASwMAUAFsAHcKAHcAmgB3AHUAdQB2AHVu8UgAygDAAHcAdQB1AHYAdQALCgB3AAsAmgB3AAsCOwB3AAtu8UgAygDAAHgKAJoAdwB3AHUAdQB2AHUAeAB1AHUAdgB1bvFIAMoAwAALCgCaAHcACwB3AAsCOwB3AAtu8UgAygDAAH4ACwGgALcBpwC6AahdAu0COwLtbvFIAMoAwAALCgCaAu0ACwLtAAsCOwLtAAtu8UgAygDAA24ACwNvAAu0VsQAAzsAABCkjUIpAAsAUIusOggWcgMeBxVsGwL67U/2HlzmWOEeOgALASvuAAseAfpKUpnpGgYJDCIZM6YyARUE9ThqAD5iXQgnAJYJPnOzw0ZAEZxEKsIAkA4DhAHnTAIDxxUDK0lxCQlPYgIvIQVYJQBVqE1GakUAKGYiDToSBA1EtAYAXQJYAIF8GgMHRyAAIAjOe9YncekRAA0KACUrjwE7Ayc6AAYWAqaiKG4McEcqANoN3+Mg9TwCBhIkuCny+JwUQ29L008JluRxu3K+oAdqiHOqFH0AG5SUIfUJ5SxCGfxdipRzqTmT4V5Zb+r1Uo4Vm+NqSSEl2mNvR2JhIa8SpYO6ntdwFXHCWTCK8f2+Hxo7uiG3drDycAuKIMP5bhi06ACnqArH1rz4Rqg//lm6SgJGEVbF9xJHISaR6HxqxSnkw6shDnelHKNEfGUXSJRJ1GcsmtJw25xrZMDK9gXSm1/YMkdX4/6NKYOdtk/NQ3/NnDASjTc3fPjIjW/5sVfVObX2oTDWkr1dF9f3kxBsD3/3aQO8hPfRz+e0uEiJqt1161griu7gz8hDDwtpy+F+BWtefnKHZPAxcZoWbnznhJpy0e842j36bcNzGnIEusgGX0a8ZxsnjcSsPDZ09yZ36fCQbriHeQ72JRMILNl6ePPf2HWoVwgWAm1fb3V2sAY0+B6rAXqSwPBgseVmoqsBTSrm91+XasMYYySI8eeRxH3ZvHkMz3BQ5aJ3iUVbYPNM3/7emRtjlsMgv/9VyTsyt/mK+8fgWeT6SoFaclXqn42dAIsvAarF5vNNWHzKSkKQ/8Hfk5ZWK7r9yliOsooyBjRhfkHP4Q2DkWXQi6FG/9r/IwbmkV5T7JSopHKn1pJwm9tb5Ot0oyN1Z2mPpKXHTxx2nlK08fKk1hEYA8WgVVWL5lgx0iTv+KdojJeU23ZDjmiubXOxVXJKKi2Wjuh2HLZOFLiSC7Tls5SMh4f+Pj6xUSrNjFqLGehRNB8lC0QSLNmkJJx/wSG3MnjE9T1CkPwJI0wH2lfzwETIiVqUxg0dfu5q39Gt+hwdcxkhhNvQ4TyrBceof3Mhs/IxFci1HmHr4FMZgXEEczPiGCx0HRwzAqDq2j9AVm1kwN0mRVLWLylgtoPNapF5cY4Y1wJh/e0BBwZj44YgZrDNqvD/9Hv7GFYdUQeDJuQ3EWI4HaKqavU1XjC/n41kT4L79kqGq0kLhdTZvgP3TA3fS0ozVz+5piZsoOtIvBUFoMKbNcmBL6YxxaUAusHB38XrS8dQMnQwJfUUkpRoGr5AUeWicvBTzyK9g77+yCkf5PAysL7r/JjcZgrbvRpMW9iyaxZvKO6ceZN2EwIxKwVFPuvFuiEPGCoagbMo+SpydLrXqBzNCDGFCrO/rkcwa2xhokQZ5CdZ0AsU3JfSqJ6n5I14YA+P/uAgfhPU84Tlw7cEFfp7AEE8ey4sP12PTt4Cods1GRgDOB5xvyiR5m+Bx8O5nBCNctU8BevfV5A08x6RHd5jcwPTMDSZJOedIZ1cGQ704lxbAzqZOP05ZxaOghzSdvFBHYqomATARyAADK4elP8Ly3IrUZKfWh23Xy20uBUmLS4Pfagu9+oyVa2iPgqRP3F2CTUsvJ7+RYnN8fFZbU/HVvxvcFFDKkiTqV5UBZ3Gz54JAKByi9hkKMZJvuGgcSYXFmw08UyoQyVdfTD1/dMkCHXcTGAKeROgArsvmRrQTLUOXioOHGK2QkjHuoYFgXciZoTJd6Fs5q1QX1G+p/e26hYsEf7QZD1nnIyl/SFkNtYYmmBhpBrxl9WbY0YpHWRuw2Ll/tj9mD8P4snVzJl4F9J+1arVeTb9E5r2ILH04qStjxQNwn3m4YNqxmaNbLAqW2TN6LidwuJRqS+NXbtqxoeDXpxeGWmxzSkWxjkyCkX4NQRme6q5SAcC+M7+9ETfA/EwrzQajKakCwYyeunP6ZFlxU2oMEn1Pz31zeStW74G406ZJFCl1wAXIoUKkWotYEpOuXB1uVNxJ63dpJEqfxBeptwIHNrPz8BllZoIcBoXwgfJ+8VAUnVPvRvexnw0Ma/WiGYuJO5y8QTvEYBigFmhUxY5RqzE8OcywN/8m4UYrlaniJO75XQ6KSo9+tWHlu+hMi0UVdiKQp7NelnoZUzNaIyBPVeOwK6GNp+FfHuPOoyhaWuNvTYFkvxscMQWDh+zeFCFkgwbXftiV23ywJ4+uwRqmg9k3KzwIQpzppt8DBBOMbrqwQM5Gb05sEwdKzMiAqOloaA/lr0KA+1pr0/+HiWoiIjHA/wir2nIuS3PeU/ji3O6ZwoxcR1SZ9FhtLC5S0FIzFhbBWcGVP/KpxOPSiUoAdWUpqKH++6Scz507iCcxYI6rdMBICPJZea7OcmeFw5mObJSiqpjg2UoWNIs+cFhyDSt6geV5qgi3FunmwwDoGSMgerFOZGX1m0dMCYo5XOruxO063dwENK9DbnVM9wYFREzh4vyU1WYYJ/LRRp6oxgjqP/X5a8/4Af6p6NWkQferzBmXme0zY/4nwMJm/wd1tIqSwGz+E3xPEAOoZlJit3XddD7/BT1pllzOx+8bmQtANQ/S6fZexc6qi3W+Q2xcmXTUhuS5mpHQRvcxZUN0S5+PL9lXWUAaRZhEH8hTdAcuNMMCuVNKTEGtSUKNi3O6KhSaTzck8csZ2vWRZ+d7mW8c4IKwXIYd25S/zIftPkwPzufjEvOHWVD1m+FjpDVUTV0DGDuHj6QnaEwLu/dEgdLQOg9E1Sro9XHJ8ykLAwtPu+pxqKDuFexqON1sKQm7rwbE1E68UCfA/erovrTCG+DBSNg0l4goDQvZN6uNlbyLpcZAwj2UclycvLpIZMgv4yRlpb3YuMftozorbcGVHt/VeDV3+Fdf1TP0iuaCsPi2G4XeGhsyF1ubVDxkoJhmniQ0/jSg/eYML9KLfnCFgISWkp91eauR3IQvED0nAPXK+6hPCYs+n3+hCZbiskmVMG2da+0EsZPonUeIY8EbfusQXjsK/eFDaosbPjEfQS0RKG7yj5GG69M7MeO1HmiUYocgygJHL6M1qzUDDwUSmr99V7Sdr2F3JjQAJY+F0yH33Iv3+C9M38eML7gTgmNu/r2bUMiPvpYbZ6v1/IaESirBHNa7mPKn4dEmYg7v/+HQgPN1G79jBQ1+soydfDC2r+h2Bl/KIc5KjMK7OH6nb1jLsNf0EHVe2KBiE51ox636uyG6Lho0t3J34L5QY/ilE3mikaF4HKXG1mG1rCevT1Vv6GavltxoQe/bMrpZvRggnBxSEPEeEzkEdOxTnPXHVjUYdw8JYvjB/o7Eegc3Ma+NUxLLnsK0kJlinPmUHzHGtrk5+CAbVzFOBqpyy3QVUnzTDfC/0XD94/okH+OB+i7g9lolhWIjSnfIb+Eq43ZXOWmwvjyV/qqD+t0e+7mTEM74qP/Ozt8nmC7mRpyu63OB4KnUzFc074SqoyPUAgM+/TJGFo6T44EHnQU4X4z6qannVqgw/U7zCpwcmXV1AubIrvOmkKHazJAR55ePjp5tLBsN8vAqs3NAHdcEHOR2xQ0lsNAFzSUuxFQCFYvXLZJdOj9p4fNq6p0HBGUik2YzaI4xySy91KzhQ0+q1hjxvImRwPRf76tChlRkhRCi74NXZ9qUNeIwP+s5p+3m5nwPdNOHgSLD79n7O9m1n1uDHiMntq4nkYwV5OZ1ENbXxFd4PgrlvavZsyUO4MqYlqqn1O8W/I1dEZq5dXhrbETLaZIbC2Kj/Aa/QM+fqUOHdf0tXAQ1huZ3cmWECWSXy/43j35+Mvq9xws7JKseriZ1pEWKc8qlzNrGPUGcVgOa9cPJYIJsGnJTAUsEcDOEVULO5x0rXBijc1lgXEzQQKhROf8zIV82w8eswc78YX11KYLWQRcgHNJElBxfXr72lS2RBSl07qTKorO2uUDZr3sFhYsvnhLZn0A94KRzJ/7DEGIAhW5ZWFpL8gEwu1aLA9MuWZzNwl8Oze9Y+bX+v9gywRVnoB5I/8kXTXU3141yRLYrIOOz6SOnyHNy4SieqzkBXharjfjqq1q6tklaEbA8Qfm2DaIPs7OTq/nvJBjKfO2H9bH2cCMh1+5gspfycu8f/cuuRmtDjyqZ7uCIMyjdV3a+p3fqmXsRx4C8lujezIFHnQiVTXLXuI1XrwN3+siYYj2HHTvESUx8DlOTXpak9qFRK+L3mgJ1WsD7F4cu1aJoFoYQnu+wGDMOjJM3kiBQWHCcvhJ/HRdxodOQp45YZaOTA22Nb4XKCVxqkbwMYFhzYQYIAnCW8FW14uf98jhUG2zrKhQQ0q0CEq0t5nXyvUyvR8DvD69LU+g3i+HFWQMQ8PqZuHD+sNKAV0+M6EJC0szq7rEr7B5bQ8BcNHzvDMc9eqB5ZCQdTf80Obn4uzjwpYU7SISdtV0QGa9D3Wrh2BDQtpBKxaNFV+/Cy2P/Sv+8s7Ud0Fd74X4+o/TNztWgETUapy+majNQ68Lq3ee0ZO48VEbTZYiH1Co4OlfWef82RWeyUXo7woM03PyapGfikTnQinoNq5z5veLpeMV3HCAMTaZmA1oGLAn7XS3XYsz+XK7VMQsc4XKrmDXOLU/pSXVNUq8dIqTba///3x6LiLS6xs1xuCAYSfcQ3+rQgmu7uvf3THKt5Ooo97TqcbRqxx7EASizaQCBQllG/rYxVapMLgtLbZS64w1MDBMXX+PQpBKNwqUKOf2DDRDUXQf9EhOS0Qj4nTmlA8dzSLz/G1d+Ud8MTy/6ghhdiLpeerGY/UlDOfiuqFsMUU5/UYlP+BAmgRLuNpvrUaLlVkrqDievNVEAwF+4CoM1MZTmjxjJMsKJq+u8Zd7tNCUFy6LiyYXRJQ4VyvEQFFaCGKsxIwQkk7EzZ6LTJq2hUuPhvAW+gQnSG6J+MszC+7QCRHcnqDdyNRJ6T9xyS87A6MDutbzKGvGktpbXqtzWtXb9HsfK2cBMomjN9a4y+TaJLnXxAeX/HWzmf4cR4vALt/P4w4qgKY04ml4ZdLOinFYS6cup3G/1ie4+t1eOnpBNlqGqs75ilzkT4+DsZQxNvaSKJ//6zIbbk/M7LOhFmRc/1R+kBtz7JFGdZm/COotIdvQoXpTqP/1uqEUmCb/QWoGLMwO5ANcHzxdY48IGP5+J+zKOTBFZ4Pid+GTM+Wq12MV/H86xEJptBa6T+p3kgpwLedManBHC2GgNrFpoN2xnrMz9WFWX/8/ygSBkavq2Uv7FdCsLEYLu9LLIvAU0bNRDtzYl+/vXmjpIvuJFYjmI0im6QEYqnIeMsNjXG4vIutIGHijeAG/9EDBozKV5cldkHbLxHh25vT+ZEzbhXlqvpzKJwcEgfNwLAKFeo0/pvEE10XDB+EXRTXtSzJozQKFFAJhMxYkVaCW+E9AL7tMeU8acxidHqzb6lX4691UsDpy/LLRmT+epgW56+5Cw8tB4kMUv6s9lh3eRKbyGs+H/4mQMaYzPTf2OOdokEn+zzgvoD3FqNKk8QqGAXVsqcGdXrT62fSPkR2vROFi68A6se86UxRUk4cajfPyCC4G5wDhD+zNq4jodQ4u4n/m37Lr36n4LIAAsVr02dFi9AiwA81MYs2rm4eDlDNmdMRvEKRHfBwW5DdMNp0jPFZMeARqF/wL4XBfd+EMLBfMzpH5GH6NaW+1vrvMdg+VxDzatk3MXgO3ro3P/DpcC6+Mo4MySJhKJhSR01SGGGp5hPWmrrUgrv3lDnP+HhcI3nt3YqBoVAVTBAQT5iuhTg8nvPtd8ZeYj6w1x6RqGUBrSku7+N1+BaasZvjTk64RoIDlL8brpEcJx3OmY7jLoZsswdtmhfC/G21llXhITOwmvRDDeTTPbyASOa16cF5/A1fZAidJpqju3wYAy9avPR1ya6eNp9K8XYrrtuxlqi+bDKwlfrYdR0RRiKRVTLOH85+ZY7XSmzRpfZBJjaTa81VDcJHpZnZnSQLASGYW9l51ZV/h7eVzTi3Hv6hUsgc/51AqJRTkpbFVLXXszoBL8nBX0u/0jBLT8nH+fJePbrwURT58OY+UieRjd1vs04w0VG5VN2U6MoGZkQzKN/ptz0Q366dxoTGmj7i1NQGHi9GgnquXFYdrCfZBmeb7s0T6yrdlZH5cZuwHFyIJ/kAtGsTg0xH5taAAq44BAk1CPk9KVVbqQzrCUiFdF/6gtlPQ8bHHc1G1W92MXGZ5HEHftyLYs8mbD/9xYRUWkHmlM0zC2ilJlnNgV4bfALpQghxOUoZL7VTqtCHIaQSXm+YUMnpkXybnV+A6xlm2CVy8fn0Xlm2XRa0+zzOa21JWWmixfiPMSCZ7qA4rS93VN3pkpF1s5TonQjisHf7iU9ZGvUPOAKZcR1pbeVf/Ul7OhepGCaId9wOtqo7pJ7yLcBZ0pFkOF28y4zEI/kcUNmutBHaQpBdNM8vjCS6HZRokkeo88TBAjGyG7SR+6vUgTcyK9Imalj0kuxz0wmK+byQU11AiJFk/ya5dNduRClcnU64yGu/ieWSeOos1t3ep+RPIWQ2pyTYVbZltTbsb7NiwSi3AV+8KLWk7LxCnfZUetEM8ThnsSoGH38/nyAwFguJp8FjvlHtcWZuU4hPva0rHfr0UhOOJ/F6vS62FW7KzkmRll2HEc7oUq4fyi5T70Vl7YVIfsPHUCdHesf9Lk7WNVWO75JDkYbMI8TOW8JKVtLY9d6UJRITO8oKo0xS+o99Yy04iniGHAaGj88kEWgwv0OrHdY/nr76DOGNS59hXCGXzTKUvDl9iKpLSWYN1lxIeyywdNpTkhay74w2jFT6NS8qkjo5CxA1yfSYwp6AJIZNKIeEK5PJAW7ORgWgwp0VgzYpqovMrWxbu+DGZ6Lhie1RAqpzm8VUzKJOH3mCzWuTOLsN3VT/dv2eeYe9UjbR8YTBsLz7q60VN1sU51k+um1f8JxD5pPhbhSC8rRaB454tmh6YUWrJI3+GWY0qeWioj/tbkYITOkJaeuGt4JrJvHA+l0Gu7kY7XOaa05alMnRWVCXqFgLIwSY4uF59Ue5SU4QKuc/HamDxbr0x6csCetXGoP7Qn1Bk/J9DsynO/UD6iZ1Hyrz+jit0hDCwi/E9OjgKTbB3ZQKQ/0ZOvevfNHG0NK4Aj3Cp7NpRk07RT1i/S0EL93Ag8GRgKI9CfpajKyK6+Jj/PI1KO5/85VAwz2AwzP8FTBb075IxCXv6T9RVvWT2tUaqxDS92zrGUbWzUYk9mSs82pECH+fkqsDt93VW++4YsR/dHCYcQSYTO/KaBMDj9LSD/J/+z20Kq8XvZUAIHtm9hRPP3ItbuAu2Hm5lkPs92pd7kCxgRs0xOVBnZ13ccdA0aunrwv9SdqElJRC3g+oCu+nXyCgmXUs9yMjTMAIHfxZV+aPKcZeUBWt057Xo85Ks1Ir5gzEHCWqZEhrLZMuF11ziGtFQUds/EESajhagzcKsxamcSZxGth4UII+adPhQkUnx2WyN+4YWR+r3f8MnkyGFuR4zjzxJS8WsQYR5PTyRaD9ixa6Mh741nBHbzfjXHskGDq179xaRNrCIB1z1xRfWfjqw2pHc1zk9xlPpL8sQWAIuETZZhbnmL54rceXVNRvUiKrrqIkeogsl0XXb17ylNb0f4GA9Wd44vffEG8FSZGHEL2fbaTGRcSiCeA8PmA/f6Hz8HCS76fXUHwgwkzSwlI71ekZ7Fapmlk/KC+Hs8hUcw3N2LN5LhkVYyizYFl/uPeVP5lsoJHhhfWvvSWruCUW1ZcJOeuTbrDgywJ/qG07gZJplnTvLcYdNaH0KMYOYMGX+rB4NGPFmQsNaIwlWrfCezxre8zXBrsMT+edVLbLqN1BqB76JH4BvZTqUIMfGwPGEn+EnmTV86fPBaYbFL3DFEhjB45CewkXEAtJxk4/Ms2pPXnaRqdky0HOYdcUcE2zcXq4vaIvW2/v0nHFJH2XXe22ueDmq/18XGtELSq85j9X8q0tcNSSKJIX8FTuJF/Pf8j5PhqG2u+osvsLxYrvvfeVJL+4tkcXcr9JV7v0ERmj/X6fM3NC4j6dS1+9Umr2oPavqiAydTZPLMNRGY23LO9zAVDly7jD+70G5TPPLdhRIl4WxcYjLnM+SNcJ26FOrkrISUtPObIz5Zb3AG612krnpy15RMW+1cQjlnWFI6538qky9axd2oJmHIHP08KyP0ubGO+TQNOYuv2uh17yCIvR8VcStw7o1g0NM60sk+8Tq7YfIBJrtp53GkvzXH7OA0p8/n/u1satf/VJhtR1l8Wa6Gmaug7haSpaCaYQax6ta0mkutlb+eAOSG1aobM81D9A4iS1RRlzBBoVX6tU1S6WE2N9ORY6DfeLRC4l9Rvr5h95XDWB2mR1d4WFudpsgVYwiTwT31ljskD8ZyDOlm5DkGh9N/UB/0AI5Xvb8ZBmai2hQ4BWMqFwYnzxwB26YHSOv9WgY3JXnvoN+2R4rqGVh/LLDMtpFP+SpMGJNWvbIl5SOodbCczW2RKleksPoUeGEzrjtKHVdtZA+kfqO+rVx/iclCqwoopepvJpSTDjT+b9GWylGRF8EDbGlw6eUzmJM95Ovoz+kwLX3c2fTjFeYEsE7vUZm3mqdGJuKh2w9/QGSaqRHs99aScGOdDqkFcACoqdbBoQqqjamhH6Q9ng39JCg3lrGJwd50Qk9ovnqBTr8MME7Ps2wiVfygUmPoUBJJfJWX5Nda0nuncbFkA=="));
}



const $cecb159d53c0fe21$var$r = (0, $584fcc90974ab591$export$7a171f172be0782e)();
// @TODO: This should be lazily loaded
const $cecb159d53c0fe21$var$VALID = new Set((0, $27e1c16409ffff0a$export$9303bf4e1ede4914)($cecb159d53c0fe21$var$r));
const $cecb159d53c0fe21$var$IGNORED = new Set((0, $27e1c16409ffff0a$export$9303bf4e1ede4914)($cecb159d53c0fe21$var$r));
const $cecb159d53c0fe21$var$MAPPED = (0, $27e1c16409ffff0a$export$824d00fb01c38bd9)($cecb159d53c0fe21$var$r);
const $cecb159d53c0fe21$var$EMOJI_ROOT = (0, $27e1c16409ffff0a$export$d7b24c6ce369e1b7)($cecb159d53c0fe21$var$r);
//const NFC_CHECK = new Set(read_member_array(r, Array.from(VALID.values()).sort((a, b) => a - b)));
//const STOP = 0x2E;
const $cecb159d53c0fe21$var$HYPHEN = 0x2D;
const $cecb159d53c0fe21$var$UNDERSCORE = 0x5F;
function $cecb159d53c0fe21$var$explode_cp(name) {
    return (0, $7bbf1261c840221b$export$ae470a36a31b28c2)(name);
}
function $cecb159d53c0fe21$var$filter_fe0f(cps) {
    return cps.filter((cp)=>cp != 0xFE0F);
}
function $cecb159d53c0fe21$export$5252e54b57fcf4fd(name) {
    for (let label of name.split(".")){
        let cps = $cecb159d53c0fe21$var$explode_cp(label);
        try {
            for(let i = cps.lastIndexOf($cecb159d53c0fe21$var$UNDERSCORE) - 1; i >= 0; i--){
                if (cps[i] !== $cecb159d53c0fe21$var$UNDERSCORE) throw new Error(`underscore only allowed at start`);
            }
            if (cps.length >= 4 && cps.every((cp)=>cp < 0x80) && cps[2] === $cecb159d53c0fe21$var$HYPHEN && cps[3] === $cecb159d53c0fe21$var$HYPHEN) throw new Error(`invalid label extension`);
        } catch (err) {
            throw new Error(`Invalid label "${label}": ${err.message}`);
        }
    }
    return name;
}
function $cecb159d53c0fe21$export$499f715881831a51(name) {
    return $cecb159d53c0fe21$export$5252e54b57fcf4fd($cecb159d53c0fe21$var$normalize(name, $cecb159d53c0fe21$var$filter_fe0f));
}
function $cecb159d53c0fe21$var$normalize(name, emoji_filter) {
    let input = $cecb159d53c0fe21$var$explode_cp(name).reverse(); // flip for pop
    let output = [];
    while(input.length){
        let emoji = $cecb159d53c0fe21$var$consume_emoji_reversed(input);
        if (emoji) {
            output.push(...emoji_filter(emoji));
            continue;
        }
        let cp = input.pop();
        if ($cecb159d53c0fe21$var$VALID.has(cp)) {
            output.push(cp);
            continue;
        }
        if ($cecb159d53c0fe21$var$IGNORED.has(cp)) continue;
        let cps = $cecb159d53c0fe21$var$MAPPED[cp];
        if (cps) {
            output.push(...cps);
            continue;
        }
        throw new Error(`Disallowed codepoint: 0x${cp.toString(16).toUpperCase()}`);
    }
    return $cecb159d53c0fe21$export$5252e54b57fcf4fd($cecb159d53c0fe21$var$nfc(String.fromCodePoint(...output)));
}
function $cecb159d53c0fe21$var$nfc(s) {
    return s.normalize("NFC");
}
function $cecb159d53c0fe21$var$consume_emoji_reversed(cps, eaten) {
    var _a;
    let node = $cecb159d53c0fe21$var$EMOJI_ROOT;
    let emoji;
    let saved;
    let stack = [];
    let pos = cps.length;
    if (eaten) eaten.length = 0; // clear input buffer (if needed)
    while(pos){
        let cp = cps[--pos];
        node = (_a = node.branches.find((x)=>x.set.has(cp))) === null || _a === void 0 ? void 0 : _a.node;
        if (!node) break;
        if (node.save) saved = cp;
        else if (node.check) {
            if (cp === saved) break;
        }
        stack.push(cp);
        if (node.fe0f) {
            stack.push(0xFE0F);
            if (pos > 0 && cps[pos - 1] == 0xFE0F) pos--; // consume optional FE0F
        }
        if (node.valid) {
            emoji = stack.slice(); // copy stack
            if (node.valid == 2) emoji.splice(1, 1); // delete FE0F at position 1 (RGI ZWJ don't follow spec!)
            if (eaten) eaten.push(...cps.slice(pos).reverse()); // copy input (if needed)
            cps.length = pos; // truncate
        }
    }
    return emoji;
}


const $0e4d091b6edb4637$var$logger = new (0, $5f596c9584f643ae$export$efa9a398d6368992)((0, $3f74d983611b69f1$export$83d89fbfd8236492));
const $0e4d091b6edb4637$var$Zeros = new Uint8Array(32);
$0e4d091b6edb4637$var$Zeros.fill(0);
function $0e4d091b6edb4637$var$checkComponent(comp) {
    if (comp.length === 0) throw new Error("invalid ENS name; empty component");
    return comp;
}
function $0e4d091b6edb4637$var$ensNameSplit(name) {
    const bytes = (0, $7bbf1261c840221b$export$8feeb310b4b4752f)((0, $cecb159d53c0fe21$export$499f715881831a51)(name));
    const comps = [];
    if (name.length === 0) return comps;
    let last = 0;
    for(let i = 0; i < bytes.length; i++){
        const d = bytes[i];
        // A separator (i.e. "."); copy this component
        if (d === 0x2e) {
            comps.push($0e4d091b6edb4637$var$checkComponent(bytes.slice(last, i)));
            last = i + 1;
        }
    }
    // There was a stray separator at the end of the name
    if (last >= bytes.length) throw new Error("invalid ENS name; empty component");
    comps.push($0e4d091b6edb4637$var$checkComponent(bytes.slice(last)));
    return comps;
}
function $0e4d091b6edb4637$export$5f232fd2f1a1e8ac(name) {
    return $0e4d091b6edb4637$var$ensNameSplit(name).map((comp)=>(0, $7bbf1261c840221b$export$7643a1dc2c38d5eb)(comp)).join(".");
}
function $0e4d091b6edb4637$export$cce2300886e7ace6(name) {
    try {
        return $0e4d091b6edb4637$var$ensNameSplit(name).length !== 0;
    } catch (error) {}
    return false;
}
function $0e4d091b6edb4637$export$91d651ee363e1209(name) {
    /* istanbul ignore if */ if (typeof name !== "string") $0e4d091b6edb4637$var$logger.throwArgumentError("invalid ENS name; not a string", "name", name);
    let result = $0e4d091b6edb4637$var$Zeros;
    const comps = $0e4d091b6edb4637$var$ensNameSplit(name);
    while(comps.length)result = (0, $62e3396d458230e9$export$f8151fce47ad1c35)((0, $06d75ae17ce69367$export$ee1b3e54f0441b22)([
        result,
        (0, $62e3396d458230e9$export$f8151fce47ad1c35)(comps.pop())
    ]));
    return (0, $06d75ae17ce69367$export$2b0d6b5fbe698c70)(result);
}
function $0e4d091b6edb4637$export$6c0a8cdae51cb512(name) {
    return (0, $06d75ae17ce69367$export$2b0d6b5fbe698c70)((0, $06d75ae17ce69367$export$ee1b3e54f0441b22)($0e4d091b6edb4637$var$ensNameSplit(name).map((comp)=>{
        // DNS does not allow components over 63 bytes in length
        if (comp.length > 63) throw new Error("invalid DNS encoded entry; length exceeds 63 bytes");
        const bytes = new Uint8Array(comp.length + 1);
        bytes.set(comp, 1);
        bytes[0] = bytes.length - 1;
        return bytes;
    }))) + "00";
}





var $leqJp = parcelRequire("leqJp");

var $c4af312545dae30d$export$d2a8849cfb277c;
(function(SupportedAlgorithm) {
    SupportedAlgorithm["sha256"] = "sha256";
    SupportedAlgorithm["sha512"] = "sha512";
})($c4af312545dae30d$export$d2a8849cfb277c || ($c4af312545dae30d$export$d2a8849cfb277c = {}));



const $d616ecab8a4a7575$export$83d89fbfd8236492 = "sha2/5.7.0";


"use strict";
const $ad6b4320c60d6c47$var$logger = new (0, $5f596c9584f643ae$export$efa9a398d6368992)((0, $d616ecab8a4a7575$export$83d89fbfd8236492));
function $ad6b4320c60d6c47$export$d1cea0ee4e3f0d3e(data) {
    return "0x" + (0, (/*@__PURE__*/$parcel$interopDefault($leqJp))).ripemd160().update((0, $06d75ae17ce69367$export$3131421a7d01b4fb)(data)).digest("hex");
}
function $ad6b4320c60d6c47$export$bced8d2aada2d1c9(data) {
    return "0x" + (0, (/*@__PURE__*/$parcel$interopDefault($leqJp))).sha256().update((0, $06d75ae17ce69367$export$3131421a7d01b4fb)(data)).digest("hex");
}
function $ad6b4320c60d6c47$export$a888d2532e6dc7bb(data) {
    return "0x" + (0, (/*@__PURE__*/$parcel$interopDefault($leqJp))).sha512().update((0, $06d75ae17ce69367$export$3131421a7d01b4fb)(data)).digest("hex");
}
function $ad6b4320c60d6c47$export$967075d2f3b8e7ff(algorithm, key, data) {
    if (!(0, $c4af312545dae30d$export$d2a8849cfb277c)[algorithm]) $ad6b4320c60d6c47$var$logger.throwError("unsupported algorithm " + algorithm, (0, $5f596c9584f643ae$export$efa9a398d6368992).errors.UNSUPPORTED_OPERATION, {
        operation: "hmac",
        algorithm: algorithm
    });
    return "0x" + (0, (/*@__PURE__*/$parcel$interopDefault($leqJp))).hmac((0, (/*@__PURE__*/$parcel$interopDefault($leqJp)))[algorithm], (0, $06d75ae17ce69367$export$3131421a7d01b4fb)(key)).update((0, $06d75ae17ce69367$export$3131421a7d01b4fb)(data)).digest("hex");
}



var $1f5b367caa9efc4a$exports = {};

$parcel$export($1f5b367caa9efc4a$exports, "_fetchData", function () { return $1f5b367caa9efc4a$export$e37fa27017c6c012; });
$parcel$export($1f5b367caa9efc4a$exports, "fetchJson", function () { return $1f5b367caa9efc4a$export$6d71b655afe1638d; });
$parcel$export($1f5b367caa9efc4a$exports, "poll", function () { return $1f5b367caa9efc4a$export$e0c10349b2c5e1d4; });





const $e339deefa12d3888$export$83d89fbfd8236492 = "web/5.7.1";


var $345030b65075326d$exports = {};

$parcel$export($345030b65075326d$exports, "getUrl", function () { return $345030b65075326d$export$94df0e59ebebf4a7; });

"use strict";
var $345030b65075326d$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
function $345030b65075326d$export$94df0e59ebebf4a7(href, options) {
    return $345030b65075326d$var$__awaiter(this, void 0, void 0, function*() {
        if (options == null) options = {};
        const request = {
            method: options.method || "GET",
            headers: options.headers || {},
            body: options.body || undefined
        };
        if (options.skipFetchSetup !== true) {
            request.mode = "cors"; // no-cors, cors, *same-origin
            request.cache = "no-cache"; // *default, no-cache, reload, force-cache, only-if-cached
            request.credentials = "same-origin"; // include, *same-origin, omit
            request.redirect = "follow"; // manual, *follow, error
            request.referrer = "client"; // no-referrer, *client
        }
        if (options.fetchOptions != null) {
            const opts = options.fetchOptions;
            if (opts.mode) request.mode = opts.mode;
            if (opts.cache) request.cache = opts.cache;
            if (opts.credentials) request.credentials = opts.credentials;
            if (opts.redirect) request.redirect = opts.redirect;
            if (opts.referrer) request.referrer = opts.referrer;
        }
        const response = yield fetch(href, request);
        const body = yield response.arrayBuffer();
        const headers = {};
        if (response.headers.forEach) response.headers.forEach((value, key)=>{
            headers[key.toLowerCase()] = value;
        });
        else response.headers.keys().forEach((key)=>{
            headers[key.toLowerCase()] = response.headers.get(key);
        });
        return {
            headers: headers,
            statusCode: response.status,
            statusMessage: response.statusText,
            body: (0, $06d75ae17ce69367$export$3131421a7d01b4fb)(new Uint8Array(body))
        };
    });
}


"use strict";
var $1f5b367caa9efc4a$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
const $1f5b367caa9efc4a$var$logger = new (0, $5f596c9584f643ae$export$efa9a398d6368992)((0, $e339deefa12d3888$export$83d89fbfd8236492));
function $1f5b367caa9efc4a$var$staller(duration) {
    return new Promise((resolve)=>{
        setTimeout(resolve, duration);
    });
}
function $1f5b367caa9efc4a$var$bodyify(value, type) {
    if (value == null) return null;
    if (typeof value === "string") return value;
    if ((0, $06d75ae17ce69367$export$9a14abb1a440cd5e)(value)) {
        if (type && (type.split("/")[0] === "text" || type.split(";")[0].trim() === "application/json")) try {
            return (0, $7bbf1261c840221b$export$7643a1dc2c38d5eb)(value);
        } catch (error) {}
        return (0, $06d75ae17ce69367$export$2b0d6b5fbe698c70)(value);
    }
    return value;
}
function $1f5b367caa9efc4a$var$unpercent(value) {
    return (0, $7bbf1261c840221b$export$8feeb310b4b4752f)(value.replace(/%([0-9a-f][0-9a-f])/gi, (all, code)=>{
        return String.fromCharCode(parseInt(code, 16));
    }));
}
function $1f5b367caa9efc4a$export$e37fa27017c6c012(connection, body, processFunc) {
    // How many times to retry in the event of a throttle
    const attemptLimit = typeof connection === "object" && connection.throttleLimit != null ? connection.throttleLimit : 12;
    $1f5b367caa9efc4a$var$logger.assertArgument(attemptLimit > 0 && attemptLimit % 1 === 0, "invalid connection throttle limit", "connection.throttleLimit", attemptLimit);
    const throttleCallback = typeof connection === "object" ? connection.throttleCallback : null;
    const throttleSlotInterval = typeof connection === "object" && typeof connection.throttleSlotInterval === "number" ? connection.throttleSlotInterval : 100;
    $1f5b367caa9efc4a$var$logger.assertArgument(throttleSlotInterval > 0 && throttleSlotInterval % 1 === 0, "invalid connection throttle slot interval", "connection.throttleSlotInterval", throttleSlotInterval);
    const errorPassThrough = typeof connection === "object" ? !!connection.errorPassThrough : false;
    const headers = {};
    let url = null;
    // @TODO: Allow ConnectionInfo to override some of these values
    const options = {
        method: "GET"
    };
    let allow304 = false;
    let timeout = 120000;
    if (typeof connection === "string") url = connection;
    else if (typeof connection === "object") {
        if (connection == null || connection.url == null) $1f5b367caa9efc4a$var$logger.throwArgumentError("missing URL", "connection.url", connection);
        url = connection.url;
        if (typeof connection.timeout === "number" && connection.timeout > 0) timeout = connection.timeout;
        if (connection.headers) for(const key in connection.headers){
            headers[key.toLowerCase()] = {
                key: key,
                value: String(connection.headers[key])
            };
            if ([
                "if-none-match",
                "if-modified-since"
            ].indexOf(key.toLowerCase()) >= 0) allow304 = true;
        }
        options.allowGzip = !!connection.allowGzip;
        if (connection.user != null && connection.password != null) {
            if (url.substring(0, 6) !== "https:" && connection.allowInsecureAuthentication !== true) $1f5b367caa9efc4a$var$logger.throwError("basic authentication requires a secure https url", (0, $5f596c9584f643ae$export$efa9a398d6368992).errors.INVALID_ARGUMENT, {
                argument: "url",
                url: url,
                user: connection.user,
                password: "[REDACTED]"
            });
            const authorization = connection.user + ":" + connection.password;
            headers["authorization"] = {
                key: "Authorization",
                value: "Basic " + (0, $197fdee3ede33bf0$export$c564cdbbe6da493)((0, $7bbf1261c840221b$export$8feeb310b4b4752f)(authorization))
            };
        }
        if (connection.skipFetchSetup != null) options.skipFetchSetup = !!connection.skipFetchSetup;
        if (connection.fetchOptions != null) options.fetchOptions = (0, $d2d9b472f7878d5e$exports.shallowCopy)(connection.fetchOptions);
    }
    const reData = new RegExp("^data:([^;:]*)?(;base64)?,(.*)$", "i");
    const dataMatch = url ? url.match(reData) : null;
    if (dataMatch) try {
        const response = {
            statusCode: 200,
            statusMessage: "OK",
            headers: {
                "content-type": dataMatch[1] || "text/plain"
            },
            body: dataMatch[2] ? (0, $197fdee3ede33bf0$export$2f872c0f2117be69)(dataMatch[3]) : $1f5b367caa9efc4a$var$unpercent(dataMatch[3])
        };
        let result = response.body;
        if (processFunc) result = processFunc(response.body, response);
        return Promise.resolve(result);
    } catch (error) {
        $1f5b367caa9efc4a$var$logger.throwError("processing response error", (0, $5f596c9584f643ae$export$efa9a398d6368992).errors.SERVER_ERROR, {
            body: $1f5b367caa9efc4a$var$bodyify(dataMatch[1], dataMatch[2]),
            error: error,
            requestBody: null,
            requestMethod: "GET",
            url: url
        });
    }
    if (body) {
        options.method = "POST";
        options.body = body;
        if (headers["content-type"] == null) headers["content-type"] = {
            key: "Content-Type",
            value: "application/octet-stream"
        };
        if (headers["content-length"] == null) headers["content-length"] = {
            key: "Content-Length",
            value: String(body.length)
        };
    }
    const flatHeaders = {};
    Object.keys(headers).forEach((key)=>{
        const header = headers[key];
        flatHeaders[header.key] = header.value;
    });
    options.headers = flatHeaders;
    const runningTimeout = function() {
        let timer = null;
        const promise = new Promise(function(resolve, reject) {
            if (timeout) timer = setTimeout(()=>{
                if (timer == null) return;
                timer = null;
                reject($1f5b367caa9efc4a$var$logger.makeError("timeout", (0, $5f596c9584f643ae$export$efa9a398d6368992).errors.TIMEOUT, {
                    requestBody: $1f5b367caa9efc4a$var$bodyify(options.body, flatHeaders["content-type"]),
                    requestMethod: options.method,
                    timeout: timeout,
                    url: url
                }));
            }, timeout);
        });
        const cancel = function() {
            if (timer == null) return;
            clearTimeout(timer);
            timer = null;
        };
        return {
            promise: promise,
            cancel: cancel
        };
    }();
    const runningFetch = function() {
        return $1f5b367caa9efc4a$var$__awaiter(this, void 0, void 0, function*() {
            for(let attempt = 0; attempt < attemptLimit; attempt++){
                let response = null;
                try {
                    response = yield (0, $345030b65075326d$exports.getUrl)(url, options);
                    if (attempt < attemptLimit) {
                        if (response.statusCode === 301 || response.statusCode === 302) {
                            // Redirection; for now we only support absolute locataions
                            const location = response.headers.location || "";
                            if (options.method === "GET" && location.match(/^https:/)) {
                                url = response.headers.location;
                                continue;
                            }
                        } else if (response.statusCode === 429) {
                            // Exponential back-off throttling
                            let tryAgain = true;
                            if (throttleCallback) tryAgain = yield throttleCallback(attempt, url);
                            if (tryAgain) {
                                let stall = 0;
                                const retryAfter = response.headers["retry-after"];
                                if (typeof retryAfter === "string" && retryAfter.match(/^[1-9][0-9]*$/)) stall = parseInt(retryAfter) * 1000;
                                else stall = throttleSlotInterval * parseInt(String(Math.random() * Math.pow(2, attempt)));
                                //console.log("Stalling 429");
                                yield $1f5b367caa9efc4a$var$staller(stall);
                                continue;
                            }
                        }
                    }
                } catch (error) {
                    response = error.response;
                    if (response == null) {
                        runningTimeout.cancel();
                        $1f5b367caa9efc4a$var$logger.throwError("missing response", (0, $5f596c9584f643ae$export$efa9a398d6368992).errors.SERVER_ERROR, {
                            requestBody: $1f5b367caa9efc4a$var$bodyify(options.body, flatHeaders["content-type"]),
                            requestMethod: options.method,
                            serverError: error,
                            url: url
                        });
                    }
                }
                let body = response.body;
                if (allow304 && response.statusCode === 304) body = null;
                else if (!errorPassThrough && (response.statusCode < 200 || response.statusCode >= 300)) {
                    runningTimeout.cancel();
                    $1f5b367caa9efc4a$var$logger.throwError("bad response", (0, $5f596c9584f643ae$export$efa9a398d6368992).errors.SERVER_ERROR, {
                        status: response.statusCode,
                        headers: response.headers,
                        body: $1f5b367caa9efc4a$var$bodyify(body, response.headers ? response.headers["content-type"] : null),
                        requestBody: $1f5b367caa9efc4a$var$bodyify(options.body, flatHeaders["content-type"]),
                        requestMethod: options.method,
                        url: url
                    });
                }
                if (processFunc) try {
                    const result = yield processFunc(body, response);
                    runningTimeout.cancel();
                    return result;
                } catch (error) {
                    // Allow the processFunc to trigger a throttle
                    if (error.throttleRetry && attempt < attemptLimit) {
                        let tryAgain = true;
                        if (throttleCallback) tryAgain = yield throttleCallback(attempt, url);
                        if (tryAgain) {
                            const timeout = throttleSlotInterval * parseInt(String(Math.random() * Math.pow(2, attempt)));
                            //console.log("Stalling callback");
                            yield $1f5b367caa9efc4a$var$staller(timeout);
                            continue;
                        }
                    }
                    runningTimeout.cancel();
                    $1f5b367caa9efc4a$var$logger.throwError("processing response error", (0, $5f596c9584f643ae$export$efa9a398d6368992).errors.SERVER_ERROR, {
                        body: $1f5b367caa9efc4a$var$bodyify(body, response.headers ? response.headers["content-type"] : null),
                        error: error,
                        requestBody: $1f5b367caa9efc4a$var$bodyify(options.body, flatHeaders["content-type"]),
                        requestMethod: options.method,
                        url: url
                    });
                }
                runningTimeout.cancel();
                // If we had a processFunc, it either returned a T or threw above.
                // The "body" is now a Uint8Array.
                return body;
            }
            return $1f5b367caa9efc4a$var$logger.throwError("failed response", (0, $5f596c9584f643ae$export$efa9a398d6368992).errors.SERVER_ERROR, {
                requestBody: $1f5b367caa9efc4a$var$bodyify(options.body, flatHeaders["content-type"]),
                requestMethod: options.method,
                url: url
            });
        });
    }();
    return Promise.race([
        runningTimeout.promise,
        runningFetch
    ]);
}
function $1f5b367caa9efc4a$export$6d71b655afe1638d(connection, json, processFunc) {
    let processJsonFunc = (value, response)=>{
        let result = null;
        if (value != null) try {
            result = JSON.parse((0, $7bbf1261c840221b$export$7643a1dc2c38d5eb)(value));
        } catch (error) {
            $1f5b367caa9efc4a$var$logger.throwError("invalid JSON", (0, $5f596c9584f643ae$export$efa9a398d6368992).errors.SERVER_ERROR, {
                body: value,
                error: error
            });
        }
        if (processFunc) result = processFunc(result, response);
        return result;
    };
    // If we have json to send, we must
    // - add content-type of application/json (unless already overridden)
    // - convert the json to bytes
    let body = null;
    if (json != null) {
        body = (0, $7bbf1261c840221b$export$8feeb310b4b4752f)(json);
        // Create a connection with the content-type set for JSON
        const updated = typeof connection === "string" ? {
            url: connection
        } : (0, $d2d9b472f7878d5e$exports.shallowCopy)(connection);
        if (updated.headers) {
            const hasContentType = Object.keys(updated.headers).filter((k)=>k.toLowerCase() === "content-type").length !== 0;
            if (!hasContentType) {
                updated.headers = (0, $d2d9b472f7878d5e$exports.shallowCopy)(updated.headers);
                updated.headers["content-type"] = "application/json";
            }
        } else updated.headers = {
            "content-type": "application/json"
        };
        connection = updated;
    }
    return $1f5b367caa9efc4a$export$e37fa27017c6c012(connection, body, processJsonFunc);
}
function $1f5b367caa9efc4a$export$e0c10349b2c5e1d4(func, options) {
    if (!options) options = {};
    options = (0, $d2d9b472f7878d5e$exports.shallowCopy)(options);
    if (options.floor == null) options.floor = 0;
    if (options.ceiling == null) options.ceiling = 10000;
    if (options.interval == null) options.interval = 250;
    return new Promise(function(resolve, reject) {
        let timer = null;
        let done = false;
        // Returns true if cancel was successful. Unsuccessful cancel means we're already done.
        const cancel = ()=>{
            if (done) return false;
            done = true;
            if (timer) clearTimeout(timer);
            return true;
        };
        if (options.timeout) timer = setTimeout(()=>{
            if (cancel()) reject(new Error("timeout"));
        }, options.timeout);
        const retryLimit = options.retryLimit;
        let attempt = 0;
        function check() {
            return func().then(function(result) {
                // If we have a result, or are allowed null then we're done
                if (result !== undefined) {
                    if (cancel()) resolve(result);
                } else if (options.oncePoll) options.oncePoll.once("poll", check);
                else if (options.onceBlock) options.onceBlock.once("block", check);
                else if (!done) {
                    attempt++;
                    if (attempt > retryLimit) {
                        if (cancel()) reject(new Error("retry limit reached"));
                        return;
                    }
                    let timeout = options.interval * parseInt(String(Math.random() * Math.pow(2, attempt)));
                    if (timeout < options.floor) timeout = options.floor;
                    if (timeout > options.ceiling) timeout = options.ceiling;
                    setTimeout(check, timeout);
                }
                return null;
            }, function(error) {
                if (cancel()) reject(error);
            });
        }
        check();
    });
}



var $5wgCY = parcelRequire("5wgCY");

const $e9ed5b422bb4952f$export$83d89fbfd8236492 = "providers/5.7.2";





var $196d3b44be9fdb46$exports = {};

$parcel$export($196d3b44be9fdb46$exports, "encode", function () { return $196d3b44be9fdb46$export$c564cdbbe6da493; });
$parcel$export($196d3b44be9fdb46$exports, "decode", function () { return $196d3b44be9fdb46$export$2f872c0f2117be69; });


const $fa0a32506f7ec4cd$export$83d89fbfd8236492 = "rlp/5.7.0";


"use strict";
const $196d3b44be9fdb46$var$logger = new (0, $5f596c9584f643ae$export$efa9a398d6368992)((0, $fa0a32506f7ec4cd$export$83d89fbfd8236492));
function $196d3b44be9fdb46$var$arrayifyInteger(value) {
    const result = [];
    while(value){
        result.unshift(value & 0xff);
        value >>= 8;
    }
    return result;
}
function $196d3b44be9fdb46$var$unarrayifyInteger(data, offset, length) {
    let result = 0;
    for(let i = 0; i < length; i++)result = result * 256 + data[offset + i];
    return result;
}
function $196d3b44be9fdb46$var$_encode(object) {
    if (Array.isArray(object)) {
        let payload = [];
        object.forEach(function(child) {
            payload = payload.concat($196d3b44be9fdb46$var$_encode(child));
        });
        if (payload.length <= 55) {
            payload.unshift(0xc0 + payload.length);
            return payload;
        }
        const length = $196d3b44be9fdb46$var$arrayifyInteger(payload.length);
        length.unshift(0xf7 + length.length);
        return length.concat(payload);
    }
    if (!(0, $06d75ae17ce69367$export$9a14abb1a440cd5e)(object)) $196d3b44be9fdb46$var$logger.throwArgumentError("RLP object must be BytesLike", "object", object);
    const data = Array.prototype.slice.call((0, $06d75ae17ce69367$export$3131421a7d01b4fb)(object));
    if (data.length === 1 && data[0] <= 0x7f) return data;
    else if (data.length <= 55) {
        data.unshift(0x80 + data.length);
        return data;
    }
    const length = $196d3b44be9fdb46$var$arrayifyInteger(data.length);
    length.unshift(0xb7 + length.length);
    return length.concat(data);
}
function $196d3b44be9fdb46$export$c564cdbbe6da493(object) {
    return (0, $06d75ae17ce69367$export$2b0d6b5fbe698c70)($196d3b44be9fdb46$var$_encode(object));
}
function $196d3b44be9fdb46$var$_decodeChildren(data, offset, childOffset, length) {
    const result = [];
    while(childOffset < offset + 1 + length){
        const decoded = $196d3b44be9fdb46$var$_decode(data, childOffset);
        result.push(decoded.result);
        childOffset += decoded.consumed;
        if (childOffset > offset + 1 + length) $196d3b44be9fdb46$var$logger.throwError("child data too short", (0, $5f596c9584f643ae$export$efa9a398d6368992).errors.BUFFER_OVERRUN, {});
    }
    return {
        consumed: 1 + length,
        result: result
    };
}
// returns { consumed: number, result: Object }
function $196d3b44be9fdb46$var$_decode(data, offset) {
    if (data.length === 0) $196d3b44be9fdb46$var$logger.throwError("data too short", (0, $5f596c9584f643ae$export$efa9a398d6368992).errors.BUFFER_OVERRUN, {});
    // Array with extra length prefix
    if (data[offset] >= 0xf8) {
        const lengthLength = data[offset] - 0xf7;
        if (offset + 1 + lengthLength > data.length) $196d3b44be9fdb46$var$logger.throwError("data short segment too short", (0, $5f596c9584f643ae$export$efa9a398d6368992).errors.BUFFER_OVERRUN, {});
        const length = $196d3b44be9fdb46$var$unarrayifyInteger(data, offset + 1, lengthLength);
        if (offset + 1 + lengthLength + length > data.length) $196d3b44be9fdb46$var$logger.throwError("data long segment too short", (0, $5f596c9584f643ae$export$efa9a398d6368992).errors.BUFFER_OVERRUN, {});
        return $196d3b44be9fdb46$var$_decodeChildren(data, offset, offset + 1 + lengthLength, lengthLength + length);
    } else if (data[offset] >= 0xc0) {
        const length = data[offset] - 0xc0;
        if (offset + 1 + length > data.length) $196d3b44be9fdb46$var$logger.throwError("data array too short", (0, $5f596c9584f643ae$export$efa9a398d6368992).errors.BUFFER_OVERRUN, {});
        return $196d3b44be9fdb46$var$_decodeChildren(data, offset, offset + 1, length);
    } else if (data[offset] >= 0xb8) {
        const lengthLength = data[offset] - 0xb7;
        if (offset + 1 + lengthLength > data.length) $196d3b44be9fdb46$var$logger.throwError("data array too short", (0, $5f596c9584f643ae$export$efa9a398d6368992).errors.BUFFER_OVERRUN, {});
        const length = $196d3b44be9fdb46$var$unarrayifyInteger(data, offset + 1, lengthLength);
        if (offset + 1 + lengthLength + length > data.length) $196d3b44be9fdb46$var$logger.throwError("data array too short", (0, $5f596c9584f643ae$export$efa9a398d6368992).errors.BUFFER_OVERRUN, {});
        const result = (0, $06d75ae17ce69367$export$2b0d6b5fbe698c70)(data.slice(offset + 1 + lengthLength, offset + 1 + lengthLength + length));
        return {
            consumed: 1 + lengthLength + length,
            result: result
        };
    } else if (data[offset] >= 0x80) {
        const length = data[offset] - 0x80;
        if (offset + 1 + length > data.length) $196d3b44be9fdb46$var$logger.throwError("data too short", (0, $5f596c9584f643ae$export$efa9a398d6368992).errors.BUFFER_OVERRUN, {});
        const result = (0, $06d75ae17ce69367$export$2b0d6b5fbe698c70)(data.slice(offset + 1, offset + 1 + length));
        return {
            consumed: 1 + length,
            result: result
        };
    }
    return {
        consumed: 1,
        result: (0, $06d75ae17ce69367$export$2b0d6b5fbe698c70)(data[offset])
    };
}
function $196d3b44be9fdb46$export$2f872c0f2117be69(data) {
    const bytes = (0, $06d75ae17ce69367$export$3131421a7d01b4fb)(data);
    const decoded = $196d3b44be9fdb46$var$_decode(bytes, 0);
    if (decoded.consumed !== bytes.length) $196d3b44be9fdb46$var$logger.throwArgumentError("invalid rlp data", "data", data);
    return decoded.result;
}



const $13b5b621afd5242c$export$83d89fbfd8236492 = "address/5.7.0";


"use strict";
const $5652f239bab101de$var$logger = new (0, $5f596c9584f643ae$export$efa9a398d6368992)((0, $13b5b621afd5242c$export$83d89fbfd8236492));
function $5652f239bab101de$var$getChecksumAddress(address) {
    if (!(0, $06d75ae17ce69367$export$b02a40aff8e4ad18)(address, 20)) $5652f239bab101de$var$logger.throwArgumentError("invalid address", "address", address);
    address = address.toLowerCase();
    const chars = address.substring(2).split("");
    const expanded = new Uint8Array(40);
    for(let i = 0; i < 40; i++)expanded[i] = chars[i].charCodeAt(0);
    const hashed = (0, $06d75ae17ce69367$export$3131421a7d01b4fb)((0, $62e3396d458230e9$export$f8151fce47ad1c35)(expanded));
    for(let i = 0; i < 40; i += 2){
        if (hashed[i >> 1] >> 4 >= 8) chars[i] = chars[i].toUpperCase();
        if ((hashed[i >> 1] & 0x0f) >= 8) chars[i + 1] = chars[i + 1].toUpperCase();
    }
    return "0x" + chars.join("");
}
// Shims for environments that are missing some required constants and functions
const $5652f239bab101de$var$MAX_SAFE_INTEGER = 0x1fffffffffffff;
function $5652f239bab101de$var$log10(x) {
    if (Math.log10) return Math.log10(x);
    return Math.log(x) / Math.LN10;
}
// See: https://en.wikipedia.org/wiki/International_Bank_Account_Number
// Create lookup table
const $5652f239bab101de$var$ibanLookup = {};
for(let i = 0; i < 10; i++)$5652f239bab101de$var$ibanLookup[String(i)] = String(i);
for(let i = 0; i < 26; i++)$5652f239bab101de$var$ibanLookup[String.fromCharCode(65 + i)] = String(10 + i);
// How many decimal digits can we process? (for 64-bit float, this is 15)
const $5652f239bab101de$var$safeDigits = Math.floor($5652f239bab101de$var$log10($5652f239bab101de$var$MAX_SAFE_INTEGER));
function $5652f239bab101de$var$ibanChecksum(address) {
    address = address.toUpperCase();
    address = address.substring(4) + address.substring(0, 2) + "00";
    let expanded = address.split("").map((c)=>{
        return $5652f239bab101de$var$ibanLookup[c];
    }).join("");
    // Javascript can handle integers safely up to 15 (decimal) digits
    while(expanded.length >= $5652f239bab101de$var$safeDigits){
        let block = expanded.substring(0, $5652f239bab101de$var$safeDigits);
        expanded = parseInt(block, 10) % 97 + expanded.substring(block.length);
    }
    let checksum = String(98 - parseInt(expanded, 10) % 97);
    while(checksum.length < 2)checksum = "0" + checksum;
    return checksum;
}
function $5652f239bab101de$export$88411125f012957a(address) {
    let result = null;
    if (typeof address !== "string") $5652f239bab101de$var$logger.throwArgumentError("invalid address", "address", address);
    if (address.match(/^(0x)?[0-9a-fA-F]{40}$/)) {
        // Missing the 0x prefix
        if (address.substring(0, 2) !== "0x") address = "0x" + address;
        result = $5652f239bab101de$var$getChecksumAddress(address);
        // It is a checksummed address with a bad checksum
        if (address.match(/([A-F].*[a-f])|([a-f].*[A-F])/) && result !== address) $5652f239bab101de$var$logger.throwArgumentError("bad address checksum", "address", address);
    // Maybe ICAP? (we only support direct mode)
    } else if (address.match(/^XE[0-9]{2}[0-9A-Za-z]{30,31}$/)) {
        // It is an ICAP address with a bad checksum
        if (address.substring(2, 4) !== $5652f239bab101de$var$ibanChecksum(address)) $5652f239bab101de$var$logger.throwArgumentError("bad icap checksum", "address", address);
        result = (0, $a87aa97415e1b917$export$51e4a08295f7770f)(address.substring(4));
        while(result.length < 40)result = "0" + result;
        result = $5652f239bab101de$var$getChecksumAddress("0x" + result);
    } else $5652f239bab101de$var$logger.throwArgumentError("invalid address", "address", address);
    return result;
}
function $5652f239bab101de$export$977e255126d763d6(address) {
    try {
        $5652f239bab101de$export$88411125f012957a(address);
        return true;
    } catch (error) {}
    return false;
}
function $5652f239bab101de$export$962c4ddada9f668f(address) {
    let base36 = (0, $a87aa97415e1b917$export$1293db5d29c264ff)($5652f239bab101de$export$88411125f012957a(address).substring(2)).toUpperCase();
    while(base36.length < 30)base36 = "0" + base36;
    return "XE" + $5652f239bab101de$var$ibanChecksum("XE00" + base36) + base36;
}
function $5652f239bab101de$export$b7fbffef12272e40(transaction) {
    let from = null;
    try {
        from = $5652f239bab101de$export$88411125f012957a(transaction.from);
    } catch (error) {
        $5652f239bab101de$var$logger.throwArgumentError("missing from address", "transaction", transaction);
    }
    const nonce = (0, $06d75ae17ce69367$export$a8f4574d0e56446c)((0, $06d75ae17ce69367$export$3131421a7d01b4fb)((0, $a87aa97415e1b917$export$d97aa349ed20696).from(transaction.nonce).toHexString()));
    return $5652f239bab101de$export$88411125f012957a((0, $06d75ae17ce69367$export$15da666eba198c18)((0, $62e3396d458230e9$export$f8151fce47ad1c35)((0, $196d3b44be9fdb46$export$c564cdbbe6da493)([
        from,
        nonce
    ])), 12));
}
function $5652f239bab101de$export$e0b22d96621f73a2(from, salt, initCodeHash) {
    if ((0, $06d75ae17ce69367$export$13882f896d3c0683)(salt) !== 32) $5652f239bab101de$var$logger.throwArgumentError("salt must be 32 bytes", "salt", salt);
    if ((0, $06d75ae17ce69367$export$13882f896d3c0683)(initCodeHash) !== 32) $5652f239bab101de$var$logger.throwArgumentError("initCodeHash must be 32 bytes", "initCodeHash", initCodeHash);
    return $5652f239bab101de$export$88411125f012957a((0, $06d75ae17ce69367$export$15da666eba198c18)((0, $62e3396d458230e9$export$f8151fce47ad1c35)((0, $06d75ae17ce69367$export$ee1b3e54f0441b22)([
        "0xff",
        $5652f239bab101de$export$88411125f012957a(from),
        salt,
        initCodeHash
    ])), 12));
}




const $16ad1643f931e329$export$badd13187c087617 = "0x0000000000000000000000000000000000000000";







const $9b44019502d48201$export$c83ef0909a6ddeec = /*#__PURE__*/ (0, $a87aa97415e1b917$export$d97aa349ed20696).from(-1);
const $9b44019502d48201$export$aaef8a3eae948f03 = /*#__PURE__*/ (0, $a87aa97415e1b917$export$d97aa349ed20696).from(0);
const $9b44019502d48201$export$9aa05a5866350bcf = /*#__PURE__*/ (0, $a87aa97415e1b917$export$d97aa349ed20696).from(1);
const $9b44019502d48201$export$9276dd97bf62cc8d = /*#__PURE__*/ (0, $a87aa97415e1b917$export$d97aa349ed20696).from(2);
const $9b44019502d48201$export$c8db55bd7405209e = /*#__PURE__*/ (0, $a87aa97415e1b917$export$d97aa349ed20696).from("1000000000000000000");
const $9b44019502d48201$export$1b53890de5aabdd0 = /*#__PURE__*/ (0, $a87aa97415e1b917$export$d97aa349ed20696).from("0xffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff");
const $9b44019502d48201$export$963c9b9317b80aaf = /*#__PURE__*/ (0, $a87aa97415e1b917$export$d97aa349ed20696).from("-0x8000000000000000000000000000000000000000000000000000000000000000");
const $9b44019502d48201$export$6f8dbb07ebe6d738 = /*#__PURE__*/ (0, $a87aa97415e1b917$export$d97aa349ed20696).from("0x7fffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff");






var $9we9E = parcelRequire("9we9E");

var $leqJp = parcelRequire("leqJp");
var $281715568a2bf9a7$var$commonjsGlobal = typeof globalThis !== "undefined" ? globalThis : typeof window !== "undefined" ? window : typeof $parcel$global !== "undefined" ? $parcel$global : typeof self !== "undefined" ? self : {};
function $281715568a2bf9a7$var$getDefaultExportFromCjs(x) {
    return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, "default") ? x["default"] : x;
}
function $281715568a2bf9a7$var$createCommonjsModule(fn, basedir, module) {
    return module = {
        path: basedir,
        exports: {},
        require: function(path, base) {
            return $281715568a2bf9a7$var$commonjsRequire(path, base === undefined || base === null ? module.path : base);
        }
    }, fn(module, module.exports), module.exports;
}
function $281715568a2bf9a7$var$getDefaultExportFromNamespaceIfPresent(n) {
    return n && Object.prototype.hasOwnProperty.call(n, "default") ? n["default"] : n;
}
function $281715568a2bf9a7$var$getDefaultExportFromNamespaceIfNotNamed(n) {
    return n && Object.prototype.hasOwnProperty.call(n, "default") && Object.keys(n).length === 1 ? n["default"] : n;
}
function $281715568a2bf9a7$var$getAugmentedNamespace(n) {
    if (n.__esModule) return n;
    var a = Object.defineProperty({}, "__esModule", {
        value: true
    });
    Object.keys(n).forEach(function(k) {
        var d = Object.getOwnPropertyDescriptor(n, k);
        Object.defineProperty(a, k, d.get ? d : {
            enumerable: true,
            get: function() {
                return n[k];
            }
        });
    });
    return a;
}
function $281715568a2bf9a7$var$commonjsRequire() {
    throw new Error("Dynamic requires are not currently supported by @rollup/plugin-commonjs");
}
var $281715568a2bf9a7$var$minimalisticAssert = $281715568a2bf9a7$var$assert;
function $281715568a2bf9a7$var$assert(val, msg) {
    if (!val) throw new Error(msg || "Assertion failed");
}
$281715568a2bf9a7$var$assert.equal = function assertEqual(l, r, msg) {
    if (l != r) throw new Error(msg || "Assertion failed: " + l + " != " + r);
};
var $281715568a2bf9a7$var$utils_1 = $281715568a2bf9a7$var$createCommonjsModule(function(module, exports) {
    "use strict";
    var utils = exports;
    function toArray(msg, enc) {
        if (Array.isArray(msg)) return msg.slice();
        if (!msg) return [];
        var res = [];
        if (typeof msg !== "string") {
            for(var i = 0; i < msg.length; i++)res[i] = msg[i] | 0;
            return res;
        }
        if (enc === "hex") {
            msg = msg.replace(/[^a-z0-9]+/ig, "");
            if (msg.length % 2 !== 0) msg = "0" + msg;
            for(var i = 0; i < msg.length; i += 2)res.push(parseInt(msg[i] + msg[i + 1], 16));
        } else for(var i = 0; i < msg.length; i++){
            var c = msg.charCodeAt(i);
            var hi = c >> 8;
            var lo = c & 0xff;
            if (hi) res.push(hi, lo);
            else res.push(lo);
        }
        return res;
    }
    utils.toArray = toArray;
    function zero2(word) {
        if (word.length === 1) return "0" + word;
        else return word;
    }
    utils.zero2 = zero2;
    function toHex(msg) {
        var res = "";
        for(var i = 0; i < msg.length; i++)res += zero2(msg[i].toString(16));
        return res;
    }
    utils.toHex = toHex;
    utils.encode = function encode(arr, enc) {
        if (enc === "hex") return toHex(arr);
        else return arr;
    };
});
var $281715568a2bf9a7$var$utils_1$1 = $281715568a2bf9a7$var$createCommonjsModule(function(module, exports) {
    "use strict";
    var utils = exports;
    utils.assert = $281715568a2bf9a7$var$minimalisticAssert;
    utils.toArray = $281715568a2bf9a7$var$utils_1.toArray;
    utils.zero2 = $281715568a2bf9a7$var$utils_1.zero2;
    utils.toHex = $281715568a2bf9a7$var$utils_1.toHex;
    utils.encode = $281715568a2bf9a7$var$utils_1.encode;
    // Represent num in a w-NAF form
    function getNAF(num, w, bits) {
        var naf = new Array(Math.max(num.bitLength(), bits) + 1);
        naf.fill(0);
        var ws = 1 << w + 1;
        var k = num.clone();
        for(var i = 0; i < naf.length; i++){
            var z;
            var mod = k.andln(ws - 1);
            if (k.isOdd()) {
                if (mod > (ws >> 1) - 1) z = (ws >> 1) - mod;
                else z = mod;
                k.isubn(z);
            } else z = 0;
            naf[i] = z;
            k.iushrn(1);
        }
        return naf;
    }
    utils.getNAF = getNAF;
    // Represent k1, k2 in a Joint Sparse Form
    function getJSF(k1, k2) {
        var jsf = [
            [],
            []
        ];
        k1 = k1.clone();
        k2 = k2.clone();
        var d1 = 0;
        var d2 = 0;
        var m8;
        while(k1.cmpn(-d1) > 0 || k2.cmpn(-d2) > 0){
            // First phase
            var m14 = k1.andln(3) + d1 & 3;
            var m24 = k2.andln(3) + d2 & 3;
            if (m14 === 3) m14 = -1;
            if (m24 === 3) m24 = -1;
            var u1;
            if ((m14 & 1) === 0) u1 = 0;
            else {
                m8 = k1.andln(7) + d1 & 7;
                if ((m8 === 3 || m8 === 5) && m24 === 2) u1 = -m14;
                else u1 = m14;
            }
            jsf[0].push(u1);
            var u2;
            if ((m24 & 1) === 0) u2 = 0;
            else {
                m8 = k2.andln(7) + d2 & 7;
                if ((m8 === 3 || m8 === 5) && m14 === 2) u2 = -m24;
                else u2 = m24;
            }
            jsf[1].push(u2);
            // Second phase
            if (2 * d1 === u1 + 1) d1 = 1 - d1;
            if (2 * d2 === u2 + 1) d2 = 1 - d2;
            k1.iushrn(1);
            k2.iushrn(1);
        }
        return jsf;
    }
    utils.getJSF = getJSF;
    function cachedProperty(obj, name, computer) {
        var key = "_" + name;
        obj.prototype[name] = function cachedProperty() {
            return this[key] !== undefined ? this[key] : this[key] = computer.call(this);
        };
    }
    utils.cachedProperty = cachedProperty;
    function parseBytes(bytes) {
        return typeof bytes === "string" ? utils.toArray(bytes, "hex") : bytes;
    }
    utils.parseBytes = parseBytes;
    function intFromLE(bytes) {
        return new (0, (/*@__PURE__*/$parcel$interopDefault($9we9E)))(bytes, "hex", "le");
    }
    utils.intFromLE = intFromLE;
});
"use strict";
var $281715568a2bf9a7$var$getNAF = $281715568a2bf9a7$var$utils_1$1.getNAF;
var $281715568a2bf9a7$var$getJSF = $281715568a2bf9a7$var$utils_1$1.getJSF;
var $281715568a2bf9a7$var$assert$1 = $281715568a2bf9a7$var$utils_1$1.assert;
function $281715568a2bf9a7$var$BaseCurve(type, conf) {
    this.type = type;
    this.p = new (0, (/*@__PURE__*/$parcel$interopDefault($9we9E)))(conf.p, 16);
    // Use Montgomery, when there is no fast reduction for the prime
    this.red = conf.prime ? (0, (/*@__PURE__*/$parcel$interopDefault($9we9E))).red(conf.prime) : (0, (/*@__PURE__*/$parcel$interopDefault($9we9E))).mont(this.p);
    // Useful for many curves
    this.zero = new (0, (/*@__PURE__*/$parcel$interopDefault($9we9E)))(0).toRed(this.red);
    this.one = new (0, (/*@__PURE__*/$parcel$interopDefault($9we9E)))(1).toRed(this.red);
    this.two = new (0, (/*@__PURE__*/$parcel$interopDefault($9we9E)))(2).toRed(this.red);
    // Curve configuration, optional
    this.n = conf.n && new (0, (/*@__PURE__*/$parcel$interopDefault($9we9E)))(conf.n, 16);
    this.g = conf.g && this.pointFromJSON(conf.g, conf.gRed);
    // Temporary arrays
    this._wnafT1 = new Array(4);
    this._wnafT2 = new Array(4);
    this._wnafT3 = new Array(4);
    this._wnafT4 = new Array(4);
    this._bitLength = this.n ? this.n.bitLength() : 0;
    // Generalized Greg Maxwell's trick
    var adjustCount = this.n && this.p.div(this.n);
    if (!adjustCount || adjustCount.cmpn(100) > 0) this.redN = null;
    else {
        this._maxwellTrick = true;
        this.redN = this.n.toRed(this.red);
    }
}
var $281715568a2bf9a7$var$base = $281715568a2bf9a7$var$BaseCurve;
$281715568a2bf9a7$var$BaseCurve.prototype.point = function point() {
    throw new Error("Not implemented");
};
$281715568a2bf9a7$var$BaseCurve.prototype.validate = function validate() {
    throw new Error("Not implemented");
};
$281715568a2bf9a7$var$BaseCurve.prototype._fixedNafMul = function _fixedNafMul(p, k) {
    $281715568a2bf9a7$var$assert$1(p.precomputed);
    var doubles = p._getDoubles();
    var naf = $281715568a2bf9a7$var$getNAF(k, 1, this._bitLength);
    var I = (1 << doubles.step + 1) - (doubles.step % 2 === 0 ? 2 : 1);
    I /= 3;
    // Translate into more windowed form
    var repr = [];
    var j;
    var nafW;
    for(j = 0; j < naf.length; j += doubles.step){
        nafW = 0;
        for(var l = j + doubles.step - 1; l >= j; l--)nafW = (nafW << 1) + naf[l];
        repr.push(nafW);
    }
    var a = this.jpoint(null, null, null);
    var b = this.jpoint(null, null, null);
    for(var i = I; i > 0; i--){
        for(j = 0; j < repr.length; j++){
            nafW = repr[j];
            if (nafW === i) b = b.mixedAdd(doubles.points[j]);
            else if (nafW === -i) b = b.mixedAdd(doubles.points[j].neg());
        }
        a = a.add(b);
    }
    return a.toP();
};
$281715568a2bf9a7$var$BaseCurve.prototype._wnafMul = function _wnafMul(p, k) {
    var w = 4;
    // Precompute window
    var nafPoints = p._getNAFPoints(w);
    w = nafPoints.wnd;
    var wnd = nafPoints.points;
    // Get NAF form
    var naf = $281715568a2bf9a7$var$getNAF(k, w, this._bitLength);
    // Add `this`*(N+1) for every w-NAF index
    var acc = this.jpoint(null, null, null);
    for(var i = naf.length - 1; i >= 0; i--){
        // Count zeroes
        for(var l = 0; i >= 0 && naf[i] === 0; i--)l++;
        if (i >= 0) l++;
        acc = acc.dblp(l);
        if (i < 0) break;
        var z = naf[i];
        $281715568a2bf9a7$var$assert$1(z !== 0);
        if (p.type === "affine") {
            // J +- P
            if (z > 0) acc = acc.mixedAdd(wnd[z - 1 >> 1]);
            else acc = acc.mixedAdd(wnd[-z - 1 >> 1].neg());
        } else // J +- J
        if (z > 0) acc = acc.add(wnd[z - 1 >> 1]);
        else acc = acc.add(wnd[-z - 1 >> 1].neg());
    }
    return p.type === "affine" ? acc.toP() : acc;
};
$281715568a2bf9a7$var$BaseCurve.prototype._wnafMulAdd = function _wnafMulAdd(defW, points, coeffs, len, jacobianResult) {
    var wndWidth = this._wnafT1;
    var wnd = this._wnafT2;
    var naf = this._wnafT3;
    // Fill all arrays
    var max = 0;
    var i;
    var j;
    var p;
    for(i = 0; i < len; i++){
        p = points[i];
        var nafPoints = p._getNAFPoints(defW);
        wndWidth[i] = nafPoints.wnd;
        wnd[i] = nafPoints.points;
    }
    // Comb small window NAFs
    for(i = len - 1; i >= 1; i -= 2){
        var a = i - 1;
        var b = i;
        if (wndWidth[a] !== 1 || wndWidth[b] !== 1) {
            naf[a] = $281715568a2bf9a7$var$getNAF(coeffs[a], wndWidth[a], this._bitLength);
            naf[b] = $281715568a2bf9a7$var$getNAF(coeffs[b], wndWidth[b], this._bitLength);
            max = Math.max(naf[a].length, max);
            max = Math.max(naf[b].length, max);
            continue;
        }
        var comb = [
            points[a],
            /* 1 */ null,
            /* 3 */ null,
            /* 5 */ points[b]
        ];
        // Try to avoid Projective points, if possible
        if (points[a].y.cmp(points[b].y) === 0) {
            comb[1] = points[a].add(points[b]);
            comb[2] = points[a].toJ().mixedAdd(points[b].neg());
        } else if (points[a].y.cmp(points[b].y.redNeg()) === 0) {
            comb[1] = points[a].toJ().mixedAdd(points[b]);
            comb[2] = points[a].add(points[b].neg());
        } else {
            comb[1] = points[a].toJ().mixedAdd(points[b]);
            comb[2] = points[a].toJ().mixedAdd(points[b].neg());
        }
        var index = [
            -3,
            /* -1 -1 */ -1,
            /* -1 0 */ -5,
            /* -1 1 */ -7,
            /* 0 -1 */ 0,
            /* 0 0 */ 7,
            /* 0 1 */ 5,
            /* 1 -1 */ 1,
            /* 1 0 */ 3
        ];
        var jsf = $281715568a2bf9a7$var$getJSF(coeffs[a], coeffs[b]);
        max = Math.max(jsf[0].length, max);
        naf[a] = new Array(max);
        naf[b] = new Array(max);
        for(j = 0; j < max; j++){
            var ja = jsf[0][j] | 0;
            var jb = jsf[1][j] | 0;
            naf[a][j] = index[(ja + 1) * 3 + (jb + 1)];
            naf[b][j] = 0;
            wnd[a] = comb;
        }
    }
    var acc = this.jpoint(null, null, null);
    var tmp = this._wnafT4;
    for(i = max; i >= 0; i--){
        var k = 0;
        while(i >= 0){
            var zero = true;
            for(j = 0; j < len; j++){
                tmp[j] = naf[j][i] | 0;
                if (tmp[j] !== 0) zero = false;
            }
            if (!zero) break;
            k++;
            i--;
        }
        if (i >= 0) k++;
        acc = acc.dblp(k);
        if (i < 0) break;
        for(j = 0; j < len; j++){
            var z = tmp[j];
            p;
            if (z === 0) continue;
            else if (z > 0) p = wnd[j][z - 1 >> 1];
            else if (z < 0) p = wnd[j][-z - 1 >> 1].neg();
            if (p.type === "affine") acc = acc.mixedAdd(p);
            else acc = acc.add(p);
        }
    }
    // Zeroify references
    for(i = 0; i < len; i++)wnd[i] = null;
    if (jacobianResult) return acc;
    else return acc.toP();
};
function $281715568a2bf9a7$var$BasePoint(curve, type) {
    this.curve = curve;
    this.type = type;
    this.precomputed = null;
}
$281715568a2bf9a7$var$BaseCurve.BasePoint = $281715568a2bf9a7$var$BasePoint;
$281715568a2bf9a7$var$BasePoint.prototype.eq = function eq() {
    throw new Error("Not implemented");
};
$281715568a2bf9a7$var$BasePoint.prototype.validate = function validate() {
    return this.curve.validate(this);
};
$281715568a2bf9a7$var$BaseCurve.prototype.decodePoint = function decodePoint(bytes, enc) {
    bytes = $281715568a2bf9a7$var$utils_1$1.toArray(bytes, enc);
    var len = this.p.byteLength();
    // uncompressed, hybrid-odd, hybrid-even
    if ((bytes[0] === 0x04 || bytes[0] === 0x06 || bytes[0] === 0x07) && bytes.length - 1 === 2 * len) {
        if (bytes[0] === 0x06) $281715568a2bf9a7$var$assert$1(bytes[bytes.length - 1] % 2 === 0);
        else if (bytes[0] === 0x07) $281715568a2bf9a7$var$assert$1(bytes[bytes.length - 1] % 2 === 1);
        var res = this.point(bytes.slice(1, 1 + len), bytes.slice(1 + len, 1 + 2 * len));
        return res;
    } else if ((bytes[0] === 0x02 || bytes[0] === 0x03) && bytes.length - 1 === len) return this.pointFromX(bytes.slice(1, 1 + len), bytes[0] === 0x03);
    throw new Error("Unknown point format");
};
$281715568a2bf9a7$var$BasePoint.prototype.encodeCompressed = function encodeCompressed(enc) {
    return this.encode(enc, true);
};
$281715568a2bf9a7$var$BasePoint.prototype._encode = function _encode(compact) {
    var len = this.curve.p.byteLength();
    var x = this.getX().toArray("be", len);
    if (compact) return [
        this.getY().isEven() ? 0x02 : 0x03
    ].concat(x);
    return [
        0x04
    ].concat(x, this.getY().toArray("be", len));
};
$281715568a2bf9a7$var$BasePoint.prototype.encode = function encode(enc, compact) {
    return $281715568a2bf9a7$var$utils_1$1.encode(this._encode(compact), enc);
};
$281715568a2bf9a7$var$BasePoint.prototype.precompute = function precompute(power) {
    if (this.precomputed) return this;
    var precomputed = {
        doubles: null,
        naf: null,
        beta: null
    };
    precomputed.naf = this._getNAFPoints(8);
    precomputed.doubles = this._getDoubles(4, power);
    precomputed.beta = this._getBeta();
    this.precomputed = precomputed;
    return this;
};
$281715568a2bf9a7$var$BasePoint.prototype._hasDoubles = function _hasDoubles(k) {
    if (!this.precomputed) return false;
    var doubles = this.precomputed.doubles;
    if (!doubles) return false;
    return doubles.points.length >= Math.ceil((k.bitLength() + 1) / doubles.step);
};
$281715568a2bf9a7$var$BasePoint.prototype._getDoubles = function _getDoubles(step, power) {
    if (this.precomputed && this.precomputed.doubles) return this.precomputed.doubles;
    var doubles = [
        this
    ];
    var acc = this;
    for(var i = 0; i < power; i += step){
        for(var j = 0; j < step; j++)acc = acc.dbl();
        doubles.push(acc);
    }
    return {
        step: step,
        points: doubles
    };
};
$281715568a2bf9a7$var$BasePoint.prototype._getNAFPoints = function _getNAFPoints(wnd) {
    if (this.precomputed && this.precomputed.naf) return this.precomputed.naf;
    var res = [
        this
    ];
    var max = (1 << wnd) - 1;
    var dbl = max === 1 ? null : this.dbl();
    for(var i = 1; i < max; i++)res[i] = res[i - 1].add(dbl);
    return {
        wnd: wnd,
        points: res
    };
};
$281715568a2bf9a7$var$BasePoint.prototype._getBeta = function _getBeta() {
    return null;
};
$281715568a2bf9a7$var$BasePoint.prototype.dblp = function dblp(k) {
    var r = this;
    for(var i = 0; i < k; i++)r = r.dbl();
    return r;
};
var $281715568a2bf9a7$var$inherits_browser = $281715568a2bf9a7$var$createCommonjsModule(function(module) {
    if (typeof Object.create === "function") // implementation from standard node.js 'util' module
    module.exports = function inherits(ctor, superCtor) {
        if (superCtor) {
            ctor.super_ = superCtor;
            ctor.prototype = Object.create(superCtor.prototype, {
                constructor: {
                    value: ctor,
                    enumerable: false,
                    writable: true,
                    configurable: true
                }
            });
        }
    };
    else // old school shim for old browsers
    module.exports = function inherits(ctor, superCtor) {
        if (superCtor) {
            ctor.super_ = superCtor;
            var TempCtor = function() {};
            TempCtor.prototype = superCtor.prototype;
            ctor.prototype = new TempCtor();
            ctor.prototype.constructor = ctor;
        }
    };
});
"use strict";
var $281715568a2bf9a7$var$assert$2 = $281715568a2bf9a7$var$utils_1$1.assert;
function $281715568a2bf9a7$var$ShortCurve(conf) {
    $281715568a2bf9a7$var$base.call(this, "short", conf);
    this.a = new (0, (/*@__PURE__*/$parcel$interopDefault($9we9E)))(conf.a, 16).toRed(this.red);
    this.b = new (0, (/*@__PURE__*/$parcel$interopDefault($9we9E)))(conf.b, 16).toRed(this.red);
    this.tinv = this.two.redInvm();
    this.zeroA = this.a.fromRed().cmpn(0) === 0;
    this.threeA = this.a.fromRed().sub(this.p).cmpn(-3) === 0;
    // If the curve is endomorphic, precalculate beta and lambda
    this.endo = this._getEndomorphism(conf);
    this._endoWnafT1 = new Array(4);
    this._endoWnafT2 = new Array(4);
}
$281715568a2bf9a7$var$inherits_browser($281715568a2bf9a7$var$ShortCurve, $281715568a2bf9a7$var$base);
var $281715568a2bf9a7$var$short_1 = $281715568a2bf9a7$var$ShortCurve;
$281715568a2bf9a7$var$ShortCurve.prototype._getEndomorphism = function _getEndomorphism(conf) {
    // No efficient endomorphism
    if (!this.zeroA || !this.g || !this.n || this.p.modn(3) !== 1) return;
    // Compute beta and lambda, that lambda * P = (beta * Px; Py)
    var beta;
    var lambda;
    if (conf.beta) beta = new (0, (/*@__PURE__*/$parcel$interopDefault($9we9E)))(conf.beta, 16).toRed(this.red);
    else {
        var betas = this._getEndoRoots(this.p);
        // Choose the smallest beta
        beta = betas[0].cmp(betas[1]) < 0 ? betas[0] : betas[1];
        beta = beta.toRed(this.red);
    }
    if (conf.lambda) lambda = new (0, (/*@__PURE__*/$parcel$interopDefault($9we9E)))(conf.lambda, 16);
    else {
        // Choose the lambda that is matching selected beta
        var lambdas = this._getEndoRoots(this.n);
        if (this.g.mul(lambdas[0]).x.cmp(this.g.x.redMul(beta)) === 0) lambda = lambdas[0];
        else {
            lambda = lambdas[1];
            $281715568a2bf9a7$var$assert$2(this.g.mul(lambda).x.cmp(this.g.x.redMul(beta)) === 0);
        }
    }
    // Get basis vectors, used for balanced length-two representation
    var basis;
    if (conf.basis) basis = conf.basis.map(function(vec) {
        return {
            a: new (0, (/*@__PURE__*/$parcel$interopDefault($9we9E)))(vec.a, 16),
            b: new (0, (/*@__PURE__*/$parcel$interopDefault($9we9E)))(vec.b, 16)
        };
    });
    else basis = this._getEndoBasis(lambda);
    return {
        beta: beta,
        lambda: lambda,
        basis: basis
    };
};
$281715568a2bf9a7$var$ShortCurve.prototype._getEndoRoots = function _getEndoRoots(num) {
    // Find roots of for x^2 + x + 1 in F
    // Root = (-1 +- Sqrt(-3)) / 2
    //
    var red = num === this.p ? this.red : (0, (/*@__PURE__*/$parcel$interopDefault($9we9E))).mont(num);
    var tinv = new (0, (/*@__PURE__*/$parcel$interopDefault($9we9E)))(2).toRed(red).redInvm();
    var ntinv = tinv.redNeg();
    var s = new (0, (/*@__PURE__*/$parcel$interopDefault($9we9E)))(3).toRed(red).redNeg().redSqrt().redMul(tinv);
    var l1 = ntinv.redAdd(s).fromRed();
    var l2 = ntinv.redSub(s).fromRed();
    return [
        l1,
        l2
    ];
};
$281715568a2bf9a7$var$ShortCurve.prototype._getEndoBasis = function _getEndoBasis(lambda) {
    // aprxSqrt >= sqrt(this.n)
    var aprxSqrt = this.n.ushrn(Math.floor(this.n.bitLength() / 2));
    // 3.74
    // Run EGCD, until r(L + 1) < aprxSqrt
    var u = lambda;
    var v = this.n.clone();
    var x1 = new (0, (/*@__PURE__*/$parcel$interopDefault($9we9E)))(1);
    var y1 = new (0, (/*@__PURE__*/$parcel$interopDefault($9we9E)))(0);
    var x2 = new (0, (/*@__PURE__*/$parcel$interopDefault($9we9E)))(0);
    var y2 = new (0, (/*@__PURE__*/$parcel$interopDefault($9we9E)))(1);
    // NOTE: all vectors are roots of: a + b * lambda = 0 (mod n)
    var a0;
    var b0;
    // First vector
    var a1;
    var b1;
    // Second vector
    var a2;
    var b2;
    var prevR;
    var i = 0;
    var r;
    var x;
    while(u.cmpn(0) !== 0){
        var q = v.div(u);
        r = v.sub(q.mul(u));
        x = x2.sub(q.mul(x1));
        var y = y2.sub(q.mul(y1));
        if (!a1 && r.cmp(aprxSqrt) < 0) {
            a0 = prevR.neg();
            b0 = x1;
            a1 = r.neg();
            b1 = x;
        } else if (a1 && ++i === 2) break;
        prevR = r;
        v = u;
        u = r;
        x2 = x1;
        x1 = x;
        y2 = y1;
        y1 = y;
    }
    a2 = r.neg();
    b2 = x;
    var len1 = a1.sqr().add(b1.sqr());
    var len2 = a2.sqr().add(b2.sqr());
    if (len2.cmp(len1) >= 0) {
        a2 = a0;
        b2 = b0;
    }
    // Normalize signs
    if (a1.negative) {
        a1 = a1.neg();
        b1 = b1.neg();
    }
    if (a2.negative) {
        a2 = a2.neg();
        b2 = b2.neg();
    }
    return [
        {
            a: a1,
            b: b1
        },
        {
            a: a2,
            b: b2
        }
    ];
};
$281715568a2bf9a7$var$ShortCurve.prototype._endoSplit = function _endoSplit(k) {
    var basis = this.endo.basis;
    var v1 = basis[0];
    var v2 = basis[1];
    var c1 = v2.b.mul(k).divRound(this.n);
    var c2 = v1.b.neg().mul(k).divRound(this.n);
    var p1 = c1.mul(v1.a);
    var p2 = c2.mul(v2.a);
    var q1 = c1.mul(v1.b);
    var q2 = c2.mul(v2.b);
    // Calculate answer
    var k1 = k.sub(p1).sub(p2);
    var k2 = q1.add(q2).neg();
    return {
        k1: k1,
        k2: k2
    };
};
$281715568a2bf9a7$var$ShortCurve.prototype.pointFromX = function pointFromX(x, odd) {
    x = new (0, (/*@__PURE__*/$parcel$interopDefault($9we9E)))(x, 16);
    if (!x.red) x = x.toRed(this.red);
    var y2 = x.redSqr().redMul(x).redIAdd(x.redMul(this.a)).redIAdd(this.b);
    var y = y2.redSqrt();
    if (y.redSqr().redSub(y2).cmp(this.zero) !== 0) throw new Error("invalid point");
    // XXX Is there any way to tell if the number is odd without converting it
    // to non-red form?
    var isOdd = y.fromRed().isOdd();
    if (odd && !isOdd || !odd && isOdd) y = y.redNeg();
    return this.point(x, y);
};
$281715568a2bf9a7$var$ShortCurve.prototype.validate = function validate(point) {
    if (point.inf) return true;
    var x = point.x;
    var y = point.y;
    var ax = this.a.redMul(x);
    var rhs = x.redSqr().redMul(x).redIAdd(ax).redIAdd(this.b);
    return y.redSqr().redISub(rhs).cmpn(0) === 0;
};
$281715568a2bf9a7$var$ShortCurve.prototype._endoWnafMulAdd = function _endoWnafMulAdd(points, coeffs, jacobianResult) {
    var npoints = this._endoWnafT1;
    var ncoeffs = this._endoWnafT2;
    for(var i = 0; i < points.length; i++){
        var split = this._endoSplit(coeffs[i]);
        var p = points[i];
        var beta = p._getBeta();
        if (split.k1.negative) {
            split.k1.ineg();
            p = p.neg(true);
        }
        if (split.k2.negative) {
            split.k2.ineg();
            beta = beta.neg(true);
        }
        npoints[i * 2] = p;
        npoints[i * 2 + 1] = beta;
        ncoeffs[i * 2] = split.k1;
        ncoeffs[i * 2 + 1] = split.k2;
    }
    var res = this._wnafMulAdd(1, npoints, ncoeffs, i * 2, jacobianResult);
    // Clean-up references to points and coefficients
    for(var j = 0; j < i * 2; j++){
        npoints[j] = null;
        ncoeffs[j] = null;
    }
    return res;
};
function $281715568a2bf9a7$var$Point(curve, x, y, isRed) {
    $281715568a2bf9a7$var$base.BasePoint.call(this, curve, "affine");
    if (x === null && y === null) {
        this.x = null;
        this.y = null;
        this.inf = true;
    } else {
        this.x = new (0, (/*@__PURE__*/$parcel$interopDefault($9we9E)))(x, 16);
        this.y = new (0, (/*@__PURE__*/$parcel$interopDefault($9we9E)))(y, 16);
        // Force redgomery representation when loading from JSON
        if (isRed) {
            this.x.forceRed(this.curve.red);
            this.y.forceRed(this.curve.red);
        }
        if (!this.x.red) this.x = this.x.toRed(this.curve.red);
        if (!this.y.red) this.y = this.y.toRed(this.curve.red);
        this.inf = false;
    }
}
$281715568a2bf9a7$var$inherits_browser($281715568a2bf9a7$var$Point, $281715568a2bf9a7$var$base.BasePoint);
$281715568a2bf9a7$var$ShortCurve.prototype.point = function point(x, y, isRed) {
    return new $281715568a2bf9a7$var$Point(this, x, y, isRed);
};
$281715568a2bf9a7$var$ShortCurve.prototype.pointFromJSON = function pointFromJSON(obj, red) {
    return $281715568a2bf9a7$var$Point.fromJSON(this, obj, red);
};
$281715568a2bf9a7$var$Point.prototype._getBeta = function _getBeta() {
    if (!this.curve.endo) return;
    var pre = this.precomputed;
    if (pre && pre.beta) return pre.beta;
    var beta = this.curve.point(this.x.redMul(this.curve.endo.beta), this.y);
    if (pre) {
        var curve = this.curve;
        var endoMul = function(p) {
            return curve.point(p.x.redMul(curve.endo.beta), p.y);
        };
        pre.beta = beta;
        beta.precomputed = {
            beta: null,
            naf: pre.naf && {
                wnd: pre.naf.wnd,
                points: pre.naf.points.map(endoMul)
            },
            doubles: pre.doubles && {
                step: pre.doubles.step,
                points: pre.doubles.points.map(endoMul)
            }
        };
    }
    return beta;
};
$281715568a2bf9a7$var$Point.prototype.toJSON = function toJSON() {
    if (!this.precomputed) return [
        this.x,
        this.y
    ];
    return [
        this.x,
        this.y,
        this.precomputed && {
            doubles: this.precomputed.doubles && {
                step: this.precomputed.doubles.step,
                points: this.precomputed.doubles.points.slice(1)
            },
            naf: this.precomputed.naf && {
                wnd: this.precomputed.naf.wnd,
                points: this.precomputed.naf.points.slice(1)
            }
        }
    ];
};
$281715568a2bf9a7$var$Point.fromJSON = function fromJSON(curve, obj, red) {
    if (typeof obj === "string") obj = JSON.parse(obj);
    var res = curve.point(obj[0], obj[1], red);
    if (!obj[2]) return res;
    function obj2point(obj) {
        return curve.point(obj[0], obj[1], red);
    }
    var pre = obj[2];
    res.precomputed = {
        beta: null,
        doubles: pre.doubles && {
            step: pre.doubles.step,
            points: [
                res
            ].concat(pre.doubles.points.map(obj2point))
        },
        naf: pre.naf && {
            wnd: pre.naf.wnd,
            points: [
                res
            ].concat(pre.naf.points.map(obj2point))
        }
    };
    return res;
};
$281715568a2bf9a7$var$Point.prototype.inspect = function inspect() {
    if (this.isInfinity()) return "<EC Point Infinity>";
    return "<EC Point x: " + this.x.fromRed().toString(16, 2) + " y: " + this.y.fromRed().toString(16, 2) + ">";
};
$281715568a2bf9a7$var$Point.prototype.isInfinity = function isInfinity() {
    return this.inf;
};
$281715568a2bf9a7$var$Point.prototype.add = function add(p) {
    // O + P = P
    if (this.inf) return p;
    // P + O = P
    if (p.inf) return this;
    // P + P = 2P
    if (this.eq(p)) return this.dbl();
    // P + (-P) = O
    if (this.neg().eq(p)) return this.curve.point(null, null);
    // P + Q = O
    if (this.x.cmp(p.x) === 0) return this.curve.point(null, null);
    var c = this.y.redSub(p.y);
    if (c.cmpn(0) !== 0) c = c.redMul(this.x.redSub(p.x).redInvm());
    var nx = c.redSqr().redISub(this.x).redISub(p.x);
    var ny = c.redMul(this.x.redSub(nx)).redISub(this.y);
    return this.curve.point(nx, ny);
};
$281715568a2bf9a7$var$Point.prototype.dbl = function dbl() {
    if (this.inf) return this;
    // 2P = O
    var ys1 = this.y.redAdd(this.y);
    if (ys1.cmpn(0) === 0) return this.curve.point(null, null);
    var a = this.curve.a;
    var x2 = this.x.redSqr();
    var dyinv = ys1.redInvm();
    var c = x2.redAdd(x2).redIAdd(x2).redIAdd(a).redMul(dyinv);
    var nx = c.redSqr().redISub(this.x.redAdd(this.x));
    var ny = c.redMul(this.x.redSub(nx)).redISub(this.y);
    return this.curve.point(nx, ny);
};
$281715568a2bf9a7$var$Point.prototype.getX = function getX() {
    return this.x.fromRed();
};
$281715568a2bf9a7$var$Point.prototype.getY = function getY() {
    return this.y.fromRed();
};
$281715568a2bf9a7$var$Point.prototype.mul = function mul(k) {
    k = new (0, (/*@__PURE__*/$parcel$interopDefault($9we9E)))(k, 16);
    if (this.isInfinity()) return this;
    else if (this._hasDoubles(k)) return this.curve._fixedNafMul(this, k);
    else if (this.curve.endo) return this.curve._endoWnafMulAdd([
        this
    ], [
        k
    ]);
    else return this.curve._wnafMul(this, k);
};
$281715568a2bf9a7$var$Point.prototype.mulAdd = function mulAdd(k1, p2, k2) {
    var points = [
        this,
        p2
    ];
    var coeffs = [
        k1,
        k2
    ];
    if (this.curve.endo) return this.curve._endoWnafMulAdd(points, coeffs);
    else return this.curve._wnafMulAdd(1, points, coeffs, 2);
};
$281715568a2bf9a7$var$Point.prototype.jmulAdd = function jmulAdd(k1, p2, k2) {
    var points = [
        this,
        p2
    ];
    var coeffs = [
        k1,
        k2
    ];
    if (this.curve.endo) return this.curve._endoWnafMulAdd(points, coeffs, true);
    else return this.curve._wnafMulAdd(1, points, coeffs, 2, true);
};
$281715568a2bf9a7$var$Point.prototype.eq = function eq(p) {
    return this === p || this.inf === p.inf && (this.inf || this.x.cmp(p.x) === 0 && this.y.cmp(p.y) === 0);
};
$281715568a2bf9a7$var$Point.prototype.neg = function neg(_precompute) {
    if (this.inf) return this;
    var res = this.curve.point(this.x, this.y.redNeg());
    if (_precompute && this.precomputed) {
        var pre = this.precomputed;
        var negate = function(p) {
            return p.neg();
        };
        res.precomputed = {
            naf: pre.naf && {
                wnd: pre.naf.wnd,
                points: pre.naf.points.map(negate)
            },
            doubles: pre.doubles && {
                step: pre.doubles.step,
                points: pre.doubles.points.map(negate)
            }
        };
    }
    return res;
};
$281715568a2bf9a7$var$Point.prototype.toJ = function toJ() {
    if (this.inf) return this.curve.jpoint(null, null, null);
    var res = this.curve.jpoint(this.x, this.y, this.curve.one);
    return res;
};
function $281715568a2bf9a7$var$JPoint(curve, x, y, z) {
    $281715568a2bf9a7$var$base.BasePoint.call(this, curve, "jacobian");
    if (x === null && y === null && z === null) {
        this.x = this.curve.one;
        this.y = this.curve.one;
        this.z = new (0, (/*@__PURE__*/$parcel$interopDefault($9we9E)))(0);
    } else {
        this.x = new (0, (/*@__PURE__*/$parcel$interopDefault($9we9E)))(x, 16);
        this.y = new (0, (/*@__PURE__*/$parcel$interopDefault($9we9E)))(y, 16);
        this.z = new (0, (/*@__PURE__*/$parcel$interopDefault($9we9E)))(z, 16);
    }
    if (!this.x.red) this.x = this.x.toRed(this.curve.red);
    if (!this.y.red) this.y = this.y.toRed(this.curve.red);
    if (!this.z.red) this.z = this.z.toRed(this.curve.red);
    this.zOne = this.z === this.curve.one;
}
$281715568a2bf9a7$var$inherits_browser($281715568a2bf9a7$var$JPoint, $281715568a2bf9a7$var$base.BasePoint);
$281715568a2bf9a7$var$ShortCurve.prototype.jpoint = function jpoint(x, y, z) {
    return new $281715568a2bf9a7$var$JPoint(this, x, y, z);
};
$281715568a2bf9a7$var$JPoint.prototype.toP = function toP() {
    if (this.isInfinity()) return this.curve.point(null, null);
    var zinv = this.z.redInvm();
    var zinv2 = zinv.redSqr();
    var ax = this.x.redMul(zinv2);
    var ay = this.y.redMul(zinv2).redMul(zinv);
    return this.curve.point(ax, ay);
};
$281715568a2bf9a7$var$JPoint.prototype.neg = function neg() {
    return this.curve.jpoint(this.x, this.y.redNeg(), this.z);
};
$281715568a2bf9a7$var$JPoint.prototype.add = function add(p) {
    // O + P = P
    if (this.isInfinity()) return p;
    // P + O = P
    if (p.isInfinity()) return this;
    // 12M + 4S + 7A
    var pz2 = p.z.redSqr();
    var z2 = this.z.redSqr();
    var u1 = this.x.redMul(pz2);
    var u2 = p.x.redMul(z2);
    var s1 = this.y.redMul(pz2.redMul(p.z));
    var s2 = p.y.redMul(z2.redMul(this.z));
    var h = u1.redSub(u2);
    var r = s1.redSub(s2);
    if (h.cmpn(0) === 0) {
        if (r.cmpn(0) !== 0) return this.curve.jpoint(null, null, null);
        else return this.dbl();
    }
    var h2 = h.redSqr();
    var h3 = h2.redMul(h);
    var v = u1.redMul(h2);
    var nx = r.redSqr().redIAdd(h3).redISub(v).redISub(v);
    var ny = r.redMul(v.redISub(nx)).redISub(s1.redMul(h3));
    var nz = this.z.redMul(p.z).redMul(h);
    return this.curve.jpoint(nx, ny, nz);
};
$281715568a2bf9a7$var$JPoint.prototype.mixedAdd = function mixedAdd(p) {
    // O + P = P
    if (this.isInfinity()) return p.toJ();
    // P + O = P
    if (p.isInfinity()) return this;
    // 8M + 3S + 7A
    var z2 = this.z.redSqr();
    var u1 = this.x;
    var u2 = p.x.redMul(z2);
    var s1 = this.y;
    var s2 = p.y.redMul(z2).redMul(this.z);
    var h = u1.redSub(u2);
    var r = s1.redSub(s2);
    if (h.cmpn(0) === 0) {
        if (r.cmpn(0) !== 0) return this.curve.jpoint(null, null, null);
        else return this.dbl();
    }
    var h2 = h.redSqr();
    var h3 = h2.redMul(h);
    var v = u1.redMul(h2);
    var nx = r.redSqr().redIAdd(h3).redISub(v).redISub(v);
    var ny = r.redMul(v.redISub(nx)).redISub(s1.redMul(h3));
    var nz = this.z.redMul(h);
    return this.curve.jpoint(nx, ny, nz);
};
$281715568a2bf9a7$var$JPoint.prototype.dblp = function dblp(pow) {
    if (pow === 0) return this;
    if (this.isInfinity()) return this;
    if (!pow) return this.dbl();
    var i;
    if (this.curve.zeroA || this.curve.threeA) {
        var r = this;
        for(i = 0; i < pow; i++)r = r.dbl();
        return r;
    }
    // 1M + 2S + 1A + N * (4S + 5M + 8A)
    // N = 1 => 6M + 6S + 9A
    var a = this.curve.a;
    var tinv = this.curve.tinv;
    var jx = this.x;
    var jy = this.y;
    var jz = this.z;
    var jz4 = jz.redSqr().redSqr();
    // Reuse results
    var jyd = jy.redAdd(jy);
    for(i = 0; i < pow; i++){
        var jx2 = jx.redSqr();
        var jyd2 = jyd.redSqr();
        var jyd4 = jyd2.redSqr();
        var c = jx2.redAdd(jx2).redIAdd(jx2).redIAdd(a.redMul(jz4));
        var t1 = jx.redMul(jyd2);
        var nx = c.redSqr().redISub(t1.redAdd(t1));
        var t2 = t1.redISub(nx);
        var dny = c.redMul(t2);
        dny = dny.redIAdd(dny).redISub(jyd4);
        var nz = jyd.redMul(jz);
        if (i + 1 < pow) jz4 = jz4.redMul(jyd4);
        jx = nx;
        jz = nz;
        jyd = dny;
    }
    return this.curve.jpoint(jx, jyd.redMul(tinv), jz);
};
$281715568a2bf9a7$var$JPoint.prototype.dbl = function dbl() {
    if (this.isInfinity()) return this;
    if (this.curve.zeroA) return this._zeroDbl();
    else if (this.curve.threeA) return this._threeDbl();
    else return this._dbl();
};
$281715568a2bf9a7$var$JPoint.prototype._zeroDbl = function _zeroDbl() {
    var nx;
    var ny;
    var nz;
    // Z = 1
    if (this.zOne) {
        // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-0.html
        //     #doubling-mdbl-2007-bl
        // 1M + 5S + 14A
        // XX = X1^2
        var xx = this.x.redSqr();
        // YY = Y1^2
        var yy = this.y.redSqr();
        // YYYY = YY^2
        var yyyy = yy.redSqr();
        // S = 2 * ((X1 + YY)^2 - XX - YYYY)
        var s = this.x.redAdd(yy).redSqr().redISub(xx).redISub(yyyy);
        s = s.redIAdd(s);
        // M = 3 * XX + a; a = 0
        var m = xx.redAdd(xx).redIAdd(xx);
        // T = M ^ 2 - 2*S
        var t = m.redSqr().redISub(s).redISub(s);
        // 8 * YYYY
        var yyyy8 = yyyy.redIAdd(yyyy);
        yyyy8 = yyyy8.redIAdd(yyyy8);
        yyyy8 = yyyy8.redIAdd(yyyy8);
        // X3 = T
        nx = t;
        // Y3 = M * (S - T) - 8 * YYYY
        ny = m.redMul(s.redISub(t)).redISub(yyyy8);
        // Z3 = 2*Y1
        nz = this.y.redAdd(this.y);
    } else {
        // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-0.html
        //     #doubling-dbl-2009-l
        // 2M + 5S + 13A
        // A = X1^2
        var a = this.x.redSqr();
        // B = Y1^2
        var b = this.y.redSqr();
        // C = B^2
        var c = b.redSqr();
        // D = 2 * ((X1 + B)^2 - A - C)
        var d = this.x.redAdd(b).redSqr().redISub(a).redISub(c);
        d = d.redIAdd(d);
        // E = 3 * A
        var e = a.redAdd(a).redIAdd(a);
        // F = E^2
        var f = e.redSqr();
        // 8 * C
        var c8 = c.redIAdd(c);
        c8 = c8.redIAdd(c8);
        c8 = c8.redIAdd(c8);
        // X3 = F - 2 * D
        nx = f.redISub(d).redISub(d);
        // Y3 = E * (D - X3) - 8 * C
        ny = e.redMul(d.redISub(nx)).redISub(c8);
        // Z3 = 2 * Y1 * Z1
        nz = this.y.redMul(this.z);
        nz = nz.redIAdd(nz);
    }
    return this.curve.jpoint(nx, ny, nz);
};
$281715568a2bf9a7$var$JPoint.prototype._threeDbl = function _threeDbl() {
    var nx;
    var ny;
    var nz;
    // Z = 1
    if (this.zOne) {
        // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-3.html
        //     #doubling-mdbl-2007-bl
        // 1M + 5S + 15A
        // XX = X1^2
        var xx = this.x.redSqr();
        // YY = Y1^2
        var yy = this.y.redSqr();
        // YYYY = YY^2
        var yyyy = yy.redSqr();
        // S = 2 * ((X1 + YY)^2 - XX - YYYY)
        var s = this.x.redAdd(yy).redSqr().redISub(xx).redISub(yyyy);
        s = s.redIAdd(s);
        // M = 3 * XX + a
        var m = xx.redAdd(xx).redIAdd(xx).redIAdd(this.curve.a);
        // T = M^2 - 2 * S
        var t = m.redSqr().redISub(s).redISub(s);
        // X3 = T
        nx = t;
        // Y3 = M * (S - T) - 8 * YYYY
        var yyyy8 = yyyy.redIAdd(yyyy);
        yyyy8 = yyyy8.redIAdd(yyyy8);
        yyyy8 = yyyy8.redIAdd(yyyy8);
        ny = m.redMul(s.redISub(t)).redISub(yyyy8);
        // Z3 = 2 * Y1
        nz = this.y.redAdd(this.y);
    } else {
        // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-3.html#doubling-dbl-2001-b
        // 3M + 5S
        // delta = Z1^2
        var delta = this.z.redSqr();
        // gamma = Y1^2
        var gamma = this.y.redSqr();
        // beta = X1 * gamma
        var beta = this.x.redMul(gamma);
        // alpha = 3 * (X1 - delta) * (X1 + delta)
        var alpha = this.x.redSub(delta).redMul(this.x.redAdd(delta));
        alpha = alpha.redAdd(alpha).redIAdd(alpha);
        // X3 = alpha^2 - 8 * beta
        var beta4 = beta.redIAdd(beta);
        beta4 = beta4.redIAdd(beta4);
        var beta8 = beta4.redAdd(beta4);
        nx = alpha.redSqr().redISub(beta8);
        // Z3 = (Y1 + Z1)^2 - gamma - delta
        nz = this.y.redAdd(this.z).redSqr().redISub(gamma).redISub(delta);
        // Y3 = alpha * (4 * beta - X3) - 8 * gamma^2
        var ggamma8 = gamma.redSqr();
        ggamma8 = ggamma8.redIAdd(ggamma8);
        ggamma8 = ggamma8.redIAdd(ggamma8);
        ggamma8 = ggamma8.redIAdd(ggamma8);
        ny = alpha.redMul(beta4.redISub(nx)).redISub(ggamma8);
    }
    return this.curve.jpoint(nx, ny, nz);
};
$281715568a2bf9a7$var$JPoint.prototype._dbl = function _dbl() {
    var a = this.curve.a;
    // 4M + 6S + 10A
    var jx = this.x;
    var jy = this.y;
    var jz = this.z;
    var jz4 = jz.redSqr().redSqr();
    var jx2 = jx.redSqr();
    var jy2 = jy.redSqr();
    var c = jx2.redAdd(jx2).redIAdd(jx2).redIAdd(a.redMul(jz4));
    var jxd4 = jx.redAdd(jx);
    jxd4 = jxd4.redIAdd(jxd4);
    var t1 = jxd4.redMul(jy2);
    var nx = c.redSqr().redISub(t1.redAdd(t1));
    var t2 = t1.redISub(nx);
    var jyd8 = jy2.redSqr();
    jyd8 = jyd8.redIAdd(jyd8);
    jyd8 = jyd8.redIAdd(jyd8);
    jyd8 = jyd8.redIAdd(jyd8);
    var ny = c.redMul(t2).redISub(jyd8);
    var nz = jy.redAdd(jy).redMul(jz);
    return this.curve.jpoint(nx, ny, nz);
};
$281715568a2bf9a7$var$JPoint.prototype.trpl = function trpl() {
    if (!this.curve.zeroA) return this.dbl().add(this);
    // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-0.html#tripling-tpl-2007-bl
    // 5M + 10S + ...
    // XX = X1^2
    var xx = this.x.redSqr();
    // YY = Y1^2
    var yy = this.y.redSqr();
    // ZZ = Z1^2
    var zz = this.z.redSqr();
    // YYYY = YY^2
    var yyyy = yy.redSqr();
    // M = 3 * XX + a * ZZ2; a = 0
    var m = xx.redAdd(xx).redIAdd(xx);
    // MM = M^2
    var mm = m.redSqr();
    // E = 6 * ((X1 + YY)^2 - XX - YYYY) - MM
    var e = this.x.redAdd(yy).redSqr().redISub(xx).redISub(yyyy);
    e = e.redIAdd(e);
    e = e.redAdd(e).redIAdd(e);
    e = e.redISub(mm);
    // EE = E^2
    var ee = e.redSqr();
    // T = 16*YYYY
    var t = yyyy.redIAdd(yyyy);
    t = t.redIAdd(t);
    t = t.redIAdd(t);
    t = t.redIAdd(t);
    // U = (M + E)^2 - MM - EE - T
    var u = m.redIAdd(e).redSqr().redISub(mm).redISub(ee).redISub(t);
    // X3 = 4 * (X1 * EE - 4 * YY * U)
    var yyu4 = yy.redMul(u);
    yyu4 = yyu4.redIAdd(yyu4);
    yyu4 = yyu4.redIAdd(yyu4);
    var nx = this.x.redMul(ee).redISub(yyu4);
    nx = nx.redIAdd(nx);
    nx = nx.redIAdd(nx);
    // Y3 = 8 * Y1 * (U * (T - U) - E * EE)
    var ny = this.y.redMul(u.redMul(t.redISub(u)).redISub(e.redMul(ee)));
    ny = ny.redIAdd(ny);
    ny = ny.redIAdd(ny);
    ny = ny.redIAdd(ny);
    // Z3 = (Z1 + E)^2 - ZZ - EE
    var nz = this.z.redAdd(e).redSqr().redISub(zz).redISub(ee);
    return this.curve.jpoint(nx, ny, nz);
};
$281715568a2bf9a7$var$JPoint.prototype.mul = function mul(k, kbase) {
    k = new (0, (/*@__PURE__*/$parcel$interopDefault($9we9E)))(k, kbase);
    return this.curve._wnafMul(this, k);
};
$281715568a2bf9a7$var$JPoint.prototype.eq = function eq(p) {
    if (p.type === "affine") return this.eq(p.toJ());
    if (this === p) return true;
    // x1 * z2^2 == x2 * z1^2
    var z2 = this.z.redSqr();
    var pz2 = p.z.redSqr();
    if (this.x.redMul(pz2).redISub(p.x.redMul(z2)).cmpn(0) !== 0) return false;
    // y1 * z2^3 == y2 * z1^3
    var z3 = z2.redMul(this.z);
    var pz3 = pz2.redMul(p.z);
    return this.y.redMul(pz3).redISub(p.y.redMul(z3)).cmpn(0) === 0;
};
$281715568a2bf9a7$var$JPoint.prototype.eqXToP = function eqXToP(x) {
    var zs = this.z.redSqr();
    var rx = x.toRed(this.curve.red).redMul(zs);
    if (this.x.cmp(rx) === 0) return true;
    var xc = x.clone();
    var t = this.curve.redN.redMul(zs);
    for(;;){
        xc.iadd(this.curve.n);
        if (xc.cmp(this.curve.p) >= 0) return false;
        rx.redIAdd(t);
        if (this.x.cmp(rx) === 0) return true;
    }
};
$281715568a2bf9a7$var$JPoint.prototype.inspect = function inspect() {
    if (this.isInfinity()) return "<EC JPoint Infinity>";
    return "<EC JPoint x: " + this.x.toString(16, 2) + " y: " + this.y.toString(16, 2) + " z: " + this.z.toString(16, 2) + ">";
};
$281715568a2bf9a7$var$JPoint.prototype.isInfinity = function isInfinity() {
    // XXX This code assumes that zero is always zero in red
    return this.z.cmpn(0) === 0;
};
var $281715568a2bf9a7$var$curve_1 = $281715568a2bf9a7$var$createCommonjsModule(function(module, exports) {
    "use strict";
    var curve = exports;
    curve.base = $281715568a2bf9a7$var$base;
    curve.short = $281715568a2bf9a7$var$short_1;
    curve.mont = /*RicMoo:ethers:require(./mont)*/ null;
    curve.edwards = /*RicMoo:ethers:require(./edwards)*/ null;
});
var $281715568a2bf9a7$var$curves_1 = $281715568a2bf9a7$var$createCommonjsModule(function(module, exports) {
    "use strict";
    var curves = exports;
    var assert = $281715568a2bf9a7$var$utils_1$1.assert;
    function PresetCurve(options) {
        if (options.type === "short") this.curve = new $281715568a2bf9a7$var$curve_1.short(options);
        else if (options.type === "edwards") this.curve = new $281715568a2bf9a7$var$curve_1.edwards(options);
        else this.curve = new $281715568a2bf9a7$var$curve_1.mont(options);
        this.g = this.curve.g;
        this.n = this.curve.n;
        this.hash = options.hash;
        assert(this.g.validate(), "Invalid curve");
        assert(this.g.mul(this.n).isInfinity(), "Invalid curve, G*N != O");
    }
    curves.PresetCurve = PresetCurve;
    function defineCurve(name, options) {
        Object.defineProperty(curves, name, {
            configurable: true,
            enumerable: true,
            get: function() {
                var curve = new PresetCurve(options);
                Object.defineProperty(curves, name, {
                    configurable: true,
                    enumerable: true,
                    value: curve
                });
                return curve;
            }
        });
    }
    defineCurve("p192", {
        type: "short",
        prime: "p192",
        p: "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff",
        a: "ffffffff ffffffff ffffffff fffffffe ffffffff fffffffc",
        b: "64210519 e59c80e7 0fa7e9ab 72243049 feb8deec c146b9b1",
        n: "ffffffff ffffffff ffffffff 99def836 146bc9b1 b4d22831",
        hash: (0, (/*@__PURE__*/$parcel$interopDefault($leqJp))).sha256,
        gRed: false,
        g: [
            "188da80e b03090f6 7cbf20eb 43a18800 f4ff0afd 82ff1012",
            "07192b95 ffc8da78 631011ed 6b24cdd5 73f977a1 1e794811"
        ]
    });
    defineCurve("p224", {
        type: "short",
        prime: "p224",
        p: "ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001",
        a: "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff fffffffe",
        b: "b4050a85 0c04b3ab f5413256 5044b0b7 d7bfd8ba 270b3943 2355ffb4",
        n: "ffffffff ffffffff ffffffff ffff16a2 e0b8f03e 13dd2945 5c5c2a3d",
        hash: (0, (/*@__PURE__*/$parcel$interopDefault($leqJp))).sha256,
        gRed: false,
        g: [
            "b70e0cbd 6bb4bf7f 321390b9 4a03c1d3 56c21122 343280d6 115c1d21",
            "bd376388 b5f723fb 4c22dfe6 cd4375a0 5a074764 44d58199 85007e34"
        ]
    });
    defineCurve("p256", {
        type: "short",
        prime: null,
        p: "ffffffff 00000001 00000000 00000000 00000000 ffffffff ffffffff ffffffff",
        a: "ffffffff 00000001 00000000 00000000 00000000 ffffffff ffffffff fffffffc",
        b: "5ac635d8 aa3a93e7 b3ebbd55 769886bc 651d06b0 cc53b0f6 3bce3c3e 27d2604b",
        n: "ffffffff 00000000 ffffffff ffffffff bce6faad a7179e84 f3b9cac2 fc632551",
        hash: (0, (/*@__PURE__*/$parcel$interopDefault($leqJp))).sha256,
        gRed: false,
        g: [
            "6b17d1f2 e12c4247 f8bce6e5 63a440f2 77037d81 2deb33a0 f4a13945 d898c296",
            "4fe342e2 fe1a7f9b 8ee7eb4a 7c0f9e16 2bce3357 6b315ece cbb64068 37bf51f5"
        ]
    });
    defineCurve("p384", {
        type: "short",
        prime: null,
        p: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe ffffffff 00000000 00000000 ffffffff",
        a: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe ffffffff 00000000 00000000 fffffffc",
        b: "b3312fa7 e23ee7e4 988e056b e3f82d19 181d9c6e fe814112 0314088f 5013875a c656398d 8a2ed19d 2a85c8ed d3ec2aef",
        n: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff c7634d81 f4372ddf 581a0db2 48b0a77a ecec196a ccc52973",
        hash: (0, (/*@__PURE__*/$parcel$interopDefault($leqJp))).sha384,
        gRed: false,
        g: [
            "aa87ca22 be8b0537 8eb1c71e f320ad74 6e1d3b62 8ba79b98 59f741e0 82542a38 5502f25d bf55296c 3a545e38 72760ab7",
            "3617de4a 96262c6f 5d9e98bf 9292dc29 f8f41dbd 289a147c e9da3113 b5f0b8c0 0a60b1ce 1d7e819d 7a431d7c 90ea0e5f"
        ]
    });
    defineCurve("p521", {
        type: "short",
        prime: null,
        p: "000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff",
        a: "000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffc",
        b: "00000051 953eb961 8e1c9a1f 929a21a0 b68540ee a2da725b 99b315f3 b8b48991 8ef109e1 56193951 ec7e937b 1652c0bd 3bb1bf07 3573df88 3d2c34f1 ef451fd4 6b503f00",
        n: "000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffa 51868783 bf2f966b 7fcc0148 f709a5d0 3bb5c9b8 899c47ae bb6fb71e 91386409",
        hash: (0, (/*@__PURE__*/$parcel$interopDefault($leqJp))).sha512,
        gRed: false,
        g: [
            "000000c6 858e06b7 0404e9cd 9e3ecb66 2395b442 9c648139 053fb521 f828af60 6b4d3dba a14b5e77 efe75928 fe1dc127 a2ffa8de 3348b3c1 856a429b f97e7e31 c2e5bd66",
            "00000118 39296a78 9a3bc004 5c8a5fb4 2c7d1bd9 98f54449 579b4468 17afbd17 273e662c 97ee7299 5ef42640 c550b901 3fad0761 353c7086 a272c240 88be9476 9fd16650"
        ]
    });
    defineCurve("curve25519", {
        type: "mont",
        prime: "p25519",
        p: "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed",
        a: "76d06",
        b: "1",
        n: "1000000000000000 0000000000000000 14def9dea2f79cd6 5812631a5cf5d3ed",
        hash: (0, (/*@__PURE__*/$parcel$interopDefault($leqJp))).sha256,
        gRed: false,
        g: [
            "9"
        ]
    });
    defineCurve("ed25519", {
        type: "edwards",
        prime: "p25519",
        p: "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed",
        a: "-1",
        c: "1",
        // -121665 * (121666^(-1)) (mod P)
        d: "52036cee2b6ffe73 8cc740797779e898 00700a4d4141d8ab 75eb4dca135978a3",
        n: "1000000000000000 0000000000000000 14def9dea2f79cd6 5812631a5cf5d3ed",
        hash: (0, (/*@__PURE__*/$parcel$interopDefault($leqJp))).sha256,
        gRed: false,
        g: [
            "216936d3cd6e53fec0a4e231fdd6dc5c692cc7609525a7b2c9562d608f25d51a",
            // 4/5
            "6666666666666666666666666666666666666666666666666666666666666658"
        ]
    });
    var pre;
    try {
        pre = /*RicMoo:ethers:require(./precomputed/secp256k1)*/ null.crash();
    } catch (e) {
        pre = undefined;
    }
    defineCurve("secp256k1", {
        type: "short",
        prime: "k256",
        p: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f",
        a: "0",
        b: "7",
        n: "ffffffff ffffffff ffffffff fffffffe baaedce6 af48a03b bfd25e8c d0364141",
        h: "1",
        hash: (0, (/*@__PURE__*/$parcel$interopDefault($leqJp))).sha256,
        // Precomputed endomorphism
        beta: "7ae96a2b657c07106e64479eac3434e99cf0497512f58995c1396c28719501ee",
        lambda: "5363ad4cc05c30e0a5261c028812645a122e22ea20816678df02967c1b23bd72",
        basis: [
            {
                a: "3086d221a7d46bcde86c90e49284eb15",
                b: "-e4437ed6010e88286f547fa90abfe4c3"
            },
            {
                a: "114ca50f7a8e2f3f657c1108d9d44cfd8",
                b: "3086d221a7d46bcde86c90e49284eb15"
            }
        ],
        gRed: false,
        g: [
            "79be667ef9dcbbac55a06295ce870b07029bfcdb2dce28d959f2815b16f81798",
            "483ada7726a3c4655da4fbfc0e1108a8fd17b448a68554199c47d08ffb10d4b8",
            pre
        ]
    });
});
"use strict";
function $281715568a2bf9a7$var$HmacDRBG(options) {
    if (!(this instanceof $281715568a2bf9a7$var$HmacDRBG)) return new $281715568a2bf9a7$var$HmacDRBG(options);
    this.hash = options.hash;
    this.predResist = !!options.predResist;
    this.outLen = this.hash.outSize;
    this.minEntropy = options.minEntropy || this.hash.hmacStrength;
    this._reseed = null;
    this.reseedInterval = null;
    this.K = null;
    this.V = null;
    var entropy = $281715568a2bf9a7$var$utils_1.toArray(options.entropy, options.entropyEnc || "hex");
    var nonce = $281715568a2bf9a7$var$utils_1.toArray(options.nonce, options.nonceEnc || "hex");
    var pers = $281715568a2bf9a7$var$utils_1.toArray(options.pers, options.persEnc || "hex");
    $281715568a2bf9a7$var$minimalisticAssert(entropy.length >= this.minEntropy / 8, "Not enough entropy. Minimum is: " + this.minEntropy + " bits");
    this._init(entropy, nonce, pers);
}
var $281715568a2bf9a7$var$hmacDrbg = $281715568a2bf9a7$var$HmacDRBG;
$281715568a2bf9a7$var$HmacDRBG.prototype._init = function init(entropy, nonce, pers) {
    var seed = entropy.concat(nonce).concat(pers);
    this.K = new Array(this.outLen / 8);
    this.V = new Array(this.outLen / 8);
    for(var i = 0; i < this.V.length; i++){
        this.K[i] = 0x00;
        this.V[i] = 0x01;
    }
    this._update(seed);
    this._reseed = 1;
    this.reseedInterval = 0x1000000000000; // 2^48
};
$281715568a2bf9a7$var$HmacDRBG.prototype._hmac = function hmac() {
    return new (0, (/*@__PURE__*/$parcel$interopDefault($leqJp))).hmac(this.hash, this.K);
};
$281715568a2bf9a7$var$HmacDRBG.prototype._update = function update(seed) {
    var kmac = this._hmac().update(this.V).update([
        0x00
    ]);
    if (seed) kmac = kmac.update(seed);
    this.K = kmac.digest();
    this.V = this._hmac().update(this.V).digest();
    if (!seed) return;
    this.K = this._hmac().update(this.V).update([
        0x01
    ]).update(seed).digest();
    this.V = this._hmac().update(this.V).digest();
};
$281715568a2bf9a7$var$HmacDRBG.prototype.reseed = function reseed(entropy, entropyEnc, add, addEnc) {
    // Optional entropy enc
    if (typeof entropyEnc !== "string") {
        addEnc = add;
        add = entropyEnc;
        entropyEnc = null;
    }
    entropy = $281715568a2bf9a7$var$utils_1.toArray(entropy, entropyEnc);
    add = $281715568a2bf9a7$var$utils_1.toArray(add, addEnc);
    $281715568a2bf9a7$var$minimalisticAssert(entropy.length >= this.minEntropy / 8, "Not enough entropy. Minimum is: " + this.minEntropy + " bits");
    this._update(entropy.concat(add || []));
    this._reseed = 1;
};
$281715568a2bf9a7$var$HmacDRBG.prototype.generate = function generate(len, enc, add, addEnc) {
    if (this._reseed > this.reseedInterval) throw new Error("Reseed is required");
    // Optional encoding
    if (typeof enc !== "string") {
        addEnc = add;
        add = enc;
        enc = null;
    }
    // Optional additional data
    if (add) {
        add = $281715568a2bf9a7$var$utils_1.toArray(add, addEnc || "hex");
        this._update(add);
    }
    var temp = [];
    while(temp.length < len){
        this.V = this._hmac().update(this.V).digest();
        temp = temp.concat(this.V);
    }
    var res = temp.slice(0, len);
    this._update(add);
    this._reseed++;
    return $281715568a2bf9a7$var$utils_1.encode(res, enc);
};
"use strict";
var $281715568a2bf9a7$var$assert$3 = $281715568a2bf9a7$var$utils_1$1.assert;
function $281715568a2bf9a7$var$KeyPair(ec, options) {
    this.ec = ec;
    this.priv = null;
    this.pub = null;
    // KeyPair(ec, { priv: ..., pub: ... })
    if (options.priv) this._importPrivate(options.priv, options.privEnc);
    if (options.pub) this._importPublic(options.pub, options.pubEnc);
}
var $281715568a2bf9a7$var$key = $281715568a2bf9a7$var$KeyPair;
$281715568a2bf9a7$var$KeyPair.fromPublic = function fromPublic(ec, pub, enc) {
    if (pub instanceof $281715568a2bf9a7$var$KeyPair) return pub;
    return new $281715568a2bf9a7$var$KeyPair(ec, {
        pub: pub,
        pubEnc: enc
    });
};
$281715568a2bf9a7$var$KeyPair.fromPrivate = function fromPrivate(ec, priv, enc) {
    if (priv instanceof $281715568a2bf9a7$var$KeyPair) return priv;
    return new $281715568a2bf9a7$var$KeyPair(ec, {
        priv: priv,
        privEnc: enc
    });
};
$281715568a2bf9a7$var$KeyPair.prototype.validate = function validate() {
    var pub = this.getPublic();
    if (pub.isInfinity()) return {
        result: false,
        reason: "Invalid public key"
    };
    if (!pub.validate()) return {
        result: false,
        reason: "Public key is not a point"
    };
    if (!pub.mul(this.ec.curve.n).isInfinity()) return {
        result: false,
        reason: "Public key * N != O"
    };
    return {
        result: true,
        reason: null
    };
};
$281715568a2bf9a7$var$KeyPair.prototype.getPublic = function getPublic(compact, enc) {
    // compact is optional argument
    if (typeof compact === "string") {
        enc = compact;
        compact = null;
    }
    if (!this.pub) this.pub = this.ec.g.mul(this.priv);
    if (!enc) return this.pub;
    return this.pub.encode(enc, compact);
};
$281715568a2bf9a7$var$KeyPair.prototype.getPrivate = function getPrivate(enc) {
    if (enc === "hex") return this.priv.toString(16, 2);
    else return this.priv;
};
$281715568a2bf9a7$var$KeyPair.prototype._importPrivate = function _importPrivate(key, enc) {
    this.priv = new (0, (/*@__PURE__*/$parcel$interopDefault($9we9E)))(key, enc || 16);
    // Ensure that the priv won't be bigger than n, otherwise we may fail
    // in fixed multiplication method
    this.priv = this.priv.umod(this.ec.curve.n);
};
$281715568a2bf9a7$var$KeyPair.prototype._importPublic = function _importPublic(key, enc) {
    if (key.x || key.y) {
        // Montgomery points only have an `x` coordinate.
        // Weierstrass/Edwards points on the other hand have both `x` and
        // `y` coordinates.
        if (this.ec.curve.type === "mont") $281715568a2bf9a7$var$assert$3(key.x, "Need x coordinate");
        else if (this.ec.curve.type === "short" || this.ec.curve.type === "edwards") $281715568a2bf9a7$var$assert$3(key.x && key.y, "Need both x and y coordinate");
        this.pub = this.ec.curve.point(key.x, key.y);
        return;
    }
    this.pub = this.ec.curve.decodePoint(key, enc);
};
// ECDH
$281715568a2bf9a7$var$KeyPair.prototype.derive = function derive(pub) {
    if (!pub.validate()) $281715568a2bf9a7$var$assert$3(pub.validate(), "public point not validated");
    return pub.mul(this.priv).getX();
};
// ECDSA
$281715568a2bf9a7$var$KeyPair.prototype.sign = function sign(msg, enc, options) {
    return this.ec.sign(msg, this, enc, options);
};
$281715568a2bf9a7$var$KeyPair.prototype.verify = function verify(msg, signature) {
    return this.ec.verify(msg, signature, this);
};
$281715568a2bf9a7$var$KeyPair.prototype.inspect = function inspect() {
    return "<Key priv: " + (this.priv && this.priv.toString(16, 2)) + " pub: " + (this.pub && this.pub.inspect()) + " >";
};
"use strict";
var $281715568a2bf9a7$var$assert$4 = $281715568a2bf9a7$var$utils_1$1.assert;
function $281715568a2bf9a7$var$Signature(options, enc) {
    if (options instanceof $281715568a2bf9a7$var$Signature) return options;
    if (this._importDER(options, enc)) return;
    $281715568a2bf9a7$var$assert$4(options.r && options.s, "Signature without r or s");
    this.r = new (0, (/*@__PURE__*/$parcel$interopDefault($9we9E)))(options.r, 16);
    this.s = new (0, (/*@__PURE__*/$parcel$interopDefault($9we9E)))(options.s, 16);
    if (options.recoveryParam === undefined) this.recoveryParam = null;
    else this.recoveryParam = options.recoveryParam;
}
var $281715568a2bf9a7$var$signature = $281715568a2bf9a7$var$Signature;
function $281715568a2bf9a7$var$Position() {
    this.place = 0;
}
function $281715568a2bf9a7$var$getLength(buf, p) {
    var initial = buf[p.place++];
    if (!(initial & 0x80)) return initial;
    var octetLen = initial & 0xf;
    // Indefinite length or overflow
    if (octetLen === 0 || octetLen > 4) return false;
    var val = 0;
    for(var i = 0, off = p.place; i < octetLen; i++, off++){
        val <<= 8;
        val |= buf[off];
        val >>>= 0;
    }
    // Leading zeroes
    if (val <= 0x7f) return false;
    p.place = off;
    return val;
}
function $281715568a2bf9a7$var$rmPadding(buf) {
    var i = 0;
    var len = buf.length - 1;
    while(!buf[i] && !(buf[i + 1] & 0x80) && i < len)i++;
    if (i === 0) return buf;
    return buf.slice(i);
}
$281715568a2bf9a7$var$Signature.prototype._importDER = function _importDER(data, enc) {
    data = $281715568a2bf9a7$var$utils_1$1.toArray(data, enc);
    var p = new $281715568a2bf9a7$var$Position();
    if (data[p.place++] !== 0x30) return false;
    var len = $281715568a2bf9a7$var$getLength(data, p);
    if (len === false) return false;
    if (len + p.place !== data.length) return false;
    if (data[p.place++] !== 0x02) return false;
    var rlen = $281715568a2bf9a7$var$getLength(data, p);
    if (rlen === false) return false;
    var r = data.slice(p.place, rlen + p.place);
    p.place += rlen;
    if (data[p.place++] !== 0x02) return false;
    var slen = $281715568a2bf9a7$var$getLength(data, p);
    if (slen === false) return false;
    if (data.length !== slen + p.place) return false;
    var s = data.slice(p.place, slen + p.place);
    if (r[0] === 0) {
        if (r[1] & 0x80) r = r.slice(1);
        else // Leading zeroes
        return false;
    }
    if (s[0] === 0) {
        if (s[1] & 0x80) s = s.slice(1);
        else // Leading zeroes
        return false;
    }
    this.r = new (0, (/*@__PURE__*/$parcel$interopDefault($9we9E)))(r);
    this.s = new (0, (/*@__PURE__*/$parcel$interopDefault($9we9E)))(s);
    this.recoveryParam = null;
    return true;
};
function $281715568a2bf9a7$var$constructLength(arr, len) {
    if (len < 0x80) {
        arr.push(len);
        return;
    }
    var octets = 1 + (Math.log(len) / Math.LN2 >>> 3);
    arr.push(octets | 0x80);
    while(--octets)arr.push(len >>> (octets << 3) & 0xff);
    arr.push(len);
}
$281715568a2bf9a7$var$Signature.prototype.toDER = function toDER(enc) {
    var r = this.r.toArray();
    var s = this.s.toArray();
    // Pad values
    if (r[0] & 0x80) r = [
        0
    ].concat(r);
    // Pad values
    if (s[0] & 0x80) s = [
        0
    ].concat(s);
    r = $281715568a2bf9a7$var$rmPadding(r);
    s = $281715568a2bf9a7$var$rmPadding(s);
    while(!s[0] && !(s[1] & 0x80))s = s.slice(1);
    var arr = [
        0x02
    ];
    $281715568a2bf9a7$var$constructLength(arr, r.length);
    arr = arr.concat(r);
    arr.push(0x02);
    $281715568a2bf9a7$var$constructLength(arr, s.length);
    var backHalf = arr.concat(s);
    var res = [
        0x30
    ];
    $281715568a2bf9a7$var$constructLength(res, backHalf.length);
    res = res.concat(backHalf);
    return $281715568a2bf9a7$var$utils_1$1.encode(res, enc);
};
"use strict";
var $281715568a2bf9a7$var$rand = /*RicMoo:ethers:require(brorand)*/ function() {
    throw new Error("unsupported");
};
var $281715568a2bf9a7$var$assert$5 = $281715568a2bf9a7$var$utils_1$1.assert;
function $281715568a2bf9a7$var$EC(options) {
    if (!(this instanceof $281715568a2bf9a7$var$EC)) return new $281715568a2bf9a7$var$EC(options);
    // Shortcut `elliptic.ec(curve-name)`
    if (typeof options === "string") {
        $281715568a2bf9a7$var$assert$5(Object.prototype.hasOwnProperty.call($281715568a2bf9a7$var$curves_1, options), "Unknown curve " + options);
        options = $281715568a2bf9a7$var$curves_1[options];
    }
    // Shortcut for `elliptic.ec(elliptic.curves.curveName)`
    if (options instanceof $281715568a2bf9a7$var$curves_1.PresetCurve) options = {
        curve: options
    };
    this.curve = options.curve.curve;
    this.n = this.curve.n;
    this.nh = this.n.ushrn(1);
    this.g = this.curve.g;
    // Point on curve
    this.g = options.curve.g;
    this.g.precompute(options.curve.n.bitLength() + 1);
    // Hash for function for DRBG
    this.hash = options.hash || options.curve.hash;
}
var $281715568a2bf9a7$var$ec = $281715568a2bf9a7$var$EC;
$281715568a2bf9a7$var$EC.prototype.keyPair = function keyPair(options) {
    return new $281715568a2bf9a7$var$key(this, options);
};
$281715568a2bf9a7$var$EC.prototype.keyFromPrivate = function keyFromPrivate(priv, enc) {
    return $281715568a2bf9a7$var$key.fromPrivate(this, priv, enc);
};
$281715568a2bf9a7$var$EC.prototype.keyFromPublic = function keyFromPublic(pub, enc) {
    return $281715568a2bf9a7$var$key.fromPublic(this, pub, enc);
};
$281715568a2bf9a7$var$EC.prototype.genKeyPair = function genKeyPair(options) {
    if (!options) options = {};
    // Instantiate Hmac_DRBG
    var drbg = new $281715568a2bf9a7$var$hmacDrbg({
        hash: this.hash,
        pers: options.pers,
        persEnc: options.persEnc || "utf8",
        entropy: options.entropy || $281715568a2bf9a7$var$rand(this.hash.hmacStrength),
        entropyEnc: options.entropy && options.entropyEnc || "utf8",
        nonce: this.n.toArray()
    });
    var bytes = this.n.byteLength();
    var ns2 = this.n.sub(new (0, (/*@__PURE__*/$parcel$interopDefault($9we9E)))(2));
    for(;;){
        var priv = new (0, (/*@__PURE__*/$parcel$interopDefault($9we9E)))(drbg.generate(bytes));
        if (priv.cmp(ns2) > 0) continue;
        priv.iaddn(1);
        return this.keyFromPrivate(priv);
    }
};
$281715568a2bf9a7$var$EC.prototype._truncateToN = function _truncateToN(msg, truncOnly) {
    var delta = msg.byteLength() * 8 - this.n.bitLength();
    if (delta > 0) msg = msg.ushrn(delta);
    if (!truncOnly && msg.cmp(this.n) >= 0) return msg.sub(this.n);
    else return msg;
};
$281715568a2bf9a7$var$EC.prototype.sign = function sign(msg, key, enc, options) {
    if (typeof enc === "object") {
        options = enc;
        enc = null;
    }
    if (!options) options = {};
    key = this.keyFromPrivate(key, enc);
    msg = this._truncateToN(new (0, (/*@__PURE__*/$parcel$interopDefault($9we9E)))(msg, 16));
    // Zero-extend key to provide enough entropy
    var bytes = this.n.byteLength();
    var bkey = key.getPrivate().toArray("be", bytes);
    // Zero-extend nonce to have the same byte size as N
    var nonce = msg.toArray("be", bytes);
    // Instantiate Hmac_DRBG
    var drbg = new $281715568a2bf9a7$var$hmacDrbg({
        hash: this.hash,
        entropy: bkey,
        nonce: nonce,
        pers: options.pers,
        persEnc: options.persEnc || "utf8"
    });
    // Number of bytes to generate
    var ns1 = this.n.sub(new (0, (/*@__PURE__*/$parcel$interopDefault($9we9E)))(1));
    for(var iter = 0;; iter++){
        var k = options.k ? options.k(iter) : new (0, (/*@__PURE__*/$parcel$interopDefault($9we9E)))(drbg.generate(this.n.byteLength()));
        k = this._truncateToN(k, true);
        if (k.cmpn(1) <= 0 || k.cmp(ns1) >= 0) continue;
        var kp = this.g.mul(k);
        if (kp.isInfinity()) continue;
        var kpX = kp.getX();
        var r = kpX.umod(this.n);
        if (r.cmpn(0) === 0) continue;
        var s = k.invm(this.n).mul(r.mul(key.getPrivate()).iadd(msg));
        s = s.umod(this.n);
        if (s.cmpn(0) === 0) continue;
        var recoveryParam = (kp.getY().isOdd() ? 1 : 0) | (kpX.cmp(r) !== 0 ? 2 : 0);
        // Use complement of `s`, if it is > `n / 2`
        if (options.canonical && s.cmp(this.nh) > 0) {
            s = this.n.sub(s);
            recoveryParam ^= 1;
        }
        return new $281715568a2bf9a7$var$signature({
            r: r,
            s: s,
            recoveryParam: recoveryParam
        });
    }
};
$281715568a2bf9a7$var$EC.prototype.verify = function verify(msg, signature$1, key, enc) {
    msg = this._truncateToN(new (0, (/*@__PURE__*/$parcel$interopDefault($9we9E)))(msg, 16));
    key = this.keyFromPublic(key, enc);
    signature$1 = new $281715568a2bf9a7$var$signature(signature$1, "hex");
    // Perform primitive values validation
    var r = signature$1.r;
    var s = signature$1.s;
    if (r.cmpn(1) < 0 || r.cmp(this.n) >= 0) return false;
    if (s.cmpn(1) < 0 || s.cmp(this.n) >= 0) return false;
    // Validate signature
    var sinv = s.invm(this.n);
    var u1 = sinv.mul(msg).umod(this.n);
    var u2 = sinv.mul(r).umod(this.n);
    var p;
    if (!this.curve._maxwellTrick) {
        p = this.g.mulAdd(u1, key.getPublic(), u2);
        if (p.isInfinity()) return false;
        return p.getX().umod(this.n).cmp(r) === 0;
    }
    // NOTE: Greg Maxwell's trick, inspired by:
    // https://git.io/vad3K
    p = this.g.jmulAdd(u1, key.getPublic(), u2);
    if (p.isInfinity()) return false;
    // Compare `p.x` of Jacobian point with `r`,
    // this will do `p.x == r * p.z^2` instead of multiplying `p.x` by the
    // inverse of `p.z^2`
    return p.eqXToP(r);
};
$281715568a2bf9a7$var$EC.prototype.recoverPubKey = function(msg, signature$1, j, enc) {
    $281715568a2bf9a7$var$assert$5((3 & j) === j, "The recovery param is more than two bits");
    signature$1 = new $281715568a2bf9a7$var$signature(signature$1, enc);
    var n = this.n;
    var e = new (0, (/*@__PURE__*/$parcel$interopDefault($9we9E)))(msg);
    var r = signature$1.r;
    var s = signature$1.s;
    // A set LSB signifies that the y-coordinate is odd
    var isYOdd = j & 1;
    var isSecondKey = j >> 1;
    if (r.cmp(this.curve.p.umod(this.curve.n)) >= 0 && isSecondKey) throw new Error("Unable to find sencond key candinate");
    // 1.1. Let x = r + jn.
    if (isSecondKey) r = this.curve.pointFromX(r.add(this.curve.n), isYOdd);
    else r = this.curve.pointFromX(r, isYOdd);
    var rInv = signature$1.r.invm(n);
    var s1 = n.sub(e).mul(rInv).umod(n);
    var s2 = s.mul(rInv).umod(n);
    // 1.6.1 Compute Q = r^-1 (sR -  eG)
    //               Q = r^-1 (sR + -eG)
    return this.g.mulAdd(s1, r, s2);
};
$281715568a2bf9a7$var$EC.prototype.getKeyRecoveryParam = function(e, signature$1, Q, enc) {
    signature$1 = new $281715568a2bf9a7$var$signature(signature$1, enc);
    if (signature$1.recoveryParam !== null) return signature$1.recoveryParam;
    for(var i = 0; i < 4; i++){
        var Qprime;
        try {
            Qprime = this.recoverPubKey(e, signature$1, i);
        } catch (e) {
            continue;
        }
        if (Qprime.eq(Q)) return i;
    }
    throw new Error("Unable to find valid recovery factor");
};
var $281715568a2bf9a7$var$elliptic_1 = $281715568a2bf9a7$var$createCommonjsModule(function(module, exports) {
    "use strict";
    var elliptic = exports;
    elliptic.version = "6.5.4";
    elliptic.utils = $281715568a2bf9a7$var$utils_1$1;
    elliptic.rand = /*RicMoo:ethers:require(brorand)*/ function() {
        throw new Error("unsupported");
    };
    elliptic.curve = $281715568a2bf9a7$var$curve_1;
    elliptic.curves = $281715568a2bf9a7$var$curves_1;
    // Protocols
    elliptic.ec = $281715568a2bf9a7$var$ec;
    elliptic.eddsa = /*RicMoo:ethers:require(./elliptic/eddsa)*/ null;
});
var $281715568a2bf9a7$export$129fe12d32abc311 = $281715568a2bf9a7$var$elliptic_1.ec;





const $9c0eaf0f6b9e8102$export$83d89fbfd8236492 = "signing-key/5.7.0";


"use strict";
const $49ebbfa7c2be841e$var$logger = new (0, $5f596c9584f643ae$export$efa9a398d6368992)((0, $9c0eaf0f6b9e8102$export$83d89fbfd8236492));
let $49ebbfa7c2be841e$var$_curve = null;
function $49ebbfa7c2be841e$var$getCurve() {
    if (!$49ebbfa7c2be841e$var$_curve) $49ebbfa7c2be841e$var$_curve = new (0, $281715568a2bf9a7$export$129fe12d32abc311)("secp256k1");
    return $49ebbfa7c2be841e$var$_curve;
}
class $49ebbfa7c2be841e$export$21643ca94aed3e83 {
    constructor(privateKey){
        (0, $d2d9b472f7878d5e$exports.defineReadOnly)(this, "curve", "secp256k1");
        (0, $d2d9b472f7878d5e$exports.defineReadOnly)(this, "privateKey", (0, $06d75ae17ce69367$export$2b0d6b5fbe698c70)(privateKey));
        if ((0, $06d75ae17ce69367$export$13882f896d3c0683)(this.privateKey) !== 32) $49ebbfa7c2be841e$var$logger.throwArgumentError("invalid private key", "privateKey", "[[ REDACTED ]]");
        const keyPair = $49ebbfa7c2be841e$var$getCurve().keyFromPrivate((0, $06d75ae17ce69367$export$3131421a7d01b4fb)(this.privateKey));
        (0, $d2d9b472f7878d5e$exports.defineReadOnly)(this, "publicKey", "0x" + keyPair.getPublic(false, "hex"));
        (0, $d2d9b472f7878d5e$exports.defineReadOnly)(this, "compressedPublicKey", "0x" + keyPair.getPublic(true, "hex"));
        (0, $d2d9b472f7878d5e$exports.defineReadOnly)(this, "_isSigningKey", true);
    }
    _addPoint(other) {
        const p0 = $49ebbfa7c2be841e$var$getCurve().keyFromPublic((0, $06d75ae17ce69367$export$3131421a7d01b4fb)(this.publicKey));
        const p1 = $49ebbfa7c2be841e$var$getCurve().keyFromPublic((0, $06d75ae17ce69367$export$3131421a7d01b4fb)(other));
        return "0x" + p0.pub.add(p1.pub).encodeCompressed("hex");
    }
    signDigest(digest) {
        const keyPair = $49ebbfa7c2be841e$var$getCurve().keyFromPrivate((0, $06d75ae17ce69367$export$3131421a7d01b4fb)(this.privateKey));
        const digestBytes = (0, $06d75ae17ce69367$export$3131421a7d01b4fb)(digest);
        if (digestBytes.length !== 32) $49ebbfa7c2be841e$var$logger.throwArgumentError("bad digest length", "digest", digest);
        const signature = keyPair.sign(digestBytes, {
            canonical: true
        });
        return (0, $06d75ae17ce69367$export$7fb170f1e457988f)({
            recoveryParam: signature.recoveryParam,
            r: (0, $06d75ae17ce69367$export$e9c46a54370b47e8)("0x" + signature.r.toString(16), 32),
            s: (0, $06d75ae17ce69367$export$e9c46a54370b47e8)("0x" + signature.s.toString(16), 32)
        });
    }
    computeSharedSecret(otherKey) {
        const keyPair = $49ebbfa7c2be841e$var$getCurve().keyFromPrivate((0, $06d75ae17ce69367$export$3131421a7d01b4fb)(this.privateKey));
        const otherKeyPair = $49ebbfa7c2be841e$var$getCurve().keyFromPublic((0, $06d75ae17ce69367$export$3131421a7d01b4fb)($49ebbfa7c2be841e$export$4a89473d39301224(otherKey)));
        return (0, $06d75ae17ce69367$export$e9c46a54370b47e8)("0x" + keyPair.derive(otherKeyPair.getPublic()).toString(16), 32);
    }
    static isSigningKey(value) {
        return !!(value && value._isSigningKey);
    }
}
function $49ebbfa7c2be841e$export$952dd09fbe0232b7(digest, signature) {
    const sig = (0, $06d75ae17ce69367$export$7fb170f1e457988f)(signature);
    const rs = {
        r: (0, $06d75ae17ce69367$export$3131421a7d01b4fb)(sig.r),
        s: (0, $06d75ae17ce69367$export$3131421a7d01b4fb)(sig.s)
    };
    return "0x" + $49ebbfa7c2be841e$var$getCurve().recoverPubKey((0, $06d75ae17ce69367$export$3131421a7d01b4fb)(digest), rs, sig.recoveryParam).encode("hex", false);
}
function $49ebbfa7c2be841e$export$4a89473d39301224(key, compressed) {
    const bytes = (0, $06d75ae17ce69367$export$3131421a7d01b4fb)(key);
    if (bytes.length === 32) {
        const signingKey = new $49ebbfa7c2be841e$export$21643ca94aed3e83(bytes);
        if (compressed) return "0x" + $49ebbfa7c2be841e$var$getCurve().keyFromPrivate(bytes).getPublic(true, "hex");
        return signingKey.publicKey;
    } else if (bytes.length === 33) {
        if (compressed) return (0, $06d75ae17ce69367$export$2b0d6b5fbe698c70)(bytes);
        return "0x" + $49ebbfa7c2be841e$var$getCurve().keyFromPublic(bytes).getPublic(false, "hex");
    } else if (bytes.length === 65) {
        if (!compressed) return (0, $06d75ae17ce69367$export$2b0d6b5fbe698c70)(bytes);
        return "0x" + $49ebbfa7c2be841e$var$getCurve().keyFromPublic(bytes).getPublic(true, "hex");
    }
    return $49ebbfa7c2be841e$var$logger.throwArgumentError("invalid public or private key", "key", "[REDACTED]");
}



const $6bb4b35d8ca5d704$export$83d89fbfd8236492 = "transactions/5.7.0";


"use strict";
const $4335107f861a4482$var$logger = new (0, $5f596c9584f643ae$export$efa9a398d6368992)((0, $6bb4b35d8ca5d704$export$83d89fbfd8236492));
var $4335107f861a4482$export$80349e05e0724e11;
(function(TransactionTypes) {
    TransactionTypes[TransactionTypes["legacy"] = 0] = "legacy";
    TransactionTypes[TransactionTypes["eip2930"] = 1] = "eip2930";
    TransactionTypes[TransactionTypes["eip1559"] = 2] = "eip1559";
})($4335107f861a4482$export$80349e05e0724e11 || ($4335107f861a4482$export$80349e05e0724e11 = {}));
///////////////////////////////
function $4335107f861a4482$var$handleAddress(value) {
    if (value === "0x") return null;
    return (0, $5652f239bab101de$export$88411125f012957a)(value);
}
function $4335107f861a4482$var$handleNumber(value) {
    if (value === "0x") return 0, $9b44019502d48201$export$aaef8a3eae948f03;
    return (0, $a87aa97415e1b917$export$d97aa349ed20696).from(value);
}
// Legacy Transaction Fields
const $4335107f861a4482$var$transactionFields = [
    {
        name: "nonce",
        maxLength: 32,
        numeric: true
    },
    {
        name: "gasPrice",
        maxLength: 32,
        numeric: true
    },
    {
        name: "gasLimit",
        maxLength: 32,
        numeric: true
    },
    {
        name: "to",
        length: 20
    },
    {
        name: "value",
        maxLength: 32,
        numeric: true
    },
    {
        name: "data"
    }
];
const $4335107f861a4482$var$allowedTransactionKeys = {
    chainId: true,
    data: true,
    gasLimit: true,
    gasPrice: true,
    nonce: true,
    to: true,
    type: true,
    value: true
};
function $4335107f861a4482$export$e67e2732ba9803f9(key) {
    const publicKey = (0, $49ebbfa7c2be841e$export$4a89473d39301224)(key);
    return (0, $5652f239bab101de$export$88411125f012957a)((0, $06d75ae17ce69367$export$15da666eba198c18)((0, $62e3396d458230e9$export$f8151fce47ad1c35)((0, $06d75ae17ce69367$export$15da666eba198c18)(publicKey, 1)), 12));
}
function $4335107f861a4482$export$23cc18f96d8510e2(digest, signature) {
    return $4335107f861a4482$export$e67e2732ba9803f9((0, $49ebbfa7c2be841e$export$952dd09fbe0232b7)((0, $06d75ae17ce69367$export$3131421a7d01b4fb)(digest), signature));
}
function $4335107f861a4482$var$formatNumber(value, name) {
    const result = (0, $06d75ae17ce69367$export$a8f4574d0e56446c)((0, $a87aa97415e1b917$export$d97aa349ed20696).from(value).toHexString());
    if (result.length > 32) $4335107f861a4482$var$logger.throwArgumentError("invalid length for " + name, "transaction:" + name, value);
    return result;
}
function $4335107f861a4482$var$accessSetify(addr, storageKeys) {
    return {
        address: (0, $5652f239bab101de$export$88411125f012957a)(addr),
        storageKeys: (storageKeys || []).map((storageKey, index)=>{
            if ((0, $06d75ae17ce69367$export$13882f896d3c0683)(storageKey) !== 32) $4335107f861a4482$var$logger.throwArgumentError("invalid access list storageKey", `accessList[${addr}:${index}]`, storageKey);
            return storageKey.toLowerCase();
        })
    };
}
function $4335107f861a4482$export$6c8662b1600dce2(value) {
    if (Array.isArray(value)) return value.map((set, index)=>{
        if (Array.isArray(set)) {
            if (set.length > 2) $4335107f861a4482$var$logger.throwArgumentError("access list expected to be [ address, storageKeys[] ]", `value[${index}]`, set);
            return $4335107f861a4482$var$accessSetify(set[0], set[1]);
        }
        return $4335107f861a4482$var$accessSetify(set.address, set.storageKeys);
    });
    const result = Object.keys(value).map((addr)=>{
        const storageKeys = value[addr].reduce((accum, storageKey)=>{
            accum[storageKey] = true;
            return accum;
        }, {});
        return $4335107f861a4482$var$accessSetify(addr, Object.keys(storageKeys).sort());
    });
    result.sort((a, b)=>a.address.localeCompare(b.address));
    return result;
}
function $4335107f861a4482$var$formatAccessList(value) {
    return $4335107f861a4482$export$6c8662b1600dce2(value).map((set)=>[
            set.address,
            set.storageKeys
        ]);
}
function $4335107f861a4482$var$_serializeEip1559(transaction, signature) {
    // If there is an explicit gasPrice, make sure it matches the
    // EIP-1559 fees; otherwise they may not understand what they
    // think they are setting in terms of fee.
    if (transaction.gasPrice != null) {
        const gasPrice = (0, $a87aa97415e1b917$export$d97aa349ed20696).from(transaction.gasPrice);
        const maxFeePerGas = (0, $a87aa97415e1b917$export$d97aa349ed20696).from(transaction.maxFeePerGas || 0);
        if (!gasPrice.eq(maxFeePerGas)) $4335107f861a4482$var$logger.throwArgumentError("mismatch EIP-1559 gasPrice != maxFeePerGas", "tx", {
            gasPrice: gasPrice,
            maxFeePerGas: maxFeePerGas
        });
    }
    const fields = [
        $4335107f861a4482$var$formatNumber(transaction.chainId || 0, "chainId"),
        $4335107f861a4482$var$formatNumber(transaction.nonce || 0, "nonce"),
        $4335107f861a4482$var$formatNumber(transaction.maxPriorityFeePerGas || 0, "maxPriorityFeePerGas"),
        $4335107f861a4482$var$formatNumber(transaction.maxFeePerGas || 0, "maxFeePerGas"),
        $4335107f861a4482$var$formatNumber(transaction.gasLimit || 0, "gasLimit"),
        transaction.to != null ? (0, $5652f239bab101de$export$88411125f012957a)(transaction.to) : "0x",
        $4335107f861a4482$var$formatNumber(transaction.value || 0, "value"),
        transaction.data || "0x",
        $4335107f861a4482$var$formatAccessList(transaction.accessList || [])
    ];
    if (signature) {
        const sig = (0, $06d75ae17ce69367$export$7fb170f1e457988f)(signature);
        fields.push($4335107f861a4482$var$formatNumber(sig.recoveryParam, "recoveryParam"));
        fields.push((0, $06d75ae17ce69367$export$a8f4574d0e56446c)(sig.r));
        fields.push((0, $06d75ae17ce69367$export$a8f4574d0e56446c)(sig.s));
    }
    return (0, $06d75ae17ce69367$export$6d4b99629b38754a)([
        "0x02",
        $196d3b44be9fdb46$export$c564cdbbe6da493(fields)
    ]);
}
function $4335107f861a4482$var$_serializeEip2930(transaction, signature) {
    const fields = [
        $4335107f861a4482$var$formatNumber(transaction.chainId || 0, "chainId"),
        $4335107f861a4482$var$formatNumber(transaction.nonce || 0, "nonce"),
        $4335107f861a4482$var$formatNumber(transaction.gasPrice || 0, "gasPrice"),
        $4335107f861a4482$var$formatNumber(transaction.gasLimit || 0, "gasLimit"),
        transaction.to != null ? (0, $5652f239bab101de$export$88411125f012957a)(transaction.to) : "0x",
        $4335107f861a4482$var$formatNumber(transaction.value || 0, "value"),
        transaction.data || "0x",
        $4335107f861a4482$var$formatAccessList(transaction.accessList || [])
    ];
    if (signature) {
        const sig = (0, $06d75ae17ce69367$export$7fb170f1e457988f)(signature);
        fields.push($4335107f861a4482$var$formatNumber(sig.recoveryParam, "recoveryParam"));
        fields.push((0, $06d75ae17ce69367$export$a8f4574d0e56446c)(sig.r));
        fields.push((0, $06d75ae17ce69367$export$a8f4574d0e56446c)(sig.s));
    }
    return (0, $06d75ae17ce69367$export$6d4b99629b38754a)([
        "0x01",
        $196d3b44be9fdb46$export$c564cdbbe6da493(fields)
    ]);
}
// Legacy Transactions and EIP-155
function $4335107f861a4482$var$_serialize(transaction, signature) {
    (0, $d2d9b472f7878d5e$exports.checkProperties)(transaction, $4335107f861a4482$var$allowedTransactionKeys);
    const raw = [];
    $4335107f861a4482$var$transactionFields.forEach(function(fieldInfo) {
        let value = transaction[fieldInfo.name] || [];
        const options = {};
        if (fieldInfo.numeric) options.hexPad = "left";
        value = (0, $06d75ae17ce69367$export$3131421a7d01b4fb)((0, $06d75ae17ce69367$export$2b0d6b5fbe698c70)(value, options));
        // Fixed-width field
        if (fieldInfo.length && value.length !== fieldInfo.length && value.length > 0) $4335107f861a4482$var$logger.throwArgumentError("invalid length for " + fieldInfo.name, "transaction:" + fieldInfo.name, value);
        // Variable-width (with a maximum)
        if (fieldInfo.maxLength) {
            value = (0, $06d75ae17ce69367$export$a8f4574d0e56446c)(value);
            if (value.length > fieldInfo.maxLength) $4335107f861a4482$var$logger.throwArgumentError("invalid length for " + fieldInfo.name, "transaction:" + fieldInfo.name, value);
        }
        raw.push((0, $06d75ae17ce69367$export$2b0d6b5fbe698c70)(value));
    });
    let chainId = 0;
    if (transaction.chainId != null) {
        // A chainId was provided; if non-zero we'll use EIP-155
        chainId = transaction.chainId;
        if (typeof chainId !== "number") $4335107f861a4482$var$logger.throwArgumentError("invalid transaction.chainId", "transaction", transaction);
    } else if (signature && !(0, $06d75ae17ce69367$export$9a14abb1a440cd5e)(signature) && signature.v > 28) // No chainId provided, but the signature is signing with EIP-155; derive chainId
    chainId = Math.floor((signature.v - 35) / 2);
    // We have an EIP-155 transaction (chainId was specified and non-zero)
    if (chainId !== 0) {
        raw.push((0, $06d75ae17ce69367$export$2b0d6b5fbe698c70)(chainId)); // @TODO: hexValue?
        raw.push("0x");
        raw.push("0x");
    }
    // Requesting an unsigned transaction
    if (!signature) return $196d3b44be9fdb46$export$c564cdbbe6da493(raw);
    // The splitSignature will ensure the transaction has a recoveryParam in the
    // case that the signTransaction function only adds a v.
    const sig = (0, $06d75ae17ce69367$export$7fb170f1e457988f)(signature);
    // We pushed a chainId and null r, s on for hashing only; remove those
    let v = 27 + sig.recoveryParam;
    if (chainId !== 0) {
        raw.pop();
        raw.pop();
        raw.pop();
        v += chainId * 2 + 8;
        // If an EIP-155 v (directly or indirectly; maybe _vs) was provided, check it!
        if (sig.v > 28 && sig.v !== v) $4335107f861a4482$var$logger.throwArgumentError("transaction.chainId/signature.v mismatch", "signature", signature);
    } else if (sig.v !== v) $4335107f861a4482$var$logger.throwArgumentError("transaction.chainId/signature.v mismatch", "signature", signature);
    raw.push((0, $06d75ae17ce69367$export$2b0d6b5fbe698c70)(v));
    raw.push((0, $06d75ae17ce69367$export$a8f4574d0e56446c)((0, $06d75ae17ce69367$export$3131421a7d01b4fb)(sig.r)));
    raw.push((0, $06d75ae17ce69367$export$a8f4574d0e56446c)((0, $06d75ae17ce69367$export$3131421a7d01b4fb)(sig.s)));
    return $196d3b44be9fdb46$export$c564cdbbe6da493(raw);
}
function $4335107f861a4482$export$dfdc1655ccc5b9cb(transaction, signature) {
    // Legacy and EIP-155 Transactions
    if (transaction.type == null || transaction.type === 0) {
        if (transaction.accessList != null) $4335107f861a4482$var$logger.throwArgumentError("untyped transactions do not support accessList; include type: 1", "transaction", transaction);
        return $4335107f861a4482$var$_serialize(transaction, signature);
    }
    // Typed Transactions (EIP-2718)
    switch(transaction.type){
        case 1:
            return $4335107f861a4482$var$_serializeEip2930(transaction, signature);
        case 2:
            return $4335107f861a4482$var$_serializeEip1559(transaction, signature);
        default:
            break;
    }
    return $4335107f861a4482$var$logger.throwError(`unsupported transaction type: ${transaction.type}`, (0, $5f596c9584f643ae$export$efa9a398d6368992).errors.UNSUPPORTED_OPERATION, {
        operation: "serializeTransaction",
        transactionType: transaction.type
    });
}
function $4335107f861a4482$var$_parseEipSignature(tx, fields, serialize) {
    try {
        const recid = $4335107f861a4482$var$handleNumber(fields[0]).toNumber();
        if (recid !== 0 && recid !== 1) throw new Error("bad recid");
        tx.v = recid;
    } catch (error) {
        $4335107f861a4482$var$logger.throwArgumentError("invalid v for transaction type: 1", "v", fields[0]);
    }
    tx.r = (0, $06d75ae17ce69367$export$e9c46a54370b47e8)(fields[1], 32);
    tx.s = (0, $06d75ae17ce69367$export$e9c46a54370b47e8)(fields[2], 32);
    try {
        const digest = (0, $62e3396d458230e9$export$f8151fce47ad1c35)(serialize(tx));
        tx.from = $4335107f861a4482$export$23cc18f96d8510e2(digest, {
            r: tx.r,
            s: tx.s,
            recoveryParam: tx.v
        });
    } catch (error) {}
}
function $4335107f861a4482$var$_parseEip1559(payload) {
    const transaction = $196d3b44be9fdb46$export$2f872c0f2117be69(payload.slice(1));
    if (transaction.length !== 9 && transaction.length !== 12) $4335107f861a4482$var$logger.throwArgumentError("invalid component count for transaction type: 2", "payload", (0, $06d75ae17ce69367$export$2b0d6b5fbe698c70)(payload));
    const maxPriorityFeePerGas = $4335107f861a4482$var$handleNumber(transaction[2]);
    const maxFeePerGas = $4335107f861a4482$var$handleNumber(transaction[3]);
    const tx = {
        type: 2,
        chainId: $4335107f861a4482$var$handleNumber(transaction[0]).toNumber(),
        nonce: $4335107f861a4482$var$handleNumber(transaction[1]).toNumber(),
        maxPriorityFeePerGas: maxPriorityFeePerGas,
        maxFeePerGas: maxFeePerGas,
        gasPrice: null,
        gasLimit: $4335107f861a4482$var$handleNumber(transaction[4]),
        to: $4335107f861a4482$var$handleAddress(transaction[5]),
        value: $4335107f861a4482$var$handleNumber(transaction[6]),
        data: transaction[7],
        accessList: $4335107f861a4482$export$6c8662b1600dce2(transaction[8])
    };
    // Unsigned EIP-1559 Transaction
    if (transaction.length === 9) return tx;
    tx.hash = (0, $62e3396d458230e9$export$f8151fce47ad1c35)(payload);
    $4335107f861a4482$var$_parseEipSignature(tx, transaction.slice(9), $4335107f861a4482$var$_serializeEip1559);
    return tx;
}
function $4335107f861a4482$var$_parseEip2930(payload) {
    const transaction = $196d3b44be9fdb46$export$2f872c0f2117be69(payload.slice(1));
    if (transaction.length !== 8 && transaction.length !== 11) $4335107f861a4482$var$logger.throwArgumentError("invalid component count for transaction type: 1", "payload", (0, $06d75ae17ce69367$export$2b0d6b5fbe698c70)(payload));
    const tx = {
        type: 1,
        chainId: $4335107f861a4482$var$handleNumber(transaction[0]).toNumber(),
        nonce: $4335107f861a4482$var$handleNumber(transaction[1]).toNumber(),
        gasPrice: $4335107f861a4482$var$handleNumber(transaction[2]),
        gasLimit: $4335107f861a4482$var$handleNumber(transaction[3]),
        to: $4335107f861a4482$var$handleAddress(transaction[4]),
        value: $4335107f861a4482$var$handleNumber(transaction[5]),
        data: transaction[6],
        accessList: $4335107f861a4482$export$6c8662b1600dce2(transaction[7])
    };
    // Unsigned EIP-2930 Transaction
    if (transaction.length === 8) return tx;
    tx.hash = (0, $62e3396d458230e9$export$f8151fce47ad1c35)(payload);
    $4335107f861a4482$var$_parseEipSignature(tx, transaction.slice(8), $4335107f861a4482$var$_serializeEip2930);
    return tx;
}
// Legacy Transactions and EIP-155
function $4335107f861a4482$var$_parse(rawTransaction) {
    const transaction = $196d3b44be9fdb46$export$2f872c0f2117be69(rawTransaction);
    if (transaction.length !== 9 && transaction.length !== 6) $4335107f861a4482$var$logger.throwArgumentError("invalid raw transaction", "rawTransaction", rawTransaction);
    const tx = {
        nonce: $4335107f861a4482$var$handleNumber(transaction[0]).toNumber(),
        gasPrice: $4335107f861a4482$var$handleNumber(transaction[1]),
        gasLimit: $4335107f861a4482$var$handleNumber(transaction[2]),
        to: $4335107f861a4482$var$handleAddress(transaction[3]),
        value: $4335107f861a4482$var$handleNumber(transaction[4]),
        data: transaction[5],
        chainId: 0
    };
    // Legacy unsigned transaction
    if (transaction.length === 6) return tx;
    try {
        tx.v = (0, $a87aa97415e1b917$export$d97aa349ed20696).from(transaction[6]).toNumber();
    } catch (error) {
        // @TODO: What makes snese to do? The v is too big
        return tx;
    }
    tx.r = (0, $06d75ae17ce69367$export$e9c46a54370b47e8)(transaction[7], 32);
    tx.s = (0, $06d75ae17ce69367$export$e9c46a54370b47e8)(transaction[8], 32);
    if ((0, $a87aa97415e1b917$export$d97aa349ed20696).from(tx.r).isZero() && (0, $a87aa97415e1b917$export$d97aa349ed20696).from(tx.s).isZero()) {
        // EIP-155 unsigned transaction
        tx.chainId = tx.v;
        tx.v = 0;
    } else {
        // Signed Transaction
        tx.chainId = Math.floor((tx.v - 35) / 2);
        if (tx.chainId < 0) tx.chainId = 0;
        let recoveryParam = tx.v - 27;
        const raw = transaction.slice(0, 6);
        if (tx.chainId !== 0) {
            raw.push((0, $06d75ae17ce69367$export$2b0d6b5fbe698c70)(tx.chainId));
            raw.push("0x");
            raw.push("0x");
            recoveryParam -= tx.chainId * 2 + 8;
        }
        const digest = (0, $62e3396d458230e9$export$f8151fce47ad1c35)($196d3b44be9fdb46$export$c564cdbbe6da493(raw));
        try {
            tx.from = $4335107f861a4482$export$23cc18f96d8510e2(digest, {
                r: (0, $06d75ae17ce69367$export$2b0d6b5fbe698c70)(tx.r),
                s: (0, $06d75ae17ce69367$export$2b0d6b5fbe698c70)(tx.s),
                recoveryParam: recoveryParam
            });
        } catch (error) {}
        tx.hash = (0, $62e3396d458230e9$export$f8151fce47ad1c35)(rawTransaction);
    }
    tx.type = null;
    return tx;
}
function $4335107f861a4482$export$98e6a39c04603d36(rawTransaction) {
    const payload = (0, $06d75ae17ce69367$export$3131421a7d01b4fb)(rawTransaction);
    // Legacy and EIP-155 Transactions
    if (payload[0] > 0x7f) return $4335107f861a4482$var$_parse(payload);
    // Typed Transaction (EIP-2718)
    switch(payload[0]){
        case 1:
            return $4335107f861a4482$var$_parseEip2930(payload);
        case 2:
            return $4335107f861a4482$var$_parseEip1559(payload);
        default:
            break;
    }
    return $4335107f861a4482$var$logger.throwError(`unsupported transaction type: ${payload[0]}`, (0, $5f596c9584f643ae$export$efa9a398d6368992).errors.UNSUPPORTED_OPERATION, {
        operation: "parseTransaction",
        transactionType: payload[0]
    });
}




"use strict";
const $23494291de5f329b$var$logger = new (0, $5f596c9584f643ae$export$efa9a398d6368992)((0, $e9ed5b422bb4952f$export$83d89fbfd8236492));
class $23494291de5f329b$export$a06636add2a09fd8 {
    constructor(){
        this.formats = this.getDefaultFormats();
    }
    getDefaultFormats() {
        const formats = {};
        const address = this.address.bind(this);
        const bigNumber = this.bigNumber.bind(this);
        const blockTag = this.blockTag.bind(this);
        const data = this.data.bind(this);
        const hash = this.hash.bind(this);
        const hex = this.hex.bind(this);
        const number = this.number.bind(this);
        const type = this.type.bind(this);
        const strictData = (v)=>{
            return this.data(v, true);
        };
        formats.transaction = {
            hash: hash,
            type: type,
            accessList: $23494291de5f329b$export$a06636add2a09fd8.allowNull(this.accessList.bind(this), null),
            blockHash: $23494291de5f329b$export$a06636add2a09fd8.allowNull(hash, null),
            blockNumber: $23494291de5f329b$export$a06636add2a09fd8.allowNull(number, null),
            transactionIndex: $23494291de5f329b$export$a06636add2a09fd8.allowNull(number, null),
            confirmations: $23494291de5f329b$export$a06636add2a09fd8.allowNull(number, null),
            from: address,
            // either (gasPrice) or (maxPriorityFeePerGas + maxFeePerGas)
            // must be set
            gasPrice: $23494291de5f329b$export$a06636add2a09fd8.allowNull(bigNumber),
            maxPriorityFeePerGas: $23494291de5f329b$export$a06636add2a09fd8.allowNull(bigNumber),
            maxFeePerGas: $23494291de5f329b$export$a06636add2a09fd8.allowNull(bigNumber),
            gasLimit: bigNumber,
            to: $23494291de5f329b$export$a06636add2a09fd8.allowNull(address, null),
            value: bigNumber,
            nonce: number,
            data: data,
            r: $23494291de5f329b$export$a06636add2a09fd8.allowNull(this.uint256),
            s: $23494291de5f329b$export$a06636add2a09fd8.allowNull(this.uint256),
            v: $23494291de5f329b$export$a06636add2a09fd8.allowNull(number),
            creates: $23494291de5f329b$export$a06636add2a09fd8.allowNull(address, null),
            raw: $23494291de5f329b$export$a06636add2a09fd8.allowNull(data)
        };
        formats.transactionRequest = {
            from: $23494291de5f329b$export$a06636add2a09fd8.allowNull(address),
            nonce: $23494291de5f329b$export$a06636add2a09fd8.allowNull(number),
            gasLimit: $23494291de5f329b$export$a06636add2a09fd8.allowNull(bigNumber),
            gasPrice: $23494291de5f329b$export$a06636add2a09fd8.allowNull(bigNumber),
            maxPriorityFeePerGas: $23494291de5f329b$export$a06636add2a09fd8.allowNull(bigNumber),
            maxFeePerGas: $23494291de5f329b$export$a06636add2a09fd8.allowNull(bigNumber),
            to: $23494291de5f329b$export$a06636add2a09fd8.allowNull(address),
            value: $23494291de5f329b$export$a06636add2a09fd8.allowNull(bigNumber),
            data: $23494291de5f329b$export$a06636add2a09fd8.allowNull(strictData),
            type: $23494291de5f329b$export$a06636add2a09fd8.allowNull(number),
            accessList: $23494291de5f329b$export$a06636add2a09fd8.allowNull(this.accessList.bind(this), null)
        };
        formats.receiptLog = {
            transactionIndex: number,
            blockNumber: number,
            transactionHash: hash,
            address: address,
            topics: $23494291de5f329b$export$a06636add2a09fd8.arrayOf(hash),
            data: data,
            logIndex: number,
            blockHash: hash
        };
        formats.receipt = {
            to: $23494291de5f329b$export$a06636add2a09fd8.allowNull(this.address, null),
            from: $23494291de5f329b$export$a06636add2a09fd8.allowNull(this.address, null),
            contractAddress: $23494291de5f329b$export$a06636add2a09fd8.allowNull(address, null),
            transactionIndex: number,
            // should be allowNull(hash), but broken-EIP-658 support is handled in receipt
            root: $23494291de5f329b$export$a06636add2a09fd8.allowNull(hex),
            gasUsed: bigNumber,
            logsBloom: $23494291de5f329b$export$a06636add2a09fd8.allowNull(data),
            blockHash: hash,
            transactionHash: hash,
            logs: $23494291de5f329b$export$a06636add2a09fd8.arrayOf(this.receiptLog.bind(this)),
            blockNumber: number,
            confirmations: $23494291de5f329b$export$a06636add2a09fd8.allowNull(number, null),
            cumulativeGasUsed: bigNumber,
            effectiveGasPrice: $23494291de5f329b$export$a06636add2a09fd8.allowNull(bigNumber),
            status: $23494291de5f329b$export$a06636add2a09fd8.allowNull(number),
            type: type
        };
        formats.block = {
            hash: $23494291de5f329b$export$a06636add2a09fd8.allowNull(hash),
            parentHash: hash,
            number: number,
            timestamp: number,
            nonce: $23494291de5f329b$export$a06636add2a09fd8.allowNull(hex),
            difficulty: this.difficulty.bind(this),
            gasLimit: bigNumber,
            gasUsed: bigNumber,
            miner: $23494291de5f329b$export$a06636add2a09fd8.allowNull(address),
            extraData: data,
            transactions: $23494291de5f329b$export$a06636add2a09fd8.allowNull($23494291de5f329b$export$a06636add2a09fd8.arrayOf(hash)),
            baseFeePerGas: $23494291de5f329b$export$a06636add2a09fd8.allowNull(bigNumber)
        };
        formats.blockWithTransactions = (0, $d2d9b472f7878d5e$exports.shallowCopy)(formats.block);
        formats.blockWithTransactions.transactions = $23494291de5f329b$export$a06636add2a09fd8.allowNull($23494291de5f329b$export$a06636add2a09fd8.arrayOf(this.transactionResponse.bind(this)));
        formats.filter = {
            fromBlock: $23494291de5f329b$export$a06636add2a09fd8.allowNull(blockTag, undefined),
            toBlock: $23494291de5f329b$export$a06636add2a09fd8.allowNull(blockTag, undefined),
            blockHash: $23494291de5f329b$export$a06636add2a09fd8.allowNull(hash, undefined),
            address: $23494291de5f329b$export$a06636add2a09fd8.allowNull(address, undefined),
            topics: $23494291de5f329b$export$a06636add2a09fd8.allowNull(this.topics.bind(this), undefined)
        };
        formats.filterLog = {
            blockNumber: $23494291de5f329b$export$a06636add2a09fd8.allowNull(number),
            blockHash: $23494291de5f329b$export$a06636add2a09fd8.allowNull(hash),
            transactionIndex: number,
            removed: $23494291de5f329b$export$a06636add2a09fd8.allowNull(this.boolean.bind(this)),
            address: address,
            data: $23494291de5f329b$export$a06636add2a09fd8.allowFalsish(data, "0x"),
            topics: $23494291de5f329b$export$a06636add2a09fd8.arrayOf(hash),
            transactionHash: hash,
            logIndex: number
        };
        return formats;
    }
    accessList(accessList) {
        return (0, $4335107f861a4482$export$6c8662b1600dce2)(accessList || []);
    }
    // Requires a BigNumberish that is within the IEEE754 safe integer range; returns a number
    // Strict! Used on input.
    number(number) {
        if (number === "0x") return 0;
        return (0, $a87aa97415e1b917$export$d97aa349ed20696).from(number).toNumber();
    }
    type(number) {
        if (number === "0x" || number == null) return 0;
        return (0, $a87aa97415e1b917$export$d97aa349ed20696).from(number).toNumber();
    }
    // Strict! Used on input.
    bigNumber(value) {
        return (0, $a87aa97415e1b917$export$d97aa349ed20696).from(value);
    }
    // Requires a boolean, "true" or  "false"; returns a boolean
    boolean(value) {
        if (typeof value === "boolean") return value;
        if (typeof value === "string") {
            value = value.toLowerCase();
            if (value === "true") return true;
            if (value === "false") return false;
        }
        throw new Error("invalid boolean - " + value);
    }
    hex(value, strict) {
        if (typeof value === "string") {
            if (!strict && value.substring(0, 2) !== "0x") value = "0x" + value;
            if ((0, $06d75ae17ce69367$export$b02a40aff8e4ad18)(value)) return value.toLowerCase();
        }
        return $23494291de5f329b$var$logger.throwArgumentError("invalid hash", "value", value);
    }
    data(value, strict) {
        const result = this.hex(value, strict);
        if (result.length % 2 !== 0) throw new Error("invalid data; odd-length - " + value);
        return result;
    }
    // Requires an address
    // Strict! Used on input.
    address(value) {
        return (0, $5652f239bab101de$export$88411125f012957a)(value);
    }
    callAddress(value) {
        if (!(0, $06d75ae17ce69367$export$b02a40aff8e4ad18)(value, 32)) return null;
        const address = (0, $5652f239bab101de$export$88411125f012957a)((0, $06d75ae17ce69367$export$15da666eba198c18)(value, 12));
        return address === (0, $16ad1643f931e329$export$badd13187c087617) ? null : address;
    }
    contractAddress(value) {
        return (0, $5652f239bab101de$export$b7fbffef12272e40)(value);
    }
    // Strict! Used on input.
    blockTag(blockTag) {
        if (blockTag == null) return "latest";
        if (blockTag === "earliest") return "0x0";
        switch(blockTag){
            case "earliest":
                return "0x0";
            case "latest":
            case "pending":
            case "safe":
            case "finalized":
                return blockTag;
        }
        if (typeof blockTag === "number" || (0, $06d75ae17ce69367$export$b02a40aff8e4ad18)(blockTag)) return (0, $06d75ae17ce69367$export$6916af760a341dd3)(blockTag);
        throw new Error("invalid blockTag");
    }
    // Requires a hash, optionally requires 0x prefix; returns prefixed lowercase hash.
    hash(value, strict) {
        const result = this.hex(value, strict);
        if ((0, $06d75ae17ce69367$export$13882f896d3c0683)(result) !== 32) return $23494291de5f329b$var$logger.throwArgumentError("invalid hash", "value", value);
        return result;
    }
    // Returns the difficulty as a number, or if too large (i.e. PoA network) null
    difficulty(value) {
        if (value == null) return null;
        const v = (0, $a87aa97415e1b917$export$d97aa349ed20696).from(value);
        try {
            return v.toNumber();
        } catch (error) {}
        return null;
    }
    uint256(value) {
        if (!(0, $06d75ae17ce69367$export$b02a40aff8e4ad18)(value)) throw new Error("invalid uint256");
        return (0, $06d75ae17ce69367$export$e9c46a54370b47e8)(value, 32);
    }
    _block(value, format) {
        if (value.author != null && value.miner == null) value.miner = value.author;
        // The difficulty may need to come from _difficulty in recursed blocks
        const difficulty = value._difficulty != null ? value._difficulty : value.difficulty;
        const result = $23494291de5f329b$export$a06636add2a09fd8.check(format, value);
        result._difficulty = difficulty == null ? null : (0, $a87aa97415e1b917$export$d97aa349ed20696).from(difficulty);
        return result;
    }
    block(value) {
        return this._block(value, this.formats.block);
    }
    blockWithTransactions(value) {
        return this._block(value, this.formats.blockWithTransactions);
    }
    // Strict! Used on input.
    transactionRequest(value) {
        return $23494291de5f329b$export$a06636add2a09fd8.check(this.formats.transactionRequest, value);
    }
    transactionResponse(transaction) {
        // Rename gas to gasLimit
        if (transaction.gas != null && transaction.gasLimit == null) transaction.gasLimit = transaction.gas;
        // Some clients (TestRPC) do strange things like return 0x0 for the
        // 0 address; correct this to be a real address
        if (transaction.to && (0, $a87aa97415e1b917$export$d97aa349ed20696).from(transaction.to).isZero()) transaction.to = "0x0000000000000000000000000000000000000000";
        // Rename input to data
        if (transaction.input != null && transaction.data == null) transaction.data = transaction.input;
        // If to and creates are empty, populate the creates from the transaction
        if (transaction.to == null && transaction.creates == null) transaction.creates = this.contractAddress(transaction);
        if ((transaction.type === 1 || transaction.type === 2) && transaction.accessList == null) transaction.accessList = [];
        const result = $23494291de5f329b$export$a06636add2a09fd8.check(this.formats.transaction, transaction);
        if (transaction.chainId != null) {
            let chainId = transaction.chainId;
            if ((0, $06d75ae17ce69367$export$b02a40aff8e4ad18)(chainId)) chainId = (0, $a87aa97415e1b917$export$d97aa349ed20696).from(chainId).toNumber();
            result.chainId = chainId;
        } else {
            let chainId = transaction.networkId;
            // geth-etc returns chainId
            if (chainId == null && result.v == null) chainId = transaction.chainId;
            if ((0, $06d75ae17ce69367$export$b02a40aff8e4ad18)(chainId)) chainId = (0, $a87aa97415e1b917$export$d97aa349ed20696).from(chainId).toNumber();
            if (typeof chainId !== "number" && result.v != null) {
                chainId = (result.v - 35) / 2;
                if (chainId < 0) chainId = 0;
                chainId = parseInt(chainId);
            }
            if (typeof chainId !== "number") chainId = 0;
            result.chainId = chainId;
        }
        // 0x0000... should actually be null
        if (result.blockHash && result.blockHash.replace(/0/g, "") === "x") result.blockHash = null;
        return result;
    }
    transaction(value) {
        return (0, $4335107f861a4482$export$98e6a39c04603d36)(value);
    }
    receiptLog(value) {
        return $23494291de5f329b$export$a06636add2a09fd8.check(this.formats.receiptLog, value);
    }
    receipt(value) {
        const result = $23494291de5f329b$export$a06636add2a09fd8.check(this.formats.receipt, value);
        // RSK incorrectly implemented EIP-658, so we munge things a bit here for it
        if (result.root != null) {
            if (result.root.length <= 4) {
                // Could be 0x00, 0x0, 0x01 or 0x1
                const value = (0, $a87aa97415e1b917$export$d97aa349ed20696).from(result.root).toNumber();
                if (value === 0 || value === 1) {
                    // Make sure if both are specified, they match
                    if (result.status != null && result.status !== value) $23494291de5f329b$var$logger.throwArgumentError("alt-root-status/status mismatch", "value", {
                        root: result.root,
                        status: result.status
                    });
                    result.status = value;
                    delete result.root;
                } else $23494291de5f329b$var$logger.throwArgumentError("invalid alt-root-status", "value.root", result.root);
            } else if (result.root.length !== 66) // Must be a valid bytes32
            $23494291de5f329b$var$logger.throwArgumentError("invalid root hash", "value.root", result.root);
        }
        if (result.status != null) result.byzantium = true;
        return result;
    }
    topics(value) {
        if (Array.isArray(value)) return value.map((v)=>this.topics(v));
        else if (value != null) return this.hash(value, true);
        return null;
    }
    filter(value) {
        return $23494291de5f329b$export$a06636add2a09fd8.check(this.formats.filter, value);
    }
    filterLog(value) {
        return $23494291de5f329b$export$a06636add2a09fd8.check(this.formats.filterLog, value);
    }
    static check(format, object) {
        const result = {};
        for(const key in format)try {
            const value = format[key](object[key]);
            if (value !== undefined) result[key] = value;
        } catch (error) {
            error.checkKey = key;
            error.checkValue = object[key];
            throw error;
        }
        return result;
    }
    // if value is null-ish, nullValue is returned
    static allowNull(format, nullValue) {
        return function(value) {
            if (value == null) return nullValue;
            return format(value);
        };
    }
    // If value is false-ish, replaceValue is returned
    static allowFalsish(format, replaceValue) {
        return function(value) {
            if (!value) return replaceValue;
            return format(value);
        };
    }
    // Requires an Array satisfying check
    static arrayOf(format) {
        return function(array) {
            if (!Array.isArray(array)) throw new Error("not an array");
            const result = [];
            array.forEach(function(value) {
                result.push(format(value));
            });
            return result;
        };
    }
}
function $23494291de5f329b$export$3091239f5b20b896(value) {
    return value && typeof value.isCommunityResource === "function";
}
function $23494291de5f329b$export$d93d5f61c2498b6(value) {
    return $23494291de5f329b$export$3091239f5b20b896(value) && value.isCommunityResource();
}
// Show the throttle message only once
let $23494291de5f329b$var$throttleMessage = false;
function $23494291de5f329b$export$4c41bd49e82e82ab() {
    if ($23494291de5f329b$var$throttleMessage) return;
    $23494291de5f329b$var$throttleMessage = true;
    console.log("========= NOTICE =========");
    console.log("Request-Rate Exceeded  (this message will not be repeated)");
    console.log("");
    console.log("The default API keys for each service are provided as a highly-throttled,");
    console.log("community resource for low-traffic projects and early prototyping.");
    console.log("");
    console.log("While your application will continue to function, we highly recommended");
    console.log("signing up for your own API keys to improve performance, increase your");
    console.log("request rate/limit and enable other perks, such as metrics and advanced APIs.");
    console.log("");
    console.log("For more details: https://docs.ethers.io/api-keys/");
    console.log("==========================");
}


"use strict";
var $fa2219aa02c3e62e$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
const $fa2219aa02c3e62e$var$logger = new (0, $5f596c9584f643ae$export$efa9a398d6368992)((0, $e9ed5b422bb4952f$export$83d89fbfd8236492));
const $fa2219aa02c3e62e$var$MAX_CCIP_REDIRECTS = 10;
//////////////////////////////
// Event Serializeing
function $fa2219aa02c3e62e$var$checkTopic(topic) {
    if (topic == null) return "null";
    if ((0, $06d75ae17ce69367$export$13882f896d3c0683)(topic) !== 32) $fa2219aa02c3e62e$var$logger.throwArgumentError("invalid topic", "topic", topic);
    return topic.toLowerCase();
}
function $fa2219aa02c3e62e$var$serializeTopics(topics) {
    // Remove trailing null AND-topics; they are redundant
    topics = topics.slice();
    while(topics.length > 0 && topics[topics.length - 1] == null)topics.pop();
    return topics.map((topic)=>{
        if (Array.isArray(topic)) {
            // Only track unique OR-topics
            const unique = {};
            topic.forEach((topic)=>{
                unique[$fa2219aa02c3e62e$var$checkTopic(topic)] = true;
            });
            // The order of OR-topics does not matter
            const sorted = Object.keys(unique);
            sorted.sort();
            return sorted.join("|");
        } else return $fa2219aa02c3e62e$var$checkTopic(topic);
    }).join("&");
}
function $fa2219aa02c3e62e$var$deserializeTopics(data) {
    if (data === "") return [];
    return data.split(/&/g).map((topic)=>{
        if (topic === "") return [];
        const comps = topic.split("|").map((topic)=>{
            return topic === "null" ? null : topic;
        });
        return comps.length === 1 ? comps[0] : comps;
    });
}
function $fa2219aa02c3e62e$var$getEventTag(eventName) {
    if (typeof eventName === "string") {
        eventName = eventName.toLowerCase();
        if ((0, $06d75ae17ce69367$export$13882f896d3c0683)(eventName) === 32) return "tx:" + eventName;
        if (eventName.indexOf(":") === -1) return eventName;
    } else if (Array.isArray(eventName)) return "filter:*:" + $fa2219aa02c3e62e$var$serializeTopics(eventName);
    else if ((0, $9f78b76a8aa61745$exports.ForkEvent).isForkEvent(eventName)) {
        $fa2219aa02c3e62e$var$logger.warn("not implemented");
        throw new Error("not implemented");
    } else if (eventName && typeof eventName === "object") return "filter:" + (eventName.address || "*") + ":" + $fa2219aa02c3e62e$var$serializeTopics(eventName.topics || []);
    throw new Error("invalid event - " + eventName);
}
//////////////////////////////
// Helper Object
function $fa2219aa02c3e62e$var$getTime() {
    return new Date().getTime();
}
function $fa2219aa02c3e62e$var$stall(duration) {
    return new Promise((resolve)=>{
        setTimeout(resolve, duration);
    });
}
//////////////////////////////
// Provider Object
/**
 *  EventType
 *   - "block"
 *   - "poll"
 *   - "didPoll"
 *   - "pending"
 *   - "error"
 *   - "network"
 *   - filter
 *   - topics array
 *   - transaction hash
 */ const $fa2219aa02c3e62e$var$PollableEvents = [
    "block",
    "network",
    "pending",
    "poll"
];
class $fa2219aa02c3e62e$export$d61e24a684f9e51 {
    constructor(tag, listener, once){
        (0, $d2d9b472f7878d5e$exports.defineReadOnly)(this, "tag", tag);
        (0, $d2d9b472f7878d5e$exports.defineReadOnly)(this, "listener", listener);
        (0, $d2d9b472f7878d5e$exports.defineReadOnly)(this, "once", once);
        this._lastBlockNumber = -2;
        this._inflight = false;
    }
    get event() {
        switch(this.type){
            case "tx":
                return this.hash;
            case "filter":
                return this.filter;
        }
        return this.tag;
    }
    get type() {
        return this.tag.split(":")[0];
    }
    get hash() {
        const comps = this.tag.split(":");
        if (comps[0] !== "tx") return null;
        return comps[1];
    }
    get filter() {
        const comps = this.tag.split(":");
        if (comps[0] !== "filter") return null;
        const address = comps[1];
        const topics = $fa2219aa02c3e62e$var$deserializeTopics(comps[2]);
        const filter = {};
        if (topics.length > 0) filter.topics = topics;
        if (address && address !== "*") filter.address = address;
        return filter;
    }
    pollable() {
        return this.tag.indexOf(":") >= 0 || $fa2219aa02c3e62e$var$PollableEvents.indexOf(this.tag) >= 0;
    }
}
// https://github.com/satoshilabs/slips/blob/master/slip-0044.md
const $fa2219aa02c3e62e$var$coinInfos = {
    "0": {
        symbol: "btc",
        p2pkh: 0x00,
        p2sh: 0x05,
        prefix: "bc"
    },
    "2": {
        symbol: "ltc",
        p2pkh: 0x30,
        p2sh: 0x32,
        prefix: "ltc"
    },
    "3": {
        symbol: "doge",
        p2pkh: 0x1e,
        p2sh: 0x16
    },
    "60": {
        symbol: "eth",
        ilk: "eth"
    },
    "61": {
        symbol: "etc",
        ilk: "eth"
    },
    "700": {
        symbol: "xdai",
        ilk: "eth"
    }
};
function $fa2219aa02c3e62e$var$bytes32ify(value) {
    return (0, $06d75ae17ce69367$export$e9c46a54370b47e8)((0, $a87aa97415e1b917$export$d97aa349ed20696).from(value).toHexString(), 32);
}
// Compute the Base58Check encoded data (checksum is first 4 bytes of sha256d)
function $fa2219aa02c3e62e$var$base58Encode(data) {
    return (0, $4f9292cbf9a48447$export$45a587635c9954b2).encode((0, $06d75ae17ce69367$export$ee1b3e54f0441b22)([
        data,
        (0, $06d75ae17ce69367$export$15da666eba198c18)((0, $ad6b4320c60d6c47$export$bced8d2aada2d1c9)((0, $ad6b4320c60d6c47$export$bced8d2aada2d1c9)(data)), 0, 4)
    ]));
}
const $fa2219aa02c3e62e$var$matcherIpfs = new RegExp("^(ipfs)://(.*)$", "i");
const $fa2219aa02c3e62e$var$matchers = [
    new RegExp("^(https)://(.*)$", "i"),
    new RegExp("^(data):(.*)$", "i"),
    $fa2219aa02c3e62e$var$matcherIpfs,
    new RegExp("^eip155:[0-9]+/(erc[0-9]+):(.*)$", "i")
];
function $fa2219aa02c3e62e$var$_parseString(result, start) {
    try {
        return (0, $7bbf1261c840221b$export$7643a1dc2c38d5eb)($fa2219aa02c3e62e$var$_parseBytes(result, start));
    } catch (error) {}
    return null;
}
function $fa2219aa02c3e62e$var$_parseBytes(result, start) {
    if (result === "0x") return null;
    const offset = (0, $a87aa97415e1b917$export$d97aa349ed20696).from((0, $06d75ae17ce69367$export$15da666eba198c18)(result, start, start + 32)).toNumber();
    const length = (0, $a87aa97415e1b917$export$d97aa349ed20696).from((0, $06d75ae17ce69367$export$15da666eba198c18)(result, offset, offset + 32)).toNumber();
    return (0, $06d75ae17ce69367$export$15da666eba198c18)(result, offset + 32, offset + 32 + length);
}
// Trim off the ipfs:// prefix and return the default gateway URL
function $fa2219aa02c3e62e$var$getIpfsLink(link) {
    if (link.match(/^ipfs:\/\/ipfs\//i)) link = link.substring(12);
    else if (link.match(/^ipfs:\/\//i)) link = link.substring(7);
    else $fa2219aa02c3e62e$var$logger.throwArgumentError("unsupported IPFS format", "link", link);
    return `https:/\/gateway.ipfs.io/ipfs/${link}`;
}
function $fa2219aa02c3e62e$var$numPad(value) {
    const result = (0, $06d75ae17ce69367$export$3131421a7d01b4fb)(value);
    if (result.length > 32) throw new Error("internal; should not happen");
    const padded = new Uint8Array(32);
    padded.set(result, 32 - result.length);
    return padded;
}
function $fa2219aa02c3e62e$var$bytesPad(value) {
    if (value.length % 32 === 0) return value;
    const result = new Uint8Array(Math.ceil(value.length / 32) * 32);
    result.set(value);
    return result;
}
// ABI Encodes a series of (bytes, bytes, ...)
function $fa2219aa02c3e62e$var$encodeBytes(datas) {
    const result = [];
    let byteCount = 0;
    // Add place-holders for pointers as we add items
    for(let i = 0; i < datas.length; i++){
        result.push(null);
        byteCount += 32;
    }
    for(let i = 0; i < datas.length; i++){
        const data = (0, $06d75ae17ce69367$export$3131421a7d01b4fb)(datas[i]);
        // Update the bytes offset
        result[i] = $fa2219aa02c3e62e$var$numPad(byteCount);
        // The length and padded value of data
        result.push($fa2219aa02c3e62e$var$numPad(data.length));
        result.push($fa2219aa02c3e62e$var$bytesPad(data));
        byteCount += 32 + Math.ceil(data.length / 32) * 32;
    }
    return (0, $06d75ae17ce69367$export$6d4b99629b38754a)(result);
}
class $fa2219aa02c3e62e$export$8b4c839865b08288 {
    // The resolvedAddress is only for creating a ReverseLookup resolver
    constructor(provider, address, name, resolvedAddress){
        (0, $d2d9b472f7878d5e$exports.defineReadOnly)(this, "provider", provider);
        (0, $d2d9b472f7878d5e$exports.defineReadOnly)(this, "name", name);
        (0, $d2d9b472f7878d5e$exports.defineReadOnly)(this, "address", provider.formatter.address(address));
        (0, $d2d9b472f7878d5e$exports.defineReadOnly)(this, "_resolvedAddress", resolvedAddress);
    }
    supportsWildcard() {
        if (!this._supportsEip2544) // supportsInterface(bytes4 = selector("resolve(bytes,bytes)"))
        this._supportsEip2544 = this.provider.call({
            to: this.address,
            data: "0x01ffc9a79061b92300000000000000000000000000000000000000000000000000000000"
        }).then((result)=>{
            return (0, $a87aa97415e1b917$export$d97aa349ed20696).from(result).eq(1);
        }).catch((error)=>{
            if (error.code === (0, $5f596c9584f643ae$export$efa9a398d6368992).errors.CALL_EXCEPTION) return false;
            // Rethrow the error: link is down, etc. Let future attempts retry.
            this._supportsEip2544 = null;
            throw error;
        });
        return this._supportsEip2544;
    }
    _fetch(selector, parameters) {
        return $fa2219aa02c3e62e$var$__awaiter(this, void 0, void 0, function*() {
            // e.g. keccak256("addr(bytes32,uint256)")
            const tx = {
                to: this.address,
                ccipReadEnabled: true,
                data: (0, $06d75ae17ce69367$export$6d4b99629b38754a)([
                    selector,
                    (0, $0e4d091b6edb4637$export$91d651ee363e1209)(this.name),
                    parameters || "0x"
                ])
            };
            // Wildcard support; use EIP-2544 to resolve the request
            let parseBytes = false;
            if (yield this.supportsWildcard()) {
                parseBytes = true;
                // selector("resolve(bytes,bytes)")
                tx.data = (0, $06d75ae17ce69367$export$6d4b99629b38754a)([
                    "0x9061b923",
                    $fa2219aa02c3e62e$var$encodeBytes([
                        (0, $0e4d091b6edb4637$export$6c0a8cdae51cb512)(this.name),
                        tx.data
                    ])
                ]);
            }
            try {
                let result = yield this.provider.call(tx);
                if ((0, $06d75ae17ce69367$export$3131421a7d01b4fb)(result).length % 32 === 4) $fa2219aa02c3e62e$var$logger.throwError("resolver threw error", (0, $5f596c9584f643ae$export$efa9a398d6368992).errors.CALL_EXCEPTION, {
                    transaction: tx,
                    data: result
                });
                if (parseBytes) result = $fa2219aa02c3e62e$var$_parseBytes(result, 0);
                return result;
            } catch (error) {
                if (error.code === (0, $5f596c9584f643ae$export$efa9a398d6368992).errors.CALL_EXCEPTION) return null;
                throw error;
            }
        });
    }
    _fetchBytes(selector, parameters) {
        return $fa2219aa02c3e62e$var$__awaiter(this, void 0, void 0, function*() {
            const result = yield this._fetch(selector, parameters);
            if (result != null) return $fa2219aa02c3e62e$var$_parseBytes(result, 0);
            return null;
        });
    }
    _getAddress(coinType, hexBytes) {
        const coinInfo = $fa2219aa02c3e62e$var$coinInfos[String(coinType)];
        if (coinInfo == null) $fa2219aa02c3e62e$var$logger.throwError(`unsupported coin type: ${coinType}`, (0, $5f596c9584f643ae$export$efa9a398d6368992).errors.UNSUPPORTED_OPERATION, {
            operation: `getAddress(${coinType})`
        });
        if (coinInfo.ilk === "eth") return this.provider.formatter.address(hexBytes);
        const bytes = (0, $06d75ae17ce69367$export$3131421a7d01b4fb)(hexBytes);
        // P2PKH: OP_DUP OP_HASH160 <pubKeyHash> OP_EQUALVERIFY OP_CHECKSIG
        if (coinInfo.p2pkh != null) {
            const p2pkh = hexBytes.match(/^0x76a9([0-9a-f][0-9a-f])([0-9a-f]*)88ac$/);
            if (p2pkh) {
                const length = parseInt(p2pkh[1], 16);
                if (p2pkh[2].length === length * 2 && length >= 1 && length <= 75) return $fa2219aa02c3e62e$var$base58Encode((0, $06d75ae17ce69367$export$ee1b3e54f0441b22)([
                    [
                        coinInfo.p2pkh
                    ],
                    "0x" + p2pkh[2]
                ]));
            }
        }
        // P2SH: OP_HASH160 <scriptHash> OP_EQUAL
        if (coinInfo.p2sh != null) {
            const p2sh = hexBytes.match(/^0xa9([0-9a-f][0-9a-f])([0-9a-f]*)87$/);
            if (p2sh) {
                const length = parseInt(p2sh[1], 16);
                if (p2sh[2].length === length * 2 && length >= 1 && length <= 75) return $fa2219aa02c3e62e$var$base58Encode((0, $06d75ae17ce69367$export$ee1b3e54f0441b22)([
                    [
                        coinInfo.p2sh
                    ],
                    "0x" + p2sh[2]
                ]));
            }
        }
        // Bech32
        if (coinInfo.prefix != null) {
            const length = bytes[1];
            // https://github.com/bitcoin/bips/blob/master/bip-0141.mediawiki#witness-program
            let version = bytes[0];
            if (version === 0x00) {
                if (length !== 20 && length !== 32) version = -1;
            } else version = -1;
            if (version >= 0 && bytes.length === 2 + length && length >= 1 && length <= 75) {
                const words = (0, (/*@__PURE__*/$parcel$interopDefault($5wgCY))).toWords(bytes.slice(2));
                words.unshift(version);
                return (0, (/*@__PURE__*/$parcel$interopDefault($5wgCY))).encode(coinInfo.prefix, words);
            }
        }
        return null;
    }
    getAddress(coinType) {
        return $fa2219aa02c3e62e$var$__awaiter(this, void 0, void 0, function*() {
            if (coinType == null) coinType = 60;
            // If Ethereum, use the standard `addr(bytes32)`
            if (coinType === 60) try {
                // keccak256("addr(bytes32)")
                const result = yield this._fetch("0x3b3b57de");
                // No address
                if (result === "0x" || result === (0, $0c009a6d1ae8a424$export$71c2e4e213dcb7f2)) return null;
                return this.provider.formatter.callAddress(result);
            } catch (error) {
                if (error.code === (0, $5f596c9584f643ae$export$efa9a398d6368992).errors.CALL_EXCEPTION) return null;
                throw error;
            }
            // keccak256("addr(bytes32,uint256")
            const hexBytes = yield this._fetchBytes("0xf1cb7e06", $fa2219aa02c3e62e$var$bytes32ify(coinType));
            // No address
            if (hexBytes == null || hexBytes === "0x") return null;
            // Compute the address
            const address = this._getAddress(coinType, hexBytes);
            if (address == null) $fa2219aa02c3e62e$var$logger.throwError(`invalid or unsupported coin data`, (0, $5f596c9584f643ae$export$efa9a398d6368992).errors.UNSUPPORTED_OPERATION, {
                operation: `getAddress(${coinType})`,
                coinType: coinType,
                data: hexBytes
            });
            return address;
        });
    }
    getAvatar() {
        return $fa2219aa02c3e62e$var$__awaiter(this, void 0, void 0, function*() {
            const linkage = [
                {
                    type: "name",
                    content: this.name
                }
            ];
            try {
                // test data for ricmoo.eth
                //const avatar = "eip155:1/erc721:0x265385c7f4132228A0d54EB1A9e7460b91c0cC68/29233";
                const avatar = yield this.getText("avatar");
                if (avatar == null) return null;
                for(let i = 0; i < $fa2219aa02c3e62e$var$matchers.length; i++){
                    const match = avatar.match($fa2219aa02c3e62e$var$matchers[i]);
                    if (match == null) continue;
                    const scheme = match[1].toLowerCase();
                    switch(scheme){
                        case "https":
                            linkage.push({
                                type: "url",
                                content: avatar
                            });
                            return {
                                linkage: linkage,
                                url: avatar
                            };
                        case "data":
                            linkage.push({
                                type: "data",
                                content: avatar
                            });
                            return {
                                linkage: linkage,
                                url: avatar
                            };
                        case "ipfs":
                            linkage.push({
                                type: "ipfs",
                                content: avatar
                            });
                            return {
                                linkage: linkage,
                                url: $fa2219aa02c3e62e$var$getIpfsLink(avatar)
                            };
                        case "erc721":
                        case "erc1155":
                            {
                                // Depending on the ERC type, use tokenURI(uint256) or url(uint256)
                                const selector = scheme === "erc721" ? "0xc87b56dd" : "0x0e89341c";
                                linkage.push({
                                    type: scheme,
                                    content: avatar
                                });
                                // The owner of this name
                                const owner = this._resolvedAddress || (yield this.getAddress());
                                const comps = (match[2] || "").split("/");
                                if (comps.length !== 2) return null;
                                const addr = yield this.provider.formatter.address(comps[0]);
                                const tokenId = (0, $06d75ae17ce69367$export$e9c46a54370b47e8)((0, $a87aa97415e1b917$export$d97aa349ed20696).from(comps[1]).toHexString(), 32);
                                // Check that this account owns the token
                                if (scheme === "erc721") {
                                    // ownerOf(uint256 tokenId)
                                    const tokenOwner = this.provider.formatter.callAddress((yield this.provider.call({
                                        to: addr,
                                        data: (0, $06d75ae17ce69367$export$6d4b99629b38754a)([
                                            "0x6352211e",
                                            tokenId
                                        ])
                                    })));
                                    if (owner !== tokenOwner) return null;
                                    linkage.push({
                                        type: "owner",
                                        content: tokenOwner
                                    });
                                } else if (scheme === "erc1155") {
                                    // balanceOf(address owner, uint256 tokenId)
                                    const balance = (0, $a87aa97415e1b917$export$d97aa349ed20696).from((yield this.provider.call({
                                        to: addr,
                                        data: (0, $06d75ae17ce69367$export$6d4b99629b38754a)([
                                            "0x00fdd58e",
                                            (0, $06d75ae17ce69367$export$e9c46a54370b47e8)(owner, 32),
                                            tokenId
                                        ])
                                    })));
                                    if (balance.isZero()) return null;
                                    linkage.push({
                                        type: "balance",
                                        content: balance.toString()
                                    });
                                }
                                // Call the token contract for the metadata URL
                                const tx = {
                                    to: this.provider.formatter.address(comps[0]),
                                    data: (0, $06d75ae17ce69367$export$6d4b99629b38754a)([
                                        selector,
                                        tokenId
                                    ])
                                };
                                let metadataUrl = $fa2219aa02c3e62e$var$_parseString((yield this.provider.call(tx)), 0);
                                if (metadataUrl == null) return null;
                                linkage.push({
                                    type: "metadata-url-base",
                                    content: metadataUrl
                                });
                                // ERC-1155 allows a generic {id} in the URL
                                if (scheme === "erc1155") {
                                    metadataUrl = metadataUrl.replace("{id}", tokenId.substring(2));
                                    linkage.push({
                                        type: "metadata-url-expanded",
                                        content: metadataUrl
                                    });
                                }
                                // Transform IPFS metadata links
                                if (metadataUrl.match(/^ipfs:/i)) metadataUrl = $fa2219aa02c3e62e$var$getIpfsLink(metadataUrl);
                                linkage.push({
                                    type: "metadata-url",
                                    content: metadataUrl
                                });
                                // Get the token metadata
                                const metadata = yield (0, $1f5b367caa9efc4a$exports.fetchJson)(metadataUrl);
                                if (!metadata) return null;
                                linkage.push({
                                    type: "metadata",
                                    content: JSON.stringify(metadata)
                                });
                                // Pull the image URL out
                                let imageUrl = metadata.image;
                                if (typeof imageUrl !== "string") return null;
                                if (imageUrl.match(/^(https:\/\/|data:)/i)) ;
                                else {
                                    // Transform IPFS link to gateway
                                    const ipfs = imageUrl.match($fa2219aa02c3e62e$var$matcherIpfs);
                                    if (ipfs == null) return null;
                                    linkage.push({
                                        type: "url-ipfs",
                                        content: imageUrl
                                    });
                                    imageUrl = $fa2219aa02c3e62e$var$getIpfsLink(imageUrl);
                                }
                                linkage.push({
                                    type: "url",
                                    content: imageUrl
                                });
                                return {
                                    linkage: linkage,
                                    url: imageUrl
                                };
                            }
                    }
                }
            } catch (error) {}
            return null;
        });
    }
    getContentHash() {
        return $fa2219aa02c3e62e$var$__awaiter(this, void 0, void 0, function*() {
            // keccak256("contenthash()")
            const hexBytes = yield this._fetchBytes("0xbc1c58d1");
            // No contenthash
            if (hexBytes == null || hexBytes === "0x") return null;
            // IPFS (CID: 1, Type: DAG-PB)
            const ipfs = hexBytes.match(/^0xe3010170(([0-9a-f][0-9a-f])([0-9a-f][0-9a-f])([0-9a-f]*))$/);
            if (ipfs) {
                const length = parseInt(ipfs[3], 16);
                if (ipfs[4].length === length * 2) return "ipfs://" + (0, $4f9292cbf9a48447$export$45a587635c9954b2).encode("0x" + ipfs[1]);
            }
            // IPNS (CID: 1, Type: libp2p-key)
            const ipns = hexBytes.match(/^0xe5010172(([0-9a-f][0-9a-f])([0-9a-f][0-9a-f])([0-9a-f]*))$/);
            if (ipns) {
                const length = parseInt(ipns[3], 16);
                if (ipns[4].length === length * 2) return "ipns://" + (0, $4f9292cbf9a48447$export$45a587635c9954b2).encode("0x" + ipns[1]);
            }
            // Swarm (CID: 1, Type: swarm-manifest; hash/length hard-coded to keccak256/32)
            const swarm = hexBytes.match(/^0xe40101fa011b20([0-9a-f]*)$/);
            if (swarm) {
                if (swarm[1].length === 64) return "bzz://" + swarm[1];
            }
            const skynet = hexBytes.match(/^0x90b2c605([0-9a-f]*)$/);
            if (skynet) {
                if (skynet[1].length === 68) {
                    // URL Safe base64; https://datatracker.ietf.org/doc/html/rfc4648#section-5
                    const urlSafe = {
                        "=": "",
                        "+": "-",
                        "/": "_"
                    };
                    const hash = (0, $197fdee3ede33bf0$export$c564cdbbe6da493)("0x" + skynet[1]).replace(/[=+\/]/g, (a)=>urlSafe[a]);
                    return "sia://" + hash;
                }
            }
            return $fa2219aa02c3e62e$var$logger.throwError(`invalid or unsupported content hash data`, (0, $5f596c9584f643ae$export$efa9a398d6368992).errors.UNSUPPORTED_OPERATION, {
                operation: "getContentHash()",
                data: hexBytes
            });
        });
    }
    getText(key) {
        return $fa2219aa02c3e62e$var$__awaiter(this, void 0, void 0, function*() {
            // The key encoded as parameter to fetchBytes
            let keyBytes = (0, $7bbf1261c840221b$export$8feeb310b4b4752f)(key);
            // The nodehash consumes the first slot, so the string pointer targets
            // offset 64, with the length at offset 64 and data starting at offset 96
            keyBytes = (0, $06d75ae17ce69367$export$ee1b3e54f0441b22)([
                $fa2219aa02c3e62e$var$bytes32ify(64),
                $fa2219aa02c3e62e$var$bytes32ify(keyBytes.length),
                keyBytes
            ]);
            // Pad to word-size (32 bytes)
            if (keyBytes.length % 32 !== 0) keyBytes = (0, $06d75ae17ce69367$export$ee1b3e54f0441b22)([
                keyBytes,
                (0, $06d75ae17ce69367$export$e9c46a54370b47e8)("0x", 32 - key.length % 32)
            ]);
            const hexBytes = yield this._fetchBytes("0x59d1d43c", (0, $06d75ae17ce69367$export$2b0d6b5fbe698c70)(keyBytes));
            if (hexBytes == null || hexBytes === "0x") return null;
            return (0, $7bbf1261c840221b$export$7643a1dc2c38d5eb)(hexBytes);
        });
    }
}
let $fa2219aa02c3e62e$var$defaultFormatter = null;
let $fa2219aa02c3e62e$var$nextPollId = 1;
class $fa2219aa02c3e62e$export$ff3f6dd83125ac45 extends (0, $9f78b76a8aa61745$exports.Provider) {
    /**
     *  ready
     *
     *  A Promise<Network> that resolves only once the provider is ready.
     *
     *  Sub-classes that call the super with a network without a chainId
     *  MUST set this. Standard named networks have a known chainId.
     *
     */ constructor(network){
        super();
        // Events being listened to
        this._events = [];
        this._emitted = {
            block: -2
        };
        this.disableCcipRead = false;
        this.formatter = new.target.getFormatter();
        // If network is any, this Provider allows the underlying
        // network to change dynamically, and we auto-detect the
        // current network
        (0, $d2d9b472f7878d5e$exports.defineReadOnly)(this, "anyNetwork", network === "any");
        if (this.anyNetwork) network = this.detectNetwork();
        if (network instanceof Promise) {
            this._networkPromise = network;
            // Squash any "unhandled promise" errors; that do not need to be handled
            network.catch((error)=>{});
            // Trigger initial network setting (async)
            this._ready().catch((error)=>{});
        } else {
            const knownNetwork = (0, $d2d9b472f7878d5e$exports.getStatic)(new.target, "getNetwork")(network);
            if (knownNetwork) {
                (0, $d2d9b472f7878d5e$exports.defineReadOnly)(this, "_network", knownNetwork);
                this.emit("network", knownNetwork, null);
            } else $fa2219aa02c3e62e$var$logger.throwArgumentError("invalid network", "network", network);
        }
        this._maxInternalBlockNumber = -1024;
        this._lastBlockNumber = -2;
        this._maxFilterBlockRange = 10;
        this._pollingInterval = 4000;
        this._fastQueryDate = 0;
    }
    _ready() {
        return $fa2219aa02c3e62e$var$__awaiter(this, void 0, void 0, function*() {
            if (this._network == null) {
                let network = null;
                if (this._networkPromise) try {
                    network = yield this._networkPromise;
                } catch (error) {}
                // Try the Provider's network detection (this MUST throw if it cannot)
                if (network == null) network = yield this.detectNetwork();
                // This should never happen; every Provider sub-class should have
                // suggested a network by here (or have thrown).
                if (!network) $fa2219aa02c3e62e$var$logger.throwError("no network detected", (0, $5f596c9584f643ae$export$efa9a398d6368992).errors.UNKNOWN_ERROR, {});
                // Possible this call stacked so do not call defineReadOnly again
                if (this._network == null) {
                    if (this.anyNetwork) this._network = network;
                    else (0, $d2d9b472f7878d5e$exports.defineReadOnly)(this, "_network", network);
                    this.emit("network", network, null);
                }
            }
            return this._network;
        });
    }
    // This will always return the most recently established network.
    // For "any", this can change (a "network" event is emitted before
    // any change is reflected); otherwise this cannot change
    get ready() {
        return (0, $1f5b367caa9efc4a$exports.poll)(()=>{
            return this._ready().then((network)=>{
                return network;
            }, (error)=>{
                // If the network isn't running yet, we will wait
                if (error.code === (0, $5f596c9584f643ae$export$efa9a398d6368992).errors.NETWORK_ERROR && error.event === "noNetwork") return undefined;
                throw error;
            });
        });
    }
    // @TODO: Remove this and just create a singleton formatter
    static getFormatter() {
        if ($fa2219aa02c3e62e$var$defaultFormatter == null) $fa2219aa02c3e62e$var$defaultFormatter = new (0, $23494291de5f329b$export$a06636add2a09fd8)();
        return $fa2219aa02c3e62e$var$defaultFormatter;
    }
    // @TODO: Remove this and just use getNetwork
    static getNetwork(network) {
        return (0, $e6278266fc0cd090$export$7de4970ebfd8206d)(network == null ? "homestead" : network);
    }
    ccipReadFetch(tx, calldata, urls) {
        return $fa2219aa02c3e62e$var$__awaiter(this, void 0, void 0, function*() {
            if (this.disableCcipRead || urls.length === 0) return null;
            const sender = tx.to.toLowerCase();
            const data = calldata.toLowerCase();
            const errorMessages = [];
            for(let i = 0; i < urls.length; i++){
                const url = urls[i];
                // URL expansion
                const href = url.replace("{sender}", sender).replace("{data}", data);
                // If no {data} is present, use POST; otherwise GET
                const json = url.indexOf("{data}") >= 0 ? null : JSON.stringify({
                    data: data,
                    sender: sender
                });
                const result = yield (0, $1f5b367caa9efc4a$exports.fetchJson)({
                    url: href,
                    errorPassThrough: true
                }, json, (value, response)=>{
                    value.status = response.statusCode;
                    return value;
                });
                if (result.data) return result.data;
                const errorMessage = result.message || "unknown error";
                // 4xx indicates the result is not present; stop
                if (result.status >= 400 && result.status < 500) return $fa2219aa02c3e62e$var$logger.throwError(`response not found during CCIP fetch: ${errorMessage}`, (0, $5f596c9584f643ae$export$efa9a398d6368992).errors.SERVER_ERROR, {
                    url: url,
                    errorMessage: errorMessage
                });
                // 5xx indicates server issue; try the next url
                errorMessages.push(errorMessage);
            }
            return $fa2219aa02c3e62e$var$logger.throwError(`error encountered during CCIP fetch: ${errorMessages.map((m)=>JSON.stringify(m)).join(", ")}`, (0, $5f596c9584f643ae$export$efa9a398d6368992).errors.SERVER_ERROR, {
                urls: urls,
                errorMessages: errorMessages
            });
        });
    }
    // Fetches the blockNumber, but will reuse any result that is less
    // than maxAge old or has been requested since the last request
    _getInternalBlockNumber(maxAge) {
        return $fa2219aa02c3e62e$var$__awaiter(this, void 0, void 0, function*() {
            yield this._ready();
            // Allowing stale data up to maxAge old
            if (maxAge > 0) // While there are pending internal block requests...
            while(this._internalBlockNumber){
                // ..."remember" which fetch we started with
                const internalBlockNumber = this._internalBlockNumber;
                try {
                    // Check the result is not too stale
                    const result = yield internalBlockNumber;
                    if ($fa2219aa02c3e62e$var$getTime() - result.respTime <= maxAge) return result.blockNumber;
                    break;
                } catch (error) {
                    // The fetch rejected; if we are the first to get the
                    // rejection, drop through so we replace it with a new
                    // fetch; all others blocked will then get that fetch
                    // which won't match the one they "remembered" and loop
                    if (this._internalBlockNumber === internalBlockNumber) break;
                }
            }
            const reqTime = $fa2219aa02c3e62e$var$getTime();
            const checkInternalBlockNumber = (0, $d2d9b472f7878d5e$exports.resolveProperties)({
                blockNumber: this.perform("getBlockNumber", {}),
                networkError: this.getNetwork().then((network)=>null, (error)=>error)
            }).then(({ blockNumber: blockNumber, networkError: networkError })=>{
                if (networkError) {
                    // Unremember this bad internal block number
                    if (this._internalBlockNumber === checkInternalBlockNumber) this._internalBlockNumber = null;
                    throw networkError;
                }
                const respTime = $fa2219aa02c3e62e$var$getTime();
                blockNumber = (0, $a87aa97415e1b917$export$d97aa349ed20696).from(blockNumber).toNumber();
                if (blockNumber < this._maxInternalBlockNumber) blockNumber = this._maxInternalBlockNumber;
                this._maxInternalBlockNumber = blockNumber;
                this._setFastBlockNumber(blockNumber); // @TODO: Still need this?
                return {
                    blockNumber: blockNumber,
                    reqTime: reqTime,
                    respTime: respTime
                };
            });
            this._internalBlockNumber = checkInternalBlockNumber;
            // Swallow unhandled exceptions; if needed they are handled else where
            checkInternalBlockNumber.catch((error)=>{
                // Don't null the dead (rejected) fetch, if it has already been updated
                if (this._internalBlockNumber === checkInternalBlockNumber) this._internalBlockNumber = null;
            });
            return (yield checkInternalBlockNumber).blockNumber;
        });
    }
    poll() {
        return $fa2219aa02c3e62e$var$__awaiter(this, void 0, void 0, function*() {
            const pollId = $fa2219aa02c3e62e$var$nextPollId++;
            // Track all running promises, so we can trigger a post-poll once they are complete
            const runners = [];
            let blockNumber = null;
            try {
                blockNumber = yield this._getInternalBlockNumber(100 + this.pollingInterval / 2);
            } catch (error) {
                this.emit("error", error);
                return;
            }
            this._setFastBlockNumber(blockNumber);
            // Emit a poll event after we have the latest (fast) block number
            this.emit("poll", pollId, blockNumber);
            // If the block has not changed, meh.
            if (blockNumber === this._lastBlockNumber) {
                this.emit("didPoll", pollId);
                return;
            }
            // First polling cycle, trigger a "block" events
            if (this._emitted.block === -2) this._emitted.block = blockNumber - 1;
            if (Math.abs(this._emitted.block - blockNumber) > 1000) {
                $fa2219aa02c3e62e$var$logger.warn(`network block skew detected; skipping block events (emitted=${this._emitted.block} blockNumber${blockNumber})`);
                this.emit("error", $fa2219aa02c3e62e$var$logger.makeError("network block skew detected", (0, $5f596c9584f643ae$export$efa9a398d6368992).errors.NETWORK_ERROR, {
                    blockNumber: blockNumber,
                    event: "blockSkew",
                    previousBlockNumber: this._emitted.block
                }));
                this.emit("block", blockNumber);
            } else // Notify all listener for each block that has passed
            for(let i = this._emitted.block + 1; i <= blockNumber; i++)this.emit("block", i);
            // The emitted block was updated, check for obsolete events
            if (this._emitted.block !== blockNumber) {
                this._emitted.block = blockNumber;
                Object.keys(this._emitted).forEach((key)=>{
                    // The block event does not expire
                    if (key === "block") return;
                    // The block we were at when we emitted this event
                    const eventBlockNumber = this._emitted[key];
                    // We cannot garbage collect pending transactions or blocks here
                    // They should be garbage collected by the Provider when setting
                    // "pending" events
                    if (eventBlockNumber === "pending") return;
                    // Evict any transaction hashes or block hashes over 12 blocks
                    // old, since they should not return null anyways
                    if (blockNumber - eventBlockNumber > 12) delete this._emitted[key];
                });
            }
            // First polling cycle
            if (this._lastBlockNumber === -2) this._lastBlockNumber = blockNumber - 1;
            // Find all transaction hashes we are waiting on
            this._events.forEach((event)=>{
                switch(event.type){
                    case "tx":
                        {
                            const hash = event.hash;
                            let runner = this.getTransactionReceipt(hash).then((receipt)=>{
                                if (!receipt || receipt.blockNumber == null) return null;
                                this._emitted["t:" + hash] = receipt.blockNumber;
                                this.emit(hash, receipt);
                                return null;
                            }).catch((error)=>{
                                this.emit("error", error);
                            });
                            runners.push(runner);
                            break;
                        }
                    case "filter":
                        // We only allow a single getLogs to be in-flight at a time
                        if (!event._inflight) {
                            event._inflight = true;
                            // This is the first filter for this event, so we want to
                            // restrict events to events that happened no earlier than now
                            if (event._lastBlockNumber === -2) event._lastBlockNumber = blockNumber - 1;
                            // Filter from the last *known* event; due to load-balancing
                            // and some nodes returning updated block numbers before
                            // indexing events, a logs result with 0 entries cannot be
                            // trusted and we must retry a range which includes it again
                            const filter = event.filter;
                            filter.fromBlock = event._lastBlockNumber + 1;
                            filter.toBlock = blockNumber;
                            // Prevent fitler ranges from growing too wild, since it is quite
                            // likely there just haven't been any events to move the lastBlockNumber.
                            const minFromBlock = filter.toBlock - this._maxFilterBlockRange;
                            if (minFromBlock > filter.fromBlock) filter.fromBlock = minFromBlock;
                            if (filter.fromBlock < 0) filter.fromBlock = 0;
                            const runner = this.getLogs(filter).then((logs)=>{
                                // Allow the next getLogs
                                event._inflight = false;
                                if (logs.length === 0) return;
                                logs.forEach((log)=>{
                                    // Only when we get an event for a given block number
                                    // can we trust the events are indexed
                                    if (log.blockNumber > event._lastBlockNumber) event._lastBlockNumber = log.blockNumber;
                                    // Make sure we stall requests to fetch blocks and txs
                                    this._emitted["b:" + log.blockHash] = log.blockNumber;
                                    this._emitted["t:" + log.transactionHash] = log.blockNumber;
                                    this.emit(filter, log);
                                });
                            }).catch((error)=>{
                                this.emit("error", error);
                                // Allow another getLogs (the range was not updated)
                                event._inflight = false;
                            });
                            runners.push(runner);
                        }
                        break;
                }
            });
            this._lastBlockNumber = blockNumber;
            // Once all events for this loop have been processed, emit "didPoll"
            Promise.all(runners).then(()=>{
                this.emit("didPoll", pollId);
            }).catch((error)=>{
                this.emit("error", error);
            });
            return;
        });
    }
    // Deprecated; do not use this
    resetEventsBlock(blockNumber) {
        this._lastBlockNumber = blockNumber - 1;
        if (this.polling) this.poll();
    }
    get network() {
        return this._network;
    }
    // This method should query the network if the underlying network
    // can change, such as when connected to a JSON-RPC backend
    detectNetwork() {
        return $fa2219aa02c3e62e$var$__awaiter(this, void 0, void 0, function*() {
            return $fa2219aa02c3e62e$var$logger.throwError("provider does not support network detection", (0, $5f596c9584f643ae$export$efa9a398d6368992).errors.UNSUPPORTED_OPERATION, {
                operation: "provider.detectNetwork"
            });
        });
    }
    getNetwork() {
        return $fa2219aa02c3e62e$var$__awaiter(this, void 0, void 0, function*() {
            const network = yield this._ready();
            // Make sure we are still connected to the same network; this is
            // only an external call for backends which can have the underlying
            // network change spontaneously
            const currentNetwork = yield this.detectNetwork();
            if (network.chainId !== currentNetwork.chainId) {
                // We are allowing network changes, things can get complex fast;
                // make sure you know what you are doing if you use "any"
                if (this.anyNetwork) {
                    this._network = currentNetwork;
                    // Reset all internal block number guards and caches
                    this._lastBlockNumber = -2;
                    this._fastBlockNumber = null;
                    this._fastBlockNumberPromise = null;
                    this._fastQueryDate = 0;
                    this._emitted.block = -2;
                    this._maxInternalBlockNumber = -1024;
                    this._internalBlockNumber = null;
                    // The "network" event MUST happen before this method resolves
                    // so any events have a chance to unregister, so we stall an
                    // additional event loop before returning from /this/ call
                    this.emit("network", currentNetwork, network);
                    yield $fa2219aa02c3e62e$var$stall(0);
                    return this._network;
                }
                const error = $fa2219aa02c3e62e$var$logger.makeError("underlying network changed", (0, $5f596c9584f643ae$export$efa9a398d6368992).errors.NETWORK_ERROR, {
                    event: "changed",
                    network: network,
                    detectedNetwork: currentNetwork
                });
                this.emit("error", error);
                throw error;
            }
            return network;
        });
    }
    get blockNumber() {
        this._getInternalBlockNumber(100 + this.pollingInterval / 2).then((blockNumber)=>{
            this._setFastBlockNumber(blockNumber);
        }, (error)=>{});
        return this._fastBlockNumber != null ? this._fastBlockNumber : -1;
    }
    get polling() {
        return this._poller != null;
    }
    set polling(value) {
        if (value && !this._poller) {
            this._poller = setInterval(()=>{
                this.poll();
            }, this.pollingInterval);
            if (!this._bootstrapPoll) this._bootstrapPoll = setTimeout(()=>{
                this.poll();
                // We block additional polls until the polling interval
                // is done, to prevent overwhelming the poll function
                this._bootstrapPoll = setTimeout(()=>{
                    // If polling was disabled, something may require a poke
                    // since starting the bootstrap poll and it was disabled
                    if (!this._poller) this.poll();
                    // Clear out the bootstrap so we can do another
                    this._bootstrapPoll = null;
                }, this.pollingInterval);
            }, 0);
        } else if (!value && this._poller) {
            clearInterval(this._poller);
            this._poller = null;
        }
    }
    get pollingInterval() {
        return this._pollingInterval;
    }
    set pollingInterval(value) {
        if (typeof value !== "number" || value <= 0 || parseInt(String(value)) != value) throw new Error("invalid polling interval");
        this._pollingInterval = value;
        if (this._poller) {
            clearInterval(this._poller);
            this._poller = setInterval(()=>{
                this.poll();
            }, this._pollingInterval);
        }
    }
    _getFastBlockNumber() {
        const now = $fa2219aa02c3e62e$var$getTime();
        // Stale block number, request a newer value
        if (now - this._fastQueryDate > 2 * this._pollingInterval) {
            this._fastQueryDate = now;
            this._fastBlockNumberPromise = this.getBlockNumber().then((blockNumber)=>{
                if (this._fastBlockNumber == null || blockNumber > this._fastBlockNumber) this._fastBlockNumber = blockNumber;
                return this._fastBlockNumber;
            });
        }
        return this._fastBlockNumberPromise;
    }
    _setFastBlockNumber(blockNumber) {
        // Older block, maybe a stale request
        if (this._fastBlockNumber != null && blockNumber < this._fastBlockNumber) return;
        // Update the time we updated the blocknumber
        this._fastQueryDate = $fa2219aa02c3e62e$var$getTime();
        // Newer block number, use  it
        if (this._fastBlockNumber == null || blockNumber > this._fastBlockNumber) {
            this._fastBlockNumber = blockNumber;
            this._fastBlockNumberPromise = Promise.resolve(blockNumber);
        }
    }
    waitForTransaction(transactionHash, confirmations, timeout) {
        return $fa2219aa02c3e62e$var$__awaiter(this, void 0, void 0, function*() {
            return this._waitForTransaction(transactionHash, confirmations == null ? 1 : confirmations, timeout || 0, null);
        });
    }
    _waitForTransaction(transactionHash, confirmations, timeout, replaceable) {
        return $fa2219aa02c3e62e$var$__awaiter(this, void 0, void 0, function*() {
            const receipt = yield this.getTransactionReceipt(transactionHash);
            // Receipt is already good
            if ((receipt ? receipt.confirmations : 0) >= confirmations) return receipt;
            // Poll until the receipt is good...
            return new Promise((resolve, reject)=>{
                const cancelFuncs = [];
                let done = false;
                const alreadyDone = function() {
                    if (done) return true;
                    done = true;
                    cancelFuncs.forEach((func)=>{
                        func();
                    });
                    return false;
                };
                const minedHandler = (receipt)=>{
                    if (receipt.confirmations < confirmations) return;
                    if (alreadyDone()) return;
                    resolve(receipt);
                };
                this.on(transactionHash, minedHandler);
                cancelFuncs.push(()=>{
                    this.removeListener(transactionHash, minedHandler);
                });
                if (replaceable) {
                    let lastBlockNumber = replaceable.startBlock;
                    let scannedBlock = null;
                    const replaceHandler = (blockNumber)=>$fa2219aa02c3e62e$var$__awaiter(this, void 0, void 0, function*() {
                            if (done) return;
                            // Wait 1 second; this is only used in the case of a fault, so
                            // we will trade off a little bit of latency for more consistent
                            // results and fewer JSON-RPC calls
                            yield $fa2219aa02c3e62e$var$stall(1000);
                            this.getTransactionCount(replaceable.from).then((nonce)=>$fa2219aa02c3e62e$var$__awaiter(this, void 0, void 0, function*() {
                                    if (done) return;
                                    if (nonce <= replaceable.nonce) lastBlockNumber = blockNumber;
                                    else {
                                        // First check if the transaction was mined
                                        {
                                            const mined = yield this.getTransaction(transactionHash);
                                            if (mined && mined.blockNumber != null) return;
                                        }
                                        // First time scanning. We start a little earlier for some
                                        // wiggle room here to handle the eventually consistent nature
                                        // of blockchain (e.g. the getTransactionCount was for a
                                        // different block)
                                        if (scannedBlock == null) {
                                            scannedBlock = lastBlockNumber - 3;
                                            if (scannedBlock < replaceable.startBlock) scannedBlock = replaceable.startBlock;
                                        }
                                        while(scannedBlock <= blockNumber){
                                            if (done) return;
                                            const block = yield this.getBlockWithTransactions(scannedBlock);
                                            for(let ti = 0; ti < block.transactions.length; ti++){
                                                const tx = block.transactions[ti];
                                                // Successfully mined!
                                                if (tx.hash === transactionHash) return;
                                                // Matches our transaction from and nonce; its a replacement
                                                if (tx.from === replaceable.from && tx.nonce === replaceable.nonce) {
                                                    if (done) return;
                                                    // Get the receipt of the replacement
                                                    const receipt = yield this.waitForTransaction(tx.hash, confirmations);
                                                    // Already resolved or rejected (prolly a timeout)
                                                    if (alreadyDone()) return;
                                                    // The reason we were replaced
                                                    let reason = "replaced";
                                                    if (tx.data === replaceable.data && tx.to === replaceable.to && tx.value.eq(replaceable.value)) reason = "repriced";
                                                    else if (tx.data === "0x" && tx.from === tx.to && tx.value.isZero()) reason = "cancelled";
                                                    // Explain why we were replaced
                                                    reject($fa2219aa02c3e62e$var$logger.makeError("transaction was replaced", (0, $5f596c9584f643ae$export$efa9a398d6368992).errors.TRANSACTION_REPLACED, {
                                                        cancelled: reason === "replaced" || reason === "cancelled",
                                                        reason: reason,
                                                        replacement: this._wrapTransaction(tx),
                                                        hash: transactionHash,
                                                        receipt: receipt
                                                    }));
                                                    return;
                                                }
                                            }
                                            scannedBlock++;
                                        }
                                    }
                                    if (done) return;
                                    this.once("block", replaceHandler);
                                }), (error)=>{
                                if (done) return;
                                this.once("block", replaceHandler);
                            });
                        });
                    if (done) return;
                    this.once("block", replaceHandler);
                    cancelFuncs.push(()=>{
                        this.removeListener("block", replaceHandler);
                    });
                }
                if (typeof timeout === "number" && timeout > 0) {
                    const timer = setTimeout(()=>{
                        if (alreadyDone()) return;
                        reject($fa2219aa02c3e62e$var$logger.makeError("timeout exceeded", (0, $5f596c9584f643ae$export$efa9a398d6368992).errors.TIMEOUT, {
                            timeout: timeout
                        }));
                    }, timeout);
                    if (timer.unref) timer.unref();
                    cancelFuncs.push(()=>{
                        clearTimeout(timer);
                    });
                }
            });
        });
    }
    getBlockNumber() {
        return $fa2219aa02c3e62e$var$__awaiter(this, void 0, void 0, function*() {
            return this._getInternalBlockNumber(0);
        });
    }
    getGasPrice() {
        return $fa2219aa02c3e62e$var$__awaiter(this, void 0, void 0, function*() {
            yield this.getNetwork();
            const result = yield this.perform("getGasPrice", {});
            try {
                return (0, $a87aa97415e1b917$export$d97aa349ed20696).from(result);
            } catch (error) {
                return $fa2219aa02c3e62e$var$logger.throwError("bad result from backend", (0, $5f596c9584f643ae$export$efa9a398d6368992).errors.SERVER_ERROR, {
                    method: "getGasPrice",
                    result: result,
                    error: error
                });
            }
        });
    }
    getBalance(addressOrName, blockTag) {
        return $fa2219aa02c3e62e$var$__awaiter(this, void 0, void 0, function*() {
            yield this.getNetwork();
            const params = yield (0, $d2d9b472f7878d5e$exports.resolveProperties)({
                address: this._getAddress(addressOrName),
                blockTag: this._getBlockTag(blockTag)
            });
            const result = yield this.perform("getBalance", params);
            try {
                return (0, $a87aa97415e1b917$export$d97aa349ed20696).from(result);
            } catch (error) {
                return $fa2219aa02c3e62e$var$logger.throwError("bad result from backend", (0, $5f596c9584f643ae$export$efa9a398d6368992).errors.SERVER_ERROR, {
                    method: "getBalance",
                    params: params,
                    result: result,
                    error: error
                });
            }
        });
    }
    getTransactionCount(addressOrName, blockTag) {
        return $fa2219aa02c3e62e$var$__awaiter(this, void 0, void 0, function*() {
            yield this.getNetwork();
            const params = yield (0, $d2d9b472f7878d5e$exports.resolveProperties)({
                address: this._getAddress(addressOrName),
                blockTag: this._getBlockTag(blockTag)
            });
            const result = yield this.perform("getTransactionCount", params);
            try {
                return (0, $a87aa97415e1b917$export$d97aa349ed20696).from(result).toNumber();
            } catch (error) {
                return $fa2219aa02c3e62e$var$logger.throwError("bad result from backend", (0, $5f596c9584f643ae$export$efa9a398d6368992).errors.SERVER_ERROR, {
                    method: "getTransactionCount",
                    params: params,
                    result: result,
                    error: error
                });
            }
        });
    }
    getCode(addressOrName, blockTag) {
        return $fa2219aa02c3e62e$var$__awaiter(this, void 0, void 0, function*() {
            yield this.getNetwork();
            const params = yield (0, $d2d9b472f7878d5e$exports.resolveProperties)({
                address: this._getAddress(addressOrName),
                blockTag: this._getBlockTag(blockTag)
            });
            const result = yield this.perform("getCode", params);
            try {
                return (0, $06d75ae17ce69367$export$2b0d6b5fbe698c70)(result);
            } catch (error) {
                return $fa2219aa02c3e62e$var$logger.throwError("bad result from backend", (0, $5f596c9584f643ae$export$efa9a398d6368992).errors.SERVER_ERROR, {
                    method: "getCode",
                    params: params,
                    result: result,
                    error: error
                });
            }
        });
    }
    getStorageAt(addressOrName, position, blockTag) {
        return $fa2219aa02c3e62e$var$__awaiter(this, void 0, void 0, function*() {
            yield this.getNetwork();
            const params = yield (0, $d2d9b472f7878d5e$exports.resolveProperties)({
                address: this._getAddress(addressOrName),
                blockTag: this._getBlockTag(blockTag),
                position: Promise.resolve(position).then((p)=>(0, $06d75ae17ce69367$export$6916af760a341dd3)(p))
            });
            const result = yield this.perform("getStorageAt", params);
            try {
                return (0, $06d75ae17ce69367$export$2b0d6b5fbe698c70)(result);
            } catch (error) {
                return $fa2219aa02c3e62e$var$logger.throwError("bad result from backend", (0, $5f596c9584f643ae$export$efa9a398d6368992).errors.SERVER_ERROR, {
                    method: "getStorageAt",
                    params: params,
                    result: result,
                    error: error
                });
            }
        });
    }
    // This should be called by any subclass wrapping a TransactionResponse
    _wrapTransaction(tx, hash, startBlock) {
        if (hash != null && (0, $06d75ae17ce69367$export$13882f896d3c0683)(hash) !== 32) throw new Error("invalid response - sendTransaction");
        const result = tx;
        // Check the hash we expect is the same as the hash the server reported
        if (hash != null && tx.hash !== hash) $fa2219aa02c3e62e$var$logger.throwError("Transaction hash mismatch from Provider.sendTransaction.", (0, $5f596c9584f643ae$export$efa9a398d6368992).errors.UNKNOWN_ERROR, {
            expectedHash: tx.hash,
            returnedHash: hash
        });
        result.wait = (confirms, timeout)=>$fa2219aa02c3e62e$var$__awaiter(this, void 0, void 0, function*() {
                if (confirms == null) confirms = 1;
                if (timeout == null) timeout = 0;
                // Get the details to detect replacement
                let replacement = undefined;
                if (confirms !== 0 && startBlock != null) replacement = {
                    data: tx.data,
                    from: tx.from,
                    nonce: tx.nonce,
                    to: tx.to,
                    value: tx.value,
                    startBlock: startBlock
                };
                const receipt = yield this._waitForTransaction(tx.hash, confirms, timeout, replacement);
                if (receipt == null && confirms === 0) return null;
                // No longer pending, allow the polling loop to garbage collect this
                this._emitted["t:" + tx.hash] = receipt.blockNumber;
                if (receipt.status === 0) $fa2219aa02c3e62e$var$logger.throwError("transaction failed", (0, $5f596c9584f643ae$export$efa9a398d6368992).errors.CALL_EXCEPTION, {
                    transactionHash: tx.hash,
                    transaction: tx,
                    receipt: receipt
                });
                return receipt;
            });
        return result;
    }
    sendTransaction(signedTransaction) {
        return $fa2219aa02c3e62e$var$__awaiter(this, void 0, void 0, function*() {
            yield this.getNetwork();
            const hexTx = yield Promise.resolve(signedTransaction).then((t)=>(0, $06d75ae17ce69367$export$2b0d6b5fbe698c70)(t));
            const tx = this.formatter.transaction(signedTransaction);
            if (tx.confirmations == null) tx.confirmations = 0;
            const blockNumber = yield this._getInternalBlockNumber(100 + 2 * this.pollingInterval);
            try {
                const hash = yield this.perform("sendTransaction", {
                    signedTransaction: hexTx
                });
                return this._wrapTransaction(tx, hash, blockNumber);
            } catch (error) {
                error.transaction = tx;
                error.transactionHash = tx.hash;
                throw error;
            }
        });
    }
    _getTransactionRequest(transaction) {
        return $fa2219aa02c3e62e$var$__awaiter(this, void 0, void 0, function*() {
            const values = yield transaction;
            const tx = {};
            [
                "from",
                "to"
            ].forEach((key)=>{
                if (values[key] == null) return;
                tx[key] = Promise.resolve(values[key]).then((v)=>v ? this._getAddress(v) : null);
            });
            [
                "gasLimit",
                "gasPrice",
                "maxFeePerGas",
                "maxPriorityFeePerGas",
                "value"
            ].forEach((key)=>{
                if (values[key] == null) return;
                tx[key] = Promise.resolve(values[key]).then((v)=>v ? (0, $a87aa97415e1b917$export$d97aa349ed20696).from(v) : null);
            });
            [
                "type"
            ].forEach((key)=>{
                if (values[key] == null) return;
                tx[key] = Promise.resolve(values[key]).then((v)=>v != null ? v : null);
            });
            if (values.accessList) tx.accessList = this.formatter.accessList(values.accessList);
            [
                "data"
            ].forEach((key)=>{
                if (values[key] == null) return;
                tx[key] = Promise.resolve(values[key]).then((v)=>v ? (0, $06d75ae17ce69367$export$2b0d6b5fbe698c70)(v) : null);
            });
            return this.formatter.transactionRequest((yield (0, $d2d9b472f7878d5e$exports.resolveProperties)(tx)));
        });
    }
    _getFilter(filter) {
        return $fa2219aa02c3e62e$var$__awaiter(this, void 0, void 0, function*() {
            filter = yield filter;
            const result = {};
            if (filter.address != null) result.address = this._getAddress(filter.address);
            [
                "blockHash",
                "topics"
            ].forEach((key)=>{
                if (filter[key] == null) return;
                result[key] = filter[key];
            });
            [
                "fromBlock",
                "toBlock"
            ].forEach((key)=>{
                if (filter[key] == null) return;
                result[key] = this._getBlockTag(filter[key]);
            });
            return this.formatter.filter((yield (0, $d2d9b472f7878d5e$exports.resolveProperties)(result)));
        });
    }
    _call(transaction, blockTag, attempt) {
        return $fa2219aa02c3e62e$var$__awaiter(this, void 0, void 0, function*() {
            if (attempt >= $fa2219aa02c3e62e$var$MAX_CCIP_REDIRECTS) $fa2219aa02c3e62e$var$logger.throwError("CCIP read exceeded maximum redirections", (0, $5f596c9584f643ae$export$efa9a398d6368992).errors.SERVER_ERROR, {
                redirects: attempt,
                transaction: transaction
            });
            const txSender = transaction.to;
            const result = yield this.perform("call", {
                transaction: transaction,
                blockTag: blockTag
            });
            // CCIP Read request via OffchainLookup(address,string[],bytes,bytes4,bytes)
            if (attempt >= 0 && blockTag === "latest" && txSender != null && result.substring(0, 10) === "0x556f1830" && (0, $06d75ae17ce69367$export$13882f896d3c0683)(result) % 32 === 4) try {
                const data = (0, $06d75ae17ce69367$export$15da666eba198c18)(result, 4);
                // Check the sender of the OffchainLookup matches the transaction
                const sender = (0, $06d75ae17ce69367$export$15da666eba198c18)(data, 0, 32);
                if (!(0, $a87aa97415e1b917$export$d97aa349ed20696).from(sender).eq(txSender)) $fa2219aa02c3e62e$var$logger.throwError("CCIP Read sender did not match", (0, $5f596c9584f643ae$export$efa9a398d6368992).errors.CALL_EXCEPTION, {
                    name: "OffchainLookup",
                    signature: "OffchainLookup(address,string[],bytes,bytes4,bytes)",
                    transaction: transaction,
                    data: result
                });
                // Read the URLs from the response
                const urls = [];
                const urlsOffset = (0, $a87aa97415e1b917$export$d97aa349ed20696).from((0, $06d75ae17ce69367$export$15da666eba198c18)(data, 32, 64)).toNumber();
                const urlsLength = (0, $a87aa97415e1b917$export$d97aa349ed20696).from((0, $06d75ae17ce69367$export$15da666eba198c18)(data, urlsOffset, urlsOffset + 32)).toNumber();
                const urlsData = (0, $06d75ae17ce69367$export$15da666eba198c18)(data, urlsOffset + 32);
                for(let u = 0; u < urlsLength; u++){
                    const url = $fa2219aa02c3e62e$var$_parseString(urlsData, u * 32);
                    if (url == null) $fa2219aa02c3e62e$var$logger.throwError("CCIP Read contained corrupt URL string", (0, $5f596c9584f643ae$export$efa9a398d6368992).errors.CALL_EXCEPTION, {
                        name: "OffchainLookup",
                        signature: "OffchainLookup(address,string[],bytes,bytes4,bytes)",
                        transaction: transaction,
                        data: result
                    });
                    urls.push(url);
                }
                // Get the CCIP calldata to forward
                const calldata = $fa2219aa02c3e62e$var$_parseBytes(data, 64);
                // Get the callbackSelector (bytes4)
                if (!(0, $a87aa97415e1b917$export$d97aa349ed20696).from((0, $06d75ae17ce69367$export$15da666eba198c18)(data, 100, 128)).isZero()) $fa2219aa02c3e62e$var$logger.throwError("CCIP Read callback selector included junk", (0, $5f596c9584f643ae$export$efa9a398d6368992).errors.CALL_EXCEPTION, {
                    name: "OffchainLookup",
                    signature: "OffchainLookup(address,string[],bytes,bytes4,bytes)",
                    transaction: transaction,
                    data: result
                });
                const callbackSelector = (0, $06d75ae17ce69367$export$15da666eba198c18)(data, 96, 100);
                // Get the extra data to send back to the contract as context
                const extraData = $fa2219aa02c3e62e$var$_parseBytes(data, 128);
                const ccipResult = yield this.ccipReadFetch(transaction, calldata, urls);
                if (ccipResult == null) $fa2219aa02c3e62e$var$logger.throwError("CCIP Read disabled or provided no URLs", (0, $5f596c9584f643ae$export$efa9a398d6368992).errors.CALL_EXCEPTION, {
                    name: "OffchainLookup",
                    signature: "OffchainLookup(address,string[],bytes,bytes4,bytes)",
                    transaction: transaction,
                    data: result
                });
                const tx = {
                    to: txSender,
                    data: (0, $06d75ae17ce69367$export$6d4b99629b38754a)([
                        callbackSelector,
                        $fa2219aa02c3e62e$var$encodeBytes([
                            ccipResult,
                            extraData
                        ])
                    ])
                };
                return this._call(tx, blockTag, attempt + 1);
            } catch (error) {
                if (error.code === (0, $5f596c9584f643ae$export$efa9a398d6368992).errors.SERVER_ERROR) throw error;
            }
            try {
                return (0, $06d75ae17ce69367$export$2b0d6b5fbe698c70)(result);
            } catch (error) {
                return $fa2219aa02c3e62e$var$logger.throwError("bad result from backend", (0, $5f596c9584f643ae$export$efa9a398d6368992).errors.SERVER_ERROR, {
                    method: "call",
                    params: {
                        transaction: transaction,
                        blockTag: blockTag
                    },
                    result: result,
                    error: error
                });
            }
        });
    }
    call(transaction, blockTag) {
        return $fa2219aa02c3e62e$var$__awaiter(this, void 0, void 0, function*() {
            yield this.getNetwork();
            const resolved = yield (0, $d2d9b472f7878d5e$exports.resolveProperties)({
                transaction: this._getTransactionRequest(transaction),
                blockTag: this._getBlockTag(blockTag),
                ccipReadEnabled: Promise.resolve(transaction.ccipReadEnabled)
            });
            return this._call(resolved.transaction, resolved.blockTag, resolved.ccipReadEnabled ? 0 : -1);
        });
    }
    estimateGas(transaction) {
        return $fa2219aa02c3e62e$var$__awaiter(this, void 0, void 0, function*() {
            yield this.getNetwork();
            const params = yield (0, $d2d9b472f7878d5e$exports.resolveProperties)({
                transaction: this._getTransactionRequest(transaction)
            });
            const result = yield this.perform("estimateGas", params);
            try {
                return (0, $a87aa97415e1b917$export$d97aa349ed20696).from(result);
            } catch (error) {
                return $fa2219aa02c3e62e$var$logger.throwError("bad result from backend", (0, $5f596c9584f643ae$export$efa9a398d6368992).errors.SERVER_ERROR, {
                    method: "estimateGas",
                    params: params,
                    result: result,
                    error: error
                });
            }
        });
    }
    _getAddress(addressOrName) {
        return $fa2219aa02c3e62e$var$__awaiter(this, void 0, void 0, function*() {
            addressOrName = yield addressOrName;
            if (typeof addressOrName !== "string") $fa2219aa02c3e62e$var$logger.throwArgumentError("invalid address or ENS name", "name", addressOrName);
            const address = yield this.resolveName(addressOrName);
            if (address == null) $fa2219aa02c3e62e$var$logger.throwError("ENS name not configured", (0, $5f596c9584f643ae$export$efa9a398d6368992).errors.UNSUPPORTED_OPERATION, {
                operation: `resolveName(${JSON.stringify(addressOrName)})`
            });
            return address;
        });
    }
    _getBlock(blockHashOrBlockTag, includeTransactions) {
        return $fa2219aa02c3e62e$var$__awaiter(this, void 0, void 0, function*() {
            yield this.getNetwork();
            blockHashOrBlockTag = yield blockHashOrBlockTag;
            // If blockTag is a number (not "latest", etc), this is the block number
            let blockNumber = -128;
            const params = {
                includeTransactions: !!includeTransactions
            };
            if ((0, $06d75ae17ce69367$export$b02a40aff8e4ad18)(blockHashOrBlockTag, 32)) params.blockHash = blockHashOrBlockTag;
            else try {
                params.blockTag = yield this._getBlockTag(blockHashOrBlockTag);
                if ((0, $06d75ae17ce69367$export$b02a40aff8e4ad18)(params.blockTag)) blockNumber = parseInt(params.blockTag.substring(2), 16);
            } catch (error) {
                $fa2219aa02c3e62e$var$logger.throwArgumentError("invalid block hash or block tag", "blockHashOrBlockTag", blockHashOrBlockTag);
            }
            return (0, $1f5b367caa9efc4a$exports.poll)(()=>$fa2219aa02c3e62e$var$__awaiter(this, void 0, void 0, function*() {
                    const block = yield this.perform("getBlock", params);
                    // Block was not found
                    if (block == null) {
                        // For blockhashes, if we didn't say it existed, that blockhash may
                        // not exist. If we did see it though, perhaps from a log, we know
                        // it exists, and this node is just not caught up yet.
                        if (params.blockHash != null) {
                            if (this._emitted["b:" + params.blockHash] == null) return null;
                        }
                        // For block tags, if we are asking for a future block, we return null
                        if (params.blockTag != null) {
                            if (blockNumber > this._emitted.block) return null;
                        }
                        // Retry on the next block
                        return undefined;
                    }
                    // Add transactions
                    if (includeTransactions) {
                        let blockNumber = null;
                        for(let i = 0; i < block.transactions.length; i++){
                            const tx = block.transactions[i];
                            if (tx.blockNumber == null) tx.confirmations = 0;
                            else if (tx.confirmations == null) {
                                if (blockNumber == null) blockNumber = yield this._getInternalBlockNumber(100 + 2 * this.pollingInterval);
                                // Add the confirmations using the fast block number (pessimistic)
                                let confirmations = blockNumber - tx.blockNumber + 1;
                                if (confirmations <= 0) confirmations = 1;
                                tx.confirmations = confirmations;
                            }
                        }
                        const blockWithTxs = this.formatter.blockWithTransactions(block);
                        blockWithTxs.transactions = blockWithTxs.transactions.map((tx)=>this._wrapTransaction(tx));
                        return blockWithTxs;
                    }
                    return this.formatter.block(block);
                }), {
                oncePoll: this
            });
        });
    }
    getBlock(blockHashOrBlockTag) {
        return this._getBlock(blockHashOrBlockTag, false);
    }
    getBlockWithTransactions(blockHashOrBlockTag) {
        return this._getBlock(blockHashOrBlockTag, true);
    }
    getTransaction(transactionHash) {
        return $fa2219aa02c3e62e$var$__awaiter(this, void 0, void 0, function*() {
            yield this.getNetwork();
            transactionHash = yield transactionHash;
            const params = {
                transactionHash: this.formatter.hash(transactionHash, true)
            };
            return (0, $1f5b367caa9efc4a$exports.poll)(()=>$fa2219aa02c3e62e$var$__awaiter(this, void 0, void 0, function*() {
                    const result = yield this.perform("getTransaction", params);
                    if (result == null) {
                        if (this._emitted["t:" + transactionHash] == null) return null;
                        return undefined;
                    }
                    const tx = this.formatter.transactionResponse(result);
                    if (tx.blockNumber == null) tx.confirmations = 0;
                    else if (tx.confirmations == null) {
                        const blockNumber = yield this._getInternalBlockNumber(100 + 2 * this.pollingInterval);
                        // Add the confirmations using the fast block number (pessimistic)
                        let confirmations = blockNumber - tx.blockNumber + 1;
                        if (confirmations <= 0) confirmations = 1;
                        tx.confirmations = confirmations;
                    }
                    return this._wrapTransaction(tx);
                }), {
                oncePoll: this
            });
        });
    }
    getTransactionReceipt(transactionHash) {
        return $fa2219aa02c3e62e$var$__awaiter(this, void 0, void 0, function*() {
            yield this.getNetwork();
            transactionHash = yield transactionHash;
            const params = {
                transactionHash: this.formatter.hash(transactionHash, true)
            };
            return (0, $1f5b367caa9efc4a$exports.poll)(()=>$fa2219aa02c3e62e$var$__awaiter(this, void 0, void 0, function*() {
                    const result = yield this.perform("getTransactionReceipt", params);
                    if (result == null) {
                        if (this._emitted["t:" + transactionHash] == null) return null;
                        return undefined;
                    }
                    // "geth-etc" returns receipts before they are ready
                    if (result.blockHash == null) return undefined;
                    const receipt = this.formatter.receipt(result);
                    if (receipt.blockNumber == null) receipt.confirmations = 0;
                    else if (receipt.confirmations == null) {
                        const blockNumber = yield this._getInternalBlockNumber(100 + 2 * this.pollingInterval);
                        // Add the confirmations using the fast block number (pessimistic)
                        let confirmations = blockNumber - receipt.blockNumber + 1;
                        if (confirmations <= 0) confirmations = 1;
                        receipt.confirmations = confirmations;
                    }
                    return receipt;
                }), {
                oncePoll: this
            });
        });
    }
    getLogs(filter) {
        return $fa2219aa02c3e62e$var$__awaiter(this, void 0, void 0, function*() {
            yield this.getNetwork();
            const params = yield (0, $d2d9b472f7878d5e$exports.resolveProperties)({
                filter: this._getFilter(filter)
            });
            const logs = yield this.perform("getLogs", params);
            logs.forEach((log)=>{
                if (log.removed == null) log.removed = false;
            });
            return (0, $23494291de5f329b$export$a06636add2a09fd8).arrayOf(this.formatter.filterLog.bind(this.formatter))(logs);
        });
    }
    getEtherPrice() {
        return $fa2219aa02c3e62e$var$__awaiter(this, void 0, void 0, function*() {
            yield this.getNetwork();
            return this.perform("getEtherPrice", {});
        });
    }
    _getBlockTag(blockTag) {
        return $fa2219aa02c3e62e$var$__awaiter(this, void 0, void 0, function*() {
            blockTag = yield blockTag;
            if (typeof blockTag === "number" && blockTag < 0) {
                if (blockTag % 1) $fa2219aa02c3e62e$var$logger.throwArgumentError("invalid BlockTag", "blockTag", blockTag);
                let blockNumber = yield this._getInternalBlockNumber(100 + 2 * this.pollingInterval);
                blockNumber += blockTag;
                if (blockNumber < 0) blockNumber = 0;
                return this.formatter.blockTag(blockNumber);
            }
            return this.formatter.blockTag(blockTag);
        });
    }
    getResolver(name) {
        return $fa2219aa02c3e62e$var$__awaiter(this, void 0, void 0, function*() {
            let currentName = name;
            while(true){
                if (currentName === "" || currentName === ".") return null;
                // Optimization since the eth node cannot change and does
                // not have a wildcard resolver
                if (name !== "eth" && currentName === "eth") return null;
                // Check the current node for a resolver
                const addr = yield this._getResolver(currentName, "getResolver");
                // Found a resolver!
                if (addr != null) {
                    const resolver = new $fa2219aa02c3e62e$export$8b4c839865b08288(this, addr, name);
                    // Legacy resolver found, using EIP-2544 so it isn't safe to use
                    if (currentName !== name && !(yield resolver.supportsWildcard())) return null;
                    return resolver;
                }
                // Get the parent node
                currentName = currentName.split(".").slice(1).join(".");
            }
        });
    }
    _getResolver(name, operation) {
        return $fa2219aa02c3e62e$var$__awaiter(this, void 0, void 0, function*() {
            if (operation == null) operation = "ENS";
            const network = yield this.getNetwork();
            // No ENS...
            if (!network.ensAddress) $fa2219aa02c3e62e$var$logger.throwError("network does not support ENS", (0, $5f596c9584f643ae$export$efa9a398d6368992).errors.UNSUPPORTED_OPERATION, {
                operation: operation,
                network: network.name
            });
            try {
                // keccak256("resolver(bytes32)")
                const addrData = yield this.call({
                    to: network.ensAddress,
                    data: "0x0178b8bf" + (0, $0e4d091b6edb4637$export$91d651ee363e1209)(name).substring(2)
                });
                return this.formatter.callAddress(addrData);
            } catch (error) {
            // ENS registry cannot throw errors on resolver(bytes32)
            }
            return null;
        });
    }
    resolveName(name) {
        return $fa2219aa02c3e62e$var$__awaiter(this, void 0, void 0, function*() {
            name = yield name;
            // If it is already an address, nothing to resolve
            try {
                return Promise.resolve(this.formatter.address(name));
            } catch (error) {
                // If is is a hexstring, the address is bad (See #694)
                if ((0, $06d75ae17ce69367$export$b02a40aff8e4ad18)(name)) throw error;
            }
            if (typeof name !== "string") $fa2219aa02c3e62e$var$logger.throwArgumentError("invalid ENS name", "name", name);
            // Get the addr from the resolver
            const resolver = yield this.getResolver(name);
            if (!resolver) return null;
            return yield resolver.getAddress();
        });
    }
    lookupAddress(address) {
        return $fa2219aa02c3e62e$var$__awaiter(this, void 0, void 0, function*() {
            address = yield address;
            address = this.formatter.address(address);
            const node = address.substring(2).toLowerCase() + ".addr.reverse";
            const resolverAddr = yield this._getResolver(node, "lookupAddress");
            if (resolverAddr == null) return null;
            // keccak("name(bytes32)")
            const name = $fa2219aa02c3e62e$var$_parseString((yield this.call({
                to: resolverAddr,
                data: "0x691f3431" + (0, $0e4d091b6edb4637$export$91d651ee363e1209)(node).substring(2)
            })), 0);
            const addr = yield this.resolveName(name);
            if (addr != address) return null;
            return name;
        });
    }
    getAvatar(nameOrAddress) {
        return $fa2219aa02c3e62e$var$__awaiter(this, void 0, void 0, function*() {
            let resolver = null;
            if ((0, $06d75ae17ce69367$export$b02a40aff8e4ad18)(nameOrAddress)) {
                // Address; reverse lookup
                const address = this.formatter.address(nameOrAddress);
                const node = address.substring(2).toLowerCase() + ".addr.reverse";
                const resolverAddress = yield this._getResolver(node, "getAvatar");
                if (!resolverAddress) return null;
                // Try resolving the avatar against the addr.reverse resolver
                resolver = new $fa2219aa02c3e62e$export$8b4c839865b08288(this, resolverAddress, node);
                try {
                    const avatar = yield resolver.getAvatar();
                    if (avatar) return avatar.url;
                } catch (error) {
                    if (error.code !== (0, $5f596c9584f643ae$export$efa9a398d6368992).errors.CALL_EXCEPTION) throw error;
                }
                // Try getting the name and performing forward lookup; allowing wildcards
                try {
                    // keccak("name(bytes32)")
                    const name = $fa2219aa02c3e62e$var$_parseString((yield this.call({
                        to: resolverAddress,
                        data: "0x691f3431" + (0, $0e4d091b6edb4637$export$91d651ee363e1209)(node).substring(2)
                    })), 0);
                    resolver = yield this.getResolver(name);
                } catch (error) {
                    if (error.code !== (0, $5f596c9584f643ae$export$efa9a398d6368992).errors.CALL_EXCEPTION) throw error;
                    return null;
                }
            } else {
                // ENS name; forward lookup with wildcard
                resolver = yield this.getResolver(nameOrAddress);
                if (!resolver) return null;
            }
            const avatar = yield resolver.getAvatar();
            if (avatar == null) return null;
            return avatar.url;
        });
    }
    perform(method, params) {
        return $fa2219aa02c3e62e$var$logger.throwError(method + " not implemented", (0, $5f596c9584f643ae$export$efa9a398d6368992).errors.NOT_IMPLEMENTED, {
            operation: method
        });
    }
    _startEvent(event) {
        this.polling = this._events.filter((e)=>e.pollable()).length > 0;
    }
    _stopEvent(event) {
        this.polling = this._events.filter((e)=>e.pollable()).length > 0;
    }
    _addEventListener(eventName, listener, once) {
        const event = new $fa2219aa02c3e62e$export$d61e24a684f9e51($fa2219aa02c3e62e$var$getEventTag(eventName), listener, once);
        this._events.push(event);
        this._startEvent(event);
        return this;
    }
    on(eventName, listener) {
        return this._addEventListener(eventName, listener, false);
    }
    once(eventName, listener) {
        return this._addEventListener(eventName, listener, true);
    }
    emit(eventName, ...args) {
        let result = false;
        let stopped = [];
        let eventTag = $fa2219aa02c3e62e$var$getEventTag(eventName);
        this._events = this._events.filter((event)=>{
            if (event.tag !== eventTag) return true;
            setTimeout(()=>{
                event.listener.apply(this, args);
            }, 0);
            result = true;
            if (event.once) {
                stopped.push(event);
                return false;
            }
            return true;
        });
        stopped.forEach((event)=>{
            this._stopEvent(event);
        });
        return result;
    }
    listenerCount(eventName) {
        if (!eventName) return this._events.length;
        let eventTag = $fa2219aa02c3e62e$var$getEventTag(eventName);
        return this._events.filter((event)=>{
            return event.tag === eventTag;
        }).length;
    }
    listeners(eventName) {
        if (eventName == null) return this._events.map((event)=>event.listener);
        let eventTag = $fa2219aa02c3e62e$var$getEventTag(eventName);
        return this._events.filter((event)=>event.tag === eventTag).map((event)=>event.listener);
    }
    off(eventName, listener) {
        if (listener == null) return this.removeAllListeners(eventName);
        const stopped = [];
        let found = false;
        let eventTag = $fa2219aa02c3e62e$var$getEventTag(eventName);
        this._events = this._events.filter((event)=>{
            if (event.tag !== eventTag || event.listener != listener) return true;
            if (found) return true;
            found = true;
            stopped.push(event);
            return false;
        });
        stopped.forEach((event)=>{
            this._stopEvent(event);
        });
        return this;
    }
    removeAllListeners(eventName) {
        let stopped = [];
        if (eventName == null) {
            stopped = this._events;
            this._events = [];
        } else {
            const eventTag = $fa2219aa02c3e62e$var$getEventTag(eventName);
            this._events = this._events.filter((event)=>{
                if (event.tag !== eventTag) return true;
                stopped.push(event);
                return false;
            });
        }
        stopped.forEach((event)=>{
            this._stopEvent(event);
        });
        return this;
    }
}




var $d1a04efa16266f30$exports = {};

$parcel$export($d1a04efa16266f30$exports, "WebSocketProvider", function () { return $d1a04efa16266f30$export$bfafe629242f30bd; });


var $9609e75996f2bd40$exports = {};

$parcel$export($9609e75996f2bd40$exports, "JsonRpcSigner", function () { return $9609e75996f2bd40$export$5f7b5fca3508545a; });
$parcel$export($9609e75996f2bd40$exports, "JsonRpcProvider", function () { return $9609e75996f2bd40$export$da28308012bf6748; });
var $04afbe51d47fcc12$exports = {};

$parcel$export($04afbe51d47fcc12$exports, "Signer", function () { return $04afbe51d47fcc12$export$fdf54fdde81cc9f0; });
$parcel$export($04afbe51d47fcc12$exports, "VoidSigner", function () { return $04afbe51d47fcc12$export$7dbc56d9b9612bad; });


const $3f2aff55e3d3791c$export$83d89fbfd8236492 = "abstract-signer/5.7.0";


"use strict";
var $04afbe51d47fcc12$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
const $04afbe51d47fcc12$var$logger = new (0, $5f596c9584f643ae$export$efa9a398d6368992)((0, $3f2aff55e3d3791c$export$83d89fbfd8236492));
const $04afbe51d47fcc12$var$allowedTransactionKeys = [
    "accessList",
    "ccipReadEnabled",
    "chainId",
    "customData",
    "data",
    "from",
    "gasLimit",
    "gasPrice",
    "maxFeePerGas",
    "maxPriorityFeePerGas",
    "nonce",
    "to",
    "type",
    "value"
];
const $04afbe51d47fcc12$var$forwardErrors = [
    (0, $5f596c9584f643ae$export$efa9a398d6368992).errors.INSUFFICIENT_FUNDS,
    (0, $5f596c9584f643ae$export$efa9a398d6368992).errors.NONCE_EXPIRED,
    (0, $5f596c9584f643ae$export$efa9a398d6368992).errors.REPLACEMENT_UNDERPRICED
];
class $04afbe51d47fcc12$export$fdf54fdde81cc9f0 {
    ///////////////////
    // Sub-classes MUST call super
    constructor(){
        $04afbe51d47fcc12$var$logger.checkAbstract(new.target, $04afbe51d47fcc12$export$fdf54fdde81cc9f0);
        (0, $d2d9b472f7878d5e$exports.defineReadOnly)(this, "_isSigner", true);
    }
    ///////////////////
    // Sub-classes MAY override these
    getBalance(blockTag) {
        return $04afbe51d47fcc12$var$__awaiter(this, void 0, void 0, function*() {
            this._checkProvider("getBalance");
            return yield this.provider.getBalance(this.getAddress(), blockTag);
        });
    }
    getTransactionCount(blockTag) {
        return $04afbe51d47fcc12$var$__awaiter(this, void 0, void 0, function*() {
            this._checkProvider("getTransactionCount");
            return yield this.provider.getTransactionCount(this.getAddress(), blockTag);
        });
    }
    // Populates "from" if unspecified, and estimates the gas for the transaction
    estimateGas(transaction) {
        return $04afbe51d47fcc12$var$__awaiter(this, void 0, void 0, function*() {
            this._checkProvider("estimateGas");
            const tx = yield (0, $d2d9b472f7878d5e$exports.resolveProperties)(this.checkTransaction(transaction));
            return yield this.provider.estimateGas(tx);
        });
    }
    // Populates "from" if unspecified, and calls with the transaction
    call(transaction, blockTag) {
        return $04afbe51d47fcc12$var$__awaiter(this, void 0, void 0, function*() {
            this._checkProvider("call");
            const tx = yield (0, $d2d9b472f7878d5e$exports.resolveProperties)(this.checkTransaction(transaction));
            return yield this.provider.call(tx, blockTag);
        });
    }
    // Populates all fields in a transaction, signs it and sends it to the network
    sendTransaction(transaction) {
        return $04afbe51d47fcc12$var$__awaiter(this, void 0, void 0, function*() {
            this._checkProvider("sendTransaction");
            const tx = yield this.populateTransaction(transaction);
            const signedTx = yield this.signTransaction(tx);
            return yield this.provider.sendTransaction(signedTx);
        });
    }
    getChainId() {
        return $04afbe51d47fcc12$var$__awaiter(this, void 0, void 0, function*() {
            this._checkProvider("getChainId");
            const network = yield this.provider.getNetwork();
            return network.chainId;
        });
    }
    getGasPrice() {
        return $04afbe51d47fcc12$var$__awaiter(this, void 0, void 0, function*() {
            this._checkProvider("getGasPrice");
            return yield this.provider.getGasPrice();
        });
    }
    getFeeData() {
        return $04afbe51d47fcc12$var$__awaiter(this, void 0, void 0, function*() {
            this._checkProvider("getFeeData");
            return yield this.provider.getFeeData();
        });
    }
    resolveName(name) {
        return $04afbe51d47fcc12$var$__awaiter(this, void 0, void 0, function*() {
            this._checkProvider("resolveName");
            return yield this.provider.resolveName(name);
        });
    }
    // Checks a transaction does not contain invalid keys and if
    // no "from" is provided, populates it.
    // - does NOT require a provider
    // - adds "from" is not present
    // - returns a COPY (safe to mutate the result)
    // By default called from: (overriding these prevents it)
    //   - call
    //   - estimateGas
    //   - populateTransaction (and therefor sendTransaction)
    checkTransaction(transaction) {
        for(const key in transaction)if ($04afbe51d47fcc12$var$allowedTransactionKeys.indexOf(key) === -1) $04afbe51d47fcc12$var$logger.throwArgumentError("invalid transaction key: " + key, "transaction", transaction);
        const tx = (0, $d2d9b472f7878d5e$exports.shallowCopy)(transaction);
        if (tx.from == null) tx.from = this.getAddress();
        else // Make sure any provided address matches this signer
        tx.from = Promise.all([
            Promise.resolve(tx.from),
            this.getAddress()
        ]).then((result)=>{
            if (result[0].toLowerCase() !== result[1].toLowerCase()) $04afbe51d47fcc12$var$logger.throwArgumentError("from address mismatch", "transaction", transaction);
            return result[0];
        });
        return tx;
    }
    // Populates ALL keys for a transaction and checks that "from" matches
    // this Signer. Should be used by sendTransaction but NOT by signTransaction.
    // By default called from: (overriding these prevents it)
    //   - sendTransaction
    //
    // Notes:
    //  - We allow gasPrice for EIP-1559 as long as it matches maxFeePerGas
    populateTransaction(transaction) {
        return $04afbe51d47fcc12$var$__awaiter(this, void 0, void 0, function*() {
            const tx = yield (0, $d2d9b472f7878d5e$exports.resolveProperties)(this.checkTransaction(transaction));
            if (tx.to != null) {
                tx.to = Promise.resolve(tx.to).then((to)=>$04afbe51d47fcc12$var$__awaiter(this, void 0, void 0, function*() {
                        if (to == null) return null;
                        const address = yield this.resolveName(to);
                        if (address == null) $04afbe51d47fcc12$var$logger.throwArgumentError("provided ENS name resolves to null", "tx.to", to);
                        return address;
                    }));
                // Prevent this error from causing an UnhandledPromiseException
                tx.to.catch((error)=>{});
            }
            // Do not allow mixing pre-eip-1559 and eip-1559 properties
            const hasEip1559 = tx.maxFeePerGas != null || tx.maxPriorityFeePerGas != null;
            if (tx.gasPrice != null && (tx.type === 2 || hasEip1559)) $04afbe51d47fcc12$var$logger.throwArgumentError("eip-1559 transaction do not support gasPrice", "transaction", transaction);
            else if ((tx.type === 0 || tx.type === 1) && hasEip1559) $04afbe51d47fcc12$var$logger.throwArgumentError("pre-eip-1559 transaction do not support maxFeePerGas/maxPriorityFeePerGas", "transaction", transaction);
            if ((tx.type === 2 || tx.type == null) && tx.maxFeePerGas != null && tx.maxPriorityFeePerGas != null) // Fully-formed EIP-1559 transaction (skip getFeeData)
            tx.type = 2;
            else if (tx.type === 0 || tx.type === 1) // Explicit Legacy or EIP-2930 transaction
            // Populate missing gasPrice
            {
                if (tx.gasPrice == null) tx.gasPrice = this.getGasPrice();
            } else {
                // We need to get fee data to determine things
                const feeData = yield this.getFeeData();
                if (tx.type == null) {
                    // We need to auto-detect the intended type of this transaction...
                    if (feeData.maxFeePerGas != null && feeData.maxPriorityFeePerGas != null) {
                        // The network supports EIP-1559!
                        // Upgrade transaction from null to eip-1559
                        tx.type = 2;
                        if (tx.gasPrice != null) {
                            // Using legacy gasPrice property on an eip-1559 network,
                            // so use gasPrice as both fee properties
                            const gasPrice = tx.gasPrice;
                            delete tx.gasPrice;
                            tx.maxFeePerGas = gasPrice;
                            tx.maxPriorityFeePerGas = gasPrice;
                        } else {
                            // Populate missing fee data
                            if (tx.maxFeePerGas == null) tx.maxFeePerGas = feeData.maxFeePerGas;
                            if (tx.maxPriorityFeePerGas == null) tx.maxPriorityFeePerGas = feeData.maxPriorityFeePerGas;
                        }
                    } else if (feeData.gasPrice != null) {
                        // Network doesn't support EIP-1559...
                        // ...but they are trying to use EIP-1559 properties
                        if (hasEip1559) $04afbe51d47fcc12$var$logger.throwError("network does not support EIP-1559", (0, $5f596c9584f643ae$export$efa9a398d6368992).errors.UNSUPPORTED_OPERATION, {
                            operation: "populateTransaction"
                        });
                        // Populate missing fee data
                        if (tx.gasPrice == null) tx.gasPrice = feeData.gasPrice;
                        // Explicitly set untyped transaction to legacy
                        tx.type = 0;
                    } else // getFeeData has failed us.
                    $04afbe51d47fcc12$var$logger.throwError("failed to get consistent fee data", (0, $5f596c9584f643ae$export$efa9a398d6368992).errors.UNSUPPORTED_OPERATION, {
                        operation: "signer.getFeeData"
                    });
                } else if (tx.type === 2) {
                    // Explicitly using EIP-1559
                    // Populate missing fee data
                    if (tx.maxFeePerGas == null) tx.maxFeePerGas = feeData.maxFeePerGas;
                    if (tx.maxPriorityFeePerGas == null) tx.maxPriorityFeePerGas = feeData.maxPriorityFeePerGas;
                }
            }
            if (tx.nonce == null) tx.nonce = this.getTransactionCount("pending");
            if (tx.gasLimit == null) tx.gasLimit = this.estimateGas(tx).catch((error)=>{
                if ($04afbe51d47fcc12$var$forwardErrors.indexOf(error.code) >= 0) throw error;
                return $04afbe51d47fcc12$var$logger.throwError("cannot estimate gas; transaction may fail or may require manual gas limit", (0, $5f596c9584f643ae$export$efa9a398d6368992).errors.UNPREDICTABLE_GAS_LIMIT, {
                    error: error,
                    tx: tx
                });
            });
            if (tx.chainId == null) tx.chainId = this.getChainId();
            else tx.chainId = Promise.all([
                Promise.resolve(tx.chainId),
                this.getChainId()
            ]).then((results)=>{
                if (results[1] !== 0 && results[0] !== results[1]) $04afbe51d47fcc12$var$logger.throwArgumentError("chainId address mismatch", "transaction", transaction);
                return results[0];
            });
            return yield (0, $d2d9b472f7878d5e$exports.resolveProperties)(tx);
        });
    }
    ///////////////////
    // Sub-classes SHOULD leave these alone
    _checkProvider(operation) {
        if (!this.provider) $04afbe51d47fcc12$var$logger.throwError("missing provider", (0, $5f596c9584f643ae$export$efa9a398d6368992).errors.UNSUPPORTED_OPERATION, {
            operation: operation || "_checkProvider"
        });
    }
    static isSigner(value) {
        return !!(value && value._isSigner);
    }
}
class $04afbe51d47fcc12$export$7dbc56d9b9612bad extends $04afbe51d47fcc12$export$fdf54fdde81cc9f0 {
    constructor(address, provider){
        super();
        (0, $d2d9b472f7878d5e$exports.defineReadOnly)(this, "address", address);
        (0, $d2d9b472f7878d5e$exports.defineReadOnly)(this, "provider", provider || null);
    }
    getAddress() {
        return Promise.resolve(this.address);
    }
    _fail(message, operation) {
        return Promise.resolve().then(()=>{
            $04afbe51d47fcc12$var$logger.throwError(message, (0, $5f596c9584f643ae$export$efa9a398d6368992).errors.UNSUPPORTED_OPERATION, {
                operation: operation
            });
        });
    }
    signMessage(message) {
        return this._fail("VoidSigner cannot sign messages", "signMessage");
    }
    signTransaction(transaction) {
        return this._fail("VoidSigner cannot sign transactions", "signTransaction");
    }
    _signTypedData(domain, types, value) {
        return this._fail("VoidSigner cannot sign typed data", "signTypedData");
    }
    connect(provider) {
        return new $04afbe51d47fcc12$export$7dbc56d9b9612bad(this.address, provider);
    }
}




var $9492f7dcb2320b2f$exports = {};

$parcel$export($9492f7dcb2320b2f$exports, "TypedDataEncoder", function () { return $9492f7dcb2320b2f$export$458ab927ae635c3; });









function $143d6d71aa960133$export$d560c7e4a29451c2(text) {
    return (0, $62e3396d458230e9$export$f8151fce47ad1c35)((0, $7bbf1261c840221b$export$8feeb310b4b4752f)(text));
}


var $9492f7dcb2320b2f$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
const $9492f7dcb2320b2f$var$logger = new (0, $5f596c9584f643ae$export$efa9a398d6368992)((0, $3f74d983611b69f1$export$83d89fbfd8236492));
const $9492f7dcb2320b2f$var$padding = new Uint8Array(32);
$9492f7dcb2320b2f$var$padding.fill(0);
const $9492f7dcb2320b2f$var$NegativeOne = (0, $a87aa97415e1b917$export$d97aa349ed20696).from(-1);
const $9492f7dcb2320b2f$var$Zero = (0, $a87aa97415e1b917$export$d97aa349ed20696).from(0);
const $9492f7dcb2320b2f$var$One = (0, $a87aa97415e1b917$export$d97aa349ed20696).from(1);
const $9492f7dcb2320b2f$var$MaxUint256 = (0, $a87aa97415e1b917$export$d97aa349ed20696).from("0xffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff");
function $9492f7dcb2320b2f$var$hexPadRight(value) {
    const bytes = (0, $06d75ae17ce69367$export$3131421a7d01b4fb)(value);
    const padOffset = bytes.length % 32;
    if (padOffset) return (0, $06d75ae17ce69367$export$6d4b99629b38754a)([
        bytes,
        $9492f7dcb2320b2f$var$padding.slice(padOffset)
    ]);
    return (0, $06d75ae17ce69367$export$2b0d6b5fbe698c70)(bytes);
}
const $9492f7dcb2320b2f$var$hexTrue = (0, $06d75ae17ce69367$export$e9c46a54370b47e8)($9492f7dcb2320b2f$var$One.toHexString(), 32);
const $9492f7dcb2320b2f$var$hexFalse = (0, $06d75ae17ce69367$export$e9c46a54370b47e8)($9492f7dcb2320b2f$var$Zero.toHexString(), 32);
const $9492f7dcb2320b2f$var$domainFieldTypes = {
    name: "string",
    version: "string",
    chainId: "uint256",
    verifyingContract: "address",
    salt: "bytes32"
};
const $9492f7dcb2320b2f$var$domainFieldNames = [
    "name",
    "version",
    "chainId",
    "verifyingContract",
    "salt"
];
function $9492f7dcb2320b2f$var$checkString(key) {
    return function(value) {
        if (typeof value !== "string") $9492f7dcb2320b2f$var$logger.throwArgumentError(`invalid domain value for ${JSON.stringify(key)}`, `domain.${key}`, value);
        return value;
    };
}
const $9492f7dcb2320b2f$var$domainChecks = {
    name: $9492f7dcb2320b2f$var$checkString("name"),
    version: $9492f7dcb2320b2f$var$checkString("version"),
    chainId: function(value) {
        try {
            return (0, $a87aa97415e1b917$export$d97aa349ed20696).from(value).toString();
        } catch (error) {}
        return $9492f7dcb2320b2f$var$logger.throwArgumentError(`invalid domain value for "chainId"`, "domain.chainId", value);
    },
    verifyingContract: function(value) {
        try {
            return (0, $5652f239bab101de$export$88411125f012957a)(value).toLowerCase();
        } catch (error) {}
        return $9492f7dcb2320b2f$var$logger.throwArgumentError(`invalid domain value "verifyingContract"`, "domain.verifyingContract", value);
    },
    salt: function(value) {
        try {
            const bytes = (0, $06d75ae17ce69367$export$3131421a7d01b4fb)(value);
            if (bytes.length !== 32) throw new Error("bad length");
            return (0, $06d75ae17ce69367$export$2b0d6b5fbe698c70)(bytes);
        } catch (error) {}
        return $9492f7dcb2320b2f$var$logger.throwArgumentError(`invalid domain value "salt"`, "domain.salt", value);
    }
};
function $9492f7dcb2320b2f$var$getBaseEncoder(type) {
    // intXX and uintXX
    {
        const match = type.match(/^(u?)int(\d*)$/);
        if (match) {
            const signed = match[1] === "";
            const width = parseInt(match[2] || "256");
            if (width % 8 !== 0 || width > 256 || match[2] && match[2] !== String(width)) $9492f7dcb2320b2f$var$logger.throwArgumentError("invalid numeric width", "type", type);
            const boundsUpper = $9492f7dcb2320b2f$var$MaxUint256.mask(signed ? width - 1 : width);
            const boundsLower = signed ? boundsUpper.add($9492f7dcb2320b2f$var$One).mul($9492f7dcb2320b2f$var$NegativeOne) : $9492f7dcb2320b2f$var$Zero;
            return function(value) {
                const v = (0, $a87aa97415e1b917$export$d97aa349ed20696).from(value);
                if (v.lt(boundsLower) || v.gt(boundsUpper)) $9492f7dcb2320b2f$var$logger.throwArgumentError(`value out-of-bounds for ${type}`, "value", value);
                return (0, $06d75ae17ce69367$export$e9c46a54370b47e8)(v.toTwos(256).toHexString(), 32);
            };
        }
    }
    // bytesXX
    {
        const match = type.match(/^bytes(\d+)$/);
        if (match) {
            const width = parseInt(match[1]);
            if (width === 0 || width > 32 || match[1] !== String(width)) $9492f7dcb2320b2f$var$logger.throwArgumentError("invalid bytes width", "type", type);
            return function(value) {
                const bytes = (0, $06d75ae17ce69367$export$3131421a7d01b4fb)(value);
                if (bytes.length !== width) $9492f7dcb2320b2f$var$logger.throwArgumentError(`invalid length for ${type}`, "value", value);
                return $9492f7dcb2320b2f$var$hexPadRight(value);
            };
        }
    }
    switch(type){
        case "address":
            return function(value) {
                return (0, $06d75ae17ce69367$export$e9c46a54370b47e8)((0, $5652f239bab101de$export$88411125f012957a)(value), 32);
            };
        case "bool":
            return function(value) {
                return !value ? $9492f7dcb2320b2f$var$hexFalse : $9492f7dcb2320b2f$var$hexTrue;
            };
        case "bytes":
            return function(value) {
                return (0, $62e3396d458230e9$export$f8151fce47ad1c35)(value);
            };
        case "string":
            return function(value) {
                return (0, $143d6d71aa960133$export$d560c7e4a29451c2)(value);
            };
    }
    return null;
}
function $9492f7dcb2320b2f$var$encodeType(name, fields) {
    return `${name}(${fields.map(({ name: name, type: type })=>type + " " + name).join(",")})`;
}
class $9492f7dcb2320b2f$export$458ab927ae635c3 {
    constructor(types){
        (0, $d2d9b472f7878d5e$exports.defineReadOnly)(this, "types", Object.freeze((0, $d2d9b472f7878d5e$exports.deepCopy)(types)));
        (0, $d2d9b472f7878d5e$exports.defineReadOnly)(this, "_encoderCache", {});
        (0, $d2d9b472f7878d5e$exports.defineReadOnly)(this, "_types", {});
        // Link struct types to their direct child structs
        const links = {};
        // Link structs to structs which contain them as a child
        const parents = {};
        // Link all subtypes within a given struct
        const subtypes = {};
        Object.keys(types).forEach((type)=>{
            links[type] = {};
            parents[type] = [];
            subtypes[type] = {};
        });
        for(const name in types){
            const uniqueNames = {};
            types[name].forEach((field)=>{
                // Check each field has a unique name
                if (uniqueNames[field.name]) $9492f7dcb2320b2f$var$logger.throwArgumentError(`duplicate variable name ${JSON.stringify(field.name)} in ${JSON.stringify(name)}`, "types", types);
                uniqueNames[field.name] = true;
                // Get the base type (drop any array specifiers)
                const baseType = field.type.match(/^([^\x5b]*)(\x5b|$)/)[1];
                if (baseType === name) $9492f7dcb2320b2f$var$logger.throwArgumentError(`circular type reference to ${JSON.stringify(baseType)}`, "types", types);
                // Is this a base encoding type?
                const encoder = $9492f7dcb2320b2f$var$getBaseEncoder(baseType);
                if (encoder) return;
                if (!parents[baseType]) $9492f7dcb2320b2f$var$logger.throwArgumentError(`unknown type ${JSON.stringify(baseType)}`, "types", types);
                // Add linkage
                parents[baseType].push(name);
                links[name][baseType] = true;
            });
        }
        // Deduce the primary type
        const primaryTypes = Object.keys(parents).filter((n)=>parents[n].length === 0);
        if (primaryTypes.length === 0) $9492f7dcb2320b2f$var$logger.throwArgumentError("missing primary type", "types", types);
        else if (primaryTypes.length > 1) $9492f7dcb2320b2f$var$logger.throwArgumentError(`ambiguous primary types or unused types: ${primaryTypes.map((t)=>JSON.stringify(t)).join(", ")}`, "types", types);
        (0, $d2d9b472f7878d5e$exports.defineReadOnly)(this, "primaryType", primaryTypes[0]);
        // Check for circular type references
        function checkCircular(type, found) {
            if (found[type]) $9492f7dcb2320b2f$var$logger.throwArgumentError(`circular type reference to ${JSON.stringify(type)}`, "types", types);
            found[type] = true;
            Object.keys(links[type]).forEach((child)=>{
                if (!parents[child]) return;
                // Recursively check children
                checkCircular(child, found);
                // Mark all ancestors as having this decendant
                Object.keys(found).forEach((subtype)=>{
                    subtypes[subtype][child] = true;
                });
            });
            delete found[type];
        }
        checkCircular(this.primaryType, {});
        // Compute each fully describe type
        for(const name in subtypes){
            const st = Object.keys(subtypes[name]);
            st.sort();
            this._types[name] = $9492f7dcb2320b2f$var$encodeType(name, types[name]) + st.map((t)=>$9492f7dcb2320b2f$var$encodeType(t, types[t])).join("");
        }
    }
    getEncoder(type) {
        let encoder = this._encoderCache[type];
        if (!encoder) encoder = this._encoderCache[type] = this._getEncoder(type);
        return encoder;
    }
    _getEncoder(type) {
        // Basic encoder type (address, bool, uint256, etc)
        {
            const encoder = $9492f7dcb2320b2f$var$getBaseEncoder(type);
            if (encoder) return encoder;
        }
        // Array
        const match = type.match(/^(.*)(\x5b(\d*)\x5d)$/);
        if (match) {
            const subtype = match[1];
            const subEncoder = this.getEncoder(subtype);
            const length = parseInt(match[3]);
            return (value)=>{
                if (length >= 0 && value.length !== length) $9492f7dcb2320b2f$var$logger.throwArgumentError("array length mismatch; expected length ${ arrayLength }", "value", value);
                let result = value.map(subEncoder);
                if (this._types[subtype]) result = result.map((0, $62e3396d458230e9$export$f8151fce47ad1c35));
                return (0, $62e3396d458230e9$export$f8151fce47ad1c35)((0, $06d75ae17ce69367$export$6d4b99629b38754a)(result));
            };
        }
        // Struct
        const fields = this.types[type];
        if (fields) {
            const encodedType = (0, $143d6d71aa960133$export$d560c7e4a29451c2)(this._types[type]);
            return (value)=>{
                const values = fields.map(({ name: name, type: type })=>{
                    const result = this.getEncoder(type)(value[name]);
                    if (this._types[type]) return (0, $62e3396d458230e9$export$f8151fce47ad1c35)(result);
                    return result;
                });
                values.unshift(encodedType);
                return (0, $06d75ae17ce69367$export$6d4b99629b38754a)(values);
            };
        }
        return $9492f7dcb2320b2f$var$logger.throwArgumentError(`unknown type: ${type}`, "type", type);
    }
    encodeType(name) {
        const result = this._types[name];
        if (!result) $9492f7dcb2320b2f$var$logger.throwArgumentError(`unknown type: ${JSON.stringify(name)}`, "name", name);
        return result;
    }
    encodeData(type, value) {
        return this.getEncoder(type)(value);
    }
    hashStruct(name, value) {
        return (0, $62e3396d458230e9$export$f8151fce47ad1c35)(this.encodeData(name, value));
    }
    encode(value) {
        return this.encodeData(this.primaryType, value);
    }
    hash(value) {
        return this.hashStruct(this.primaryType, value);
    }
    _visit(type, value, callback) {
        // Basic encoder type (address, bool, uint256, etc)
        {
            const encoder = $9492f7dcb2320b2f$var$getBaseEncoder(type);
            if (encoder) return callback(type, value);
        }
        // Array
        const match = type.match(/^(.*)(\x5b(\d*)\x5d)$/);
        if (match) {
            const subtype = match[1];
            const length = parseInt(match[3]);
            if (length >= 0 && value.length !== length) $9492f7dcb2320b2f$var$logger.throwArgumentError("array length mismatch; expected length ${ arrayLength }", "value", value);
            return value.map((v)=>this._visit(subtype, v, callback));
        }
        // Struct
        const fields = this.types[type];
        if (fields) return fields.reduce((accum, { name: name, type: type })=>{
            accum[name] = this._visit(type, value[name], callback);
            return accum;
        }, {});
        return $9492f7dcb2320b2f$var$logger.throwArgumentError(`unknown type: ${type}`, "type", type);
    }
    visit(value, callback) {
        return this._visit(this.primaryType, value, callback);
    }
    static from(types) {
        return new $9492f7dcb2320b2f$export$458ab927ae635c3(types);
    }
    static getPrimaryType(types) {
        return $9492f7dcb2320b2f$export$458ab927ae635c3.from(types).primaryType;
    }
    static hashStruct(name, types, value) {
        return $9492f7dcb2320b2f$export$458ab927ae635c3.from(types).hashStruct(name, value);
    }
    static hashDomain(domain) {
        const domainFields = [];
        for(const name in domain){
            const type = $9492f7dcb2320b2f$var$domainFieldTypes[name];
            if (!type) $9492f7dcb2320b2f$var$logger.throwArgumentError(`invalid typed-data domain key: ${JSON.stringify(name)}`, "domain", domain);
            domainFields.push({
                name: name,
                type: type
            });
        }
        domainFields.sort((a, b)=>{
            return $9492f7dcb2320b2f$var$domainFieldNames.indexOf(a.name) - $9492f7dcb2320b2f$var$domainFieldNames.indexOf(b.name);
        });
        return $9492f7dcb2320b2f$export$458ab927ae635c3.hashStruct("EIP712Domain", {
            EIP712Domain: domainFields
        }, domain);
    }
    static encode(domain, types, value) {
        return (0, $06d75ae17ce69367$export$6d4b99629b38754a)([
            "0x1901",
            $9492f7dcb2320b2f$export$458ab927ae635c3.hashDomain(domain),
            $9492f7dcb2320b2f$export$458ab927ae635c3.from(types).hash(value)
        ]);
    }
    static hash(domain, types, value) {
        return (0, $62e3396d458230e9$export$f8151fce47ad1c35)($9492f7dcb2320b2f$export$458ab927ae635c3.encode(domain, types, value));
    }
    // Replaces all address types with ENS names with their looked up address
    static resolveNames(domain, types, value, resolveName) {
        return $9492f7dcb2320b2f$var$__awaiter(this, void 0, void 0, function*() {
            // Make a copy to isolate it from the object passed in
            domain = (0, $d2d9b472f7878d5e$exports.shallowCopy)(domain);
            // Look up all ENS names
            const ensCache = {};
            // Do we need to look up the domain's verifyingContract?
            if (domain.verifyingContract && !(0, $06d75ae17ce69367$export$b02a40aff8e4ad18)(domain.verifyingContract, 20)) ensCache[domain.verifyingContract] = "0x";
            // We are going to use the encoder to visit all the base values
            const encoder = $9492f7dcb2320b2f$export$458ab927ae635c3.from(types);
            // Get a list of all the addresses
            encoder.visit(value, (type, value)=>{
                if (type === "address" && !(0, $06d75ae17ce69367$export$b02a40aff8e4ad18)(value, 20)) ensCache[value] = "0x";
                return value;
            });
            // Lookup each name
            for(const name in ensCache)ensCache[name] = yield resolveName(name);
            // Replace the domain verifyingContract if needed
            if (domain.verifyingContract && ensCache[domain.verifyingContract]) domain.verifyingContract = ensCache[domain.verifyingContract];
            // Replace all ENS names with their address
            value = encoder.visit(value, (type, value)=>{
                if (type === "address" && ensCache[value]) return ensCache[value];
                return value;
            });
            return {
                domain: domain,
                value: value
            };
        });
    }
    static getPayload(domain, types, value) {
        // Validate the domain fields
        $9492f7dcb2320b2f$export$458ab927ae635c3.hashDomain(domain);
        // Derive the EIP712Domain Struct reference type
        const domainValues = {};
        const domainTypes = [];
        $9492f7dcb2320b2f$var$domainFieldNames.forEach((name)=>{
            const value = domain[name];
            if (value == null) return;
            domainValues[name] = $9492f7dcb2320b2f$var$domainChecks[name](value);
            domainTypes.push({
                name: name,
                type: $9492f7dcb2320b2f$var$domainFieldTypes[name]
            });
        });
        const encoder = $9492f7dcb2320b2f$export$458ab927ae635c3.from(types);
        const typesWithDomain = (0, $d2d9b472f7878d5e$exports.shallowCopy)(types);
        if (typesWithDomain.EIP712Domain) $9492f7dcb2320b2f$var$logger.throwArgumentError("types must not contain EIP712Domain type", "types.EIP712Domain", types);
        else typesWithDomain.EIP712Domain = domainTypes;
        // Validate the data structures and types
        encoder.encode(value);
        return {
            types: typesWithDomain,
            domain: domainValues,
            primaryType: encoder.primaryType,
            message: encoder.visit(value, (type, value)=>{
                // bytes
                if (type.match(/^bytes(\d*)/)) return (0, $06d75ae17ce69367$export$2b0d6b5fbe698c70)((0, $06d75ae17ce69367$export$3131421a7d01b4fb)(value));
                // uint or int
                if (type.match(/^u?int/)) return (0, $a87aa97415e1b917$export$d97aa349ed20696).from(value).toString();
                switch(type){
                    case "address":
                        return value.toLowerCase();
                    case "bool":
                        return !!value;
                    case "string":
                        if (typeof value !== "string") $9492f7dcb2320b2f$var$logger.throwArgumentError(`invalid string`, "value", value);
                        return value;
                }
                return $9492f7dcb2320b2f$var$logger.throwArgumentError("unsupported type", "type", type);
            })
        };
    }
}









"use strict";
var $9609e75996f2bd40$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
const $9609e75996f2bd40$var$logger = new (0, $5f596c9584f643ae$export$efa9a398d6368992)((0, $e9ed5b422bb4952f$export$83d89fbfd8236492));
const $9609e75996f2bd40$var$errorGas = [
    "call",
    "estimateGas"
];
function $9609e75996f2bd40$var$spelunk(value, requireData) {
    if (value == null) return null;
    // These *are* the droids we're looking for.
    if (typeof value.message === "string" && value.message.match("reverted")) {
        const data = (0, $06d75ae17ce69367$export$b02a40aff8e4ad18)(value.data) ? value.data : null;
        if (!requireData || data) return {
            message: value.message,
            data: data
        };
    }
    // Spelunk further...
    if (typeof value === "object") {
        for(const key in value){
            const result = $9609e75996f2bd40$var$spelunk(value[key], requireData);
            if (result) return result;
        }
        return null;
    }
    // Might be a JSON string we can further descend...
    if (typeof value === "string") try {
        return $9609e75996f2bd40$var$spelunk(JSON.parse(value), requireData);
    } catch (error) {}
    return null;
}
function $9609e75996f2bd40$var$checkError(method, error, params) {
    const transaction = params.transaction || params.signedTransaction;
    // Undo the "convenience" some nodes are attempting to prevent backwards
    // incompatibility; maybe for v6 consider forwarding reverts as errors
    if (method === "call") {
        const result = $9609e75996f2bd40$var$spelunk(error, true);
        if (result) return result.data;
        // Nothing descriptive..
        $9609e75996f2bd40$var$logger.throwError("missing revert data in call exception; Transaction reverted without a reason string", (0, $5f596c9584f643ae$export$efa9a398d6368992).errors.CALL_EXCEPTION, {
            data: "0x",
            transaction: transaction,
            error: error
        });
    }
    if (method === "estimateGas") {
        // Try to find something, with a preference on SERVER_ERROR body
        let result = $9609e75996f2bd40$var$spelunk(error.body, false);
        if (result == null) result = $9609e75996f2bd40$var$spelunk(error, false);
        // Found "reverted", this is a CALL_EXCEPTION
        if (result) $9609e75996f2bd40$var$logger.throwError("cannot estimate gas; transaction may fail or may require manual gas limit", (0, $5f596c9584f643ae$export$efa9a398d6368992).errors.UNPREDICTABLE_GAS_LIMIT, {
            reason: result.message,
            method: method,
            transaction: transaction,
            error: error
        });
    }
    // @TODO: Should we spelunk for message too?
    let message = error.message;
    if (error.code === (0, $5f596c9584f643ae$export$efa9a398d6368992).errors.SERVER_ERROR && error.error && typeof error.error.message === "string") message = error.error.message;
    else if (typeof error.body === "string") message = error.body;
    else if (typeof error.responseText === "string") message = error.responseText;
    message = (message || "").toLowerCase();
    // "insufficient funds for gas * price + value + cost(data)"
    if (message.match(/insufficient funds|base fee exceeds gas limit|InsufficientFunds/i)) $9609e75996f2bd40$var$logger.throwError("insufficient funds for intrinsic transaction cost", (0, $5f596c9584f643ae$export$efa9a398d6368992).errors.INSUFFICIENT_FUNDS, {
        error: error,
        method: method,
        transaction: transaction
    });
    // "nonce too low"
    if (message.match(/nonce (is )?too low/i)) $9609e75996f2bd40$var$logger.throwError("nonce has already been used", (0, $5f596c9584f643ae$export$efa9a398d6368992).errors.NONCE_EXPIRED, {
        error: error,
        method: method,
        transaction: transaction
    });
    // "replacement transaction underpriced"
    if (message.match(/replacement transaction underpriced|transaction gas price.*too low/i)) $9609e75996f2bd40$var$logger.throwError("replacement fee too low", (0, $5f596c9584f643ae$export$efa9a398d6368992).errors.REPLACEMENT_UNDERPRICED, {
        error: error,
        method: method,
        transaction: transaction
    });
    // "replacement transaction underpriced"
    if (message.match(/only replay-protected/i)) $9609e75996f2bd40$var$logger.throwError("legacy pre-eip-155 transactions not supported", (0, $5f596c9584f643ae$export$efa9a398d6368992).errors.UNSUPPORTED_OPERATION, {
        error: error,
        method: method,
        transaction: transaction
    });
    if ($9609e75996f2bd40$var$errorGas.indexOf(method) >= 0 && message.match(/gas required exceeds allowance|always failing transaction|execution reverted|revert/)) $9609e75996f2bd40$var$logger.throwError("cannot estimate gas; transaction may fail or may require manual gas limit", (0, $5f596c9584f643ae$export$efa9a398d6368992).errors.UNPREDICTABLE_GAS_LIMIT, {
        error: error,
        method: method,
        transaction: transaction
    });
    throw error;
}
function $9609e75996f2bd40$var$timer(timeout) {
    return new Promise(function(resolve) {
        setTimeout(resolve, timeout);
    });
}
function $9609e75996f2bd40$var$getResult(payload) {
    if (payload.error) {
        // @TODO: not any
        const error = new Error(payload.error.message);
        error.code = payload.error.code;
        error.data = payload.error.data;
        throw error;
    }
    return payload.result;
}
function $9609e75996f2bd40$var$getLowerCase(value) {
    if (value) return value.toLowerCase();
    return value;
}
const $9609e75996f2bd40$var$_constructorGuard = {};
class $9609e75996f2bd40$export$5f7b5fca3508545a extends (0, $04afbe51d47fcc12$exports.Signer) {
    constructor(constructorGuard, provider, addressOrIndex){
        super();
        if (constructorGuard !== $9609e75996f2bd40$var$_constructorGuard) throw new Error("do not call the JsonRpcSigner constructor directly; use provider.getSigner");
        (0, $d2d9b472f7878d5e$exports.defineReadOnly)(this, "provider", provider);
        if (addressOrIndex == null) addressOrIndex = 0;
        if (typeof addressOrIndex === "string") {
            (0, $d2d9b472f7878d5e$exports.defineReadOnly)(this, "_address", this.provider.formatter.address(addressOrIndex));
            (0, $d2d9b472f7878d5e$exports.defineReadOnly)(this, "_index", null);
        } else if (typeof addressOrIndex === "number") {
            (0, $d2d9b472f7878d5e$exports.defineReadOnly)(this, "_index", addressOrIndex);
            (0, $d2d9b472f7878d5e$exports.defineReadOnly)(this, "_address", null);
        } else $9609e75996f2bd40$var$logger.throwArgumentError("invalid address or index", "addressOrIndex", addressOrIndex);
    }
    connect(provider) {
        return $9609e75996f2bd40$var$logger.throwError("cannot alter JSON-RPC Signer connection", (0, $5f596c9584f643ae$export$efa9a398d6368992).errors.UNSUPPORTED_OPERATION, {
            operation: "connect"
        });
    }
    connectUnchecked() {
        return new $9609e75996f2bd40$var$UncheckedJsonRpcSigner($9609e75996f2bd40$var$_constructorGuard, this.provider, this._address || this._index);
    }
    getAddress() {
        if (this._address) return Promise.resolve(this._address);
        return this.provider.send("eth_accounts", []).then((accounts)=>{
            if (accounts.length <= this._index) $9609e75996f2bd40$var$logger.throwError("unknown account #" + this._index, (0, $5f596c9584f643ae$export$efa9a398d6368992).errors.UNSUPPORTED_OPERATION, {
                operation: "getAddress"
            });
            return this.provider.formatter.address(accounts[this._index]);
        });
    }
    sendUncheckedTransaction(transaction) {
        transaction = (0, $d2d9b472f7878d5e$exports.shallowCopy)(transaction);
        const fromAddress = this.getAddress().then((address)=>{
            if (address) address = address.toLowerCase();
            return address;
        });
        // The JSON-RPC for eth_sendTransaction uses 90000 gas; if the user
        // wishes to use this, it is easy to specify explicitly, otherwise
        // we look it up for them.
        if (transaction.gasLimit == null) {
            const estimate = (0, $d2d9b472f7878d5e$exports.shallowCopy)(transaction);
            estimate.from = fromAddress;
            transaction.gasLimit = this.provider.estimateGas(estimate);
        }
        if (transaction.to != null) transaction.to = Promise.resolve(transaction.to).then((to)=>$9609e75996f2bd40$var$__awaiter(this, void 0, void 0, function*() {
                if (to == null) return null;
                const address = yield this.provider.resolveName(to);
                if (address == null) $9609e75996f2bd40$var$logger.throwArgumentError("provided ENS name resolves to null", "tx.to", to);
                return address;
            }));
        return (0, $d2d9b472f7878d5e$exports.resolveProperties)({
            tx: (0, $d2d9b472f7878d5e$exports.resolveProperties)(transaction),
            sender: fromAddress
        }).then(({ tx: tx, sender: sender })=>{
            if (tx.from != null) {
                if (tx.from.toLowerCase() !== sender) $9609e75996f2bd40$var$logger.throwArgumentError("from address mismatch", "transaction", transaction);
            } else tx.from = sender;
            const hexTx = this.provider.constructor.hexlifyTransaction(tx, {
                from: true
            });
            return this.provider.send("eth_sendTransaction", [
                hexTx
            ]).then((hash)=>{
                return hash;
            }, (error)=>{
                if (typeof error.message === "string" && error.message.match(/user denied/i)) $9609e75996f2bd40$var$logger.throwError("user rejected transaction", (0, $5f596c9584f643ae$export$efa9a398d6368992).errors.ACTION_REJECTED, {
                    action: "sendTransaction",
                    transaction: tx
                });
                return $9609e75996f2bd40$var$checkError("sendTransaction", error, hexTx);
            });
        });
    }
    signTransaction(transaction) {
        return $9609e75996f2bd40$var$logger.throwError("signing transactions is unsupported", (0, $5f596c9584f643ae$export$efa9a398d6368992).errors.UNSUPPORTED_OPERATION, {
            operation: "signTransaction"
        });
    }
    sendTransaction(transaction) {
        return $9609e75996f2bd40$var$__awaiter(this, void 0, void 0, function*() {
            // This cannot be mined any earlier than any recent block
            const blockNumber = yield this.provider._getInternalBlockNumber(100 + 2 * this.provider.pollingInterval);
            // Send the transaction
            const hash = yield this.sendUncheckedTransaction(transaction);
            try {
                // Unfortunately, JSON-RPC only provides and opaque transaction hash
                // for a response, and we need the actual transaction, so we poll
                // for it; it should show up very quickly
                return yield (0, $1f5b367caa9efc4a$exports.poll)(()=>$9609e75996f2bd40$var$__awaiter(this, void 0, void 0, function*() {
                        const tx = yield this.provider.getTransaction(hash);
                        if (tx === null) return undefined;
                        return this.provider._wrapTransaction(tx, hash, blockNumber);
                    }), {
                    oncePoll: this.provider
                });
            } catch (error) {
                error.transactionHash = hash;
                throw error;
            }
        });
    }
    signMessage(message) {
        return $9609e75996f2bd40$var$__awaiter(this, void 0, void 0, function*() {
            const data = typeof message === "string" ? (0, $7bbf1261c840221b$export$8feeb310b4b4752f)(message) : message;
            const address = yield this.getAddress();
            try {
                return yield this.provider.send("personal_sign", [
                    (0, $06d75ae17ce69367$export$2b0d6b5fbe698c70)(data),
                    address.toLowerCase()
                ]);
            } catch (error) {
                if (typeof error.message === "string" && error.message.match(/user denied/i)) $9609e75996f2bd40$var$logger.throwError("user rejected signing", (0, $5f596c9584f643ae$export$efa9a398d6368992).errors.ACTION_REJECTED, {
                    action: "signMessage",
                    from: address,
                    messageData: message
                });
                throw error;
            }
        });
    }
    _legacySignMessage(message) {
        return $9609e75996f2bd40$var$__awaiter(this, void 0, void 0, function*() {
            const data = typeof message === "string" ? (0, $7bbf1261c840221b$export$8feeb310b4b4752f)(message) : message;
            const address = yield this.getAddress();
            try {
                // https://github.com/ethereum/wiki/wiki/JSON-RPC#eth_sign
                return yield this.provider.send("eth_sign", [
                    address.toLowerCase(),
                    (0, $06d75ae17ce69367$export$2b0d6b5fbe698c70)(data)
                ]);
            } catch (error) {
                if (typeof error.message === "string" && error.message.match(/user denied/i)) $9609e75996f2bd40$var$logger.throwError("user rejected signing", (0, $5f596c9584f643ae$export$efa9a398d6368992).errors.ACTION_REJECTED, {
                    action: "_legacySignMessage",
                    from: address,
                    messageData: message
                });
                throw error;
            }
        });
    }
    _signTypedData(domain, types, value) {
        return $9609e75996f2bd40$var$__awaiter(this, void 0, void 0, function*() {
            // Populate any ENS names (in-place)
            const populated = yield (0, $9492f7dcb2320b2f$exports.TypedDataEncoder).resolveNames(domain, types, value, (name)=>{
                return this.provider.resolveName(name);
            });
            const address = yield this.getAddress();
            try {
                return yield this.provider.send("eth_signTypedData_v4", [
                    address.toLowerCase(),
                    JSON.stringify((0, $9492f7dcb2320b2f$exports.TypedDataEncoder).getPayload(populated.domain, types, populated.value))
                ]);
            } catch (error) {
                if (typeof error.message === "string" && error.message.match(/user denied/i)) $9609e75996f2bd40$var$logger.throwError("user rejected signing", (0, $5f596c9584f643ae$export$efa9a398d6368992).errors.ACTION_REJECTED, {
                    action: "_signTypedData",
                    from: address,
                    messageData: {
                        domain: populated.domain,
                        types: types,
                        value: populated.value
                    }
                });
                throw error;
            }
        });
    }
    unlock(password) {
        return $9609e75996f2bd40$var$__awaiter(this, void 0, void 0, function*() {
            const provider = this.provider;
            const address = yield this.getAddress();
            return provider.send("personal_unlockAccount", [
                address.toLowerCase(),
                password,
                null
            ]);
        });
    }
}
class $9609e75996f2bd40$var$UncheckedJsonRpcSigner extends $9609e75996f2bd40$export$5f7b5fca3508545a {
    sendTransaction(transaction) {
        return this.sendUncheckedTransaction(transaction).then((hash)=>{
            return {
                hash: hash,
                nonce: null,
                gasLimit: null,
                gasPrice: null,
                data: null,
                value: null,
                chainId: null,
                confirmations: 0,
                from: null,
                wait: (confirmations)=>{
                    return this.provider.waitForTransaction(hash, confirmations);
                }
            };
        });
    }
}
const $9609e75996f2bd40$var$allowedTransactionKeys = {
    chainId: true,
    data: true,
    gasLimit: true,
    gasPrice: true,
    nonce: true,
    to: true,
    value: true,
    type: true,
    accessList: true,
    maxFeePerGas: true,
    maxPriorityFeePerGas: true
};
class $9609e75996f2bd40$export$da28308012bf6748 extends (0, $fa2219aa02c3e62e$exports.BaseProvider) {
    constructor(url, network){
        let networkOrReady = network;
        // The network is unknown, query the JSON-RPC for it
        if (networkOrReady == null) networkOrReady = new Promise((resolve, reject)=>{
            setTimeout(()=>{
                this.detectNetwork().then((network)=>{
                    resolve(network);
                }, (error)=>{
                    reject(error);
                });
            }, 0);
        });
        super(networkOrReady);
        // Default URL
        if (!url) url = (0, $d2d9b472f7878d5e$exports.getStatic)(this.constructor, "defaultUrl")();
        if (typeof url === "string") (0, $d2d9b472f7878d5e$exports.defineReadOnly)(this, "connection", Object.freeze({
            url: url
        }));
        else (0, $d2d9b472f7878d5e$exports.defineReadOnly)(this, "connection", Object.freeze((0, $d2d9b472f7878d5e$exports.shallowCopy)(url)));
        this._nextId = 42;
    }
    get _cache() {
        if (this._eventLoopCache == null) this._eventLoopCache = {};
        return this._eventLoopCache;
    }
    static defaultUrl() {
        return "http://localhost:8545";
    }
    detectNetwork() {
        if (!this._cache["detectNetwork"]) {
            this._cache["detectNetwork"] = this._uncachedDetectNetwork();
            // Clear this cache at the beginning of the next event loop
            setTimeout(()=>{
                this._cache["detectNetwork"] = null;
            }, 0);
        }
        return this._cache["detectNetwork"];
    }
    _uncachedDetectNetwork() {
        return $9609e75996f2bd40$var$__awaiter(this, void 0, void 0, function*() {
            yield $9609e75996f2bd40$var$timer(0);
            let chainId = null;
            try {
                chainId = yield this.send("eth_chainId", []);
            } catch (error) {
                try {
                    chainId = yield this.send("net_version", []);
                } catch (error) {}
            }
            if (chainId != null) {
                const getNetwork = (0, $d2d9b472f7878d5e$exports.getStatic)(this.constructor, "getNetwork");
                try {
                    return getNetwork((0, $a87aa97415e1b917$export$d97aa349ed20696).from(chainId).toNumber());
                } catch (error) {
                    return $9609e75996f2bd40$var$logger.throwError("could not detect network", (0, $5f596c9584f643ae$export$efa9a398d6368992).errors.NETWORK_ERROR, {
                        chainId: chainId,
                        event: "invalidNetwork",
                        serverError: error
                    });
                }
            }
            return $9609e75996f2bd40$var$logger.throwError("could not detect network", (0, $5f596c9584f643ae$export$efa9a398d6368992).errors.NETWORK_ERROR, {
                event: "noNetwork"
            });
        });
    }
    getSigner(addressOrIndex) {
        return new $9609e75996f2bd40$export$5f7b5fca3508545a($9609e75996f2bd40$var$_constructorGuard, this, addressOrIndex);
    }
    getUncheckedSigner(addressOrIndex) {
        return this.getSigner(addressOrIndex).connectUnchecked();
    }
    listAccounts() {
        return this.send("eth_accounts", []).then((accounts)=>{
            return accounts.map((a)=>this.formatter.address(a));
        });
    }
    send(method, params) {
        const request = {
            method: method,
            params: params,
            id: this._nextId++,
            jsonrpc: "2.0"
        };
        this.emit("debug", {
            action: "request",
            request: (0, $d2d9b472f7878d5e$exports.deepCopy)(request),
            provider: this
        });
        // We can expand this in the future to any call, but for now these
        // are the biggest wins and do not require any serializing parameters.
        const cache = [
            "eth_chainId",
            "eth_blockNumber"
        ].indexOf(method) >= 0;
        if (cache && this._cache[method]) return this._cache[method];
        const result = (0, $1f5b367caa9efc4a$exports.fetchJson)(this.connection, JSON.stringify(request), $9609e75996f2bd40$var$getResult).then((result)=>{
            this.emit("debug", {
                action: "response",
                request: request,
                response: result,
                provider: this
            });
            return result;
        }, (error)=>{
            this.emit("debug", {
                action: "response",
                error: error,
                request: request,
                provider: this
            });
            throw error;
        });
        // Cache the fetch, but clear it on the next event loop
        if (cache) {
            this._cache[method] = result;
            setTimeout(()=>{
                this._cache[method] = null;
            }, 0);
        }
        return result;
    }
    prepareRequest(method, params) {
        switch(method){
            case "getBlockNumber":
                return [
                    "eth_blockNumber",
                    []
                ];
            case "getGasPrice":
                return [
                    "eth_gasPrice",
                    []
                ];
            case "getBalance":
                return [
                    "eth_getBalance",
                    [
                        $9609e75996f2bd40$var$getLowerCase(params.address),
                        params.blockTag
                    ]
                ];
            case "getTransactionCount":
                return [
                    "eth_getTransactionCount",
                    [
                        $9609e75996f2bd40$var$getLowerCase(params.address),
                        params.blockTag
                    ]
                ];
            case "getCode":
                return [
                    "eth_getCode",
                    [
                        $9609e75996f2bd40$var$getLowerCase(params.address),
                        params.blockTag
                    ]
                ];
            case "getStorageAt":
                return [
                    "eth_getStorageAt",
                    [
                        $9609e75996f2bd40$var$getLowerCase(params.address),
                        (0, $06d75ae17ce69367$export$e9c46a54370b47e8)(params.position, 32),
                        params.blockTag
                    ]
                ];
            case "sendTransaction":
                return [
                    "eth_sendRawTransaction",
                    [
                        params.signedTransaction
                    ]
                ];
            case "getBlock":
                if (params.blockTag) return [
                    "eth_getBlockByNumber",
                    [
                        params.blockTag,
                        !!params.includeTransactions
                    ]
                ];
                else if (params.blockHash) return [
                    "eth_getBlockByHash",
                    [
                        params.blockHash,
                        !!params.includeTransactions
                    ]
                ];
                return null;
            case "getTransaction":
                return [
                    "eth_getTransactionByHash",
                    [
                        params.transactionHash
                    ]
                ];
            case "getTransactionReceipt":
                return [
                    "eth_getTransactionReceipt",
                    [
                        params.transactionHash
                    ]
                ];
            case "call":
                {
                    const hexlifyTransaction = (0, $d2d9b472f7878d5e$exports.getStatic)(this.constructor, "hexlifyTransaction");
                    return [
                        "eth_call",
                        [
                            hexlifyTransaction(params.transaction, {
                                from: true
                            }),
                            params.blockTag
                        ]
                    ];
                }
            case "estimateGas":
                {
                    const hexlifyTransaction = (0, $d2d9b472f7878d5e$exports.getStatic)(this.constructor, "hexlifyTransaction");
                    return [
                        "eth_estimateGas",
                        [
                            hexlifyTransaction(params.transaction, {
                                from: true
                            })
                        ]
                    ];
                }
            case "getLogs":
                if (params.filter && params.filter.address != null) params.filter.address = $9609e75996f2bd40$var$getLowerCase(params.filter.address);
                return [
                    "eth_getLogs",
                    [
                        params.filter
                    ]
                ];
            default:
                break;
        }
        return null;
    }
    perform(method, params) {
        return $9609e75996f2bd40$var$__awaiter(this, void 0, void 0, function*() {
            // Legacy networks do not like the type field being passed along (which
            // is fair), so we delete type if it is 0 and a non-EIP-1559 network
            if (method === "call" || method === "estimateGas") {
                const tx = params.transaction;
                if (tx && tx.type != null && (0, $a87aa97415e1b917$export$d97aa349ed20696).from(tx.type).isZero()) // If there are no EIP-1559 properties, it might be non-EIP-1559
                {
                    if (tx.maxFeePerGas == null && tx.maxPriorityFeePerGas == null) {
                        const feeData = yield this.getFeeData();
                        if (feeData.maxFeePerGas == null && feeData.maxPriorityFeePerGas == null) {
                            // Network doesn't know about EIP-1559 (and hence type)
                            params = (0, $d2d9b472f7878d5e$exports.shallowCopy)(params);
                            params.transaction = (0, $d2d9b472f7878d5e$exports.shallowCopy)(tx);
                            delete params.transaction.type;
                        }
                    }
                }
            }
            const args = this.prepareRequest(method, params);
            if (args == null) $9609e75996f2bd40$var$logger.throwError(method + " not implemented", (0, $5f596c9584f643ae$export$efa9a398d6368992).errors.NOT_IMPLEMENTED, {
                operation: method
            });
            try {
                return yield this.send(args[0], args[1]);
            } catch (error) {
                return $9609e75996f2bd40$var$checkError(method, error, params);
            }
        });
    }
    _startEvent(event) {
        if (event.tag === "pending") this._startPending();
        super._startEvent(event);
    }
    _startPending() {
        if (this._pendingFilter != null) return;
        const self = this;
        const pendingFilter = this.send("eth_newPendingTransactionFilter", []);
        this._pendingFilter = pendingFilter;
        pendingFilter.then(function(filterId) {
            function poll() {
                self.send("eth_getFilterChanges", [
                    filterId
                ]).then(function(hashes) {
                    if (self._pendingFilter != pendingFilter) return null;
                    let seq = Promise.resolve();
                    hashes.forEach(function(hash) {
                        // @TODO: This should be garbage collected at some point... How? When?
                        self._emitted["t:" + hash.toLowerCase()] = "pending";
                        seq = seq.then(function() {
                            return self.getTransaction(hash).then(function(tx) {
                                self.emit("pending", tx);
                                return null;
                            });
                        });
                    });
                    return seq.then(function() {
                        return $9609e75996f2bd40$var$timer(1000);
                    });
                }).then(function() {
                    if (self._pendingFilter != pendingFilter) {
                        self.send("eth_uninstallFilter", [
                            filterId
                        ]);
                        return;
                    }
                    setTimeout(function() {
                        poll();
                    }, 0);
                    return null;
                }).catch((error)=>{});
            }
            poll();
            return filterId;
        }).catch((error)=>{});
    }
    _stopEvent(event) {
        if (event.tag === "pending" && this.listenerCount("pending") === 0) this._pendingFilter = null;
        super._stopEvent(event);
    }
    // Convert an ethers.js transaction into a JSON-RPC transaction
    //  - gasLimit => gas
    //  - All values hexlified
    //  - All numeric values zero-striped
    //  - All addresses are lowercased
    // NOTE: This allows a TransactionRequest, but all values should be resolved
    //       before this is called
    // @TODO: This will likely be removed in future versions and prepareRequest
    //        will be the preferred method for this.
    static hexlifyTransaction(transaction, allowExtra) {
        // Check only allowed properties are given
        const allowed = (0, $d2d9b472f7878d5e$exports.shallowCopy)($9609e75996f2bd40$var$allowedTransactionKeys);
        if (allowExtra) {
            for(const key in allowExtra)if (allowExtra[key]) allowed[key] = true;
        }
        (0, $d2d9b472f7878d5e$exports.checkProperties)(transaction, allowed);
        const result = {};
        // JSON-RPC now requires numeric values to be "quantity" values
        [
            "chainId",
            "gasLimit",
            "gasPrice",
            "type",
            "maxFeePerGas",
            "maxPriorityFeePerGas",
            "nonce",
            "value"
        ].forEach(function(key) {
            if (transaction[key] == null) return;
            const value = (0, $06d75ae17ce69367$export$6916af760a341dd3)((0, $a87aa97415e1b917$export$d97aa349ed20696).from(transaction[key]));
            if (key === "gasLimit") key = "gas";
            result[key] = value;
        });
        [
            "from",
            "to",
            "data"
        ].forEach(function(key) {
            if (transaction[key] == null) return;
            result[key] = (0, $06d75ae17ce69367$export$2b0d6b5fbe698c70)(transaction[key]);
        });
        if (transaction.accessList) result["accessList"] = (0, $4335107f861a4482$export$6c8662b1600dce2)(transaction.accessList);
        return result;
    }
}




"use strict";
let $a5a739e019737409$export$3909fb301d3dc8c9 = null;
try {
    $a5a739e019737409$export$3909fb301d3dc8c9 = WebSocket;
    if ($a5a739e019737409$export$3909fb301d3dc8c9 == null) throw new Error("inject please");
} catch (error) {
    const logger = new (0, $5f596c9584f643ae$export$efa9a398d6368992)((0, $e9ed5b422bb4952f$export$83d89fbfd8236492));
    $a5a739e019737409$export$3909fb301d3dc8c9 = function() {
        logger.throwError("WebSockets not supported in this environment", (0, $5f596c9584f643ae$export$efa9a398d6368992).errors.UNSUPPORTED_OPERATION, {
            operation: "new WebSocket()"
        });
    };
}




"use strict";
var $d1a04efa16266f30$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
const $d1a04efa16266f30$var$logger = new (0, $5f596c9584f643ae$export$efa9a398d6368992)((0, $e9ed5b422bb4952f$export$83d89fbfd8236492));
/**
 *  Notes:
 *
 *  This provider differs a bit from the polling providers. One main
 *  difference is how it handles consistency. The polling providers
 *  will stall responses to ensure a consistent state, while this
 *  WebSocket provider assumes the connected backend will manage this.
 *
 *  For example, if a polling provider emits an event which indicates
 *  the event occurred in blockhash XXX, a call to fetch that block by
 *  its hash XXX, if not present will retry until it is present. This
 *  can occur when querying a pool of nodes that are mildly out of sync
 *  with each other.
 */ let $d1a04efa16266f30$var$NextId = 1;
class $d1a04efa16266f30$export$bfafe629242f30bd extends (0, $9609e75996f2bd40$exports.JsonRpcProvider) {
    constructor(url, network){
        // This will be added in the future; please open an issue to expedite
        if (network === "any") $d1a04efa16266f30$var$logger.throwError("WebSocketProvider does not support 'any' network yet", (0, $5f596c9584f643ae$export$efa9a398d6368992).errors.UNSUPPORTED_OPERATION, {
            operation: "network:any"
        });
        if (typeof url === "string") super(url, network);
        else super("_websocket", network);
        this._pollingInterval = -1;
        this._wsReady = false;
        if (typeof url === "string") (0, $d2d9b472f7878d5e$exports.defineReadOnly)(this, "_websocket", new (0, $a5a739e019737409$export$3909fb301d3dc8c9)(this.connection.url));
        else (0, $d2d9b472f7878d5e$exports.defineReadOnly)(this, "_websocket", url);
        (0, $d2d9b472f7878d5e$exports.defineReadOnly)(this, "_requests", {});
        (0, $d2d9b472f7878d5e$exports.defineReadOnly)(this, "_subs", {});
        (0, $d2d9b472f7878d5e$exports.defineReadOnly)(this, "_subIds", {});
        (0, $d2d9b472f7878d5e$exports.defineReadOnly)(this, "_detectNetwork", super.detectNetwork());
        // Stall sending requests until the socket is open...
        this.websocket.onopen = ()=>{
            this._wsReady = true;
            Object.keys(this._requests).forEach((id)=>{
                this.websocket.send(this._requests[id].payload);
            });
        };
        this.websocket.onmessage = (messageEvent)=>{
            const data = messageEvent.data;
            const result = JSON.parse(data);
            if (result.id != null) {
                const id = String(result.id);
                const request = this._requests[id];
                delete this._requests[id];
                if (result.result !== undefined) {
                    request.callback(null, result.result);
                    this.emit("debug", {
                        action: "response",
                        request: JSON.parse(request.payload),
                        response: result.result,
                        provider: this
                    });
                } else {
                    let error = null;
                    if (result.error) {
                        error = new Error(result.error.message || "unknown error");
                        (0, $d2d9b472f7878d5e$exports.defineReadOnly)(error, "code", result.error.code || null);
                        (0, $d2d9b472f7878d5e$exports.defineReadOnly)(error, "response", data);
                    } else error = new Error("unknown error");
                    request.callback(error, undefined);
                    this.emit("debug", {
                        action: "response",
                        error: error,
                        request: JSON.parse(request.payload),
                        provider: this
                    });
                }
            } else if (result.method === "eth_subscription") {
                // Subscription...
                const sub = this._subs[result.params.subscription];
                if (sub) //this.emit.apply(this,                  );
                sub.processFunc(result.params.result);
            } else console.warn("this should not happen");
        };
        // This Provider does not actually poll, but we want to trigger
        // poll events for things that depend on them (like stalling for
        // block and transaction lookups)
        const fauxPoll = setInterval(()=>{
            this.emit("poll");
        }, 1000);
        if (fauxPoll.unref) fauxPoll.unref();
    }
    // Cannot narrow the type of _websocket, as that is not backwards compatible
    // so we add a getter and let the WebSocket be a public API.
    get websocket() {
        return this._websocket;
    }
    detectNetwork() {
        return this._detectNetwork;
    }
    get pollingInterval() {
        return 0;
    }
    resetEventsBlock(blockNumber) {
        $d1a04efa16266f30$var$logger.throwError("cannot reset events block on WebSocketProvider", (0, $5f596c9584f643ae$export$efa9a398d6368992).errors.UNSUPPORTED_OPERATION, {
            operation: "resetEventBlock"
        });
    }
    set pollingInterval(value) {
        $d1a04efa16266f30$var$logger.throwError("cannot set polling interval on WebSocketProvider", (0, $5f596c9584f643ae$export$efa9a398d6368992).errors.UNSUPPORTED_OPERATION, {
            operation: "setPollingInterval"
        });
    }
    poll() {
        return $d1a04efa16266f30$var$__awaiter(this, void 0, void 0, function*() {
            return null;
        });
    }
    set polling(value) {
        if (!value) return;
        $d1a04efa16266f30$var$logger.throwError("cannot set polling on WebSocketProvider", (0, $5f596c9584f643ae$export$efa9a398d6368992).errors.UNSUPPORTED_OPERATION, {
            operation: "setPolling"
        });
    }
    send(method, params) {
        const rid = $d1a04efa16266f30$var$NextId++;
        return new Promise((resolve, reject)=>{
            function callback(error, result) {
                if (error) return reject(error);
                return resolve(result);
            }
            const payload = JSON.stringify({
                method: method,
                params: params,
                id: rid,
                jsonrpc: "2.0"
            });
            this.emit("debug", {
                action: "request",
                request: JSON.parse(payload),
                provider: this
            });
            this._requests[String(rid)] = {
                callback: callback,
                payload: payload
            };
            if (this._wsReady) this.websocket.send(payload);
        });
    }
    static defaultUrl() {
        return "ws://localhost:8546";
    }
    _subscribe(tag, param, processFunc) {
        return $d1a04efa16266f30$var$__awaiter(this, void 0, void 0, function*() {
            let subIdPromise = this._subIds[tag];
            if (subIdPromise == null) {
                subIdPromise = Promise.all(param).then((param)=>{
                    return this.send("eth_subscribe", param);
                });
                this._subIds[tag] = subIdPromise;
            }
            const subId = yield subIdPromise;
            this._subs[subId] = {
                tag: tag,
                processFunc: processFunc
            };
        });
    }
    _startEvent(event) {
        switch(event.type){
            case "block":
                this._subscribe("block", [
                    "newHeads"
                ], (result)=>{
                    const blockNumber = (0, $a87aa97415e1b917$export$d97aa349ed20696).from(result.number).toNumber();
                    this._emitted.block = blockNumber;
                    this.emit("block", blockNumber);
                });
                break;
            case "pending":
                this._subscribe("pending", [
                    "newPendingTransactions"
                ], (result)=>{
                    this.emit("pending", result);
                });
                break;
            case "filter":
                this._subscribe(event.tag, [
                    "logs",
                    this._getFilter(event.filter)
                ], (result)=>{
                    if (result.removed == null) result.removed = false;
                    this.emit(event.filter, this.formatter.filterLog(result));
                });
                break;
            case "tx":
                {
                    const emitReceipt = (event)=>{
                        const hash = event.hash;
                        this.getTransactionReceipt(hash).then((receipt)=>{
                            if (!receipt) return;
                            this.emit(hash, receipt);
                        });
                    };
                    // In case it is already mined
                    emitReceipt(event);
                    // To keep things simple, we start up a single newHeads subscription
                    // to keep an eye out for transactions we are watching for.
                    // Starting a subscription for an event (i.e. "tx") that is already
                    // running is (basically) a nop.
                    this._subscribe("tx", [
                        "newHeads"
                    ], (result)=>{
                        this._events.filter((e)=>e.type === "tx").forEach(emitReceipt);
                    });
                    break;
                }
            // Nothing is needed
            case "debug":
            case "poll":
            case "willPoll":
            case "didPoll":
            case "error":
                break;
            default:
                console.log("unhandled:", event);
                break;
        }
    }
    _stopEvent(event) {
        let tag = event.tag;
        if (event.type === "tx") {
            // There are remaining transaction event listeners
            if (this._events.filter((e)=>e.type === "tx").length) return;
            tag = "tx";
        } else if (this.listenerCount(event.event)) // There are remaining event listeners
        return;
        const subId = this._subIds[tag];
        if (!subId) return;
        delete this._subIds[tag];
        subId.then((subId)=>{
            if (!this._subs[subId]) return;
            delete this._subs[subId];
            this.send("eth_unsubscribe", [
                subId
            ]);
        });
    }
    destroy() {
        return $d1a04efa16266f30$var$__awaiter(this, void 0, void 0, function*() {
            // Wait until we have connected before trying to disconnect
            if (this.websocket.readyState === (0, $a5a739e019737409$export$3909fb301d3dc8c9).CONNECTING) yield new Promise((resolve)=>{
                this.websocket.onopen = function() {
                    resolve(true);
                };
                this.websocket.onerror = function() {
                    resolve(false);
                };
            });
            // Hangup
            // See: https://developer.mozilla.org/en-US/docs/Web/API/CloseEvent#Status_codes
            this.websocket.close(1000);
        });
    }
}




var $94a45602d091e5d2$exports = {};

$parcel$export($94a45602d091e5d2$exports, "StaticJsonRpcProvider", function () { return $94a45602d091e5d2$export$b3d647c1c29df44d; });
$parcel$export($94a45602d091e5d2$exports, "UrlJsonRpcProvider", function () { return $94a45602d091e5d2$export$664128d6239ccf96; });




"use strict";
var $94a45602d091e5d2$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
const $94a45602d091e5d2$var$logger = new (0, $5f596c9584f643ae$export$efa9a398d6368992)((0, $e9ed5b422bb4952f$export$83d89fbfd8236492));
class $94a45602d091e5d2$export$b3d647c1c29df44d extends (0, $9609e75996f2bd40$exports.JsonRpcProvider) {
    detectNetwork() {
        const _super = Object.create(null, {
            detectNetwork: {
                get: ()=>super.detectNetwork
            }
        });
        return $94a45602d091e5d2$var$__awaiter(this, void 0, void 0, function*() {
            let network = this.network;
            if (network == null) {
                network = yield _super.detectNetwork.call(this);
                if (!network) $94a45602d091e5d2$var$logger.throwError("no network detected", (0, $5f596c9584f643ae$export$efa9a398d6368992).errors.UNKNOWN_ERROR, {});
                // If still not set, set it
                if (this._network == null) {
                    // A static network does not support "any"
                    (0, $d2d9b472f7878d5e$exports.defineReadOnly)(this, "_network", network);
                    this.emit("network", network, null);
                }
            }
            return network;
        });
    }
}
class $94a45602d091e5d2$export$664128d6239ccf96 extends $94a45602d091e5d2$export$b3d647c1c29df44d {
    constructor(network, apiKey){
        $94a45602d091e5d2$var$logger.checkAbstract(new.target, $94a45602d091e5d2$export$664128d6239ccf96);
        // Normalize the Network and API Key
        network = (0, $d2d9b472f7878d5e$exports.getStatic)(new.target, "getNetwork")(network);
        apiKey = (0, $d2d9b472f7878d5e$exports.getStatic)(new.target, "getApiKey")(apiKey);
        const connection = (0, $d2d9b472f7878d5e$exports.getStatic)(new.target, "getUrl")(network, apiKey);
        super(connection, network);
        if (typeof apiKey === "string") (0, $d2d9b472f7878d5e$exports.defineReadOnly)(this, "apiKey", apiKey);
        else if (apiKey != null) Object.keys(apiKey).forEach((key)=>{
            (0, $d2d9b472f7878d5e$exports.defineReadOnly)(this, key, apiKey[key]);
        });
    }
    _startPending() {
        $94a45602d091e5d2$var$logger.warn("WARNING: API provider does not support pending filters");
    }
    isCommunityResource() {
        return false;
    }
    getSigner(address) {
        return $94a45602d091e5d2$var$logger.throwError("API provider does not support signing", (0, $5f596c9584f643ae$export$efa9a398d6368992).errors.UNSUPPORTED_OPERATION, {
            operation: "getSigner"
        });
    }
    listAccounts() {
        return Promise.resolve([]);
    }
    // Return a defaultApiKey if null, otherwise validate the API key
    static getApiKey(apiKey) {
        return apiKey;
    }
    // Returns the url or connection for the given network and API key. The
    // API key will have been sanitized by the getApiKey first, so any validation
    // or transformations can be done there.
    static getUrl(network, apiKey) {
        return $94a45602d091e5d2$var$logger.throwError("not implemented; sub-classes must override getUrl", (0, $5f596c9584f643ae$export$efa9a398d6368992).errors.NOT_IMPLEMENTED, {
            operation: "getUrl"
        });
    }
}


"use strict";
const $5142047284b3daba$var$logger = new (0, $5f596c9584f643ae$export$efa9a398d6368992)((0, $e9ed5b422bb4952f$export$83d89fbfd8236492));
// This key was provided to ethers.js by Alchemy to be used by the
// default provider, but it is recommended that for your own
// production environments, that you acquire your own API key at:
//   https://dashboard.alchemyapi.io
const $5142047284b3daba$var$defaultApiKey = "_gg7wSSi0KMBsdKnGVfHDueq6xMB9EkC";
class $5142047284b3daba$export$f6c13301c7b76371 extends (0, $d1a04efa16266f30$exports.WebSocketProvider) {
    constructor(network, apiKey){
        const provider = new $5142047284b3daba$export$999cc40da3fbc6f(network, apiKey);
        const url = provider.connection.url.replace(/^http/i, "ws").replace(".alchemyapi.", ".ws.alchemyapi.");
        super(url, provider.network);
        (0, $d2d9b472f7878d5e$exports.defineReadOnly)(this, "apiKey", provider.apiKey);
    }
    isCommunityResource() {
        return this.apiKey === $5142047284b3daba$var$defaultApiKey;
    }
}
class $5142047284b3daba$export$999cc40da3fbc6f extends (0, $94a45602d091e5d2$exports.UrlJsonRpcProvider) {
    static getWebSocketProvider(network, apiKey) {
        return new $5142047284b3daba$export$f6c13301c7b76371(network, apiKey);
    }
    static getApiKey(apiKey) {
        if (apiKey == null) return $5142047284b3daba$var$defaultApiKey;
        if (apiKey && typeof apiKey !== "string") $5142047284b3daba$var$logger.throwArgumentError("invalid apiKey", "apiKey", apiKey);
        return apiKey;
    }
    static getUrl(network, apiKey) {
        let host = null;
        switch(network.name){
            case "homestead":
                host = "eth-mainnet.alchemyapi.io/v2/";
                break;
            case "goerli":
                host = "eth-goerli.g.alchemy.com/v2/";
                break;
            case "matic":
                host = "polygon-mainnet.g.alchemy.com/v2/";
                break;
            case "maticmum":
                host = "polygon-mumbai.g.alchemy.com/v2/";
                break;
            case "arbitrum":
                host = "arb-mainnet.g.alchemy.com/v2/";
                break;
            case "arbitrum-goerli":
                host = "arb-goerli.g.alchemy.com/v2/";
                break;
            case "optimism":
                host = "opt-mainnet.g.alchemy.com/v2/";
                break;
            case "optimism-goerli":
                host = "opt-goerli.g.alchemy.com/v2/";
                break;
            default:
                $5142047284b3daba$var$logger.throwArgumentError("unsupported network", "network", arguments[0]);
        }
        return {
            allowGzip: true,
            url: "https://" + host + apiKey,
            throttleCallback: (attempt, url)=>{
                if (apiKey === $5142047284b3daba$var$defaultApiKey) (0, $23494291de5f329b$export$4c41bd49e82e82ab)();
                return Promise.resolve(true);
            }
        };
    }
    isCommunityResource() {
        return this.apiKey === $5142047284b3daba$var$defaultApiKey;
    }
}






const $27dd6519e1beec55$var$logger = new (0, $5f596c9584f643ae$export$efa9a398d6368992)((0, $e9ed5b422bb4952f$export$83d89fbfd8236492));
const $27dd6519e1beec55$var$defaultApiKey = "9f7d929b018cdffb338517efa06f58359e86ff1ffd350bc889738523659e7972";
function $27dd6519e1beec55$var$getHost(name) {
    switch(name){
        case "homestead":
            return "rpc.ankr.com/eth/";
        case "ropsten":
            return "rpc.ankr.com/eth_ropsten/";
        case "rinkeby":
            return "rpc.ankr.com/eth_rinkeby/";
        case "goerli":
            return "rpc.ankr.com/eth_goerli/";
        case "matic":
            return "rpc.ankr.com/polygon/";
        case "arbitrum":
            return "rpc.ankr.com/arbitrum/";
    }
    return $27dd6519e1beec55$var$logger.throwArgumentError("unsupported network", "name", name);
}
class $27dd6519e1beec55$export$72783b2aefa72a45 extends (0, $94a45602d091e5d2$exports.UrlJsonRpcProvider) {
    isCommunityResource() {
        return this.apiKey === $27dd6519e1beec55$var$defaultApiKey;
    }
    static getApiKey(apiKey) {
        if (apiKey == null) return $27dd6519e1beec55$var$defaultApiKey;
        return apiKey;
    }
    static getUrl(network, apiKey) {
        if (apiKey == null) apiKey = $27dd6519e1beec55$var$defaultApiKey;
        const connection = {
            allowGzip: true,
            url: "https://" + $27dd6519e1beec55$var$getHost(network.name) + apiKey,
            throttleCallback: (attempt, url)=>{
                if (apiKey.apiKey === $27dd6519e1beec55$var$defaultApiKey) (0, $23494291de5f329b$export$4c41bd49e82e82ab)();
                return Promise.resolve(true);
            }
        };
        if (apiKey.projectSecret != null) {
            connection.user = "";
            connection.password = apiKey.projectSecret;
        }
        return connection;
    }
}


var $819ad3a08ca08517$exports = {};

$parcel$export($819ad3a08ca08517$exports, "CloudflareProvider", function () { return $819ad3a08ca08517$export$7113381f8f264fc0; });



"use strict";
var $819ad3a08ca08517$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
const $819ad3a08ca08517$var$logger = new (0, $5f596c9584f643ae$export$efa9a398d6368992)((0, $e9ed5b422bb4952f$export$83d89fbfd8236492));
class $819ad3a08ca08517$export$7113381f8f264fc0 extends (0, $94a45602d091e5d2$exports.UrlJsonRpcProvider) {
    static getApiKey(apiKey) {
        if (apiKey != null) $819ad3a08ca08517$var$logger.throwArgumentError("apiKey not supported for cloudflare", "apiKey", apiKey);
        return null;
    }
    static getUrl(network, apiKey) {
        let host = null;
        switch(network.name){
            case "homestead":
                host = "https://cloudflare-eth.com/";
                break;
            default:
                $819ad3a08ca08517$var$logger.throwArgumentError("unsupported network", "network", arguments[0]);
        }
        return host;
    }
    perform(method, params) {
        const _super = Object.create(null, {
            perform: {
                get: ()=>super.perform
            }
        });
        return $819ad3a08ca08517$var$__awaiter(this, void 0, void 0, function*() {
            // The Cloudflare provider does not support eth_blockNumber,
            // so we get the latest block and pull it from that
            if (method === "getBlockNumber") {
                const block = yield _super.perform.call(this, "getBlock", {
                    blockTag: "latest"
                });
                return block.number;
            }
            return _super.perform.call(this, method, params);
        });
    }
}


var $dce3608ad1ddcc3f$exports = {};

$parcel$export($dce3608ad1ddcc3f$exports, "EtherscanProvider", function () { return $dce3608ad1ddcc3f$export$dd1d942a536c7912; });








"use strict";
var $dce3608ad1ddcc3f$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
const $dce3608ad1ddcc3f$var$logger = new (0, $5f596c9584f643ae$export$efa9a398d6368992)((0, $e9ed5b422bb4952f$export$83d89fbfd8236492));
// The transaction has already been sanitized by the calls in Provider
function $dce3608ad1ddcc3f$var$getTransactionPostData(transaction) {
    const result = {};
    for(let key in transaction){
        if (transaction[key] == null) continue;
        let value = transaction[key];
        if (key === "type" && value === 0) continue;
        // Quantity-types require no leading zero, unless 0
        if (({
            type: true,
            gasLimit: true,
            gasPrice: true,
            maxFeePerGs: true,
            maxPriorityFeePerGas: true,
            nonce: true,
            value: true
        })[key]) value = (0, $06d75ae17ce69367$export$6916af760a341dd3)((0, $06d75ae17ce69367$export$2b0d6b5fbe698c70)(value));
        else if (key === "accessList") value = "[" + (0, $4335107f861a4482$export$6c8662b1600dce2)(value).map((set)=>{
            return `{address:"${set.address}",storageKeys:["${set.storageKeys.join('","')}"]}`;
        }).join(",") + "]";
        else value = (0, $06d75ae17ce69367$export$2b0d6b5fbe698c70)(value);
        result[key] = value;
    }
    return result;
}
function $dce3608ad1ddcc3f$var$getResult(result) {
    // getLogs, getHistory have weird success responses
    if (result.status == 0 && (result.message === "No records found" || result.message === "No transactions found")) return result.result;
    if (result.status != 1 || typeof result.message !== "string" || !result.message.match(/^OK/)) {
        const error = new Error("invalid response");
        error.result = JSON.stringify(result);
        if ((result.result || "").toLowerCase().indexOf("rate limit") >= 0) error.throttleRetry = true;
        throw error;
    }
    return result.result;
}
function $dce3608ad1ddcc3f$var$getJsonResult(result) {
    // This response indicates we are being throttled
    if (result && result.status == 0 && result.message == "NOTOK" && (result.result || "").toLowerCase().indexOf("rate limit") >= 0) {
        const error = new Error("throttled response");
        error.result = JSON.stringify(result);
        error.throttleRetry = true;
        throw error;
    }
    if (result.jsonrpc != "2.0") {
        // @TODO: not any
        const error = new Error("invalid response");
        error.result = JSON.stringify(result);
        throw error;
    }
    if (result.error) {
        // @TODO: not any
        const error = new Error(result.error.message || "unknown error");
        if (result.error.code) error.code = result.error.code;
        if (result.error.data) error.data = result.error.data;
        throw error;
    }
    return result.result;
}
// The blockTag was normalized as a string by the Provider pre-perform operations
function $dce3608ad1ddcc3f$var$checkLogTag(blockTag) {
    if (blockTag === "pending") throw new Error("pending not supported");
    if (blockTag === "latest") return blockTag;
    return parseInt(blockTag.substring(2), 16);
}
function $dce3608ad1ddcc3f$var$checkError(method, error, transaction) {
    // Undo the "convenience" some nodes are attempting to prevent backwards
    // incompatibility; maybe for v6 consider forwarding reverts as errors
    if (method === "call" && error.code === (0, $5f596c9584f643ae$export$efa9a398d6368992).errors.SERVER_ERROR) {
        const e = error.error;
        // Etherscan keeps changing their string
        if (e && (e.message.match(/reverted/i) || e.message.match(/VM execution error/i))) {
            // Etherscan prefixes the data like "Reverted 0x1234"
            let data = e.data;
            if (data) data = "0x" + data.replace(/^.*0x/i, "");
            if ((0, $06d75ae17ce69367$export$b02a40aff8e4ad18)(data)) return data;
            $dce3608ad1ddcc3f$var$logger.throwError("missing revert data in call exception", (0, $5f596c9584f643ae$export$efa9a398d6368992).errors.CALL_EXCEPTION, {
                error: error,
                data: "0x"
            });
        }
    }
    // Get the message from any nested error structure
    let message = error.message;
    if (error.code === (0, $5f596c9584f643ae$export$efa9a398d6368992).errors.SERVER_ERROR) {
        if (error.error && typeof error.error.message === "string") message = error.error.message;
        else if (typeof error.body === "string") message = error.body;
        else if (typeof error.responseText === "string") message = error.responseText;
    }
    message = (message || "").toLowerCase();
    // "Insufficient funds. The account you tried to send transaction from does not have enough funds. Required 21464000000000 and got: 0"
    if (message.match(/insufficient funds/)) $dce3608ad1ddcc3f$var$logger.throwError("insufficient funds for intrinsic transaction cost", (0, $5f596c9584f643ae$export$efa9a398d6368992).errors.INSUFFICIENT_FUNDS, {
        error: error,
        method: method,
        transaction: transaction
    });
    // "Transaction with the same hash was already imported."
    if (message.match(/same hash was already imported|transaction nonce is too low|nonce too low/)) $dce3608ad1ddcc3f$var$logger.throwError("nonce has already been used", (0, $5f596c9584f643ae$export$efa9a398d6368992).errors.NONCE_EXPIRED, {
        error: error,
        method: method,
        transaction: transaction
    });
    // "Transaction gas price is too low. There is another transaction with same nonce in the queue. Try increasing the gas price or incrementing the nonce."
    if (message.match(/another transaction with same nonce/)) $dce3608ad1ddcc3f$var$logger.throwError("replacement fee too low", (0, $5f596c9584f643ae$export$efa9a398d6368992).errors.REPLACEMENT_UNDERPRICED, {
        error: error,
        method: method,
        transaction: transaction
    });
    if (message.match(/execution failed due to an exception|execution reverted/)) $dce3608ad1ddcc3f$var$logger.throwError("cannot estimate gas; transaction may fail or may require manual gas limit", (0, $5f596c9584f643ae$export$efa9a398d6368992).errors.UNPREDICTABLE_GAS_LIMIT, {
        error: error,
        method: method,
        transaction: transaction
    });
    throw error;
}
class $dce3608ad1ddcc3f$export$dd1d942a536c7912 extends (0, $fa2219aa02c3e62e$exports.BaseProvider) {
    constructor(network, apiKey){
        super(network);
        (0, $d2d9b472f7878d5e$exports.defineReadOnly)(this, "baseUrl", this.getBaseUrl());
        (0, $d2d9b472f7878d5e$exports.defineReadOnly)(this, "apiKey", apiKey || null);
    }
    getBaseUrl() {
        switch(this.network ? this.network.name : "invalid"){
            case "homestead":
                return "https://api.etherscan.io";
            case "goerli":
                return "https://api-goerli.etherscan.io";
            case "sepolia":
                return "https://api-sepolia.etherscan.io";
            case "matic":
                return "https://api.polygonscan.com";
            case "maticmum":
                return "https://api-testnet.polygonscan.com";
            case "arbitrum":
                return "https://api.arbiscan.io";
            case "arbitrum-goerli":
                return "https://api-goerli.arbiscan.io";
            case "optimism":
                return "https://api-optimistic.etherscan.io";
            case "optimism-goerli":
                return "https://api-goerli-optimistic.etherscan.io";
            default:
        }
        return $dce3608ad1ddcc3f$var$logger.throwArgumentError("unsupported network", "network", this.network.name);
    }
    getUrl(module, params) {
        const query = Object.keys(params).reduce((accum, key)=>{
            const value = params[key];
            if (value != null) accum += `&${key}=${value}`;
            return accum;
        }, "");
        const apiKey = this.apiKey ? `&apikey=${this.apiKey}` : "";
        return `${this.baseUrl}/api?module=${module}${query}${apiKey}`;
    }
    getPostUrl() {
        return `${this.baseUrl}/api`;
    }
    getPostData(module, params) {
        params.module = module;
        params.apikey = this.apiKey;
        return params;
    }
    fetch(module, params, post) {
        return $dce3608ad1ddcc3f$var$__awaiter(this, void 0, void 0, function*() {
            const url = post ? this.getPostUrl() : this.getUrl(module, params);
            const payload = post ? this.getPostData(module, params) : null;
            const procFunc = module === "proxy" ? $dce3608ad1ddcc3f$var$getJsonResult : $dce3608ad1ddcc3f$var$getResult;
            this.emit("debug", {
                action: "request",
                request: url,
                provider: this
            });
            const connection = {
                url: url,
                throttleSlotInterval: 1000,
                throttleCallback: (attempt, url)=>{
                    if (this.isCommunityResource()) (0, $23494291de5f329b$export$4c41bd49e82e82ab)();
                    return Promise.resolve(true);
                }
            };
            let payloadStr = null;
            if (payload) {
                connection.headers = {
                    "content-type": "application/x-www-form-urlencoded; charset=UTF-8"
                };
                payloadStr = Object.keys(payload).map((key)=>{
                    return `${key}=${payload[key]}`;
                }).join("&");
            }
            const result = yield (0, $1f5b367caa9efc4a$exports.fetchJson)(connection, payloadStr, procFunc || $dce3608ad1ddcc3f$var$getJsonResult);
            this.emit("debug", {
                action: "response",
                request: url,
                response: (0, $d2d9b472f7878d5e$exports.deepCopy)(result),
                provider: this
            });
            return result;
        });
    }
    detectNetwork() {
        return $dce3608ad1ddcc3f$var$__awaiter(this, void 0, void 0, function*() {
            return this.network;
        });
    }
    perform(method, params) {
        const _super = Object.create(null, {
            perform: {
                get: ()=>super.perform
            }
        });
        return $dce3608ad1ddcc3f$var$__awaiter(this, void 0, void 0, function*() {
            switch(method){
                case "getBlockNumber":
                    return this.fetch("proxy", {
                        action: "eth_blockNumber"
                    });
                case "getGasPrice":
                    return this.fetch("proxy", {
                        action: "eth_gasPrice"
                    });
                case "getBalance":
                    // Returns base-10 result
                    return this.fetch("account", {
                        action: "balance",
                        address: params.address,
                        tag: params.blockTag
                    });
                case "getTransactionCount":
                    return this.fetch("proxy", {
                        action: "eth_getTransactionCount",
                        address: params.address,
                        tag: params.blockTag
                    });
                case "getCode":
                    return this.fetch("proxy", {
                        action: "eth_getCode",
                        address: params.address,
                        tag: params.blockTag
                    });
                case "getStorageAt":
                    return this.fetch("proxy", {
                        action: "eth_getStorageAt",
                        address: params.address,
                        position: params.position,
                        tag: params.blockTag
                    });
                case "sendTransaction":
                    return this.fetch("proxy", {
                        action: "eth_sendRawTransaction",
                        hex: params.signedTransaction
                    }, true).catch((error)=>{
                        return $dce3608ad1ddcc3f$var$checkError("sendTransaction", error, params.signedTransaction);
                    });
                case "getBlock":
                    if (params.blockTag) return this.fetch("proxy", {
                        action: "eth_getBlockByNumber",
                        tag: params.blockTag,
                        boolean: params.includeTransactions ? "true" : "false"
                    });
                    throw new Error("getBlock by blockHash not implemented");
                case "getTransaction":
                    return this.fetch("proxy", {
                        action: "eth_getTransactionByHash",
                        txhash: params.transactionHash
                    });
                case "getTransactionReceipt":
                    return this.fetch("proxy", {
                        action: "eth_getTransactionReceipt",
                        txhash: params.transactionHash
                    });
                case "call":
                    {
                        if (params.blockTag !== "latest") throw new Error("EtherscanProvider does not support blockTag for call");
                        const postData = $dce3608ad1ddcc3f$var$getTransactionPostData(params.transaction);
                        postData.module = "proxy";
                        postData.action = "eth_call";
                        try {
                            return yield this.fetch("proxy", postData, true);
                        } catch (error) {
                            return $dce3608ad1ddcc3f$var$checkError("call", error, params.transaction);
                        }
                    }
                case "estimateGas":
                    {
                        const postData = $dce3608ad1ddcc3f$var$getTransactionPostData(params.transaction);
                        postData.module = "proxy";
                        postData.action = "eth_estimateGas";
                        try {
                            return yield this.fetch("proxy", postData, true);
                        } catch (error) {
                            return $dce3608ad1ddcc3f$var$checkError("estimateGas", error, params.transaction);
                        }
                    }
                case "getLogs":
                    {
                        const args = {
                            action: "getLogs"
                        };
                        if (params.filter.fromBlock) args.fromBlock = $dce3608ad1ddcc3f$var$checkLogTag(params.filter.fromBlock);
                        if (params.filter.toBlock) args.toBlock = $dce3608ad1ddcc3f$var$checkLogTag(params.filter.toBlock);
                        if (params.filter.address) args.address = params.filter.address;
                        // @TODO: We can handle slightly more complicated logs using the logs API
                        if (params.filter.topics && params.filter.topics.length > 0) {
                            if (params.filter.topics.length > 1) $dce3608ad1ddcc3f$var$logger.throwError("unsupported topic count", (0, $5f596c9584f643ae$export$efa9a398d6368992).errors.UNSUPPORTED_OPERATION, {
                                topics: params.filter.topics
                            });
                            if (params.filter.topics.length === 1) {
                                const topic0 = params.filter.topics[0];
                                if (typeof topic0 !== "string" || topic0.length !== 66) $dce3608ad1ddcc3f$var$logger.throwError("unsupported topic format", (0, $5f596c9584f643ae$export$efa9a398d6368992).errors.UNSUPPORTED_OPERATION, {
                                    topic0: topic0
                                });
                                args.topic0 = topic0;
                            }
                        }
                        const logs = yield this.fetch("logs", args);
                        // Cache txHash => blockHash
                        let blocks = {};
                        // Add any missing blockHash to the logs
                        for(let i = 0; i < logs.length; i++){
                            const log = logs[i];
                            if (log.blockHash != null) continue;
                            if (blocks[log.blockNumber] == null) {
                                const block = yield this.getBlock(log.blockNumber);
                                if (block) blocks[log.blockNumber] = block.hash;
                            }
                            log.blockHash = blocks[log.blockNumber];
                        }
                        return logs;
                    }
                case "getEtherPrice":
                    if (this.network.name !== "homestead") return 0.0;
                    return parseFloat((yield this.fetch("stats", {
                        action: "ethprice"
                    })).ethusd);
                default:
                    break;
            }
            return _super.perform.call(this, method, params);
        });
    }
    // Note: The `page` page parameter only allows pagination within the
    //       10,000 window available without a page and offset parameter
    //       Error: Result window is too large, PageNo x Offset size must
    //              be less than or equal to 10000
    getHistory(addressOrName, startBlock, endBlock) {
        return $dce3608ad1ddcc3f$var$__awaiter(this, void 0, void 0, function*() {
            const params = {
                action: "txlist",
                address: yield this.resolveName(addressOrName),
                startblock: startBlock == null ? 0 : startBlock,
                endblock: endBlock == null ? 99999999 : endBlock,
                sort: "asc"
            };
            const result = yield this.fetch("account", params);
            return result.map((tx)=>{
                [
                    "contractAddress",
                    "to"
                ].forEach(function(key) {
                    if (tx[key] == "") delete tx[key];
                });
                if (tx.creates == null && tx.contractAddress != null) tx.creates = tx.contractAddress;
                const item = this.formatter.transactionResponse(tx);
                if (tx.timeStamp) item.timestamp = parseInt(tx.timeStamp);
                return item;
            });
        });
    }
    isCommunityResource() {
        return this.apiKey == null;
    }
}


var $679b99176172981c$exports = {};

$parcel$export($679b99176172981c$exports, "FallbackProvider", function () { return $679b99176172981c$export$cb1d0beacb55feb7; });




"use strict";
function $7efaf3cc8a62189f$export$e6c7296801b9b341(array) {
    array = array.slice();
    for(let i = array.length - 1; i > 0; i--){
        const j = Math.floor(Math.random() * (i + 1));
        const tmp = array[i];
        array[i] = array[j];
        array[j] = tmp;
    }
    return array;
}







"use strict";
var $679b99176172981c$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
const $679b99176172981c$var$logger = new (0, $5f596c9584f643ae$export$efa9a398d6368992)((0, $e9ed5b422bb4952f$export$83d89fbfd8236492));
function $679b99176172981c$var$now() {
    return new Date().getTime();
}
// Returns to network as long as all agree, or null if any is null.
// Throws an error if any two networks do not match.
function $679b99176172981c$var$checkNetworks(networks) {
    let result = null;
    for(let i = 0; i < networks.length; i++){
        const network = networks[i];
        // Null! We do not know our network; bail.
        if (network == null) return null;
        if (result) // Make sure the network matches the previous networks
        {
            if (!(result.name === network.name && result.chainId === network.chainId && (result.ensAddress === network.ensAddress || result.ensAddress == null && network.ensAddress == null))) $679b99176172981c$var$logger.throwArgumentError("provider mismatch", "networks", networks);
        } else result = network;
    }
    return result;
}
function $679b99176172981c$var$median(values, maxDelta) {
    values = values.slice().sort();
    const middle = Math.floor(values.length / 2);
    // Odd length; take the middle
    if (values.length % 2) return values[middle];
    // Even length; take the average of the two middle
    const a = values[middle - 1], b = values[middle];
    if (maxDelta != null && Math.abs(a - b) > maxDelta) return null;
    return (a + b) / 2;
}
function $679b99176172981c$var$serialize(value) {
    if (value === null) return "null";
    else if (typeof value === "number" || typeof value === "boolean") return JSON.stringify(value);
    else if (typeof value === "string") return value;
    else if ((0, $a87aa97415e1b917$export$d97aa349ed20696).isBigNumber(value)) return value.toString();
    else if (Array.isArray(value)) return JSON.stringify(value.map((i)=>$679b99176172981c$var$serialize(i)));
    else if (typeof value === "object") {
        const keys = Object.keys(value);
        keys.sort();
        return "{" + keys.map((key)=>{
            let v = value[key];
            if (typeof v === "function") v = "[function]";
            else v = $679b99176172981c$var$serialize(v);
            return JSON.stringify(key) + ":" + v;
        }).join(",") + "}";
    }
    throw new Error("unknown value type: " + typeof value);
}
// Next request ID to use for emitting debug info
let $679b99176172981c$var$nextRid = 1;
function $679b99176172981c$var$stall(duration) {
    let cancel = null;
    let timer = null;
    let promise = new Promise((resolve)=>{
        cancel = function() {
            if (timer) {
                clearTimeout(timer);
                timer = null;
            }
            resolve();
        };
        timer = setTimeout(cancel, duration);
    });
    const wait = (func)=>{
        promise = promise.then(func);
        return promise;
    };
    function getPromise() {
        return promise;
    }
    return {
        cancel: cancel,
        getPromise: getPromise,
        wait: wait
    };
}
const $679b99176172981c$var$ForwardErrors = [
    (0, $5f596c9584f643ae$export$efa9a398d6368992).errors.CALL_EXCEPTION,
    (0, $5f596c9584f643ae$export$efa9a398d6368992).errors.INSUFFICIENT_FUNDS,
    (0, $5f596c9584f643ae$export$efa9a398d6368992).errors.NONCE_EXPIRED,
    (0, $5f596c9584f643ae$export$efa9a398d6368992).errors.REPLACEMENT_UNDERPRICED,
    (0, $5f596c9584f643ae$export$efa9a398d6368992).errors.UNPREDICTABLE_GAS_LIMIT
];
const $679b99176172981c$var$ForwardProperties = [
    "address",
    "args",
    "errorArgs",
    "errorSignature",
    "method",
    "transaction"
];
function $679b99176172981c$var$exposeDebugConfig(config, now) {
    const result = {
        weight: config.weight
    };
    Object.defineProperty(result, "provider", {
        get: ()=>config.provider
    });
    if (config.start) result.start = config.start;
    if (now) result.duration = now - config.start;
    if (config.done) {
        if (config.error) result.error = config.error;
        else result.result = config.result || null;
    }
    return result;
}
function $679b99176172981c$var$normalizedTally(normalize, quorum) {
    return function(configs) {
        // Count the votes for each result
        const tally = {};
        configs.forEach((c)=>{
            const value = normalize(c.result);
            if (!tally[value]) tally[value] = {
                count: 0,
                result: c.result
            };
            tally[value].count++;
        });
        // Check for a quorum on any given result
        const keys = Object.keys(tally);
        for(let i = 0; i < keys.length; i++){
            const check = tally[keys[i]];
            if (check.count >= quorum) return check.result;
        }
        // No quroum
        return undefined;
    };
}
function $679b99176172981c$var$getProcessFunc(provider, method, params) {
    let normalize = $679b99176172981c$var$serialize;
    switch(method){
        case "getBlockNumber":
            // Return the median value, unless there is (median + 1) is also
            // present, in which case that is probably true and the median
            // is going to be stale soon. In the event of a malicious node,
            // the lie will be true soon enough.
            return function(configs) {
                const values = configs.map((c)=>c.result);
                // Get the median block number
                let blockNumber = $679b99176172981c$var$median(configs.map((c)=>c.result), 2);
                if (blockNumber == null) return undefined;
                blockNumber = Math.ceil(blockNumber);
                // If the next block height is present, its prolly safe to use
                if (values.indexOf(blockNumber + 1) >= 0) blockNumber++;
                // Don't ever roll back the blockNumber
                if (blockNumber >= provider._highestBlockNumber) provider._highestBlockNumber = blockNumber;
                return provider._highestBlockNumber;
            };
        case "getGasPrice":
            // Return the middle (round index up) value, similar to median
            // but do not average even entries and choose the higher.
            // Malicious actors must compromise 50% of the nodes to lie.
            return function(configs) {
                const values = configs.map((c)=>c.result);
                values.sort();
                return values[Math.floor(values.length / 2)];
            };
        case "getEtherPrice":
            // Returns the median price. Malicious actors must compromise at
            // least 50% of the nodes to lie (in a meaningful way).
            return function(configs) {
                return $679b99176172981c$var$median(configs.map((c)=>c.result));
            };
        // No additional normalizing required; serialize is enough
        case "getBalance":
        case "getTransactionCount":
        case "getCode":
        case "getStorageAt":
        case "call":
        case "estimateGas":
        case "getLogs":
            break;
        // We drop the confirmations from transactions as it is approximate
        case "getTransaction":
        case "getTransactionReceipt":
            normalize = function(tx) {
                if (tx == null) return null;
                tx = (0, $d2d9b472f7878d5e$exports.shallowCopy)(tx);
                tx.confirmations = -1;
                return $679b99176172981c$var$serialize(tx);
            };
            break;
        // We drop the confirmations from transactions as it is approximate
        case "getBlock":
            // We drop the confirmations from transactions as it is approximate
            if (params.includeTransactions) normalize = function(block) {
                if (block == null) return null;
                block = (0, $d2d9b472f7878d5e$exports.shallowCopy)(block);
                block.transactions = block.transactions.map((tx)=>{
                    tx = (0, $d2d9b472f7878d5e$exports.shallowCopy)(tx);
                    tx.confirmations = -1;
                    return tx;
                });
                return $679b99176172981c$var$serialize(block);
            };
            else normalize = function(block) {
                if (block == null) return null;
                return $679b99176172981c$var$serialize(block);
            };
            break;
        default:
            throw new Error("unknown method: " + method);
    }
    // Return the result if and only if the expected quorum is
    // satisfied and agreed upon for the final result.
    return $679b99176172981c$var$normalizedTally(normalize, provider.quorum);
}
// If we are doing a blockTag query, we need to make sure the backend is
// caught up to the FallbackProvider, before sending a request to it.
function $679b99176172981c$var$waitForSync(config, blockNumber) {
    return $679b99176172981c$var$__awaiter(this, void 0, void 0, function*() {
        const provider = config.provider;
        if (provider.blockNumber != null && provider.blockNumber >= blockNumber || blockNumber === -1) return provider;
        return (0, $1f5b367caa9efc4a$exports.poll)(()=>{
            return new Promise((resolve, reject)=>{
                setTimeout(function() {
                    // We are synced
                    if (provider.blockNumber >= blockNumber) return resolve(provider);
                    // We're done; just quit
                    if (config.cancelled) return resolve(null);
                    // Try again, next block
                    return resolve(undefined);
                }, 0);
            });
        }, {
            oncePoll: provider
        });
    });
}
function $679b99176172981c$var$getRunner(config, currentBlockNumber, method, params) {
    return $679b99176172981c$var$__awaiter(this, void 0, void 0, function*() {
        let provider = config.provider;
        switch(method){
            case "getBlockNumber":
            case "getGasPrice":
                return provider[method]();
            case "getEtherPrice":
                if (provider.getEtherPrice) return provider.getEtherPrice();
                break;
            case "getBalance":
            case "getTransactionCount":
            case "getCode":
                if (params.blockTag && (0, $06d75ae17ce69367$export$b02a40aff8e4ad18)(params.blockTag)) provider = yield $679b99176172981c$var$waitForSync(config, currentBlockNumber);
                return provider[method](params.address, params.blockTag || "latest");
            case "getStorageAt":
                if (params.blockTag && (0, $06d75ae17ce69367$export$b02a40aff8e4ad18)(params.blockTag)) provider = yield $679b99176172981c$var$waitForSync(config, currentBlockNumber);
                return provider.getStorageAt(params.address, params.position, params.blockTag || "latest");
            case "getBlock":
                if (params.blockTag && (0, $06d75ae17ce69367$export$b02a40aff8e4ad18)(params.blockTag)) provider = yield $679b99176172981c$var$waitForSync(config, currentBlockNumber);
                return provider[params.includeTransactions ? "getBlockWithTransactions" : "getBlock"](params.blockTag || params.blockHash);
            case "call":
            case "estimateGas":
                if (params.blockTag && (0, $06d75ae17ce69367$export$b02a40aff8e4ad18)(params.blockTag)) provider = yield $679b99176172981c$var$waitForSync(config, currentBlockNumber);
                if (method === "call" && params.blockTag) return provider[method](params.transaction, params.blockTag);
                return provider[method](params.transaction);
            case "getTransaction":
            case "getTransactionReceipt":
                return provider[method](params.transactionHash);
            case "getLogs":
                {
                    let filter = params.filter;
                    if (filter.fromBlock && (0, $06d75ae17ce69367$export$b02a40aff8e4ad18)(filter.fromBlock) || filter.toBlock && (0, $06d75ae17ce69367$export$b02a40aff8e4ad18)(filter.toBlock)) provider = yield $679b99176172981c$var$waitForSync(config, currentBlockNumber);
                    return provider.getLogs(filter);
                }
        }
        return $679b99176172981c$var$logger.throwError("unknown method error", (0, $5f596c9584f643ae$export$efa9a398d6368992).errors.UNKNOWN_ERROR, {
            method: method,
            params: params
        });
    });
}
class $679b99176172981c$export$cb1d0beacb55feb7 extends (0, $fa2219aa02c3e62e$exports.BaseProvider) {
    constructor(providers, quorum){
        if (providers.length === 0) $679b99176172981c$var$logger.throwArgumentError("missing providers", "providers", providers);
        const providerConfigs = providers.map((configOrProvider, index)=>{
            if ((0, $9f78b76a8aa61745$exports.Provider).isProvider(configOrProvider)) {
                const stallTimeout = (0, $23494291de5f329b$export$d93d5f61c2498b6)(configOrProvider) ? 2000 : 750;
                const priority = 1;
                return Object.freeze({
                    provider: configOrProvider,
                    weight: 1,
                    stallTimeout: stallTimeout,
                    priority: priority
                });
            }
            const config = (0, $d2d9b472f7878d5e$exports.shallowCopy)(configOrProvider);
            if (config.priority == null) config.priority = 1;
            if (config.stallTimeout == null) config.stallTimeout = (0, $23494291de5f329b$export$d93d5f61c2498b6)(configOrProvider) ? 2000 : 750;
            if (config.weight == null) config.weight = 1;
            const weight = config.weight;
            if (weight % 1 || weight > 512 || weight < 1) $679b99176172981c$var$logger.throwArgumentError("invalid weight; must be integer in [1, 512]", `providers[${index}].weight`, weight);
            return Object.freeze(config);
        });
        const total = providerConfigs.reduce((accum, c)=>accum + c.weight, 0);
        if (quorum == null) quorum = total / 2;
        else if (quorum > total) $679b99176172981c$var$logger.throwArgumentError("quorum will always fail; larger than total weight", "quorum", quorum);
        // Are all providers' networks are known
        let networkOrReady = $679b99176172981c$var$checkNetworks(providerConfigs.map((c)=>c.provider.network));
        // Not all networks are known; we must stall
        if (networkOrReady == null) networkOrReady = new Promise((resolve, reject)=>{
            setTimeout(()=>{
                this.detectNetwork().then(resolve, reject);
            }, 0);
        });
        super(networkOrReady);
        // Preserve a copy, so we do not get mutated
        (0, $d2d9b472f7878d5e$exports.defineReadOnly)(this, "providerConfigs", Object.freeze(providerConfigs));
        (0, $d2d9b472f7878d5e$exports.defineReadOnly)(this, "quorum", quorum);
        this._highestBlockNumber = -1;
    }
    detectNetwork() {
        return $679b99176172981c$var$__awaiter(this, void 0, void 0, function*() {
            const networks = yield Promise.all(this.providerConfigs.map((c)=>c.provider.getNetwork()));
            return $679b99176172981c$var$checkNetworks(networks);
        });
    }
    perform(method, params) {
        return $679b99176172981c$var$__awaiter(this, void 0, void 0, function*() {
            // Sending transactions is special; always broadcast it to all backends
            if (method === "sendTransaction") {
                const results = yield Promise.all(this.providerConfigs.map((c)=>{
                    return c.provider.sendTransaction(params.signedTransaction).then((result)=>{
                        return result.hash;
                    }, (error)=>{
                        return error;
                    });
                }));
                // Any success is good enough (other errors are likely "already seen" errors
                for(let i = 0; i < results.length; i++){
                    const result = results[i];
                    if (typeof result === "string") return result;
                }
                // They were all an error; pick the first error
                throw results[0];
            }
            // We need to make sure we are in sync with our backends, so we need
            // to know this before we can make a lot of calls
            if (this._highestBlockNumber === -1 && method !== "getBlockNumber") yield this.getBlockNumber();
            const processFunc = $679b99176172981c$var$getProcessFunc(this, method, params);
            // Shuffle the providers and then sort them by their priority; we
            // shallowCopy them since we will store the result in them too
            const configs = (0, $7efaf3cc8a62189f$export$e6c7296801b9b341)(this.providerConfigs.map((0, $d2d9b472f7878d5e$exports.shallowCopy)));
            configs.sort((a, b)=>a.priority - b.priority);
            const currentBlockNumber = this._highestBlockNumber;
            let i = 0;
            let first = true;
            while(true){
                const t0 = $679b99176172981c$var$now();
                // Compute the inflight weight (exclude anything past)
                let inflightWeight = configs.filter((c)=>c.runner && t0 - c.start < c.stallTimeout).reduce((accum, c)=>accum + c.weight, 0);
                // Start running enough to meet quorum
                while(inflightWeight < this.quorum && i < configs.length){
                    const config = configs[i++];
                    const rid = $679b99176172981c$var$nextRid++;
                    config.start = $679b99176172981c$var$now();
                    config.staller = $679b99176172981c$var$stall(config.stallTimeout);
                    config.staller.wait(()=>{
                        config.staller = null;
                    });
                    config.runner = $679b99176172981c$var$getRunner(config, currentBlockNumber, method, params).then((result)=>{
                        config.done = true;
                        config.result = result;
                        if (this.listenerCount("debug")) this.emit("debug", {
                            action: "request",
                            rid: rid,
                            backend: $679b99176172981c$var$exposeDebugConfig(config, $679b99176172981c$var$now()),
                            request: {
                                method: method,
                                params: (0, $d2d9b472f7878d5e$exports.deepCopy)(params)
                            },
                            provider: this
                        });
                    }, (error)=>{
                        config.done = true;
                        config.error = error;
                        if (this.listenerCount("debug")) this.emit("debug", {
                            action: "request",
                            rid: rid,
                            backend: $679b99176172981c$var$exposeDebugConfig(config, $679b99176172981c$var$now()),
                            request: {
                                method: method,
                                params: (0, $d2d9b472f7878d5e$exports.deepCopy)(params)
                            },
                            provider: this
                        });
                    });
                    if (this.listenerCount("debug")) this.emit("debug", {
                        action: "request",
                        rid: rid,
                        backend: $679b99176172981c$var$exposeDebugConfig(config, null),
                        request: {
                            method: method,
                            params: (0, $d2d9b472f7878d5e$exports.deepCopy)(params)
                        },
                        provider: this
                    });
                    inflightWeight += config.weight;
                }
                // Wait for anything meaningful to finish or stall out
                const waiting = [];
                configs.forEach((c)=>{
                    if (c.done || !c.runner) return;
                    waiting.push(c.runner);
                    if (c.staller) waiting.push(c.staller.getPromise());
                });
                if (waiting.length) yield Promise.race(waiting);
                // Check the quorum and process the results; the process function
                // may additionally decide the quorum is not met
                const results = configs.filter((c)=>c.done && c.error == null);
                if (results.length >= this.quorum) {
                    const result = processFunc(results);
                    if (result !== undefined) {
                        // Shut down any stallers
                        configs.forEach((c)=>{
                            if (c.staller) c.staller.cancel();
                            c.cancelled = true;
                        });
                        return result;
                    }
                    if (!first) yield $679b99176172981c$var$stall(100).getPromise();
                    first = false;
                }
                // No result, check for errors that should be forwarded
                const errors = configs.reduce((accum, c)=>{
                    if (!c.done || c.error == null) return accum;
                    const code = c.error.code;
                    if ($679b99176172981c$var$ForwardErrors.indexOf(code) >= 0) {
                        if (!accum[code]) accum[code] = {
                            error: c.error,
                            weight: 0
                        };
                        accum[code].weight += c.weight;
                    }
                    return accum;
                }, {});
                Object.keys(errors).forEach((errorCode)=>{
                    const tally = errors[errorCode];
                    if (tally.weight < this.quorum) return;
                    // Shut down any stallers
                    configs.forEach((c)=>{
                        if (c.staller) c.staller.cancel();
                        c.cancelled = true;
                    });
                    const e = tally.error;
                    const props = {};
                    $679b99176172981c$var$ForwardProperties.forEach((name)=>{
                        if (e[name] == null) return;
                        props[name] = e[name];
                    });
                    $679b99176172981c$var$logger.throwError(e.reason || e.message, errorCode, props);
                });
                // All configs have run to completion; we will never get more data
                if (configs.filter((c)=>!c.done).length === 0) break;
            }
            // Shut down any stallers; shouldn't be any
            configs.forEach((c)=>{
                if (c.staller) c.staller.cancel();
                c.cancelled = true;
            });
            return $679b99176172981c$var$logger.throwError("failed to meet quorum", (0, $5f596c9584f643ae$export$efa9a398d6368992).errors.SERVER_ERROR, {
                method: method,
                params: params,
                //results: configs.map((c) => c.result),
                //errors: configs.map((c) => c.error),
                results: configs.map((c)=>$679b99176172981c$var$exposeDebugConfig(c)),
                provider: this
            });
        });
    }
}


"use strict";
const $f8338370fa8a55b7$export$fbe151f90a1ece01 = null;








"use strict";
const $2f517ba1fc7b9c0f$var$logger = new (0, $5f596c9584f643ae$export$efa9a398d6368992)((0, $e9ed5b422bb4952f$export$83d89fbfd8236492));
const $2f517ba1fc7b9c0f$var$defaultProjectId = "84842078b09946638c03157f83405213";
class $2f517ba1fc7b9c0f$export$dd168a807d60da4f extends (0, $d1a04efa16266f30$exports.WebSocketProvider) {
    constructor(network, apiKey){
        const provider = new $2f517ba1fc7b9c0f$export$60ff1a559b5c6ebd(network, apiKey);
        const connection = provider.connection;
        if (connection.password) $2f517ba1fc7b9c0f$var$logger.throwError("INFURA WebSocket project secrets unsupported", (0, $5f596c9584f643ae$export$efa9a398d6368992).errors.UNSUPPORTED_OPERATION, {
            operation: "InfuraProvider.getWebSocketProvider()"
        });
        const url = connection.url.replace(/^http/i, "ws").replace("/v3/", "/ws/v3/");
        super(url, network);
        (0, $d2d9b472f7878d5e$exports.defineReadOnly)(this, "apiKey", provider.projectId);
        (0, $d2d9b472f7878d5e$exports.defineReadOnly)(this, "projectId", provider.projectId);
        (0, $d2d9b472f7878d5e$exports.defineReadOnly)(this, "projectSecret", provider.projectSecret);
    }
    isCommunityResource() {
        return this.projectId === $2f517ba1fc7b9c0f$var$defaultProjectId;
    }
}
class $2f517ba1fc7b9c0f$export$60ff1a559b5c6ebd extends (0, $94a45602d091e5d2$exports.UrlJsonRpcProvider) {
    static getWebSocketProvider(network, apiKey) {
        return new $2f517ba1fc7b9c0f$export$dd168a807d60da4f(network, apiKey);
    }
    static getApiKey(apiKey) {
        const apiKeyObj = {
            apiKey: $2f517ba1fc7b9c0f$var$defaultProjectId,
            projectId: $2f517ba1fc7b9c0f$var$defaultProjectId,
            projectSecret: null
        };
        if (apiKey == null) return apiKeyObj;
        if (typeof apiKey === "string") apiKeyObj.projectId = apiKey;
        else if (apiKey.projectSecret != null) {
            $2f517ba1fc7b9c0f$var$logger.assertArgument(typeof apiKey.projectId === "string", "projectSecret requires a projectId", "projectId", apiKey.projectId);
            $2f517ba1fc7b9c0f$var$logger.assertArgument(typeof apiKey.projectSecret === "string", "invalid projectSecret", "projectSecret", "[REDACTED]");
            apiKeyObj.projectId = apiKey.projectId;
            apiKeyObj.projectSecret = apiKey.projectSecret;
        } else if (apiKey.projectId) apiKeyObj.projectId = apiKey.projectId;
        apiKeyObj.apiKey = apiKeyObj.projectId;
        return apiKeyObj;
    }
    static getUrl(network, apiKey) {
        let host = null;
        switch(network ? network.name : "unknown"){
            case "homestead":
                host = "mainnet.infura.io";
                break;
            case "goerli":
                host = "goerli.infura.io";
                break;
            case "sepolia":
                host = "sepolia.infura.io";
                break;
            case "matic":
                host = "polygon-mainnet.infura.io";
                break;
            case "maticmum":
                host = "polygon-mumbai.infura.io";
                break;
            case "optimism":
                host = "optimism-mainnet.infura.io";
                break;
            case "optimism-goerli":
                host = "optimism-goerli.infura.io";
                break;
            case "arbitrum":
                host = "arbitrum-mainnet.infura.io";
                break;
            case "arbitrum-goerli":
                host = "arbitrum-goerli.infura.io";
                break;
            default:
                $2f517ba1fc7b9c0f$var$logger.throwError("unsupported network", (0, $5f596c9584f643ae$export$efa9a398d6368992).errors.INVALID_ARGUMENT, {
                    argument: "network",
                    value: network
                });
        }
        const connection = {
            allowGzip: true,
            url: "https://" + host + "/v3/" + apiKey.projectId,
            throttleCallback: (attempt, url)=>{
                if (apiKey.projectId === $2f517ba1fc7b9c0f$var$defaultProjectId) (0, $23494291de5f329b$export$4c41bd49e82e82ab)();
                return Promise.resolve(true);
            }
        };
        if (apiKey.projectSecret != null) {
            connection.user = "";
            connection.password = apiKey.projectSecret;
        }
        return connection;
    }
    isCommunityResource() {
        return this.projectId === $2f517ba1fc7b9c0f$var$defaultProjectId;
    }
}






class $0e9822498cccaf3d$export$5a16092bf20edf97 extends (0, $9609e75996f2bd40$exports.JsonRpcProvider) {
    send(method, params) {
        const request = {
            method: method,
            params: params,
            id: this._nextId++,
            jsonrpc: "2.0"
        };
        if (this._pendingBatch == null) this._pendingBatch = [];
        const inflightRequest = {
            request: request,
            resolve: null,
            reject: null
        };
        const promise = new Promise((resolve, reject)=>{
            inflightRequest.resolve = resolve;
            inflightRequest.reject = reject;
        });
        this._pendingBatch.push(inflightRequest);
        if (!this._pendingBatchAggregator) // Schedule batch for next event loop + short duration
        this._pendingBatchAggregator = setTimeout(()=>{
            // Get teh current batch and clear it, so new requests
            // go into the next batch
            const batch = this._pendingBatch;
            this._pendingBatch = null;
            this._pendingBatchAggregator = null;
            // Get the request as an array of requests
            const request = batch.map((inflight)=>inflight.request);
            this.emit("debug", {
                action: "requestBatch",
                request: (0, $d2d9b472f7878d5e$exports.deepCopy)(request),
                provider: this
            });
            return (0, $1f5b367caa9efc4a$exports.fetchJson)(this.connection, JSON.stringify(request)).then((result)=>{
                this.emit("debug", {
                    action: "response",
                    request: request,
                    response: result,
                    provider: this
                });
                // For each result, feed it to the correct Promise, depending
                // on whether it was a success or error
                batch.forEach((inflightRequest, index)=>{
                    const payload = result[index];
                    if (payload.error) {
                        const error = new Error(payload.error.message);
                        error.code = payload.error.code;
                        error.data = payload.error.data;
                        inflightRequest.reject(error);
                    } else inflightRequest.resolve(payload.result);
                });
            }, (error)=>{
                this.emit("debug", {
                    action: "response",
                    error: error,
                    request: request,
                    provider: this
                });
                batch.forEach((inflightRequest)=>{
                    inflightRequest.reject(error);
                });
            });
        }, 10);
        return promise;
    }
}


/* istanbul ignore file */ 


"use strict";
const $5698d1b59ff58cae$var$logger = new (0, $5f596c9584f643ae$export$efa9a398d6368992)((0, $e9ed5b422bb4952f$export$83d89fbfd8236492));
// Special API key provided by Nodesmith for ethers.js
const $5698d1b59ff58cae$var$defaultApiKey = "ETHERS_JS_SHARED";
class $5698d1b59ff58cae$export$8235cbce3ce273bd extends (0, $94a45602d091e5d2$exports.UrlJsonRpcProvider) {
    static getApiKey(apiKey) {
        if (apiKey && typeof apiKey !== "string") $5698d1b59ff58cae$var$logger.throwArgumentError("invalid apiKey", "apiKey", apiKey);
        return apiKey || $5698d1b59ff58cae$var$defaultApiKey;
    }
    static getUrl(network, apiKey) {
        $5698d1b59ff58cae$var$logger.warn("NodeSmith will be discontinued on 2019-12-20; please migrate to another platform.");
        let host = null;
        switch(network.name){
            case "homestead":
                host = "https://ethereum.api.nodesmith.io/v1/mainnet/jsonrpc";
                break;
            case "ropsten":
                host = "https://ethereum.api.nodesmith.io/v1/ropsten/jsonrpc";
                break;
            case "rinkeby":
                host = "https://ethereum.api.nodesmith.io/v1/rinkeby/jsonrpc";
                break;
            case "goerli":
                host = "https://ethereum.api.nodesmith.io/v1/goerli/jsonrpc";
                break;
            case "kovan":
                host = "https://ethereum.api.nodesmith.io/v1/kovan/jsonrpc";
                break;
            default:
                $5698d1b59ff58cae$var$logger.throwArgumentError("unsupported network", "network", arguments[0]);
        }
        return host + "?apiKey=" + apiKey;
    }
}





"use strict";
const $329bf708d9366864$var$logger = new (0, $5f596c9584f643ae$export$efa9a398d6368992)((0, $e9ed5b422bb4952f$export$83d89fbfd8236492));
const $329bf708d9366864$var$defaultApplicationId = "62e1ad51b37b8e00394bda3b";
class $329bf708d9366864$export$58bb47e42f6b092e extends (0, $94a45602d091e5d2$exports.UrlJsonRpcProvider) {
    static getApiKey(apiKey) {
        const apiKeyObj = {
            applicationId: null,
            loadBalancer: true,
            applicationSecretKey: null
        };
        // Parse applicationId and applicationSecretKey
        if (apiKey == null) apiKeyObj.applicationId = $329bf708d9366864$var$defaultApplicationId;
        else if (typeof apiKey === "string") apiKeyObj.applicationId = apiKey;
        else if (apiKey.applicationSecretKey != null) {
            apiKeyObj.applicationId = apiKey.applicationId;
            apiKeyObj.applicationSecretKey = apiKey.applicationSecretKey;
        } else if (apiKey.applicationId) apiKeyObj.applicationId = apiKey.applicationId;
        else $329bf708d9366864$var$logger.throwArgumentError("unsupported PocketProvider apiKey", "apiKey", apiKey);
        return apiKeyObj;
    }
    static getUrl(network, apiKey) {
        let host = null;
        switch(network ? network.name : "unknown"){
            case "goerli":
                host = "eth-goerli.gateway.pokt.network";
                break;
            case "homestead":
                host = "eth-mainnet.gateway.pokt.network";
                break;
            case "kovan":
                host = "poa-kovan.gateway.pokt.network";
                break;
            case "matic":
                host = "poly-mainnet.gateway.pokt.network";
                break;
            case "maticmum":
                host = "polygon-mumbai-rpc.gateway.pokt.network";
                break;
            case "rinkeby":
                host = "eth-rinkeby.gateway.pokt.network";
                break;
            case "ropsten":
                host = "eth-ropsten.gateway.pokt.network";
                break;
            default:
                $329bf708d9366864$var$logger.throwError("unsupported network", (0, $5f596c9584f643ae$export$efa9a398d6368992).errors.INVALID_ARGUMENT, {
                    argument: "network",
                    value: network
                });
        }
        const url = `https:/\/${host}/v1/lb/${apiKey.applicationId}`;
        const connection = {
            headers: {},
            url: url
        };
        if (apiKey.applicationSecretKey != null) {
            connection.user = "";
            connection.password = apiKey.applicationSecretKey;
        }
        return connection;
    }
    isCommunityResource() {
        return this.applicationId === $329bf708d9366864$var$defaultApplicationId;
    }
}







"use strict";
const $ea752ed8b721343a$var$logger = new (0, $5f596c9584f643ae$export$efa9a398d6368992)((0, $e9ed5b422bb4952f$export$83d89fbfd8236492));
let $ea752ed8b721343a$var$_nextId = 1;
function $ea752ed8b721343a$var$buildWeb3LegacyFetcher(provider, sendFunc) {
    const fetcher = "Web3LegacyFetcher";
    return function(method, params) {
        const request = {
            method: method,
            params: params,
            id: $ea752ed8b721343a$var$_nextId++,
            jsonrpc: "2.0"
        };
        return new Promise((resolve, reject)=>{
            this.emit("debug", {
                action: "request",
                fetcher: fetcher,
                request: (0, $d2d9b472f7878d5e$exports.deepCopy)(request),
                provider: this
            });
            sendFunc(request, (error, response)=>{
                if (error) {
                    this.emit("debug", {
                        action: "response",
                        fetcher: fetcher,
                        error: error,
                        request: request,
                        provider: this
                    });
                    return reject(error);
                }
                this.emit("debug", {
                    action: "response",
                    fetcher: fetcher,
                    request: request,
                    response: response,
                    provider: this
                });
                if (response.error) {
                    const error = new Error(response.error.message);
                    error.code = response.error.code;
                    error.data = response.error.data;
                    return reject(error);
                }
                resolve(response.result);
            });
        });
    };
}
function $ea752ed8b721343a$var$buildEip1193Fetcher(provider) {
    return function(method, params) {
        if (params == null) params = [];
        const request = {
            method: method,
            params: params
        };
        this.emit("debug", {
            action: "request",
            fetcher: "Eip1193Fetcher",
            request: (0, $d2d9b472f7878d5e$exports.deepCopy)(request),
            provider: this
        });
        return provider.request(request).then((response)=>{
            this.emit("debug", {
                action: "response",
                fetcher: "Eip1193Fetcher",
                request: request,
                response: response,
                provider: this
            });
            return response;
        }, (error)=>{
            this.emit("debug", {
                action: "response",
                fetcher: "Eip1193Fetcher",
                request: request,
                error: error,
                provider: this
            });
            throw error;
        });
    };
}
class $ea752ed8b721343a$export$d05096c9fd9d936d extends (0, $9609e75996f2bd40$exports.JsonRpcProvider) {
    constructor(provider, network){
        if (provider == null) $ea752ed8b721343a$var$logger.throwArgumentError("missing provider", "provider", provider);
        let path = null;
        let jsonRpcFetchFunc = null;
        let subprovider = null;
        if (typeof provider === "function") {
            path = "unknown:";
            jsonRpcFetchFunc = provider;
        } else {
            path = provider.host || provider.path || "";
            if (!path && provider.isMetaMask) path = "metamask";
            subprovider = provider;
            if (provider.request) {
                if (path === "") path = "eip-1193:";
                jsonRpcFetchFunc = $ea752ed8b721343a$var$buildEip1193Fetcher(provider);
            } else if (provider.sendAsync) jsonRpcFetchFunc = $ea752ed8b721343a$var$buildWeb3LegacyFetcher(provider, provider.sendAsync.bind(provider));
            else if (provider.send) jsonRpcFetchFunc = $ea752ed8b721343a$var$buildWeb3LegacyFetcher(provider, provider.send.bind(provider));
            else $ea752ed8b721343a$var$logger.throwArgumentError("unsupported provider", "provider", provider);
            if (!path) path = "unknown:";
        }
        super(path, network);
        (0, $d2d9b472f7878d5e$exports.defineReadOnly)(this, "jsonRpcFetchFunc", jsonRpcFetchFunc);
        (0, $d2d9b472f7878d5e$exports.defineReadOnly)(this, "provider", subprovider);
    }
    send(method, params) {
        return this.jsonRpcFetchFunc(method, params);
    }
}






"use strict";
const $6b2231007a47a4de$var$logger = new (0, $5f596c9584f643ae$export$efa9a398d6368992)((0, $e9ed5b422bb4952f$export$83d89fbfd8236492));
////////////////////////
// Helper Functions
function $6b2231007a47a4de$export$4f77a1d3c1ac6642(network, options) {
    if (network == null) network = "homestead";
    // If passed a URL, figure out the right type of provider based on the scheme
    if (typeof network === "string") {
        // @TODO: Add support for IpcProvider; maybe if it ends in ".ipc"?
        // Handle http and ws (and their secure variants)
        const match = network.match(/^(ws|http)s?:/i);
        if (match) switch(match[1].toLowerCase()){
            case "http":
            case "https":
                return new (0, $9609e75996f2bd40$exports.JsonRpcProvider)(network);
            case "ws":
            case "wss":
                return new (0, $d1a04efa16266f30$exports.WebSocketProvider)(network);
            default:
                $6b2231007a47a4de$var$logger.throwArgumentError("unsupported URL scheme", "network", network);
        }
    }
    const n = (0, $e6278266fc0cd090$export$7de4970ebfd8206d)(network);
    if (!n || !n._defaultProvider) $6b2231007a47a4de$var$logger.throwError("unsupported getDefaultProvider network", (0, $5f596c9584f643ae$export$efa9a398d6368992).errors.NETWORK_ERROR, {
        operation: "getDefaultProvider",
        network: network
    });
    return n._defaultProvider({
        FallbackProvider: $679b99176172981c$exports.FallbackProvider,
        AlchemyProvider: $5142047284b3daba$export$999cc40da3fbc6f,
        AnkrProvider: $27dd6519e1beec55$export$72783b2aefa72a45,
        CloudflareProvider: $819ad3a08ca08517$exports.CloudflareProvider,
        EtherscanProvider: $dce3608ad1ddcc3f$exports.EtherscanProvider,
        InfuraProvider: $2f517ba1fc7b9c0f$export$60ff1a559b5c6ebd,
        JsonRpcProvider: $9609e75996f2bd40$exports.JsonRpcProvider,
        NodesmithProvider: $5698d1b59ff58cae$export$8235cbce3ce273bd,
        PocketProvider: $329bf708d9366864$export$58bb47e42f6b092e,
        Web3Provider: $ea752ed8b721343a$export$d05096c9fd9d936d,
        IpcProvider: $f8338370fa8a55b7$export$fbe151f90a1ece01
    }, options);
}


var $764ab7ccc627cd55$exports = {};
"use strict";
Object.defineProperty($764ab7ccc627cd55$exports, "__esModule", {
    value: true
});
$764ab7ccc627cd55$exports.getMessageFromCode = $764ab7ccc627cd55$exports.serializeError = $764ab7ccc627cd55$exports.EthereumProviderError = $764ab7ccc627cd55$exports.EthereumRpcError = $764ab7ccc627cd55$exports.ethErrors = $764ab7ccc627cd55$exports.errorCodes = void 0;
var $2ae93d0ce1c5b9df$exports = {};
"use strict";
Object.defineProperty($2ae93d0ce1c5b9df$exports, "__esModule", {
    value: true
});
$2ae93d0ce1c5b9df$exports.EthereumProviderError = $2ae93d0ce1c5b9df$exports.EthereumRpcError = void 0;
var $55191bd6ee862399$exports = {};
$55191bd6ee862399$exports = $55191bd6ee862399$var$stringify;
$55191bd6ee862399$var$stringify.default = $55191bd6ee862399$var$stringify;
$55191bd6ee862399$var$stringify.stable = $55191bd6ee862399$var$deterministicStringify;
$55191bd6ee862399$var$stringify.stableStringify = $55191bd6ee862399$var$deterministicStringify;
var $55191bd6ee862399$var$LIMIT_REPLACE_NODE = "[...]";
var $55191bd6ee862399$var$CIRCULAR_REPLACE_NODE = "[Circular]";
var $55191bd6ee862399$var$arr = [];
var $55191bd6ee862399$var$replacerStack = [];
function $55191bd6ee862399$var$defaultOptions() {
    return {
        depthLimit: Number.MAX_SAFE_INTEGER,
        edgesLimit: Number.MAX_SAFE_INTEGER
    };
}
// Regular stringify
function $55191bd6ee862399$var$stringify(obj, replacer, spacer, options) {
    if (typeof options === "undefined") options = $55191bd6ee862399$var$defaultOptions();
    $55191bd6ee862399$var$decirc(obj, "", 0, [], undefined, 0, options);
    var res;
    try {
        if ($55191bd6ee862399$var$replacerStack.length === 0) res = JSON.stringify(obj, replacer, spacer);
        else res = JSON.stringify(obj, $55191bd6ee862399$var$replaceGetterValues(replacer), spacer);
    } catch (_) {
        return JSON.stringify("[unable to serialize, circular reference is too complex to analyze]");
    } finally{
        while($55191bd6ee862399$var$arr.length !== 0){
            var part = $55191bd6ee862399$var$arr.pop();
            if (part.length === 4) Object.defineProperty(part[0], part[1], part[3]);
            else part[0][part[1]] = part[2];
        }
    }
    return res;
}
function $55191bd6ee862399$var$setReplace(replace, val, k, parent) {
    var propertyDescriptor = Object.getOwnPropertyDescriptor(parent, k);
    if (propertyDescriptor.get !== undefined) {
        if (propertyDescriptor.configurable) {
            Object.defineProperty(parent, k, {
                value: replace
            });
            $55191bd6ee862399$var$arr.push([
                parent,
                k,
                val,
                propertyDescriptor
            ]);
        } else $55191bd6ee862399$var$replacerStack.push([
            val,
            k,
            replace
        ]);
    } else {
        parent[k] = replace;
        $55191bd6ee862399$var$arr.push([
            parent,
            k,
            val
        ]);
    }
}
function $55191bd6ee862399$var$decirc(val, k, edgeIndex, stack, parent, depth, options) {
    depth += 1;
    var i;
    if (typeof val === "object" && val !== null) {
        for(i = 0; i < stack.length; i++)if (stack[i] === val) {
            $55191bd6ee862399$var$setReplace($55191bd6ee862399$var$CIRCULAR_REPLACE_NODE, val, k, parent);
            return;
        }
        if (typeof options.depthLimit !== "undefined" && depth > options.depthLimit) {
            $55191bd6ee862399$var$setReplace($55191bd6ee862399$var$LIMIT_REPLACE_NODE, val, k, parent);
            return;
        }
        if (typeof options.edgesLimit !== "undefined" && edgeIndex + 1 > options.edgesLimit) {
            $55191bd6ee862399$var$setReplace($55191bd6ee862399$var$LIMIT_REPLACE_NODE, val, k, parent);
            return;
        }
        stack.push(val);
        // Optimize for Arrays. Big arrays could kill the performance otherwise!
        if (Array.isArray(val)) for(i = 0; i < val.length; i++)$55191bd6ee862399$var$decirc(val[i], i, i, stack, val, depth, options);
        else {
            var keys = Object.keys(val);
            for(i = 0; i < keys.length; i++){
                var key = keys[i];
                $55191bd6ee862399$var$decirc(val[key], key, i, stack, val, depth, options);
            }
        }
        stack.pop();
    }
}
// Stable-stringify
function $55191bd6ee862399$var$compareFunction(a, b) {
    if (a < b) return -1;
    if (a > b) return 1;
    return 0;
}
function $55191bd6ee862399$var$deterministicStringify(obj, replacer, spacer, options) {
    if (typeof options === "undefined") options = $55191bd6ee862399$var$defaultOptions();
    var tmp = $55191bd6ee862399$var$deterministicDecirc(obj, "", 0, [], undefined, 0, options) || obj;
    var res;
    try {
        if ($55191bd6ee862399$var$replacerStack.length === 0) res = JSON.stringify(tmp, replacer, spacer);
        else res = JSON.stringify(tmp, $55191bd6ee862399$var$replaceGetterValues(replacer), spacer);
    } catch (_) {
        return JSON.stringify("[unable to serialize, circular reference is too complex to analyze]");
    } finally{
        // Ensure that we restore the object as it was.
        while($55191bd6ee862399$var$arr.length !== 0){
            var part = $55191bd6ee862399$var$arr.pop();
            if (part.length === 4) Object.defineProperty(part[0], part[1], part[3]);
            else part[0][part[1]] = part[2];
        }
    }
    return res;
}
function $55191bd6ee862399$var$deterministicDecirc(val, k, edgeIndex, stack, parent, depth, options) {
    depth += 1;
    var i;
    if (typeof val === "object" && val !== null) {
        for(i = 0; i < stack.length; i++)if (stack[i] === val) {
            $55191bd6ee862399$var$setReplace($55191bd6ee862399$var$CIRCULAR_REPLACE_NODE, val, k, parent);
            return;
        }
        try {
            if (typeof val.toJSON === "function") return;
        } catch (_) {
            return;
        }
        if (typeof options.depthLimit !== "undefined" && depth > options.depthLimit) {
            $55191bd6ee862399$var$setReplace($55191bd6ee862399$var$LIMIT_REPLACE_NODE, val, k, parent);
            return;
        }
        if (typeof options.edgesLimit !== "undefined" && edgeIndex + 1 > options.edgesLimit) {
            $55191bd6ee862399$var$setReplace($55191bd6ee862399$var$LIMIT_REPLACE_NODE, val, k, parent);
            return;
        }
        stack.push(val);
        // Optimize for Arrays. Big arrays could kill the performance otherwise!
        if (Array.isArray(val)) for(i = 0; i < val.length; i++)$55191bd6ee862399$var$deterministicDecirc(val[i], i, i, stack, val, depth, options);
        else {
            // Create a temporary object in the required way
            var tmp = {};
            var keys = Object.keys(val).sort($55191bd6ee862399$var$compareFunction);
            for(i = 0; i < keys.length; i++){
                var key = keys[i];
                $55191bd6ee862399$var$deterministicDecirc(val[key], key, i, stack, val, depth, options);
                tmp[key] = val[key];
            }
            if (typeof parent !== "undefined") {
                $55191bd6ee862399$var$arr.push([
                    parent,
                    k,
                    val
                ]);
                parent[k] = tmp;
            } else return tmp;
        }
        stack.pop();
    }
}
// wraps replacer function to handle values we couldn't replace
// and mark them as replaced value
function $55191bd6ee862399$var$replaceGetterValues(replacer) {
    replacer = typeof replacer !== "undefined" ? replacer : function(k, v) {
        return v;
    };
    return function(key, val) {
        if ($55191bd6ee862399$var$replacerStack.length > 0) for(var i = 0; i < $55191bd6ee862399$var$replacerStack.length; i++){
            var part = $55191bd6ee862399$var$replacerStack[i];
            if (part[1] === key && part[0] === val) {
                val = part[2];
                $55191bd6ee862399$var$replacerStack.splice(i, 1);
                break;
            }
        }
        return replacer.call(this, key, val);
    };
}


/**
 * Error subclass implementing JSON RPC 2.0 errors and Ethereum RPC errors
 * per EIP-1474.
 * Permits any integer error code.
 */ class $2ae93d0ce1c5b9df$var$EthereumRpcError extends Error {
    constructor(code, message, data){
        if (!Number.isInteger(code)) throw new Error('"code" must be an integer.');
        if (!message || typeof message !== "string") throw new Error('"message" must be a nonempty string.');
        super(message);
        this.code = code;
        if (data !== undefined) this.data = data;
    }
    /**
     * Returns a plain object with all public class properties.
     */ serialize() {
        const serialized = {
            code: this.code,
            message: this.message
        };
        if (this.data !== undefined) serialized.data = this.data;
        if (this.stack) serialized.stack = this.stack;
        return serialized;
    }
    /**
     * Return a string representation of the serialized error, omitting
     * any circular references.
     */ toString() {
        return $55191bd6ee862399$exports.default(this.serialize(), $2ae93d0ce1c5b9df$var$stringifyReplacer, 2);
    }
}
$2ae93d0ce1c5b9df$exports.EthereumRpcError = $2ae93d0ce1c5b9df$var$EthereumRpcError;
/**
 * Error subclass implementing Ethereum Provider errors per EIP-1193.
 * Permits integer error codes in the [ 1000 <= 4999 ] range.
 */ class $2ae93d0ce1c5b9df$var$EthereumProviderError extends $2ae93d0ce1c5b9df$var$EthereumRpcError {
    /**
     * Create an Ethereum Provider JSON-RPC error.
     * `code` must be an integer in the 1000 <= 4999 range.
     */ constructor(code, message, data){
        if (!$2ae93d0ce1c5b9df$var$isValidEthProviderCode(code)) throw new Error('"code" must be an integer such that: 1000 <= code <= 4999');
        super(code, message, data);
    }
}
$2ae93d0ce1c5b9df$exports.EthereumProviderError = $2ae93d0ce1c5b9df$var$EthereumProviderError;
// Internal
function $2ae93d0ce1c5b9df$var$isValidEthProviderCode(code) {
    return Number.isInteger(code) && code >= 1000 && code <= 4999;
}
function $2ae93d0ce1c5b9df$var$stringifyReplacer(_, value) {
    if (value === "[Circular]") return undefined;
    return value;
}


Object.defineProperty($764ab7ccc627cd55$exports, "EthereumRpcError", {
    enumerable: true,
    get: function() {
        return $2ae93d0ce1c5b9df$exports.EthereumRpcError;
    }
});
Object.defineProperty($764ab7ccc627cd55$exports, "EthereumProviderError", {
    enumerable: true,
    get: function() {
        return $2ae93d0ce1c5b9df$exports.EthereumProviderError;
    }
});
var $976e3b62035dd6e6$exports = {};
"use strict";
Object.defineProperty($976e3b62035dd6e6$exports, "__esModule", {
    value: true
});
$976e3b62035dd6e6$exports.serializeError = $976e3b62035dd6e6$exports.isValidCode = $976e3b62035dd6e6$exports.getMessageFromCode = $976e3b62035dd6e6$exports.JSON_RPC_SERVER_ERROR_MESSAGE = void 0;
var $f36285de497fb331$exports = {};
"use strict";
Object.defineProperty($f36285de497fb331$exports, "__esModule", {
    value: true
});
$f36285de497fb331$exports.errorValues = $f36285de497fb331$exports.errorCodes = void 0;
$f36285de497fb331$exports.errorCodes = {
    rpc: {
        invalidInput: -32000,
        resourceNotFound: -32001,
        resourceUnavailable: -32002,
        transactionRejected: -32003,
        methodNotSupported: -32004,
        limitExceeded: -32005,
        parse: -32700,
        invalidRequest: -32600,
        methodNotFound: -32601,
        invalidParams: -32602,
        internal: -32603
    },
    provider: {
        userRejectedRequest: 4001,
        unauthorized: 4100,
        unsupportedMethod: 4200,
        disconnected: 4900,
        chainDisconnected: 4901
    }
};
$f36285de497fb331$exports.errorValues = {
    "-32700": {
        standard: "JSON RPC 2.0",
        message: "Invalid JSON was received by the server. An error occurred on the server while parsing the JSON text."
    },
    "-32600": {
        standard: "JSON RPC 2.0",
        message: "The JSON sent is not a valid Request object."
    },
    "-32601": {
        standard: "JSON RPC 2.0",
        message: "The method does not exist / is not available."
    },
    "-32602": {
        standard: "JSON RPC 2.0",
        message: "Invalid method parameter(s)."
    },
    "-32603": {
        standard: "JSON RPC 2.0",
        message: "Internal JSON-RPC error."
    },
    "-32000": {
        standard: "EIP-1474",
        message: "Invalid input."
    },
    "-32001": {
        standard: "EIP-1474",
        message: "Resource not found."
    },
    "-32002": {
        standard: "EIP-1474",
        message: "Resource unavailable."
    },
    "-32003": {
        standard: "EIP-1474",
        message: "Transaction rejected."
    },
    "-32004": {
        standard: "EIP-1474",
        message: "Method not supported."
    },
    "-32005": {
        standard: "EIP-1474",
        message: "Request limit exceeded."
    },
    "4001": {
        standard: "EIP-1193",
        message: "User rejected the request."
    },
    "4100": {
        standard: "EIP-1193",
        message: "The requested account and/or method has not been authorized by the user."
    },
    "4200": {
        standard: "EIP-1193",
        message: "The requested method is not supported by this Ethereum provider."
    },
    "4900": {
        standard: "EIP-1193",
        message: "The provider is disconnected from all chains."
    },
    "4901": {
        standard: "EIP-1193",
        message: "The provider is disconnected from the specified chain."
    }
};



const $976e3b62035dd6e6$var$FALLBACK_ERROR_CODE = $f36285de497fb331$exports.errorCodes.rpc.internal;
const $976e3b62035dd6e6$var$FALLBACK_MESSAGE = "Unspecified error message. This is a bug, please report it.";
const $976e3b62035dd6e6$var$FALLBACK_ERROR = {
    code: $976e3b62035dd6e6$var$FALLBACK_ERROR_CODE,
    message: $976e3b62035dd6e6$var$getMessageFromCode($976e3b62035dd6e6$var$FALLBACK_ERROR_CODE)
};
$976e3b62035dd6e6$exports.JSON_RPC_SERVER_ERROR_MESSAGE = "Unspecified server error.";
/**
 * Gets the message for a given code, or a fallback message if the code has
 * no corresponding message.
 */ function $976e3b62035dd6e6$var$getMessageFromCode(code, fallbackMessage = $976e3b62035dd6e6$var$FALLBACK_MESSAGE) {
    if (Number.isInteger(code)) {
        const codeString = code.toString();
        if ($976e3b62035dd6e6$var$hasKey($f36285de497fb331$exports.errorValues, codeString)) return $f36285de497fb331$exports.errorValues[codeString].message;
        if ($976e3b62035dd6e6$var$isJsonRpcServerError(code)) return $976e3b62035dd6e6$exports.JSON_RPC_SERVER_ERROR_MESSAGE;
    }
    return fallbackMessage;
}
$976e3b62035dd6e6$exports.getMessageFromCode = $976e3b62035dd6e6$var$getMessageFromCode;
/**
 * Returns whether the given code is valid.
 * A code is only valid if it has a message.
 */ function $976e3b62035dd6e6$var$isValidCode(code) {
    if (!Number.isInteger(code)) return false;
    const codeString = code.toString();
    if ($f36285de497fb331$exports.errorValues[codeString]) return true;
    if ($976e3b62035dd6e6$var$isJsonRpcServerError(code)) return true;
    return false;
}
$976e3b62035dd6e6$exports.isValidCode = $976e3b62035dd6e6$var$isValidCode;
/**
 * Serializes the given error to an Ethereum JSON RPC-compatible error object.
 * Merely copies the given error's values if it is already compatible.
 * If the given error is not fully compatible, it will be preserved on the
 * returned object's data.originalError property.
 */ function $976e3b62035dd6e6$var$serializeError(error, { fallbackError: fallbackError = $976e3b62035dd6e6$var$FALLBACK_ERROR, shouldIncludeStack: shouldIncludeStack = false } = {}) {
    var _a, _b;
    if (!fallbackError || !Number.isInteger(fallbackError.code) || typeof fallbackError.message !== "string") throw new Error("Must provide fallback error with integer number code and string message.");
    if (error instanceof $2ae93d0ce1c5b9df$exports.EthereumRpcError) return error.serialize();
    const serialized = {};
    if (error && typeof error === "object" && !Array.isArray(error) && $976e3b62035dd6e6$var$hasKey(error, "code") && $976e3b62035dd6e6$var$isValidCode(error.code)) {
        const _error = error;
        serialized.code = _error.code;
        if (_error.message && typeof _error.message === "string") {
            serialized.message = _error.message;
            if ($976e3b62035dd6e6$var$hasKey(_error, "data")) serialized.data = _error.data;
        } else {
            serialized.message = $976e3b62035dd6e6$var$getMessageFromCode(serialized.code);
            serialized.data = {
                originalError: $976e3b62035dd6e6$var$assignOriginalError(error)
            };
        }
    } else {
        serialized.code = fallbackError.code;
        const message = (_a = error) === null || _a === void 0 ? void 0 : _a.message;
        serialized.message = message && typeof message === "string" ? message : fallbackError.message;
        serialized.data = {
            originalError: $976e3b62035dd6e6$var$assignOriginalError(error)
        };
    }
    const stack = (_b = error) === null || _b === void 0 ? void 0 : _b.stack;
    if (shouldIncludeStack && error && stack && typeof stack === "string") serialized.stack = stack;
    return serialized;
}
$976e3b62035dd6e6$exports.serializeError = $976e3b62035dd6e6$var$serializeError;
// Internal
function $976e3b62035dd6e6$var$isJsonRpcServerError(code) {
    return code >= -32099 && code <= -32000;
}
function $976e3b62035dd6e6$var$assignOriginalError(error) {
    if (error && typeof error === "object" && !Array.isArray(error)) return Object.assign({}, error);
    return error;
}
function $976e3b62035dd6e6$var$hasKey(obj, key) {
    return Object.prototype.hasOwnProperty.call(obj, key);
}


Object.defineProperty($764ab7ccc627cd55$exports, "serializeError", {
    enumerable: true,
    get: function() {
        return $976e3b62035dd6e6$exports.serializeError;
    }
});
Object.defineProperty($764ab7ccc627cd55$exports, "getMessageFromCode", {
    enumerable: true,
    get: function() {
        return $976e3b62035dd6e6$exports.getMessageFromCode;
    }
});
var $0468ce9ee431d80d$exports = {};
"use strict";
Object.defineProperty($0468ce9ee431d80d$exports, "__esModule", {
    value: true
});
$0468ce9ee431d80d$exports.ethErrors = void 0;



$0468ce9ee431d80d$exports.ethErrors = {
    rpc: {
        /**
         * Get a JSON RPC 2.0 Parse (-32700) error.
         */ parse: (arg)=>$0468ce9ee431d80d$var$getEthJsonRpcError($f36285de497fb331$exports.errorCodes.rpc.parse, arg),
        /**
         * Get a JSON RPC 2.0 Invalid Request (-32600) error.
         */ invalidRequest: (arg)=>$0468ce9ee431d80d$var$getEthJsonRpcError($f36285de497fb331$exports.errorCodes.rpc.invalidRequest, arg),
        /**
         * Get a JSON RPC 2.0 Invalid Params (-32602) error.
         */ invalidParams: (arg)=>$0468ce9ee431d80d$var$getEthJsonRpcError($f36285de497fb331$exports.errorCodes.rpc.invalidParams, arg),
        /**
         * Get a JSON RPC 2.0 Method Not Found (-32601) error.
         */ methodNotFound: (arg)=>$0468ce9ee431d80d$var$getEthJsonRpcError($f36285de497fb331$exports.errorCodes.rpc.methodNotFound, arg),
        /**
         * Get a JSON RPC 2.0 Internal (-32603) error.
         */ internal: (arg)=>$0468ce9ee431d80d$var$getEthJsonRpcError($f36285de497fb331$exports.errorCodes.rpc.internal, arg),
        /**
         * Get a JSON RPC 2.0 Server error.
         * Permits integer error codes in the [ -32099 <= -32005 ] range.
         * Codes -32000 through -32004 are reserved by EIP-1474.
         */ server: (opts)=>{
            if (!opts || typeof opts !== "object" || Array.isArray(opts)) throw new Error("Ethereum RPC Server errors must provide single object argument.");
            const { code: code } = opts;
            if (!Number.isInteger(code) || code > -32005 || code < -32099) throw new Error('"code" must be an integer such that: -32099 <= code <= -32005');
            return $0468ce9ee431d80d$var$getEthJsonRpcError(code, opts);
        },
        /**
         * Get an Ethereum JSON RPC Invalid Input (-32000) error.
         */ invalidInput: (arg)=>$0468ce9ee431d80d$var$getEthJsonRpcError($f36285de497fb331$exports.errorCodes.rpc.invalidInput, arg),
        /**
         * Get an Ethereum JSON RPC Resource Not Found (-32001) error.
         */ resourceNotFound: (arg)=>$0468ce9ee431d80d$var$getEthJsonRpcError($f36285de497fb331$exports.errorCodes.rpc.resourceNotFound, arg),
        /**
         * Get an Ethereum JSON RPC Resource Unavailable (-32002) error.
         */ resourceUnavailable: (arg)=>$0468ce9ee431d80d$var$getEthJsonRpcError($f36285de497fb331$exports.errorCodes.rpc.resourceUnavailable, arg),
        /**
         * Get an Ethereum JSON RPC Transaction Rejected (-32003) error.
         */ transactionRejected: (arg)=>$0468ce9ee431d80d$var$getEthJsonRpcError($f36285de497fb331$exports.errorCodes.rpc.transactionRejected, arg),
        /**
         * Get an Ethereum JSON RPC Method Not Supported (-32004) error.
         */ methodNotSupported: (arg)=>$0468ce9ee431d80d$var$getEthJsonRpcError($f36285de497fb331$exports.errorCodes.rpc.methodNotSupported, arg),
        /**
         * Get an Ethereum JSON RPC Limit Exceeded (-32005) error.
         */ limitExceeded: (arg)=>$0468ce9ee431d80d$var$getEthJsonRpcError($f36285de497fb331$exports.errorCodes.rpc.limitExceeded, arg)
    },
    provider: {
        /**
         * Get an Ethereum Provider User Rejected Request (4001) error.
         */ userRejectedRequest: (arg)=>{
            return $0468ce9ee431d80d$var$getEthProviderError($f36285de497fb331$exports.errorCodes.provider.userRejectedRequest, arg);
        },
        /**
         * Get an Ethereum Provider Unauthorized (4100) error.
         */ unauthorized: (arg)=>{
            return $0468ce9ee431d80d$var$getEthProviderError($f36285de497fb331$exports.errorCodes.provider.unauthorized, arg);
        },
        /**
         * Get an Ethereum Provider Unsupported Method (4200) error.
         */ unsupportedMethod: (arg)=>{
            return $0468ce9ee431d80d$var$getEthProviderError($f36285de497fb331$exports.errorCodes.provider.unsupportedMethod, arg);
        },
        /**
         * Get an Ethereum Provider Not Connected (4900) error.
         */ disconnected: (arg)=>{
            return $0468ce9ee431d80d$var$getEthProviderError($f36285de497fb331$exports.errorCodes.provider.disconnected, arg);
        },
        /**
         * Get an Ethereum Provider Chain Not Connected (4901) error.
         */ chainDisconnected: (arg)=>{
            return $0468ce9ee431d80d$var$getEthProviderError($f36285de497fb331$exports.errorCodes.provider.chainDisconnected, arg);
        },
        /**
         * Get a custom Ethereum Provider error.
         */ custom: (opts)=>{
            if (!opts || typeof opts !== "object" || Array.isArray(opts)) throw new Error("Ethereum Provider custom errors must provide single object argument.");
            const { code: code, message: message, data: data } = opts;
            if (!message || typeof message !== "string") throw new Error('"message" must be a nonempty string');
            return new $2ae93d0ce1c5b9df$exports.EthereumProviderError(code, message, data);
        }
    }
};
// Internal
function $0468ce9ee431d80d$var$getEthJsonRpcError(code, arg) {
    const [message, data] = $0468ce9ee431d80d$var$parseOpts(arg);
    return new $2ae93d0ce1c5b9df$exports.EthereumRpcError(code, message || $976e3b62035dd6e6$exports.getMessageFromCode(code), data);
}
function $0468ce9ee431d80d$var$getEthProviderError(code, arg) {
    const [message, data] = $0468ce9ee431d80d$var$parseOpts(arg);
    return new $2ae93d0ce1c5b9df$exports.EthereumProviderError(code, message || $976e3b62035dd6e6$exports.getMessageFromCode(code), data);
}
function $0468ce9ee431d80d$var$parseOpts(arg) {
    if (arg) {
        if (typeof arg === "string") return [
            arg
        ];
        else if (typeof arg === "object" && !Array.isArray(arg)) {
            const { message: message, data: data } = arg;
            if (message && typeof message !== "string") throw new Error("Must specify string message.");
            return [
                message || undefined,
                data
            ];
        }
    }
    return [];
}


Object.defineProperty($764ab7ccc627cd55$exports, "ethErrors", {
    enumerable: true,
    get: function() {
        return $0468ce9ee431d80d$exports.ethErrors;
    }
});

Object.defineProperty($764ab7ccc627cd55$exports, "errorCodes", {
    enumerable: true,
    get: function() {
        return $f36285de497fb331$exports.errorCodes;
    }
});



var $5d1e44928e4bdfed$var$w = Object.defineProperty;
var $5d1e44928e4bdfed$var$E = (n, e)=>$5d1e44928e4bdfed$var$w(n, "name", {
        value: e,
        configurable: !0
    });
var $5d1e44928e4bdfed$var$R = {
    rpc: {
        invalidInput: -32000,
        resourceNotFound: -32001,
        resourceUnavailable: -32002,
        transactionRejected: -32003,
        methodNotSupported: -32004,
        limitExceeded: -32005,
        parse: -32700,
        invalidRequest: -32600,
        methodNotFound: -32601,
        invalidParams: -32602,
        internal: -32603
    },
    provider: {
        userRejectedRequest: 4001,
        unauthorized: 4100,
        unsupportedMethod: 4200,
        disconnected: 4900,
        chainDisconnected: 4901
    }
};
var $5d1e44928e4bdfed$export$2301774de5742bc7 = $5d1e44928e4bdfed$var$E((n)=>{
    if (!n) return new (0, $6bf9e406f810d981$exports.SignerError)((0, $6bf9e406f810d981$exports.SignerErrorCode).SEND_TX_ERROR);
    if ((0, $6bf9e406f810d981$exports.SignerError).isSignerError(n)) return n;
    let e = Object.prototype.hasOwnProperty.call(n, "message"), i = Object.prototype.hasOwnProperty.call(n, "code");
    if (e && i) {
        let { message: r, code: t } = n;
        if ("ACTION_REJECTED" === t || $5d1e44928e4bdfed$var$R.provider.userRejectedRequest === t) return new (0, $6bf9e406f810d981$exports.SignerError)((0, $6bf9e406f810d981$exports.SignerErrorCode).REJECTED_BY_USER, void 0, n, (0, $6bf9e406f810d981$exports.RPCErrorCode).REJECTION, n);
        if (typeof t == "number") {
            if (Object.values($5d1e44928e4bdfed$var$R.provider).includes(t)) {
                let s = (0, $764ab7ccc627cd55$exports.getMessageFromCode)(t);
                return new (0, $6bf9e406f810d981$exports.SignerError)((0, $6bf9e406f810d981$exports.SignerErrorCode).SEND_TX_ERROR, void 0, s, (0, $6bf9e406f810d981$exports.RPCErrorCode).UNKNOWN_ERROR, n);
            } else if (Object.values($5d1e44928e4bdfed$var$R.rpc).includes(t)) {
                if (t === $5d1e44928e4bdfed$var$R.rpc.internal && (r?.includes("underpriced") || r?.includes("replacement fee too low"))) return new (0, $6bf9e406f810d981$exports.SignerError)((0, $6bf9e406f810d981$exports.SignerErrorCode).SEND_TX_ERROR, void 0, "Transaction is underpriced.", (0, $6bf9e406f810d981$exports.RPCErrorCode).UNDER_PRICED, n);
                if (r?.includes("intrinsic gas too low") || r?.includes("out of gas")) return new (0, $6bf9e406f810d981$exports.SignerError)((0, $6bf9e406f810d981$exports.SignerErrorCode).SEND_TX_ERROR, void 0, "Gas limit is low.", (0, $6bf9e406f810d981$exports.RPCErrorCode).OUT_OF_GAS, n);
                let s = (0, $764ab7ccc627cd55$exports.getMessageFromCode)(t);
                return new (0, $6bf9e406f810d981$exports.SignerError)((0, $6bf9e406f810d981$exports.SignerErrorCode).SEND_TX_ERROR, void 0, s ?? n, (0, $6bf9e406f810d981$exports.RPCErrorCode).UNKNOWN_ERROR, n);
            }
        }
        switch(t){
            case "INVALID_ARGUMENT":
                {
                    let s = (n.reason || n.message) ?? n;
                    return new (0, $6bf9e406f810d981$exports.SignerError)((0, $6bf9e406f810d981$exports.SignerErrorCode).SEND_TX_ERROR, void 0, s, (0, $6bf9e406f810d981$exports.RPCErrorCode).UNKNOWN_ERROR, n);
                }
        }
    }
    return new (0, $6bf9e406f810d981$exports.SignerError)((0, $6bf9e406f810d981$exports.SignerErrorCode).SEND_TX_ERROR, void 0, n, (0, $6bf9e406f810d981$exports.RPCErrorCode).UNKNOWN_ERROR, n);
}, "cleanEvmError");
async function $5d1e44928e4bdfed$var$_(n, e) {
    if (!n || !e) return;
    let i = parseInt(n);
    try {
        let r = `https://api.tenderly.co/api/v1/public-contract/${i}/tx/${e}`, t = await fetch(r, {
            method: "GET"
        });
        return t.ok ? (await t.json())?.error_message : void 0;
    } catch  {
        return;
    }
}
$5d1e44928e4bdfed$var$E($5d1e44928e4bdfed$var$_, "getTenderlyError");
var $5d1e44928e4bdfed$export$58d6a4bf07475873 = $5d1e44928e4bdfed$var$E(async (n)=>new Promise((e)=>setTimeout(e, n)), "waitMs");
var $5d1e44928e4bdfed$var$y = $5d1e44928e4bdfed$var$E(async (n, e, i, r)=>{
    let t = !1;
    return await Promise.race([
        (async ()=>{
            await e.wait(r), t = !0;
        })(),
        (async ()=>{
            for(; !t;){
                if (await $5d1e44928e4bdfed$export$58d6a4bf07475873(3e3), t) return null;
                try {
                    if (!await n.getTransaction(i)) return null;
                } catch (s) {
                    return console.log({
                        error: s
                    }), null;
                }
            }
            return null;
        })()
    ]);
}, "waitWithMempoolCheck"), $5d1e44928e4bdfed$export$363eea3e7285b95a = class {
    constructor(e){
        this.provider = new (0, $6b2231007a47a4de$exports).Web3Provider(e), this.signer = this.provider.getSigner();
    }
    async signMessage(e) {
        try {
            return await this.signer.signMessage(e);
        } catch (i) {
            throw new (0, $6bf9e406f810d981$exports.SignerError)((0, $6bf9e406f810d981$exports.SignerErrorCode).SIGN_TX_ERROR, void 0, i);
        }
    }
    async signAndSendTx(e, i, r) {
        try {
            this.signer = this.provider.getSigner(e.from ?? void 0);
            let t = $5d1e44928e4bdfed$export$363eea3e7285b95a.buildTx(e), s = await this.signer.getChainId(), o = await this.signer.getAddress();
            if (r && s && s !== parseInt(r)) throw new (0, $6bf9e406f810d981$exports.SignerError)((0, $6bf9e406f810d981$exports.SignerErrorCode).UNEXPECTED_BEHAVIOUR, void 0, `Signer chainId: '${s}' doesn't match with required chainId: '${r}' for tx.`);
            if (o && i && o.toLowerCase() !== i.toLowerCase()) throw new (0, $6bf9e406f810d981$exports.SignerError)((0, $6bf9e406f810d981$exports.SignerErrorCode).UNEXPECTED_BEHAVIOUR, void 0, `Signer address: '${o.toLowerCase()}' doesn't match with required address: '${i.toLowerCase()}' for tx.`);
            try {
                let a = await this.signer.sendTransaction(t);
                return {
                    hash: a.hash,
                    response: a
                };
            } catch (a) {
                if (a?.message && typeof a.message == "string" && a.message.indexOf("EIP-1559") !== -1) {
                    console.log("retrying EIP-1559 error without v2 fields ...");
                    let T = $5d1e44928e4bdfed$export$363eea3e7285b95a.buildTx(e, !0), m = await this.signer.sendTransaction(T);
                    return {
                        hash: m.hash,
                        response: m
                    };
                } else throw a;
            }
        } catch (t) {
            throw $5d1e44928e4bdfed$export$2301774de5742bc7(t);
        }
    }
    async wait(e, i, r, t) {
        try {
            if (r) return await r?.wait(t), {
                hash: e
            };
            if (!this.provider) return {
                hash: e
            };
            if (this.signer = this.provider.getSigner(), !i) return {
                hash: e
            };
            let s = await this.signer.getChainId();
            if (!s || parseInt(i) != s) return {
                hash: e
            };
            let o = await this.provider.getTransaction(e);
            if (!o) throw Error(`Transaction hash '${e}' not found in blockchain.`);
            return await $5d1e44928e4bdfed$var$y(this.provider, o, e, t), {
                hash: e
            };
        } catch (s) {
            let o = s;
            if (o?.code === "TRANSACTION_REPLACED" && o?.replacement) return {
                hash: o?.replacement?.hash,
                response: o?.replacement
            };
            if (o?.code === "CALL_EXCEPTION") {
                let a = await $5d1e44928e4bdfed$var$_(i, e);
                if (a) throw new (0, $6bf9e406f810d981$exports.SignerError)((0, $6bf9e406f810d981$exports.SignerErrorCode).TX_FAILED_IN_BLOCKCHAIN, "Trannsaction failed in blockchain", a, (0, $6bf9e406f810d981$exports.RPCErrorCode).CALL_EXCEPTION, o);
                return {
                    hash: e
                };
            }
            throw $5d1e44928e4bdfed$export$2301774de5742bc7(o);
        }
    }
    static buildTx(e, i = !1) {
        let r = {};
        return e.from && (r = {
            ...r,
            from: e.from
        }), e.to && (r = {
            ...r,
            to: e.to
        }), e.data && (r = {
            ...r,
            data: e.data
        }), e.value && (r = {
            ...r,
            value: e.value
        }), e.nonce && (r = {
            ...r,
            nonce: e.nonce
        }), e.gasLimit && (r = {
            ...r,
            gasLimit: e.gasLimit
        }), e.gasPrice && (r = {
            ...r,
            gasPrice: "0x" + parseInt(e.gasPrice).toString(16)
        }), e.maxFeePerGas && !i && (r = {
            ...r,
            maxFeePerGas: e.maxFeePerGas
        }), e.maxPriorityFeePerGas && !i && (r = {
            ...r,
            maxPriorityFeePerGas: e.maxPriorityFeePerGas
        }), r;
    }
};
$5d1e44928e4bdfed$var$E($5d1e44928e4bdfed$export$363eea3e7285b95a, "DefaultEvmSigner");


var $f5669291906fba67$var$c = Object.defineProperty;
var $f5669291906fba67$var$o = (t, e)=>$f5669291906fba67$var$c(t, "name", {
        value: e,
        configurable: !0
    });
function $f5669291906fba67$var$r() {
    let t = !!(0, $c7b1ddb572c90b38$export$bc1a75e20816804a)(), { ethereum: e } = window;
    return t ? (0, $c7b1ddb572c90b38$export$bc1a75e20816804a)("metamask") : e && e.isMetaMask ? e : null;
}
$f5669291906fba67$var$o($f5669291906fba67$var$r, "metamask");
function $f5669291906fba67$var$n(t) {
    let e = new (0, $b0f7ab1c178913fc$export$2006fb7614e99307);
    return e.registerSigner((0, $6fc89aa3c0b05299$export$d513b00599f845d4).EVM, new (0, $5d1e44928e4bdfed$export$363eea3e7285b95a)(t)), e;
}
$f5669291906fba67$var$o($f5669291906fba67$var$n, "getSigners");
var $f5669291906fba67$var$b = (0, $c7b1ddb572c90b38$export$b80cfa133c9c182d).META_MASK, $f5669291906fba67$export$e506a1d27d1eaa20 = {
    type: $f5669291906fba67$var$b
}, $f5669291906fba67$export$8bedcca5bbd73999 = $f5669291906fba67$var$r, $f5669291906fba67$export$64605811ab45167f = $f5669291906fba67$var$o(async ({ instance: t })=>{
    let { accounts: e, chainId: s } = await (0, $c7b1ddb572c90b38$export$785cd5e95d0717c1)(t);
    return {
        accounts: e,
        chainId: s
    };
}, "connect"), $f5669291906fba67$export$ec068583843480e7 = (0, $c7b1ddb572c90b38$export$dae4ecb17c5c4020), $f5669291906fba67$export$f3473d805e486329 = (0, $c7b1ddb572c90b38$export$394219efce660c44), $f5669291906fba67$export$3b3cf9ab9019de20 = (0, $c7b1ddb572c90b38$export$86abff8ce014c125), $f5669291906fba67$export$6352a17a50193ded = $f5669291906fba67$var$n, $f5669291906fba67$export$be9f3c5ed1d25e42 = (0, $c7b1ddb572c90b38$export$4e65aae37dd4fc2c), $f5669291906fba67$export$e5b9d96c6aeb3ff7 = $f5669291906fba67$var$o((t)=>{
    let e = (0, $cd8bb37a306c2b01$export$e2a694e57950e88e)(t);
    return {
        name: "MetaMask",
        img: "https://raw.githubusercontent.com/rango-exchange/assets/main/wallets/metamask/icon.svg",
        installLink: {
            CHROME: "https://chrome.google.com/webstore/detail/metamask/nkbihfbeogaeaoehlefnkodbefgpgknn?hl=en",
            BRAVE: "https://chrome.google.com/webstore/detail/metamask/nkbihfbeogaeaoehlefnkodbefgpgknn?hl=en",
            FIREFOX: "https://addons.mozilla.org/en-US/firefox/addon/ether-metamask",
            EDGE: "https://microsoftedge.microsoft.com/addons/detail/metamask/ejbalbakoplchlghecdalmeeeajnimhm?hl=en-US",
            DEFAULT: "https://metamask.io/download/"
        },
        color: "#dac7ae",
        supportedChains: e
    };
}, "getWalletInfo");


var $4ececec3958d7516$exports = {};

$parcel$export($4ececec3958d7516$exports, "config", function () { return $4ececec3958d7516$export$e506a1d27d1eaa20; });
$parcel$export($4ececec3958d7516$exports, "getInstance", function () { return $4ececec3958d7516$export$8bedcca5bbd73999; });
$parcel$export($4ececec3958d7516$exports, "connect", function () { return $4ececec3958d7516$export$64605811ab45167f; });
$parcel$export($4ececec3958d7516$exports, "subscribe", function () { return $4ececec3958d7516$export$ec068583843480e7; });
$parcel$export($4ececec3958d7516$exports, "suggest", function () { return $4ececec3958d7516$export$b0b3f4ef5d856594; });
$parcel$export($4ececec3958d7516$exports, "getSigners", function () { return $4ececec3958d7516$export$6352a17a50193ded; });
$parcel$export($4ececec3958d7516$exports, "getWalletInfo", function () { return $4ececec3958d7516$export$e5b9d96c6aeb3ff7; });


var $b8ae3714266935c3$exports = {};
"use strict";
var $b8ae3714266935c3$var$__createBinding = $b8ae3714266935c3$exports && $b8ae3714266935c3$exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, {
        enumerable: true,
        get: function() {
            return m[k];
        }
    });
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $b8ae3714266935c3$var$__setModuleDefault = $b8ae3714266935c3$exports && $b8ae3714266935c3$exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $b8ae3714266935c3$var$__importStar = $b8ae3714266935c3$exports && $b8ae3714266935c3$exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $b8ae3714266935c3$var$__createBinding(result, mod, k);
    }
    $b8ae3714266935c3$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty($b8ae3714266935c3$exports, "__esModule", {
    value: true
});
$b8ae3714266935c3$exports.isMsgFundCommunityPool = $b8ae3714266935c3$exports.isMsgEditValidator = $b8ae3714266935c3$exports.isMsgDelegate = $b8ae3714266935c3$exports.isMsgCreateValidator = $b8ae3714266935c3$exports.isMsgBeginRedelegate = $b8ae3714266935c3$exports.uint64ToString = $b8ae3714266935c3$exports.uint64ToNumber = $b8ae3714266935c3$exports.setupSupplyExtension = $b8ae3714266935c3$exports.setupStakingExtension = $b8ae3714266935c3$exports.setupSlashingExtension = $b8ae3714266935c3$exports.setupMintExtension = $b8ae3714266935c3$exports.setupGovExtension = $b8ae3714266935c3$exports.setupDistributionExtension = $b8ae3714266935c3$exports.setupBankExtension = $b8ae3714266935c3$exports.setupAuthExtension = $b8ae3714266935c3$exports.normalizePubkey = $b8ae3714266935c3$exports.normalizeLcdApiArray = $b8ae3714266935c3$exports.LcdClient = $b8ae3714266935c3$exports.BroadcastMode = $b8ae3714266935c3$exports.GasPrice = $b8ae3714266935c3$exports.buildFeeTable = $b8ae3714266935c3$exports.isSearchByTagsQuery = $b8ae3714266935c3$exports.isSearchBySentFromOrToQuery = $b8ae3714266935c3$exports.isSearchByHeightQuery = $b8ae3714266935c3$exports.isBroadcastTxSuccess = $b8ae3714266935c3$exports.isBroadcastTxFailure = $b8ae3714266935c3$exports.CosmosClient = $b8ae3714266935c3$exports.assertIsBroadcastTxSuccess = $b8ae3714266935c3$exports.logs = $b8ae3714266935c3$exports.serializeSignDoc = $b8ae3714266935c3$exports.Secp256k1Wallet = $b8ae3714266935c3$exports.Secp256k1HdWallet = $b8ae3714266935c3$exports.pubkeyType = $b8ae3714266935c3$exports.pubkeyToAddress = $b8ae3714266935c3$exports.parseCoins = $b8ae3714266935c3$exports.makeStdTx = $b8ae3714266935c3$exports.makeSignDoc = $b8ae3714266935c3$exports.makeCosmoshubPath = $b8ae3714266935c3$exports.isStdTx = $b8ae3714266935c3$exports.extractKdfConfiguration = $b8ae3714266935c3$exports.executeKdf = $b8ae3714266935c3$exports.encodeSecp256k1Signature = $b8ae3714266935c3$exports.encodeSecp256k1Pubkey = $b8ae3714266935c3$exports.encodeBech32Pubkey = $b8ae3714266935c3$exports.encodeAminoPubkey = $b8ae3714266935c3$exports.decodeSignature = $b8ae3714266935c3$exports.decodeBech32Pubkey = $b8ae3714266935c3$exports.decodeAminoPubkey = $b8ae3714266935c3$exports.coins = $b8ae3714266935c3$exports.coin = void 0;
$b8ae3714266935c3$exports.isWrappedStdTx = $b8ae3714266935c3$exports.SigningCosmosClient = $b8ae3714266935c3$exports.findSequenceForSignedTx = $b8ae3714266935c3$exports.isMsgWithdrawValidatorCommission = $b8ae3714266935c3$exports.isMsgWithdrawDelegatorReward = $b8ae3714266935c3$exports.isMsgUndelegate = $b8ae3714266935c3$exports.isMsgSetWithdrawAddress = $b8ae3714266935c3$exports.isMsgSend = $b8ae3714266935c3$exports.isMsgMultiSend = void 0;
var $a11446128a9e19fc$exports = {};
"use strict";
Object.defineProperty($a11446128a9e19fc$exports, "__esModule", {
    value: true
});
$a11446128a9e19fc$exports.executeKdf = $a11446128a9e19fc$exports.makeStdTx = $a11446128a9e19fc$exports.isStdTx = $a11446128a9e19fc$exports.serializeSignDoc = $a11446128a9e19fc$exports.makeSignDoc = $a11446128a9e19fc$exports.encodeSecp256k1Signature = $a11446128a9e19fc$exports.decodeSignature = $a11446128a9e19fc$exports.Secp256k1Wallet = $a11446128a9e19fc$exports.Secp256k1HdWallet = $a11446128a9e19fc$exports.extractKdfConfiguration = $a11446128a9e19fc$exports.pubkeyType = $a11446128a9e19fc$exports.isSinglePubkey = $a11446128a9e19fc$exports.isSecp256k1Pubkey = $a11446128a9e19fc$exports.isMultisigThresholdPubkey = $a11446128a9e19fc$exports.isEd25519Pubkey = $a11446128a9e19fc$exports.makeCosmoshubPath = $a11446128a9e19fc$exports.createMultisigThresholdPubkey = $a11446128a9e19fc$exports.encodeSecp256k1Pubkey = $a11446128a9e19fc$exports.encodeBech32Pubkey = $a11446128a9e19fc$exports.encodeAminoPubkey = $a11446128a9e19fc$exports.decodeBech32Pubkey = $a11446128a9e19fc$exports.decodeAminoPubkey = $a11446128a9e19fc$exports.parseCoins = $a11446128a9e19fc$exports.coins = $a11446128a9e19fc$exports.coin = $a11446128a9e19fc$exports.rawSecp256k1PubkeyToRawAddress = $a11446128a9e19fc$exports.rawEd25519PubkeyToRawAddress = $a11446128a9e19fc$exports.pubkeyToRawAddress = $a11446128a9e19fc$exports.pubkeyToAddress = void 0;
var $5ef7be25afc40ef7$exports = {};
"use strict";
// See https://github.com/tendermint/tendermint/blob/f2ada0a604b4c0763bda2f64fac53d506d3beca7/docs/spec/blockchain/encoding.md#public-key-cryptography
Object.defineProperty($5ef7be25afc40ef7$exports, "__esModule", {
    value: true
});
$5ef7be25afc40ef7$exports.pubkeyToAddress = $5ef7be25afc40ef7$exports.pubkeyToRawAddress = $5ef7be25afc40ef7$exports.rawSecp256k1PubkeyToRawAddress = $5ef7be25afc40ef7$exports.rawEd25519PubkeyToRawAddress = void 0;
var $ca4c58922ce7f03a$exports = {};
"use strict";
Object.defineProperty($ca4c58922ce7f03a$exports, "__esModule", {
    value: true
});
$ca4c58922ce7f03a$exports.stringToPath = $ca4c58922ce7f03a$exports.Slip10RawIndex = $ca4c58922ce7f03a$exports.slip10CurveFromString = $ca4c58922ce7f03a$exports.Slip10Curve = $ca4c58922ce7f03a$exports.Slip10 = $ca4c58922ce7f03a$exports.pathToString = $ca4c58922ce7f03a$exports.sha512 = $ca4c58922ce7f03a$exports.Sha512 = $ca4c58922ce7f03a$exports.sha256 = $ca4c58922ce7f03a$exports.Sha256 = $ca4c58922ce7f03a$exports.sha1 = $ca4c58922ce7f03a$exports.Sha1 = $ca4c58922ce7f03a$exports.Secp256k1Signature = $ca4c58922ce7f03a$exports.ExtendedSecp256k1Signature = $ca4c58922ce7f03a$exports.Secp256k1 = $ca4c58922ce7f03a$exports.ripemd160 = $ca4c58922ce7f03a$exports.Ripemd160 = $ca4c58922ce7f03a$exports.Random = $ca4c58922ce7f03a$exports.Xchacha20poly1305Ietf = $ca4c58922ce7f03a$exports.xchacha20NonceLength = $ca4c58922ce7f03a$exports.isArgon2idOptions = $ca4c58922ce7f03a$exports.Ed25519Keypair = $ca4c58922ce7f03a$exports.Ed25519 = $ca4c58922ce7f03a$exports.Argon2id = $ca4c58922ce7f03a$exports.keccak256 = $ca4c58922ce7f03a$exports.Keccak256 = $ca4c58922ce7f03a$exports.Hmac = $ca4c58922ce7f03a$exports.EnglishMnemonic = $ca4c58922ce7f03a$exports.Bip39 = void 0;
var $68ae3a3bfd741578$exports = {};
"use strict";
var $68ae3a3bfd741578$var$__createBinding = $68ae3a3bfd741578$exports && $68ae3a3bfd741578$exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, {
        enumerable: true,
        get: function() {
            return m[k];
        }
    });
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $68ae3a3bfd741578$var$__setModuleDefault = $68ae3a3bfd741578$exports && $68ae3a3bfd741578$exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $68ae3a3bfd741578$var$__importStar = $68ae3a3bfd741578$exports && $68ae3a3bfd741578$exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $68ae3a3bfd741578$var$__createBinding(result, mod, k);
    }
    $68ae3a3bfd741578$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty($68ae3a3bfd741578$exports, "__esModule", {
    value: true
});
$68ae3a3bfd741578$exports.Bip39 = void 0;
var $3977281a39984aec$exports = {};
"use strict";
Object.defineProperty($3977281a39984aec$exports, "__esModule", {
    value: true
});
$3977281a39984aec$exports.toUtf8 = $3977281a39984aec$exports.fromUtf8 = $3977281a39984aec$exports.toRfc3339 = $3977281a39984aec$exports.fromRfc3339 = $3977281a39984aec$exports.toHex = $3977281a39984aec$exports.fromHex = $3977281a39984aec$exports.Bech32 = $3977281a39984aec$exports.toBase64 = $3977281a39984aec$exports.fromBase64 = $3977281a39984aec$exports.toAscii = $3977281a39984aec$exports.fromAscii = void 0;
var $b8f42953abcfa60d$exports = {};
"use strict";
Object.defineProperty($b8f42953abcfa60d$exports, "__esModule", {
    value: true
});
$b8f42953abcfa60d$exports.fromAscii = $b8f42953abcfa60d$exports.toAscii = void 0;
function $b8f42953abcfa60d$var$toAscii(input) {
    const toNums = (str)=>str.split("").map((x)=>{
            const charCode = x.charCodeAt(0);
            // 0x00–0x1F control characters
            // 0x20–0x7E printable characters
            // 0x7F delete character
            // 0x80–0xFF out of 7 bit ascii range
            if (charCode < 0x20 || charCode > 0x7e) throw new Error("Cannot encode character that is out of printable ASCII range: " + charCode);
            return charCode;
        });
    return Uint8Array.from(toNums(input));
}
$b8f42953abcfa60d$exports.toAscii = $b8f42953abcfa60d$var$toAscii;
function $b8f42953abcfa60d$var$fromAscii(data) {
    const fromNums = (listOfNumbers)=>listOfNumbers.map((x)=>{
            // 0x00–0x1F control characters
            // 0x20–0x7E printable characters
            // 0x7F delete character
            // 0x80–0xFF out of 7 bit ascii range
            if (x < 0x20 || x > 0x7e) throw new Error("Cannot decode character that is out of printable ASCII range: " + x);
            return String.fromCharCode(x);
        });
    return fromNums(Array.from(data)).join("");
}
$b8f42953abcfa60d$exports.fromAscii = $b8f42953abcfa60d$var$fromAscii;


Object.defineProperty($3977281a39984aec$exports, "fromAscii", {
    enumerable: true,
    get: function() {
        return $b8f42953abcfa60d$exports.fromAscii;
    }
});
Object.defineProperty($3977281a39984aec$exports, "toAscii", {
    enumerable: true,
    get: function() {
        return $b8f42953abcfa60d$exports.toAscii;
    }
});
var $5264f9efb6af8b82$exports = {};
"use strict";
var $5264f9efb6af8b82$var$__createBinding = $5264f9efb6af8b82$exports && $5264f9efb6af8b82$exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, {
        enumerable: true,
        get: function() {
            return m[k];
        }
    });
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $5264f9efb6af8b82$var$__setModuleDefault = $5264f9efb6af8b82$exports && $5264f9efb6af8b82$exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $5264f9efb6af8b82$var$__importStar = $5264f9efb6af8b82$exports && $5264f9efb6af8b82$exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $5264f9efb6af8b82$var$__createBinding(result, mod, k);
    }
    $5264f9efb6af8b82$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty($5264f9efb6af8b82$exports, "__esModule", {
    value: true
});
$5264f9efb6af8b82$exports.fromBase64 = $5264f9efb6af8b82$exports.toBase64 = void 0;

const $5264f9efb6af8b82$var$base64js = $5264f9efb6af8b82$var$__importStar((parcelRequire("hqZtu")));
function $5264f9efb6af8b82$var$toBase64(data) {
    return $5264f9efb6af8b82$var$base64js.fromByteArray(data);
}
$5264f9efb6af8b82$exports.toBase64 = $5264f9efb6af8b82$var$toBase64;
function $5264f9efb6af8b82$var$fromBase64(base64String) {
    if (!base64String.match(/^[a-zA-Z0-9+/]*={0,2}$/)) throw new Error("Invalid base64 string format");
    return $5264f9efb6af8b82$var$base64js.toByteArray(base64String);
}
$5264f9efb6af8b82$exports.fromBase64 = $5264f9efb6af8b82$var$fromBase64;


Object.defineProperty($3977281a39984aec$exports, "fromBase64", {
    enumerable: true,
    get: function() {
        return $5264f9efb6af8b82$exports.fromBase64;
    }
});
Object.defineProperty($3977281a39984aec$exports, "toBase64", {
    enumerable: true,
    get: function() {
        return $5264f9efb6af8b82$exports.toBase64;
    }
});
var $dc0fbfb090a515f0$exports = {};
"use strict";
var $dc0fbfb090a515f0$var$__createBinding = $dc0fbfb090a515f0$exports && $dc0fbfb090a515f0$exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, {
        enumerable: true,
        get: function() {
            return m[k];
        }
    });
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $dc0fbfb090a515f0$var$__setModuleDefault = $dc0fbfb090a515f0$exports && $dc0fbfb090a515f0$exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $dc0fbfb090a515f0$var$__importStar = $dc0fbfb090a515f0$exports && $dc0fbfb090a515f0$exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $dc0fbfb090a515f0$var$__createBinding(result, mod, k);
    }
    $dc0fbfb090a515f0$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty($dc0fbfb090a515f0$exports, "__esModule", {
    value: true
});
$dc0fbfb090a515f0$exports.Bech32 = void 0;

const $dc0fbfb090a515f0$var$bech32 = $dc0fbfb090a515f0$var$__importStar((parcelRequire("5wgCY")));
class $dc0fbfb090a515f0$var$Bech32 {
    static encode(prefix, data, limit) {
        const address = $dc0fbfb090a515f0$var$bech32.encode(prefix, $dc0fbfb090a515f0$var$bech32.toWords(data), limit);
        return address;
    }
    static decode(address, limit = Infinity) {
        const decodedAddress = $dc0fbfb090a515f0$var$bech32.decode(address, limit);
        return {
            prefix: decodedAddress.prefix,
            data: new Uint8Array($dc0fbfb090a515f0$var$bech32.fromWords(decodedAddress.words))
        };
    }
}
$dc0fbfb090a515f0$exports.Bech32 = $dc0fbfb090a515f0$var$Bech32;


Object.defineProperty($3977281a39984aec$exports, "Bech32", {
    enumerable: true,
    get: function() {
        return $dc0fbfb090a515f0$exports.Bech32;
    }
});
var $e9ad39fc42b51dd4$exports = {};
"use strict";
Object.defineProperty($e9ad39fc42b51dd4$exports, "__esModule", {
    value: true
});
$e9ad39fc42b51dd4$exports.fromHex = $e9ad39fc42b51dd4$exports.toHex = void 0;
function $e9ad39fc42b51dd4$var$toHex(data) {
    let out = "";
    for (const byte of data)out += ("0" + byte.toString(16)).slice(-2);
    return out;
}
$e9ad39fc42b51dd4$exports.toHex = $e9ad39fc42b51dd4$var$toHex;
function $e9ad39fc42b51dd4$var$fromHex(hexstring) {
    if (hexstring.length % 2 !== 0) throw new Error("hex string length must be a multiple of 2");
    const listOfInts = [];
    for(let i = 0; i < hexstring.length; i += 2){
        const hexByteAsString = hexstring.substr(i, 2);
        if (!hexByteAsString.match(/[0-9a-f]{2}/i)) throw new Error("hex string contains invalid characters");
        listOfInts.push(parseInt(hexByteAsString, 16));
    }
    return new Uint8Array(listOfInts);
}
$e9ad39fc42b51dd4$exports.fromHex = $e9ad39fc42b51dd4$var$fromHex;


Object.defineProperty($3977281a39984aec$exports, "fromHex", {
    enumerable: true,
    get: function() {
        return $e9ad39fc42b51dd4$exports.fromHex;
    }
});
Object.defineProperty($3977281a39984aec$exports, "toHex", {
    enumerable: true,
    get: function() {
        return $e9ad39fc42b51dd4$exports.toHex;
    }
});
var $d277429012792d04$exports = {};
"use strict";
Object.defineProperty($d277429012792d04$exports, "__esModule", {
    value: true
});
$d277429012792d04$exports.toRfc3339 = $d277429012792d04$exports.fromRfc3339 = void 0;
const $d277429012792d04$var$rfc3339Matcher = /^(\d{4})-(\d{2})-(\d{2})[T ](\d{2}):(\d{2}):(\d{2})(\.\d{1,9})?((?:[+-]\d{2}:\d{2})|Z)$/;
function $d277429012792d04$var$padded(integer, length = 2) {
    const filled = "00000" + integer.toString();
    return filled.substring(filled.length - length);
}
function $d277429012792d04$var$fromRfc3339(str) {
    const matches = $d277429012792d04$var$rfc3339Matcher.exec(str);
    if (!matches) throw new Error("Date string is not in RFC3339 format");
    const year = +matches[1];
    const month = +matches[2];
    const day = +matches[3];
    const hour = +matches[4];
    const minute = +matches[5];
    const second = +matches[6];
    // fractional seconds match either undefined or a string like ".1", ".123456789"
    const milliSeconds = matches[7] ? Math.floor(+matches[7] * 1000) : 0;
    let tzOffsetSign;
    let tzOffsetHours;
    let tzOffsetMinutes;
    // if timezone is undefined, it must be Z or nothing (otherwise the group would have captured).
    if (matches[8] === "Z") {
        tzOffsetSign = 1;
        tzOffsetHours = 0;
        tzOffsetMinutes = 0;
    } else {
        tzOffsetSign = matches[8].substring(0, 1) === "-" ? -1 : 1;
        tzOffsetHours = +matches[8].substring(1, 3);
        tzOffsetMinutes = +matches[8].substring(4, 6);
    }
    const tzOffset = tzOffsetSign * (tzOffsetHours * 60 + tzOffsetMinutes) * 60; // seconds
    const timestamp = Date.UTC(year, month - 1, day, hour, minute, second, milliSeconds) - tzOffset * 1000;
    return new Date(timestamp);
}
$d277429012792d04$exports.fromRfc3339 = $d277429012792d04$var$fromRfc3339;
function $d277429012792d04$var$toRfc3339(date) {
    const year = date.getUTCFullYear();
    const month = $d277429012792d04$var$padded(date.getUTCMonth() + 1);
    const day = $d277429012792d04$var$padded(date.getUTCDate());
    const hour = $d277429012792d04$var$padded(date.getUTCHours());
    const minute = $d277429012792d04$var$padded(date.getUTCMinutes());
    const second = $d277429012792d04$var$padded(date.getUTCSeconds());
    const ms = $d277429012792d04$var$padded(date.getUTCMilliseconds(), 3);
    return `${year}-${month}-${day}T${hour}:${minute}:${second}.${ms}Z`;
}
$d277429012792d04$exports.toRfc3339 = $d277429012792d04$var$toRfc3339;


Object.defineProperty($3977281a39984aec$exports, "fromRfc3339", {
    enumerable: true,
    get: function() {
        return $d277429012792d04$exports.fromRfc3339;
    }
});
Object.defineProperty($3977281a39984aec$exports, "toRfc3339", {
    enumerable: true,
    get: function() {
        return $d277429012792d04$exports.toRfc3339;
    }
});
var $1a58daa44cf9b78c$exports = {};
"use strict";
Object.defineProperty($1a58daa44cf9b78c$exports, "__esModule", {
    value: true
});
$1a58daa44cf9b78c$exports.fromUtf8 = $1a58daa44cf9b78c$exports.toUtf8 = void 0;
function $1a58daa44cf9b78c$var$toUtf8(str) {
    return new TextEncoder().encode(str);
}
$1a58daa44cf9b78c$exports.toUtf8 = $1a58daa44cf9b78c$var$toUtf8;
function $1a58daa44cf9b78c$var$fromUtf8(data) {
    return new TextDecoder("utf-8", {
        fatal: true
    }).decode(data);
}
$1a58daa44cf9b78c$exports.fromUtf8 = $1a58daa44cf9b78c$var$fromUtf8;


Object.defineProperty($3977281a39984aec$exports, "fromUtf8", {
    enumerable: true,
    get: function() {
        return $1a58daa44cf9b78c$exports.fromUtf8;
    }
});
Object.defineProperty($3977281a39984aec$exports, "toUtf8", {
    enumerable: true,
    get: function() {
        return $1a58daa44cf9b78c$exports.toUtf8;
    }
});



const $68ae3a3bfd741578$var$bip39 = $68ae3a3bfd741578$var$__importStar((parcelRequire("5qnT8")));
var $2457a46325952964$exports = {};
"use strict";
var $2457a46325952964$var$__createBinding = $2457a46325952964$exports && $2457a46325952964$exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, {
        enumerable: true,
        get: function() {
            return m[k];
        }
    });
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $2457a46325952964$var$__setModuleDefault = $2457a46325952964$exports && $2457a46325952964$exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $2457a46325952964$var$__importStar = $2457a46325952964$exports && $2457a46325952964$exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $2457a46325952964$var$__createBinding(result, mod, k);
    }
    $2457a46325952964$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty($2457a46325952964$exports, "__esModule", {
    value: true
});
$2457a46325952964$exports.EnglishMnemonic = void 0;

const $2457a46325952964$var$bip39 = $2457a46325952964$var$__importStar((parcelRequire("5qnT8")));
class $2457a46325952964$var$EnglishMnemonic {
    constructor(mnemonic){
        if (!$2457a46325952964$var$EnglishMnemonic.mnemonicMatcher.test(mnemonic)) throw new Error("Invalid mnemonic format");
        const words = mnemonic.split(" ");
        const allowedWordsLengths = [
            12,
            15,
            18,
            21,
            24
        ];
        if (allowedWordsLengths.indexOf(words.length) === -1) throw new Error(`Invalid word count in mnemonic (allowed: ${allowedWordsLengths} got: ${words.length})`);
        for (const word of words){
            if ($2457a46325952964$var$EnglishMnemonic.wordlist.indexOf(word) === -1) throw new Error("Mnemonic contains invalid word");
        }
        // Throws with informative error message if mnemonic is not valid
        $2457a46325952964$var$bip39.mnemonicToEntropy(mnemonic);
        this.data = mnemonic;
    }
    toString() {
        return this.data;
    }
}
$2457a46325952964$exports.EnglishMnemonic = $2457a46325952964$var$EnglishMnemonic;
$2457a46325952964$var$EnglishMnemonic.wordlist = $2457a46325952964$var$bip39.wordlists.english;
// list of space separated lower case words (1 or more)
$2457a46325952964$var$EnglishMnemonic.mnemonicMatcher = /^[a-z]+( [a-z]+)*$/;


class $68ae3a3bfd741578$var$Bip39 {
    /**
     * Encodes raw entropy of length 16, 20, 24, 28 or 32 bytes as an English mnemonic between 12 and 24 words.
     *
     * | Entropy            | Words |
     * |--------------------|-------|
     * | 128 bit (16 bytes) |    12 |
     * | 160 bit (20 bytes) |    15 |
     * | 192 bit (24 bytes) |    18 |
     * | 224 bit (28 bytes) |    21 |
     * | 256 bit (32 bytes) |    24 |
     *
     *
     * @see https://github.com/bitcoin/bips/blob/master/bip-0039.mediawiki#generating-the-mnemonic
     * @param entropy The entropy to be encoded. This must be cryptographically secure.
     */ static encode(entropy) {
        const allowedEntropyLengths = [
            16,
            20,
            24,
            28,
            32
        ];
        if (allowedEntropyLengths.indexOf(entropy.length) === -1) throw new Error("invalid input length");
        return new $2457a46325952964$exports.EnglishMnemonic($68ae3a3bfd741578$var$bip39.entropyToMnemonic((0, $3977281a39984aec$exports.toHex)(entropy)));
    }
    static decode(mnemonic) {
        return (0, $3977281a39984aec$exports.fromHex)($68ae3a3bfd741578$var$bip39.mnemonicToEntropy(mnemonic.toString()));
    }
    static async mnemonicToSeed(mnemonic, password) {
        return new Uint8Array(await $68ae3a3bfd741578$var$bip39.mnemonicToSeed(mnemonic.toString(), password));
    }
}
$68ae3a3bfd741578$exports.Bip39 = $68ae3a3bfd741578$var$Bip39;


Object.defineProperty($ca4c58922ce7f03a$exports, "Bip39", {
    enumerable: true,
    get: function() {
        return $68ae3a3bfd741578$exports.Bip39;
    }
});

Object.defineProperty($ca4c58922ce7f03a$exports, "EnglishMnemonic", {
    enumerable: true,
    get: function() {
        return $2457a46325952964$exports.EnglishMnemonic;
    }
});
var $f3b21ddb1d896800$exports = {};
"use strict";
Object.defineProperty($f3b21ddb1d896800$exports, "__esModule", {
    value: true
});
$f3b21ddb1d896800$exports.Hmac = void 0;
class $f3b21ddb1d896800$var$Hmac {
    constructor(hashFunctionConstructor, originalKey){
        // This implementation is based on https://en.wikipedia.org/wiki/HMAC#Implementation
        // with the addition of incremental hashing support. Thus part of the algorithm
        // is in the constructor and the rest in digest().
        const blockSize = new hashFunctionConstructor().blockSize;
        this.hash = (data)=>new hashFunctionConstructor().update(data).digest();
        let key = originalKey;
        if (key.length > blockSize) key = this.hash(key);
        if (key.length < blockSize) {
            const zeroPadding = new Uint8Array(blockSize - key.length);
            key = new Uint8Array([
                ...key,
                ...zeroPadding
            ]);
        }
        // eslint-disable-next-line no-bitwise
        this.oKeyPad = key.map((keyByte)=>keyByte ^ 0x5c);
        // eslint-disable-next-line no-bitwise
        this.iKeyPad = key.map((keyByte)=>keyByte ^ 0x36);
        this.messageHasher = new hashFunctionConstructor();
        this.blockSize = blockSize;
        this.update(this.iKeyPad);
    }
    update(data) {
        this.messageHasher.update(data);
        return this;
    }
    digest() {
        const innerHash = this.messageHasher.digest();
        return this.hash(new Uint8Array([
            ...this.oKeyPad,
            ...innerHash
        ]));
    }
}
$f3b21ddb1d896800$exports.Hmac = $f3b21ddb1d896800$var$Hmac;


Object.defineProperty($ca4c58922ce7f03a$exports, "Hmac", {
    enumerable: true,
    get: function() {
        return $f3b21ddb1d896800$exports.Hmac;
    }
});
var $2fee38e00898059f$exports = {};
"use strict";
var $2fee38e00898059f$var$__importDefault = $2fee38e00898059f$exports && $2fee38e00898059f$exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty($2fee38e00898059f$exports, "__esModule", {
    value: true
});
$2fee38e00898059f$exports.keccak256 = $2fee38e00898059f$exports.Keccak256 = void 0;

const $2fee38e00898059f$var$js_sha3_1 = $2fee38e00898059f$var$__importDefault((parcelRequire("baOVG")));
class $2fee38e00898059f$var$Keccak256 {
    constructor(firstData){
        this.blockSize = 64;
        this.impl = $2fee38e00898059f$var$js_sha3_1.default.keccak256.create();
        if (firstData) this.update(firstData);
    }
    update(data) {
        this.impl.update(data);
        return this;
    }
    digest() {
        return new Uint8Array(this.impl.digest());
    }
}
$2fee38e00898059f$exports.Keccak256 = $2fee38e00898059f$var$Keccak256;
/** Convenience function equivalent to `new Keccak256(data).digest()` */ function $2fee38e00898059f$var$keccak256(data) {
    return new $2fee38e00898059f$var$Keccak256(data).digest();
}
$2fee38e00898059f$exports.keccak256 = $2fee38e00898059f$var$keccak256;


Object.defineProperty($ca4c58922ce7f03a$exports, "Keccak256", {
    enumerable: true,
    get: function() {
        return $2fee38e00898059f$exports.Keccak256;
    }
});
Object.defineProperty($ca4c58922ce7f03a$exports, "keccak256", {
    enumerable: true,
    get: function() {
        return $2fee38e00898059f$exports.keccak256;
    }
});
var $353f600b48779e58$exports = {};
"use strict";
// Keep all classes requiring libsodium-js in one file as having multiple
// requiring of the libsodium-wrappers module currently crashes browsers
//
// libsodium.js API: https://gist.github.com/webmaster128/b2dbe6d54d36dd168c9fabf441b9b09c
var $353f600b48779e58$var$__importDefault = $353f600b48779e58$exports && $353f600b48779e58$exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty($353f600b48779e58$exports, "__esModule", {
    value: true
});
$353f600b48779e58$exports.Xchacha20poly1305Ietf = $353f600b48779e58$exports.xchacha20NonceLength = $353f600b48779e58$exports.Ed25519 = $353f600b48779e58$exports.Ed25519Keypair = $353f600b48779e58$exports.Argon2id = $353f600b48779e58$exports.isArgon2idOptions = void 0;

var $dOLgD = parcelRequire("dOLgD");

const $353f600b48779e58$var$libsodium_wrappers_1 = $353f600b48779e58$var$__importDefault((parcelRequire("dFkC5")));
function $353f600b48779e58$var$isArgon2idOptions(thing) {
    if (!(0, $dOLgD.isNonNullObject)(thing)) return false;
    if (typeof thing.outputLength !== "number") return false;
    if (typeof thing.opsLimit !== "number") return false;
    if (typeof thing.memLimitKib !== "number") return false;
    return true;
}
$353f600b48779e58$exports.isArgon2idOptions = $353f600b48779e58$var$isArgon2idOptions;
class $353f600b48779e58$var$Argon2id {
    static async execute(password, salt, options) {
        await $353f600b48779e58$var$libsodium_wrappers_1.default.ready;
        return $353f600b48779e58$var$libsodium_wrappers_1.default.crypto_pwhash(options.outputLength, password, salt, options.opsLimit, options.memLimitKib * 1024, $353f600b48779e58$var$libsodium_wrappers_1.default.crypto_pwhash_ALG_ARGON2ID13);
    }
}
$353f600b48779e58$exports.Argon2id = $353f600b48779e58$var$Argon2id;
class $353f600b48779e58$var$Ed25519Keypair {
    constructor(privkey, pubkey){
        this.privkey = privkey;
        this.pubkey = pubkey;
    }
    // a libsodium privkey has the format `<ed25519 privkey> + <ed25519 pubkey>`
    static fromLibsodiumPrivkey(libsodiumPrivkey) {
        if (libsodiumPrivkey.length !== 64) throw new Error(`Unexpected key length ${libsodiumPrivkey.length}. Must be 64.`);
        return new $353f600b48779e58$var$Ed25519Keypair(libsodiumPrivkey.slice(0, 32), libsodiumPrivkey.slice(32, 64));
    }
    toLibsodiumPrivkey() {
        return new Uint8Array([
            ...this.privkey,
            ...this.pubkey
        ]);
    }
}
$353f600b48779e58$exports.Ed25519Keypair = $353f600b48779e58$var$Ed25519Keypair;
class $353f600b48779e58$var$Ed25519 {
    /**
     * Generates a keypair deterministically from a given 32 bytes seed.
     *
     * This seed equals the Ed25519 private key.
     * For implementation details see crypto_sign_seed_keypair in
     * https://download.libsodium.org/doc/public-key_cryptography/public-key_signatures.html
     * and diagram on https://blog.mozilla.org/warner/2011/11/29/ed25519-keys/
     */ static async makeKeypair(seed) {
        await $353f600b48779e58$var$libsodium_wrappers_1.default.ready;
        const keypair = $353f600b48779e58$var$libsodium_wrappers_1.default.crypto_sign_seed_keypair(seed);
        return $353f600b48779e58$var$Ed25519Keypair.fromLibsodiumPrivkey(keypair.privateKey);
    }
    static async createSignature(message, keyPair) {
        await $353f600b48779e58$var$libsodium_wrappers_1.default.ready;
        return $353f600b48779e58$var$libsodium_wrappers_1.default.crypto_sign_detached(message, keyPair.toLibsodiumPrivkey());
    }
    static async verifySignature(signature, message, pubkey) {
        await $353f600b48779e58$var$libsodium_wrappers_1.default.ready;
        return $353f600b48779e58$var$libsodium_wrappers_1.default.crypto_sign_verify_detached(signature, message, pubkey);
    }
}
$353f600b48779e58$exports.Ed25519 = $353f600b48779e58$var$Ed25519;
/**
 * Nonce length in bytes for all flavours of XChaCha20.
 *
 * @see https://libsodium.gitbook.io/doc/advanced/stream_ciphers/xchacha20#notes
 */ $353f600b48779e58$exports.xchacha20NonceLength = 24;
class $353f600b48779e58$var$Xchacha20poly1305Ietf {
    static async encrypt(message, key, nonce) {
        await $353f600b48779e58$var$libsodium_wrappers_1.default.ready;
        const additionalData = null;
        return $353f600b48779e58$var$libsodium_wrappers_1.default.crypto_aead_xchacha20poly1305_ietf_encrypt(message, additionalData, null, nonce, key);
    }
    static async decrypt(ciphertext, key, nonce) {
        await $353f600b48779e58$var$libsodium_wrappers_1.default.ready;
        const additionalData = null;
        return $353f600b48779e58$var$libsodium_wrappers_1.default.crypto_aead_xchacha20poly1305_ietf_decrypt(null, ciphertext, additionalData, nonce, key);
    }
}
$353f600b48779e58$exports.Xchacha20poly1305Ietf = $353f600b48779e58$var$Xchacha20poly1305Ietf;


Object.defineProperty($ca4c58922ce7f03a$exports, "Argon2id", {
    enumerable: true,
    get: function() {
        return $353f600b48779e58$exports.Argon2id;
    }
});
Object.defineProperty($ca4c58922ce7f03a$exports, "Ed25519", {
    enumerable: true,
    get: function() {
        return $353f600b48779e58$exports.Ed25519;
    }
});
Object.defineProperty($ca4c58922ce7f03a$exports, "Ed25519Keypair", {
    enumerable: true,
    get: function() {
        return $353f600b48779e58$exports.Ed25519Keypair;
    }
});
Object.defineProperty($ca4c58922ce7f03a$exports, "isArgon2idOptions", {
    enumerable: true,
    get: function() {
        return $353f600b48779e58$exports.isArgon2idOptions;
    }
});
Object.defineProperty($ca4c58922ce7f03a$exports, "xchacha20NonceLength", {
    enumerable: true,
    get: function() {
        return $353f600b48779e58$exports.xchacha20NonceLength;
    }
});
Object.defineProperty($ca4c58922ce7f03a$exports, "Xchacha20poly1305Ietf", {
    enumerable: true,
    get: function() {
        return $353f600b48779e58$exports.Xchacha20poly1305Ietf;
    }
});
var $04ae6d84c1d30cc6$exports = {};
"use strict";
Object.defineProperty($04ae6d84c1d30cc6$exports, "__esModule", {
    value: true
});
$04ae6d84c1d30cc6$exports.Random = void 0;

class $04ae6d84c1d30cc6$var$Random {
    /**
     * Returns `count` cryptographically secure random bytes
     */ static getBytes(count) {
        try {
            const globalObject = typeof window === "object" ? window : self;
            const cryptoApi = typeof globalObject.crypto !== "undefined" ? globalObject.crypto : globalObject.msCrypto;
            const out = new Uint8Array(count);
            cryptoApi.getRandomValues(out);
            return out;
        } catch (_a) {
            try {
                // eslint-disable-next-line @typescript-eslint/no-var-requires
                const crypto = (parcelRequire("aO8Ot"));
                return new Uint8Array([
                    ...crypto.randomBytes(count)
                ]);
            } catch (_b) {
                throw new Error("No secure random number generator found");
            }
        }
    }
}
$04ae6d84c1d30cc6$exports.Random = $04ae6d84c1d30cc6$var$Random;


Object.defineProperty($ca4c58922ce7f03a$exports, "Random", {
    enumerable: true,
    get: function() {
        return $04ae6d84c1d30cc6$exports.Random;
    }
});
var $960e1a22badfcd58$exports = {};

var $ihoyg = parcelRequire("ihoyg");
var $960e1a22badfcd58$require$Buffer = $ihoyg.Buffer;
"use strict";
var $960e1a22badfcd58$var$__importDefault = $960e1a22badfcd58$exports && $960e1a22badfcd58$exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty($960e1a22badfcd58$exports, "__esModule", {
    value: true
});
$960e1a22badfcd58$exports.ripemd160 = $960e1a22badfcd58$exports.Ripemd160 = void 0;

const $960e1a22badfcd58$var$ripemd160_1 = $960e1a22badfcd58$var$__importDefault((parcelRequire("cjuEr")));
class $960e1a22badfcd58$var$Ripemd160 {
    constructor(firstData){
        this.blockSize = 64;
        this.impl = new $960e1a22badfcd58$var$ripemd160_1.default();
        if (firstData) this.update(firstData);
    }
    update(data) {
        this.impl.update($960e1a22badfcd58$require$Buffer.from(data));
        return this;
    }
    digest() {
        return Uint8Array.from(this.impl.digest());
    }
}
$960e1a22badfcd58$exports.Ripemd160 = $960e1a22badfcd58$var$Ripemd160;
/** Convenience function equivalent to `new Ripemd160(data).digest()` */ function $960e1a22badfcd58$var$ripemd160(data) {
    return new $960e1a22badfcd58$var$Ripemd160(data).digest();
}
$960e1a22badfcd58$exports.ripemd160 = $960e1a22badfcd58$var$ripemd160;


Object.defineProperty($ca4c58922ce7f03a$exports, "Ripemd160", {
    enumerable: true,
    get: function() {
        return $960e1a22badfcd58$exports.Ripemd160;
    }
});
Object.defineProperty($ca4c58922ce7f03a$exports, "ripemd160", {
    enumerable: true,
    get: function() {
        return $960e1a22badfcd58$exports.ripemd160;
    }
});
var $fb7148775d133dd2$exports = {};
"use strict";
var $fb7148775d133dd2$var$__importDefault = $fb7148775d133dd2$exports && $fb7148775d133dd2$exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty($fb7148775d133dd2$exports, "__esModule", {
    value: true
});
$fb7148775d133dd2$exports.Secp256k1 = void 0;


const $fb7148775d133dd2$var$bn_js_1 = $fb7148775d133dd2$var$__importDefault((parcelRequire("gtrXq")));

const $fb7148775d133dd2$var$elliptic_1 = $fb7148775d133dd2$var$__importDefault((parcelRequire("8J1ou")));
var $04916f17d3c4066f$exports = {};
"use strict";
Object.defineProperty($04916f17d3c4066f$exports, "__esModule", {
    value: true
});
$04916f17d3c4066f$exports.ExtendedSecp256k1Signature = $04916f17d3c4066f$exports.Secp256k1Signature = void 0;
function $04916f17d3c4066f$var$trimLeadingNullBytes(inData) {
    let numberOfLeadingNullBytes = 0;
    for (const byte of inData){
        if (byte === 0x00) numberOfLeadingNullBytes++;
        else break;
    }
    return inData.slice(numberOfLeadingNullBytes);
}
const $04916f17d3c4066f$var$derTagInteger = 0x02;
class $04916f17d3c4066f$var$Secp256k1Signature {
    constructor(r, s){
        if (r.length > 32 || r.length === 0 || r[0] === 0x00) throw new Error("Unsigned integer r must be encoded as unpadded big endian.");
        if (s.length > 32 || s.length === 0 || s[0] === 0x00) throw new Error("Unsigned integer s must be encoded as unpadded big endian.");
        this.data = {
            r: r,
            s: s
        };
    }
    /**
     * Takes the pair of integers (r, s) as 2x32 byte of binary data.
     *
     * Note: This is the format Cosmos SDK uses natively.
     *
     * @param data a 64 byte value containing integers r and s.
     */ static fromFixedLength(data) {
        if (data.length !== 64) throw new Error(`Got invalid data length: ${data.length}. Expected 2x 32 bytes for the pair (r, s)`);
        return new $04916f17d3c4066f$var$Secp256k1Signature($04916f17d3c4066f$var$trimLeadingNullBytes(data.slice(0, 32)), $04916f17d3c4066f$var$trimLeadingNullBytes(data.slice(32, 64)));
    }
    static fromDer(data) {
        let pos = 0;
        if (data[pos++] !== 0x30) throw new Error("Prefix 0x30 expected");
        const bodyLength = data[pos++];
        if (data.length - pos !== bodyLength) throw new Error("Data length mismatch detected");
        // r
        const rTag = data[pos++];
        if (rTag !== $04916f17d3c4066f$var$derTagInteger) throw new Error("INTEGER tag expected");
        const rLength = data[pos++];
        if (rLength >= 0x80) throw new Error("Decoding length values above 127 not supported");
        const rData = data.slice(pos, pos + rLength);
        pos += rLength;
        // s
        const sTag = data[pos++];
        if (sTag !== $04916f17d3c4066f$var$derTagInteger) throw new Error("INTEGER tag expected");
        const sLength = data[pos++];
        if (sLength >= 0x80) throw new Error("Decoding length values above 127 not supported");
        const sData = data.slice(pos, pos + sLength);
        pos += sLength;
        return new $04916f17d3c4066f$var$Secp256k1Signature(// r/s data can contain leading 0 bytes to express integers being non-negative in DER
        $04916f17d3c4066f$var$trimLeadingNullBytes(rData), $04916f17d3c4066f$var$trimLeadingNullBytes(sData));
    }
    r(length) {
        if (length === undefined) return this.data.r;
        else {
            const paddingLength = length - this.data.r.length;
            if (paddingLength < 0) throw new Error("Length too small to hold parameter r");
            const padding = new Uint8Array(paddingLength);
            return new Uint8Array([
                ...padding,
                ...this.data.r
            ]);
        }
    }
    s(length) {
        if (length === undefined) return this.data.s;
        else {
            const paddingLength = length - this.data.s.length;
            if (paddingLength < 0) throw new Error("Length too small to hold parameter s");
            const padding = new Uint8Array(paddingLength);
            return new Uint8Array([
                ...padding,
                ...this.data.s
            ]);
        }
    }
    toFixedLength() {
        return new Uint8Array([
            ...this.r(32),
            ...this.s(32)
        ]);
    }
    toDer() {
        // DER supports negative integers but our data is unsigned. Thus we need to prepend
        // a leading 0 byte when the higest bit is set to differentiate nagative values
        const rEncoded = this.data.r[0] >= 0x80 ? new Uint8Array([
            0,
            ...this.data.r
        ]) : this.data.r;
        const sEncoded = this.data.s[0] >= 0x80 ? new Uint8Array([
            0,
            ...this.data.s
        ]) : this.data.s;
        const rLength = rEncoded.length;
        const sLength = sEncoded.length;
        const data = new Uint8Array([
            $04916f17d3c4066f$var$derTagInteger,
            rLength,
            ...rEncoded,
            $04916f17d3c4066f$var$derTagInteger,
            sLength,
            ...sEncoded
        ]);
        return new Uint8Array([
            0x30,
            data.length,
            ...data
        ]);
    }
}
$04916f17d3c4066f$exports.Secp256k1Signature = $04916f17d3c4066f$var$Secp256k1Signature;
/**
 * A Secp256k1Signature plus the recovery parameter
 */ class $04916f17d3c4066f$var$ExtendedSecp256k1Signature extends $04916f17d3c4066f$var$Secp256k1Signature {
    constructor(r, s, recovery){
        super(r, s);
        if (!Number.isInteger(recovery)) throw new Error("The recovery parameter must be an integer.");
        if (recovery < 0 || recovery > 4) throw new Error("The recovery parameter must be one of 0, 1, 2, 3.");
        this.recovery = recovery;
    }
    /**
     * Decode extended signature from the simple fixed length encoding
     * described in toFixedLength().
     */ static fromFixedLength(data) {
        if (data.length !== 65) throw new Error(`Got invalid data length ${data.length}. Expected 32 + 32 + 1`);
        return new $04916f17d3c4066f$var$ExtendedSecp256k1Signature($04916f17d3c4066f$var$trimLeadingNullBytes(data.slice(0, 32)), $04916f17d3c4066f$var$trimLeadingNullBytes(data.slice(32, 64)), data[64]);
    }
    /**
     * A simple custom encoding that encodes the extended signature as
     * r (32 bytes) | s (32 bytes) | recovery param (1 byte)
     * where | denotes concatenation of bonary data.
     */ toFixedLength() {
        return new Uint8Array([
            ...this.r(32),
            ...this.s(32),
            this.recovery
        ]);
    }
}
$04916f17d3c4066f$exports.ExtendedSecp256k1Signature = $04916f17d3c4066f$var$ExtendedSecp256k1Signature;


const $fb7148775d133dd2$var$secp256k1 = new $fb7148775d133dd2$var$elliptic_1.default.ec("secp256k1");
const $fb7148775d133dd2$var$secp256k1N = new $fb7148775d133dd2$var$bn_js_1.default("FFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFEBAAEDCE6AF48A03BBFD25E8CD0364141", "hex");
class $fb7148775d133dd2$var$Secp256k1 {
    static async makeKeypair(privkey) {
        if (privkey.length !== 32) // is this check missing in secp256k1.validatePrivateKey?
        // https://github.com/bitjson/bitcoin-ts/issues/4
        throw new Error("input data is not a valid secp256k1 private key");
        const keypair = $fb7148775d133dd2$var$secp256k1.keyFromPrivate(privkey);
        if (keypair.validate().result !== true) throw new Error("input data is not a valid secp256k1 private key");
        // range test that is not part of the elliptic implementation
        const privkeyAsBigInteger = new $fb7148775d133dd2$var$bn_js_1.default(privkey);
        if (privkeyAsBigInteger.gte($fb7148775d133dd2$var$secp256k1N)) // not strictly smaller than N
        throw new Error("input data is not a valid secp256k1 private key");
        const out = {
            privkey: (0, $3977281a39984aec$exports.fromHex)(keypair.getPrivate("hex")),
            // encodes uncompressed as
            // - 1-byte prefix "04"
            // - 32-byte x coordinate
            // - 32-byte y coordinate
            pubkey: Uint8Array.from(keypair.getPublic("array"))
        };
        return out;
    }
    // Creates a signature that is
    // - deterministic (RFC 6979)
    // - lowS signature
    // - DER encoded
    static async createSignature(messageHash, privkey) {
        if (messageHash.length === 0) throw new Error("Message hash must not be empty");
        if (messageHash.length > 32) throw new Error("Message hash length must not exceed 32 bytes");
        const keypair = $fb7148775d133dd2$var$secp256k1.keyFromPrivate(privkey);
        // the `canonical` option ensures creation of lowS signature representations
        const { r: r, s: s, recoveryParam: recoveryParam } = keypair.sign(messageHash, {
            canonical: true
        });
        if (typeof recoveryParam !== "number") throw new Error("Recovery param missing");
        return new $04916f17d3c4066f$exports.ExtendedSecp256k1Signature(Uint8Array.from(r.toArray()), Uint8Array.from(s.toArray()), recoveryParam);
    }
    static async verifySignature(signature, messageHash, pubkey) {
        if (messageHash.length === 0) throw new Error("Message hash must not be empty");
        if (messageHash.length > 32) throw new Error("Message hash length must not exceed 32 bytes");
        const keypair = $fb7148775d133dd2$var$secp256k1.keyFromPublic(pubkey);
        // From https://github.com/indutny/elliptic:
        //
        //     Sign the message's hash (input must be an array, or a hex-string)
        //
        //     Signature MUST be either:
        //     1) DER-encoded signature as hex-string; or
        //     2) DER-encoded signature as buffer; or
        //     3) object with two hex-string properties (r and s); or
        //     4) object with two buffer properties (r and s)
        //
        // Uint8Array is not a Buffer, but elliptic seems to be happy with the interface
        // common to both types. Uint8Array is not an array of ints but the interface is
        // similar
        try {
            return keypair.verify(messageHash, signature.toDer());
        } catch (error) {
            return false;
        }
    }
    static recoverPubkey(signature, messageHash) {
        const signatureForElliptic = {
            r: (0, $3977281a39984aec$exports.toHex)(signature.r()),
            s: (0, $3977281a39984aec$exports.toHex)(signature.s())
        };
        const point = $fb7148775d133dd2$var$secp256k1.recoverPubKey(messageHash, signatureForElliptic, signature.recovery);
        const keypair = $fb7148775d133dd2$var$secp256k1.keyFromPublic(point);
        return (0, $3977281a39984aec$exports.fromHex)(keypair.getPublic(false, "hex"));
    }
    static compressPubkey(pubkey) {
        switch(pubkey.length){
            case 33:
                return pubkey;
            case 65:
                return Uint8Array.from($fb7148775d133dd2$var$secp256k1.keyFromPublic(pubkey).getPublic(true, "array"));
            default:
                throw new Error("Invalid pubkey length");
        }
    }
    static trimRecoveryByte(signature) {
        switch(signature.length){
            case 64:
                return signature;
            case 65:
                return signature.slice(0, 64);
            default:
                throw new Error("Invalid signature length");
        }
    }
}
$fb7148775d133dd2$exports.Secp256k1 = $fb7148775d133dd2$var$Secp256k1;


Object.defineProperty($ca4c58922ce7f03a$exports, "Secp256k1", {
    enumerable: true,
    get: function() {
        return $fb7148775d133dd2$exports.Secp256k1;
    }
});

Object.defineProperty($ca4c58922ce7f03a$exports, "ExtendedSecp256k1Signature", {
    enumerable: true,
    get: function() {
        return $04916f17d3c4066f$exports.ExtendedSecp256k1Signature;
    }
});
Object.defineProperty($ca4c58922ce7f03a$exports, "Secp256k1Signature", {
    enumerable: true,
    get: function() {
        return $04916f17d3c4066f$exports.Secp256k1Signature;
    }
});
var $0eefd27e4c099814$exports = {};
"use strict";
var $0eefd27e4c099814$var$__importDefault = $0eefd27e4c099814$exports && $0eefd27e4c099814$exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty($0eefd27e4c099814$exports, "__esModule", {
    value: true
});
$0eefd27e4c099814$exports.sha512 = $0eefd27e4c099814$exports.Sha512 = $0eefd27e4c099814$exports.sha256 = $0eefd27e4c099814$exports.Sha256 = $0eefd27e4c099814$exports.sha1 = $0eefd27e4c099814$exports.Sha1 = void 0;

const $0eefd27e4c099814$var$sha_js_1 = $0eefd27e4c099814$var$__importDefault((parcelRequire("fkJVr")));
class $0eefd27e4c099814$var$Sha1 {
    constructor(firstData){
        this.blockSize = 64;
        this.impl = (0, $0eefd27e4c099814$var$sha_js_1.default)("sha1");
        if (firstData) this.update(firstData);
    }
    update(data) {
        this.impl.update(data);
        return this;
    }
    digest() {
        return new Uint8Array(this.impl.digest());
    }
}
$0eefd27e4c099814$exports.Sha1 = $0eefd27e4c099814$var$Sha1;
/** Convenience function equivalent to `new Sha1(data).digest()` */ function $0eefd27e4c099814$var$sha1(data) {
    return new $0eefd27e4c099814$var$Sha1(data).digest();
}
$0eefd27e4c099814$exports.sha1 = $0eefd27e4c099814$var$sha1;
class $0eefd27e4c099814$var$Sha256 {
    constructor(firstData){
        this.blockSize = 64;
        this.impl = (0, $0eefd27e4c099814$var$sha_js_1.default)("sha256");
        if (firstData) this.update(firstData);
    }
    update(data) {
        this.impl.update(data);
        return this;
    }
    digest() {
        return new Uint8Array(this.impl.digest());
    }
}
$0eefd27e4c099814$exports.Sha256 = $0eefd27e4c099814$var$Sha256;
/** Convenience function equivalent to `new Sha256(data).digest()` */ function $0eefd27e4c099814$var$sha256(data) {
    return new $0eefd27e4c099814$var$Sha256(data).digest();
}
$0eefd27e4c099814$exports.sha256 = $0eefd27e4c099814$var$sha256;
class $0eefd27e4c099814$var$Sha512 {
    constructor(firstData){
        this.blockSize = 128;
        this.impl = (0, $0eefd27e4c099814$var$sha_js_1.default)("sha512");
        if (firstData) this.update(firstData);
    }
    update(data) {
        this.impl.update(data);
        return this;
    }
    digest() {
        return new Uint8Array(this.impl.digest());
    }
}
$0eefd27e4c099814$exports.Sha512 = $0eefd27e4c099814$var$Sha512;
/** Convenience function equivalent to `new Sha512(data).digest()` */ function $0eefd27e4c099814$var$sha512(data) {
    return new $0eefd27e4c099814$var$Sha512(data).digest();
}
$0eefd27e4c099814$exports.sha512 = $0eefd27e4c099814$var$sha512;


Object.defineProperty($ca4c58922ce7f03a$exports, "Sha1", {
    enumerable: true,
    get: function() {
        return $0eefd27e4c099814$exports.Sha1;
    }
});
Object.defineProperty($ca4c58922ce7f03a$exports, "sha1", {
    enumerable: true,
    get: function() {
        return $0eefd27e4c099814$exports.sha1;
    }
});
Object.defineProperty($ca4c58922ce7f03a$exports, "Sha256", {
    enumerable: true,
    get: function() {
        return $0eefd27e4c099814$exports.Sha256;
    }
});
Object.defineProperty($ca4c58922ce7f03a$exports, "sha256", {
    enumerable: true,
    get: function() {
        return $0eefd27e4c099814$exports.sha256;
    }
});
Object.defineProperty($ca4c58922ce7f03a$exports, "Sha512", {
    enumerable: true,
    get: function() {
        return $0eefd27e4c099814$exports.Sha512;
    }
});
Object.defineProperty($ca4c58922ce7f03a$exports, "sha512", {
    enumerable: true,
    get: function() {
        return $0eefd27e4c099814$exports.sha512;
    }
});
var $f60fe513566bf665$exports = {};
"use strict";
var $f60fe513566bf665$var$__importDefault = $f60fe513566bf665$exports && $f60fe513566bf665$exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty($f60fe513566bf665$exports, "__esModule", {
    value: true
});
$f60fe513566bf665$exports.stringToPath = $f60fe513566bf665$exports.pathToString = $f60fe513566bf665$exports.Slip10 = $f60fe513566bf665$exports.Slip10RawIndex = $f60fe513566bf665$exports.slip10CurveFromString = $f60fe513566bf665$exports.Slip10Curve = void 0;

var $1d6e3095a7e37622$exports = {};
"use strict";
Object.defineProperty($1d6e3095a7e37622$exports, "__esModule", {
    value: true
});
$1d6e3095a7e37622$exports.Uint64 = $1d6e3095a7e37622$exports.Uint53 = $1d6e3095a7e37622$exports.Uint32 = $1d6e3095a7e37622$exports.Int53 = $1d6e3095a7e37622$exports.Decimal = void 0;
var $d26326fab986e4c0$exports = {};
"use strict";
var $d26326fab986e4c0$var$__importDefault = $d26326fab986e4c0$exports && $d26326fab986e4c0$exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty($d26326fab986e4c0$exports, "__esModule", {
    value: true
});
$d26326fab986e4c0$exports.Decimal = void 0;

const $d26326fab986e4c0$var$bn_js_1 = $d26326fab986e4c0$var$__importDefault((parcelRequire("gtrXq")));
// Too large values lead to massive memory usage. Limit to something sensible.
// The largest value we need is 18 (Ether).
const $d26326fab986e4c0$var$maxFractionalDigits = 100;
/**
 * A type for arbitrary precision, non-negative decimals.
 *
 * Instances of this class are immutable.
 */ class $d26326fab986e4c0$var$Decimal {
    constructor(atomics, fractionalDigits){
        this.data = {
            atomics: new $d26326fab986e4c0$var$bn_js_1.default(atomics),
            fractionalDigits: fractionalDigits
        };
    }
    static fromUserInput(input, fractionalDigits) {
        $d26326fab986e4c0$var$Decimal.verifyFractionalDigits(fractionalDigits);
        const badCharacter = input.match(/[^0-9.]/);
        if (badCharacter) // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        throw new Error(`Invalid character at position ${badCharacter.index + 1}`);
        let whole;
        let fractional;
        if (input.search(/\./) === -1) {
            // integer format, no separator
            whole = input;
            fractional = "";
        } else {
            const parts = input.split(".");
            switch(parts.length){
                case 0:
                case 1:
                    throw new Error("Fewer than two elements in split result. This must not happen here.");
                case 2:
                    if (!parts[1]) throw new Error("Fractional part missing");
                    whole = parts[0];
                    fractional = parts[1].replace(/0+$/, "");
                    break;
                default:
                    throw new Error("More than one separator found");
            }
        }
        if (fractional.length > fractionalDigits) throw new Error("Got more fractional digits than supported");
        const quantity = `${whole}${fractional.padEnd(fractionalDigits, "0")}`;
        return new $d26326fab986e4c0$var$Decimal(quantity, fractionalDigits);
    }
    static fromAtomics(atomics, fractionalDigits) {
        $d26326fab986e4c0$var$Decimal.verifyFractionalDigits(fractionalDigits);
        return new $d26326fab986e4c0$var$Decimal(atomics, fractionalDigits);
    }
    static verifyFractionalDigits(fractionalDigits) {
        if (!Number.isInteger(fractionalDigits)) throw new Error("Fractional digits is not an integer");
        if (fractionalDigits < 0) throw new Error("Fractional digits must not be negative");
        if (fractionalDigits > $d26326fab986e4c0$var$maxFractionalDigits) throw new Error(`Fractional digits must not exceed ${$d26326fab986e4c0$var$maxFractionalDigits}`);
    }
    static compare(a, b) {
        if (a.fractionalDigits !== b.fractionalDigits) throw new Error("Fractional digits do not match");
        return a.data.atomics.cmp(new $d26326fab986e4c0$var$bn_js_1.default(b.atomics));
    }
    get atomics() {
        return this.data.atomics.toString();
    }
    get fractionalDigits() {
        return this.data.fractionalDigits;
    }
    toString() {
        const factor = new $d26326fab986e4c0$var$bn_js_1.default(10).pow(new $d26326fab986e4c0$var$bn_js_1.default(this.data.fractionalDigits));
        const whole = this.data.atomics.div(factor);
        const fractional = this.data.atomics.mod(factor);
        if (fractional.isZero()) return whole.toString();
        else {
            const fullFractionalPart = fractional.toString().padStart(this.data.fractionalDigits, "0");
            const trimmedFractionalPart = fullFractionalPart.replace(/0+$/, "");
            return `${whole.toString()}.${trimmedFractionalPart}`;
        }
    }
    /**
     * Returns an approximation as a float type. Only use this if no
     * exact calculation is required.
     */ toFloatApproximation() {
        const out = Number(this.toString());
        if (Number.isNaN(out)) throw new Error("Conversion to number failed");
        return out;
    }
    /**
     * a.plus(b) returns a+b.
     *
     * Both values need to have the same fractional digits.
     */ plus(b) {
        if (this.fractionalDigits !== b.fractionalDigits) throw new Error("Fractional digits do not match");
        const sum = this.data.atomics.add(new $d26326fab986e4c0$var$bn_js_1.default(b.atomics));
        return new $d26326fab986e4c0$var$Decimal(sum.toString(), this.fractionalDigits);
    }
    /**
     * a.minus(b) returns a-b.
     *
     * Both values need to have the same fractional digits.
     * The resulting difference needs to be non-negative.
     */ minus(b) {
        if (this.fractionalDigits !== b.fractionalDigits) throw new Error("Fractional digits do not match");
        const difference = this.data.atomics.sub(new $d26326fab986e4c0$var$bn_js_1.default(b.atomics));
        if (difference.ltn(0)) throw new Error("Difference must not be negative");
        return new $d26326fab986e4c0$var$Decimal(difference.toString(), this.fractionalDigits);
    }
    /**
     * a.multiply(b) returns a*b.
     *
     * We only allow multiplication by unsigned integers to avoid rounding errors.
     */ multiply(b) {
        const product = this.data.atomics.mul(new $d26326fab986e4c0$var$bn_js_1.default(b.toString()));
        return new $d26326fab986e4c0$var$Decimal(product.toString(), this.fractionalDigits);
    }
    equals(b) {
        return $d26326fab986e4c0$var$Decimal.compare(this, b) === 0;
    }
    isLessThan(b) {
        return $d26326fab986e4c0$var$Decimal.compare(this, b) < 0;
    }
    isLessThanOrEqual(b) {
        return $d26326fab986e4c0$var$Decimal.compare(this, b) <= 0;
    }
    isGreaterThan(b) {
        return $d26326fab986e4c0$var$Decimal.compare(this, b) > 0;
    }
    isGreaterThanOrEqual(b) {
        return $d26326fab986e4c0$var$Decimal.compare(this, b) >= 0;
    }
}
$d26326fab986e4c0$exports.Decimal = $d26326fab986e4c0$var$Decimal;


Object.defineProperty($1d6e3095a7e37622$exports, "Decimal", {
    enumerable: true,
    get: function() {
        return $d26326fab986e4c0$exports.Decimal;
    }
});
var $7628a5be3e20cee9$exports = {};
"use strict";
var $7628a5be3e20cee9$var$__importDefault = $7628a5be3e20cee9$exports && $7628a5be3e20cee9$exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty($7628a5be3e20cee9$exports, "__esModule", {
    value: true
});
$7628a5be3e20cee9$exports.Uint64 = $7628a5be3e20cee9$exports.Uint53 = $7628a5be3e20cee9$exports.Int53 = $7628a5be3e20cee9$exports.Uint32 = void 0;

/* eslint-disable no-bitwise */ const $7628a5be3e20cee9$var$bn_js_1 = $7628a5be3e20cee9$var$__importDefault((parcelRequire("gtrXq")));
const $7628a5be3e20cee9$var$uint64MaxValue = new $7628a5be3e20cee9$var$bn_js_1.default("18446744073709551615", 10, "be");
class $7628a5be3e20cee9$var$Uint32 {
    constructor(input){
        if (Number.isNaN(input)) throw new Error("Input is not a number");
        if (!Number.isInteger(input)) throw new Error("Input is not an integer");
        if (input < 0 || input > 4294967295) throw new Error("Input not in uint32 range: " + input.toString());
        this.data = input;
    }
    /** @deprecated use Uint32.fromBytes */ static fromBigEndianBytes(bytes) {
        return $7628a5be3e20cee9$var$Uint32.fromBytes(bytes);
    }
    /**
     * Creates a Uint32 from a fixed length byte array.
     *
     * @param bytes a list of exactly 4 bytes
     * @param endianess defaults to big endian
     */ static fromBytes(bytes, endianess = "be") {
        if (bytes.length !== 4) throw new Error("Invalid input length. Expected 4 bytes.");
        for(let i = 0; i < bytes.length; ++i){
            if (!Number.isInteger(bytes[i]) || bytes[i] > 255 || bytes[i] < 0) throw new Error("Invalid value in byte. Found: " + bytes[i]);
        }
        const beBytes = endianess === "be" ? bytes : Array.from(bytes).reverse();
        // Use mulitiplication instead of shifting since bitwise operators are defined
        // on SIGNED int32 in JavaScript and we don't want to risk surprises
        return new $7628a5be3e20cee9$var$Uint32(beBytes[0] * 2 ** 24 + beBytes[1] * 2 ** 16 + beBytes[2] * 256 + beBytes[3]);
    }
    static fromString(str) {
        if (!str.match(/^[0-9]+$/)) throw new Error("Invalid string format");
        return new $7628a5be3e20cee9$var$Uint32(Number.parseInt(str, 10));
    }
    toBytesBigEndian() {
        // Use division instead of shifting since bitwise operators are defined
        // on SIGNED int32 in JavaScript and we don't want to risk surprises
        return new Uint8Array([
            Math.floor(this.data / 2 ** 24) & 0xff,
            Math.floor(this.data / 2 ** 16) & 0xff,
            Math.floor(this.data / 256) & 0xff,
            Math.floor(this.data / 1) & 0xff
        ]);
    }
    toBytesLittleEndian() {
        // Use division instead of shifting since bitwise operators are defined
        // on SIGNED int32 in JavaScript and we don't want to risk surprises
        return new Uint8Array([
            Math.floor(this.data / 1) & 0xff,
            Math.floor(this.data / 256) & 0xff,
            Math.floor(this.data / 2 ** 16) & 0xff,
            Math.floor(this.data / 2 ** 24) & 0xff
        ]);
    }
    toNumber() {
        return this.data;
    }
    toString() {
        return this.data.toString();
    }
}
$7628a5be3e20cee9$exports.Uint32 = $7628a5be3e20cee9$var$Uint32;
class $7628a5be3e20cee9$var$Int53 {
    constructor(input){
        if (Number.isNaN(input)) throw new Error("Input is not a number");
        if (!Number.isInteger(input)) throw new Error("Input is not an integer");
        if (input < Number.MIN_SAFE_INTEGER || input > Number.MAX_SAFE_INTEGER) throw new Error("Input not in int53 range: " + input.toString());
        this.data = input;
    }
    static fromString(str) {
        if (!str.match(/^-?[0-9]+$/)) throw new Error("Invalid string format");
        return new $7628a5be3e20cee9$var$Int53(Number.parseInt(str, 10));
    }
    toNumber() {
        return this.data;
    }
    toString() {
        return this.data.toString();
    }
}
$7628a5be3e20cee9$exports.Int53 = $7628a5be3e20cee9$var$Int53;
class $7628a5be3e20cee9$var$Uint53 {
    constructor(input){
        const signed = new $7628a5be3e20cee9$var$Int53(input);
        if (signed.toNumber() < 0) throw new Error("Input is negative");
        this.data = signed;
    }
    static fromString(str) {
        const signed = $7628a5be3e20cee9$var$Int53.fromString(str);
        return new $7628a5be3e20cee9$var$Uint53(signed.toNumber());
    }
    toNumber() {
        return this.data.toNumber();
    }
    toString() {
        return this.data.toString();
    }
}
$7628a5be3e20cee9$exports.Uint53 = $7628a5be3e20cee9$var$Uint53;
class $7628a5be3e20cee9$var$Uint64 {
    constructor(data){
        if (data.isNeg()) throw new Error("Input is negative");
        if (data.gt($7628a5be3e20cee9$var$uint64MaxValue)) throw new Error("Input exceeds uint64 range");
        this.data = data;
    }
    /** @deprecated use Uint64.fromBytes */ static fromBytesBigEndian(bytes) {
        return $7628a5be3e20cee9$var$Uint64.fromBytes(bytes);
    }
    /**
     * Creates a Uint64 from a fixed length byte array.
     *
     * @param bytes a list of exactly 8 bytes
     * @param endianess defaults to big endian
     */ static fromBytes(bytes, endianess = "be") {
        if (bytes.length !== 8) throw new Error("Invalid input length. Expected 8 bytes.");
        for(let i = 0; i < bytes.length; ++i){
            if (!Number.isInteger(bytes[i]) || bytes[i] > 255 || bytes[i] < 0) throw new Error("Invalid value in byte. Found: " + bytes[i]);
        }
        const beBytes = endianess === "be" ? Array.from(bytes) : Array.from(bytes).reverse();
        return new $7628a5be3e20cee9$var$Uint64(new $7628a5be3e20cee9$var$bn_js_1.default(beBytes));
    }
    static fromString(str) {
        if (!str.match(/^[0-9]+$/)) throw new Error("Invalid string format");
        return new $7628a5be3e20cee9$var$Uint64(new $7628a5be3e20cee9$var$bn_js_1.default(str, 10, "be"));
    }
    static fromNumber(input) {
        if (Number.isNaN(input)) throw new Error("Input is not a number");
        if (!Number.isInteger(input)) throw new Error("Input is not an integer");
        let bigint;
        try {
            bigint = new $7628a5be3e20cee9$var$bn_js_1.default(input);
        } catch (_a) {
            throw new Error("Input is not a safe integer");
        }
        return new $7628a5be3e20cee9$var$Uint64(bigint);
    }
    toBytesBigEndian() {
        return Uint8Array.from(this.data.toArray("be", 8));
    }
    toBytesLittleEndian() {
        return Uint8Array.from(this.data.toArray("le", 8));
    }
    toString() {
        return this.data.toString(10);
    }
    toNumber() {
        return this.data.toNumber();
    }
}
$7628a5be3e20cee9$exports.Uint64 = $7628a5be3e20cee9$var$Uint64;
// Assign classes to unused variables in order to verify static interface conformance at compile time.
// Workaround for https://github.com/microsoft/TypeScript/issues/33892
const $7628a5be3e20cee9$var$_int53Class = $7628a5be3e20cee9$var$Int53;
const $7628a5be3e20cee9$var$_uint53Class = $7628a5be3e20cee9$var$Uint53;
const $7628a5be3e20cee9$var$_uint32Class = $7628a5be3e20cee9$var$Uint32;
const $7628a5be3e20cee9$var$_uint64Class = $7628a5be3e20cee9$var$Uint64;


Object.defineProperty($1d6e3095a7e37622$exports, "Int53", {
    enumerable: true,
    get: function() {
        return $7628a5be3e20cee9$exports.Int53;
    }
});
Object.defineProperty($1d6e3095a7e37622$exports, "Uint32", {
    enumerable: true,
    get: function() {
        return $7628a5be3e20cee9$exports.Uint32;
    }
});
Object.defineProperty($1d6e3095a7e37622$exports, "Uint53", {
    enumerable: true,
    get: function() {
        return $7628a5be3e20cee9$exports.Uint53;
    }
});
Object.defineProperty($1d6e3095a7e37622$exports, "Uint64", {
    enumerable: true,
    get: function() {
        return $7628a5be3e20cee9$exports.Uint64;
    }
});



const $f60fe513566bf665$var$bn_js_1 = $f60fe513566bf665$var$__importDefault((parcelRequire("gtrXq")));

const $f60fe513566bf665$var$elliptic_1 = $f60fe513566bf665$var$__importDefault((parcelRequire("8J1ou")));


/**
 * Raw values must match the curve string in SLIP-0010 master key generation
 *
 * @see https://github.com/satoshilabs/slips/blob/master/slip-0010.md#master-key-generation
 */ var $f60fe513566bf665$var$Slip10Curve;
(function(Slip10Curve) {
    Slip10Curve["Secp256k1"] = "Bitcoin seed";
    Slip10Curve["Ed25519"] = "ed25519 seed";
})($f60fe513566bf665$var$Slip10Curve = $f60fe513566bf665$exports.Slip10Curve || ($f60fe513566bf665$exports.Slip10Curve = {}));
/**
 * Reverse mapping of Slip10Curve
 */ function $f60fe513566bf665$var$slip10CurveFromString(curveString) {
    switch(curveString){
        case $f60fe513566bf665$var$Slip10Curve.Ed25519:
            return $f60fe513566bf665$var$Slip10Curve.Ed25519;
        case $f60fe513566bf665$var$Slip10Curve.Secp256k1:
            return $f60fe513566bf665$var$Slip10Curve.Secp256k1;
        default:
            throw new Error(`Unknown curve string: '${curveString}'`);
    }
}
$f60fe513566bf665$exports.slip10CurveFromString = $f60fe513566bf665$var$slip10CurveFromString;
class $f60fe513566bf665$var$Slip10RawIndex extends $1d6e3095a7e37622$exports.Uint32 {
    static hardened(hardenedIndex) {
        return new $f60fe513566bf665$var$Slip10RawIndex(hardenedIndex + 2 ** 31);
    }
    static normal(normalIndex) {
        return new $f60fe513566bf665$var$Slip10RawIndex(normalIndex);
    }
    isHardened() {
        return this.data >= 2 ** 31;
    }
}
$f60fe513566bf665$exports.Slip10RawIndex = $f60fe513566bf665$var$Slip10RawIndex;
const $f60fe513566bf665$var$secp256k1 = new $f60fe513566bf665$var$elliptic_1.default.ec("secp256k1");
// Universal private key derivation accoring to
// https://github.com/satoshilabs/slips/blob/master/slip-0010.md
class $f60fe513566bf665$var$Slip10 {
    static derivePath(curve, seed, path) {
        let result = this.master(curve, seed);
        for (const rawIndex of path)result = this.child(curve, result.privkey, result.chainCode, rawIndex);
        return result;
    }
    static master(curve, seed) {
        const i = new $f3b21ddb1d896800$exports.Hmac($0eefd27e4c099814$exports.Sha512, (0, $3977281a39984aec$exports.toAscii)(curve)).update(seed).digest();
        const il = i.slice(0, 32);
        const ir = i.slice(32, 64);
        if (curve !== $f60fe513566bf665$var$Slip10Curve.Ed25519 && (this.isZero(il) || this.isGteN(curve, il))) return this.master(curve, i);
        return {
            chainCode: ir,
            privkey: il
        };
    }
    static child(curve, parentPrivkey, parentChainCode, rawIndex) {
        let i;
        if (rawIndex.isHardened()) {
            const payload = new Uint8Array([
                0x00,
                ...parentPrivkey,
                ...rawIndex.toBytesBigEndian()
            ]);
            i = new $f3b21ddb1d896800$exports.Hmac($0eefd27e4c099814$exports.Sha512, parentChainCode).update(payload).digest();
        } else {
            if (curve === $f60fe513566bf665$var$Slip10Curve.Ed25519) throw new Error("Normal keys are not allowed with ed25519");
            else {
                // Step 1 of https://github.com/satoshilabs/slips/blob/master/slip-0010.md#private-parent-key--private-child-key
                // Calculate I = HMAC-SHA512(Key = c_par, Data = ser_P(point(k_par)) || ser_32(i)).
                // where the functions point() and ser_p() are defined in BIP-0032
                const data = new Uint8Array([
                    ...$f60fe513566bf665$var$Slip10.serializedPoint(curve, new $f60fe513566bf665$var$bn_js_1.default(parentPrivkey)),
                    ...rawIndex.toBytesBigEndian()
                ]);
                i = new $f3b21ddb1d896800$exports.Hmac($0eefd27e4c099814$exports.Sha512, parentChainCode).update(data).digest();
            }
        }
        return this.childImpl(curve, parentPrivkey, parentChainCode, rawIndex, i);
    }
    /**
     * Implementation of ser_P(point(k_par)) from BIP-0032
     *
     * @see https://github.com/bitcoin/bips/blob/master/bip-0032.mediawiki
     */ static serializedPoint(curve, p) {
        switch(curve){
            case $f60fe513566bf665$var$Slip10Curve.Secp256k1:
                return (0, $3977281a39984aec$exports.fromHex)($f60fe513566bf665$var$secp256k1.g.mul(p).encodeCompressed("hex"));
            default:
                throw new Error("curve not supported");
        }
    }
    static childImpl(curve, parentPrivkey, parentChainCode, rawIndex, i) {
        // step 2 (of the Private parent key → private child key algorithm)
        const il = i.slice(0, 32);
        const ir = i.slice(32, 64);
        // step 3
        const returnChainCode = ir;
        // step 4
        if (curve === $f60fe513566bf665$var$Slip10Curve.Ed25519) return {
            chainCode: returnChainCode,
            privkey: il
        };
        // step 5
        const n = this.n(curve);
        const returnChildKeyAsNumber = new $f60fe513566bf665$var$bn_js_1.default(il).add(new $f60fe513566bf665$var$bn_js_1.default(parentPrivkey)).mod(n);
        const returnChildKey = Uint8Array.from(returnChildKeyAsNumber.toArray("be", 32));
        // step 6
        if (this.isGteN(curve, il) || this.isZero(returnChildKey)) {
            const newI = new $f3b21ddb1d896800$exports.Hmac($0eefd27e4c099814$exports.Sha512, parentChainCode).update(new Uint8Array([
                0x01,
                ...ir,
                ...rawIndex.toBytesBigEndian()
            ])).digest();
            return this.childImpl(curve, parentPrivkey, parentChainCode, rawIndex, newI);
        }
        // step 7
        return {
            chainCode: returnChainCode,
            privkey: returnChildKey
        };
    }
    static isZero(privkey) {
        return privkey.every((byte)=>byte === 0);
    }
    static isGteN(curve, privkey) {
        const keyAsNumber = new $f60fe513566bf665$var$bn_js_1.default(privkey);
        return keyAsNumber.gte(this.n(curve));
    }
    static n(curve) {
        switch(curve){
            case $f60fe513566bf665$var$Slip10Curve.Secp256k1:
                return new $f60fe513566bf665$var$bn_js_1.default("FFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFEBAAEDCE6AF48A03BBFD25E8CD0364141", 16);
            default:
                throw new Error("curve not supported");
        }
    }
}
$f60fe513566bf665$exports.Slip10 = $f60fe513566bf665$var$Slip10;
function $f60fe513566bf665$var$pathToString(path) {
    return path.reduce((current, component)=>{
        const componentString = component.isHardened() ? `${component.toNumber() - 2 ** 31}'` : component.toString();
        return current + "/" + componentString;
    }, "m");
}
$f60fe513566bf665$exports.pathToString = $f60fe513566bf665$var$pathToString;
function $f60fe513566bf665$var$stringToPath(input) {
    if (!input.startsWith("m")) throw new Error("Path string must start with 'm'");
    let rest = input.slice(1);
    const out = new Array();
    while(rest){
        const match = rest.match(/^\/([0-9]+)('?)/);
        if (!match) throw new Error("Syntax error while reading path component");
        const [fullMatch, numberString, apostrophe] = match;
        const value = $1d6e3095a7e37622$exports.Uint53.fromString(numberString).toNumber();
        if (value >= 2 ** 31) throw new Error("Component value too high. Must not exceed 2**31-1.");
        if (apostrophe) out.push($f60fe513566bf665$var$Slip10RawIndex.hardened(value));
        else out.push($f60fe513566bf665$var$Slip10RawIndex.normal(value));
        rest = rest.slice(fullMatch.length);
    }
    return out;
}
$f60fe513566bf665$exports.stringToPath = $f60fe513566bf665$var$stringToPath;


Object.defineProperty($ca4c58922ce7f03a$exports, "pathToString", {
    enumerable: true,
    get: function() {
        return $f60fe513566bf665$exports.pathToString;
    }
});
Object.defineProperty($ca4c58922ce7f03a$exports, "Slip10", {
    enumerable: true,
    get: function() {
        return $f60fe513566bf665$exports.Slip10;
    }
});
Object.defineProperty($ca4c58922ce7f03a$exports, "Slip10Curve", {
    enumerable: true,
    get: function() {
        return $f60fe513566bf665$exports.Slip10Curve;
    }
});
Object.defineProperty($ca4c58922ce7f03a$exports, "slip10CurveFromString", {
    enumerable: true,
    get: function() {
        return $f60fe513566bf665$exports.slip10CurveFromString;
    }
});
Object.defineProperty($ca4c58922ce7f03a$exports, "Slip10RawIndex", {
    enumerable: true,
    get: function() {
        return $f60fe513566bf665$exports.Slip10RawIndex;
    }
});
Object.defineProperty($ca4c58922ce7f03a$exports, "stringToPath", {
    enumerable: true,
    get: function() {
        return $f60fe513566bf665$exports.stringToPath;
    }
});



var $68079a66d6248ed8$exports = {};
"use strict";
Object.defineProperty($68079a66d6248ed8$exports, "__esModule", {
    value: true
});
$68079a66d6248ed8$exports.encodeBech32Pubkey = $68079a66d6248ed8$exports.encodeAminoPubkey = $68079a66d6248ed8$exports.decodeBech32Pubkey = $68079a66d6248ed8$exports.decodeAminoPubkey = $68079a66d6248ed8$exports.encodeSecp256k1Pubkey = void 0;



var $dOLgD = parcelRequire("dOLgD");
var $f1e3af7bd086eae3$exports = {};
"use strict";
Object.defineProperty($f1e3af7bd086eae3$exports, "__esModule", {
    value: true
});
$f1e3af7bd086eae3$exports.isMultisigThresholdPubkey = $f1e3af7bd086eae3$exports.isSinglePubkey = $f1e3af7bd086eae3$exports.pubkeyType = $f1e3af7bd086eae3$exports.isSecp256k1Pubkey = $f1e3af7bd086eae3$exports.isEd25519Pubkey = void 0;
function $f1e3af7bd086eae3$var$isEd25519Pubkey(pubkey) {
    return pubkey.type === "tendermint/PubKeyEd25519";
}
$f1e3af7bd086eae3$exports.isEd25519Pubkey = $f1e3af7bd086eae3$var$isEd25519Pubkey;
function $f1e3af7bd086eae3$var$isSecp256k1Pubkey(pubkey) {
    return pubkey.type === "tendermint/PubKeySecp256k1";
}
$f1e3af7bd086eae3$exports.isSecp256k1Pubkey = $f1e3af7bd086eae3$var$isSecp256k1Pubkey;
$f1e3af7bd086eae3$exports.pubkeyType = {
    /** @see https://github.com/tendermint/tendermint/blob/v0.33.0/crypto/ed25519/ed25519.go#L22 */ secp256k1: "tendermint/PubKeySecp256k1",
    /** @see https://github.com/tendermint/tendermint/blob/v0.33.0/crypto/secp256k1/secp256k1.go#L23 */ ed25519: "tendermint/PubKeyEd25519",
    /** @see https://github.com/tendermint/tendermint/blob/v0.33.0/crypto/sr25519/codec.go#L12 */ sr25519: "tendermint/PubKeySr25519",
    multisigThreshold: "tendermint/PubKeyMultisigThreshold"
};
function $f1e3af7bd086eae3$var$isSinglePubkey(pubkey) {
    const singPubkeyTypes = [
        $f1e3af7bd086eae3$exports.pubkeyType.ed25519,
        $f1e3af7bd086eae3$exports.pubkeyType.secp256k1,
        $f1e3af7bd086eae3$exports.pubkeyType.sr25519
    ];
    return singPubkeyTypes.includes(pubkey.type);
}
$f1e3af7bd086eae3$exports.isSinglePubkey = $f1e3af7bd086eae3$var$isSinglePubkey;
function $f1e3af7bd086eae3$var$isMultisigThresholdPubkey(pubkey) {
    return pubkey.type === "tendermint/PubKeyMultisigThreshold";
}
$f1e3af7bd086eae3$exports.isMultisigThresholdPubkey = $f1e3af7bd086eae3$var$isMultisigThresholdPubkey;


function $68079a66d6248ed8$var$encodeSecp256k1Pubkey(pubkey) {
    if (pubkey.length !== 33 || pubkey[0] !== 0x02 && pubkey[0] !== 0x03) throw new Error("Public key must be compressed secp256k1, i.e. 33 bytes starting with 0x02 or 0x03");
    return {
        type: $f1e3af7bd086eae3$exports.pubkeyType.secp256k1,
        value: (0, $3977281a39984aec$exports.toBase64)(pubkey)
    };
}
$68079a66d6248ed8$exports.encodeSecp256k1Pubkey = $68079a66d6248ed8$var$encodeSecp256k1Pubkey;
// As discussed in https://github.com/binance-chain/javascript-sdk/issues/163
// Prefixes listed here: https://github.com/tendermint/tendermint/blob/d419fffe18531317c28c29a292ad7d253f6cafdf/docs/spec/blockchain/encoding.md#public-key-cryptography
// Last bytes is varint-encoded length prefix
const $68079a66d6248ed8$var$pubkeyAminoPrefixSecp256k1 = (0, $3977281a39984aec$exports.fromHex)("eb5ae98721" /* fixed length */ );
const $68079a66d6248ed8$var$pubkeyAminoPrefixEd25519 = (0, $3977281a39984aec$exports.fromHex)("1624de6420" /* fixed length */ );
const $68079a66d6248ed8$var$pubkeyAminoPrefixSr25519 = (0, $3977281a39984aec$exports.fromHex)("0dfb100520" /* fixed length */ );
/** See https://github.com/tendermint/tendermint/commit/38b401657e4ad7a7eeb3c30a3cbf512037df3740 */ const $68079a66d6248ed8$var$pubkeyAminoPrefixMultisigThreshold = (0, $3977281a39984aec$exports.fromHex)("22c1f7e2" /* variable length not included */ );
/**
 * Decodes a pubkey in the Amino binary format to a type/value object.
 */ function $68079a66d6248ed8$var$decodeAminoPubkey(data) {
    if ((0, $dOLgD.arrayContentStartsWith)(data, $68079a66d6248ed8$var$pubkeyAminoPrefixSecp256k1)) {
        const rest = data.slice($68079a66d6248ed8$var$pubkeyAminoPrefixSecp256k1.length);
        if (rest.length !== 33) throw new Error("Invalid rest data length. Expected 33 bytes (compressed secp256k1 pubkey).");
        return {
            type: $f1e3af7bd086eae3$exports.pubkeyType.secp256k1,
            value: (0, $3977281a39984aec$exports.toBase64)(rest)
        };
    } else if ((0, $dOLgD.arrayContentStartsWith)(data, $68079a66d6248ed8$var$pubkeyAminoPrefixEd25519)) {
        const rest = data.slice($68079a66d6248ed8$var$pubkeyAminoPrefixEd25519.length);
        if (rest.length !== 32) throw new Error("Invalid rest data length. Expected 32 bytes (Ed25519 pubkey).");
        return {
            type: $f1e3af7bd086eae3$exports.pubkeyType.ed25519,
            value: (0, $3977281a39984aec$exports.toBase64)(rest)
        };
    } else if ((0, $dOLgD.arrayContentStartsWith)(data, $68079a66d6248ed8$var$pubkeyAminoPrefixSr25519)) {
        const rest = data.slice($68079a66d6248ed8$var$pubkeyAminoPrefixSr25519.length);
        if (rest.length !== 32) throw new Error("Invalid rest data length. Expected 32 bytes (Sr25519 pubkey).");
        return {
            type: $f1e3af7bd086eae3$exports.pubkeyType.sr25519,
            value: (0, $3977281a39984aec$exports.toBase64)(rest)
        };
    } else if ((0, $dOLgD.arrayContentStartsWith)(data, $68079a66d6248ed8$var$pubkeyAminoPrefixMultisigThreshold)) // eslint-disable-next-line @typescript-eslint/no-use-before-define
    return $68079a66d6248ed8$var$decodeMultisigPubkey(data);
    else throw new Error("Unsupported public key type. Amino data starts with: " + (0, $3977281a39984aec$exports.toHex)(data.slice(0, 5)));
}
$68079a66d6248ed8$exports.decodeAminoPubkey = $68079a66d6248ed8$var$decodeAminoPubkey;
/**
 * Decodes a bech32 pubkey to Amino binary, which is then decoded to a type/value object.
 * The bech32 prefix is ignored and discareded.
 *
 * @param bechEncoded the bech32 encoded pubkey
 */ function $68079a66d6248ed8$var$decodeBech32Pubkey(bechEncoded) {
    const { data: data } = $3977281a39984aec$exports.Bech32.decode(bechEncoded);
    return $68079a66d6248ed8$var$decodeAminoPubkey(data);
}
$68079a66d6248ed8$exports.decodeBech32Pubkey = $68079a66d6248ed8$var$decodeBech32Pubkey;
/**
 * Uvarint decoder for Amino.
 * @see https://github.com/tendermint/go-amino/blob/8e779b71f40d175/decoder.go#L64-76
 * @returns varint as number, and bytes count occupied by varaint
 */ function $68079a66d6248ed8$var$decodeUvarint(reader) {
    if (reader.length < 1) throw new Error("Can't decode varint. EOF");
    if (reader[0] > 127) throw new Error("Decoding numbers > 127 is not supported here. Please tell those lazy CosmJS maintainers to port the binary.Varint implementation from the Go standard library and write some tests.");
    return [
        reader[0],
        1
    ];
}
/**
 * Decodes a multisig pubkey to type object.
 * Pubkey structure [ prefix + const + threshold + loop:(const + pubkeyLength + pubkey            ) ]
 *                  [   4b   + 1b    +  varint   + loop:(1b    +    varint    + pubkeyLength bytes) ]
 * @param data encoded pubkey
 */ function $68079a66d6248ed8$var$decodeMultisigPubkey(data) {
    const reader = Array.from(data);
    // remove multisig amino prefix;
    const prefixFromReader = reader.splice(0, $68079a66d6248ed8$var$pubkeyAminoPrefixMultisigThreshold.length);
    if (!(0, $dOLgD.arrayContentStartsWith)(prefixFromReader, $68079a66d6248ed8$var$pubkeyAminoPrefixMultisigThreshold)) throw new Error("Invalid multisig prefix.");
    // remove 0x08 threshold prefix;
    if (reader.shift() != 0x08) throw new Error("Invalid multisig data. Expecting 0x08 prefix before threshold.");
    // read threshold
    const [threshold, thresholdBytesLength] = $68079a66d6248ed8$var$decodeUvarint(reader);
    reader.splice(0, thresholdBytesLength);
    // read participants pubkeys
    const pubkeys = [];
    while(reader.length > 0){
        // remove 0x12 threshold prefix;
        if (reader.shift() != 0x12) throw new Error("Invalid multisig data. Expecting 0x12 prefix before participant pubkey length.");
        // read pubkey length
        const [pubkeyLength, pubkeyLengthBytesSize] = $68079a66d6248ed8$var$decodeUvarint(reader);
        reader.splice(0, pubkeyLengthBytesSize);
        // verify that we can read pubkey
        if (reader.length < pubkeyLength) throw new Error("Invalid multisig data length.");
        // read and decode participant pubkey
        const encodedPubkey = reader.splice(0, pubkeyLength);
        const pubkey = $68079a66d6248ed8$var$decodeAminoPubkey(Uint8Array.from(encodedPubkey));
        pubkeys.push(pubkey);
    }
    return {
        type: $f1e3af7bd086eae3$exports.pubkeyType.multisigThreshold,
        value: {
            threshold: threshold.toString(),
            pubkeys: pubkeys
        }
    };
}
/**
 * Uvarint encoder for Amino. This is the same encoding as `binary.PutUvarint` from the Go
 * standard library.
 *
 * @see https://github.com/tendermint/go-amino/blob/8e779b71f40d175/encoder.go#L77-L85
 */ function $68079a66d6248ed8$var$encodeUvarint(value) {
    const checked = $1d6e3095a7e37622$exports.Uint53.fromString(value.toString()).toNumber();
    if (checked > 127) throw new Error("Encoding numbers > 127 is not supported here. Please tell those lazy CosmJS maintainers to port the binary.PutUvarint implementation from the Go standard library and write some tests.");
    return [
        checked
    ];
}
/**
 * Encodes a public key to binary Amino.
 */ function $68079a66d6248ed8$var$encodeAminoPubkey(pubkey) {
    if ((0, $f1e3af7bd086eae3$exports.isMultisigThresholdPubkey)(pubkey)) {
        const out = Array.from($68079a66d6248ed8$var$pubkeyAminoPrefixMultisigThreshold);
        out.push(0x08); // TODO: What is this?
        out.push(...$68079a66d6248ed8$var$encodeUvarint(pubkey.value.threshold));
        for (const pubkeyData of pubkey.value.pubkeys.map((p)=>$68079a66d6248ed8$var$encodeAminoPubkey(p))){
            out.push(0x12); // TODO: What is this?
            out.push(...$68079a66d6248ed8$var$encodeUvarint(pubkeyData.length));
            out.push(...pubkeyData);
        }
        return new Uint8Array(out);
    } else if ((0, $f1e3af7bd086eae3$exports.isEd25519Pubkey)(pubkey)) return new Uint8Array([
        ...$68079a66d6248ed8$var$pubkeyAminoPrefixEd25519,
        ...(0, $3977281a39984aec$exports.fromBase64)(pubkey.value)
    ]);
    else if ((0, $f1e3af7bd086eae3$exports.isSecp256k1Pubkey)(pubkey)) return new Uint8Array([
        ...$68079a66d6248ed8$var$pubkeyAminoPrefixSecp256k1,
        ...(0, $3977281a39984aec$exports.fromBase64)(pubkey.value)
    ]);
    else throw new Error("Unsupported pubkey type");
}
$68079a66d6248ed8$exports.encodeAminoPubkey = $68079a66d6248ed8$var$encodeAminoPubkey;
/**
 * Encodes a public key to binary Amino and then to bech32.
 *
 * @param pubkey the public key to encode
 * @param prefix the bech32 prefix (human readable part)
 */ function $68079a66d6248ed8$var$encodeBech32Pubkey(pubkey, prefix) {
    return $3977281a39984aec$exports.Bech32.encode(prefix, $68079a66d6248ed8$var$encodeAminoPubkey(pubkey));
}
$68079a66d6248ed8$exports.encodeBech32Pubkey = $68079a66d6248ed8$var$encodeBech32Pubkey;



function $5ef7be25afc40ef7$var$rawEd25519PubkeyToRawAddress(pubkeyData) {
    if (pubkeyData.length !== 32) throw new Error(`Invalid Ed25519 pubkey length: ${pubkeyData.length}`);
    return (0, $ca4c58922ce7f03a$exports.sha256)(pubkeyData).slice(0, 20);
}
$5ef7be25afc40ef7$exports.rawEd25519PubkeyToRawAddress = $5ef7be25afc40ef7$var$rawEd25519PubkeyToRawAddress;
function $5ef7be25afc40ef7$var$rawSecp256k1PubkeyToRawAddress(pubkeyData) {
    if (pubkeyData.length !== 33) throw new Error(`Invalid Secp256k1 pubkey length (compressed): ${pubkeyData.length}`);
    return (0, $ca4c58922ce7f03a$exports.ripemd160)((0, $ca4c58922ce7f03a$exports.sha256)(pubkeyData));
}
$5ef7be25afc40ef7$exports.rawSecp256k1PubkeyToRawAddress = $5ef7be25afc40ef7$var$rawSecp256k1PubkeyToRawAddress;
// For secp256k1 this assumes we already have a compressed pubkey.
function $5ef7be25afc40ef7$var$pubkeyToRawAddress(pubkey) {
    if ((0, $f1e3af7bd086eae3$exports.isSecp256k1Pubkey)(pubkey)) {
        const pubkeyData = (0, $3977281a39984aec$exports.fromBase64)(pubkey.value);
        return $5ef7be25afc40ef7$var$rawSecp256k1PubkeyToRawAddress(pubkeyData);
    } else if ((0, $f1e3af7bd086eae3$exports.isEd25519Pubkey)(pubkey)) {
        const pubkeyData = (0, $3977281a39984aec$exports.fromBase64)(pubkey.value);
        return $5ef7be25afc40ef7$var$rawEd25519PubkeyToRawAddress(pubkeyData);
    } else if ((0, $f1e3af7bd086eae3$exports.isMultisigThresholdPubkey)(pubkey)) {
        // https://github.com/tendermint/tendermint/blob/38b401657e4ad7a7eeb3c30a3cbf512037df3740/crypto/multisig/threshold_pubkey.go#L71-L74
        const pubkeyData = (0, $68079a66d6248ed8$exports.encodeAminoPubkey)(pubkey);
        return (0, $ca4c58922ce7f03a$exports.sha256)(pubkeyData).slice(0, 20);
    } else throw new Error("Unsupported public key type");
}
$5ef7be25afc40ef7$exports.pubkeyToRawAddress = $5ef7be25afc40ef7$var$pubkeyToRawAddress;
function $5ef7be25afc40ef7$var$pubkeyToAddress(pubkey, prefix) {
    return $3977281a39984aec$exports.Bech32.encode(prefix, $5ef7be25afc40ef7$var$pubkeyToRawAddress(pubkey));
}
$5ef7be25afc40ef7$exports.pubkeyToAddress = $5ef7be25afc40ef7$var$pubkeyToAddress;


Object.defineProperty($a11446128a9e19fc$exports, "pubkeyToAddress", {
    enumerable: true,
    get: function() {
        return $5ef7be25afc40ef7$exports.pubkeyToAddress;
    }
});
Object.defineProperty($a11446128a9e19fc$exports, "pubkeyToRawAddress", {
    enumerable: true,
    get: function() {
        return $5ef7be25afc40ef7$exports.pubkeyToRawAddress;
    }
});
Object.defineProperty($a11446128a9e19fc$exports, "rawEd25519PubkeyToRawAddress", {
    enumerable: true,
    get: function() {
        return $5ef7be25afc40ef7$exports.rawEd25519PubkeyToRawAddress;
    }
});
Object.defineProperty($a11446128a9e19fc$exports, "rawSecp256k1PubkeyToRawAddress", {
    enumerable: true,
    get: function() {
        return $5ef7be25afc40ef7$exports.rawSecp256k1PubkeyToRawAddress;
    }
});
var $0a1a6848a5ee0662$exports = {};
"use strict";
Object.defineProperty($0a1a6848a5ee0662$exports, "__esModule", {
    value: true
});
$0a1a6848a5ee0662$exports.parseCoins = $0a1a6848a5ee0662$exports.coins = $0a1a6848a5ee0662$exports.coin = void 0;

/**
 * Creates a coin.
 *
 * If your values do not exceed the safe integer range of JS numbers (53 bit),
 * you can use the number type here. This is the case for all typical Cosmos SDK
 * chains that use the default 6 decimals.
 *
 * In case you need to supportr larger values, use unsigned integer strings instead.
 */ function $0a1a6848a5ee0662$var$coin(amount, denom) {
    let outAmount;
    if (typeof amount === "number") try {
        outAmount = new $1d6e3095a7e37622$exports.Uint53(amount).toString();
    } catch (_err) {
        throw new Error("Given amount is not a safe integer. Consider using a string instead to overcome the limitations of JS numbers.");
    }
    else {
        if (!amount.match(/^[0-9]+$/)) throw new Error("Invalid unsigned integer string format");
        outAmount = amount.replace(/^0*/, "") || "0";
    }
    return {
        amount: outAmount,
        denom: denom
    };
}
$0a1a6848a5ee0662$exports.coin = $0a1a6848a5ee0662$var$coin;
/**
 * Creates a list of coins with one element.
 */ function $0a1a6848a5ee0662$var$coins(amount, denom) {
    return [
        $0a1a6848a5ee0662$var$coin(amount, denom)
    ];
}
$0a1a6848a5ee0662$exports.coins = $0a1a6848a5ee0662$var$coins;
/**
 * Takes a coins list like "819966000ucosm,700000000ustake" and parses it.
 *
 * A Stargate-ready variant of this function is available via:
 *
 * ```
 * import { parseCoins } from "@cosmjs/proto-signing";
 * // or
 * import { parseCoins } from "@cosmjs/stargate";
 * ```
 */ function $0a1a6848a5ee0662$var$parseCoins(input) {
    return input.replace(/\s/g, "").split(",").filter(Boolean).map((part)=>{
        const match = part.match(/^([0-9]+)([a-zA-Z]+)/);
        if (!match) throw new Error("Got an invalid coin string");
        return {
            amount: $1d6e3095a7e37622$exports.Uint64.fromString(match[1]).toString(),
            denom: match[2]
        };
    });
}
$0a1a6848a5ee0662$exports.parseCoins = $0a1a6848a5ee0662$var$parseCoins;


Object.defineProperty($a11446128a9e19fc$exports, "coin", {
    enumerable: true,
    get: function() {
        return $0a1a6848a5ee0662$exports.coin;
    }
});
Object.defineProperty($a11446128a9e19fc$exports, "coins", {
    enumerable: true,
    get: function() {
        return $0a1a6848a5ee0662$exports.coins;
    }
});
Object.defineProperty($a11446128a9e19fc$exports, "parseCoins", {
    enumerable: true,
    get: function() {
        return $0a1a6848a5ee0662$exports.parseCoins;
    }
});

Object.defineProperty($a11446128a9e19fc$exports, "decodeAminoPubkey", {
    enumerable: true,
    get: function() {
        return $68079a66d6248ed8$exports.decodeAminoPubkey;
    }
});
Object.defineProperty($a11446128a9e19fc$exports, "decodeBech32Pubkey", {
    enumerable: true,
    get: function() {
        return $68079a66d6248ed8$exports.decodeBech32Pubkey;
    }
});
Object.defineProperty($a11446128a9e19fc$exports, "encodeAminoPubkey", {
    enumerable: true,
    get: function() {
        return $68079a66d6248ed8$exports.encodeAminoPubkey;
    }
});
Object.defineProperty($a11446128a9e19fc$exports, "encodeBech32Pubkey", {
    enumerable: true,
    get: function() {
        return $68079a66d6248ed8$exports.encodeBech32Pubkey;
    }
});
Object.defineProperty($a11446128a9e19fc$exports, "encodeSecp256k1Pubkey", {
    enumerable: true,
    get: function() {
        return $68079a66d6248ed8$exports.encodeSecp256k1Pubkey;
    }
});
var $7d4553111913cae9$exports = {};
"use strict";
Object.defineProperty($7d4553111913cae9$exports, "__esModule", {
    value: true
});
$7d4553111913cae9$exports.createMultisigThresholdPubkey = $7d4553111913cae9$exports.compareArrays = void 0;



/**
 * Compare arrays lexicographically.
 *
 * Returns value < 0 if `a < b`.
 * Returns value > 0 if `a > b`.
 * Returns 0 if `a === b`.
 */ function $7d4553111913cae9$var$compareArrays(a, b) {
    const aHex = (0, $3977281a39984aec$exports.toHex)(a);
    const bHex = (0, $3977281a39984aec$exports.toHex)(b);
    return aHex === bHex ? 0 : aHex < bHex ? -1 : 1;
}
$7d4553111913cae9$exports.compareArrays = $7d4553111913cae9$var$compareArrays;
function $7d4553111913cae9$var$createMultisigThresholdPubkey(pubkeys, threshold, nosort = false) {
    const uintThreshold = new $1d6e3095a7e37622$exports.Uint53(threshold);
    if (uintThreshold.toNumber() > pubkeys.length) throw new Error(`Threshold k = ${uintThreshold.toNumber()} exceeds number of keys n = ${pubkeys.length}`);
    const outPubkeys = nosort ? pubkeys : Array.from(pubkeys).sort((lhs, rhs)=>{
        // https://github.com/cosmos/cosmos-sdk/blob/v0.42.2/client/keys/add.go#L172-L174
        const addressLhs = (0, $5ef7be25afc40ef7$exports.pubkeyToRawAddress)(lhs);
        const addressRhs = (0, $5ef7be25afc40ef7$exports.pubkeyToRawAddress)(rhs);
        return $7d4553111913cae9$var$compareArrays(addressLhs, addressRhs);
    });
    return {
        type: "tendermint/PubKeyMultisigThreshold",
        value: {
            threshold: uintThreshold.toString(),
            pubkeys: outPubkeys
        }
    };
}
$7d4553111913cae9$exports.createMultisigThresholdPubkey = $7d4553111913cae9$var$createMultisigThresholdPubkey;


Object.defineProperty($a11446128a9e19fc$exports, "createMultisigThresholdPubkey", {
    enumerable: true,
    get: function() {
        return $7d4553111913cae9$exports.createMultisigThresholdPubkey;
    }
});
var $8afb1ec71503b0b3$exports = {};
"use strict";
Object.defineProperty($8afb1ec71503b0b3$exports, "__esModule", {
    value: true
});
$8afb1ec71503b0b3$exports.makeCosmoshubPath = void 0;

/**
 * The Cosmos Hub derivation path in the form `m/44'/118'/0'/0/a`
 * with 0-based account index `a`.
 */ function $8afb1ec71503b0b3$var$makeCosmoshubPath(a) {
    return [
        $ca4c58922ce7f03a$exports.Slip10RawIndex.hardened(44),
        $ca4c58922ce7f03a$exports.Slip10RawIndex.hardened(118),
        $ca4c58922ce7f03a$exports.Slip10RawIndex.hardened(0),
        $ca4c58922ce7f03a$exports.Slip10RawIndex.normal(0),
        $ca4c58922ce7f03a$exports.Slip10RawIndex.normal(a)
    ];
}
$8afb1ec71503b0b3$exports.makeCosmoshubPath = $8afb1ec71503b0b3$var$makeCosmoshubPath;


Object.defineProperty($a11446128a9e19fc$exports, "makeCosmoshubPath", {
    enumerable: true,
    get: function() {
        return $8afb1ec71503b0b3$exports.makeCosmoshubPath;
    }
});

Object.defineProperty($a11446128a9e19fc$exports, "isEd25519Pubkey", {
    enumerable: true,
    get: function() {
        return $f1e3af7bd086eae3$exports.isEd25519Pubkey;
    }
});
Object.defineProperty($a11446128a9e19fc$exports, "isMultisigThresholdPubkey", {
    enumerable: true,
    get: function() {
        return $f1e3af7bd086eae3$exports.isMultisigThresholdPubkey;
    }
});
Object.defineProperty($a11446128a9e19fc$exports, "isSecp256k1Pubkey", {
    enumerable: true,
    get: function() {
        return $f1e3af7bd086eae3$exports.isSecp256k1Pubkey;
    }
});
Object.defineProperty($a11446128a9e19fc$exports, "isSinglePubkey", {
    enumerable: true,
    get: function() {
        return $f1e3af7bd086eae3$exports.isSinglePubkey;
    }
});
Object.defineProperty($a11446128a9e19fc$exports, "pubkeyType", {
    enumerable: true,
    get: function() {
        return $f1e3af7bd086eae3$exports.pubkeyType;
    }
});
var $c3535b9d4283f835$exports = {};
"use strict";
Object.defineProperty($c3535b9d4283f835$exports, "__esModule", {
    value: true
});
$c3535b9d4283f835$exports.Secp256k1HdWallet = $c3535b9d4283f835$exports.extractKdfConfiguration = void 0;



var $dOLgD = parcelRequire("dOLgD");


var $77366b981aa3d14e$exports = {};
"use strict";
Object.defineProperty($77366b981aa3d14e$exports, "__esModule", {
    value: true
});
$77366b981aa3d14e$exports.decodeSignature = $77366b981aa3d14e$exports.encodeSecp256k1Signature = void 0;



/**
 * Takes a binary pubkey and signature to create a signature object
 *
 * @param pubkey a compressed secp256k1 public key
 * @param signature a 64 byte fixed length representation of secp256k1 signature components r and s
 */ function $77366b981aa3d14e$var$encodeSecp256k1Signature(pubkey, signature) {
    if (signature.length !== 64) throw new Error("Signature must be 64 bytes long. Cosmos SDK uses a 2x32 byte fixed length encoding for the secp256k1 signature integers r and s.");
    return {
        pub_key: (0, $68079a66d6248ed8$exports.encodeSecp256k1Pubkey)(pubkey),
        signature: (0, $3977281a39984aec$exports.toBase64)(signature)
    };
}
$77366b981aa3d14e$exports.encodeSecp256k1Signature = $77366b981aa3d14e$var$encodeSecp256k1Signature;
function $77366b981aa3d14e$var$decodeSignature(signature) {
    switch(signature.pub_key.type){
        // Note: please don't add cases here without writing additional unit tests
        case $f1e3af7bd086eae3$exports.pubkeyType.secp256k1:
            return {
                pubkey: (0, $3977281a39984aec$exports.fromBase64)(signature.pub_key.value),
                signature: (0, $3977281a39984aec$exports.fromBase64)(signature.signature)
            };
        default:
            throw new Error("Unsupported pubkey type");
    }
}
$77366b981aa3d14e$exports.decodeSignature = $77366b981aa3d14e$var$decodeSignature;


var $eb773f8b0da24058$exports = {};
"use strict";
Object.defineProperty($eb773f8b0da24058$exports, "__esModule", {
    value: true
});
$eb773f8b0da24058$exports.serializeSignDoc = $eb773f8b0da24058$exports.makeSignDoc = $eb773f8b0da24058$exports.sortedJsonStringify = void 0;


function $eb773f8b0da24058$var$sortedObject(obj) {
    if (typeof obj !== "object" || obj === null) return obj;
    if (Array.isArray(obj)) return obj.map($eb773f8b0da24058$var$sortedObject);
    const sortedKeys = Object.keys(obj).sort();
    const result = {};
    // NOTE: Use forEach instead of reduce for performance with large objects eg Wasm code
    sortedKeys.forEach((key)=>{
        result[key] = $eb773f8b0da24058$var$sortedObject(obj[key]);
    });
    return result;
}
/** Returns a JSON string with objects sorted by key */ // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
function $eb773f8b0da24058$var$sortedJsonStringify(obj) {
    return JSON.stringify($eb773f8b0da24058$var$sortedObject(obj));
}
$eb773f8b0da24058$exports.sortedJsonStringify = $eb773f8b0da24058$var$sortedJsonStringify;
function $eb773f8b0da24058$var$makeSignDoc(msgs, fee, chainId, memo, accountNumber, sequence) {
    return {
        chain_id: chainId,
        account_number: $1d6e3095a7e37622$exports.Uint53.fromString(accountNumber.toString()).toString(),
        sequence: $1d6e3095a7e37622$exports.Uint53.fromString(sequence.toString()).toString(),
        fee: fee,
        msgs: msgs,
        memo: memo || ""
    };
}
$eb773f8b0da24058$exports.makeSignDoc = $eb773f8b0da24058$var$makeSignDoc;
function $eb773f8b0da24058$var$serializeSignDoc(signDoc) {
    return (0, $3977281a39984aec$exports.toUtf8)($eb773f8b0da24058$var$sortedJsonStringify(signDoc));
}
$eb773f8b0da24058$exports.serializeSignDoc = $eb773f8b0da24058$var$serializeSignDoc;


var $f06b1af6d55110b4$exports = {};
"use strict";
Object.defineProperty($f06b1af6d55110b4$exports, "__esModule", {
    value: true
});
$f06b1af6d55110b4$exports.decrypt = $f06b1af6d55110b4$exports.encrypt = $f06b1af6d55110b4$exports.supportedAlgorithms = $f06b1af6d55110b4$exports.executeKdf = $f06b1af6d55110b4$exports.cosmjsSalt = void 0;


/**
 * A fixed salt is chosen to archive a deterministic password to key derivation.
 * This reduces the scope of a potential rainbow attack to all CosmJS users.
 * Must be 16 bytes due to implementation limitations.
 */ $f06b1af6d55110b4$exports.cosmjsSalt = (0, $3977281a39984aec$exports.toAscii)("The CosmJS salt.");
async function $f06b1af6d55110b4$var$executeKdf(password, configuration) {
    switch(configuration.algorithm){
        case "argon2id":
            {
                const options = configuration.params;
                if (!(0, $ca4c58922ce7f03a$exports.isArgon2idOptions)(options)) throw new Error("Invalid format of argon2id params");
                return $ca4c58922ce7f03a$exports.Argon2id.execute(password, $f06b1af6d55110b4$exports.cosmjsSalt, options);
            }
        default:
            throw new Error("Unsupported KDF algorithm");
    }
}
$f06b1af6d55110b4$exports.executeKdf = $f06b1af6d55110b4$var$executeKdf;
$f06b1af6d55110b4$exports.supportedAlgorithms = {
    xchacha20poly1305Ietf: "xchacha20poly1305-ietf"
};
async function $f06b1af6d55110b4$var$encrypt(plaintext, encryptionKey, config) {
    switch(config.algorithm){
        case $f06b1af6d55110b4$exports.supportedAlgorithms.xchacha20poly1305Ietf:
            {
                const nonce = $ca4c58922ce7f03a$exports.Random.getBytes($ca4c58922ce7f03a$exports.xchacha20NonceLength);
                // Prepend fixed-length nonce to ciphertext as suggested in the example from https://github.com/jedisct1/libsodium.js#api
                return new Uint8Array([
                    ...nonce,
                    ...await $ca4c58922ce7f03a$exports.Xchacha20poly1305Ietf.encrypt(plaintext, encryptionKey, nonce)
                ]);
            }
        default:
            throw new Error(`Unsupported encryption algorithm: '${config.algorithm}'`);
    }
}
$f06b1af6d55110b4$exports.encrypt = $f06b1af6d55110b4$var$encrypt;
async function $f06b1af6d55110b4$var$decrypt(ciphertext, encryptionKey, config) {
    switch(config.algorithm){
        case $f06b1af6d55110b4$exports.supportedAlgorithms.xchacha20poly1305Ietf:
            {
                const nonce = ciphertext.slice(0, $ca4c58922ce7f03a$exports.xchacha20NonceLength);
                return $ca4c58922ce7f03a$exports.Xchacha20poly1305Ietf.decrypt(ciphertext.slice($ca4c58922ce7f03a$exports.xchacha20NonceLength), encryptionKey, nonce);
            }
        default:
            throw new Error(`Unsupported encryption algorithm: '${config.algorithm}'`);
    }
}
$f06b1af6d55110b4$exports.decrypt = $f06b1af6d55110b4$var$decrypt;


const $c3535b9d4283f835$var$serializationTypeV1 = "secp256k1wallet-v1";
/**
 * A KDF configuration that is not very strong but can be used on the main thread.
 * It takes about 1 second in Node.js 16.0.0 and should have similar runtimes in other modern Wasm hosts.
 */ const $c3535b9d4283f835$var$basicPasswordHashingOptions = {
    algorithm: "argon2id",
    params: {
        outputLength: 32,
        opsLimit: 24,
        memLimitKib: 12288
    }
};
function $c3535b9d4283f835$var$isDerivationJson(thing) {
    if (!(0, $dOLgD.isNonNullObject)(thing)) return false;
    if (typeof thing.hdPath !== "string") return false;
    if (typeof thing.prefix !== "string") return false;
    return true;
}
function $c3535b9d4283f835$var$extractKdfConfigurationV1(doc) {
    return doc.kdf;
}
function $c3535b9d4283f835$var$extractKdfConfiguration(serialization) {
    const root = JSON.parse(serialization);
    if (!(0, $dOLgD.isNonNullObject)(root)) throw new Error("Root document is not an object.");
    switch(root.type){
        case $c3535b9d4283f835$var$serializationTypeV1:
            return $c3535b9d4283f835$var$extractKdfConfigurationV1(root);
        default:
            throw new Error("Unsupported serialization type");
    }
}
$c3535b9d4283f835$exports.extractKdfConfiguration = $c3535b9d4283f835$var$extractKdfConfiguration;
const $c3535b9d4283f835$var$defaultOptions = {
    bip39Password: "",
    hdPaths: [
        (0, $8afb1ec71503b0b3$exports.makeCosmoshubPath)(0)
    ],
    prefix: "cosmos"
};
class $c3535b9d4283f835$var$Secp256k1HdWallet {
    constructor(mnemonic, options){
        var _a, _b;
        const hdPaths = (_a = options.hdPaths) !== null && _a !== void 0 ? _a : $c3535b9d4283f835$var$defaultOptions.hdPaths;
        const prefix = (_b = options.prefix) !== null && _b !== void 0 ? _b : $c3535b9d4283f835$var$defaultOptions.prefix;
        this.secret = mnemonic;
        this.seed = options.seed;
        this.accounts = hdPaths.map((hdPath)=>({
                hdPath: hdPath,
                prefix: prefix
            }));
    }
    /**
     * Restores a wallet from the given BIP39 mnemonic.
     *
     * @param mnemonic Any valid English mnemonic.
     * @param options An optional `Secp256k1HdWalletOptions` object optionally containing a bip39Password, hdPaths, and prefix.
     */ static async fromMnemonic(mnemonic, options = {}) {
        const mnemonicChecked = new $ca4c58922ce7f03a$exports.EnglishMnemonic(mnemonic);
        const seed = await $ca4c58922ce7f03a$exports.Bip39.mnemonicToSeed(mnemonicChecked, options.bip39Password);
        return new $c3535b9d4283f835$var$Secp256k1HdWallet(mnemonicChecked, Object.assign(Object.assign({}, options), {
            seed: seed
        }));
    }
    /**
     * Generates a new wallet with a BIP39 mnemonic of the given length.
     *
     * @param length The number of words in the mnemonic (12, 15, 18, 21 or 24).
     * @param options An optional `Secp256k1HdWalletOptions` object optionally containing a bip39Password, hdPaths, and prefix.
     */ static async generate(length = 12, options = {}) {
        const entropyLength = 4 * Math.floor(11 * length / 33);
        const entropy = $ca4c58922ce7f03a$exports.Random.getBytes(entropyLength);
        const mnemonic = $ca4c58922ce7f03a$exports.Bip39.encode(entropy);
        return $c3535b9d4283f835$var$Secp256k1HdWallet.fromMnemonic(mnemonic.toString(), options);
    }
    /**
     * Restores a wallet from an encrypted serialization.
     *
     * @param password The user provided password used to generate an encryption key via a KDF.
     *                 This is not normalized internally (see "Unicode normalization" to learn more).
     */ static async deserialize(serialization, password) {
        const root = JSON.parse(serialization);
        if (!(0, $dOLgD.isNonNullObject)(root)) throw new Error("Root document is not an object.");
        switch(root.type){
            case $c3535b9d4283f835$var$serializationTypeV1:
                return $c3535b9d4283f835$var$Secp256k1HdWallet.deserializeTypeV1(serialization, password);
            default:
                throw new Error("Unsupported serialization type");
        }
    }
    /**
     * Restores a wallet from an encrypted serialization.
     *
     * This is an advanced alternative to calling `deserialize(serialization, password)` directly, which allows
     * you to offload the KDF execution to a non-UI thread (e.g. in a WebWorker).
     *
     * The caller is responsible for ensuring the key was derived with the given KDF configuration. This can be
     * done using `extractKdfConfiguration(serialization)` and `executeKdf(password, kdfConfiguration)` from this package.
     */ static async deserializeWithEncryptionKey(serialization, encryptionKey) {
        const root = JSON.parse(serialization);
        if (!(0, $dOLgD.isNonNullObject)(root)) throw new Error("Root document is not an object.");
        const untypedRoot = root;
        switch(untypedRoot.type){
            case $c3535b9d4283f835$var$serializationTypeV1:
                {
                    const decryptedBytes = await (0, $f06b1af6d55110b4$exports.decrypt)((0, $3977281a39984aec$exports.fromBase64)(untypedRoot.data), encryptionKey, untypedRoot.encryption);
                    const decryptedDocument = JSON.parse((0, $3977281a39984aec$exports.fromUtf8)(decryptedBytes));
                    const { mnemonic: mnemonic, accounts: accounts } = decryptedDocument;
                    (0, $dOLgD.assert)(typeof mnemonic === "string");
                    if (!Array.isArray(accounts)) throw new Error("Property 'accounts' is not an array");
                    if (!accounts.every((account)=>$c3535b9d4283f835$var$isDerivationJson(account))) throw new Error("Account is not in the correct format.");
                    const firstPrefix = accounts[0].prefix;
                    if (!accounts.every(({ prefix: prefix })=>prefix === firstPrefix)) throw new Error("Accounts do not all have the same prefix");
                    const hdPaths = accounts.map(({ hdPath: hdPath })=>(0, $ca4c58922ce7f03a$exports.stringToPath)(hdPath));
                    return $c3535b9d4283f835$var$Secp256k1HdWallet.fromMnemonic(mnemonic, {
                        hdPaths: hdPaths,
                        prefix: firstPrefix
                    });
                }
            default:
                throw new Error("Unsupported serialization type");
        }
    }
    static async deserializeTypeV1(serialization, password) {
        const root = JSON.parse(serialization);
        if (!(0, $dOLgD.isNonNullObject)(root)) throw new Error("Root document is not an object.");
        const encryptionKey = await (0, $f06b1af6d55110b4$exports.executeKdf)(password, root.kdf);
        return $c3535b9d4283f835$var$Secp256k1HdWallet.deserializeWithEncryptionKey(serialization, encryptionKey);
    }
    get mnemonic() {
        return this.secret.toString();
    }
    async getAccounts() {
        const accountsWithPrivkeys = await this.getAccountsWithPrivkeys();
        return accountsWithPrivkeys.map(({ algo: algo, pubkey: pubkey, address: address })=>({
                algo: algo,
                pubkey: pubkey,
                address: address
            }));
    }
    async signAmino(signerAddress, signDoc) {
        const accounts = await this.getAccountsWithPrivkeys();
        const account = accounts.find(({ address: address })=>address === signerAddress);
        if (account === undefined) throw new Error(`Address ${signerAddress} not found in wallet`);
        const { privkey: privkey, pubkey: pubkey } = account;
        const message = (0, $ca4c58922ce7f03a$exports.sha256)((0, $eb773f8b0da24058$exports.serializeSignDoc)(signDoc));
        const signature = await $ca4c58922ce7f03a$exports.Secp256k1.createSignature(message, privkey);
        const signatureBytes = new Uint8Array([
            ...signature.r(32),
            ...signature.s(32)
        ]);
        return {
            signed: signDoc,
            signature: (0, $77366b981aa3d14e$exports.encodeSecp256k1Signature)(pubkey, signatureBytes)
        };
    }
    /**
     * Generates an encrypted serialization of this wallet.
     *
     * @param password The user provided password used to generate an encryption key via a KDF.
     *                 This is not normalized internally (see "Unicode normalization" to learn more).
     */ async serialize(password) {
        const kdfConfiguration = $c3535b9d4283f835$var$basicPasswordHashingOptions;
        const encryptionKey = await (0, $f06b1af6d55110b4$exports.executeKdf)(password, kdfConfiguration);
        return this.serializeWithEncryptionKey(encryptionKey, kdfConfiguration);
    }
    /**
     * Generates an encrypted serialization of this wallet.
     *
     * This is an advanced alternative to calling `serialize(password)` directly, which allows you to
     * offload the KDF execution to a non-UI thread (e.g. in a WebWorker).
     *
     * The caller is responsible for ensuring the key was derived with the given KDF options. If this
     * is not the case, the wallet cannot be restored with the original password.
     */ async serializeWithEncryptionKey(encryptionKey, kdfConfiguration) {
        const dataToEncrypt = {
            mnemonic: this.mnemonic,
            accounts: this.accounts.map(({ hdPath: hdPath, prefix: prefix })=>({
                    hdPath: (0, $ca4c58922ce7f03a$exports.pathToString)(hdPath),
                    prefix: prefix
                }))
        };
        const dataToEncryptRaw = (0, $3977281a39984aec$exports.toUtf8)(JSON.stringify(dataToEncrypt));
        const encryptionConfiguration = {
            algorithm: $f06b1af6d55110b4$exports.supportedAlgorithms.xchacha20poly1305Ietf
        };
        const encryptedData = await (0, $f06b1af6d55110b4$exports.encrypt)(dataToEncryptRaw, encryptionKey, encryptionConfiguration);
        const out = {
            type: $c3535b9d4283f835$var$serializationTypeV1,
            kdf: kdfConfiguration,
            encryption: encryptionConfiguration,
            data: (0, $3977281a39984aec$exports.toBase64)(encryptedData)
        };
        return JSON.stringify(out);
    }
    async getKeyPair(hdPath) {
        const { privkey: privkey } = $ca4c58922ce7f03a$exports.Slip10.derivePath($ca4c58922ce7f03a$exports.Slip10Curve.Secp256k1, this.seed, hdPath);
        const { pubkey: pubkey } = await $ca4c58922ce7f03a$exports.Secp256k1.makeKeypair(privkey);
        return {
            privkey: privkey,
            pubkey: $ca4c58922ce7f03a$exports.Secp256k1.compressPubkey(pubkey)
        };
    }
    async getAccountsWithPrivkeys() {
        return Promise.all(this.accounts.map(async ({ hdPath: hdPath, prefix: prefix })=>{
            const { privkey: privkey, pubkey: pubkey } = await this.getKeyPair(hdPath);
            const address = $3977281a39984aec$exports.Bech32.encode(prefix, (0, $5ef7be25afc40ef7$exports.rawSecp256k1PubkeyToRawAddress)(pubkey));
            return {
                algo: "secp256k1",
                privkey: privkey,
                pubkey: pubkey,
                address: address
            };
        }));
    }
}
$c3535b9d4283f835$exports.Secp256k1HdWallet = $c3535b9d4283f835$var$Secp256k1HdWallet;


Object.defineProperty($a11446128a9e19fc$exports, "extractKdfConfiguration", {
    enumerable: true,
    get: function() {
        return $c3535b9d4283f835$exports.extractKdfConfiguration;
    }
});
Object.defineProperty($a11446128a9e19fc$exports, "Secp256k1HdWallet", {
    enumerable: true,
    get: function() {
        return $c3535b9d4283f835$exports.Secp256k1HdWallet;
    }
});
var $63e06d63e72c310f$exports = {};
"use strict";
Object.defineProperty($63e06d63e72c310f$exports, "__esModule", {
    value: true
});
$63e06d63e72c310f$exports.Secp256k1Wallet = void 0;





/**
 * A wallet that holds a single secp256k1 keypair.
 *
 * If you want to work with BIP39 mnemonics and multiple accounts, use Secp256k1HdWallet.
 */ class $63e06d63e72c310f$var$Secp256k1Wallet {
    constructor(privkey, pubkey, prefix){
        this.privkey = privkey;
        this.pubkey = pubkey;
        this.prefix = prefix;
    }
    /**
     * Creates a Secp256k1Wallet from the given private key
     *
     * @param privkey The private key.
     * @param prefix The bech32 address prefix (human readable part). Defaults to "cosmos".
     */ static async fromKey(privkey, prefix = "cosmos") {
        const uncompressed = (await $ca4c58922ce7f03a$exports.Secp256k1.makeKeypair(privkey)).pubkey;
        return new $63e06d63e72c310f$var$Secp256k1Wallet(privkey, $ca4c58922ce7f03a$exports.Secp256k1.compressPubkey(uncompressed), prefix);
    }
    get address() {
        return $3977281a39984aec$exports.Bech32.encode(this.prefix, (0, $5ef7be25afc40ef7$exports.rawSecp256k1PubkeyToRawAddress)(this.pubkey));
    }
    async getAccounts() {
        return [
            {
                algo: "secp256k1",
                address: this.address,
                pubkey: this.pubkey
            }
        ];
    }
    async signAmino(signerAddress, signDoc) {
        if (signerAddress !== this.address) throw new Error(`Address ${signerAddress} not found in wallet`);
        const message = new $ca4c58922ce7f03a$exports.Sha256((0, $eb773f8b0da24058$exports.serializeSignDoc)(signDoc)).digest();
        const signature = await $ca4c58922ce7f03a$exports.Secp256k1.createSignature(message, this.privkey);
        const signatureBytes = new Uint8Array([
            ...signature.r(32),
            ...signature.s(32)
        ]);
        return {
            signed: signDoc,
            signature: (0, $77366b981aa3d14e$exports.encodeSecp256k1Signature)(this.pubkey, signatureBytes)
        };
    }
}
$63e06d63e72c310f$exports.Secp256k1Wallet = $63e06d63e72c310f$var$Secp256k1Wallet;


Object.defineProperty($a11446128a9e19fc$exports, "Secp256k1Wallet", {
    enumerable: true,
    get: function() {
        return $63e06d63e72c310f$exports.Secp256k1Wallet;
    }
});

Object.defineProperty($a11446128a9e19fc$exports, "decodeSignature", {
    enumerable: true,
    get: function() {
        return $77366b981aa3d14e$exports.decodeSignature;
    }
});
Object.defineProperty($a11446128a9e19fc$exports, "encodeSecp256k1Signature", {
    enumerable: true,
    get: function() {
        return $77366b981aa3d14e$exports.encodeSecp256k1Signature;
    }
});

Object.defineProperty($a11446128a9e19fc$exports, "makeSignDoc", {
    enumerable: true,
    get: function() {
        return $eb773f8b0da24058$exports.makeSignDoc;
    }
});
Object.defineProperty($a11446128a9e19fc$exports, "serializeSignDoc", {
    enumerable: true,
    get: function() {
        return $eb773f8b0da24058$exports.serializeSignDoc;
    }
});
var $d3e37fdca7fffcd5$exports = {};
"use strict";
Object.defineProperty($d3e37fdca7fffcd5$exports, "__esModule", {
    value: true
});
$d3e37fdca7fffcd5$exports.makeStdTx = $d3e37fdca7fffcd5$exports.isStdTx = void 0;
function $d3e37fdca7fffcd5$var$isStdTx(txValue) {
    const { memo: memo, msg: msg, fee: fee, signatures: signatures } = txValue;
    return typeof memo === "string" && Array.isArray(msg) && typeof fee === "object" && Array.isArray(signatures);
}
$d3e37fdca7fffcd5$exports.isStdTx = $d3e37fdca7fffcd5$var$isStdTx;
function $d3e37fdca7fffcd5$var$makeStdTx(content, signatures) {
    return {
        msg: content.msgs,
        fee: content.fee,
        memo: content.memo,
        signatures: Array.isArray(signatures) ? signatures : [
            signatures
        ]
    };
}
$d3e37fdca7fffcd5$exports.makeStdTx = $d3e37fdca7fffcd5$var$makeStdTx;


Object.defineProperty($a11446128a9e19fc$exports, "isStdTx", {
    enumerable: true,
    get: function() {
        return $d3e37fdca7fffcd5$exports.isStdTx;
    }
});
Object.defineProperty($a11446128a9e19fc$exports, "makeStdTx", {
    enumerable: true,
    get: function() {
        return $d3e37fdca7fffcd5$exports.makeStdTx;
    }
});

Object.defineProperty($a11446128a9e19fc$exports, "executeKdf", {
    enumerable: true,
    get: function() {
        return $f06b1af6d55110b4$exports.executeKdf;
    }
});


Object.defineProperty($b8ae3714266935c3$exports, "coin", {
    enumerable: true,
    get: function() {
        return $a11446128a9e19fc$exports.coin;
    }
});
Object.defineProperty($b8ae3714266935c3$exports, "coins", {
    enumerable: true,
    get: function() {
        return $a11446128a9e19fc$exports.coins;
    }
});
Object.defineProperty($b8ae3714266935c3$exports, "decodeAminoPubkey", {
    enumerable: true,
    get: function() {
        return $a11446128a9e19fc$exports.decodeAminoPubkey;
    }
});
Object.defineProperty($b8ae3714266935c3$exports, "decodeBech32Pubkey", {
    enumerable: true,
    get: function() {
        return $a11446128a9e19fc$exports.decodeBech32Pubkey;
    }
});
Object.defineProperty($b8ae3714266935c3$exports, "decodeSignature", {
    enumerable: true,
    get: function() {
        return $a11446128a9e19fc$exports.decodeSignature;
    }
});
Object.defineProperty($b8ae3714266935c3$exports, "encodeAminoPubkey", {
    enumerable: true,
    get: function() {
        return $a11446128a9e19fc$exports.encodeAminoPubkey;
    }
});
Object.defineProperty($b8ae3714266935c3$exports, "encodeBech32Pubkey", {
    enumerable: true,
    get: function() {
        return $a11446128a9e19fc$exports.encodeBech32Pubkey;
    }
});
Object.defineProperty($b8ae3714266935c3$exports, "encodeSecp256k1Pubkey", {
    enumerable: true,
    get: function() {
        return $a11446128a9e19fc$exports.encodeSecp256k1Pubkey;
    }
});
Object.defineProperty($b8ae3714266935c3$exports, "encodeSecp256k1Signature", {
    enumerable: true,
    get: function() {
        return $a11446128a9e19fc$exports.encodeSecp256k1Signature;
    }
});
Object.defineProperty($b8ae3714266935c3$exports, "executeKdf", {
    enumerable: true,
    get: function() {
        return $a11446128a9e19fc$exports.executeKdf;
    }
});
Object.defineProperty($b8ae3714266935c3$exports, "extractKdfConfiguration", {
    enumerable: true,
    get: function() {
        return $a11446128a9e19fc$exports.extractKdfConfiguration;
    }
});
Object.defineProperty($b8ae3714266935c3$exports, "isStdTx", {
    enumerable: true,
    get: function() {
        return $a11446128a9e19fc$exports.isStdTx;
    }
});
Object.defineProperty($b8ae3714266935c3$exports, "makeCosmoshubPath", {
    enumerable: true,
    get: function() {
        return $a11446128a9e19fc$exports.makeCosmoshubPath;
    }
});
Object.defineProperty($b8ae3714266935c3$exports, "makeSignDoc", {
    enumerable: true,
    get: function() {
        return $a11446128a9e19fc$exports.makeSignDoc;
    }
});
Object.defineProperty($b8ae3714266935c3$exports, "makeStdTx", {
    enumerable: true,
    get: function() {
        return $a11446128a9e19fc$exports.makeStdTx;
    }
});
Object.defineProperty($b8ae3714266935c3$exports, "parseCoins", {
    enumerable: true,
    get: function() {
        return $a11446128a9e19fc$exports.parseCoins;
    }
});
Object.defineProperty($b8ae3714266935c3$exports, "pubkeyToAddress", {
    enumerable: true,
    get: function() {
        return $a11446128a9e19fc$exports.pubkeyToAddress;
    }
});
Object.defineProperty($b8ae3714266935c3$exports, "pubkeyType", {
    enumerable: true,
    get: function() {
        return $a11446128a9e19fc$exports.pubkeyType;
    }
});
Object.defineProperty($b8ae3714266935c3$exports, "Secp256k1HdWallet", {
    enumerable: true,
    get: function() {
        return $a11446128a9e19fc$exports.Secp256k1HdWallet;
    }
});
Object.defineProperty($b8ae3714266935c3$exports, "Secp256k1Wallet", {
    enumerable: true,
    get: function() {
        return $a11446128a9e19fc$exports.Secp256k1Wallet;
    }
});
Object.defineProperty($b8ae3714266935c3$exports, "serializeSignDoc", {
    enumerable: true,
    get: function() {
        return $a11446128a9e19fc$exports.serializeSignDoc;
    }
});

const $b8ae3714266935c3$var$logs = $b8ae3714266935c3$var$__importStar((parcelRequire("fnnh9")));
$b8ae3714266935c3$exports.logs = $b8ae3714266935c3$var$logs;
var $39b326257dacbed3$exports = {};
"use strict";
Object.defineProperty($39b326257dacbed3$exports, "__esModule", {
    value: true
});
$39b326257dacbed3$exports.CosmosClient = $39b326257dacbed3$exports.isSearchByTagsQuery = $39b326257dacbed3$exports.isSearchBySentFromOrToQuery = $39b326257dacbed3$exports.isSearchByHeightQuery = $39b326257dacbed3$exports.assertIsBroadcastTxSuccess = $39b326257dacbed3$exports.isBroadcastTxSuccess = $39b326257dacbed3$exports.isBroadcastTxFailure = void 0;



var $25c7156131030f5c$exports = {};
"use strict";
//
// Standard modules (see tracking issue https://github.com/cosmos/cosmjs/issues/276)
//
Object.defineProperty($25c7156131030f5c$exports, "__esModule", {
    value: true
});
$25c7156131030f5c$exports.uint64ToString = $25c7156131030f5c$exports.uint64ToNumber = $25c7156131030f5c$exports.normalizePubkey = $25c7156131030f5c$exports.normalizeLcdApiArray = $25c7156131030f5c$exports.LcdClient = $25c7156131030f5c$exports.BroadcastMode = $25c7156131030f5c$exports.setupSupplyExtension = $25c7156131030f5c$exports.setupStakingExtension = $25c7156131030f5c$exports.setupSlashingExtension = $25c7156131030f5c$exports.setupMintExtension = $25c7156131030f5c$exports.setupGovExtension = $25c7156131030f5c$exports.setupDistributionExtension = $25c7156131030f5c$exports.setupBankExtension = $25c7156131030f5c$exports.setupAuthExtension = void 0;
var $edb0fef9acba2ced$exports = {};
"use strict";
Object.defineProperty($edb0fef9acba2ced$exports, "__esModule", {
    value: true
});
$edb0fef9acba2ced$exports.setupAuthExtension = void 0;
function $edb0fef9acba2ced$var$setupAuthExtension(base) {
    return {
        auth: {
            account: async (address)=>{
                const path = `/auth/accounts/${address}`;
                const responseData = await base.get(path);
                if (responseData.result.type !== "cosmos-sdk/Account") throw new Error("Unexpected response data format");
                return responseData;
            }
        }
    };
}
$edb0fef9acba2ced$exports.setupAuthExtension = $edb0fef9acba2ced$var$setupAuthExtension;


Object.defineProperty($25c7156131030f5c$exports, "setupAuthExtension", {
    enumerable: true,
    get: function() {
        return $edb0fef9acba2ced$exports.setupAuthExtension;
    }
});
var $92c4ef58fd5719d9$exports = {};
"use strict";
Object.defineProperty($92c4ef58fd5719d9$exports, "__esModule", {
    value: true
});
$92c4ef58fd5719d9$exports.setupBankExtension = void 0;
function $92c4ef58fd5719d9$var$setupBankExtension(base) {
    return {
        bank: {
            balances: async (address)=>{
                const path = `/bank/balances/${address}`;
                return base.get(path);
            }
        }
    };
}
$92c4ef58fd5719d9$exports.setupBankExtension = $92c4ef58fd5719d9$var$setupBankExtension;


Object.defineProperty($25c7156131030f5c$exports, "setupBankExtension", {
    enumerable: true,
    get: function() {
        return $92c4ef58fd5719d9$exports.setupBankExtension;
    }
});
var $f04534ccae03b7ce$exports = {};
"use strict";
Object.defineProperty($f04534ccae03b7ce$exports, "__esModule", {
    value: true
});
$f04534ccae03b7ce$exports.setupDistributionExtension = void 0;
function $f04534ccae03b7ce$var$setupDistributionExtension(base) {
    return {
        distribution: {
            delegatorRewards: async (delegatorAddress)=>base.get(`/distribution/delegators/${delegatorAddress}/rewards`),
            delegatorReward: async (delegatorAddress, validatorAddress)=>base.get(`/distribution/delegators/${delegatorAddress}/rewards/${validatorAddress}`),
            withdrawAddress: async (delegatorAddress)=>base.get(`/distribution/delegators/${delegatorAddress}/withdraw_address`),
            validator: async (validatorAddress)=>base.get(`/distribution/validators/${validatorAddress}`),
            validatorRewards: async (validatorAddress)=>base.get(`/distribution/validators/${validatorAddress}/rewards`),
            validatorOutstandingRewards: async (validatorAddress)=>base.get(`/distribution/validators/${validatorAddress}/outstanding_rewards`),
            parameters: async ()=>base.get(`/distribution/parameters`),
            communityPool: async ()=>base.get(`/distribution/community_pool`)
        }
    };
}
$f04534ccae03b7ce$exports.setupDistributionExtension = $f04534ccae03b7ce$var$setupDistributionExtension;


Object.defineProperty($25c7156131030f5c$exports, "setupDistributionExtension", {
    enumerable: true,
    get: function() {
        return $f04534ccae03b7ce$exports.setupDistributionExtension;
    }
});
var $7cc265ecac3ae1a7$exports = {};
"use strict";
Object.defineProperty($7cc265ecac3ae1a7$exports, "__esModule", {
    value: true
});
$7cc265ecac3ae1a7$exports.setupGovExtension = $7cc265ecac3ae1a7$exports.GovParametersType = void 0;
var $7cc265ecac3ae1a7$var$GovParametersType;
(function(GovParametersType) {
    GovParametersType["Deposit"] = "deposit";
    GovParametersType["Tallying"] = "tallying";
    GovParametersType["Voting"] = "voting";
})($7cc265ecac3ae1a7$var$GovParametersType = $7cc265ecac3ae1a7$exports.GovParametersType || ($7cc265ecac3ae1a7$exports.GovParametersType = {}));
function $7cc265ecac3ae1a7$var$setupGovExtension(base) {
    return {
        gov: {
            parameters: async (parametersType)=>base.get(`/gov/parameters/${parametersType}`),
            proposals: async ()=>base.get("/gov/proposals"),
            proposal: async (proposalId)=>base.get(`/gov/proposals/${proposalId}`),
            proposer: async (proposalId)=>base.get(`/gov/proposals/${proposalId}/proposer`),
            deposits: async (proposalId)=>base.get(`/gov/proposals/${proposalId}/deposits`),
            deposit: async (proposalId, depositorAddress)=>base.get(`/gov/proposals/${proposalId}/deposits/${depositorAddress}`),
            tally: async (proposalId)=>base.get(`/gov/proposals/${proposalId}/tally`),
            votes: async (proposalId)=>base.get(`/gov/proposals/${proposalId}/votes`),
            vote: async (proposalId, voterAddress)=>base.get(`/gov/proposals/${proposalId}/votes/${voterAddress}`)
        }
    };
}
$7cc265ecac3ae1a7$exports.setupGovExtension = $7cc265ecac3ae1a7$var$setupGovExtension;


Object.defineProperty($25c7156131030f5c$exports, "setupGovExtension", {
    enumerable: true,
    get: function() {
        return $7cc265ecac3ae1a7$exports.setupGovExtension;
    }
});
var $20c09ef95d404665$exports = {};
"use strict";
Object.defineProperty($20c09ef95d404665$exports, "__esModule", {
    value: true
});
$20c09ef95d404665$exports.setupMintExtension = void 0;
function $20c09ef95d404665$var$setupMintExtension(base) {
    return {
        mint: {
            parameters: async ()=>base.get(`/minting/parameters`),
            inflation: async ()=>base.get(`/minting/inflation`),
            annualProvisions: async ()=>base.get(`/minting/annual-provisions`)
        }
    };
}
$20c09ef95d404665$exports.setupMintExtension = $20c09ef95d404665$var$setupMintExtension;


Object.defineProperty($25c7156131030f5c$exports, "setupMintExtension", {
    enumerable: true,
    get: function() {
        return $20c09ef95d404665$exports.setupMintExtension;
    }
});
var $13bf2829ba91afb8$exports = {};
"use strict";
Object.defineProperty($13bf2829ba91afb8$exports, "__esModule", {
    value: true
});
$13bf2829ba91afb8$exports.setupSlashingExtension = void 0;
function $13bf2829ba91afb8$var$setupSlashingExtension(base) {
    return {
        slashing: {
            signingInfos: async ()=>{
                return base.get(`/slashing/signing_infos`);
            },
            parameters: async ()=>{
                return base.get(`/slashing/parameters`);
            }
        }
    };
}
$13bf2829ba91afb8$exports.setupSlashingExtension = $13bf2829ba91afb8$var$setupSlashingExtension;


Object.defineProperty($25c7156131030f5c$exports, "setupSlashingExtension", {
    enumerable: true,
    get: function() {
        return $13bf2829ba91afb8$exports.setupSlashingExtension;
    }
});
var $c2fe778c3a21eb32$exports = {};
"use strict";
Object.defineProperty($c2fe778c3a21eb32$exports, "__esModule", {
    value: true
});
$c2fe778c3a21eb32$exports.setupStakingExtension = $c2fe778c3a21eb32$exports.BondStatus = void 0;
/**
 * Numeric bonding status
 *
 * @see https://github.com/cosmos/cosmos-sdk/blob/v0.38.5/types/staking.go#L43-L49
 */ var $c2fe778c3a21eb32$var$BondStatus;
(function(BondStatus) {
    BondStatus[BondStatus["Unbonded"] = 0] = "Unbonded";
    BondStatus[BondStatus["Unbonding"] = 1] = "Unbonding";
    BondStatus[BondStatus["Bonded"] = 2] = "Bonded";
})($c2fe778c3a21eb32$var$BondStatus = $c2fe778c3a21eb32$exports.BondStatus || ($c2fe778c3a21eb32$exports.BondStatus = {}));
function $c2fe778c3a21eb32$var$setupStakingExtension(base) {
    return {
        staking: {
            delegatorDelegations: async (delegatorAddress)=>base.get(`/staking/delegators/${delegatorAddress}/delegations`),
            delegatorUnbondingDelegations: async (delegatorAddress)=>base.get(`/staking/delegators/${delegatorAddress}/unbonding_delegations`),
            delegatorTransactions: async (delegatorAddress)=>base.get(`/staking/delegators/${delegatorAddress}/txs`),
            delegatorValidators: async (delegatorAddress)=>base.get(`/staking/delegators/${delegatorAddress}/validators`),
            delegatorValidator: async (delegatorAddress, validatorAddress)=>base.get(`/staking/delegators/${delegatorAddress}/validators/${validatorAddress}`),
            delegation: async (delegatorAddress, validatorAddress)=>base.get(`/staking/delegators/${delegatorAddress}/delegations/${validatorAddress}`),
            unbondingDelegation: async (delegatorAddress, validatorAddress)=>base.get(`/staking/delegators/${delegatorAddress}/unbonding_delegations/${validatorAddress}`),
            redelegations: async ()=>base.get(`/staking/redelegations`),
            validators: async (params)=>base.get(`/staking/validators`, params),
            validator: async (validatorAddress)=>base.get(`/staking/validators/${validatorAddress}`),
            validatorDelegations: async (validatorAddress)=>base.get(`/staking/validators/${validatorAddress}/delegations`),
            validatorUnbondingDelegations: async (validatorAddress)=>base.get(`/staking/validators/${validatorAddress}/unbonding_delegations`),
            historicalInfo: async (height)=>base.get(`/staking/historical_info/${height}`),
            pool: async ()=>base.get(`/staking/pool`),
            parameters: async ()=>base.get(`/staking/parameters`)
        }
    };
}
$c2fe778c3a21eb32$exports.setupStakingExtension = $c2fe778c3a21eb32$var$setupStakingExtension;


Object.defineProperty($25c7156131030f5c$exports, "setupStakingExtension", {
    enumerable: true,
    get: function() {
        return $c2fe778c3a21eb32$exports.setupStakingExtension;
    }
});
var $37baea22bbb728c9$exports = {};
"use strict";
Object.defineProperty($37baea22bbb728c9$exports, "__esModule", {
    value: true
});
$37baea22bbb728c9$exports.setupSupplyExtension = void 0;
function $37baea22bbb728c9$var$setupSupplyExtension(base) {
    return {
        supply: {
            totalAll: async ()=>{
                return base.get(`/supply/total`);
            },
            total: async (denom)=>{
                return base.get(`/supply/total/${denom}`);
            }
        }
    };
}
$37baea22bbb728c9$exports.setupSupplyExtension = $37baea22bbb728c9$var$setupSupplyExtension;


Object.defineProperty($25c7156131030f5c$exports, "setupSupplyExtension", {
    enumerable: true,
    get: function() {
        return $37baea22bbb728c9$exports.setupSupplyExtension;
    }
});
var $b37c18831b02f9c3$exports = {};
"use strict";
Object.defineProperty($b37c18831b02f9c3$exports, "__esModule", {
    value: true
});
$b37c18831b02f9c3$exports.BroadcastMode = void 0;
/**
 * The mode used to send transaction
 *
 * @see https://cosmos.network/rpc/#/Transactions/post_txs
 */ var $b37c18831b02f9c3$var$BroadcastMode;
(function(BroadcastMode) {
    /** Return after tx commit */ BroadcastMode["Block"] = "block";
    /** Return after CheckTx */ BroadcastMode["Sync"] = "sync";
    /** Return right away */ BroadcastMode["Async"] = "async";
})($b37c18831b02f9c3$var$BroadcastMode = $b37c18831b02f9c3$exports.BroadcastMode || ($b37c18831b02f9c3$exports.BroadcastMode = {}));


Object.defineProperty($25c7156131030f5c$exports, "BroadcastMode", {
    enumerable: true,
    get: function() {
        return $b37c18831b02f9c3$exports.BroadcastMode;
    }
});
var $8164d070c0d16efc$exports = {};
"use strict";
var $8164d070c0d16efc$var$__importDefault = $8164d070c0d16efc$exports && $8164d070c0d16efc$exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty($8164d070c0d16efc$exports, "__esModule", {
    value: true
});
$8164d070c0d16efc$exports.LcdClient = $8164d070c0d16efc$exports.normalizeLcdApiArray = void 0;

var $dOLgD = parcelRequire("dOLgD");

const $8164d070c0d16efc$var$axios_1 = $8164d070c0d16efc$var$__importDefault((parcelRequire("2shzp")));

function $8164d070c0d16efc$var$normalizeLcdApiArray(backend) {
    return backend || [];
}
$8164d070c0d16efc$exports.normalizeLcdApiArray = $8164d070c0d16efc$var$normalizeLcdApiArray;
// We want to get message data from 500 errors
// https://stackoverflow.com/questions/56577124/how-to-handle-500-error-message-with-axios
// this should be chained to catch one error and throw a more informative one
function $8164d070c0d16efc$var$parseAxiosError(err) {
    var _a;
    // use the error message sent from server, not default 500 msg
    if ((_a = err.response) === null || _a === void 0 ? void 0 : _a.data) {
        let errorText;
        const data = err.response.data;
        // expect { error: string }, but otherwise dump
        if (data.error && typeof data.error === "string") errorText = data.error;
        else if (typeof data === "string") errorText = data;
        else errorText = JSON.stringify(data);
        throw new Error(`${errorText} (HTTP ${err.response.status})`);
    } else throw err;
}
/**
 * A client to the LCD's (light client daemon) API.
 * This light client connects to Tendermint (i.e. the chain), encodes/decodes Amino data for us and provides a convenient JSON interface.
 *
 * This _JSON over HTTP_ API is sometimes referred to as "REST" or "RPC", which are both misleading terms
 * for the same thing.
 *
 * Please note that the client to the LCD can not verify light client proofs. When using this,
 * you need to trust the API provider as well as the network connection between client and API.
 *
 * @see https://cosmos.network/rpc
 */ class $8164d070c0d16efc$var$LcdClient {
    /**
     * Creates a new client to interact with a Cosmos SDK light client daemon.
     * This class tries to be a direct mapping onto the API. Some basic decoding and normalizatin is done
     * but things like caching are done at a higher level.
     *
     * When building apps, you should not need to use this class directly. If you do, this indicates a missing feature
     * in higher level components. Feel free to raise an issue in this case.
     *
     * @param apiUrl The URL of a Cosmos SDK light client daemon API (sometimes called REST server or REST API)
     * @param broadcastMode Defines at which point of the transaction processing the broadcastTx method returns
     */ constructor(apiUrl, broadcastMode = $b37c18831b02f9c3$exports.BroadcastMode.Block){
        const headers = {
            post: {
                "Content-Type": "application/json"
            }
        };
        this.client = $8164d070c0d16efc$var$axios_1.default.create({
            baseURL: apiUrl,
            headers: headers
        });
        this.broadcastMode = broadcastMode;
    }
    static withExtensions(options, ...extensionSetups) {
        const client = new $8164d070c0d16efc$var$LcdClient(options.apiUrl, options.broadcastMode);
        const extensions = extensionSetups.map((setupExtension)=>setupExtension(client));
        for (const extension of extensions){
            (0, $dOLgD.assert)((0, $dOLgD.isNonNullObject)(extension), `Extension must be a non-null object`);
            for (const [moduleKey, moduleValue] of Object.entries(extension)){
                (0, $dOLgD.assert)((0, $dOLgD.isNonNullObject)(moduleValue), `Module must be a non-null object. Found type ${typeof moduleValue} for module "${moduleKey}".`);
                const current = client[moduleKey] || {};
                client[moduleKey] = Object.assign(Object.assign({}, current), moduleValue);
            }
        }
        return client;
    }
    async get(path, params) {
        const { data: data } = await this.client.get(path, {
            params: params
        }).catch($8164d070c0d16efc$var$parseAxiosError);
        if (data === null) throw new Error("Received null response from server");
        return data;
    }
    // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
    async post(path, params) {
        if (!(0, $dOLgD.isNonNullObject)(params)) throw new Error("Got unexpected type of params. Expected object.");
        const { data: data } = await this.client.post(path, params).catch($8164d070c0d16efc$var$parseAxiosError);
        if (data === null) throw new Error("Received null response from server");
        return data;
    }
    // The /blocks endpoints
    async blocksLatest() {
        const responseData = await this.get("/blocks/latest");
        if (!responseData.block) throw new Error("Unexpected response data format");
        return responseData;
    }
    async blocks(height) {
        const responseData = await this.get(`/blocks/${height}`);
        if (!responseData.block) throw new Error("Unexpected response data format");
        return responseData;
    }
    // The /node_info endpoint
    async nodeInfo() {
        const responseData = await this.get("/node_info");
        if (!responseData.node_info) throw new Error("Unexpected response data format");
        return responseData;
    }
    // The /txs endpoints
    async txById(id) {
        const responseData = await this.get(`/txs/${id}`);
        if (!responseData.tx) throw new Error("Unexpected response data format");
        return responseData;
    }
    async txsQuery(query) {
        const responseData = await this.get(`/txs?${query}`);
        if (!responseData.txs) throw new Error("Unexpected response data format");
        return responseData;
    }
    /** returns the amino-encoding of the transaction performed by the server */ async encodeTx(tx) {
        const responseData = await this.post("/txs/encode", tx);
        if (!responseData.tx) throw new Error("Unexpected response data format");
        return responseData;
    }
    /**
     * Broadcasts a signed transaction to the transaction pool.
     * Depending on the client's broadcast mode, this might or might
     * wait for checkTx or deliverTx to be executed before returning.
     *
     * @param tx a signed transaction as StdTx (i.e. not wrapped in type/value container)
     */ async broadcastTx(tx) {
        const params = {
            tx: tx,
            mode: this.broadcastMode
        };
        const responseData = await this.post("/txs", params);
        if (!responseData.txhash) throw new Error("Unexpected response data format");
        return responseData;
    }
}
$8164d070c0d16efc$exports.LcdClient = $8164d070c0d16efc$var$LcdClient;


Object.defineProperty($25c7156131030f5c$exports, "LcdClient", {
    enumerable: true,
    get: function() {
        return $8164d070c0d16efc$exports.LcdClient;
    }
});
Object.defineProperty($25c7156131030f5c$exports, "normalizeLcdApiArray", {
    enumerable: true,
    get: function() {
        return $8164d070c0d16efc$exports.normalizeLcdApiArray;
    }
});
var $9b519dcbc059533b$exports = {};
"use strict";
Object.defineProperty($9b519dcbc059533b$exports, "__esModule", {
    value: true
});
$9b519dcbc059533b$exports.normalizePubkey = $9b519dcbc059533b$exports.uint64ToString = $9b519dcbc059533b$exports.uint64ToNumber = void 0;


/**
 * Converts an integer expressed as number or string to a number.
 * Throws if input is not a valid uint64 or if the value exceeds MAX_SAFE_INTEGER.
 *
 * This is needed for supporting Comsos SDK 0.37/0.38/0.39 with one client.
 */ function $9b519dcbc059533b$var$uint64ToNumber(input) {
    const value = typeof input === "number" ? $1d6e3095a7e37622$exports.Uint64.fromNumber(input) : $1d6e3095a7e37622$exports.Uint64.fromString(input);
    return value.toNumber();
}
$9b519dcbc059533b$exports.uint64ToNumber = $9b519dcbc059533b$var$uint64ToNumber;
/**
 * Converts an integer expressed as number or string to a string.
 * Throws if input is not a valid uint64.
 *
 * This is needed for supporting Comsos SDK 0.37/0.38/0.39 with one client.
 */ function $9b519dcbc059533b$var$uint64ToString(input) {
    const value = typeof input === "number" ? $1d6e3095a7e37622$exports.Uint64.fromNumber(input) : $1d6e3095a7e37622$exports.Uint64.fromString(input);
    return value.toString();
}
$9b519dcbc059533b$exports.uint64ToString = $9b519dcbc059533b$var$uint64ToString;
/**
 * Normalizes a pubkey as in `BaseAccount.public_key` to allow supporting
 * Comsos SDK 0.37–0.39.
 *
 * Returns null when unset.
 */ function $9b519dcbc059533b$var$normalizePubkey(input) {
    if (!input) return null;
    if (typeof input === "string") return (0, $a11446128a9e19fc$exports.decodeBech32Pubkey)(input);
    return input;
}
$9b519dcbc059533b$exports.normalizePubkey = $9b519dcbc059533b$var$normalizePubkey;


Object.defineProperty($25c7156131030f5c$exports, "normalizePubkey", {
    enumerable: true,
    get: function() {
        return $9b519dcbc059533b$exports.normalizePubkey;
    }
});
Object.defineProperty($25c7156131030f5c$exports, "uint64ToNumber", {
    enumerable: true,
    get: function() {
        return $9b519dcbc059533b$exports.uint64ToNumber;
    }
});
Object.defineProperty($25c7156131030f5c$exports, "uint64ToString", {
    enumerable: true,
    get: function() {
        return $9b519dcbc059533b$exports.uint64ToString;
    }
});



var $fnnh9 = parcelRequire("fnnh9");
function $39b326257dacbed3$var$isBroadcastTxFailure(result) {
    return !!result.code;
}
$39b326257dacbed3$exports.isBroadcastTxFailure = $39b326257dacbed3$var$isBroadcastTxFailure;
function $39b326257dacbed3$var$isBroadcastTxSuccess(result) {
    return !$39b326257dacbed3$var$isBroadcastTxFailure(result);
}
$39b326257dacbed3$exports.isBroadcastTxSuccess = $39b326257dacbed3$var$isBroadcastTxSuccess;
/**
 * Ensures the given result is a success. Throws a detailed error message otherwise.
 */ function $39b326257dacbed3$var$assertIsBroadcastTxSuccess(result) {
    if ($39b326257dacbed3$var$isBroadcastTxFailure(result)) throw new Error(`Error when broadcasting tx ${result.transactionHash} at height ${result.height}. Code: ${result.code}; Raw log: ${result.rawLog}`);
}
$39b326257dacbed3$exports.assertIsBroadcastTxSuccess = $39b326257dacbed3$var$assertIsBroadcastTxSuccess;
function $39b326257dacbed3$var$isSearchByHeightQuery(query) {
    return query.height !== undefined;
}
$39b326257dacbed3$exports.isSearchByHeightQuery = $39b326257dacbed3$var$isSearchByHeightQuery;
function $39b326257dacbed3$var$isSearchBySentFromOrToQuery(query) {
    return query.sentFromOrTo !== undefined;
}
$39b326257dacbed3$exports.isSearchBySentFromOrToQuery = $39b326257dacbed3$var$isSearchBySentFromOrToQuery;
function $39b326257dacbed3$var$isSearchByTagsQuery(query) {
    return query.tags !== undefined;
}
$39b326257dacbed3$exports.isSearchByTagsQuery = $39b326257dacbed3$var$isSearchByTagsQuery;
class $39b326257dacbed3$var$CosmosClient {
    /**
     * Creates a new client to interact with a CosmWasm blockchain.
     *
     * This instance does a lot of caching. In order to benefit from that you should try to use one instance
     * for the lifetime of your application. When switching backends, a new instance must be created.
     *
     * @param apiUrl The URL of a Cosmos SDK light client daemon API (sometimes called REST server or REST API)
     * @param broadcastMode Defines at which point of the transaction processing the broadcastTx method returns
     */ constructor(apiUrl, broadcastMode = $25c7156131030f5c$exports.BroadcastMode.Block){
        this.lcdClient = $25c7156131030f5c$exports.LcdClient.withExtensions({
            apiUrl: apiUrl,
            broadcastMode: broadcastMode
        }, $25c7156131030f5c$exports.setupAuthExtension);
    }
    async getChainId() {
        if (!this.chainId) {
            const response = await this.lcdClient.nodeInfo();
            const chainId = response.node_info.network;
            if (!chainId) throw new Error("Chain ID must not be empty");
            this.chainId = chainId;
        }
        return this.chainId;
    }
    async getHeight() {
        if (this.anyValidAddress) {
            const { height: height } = await this.lcdClient.auth.account(this.anyValidAddress);
            return parseInt(height, 10);
        } else {
            // Note: this gets inefficient when blocks contain a lot of transactions since it
            // requires downloading and deserializing all transactions in the block.
            const latest = await this.lcdClient.blocksLatest();
            return parseInt(latest.block.header.height, 10);
        }
    }
    /**
     * Returns a 32 byte upper-case hex transaction hash (typically used as the transaction ID)
     */ async getIdentifier(tx) {
        // We consult the REST API because we don't have a local amino encoder
        const response = await this.lcdClient.encodeTx(tx);
        const hash = (0, $ca4c58922ce7f03a$exports.sha256)((0, $3977281a39984aec$exports.fromBase64)(response.tx));
        return (0, $3977281a39984aec$exports.toHex)(hash).toUpperCase();
    }
    /**
     * Returns account number and sequence.
     *
     * Throws if the account does not exist on chain.
     *
     * @param address returns data for this address. When unset, the client's sender adddress is used.
     */ async getSequence(address) {
        const account = await this.getAccount(address);
        if (!account) throw new Error("Account does not exist on chain. Send some tokens there before trying to query sequence.");
        return {
            accountNumber: account.accountNumber,
            sequence: account.sequence
        };
    }
    async getAccount(address) {
        const account = await this.lcdClient.auth.account(address);
        const value = account.result.value;
        if (value.address === "") return undefined;
        else {
            this.anyValidAddress = value.address;
            return {
                address: value.address,
                balance: value.coins,
                pubkey: (0, $25c7156131030f5c$exports.normalizePubkey)(value.public_key) || undefined,
                accountNumber: (0, $25c7156131030f5c$exports.uint64ToNumber)(value.account_number),
                sequence: (0, $25c7156131030f5c$exports.uint64ToNumber)(value.sequence)
            };
        }
    }
    /**
     * Gets block header and meta
     *
     * @param height The height of the block. If undefined, the latest height is used.
     */ async getBlock(height) {
        const response = height !== undefined ? await this.lcdClient.blocks(height) : await this.lcdClient.blocksLatest();
        return {
            id: response.block_id.hash,
            header: {
                version: response.block.header.version,
                time: response.block.header.time,
                height: parseInt(response.block.header.height, 10),
                chainId: response.block.header.chain_id
            },
            txs: (response.block.data.txs || []).map($3977281a39984aec$exports.fromBase64)
        };
    }
    async getTx(id) {
        var _a;
        const results = await this.txsQuery(`tx.hash=${id}`);
        return (_a = results[0]) !== null && _a !== void 0 ? _a : null;
    }
    async searchTx(query, filter = {}) {
        const minHeight = filter.minHeight || 0;
        const maxHeight = filter.maxHeight || Number.MAX_SAFE_INTEGER;
        if (maxHeight < minHeight) return []; // optional optimization
        function withFilters(originalQuery) {
            return `${originalQuery}&tx.minheight=${minHeight}&tx.maxheight=${maxHeight}`;
        }
        let txs;
        if ($39b326257dacbed3$var$isSearchByHeightQuery(query)) {
            // optional optimization to avoid network request
            if (query.height < minHeight || query.height > maxHeight) txs = [];
            else txs = await this.txsQuery(`tx.height=${query.height}`);
        } else if ($39b326257dacbed3$var$isSearchBySentFromOrToQuery(query)) {
            // We cannot get both in one request (see https://github.com/cosmos/gaia/issues/75)
            const sentQuery = withFilters(`message.module=bank&message.sender=${query.sentFromOrTo}`);
            const receivedQuery = withFilters(`message.module=bank&transfer.recipient=${query.sentFromOrTo}`);
            const sent = await this.txsQuery(sentQuery);
            const received = await this.txsQuery(receivedQuery);
            const sentHashes = sent.map((t)=>t.hash);
            txs = [
                ...sent,
                ...received.filter((t)=>!sentHashes.includes(t.hash))
            ];
        } else if ($39b326257dacbed3$var$isSearchByTagsQuery(query)) {
            const rawQuery = withFilters(query.tags.map((t)=>`${t.key}=${t.value}`).join("&"));
            txs = await this.txsQuery(rawQuery);
        } else throw new Error("Unknown query type");
        // backend sometimes messes up with min/max height filtering
        const filtered = txs.filter((tx)=>tx.height >= minHeight && tx.height <= maxHeight);
        return filtered;
    }
    async broadcastTx(tx) {
        const result = await this.lcdClient.broadcastTx(tx);
        if (!result.txhash.match(/^([0-9A-F][0-9A-F])+$/)) throw new Error("Received ill-formatted txhash. Must be non-empty upper-case hex");
        return result.code !== undefined ? {
            height: $1d6e3095a7e37622$exports.Uint53.fromString(result.height).toNumber(),
            transactionHash: result.txhash,
            code: result.code,
            rawLog: result.raw_log || ""
        } : {
            logs: result.logs ? (0, $fnnh9.parseLogs)(result.logs) : [],
            rawLog: result.raw_log || "",
            transactionHash: result.txhash,
            data: result.data ? (0, $3977281a39984aec$exports.fromHex)(result.data) : undefined
        };
    }
    async txsQuery(query) {
        // TODO: we need proper pagination support
        const limit = 100;
        const result = await this.lcdClient.txsQuery(`${query}&limit=${limit}`);
        const pages = parseInt(result.page_total, 10);
        if (pages > 1) throw new Error(`Found more results on the backend than we can process currently. Results: ${result.total_count}, supported: ${limit}`);
        return result.txs.map((restItem)=>({
                height: parseInt(restItem.height, 10),
                hash: restItem.txhash,
                code: restItem.code || 0,
                rawLog: restItem.raw_log,
                logs: (0, $fnnh9.parseLogs)(restItem.logs || []),
                tx: restItem.tx,
                timestamp: restItem.timestamp
            }));
    }
}
$39b326257dacbed3$exports.CosmosClient = $39b326257dacbed3$var$CosmosClient;


Object.defineProperty($b8ae3714266935c3$exports, "assertIsBroadcastTxSuccess", {
    enumerable: true,
    get: function() {
        return $39b326257dacbed3$exports.assertIsBroadcastTxSuccess;
    }
});
Object.defineProperty($b8ae3714266935c3$exports, "CosmosClient", {
    enumerable: true,
    get: function() {
        return $39b326257dacbed3$exports.CosmosClient;
    }
});
Object.defineProperty($b8ae3714266935c3$exports, "isBroadcastTxFailure", {
    enumerable: true,
    get: function() {
        return $39b326257dacbed3$exports.isBroadcastTxFailure;
    }
});
Object.defineProperty($b8ae3714266935c3$exports, "isBroadcastTxSuccess", {
    enumerable: true,
    get: function() {
        return $39b326257dacbed3$exports.isBroadcastTxSuccess;
    }
});
Object.defineProperty($b8ae3714266935c3$exports, "isSearchByHeightQuery", {
    enumerable: true,
    get: function() {
        return $39b326257dacbed3$exports.isSearchByHeightQuery;
    }
});
Object.defineProperty($b8ae3714266935c3$exports, "isSearchBySentFromOrToQuery", {
    enumerable: true,
    get: function() {
        return $39b326257dacbed3$exports.isSearchBySentFromOrToQuery;
    }
});
Object.defineProperty($b8ae3714266935c3$exports, "isSearchByTagsQuery", {
    enumerable: true,
    get: function() {
        return $39b326257dacbed3$exports.isSearchByTagsQuery;
    }
});
var $418df4b97bd2b3eb$exports = {};
"use strict";
Object.defineProperty($418df4b97bd2b3eb$exports, "__esModule", {
    value: true
});
$418df4b97bd2b3eb$exports.buildFeeTable = $418df4b97bd2b3eb$exports.GasPrice = void 0;


/**
 * Denom checker for the Cosmos SDK 0.39 denom pattern
 * (https://github.com/cosmos/cosmos-sdk/blob/v0.39.3/types/coin.go#L597-L598).
 *
 * This is like a regexp but with helpful error messages.
 */ function $418df4b97bd2b3eb$var$checkDenom(denom) {
    if (denom.length < 3 || denom.length > 16) throw new Error("Denom must be between 3 and 16 characters");
    if (denom.match(/[^a-z0-9]/)) throw new Error("Denom must only contain lower case letters a-z and digits 0-9");
}
/**
 * A gas price, i.e. the price of a single unit of gas. This is typically a fraction of
 * the smallest fee token unit, such as 0.012utoken.
 */ class $418df4b97bd2b3eb$var$GasPrice {
    constructor(amount, denom){
        this.amount = amount;
        this.denom = denom;
    }
    /**
     * Parses a gas price formatted as `<amount><denom>`, e.g. `GasPrice.fromString("0.012utoken")`.
     *
     * The denom must match the Cosmos SDK 0.39 pattern (https://github.com/cosmos/cosmos-sdk/blob/v0.39.3/types/coin.go#L597-L598).
     * See `GasPrice` in @cosmjs/stargate for a more generic matcher.
     */ static fromString(gasPrice) {
        // Use Decimal.fromUserInput and checkDenom for detailed checks and helpful error messages
        const matchResult = gasPrice.match(/^([0-9.]+)([a-z][a-z0-9]*)$/i);
        if (!matchResult) throw new Error("Invalid gas price string");
        const [_, amount, denom] = matchResult;
        $418df4b97bd2b3eb$var$checkDenom(denom);
        const fractionalDigits = 18;
        const decimalAmount = $1d6e3095a7e37622$exports.Decimal.fromUserInput(amount, fractionalDigits);
        return new $418df4b97bd2b3eb$var$GasPrice(decimalAmount, denom);
    }
}
$418df4b97bd2b3eb$exports.GasPrice = $418df4b97bd2b3eb$var$GasPrice;
function $418df4b97bd2b3eb$var$calculateFee(gasLimit, { denom: denom, amount: gasPriceAmount }) {
    const amount = Math.ceil(gasPriceAmount.multiply(new $1d6e3095a7e37622$exports.Uint53(gasLimit)).toFloatApproximation());
    return {
        amount: (0, $a11446128a9e19fc$exports.coins)(amount, denom),
        gas: gasLimit.toString()
    };
}
function $418df4b97bd2b3eb$var$buildFeeTable(gasPrice, defaultGasLimits, gasLimits) {
    return Object.entries(defaultGasLimits).reduce((feeTable, [type, defaultGasLimit])=>Object.assign(Object.assign({}, feeTable), {
            [type]: $418df4b97bd2b3eb$var$calculateFee(gasLimits[type] || defaultGasLimit, gasPrice)
        }), {});
}
$418df4b97bd2b3eb$exports.buildFeeTable = $418df4b97bd2b3eb$var$buildFeeTable;


Object.defineProperty($b8ae3714266935c3$exports, "buildFeeTable", {
    enumerable: true,
    get: function() {
        return $418df4b97bd2b3eb$exports.buildFeeTable;
    }
});
Object.defineProperty($b8ae3714266935c3$exports, "GasPrice", {
    enumerable: true,
    get: function() {
        return $418df4b97bd2b3eb$exports.GasPrice;
    }
});

Object.defineProperty($b8ae3714266935c3$exports, "BroadcastMode", {
    enumerable: true,
    get: function() {
        return $25c7156131030f5c$exports.BroadcastMode;
    }
});
Object.defineProperty($b8ae3714266935c3$exports, "LcdClient", {
    enumerable: true,
    get: function() {
        return $25c7156131030f5c$exports.LcdClient;
    }
});
Object.defineProperty($b8ae3714266935c3$exports, "normalizeLcdApiArray", {
    enumerable: true,
    get: function() {
        return $25c7156131030f5c$exports.normalizeLcdApiArray;
    }
});
Object.defineProperty($b8ae3714266935c3$exports, "normalizePubkey", {
    enumerable: true,
    get: function() {
        return $25c7156131030f5c$exports.normalizePubkey;
    }
});
Object.defineProperty($b8ae3714266935c3$exports, "setupAuthExtension", {
    enumerable: true,
    get: function() {
        return $25c7156131030f5c$exports.setupAuthExtension;
    }
});
Object.defineProperty($b8ae3714266935c3$exports, "setupBankExtension", {
    enumerable: true,
    get: function() {
        return $25c7156131030f5c$exports.setupBankExtension;
    }
});
Object.defineProperty($b8ae3714266935c3$exports, "setupDistributionExtension", {
    enumerable: true,
    get: function() {
        return $25c7156131030f5c$exports.setupDistributionExtension;
    }
});
Object.defineProperty($b8ae3714266935c3$exports, "setupGovExtension", {
    enumerable: true,
    get: function() {
        return $25c7156131030f5c$exports.setupGovExtension;
    }
});
Object.defineProperty($b8ae3714266935c3$exports, "setupMintExtension", {
    enumerable: true,
    get: function() {
        return $25c7156131030f5c$exports.setupMintExtension;
    }
});
Object.defineProperty($b8ae3714266935c3$exports, "setupSlashingExtension", {
    enumerable: true,
    get: function() {
        return $25c7156131030f5c$exports.setupSlashingExtension;
    }
});
Object.defineProperty($b8ae3714266935c3$exports, "setupStakingExtension", {
    enumerable: true,
    get: function() {
        return $25c7156131030f5c$exports.setupStakingExtension;
    }
});
Object.defineProperty($b8ae3714266935c3$exports, "setupSupplyExtension", {
    enumerable: true,
    get: function() {
        return $25c7156131030f5c$exports.setupSupplyExtension;
    }
});
Object.defineProperty($b8ae3714266935c3$exports, "uint64ToNumber", {
    enumerable: true,
    get: function() {
        return $25c7156131030f5c$exports.uint64ToNumber;
    }
});
Object.defineProperty($b8ae3714266935c3$exports, "uint64ToString", {
    enumerable: true,
    get: function() {
        return $25c7156131030f5c$exports.uint64ToString;
    }
});
var $37e8a33ea841e05f$exports = {};
"use strict";
Object.defineProperty($37e8a33ea841e05f$exports, "__esModule", {
    value: true
});
$37e8a33ea841e05f$exports.isMsgUndelegate = $37e8a33ea841e05f$exports.isMsgBeginRedelegate = $37e8a33ea841e05f$exports.isMsgDelegate = $37e8a33ea841e05f$exports.isMsgEditValidator = $37e8a33ea841e05f$exports.isMsgCreateValidator = $37e8a33ea841e05f$exports.isMsgUnjail = $37e8a33ea841e05f$exports.isMsgDeposit = $37e8a33ea841e05f$exports.isMsgVote = $37e8a33ea841e05f$exports.isMsgSubmitProposal = $37e8a33ea841e05f$exports.isMsgSubmitEvidence = $37e8a33ea841e05f$exports.isMsgFundCommunityPool = $37e8a33ea841e05f$exports.isMsgWithdrawValidatorCommission = $37e8a33ea841e05f$exports.isMsgWithdrawDelegatorReward = $37e8a33ea841e05f$exports.isMsgSetWithdrawAddress = $37e8a33ea841e05f$exports.isMsgVerifyInvariant = $37e8a33ea841e05f$exports.isMsgMultiSend = $37e8a33ea841e05f$exports.isMsgSend = void 0;
function $37e8a33ea841e05f$var$isMsgSend(msg) {
    return msg.type === "cosmos-sdk/MsgSend";
}
$37e8a33ea841e05f$exports.isMsgSend = $37e8a33ea841e05f$var$isMsgSend;
function $37e8a33ea841e05f$var$isMsgMultiSend(msg) {
    return msg.type === "cosmos-sdk/MsgMultiSend";
}
$37e8a33ea841e05f$exports.isMsgMultiSend = $37e8a33ea841e05f$var$isMsgMultiSend;
function $37e8a33ea841e05f$var$isMsgVerifyInvariant(msg) {
    return msg.type === "cosmos-sdk/MsgVerifyInvariant";
}
$37e8a33ea841e05f$exports.isMsgVerifyInvariant = $37e8a33ea841e05f$var$isMsgVerifyInvariant;
function $37e8a33ea841e05f$var$isMsgSetWithdrawAddress(msg) {
    // NOTE: Type string and names diverge here!
    return msg.type === "cosmos-sdk/MsgModifyWithdrawAddress";
}
$37e8a33ea841e05f$exports.isMsgSetWithdrawAddress = $37e8a33ea841e05f$var$isMsgSetWithdrawAddress;
function $37e8a33ea841e05f$var$isMsgWithdrawDelegatorReward(msg) {
    // NOTE: Type string and names diverge here!
    return msg.type === "cosmos-sdk/MsgWithdrawDelegationReward";
}
$37e8a33ea841e05f$exports.isMsgWithdrawDelegatorReward = $37e8a33ea841e05f$var$isMsgWithdrawDelegatorReward;
function $37e8a33ea841e05f$var$isMsgWithdrawValidatorCommission(msg) {
    return msg.type === "cosmos-sdk/MsgWithdrawValidatorCommission";
}
$37e8a33ea841e05f$exports.isMsgWithdrawValidatorCommission = $37e8a33ea841e05f$var$isMsgWithdrawValidatorCommission;
function $37e8a33ea841e05f$var$isMsgFundCommunityPool(msg) {
    return msg.type === "cosmos-sdk/MsgFundCommunityPool";
}
$37e8a33ea841e05f$exports.isMsgFundCommunityPool = $37e8a33ea841e05f$var$isMsgFundCommunityPool;
function $37e8a33ea841e05f$var$isMsgSubmitEvidence(msg) {
    return msg.type === "cosmos-sdk/MsgSubmitEvidence";
}
$37e8a33ea841e05f$exports.isMsgSubmitEvidence = $37e8a33ea841e05f$var$isMsgSubmitEvidence;
function $37e8a33ea841e05f$var$isMsgSubmitProposal(msg) {
    return msg.type === "cosmos-sdk/MsgSubmitProposal";
}
$37e8a33ea841e05f$exports.isMsgSubmitProposal = $37e8a33ea841e05f$var$isMsgSubmitProposal;
var $37e8a33ea841e05f$var$VoteOption;
(function(VoteOption) {
    VoteOption[VoteOption["VoteOptionUnspecified"] = 0] = "VoteOptionUnspecified";
    VoteOption[VoteOption["VoteOptionYes"] = 1] = "VoteOptionYes";
    VoteOption[VoteOption["VoteOptionAbstain"] = 2] = "VoteOptionAbstain";
    VoteOption[VoteOption["VoteOptionNo"] = 3] = "VoteOptionNo";
    VoteOption[VoteOption["VoteOptionNoWithVeto"] = 4] = "VoteOptionNoWithVeto";
})($37e8a33ea841e05f$var$VoteOption || ($37e8a33ea841e05f$var$VoteOption = {}));
function $37e8a33ea841e05f$var$isMsgVote(msg) {
    return msg.type === "cosmos-sdk/MsgVote";
}
$37e8a33ea841e05f$exports.isMsgVote = $37e8a33ea841e05f$var$isMsgVote;
function $37e8a33ea841e05f$var$isMsgDeposit(msg) {
    return msg.type === "cosmos-sdk/MsgDeposit";
}
$37e8a33ea841e05f$exports.isMsgDeposit = $37e8a33ea841e05f$var$isMsgDeposit;
function $37e8a33ea841e05f$var$isMsgUnjail(msg) {
    return msg.type === "cosmos-sdk/MsgUnjail";
}
$37e8a33ea841e05f$exports.isMsgUnjail = $37e8a33ea841e05f$var$isMsgUnjail;
function $37e8a33ea841e05f$var$isMsgCreateValidator(msg) {
    return msg.type === "cosmos-sdk/MsgCreateValidator";
}
$37e8a33ea841e05f$exports.isMsgCreateValidator = $37e8a33ea841e05f$var$isMsgCreateValidator;
function $37e8a33ea841e05f$var$isMsgEditValidator(msg) {
    return msg.type === "cosmos-sdk/MsgEditValidator";
}
$37e8a33ea841e05f$exports.isMsgEditValidator = $37e8a33ea841e05f$var$isMsgEditValidator;
function $37e8a33ea841e05f$var$isMsgDelegate(msg) {
    return msg.type === "cosmos-sdk/MsgDelegate";
}
$37e8a33ea841e05f$exports.isMsgDelegate = $37e8a33ea841e05f$var$isMsgDelegate;
function $37e8a33ea841e05f$var$isMsgBeginRedelegate(msg) {
    return msg.type === "cosmos-sdk/MsgBeginRedelegate";
}
$37e8a33ea841e05f$exports.isMsgBeginRedelegate = $37e8a33ea841e05f$var$isMsgBeginRedelegate;
function $37e8a33ea841e05f$var$isMsgUndelegate(msg) {
    return msg.type === "cosmos-sdk/MsgUndelegate";
}
$37e8a33ea841e05f$exports.isMsgUndelegate = $37e8a33ea841e05f$var$isMsgUndelegate; // upgrade (no messages) - see https://github.com/cosmos/cosmos-sdk/blob/efa73c7/proto/cosmos/upgrade/upgrade.proto


Object.defineProperty($b8ae3714266935c3$exports, "isMsgBeginRedelegate", {
    enumerable: true,
    get: function() {
        return $37e8a33ea841e05f$exports.isMsgBeginRedelegate;
    }
});
Object.defineProperty($b8ae3714266935c3$exports, "isMsgCreateValidator", {
    enumerable: true,
    get: function() {
        return $37e8a33ea841e05f$exports.isMsgCreateValidator;
    }
});
Object.defineProperty($b8ae3714266935c3$exports, "isMsgDelegate", {
    enumerable: true,
    get: function() {
        return $37e8a33ea841e05f$exports.isMsgDelegate;
    }
});
Object.defineProperty($b8ae3714266935c3$exports, "isMsgEditValidator", {
    enumerable: true,
    get: function() {
        return $37e8a33ea841e05f$exports.isMsgEditValidator;
    }
});
Object.defineProperty($b8ae3714266935c3$exports, "isMsgFundCommunityPool", {
    enumerable: true,
    get: function() {
        return $37e8a33ea841e05f$exports.isMsgFundCommunityPool;
    }
});
Object.defineProperty($b8ae3714266935c3$exports, "isMsgMultiSend", {
    enumerable: true,
    get: function() {
        return $37e8a33ea841e05f$exports.isMsgMultiSend;
    }
});
Object.defineProperty($b8ae3714266935c3$exports, "isMsgSend", {
    enumerable: true,
    get: function() {
        return $37e8a33ea841e05f$exports.isMsgSend;
    }
});
Object.defineProperty($b8ae3714266935c3$exports, "isMsgSetWithdrawAddress", {
    enumerable: true,
    get: function() {
        return $37e8a33ea841e05f$exports.isMsgSetWithdrawAddress;
    }
});
Object.defineProperty($b8ae3714266935c3$exports, "isMsgUndelegate", {
    enumerable: true,
    get: function() {
        return $37e8a33ea841e05f$exports.isMsgUndelegate;
    }
});
Object.defineProperty($b8ae3714266935c3$exports, "isMsgWithdrawDelegatorReward", {
    enumerable: true,
    get: function() {
        return $37e8a33ea841e05f$exports.isMsgWithdrawDelegatorReward;
    }
});
Object.defineProperty($b8ae3714266935c3$exports, "isMsgWithdrawValidatorCommission", {
    enumerable: true,
    get: function() {
        return $37e8a33ea841e05f$exports.isMsgWithdrawValidatorCommission;
    }
});
var $970d2f307c300415$exports = {};
"use strict";
Object.defineProperty($970d2f307c300415$exports, "__esModule", {
    value: true
});
$970d2f307c300415$exports.findSequenceForSignedTx = void 0;


/**
 * Serach for sequence s with `min` <= `s` < `upperBound` to find the sequence that was used to sign the transaction
 *
 * @param tx The signed transaction
 * @param chainId The chain ID for which this transaction was signed
 * @param accountNumber The account number for which this transaction was signed
 * @param upperBound The upper bound for the testing, i.e. sequence must be lower than this value
 * @param min The lowest sequence that is tested
 *
 * @returns the sequence if a match was found and undefined otherwise
 */ async function $970d2f307c300415$var$findSequenceForSignedTx(tx, chainId, accountNumber, upperBound, min = 0) {
    const firstSignature = tx.value.signatures.find(()=>true);
    if (!firstSignature) throw new Error("Signature missing in tx");
    const { pubkey: pubkey, signature: signature } = (0, $a11446128a9e19fc$exports.decodeSignature)(firstSignature);
    const secp256keSignature = $ca4c58922ce7f03a$exports.Secp256k1Signature.fromFixedLength(signature);
    for(let s = min; s < upperBound; s++){
        // console.log(`Trying sequence ${s}`);
        const signBytes = (0, $a11446128a9e19fc$exports.serializeSignDoc)((0, $a11446128a9e19fc$exports.makeSignDoc)(tx.value.msg, tx.value.fee, chainId, tx.value.memo || "", accountNumber, s));
        const prehashed = (0, $ca4c58922ce7f03a$exports.sha256)(signBytes);
        const valid = await $ca4c58922ce7f03a$exports.Secp256k1.verifySignature(secp256keSignature, prehashed, pubkey);
        if (valid) return s;
    }
    return undefined;
}
$970d2f307c300415$exports.findSequenceForSignedTx = $970d2f307c300415$var$findSequenceForSignedTx;


Object.defineProperty($b8ae3714266935c3$exports, "findSequenceForSignedTx", {
    enumerable: true,
    get: function() {
        return $970d2f307c300415$exports.findSequenceForSignedTx;
    }
});
var $29f4cbe3e17453da$exports = {};
"use strict";
var $29f4cbe3e17453da$var$__importDefault = $29f4cbe3e17453da$exports && $29f4cbe3e17453da$exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty($29f4cbe3e17453da$exports, "__esModule", {
    value: true
});
$29f4cbe3e17453da$exports.SigningCosmosClient = void 0;


const $29f4cbe3e17453da$var$fast_deep_equal_1 = $29f4cbe3e17453da$var$__importDefault((parcelRequire("iLExI")));



const $29f4cbe3e17453da$var$defaultGasPrice = $418df4b97bd2b3eb$exports.GasPrice.fromString("0.025ucosm");
const $29f4cbe3e17453da$var$defaultGasLimits = {
    send: 80000
};
class $29f4cbe3e17453da$var$SigningCosmosClient extends $39b326257dacbed3$exports.CosmosClient {
    /**
     * Creates a new client with signing capability to interact with a Cosmos SDK blockchain. This is the bigger brother of CosmosClient.
     *
     * This instance does a lot of caching. In order to benefit from that you should try to use one instance
     * for the lifetime of your application. When switching backends, a new instance must be created.
     *
     * @param apiUrl The URL of a Cosmos SDK light client daemon API (sometimes called REST server or REST API)
     * @param signerAddress The address that will sign transactions using this instance. The `signer` must be able to sign with this address.
     * @param signer An implementation of OfflineAminoSigner which can provide signatures for transactions, potentially requiring user input.
     * @param gasPrice The price paid per unit of gas
     * @param gasLimits Custom overrides for gas limits related to specific transaction types
     * @param broadcastMode Defines at which point of the transaction processing the broadcastTx method returns
     */ constructor(apiUrl, signerAddress, signer, gasPrice = $29f4cbe3e17453da$var$defaultGasPrice, gasLimits = {}, broadcastMode = $25c7156131030f5c$exports.BroadcastMode.Block){
        super(apiUrl, broadcastMode);
        this.anyValidAddress = signerAddress;
        this.signerAddress = signerAddress;
        this.signer = signer;
        this.fees = (0, $418df4b97bd2b3eb$exports.buildFeeTable)(gasPrice, $29f4cbe3e17453da$var$defaultGasLimits, gasLimits);
    }
    async getSequence(address) {
        return super.getSequence(address || this.signerAddress);
    }
    async getAccount(address) {
        return super.getAccount(address || this.signerAddress);
    }
    async sendTokens(recipientAddress, amount, memo = "") {
        const sendMsg = {
            type: "cosmos-sdk/MsgSend",
            value: {
                from_address: this.signerAddress,
                to_address: recipientAddress,
                amount: amount
            }
        };
        return this.signAndBroadcast([
            sendMsg
        ], this.fees.send, memo);
    }
    /**
     * Gets account number and sequence from the API, creates a sign doc,
     * creates a single signature, assembles the signed transaction and broadcasts it.
     */ async signAndBroadcast(msgs, fee, memo = "") {
        const signedTx = await this.sign(msgs, fee, memo);
        return this.broadcastTx(signedTx);
    }
    /**
     * Gets account number and sequence from the API, creates a sign doc,
     * creates a single signature and assembles the signed transaction.
     */ async sign(msgs, fee, memo = "") {
        const { accountNumber: accountNumber, sequence: sequence } = await this.getSequence();
        const chainId = await this.getChainId();
        const signDoc = (0, $a11446128a9e19fc$exports.makeSignDoc)(msgs, fee, chainId, memo, accountNumber, sequence);
        const { signed: signed, signature: signature } = await this.signer.signAmino(this.signerAddress, signDoc);
        return (0, $a11446128a9e19fc$exports.makeStdTx)(signed, signature);
    }
    /**
     * Gets account number and sequence from the API, creates a sign doc,
     * creates a single signature and appends it to the existing signatures.
     */ async appendSignature(signedTx) {
        const { msg: msgs, fee: fee, memo: memo } = signedTx;
        const { accountNumber: accountNumber, sequence: sequence } = await this.getSequence();
        const chainId = await this.getChainId();
        const signDoc = (0, $a11446128a9e19fc$exports.makeSignDoc)(msgs, fee, chainId, memo, accountNumber, sequence);
        const { signed: signed, signature: additionalSignature } = await this.signer.signAmino(this.signerAddress, signDoc);
        if (!(0, $29f4cbe3e17453da$var$fast_deep_equal_1.default)(signDoc, signed)) throw new Error("The signed document differs from the one of the original transaction. This is not allowed since the resulting transaction will be invalid.");
        return (0, $a11446128a9e19fc$exports.makeStdTx)(signed, [
            ...signedTx.signatures,
            additionalSignature
        ]);
    }
}
$29f4cbe3e17453da$exports.SigningCosmosClient = $29f4cbe3e17453da$var$SigningCosmosClient;


Object.defineProperty($b8ae3714266935c3$exports, "SigningCosmosClient", {
    enumerable: true,
    get: function() {
        return $29f4cbe3e17453da$exports.SigningCosmosClient;
    }
});
var $836b88db0c71fda9$exports = {};
"use strict";
Object.defineProperty($836b88db0c71fda9$exports, "__esModule", {
    value: true
});
$836b88db0c71fda9$exports.isWrappedStdTx = void 0;

function $836b88db0c71fda9$var$isWrappedStdTx(wrapped) {
    return wrapped.type === "cosmos-sdk/StdTx" && (0, $a11446128a9e19fc$exports.isStdTx)(wrapped.value);
}
$836b88db0c71fda9$exports.isWrappedStdTx = $836b88db0c71fda9$var$isWrappedStdTx;


Object.defineProperty($b8ae3714266935c3$exports, "isWrappedStdTx", {
    enumerable: true,
    get: function() {
        return $836b88db0c71fda9$exports.isWrappedStdTx;
    }
});


var $ee390ef646431151$exports = {};
"use strict";
var $ee390ef646431151$var$__createBinding = $ee390ef646431151$exports && $ee390ef646431151$exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $ee390ef646431151$var$__setModuleDefault = $ee390ef646431151$exports && $ee390ef646431151$exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $ee390ef646431151$var$__importStar = $ee390ef646431151$exports && $ee390ef646431151$exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $ee390ef646431151$var$__createBinding(result, mod, k);
    }
    $ee390ef646431151$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty($ee390ef646431151$exports, "__esModule", {
    value: true
});
$ee390ef646431151$exports.isMsgWithdrawDelegatorRewardEncodeObject = $ee390ef646431151$exports.isMsgVoteWeightedEncodeObject = $ee390ef646431151$exports.isMsgVoteEncodeObject = $ee390ef646431151$exports.isMsgUndelegateEncodeObject = $ee390ef646431151$exports.isMsgTransferEncodeObject = $ee390ef646431151$exports.isMsgSubmitProposalEncodeObject = $ee390ef646431151$exports.isMsgSendEncodeObject = $ee390ef646431151$exports.isMsgEditValidatorEncodeObject = $ee390ef646431151$exports.isMsgDepositEncodeObject = $ee390ef646431151$exports.isMsgDelegateEncodeObject = $ee390ef646431151$exports.isMsgCreateValidatorEncodeObject = $ee390ef646431151$exports.isMsgBeginRedelegateEncodeObject = $ee390ef646431151$exports.isAminoMsgWithdrawValidatorCommission = $ee390ef646431151$exports.isAminoMsgWithdrawDelegatorReward = $ee390ef646431151$exports.isAminoMsgVoteWeighted = $ee390ef646431151$exports.isAminoMsgVote = $ee390ef646431151$exports.isAminoMsgVerifyInvariant = $ee390ef646431151$exports.isAminoMsgUnjail = $ee390ef646431151$exports.isAminoMsgUndelegate = $ee390ef646431151$exports.isAminoMsgTransfer = $ee390ef646431151$exports.isAminoMsgSubmitProposal = $ee390ef646431151$exports.isAminoMsgSubmitEvidence = $ee390ef646431151$exports.isAminoMsgSetWithdrawAddress = $ee390ef646431151$exports.isAminoMsgSend = $ee390ef646431151$exports.isAminoMsgMultiSend = $ee390ef646431151$exports.isAminoMsgFundCommunityPool = $ee390ef646431151$exports.isAminoMsgEditValidator = $ee390ef646431151$exports.isAminoMsgDeposit = $ee390ef646431151$exports.isAminoMsgDelegate = $ee390ef646431151$exports.isAminoMsgCreateVestingAccount = $ee390ef646431151$exports.isAminoMsgCreateValidator = $ee390ef646431151$exports.isAminoMsgBeginRedelegate = $ee390ef646431151$exports.createVestingAminoConverters = $ee390ef646431151$exports.createStakingAminoConverters = $ee390ef646431151$exports.createSlashingAminoConverters = $ee390ef646431151$exports.createIbcAminoConverters = $ee390ef646431151$exports.createGroupAminoConverters = $ee390ef646431151$exports.createGovAminoConverters = $ee390ef646431151$exports.createFeegrantAminoConverters = $ee390ef646431151$exports.createEvidenceAminoConverters = $ee390ef646431151$exports.createDistributionAminoConverters = $ee390ef646431151$exports.createCrysisAminoConverters = $ee390ef646431151$exports.createBankAminoConverters = $ee390ef646431151$exports.createAuthzAminoConverters = $ee390ef646431151$exports.logs = $ee390ef646431151$exports.GasPrice = $ee390ef646431151$exports.calculateFee = $ee390ef646431151$exports.fromTendermintEvent = $ee390ef646431151$exports.AminoTypes = $ee390ef646431151$exports.accountFromAny = void 0;
$ee390ef646431151$exports.parseCoins = $ee390ef646431151$exports.makeCosmoshubPath = $ee390ef646431151$exports.coins = $ee390ef646431151$exports.coin = $ee390ef646431151$exports.TimeoutError = $ee390ef646431151$exports.StargateClient = $ee390ef646431151$exports.isDeliverTxSuccess = $ee390ef646431151$exports.isDeliverTxFailure = $ee390ef646431151$exports.BroadcastTxError = $ee390ef646431151$exports.assertIsDeliverTxSuccess = $ee390ef646431151$exports.assertIsDeliverTxFailure = $ee390ef646431151$exports.SigningStargateClient = $ee390ef646431151$exports.defaultRegistryTypes = $ee390ef646431151$exports.createDefaultAminoConverters = $ee390ef646431151$exports.QueryClient = $ee390ef646431151$exports.decodeCosmosSdkDecFromProto = $ee390ef646431151$exports.createProtobufRpcClient = $ee390ef646431151$exports.createPagination = $ee390ef646431151$exports.makeMultisignedTxBytes = $ee390ef646431151$exports.makeMultisignedTx = $ee390ef646431151$exports.setupTxExtension = $ee390ef646431151$exports.setupStakingExtension = $ee390ef646431151$exports.setupSlashingExtension = $ee390ef646431151$exports.setupMintExtension = $ee390ef646431151$exports.setupIbcExtension = $ee390ef646431151$exports.setupGovExtension = $ee390ef646431151$exports.setupFeegrantExtension = $ee390ef646431151$exports.setupDistributionExtension = $ee390ef646431151$exports.setupBankExtension = $ee390ef646431151$exports.setupAuthzExtension = $ee390ef646431151$exports.setupAuthExtension = void 0;
var $55dae034d780d4b9$exports = {};
"use strict";
Object.defineProperty($55dae034d780d4b9$exports, "__esModule", {
    value: true
});
$55dae034d780d4b9$exports.accountFromAny = void 0;

var $7UsfE = parcelRequire("7UsfE");
var $c0a9381c50e8ee56$exports = {};
"use strict";
Object.defineProperty($c0a9381c50e8ee56$exports, "__esModule", {
    value: true
});
$c0a9381c50e8ee56$exports.coins = $c0a9381c50e8ee56$exports.coin = $c0a9381c50e8ee56$exports.executeKdf = $c0a9381c50e8ee56$exports.makeSignDoc = $c0a9381c50e8ee56$exports.makeSignBytes = $c0a9381c50e8ee56$exports.makeAuthInfoBytes = $c0a9381c50e8ee56$exports.isOfflineDirectSigner = $c0a9381c50e8ee56$exports.Registry = $c0a9381c50e8ee56$exports.isTxBodyEncodeObject = $c0a9381c50e8ee56$exports.isTsProtoGeneratedType = $c0a9381c50e8ee56$exports.isPbjsGeneratedType = $c0a9381c50e8ee56$exports.encodePubkey = $c0a9381c50e8ee56$exports.decodePubkey = $c0a9381c50e8ee56$exports.anyToSinglePubkey = $c0a9381c50e8ee56$exports.makeCosmoshubPath = $c0a9381c50e8ee56$exports.DirectSecp256k1Wallet = $c0a9381c50e8ee56$exports.extractKdfConfiguration = $c0a9381c50e8ee56$exports.DirectSecp256k1HdWallet = $c0a9381c50e8ee56$exports.decodeTxRaw = $c0a9381c50e8ee56$exports.parseCoins = void 0;
var $3011f733cd750deb$exports = {};
"use strict";
Object.defineProperty($3011f733cd750deb$exports, "__esModule", {
    value: true
});
$3011f733cd750deb$exports.parseCoins = void 0;
/**
 * Takes a coins list like "819966000ucosm,700000000ustake" and parses it.
 *
 * This is a Stargate ready version of parseCoins from @cosmjs/amino.
 * It supports more denoms.
 */ function $3011f733cd750deb$var$parseCoins(input) {
    return input.replace(/\s/g, "").split(",").filter(Boolean).map((part)=>{
        // Denom regex from Stargate (https://github.com/cosmos/cosmos-sdk/blob/v0.42.7/types/coin.go#L599-L601)
        const match = part.match(/^([0-9]+)([a-zA-Z][a-zA-Z0-9/]{2,127})$/);
        if (!match) throw new Error("Got an invalid coin string");
        return {
            amount: match[1].replace(/^0+/, "") || "0",
            denom: match[2]
        };
    });
}
$3011f733cd750deb$exports.parseCoins = $3011f733cd750deb$var$parseCoins;


Object.defineProperty($c0a9381c50e8ee56$exports, "parseCoins", {
    enumerable: true,
    get: function() {
        return $3011f733cd750deb$exports.parseCoins;
    }
});
var $c08ee0c877bbf0d6$exports = {};
"use strict";
Object.defineProperty($c08ee0c877bbf0d6$exports, "__esModule", {
    value: true
});
$c08ee0c877bbf0d6$exports.decodeTxRaw = void 0;
var $eedf6d503be55212$exports = {};
"use strict";
var $eedf6d503be55212$var$__createBinding = $eedf6d503be55212$exports && $eedf6d503be55212$exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $eedf6d503be55212$var$__setModuleDefault = $eedf6d503be55212$exports && $eedf6d503be55212$exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $eedf6d503be55212$var$__importStar = $eedf6d503be55212$exports && $eedf6d503be55212$exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $eedf6d503be55212$var$__createBinding(result, mod, k);
    }
    $eedf6d503be55212$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty($eedf6d503be55212$exports, "__esModule", {
    value: true
});
$eedf6d503be55212$exports.AuxSignerData = $eedf6d503be55212$exports.Tip = $eedf6d503be55212$exports.Fee = $eedf6d503be55212$exports.ModeInfo_Multi = $eedf6d503be55212$exports.ModeInfo_Single = $eedf6d503be55212$exports.ModeInfo = $eedf6d503be55212$exports.SignerInfo = $eedf6d503be55212$exports.AuthInfo = $eedf6d503be55212$exports.TxBody = $eedf6d503be55212$exports.SignDocDirectAux = $eedf6d503be55212$exports.SignDoc = $eedf6d503be55212$exports.TxRaw = $eedf6d503be55212$exports.Tx = $eedf6d503be55212$exports.protobufPackage = void 0;
var $64138e590dcf0cc1$exports = {};
"use strict";
var $64138e590dcf0cc1$var$__createBinding = $64138e590dcf0cc1$exports && $64138e590dcf0cc1$exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $64138e590dcf0cc1$var$__setModuleDefault = $64138e590dcf0cc1$exports && $64138e590dcf0cc1$exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $64138e590dcf0cc1$var$__importStar = $64138e590dcf0cc1$exports && $64138e590dcf0cc1$exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $64138e590dcf0cc1$var$__createBinding(result, mod, k);
    }
    $64138e590dcf0cc1$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty($64138e590dcf0cc1$exports, "__esModule", {
    value: true
});
$64138e590dcf0cc1$exports.Any = $64138e590dcf0cc1$exports.protobufPackage = void 0;

/* eslint-disable */ const $64138e590dcf0cc1$var$_m0 = $64138e590dcf0cc1$var$__importStar((parcelRequire("fQBv0")));
var $d5e07fe2518aae94$exports = {};

var $ihoyg = parcelRequire("ihoyg");
var $d5e07fe2518aae94$require$Buffer = $ihoyg.Buffer;
"use strict";
/* eslint-disable */ /**
 * This file and any referenced files were automatically generated by @osmonauts/telescope@0.94.1
 * DO NOT MODIFY BY HAND. Instead, download the latest proto files for your chain
 * and run the transpile command or yarn proto command to regenerate this bundle.
 */ var $d5e07fe2518aae94$var$__createBinding = $d5e07fe2518aae94$exports && $d5e07fe2518aae94$exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $d5e07fe2518aae94$var$__setModuleDefault = $d5e07fe2518aae94$exports && $d5e07fe2518aae94$exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $d5e07fe2518aae94$var$__importStar = $d5e07fe2518aae94$exports && $d5e07fe2518aae94$exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $d5e07fe2518aae94$var$__createBinding(result, mod, k);
    }
    $d5e07fe2518aae94$var$__setModuleDefault(result, mod);
    return result;
};
var $d5e07fe2518aae94$var$__importDefault = $d5e07fe2518aae94$exports && $d5e07fe2518aae94$exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty($d5e07fe2518aae94$exports, "__esModule", {
    value: true
});
$d5e07fe2518aae94$exports.fromJsonTimestamp = $d5e07fe2518aae94$exports.fromTimestamp = $d5e07fe2518aae94$exports.toTimestamp = $d5e07fe2518aae94$exports.setPaginationParams = $d5e07fe2518aae94$exports.isObject = $d5e07fe2518aae94$exports.isSet = $d5e07fe2518aae94$exports.fromDuration = $d5e07fe2518aae94$exports.toDuration = $d5e07fe2518aae94$exports.omitDefault = $d5e07fe2518aae94$exports.base64FromBytes = $d5e07fe2518aae94$exports.bytesFromBase64 = $d5e07fe2518aae94$exports.Long = void 0;

const $d5e07fe2518aae94$var$_m0 = $d5e07fe2518aae94$var$__importStar((parcelRequire("fQBv0")));

const $d5e07fe2518aae94$var$long_1 = $d5e07fe2518aae94$var$__importDefault((parcelRequire("jRkuS")));
$d5e07fe2518aae94$exports.Long = $d5e07fe2518aae94$var$long_1.default;
// @ts-ignore
if ($d5e07fe2518aae94$var$_m0.util.Long !== $d5e07fe2518aae94$var$long_1.default) {
    $d5e07fe2518aae94$var$_m0.util.Long = $d5e07fe2518aae94$var$long_1.default;
    $d5e07fe2518aae94$var$_m0.configure();
}
var $d5e07fe2518aae94$var$globalThis = (()=>{
    if (typeof $d5e07fe2518aae94$var$globalThis !== "undefined") return $d5e07fe2518aae94$var$globalThis;
    if (typeof self !== "undefined") return self;
    if (typeof window !== "undefined") return window;
    if (typeof $parcel$global !== "undefined") return $parcel$global;
    throw "Unable to locate global object";
})();
const $d5e07fe2518aae94$var$atob = $d5e07fe2518aae94$var$globalThis.atob || ((b64)=>$d5e07fe2518aae94$var$globalThis.Buffer.from(b64, "base64").toString("binary"));
function $d5e07fe2518aae94$var$bytesFromBase64(b64) {
    const bin = $d5e07fe2518aae94$var$atob(b64);
    const arr = new Uint8Array(bin.length);
    for(let i = 0; i < bin.length; ++i)arr[i] = bin.charCodeAt(i);
    return arr;
}
$d5e07fe2518aae94$exports.bytesFromBase64 = $d5e07fe2518aae94$var$bytesFromBase64;
const $d5e07fe2518aae94$var$btoa = $d5e07fe2518aae94$var$globalThis.btoa || ((bin)=>$d5e07fe2518aae94$var$globalThis.Buffer.from(bin, "binary").toString("base64"));
function $d5e07fe2518aae94$var$base64FromBytes(arr) {
    const bin = [];
    arr.forEach((byte)=>{
        bin.push(String.fromCharCode(byte));
    });
    return $d5e07fe2518aae94$var$btoa(bin.join(""));
}
$d5e07fe2518aae94$exports.base64FromBytes = $d5e07fe2518aae94$var$base64FromBytes;
function $d5e07fe2518aae94$var$omitDefault(input) {
    if (typeof input === "string") return input === "" ? undefined : input;
    if (typeof input === "number") return input === 0 ? undefined : input;
    if ($d5e07fe2518aae94$var$long_1.default.isLong(input)) return input.isZero() ? undefined : input;
    throw new Error(`Got unsupported type ${typeof input}`);
}
$d5e07fe2518aae94$exports.omitDefault = $d5e07fe2518aae94$var$omitDefault;
function $d5e07fe2518aae94$var$toDuration(duration) {
    return {
        seconds: $d5e07fe2518aae94$var$long_1.default.fromNumber(Math.floor(parseInt(duration) / 1000000000)),
        nanos: parseInt(duration) % 1000000000
    };
}
$d5e07fe2518aae94$exports.toDuration = $d5e07fe2518aae94$var$toDuration;
function $d5e07fe2518aae94$var$fromDuration(duration) {
    return (parseInt(duration.seconds.toString()) * 1000000000 + duration.nanos).toString();
}
$d5e07fe2518aae94$exports.fromDuration = $d5e07fe2518aae94$var$fromDuration;
function $d5e07fe2518aae94$var$isSet(value) {
    return value !== null && value !== undefined;
}
$d5e07fe2518aae94$exports.isSet = $d5e07fe2518aae94$var$isSet;
function $d5e07fe2518aae94$var$isObject(value) {
    return typeof value === "object" && value !== null;
}
$d5e07fe2518aae94$exports.isObject = $d5e07fe2518aae94$var$isObject;
const $d5e07fe2518aae94$var$setPaginationParams = (options, pagination)=>{
    if (!pagination) return options;
    if (typeof pagination?.countTotal !== "undefined") options.params["pagination.count_total"] = pagination.countTotal;
    if (typeof pagination?.key !== "undefined") // String to Uint8Array
    // let uint8arr = new Uint8Array(Buffer.from(data,'base64'));
    // Uint8Array to String
    options.params["pagination.key"] = $d5e07fe2518aae94$require$Buffer.from(pagination.key).toString("base64");
    if (typeof pagination?.limit !== "undefined") options.params["pagination.limit"] = pagination.limit.toString();
    if (typeof pagination?.offset !== "undefined") options.params["pagination.offset"] = pagination.offset.toString();
    if (typeof pagination?.reverse !== "undefined") options.params["pagination.reverse"] = pagination.reverse;
    return options;
};
$d5e07fe2518aae94$exports.setPaginationParams = $d5e07fe2518aae94$var$setPaginationParams;
function $d5e07fe2518aae94$var$toTimestamp(date) {
    const seconds = $d5e07fe2518aae94$var$numberToLong(date.getTime() / 1000);
    const nanos = date.getTime() % 1000 * 1000000;
    return {
        seconds: seconds,
        nanos: nanos
    };
}
$d5e07fe2518aae94$exports.toTimestamp = $d5e07fe2518aae94$var$toTimestamp;
function $d5e07fe2518aae94$var$fromTimestamp(t) {
    let millis = t.seconds.toNumber() * 1000;
    millis += t.nanos / 1000000;
    return new Date(millis);
}
$d5e07fe2518aae94$exports.fromTimestamp = $d5e07fe2518aae94$var$fromTimestamp;
const $d5e07fe2518aae94$var$fromJSON = (object)=>{
    return {
        seconds: $d5e07fe2518aae94$var$isSet(object.seconds) ? $d5e07fe2518aae94$var$long_1.default.fromString(object.seconds) : $d5e07fe2518aae94$var$long_1.default.ZERO,
        nanos: $d5e07fe2518aae94$var$isSet(object.nanos) ? Number(object.nanos) : 0
    };
};
const $d5e07fe2518aae94$var$timestampFromJSON = (object)=>{
    return {
        seconds: $d5e07fe2518aae94$var$isSet(object.seconds) ? $d5e07fe2518aae94$var$long_1.default.fromValue(object.seconds) : $d5e07fe2518aae94$var$long_1.default.ZERO,
        nanos: $d5e07fe2518aae94$var$isSet(object.nanos) ? Number(object.nanos) : 0
    };
};
function $d5e07fe2518aae94$var$fromJsonTimestamp(o) {
    if (o instanceof Date) return $d5e07fe2518aae94$var$toTimestamp(o);
    else if (typeof o === "string") return $d5e07fe2518aae94$var$toTimestamp(new Date(o));
    else return $d5e07fe2518aae94$var$timestampFromJSON(o);
}
$d5e07fe2518aae94$exports.fromJsonTimestamp = $d5e07fe2518aae94$var$fromJsonTimestamp;
function $d5e07fe2518aae94$var$numberToLong(number) {
    return $d5e07fe2518aae94$var$long_1.default.fromNumber(number);
}


$64138e590dcf0cc1$exports.protobufPackage = "google.protobuf";
function $64138e590dcf0cc1$var$createBaseAny() {
    return {
        typeUrl: "",
        value: new Uint8Array()
    };
}
$64138e590dcf0cc1$exports.Any = {
    encode (message, writer = $64138e590dcf0cc1$var$_m0.Writer.create()) {
        if (message.typeUrl !== "") writer.uint32(10).string(message.typeUrl);
        if (message.value.length !== 0) writer.uint32(18).bytes(message.value);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $64138e590dcf0cc1$var$_m0.Reader ? input : new $64138e590dcf0cc1$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $64138e590dcf0cc1$var$createBaseAny();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.typeUrl = reader.string();
                    break;
                case 2:
                    message.value = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            typeUrl: (0, $d5e07fe2518aae94$exports.isSet)(object.typeUrl) ? String(object.typeUrl) : "",
            value: (0, $d5e07fe2518aae94$exports.isSet)(object.value) ? (0, $d5e07fe2518aae94$exports.bytesFromBase64)(object.value) : new Uint8Array()
        };
    },
    toJSON (message) {
        const obj = {};
        message.typeUrl !== undefined && (obj.typeUrl = message.typeUrl);
        message.value !== undefined && (obj.value = (0, $d5e07fe2518aae94$exports.base64FromBytes)(message.value !== undefined ? message.value : new Uint8Array()));
        return obj;
    },
    fromPartial (object) {
        const message = $64138e590dcf0cc1$var$createBaseAny();
        message.typeUrl = object.typeUrl ?? "";
        message.value = object.value ?? new Uint8Array();
        return message;
    }
};


var $cefef10ba181af21$exports = {};
"use strict";
var $cefef10ba181af21$var$__createBinding = $cefef10ba181af21$exports && $cefef10ba181af21$exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $cefef10ba181af21$var$__setModuleDefault = $cefef10ba181af21$exports && $cefef10ba181af21$exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $cefef10ba181af21$var$__importStar = $cefef10ba181af21$exports && $cefef10ba181af21$exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $cefef10ba181af21$var$__createBinding(result, mod, k);
    }
    $cefef10ba181af21$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty($cefef10ba181af21$exports, "__esModule", {
    value: true
});
$cefef10ba181af21$exports.SignatureDescriptor_Data_Multi = $cefef10ba181af21$exports.SignatureDescriptor_Data_Single = $cefef10ba181af21$exports.SignatureDescriptor_Data = $cefef10ba181af21$exports.SignatureDescriptor = $cefef10ba181af21$exports.SignatureDescriptors = $cefef10ba181af21$exports.signModeToJSON = $cefef10ba181af21$exports.signModeFromJSON = $cefef10ba181af21$exports.SignMode = $cefef10ba181af21$exports.protobufPackage = void 0;
var $49dbfe0929da90f4$exports = {};
"use strict";
var $49dbfe0929da90f4$var$__createBinding = $49dbfe0929da90f4$exports && $49dbfe0929da90f4$exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $49dbfe0929da90f4$var$__setModuleDefault = $49dbfe0929da90f4$exports && $49dbfe0929da90f4$exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $49dbfe0929da90f4$var$__importStar = $49dbfe0929da90f4$exports && $49dbfe0929da90f4$exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $49dbfe0929da90f4$var$__createBinding(result, mod, k);
    }
    $49dbfe0929da90f4$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty($49dbfe0929da90f4$exports, "__esModule", {
    value: true
});
$49dbfe0929da90f4$exports.CompactBitArray = $49dbfe0929da90f4$exports.MultiSignature = $49dbfe0929da90f4$exports.protobufPackage = void 0;

/* eslint-disable */ const $49dbfe0929da90f4$var$_m0 = $49dbfe0929da90f4$var$__importStar((parcelRequire("fQBv0")));

$49dbfe0929da90f4$exports.protobufPackage = "cosmos.crypto.multisig.v1beta1";
function $49dbfe0929da90f4$var$createBaseMultiSignature() {
    return {
        signatures: []
    };
}
$49dbfe0929da90f4$exports.MultiSignature = {
    encode (message, writer = $49dbfe0929da90f4$var$_m0.Writer.create()) {
        for (const v of message.signatures)writer.uint32(10).bytes(v);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $49dbfe0929da90f4$var$_m0.Reader ? input : new $49dbfe0929da90f4$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $49dbfe0929da90f4$var$createBaseMultiSignature();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.signatures.push(reader.bytes());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            signatures: Array.isArray(object?.signatures) ? object.signatures.map((e)=>(0, $d5e07fe2518aae94$exports.bytesFromBase64)(e)) : []
        };
    },
    toJSON (message) {
        const obj = {};
        if (message.signatures) obj.signatures = message.signatures.map((e)=>(0, $d5e07fe2518aae94$exports.base64FromBytes)(e !== undefined ? e : new Uint8Array()));
        else obj.signatures = [];
        return obj;
    },
    fromPartial (object) {
        const message = $49dbfe0929da90f4$var$createBaseMultiSignature();
        message.signatures = object.signatures?.map((e)=>e) || [];
        return message;
    }
};
function $49dbfe0929da90f4$var$createBaseCompactBitArray() {
    return {
        extraBitsStored: 0,
        elems: new Uint8Array()
    };
}
$49dbfe0929da90f4$exports.CompactBitArray = {
    encode (message, writer = $49dbfe0929da90f4$var$_m0.Writer.create()) {
        if (message.extraBitsStored !== 0) writer.uint32(8).uint32(message.extraBitsStored);
        if (message.elems.length !== 0) writer.uint32(18).bytes(message.elems);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $49dbfe0929da90f4$var$_m0.Reader ? input : new $49dbfe0929da90f4$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $49dbfe0929da90f4$var$createBaseCompactBitArray();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.extraBitsStored = reader.uint32();
                    break;
                case 2:
                    message.elems = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            extraBitsStored: (0, $d5e07fe2518aae94$exports.isSet)(object.extraBitsStored) ? Number(object.extraBitsStored) : 0,
            elems: (0, $d5e07fe2518aae94$exports.isSet)(object.elems) ? (0, $d5e07fe2518aae94$exports.bytesFromBase64)(object.elems) : new Uint8Array()
        };
    },
    toJSON (message) {
        const obj = {};
        message.extraBitsStored !== undefined && (obj.extraBitsStored = Math.round(message.extraBitsStored));
        message.elems !== undefined && (obj.elems = (0, $d5e07fe2518aae94$exports.base64FromBytes)(message.elems !== undefined ? message.elems : new Uint8Array()));
        return obj;
    },
    fromPartial (object) {
        const message = $49dbfe0929da90f4$var$createBaseCompactBitArray();
        message.extraBitsStored = object.extraBitsStored ?? 0;
        message.elems = object.elems ?? new Uint8Array();
        return message;
    }
};





const $cefef10ba181af21$var$_m0 = $cefef10ba181af21$var$__importStar((parcelRequire("fQBv0")));
$cefef10ba181af21$exports.protobufPackage = "cosmos.tx.signing.v1beta1";
/**
 * SignMode represents a signing mode with its own security guarantees.
 *
 * This enum should be considered a registry of all known sign modes
 * in the Cosmos ecosystem. Apps are not expected to support all known
 * sign modes. Apps that would like to support custom  sign modes are
 * encouraged to open a small PR against this file to add a new case
 * to this SignMode enum describing their sign mode so that different
 * apps have a consistent version of this enum.
 */ var $cefef10ba181af21$var$SignMode;
(function(SignMode) {
    /**
     * SIGN_MODE_UNSPECIFIED - SIGN_MODE_UNSPECIFIED specifies an unknown signing mode and will be
     * rejected.
     */ SignMode[SignMode["SIGN_MODE_UNSPECIFIED"] = 0] = "SIGN_MODE_UNSPECIFIED";
    /**
     * SIGN_MODE_DIRECT - SIGN_MODE_DIRECT specifies a signing mode which uses SignDoc and is
     * verified with raw bytes from Tx.
     */ SignMode[SignMode["SIGN_MODE_DIRECT"] = 1] = "SIGN_MODE_DIRECT";
    /**
     * SIGN_MODE_TEXTUAL - SIGN_MODE_TEXTUAL is a future signing mode that will verify some
     * human-readable textual representation on top of the binary representation
     * from SIGN_MODE_DIRECT. It is currently not supported.
     */ SignMode[SignMode["SIGN_MODE_TEXTUAL"] = 2] = "SIGN_MODE_TEXTUAL";
    /**
     * SIGN_MODE_DIRECT_AUX - SIGN_MODE_DIRECT_AUX specifies a signing mode which uses
     * SignDocDirectAux. As opposed to SIGN_MODE_DIRECT, this sign mode does not
     * require signers signing over other signers' `signer_info`. It also allows
     * for adding Tips in transactions.
     *
     * Since: cosmos-sdk 0.46
     */ SignMode[SignMode["SIGN_MODE_DIRECT_AUX"] = 3] = "SIGN_MODE_DIRECT_AUX";
    /**
     * SIGN_MODE_LEGACY_AMINO_JSON - SIGN_MODE_LEGACY_AMINO_JSON is a backwards compatibility mode which uses
     * Amino JSON and will be removed in the future.
     */ SignMode[SignMode["SIGN_MODE_LEGACY_AMINO_JSON"] = 127] = "SIGN_MODE_LEGACY_AMINO_JSON";
    /**
     * SIGN_MODE_EIP_191 - SIGN_MODE_EIP_191 specifies the sign mode for EIP 191 signing on the Cosmos
     * SDK. Ref: https://eips.ethereum.org/EIPS/eip-191
     *
     * Currently, SIGN_MODE_EIP_191 is registered as a SignMode enum variant,
     * but is not implemented on the SDK by default. To enable EIP-191, you need
     * to pass a custom `TxConfig` that has an implementation of
     * `SignModeHandler` for EIP-191. The SDK may decide to fully support
     * EIP-191 in the future.
     *
     * Since: cosmos-sdk 0.45.2
     */ SignMode[SignMode["SIGN_MODE_EIP_191"] = 191] = "SIGN_MODE_EIP_191";
    SignMode[SignMode["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})($cefef10ba181af21$var$SignMode = $cefef10ba181af21$exports.SignMode || ($cefef10ba181af21$exports.SignMode = {}));
function $cefef10ba181af21$var$signModeFromJSON(object) {
    switch(object){
        case 0:
        case "SIGN_MODE_UNSPECIFIED":
            return $cefef10ba181af21$var$SignMode.SIGN_MODE_UNSPECIFIED;
        case 1:
        case "SIGN_MODE_DIRECT":
            return $cefef10ba181af21$var$SignMode.SIGN_MODE_DIRECT;
        case 2:
        case "SIGN_MODE_TEXTUAL":
            return $cefef10ba181af21$var$SignMode.SIGN_MODE_TEXTUAL;
        case 3:
        case "SIGN_MODE_DIRECT_AUX":
            return $cefef10ba181af21$var$SignMode.SIGN_MODE_DIRECT_AUX;
        case 127:
        case "SIGN_MODE_LEGACY_AMINO_JSON":
            return $cefef10ba181af21$var$SignMode.SIGN_MODE_LEGACY_AMINO_JSON;
        case 191:
        case "SIGN_MODE_EIP_191":
            return $cefef10ba181af21$var$SignMode.SIGN_MODE_EIP_191;
        case -1:
        case "UNRECOGNIZED":
        default:
            return $cefef10ba181af21$var$SignMode.UNRECOGNIZED;
    }
}
$cefef10ba181af21$exports.signModeFromJSON = $cefef10ba181af21$var$signModeFromJSON;
function $cefef10ba181af21$var$signModeToJSON(object) {
    switch(object){
        case $cefef10ba181af21$var$SignMode.SIGN_MODE_UNSPECIFIED:
            return "SIGN_MODE_UNSPECIFIED";
        case $cefef10ba181af21$var$SignMode.SIGN_MODE_DIRECT:
            return "SIGN_MODE_DIRECT";
        case $cefef10ba181af21$var$SignMode.SIGN_MODE_TEXTUAL:
            return "SIGN_MODE_TEXTUAL";
        case $cefef10ba181af21$var$SignMode.SIGN_MODE_DIRECT_AUX:
            return "SIGN_MODE_DIRECT_AUX";
        case $cefef10ba181af21$var$SignMode.SIGN_MODE_LEGACY_AMINO_JSON:
            return "SIGN_MODE_LEGACY_AMINO_JSON";
        case $cefef10ba181af21$var$SignMode.SIGN_MODE_EIP_191:
            return "SIGN_MODE_EIP_191";
        case $cefef10ba181af21$var$SignMode.UNRECOGNIZED:
        default:
            return "UNRECOGNIZED";
    }
}
$cefef10ba181af21$exports.signModeToJSON = $cefef10ba181af21$var$signModeToJSON;
function $cefef10ba181af21$var$createBaseSignatureDescriptors() {
    return {
        signatures: []
    };
}
$cefef10ba181af21$exports.SignatureDescriptors = {
    encode (message, writer = $cefef10ba181af21$var$_m0.Writer.create()) {
        for (const v of message.signatures)$cefef10ba181af21$exports.SignatureDescriptor.encode(v, writer.uint32(10).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $cefef10ba181af21$var$_m0.Reader ? input : new $cefef10ba181af21$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $cefef10ba181af21$var$createBaseSignatureDescriptors();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.signatures.push($cefef10ba181af21$exports.SignatureDescriptor.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            signatures: Array.isArray(object?.signatures) ? object.signatures.map((e)=>$cefef10ba181af21$exports.SignatureDescriptor.fromJSON(e)) : []
        };
    },
    toJSON (message) {
        const obj = {};
        if (message.signatures) obj.signatures = message.signatures.map((e)=>e ? $cefef10ba181af21$exports.SignatureDescriptor.toJSON(e) : undefined);
        else obj.signatures = [];
        return obj;
    },
    fromPartial (object) {
        const message = $cefef10ba181af21$var$createBaseSignatureDescriptors();
        message.signatures = object.signatures?.map((e)=>$cefef10ba181af21$exports.SignatureDescriptor.fromPartial(e)) || [];
        return message;
    }
};
function $cefef10ba181af21$var$createBaseSignatureDescriptor() {
    return {
        publicKey: undefined,
        data: undefined,
        sequence: $d5e07fe2518aae94$exports.Long.UZERO
    };
}
$cefef10ba181af21$exports.SignatureDescriptor = {
    encode (message, writer = $cefef10ba181af21$var$_m0.Writer.create()) {
        if (message.publicKey !== undefined) $64138e590dcf0cc1$exports.Any.encode(message.publicKey, writer.uint32(10).fork()).ldelim();
        if (message.data !== undefined) $cefef10ba181af21$exports.SignatureDescriptor_Data.encode(message.data, writer.uint32(18).fork()).ldelim();
        if (!message.sequence.isZero()) writer.uint32(24).uint64(message.sequence);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $cefef10ba181af21$var$_m0.Reader ? input : new $cefef10ba181af21$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $cefef10ba181af21$var$createBaseSignatureDescriptor();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.publicKey = $64138e590dcf0cc1$exports.Any.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.data = $cefef10ba181af21$exports.SignatureDescriptor_Data.decode(reader, reader.uint32());
                    break;
                case 3:
                    message.sequence = reader.uint64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            publicKey: (0, $d5e07fe2518aae94$exports.isSet)(object.publicKey) ? $64138e590dcf0cc1$exports.Any.fromJSON(object.publicKey) : undefined,
            data: (0, $d5e07fe2518aae94$exports.isSet)(object.data) ? $cefef10ba181af21$exports.SignatureDescriptor_Data.fromJSON(object.data) : undefined,
            sequence: (0, $d5e07fe2518aae94$exports.isSet)(object.sequence) ? $d5e07fe2518aae94$exports.Long.fromValue(object.sequence) : $d5e07fe2518aae94$exports.Long.UZERO
        };
    },
    toJSON (message) {
        const obj = {};
        message.publicKey !== undefined && (obj.publicKey = message.publicKey ? $64138e590dcf0cc1$exports.Any.toJSON(message.publicKey) : undefined);
        message.data !== undefined && (obj.data = message.data ? $cefef10ba181af21$exports.SignatureDescriptor_Data.toJSON(message.data) : undefined);
        message.sequence !== undefined && (obj.sequence = (message.sequence || $d5e07fe2518aae94$exports.Long.UZERO).toString());
        return obj;
    },
    fromPartial (object) {
        const message = $cefef10ba181af21$var$createBaseSignatureDescriptor();
        message.publicKey = object.publicKey !== undefined && object.publicKey !== null ? $64138e590dcf0cc1$exports.Any.fromPartial(object.publicKey) : undefined;
        message.data = object.data !== undefined && object.data !== null ? $cefef10ba181af21$exports.SignatureDescriptor_Data.fromPartial(object.data) : undefined;
        message.sequence = object.sequence !== undefined && object.sequence !== null ? $d5e07fe2518aae94$exports.Long.fromValue(object.sequence) : $d5e07fe2518aae94$exports.Long.UZERO;
        return message;
    }
};
function $cefef10ba181af21$var$createBaseSignatureDescriptor_Data() {
    return {
        single: undefined,
        multi: undefined
    };
}
$cefef10ba181af21$exports.SignatureDescriptor_Data = {
    encode (message, writer = $cefef10ba181af21$var$_m0.Writer.create()) {
        if (message.single !== undefined) $cefef10ba181af21$exports.SignatureDescriptor_Data_Single.encode(message.single, writer.uint32(10).fork()).ldelim();
        if (message.multi !== undefined) $cefef10ba181af21$exports.SignatureDescriptor_Data_Multi.encode(message.multi, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $cefef10ba181af21$var$_m0.Reader ? input : new $cefef10ba181af21$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $cefef10ba181af21$var$createBaseSignatureDescriptor_Data();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.single = $cefef10ba181af21$exports.SignatureDescriptor_Data_Single.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.multi = $cefef10ba181af21$exports.SignatureDescriptor_Data_Multi.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            single: (0, $d5e07fe2518aae94$exports.isSet)(object.single) ? $cefef10ba181af21$exports.SignatureDescriptor_Data_Single.fromJSON(object.single) : undefined,
            multi: (0, $d5e07fe2518aae94$exports.isSet)(object.multi) ? $cefef10ba181af21$exports.SignatureDescriptor_Data_Multi.fromJSON(object.multi) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.single !== undefined && (obj.single = message.single ? $cefef10ba181af21$exports.SignatureDescriptor_Data_Single.toJSON(message.single) : undefined);
        message.multi !== undefined && (obj.multi = message.multi ? $cefef10ba181af21$exports.SignatureDescriptor_Data_Multi.toJSON(message.multi) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $cefef10ba181af21$var$createBaseSignatureDescriptor_Data();
        message.single = object.single !== undefined && object.single !== null ? $cefef10ba181af21$exports.SignatureDescriptor_Data_Single.fromPartial(object.single) : undefined;
        message.multi = object.multi !== undefined && object.multi !== null ? $cefef10ba181af21$exports.SignatureDescriptor_Data_Multi.fromPartial(object.multi) : undefined;
        return message;
    }
};
function $cefef10ba181af21$var$createBaseSignatureDescriptor_Data_Single() {
    return {
        mode: 0,
        signature: new Uint8Array()
    };
}
$cefef10ba181af21$exports.SignatureDescriptor_Data_Single = {
    encode (message, writer = $cefef10ba181af21$var$_m0.Writer.create()) {
        if (message.mode !== 0) writer.uint32(8).int32(message.mode);
        if (message.signature.length !== 0) writer.uint32(18).bytes(message.signature);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $cefef10ba181af21$var$_m0.Reader ? input : new $cefef10ba181af21$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $cefef10ba181af21$var$createBaseSignatureDescriptor_Data_Single();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.mode = reader.int32();
                    break;
                case 2:
                    message.signature = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            mode: (0, $d5e07fe2518aae94$exports.isSet)(object.mode) ? $cefef10ba181af21$var$signModeFromJSON(object.mode) : 0,
            signature: (0, $d5e07fe2518aae94$exports.isSet)(object.signature) ? (0, $d5e07fe2518aae94$exports.bytesFromBase64)(object.signature) : new Uint8Array()
        };
    },
    toJSON (message) {
        const obj = {};
        message.mode !== undefined && (obj.mode = $cefef10ba181af21$var$signModeToJSON(message.mode));
        message.signature !== undefined && (obj.signature = (0, $d5e07fe2518aae94$exports.base64FromBytes)(message.signature !== undefined ? message.signature : new Uint8Array()));
        return obj;
    },
    fromPartial (object) {
        const message = $cefef10ba181af21$var$createBaseSignatureDescriptor_Data_Single();
        message.mode = object.mode ?? 0;
        message.signature = object.signature ?? new Uint8Array();
        return message;
    }
};
function $cefef10ba181af21$var$createBaseSignatureDescriptor_Data_Multi() {
    return {
        bitarray: undefined,
        signatures: []
    };
}
$cefef10ba181af21$exports.SignatureDescriptor_Data_Multi = {
    encode (message, writer = $cefef10ba181af21$var$_m0.Writer.create()) {
        if (message.bitarray !== undefined) $49dbfe0929da90f4$exports.CompactBitArray.encode(message.bitarray, writer.uint32(10).fork()).ldelim();
        for (const v of message.signatures)$cefef10ba181af21$exports.SignatureDescriptor_Data.encode(v, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $cefef10ba181af21$var$_m0.Reader ? input : new $cefef10ba181af21$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $cefef10ba181af21$var$createBaseSignatureDescriptor_Data_Multi();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.bitarray = $49dbfe0929da90f4$exports.CompactBitArray.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.signatures.push($cefef10ba181af21$exports.SignatureDescriptor_Data.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            bitarray: (0, $d5e07fe2518aae94$exports.isSet)(object.bitarray) ? $49dbfe0929da90f4$exports.CompactBitArray.fromJSON(object.bitarray) : undefined,
            signatures: Array.isArray(object?.signatures) ? object.signatures.map((e)=>$cefef10ba181af21$exports.SignatureDescriptor_Data.fromJSON(e)) : []
        };
    },
    toJSON (message) {
        const obj = {};
        message.bitarray !== undefined && (obj.bitarray = message.bitarray ? $49dbfe0929da90f4$exports.CompactBitArray.toJSON(message.bitarray) : undefined);
        if (message.signatures) obj.signatures = message.signatures.map((e)=>e ? $cefef10ba181af21$exports.SignatureDescriptor_Data.toJSON(e) : undefined);
        else obj.signatures = [];
        return obj;
    },
    fromPartial (object) {
        const message = $cefef10ba181af21$var$createBaseSignatureDescriptor_Data_Multi();
        message.bitarray = object.bitarray !== undefined && object.bitarray !== null ? $49dbfe0929da90f4$exports.CompactBitArray.fromPartial(object.bitarray) : undefined;
        message.signatures = object.signatures?.map((e)=>$cefef10ba181af21$exports.SignatureDescriptor_Data.fromPartial(e)) || [];
        return message;
    }
};



var $783dd8715fde0fcf$exports = {};
"use strict";
var $783dd8715fde0fcf$var$__createBinding = $783dd8715fde0fcf$exports && $783dd8715fde0fcf$exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $783dd8715fde0fcf$var$__setModuleDefault = $783dd8715fde0fcf$exports && $783dd8715fde0fcf$exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $783dd8715fde0fcf$var$__importStar = $783dd8715fde0fcf$exports && $783dd8715fde0fcf$exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $783dd8715fde0fcf$var$__createBinding(result, mod, k);
    }
    $783dd8715fde0fcf$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty($783dd8715fde0fcf$exports, "__esModule", {
    value: true
});
$783dd8715fde0fcf$exports.DecProto = $783dd8715fde0fcf$exports.IntProto = $783dd8715fde0fcf$exports.DecCoin = $783dd8715fde0fcf$exports.Coin = $783dd8715fde0fcf$exports.protobufPackage = void 0;

/* eslint-disable */ const $783dd8715fde0fcf$var$_m0 = $783dd8715fde0fcf$var$__importStar((parcelRequire("fQBv0")));

$783dd8715fde0fcf$exports.protobufPackage = "cosmos.base.v1beta1";
function $783dd8715fde0fcf$var$createBaseCoin() {
    return {
        denom: "",
        amount: ""
    };
}
$783dd8715fde0fcf$exports.Coin = {
    encode (message, writer = $783dd8715fde0fcf$var$_m0.Writer.create()) {
        if (message.denom !== "") writer.uint32(10).string(message.denom);
        if (message.amount !== "") writer.uint32(18).string(message.amount);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $783dd8715fde0fcf$var$_m0.Reader ? input : new $783dd8715fde0fcf$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $783dd8715fde0fcf$var$createBaseCoin();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.denom = reader.string();
                    break;
                case 2:
                    message.amount = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            denom: (0, $d5e07fe2518aae94$exports.isSet)(object.denom) ? String(object.denom) : "",
            amount: (0, $d5e07fe2518aae94$exports.isSet)(object.amount) ? String(object.amount) : ""
        };
    },
    toJSON (message) {
        const obj = {};
        message.denom !== undefined && (obj.denom = message.denom);
        message.amount !== undefined && (obj.amount = message.amount);
        return obj;
    },
    fromPartial (object) {
        const message = $783dd8715fde0fcf$var$createBaseCoin();
        message.denom = object.denom ?? "";
        message.amount = object.amount ?? "";
        return message;
    }
};
function $783dd8715fde0fcf$var$createBaseDecCoin() {
    return {
        denom: "",
        amount: ""
    };
}
$783dd8715fde0fcf$exports.DecCoin = {
    encode (message, writer = $783dd8715fde0fcf$var$_m0.Writer.create()) {
        if (message.denom !== "") writer.uint32(10).string(message.denom);
        if (message.amount !== "") writer.uint32(18).string(message.amount);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $783dd8715fde0fcf$var$_m0.Reader ? input : new $783dd8715fde0fcf$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $783dd8715fde0fcf$var$createBaseDecCoin();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.denom = reader.string();
                    break;
                case 2:
                    message.amount = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            denom: (0, $d5e07fe2518aae94$exports.isSet)(object.denom) ? String(object.denom) : "",
            amount: (0, $d5e07fe2518aae94$exports.isSet)(object.amount) ? String(object.amount) : ""
        };
    },
    toJSON (message) {
        const obj = {};
        message.denom !== undefined && (obj.denom = message.denom);
        message.amount !== undefined && (obj.amount = message.amount);
        return obj;
    },
    fromPartial (object) {
        const message = $783dd8715fde0fcf$var$createBaseDecCoin();
        message.denom = object.denom ?? "";
        message.amount = object.amount ?? "";
        return message;
    }
};
function $783dd8715fde0fcf$var$createBaseIntProto() {
    return {
        int: ""
    };
}
$783dd8715fde0fcf$exports.IntProto = {
    encode (message, writer = $783dd8715fde0fcf$var$_m0.Writer.create()) {
        if (message.int !== "") writer.uint32(10).string(message.int);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $783dd8715fde0fcf$var$_m0.Reader ? input : new $783dd8715fde0fcf$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $783dd8715fde0fcf$var$createBaseIntProto();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.int = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            int: (0, $d5e07fe2518aae94$exports.isSet)(object.int) ? String(object.int) : ""
        };
    },
    toJSON (message) {
        const obj = {};
        message.int !== undefined && (obj.int = message.int);
        return obj;
    },
    fromPartial (object) {
        const message = $783dd8715fde0fcf$var$createBaseIntProto();
        message.int = object.int ?? "";
        return message;
    }
};
function $783dd8715fde0fcf$var$createBaseDecProto() {
    return {
        dec: ""
    };
}
$783dd8715fde0fcf$exports.DecProto = {
    encode (message, writer = $783dd8715fde0fcf$var$_m0.Writer.create()) {
        if (message.dec !== "") writer.uint32(10).string(message.dec);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $783dd8715fde0fcf$var$_m0.Reader ? input : new $783dd8715fde0fcf$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $783dd8715fde0fcf$var$createBaseDecProto();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.dec = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            dec: (0, $d5e07fe2518aae94$exports.isSet)(object.dec) ? String(object.dec) : ""
        };
    },
    toJSON (message) {
        const obj = {};
        message.dec !== undefined && (obj.dec = message.dec);
        return obj;
    },
    fromPartial (object) {
        const message = $783dd8715fde0fcf$var$createBaseDecProto();
        message.dec = object.dec ?? "";
        return message;
    }
};




const $eedf6d503be55212$var$_m0 = $eedf6d503be55212$var$__importStar((parcelRequire("fQBv0")));
$eedf6d503be55212$exports.protobufPackage = "cosmos.tx.v1beta1";
function $eedf6d503be55212$var$createBaseTx() {
    return {
        body: undefined,
        authInfo: undefined,
        signatures: []
    };
}
$eedf6d503be55212$exports.Tx = {
    encode (message, writer = $eedf6d503be55212$var$_m0.Writer.create()) {
        if (message.body !== undefined) $eedf6d503be55212$exports.TxBody.encode(message.body, writer.uint32(10).fork()).ldelim();
        if (message.authInfo !== undefined) $eedf6d503be55212$exports.AuthInfo.encode(message.authInfo, writer.uint32(18).fork()).ldelim();
        for (const v of message.signatures)writer.uint32(26).bytes(v);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $eedf6d503be55212$var$_m0.Reader ? input : new $eedf6d503be55212$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $eedf6d503be55212$var$createBaseTx();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.body = $eedf6d503be55212$exports.TxBody.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.authInfo = $eedf6d503be55212$exports.AuthInfo.decode(reader, reader.uint32());
                    break;
                case 3:
                    message.signatures.push(reader.bytes());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            body: (0, $d5e07fe2518aae94$exports.isSet)(object.body) ? $eedf6d503be55212$exports.TxBody.fromJSON(object.body) : undefined,
            authInfo: (0, $d5e07fe2518aae94$exports.isSet)(object.authInfo) ? $eedf6d503be55212$exports.AuthInfo.fromJSON(object.authInfo) : undefined,
            signatures: Array.isArray(object?.signatures) ? object.signatures.map((e)=>(0, $d5e07fe2518aae94$exports.bytesFromBase64)(e)) : []
        };
    },
    toJSON (message) {
        const obj = {};
        message.body !== undefined && (obj.body = message.body ? $eedf6d503be55212$exports.TxBody.toJSON(message.body) : undefined);
        message.authInfo !== undefined && (obj.authInfo = message.authInfo ? $eedf6d503be55212$exports.AuthInfo.toJSON(message.authInfo) : undefined);
        if (message.signatures) obj.signatures = message.signatures.map((e)=>(0, $d5e07fe2518aae94$exports.base64FromBytes)(e !== undefined ? e : new Uint8Array()));
        else obj.signatures = [];
        return obj;
    },
    fromPartial (object) {
        const message = $eedf6d503be55212$var$createBaseTx();
        message.body = object.body !== undefined && object.body !== null ? $eedf6d503be55212$exports.TxBody.fromPartial(object.body) : undefined;
        message.authInfo = object.authInfo !== undefined && object.authInfo !== null ? $eedf6d503be55212$exports.AuthInfo.fromPartial(object.authInfo) : undefined;
        message.signatures = object.signatures?.map((e)=>e) || [];
        return message;
    }
};
function $eedf6d503be55212$var$createBaseTxRaw() {
    return {
        bodyBytes: new Uint8Array(),
        authInfoBytes: new Uint8Array(),
        signatures: []
    };
}
$eedf6d503be55212$exports.TxRaw = {
    encode (message, writer = $eedf6d503be55212$var$_m0.Writer.create()) {
        if (message.bodyBytes.length !== 0) writer.uint32(10).bytes(message.bodyBytes);
        if (message.authInfoBytes.length !== 0) writer.uint32(18).bytes(message.authInfoBytes);
        for (const v of message.signatures)writer.uint32(26).bytes(v);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $eedf6d503be55212$var$_m0.Reader ? input : new $eedf6d503be55212$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $eedf6d503be55212$var$createBaseTxRaw();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.bodyBytes = reader.bytes();
                    break;
                case 2:
                    message.authInfoBytes = reader.bytes();
                    break;
                case 3:
                    message.signatures.push(reader.bytes());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            bodyBytes: (0, $d5e07fe2518aae94$exports.isSet)(object.bodyBytes) ? (0, $d5e07fe2518aae94$exports.bytesFromBase64)(object.bodyBytes) : new Uint8Array(),
            authInfoBytes: (0, $d5e07fe2518aae94$exports.isSet)(object.authInfoBytes) ? (0, $d5e07fe2518aae94$exports.bytesFromBase64)(object.authInfoBytes) : new Uint8Array(),
            signatures: Array.isArray(object?.signatures) ? object.signatures.map((e)=>(0, $d5e07fe2518aae94$exports.bytesFromBase64)(e)) : []
        };
    },
    toJSON (message) {
        const obj = {};
        message.bodyBytes !== undefined && (obj.bodyBytes = (0, $d5e07fe2518aae94$exports.base64FromBytes)(message.bodyBytes !== undefined ? message.bodyBytes : new Uint8Array()));
        message.authInfoBytes !== undefined && (obj.authInfoBytes = (0, $d5e07fe2518aae94$exports.base64FromBytes)(message.authInfoBytes !== undefined ? message.authInfoBytes : new Uint8Array()));
        if (message.signatures) obj.signatures = message.signatures.map((e)=>(0, $d5e07fe2518aae94$exports.base64FromBytes)(e !== undefined ? e : new Uint8Array()));
        else obj.signatures = [];
        return obj;
    },
    fromPartial (object) {
        const message = $eedf6d503be55212$var$createBaseTxRaw();
        message.bodyBytes = object.bodyBytes ?? new Uint8Array();
        message.authInfoBytes = object.authInfoBytes ?? new Uint8Array();
        message.signatures = object.signatures?.map((e)=>e) || [];
        return message;
    }
};
function $eedf6d503be55212$var$createBaseSignDoc() {
    return {
        bodyBytes: new Uint8Array(),
        authInfoBytes: new Uint8Array(),
        chainId: "",
        accountNumber: $d5e07fe2518aae94$exports.Long.UZERO
    };
}
$eedf6d503be55212$exports.SignDoc = {
    encode (message, writer = $eedf6d503be55212$var$_m0.Writer.create()) {
        if (message.bodyBytes.length !== 0) writer.uint32(10).bytes(message.bodyBytes);
        if (message.authInfoBytes.length !== 0) writer.uint32(18).bytes(message.authInfoBytes);
        if (message.chainId !== "") writer.uint32(26).string(message.chainId);
        if (!message.accountNumber.isZero()) writer.uint32(32).uint64(message.accountNumber);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $eedf6d503be55212$var$_m0.Reader ? input : new $eedf6d503be55212$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $eedf6d503be55212$var$createBaseSignDoc();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.bodyBytes = reader.bytes();
                    break;
                case 2:
                    message.authInfoBytes = reader.bytes();
                    break;
                case 3:
                    message.chainId = reader.string();
                    break;
                case 4:
                    message.accountNumber = reader.uint64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            bodyBytes: (0, $d5e07fe2518aae94$exports.isSet)(object.bodyBytes) ? (0, $d5e07fe2518aae94$exports.bytesFromBase64)(object.bodyBytes) : new Uint8Array(),
            authInfoBytes: (0, $d5e07fe2518aae94$exports.isSet)(object.authInfoBytes) ? (0, $d5e07fe2518aae94$exports.bytesFromBase64)(object.authInfoBytes) : new Uint8Array(),
            chainId: (0, $d5e07fe2518aae94$exports.isSet)(object.chainId) ? String(object.chainId) : "",
            accountNumber: (0, $d5e07fe2518aae94$exports.isSet)(object.accountNumber) ? $d5e07fe2518aae94$exports.Long.fromValue(object.accountNumber) : $d5e07fe2518aae94$exports.Long.UZERO
        };
    },
    toJSON (message) {
        const obj = {};
        message.bodyBytes !== undefined && (obj.bodyBytes = (0, $d5e07fe2518aae94$exports.base64FromBytes)(message.bodyBytes !== undefined ? message.bodyBytes : new Uint8Array()));
        message.authInfoBytes !== undefined && (obj.authInfoBytes = (0, $d5e07fe2518aae94$exports.base64FromBytes)(message.authInfoBytes !== undefined ? message.authInfoBytes : new Uint8Array()));
        message.chainId !== undefined && (obj.chainId = message.chainId);
        message.accountNumber !== undefined && (obj.accountNumber = (message.accountNumber || $d5e07fe2518aae94$exports.Long.UZERO).toString());
        return obj;
    },
    fromPartial (object) {
        const message = $eedf6d503be55212$var$createBaseSignDoc();
        message.bodyBytes = object.bodyBytes ?? new Uint8Array();
        message.authInfoBytes = object.authInfoBytes ?? new Uint8Array();
        message.chainId = object.chainId ?? "";
        message.accountNumber = object.accountNumber !== undefined && object.accountNumber !== null ? $d5e07fe2518aae94$exports.Long.fromValue(object.accountNumber) : $d5e07fe2518aae94$exports.Long.UZERO;
        return message;
    }
};
function $eedf6d503be55212$var$createBaseSignDocDirectAux() {
    return {
        bodyBytes: new Uint8Array(),
        publicKey: undefined,
        chainId: "",
        accountNumber: $d5e07fe2518aae94$exports.Long.UZERO,
        sequence: $d5e07fe2518aae94$exports.Long.UZERO,
        tip: undefined
    };
}
$eedf6d503be55212$exports.SignDocDirectAux = {
    encode (message, writer = $eedf6d503be55212$var$_m0.Writer.create()) {
        if (message.bodyBytes.length !== 0) writer.uint32(10).bytes(message.bodyBytes);
        if (message.publicKey !== undefined) $64138e590dcf0cc1$exports.Any.encode(message.publicKey, writer.uint32(18).fork()).ldelim();
        if (message.chainId !== "") writer.uint32(26).string(message.chainId);
        if (!message.accountNumber.isZero()) writer.uint32(32).uint64(message.accountNumber);
        if (!message.sequence.isZero()) writer.uint32(40).uint64(message.sequence);
        if (message.tip !== undefined) $eedf6d503be55212$exports.Tip.encode(message.tip, writer.uint32(50).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $eedf6d503be55212$var$_m0.Reader ? input : new $eedf6d503be55212$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $eedf6d503be55212$var$createBaseSignDocDirectAux();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.bodyBytes = reader.bytes();
                    break;
                case 2:
                    message.publicKey = $64138e590dcf0cc1$exports.Any.decode(reader, reader.uint32());
                    break;
                case 3:
                    message.chainId = reader.string();
                    break;
                case 4:
                    message.accountNumber = reader.uint64();
                    break;
                case 5:
                    message.sequence = reader.uint64();
                    break;
                case 6:
                    message.tip = $eedf6d503be55212$exports.Tip.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            bodyBytes: (0, $d5e07fe2518aae94$exports.isSet)(object.bodyBytes) ? (0, $d5e07fe2518aae94$exports.bytesFromBase64)(object.bodyBytes) : new Uint8Array(),
            publicKey: (0, $d5e07fe2518aae94$exports.isSet)(object.publicKey) ? $64138e590dcf0cc1$exports.Any.fromJSON(object.publicKey) : undefined,
            chainId: (0, $d5e07fe2518aae94$exports.isSet)(object.chainId) ? String(object.chainId) : "",
            accountNumber: (0, $d5e07fe2518aae94$exports.isSet)(object.accountNumber) ? $d5e07fe2518aae94$exports.Long.fromValue(object.accountNumber) : $d5e07fe2518aae94$exports.Long.UZERO,
            sequence: (0, $d5e07fe2518aae94$exports.isSet)(object.sequence) ? $d5e07fe2518aae94$exports.Long.fromValue(object.sequence) : $d5e07fe2518aae94$exports.Long.UZERO,
            tip: (0, $d5e07fe2518aae94$exports.isSet)(object.tip) ? $eedf6d503be55212$exports.Tip.fromJSON(object.tip) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.bodyBytes !== undefined && (obj.bodyBytes = (0, $d5e07fe2518aae94$exports.base64FromBytes)(message.bodyBytes !== undefined ? message.bodyBytes : new Uint8Array()));
        message.publicKey !== undefined && (obj.publicKey = message.publicKey ? $64138e590dcf0cc1$exports.Any.toJSON(message.publicKey) : undefined);
        message.chainId !== undefined && (obj.chainId = message.chainId);
        message.accountNumber !== undefined && (obj.accountNumber = (message.accountNumber || $d5e07fe2518aae94$exports.Long.UZERO).toString());
        message.sequence !== undefined && (obj.sequence = (message.sequence || $d5e07fe2518aae94$exports.Long.UZERO).toString());
        message.tip !== undefined && (obj.tip = message.tip ? $eedf6d503be55212$exports.Tip.toJSON(message.tip) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $eedf6d503be55212$var$createBaseSignDocDirectAux();
        message.bodyBytes = object.bodyBytes ?? new Uint8Array();
        message.publicKey = object.publicKey !== undefined && object.publicKey !== null ? $64138e590dcf0cc1$exports.Any.fromPartial(object.publicKey) : undefined;
        message.chainId = object.chainId ?? "";
        message.accountNumber = object.accountNumber !== undefined && object.accountNumber !== null ? $d5e07fe2518aae94$exports.Long.fromValue(object.accountNumber) : $d5e07fe2518aae94$exports.Long.UZERO;
        message.sequence = object.sequence !== undefined && object.sequence !== null ? $d5e07fe2518aae94$exports.Long.fromValue(object.sequence) : $d5e07fe2518aae94$exports.Long.UZERO;
        message.tip = object.tip !== undefined && object.tip !== null ? $eedf6d503be55212$exports.Tip.fromPartial(object.tip) : undefined;
        return message;
    }
};
function $eedf6d503be55212$var$createBaseTxBody() {
    return {
        messages: [],
        memo: "",
        timeoutHeight: $d5e07fe2518aae94$exports.Long.UZERO,
        extensionOptions: [],
        nonCriticalExtensionOptions: []
    };
}
$eedf6d503be55212$exports.TxBody = {
    encode (message, writer = $eedf6d503be55212$var$_m0.Writer.create()) {
        for (const v of message.messages)$64138e590dcf0cc1$exports.Any.encode(v, writer.uint32(10).fork()).ldelim();
        if (message.memo !== "") writer.uint32(18).string(message.memo);
        if (!message.timeoutHeight.isZero()) writer.uint32(24).uint64(message.timeoutHeight);
        for (const v of message.extensionOptions)$64138e590dcf0cc1$exports.Any.encode(v, writer.uint32(8186).fork()).ldelim();
        for (const v of message.nonCriticalExtensionOptions)$64138e590dcf0cc1$exports.Any.encode(v, writer.uint32(16378).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $eedf6d503be55212$var$_m0.Reader ? input : new $eedf6d503be55212$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $eedf6d503be55212$var$createBaseTxBody();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.messages.push($64138e590dcf0cc1$exports.Any.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.memo = reader.string();
                    break;
                case 3:
                    message.timeoutHeight = reader.uint64();
                    break;
                case 1023:
                    message.extensionOptions.push($64138e590dcf0cc1$exports.Any.decode(reader, reader.uint32()));
                    break;
                case 2047:
                    message.nonCriticalExtensionOptions.push($64138e590dcf0cc1$exports.Any.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            messages: Array.isArray(object?.messages) ? object.messages.map((e)=>$64138e590dcf0cc1$exports.Any.fromJSON(e)) : [],
            memo: (0, $d5e07fe2518aae94$exports.isSet)(object.memo) ? String(object.memo) : "",
            timeoutHeight: (0, $d5e07fe2518aae94$exports.isSet)(object.timeoutHeight) ? $d5e07fe2518aae94$exports.Long.fromValue(object.timeoutHeight) : $d5e07fe2518aae94$exports.Long.UZERO,
            extensionOptions: Array.isArray(object?.extensionOptions) ? object.extensionOptions.map((e)=>$64138e590dcf0cc1$exports.Any.fromJSON(e)) : [],
            nonCriticalExtensionOptions: Array.isArray(object?.nonCriticalExtensionOptions) ? object.nonCriticalExtensionOptions.map((e)=>$64138e590dcf0cc1$exports.Any.fromJSON(e)) : []
        };
    },
    toJSON (message) {
        const obj = {};
        if (message.messages) obj.messages = message.messages.map((e)=>e ? $64138e590dcf0cc1$exports.Any.toJSON(e) : undefined);
        else obj.messages = [];
        message.memo !== undefined && (obj.memo = message.memo);
        message.timeoutHeight !== undefined && (obj.timeoutHeight = (message.timeoutHeight || $d5e07fe2518aae94$exports.Long.UZERO).toString());
        if (message.extensionOptions) obj.extensionOptions = message.extensionOptions.map((e)=>e ? $64138e590dcf0cc1$exports.Any.toJSON(e) : undefined);
        else obj.extensionOptions = [];
        if (message.nonCriticalExtensionOptions) obj.nonCriticalExtensionOptions = message.nonCriticalExtensionOptions.map((e)=>e ? $64138e590dcf0cc1$exports.Any.toJSON(e) : undefined);
        else obj.nonCriticalExtensionOptions = [];
        return obj;
    },
    fromPartial (object) {
        const message = $eedf6d503be55212$var$createBaseTxBody();
        message.messages = object.messages?.map((e)=>$64138e590dcf0cc1$exports.Any.fromPartial(e)) || [];
        message.memo = object.memo ?? "";
        message.timeoutHeight = object.timeoutHeight !== undefined && object.timeoutHeight !== null ? $d5e07fe2518aae94$exports.Long.fromValue(object.timeoutHeight) : $d5e07fe2518aae94$exports.Long.UZERO;
        message.extensionOptions = object.extensionOptions?.map((e)=>$64138e590dcf0cc1$exports.Any.fromPartial(e)) || [];
        message.nonCriticalExtensionOptions = object.nonCriticalExtensionOptions?.map((e)=>$64138e590dcf0cc1$exports.Any.fromPartial(e)) || [];
        return message;
    }
};
function $eedf6d503be55212$var$createBaseAuthInfo() {
    return {
        signerInfos: [],
        fee: undefined,
        tip: undefined
    };
}
$eedf6d503be55212$exports.AuthInfo = {
    encode (message, writer = $eedf6d503be55212$var$_m0.Writer.create()) {
        for (const v of message.signerInfos)$eedf6d503be55212$exports.SignerInfo.encode(v, writer.uint32(10).fork()).ldelim();
        if (message.fee !== undefined) $eedf6d503be55212$exports.Fee.encode(message.fee, writer.uint32(18).fork()).ldelim();
        if (message.tip !== undefined) $eedf6d503be55212$exports.Tip.encode(message.tip, writer.uint32(26).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $eedf6d503be55212$var$_m0.Reader ? input : new $eedf6d503be55212$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $eedf6d503be55212$var$createBaseAuthInfo();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.signerInfos.push($eedf6d503be55212$exports.SignerInfo.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.fee = $eedf6d503be55212$exports.Fee.decode(reader, reader.uint32());
                    break;
                case 3:
                    message.tip = $eedf6d503be55212$exports.Tip.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            signerInfos: Array.isArray(object?.signerInfos) ? object.signerInfos.map((e)=>$eedf6d503be55212$exports.SignerInfo.fromJSON(e)) : [],
            fee: (0, $d5e07fe2518aae94$exports.isSet)(object.fee) ? $eedf6d503be55212$exports.Fee.fromJSON(object.fee) : undefined,
            tip: (0, $d5e07fe2518aae94$exports.isSet)(object.tip) ? $eedf6d503be55212$exports.Tip.fromJSON(object.tip) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        if (message.signerInfos) obj.signerInfos = message.signerInfos.map((e)=>e ? $eedf6d503be55212$exports.SignerInfo.toJSON(e) : undefined);
        else obj.signerInfos = [];
        message.fee !== undefined && (obj.fee = message.fee ? $eedf6d503be55212$exports.Fee.toJSON(message.fee) : undefined);
        message.tip !== undefined && (obj.tip = message.tip ? $eedf6d503be55212$exports.Tip.toJSON(message.tip) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $eedf6d503be55212$var$createBaseAuthInfo();
        message.signerInfos = object.signerInfos?.map((e)=>$eedf6d503be55212$exports.SignerInfo.fromPartial(e)) || [];
        message.fee = object.fee !== undefined && object.fee !== null ? $eedf6d503be55212$exports.Fee.fromPartial(object.fee) : undefined;
        message.tip = object.tip !== undefined && object.tip !== null ? $eedf6d503be55212$exports.Tip.fromPartial(object.tip) : undefined;
        return message;
    }
};
function $eedf6d503be55212$var$createBaseSignerInfo() {
    return {
        publicKey: undefined,
        modeInfo: undefined,
        sequence: $d5e07fe2518aae94$exports.Long.UZERO
    };
}
$eedf6d503be55212$exports.SignerInfo = {
    encode (message, writer = $eedf6d503be55212$var$_m0.Writer.create()) {
        if (message.publicKey !== undefined) $64138e590dcf0cc1$exports.Any.encode(message.publicKey, writer.uint32(10).fork()).ldelim();
        if (message.modeInfo !== undefined) $eedf6d503be55212$exports.ModeInfo.encode(message.modeInfo, writer.uint32(18).fork()).ldelim();
        if (!message.sequence.isZero()) writer.uint32(24).uint64(message.sequence);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $eedf6d503be55212$var$_m0.Reader ? input : new $eedf6d503be55212$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $eedf6d503be55212$var$createBaseSignerInfo();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.publicKey = $64138e590dcf0cc1$exports.Any.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.modeInfo = $eedf6d503be55212$exports.ModeInfo.decode(reader, reader.uint32());
                    break;
                case 3:
                    message.sequence = reader.uint64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            publicKey: (0, $d5e07fe2518aae94$exports.isSet)(object.publicKey) ? $64138e590dcf0cc1$exports.Any.fromJSON(object.publicKey) : undefined,
            modeInfo: (0, $d5e07fe2518aae94$exports.isSet)(object.modeInfo) ? $eedf6d503be55212$exports.ModeInfo.fromJSON(object.modeInfo) : undefined,
            sequence: (0, $d5e07fe2518aae94$exports.isSet)(object.sequence) ? $d5e07fe2518aae94$exports.Long.fromValue(object.sequence) : $d5e07fe2518aae94$exports.Long.UZERO
        };
    },
    toJSON (message) {
        const obj = {};
        message.publicKey !== undefined && (obj.publicKey = message.publicKey ? $64138e590dcf0cc1$exports.Any.toJSON(message.publicKey) : undefined);
        message.modeInfo !== undefined && (obj.modeInfo = message.modeInfo ? $eedf6d503be55212$exports.ModeInfo.toJSON(message.modeInfo) : undefined);
        message.sequence !== undefined && (obj.sequence = (message.sequence || $d5e07fe2518aae94$exports.Long.UZERO).toString());
        return obj;
    },
    fromPartial (object) {
        const message = $eedf6d503be55212$var$createBaseSignerInfo();
        message.publicKey = object.publicKey !== undefined && object.publicKey !== null ? $64138e590dcf0cc1$exports.Any.fromPartial(object.publicKey) : undefined;
        message.modeInfo = object.modeInfo !== undefined && object.modeInfo !== null ? $eedf6d503be55212$exports.ModeInfo.fromPartial(object.modeInfo) : undefined;
        message.sequence = object.sequence !== undefined && object.sequence !== null ? $d5e07fe2518aae94$exports.Long.fromValue(object.sequence) : $d5e07fe2518aae94$exports.Long.UZERO;
        return message;
    }
};
function $eedf6d503be55212$var$createBaseModeInfo() {
    return {
        single: undefined,
        multi: undefined
    };
}
$eedf6d503be55212$exports.ModeInfo = {
    encode (message, writer = $eedf6d503be55212$var$_m0.Writer.create()) {
        if (message.single !== undefined) $eedf6d503be55212$exports.ModeInfo_Single.encode(message.single, writer.uint32(10).fork()).ldelim();
        if (message.multi !== undefined) $eedf6d503be55212$exports.ModeInfo_Multi.encode(message.multi, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $eedf6d503be55212$var$_m0.Reader ? input : new $eedf6d503be55212$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $eedf6d503be55212$var$createBaseModeInfo();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.single = $eedf6d503be55212$exports.ModeInfo_Single.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.multi = $eedf6d503be55212$exports.ModeInfo_Multi.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            single: (0, $d5e07fe2518aae94$exports.isSet)(object.single) ? $eedf6d503be55212$exports.ModeInfo_Single.fromJSON(object.single) : undefined,
            multi: (0, $d5e07fe2518aae94$exports.isSet)(object.multi) ? $eedf6d503be55212$exports.ModeInfo_Multi.fromJSON(object.multi) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.single !== undefined && (obj.single = message.single ? $eedf6d503be55212$exports.ModeInfo_Single.toJSON(message.single) : undefined);
        message.multi !== undefined && (obj.multi = message.multi ? $eedf6d503be55212$exports.ModeInfo_Multi.toJSON(message.multi) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $eedf6d503be55212$var$createBaseModeInfo();
        message.single = object.single !== undefined && object.single !== null ? $eedf6d503be55212$exports.ModeInfo_Single.fromPartial(object.single) : undefined;
        message.multi = object.multi !== undefined && object.multi !== null ? $eedf6d503be55212$exports.ModeInfo_Multi.fromPartial(object.multi) : undefined;
        return message;
    }
};
function $eedf6d503be55212$var$createBaseModeInfo_Single() {
    return {
        mode: 0
    };
}
$eedf6d503be55212$exports.ModeInfo_Single = {
    encode (message, writer = $eedf6d503be55212$var$_m0.Writer.create()) {
        if (message.mode !== 0) writer.uint32(8).int32(message.mode);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $eedf6d503be55212$var$_m0.Reader ? input : new $eedf6d503be55212$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $eedf6d503be55212$var$createBaseModeInfo_Single();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.mode = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            mode: (0, $d5e07fe2518aae94$exports.isSet)(object.mode) ? (0, $cefef10ba181af21$exports.signModeFromJSON)(object.mode) : 0
        };
    },
    toJSON (message) {
        const obj = {};
        message.mode !== undefined && (obj.mode = (0, $cefef10ba181af21$exports.signModeToJSON)(message.mode));
        return obj;
    },
    fromPartial (object) {
        const message = $eedf6d503be55212$var$createBaseModeInfo_Single();
        message.mode = object.mode ?? 0;
        return message;
    }
};
function $eedf6d503be55212$var$createBaseModeInfo_Multi() {
    return {
        bitarray: undefined,
        modeInfos: []
    };
}
$eedf6d503be55212$exports.ModeInfo_Multi = {
    encode (message, writer = $eedf6d503be55212$var$_m0.Writer.create()) {
        if (message.bitarray !== undefined) $49dbfe0929da90f4$exports.CompactBitArray.encode(message.bitarray, writer.uint32(10).fork()).ldelim();
        for (const v of message.modeInfos)$eedf6d503be55212$exports.ModeInfo.encode(v, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $eedf6d503be55212$var$_m0.Reader ? input : new $eedf6d503be55212$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $eedf6d503be55212$var$createBaseModeInfo_Multi();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.bitarray = $49dbfe0929da90f4$exports.CompactBitArray.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.modeInfos.push($eedf6d503be55212$exports.ModeInfo.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            bitarray: (0, $d5e07fe2518aae94$exports.isSet)(object.bitarray) ? $49dbfe0929da90f4$exports.CompactBitArray.fromJSON(object.bitarray) : undefined,
            modeInfos: Array.isArray(object?.modeInfos) ? object.modeInfos.map((e)=>$eedf6d503be55212$exports.ModeInfo.fromJSON(e)) : []
        };
    },
    toJSON (message) {
        const obj = {};
        message.bitarray !== undefined && (obj.bitarray = message.bitarray ? $49dbfe0929da90f4$exports.CompactBitArray.toJSON(message.bitarray) : undefined);
        if (message.modeInfos) obj.modeInfos = message.modeInfos.map((e)=>e ? $eedf6d503be55212$exports.ModeInfo.toJSON(e) : undefined);
        else obj.modeInfos = [];
        return obj;
    },
    fromPartial (object) {
        const message = $eedf6d503be55212$var$createBaseModeInfo_Multi();
        message.bitarray = object.bitarray !== undefined && object.bitarray !== null ? $49dbfe0929da90f4$exports.CompactBitArray.fromPartial(object.bitarray) : undefined;
        message.modeInfos = object.modeInfos?.map((e)=>$eedf6d503be55212$exports.ModeInfo.fromPartial(e)) || [];
        return message;
    }
};
function $eedf6d503be55212$var$createBaseFee() {
    return {
        amount: [],
        gasLimit: $d5e07fe2518aae94$exports.Long.UZERO,
        payer: "",
        granter: ""
    };
}
$eedf6d503be55212$exports.Fee = {
    encode (message, writer = $eedf6d503be55212$var$_m0.Writer.create()) {
        for (const v of message.amount)$783dd8715fde0fcf$exports.Coin.encode(v, writer.uint32(10).fork()).ldelim();
        if (!message.gasLimit.isZero()) writer.uint32(16).uint64(message.gasLimit);
        if (message.payer !== "") writer.uint32(26).string(message.payer);
        if (message.granter !== "") writer.uint32(34).string(message.granter);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $eedf6d503be55212$var$_m0.Reader ? input : new $eedf6d503be55212$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $eedf6d503be55212$var$createBaseFee();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.amount.push($783dd8715fde0fcf$exports.Coin.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.gasLimit = reader.uint64();
                    break;
                case 3:
                    message.payer = reader.string();
                    break;
                case 4:
                    message.granter = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            amount: Array.isArray(object?.amount) ? object.amount.map((e)=>$783dd8715fde0fcf$exports.Coin.fromJSON(e)) : [],
            gasLimit: (0, $d5e07fe2518aae94$exports.isSet)(object.gasLimit) ? $d5e07fe2518aae94$exports.Long.fromValue(object.gasLimit) : $d5e07fe2518aae94$exports.Long.UZERO,
            payer: (0, $d5e07fe2518aae94$exports.isSet)(object.payer) ? String(object.payer) : "",
            granter: (0, $d5e07fe2518aae94$exports.isSet)(object.granter) ? String(object.granter) : ""
        };
    },
    toJSON (message) {
        const obj = {};
        if (message.amount) obj.amount = message.amount.map((e)=>e ? $783dd8715fde0fcf$exports.Coin.toJSON(e) : undefined);
        else obj.amount = [];
        message.gasLimit !== undefined && (obj.gasLimit = (message.gasLimit || $d5e07fe2518aae94$exports.Long.UZERO).toString());
        message.payer !== undefined && (obj.payer = message.payer);
        message.granter !== undefined && (obj.granter = message.granter);
        return obj;
    },
    fromPartial (object) {
        const message = $eedf6d503be55212$var$createBaseFee();
        message.amount = object.amount?.map((e)=>$783dd8715fde0fcf$exports.Coin.fromPartial(e)) || [];
        message.gasLimit = object.gasLimit !== undefined && object.gasLimit !== null ? $d5e07fe2518aae94$exports.Long.fromValue(object.gasLimit) : $d5e07fe2518aae94$exports.Long.UZERO;
        message.payer = object.payer ?? "";
        message.granter = object.granter ?? "";
        return message;
    }
};
function $eedf6d503be55212$var$createBaseTip() {
    return {
        amount: [],
        tipper: ""
    };
}
$eedf6d503be55212$exports.Tip = {
    encode (message, writer = $eedf6d503be55212$var$_m0.Writer.create()) {
        for (const v of message.amount)$783dd8715fde0fcf$exports.Coin.encode(v, writer.uint32(10).fork()).ldelim();
        if (message.tipper !== "") writer.uint32(18).string(message.tipper);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $eedf6d503be55212$var$_m0.Reader ? input : new $eedf6d503be55212$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $eedf6d503be55212$var$createBaseTip();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.amount.push($783dd8715fde0fcf$exports.Coin.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.tipper = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            amount: Array.isArray(object?.amount) ? object.amount.map((e)=>$783dd8715fde0fcf$exports.Coin.fromJSON(e)) : [],
            tipper: (0, $d5e07fe2518aae94$exports.isSet)(object.tipper) ? String(object.tipper) : ""
        };
    },
    toJSON (message) {
        const obj = {};
        if (message.amount) obj.amount = message.amount.map((e)=>e ? $783dd8715fde0fcf$exports.Coin.toJSON(e) : undefined);
        else obj.amount = [];
        message.tipper !== undefined && (obj.tipper = message.tipper);
        return obj;
    },
    fromPartial (object) {
        const message = $eedf6d503be55212$var$createBaseTip();
        message.amount = object.amount?.map((e)=>$783dd8715fde0fcf$exports.Coin.fromPartial(e)) || [];
        message.tipper = object.tipper ?? "";
        return message;
    }
};
function $eedf6d503be55212$var$createBaseAuxSignerData() {
    return {
        address: "",
        signDoc: undefined,
        mode: 0,
        sig: new Uint8Array()
    };
}
$eedf6d503be55212$exports.AuxSignerData = {
    encode (message, writer = $eedf6d503be55212$var$_m0.Writer.create()) {
        if (message.address !== "") writer.uint32(10).string(message.address);
        if (message.signDoc !== undefined) $eedf6d503be55212$exports.SignDocDirectAux.encode(message.signDoc, writer.uint32(18).fork()).ldelim();
        if (message.mode !== 0) writer.uint32(24).int32(message.mode);
        if (message.sig.length !== 0) writer.uint32(34).bytes(message.sig);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $eedf6d503be55212$var$_m0.Reader ? input : new $eedf6d503be55212$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $eedf6d503be55212$var$createBaseAuxSignerData();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.address = reader.string();
                    break;
                case 2:
                    message.signDoc = $eedf6d503be55212$exports.SignDocDirectAux.decode(reader, reader.uint32());
                    break;
                case 3:
                    message.mode = reader.int32();
                    break;
                case 4:
                    message.sig = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            address: (0, $d5e07fe2518aae94$exports.isSet)(object.address) ? String(object.address) : "",
            signDoc: (0, $d5e07fe2518aae94$exports.isSet)(object.signDoc) ? $eedf6d503be55212$exports.SignDocDirectAux.fromJSON(object.signDoc) : undefined,
            mode: (0, $d5e07fe2518aae94$exports.isSet)(object.mode) ? (0, $cefef10ba181af21$exports.signModeFromJSON)(object.mode) : 0,
            sig: (0, $d5e07fe2518aae94$exports.isSet)(object.sig) ? (0, $d5e07fe2518aae94$exports.bytesFromBase64)(object.sig) : new Uint8Array()
        };
    },
    toJSON (message) {
        const obj = {};
        message.address !== undefined && (obj.address = message.address);
        message.signDoc !== undefined && (obj.signDoc = message.signDoc ? $eedf6d503be55212$exports.SignDocDirectAux.toJSON(message.signDoc) : undefined);
        message.mode !== undefined && (obj.mode = (0, $cefef10ba181af21$exports.signModeToJSON)(message.mode));
        message.sig !== undefined && (obj.sig = (0, $d5e07fe2518aae94$exports.base64FromBytes)(message.sig !== undefined ? message.sig : new Uint8Array()));
        return obj;
    },
    fromPartial (object) {
        const message = $eedf6d503be55212$var$createBaseAuxSignerData();
        message.address = object.address ?? "";
        message.signDoc = object.signDoc !== undefined && object.signDoc !== null ? $eedf6d503be55212$exports.SignDocDirectAux.fromPartial(object.signDoc) : undefined;
        message.mode = object.mode ?? 0;
        message.sig = object.sig ?? new Uint8Array();
        return message;
    }
};


/**
 * Takes a serialized TxRaw (the bytes stored in Tendermint) and decodes it into something usable.
 */ function $c08ee0c877bbf0d6$var$decodeTxRaw(tx) {
    const txRaw = $eedf6d503be55212$exports.TxRaw.decode(tx);
    return {
        authInfo: $eedf6d503be55212$exports.AuthInfo.decode(txRaw.authInfoBytes),
        body: $eedf6d503be55212$exports.TxBody.decode(txRaw.bodyBytes),
        signatures: txRaw.signatures
    };
}
$c08ee0c877bbf0d6$exports.decodeTxRaw = $c08ee0c877bbf0d6$var$decodeTxRaw;


Object.defineProperty($c0a9381c50e8ee56$exports, "decodeTxRaw", {
    enumerable: true,
    get: function() {
        return $c08ee0c877bbf0d6$exports.decodeTxRaw;
    }
});
var $e2709248318d325a$exports = {};
"use strict";
Object.defineProperty($e2709248318d325a$exports, "__esModule", {
    value: true
});
$e2709248318d325a$exports.DirectSecp256k1HdWallet = $e2709248318d325a$exports.extractKdfConfiguration = void 0;
var $6078e8ec636191fb$exports = {};
"use strict";
Object.defineProperty($6078e8ec636191fb$exports, "__esModule", {
    value: true
});
$6078e8ec636191fb$exports.executeKdf = $6078e8ec636191fb$exports.makeStdTx = $6078e8ec636191fb$exports.isStdTx = $6078e8ec636191fb$exports.serializeSignDoc = $6078e8ec636191fb$exports.makeSignDoc = $6078e8ec636191fb$exports.encodeSecp256k1Signature = $6078e8ec636191fb$exports.decodeSignature = $6078e8ec636191fb$exports.Secp256k1Wallet = $6078e8ec636191fb$exports.Secp256k1HdWallet = $6078e8ec636191fb$exports.extractKdfConfiguration = $6078e8ec636191fb$exports.pubkeyType = $6078e8ec636191fb$exports.isSinglePubkey = $6078e8ec636191fb$exports.isSecp256k1Pubkey = $6078e8ec636191fb$exports.isMultisigThresholdPubkey = $6078e8ec636191fb$exports.isEd25519Pubkey = $6078e8ec636191fb$exports.makeCosmoshubPath = $6078e8ec636191fb$exports.createMultisigThresholdPubkey = $6078e8ec636191fb$exports.encodeSecp256k1Pubkey = $6078e8ec636191fb$exports.encodeEd25519Pubkey = $6078e8ec636191fb$exports.encodeBech32Pubkey = $6078e8ec636191fb$exports.encodeAminoPubkey = $6078e8ec636191fb$exports.decodeBech32Pubkey = $6078e8ec636191fb$exports.decodeAminoPubkey = $6078e8ec636191fb$exports.parseCoins = $6078e8ec636191fb$exports.coins = $6078e8ec636191fb$exports.coin = $6078e8ec636191fb$exports.addCoins = $6078e8ec636191fb$exports.rawSecp256k1PubkeyToRawAddress = $6078e8ec636191fb$exports.rawEd25519PubkeyToRawAddress = $6078e8ec636191fb$exports.pubkeyToRawAddress = $6078e8ec636191fb$exports.pubkeyToAddress = void 0;
var $4e7d0e4795298bde$exports = {};
"use strict";
// See https://github.com/tendermint/tendermint/blob/f2ada0a604b4c0763bda2f64fac53d506d3beca7/docs/spec/blockchain/encoding.md#public-key-cryptography
Object.defineProperty($4e7d0e4795298bde$exports, "__esModule", {
    value: true
});
$4e7d0e4795298bde$exports.pubkeyToAddress = $4e7d0e4795298bde$exports.pubkeyToRawAddress = $4e7d0e4795298bde$exports.rawSecp256k1PubkeyToRawAddress = $4e7d0e4795298bde$exports.rawEd25519PubkeyToRawAddress = void 0;

var $6f1ux = parcelRequire("6f1ux");

var $6XcLW = parcelRequire("6XcLW");
var $ae2e33ef639c9d04$exports = {};
"use strict";
Object.defineProperty($ae2e33ef639c9d04$exports, "__esModule", {
    value: true
});
$ae2e33ef639c9d04$exports.encodeBech32Pubkey = $ae2e33ef639c9d04$exports.encodeAminoPubkey = $ae2e33ef639c9d04$exports.decodeBech32Pubkey = $ae2e33ef639c9d04$exports.decodeAminoPubkey = $ae2e33ef639c9d04$exports.encodeEd25519Pubkey = $ae2e33ef639c9d04$exports.encodeSecp256k1Pubkey = void 0;

var $6XcLW = parcelRequire("6XcLW");

var $7UsfE = parcelRequire("7UsfE");

var $fZwG5 = parcelRequire("fZwG5");
var $b86afde31632bfcc$exports = {};
"use strict";
Object.defineProperty($b86afde31632bfcc$exports, "__esModule", {
    value: true
});
$b86afde31632bfcc$exports.isMultisigThresholdPubkey = $b86afde31632bfcc$exports.isSinglePubkey = $b86afde31632bfcc$exports.pubkeyType = $b86afde31632bfcc$exports.isSecp256k1Pubkey = $b86afde31632bfcc$exports.isEd25519Pubkey = void 0;
function $b86afde31632bfcc$var$isEd25519Pubkey(pubkey) {
    return pubkey.type === "tendermint/PubKeyEd25519";
}
$b86afde31632bfcc$exports.isEd25519Pubkey = $b86afde31632bfcc$var$isEd25519Pubkey;
function $b86afde31632bfcc$var$isSecp256k1Pubkey(pubkey) {
    return pubkey.type === "tendermint/PubKeySecp256k1";
}
$b86afde31632bfcc$exports.isSecp256k1Pubkey = $b86afde31632bfcc$var$isSecp256k1Pubkey;
$b86afde31632bfcc$exports.pubkeyType = {
    /** @see https://github.com/tendermint/tendermint/blob/v0.33.0/crypto/ed25519/ed25519.go#L22 */ secp256k1: "tendermint/PubKeySecp256k1",
    /** @see https://github.com/tendermint/tendermint/blob/v0.33.0/crypto/secp256k1/secp256k1.go#L23 */ ed25519: "tendermint/PubKeyEd25519",
    /** @see https://github.com/tendermint/tendermint/blob/v0.33.0/crypto/sr25519/codec.go#L12 */ sr25519: "tendermint/PubKeySr25519",
    multisigThreshold: "tendermint/PubKeyMultisigThreshold"
};
function $b86afde31632bfcc$var$isSinglePubkey(pubkey) {
    const singPubkeyTypes = [
        $b86afde31632bfcc$exports.pubkeyType.ed25519,
        $b86afde31632bfcc$exports.pubkeyType.secp256k1,
        $b86afde31632bfcc$exports.pubkeyType.sr25519
    ];
    return singPubkeyTypes.includes(pubkey.type);
}
$b86afde31632bfcc$exports.isSinglePubkey = $b86afde31632bfcc$var$isSinglePubkey;
function $b86afde31632bfcc$var$isMultisigThresholdPubkey(pubkey) {
    return pubkey.type === "tendermint/PubKeyMultisigThreshold";
}
$b86afde31632bfcc$exports.isMultisigThresholdPubkey = $b86afde31632bfcc$var$isMultisigThresholdPubkey;


/**
 * Takes a Secp256k1 public key as raw bytes and returns the Amino JSON
 * representation of it (the type/value wrapper object).
 */ function $ae2e33ef639c9d04$var$encodeSecp256k1Pubkey(pubkey) {
    if (pubkey.length !== 33 || pubkey[0] !== 0x02 && pubkey[0] !== 0x03) throw new Error("Public key must be compressed secp256k1, i.e. 33 bytes starting with 0x02 or 0x03");
    return {
        type: $b86afde31632bfcc$exports.pubkeyType.secp256k1,
        value: (0, $6XcLW.toBase64)(pubkey)
    };
}
$ae2e33ef639c9d04$exports.encodeSecp256k1Pubkey = $ae2e33ef639c9d04$var$encodeSecp256k1Pubkey;
/**
 * Takes an Edd25519 public key as raw bytes and returns the Amino JSON
 * representation of it (the type/value wrapper object).
 */ function $ae2e33ef639c9d04$var$encodeEd25519Pubkey(pubkey) {
    if (pubkey.length !== 32) throw new Error("Ed25519 public key must be 32 bytes long");
    return {
        type: $b86afde31632bfcc$exports.pubkeyType.ed25519,
        value: (0, $6XcLW.toBase64)(pubkey)
    };
}
$ae2e33ef639c9d04$exports.encodeEd25519Pubkey = $ae2e33ef639c9d04$var$encodeEd25519Pubkey;
// As discussed in https://github.com/binance-chain/javascript-sdk/issues/163
// Prefixes listed here: https://github.com/tendermint/tendermint/blob/d419fffe18531317c28c29a292ad7d253f6cafdf/docs/spec/blockchain/encoding.md#public-key-cryptography
// Last bytes is varint-encoded length prefix
const $ae2e33ef639c9d04$var$pubkeyAminoPrefixSecp256k1 = (0, $6XcLW.fromHex)("eb5ae98721" /* fixed length */ );
const $ae2e33ef639c9d04$var$pubkeyAminoPrefixEd25519 = (0, $6XcLW.fromHex)("1624de6420" /* fixed length */ );
const $ae2e33ef639c9d04$var$pubkeyAminoPrefixSr25519 = (0, $6XcLW.fromHex)("0dfb100520" /* fixed length */ );
/** See https://github.com/tendermint/tendermint/commit/38b401657e4ad7a7eeb3c30a3cbf512037df3740 */ const $ae2e33ef639c9d04$var$pubkeyAminoPrefixMultisigThreshold = (0, $6XcLW.fromHex)("22c1f7e2" /* variable length not included */ );
/**
 * Decodes a pubkey in the Amino binary format to a type/value object.
 */ function $ae2e33ef639c9d04$var$decodeAminoPubkey(data) {
    if ((0, $fZwG5.arrayContentStartsWith)(data, $ae2e33ef639c9d04$var$pubkeyAminoPrefixSecp256k1)) {
        const rest = data.slice($ae2e33ef639c9d04$var$pubkeyAminoPrefixSecp256k1.length);
        if (rest.length !== 33) throw new Error("Invalid rest data length. Expected 33 bytes (compressed secp256k1 pubkey).");
        return {
            type: $b86afde31632bfcc$exports.pubkeyType.secp256k1,
            value: (0, $6XcLW.toBase64)(rest)
        };
    } else if ((0, $fZwG5.arrayContentStartsWith)(data, $ae2e33ef639c9d04$var$pubkeyAminoPrefixEd25519)) {
        const rest = data.slice($ae2e33ef639c9d04$var$pubkeyAminoPrefixEd25519.length);
        if (rest.length !== 32) throw new Error("Invalid rest data length. Expected 32 bytes (Ed25519 pubkey).");
        return {
            type: $b86afde31632bfcc$exports.pubkeyType.ed25519,
            value: (0, $6XcLW.toBase64)(rest)
        };
    } else if ((0, $fZwG5.arrayContentStartsWith)(data, $ae2e33ef639c9d04$var$pubkeyAminoPrefixSr25519)) {
        const rest = data.slice($ae2e33ef639c9d04$var$pubkeyAminoPrefixSr25519.length);
        if (rest.length !== 32) throw new Error("Invalid rest data length. Expected 32 bytes (Sr25519 pubkey).");
        return {
            type: $b86afde31632bfcc$exports.pubkeyType.sr25519,
            value: (0, $6XcLW.toBase64)(rest)
        };
    } else if ((0, $fZwG5.arrayContentStartsWith)(data, $ae2e33ef639c9d04$var$pubkeyAminoPrefixMultisigThreshold)) // eslint-disable-next-line @typescript-eslint/no-use-before-define
    return $ae2e33ef639c9d04$var$decodeMultisigPubkey(data);
    else throw new Error("Unsupported public key type. Amino data starts with: " + (0, $6XcLW.toHex)(data.slice(0, 5)));
}
$ae2e33ef639c9d04$exports.decodeAminoPubkey = $ae2e33ef639c9d04$var$decodeAminoPubkey;
/**
 * Decodes a bech32 pubkey to Amino binary, which is then decoded to a type/value object.
 * The bech32 prefix is ignored and discareded.
 *
 * @param bechEncoded the bech32 encoded pubkey
 */ function $ae2e33ef639c9d04$var$decodeBech32Pubkey(bechEncoded) {
    const { data: data } = (0, $6XcLW.fromBech32)(bechEncoded);
    return $ae2e33ef639c9d04$var$decodeAminoPubkey(data);
}
$ae2e33ef639c9d04$exports.decodeBech32Pubkey = $ae2e33ef639c9d04$var$decodeBech32Pubkey;
/**
 * Uvarint decoder for Amino.
 * @see https://github.com/tendermint/go-amino/blob/8e779b71f40d175/decoder.go#L64-76
 * @returns varint as number, and bytes count occupied by varaint
 */ function $ae2e33ef639c9d04$var$decodeUvarint(reader) {
    if (reader.length < 1) throw new Error("Can't decode varint. EOF");
    if (reader[0] > 127) throw new Error("Decoding numbers > 127 is not supported here. Please tell those lazy CosmJS maintainers to port the binary.Varint implementation from the Go standard library and write some tests.");
    return [
        reader[0],
        1
    ];
}
/**
 * Decodes a multisig pubkey to type object.
 * Pubkey structure [ prefix + const + threshold + loop:(const + pubkeyLength + pubkey            ) ]
 *                  [   4b   + 1b    +  varint   + loop:(1b    +    varint    + pubkeyLength bytes) ]
 * @param data encoded pubkey
 */ function $ae2e33ef639c9d04$var$decodeMultisigPubkey(data) {
    const reader = Array.from(data);
    // remove multisig amino prefix;
    const prefixFromReader = reader.splice(0, $ae2e33ef639c9d04$var$pubkeyAminoPrefixMultisigThreshold.length);
    if (!(0, $fZwG5.arrayContentStartsWith)(prefixFromReader, $ae2e33ef639c9d04$var$pubkeyAminoPrefixMultisigThreshold)) throw new Error("Invalid multisig prefix.");
    // remove 0x08 threshold prefix;
    if (reader.shift() != 0x08) throw new Error("Invalid multisig data. Expecting 0x08 prefix before threshold.");
    // read threshold
    const [threshold, thresholdBytesLength] = $ae2e33ef639c9d04$var$decodeUvarint(reader);
    reader.splice(0, thresholdBytesLength);
    // read participants pubkeys
    const pubkeys = [];
    while(reader.length > 0){
        // remove 0x12 threshold prefix;
        if (reader.shift() != 0x12) throw new Error("Invalid multisig data. Expecting 0x12 prefix before participant pubkey length.");
        // read pubkey length
        const [pubkeyLength, pubkeyLengthBytesSize] = $ae2e33ef639c9d04$var$decodeUvarint(reader);
        reader.splice(0, pubkeyLengthBytesSize);
        // verify that we can read pubkey
        if (reader.length < pubkeyLength) throw new Error("Invalid multisig data length.");
        // read and decode participant pubkey
        const encodedPubkey = reader.splice(0, pubkeyLength);
        const pubkey = $ae2e33ef639c9d04$var$decodeAminoPubkey(Uint8Array.from(encodedPubkey));
        pubkeys.push(pubkey);
    }
    return {
        type: $b86afde31632bfcc$exports.pubkeyType.multisigThreshold,
        value: {
            threshold: threshold.toString(),
            pubkeys: pubkeys
        }
    };
}
/**
 * Uvarint encoder for Amino. This is the same encoding as `binary.PutUvarint` from the Go
 * standard library.
 *
 * @see https://github.com/tendermint/go-amino/blob/8e779b71f40d175/encoder.go#L77-L85
 */ function $ae2e33ef639c9d04$var$encodeUvarint(value) {
    const checked = $7UsfE.Uint53.fromString(value.toString()).toNumber();
    if (checked > 127) throw new Error("Encoding numbers > 127 is not supported here. Please tell those lazy CosmJS maintainers to port the binary.PutUvarint implementation from the Go standard library and write some tests.");
    return [
        checked
    ];
}
/**
 * Encodes a public key to binary Amino.
 */ function $ae2e33ef639c9d04$var$encodeAminoPubkey(pubkey) {
    if ((0, $b86afde31632bfcc$exports.isMultisigThresholdPubkey)(pubkey)) {
        const out = Array.from($ae2e33ef639c9d04$var$pubkeyAminoPrefixMultisigThreshold);
        out.push(0x08); // TODO: What is this?
        out.push(...$ae2e33ef639c9d04$var$encodeUvarint(pubkey.value.threshold));
        for (const pubkeyData of pubkey.value.pubkeys.map((p)=>$ae2e33ef639c9d04$var$encodeAminoPubkey(p))){
            out.push(0x12); // TODO: What is this?
            out.push(...$ae2e33ef639c9d04$var$encodeUvarint(pubkeyData.length));
            out.push(...pubkeyData);
        }
        return new Uint8Array(out);
    } else if ((0, $b86afde31632bfcc$exports.isEd25519Pubkey)(pubkey)) return new Uint8Array([
        ...$ae2e33ef639c9d04$var$pubkeyAminoPrefixEd25519,
        ...(0, $6XcLW.fromBase64)(pubkey.value)
    ]);
    else if ((0, $b86afde31632bfcc$exports.isSecp256k1Pubkey)(pubkey)) return new Uint8Array([
        ...$ae2e33ef639c9d04$var$pubkeyAminoPrefixSecp256k1,
        ...(0, $6XcLW.fromBase64)(pubkey.value)
    ]);
    else throw new Error("Unsupported pubkey type");
}
$ae2e33ef639c9d04$exports.encodeAminoPubkey = $ae2e33ef639c9d04$var$encodeAminoPubkey;
/**
 * Encodes a public key to binary Amino and then to bech32.
 *
 * @param pubkey the public key to encode
 * @param prefix the bech32 prefix (human readable part)
 */ function $ae2e33ef639c9d04$var$encodeBech32Pubkey(pubkey, prefix) {
    return (0, $6XcLW.toBech32)(prefix, $ae2e33ef639c9d04$var$encodeAminoPubkey(pubkey));
}
$ae2e33ef639c9d04$exports.encodeBech32Pubkey = $ae2e33ef639c9d04$var$encodeBech32Pubkey;



function $4e7d0e4795298bde$var$rawEd25519PubkeyToRawAddress(pubkeyData) {
    if (pubkeyData.length !== 32) throw new Error(`Invalid Ed25519 pubkey length: ${pubkeyData.length}`);
    return (0, $6f1ux.sha256)(pubkeyData).slice(0, 20);
}
$4e7d0e4795298bde$exports.rawEd25519PubkeyToRawAddress = $4e7d0e4795298bde$var$rawEd25519PubkeyToRawAddress;
function $4e7d0e4795298bde$var$rawSecp256k1PubkeyToRawAddress(pubkeyData) {
    if (pubkeyData.length !== 33) throw new Error(`Invalid Secp256k1 pubkey length (compressed): ${pubkeyData.length}`);
    return (0, $6f1ux.ripemd160)((0, $6f1ux.sha256)(pubkeyData));
}
$4e7d0e4795298bde$exports.rawSecp256k1PubkeyToRawAddress = $4e7d0e4795298bde$var$rawSecp256k1PubkeyToRawAddress;
// For secp256k1 this assumes we already have a compressed pubkey.
function $4e7d0e4795298bde$var$pubkeyToRawAddress(pubkey) {
    if ((0, $b86afde31632bfcc$exports.isSecp256k1Pubkey)(pubkey)) {
        const pubkeyData = (0, $6XcLW.fromBase64)(pubkey.value);
        return $4e7d0e4795298bde$var$rawSecp256k1PubkeyToRawAddress(pubkeyData);
    } else if ((0, $b86afde31632bfcc$exports.isEd25519Pubkey)(pubkey)) {
        const pubkeyData = (0, $6XcLW.fromBase64)(pubkey.value);
        return $4e7d0e4795298bde$var$rawEd25519PubkeyToRawAddress(pubkeyData);
    } else if ((0, $b86afde31632bfcc$exports.isMultisigThresholdPubkey)(pubkey)) {
        // https://github.com/tendermint/tendermint/blob/38b401657e4ad7a7eeb3c30a3cbf512037df3740/crypto/multisig/threshold_pubkey.go#L71-L74
        const pubkeyData = (0, $ae2e33ef639c9d04$exports.encodeAminoPubkey)(pubkey);
        return (0, $6f1ux.sha256)(pubkeyData).slice(0, 20);
    } else throw new Error("Unsupported public key type");
}
$4e7d0e4795298bde$exports.pubkeyToRawAddress = $4e7d0e4795298bde$var$pubkeyToRawAddress;
function $4e7d0e4795298bde$var$pubkeyToAddress(pubkey, prefix) {
    return (0, $6XcLW.toBech32)(prefix, $4e7d0e4795298bde$var$pubkeyToRawAddress(pubkey));
}
$4e7d0e4795298bde$exports.pubkeyToAddress = $4e7d0e4795298bde$var$pubkeyToAddress;


Object.defineProperty($6078e8ec636191fb$exports, "pubkeyToAddress", {
    enumerable: true,
    get: function() {
        return $4e7d0e4795298bde$exports.pubkeyToAddress;
    }
});
Object.defineProperty($6078e8ec636191fb$exports, "pubkeyToRawAddress", {
    enumerable: true,
    get: function() {
        return $4e7d0e4795298bde$exports.pubkeyToRawAddress;
    }
});
Object.defineProperty($6078e8ec636191fb$exports, "rawEd25519PubkeyToRawAddress", {
    enumerable: true,
    get: function() {
        return $4e7d0e4795298bde$exports.rawEd25519PubkeyToRawAddress;
    }
});
Object.defineProperty($6078e8ec636191fb$exports, "rawSecp256k1PubkeyToRawAddress", {
    enumerable: true,
    get: function() {
        return $4e7d0e4795298bde$exports.rawSecp256k1PubkeyToRawAddress;
    }
});
var $cde6671a8cf6093b$exports = {};
"use strict";
Object.defineProperty($cde6671a8cf6093b$exports, "__esModule", {
    value: true
});
$cde6671a8cf6093b$exports.addCoins = $cde6671a8cf6093b$exports.parseCoins = $cde6671a8cf6093b$exports.coins = $cde6671a8cf6093b$exports.coin = void 0;

var $7UsfE = parcelRequire("7UsfE");
/**
 * Creates a coin.
 *
 * If your values do not exceed the safe integer range of JS numbers (53 bit),
 * you can use the number type here. This is the case for all typical Cosmos SDK
 * chains that use the default 6 decimals.
 *
 * In case you need to supportr larger values, use unsigned integer strings instead.
 */ function $cde6671a8cf6093b$var$coin(amount, denom) {
    let outAmount;
    if (typeof amount === "number") try {
        outAmount = new $7UsfE.Uint53(amount).toString();
    } catch (_err) {
        throw new Error("Given amount is not a safe integer. Consider using a string instead to overcome the limitations of JS numbers.");
    }
    else {
        if (!amount.match(/^[0-9]+$/)) throw new Error("Invalid unsigned integer string format");
        outAmount = amount.replace(/^0*/, "") || "0";
    }
    return {
        amount: outAmount,
        denom: denom
    };
}
$cde6671a8cf6093b$exports.coin = $cde6671a8cf6093b$var$coin;
/**
 * Creates a list of coins with one element.
 */ function $cde6671a8cf6093b$var$coins(amount, denom) {
    return [
        $cde6671a8cf6093b$var$coin(amount, denom)
    ];
}
$cde6671a8cf6093b$exports.coins = $cde6671a8cf6093b$var$coins;
/**
 * Takes a coins list like "819966000ucosm,700000000ustake" and parses it.
 *
 * A Stargate-ready variant of this function is available via:
 *
 * ```
 * import { parseCoins } from "@cosmjs/proto-signing";
 * // or
 * import { parseCoins } from "@cosmjs/stargate";
 * ```
 */ function $cde6671a8cf6093b$var$parseCoins(input) {
    return input.replace(/\s/g, "").split(",").filter(Boolean).map((part)=>{
        const match = part.match(/^([0-9]+)([a-zA-Z]+)/);
        if (!match) throw new Error("Got an invalid coin string");
        return {
            amount: match[1].replace(/^0+/, "") || "0",
            denom: match[2]
        };
    });
}
$cde6671a8cf6093b$exports.parseCoins = $cde6671a8cf6093b$var$parseCoins;
/**
 * Function to sum up coins with type Coin
 */ function $cde6671a8cf6093b$var$addCoins(lhs, rhs) {
    if (lhs.denom !== rhs.denom) throw new Error("Trying to add two coins with different denoms");
    return {
        amount: $7UsfE.Decimal.fromAtomics(lhs.amount, 0).plus($7UsfE.Decimal.fromAtomics(rhs.amount, 0)).atomics,
        denom: lhs.denom
    };
}
$cde6671a8cf6093b$exports.addCoins = $cde6671a8cf6093b$var$addCoins;


Object.defineProperty($6078e8ec636191fb$exports, "addCoins", {
    enumerable: true,
    get: function() {
        return $cde6671a8cf6093b$exports.addCoins;
    }
});
Object.defineProperty($6078e8ec636191fb$exports, "coin", {
    enumerable: true,
    get: function() {
        return $cde6671a8cf6093b$exports.coin;
    }
});
Object.defineProperty($6078e8ec636191fb$exports, "coins", {
    enumerable: true,
    get: function() {
        return $cde6671a8cf6093b$exports.coins;
    }
});
Object.defineProperty($6078e8ec636191fb$exports, "parseCoins", {
    enumerable: true,
    get: function() {
        return $cde6671a8cf6093b$exports.parseCoins;
    }
});

Object.defineProperty($6078e8ec636191fb$exports, "decodeAminoPubkey", {
    enumerable: true,
    get: function() {
        return $ae2e33ef639c9d04$exports.decodeAminoPubkey;
    }
});
Object.defineProperty($6078e8ec636191fb$exports, "decodeBech32Pubkey", {
    enumerable: true,
    get: function() {
        return $ae2e33ef639c9d04$exports.decodeBech32Pubkey;
    }
});
Object.defineProperty($6078e8ec636191fb$exports, "encodeAminoPubkey", {
    enumerable: true,
    get: function() {
        return $ae2e33ef639c9d04$exports.encodeAminoPubkey;
    }
});
Object.defineProperty($6078e8ec636191fb$exports, "encodeBech32Pubkey", {
    enumerable: true,
    get: function() {
        return $ae2e33ef639c9d04$exports.encodeBech32Pubkey;
    }
});
Object.defineProperty($6078e8ec636191fb$exports, "encodeEd25519Pubkey", {
    enumerable: true,
    get: function() {
        return $ae2e33ef639c9d04$exports.encodeEd25519Pubkey;
    }
});
Object.defineProperty($6078e8ec636191fb$exports, "encodeSecp256k1Pubkey", {
    enumerable: true,
    get: function() {
        return $ae2e33ef639c9d04$exports.encodeSecp256k1Pubkey;
    }
});
var $561ffe9f81d48760$exports = {};
"use strict";
Object.defineProperty($561ffe9f81d48760$exports, "__esModule", {
    value: true
});
$561ffe9f81d48760$exports.createMultisigThresholdPubkey = $561ffe9f81d48760$exports.compareArrays = void 0;

var $6XcLW = parcelRequire("6XcLW");

var $7UsfE = parcelRequire("7UsfE");

/**
 * Compare arrays lexicographically.
 *
 * Returns value < 0 if `a < b`.
 * Returns value > 0 if `a > b`.
 * Returns 0 if `a === b`.
 */ function $561ffe9f81d48760$var$compareArrays(a, b) {
    const aHex = (0, $6XcLW.toHex)(a);
    const bHex = (0, $6XcLW.toHex)(b);
    return aHex === bHex ? 0 : aHex < bHex ? -1 : 1;
}
$561ffe9f81d48760$exports.compareArrays = $561ffe9f81d48760$var$compareArrays;
function $561ffe9f81d48760$var$createMultisigThresholdPubkey(pubkeys, threshold, nosort = false) {
    const uintThreshold = new $7UsfE.Uint53(threshold);
    if (uintThreshold.toNumber() > pubkeys.length) throw new Error(`Threshold k = ${uintThreshold.toNumber()} exceeds number of keys n = ${pubkeys.length}`);
    const outPubkeys = nosort ? pubkeys : Array.from(pubkeys).sort((lhs, rhs)=>{
        // https://github.com/cosmos/cosmos-sdk/blob/v0.42.2/client/keys/add.go#L172-L174
        const addressLhs = (0, $4e7d0e4795298bde$exports.pubkeyToRawAddress)(lhs);
        const addressRhs = (0, $4e7d0e4795298bde$exports.pubkeyToRawAddress)(rhs);
        return $561ffe9f81d48760$var$compareArrays(addressLhs, addressRhs);
    });
    return {
        type: "tendermint/PubKeyMultisigThreshold",
        value: {
            threshold: uintThreshold.toString(),
            pubkeys: outPubkeys
        }
    };
}
$561ffe9f81d48760$exports.createMultisigThresholdPubkey = $561ffe9f81d48760$var$createMultisigThresholdPubkey;


Object.defineProperty($6078e8ec636191fb$exports, "createMultisigThresholdPubkey", {
    enumerable: true,
    get: function() {
        return $561ffe9f81d48760$exports.createMultisigThresholdPubkey;
    }
});
var $26c6be321d4f0223$exports = {};
"use strict";
Object.defineProperty($26c6be321d4f0223$exports, "__esModule", {
    value: true
});
$26c6be321d4f0223$exports.makeCosmoshubPath = void 0;

var $6f1ux = parcelRequire("6f1ux");
/**
 * The Cosmos Hub derivation path in the form `m/44'/118'/0'/0/a`
 * with 0-based account index `a`.
 */ function $26c6be321d4f0223$var$makeCosmoshubPath(a) {
    return [
        $6f1ux.Slip10RawIndex.hardened(44),
        $6f1ux.Slip10RawIndex.hardened(118),
        $6f1ux.Slip10RawIndex.hardened(0),
        $6f1ux.Slip10RawIndex.normal(0),
        $6f1ux.Slip10RawIndex.normal(a)
    ];
}
$26c6be321d4f0223$exports.makeCosmoshubPath = $26c6be321d4f0223$var$makeCosmoshubPath;


Object.defineProperty($6078e8ec636191fb$exports, "makeCosmoshubPath", {
    enumerable: true,
    get: function() {
        return $26c6be321d4f0223$exports.makeCosmoshubPath;
    }
});

Object.defineProperty($6078e8ec636191fb$exports, "isEd25519Pubkey", {
    enumerable: true,
    get: function() {
        return $b86afde31632bfcc$exports.isEd25519Pubkey;
    }
});
Object.defineProperty($6078e8ec636191fb$exports, "isMultisigThresholdPubkey", {
    enumerable: true,
    get: function() {
        return $b86afde31632bfcc$exports.isMultisigThresholdPubkey;
    }
});
Object.defineProperty($6078e8ec636191fb$exports, "isSecp256k1Pubkey", {
    enumerable: true,
    get: function() {
        return $b86afde31632bfcc$exports.isSecp256k1Pubkey;
    }
});
Object.defineProperty($6078e8ec636191fb$exports, "isSinglePubkey", {
    enumerable: true,
    get: function() {
        return $b86afde31632bfcc$exports.isSinglePubkey;
    }
});
Object.defineProperty($6078e8ec636191fb$exports, "pubkeyType", {
    enumerable: true,
    get: function() {
        return $b86afde31632bfcc$exports.pubkeyType;
    }
});
var $ef907aac4476815c$exports = {};
"use strict";
Object.defineProperty($ef907aac4476815c$exports, "__esModule", {
    value: true
});
$ef907aac4476815c$exports.Secp256k1HdWallet = $ef907aac4476815c$exports.extractKdfConfiguration = void 0;

var $6f1ux = parcelRequire("6f1ux");

var $6XcLW = parcelRequire("6XcLW");

var $fZwG5 = parcelRequire("fZwG5");


var $803b41bf0d7712c7$exports = {};
"use strict";
Object.defineProperty($803b41bf0d7712c7$exports, "__esModule", {
    value: true
});
$803b41bf0d7712c7$exports.decodeSignature = $803b41bf0d7712c7$exports.encodeSecp256k1Signature = void 0;

var $6XcLW = parcelRequire("6XcLW");


/**
 * Takes a binary pubkey and signature to create a signature object
 *
 * @param pubkey a compressed secp256k1 public key
 * @param signature a 64 byte fixed length representation of secp256k1 signature components r and s
 */ function $803b41bf0d7712c7$var$encodeSecp256k1Signature(pubkey, signature) {
    if (signature.length !== 64) throw new Error("Signature must be 64 bytes long. Cosmos SDK uses a 2x32 byte fixed length encoding for the secp256k1 signature integers r and s.");
    return {
        pub_key: (0, $ae2e33ef639c9d04$exports.encodeSecp256k1Pubkey)(pubkey),
        signature: (0, $6XcLW.toBase64)(signature)
    };
}
$803b41bf0d7712c7$exports.encodeSecp256k1Signature = $803b41bf0d7712c7$var$encodeSecp256k1Signature;
function $803b41bf0d7712c7$var$decodeSignature(signature) {
    switch(signature.pub_key.type){
        // Note: please don't add cases here without writing additional unit tests
        case $b86afde31632bfcc$exports.pubkeyType.secp256k1:
            return {
                pubkey: (0, $6XcLW.fromBase64)(signature.pub_key.value),
                signature: (0, $6XcLW.fromBase64)(signature.signature)
            };
        default:
            throw new Error("Unsupported pubkey type");
    }
}
$803b41bf0d7712c7$exports.decodeSignature = $803b41bf0d7712c7$var$decodeSignature;


var $9f3408fc61cfebb1$exports = {};
"use strict";
Object.defineProperty($9f3408fc61cfebb1$exports, "__esModule", {
    value: true
});
$9f3408fc61cfebb1$exports.serializeSignDoc = $9f3408fc61cfebb1$exports.escapeCharacters = $9f3408fc61cfebb1$exports.makeSignDoc = $9f3408fc61cfebb1$exports.sortedJsonStringify = void 0;

var $6XcLW = parcelRequire("6XcLW");

var $7UsfE = parcelRequire("7UsfE");
function $9f3408fc61cfebb1$var$sortedObject(obj) {
    if (typeof obj !== "object" || obj === null) return obj;
    if (Array.isArray(obj)) return obj.map($9f3408fc61cfebb1$var$sortedObject);
    const sortedKeys = Object.keys(obj).sort();
    const result = {};
    // NOTE: Use forEach instead of reduce for performance with large objects eg Wasm code
    sortedKeys.forEach((key)=>{
        result[key] = $9f3408fc61cfebb1$var$sortedObject(obj[key]);
    });
    return result;
}
/** Returns a JSON string with objects sorted by key */ // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
function $9f3408fc61cfebb1$var$sortedJsonStringify(obj) {
    return JSON.stringify($9f3408fc61cfebb1$var$sortedObject(obj));
}
$9f3408fc61cfebb1$exports.sortedJsonStringify = $9f3408fc61cfebb1$var$sortedJsonStringify;
function $9f3408fc61cfebb1$var$makeSignDoc(msgs, fee, chainId, memo, accountNumber, sequence) {
    return {
        chain_id: chainId,
        account_number: $7UsfE.Uint53.fromString(accountNumber.toString()).toString(),
        sequence: $7UsfE.Uint53.fromString(sequence.toString()).toString(),
        fee: fee,
        msgs: msgs,
        memo: memo || ""
    };
}
$9f3408fc61cfebb1$exports.makeSignDoc = $9f3408fc61cfebb1$var$makeSignDoc;
/**
 * Takes a valid JSON document and performs the following escapings in string values:
 *
 * `&` -> `\u0026`
 * `<` -> `\u003c`
 * `>` -> `\u003e`
 *
 * Since those characters do not occur in other places of the JSON document, only
 * string values are affected.
 *
 * If the input is invalid JSON, the behaviour is undefined.
 */ function $9f3408fc61cfebb1$var$escapeCharacters(input) {
    // When we migrate to target es2021 or above, we can use replaceAll instead of global patterns.
    // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/replaceAll
    const amp = /&/g;
    const lt = /</g;
    const gt = />/g;
    return input.replace(amp, "\\u0026").replace(lt, "\\u003c").replace(gt, "\\u003e");
}
$9f3408fc61cfebb1$exports.escapeCharacters = $9f3408fc61cfebb1$var$escapeCharacters;
function $9f3408fc61cfebb1$var$serializeSignDoc(signDoc) {
    const serialized = $9f3408fc61cfebb1$var$escapeCharacters($9f3408fc61cfebb1$var$sortedJsonStringify(signDoc));
    return (0, $6XcLW.toUtf8)(serialized);
}
$9f3408fc61cfebb1$exports.serializeSignDoc = $9f3408fc61cfebb1$var$serializeSignDoc;


var $f6fe93efefc3ded0$exports = {};
"use strict";
Object.defineProperty($f6fe93efefc3ded0$exports, "__esModule", {
    value: true
});
$f6fe93efefc3ded0$exports.decrypt = $f6fe93efefc3ded0$exports.encrypt = $f6fe93efefc3ded0$exports.supportedAlgorithms = $f6fe93efefc3ded0$exports.executeKdf = $f6fe93efefc3ded0$exports.cosmjsSalt = void 0;

var $6f1ux = parcelRequire("6f1ux");

var $6XcLW = parcelRequire("6XcLW");
/**
 * A fixed salt is chosen to archive a deterministic password to key derivation.
 * This reduces the scope of a potential rainbow attack to all CosmJS users.
 * Must be 16 bytes due to implementation limitations.
 */ $f6fe93efefc3ded0$exports.cosmjsSalt = (0, $6XcLW.toAscii)("The CosmJS salt.");
async function $f6fe93efefc3ded0$var$executeKdf(password, configuration) {
    switch(configuration.algorithm){
        case "argon2id":
            {
                const options = configuration.params;
                if (!(0, $6f1ux.isArgon2idOptions)(options)) throw new Error("Invalid format of argon2id params");
                return $6f1ux.Argon2id.execute(password, $f6fe93efefc3ded0$exports.cosmjsSalt, options);
            }
        default:
            throw new Error("Unsupported KDF algorithm");
    }
}
$f6fe93efefc3ded0$exports.executeKdf = $f6fe93efefc3ded0$var$executeKdf;
$f6fe93efefc3ded0$exports.supportedAlgorithms = {
    xchacha20poly1305Ietf: "xchacha20poly1305-ietf"
};
async function $f6fe93efefc3ded0$var$encrypt(plaintext, encryptionKey, config) {
    switch(config.algorithm){
        case $f6fe93efefc3ded0$exports.supportedAlgorithms.xchacha20poly1305Ietf:
            {
                const nonce = $6f1ux.Random.getBytes($6f1ux.xchacha20NonceLength);
                // Prepend fixed-length nonce to ciphertext as suggested in the example from https://github.com/jedisct1/libsodium.js#api
                return new Uint8Array([
                    ...nonce,
                    ...await $6f1ux.Xchacha20poly1305Ietf.encrypt(plaintext, encryptionKey, nonce)
                ]);
            }
        default:
            throw new Error(`Unsupported encryption algorithm: '${config.algorithm}'`);
    }
}
$f6fe93efefc3ded0$exports.encrypt = $f6fe93efefc3ded0$var$encrypt;
async function $f6fe93efefc3ded0$var$decrypt(ciphertext, encryptionKey, config) {
    switch(config.algorithm){
        case $f6fe93efefc3ded0$exports.supportedAlgorithms.xchacha20poly1305Ietf:
            {
                const nonce = ciphertext.slice(0, $6f1ux.xchacha20NonceLength);
                return $6f1ux.Xchacha20poly1305Ietf.decrypt(ciphertext.slice($6f1ux.xchacha20NonceLength), encryptionKey, nonce);
            }
        default:
            throw new Error(`Unsupported encryption algorithm: '${config.algorithm}'`);
    }
}
$f6fe93efefc3ded0$exports.decrypt = $f6fe93efefc3ded0$var$decrypt;


const $ef907aac4476815c$var$serializationTypeV1 = "secp256k1wallet-v1";
/**
 * A KDF configuration that is not very strong but can be used on the main thread.
 * It takes about 1 second in Node.js 16.0.0 and should have similar runtimes in other modern Wasm hosts.
 */ const $ef907aac4476815c$var$basicPasswordHashingOptions = {
    algorithm: "argon2id",
    params: {
        outputLength: 32,
        opsLimit: 24,
        memLimitKib: 12288
    }
};
function $ef907aac4476815c$var$isDerivationJson(thing) {
    if (!(0, $fZwG5.isNonNullObject)(thing)) return false;
    if (typeof thing.hdPath !== "string") return false;
    if (typeof thing.prefix !== "string") return false;
    return true;
}
function $ef907aac4476815c$var$extractKdfConfigurationV1(doc) {
    return doc.kdf;
}
function $ef907aac4476815c$var$extractKdfConfiguration(serialization) {
    const root = JSON.parse(serialization);
    if (!(0, $fZwG5.isNonNullObject)(root)) throw new Error("Root document is not an object.");
    switch(root.type){
        case $ef907aac4476815c$var$serializationTypeV1:
            return $ef907aac4476815c$var$extractKdfConfigurationV1(root);
        default:
            throw new Error("Unsupported serialization type");
    }
}
$ef907aac4476815c$exports.extractKdfConfiguration = $ef907aac4476815c$var$extractKdfConfiguration;
const $ef907aac4476815c$var$defaultOptions = {
    bip39Password: "",
    hdPaths: [
        (0, $26c6be321d4f0223$exports.makeCosmoshubPath)(0)
    ],
    prefix: "cosmos"
};
class $ef907aac4476815c$var$Secp256k1HdWallet {
    /**
     * Restores a wallet from the given BIP39 mnemonic.
     *
     * @param mnemonic Any valid English mnemonic.
     * @param options An optional `Secp256k1HdWalletOptions` object optionally containing a bip39Password, hdPaths, and prefix.
     */ static async fromMnemonic(mnemonic, options = {}) {
        const mnemonicChecked = new $6f1ux.EnglishMnemonic(mnemonic);
        const seed = await $6f1ux.Bip39.mnemonicToSeed(mnemonicChecked, options.bip39Password);
        return new $ef907aac4476815c$var$Secp256k1HdWallet(mnemonicChecked, {
            ...options,
            seed: seed
        });
    }
    /**
     * Generates a new wallet with a BIP39 mnemonic of the given length.
     *
     * @param length The number of words in the mnemonic (12, 15, 18, 21 or 24).
     * @param options An optional `Secp256k1HdWalletOptions` object optionally containing a bip39Password, hdPaths, and prefix.
     */ static async generate(length = 12, options = {}) {
        const entropyLength = 4 * Math.floor(11 * length / 33);
        const entropy = $6f1ux.Random.getBytes(entropyLength);
        const mnemonic = $6f1ux.Bip39.encode(entropy);
        return $ef907aac4476815c$var$Secp256k1HdWallet.fromMnemonic(mnemonic.toString(), options);
    }
    /**
     * Restores a wallet from an encrypted serialization.
     *
     * @param password The user provided password used to generate an encryption key via a KDF.
     *                 This is not normalized internally (see "Unicode normalization" to learn more).
     */ static async deserialize(serialization, password) {
        const root = JSON.parse(serialization);
        if (!(0, $fZwG5.isNonNullObject)(root)) throw new Error("Root document is not an object.");
        switch(root.type){
            case $ef907aac4476815c$var$serializationTypeV1:
                return $ef907aac4476815c$var$Secp256k1HdWallet.deserializeTypeV1(serialization, password);
            default:
                throw new Error("Unsupported serialization type");
        }
    }
    /**
     * Restores a wallet from an encrypted serialization.
     *
     * This is an advanced alternative to calling `deserialize(serialization, password)` directly, which allows
     * you to offload the KDF execution to a non-UI thread (e.g. in a WebWorker).
     *
     * The caller is responsible for ensuring the key was derived with the given KDF configuration. This can be
     * done using `extractKdfConfiguration(serialization)` and `executeKdf(password, kdfConfiguration)` from this package.
     */ static async deserializeWithEncryptionKey(serialization, encryptionKey) {
        const root = JSON.parse(serialization);
        if (!(0, $fZwG5.isNonNullObject)(root)) throw new Error("Root document is not an object.");
        const untypedRoot = root;
        switch(untypedRoot.type){
            case $ef907aac4476815c$var$serializationTypeV1:
                {
                    const decryptedBytes = await (0, $f6fe93efefc3ded0$exports.decrypt)((0, $6XcLW.fromBase64)(untypedRoot.data), encryptionKey, untypedRoot.encryption);
                    const decryptedDocument = JSON.parse((0, $6XcLW.fromUtf8)(decryptedBytes));
                    const { mnemonic: mnemonic, accounts: accounts } = decryptedDocument;
                    (0, $fZwG5.assert)(typeof mnemonic === "string");
                    if (!Array.isArray(accounts)) throw new Error("Property 'accounts' is not an array");
                    if (!accounts.every((account)=>$ef907aac4476815c$var$isDerivationJson(account))) throw new Error("Account is not in the correct format.");
                    const firstPrefix = accounts[0].prefix;
                    if (!accounts.every(({ prefix: prefix })=>prefix === firstPrefix)) throw new Error("Accounts do not all have the same prefix");
                    const hdPaths = accounts.map(({ hdPath: hdPath })=>(0, $6f1ux.stringToPath)(hdPath));
                    return $ef907aac4476815c$var$Secp256k1HdWallet.fromMnemonic(mnemonic, {
                        hdPaths: hdPaths,
                        prefix: firstPrefix
                    });
                }
            default:
                throw new Error("Unsupported serialization type");
        }
    }
    static async deserializeTypeV1(serialization, password) {
        const root = JSON.parse(serialization);
        if (!(0, $fZwG5.isNonNullObject)(root)) throw new Error("Root document is not an object.");
        const encryptionKey = await (0, $f6fe93efefc3ded0$exports.executeKdf)(password, root.kdf);
        return $ef907aac4476815c$var$Secp256k1HdWallet.deserializeWithEncryptionKey(serialization, encryptionKey);
    }
    constructor(mnemonic, options){
        const hdPaths = options.hdPaths ?? $ef907aac4476815c$var$defaultOptions.hdPaths;
        const prefix = options.prefix ?? $ef907aac4476815c$var$defaultOptions.prefix;
        this.secret = mnemonic;
        this.seed = options.seed;
        this.accounts = hdPaths.map((hdPath)=>({
                hdPath: hdPath,
                prefix: prefix
            }));
    }
    get mnemonic() {
        return this.secret.toString();
    }
    async getAccounts() {
        const accountsWithPrivkeys = await this.getAccountsWithPrivkeys();
        return accountsWithPrivkeys.map(({ algo: algo, pubkey: pubkey, address: address })=>({
                algo: algo,
                pubkey: pubkey,
                address: address
            }));
    }
    async signAmino(signerAddress, signDoc) {
        const accounts = await this.getAccountsWithPrivkeys();
        const account = accounts.find(({ address: address })=>address === signerAddress);
        if (account === undefined) throw new Error(`Address ${signerAddress} not found in wallet`);
        const { privkey: privkey, pubkey: pubkey } = account;
        const message = (0, $6f1ux.sha256)((0, $9f3408fc61cfebb1$exports.serializeSignDoc)(signDoc));
        const signature = await $6f1ux.Secp256k1.createSignature(message, privkey);
        const signatureBytes = new Uint8Array([
            ...signature.r(32),
            ...signature.s(32)
        ]);
        return {
            signed: signDoc,
            signature: (0, $803b41bf0d7712c7$exports.encodeSecp256k1Signature)(pubkey, signatureBytes)
        };
    }
    /**
     * Generates an encrypted serialization of this wallet.
     *
     * @param password The user provided password used to generate an encryption key via a KDF.
     *                 This is not normalized internally (see "Unicode normalization" to learn more).
     */ async serialize(password) {
        const kdfConfiguration = $ef907aac4476815c$var$basicPasswordHashingOptions;
        const encryptionKey = await (0, $f6fe93efefc3ded0$exports.executeKdf)(password, kdfConfiguration);
        return this.serializeWithEncryptionKey(encryptionKey, kdfConfiguration);
    }
    /**
     * Generates an encrypted serialization of this wallet.
     *
     * This is an advanced alternative to calling `serialize(password)` directly, which allows you to
     * offload the KDF execution to a non-UI thread (e.g. in a WebWorker).
     *
     * The caller is responsible for ensuring the key was derived with the given KDF options. If this
     * is not the case, the wallet cannot be restored with the original password.
     */ async serializeWithEncryptionKey(encryptionKey, kdfConfiguration) {
        const dataToEncrypt = {
            mnemonic: this.mnemonic,
            accounts: this.accounts.map(({ hdPath: hdPath, prefix: prefix })=>({
                    hdPath: (0, $6f1ux.pathToString)(hdPath),
                    prefix: prefix
                }))
        };
        const dataToEncryptRaw = (0, $6XcLW.toUtf8)(JSON.stringify(dataToEncrypt));
        const encryptionConfiguration = {
            algorithm: $f6fe93efefc3ded0$exports.supportedAlgorithms.xchacha20poly1305Ietf
        };
        const encryptedData = await (0, $f6fe93efefc3ded0$exports.encrypt)(dataToEncryptRaw, encryptionKey, encryptionConfiguration);
        const out = {
            type: $ef907aac4476815c$var$serializationTypeV1,
            kdf: kdfConfiguration,
            encryption: encryptionConfiguration,
            data: (0, $6XcLW.toBase64)(encryptedData)
        };
        return JSON.stringify(out);
    }
    async getKeyPair(hdPath) {
        const { privkey: privkey } = $6f1ux.Slip10.derivePath($6f1ux.Slip10Curve.Secp256k1, this.seed, hdPath);
        const { pubkey: pubkey } = await $6f1ux.Secp256k1.makeKeypair(privkey);
        return {
            privkey: privkey,
            pubkey: $6f1ux.Secp256k1.compressPubkey(pubkey)
        };
    }
    async getAccountsWithPrivkeys() {
        return Promise.all(this.accounts.map(async ({ hdPath: hdPath, prefix: prefix })=>{
            const { privkey: privkey, pubkey: pubkey } = await this.getKeyPair(hdPath);
            const address = (0, $6XcLW.toBech32)(prefix, (0, $4e7d0e4795298bde$exports.rawSecp256k1PubkeyToRawAddress)(pubkey));
            return {
                algo: "secp256k1",
                privkey: privkey,
                pubkey: pubkey,
                address: address
            };
        }));
    }
}
$ef907aac4476815c$exports.Secp256k1HdWallet = $ef907aac4476815c$var$Secp256k1HdWallet;


Object.defineProperty($6078e8ec636191fb$exports, "extractKdfConfiguration", {
    enumerable: true,
    get: function() {
        return $ef907aac4476815c$exports.extractKdfConfiguration;
    }
});
Object.defineProperty($6078e8ec636191fb$exports, "Secp256k1HdWallet", {
    enumerable: true,
    get: function() {
        return $ef907aac4476815c$exports.Secp256k1HdWallet;
    }
});
var $2037786f8a0c0fa5$exports = {};
"use strict";
Object.defineProperty($2037786f8a0c0fa5$exports, "__esModule", {
    value: true
});
$2037786f8a0c0fa5$exports.Secp256k1Wallet = void 0;

var $6f1ux = parcelRequire("6f1ux");

var $6XcLW = parcelRequire("6XcLW");



/**
 * A wallet that holds a single secp256k1 keypair.
 *
 * If you want to work with BIP39 mnemonics and multiple accounts, use Secp256k1HdWallet.
 */ class $2037786f8a0c0fa5$var$Secp256k1Wallet {
    /**
     * Creates a Secp256k1Wallet from the given private key
     *
     * @param privkey The private key.
     * @param prefix The bech32 address prefix (human readable part). Defaults to "cosmos".
     */ static async fromKey(privkey, prefix = "cosmos") {
        const uncompressed = (await $6f1ux.Secp256k1.makeKeypair(privkey)).pubkey;
        return new $2037786f8a0c0fa5$var$Secp256k1Wallet(privkey, $6f1ux.Secp256k1.compressPubkey(uncompressed), prefix);
    }
    constructor(privkey, pubkey, prefix){
        this.privkey = privkey;
        this.pubkey = pubkey;
        this.prefix = prefix;
    }
    get address() {
        return (0, $6XcLW.toBech32)(this.prefix, (0, $4e7d0e4795298bde$exports.rawSecp256k1PubkeyToRawAddress)(this.pubkey));
    }
    async getAccounts() {
        return [
            {
                algo: "secp256k1",
                address: this.address,
                pubkey: this.pubkey
            }
        ];
    }
    async signAmino(signerAddress, signDoc) {
        if (signerAddress !== this.address) throw new Error(`Address ${signerAddress} not found in wallet`);
        const message = new $6f1ux.Sha256((0, $9f3408fc61cfebb1$exports.serializeSignDoc)(signDoc)).digest();
        const signature = await $6f1ux.Secp256k1.createSignature(message, this.privkey);
        const signatureBytes = new Uint8Array([
            ...signature.r(32),
            ...signature.s(32)
        ]);
        return {
            signed: signDoc,
            signature: (0, $803b41bf0d7712c7$exports.encodeSecp256k1Signature)(this.pubkey, signatureBytes)
        };
    }
}
$2037786f8a0c0fa5$exports.Secp256k1Wallet = $2037786f8a0c0fa5$var$Secp256k1Wallet;


Object.defineProperty($6078e8ec636191fb$exports, "Secp256k1Wallet", {
    enumerable: true,
    get: function() {
        return $2037786f8a0c0fa5$exports.Secp256k1Wallet;
    }
});

Object.defineProperty($6078e8ec636191fb$exports, "decodeSignature", {
    enumerable: true,
    get: function() {
        return $803b41bf0d7712c7$exports.decodeSignature;
    }
});
Object.defineProperty($6078e8ec636191fb$exports, "encodeSecp256k1Signature", {
    enumerable: true,
    get: function() {
        return $803b41bf0d7712c7$exports.encodeSecp256k1Signature;
    }
});

Object.defineProperty($6078e8ec636191fb$exports, "makeSignDoc", {
    enumerable: true,
    get: function() {
        return $9f3408fc61cfebb1$exports.makeSignDoc;
    }
});
Object.defineProperty($6078e8ec636191fb$exports, "serializeSignDoc", {
    enumerable: true,
    get: function() {
        return $9f3408fc61cfebb1$exports.serializeSignDoc;
    }
});
var $c1391df51b820f93$exports = {};
"use strict";
Object.defineProperty($c1391df51b820f93$exports, "__esModule", {
    value: true
});
$c1391df51b820f93$exports.makeStdTx = $c1391df51b820f93$exports.isStdTx = void 0;
function $c1391df51b820f93$var$isStdTx(txValue) {
    const { memo: memo, msg: msg, fee: fee, signatures: signatures } = txValue;
    return typeof memo === "string" && Array.isArray(msg) && typeof fee === "object" && Array.isArray(signatures);
}
$c1391df51b820f93$exports.isStdTx = $c1391df51b820f93$var$isStdTx;
function $c1391df51b820f93$var$makeStdTx(content, signatures) {
    return {
        msg: content.msgs,
        fee: content.fee,
        memo: content.memo,
        signatures: Array.isArray(signatures) ? signatures : [
            signatures
        ]
    };
}
$c1391df51b820f93$exports.makeStdTx = $c1391df51b820f93$var$makeStdTx;


Object.defineProperty($6078e8ec636191fb$exports, "isStdTx", {
    enumerable: true,
    get: function() {
        return $c1391df51b820f93$exports.isStdTx;
    }
});
Object.defineProperty($6078e8ec636191fb$exports, "makeStdTx", {
    enumerable: true,
    get: function() {
        return $c1391df51b820f93$exports.makeStdTx;
    }
});

Object.defineProperty($6078e8ec636191fb$exports, "executeKdf", {
    enumerable: true,
    get: function() {
        return $f6fe93efefc3ded0$exports.executeKdf;
    }
});



var $6f1ux = parcelRequire("6f1ux");

var $6XcLW = parcelRequire("6XcLW");

var $fZwG5 = parcelRequire("fZwG5");
var $8eeafeb2969d4151$exports = {};
"use strict";
var $8eeafeb2969d4151$var$__importDefault = $8eeafeb2969d4151$exports && $8eeafeb2969d4151$exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty($8eeafeb2969d4151$exports, "__esModule", {
    value: true
});
$8eeafeb2969d4151$exports.makeSignBytes = $8eeafeb2969d4151$exports.makeSignDoc = $8eeafeb2969d4151$exports.makeAuthInfoBytes = void 0;

var $fZwG5 = parcelRequire("fZwG5");



const $8eeafeb2969d4151$var$long_1 = $8eeafeb2969d4151$var$__importDefault((parcelRequire("jRkuS")));
/**
 * Create signer infos from the provided signers.
 *
 * This implementation does not support different signing modes for the different signers.
 */ function $8eeafeb2969d4151$var$makeSignerInfos(signers, signMode) {
    return signers.map(({ pubkey: pubkey, sequence: sequence })=>({
            publicKey: pubkey,
            modeInfo: {
                single: {
                    mode: signMode
                }
            },
            sequence: $8eeafeb2969d4151$var$long_1.default.fromNumber(sequence)
        }));
}
/**
 * Creates and serializes an AuthInfo document.
 *
 * This implementation does not support different signing modes for the different signers.
 */ function $8eeafeb2969d4151$var$makeAuthInfoBytes(signers, feeAmount, gasLimit, feeGranter, feePayer, signMode = $cefef10ba181af21$exports.SignMode.SIGN_MODE_DIRECT) {
    // Required arguments 4 and 5 were added in CosmJS 0.29. Use runtime checks to help our non-TS users.
    (0, $fZwG5.assert)(feeGranter === undefined || typeof feeGranter === "string", "feeGranter must be undefined or string");
    (0, $fZwG5.assert)(feePayer === undefined || typeof feePayer === "string", "feePayer must be undefined or string");
    const authInfo = $eedf6d503be55212$exports.AuthInfo.fromPartial({
        signerInfos: $8eeafeb2969d4151$var$makeSignerInfos(signers, signMode),
        fee: {
            amount: [
                ...feeAmount
            ],
            gasLimit: $8eeafeb2969d4151$var$long_1.default.fromNumber(gasLimit),
            granter: feeGranter,
            payer: feePayer
        }
    });
    return $eedf6d503be55212$exports.AuthInfo.encode(authInfo).finish();
}
$8eeafeb2969d4151$exports.makeAuthInfoBytes = $8eeafeb2969d4151$var$makeAuthInfoBytes;
function $8eeafeb2969d4151$var$makeSignDoc(bodyBytes, authInfoBytes, chainId, accountNumber) {
    return {
        bodyBytes: bodyBytes,
        authInfoBytes: authInfoBytes,
        chainId: chainId,
        accountNumber: $8eeafeb2969d4151$var$long_1.default.fromNumber(accountNumber)
    };
}
$8eeafeb2969d4151$exports.makeSignDoc = $8eeafeb2969d4151$var$makeSignDoc;
function $8eeafeb2969d4151$var$makeSignBytes({ accountNumber: accountNumber, authInfoBytes: authInfoBytes, bodyBytes: bodyBytes, chainId: chainId }) {
    const signDoc = $eedf6d503be55212$exports.SignDoc.fromPartial({
        accountNumber: accountNumber,
        authInfoBytes: authInfoBytes,
        bodyBytes: bodyBytes,
        chainId: chainId
    });
    return $eedf6d503be55212$exports.SignDoc.encode(signDoc).finish();
}
$8eeafeb2969d4151$exports.makeSignBytes = $8eeafeb2969d4151$var$makeSignBytes;


var $5dc5a6f45d5fe193$exports = {};
"use strict";
Object.defineProperty($5dc5a6f45d5fe193$exports, "__esModule", {
    value: true
});
$5dc5a6f45d5fe193$exports.decrypt = $5dc5a6f45d5fe193$exports.encrypt = $5dc5a6f45d5fe193$exports.supportedAlgorithms = $5dc5a6f45d5fe193$exports.executeKdf = $5dc5a6f45d5fe193$exports.cosmjsSalt = void 0;

var $6f1ux = parcelRequire("6f1ux");

var $6XcLW = parcelRequire("6XcLW");
/**
 * A fixed salt is chosen to archive a deterministic password to key derivation.
 * This reduces the scope of a potential rainbow attack to all CosmJS users.
 * Must be 16 bytes due to implementation limitations.
 */ $5dc5a6f45d5fe193$exports.cosmjsSalt = (0, $6XcLW.toAscii)("The CosmJS salt.");
async function $5dc5a6f45d5fe193$var$executeKdf(password, configuration) {
    switch(configuration.algorithm){
        case "argon2id":
            {
                const options = configuration.params;
                if (!(0, $6f1ux.isArgon2idOptions)(options)) throw new Error("Invalid format of argon2id params");
                return $6f1ux.Argon2id.execute(password, $5dc5a6f45d5fe193$exports.cosmjsSalt, options);
            }
        default:
            throw new Error("Unsupported KDF algorithm");
    }
}
$5dc5a6f45d5fe193$exports.executeKdf = $5dc5a6f45d5fe193$var$executeKdf;
$5dc5a6f45d5fe193$exports.supportedAlgorithms = {
    xchacha20poly1305Ietf: "xchacha20poly1305-ietf"
};
async function $5dc5a6f45d5fe193$var$encrypt(plaintext, encryptionKey, config) {
    switch(config.algorithm){
        case $5dc5a6f45d5fe193$exports.supportedAlgorithms.xchacha20poly1305Ietf:
            {
                const nonce = $6f1ux.Random.getBytes($6f1ux.xchacha20NonceLength);
                // Prepend fixed-length nonce to ciphertext as suggested in the example from https://github.com/jedisct1/libsodium.js#api
                return new Uint8Array([
                    ...nonce,
                    ...await $6f1ux.Xchacha20poly1305Ietf.encrypt(plaintext, encryptionKey, nonce)
                ]);
            }
        default:
            throw new Error(`Unsupported encryption algorithm: '${config.algorithm}'`);
    }
}
$5dc5a6f45d5fe193$exports.encrypt = $5dc5a6f45d5fe193$var$encrypt;
async function $5dc5a6f45d5fe193$var$decrypt(ciphertext, encryptionKey, config) {
    switch(config.algorithm){
        case $5dc5a6f45d5fe193$exports.supportedAlgorithms.xchacha20poly1305Ietf:
            {
                const nonce = ciphertext.slice(0, $6f1ux.xchacha20NonceLength);
                return $6f1ux.Xchacha20poly1305Ietf.decrypt(ciphertext.slice($6f1ux.xchacha20NonceLength), encryptionKey, nonce);
            }
        default:
            throw new Error(`Unsupported encryption algorithm: '${config.algorithm}'`);
    }
}
$5dc5a6f45d5fe193$exports.decrypt = $5dc5a6f45d5fe193$var$decrypt;


const $e2709248318d325a$var$serializationTypeV1 = "directsecp256k1hdwallet-v1";
/**
 * A KDF configuration that is not very strong but can be used on the main thread.
 * It takes about 1 second in Node.js 16.0.0 and should have similar runtimes in other modern Wasm hosts.
 */ const $e2709248318d325a$var$basicPasswordHashingOptions = {
    algorithm: "argon2id",
    params: {
        outputLength: 32,
        opsLimit: 24,
        memLimitKib: 12288
    }
};
function $e2709248318d325a$var$isDerivationJson(thing) {
    if (!(0, $fZwG5.isNonNullObject)(thing)) return false;
    if (typeof thing.hdPath !== "string") return false;
    if (typeof thing.prefix !== "string") return false;
    return true;
}
function $e2709248318d325a$var$extractKdfConfigurationV1(doc) {
    return doc.kdf;
}
function $e2709248318d325a$var$extractKdfConfiguration(serialization) {
    const root = JSON.parse(serialization);
    if (!(0, $fZwG5.isNonNullObject)(root)) throw new Error("Root document is not an object.");
    switch(root.type){
        case $e2709248318d325a$var$serializationTypeV1:
            return $e2709248318d325a$var$extractKdfConfigurationV1(root);
        default:
            throw new Error("Unsupported serialization type");
    }
}
$e2709248318d325a$exports.extractKdfConfiguration = $e2709248318d325a$var$extractKdfConfiguration;
const $e2709248318d325a$var$defaultOptions = {
    bip39Password: "",
    hdPaths: [
        (0, $6078e8ec636191fb$exports.makeCosmoshubPath)(0)
    ],
    prefix: "cosmos"
};
/** A wallet for protobuf based signing using SIGN_MODE_DIRECT */ class $e2709248318d325a$var$DirectSecp256k1HdWallet {
    /**
     * Restores a wallet from the given BIP39 mnemonic.
     *
     * @param mnemonic Any valid English mnemonic.
     * @param options An optional `DirectSecp256k1HdWalletOptions` object optionally containing a bip39Password, hdPaths, and prefix.
     */ static async fromMnemonic(mnemonic, options = {}) {
        const mnemonicChecked = new $6f1ux.EnglishMnemonic(mnemonic);
        const seed = await $6f1ux.Bip39.mnemonicToSeed(mnemonicChecked, options.bip39Password);
        return new $e2709248318d325a$var$DirectSecp256k1HdWallet(mnemonicChecked, {
            ...options,
            seed: seed
        });
    }
    /**
     * Generates a new wallet with a BIP39 mnemonic of the given length.
     *
     * @param length The number of words in the mnemonic (12, 15, 18, 21 or 24).
     * @param options An optional `DirectSecp256k1HdWalletOptions` object optionally containing a bip39Password, hdPaths, and prefix.
     */ static async generate(length = 12, options = {}) {
        const entropyLength = 4 * Math.floor(11 * length / 33);
        const entropy = $6f1ux.Random.getBytes(entropyLength);
        const mnemonic = $6f1ux.Bip39.encode(entropy);
        return $e2709248318d325a$var$DirectSecp256k1HdWallet.fromMnemonic(mnemonic.toString(), options);
    }
    /**
     * Restores a wallet from an encrypted serialization.
     *
     * @param password The user provided password used to generate an encryption key via a KDF.
     *                 This is not normalized internally (see "Unicode normalization" to learn more).
     */ static async deserialize(serialization, password) {
        const root = JSON.parse(serialization);
        if (!(0, $fZwG5.isNonNullObject)(root)) throw new Error("Root document is not an object.");
        switch(root.type){
            case $e2709248318d325a$var$serializationTypeV1:
                return $e2709248318d325a$var$DirectSecp256k1HdWallet.deserializeTypeV1(serialization, password);
            default:
                throw new Error("Unsupported serialization type");
        }
    }
    /**
     * Restores a wallet from an encrypted serialization.
     *
     * This is an advanced alternative to calling `deserialize(serialization, password)` directly, which allows
     * you to offload the KDF execution to a non-UI thread (e.g. in a WebWorker).
     *
     * The caller is responsible for ensuring the key was derived with the given KDF configuration. This can be
     * done using `extractKdfConfiguration(serialization)` and `executeKdf(password, kdfConfiguration)` from this package.
     */ static async deserializeWithEncryptionKey(serialization, encryptionKey) {
        const root = JSON.parse(serialization);
        if (!(0, $fZwG5.isNonNullObject)(root)) throw new Error("Root document is not an object.");
        const untypedRoot = root;
        switch(untypedRoot.type){
            case $e2709248318d325a$var$serializationTypeV1:
                {
                    const decryptedBytes = await (0, $5dc5a6f45d5fe193$exports.decrypt)((0, $6XcLW.fromBase64)(untypedRoot.data), encryptionKey, untypedRoot.encryption);
                    const decryptedDocument = JSON.parse((0, $6XcLW.fromUtf8)(decryptedBytes));
                    const { mnemonic: mnemonic, accounts: accounts } = decryptedDocument;
                    (0, $fZwG5.assert)(typeof mnemonic === "string");
                    if (!Array.isArray(accounts)) throw new Error("Property 'accounts' is not an array");
                    if (!accounts.every((account)=>$e2709248318d325a$var$isDerivationJson(account))) throw new Error("Account is not in the correct format.");
                    const firstPrefix = accounts[0].prefix;
                    if (!accounts.every(({ prefix: prefix })=>prefix === firstPrefix)) throw new Error("Accounts do not all have the same prefix");
                    const hdPaths = accounts.map(({ hdPath: hdPath })=>(0, $6f1ux.stringToPath)(hdPath));
                    return $e2709248318d325a$var$DirectSecp256k1HdWallet.fromMnemonic(mnemonic, {
                        hdPaths: hdPaths,
                        prefix: firstPrefix
                    });
                }
            default:
                throw new Error("Unsupported serialization type");
        }
    }
    static async deserializeTypeV1(serialization, password) {
        const root = JSON.parse(serialization);
        if (!(0, $fZwG5.isNonNullObject)(root)) throw new Error("Root document is not an object.");
        const encryptionKey = await (0, $5dc5a6f45d5fe193$exports.executeKdf)(password, root.kdf);
        return $e2709248318d325a$var$DirectSecp256k1HdWallet.deserializeWithEncryptionKey(serialization, encryptionKey);
    }
    constructor(mnemonic, options){
        const prefix = options.prefix ?? $e2709248318d325a$var$defaultOptions.prefix;
        const hdPaths = options.hdPaths ?? $e2709248318d325a$var$defaultOptions.hdPaths;
        this.secret = mnemonic;
        this.seed = options.seed;
        this.accounts = hdPaths.map((hdPath)=>({
                hdPath: hdPath,
                prefix: prefix
            }));
    }
    get mnemonic() {
        return this.secret.toString();
    }
    async getAccounts() {
        const accountsWithPrivkeys = await this.getAccountsWithPrivkeys();
        return accountsWithPrivkeys.map(({ algo: algo, pubkey: pubkey, address: address })=>({
                algo: algo,
                pubkey: pubkey,
                address: address
            }));
    }
    async signDirect(signerAddress, signDoc) {
        const accounts = await this.getAccountsWithPrivkeys();
        const account = accounts.find(({ address: address })=>address === signerAddress);
        if (account === undefined) throw new Error(`Address ${signerAddress} not found in wallet`);
        const { privkey: privkey, pubkey: pubkey } = account;
        const signBytes = (0, $8eeafeb2969d4151$exports.makeSignBytes)(signDoc);
        const hashedMessage = (0, $6f1ux.sha256)(signBytes);
        const signature = await $6f1ux.Secp256k1.createSignature(hashedMessage, privkey);
        const signatureBytes = new Uint8Array([
            ...signature.r(32),
            ...signature.s(32)
        ]);
        const stdSignature = (0, $6078e8ec636191fb$exports.encodeSecp256k1Signature)(pubkey, signatureBytes);
        return {
            signed: signDoc,
            signature: stdSignature
        };
    }
    /**
     * Generates an encrypted serialization of this wallet.
     *
     * @param password The user provided password used to generate an encryption key via a KDF.
     *                 This is not normalized internally (see "Unicode normalization" to learn more).
     */ async serialize(password) {
        const kdfConfiguration = $e2709248318d325a$var$basicPasswordHashingOptions;
        const encryptionKey = await (0, $5dc5a6f45d5fe193$exports.executeKdf)(password, kdfConfiguration);
        return this.serializeWithEncryptionKey(encryptionKey, kdfConfiguration);
    }
    /**
     * Generates an encrypted serialization of this wallet.
     *
     * This is an advanced alternative to calling `serialize(password)` directly, which allows you to
     * offload the KDF execution to a non-UI thread (e.g. in a WebWorker).
     *
     * The caller is responsible for ensuring the key was derived with the given KDF options. If this
     * is not the case, the wallet cannot be restored with the original password.
     */ async serializeWithEncryptionKey(encryptionKey, kdfConfiguration) {
        const dataToEncrypt = {
            mnemonic: this.mnemonic,
            accounts: this.accounts.map(({ hdPath: hdPath, prefix: prefix })=>({
                    hdPath: (0, $6f1ux.pathToString)(hdPath),
                    prefix: prefix
                }))
        };
        const dataToEncryptRaw = (0, $6XcLW.toUtf8)(JSON.stringify(dataToEncrypt));
        const encryptionConfiguration = {
            algorithm: $5dc5a6f45d5fe193$exports.supportedAlgorithms.xchacha20poly1305Ietf
        };
        const encryptedData = await (0, $5dc5a6f45d5fe193$exports.encrypt)(dataToEncryptRaw, encryptionKey, encryptionConfiguration);
        const out = {
            type: $e2709248318d325a$var$serializationTypeV1,
            kdf: kdfConfiguration,
            encryption: encryptionConfiguration,
            data: (0, $6XcLW.toBase64)(encryptedData)
        };
        return JSON.stringify(out);
    }
    async getKeyPair(hdPath) {
        const { privkey: privkey } = $6f1ux.Slip10.derivePath($6f1ux.Slip10Curve.Secp256k1, this.seed, hdPath);
        const { pubkey: pubkey } = await $6f1ux.Secp256k1.makeKeypair(privkey);
        return {
            privkey: privkey,
            pubkey: $6f1ux.Secp256k1.compressPubkey(pubkey)
        };
    }
    async getAccountsWithPrivkeys() {
        return Promise.all(this.accounts.map(async ({ hdPath: hdPath, prefix: prefix })=>{
            const { privkey: privkey, pubkey: pubkey } = await this.getKeyPair(hdPath);
            const address = (0, $6XcLW.toBech32)(prefix, (0, $6078e8ec636191fb$exports.rawSecp256k1PubkeyToRawAddress)(pubkey));
            return {
                algo: "secp256k1",
                privkey: privkey,
                pubkey: pubkey,
                address: address
            };
        }));
    }
}
$e2709248318d325a$exports.DirectSecp256k1HdWallet = $e2709248318d325a$var$DirectSecp256k1HdWallet;


Object.defineProperty($c0a9381c50e8ee56$exports, "DirectSecp256k1HdWallet", {
    enumerable: true,
    get: function() {
        return $e2709248318d325a$exports.DirectSecp256k1HdWallet;
    }
});
Object.defineProperty($c0a9381c50e8ee56$exports, "extractKdfConfiguration", {
    enumerable: true,
    get: function() {
        return $e2709248318d325a$exports.extractKdfConfiguration;
    }
});
var $d7318d865ef32cf7$exports = {};
"use strict";
Object.defineProperty($d7318d865ef32cf7$exports, "__esModule", {
    value: true
});
$d7318d865ef32cf7$exports.DirectSecp256k1Wallet = void 0;


var $6f1ux = parcelRequire("6f1ux");

var $6XcLW = parcelRequire("6XcLW");

/**
 * A wallet that holds a single secp256k1 keypair.
 *
 * If you want to work with BIP39 mnemonics and multiple accounts, use DirectSecp256k1HdWallet.
 */ class $d7318d865ef32cf7$var$DirectSecp256k1Wallet {
    /**
     * Creates a DirectSecp256k1Wallet from the given private key
     *
     * @param privkey The private key.
     * @param prefix The bech32 address prefix (human readable part). Defaults to "cosmos".
     */ static async fromKey(privkey, prefix = "cosmos") {
        const uncompressed = (await $6f1ux.Secp256k1.makeKeypair(privkey)).pubkey;
        return new $d7318d865ef32cf7$var$DirectSecp256k1Wallet(privkey, $6f1ux.Secp256k1.compressPubkey(uncompressed), prefix);
    }
    constructor(privkey, pubkey, prefix){
        this.privkey = privkey;
        this.pubkey = pubkey;
        this.prefix = prefix;
    }
    get address() {
        return (0, $6XcLW.toBech32)(this.prefix, (0, $6078e8ec636191fb$exports.rawSecp256k1PubkeyToRawAddress)(this.pubkey));
    }
    async getAccounts() {
        return [
            {
                algo: "secp256k1",
                address: this.address,
                pubkey: this.pubkey
            }
        ];
    }
    async signDirect(address, signDoc) {
        const signBytes = (0, $8eeafeb2969d4151$exports.makeSignBytes)(signDoc);
        if (address !== this.address) throw new Error(`Address ${address} not found in wallet`);
        const hashedMessage = (0, $6f1ux.sha256)(signBytes);
        const signature = await $6f1ux.Secp256k1.createSignature(hashedMessage, this.privkey);
        const signatureBytes = new Uint8Array([
            ...signature.r(32),
            ...signature.s(32)
        ]);
        const stdSignature = (0, $6078e8ec636191fb$exports.encodeSecp256k1Signature)(this.pubkey, signatureBytes);
        return {
            signed: signDoc,
            signature: stdSignature
        };
    }
}
$d7318d865ef32cf7$exports.DirectSecp256k1Wallet = $d7318d865ef32cf7$var$DirectSecp256k1Wallet;


Object.defineProperty($c0a9381c50e8ee56$exports, "DirectSecp256k1Wallet", {
    enumerable: true,
    get: function() {
        return $d7318d865ef32cf7$exports.DirectSecp256k1Wallet;
    }
});
var $3746dfb862c9f264$exports = {};
"use strict";
Object.defineProperty($3746dfb862c9f264$exports, "__esModule", {
    value: true
});
$3746dfb862c9f264$exports.makeCosmoshubPath = void 0;

var $6f1ux = parcelRequire("6f1ux");
/**
 * The Cosmos Hub derivation path in the form `m/44'/118'/0'/0/a`
 * with 0-based account index `a`.
 */ function $3746dfb862c9f264$var$makeCosmoshubPath(a) {
    return [
        $6f1ux.Slip10RawIndex.hardened(44),
        $6f1ux.Slip10RawIndex.hardened(118),
        $6f1ux.Slip10RawIndex.hardened(0),
        $6f1ux.Slip10RawIndex.normal(0),
        $6f1ux.Slip10RawIndex.normal(a)
    ];
}
$3746dfb862c9f264$exports.makeCosmoshubPath = $3746dfb862c9f264$var$makeCosmoshubPath;


Object.defineProperty($c0a9381c50e8ee56$exports, "makeCosmoshubPath", {
    enumerable: true,
    get: function() {
        return $3746dfb862c9f264$exports.makeCosmoshubPath;
    }
});
var $cc54f4fdaf0ea72e$exports = {};
"use strict";
Object.defineProperty($cc54f4fdaf0ea72e$exports, "__esModule", {
    value: true
});
$cc54f4fdaf0ea72e$exports.decodePubkey = $cc54f4fdaf0ea72e$exports.anyToSinglePubkey = $cc54f4fdaf0ea72e$exports.encodePubkey = void 0;


var $6XcLW = parcelRequire("6XcLW");

var $7UsfE = parcelRequire("7UsfE");
var $85618e6f70d91047$exports = {};
"use strict";
var $85618e6f70d91047$var$__createBinding = $85618e6f70d91047$exports && $85618e6f70d91047$exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $85618e6f70d91047$var$__setModuleDefault = $85618e6f70d91047$exports && $85618e6f70d91047$exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $85618e6f70d91047$var$__importStar = $85618e6f70d91047$exports && $85618e6f70d91047$exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $85618e6f70d91047$var$__createBinding(result, mod, k);
    }
    $85618e6f70d91047$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty($85618e6f70d91047$exports, "__esModule", {
    value: true
});
$85618e6f70d91047$exports.PrivKey = $85618e6f70d91047$exports.PubKey = $85618e6f70d91047$exports.protobufPackage = void 0;

/* eslint-disable */ const $85618e6f70d91047$var$_m0 = $85618e6f70d91047$var$__importStar((parcelRequire("fQBv0")));

$85618e6f70d91047$exports.protobufPackage = "cosmos.crypto.ed25519";
function $85618e6f70d91047$var$createBasePubKey() {
    return {
        key: new Uint8Array()
    };
}
$85618e6f70d91047$exports.PubKey = {
    encode (message, writer = $85618e6f70d91047$var$_m0.Writer.create()) {
        if (message.key.length !== 0) writer.uint32(10).bytes(message.key);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $85618e6f70d91047$var$_m0.Reader ? input : new $85618e6f70d91047$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $85618e6f70d91047$var$createBasePubKey();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.key = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            key: (0, $d5e07fe2518aae94$exports.isSet)(object.key) ? (0, $d5e07fe2518aae94$exports.bytesFromBase64)(object.key) : new Uint8Array()
        };
    },
    toJSON (message) {
        const obj = {};
        message.key !== undefined && (obj.key = (0, $d5e07fe2518aae94$exports.base64FromBytes)(message.key !== undefined ? message.key : new Uint8Array()));
        return obj;
    },
    fromPartial (object) {
        const message = $85618e6f70d91047$var$createBasePubKey();
        message.key = object.key ?? new Uint8Array();
        return message;
    }
};
function $85618e6f70d91047$var$createBasePrivKey() {
    return {
        key: new Uint8Array()
    };
}
$85618e6f70d91047$exports.PrivKey = {
    encode (message, writer = $85618e6f70d91047$var$_m0.Writer.create()) {
        if (message.key.length !== 0) writer.uint32(10).bytes(message.key);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $85618e6f70d91047$var$_m0.Reader ? input : new $85618e6f70d91047$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $85618e6f70d91047$var$createBasePrivKey();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.key = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            key: (0, $d5e07fe2518aae94$exports.isSet)(object.key) ? (0, $d5e07fe2518aae94$exports.bytesFromBase64)(object.key) : new Uint8Array()
        };
    },
    toJSON (message) {
        const obj = {};
        message.key !== undefined && (obj.key = (0, $d5e07fe2518aae94$exports.base64FromBytes)(message.key !== undefined ? message.key : new Uint8Array()));
        return obj;
    },
    fromPartial (object) {
        const message = $85618e6f70d91047$var$createBasePrivKey();
        message.key = object.key ?? new Uint8Array();
        return message;
    }
};


var $21dba21d25e5deee$exports = {};
"use strict";
var $21dba21d25e5deee$var$__createBinding = $21dba21d25e5deee$exports && $21dba21d25e5deee$exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $21dba21d25e5deee$var$__setModuleDefault = $21dba21d25e5deee$exports && $21dba21d25e5deee$exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $21dba21d25e5deee$var$__importStar = $21dba21d25e5deee$exports && $21dba21d25e5deee$exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $21dba21d25e5deee$var$__createBinding(result, mod, k);
    }
    $21dba21d25e5deee$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty($21dba21d25e5deee$exports, "__esModule", {
    value: true
});
$21dba21d25e5deee$exports.LegacyAminoPubKey = $21dba21d25e5deee$exports.protobufPackage = void 0;


const $21dba21d25e5deee$var$_m0 = $21dba21d25e5deee$var$__importStar((parcelRequire("fQBv0")));

$21dba21d25e5deee$exports.protobufPackage = "cosmos.crypto.multisig";
function $21dba21d25e5deee$var$createBaseLegacyAminoPubKey() {
    return {
        threshold: 0,
        publicKeys: []
    };
}
$21dba21d25e5deee$exports.LegacyAminoPubKey = {
    encode (message, writer = $21dba21d25e5deee$var$_m0.Writer.create()) {
        if (message.threshold !== 0) writer.uint32(8).uint32(message.threshold);
        for (const v of message.publicKeys)$64138e590dcf0cc1$exports.Any.encode(v, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $21dba21d25e5deee$var$_m0.Reader ? input : new $21dba21d25e5deee$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $21dba21d25e5deee$var$createBaseLegacyAminoPubKey();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.threshold = reader.uint32();
                    break;
                case 2:
                    message.publicKeys.push($64138e590dcf0cc1$exports.Any.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            threshold: (0, $d5e07fe2518aae94$exports.isSet)(object.threshold) ? Number(object.threshold) : 0,
            publicKeys: Array.isArray(object?.publicKeys) ? object.publicKeys.map((e)=>$64138e590dcf0cc1$exports.Any.fromJSON(e)) : []
        };
    },
    toJSON (message) {
        const obj = {};
        message.threshold !== undefined && (obj.threshold = Math.round(message.threshold));
        if (message.publicKeys) obj.publicKeys = message.publicKeys.map((e)=>e ? $64138e590dcf0cc1$exports.Any.toJSON(e) : undefined);
        else obj.publicKeys = [];
        return obj;
    },
    fromPartial (object) {
        const message = $21dba21d25e5deee$var$createBaseLegacyAminoPubKey();
        message.threshold = object.threshold ?? 0;
        message.publicKeys = object.publicKeys?.map((e)=>$64138e590dcf0cc1$exports.Any.fromPartial(e)) || [];
        return message;
    }
};


var $25adc19aacc7f420$exports = {};
"use strict";
var $25adc19aacc7f420$var$__createBinding = $25adc19aacc7f420$exports && $25adc19aacc7f420$exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $25adc19aacc7f420$var$__setModuleDefault = $25adc19aacc7f420$exports && $25adc19aacc7f420$exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $25adc19aacc7f420$var$__importStar = $25adc19aacc7f420$exports && $25adc19aacc7f420$exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $25adc19aacc7f420$var$__createBinding(result, mod, k);
    }
    $25adc19aacc7f420$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty($25adc19aacc7f420$exports, "__esModule", {
    value: true
});
$25adc19aacc7f420$exports.PrivKey = $25adc19aacc7f420$exports.PubKey = $25adc19aacc7f420$exports.protobufPackage = void 0;

/* eslint-disable */ const $25adc19aacc7f420$var$_m0 = $25adc19aacc7f420$var$__importStar((parcelRequire("fQBv0")));

$25adc19aacc7f420$exports.protobufPackage = "cosmos.crypto.secp256k1";
function $25adc19aacc7f420$var$createBasePubKey() {
    return {
        key: new Uint8Array()
    };
}
$25adc19aacc7f420$exports.PubKey = {
    encode (message, writer = $25adc19aacc7f420$var$_m0.Writer.create()) {
        if (message.key.length !== 0) writer.uint32(10).bytes(message.key);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $25adc19aacc7f420$var$_m0.Reader ? input : new $25adc19aacc7f420$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $25adc19aacc7f420$var$createBasePubKey();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.key = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            key: (0, $d5e07fe2518aae94$exports.isSet)(object.key) ? (0, $d5e07fe2518aae94$exports.bytesFromBase64)(object.key) : new Uint8Array()
        };
    },
    toJSON (message) {
        const obj = {};
        message.key !== undefined && (obj.key = (0, $d5e07fe2518aae94$exports.base64FromBytes)(message.key !== undefined ? message.key : new Uint8Array()));
        return obj;
    },
    fromPartial (object) {
        const message = $25adc19aacc7f420$var$createBasePubKey();
        message.key = object.key ?? new Uint8Array();
        return message;
    }
};
function $25adc19aacc7f420$var$createBasePrivKey() {
    return {
        key: new Uint8Array()
    };
}
$25adc19aacc7f420$exports.PrivKey = {
    encode (message, writer = $25adc19aacc7f420$var$_m0.Writer.create()) {
        if (message.key.length !== 0) writer.uint32(10).bytes(message.key);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $25adc19aacc7f420$var$_m0.Reader ? input : new $25adc19aacc7f420$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $25adc19aacc7f420$var$createBasePrivKey();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.key = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            key: (0, $d5e07fe2518aae94$exports.isSet)(object.key) ? (0, $d5e07fe2518aae94$exports.bytesFromBase64)(object.key) : new Uint8Array()
        };
    },
    toJSON (message) {
        const obj = {};
        message.key !== undefined && (obj.key = (0, $d5e07fe2518aae94$exports.base64FromBytes)(message.key !== undefined ? message.key : new Uint8Array()));
        return obj;
    },
    fromPartial (object) {
        const message = $25adc19aacc7f420$var$createBasePrivKey();
        message.key = object.key ?? new Uint8Array();
        return message;
    }
};



/**
 * Takes a pubkey in the Amino JSON object style (type/value wrapper)
 * and convertes it into a protobuf `Any`.
 *
 * This is the reverse operation to `decodePubkey`.
 */ function $cc54f4fdaf0ea72e$var$encodePubkey(pubkey) {
    if ((0, $6078e8ec636191fb$exports.isSecp256k1Pubkey)(pubkey)) {
        const pubkeyProto = $25adc19aacc7f420$exports.PubKey.fromPartial({
            key: (0, $6XcLW.fromBase64)(pubkey.value)
        });
        return $64138e590dcf0cc1$exports.Any.fromPartial({
            typeUrl: "/cosmos.crypto.secp256k1.PubKey",
            value: Uint8Array.from($25adc19aacc7f420$exports.PubKey.encode(pubkeyProto).finish())
        });
    } else if ((0, $6078e8ec636191fb$exports.isEd25519Pubkey)(pubkey)) {
        const pubkeyProto = $85618e6f70d91047$exports.PubKey.fromPartial({
            key: (0, $6XcLW.fromBase64)(pubkey.value)
        });
        return $64138e590dcf0cc1$exports.Any.fromPartial({
            typeUrl: "/cosmos.crypto.ed25519.PubKey",
            value: Uint8Array.from($85618e6f70d91047$exports.PubKey.encode(pubkeyProto).finish())
        });
    } else if ((0, $6078e8ec636191fb$exports.isMultisigThresholdPubkey)(pubkey)) {
        const pubkeyProto = $21dba21d25e5deee$exports.LegacyAminoPubKey.fromPartial({
            threshold: $7UsfE.Uint53.fromString(pubkey.value.threshold).toNumber(),
            publicKeys: pubkey.value.pubkeys.map($cc54f4fdaf0ea72e$var$encodePubkey)
        });
        return $64138e590dcf0cc1$exports.Any.fromPartial({
            typeUrl: "/cosmos.crypto.multisig.LegacyAminoPubKey",
            value: Uint8Array.from($21dba21d25e5deee$exports.LegacyAminoPubKey.encode(pubkeyProto).finish())
        });
    } else throw new Error(`Pubkey type ${pubkey.type} not recognized`);
}
$cc54f4fdaf0ea72e$exports.encodePubkey = $cc54f4fdaf0ea72e$var$encodePubkey;
/**
 * Decodes a single pubkey (i.e. not a multisig pubkey) from `Any` into
 * `SinglePubkey`.
 *
 * In most cases you probably want to use `decodePubkey`.
 */ function $cc54f4fdaf0ea72e$var$anyToSinglePubkey(pubkey) {
    switch(pubkey.typeUrl){
        case "/cosmos.crypto.secp256k1.PubKey":
            {
                const { key: key } = $25adc19aacc7f420$exports.PubKey.decode(pubkey.value);
                return (0, $6078e8ec636191fb$exports.encodeSecp256k1Pubkey)(key);
            }
        case "/cosmos.crypto.ed25519.PubKey":
            {
                const { key: key } = $85618e6f70d91047$exports.PubKey.decode(pubkey.value);
                return (0, $6078e8ec636191fb$exports.encodeEd25519Pubkey)(key);
            }
        default:
            throw new Error(`Pubkey type_url ${pubkey.typeUrl} not recognized as single public key type`);
    }
}
$cc54f4fdaf0ea72e$exports.anyToSinglePubkey = $cc54f4fdaf0ea72e$var$anyToSinglePubkey;
/**
 * Decodes a pubkey from a protobuf `Any` into `Pubkey`.
 * This supports single pubkeys such as Cosmos ed25519 and secp256k1 keys
 * as well as multisig threshold pubkeys.
 */ function $cc54f4fdaf0ea72e$var$decodePubkey(pubkey) {
    switch(pubkey.typeUrl){
        case "/cosmos.crypto.secp256k1.PubKey":
        case "/cosmos.crypto.ed25519.PubKey":
            return $cc54f4fdaf0ea72e$var$anyToSinglePubkey(pubkey);
        case "/cosmos.crypto.multisig.LegacyAminoPubKey":
            {
                const { threshold: threshold, publicKeys: publicKeys } = $21dba21d25e5deee$exports.LegacyAminoPubKey.decode(pubkey.value);
                const out = {
                    type: "tendermint/PubKeyMultisigThreshold",
                    value: {
                        threshold: threshold.toString(),
                        pubkeys: publicKeys.map($cc54f4fdaf0ea72e$var$anyToSinglePubkey)
                    }
                };
                return out;
            }
        default:
            throw new Error(`Pubkey type_url ${pubkey.typeUrl} not recognized`);
    }
}
$cc54f4fdaf0ea72e$exports.decodePubkey = $cc54f4fdaf0ea72e$var$decodePubkey;


Object.defineProperty($c0a9381c50e8ee56$exports, "anyToSinglePubkey", {
    enumerable: true,
    get: function() {
        return $cc54f4fdaf0ea72e$exports.anyToSinglePubkey;
    }
});
Object.defineProperty($c0a9381c50e8ee56$exports, "decodePubkey", {
    enumerable: true,
    get: function() {
        return $cc54f4fdaf0ea72e$exports.decodePubkey;
    }
});
Object.defineProperty($c0a9381c50e8ee56$exports, "encodePubkey", {
    enumerable: true,
    get: function() {
        return $cc54f4fdaf0ea72e$exports.encodePubkey;
    }
});
var $37c902fea27560f9$exports = {};

var $ihoyg = parcelRequire("ihoyg");
var $37c902fea27560f9$require$Buffer = $ihoyg.Buffer;
"use strict";
Object.defineProperty($37c902fea27560f9$exports, "__esModule", {
    value: true
});
$37c902fea27560f9$exports.Registry = $37c902fea27560f9$exports.isTxBodyEncodeObject = $37c902fea27560f9$exports.isPbjsGeneratedType = $37c902fea27560f9$exports.isTsProtoGeneratedType = void 0;
var $34c46a888039c4e4$exports = {};
"use strict";
var $34c46a888039c4e4$var$__createBinding = $34c46a888039c4e4$exports && $34c46a888039c4e4$exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $34c46a888039c4e4$var$__setModuleDefault = $34c46a888039c4e4$exports && $34c46a888039c4e4$exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $34c46a888039c4e4$var$__importStar = $34c46a888039c4e4$exports && $34c46a888039c4e4$exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $34c46a888039c4e4$var$__createBinding(result, mod, k);
    }
    $34c46a888039c4e4$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty($34c46a888039c4e4$exports, "__esModule", {
    value: true
});
$34c46a888039c4e4$exports.MsgClientImpl = $34c46a888039c4e4$exports.MsgSetSendEnabledResponse = $34c46a888039c4e4$exports.MsgSetSendEnabled = $34c46a888039c4e4$exports.MsgUpdateParamsResponse = $34c46a888039c4e4$exports.MsgUpdateParams = $34c46a888039c4e4$exports.MsgMultiSendResponse = $34c46a888039c4e4$exports.MsgMultiSend = $34c46a888039c4e4$exports.MsgSendResponse = $34c46a888039c4e4$exports.MsgSend = $34c46a888039c4e4$exports.protobufPackage = void 0;

var $3d7c161a5bad8b39$exports = {};
"use strict";
var $3d7c161a5bad8b39$var$__createBinding = $3d7c161a5bad8b39$exports && $3d7c161a5bad8b39$exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $3d7c161a5bad8b39$var$__setModuleDefault = $3d7c161a5bad8b39$exports && $3d7c161a5bad8b39$exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $3d7c161a5bad8b39$var$__importStar = $3d7c161a5bad8b39$exports && $3d7c161a5bad8b39$exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $3d7c161a5bad8b39$var$__createBinding(result, mod, k);
    }
    $3d7c161a5bad8b39$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty($3d7c161a5bad8b39$exports, "__esModule", {
    value: true
});
$3d7c161a5bad8b39$exports.Metadata = $3d7c161a5bad8b39$exports.DenomUnit = $3d7c161a5bad8b39$exports.Supply = $3d7c161a5bad8b39$exports.Output = $3d7c161a5bad8b39$exports.Input = $3d7c161a5bad8b39$exports.SendEnabled = $3d7c161a5bad8b39$exports.Params = $3d7c161a5bad8b39$exports.protobufPackage = void 0;


const $3d7c161a5bad8b39$var$_m0 = $3d7c161a5bad8b39$var$__importStar((parcelRequire("fQBv0")));

$3d7c161a5bad8b39$exports.protobufPackage = "cosmos.bank.v1beta1";
function $3d7c161a5bad8b39$var$createBaseParams() {
    return {
        sendEnabled: [],
        defaultSendEnabled: false
    };
}
$3d7c161a5bad8b39$exports.Params = {
    encode (message, writer = $3d7c161a5bad8b39$var$_m0.Writer.create()) {
        for (const v of message.sendEnabled)$3d7c161a5bad8b39$exports.SendEnabled.encode(v, writer.uint32(10).fork()).ldelim();
        if (message.defaultSendEnabled === true) writer.uint32(16).bool(message.defaultSendEnabled);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $3d7c161a5bad8b39$var$_m0.Reader ? input : new $3d7c161a5bad8b39$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $3d7c161a5bad8b39$var$createBaseParams();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.sendEnabled.push($3d7c161a5bad8b39$exports.SendEnabled.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.defaultSendEnabled = reader.bool();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            sendEnabled: Array.isArray(object?.sendEnabled) ? object.sendEnabled.map((e)=>$3d7c161a5bad8b39$exports.SendEnabled.fromJSON(e)) : [],
            defaultSendEnabled: (0, $d5e07fe2518aae94$exports.isSet)(object.defaultSendEnabled) ? Boolean(object.defaultSendEnabled) : false
        };
    },
    toJSON (message) {
        const obj = {};
        if (message.sendEnabled) obj.sendEnabled = message.sendEnabled.map((e)=>e ? $3d7c161a5bad8b39$exports.SendEnabled.toJSON(e) : undefined);
        else obj.sendEnabled = [];
        message.defaultSendEnabled !== undefined && (obj.defaultSendEnabled = message.defaultSendEnabled);
        return obj;
    },
    fromPartial (object) {
        const message = $3d7c161a5bad8b39$var$createBaseParams();
        message.sendEnabled = object.sendEnabled?.map((e)=>$3d7c161a5bad8b39$exports.SendEnabled.fromPartial(e)) || [];
        message.defaultSendEnabled = object.defaultSendEnabled ?? false;
        return message;
    }
};
function $3d7c161a5bad8b39$var$createBaseSendEnabled() {
    return {
        denom: "",
        enabled: false
    };
}
$3d7c161a5bad8b39$exports.SendEnabled = {
    encode (message, writer = $3d7c161a5bad8b39$var$_m0.Writer.create()) {
        if (message.denom !== "") writer.uint32(10).string(message.denom);
        if (message.enabled === true) writer.uint32(16).bool(message.enabled);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $3d7c161a5bad8b39$var$_m0.Reader ? input : new $3d7c161a5bad8b39$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $3d7c161a5bad8b39$var$createBaseSendEnabled();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.denom = reader.string();
                    break;
                case 2:
                    message.enabled = reader.bool();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            denom: (0, $d5e07fe2518aae94$exports.isSet)(object.denom) ? String(object.denom) : "",
            enabled: (0, $d5e07fe2518aae94$exports.isSet)(object.enabled) ? Boolean(object.enabled) : false
        };
    },
    toJSON (message) {
        const obj = {};
        message.denom !== undefined && (obj.denom = message.denom);
        message.enabled !== undefined && (obj.enabled = message.enabled);
        return obj;
    },
    fromPartial (object) {
        const message = $3d7c161a5bad8b39$var$createBaseSendEnabled();
        message.denom = object.denom ?? "";
        message.enabled = object.enabled ?? false;
        return message;
    }
};
function $3d7c161a5bad8b39$var$createBaseInput() {
    return {
        address: "",
        coins: []
    };
}
$3d7c161a5bad8b39$exports.Input = {
    encode (message, writer = $3d7c161a5bad8b39$var$_m0.Writer.create()) {
        if (message.address !== "") writer.uint32(10).string(message.address);
        for (const v of message.coins)$783dd8715fde0fcf$exports.Coin.encode(v, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $3d7c161a5bad8b39$var$_m0.Reader ? input : new $3d7c161a5bad8b39$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $3d7c161a5bad8b39$var$createBaseInput();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.address = reader.string();
                    break;
                case 2:
                    message.coins.push($783dd8715fde0fcf$exports.Coin.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            address: (0, $d5e07fe2518aae94$exports.isSet)(object.address) ? String(object.address) : "",
            coins: Array.isArray(object?.coins) ? object.coins.map((e)=>$783dd8715fde0fcf$exports.Coin.fromJSON(e)) : []
        };
    },
    toJSON (message) {
        const obj = {};
        message.address !== undefined && (obj.address = message.address);
        if (message.coins) obj.coins = message.coins.map((e)=>e ? $783dd8715fde0fcf$exports.Coin.toJSON(e) : undefined);
        else obj.coins = [];
        return obj;
    },
    fromPartial (object) {
        const message = $3d7c161a5bad8b39$var$createBaseInput();
        message.address = object.address ?? "";
        message.coins = object.coins?.map((e)=>$783dd8715fde0fcf$exports.Coin.fromPartial(e)) || [];
        return message;
    }
};
function $3d7c161a5bad8b39$var$createBaseOutput() {
    return {
        address: "",
        coins: []
    };
}
$3d7c161a5bad8b39$exports.Output = {
    encode (message, writer = $3d7c161a5bad8b39$var$_m0.Writer.create()) {
        if (message.address !== "") writer.uint32(10).string(message.address);
        for (const v of message.coins)$783dd8715fde0fcf$exports.Coin.encode(v, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $3d7c161a5bad8b39$var$_m0.Reader ? input : new $3d7c161a5bad8b39$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $3d7c161a5bad8b39$var$createBaseOutput();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.address = reader.string();
                    break;
                case 2:
                    message.coins.push($783dd8715fde0fcf$exports.Coin.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            address: (0, $d5e07fe2518aae94$exports.isSet)(object.address) ? String(object.address) : "",
            coins: Array.isArray(object?.coins) ? object.coins.map((e)=>$783dd8715fde0fcf$exports.Coin.fromJSON(e)) : []
        };
    },
    toJSON (message) {
        const obj = {};
        message.address !== undefined && (obj.address = message.address);
        if (message.coins) obj.coins = message.coins.map((e)=>e ? $783dd8715fde0fcf$exports.Coin.toJSON(e) : undefined);
        else obj.coins = [];
        return obj;
    },
    fromPartial (object) {
        const message = $3d7c161a5bad8b39$var$createBaseOutput();
        message.address = object.address ?? "";
        message.coins = object.coins?.map((e)=>$783dd8715fde0fcf$exports.Coin.fromPartial(e)) || [];
        return message;
    }
};
function $3d7c161a5bad8b39$var$createBaseSupply() {
    return {
        total: []
    };
}
$3d7c161a5bad8b39$exports.Supply = {
    encode (message, writer = $3d7c161a5bad8b39$var$_m0.Writer.create()) {
        for (const v of message.total)$783dd8715fde0fcf$exports.Coin.encode(v, writer.uint32(10).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $3d7c161a5bad8b39$var$_m0.Reader ? input : new $3d7c161a5bad8b39$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $3d7c161a5bad8b39$var$createBaseSupply();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.total.push($783dd8715fde0fcf$exports.Coin.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            total: Array.isArray(object?.total) ? object.total.map((e)=>$783dd8715fde0fcf$exports.Coin.fromJSON(e)) : []
        };
    },
    toJSON (message) {
        const obj = {};
        if (message.total) obj.total = message.total.map((e)=>e ? $783dd8715fde0fcf$exports.Coin.toJSON(e) : undefined);
        else obj.total = [];
        return obj;
    },
    fromPartial (object) {
        const message = $3d7c161a5bad8b39$var$createBaseSupply();
        message.total = object.total?.map((e)=>$783dd8715fde0fcf$exports.Coin.fromPartial(e)) || [];
        return message;
    }
};
function $3d7c161a5bad8b39$var$createBaseDenomUnit() {
    return {
        denom: "",
        exponent: 0,
        aliases: []
    };
}
$3d7c161a5bad8b39$exports.DenomUnit = {
    encode (message, writer = $3d7c161a5bad8b39$var$_m0.Writer.create()) {
        if (message.denom !== "") writer.uint32(10).string(message.denom);
        if (message.exponent !== 0) writer.uint32(16).uint32(message.exponent);
        for (const v of message.aliases)writer.uint32(26).string(v);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $3d7c161a5bad8b39$var$_m0.Reader ? input : new $3d7c161a5bad8b39$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $3d7c161a5bad8b39$var$createBaseDenomUnit();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.denom = reader.string();
                    break;
                case 2:
                    message.exponent = reader.uint32();
                    break;
                case 3:
                    message.aliases.push(reader.string());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            denom: (0, $d5e07fe2518aae94$exports.isSet)(object.denom) ? String(object.denom) : "",
            exponent: (0, $d5e07fe2518aae94$exports.isSet)(object.exponent) ? Number(object.exponent) : 0,
            aliases: Array.isArray(object?.aliases) ? object.aliases.map((e)=>String(e)) : []
        };
    },
    toJSON (message) {
        const obj = {};
        message.denom !== undefined && (obj.denom = message.denom);
        message.exponent !== undefined && (obj.exponent = Math.round(message.exponent));
        if (message.aliases) obj.aliases = message.aliases.map((e)=>e);
        else obj.aliases = [];
        return obj;
    },
    fromPartial (object) {
        const message = $3d7c161a5bad8b39$var$createBaseDenomUnit();
        message.denom = object.denom ?? "";
        message.exponent = object.exponent ?? 0;
        message.aliases = object.aliases?.map((e)=>e) || [];
        return message;
    }
};
function $3d7c161a5bad8b39$var$createBaseMetadata() {
    return {
        description: "",
        denomUnits: [],
        base: "",
        display: "",
        name: "",
        symbol: "",
        uri: "",
        uriHash: ""
    };
}
$3d7c161a5bad8b39$exports.Metadata = {
    encode (message, writer = $3d7c161a5bad8b39$var$_m0.Writer.create()) {
        if (message.description !== "") writer.uint32(10).string(message.description);
        for (const v of message.denomUnits)$3d7c161a5bad8b39$exports.DenomUnit.encode(v, writer.uint32(18).fork()).ldelim();
        if (message.base !== "") writer.uint32(26).string(message.base);
        if (message.display !== "") writer.uint32(34).string(message.display);
        if (message.name !== "") writer.uint32(42).string(message.name);
        if (message.symbol !== "") writer.uint32(50).string(message.symbol);
        if (message.uri !== "") writer.uint32(58).string(message.uri);
        if (message.uriHash !== "") writer.uint32(66).string(message.uriHash);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $3d7c161a5bad8b39$var$_m0.Reader ? input : new $3d7c161a5bad8b39$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $3d7c161a5bad8b39$var$createBaseMetadata();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.description = reader.string();
                    break;
                case 2:
                    message.denomUnits.push($3d7c161a5bad8b39$exports.DenomUnit.decode(reader, reader.uint32()));
                    break;
                case 3:
                    message.base = reader.string();
                    break;
                case 4:
                    message.display = reader.string();
                    break;
                case 5:
                    message.name = reader.string();
                    break;
                case 6:
                    message.symbol = reader.string();
                    break;
                case 7:
                    message.uri = reader.string();
                    break;
                case 8:
                    message.uriHash = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            description: (0, $d5e07fe2518aae94$exports.isSet)(object.description) ? String(object.description) : "",
            denomUnits: Array.isArray(object?.denomUnits) ? object.denomUnits.map((e)=>$3d7c161a5bad8b39$exports.DenomUnit.fromJSON(e)) : [],
            base: (0, $d5e07fe2518aae94$exports.isSet)(object.base) ? String(object.base) : "",
            display: (0, $d5e07fe2518aae94$exports.isSet)(object.display) ? String(object.display) : "",
            name: (0, $d5e07fe2518aae94$exports.isSet)(object.name) ? String(object.name) : "",
            symbol: (0, $d5e07fe2518aae94$exports.isSet)(object.symbol) ? String(object.symbol) : "",
            uri: (0, $d5e07fe2518aae94$exports.isSet)(object.uri) ? String(object.uri) : "",
            uriHash: (0, $d5e07fe2518aae94$exports.isSet)(object.uriHash) ? String(object.uriHash) : ""
        };
    },
    toJSON (message) {
        const obj = {};
        message.description !== undefined && (obj.description = message.description);
        if (message.denomUnits) obj.denomUnits = message.denomUnits.map((e)=>e ? $3d7c161a5bad8b39$exports.DenomUnit.toJSON(e) : undefined);
        else obj.denomUnits = [];
        message.base !== undefined && (obj.base = message.base);
        message.display !== undefined && (obj.display = message.display);
        message.name !== undefined && (obj.name = message.name);
        message.symbol !== undefined && (obj.symbol = message.symbol);
        message.uri !== undefined && (obj.uri = message.uri);
        message.uriHash !== undefined && (obj.uriHash = message.uriHash);
        return obj;
    },
    fromPartial (object) {
        const message = $3d7c161a5bad8b39$var$createBaseMetadata();
        message.description = object.description ?? "";
        message.denomUnits = object.denomUnits?.map((e)=>$3d7c161a5bad8b39$exports.DenomUnit.fromPartial(e)) || [];
        message.base = object.base ?? "";
        message.display = object.display ?? "";
        message.name = object.name ?? "";
        message.symbol = object.symbol ?? "";
        message.uri = object.uri ?? "";
        message.uriHash = object.uriHash ?? "";
        return message;
    }
};



const $34c46a888039c4e4$var$_m0 = $34c46a888039c4e4$var$__importStar((parcelRequire("fQBv0")));

$34c46a888039c4e4$exports.protobufPackage = "cosmos.bank.v1beta1";
function $34c46a888039c4e4$var$createBaseMsgSend() {
    return {
        fromAddress: "",
        toAddress: "",
        amount: []
    };
}
$34c46a888039c4e4$exports.MsgSend = {
    encode (message, writer = $34c46a888039c4e4$var$_m0.Writer.create()) {
        if (message.fromAddress !== "") writer.uint32(10).string(message.fromAddress);
        if (message.toAddress !== "") writer.uint32(18).string(message.toAddress);
        for (const v of message.amount)$783dd8715fde0fcf$exports.Coin.encode(v, writer.uint32(26).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $34c46a888039c4e4$var$_m0.Reader ? input : new $34c46a888039c4e4$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $34c46a888039c4e4$var$createBaseMsgSend();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.fromAddress = reader.string();
                    break;
                case 2:
                    message.toAddress = reader.string();
                    break;
                case 3:
                    message.amount.push($783dd8715fde0fcf$exports.Coin.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            fromAddress: (0, $d5e07fe2518aae94$exports.isSet)(object.fromAddress) ? String(object.fromAddress) : "",
            toAddress: (0, $d5e07fe2518aae94$exports.isSet)(object.toAddress) ? String(object.toAddress) : "",
            amount: Array.isArray(object?.amount) ? object.amount.map((e)=>$783dd8715fde0fcf$exports.Coin.fromJSON(e)) : []
        };
    },
    toJSON (message) {
        const obj = {};
        message.fromAddress !== undefined && (obj.fromAddress = message.fromAddress);
        message.toAddress !== undefined && (obj.toAddress = message.toAddress);
        if (message.amount) obj.amount = message.amount.map((e)=>e ? $783dd8715fde0fcf$exports.Coin.toJSON(e) : undefined);
        else obj.amount = [];
        return obj;
    },
    fromPartial (object) {
        const message = $34c46a888039c4e4$var$createBaseMsgSend();
        message.fromAddress = object.fromAddress ?? "";
        message.toAddress = object.toAddress ?? "";
        message.amount = object.amount?.map((e)=>$783dd8715fde0fcf$exports.Coin.fromPartial(e)) || [];
        return message;
    }
};
function $34c46a888039c4e4$var$createBaseMsgSendResponse() {
    return {};
}
$34c46a888039c4e4$exports.MsgSendResponse = {
    encode (_, writer = $34c46a888039c4e4$var$_m0.Writer.create()) {
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $34c46a888039c4e4$var$_m0.Reader ? input : new $34c46a888039c4e4$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $34c46a888039c4e4$var$createBaseMsgSendResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            tag;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON (_) {
        return {};
    },
    toJSON (_) {
        const obj = {};
        return obj;
    },
    fromPartial (_) {
        const message = $34c46a888039c4e4$var$createBaseMsgSendResponse();
        return message;
    }
};
function $34c46a888039c4e4$var$createBaseMsgMultiSend() {
    return {
        inputs: [],
        outputs: []
    };
}
$34c46a888039c4e4$exports.MsgMultiSend = {
    encode (message, writer = $34c46a888039c4e4$var$_m0.Writer.create()) {
        for (const v of message.inputs)$3d7c161a5bad8b39$exports.Input.encode(v, writer.uint32(10).fork()).ldelim();
        for (const v of message.outputs)$3d7c161a5bad8b39$exports.Output.encode(v, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $34c46a888039c4e4$var$_m0.Reader ? input : new $34c46a888039c4e4$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $34c46a888039c4e4$var$createBaseMsgMultiSend();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.inputs.push($3d7c161a5bad8b39$exports.Input.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.outputs.push($3d7c161a5bad8b39$exports.Output.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            inputs: Array.isArray(object?.inputs) ? object.inputs.map((e)=>$3d7c161a5bad8b39$exports.Input.fromJSON(e)) : [],
            outputs: Array.isArray(object?.outputs) ? object.outputs.map((e)=>$3d7c161a5bad8b39$exports.Output.fromJSON(e)) : []
        };
    },
    toJSON (message) {
        const obj = {};
        if (message.inputs) obj.inputs = message.inputs.map((e)=>e ? $3d7c161a5bad8b39$exports.Input.toJSON(e) : undefined);
        else obj.inputs = [];
        if (message.outputs) obj.outputs = message.outputs.map((e)=>e ? $3d7c161a5bad8b39$exports.Output.toJSON(e) : undefined);
        else obj.outputs = [];
        return obj;
    },
    fromPartial (object) {
        const message = $34c46a888039c4e4$var$createBaseMsgMultiSend();
        message.inputs = object.inputs?.map((e)=>$3d7c161a5bad8b39$exports.Input.fromPartial(e)) || [];
        message.outputs = object.outputs?.map((e)=>$3d7c161a5bad8b39$exports.Output.fromPartial(e)) || [];
        return message;
    }
};
function $34c46a888039c4e4$var$createBaseMsgMultiSendResponse() {
    return {};
}
$34c46a888039c4e4$exports.MsgMultiSendResponse = {
    encode (_, writer = $34c46a888039c4e4$var$_m0.Writer.create()) {
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $34c46a888039c4e4$var$_m0.Reader ? input : new $34c46a888039c4e4$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $34c46a888039c4e4$var$createBaseMsgMultiSendResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            tag;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON (_) {
        return {};
    },
    toJSON (_) {
        const obj = {};
        return obj;
    },
    fromPartial (_) {
        const message = $34c46a888039c4e4$var$createBaseMsgMultiSendResponse();
        return message;
    }
};
function $34c46a888039c4e4$var$createBaseMsgUpdateParams() {
    return {
        authority: "",
        params: undefined
    };
}
$34c46a888039c4e4$exports.MsgUpdateParams = {
    encode (message, writer = $34c46a888039c4e4$var$_m0.Writer.create()) {
        if (message.authority !== "") writer.uint32(10).string(message.authority);
        if (message.params !== undefined) $3d7c161a5bad8b39$exports.Params.encode(message.params, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $34c46a888039c4e4$var$_m0.Reader ? input : new $34c46a888039c4e4$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $34c46a888039c4e4$var$createBaseMsgUpdateParams();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.authority = reader.string();
                    break;
                case 2:
                    message.params = $3d7c161a5bad8b39$exports.Params.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            authority: (0, $d5e07fe2518aae94$exports.isSet)(object.authority) ? String(object.authority) : "",
            params: (0, $d5e07fe2518aae94$exports.isSet)(object.params) ? $3d7c161a5bad8b39$exports.Params.fromJSON(object.params) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.authority !== undefined && (obj.authority = message.authority);
        message.params !== undefined && (obj.params = message.params ? $3d7c161a5bad8b39$exports.Params.toJSON(message.params) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $34c46a888039c4e4$var$createBaseMsgUpdateParams();
        message.authority = object.authority ?? "";
        message.params = object.params !== undefined && object.params !== null ? $3d7c161a5bad8b39$exports.Params.fromPartial(object.params) : undefined;
        return message;
    }
};
function $34c46a888039c4e4$var$createBaseMsgUpdateParamsResponse() {
    return {};
}
$34c46a888039c4e4$exports.MsgUpdateParamsResponse = {
    encode (_, writer = $34c46a888039c4e4$var$_m0.Writer.create()) {
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $34c46a888039c4e4$var$_m0.Reader ? input : new $34c46a888039c4e4$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $34c46a888039c4e4$var$createBaseMsgUpdateParamsResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            tag;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON (_) {
        return {};
    },
    toJSON (_) {
        const obj = {};
        return obj;
    },
    fromPartial (_) {
        const message = $34c46a888039c4e4$var$createBaseMsgUpdateParamsResponse();
        return message;
    }
};
function $34c46a888039c4e4$var$createBaseMsgSetSendEnabled() {
    return {
        authority: "",
        sendEnabled: [],
        useDefaultFor: []
    };
}
$34c46a888039c4e4$exports.MsgSetSendEnabled = {
    encode (message, writer = $34c46a888039c4e4$var$_m0.Writer.create()) {
        if (message.authority !== "") writer.uint32(10).string(message.authority);
        for (const v of message.sendEnabled)$3d7c161a5bad8b39$exports.SendEnabled.encode(v, writer.uint32(18).fork()).ldelim();
        for (const v of message.useDefaultFor)writer.uint32(26).string(v);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $34c46a888039c4e4$var$_m0.Reader ? input : new $34c46a888039c4e4$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $34c46a888039c4e4$var$createBaseMsgSetSendEnabled();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.authority = reader.string();
                    break;
                case 2:
                    message.sendEnabled.push($3d7c161a5bad8b39$exports.SendEnabled.decode(reader, reader.uint32()));
                    break;
                case 3:
                    message.useDefaultFor.push(reader.string());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            authority: (0, $d5e07fe2518aae94$exports.isSet)(object.authority) ? String(object.authority) : "",
            sendEnabled: Array.isArray(object?.sendEnabled) ? object.sendEnabled.map((e)=>$3d7c161a5bad8b39$exports.SendEnabled.fromJSON(e)) : [],
            useDefaultFor: Array.isArray(object?.useDefaultFor) ? object.useDefaultFor.map((e)=>String(e)) : []
        };
    },
    toJSON (message) {
        const obj = {};
        message.authority !== undefined && (obj.authority = message.authority);
        if (message.sendEnabled) obj.sendEnabled = message.sendEnabled.map((e)=>e ? $3d7c161a5bad8b39$exports.SendEnabled.toJSON(e) : undefined);
        else obj.sendEnabled = [];
        if (message.useDefaultFor) obj.useDefaultFor = message.useDefaultFor.map((e)=>e);
        else obj.useDefaultFor = [];
        return obj;
    },
    fromPartial (object) {
        const message = $34c46a888039c4e4$var$createBaseMsgSetSendEnabled();
        message.authority = object.authority ?? "";
        message.sendEnabled = object.sendEnabled?.map((e)=>$3d7c161a5bad8b39$exports.SendEnabled.fromPartial(e)) || [];
        message.useDefaultFor = object.useDefaultFor?.map((e)=>e) || [];
        return message;
    }
};
function $34c46a888039c4e4$var$createBaseMsgSetSendEnabledResponse() {
    return {};
}
$34c46a888039c4e4$exports.MsgSetSendEnabledResponse = {
    encode (_, writer = $34c46a888039c4e4$var$_m0.Writer.create()) {
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $34c46a888039c4e4$var$_m0.Reader ? input : new $34c46a888039c4e4$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $34c46a888039c4e4$var$createBaseMsgSetSendEnabledResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            tag;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON (_) {
        return {};
    },
    toJSON (_) {
        const obj = {};
        return obj;
    },
    fromPartial (_) {
        const message = $34c46a888039c4e4$var$createBaseMsgSetSendEnabledResponse();
        return message;
    }
};
class $34c46a888039c4e4$var$MsgClientImpl {
    constructor(rpc){
        this.rpc = rpc;
        this.Send = this.Send.bind(this);
        this.MultiSend = this.MultiSend.bind(this);
        this.UpdateParams = this.UpdateParams.bind(this);
        this.SetSendEnabled = this.SetSendEnabled.bind(this);
    }
    Send(request) {
        const data = $34c46a888039c4e4$exports.MsgSend.encode(request).finish();
        const promise = this.rpc.request("cosmos.bank.v1beta1.Msg", "Send", data);
        return promise.then((data)=>$34c46a888039c4e4$exports.MsgSendResponse.decode(new $34c46a888039c4e4$var$_m0.Reader(data)));
    }
    MultiSend(request) {
        const data = $34c46a888039c4e4$exports.MsgMultiSend.encode(request).finish();
        const promise = this.rpc.request("cosmos.bank.v1beta1.Msg", "MultiSend", data);
        return promise.then((data)=>$34c46a888039c4e4$exports.MsgMultiSendResponse.decode(new $34c46a888039c4e4$var$_m0.Reader(data)));
    }
    UpdateParams(request) {
        const data = $34c46a888039c4e4$exports.MsgUpdateParams.encode(request).finish();
        const promise = this.rpc.request("cosmos.bank.v1beta1.Msg", "UpdateParams", data);
        return promise.then((data)=>$34c46a888039c4e4$exports.MsgUpdateParamsResponse.decode(new $34c46a888039c4e4$var$_m0.Reader(data)));
    }
    SetSendEnabled(request) {
        const data = $34c46a888039c4e4$exports.MsgSetSendEnabled.encode(request).finish();
        const promise = this.rpc.request("cosmos.bank.v1beta1.Msg", "SetSendEnabled", data);
        return promise.then((data)=>$34c46a888039c4e4$exports.MsgSetSendEnabledResponse.decode(new $34c46a888039c4e4$var$_m0.Reader(data)));
    }
}
$34c46a888039c4e4$exports.MsgClientImpl = $34c46a888039c4e4$var$MsgClientImpl;





function $37c902fea27560f9$var$isTsProtoGeneratedType(type) {
    return typeof type.fromPartial === "function";
}
$37c902fea27560f9$exports.isTsProtoGeneratedType = $37c902fea27560f9$var$isTsProtoGeneratedType;
function $37c902fea27560f9$var$isPbjsGeneratedType(type) {
    return !$37c902fea27560f9$var$isTsProtoGeneratedType(type);
}
$37c902fea27560f9$exports.isPbjsGeneratedType = $37c902fea27560f9$var$isPbjsGeneratedType;
const $37c902fea27560f9$var$defaultTypeUrls = {
    cosmosCoin: "/cosmos.base.v1beta1.Coin",
    cosmosMsgSend: "/cosmos.bank.v1beta1.MsgSend",
    cosmosTxBody: "/cosmos.tx.v1beta1.TxBody",
    googleAny: "/google.protobuf.Any"
};
function $37c902fea27560f9$var$isTxBodyEncodeObject(encodeObject) {
    return encodeObject.typeUrl === "/cosmos.tx.v1beta1.TxBody";
}
$37c902fea27560f9$exports.isTxBodyEncodeObject = $37c902fea27560f9$var$isTxBodyEncodeObject;
class $37c902fea27560f9$var$Registry {
    /**
     * Creates a new Registry for mapping protobuf type identifiers/type URLs to
     * actual implementations. Those implementations are typically generated with ts-proto
     * but we also support protobuf.js as a type generator.
     *
     * If there is no parameter given, a `new Registry()` adds the types `Coin` and `MsgSend`
     * for historic reasons. Those can be overriden by customTypes.
     *
     * There are currently two methods for adding new types:
     * 1. Passing types to the constructor.
     * 2. Using the `register()` method
     */ constructor(customTypes){
        const { cosmosCoin: cosmosCoin, cosmosMsgSend: cosmosMsgSend } = $37c902fea27560f9$var$defaultTypeUrls;
        this.types = customTypes ? new Map([
            ...customTypes
        ]) : new Map([
            [
                cosmosCoin,
                $783dd8715fde0fcf$exports.Coin
            ],
            [
                cosmosMsgSend,
                $34c46a888039c4e4$exports.MsgSend
            ]
        ]);
    }
    register(typeUrl, type) {
        this.types.set(typeUrl, type);
    }
    /**
     * Looks up a type that was previously added to the registry.
     *
     * The generator information (ts-proto or pbjs) gets lost along the way.
     * If you need to work with the result type in TypeScript, you can use:
     *
     * ```
     * import { assert } from "@cosmjs/utils";
     *
     * const Coin = registry.lookupType("/cosmos.base.v1beta1.Coin");
     * assert(Coin); // Ensures not unset
     * assert(isTsProtoGeneratedType(Coin)); // Ensures this is the type we expect
     *
     * // Coin is typed TsProtoGeneratedType now.
     * ```
     */ lookupType(typeUrl) {
        return this.types.get(typeUrl);
    }
    lookupTypeWithError(typeUrl) {
        const type = this.lookupType(typeUrl);
        if (!type) throw new Error(`Unregistered type url: ${typeUrl}`);
        return type;
    }
    /**
     * Takes a typeUrl/value pair and encodes the value to protobuf if
     * the given type was previously registered.
     *
     * If the value has to be wrapped in an Any, this needs to be done
     * manually after this call. Or use `encodeAsAny` instead.
     */ encode(encodeObject) {
        const { value: value, typeUrl: typeUrl } = encodeObject;
        if ($37c902fea27560f9$var$isTxBodyEncodeObject(encodeObject)) return this.encodeTxBody(value);
        const type = this.lookupTypeWithError(typeUrl);
        const instance = $37c902fea27560f9$var$isTsProtoGeneratedType(type) ? type.fromPartial(value) : type.create(value);
        return type.encode(instance).finish();
    }
    /**
     * Takes a typeUrl/value pair and encodes the value to an Any if
     * the given type was previously registered.
     */ encodeAsAny(encodeObject) {
        const binaryValue = this.encode(encodeObject);
        return $64138e590dcf0cc1$exports.Any.fromPartial({
            typeUrl: encodeObject.typeUrl,
            value: binaryValue
        });
    }
    encodeTxBody(txBodyFields) {
        const wrappedMessages = txBodyFields.messages.map((message)=>this.encodeAsAny(message));
        const txBody = $eedf6d503be55212$exports.TxBody.fromPartial({
            ...txBodyFields,
            messages: wrappedMessages
        });
        return $eedf6d503be55212$exports.TxBody.encode(txBody).finish();
    }
    decode({ typeUrl: typeUrl, value: value }) {
        if (typeUrl === $37c902fea27560f9$var$defaultTypeUrls.cosmosTxBody) return this.decodeTxBody(value);
        const type = this.lookupTypeWithError(typeUrl);
        const decoded = type.decode(value);
        Object.entries(decoded).forEach(([key, val])=>{
            if (typeof $37c902fea27560f9$require$Buffer !== "undefined" && typeof $37c902fea27560f9$require$Buffer.isBuffer !== "undefined" && $37c902fea27560f9$require$Buffer.isBuffer(val)) decoded[key] = Uint8Array.from(val);
        });
        return decoded;
    }
    decodeTxBody(txBody) {
        const decodedTxBody = $eedf6d503be55212$exports.TxBody.decode(txBody);
        return {
            ...decodedTxBody,
            messages: decodedTxBody.messages.map(({ typeUrl: typeUrl, value: value })=>{
                if (!typeUrl) throw new Error("Missing type_url in Any");
                if (!value) throw new Error("Missing value in Any");
                return this.decode({
                    typeUrl: typeUrl,
                    value: value
                });
            })
        };
    }
}
$37c902fea27560f9$exports.Registry = $37c902fea27560f9$var$Registry;


Object.defineProperty($c0a9381c50e8ee56$exports, "isPbjsGeneratedType", {
    enumerable: true,
    get: function() {
        return $37c902fea27560f9$exports.isPbjsGeneratedType;
    }
});
Object.defineProperty($c0a9381c50e8ee56$exports, "isTsProtoGeneratedType", {
    enumerable: true,
    get: function() {
        return $37c902fea27560f9$exports.isTsProtoGeneratedType;
    }
});
Object.defineProperty($c0a9381c50e8ee56$exports, "isTxBodyEncodeObject", {
    enumerable: true,
    get: function() {
        return $37c902fea27560f9$exports.isTxBodyEncodeObject;
    }
});
Object.defineProperty($c0a9381c50e8ee56$exports, "Registry", {
    enumerable: true,
    get: function() {
        return $37c902fea27560f9$exports.Registry;
    }
});
var $bd99e8fece21a126$exports = {};
"use strict";
Object.defineProperty($bd99e8fece21a126$exports, "__esModule", {
    value: true
});
$bd99e8fece21a126$exports.isOfflineDirectSigner = void 0;
function $bd99e8fece21a126$var$isOfflineDirectSigner(signer) {
    return signer.signDirect !== undefined;
}
$bd99e8fece21a126$exports.isOfflineDirectSigner = $bd99e8fece21a126$var$isOfflineDirectSigner;


Object.defineProperty($c0a9381c50e8ee56$exports, "isOfflineDirectSigner", {
    enumerable: true,
    get: function() {
        return $bd99e8fece21a126$exports.isOfflineDirectSigner;
    }
});

Object.defineProperty($c0a9381c50e8ee56$exports, "makeAuthInfoBytes", {
    enumerable: true,
    get: function() {
        return $8eeafeb2969d4151$exports.makeAuthInfoBytes;
    }
});
Object.defineProperty($c0a9381c50e8ee56$exports, "makeSignBytes", {
    enumerable: true,
    get: function() {
        return $8eeafeb2969d4151$exports.makeSignBytes;
    }
});
Object.defineProperty($c0a9381c50e8ee56$exports, "makeSignDoc", {
    enumerable: true,
    get: function() {
        return $8eeafeb2969d4151$exports.makeSignDoc;
    }
});

Object.defineProperty($c0a9381c50e8ee56$exports, "executeKdf", {
    enumerable: true,
    get: function() {
        return $5dc5a6f45d5fe193$exports.executeKdf;
    }
});

Object.defineProperty($c0a9381c50e8ee56$exports, "coin", {
    enumerable: true,
    get: function() {
        return $6078e8ec636191fb$exports.coin;
    }
});
Object.defineProperty($c0a9381c50e8ee56$exports, "coins", {
    enumerable: true,
    get: function() {
        return $6078e8ec636191fb$exports.coins;
    }
});



var $fZwG5 = parcelRequire("fZwG5");
var $c31a5024779af595$exports = {};
"use strict";
var $c31a5024779af595$var$__createBinding = $c31a5024779af595$exports && $c31a5024779af595$exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $c31a5024779af595$var$__setModuleDefault = $c31a5024779af595$exports && $c31a5024779af595$exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $c31a5024779af595$var$__importStar = $c31a5024779af595$exports && $c31a5024779af595$exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $c31a5024779af595$var$__createBinding(result, mod, k);
    }
    $c31a5024779af595$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty($c31a5024779af595$exports, "__esModule", {
    value: true
});
$c31a5024779af595$exports.Params = $c31a5024779af595$exports.ModuleCredential = $c31a5024779af595$exports.ModuleAccount = $c31a5024779af595$exports.BaseAccount = $c31a5024779af595$exports.protobufPackage = void 0;



const $c31a5024779af595$var$_m0 = $c31a5024779af595$var$__importStar((parcelRequire("fQBv0")));
$c31a5024779af595$exports.protobufPackage = "cosmos.auth.v1beta1";
function $c31a5024779af595$var$createBaseBaseAccount() {
    return {
        address: "",
        pubKey: undefined,
        accountNumber: $d5e07fe2518aae94$exports.Long.UZERO,
        sequence: $d5e07fe2518aae94$exports.Long.UZERO
    };
}
$c31a5024779af595$exports.BaseAccount = {
    encode (message, writer = $c31a5024779af595$var$_m0.Writer.create()) {
        if (message.address !== "") writer.uint32(10).string(message.address);
        if (message.pubKey !== undefined) $64138e590dcf0cc1$exports.Any.encode(message.pubKey, writer.uint32(18).fork()).ldelim();
        if (!message.accountNumber.isZero()) writer.uint32(24).uint64(message.accountNumber);
        if (!message.sequence.isZero()) writer.uint32(32).uint64(message.sequence);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $c31a5024779af595$var$_m0.Reader ? input : new $c31a5024779af595$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $c31a5024779af595$var$createBaseBaseAccount();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.address = reader.string();
                    break;
                case 2:
                    message.pubKey = $64138e590dcf0cc1$exports.Any.decode(reader, reader.uint32());
                    break;
                case 3:
                    message.accountNumber = reader.uint64();
                    break;
                case 4:
                    message.sequence = reader.uint64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            address: (0, $d5e07fe2518aae94$exports.isSet)(object.address) ? String(object.address) : "",
            pubKey: (0, $d5e07fe2518aae94$exports.isSet)(object.pubKey) ? $64138e590dcf0cc1$exports.Any.fromJSON(object.pubKey) : undefined,
            accountNumber: (0, $d5e07fe2518aae94$exports.isSet)(object.accountNumber) ? $d5e07fe2518aae94$exports.Long.fromValue(object.accountNumber) : $d5e07fe2518aae94$exports.Long.UZERO,
            sequence: (0, $d5e07fe2518aae94$exports.isSet)(object.sequence) ? $d5e07fe2518aae94$exports.Long.fromValue(object.sequence) : $d5e07fe2518aae94$exports.Long.UZERO
        };
    },
    toJSON (message) {
        const obj = {};
        message.address !== undefined && (obj.address = message.address);
        message.pubKey !== undefined && (obj.pubKey = message.pubKey ? $64138e590dcf0cc1$exports.Any.toJSON(message.pubKey) : undefined);
        message.accountNumber !== undefined && (obj.accountNumber = (message.accountNumber || $d5e07fe2518aae94$exports.Long.UZERO).toString());
        message.sequence !== undefined && (obj.sequence = (message.sequence || $d5e07fe2518aae94$exports.Long.UZERO).toString());
        return obj;
    },
    fromPartial (object) {
        const message = $c31a5024779af595$var$createBaseBaseAccount();
        message.address = object.address ?? "";
        message.pubKey = object.pubKey !== undefined && object.pubKey !== null ? $64138e590dcf0cc1$exports.Any.fromPartial(object.pubKey) : undefined;
        message.accountNumber = object.accountNumber !== undefined && object.accountNumber !== null ? $d5e07fe2518aae94$exports.Long.fromValue(object.accountNumber) : $d5e07fe2518aae94$exports.Long.UZERO;
        message.sequence = object.sequence !== undefined && object.sequence !== null ? $d5e07fe2518aae94$exports.Long.fromValue(object.sequence) : $d5e07fe2518aae94$exports.Long.UZERO;
        return message;
    }
};
function $c31a5024779af595$var$createBaseModuleAccount() {
    return {
        baseAccount: undefined,
        name: "",
        permissions: []
    };
}
$c31a5024779af595$exports.ModuleAccount = {
    encode (message, writer = $c31a5024779af595$var$_m0.Writer.create()) {
        if (message.baseAccount !== undefined) $c31a5024779af595$exports.BaseAccount.encode(message.baseAccount, writer.uint32(10).fork()).ldelim();
        if (message.name !== "") writer.uint32(18).string(message.name);
        for (const v of message.permissions)writer.uint32(26).string(v);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $c31a5024779af595$var$_m0.Reader ? input : new $c31a5024779af595$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $c31a5024779af595$var$createBaseModuleAccount();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.baseAccount = $c31a5024779af595$exports.BaseAccount.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.name = reader.string();
                    break;
                case 3:
                    message.permissions.push(reader.string());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            baseAccount: (0, $d5e07fe2518aae94$exports.isSet)(object.baseAccount) ? $c31a5024779af595$exports.BaseAccount.fromJSON(object.baseAccount) : undefined,
            name: (0, $d5e07fe2518aae94$exports.isSet)(object.name) ? String(object.name) : "",
            permissions: Array.isArray(object?.permissions) ? object.permissions.map((e)=>String(e)) : []
        };
    },
    toJSON (message) {
        const obj = {};
        message.baseAccount !== undefined && (obj.baseAccount = message.baseAccount ? $c31a5024779af595$exports.BaseAccount.toJSON(message.baseAccount) : undefined);
        message.name !== undefined && (obj.name = message.name);
        if (message.permissions) obj.permissions = message.permissions.map((e)=>e);
        else obj.permissions = [];
        return obj;
    },
    fromPartial (object) {
        const message = $c31a5024779af595$var$createBaseModuleAccount();
        message.baseAccount = object.baseAccount !== undefined && object.baseAccount !== null ? $c31a5024779af595$exports.BaseAccount.fromPartial(object.baseAccount) : undefined;
        message.name = object.name ?? "";
        message.permissions = object.permissions?.map((e)=>e) || [];
        return message;
    }
};
function $c31a5024779af595$var$createBaseModuleCredential() {
    return {
        moduleName: "",
        derivationKeys: []
    };
}
$c31a5024779af595$exports.ModuleCredential = {
    encode (message, writer = $c31a5024779af595$var$_m0.Writer.create()) {
        if (message.moduleName !== "") writer.uint32(10).string(message.moduleName);
        for (const v of message.derivationKeys)writer.uint32(18).bytes(v);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $c31a5024779af595$var$_m0.Reader ? input : new $c31a5024779af595$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $c31a5024779af595$var$createBaseModuleCredential();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.moduleName = reader.string();
                    break;
                case 2:
                    message.derivationKeys.push(reader.bytes());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            moduleName: (0, $d5e07fe2518aae94$exports.isSet)(object.moduleName) ? String(object.moduleName) : "",
            derivationKeys: Array.isArray(object?.derivationKeys) ? object.derivationKeys.map((e)=>(0, $d5e07fe2518aae94$exports.bytesFromBase64)(e)) : []
        };
    },
    toJSON (message) {
        const obj = {};
        message.moduleName !== undefined && (obj.moduleName = message.moduleName);
        if (message.derivationKeys) obj.derivationKeys = message.derivationKeys.map((e)=>(0, $d5e07fe2518aae94$exports.base64FromBytes)(e !== undefined ? e : new Uint8Array()));
        else obj.derivationKeys = [];
        return obj;
    },
    fromPartial (object) {
        const message = $c31a5024779af595$var$createBaseModuleCredential();
        message.moduleName = object.moduleName ?? "";
        message.derivationKeys = object.derivationKeys?.map((e)=>e) || [];
        return message;
    }
};
function $c31a5024779af595$var$createBaseParams() {
    return {
        maxMemoCharacters: $d5e07fe2518aae94$exports.Long.UZERO,
        txSigLimit: $d5e07fe2518aae94$exports.Long.UZERO,
        txSizeCostPerByte: $d5e07fe2518aae94$exports.Long.UZERO,
        sigVerifyCostEd25519: $d5e07fe2518aae94$exports.Long.UZERO,
        sigVerifyCostSecp256k1: $d5e07fe2518aae94$exports.Long.UZERO
    };
}
$c31a5024779af595$exports.Params = {
    encode (message, writer = $c31a5024779af595$var$_m0.Writer.create()) {
        if (!message.maxMemoCharacters.isZero()) writer.uint32(8).uint64(message.maxMemoCharacters);
        if (!message.txSigLimit.isZero()) writer.uint32(16).uint64(message.txSigLimit);
        if (!message.txSizeCostPerByte.isZero()) writer.uint32(24).uint64(message.txSizeCostPerByte);
        if (!message.sigVerifyCostEd25519.isZero()) writer.uint32(32).uint64(message.sigVerifyCostEd25519);
        if (!message.sigVerifyCostSecp256k1.isZero()) writer.uint32(40).uint64(message.sigVerifyCostSecp256k1);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $c31a5024779af595$var$_m0.Reader ? input : new $c31a5024779af595$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $c31a5024779af595$var$createBaseParams();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.maxMemoCharacters = reader.uint64();
                    break;
                case 2:
                    message.txSigLimit = reader.uint64();
                    break;
                case 3:
                    message.txSizeCostPerByte = reader.uint64();
                    break;
                case 4:
                    message.sigVerifyCostEd25519 = reader.uint64();
                    break;
                case 5:
                    message.sigVerifyCostSecp256k1 = reader.uint64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            maxMemoCharacters: (0, $d5e07fe2518aae94$exports.isSet)(object.maxMemoCharacters) ? $d5e07fe2518aae94$exports.Long.fromValue(object.maxMemoCharacters) : $d5e07fe2518aae94$exports.Long.UZERO,
            txSigLimit: (0, $d5e07fe2518aae94$exports.isSet)(object.txSigLimit) ? $d5e07fe2518aae94$exports.Long.fromValue(object.txSigLimit) : $d5e07fe2518aae94$exports.Long.UZERO,
            txSizeCostPerByte: (0, $d5e07fe2518aae94$exports.isSet)(object.txSizeCostPerByte) ? $d5e07fe2518aae94$exports.Long.fromValue(object.txSizeCostPerByte) : $d5e07fe2518aae94$exports.Long.UZERO,
            sigVerifyCostEd25519: (0, $d5e07fe2518aae94$exports.isSet)(object.sigVerifyCostEd25519) ? $d5e07fe2518aae94$exports.Long.fromValue(object.sigVerifyCostEd25519) : $d5e07fe2518aae94$exports.Long.UZERO,
            sigVerifyCostSecp256k1: (0, $d5e07fe2518aae94$exports.isSet)(object.sigVerifyCostSecp256k1) ? $d5e07fe2518aae94$exports.Long.fromValue(object.sigVerifyCostSecp256k1) : $d5e07fe2518aae94$exports.Long.UZERO
        };
    },
    toJSON (message) {
        const obj = {};
        message.maxMemoCharacters !== undefined && (obj.maxMemoCharacters = (message.maxMemoCharacters || $d5e07fe2518aae94$exports.Long.UZERO).toString());
        message.txSigLimit !== undefined && (obj.txSigLimit = (message.txSigLimit || $d5e07fe2518aae94$exports.Long.UZERO).toString());
        message.txSizeCostPerByte !== undefined && (obj.txSizeCostPerByte = (message.txSizeCostPerByte || $d5e07fe2518aae94$exports.Long.UZERO).toString());
        message.sigVerifyCostEd25519 !== undefined && (obj.sigVerifyCostEd25519 = (message.sigVerifyCostEd25519 || $d5e07fe2518aae94$exports.Long.UZERO).toString());
        message.sigVerifyCostSecp256k1 !== undefined && (obj.sigVerifyCostSecp256k1 = (message.sigVerifyCostSecp256k1 || $d5e07fe2518aae94$exports.Long.UZERO).toString());
        return obj;
    },
    fromPartial (object) {
        const message = $c31a5024779af595$var$createBaseParams();
        message.maxMemoCharacters = object.maxMemoCharacters !== undefined && object.maxMemoCharacters !== null ? $d5e07fe2518aae94$exports.Long.fromValue(object.maxMemoCharacters) : $d5e07fe2518aae94$exports.Long.UZERO;
        message.txSigLimit = object.txSigLimit !== undefined && object.txSigLimit !== null ? $d5e07fe2518aae94$exports.Long.fromValue(object.txSigLimit) : $d5e07fe2518aae94$exports.Long.UZERO;
        message.txSizeCostPerByte = object.txSizeCostPerByte !== undefined && object.txSizeCostPerByte !== null ? $d5e07fe2518aae94$exports.Long.fromValue(object.txSizeCostPerByte) : $d5e07fe2518aae94$exports.Long.UZERO;
        message.sigVerifyCostEd25519 = object.sigVerifyCostEd25519 !== undefined && object.sigVerifyCostEd25519 !== null ? $d5e07fe2518aae94$exports.Long.fromValue(object.sigVerifyCostEd25519) : $d5e07fe2518aae94$exports.Long.UZERO;
        message.sigVerifyCostSecp256k1 = object.sigVerifyCostSecp256k1 !== undefined && object.sigVerifyCostSecp256k1 !== null ? $d5e07fe2518aae94$exports.Long.fromValue(object.sigVerifyCostSecp256k1) : $d5e07fe2518aae94$exports.Long.UZERO;
        return message;
    }
};


var $294964efb46f9b42$exports = {};
"use strict";
var $294964efb46f9b42$var$__createBinding = $294964efb46f9b42$exports && $294964efb46f9b42$exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $294964efb46f9b42$var$__setModuleDefault = $294964efb46f9b42$exports && $294964efb46f9b42$exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $294964efb46f9b42$var$__importStar = $294964efb46f9b42$exports && $294964efb46f9b42$exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $294964efb46f9b42$var$__createBinding(result, mod, k);
    }
    $294964efb46f9b42$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty($294964efb46f9b42$exports, "__esModule", {
    value: true
});
$294964efb46f9b42$exports.PermanentLockedAccount = $294964efb46f9b42$exports.PeriodicVestingAccount = $294964efb46f9b42$exports.Period = $294964efb46f9b42$exports.DelayedVestingAccount = $294964efb46f9b42$exports.ContinuousVestingAccount = $294964efb46f9b42$exports.BaseVestingAccount = $294964efb46f9b42$exports.protobufPackage = void 0;




const $294964efb46f9b42$var$_m0 = $294964efb46f9b42$var$__importStar((parcelRequire("fQBv0")));
$294964efb46f9b42$exports.protobufPackage = "cosmos.vesting.v1beta1";
function $294964efb46f9b42$var$createBaseBaseVestingAccount() {
    return {
        baseAccount: undefined,
        originalVesting: [],
        delegatedFree: [],
        delegatedVesting: [],
        endTime: $d5e07fe2518aae94$exports.Long.ZERO
    };
}
$294964efb46f9b42$exports.BaseVestingAccount = {
    encode (message, writer = $294964efb46f9b42$var$_m0.Writer.create()) {
        if (message.baseAccount !== undefined) $c31a5024779af595$exports.BaseAccount.encode(message.baseAccount, writer.uint32(10).fork()).ldelim();
        for (const v of message.originalVesting)$783dd8715fde0fcf$exports.Coin.encode(v, writer.uint32(18).fork()).ldelim();
        for (const v of message.delegatedFree)$783dd8715fde0fcf$exports.Coin.encode(v, writer.uint32(26).fork()).ldelim();
        for (const v of message.delegatedVesting)$783dd8715fde0fcf$exports.Coin.encode(v, writer.uint32(34).fork()).ldelim();
        if (!message.endTime.isZero()) writer.uint32(40).int64(message.endTime);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $294964efb46f9b42$var$_m0.Reader ? input : new $294964efb46f9b42$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $294964efb46f9b42$var$createBaseBaseVestingAccount();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.baseAccount = $c31a5024779af595$exports.BaseAccount.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.originalVesting.push($783dd8715fde0fcf$exports.Coin.decode(reader, reader.uint32()));
                    break;
                case 3:
                    message.delegatedFree.push($783dd8715fde0fcf$exports.Coin.decode(reader, reader.uint32()));
                    break;
                case 4:
                    message.delegatedVesting.push($783dd8715fde0fcf$exports.Coin.decode(reader, reader.uint32()));
                    break;
                case 5:
                    message.endTime = reader.int64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            baseAccount: (0, $d5e07fe2518aae94$exports.isSet)(object.baseAccount) ? $c31a5024779af595$exports.BaseAccount.fromJSON(object.baseAccount) : undefined,
            originalVesting: Array.isArray(object?.originalVesting) ? object.originalVesting.map((e)=>$783dd8715fde0fcf$exports.Coin.fromJSON(e)) : [],
            delegatedFree: Array.isArray(object?.delegatedFree) ? object.delegatedFree.map((e)=>$783dd8715fde0fcf$exports.Coin.fromJSON(e)) : [],
            delegatedVesting: Array.isArray(object?.delegatedVesting) ? object.delegatedVesting.map((e)=>$783dd8715fde0fcf$exports.Coin.fromJSON(e)) : [],
            endTime: (0, $d5e07fe2518aae94$exports.isSet)(object.endTime) ? $d5e07fe2518aae94$exports.Long.fromValue(object.endTime) : $d5e07fe2518aae94$exports.Long.ZERO
        };
    },
    toJSON (message) {
        const obj = {};
        message.baseAccount !== undefined && (obj.baseAccount = message.baseAccount ? $c31a5024779af595$exports.BaseAccount.toJSON(message.baseAccount) : undefined);
        if (message.originalVesting) obj.originalVesting = message.originalVesting.map((e)=>e ? $783dd8715fde0fcf$exports.Coin.toJSON(e) : undefined);
        else obj.originalVesting = [];
        if (message.delegatedFree) obj.delegatedFree = message.delegatedFree.map((e)=>e ? $783dd8715fde0fcf$exports.Coin.toJSON(e) : undefined);
        else obj.delegatedFree = [];
        if (message.delegatedVesting) obj.delegatedVesting = message.delegatedVesting.map((e)=>e ? $783dd8715fde0fcf$exports.Coin.toJSON(e) : undefined);
        else obj.delegatedVesting = [];
        message.endTime !== undefined && (obj.endTime = (message.endTime || $d5e07fe2518aae94$exports.Long.ZERO).toString());
        return obj;
    },
    fromPartial (object) {
        const message = $294964efb46f9b42$var$createBaseBaseVestingAccount();
        message.baseAccount = object.baseAccount !== undefined && object.baseAccount !== null ? $c31a5024779af595$exports.BaseAccount.fromPartial(object.baseAccount) : undefined;
        message.originalVesting = object.originalVesting?.map((e)=>$783dd8715fde0fcf$exports.Coin.fromPartial(e)) || [];
        message.delegatedFree = object.delegatedFree?.map((e)=>$783dd8715fde0fcf$exports.Coin.fromPartial(e)) || [];
        message.delegatedVesting = object.delegatedVesting?.map((e)=>$783dd8715fde0fcf$exports.Coin.fromPartial(e)) || [];
        message.endTime = object.endTime !== undefined && object.endTime !== null ? $d5e07fe2518aae94$exports.Long.fromValue(object.endTime) : $d5e07fe2518aae94$exports.Long.ZERO;
        return message;
    }
};
function $294964efb46f9b42$var$createBaseContinuousVestingAccount() {
    return {
        baseVestingAccount: undefined,
        startTime: $d5e07fe2518aae94$exports.Long.ZERO
    };
}
$294964efb46f9b42$exports.ContinuousVestingAccount = {
    encode (message, writer = $294964efb46f9b42$var$_m0.Writer.create()) {
        if (message.baseVestingAccount !== undefined) $294964efb46f9b42$exports.BaseVestingAccount.encode(message.baseVestingAccount, writer.uint32(10).fork()).ldelim();
        if (!message.startTime.isZero()) writer.uint32(16).int64(message.startTime);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $294964efb46f9b42$var$_m0.Reader ? input : new $294964efb46f9b42$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $294964efb46f9b42$var$createBaseContinuousVestingAccount();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.baseVestingAccount = $294964efb46f9b42$exports.BaseVestingAccount.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.startTime = reader.int64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            baseVestingAccount: (0, $d5e07fe2518aae94$exports.isSet)(object.baseVestingAccount) ? $294964efb46f9b42$exports.BaseVestingAccount.fromJSON(object.baseVestingAccount) : undefined,
            startTime: (0, $d5e07fe2518aae94$exports.isSet)(object.startTime) ? $d5e07fe2518aae94$exports.Long.fromValue(object.startTime) : $d5e07fe2518aae94$exports.Long.ZERO
        };
    },
    toJSON (message) {
        const obj = {};
        message.baseVestingAccount !== undefined && (obj.baseVestingAccount = message.baseVestingAccount ? $294964efb46f9b42$exports.BaseVestingAccount.toJSON(message.baseVestingAccount) : undefined);
        message.startTime !== undefined && (obj.startTime = (message.startTime || $d5e07fe2518aae94$exports.Long.ZERO).toString());
        return obj;
    },
    fromPartial (object) {
        const message = $294964efb46f9b42$var$createBaseContinuousVestingAccount();
        message.baseVestingAccount = object.baseVestingAccount !== undefined && object.baseVestingAccount !== null ? $294964efb46f9b42$exports.BaseVestingAccount.fromPartial(object.baseVestingAccount) : undefined;
        message.startTime = object.startTime !== undefined && object.startTime !== null ? $d5e07fe2518aae94$exports.Long.fromValue(object.startTime) : $d5e07fe2518aae94$exports.Long.ZERO;
        return message;
    }
};
function $294964efb46f9b42$var$createBaseDelayedVestingAccount() {
    return {
        baseVestingAccount: undefined
    };
}
$294964efb46f9b42$exports.DelayedVestingAccount = {
    encode (message, writer = $294964efb46f9b42$var$_m0.Writer.create()) {
        if (message.baseVestingAccount !== undefined) $294964efb46f9b42$exports.BaseVestingAccount.encode(message.baseVestingAccount, writer.uint32(10).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $294964efb46f9b42$var$_m0.Reader ? input : new $294964efb46f9b42$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $294964efb46f9b42$var$createBaseDelayedVestingAccount();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.baseVestingAccount = $294964efb46f9b42$exports.BaseVestingAccount.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            baseVestingAccount: (0, $d5e07fe2518aae94$exports.isSet)(object.baseVestingAccount) ? $294964efb46f9b42$exports.BaseVestingAccount.fromJSON(object.baseVestingAccount) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.baseVestingAccount !== undefined && (obj.baseVestingAccount = message.baseVestingAccount ? $294964efb46f9b42$exports.BaseVestingAccount.toJSON(message.baseVestingAccount) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $294964efb46f9b42$var$createBaseDelayedVestingAccount();
        message.baseVestingAccount = object.baseVestingAccount !== undefined && object.baseVestingAccount !== null ? $294964efb46f9b42$exports.BaseVestingAccount.fromPartial(object.baseVestingAccount) : undefined;
        return message;
    }
};
function $294964efb46f9b42$var$createBasePeriod() {
    return {
        length: $d5e07fe2518aae94$exports.Long.ZERO,
        amount: []
    };
}
$294964efb46f9b42$exports.Period = {
    encode (message, writer = $294964efb46f9b42$var$_m0.Writer.create()) {
        if (!message.length.isZero()) writer.uint32(8).int64(message.length);
        for (const v of message.amount)$783dd8715fde0fcf$exports.Coin.encode(v, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $294964efb46f9b42$var$_m0.Reader ? input : new $294964efb46f9b42$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $294964efb46f9b42$var$createBasePeriod();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.length = reader.int64();
                    break;
                case 2:
                    message.amount.push($783dd8715fde0fcf$exports.Coin.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            length: (0, $d5e07fe2518aae94$exports.isSet)(object.length) ? $d5e07fe2518aae94$exports.Long.fromValue(object.length) : $d5e07fe2518aae94$exports.Long.ZERO,
            amount: Array.isArray(object?.amount) ? object.amount.map((e)=>$783dd8715fde0fcf$exports.Coin.fromJSON(e)) : []
        };
    },
    toJSON (message) {
        const obj = {};
        message.length !== undefined && (obj.length = (message.length || $d5e07fe2518aae94$exports.Long.ZERO).toString());
        if (message.amount) obj.amount = message.amount.map((e)=>e ? $783dd8715fde0fcf$exports.Coin.toJSON(e) : undefined);
        else obj.amount = [];
        return obj;
    },
    fromPartial (object) {
        const message = $294964efb46f9b42$var$createBasePeriod();
        message.length = object.length !== undefined && object.length !== null ? $d5e07fe2518aae94$exports.Long.fromValue(object.length) : $d5e07fe2518aae94$exports.Long.ZERO;
        message.amount = object.amount?.map((e)=>$783dd8715fde0fcf$exports.Coin.fromPartial(e)) || [];
        return message;
    }
};
function $294964efb46f9b42$var$createBasePeriodicVestingAccount() {
    return {
        baseVestingAccount: undefined,
        startTime: $d5e07fe2518aae94$exports.Long.ZERO,
        vestingPeriods: []
    };
}
$294964efb46f9b42$exports.PeriodicVestingAccount = {
    encode (message, writer = $294964efb46f9b42$var$_m0.Writer.create()) {
        if (message.baseVestingAccount !== undefined) $294964efb46f9b42$exports.BaseVestingAccount.encode(message.baseVestingAccount, writer.uint32(10).fork()).ldelim();
        if (!message.startTime.isZero()) writer.uint32(16).int64(message.startTime);
        for (const v of message.vestingPeriods)$294964efb46f9b42$exports.Period.encode(v, writer.uint32(26).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $294964efb46f9b42$var$_m0.Reader ? input : new $294964efb46f9b42$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $294964efb46f9b42$var$createBasePeriodicVestingAccount();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.baseVestingAccount = $294964efb46f9b42$exports.BaseVestingAccount.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.startTime = reader.int64();
                    break;
                case 3:
                    message.vestingPeriods.push($294964efb46f9b42$exports.Period.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            baseVestingAccount: (0, $d5e07fe2518aae94$exports.isSet)(object.baseVestingAccount) ? $294964efb46f9b42$exports.BaseVestingAccount.fromJSON(object.baseVestingAccount) : undefined,
            startTime: (0, $d5e07fe2518aae94$exports.isSet)(object.startTime) ? $d5e07fe2518aae94$exports.Long.fromValue(object.startTime) : $d5e07fe2518aae94$exports.Long.ZERO,
            vestingPeriods: Array.isArray(object?.vestingPeriods) ? object.vestingPeriods.map((e)=>$294964efb46f9b42$exports.Period.fromJSON(e)) : []
        };
    },
    toJSON (message) {
        const obj = {};
        message.baseVestingAccount !== undefined && (obj.baseVestingAccount = message.baseVestingAccount ? $294964efb46f9b42$exports.BaseVestingAccount.toJSON(message.baseVestingAccount) : undefined);
        message.startTime !== undefined && (obj.startTime = (message.startTime || $d5e07fe2518aae94$exports.Long.ZERO).toString());
        if (message.vestingPeriods) obj.vestingPeriods = message.vestingPeriods.map((e)=>e ? $294964efb46f9b42$exports.Period.toJSON(e) : undefined);
        else obj.vestingPeriods = [];
        return obj;
    },
    fromPartial (object) {
        const message = $294964efb46f9b42$var$createBasePeriodicVestingAccount();
        message.baseVestingAccount = object.baseVestingAccount !== undefined && object.baseVestingAccount !== null ? $294964efb46f9b42$exports.BaseVestingAccount.fromPartial(object.baseVestingAccount) : undefined;
        message.startTime = object.startTime !== undefined && object.startTime !== null ? $d5e07fe2518aae94$exports.Long.fromValue(object.startTime) : $d5e07fe2518aae94$exports.Long.ZERO;
        message.vestingPeriods = object.vestingPeriods?.map((e)=>$294964efb46f9b42$exports.Period.fromPartial(e)) || [];
        return message;
    }
};
function $294964efb46f9b42$var$createBasePermanentLockedAccount() {
    return {
        baseVestingAccount: undefined
    };
}
$294964efb46f9b42$exports.PermanentLockedAccount = {
    encode (message, writer = $294964efb46f9b42$var$_m0.Writer.create()) {
        if (message.baseVestingAccount !== undefined) $294964efb46f9b42$exports.BaseVestingAccount.encode(message.baseVestingAccount, writer.uint32(10).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $294964efb46f9b42$var$_m0.Reader ? input : new $294964efb46f9b42$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $294964efb46f9b42$var$createBasePermanentLockedAccount();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.baseVestingAccount = $294964efb46f9b42$exports.BaseVestingAccount.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            baseVestingAccount: (0, $d5e07fe2518aae94$exports.isSet)(object.baseVestingAccount) ? $294964efb46f9b42$exports.BaseVestingAccount.fromJSON(object.baseVestingAccount) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.baseVestingAccount !== undefined && (obj.baseVestingAccount = message.baseVestingAccount ? $294964efb46f9b42$exports.BaseVestingAccount.toJSON(message.baseVestingAccount) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $294964efb46f9b42$var$createBasePermanentLockedAccount();
        message.baseVestingAccount = object.baseVestingAccount !== undefined && object.baseVestingAccount !== null ? $294964efb46f9b42$exports.BaseVestingAccount.fromPartial(object.baseVestingAccount) : undefined;
        return message;
    }
};


function $55dae034d780d4b9$var$uint64FromProto(input) {
    return $7UsfE.Uint64.fromString(input.toString());
}
function $55dae034d780d4b9$var$accountFromBaseAccount(input) {
    const { address: address, pubKey: pubKey, accountNumber: accountNumber, sequence: sequence } = input;
    const pubkey = pubKey ? (0, $c0a9381c50e8ee56$exports.decodePubkey)(pubKey) : null;
    return {
        address: address,
        pubkey: pubkey,
        accountNumber: $55dae034d780d4b9$var$uint64FromProto(accountNumber).toNumber(),
        sequence: $55dae034d780d4b9$var$uint64FromProto(sequence).toNumber()
    };
}
/**
 * Basic implementation of AccountParser. This is supposed to support the most relevant
 * common Cosmos SDK account types. If you need support for exotic account types,
 * you'll need to write your own account decoder.
 */ function $55dae034d780d4b9$var$accountFromAny(input) {
    const { typeUrl: typeUrl, value: value } = input;
    switch(typeUrl){
        // auth
        case "/cosmos.auth.v1beta1.BaseAccount":
            return $55dae034d780d4b9$var$accountFromBaseAccount($c31a5024779af595$exports.BaseAccount.decode(value));
        case "/cosmos.auth.v1beta1.ModuleAccount":
            {
                const baseAccount = $c31a5024779af595$exports.ModuleAccount.decode(value).baseAccount;
                (0, $fZwG5.assert)(baseAccount);
                return $55dae034d780d4b9$var$accountFromBaseAccount(baseAccount);
            }
        // vesting
        case "/cosmos.vesting.v1beta1.BaseVestingAccount":
            {
                const baseAccount = $294964efb46f9b42$exports.BaseVestingAccount.decode(value)?.baseAccount;
                (0, $fZwG5.assert)(baseAccount);
                return $55dae034d780d4b9$var$accountFromBaseAccount(baseAccount);
            }
        case "/cosmos.vesting.v1beta1.ContinuousVestingAccount":
            {
                const baseAccount = $294964efb46f9b42$exports.ContinuousVestingAccount.decode(value)?.baseVestingAccount?.baseAccount;
                (0, $fZwG5.assert)(baseAccount);
                return $55dae034d780d4b9$var$accountFromBaseAccount(baseAccount);
            }
        case "/cosmos.vesting.v1beta1.DelayedVestingAccount":
            {
                const baseAccount = $294964efb46f9b42$exports.DelayedVestingAccount.decode(value)?.baseVestingAccount?.baseAccount;
                (0, $fZwG5.assert)(baseAccount);
                return $55dae034d780d4b9$var$accountFromBaseAccount(baseAccount);
            }
        case "/cosmos.vesting.v1beta1.PeriodicVestingAccount":
            {
                const baseAccount = $294964efb46f9b42$exports.PeriodicVestingAccount.decode(value)?.baseVestingAccount?.baseAccount;
                (0, $fZwG5.assert)(baseAccount);
                return $55dae034d780d4b9$var$accountFromBaseAccount(baseAccount);
            }
        default:
            throw new Error(`Unsupported type: '${typeUrl}'`);
    }
}
$55dae034d780d4b9$exports.accountFromAny = $55dae034d780d4b9$var$accountFromAny;


Object.defineProperty($ee390ef646431151$exports, "accountFromAny", {
    enumerable: true,
    get: function() {
        return $55dae034d780d4b9$exports.accountFromAny;
    }
});
var $c23a6866dab6bf09$exports = {};
"use strict";
Object.defineProperty($c23a6866dab6bf09$exports, "__esModule", {
    value: true
});
$c23a6866dab6bf09$exports.AminoTypes = void 0;
/**
 * A map from Stargate message types as used in the messages's `Any` type
 * to Amino types.
 */ class $c23a6866dab6bf09$var$AminoTypes {
    constructor(types){
        this.register = types;
    }
    toAmino({ typeUrl: typeUrl, value: value }) {
        const converter = this.register[typeUrl];
        if (!converter) throw new Error(`Type URL '${typeUrl}' does not exist in the Amino message type register. ` + "If you need support for this message type, you can pass in additional entries to the AminoTypes constructor. " + "If you think this message type should be included by default, please open an issue at https://github.com/cosmos/cosmjs/issues.");
        return {
            type: converter.aminoType,
            value: converter.toAmino(value)
        };
    }
    fromAmino({ type: type, value: value }) {
        const matches = Object.entries(this.register).filter(([_typeUrl, { aminoType: aminoType }])=>aminoType === type);
        switch(matches.length){
            case 0:
                throw new Error(`Amino type identifier '${type}' does not exist in the Amino message type register. ` + "If you need support for this message type, you can pass in additional entries to the AminoTypes constructor. " + "If you think this message type should be included by default, please open an issue at https://github.com/cosmos/cosmjs/issues.");
            case 1:
                {
                    const [typeUrl, converter] = matches[0];
                    return {
                        typeUrl: typeUrl,
                        value: converter.fromAmino(value)
                    };
                }
            default:
                throw new Error(`Multiple types are registered with Amino type identifier '${type}': '` + matches.map(([key, _value])=>key).sort().join("', '") + "'. Thus fromAmino cannot be performed.");
        }
    }
}
$c23a6866dab6bf09$exports.AminoTypes = $c23a6866dab6bf09$var$AminoTypes;


Object.defineProperty($ee390ef646431151$exports, "AminoTypes", {
    enumerable: true,
    get: function() {
        return $c23a6866dab6bf09$exports.AminoTypes;
    }
});
var $e8bc1ea6b01ea32f$exports = {};
"use strict";
Object.defineProperty($e8bc1ea6b01ea32f$exports, "__esModule", {
    value: true
});
$e8bc1ea6b01ea32f$exports.fromTendermintEvent = void 0;

var $6XcLW = parcelRequire("6XcLW");
/**
 * Takes a Tendermint 0.34 or 0.37 event with binary encoded key and value
 * and converts it into an `Event` with string attributes.
 */ function $e8bc1ea6b01ea32f$var$fromTendermintEvent(event) {
    return {
        type: event.type,
        attributes: event.attributes.map((attr)=>({
                key: typeof attr.key == "string" ? attr.key : (0, $6XcLW.fromUtf8)(attr.key, true),
                value: typeof attr.value == "string" ? attr.value : (0, $6XcLW.fromUtf8)(attr.value, true)
            }))
    };
}
$e8bc1ea6b01ea32f$exports.fromTendermintEvent = $e8bc1ea6b01ea32f$var$fromTendermintEvent;


Object.defineProperty($ee390ef646431151$exports, "fromTendermintEvent", {
    enumerable: true,
    get: function() {
        return $e8bc1ea6b01ea32f$exports.fromTendermintEvent;
    }
});
var $3c41c4da02081396$exports = {};
"use strict";
Object.defineProperty($3c41c4da02081396$exports, "__esModule", {
    value: true
});
$3c41c4da02081396$exports.calculateFee = $3c41c4da02081396$exports.GasPrice = void 0;

var $7UsfE = parcelRequire("7UsfE");

/**
 * Denom checker for the Cosmos SDK 0.42 denom pattern
 * (https://github.com/cosmos/cosmos-sdk/blob/v0.42.4/types/coin.go#L599-L601).
 *
 * This is like a regexp but with helpful error messages.
 */ function $3c41c4da02081396$var$checkDenom(denom) {
    if (denom.length < 3 || denom.length > 128) throw new Error("Denom must be between 3 and 128 characters");
}
/**
 * A gas price, i.e. the price of a single unit of gas. This is typically a fraction of
 * the smallest fee token unit, such as 0.012utoken.
 */ class $3c41c4da02081396$var$GasPrice {
    constructor(amount, denom){
        this.amount = amount;
        this.denom = denom;
    }
    /**
     * Parses a gas price formatted as `<amount><denom>`, e.g. `GasPrice.fromString("0.012utoken")`.
     *
     * The denom must match the Cosmos SDK 0.42 pattern (https://github.com/cosmos/cosmos-sdk/blob/v0.42.4/types/coin.go#L599-L601).
     * See `GasPrice` in @cosmjs/stargate for a more generic matcher.
     *
     * Separators are not yet supported.
     */ static fromString(gasPrice) {
        // Use Decimal.fromUserInput and checkDenom for detailed checks and helpful error messages
        const matchResult = gasPrice.match(/^([0-9.]+)([a-z][a-z0-9]*)$/i);
        if (!matchResult) throw new Error("Invalid gas price string");
        const [_, amount, denom] = matchResult;
        $3c41c4da02081396$var$checkDenom(denom);
        const fractionalDigits = 18;
        const decimalAmount = $7UsfE.Decimal.fromUserInput(amount, fractionalDigits);
        return new $3c41c4da02081396$var$GasPrice(decimalAmount, denom);
    }
    /**
     * Returns a string representation of this gas price, e.g. "0.025uatom".
     * This can be used as an input to `GasPrice.fromString`.
     */ toString() {
        return this.amount.toString() + this.denom;
    }
}
$3c41c4da02081396$exports.GasPrice = $3c41c4da02081396$var$GasPrice;
function $3c41c4da02081396$var$calculateFee(gasLimit, gasPrice) {
    const processedGasPrice = typeof gasPrice === "string" ? $3c41c4da02081396$var$GasPrice.fromString(gasPrice) : gasPrice;
    const { denom: denom, amount: gasPriceAmount } = processedGasPrice;
    // Note: Amount can exceed the safe integer range (https://github.com/cosmos/cosmjs/issues/1134),
    // which we handle by converting from Decimal to string without going through number.
    const amount = gasPriceAmount.multiply(new $7UsfE.Uint53(gasLimit)).ceil().toString();
    return {
        amount: (0, $c0a9381c50e8ee56$exports.coins)(amount, denom),
        gas: gasLimit.toString()
    };
}
$3c41c4da02081396$exports.calculateFee = $3c41c4da02081396$var$calculateFee;


Object.defineProperty($ee390ef646431151$exports, "calculateFee", {
    enumerable: true,
    get: function() {
        return $3c41c4da02081396$exports.calculateFee;
    }
});
Object.defineProperty($ee390ef646431151$exports, "GasPrice", {
    enumerable: true,
    get: function() {
        return $3c41c4da02081396$exports.GasPrice;
    }
});

$ee390ef646431151$exports.logs = $ee390ef646431151$var$__importStar((parcelRequire("lDrC1")));
var $d0d8b6f4712acd9f$exports = {};
"use strict";
Object.defineProperty($d0d8b6f4712acd9f$exports, "__esModule", {
    value: true
});
$d0d8b6f4712acd9f$exports.isAminoMsgCreateValidator = $d0d8b6f4712acd9f$exports.isAminoMsgBeginRedelegate = $d0d8b6f4712acd9f$exports.createStakingAminoConverters = $d0d8b6f4712acd9f$exports.setupSlashingExtension = $d0d8b6f4712acd9f$exports.isAminoMsgUnjail = $d0d8b6f4712acd9f$exports.createSlashingAminoConverters = $d0d8b6f4712acd9f$exports.setupMintExtension = $d0d8b6f4712acd9f$exports.setupIbcExtension = $d0d8b6f4712acd9f$exports.isMsgTransferEncodeObject = $d0d8b6f4712acd9f$exports.ibcTypes = $d0d8b6f4712acd9f$exports.isAminoMsgTransfer = $d0d8b6f4712acd9f$exports.createIbcAminoConverters = $d0d8b6f4712acd9f$exports.groupTypes = $d0d8b6f4712acd9f$exports.createGroupAminoConverters = $d0d8b6f4712acd9f$exports.setupGovExtension = $d0d8b6f4712acd9f$exports.isMsgVoteWeightedEncodeObject = $d0d8b6f4712acd9f$exports.isMsgVoteEncodeObject = $d0d8b6f4712acd9f$exports.isMsgSubmitProposalEncodeObject = $d0d8b6f4712acd9f$exports.isMsgDepositEncodeObject = $d0d8b6f4712acd9f$exports.govTypes = $d0d8b6f4712acd9f$exports.isAminoMsgVoteWeighted = $d0d8b6f4712acd9f$exports.isAminoMsgVote = $d0d8b6f4712acd9f$exports.isAminoMsgSubmitProposal = $d0d8b6f4712acd9f$exports.isAminoMsgDeposit = $d0d8b6f4712acd9f$exports.createGovAminoConverters = $d0d8b6f4712acd9f$exports.setupFeegrantExtension = $d0d8b6f4712acd9f$exports.feegrantTypes = $d0d8b6f4712acd9f$exports.createFeegrantAminoConverters = $d0d8b6f4712acd9f$exports.isAminoMsgSubmitEvidence = $d0d8b6f4712acd9f$exports.createEvidenceAminoConverters = $d0d8b6f4712acd9f$exports.setupDistributionExtension = $d0d8b6f4712acd9f$exports.isMsgWithdrawDelegatorRewardEncodeObject = $d0d8b6f4712acd9f$exports.distributionTypes = $d0d8b6f4712acd9f$exports.isAminoMsgWithdrawValidatorCommission = $d0d8b6f4712acd9f$exports.isAminoMsgWithdrawDelegatorReward = $d0d8b6f4712acd9f$exports.isAminoMsgSetWithdrawAddress = $d0d8b6f4712acd9f$exports.isAminoMsgFundCommunityPool = $d0d8b6f4712acd9f$exports.createDistributionAminoConverters = $d0d8b6f4712acd9f$exports.isAminoMsgVerifyInvariant = $d0d8b6f4712acd9f$exports.createCrysisAminoConverters = $d0d8b6f4712acd9f$exports.setupBankExtension = $d0d8b6f4712acd9f$exports.isMsgSendEncodeObject = $d0d8b6f4712acd9f$exports.bankTypes = $d0d8b6f4712acd9f$exports.isAminoMsgSend = $d0d8b6f4712acd9f$exports.isAminoMsgMultiSend = $d0d8b6f4712acd9f$exports.createBankAminoConverters = $d0d8b6f4712acd9f$exports.setupAuthzExtension = $d0d8b6f4712acd9f$exports.authzTypes = $d0d8b6f4712acd9f$exports.createAuthzAminoConverters = $d0d8b6f4712acd9f$exports.setupAuthExtension = void 0;
$d0d8b6f4712acd9f$exports.vestingTypes = $d0d8b6f4712acd9f$exports.isAminoMsgCreateVestingAccount = $d0d8b6f4712acd9f$exports.createVestingAminoConverters = $d0d8b6f4712acd9f$exports.setupTxExtension = $d0d8b6f4712acd9f$exports.setupStakingExtension = $d0d8b6f4712acd9f$exports.stakingTypes = $d0d8b6f4712acd9f$exports.isMsgUndelegateEncodeObject = $d0d8b6f4712acd9f$exports.isMsgEditValidatorEncodeObject = $d0d8b6f4712acd9f$exports.isMsgDelegateEncodeObject = $d0d8b6f4712acd9f$exports.isMsgCreateValidatorEncodeObject = $d0d8b6f4712acd9f$exports.isMsgBeginRedelegateEncodeObject = $d0d8b6f4712acd9f$exports.isAminoMsgUndelegate = $d0d8b6f4712acd9f$exports.isAminoMsgEditValidator = $d0d8b6f4712acd9f$exports.isAminoMsgDelegate = void 0;
var $cfd768647aeb9448$exports = {};
"use strict";
Object.defineProperty($cfd768647aeb9448$exports, "__esModule", {
    value: true
});
$cfd768647aeb9448$exports.setupAuthExtension = void 0;
var $c4e0f03afcc1bc46$exports = {};
"use strict";
var $c4e0f03afcc1bc46$var$__createBinding = $c4e0f03afcc1bc46$exports && $c4e0f03afcc1bc46$exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $c4e0f03afcc1bc46$var$__setModuleDefault = $c4e0f03afcc1bc46$exports && $c4e0f03afcc1bc46$exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $c4e0f03afcc1bc46$var$__importStar = $c4e0f03afcc1bc46$exports && $c4e0f03afcc1bc46$exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $c4e0f03afcc1bc46$var$__createBinding(result, mod, k);
    }
    $c4e0f03afcc1bc46$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty($c4e0f03afcc1bc46$exports, "__esModule", {
    value: true
});
$c4e0f03afcc1bc46$exports.QueryClientImpl = $c4e0f03afcc1bc46$exports.QueryAccountInfoResponse = $c4e0f03afcc1bc46$exports.QueryAccountInfoRequest = $c4e0f03afcc1bc46$exports.QueryAccountAddressByIDResponse = $c4e0f03afcc1bc46$exports.QueryAccountAddressByIDRequest = $c4e0f03afcc1bc46$exports.AddressStringToBytesResponse = $c4e0f03afcc1bc46$exports.AddressStringToBytesRequest = $c4e0f03afcc1bc46$exports.AddressBytesToStringResponse = $c4e0f03afcc1bc46$exports.AddressBytesToStringRequest = $c4e0f03afcc1bc46$exports.Bech32PrefixResponse = $c4e0f03afcc1bc46$exports.Bech32PrefixRequest = $c4e0f03afcc1bc46$exports.QueryModuleAccountByNameResponse = $c4e0f03afcc1bc46$exports.QueryModuleAccountByNameRequest = $c4e0f03afcc1bc46$exports.QueryModuleAccountsResponse = $c4e0f03afcc1bc46$exports.QueryModuleAccountsRequest = $c4e0f03afcc1bc46$exports.QueryParamsResponse = $c4e0f03afcc1bc46$exports.QueryParamsRequest = $c4e0f03afcc1bc46$exports.QueryAccountResponse = $c4e0f03afcc1bc46$exports.QueryAccountRequest = $c4e0f03afcc1bc46$exports.QueryAccountsResponse = $c4e0f03afcc1bc46$exports.QueryAccountsRequest = $c4e0f03afcc1bc46$exports.protobufPackage = void 0;
var $5eae5f3cc99e92ab$exports = {};
"use strict";
var $5eae5f3cc99e92ab$var$__createBinding = $5eae5f3cc99e92ab$exports && $5eae5f3cc99e92ab$exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $5eae5f3cc99e92ab$var$__setModuleDefault = $5eae5f3cc99e92ab$exports && $5eae5f3cc99e92ab$exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $5eae5f3cc99e92ab$var$__importStar = $5eae5f3cc99e92ab$exports && $5eae5f3cc99e92ab$exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $5eae5f3cc99e92ab$var$__createBinding(result, mod, k);
    }
    $5eae5f3cc99e92ab$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty($5eae5f3cc99e92ab$exports, "__esModule", {
    value: true
});
$5eae5f3cc99e92ab$exports.PageResponse = $5eae5f3cc99e92ab$exports.PageRequest = $5eae5f3cc99e92ab$exports.protobufPackage = void 0;


const $5eae5f3cc99e92ab$var$_m0 = $5eae5f3cc99e92ab$var$__importStar((parcelRequire("fQBv0")));
$5eae5f3cc99e92ab$exports.protobufPackage = "cosmos.base.query.v1beta1";
function $5eae5f3cc99e92ab$var$createBasePageRequest() {
    return {
        key: new Uint8Array(),
        offset: $d5e07fe2518aae94$exports.Long.UZERO,
        limit: $d5e07fe2518aae94$exports.Long.UZERO,
        countTotal: false,
        reverse: false
    };
}
$5eae5f3cc99e92ab$exports.PageRequest = {
    encode (message, writer = $5eae5f3cc99e92ab$var$_m0.Writer.create()) {
        if (message.key.length !== 0) writer.uint32(10).bytes(message.key);
        if (!message.offset.isZero()) writer.uint32(16).uint64(message.offset);
        if (!message.limit.isZero()) writer.uint32(24).uint64(message.limit);
        if (message.countTotal === true) writer.uint32(32).bool(message.countTotal);
        if (message.reverse === true) writer.uint32(40).bool(message.reverse);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $5eae5f3cc99e92ab$var$_m0.Reader ? input : new $5eae5f3cc99e92ab$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $5eae5f3cc99e92ab$var$createBasePageRequest();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.key = reader.bytes();
                    break;
                case 2:
                    message.offset = reader.uint64();
                    break;
                case 3:
                    message.limit = reader.uint64();
                    break;
                case 4:
                    message.countTotal = reader.bool();
                    break;
                case 5:
                    message.reverse = reader.bool();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            key: (0, $d5e07fe2518aae94$exports.isSet)(object.key) ? (0, $d5e07fe2518aae94$exports.bytesFromBase64)(object.key) : new Uint8Array(),
            offset: (0, $d5e07fe2518aae94$exports.isSet)(object.offset) ? $d5e07fe2518aae94$exports.Long.fromValue(object.offset) : $d5e07fe2518aae94$exports.Long.UZERO,
            limit: (0, $d5e07fe2518aae94$exports.isSet)(object.limit) ? $d5e07fe2518aae94$exports.Long.fromValue(object.limit) : $d5e07fe2518aae94$exports.Long.UZERO,
            countTotal: (0, $d5e07fe2518aae94$exports.isSet)(object.countTotal) ? Boolean(object.countTotal) : false,
            reverse: (0, $d5e07fe2518aae94$exports.isSet)(object.reverse) ? Boolean(object.reverse) : false
        };
    },
    toJSON (message) {
        const obj = {};
        message.key !== undefined && (obj.key = (0, $d5e07fe2518aae94$exports.base64FromBytes)(message.key !== undefined ? message.key : new Uint8Array()));
        message.offset !== undefined && (obj.offset = (message.offset || $d5e07fe2518aae94$exports.Long.UZERO).toString());
        message.limit !== undefined && (obj.limit = (message.limit || $d5e07fe2518aae94$exports.Long.UZERO).toString());
        message.countTotal !== undefined && (obj.countTotal = message.countTotal);
        message.reverse !== undefined && (obj.reverse = message.reverse);
        return obj;
    },
    fromPartial (object) {
        const message = $5eae5f3cc99e92ab$var$createBasePageRequest();
        message.key = object.key ?? new Uint8Array();
        message.offset = object.offset !== undefined && object.offset !== null ? $d5e07fe2518aae94$exports.Long.fromValue(object.offset) : $d5e07fe2518aae94$exports.Long.UZERO;
        message.limit = object.limit !== undefined && object.limit !== null ? $d5e07fe2518aae94$exports.Long.fromValue(object.limit) : $d5e07fe2518aae94$exports.Long.UZERO;
        message.countTotal = object.countTotal ?? false;
        message.reverse = object.reverse ?? false;
        return message;
    }
};
function $5eae5f3cc99e92ab$var$createBasePageResponse() {
    return {
        nextKey: new Uint8Array(),
        total: $d5e07fe2518aae94$exports.Long.UZERO
    };
}
$5eae5f3cc99e92ab$exports.PageResponse = {
    encode (message, writer = $5eae5f3cc99e92ab$var$_m0.Writer.create()) {
        if (message.nextKey.length !== 0) writer.uint32(10).bytes(message.nextKey);
        if (!message.total.isZero()) writer.uint32(16).uint64(message.total);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $5eae5f3cc99e92ab$var$_m0.Reader ? input : new $5eae5f3cc99e92ab$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $5eae5f3cc99e92ab$var$createBasePageResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.nextKey = reader.bytes();
                    break;
                case 2:
                    message.total = reader.uint64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            nextKey: (0, $d5e07fe2518aae94$exports.isSet)(object.nextKey) ? (0, $d5e07fe2518aae94$exports.bytesFromBase64)(object.nextKey) : new Uint8Array(),
            total: (0, $d5e07fe2518aae94$exports.isSet)(object.total) ? $d5e07fe2518aae94$exports.Long.fromValue(object.total) : $d5e07fe2518aae94$exports.Long.UZERO
        };
    },
    toJSON (message) {
        const obj = {};
        message.nextKey !== undefined && (obj.nextKey = (0, $d5e07fe2518aae94$exports.base64FromBytes)(message.nextKey !== undefined ? message.nextKey : new Uint8Array()));
        message.total !== undefined && (obj.total = (message.total || $d5e07fe2518aae94$exports.Long.UZERO).toString());
        return obj;
    },
    fromPartial (object) {
        const message = $5eae5f3cc99e92ab$var$createBasePageResponse();
        message.nextKey = object.nextKey ?? new Uint8Array();
        message.total = object.total !== undefined && object.total !== null ? $d5e07fe2518aae94$exports.Long.fromValue(object.total) : $d5e07fe2518aae94$exports.Long.UZERO;
        return message;
    }
};






const $c4e0f03afcc1bc46$var$_m0 = $c4e0f03afcc1bc46$var$__importStar((parcelRequire("fQBv0")));
$c4e0f03afcc1bc46$exports.protobufPackage = "cosmos.auth.v1beta1";
function $c4e0f03afcc1bc46$var$createBaseQueryAccountsRequest() {
    return {
        pagination: undefined
    };
}
$c4e0f03afcc1bc46$exports.QueryAccountsRequest = {
    encode (message, writer = $c4e0f03afcc1bc46$var$_m0.Writer.create()) {
        if (message.pagination !== undefined) $5eae5f3cc99e92ab$exports.PageRequest.encode(message.pagination, writer.uint32(10).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $c4e0f03afcc1bc46$var$_m0.Reader ? input : new $c4e0f03afcc1bc46$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $c4e0f03afcc1bc46$var$createBaseQueryAccountsRequest();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.pagination = $5eae5f3cc99e92ab$exports.PageRequest.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            pagination: (0, $d5e07fe2518aae94$exports.isSet)(object.pagination) ? $5eae5f3cc99e92ab$exports.PageRequest.fromJSON(object.pagination) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.pagination !== undefined && (obj.pagination = message.pagination ? $5eae5f3cc99e92ab$exports.PageRequest.toJSON(message.pagination) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $c4e0f03afcc1bc46$var$createBaseQueryAccountsRequest();
        message.pagination = object.pagination !== undefined && object.pagination !== null ? $5eae5f3cc99e92ab$exports.PageRequest.fromPartial(object.pagination) : undefined;
        return message;
    }
};
function $c4e0f03afcc1bc46$var$createBaseQueryAccountsResponse() {
    return {
        accounts: [],
        pagination: undefined
    };
}
$c4e0f03afcc1bc46$exports.QueryAccountsResponse = {
    encode (message, writer = $c4e0f03afcc1bc46$var$_m0.Writer.create()) {
        for (const v of message.accounts)$64138e590dcf0cc1$exports.Any.encode(v, writer.uint32(10).fork()).ldelim();
        if (message.pagination !== undefined) $5eae5f3cc99e92ab$exports.PageResponse.encode(message.pagination, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $c4e0f03afcc1bc46$var$_m0.Reader ? input : new $c4e0f03afcc1bc46$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $c4e0f03afcc1bc46$var$createBaseQueryAccountsResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.accounts.push($64138e590dcf0cc1$exports.Any.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.pagination = $5eae5f3cc99e92ab$exports.PageResponse.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            accounts: Array.isArray(object?.accounts) ? object.accounts.map((e)=>$64138e590dcf0cc1$exports.Any.fromJSON(e)) : [],
            pagination: (0, $d5e07fe2518aae94$exports.isSet)(object.pagination) ? $5eae5f3cc99e92ab$exports.PageResponse.fromJSON(object.pagination) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        if (message.accounts) obj.accounts = message.accounts.map((e)=>e ? $64138e590dcf0cc1$exports.Any.toJSON(e) : undefined);
        else obj.accounts = [];
        message.pagination !== undefined && (obj.pagination = message.pagination ? $5eae5f3cc99e92ab$exports.PageResponse.toJSON(message.pagination) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $c4e0f03afcc1bc46$var$createBaseQueryAccountsResponse();
        message.accounts = object.accounts?.map((e)=>$64138e590dcf0cc1$exports.Any.fromPartial(e)) || [];
        message.pagination = object.pagination !== undefined && object.pagination !== null ? $5eae5f3cc99e92ab$exports.PageResponse.fromPartial(object.pagination) : undefined;
        return message;
    }
};
function $c4e0f03afcc1bc46$var$createBaseQueryAccountRequest() {
    return {
        address: ""
    };
}
$c4e0f03afcc1bc46$exports.QueryAccountRequest = {
    encode (message, writer = $c4e0f03afcc1bc46$var$_m0.Writer.create()) {
        if (message.address !== "") writer.uint32(10).string(message.address);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $c4e0f03afcc1bc46$var$_m0.Reader ? input : new $c4e0f03afcc1bc46$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $c4e0f03afcc1bc46$var$createBaseQueryAccountRequest();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.address = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            address: (0, $d5e07fe2518aae94$exports.isSet)(object.address) ? String(object.address) : ""
        };
    },
    toJSON (message) {
        const obj = {};
        message.address !== undefined && (obj.address = message.address);
        return obj;
    },
    fromPartial (object) {
        const message = $c4e0f03afcc1bc46$var$createBaseQueryAccountRequest();
        message.address = object.address ?? "";
        return message;
    }
};
function $c4e0f03afcc1bc46$var$createBaseQueryAccountResponse() {
    return {
        account: undefined
    };
}
$c4e0f03afcc1bc46$exports.QueryAccountResponse = {
    encode (message, writer = $c4e0f03afcc1bc46$var$_m0.Writer.create()) {
        if (message.account !== undefined) $64138e590dcf0cc1$exports.Any.encode(message.account, writer.uint32(10).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $c4e0f03afcc1bc46$var$_m0.Reader ? input : new $c4e0f03afcc1bc46$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $c4e0f03afcc1bc46$var$createBaseQueryAccountResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.account = $64138e590dcf0cc1$exports.Any.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            account: (0, $d5e07fe2518aae94$exports.isSet)(object.account) ? $64138e590dcf0cc1$exports.Any.fromJSON(object.account) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.account !== undefined && (obj.account = message.account ? $64138e590dcf0cc1$exports.Any.toJSON(message.account) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $c4e0f03afcc1bc46$var$createBaseQueryAccountResponse();
        message.account = object.account !== undefined && object.account !== null ? $64138e590dcf0cc1$exports.Any.fromPartial(object.account) : undefined;
        return message;
    }
};
function $c4e0f03afcc1bc46$var$createBaseQueryParamsRequest() {
    return {};
}
$c4e0f03afcc1bc46$exports.QueryParamsRequest = {
    encode (_, writer = $c4e0f03afcc1bc46$var$_m0.Writer.create()) {
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $c4e0f03afcc1bc46$var$_m0.Reader ? input : new $c4e0f03afcc1bc46$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $c4e0f03afcc1bc46$var$createBaseQueryParamsRequest();
        while(reader.pos < end){
            const tag = reader.uint32();
            tag;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON (_) {
        return {};
    },
    toJSON (_) {
        const obj = {};
        return obj;
    },
    fromPartial (_) {
        const message = $c4e0f03afcc1bc46$var$createBaseQueryParamsRequest();
        return message;
    }
};
function $c4e0f03afcc1bc46$var$createBaseQueryParamsResponse() {
    return {
        params: undefined
    };
}
$c4e0f03afcc1bc46$exports.QueryParamsResponse = {
    encode (message, writer = $c4e0f03afcc1bc46$var$_m0.Writer.create()) {
        if (message.params !== undefined) $c31a5024779af595$exports.Params.encode(message.params, writer.uint32(10).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $c4e0f03afcc1bc46$var$_m0.Reader ? input : new $c4e0f03afcc1bc46$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $c4e0f03afcc1bc46$var$createBaseQueryParamsResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.params = $c31a5024779af595$exports.Params.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            params: (0, $d5e07fe2518aae94$exports.isSet)(object.params) ? $c31a5024779af595$exports.Params.fromJSON(object.params) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.params !== undefined && (obj.params = message.params ? $c31a5024779af595$exports.Params.toJSON(message.params) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $c4e0f03afcc1bc46$var$createBaseQueryParamsResponse();
        message.params = object.params !== undefined && object.params !== null ? $c31a5024779af595$exports.Params.fromPartial(object.params) : undefined;
        return message;
    }
};
function $c4e0f03afcc1bc46$var$createBaseQueryModuleAccountsRequest() {
    return {};
}
$c4e0f03afcc1bc46$exports.QueryModuleAccountsRequest = {
    encode (_, writer = $c4e0f03afcc1bc46$var$_m0.Writer.create()) {
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $c4e0f03afcc1bc46$var$_m0.Reader ? input : new $c4e0f03afcc1bc46$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $c4e0f03afcc1bc46$var$createBaseQueryModuleAccountsRequest();
        while(reader.pos < end){
            const tag = reader.uint32();
            tag;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON (_) {
        return {};
    },
    toJSON (_) {
        const obj = {};
        return obj;
    },
    fromPartial (_) {
        const message = $c4e0f03afcc1bc46$var$createBaseQueryModuleAccountsRequest();
        return message;
    }
};
function $c4e0f03afcc1bc46$var$createBaseQueryModuleAccountsResponse() {
    return {
        accounts: []
    };
}
$c4e0f03afcc1bc46$exports.QueryModuleAccountsResponse = {
    encode (message, writer = $c4e0f03afcc1bc46$var$_m0.Writer.create()) {
        for (const v of message.accounts)$64138e590dcf0cc1$exports.Any.encode(v, writer.uint32(10).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $c4e0f03afcc1bc46$var$_m0.Reader ? input : new $c4e0f03afcc1bc46$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $c4e0f03afcc1bc46$var$createBaseQueryModuleAccountsResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.accounts.push($64138e590dcf0cc1$exports.Any.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            accounts: Array.isArray(object?.accounts) ? object.accounts.map((e)=>$64138e590dcf0cc1$exports.Any.fromJSON(e)) : []
        };
    },
    toJSON (message) {
        const obj = {};
        if (message.accounts) obj.accounts = message.accounts.map((e)=>e ? $64138e590dcf0cc1$exports.Any.toJSON(e) : undefined);
        else obj.accounts = [];
        return obj;
    },
    fromPartial (object) {
        const message = $c4e0f03afcc1bc46$var$createBaseQueryModuleAccountsResponse();
        message.accounts = object.accounts?.map((e)=>$64138e590dcf0cc1$exports.Any.fromPartial(e)) || [];
        return message;
    }
};
function $c4e0f03afcc1bc46$var$createBaseQueryModuleAccountByNameRequest() {
    return {
        name: ""
    };
}
$c4e0f03afcc1bc46$exports.QueryModuleAccountByNameRequest = {
    encode (message, writer = $c4e0f03afcc1bc46$var$_m0.Writer.create()) {
        if (message.name !== "") writer.uint32(10).string(message.name);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $c4e0f03afcc1bc46$var$_m0.Reader ? input : new $c4e0f03afcc1bc46$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $c4e0f03afcc1bc46$var$createBaseQueryModuleAccountByNameRequest();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.name = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            name: (0, $d5e07fe2518aae94$exports.isSet)(object.name) ? String(object.name) : ""
        };
    },
    toJSON (message) {
        const obj = {};
        message.name !== undefined && (obj.name = message.name);
        return obj;
    },
    fromPartial (object) {
        const message = $c4e0f03afcc1bc46$var$createBaseQueryModuleAccountByNameRequest();
        message.name = object.name ?? "";
        return message;
    }
};
function $c4e0f03afcc1bc46$var$createBaseQueryModuleAccountByNameResponse() {
    return {
        account: undefined
    };
}
$c4e0f03afcc1bc46$exports.QueryModuleAccountByNameResponse = {
    encode (message, writer = $c4e0f03afcc1bc46$var$_m0.Writer.create()) {
        if (message.account !== undefined) $64138e590dcf0cc1$exports.Any.encode(message.account, writer.uint32(10).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $c4e0f03afcc1bc46$var$_m0.Reader ? input : new $c4e0f03afcc1bc46$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $c4e0f03afcc1bc46$var$createBaseQueryModuleAccountByNameResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.account = $64138e590dcf0cc1$exports.Any.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            account: (0, $d5e07fe2518aae94$exports.isSet)(object.account) ? $64138e590dcf0cc1$exports.Any.fromJSON(object.account) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.account !== undefined && (obj.account = message.account ? $64138e590dcf0cc1$exports.Any.toJSON(message.account) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $c4e0f03afcc1bc46$var$createBaseQueryModuleAccountByNameResponse();
        message.account = object.account !== undefined && object.account !== null ? $64138e590dcf0cc1$exports.Any.fromPartial(object.account) : undefined;
        return message;
    }
};
function $c4e0f03afcc1bc46$var$createBaseBech32PrefixRequest() {
    return {};
}
$c4e0f03afcc1bc46$exports.Bech32PrefixRequest = {
    encode (_, writer = $c4e0f03afcc1bc46$var$_m0.Writer.create()) {
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $c4e0f03afcc1bc46$var$_m0.Reader ? input : new $c4e0f03afcc1bc46$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $c4e0f03afcc1bc46$var$createBaseBech32PrefixRequest();
        while(reader.pos < end){
            const tag = reader.uint32();
            tag;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON (_) {
        return {};
    },
    toJSON (_) {
        const obj = {};
        return obj;
    },
    fromPartial (_) {
        const message = $c4e0f03afcc1bc46$var$createBaseBech32PrefixRequest();
        return message;
    }
};
function $c4e0f03afcc1bc46$var$createBaseBech32PrefixResponse() {
    return {
        bech32Prefix: ""
    };
}
$c4e0f03afcc1bc46$exports.Bech32PrefixResponse = {
    encode (message, writer = $c4e0f03afcc1bc46$var$_m0.Writer.create()) {
        if (message.bech32Prefix !== "") writer.uint32(10).string(message.bech32Prefix);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $c4e0f03afcc1bc46$var$_m0.Reader ? input : new $c4e0f03afcc1bc46$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $c4e0f03afcc1bc46$var$createBaseBech32PrefixResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.bech32Prefix = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            bech32Prefix: (0, $d5e07fe2518aae94$exports.isSet)(object.bech32Prefix) ? String(object.bech32Prefix) : ""
        };
    },
    toJSON (message) {
        const obj = {};
        message.bech32Prefix !== undefined && (obj.bech32Prefix = message.bech32Prefix);
        return obj;
    },
    fromPartial (object) {
        const message = $c4e0f03afcc1bc46$var$createBaseBech32PrefixResponse();
        message.bech32Prefix = object.bech32Prefix ?? "";
        return message;
    }
};
function $c4e0f03afcc1bc46$var$createBaseAddressBytesToStringRequest() {
    return {
        addressBytes: new Uint8Array()
    };
}
$c4e0f03afcc1bc46$exports.AddressBytesToStringRequest = {
    encode (message, writer = $c4e0f03afcc1bc46$var$_m0.Writer.create()) {
        if (message.addressBytes.length !== 0) writer.uint32(10).bytes(message.addressBytes);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $c4e0f03afcc1bc46$var$_m0.Reader ? input : new $c4e0f03afcc1bc46$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $c4e0f03afcc1bc46$var$createBaseAddressBytesToStringRequest();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.addressBytes = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            addressBytes: (0, $d5e07fe2518aae94$exports.isSet)(object.addressBytes) ? (0, $d5e07fe2518aae94$exports.bytesFromBase64)(object.addressBytes) : new Uint8Array()
        };
    },
    toJSON (message) {
        const obj = {};
        message.addressBytes !== undefined && (obj.addressBytes = (0, $d5e07fe2518aae94$exports.base64FromBytes)(message.addressBytes !== undefined ? message.addressBytes : new Uint8Array()));
        return obj;
    },
    fromPartial (object) {
        const message = $c4e0f03afcc1bc46$var$createBaseAddressBytesToStringRequest();
        message.addressBytes = object.addressBytes ?? new Uint8Array();
        return message;
    }
};
function $c4e0f03afcc1bc46$var$createBaseAddressBytesToStringResponse() {
    return {
        addressString: ""
    };
}
$c4e0f03afcc1bc46$exports.AddressBytesToStringResponse = {
    encode (message, writer = $c4e0f03afcc1bc46$var$_m0.Writer.create()) {
        if (message.addressString !== "") writer.uint32(10).string(message.addressString);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $c4e0f03afcc1bc46$var$_m0.Reader ? input : new $c4e0f03afcc1bc46$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $c4e0f03afcc1bc46$var$createBaseAddressBytesToStringResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.addressString = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            addressString: (0, $d5e07fe2518aae94$exports.isSet)(object.addressString) ? String(object.addressString) : ""
        };
    },
    toJSON (message) {
        const obj = {};
        message.addressString !== undefined && (obj.addressString = message.addressString);
        return obj;
    },
    fromPartial (object) {
        const message = $c4e0f03afcc1bc46$var$createBaseAddressBytesToStringResponse();
        message.addressString = object.addressString ?? "";
        return message;
    }
};
function $c4e0f03afcc1bc46$var$createBaseAddressStringToBytesRequest() {
    return {
        addressString: ""
    };
}
$c4e0f03afcc1bc46$exports.AddressStringToBytesRequest = {
    encode (message, writer = $c4e0f03afcc1bc46$var$_m0.Writer.create()) {
        if (message.addressString !== "") writer.uint32(10).string(message.addressString);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $c4e0f03afcc1bc46$var$_m0.Reader ? input : new $c4e0f03afcc1bc46$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $c4e0f03afcc1bc46$var$createBaseAddressStringToBytesRequest();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.addressString = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            addressString: (0, $d5e07fe2518aae94$exports.isSet)(object.addressString) ? String(object.addressString) : ""
        };
    },
    toJSON (message) {
        const obj = {};
        message.addressString !== undefined && (obj.addressString = message.addressString);
        return obj;
    },
    fromPartial (object) {
        const message = $c4e0f03afcc1bc46$var$createBaseAddressStringToBytesRequest();
        message.addressString = object.addressString ?? "";
        return message;
    }
};
function $c4e0f03afcc1bc46$var$createBaseAddressStringToBytesResponse() {
    return {
        addressBytes: new Uint8Array()
    };
}
$c4e0f03afcc1bc46$exports.AddressStringToBytesResponse = {
    encode (message, writer = $c4e0f03afcc1bc46$var$_m0.Writer.create()) {
        if (message.addressBytes.length !== 0) writer.uint32(10).bytes(message.addressBytes);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $c4e0f03afcc1bc46$var$_m0.Reader ? input : new $c4e0f03afcc1bc46$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $c4e0f03afcc1bc46$var$createBaseAddressStringToBytesResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.addressBytes = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            addressBytes: (0, $d5e07fe2518aae94$exports.isSet)(object.addressBytes) ? (0, $d5e07fe2518aae94$exports.bytesFromBase64)(object.addressBytes) : new Uint8Array()
        };
    },
    toJSON (message) {
        const obj = {};
        message.addressBytes !== undefined && (obj.addressBytes = (0, $d5e07fe2518aae94$exports.base64FromBytes)(message.addressBytes !== undefined ? message.addressBytes : new Uint8Array()));
        return obj;
    },
    fromPartial (object) {
        const message = $c4e0f03afcc1bc46$var$createBaseAddressStringToBytesResponse();
        message.addressBytes = object.addressBytes ?? new Uint8Array();
        return message;
    }
};
function $c4e0f03afcc1bc46$var$createBaseQueryAccountAddressByIDRequest() {
    return {
        id: $d5e07fe2518aae94$exports.Long.ZERO,
        accountId: $d5e07fe2518aae94$exports.Long.UZERO
    };
}
$c4e0f03afcc1bc46$exports.QueryAccountAddressByIDRequest = {
    encode (message, writer = $c4e0f03afcc1bc46$var$_m0.Writer.create()) {
        if (!message.id.isZero()) writer.uint32(8).int64(message.id);
        if (!message.accountId.isZero()) writer.uint32(16).uint64(message.accountId);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $c4e0f03afcc1bc46$var$_m0.Reader ? input : new $c4e0f03afcc1bc46$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $c4e0f03afcc1bc46$var$createBaseQueryAccountAddressByIDRequest();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.id = reader.int64();
                    break;
                case 2:
                    message.accountId = reader.uint64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            id: (0, $d5e07fe2518aae94$exports.isSet)(object.id) ? $d5e07fe2518aae94$exports.Long.fromValue(object.id) : $d5e07fe2518aae94$exports.Long.ZERO,
            accountId: (0, $d5e07fe2518aae94$exports.isSet)(object.accountId) ? $d5e07fe2518aae94$exports.Long.fromValue(object.accountId) : $d5e07fe2518aae94$exports.Long.UZERO
        };
    },
    toJSON (message) {
        const obj = {};
        message.id !== undefined && (obj.id = (message.id || $d5e07fe2518aae94$exports.Long.ZERO).toString());
        message.accountId !== undefined && (obj.accountId = (message.accountId || $d5e07fe2518aae94$exports.Long.UZERO).toString());
        return obj;
    },
    fromPartial (object) {
        const message = $c4e0f03afcc1bc46$var$createBaseQueryAccountAddressByIDRequest();
        message.id = object.id !== undefined && object.id !== null ? $d5e07fe2518aae94$exports.Long.fromValue(object.id) : $d5e07fe2518aae94$exports.Long.ZERO;
        message.accountId = object.accountId !== undefined && object.accountId !== null ? $d5e07fe2518aae94$exports.Long.fromValue(object.accountId) : $d5e07fe2518aae94$exports.Long.UZERO;
        return message;
    }
};
function $c4e0f03afcc1bc46$var$createBaseQueryAccountAddressByIDResponse() {
    return {
        accountAddress: ""
    };
}
$c4e0f03afcc1bc46$exports.QueryAccountAddressByIDResponse = {
    encode (message, writer = $c4e0f03afcc1bc46$var$_m0.Writer.create()) {
        if (message.accountAddress !== "") writer.uint32(10).string(message.accountAddress);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $c4e0f03afcc1bc46$var$_m0.Reader ? input : new $c4e0f03afcc1bc46$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $c4e0f03afcc1bc46$var$createBaseQueryAccountAddressByIDResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.accountAddress = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            accountAddress: (0, $d5e07fe2518aae94$exports.isSet)(object.accountAddress) ? String(object.accountAddress) : ""
        };
    },
    toJSON (message) {
        const obj = {};
        message.accountAddress !== undefined && (obj.accountAddress = message.accountAddress);
        return obj;
    },
    fromPartial (object) {
        const message = $c4e0f03afcc1bc46$var$createBaseQueryAccountAddressByIDResponse();
        message.accountAddress = object.accountAddress ?? "";
        return message;
    }
};
function $c4e0f03afcc1bc46$var$createBaseQueryAccountInfoRequest() {
    return {
        address: ""
    };
}
$c4e0f03afcc1bc46$exports.QueryAccountInfoRequest = {
    encode (message, writer = $c4e0f03afcc1bc46$var$_m0.Writer.create()) {
        if (message.address !== "") writer.uint32(10).string(message.address);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $c4e0f03afcc1bc46$var$_m0.Reader ? input : new $c4e0f03afcc1bc46$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $c4e0f03afcc1bc46$var$createBaseQueryAccountInfoRequest();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.address = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            address: (0, $d5e07fe2518aae94$exports.isSet)(object.address) ? String(object.address) : ""
        };
    },
    toJSON (message) {
        const obj = {};
        message.address !== undefined && (obj.address = message.address);
        return obj;
    },
    fromPartial (object) {
        const message = $c4e0f03afcc1bc46$var$createBaseQueryAccountInfoRequest();
        message.address = object.address ?? "";
        return message;
    }
};
function $c4e0f03afcc1bc46$var$createBaseQueryAccountInfoResponse() {
    return {
        info: undefined
    };
}
$c4e0f03afcc1bc46$exports.QueryAccountInfoResponse = {
    encode (message, writer = $c4e0f03afcc1bc46$var$_m0.Writer.create()) {
        if (message.info !== undefined) $c31a5024779af595$exports.BaseAccount.encode(message.info, writer.uint32(10).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $c4e0f03afcc1bc46$var$_m0.Reader ? input : new $c4e0f03afcc1bc46$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $c4e0f03afcc1bc46$var$createBaseQueryAccountInfoResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.info = $c31a5024779af595$exports.BaseAccount.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            info: (0, $d5e07fe2518aae94$exports.isSet)(object.info) ? $c31a5024779af595$exports.BaseAccount.fromJSON(object.info) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.info !== undefined && (obj.info = message.info ? $c31a5024779af595$exports.BaseAccount.toJSON(message.info) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $c4e0f03afcc1bc46$var$createBaseQueryAccountInfoResponse();
        message.info = object.info !== undefined && object.info !== null ? $c31a5024779af595$exports.BaseAccount.fromPartial(object.info) : undefined;
        return message;
    }
};
class $c4e0f03afcc1bc46$var$QueryClientImpl {
    constructor(rpc){
        this.rpc = rpc;
        this.Accounts = this.Accounts.bind(this);
        this.Account = this.Account.bind(this);
        this.AccountAddressByID = this.AccountAddressByID.bind(this);
        this.Params = this.Params.bind(this);
        this.ModuleAccounts = this.ModuleAccounts.bind(this);
        this.ModuleAccountByName = this.ModuleAccountByName.bind(this);
        this.Bech32Prefix = this.Bech32Prefix.bind(this);
        this.AddressBytesToString = this.AddressBytesToString.bind(this);
        this.AddressStringToBytes = this.AddressStringToBytes.bind(this);
        this.AccountInfo = this.AccountInfo.bind(this);
    }
    Accounts(request = {
        pagination: undefined
    }) {
        const data = $c4e0f03afcc1bc46$exports.QueryAccountsRequest.encode(request).finish();
        const promise = this.rpc.request("cosmos.auth.v1beta1.Query", "Accounts", data);
        return promise.then((data)=>$c4e0f03afcc1bc46$exports.QueryAccountsResponse.decode(new $c4e0f03afcc1bc46$var$_m0.Reader(data)));
    }
    Account(request) {
        const data = $c4e0f03afcc1bc46$exports.QueryAccountRequest.encode(request).finish();
        const promise = this.rpc.request("cosmos.auth.v1beta1.Query", "Account", data);
        return promise.then((data)=>$c4e0f03afcc1bc46$exports.QueryAccountResponse.decode(new $c4e0f03afcc1bc46$var$_m0.Reader(data)));
    }
    AccountAddressByID(request) {
        const data = $c4e0f03afcc1bc46$exports.QueryAccountAddressByIDRequest.encode(request).finish();
        const promise = this.rpc.request("cosmos.auth.v1beta1.Query", "AccountAddressByID", data);
        return promise.then((data)=>$c4e0f03afcc1bc46$exports.QueryAccountAddressByIDResponse.decode(new $c4e0f03afcc1bc46$var$_m0.Reader(data)));
    }
    Params(request = {}) {
        const data = $c4e0f03afcc1bc46$exports.QueryParamsRequest.encode(request).finish();
        const promise = this.rpc.request("cosmos.auth.v1beta1.Query", "Params", data);
        return promise.then((data)=>$c4e0f03afcc1bc46$exports.QueryParamsResponse.decode(new $c4e0f03afcc1bc46$var$_m0.Reader(data)));
    }
    ModuleAccounts(request = {}) {
        const data = $c4e0f03afcc1bc46$exports.QueryModuleAccountsRequest.encode(request).finish();
        const promise = this.rpc.request("cosmos.auth.v1beta1.Query", "ModuleAccounts", data);
        return promise.then((data)=>$c4e0f03afcc1bc46$exports.QueryModuleAccountsResponse.decode(new $c4e0f03afcc1bc46$var$_m0.Reader(data)));
    }
    ModuleAccountByName(request) {
        const data = $c4e0f03afcc1bc46$exports.QueryModuleAccountByNameRequest.encode(request).finish();
        const promise = this.rpc.request("cosmos.auth.v1beta1.Query", "ModuleAccountByName", data);
        return promise.then((data)=>$c4e0f03afcc1bc46$exports.QueryModuleAccountByNameResponse.decode(new $c4e0f03afcc1bc46$var$_m0.Reader(data)));
    }
    Bech32Prefix(request = {}) {
        const data = $c4e0f03afcc1bc46$exports.Bech32PrefixRequest.encode(request).finish();
        const promise = this.rpc.request("cosmos.auth.v1beta1.Query", "Bech32Prefix", data);
        return promise.then((data)=>$c4e0f03afcc1bc46$exports.Bech32PrefixResponse.decode(new $c4e0f03afcc1bc46$var$_m0.Reader(data)));
    }
    AddressBytesToString(request) {
        const data = $c4e0f03afcc1bc46$exports.AddressBytesToStringRequest.encode(request).finish();
        const promise = this.rpc.request("cosmos.auth.v1beta1.Query", "AddressBytesToString", data);
        return promise.then((data)=>$c4e0f03afcc1bc46$exports.AddressBytesToStringResponse.decode(new $c4e0f03afcc1bc46$var$_m0.Reader(data)));
    }
    AddressStringToBytes(request) {
        const data = $c4e0f03afcc1bc46$exports.AddressStringToBytesRequest.encode(request).finish();
        const promise = this.rpc.request("cosmos.auth.v1beta1.Query", "AddressStringToBytes", data);
        return promise.then((data)=>$c4e0f03afcc1bc46$exports.AddressStringToBytesResponse.decode(new $c4e0f03afcc1bc46$var$_m0.Reader(data)));
    }
    AccountInfo(request) {
        const data = $c4e0f03afcc1bc46$exports.QueryAccountInfoRequest.encode(request).finish();
        const promise = this.rpc.request("cosmos.auth.v1beta1.Query", "AccountInfo", data);
        return promise.then((data)=>$c4e0f03afcc1bc46$exports.QueryAccountInfoResponse.decode(new $c4e0f03afcc1bc46$var$_m0.Reader(data)));
    }
}
$c4e0f03afcc1bc46$exports.QueryClientImpl = $c4e0f03afcc1bc46$var$QueryClientImpl;


var $a3959936d2cce854$exports = {};
"use strict";
Object.defineProperty($a3959936d2cce854$exports, "__esModule", {
    value: true
});
$a3959936d2cce854$exports.longify = $a3959936d2cce854$exports.decodeCosmosSdkDecFromProto = $a3959936d2cce854$exports.createProtobufRpcClient = $a3959936d2cce854$exports.createPagination = $a3959936d2cce854$exports.QueryClient = void 0;
var $c72059c029acecec$exports = {};
"use strict";
Object.defineProperty($c72059c029acecec$exports, "__esModule", {
    value: true
});
$c72059c029acecec$exports.QueryClient = void 0;
var $a036351a9c7664e2$exports = {};
"use strict";
Object.defineProperty($a036351a9c7664e2$exports, "__esModule", {
    value: true
});
$a036351a9c7664e2$exports.verifyNonExistence = $a036351a9c7664e2$exports.verifyExistence = $a036351a9c7664e2$exports.tendermintSpec = $a036351a9c7664e2$exports.iavlSpec = $a036351a9c7664e2$exports.calculateExistenceRoot = $a036351a9c7664e2$exports.verifyNonMembership = $a036351a9c7664e2$exports.verifyMembership = $a036351a9c7664e2$exports.ics23 = void 0;
var $ef65a4887ab7ae06$exports = {};
/*eslint-disable block-scoped-var, id-length, no-control-regex, no-magic-numbers, no-prototype-builtins, no-redeclare, no-shadow, no-var, sort-vars*/ "use strict";

var $fQBv0 = parcelRequire("fQBv0");
// Common aliases
var $ef65a4887ab7ae06$var$$Reader = $fQBv0.Reader, $ef65a4887ab7ae06$var$$Writer = $fQBv0.Writer, $ef65a4887ab7ae06$var$$util = $fQBv0.util;
// Exported root namespace
var $ef65a4887ab7ae06$var$$root = $fQBv0.roots["default"] || ($fQBv0.roots["default"] = {});
$ef65a4887ab7ae06$var$$root.ics23 = function() {
    /**
     * Namespace ics23.
     * @exports ics23
     * @namespace
     */ var ics23 = {};
    /**
     * HashOp enum.
     * @name ics23.HashOp
     * @enum {string}
     * @property {number} NO_HASH=0 NO_HASH value
     * @property {number} SHA256=1 SHA256 value
     * @property {number} SHA512=2 SHA512 value
     * @property {number} KECCAK=3 KECCAK value
     * @property {number} RIPEMD160=4 RIPEMD160 value
     * @property {number} BITCOIN=5 BITCOIN value
     * @property {number} SHA512_256=6 SHA512_256 value
     */ ics23.HashOp = function() {
        var valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "NO_HASH"] = 0;
        values[valuesById[1] = "SHA256"] = 1;
        values[valuesById[2] = "SHA512"] = 2;
        values[valuesById[3] = "KECCAK"] = 3;
        values[valuesById[4] = "RIPEMD160"] = 4;
        values[valuesById[5] = "BITCOIN"] = 5;
        values[valuesById[6] = "SHA512_256"] = 6;
        return values;
    }();
    /**
     * LengthOp defines how to process the key and value of the LeafOp
     * to include length information. After encoding the length with the given
     * algorithm, the length will be prepended to the key and value bytes.
     * (Each one with it's own encoded length)
     * @name ics23.LengthOp
     * @enum {string}
     * @property {number} NO_PREFIX=0 NO_PREFIX value
     * @property {number} VAR_PROTO=1 VAR_PROTO value
     * @property {number} VAR_RLP=2 VAR_RLP value
     * @property {number} FIXED32_BIG=3 FIXED32_BIG value
     * @property {number} FIXED32_LITTLE=4 FIXED32_LITTLE value
     * @property {number} FIXED64_BIG=5 FIXED64_BIG value
     * @property {number} FIXED64_LITTLE=6 FIXED64_LITTLE value
     * @property {number} REQUIRE_32_BYTES=7 REQUIRE_32_BYTES value
     * @property {number} REQUIRE_64_BYTES=8 REQUIRE_64_BYTES value
     */ ics23.LengthOp = function() {
        var valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "NO_PREFIX"] = 0;
        values[valuesById[1] = "VAR_PROTO"] = 1;
        values[valuesById[2] = "VAR_RLP"] = 2;
        values[valuesById[3] = "FIXED32_BIG"] = 3;
        values[valuesById[4] = "FIXED32_LITTLE"] = 4;
        values[valuesById[5] = "FIXED64_BIG"] = 5;
        values[valuesById[6] = "FIXED64_LITTLE"] = 6;
        values[valuesById[7] = "REQUIRE_32_BYTES"] = 7;
        values[valuesById[8] = "REQUIRE_64_BYTES"] = 8;
        return values;
    }();
    ics23.ExistenceProof = function() {
        /**
         * Properties of an ExistenceProof.
         * @memberof ics23
         * @interface IExistenceProof
         * @property {Uint8Array|null} [key] ExistenceProof key
         * @property {Uint8Array|null} [value] ExistenceProof value
         * @property {ics23.ILeafOp|null} [leaf] ExistenceProof leaf
         * @property {Array.<ics23.IInnerOp>|null} [path] ExistenceProof path
         */ /**
         * Constructs a new ExistenceProof.
         * @memberof ics23
         * @classdesc ExistenceProof takes a key and a value and a set of steps to perform on it.
         * The result of peforming all these steps will provide a "root hash", which can
         * be compared to the value in a header.
         * 
         * Since it is computationally infeasible to produce a hash collission for any of the used
         * cryptographic hash functions, if someone can provide a series of operations to transform
         * a given key and value into a root hash that matches some trusted root, these key and values
         * must be in the referenced merkle tree.
         * 
         * The only possible issue is maliablity in LeafOp, such as providing extra prefix data,
         * which should be controlled by a spec. Eg. with lengthOp as NONE,
         * prefix = FOO, key = BAR, value = CHOICE
         * and
         * prefix = F, key = OOBAR, value = CHOICE
         * would produce the same value.
         * 
         * With LengthOp this is tricker but not impossible. Which is why the "leafPrefixEqual" field
         * in the ProofSpec is valuable to prevent this mutability. And why all trees should
         * length-prefix the data before hashing it.
         * @implements IExistenceProof
         * @constructor
         * @param {ics23.IExistenceProof=} [properties] Properties to set
         */ function ExistenceProof(properties) {
            this.path = [];
            if (properties) {
                for(var keys = Object.keys(properties), i = 0; i < keys.length; ++i)if (properties[keys[i]] != null) this[keys[i]] = properties[keys[i]];
            }
        }
        /**
         * ExistenceProof key.
         * @member {Uint8Array} key
         * @memberof ics23.ExistenceProof
         * @instance
         */ ExistenceProof.prototype.key = $ef65a4887ab7ae06$var$$util.newBuffer([]);
        /**
         * ExistenceProof value.
         * @member {Uint8Array} value
         * @memberof ics23.ExistenceProof
         * @instance
         */ ExistenceProof.prototype.value = $ef65a4887ab7ae06$var$$util.newBuffer([]);
        /**
         * ExistenceProof leaf.
         * @member {ics23.ILeafOp|null|undefined} leaf
         * @memberof ics23.ExistenceProof
         * @instance
         */ ExistenceProof.prototype.leaf = null;
        /**
         * ExistenceProof path.
         * @member {Array.<ics23.IInnerOp>} path
         * @memberof ics23.ExistenceProof
         * @instance
         */ ExistenceProof.prototype.path = $ef65a4887ab7ae06$var$$util.emptyArray;
        /**
         * Creates a new ExistenceProof instance using the specified properties.
         * @function create
         * @memberof ics23.ExistenceProof
         * @static
         * @param {ics23.IExistenceProof=} [properties] Properties to set
         * @returns {ics23.ExistenceProof} ExistenceProof instance
         */ ExistenceProof.create = function create(properties) {
            return new ExistenceProof(properties);
        };
        /**
         * Encodes the specified ExistenceProof message. Does not implicitly {@link ics23.ExistenceProof.verify|verify} messages.
         * @function encode
         * @memberof ics23.ExistenceProof
         * @static
         * @param {ics23.IExistenceProof} message ExistenceProof message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */ ExistenceProof.encode = function encode(message, writer) {
            if (!writer) writer = $ef65a4887ab7ae06$var$$Writer.create();
            if (message.key != null && message.hasOwnProperty("key")) writer.uint32(/* id 1, wireType 2 =*/ 10).bytes(message.key);
            if (message.value != null && message.hasOwnProperty("value")) writer.uint32(/* id 2, wireType 2 =*/ 18).bytes(message.value);
            if (message.leaf != null && message.hasOwnProperty("leaf")) $ef65a4887ab7ae06$var$$root.ics23.LeafOp.encode(message.leaf, writer.uint32(/* id 3, wireType 2 =*/ 26).fork()).ldelim();
            if (message.path != null && message.path.length) for(var i = 0; i < message.path.length; ++i)$ef65a4887ab7ae06$var$$root.ics23.InnerOp.encode(message.path[i], writer.uint32(/* id 4, wireType 2 =*/ 34).fork()).ldelim();
            return writer;
        };
        /**
         * Encodes the specified ExistenceProof message, length delimited. Does not implicitly {@link ics23.ExistenceProof.verify|verify} messages.
         * @function encodeDelimited
         * @memberof ics23.ExistenceProof
         * @static
         * @param {ics23.IExistenceProof} message ExistenceProof message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */ ExistenceProof.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };
        /**
         * Decodes an ExistenceProof message from the specified reader or buffer.
         * @function decode
         * @memberof ics23.ExistenceProof
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {ics23.ExistenceProof} ExistenceProof
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */ ExistenceProof.decode = function decode(reader, length) {
            if (!(reader instanceof $ef65a4887ab7ae06$var$$Reader)) reader = $ef65a4887ab7ae06$var$$Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $ef65a4887ab7ae06$var$$root.ics23.ExistenceProof();
            while(reader.pos < end){
                var tag = reader.uint32();
                switch(tag >>> 3){
                    case 1:
                        message.key = reader.bytes();
                        break;
                    case 2:
                        message.value = reader.bytes();
                        break;
                    case 3:
                        message.leaf = $ef65a4887ab7ae06$var$$root.ics23.LeafOp.decode(reader, reader.uint32());
                        break;
                    case 4:
                        if (!(message.path && message.path.length)) message.path = [];
                        message.path.push($ef65a4887ab7ae06$var$$root.ics23.InnerOp.decode(reader, reader.uint32()));
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                }
            }
            return message;
        };
        /**
         * Decodes an ExistenceProof message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof ics23.ExistenceProof
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {ics23.ExistenceProof} ExistenceProof
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */ ExistenceProof.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $ef65a4887ab7ae06$var$$Reader)) reader = new $ef65a4887ab7ae06$var$$Reader(reader);
            return this.decode(reader, reader.uint32());
        };
        /**
         * Verifies an ExistenceProof message.
         * @function verify
         * @memberof ics23.ExistenceProof
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */ ExistenceProof.verify = function verify(message) {
            if (typeof message !== "object" || message === null) return "object expected";
            if (message.key != null && message.hasOwnProperty("key")) {
                if (!(message.key && typeof message.key.length === "number" || $ef65a4887ab7ae06$var$$util.isString(message.key))) return "key: buffer expected";
            }
            if (message.value != null && message.hasOwnProperty("value")) {
                if (!(message.value && typeof message.value.length === "number" || $ef65a4887ab7ae06$var$$util.isString(message.value))) return "value: buffer expected";
            }
            if (message.leaf != null && message.hasOwnProperty("leaf")) {
                var error = $ef65a4887ab7ae06$var$$root.ics23.LeafOp.verify(message.leaf);
                if (error) return "leaf." + error;
            }
            if (message.path != null && message.hasOwnProperty("path")) {
                if (!Array.isArray(message.path)) return "path: array expected";
                for(var i = 0; i < message.path.length; ++i){
                    var error = $ef65a4887ab7ae06$var$$root.ics23.InnerOp.verify(message.path[i]);
                    if (error) return "path." + error;
                }
            }
            return null;
        };
        /**
         * Creates an ExistenceProof message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof ics23.ExistenceProof
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {ics23.ExistenceProof} ExistenceProof
         */ ExistenceProof.fromObject = function fromObject(object) {
            if (object instanceof $ef65a4887ab7ae06$var$$root.ics23.ExistenceProof) return object;
            var message = new $ef65a4887ab7ae06$var$$root.ics23.ExistenceProof();
            if (object.key != null) {
                if (typeof object.key === "string") $ef65a4887ab7ae06$var$$util.base64.decode(object.key, message.key = $ef65a4887ab7ae06$var$$util.newBuffer($ef65a4887ab7ae06$var$$util.base64.length(object.key)), 0);
                else if (object.key.length) message.key = object.key;
            }
            if (object.value != null) {
                if (typeof object.value === "string") $ef65a4887ab7ae06$var$$util.base64.decode(object.value, message.value = $ef65a4887ab7ae06$var$$util.newBuffer($ef65a4887ab7ae06$var$$util.base64.length(object.value)), 0);
                else if (object.value.length) message.value = object.value;
            }
            if (object.leaf != null) {
                if (typeof object.leaf !== "object") throw TypeError(".ics23.ExistenceProof.leaf: object expected");
                message.leaf = $ef65a4887ab7ae06$var$$root.ics23.LeafOp.fromObject(object.leaf);
            }
            if (object.path) {
                if (!Array.isArray(object.path)) throw TypeError(".ics23.ExistenceProof.path: array expected");
                message.path = [];
                for(var i = 0; i < object.path.length; ++i){
                    if (typeof object.path[i] !== "object") throw TypeError(".ics23.ExistenceProof.path: object expected");
                    message.path[i] = $ef65a4887ab7ae06$var$$root.ics23.InnerOp.fromObject(object.path[i]);
                }
            }
            return message;
        };
        /**
         * Creates a plain object from an ExistenceProof message. Also converts values to other types if specified.
         * @function toObject
         * @memberof ics23.ExistenceProof
         * @static
         * @param {ics23.ExistenceProof} message ExistenceProof
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */ ExistenceProof.toObject = function toObject(message, options) {
            if (!options) options = {};
            var object = {};
            if (options.arrays || options.defaults) object.path = [];
            if (options.defaults) {
                if (options.bytes === String) object.key = "";
                else {
                    object.key = [];
                    if (options.bytes !== Array) object.key = $ef65a4887ab7ae06$var$$util.newBuffer(object.key);
                }
                if (options.bytes === String) object.value = "";
                else {
                    object.value = [];
                    if (options.bytes !== Array) object.value = $ef65a4887ab7ae06$var$$util.newBuffer(object.value);
                }
                object.leaf = null;
            }
            if (message.key != null && message.hasOwnProperty("key")) object.key = options.bytes === String ? $ef65a4887ab7ae06$var$$util.base64.encode(message.key, 0, message.key.length) : options.bytes === Array ? Array.prototype.slice.call(message.key) : message.key;
            if (message.value != null && message.hasOwnProperty("value")) object.value = options.bytes === String ? $ef65a4887ab7ae06$var$$util.base64.encode(message.value, 0, message.value.length) : options.bytes === Array ? Array.prototype.slice.call(message.value) : message.value;
            if (message.leaf != null && message.hasOwnProperty("leaf")) object.leaf = $ef65a4887ab7ae06$var$$root.ics23.LeafOp.toObject(message.leaf, options);
            if (message.path && message.path.length) {
                object.path = [];
                for(var j = 0; j < message.path.length; ++j)object.path[j] = $ef65a4887ab7ae06$var$$root.ics23.InnerOp.toObject(message.path[j], options);
            }
            return object;
        };
        /**
         * Converts this ExistenceProof to JSON.
         * @function toJSON
         * @memberof ics23.ExistenceProof
         * @instance
         * @returns {Object.<string,*>} JSON object
         */ ExistenceProof.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $fQBv0.util.toJSONOptions);
        };
        return ExistenceProof;
    }();
    ics23.NonExistenceProof = function() {
        /**
         * Properties of a NonExistenceProof.
         * @memberof ics23
         * @interface INonExistenceProof
         * @property {Uint8Array|null} [key] NonExistenceProof key
         * @property {ics23.IExistenceProof|null} [left] NonExistenceProof left
         * @property {ics23.IExistenceProof|null} [right] NonExistenceProof right
         */ /**
         * Constructs a new NonExistenceProof.
         * @memberof ics23
         * @classdesc Represents a NonExistenceProof.
         * @implements INonExistenceProof
         * @constructor
         * @param {ics23.INonExistenceProof=} [properties] Properties to set
         */ function NonExistenceProof(properties) {
            if (properties) {
                for(var keys = Object.keys(properties), i = 0; i < keys.length; ++i)if (properties[keys[i]] != null) this[keys[i]] = properties[keys[i]];
            }
        }
        /**
         * NonExistenceProof key.
         * @member {Uint8Array} key
         * @memberof ics23.NonExistenceProof
         * @instance
         */ NonExistenceProof.prototype.key = $ef65a4887ab7ae06$var$$util.newBuffer([]);
        /**
         * NonExistenceProof left.
         * @member {ics23.IExistenceProof|null|undefined} left
         * @memberof ics23.NonExistenceProof
         * @instance
         */ NonExistenceProof.prototype.left = null;
        /**
         * NonExistenceProof right.
         * @member {ics23.IExistenceProof|null|undefined} right
         * @memberof ics23.NonExistenceProof
         * @instance
         */ NonExistenceProof.prototype.right = null;
        /**
         * Creates a new NonExistenceProof instance using the specified properties.
         * @function create
         * @memberof ics23.NonExistenceProof
         * @static
         * @param {ics23.INonExistenceProof=} [properties] Properties to set
         * @returns {ics23.NonExistenceProof} NonExistenceProof instance
         */ NonExistenceProof.create = function create(properties) {
            return new NonExistenceProof(properties);
        };
        /**
         * Encodes the specified NonExistenceProof message. Does not implicitly {@link ics23.NonExistenceProof.verify|verify} messages.
         * @function encode
         * @memberof ics23.NonExistenceProof
         * @static
         * @param {ics23.INonExistenceProof} message NonExistenceProof message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */ NonExistenceProof.encode = function encode(message, writer) {
            if (!writer) writer = $ef65a4887ab7ae06$var$$Writer.create();
            if (message.key != null && message.hasOwnProperty("key")) writer.uint32(/* id 1, wireType 2 =*/ 10).bytes(message.key);
            if (message.left != null && message.hasOwnProperty("left")) $ef65a4887ab7ae06$var$$root.ics23.ExistenceProof.encode(message.left, writer.uint32(/* id 2, wireType 2 =*/ 18).fork()).ldelim();
            if (message.right != null && message.hasOwnProperty("right")) $ef65a4887ab7ae06$var$$root.ics23.ExistenceProof.encode(message.right, writer.uint32(/* id 3, wireType 2 =*/ 26).fork()).ldelim();
            return writer;
        };
        /**
         * Encodes the specified NonExistenceProof message, length delimited. Does not implicitly {@link ics23.NonExistenceProof.verify|verify} messages.
         * @function encodeDelimited
         * @memberof ics23.NonExistenceProof
         * @static
         * @param {ics23.INonExistenceProof} message NonExistenceProof message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */ NonExistenceProof.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };
        /**
         * Decodes a NonExistenceProof message from the specified reader or buffer.
         * @function decode
         * @memberof ics23.NonExistenceProof
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {ics23.NonExistenceProof} NonExistenceProof
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */ NonExistenceProof.decode = function decode(reader, length) {
            if (!(reader instanceof $ef65a4887ab7ae06$var$$Reader)) reader = $ef65a4887ab7ae06$var$$Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $ef65a4887ab7ae06$var$$root.ics23.NonExistenceProof();
            while(reader.pos < end){
                var tag = reader.uint32();
                switch(tag >>> 3){
                    case 1:
                        message.key = reader.bytes();
                        break;
                    case 2:
                        message.left = $ef65a4887ab7ae06$var$$root.ics23.ExistenceProof.decode(reader, reader.uint32());
                        break;
                    case 3:
                        message.right = $ef65a4887ab7ae06$var$$root.ics23.ExistenceProof.decode(reader, reader.uint32());
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                }
            }
            return message;
        };
        /**
         * Decodes a NonExistenceProof message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof ics23.NonExistenceProof
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {ics23.NonExistenceProof} NonExistenceProof
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */ NonExistenceProof.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $ef65a4887ab7ae06$var$$Reader)) reader = new $ef65a4887ab7ae06$var$$Reader(reader);
            return this.decode(reader, reader.uint32());
        };
        /**
         * Verifies a NonExistenceProof message.
         * @function verify
         * @memberof ics23.NonExistenceProof
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */ NonExistenceProof.verify = function verify(message) {
            if (typeof message !== "object" || message === null) return "object expected";
            if (message.key != null && message.hasOwnProperty("key")) {
                if (!(message.key && typeof message.key.length === "number" || $ef65a4887ab7ae06$var$$util.isString(message.key))) return "key: buffer expected";
            }
            if (message.left != null && message.hasOwnProperty("left")) {
                var error = $ef65a4887ab7ae06$var$$root.ics23.ExistenceProof.verify(message.left);
                if (error) return "left." + error;
            }
            if (message.right != null && message.hasOwnProperty("right")) {
                var error = $ef65a4887ab7ae06$var$$root.ics23.ExistenceProof.verify(message.right);
                if (error) return "right." + error;
            }
            return null;
        };
        /**
         * Creates a NonExistenceProof message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof ics23.NonExistenceProof
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {ics23.NonExistenceProof} NonExistenceProof
         */ NonExistenceProof.fromObject = function fromObject(object) {
            if (object instanceof $ef65a4887ab7ae06$var$$root.ics23.NonExistenceProof) return object;
            var message = new $ef65a4887ab7ae06$var$$root.ics23.NonExistenceProof();
            if (object.key != null) {
                if (typeof object.key === "string") $ef65a4887ab7ae06$var$$util.base64.decode(object.key, message.key = $ef65a4887ab7ae06$var$$util.newBuffer($ef65a4887ab7ae06$var$$util.base64.length(object.key)), 0);
                else if (object.key.length) message.key = object.key;
            }
            if (object.left != null) {
                if (typeof object.left !== "object") throw TypeError(".ics23.NonExistenceProof.left: object expected");
                message.left = $ef65a4887ab7ae06$var$$root.ics23.ExistenceProof.fromObject(object.left);
            }
            if (object.right != null) {
                if (typeof object.right !== "object") throw TypeError(".ics23.NonExistenceProof.right: object expected");
                message.right = $ef65a4887ab7ae06$var$$root.ics23.ExistenceProof.fromObject(object.right);
            }
            return message;
        };
        /**
         * Creates a plain object from a NonExistenceProof message. Also converts values to other types if specified.
         * @function toObject
         * @memberof ics23.NonExistenceProof
         * @static
         * @param {ics23.NonExistenceProof} message NonExistenceProof
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */ NonExistenceProof.toObject = function toObject(message, options) {
            if (!options) options = {};
            var object = {};
            if (options.defaults) {
                if (options.bytes === String) object.key = "";
                else {
                    object.key = [];
                    if (options.bytes !== Array) object.key = $ef65a4887ab7ae06$var$$util.newBuffer(object.key);
                }
                object.left = null;
                object.right = null;
            }
            if (message.key != null && message.hasOwnProperty("key")) object.key = options.bytes === String ? $ef65a4887ab7ae06$var$$util.base64.encode(message.key, 0, message.key.length) : options.bytes === Array ? Array.prototype.slice.call(message.key) : message.key;
            if (message.left != null && message.hasOwnProperty("left")) object.left = $ef65a4887ab7ae06$var$$root.ics23.ExistenceProof.toObject(message.left, options);
            if (message.right != null && message.hasOwnProperty("right")) object.right = $ef65a4887ab7ae06$var$$root.ics23.ExistenceProof.toObject(message.right, options);
            return object;
        };
        /**
         * Converts this NonExistenceProof to JSON.
         * @function toJSON
         * @memberof ics23.NonExistenceProof
         * @instance
         * @returns {Object.<string,*>} JSON object
         */ NonExistenceProof.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $fQBv0.util.toJSONOptions);
        };
        return NonExistenceProof;
    }();
    ics23.CommitmentProof = function() {
        /**
         * Properties of a CommitmentProof.
         * @memberof ics23
         * @interface ICommitmentProof
         * @property {ics23.IExistenceProof|null} [exist] CommitmentProof exist
         * @property {ics23.INonExistenceProof|null} [nonexist] CommitmentProof nonexist
         * @property {ics23.IBatchProof|null} [batch] CommitmentProof batch
         * @property {ics23.ICompressedBatchProof|null} [compressed] CommitmentProof compressed
         */ /**
         * Constructs a new CommitmentProof.
         * @memberof ics23
         * @classdesc Represents a CommitmentProof.
         * @implements ICommitmentProof
         * @constructor
         * @param {ics23.ICommitmentProof=} [properties] Properties to set
         */ function CommitmentProof(properties) {
            if (properties) {
                for(var keys = Object.keys(properties), i = 0; i < keys.length; ++i)if (properties[keys[i]] != null) this[keys[i]] = properties[keys[i]];
            }
        }
        /**
         * CommitmentProof exist.
         * @member {ics23.IExistenceProof|null|undefined} exist
         * @memberof ics23.CommitmentProof
         * @instance
         */ CommitmentProof.prototype.exist = null;
        /**
         * CommitmentProof nonexist.
         * @member {ics23.INonExistenceProof|null|undefined} nonexist
         * @memberof ics23.CommitmentProof
         * @instance
         */ CommitmentProof.prototype.nonexist = null;
        /**
         * CommitmentProof batch.
         * @member {ics23.IBatchProof|null|undefined} batch
         * @memberof ics23.CommitmentProof
         * @instance
         */ CommitmentProof.prototype.batch = null;
        /**
         * CommitmentProof compressed.
         * @member {ics23.ICompressedBatchProof|null|undefined} compressed
         * @memberof ics23.CommitmentProof
         * @instance
         */ CommitmentProof.prototype.compressed = null;
        // OneOf field names bound to virtual getters and setters
        var $oneOfFields;
        /**
         * CommitmentProof proof.
         * @member {"exist"|"nonexist"|"batch"|"compressed"|undefined} proof
         * @memberof ics23.CommitmentProof
         * @instance
         */ Object.defineProperty(CommitmentProof.prototype, "proof", {
            get: $ef65a4887ab7ae06$var$$util.oneOfGetter($oneOfFields = [
                "exist",
                "nonexist",
                "batch",
                "compressed"
            ]),
            set: $ef65a4887ab7ae06$var$$util.oneOfSetter($oneOfFields)
        });
        /**
         * Creates a new CommitmentProof instance using the specified properties.
         * @function create
         * @memberof ics23.CommitmentProof
         * @static
         * @param {ics23.ICommitmentProof=} [properties] Properties to set
         * @returns {ics23.CommitmentProof} CommitmentProof instance
         */ CommitmentProof.create = function create(properties) {
            return new CommitmentProof(properties);
        };
        /**
         * Encodes the specified CommitmentProof message. Does not implicitly {@link ics23.CommitmentProof.verify|verify} messages.
         * @function encode
         * @memberof ics23.CommitmentProof
         * @static
         * @param {ics23.ICommitmentProof} message CommitmentProof message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */ CommitmentProof.encode = function encode(message, writer) {
            if (!writer) writer = $ef65a4887ab7ae06$var$$Writer.create();
            if (message.exist != null && message.hasOwnProperty("exist")) $ef65a4887ab7ae06$var$$root.ics23.ExistenceProof.encode(message.exist, writer.uint32(/* id 1, wireType 2 =*/ 10).fork()).ldelim();
            if (message.nonexist != null && message.hasOwnProperty("nonexist")) $ef65a4887ab7ae06$var$$root.ics23.NonExistenceProof.encode(message.nonexist, writer.uint32(/* id 2, wireType 2 =*/ 18).fork()).ldelim();
            if (message.batch != null && message.hasOwnProperty("batch")) $ef65a4887ab7ae06$var$$root.ics23.BatchProof.encode(message.batch, writer.uint32(/* id 3, wireType 2 =*/ 26).fork()).ldelim();
            if (message.compressed != null && message.hasOwnProperty("compressed")) $ef65a4887ab7ae06$var$$root.ics23.CompressedBatchProof.encode(message.compressed, writer.uint32(/* id 4, wireType 2 =*/ 34).fork()).ldelim();
            return writer;
        };
        /**
         * Encodes the specified CommitmentProof message, length delimited. Does not implicitly {@link ics23.CommitmentProof.verify|verify} messages.
         * @function encodeDelimited
         * @memberof ics23.CommitmentProof
         * @static
         * @param {ics23.ICommitmentProof} message CommitmentProof message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */ CommitmentProof.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };
        /**
         * Decodes a CommitmentProof message from the specified reader or buffer.
         * @function decode
         * @memberof ics23.CommitmentProof
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {ics23.CommitmentProof} CommitmentProof
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */ CommitmentProof.decode = function decode(reader, length) {
            if (!(reader instanceof $ef65a4887ab7ae06$var$$Reader)) reader = $ef65a4887ab7ae06$var$$Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $ef65a4887ab7ae06$var$$root.ics23.CommitmentProof();
            while(reader.pos < end){
                var tag = reader.uint32();
                switch(tag >>> 3){
                    case 1:
                        message.exist = $ef65a4887ab7ae06$var$$root.ics23.ExistenceProof.decode(reader, reader.uint32());
                        break;
                    case 2:
                        message.nonexist = $ef65a4887ab7ae06$var$$root.ics23.NonExistenceProof.decode(reader, reader.uint32());
                        break;
                    case 3:
                        message.batch = $ef65a4887ab7ae06$var$$root.ics23.BatchProof.decode(reader, reader.uint32());
                        break;
                    case 4:
                        message.compressed = $ef65a4887ab7ae06$var$$root.ics23.CompressedBatchProof.decode(reader, reader.uint32());
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                }
            }
            return message;
        };
        /**
         * Decodes a CommitmentProof message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof ics23.CommitmentProof
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {ics23.CommitmentProof} CommitmentProof
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */ CommitmentProof.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $ef65a4887ab7ae06$var$$Reader)) reader = new $ef65a4887ab7ae06$var$$Reader(reader);
            return this.decode(reader, reader.uint32());
        };
        /**
         * Verifies a CommitmentProof message.
         * @function verify
         * @memberof ics23.CommitmentProof
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */ CommitmentProof.verify = function verify(message) {
            if (typeof message !== "object" || message === null) return "object expected";
            var properties = {};
            if (message.exist != null && message.hasOwnProperty("exist")) {
                properties.proof = 1;
                var error = $ef65a4887ab7ae06$var$$root.ics23.ExistenceProof.verify(message.exist);
                if (error) return "exist." + error;
            }
            if (message.nonexist != null && message.hasOwnProperty("nonexist")) {
                if (properties.proof === 1) return "proof: multiple values";
                properties.proof = 1;
                var error = $ef65a4887ab7ae06$var$$root.ics23.NonExistenceProof.verify(message.nonexist);
                if (error) return "nonexist." + error;
            }
            if (message.batch != null && message.hasOwnProperty("batch")) {
                if (properties.proof === 1) return "proof: multiple values";
                properties.proof = 1;
                var error = $ef65a4887ab7ae06$var$$root.ics23.BatchProof.verify(message.batch);
                if (error) return "batch." + error;
            }
            if (message.compressed != null && message.hasOwnProperty("compressed")) {
                if (properties.proof === 1) return "proof: multiple values";
                properties.proof = 1;
                var error = $ef65a4887ab7ae06$var$$root.ics23.CompressedBatchProof.verify(message.compressed);
                if (error) return "compressed." + error;
            }
            return null;
        };
        /**
         * Creates a CommitmentProof message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof ics23.CommitmentProof
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {ics23.CommitmentProof} CommitmentProof
         */ CommitmentProof.fromObject = function fromObject(object) {
            if (object instanceof $ef65a4887ab7ae06$var$$root.ics23.CommitmentProof) return object;
            var message = new $ef65a4887ab7ae06$var$$root.ics23.CommitmentProof();
            if (object.exist != null) {
                if (typeof object.exist !== "object") throw TypeError(".ics23.CommitmentProof.exist: object expected");
                message.exist = $ef65a4887ab7ae06$var$$root.ics23.ExistenceProof.fromObject(object.exist);
            }
            if (object.nonexist != null) {
                if (typeof object.nonexist !== "object") throw TypeError(".ics23.CommitmentProof.nonexist: object expected");
                message.nonexist = $ef65a4887ab7ae06$var$$root.ics23.NonExistenceProof.fromObject(object.nonexist);
            }
            if (object.batch != null) {
                if (typeof object.batch !== "object") throw TypeError(".ics23.CommitmentProof.batch: object expected");
                message.batch = $ef65a4887ab7ae06$var$$root.ics23.BatchProof.fromObject(object.batch);
            }
            if (object.compressed != null) {
                if (typeof object.compressed !== "object") throw TypeError(".ics23.CommitmentProof.compressed: object expected");
                message.compressed = $ef65a4887ab7ae06$var$$root.ics23.CompressedBatchProof.fromObject(object.compressed);
            }
            return message;
        };
        /**
         * Creates a plain object from a CommitmentProof message. Also converts values to other types if specified.
         * @function toObject
         * @memberof ics23.CommitmentProof
         * @static
         * @param {ics23.CommitmentProof} message CommitmentProof
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */ CommitmentProof.toObject = function toObject(message, options) {
            if (!options) options = {};
            var object = {};
            if (message.exist != null && message.hasOwnProperty("exist")) {
                object.exist = $ef65a4887ab7ae06$var$$root.ics23.ExistenceProof.toObject(message.exist, options);
                if (options.oneofs) object.proof = "exist";
            }
            if (message.nonexist != null && message.hasOwnProperty("nonexist")) {
                object.nonexist = $ef65a4887ab7ae06$var$$root.ics23.NonExistenceProof.toObject(message.nonexist, options);
                if (options.oneofs) object.proof = "nonexist";
            }
            if (message.batch != null && message.hasOwnProperty("batch")) {
                object.batch = $ef65a4887ab7ae06$var$$root.ics23.BatchProof.toObject(message.batch, options);
                if (options.oneofs) object.proof = "batch";
            }
            if (message.compressed != null && message.hasOwnProperty("compressed")) {
                object.compressed = $ef65a4887ab7ae06$var$$root.ics23.CompressedBatchProof.toObject(message.compressed, options);
                if (options.oneofs) object.proof = "compressed";
            }
            return object;
        };
        /**
         * Converts this CommitmentProof to JSON.
         * @function toJSON
         * @memberof ics23.CommitmentProof
         * @instance
         * @returns {Object.<string,*>} JSON object
         */ CommitmentProof.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $fQBv0.util.toJSONOptions);
        };
        return CommitmentProof;
    }();
    ics23.LeafOp = function() {
        /**
         * Properties of a LeafOp.
         * @memberof ics23
         * @interface ILeafOp
         * @property {ics23.HashOp|null} [hash] LeafOp hash
         * @property {ics23.HashOp|null} [prehashKey] LeafOp prehashKey
         * @property {ics23.HashOp|null} [prehashValue] LeafOp prehashValue
         * @property {ics23.LengthOp|null} [length] LeafOp length
         * @property {Uint8Array|null} [prefix] LeafOp prefix
         */ /**
         * Constructs a new LeafOp.
         * @memberof ics23
         * @classdesc LeafOp represents the raw key-value data we wish to prove, and
         * must be flexible to represent the internal transformation from
         * the original key-value pairs into the basis hash, for many existing
         * merkle trees.
         * 
         * key and value are passed in. So that the signature of this operation is:
         * leafOp(key, value) -> output
         * 
         * To process this, first prehash the keys and values if needed (ANY means no hash in this case):
         * hkey = prehashKey(key)
         * hvalue = prehashValue(value)
         * 
         * Then combine the bytes, and hash it
         * output = hash(prefix || length(hkey) || hkey || length(hvalue) || hvalue)
         * @implements ILeafOp
         * @constructor
         * @param {ics23.ILeafOp=} [properties] Properties to set
         */ function LeafOp(properties) {
            if (properties) {
                for(var keys = Object.keys(properties), i = 0; i < keys.length; ++i)if (properties[keys[i]] != null) this[keys[i]] = properties[keys[i]];
            }
        }
        /**
         * LeafOp hash.
         * @member {ics23.HashOp} hash
         * @memberof ics23.LeafOp
         * @instance
         */ LeafOp.prototype.hash = 0;
        /**
         * LeafOp prehashKey.
         * @member {ics23.HashOp} prehashKey
         * @memberof ics23.LeafOp
         * @instance
         */ LeafOp.prototype.prehashKey = 0;
        /**
         * LeafOp prehashValue.
         * @member {ics23.HashOp} prehashValue
         * @memberof ics23.LeafOp
         * @instance
         */ LeafOp.prototype.prehashValue = 0;
        /**
         * LeafOp length.
         * @member {ics23.LengthOp} length
         * @memberof ics23.LeafOp
         * @instance
         */ LeafOp.prototype.length = 0;
        /**
         * LeafOp prefix.
         * @member {Uint8Array} prefix
         * @memberof ics23.LeafOp
         * @instance
         */ LeafOp.prototype.prefix = $ef65a4887ab7ae06$var$$util.newBuffer([]);
        /**
         * Creates a new LeafOp instance using the specified properties.
         * @function create
         * @memberof ics23.LeafOp
         * @static
         * @param {ics23.ILeafOp=} [properties] Properties to set
         * @returns {ics23.LeafOp} LeafOp instance
         */ LeafOp.create = function create(properties) {
            return new LeafOp(properties);
        };
        /**
         * Encodes the specified LeafOp message. Does not implicitly {@link ics23.LeafOp.verify|verify} messages.
         * @function encode
         * @memberof ics23.LeafOp
         * @static
         * @param {ics23.ILeafOp} message LeafOp message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */ LeafOp.encode = function encode(message, writer) {
            if (!writer) writer = $ef65a4887ab7ae06$var$$Writer.create();
            if (message.hash != null && message.hasOwnProperty("hash")) writer.uint32(/* id 1, wireType 0 =*/ 8).int32(message.hash);
            if (message.prehashKey != null && message.hasOwnProperty("prehashKey")) writer.uint32(/* id 2, wireType 0 =*/ 16).int32(message.prehashKey);
            if (message.prehashValue != null && message.hasOwnProperty("prehashValue")) writer.uint32(/* id 3, wireType 0 =*/ 24).int32(message.prehashValue);
            if (message.length != null && message.hasOwnProperty("length")) writer.uint32(/* id 4, wireType 0 =*/ 32).int32(message.length);
            if (message.prefix != null && message.hasOwnProperty("prefix")) writer.uint32(/* id 5, wireType 2 =*/ 42).bytes(message.prefix);
            return writer;
        };
        /**
         * Encodes the specified LeafOp message, length delimited. Does not implicitly {@link ics23.LeafOp.verify|verify} messages.
         * @function encodeDelimited
         * @memberof ics23.LeafOp
         * @static
         * @param {ics23.ILeafOp} message LeafOp message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */ LeafOp.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };
        /**
         * Decodes a LeafOp message from the specified reader or buffer.
         * @function decode
         * @memberof ics23.LeafOp
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {ics23.LeafOp} LeafOp
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */ LeafOp.decode = function decode(reader, length) {
            if (!(reader instanceof $ef65a4887ab7ae06$var$$Reader)) reader = $ef65a4887ab7ae06$var$$Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $ef65a4887ab7ae06$var$$root.ics23.LeafOp();
            while(reader.pos < end){
                var tag = reader.uint32();
                switch(tag >>> 3){
                    case 1:
                        message.hash = reader.int32();
                        break;
                    case 2:
                        message.prehashKey = reader.int32();
                        break;
                    case 3:
                        message.prehashValue = reader.int32();
                        break;
                    case 4:
                        message.length = reader.int32();
                        break;
                    case 5:
                        message.prefix = reader.bytes();
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                }
            }
            return message;
        };
        /**
         * Decodes a LeafOp message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof ics23.LeafOp
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {ics23.LeafOp} LeafOp
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */ LeafOp.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $ef65a4887ab7ae06$var$$Reader)) reader = new $ef65a4887ab7ae06$var$$Reader(reader);
            return this.decode(reader, reader.uint32());
        };
        /**
         * Verifies a LeafOp message.
         * @function verify
         * @memberof ics23.LeafOp
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */ LeafOp.verify = function verify(message) {
            if (typeof message !== "object" || message === null) return "object expected";
            if (message.hash != null && message.hasOwnProperty("hash")) switch(message.hash){
                default:
                    return "hash: enum value expected";
                case 0:
                case 1:
                case 2:
                case 3:
                case 4:
                case 5:
                case 6:
                    break;
            }
            if (message.prehashKey != null && message.hasOwnProperty("prehashKey")) switch(message.prehashKey){
                default:
                    return "prehashKey: enum value expected";
                case 0:
                case 1:
                case 2:
                case 3:
                case 4:
                case 5:
                case 6:
                    break;
            }
            if (message.prehashValue != null && message.hasOwnProperty("prehashValue")) switch(message.prehashValue){
                default:
                    return "prehashValue: enum value expected";
                case 0:
                case 1:
                case 2:
                case 3:
                case 4:
                case 5:
                case 6:
                    break;
            }
            if (message.length != null && message.hasOwnProperty("length")) switch(message.length){
                default:
                    return "length: enum value expected";
                case 0:
                case 1:
                case 2:
                case 3:
                case 4:
                case 5:
                case 6:
                case 7:
                case 8:
                    break;
            }
            if (message.prefix != null && message.hasOwnProperty("prefix")) {
                if (!(message.prefix && typeof message.prefix.length === "number" || $ef65a4887ab7ae06$var$$util.isString(message.prefix))) return "prefix: buffer expected";
            }
            return null;
        };
        /**
         * Creates a LeafOp message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof ics23.LeafOp
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {ics23.LeafOp} LeafOp
         */ LeafOp.fromObject = function fromObject(object) {
            if (object instanceof $ef65a4887ab7ae06$var$$root.ics23.LeafOp) return object;
            var message = new $ef65a4887ab7ae06$var$$root.ics23.LeafOp();
            switch(object.hash){
                case "NO_HASH":
                case 0:
                    message.hash = 0;
                    break;
                case "SHA256":
                case 1:
                    message.hash = 1;
                    break;
                case "SHA512":
                case 2:
                    message.hash = 2;
                    break;
                case "KECCAK":
                case 3:
                    message.hash = 3;
                    break;
                case "RIPEMD160":
                case 4:
                    message.hash = 4;
                    break;
                case "BITCOIN":
                case 5:
                    message.hash = 5;
                    break;
                case "SHA512_256":
                case 6:
                    message.hash = 6;
                    break;
            }
            switch(object.prehashKey){
                case "NO_HASH":
                case 0:
                    message.prehashKey = 0;
                    break;
                case "SHA256":
                case 1:
                    message.prehashKey = 1;
                    break;
                case "SHA512":
                case 2:
                    message.prehashKey = 2;
                    break;
                case "KECCAK":
                case 3:
                    message.prehashKey = 3;
                    break;
                case "RIPEMD160":
                case 4:
                    message.prehashKey = 4;
                    break;
                case "BITCOIN":
                case 5:
                    message.prehashKey = 5;
                    break;
                case "SHA512_256":
                case 6:
                    message.prehashKey = 6;
                    break;
            }
            switch(object.prehashValue){
                case "NO_HASH":
                case 0:
                    message.prehashValue = 0;
                    break;
                case "SHA256":
                case 1:
                    message.prehashValue = 1;
                    break;
                case "SHA512":
                case 2:
                    message.prehashValue = 2;
                    break;
                case "KECCAK":
                case 3:
                    message.prehashValue = 3;
                    break;
                case "RIPEMD160":
                case 4:
                    message.prehashValue = 4;
                    break;
                case "BITCOIN":
                case 5:
                    message.prehashValue = 5;
                    break;
                case "SHA512_256":
                case 6:
                    message.prehashValue = 6;
                    break;
            }
            switch(object.length){
                case "NO_PREFIX":
                case 0:
                    message.length = 0;
                    break;
                case "VAR_PROTO":
                case 1:
                    message.length = 1;
                    break;
                case "VAR_RLP":
                case 2:
                    message.length = 2;
                    break;
                case "FIXED32_BIG":
                case 3:
                    message.length = 3;
                    break;
                case "FIXED32_LITTLE":
                case 4:
                    message.length = 4;
                    break;
                case "FIXED64_BIG":
                case 5:
                    message.length = 5;
                    break;
                case "FIXED64_LITTLE":
                case 6:
                    message.length = 6;
                    break;
                case "REQUIRE_32_BYTES":
                case 7:
                    message.length = 7;
                    break;
                case "REQUIRE_64_BYTES":
                case 8:
                    message.length = 8;
                    break;
            }
            if (object.prefix != null) {
                if (typeof object.prefix === "string") $ef65a4887ab7ae06$var$$util.base64.decode(object.prefix, message.prefix = $ef65a4887ab7ae06$var$$util.newBuffer($ef65a4887ab7ae06$var$$util.base64.length(object.prefix)), 0);
                else if (object.prefix.length) message.prefix = object.prefix;
            }
            return message;
        };
        /**
         * Creates a plain object from a LeafOp message. Also converts values to other types if specified.
         * @function toObject
         * @memberof ics23.LeafOp
         * @static
         * @param {ics23.LeafOp} message LeafOp
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */ LeafOp.toObject = function toObject(message, options) {
            if (!options) options = {};
            var object = {};
            if (options.defaults) {
                object.hash = options.enums === String ? "NO_HASH" : 0;
                object.prehashKey = options.enums === String ? "NO_HASH" : 0;
                object.prehashValue = options.enums === String ? "NO_HASH" : 0;
                object.length = options.enums === String ? "NO_PREFIX" : 0;
                if (options.bytes === String) object.prefix = "";
                else {
                    object.prefix = [];
                    if (options.bytes !== Array) object.prefix = $ef65a4887ab7ae06$var$$util.newBuffer(object.prefix);
                }
            }
            if (message.hash != null && message.hasOwnProperty("hash")) object.hash = options.enums === String ? $ef65a4887ab7ae06$var$$root.ics23.HashOp[message.hash] : message.hash;
            if (message.prehashKey != null && message.hasOwnProperty("prehashKey")) object.prehashKey = options.enums === String ? $ef65a4887ab7ae06$var$$root.ics23.HashOp[message.prehashKey] : message.prehashKey;
            if (message.prehashValue != null && message.hasOwnProperty("prehashValue")) object.prehashValue = options.enums === String ? $ef65a4887ab7ae06$var$$root.ics23.HashOp[message.prehashValue] : message.prehashValue;
            if (message.length != null && message.hasOwnProperty("length")) object.length = options.enums === String ? $ef65a4887ab7ae06$var$$root.ics23.LengthOp[message.length] : message.length;
            if (message.prefix != null && message.hasOwnProperty("prefix")) object.prefix = options.bytes === String ? $ef65a4887ab7ae06$var$$util.base64.encode(message.prefix, 0, message.prefix.length) : options.bytes === Array ? Array.prototype.slice.call(message.prefix) : message.prefix;
            return object;
        };
        /**
         * Converts this LeafOp to JSON.
         * @function toJSON
         * @memberof ics23.LeafOp
         * @instance
         * @returns {Object.<string,*>} JSON object
         */ LeafOp.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $fQBv0.util.toJSONOptions);
        };
        return LeafOp;
    }();
    ics23.InnerOp = function() {
        /**
         * Properties of an InnerOp.
         * @memberof ics23
         * @interface IInnerOp
         * @property {ics23.HashOp|null} [hash] InnerOp hash
         * @property {Uint8Array|null} [prefix] InnerOp prefix
         * @property {Uint8Array|null} [suffix] InnerOp suffix
         */ /**
         * Constructs a new InnerOp.
         * @memberof ics23
         * @classdesc InnerOp represents a merkle-proof step that is not a leaf.
         * It represents concatenating two children and hashing them to provide the next result.
         * 
         * The result of the previous step is passed in, so the signature of this op is:
         * innerOp(child) -> output
         * 
         * The result of applying InnerOp should be:
         * output = op.hash(op.prefix || child || op.suffix)
         * 
         * where the || operator is concatenation of binary data,
         * and child is the result of hashing all the tree below this step.
         * 
         * Any special data, like prepending child with the length, or prepending the entire operation with
         * some value to differentiate from leaf nodes, should be included in prefix and suffix.
         * If either of prefix or suffix is empty, we just treat it as an empty string
         * @implements IInnerOp
         * @constructor
         * @param {ics23.IInnerOp=} [properties] Properties to set
         */ function InnerOp(properties) {
            if (properties) {
                for(var keys = Object.keys(properties), i = 0; i < keys.length; ++i)if (properties[keys[i]] != null) this[keys[i]] = properties[keys[i]];
            }
        }
        /**
         * InnerOp hash.
         * @member {ics23.HashOp} hash
         * @memberof ics23.InnerOp
         * @instance
         */ InnerOp.prototype.hash = 0;
        /**
         * InnerOp prefix.
         * @member {Uint8Array} prefix
         * @memberof ics23.InnerOp
         * @instance
         */ InnerOp.prototype.prefix = $ef65a4887ab7ae06$var$$util.newBuffer([]);
        /**
         * InnerOp suffix.
         * @member {Uint8Array} suffix
         * @memberof ics23.InnerOp
         * @instance
         */ InnerOp.prototype.suffix = $ef65a4887ab7ae06$var$$util.newBuffer([]);
        /**
         * Creates a new InnerOp instance using the specified properties.
         * @function create
         * @memberof ics23.InnerOp
         * @static
         * @param {ics23.IInnerOp=} [properties] Properties to set
         * @returns {ics23.InnerOp} InnerOp instance
         */ InnerOp.create = function create(properties) {
            return new InnerOp(properties);
        };
        /**
         * Encodes the specified InnerOp message. Does not implicitly {@link ics23.InnerOp.verify|verify} messages.
         * @function encode
         * @memberof ics23.InnerOp
         * @static
         * @param {ics23.IInnerOp} message InnerOp message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */ InnerOp.encode = function encode(message, writer) {
            if (!writer) writer = $ef65a4887ab7ae06$var$$Writer.create();
            if (message.hash != null && message.hasOwnProperty("hash")) writer.uint32(/* id 1, wireType 0 =*/ 8).int32(message.hash);
            if (message.prefix != null && message.hasOwnProperty("prefix")) writer.uint32(/* id 2, wireType 2 =*/ 18).bytes(message.prefix);
            if (message.suffix != null && message.hasOwnProperty("suffix")) writer.uint32(/* id 3, wireType 2 =*/ 26).bytes(message.suffix);
            return writer;
        };
        /**
         * Encodes the specified InnerOp message, length delimited. Does not implicitly {@link ics23.InnerOp.verify|verify} messages.
         * @function encodeDelimited
         * @memberof ics23.InnerOp
         * @static
         * @param {ics23.IInnerOp} message InnerOp message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */ InnerOp.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };
        /**
         * Decodes an InnerOp message from the specified reader or buffer.
         * @function decode
         * @memberof ics23.InnerOp
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {ics23.InnerOp} InnerOp
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */ InnerOp.decode = function decode(reader, length) {
            if (!(reader instanceof $ef65a4887ab7ae06$var$$Reader)) reader = $ef65a4887ab7ae06$var$$Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $ef65a4887ab7ae06$var$$root.ics23.InnerOp();
            while(reader.pos < end){
                var tag = reader.uint32();
                switch(tag >>> 3){
                    case 1:
                        message.hash = reader.int32();
                        break;
                    case 2:
                        message.prefix = reader.bytes();
                        break;
                    case 3:
                        message.suffix = reader.bytes();
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                }
            }
            return message;
        };
        /**
         * Decodes an InnerOp message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof ics23.InnerOp
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {ics23.InnerOp} InnerOp
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */ InnerOp.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $ef65a4887ab7ae06$var$$Reader)) reader = new $ef65a4887ab7ae06$var$$Reader(reader);
            return this.decode(reader, reader.uint32());
        };
        /**
         * Verifies an InnerOp message.
         * @function verify
         * @memberof ics23.InnerOp
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */ InnerOp.verify = function verify(message) {
            if (typeof message !== "object" || message === null) return "object expected";
            if (message.hash != null && message.hasOwnProperty("hash")) switch(message.hash){
                default:
                    return "hash: enum value expected";
                case 0:
                case 1:
                case 2:
                case 3:
                case 4:
                case 5:
                case 6:
                    break;
            }
            if (message.prefix != null && message.hasOwnProperty("prefix")) {
                if (!(message.prefix && typeof message.prefix.length === "number" || $ef65a4887ab7ae06$var$$util.isString(message.prefix))) return "prefix: buffer expected";
            }
            if (message.suffix != null && message.hasOwnProperty("suffix")) {
                if (!(message.suffix && typeof message.suffix.length === "number" || $ef65a4887ab7ae06$var$$util.isString(message.suffix))) return "suffix: buffer expected";
            }
            return null;
        };
        /**
         * Creates an InnerOp message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof ics23.InnerOp
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {ics23.InnerOp} InnerOp
         */ InnerOp.fromObject = function fromObject(object) {
            if (object instanceof $ef65a4887ab7ae06$var$$root.ics23.InnerOp) return object;
            var message = new $ef65a4887ab7ae06$var$$root.ics23.InnerOp();
            switch(object.hash){
                case "NO_HASH":
                case 0:
                    message.hash = 0;
                    break;
                case "SHA256":
                case 1:
                    message.hash = 1;
                    break;
                case "SHA512":
                case 2:
                    message.hash = 2;
                    break;
                case "KECCAK":
                case 3:
                    message.hash = 3;
                    break;
                case "RIPEMD160":
                case 4:
                    message.hash = 4;
                    break;
                case "BITCOIN":
                case 5:
                    message.hash = 5;
                    break;
                case "SHA512_256":
                case 6:
                    message.hash = 6;
                    break;
            }
            if (object.prefix != null) {
                if (typeof object.prefix === "string") $ef65a4887ab7ae06$var$$util.base64.decode(object.prefix, message.prefix = $ef65a4887ab7ae06$var$$util.newBuffer($ef65a4887ab7ae06$var$$util.base64.length(object.prefix)), 0);
                else if (object.prefix.length) message.prefix = object.prefix;
            }
            if (object.suffix != null) {
                if (typeof object.suffix === "string") $ef65a4887ab7ae06$var$$util.base64.decode(object.suffix, message.suffix = $ef65a4887ab7ae06$var$$util.newBuffer($ef65a4887ab7ae06$var$$util.base64.length(object.suffix)), 0);
                else if (object.suffix.length) message.suffix = object.suffix;
            }
            return message;
        };
        /**
         * Creates a plain object from an InnerOp message. Also converts values to other types if specified.
         * @function toObject
         * @memberof ics23.InnerOp
         * @static
         * @param {ics23.InnerOp} message InnerOp
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */ InnerOp.toObject = function toObject(message, options) {
            if (!options) options = {};
            var object = {};
            if (options.defaults) {
                object.hash = options.enums === String ? "NO_HASH" : 0;
                if (options.bytes === String) object.prefix = "";
                else {
                    object.prefix = [];
                    if (options.bytes !== Array) object.prefix = $ef65a4887ab7ae06$var$$util.newBuffer(object.prefix);
                }
                if (options.bytes === String) object.suffix = "";
                else {
                    object.suffix = [];
                    if (options.bytes !== Array) object.suffix = $ef65a4887ab7ae06$var$$util.newBuffer(object.suffix);
                }
            }
            if (message.hash != null && message.hasOwnProperty("hash")) object.hash = options.enums === String ? $ef65a4887ab7ae06$var$$root.ics23.HashOp[message.hash] : message.hash;
            if (message.prefix != null && message.hasOwnProperty("prefix")) object.prefix = options.bytes === String ? $ef65a4887ab7ae06$var$$util.base64.encode(message.prefix, 0, message.prefix.length) : options.bytes === Array ? Array.prototype.slice.call(message.prefix) : message.prefix;
            if (message.suffix != null && message.hasOwnProperty("suffix")) object.suffix = options.bytes === String ? $ef65a4887ab7ae06$var$$util.base64.encode(message.suffix, 0, message.suffix.length) : options.bytes === Array ? Array.prototype.slice.call(message.suffix) : message.suffix;
            return object;
        };
        /**
         * Converts this InnerOp to JSON.
         * @function toJSON
         * @memberof ics23.InnerOp
         * @instance
         * @returns {Object.<string,*>} JSON object
         */ InnerOp.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $fQBv0.util.toJSONOptions);
        };
        return InnerOp;
    }();
    ics23.ProofSpec = function() {
        /**
         * Properties of a ProofSpec.
         * @memberof ics23
         * @interface IProofSpec
         * @property {ics23.ILeafOp|null} [leafSpec] ProofSpec leafSpec
         * @property {ics23.IInnerSpec|null} [innerSpec] ProofSpec innerSpec
         * @property {number|null} [maxDepth] ProofSpec maxDepth
         * @property {number|null} [minDepth] ProofSpec minDepth
         */ /**
         * Constructs a new ProofSpec.
         * @memberof ics23
         * @classdesc ProofSpec defines what the expected parameters are for a given proof type.
         * This can be stored in the client and used to validate any incoming proofs.
         * 
         * verify(ProofSpec, Proof) -> Proof | Error
         * 
         * As demonstrated in tests, if we don't fix the algorithm used to calculate the
         * LeafHash for a given tree, there are many possible key-value pairs that can
         * generate a given hash (by interpretting the preimage differently).
         * We need this for proper security, requires client knows a priori what
         * tree format server uses. But not in code, rather a configuration object.
         * @implements IProofSpec
         * @constructor
         * @param {ics23.IProofSpec=} [properties] Properties to set
         */ function ProofSpec(properties) {
            if (properties) {
                for(var keys = Object.keys(properties), i = 0; i < keys.length; ++i)if (properties[keys[i]] != null) this[keys[i]] = properties[keys[i]];
            }
        }
        /**
         * ProofSpec leafSpec.
         * @member {ics23.ILeafOp|null|undefined} leafSpec
         * @memberof ics23.ProofSpec
         * @instance
         */ ProofSpec.prototype.leafSpec = null;
        /**
         * ProofSpec innerSpec.
         * @member {ics23.IInnerSpec|null|undefined} innerSpec
         * @memberof ics23.ProofSpec
         * @instance
         */ ProofSpec.prototype.innerSpec = null;
        /**
         * ProofSpec maxDepth.
         * @member {number} maxDepth
         * @memberof ics23.ProofSpec
         * @instance
         */ ProofSpec.prototype.maxDepth = 0;
        /**
         * ProofSpec minDepth.
         * @member {number} minDepth
         * @memberof ics23.ProofSpec
         * @instance
         */ ProofSpec.prototype.minDepth = 0;
        /**
         * Creates a new ProofSpec instance using the specified properties.
         * @function create
         * @memberof ics23.ProofSpec
         * @static
         * @param {ics23.IProofSpec=} [properties] Properties to set
         * @returns {ics23.ProofSpec} ProofSpec instance
         */ ProofSpec.create = function create(properties) {
            return new ProofSpec(properties);
        };
        /**
         * Encodes the specified ProofSpec message. Does not implicitly {@link ics23.ProofSpec.verify|verify} messages.
         * @function encode
         * @memberof ics23.ProofSpec
         * @static
         * @param {ics23.IProofSpec} message ProofSpec message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */ ProofSpec.encode = function encode(message, writer) {
            if (!writer) writer = $ef65a4887ab7ae06$var$$Writer.create();
            if (message.leafSpec != null && message.hasOwnProperty("leafSpec")) $ef65a4887ab7ae06$var$$root.ics23.LeafOp.encode(message.leafSpec, writer.uint32(/* id 1, wireType 2 =*/ 10).fork()).ldelim();
            if (message.innerSpec != null && message.hasOwnProperty("innerSpec")) $ef65a4887ab7ae06$var$$root.ics23.InnerSpec.encode(message.innerSpec, writer.uint32(/* id 2, wireType 2 =*/ 18).fork()).ldelim();
            if (message.maxDepth != null && message.hasOwnProperty("maxDepth")) writer.uint32(/* id 3, wireType 0 =*/ 24).int32(message.maxDepth);
            if (message.minDepth != null && message.hasOwnProperty("minDepth")) writer.uint32(/* id 4, wireType 0 =*/ 32).int32(message.minDepth);
            return writer;
        };
        /**
         * Encodes the specified ProofSpec message, length delimited. Does not implicitly {@link ics23.ProofSpec.verify|verify} messages.
         * @function encodeDelimited
         * @memberof ics23.ProofSpec
         * @static
         * @param {ics23.IProofSpec} message ProofSpec message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */ ProofSpec.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };
        /**
         * Decodes a ProofSpec message from the specified reader or buffer.
         * @function decode
         * @memberof ics23.ProofSpec
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {ics23.ProofSpec} ProofSpec
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */ ProofSpec.decode = function decode(reader, length) {
            if (!(reader instanceof $ef65a4887ab7ae06$var$$Reader)) reader = $ef65a4887ab7ae06$var$$Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $ef65a4887ab7ae06$var$$root.ics23.ProofSpec();
            while(reader.pos < end){
                var tag = reader.uint32();
                switch(tag >>> 3){
                    case 1:
                        message.leafSpec = $ef65a4887ab7ae06$var$$root.ics23.LeafOp.decode(reader, reader.uint32());
                        break;
                    case 2:
                        message.innerSpec = $ef65a4887ab7ae06$var$$root.ics23.InnerSpec.decode(reader, reader.uint32());
                        break;
                    case 3:
                        message.maxDepth = reader.int32();
                        break;
                    case 4:
                        message.minDepth = reader.int32();
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                }
            }
            return message;
        };
        /**
         * Decodes a ProofSpec message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof ics23.ProofSpec
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {ics23.ProofSpec} ProofSpec
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */ ProofSpec.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $ef65a4887ab7ae06$var$$Reader)) reader = new $ef65a4887ab7ae06$var$$Reader(reader);
            return this.decode(reader, reader.uint32());
        };
        /**
         * Verifies a ProofSpec message.
         * @function verify
         * @memberof ics23.ProofSpec
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */ ProofSpec.verify = function verify(message) {
            if (typeof message !== "object" || message === null) return "object expected";
            if (message.leafSpec != null && message.hasOwnProperty("leafSpec")) {
                var error = $ef65a4887ab7ae06$var$$root.ics23.LeafOp.verify(message.leafSpec);
                if (error) return "leafSpec." + error;
            }
            if (message.innerSpec != null && message.hasOwnProperty("innerSpec")) {
                var error = $ef65a4887ab7ae06$var$$root.ics23.InnerSpec.verify(message.innerSpec);
                if (error) return "innerSpec." + error;
            }
            if (message.maxDepth != null && message.hasOwnProperty("maxDepth")) {
                if (!$ef65a4887ab7ae06$var$$util.isInteger(message.maxDepth)) return "maxDepth: integer expected";
            }
            if (message.minDepth != null && message.hasOwnProperty("minDepth")) {
                if (!$ef65a4887ab7ae06$var$$util.isInteger(message.minDepth)) return "minDepth: integer expected";
            }
            return null;
        };
        /**
         * Creates a ProofSpec message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof ics23.ProofSpec
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {ics23.ProofSpec} ProofSpec
         */ ProofSpec.fromObject = function fromObject(object) {
            if (object instanceof $ef65a4887ab7ae06$var$$root.ics23.ProofSpec) return object;
            var message = new $ef65a4887ab7ae06$var$$root.ics23.ProofSpec();
            if (object.leafSpec != null) {
                if (typeof object.leafSpec !== "object") throw TypeError(".ics23.ProofSpec.leafSpec: object expected");
                message.leafSpec = $ef65a4887ab7ae06$var$$root.ics23.LeafOp.fromObject(object.leafSpec);
            }
            if (object.innerSpec != null) {
                if (typeof object.innerSpec !== "object") throw TypeError(".ics23.ProofSpec.innerSpec: object expected");
                message.innerSpec = $ef65a4887ab7ae06$var$$root.ics23.InnerSpec.fromObject(object.innerSpec);
            }
            if (object.maxDepth != null) message.maxDepth = object.maxDepth | 0;
            if (object.minDepth != null) message.minDepth = object.minDepth | 0;
            return message;
        };
        /**
         * Creates a plain object from a ProofSpec message. Also converts values to other types if specified.
         * @function toObject
         * @memberof ics23.ProofSpec
         * @static
         * @param {ics23.ProofSpec} message ProofSpec
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */ ProofSpec.toObject = function toObject(message, options) {
            if (!options) options = {};
            var object = {};
            if (options.defaults) {
                object.leafSpec = null;
                object.innerSpec = null;
                object.maxDepth = 0;
                object.minDepth = 0;
            }
            if (message.leafSpec != null && message.hasOwnProperty("leafSpec")) object.leafSpec = $ef65a4887ab7ae06$var$$root.ics23.LeafOp.toObject(message.leafSpec, options);
            if (message.innerSpec != null && message.hasOwnProperty("innerSpec")) object.innerSpec = $ef65a4887ab7ae06$var$$root.ics23.InnerSpec.toObject(message.innerSpec, options);
            if (message.maxDepth != null && message.hasOwnProperty("maxDepth")) object.maxDepth = message.maxDepth;
            if (message.minDepth != null && message.hasOwnProperty("minDepth")) object.minDepth = message.minDepth;
            return object;
        };
        /**
         * Converts this ProofSpec to JSON.
         * @function toJSON
         * @memberof ics23.ProofSpec
         * @instance
         * @returns {Object.<string,*>} JSON object
         */ ProofSpec.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $fQBv0.util.toJSONOptions);
        };
        return ProofSpec;
    }();
    ics23.InnerSpec = function() {
        /**
         * Properties of an InnerSpec.
         * @memberof ics23
         * @interface IInnerSpec
         * @property {Array.<number>|null} [childOrder] InnerSpec childOrder
         * @property {number|null} [childSize] InnerSpec childSize
         * @property {number|null} [minPrefixLength] InnerSpec minPrefixLength
         * @property {number|null} [maxPrefixLength] InnerSpec maxPrefixLength
         * @property {Uint8Array|null} [emptyChild] InnerSpec emptyChild
         * @property {ics23.HashOp|null} [hash] InnerSpec hash
         */ /**
         * Constructs a new InnerSpec.
         * @memberof ics23
         * @classdesc Represents an InnerSpec.
         * @implements IInnerSpec
         * @constructor
         * @param {ics23.IInnerSpec=} [properties] Properties to set
         */ function InnerSpec(properties) {
            this.childOrder = [];
            if (properties) {
                for(var keys = Object.keys(properties), i = 0; i < keys.length; ++i)if (properties[keys[i]] != null) this[keys[i]] = properties[keys[i]];
            }
        }
        /**
         * InnerSpec childOrder.
         * @member {Array.<number>} childOrder
         * @memberof ics23.InnerSpec
         * @instance
         */ InnerSpec.prototype.childOrder = $ef65a4887ab7ae06$var$$util.emptyArray;
        /**
         * InnerSpec childSize.
         * @member {number} childSize
         * @memberof ics23.InnerSpec
         * @instance
         */ InnerSpec.prototype.childSize = 0;
        /**
         * InnerSpec minPrefixLength.
         * @member {number} minPrefixLength
         * @memberof ics23.InnerSpec
         * @instance
         */ InnerSpec.prototype.minPrefixLength = 0;
        /**
         * InnerSpec maxPrefixLength.
         * @member {number} maxPrefixLength
         * @memberof ics23.InnerSpec
         * @instance
         */ InnerSpec.prototype.maxPrefixLength = 0;
        /**
         * InnerSpec emptyChild.
         * @member {Uint8Array} emptyChild
         * @memberof ics23.InnerSpec
         * @instance
         */ InnerSpec.prototype.emptyChild = $ef65a4887ab7ae06$var$$util.newBuffer([]);
        /**
         * InnerSpec hash.
         * @member {ics23.HashOp} hash
         * @memberof ics23.InnerSpec
         * @instance
         */ InnerSpec.prototype.hash = 0;
        /**
         * Creates a new InnerSpec instance using the specified properties.
         * @function create
         * @memberof ics23.InnerSpec
         * @static
         * @param {ics23.IInnerSpec=} [properties] Properties to set
         * @returns {ics23.InnerSpec} InnerSpec instance
         */ InnerSpec.create = function create(properties) {
            return new InnerSpec(properties);
        };
        /**
         * Encodes the specified InnerSpec message. Does not implicitly {@link ics23.InnerSpec.verify|verify} messages.
         * @function encode
         * @memberof ics23.InnerSpec
         * @static
         * @param {ics23.IInnerSpec} message InnerSpec message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */ InnerSpec.encode = function encode(message, writer) {
            if (!writer) writer = $ef65a4887ab7ae06$var$$Writer.create();
            if (message.childOrder != null && message.childOrder.length) {
                writer.uint32(/* id 1, wireType 2 =*/ 10).fork();
                for(var i = 0; i < message.childOrder.length; ++i)writer.int32(message.childOrder[i]);
                writer.ldelim();
            }
            if (message.childSize != null && message.hasOwnProperty("childSize")) writer.uint32(/* id 2, wireType 0 =*/ 16).int32(message.childSize);
            if (message.minPrefixLength != null && message.hasOwnProperty("minPrefixLength")) writer.uint32(/* id 3, wireType 0 =*/ 24).int32(message.minPrefixLength);
            if (message.maxPrefixLength != null && message.hasOwnProperty("maxPrefixLength")) writer.uint32(/* id 4, wireType 0 =*/ 32).int32(message.maxPrefixLength);
            if (message.emptyChild != null && message.hasOwnProperty("emptyChild")) writer.uint32(/* id 5, wireType 2 =*/ 42).bytes(message.emptyChild);
            if (message.hash != null && message.hasOwnProperty("hash")) writer.uint32(/* id 6, wireType 0 =*/ 48).int32(message.hash);
            return writer;
        };
        /**
         * Encodes the specified InnerSpec message, length delimited. Does not implicitly {@link ics23.InnerSpec.verify|verify} messages.
         * @function encodeDelimited
         * @memberof ics23.InnerSpec
         * @static
         * @param {ics23.IInnerSpec} message InnerSpec message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */ InnerSpec.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };
        /**
         * Decodes an InnerSpec message from the specified reader or buffer.
         * @function decode
         * @memberof ics23.InnerSpec
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {ics23.InnerSpec} InnerSpec
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */ InnerSpec.decode = function decode(reader, length) {
            if (!(reader instanceof $ef65a4887ab7ae06$var$$Reader)) reader = $ef65a4887ab7ae06$var$$Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $ef65a4887ab7ae06$var$$root.ics23.InnerSpec();
            while(reader.pos < end){
                var tag = reader.uint32();
                switch(tag >>> 3){
                    case 1:
                        if (!(message.childOrder && message.childOrder.length)) message.childOrder = [];
                        if ((tag & 7) === 2) {
                            var end2 = reader.uint32() + reader.pos;
                            while(reader.pos < end2)message.childOrder.push(reader.int32());
                        } else message.childOrder.push(reader.int32());
                        break;
                    case 2:
                        message.childSize = reader.int32();
                        break;
                    case 3:
                        message.minPrefixLength = reader.int32();
                        break;
                    case 4:
                        message.maxPrefixLength = reader.int32();
                        break;
                    case 5:
                        message.emptyChild = reader.bytes();
                        break;
                    case 6:
                        message.hash = reader.int32();
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                }
            }
            return message;
        };
        /**
         * Decodes an InnerSpec message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof ics23.InnerSpec
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {ics23.InnerSpec} InnerSpec
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */ InnerSpec.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $ef65a4887ab7ae06$var$$Reader)) reader = new $ef65a4887ab7ae06$var$$Reader(reader);
            return this.decode(reader, reader.uint32());
        };
        /**
         * Verifies an InnerSpec message.
         * @function verify
         * @memberof ics23.InnerSpec
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */ InnerSpec.verify = function verify(message) {
            if (typeof message !== "object" || message === null) return "object expected";
            if (message.childOrder != null && message.hasOwnProperty("childOrder")) {
                if (!Array.isArray(message.childOrder)) return "childOrder: array expected";
                for(var i = 0; i < message.childOrder.length; ++i)if (!$ef65a4887ab7ae06$var$$util.isInteger(message.childOrder[i])) return "childOrder: integer[] expected";
            }
            if (message.childSize != null && message.hasOwnProperty("childSize")) {
                if (!$ef65a4887ab7ae06$var$$util.isInteger(message.childSize)) return "childSize: integer expected";
            }
            if (message.minPrefixLength != null && message.hasOwnProperty("minPrefixLength")) {
                if (!$ef65a4887ab7ae06$var$$util.isInteger(message.minPrefixLength)) return "minPrefixLength: integer expected";
            }
            if (message.maxPrefixLength != null && message.hasOwnProperty("maxPrefixLength")) {
                if (!$ef65a4887ab7ae06$var$$util.isInteger(message.maxPrefixLength)) return "maxPrefixLength: integer expected";
            }
            if (message.emptyChild != null && message.hasOwnProperty("emptyChild")) {
                if (!(message.emptyChild && typeof message.emptyChild.length === "number" || $ef65a4887ab7ae06$var$$util.isString(message.emptyChild))) return "emptyChild: buffer expected";
            }
            if (message.hash != null && message.hasOwnProperty("hash")) switch(message.hash){
                default:
                    return "hash: enum value expected";
                case 0:
                case 1:
                case 2:
                case 3:
                case 4:
                case 5:
                case 6:
                    break;
            }
            return null;
        };
        /**
         * Creates an InnerSpec message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof ics23.InnerSpec
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {ics23.InnerSpec} InnerSpec
         */ InnerSpec.fromObject = function fromObject(object) {
            if (object instanceof $ef65a4887ab7ae06$var$$root.ics23.InnerSpec) return object;
            var message = new $ef65a4887ab7ae06$var$$root.ics23.InnerSpec();
            if (object.childOrder) {
                if (!Array.isArray(object.childOrder)) throw TypeError(".ics23.InnerSpec.childOrder: array expected");
                message.childOrder = [];
                for(var i = 0; i < object.childOrder.length; ++i)message.childOrder[i] = object.childOrder[i] | 0;
            }
            if (object.childSize != null) message.childSize = object.childSize | 0;
            if (object.minPrefixLength != null) message.minPrefixLength = object.minPrefixLength | 0;
            if (object.maxPrefixLength != null) message.maxPrefixLength = object.maxPrefixLength | 0;
            if (object.emptyChild != null) {
                if (typeof object.emptyChild === "string") $ef65a4887ab7ae06$var$$util.base64.decode(object.emptyChild, message.emptyChild = $ef65a4887ab7ae06$var$$util.newBuffer($ef65a4887ab7ae06$var$$util.base64.length(object.emptyChild)), 0);
                else if (object.emptyChild.length) message.emptyChild = object.emptyChild;
            }
            switch(object.hash){
                case "NO_HASH":
                case 0:
                    message.hash = 0;
                    break;
                case "SHA256":
                case 1:
                    message.hash = 1;
                    break;
                case "SHA512":
                case 2:
                    message.hash = 2;
                    break;
                case "KECCAK":
                case 3:
                    message.hash = 3;
                    break;
                case "RIPEMD160":
                case 4:
                    message.hash = 4;
                    break;
                case "BITCOIN":
                case 5:
                    message.hash = 5;
                    break;
                case "SHA512_256":
                case 6:
                    message.hash = 6;
                    break;
            }
            return message;
        };
        /**
         * Creates a plain object from an InnerSpec message. Also converts values to other types if specified.
         * @function toObject
         * @memberof ics23.InnerSpec
         * @static
         * @param {ics23.InnerSpec} message InnerSpec
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */ InnerSpec.toObject = function toObject(message, options) {
            if (!options) options = {};
            var object = {};
            if (options.arrays || options.defaults) object.childOrder = [];
            if (options.defaults) {
                object.childSize = 0;
                object.minPrefixLength = 0;
                object.maxPrefixLength = 0;
                if (options.bytes === String) object.emptyChild = "";
                else {
                    object.emptyChild = [];
                    if (options.bytes !== Array) object.emptyChild = $ef65a4887ab7ae06$var$$util.newBuffer(object.emptyChild);
                }
                object.hash = options.enums === String ? "NO_HASH" : 0;
            }
            if (message.childOrder && message.childOrder.length) {
                object.childOrder = [];
                for(var j = 0; j < message.childOrder.length; ++j)object.childOrder[j] = message.childOrder[j];
            }
            if (message.childSize != null && message.hasOwnProperty("childSize")) object.childSize = message.childSize;
            if (message.minPrefixLength != null && message.hasOwnProperty("minPrefixLength")) object.minPrefixLength = message.minPrefixLength;
            if (message.maxPrefixLength != null && message.hasOwnProperty("maxPrefixLength")) object.maxPrefixLength = message.maxPrefixLength;
            if (message.emptyChild != null && message.hasOwnProperty("emptyChild")) object.emptyChild = options.bytes === String ? $ef65a4887ab7ae06$var$$util.base64.encode(message.emptyChild, 0, message.emptyChild.length) : options.bytes === Array ? Array.prototype.slice.call(message.emptyChild) : message.emptyChild;
            if (message.hash != null && message.hasOwnProperty("hash")) object.hash = options.enums === String ? $ef65a4887ab7ae06$var$$root.ics23.HashOp[message.hash] : message.hash;
            return object;
        };
        /**
         * Converts this InnerSpec to JSON.
         * @function toJSON
         * @memberof ics23.InnerSpec
         * @instance
         * @returns {Object.<string,*>} JSON object
         */ InnerSpec.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $fQBv0.util.toJSONOptions);
        };
        return InnerSpec;
    }();
    ics23.BatchProof = function() {
        /**
         * Properties of a BatchProof.
         * @memberof ics23
         * @interface IBatchProof
         * @property {Array.<ics23.IBatchEntry>|null} [entries] BatchProof entries
         */ /**
         * Constructs a new BatchProof.
         * @memberof ics23
         * @classdesc Represents a BatchProof.
         * @implements IBatchProof
         * @constructor
         * @param {ics23.IBatchProof=} [properties] Properties to set
         */ function BatchProof(properties) {
            this.entries = [];
            if (properties) {
                for(var keys = Object.keys(properties), i = 0; i < keys.length; ++i)if (properties[keys[i]] != null) this[keys[i]] = properties[keys[i]];
            }
        }
        /**
         * BatchProof entries.
         * @member {Array.<ics23.IBatchEntry>} entries
         * @memberof ics23.BatchProof
         * @instance
         */ BatchProof.prototype.entries = $ef65a4887ab7ae06$var$$util.emptyArray;
        /**
         * Creates a new BatchProof instance using the specified properties.
         * @function create
         * @memberof ics23.BatchProof
         * @static
         * @param {ics23.IBatchProof=} [properties] Properties to set
         * @returns {ics23.BatchProof} BatchProof instance
         */ BatchProof.create = function create(properties) {
            return new BatchProof(properties);
        };
        /**
         * Encodes the specified BatchProof message. Does not implicitly {@link ics23.BatchProof.verify|verify} messages.
         * @function encode
         * @memberof ics23.BatchProof
         * @static
         * @param {ics23.IBatchProof} message BatchProof message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */ BatchProof.encode = function encode(message, writer) {
            if (!writer) writer = $ef65a4887ab7ae06$var$$Writer.create();
            if (message.entries != null && message.entries.length) for(var i = 0; i < message.entries.length; ++i)$ef65a4887ab7ae06$var$$root.ics23.BatchEntry.encode(message.entries[i], writer.uint32(/* id 1, wireType 2 =*/ 10).fork()).ldelim();
            return writer;
        };
        /**
         * Encodes the specified BatchProof message, length delimited. Does not implicitly {@link ics23.BatchProof.verify|verify} messages.
         * @function encodeDelimited
         * @memberof ics23.BatchProof
         * @static
         * @param {ics23.IBatchProof} message BatchProof message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */ BatchProof.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };
        /**
         * Decodes a BatchProof message from the specified reader or buffer.
         * @function decode
         * @memberof ics23.BatchProof
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {ics23.BatchProof} BatchProof
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */ BatchProof.decode = function decode(reader, length) {
            if (!(reader instanceof $ef65a4887ab7ae06$var$$Reader)) reader = $ef65a4887ab7ae06$var$$Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $ef65a4887ab7ae06$var$$root.ics23.BatchProof();
            while(reader.pos < end){
                var tag = reader.uint32();
                switch(tag >>> 3){
                    case 1:
                        if (!(message.entries && message.entries.length)) message.entries = [];
                        message.entries.push($ef65a4887ab7ae06$var$$root.ics23.BatchEntry.decode(reader, reader.uint32()));
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                }
            }
            return message;
        };
        /**
         * Decodes a BatchProof message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof ics23.BatchProof
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {ics23.BatchProof} BatchProof
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */ BatchProof.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $ef65a4887ab7ae06$var$$Reader)) reader = new $ef65a4887ab7ae06$var$$Reader(reader);
            return this.decode(reader, reader.uint32());
        };
        /**
         * Verifies a BatchProof message.
         * @function verify
         * @memberof ics23.BatchProof
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */ BatchProof.verify = function verify(message) {
            if (typeof message !== "object" || message === null) return "object expected";
            if (message.entries != null && message.hasOwnProperty("entries")) {
                if (!Array.isArray(message.entries)) return "entries: array expected";
                for(var i = 0; i < message.entries.length; ++i){
                    var error = $ef65a4887ab7ae06$var$$root.ics23.BatchEntry.verify(message.entries[i]);
                    if (error) return "entries." + error;
                }
            }
            return null;
        };
        /**
         * Creates a BatchProof message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof ics23.BatchProof
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {ics23.BatchProof} BatchProof
         */ BatchProof.fromObject = function fromObject(object) {
            if (object instanceof $ef65a4887ab7ae06$var$$root.ics23.BatchProof) return object;
            var message = new $ef65a4887ab7ae06$var$$root.ics23.BatchProof();
            if (object.entries) {
                if (!Array.isArray(object.entries)) throw TypeError(".ics23.BatchProof.entries: array expected");
                message.entries = [];
                for(var i = 0; i < object.entries.length; ++i){
                    if (typeof object.entries[i] !== "object") throw TypeError(".ics23.BatchProof.entries: object expected");
                    message.entries[i] = $ef65a4887ab7ae06$var$$root.ics23.BatchEntry.fromObject(object.entries[i]);
                }
            }
            return message;
        };
        /**
         * Creates a plain object from a BatchProof message. Also converts values to other types if specified.
         * @function toObject
         * @memberof ics23.BatchProof
         * @static
         * @param {ics23.BatchProof} message BatchProof
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */ BatchProof.toObject = function toObject(message, options) {
            if (!options) options = {};
            var object = {};
            if (options.arrays || options.defaults) object.entries = [];
            if (message.entries && message.entries.length) {
                object.entries = [];
                for(var j = 0; j < message.entries.length; ++j)object.entries[j] = $ef65a4887ab7ae06$var$$root.ics23.BatchEntry.toObject(message.entries[j], options);
            }
            return object;
        };
        /**
         * Converts this BatchProof to JSON.
         * @function toJSON
         * @memberof ics23.BatchProof
         * @instance
         * @returns {Object.<string,*>} JSON object
         */ BatchProof.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $fQBv0.util.toJSONOptions);
        };
        return BatchProof;
    }();
    ics23.BatchEntry = function() {
        /**
         * Properties of a BatchEntry.
         * @memberof ics23
         * @interface IBatchEntry
         * @property {ics23.IExistenceProof|null} [exist] BatchEntry exist
         * @property {ics23.INonExistenceProof|null} [nonexist] BatchEntry nonexist
         */ /**
         * Constructs a new BatchEntry.
         * @memberof ics23
         * @classdesc Represents a BatchEntry.
         * @implements IBatchEntry
         * @constructor
         * @param {ics23.IBatchEntry=} [properties] Properties to set
         */ function BatchEntry(properties) {
            if (properties) {
                for(var keys = Object.keys(properties), i = 0; i < keys.length; ++i)if (properties[keys[i]] != null) this[keys[i]] = properties[keys[i]];
            }
        }
        /**
         * BatchEntry exist.
         * @member {ics23.IExistenceProof|null|undefined} exist
         * @memberof ics23.BatchEntry
         * @instance
         */ BatchEntry.prototype.exist = null;
        /**
         * BatchEntry nonexist.
         * @member {ics23.INonExistenceProof|null|undefined} nonexist
         * @memberof ics23.BatchEntry
         * @instance
         */ BatchEntry.prototype.nonexist = null;
        // OneOf field names bound to virtual getters and setters
        var $oneOfFields;
        /**
         * BatchEntry proof.
         * @member {"exist"|"nonexist"|undefined} proof
         * @memberof ics23.BatchEntry
         * @instance
         */ Object.defineProperty(BatchEntry.prototype, "proof", {
            get: $ef65a4887ab7ae06$var$$util.oneOfGetter($oneOfFields = [
                "exist",
                "nonexist"
            ]),
            set: $ef65a4887ab7ae06$var$$util.oneOfSetter($oneOfFields)
        });
        /**
         * Creates a new BatchEntry instance using the specified properties.
         * @function create
         * @memberof ics23.BatchEntry
         * @static
         * @param {ics23.IBatchEntry=} [properties] Properties to set
         * @returns {ics23.BatchEntry} BatchEntry instance
         */ BatchEntry.create = function create(properties) {
            return new BatchEntry(properties);
        };
        /**
         * Encodes the specified BatchEntry message. Does not implicitly {@link ics23.BatchEntry.verify|verify} messages.
         * @function encode
         * @memberof ics23.BatchEntry
         * @static
         * @param {ics23.IBatchEntry} message BatchEntry message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */ BatchEntry.encode = function encode(message, writer) {
            if (!writer) writer = $ef65a4887ab7ae06$var$$Writer.create();
            if (message.exist != null && message.hasOwnProperty("exist")) $ef65a4887ab7ae06$var$$root.ics23.ExistenceProof.encode(message.exist, writer.uint32(/* id 1, wireType 2 =*/ 10).fork()).ldelim();
            if (message.nonexist != null && message.hasOwnProperty("nonexist")) $ef65a4887ab7ae06$var$$root.ics23.NonExistenceProof.encode(message.nonexist, writer.uint32(/* id 2, wireType 2 =*/ 18).fork()).ldelim();
            return writer;
        };
        /**
         * Encodes the specified BatchEntry message, length delimited. Does not implicitly {@link ics23.BatchEntry.verify|verify} messages.
         * @function encodeDelimited
         * @memberof ics23.BatchEntry
         * @static
         * @param {ics23.IBatchEntry} message BatchEntry message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */ BatchEntry.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };
        /**
         * Decodes a BatchEntry message from the specified reader or buffer.
         * @function decode
         * @memberof ics23.BatchEntry
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {ics23.BatchEntry} BatchEntry
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */ BatchEntry.decode = function decode(reader, length) {
            if (!(reader instanceof $ef65a4887ab7ae06$var$$Reader)) reader = $ef65a4887ab7ae06$var$$Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $ef65a4887ab7ae06$var$$root.ics23.BatchEntry();
            while(reader.pos < end){
                var tag = reader.uint32();
                switch(tag >>> 3){
                    case 1:
                        message.exist = $ef65a4887ab7ae06$var$$root.ics23.ExistenceProof.decode(reader, reader.uint32());
                        break;
                    case 2:
                        message.nonexist = $ef65a4887ab7ae06$var$$root.ics23.NonExistenceProof.decode(reader, reader.uint32());
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                }
            }
            return message;
        };
        /**
         * Decodes a BatchEntry message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof ics23.BatchEntry
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {ics23.BatchEntry} BatchEntry
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */ BatchEntry.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $ef65a4887ab7ae06$var$$Reader)) reader = new $ef65a4887ab7ae06$var$$Reader(reader);
            return this.decode(reader, reader.uint32());
        };
        /**
         * Verifies a BatchEntry message.
         * @function verify
         * @memberof ics23.BatchEntry
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */ BatchEntry.verify = function verify(message) {
            if (typeof message !== "object" || message === null) return "object expected";
            var properties = {};
            if (message.exist != null && message.hasOwnProperty("exist")) {
                properties.proof = 1;
                var error = $ef65a4887ab7ae06$var$$root.ics23.ExistenceProof.verify(message.exist);
                if (error) return "exist." + error;
            }
            if (message.nonexist != null && message.hasOwnProperty("nonexist")) {
                if (properties.proof === 1) return "proof: multiple values";
                properties.proof = 1;
                var error = $ef65a4887ab7ae06$var$$root.ics23.NonExistenceProof.verify(message.nonexist);
                if (error) return "nonexist." + error;
            }
            return null;
        };
        /**
         * Creates a BatchEntry message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof ics23.BatchEntry
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {ics23.BatchEntry} BatchEntry
         */ BatchEntry.fromObject = function fromObject(object) {
            if (object instanceof $ef65a4887ab7ae06$var$$root.ics23.BatchEntry) return object;
            var message = new $ef65a4887ab7ae06$var$$root.ics23.BatchEntry();
            if (object.exist != null) {
                if (typeof object.exist !== "object") throw TypeError(".ics23.BatchEntry.exist: object expected");
                message.exist = $ef65a4887ab7ae06$var$$root.ics23.ExistenceProof.fromObject(object.exist);
            }
            if (object.nonexist != null) {
                if (typeof object.nonexist !== "object") throw TypeError(".ics23.BatchEntry.nonexist: object expected");
                message.nonexist = $ef65a4887ab7ae06$var$$root.ics23.NonExistenceProof.fromObject(object.nonexist);
            }
            return message;
        };
        /**
         * Creates a plain object from a BatchEntry message. Also converts values to other types if specified.
         * @function toObject
         * @memberof ics23.BatchEntry
         * @static
         * @param {ics23.BatchEntry} message BatchEntry
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */ BatchEntry.toObject = function toObject(message, options) {
            if (!options) options = {};
            var object = {};
            if (message.exist != null && message.hasOwnProperty("exist")) {
                object.exist = $ef65a4887ab7ae06$var$$root.ics23.ExistenceProof.toObject(message.exist, options);
                if (options.oneofs) object.proof = "exist";
            }
            if (message.nonexist != null && message.hasOwnProperty("nonexist")) {
                object.nonexist = $ef65a4887ab7ae06$var$$root.ics23.NonExistenceProof.toObject(message.nonexist, options);
                if (options.oneofs) object.proof = "nonexist";
            }
            return object;
        };
        /**
         * Converts this BatchEntry to JSON.
         * @function toJSON
         * @memberof ics23.BatchEntry
         * @instance
         * @returns {Object.<string,*>} JSON object
         */ BatchEntry.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $fQBv0.util.toJSONOptions);
        };
        return BatchEntry;
    }();
    ics23.CompressedBatchProof = function() {
        /**
         * Properties of a CompressedBatchProof.
         * @memberof ics23
         * @interface ICompressedBatchProof
         * @property {Array.<ics23.ICompressedBatchEntry>|null} [entries] CompressedBatchProof entries
         * @property {Array.<ics23.IInnerOp>|null} [lookupInners] CompressedBatchProof lookupInners
         */ /**
         * Constructs a new CompressedBatchProof.
         * @memberof ics23
         * @classdesc Represents a CompressedBatchProof.
         * @implements ICompressedBatchProof
         * @constructor
         * @param {ics23.ICompressedBatchProof=} [properties] Properties to set
         */ function CompressedBatchProof(properties) {
            this.entries = [];
            this.lookupInners = [];
            if (properties) {
                for(var keys = Object.keys(properties), i = 0; i < keys.length; ++i)if (properties[keys[i]] != null) this[keys[i]] = properties[keys[i]];
            }
        }
        /**
         * CompressedBatchProof entries.
         * @member {Array.<ics23.ICompressedBatchEntry>} entries
         * @memberof ics23.CompressedBatchProof
         * @instance
         */ CompressedBatchProof.prototype.entries = $ef65a4887ab7ae06$var$$util.emptyArray;
        /**
         * CompressedBatchProof lookupInners.
         * @member {Array.<ics23.IInnerOp>} lookupInners
         * @memberof ics23.CompressedBatchProof
         * @instance
         */ CompressedBatchProof.prototype.lookupInners = $ef65a4887ab7ae06$var$$util.emptyArray;
        /**
         * Creates a new CompressedBatchProof instance using the specified properties.
         * @function create
         * @memberof ics23.CompressedBatchProof
         * @static
         * @param {ics23.ICompressedBatchProof=} [properties] Properties to set
         * @returns {ics23.CompressedBatchProof} CompressedBatchProof instance
         */ CompressedBatchProof.create = function create(properties) {
            return new CompressedBatchProof(properties);
        };
        /**
         * Encodes the specified CompressedBatchProof message. Does not implicitly {@link ics23.CompressedBatchProof.verify|verify} messages.
         * @function encode
         * @memberof ics23.CompressedBatchProof
         * @static
         * @param {ics23.ICompressedBatchProof} message CompressedBatchProof message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */ CompressedBatchProof.encode = function encode(message, writer) {
            if (!writer) writer = $ef65a4887ab7ae06$var$$Writer.create();
            if (message.entries != null && message.entries.length) for(var i = 0; i < message.entries.length; ++i)$ef65a4887ab7ae06$var$$root.ics23.CompressedBatchEntry.encode(message.entries[i], writer.uint32(/* id 1, wireType 2 =*/ 10).fork()).ldelim();
            if (message.lookupInners != null && message.lookupInners.length) for(var i = 0; i < message.lookupInners.length; ++i)$ef65a4887ab7ae06$var$$root.ics23.InnerOp.encode(message.lookupInners[i], writer.uint32(/* id 2, wireType 2 =*/ 18).fork()).ldelim();
            return writer;
        };
        /**
         * Encodes the specified CompressedBatchProof message, length delimited. Does not implicitly {@link ics23.CompressedBatchProof.verify|verify} messages.
         * @function encodeDelimited
         * @memberof ics23.CompressedBatchProof
         * @static
         * @param {ics23.ICompressedBatchProof} message CompressedBatchProof message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */ CompressedBatchProof.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };
        /**
         * Decodes a CompressedBatchProof message from the specified reader or buffer.
         * @function decode
         * @memberof ics23.CompressedBatchProof
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {ics23.CompressedBatchProof} CompressedBatchProof
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */ CompressedBatchProof.decode = function decode(reader, length) {
            if (!(reader instanceof $ef65a4887ab7ae06$var$$Reader)) reader = $ef65a4887ab7ae06$var$$Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $ef65a4887ab7ae06$var$$root.ics23.CompressedBatchProof();
            while(reader.pos < end){
                var tag = reader.uint32();
                switch(tag >>> 3){
                    case 1:
                        if (!(message.entries && message.entries.length)) message.entries = [];
                        message.entries.push($ef65a4887ab7ae06$var$$root.ics23.CompressedBatchEntry.decode(reader, reader.uint32()));
                        break;
                    case 2:
                        if (!(message.lookupInners && message.lookupInners.length)) message.lookupInners = [];
                        message.lookupInners.push($ef65a4887ab7ae06$var$$root.ics23.InnerOp.decode(reader, reader.uint32()));
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                }
            }
            return message;
        };
        /**
         * Decodes a CompressedBatchProof message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof ics23.CompressedBatchProof
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {ics23.CompressedBatchProof} CompressedBatchProof
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */ CompressedBatchProof.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $ef65a4887ab7ae06$var$$Reader)) reader = new $ef65a4887ab7ae06$var$$Reader(reader);
            return this.decode(reader, reader.uint32());
        };
        /**
         * Verifies a CompressedBatchProof message.
         * @function verify
         * @memberof ics23.CompressedBatchProof
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */ CompressedBatchProof.verify = function verify(message) {
            if (typeof message !== "object" || message === null) return "object expected";
            if (message.entries != null && message.hasOwnProperty("entries")) {
                if (!Array.isArray(message.entries)) return "entries: array expected";
                for(var i = 0; i < message.entries.length; ++i){
                    var error = $ef65a4887ab7ae06$var$$root.ics23.CompressedBatchEntry.verify(message.entries[i]);
                    if (error) return "entries." + error;
                }
            }
            if (message.lookupInners != null && message.hasOwnProperty("lookupInners")) {
                if (!Array.isArray(message.lookupInners)) return "lookupInners: array expected";
                for(var i = 0; i < message.lookupInners.length; ++i){
                    var error = $ef65a4887ab7ae06$var$$root.ics23.InnerOp.verify(message.lookupInners[i]);
                    if (error) return "lookupInners." + error;
                }
            }
            return null;
        };
        /**
         * Creates a CompressedBatchProof message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof ics23.CompressedBatchProof
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {ics23.CompressedBatchProof} CompressedBatchProof
         */ CompressedBatchProof.fromObject = function fromObject(object) {
            if (object instanceof $ef65a4887ab7ae06$var$$root.ics23.CompressedBatchProof) return object;
            var message = new $ef65a4887ab7ae06$var$$root.ics23.CompressedBatchProof();
            if (object.entries) {
                if (!Array.isArray(object.entries)) throw TypeError(".ics23.CompressedBatchProof.entries: array expected");
                message.entries = [];
                for(var i = 0; i < object.entries.length; ++i){
                    if (typeof object.entries[i] !== "object") throw TypeError(".ics23.CompressedBatchProof.entries: object expected");
                    message.entries[i] = $ef65a4887ab7ae06$var$$root.ics23.CompressedBatchEntry.fromObject(object.entries[i]);
                }
            }
            if (object.lookupInners) {
                if (!Array.isArray(object.lookupInners)) throw TypeError(".ics23.CompressedBatchProof.lookupInners: array expected");
                message.lookupInners = [];
                for(var i = 0; i < object.lookupInners.length; ++i){
                    if (typeof object.lookupInners[i] !== "object") throw TypeError(".ics23.CompressedBatchProof.lookupInners: object expected");
                    message.lookupInners[i] = $ef65a4887ab7ae06$var$$root.ics23.InnerOp.fromObject(object.lookupInners[i]);
                }
            }
            return message;
        };
        /**
         * Creates a plain object from a CompressedBatchProof message. Also converts values to other types if specified.
         * @function toObject
         * @memberof ics23.CompressedBatchProof
         * @static
         * @param {ics23.CompressedBatchProof} message CompressedBatchProof
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */ CompressedBatchProof.toObject = function toObject(message, options) {
            if (!options) options = {};
            var object = {};
            if (options.arrays || options.defaults) {
                object.entries = [];
                object.lookupInners = [];
            }
            if (message.entries && message.entries.length) {
                object.entries = [];
                for(var j = 0; j < message.entries.length; ++j)object.entries[j] = $ef65a4887ab7ae06$var$$root.ics23.CompressedBatchEntry.toObject(message.entries[j], options);
            }
            if (message.lookupInners && message.lookupInners.length) {
                object.lookupInners = [];
                for(var j = 0; j < message.lookupInners.length; ++j)object.lookupInners[j] = $ef65a4887ab7ae06$var$$root.ics23.InnerOp.toObject(message.lookupInners[j], options);
            }
            return object;
        };
        /**
         * Converts this CompressedBatchProof to JSON.
         * @function toJSON
         * @memberof ics23.CompressedBatchProof
         * @instance
         * @returns {Object.<string,*>} JSON object
         */ CompressedBatchProof.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $fQBv0.util.toJSONOptions);
        };
        return CompressedBatchProof;
    }();
    ics23.CompressedBatchEntry = function() {
        /**
         * Properties of a CompressedBatchEntry.
         * @memberof ics23
         * @interface ICompressedBatchEntry
         * @property {ics23.ICompressedExistenceProof|null} [exist] CompressedBatchEntry exist
         * @property {ics23.ICompressedNonExistenceProof|null} [nonexist] CompressedBatchEntry nonexist
         */ /**
         * Constructs a new CompressedBatchEntry.
         * @memberof ics23
         * @classdesc Represents a CompressedBatchEntry.
         * @implements ICompressedBatchEntry
         * @constructor
         * @param {ics23.ICompressedBatchEntry=} [properties] Properties to set
         */ function CompressedBatchEntry(properties) {
            if (properties) {
                for(var keys = Object.keys(properties), i = 0; i < keys.length; ++i)if (properties[keys[i]] != null) this[keys[i]] = properties[keys[i]];
            }
        }
        /**
         * CompressedBatchEntry exist.
         * @member {ics23.ICompressedExistenceProof|null|undefined} exist
         * @memberof ics23.CompressedBatchEntry
         * @instance
         */ CompressedBatchEntry.prototype.exist = null;
        /**
         * CompressedBatchEntry nonexist.
         * @member {ics23.ICompressedNonExistenceProof|null|undefined} nonexist
         * @memberof ics23.CompressedBatchEntry
         * @instance
         */ CompressedBatchEntry.prototype.nonexist = null;
        // OneOf field names bound to virtual getters and setters
        var $oneOfFields;
        /**
         * CompressedBatchEntry proof.
         * @member {"exist"|"nonexist"|undefined} proof
         * @memberof ics23.CompressedBatchEntry
         * @instance
         */ Object.defineProperty(CompressedBatchEntry.prototype, "proof", {
            get: $ef65a4887ab7ae06$var$$util.oneOfGetter($oneOfFields = [
                "exist",
                "nonexist"
            ]),
            set: $ef65a4887ab7ae06$var$$util.oneOfSetter($oneOfFields)
        });
        /**
         * Creates a new CompressedBatchEntry instance using the specified properties.
         * @function create
         * @memberof ics23.CompressedBatchEntry
         * @static
         * @param {ics23.ICompressedBatchEntry=} [properties] Properties to set
         * @returns {ics23.CompressedBatchEntry} CompressedBatchEntry instance
         */ CompressedBatchEntry.create = function create(properties) {
            return new CompressedBatchEntry(properties);
        };
        /**
         * Encodes the specified CompressedBatchEntry message. Does not implicitly {@link ics23.CompressedBatchEntry.verify|verify} messages.
         * @function encode
         * @memberof ics23.CompressedBatchEntry
         * @static
         * @param {ics23.ICompressedBatchEntry} message CompressedBatchEntry message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */ CompressedBatchEntry.encode = function encode(message, writer) {
            if (!writer) writer = $ef65a4887ab7ae06$var$$Writer.create();
            if (message.exist != null && message.hasOwnProperty("exist")) $ef65a4887ab7ae06$var$$root.ics23.CompressedExistenceProof.encode(message.exist, writer.uint32(/* id 1, wireType 2 =*/ 10).fork()).ldelim();
            if (message.nonexist != null && message.hasOwnProperty("nonexist")) $ef65a4887ab7ae06$var$$root.ics23.CompressedNonExistenceProof.encode(message.nonexist, writer.uint32(/* id 2, wireType 2 =*/ 18).fork()).ldelim();
            return writer;
        };
        /**
         * Encodes the specified CompressedBatchEntry message, length delimited. Does not implicitly {@link ics23.CompressedBatchEntry.verify|verify} messages.
         * @function encodeDelimited
         * @memberof ics23.CompressedBatchEntry
         * @static
         * @param {ics23.ICompressedBatchEntry} message CompressedBatchEntry message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */ CompressedBatchEntry.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };
        /**
         * Decodes a CompressedBatchEntry message from the specified reader or buffer.
         * @function decode
         * @memberof ics23.CompressedBatchEntry
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {ics23.CompressedBatchEntry} CompressedBatchEntry
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */ CompressedBatchEntry.decode = function decode(reader, length) {
            if (!(reader instanceof $ef65a4887ab7ae06$var$$Reader)) reader = $ef65a4887ab7ae06$var$$Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $ef65a4887ab7ae06$var$$root.ics23.CompressedBatchEntry();
            while(reader.pos < end){
                var tag = reader.uint32();
                switch(tag >>> 3){
                    case 1:
                        message.exist = $ef65a4887ab7ae06$var$$root.ics23.CompressedExistenceProof.decode(reader, reader.uint32());
                        break;
                    case 2:
                        message.nonexist = $ef65a4887ab7ae06$var$$root.ics23.CompressedNonExistenceProof.decode(reader, reader.uint32());
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                }
            }
            return message;
        };
        /**
         * Decodes a CompressedBatchEntry message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof ics23.CompressedBatchEntry
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {ics23.CompressedBatchEntry} CompressedBatchEntry
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */ CompressedBatchEntry.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $ef65a4887ab7ae06$var$$Reader)) reader = new $ef65a4887ab7ae06$var$$Reader(reader);
            return this.decode(reader, reader.uint32());
        };
        /**
         * Verifies a CompressedBatchEntry message.
         * @function verify
         * @memberof ics23.CompressedBatchEntry
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */ CompressedBatchEntry.verify = function verify(message) {
            if (typeof message !== "object" || message === null) return "object expected";
            var properties = {};
            if (message.exist != null && message.hasOwnProperty("exist")) {
                properties.proof = 1;
                var error = $ef65a4887ab7ae06$var$$root.ics23.CompressedExistenceProof.verify(message.exist);
                if (error) return "exist." + error;
            }
            if (message.nonexist != null && message.hasOwnProperty("nonexist")) {
                if (properties.proof === 1) return "proof: multiple values";
                properties.proof = 1;
                var error = $ef65a4887ab7ae06$var$$root.ics23.CompressedNonExistenceProof.verify(message.nonexist);
                if (error) return "nonexist." + error;
            }
            return null;
        };
        /**
         * Creates a CompressedBatchEntry message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof ics23.CompressedBatchEntry
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {ics23.CompressedBatchEntry} CompressedBatchEntry
         */ CompressedBatchEntry.fromObject = function fromObject(object) {
            if (object instanceof $ef65a4887ab7ae06$var$$root.ics23.CompressedBatchEntry) return object;
            var message = new $ef65a4887ab7ae06$var$$root.ics23.CompressedBatchEntry();
            if (object.exist != null) {
                if (typeof object.exist !== "object") throw TypeError(".ics23.CompressedBatchEntry.exist: object expected");
                message.exist = $ef65a4887ab7ae06$var$$root.ics23.CompressedExistenceProof.fromObject(object.exist);
            }
            if (object.nonexist != null) {
                if (typeof object.nonexist !== "object") throw TypeError(".ics23.CompressedBatchEntry.nonexist: object expected");
                message.nonexist = $ef65a4887ab7ae06$var$$root.ics23.CompressedNonExistenceProof.fromObject(object.nonexist);
            }
            return message;
        };
        /**
         * Creates a plain object from a CompressedBatchEntry message. Also converts values to other types if specified.
         * @function toObject
         * @memberof ics23.CompressedBatchEntry
         * @static
         * @param {ics23.CompressedBatchEntry} message CompressedBatchEntry
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */ CompressedBatchEntry.toObject = function toObject(message, options) {
            if (!options) options = {};
            var object = {};
            if (message.exist != null && message.hasOwnProperty("exist")) {
                object.exist = $ef65a4887ab7ae06$var$$root.ics23.CompressedExistenceProof.toObject(message.exist, options);
                if (options.oneofs) object.proof = "exist";
            }
            if (message.nonexist != null && message.hasOwnProperty("nonexist")) {
                object.nonexist = $ef65a4887ab7ae06$var$$root.ics23.CompressedNonExistenceProof.toObject(message.nonexist, options);
                if (options.oneofs) object.proof = "nonexist";
            }
            return object;
        };
        /**
         * Converts this CompressedBatchEntry to JSON.
         * @function toJSON
         * @memberof ics23.CompressedBatchEntry
         * @instance
         * @returns {Object.<string,*>} JSON object
         */ CompressedBatchEntry.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $fQBv0.util.toJSONOptions);
        };
        return CompressedBatchEntry;
    }();
    ics23.CompressedExistenceProof = function() {
        /**
         * Properties of a CompressedExistenceProof.
         * @memberof ics23
         * @interface ICompressedExistenceProof
         * @property {Uint8Array|null} [key] CompressedExistenceProof key
         * @property {Uint8Array|null} [value] CompressedExistenceProof value
         * @property {ics23.ILeafOp|null} [leaf] CompressedExistenceProof leaf
         * @property {Array.<number>|null} [path] CompressedExistenceProof path
         */ /**
         * Constructs a new CompressedExistenceProof.
         * @memberof ics23
         * @classdesc Represents a CompressedExistenceProof.
         * @implements ICompressedExistenceProof
         * @constructor
         * @param {ics23.ICompressedExistenceProof=} [properties] Properties to set
         */ function CompressedExistenceProof(properties) {
            this.path = [];
            if (properties) {
                for(var keys = Object.keys(properties), i = 0; i < keys.length; ++i)if (properties[keys[i]] != null) this[keys[i]] = properties[keys[i]];
            }
        }
        /**
         * CompressedExistenceProof key.
         * @member {Uint8Array} key
         * @memberof ics23.CompressedExistenceProof
         * @instance
         */ CompressedExistenceProof.prototype.key = $ef65a4887ab7ae06$var$$util.newBuffer([]);
        /**
         * CompressedExistenceProof value.
         * @member {Uint8Array} value
         * @memberof ics23.CompressedExistenceProof
         * @instance
         */ CompressedExistenceProof.prototype.value = $ef65a4887ab7ae06$var$$util.newBuffer([]);
        /**
         * CompressedExistenceProof leaf.
         * @member {ics23.ILeafOp|null|undefined} leaf
         * @memberof ics23.CompressedExistenceProof
         * @instance
         */ CompressedExistenceProof.prototype.leaf = null;
        /**
         * CompressedExistenceProof path.
         * @member {Array.<number>} path
         * @memberof ics23.CompressedExistenceProof
         * @instance
         */ CompressedExistenceProof.prototype.path = $ef65a4887ab7ae06$var$$util.emptyArray;
        /**
         * Creates a new CompressedExistenceProof instance using the specified properties.
         * @function create
         * @memberof ics23.CompressedExistenceProof
         * @static
         * @param {ics23.ICompressedExistenceProof=} [properties] Properties to set
         * @returns {ics23.CompressedExistenceProof} CompressedExistenceProof instance
         */ CompressedExistenceProof.create = function create(properties) {
            return new CompressedExistenceProof(properties);
        };
        /**
         * Encodes the specified CompressedExistenceProof message. Does not implicitly {@link ics23.CompressedExistenceProof.verify|verify} messages.
         * @function encode
         * @memberof ics23.CompressedExistenceProof
         * @static
         * @param {ics23.ICompressedExistenceProof} message CompressedExistenceProof message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */ CompressedExistenceProof.encode = function encode(message, writer) {
            if (!writer) writer = $ef65a4887ab7ae06$var$$Writer.create();
            if (message.key != null && message.hasOwnProperty("key")) writer.uint32(/* id 1, wireType 2 =*/ 10).bytes(message.key);
            if (message.value != null && message.hasOwnProperty("value")) writer.uint32(/* id 2, wireType 2 =*/ 18).bytes(message.value);
            if (message.leaf != null && message.hasOwnProperty("leaf")) $ef65a4887ab7ae06$var$$root.ics23.LeafOp.encode(message.leaf, writer.uint32(/* id 3, wireType 2 =*/ 26).fork()).ldelim();
            if (message.path != null && message.path.length) {
                writer.uint32(/* id 4, wireType 2 =*/ 34).fork();
                for(var i = 0; i < message.path.length; ++i)writer.int32(message.path[i]);
                writer.ldelim();
            }
            return writer;
        };
        /**
         * Encodes the specified CompressedExistenceProof message, length delimited. Does not implicitly {@link ics23.CompressedExistenceProof.verify|verify} messages.
         * @function encodeDelimited
         * @memberof ics23.CompressedExistenceProof
         * @static
         * @param {ics23.ICompressedExistenceProof} message CompressedExistenceProof message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */ CompressedExistenceProof.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };
        /**
         * Decodes a CompressedExistenceProof message from the specified reader or buffer.
         * @function decode
         * @memberof ics23.CompressedExistenceProof
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {ics23.CompressedExistenceProof} CompressedExistenceProof
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */ CompressedExistenceProof.decode = function decode(reader, length) {
            if (!(reader instanceof $ef65a4887ab7ae06$var$$Reader)) reader = $ef65a4887ab7ae06$var$$Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $ef65a4887ab7ae06$var$$root.ics23.CompressedExistenceProof();
            while(reader.pos < end){
                var tag = reader.uint32();
                switch(tag >>> 3){
                    case 1:
                        message.key = reader.bytes();
                        break;
                    case 2:
                        message.value = reader.bytes();
                        break;
                    case 3:
                        message.leaf = $ef65a4887ab7ae06$var$$root.ics23.LeafOp.decode(reader, reader.uint32());
                        break;
                    case 4:
                        if (!(message.path && message.path.length)) message.path = [];
                        if ((tag & 7) === 2) {
                            var end2 = reader.uint32() + reader.pos;
                            while(reader.pos < end2)message.path.push(reader.int32());
                        } else message.path.push(reader.int32());
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                }
            }
            return message;
        };
        /**
         * Decodes a CompressedExistenceProof message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof ics23.CompressedExistenceProof
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {ics23.CompressedExistenceProof} CompressedExistenceProof
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */ CompressedExistenceProof.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $ef65a4887ab7ae06$var$$Reader)) reader = new $ef65a4887ab7ae06$var$$Reader(reader);
            return this.decode(reader, reader.uint32());
        };
        /**
         * Verifies a CompressedExistenceProof message.
         * @function verify
         * @memberof ics23.CompressedExistenceProof
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */ CompressedExistenceProof.verify = function verify(message) {
            if (typeof message !== "object" || message === null) return "object expected";
            if (message.key != null && message.hasOwnProperty("key")) {
                if (!(message.key && typeof message.key.length === "number" || $ef65a4887ab7ae06$var$$util.isString(message.key))) return "key: buffer expected";
            }
            if (message.value != null && message.hasOwnProperty("value")) {
                if (!(message.value && typeof message.value.length === "number" || $ef65a4887ab7ae06$var$$util.isString(message.value))) return "value: buffer expected";
            }
            if (message.leaf != null && message.hasOwnProperty("leaf")) {
                var error = $ef65a4887ab7ae06$var$$root.ics23.LeafOp.verify(message.leaf);
                if (error) return "leaf." + error;
            }
            if (message.path != null && message.hasOwnProperty("path")) {
                if (!Array.isArray(message.path)) return "path: array expected";
                for(var i = 0; i < message.path.length; ++i)if (!$ef65a4887ab7ae06$var$$util.isInteger(message.path[i])) return "path: integer[] expected";
            }
            return null;
        };
        /**
         * Creates a CompressedExistenceProof message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof ics23.CompressedExistenceProof
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {ics23.CompressedExistenceProof} CompressedExistenceProof
         */ CompressedExistenceProof.fromObject = function fromObject(object) {
            if (object instanceof $ef65a4887ab7ae06$var$$root.ics23.CompressedExistenceProof) return object;
            var message = new $ef65a4887ab7ae06$var$$root.ics23.CompressedExistenceProof();
            if (object.key != null) {
                if (typeof object.key === "string") $ef65a4887ab7ae06$var$$util.base64.decode(object.key, message.key = $ef65a4887ab7ae06$var$$util.newBuffer($ef65a4887ab7ae06$var$$util.base64.length(object.key)), 0);
                else if (object.key.length) message.key = object.key;
            }
            if (object.value != null) {
                if (typeof object.value === "string") $ef65a4887ab7ae06$var$$util.base64.decode(object.value, message.value = $ef65a4887ab7ae06$var$$util.newBuffer($ef65a4887ab7ae06$var$$util.base64.length(object.value)), 0);
                else if (object.value.length) message.value = object.value;
            }
            if (object.leaf != null) {
                if (typeof object.leaf !== "object") throw TypeError(".ics23.CompressedExistenceProof.leaf: object expected");
                message.leaf = $ef65a4887ab7ae06$var$$root.ics23.LeafOp.fromObject(object.leaf);
            }
            if (object.path) {
                if (!Array.isArray(object.path)) throw TypeError(".ics23.CompressedExistenceProof.path: array expected");
                message.path = [];
                for(var i = 0; i < object.path.length; ++i)message.path[i] = object.path[i] | 0;
            }
            return message;
        };
        /**
         * Creates a plain object from a CompressedExistenceProof message. Also converts values to other types if specified.
         * @function toObject
         * @memberof ics23.CompressedExistenceProof
         * @static
         * @param {ics23.CompressedExistenceProof} message CompressedExistenceProof
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */ CompressedExistenceProof.toObject = function toObject(message, options) {
            if (!options) options = {};
            var object = {};
            if (options.arrays || options.defaults) object.path = [];
            if (options.defaults) {
                if (options.bytes === String) object.key = "";
                else {
                    object.key = [];
                    if (options.bytes !== Array) object.key = $ef65a4887ab7ae06$var$$util.newBuffer(object.key);
                }
                if (options.bytes === String) object.value = "";
                else {
                    object.value = [];
                    if (options.bytes !== Array) object.value = $ef65a4887ab7ae06$var$$util.newBuffer(object.value);
                }
                object.leaf = null;
            }
            if (message.key != null && message.hasOwnProperty("key")) object.key = options.bytes === String ? $ef65a4887ab7ae06$var$$util.base64.encode(message.key, 0, message.key.length) : options.bytes === Array ? Array.prototype.slice.call(message.key) : message.key;
            if (message.value != null && message.hasOwnProperty("value")) object.value = options.bytes === String ? $ef65a4887ab7ae06$var$$util.base64.encode(message.value, 0, message.value.length) : options.bytes === Array ? Array.prototype.slice.call(message.value) : message.value;
            if (message.leaf != null && message.hasOwnProperty("leaf")) object.leaf = $ef65a4887ab7ae06$var$$root.ics23.LeafOp.toObject(message.leaf, options);
            if (message.path && message.path.length) {
                object.path = [];
                for(var j = 0; j < message.path.length; ++j)object.path[j] = message.path[j];
            }
            return object;
        };
        /**
         * Converts this CompressedExistenceProof to JSON.
         * @function toJSON
         * @memberof ics23.CompressedExistenceProof
         * @instance
         * @returns {Object.<string,*>} JSON object
         */ CompressedExistenceProof.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $fQBv0.util.toJSONOptions);
        };
        return CompressedExistenceProof;
    }();
    ics23.CompressedNonExistenceProof = function() {
        /**
         * Properties of a CompressedNonExistenceProof.
         * @memberof ics23
         * @interface ICompressedNonExistenceProof
         * @property {Uint8Array|null} [key] CompressedNonExistenceProof key
         * @property {ics23.ICompressedExistenceProof|null} [left] CompressedNonExistenceProof left
         * @property {ics23.ICompressedExistenceProof|null} [right] CompressedNonExistenceProof right
         */ /**
         * Constructs a new CompressedNonExistenceProof.
         * @memberof ics23
         * @classdesc Represents a CompressedNonExistenceProof.
         * @implements ICompressedNonExistenceProof
         * @constructor
         * @param {ics23.ICompressedNonExistenceProof=} [properties] Properties to set
         */ function CompressedNonExistenceProof(properties) {
            if (properties) {
                for(var keys = Object.keys(properties), i = 0; i < keys.length; ++i)if (properties[keys[i]] != null) this[keys[i]] = properties[keys[i]];
            }
        }
        /**
         * CompressedNonExistenceProof key.
         * @member {Uint8Array} key
         * @memberof ics23.CompressedNonExistenceProof
         * @instance
         */ CompressedNonExistenceProof.prototype.key = $ef65a4887ab7ae06$var$$util.newBuffer([]);
        /**
         * CompressedNonExistenceProof left.
         * @member {ics23.ICompressedExistenceProof|null|undefined} left
         * @memberof ics23.CompressedNonExistenceProof
         * @instance
         */ CompressedNonExistenceProof.prototype.left = null;
        /**
         * CompressedNonExistenceProof right.
         * @member {ics23.ICompressedExistenceProof|null|undefined} right
         * @memberof ics23.CompressedNonExistenceProof
         * @instance
         */ CompressedNonExistenceProof.prototype.right = null;
        /**
         * Creates a new CompressedNonExistenceProof instance using the specified properties.
         * @function create
         * @memberof ics23.CompressedNonExistenceProof
         * @static
         * @param {ics23.ICompressedNonExistenceProof=} [properties] Properties to set
         * @returns {ics23.CompressedNonExistenceProof} CompressedNonExistenceProof instance
         */ CompressedNonExistenceProof.create = function create(properties) {
            return new CompressedNonExistenceProof(properties);
        };
        /**
         * Encodes the specified CompressedNonExistenceProof message. Does not implicitly {@link ics23.CompressedNonExistenceProof.verify|verify} messages.
         * @function encode
         * @memberof ics23.CompressedNonExistenceProof
         * @static
         * @param {ics23.ICompressedNonExistenceProof} message CompressedNonExistenceProof message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */ CompressedNonExistenceProof.encode = function encode(message, writer) {
            if (!writer) writer = $ef65a4887ab7ae06$var$$Writer.create();
            if (message.key != null && message.hasOwnProperty("key")) writer.uint32(/* id 1, wireType 2 =*/ 10).bytes(message.key);
            if (message.left != null && message.hasOwnProperty("left")) $ef65a4887ab7ae06$var$$root.ics23.CompressedExistenceProof.encode(message.left, writer.uint32(/* id 2, wireType 2 =*/ 18).fork()).ldelim();
            if (message.right != null && message.hasOwnProperty("right")) $ef65a4887ab7ae06$var$$root.ics23.CompressedExistenceProof.encode(message.right, writer.uint32(/* id 3, wireType 2 =*/ 26).fork()).ldelim();
            return writer;
        };
        /**
         * Encodes the specified CompressedNonExistenceProof message, length delimited. Does not implicitly {@link ics23.CompressedNonExistenceProof.verify|verify} messages.
         * @function encodeDelimited
         * @memberof ics23.CompressedNonExistenceProof
         * @static
         * @param {ics23.ICompressedNonExistenceProof} message CompressedNonExistenceProof message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */ CompressedNonExistenceProof.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };
        /**
         * Decodes a CompressedNonExistenceProof message from the specified reader or buffer.
         * @function decode
         * @memberof ics23.CompressedNonExistenceProof
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {ics23.CompressedNonExistenceProof} CompressedNonExistenceProof
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */ CompressedNonExistenceProof.decode = function decode(reader, length) {
            if (!(reader instanceof $ef65a4887ab7ae06$var$$Reader)) reader = $ef65a4887ab7ae06$var$$Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $ef65a4887ab7ae06$var$$root.ics23.CompressedNonExistenceProof();
            while(reader.pos < end){
                var tag = reader.uint32();
                switch(tag >>> 3){
                    case 1:
                        message.key = reader.bytes();
                        break;
                    case 2:
                        message.left = $ef65a4887ab7ae06$var$$root.ics23.CompressedExistenceProof.decode(reader, reader.uint32());
                        break;
                    case 3:
                        message.right = $ef65a4887ab7ae06$var$$root.ics23.CompressedExistenceProof.decode(reader, reader.uint32());
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                }
            }
            return message;
        };
        /**
         * Decodes a CompressedNonExistenceProof message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof ics23.CompressedNonExistenceProof
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {ics23.CompressedNonExistenceProof} CompressedNonExistenceProof
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */ CompressedNonExistenceProof.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $ef65a4887ab7ae06$var$$Reader)) reader = new $ef65a4887ab7ae06$var$$Reader(reader);
            return this.decode(reader, reader.uint32());
        };
        /**
         * Verifies a CompressedNonExistenceProof message.
         * @function verify
         * @memberof ics23.CompressedNonExistenceProof
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */ CompressedNonExistenceProof.verify = function verify(message) {
            if (typeof message !== "object" || message === null) return "object expected";
            if (message.key != null && message.hasOwnProperty("key")) {
                if (!(message.key && typeof message.key.length === "number" || $ef65a4887ab7ae06$var$$util.isString(message.key))) return "key: buffer expected";
            }
            if (message.left != null && message.hasOwnProperty("left")) {
                var error = $ef65a4887ab7ae06$var$$root.ics23.CompressedExistenceProof.verify(message.left);
                if (error) return "left." + error;
            }
            if (message.right != null && message.hasOwnProperty("right")) {
                var error = $ef65a4887ab7ae06$var$$root.ics23.CompressedExistenceProof.verify(message.right);
                if (error) return "right." + error;
            }
            return null;
        };
        /**
         * Creates a CompressedNonExistenceProof message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof ics23.CompressedNonExistenceProof
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {ics23.CompressedNonExistenceProof} CompressedNonExistenceProof
         */ CompressedNonExistenceProof.fromObject = function fromObject(object) {
            if (object instanceof $ef65a4887ab7ae06$var$$root.ics23.CompressedNonExistenceProof) return object;
            var message = new $ef65a4887ab7ae06$var$$root.ics23.CompressedNonExistenceProof();
            if (object.key != null) {
                if (typeof object.key === "string") $ef65a4887ab7ae06$var$$util.base64.decode(object.key, message.key = $ef65a4887ab7ae06$var$$util.newBuffer($ef65a4887ab7ae06$var$$util.base64.length(object.key)), 0);
                else if (object.key.length) message.key = object.key;
            }
            if (object.left != null) {
                if (typeof object.left !== "object") throw TypeError(".ics23.CompressedNonExistenceProof.left: object expected");
                message.left = $ef65a4887ab7ae06$var$$root.ics23.CompressedExistenceProof.fromObject(object.left);
            }
            if (object.right != null) {
                if (typeof object.right !== "object") throw TypeError(".ics23.CompressedNonExistenceProof.right: object expected");
                message.right = $ef65a4887ab7ae06$var$$root.ics23.CompressedExistenceProof.fromObject(object.right);
            }
            return message;
        };
        /**
         * Creates a plain object from a CompressedNonExistenceProof message. Also converts values to other types if specified.
         * @function toObject
         * @memberof ics23.CompressedNonExistenceProof
         * @static
         * @param {ics23.CompressedNonExistenceProof} message CompressedNonExistenceProof
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */ CompressedNonExistenceProof.toObject = function toObject(message, options) {
            if (!options) options = {};
            var object = {};
            if (options.defaults) {
                if (options.bytes === String) object.key = "";
                else {
                    object.key = [];
                    if (options.bytes !== Array) object.key = $ef65a4887ab7ae06$var$$util.newBuffer(object.key);
                }
                object.left = null;
                object.right = null;
            }
            if (message.key != null && message.hasOwnProperty("key")) object.key = options.bytes === String ? $ef65a4887ab7ae06$var$$util.base64.encode(message.key, 0, message.key.length) : options.bytes === Array ? Array.prototype.slice.call(message.key) : message.key;
            if (message.left != null && message.hasOwnProperty("left")) object.left = $ef65a4887ab7ae06$var$$root.ics23.CompressedExistenceProof.toObject(message.left, options);
            if (message.right != null && message.hasOwnProperty("right")) object.right = $ef65a4887ab7ae06$var$$root.ics23.CompressedExistenceProof.toObject(message.right, options);
            return object;
        };
        /**
         * Converts this CompressedNonExistenceProof to JSON.
         * @function toJSON
         * @memberof ics23.CompressedNonExistenceProof
         * @instance
         * @returns {Object.<string,*>} JSON object
         */ CompressedNonExistenceProof.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $fQBv0.util.toJSONOptions);
        };
        return CompressedNonExistenceProof;
    }();
    return ics23;
}();
$ef65a4887ab7ae06$exports = $ef65a4887ab7ae06$var$$root;


Object.defineProperty($a036351a9c7664e2$exports, "ics23", {
    enumerable: true,
    get: function() {
        return $ef65a4887ab7ae06$exports.ics23;
    }
});
var $c9b9a70de1fa4ad1$exports = {};
"use strict";
Object.defineProperty($c9b9a70de1fa4ad1$exports, "__esModule", {
    value: true
});
$c9b9a70de1fa4ad1$exports.batchVerifyNonMembership = $c9b9a70de1fa4ad1$exports.batchVerifyMembership = $c9b9a70de1fa4ad1$exports.verifyNonMembership = $c9b9a70de1fa4ad1$exports.verifyMembership = void 0;
var $3c58597323077e17$exports = {};
"use strict";
Object.defineProperty($3c58597323077e17$exports, "__esModule", {
    value: true
});
$3c58597323077e17$exports.decompress = $3c58597323077e17$exports.compress = void 0;

function $3c58597323077e17$var$compress(proof) {
    if (!proof.batch) return proof;
    return {
        compressed: $3c58597323077e17$var$compressBatch(proof.batch)
    };
}
$3c58597323077e17$exports.compress = $3c58597323077e17$var$compress;
function $3c58597323077e17$var$decompress(proof) {
    if (!proof.compressed) return proof;
    return {
        batch: $3c58597323077e17$var$decompressBatch(proof.compressed)
    };
}
$3c58597323077e17$exports.decompress = $3c58597323077e17$var$decompress;
function $3c58597323077e17$var$compressBatch(proof) {
    const centries = [];
    const lookup = [];
    const registry = new Map();
    for (const entry of proof.entries){
        if (entry.exist) {
            const centry = {
                exist: $3c58597323077e17$var$compressExist(entry.exist, lookup, registry)
            };
            centries.push(centry);
        } else if (entry.nonexist) {
            const non = entry.nonexist;
            const centry = {
                nonexist: {
                    key: non.key,
                    left: $3c58597323077e17$var$compressExist(non.left, lookup, registry),
                    right: $3c58597323077e17$var$compressExist(non.right, lookup, registry)
                }
            };
            centries.push(centry);
        } else throw new Error("Unexpected batch entry during compress");
    }
    return {
        entries: centries,
        lookupInners: lookup
    };
}
function $3c58597323077e17$var$compressExist(exist, lookup, registry) {
    if (!exist) return undefined;
    const path = exist.path.map((inner)=>{
        const sig = $ef65a4887ab7ae06$exports.ics23.InnerOp.encode(inner).finish();
        let idx = registry.get(sig);
        if (idx === undefined) {
            idx = lookup.length;
            lookup.push(inner);
            registry.set(sig, idx);
        }
        return idx;
    });
    return {
        key: exist.key,
        value: exist.value,
        leaf: exist.leaf,
        path: path
    };
}
function $3c58597323077e17$var$decompressBatch(proof) {
    const lookup = proof.lookupInners;
    const entries = proof.entries.map((comp)=>{
        if (comp.exist) return {
            exist: $3c58597323077e17$var$decompressExist(comp.exist, lookup)
        };
        else if (comp.nonexist) {
            const non = comp.nonexist;
            return {
                nonexist: {
                    key: non.key,
                    left: $3c58597323077e17$var$decompressExist(non.left, lookup),
                    right: $3c58597323077e17$var$decompressExist(non.right, lookup)
                }
            };
        } else throw new Error("Unexpected batch entry during compress");
    });
    return {
        entries: entries
    };
}
function $3c58597323077e17$var$decompressExist(exist, lookup) {
    if (!exist) return undefined;
    const { key: key, value: value, leaf: leaf, path: path } = exist;
    const newPath = (path || []).map((idx)=>lookup[idx]);
    return {
        key: key,
        value: value,
        leaf: leaf,
        path: newPath
    };
}


var $7fc99925ed35b525$exports = {};
"use strict";
Object.defineProperty($7fc99925ed35b525$exports, "__esModule", {
    value: true
});
$7fc99925ed35b525$exports.ensureLeftNeighbor = $7fc99925ed35b525$exports.ensureSpec = $7fc99925ed35b525$exports.calculateExistenceRoot = $7fc99925ed35b525$exports.verifyNonExistence = $7fc99925ed35b525$exports.verifyExistence = $7fc99925ed35b525$exports.smtSpec = $7fc99925ed35b525$exports.tendermintSpec = $7fc99925ed35b525$exports.iavlSpec = void 0;

var $cb86f0ebcea6d126$exports = {};
"use strict";
Object.defineProperty($cb86f0ebcea6d126$exports, "__esModule", {
    value: true
});
$cb86f0ebcea6d126$exports.doHash = $cb86f0ebcea6d126$exports.applyInner = $cb86f0ebcea6d126$exports.applyLeaf = void 0;

var $imJuD = parcelRequire("imJuD");

var $lrsL3 = parcelRequire("lrsL3");

var $fJ9Lg = parcelRequire("fJ9Lg");

function $cb86f0ebcea6d126$var$applyLeaf(leaf, key, value) {
    if (key.length === 0) throw new Error("Missing key");
    if (value.length === 0) throw new Error("Missing value");
    const pkey = $cb86f0ebcea6d126$var$prepareLeafData($cb86f0ebcea6d126$var$ensureHash(leaf.prehashKey), $cb86f0ebcea6d126$var$ensureLength(leaf.length), key);
    const pvalue = $cb86f0ebcea6d126$var$prepareLeafData($cb86f0ebcea6d126$var$ensureHash(leaf.prehashValue), $cb86f0ebcea6d126$var$ensureLength(leaf.length), value);
    const data = new Uint8Array([
        ...$cb86f0ebcea6d126$var$ensureBytes(leaf.prefix),
        ...pkey,
        ...pvalue
    ]);
    return $cb86f0ebcea6d126$var$doHash($cb86f0ebcea6d126$var$ensureHash(leaf.hash), data);
}
$cb86f0ebcea6d126$exports.applyLeaf = $cb86f0ebcea6d126$var$applyLeaf;
function $cb86f0ebcea6d126$var$applyInner(inner, child) {
    if (child.length === 0) throw new Error("Inner op needs child value");
    const preimage = new Uint8Array([
        ...$cb86f0ebcea6d126$var$ensureBytes(inner.prefix),
        ...child,
        ...$cb86f0ebcea6d126$var$ensureBytes(inner.suffix)
    ]);
    return $cb86f0ebcea6d126$var$doHash($cb86f0ebcea6d126$var$ensureHash(inner.hash), preimage);
}
$cb86f0ebcea6d126$exports.applyInner = $cb86f0ebcea6d126$var$applyInner;
function $cb86f0ebcea6d126$var$ensure(maybe, value) {
    return maybe === undefined || maybe === null ? value : maybe;
}
const $cb86f0ebcea6d126$var$ensureHash = (h)=>$cb86f0ebcea6d126$var$ensure(h, $ef65a4887ab7ae06$exports.ics23.HashOp.NO_HASH);
const $cb86f0ebcea6d126$var$ensureLength = (l)=>$cb86f0ebcea6d126$var$ensure(l, $ef65a4887ab7ae06$exports.ics23.LengthOp.NO_PREFIX);
const $cb86f0ebcea6d126$var$ensureBytes = (b)=>$cb86f0ebcea6d126$var$ensure(b, new Uint8Array([]));
function $cb86f0ebcea6d126$var$prepareLeafData(hashOp, lengthOp, data) {
    const h = $cb86f0ebcea6d126$var$doHashOrNoop(hashOp, data);
    return $cb86f0ebcea6d126$var$doLengthOp(lengthOp, h);
}
// doHashOrNoop will return the preimage untouched if hashOp == NONE,
// otherwise, perform doHash
function $cb86f0ebcea6d126$var$doHashOrNoop(hashOp, preimage) {
    if (hashOp === $ef65a4887ab7ae06$exports.ics23.HashOp.NO_HASH) return preimage;
    return $cb86f0ebcea6d126$var$doHash(hashOp, preimage);
}
// doHash will preform the specified hash on the preimage.
// if hashOp == NONE, it will return an error (use doHashOrNoop if you want different behavior)
function $cb86f0ebcea6d126$var$doHash(hashOp, preimage) {
    switch(hashOp){
        case $ef65a4887ab7ae06$exports.ics23.HashOp.SHA256:
            return (0, $lrsL3.sha256)(preimage);
        case $ef65a4887ab7ae06$exports.ics23.HashOp.SHA512:
            return (0, $fJ9Lg.sha512)(preimage);
        case $ef65a4887ab7ae06$exports.ics23.HashOp.RIPEMD160:
            return (0, $imJuD.ripemd160)(preimage);
        case $ef65a4887ab7ae06$exports.ics23.HashOp.BITCOIN:
            return (0, $imJuD.ripemd160)((0, $lrsL3.sha256)(preimage));
        case $ef65a4887ab7ae06$exports.ics23.HashOp.SHA512_256:
            return (0, $fJ9Lg.sha512_256)(preimage);
    }
    throw new Error(`Unsupported hashop: ${hashOp}`);
}
$cb86f0ebcea6d126$exports.doHash = $cb86f0ebcea6d126$var$doHash;
// doLengthOp will calculate the proper prefix and return it prepended
//   doLengthOp(op, data) -> length(data) || data
function $cb86f0ebcea6d126$var$doLengthOp(lengthOp, data) {
    switch(lengthOp){
        case $ef65a4887ab7ae06$exports.ics23.LengthOp.NO_PREFIX:
            return data;
        case $ef65a4887ab7ae06$exports.ics23.LengthOp.VAR_PROTO:
            return new Uint8Array([
                ...$cb86f0ebcea6d126$var$encodeVarintProto(data.length),
                ...data
            ]);
        case $ef65a4887ab7ae06$exports.ics23.LengthOp.REQUIRE_32_BYTES:
            if (data.length !== 32) throw new Error(`Length is ${data.length}, not 32 bytes`);
            return data;
        case $ef65a4887ab7ae06$exports.ics23.LengthOp.REQUIRE_64_BYTES:
            if (data.length !== 64) throw new Error(`Length is ${data.length}, not 64 bytes`);
            return data;
        case $ef65a4887ab7ae06$exports.ics23.LengthOp.FIXED32_LITTLE:
            return new Uint8Array([
                ...$cb86f0ebcea6d126$var$encodeFixed32Le(data.length),
                ...data
            ]);
    }
    throw new Error(`Unsupported lengthop: ${lengthOp}`);
}
function $cb86f0ebcea6d126$var$encodeVarintProto(n) {
    let enc = [];
    let l = n;
    while(l >= 128){
        const b = l % 128 + 128;
        enc = [
            ...enc,
            b
        ];
        l = l / 128;
    }
    enc = [
        ...enc,
        l
    ];
    return new Uint8Array(enc);
}
function $cb86f0ebcea6d126$var$encodeFixed32Le(n) {
    const enc = new Uint8Array(4);
    let l = n;
    for(let i = enc.length; i > 0; i--){
        enc[Math.abs(i - enc.length)] = l % 256;
        l = Math.floor(l / 256);
    }
    return enc;
}


var $fda0ee5208e5950e$exports = {};
"use strict";
Object.defineProperty($fda0ee5208e5950e$exports, "__esModule", {
    value: true
});
$fda0ee5208e5950e$exports.bytesBefore = $fda0ee5208e5950e$exports.ensureBytesBefore = $fda0ee5208e5950e$exports.bytesEqual = $fda0ee5208e5950e$exports.ensureBytesEqual = $fda0ee5208e5950e$exports.ensureInner = $fda0ee5208e5950e$exports.ensureLeaf = void 0;
function $fda0ee5208e5950e$var$ensureLeaf(leaf, spec) {
    if (leaf.hash !== spec.hash) throw new Error(`Unexpected hashOp: ${leaf.hash}`);
    if (leaf.prehashKey !== spec.prehashKey) throw new Error(`Unexpected prehashKey: ${leaf.prehashKey}`);
    if (leaf.prehashValue !== spec.prehashValue) throw new Error(`Unexpected prehashValue: ${leaf.prehashValue}`);
    if (leaf.length !== spec.length) throw new Error(`Unexpected length op: ${leaf.length}`);
    $fda0ee5208e5950e$var$ensurePrefix(leaf.prefix, spec.prefix);
}
$fda0ee5208e5950e$exports.ensureLeaf = $fda0ee5208e5950e$var$ensureLeaf;
function $fda0ee5208e5950e$var$ensureInner(inner, prefix, spec) {
    if (inner.hash !== spec.hash) throw new Error(`Unexpected hashOp: ${inner.hash}`);
    if (!inner.prefix) throw new Error("No prefix set for inner node");
    if ($fda0ee5208e5950e$var$hasPrefix(inner.prefix, prefix)) throw new Error(`Inner node has leaf prefix`);
    if (inner.prefix.length < (spec.minPrefixLength || 0)) throw new Error(`Prefix too short: ${inner.prefix.length} bytes`);
    const maxLeftChildBytes = (spec.childOrder.length - 1) * spec.childSize;
    if (inner.prefix.length > (spec.maxPrefixLength || 0) + maxLeftChildBytes) throw new Error(`Prefix too long: ${inner.prefix.length} bytes`);
}
$fda0ee5208e5950e$exports.ensureInner = $fda0ee5208e5950e$var$ensureInner;
function $fda0ee5208e5950e$var$ensurePrefix(check, prefix) {
    // no prefix supplied, means everything passes
    if (!prefix || prefix.length === 0) return;
    if (!check) throw new Error(`Target bytes missing`);
    $fda0ee5208e5950e$var$ensureBytesEqual(prefix, check.slice(0, prefix.length));
}
// ensureBytesEqual throws an error if the arrays are different
function $fda0ee5208e5950e$var$ensureBytesEqual(a, b) {
    if (a.length !== b.length) throw new Error(`Different lengths ${a.length} vs ${b.length}`);
    for(let i = 0; i < a.length; i++){
        if (a[i] !== b[i]) throw new Error(`Arrays differ at index ${i}: ${a[i]} vs ${b[i]}`);
    }
}
$fda0ee5208e5950e$exports.ensureBytesEqual = $fda0ee5208e5950e$var$ensureBytesEqual;
function $fda0ee5208e5950e$var$bytesEqual(a, b) {
    if (a.length !== b.length) return false;
    for(let i = 0; i < a.length; i++){
        if (a[i] !== b[i]) return false;
    }
    return true;
}
$fda0ee5208e5950e$exports.bytesEqual = $fda0ee5208e5950e$var$bytesEqual;
function $fda0ee5208e5950e$var$hasPrefix(check, prefix) {
    // no prefix supplied, means everything passes
    if (!prefix || prefix.length === 0) return false;
    if (!check) return false;
    if (check.length <= prefix.length) return false;
    for(let i = 0; i < prefix.length; i++){
        if (check[i] !== prefix[i]) return false;
    }
    throw true;
}
// ensureBytesBefore throws an error if first >= last
// we compare byte by byte
function $fda0ee5208e5950e$var$ensureBytesBefore(first, last) {
    if (!$fda0ee5208e5950e$var$bytesBefore(first, last)) throw new Error("first is after last");
}
$fda0ee5208e5950e$exports.ensureBytesBefore = $fda0ee5208e5950e$var$ensureBytesBefore;
function $fda0ee5208e5950e$var$bytesBefore(first, last) {
    const min = first.length < last.length ? first.length : last.length;
    for(let i = 0; i < min; i++){
        if (first[i] < last[i]) return true;
        if (first[i] > last[i]) return false;
    // if they are equal, continue to next step
    }
    // if they match, ensure that last is longer than first..
    return first.length < last.length;
}
$fda0ee5208e5950e$exports.bytesBefore = $fda0ee5208e5950e$var$bytesBefore;


$7fc99925ed35b525$exports.iavlSpec = {
    leafSpec: {
        prefix: Uint8Array.from([
            0
        ]),
        hash: $ef65a4887ab7ae06$exports.ics23.HashOp.SHA256,
        prehashValue: $ef65a4887ab7ae06$exports.ics23.HashOp.SHA256,
        prehashKey: $ef65a4887ab7ae06$exports.ics23.HashOp.NO_HASH,
        length: $ef65a4887ab7ae06$exports.ics23.LengthOp.VAR_PROTO
    },
    innerSpec: {
        childOrder: [
            0,
            1
        ],
        minPrefixLength: 4,
        maxPrefixLength: 12,
        childSize: 33,
        hash: $ef65a4887ab7ae06$exports.ics23.HashOp.SHA256
    }
};
$7fc99925ed35b525$exports.tendermintSpec = {
    leafSpec: {
        prefix: Uint8Array.from([
            0
        ]),
        hash: $ef65a4887ab7ae06$exports.ics23.HashOp.SHA256,
        prehashValue: $ef65a4887ab7ae06$exports.ics23.HashOp.SHA256,
        prehashKey: $ef65a4887ab7ae06$exports.ics23.HashOp.NO_HASH,
        length: $ef65a4887ab7ae06$exports.ics23.LengthOp.VAR_PROTO
    },
    innerSpec: {
        childOrder: [
            0,
            1
        ],
        minPrefixLength: 1,
        maxPrefixLength: 1,
        childSize: 32,
        hash: $ef65a4887ab7ae06$exports.ics23.HashOp.SHA256
    }
};
$7fc99925ed35b525$exports.smtSpec = {
    leafSpec: {
        hash: $ef65a4887ab7ae06$exports.ics23.HashOp.SHA256,
        prehashKey: $ef65a4887ab7ae06$exports.ics23.HashOp.NO_HASH,
        prehashValue: $ef65a4887ab7ae06$exports.ics23.HashOp.SHA256,
        length: $ef65a4887ab7ae06$exports.ics23.LengthOp.NO_PREFIX,
        prefix: Uint8Array.from([
            0
        ])
    },
    innerSpec: {
        childOrder: [
            0,
            1
        ],
        childSize: 32,
        minPrefixLength: 1,
        maxPrefixLength: 1,
        emptyChild: new Uint8Array(32),
        hash: $ef65a4887ab7ae06$exports.ics23.HashOp.SHA256
    },
    maxDepth: 256
};
// verifyExistence will throw an error if the proof doesn't link key, value -> root
// or if it doesn't fulfill the spec
function $7fc99925ed35b525$var$verifyExistence(proof, spec, root, key, value) {
    $7fc99925ed35b525$var$ensureSpec(proof, spec);
    const calc = $7fc99925ed35b525$var$calculateExistenceRoot(proof);
    (0, $fda0ee5208e5950e$exports.ensureBytesEqual)(calc, root);
    (0, $fda0ee5208e5950e$exports.ensureBytesEqual)(key, proof.key);
    (0, $fda0ee5208e5950e$exports.ensureBytesEqual)(value, proof.value);
}
$7fc99925ed35b525$exports.verifyExistence = $7fc99925ed35b525$var$verifyExistence;
// Verify does all checks to ensure the proof has valid non-existence proofs,
// and they ensure the given key is not in the CommitmentState,
// throwing an error if there is an issue
function $7fc99925ed35b525$var$verifyNonExistence(proof, spec, root, key) {
    let leftKey;
    let rightKey;
    if (proof.left) {
        $7fc99925ed35b525$var$verifyExistence(proof.left, spec, root, proof.left.key, proof.left.value);
        leftKey = proof.left.key;
    }
    if (proof.right) {
        $7fc99925ed35b525$var$verifyExistence(proof.right, spec, root, proof.right.key, proof.right.value);
        rightKey = proof.right.key;
    }
    if (!leftKey && !rightKey) throw new Error("neither left nor right proof defined");
    if (leftKey) (0, $fda0ee5208e5950e$exports.ensureBytesBefore)(leftKey, key);
    if (rightKey) (0, $fda0ee5208e5950e$exports.ensureBytesBefore)(key, rightKey);
    if (!spec.innerSpec) throw new Error("no inner spec");
    if (!leftKey) $7fc99925ed35b525$var$ensureLeftMost(spec.innerSpec, proof.right.path);
    else if (!rightKey) $7fc99925ed35b525$var$ensureRightMost(spec.innerSpec, proof.left.path);
    else $7fc99925ed35b525$var$ensureLeftNeighbor(spec.innerSpec, proof.left.path, proof.right.path);
    return;
}
$7fc99925ed35b525$exports.verifyNonExistence = $7fc99925ed35b525$var$verifyNonExistence;
// Calculate determines the root hash that matches the given proof.
// You must validate the result is what you have in a header.
// Returns error if the calculations cannot be performed.
function $7fc99925ed35b525$var$calculateExistenceRoot(proof) {
    if (!proof.key || !proof.value) throw new Error("Existence proof needs key and value set");
    if (!proof.leaf) throw new Error("Existence proof must start with a leaf operation");
    const path = proof.path || [];
    let res = (0, $cb86f0ebcea6d126$exports.applyLeaf)(proof.leaf, proof.key, proof.value);
    for (const inner of path)res = (0, $cb86f0ebcea6d126$exports.applyInner)(inner, res);
    return res;
}
$7fc99925ed35b525$exports.calculateExistenceRoot = $7fc99925ed35b525$var$calculateExistenceRoot;
// ensureSpec throws an Error if proof doesn't fulfill spec
function $7fc99925ed35b525$var$ensureSpec(proof, spec) {
    if (!proof.leaf) throw new Error("Existence proof must start with a leaf operation");
    if (!spec.leafSpec) throw new Error("Spec must include leafSpec");
    if (!spec.innerSpec) throw new Error("Spec must include innerSpec");
    (0, $fda0ee5208e5950e$exports.ensureLeaf)(proof.leaf, spec.leafSpec);
    const path = proof.path || [];
    if (spec.minDepth && path.length < spec.minDepth) throw new Error(`Too few inner nodes ${path.length}`);
    if (spec.maxDepth && path.length > spec.maxDepth) throw new Error(`Too many inner nodes ${path.length}`);
    for (const inner of path)(0, $fda0ee5208e5950e$exports.ensureInner)(inner, spec.leafSpec.prefix, spec.innerSpec);
}
$7fc99925ed35b525$exports.ensureSpec = $7fc99925ed35b525$var$ensureSpec;
function $7fc99925ed35b525$var$ensureLeftMost(spec, path) {
    const { minPrefix: minPrefix, maxPrefix: maxPrefix, suffix: suffix } = $7fc99925ed35b525$var$getPadding(spec, 0);
    // ensure every step has a prefix and suffix defined to be leftmost
    for (const step of path){
        if (!$7fc99925ed35b525$var$hasPadding(step, minPrefix, maxPrefix, suffix)) throw new Error("Step not leftmost");
    }
}
function $7fc99925ed35b525$var$ensureRightMost(spec, path) {
    const len = spec.childOrder.length - 1;
    const { minPrefix: minPrefix, maxPrefix: maxPrefix, suffix: suffix } = $7fc99925ed35b525$var$getPadding(spec, len);
    // ensure every step has a prefix and suffix defined to be leftmost
    for (const step of path){
        if (!$7fc99925ed35b525$var$hasPadding(step, minPrefix, maxPrefix, suffix)) throw new Error("Step not leftmost");
    }
}
function $7fc99925ed35b525$var$ensureLeftNeighbor(spec, left, right) {
    const mutleft = [
        ...left
    ];
    const mutright = [
        ...right
    ];
    let topleft = mutleft.pop();
    let topright = mutright.pop();
    while((0, $fda0ee5208e5950e$exports.bytesEqual)(topleft.prefix, topright.prefix) && (0, $fda0ee5208e5950e$exports.bytesEqual)(topleft.suffix, topright.suffix)){
        topleft = mutleft.pop();
        topright = mutright.pop();
    }
    // now topleft and topright are the first divergent nodes
    // make sure they are left and right of each other
    if (!$7fc99925ed35b525$var$isLeftStep(spec, topleft, topright)) throw new Error(`Not left neightbor at first divergent step`);
    // make sure the paths are left and right most possibilities respectively
    $7fc99925ed35b525$var$ensureRightMost(spec, mutleft);
    $7fc99925ed35b525$var$ensureLeftMost(spec, mutright);
}
$7fc99925ed35b525$exports.ensureLeftNeighbor = $7fc99925ed35b525$var$ensureLeftNeighbor;
// isLeftStep assumes left and right have common parents
// checks if left is exactly one slot to the left of right
function $7fc99925ed35b525$var$isLeftStep(spec, left, right) {
    const leftidx = $7fc99925ed35b525$var$orderFromPadding(spec, left);
    const rightidx = $7fc99925ed35b525$var$orderFromPadding(spec, right);
    return rightidx === leftidx + 1;
}
function $7fc99925ed35b525$var$orderFromPadding(spec, inner) {
    for(let branch = 0; branch < spec.childOrder.length; branch++){
        const { minPrefix: minPrefix, maxPrefix: maxPrefix, suffix: suffix } = $7fc99925ed35b525$var$getPadding(spec, branch);
        if ($7fc99925ed35b525$var$hasPadding(inner, minPrefix, maxPrefix, suffix)) return branch;
    }
    throw new Error(`Cannot find any valid spacing for this node`);
}
function $7fc99925ed35b525$var$hasPadding(op, minPrefix, maxPrefix, suffix) {
    if ((op.prefix || []).length < minPrefix) return false;
    if ((op.prefix || []).length > maxPrefix) return false;
    return (op.suffix || []).length === suffix;
}
function $7fc99925ed35b525$var$getPadding(spec, branch) {
    const idx = $7fc99925ed35b525$var$getPosition(spec.childOrder, branch);
    // count how many children are in the prefix
    const prefix = idx * spec.childSize;
    const minPrefix = prefix + spec.minPrefixLength;
    const maxPrefix = prefix + spec.maxPrefixLength;
    // count how many children are in the suffix
    const suffix = (spec.childOrder.length - 1 - idx) * spec.childSize;
    return {
        minPrefix: minPrefix,
        maxPrefix: maxPrefix,
        suffix: suffix
    };
}
function $7fc99925ed35b525$var$getPosition(order, branch) {
    if (branch < 0 || branch >= order.length) throw new Error(`Invalid branch: ${branch}`);
    return order.findIndex((val)=>val === branch);
}



/*
This implements the client side functions as specified in
https://github.com/cosmos/ics/tree/master/spec/ics-023-vector-commitments

In particular:

  // Assumes ExistenceProof
  type verifyMembership = (root: CommitmentRoot, proof: CommitmentProof, key: Key, value: Value) => boolean

  // Assumes NonExistenceProof
  type verifyNonMembership = (root: CommitmentRoot, proof: CommitmentProof, key: Key) => boolean

  // Assumes BatchProof - required ExistenceProofs may be a subset of all items proven
  type batchVerifyMembership = (root: CommitmentRoot, proof: CommitmentProof, items: Map<Key, Value>) => boolean

  // Assumes BatchProof - required NonExistenceProofs may be a subset of all items proven
  type batchVerifyNonMembership = (root: CommitmentRoot, proof: CommitmentProof, keys: Set<Key>) => boolean

We make an adjustment to accept a Spec to ensure the provided proof is in the format of the expected merkle store.
This can avoid an range of attacks on fake preimages, as we need to be careful on how to map key, value -> leaf
and determine neighbors
*/ /**
 * verifyMembership ensures proof is (contains) a valid existence proof for the given
 */ function $c9b9a70de1fa4ad1$var$verifyMembership(proof, spec, root, key, value) {
    const norm = (0, $3c58597323077e17$exports.decompress)(proof);
    const exist = $c9b9a70de1fa4ad1$var$getExistForKey(norm, key);
    if (!exist) return false;
    try {
        (0, $7fc99925ed35b525$exports.verifyExistence)(exist, spec, root, key, value);
        return true;
    } catch (_a) {
        return false;
    }
}
$c9b9a70de1fa4ad1$exports.verifyMembership = $c9b9a70de1fa4ad1$var$verifyMembership;
/**
 * verifyNonMembership ensures proof is (contains) a valid non-existence proof for the given key
 */ function $c9b9a70de1fa4ad1$var$verifyNonMembership(proof, spec, root, key) {
    const norm = (0, $3c58597323077e17$exports.decompress)(proof);
    const nonexist = $c9b9a70de1fa4ad1$var$getNonExistForKey(norm, key);
    if (!nonexist) return false;
    try {
        (0, $7fc99925ed35b525$exports.verifyNonExistence)(nonexist, spec, root, key);
        return true;
    } catch (_a) {
        return false;
    }
}
$c9b9a70de1fa4ad1$exports.verifyNonMembership = $c9b9a70de1fa4ad1$var$verifyNonMembership;
/**
 * batchVerifyMembership ensures proof is (contains) a valid existence proof for the given
 */ function $c9b9a70de1fa4ad1$var$batchVerifyMembership(proof, spec, root, items) {
    const norm = (0, $3c58597323077e17$exports.decompress)(proof);
    for (const [key, value] of items.entries()){
        if (!$c9b9a70de1fa4ad1$var$verifyMembership(norm, spec, root, key, value)) return false;
    }
    return true;
}
$c9b9a70de1fa4ad1$exports.batchVerifyMembership = $c9b9a70de1fa4ad1$var$batchVerifyMembership;
/**
 * batchVerifyNonMembership ensures proof is (contains) a valid existence proof for the given
 */ function $c9b9a70de1fa4ad1$var$batchVerifyNonMembership(proof, spec, root, keys) {
    const norm = (0, $3c58597323077e17$exports.decompress)(proof);
    for (const key of keys){
        if (!$c9b9a70de1fa4ad1$var$verifyNonMembership(norm, spec, root, key)) return false;
    }
    return true;
}
$c9b9a70de1fa4ad1$exports.batchVerifyNonMembership = $c9b9a70de1fa4ad1$var$batchVerifyNonMembership;
function $c9b9a70de1fa4ad1$var$getExistForKey(proof, key) {
    const match = (p)=>!!p && (0, $fda0ee5208e5950e$exports.bytesEqual)(key, p.key);
    if (match(proof.exist)) return proof.exist;
    else if (proof.batch) return proof.batch.entries.map((x)=>x.exist || null).find(match);
    return undefined;
}
function $c9b9a70de1fa4ad1$var$getNonExistForKey(proof, key) {
    const match = (p)=>{
        return !!p && (!p.left || (0, $fda0ee5208e5950e$exports.bytesBefore)(p.left.key, key)) && (!p.right || (0, $fda0ee5208e5950e$exports.bytesBefore)(key, p.right.key));
    };
    if (match(proof.nonexist)) return proof.nonexist;
    else if (proof.batch) return proof.batch.entries.map((x)=>x.nonexist || null).find(match);
    return undefined;
}


Object.defineProperty($a036351a9c7664e2$exports, "verifyMembership", {
    enumerable: true,
    get: function() {
        return $c9b9a70de1fa4ad1$exports.verifyMembership;
    }
});
Object.defineProperty($a036351a9c7664e2$exports, "verifyNonMembership", {
    enumerable: true,
    get: function() {
        return $c9b9a70de1fa4ad1$exports.verifyNonMembership;
    }
});

Object.defineProperty($a036351a9c7664e2$exports, "calculateExistenceRoot", {
    enumerable: true,
    get: function() {
        return $7fc99925ed35b525$exports.calculateExistenceRoot;
    }
});
Object.defineProperty($a036351a9c7664e2$exports, "iavlSpec", {
    enumerable: true,
    get: function() {
        return $7fc99925ed35b525$exports.iavlSpec;
    }
});
Object.defineProperty($a036351a9c7664e2$exports, "tendermintSpec", {
    enumerable: true,
    get: function() {
        return $7fc99925ed35b525$exports.tendermintSpec;
    }
});
Object.defineProperty($a036351a9c7664e2$exports, "verifyExistence", {
    enumerable: true,
    get: function() {
        return $7fc99925ed35b525$exports.verifyExistence;
    }
});
Object.defineProperty($a036351a9c7664e2$exports, "verifyNonExistence", {
    enumerable: true,
    get: function() {
        return $7fc99925ed35b525$exports.verifyNonExistence;
    }
});



var $6XcLW = parcelRequire("6XcLW");

var $8iJvX = parcelRequire("8iJvX");

var $fZwG5 = parcelRequire("fZwG5");
function $c72059c029acecec$var$checkAndParseOp(op, kind, key) {
    if (op.type !== kind) throw new Error(`Op expected to be ${kind}, got "${op.type}`);
    if (!(0, $fZwG5.arrayContentEquals)(key, op.key)) throw new Error(`Proven key different than queried key.\nQuery: ${(0, $6XcLW.toHex)(key)}\nProven: ${(0, $6XcLW.toHex)(op.key)}`);
    return $a036351a9c7664e2$exports.ics23.CommitmentProof.decode(op.data);
}
class $c72059c029acecec$var$QueryClient {
    static withExtensions(tmClient, ...extensionSetups) {
        const client = new $c72059c029acecec$var$QueryClient(tmClient);
        const extensions = extensionSetups.map((setupExtension)=>setupExtension(client));
        for (const extension of extensions){
            (0, $fZwG5.assert)((0, $fZwG5.isNonNullObject)(extension), `Extension must be a non-null object`);
            for (const [moduleKey, moduleValue] of Object.entries(extension)){
                (0, $fZwG5.assert)((0, $fZwG5.isNonNullObject)(moduleValue), `Module must be a non-null object. Found type ${typeof moduleValue} for module "${moduleKey}".`);
                const current = client[moduleKey] || {};
                client[moduleKey] = {
                    ...current,
                    ...moduleValue
                };
            }
        }
        return client;
    }
    constructor(tmClient){
        this.tmClient = tmClient;
    }
    /**
     * Queries the database store with a proof, which is then verified.
     *
     * Please note: the current implementation trusts block headers it gets from the PRC endpoint.
     */ async queryStoreVerified(store, queryKey, desiredHeight) {
        const { height: height, proof: proof, key: key, value: value } = await this.queryRawProof(store, queryKey, desiredHeight);
        const subProof = $c72059c029acecec$var$checkAndParseOp(proof.ops[0], "ics23:iavl", queryKey);
        const storeProof = $c72059c029acecec$var$checkAndParseOp(proof.ops[1], "ics23:simple", (0, $6XcLW.toAscii)(store));
        // this must always be existence, if the store is not a typo
        (0, $fZwG5.assert)(storeProof.exist);
        (0, $fZwG5.assert)(storeProof.exist.value);
        // this may be exist or non-exist, depends on response
        if (!value || value.length === 0) {
            // non-existence check
            (0, $fZwG5.assert)(subProof.nonexist);
            // the subproof must map the desired key to the "value" of the storeProof
            (0, $a036351a9c7664e2$exports.verifyNonExistence)(subProof.nonexist, $a036351a9c7664e2$exports.iavlSpec, storeProof.exist.value, queryKey);
        } else {
            // existence check
            (0, $fZwG5.assert)(subProof.exist);
            (0, $fZwG5.assert)(subProof.exist.value);
            // the subproof must map the desired key to the "value" of the storeProof
            (0, $a036351a9c7664e2$exports.verifyExistence)(subProof.exist, $a036351a9c7664e2$exports.iavlSpec, storeProof.exist.value, queryKey, value);
        }
        // the store proof must map its declared value (root of subProof) to the appHash of the next block
        const header = await this.getNextHeader(height);
        (0, $a036351a9c7664e2$exports.verifyExistence)(storeProof.exist, $a036351a9c7664e2$exports.tendermintSpec, header.appHash, (0, $6XcLW.toAscii)(store), storeProof.exist.value);
        return {
            key: key,
            value: value,
            height: height
        };
    }
    async queryRawProof(store, queryKey, desiredHeight) {
        const { key: key, value: value, height: height, proof: proof, code: code, log: log } = await this.tmClient.abciQuery({
            // we need the StoreKey for the module, not the module name
            // https://github.com/cosmos/cosmos-sdk/blob/8cab43c8120fec5200c3459cbf4a92017bb6f287/x/auth/types/keys.go#L12
            path: `/store/${store}/key`,
            data: queryKey,
            prove: true,
            height: desiredHeight
        });
        if (code) throw new Error(`Query failed with (${code}): ${log}`);
        if (!(0, $fZwG5.arrayContentEquals)(queryKey, key)) throw new Error(`Response key ${(0, $6XcLW.toHex)(key)} doesn't match query key ${(0, $6XcLW.toHex)(queryKey)}`);
        if (!height) throw new Error("No query height returned");
        if (!proof || proof.ops.length !== 2) throw new Error(`Expected 2 proof ops, got ${proof?.ops.length ?? 0}. Are you using stargate?`);
        // we don't need the results, but we can ensure the data is the proper format
        $c72059c029acecec$var$checkAndParseOp(proof.ops[0], "ics23:iavl", key);
        $c72059c029acecec$var$checkAndParseOp(proof.ops[1], "ics23:simple", (0, $6XcLW.toAscii)(store));
        return {
            key: key,
            value: value,
            height: height,
            // need to clone this: readonly input / writeable output
            proof: {
                ops: [
                    ...proof.ops
                ]
            }
        };
    }
    /**
     * Performs an ABCI query to Tendermint without requesting a proof.
     *
     * If the `desiredHeight` is set, a particular height is requested. Otherwise
     * the latest height is requested. The response contains the actual height of
     * the query.
     */ async queryAbci(path, request, desiredHeight) {
        const response = await this.tmClient.abciQuery({
            path: path,
            data: request,
            prove: false,
            height: desiredHeight
        });
        if (response.code) throw new Error(`Query failed with (${response.code}): ${response.log}`);
        if (!response.height) throw new Error("No query height returned");
        return {
            value: response.value,
            height: response.height
        };
    }
    // this must return the header for height+1
    // throws an error if height is 0 or undefined
    async getNextHeader(height) {
        (0, $fZwG5.assertDefined)(height);
        if (height === 0) throw new Error("Query returned height 0, cannot prove it");
        const searchHeight = height + 1;
        let nextHeader;
        let headersSubscription;
        try {
            headersSubscription = this.tmClient.subscribeNewBlockHeader();
        } catch  {
        // Ignore exception caused by non-WebSocket Tendermint clients
        }
        if (headersSubscription) {
            const firstHeader = await (0, $8iJvX.firstEvent)(headersSubscription);
            // The first header we get might not be n+1 but n+2 or even higher. In such cases we fall back on a query.
            if (firstHeader.height === searchHeight) nextHeader = firstHeader;
        }
        while(!nextHeader){
            // start from current height to avoid backend error for minHeight in the future
            const correctHeader = (await this.tmClient.blockchain(height, searchHeight)).blockMetas.map((meta)=>meta.header).find((h)=>h.height === searchHeight);
            if (correctHeader) nextHeader = correctHeader;
            else await (0, $fZwG5.sleep)(1000);
        }
        (0, $fZwG5.assert)(nextHeader.height === searchHeight, "Got wrong header. This is a bug in the logic above.");
        return nextHeader;
    }
}
$c72059c029acecec$exports.QueryClient = $c72059c029acecec$var$QueryClient;


Object.defineProperty($a3959936d2cce854$exports, "QueryClient", {
    enumerable: true,
    get: function() {
        return $c72059c029acecec$exports.QueryClient;
    }
});
var $24b0070180bb6753$exports = {};
"use strict";
var $24b0070180bb6753$var$__importDefault = $24b0070180bb6753$exports && $24b0070180bb6753$exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty($24b0070180bb6753$exports, "__esModule", {
    value: true
});
$24b0070180bb6753$exports.decodeCosmosSdkDecFromProto = $24b0070180bb6753$exports.longify = $24b0070180bb6753$exports.createProtobufRpcClient = $24b0070180bb6753$exports.createPagination = $24b0070180bb6753$exports.toAccAddress = void 0;

var $6XcLW = parcelRequire("6XcLW");

var $7UsfE = parcelRequire("7UsfE");


const $24b0070180bb6753$var$long_1 = $24b0070180bb6753$var$__importDefault((parcelRequire("jRkuS")));
/**
 * Takes a bech32 encoded address and returns the data part. The prefix is ignored and discarded.
 * This is called AccAddress in Cosmos SDK, which is basically an alias for raw binary data.
 * The result is typically 20 bytes long but not restricted to that.
 */ function $24b0070180bb6753$var$toAccAddress(address) {
    return (0, $6XcLW.fromBech32)(address).data;
}
$24b0070180bb6753$exports.toAccAddress = $24b0070180bb6753$var$toAccAddress;
/**
 * If paginationKey is set, return a `PageRequest` with the given key.
 * If paginationKey is unset, return `undefined`.
 *
 * Use this with a query response's pagination next key to
 * request the next page.
 */ function $24b0070180bb6753$var$createPagination(paginationKey) {
    return paginationKey ? $5eae5f3cc99e92ab$exports.PageRequest.fromPartial({
        key: paginationKey
    }) : undefined;
}
$24b0070180bb6753$exports.createPagination = $24b0070180bb6753$var$createPagination;
function $24b0070180bb6753$var$createProtobufRpcClient(base) {
    return {
        request: async (service, method, data)=>{
            const path = `/${service}/${method}`;
            const response = await base.queryAbci(path, data, undefined);
            return response.value;
        }
    };
}
$24b0070180bb6753$exports.createProtobufRpcClient = $24b0070180bb6753$var$createProtobufRpcClient;
/**
 * Takes a uint64 value as string, number, Long or Uint64 and returns an unsigned Long instance
 * of it.
 */ function $24b0070180bb6753$var$longify(value) {
    const checkedValue = $7UsfE.Uint64.fromString(value.toString());
    return $24b0070180bb6753$var$long_1.default.fromBytesBE([
        ...checkedValue.toBytesBigEndian()
    ], true);
}
$24b0070180bb6753$exports.longify = $24b0070180bb6753$var$longify;
/**
 * Takes a string or binary encoded `github.com/cosmos/cosmos-sdk/types.Dec` from the
 * protobuf API and converts it into a `Decimal` with 18 fractional digits.
 *
 * See https://github.com/cosmos/cosmos-sdk/issues/10863 for more context why this is needed.
 */ function $24b0070180bb6753$var$decodeCosmosSdkDecFromProto(input) {
    const asString = typeof input === "string" ? input : (0, $6XcLW.fromAscii)(input);
    return $7UsfE.Decimal.fromAtomics(asString, 18);
}
$24b0070180bb6753$exports.decodeCosmosSdkDecFromProto = $24b0070180bb6753$var$decodeCosmosSdkDecFromProto;


Object.defineProperty($a3959936d2cce854$exports, "createPagination", {
    enumerable: true,
    get: function() {
        return $24b0070180bb6753$exports.createPagination;
    }
});
Object.defineProperty($a3959936d2cce854$exports, "createProtobufRpcClient", {
    enumerable: true,
    get: function() {
        return $24b0070180bb6753$exports.createProtobufRpcClient;
    }
});
Object.defineProperty($a3959936d2cce854$exports, "decodeCosmosSdkDecFromProto", {
    enumerable: true,
    get: function() {
        return $24b0070180bb6753$exports.decodeCosmosSdkDecFromProto;
    }
});
Object.defineProperty($a3959936d2cce854$exports, "longify", {
    enumerable: true,
    get: function() {
        return $24b0070180bb6753$exports.longify;
    }
});


function $cfd768647aeb9448$var$setupAuthExtension(base) {
    const rpc = (0, $a3959936d2cce854$exports.createProtobufRpcClient)(base);
    // Use this service to get easy typed access to query methods
    // This cannot be used for proof verification
    const queryService = new $c4e0f03afcc1bc46$exports.QueryClientImpl(rpc);
    return {
        auth: {
            account: async (address)=>{
                const { account: account } = await queryService.Account({
                    address: address
                });
                return account ?? null;
            }
        }
    };
}
$cfd768647aeb9448$exports.setupAuthExtension = $cfd768647aeb9448$var$setupAuthExtension;


Object.defineProperty($d0d8b6f4712acd9f$exports, "setupAuthExtension", {
    enumerable: true,
    get: function() {
        return $cfd768647aeb9448$exports.setupAuthExtension;
    }
});
var $32bcbd4bae8c9467$exports = {};
"use strict";
Object.defineProperty($32bcbd4bae8c9467$exports, "__esModule", {
    value: true
});
$32bcbd4bae8c9467$exports.createAuthzAminoConverters = void 0;
function $32bcbd4bae8c9467$var$createAuthzAminoConverters() {
    return {
    };
}
$32bcbd4bae8c9467$exports.createAuthzAminoConverters = $32bcbd4bae8c9467$var$createAuthzAminoConverters;


Object.defineProperty($d0d8b6f4712acd9f$exports, "createAuthzAminoConverters", {
    enumerable: true,
    get: function() {
        return $32bcbd4bae8c9467$exports.createAuthzAminoConverters;
    }
});
var $963d4e70e3506c83$exports = {};
"use strict";
Object.defineProperty($963d4e70e3506c83$exports, "__esModule", {
    value: true
});
$963d4e70e3506c83$exports.authzTypes = void 0;
var $aad6106f2712b18b$exports = {};
"use strict";
var $aad6106f2712b18b$var$__createBinding = $aad6106f2712b18b$exports && $aad6106f2712b18b$exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $aad6106f2712b18b$var$__setModuleDefault = $aad6106f2712b18b$exports && $aad6106f2712b18b$exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $aad6106f2712b18b$var$__importStar = $aad6106f2712b18b$exports && $aad6106f2712b18b$exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $aad6106f2712b18b$var$__createBinding(result, mod, k);
    }
    $aad6106f2712b18b$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty($aad6106f2712b18b$exports, "__esModule", {
    value: true
});
$aad6106f2712b18b$exports.MsgClientImpl = $aad6106f2712b18b$exports.MsgRevokeResponse = $aad6106f2712b18b$exports.MsgRevoke = $aad6106f2712b18b$exports.MsgGrantResponse = $aad6106f2712b18b$exports.MsgExec = $aad6106f2712b18b$exports.MsgExecResponse = $aad6106f2712b18b$exports.MsgGrant = $aad6106f2712b18b$exports.protobufPackage = void 0;
var $ca2ae5ae7d8767c5$exports = {};
"use strict";
var $ca2ae5ae7d8767c5$var$__createBinding = $ca2ae5ae7d8767c5$exports && $ca2ae5ae7d8767c5$exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $ca2ae5ae7d8767c5$var$__setModuleDefault = $ca2ae5ae7d8767c5$exports && $ca2ae5ae7d8767c5$exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $ca2ae5ae7d8767c5$var$__importStar = $ca2ae5ae7d8767c5$exports && $ca2ae5ae7d8767c5$exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $ca2ae5ae7d8767c5$var$__createBinding(result, mod, k);
    }
    $ca2ae5ae7d8767c5$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty($ca2ae5ae7d8767c5$exports, "__esModule", {
    value: true
});
$ca2ae5ae7d8767c5$exports.GrantQueueItem = $ca2ae5ae7d8767c5$exports.GrantAuthorization = $ca2ae5ae7d8767c5$exports.Grant = $ca2ae5ae7d8767c5$exports.GenericAuthorization = $ca2ae5ae7d8767c5$exports.protobufPackage = void 0;

var $e7eaeedc85b414fc$exports = {};
"use strict";
var $e7eaeedc85b414fc$var$__createBinding = $e7eaeedc85b414fc$exports && $e7eaeedc85b414fc$exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $e7eaeedc85b414fc$var$__setModuleDefault = $e7eaeedc85b414fc$exports && $e7eaeedc85b414fc$exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $e7eaeedc85b414fc$var$__importStar = $e7eaeedc85b414fc$exports && $e7eaeedc85b414fc$exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $e7eaeedc85b414fc$var$__createBinding(result, mod, k);
    }
    $e7eaeedc85b414fc$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty($e7eaeedc85b414fc$exports, "__esModule", {
    value: true
});
$e7eaeedc85b414fc$exports.Timestamp = $e7eaeedc85b414fc$exports.protobufPackage = void 0;


const $e7eaeedc85b414fc$var$_m0 = $e7eaeedc85b414fc$var$__importStar((parcelRequire("fQBv0")));
$e7eaeedc85b414fc$exports.protobufPackage = "google.protobuf";
function $e7eaeedc85b414fc$var$createBaseTimestamp() {
    return {
        seconds: $d5e07fe2518aae94$exports.Long.ZERO,
        nanos: 0
    };
}
$e7eaeedc85b414fc$exports.Timestamp = {
    encode (message, writer = $e7eaeedc85b414fc$var$_m0.Writer.create()) {
        if (!message.seconds.isZero()) writer.uint32(8).int64(message.seconds);
        if (message.nanos !== 0) writer.uint32(16).int32(message.nanos);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $e7eaeedc85b414fc$var$_m0.Reader ? input : new $e7eaeedc85b414fc$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $e7eaeedc85b414fc$var$createBaseTimestamp();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.seconds = reader.int64();
                    break;
                case 2:
                    message.nanos = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            seconds: (0, $d5e07fe2518aae94$exports.isSet)(object.seconds) ? $d5e07fe2518aae94$exports.Long.fromValue(object.seconds) : $d5e07fe2518aae94$exports.Long.ZERO,
            nanos: (0, $d5e07fe2518aae94$exports.isSet)(object.nanos) ? Number(object.nanos) : 0
        };
    },
    toJSON (message) {
        const obj = {};
        message.seconds !== undefined && (obj.seconds = (message.seconds || $d5e07fe2518aae94$exports.Long.ZERO).toString());
        message.nanos !== undefined && (obj.nanos = Math.round(message.nanos));
        return obj;
    },
    fromPartial (object) {
        const message = $e7eaeedc85b414fc$var$createBaseTimestamp();
        message.seconds = object.seconds !== undefined && object.seconds !== null ? $d5e07fe2518aae94$exports.Long.fromValue(object.seconds) : $d5e07fe2518aae94$exports.Long.ZERO;
        message.nanos = object.nanos ?? 0;
        return message;
    }
};



const $ca2ae5ae7d8767c5$var$_m0 = $ca2ae5ae7d8767c5$var$__importStar((parcelRequire("fQBv0")));

$ca2ae5ae7d8767c5$exports.protobufPackage = "cosmos.authz.v1beta1";
function $ca2ae5ae7d8767c5$var$createBaseGenericAuthorization() {
    return {
        msg: ""
    };
}
$ca2ae5ae7d8767c5$exports.GenericAuthorization = {
    encode (message, writer = $ca2ae5ae7d8767c5$var$_m0.Writer.create()) {
        if (message.msg !== "") writer.uint32(10).string(message.msg);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $ca2ae5ae7d8767c5$var$_m0.Reader ? input : new $ca2ae5ae7d8767c5$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $ca2ae5ae7d8767c5$var$createBaseGenericAuthorization();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.msg = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            msg: (0, $d5e07fe2518aae94$exports.isSet)(object.msg) ? String(object.msg) : ""
        };
    },
    toJSON (message) {
        const obj = {};
        message.msg !== undefined && (obj.msg = message.msg);
        return obj;
    },
    fromPartial (object) {
        const message = $ca2ae5ae7d8767c5$var$createBaseGenericAuthorization();
        message.msg = object.msg ?? "";
        return message;
    }
};
function $ca2ae5ae7d8767c5$var$createBaseGrant() {
    return {
        authorization: undefined,
        expiration: undefined
    };
}
$ca2ae5ae7d8767c5$exports.Grant = {
    encode (message, writer = $ca2ae5ae7d8767c5$var$_m0.Writer.create()) {
        if (message.authorization !== undefined) $64138e590dcf0cc1$exports.Any.encode(message.authorization, writer.uint32(10).fork()).ldelim();
        if (message.expiration !== undefined) $e7eaeedc85b414fc$exports.Timestamp.encode(message.expiration, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $ca2ae5ae7d8767c5$var$_m0.Reader ? input : new $ca2ae5ae7d8767c5$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $ca2ae5ae7d8767c5$var$createBaseGrant();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.authorization = $64138e590dcf0cc1$exports.Any.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.expiration = $e7eaeedc85b414fc$exports.Timestamp.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            authorization: (0, $d5e07fe2518aae94$exports.isSet)(object.authorization) ? $64138e590dcf0cc1$exports.Any.fromJSON(object.authorization) : undefined,
            expiration: (0, $d5e07fe2518aae94$exports.isSet)(object.expiration) ? (0, $d5e07fe2518aae94$exports.fromJsonTimestamp)(object.expiration) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.authorization !== undefined && (obj.authorization = message.authorization ? $64138e590dcf0cc1$exports.Any.toJSON(message.authorization) : undefined);
        message.expiration !== undefined && (obj.expiration = (0, $d5e07fe2518aae94$exports.fromTimestamp)(message.expiration).toISOString());
        return obj;
    },
    fromPartial (object) {
        const message = $ca2ae5ae7d8767c5$var$createBaseGrant();
        message.authorization = object.authorization !== undefined && object.authorization !== null ? $64138e590dcf0cc1$exports.Any.fromPartial(object.authorization) : undefined;
        message.expiration = object.expiration !== undefined && object.expiration !== null ? $e7eaeedc85b414fc$exports.Timestamp.fromPartial(object.expiration) : undefined;
        return message;
    }
};
function $ca2ae5ae7d8767c5$var$createBaseGrantAuthorization() {
    return {
        granter: "",
        grantee: "",
        authorization: undefined,
        expiration: undefined
    };
}
$ca2ae5ae7d8767c5$exports.GrantAuthorization = {
    encode (message, writer = $ca2ae5ae7d8767c5$var$_m0.Writer.create()) {
        if (message.granter !== "") writer.uint32(10).string(message.granter);
        if (message.grantee !== "") writer.uint32(18).string(message.grantee);
        if (message.authorization !== undefined) $64138e590dcf0cc1$exports.Any.encode(message.authorization, writer.uint32(26).fork()).ldelim();
        if (message.expiration !== undefined) $e7eaeedc85b414fc$exports.Timestamp.encode(message.expiration, writer.uint32(34).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $ca2ae5ae7d8767c5$var$_m0.Reader ? input : new $ca2ae5ae7d8767c5$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $ca2ae5ae7d8767c5$var$createBaseGrantAuthorization();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.granter = reader.string();
                    break;
                case 2:
                    message.grantee = reader.string();
                    break;
                case 3:
                    message.authorization = $64138e590dcf0cc1$exports.Any.decode(reader, reader.uint32());
                    break;
                case 4:
                    message.expiration = $e7eaeedc85b414fc$exports.Timestamp.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            granter: (0, $d5e07fe2518aae94$exports.isSet)(object.granter) ? String(object.granter) : "",
            grantee: (0, $d5e07fe2518aae94$exports.isSet)(object.grantee) ? String(object.grantee) : "",
            authorization: (0, $d5e07fe2518aae94$exports.isSet)(object.authorization) ? $64138e590dcf0cc1$exports.Any.fromJSON(object.authorization) : undefined,
            expiration: (0, $d5e07fe2518aae94$exports.isSet)(object.expiration) ? (0, $d5e07fe2518aae94$exports.fromJsonTimestamp)(object.expiration) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.granter !== undefined && (obj.granter = message.granter);
        message.grantee !== undefined && (obj.grantee = message.grantee);
        message.authorization !== undefined && (obj.authorization = message.authorization ? $64138e590dcf0cc1$exports.Any.toJSON(message.authorization) : undefined);
        message.expiration !== undefined && (obj.expiration = (0, $d5e07fe2518aae94$exports.fromTimestamp)(message.expiration).toISOString());
        return obj;
    },
    fromPartial (object) {
        const message = $ca2ae5ae7d8767c5$var$createBaseGrantAuthorization();
        message.granter = object.granter ?? "";
        message.grantee = object.grantee ?? "";
        message.authorization = object.authorization !== undefined && object.authorization !== null ? $64138e590dcf0cc1$exports.Any.fromPartial(object.authorization) : undefined;
        message.expiration = object.expiration !== undefined && object.expiration !== null ? $e7eaeedc85b414fc$exports.Timestamp.fromPartial(object.expiration) : undefined;
        return message;
    }
};
function $ca2ae5ae7d8767c5$var$createBaseGrantQueueItem() {
    return {
        msgTypeUrls: []
    };
}
$ca2ae5ae7d8767c5$exports.GrantQueueItem = {
    encode (message, writer = $ca2ae5ae7d8767c5$var$_m0.Writer.create()) {
        for (const v of message.msgTypeUrls)writer.uint32(10).string(v);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $ca2ae5ae7d8767c5$var$_m0.Reader ? input : new $ca2ae5ae7d8767c5$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $ca2ae5ae7d8767c5$var$createBaseGrantQueueItem();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.msgTypeUrls.push(reader.string());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            msgTypeUrls: Array.isArray(object?.msgTypeUrls) ? object.msgTypeUrls.map((e)=>String(e)) : []
        };
    },
    toJSON (message) {
        const obj = {};
        if (message.msgTypeUrls) obj.msgTypeUrls = message.msgTypeUrls.map((e)=>e);
        else obj.msgTypeUrls = [];
        return obj;
    },
    fromPartial (object) {
        const message = $ca2ae5ae7d8767c5$var$createBaseGrantQueueItem();
        message.msgTypeUrls = object.msgTypeUrls?.map((e)=>e) || [];
        return message;
    }
};




const $aad6106f2712b18b$var$_m0 = $aad6106f2712b18b$var$__importStar((parcelRequire("fQBv0")));

$aad6106f2712b18b$exports.protobufPackage = "cosmos.authz.v1beta1";
function $aad6106f2712b18b$var$createBaseMsgGrant() {
    return {
        granter: "",
        grantee: "",
        grant: undefined
    };
}
$aad6106f2712b18b$exports.MsgGrant = {
    encode (message, writer = $aad6106f2712b18b$var$_m0.Writer.create()) {
        if (message.granter !== "") writer.uint32(10).string(message.granter);
        if (message.grantee !== "") writer.uint32(18).string(message.grantee);
        if (message.grant !== undefined) $ca2ae5ae7d8767c5$exports.Grant.encode(message.grant, writer.uint32(26).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $aad6106f2712b18b$var$_m0.Reader ? input : new $aad6106f2712b18b$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $aad6106f2712b18b$var$createBaseMsgGrant();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.granter = reader.string();
                    break;
                case 2:
                    message.grantee = reader.string();
                    break;
                case 3:
                    message.grant = $ca2ae5ae7d8767c5$exports.Grant.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            granter: (0, $d5e07fe2518aae94$exports.isSet)(object.granter) ? String(object.granter) : "",
            grantee: (0, $d5e07fe2518aae94$exports.isSet)(object.grantee) ? String(object.grantee) : "",
            grant: (0, $d5e07fe2518aae94$exports.isSet)(object.grant) ? $ca2ae5ae7d8767c5$exports.Grant.fromJSON(object.grant) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.granter !== undefined && (obj.granter = message.granter);
        message.grantee !== undefined && (obj.grantee = message.grantee);
        message.grant !== undefined && (obj.grant = message.grant ? $ca2ae5ae7d8767c5$exports.Grant.toJSON(message.grant) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $aad6106f2712b18b$var$createBaseMsgGrant();
        message.granter = object.granter ?? "";
        message.grantee = object.grantee ?? "";
        message.grant = object.grant !== undefined && object.grant !== null ? $ca2ae5ae7d8767c5$exports.Grant.fromPartial(object.grant) : undefined;
        return message;
    }
};
function $aad6106f2712b18b$var$createBaseMsgExecResponse() {
    return {
        results: []
    };
}
$aad6106f2712b18b$exports.MsgExecResponse = {
    encode (message, writer = $aad6106f2712b18b$var$_m0.Writer.create()) {
        for (const v of message.results)writer.uint32(10).bytes(v);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $aad6106f2712b18b$var$_m0.Reader ? input : new $aad6106f2712b18b$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $aad6106f2712b18b$var$createBaseMsgExecResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.results.push(reader.bytes());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            results: Array.isArray(object?.results) ? object.results.map((e)=>(0, $d5e07fe2518aae94$exports.bytesFromBase64)(e)) : []
        };
    },
    toJSON (message) {
        const obj = {};
        if (message.results) obj.results = message.results.map((e)=>(0, $d5e07fe2518aae94$exports.base64FromBytes)(e !== undefined ? e : new Uint8Array()));
        else obj.results = [];
        return obj;
    },
    fromPartial (object) {
        const message = $aad6106f2712b18b$var$createBaseMsgExecResponse();
        message.results = object.results?.map((e)=>e) || [];
        return message;
    }
};
function $aad6106f2712b18b$var$createBaseMsgExec() {
    return {
        grantee: "",
        msgs: []
    };
}
$aad6106f2712b18b$exports.MsgExec = {
    encode (message, writer = $aad6106f2712b18b$var$_m0.Writer.create()) {
        if (message.grantee !== "") writer.uint32(10).string(message.grantee);
        for (const v of message.msgs)$64138e590dcf0cc1$exports.Any.encode(v, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $aad6106f2712b18b$var$_m0.Reader ? input : new $aad6106f2712b18b$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $aad6106f2712b18b$var$createBaseMsgExec();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.grantee = reader.string();
                    break;
                case 2:
                    message.msgs.push($64138e590dcf0cc1$exports.Any.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            grantee: (0, $d5e07fe2518aae94$exports.isSet)(object.grantee) ? String(object.grantee) : "",
            msgs: Array.isArray(object?.msgs) ? object.msgs.map((e)=>$64138e590dcf0cc1$exports.Any.fromJSON(e)) : []
        };
    },
    toJSON (message) {
        const obj = {};
        message.grantee !== undefined && (obj.grantee = message.grantee);
        if (message.msgs) obj.msgs = message.msgs.map((e)=>e ? $64138e590dcf0cc1$exports.Any.toJSON(e) : undefined);
        else obj.msgs = [];
        return obj;
    },
    fromPartial (object) {
        const message = $aad6106f2712b18b$var$createBaseMsgExec();
        message.grantee = object.grantee ?? "";
        message.msgs = object.msgs?.map((e)=>$64138e590dcf0cc1$exports.Any.fromPartial(e)) || [];
        return message;
    }
};
function $aad6106f2712b18b$var$createBaseMsgGrantResponse() {
    return {};
}
$aad6106f2712b18b$exports.MsgGrantResponse = {
    encode (_, writer = $aad6106f2712b18b$var$_m0.Writer.create()) {
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $aad6106f2712b18b$var$_m0.Reader ? input : new $aad6106f2712b18b$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $aad6106f2712b18b$var$createBaseMsgGrantResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            tag;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON (_) {
        return {};
    },
    toJSON (_) {
        const obj = {};
        return obj;
    },
    fromPartial (_) {
        const message = $aad6106f2712b18b$var$createBaseMsgGrantResponse();
        return message;
    }
};
function $aad6106f2712b18b$var$createBaseMsgRevoke() {
    return {
        granter: "",
        grantee: "",
        msgTypeUrl: ""
    };
}
$aad6106f2712b18b$exports.MsgRevoke = {
    encode (message, writer = $aad6106f2712b18b$var$_m0.Writer.create()) {
        if (message.granter !== "") writer.uint32(10).string(message.granter);
        if (message.grantee !== "") writer.uint32(18).string(message.grantee);
        if (message.msgTypeUrl !== "") writer.uint32(26).string(message.msgTypeUrl);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $aad6106f2712b18b$var$_m0.Reader ? input : new $aad6106f2712b18b$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $aad6106f2712b18b$var$createBaseMsgRevoke();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.granter = reader.string();
                    break;
                case 2:
                    message.grantee = reader.string();
                    break;
                case 3:
                    message.msgTypeUrl = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            granter: (0, $d5e07fe2518aae94$exports.isSet)(object.granter) ? String(object.granter) : "",
            grantee: (0, $d5e07fe2518aae94$exports.isSet)(object.grantee) ? String(object.grantee) : "",
            msgTypeUrl: (0, $d5e07fe2518aae94$exports.isSet)(object.msgTypeUrl) ? String(object.msgTypeUrl) : ""
        };
    },
    toJSON (message) {
        const obj = {};
        message.granter !== undefined && (obj.granter = message.granter);
        message.grantee !== undefined && (obj.grantee = message.grantee);
        message.msgTypeUrl !== undefined && (obj.msgTypeUrl = message.msgTypeUrl);
        return obj;
    },
    fromPartial (object) {
        const message = $aad6106f2712b18b$var$createBaseMsgRevoke();
        message.granter = object.granter ?? "";
        message.grantee = object.grantee ?? "";
        message.msgTypeUrl = object.msgTypeUrl ?? "";
        return message;
    }
};
function $aad6106f2712b18b$var$createBaseMsgRevokeResponse() {
    return {};
}
$aad6106f2712b18b$exports.MsgRevokeResponse = {
    encode (_, writer = $aad6106f2712b18b$var$_m0.Writer.create()) {
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $aad6106f2712b18b$var$_m0.Reader ? input : new $aad6106f2712b18b$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $aad6106f2712b18b$var$createBaseMsgRevokeResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            tag;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON (_) {
        return {};
    },
    toJSON (_) {
        const obj = {};
        return obj;
    },
    fromPartial (_) {
        const message = $aad6106f2712b18b$var$createBaseMsgRevokeResponse();
        return message;
    }
};
class $aad6106f2712b18b$var$MsgClientImpl {
    constructor(rpc){
        this.rpc = rpc;
        this.Grant = this.Grant.bind(this);
        this.Exec = this.Exec.bind(this);
        this.Revoke = this.Revoke.bind(this);
    }
    Grant(request) {
        const data = $aad6106f2712b18b$exports.MsgGrant.encode(request).finish();
        const promise = this.rpc.request("cosmos.authz.v1beta1.Msg", "Grant", data);
        return promise.then((data)=>$aad6106f2712b18b$exports.MsgGrantResponse.decode(new $aad6106f2712b18b$var$_m0.Reader(data)));
    }
    Exec(request) {
        const data = $aad6106f2712b18b$exports.MsgExec.encode(request).finish();
        const promise = this.rpc.request("cosmos.authz.v1beta1.Msg", "Exec", data);
        return promise.then((data)=>$aad6106f2712b18b$exports.MsgExecResponse.decode(new $aad6106f2712b18b$var$_m0.Reader(data)));
    }
    Revoke(request) {
        const data = $aad6106f2712b18b$exports.MsgRevoke.encode(request).finish();
        const promise = this.rpc.request("cosmos.authz.v1beta1.Msg", "Revoke", data);
        return promise.then((data)=>$aad6106f2712b18b$exports.MsgRevokeResponse.decode(new $aad6106f2712b18b$var$_m0.Reader(data)));
    }
}
$aad6106f2712b18b$exports.MsgClientImpl = $aad6106f2712b18b$var$MsgClientImpl;


$963d4e70e3506c83$exports.authzTypes = [
    [
        "/cosmos.authz.v1beta1.MsgExec",
        $aad6106f2712b18b$exports.MsgExec
    ],
    [
        "/cosmos.authz.v1beta1.MsgGrant",
        $aad6106f2712b18b$exports.MsgGrant
    ],
    [
        "/cosmos.authz.v1beta1.MsgRevoke",
        $aad6106f2712b18b$exports.MsgRevoke
    ]
];


Object.defineProperty($d0d8b6f4712acd9f$exports, "authzTypes", {
    enumerable: true,
    get: function() {
        return $963d4e70e3506c83$exports.authzTypes;
    }
});
var $d02ec73e6025f7c7$exports = {};
"use strict";
Object.defineProperty($d02ec73e6025f7c7$exports, "__esModule", {
    value: true
});
$d02ec73e6025f7c7$exports.setupAuthzExtension = void 0;
var $989b5e405af33c96$exports = {};
"use strict";
var $989b5e405af33c96$var$__createBinding = $989b5e405af33c96$exports && $989b5e405af33c96$exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $989b5e405af33c96$var$__setModuleDefault = $989b5e405af33c96$exports && $989b5e405af33c96$exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $989b5e405af33c96$var$__importStar = $989b5e405af33c96$exports && $989b5e405af33c96$exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $989b5e405af33c96$var$__createBinding(result, mod, k);
    }
    $989b5e405af33c96$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty($989b5e405af33c96$exports, "__esModule", {
    value: true
});
$989b5e405af33c96$exports.QueryClientImpl = $989b5e405af33c96$exports.QueryGranteeGrantsResponse = $989b5e405af33c96$exports.QueryGranteeGrantsRequest = $989b5e405af33c96$exports.QueryGranterGrantsResponse = $989b5e405af33c96$exports.QueryGranterGrantsRequest = $989b5e405af33c96$exports.QueryGrantsResponse = $989b5e405af33c96$exports.QueryGrantsRequest = $989b5e405af33c96$exports.protobufPackage = void 0;



const $989b5e405af33c96$var$_m0 = $989b5e405af33c96$var$__importStar((parcelRequire("fQBv0")));

$989b5e405af33c96$exports.protobufPackage = "cosmos.authz.v1beta1";
function $989b5e405af33c96$var$createBaseQueryGrantsRequest() {
    return {
        granter: "",
        grantee: "",
        msgTypeUrl: "",
        pagination: undefined
    };
}
$989b5e405af33c96$exports.QueryGrantsRequest = {
    encode (message, writer = $989b5e405af33c96$var$_m0.Writer.create()) {
        if (message.granter !== "") writer.uint32(10).string(message.granter);
        if (message.grantee !== "") writer.uint32(18).string(message.grantee);
        if (message.msgTypeUrl !== "") writer.uint32(26).string(message.msgTypeUrl);
        if (message.pagination !== undefined) $5eae5f3cc99e92ab$exports.PageRequest.encode(message.pagination, writer.uint32(34).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $989b5e405af33c96$var$_m0.Reader ? input : new $989b5e405af33c96$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $989b5e405af33c96$var$createBaseQueryGrantsRequest();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.granter = reader.string();
                    break;
                case 2:
                    message.grantee = reader.string();
                    break;
                case 3:
                    message.msgTypeUrl = reader.string();
                    break;
                case 4:
                    message.pagination = $5eae5f3cc99e92ab$exports.PageRequest.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            granter: (0, $d5e07fe2518aae94$exports.isSet)(object.granter) ? String(object.granter) : "",
            grantee: (0, $d5e07fe2518aae94$exports.isSet)(object.grantee) ? String(object.grantee) : "",
            msgTypeUrl: (0, $d5e07fe2518aae94$exports.isSet)(object.msgTypeUrl) ? String(object.msgTypeUrl) : "",
            pagination: (0, $d5e07fe2518aae94$exports.isSet)(object.pagination) ? $5eae5f3cc99e92ab$exports.PageRequest.fromJSON(object.pagination) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.granter !== undefined && (obj.granter = message.granter);
        message.grantee !== undefined && (obj.grantee = message.grantee);
        message.msgTypeUrl !== undefined && (obj.msgTypeUrl = message.msgTypeUrl);
        message.pagination !== undefined && (obj.pagination = message.pagination ? $5eae5f3cc99e92ab$exports.PageRequest.toJSON(message.pagination) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $989b5e405af33c96$var$createBaseQueryGrantsRequest();
        message.granter = object.granter ?? "";
        message.grantee = object.grantee ?? "";
        message.msgTypeUrl = object.msgTypeUrl ?? "";
        message.pagination = object.pagination !== undefined && object.pagination !== null ? $5eae5f3cc99e92ab$exports.PageRequest.fromPartial(object.pagination) : undefined;
        return message;
    }
};
function $989b5e405af33c96$var$createBaseQueryGrantsResponse() {
    return {
        grants: [],
        pagination: undefined
    };
}
$989b5e405af33c96$exports.QueryGrantsResponse = {
    encode (message, writer = $989b5e405af33c96$var$_m0.Writer.create()) {
        for (const v of message.grants)$ca2ae5ae7d8767c5$exports.Grant.encode(v, writer.uint32(10).fork()).ldelim();
        if (message.pagination !== undefined) $5eae5f3cc99e92ab$exports.PageResponse.encode(message.pagination, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $989b5e405af33c96$var$_m0.Reader ? input : new $989b5e405af33c96$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $989b5e405af33c96$var$createBaseQueryGrantsResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.grants.push($ca2ae5ae7d8767c5$exports.Grant.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.pagination = $5eae5f3cc99e92ab$exports.PageResponse.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            grants: Array.isArray(object?.grants) ? object.grants.map((e)=>$ca2ae5ae7d8767c5$exports.Grant.fromJSON(e)) : [],
            pagination: (0, $d5e07fe2518aae94$exports.isSet)(object.pagination) ? $5eae5f3cc99e92ab$exports.PageResponse.fromJSON(object.pagination) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        if (message.grants) obj.grants = message.grants.map((e)=>e ? $ca2ae5ae7d8767c5$exports.Grant.toJSON(e) : undefined);
        else obj.grants = [];
        message.pagination !== undefined && (obj.pagination = message.pagination ? $5eae5f3cc99e92ab$exports.PageResponse.toJSON(message.pagination) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $989b5e405af33c96$var$createBaseQueryGrantsResponse();
        message.grants = object.grants?.map((e)=>$ca2ae5ae7d8767c5$exports.Grant.fromPartial(e)) || [];
        message.pagination = object.pagination !== undefined && object.pagination !== null ? $5eae5f3cc99e92ab$exports.PageResponse.fromPartial(object.pagination) : undefined;
        return message;
    }
};
function $989b5e405af33c96$var$createBaseQueryGranterGrantsRequest() {
    return {
        granter: "",
        pagination: undefined
    };
}
$989b5e405af33c96$exports.QueryGranterGrantsRequest = {
    encode (message, writer = $989b5e405af33c96$var$_m0.Writer.create()) {
        if (message.granter !== "") writer.uint32(10).string(message.granter);
        if (message.pagination !== undefined) $5eae5f3cc99e92ab$exports.PageRequest.encode(message.pagination, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $989b5e405af33c96$var$_m0.Reader ? input : new $989b5e405af33c96$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $989b5e405af33c96$var$createBaseQueryGranterGrantsRequest();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.granter = reader.string();
                    break;
                case 2:
                    message.pagination = $5eae5f3cc99e92ab$exports.PageRequest.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            granter: (0, $d5e07fe2518aae94$exports.isSet)(object.granter) ? String(object.granter) : "",
            pagination: (0, $d5e07fe2518aae94$exports.isSet)(object.pagination) ? $5eae5f3cc99e92ab$exports.PageRequest.fromJSON(object.pagination) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.granter !== undefined && (obj.granter = message.granter);
        message.pagination !== undefined && (obj.pagination = message.pagination ? $5eae5f3cc99e92ab$exports.PageRequest.toJSON(message.pagination) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $989b5e405af33c96$var$createBaseQueryGranterGrantsRequest();
        message.granter = object.granter ?? "";
        message.pagination = object.pagination !== undefined && object.pagination !== null ? $5eae5f3cc99e92ab$exports.PageRequest.fromPartial(object.pagination) : undefined;
        return message;
    }
};
function $989b5e405af33c96$var$createBaseQueryGranterGrantsResponse() {
    return {
        grants: [],
        pagination: undefined
    };
}
$989b5e405af33c96$exports.QueryGranterGrantsResponse = {
    encode (message, writer = $989b5e405af33c96$var$_m0.Writer.create()) {
        for (const v of message.grants)$ca2ae5ae7d8767c5$exports.GrantAuthorization.encode(v, writer.uint32(10).fork()).ldelim();
        if (message.pagination !== undefined) $5eae5f3cc99e92ab$exports.PageResponse.encode(message.pagination, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $989b5e405af33c96$var$_m0.Reader ? input : new $989b5e405af33c96$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $989b5e405af33c96$var$createBaseQueryGranterGrantsResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.grants.push($ca2ae5ae7d8767c5$exports.GrantAuthorization.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.pagination = $5eae5f3cc99e92ab$exports.PageResponse.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            grants: Array.isArray(object?.grants) ? object.grants.map((e)=>$ca2ae5ae7d8767c5$exports.GrantAuthorization.fromJSON(e)) : [],
            pagination: (0, $d5e07fe2518aae94$exports.isSet)(object.pagination) ? $5eae5f3cc99e92ab$exports.PageResponse.fromJSON(object.pagination) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        if (message.grants) obj.grants = message.grants.map((e)=>e ? $ca2ae5ae7d8767c5$exports.GrantAuthorization.toJSON(e) : undefined);
        else obj.grants = [];
        message.pagination !== undefined && (obj.pagination = message.pagination ? $5eae5f3cc99e92ab$exports.PageResponse.toJSON(message.pagination) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $989b5e405af33c96$var$createBaseQueryGranterGrantsResponse();
        message.grants = object.grants?.map((e)=>$ca2ae5ae7d8767c5$exports.GrantAuthorization.fromPartial(e)) || [];
        message.pagination = object.pagination !== undefined && object.pagination !== null ? $5eae5f3cc99e92ab$exports.PageResponse.fromPartial(object.pagination) : undefined;
        return message;
    }
};
function $989b5e405af33c96$var$createBaseQueryGranteeGrantsRequest() {
    return {
        grantee: "",
        pagination: undefined
    };
}
$989b5e405af33c96$exports.QueryGranteeGrantsRequest = {
    encode (message, writer = $989b5e405af33c96$var$_m0.Writer.create()) {
        if (message.grantee !== "") writer.uint32(10).string(message.grantee);
        if (message.pagination !== undefined) $5eae5f3cc99e92ab$exports.PageRequest.encode(message.pagination, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $989b5e405af33c96$var$_m0.Reader ? input : new $989b5e405af33c96$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $989b5e405af33c96$var$createBaseQueryGranteeGrantsRequest();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.grantee = reader.string();
                    break;
                case 2:
                    message.pagination = $5eae5f3cc99e92ab$exports.PageRequest.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            grantee: (0, $d5e07fe2518aae94$exports.isSet)(object.grantee) ? String(object.grantee) : "",
            pagination: (0, $d5e07fe2518aae94$exports.isSet)(object.pagination) ? $5eae5f3cc99e92ab$exports.PageRequest.fromJSON(object.pagination) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.grantee !== undefined && (obj.grantee = message.grantee);
        message.pagination !== undefined && (obj.pagination = message.pagination ? $5eae5f3cc99e92ab$exports.PageRequest.toJSON(message.pagination) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $989b5e405af33c96$var$createBaseQueryGranteeGrantsRequest();
        message.grantee = object.grantee ?? "";
        message.pagination = object.pagination !== undefined && object.pagination !== null ? $5eae5f3cc99e92ab$exports.PageRequest.fromPartial(object.pagination) : undefined;
        return message;
    }
};
function $989b5e405af33c96$var$createBaseQueryGranteeGrantsResponse() {
    return {
        grants: [],
        pagination: undefined
    };
}
$989b5e405af33c96$exports.QueryGranteeGrantsResponse = {
    encode (message, writer = $989b5e405af33c96$var$_m0.Writer.create()) {
        for (const v of message.grants)$ca2ae5ae7d8767c5$exports.GrantAuthorization.encode(v, writer.uint32(10).fork()).ldelim();
        if (message.pagination !== undefined) $5eae5f3cc99e92ab$exports.PageResponse.encode(message.pagination, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $989b5e405af33c96$var$_m0.Reader ? input : new $989b5e405af33c96$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $989b5e405af33c96$var$createBaseQueryGranteeGrantsResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.grants.push($ca2ae5ae7d8767c5$exports.GrantAuthorization.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.pagination = $5eae5f3cc99e92ab$exports.PageResponse.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            grants: Array.isArray(object?.grants) ? object.grants.map((e)=>$ca2ae5ae7d8767c5$exports.GrantAuthorization.fromJSON(e)) : [],
            pagination: (0, $d5e07fe2518aae94$exports.isSet)(object.pagination) ? $5eae5f3cc99e92ab$exports.PageResponse.fromJSON(object.pagination) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        if (message.grants) obj.grants = message.grants.map((e)=>e ? $ca2ae5ae7d8767c5$exports.GrantAuthorization.toJSON(e) : undefined);
        else obj.grants = [];
        message.pagination !== undefined && (obj.pagination = message.pagination ? $5eae5f3cc99e92ab$exports.PageResponse.toJSON(message.pagination) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $989b5e405af33c96$var$createBaseQueryGranteeGrantsResponse();
        message.grants = object.grants?.map((e)=>$ca2ae5ae7d8767c5$exports.GrantAuthorization.fromPartial(e)) || [];
        message.pagination = object.pagination !== undefined && object.pagination !== null ? $5eae5f3cc99e92ab$exports.PageResponse.fromPartial(object.pagination) : undefined;
        return message;
    }
};
class $989b5e405af33c96$var$QueryClientImpl {
    constructor(rpc){
        this.rpc = rpc;
        this.Grants = this.Grants.bind(this);
        this.GranterGrants = this.GranterGrants.bind(this);
        this.GranteeGrants = this.GranteeGrants.bind(this);
    }
    Grants(request) {
        const data = $989b5e405af33c96$exports.QueryGrantsRequest.encode(request).finish();
        const promise = this.rpc.request("cosmos.authz.v1beta1.Query", "Grants", data);
        return promise.then((data)=>$989b5e405af33c96$exports.QueryGrantsResponse.decode(new $989b5e405af33c96$var$_m0.Reader(data)));
    }
    GranterGrants(request) {
        const data = $989b5e405af33c96$exports.QueryGranterGrantsRequest.encode(request).finish();
        const promise = this.rpc.request("cosmos.authz.v1beta1.Query", "GranterGrants", data);
        return promise.then((data)=>$989b5e405af33c96$exports.QueryGranterGrantsResponse.decode(new $989b5e405af33c96$var$_m0.Reader(data)));
    }
    GranteeGrants(request) {
        const data = $989b5e405af33c96$exports.QueryGranteeGrantsRequest.encode(request).finish();
        const promise = this.rpc.request("cosmos.authz.v1beta1.Query", "GranteeGrants", data);
        return promise.then((data)=>$989b5e405af33c96$exports.QueryGranteeGrantsResponse.decode(new $989b5e405af33c96$var$_m0.Reader(data)));
    }
}
$989b5e405af33c96$exports.QueryClientImpl = $989b5e405af33c96$var$QueryClientImpl;



function $d02ec73e6025f7c7$var$setupAuthzExtension(base) {
    // Use this service to get easy typed access to query methods
    // This cannot be used for proof verification
    const rpc = (0, $a3959936d2cce854$exports.createProtobufRpcClient)(base);
    const queryService = new $989b5e405af33c96$exports.QueryClientImpl(rpc);
    return {
        authz: {
            grants: async (granter, grantee, msgTypeUrl, paginationKey)=>{
                return await queryService.Grants({
                    granter: granter,
                    grantee: grantee,
                    msgTypeUrl: msgTypeUrl,
                    pagination: (0, $a3959936d2cce854$exports.createPagination)(paginationKey)
                });
            },
            granteeGrants: async (grantee, paginationKey)=>{
                return await queryService.GranteeGrants({
                    grantee: grantee,
                    pagination: (0, $a3959936d2cce854$exports.createPagination)(paginationKey)
                });
            },
            granterGrants: async (granter, paginationKey)=>{
                return await queryService.GranterGrants({
                    granter: granter,
                    pagination: (0, $a3959936d2cce854$exports.createPagination)(paginationKey)
                });
            }
        }
    };
}
$d02ec73e6025f7c7$exports.setupAuthzExtension = $d02ec73e6025f7c7$var$setupAuthzExtension;


Object.defineProperty($d0d8b6f4712acd9f$exports, "setupAuthzExtension", {
    enumerable: true,
    get: function() {
        return $d02ec73e6025f7c7$exports.setupAuthzExtension;
    }
});
var $4e39ab634ca06659$exports = {};
"use strict";
Object.defineProperty($4e39ab634ca06659$exports, "__esModule", {
    value: true
});
$4e39ab634ca06659$exports.createBankAminoConverters = $4e39ab634ca06659$exports.isAminoMsgMultiSend = $4e39ab634ca06659$exports.isAminoMsgSend = void 0;
function $4e39ab634ca06659$var$isAminoMsgSend(msg) {
    return msg.type === "cosmos-sdk/MsgSend";
}
$4e39ab634ca06659$exports.isAminoMsgSend = $4e39ab634ca06659$var$isAminoMsgSend;
function $4e39ab634ca06659$var$isAminoMsgMultiSend(msg) {
    return msg.type === "cosmos-sdk/MsgMultiSend";
}
$4e39ab634ca06659$exports.isAminoMsgMultiSend = $4e39ab634ca06659$var$isAminoMsgMultiSend;
function $4e39ab634ca06659$var$createBankAminoConverters() {
    return {
        "/cosmos.bank.v1beta1.MsgSend": {
            aminoType: "cosmos-sdk/MsgSend",
            toAmino: ({ fromAddress: fromAddress, toAddress: toAddress, amount: amount })=>({
                    from_address: fromAddress,
                    to_address: toAddress,
                    amount: [
                        ...amount
                    ]
                }),
            fromAmino: ({ from_address: from_address, to_address: to_address, amount: amount })=>({
                    fromAddress: from_address,
                    toAddress: to_address,
                    amount: [
                        ...amount
                    ]
                })
        },
        "/cosmos.bank.v1beta1.MsgMultiSend": {
            aminoType: "cosmos-sdk/MsgMultiSend",
            toAmino: ({ inputs: inputs, outputs: outputs })=>({
                    inputs: inputs.map((input)=>({
                            address: input.address,
                            coins: [
                                ...input.coins
                            ]
                        })),
                    outputs: outputs.map((output)=>({
                            address: output.address,
                            coins: [
                                ...output.coins
                            ]
                        }))
                }),
            fromAmino: ({ inputs: inputs, outputs: outputs })=>({
                    inputs: inputs.map((input)=>({
                            address: input.address,
                            coins: [
                                ...input.coins
                            ]
                        })),
                    outputs: outputs.map((output)=>({
                            address: output.address,
                            coins: [
                                ...output.coins
                            ]
                        }))
                })
        }
    };
}
$4e39ab634ca06659$exports.createBankAminoConverters = $4e39ab634ca06659$var$createBankAminoConverters;


Object.defineProperty($d0d8b6f4712acd9f$exports, "createBankAminoConverters", {
    enumerable: true,
    get: function() {
        return $4e39ab634ca06659$exports.createBankAminoConverters;
    }
});
Object.defineProperty($d0d8b6f4712acd9f$exports, "isAminoMsgMultiSend", {
    enumerable: true,
    get: function() {
        return $4e39ab634ca06659$exports.isAminoMsgMultiSend;
    }
});
Object.defineProperty($d0d8b6f4712acd9f$exports, "isAminoMsgSend", {
    enumerable: true,
    get: function() {
        return $4e39ab634ca06659$exports.isAminoMsgSend;
    }
});
var $d3697ee1ba37375c$exports = {};
"use strict";
Object.defineProperty($d3697ee1ba37375c$exports, "__esModule", {
    value: true
});
$d3697ee1ba37375c$exports.isMsgSendEncodeObject = $d3697ee1ba37375c$exports.bankTypes = void 0;

$d3697ee1ba37375c$exports.bankTypes = [
    [
        "/cosmos.bank.v1beta1.MsgMultiSend",
        $34c46a888039c4e4$exports.MsgMultiSend
    ],
    [
        "/cosmos.bank.v1beta1.MsgSend",
        $34c46a888039c4e4$exports.MsgSend
    ]
];
function $d3697ee1ba37375c$var$isMsgSendEncodeObject(encodeObject) {
    return encodeObject.typeUrl === "/cosmos.bank.v1beta1.MsgSend";
}
$d3697ee1ba37375c$exports.isMsgSendEncodeObject = $d3697ee1ba37375c$var$isMsgSendEncodeObject;


Object.defineProperty($d0d8b6f4712acd9f$exports, "bankTypes", {
    enumerable: true,
    get: function() {
        return $d3697ee1ba37375c$exports.bankTypes;
    }
});
Object.defineProperty($d0d8b6f4712acd9f$exports, "isMsgSendEncodeObject", {
    enumerable: true,
    get: function() {
        return $d3697ee1ba37375c$exports.isMsgSendEncodeObject;
    }
});
var $46bdb9fe6141f5f3$exports = {};
"use strict";
Object.defineProperty($46bdb9fe6141f5f3$exports, "__esModule", {
    value: true
});
$46bdb9fe6141f5f3$exports.setupBankExtension = void 0;

var $fZwG5 = parcelRequire("fZwG5");
var $c7c3e434b692342b$exports = {};
"use strict";
var $c7c3e434b692342b$var$__createBinding = $c7c3e434b692342b$exports && $c7c3e434b692342b$exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $c7c3e434b692342b$var$__setModuleDefault = $c7c3e434b692342b$exports && $c7c3e434b692342b$exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $c7c3e434b692342b$var$__importStar = $c7c3e434b692342b$exports && $c7c3e434b692342b$exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $c7c3e434b692342b$var$__createBinding(result, mod, k);
    }
    $c7c3e434b692342b$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty($c7c3e434b692342b$exports, "__esModule", {
    value: true
});
$c7c3e434b692342b$exports.QueryClientImpl = $c7c3e434b692342b$exports.QuerySendEnabledResponse = $c7c3e434b692342b$exports.QuerySendEnabledRequest = $c7c3e434b692342b$exports.QueryDenomOwnersResponse = $c7c3e434b692342b$exports.DenomOwner = $c7c3e434b692342b$exports.QueryDenomOwnersRequest = $c7c3e434b692342b$exports.QueryDenomMetadataResponse = $c7c3e434b692342b$exports.QueryDenomMetadataRequest = $c7c3e434b692342b$exports.QueryDenomsMetadataResponse = $c7c3e434b692342b$exports.QueryDenomsMetadataRequest = $c7c3e434b692342b$exports.QueryParamsResponse = $c7c3e434b692342b$exports.QueryParamsRequest = $c7c3e434b692342b$exports.QuerySupplyOfResponse = $c7c3e434b692342b$exports.QuerySupplyOfRequest = $c7c3e434b692342b$exports.QueryTotalSupplyResponse = $c7c3e434b692342b$exports.QueryTotalSupplyRequest = $c7c3e434b692342b$exports.QuerySpendableBalanceByDenomResponse = $c7c3e434b692342b$exports.QuerySpendableBalanceByDenomRequest = $c7c3e434b692342b$exports.QuerySpendableBalancesResponse = $c7c3e434b692342b$exports.QuerySpendableBalancesRequest = $c7c3e434b692342b$exports.QueryAllBalancesResponse = $c7c3e434b692342b$exports.QueryAllBalancesRequest = $c7c3e434b692342b$exports.QueryBalanceResponse = $c7c3e434b692342b$exports.QueryBalanceRequest = $c7c3e434b692342b$exports.protobufPackage = void 0;




const $c7c3e434b692342b$var$_m0 = $c7c3e434b692342b$var$__importStar((parcelRequire("fQBv0")));

$c7c3e434b692342b$exports.protobufPackage = "cosmos.bank.v1beta1";
function $c7c3e434b692342b$var$createBaseQueryBalanceRequest() {
    return {
        address: "",
        denom: ""
    };
}
$c7c3e434b692342b$exports.QueryBalanceRequest = {
    encode (message, writer = $c7c3e434b692342b$var$_m0.Writer.create()) {
        if (message.address !== "") writer.uint32(10).string(message.address);
        if (message.denom !== "") writer.uint32(18).string(message.denom);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $c7c3e434b692342b$var$_m0.Reader ? input : new $c7c3e434b692342b$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $c7c3e434b692342b$var$createBaseQueryBalanceRequest();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.address = reader.string();
                    break;
                case 2:
                    message.denom = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            address: (0, $d5e07fe2518aae94$exports.isSet)(object.address) ? String(object.address) : "",
            denom: (0, $d5e07fe2518aae94$exports.isSet)(object.denom) ? String(object.denom) : ""
        };
    },
    toJSON (message) {
        const obj = {};
        message.address !== undefined && (obj.address = message.address);
        message.denom !== undefined && (obj.denom = message.denom);
        return obj;
    },
    fromPartial (object) {
        const message = $c7c3e434b692342b$var$createBaseQueryBalanceRequest();
        message.address = object.address ?? "";
        message.denom = object.denom ?? "";
        return message;
    }
};
function $c7c3e434b692342b$var$createBaseQueryBalanceResponse() {
    return {
        balance: undefined
    };
}
$c7c3e434b692342b$exports.QueryBalanceResponse = {
    encode (message, writer = $c7c3e434b692342b$var$_m0.Writer.create()) {
        if (message.balance !== undefined) $783dd8715fde0fcf$exports.Coin.encode(message.balance, writer.uint32(10).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $c7c3e434b692342b$var$_m0.Reader ? input : new $c7c3e434b692342b$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $c7c3e434b692342b$var$createBaseQueryBalanceResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.balance = $783dd8715fde0fcf$exports.Coin.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            balance: (0, $d5e07fe2518aae94$exports.isSet)(object.balance) ? $783dd8715fde0fcf$exports.Coin.fromJSON(object.balance) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.balance !== undefined && (obj.balance = message.balance ? $783dd8715fde0fcf$exports.Coin.toJSON(message.balance) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $c7c3e434b692342b$var$createBaseQueryBalanceResponse();
        message.balance = object.balance !== undefined && object.balance !== null ? $783dd8715fde0fcf$exports.Coin.fromPartial(object.balance) : undefined;
        return message;
    }
};
function $c7c3e434b692342b$var$createBaseQueryAllBalancesRequest() {
    return {
        address: "",
        pagination: undefined
    };
}
$c7c3e434b692342b$exports.QueryAllBalancesRequest = {
    encode (message, writer = $c7c3e434b692342b$var$_m0.Writer.create()) {
        if (message.address !== "") writer.uint32(10).string(message.address);
        if (message.pagination !== undefined) $5eae5f3cc99e92ab$exports.PageRequest.encode(message.pagination, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $c7c3e434b692342b$var$_m0.Reader ? input : new $c7c3e434b692342b$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $c7c3e434b692342b$var$createBaseQueryAllBalancesRequest();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.address = reader.string();
                    break;
                case 2:
                    message.pagination = $5eae5f3cc99e92ab$exports.PageRequest.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            address: (0, $d5e07fe2518aae94$exports.isSet)(object.address) ? String(object.address) : "",
            pagination: (0, $d5e07fe2518aae94$exports.isSet)(object.pagination) ? $5eae5f3cc99e92ab$exports.PageRequest.fromJSON(object.pagination) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.address !== undefined && (obj.address = message.address);
        message.pagination !== undefined && (obj.pagination = message.pagination ? $5eae5f3cc99e92ab$exports.PageRequest.toJSON(message.pagination) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $c7c3e434b692342b$var$createBaseQueryAllBalancesRequest();
        message.address = object.address ?? "";
        message.pagination = object.pagination !== undefined && object.pagination !== null ? $5eae5f3cc99e92ab$exports.PageRequest.fromPartial(object.pagination) : undefined;
        return message;
    }
};
function $c7c3e434b692342b$var$createBaseQueryAllBalancesResponse() {
    return {
        balances: [],
        pagination: undefined
    };
}
$c7c3e434b692342b$exports.QueryAllBalancesResponse = {
    encode (message, writer = $c7c3e434b692342b$var$_m0.Writer.create()) {
        for (const v of message.balances)$783dd8715fde0fcf$exports.Coin.encode(v, writer.uint32(10).fork()).ldelim();
        if (message.pagination !== undefined) $5eae5f3cc99e92ab$exports.PageResponse.encode(message.pagination, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $c7c3e434b692342b$var$_m0.Reader ? input : new $c7c3e434b692342b$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $c7c3e434b692342b$var$createBaseQueryAllBalancesResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.balances.push($783dd8715fde0fcf$exports.Coin.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.pagination = $5eae5f3cc99e92ab$exports.PageResponse.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            balances: Array.isArray(object?.balances) ? object.balances.map((e)=>$783dd8715fde0fcf$exports.Coin.fromJSON(e)) : [],
            pagination: (0, $d5e07fe2518aae94$exports.isSet)(object.pagination) ? $5eae5f3cc99e92ab$exports.PageResponse.fromJSON(object.pagination) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        if (message.balances) obj.balances = message.balances.map((e)=>e ? $783dd8715fde0fcf$exports.Coin.toJSON(e) : undefined);
        else obj.balances = [];
        message.pagination !== undefined && (obj.pagination = message.pagination ? $5eae5f3cc99e92ab$exports.PageResponse.toJSON(message.pagination) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $c7c3e434b692342b$var$createBaseQueryAllBalancesResponse();
        message.balances = object.balances?.map((e)=>$783dd8715fde0fcf$exports.Coin.fromPartial(e)) || [];
        message.pagination = object.pagination !== undefined && object.pagination !== null ? $5eae5f3cc99e92ab$exports.PageResponse.fromPartial(object.pagination) : undefined;
        return message;
    }
};
function $c7c3e434b692342b$var$createBaseQuerySpendableBalancesRequest() {
    return {
        address: "",
        pagination: undefined
    };
}
$c7c3e434b692342b$exports.QuerySpendableBalancesRequest = {
    encode (message, writer = $c7c3e434b692342b$var$_m0.Writer.create()) {
        if (message.address !== "") writer.uint32(10).string(message.address);
        if (message.pagination !== undefined) $5eae5f3cc99e92ab$exports.PageRequest.encode(message.pagination, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $c7c3e434b692342b$var$_m0.Reader ? input : new $c7c3e434b692342b$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $c7c3e434b692342b$var$createBaseQuerySpendableBalancesRequest();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.address = reader.string();
                    break;
                case 2:
                    message.pagination = $5eae5f3cc99e92ab$exports.PageRequest.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            address: (0, $d5e07fe2518aae94$exports.isSet)(object.address) ? String(object.address) : "",
            pagination: (0, $d5e07fe2518aae94$exports.isSet)(object.pagination) ? $5eae5f3cc99e92ab$exports.PageRequest.fromJSON(object.pagination) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.address !== undefined && (obj.address = message.address);
        message.pagination !== undefined && (obj.pagination = message.pagination ? $5eae5f3cc99e92ab$exports.PageRequest.toJSON(message.pagination) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $c7c3e434b692342b$var$createBaseQuerySpendableBalancesRequest();
        message.address = object.address ?? "";
        message.pagination = object.pagination !== undefined && object.pagination !== null ? $5eae5f3cc99e92ab$exports.PageRequest.fromPartial(object.pagination) : undefined;
        return message;
    }
};
function $c7c3e434b692342b$var$createBaseQuerySpendableBalancesResponse() {
    return {
        balances: [],
        pagination: undefined
    };
}
$c7c3e434b692342b$exports.QuerySpendableBalancesResponse = {
    encode (message, writer = $c7c3e434b692342b$var$_m0.Writer.create()) {
        for (const v of message.balances)$783dd8715fde0fcf$exports.Coin.encode(v, writer.uint32(10).fork()).ldelim();
        if (message.pagination !== undefined) $5eae5f3cc99e92ab$exports.PageResponse.encode(message.pagination, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $c7c3e434b692342b$var$_m0.Reader ? input : new $c7c3e434b692342b$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $c7c3e434b692342b$var$createBaseQuerySpendableBalancesResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.balances.push($783dd8715fde0fcf$exports.Coin.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.pagination = $5eae5f3cc99e92ab$exports.PageResponse.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            balances: Array.isArray(object?.balances) ? object.balances.map((e)=>$783dd8715fde0fcf$exports.Coin.fromJSON(e)) : [],
            pagination: (0, $d5e07fe2518aae94$exports.isSet)(object.pagination) ? $5eae5f3cc99e92ab$exports.PageResponse.fromJSON(object.pagination) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        if (message.balances) obj.balances = message.balances.map((e)=>e ? $783dd8715fde0fcf$exports.Coin.toJSON(e) : undefined);
        else obj.balances = [];
        message.pagination !== undefined && (obj.pagination = message.pagination ? $5eae5f3cc99e92ab$exports.PageResponse.toJSON(message.pagination) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $c7c3e434b692342b$var$createBaseQuerySpendableBalancesResponse();
        message.balances = object.balances?.map((e)=>$783dd8715fde0fcf$exports.Coin.fromPartial(e)) || [];
        message.pagination = object.pagination !== undefined && object.pagination !== null ? $5eae5f3cc99e92ab$exports.PageResponse.fromPartial(object.pagination) : undefined;
        return message;
    }
};
function $c7c3e434b692342b$var$createBaseQuerySpendableBalanceByDenomRequest() {
    return {
        address: "",
        denom: ""
    };
}
$c7c3e434b692342b$exports.QuerySpendableBalanceByDenomRequest = {
    encode (message, writer = $c7c3e434b692342b$var$_m0.Writer.create()) {
        if (message.address !== "") writer.uint32(10).string(message.address);
        if (message.denom !== "") writer.uint32(18).string(message.denom);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $c7c3e434b692342b$var$_m0.Reader ? input : new $c7c3e434b692342b$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $c7c3e434b692342b$var$createBaseQuerySpendableBalanceByDenomRequest();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.address = reader.string();
                    break;
                case 2:
                    message.denom = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            address: (0, $d5e07fe2518aae94$exports.isSet)(object.address) ? String(object.address) : "",
            denom: (0, $d5e07fe2518aae94$exports.isSet)(object.denom) ? String(object.denom) : ""
        };
    },
    toJSON (message) {
        const obj = {};
        message.address !== undefined && (obj.address = message.address);
        message.denom !== undefined && (obj.denom = message.denom);
        return obj;
    },
    fromPartial (object) {
        const message = $c7c3e434b692342b$var$createBaseQuerySpendableBalanceByDenomRequest();
        message.address = object.address ?? "";
        message.denom = object.denom ?? "";
        return message;
    }
};
function $c7c3e434b692342b$var$createBaseQuerySpendableBalanceByDenomResponse() {
    return {
        balance: undefined
    };
}
$c7c3e434b692342b$exports.QuerySpendableBalanceByDenomResponse = {
    encode (message, writer = $c7c3e434b692342b$var$_m0.Writer.create()) {
        if (message.balance !== undefined) $783dd8715fde0fcf$exports.Coin.encode(message.balance, writer.uint32(10).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $c7c3e434b692342b$var$_m0.Reader ? input : new $c7c3e434b692342b$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $c7c3e434b692342b$var$createBaseQuerySpendableBalanceByDenomResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.balance = $783dd8715fde0fcf$exports.Coin.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            balance: (0, $d5e07fe2518aae94$exports.isSet)(object.balance) ? $783dd8715fde0fcf$exports.Coin.fromJSON(object.balance) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.balance !== undefined && (obj.balance = message.balance ? $783dd8715fde0fcf$exports.Coin.toJSON(message.balance) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $c7c3e434b692342b$var$createBaseQuerySpendableBalanceByDenomResponse();
        message.balance = object.balance !== undefined && object.balance !== null ? $783dd8715fde0fcf$exports.Coin.fromPartial(object.balance) : undefined;
        return message;
    }
};
function $c7c3e434b692342b$var$createBaseQueryTotalSupplyRequest() {
    return {
        pagination: undefined
    };
}
$c7c3e434b692342b$exports.QueryTotalSupplyRequest = {
    encode (message, writer = $c7c3e434b692342b$var$_m0.Writer.create()) {
        if (message.pagination !== undefined) $5eae5f3cc99e92ab$exports.PageRequest.encode(message.pagination, writer.uint32(10).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $c7c3e434b692342b$var$_m0.Reader ? input : new $c7c3e434b692342b$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $c7c3e434b692342b$var$createBaseQueryTotalSupplyRequest();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.pagination = $5eae5f3cc99e92ab$exports.PageRequest.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            pagination: (0, $d5e07fe2518aae94$exports.isSet)(object.pagination) ? $5eae5f3cc99e92ab$exports.PageRequest.fromJSON(object.pagination) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.pagination !== undefined && (obj.pagination = message.pagination ? $5eae5f3cc99e92ab$exports.PageRequest.toJSON(message.pagination) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $c7c3e434b692342b$var$createBaseQueryTotalSupplyRequest();
        message.pagination = object.pagination !== undefined && object.pagination !== null ? $5eae5f3cc99e92ab$exports.PageRequest.fromPartial(object.pagination) : undefined;
        return message;
    }
};
function $c7c3e434b692342b$var$createBaseQueryTotalSupplyResponse() {
    return {
        supply: [],
        pagination: undefined
    };
}
$c7c3e434b692342b$exports.QueryTotalSupplyResponse = {
    encode (message, writer = $c7c3e434b692342b$var$_m0.Writer.create()) {
        for (const v of message.supply)$783dd8715fde0fcf$exports.Coin.encode(v, writer.uint32(10).fork()).ldelim();
        if (message.pagination !== undefined) $5eae5f3cc99e92ab$exports.PageResponse.encode(message.pagination, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $c7c3e434b692342b$var$_m0.Reader ? input : new $c7c3e434b692342b$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $c7c3e434b692342b$var$createBaseQueryTotalSupplyResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.supply.push($783dd8715fde0fcf$exports.Coin.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.pagination = $5eae5f3cc99e92ab$exports.PageResponse.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            supply: Array.isArray(object?.supply) ? object.supply.map((e)=>$783dd8715fde0fcf$exports.Coin.fromJSON(e)) : [],
            pagination: (0, $d5e07fe2518aae94$exports.isSet)(object.pagination) ? $5eae5f3cc99e92ab$exports.PageResponse.fromJSON(object.pagination) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        if (message.supply) obj.supply = message.supply.map((e)=>e ? $783dd8715fde0fcf$exports.Coin.toJSON(e) : undefined);
        else obj.supply = [];
        message.pagination !== undefined && (obj.pagination = message.pagination ? $5eae5f3cc99e92ab$exports.PageResponse.toJSON(message.pagination) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $c7c3e434b692342b$var$createBaseQueryTotalSupplyResponse();
        message.supply = object.supply?.map((e)=>$783dd8715fde0fcf$exports.Coin.fromPartial(e)) || [];
        message.pagination = object.pagination !== undefined && object.pagination !== null ? $5eae5f3cc99e92ab$exports.PageResponse.fromPartial(object.pagination) : undefined;
        return message;
    }
};
function $c7c3e434b692342b$var$createBaseQuerySupplyOfRequest() {
    return {
        denom: ""
    };
}
$c7c3e434b692342b$exports.QuerySupplyOfRequest = {
    encode (message, writer = $c7c3e434b692342b$var$_m0.Writer.create()) {
        if (message.denom !== "") writer.uint32(10).string(message.denom);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $c7c3e434b692342b$var$_m0.Reader ? input : new $c7c3e434b692342b$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $c7c3e434b692342b$var$createBaseQuerySupplyOfRequest();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.denom = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            denom: (0, $d5e07fe2518aae94$exports.isSet)(object.denom) ? String(object.denom) : ""
        };
    },
    toJSON (message) {
        const obj = {};
        message.denom !== undefined && (obj.denom = message.denom);
        return obj;
    },
    fromPartial (object) {
        const message = $c7c3e434b692342b$var$createBaseQuerySupplyOfRequest();
        message.denom = object.denom ?? "";
        return message;
    }
};
function $c7c3e434b692342b$var$createBaseQuerySupplyOfResponse() {
    return {
        amount: undefined
    };
}
$c7c3e434b692342b$exports.QuerySupplyOfResponse = {
    encode (message, writer = $c7c3e434b692342b$var$_m0.Writer.create()) {
        if (message.amount !== undefined) $783dd8715fde0fcf$exports.Coin.encode(message.amount, writer.uint32(10).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $c7c3e434b692342b$var$_m0.Reader ? input : new $c7c3e434b692342b$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $c7c3e434b692342b$var$createBaseQuerySupplyOfResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.amount = $783dd8715fde0fcf$exports.Coin.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            amount: (0, $d5e07fe2518aae94$exports.isSet)(object.amount) ? $783dd8715fde0fcf$exports.Coin.fromJSON(object.amount) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.amount !== undefined && (obj.amount = message.amount ? $783dd8715fde0fcf$exports.Coin.toJSON(message.amount) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $c7c3e434b692342b$var$createBaseQuerySupplyOfResponse();
        message.amount = object.amount !== undefined && object.amount !== null ? $783dd8715fde0fcf$exports.Coin.fromPartial(object.amount) : undefined;
        return message;
    }
};
function $c7c3e434b692342b$var$createBaseQueryParamsRequest() {
    return {};
}
$c7c3e434b692342b$exports.QueryParamsRequest = {
    encode (_, writer = $c7c3e434b692342b$var$_m0.Writer.create()) {
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $c7c3e434b692342b$var$_m0.Reader ? input : new $c7c3e434b692342b$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $c7c3e434b692342b$var$createBaseQueryParamsRequest();
        while(reader.pos < end){
            const tag = reader.uint32();
            tag;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON (_) {
        return {};
    },
    toJSON (_) {
        const obj = {};
        return obj;
    },
    fromPartial (_) {
        const message = $c7c3e434b692342b$var$createBaseQueryParamsRequest();
        return message;
    }
};
function $c7c3e434b692342b$var$createBaseQueryParamsResponse() {
    return {
        params: undefined
    };
}
$c7c3e434b692342b$exports.QueryParamsResponse = {
    encode (message, writer = $c7c3e434b692342b$var$_m0.Writer.create()) {
        if (message.params !== undefined) $3d7c161a5bad8b39$exports.Params.encode(message.params, writer.uint32(10).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $c7c3e434b692342b$var$_m0.Reader ? input : new $c7c3e434b692342b$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $c7c3e434b692342b$var$createBaseQueryParamsResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.params = $3d7c161a5bad8b39$exports.Params.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            params: (0, $d5e07fe2518aae94$exports.isSet)(object.params) ? $3d7c161a5bad8b39$exports.Params.fromJSON(object.params) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.params !== undefined && (obj.params = message.params ? $3d7c161a5bad8b39$exports.Params.toJSON(message.params) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $c7c3e434b692342b$var$createBaseQueryParamsResponse();
        message.params = object.params !== undefined && object.params !== null ? $3d7c161a5bad8b39$exports.Params.fromPartial(object.params) : undefined;
        return message;
    }
};
function $c7c3e434b692342b$var$createBaseQueryDenomsMetadataRequest() {
    return {
        pagination: undefined
    };
}
$c7c3e434b692342b$exports.QueryDenomsMetadataRequest = {
    encode (message, writer = $c7c3e434b692342b$var$_m0.Writer.create()) {
        if (message.pagination !== undefined) $5eae5f3cc99e92ab$exports.PageRequest.encode(message.pagination, writer.uint32(10).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $c7c3e434b692342b$var$_m0.Reader ? input : new $c7c3e434b692342b$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $c7c3e434b692342b$var$createBaseQueryDenomsMetadataRequest();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.pagination = $5eae5f3cc99e92ab$exports.PageRequest.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            pagination: (0, $d5e07fe2518aae94$exports.isSet)(object.pagination) ? $5eae5f3cc99e92ab$exports.PageRequest.fromJSON(object.pagination) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.pagination !== undefined && (obj.pagination = message.pagination ? $5eae5f3cc99e92ab$exports.PageRequest.toJSON(message.pagination) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $c7c3e434b692342b$var$createBaseQueryDenomsMetadataRequest();
        message.pagination = object.pagination !== undefined && object.pagination !== null ? $5eae5f3cc99e92ab$exports.PageRequest.fromPartial(object.pagination) : undefined;
        return message;
    }
};
function $c7c3e434b692342b$var$createBaseQueryDenomsMetadataResponse() {
    return {
        metadatas: [],
        pagination: undefined
    };
}
$c7c3e434b692342b$exports.QueryDenomsMetadataResponse = {
    encode (message, writer = $c7c3e434b692342b$var$_m0.Writer.create()) {
        for (const v of message.metadatas)$3d7c161a5bad8b39$exports.Metadata.encode(v, writer.uint32(10).fork()).ldelim();
        if (message.pagination !== undefined) $5eae5f3cc99e92ab$exports.PageResponse.encode(message.pagination, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $c7c3e434b692342b$var$_m0.Reader ? input : new $c7c3e434b692342b$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $c7c3e434b692342b$var$createBaseQueryDenomsMetadataResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.metadatas.push($3d7c161a5bad8b39$exports.Metadata.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.pagination = $5eae5f3cc99e92ab$exports.PageResponse.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            metadatas: Array.isArray(object?.metadatas) ? object.metadatas.map((e)=>$3d7c161a5bad8b39$exports.Metadata.fromJSON(e)) : [],
            pagination: (0, $d5e07fe2518aae94$exports.isSet)(object.pagination) ? $5eae5f3cc99e92ab$exports.PageResponse.fromJSON(object.pagination) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        if (message.metadatas) obj.metadatas = message.metadatas.map((e)=>e ? $3d7c161a5bad8b39$exports.Metadata.toJSON(e) : undefined);
        else obj.metadatas = [];
        message.pagination !== undefined && (obj.pagination = message.pagination ? $5eae5f3cc99e92ab$exports.PageResponse.toJSON(message.pagination) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $c7c3e434b692342b$var$createBaseQueryDenomsMetadataResponse();
        message.metadatas = object.metadatas?.map((e)=>$3d7c161a5bad8b39$exports.Metadata.fromPartial(e)) || [];
        message.pagination = object.pagination !== undefined && object.pagination !== null ? $5eae5f3cc99e92ab$exports.PageResponse.fromPartial(object.pagination) : undefined;
        return message;
    }
};
function $c7c3e434b692342b$var$createBaseQueryDenomMetadataRequest() {
    return {
        denom: ""
    };
}
$c7c3e434b692342b$exports.QueryDenomMetadataRequest = {
    encode (message, writer = $c7c3e434b692342b$var$_m0.Writer.create()) {
        if (message.denom !== "") writer.uint32(10).string(message.denom);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $c7c3e434b692342b$var$_m0.Reader ? input : new $c7c3e434b692342b$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $c7c3e434b692342b$var$createBaseQueryDenomMetadataRequest();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.denom = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            denom: (0, $d5e07fe2518aae94$exports.isSet)(object.denom) ? String(object.denom) : ""
        };
    },
    toJSON (message) {
        const obj = {};
        message.denom !== undefined && (obj.denom = message.denom);
        return obj;
    },
    fromPartial (object) {
        const message = $c7c3e434b692342b$var$createBaseQueryDenomMetadataRequest();
        message.denom = object.denom ?? "";
        return message;
    }
};
function $c7c3e434b692342b$var$createBaseQueryDenomMetadataResponse() {
    return {
        metadata: undefined
    };
}
$c7c3e434b692342b$exports.QueryDenomMetadataResponse = {
    encode (message, writer = $c7c3e434b692342b$var$_m0.Writer.create()) {
        if (message.metadata !== undefined) $3d7c161a5bad8b39$exports.Metadata.encode(message.metadata, writer.uint32(10).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $c7c3e434b692342b$var$_m0.Reader ? input : new $c7c3e434b692342b$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $c7c3e434b692342b$var$createBaseQueryDenomMetadataResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.metadata = $3d7c161a5bad8b39$exports.Metadata.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            metadata: (0, $d5e07fe2518aae94$exports.isSet)(object.metadata) ? $3d7c161a5bad8b39$exports.Metadata.fromJSON(object.metadata) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.metadata !== undefined && (obj.metadata = message.metadata ? $3d7c161a5bad8b39$exports.Metadata.toJSON(message.metadata) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $c7c3e434b692342b$var$createBaseQueryDenomMetadataResponse();
        message.metadata = object.metadata !== undefined && object.metadata !== null ? $3d7c161a5bad8b39$exports.Metadata.fromPartial(object.metadata) : undefined;
        return message;
    }
};
function $c7c3e434b692342b$var$createBaseQueryDenomOwnersRequest() {
    return {
        denom: "",
        pagination: undefined
    };
}
$c7c3e434b692342b$exports.QueryDenomOwnersRequest = {
    encode (message, writer = $c7c3e434b692342b$var$_m0.Writer.create()) {
        if (message.denom !== "") writer.uint32(10).string(message.denom);
        if (message.pagination !== undefined) $5eae5f3cc99e92ab$exports.PageRequest.encode(message.pagination, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $c7c3e434b692342b$var$_m0.Reader ? input : new $c7c3e434b692342b$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $c7c3e434b692342b$var$createBaseQueryDenomOwnersRequest();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.denom = reader.string();
                    break;
                case 2:
                    message.pagination = $5eae5f3cc99e92ab$exports.PageRequest.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            denom: (0, $d5e07fe2518aae94$exports.isSet)(object.denom) ? String(object.denom) : "",
            pagination: (0, $d5e07fe2518aae94$exports.isSet)(object.pagination) ? $5eae5f3cc99e92ab$exports.PageRequest.fromJSON(object.pagination) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.denom !== undefined && (obj.denom = message.denom);
        message.pagination !== undefined && (obj.pagination = message.pagination ? $5eae5f3cc99e92ab$exports.PageRequest.toJSON(message.pagination) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $c7c3e434b692342b$var$createBaseQueryDenomOwnersRequest();
        message.denom = object.denom ?? "";
        message.pagination = object.pagination !== undefined && object.pagination !== null ? $5eae5f3cc99e92ab$exports.PageRequest.fromPartial(object.pagination) : undefined;
        return message;
    }
};
function $c7c3e434b692342b$var$createBaseDenomOwner() {
    return {
        address: "",
        balance: undefined
    };
}
$c7c3e434b692342b$exports.DenomOwner = {
    encode (message, writer = $c7c3e434b692342b$var$_m0.Writer.create()) {
        if (message.address !== "") writer.uint32(10).string(message.address);
        if (message.balance !== undefined) $783dd8715fde0fcf$exports.Coin.encode(message.balance, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $c7c3e434b692342b$var$_m0.Reader ? input : new $c7c3e434b692342b$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $c7c3e434b692342b$var$createBaseDenomOwner();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.address = reader.string();
                    break;
                case 2:
                    message.balance = $783dd8715fde0fcf$exports.Coin.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            address: (0, $d5e07fe2518aae94$exports.isSet)(object.address) ? String(object.address) : "",
            balance: (0, $d5e07fe2518aae94$exports.isSet)(object.balance) ? $783dd8715fde0fcf$exports.Coin.fromJSON(object.balance) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.address !== undefined && (obj.address = message.address);
        message.balance !== undefined && (obj.balance = message.balance ? $783dd8715fde0fcf$exports.Coin.toJSON(message.balance) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $c7c3e434b692342b$var$createBaseDenomOwner();
        message.address = object.address ?? "";
        message.balance = object.balance !== undefined && object.balance !== null ? $783dd8715fde0fcf$exports.Coin.fromPartial(object.balance) : undefined;
        return message;
    }
};
function $c7c3e434b692342b$var$createBaseQueryDenomOwnersResponse() {
    return {
        denomOwners: [],
        pagination: undefined
    };
}
$c7c3e434b692342b$exports.QueryDenomOwnersResponse = {
    encode (message, writer = $c7c3e434b692342b$var$_m0.Writer.create()) {
        for (const v of message.denomOwners)$c7c3e434b692342b$exports.DenomOwner.encode(v, writer.uint32(10).fork()).ldelim();
        if (message.pagination !== undefined) $5eae5f3cc99e92ab$exports.PageResponse.encode(message.pagination, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $c7c3e434b692342b$var$_m0.Reader ? input : new $c7c3e434b692342b$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $c7c3e434b692342b$var$createBaseQueryDenomOwnersResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.denomOwners.push($c7c3e434b692342b$exports.DenomOwner.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.pagination = $5eae5f3cc99e92ab$exports.PageResponse.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            denomOwners: Array.isArray(object?.denomOwners) ? object.denomOwners.map((e)=>$c7c3e434b692342b$exports.DenomOwner.fromJSON(e)) : [],
            pagination: (0, $d5e07fe2518aae94$exports.isSet)(object.pagination) ? $5eae5f3cc99e92ab$exports.PageResponse.fromJSON(object.pagination) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        if (message.denomOwners) obj.denomOwners = message.denomOwners.map((e)=>e ? $c7c3e434b692342b$exports.DenomOwner.toJSON(e) : undefined);
        else obj.denomOwners = [];
        message.pagination !== undefined && (obj.pagination = message.pagination ? $5eae5f3cc99e92ab$exports.PageResponse.toJSON(message.pagination) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $c7c3e434b692342b$var$createBaseQueryDenomOwnersResponse();
        message.denomOwners = object.denomOwners?.map((e)=>$c7c3e434b692342b$exports.DenomOwner.fromPartial(e)) || [];
        message.pagination = object.pagination !== undefined && object.pagination !== null ? $5eae5f3cc99e92ab$exports.PageResponse.fromPartial(object.pagination) : undefined;
        return message;
    }
};
function $c7c3e434b692342b$var$createBaseQuerySendEnabledRequest() {
    return {
        denoms: [],
        pagination: undefined
    };
}
$c7c3e434b692342b$exports.QuerySendEnabledRequest = {
    encode (message, writer = $c7c3e434b692342b$var$_m0.Writer.create()) {
        for (const v of message.denoms)writer.uint32(10).string(v);
        if (message.pagination !== undefined) $5eae5f3cc99e92ab$exports.PageRequest.encode(message.pagination, writer.uint32(794).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $c7c3e434b692342b$var$_m0.Reader ? input : new $c7c3e434b692342b$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $c7c3e434b692342b$var$createBaseQuerySendEnabledRequest();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.denoms.push(reader.string());
                    break;
                case 99:
                    message.pagination = $5eae5f3cc99e92ab$exports.PageRequest.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            denoms: Array.isArray(object?.denoms) ? object.denoms.map((e)=>String(e)) : [],
            pagination: (0, $d5e07fe2518aae94$exports.isSet)(object.pagination) ? $5eae5f3cc99e92ab$exports.PageRequest.fromJSON(object.pagination) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        if (message.denoms) obj.denoms = message.denoms.map((e)=>e);
        else obj.denoms = [];
        message.pagination !== undefined && (obj.pagination = message.pagination ? $5eae5f3cc99e92ab$exports.PageRequest.toJSON(message.pagination) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $c7c3e434b692342b$var$createBaseQuerySendEnabledRequest();
        message.denoms = object.denoms?.map((e)=>e) || [];
        message.pagination = object.pagination !== undefined && object.pagination !== null ? $5eae5f3cc99e92ab$exports.PageRequest.fromPartial(object.pagination) : undefined;
        return message;
    }
};
function $c7c3e434b692342b$var$createBaseQuerySendEnabledResponse() {
    return {
        sendEnabled: [],
        pagination: undefined
    };
}
$c7c3e434b692342b$exports.QuerySendEnabledResponse = {
    encode (message, writer = $c7c3e434b692342b$var$_m0.Writer.create()) {
        for (const v of message.sendEnabled)$3d7c161a5bad8b39$exports.SendEnabled.encode(v, writer.uint32(10).fork()).ldelim();
        if (message.pagination !== undefined) $5eae5f3cc99e92ab$exports.PageResponse.encode(message.pagination, writer.uint32(794).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $c7c3e434b692342b$var$_m0.Reader ? input : new $c7c3e434b692342b$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $c7c3e434b692342b$var$createBaseQuerySendEnabledResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.sendEnabled.push($3d7c161a5bad8b39$exports.SendEnabled.decode(reader, reader.uint32()));
                    break;
                case 99:
                    message.pagination = $5eae5f3cc99e92ab$exports.PageResponse.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            sendEnabled: Array.isArray(object?.sendEnabled) ? object.sendEnabled.map((e)=>$3d7c161a5bad8b39$exports.SendEnabled.fromJSON(e)) : [],
            pagination: (0, $d5e07fe2518aae94$exports.isSet)(object.pagination) ? $5eae5f3cc99e92ab$exports.PageResponse.fromJSON(object.pagination) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        if (message.sendEnabled) obj.sendEnabled = message.sendEnabled.map((e)=>e ? $3d7c161a5bad8b39$exports.SendEnabled.toJSON(e) : undefined);
        else obj.sendEnabled = [];
        message.pagination !== undefined && (obj.pagination = message.pagination ? $5eae5f3cc99e92ab$exports.PageResponse.toJSON(message.pagination) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $c7c3e434b692342b$var$createBaseQuerySendEnabledResponse();
        message.sendEnabled = object.sendEnabled?.map((e)=>$3d7c161a5bad8b39$exports.SendEnabled.fromPartial(e)) || [];
        message.pagination = object.pagination !== undefined && object.pagination !== null ? $5eae5f3cc99e92ab$exports.PageResponse.fromPartial(object.pagination) : undefined;
        return message;
    }
};
class $c7c3e434b692342b$var$QueryClientImpl {
    constructor(rpc){
        this.rpc = rpc;
        this.Balance = this.Balance.bind(this);
        this.AllBalances = this.AllBalances.bind(this);
        this.SpendableBalances = this.SpendableBalances.bind(this);
        this.SpendableBalanceByDenom = this.SpendableBalanceByDenom.bind(this);
        this.TotalSupply = this.TotalSupply.bind(this);
        this.SupplyOf = this.SupplyOf.bind(this);
        this.Params = this.Params.bind(this);
        this.DenomMetadata = this.DenomMetadata.bind(this);
        this.DenomsMetadata = this.DenomsMetadata.bind(this);
        this.DenomOwners = this.DenomOwners.bind(this);
        this.SendEnabled = this.SendEnabled.bind(this);
    }
    Balance(request) {
        const data = $c7c3e434b692342b$exports.QueryBalanceRequest.encode(request).finish();
        const promise = this.rpc.request("cosmos.bank.v1beta1.Query", "Balance", data);
        return promise.then((data)=>$c7c3e434b692342b$exports.QueryBalanceResponse.decode(new $c7c3e434b692342b$var$_m0.Reader(data)));
    }
    AllBalances(request) {
        const data = $c7c3e434b692342b$exports.QueryAllBalancesRequest.encode(request).finish();
        const promise = this.rpc.request("cosmos.bank.v1beta1.Query", "AllBalances", data);
        return promise.then((data)=>$c7c3e434b692342b$exports.QueryAllBalancesResponse.decode(new $c7c3e434b692342b$var$_m0.Reader(data)));
    }
    SpendableBalances(request) {
        const data = $c7c3e434b692342b$exports.QuerySpendableBalancesRequest.encode(request).finish();
        const promise = this.rpc.request("cosmos.bank.v1beta1.Query", "SpendableBalances", data);
        return promise.then((data)=>$c7c3e434b692342b$exports.QuerySpendableBalancesResponse.decode(new $c7c3e434b692342b$var$_m0.Reader(data)));
    }
    SpendableBalanceByDenom(request) {
        const data = $c7c3e434b692342b$exports.QuerySpendableBalanceByDenomRequest.encode(request).finish();
        const promise = this.rpc.request("cosmos.bank.v1beta1.Query", "SpendableBalanceByDenom", data);
        return promise.then((data)=>$c7c3e434b692342b$exports.QuerySpendableBalanceByDenomResponse.decode(new $c7c3e434b692342b$var$_m0.Reader(data)));
    }
    TotalSupply(request = {
        pagination: undefined
    }) {
        const data = $c7c3e434b692342b$exports.QueryTotalSupplyRequest.encode(request).finish();
        const promise = this.rpc.request("cosmos.bank.v1beta1.Query", "TotalSupply", data);
        return promise.then((data)=>$c7c3e434b692342b$exports.QueryTotalSupplyResponse.decode(new $c7c3e434b692342b$var$_m0.Reader(data)));
    }
    SupplyOf(request) {
        const data = $c7c3e434b692342b$exports.QuerySupplyOfRequest.encode(request).finish();
        const promise = this.rpc.request("cosmos.bank.v1beta1.Query", "SupplyOf", data);
        return promise.then((data)=>$c7c3e434b692342b$exports.QuerySupplyOfResponse.decode(new $c7c3e434b692342b$var$_m0.Reader(data)));
    }
    Params(request = {}) {
        const data = $c7c3e434b692342b$exports.QueryParamsRequest.encode(request).finish();
        const promise = this.rpc.request("cosmos.bank.v1beta1.Query", "Params", data);
        return promise.then((data)=>$c7c3e434b692342b$exports.QueryParamsResponse.decode(new $c7c3e434b692342b$var$_m0.Reader(data)));
    }
    DenomMetadata(request) {
        const data = $c7c3e434b692342b$exports.QueryDenomMetadataRequest.encode(request).finish();
        const promise = this.rpc.request("cosmos.bank.v1beta1.Query", "DenomMetadata", data);
        return promise.then((data)=>$c7c3e434b692342b$exports.QueryDenomMetadataResponse.decode(new $c7c3e434b692342b$var$_m0.Reader(data)));
    }
    DenomsMetadata(request = {
        pagination: undefined
    }) {
        const data = $c7c3e434b692342b$exports.QueryDenomsMetadataRequest.encode(request).finish();
        const promise = this.rpc.request("cosmos.bank.v1beta1.Query", "DenomsMetadata", data);
        return promise.then((data)=>$c7c3e434b692342b$exports.QueryDenomsMetadataResponse.decode(new $c7c3e434b692342b$var$_m0.Reader(data)));
    }
    DenomOwners(request) {
        const data = $c7c3e434b692342b$exports.QueryDenomOwnersRequest.encode(request).finish();
        const promise = this.rpc.request("cosmos.bank.v1beta1.Query", "DenomOwners", data);
        return promise.then((data)=>$c7c3e434b692342b$exports.QueryDenomOwnersResponse.decode(new $c7c3e434b692342b$var$_m0.Reader(data)));
    }
    SendEnabled(request) {
        const data = $c7c3e434b692342b$exports.QuerySendEnabledRequest.encode(request).finish();
        const promise = this.rpc.request("cosmos.bank.v1beta1.Query", "SendEnabled", data);
        return promise.then((data)=>$c7c3e434b692342b$exports.QuerySendEnabledResponse.decode(new $c7c3e434b692342b$var$_m0.Reader(data)));
    }
}
$c7c3e434b692342b$exports.QueryClientImpl = $c7c3e434b692342b$var$QueryClientImpl;



function $46bdb9fe6141f5f3$var$setupBankExtension(base) {
    const rpc = (0, $a3959936d2cce854$exports.createProtobufRpcClient)(base);
    // Use this service to get easy typed access to query methods
    // This cannot be used for proof verification
    const queryService = new $c7c3e434b692342b$exports.QueryClientImpl(rpc);
    return {
        bank: {
            balance: async (address, denom)=>{
                const { balance: balance } = await queryService.Balance({
                    address: address,
                    denom: denom
                });
                (0, $fZwG5.assert)(balance);
                return balance;
            },
            allBalances: async (address)=>{
                const { balances: balances } = await queryService.AllBalances({
                    address: address
                });
                return balances;
            },
            totalSupply: async (paginationKey)=>{
                const response = await queryService.TotalSupply({
                    pagination: (0, $a3959936d2cce854$exports.createPagination)(paginationKey)
                });
                return response;
            },
            supplyOf: async (denom)=>{
                const { amount: amount } = await queryService.SupplyOf({
                    denom: denom
                });
                (0, $fZwG5.assert)(amount);
                return amount;
            },
            denomMetadata: async (denom)=>{
                const { metadata: metadata } = await queryService.DenomMetadata({
                    denom: denom
                });
                (0, $fZwG5.assert)(metadata);
                return metadata;
            },
            denomsMetadata: async ()=>{
                const { metadatas: metadatas } = await queryService.DenomsMetadata({
                    pagination: undefined
                });
                return metadatas;
            }
        }
    };
}
$46bdb9fe6141f5f3$exports.setupBankExtension = $46bdb9fe6141f5f3$var$setupBankExtension;


Object.defineProperty($d0d8b6f4712acd9f$exports, "setupBankExtension", {
    enumerable: true,
    get: function() {
        return $46bdb9fe6141f5f3$exports.setupBankExtension;
    }
});
var $23b7488ff4638e88$exports = {};
"use strict";
Object.defineProperty($23b7488ff4638e88$exports, "__esModule", {
    value: true
});
$23b7488ff4638e88$exports.createCrysisAminoConverters = $23b7488ff4638e88$exports.isAminoMsgVerifyInvariant = void 0;
function $23b7488ff4638e88$var$isAminoMsgVerifyInvariant(msg) {
    return msg.type === "cosmos-sdk/MsgVerifyInvariant";
}
$23b7488ff4638e88$exports.isAminoMsgVerifyInvariant = $23b7488ff4638e88$var$isAminoMsgVerifyInvariant;
function $23b7488ff4638e88$var$createCrysisAminoConverters() {
    throw new Error("Not implemented");
}
$23b7488ff4638e88$exports.createCrysisAminoConverters = $23b7488ff4638e88$var$createCrysisAminoConverters;


Object.defineProperty($d0d8b6f4712acd9f$exports, "createCrysisAminoConverters", {
    enumerable: true,
    get: function() {
        return $23b7488ff4638e88$exports.createCrysisAminoConverters;
    }
});
Object.defineProperty($d0d8b6f4712acd9f$exports, "isAminoMsgVerifyInvariant", {
    enumerable: true,
    get: function() {
        return $23b7488ff4638e88$exports.isAminoMsgVerifyInvariant;
    }
});
var $8c29d41e3d90f40d$exports = {};
"use strict";
Object.defineProperty($8c29d41e3d90f40d$exports, "__esModule", {
    value: true
});
$8c29d41e3d90f40d$exports.createDistributionAminoConverters = $8c29d41e3d90f40d$exports.isAminoMsgFundCommunityPool = $8c29d41e3d90f40d$exports.isAminoMsgWithdrawValidatorCommission = $8c29d41e3d90f40d$exports.isAminoMsgWithdrawDelegatorReward = $8c29d41e3d90f40d$exports.isAminoMsgSetWithdrawAddress = void 0;
function $8c29d41e3d90f40d$var$isAminoMsgSetWithdrawAddress(msg) {
    // NOTE: Type string and names diverge here!
    return msg.type === "cosmos-sdk/MsgModifyWithdrawAddress";
}
$8c29d41e3d90f40d$exports.isAminoMsgSetWithdrawAddress = $8c29d41e3d90f40d$var$isAminoMsgSetWithdrawAddress;
function $8c29d41e3d90f40d$var$isAminoMsgWithdrawDelegatorReward(msg) {
    // NOTE: Type string and names diverge here!
    return msg.type === "cosmos-sdk/MsgWithdrawDelegationReward";
}
$8c29d41e3d90f40d$exports.isAminoMsgWithdrawDelegatorReward = $8c29d41e3d90f40d$var$isAminoMsgWithdrawDelegatorReward;
function $8c29d41e3d90f40d$var$isAminoMsgWithdrawValidatorCommission(msg) {
    return msg.type === "cosmos-sdk/MsgWithdrawValidatorCommission";
}
$8c29d41e3d90f40d$exports.isAminoMsgWithdrawValidatorCommission = $8c29d41e3d90f40d$var$isAminoMsgWithdrawValidatorCommission;
function $8c29d41e3d90f40d$var$isAminoMsgFundCommunityPool(msg) {
    return msg.type === "cosmos-sdk/MsgFundCommunityPool";
}
$8c29d41e3d90f40d$exports.isAminoMsgFundCommunityPool = $8c29d41e3d90f40d$var$isAminoMsgFundCommunityPool;
function $8c29d41e3d90f40d$var$createDistributionAminoConverters() {
    return {
        "/cosmos.distribution.v1beta1.MsgFundCommunityPool": {
            aminoType: "cosmos-sdk/MsgFundCommunityPool",
            toAmino: ({ amount: amount, depositor: depositor })=>({
                    amount: [
                        ...amount
                    ],
                    depositor: depositor
                }),
            fromAmino: ({ amount: amount, depositor: depositor })=>({
                    amount: [
                        ...amount
                    ],
                    depositor: depositor
                })
        },
        "/cosmos.distribution.v1beta1.MsgSetWithdrawAddress": {
            aminoType: "cosmos-sdk/MsgModifyWithdrawAddress",
            toAmino: ({ delegatorAddress: delegatorAddress, withdrawAddress: withdrawAddress })=>({
                    delegator_address: delegatorAddress,
                    withdraw_address: withdrawAddress
                }),
            fromAmino: ({ delegator_address: delegator_address, withdraw_address: withdraw_address })=>({
                    delegatorAddress: delegator_address,
                    withdrawAddress: withdraw_address
                })
        },
        "/cosmos.distribution.v1beta1.MsgWithdrawDelegatorReward": {
            aminoType: "cosmos-sdk/MsgWithdrawDelegationReward",
            toAmino: ({ delegatorAddress: delegatorAddress, validatorAddress: validatorAddress })=>({
                    delegator_address: delegatorAddress,
                    validator_address: validatorAddress
                }),
            fromAmino: ({ delegator_address: delegator_address, validator_address: validator_address })=>({
                    delegatorAddress: delegator_address,
                    validatorAddress: validator_address
                })
        },
        "/cosmos.distribution.v1beta1.MsgWithdrawValidatorCommission": {
            aminoType: "cosmos-sdk/MsgWithdrawValidatorCommission",
            toAmino: ({ validatorAddress: validatorAddress })=>({
                    validator_address: validatorAddress
                }),
            fromAmino: ({ validator_address: validator_address })=>({
                    validatorAddress: validator_address
                })
        }
    };
}
$8c29d41e3d90f40d$exports.createDistributionAminoConverters = $8c29d41e3d90f40d$var$createDistributionAminoConverters;


Object.defineProperty($d0d8b6f4712acd9f$exports, "createDistributionAminoConverters", {
    enumerable: true,
    get: function() {
        return $8c29d41e3d90f40d$exports.createDistributionAminoConverters;
    }
});
Object.defineProperty($d0d8b6f4712acd9f$exports, "isAminoMsgFundCommunityPool", {
    enumerable: true,
    get: function() {
        return $8c29d41e3d90f40d$exports.isAminoMsgFundCommunityPool;
    }
});
Object.defineProperty($d0d8b6f4712acd9f$exports, "isAminoMsgSetWithdrawAddress", {
    enumerable: true,
    get: function() {
        return $8c29d41e3d90f40d$exports.isAminoMsgSetWithdrawAddress;
    }
});
Object.defineProperty($d0d8b6f4712acd9f$exports, "isAminoMsgWithdrawDelegatorReward", {
    enumerable: true,
    get: function() {
        return $8c29d41e3d90f40d$exports.isAminoMsgWithdrawDelegatorReward;
    }
});
Object.defineProperty($d0d8b6f4712acd9f$exports, "isAminoMsgWithdrawValidatorCommission", {
    enumerable: true,
    get: function() {
        return $8c29d41e3d90f40d$exports.isAminoMsgWithdrawValidatorCommission;
    }
});
var $708ba6d31093d4f5$exports = {};
"use strict";
Object.defineProperty($708ba6d31093d4f5$exports, "__esModule", {
    value: true
});
$708ba6d31093d4f5$exports.isMsgWithdrawDelegatorRewardEncodeObject = $708ba6d31093d4f5$exports.distributionTypes = void 0;
var $e8f7350709207109$exports = {};
"use strict";
var $e8f7350709207109$var$__createBinding = $e8f7350709207109$exports && $e8f7350709207109$exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $e8f7350709207109$var$__setModuleDefault = $e8f7350709207109$exports && $e8f7350709207109$exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $e8f7350709207109$var$__importStar = $e8f7350709207109$exports && $e8f7350709207109$exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $e8f7350709207109$var$__createBinding(result, mod, k);
    }
    $e8f7350709207109$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty($e8f7350709207109$exports, "__esModule", {
    value: true
});
$e8f7350709207109$exports.MsgClientImpl = $e8f7350709207109$exports.MsgCommunityPoolSpendResponse = $e8f7350709207109$exports.MsgCommunityPoolSpend = $e8f7350709207109$exports.MsgUpdateParamsResponse = $e8f7350709207109$exports.MsgUpdateParams = $e8f7350709207109$exports.MsgFundCommunityPoolResponse = $e8f7350709207109$exports.MsgFundCommunityPool = $e8f7350709207109$exports.MsgWithdrawValidatorCommissionResponse = $e8f7350709207109$exports.MsgWithdrawValidatorCommission = $e8f7350709207109$exports.MsgWithdrawDelegatorRewardResponse = $e8f7350709207109$exports.MsgWithdrawDelegatorReward = $e8f7350709207109$exports.MsgSetWithdrawAddressResponse = $e8f7350709207109$exports.MsgSetWithdrawAddress = $e8f7350709207109$exports.protobufPackage = void 0;

var $5ca23c6a841b0ad3$exports = {};
"use strict";
var $5ca23c6a841b0ad3$var$__createBinding = $5ca23c6a841b0ad3$exports && $5ca23c6a841b0ad3$exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $5ca23c6a841b0ad3$var$__setModuleDefault = $5ca23c6a841b0ad3$exports && $5ca23c6a841b0ad3$exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $5ca23c6a841b0ad3$var$__importStar = $5ca23c6a841b0ad3$exports && $5ca23c6a841b0ad3$exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $5ca23c6a841b0ad3$var$__createBinding(result, mod, k);
    }
    $5ca23c6a841b0ad3$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty($5ca23c6a841b0ad3$exports, "__esModule", {
    value: true
});
$5ca23c6a841b0ad3$exports.CommunityPoolSpendProposalWithDeposit = $5ca23c6a841b0ad3$exports.DelegationDelegatorReward = $5ca23c6a841b0ad3$exports.DelegatorStartingInfo = $5ca23c6a841b0ad3$exports.CommunityPoolSpendProposal = $5ca23c6a841b0ad3$exports.FeePool = $5ca23c6a841b0ad3$exports.ValidatorSlashEvents = $5ca23c6a841b0ad3$exports.ValidatorSlashEvent = $5ca23c6a841b0ad3$exports.ValidatorOutstandingRewards = $5ca23c6a841b0ad3$exports.ValidatorAccumulatedCommission = $5ca23c6a841b0ad3$exports.ValidatorCurrentRewards = $5ca23c6a841b0ad3$exports.ValidatorHistoricalRewards = $5ca23c6a841b0ad3$exports.Params = $5ca23c6a841b0ad3$exports.protobufPackage = void 0;



const $5ca23c6a841b0ad3$var$_m0 = $5ca23c6a841b0ad3$var$__importStar((parcelRequire("fQBv0")));
$5ca23c6a841b0ad3$exports.protobufPackage = "cosmos.distribution.v1beta1";
function $5ca23c6a841b0ad3$var$createBaseParams() {
    return {
        communityTax: "",
        baseProposerReward: "",
        bonusProposerReward: "",
        withdrawAddrEnabled: false
    };
}
$5ca23c6a841b0ad3$exports.Params = {
    encode (message, writer = $5ca23c6a841b0ad3$var$_m0.Writer.create()) {
        if (message.communityTax !== "") writer.uint32(10).string(message.communityTax);
        if (message.baseProposerReward !== "") writer.uint32(18).string(message.baseProposerReward);
        if (message.bonusProposerReward !== "") writer.uint32(26).string(message.bonusProposerReward);
        if (message.withdrawAddrEnabled === true) writer.uint32(32).bool(message.withdrawAddrEnabled);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $5ca23c6a841b0ad3$var$_m0.Reader ? input : new $5ca23c6a841b0ad3$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $5ca23c6a841b0ad3$var$createBaseParams();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.communityTax = reader.string();
                    break;
                case 2:
                    message.baseProposerReward = reader.string();
                    break;
                case 3:
                    message.bonusProposerReward = reader.string();
                    break;
                case 4:
                    message.withdrawAddrEnabled = reader.bool();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            communityTax: (0, $d5e07fe2518aae94$exports.isSet)(object.communityTax) ? String(object.communityTax) : "",
            baseProposerReward: (0, $d5e07fe2518aae94$exports.isSet)(object.baseProposerReward) ? String(object.baseProposerReward) : "",
            bonusProposerReward: (0, $d5e07fe2518aae94$exports.isSet)(object.bonusProposerReward) ? String(object.bonusProposerReward) : "",
            withdrawAddrEnabled: (0, $d5e07fe2518aae94$exports.isSet)(object.withdrawAddrEnabled) ? Boolean(object.withdrawAddrEnabled) : false
        };
    },
    toJSON (message) {
        const obj = {};
        message.communityTax !== undefined && (obj.communityTax = message.communityTax);
        message.baseProposerReward !== undefined && (obj.baseProposerReward = message.baseProposerReward);
        message.bonusProposerReward !== undefined && (obj.bonusProposerReward = message.bonusProposerReward);
        message.withdrawAddrEnabled !== undefined && (obj.withdrawAddrEnabled = message.withdrawAddrEnabled);
        return obj;
    },
    fromPartial (object) {
        const message = $5ca23c6a841b0ad3$var$createBaseParams();
        message.communityTax = object.communityTax ?? "";
        message.baseProposerReward = object.baseProposerReward ?? "";
        message.bonusProposerReward = object.bonusProposerReward ?? "";
        message.withdrawAddrEnabled = object.withdrawAddrEnabled ?? false;
        return message;
    }
};
function $5ca23c6a841b0ad3$var$createBaseValidatorHistoricalRewards() {
    return {
        cumulativeRewardRatio: [],
        referenceCount: 0
    };
}
$5ca23c6a841b0ad3$exports.ValidatorHistoricalRewards = {
    encode (message, writer = $5ca23c6a841b0ad3$var$_m0.Writer.create()) {
        for (const v of message.cumulativeRewardRatio)$783dd8715fde0fcf$exports.DecCoin.encode(v, writer.uint32(10).fork()).ldelim();
        if (message.referenceCount !== 0) writer.uint32(16).uint32(message.referenceCount);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $5ca23c6a841b0ad3$var$_m0.Reader ? input : new $5ca23c6a841b0ad3$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $5ca23c6a841b0ad3$var$createBaseValidatorHistoricalRewards();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.cumulativeRewardRatio.push($783dd8715fde0fcf$exports.DecCoin.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.referenceCount = reader.uint32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            cumulativeRewardRatio: Array.isArray(object?.cumulativeRewardRatio) ? object.cumulativeRewardRatio.map((e)=>$783dd8715fde0fcf$exports.DecCoin.fromJSON(e)) : [],
            referenceCount: (0, $d5e07fe2518aae94$exports.isSet)(object.referenceCount) ? Number(object.referenceCount) : 0
        };
    },
    toJSON (message) {
        const obj = {};
        if (message.cumulativeRewardRatio) obj.cumulativeRewardRatio = message.cumulativeRewardRatio.map((e)=>e ? $783dd8715fde0fcf$exports.DecCoin.toJSON(e) : undefined);
        else obj.cumulativeRewardRatio = [];
        message.referenceCount !== undefined && (obj.referenceCount = Math.round(message.referenceCount));
        return obj;
    },
    fromPartial (object) {
        const message = $5ca23c6a841b0ad3$var$createBaseValidatorHistoricalRewards();
        message.cumulativeRewardRatio = object.cumulativeRewardRatio?.map((e)=>$783dd8715fde0fcf$exports.DecCoin.fromPartial(e)) || [];
        message.referenceCount = object.referenceCount ?? 0;
        return message;
    }
};
function $5ca23c6a841b0ad3$var$createBaseValidatorCurrentRewards() {
    return {
        rewards: [],
        period: $d5e07fe2518aae94$exports.Long.UZERO
    };
}
$5ca23c6a841b0ad3$exports.ValidatorCurrentRewards = {
    encode (message, writer = $5ca23c6a841b0ad3$var$_m0.Writer.create()) {
        for (const v of message.rewards)$783dd8715fde0fcf$exports.DecCoin.encode(v, writer.uint32(10).fork()).ldelim();
        if (!message.period.isZero()) writer.uint32(16).uint64(message.period);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $5ca23c6a841b0ad3$var$_m0.Reader ? input : new $5ca23c6a841b0ad3$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $5ca23c6a841b0ad3$var$createBaseValidatorCurrentRewards();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.rewards.push($783dd8715fde0fcf$exports.DecCoin.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.period = reader.uint64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            rewards: Array.isArray(object?.rewards) ? object.rewards.map((e)=>$783dd8715fde0fcf$exports.DecCoin.fromJSON(e)) : [],
            period: (0, $d5e07fe2518aae94$exports.isSet)(object.period) ? $d5e07fe2518aae94$exports.Long.fromValue(object.period) : $d5e07fe2518aae94$exports.Long.UZERO
        };
    },
    toJSON (message) {
        const obj = {};
        if (message.rewards) obj.rewards = message.rewards.map((e)=>e ? $783dd8715fde0fcf$exports.DecCoin.toJSON(e) : undefined);
        else obj.rewards = [];
        message.period !== undefined && (obj.period = (message.period || $d5e07fe2518aae94$exports.Long.UZERO).toString());
        return obj;
    },
    fromPartial (object) {
        const message = $5ca23c6a841b0ad3$var$createBaseValidatorCurrentRewards();
        message.rewards = object.rewards?.map((e)=>$783dd8715fde0fcf$exports.DecCoin.fromPartial(e)) || [];
        message.period = object.period !== undefined && object.period !== null ? $d5e07fe2518aae94$exports.Long.fromValue(object.period) : $d5e07fe2518aae94$exports.Long.UZERO;
        return message;
    }
};
function $5ca23c6a841b0ad3$var$createBaseValidatorAccumulatedCommission() {
    return {
        commission: []
    };
}
$5ca23c6a841b0ad3$exports.ValidatorAccumulatedCommission = {
    encode (message, writer = $5ca23c6a841b0ad3$var$_m0.Writer.create()) {
        for (const v of message.commission)$783dd8715fde0fcf$exports.DecCoin.encode(v, writer.uint32(10).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $5ca23c6a841b0ad3$var$_m0.Reader ? input : new $5ca23c6a841b0ad3$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $5ca23c6a841b0ad3$var$createBaseValidatorAccumulatedCommission();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.commission.push($783dd8715fde0fcf$exports.DecCoin.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            commission: Array.isArray(object?.commission) ? object.commission.map((e)=>$783dd8715fde0fcf$exports.DecCoin.fromJSON(e)) : []
        };
    },
    toJSON (message) {
        const obj = {};
        if (message.commission) obj.commission = message.commission.map((e)=>e ? $783dd8715fde0fcf$exports.DecCoin.toJSON(e) : undefined);
        else obj.commission = [];
        return obj;
    },
    fromPartial (object) {
        const message = $5ca23c6a841b0ad3$var$createBaseValidatorAccumulatedCommission();
        message.commission = object.commission?.map((e)=>$783dd8715fde0fcf$exports.DecCoin.fromPartial(e)) || [];
        return message;
    }
};
function $5ca23c6a841b0ad3$var$createBaseValidatorOutstandingRewards() {
    return {
        rewards: []
    };
}
$5ca23c6a841b0ad3$exports.ValidatorOutstandingRewards = {
    encode (message, writer = $5ca23c6a841b0ad3$var$_m0.Writer.create()) {
        for (const v of message.rewards)$783dd8715fde0fcf$exports.DecCoin.encode(v, writer.uint32(10).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $5ca23c6a841b0ad3$var$_m0.Reader ? input : new $5ca23c6a841b0ad3$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $5ca23c6a841b0ad3$var$createBaseValidatorOutstandingRewards();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.rewards.push($783dd8715fde0fcf$exports.DecCoin.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            rewards: Array.isArray(object?.rewards) ? object.rewards.map((e)=>$783dd8715fde0fcf$exports.DecCoin.fromJSON(e)) : []
        };
    },
    toJSON (message) {
        const obj = {};
        if (message.rewards) obj.rewards = message.rewards.map((e)=>e ? $783dd8715fde0fcf$exports.DecCoin.toJSON(e) : undefined);
        else obj.rewards = [];
        return obj;
    },
    fromPartial (object) {
        const message = $5ca23c6a841b0ad3$var$createBaseValidatorOutstandingRewards();
        message.rewards = object.rewards?.map((e)=>$783dd8715fde0fcf$exports.DecCoin.fromPartial(e)) || [];
        return message;
    }
};
function $5ca23c6a841b0ad3$var$createBaseValidatorSlashEvent() {
    return {
        validatorPeriod: $d5e07fe2518aae94$exports.Long.UZERO,
        fraction: ""
    };
}
$5ca23c6a841b0ad3$exports.ValidatorSlashEvent = {
    encode (message, writer = $5ca23c6a841b0ad3$var$_m0.Writer.create()) {
        if (!message.validatorPeriod.isZero()) writer.uint32(8).uint64(message.validatorPeriod);
        if (message.fraction !== "") writer.uint32(18).string(message.fraction);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $5ca23c6a841b0ad3$var$_m0.Reader ? input : new $5ca23c6a841b0ad3$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $5ca23c6a841b0ad3$var$createBaseValidatorSlashEvent();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.validatorPeriod = reader.uint64();
                    break;
                case 2:
                    message.fraction = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            validatorPeriod: (0, $d5e07fe2518aae94$exports.isSet)(object.validatorPeriod) ? $d5e07fe2518aae94$exports.Long.fromValue(object.validatorPeriod) : $d5e07fe2518aae94$exports.Long.UZERO,
            fraction: (0, $d5e07fe2518aae94$exports.isSet)(object.fraction) ? String(object.fraction) : ""
        };
    },
    toJSON (message) {
        const obj = {};
        message.validatorPeriod !== undefined && (obj.validatorPeriod = (message.validatorPeriod || $d5e07fe2518aae94$exports.Long.UZERO).toString());
        message.fraction !== undefined && (obj.fraction = message.fraction);
        return obj;
    },
    fromPartial (object) {
        const message = $5ca23c6a841b0ad3$var$createBaseValidatorSlashEvent();
        message.validatorPeriod = object.validatorPeriod !== undefined && object.validatorPeriod !== null ? $d5e07fe2518aae94$exports.Long.fromValue(object.validatorPeriod) : $d5e07fe2518aae94$exports.Long.UZERO;
        message.fraction = object.fraction ?? "";
        return message;
    }
};
function $5ca23c6a841b0ad3$var$createBaseValidatorSlashEvents() {
    return {
        validatorSlashEvents: []
    };
}
$5ca23c6a841b0ad3$exports.ValidatorSlashEvents = {
    encode (message, writer = $5ca23c6a841b0ad3$var$_m0.Writer.create()) {
        for (const v of message.validatorSlashEvents)$5ca23c6a841b0ad3$exports.ValidatorSlashEvent.encode(v, writer.uint32(10).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $5ca23c6a841b0ad3$var$_m0.Reader ? input : new $5ca23c6a841b0ad3$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $5ca23c6a841b0ad3$var$createBaseValidatorSlashEvents();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.validatorSlashEvents.push($5ca23c6a841b0ad3$exports.ValidatorSlashEvent.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            validatorSlashEvents: Array.isArray(object?.validatorSlashEvents) ? object.validatorSlashEvents.map((e)=>$5ca23c6a841b0ad3$exports.ValidatorSlashEvent.fromJSON(e)) : []
        };
    },
    toJSON (message) {
        const obj = {};
        if (message.validatorSlashEvents) obj.validatorSlashEvents = message.validatorSlashEvents.map((e)=>e ? $5ca23c6a841b0ad3$exports.ValidatorSlashEvent.toJSON(e) : undefined);
        else obj.validatorSlashEvents = [];
        return obj;
    },
    fromPartial (object) {
        const message = $5ca23c6a841b0ad3$var$createBaseValidatorSlashEvents();
        message.validatorSlashEvents = object.validatorSlashEvents?.map((e)=>$5ca23c6a841b0ad3$exports.ValidatorSlashEvent.fromPartial(e)) || [];
        return message;
    }
};
function $5ca23c6a841b0ad3$var$createBaseFeePool() {
    return {
        communityPool: []
    };
}
$5ca23c6a841b0ad3$exports.FeePool = {
    encode (message, writer = $5ca23c6a841b0ad3$var$_m0.Writer.create()) {
        for (const v of message.communityPool)$783dd8715fde0fcf$exports.DecCoin.encode(v, writer.uint32(10).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $5ca23c6a841b0ad3$var$_m0.Reader ? input : new $5ca23c6a841b0ad3$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $5ca23c6a841b0ad3$var$createBaseFeePool();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.communityPool.push($783dd8715fde0fcf$exports.DecCoin.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            communityPool: Array.isArray(object?.communityPool) ? object.communityPool.map((e)=>$783dd8715fde0fcf$exports.DecCoin.fromJSON(e)) : []
        };
    },
    toJSON (message) {
        const obj = {};
        if (message.communityPool) obj.communityPool = message.communityPool.map((e)=>e ? $783dd8715fde0fcf$exports.DecCoin.toJSON(e) : undefined);
        else obj.communityPool = [];
        return obj;
    },
    fromPartial (object) {
        const message = $5ca23c6a841b0ad3$var$createBaseFeePool();
        message.communityPool = object.communityPool?.map((e)=>$783dd8715fde0fcf$exports.DecCoin.fromPartial(e)) || [];
        return message;
    }
};
function $5ca23c6a841b0ad3$var$createBaseCommunityPoolSpendProposal() {
    return {
        title: "",
        description: "",
        recipient: "",
        amount: []
    };
}
$5ca23c6a841b0ad3$exports.CommunityPoolSpendProposal = {
    encode (message, writer = $5ca23c6a841b0ad3$var$_m0.Writer.create()) {
        if (message.title !== "") writer.uint32(10).string(message.title);
        if (message.description !== "") writer.uint32(18).string(message.description);
        if (message.recipient !== "") writer.uint32(26).string(message.recipient);
        for (const v of message.amount)$783dd8715fde0fcf$exports.Coin.encode(v, writer.uint32(34).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $5ca23c6a841b0ad3$var$_m0.Reader ? input : new $5ca23c6a841b0ad3$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $5ca23c6a841b0ad3$var$createBaseCommunityPoolSpendProposal();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.title = reader.string();
                    break;
                case 2:
                    message.description = reader.string();
                    break;
                case 3:
                    message.recipient = reader.string();
                    break;
                case 4:
                    message.amount.push($783dd8715fde0fcf$exports.Coin.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            title: (0, $d5e07fe2518aae94$exports.isSet)(object.title) ? String(object.title) : "",
            description: (0, $d5e07fe2518aae94$exports.isSet)(object.description) ? String(object.description) : "",
            recipient: (0, $d5e07fe2518aae94$exports.isSet)(object.recipient) ? String(object.recipient) : "",
            amount: Array.isArray(object?.amount) ? object.amount.map((e)=>$783dd8715fde0fcf$exports.Coin.fromJSON(e)) : []
        };
    },
    toJSON (message) {
        const obj = {};
        message.title !== undefined && (obj.title = message.title);
        message.description !== undefined && (obj.description = message.description);
        message.recipient !== undefined && (obj.recipient = message.recipient);
        if (message.amount) obj.amount = message.amount.map((e)=>e ? $783dd8715fde0fcf$exports.Coin.toJSON(e) : undefined);
        else obj.amount = [];
        return obj;
    },
    fromPartial (object) {
        const message = $5ca23c6a841b0ad3$var$createBaseCommunityPoolSpendProposal();
        message.title = object.title ?? "";
        message.description = object.description ?? "";
        message.recipient = object.recipient ?? "";
        message.amount = object.amount?.map((e)=>$783dd8715fde0fcf$exports.Coin.fromPartial(e)) || [];
        return message;
    }
};
function $5ca23c6a841b0ad3$var$createBaseDelegatorStartingInfo() {
    return {
        previousPeriod: $d5e07fe2518aae94$exports.Long.UZERO,
        stake: "",
        height: $d5e07fe2518aae94$exports.Long.UZERO
    };
}
$5ca23c6a841b0ad3$exports.DelegatorStartingInfo = {
    encode (message, writer = $5ca23c6a841b0ad3$var$_m0.Writer.create()) {
        if (!message.previousPeriod.isZero()) writer.uint32(8).uint64(message.previousPeriod);
        if (message.stake !== "") writer.uint32(18).string(message.stake);
        if (!message.height.isZero()) writer.uint32(24).uint64(message.height);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $5ca23c6a841b0ad3$var$_m0.Reader ? input : new $5ca23c6a841b0ad3$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $5ca23c6a841b0ad3$var$createBaseDelegatorStartingInfo();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.previousPeriod = reader.uint64();
                    break;
                case 2:
                    message.stake = reader.string();
                    break;
                case 3:
                    message.height = reader.uint64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            previousPeriod: (0, $d5e07fe2518aae94$exports.isSet)(object.previousPeriod) ? $d5e07fe2518aae94$exports.Long.fromValue(object.previousPeriod) : $d5e07fe2518aae94$exports.Long.UZERO,
            stake: (0, $d5e07fe2518aae94$exports.isSet)(object.stake) ? String(object.stake) : "",
            height: (0, $d5e07fe2518aae94$exports.isSet)(object.height) ? $d5e07fe2518aae94$exports.Long.fromValue(object.height) : $d5e07fe2518aae94$exports.Long.UZERO
        };
    },
    toJSON (message) {
        const obj = {};
        message.previousPeriod !== undefined && (obj.previousPeriod = (message.previousPeriod || $d5e07fe2518aae94$exports.Long.UZERO).toString());
        message.stake !== undefined && (obj.stake = message.stake);
        message.height !== undefined && (obj.height = (message.height || $d5e07fe2518aae94$exports.Long.UZERO).toString());
        return obj;
    },
    fromPartial (object) {
        const message = $5ca23c6a841b0ad3$var$createBaseDelegatorStartingInfo();
        message.previousPeriod = object.previousPeriod !== undefined && object.previousPeriod !== null ? $d5e07fe2518aae94$exports.Long.fromValue(object.previousPeriod) : $d5e07fe2518aae94$exports.Long.UZERO;
        message.stake = object.stake ?? "";
        message.height = object.height !== undefined && object.height !== null ? $d5e07fe2518aae94$exports.Long.fromValue(object.height) : $d5e07fe2518aae94$exports.Long.UZERO;
        return message;
    }
};
function $5ca23c6a841b0ad3$var$createBaseDelegationDelegatorReward() {
    return {
        validatorAddress: "",
        reward: []
    };
}
$5ca23c6a841b0ad3$exports.DelegationDelegatorReward = {
    encode (message, writer = $5ca23c6a841b0ad3$var$_m0.Writer.create()) {
        if (message.validatorAddress !== "") writer.uint32(10).string(message.validatorAddress);
        for (const v of message.reward)$783dd8715fde0fcf$exports.DecCoin.encode(v, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $5ca23c6a841b0ad3$var$_m0.Reader ? input : new $5ca23c6a841b0ad3$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $5ca23c6a841b0ad3$var$createBaseDelegationDelegatorReward();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.validatorAddress = reader.string();
                    break;
                case 2:
                    message.reward.push($783dd8715fde0fcf$exports.DecCoin.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            validatorAddress: (0, $d5e07fe2518aae94$exports.isSet)(object.validatorAddress) ? String(object.validatorAddress) : "",
            reward: Array.isArray(object?.reward) ? object.reward.map((e)=>$783dd8715fde0fcf$exports.DecCoin.fromJSON(e)) : []
        };
    },
    toJSON (message) {
        const obj = {};
        message.validatorAddress !== undefined && (obj.validatorAddress = message.validatorAddress);
        if (message.reward) obj.reward = message.reward.map((e)=>e ? $783dd8715fde0fcf$exports.DecCoin.toJSON(e) : undefined);
        else obj.reward = [];
        return obj;
    },
    fromPartial (object) {
        const message = $5ca23c6a841b0ad3$var$createBaseDelegationDelegatorReward();
        message.validatorAddress = object.validatorAddress ?? "";
        message.reward = object.reward?.map((e)=>$783dd8715fde0fcf$exports.DecCoin.fromPartial(e)) || [];
        return message;
    }
};
function $5ca23c6a841b0ad3$var$createBaseCommunityPoolSpendProposalWithDeposit() {
    return {
        title: "",
        description: "",
        recipient: "",
        amount: "",
        deposit: ""
    };
}
$5ca23c6a841b0ad3$exports.CommunityPoolSpendProposalWithDeposit = {
    encode (message, writer = $5ca23c6a841b0ad3$var$_m0.Writer.create()) {
        if (message.title !== "") writer.uint32(10).string(message.title);
        if (message.description !== "") writer.uint32(18).string(message.description);
        if (message.recipient !== "") writer.uint32(26).string(message.recipient);
        if (message.amount !== "") writer.uint32(34).string(message.amount);
        if (message.deposit !== "") writer.uint32(42).string(message.deposit);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $5ca23c6a841b0ad3$var$_m0.Reader ? input : new $5ca23c6a841b0ad3$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $5ca23c6a841b0ad3$var$createBaseCommunityPoolSpendProposalWithDeposit();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.title = reader.string();
                    break;
                case 2:
                    message.description = reader.string();
                    break;
                case 3:
                    message.recipient = reader.string();
                    break;
                case 4:
                    message.amount = reader.string();
                    break;
                case 5:
                    message.deposit = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            title: (0, $d5e07fe2518aae94$exports.isSet)(object.title) ? String(object.title) : "",
            description: (0, $d5e07fe2518aae94$exports.isSet)(object.description) ? String(object.description) : "",
            recipient: (0, $d5e07fe2518aae94$exports.isSet)(object.recipient) ? String(object.recipient) : "",
            amount: (0, $d5e07fe2518aae94$exports.isSet)(object.amount) ? String(object.amount) : "",
            deposit: (0, $d5e07fe2518aae94$exports.isSet)(object.deposit) ? String(object.deposit) : ""
        };
    },
    toJSON (message) {
        const obj = {};
        message.title !== undefined && (obj.title = message.title);
        message.description !== undefined && (obj.description = message.description);
        message.recipient !== undefined && (obj.recipient = message.recipient);
        message.amount !== undefined && (obj.amount = message.amount);
        message.deposit !== undefined && (obj.deposit = message.deposit);
        return obj;
    },
    fromPartial (object) {
        const message = $5ca23c6a841b0ad3$var$createBaseCommunityPoolSpendProposalWithDeposit();
        message.title = object.title ?? "";
        message.description = object.description ?? "";
        message.recipient = object.recipient ?? "";
        message.amount = object.amount ?? "";
        message.deposit = object.deposit ?? "";
        return message;
    }
};



const $e8f7350709207109$var$_m0 = $e8f7350709207109$var$__importStar((parcelRequire("fQBv0")));

$e8f7350709207109$exports.protobufPackage = "cosmos.distribution.v1beta1";
function $e8f7350709207109$var$createBaseMsgSetWithdrawAddress() {
    return {
        delegatorAddress: "",
        withdrawAddress: ""
    };
}
$e8f7350709207109$exports.MsgSetWithdrawAddress = {
    encode (message, writer = $e8f7350709207109$var$_m0.Writer.create()) {
        if (message.delegatorAddress !== "") writer.uint32(10).string(message.delegatorAddress);
        if (message.withdrawAddress !== "") writer.uint32(18).string(message.withdrawAddress);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $e8f7350709207109$var$_m0.Reader ? input : new $e8f7350709207109$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $e8f7350709207109$var$createBaseMsgSetWithdrawAddress();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.delegatorAddress = reader.string();
                    break;
                case 2:
                    message.withdrawAddress = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            delegatorAddress: (0, $d5e07fe2518aae94$exports.isSet)(object.delegatorAddress) ? String(object.delegatorAddress) : "",
            withdrawAddress: (0, $d5e07fe2518aae94$exports.isSet)(object.withdrawAddress) ? String(object.withdrawAddress) : ""
        };
    },
    toJSON (message) {
        const obj = {};
        message.delegatorAddress !== undefined && (obj.delegatorAddress = message.delegatorAddress);
        message.withdrawAddress !== undefined && (obj.withdrawAddress = message.withdrawAddress);
        return obj;
    },
    fromPartial (object) {
        const message = $e8f7350709207109$var$createBaseMsgSetWithdrawAddress();
        message.delegatorAddress = object.delegatorAddress ?? "";
        message.withdrawAddress = object.withdrawAddress ?? "";
        return message;
    }
};
function $e8f7350709207109$var$createBaseMsgSetWithdrawAddressResponse() {
    return {};
}
$e8f7350709207109$exports.MsgSetWithdrawAddressResponse = {
    encode (_, writer = $e8f7350709207109$var$_m0.Writer.create()) {
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $e8f7350709207109$var$_m0.Reader ? input : new $e8f7350709207109$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $e8f7350709207109$var$createBaseMsgSetWithdrawAddressResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            tag;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON (_) {
        return {};
    },
    toJSON (_) {
        const obj = {};
        return obj;
    },
    fromPartial (_) {
        const message = $e8f7350709207109$var$createBaseMsgSetWithdrawAddressResponse();
        return message;
    }
};
function $e8f7350709207109$var$createBaseMsgWithdrawDelegatorReward() {
    return {
        delegatorAddress: "",
        validatorAddress: ""
    };
}
$e8f7350709207109$exports.MsgWithdrawDelegatorReward = {
    encode (message, writer = $e8f7350709207109$var$_m0.Writer.create()) {
        if (message.delegatorAddress !== "") writer.uint32(10).string(message.delegatorAddress);
        if (message.validatorAddress !== "") writer.uint32(18).string(message.validatorAddress);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $e8f7350709207109$var$_m0.Reader ? input : new $e8f7350709207109$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $e8f7350709207109$var$createBaseMsgWithdrawDelegatorReward();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.delegatorAddress = reader.string();
                    break;
                case 2:
                    message.validatorAddress = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            delegatorAddress: (0, $d5e07fe2518aae94$exports.isSet)(object.delegatorAddress) ? String(object.delegatorAddress) : "",
            validatorAddress: (0, $d5e07fe2518aae94$exports.isSet)(object.validatorAddress) ? String(object.validatorAddress) : ""
        };
    },
    toJSON (message) {
        const obj = {};
        message.delegatorAddress !== undefined && (obj.delegatorAddress = message.delegatorAddress);
        message.validatorAddress !== undefined && (obj.validatorAddress = message.validatorAddress);
        return obj;
    },
    fromPartial (object) {
        const message = $e8f7350709207109$var$createBaseMsgWithdrawDelegatorReward();
        message.delegatorAddress = object.delegatorAddress ?? "";
        message.validatorAddress = object.validatorAddress ?? "";
        return message;
    }
};
function $e8f7350709207109$var$createBaseMsgWithdrawDelegatorRewardResponse() {
    return {
        amount: []
    };
}
$e8f7350709207109$exports.MsgWithdrawDelegatorRewardResponse = {
    encode (message, writer = $e8f7350709207109$var$_m0.Writer.create()) {
        for (const v of message.amount)$783dd8715fde0fcf$exports.Coin.encode(v, writer.uint32(10).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $e8f7350709207109$var$_m0.Reader ? input : new $e8f7350709207109$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $e8f7350709207109$var$createBaseMsgWithdrawDelegatorRewardResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.amount.push($783dd8715fde0fcf$exports.Coin.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            amount: Array.isArray(object?.amount) ? object.amount.map((e)=>$783dd8715fde0fcf$exports.Coin.fromJSON(e)) : []
        };
    },
    toJSON (message) {
        const obj = {};
        if (message.amount) obj.amount = message.amount.map((e)=>e ? $783dd8715fde0fcf$exports.Coin.toJSON(e) : undefined);
        else obj.amount = [];
        return obj;
    },
    fromPartial (object) {
        const message = $e8f7350709207109$var$createBaseMsgWithdrawDelegatorRewardResponse();
        message.amount = object.amount?.map((e)=>$783dd8715fde0fcf$exports.Coin.fromPartial(e)) || [];
        return message;
    }
};
function $e8f7350709207109$var$createBaseMsgWithdrawValidatorCommission() {
    return {
        validatorAddress: ""
    };
}
$e8f7350709207109$exports.MsgWithdrawValidatorCommission = {
    encode (message, writer = $e8f7350709207109$var$_m0.Writer.create()) {
        if (message.validatorAddress !== "") writer.uint32(10).string(message.validatorAddress);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $e8f7350709207109$var$_m0.Reader ? input : new $e8f7350709207109$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $e8f7350709207109$var$createBaseMsgWithdrawValidatorCommission();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.validatorAddress = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            validatorAddress: (0, $d5e07fe2518aae94$exports.isSet)(object.validatorAddress) ? String(object.validatorAddress) : ""
        };
    },
    toJSON (message) {
        const obj = {};
        message.validatorAddress !== undefined && (obj.validatorAddress = message.validatorAddress);
        return obj;
    },
    fromPartial (object) {
        const message = $e8f7350709207109$var$createBaseMsgWithdrawValidatorCommission();
        message.validatorAddress = object.validatorAddress ?? "";
        return message;
    }
};
function $e8f7350709207109$var$createBaseMsgWithdrawValidatorCommissionResponse() {
    return {
        amount: []
    };
}
$e8f7350709207109$exports.MsgWithdrawValidatorCommissionResponse = {
    encode (message, writer = $e8f7350709207109$var$_m0.Writer.create()) {
        for (const v of message.amount)$783dd8715fde0fcf$exports.Coin.encode(v, writer.uint32(10).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $e8f7350709207109$var$_m0.Reader ? input : new $e8f7350709207109$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $e8f7350709207109$var$createBaseMsgWithdrawValidatorCommissionResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.amount.push($783dd8715fde0fcf$exports.Coin.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            amount: Array.isArray(object?.amount) ? object.amount.map((e)=>$783dd8715fde0fcf$exports.Coin.fromJSON(e)) : []
        };
    },
    toJSON (message) {
        const obj = {};
        if (message.amount) obj.amount = message.amount.map((e)=>e ? $783dd8715fde0fcf$exports.Coin.toJSON(e) : undefined);
        else obj.amount = [];
        return obj;
    },
    fromPartial (object) {
        const message = $e8f7350709207109$var$createBaseMsgWithdrawValidatorCommissionResponse();
        message.amount = object.amount?.map((e)=>$783dd8715fde0fcf$exports.Coin.fromPartial(e)) || [];
        return message;
    }
};
function $e8f7350709207109$var$createBaseMsgFundCommunityPool() {
    return {
        amount: [],
        depositor: ""
    };
}
$e8f7350709207109$exports.MsgFundCommunityPool = {
    encode (message, writer = $e8f7350709207109$var$_m0.Writer.create()) {
        for (const v of message.amount)$783dd8715fde0fcf$exports.Coin.encode(v, writer.uint32(10).fork()).ldelim();
        if (message.depositor !== "") writer.uint32(18).string(message.depositor);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $e8f7350709207109$var$_m0.Reader ? input : new $e8f7350709207109$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $e8f7350709207109$var$createBaseMsgFundCommunityPool();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.amount.push($783dd8715fde0fcf$exports.Coin.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.depositor = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            amount: Array.isArray(object?.amount) ? object.amount.map((e)=>$783dd8715fde0fcf$exports.Coin.fromJSON(e)) : [],
            depositor: (0, $d5e07fe2518aae94$exports.isSet)(object.depositor) ? String(object.depositor) : ""
        };
    },
    toJSON (message) {
        const obj = {};
        if (message.amount) obj.amount = message.amount.map((e)=>e ? $783dd8715fde0fcf$exports.Coin.toJSON(e) : undefined);
        else obj.amount = [];
        message.depositor !== undefined && (obj.depositor = message.depositor);
        return obj;
    },
    fromPartial (object) {
        const message = $e8f7350709207109$var$createBaseMsgFundCommunityPool();
        message.amount = object.amount?.map((e)=>$783dd8715fde0fcf$exports.Coin.fromPartial(e)) || [];
        message.depositor = object.depositor ?? "";
        return message;
    }
};
function $e8f7350709207109$var$createBaseMsgFundCommunityPoolResponse() {
    return {};
}
$e8f7350709207109$exports.MsgFundCommunityPoolResponse = {
    encode (_, writer = $e8f7350709207109$var$_m0.Writer.create()) {
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $e8f7350709207109$var$_m0.Reader ? input : new $e8f7350709207109$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $e8f7350709207109$var$createBaseMsgFundCommunityPoolResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            tag;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON (_) {
        return {};
    },
    toJSON (_) {
        const obj = {};
        return obj;
    },
    fromPartial (_) {
        const message = $e8f7350709207109$var$createBaseMsgFundCommunityPoolResponse();
        return message;
    }
};
function $e8f7350709207109$var$createBaseMsgUpdateParams() {
    return {
        authority: "",
        params: undefined
    };
}
$e8f7350709207109$exports.MsgUpdateParams = {
    encode (message, writer = $e8f7350709207109$var$_m0.Writer.create()) {
        if (message.authority !== "") writer.uint32(10).string(message.authority);
        if (message.params !== undefined) $5ca23c6a841b0ad3$exports.Params.encode(message.params, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $e8f7350709207109$var$_m0.Reader ? input : new $e8f7350709207109$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $e8f7350709207109$var$createBaseMsgUpdateParams();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.authority = reader.string();
                    break;
                case 2:
                    message.params = $5ca23c6a841b0ad3$exports.Params.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            authority: (0, $d5e07fe2518aae94$exports.isSet)(object.authority) ? String(object.authority) : "",
            params: (0, $d5e07fe2518aae94$exports.isSet)(object.params) ? $5ca23c6a841b0ad3$exports.Params.fromJSON(object.params) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.authority !== undefined && (obj.authority = message.authority);
        message.params !== undefined && (obj.params = message.params ? $5ca23c6a841b0ad3$exports.Params.toJSON(message.params) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $e8f7350709207109$var$createBaseMsgUpdateParams();
        message.authority = object.authority ?? "";
        message.params = object.params !== undefined && object.params !== null ? $5ca23c6a841b0ad3$exports.Params.fromPartial(object.params) : undefined;
        return message;
    }
};
function $e8f7350709207109$var$createBaseMsgUpdateParamsResponse() {
    return {};
}
$e8f7350709207109$exports.MsgUpdateParamsResponse = {
    encode (_, writer = $e8f7350709207109$var$_m0.Writer.create()) {
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $e8f7350709207109$var$_m0.Reader ? input : new $e8f7350709207109$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $e8f7350709207109$var$createBaseMsgUpdateParamsResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            tag;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON (_) {
        return {};
    },
    toJSON (_) {
        const obj = {};
        return obj;
    },
    fromPartial (_) {
        const message = $e8f7350709207109$var$createBaseMsgUpdateParamsResponse();
        return message;
    }
};
function $e8f7350709207109$var$createBaseMsgCommunityPoolSpend() {
    return {
        authority: "",
        recipient: "",
        amount: []
    };
}
$e8f7350709207109$exports.MsgCommunityPoolSpend = {
    encode (message, writer = $e8f7350709207109$var$_m0.Writer.create()) {
        if (message.authority !== "") writer.uint32(10).string(message.authority);
        if (message.recipient !== "") writer.uint32(18).string(message.recipient);
        for (const v of message.amount)$783dd8715fde0fcf$exports.Coin.encode(v, writer.uint32(26).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $e8f7350709207109$var$_m0.Reader ? input : new $e8f7350709207109$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $e8f7350709207109$var$createBaseMsgCommunityPoolSpend();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.authority = reader.string();
                    break;
                case 2:
                    message.recipient = reader.string();
                    break;
                case 3:
                    message.amount.push($783dd8715fde0fcf$exports.Coin.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            authority: (0, $d5e07fe2518aae94$exports.isSet)(object.authority) ? String(object.authority) : "",
            recipient: (0, $d5e07fe2518aae94$exports.isSet)(object.recipient) ? String(object.recipient) : "",
            amount: Array.isArray(object?.amount) ? object.amount.map((e)=>$783dd8715fde0fcf$exports.Coin.fromJSON(e)) : []
        };
    },
    toJSON (message) {
        const obj = {};
        message.authority !== undefined && (obj.authority = message.authority);
        message.recipient !== undefined && (obj.recipient = message.recipient);
        if (message.amount) obj.amount = message.amount.map((e)=>e ? $783dd8715fde0fcf$exports.Coin.toJSON(e) : undefined);
        else obj.amount = [];
        return obj;
    },
    fromPartial (object) {
        const message = $e8f7350709207109$var$createBaseMsgCommunityPoolSpend();
        message.authority = object.authority ?? "";
        message.recipient = object.recipient ?? "";
        message.amount = object.amount?.map((e)=>$783dd8715fde0fcf$exports.Coin.fromPartial(e)) || [];
        return message;
    }
};
function $e8f7350709207109$var$createBaseMsgCommunityPoolSpendResponse() {
    return {};
}
$e8f7350709207109$exports.MsgCommunityPoolSpendResponse = {
    encode (_, writer = $e8f7350709207109$var$_m0.Writer.create()) {
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $e8f7350709207109$var$_m0.Reader ? input : new $e8f7350709207109$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $e8f7350709207109$var$createBaseMsgCommunityPoolSpendResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            tag;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON (_) {
        return {};
    },
    toJSON (_) {
        const obj = {};
        return obj;
    },
    fromPartial (_) {
        const message = $e8f7350709207109$var$createBaseMsgCommunityPoolSpendResponse();
        return message;
    }
};
class $e8f7350709207109$var$MsgClientImpl {
    constructor(rpc){
        this.rpc = rpc;
        this.SetWithdrawAddress = this.SetWithdrawAddress.bind(this);
        this.WithdrawDelegatorReward = this.WithdrawDelegatorReward.bind(this);
        this.WithdrawValidatorCommission = this.WithdrawValidatorCommission.bind(this);
        this.FundCommunityPool = this.FundCommunityPool.bind(this);
        this.UpdateParams = this.UpdateParams.bind(this);
        this.CommunityPoolSpend = this.CommunityPoolSpend.bind(this);
    }
    SetWithdrawAddress(request) {
        const data = $e8f7350709207109$exports.MsgSetWithdrawAddress.encode(request).finish();
        const promise = this.rpc.request("cosmos.distribution.v1beta1.Msg", "SetWithdrawAddress", data);
        return promise.then((data)=>$e8f7350709207109$exports.MsgSetWithdrawAddressResponse.decode(new $e8f7350709207109$var$_m0.Reader(data)));
    }
    WithdrawDelegatorReward(request) {
        const data = $e8f7350709207109$exports.MsgWithdrawDelegatorReward.encode(request).finish();
        const promise = this.rpc.request("cosmos.distribution.v1beta1.Msg", "WithdrawDelegatorReward", data);
        return promise.then((data)=>$e8f7350709207109$exports.MsgWithdrawDelegatorRewardResponse.decode(new $e8f7350709207109$var$_m0.Reader(data)));
    }
    WithdrawValidatorCommission(request) {
        const data = $e8f7350709207109$exports.MsgWithdrawValidatorCommission.encode(request).finish();
        const promise = this.rpc.request("cosmos.distribution.v1beta1.Msg", "WithdrawValidatorCommission", data);
        return promise.then((data)=>$e8f7350709207109$exports.MsgWithdrawValidatorCommissionResponse.decode(new $e8f7350709207109$var$_m0.Reader(data)));
    }
    FundCommunityPool(request) {
        const data = $e8f7350709207109$exports.MsgFundCommunityPool.encode(request).finish();
        const promise = this.rpc.request("cosmos.distribution.v1beta1.Msg", "FundCommunityPool", data);
        return promise.then((data)=>$e8f7350709207109$exports.MsgFundCommunityPoolResponse.decode(new $e8f7350709207109$var$_m0.Reader(data)));
    }
    UpdateParams(request) {
        const data = $e8f7350709207109$exports.MsgUpdateParams.encode(request).finish();
        const promise = this.rpc.request("cosmos.distribution.v1beta1.Msg", "UpdateParams", data);
        return promise.then((data)=>$e8f7350709207109$exports.MsgUpdateParamsResponse.decode(new $e8f7350709207109$var$_m0.Reader(data)));
    }
    CommunityPoolSpend(request) {
        const data = $e8f7350709207109$exports.MsgCommunityPoolSpend.encode(request).finish();
        const promise = this.rpc.request("cosmos.distribution.v1beta1.Msg", "CommunityPoolSpend", data);
        return promise.then((data)=>$e8f7350709207109$exports.MsgCommunityPoolSpendResponse.decode(new $e8f7350709207109$var$_m0.Reader(data)));
    }
}
$e8f7350709207109$exports.MsgClientImpl = $e8f7350709207109$var$MsgClientImpl;


$708ba6d31093d4f5$exports.distributionTypes = [
    [
        "/cosmos.distribution.v1beta1.MsgFundCommunityPool",
        $e8f7350709207109$exports.MsgFundCommunityPool
    ],
    [
        "/cosmos.distribution.v1beta1.MsgSetWithdrawAddress",
        $e8f7350709207109$exports.MsgSetWithdrawAddress
    ],
    [
        "/cosmos.distribution.v1beta1.MsgWithdrawDelegatorReward",
        $e8f7350709207109$exports.MsgWithdrawDelegatorReward
    ],
    [
        "/cosmos.distribution.v1beta1.MsgWithdrawValidatorCommission",
        $e8f7350709207109$exports.MsgWithdrawValidatorCommission
    ]
];
function $708ba6d31093d4f5$var$isMsgWithdrawDelegatorRewardEncodeObject(object) {
    return object.typeUrl === "/cosmos.distribution.v1beta1.MsgWithdrawDelegatorReward";
}
$708ba6d31093d4f5$exports.isMsgWithdrawDelegatorRewardEncodeObject = $708ba6d31093d4f5$var$isMsgWithdrawDelegatorRewardEncodeObject;


Object.defineProperty($d0d8b6f4712acd9f$exports, "distributionTypes", {
    enumerable: true,
    get: function() {
        return $708ba6d31093d4f5$exports.distributionTypes;
    }
});
Object.defineProperty($d0d8b6f4712acd9f$exports, "isMsgWithdrawDelegatorRewardEncodeObject", {
    enumerable: true,
    get: function() {
        return $708ba6d31093d4f5$exports.isMsgWithdrawDelegatorRewardEncodeObject;
    }
});
var $a53e3dd09b8c1058$exports = {};
"use strict";
var $a53e3dd09b8c1058$var$__importDefault = $a53e3dd09b8c1058$exports && $a53e3dd09b8c1058$exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty($a53e3dd09b8c1058$exports, "__esModule", {
    value: true
});
$a53e3dd09b8c1058$exports.setupDistributionExtension = void 0;
var $e6dd0975df1c0d7b$exports = {};
"use strict";
var $e6dd0975df1c0d7b$var$__createBinding = $e6dd0975df1c0d7b$exports && $e6dd0975df1c0d7b$exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $e6dd0975df1c0d7b$var$__setModuleDefault = $e6dd0975df1c0d7b$exports && $e6dd0975df1c0d7b$exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $e6dd0975df1c0d7b$var$__importStar = $e6dd0975df1c0d7b$exports && $e6dd0975df1c0d7b$exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $e6dd0975df1c0d7b$var$__createBinding(result, mod, k);
    }
    $e6dd0975df1c0d7b$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty($e6dd0975df1c0d7b$exports, "__esModule", {
    value: true
});
$e6dd0975df1c0d7b$exports.QueryClientImpl = $e6dd0975df1c0d7b$exports.QueryCommunityPoolResponse = $e6dd0975df1c0d7b$exports.QueryCommunityPoolRequest = $e6dd0975df1c0d7b$exports.QueryDelegatorWithdrawAddressResponse = $e6dd0975df1c0d7b$exports.QueryDelegatorWithdrawAddressRequest = $e6dd0975df1c0d7b$exports.QueryDelegatorValidatorsResponse = $e6dd0975df1c0d7b$exports.QueryDelegatorValidatorsRequest = $e6dd0975df1c0d7b$exports.QueryDelegationTotalRewardsResponse = $e6dd0975df1c0d7b$exports.QueryDelegationTotalRewardsRequest = $e6dd0975df1c0d7b$exports.QueryDelegationRewardsResponse = $e6dd0975df1c0d7b$exports.QueryDelegationRewardsRequest = $e6dd0975df1c0d7b$exports.QueryValidatorSlashesResponse = $e6dd0975df1c0d7b$exports.QueryValidatorSlashesRequest = $e6dd0975df1c0d7b$exports.QueryValidatorCommissionResponse = $e6dd0975df1c0d7b$exports.QueryValidatorCommissionRequest = $e6dd0975df1c0d7b$exports.QueryValidatorOutstandingRewardsResponse = $e6dd0975df1c0d7b$exports.QueryValidatorOutstandingRewardsRequest = $e6dd0975df1c0d7b$exports.QueryValidatorDistributionInfoResponse = $e6dd0975df1c0d7b$exports.QueryValidatorDistributionInfoRequest = $e6dd0975df1c0d7b$exports.QueryParamsResponse = $e6dd0975df1c0d7b$exports.QueryParamsRequest = $e6dd0975df1c0d7b$exports.protobufPackage = void 0;





const $e6dd0975df1c0d7b$var$_m0 = $e6dd0975df1c0d7b$var$__importStar((parcelRequire("fQBv0")));
$e6dd0975df1c0d7b$exports.protobufPackage = "cosmos.distribution.v1beta1";
function $e6dd0975df1c0d7b$var$createBaseQueryParamsRequest() {
    return {};
}
$e6dd0975df1c0d7b$exports.QueryParamsRequest = {
    encode (_, writer = $e6dd0975df1c0d7b$var$_m0.Writer.create()) {
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $e6dd0975df1c0d7b$var$_m0.Reader ? input : new $e6dd0975df1c0d7b$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $e6dd0975df1c0d7b$var$createBaseQueryParamsRequest();
        while(reader.pos < end){
            const tag = reader.uint32();
            tag;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON (_) {
        return {};
    },
    toJSON (_) {
        const obj = {};
        return obj;
    },
    fromPartial (_) {
        const message = $e6dd0975df1c0d7b$var$createBaseQueryParamsRequest();
        return message;
    }
};
function $e6dd0975df1c0d7b$var$createBaseQueryParamsResponse() {
    return {
        params: undefined
    };
}
$e6dd0975df1c0d7b$exports.QueryParamsResponse = {
    encode (message, writer = $e6dd0975df1c0d7b$var$_m0.Writer.create()) {
        if (message.params !== undefined) $5ca23c6a841b0ad3$exports.Params.encode(message.params, writer.uint32(10).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $e6dd0975df1c0d7b$var$_m0.Reader ? input : new $e6dd0975df1c0d7b$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $e6dd0975df1c0d7b$var$createBaseQueryParamsResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.params = $5ca23c6a841b0ad3$exports.Params.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            params: (0, $d5e07fe2518aae94$exports.isSet)(object.params) ? $5ca23c6a841b0ad3$exports.Params.fromJSON(object.params) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.params !== undefined && (obj.params = message.params ? $5ca23c6a841b0ad3$exports.Params.toJSON(message.params) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $e6dd0975df1c0d7b$var$createBaseQueryParamsResponse();
        message.params = object.params !== undefined && object.params !== null ? $5ca23c6a841b0ad3$exports.Params.fromPartial(object.params) : undefined;
        return message;
    }
};
function $e6dd0975df1c0d7b$var$createBaseQueryValidatorDistributionInfoRequest() {
    return {
        validatorAddress: ""
    };
}
$e6dd0975df1c0d7b$exports.QueryValidatorDistributionInfoRequest = {
    encode (message, writer = $e6dd0975df1c0d7b$var$_m0.Writer.create()) {
        if (message.validatorAddress !== "") writer.uint32(10).string(message.validatorAddress);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $e6dd0975df1c0d7b$var$_m0.Reader ? input : new $e6dd0975df1c0d7b$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $e6dd0975df1c0d7b$var$createBaseQueryValidatorDistributionInfoRequest();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.validatorAddress = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            validatorAddress: (0, $d5e07fe2518aae94$exports.isSet)(object.validatorAddress) ? String(object.validatorAddress) : ""
        };
    },
    toJSON (message) {
        const obj = {};
        message.validatorAddress !== undefined && (obj.validatorAddress = message.validatorAddress);
        return obj;
    },
    fromPartial (object) {
        const message = $e6dd0975df1c0d7b$var$createBaseQueryValidatorDistributionInfoRequest();
        message.validatorAddress = object.validatorAddress ?? "";
        return message;
    }
};
function $e6dd0975df1c0d7b$var$createBaseQueryValidatorDistributionInfoResponse() {
    return {
        operatorAddress: "",
        selfBondRewards: [],
        commission: []
    };
}
$e6dd0975df1c0d7b$exports.QueryValidatorDistributionInfoResponse = {
    encode (message, writer = $e6dd0975df1c0d7b$var$_m0.Writer.create()) {
        if (message.operatorAddress !== "") writer.uint32(10).string(message.operatorAddress);
        for (const v of message.selfBondRewards)$783dd8715fde0fcf$exports.DecCoin.encode(v, writer.uint32(18).fork()).ldelim();
        for (const v of message.commission)$783dd8715fde0fcf$exports.DecCoin.encode(v, writer.uint32(26).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $e6dd0975df1c0d7b$var$_m0.Reader ? input : new $e6dd0975df1c0d7b$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $e6dd0975df1c0d7b$var$createBaseQueryValidatorDistributionInfoResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.operatorAddress = reader.string();
                    break;
                case 2:
                    message.selfBondRewards.push($783dd8715fde0fcf$exports.DecCoin.decode(reader, reader.uint32()));
                    break;
                case 3:
                    message.commission.push($783dd8715fde0fcf$exports.DecCoin.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            operatorAddress: (0, $d5e07fe2518aae94$exports.isSet)(object.operatorAddress) ? String(object.operatorAddress) : "",
            selfBondRewards: Array.isArray(object?.selfBondRewards) ? object.selfBondRewards.map((e)=>$783dd8715fde0fcf$exports.DecCoin.fromJSON(e)) : [],
            commission: Array.isArray(object?.commission) ? object.commission.map((e)=>$783dd8715fde0fcf$exports.DecCoin.fromJSON(e)) : []
        };
    },
    toJSON (message) {
        const obj = {};
        message.operatorAddress !== undefined && (obj.operatorAddress = message.operatorAddress);
        if (message.selfBondRewards) obj.selfBondRewards = message.selfBondRewards.map((e)=>e ? $783dd8715fde0fcf$exports.DecCoin.toJSON(e) : undefined);
        else obj.selfBondRewards = [];
        if (message.commission) obj.commission = message.commission.map((e)=>e ? $783dd8715fde0fcf$exports.DecCoin.toJSON(e) : undefined);
        else obj.commission = [];
        return obj;
    },
    fromPartial (object) {
        const message = $e6dd0975df1c0d7b$var$createBaseQueryValidatorDistributionInfoResponse();
        message.operatorAddress = object.operatorAddress ?? "";
        message.selfBondRewards = object.selfBondRewards?.map((e)=>$783dd8715fde0fcf$exports.DecCoin.fromPartial(e)) || [];
        message.commission = object.commission?.map((e)=>$783dd8715fde0fcf$exports.DecCoin.fromPartial(e)) || [];
        return message;
    }
};
function $e6dd0975df1c0d7b$var$createBaseQueryValidatorOutstandingRewardsRequest() {
    return {
        validatorAddress: ""
    };
}
$e6dd0975df1c0d7b$exports.QueryValidatorOutstandingRewardsRequest = {
    encode (message, writer = $e6dd0975df1c0d7b$var$_m0.Writer.create()) {
        if (message.validatorAddress !== "") writer.uint32(10).string(message.validatorAddress);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $e6dd0975df1c0d7b$var$_m0.Reader ? input : new $e6dd0975df1c0d7b$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $e6dd0975df1c0d7b$var$createBaseQueryValidatorOutstandingRewardsRequest();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.validatorAddress = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            validatorAddress: (0, $d5e07fe2518aae94$exports.isSet)(object.validatorAddress) ? String(object.validatorAddress) : ""
        };
    },
    toJSON (message) {
        const obj = {};
        message.validatorAddress !== undefined && (obj.validatorAddress = message.validatorAddress);
        return obj;
    },
    fromPartial (object) {
        const message = $e6dd0975df1c0d7b$var$createBaseQueryValidatorOutstandingRewardsRequest();
        message.validatorAddress = object.validatorAddress ?? "";
        return message;
    }
};
function $e6dd0975df1c0d7b$var$createBaseQueryValidatorOutstandingRewardsResponse() {
    return {
        rewards: undefined
    };
}
$e6dd0975df1c0d7b$exports.QueryValidatorOutstandingRewardsResponse = {
    encode (message, writer = $e6dd0975df1c0d7b$var$_m0.Writer.create()) {
        if (message.rewards !== undefined) $5ca23c6a841b0ad3$exports.ValidatorOutstandingRewards.encode(message.rewards, writer.uint32(10).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $e6dd0975df1c0d7b$var$_m0.Reader ? input : new $e6dd0975df1c0d7b$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $e6dd0975df1c0d7b$var$createBaseQueryValidatorOutstandingRewardsResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.rewards = $5ca23c6a841b0ad3$exports.ValidatorOutstandingRewards.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            rewards: (0, $d5e07fe2518aae94$exports.isSet)(object.rewards) ? $5ca23c6a841b0ad3$exports.ValidatorOutstandingRewards.fromJSON(object.rewards) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.rewards !== undefined && (obj.rewards = message.rewards ? $5ca23c6a841b0ad3$exports.ValidatorOutstandingRewards.toJSON(message.rewards) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $e6dd0975df1c0d7b$var$createBaseQueryValidatorOutstandingRewardsResponse();
        message.rewards = object.rewards !== undefined && object.rewards !== null ? $5ca23c6a841b0ad3$exports.ValidatorOutstandingRewards.fromPartial(object.rewards) : undefined;
        return message;
    }
};
function $e6dd0975df1c0d7b$var$createBaseQueryValidatorCommissionRequest() {
    return {
        validatorAddress: ""
    };
}
$e6dd0975df1c0d7b$exports.QueryValidatorCommissionRequest = {
    encode (message, writer = $e6dd0975df1c0d7b$var$_m0.Writer.create()) {
        if (message.validatorAddress !== "") writer.uint32(10).string(message.validatorAddress);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $e6dd0975df1c0d7b$var$_m0.Reader ? input : new $e6dd0975df1c0d7b$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $e6dd0975df1c0d7b$var$createBaseQueryValidatorCommissionRequest();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.validatorAddress = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            validatorAddress: (0, $d5e07fe2518aae94$exports.isSet)(object.validatorAddress) ? String(object.validatorAddress) : ""
        };
    },
    toJSON (message) {
        const obj = {};
        message.validatorAddress !== undefined && (obj.validatorAddress = message.validatorAddress);
        return obj;
    },
    fromPartial (object) {
        const message = $e6dd0975df1c0d7b$var$createBaseQueryValidatorCommissionRequest();
        message.validatorAddress = object.validatorAddress ?? "";
        return message;
    }
};
function $e6dd0975df1c0d7b$var$createBaseQueryValidatorCommissionResponse() {
    return {
        commission: undefined
    };
}
$e6dd0975df1c0d7b$exports.QueryValidatorCommissionResponse = {
    encode (message, writer = $e6dd0975df1c0d7b$var$_m0.Writer.create()) {
        if (message.commission !== undefined) $5ca23c6a841b0ad3$exports.ValidatorAccumulatedCommission.encode(message.commission, writer.uint32(10).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $e6dd0975df1c0d7b$var$_m0.Reader ? input : new $e6dd0975df1c0d7b$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $e6dd0975df1c0d7b$var$createBaseQueryValidatorCommissionResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.commission = $5ca23c6a841b0ad3$exports.ValidatorAccumulatedCommission.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            commission: (0, $d5e07fe2518aae94$exports.isSet)(object.commission) ? $5ca23c6a841b0ad3$exports.ValidatorAccumulatedCommission.fromJSON(object.commission) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.commission !== undefined && (obj.commission = message.commission ? $5ca23c6a841b0ad3$exports.ValidatorAccumulatedCommission.toJSON(message.commission) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $e6dd0975df1c0d7b$var$createBaseQueryValidatorCommissionResponse();
        message.commission = object.commission !== undefined && object.commission !== null ? $5ca23c6a841b0ad3$exports.ValidatorAccumulatedCommission.fromPartial(object.commission) : undefined;
        return message;
    }
};
function $e6dd0975df1c0d7b$var$createBaseQueryValidatorSlashesRequest() {
    return {
        validatorAddress: "",
        startingHeight: $d5e07fe2518aae94$exports.Long.UZERO,
        endingHeight: $d5e07fe2518aae94$exports.Long.UZERO,
        pagination: undefined
    };
}
$e6dd0975df1c0d7b$exports.QueryValidatorSlashesRequest = {
    encode (message, writer = $e6dd0975df1c0d7b$var$_m0.Writer.create()) {
        if (message.validatorAddress !== "") writer.uint32(10).string(message.validatorAddress);
        if (!message.startingHeight.isZero()) writer.uint32(16).uint64(message.startingHeight);
        if (!message.endingHeight.isZero()) writer.uint32(24).uint64(message.endingHeight);
        if (message.pagination !== undefined) $5eae5f3cc99e92ab$exports.PageRequest.encode(message.pagination, writer.uint32(34).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $e6dd0975df1c0d7b$var$_m0.Reader ? input : new $e6dd0975df1c0d7b$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $e6dd0975df1c0d7b$var$createBaseQueryValidatorSlashesRequest();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.validatorAddress = reader.string();
                    break;
                case 2:
                    message.startingHeight = reader.uint64();
                    break;
                case 3:
                    message.endingHeight = reader.uint64();
                    break;
                case 4:
                    message.pagination = $5eae5f3cc99e92ab$exports.PageRequest.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            validatorAddress: (0, $d5e07fe2518aae94$exports.isSet)(object.validatorAddress) ? String(object.validatorAddress) : "",
            startingHeight: (0, $d5e07fe2518aae94$exports.isSet)(object.startingHeight) ? $d5e07fe2518aae94$exports.Long.fromValue(object.startingHeight) : $d5e07fe2518aae94$exports.Long.UZERO,
            endingHeight: (0, $d5e07fe2518aae94$exports.isSet)(object.endingHeight) ? $d5e07fe2518aae94$exports.Long.fromValue(object.endingHeight) : $d5e07fe2518aae94$exports.Long.UZERO,
            pagination: (0, $d5e07fe2518aae94$exports.isSet)(object.pagination) ? $5eae5f3cc99e92ab$exports.PageRequest.fromJSON(object.pagination) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.validatorAddress !== undefined && (obj.validatorAddress = message.validatorAddress);
        message.startingHeight !== undefined && (obj.startingHeight = (message.startingHeight || $d5e07fe2518aae94$exports.Long.UZERO).toString());
        message.endingHeight !== undefined && (obj.endingHeight = (message.endingHeight || $d5e07fe2518aae94$exports.Long.UZERO).toString());
        message.pagination !== undefined && (obj.pagination = message.pagination ? $5eae5f3cc99e92ab$exports.PageRequest.toJSON(message.pagination) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $e6dd0975df1c0d7b$var$createBaseQueryValidatorSlashesRequest();
        message.validatorAddress = object.validatorAddress ?? "";
        message.startingHeight = object.startingHeight !== undefined && object.startingHeight !== null ? $d5e07fe2518aae94$exports.Long.fromValue(object.startingHeight) : $d5e07fe2518aae94$exports.Long.UZERO;
        message.endingHeight = object.endingHeight !== undefined && object.endingHeight !== null ? $d5e07fe2518aae94$exports.Long.fromValue(object.endingHeight) : $d5e07fe2518aae94$exports.Long.UZERO;
        message.pagination = object.pagination !== undefined && object.pagination !== null ? $5eae5f3cc99e92ab$exports.PageRequest.fromPartial(object.pagination) : undefined;
        return message;
    }
};
function $e6dd0975df1c0d7b$var$createBaseQueryValidatorSlashesResponse() {
    return {
        slashes: [],
        pagination: undefined
    };
}
$e6dd0975df1c0d7b$exports.QueryValidatorSlashesResponse = {
    encode (message, writer = $e6dd0975df1c0d7b$var$_m0.Writer.create()) {
        for (const v of message.slashes)$5ca23c6a841b0ad3$exports.ValidatorSlashEvent.encode(v, writer.uint32(10).fork()).ldelim();
        if (message.pagination !== undefined) $5eae5f3cc99e92ab$exports.PageResponse.encode(message.pagination, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $e6dd0975df1c0d7b$var$_m0.Reader ? input : new $e6dd0975df1c0d7b$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $e6dd0975df1c0d7b$var$createBaseQueryValidatorSlashesResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.slashes.push($5ca23c6a841b0ad3$exports.ValidatorSlashEvent.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.pagination = $5eae5f3cc99e92ab$exports.PageResponse.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            slashes: Array.isArray(object?.slashes) ? object.slashes.map((e)=>$5ca23c6a841b0ad3$exports.ValidatorSlashEvent.fromJSON(e)) : [],
            pagination: (0, $d5e07fe2518aae94$exports.isSet)(object.pagination) ? $5eae5f3cc99e92ab$exports.PageResponse.fromJSON(object.pagination) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        if (message.slashes) obj.slashes = message.slashes.map((e)=>e ? $5ca23c6a841b0ad3$exports.ValidatorSlashEvent.toJSON(e) : undefined);
        else obj.slashes = [];
        message.pagination !== undefined && (obj.pagination = message.pagination ? $5eae5f3cc99e92ab$exports.PageResponse.toJSON(message.pagination) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $e6dd0975df1c0d7b$var$createBaseQueryValidatorSlashesResponse();
        message.slashes = object.slashes?.map((e)=>$5ca23c6a841b0ad3$exports.ValidatorSlashEvent.fromPartial(e)) || [];
        message.pagination = object.pagination !== undefined && object.pagination !== null ? $5eae5f3cc99e92ab$exports.PageResponse.fromPartial(object.pagination) : undefined;
        return message;
    }
};
function $e6dd0975df1c0d7b$var$createBaseQueryDelegationRewardsRequest() {
    return {
        delegatorAddress: "",
        validatorAddress: ""
    };
}
$e6dd0975df1c0d7b$exports.QueryDelegationRewardsRequest = {
    encode (message, writer = $e6dd0975df1c0d7b$var$_m0.Writer.create()) {
        if (message.delegatorAddress !== "") writer.uint32(10).string(message.delegatorAddress);
        if (message.validatorAddress !== "") writer.uint32(18).string(message.validatorAddress);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $e6dd0975df1c0d7b$var$_m0.Reader ? input : new $e6dd0975df1c0d7b$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $e6dd0975df1c0d7b$var$createBaseQueryDelegationRewardsRequest();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.delegatorAddress = reader.string();
                    break;
                case 2:
                    message.validatorAddress = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            delegatorAddress: (0, $d5e07fe2518aae94$exports.isSet)(object.delegatorAddress) ? String(object.delegatorAddress) : "",
            validatorAddress: (0, $d5e07fe2518aae94$exports.isSet)(object.validatorAddress) ? String(object.validatorAddress) : ""
        };
    },
    toJSON (message) {
        const obj = {};
        message.delegatorAddress !== undefined && (obj.delegatorAddress = message.delegatorAddress);
        message.validatorAddress !== undefined && (obj.validatorAddress = message.validatorAddress);
        return obj;
    },
    fromPartial (object) {
        const message = $e6dd0975df1c0d7b$var$createBaseQueryDelegationRewardsRequest();
        message.delegatorAddress = object.delegatorAddress ?? "";
        message.validatorAddress = object.validatorAddress ?? "";
        return message;
    }
};
function $e6dd0975df1c0d7b$var$createBaseQueryDelegationRewardsResponse() {
    return {
        rewards: []
    };
}
$e6dd0975df1c0d7b$exports.QueryDelegationRewardsResponse = {
    encode (message, writer = $e6dd0975df1c0d7b$var$_m0.Writer.create()) {
        for (const v of message.rewards)$783dd8715fde0fcf$exports.DecCoin.encode(v, writer.uint32(10).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $e6dd0975df1c0d7b$var$_m0.Reader ? input : new $e6dd0975df1c0d7b$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $e6dd0975df1c0d7b$var$createBaseQueryDelegationRewardsResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.rewards.push($783dd8715fde0fcf$exports.DecCoin.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            rewards: Array.isArray(object?.rewards) ? object.rewards.map((e)=>$783dd8715fde0fcf$exports.DecCoin.fromJSON(e)) : []
        };
    },
    toJSON (message) {
        const obj = {};
        if (message.rewards) obj.rewards = message.rewards.map((e)=>e ? $783dd8715fde0fcf$exports.DecCoin.toJSON(e) : undefined);
        else obj.rewards = [];
        return obj;
    },
    fromPartial (object) {
        const message = $e6dd0975df1c0d7b$var$createBaseQueryDelegationRewardsResponse();
        message.rewards = object.rewards?.map((e)=>$783dd8715fde0fcf$exports.DecCoin.fromPartial(e)) || [];
        return message;
    }
};
function $e6dd0975df1c0d7b$var$createBaseQueryDelegationTotalRewardsRequest() {
    return {
        delegatorAddress: ""
    };
}
$e6dd0975df1c0d7b$exports.QueryDelegationTotalRewardsRequest = {
    encode (message, writer = $e6dd0975df1c0d7b$var$_m0.Writer.create()) {
        if (message.delegatorAddress !== "") writer.uint32(10).string(message.delegatorAddress);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $e6dd0975df1c0d7b$var$_m0.Reader ? input : new $e6dd0975df1c0d7b$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $e6dd0975df1c0d7b$var$createBaseQueryDelegationTotalRewardsRequest();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.delegatorAddress = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            delegatorAddress: (0, $d5e07fe2518aae94$exports.isSet)(object.delegatorAddress) ? String(object.delegatorAddress) : ""
        };
    },
    toJSON (message) {
        const obj = {};
        message.delegatorAddress !== undefined && (obj.delegatorAddress = message.delegatorAddress);
        return obj;
    },
    fromPartial (object) {
        const message = $e6dd0975df1c0d7b$var$createBaseQueryDelegationTotalRewardsRequest();
        message.delegatorAddress = object.delegatorAddress ?? "";
        return message;
    }
};
function $e6dd0975df1c0d7b$var$createBaseQueryDelegationTotalRewardsResponse() {
    return {
        rewards: [],
        total: []
    };
}
$e6dd0975df1c0d7b$exports.QueryDelegationTotalRewardsResponse = {
    encode (message, writer = $e6dd0975df1c0d7b$var$_m0.Writer.create()) {
        for (const v of message.rewards)$5ca23c6a841b0ad3$exports.DelegationDelegatorReward.encode(v, writer.uint32(10).fork()).ldelim();
        for (const v of message.total)$783dd8715fde0fcf$exports.DecCoin.encode(v, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $e6dd0975df1c0d7b$var$_m0.Reader ? input : new $e6dd0975df1c0d7b$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $e6dd0975df1c0d7b$var$createBaseQueryDelegationTotalRewardsResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.rewards.push($5ca23c6a841b0ad3$exports.DelegationDelegatorReward.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.total.push($783dd8715fde0fcf$exports.DecCoin.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            rewards: Array.isArray(object?.rewards) ? object.rewards.map((e)=>$5ca23c6a841b0ad3$exports.DelegationDelegatorReward.fromJSON(e)) : [],
            total: Array.isArray(object?.total) ? object.total.map((e)=>$783dd8715fde0fcf$exports.DecCoin.fromJSON(e)) : []
        };
    },
    toJSON (message) {
        const obj = {};
        if (message.rewards) obj.rewards = message.rewards.map((e)=>e ? $5ca23c6a841b0ad3$exports.DelegationDelegatorReward.toJSON(e) : undefined);
        else obj.rewards = [];
        if (message.total) obj.total = message.total.map((e)=>e ? $783dd8715fde0fcf$exports.DecCoin.toJSON(e) : undefined);
        else obj.total = [];
        return obj;
    },
    fromPartial (object) {
        const message = $e6dd0975df1c0d7b$var$createBaseQueryDelegationTotalRewardsResponse();
        message.rewards = object.rewards?.map((e)=>$5ca23c6a841b0ad3$exports.DelegationDelegatorReward.fromPartial(e)) || [];
        message.total = object.total?.map((e)=>$783dd8715fde0fcf$exports.DecCoin.fromPartial(e)) || [];
        return message;
    }
};
function $e6dd0975df1c0d7b$var$createBaseQueryDelegatorValidatorsRequest() {
    return {
        delegatorAddress: ""
    };
}
$e6dd0975df1c0d7b$exports.QueryDelegatorValidatorsRequest = {
    encode (message, writer = $e6dd0975df1c0d7b$var$_m0.Writer.create()) {
        if (message.delegatorAddress !== "") writer.uint32(10).string(message.delegatorAddress);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $e6dd0975df1c0d7b$var$_m0.Reader ? input : new $e6dd0975df1c0d7b$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $e6dd0975df1c0d7b$var$createBaseQueryDelegatorValidatorsRequest();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.delegatorAddress = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            delegatorAddress: (0, $d5e07fe2518aae94$exports.isSet)(object.delegatorAddress) ? String(object.delegatorAddress) : ""
        };
    },
    toJSON (message) {
        const obj = {};
        message.delegatorAddress !== undefined && (obj.delegatorAddress = message.delegatorAddress);
        return obj;
    },
    fromPartial (object) {
        const message = $e6dd0975df1c0d7b$var$createBaseQueryDelegatorValidatorsRequest();
        message.delegatorAddress = object.delegatorAddress ?? "";
        return message;
    }
};
function $e6dd0975df1c0d7b$var$createBaseQueryDelegatorValidatorsResponse() {
    return {
        validators: []
    };
}
$e6dd0975df1c0d7b$exports.QueryDelegatorValidatorsResponse = {
    encode (message, writer = $e6dd0975df1c0d7b$var$_m0.Writer.create()) {
        for (const v of message.validators)writer.uint32(10).string(v);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $e6dd0975df1c0d7b$var$_m0.Reader ? input : new $e6dd0975df1c0d7b$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $e6dd0975df1c0d7b$var$createBaseQueryDelegatorValidatorsResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.validators.push(reader.string());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            validators: Array.isArray(object?.validators) ? object.validators.map((e)=>String(e)) : []
        };
    },
    toJSON (message) {
        const obj = {};
        if (message.validators) obj.validators = message.validators.map((e)=>e);
        else obj.validators = [];
        return obj;
    },
    fromPartial (object) {
        const message = $e6dd0975df1c0d7b$var$createBaseQueryDelegatorValidatorsResponse();
        message.validators = object.validators?.map((e)=>e) || [];
        return message;
    }
};
function $e6dd0975df1c0d7b$var$createBaseQueryDelegatorWithdrawAddressRequest() {
    return {
        delegatorAddress: ""
    };
}
$e6dd0975df1c0d7b$exports.QueryDelegatorWithdrawAddressRequest = {
    encode (message, writer = $e6dd0975df1c0d7b$var$_m0.Writer.create()) {
        if (message.delegatorAddress !== "") writer.uint32(10).string(message.delegatorAddress);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $e6dd0975df1c0d7b$var$_m0.Reader ? input : new $e6dd0975df1c0d7b$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $e6dd0975df1c0d7b$var$createBaseQueryDelegatorWithdrawAddressRequest();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.delegatorAddress = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            delegatorAddress: (0, $d5e07fe2518aae94$exports.isSet)(object.delegatorAddress) ? String(object.delegatorAddress) : ""
        };
    },
    toJSON (message) {
        const obj = {};
        message.delegatorAddress !== undefined && (obj.delegatorAddress = message.delegatorAddress);
        return obj;
    },
    fromPartial (object) {
        const message = $e6dd0975df1c0d7b$var$createBaseQueryDelegatorWithdrawAddressRequest();
        message.delegatorAddress = object.delegatorAddress ?? "";
        return message;
    }
};
function $e6dd0975df1c0d7b$var$createBaseQueryDelegatorWithdrawAddressResponse() {
    return {
        withdrawAddress: ""
    };
}
$e6dd0975df1c0d7b$exports.QueryDelegatorWithdrawAddressResponse = {
    encode (message, writer = $e6dd0975df1c0d7b$var$_m0.Writer.create()) {
        if (message.withdrawAddress !== "") writer.uint32(10).string(message.withdrawAddress);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $e6dd0975df1c0d7b$var$_m0.Reader ? input : new $e6dd0975df1c0d7b$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $e6dd0975df1c0d7b$var$createBaseQueryDelegatorWithdrawAddressResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.withdrawAddress = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            withdrawAddress: (0, $d5e07fe2518aae94$exports.isSet)(object.withdrawAddress) ? String(object.withdrawAddress) : ""
        };
    },
    toJSON (message) {
        const obj = {};
        message.withdrawAddress !== undefined && (obj.withdrawAddress = message.withdrawAddress);
        return obj;
    },
    fromPartial (object) {
        const message = $e6dd0975df1c0d7b$var$createBaseQueryDelegatorWithdrawAddressResponse();
        message.withdrawAddress = object.withdrawAddress ?? "";
        return message;
    }
};
function $e6dd0975df1c0d7b$var$createBaseQueryCommunityPoolRequest() {
    return {};
}
$e6dd0975df1c0d7b$exports.QueryCommunityPoolRequest = {
    encode (_, writer = $e6dd0975df1c0d7b$var$_m0.Writer.create()) {
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $e6dd0975df1c0d7b$var$_m0.Reader ? input : new $e6dd0975df1c0d7b$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $e6dd0975df1c0d7b$var$createBaseQueryCommunityPoolRequest();
        while(reader.pos < end){
            const tag = reader.uint32();
            tag;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON (_) {
        return {};
    },
    toJSON (_) {
        const obj = {};
        return obj;
    },
    fromPartial (_) {
        const message = $e6dd0975df1c0d7b$var$createBaseQueryCommunityPoolRequest();
        return message;
    }
};
function $e6dd0975df1c0d7b$var$createBaseQueryCommunityPoolResponse() {
    return {
        pool: []
    };
}
$e6dd0975df1c0d7b$exports.QueryCommunityPoolResponse = {
    encode (message, writer = $e6dd0975df1c0d7b$var$_m0.Writer.create()) {
        for (const v of message.pool)$783dd8715fde0fcf$exports.DecCoin.encode(v, writer.uint32(10).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $e6dd0975df1c0d7b$var$_m0.Reader ? input : new $e6dd0975df1c0d7b$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $e6dd0975df1c0d7b$var$createBaseQueryCommunityPoolResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.pool.push($783dd8715fde0fcf$exports.DecCoin.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            pool: Array.isArray(object?.pool) ? object.pool.map((e)=>$783dd8715fde0fcf$exports.DecCoin.fromJSON(e)) : []
        };
    },
    toJSON (message) {
        const obj = {};
        if (message.pool) obj.pool = message.pool.map((e)=>e ? $783dd8715fde0fcf$exports.DecCoin.toJSON(e) : undefined);
        else obj.pool = [];
        return obj;
    },
    fromPartial (object) {
        const message = $e6dd0975df1c0d7b$var$createBaseQueryCommunityPoolResponse();
        message.pool = object.pool?.map((e)=>$783dd8715fde0fcf$exports.DecCoin.fromPartial(e)) || [];
        return message;
    }
};
class $e6dd0975df1c0d7b$var$QueryClientImpl {
    constructor(rpc){
        this.rpc = rpc;
        this.Params = this.Params.bind(this);
        this.ValidatorDistributionInfo = this.ValidatorDistributionInfo.bind(this);
        this.ValidatorOutstandingRewards = this.ValidatorOutstandingRewards.bind(this);
        this.ValidatorCommission = this.ValidatorCommission.bind(this);
        this.ValidatorSlashes = this.ValidatorSlashes.bind(this);
        this.DelegationRewards = this.DelegationRewards.bind(this);
        this.DelegationTotalRewards = this.DelegationTotalRewards.bind(this);
        this.DelegatorValidators = this.DelegatorValidators.bind(this);
        this.DelegatorWithdrawAddress = this.DelegatorWithdrawAddress.bind(this);
        this.CommunityPool = this.CommunityPool.bind(this);
    }
    Params(request = {}) {
        const data = $e6dd0975df1c0d7b$exports.QueryParamsRequest.encode(request).finish();
        const promise = this.rpc.request("cosmos.distribution.v1beta1.Query", "Params", data);
        return promise.then((data)=>$e6dd0975df1c0d7b$exports.QueryParamsResponse.decode(new $e6dd0975df1c0d7b$var$_m0.Reader(data)));
    }
    ValidatorDistributionInfo(request) {
        const data = $e6dd0975df1c0d7b$exports.QueryValidatorDistributionInfoRequest.encode(request).finish();
        const promise = this.rpc.request("cosmos.distribution.v1beta1.Query", "ValidatorDistributionInfo", data);
        return promise.then((data)=>$e6dd0975df1c0d7b$exports.QueryValidatorDistributionInfoResponse.decode(new $e6dd0975df1c0d7b$var$_m0.Reader(data)));
    }
    ValidatorOutstandingRewards(request) {
        const data = $e6dd0975df1c0d7b$exports.QueryValidatorOutstandingRewardsRequest.encode(request).finish();
        const promise = this.rpc.request("cosmos.distribution.v1beta1.Query", "ValidatorOutstandingRewards", data);
        return promise.then((data)=>$e6dd0975df1c0d7b$exports.QueryValidatorOutstandingRewardsResponse.decode(new $e6dd0975df1c0d7b$var$_m0.Reader(data)));
    }
    ValidatorCommission(request) {
        const data = $e6dd0975df1c0d7b$exports.QueryValidatorCommissionRequest.encode(request).finish();
        const promise = this.rpc.request("cosmos.distribution.v1beta1.Query", "ValidatorCommission", data);
        return promise.then((data)=>$e6dd0975df1c0d7b$exports.QueryValidatorCommissionResponse.decode(new $e6dd0975df1c0d7b$var$_m0.Reader(data)));
    }
    ValidatorSlashes(request) {
        const data = $e6dd0975df1c0d7b$exports.QueryValidatorSlashesRequest.encode(request).finish();
        const promise = this.rpc.request("cosmos.distribution.v1beta1.Query", "ValidatorSlashes", data);
        return promise.then((data)=>$e6dd0975df1c0d7b$exports.QueryValidatorSlashesResponse.decode(new $e6dd0975df1c0d7b$var$_m0.Reader(data)));
    }
    DelegationRewards(request) {
        const data = $e6dd0975df1c0d7b$exports.QueryDelegationRewardsRequest.encode(request).finish();
        const promise = this.rpc.request("cosmos.distribution.v1beta1.Query", "DelegationRewards", data);
        return promise.then((data)=>$e6dd0975df1c0d7b$exports.QueryDelegationRewardsResponse.decode(new $e6dd0975df1c0d7b$var$_m0.Reader(data)));
    }
    DelegationTotalRewards(request) {
        const data = $e6dd0975df1c0d7b$exports.QueryDelegationTotalRewardsRequest.encode(request).finish();
        const promise = this.rpc.request("cosmos.distribution.v1beta1.Query", "DelegationTotalRewards", data);
        return promise.then((data)=>$e6dd0975df1c0d7b$exports.QueryDelegationTotalRewardsResponse.decode(new $e6dd0975df1c0d7b$var$_m0.Reader(data)));
    }
    DelegatorValidators(request) {
        const data = $e6dd0975df1c0d7b$exports.QueryDelegatorValidatorsRequest.encode(request).finish();
        const promise = this.rpc.request("cosmos.distribution.v1beta1.Query", "DelegatorValidators", data);
        return promise.then((data)=>$e6dd0975df1c0d7b$exports.QueryDelegatorValidatorsResponse.decode(new $e6dd0975df1c0d7b$var$_m0.Reader(data)));
    }
    DelegatorWithdrawAddress(request) {
        const data = $e6dd0975df1c0d7b$exports.QueryDelegatorWithdrawAddressRequest.encode(request).finish();
        const promise = this.rpc.request("cosmos.distribution.v1beta1.Query", "DelegatorWithdrawAddress", data);
        return promise.then((data)=>$e6dd0975df1c0d7b$exports.QueryDelegatorWithdrawAddressResponse.decode(new $e6dd0975df1c0d7b$var$_m0.Reader(data)));
    }
    CommunityPool(request = {}) {
        const data = $e6dd0975df1c0d7b$exports.QueryCommunityPoolRequest.encode(request).finish();
        const promise = this.rpc.request("cosmos.distribution.v1beta1.Query", "CommunityPool", data);
        return promise.then((data)=>$e6dd0975df1c0d7b$exports.QueryCommunityPoolResponse.decode(new $e6dd0975df1c0d7b$var$_m0.Reader(data)));
    }
}
$e6dd0975df1c0d7b$exports.QueryClientImpl = $e6dd0975df1c0d7b$var$QueryClientImpl;



const $a53e3dd09b8c1058$var$long_1 = $a53e3dd09b8c1058$var$__importDefault((parcelRequire("jRkuS")));

function $a53e3dd09b8c1058$var$setupDistributionExtension(base) {
    const rpc = (0, $a3959936d2cce854$exports.createProtobufRpcClient)(base);
    // Use this service to get easy typed access to query methods
    // This cannot be used for proof verification
    const queryService = new $e6dd0975df1c0d7b$exports.QueryClientImpl(rpc);
    return {
        distribution: {
            communityPool: async ()=>{
                const response = await queryService.CommunityPool({});
                return response;
            },
            delegationRewards: async (delegatorAddress, validatorAddress)=>{
                const response = await queryService.DelegationRewards({
                    delegatorAddress: delegatorAddress,
                    validatorAddress: validatorAddress
                });
                return response;
            },
            delegationTotalRewards: async (delegatorAddress)=>{
                const response = await queryService.DelegationTotalRewards({
                    delegatorAddress: delegatorAddress
                });
                return response;
            },
            delegatorValidators: async (delegatorAddress)=>{
                const response = await queryService.DelegatorValidators({
                    delegatorAddress: delegatorAddress
                });
                return response;
            },
            delegatorWithdrawAddress: async (delegatorAddress)=>{
                const response = await queryService.DelegatorWithdrawAddress({
                    delegatorAddress: delegatorAddress
                });
                return response;
            },
            params: async ()=>{
                const response = await queryService.Params({});
                return response;
            },
            validatorCommission: async (validatorAddress)=>{
                const response = await queryService.ValidatorCommission({
                    validatorAddress: validatorAddress
                });
                return response;
            },
            validatorOutstandingRewards: async (validatorAddress)=>{
                const response = await queryService.ValidatorOutstandingRewards({
                    validatorAddress: validatorAddress
                });
                return response;
            },
            validatorSlashes: async (validatorAddress, startingHeight, endingHeight, paginationKey)=>{
                const response = await queryService.ValidatorSlashes({
                    validatorAddress: validatorAddress,
                    startingHeight: $a53e3dd09b8c1058$var$long_1.default.fromNumber(startingHeight, true),
                    endingHeight: $a53e3dd09b8c1058$var$long_1.default.fromNumber(endingHeight, true),
                    pagination: (0, $a3959936d2cce854$exports.createPagination)(paginationKey)
                });
                return response;
            }
        }
    };
}
$a53e3dd09b8c1058$exports.setupDistributionExtension = $a53e3dd09b8c1058$var$setupDistributionExtension;


Object.defineProperty($d0d8b6f4712acd9f$exports, "setupDistributionExtension", {
    enumerable: true,
    get: function() {
        return $a53e3dd09b8c1058$exports.setupDistributionExtension;
    }
});
var $cece76f4b229f621$exports = {};
"use strict";
Object.defineProperty($cece76f4b229f621$exports, "__esModule", {
    value: true
});
$cece76f4b229f621$exports.createEvidenceAminoConverters = $cece76f4b229f621$exports.isAminoMsgSubmitEvidence = void 0;
function $cece76f4b229f621$var$isAminoMsgSubmitEvidence(msg) {
    return msg.type === "cosmos-sdk/MsgSubmitEvidence";
}
$cece76f4b229f621$exports.isAminoMsgSubmitEvidence = $cece76f4b229f621$var$isAminoMsgSubmitEvidence;
function $cece76f4b229f621$var$createEvidenceAminoConverters() {
    throw new Error("Not implemented");
}
$cece76f4b229f621$exports.createEvidenceAminoConverters = $cece76f4b229f621$var$createEvidenceAminoConverters;


Object.defineProperty($d0d8b6f4712acd9f$exports, "createEvidenceAminoConverters", {
    enumerable: true,
    get: function() {
        return $cece76f4b229f621$exports.createEvidenceAminoConverters;
    }
});
Object.defineProperty($d0d8b6f4712acd9f$exports, "isAminoMsgSubmitEvidence", {
    enumerable: true,
    get: function() {
        return $cece76f4b229f621$exports.isAminoMsgSubmitEvidence;
    }
});
var $e8a74fdf0b550fc4$exports = {};
"use strict";
Object.defineProperty($e8a74fdf0b550fc4$exports, "__esModule", {
    value: true
});
$e8a74fdf0b550fc4$exports.createFeegrantAminoConverters = void 0;
function $e8a74fdf0b550fc4$var$createFeegrantAminoConverters() {
    return {
    };
}
$e8a74fdf0b550fc4$exports.createFeegrantAminoConverters = $e8a74fdf0b550fc4$var$createFeegrantAminoConverters;


Object.defineProperty($d0d8b6f4712acd9f$exports, "createFeegrantAminoConverters", {
    enumerable: true,
    get: function() {
        return $e8a74fdf0b550fc4$exports.createFeegrantAminoConverters;
    }
});
var $a2f50a2833272b94$exports = {};
"use strict";
Object.defineProperty($a2f50a2833272b94$exports, "__esModule", {
    value: true
});
$a2f50a2833272b94$exports.feegrantTypes = void 0;
var $f5037c3b3d3f4e8e$exports = {};
"use strict";
var $f5037c3b3d3f4e8e$var$__createBinding = $f5037c3b3d3f4e8e$exports && $f5037c3b3d3f4e8e$exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $f5037c3b3d3f4e8e$var$__setModuleDefault = $f5037c3b3d3f4e8e$exports && $f5037c3b3d3f4e8e$exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $f5037c3b3d3f4e8e$var$__importStar = $f5037c3b3d3f4e8e$exports && $f5037c3b3d3f4e8e$exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $f5037c3b3d3f4e8e$var$__createBinding(result, mod, k);
    }
    $f5037c3b3d3f4e8e$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty($f5037c3b3d3f4e8e$exports, "__esModule", {
    value: true
});
$f5037c3b3d3f4e8e$exports.MsgClientImpl = $f5037c3b3d3f4e8e$exports.MsgRevokeAllowanceResponse = $f5037c3b3d3f4e8e$exports.MsgRevokeAllowance = $f5037c3b3d3f4e8e$exports.MsgGrantAllowanceResponse = $f5037c3b3d3f4e8e$exports.MsgGrantAllowance = $f5037c3b3d3f4e8e$exports.protobufPackage = void 0;


const $f5037c3b3d3f4e8e$var$_m0 = $f5037c3b3d3f4e8e$var$__importStar((parcelRequire("fQBv0")));

$f5037c3b3d3f4e8e$exports.protobufPackage = "cosmos.feegrant.v1beta1";
function $f5037c3b3d3f4e8e$var$createBaseMsgGrantAllowance() {
    return {
        granter: "",
        grantee: "",
        allowance: undefined
    };
}
$f5037c3b3d3f4e8e$exports.MsgGrantAllowance = {
    encode (message, writer = $f5037c3b3d3f4e8e$var$_m0.Writer.create()) {
        if (message.granter !== "") writer.uint32(10).string(message.granter);
        if (message.grantee !== "") writer.uint32(18).string(message.grantee);
        if (message.allowance !== undefined) $64138e590dcf0cc1$exports.Any.encode(message.allowance, writer.uint32(26).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $f5037c3b3d3f4e8e$var$_m0.Reader ? input : new $f5037c3b3d3f4e8e$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $f5037c3b3d3f4e8e$var$createBaseMsgGrantAllowance();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.granter = reader.string();
                    break;
                case 2:
                    message.grantee = reader.string();
                    break;
                case 3:
                    message.allowance = $64138e590dcf0cc1$exports.Any.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            granter: (0, $d5e07fe2518aae94$exports.isSet)(object.granter) ? String(object.granter) : "",
            grantee: (0, $d5e07fe2518aae94$exports.isSet)(object.grantee) ? String(object.grantee) : "",
            allowance: (0, $d5e07fe2518aae94$exports.isSet)(object.allowance) ? $64138e590dcf0cc1$exports.Any.fromJSON(object.allowance) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.granter !== undefined && (obj.granter = message.granter);
        message.grantee !== undefined && (obj.grantee = message.grantee);
        message.allowance !== undefined && (obj.allowance = message.allowance ? $64138e590dcf0cc1$exports.Any.toJSON(message.allowance) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $f5037c3b3d3f4e8e$var$createBaseMsgGrantAllowance();
        message.granter = object.granter ?? "";
        message.grantee = object.grantee ?? "";
        message.allowance = object.allowance !== undefined && object.allowance !== null ? $64138e590dcf0cc1$exports.Any.fromPartial(object.allowance) : undefined;
        return message;
    }
};
function $f5037c3b3d3f4e8e$var$createBaseMsgGrantAllowanceResponse() {
    return {};
}
$f5037c3b3d3f4e8e$exports.MsgGrantAllowanceResponse = {
    encode (_, writer = $f5037c3b3d3f4e8e$var$_m0.Writer.create()) {
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $f5037c3b3d3f4e8e$var$_m0.Reader ? input : new $f5037c3b3d3f4e8e$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $f5037c3b3d3f4e8e$var$createBaseMsgGrantAllowanceResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            tag;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON (_) {
        return {};
    },
    toJSON (_) {
        const obj = {};
        return obj;
    },
    fromPartial (_) {
        const message = $f5037c3b3d3f4e8e$var$createBaseMsgGrantAllowanceResponse();
        return message;
    }
};
function $f5037c3b3d3f4e8e$var$createBaseMsgRevokeAllowance() {
    return {
        granter: "",
        grantee: ""
    };
}
$f5037c3b3d3f4e8e$exports.MsgRevokeAllowance = {
    encode (message, writer = $f5037c3b3d3f4e8e$var$_m0.Writer.create()) {
        if (message.granter !== "") writer.uint32(10).string(message.granter);
        if (message.grantee !== "") writer.uint32(18).string(message.grantee);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $f5037c3b3d3f4e8e$var$_m0.Reader ? input : new $f5037c3b3d3f4e8e$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $f5037c3b3d3f4e8e$var$createBaseMsgRevokeAllowance();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.granter = reader.string();
                    break;
                case 2:
                    message.grantee = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            granter: (0, $d5e07fe2518aae94$exports.isSet)(object.granter) ? String(object.granter) : "",
            grantee: (0, $d5e07fe2518aae94$exports.isSet)(object.grantee) ? String(object.grantee) : ""
        };
    },
    toJSON (message) {
        const obj = {};
        message.granter !== undefined && (obj.granter = message.granter);
        message.grantee !== undefined && (obj.grantee = message.grantee);
        return obj;
    },
    fromPartial (object) {
        const message = $f5037c3b3d3f4e8e$var$createBaseMsgRevokeAllowance();
        message.granter = object.granter ?? "";
        message.grantee = object.grantee ?? "";
        return message;
    }
};
function $f5037c3b3d3f4e8e$var$createBaseMsgRevokeAllowanceResponse() {
    return {};
}
$f5037c3b3d3f4e8e$exports.MsgRevokeAllowanceResponse = {
    encode (_, writer = $f5037c3b3d3f4e8e$var$_m0.Writer.create()) {
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $f5037c3b3d3f4e8e$var$_m0.Reader ? input : new $f5037c3b3d3f4e8e$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $f5037c3b3d3f4e8e$var$createBaseMsgRevokeAllowanceResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            tag;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON (_) {
        return {};
    },
    toJSON (_) {
        const obj = {};
        return obj;
    },
    fromPartial (_) {
        const message = $f5037c3b3d3f4e8e$var$createBaseMsgRevokeAllowanceResponse();
        return message;
    }
};
class $f5037c3b3d3f4e8e$var$MsgClientImpl {
    constructor(rpc){
        this.rpc = rpc;
        this.GrantAllowance = this.GrantAllowance.bind(this);
        this.RevokeAllowance = this.RevokeAllowance.bind(this);
    }
    GrantAllowance(request) {
        const data = $f5037c3b3d3f4e8e$exports.MsgGrantAllowance.encode(request).finish();
        const promise = this.rpc.request("cosmos.feegrant.v1beta1.Msg", "GrantAllowance", data);
        return promise.then((data)=>$f5037c3b3d3f4e8e$exports.MsgGrantAllowanceResponse.decode(new $f5037c3b3d3f4e8e$var$_m0.Reader(data)));
    }
    RevokeAllowance(request) {
        const data = $f5037c3b3d3f4e8e$exports.MsgRevokeAllowance.encode(request).finish();
        const promise = this.rpc.request("cosmos.feegrant.v1beta1.Msg", "RevokeAllowance", data);
        return promise.then((data)=>$f5037c3b3d3f4e8e$exports.MsgRevokeAllowanceResponse.decode(new $f5037c3b3d3f4e8e$var$_m0.Reader(data)));
    }
}
$f5037c3b3d3f4e8e$exports.MsgClientImpl = $f5037c3b3d3f4e8e$var$MsgClientImpl;


$a2f50a2833272b94$exports.feegrantTypes = [
    [
        "/cosmos.feegrant.v1beta1.MsgGrantAllowance",
        $f5037c3b3d3f4e8e$exports.MsgGrantAllowance
    ],
    [
        "/cosmos.feegrant.v1beta1.MsgRevokeAllowance",
        $f5037c3b3d3f4e8e$exports.MsgRevokeAllowance
    ]
];


Object.defineProperty($d0d8b6f4712acd9f$exports, "feegrantTypes", {
    enumerable: true,
    get: function() {
        return $a2f50a2833272b94$exports.feegrantTypes;
    }
});
var $b97e79a32963f84f$exports = {};
"use strict";
Object.defineProperty($b97e79a32963f84f$exports, "__esModule", {
    value: true
});
$b97e79a32963f84f$exports.setupFeegrantExtension = void 0;
var $ce2d87a37cd899f9$exports = {};
"use strict";
var $ce2d87a37cd899f9$var$__createBinding = $ce2d87a37cd899f9$exports && $ce2d87a37cd899f9$exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $ce2d87a37cd899f9$var$__setModuleDefault = $ce2d87a37cd899f9$exports && $ce2d87a37cd899f9$exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $ce2d87a37cd899f9$var$__importStar = $ce2d87a37cd899f9$exports && $ce2d87a37cd899f9$exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $ce2d87a37cd899f9$var$__createBinding(result, mod, k);
    }
    $ce2d87a37cd899f9$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty($ce2d87a37cd899f9$exports, "__esModule", {
    value: true
});
$ce2d87a37cd899f9$exports.QueryClientImpl = $ce2d87a37cd899f9$exports.QueryAllowancesByGranterResponse = $ce2d87a37cd899f9$exports.QueryAllowancesByGranterRequest = $ce2d87a37cd899f9$exports.QueryAllowancesResponse = $ce2d87a37cd899f9$exports.QueryAllowancesRequest = $ce2d87a37cd899f9$exports.QueryAllowanceResponse = $ce2d87a37cd899f9$exports.QueryAllowanceRequest = $ce2d87a37cd899f9$exports.protobufPackage = void 0;

var $b3fcf38b6e640544$exports = {};
"use strict";
var $b3fcf38b6e640544$var$__createBinding = $b3fcf38b6e640544$exports && $b3fcf38b6e640544$exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $b3fcf38b6e640544$var$__setModuleDefault = $b3fcf38b6e640544$exports && $b3fcf38b6e640544$exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $b3fcf38b6e640544$var$__importStar = $b3fcf38b6e640544$exports && $b3fcf38b6e640544$exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $b3fcf38b6e640544$var$__createBinding(result, mod, k);
    }
    $b3fcf38b6e640544$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty($b3fcf38b6e640544$exports, "__esModule", {
    value: true
});
$b3fcf38b6e640544$exports.Grant = $b3fcf38b6e640544$exports.AllowedMsgAllowance = $b3fcf38b6e640544$exports.PeriodicAllowance = $b3fcf38b6e640544$exports.BasicAllowance = $b3fcf38b6e640544$exports.protobufPackage = void 0;


var $fe534fae4538ccbf$exports = {};
"use strict";
var $fe534fae4538ccbf$var$__createBinding = $fe534fae4538ccbf$exports && $fe534fae4538ccbf$exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $fe534fae4538ccbf$var$__setModuleDefault = $fe534fae4538ccbf$exports && $fe534fae4538ccbf$exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $fe534fae4538ccbf$var$__importStar = $fe534fae4538ccbf$exports && $fe534fae4538ccbf$exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $fe534fae4538ccbf$var$__createBinding(result, mod, k);
    }
    $fe534fae4538ccbf$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty($fe534fae4538ccbf$exports, "__esModule", {
    value: true
});
$fe534fae4538ccbf$exports.Duration = $fe534fae4538ccbf$exports.protobufPackage = void 0;


const $fe534fae4538ccbf$var$_m0 = $fe534fae4538ccbf$var$__importStar((parcelRequire("fQBv0")));
$fe534fae4538ccbf$exports.protobufPackage = "google.protobuf";
function $fe534fae4538ccbf$var$createBaseDuration() {
    return {
        seconds: $d5e07fe2518aae94$exports.Long.ZERO,
        nanos: 0
    };
}
$fe534fae4538ccbf$exports.Duration = {
    encode (message, writer = $fe534fae4538ccbf$var$_m0.Writer.create()) {
        if (!message.seconds.isZero()) writer.uint32(8).int64(message.seconds);
        if (message.nanos !== 0) writer.uint32(16).int32(message.nanos);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $fe534fae4538ccbf$var$_m0.Reader ? input : new $fe534fae4538ccbf$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $fe534fae4538ccbf$var$createBaseDuration();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.seconds = reader.int64();
                    break;
                case 2:
                    message.nanos = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            seconds: (0, $d5e07fe2518aae94$exports.isSet)(object.seconds) ? $d5e07fe2518aae94$exports.Long.fromValue(object.seconds) : $d5e07fe2518aae94$exports.Long.ZERO,
            nanos: (0, $d5e07fe2518aae94$exports.isSet)(object.nanos) ? Number(object.nanos) : 0
        };
    },
    toJSON (message) {
        const obj = {};
        message.seconds !== undefined && (obj.seconds = (message.seconds || $d5e07fe2518aae94$exports.Long.ZERO).toString());
        message.nanos !== undefined && (obj.nanos = Math.round(message.nanos));
        return obj;
    },
    fromPartial (object) {
        const message = $fe534fae4538ccbf$var$createBaseDuration();
        message.seconds = object.seconds !== undefined && object.seconds !== null ? $d5e07fe2518aae94$exports.Long.fromValue(object.seconds) : $d5e07fe2518aae94$exports.Long.ZERO;
        message.nanos = object.nanos ?? 0;
        return message;
    }
};




const $b3fcf38b6e640544$var$_m0 = $b3fcf38b6e640544$var$__importStar((parcelRequire("fQBv0")));

$b3fcf38b6e640544$exports.protobufPackage = "cosmos.feegrant.v1beta1";
function $b3fcf38b6e640544$var$createBaseBasicAllowance() {
    return {
        spendLimit: [],
        expiration: undefined
    };
}
$b3fcf38b6e640544$exports.BasicAllowance = {
    encode (message, writer = $b3fcf38b6e640544$var$_m0.Writer.create()) {
        for (const v of message.spendLimit)$783dd8715fde0fcf$exports.Coin.encode(v, writer.uint32(10).fork()).ldelim();
        if (message.expiration !== undefined) $e7eaeedc85b414fc$exports.Timestamp.encode(message.expiration, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $b3fcf38b6e640544$var$_m0.Reader ? input : new $b3fcf38b6e640544$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $b3fcf38b6e640544$var$createBaseBasicAllowance();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.spendLimit.push($783dd8715fde0fcf$exports.Coin.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.expiration = $e7eaeedc85b414fc$exports.Timestamp.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            spendLimit: Array.isArray(object?.spendLimit) ? object.spendLimit.map((e)=>$783dd8715fde0fcf$exports.Coin.fromJSON(e)) : [],
            expiration: (0, $d5e07fe2518aae94$exports.isSet)(object.expiration) ? (0, $d5e07fe2518aae94$exports.fromJsonTimestamp)(object.expiration) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        if (message.spendLimit) obj.spendLimit = message.spendLimit.map((e)=>e ? $783dd8715fde0fcf$exports.Coin.toJSON(e) : undefined);
        else obj.spendLimit = [];
        message.expiration !== undefined && (obj.expiration = (0, $d5e07fe2518aae94$exports.fromTimestamp)(message.expiration).toISOString());
        return obj;
    },
    fromPartial (object) {
        const message = $b3fcf38b6e640544$var$createBaseBasicAllowance();
        message.spendLimit = object.spendLimit?.map((e)=>$783dd8715fde0fcf$exports.Coin.fromPartial(e)) || [];
        message.expiration = object.expiration !== undefined && object.expiration !== null ? $e7eaeedc85b414fc$exports.Timestamp.fromPartial(object.expiration) : undefined;
        return message;
    }
};
function $b3fcf38b6e640544$var$createBasePeriodicAllowance() {
    return {
        basic: undefined,
        period: undefined,
        periodSpendLimit: [],
        periodCanSpend: [],
        periodReset: undefined
    };
}
$b3fcf38b6e640544$exports.PeriodicAllowance = {
    encode (message, writer = $b3fcf38b6e640544$var$_m0.Writer.create()) {
        if (message.basic !== undefined) $b3fcf38b6e640544$exports.BasicAllowance.encode(message.basic, writer.uint32(10).fork()).ldelim();
        if (message.period !== undefined) $fe534fae4538ccbf$exports.Duration.encode(message.period, writer.uint32(18).fork()).ldelim();
        for (const v of message.periodSpendLimit)$783dd8715fde0fcf$exports.Coin.encode(v, writer.uint32(26).fork()).ldelim();
        for (const v of message.periodCanSpend)$783dd8715fde0fcf$exports.Coin.encode(v, writer.uint32(34).fork()).ldelim();
        if (message.periodReset !== undefined) $e7eaeedc85b414fc$exports.Timestamp.encode(message.periodReset, writer.uint32(42).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $b3fcf38b6e640544$var$_m0.Reader ? input : new $b3fcf38b6e640544$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $b3fcf38b6e640544$var$createBasePeriodicAllowance();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.basic = $b3fcf38b6e640544$exports.BasicAllowance.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.period = $fe534fae4538ccbf$exports.Duration.decode(reader, reader.uint32());
                    break;
                case 3:
                    message.periodSpendLimit.push($783dd8715fde0fcf$exports.Coin.decode(reader, reader.uint32()));
                    break;
                case 4:
                    message.periodCanSpend.push($783dd8715fde0fcf$exports.Coin.decode(reader, reader.uint32()));
                    break;
                case 5:
                    message.periodReset = $e7eaeedc85b414fc$exports.Timestamp.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            basic: (0, $d5e07fe2518aae94$exports.isSet)(object.basic) ? $b3fcf38b6e640544$exports.BasicAllowance.fromJSON(object.basic) : undefined,
            period: (0, $d5e07fe2518aae94$exports.isSet)(object.period) ? $fe534fae4538ccbf$exports.Duration.fromJSON(object.period) : undefined,
            periodSpendLimit: Array.isArray(object?.periodSpendLimit) ? object.periodSpendLimit.map((e)=>$783dd8715fde0fcf$exports.Coin.fromJSON(e)) : [],
            periodCanSpend: Array.isArray(object?.periodCanSpend) ? object.periodCanSpend.map((e)=>$783dd8715fde0fcf$exports.Coin.fromJSON(e)) : [],
            periodReset: (0, $d5e07fe2518aae94$exports.isSet)(object.periodReset) ? (0, $d5e07fe2518aae94$exports.fromJsonTimestamp)(object.periodReset) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.basic !== undefined && (obj.basic = message.basic ? $b3fcf38b6e640544$exports.BasicAllowance.toJSON(message.basic) : undefined);
        message.period !== undefined && (obj.period = message.period ? $fe534fae4538ccbf$exports.Duration.toJSON(message.period) : undefined);
        if (message.periodSpendLimit) obj.periodSpendLimit = message.periodSpendLimit.map((e)=>e ? $783dd8715fde0fcf$exports.Coin.toJSON(e) : undefined);
        else obj.periodSpendLimit = [];
        if (message.periodCanSpend) obj.periodCanSpend = message.periodCanSpend.map((e)=>e ? $783dd8715fde0fcf$exports.Coin.toJSON(e) : undefined);
        else obj.periodCanSpend = [];
        message.periodReset !== undefined && (obj.periodReset = (0, $d5e07fe2518aae94$exports.fromTimestamp)(message.periodReset).toISOString());
        return obj;
    },
    fromPartial (object) {
        const message = $b3fcf38b6e640544$var$createBasePeriodicAllowance();
        message.basic = object.basic !== undefined && object.basic !== null ? $b3fcf38b6e640544$exports.BasicAllowance.fromPartial(object.basic) : undefined;
        message.period = object.period !== undefined && object.period !== null ? $fe534fae4538ccbf$exports.Duration.fromPartial(object.period) : undefined;
        message.periodSpendLimit = object.periodSpendLimit?.map((e)=>$783dd8715fde0fcf$exports.Coin.fromPartial(e)) || [];
        message.periodCanSpend = object.periodCanSpend?.map((e)=>$783dd8715fde0fcf$exports.Coin.fromPartial(e)) || [];
        message.periodReset = object.periodReset !== undefined && object.periodReset !== null ? $e7eaeedc85b414fc$exports.Timestamp.fromPartial(object.periodReset) : undefined;
        return message;
    }
};
function $b3fcf38b6e640544$var$createBaseAllowedMsgAllowance() {
    return {
        allowance: undefined,
        allowedMessages: []
    };
}
$b3fcf38b6e640544$exports.AllowedMsgAllowance = {
    encode (message, writer = $b3fcf38b6e640544$var$_m0.Writer.create()) {
        if (message.allowance !== undefined) $64138e590dcf0cc1$exports.Any.encode(message.allowance, writer.uint32(10).fork()).ldelim();
        for (const v of message.allowedMessages)writer.uint32(18).string(v);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $b3fcf38b6e640544$var$_m0.Reader ? input : new $b3fcf38b6e640544$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $b3fcf38b6e640544$var$createBaseAllowedMsgAllowance();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.allowance = $64138e590dcf0cc1$exports.Any.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.allowedMessages.push(reader.string());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            allowance: (0, $d5e07fe2518aae94$exports.isSet)(object.allowance) ? $64138e590dcf0cc1$exports.Any.fromJSON(object.allowance) : undefined,
            allowedMessages: Array.isArray(object?.allowedMessages) ? object.allowedMessages.map((e)=>String(e)) : []
        };
    },
    toJSON (message) {
        const obj = {};
        message.allowance !== undefined && (obj.allowance = message.allowance ? $64138e590dcf0cc1$exports.Any.toJSON(message.allowance) : undefined);
        if (message.allowedMessages) obj.allowedMessages = message.allowedMessages.map((e)=>e);
        else obj.allowedMessages = [];
        return obj;
    },
    fromPartial (object) {
        const message = $b3fcf38b6e640544$var$createBaseAllowedMsgAllowance();
        message.allowance = object.allowance !== undefined && object.allowance !== null ? $64138e590dcf0cc1$exports.Any.fromPartial(object.allowance) : undefined;
        message.allowedMessages = object.allowedMessages?.map((e)=>e) || [];
        return message;
    }
};
function $b3fcf38b6e640544$var$createBaseGrant() {
    return {
        granter: "",
        grantee: "",
        allowance: undefined
    };
}
$b3fcf38b6e640544$exports.Grant = {
    encode (message, writer = $b3fcf38b6e640544$var$_m0.Writer.create()) {
        if (message.granter !== "") writer.uint32(10).string(message.granter);
        if (message.grantee !== "") writer.uint32(18).string(message.grantee);
        if (message.allowance !== undefined) $64138e590dcf0cc1$exports.Any.encode(message.allowance, writer.uint32(26).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $b3fcf38b6e640544$var$_m0.Reader ? input : new $b3fcf38b6e640544$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $b3fcf38b6e640544$var$createBaseGrant();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.granter = reader.string();
                    break;
                case 2:
                    message.grantee = reader.string();
                    break;
                case 3:
                    message.allowance = $64138e590dcf0cc1$exports.Any.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            granter: (0, $d5e07fe2518aae94$exports.isSet)(object.granter) ? String(object.granter) : "",
            grantee: (0, $d5e07fe2518aae94$exports.isSet)(object.grantee) ? String(object.grantee) : "",
            allowance: (0, $d5e07fe2518aae94$exports.isSet)(object.allowance) ? $64138e590dcf0cc1$exports.Any.fromJSON(object.allowance) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.granter !== undefined && (obj.granter = message.granter);
        message.grantee !== undefined && (obj.grantee = message.grantee);
        message.allowance !== undefined && (obj.allowance = message.allowance ? $64138e590dcf0cc1$exports.Any.toJSON(message.allowance) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $b3fcf38b6e640544$var$createBaseGrant();
        message.granter = object.granter ?? "";
        message.grantee = object.grantee ?? "";
        message.allowance = object.allowance !== undefined && object.allowance !== null ? $64138e590dcf0cc1$exports.Any.fromPartial(object.allowance) : undefined;
        return message;
    }
};



const $ce2d87a37cd899f9$var$_m0 = $ce2d87a37cd899f9$var$__importStar((parcelRequire("fQBv0")));

$ce2d87a37cd899f9$exports.protobufPackage = "cosmos.feegrant.v1beta1";
function $ce2d87a37cd899f9$var$createBaseQueryAllowanceRequest() {
    return {
        granter: "",
        grantee: ""
    };
}
$ce2d87a37cd899f9$exports.QueryAllowanceRequest = {
    encode (message, writer = $ce2d87a37cd899f9$var$_m0.Writer.create()) {
        if (message.granter !== "") writer.uint32(10).string(message.granter);
        if (message.grantee !== "") writer.uint32(18).string(message.grantee);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $ce2d87a37cd899f9$var$_m0.Reader ? input : new $ce2d87a37cd899f9$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $ce2d87a37cd899f9$var$createBaseQueryAllowanceRequest();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.granter = reader.string();
                    break;
                case 2:
                    message.grantee = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            granter: (0, $d5e07fe2518aae94$exports.isSet)(object.granter) ? String(object.granter) : "",
            grantee: (0, $d5e07fe2518aae94$exports.isSet)(object.grantee) ? String(object.grantee) : ""
        };
    },
    toJSON (message) {
        const obj = {};
        message.granter !== undefined && (obj.granter = message.granter);
        message.grantee !== undefined && (obj.grantee = message.grantee);
        return obj;
    },
    fromPartial (object) {
        const message = $ce2d87a37cd899f9$var$createBaseQueryAllowanceRequest();
        message.granter = object.granter ?? "";
        message.grantee = object.grantee ?? "";
        return message;
    }
};
function $ce2d87a37cd899f9$var$createBaseQueryAllowanceResponse() {
    return {
        allowance: undefined
    };
}
$ce2d87a37cd899f9$exports.QueryAllowanceResponse = {
    encode (message, writer = $ce2d87a37cd899f9$var$_m0.Writer.create()) {
        if (message.allowance !== undefined) $b3fcf38b6e640544$exports.Grant.encode(message.allowance, writer.uint32(10).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $ce2d87a37cd899f9$var$_m0.Reader ? input : new $ce2d87a37cd899f9$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $ce2d87a37cd899f9$var$createBaseQueryAllowanceResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.allowance = $b3fcf38b6e640544$exports.Grant.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            allowance: (0, $d5e07fe2518aae94$exports.isSet)(object.allowance) ? $b3fcf38b6e640544$exports.Grant.fromJSON(object.allowance) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.allowance !== undefined && (obj.allowance = message.allowance ? $b3fcf38b6e640544$exports.Grant.toJSON(message.allowance) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $ce2d87a37cd899f9$var$createBaseQueryAllowanceResponse();
        message.allowance = object.allowance !== undefined && object.allowance !== null ? $b3fcf38b6e640544$exports.Grant.fromPartial(object.allowance) : undefined;
        return message;
    }
};
function $ce2d87a37cd899f9$var$createBaseQueryAllowancesRequest() {
    return {
        grantee: "",
        pagination: undefined
    };
}
$ce2d87a37cd899f9$exports.QueryAllowancesRequest = {
    encode (message, writer = $ce2d87a37cd899f9$var$_m0.Writer.create()) {
        if (message.grantee !== "") writer.uint32(10).string(message.grantee);
        if (message.pagination !== undefined) $5eae5f3cc99e92ab$exports.PageRequest.encode(message.pagination, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $ce2d87a37cd899f9$var$_m0.Reader ? input : new $ce2d87a37cd899f9$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $ce2d87a37cd899f9$var$createBaseQueryAllowancesRequest();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.grantee = reader.string();
                    break;
                case 2:
                    message.pagination = $5eae5f3cc99e92ab$exports.PageRequest.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            grantee: (0, $d5e07fe2518aae94$exports.isSet)(object.grantee) ? String(object.grantee) : "",
            pagination: (0, $d5e07fe2518aae94$exports.isSet)(object.pagination) ? $5eae5f3cc99e92ab$exports.PageRequest.fromJSON(object.pagination) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.grantee !== undefined && (obj.grantee = message.grantee);
        message.pagination !== undefined && (obj.pagination = message.pagination ? $5eae5f3cc99e92ab$exports.PageRequest.toJSON(message.pagination) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $ce2d87a37cd899f9$var$createBaseQueryAllowancesRequest();
        message.grantee = object.grantee ?? "";
        message.pagination = object.pagination !== undefined && object.pagination !== null ? $5eae5f3cc99e92ab$exports.PageRequest.fromPartial(object.pagination) : undefined;
        return message;
    }
};
function $ce2d87a37cd899f9$var$createBaseQueryAllowancesResponse() {
    return {
        allowances: [],
        pagination: undefined
    };
}
$ce2d87a37cd899f9$exports.QueryAllowancesResponse = {
    encode (message, writer = $ce2d87a37cd899f9$var$_m0.Writer.create()) {
        for (const v of message.allowances)$b3fcf38b6e640544$exports.Grant.encode(v, writer.uint32(10).fork()).ldelim();
        if (message.pagination !== undefined) $5eae5f3cc99e92ab$exports.PageResponse.encode(message.pagination, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $ce2d87a37cd899f9$var$_m0.Reader ? input : new $ce2d87a37cd899f9$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $ce2d87a37cd899f9$var$createBaseQueryAllowancesResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.allowances.push($b3fcf38b6e640544$exports.Grant.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.pagination = $5eae5f3cc99e92ab$exports.PageResponse.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            allowances: Array.isArray(object?.allowances) ? object.allowances.map((e)=>$b3fcf38b6e640544$exports.Grant.fromJSON(e)) : [],
            pagination: (0, $d5e07fe2518aae94$exports.isSet)(object.pagination) ? $5eae5f3cc99e92ab$exports.PageResponse.fromJSON(object.pagination) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        if (message.allowances) obj.allowances = message.allowances.map((e)=>e ? $b3fcf38b6e640544$exports.Grant.toJSON(e) : undefined);
        else obj.allowances = [];
        message.pagination !== undefined && (obj.pagination = message.pagination ? $5eae5f3cc99e92ab$exports.PageResponse.toJSON(message.pagination) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $ce2d87a37cd899f9$var$createBaseQueryAllowancesResponse();
        message.allowances = object.allowances?.map((e)=>$b3fcf38b6e640544$exports.Grant.fromPartial(e)) || [];
        message.pagination = object.pagination !== undefined && object.pagination !== null ? $5eae5f3cc99e92ab$exports.PageResponse.fromPartial(object.pagination) : undefined;
        return message;
    }
};
function $ce2d87a37cd899f9$var$createBaseQueryAllowancesByGranterRequest() {
    return {
        granter: "",
        pagination: undefined
    };
}
$ce2d87a37cd899f9$exports.QueryAllowancesByGranterRequest = {
    encode (message, writer = $ce2d87a37cd899f9$var$_m0.Writer.create()) {
        if (message.granter !== "") writer.uint32(10).string(message.granter);
        if (message.pagination !== undefined) $5eae5f3cc99e92ab$exports.PageRequest.encode(message.pagination, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $ce2d87a37cd899f9$var$_m0.Reader ? input : new $ce2d87a37cd899f9$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $ce2d87a37cd899f9$var$createBaseQueryAllowancesByGranterRequest();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.granter = reader.string();
                    break;
                case 2:
                    message.pagination = $5eae5f3cc99e92ab$exports.PageRequest.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            granter: (0, $d5e07fe2518aae94$exports.isSet)(object.granter) ? String(object.granter) : "",
            pagination: (0, $d5e07fe2518aae94$exports.isSet)(object.pagination) ? $5eae5f3cc99e92ab$exports.PageRequest.fromJSON(object.pagination) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.granter !== undefined && (obj.granter = message.granter);
        message.pagination !== undefined && (obj.pagination = message.pagination ? $5eae5f3cc99e92ab$exports.PageRequest.toJSON(message.pagination) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $ce2d87a37cd899f9$var$createBaseQueryAllowancesByGranterRequest();
        message.granter = object.granter ?? "";
        message.pagination = object.pagination !== undefined && object.pagination !== null ? $5eae5f3cc99e92ab$exports.PageRequest.fromPartial(object.pagination) : undefined;
        return message;
    }
};
function $ce2d87a37cd899f9$var$createBaseQueryAllowancesByGranterResponse() {
    return {
        allowances: [],
        pagination: undefined
    };
}
$ce2d87a37cd899f9$exports.QueryAllowancesByGranterResponse = {
    encode (message, writer = $ce2d87a37cd899f9$var$_m0.Writer.create()) {
        for (const v of message.allowances)$b3fcf38b6e640544$exports.Grant.encode(v, writer.uint32(10).fork()).ldelim();
        if (message.pagination !== undefined) $5eae5f3cc99e92ab$exports.PageResponse.encode(message.pagination, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $ce2d87a37cd899f9$var$_m0.Reader ? input : new $ce2d87a37cd899f9$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $ce2d87a37cd899f9$var$createBaseQueryAllowancesByGranterResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.allowances.push($b3fcf38b6e640544$exports.Grant.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.pagination = $5eae5f3cc99e92ab$exports.PageResponse.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            allowances: Array.isArray(object?.allowances) ? object.allowances.map((e)=>$b3fcf38b6e640544$exports.Grant.fromJSON(e)) : [],
            pagination: (0, $d5e07fe2518aae94$exports.isSet)(object.pagination) ? $5eae5f3cc99e92ab$exports.PageResponse.fromJSON(object.pagination) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        if (message.allowances) obj.allowances = message.allowances.map((e)=>e ? $b3fcf38b6e640544$exports.Grant.toJSON(e) : undefined);
        else obj.allowances = [];
        message.pagination !== undefined && (obj.pagination = message.pagination ? $5eae5f3cc99e92ab$exports.PageResponse.toJSON(message.pagination) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $ce2d87a37cd899f9$var$createBaseQueryAllowancesByGranterResponse();
        message.allowances = object.allowances?.map((e)=>$b3fcf38b6e640544$exports.Grant.fromPartial(e)) || [];
        message.pagination = object.pagination !== undefined && object.pagination !== null ? $5eae5f3cc99e92ab$exports.PageResponse.fromPartial(object.pagination) : undefined;
        return message;
    }
};
class $ce2d87a37cd899f9$var$QueryClientImpl {
    constructor(rpc){
        this.rpc = rpc;
        this.Allowance = this.Allowance.bind(this);
        this.Allowances = this.Allowances.bind(this);
        this.AllowancesByGranter = this.AllowancesByGranter.bind(this);
    }
    Allowance(request) {
        const data = $ce2d87a37cd899f9$exports.QueryAllowanceRequest.encode(request).finish();
        const promise = this.rpc.request("cosmos.feegrant.v1beta1.Query", "Allowance", data);
        return promise.then((data)=>$ce2d87a37cd899f9$exports.QueryAllowanceResponse.decode(new $ce2d87a37cd899f9$var$_m0.Reader(data)));
    }
    Allowances(request) {
        const data = $ce2d87a37cd899f9$exports.QueryAllowancesRequest.encode(request).finish();
        const promise = this.rpc.request("cosmos.feegrant.v1beta1.Query", "Allowances", data);
        return promise.then((data)=>$ce2d87a37cd899f9$exports.QueryAllowancesResponse.decode(new $ce2d87a37cd899f9$var$_m0.Reader(data)));
    }
    AllowancesByGranter(request) {
        const data = $ce2d87a37cd899f9$exports.QueryAllowancesByGranterRequest.encode(request).finish();
        const promise = this.rpc.request("cosmos.feegrant.v1beta1.Query", "AllowancesByGranter", data);
        return promise.then((data)=>$ce2d87a37cd899f9$exports.QueryAllowancesByGranterResponse.decode(new $ce2d87a37cd899f9$var$_m0.Reader(data)));
    }
}
$ce2d87a37cd899f9$exports.QueryClientImpl = $ce2d87a37cd899f9$var$QueryClientImpl;



function $b97e79a32963f84f$var$setupFeegrantExtension(base) {
    // Use this service to get easy typed access to query methods
    // This cannot be used for proof verification
    const rpc = (0, $a3959936d2cce854$exports.createProtobufRpcClient)(base);
    const queryService = new $ce2d87a37cd899f9$exports.QueryClientImpl(rpc);
    return {
        feegrant: {
            allowance: async (granter, grantee)=>{
                const response = await queryService.Allowance({
                    granter: granter,
                    grantee: grantee
                });
                return response;
            },
            allowances: async (grantee, paginationKey)=>{
                const response = await queryService.Allowances({
                    grantee: grantee,
                    pagination: (0, $a3959936d2cce854$exports.createPagination)(paginationKey)
                });
                return response;
            }
        }
    };
}
$b97e79a32963f84f$exports.setupFeegrantExtension = $b97e79a32963f84f$var$setupFeegrantExtension;


Object.defineProperty($d0d8b6f4712acd9f$exports, "setupFeegrantExtension", {
    enumerable: true,
    get: function() {
        return $b97e79a32963f84f$exports.setupFeegrantExtension;
    }
});
var $94ab1fdb4bfa8da6$exports = {};
"use strict";
var $94ab1fdb4bfa8da6$var$__importDefault = $94ab1fdb4bfa8da6$exports && $94ab1fdb4bfa8da6$exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty($94ab1fdb4bfa8da6$exports, "__esModule", {
    value: true
});
$94ab1fdb4bfa8da6$exports.createGovAminoConverters = $94ab1fdb4bfa8da6$exports.isAminoMsgDeposit = $94ab1fdb4bfa8da6$exports.isAminoMsgVoteWeighted = $94ab1fdb4bfa8da6$exports.isAminoMsgVote = $94ab1fdb4bfa8da6$exports.isAminoMsgSubmitProposal = void 0;

var $7UsfE = parcelRequire("7UsfE");

var $fZwG5 = parcelRequire("fZwG5");
var $737f3deb0a132861$exports = {};
"use strict";
var $737f3deb0a132861$var$__createBinding = $737f3deb0a132861$exports && $737f3deb0a132861$exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $737f3deb0a132861$var$__setModuleDefault = $737f3deb0a132861$exports && $737f3deb0a132861$exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $737f3deb0a132861$var$__importStar = $737f3deb0a132861$exports && $737f3deb0a132861$exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $737f3deb0a132861$var$__createBinding(result, mod, k);
    }
    $737f3deb0a132861$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty($737f3deb0a132861$exports, "__esModule", {
    value: true
});
$737f3deb0a132861$exports.TallyParams = $737f3deb0a132861$exports.VotingParams = $737f3deb0a132861$exports.DepositParams = $737f3deb0a132861$exports.Vote = $737f3deb0a132861$exports.TallyResult = $737f3deb0a132861$exports.Proposal = $737f3deb0a132861$exports.Deposit = $737f3deb0a132861$exports.TextProposal = $737f3deb0a132861$exports.WeightedVoteOption = $737f3deb0a132861$exports.proposalStatusToJSON = $737f3deb0a132861$exports.proposalStatusFromJSON = $737f3deb0a132861$exports.ProposalStatus = $737f3deb0a132861$exports.voteOptionToJSON = $737f3deb0a132861$exports.voteOptionFromJSON = $737f3deb0a132861$exports.VoteOption = $737f3deb0a132861$exports.protobufPackage = void 0;






const $737f3deb0a132861$var$_m0 = $737f3deb0a132861$var$__importStar((parcelRequire("fQBv0")));
$737f3deb0a132861$exports.protobufPackage = "cosmos.gov.v1beta1";
/** VoteOption enumerates the valid vote options for a given governance proposal. */ var $737f3deb0a132861$var$VoteOption;
(function(VoteOption) {
    /** VOTE_OPTION_UNSPECIFIED - VOTE_OPTION_UNSPECIFIED defines a no-op vote option. */ VoteOption[VoteOption["VOTE_OPTION_UNSPECIFIED"] = 0] = "VOTE_OPTION_UNSPECIFIED";
    /** VOTE_OPTION_YES - VOTE_OPTION_YES defines a yes vote option. */ VoteOption[VoteOption["VOTE_OPTION_YES"] = 1] = "VOTE_OPTION_YES";
    /** VOTE_OPTION_ABSTAIN - VOTE_OPTION_ABSTAIN defines an abstain vote option. */ VoteOption[VoteOption["VOTE_OPTION_ABSTAIN"] = 2] = "VOTE_OPTION_ABSTAIN";
    /** VOTE_OPTION_NO - VOTE_OPTION_NO defines a no vote option. */ VoteOption[VoteOption["VOTE_OPTION_NO"] = 3] = "VOTE_OPTION_NO";
    /** VOTE_OPTION_NO_WITH_VETO - VOTE_OPTION_NO_WITH_VETO defines a no with veto vote option. */ VoteOption[VoteOption["VOTE_OPTION_NO_WITH_VETO"] = 4] = "VOTE_OPTION_NO_WITH_VETO";
    VoteOption[VoteOption["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})($737f3deb0a132861$var$VoteOption = $737f3deb0a132861$exports.VoteOption || ($737f3deb0a132861$exports.VoteOption = {}));
function $737f3deb0a132861$var$voteOptionFromJSON(object) {
    switch(object){
        case 0:
        case "VOTE_OPTION_UNSPECIFIED":
            return $737f3deb0a132861$var$VoteOption.VOTE_OPTION_UNSPECIFIED;
        case 1:
        case "VOTE_OPTION_YES":
            return $737f3deb0a132861$var$VoteOption.VOTE_OPTION_YES;
        case 2:
        case "VOTE_OPTION_ABSTAIN":
            return $737f3deb0a132861$var$VoteOption.VOTE_OPTION_ABSTAIN;
        case 3:
        case "VOTE_OPTION_NO":
            return $737f3deb0a132861$var$VoteOption.VOTE_OPTION_NO;
        case 4:
        case "VOTE_OPTION_NO_WITH_VETO":
            return $737f3deb0a132861$var$VoteOption.VOTE_OPTION_NO_WITH_VETO;
        case -1:
        case "UNRECOGNIZED":
        default:
            return $737f3deb0a132861$var$VoteOption.UNRECOGNIZED;
    }
}
$737f3deb0a132861$exports.voteOptionFromJSON = $737f3deb0a132861$var$voteOptionFromJSON;
function $737f3deb0a132861$var$voteOptionToJSON(object) {
    switch(object){
        case $737f3deb0a132861$var$VoteOption.VOTE_OPTION_UNSPECIFIED:
            return "VOTE_OPTION_UNSPECIFIED";
        case $737f3deb0a132861$var$VoteOption.VOTE_OPTION_YES:
            return "VOTE_OPTION_YES";
        case $737f3deb0a132861$var$VoteOption.VOTE_OPTION_ABSTAIN:
            return "VOTE_OPTION_ABSTAIN";
        case $737f3deb0a132861$var$VoteOption.VOTE_OPTION_NO:
            return "VOTE_OPTION_NO";
        case $737f3deb0a132861$var$VoteOption.VOTE_OPTION_NO_WITH_VETO:
            return "VOTE_OPTION_NO_WITH_VETO";
        case $737f3deb0a132861$var$VoteOption.UNRECOGNIZED:
        default:
            return "UNRECOGNIZED";
    }
}
$737f3deb0a132861$exports.voteOptionToJSON = $737f3deb0a132861$var$voteOptionToJSON;
/** ProposalStatus enumerates the valid statuses of a proposal. */ var $737f3deb0a132861$var$ProposalStatus;
(function(ProposalStatus) {
    /** PROPOSAL_STATUS_UNSPECIFIED - PROPOSAL_STATUS_UNSPECIFIED defines the default proposal status. */ ProposalStatus[ProposalStatus["PROPOSAL_STATUS_UNSPECIFIED"] = 0] = "PROPOSAL_STATUS_UNSPECIFIED";
    /**
     * PROPOSAL_STATUS_DEPOSIT_PERIOD - PROPOSAL_STATUS_DEPOSIT_PERIOD defines a proposal status during the deposit
     * period.
     */ ProposalStatus[ProposalStatus["PROPOSAL_STATUS_DEPOSIT_PERIOD"] = 1] = "PROPOSAL_STATUS_DEPOSIT_PERIOD";
    /**
     * PROPOSAL_STATUS_VOTING_PERIOD - PROPOSAL_STATUS_VOTING_PERIOD defines a proposal status during the voting
     * period.
     */ ProposalStatus[ProposalStatus["PROPOSAL_STATUS_VOTING_PERIOD"] = 2] = "PROPOSAL_STATUS_VOTING_PERIOD";
    /**
     * PROPOSAL_STATUS_PASSED - PROPOSAL_STATUS_PASSED defines a proposal status of a proposal that has
     * passed.
     */ ProposalStatus[ProposalStatus["PROPOSAL_STATUS_PASSED"] = 3] = "PROPOSAL_STATUS_PASSED";
    /**
     * PROPOSAL_STATUS_REJECTED - PROPOSAL_STATUS_REJECTED defines a proposal status of a proposal that has
     * been rejected.
     */ ProposalStatus[ProposalStatus["PROPOSAL_STATUS_REJECTED"] = 4] = "PROPOSAL_STATUS_REJECTED";
    /**
     * PROPOSAL_STATUS_FAILED - PROPOSAL_STATUS_FAILED defines a proposal status of a proposal that has
     * failed.
     */ ProposalStatus[ProposalStatus["PROPOSAL_STATUS_FAILED"] = 5] = "PROPOSAL_STATUS_FAILED";
    ProposalStatus[ProposalStatus["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})($737f3deb0a132861$var$ProposalStatus = $737f3deb0a132861$exports.ProposalStatus || ($737f3deb0a132861$exports.ProposalStatus = {}));
function $737f3deb0a132861$var$proposalStatusFromJSON(object) {
    switch(object){
        case 0:
        case "PROPOSAL_STATUS_UNSPECIFIED":
            return $737f3deb0a132861$var$ProposalStatus.PROPOSAL_STATUS_UNSPECIFIED;
        case 1:
        case "PROPOSAL_STATUS_DEPOSIT_PERIOD":
            return $737f3deb0a132861$var$ProposalStatus.PROPOSAL_STATUS_DEPOSIT_PERIOD;
        case 2:
        case "PROPOSAL_STATUS_VOTING_PERIOD":
            return $737f3deb0a132861$var$ProposalStatus.PROPOSAL_STATUS_VOTING_PERIOD;
        case 3:
        case "PROPOSAL_STATUS_PASSED":
            return $737f3deb0a132861$var$ProposalStatus.PROPOSAL_STATUS_PASSED;
        case 4:
        case "PROPOSAL_STATUS_REJECTED":
            return $737f3deb0a132861$var$ProposalStatus.PROPOSAL_STATUS_REJECTED;
        case 5:
        case "PROPOSAL_STATUS_FAILED":
            return $737f3deb0a132861$var$ProposalStatus.PROPOSAL_STATUS_FAILED;
        case -1:
        case "UNRECOGNIZED":
        default:
            return $737f3deb0a132861$var$ProposalStatus.UNRECOGNIZED;
    }
}
$737f3deb0a132861$exports.proposalStatusFromJSON = $737f3deb0a132861$var$proposalStatusFromJSON;
function $737f3deb0a132861$var$proposalStatusToJSON(object) {
    switch(object){
        case $737f3deb0a132861$var$ProposalStatus.PROPOSAL_STATUS_UNSPECIFIED:
            return "PROPOSAL_STATUS_UNSPECIFIED";
        case $737f3deb0a132861$var$ProposalStatus.PROPOSAL_STATUS_DEPOSIT_PERIOD:
            return "PROPOSAL_STATUS_DEPOSIT_PERIOD";
        case $737f3deb0a132861$var$ProposalStatus.PROPOSAL_STATUS_VOTING_PERIOD:
            return "PROPOSAL_STATUS_VOTING_PERIOD";
        case $737f3deb0a132861$var$ProposalStatus.PROPOSAL_STATUS_PASSED:
            return "PROPOSAL_STATUS_PASSED";
        case $737f3deb0a132861$var$ProposalStatus.PROPOSAL_STATUS_REJECTED:
            return "PROPOSAL_STATUS_REJECTED";
        case $737f3deb0a132861$var$ProposalStatus.PROPOSAL_STATUS_FAILED:
            return "PROPOSAL_STATUS_FAILED";
        case $737f3deb0a132861$var$ProposalStatus.UNRECOGNIZED:
        default:
            return "UNRECOGNIZED";
    }
}
$737f3deb0a132861$exports.proposalStatusToJSON = $737f3deb0a132861$var$proposalStatusToJSON;
function $737f3deb0a132861$var$createBaseWeightedVoteOption() {
    return {
        option: 0,
        weight: ""
    };
}
$737f3deb0a132861$exports.WeightedVoteOption = {
    encode (message, writer = $737f3deb0a132861$var$_m0.Writer.create()) {
        if (message.option !== 0) writer.uint32(8).int32(message.option);
        if (message.weight !== "") writer.uint32(18).string(message.weight);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $737f3deb0a132861$var$_m0.Reader ? input : new $737f3deb0a132861$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $737f3deb0a132861$var$createBaseWeightedVoteOption();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.option = reader.int32();
                    break;
                case 2:
                    message.weight = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            option: (0, $d5e07fe2518aae94$exports.isSet)(object.option) ? $737f3deb0a132861$var$voteOptionFromJSON(object.option) : 0,
            weight: (0, $d5e07fe2518aae94$exports.isSet)(object.weight) ? String(object.weight) : ""
        };
    },
    toJSON (message) {
        const obj = {};
        message.option !== undefined && (obj.option = $737f3deb0a132861$var$voteOptionToJSON(message.option));
        message.weight !== undefined && (obj.weight = message.weight);
        return obj;
    },
    fromPartial (object) {
        const message = $737f3deb0a132861$var$createBaseWeightedVoteOption();
        message.option = object.option ?? 0;
        message.weight = object.weight ?? "";
        return message;
    }
};
function $737f3deb0a132861$var$createBaseTextProposal() {
    return {
        title: "",
        description: ""
    };
}
$737f3deb0a132861$exports.TextProposal = {
    encode (message, writer = $737f3deb0a132861$var$_m0.Writer.create()) {
        if (message.title !== "") writer.uint32(10).string(message.title);
        if (message.description !== "") writer.uint32(18).string(message.description);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $737f3deb0a132861$var$_m0.Reader ? input : new $737f3deb0a132861$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $737f3deb0a132861$var$createBaseTextProposal();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.title = reader.string();
                    break;
                case 2:
                    message.description = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            title: (0, $d5e07fe2518aae94$exports.isSet)(object.title) ? String(object.title) : "",
            description: (0, $d5e07fe2518aae94$exports.isSet)(object.description) ? String(object.description) : ""
        };
    },
    toJSON (message) {
        const obj = {};
        message.title !== undefined && (obj.title = message.title);
        message.description !== undefined && (obj.description = message.description);
        return obj;
    },
    fromPartial (object) {
        const message = $737f3deb0a132861$var$createBaseTextProposal();
        message.title = object.title ?? "";
        message.description = object.description ?? "";
        return message;
    }
};
function $737f3deb0a132861$var$createBaseDeposit() {
    return {
        proposalId: $d5e07fe2518aae94$exports.Long.UZERO,
        depositor: "",
        amount: []
    };
}
$737f3deb0a132861$exports.Deposit = {
    encode (message, writer = $737f3deb0a132861$var$_m0.Writer.create()) {
        if (!message.proposalId.isZero()) writer.uint32(8).uint64(message.proposalId);
        if (message.depositor !== "") writer.uint32(18).string(message.depositor);
        for (const v of message.amount)$783dd8715fde0fcf$exports.Coin.encode(v, writer.uint32(26).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $737f3deb0a132861$var$_m0.Reader ? input : new $737f3deb0a132861$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $737f3deb0a132861$var$createBaseDeposit();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.proposalId = reader.uint64();
                    break;
                case 2:
                    message.depositor = reader.string();
                    break;
                case 3:
                    message.amount.push($783dd8715fde0fcf$exports.Coin.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            proposalId: (0, $d5e07fe2518aae94$exports.isSet)(object.proposalId) ? $d5e07fe2518aae94$exports.Long.fromValue(object.proposalId) : $d5e07fe2518aae94$exports.Long.UZERO,
            depositor: (0, $d5e07fe2518aae94$exports.isSet)(object.depositor) ? String(object.depositor) : "",
            amount: Array.isArray(object?.amount) ? object.amount.map((e)=>$783dd8715fde0fcf$exports.Coin.fromJSON(e)) : []
        };
    },
    toJSON (message) {
        const obj = {};
        message.proposalId !== undefined && (obj.proposalId = (message.proposalId || $d5e07fe2518aae94$exports.Long.UZERO).toString());
        message.depositor !== undefined && (obj.depositor = message.depositor);
        if (message.amount) obj.amount = message.amount.map((e)=>e ? $783dd8715fde0fcf$exports.Coin.toJSON(e) : undefined);
        else obj.amount = [];
        return obj;
    },
    fromPartial (object) {
        const message = $737f3deb0a132861$var$createBaseDeposit();
        message.proposalId = object.proposalId !== undefined && object.proposalId !== null ? $d5e07fe2518aae94$exports.Long.fromValue(object.proposalId) : $d5e07fe2518aae94$exports.Long.UZERO;
        message.depositor = object.depositor ?? "";
        message.amount = object.amount?.map((e)=>$783dd8715fde0fcf$exports.Coin.fromPartial(e)) || [];
        return message;
    }
};
function $737f3deb0a132861$var$createBaseProposal() {
    return {
        proposalId: $d5e07fe2518aae94$exports.Long.UZERO,
        content: undefined,
        status: 0,
        finalTallyResult: undefined,
        submitTime: undefined,
        depositEndTime: undefined,
        totalDeposit: [],
        votingStartTime: undefined,
        votingEndTime: undefined
    };
}
$737f3deb0a132861$exports.Proposal = {
    encode (message, writer = $737f3deb0a132861$var$_m0.Writer.create()) {
        if (!message.proposalId.isZero()) writer.uint32(8).uint64(message.proposalId);
        if (message.content !== undefined) $64138e590dcf0cc1$exports.Any.encode(message.content, writer.uint32(18).fork()).ldelim();
        if (message.status !== 0) writer.uint32(24).int32(message.status);
        if (message.finalTallyResult !== undefined) $737f3deb0a132861$exports.TallyResult.encode(message.finalTallyResult, writer.uint32(34).fork()).ldelim();
        if (message.submitTime !== undefined) $e7eaeedc85b414fc$exports.Timestamp.encode(message.submitTime, writer.uint32(42).fork()).ldelim();
        if (message.depositEndTime !== undefined) $e7eaeedc85b414fc$exports.Timestamp.encode(message.depositEndTime, writer.uint32(50).fork()).ldelim();
        for (const v of message.totalDeposit)$783dd8715fde0fcf$exports.Coin.encode(v, writer.uint32(58).fork()).ldelim();
        if (message.votingStartTime !== undefined) $e7eaeedc85b414fc$exports.Timestamp.encode(message.votingStartTime, writer.uint32(66).fork()).ldelim();
        if (message.votingEndTime !== undefined) $e7eaeedc85b414fc$exports.Timestamp.encode(message.votingEndTime, writer.uint32(74).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $737f3deb0a132861$var$_m0.Reader ? input : new $737f3deb0a132861$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $737f3deb0a132861$var$createBaseProposal();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.proposalId = reader.uint64();
                    break;
                case 2:
                    message.content = $64138e590dcf0cc1$exports.Any.decode(reader, reader.uint32());
                    break;
                case 3:
                    message.status = reader.int32();
                    break;
                case 4:
                    message.finalTallyResult = $737f3deb0a132861$exports.TallyResult.decode(reader, reader.uint32());
                    break;
                case 5:
                    message.submitTime = $e7eaeedc85b414fc$exports.Timestamp.decode(reader, reader.uint32());
                    break;
                case 6:
                    message.depositEndTime = $e7eaeedc85b414fc$exports.Timestamp.decode(reader, reader.uint32());
                    break;
                case 7:
                    message.totalDeposit.push($783dd8715fde0fcf$exports.Coin.decode(reader, reader.uint32()));
                    break;
                case 8:
                    message.votingStartTime = $e7eaeedc85b414fc$exports.Timestamp.decode(reader, reader.uint32());
                    break;
                case 9:
                    message.votingEndTime = $e7eaeedc85b414fc$exports.Timestamp.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            proposalId: (0, $d5e07fe2518aae94$exports.isSet)(object.proposalId) ? $d5e07fe2518aae94$exports.Long.fromValue(object.proposalId) : $d5e07fe2518aae94$exports.Long.UZERO,
            content: (0, $d5e07fe2518aae94$exports.isSet)(object.content) ? $64138e590dcf0cc1$exports.Any.fromJSON(object.content) : undefined,
            status: (0, $d5e07fe2518aae94$exports.isSet)(object.status) ? $737f3deb0a132861$var$proposalStatusFromJSON(object.status) : 0,
            finalTallyResult: (0, $d5e07fe2518aae94$exports.isSet)(object.finalTallyResult) ? $737f3deb0a132861$exports.TallyResult.fromJSON(object.finalTallyResult) : undefined,
            submitTime: (0, $d5e07fe2518aae94$exports.isSet)(object.submitTime) ? (0, $d5e07fe2518aae94$exports.fromJsonTimestamp)(object.submitTime) : undefined,
            depositEndTime: (0, $d5e07fe2518aae94$exports.isSet)(object.depositEndTime) ? (0, $d5e07fe2518aae94$exports.fromJsonTimestamp)(object.depositEndTime) : undefined,
            totalDeposit: Array.isArray(object?.totalDeposit) ? object.totalDeposit.map((e)=>$783dd8715fde0fcf$exports.Coin.fromJSON(e)) : [],
            votingStartTime: (0, $d5e07fe2518aae94$exports.isSet)(object.votingStartTime) ? (0, $d5e07fe2518aae94$exports.fromJsonTimestamp)(object.votingStartTime) : undefined,
            votingEndTime: (0, $d5e07fe2518aae94$exports.isSet)(object.votingEndTime) ? (0, $d5e07fe2518aae94$exports.fromJsonTimestamp)(object.votingEndTime) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.proposalId !== undefined && (obj.proposalId = (message.proposalId || $d5e07fe2518aae94$exports.Long.UZERO).toString());
        message.content !== undefined && (obj.content = message.content ? $64138e590dcf0cc1$exports.Any.toJSON(message.content) : undefined);
        message.status !== undefined && (obj.status = $737f3deb0a132861$var$proposalStatusToJSON(message.status));
        message.finalTallyResult !== undefined && (obj.finalTallyResult = message.finalTallyResult ? $737f3deb0a132861$exports.TallyResult.toJSON(message.finalTallyResult) : undefined);
        message.submitTime !== undefined && (obj.submitTime = (0, $d5e07fe2518aae94$exports.fromTimestamp)(message.submitTime).toISOString());
        message.depositEndTime !== undefined && (obj.depositEndTime = (0, $d5e07fe2518aae94$exports.fromTimestamp)(message.depositEndTime).toISOString());
        if (message.totalDeposit) obj.totalDeposit = message.totalDeposit.map((e)=>e ? $783dd8715fde0fcf$exports.Coin.toJSON(e) : undefined);
        else obj.totalDeposit = [];
        message.votingStartTime !== undefined && (obj.votingStartTime = (0, $d5e07fe2518aae94$exports.fromTimestamp)(message.votingStartTime).toISOString());
        message.votingEndTime !== undefined && (obj.votingEndTime = (0, $d5e07fe2518aae94$exports.fromTimestamp)(message.votingEndTime).toISOString());
        return obj;
    },
    fromPartial (object) {
        const message = $737f3deb0a132861$var$createBaseProposal();
        message.proposalId = object.proposalId !== undefined && object.proposalId !== null ? $d5e07fe2518aae94$exports.Long.fromValue(object.proposalId) : $d5e07fe2518aae94$exports.Long.UZERO;
        message.content = object.content !== undefined && object.content !== null ? $64138e590dcf0cc1$exports.Any.fromPartial(object.content) : undefined;
        message.status = object.status ?? 0;
        message.finalTallyResult = object.finalTallyResult !== undefined && object.finalTallyResult !== null ? $737f3deb0a132861$exports.TallyResult.fromPartial(object.finalTallyResult) : undefined;
        message.submitTime = object.submitTime !== undefined && object.submitTime !== null ? $e7eaeedc85b414fc$exports.Timestamp.fromPartial(object.submitTime) : undefined;
        message.depositEndTime = object.depositEndTime !== undefined && object.depositEndTime !== null ? $e7eaeedc85b414fc$exports.Timestamp.fromPartial(object.depositEndTime) : undefined;
        message.totalDeposit = object.totalDeposit?.map((e)=>$783dd8715fde0fcf$exports.Coin.fromPartial(e)) || [];
        message.votingStartTime = object.votingStartTime !== undefined && object.votingStartTime !== null ? $e7eaeedc85b414fc$exports.Timestamp.fromPartial(object.votingStartTime) : undefined;
        message.votingEndTime = object.votingEndTime !== undefined && object.votingEndTime !== null ? $e7eaeedc85b414fc$exports.Timestamp.fromPartial(object.votingEndTime) : undefined;
        return message;
    }
};
function $737f3deb0a132861$var$createBaseTallyResult() {
    return {
        yes: "",
        abstain: "",
        no: "",
        noWithVeto: ""
    };
}
$737f3deb0a132861$exports.TallyResult = {
    encode (message, writer = $737f3deb0a132861$var$_m0.Writer.create()) {
        if (message.yes !== "") writer.uint32(10).string(message.yes);
        if (message.abstain !== "") writer.uint32(18).string(message.abstain);
        if (message.no !== "") writer.uint32(26).string(message.no);
        if (message.noWithVeto !== "") writer.uint32(34).string(message.noWithVeto);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $737f3deb0a132861$var$_m0.Reader ? input : new $737f3deb0a132861$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $737f3deb0a132861$var$createBaseTallyResult();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.yes = reader.string();
                    break;
                case 2:
                    message.abstain = reader.string();
                    break;
                case 3:
                    message.no = reader.string();
                    break;
                case 4:
                    message.noWithVeto = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            yes: (0, $d5e07fe2518aae94$exports.isSet)(object.yes) ? String(object.yes) : "",
            abstain: (0, $d5e07fe2518aae94$exports.isSet)(object.abstain) ? String(object.abstain) : "",
            no: (0, $d5e07fe2518aae94$exports.isSet)(object.no) ? String(object.no) : "",
            noWithVeto: (0, $d5e07fe2518aae94$exports.isSet)(object.noWithVeto) ? String(object.noWithVeto) : ""
        };
    },
    toJSON (message) {
        const obj = {};
        message.yes !== undefined && (obj.yes = message.yes);
        message.abstain !== undefined && (obj.abstain = message.abstain);
        message.no !== undefined && (obj.no = message.no);
        message.noWithVeto !== undefined && (obj.noWithVeto = message.noWithVeto);
        return obj;
    },
    fromPartial (object) {
        const message = $737f3deb0a132861$var$createBaseTallyResult();
        message.yes = object.yes ?? "";
        message.abstain = object.abstain ?? "";
        message.no = object.no ?? "";
        message.noWithVeto = object.noWithVeto ?? "";
        return message;
    }
};
function $737f3deb0a132861$var$createBaseVote() {
    return {
        proposalId: $d5e07fe2518aae94$exports.Long.UZERO,
        voter: "",
        option: 0,
        options: []
    };
}
$737f3deb0a132861$exports.Vote = {
    encode (message, writer = $737f3deb0a132861$var$_m0.Writer.create()) {
        if (!message.proposalId.isZero()) writer.uint32(8).uint64(message.proposalId);
        if (message.voter !== "") writer.uint32(18).string(message.voter);
        if (message.option !== 0) writer.uint32(24).int32(message.option);
        for (const v of message.options)$737f3deb0a132861$exports.WeightedVoteOption.encode(v, writer.uint32(34).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $737f3deb0a132861$var$_m0.Reader ? input : new $737f3deb0a132861$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $737f3deb0a132861$var$createBaseVote();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.proposalId = reader.uint64();
                    break;
                case 2:
                    message.voter = reader.string();
                    break;
                case 3:
                    message.option = reader.int32();
                    break;
                case 4:
                    message.options.push($737f3deb0a132861$exports.WeightedVoteOption.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            proposalId: (0, $d5e07fe2518aae94$exports.isSet)(object.proposalId) ? $d5e07fe2518aae94$exports.Long.fromValue(object.proposalId) : $d5e07fe2518aae94$exports.Long.UZERO,
            voter: (0, $d5e07fe2518aae94$exports.isSet)(object.voter) ? String(object.voter) : "",
            option: (0, $d5e07fe2518aae94$exports.isSet)(object.option) ? $737f3deb0a132861$var$voteOptionFromJSON(object.option) : 0,
            options: Array.isArray(object?.options) ? object.options.map((e)=>$737f3deb0a132861$exports.WeightedVoteOption.fromJSON(e)) : []
        };
    },
    toJSON (message) {
        const obj = {};
        message.proposalId !== undefined && (obj.proposalId = (message.proposalId || $d5e07fe2518aae94$exports.Long.UZERO).toString());
        message.voter !== undefined && (obj.voter = message.voter);
        message.option !== undefined && (obj.option = $737f3deb0a132861$var$voteOptionToJSON(message.option));
        if (message.options) obj.options = message.options.map((e)=>e ? $737f3deb0a132861$exports.WeightedVoteOption.toJSON(e) : undefined);
        else obj.options = [];
        return obj;
    },
    fromPartial (object) {
        const message = $737f3deb0a132861$var$createBaseVote();
        message.proposalId = object.proposalId !== undefined && object.proposalId !== null ? $d5e07fe2518aae94$exports.Long.fromValue(object.proposalId) : $d5e07fe2518aae94$exports.Long.UZERO;
        message.voter = object.voter ?? "";
        message.option = object.option ?? 0;
        message.options = object.options?.map((e)=>$737f3deb0a132861$exports.WeightedVoteOption.fromPartial(e)) || [];
        return message;
    }
};
function $737f3deb0a132861$var$createBaseDepositParams() {
    return {
        minDeposit: [],
        maxDepositPeriod: undefined
    };
}
$737f3deb0a132861$exports.DepositParams = {
    encode (message, writer = $737f3deb0a132861$var$_m0.Writer.create()) {
        for (const v of message.minDeposit)$783dd8715fde0fcf$exports.Coin.encode(v, writer.uint32(10).fork()).ldelim();
        if (message.maxDepositPeriod !== undefined) $fe534fae4538ccbf$exports.Duration.encode(message.maxDepositPeriod, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $737f3deb0a132861$var$_m0.Reader ? input : new $737f3deb0a132861$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $737f3deb0a132861$var$createBaseDepositParams();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.minDeposit.push($783dd8715fde0fcf$exports.Coin.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.maxDepositPeriod = $fe534fae4538ccbf$exports.Duration.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            minDeposit: Array.isArray(object?.minDeposit) ? object.minDeposit.map((e)=>$783dd8715fde0fcf$exports.Coin.fromJSON(e)) : [],
            maxDepositPeriod: (0, $d5e07fe2518aae94$exports.isSet)(object.maxDepositPeriod) ? $fe534fae4538ccbf$exports.Duration.fromJSON(object.maxDepositPeriod) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        if (message.minDeposit) obj.minDeposit = message.minDeposit.map((e)=>e ? $783dd8715fde0fcf$exports.Coin.toJSON(e) : undefined);
        else obj.minDeposit = [];
        message.maxDepositPeriod !== undefined && (obj.maxDepositPeriod = message.maxDepositPeriod ? $fe534fae4538ccbf$exports.Duration.toJSON(message.maxDepositPeriod) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $737f3deb0a132861$var$createBaseDepositParams();
        message.minDeposit = object.minDeposit?.map((e)=>$783dd8715fde0fcf$exports.Coin.fromPartial(e)) || [];
        message.maxDepositPeriod = object.maxDepositPeriod !== undefined && object.maxDepositPeriod !== null ? $fe534fae4538ccbf$exports.Duration.fromPartial(object.maxDepositPeriod) : undefined;
        return message;
    }
};
function $737f3deb0a132861$var$createBaseVotingParams() {
    return {
        votingPeriod: undefined
    };
}
$737f3deb0a132861$exports.VotingParams = {
    encode (message, writer = $737f3deb0a132861$var$_m0.Writer.create()) {
        if (message.votingPeriod !== undefined) $fe534fae4538ccbf$exports.Duration.encode(message.votingPeriod, writer.uint32(10).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $737f3deb0a132861$var$_m0.Reader ? input : new $737f3deb0a132861$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $737f3deb0a132861$var$createBaseVotingParams();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.votingPeriod = $fe534fae4538ccbf$exports.Duration.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            votingPeriod: (0, $d5e07fe2518aae94$exports.isSet)(object.votingPeriod) ? $fe534fae4538ccbf$exports.Duration.fromJSON(object.votingPeriod) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.votingPeriod !== undefined && (obj.votingPeriod = message.votingPeriod ? $fe534fae4538ccbf$exports.Duration.toJSON(message.votingPeriod) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $737f3deb0a132861$var$createBaseVotingParams();
        message.votingPeriod = object.votingPeriod !== undefined && object.votingPeriod !== null ? $fe534fae4538ccbf$exports.Duration.fromPartial(object.votingPeriod) : undefined;
        return message;
    }
};
function $737f3deb0a132861$var$createBaseTallyParams() {
    return {
        quorum: new Uint8Array(),
        threshold: new Uint8Array(),
        vetoThreshold: new Uint8Array()
    };
}
$737f3deb0a132861$exports.TallyParams = {
    encode (message, writer = $737f3deb0a132861$var$_m0.Writer.create()) {
        if (message.quorum.length !== 0) writer.uint32(10).bytes(message.quorum);
        if (message.threshold.length !== 0) writer.uint32(18).bytes(message.threshold);
        if (message.vetoThreshold.length !== 0) writer.uint32(26).bytes(message.vetoThreshold);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $737f3deb0a132861$var$_m0.Reader ? input : new $737f3deb0a132861$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $737f3deb0a132861$var$createBaseTallyParams();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.quorum = reader.bytes();
                    break;
                case 2:
                    message.threshold = reader.bytes();
                    break;
                case 3:
                    message.vetoThreshold = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            quorum: (0, $d5e07fe2518aae94$exports.isSet)(object.quorum) ? (0, $d5e07fe2518aae94$exports.bytesFromBase64)(object.quorum) : new Uint8Array(),
            threshold: (0, $d5e07fe2518aae94$exports.isSet)(object.threshold) ? (0, $d5e07fe2518aae94$exports.bytesFromBase64)(object.threshold) : new Uint8Array(),
            vetoThreshold: (0, $d5e07fe2518aae94$exports.isSet)(object.vetoThreshold) ? (0, $d5e07fe2518aae94$exports.bytesFromBase64)(object.vetoThreshold) : new Uint8Array()
        };
    },
    toJSON (message) {
        const obj = {};
        message.quorum !== undefined && (obj.quorum = (0, $d5e07fe2518aae94$exports.base64FromBytes)(message.quorum !== undefined ? message.quorum : new Uint8Array()));
        message.threshold !== undefined && (obj.threshold = (0, $d5e07fe2518aae94$exports.base64FromBytes)(message.threshold !== undefined ? message.threshold : new Uint8Array()));
        message.vetoThreshold !== undefined && (obj.vetoThreshold = (0, $d5e07fe2518aae94$exports.base64FromBytes)(message.vetoThreshold !== undefined ? message.vetoThreshold : new Uint8Array()));
        return obj;
    },
    fromPartial (object) {
        const message = $737f3deb0a132861$var$createBaseTallyParams();
        message.quorum = object.quorum ?? new Uint8Array();
        message.threshold = object.threshold ?? new Uint8Array();
        message.vetoThreshold = object.vetoThreshold ?? new Uint8Array();
        return message;
    }
};




const $94ab1fdb4bfa8da6$var$long_1 = $94ab1fdb4bfa8da6$var$__importDefault((parcelRequire("jRkuS")));

function $94ab1fdb4bfa8da6$var$isAminoMsgSubmitProposal(msg) {
    return msg.type === "cosmos-sdk/MsgSubmitProposal";
}
$94ab1fdb4bfa8da6$exports.isAminoMsgSubmitProposal = $94ab1fdb4bfa8da6$var$isAminoMsgSubmitProposal;
function $94ab1fdb4bfa8da6$var$isAminoMsgVote(msg) {
    return msg.type === "cosmos-sdk/MsgVote";
}
$94ab1fdb4bfa8da6$exports.isAminoMsgVote = $94ab1fdb4bfa8da6$var$isAminoMsgVote;
function $94ab1fdb4bfa8da6$var$isAminoMsgVoteWeighted(msg) {
    return msg.type === "cosmos-sdk/MsgVoteWeighted";
}
$94ab1fdb4bfa8da6$exports.isAminoMsgVoteWeighted = $94ab1fdb4bfa8da6$var$isAminoMsgVoteWeighted;
function $94ab1fdb4bfa8da6$var$isAminoMsgDeposit(msg) {
    return msg.type === "cosmos-sdk/MsgDeposit";
}
$94ab1fdb4bfa8da6$exports.isAminoMsgDeposit = $94ab1fdb4bfa8da6$var$isAminoMsgDeposit;
function $94ab1fdb4bfa8da6$var$createGovAminoConverters() {
    // Gov v1 types missing, see
    // https://github.com/cosmos/cosmjs/issues/1442
    return {
        "/cosmos.gov.v1beta1.MsgDeposit": {
            aminoType: "cosmos-sdk/MsgDeposit",
            toAmino: ({ amount: amount, depositor: depositor, proposalId: proposalId })=>{
                return {
                    amount: amount,
                    depositor: depositor,
                    proposal_id: proposalId.toString()
                };
            },
            fromAmino: ({ amount: amount, depositor: depositor, proposal_id: proposal_id })=>{
                return {
                    amount: Array.from(amount),
                    depositor: depositor,
                    proposalId: $94ab1fdb4bfa8da6$var$long_1.default.fromString(proposal_id)
                };
            }
        },
        "/cosmos.gov.v1beta1.MsgVote": {
            aminoType: "cosmos-sdk/MsgVote",
            toAmino: ({ option: option, proposalId: proposalId, voter: voter })=>{
                return {
                    option: option,
                    proposal_id: proposalId.toString(),
                    voter: voter
                };
            },
            fromAmino: ({ option: option, proposal_id: proposal_id, voter: voter })=>{
                return {
                    option: (0, $737f3deb0a132861$exports.voteOptionFromJSON)(option),
                    proposalId: $94ab1fdb4bfa8da6$var$long_1.default.fromString(proposal_id),
                    voter: voter
                };
            }
        },
        "/cosmos.gov.v1beta1.MsgVoteWeighted": {
            aminoType: "cosmos-sdk/MsgVoteWeighted",
            toAmino: ({ options: options, proposalId: proposalId, voter: voter })=>{
                return {
                    options: options.map((o)=>({
                            option: o.option,
                            // Weight is between 0 and 1, so we always have 20 characters when printing all trailing
                            // zeros (e.g. "0.700000000000000000" or "1.000000000000000000")
                            weight: (0, $a3959936d2cce854$exports.decodeCosmosSdkDecFromProto)(o.weight).toString().padEnd(20, "0")
                        })),
                    proposal_id: proposalId.toString(),
                    voter: voter
                };
            },
            fromAmino: ({ options: options, proposal_id: proposal_id, voter: voter })=>{
                return {
                    proposalId: $94ab1fdb4bfa8da6$var$long_1.default.fromString(proposal_id),
                    voter: voter,
                    options: options.map((o)=>({
                            option: (0, $737f3deb0a132861$exports.voteOptionFromJSON)(o.option),
                            weight: $7UsfE.Decimal.fromUserInput(o.weight, 18).atomics
                        }))
                };
            }
        },
        "/cosmos.gov.v1beta1.MsgSubmitProposal": {
            aminoType: "cosmos-sdk/MsgSubmitProposal",
            toAmino: ({ initialDeposit: initialDeposit, proposer: proposer, content: content })=>{
                (0, $fZwG5.assertDefinedAndNotNull)(content);
                let proposal;
                switch(content.typeUrl){
                    case "/cosmos.gov.v1beta1.TextProposal":
                        {
                            const textProposal = $737f3deb0a132861$exports.TextProposal.decode(content.value);
                            proposal = {
                                type: "cosmos-sdk/TextProposal",
                                value: {
                                    description: textProposal.description,
                                    title: textProposal.title
                                }
                            };
                            break;
                        }
                    default:
                        throw new Error(`Unsupported proposal type: '${content.typeUrl}'`);
                }
                return {
                    initial_deposit: initialDeposit,
                    proposer: proposer,
                    content: proposal
                };
            },
            fromAmino: ({ initial_deposit: initial_deposit, proposer: proposer, content: content })=>{
                let any_content;
                switch(content.type){
                    case "cosmos-sdk/TextProposal":
                        {
                            const { value: value } = content;
                            (0, $fZwG5.assert)((0, $fZwG5.isNonNullObject)(value));
                            const { title: title, description: description } = value;
                            (0, $fZwG5.assert)(typeof title === "string");
                            (0, $fZwG5.assert)(typeof description === "string");
                            any_content = $64138e590dcf0cc1$exports.Any.fromPartial({
                                typeUrl: "/cosmos.gov.v1beta1.TextProposal",
                                value: $737f3deb0a132861$exports.TextProposal.encode($737f3deb0a132861$exports.TextProposal.fromPartial({
                                    title: title,
                                    description: description
                                })).finish()
                            });
                            break;
                        }
                    default:
                        throw new Error(`Unsupported proposal type: '${content.type}'`);
                }
                return {
                    initialDeposit: Array.from(initial_deposit),
                    proposer: proposer,
                    content: any_content
                };
            }
        }
    };
}
$94ab1fdb4bfa8da6$exports.createGovAminoConverters = $94ab1fdb4bfa8da6$var$createGovAminoConverters;


Object.defineProperty($d0d8b6f4712acd9f$exports, "createGovAminoConverters", {
    enumerable: true,
    get: function() {
        return $94ab1fdb4bfa8da6$exports.createGovAminoConverters;
    }
});
Object.defineProperty($d0d8b6f4712acd9f$exports, "isAminoMsgDeposit", {
    enumerable: true,
    get: function() {
        return $94ab1fdb4bfa8da6$exports.isAminoMsgDeposit;
    }
});
Object.defineProperty($d0d8b6f4712acd9f$exports, "isAminoMsgSubmitProposal", {
    enumerable: true,
    get: function() {
        return $94ab1fdb4bfa8da6$exports.isAminoMsgSubmitProposal;
    }
});
Object.defineProperty($d0d8b6f4712acd9f$exports, "isAminoMsgVote", {
    enumerable: true,
    get: function() {
        return $94ab1fdb4bfa8da6$exports.isAminoMsgVote;
    }
});
Object.defineProperty($d0d8b6f4712acd9f$exports, "isAminoMsgVoteWeighted", {
    enumerable: true,
    get: function() {
        return $94ab1fdb4bfa8da6$exports.isAminoMsgVoteWeighted;
    }
});
var $c210fc7a41e9e12f$exports = {};
"use strict";
Object.defineProperty($c210fc7a41e9e12f$exports, "__esModule", {
    value: true
});
$c210fc7a41e9e12f$exports.isMsgVoteWeightedEncodeObject = $c210fc7a41e9e12f$exports.isMsgVoteEncodeObject = $c210fc7a41e9e12f$exports.isMsgSubmitProposalEncodeObject = $c210fc7a41e9e12f$exports.isMsgDepositEncodeObject = $c210fc7a41e9e12f$exports.govTypes = void 0;
var $492a1b7730620d95$exports = {};
"use strict";
var $492a1b7730620d95$var$__createBinding = $492a1b7730620d95$exports && $492a1b7730620d95$exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $492a1b7730620d95$var$__setModuleDefault = $492a1b7730620d95$exports && $492a1b7730620d95$exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $492a1b7730620d95$var$__importStar = $492a1b7730620d95$exports && $492a1b7730620d95$exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $492a1b7730620d95$var$__createBinding(result, mod, k);
    }
    $492a1b7730620d95$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty($492a1b7730620d95$exports, "__esModule", {
    value: true
});
$492a1b7730620d95$exports.MsgClientImpl = $492a1b7730620d95$exports.MsgUpdateParamsResponse = $492a1b7730620d95$exports.MsgUpdateParams = $492a1b7730620d95$exports.MsgDepositResponse = $492a1b7730620d95$exports.MsgDeposit = $492a1b7730620d95$exports.MsgVoteWeightedResponse = $492a1b7730620d95$exports.MsgVoteWeighted = $492a1b7730620d95$exports.MsgVoteResponse = $492a1b7730620d95$exports.MsgVote = $492a1b7730620d95$exports.MsgExecLegacyContentResponse = $492a1b7730620d95$exports.MsgExecLegacyContent = $492a1b7730620d95$exports.MsgSubmitProposalResponse = $492a1b7730620d95$exports.MsgSubmitProposal = $492a1b7730620d95$exports.protobufPackage = void 0;


var $adcea68d92ef0a33$exports = {};
"use strict";
var $adcea68d92ef0a33$var$__createBinding = $adcea68d92ef0a33$exports && $adcea68d92ef0a33$exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $adcea68d92ef0a33$var$__setModuleDefault = $adcea68d92ef0a33$exports && $adcea68d92ef0a33$exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $adcea68d92ef0a33$var$__importStar = $adcea68d92ef0a33$exports && $adcea68d92ef0a33$exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $adcea68d92ef0a33$var$__createBinding(result, mod, k);
    }
    $adcea68d92ef0a33$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty($adcea68d92ef0a33$exports, "__esModule", {
    value: true
});
$adcea68d92ef0a33$exports.Params = $adcea68d92ef0a33$exports.TallyParams = $adcea68d92ef0a33$exports.VotingParams = $adcea68d92ef0a33$exports.DepositParams = $adcea68d92ef0a33$exports.Vote = $adcea68d92ef0a33$exports.TallyResult = $adcea68d92ef0a33$exports.Proposal = $adcea68d92ef0a33$exports.Deposit = $adcea68d92ef0a33$exports.WeightedVoteOption = $adcea68d92ef0a33$exports.proposalStatusToJSON = $adcea68d92ef0a33$exports.proposalStatusFromJSON = $adcea68d92ef0a33$exports.ProposalStatus = $adcea68d92ef0a33$exports.voteOptionToJSON = $adcea68d92ef0a33$exports.voteOptionFromJSON = $adcea68d92ef0a33$exports.VoteOption = $adcea68d92ef0a33$exports.protobufPackage = void 0;






const $adcea68d92ef0a33$var$_m0 = $adcea68d92ef0a33$var$__importStar((parcelRequire("fQBv0")));
$adcea68d92ef0a33$exports.protobufPackage = "cosmos.gov.v1";
/** VoteOption enumerates the valid vote options for a given governance proposal. */ var $adcea68d92ef0a33$var$VoteOption;
(function(VoteOption) {
    /** VOTE_OPTION_UNSPECIFIED - VOTE_OPTION_UNSPECIFIED defines a no-op vote option. */ VoteOption[VoteOption["VOTE_OPTION_UNSPECIFIED"] = 0] = "VOTE_OPTION_UNSPECIFIED";
    /** VOTE_OPTION_YES - VOTE_OPTION_YES defines a yes vote option. */ VoteOption[VoteOption["VOTE_OPTION_YES"] = 1] = "VOTE_OPTION_YES";
    /** VOTE_OPTION_ABSTAIN - VOTE_OPTION_ABSTAIN defines an abstain vote option. */ VoteOption[VoteOption["VOTE_OPTION_ABSTAIN"] = 2] = "VOTE_OPTION_ABSTAIN";
    /** VOTE_OPTION_NO - VOTE_OPTION_NO defines a no vote option. */ VoteOption[VoteOption["VOTE_OPTION_NO"] = 3] = "VOTE_OPTION_NO";
    /** VOTE_OPTION_NO_WITH_VETO - VOTE_OPTION_NO_WITH_VETO defines a no with veto vote option. */ VoteOption[VoteOption["VOTE_OPTION_NO_WITH_VETO"] = 4] = "VOTE_OPTION_NO_WITH_VETO";
    VoteOption[VoteOption["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})($adcea68d92ef0a33$var$VoteOption = $adcea68d92ef0a33$exports.VoteOption || ($adcea68d92ef0a33$exports.VoteOption = {}));
function $adcea68d92ef0a33$var$voteOptionFromJSON(object) {
    switch(object){
        case 0:
        case "VOTE_OPTION_UNSPECIFIED":
            return $adcea68d92ef0a33$var$VoteOption.VOTE_OPTION_UNSPECIFIED;
        case 1:
        case "VOTE_OPTION_YES":
            return $adcea68d92ef0a33$var$VoteOption.VOTE_OPTION_YES;
        case 2:
        case "VOTE_OPTION_ABSTAIN":
            return $adcea68d92ef0a33$var$VoteOption.VOTE_OPTION_ABSTAIN;
        case 3:
        case "VOTE_OPTION_NO":
            return $adcea68d92ef0a33$var$VoteOption.VOTE_OPTION_NO;
        case 4:
        case "VOTE_OPTION_NO_WITH_VETO":
            return $adcea68d92ef0a33$var$VoteOption.VOTE_OPTION_NO_WITH_VETO;
        case -1:
        case "UNRECOGNIZED":
        default:
            return $adcea68d92ef0a33$var$VoteOption.UNRECOGNIZED;
    }
}
$adcea68d92ef0a33$exports.voteOptionFromJSON = $adcea68d92ef0a33$var$voteOptionFromJSON;
function $adcea68d92ef0a33$var$voteOptionToJSON(object) {
    switch(object){
        case $adcea68d92ef0a33$var$VoteOption.VOTE_OPTION_UNSPECIFIED:
            return "VOTE_OPTION_UNSPECIFIED";
        case $adcea68d92ef0a33$var$VoteOption.VOTE_OPTION_YES:
            return "VOTE_OPTION_YES";
        case $adcea68d92ef0a33$var$VoteOption.VOTE_OPTION_ABSTAIN:
            return "VOTE_OPTION_ABSTAIN";
        case $adcea68d92ef0a33$var$VoteOption.VOTE_OPTION_NO:
            return "VOTE_OPTION_NO";
        case $adcea68d92ef0a33$var$VoteOption.VOTE_OPTION_NO_WITH_VETO:
            return "VOTE_OPTION_NO_WITH_VETO";
        case $adcea68d92ef0a33$var$VoteOption.UNRECOGNIZED:
        default:
            return "UNRECOGNIZED";
    }
}
$adcea68d92ef0a33$exports.voteOptionToJSON = $adcea68d92ef0a33$var$voteOptionToJSON;
/** ProposalStatus enumerates the valid statuses of a proposal. */ var $adcea68d92ef0a33$var$ProposalStatus;
(function(ProposalStatus) {
    /** PROPOSAL_STATUS_UNSPECIFIED - PROPOSAL_STATUS_UNSPECIFIED defines the default proposal status. */ ProposalStatus[ProposalStatus["PROPOSAL_STATUS_UNSPECIFIED"] = 0] = "PROPOSAL_STATUS_UNSPECIFIED";
    /**
     * PROPOSAL_STATUS_DEPOSIT_PERIOD - PROPOSAL_STATUS_DEPOSIT_PERIOD defines a proposal status during the deposit
     * period.
     */ ProposalStatus[ProposalStatus["PROPOSAL_STATUS_DEPOSIT_PERIOD"] = 1] = "PROPOSAL_STATUS_DEPOSIT_PERIOD";
    /**
     * PROPOSAL_STATUS_VOTING_PERIOD - PROPOSAL_STATUS_VOTING_PERIOD defines a proposal status during the voting
     * period.
     */ ProposalStatus[ProposalStatus["PROPOSAL_STATUS_VOTING_PERIOD"] = 2] = "PROPOSAL_STATUS_VOTING_PERIOD";
    /**
     * PROPOSAL_STATUS_PASSED - PROPOSAL_STATUS_PASSED defines a proposal status of a proposal that has
     * passed.
     */ ProposalStatus[ProposalStatus["PROPOSAL_STATUS_PASSED"] = 3] = "PROPOSAL_STATUS_PASSED";
    /**
     * PROPOSAL_STATUS_REJECTED - PROPOSAL_STATUS_REJECTED defines a proposal status of a proposal that has
     * been rejected.
     */ ProposalStatus[ProposalStatus["PROPOSAL_STATUS_REJECTED"] = 4] = "PROPOSAL_STATUS_REJECTED";
    /**
     * PROPOSAL_STATUS_FAILED - PROPOSAL_STATUS_FAILED defines a proposal status of a proposal that has
     * failed.
     */ ProposalStatus[ProposalStatus["PROPOSAL_STATUS_FAILED"] = 5] = "PROPOSAL_STATUS_FAILED";
    ProposalStatus[ProposalStatus["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})($adcea68d92ef0a33$var$ProposalStatus = $adcea68d92ef0a33$exports.ProposalStatus || ($adcea68d92ef0a33$exports.ProposalStatus = {}));
function $adcea68d92ef0a33$var$proposalStatusFromJSON(object) {
    switch(object){
        case 0:
        case "PROPOSAL_STATUS_UNSPECIFIED":
            return $adcea68d92ef0a33$var$ProposalStatus.PROPOSAL_STATUS_UNSPECIFIED;
        case 1:
        case "PROPOSAL_STATUS_DEPOSIT_PERIOD":
            return $adcea68d92ef0a33$var$ProposalStatus.PROPOSAL_STATUS_DEPOSIT_PERIOD;
        case 2:
        case "PROPOSAL_STATUS_VOTING_PERIOD":
            return $adcea68d92ef0a33$var$ProposalStatus.PROPOSAL_STATUS_VOTING_PERIOD;
        case 3:
        case "PROPOSAL_STATUS_PASSED":
            return $adcea68d92ef0a33$var$ProposalStatus.PROPOSAL_STATUS_PASSED;
        case 4:
        case "PROPOSAL_STATUS_REJECTED":
            return $adcea68d92ef0a33$var$ProposalStatus.PROPOSAL_STATUS_REJECTED;
        case 5:
        case "PROPOSAL_STATUS_FAILED":
            return $adcea68d92ef0a33$var$ProposalStatus.PROPOSAL_STATUS_FAILED;
        case -1:
        case "UNRECOGNIZED":
        default:
            return $adcea68d92ef0a33$var$ProposalStatus.UNRECOGNIZED;
    }
}
$adcea68d92ef0a33$exports.proposalStatusFromJSON = $adcea68d92ef0a33$var$proposalStatusFromJSON;
function $adcea68d92ef0a33$var$proposalStatusToJSON(object) {
    switch(object){
        case $adcea68d92ef0a33$var$ProposalStatus.PROPOSAL_STATUS_UNSPECIFIED:
            return "PROPOSAL_STATUS_UNSPECIFIED";
        case $adcea68d92ef0a33$var$ProposalStatus.PROPOSAL_STATUS_DEPOSIT_PERIOD:
            return "PROPOSAL_STATUS_DEPOSIT_PERIOD";
        case $adcea68d92ef0a33$var$ProposalStatus.PROPOSAL_STATUS_VOTING_PERIOD:
            return "PROPOSAL_STATUS_VOTING_PERIOD";
        case $adcea68d92ef0a33$var$ProposalStatus.PROPOSAL_STATUS_PASSED:
            return "PROPOSAL_STATUS_PASSED";
        case $adcea68d92ef0a33$var$ProposalStatus.PROPOSAL_STATUS_REJECTED:
            return "PROPOSAL_STATUS_REJECTED";
        case $adcea68d92ef0a33$var$ProposalStatus.PROPOSAL_STATUS_FAILED:
            return "PROPOSAL_STATUS_FAILED";
        case $adcea68d92ef0a33$var$ProposalStatus.UNRECOGNIZED:
        default:
            return "UNRECOGNIZED";
    }
}
$adcea68d92ef0a33$exports.proposalStatusToJSON = $adcea68d92ef0a33$var$proposalStatusToJSON;
function $adcea68d92ef0a33$var$createBaseWeightedVoteOption() {
    return {
        option: 0,
        weight: ""
    };
}
$adcea68d92ef0a33$exports.WeightedVoteOption = {
    encode (message, writer = $adcea68d92ef0a33$var$_m0.Writer.create()) {
        if (message.option !== 0) writer.uint32(8).int32(message.option);
        if (message.weight !== "") writer.uint32(18).string(message.weight);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $adcea68d92ef0a33$var$_m0.Reader ? input : new $adcea68d92ef0a33$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $adcea68d92ef0a33$var$createBaseWeightedVoteOption();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.option = reader.int32();
                    break;
                case 2:
                    message.weight = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            option: (0, $d5e07fe2518aae94$exports.isSet)(object.option) ? $adcea68d92ef0a33$var$voteOptionFromJSON(object.option) : 0,
            weight: (0, $d5e07fe2518aae94$exports.isSet)(object.weight) ? String(object.weight) : ""
        };
    },
    toJSON (message) {
        const obj = {};
        message.option !== undefined && (obj.option = $adcea68d92ef0a33$var$voteOptionToJSON(message.option));
        message.weight !== undefined && (obj.weight = message.weight);
        return obj;
    },
    fromPartial (object) {
        const message = $adcea68d92ef0a33$var$createBaseWeightedVoteOption();
        message.option = object.option ?? 0;
        message.weight = object.weight ?? "";
        return message;
    }
};
function $adcea68d92ef0a33$var$createBaseDeposit() {
    return {
        proposalId: $d5e07fe2518aae94$exports.Long.UZERO,
        depositor: "",
        amount: []
    };
}
$adcea68d92ef0a33$exports.Deposit = {
    encode (message, writer = $adcea68d92ef0a33$var$_m0.Writer.create()) {
        if (!message.proposalId.isZero()) writer.uint32(8).uint64(message.proposalId);
        if (message.depositor !== "") writer.uint32(18).string(message.depositor);
        for (const v of message.amount)$783dd8715fde0fcf$exports.Coin.encode(v, writer.uint32(26).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $adcea68d92ef0a33$var$_m0.Reader ? input : new $adcea68d92ef0a33$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $adcea68d92ef0a33$var$createBaseDeposit();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.proposalId = reader.uint64();
                    break;
                case 2:
                    message.depositor = reader.string();
                    break;
                case 3:
                    message.amount.push($783dd8715fde0fcf$exports.Coin.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            proposalId: (0, $d5e07fe2518aae94$exports.isSet)(object.proposalId) ? $d5e07fe2518aae94$exports.Long.fromValue(object.proposalId) : $d5e07fe2518aae94$exports.Long.UZERO,
            depositor: (0, $d5e07fe2518aae94$exports.isSet)(object.depositor) ? String(object.depositor) : "",
            amount: Array.isArray(object?.amount) ? object.amount.map((e)=>$783dd8715fde0fcf$exports.Coin.fromJSON(e)) : []
        };
    },
    toJSON (message) {
        const obj = {};
        message.proposalId !== undefined && (obj.proposalId = (message.proposalId || $d5e07fe2518aae94$exports.Long.UZERO).toString());
        message.depositor !== undefined && (obj.depositor = message.depositor);
        if (message.amount) obj.amount = message.amount.map((e)=>e ? $783dd8715fde0fcf$exports.Coin.toJSON(e) : undefined);
        else obj.amount = [];
        return obj;
    },
    fromPartial (object) {
        const message = $adcea68d92ef0a33$var$createBaseDeposit();
        message.proposalId = object.proposalId !== undefined && object.proposalId !== null ? $d5e07fe2518aae94$exports.Long.fromValue(object.proposalId) : $d5e07fe2518aae94$exports.Long.UZERO;
        message.depositor = object.depositor ?? "";
        message.amount = object.amount?.map((e)=>$783dd8715fde0fcf$exports.Coin.fromPartial(e)) || [];
        return message;
    }
};
function $adcea68d92ef0a33$var$createBaseProposal() {
    return {
        id: $d5e07fe2518aae94$exports.Long.UZERO,
        messages: [],
        status: 0,
        finalTallyResult: undefined,
        submitTime: undefined,
        depositEndTime: undefined,
        totalDeposit: [],
        votingStartTime: undefined,
        votingEndTime: undefined,
        metadata: "",
        title: "",
        summary: "",
        proposer: ""
    };
}
$adcea68d92ef0a33$exports.Proposal = {
    encode (message, writer = $adcea68d92ef0a33$var$_m0.Writer.create()) {
        if (!message.id.isZero()) writer.uint32(8).uint64(message.id);
        for (const v of message.messages)$64138e590dcf0cc1$exports.Any.encode(v, writer.uint32(18).fork()).ldelim();
        if (message.status !== 0) writer.uint32(24).int32(message.status);
        if (message.finalTallyResult !== undefined) $adcea68d92ef0a33$exports.TallyResult.encode(message.finalTallyResult, writer.uint32(34).fork()).ldelim();
        if (message.submitTime !== undefined) $e7eaeedc85b414fc$exports.Timestamp.encode(message.submitTime, writer.uint32(42).fork()).ldelim();
        if (message.depositEndTime !== undefined) $e7eaeedc85b414fc$exports.Timestamp.encode(message.depositEndTime, writer.uint32(50).fork()).ldelim();
        for (const v of message.totalDeposit)$783dd8715fde0fcf$exports.Coin.encode(v, writer.uint32(58).fork()).ldelim();
        if (message.votingStartTime !== undefined) $e7eaeedc85b414fc$exports.Timestamp.encode(message.votingStartTime, writer.uint32(66).fork()).ldelim();
        if (message.votingEndTime !== undefined) $e7eaeedc85b414fc$exports.Timestamp.encode(message.votingEndTime, writer.uint32(74).fork()).ldelim();
        if (message.metadata !== "") writer.uint32(82).string(message.metadata);
        if (message.title !== "") writer.uint32(90).string(message.title);
        if (message.summary !== "") writer.uint32(98).string(message.summary);
        if (message.proposer !== "") writer.uint32(106).string(message.proposer);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $adcea68d92ef0a33$var$_m0.Reader ? input : new $adcea68d92ef0a33$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $adcea68d92ef0a33$var$createBaseProposal();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.id = reader.uint64();
                    break;
                case 2:
                    message.messages.push($64138e590dcf0cc1$exports.Any.decode(reader, reader.uint32()));
                    break;
                case 3:
                    message.status = reader.int32();
                    break;
                case 4:
                    message.finalTallyResult = $adcea68d92ef0a33$exports.TallyResult.decode(reader, reader.uint32());
                    break;
                case 5:
                    message.submitTime = $e7eaeedc85b414fc$exports.Timestamp.decode(reader, reader.uint32());
                    break;
                case 6:
                    message.depositEndTime = $e7eaeedc85b414fc$exports.Timestamp.decode(reader, reader.uint32());
                    break;
                case 7:
                    message.totalDeposit.push($783dd8715fde0fcf$exports.Coin.decode(reader, reader.uint32()));
                    break;
                case 8:
                    message.votingStartTime = $e7eaeedc85b414fc$exports.Timestamp.decode(reader, reader.uint32());
                    break;
                case 9:
                    message.votingEndTime = $e7eaeedc85b414fc$exports.Timestamp.decode(reader, reader.uint32());
                    break;
                case 10:
                    message.metadata = reader.string();
                    break;
                case 11:
                    message.title = reader.string();
                    break;
                case 12:
                    message.summary = reader.string();
                    break;
                case 13:
                    message.proposer = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            id: (0, $d5e07fe2518aae94$exports.isSet)(object.id) ? $d5e07fe2518aae94$exports.Long.fromValue(object.id) : $d5e07fe2518aae94$exports.Long.UZERO,
            messages: Array.isArray(object?.messages) ? object.messages.map((e)=>$64138e590dcf0cc1$exports.Any.fromJSON(e)) : [],
            status: (0, $d5e07fe2518aae94$exports.isSet)(object.status) ? $adcea68d92ef0a33$var$proposalStatusFromJSON(object.status) : 0,
            finalTallyResult: (0, $d5e07fe2518aae94$exports.isSet)(object.finalTallyResult) ? $adcea68d92ef0a33$exports.TallyResult.fromJSON(object.finalTallyResult) : undefined,
            submitTime: (0, $d5e07fe2518aae94$exports.isSet)(object.submitTime) ? (0, $d5e07fe2518aae94$exports.fromJsonTimestamp)(object.submitTime) : undefined,
            depositEndTime: (0, $d5e07fe2518aae94$exports.isSet)(object.depositEndTime) ? (0, $d5e07fe2518aae94$exports.fromJsonTimestamp)(object.depositEndTime) : undefined,
            totalDeposit: Array.isArray(object?.totalDeposit) ? object.totalDeposit.map((e)=>$783dd8715fde0fcf$exports.Coin.fromJSON(e)) : [],
            votingStartTime: (0, $d5e07fe2518aae94$exports.isSet)(object.votingStartTime) ? (0, $d5e07fe2518aae94$exports.fromJsonTimestamp)(object.votingStartTime) : undefined,
            votingEndTime: (0, $d5e07fe2518aae94$exports.isSet)(object.votingEndTime) ? (0, $d5e07fe2518aae94$exports.fromJsonTimestamp)(object.votingEndTime) : undefined,
            metadata: (0, $d5e07fe2518aae94$exports.isSet)(object.metadata) ? String(object.metadata) : "",
            title: (0, $d5e07fe2518aae94$exports.isSet)(object.title) ? String(object.title) : "",
            summary: (0, $d5e07fe2518aae94$exports.isSet)(object.summary) ? String(object.summary) : "",
            proposer: (0, $d5e07fe2518aae94$exports.isSet)(object.proposer) ? String(object.proposer) : ""
        };
    },
    toJSON (message) {
        const obj = {};
        message.id !== undefined && (obj.id = (message.id || $d5e07fe2518aae94$exports.Long.UZERO).toString());
        if (message.messages) obj.messages = message.messages.map((e)=>e ? $64138e590dcf0cc1$exports.Any.toJSON(e) : undefined);
        else obj.messages = [];
        message.status !== undefined && (obj.status = $adcea68d92ef0a33$var$proposalStatusToJSON(message.status));
        message.finalTallyResult !== undefined && (obj.finalTallyResult = message.finalTallyResult ? $adcea68d92ef0a33$exports.TallyResult.toJSON(message.finalTallyResult) : undefined);
        message.submitTime !== undefined && (obj.submitTime = (0, $d5e07fe2518aae94$exports.fromTimestamp)(message.submitTime).toISOString());
        message.depositEndTime !== undefined && (obj.depositEndTime = (0, $d5e07fe2518aae94$exports.fromTimestamp)(message.depositEndTime).toISOString());
        if (message.totalDeposit) obj.totalDeposit = message.totalDeposit.map((e)=>e ? $783dd8715fde0fcf$exports.Coin.toJSON(e) : undefined);
        else obj.totalDeposit = [];
        message.votingStartTime !== undefined && (obj.votingStartTime = (0, $d5e07fe2518aae94$exports.fromTimestamp)(message.votingStartTime).toISOString());
        message.votingEndTime !== undefined && (obj.votingEndTime = (0, $d5e07fe2518aae94$exports.fromTimestamp)(message.votingEndTime).toISOString());
        message.metadata !== undefined && (obj.metadata = message.metadata);
        message.title !== undefined && (obj.title = message.title);
        message.summary !== undefined && (obj.summary = message.summary);
        message.proposer !== undefined && (obj.proposer = message.proposer);
        return obj;
    },
    fromPartial (object) {
        const message = $adcea68d92ef0a33$var$createBaseProposal();
        message.id = object.id !== undefined && object.id !== null ? $d5e07fe2518aae94$exports.Long.fromValue(object.id) : $d5e07fe2518aae94$exports.Long.UZERO;
        message.messages = object.messages?.map((e)=>$64138e590dcf0cc1$exports.Any.fromPartial(e)) || [];
        message.status = object.status ?? 0;
        message.finalTallyResult = object.finalTallyResult !== undefined && object.finalTallyResult !== null ? $adcea68d92ef0a33$exports.TallyResult.fromPartial(object.finalTallyResult) : undefined;
        message.submitTime = object.submitTime !== undefined && object.submitTime !== null ? $e7eaeedc85b414fc$exports.Timestamp.fromPartial(object.submitTime) : undefined;
        message.depositEndTime = object.depositEndTime !== undefined && object.depositEndTime !== null ? $e7eaeedc85b414fc$exports.Timestamp.fromPartial(object.depositEndTime) : undefined;
        message.totalDeposit = object.totalDeposit?.map((e)=>$783dd8715fde0fcf$exports.Coin.fromPartial(e)) || [];
        message.votingStartTime = object.votingStartTime !== undefined && object.votingStartTime !== null ? $e7eaeedc85b414fc$exports.Timestamp.fromPartial(object.votingStartTime) : undefined;
        message.votingEndTime = object.votingEndTime !== undefined && object.votingEndTime !== null ? $e7eaeedc85b414fc$exports.Timestamp.fromPartial(object.votingEndTime) : undefined;
        message.metadata = object.metadata ?? "";
        message.title = object.title ?? "";
        message.summary = object.summary ?? "";
        message.proposer = object.proposer ?? "";
        return message;
    }
};
function $adcea68d92ef0a33$var$createBaseTallyResult() {
    return {
        yesCount: "",
        abstainCount: "",
        noCount: "",
        noWithVetoCount: ""
    };
}
$adcea68d92ef0a33$exports.TallyResult = {
    encode (message, writer = $adcea68d92ef0a33$var$_m0.Writer.create()) {
        if (message.yesCount !== "") writer.uint32(10).string(message.yesCount);
        if (message.abstainCount !== "") writer.uint32(18).string(message.abstainCount);
        if (message.noCount !== "") writer.uint32(26).string(message.noCount);
        if (message.noWithVetoCount !== "") writer.uint32(34).string(message.noWithVetoCount);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $adcea68d92ef0a33$var$_m0.Reader ? input : new $adcea68d92ef0a33$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $adcea68d92ef0a33$var$createBaseTallyResult();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.yesCount = reader.string();
                    break;
                case 2:
                    message.abstainCount = reader.string();
                    break;
                case 3:
                    message.noCount = reader.string();
                    break;
                case 4:
                    message.noWithVetoCount = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            yesCount: (0, $d5e07fe2518aae94$exports.isSet)(object.yesCount) ? String(object.yesCount) : "",
            abstainCount: (0, $d5e07fe2518aae94$exports.isSet)(object.abstainCount) ? String(object.abstainCount) : "",
            noCount: (0, $d5e07fe2518aae94$exports.isSet)(object.noCount) ? String(object.noCount) : "",
            noWithVetoCount: (0, $d5e07fe2518aae94$exports.isSet)(object.noWithVetoCount) ? String(object.noWithVetoCount) : ""
        };
    },
    toJSON (message) {
        const obj = {};
        message.yesCount !== undefined && (obj.yesCount = message.yesCount);
        message.abstainCount !== undefined && (obj.abstainCount = message.abstainCount);
        message.noCount !== undefined && (obj.noCount = message.noCount);
        message.noWithVetoCount !== undefined && (obj.noWithVetoCount = message.noWithVetoCount);
        return obj;
    },
    fromPartial (object) {
        const message = $adcea68d92ef0a33$var$createBaseTallyResult();
        message.yesCount = object.yesCount ?? "";
        message.abstainCount = object.abstainCount ?? "";
        message.noCount = object.noCount ?? "";
        message.noWithVetoCount = object.noWithVetoCount ?? "";
        return message;
    }
};
function $adcea68d92ef0a33$var$createBaseVote() {
    return {
        proposalId: $d5e07fe2518aae94$exports.Long.UZERO,
        voter: "",
        options: [],
        metadata: ""
    };
}
$adcea68d92ef0a33$exports.Vote = {
    encode (message, writer = $adcea68d92ef0a33$var$_m0.Writer.create()) {
        if (!message.proposalId.isZero()) writer.uint32(8).uint64(message.proposalId);
        if (message.voter !== "") writer.uint32(18).string(message.voter);
        for (const v of message.options)$adcea68d92ef0a33$exports.WeightedVoteOption.encode(v, writer.uint32(34).fork()).ldelim();
        if (message.metadata !== "") writer.uint32(42).string(message.metadata);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $adcea68d92ef0a33$var$_m0.Reader ? input : new $adcea68d92ef0a33$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $adcea68d92ef0a33$var$createBaseVote();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.proposalId = reader.uint64();
                    break;
                case 2:
                    message.voter = reader.string();
                    break;
                case 4:
                    message.options.push($adcea68d92ef0a33$exports.WeightedVoteOption.decode(reader, reader.uint32()));
                    break;
                case 5:
                    message.metadata = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            proposalId: (0, $d5e07fe2518aae94$exports.isSet)(object.proposalId) ? $d5e07fe2518aae94$exports.Long.fromValue(object.proposalId) : $d5e07fe2518aae94$exports.Long.UZERO,
            voter: (0, $d5e07fe2518aae94$exports.isSet)(object.voter) ? String(object.voter) : "",
            options: Array.isArray(object?.options) ? object.options.map((e)=>$adcea68d92ef0a33$exports.WeightedVoteOption.fromJSON(e)) : [],
            metadata: (0, $d5e07fe2518aae94$exports.isSet)(object.metadata) ? String(object.metadata) : ""
        };
    },
    toJSON (message) {
        const obj = {};
        message.proposalId !== undefined && (obj.proposalId = (message.proposalId || $d5e07fe2518aae94$exports.Long.UZERO).toString());
        message.voter !== undefined && (obj.voter = message.voter);
        if (message.options) obj.options = message.options.map((e)=>e ? $adcea68d92ef0a33$exports.WeightedVoteOption.toJSON(e) : undefined);
        else obj.options = [];
        message.metadata !== undefined && (obj.metadata = message.metadata);
        return obj;
    },
    fromPartial (object) {
        const message = $adcea68d92ef0a33$var$createBaseVote();
        message.proposalId = object.proposalId !== undefined && object.proposalId !== null ? $d5e07fe2518aae94$exports.Long.fromValue(object.proposalId) : $d5e07fe2518aae94$exports.Long.UZERO;
        message.voter = object.voter ?? "";
        message.options = object.options?.map((e)=>$adcea68d92ef0a33$exports.WeightedVoteOption.fromPartial(e)) || [];
        message.metadata = object.metadata ?? "";
        return message;
    }
};
function $adcea68d92ef0a33$var$createBaseDepositParams() {
    return {
        minDeposit: [],
        maxDepositPeriod: undefined
    };
}
$adcea68d92ef0a33$exports.DepositParams = {
    encode (message, writer = $adcea68d92ef0a33$var$_m0.Writer.create()) {
        for (const v of message.minDeposit)$783dd8715fde0fcf$exports.Coin.encode(v, writer.uint32(10).fork()).ldelim();
        if (message.maxDepositPeriod !== undefined) $fe534fae4538ccbf$exports.Duration.encode(message.maxDepositPeriod, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $adcea68d92ef0a33$var$_m0.Reader ? input : new $adcea68d92ef0a33$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $adcea68d92ef0a33$var$createBaseDepositParams();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.minDeposit.push($783dd8715fde0fcf$exports.Coin.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.maxDepositPeriod = $fe534fae4538ccbf$exports.Duration.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            minDeposit: Array.isArray(object?.minDeposit) ? object.minDeposit.map((e)=>$783dd8715fde0fcf$exports.Coin.fromJSON(e)) : [],
            maxDepositPeriod: (0, $d5e07fe2518aae94$exports.isSet)(object.maxDepositPeriod) ? $fe534fae4538ccbf$exports.Duration.fromJSON(object.maxDepositPeriod) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        if (message.minDeposit) obj.minDeposit = message.minDeposit.map((e)=>e ? $783dd8715fde0fcf$exports.Coin.toJSON(e) : undefined);
        else obj.minDeposit = [];
        message.maxDepositPeriod !== undefined && (obj.maxDepositPeriod = message.maxDepositPeriod ? $fe534fae4538ccbf$exports.Duration.toJSON(message.maxDepositPeriod) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $adcea68d92ef0a33$var$createBaseDepositParams();
        message.minDeposit = object.minDeposit?.map((e)=>$783dd8715fde0fcf$exports.Coin.fromPartial(e)) || [];
        message.maxDepositPeriod = object.maxDepositPeriod !== undefined && object.maxDepositPeriod !== null ? $fe534fae4538ccbf$exports.Duration.fromPartial(object.maxDepositPeriod) : undefined;
        return message;
    }
};
function $adcea68d92ef0a33$var$createBaseVotingParams() {
    return {
        votingPeriod: undefined
    };
}
$adcea68d92ef0a33$exports.VotingParams = {
    encode (message, writer = $adcea68d92ef0a33$var$_m0.Writer.create()) {
        if (message.votingPeriod !== undefined) $fe534fae4538ccbf$exports.Duration.encode(message.votingPeriod, writer.uint32(10).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $adcea68d92ef0a33$var$_m0.Reader ? input : new $adcea68d92ef0a33$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $adcea68d92ef0a33$var$createBaseVotingParams();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.votingPeriod = $fe534fae4538ccbf$exports.Duration.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            votingPeriod: (0, $d5e07fe2518aae94$exports.isSet)(object.votingPeriod) ? $fe534fae4538ccbf$exports.Duration.fromJSON(object.votingPeriod) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.votingPeriod !== undefined && (obj.votingPeriod = message.votingPeriod ? $fe534fae4538ccbf$exports.Duration.toJSON(message.votingPeriod) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $adcea68d92ef0a33$var$createBaseVotingParams();
        message.votingPeriod = object.votingPeriod !== undefined && object.votingPeriod !== null ? $fe534fae4538ccbf$exports.Duration.fromPartial(object.votingPeriod) : undefined;
        return message;
    }
};
function $adcea68d92ef0a33$var$createBaseTallyParams() {
    return {
        quorum: "",
        threshold: "",
        vetoThreshold: ""
    };
}
$adcea68d92ef0a33$exports.TallyParams = {
    encode (message, writer = $adcea68d92ef0a33$var$_m0.Writer.create()) {
        if (message.quorum !== "") writer.uint32(10).string(message.quorum);
        if (message.threshold !== "") writer.uint32(18).string(message.threshold);
        if (message.vetoThreshold !== "") writer.uint32(26).string(message.vetoThreshold);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $adcea68d92ef0a33$var$_m0.Reader ? input : new $adcea68d92ef0a33$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $adcea68d92ef0a33$var$createBaseTallyParams();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.quorum = reader.string();
                    break;
                case 2:
                    message.threshold = reader.string();
                    break;
                case 3:
                    message.vetoThreshold = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            quorum: (0, $d5e07fe2518aae94$exports.isSet)(object.quorum) ? String(object.quorum) : "",
            threshold: (0, $d5e07fe2518aae94$exports.isSet)(object.threshold) ? String(object.threshold) : "",
            vetoThreshold: (0, $d5e07fe2518aae94$exports.isSet)(object.vetoThreshold) ? String(object.vetoThreshold) : ""
        };
    },
    toJSON (message) {
        const obj = {};
        message.quorum !== undefined && (obj.quorum = message.quorum);
        message.threshold !== undefined && (obj.threshold = message.threshold);
        message.vetoThreshold !== undefined && (obj.vetoThreshold = message.vetoThreshold);
        return obj;
    },
    fromPartial (object) {
        const message = $adcea68d92ef0a33$var$createBaseTallyParams();
        message.quorum = object.quorum ?? "";
        message.threshold = object.threshold ?? "";
        message.vetoThreshold = object.vetoThreshold ?? "";
        return message;
    }
};
function $adcea68d92ef0a33$var$createBaseParams() {
    return {
        minDeposit: [],
        maxDepositPeriod: undefined,
        votingPeriod: undefined,
        quorum: "",
        threshold: "",
        vetoThreshold: "",
        minInitialDepositRatio: "",
        burnVoteQuorum: false,
        burnProposalDepositPrevote: false,
        burnVoteVeto: false
    };
}
$adcea68d92ef0a33$exports.Params = {
    encode (message, writer = $adcea68d92ef0a33$var$_m0.Writer.create()) {
        for (const v of message.minDeposit)$783dd8715fde0fcf$exports.Coin.encode(v, writer.uint32(10).fork()).ldelim();
        if (message.maxDepositPeriod !== undefined) $fe534fae4538ccbf$exports.Duration.encode(message.maxDepositPeriod, writer.uint32(18).fork()).ldelim();
        if (message.votingPeriod !== undefined) $fe534fae4538ccbf$exports.Duration.encode(message.votingPeriod, writer.uint32(26).fork()).ldelim();
        if (message.quorum !== "") writer.uint32(34).string(message.quorum);
        if (message.threshold !== "") writer.uint32(42).string(message.threshold);
        if (message.vetoThreshold !== "") writer.uint32(50).string(message.vetoThreshold);
        if (message.minInitialDepositRatio !== "") writer.uint32(58).string(message.minInitialDepositRatio);
        if (message.burnVoteQuorum === true) writer.uint32(104).bool(message.burnVoteQuorum);
        if (message.burnProposalDepositPrevote === true) writer.uint32(112).bool(message.burnProposalDepositPrevote);
        if (message.burnVoteVeto === true) writer.uint32(120).bool(message.burnVoteVeto);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $adcea68d92ef0a33$var$_m0.Reader ? input : new $adcea68d92ef0a33$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $adcea68d92ef0a33$var$createBaseParams();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.minDeposit.push($783dd8715fde0fcf$exports.Coin.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.maxDepositPeriod = $fe534fae4538ccbf$exports.Duration.decode(reader, reader.uint32());
                    break;
                case 3:
                    message.votingPeriod = $fe534fae4538ccbf$exports.Duration.decode(reader, reader.uint32());
                    break;
                case 4:
                    message.quorum = reader.string();
                    break;
                case 5:
                    message.threshold = reader.string();
                    break;
                case 6:
                    message.vetoThreshold = reader.string();
                    break;
                case 7:
                    message.minInitialDepositRatio = reader.string();
                    break;
                case 13:
                    message.burnVoteQuorum = reader.bool();
                    break;
                case 14:
                    message.burnProposalDepositPrevote = reader.bool();
                    break;
                case 15:
                    message.burnVoteVeto = reader.bool();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            minDeposit: Array.isArray(object?.minDeposit) ? object.minDeposit.map((e)=>$783dd8715fde0fcf$exports.Coin.fromJSON(e)) : [],
            maxDepositPeriod: (0, $d5e07fe2518aae94$exports.isSet)(object.maxDepositPeriod) ? $fe534fae4538ccbf$exports.Duration.fromJSON(object.maxDepositPeriod) : undefined,
            votingPeriod: (0, $d5e07fe2518aae94$exports.isSet)(object.votingPeriod) ? $fe534fae4538ccbf$exports.Duration.fromJSON(object.votingPeriod) : undefined,
            quorum: (0, $d5e07fe2518aae94$exports.isSet)(object.quorum) ? String(object.quorum) : "",
            threshold: (0, $d5e07fe2518aae94$exports.isSet)(object.threshold) ? String(object.threshold) : "",
            vetoThreshold: (0, $d5e07fe2518aae94$exports.isSet)(object.vetoThreshold) ? String(object.vetoThreshold) : "",
            minInitialDepositRatio: (0, $d5e07fe2518aae94$exports.isSet)(object.minInitialDepositRatio) ? String(object.minInitialDepositRatio) : "",
            burnVoteQuorum: (0, $d5e07fe2518aae94$exports.isSet)(object.burnVoteQuorum) ? Boolean(object.burnVoteQuorum) : false,
            burnProposalDepositPrevote: (0, $d5e07fe2518aae94$exports.isSet)(object.burnProposalDepositPrevote) ? Boolean(object.burnProposalDepositPrevote) : false,
            burnVoteVeto: (0, $d5e07fe2518aae94$exports.isSet)(object.burnVoteVeto) ? Boolean(object.burnVoteVeto) : false
        };
    },
    toJSON (message) {
        const obj = {};
        if (message.minDeposit) obj.minDeposit = message.minDeposit.map((e)=>e ? $783dd8715fde0fcf$exports.Coin.toJSON(e) : undefined);
        else obj.minDeposit = [];
        message.maxDepositPeriod !== undefined && (obj.maxDepositPeriod = message.maxDepositPeriod ? $fe534fae4538ccbf$exports.Duration.toJSON(message.maxDepositPeriod) : undefined);
        message.votingPeriod !== undefined && (obj.votingPeriod = message.votingPeriod ? $fe534fae4538ccbf$exports.Duration.toJSON(message.votingPeriod) : undefined);
        message.quorum !== undefined && (obj.quorum = message.quorum);
        message.threshold !== undefined && (obj.threshold = message.threshold);
        message.vetoThreshold !== undefined && (obj.vetoThreshold = message.vetoThreshold);
        message.minInitialDepositRatio !== undefined && (obj.minInitialDepositRatio = message.minInitialDepositRatio);
        message.burnVoteQuorum !== undefined && (obj.burnVoteQuorum = message.burnVoteQuorum);
        message.burnProposalDepositPrevote !== undefined && (obj.burnProposalDepositPrevote = message.burnProposalDepositPrevote);
        message.burnVoteVeto !== undefined && (obj.burnVoteVeto = message.burnVoteVeto);
        return obj;
    },
    fromPartial (object) {
        const message = $adcea68d92ef0a33$var$createBaseParams();
        message.minDeposit = object.minDeposit?.map((e)=>$783dd8715fde0fcf$exports.Coin.fromPartial(e)) || [];
        message.maxDepositPeriod = object.maxDepositPeriod !== undefined && object.maxDepositPeriod !== null ? $fe534fae4538ccbf$exports.Duration.fromPartial(object.maxDepositPeriod) : undefined;
        message.votingPeriod = object.votingPeriod !== undefined && object.votingPeriod !== null ? $fe534fae4538ccbf$exports.Duration.fromPartial(object.votingPeriod) : undefined;
        message.quorum = object.quorum ?? "";
        message.threshold = object.threshold ?? "";
        message.vetoThreshold = object.vetoThreshold ?? "";
        message.minInitialDepositRatio = object.minInitialDepositRatio ?? "";
        message.burnVoteQuorum = object.burnVoteQuorum ?? false;
        message.burnProposalDepositPrevote = object.burnProposalDepositPrevote ?? false;
        message.burnVoteVeto = object.burnVoteVeto ?? false;
        return message;
    }
};




const $492a1b7730620d95$var$_m0 = $492a1b7730620d95$var$__importStar((parcelRequire("fQBv0")));
$492a1b7730620d95$exports.protobufPackage = "cosmos.gov.v1";
function $492a1b7730620d95$var$createBaseMsgSubmitProposal() {
    return {
        messages: [],
        initialDeposit: [],
        proposer: "",
        metadata: "",
        title: "",
        summary: ""
    };
}
$492a1b7730620d95$exports.MsgSubmitProposal = {
    encode (message, writer = $492a1b7730620d95$var$_m0.Writer.create()) {
        for (const v of message.messages)$64138e590dcf0cc1$exports.Any.encode(v, writer.uint32(10).fork()).ldelim();
        for (const v of message.initialDeposit)$783dd8715fde0fcf$exports.Coin.encode(v, writer.uint32(18).fork()).ldelim();
        if (message.proposer !== "") writer.uint32(26).string(message.proposer);
        if (message.metadata !== "") writer.uint32(34).string(message.metadata);
        if (message.title !== "") writer.uint32(42).string(message.title);
        if (message.summary !== "") writer.uint32(50).string(message.summary);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $492a1b7730620d95$var$_m0.Reader ? input : new $492a1b7730620d95$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $492a1b7730620d95$var$createBaseMsgSubmitProposal();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.messages.push($64138e590dcf0cc1$exports.Any.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.initialDeposit.push($783dd8715fde0fcf$exports.Coin.decode(reader, reader.uint32()));
                    break;
                case 3:
                    message.proposer = reader.string();
                    break;
                case 4:
                    message.metadata = reader.string();
                    break;
                case 5:
                    message.title = reader.string();
                    break;
                case 6:
                    message.summary = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            messages: Array.isArray(object?.messages) ? object.messages.map((e)=>$64138e590dcf0cc1$exports.Any.fromJSON(e)) : [],
            initialDeposit: Array.isArray(object?.initialDeposit) ? object.initialDeposit.map((e)=>$783dd8715fde0fcf$exports.Coin.fromJSON(e)) : [],
            proposer: (0, $d5e07fe2518aae94$exports.isSet)(object.proposer) ? String(object.proposer) : "",
            metadata: (0, $d5e07fe2518aae94$exports.isSet)(object.metadata) ? String(object.metadata) : "",
            title: (0, $d5e07fe2518aae94$exports.isSet)(object.title) ? String(object.title) : "",
            summary: (0, $d5e07fe2518aae94$exports.isSet)(object.summary) ? String(object.summary) : ""
        };
    },
    toJSON (message) {
        const obj = {};
        if (message.messages) obj.messages = message.messages.map((e)=>e ? $64138e590dcf0cc1$exports.Any.toJSON(e) : undefined);
        else obj.messages = [];
        if (message.initialDeposit) obj.initialDeposit = message.initialDeposit.map((e)=>e ? $783dd8715fde0fcf$exports.Coin.toJSON(e) : undefined);
        else obj.initialDeposit = [];
        message.proposer !== undefined && (obj.proposer = message.proposer);
        message.metadata !== undefined && (obj.metadata = message.metadata);
        message.title !== undefined && (obj.title = message.title);
        message.summary !== undefined && (obj.summary = message.summary);
        return obj;
    },
    fromPartial (object) {
        const message = $492a1b7730620d95$var$createBaseMsgSubmitProposal();
        message.messages = object.messages?.map((e)=>$64138e590dcf0cc1$exports.Any.fromPartial(e)) || [];
        message.initialDeposit = object.initialDeposit?.map((e)=>$783dd8715fde0fcf$exports.Coin.fromPartial(e)) || [];
        message.proposer = object.proposer ?? "";
        message.metadata = object.metadata ?? "";
        message.title = object.title ?? "";
        message.summary = object.summary ?? "";
        return message;
    }
};
function $492a1b7730620d95$var$createBaseMsgSubmitProposalResponse() {
    return {
        proposalId: $d5e07fe2518aae94$exports.Long.UZERO
    };
}
$492a1b7730620d95$exports.MsgSubmitProposalResponse = {
    encode (message, writer = $492a1b7730620d95$var$_m0.Writer.create()) {
        if (!message.proposalId.isZero()) writer.uint32(8).uint64(message.proposalId);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $492a1b7730620d95$var$_m0.Reader ? input : new $492a1b7730620d95$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $492a1b7730620d95$var$createBaseMsgSubmitProposalResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.proposalId = reader.uint64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            proposalId: (0, $d5e07fe2518aae94$exports.isSet)(object.proposalId) ? $d5e07fe2518aae94$exports.Long.fromValue(object.proposalId) : $d5e07fe2518aae94$exports.Long.UZERO
        };
    },
    toJSON (message) {
        const obj = {};
        message.proposalId !== undefined && (obj.proposalId = (message.proposalId || $d5e07fe2518aae94$exports.Long.UZERO).toString());
        return obj;
    },
    fromPartial (object) {
        const message = $492a1b7730620d95$var$createBaseMsgSubmitProposalResponse();
        message.proposalId = object.proposalId !== undefined && object.proposalId !== null ? $d5e07fe2518aae94$exports.Long.fromValue(object.proposalId) : $d5e07fe2518aae94$exports.Long.UZERO;
        return message;
    }
};
function $492a1b7730620d95$var$createBaseMsgExecLegacyContent() {
    return {
        content: undefined,
        authority: ""
    };
}
$492a1b7730620d95$exports.MsgExecLegacyContent = {
    encode (message, writer = $492a1b7730620d95$var$_m0.Writer.create()) {
        if (message.content !== undefined) $64138e590dcf0cc1$exports.Any.encode(message.content, writer.uint32(10).fork()).ldelim();
        if (message.authority !== "") writer.uint32(18).string(message.authority);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $492a1b7730620d95$var$_m0.Reader ? input : new $492a1b7730620d95$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $492a1b7730620d95$var$createBaseMsgExecLegacyContent();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.content = $64138e590dcf0cc1$exports.Any.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.authority = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            content: (0, $d5e07fe2518aae94$exports.isSet)(object.content) ? $64138e590dcf0cc1$exports.Any.fromJSON(object.content) : undefined,
            authority: (0, $d5e07fe2518aae94$exports.isSet)(object.authority) ? String(object.authority) : ""
        };
    },
    toJSON (message) {
        const obj = {};
        message.content !== undefined && (obj.content = message.content ? $64138e590dcf0cc1$exports.Any.toJSON(message.content) : undefined);
        message.authority !== undefined && (obj.authority = message.authority);
        return obj;
    },
    fromPartial (object) {
        const message = $492a1b7730620d95$var$createBaseMsgExecLegacyContent();
        message.content = object.content !== undefined && object.content !== null ? $64138e590dcf0cc1$exports.Any.fromPartial(object.content) : undefined;
        message.authority = object.authority ?? "";
        return message;
    }
};
function $492a1b7730620d95$var$createBaseMsgExecLegacyContentResponse() {
    return {};
}
$492a1b7730620d95$exports.MsgExecLegacyContentResponse = {
    encode (_, writer = $492a1b7730620d95$var$_m0.Writer.create()) {
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $492a1b7730620d95$var$_m0.Reader ? input : new $492a1b7730620d95$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $492a1b7730620d95$var$createBaseMsgExecLegacyContentResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            tag;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON (_) {
        return {};
    },
    toJSON (_) {
        const obj = {};
        return obj;
    },
    fromPartial (_) {
        const message = $492a1b7730620d95$var$createBaseMsgExecLegacyContentResponse();
        return message;
    }
};
function $492a1b7730620d95$var$createBaseMsgVote() {
    return {
        proposalId: $d5e07fe2518aae94$exports.Long.UZERO,
        voter: "",
        option: 0,
        metadata: ""
    };
}
$492a1b7730620d95$exports.MsgVote = {
    encode (message, writer = $492a1b7730620d95$var$_m0.Writer.create()) {
        if (!message.proposalId.isZero()) writer.uint32(8).uint64(message.proposalId);
        if (message.voter !== "") writer.uint32(18).string(message.voter);
        if (message.option !== 0) writer.uint32(24).int32(message.option);
        if (message.metadata !== "") writer.uint32(34).string(message.metadata);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $492a1b7730620d95$var$_m0.Reader ? input : new $492a1b7730620d95$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $492a1b7730620d95$var$createBaseMsgVote();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.proposalId = reader.uint64();
                    break;
                case 2:
                    message.voter = reader.string();
                    break;
                case 3:
                    message.option = reader.int32();
                    break;
                case 4:
                    message.metadata = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            proposalId: (0, $d5e07fe2518aae94$exports.isSet)(object.proposalId) ? $d5e07fe2518aae94$exports.Long.fromValue(object.proposalId) : $d5e07fe2518aae94$exports.Long.UZERO,
            voter: (0, $d5e07fe2518aae94$exports.isSet)(object.voter) ? String(object.voter) : "",
            option: (0, $d5e07fe2518aae94$exports.isSet)(object.option) ? (0, $adcea68d92ef0a33$exports.voteOptionFromJSON)(object.option) : 0,
            metadata: (0, $d5e07fe2518aae94$exports.isSet)(object.metadata) ? String(object.metadata) : ""
        };
    },
    toJSON (message) {
        const obj = {};
        message.proposalId !== undefined && (obj.proposalId = (message.proposalId || $d5e07fe2518aae94$exports.Long.UZERO).toString());
        message.voter !== undefined && (obj.voter = message.voter);
        message.option !== undefined && (obj.option = (0, $adcea68d92ef0a33$exports.voteOptionToJSON)(message.option));
        message.metadata !== undefined && (obj.metadata = message.metadata);
        return obj;
    },
    fromPartial (object) {
        const message = $492a1b7730620d95$var$createBaseMsgVote();
        message.proposalId = object.proposalId !== undefined && object.proposalId !== null ? $d5e07fe2518aae94$exports.Long.fromValue(object.proposalId) : $d5e07fe2518aae94$exports.Long.UZERO;
        message.voter = object.voter ?? "";
        message.option = object.option ?? 0;
        message.metadata = object.metadata ?? "";
        return message;
    }
};
function $492a1b7730620d95$var$createBaseMsgVoteResponse() {
    return {};
}
$492a1b7730620d95$exports.MsgVoteResponse = {
    encode (_, writer = $492a1b7730620d95$var$_m0.Writer.create()) {
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $492a1b7730620d95$var$_m0.Reader ? input : new $492a1b7730620d95$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $492a1b7730620d95$var$createBaseMsgVoteResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            tag;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON (_) {
        return {};
    },
    toJSON (_) {
        const obj = {};
        return obj;
    },
    fromPartial (_) {
        const message = $492a1b7730620d95$var$createBaseMsgVoteResponse();
        return message;
    }
};
function $492a1b7730620d95$var$createBaseMsgVoteWeighted() {
    return {
        proposalId: $d5e07fe2518aae94$exports.Long.UZERO,
        voter: "",
        options: [],
        metadata: ""
    };
}
$492a1b7730620d95$exports.MsgVoteWeighted = {
    encode (message, writer = $492a1b7730620d95$var$_m0.Writer.create()) {
        if (!message.proposalId.isZero()) writer.uint32(8).uint64(message.proposalId);
        if (message.voter !== "") writer.uint32(18).string(message.voter);
        for (const v of message.options)$adcea68d92ef0a33$exports.WeightedVoteOption.encode(v, writer.uint32(26).fork()).ldelim();
        if (message.metadata !== "") writer.uint32(34).string(message.metadata);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $492a1b7730620d95$var$_m0.Reader ? input : new $492a1b7730620d95$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $492a1b7730620d95$var$createBaseMsgVoteWeighted();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.proposalId = reader.uint64();
                    break;
                case 2:
                    message.voter = reader.string();
                    break;
                case 3:
                    message.options.push($adcea68d92ef0a33$exports.WeightedVoteOption.decode(reader, reader.uint32()));
                    break;
                case 4:
                    message.metadata = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            proposalId: (0, $d5e07fe2518aae94$exports.isSet)(object.proposalId) ? $d5e07fe2518aae94$exports.Long.fromValue(object.proposalId) : $d5e07fe2518aae94$exports.Long.UZERO,
            voter: (0, $d5e07fe2518aae94$exports.isSet)(object.voter) ? String(object.voter) : "",
            options: Array.isArray(object?.options) ? object.options.map((e)=>$adcea68d92ef0a33$exports.WeightedVoteOption.fromJSON(e)) : [],
            metadata: (0, $d5e07fe2518aae94$exports.isSet)(object.metadata) ? String(object.metadata) : ""
        };
    },
    toJSON (message) {
        const obj = {};
        message.proposalId !== undefined && (obj.proposalId = (message.proposalId || $d5e07fe2518aae94$exports.Long.UZERO).toString());
        message.voter !== undefined && (obj.voter = message.voter);
        if (message.options) obj.options = message.options.map((e)=>e ? $adcea68d92ef0a33$exports.WeightedVoteOption.toJSON(e) : undefined);
        else obj.options = [];
        message.metadata !== undefined && (obj.metadata = message.metadata);
        return obj;
    },
    fromPartial (object) {
        const message = $492a1b7730620d95$var$createBaseMsgVoteWeighted();
        message.proposalId = object.proposalId !== undefined && object.proposalId !== null ? $d5e07fe2518aae94$exports.Long.fromValue(object.proposalId) : $d5e07fe2518aae94$exports.Long.UZERO;
        message.voter = object.voter ?? "";
        message.options = object.options?.map((e)=>$adcea68d92ef0a33$exports.WeightedVoteOption.fromPartial(e)) || [];
        message.metadata = object.metadata ?? "";
        return message;
    }
};
function $492a1b7730620d95$var$createBaseMsgVoteWeightedResponse() {
    return {};
}
$492a1b7730620d95$exports.MsgVoteWeightedResponse = {
    encode (_, writer = $492a1b7730620d95$var$_m0.Writer.create()) {
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $492a1b7730620d95$var$_m0.Reader ? input : new $492a1b7730620d95$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $492a1b7730620d95$var$createBaseMsgVoteWeightedResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            tag;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON (_) {
        return {};
    },
    toJSON (_) {
        const obj = {};
        return obj;
    },
    fromPartial (_) {
        const message = $492a1b7730620d95$var$createBaseMsgVoteWeightedResponse();
        return message;
    }
};
function $492a1b7730620d95$var$createBaseMsgDeposit() {
    return {
        proposalId: $d5e07fe2518aae94$exports.Long.UZERO,
        depositor: "",
        amount: []
    };
}
$492a1b7730620d95$exports.MsgDeposit = {
    encode (message, writer = $492a1b7730620d95$var$_m0.Writer.create()) {
        if (!message.proposalId.isZero()) writer.uint32(8).uint64(message.proposalId);
        if (message.depositor !== "") writer.uint32(18).string(message.depositor);
        for (const v of message.amount)$783dd8715fde0fcf$exports.Coin.encode(v, writer.uint32(26).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $492a1b7730620d95$var$_m0.Reader ? input : new $492a1b7730620d95$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $492a1b7730620d95$var$createBaseMsgDeposit();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.proposalId = reader.uint64();
                    break;
                case 2:
                    message.depositor = reader.string();
                    break;
                case 3:
                    message.amount.push($783dd8715fde0fcf$exports.Coin.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            proposalId: (0, $d5e07fe2518aae94$exports.isSet)(object.proposalId) ? $d5e07fe2518aae94$exports.Long.fromValue(object.proposalId) : $d5e07fe2518aae94$exports.Long.UZERO,
            depositor: (0, $d5e07fe2518aae94$exports.isSet)(object.depositor) ? String(object.depositor) : "",
            amount: Array.isArray(object?.amount) ? object.amount.map((e)=>$783dd8715fde0fcf$exports.Coin.fromJSON(e)) : []
        };
    },
    toJSON (message) {
        const obj = {};
        message.proposalId !== undefined && (obj.proposalId = (message.proposalId || $d5e07fe2518aae94$exports.Long.UZERO).toString());
        message.depositor !== undefined && (obj.depositor = message.depositor);
        if (message.amount) obj.amount = message.amount.map((e)=>e ? $783dd8715fde0fcf$exports.Coin.toJSON(e) : undefined);
        else obj.amount = [];
        return obj;
    },
    fromPartial (object) {
        const message = $492a1b7730620d95$var$createBaseMsgDeposit();
        message.proposalId = object.proposalId !== undefined && object.proposalId !== null ? $d5e07fe2518aae94$exports.Long.fromValue(object.proposalId) : $d5e07fe2518aae94$exports.Long.UZERO;
        message.depositor = object.depositor ?? "";
        message.amount = object.amount?.map((e)=>$783dd8715fde0fcf$exports.Coin.fromPartial(e)) || [];
        return message;
    }
};
function $492a1b7730620d95$var$createBaseMsgDepositResponse() {
    return {};
}
$492a1b7730620d95$exports.MsgDepositResponse = {
    encode (_, writer = $492a1b7730620d95$var$_m0.Writer.create()) {
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $492a1b7730620d95$var$_m0.Reader ? input : new $492a1b7730620d95$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $492a1b7730620d95$var$createBaseMsgDepositResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            tag;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON (_) {
        return {};
    },
    toJSON (_) {
        const obj = {};
        return obj;
    },
    fromPartial (_) {
        const message = $492a1b7730620d95$var$createBaseMsgDepositResponse();
        return message;
    }
};
function $492a1b7730620d95$var$createBaseMsgUpdateParams() {
    return {
        authority: "",
        params: undefined
    };
}
$492a1b7730620d95$exports.MsgUpdateParams = {
    encode (message, writer = $492a1b7730620d95$var$_m0.Writer.create()) {
        if (message.authority !== "") writer.uint32(10).string(message.authority);
        if (message.params !== undefined) $adcea68d92ef0a33$exports.Params.encode(message.params, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $492a1b7730620d95$var$_m0.Reader ? input : new $492a1b7730620d95$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $492a1b7730620d95$var$createBaseMsgUpdateParams();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.authority = reader.string();
                    break;
                case 2:
                    message.params = $adcea68d92ef0a33$exports.Params.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            authority: (0, $d5e07fe2518aae94$exports.isSet)(object.authority) ? String(object.authority) : "",
            params: (0, $d5e07fe2518aae94$exports.isSet)(object.params) ? $adcea68d92ef0a33$exports.Params.fromJSON(object.params) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.authority !== undefined && (obj.authority = message.authority);
        message.params !== undefined && (obj.params = message.params ? $adcea68d92ef0a33$exports.Params.toJSON(message.params) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $492a1b7730620d95$var$createBaseMsgUpdateParams();
        message.authority = object.authority ?? "";
        message.params = object.params !== undefined && object.params !== null ? $adcea68d92ef0a33$exports.Params.fromPartial(object.params) : undefined;
        return message;
    }
};
function $492a1b7730620d95$var$createBaseMsgUpdateParamsResponse() {
    return {};
}
$492a1b7730620d95$exports.MsgUpdateParamsResponse = {
    encode (_, writer = $492a1b7730620d95$var$_m0.Writer.create()) {
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $492a1b7730620d95$var$_m0.Reader ? input : new $492a1b7730620d95$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $492a1b7730620d95$var$createBaseMsgUpdateParamsResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            tag;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON (_) {
        return {};
    },
    toJSON (_) {
        const obj = {};
        return obj;
    },
    fromPartial (_) {
        const message = $492a1b7730620d95$var$createBaseMsgUpdateParamsResponse();
        return message;
    }
};
class $492a1b7730620d95$var$MsgClientImpl {
    constructor(rpc){
        this.rpc = rpc;
        this.SubmitProposal = this.SubmitProposal.bind(this);
        this.ExecLegacyContent = this.ExecLegacyContent.bind(this);
        this.Vote = this.Vote.bind(this);
        this.VoteWeighted = this.VoteWeighted.bind(this);
        this.Deposit = this.Deposit.bind(this);
        this.UpdateParams = this.UpdateParams.bind(this);
    }
    SubmitProposal(request) {
        const data = $492a1b7730620d95$exports.MsgSubmitProposal.encode(request).finish();
        const promise = this.rpc.request("cosmos.gov.v1.Msg", "SubmitProposal", data);
        return promise.then((data)=>$492a1b7730620d95$exports.MsgSubmitProposalResponse.decode(new $492a1b7730620d95$var$_m0.Reader(data)));
    }
    ExecLegacyContent(request) {
        const data = $492a1b7730620d95$exports.MsgExecLegacyContent.encode(request).finish();
        const promise = this.rpc.request("cosmos.gov.v1.Msg", "ExecLegacyContent", data);
        return promise.then((data)=>$492a1b7730620d95$exports.MsgExecLegacyContentResponse.decode(new $492a1b7730620d95$var$_m0.Reader(data)));
    }
    Vote(request) {
        const data = $492a1b7730620d95$exports.MsgVote.encode(request).finish();
        const promise = this.rpc.request("cosmos.gov.v1.Msg", "Vote", data);
        return promise.then((data)=>$492a1b7730620d95$exports.MsgVoteResponse.decode(new $492a1b7730620d95$var$_m0.Reader(data)));
    }
    VoteWeighted(request) {
        const data = $492a1b7730620d95$exports.MsgVoteWeighted.encode(request).finish();
        const promise = this.rpc.request("cosmos.gov.v1.Msg", "VoteWeighted", data);
        return promise.then((data)=>$492a1b7730620d95$exports.MsgVoteWeightedResponse.decode(new $492a1b7730620d95$var$_m0.Reader(data)));
    }
    Deposit(request) {
        const data = $492a1b7730620d95$exports.MsgDeposit.encode(request).finish();
        const promise = this.rpc.request("cosmos.gov.v1.Msg", "Deposit", data);
        return promise.then((data)=>$492a1b7730620d95$exports.MsgDepositResponse.decode(new $492a1b7730620d95$var$_m0.Reader(data)));
    }
    UpdateParams(request) {
        const data = $492a1b7730620d95$exports.MsgUpdateParams.encode(request).finish();
        const promise = this.rpc.request("cosmos.gov.v1.Msg", "UpdateParams", data);
        return promise.then((data)=>$492a1b7730620d95$exports.MsgUpdateParamsResponse.decode(new $492a1b7730620d95$var$_m0.Reader(data)));
    }
}
$492a1b7730620d95$exports.MsgClientImpl = $492a1b7730620d95$var$MsgClientImpl;


var $89c79fb5f3bafc49$exports = {};
"use strict";
var $89c79fb5f3bafc49$var$__createBinding = $89c79fb5f3bafc49$exports && $89c79fb5f3bafc49$exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $89c79fb5f3bafc49$var$__setModuleDefault = $89c79fb5f3bafc49$exports && $89c79fb5f3bafc49$exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $89c79fb5f3bafc49$var$__importStar = $89c79fb5f3bafc49$exports && $89c79fb5f3bafc49$exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $89c79fb5f3bafc49$var$__createBinding(result, mod, k);
    }
    $89c79fb5f3bafc49$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty($89c79fb5f3bafc49$exports, "__esModule", {
    value: true
});
$89c79fb5f3bafc49$exports.MsgClientImpl = $89c79fb5f3bafc49$exports.MsgDepositResponse = $89c79fb5f3bafc49$exports.MsgDeposit = $89c79fb5f3bafc49$exports.MsgVoteWeightedResponse = $89c79fb5f3bafc49$exports.MsgVoteWeighted = $89c79fb5f3bafc49$exports.MsgVoteResponse = $89c79fb5f3bafc49$exports.MsgVote = $89c79fb5f3bafc49$exports.MsgSubmitProposalResponse = $89c79fb5f3bafc49$exports.MsgSubmitProposal = $89c79fb5f3bafc49$exports.protobufPackage = void 0;





const $89c79fb5f3bafc49$var$_m0 = $89c79fb5f3bafc49$var$__importStar((parcelRequire("fQBv0")));
$89c79fb5f3bafc49$exports.protobufPackage = "cosmos.gov.v1beta1";
function $89c79fb5f3bafc49$var$createBaseMsgSubmitProposal() {
    return {
        content: undefined,
        initialDeposit: [],
        proposer: ""
    };
}
$89c79fb5f3bafc49$exports.MsgSubmitProposal = {
    encode (message, writer = $89c79fb5f3bafc49$var$_m0.Writer.create()) {
        if (message.content !== undefined) $64138e590dcf0cc1$exports.Any.encode(message.content, writer.uint32(10).fork()).ldelim();
        for (const v of message.initialDeposit)$783dd8715fde0fcf$exports.Coin.encode(v, writer.uint32(18).fork()).ldelim();
        if (message.proposer !== "") writer.uint32(26).string(message.proposer);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $89c79fb5f3bafc49$var$_m0.Reader ? input : new $89c79fb5f3bafc49$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $89c79fb5f3bafc49$var$createBaseMsgSubmitProposal();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.content = $64138e590dcf0cc1$exports.Any.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.initialDeposit.push($783dd8715fde0fcf$exports.Coin.decode(reader, reader.uint32()));
                    break;
                case 3:
                    message.proposer = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            content: (0, $d5e07fe2518aae94$exports.isSet)(object.content) ? $64138e590dcf0cc1$exports.Any.fromJSON(object.content) : undefined,
            initialDeposit: Array.isArray(object?.initialDeposit) ? object.initialDeposit.map((e)=>$783dd8715fde0fcf$exports.Coin.fromJSON(e)) : [],
            proposer: (0, $d5e07fe2518aae94$exports.isSet)(object.proposer) ? String(object.proposer) : ""
        };
    },
    toJSON (message) {
        const obj = {};
        message.content !== undefined && (obj.content = message.content ? $64138e590dcf0cc1$exports.Any.toJSON(message.content) : undefined);
        if (message.initialDeposit) obj.initialDeposit = message.initialDeposit.map((e)=>e ? $783dd8715fde0fcf$exports.Coin.toJSON(e) : undefined);
        else obj.initialDeposit = [];
        message.proposer !== undefined && (obj.proposer = message.proposer);
        return obj;
    },
    fromPartial (object) {
        const message = $89c79fb5f3bafc49$var$createBaseMsgSubmitProposal();
        message.content = object.content !== undefined && object.content !== null ? $64138e590dcf0cc1$exports.Any.fromPartial(object.content) : undefined;
        message.initialDeposit = object.initialDeposit?.map((e)=>$783dd8715fde0fcf$exports.Coin.fromPartial(e)) || [];
        message.proposer = object.proposer ?? "";
        return message;
    }
};
function $89c79fb5f3bafc49$var$createBaseMsgSubmitProposalResponse() {
    return {
        proposalId: $d5e07fe2518aae94$exports.Long.UZERO
    };
}
$89c79fb5f3bafc49$exports.MsgSubmitProposalResponse = {
    encode (message, writer = $89c79fb5f3bafc49$var$_m0.Writer.create()) {
        if (!message.proposalId.isZero()) writer.uint32(8).uint64(message.proposalId);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $89c79fb5f3bafc49$var$_m0.Reader ? input : new $89c79fb5f3bafc49$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $89c79fb5f3bafc49$var$createBaseMsgSubmitProposalResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.proposalId = reader.uint64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            proposalId: (0, $d5e07fe2518aae94$exports.isSet)(object.proposalId) ? $d5e07fe2518aae94$exports.Long.fromValue(object.proposalId) : $d5e07fe2518aae94$exports.Long.UZERO
        };
    },
    toJSON (message) {
        const obj = {};
        message.proposalId !== undefined && (obj.proposalId = (message.proposalId || $d5e07fe2518aae94$exports.Long.UZERO).toString());
        return obj;
    },
    fromPartial (object) {
        const message = $89c79fb5f3bafc49$var$createBaseMsgSubmitProposalResponse();
        message.proposalId = object.proposalId !== undefined && object.proposalId !== null ? $d5e07fe2518aae94$exports.Long.fromValue(object.proposalId) : $d5e07fe2518aae94$exports.Long.UZERO;
        return message;
    }
};
function $89c79fb5f3bafc49$var$createBaseMsgVote() {
    return {
        proposalId: $d5e07fe2518aae94$exports.Long.UZERO,
        voter: "",
        option: 0
    };
}
$89c79fb5f3bafc49$exports.MsgVote = {
    encode (message, writer = $89c79fb5f3bafc49$var$_m0.Writer.create()) {
        if (!message.proposalId.isZero()) writer.uint32(8).uint64(message.proposalId);
        if (message.voter !== "") writer.uint32(18).string(message.voter);
        if (message.option !== 0) writer.uint32(24).int32(message.option);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $89c79fb5f3bafc49$var$_m0.Reader ? input : new $89c79fb5f3bafc49$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $89c79fb5f3bafc49$var$createBaseMsgVote();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.proposalId = reader.uint64();
                    break;
                case 2:
                    message.voter = reader.string();
                    break;
                case 3:
                    message.option = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            proposalId: (0, $d5e07fe2518aae94$exports.isSet)(object.proposalId) ? $d5e07fe2518aae94$exports.Long.fromValue(object.proposalId) : $d5e07fe2518aae94$exports.Long.UZERO,
            voter: (0, $d5e07fe2518aae94$exports.isSet)(object.voter) ? String(object.voter) : "",
            option: (0, $d5e07fe2518aae94$exports.isSet)(object.option) ? (0, $737f3deb0a132861$exports.voteOptionFromJSON)(object.option) : 0
        };
    },
    toJSON (message) {
        const obj = {};
        message.proposalId !== undefined && (obj.proposalId = (message.proposalId || $d5e07fe2518aae94$exports.Long.UZERO).toString());
        message.voter !== undefined && (obj.voter = message.voter);
        message.option !== undefined && (obj.option = (0, $737f3deb0a132861$exports.voteOptionToJSON)(message.option));
        return obj;
    },
    fromPartial (object) {
        const message = $89c79fb5f3bafc49$var$createBaseMsgVote();
        message.proposalId = object.proposalId !== undefined && object.proposalId !== null ? $d5e07fe2518aae94$exports.Long.fromValue(object.proposalId) : $d5e07fe2518aae94$exports.Long.UZERO;
        message.voter = object.voter ?? "";
        message.option = object.option ?? 0;
        return message;
    }
};
function $89c79fb5f3bafc49$var$createBaseMsgVoteResponse() {
    return {};
}
$89c79fb5f3bafc49$exports.MsgVoteResponse = {
    encode (_, writer = $89c79fb5f3bafc49$var$_m0.Writer.create()) {
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $89c79fb5f3bafc49$var$_m0.Reader ? input : new $89c79fb5f3bafc49$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $89c79fb5f3bafc49$var$createBaseMsgVoteResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            tag;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON (_) {
        return {};
    },
    toJSON (_) {
        const obj = {};
        return obj;
    },
    fromPartial (_) {
        const message = $89c79fb5f3bafc49$var$createBaseMsgVoteResponse();
        return message;
    }
};
function $89c79fb5f3bafc49$var$createBaseMsgVoteWeighted() {
    return {
        proposalId: $d5e07fe2518aae94$exports.Long.UZERO,
        voter: "",
        options: []
    };
}
$89c79fb5f3bafc49$exports.MsgVoteWeighted = {
    encode (message, writer = $89c79fb5f3bafc49$var$_m0.Writer.create()) {
        if (!message.proposalId.isZero()) writer.uint32(8).uint64(message.proposalId);
        if (message.voter !== "") writer.uint32(18).string(message.voter);
        for (const v of message.options)$737f3deb0a132861$exports.WeightedVoteOption.encode(v, writer.uint32(26).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $89c79fb5f3bafc49$var$_m0.Reader ? input : new $89c79fb5f3bafc49$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $89c79fb5f3bafc49$var$createBaseMsgVoteWeighted();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.proposalId = reader.uint64();
                    break;
                case 2:
                    message.voter = reader.string();
                    break;
                case 3:
                    message.options.push($737f3deb0a132861$exports.WeightedVoteOption.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            proposalId: (0, $d5e07fe2518aae94$exports.isSet)(object.proposalId) ? $d5e07fe2518aae94$exports.Long.fromValue(object.proposalId) : $d5e07fe2518aae94$exports.Long.UZERO,
            voter: (0, $d5e07fe2518aae94$exports.isSet)(object.voter) ? String(object.voter) : "",
            options: Array.isArray(object?.options) ? object.options.map((e)=>$737f3deb0a132861$exports.WeightedVoteOption.fromJSON(e)) : []
        };
    },
    toJSON (message) {
        const obj = {};
        message.proposalId !== undefined && (obj.proposalId = (message.proposalId || $d5e07fe2518aae94$exports.Long.UZERO).toString());
        message.voter !== undefined && (obj.voter = message.voter);
        if (message.options) obj.options = message.options.map((e)=>e ? $737f3deb0a132861$exports.WeightedVoteOption.toJSON(e) : undefined);
        else obj.options = [];
        return obj;
    },
    fromPartial (object) {
        const message = $89c79fb5f3bafc49$var$createBaseMsgVoteWeighted();
        message.proposalId = object.proposalId !== undefined && object.proposalId !== null ? $d5e07fe2518aae94$exports.Long.fromValue(object.proposalId) : $d5e07fe2518aae94$exports.Long.UZERO;
        message.voter = object.voter ?? "";
        message.options = object.options?.map((e)=>$737f3deb0a132861$exports.WeightedVoteOption.fromPartial(e)) || [];
        return message;
    }
};
function $89c79fb5f3bafc49$var$createBaseMsgVoteWeightedResponse() {
    return {};
}
$89c79fb5f3bafc49$exports.MsgVoteWeightedResponse = {
    encode (_, writer = $89c79fb5f3bafc49$var$_m0.Writer.create()) {
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $89c79fb5f3bafc49$var$_m0.Reader ? input : new $89c79fb5f3bafc49$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $89c79fb5f3bafc49$var$createBaseMsgVoteWeightedResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            tag;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON (_) {
        return {};
    },
    toJSON (_) {
        const obj = {};
        return obj;
    },
    fromPartial (_) {
        const message = $89c79fb5f3bafc49$var$createBaseMsgVoteWeightedResponse();
        return message;
    }
};
function $89c79fb5f3bafc49$var$createBaseMsgDeposit() {
    return {
        proposalId: $d5e07fe2518aae94$exports.Long.UZERO,
        depositor: "",
        amount: []
    };
}
$89c79fb5f3bafc49$exports.MsgDeposit = {
    encode (message, writer = $89c79fb5f3bafc49$var$_m0.Writer.create()) {
        if (!message.proposalId.isZero()) writer.uint32(8).uint64(message.proposalId);
        if (message.depositor !== "") writer.uint32(18).string(message.depositor);
        for (const v of message.amount)$783dd8715fde0fcf$exports.Coin.encode(v, writer.uint32(26).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $89c79fb5f3bafc49$var$_m0.Reader ? input : new $89c79fb5f3bafc49$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $89c79fb5f3bafc49$var$createBaseMsgDeposit();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.proposalId = reader.uint64();
                    break;
                case 2:
                    message.depositor = reader.string();
                    break;
                case 3:
                    message.amount.push($783dd8715fde0fcf$exports.Coin.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            proposalId: (0, $d5e07fe2518aae94$exports.isSet)(object.proposalId) ? $d5e07fe2518aae94$exports.Long.fromValue(object.proposalId) : $d5e07fe2518aae94$exports.Long.UZERO,
            depositor: (0, $d5e07fe2518aae94$exports.isSet)(object.depositor) ? String(object.depositor) : "",
            amount: Array.isArray(object?.amount) ? object.amount.map((e)=>$783dd8715fde0fcf$exports.Coin.fromJSON(e)) : []
        };
    },
    toJSON (message) {
        const obj = {};
        message.proposalId !== undefined && (obj.proposalId = (message.proposalId || $d5e07fe2518aae94$exports.Long.UZERO).toString());
        message.depositor !== undefined && (obj.depositor = message.depositor);
        if (message.amount) obj.amount = message.amount.map((e)=>e ? $783dd8715fde0fcf$exports.Coin.toJSON(e) : undefined);
        else obj.amount = [];
        return obj;
    },
    fromPartial (object) {
        const message = $89c79fb5f3bafc49$var$createBaseMsgDeposit();
        message.proposalId = object.proposalId !== undefined && object.proposalId !== null ? $d5e07fe2518aae94$exports.Long.fromValue(object.proposalId) : $d5e07fe2518aae94$exports.Long.UZERO;
        message.depositor = object.depositor ?? "";
        message.amount = object.amount?.map((e)=>$783dd8715fde0fcf$exports.Coin.fromPartial(e)) || [];
        return message;
    }
};
function $89c79fb5f3bafc49$var$createBaseMsgDepositResponse() {
    return {};
}
$89c79fb5f3bafc49$exports.MsgDepositResponse = {
    encode (_, writer = $89c79fb5f3bafc49$var$_m0.Writer.create()) {
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $89c79fb5f3bafc49$var$_m0.Reader ? input : new $89c79fb5f3bafc49$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $89c79fb5f3bafc49$var$createBaseMsgDepositResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            tag;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON (_) {
        return {};
    },
    toJSON (_) {
        const obj = {};
        return obj;
    },
    fromPartial (_) {
        const message = $89c79fb5f3bafc49$var$createBaseMsgDepositResponse();
        return message;
    }
};
class $89c79fb5f3bafc49$var$MsgClientImpl {
    constructor(rpc){
        this.rpc = rpc;
        this.SubmitProposal = this.SubmitProposal.bind(this);
        this.Vote = this.Vote.bind(this);
        this.VoteWeighted = this.VoteWeighted.bind(this);
        this.Deposit = this.Deposit.bind(this);
    }
    SubmitProposal(request) {
        const data = $89c79fb5f3bafc49$exports.MsgSubmitProposal.encode(request).finish();
        const promise = this.rpc.request("cosmos.gov.v1beta1.Msg", "SubmitProposal", data);
        return promise.then((data)=>$89c79fb5f3bafc49$exports.MsgSubmitProposalResponse.decode(new $89c79fb5f3bafc49$var$_m0.Reader(data)));
    }
    Vote(request) {
        const data = $89c79fb5f3bafc49$exports.MsgVote.encode(request).finish();
        const promise = this.rpc.request("cosmos.gov.v1beta1.Msg", "Vote", data);
        return promise.then((data)=>$89c79fb5f3bafc49$exports.MsgVoteResponse.decode(new $89c79fb5f3bafc49$var$_m0.Reader(data)));
    }
    VoteWeighted(request) {
        const data = $89c79fb5f3bafc49$exports.MsgVoteWeighted.encode(request).finish();
        const promise = this.rpc.request("cosmos.gov.v1beta1.Msg", "VoteWeighted", data);
        return promise.then((data)=>$89c79fb5f3bafc49$exports.MsgVoteWeightedResponse.decode(new $89c79fb5f3bafc49$var$_m0.Reader(data)));
    }
    Deposit(request) {
        const data = $89c79fb5f3bafc49$exports.MsgDeposit.encode(request).finish();
        const promise = this.rpc.request("cosmos.gov.v1beta1.Msg", "Deposit", data);
        return promise.then((data)=>$89c79fb5f3bafc49$exports.MsgDepositResponse.decode(new $89c79fb5f3bafc49$var$_m0.Reader(data)));
    }
}
$89c79fb5f3bafc49$exports.MsgClientImpl = $89c79fb5f3bafc49$var$MsgClientImpl;


$c210fc7a41e9e12f$exports.govTypes = [
    [
        "/cosmos.gov.v1.MsgDeposit",
        $492a1b7730620d95$exports.MsgDeposit
    ],
    [
        "/cosmos.gov.v1.MsgSubmitProposal",
        $492a1b7730620d95$exports.MsgSubmitProposal
    ],
    [
        "/cosmos.gov.v1.MsgUpdateParams",
        $492a1b7730620d95$exports.MsgUpdateParams
    ],
    [
        "/cosmos.gov.v1.MsgVote",
        $492a1b7730620d95$exports.MsgVote
    ],
    [
        "/cosmos.gov.v1.MsgVoteWeighted",
        $492a1b7730620d95$exports.MsgVoteWeighted
    ],
    [
        "/cosmos.gov.v1beta1.MsgDeposit",
        $89c79fb5f3bafc49$exports.MsgDeposit
    ],
    [
        "/cosmos.gov.v1beta1.MsgSubmitProposal",
        $89c79fb5f3bafc49$exports.MsgSubmitProposal
    ],
    [
        "/cosmos.gov.v1beta1.MsgVote",
        $89c79fb5f3bafc49$exports.MsgVote
    ],
    [
        "/cosmos.gov.v1beta1.MsgVoteWeighted",
        $89c79fb5f3bafc49$exports.MsgVoteWeighted
    ]
];
function $c210fc7a41e9e12f$var$isMsgDepositEncodeObject(object) {
    return object.typeUrl === "/cosmos.gov.v1beta1.MsgDeposit";
}
$c210fc7a41e9e12f$exports.isMsgDepositEncodeObject = $c210fc7a41e9e12f$var$isMsgDepositEncodeObject;
function $c210fc7a41e9e12f$var$isMsgSubmitProposalEncodeObject(object) {
    return object.typeUrl === "/cosmos.gov.v1beta1.MsgSubmitProposal";
}
$c210fc7a41e9e12f$exports.isMsgSubmitProposalEncodeObject = $c210fc7a41e9e12f$var$isMsgSubmitProposalEncodeObject;
function $c210fc7a41e9e12f$var$isMsgVoteEncodeObject(object) {
    return object.typeUrl === "/cosmos.gov.v1beta1.MsgVote";
}
$c210fc7a41e9e12f$exports.isMsgVoteEncodeObject = $c210fc7a41e9e12f$var$isMsgVoteEncodeObject;
function $c210fc7a41e9e12f$var$isMsgVoteWeightedEncodeObject(object) {
    return object.typeUrl === "/cosmos.gov.v1beta1.MsgVoteWeighted";
}
$c210fc7a41e9e12f$exports.isMsgVoteWeightedEncodeObject = $c210fc7a41e9e12f$var$isMsgVoteWeightedEncodeObject;


Object.defineProperty($d0d8b6f4712acd9f$exports, "govTypes", {
    enumerable: true,
    get: function() {
        return $c210fc7a41e9e12f$exports.govTypes;
    }
});
Object.defineProperty($d0d8b6f4712acd9f$exports, "isMsgDepositEncodeObject", {
    enumerable: true,
    get: function() {
        return $c210fc7a41e9e12f$exports.isMsgDepositEncodeObject;
    }
});
Object.defineProperty($d0d8b6f4712acd9f$exports, "isMsgSubmitProposalEncodeObject", {
    enumerable: true,
    get: function() {
        return $c210fc7a41e9e12f$exports.isMsgSubmitProposalEncodeObject;
    }
});
Object.defineProperty($d0d8b6f4712acd9f$exports, "isMsgVoteEncodeObject", {
    enumerable: true,
    get: function() {
        return $c210fc7a41e9e12f$exports.isMsgVoteEncodeObject;
    }
});
Object.defineProperty($d0d8b6f4712acd9f$exports, "isMsgVoteWeightedEncodeObject", {
    enumerable: true,
    get: function() {
        return $c210fc7a41e9e12f$exports.isMsgVoteWeightedEncodeObject;
    }
});
var $f6b416da756e1924$exports = {};
"use strict";
Object.defineProperty($f6b416da756e1924$exports, "__esModule", {
    value: true
});
$f6b416da756e1924$exports.setupGovExtension = void 0;
var $4feaec90c73c42da$exports = {};
"use strict";
var $4feaec90c73c42da$var$__createBinding = $4feaec90c73c42da$exports && $4feaec90c73c42da$exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $4feaec90c73c42da$var$__setModuleDefault = $4feaec90c73c42da$exports && $4feaec90c73c42da$exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $4feaec90c73c42da$var$__importStar = $4feaec90c73c42da$exports && $4feaec90c73c42da$exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $4feaec90c73c42da$var$__createBinding(result, mod, k);
    }
    $4feaec90c73c42da$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty($4feaec90c73c42da$exports, "__esModule", {
    value: true
});
$4feaec90c73c42da$exports.QueryClientImpl = $4feaec90c73c42da$exports.QueryTallyResultResponse = $4feaec90c73c42da$exports.QueryTallyResultRequest = $4feaec90c73c42da$exports.QueryDepositsResponse = $4feaec90c73c42da$exports.QueryDepositsRequest = $4feaec90c73c42da$exports.QueryDepositResponse = $4feaec90c73c42da$exports.QueryDepositRequest = $4feaec90c73c42da$exports.QueryParamsResponse = $4feaec90c73c42da$exports.QueryParamsRequest = $4feaec90c73c42da$exports.QueryVotesResponse = $4feaec90c73c42da$exports.QueryVotesRequest = $4feaec90c73c42da$exports.QueryVoteResponse = $4feaec90c73c42da$exports.QueryVoteRequest = $4feaec90c73c42da$exports.QueryProposalsResponse = $4feaec90c73c42da$exports.QueryProposalsRequest = $4feaec90c73c42da$exports.QueryProposalResponse = $4feaec90c73c42da$exports.QueryProposalRequest = $4feaec90c73c42da$exports.protobufPackage = void 0;




const $4feaec90c73c42da$var$_m0 = $4feaec90c73c42da$var$__importStar((parcelRequire("fQBv0")));
$4feaec90c73c42da$exports.protobufPackage = "cosmos.gov.v1beta1";
function $4feaec90c73c42da$var$createBaseQueryProposalRequest() {
    return {
        proposalId: $d5e07fe2518aae94$exports.Long.UZERO
    };
}
$4feaec90c73c42da$exports.QueryProposalRequest = {
    encode (message, writer = $4feaec90c73c42da$var$_m0.Writer.create()) {
        if (!message.proposalId.isZero()) writer.uint32(8).uint64(message.proposalId);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $4feaec90c73c42da$var$_m0.Reader ? input : new $4feaec90c73c42da$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $4feaec90c73c42da$var$createBaseQueryProposalRequest();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.proposalId = reader.uint64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            proposalId: (0, $d5e07fe2518aae94$exports.isSet)(object.proposalId) ? $d5e07fe2518aae94$exports.Long.fromValue(object.proposalId) : $d5e07fe2518aae94$exports.Long.UZERO
        };
    },
    toJSON (message) {
        const obj = {};
        message.proposalId !== undefined && (obj.proposalId = (message.proposalId || $d5e07fe2518aae94$exports.Long.UZERO).toString());
        return obj;
    },
    fromPartial (object) {
        const message = $4feaec90c73c42da$var$createBaseQueryProposalRequest();
        message.proposalId = object.proposalId !== undefined && object.proposalId !== null ? $d5e07fe2518aae94$exports.Long.fromValue(object.proposalId) : $d5e07fe2518aae94$exports.Long.UZERO;
        return message;
    }
};
function $4feaec90c73c42da$var$createBaseQueryProposalResponse() {
    return {
        proposal: undefined
    };
}
$4feaec90c73c42da$exports.QueryProposalResponse = {
    encode (message, writer = $4feaec90c73c42da$var$_m0.Writer.create()) {
        if (message.proposal !== undefined) $737f3deb0a132861$exports.Proposal.encode(message.proposal, writer.uint32(10).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $4feaec90c73c42da$var$_m0.Reader ? input : new $4feaec90c73c42da$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $4feaec90c73c42da$var$createBaseQueryProposalResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.proposal = $737f3deb0a132861$exports.Proposal.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            proposal: (0, $d5e07fe2518aae94$exports.isSet)(object.proposal) ? $737f3deb0a132861$exports.Proposal.fromJSON(object.proposal) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.proposal !== undefined && (obj.proposal = message.proposal ? $737f3deb0a132861$exports.Proposal.toJSON(message.proposal) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $4feaec90c73c42da$var$createBaseQueryProposalResponse();
        message.proposal = object.proposal !== undefined && object.proposal !== null ? $737f3deb0a132861$exports.Proposal.fromPartial(object.proposal) : undefined;
        return message;
    }
};
function $4feaec90c73c42da$var$createBaseQueryProposalsRequest() {
    return {
        proposalStatus: 0,
        voter: "",
        depositor: "",
        pagination: undefined
    };
}
$4feaec90c73c42da$exports.QueryProposalsRequest = {
    encode (message, writer = $4feaec90c73c42da$var$_m0.Writer.create()) {
        if (message.proposalStatus !== 0) writer.uint32(8).int32(message.proposalStatus);
        if (message.voter !== "") writer.uint32(18).string(message.voter);
        if (message.depositor !== "") writer.uint32(26).string(message.depositor);
        if (message.pagination !== undefined) $5eae5f3cc99e92ab$exports.PageRequest.encode(message.pagination, writer.uint32(34).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $4feaec90c73c42da$var$_m0.Reader ? input : new $4feaec90c73c42da$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $4feaec90c73c42da$var$createBaseQueryProposalsRequest();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.proposalStatus = reader.int32();
                    break;
                case 2:
                    message.voter = reader.string();
                    break;
                case 3:
                    message.depositor = reader.string();
                    break;
                case 4:
                    message.pagination = $5eae5f3cc99e92ab$exports.PageRequest.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            proposalStatus: (0, $d5e07fe2518aae94$exports.isSet)(object.proposalStatus) ? (0, $737f3deb0a132861$exports.proposalStatusFromJSON)(object.proposalStatus) : 0,
            voter: (0, $d5e07fe2518aae94$exports.isSet)(object.voter) ? String(object.voter) : "",
            depositor: (0, $d5e07fe2518aae94$exports.isSet)(object.depositor) ? String(object.depositor) : "",
            pagination: (0, $d5e07fe2518aae94$exports.isSet)(object.pagination) ? $5eae5f3cc99e92ab$exports.PageRequest.fromJSON(object.pagination) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.proposalStatus !== undefined && (obj.proposalStatus = (0, $737f3deb0a132861$exports.proposalStatusToJSON)(message.proposalStatus));
        message.voter !== undefined && (obj.voter = message.voter);
        message.depositor !== undefined && (obj.depositor = message.depositor);
        message.pagination !== undefined && (obj.pagination = message.pagination ? $5eae5f3cc99e92ab$exports.PageRequest.toJSON(message.pagination) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $4feaec90c73c42da$var$createBaseQueryProposalsRequest();
        message.proposalStatus = object.proposalStatus ?? 0;
        message.voter = object.voter ?? "";
        message.depositor = object.depositor ?? "";
        message.pagination = object.pagination !== undefined && object.pagination !== null ? $5eae5f3cc99e92ab$exports.PageRequest.fromPartial(object.pagination) : undefined;
        return message;
    }
};
function $4feaec90c73c42da$var$createBaseQueryProposalsResponse() {
    return {
        proposals: [],
        pagination: undefined
    };
}
$4feaec90c73c42da$exports.QueryProposalsResponse = {
    encode (message, writer = $4feaec90c73c42da$var$_m0.Writer.create()) {
        for (const v of message.proposals)$737f3deb0a132861$exports.Proposal.encode(v, writer.uint32(10).fork()).ldelim();
        if (message.pagination !== undefined) $5eae5f3cc99e92ab$exports.PageResponse.encode(message.pagination, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $4feaec90c73c42da$var$_m0.Reader ? input : new $4feaec90c73c42da$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $4feaec90c73c42da$var$createBaseQueryProposalsResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.proposals.push($737f3deb0a132861$exports.Proposal.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.pagination = $5eae5f3cc99e92ab$exports.PageResponse.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            proposals: Array.isArray(object?.proposals) ? object.proposals.map((e)=>$737f3deb0a132861$exports.Proposal.fromJSON(e)) : [],
            pagination: (0, $d5e07fe2518aae94$exports.isSet)(object.pagination) ? $5eae5f3cc99e92ab$exports.PageResponse.fromJSON(object.pagination) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        if (message.proposals) obj.proposals = message.proposals.map((e)=>e ? $737f3deb0a132861$exports.Proposal.toJSON(e) : undefined);
        else obj.proposals = [];
        message.pagination !== undefined && (obj.pagination = message.pagination ? $5eae5f3cc99e92ab$exports.PageResponse.toJSON(message.pagination) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $4feaec90c73c42da$var$createBaseQueryProposalsResponse();
        message.proposals = object.proposals?.map((e)=>$737f3deb0a132861$exports.Proposal.fromPartial(e)) || [];
        message.pagination = object.pagination !== undefined && object.pagination !== null ? $5eae5f3cc99e92ab$exports.PageResponse.fromPartial(object.pagination) : undefined;
        return message;
    }
};
function $4feaec90c73c42da$var$createBaseQueryVoteRequest() {
    return {
        proposalId: $d5e07fe2518aae94$exports.Long.UZERO,
        voter: ""
    };
}
$4feaec90c73c42da$exports.QueryVoteRequest = {
    encode (message, writer = $4feaec90c73c42da$var$_m0.Writer.create()) {
        if (!message.proposalId.isZero()) writer.uint32(8).uint64(message.proposalId);
        if (message.voter !== "") writer.uint32(18).string(message.voter);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $4feaec90c73c42da$var$_m0.Reader ? input : new $4feaec90c73c42da$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $4feaec90c73c42da$var$createBaseQueryVoteRequest();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.proposalId = reader.uint64();
                    break;
                case 2:
                    message.voter = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            proposalId: (0, $d5e07fe2518aae94$exports.isSet)(object.proposalId) ? $d5e07fe2518aae94$exports.Long.fromValue(object.proposalId) : $d5e07fe2518aae94$exports.Long.UZERO,
            voter: (0, $d5e07fe2518aae94$exports.isSet)(object.voter) ? String(object.voter) : ""
        };
    },
    toJSON (message) {
        const obj = {};
        message.proposalId !== undefined && (obj.proposalId = (message.proposalId || $d5e07fe2518aae94$exports.Long.UZERO).toString());
        message.voter !== undefined && (obj.voter = message.voter);
        return obj;
    },
    fromPartial (object) {
        const message = $4feaec90c73c42da$var$createBaseQueryVoteRequest();
        message.proposalId = object.proposalId !== undefined && object.proposalId !== null ? $d5e07fe2518aae94$exports.Long.fromValue(object.proposalId) : $d5e07fe2518aae94$exports.Long.UZERO;
        message.voter = object.voter ?? "";
        return message;
    }
};
function $4feaec90c73c42da$var$createBaseQueryVoteResponse() {
    return {
        vote: undefined
    };
}
$4feaec90c73c42da$exports.QueryVoteResponse = {
    encode (message, writer = $4feaec90c73c42da$var$_m0.Writer.create()) {
        if (message.vote !== undefined) $737f3deb0a132861$exports.Vote.encode(message.vote, writer.uint32(10).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $4feaec90c73c42da$var$_m0.Reader ? input : new $4feaec90c73c42da$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $4feaec90c73c42da$var$createBaseQueryVoteResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.vote = $737f3deb0a132861$exports.Vote.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            vote: (0, $d5e07fe2518aae94$exports.isSet)(object.vote) ? $737f3deb0a132861$exports.Vote.fromJSON(object.vote) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.vote !== undefined && (obj.vote = message.vote ? $737f3deb0a132861$exports.Vote.toJSON(message.vote) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $4feaec90c73c42da$var$createBaseQueryVoteResponse();
        message.vote = object.vote !== undefined && object.vote !== null ? $737f3deb0a132861$exports.Vote.fromPartial(object.vote) : undefined;
        return message;
    }
};
function $4feaec90c73c42da$var$createBaseQueryVotesRequest() {
    return {
        proposalId: $d5e07fe2518aae94$exports.Long.UZERO,
        pagination: undefined
    };
}
$4feaec90c73c42da$exports.QueryVotesRequest = {
    encode (message, writer = $4feaec90c73c42da$var$_m0.Writer.create()) {
        if (!message.proposalId.isZero()) writer.uint32(8).uint64(message.proposalId);
        if (message.pagination !== undefined) $5eae5f3cc99e92ab$exports.PageRequest.encode(message.pagination, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $4feaec90c73c42da$var$_m0.Reader ? input : new $4feaec90c73c42da$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $4feaec90c73c42da$var$createBaseQueryVotesRequest();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.proposalId = reader.uint64();
                    break;
                case 2:
                    message.pagination = $5eae5f3cc99e92ab$exports.PageRequest.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            proposalId: (0, $d5e07fe2518aae94$exports.isSet)(object.proposalId) ? $d5e07fe2518aae94$exports.Long.fromValue(object.proposalId) : $d5e07fe2518aae94$exports.Long.UZERO,
            pagination: (0, $d5e07fe2518aae94$exports.isSet)(object.pagination) ? $5eae5f3cc99e92ab$exports.PageRequest.fromJSON(object.pagination) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.proposalId !== undefined && (obj.proposalId = (message.proposalId || $d5e07fe2518aae94$exports.Long.UZERO).toString());
        message.pagination !== undefined && (obj.pagination = message.pagination ? $5eae5f3cc99e92ab$exports.PageRequest.toJSON(message.pagination) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $4feaec90c73c42da$var$createBaseQueryVotesRequest();
        message.proposalId = object.proposalId !== undefined && object.proposalId !== null ? $d5e07fe2518aae94$exports.Long.fromValue(object.proposalId) : $d5e07fe2518aae94$exports.Long.UZERO;
        message.pagination = object.pagination !== undefined && object.pagination !== null ? $5eae5f3cc99e92ab$exports.PageRequest.fromPartial(object.pagination) : undefined;
        return message;
    }
};
function $4feaec90c73c42da$var$createBaseQueryVotesResponse() {
    return {
        votes: [],
        pagination: undefined
    };
}
$4feaec90c73c42da$exports.QueryVotesResponse = {
    encode (message, writer = $4feaec90c73c42da$var$_m0.Writer.create()) {
        for (const v of message.votes)$737f3deb0a132861$exports.Vote.encode(v, writer.uint32(10).fork()).ldelim();
        if (message.pagination !== undefined) $5eae5f3cc99e92ab$exports.PageResponse.encode(message.pagination, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $4feaec90c73c42da$var$_m0.Reader ? input : new $4feaec90c73c42da$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $4feaec90c73c42da$var$createBaseQueryVotesResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.votes.push($737f3deb0a132861$exports.Vote.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.pagination = $5eae5f3cc99e92ab$exports.PageResponse.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            votes: Array.isArray(object?.votes) ? object.votes.map((e)=>$737f3deb0a132861$exports.Vote.fromJSON(e)) : [],
            pagination: (0, $d5e07fe2518aae94$exports.isSet)(object.pagination) ? $5eae5f3cc99e92ab$exports.PageResponse.fromJSON(object.pagination) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        if (message.votes) obj.votes = message.votes.map((e)=>e ? $737f3deb0a132861$exports.Vote.toJSON(e) : undefined);
        else obj.votes = [];
        message.pagination !== undefined && (obj.pagination = message.pagination ? $5eae5f3cc99e92ab$exports.PageResponse.toJSON(message.pagination) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $4feaec90c73c42da$var$createBaseQueryVotesResponse();
        message.votes = object.votes?.map((e)=>$737f3deb0a132861$exports.Vote.fromPartial(e)) || [];
        message.pagination = object.pagination !== undefined && object.pagination !== null ? $5eae5f3cc99e92ab$exports.PageResponse.fromPartial(object.pagination) : undefined;
        return message;
    }
};
function $4feaec90c73c42da$var$createBaseQueryParamsRequest() {
    return {
        paramsType: ""
    };
}
$4feaec90c73c42da$exports.QueryParamsRequest = {
    encode (message, writer = $4feaec90c73c42da$var$_m0.Writer.create()) {
        if (message.paramsType !== "") writer.uint32(10).string(message.paramsType);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $4feaec90c73c42da$var$_m0.Reader ? input : new $4feaec90c73c42da$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $4feaec90c73c42da$var$createBaseQueryParamsRequest();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.paramsType = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            paramsType: (0, $d5e07fe2518aae94$exports.isSet)(object.paramsType) ? String(object.paramsType) : ""
        };
    },
    toJSON (message) {
        const obj = {};
        message.paramsType !== undefined && (obj.paramsType = message.paramsType);
        return obj;
    },
    fromPartial (object) {
        const message = $4feaec90c73c42da$var$createBaseQueryParamsRequest();
        message.paramsType = object.paramsType ?? "";
        return message;
    }
};
function $4feaec90c73c42da$var$createBaseQueryParamsResponse() {
    return {
        votingParams: undefined,
        depositParams: undefined,
        tallyParams: undefined
    };
}
$4feaec90c73c42da$exports.QueryParamsResponse = {
    encode (message, writer = $4feaec90c73c42da$var$_m0.Writer.create()) {
        if (message.votingParams !== undefined) $737f3deb0a132861$exports.VotingParams.encode(message.votingParams, writer.uint32(10).fork()).ldelim();
        if (message.depositParams !== undefined) $737f3deb0a132861$exports.DepositParams.encode(message.depositParams, writer.uint32(18).fork()).ldelim();
        if (message.tallyParams !== undefined) $737f3deb0a132861$exports.TallyParams.encode(message.tallyParams, writer.uint32(26).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $4feaec90c73c42da$var$_m0.Reader ? input : new $4feaec90c73c42da$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $4feaec90c73c42da$var$createBaseQueryParamsResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.votingParams = $737f3deb0a132861$exports.VotingParams.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.depositParams = $737f3deb0a132861$exports.DepositParams.decode(reader, reader.uint32());
                    break;
                case 3:
                    message.tallyParams = $737f3deb0a132861$exports.TallyParams.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            votingParams: (0, $d5e07fe2518aae94$exports.isSet)(object.votingParams) ? $737f3deb0a132861$exports.VotingParams.fromJSON(object.votingParams) : undefined,
            depositParams: (0, $d5e07fe2518aae94$exports.isSet)(object.depositParams) ? $737f3deb0a132861$exports.DepositParams.fromJSON(object.depositParams) : undefined,
            tallyParams: (0, $d5e07fe2518aae94$exports.isSet)(object.tallyParams) ? $737f3deb0a132861$exports.TallyParams.fromJSON(object.tallyParams) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.votingParams !== undefined && (obj.votingParams = message.votingParams ? $737f3deb0a132861$exports.VotingParams.toJSON(message.votingParams) : undefined);
        message.depositParams !== undefined && (obj.depositParams = message.depositParams ? $737f3deb0a132861$exports.DepositParams.toJSON(message.depositParams) : undefined);
        message.tallyParams !== undefined && (obj.tallyParams = message.tallyParams ? $737f3deb0a132861$exports.TallyParams.toJSON(message.tallyParams) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $4feaec90c73c42da$var$createBaseQueryParamsResponse();
        message.votingParams = object.votingParams !== undefined && object.votingParams !== null ? $737f3deb0a132861$exports.VotingParams.fromPartial(object.votingParams) : undefined;
        message.depositParams = object.depositParams !== undefined && object.depositParams !== null ? $737f3deb0a132861$exports.DepositParams.fromPartial(object.depositParams) : undefined;
        message.tallyParams = object.tallyParams !== undefined && object.tallyParams !== null ? $737f3deb0a132861$exports.TallyParams.fromPartial(object.tallyParams) : undefined;
        return message;
    }
};
function $4feaec90c73c42da$var$createBaseQueryDepositRequest() {
    return {
        proposalId: $d5e07fe2518aae94$exports.Long.UZERO,
        depositor: ""
    };
}
$4feaec90c73c42da$exports.QueryDepositRequest = {
    encode (message, writer = $4feaec90c73c42da$var$_m0.Writer.create()) {
        if (!message.proposalId.isZero()) writer.uint32(8).uint64(message.proposalId);
        if (message.depositor !== "") writer.uint32(18).string(message.depositor);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $4feaec90c73c42da$var$_m0.Reader ? input : new $4feaec90c73c42da$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $4feaec90c73c42da$var$createBaseQueryDepositRequest();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.proposalId = reader.uint64();
                    break;
                case 2:
                    message.depositor = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            proposalId: (0, $d5e07fe2518aae94$exports.isSet)(object.proposalId) ? $d5e07fe2518aae94$exports.Long.fromValue(object.proposalId) : $d5e07fe2518aae94$exports.Long.UZERO,
            depositor: (0, $d5e07fe2518aae94$exports.isSet)(object.depositor) ? String(object.depositor) : ""
        };
    },
    toJSON (message) {
        const obj = {};
        message.proposalId !== undefined && (obj.proposalId = (message.proposalId || $d5e07fe2518aae94$exports.Long.UZERO).toString());
        message.depositor !== undefined && (obj.depositor = message.depositor);
        return obj;
    },
    fromPartial (object) {
        const message = $4feaec90c73c42da$var$createBaseQueryDepositRequest();
        message.proposalId = object.proposalId !== undefined && object.proposalId !== null ? $d5e07fe2518aae94$exports.Long.fromValue(object.proposalId) : $d5e07fe2518aae94$exports.Long.UZERO;
        message.depositor = object.depositor ?? "";
        return message;
    }
};
function $4feaec90c73c42da$var$createBaseQueryDepositResponse() {
    return {
        deposit: undefined
    };
}
$4feaec90c73c42da$exports.QueryDepositResponse = {
    encode (message, writer = $4feaec90c73c42da$var$_m0.Writer.create()) {
        if (message.deposit !== undefined) $737f3deb0a132861$exports.Deposit.encode(message.deposit, writer.uint32(10).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $4feaec90c73c42da$var$_m0.Reader ? input : new $4feaec90c73c42da$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $4feaec90c73c42da$var$createBaseQueryDepositResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.deposit = $737f3deb0a132861$exports.Deposit.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            deposit: (0, $d5e07fe2518aae94$exports.isSet)(object.deposit) ? $737f3deb0a132861$exports.Deposit.fromJSON(object.deposit) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.deposit !== undefined && (obj.deposit = message.deposit ? $737f3deb0a132861$exports.Deposit.toJSON(message.deposit) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $4feaec90c73c42da$var$createBaseQueryDepositResponse();
        message.deposit = object.deposit !== undefined && object.deposit !== null ? $737f3deb0a132861$exports.Deposit.fromPartial(object.deposit) : undefined;
        return message;
    }
};
function $4feaec90c73c42da$var$createBaseQueryDepositsRequest() {
    return {
        proposalId: $d5e07fe2518aae94$exports.Long.UZERO,
        pagination: undefined
    };
}
$4feaec90c73c42da$exports.QueryDepositsRequest = {
    encode (message, writer = $4feaec90c73c42da$var$_m0.Writer.create()) {
        if (!message.proposalId.isZero()) writer.uint32(8).uint64(message.proposalId);
        if (message.pagination !== undefined) $5eae5f3cc99e92ab$exports.PageRequest.encode(message.pagination, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $4feaec90c73c42da$var$_m0.Reader ? input : new $4feaec90c73c42da$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $4feaec90c73c42da$var$createBaseQueryDepositsRequest();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.proposalId = reader.uint64();
                    break;
                case 2:
                    message.pagination = $5eae5f3cc99e92ab$exports.PageRequest.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            proposalId: (0, $d5e07fe2518aae94$exports.isSet)(object.proposalId) ? $d5e07fe2518aae94$exports.Long.fromValue(object.proposalId) : $d5e07fe2518aae94$exports.Long.UZERO,
            pagination: (0, $d5e07fe2518aae94$exports.isSet)(object.pagination) ? $5eae5f3cc99e92ab$exports.PageRequest.fromJSON(object.pagination) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.proposalId !== undefined && (obj.proposalId = (message.proposalId || $d5e07fe2518aae94$exports.Long.UZERO).toString());
        message.pagination !== undefined && (obj.pagination = message.pagination ? $5eae5f3cc99e92ab$exports.PageRequest.toJSON(message.pagination) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $4feaec90c73c42da$var$createBaseQueryDepositsRequest();
        message.proposalId = object.proposalId !== undefined && object.proposalId !== null ? $d5e07fe2518aae94$exports.Long.fromValue(object.proposalId) : $d5e07fe2518aae94$exports.Long.UZERO;
        message.pagination = object.pagination !== undefined && object.pagination !== null ? $5eae5f3cc99e92ab$exports.PageRequest.fromPartial(object.pagination) : undefined;
        return message;
    }
};
function $4feaec90c73c42da$var$createBaseQueryDepositsResponse() {
    return {
        deposits: [],
        pagination: undefined
    };
}
$4feaec90c73c42da$exports.QueryDepositsResponse = {
    encode (message, writer = $4feaec90c73c42da$var$_m0.Writer.create()) {
        for (const v of message.deposits)$737f3deb0a132861$exports.Deposit.encode(v, writer.uint32(10).fork()).ldelim();
        if (message.pagination !== undefined) $5eae5f3cc99e92ab$exports.PageResponse.encode(message.pagination, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $4feaec90c73c42da$var$_m0.Reader ? input : new $4feaec90c73c42da$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $4feaec90c73c42da$var$createBaseQueryDepositsResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.deposits.push($737f3deb0a132861$exports.Deposit.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.pagination = $5eae5f3cc99e92ab$exports.PageResponse.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            deposits: Array.isArray(object?.deposits) ? object.deposits.map((e)=>$737f3deb0a132861$exports.Deposit.fromJSON(e)) : [],
            pagination: (0, $d5e07fe2518aae94$exports.isSet)(object.pagination) ? $5eae5f3cc99e92ab$exports.PageResponse.fromJSON(object.pagination) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        if (message.deposits) obj.deposits = message.deposits.map((e)=>e ? $737f3deb0a132861$exports.Deposit.toJSON(e) : undefined);
        else obj.deposits = [];
        message.pagination !== undefined && (obj.pagination = message.pagination ? $5eae5f3cc99e92ab$exports.PageResponse.toJSON(message.pagination) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $4feaec90c73c42da$var$createBaseQueryDepositsResponse();
        message.deposits = object.deposits?.map((e)=>$737f3deb0a132861$exports.Deposit.fromPartial(e)) || [];
        message.pagination = object.pagination !== undefined && object.pagination !== null ? $5eae5f3cc99e92ab$exports.PageResponse.fromPartial(object.pagination) : undefined;
        return message;
    }
};
function $4feaec90c73c42da$var$createBaseQueryTallyResultRequest() {
    return {
        proposalId: $d5e07fe2518aae94$exports.Long.UZERO
    };
}
$4feaec90c73c42da$exports.QueryTallyResultRequest = {
    encode (message, writer = $4feaec90c73c42da$var$_m0.Writer.create()) {
        if (!message.proposalId.isZero()) writer.uint32(8).uint64(message.proposalId);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $4feaec90c73c42da$var$_m0.Reader ? input : new $4feaec90c73c42da$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $4feaec90c73c42da$var$createBaseQueryTallyResultRequest();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.proposalId = reader.uint64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            proposalId: (0, $d5e07fe2518aae94$exports.isSet)(object.proposalId) ? $d5e07fe2518aae94$exports.Long.fromValue(object.proposalId) : $d5e07fe2518aae94$exports.Long.UZERO
        };
    },
    toJSON (message) {
        const obj = {};
        message.proposalId !== undefined && (obj.proposalId = (message.proposalId || $d5e07fe2518aae94$exports.Long.UZERO).toString());
        return obj;
    },
    fromPartial (object) {
        const message = $4feaec90c73c42da$var$createBaseQueryTallyResultRequest();
        message.proposalId = object.proposalId !== undefined && object.proposalId !== null ? $d5e07fe2518aae94$exports.Long.fromValue(object.proposalId) : $d5e07fe2518aae94$exports.Long.UZERO;
        return message;
    }
};
function $4feaec90c73c42da$var$createBaseQueryTallyResultResponse() {
    return {
        tally: undefined
    };
}
$4feaec90c73c42da$exports.QueryTallyResultResponse = {
    encode (message, writer = $4feaec90c73c42da$var$_m0.Writer.create()) {
        if (message.tally !== undefined) $737f3deb0a132861$exports.TallyResult.encode(message.tally, writer.uint32(10).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $4feaec90c73c42da$var$_m0.Reader ? input : new $4feaec90c73c42da$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $4feaec90c73c42da$var$createBaseQueryTallyResultResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.tally = $737f3deb0a132861$exports.TallyResult.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            tally: (0, $d5e07fe2518aae94$exports.isSet)(object.tally) ? $737f3deb0a132861$exports.TallyResult.fromJSON(object.tally) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.tally !== undefined && (obj.tally = message.tally ? $737f3deb0a132861$exports.TallyResult.toJSON(message.tally) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $4feaec90c73c42da$var$createBaseQueryTallyResultResponse();
        message.tally = object.tally !== undefined && object.tally !== null ? $737f3deb0a132861$exports.TallyResult.fromPartial(object.tally) : undefined;
        return message;
    }
};
class $4feaec90c73c42da$var$QueryClientImpl {
    constructor(rpc){
        this.rpc = rpc;
        this.Proposal = this.Proposal.bind(this);
        this.Proposals = this.Proposals.bind(this);
        this.Vote = this.Vote.bind(this);
        this.Votes = this.Votes.bind(this);
        this.Params = this.Params.bind(this);
        this.Deposit = this.Deposit.bind(this);
        this.Deposits = this.Deposits.bind(this);
        this.TallyResult = this.TallyResult.bind(this);
    }
    Proposal(request) {
        const data = $4feaec90c73c42da$exports.QueryProposalRequest.encode(request).finish();
        const promise = this.rpc.request("cosmos.gov.v1beta1.Query", "Proposal", data);
        return promise.then((data)=>$4feaec90c73c42da$exports.QueryProposalResponse.decode(new $4feaec90c73c42da$var$_m0.Reader(data)));
    }
    Proposals(request) {
        const data = $4feaec90c73c42da$exports.QueryProposalsRequest.encode(request).finish();
        const promise = this.rpc.request("cosmos.gov.v1beta1.Query", "Proposals", data);
        return promise.then((data)=>$4feaec90c73c42da$exports.QueryProposalsResponse.decode(new $4feaec90c73c42da$var$_m0.Reader(data)));
    }
    Vote(request) {
        const data = $4feaec90c73c42da$exports.QueryVoteRequest.encode(request).finish();
        const promise = this.rpc.request("cosmos.gov.v1beta1.Query", "Vote", data);
        return promise.then((data)=>$4feaec90c73c42da$exports.QueryVoteResponse.decode(new $4feaec90c73c42da$var$_m0.Reader(data)));
    }
    Votes(request) {
        const data = $4feaec90c73c42da$exports.QueryVotesRequest.encode(request).finish();
        const promise = this.rpc.request("cosmos.gov.v1beta1.Query", "Votes", data);
        return promise.then((data)=>$4feaec90c73c42da$exports.QueryVotesResponse.decode(new $4feaec90c73c42da$var$_m0.Reader(data)));
    }
    Params(request) {
        const data = $4feaec90c73c42da$exports.QueryParamsRequest.encode(request).finish();
        const promise = this.rpc.request("cosmos.gov.v1beta1.Query", "Params", data);
        return promise.then((data)=>$4feaec90c73c42da$exports.QueryParamsResponse.decode(new $4feaec90c73c42da$var$_m0.Reader(data)));
    }
    Deposit(request) {
        const data = $4feaec90c73c42da$exports.QueryDepositRequest.encode(request).finish();
        const promise = this.rpc.request("cosmos.gov.v1beta1.Query", "Deposit", data);
        return promise.then((data)=>$4feaec90c73c42da$exports.QueryDepositResponse.decode(new $4feaec90c73c42da$var$_m0.Reader(data)));
    }
    Deposits(request) {
        const data = $4feaec90c73c42da$exports.QueryDepositsRequest.encode(request).finish();
        const promise = this.rpc.request("cosmos.gov.v1beta1.Query", "Deposits", data);
        return promise.then((data)=>$4feaec90c73c42da$exports.QueryDepositsResponse.decode(new $4feaec90c73c42da$var$_m0.Reader(data)));
    }
    TallyResult(request) {
        const data = $4feaec90c73c42da$exports.QueryTallyResultRequest.encode(request).finish();
        const promise = this.rpc.request("cosmos.gov.v1beta1.Query", "TallyResult", data);
        return promise.then((data)=>$4feaec90c73c42da$exports.QueryTallyResultResponse.decode(new $4feaec90c73c42da$var$_m0.Reader(data)));
    }
}
$4feaec90c73c42da$exports.QueryClientImpl = $4feaec90c73c42da$var$QueryClientImpl;



function $f6b416da756e1924$var$setupGovExtension(base) {
    const rpc = (0, $a3959936d2cce854$exports.createProtobufRpcClient)(base);
    // Use this service to get easy typed access to query methods
    // This cannot be used for proof verification
    const queryService = new $4feaec90c73c42da$exports.QueryClientImpl(rpc);
    return {
        gov: {
            params: async (parametersType)=>{
                const response = await queryService.Params({
                    paramsType: parametersType
                });
                return response;
            },
            proposals: async (proposalStatus, depositorAddress, voterAddress, paginationKey)=>{
                const response = await queryService.Proposals({
                    proposalStatus: proposalStatus,
                    depositor: depositorAddress,
                    voter: voterAddress,
                    pagination: (0, $a3959936d2cce854$exports.createPagination)(paginationKey)
                });
                return response;
            },
            proposal: async (proposalId)=>{
                const response = await queryService.Proposal({
                    proposalId: (0, $a3959936d2cce854$exports.longify)(proposalId)
                });
                return response;
            },
            deposits: async (proposalId, paginationKey)=>{
                const response = await queryService.Deposits({
                    proposalId: (0, $a3959936d2cce854$exports.longify)(proposalId),
                    pagination: (0, $a3959936d2cce854$exports.createPagination)(paginationKey)
                });
                return response;
            },
            deposit: async (proposalId, depositorAddress)=>{
                const response = await queryService.Deposit({
                    proposalId: (0, $a3959936d2cce854$exports.longify)(proposalId),
                    depositor: depositorAddress
                });
                return response;
            },
            tally: async (proposalId)=>{
                const response = await queryService.TallyResult({
                    proposalId: (0, $a3959936d2cce854$exports.longify)(proposalId)
                });
                return response;
            },
            votes: async (proposalId, paginationKey)=>{
                const response = await queryService.Votes({
                    proposalId: (0, $a3959936d2cce854$exports.longify)(proposalId),
                    pagination: (0, $a3959936d2cce854$exports.createPagination)(paginationKey)
                });
                return response;
            },
            vote: async (proposalId, voterAddress)=>{
                const response = await queryService.Vote({
                    proposalId: (0, $a3959936d2cce854$exports.longify)(proposalId),
                    voter: voterAddress
                });
                return response;
            }
        }
    };
}
$f6b416da756e1924$exports.setupGovExtension = $f6b416da756e1924$var$setupGovExtension;


Object.defineProperty($d0d8b6f4712acd9f$exports, "setupGovExtension", {
    enumerable: true,
    get: function() {
        return $f6b416da756e1924$exports.setupGovExtension;
    }
});
var $7988bc2fa57dbfeb$exports = {};
"use strict";
Object.defineProperty($7988bc2fa57dbfeb$exports, "__esModule", {
    value: true
});
$7988bc2fa57dbfeb$exports.createGroupAminoConverters = void 0;
function $7988bc2fa57dbfeb$var$createGroupAminoConverters() {
    // Missing, see https://github.com/cosmos/cosmjs/issues/1441
    return {};
}
$7988bc2fa57dbfeb$exports.createGroupAminoConverters = $7988bc2fa57dbfeb$var$createGroupAminoConverters;


Object.defineProperty($d0d8b6f4712acd9f$exports, "createGroupAminoConverters", {
    enumerable: true,
    get: function() {
        return $7988bc2fa57dbfeb$exports.createGroupAminoConverters;
    }
});
var $c6fd43db5b1c9915$exports = {};
"use strict";
Object.defineProperty($c6fd43db5b1c9915$exports, "__esModule", {
    value: true
});
$c6fd43db5b1c9915$exports.groupTypes = void 0;
var $18c75608456c13f7$exports = {};
"use strict";
var $18c75608456c13f7$var$__createBinding = $18c75608456c13f7$exports && $18c75608456c13f7$exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $18c75608456c13f7$var$__setModuleDefault = $18c75608456c13f7$exports && $18c75608456c13f7$exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $18c75608456c13f7$var$__importStar = $18c75608456c13f7$exports && $18c75608456c13f7$exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $18c75608456c13f7$var$__createBinding(result, mod, k);
    }
    $18c75608456c13f7$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty($18c75608456c13f7$exports, "__esModule", {
    value: true
});
$18c75608456c13f7$exports.MsgClientImpl = $18c75608456c13f7$exports.MsgLeaveGroupResponse = $18c75608456c13f7$exports.MsgLeaveGroup = $18c75608456c13f7$exports.MsgExecResponse = $18c75608456c13f7$exports.MsgExec = $18c75608456c13f7$exports.MsgVoteResponse = $18c75608456c13f7$exports.MsgVote = $18c75608456c13f7$exports.MsgWithdrawProposalResponse = $18c75608456c13f7$exports.MsgWithdrawProposal = $18c75608456c13f7$exports.MsgSubmitProposalResponse = $18c75608456c13f7$exports.MsgSubmitProposal = $18c75608456c13f7$exports.MsgUpdateGroupPolicyMetadataResponse = $18c75608456c13f7$exports.MsgUpdateGroupPolicyMetadata = $18c75608456c13f7$exports.MsgUpdateGroupPolicyDecisionPolicyResponse = $18c75608456c13f7$exports.MsgUpdateGroupPolicyDecisionPolicy = $18c75608456c13f7$exports.MsgCreateGroupWithPolicyResponse = $18c75608456c13f7$exports.MsgCreateGroupWithPolicy = $18c75608456c13f7$exports.MsgUpdateGroupPolicyAdminResponse = $18c75608456c13f7$exports.MsgUpdateGroupPolicyAdmin = $18c75608456c13f7$exports.MsgCreateGroupPolicyResponse = $18c75608456c13f7$exports.MsgCreateGroupPolicy = $18c75608456c13f7$exports.MsgUpdateGroupMetadataResponse = $18c75608456c13f7$exports.MsgUpdateGroupMetadata = $18c75608456c13f7$exports.MsgUpdateGroupAdminResponse = $18c75608456c13f7$exports.MsgUpdateGroupAdmin = $18c75608456c13f7$exports.MsgUpdateGroupMembersResponse = $18c75608456c13f7$exports.MsgUpdateGroupMembers = $18c75608456c13f7$exports.MsgCreateGroupResponse = $18c75608456c13f7$exports.MsgCreateGroup = $18c75608456c13f7$exports.execToJSON = $18c75608456c13f7$exports.execFromJSON = $18c75608456c13f7$exports.Exec = $18c75608456c13f7$exports.protobufPackage = void 0;
var $911d924dc11f762c$exports = {};
"use strict";
var $911d924dc11f762c$var$__createBinding = $911d924dc11f762c$exports && $911d924dc11f762c$exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $911d924dc11f762c$var$__setModuleDefault = $911d924dc11f762c$exports && $911d924dc11f762c$exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $911d924dc11f762c$var$__importStar = $911d924dc11f762c$exports && $911d924dc11f762c$exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $911d924dc11f762c$var$__createBinding(result, mod, k);
    }
    $911d924dc11f762c$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty($911d924dc11f762c$exports, "__esModule", {
    value: true
});
$911d924dc11f762c$exports.Vote = $911d924dc11f762c$exports.TallyResult = $911d924dc11f762c$exports.Proposal = $911d924dc11f762c$exports.GroupPolicyInfo = $911d924dc11f762c$exports.GroupMember = $911d924dc11f762c$exports.GroupInfo = $911d924dc11f762c$exports.DecisionPolicyWindows = $911d924dc11f762c$exports.PercentageDecisionPolicy = $911d924dc11f762c$exports.ThresholdDecisionPolicy = $911d924dc11f762c$exports.MemberRequest = $911d924dc11f762c$exports.Member = $911d924dc11f762c$exports.proposalExecutorResultToJSON = $911d924dc11f762c$exports.proposalExecutorResultFromJSON = $911d924dc11f762c$exports.ProposalExecutorResult = $911d924dc11f762c$exports.proposalStatusToJSON = $911d924dc11f762c$exports.proposalStatusFromJSON = $911d924dc11f762c$exports.ProposalStatus = $911d924dc11f762c$exports.voteOptionToJSON = $911d924dc11f762c$exports.voteOptionFromJSON = $911d924dc11f762c$exports.VoteOption = $911d924dc11f762c$exports.protobufPackage = void 0;





const $911d924dc11f762c$var$_m0 = $911d924dc11f762c$var$__importStar((parcelRequire("fQBv0")));
$911d924dc11f762c$exports.protobufPackage = "cosmos.group.v1";
/** VoteOption enumerates the valid vote options for a given proposal. */ var $911d924dc11f762c$var$VoteOption;
(function(VoteOption) {
    /**
     * VOTE_OPTION_UNSPECIFIED - VOTE_OPTION_UNSPECIFIED defines an unspecified vote option which will
     * return an error.
     */ VoteOption[VoteOption["VOTE_OPTION_UNSPECIFIED"] = 0] = "VOTE_OPTION_UNSPECIFIED";
    /** VOTE_OPTION_YES - VOTE_OPTION_YES defines a yes vote option. */ VoteOption[VoteOption["VOTE_OPTION_YES"] = 1] = "VOTE_OPTION_YES";
    /** VOTE_OPTION_ABSTAIN - VOTE_OPTION_ABSTAIN defines an abstain vote option. */ VoteOption[VoteOption["VOTE_OPTION_ABSTAIN"] = 2] = "VOTE_OPTION_ABSTAIN";
    /** VOTE_OPTION_NO - VOTE_OPTION_NO defines a no vote option. */ VoteOption[VoteOption["VOTE_OPTION_NO"] = 3] = "VOTE_OPTION_NO";
    /** VOTE_OPTION_NO_WITH_VETO - VOTE_OPTION_NO_WITH_VETO defines a no with veto vote option. */ VoteOption[VoteOption["VOTE_OPTION_NO_WITH_VETO"] = 4] = "VOTE_OPTION_NO_WITH_VETO";
    VoteOption[VoteOption["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})($911d924dc11f762c$var$VoteOption = $911d924dc11f762c$exports.VoteOption || ($911d924dc11f762c$exports.VoteOption = {}));
function $911d924dc11f762c$var$voteOptionFromJSON(object) {
    switch(object){
        case 0:
        case "VOTE_OPTION_UNSPECIFIED":
            return $911d924dc11f762c$var$VoteOption.VOTE_OPTION_UNSPECIFIED;
        case 1:
        case "VOTE_OPTION_YES":
            return $911d924dc11f762c$var$VoteOption.VOTE_OPTION_YES;
        case 2:
        case "VOTE_OPTION_ABSTAIN":
            return $911d924dc11f762c$var$VoteOption.VOTE_OPTION_ABSTAIN;
        case 3:
        case "VOTE_OPTION_NO":
            return $911d924dc11f762c$var$VoteOption.VOTE_OPTION_NO;
        case 4:
        case "VOTE_OPTION_NO_WITH_VETO":
            return $911d924dc11f762c$var$VoteOption.VOTE_OPTION_NO_WITH_VETO;
        case -1:
        case "UNRECOGNIZED":
        default:
            return $911d924dc11f762c$var$VoteOption.UNRECOGNIZED;
    }
}
$911d924dc11f762c$exports.voteOptionFromJSON = $911d924dc11f762c$var$voteOptionFromJSON;
function $911d924dc11f762c$var$voteOptionToJSON(object) {
    switch(object){
        case $911d924dc11f762c$var$VoteOption.VOTE_OPTION_UNSPECIFIED:
            return "VOTE_OPTION_UNSPECIFIED";
        case $911d924dc11f762c$var$VoteOption.VOTE_OPTION_YES:
            return "VOTE_OPTION_YES";
        case $911d924dc11f762c$var$VoteOption.VOTE_OPTION_ABSTAIN:
            return "VOTE_OPTION_ABSTAIN";
        case $911d924dc11f762c$var$VoteOption.VOTE_OPTION_NO:
            return "VOTE_OPTION_NO";
        case $911d924dc11f762c$var$VoteOption.VOTE_OPTION_NO_WITH_VETO:
            return "VOTE_OPTION_NO_WITH_VETO";
        case $911d924dc11f762c$var$VoteOption.UNRECOGNIZED:
        default:
            return "UNRECOGNIZED";
    }
}
$911d924dc11f762c$exports.voteOptionToJSON = $911d924dc11f762c$var$voteOptionToJSON;
/** ProposalStatus defines proposal statuses. */ var $911d924dc11f762c$var$ProposalStatus;
(function(ProposalStatus) {
    /** PROPOSAL_STATUS_UNSPECIFIED - An empty value is invalid and not allowed. */ ProposalStatus[ProposalStatus["PROPOSAL_STATUS_UNSPECIFIED"] = 0] = "PROPOSAL_STATUS_UNSPECIFIED";
    /** PROPOSAL_STATUS_SUBMITTED - Initial status of a proposal when submitted. */ ProposalStatus[ProposalStatus["PROPOSAL_STATUS_SUBMITTED"] = 1] = "PROPOSAL_STATUS_SUBMITTED";
    /**
     * PROPOSAL_STATUS_ACCEPTED - Final status of a proposal when the final tally is done and the outcome
     * passes the group policy's decision policy.
     */ ProposalStatus[ProposalStatus["PROPOSAL_STATUS_ACCEPTED"] = 2] = "PROPOSAL_STATUS_ACCEPTED";
    /**
     * PROPOSAL_STATUS_REJECTED - Final status of a proposal when the final tally is done and the outcome
     * is rejected by the group policy's decision policy.
     */ ProposalStatus[ProposalStatus["PROPOSAL_STATUS_REJECTED"] = 3] = "PROPOSAL_STATUS_REJECTED";
    /**
     * PROPOSAL_STATUS_ABORTED - Final status of a proposal when the group policy is modified before the
     * final tally.
     */ ProposalStatus[ProposalStatus["PROPOSAL_STATUS_ABORTED"] = 4] = "PROPOSAL_STATUS_ABORTED";
    /**
     * PROPOSAL_STATUS_WITHDRAWN - A proposal can be withdrawn before the voting start time by the owner.
     * When this happens the final status is Withdrawn.
     */ ProposalStatus[ProposalStatus["PROPOSAL_STATUS_WITHDRAWN"] = 5] = "PROPOSAL_STATUS_WITHDRAWN";
    ProposalStatus[ProposalStatus["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})($911d924dc11f762c$var$ProposalStatus = $911d924dc11f762c$exports.ProposalStatus || ($911d924dc11f762c$exports.ProposalStatus = {}));
function $911d924dc11f762c$var$proposalStatusFromJSON(object) {
    switch(object){
        case 0:
        case "PROPOSAL_STATUS_UNSPECIFIED":
            return $911d924dc11f762c$var$ProposalStatus.PROPOSAL_STATUS_UNSPECIFIED;
        case 1:
        case "PROPOSAL_STATUS_SUBMITTED":
            return $911d924dc11f762c$var$ProposalStatus.PROPOSAL_STATUS_SUBMITTED;
        case 2:
        case "PROPOSAL_STATUS_ACCEPTED":
            return $911d924dc11f762c$var$ProposalStatus.PROPOSAL_STATUS_ACCEPTED;
        case 3:
        case "PROPOSAL_STATUS_REJECTED":
            return $911d924dc11f762c$var$ProposalStatus.PROPOSAL_STATUS_REJECTED;
        case 4:
        case "PROPOSAL_STATUS_ABORTED":
            return $911d924dc11f762c$var$ProposalStatus.PROPOSAL_STATUS_ABORTED;
        case 5:
        case "PROPOSAL_STATUS_WITHDRAWN":
            return $911d924dc11f762c$var$ProposalStatus.PROPOSAL_STATUS_WITHDRAWN;
        case -1:
        case "UNRECOGNIZED":
        default:
            return $911d924dc11f762c$var$ProposalStatus.UNRECOGNIZED;
    }
}
$911d924dc11f762c$exports.proposalStatusFromJSON = $911d924dc11f762c$var$proposalStatusFromJSON;
function $911d924dc11f762c$var$proposalStatusToJSON(object) {
    switch(object){
        case $911d924dc11f762c$var$ProposalStatus.PROPOSAL_STATUS_UNSPECIFIED:
            return "PROPOSAL_STATUS_UNSPECIFIED";
        case $911d924dc11f762c$var$ProposalStatus.PROPOSAL_STATUS_SUBMITTED:
            return "PROPOSAL_STATUS_SUBMITTED";
        case $911d924dc11f762c$var$ProposalStatus.PROPOSAL_STATUS_ACCEPTED:
            return "PROPOSAL_STATUS_ACCEPTED";
        case $911d924dc11f762c$var$ProposalStatus.PROPOSAL_STATUS_REJECTED:
            return "PROPOSAL_STATUS_REJECTED";
        case $911d924dc11f762c$var$ProposalStatus.PROPOSAL_STATUS_ABORTED:
            return "PROPOSAL_STATUS_ABORTED";
        case $911d924dc11f762c$var$ProposalStatus.PROPOSAL_STATUS_WITHDRAWN:
            return "PROPOSAL_STATUS_WITHDRAWN";
        case $911d924dc11f762c$var$ProposalStatus.UNRECOGNIZED:
        default:
            return "UNRECOGNIZED";
    }
}
$911d924dc11f762c$exports.proposalStatusToJSON = $911d924dc11f762c$var$proposalStatusToJSON;
/** ProposalExecutorResult defines types of proposal executor results. */ var $911d924dc11f762c$var$ProposalExecutorResult;
(function(ProposalExecutorResult) {
    /** PROPOSAL_EXECUTOR_RESULT_UNSPECIFIED - An empty value is not allowed. */ ProposalExecutorResult[ProposalExecutorResult["PROPOSAL_EXECUTOR_RESULT_UNSPECIFIED"] = 0] = "PROPOSAL_EXECUTOR_RESULT_UNSPECIFIED";
    /** PROPOSAL_EXECUTOR_RESULT_NOT_RUN - We have not yet run the executor. */ ProposalExecutorResult[ProposalExecutorResult["PROPOSAL_EXECUTOR_RESULT_NOT_RUN"] = 1] = "PROPOSAL_EXECUTOR_RESULT_NOT_RUN";
    /** PROPOSAL_EXECUTOR_RESULT_SUCCESS - The executor was successful and proposed action updated state. */ ProposalExecutorResult[ProposalExecutorResult["PROPOSAL_EXECUTOR_RESULT_SUCCESS"] = 2] = "PROPOSAL_EXECUTOR_RESULT_SUCCESS";
    /** PROPOSAL_EXECUTOR_RESULT_FAILURE - The executor returned an error and proposed action didn't update state. */ ProposalExecutorResult[ProposalExecutorResult["PROPOSAL_EXECUTOR_RESULT_FAILURE"] = 3] = "PROPOSAL_EXECUTOR_RESULT_FAILURE";
    ProposalExecutorResult[ProposalExecutorResult["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})($911d924dc11f762c$var$ProposalExecutorResult = $911d924dc11f762c$exports.ProposalExecutorResult || ($911d924dc11f762c$exports.ProposalExecutorResult = {}));
function $911d924dc11f762c$var$proposalExecutorResultFromJSON(object) {
    switch(object){
        case 0:
        case "PROPOSAL_EXECUTOR_RESULT_UNSPECIFIED":
            return $911d924dc11f762c$var$ProposalExecutorResult.PROPOSAL_EXECUTOR_RESULT_UNSPECIFIED;
        case 1:
        case "PROPOSAL_EXECUTOR_RESULT_NOT_RUN":
            return $911d924dc11f762c$var$ProposalExecutorResult.PROPOSAL_EXECUTOR_RESULT_NOT_RUN;
        case 2:
        case "PROPOSAL_EXECUTOR_RESULT_SUCCESS":
            return $911d924dc11f762c$var$ProposalExecutorResult.PROPOSAL_EXECUTOR_RESULT_SUCCESS;
        case 3:
        case "PROPOSAL_EXECUTOR_RESULT_FAILURE":
            return $911d924dc11f762c$var$ProposalExecutorResult.PROPOSAL_EXECUTOR_RESULT_FAILURE;
        case -1:
        case "UNRECOGNIZED":
        default:
            return $911d924dc11f762c$var$ProposalExecutorResult.UNRECOGNIZED;
    }
}
$911d924dc11f762c$exports.proposalExecutorResultFromJSON = $911d924dc11f762c$var$proposalExecutorResultFromJSON;
function $911d924dc11f762c$var$proposalExecutorResultToJSON(object) {
    switch(object){
        case $911d924dc11f762c$var$ProposalExecutorResult.PROPOSAL_EXECUTOR_RESULT_UNSPECIFIED:
            return "PROPOSAL_EXECUTOR_RESULT_UNSPECIFIED";
        case $911d924dc11f762c$var$ProposalExecutorResult.PROPOSAL_EXECUTOR_RESULT_NOT_RUN:
            return "PROPOSAL_EXECUTOR_RESULT_NOT_RUN";
        case $911d924dc11f762c$var$ProposalExecutorResult.PROPOSAL_EXECUTOR_RESULT_SUCCESS:
            return "PROPOSAL_EXECUTOR_RESULT_SUCCESS";
        case $911d924dc11f762c$var$ProposalExecutorResult.PROPOSAL_EXECUTOR_RESULT_FAILURE:
            return "PROPOSAL_EXECUTOR_RESULT_FAILURE";
        case $911d924dc11f762c$var$ProposalExecutorResult.UNRECOGNIZED:
        default:
            return "UNRECOGNIZED";
    }
}
$911d924dc11f762c$exports.proposalExecutorResultToJSON = $911d924dc11f762c$var$proposalExecutorResultToJSON;
function $911d924dc11f762c$var$createBaseMember() {
    return {
        address: "",
        weight: "",
        metadata: "",
        addedAt: undefined
    };
}
$911d924dc11f762c$exports.Member = {
    encode (message, writer = $911d924dc11f762c$var$_m0.Writer.create()) {
        if (message.address !== "") writer.uint32(10).string(message.address);
        if (message.weight !== "") writer.uint32(18).string(message.weight);
        if (message.metadata !== "") writer.uint32(26).string(message.metadata);
        if (message.addedAt !== undefined) $e7eaeedc85b414fc$exports.Timestamp.encode(message.addedAt, writer.uint32(34).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $911d924dc11f762c$var$_m0.Reader ? input : new $911d924dc11f762c$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $911d924dc11f762c$var$createBaseMember();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.address = reader.string();
                    break;
                case 2:
                    message.weight = reader.string();
                    break;
                case 3:
                    message.metadata = reader.string();
                    break;
                case 4:
                    message.addedAt = $e7eaeedc85b414fc$exports.Timestamp.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            address: (0, $d5e07fe2518aae94$exports.isSet)(object.address) ? String(object.address) : "",
            weight: (0, $d5e07fe2518aae94$exports.isSet)(object.weight) ? String(object.weight) : "",
            metadata: (0, $d5e07fe2518aae94$exports.isSet)(object.metadata) ? String(object.metadata) : "",
            addedAt: (0, $d5e07fe2518aae94$exports.isSet)(object.addedAt) ? (0, $d5e07fe2518aae94$exports.fromJsonTimestamp)(object.addedAt) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.address !== undefined && (obj.address = message.address);
        message.weight !== undefined && (obj.weight = message.weight);
        message.metadata !== undefined && (obj.metadata = message.metadata);
        message.addedAt !== undefined && (obj.addedAt = (0, $d5e07fe2518aae94$exports.fromTimestamp)(message.addedAt).toISOString());
        return obj;
    },
    fromPartial (object) {
        const message = $911d924dc11f762c$var$createBaseMember();
        message.address = object.address ?? "";
        message.weight = object.weight ?? "";
        message.metadata = object.metadata ?? "";
        message.addedAt = object.addedAt !== undefined && object.addedAt !== null ? $e7eaeedc85b414fc$exports.Timestamp.fromPartial(object.addedAt) : undefined;
        return message;
    }
};
function $911d924dc11f762c$var$createBaseMemberRequest() {
    return {
        address: "",
        weight: "",
        metadata: ""
    };
}
$911d924dc11f762c$exports.MemberRequest = {
    encode (message, writer = $911d924dc11f762c$var$_m0.Writer.create()) {
        if (message.address !== "") writer.uint32(10).string(message.address);
        if (message.weight !== "") writer.uint32(18).string(message.weight);
        if (message.metadata !== "") writer.uint32(26).string(message.metadata);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $911d924dc11f762c$var$_m0.Reader ? input : new $911d924dc11f762c$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $911d924dc11f762c$var$createBaseMemberRequest();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.address = reader.string();
                    break;
                case 2:
                    message.weight = reader.string();
                    break;
                case 3:
                    message.metadata = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            address: (0, $d5e07fe2518aae94$exports.isSet)(object.address) ? String(object.address) : "",
            weight: (0, $d5e07fe2518aae94$exports.isSet)(object.weight) ? String(object.weight) : "",
            metadata: (0, $d5e07fe2518aae94$exports.isSet)(object.metadata) ? String(object.metadata) : ""
        };
    },
    toJSON (message) {
        const obj = {};
        message.address !== undefined && (obj.address = message.address);
        message.weight !== undefined && (obj.weight = message.weight);
        message.metadata !== undefined && (obj.metadata = message.metadata);
        return obj;
    },
    fromPartial (object) {
        const message = $911d924dc11f762c$var$createBaseMemberRequest();
        message.address = object.address ?? "";
        message.weight = object.weight ?? "";
        message.metadata = object.metadata ?? "";
        return message;
    }
};
function $911d924dc11f762c$var$createBaseThresholdDecisionPolicy() {
    return {
        threshold: "",
        windows: undefined
    };
}
$911d924dc11f762c$exports.ThresholdDecisionPolicy = {
    encode (message, writer = $911d924dc11f762c$var$_m0.Writer.create()) {
        if (message.threshold !== "") writer.uint32(10).string(message.threshold);
        if (message.windows !== undefined) $911d924dc11f762c$exports.DecisionPolicyWindows.encode(message.windows, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $911d924dc11f762c$var$_m0.Reader ? input : new $911d924dc11f762c$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $911d924dc11f762c$var$createBaseThresholdDecisionPolicy();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.threshold = reader.string();
                    break;
                case 2:
                    message.windows = $911d924dc11f762c$exports.DecisionPolicyWindows.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            threshold: (0, $d5e07fe2518aae94$exports.isSet)(object.threshold) ? String(object.threshold) : "",
            windows: (0, $d5e07fe2518aae94$exports.isSet)(object.windows) ? $911d924dc11f762c$exports.DecisionPolicyWindows.fromJSON(object.windows) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.threshold !== undefined && (obj.threshold = message.threshold);
        message.windows !== undefined && (obj.windows = message.windows ? $911d924dc11f762c$exports.DecisionPolicyWindows.toJSON(message.windows) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $911d924dc11f762c$var$createBaseThresholdDecisionPolicy();
        message.threshold = object.threshold ?? "";
        message.windows = object.windows !== undefined && object.windows !== null ? $911d924dc11f762c$exports.DecisionPolicyWindows.fromPartial(object.windows) : undefined;
        return message;
    }
};
function $911d924dc11f762c$var$createBasePercentageDecisionPolicy() {
    return {
        percentage: "",
        windows: undefined
    };
}
$911d924dc11f762c$exports.PercentageDecisionPolicy = {
    encode (message, writer = $911d924dc11f762c$var$_m0.Writer.create()) {
        if (message.percentage !== "") writer.uint32(10).string(message.percentage);
        if (message.windows !== undefined) $911d924dc11f762c$exports.DecisionPolicyWindows.encode(message.windows, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $911d924dc11f762c$var$_m0.Reader ? input : new $911d924dc11f762c$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $911d924dc11f762c$var$createBasePercentageDecisionPolicy();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.percentage = reader.string();
                    break;
                case 2:
                    message.windows = $911d924dc11f762c$exports.DecisionPolicyWindows.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            percentage: (0, $d5e07fe2518aae94$exports.isSet)(object.percentage) ? String(object.percentage) : "",
            windows: (0, $d5e07fe2518aae94$exports.isSet)(object.windows) ? $911d924dc11f762c$exports.DecisionPolicyWindows.fromJSON(object.windows) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.percentage !== undefined && (obj.percentage = message.percentage);
        message.windows !== undefined && (obj.windows = message.windows ? $911d924dc11f762c$exports.DecisionPolicyWindows.toJSON(message.windows) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $911d924dc11f762c$var$createBasePercentageDecisionPolicy();
        message.percentage = object.percentage ?? "";
        message.windows = object.windows !== undefined && object.windows !== null ? $911d924dc11f762c$exports.DecisionPolicyWindows.fromPartial(object.windows) : undefined;
        return message;
    }
};
function $911d924dc11f762c$var$createBaseDecisionPolicyWindows() {
    return {
        votingPeriod: undefined,
        minExecutionPeriod: undefined
    };
}
$911d924dc11f762c$exports.DecisionPolicyWindows = {
    encode (message, writer = $911d924dc11f762c$var$_m0.Writer.create()) {
        if (message.votingPeriod !== undefined) $fe534fae4538ccbf$exports.Duration.encode(message.votingPeriod, writer.uint32(10).fork()).ldelim();
        if (message.minExecutionPeriod !== undefined) $fe534fae4538ccbf$exports.Duration.encode(message.minExecutionPeriod, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $911d924dc11f762c$var$_m0.Reader ? input : new $911d924dc11f762c$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $911d924dc11f762c$var$createBaseDecisionPolicyWindows();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.votingPeriod = $fe534fae4538ccbf$exports.Duration.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.minExecutionPeriod = $fe534fae4538ccbf$exports.Duration.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            votingPeriod: (0, $d5e07fe2518aae94$exports.isSet)(object.votingPeriod) ? $fe534fae4538ccbf$exports.Duration.fromJSON(object.votingPeriod) : undefined,
            minExecutionPeriod: (0, $d5e07fe2518aae94$exports.isSet)(object.minExecutionPeriod) ? $fe534fae4538ccbf$exports.Duration.fromJSON(object.minExecutionPeriod) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.votingPeriod !== undefined && (obj.votingPeriod = message.votingPeriod ? $fe534fae4538ccbf$exports.Duration.toJSON(message.votingPeriod) : undefined);
        message.minExecutionPeriod !== undefined && (obj.minExecutionPeriod = message.minExecutionPeriod ? $fe534fae4538ccbf$exports.Duration.toJSON(message.minExecutionPeriod) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $911d924dc11f762c$var$createBaseDecisionPolicyWindows();
        message.votingPeriod = object.votingPeriod !== undefined && object.votingPeriod !== null ? $fe534fae4538ccbf$exports.Duration.fromPartial(object.votingPeriod) : undefined;
        message.minExecutionPeriod = object.minExecutionPeriod !== undefined && object.minExecutionPeriod !== null ? $fe534fae4538ccbf$exports.Duration.fromPartial(object.minExecutionPeriod) : undefined;
        return message;
    }
};
function $911d924dc11f762c$var$createBaseGroupInfo() {
    return {
        id: $d5e07fe2518aae94$exports.Long.UZERO,
        admin: "",
        metadata: "",
        version: $d5e07fe2518aae94$exports.Long.UZERO,
        totalWeight: "",
        createdAt: undefined
    };
}
$911d924dc11f762c$exports.GroupInfo = {
    encode (message, writer = $911d924dc11f762c$var$_m0.Writer.create()) {
        if (!message.id.isZero()) writer.uint32(8).uint64(message.id);
        if (message.admin !== "") writer.uint32(18).string(message.admin);
        if (message.metadata !== "") writer.uint32(26).string(message.metadata);
        if (!message.version.isZero()) writer.uint32(32).uint64(message.version);
        if (message.totalWeight !== "") writer.uint32(42).string(message.totalWeight);
        if (message.createdAt !== undefined) $e7eaeedc85b414fc$exports.Timestamp.encode(message.createdAt, writer.uint32(50).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $911d924dc11f762c$var$_m0.Reader ? input : new $911d924dc11f762c$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $911d924dc11f762c$var$createBaseGroupInfo();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.id = reader.uint64();
                    break;
                case 2:
                    message.admin = reader.string();
                    break;
                case 3:
                    message.metadata = reader.string();
                    break;
                case 4:
                    message.version = reader.uint64();
                    break;
                case 5:
                    message.totalWeight = reader.string();
                    break;
                case 6:
                    message.createdAt = $e7eaeedc85b414fc$exports.Timestamp.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            id: (0, $d5e07fe2518aae94$exports.isSet)(object.id) ? $d5e07fe2518aae94$exports.Long.fromValue(object.id) : $d5e07fe2518aae94$exports.Long.UZERO,
            admin: (0, $d5e07fe2518aae94$exports.isSet)(object.admin) ? String(object.admin) : "",
            metadata: (0, $d5e07fe2518aae94$exports.isSet)(object.metadata) ? String(object.metadata) : "",
            version: (0, $d5e07fe2518aae94$exports.isSet)(object.version) ? $d5e07fe2518aae94$exports.Long.fromValue(object.version) : $d5e07fe2518aae94$exports.Long.UZERO,
            totalWeight: (0, $d5e07fe2518aae94$exports.isSet)(object.totalWeight) ? String(object.totalWeight) : "",
            createdAt: (0, $d5e07fe2518aae94$exports.isSet)(object.createdAt) ? (0, $d5e07fe2518aae94$exports.fromJsonTimestamp)(object.createdAt) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.id !== undefined && (obj.id = (message.id || $d5e07fe2518aae94$exports.Long.UZERO).toString());
        message.admin !== undefined && (obj.admin = message.admin);
        message.metadata !== undefined && (obj.metadata = message.metadata);
        message.version !== undefined && (obj.version = (message.version || $d5e07fe2518aae94$exports.Long.UZERO).toString());
        message.totalWeight !== undefined && (obj.totalWeight = message.totalWeight);
        message.createdAt !== undefined && (obj.createdAt = (0, $d5e07fe2518aae94$exports.fromTimestamp)(message.createdAt).toISOString());
        return obj;
    },
    fromPartial (object) {
        const message = $911d924dc11f762c$var$createBaseGroupInfo();
        message.id = object.id !== undefined && object.id !== null ? $d5e07fe2518aae94$exports.Long.fromValue(object.id) : $d5e07fe2518aae94$exports.Long.UZERO;
        message.admin = object.admin ?? "";
        message.metadata = object.metadata ?? "";
        message.version = object.version !== undefined && object.version !== null ? $d5e07fe2518aae94$exports.Long.fromValue(object.version) : $d5e07fe2518aae94$exports.Long.UZERO;
        message.totalWeight = object.totalWeight ?? "";
        message.createdAt = object.createdAt !== undefined && object.createdAt !== null ? $e7eaeedc85b414fc$exports.Timestamp.fromPartial(object.createdAt) : undefined;
        return message;
    }
};
function $911d924dc11f762c$var$createBaseGroupMember() {
    return {
        groupId: $d5e07fe2518aae94$exports.Long.UZERO,
        member: undefined
    };
}
$911d924dc11f762c$exports.GroupMember = {
    encode (message, writer = $911d924dc11f762c$var$_m0.Writer.create()) {
        if (!message.groupId.isZero()) writer.uint32(8).uint64(message.groupId);
        if (message.member !== undefined) $911d924dc11f762c$exports.Member.encode(message.member, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $911d924dc11f762c$var$_m0.Reader ? input : new $911d924dc11f762c$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $911d924dc11f762c$var$createBaseGroupMember();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.groupId = reader.uint64();
                    break;
                case 2:
                    message.member = $911d924dc11f762c$exports.Member.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            groupId: (0, $d5e07fe2518aae94$exports.isSet)(object.groupId) ? $d5e07fe2518aae94$exports.Long.fromValue(object.groupId) : $d5e07fe2518aae94$exports.Long.UZERO,
            member: (0, $d5e07fe2518aae94$exports.isSet)(object.member) ? $911d924dc11f762c$exports.Member.fromJSON(object.member) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.groupId !== undefined && (obj.groupId = (message.groupId || $d5e07fe2518aae94$exports.Long.UZERO).toString());
        message.member !== undefined && (obj.member = message.member ? $911d924dc11f762c$exports.Member.toJSON(message.member) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $911d924dc11f762c$var$createBaseGroupMember();
        message.groupId = object.groupId !== undefined && object.groupId !== null ? $d5e07fe2518aae94$exports.Long.fromValue(object.groupId) : $d5e07fe2518aae94$exports.Long.UZERO;
        message.member = object.member !== undefined && object.member !== null ? $911d924dc11f762c$exports.Member.fromPartial(object.member) : undefined;
        return message;
    }
};
function $911d924dc11f762c$var$createBaseGroupPolicyInfo() {
    return {
        address: "",
        groupId: $d5e07fe2518aae94$exports.Long.UZERO,
        admin: "",
        metadata: "",
        version: $d5e07fe2518aae94$exports.Long.UZERO,
        decisionPolicy: undefined,
        createdAt: undefined
    };
}
$911d924dc11f762c$exports.GroupPolicyInfo = {
    encode (message, writer = $911d924dc11f762c$var$_m0.Writer.create()) {
        if (message.address !== "") writer.uint32(10).string(message.address);
        if (!message.groupId.isZero()) writer.uint32(16).uint64(message.groupId);
        if (message.admin !== "") writer.uint32(26).string(message.admin);
        if (message.metadata !== "") writer.uint32(34).string(message.metadata);
        if (!message.version.isZero()) writer.uint32(40).uint64(message.version);
        if (message.decisionPolicy !== undefined) $64138e590dcf0cc1$exports.Any.encode(message.decisionPolicy, writer.uint32(50).fork()).ldelim();
        if (message.createdAt !== undefined) $e7eaeedc85b414fc$exports.Timestamp.encode(message.createdAt, writer.uint32(58).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $911d924dc11f762c$var$_m0.Reader ? input : new $911d924dc11f762c$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $911d924dc11f762c$var$createBaseGroupPolicyInfo();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.address = reader.string();
                    break;
                case 2:
                    message.groupId = reader.uint64();
                    break;
                case 3:
                    message.admin = reader.string();
                    break;
                case 4:
                    message.metadata = reader.string();
                    break;
                case 5:
                    message.version = reader.uint64();
                    break;
                case 6:
                    message.decisionPolicy = $64138e590dcf0cc1$exports.Any.decode(reader, reader.uint32());
                    break;
                case 7:
                    message.createdAt = $e7eaeedc85b414fc$exports.Timestamp.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            address: (0, $d5e07fe2518aae94$exports.isSet)(object.address) ? String(object.address) : "",
            groupId: (0, $d5e07fe2518aae94$exports.isSet)(object.groupId) ? $d5e07fe2518aae94$exports.Long.fromValue(object.groupId) : $d5e07fe2518aae94$exports.Long.UZERO,
            admin: (0, $d5e07fe2518aae94$exports.isSet)(object.admin) ? String(object.admin) : "",
            metadata: (0, $d5e07fe2518aae94$exports.isSet)(object.metadata) ? String(object.metadata) : "",
            version: (0, $d5e07fe2518aae94$exports.isSet)(object.version) ? $d5e07fe2518aae94$exports.Long.fromValue(object.version) : $d5e07fe2518aae94$exports.Long.UZERO,
            decisionPolicy: (0, $d5e07fe2518aae94$exports.isSet)(object.decisionPolicy) ? $64138e590dcf0cc1$exports.Any.fromJSON(object.decisionPolicy) : undefined,
            createdAt: (0, $d5e07fe2518aae94$exports.isSet)(object.createdAt) ? (0, $d5e07fe2518aae94$exports.fromJsonTimestamp)(object.createdAt) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.address !== undefined && (obj.address = message.address);
        message.groupId !== undefined && (obj.groupId = (message.groupId || $d5e07fe2518aae94$exports.Long.UZERO).toString());
        message.admin !== undefined && (obj.admin = message.admin);
        message.metadata !== undefined && (obj.metadata = message.metadata);
        message.version !== undefined && (obj.version = (message.version || $d5e07fe2518aae94$exports.Long.UZERO).toString());
        message.decisionPolicy !== undefined && (obj.decisionPolicy = message.decisionPolicy ? $64138e590dcf0cc1$exports.Any.toJSON(message.decisionPolicy) : undefined);
        message.createdAt !== undefined && (obj.createdAt = (0, $d5e07fe2518aae94$exports.fromTimestamp)(message.createdAt).toISOString());
        return obj;
    },
    fromPartial (object) {
        const message = $911d924dc11f762c$var$createBaseGroupPolicyInfo();
        message.address = object.address ?? "";
        message.groupId = object.groupId !== undefined && object.groupId !== null ? $d5e07fe2518aae94$exports.Long.fromValue(object.groupId) : $d5e07fe2518aae94$exports.Long.UZERO;
        message.admin = object.admin ?? "";
        message.metadata = object.metadata ?? "";
        message.version = object.version !== undefined && object.version !== null ? $d5e07fe2518aae94$exports.Long.fromValue(object.version) : $d5e07fe2518aae94$exports.Long.UZERO;
        message.decisionPolicy = object.decisionPolicy !== undefined && object.decisionPolicy !== null ? $64138e590dcf0cc1$exports.Any.fromPartial(object.decisionPolicy) : undefined;
        message.createdAt = object.createdAt !== undefined && object.createdAt !== null ? $e7eaeedc85b414fc$exports.Timestamp.fromPartial(object.createdAt) : undefined;
        return message;
    }
};
function $911d924dc11f762c$var$createBaseProposal() {
    return {
        id: $d5e07fe2518aae94$exports.Long.UZERO,
        groupPolicyAddress: "",
        metadata: "",
        proposers: [],
        submitTime: undefined,
        groupVersion: $d5e07fe2518aae94$exports.Long.UZERO,
        groupPolicyVersion: $d5e07fe2518aae94$exports.Long.UZERO,
        status: 0,
        finalTallyResult: undefined,
        votingPeriodEnd: undefined,
        executorResult: 0,
        messages: [],
        title: "",
        summary: ""
    };
}
$911d924dc11f762c$exports.Proposal = {
    encode (message, writer = $911d924dc11f762c$var$_m0.Writer.create()) {
        if (!message.id.isZero()) writer.uint32(8).uint64(message.id);
        if (message.groupPolicyAddress !== "") writer.uint32(18).string(message.groupPolicyAddress);
        if (message.metadata !== "") writer.uint32(26).string(message.metadata);
        for (const v of message.proposers)writer.uint32(34).string(v);
        if (message.submitTime !== undefined) $e7eaeedc85b414fc$exports.Timestamp.encode(message.submitTime, writer.uint32(42).fork()).ldelim();
        if (!message.groupVersion.isZero()) writer.uint32(48).uint64(message.groupVersion);
        if (!message.groupPolicyVersion.isZero()) writer.uint32(56).uint64(message.groupPolicyVersion);
        if (message.status !== 0) writer.uint32(64).int32(message.status);
        if (message.finalTallyResult !== undefined) $911d924dc11f762c$exports.TallyResult.encode(message.finalTallyResult, writer.uint32(74).fork()).ldelim();
        if (message.votingPeriodEnd !== undefined) $e7eaeedc85b414fc$exports.Timestamp.encode(message.votingPeriodEnd, writer.uint32(82).fork()).ldelim();
        if (message.executorResult !== 0) writer.uint32(88).int32(message.executorResult);
        for (const v of message.messages)$64138e590dcf0cc1$exports.Any.encode(v, writer.uint32(98).fork()).ldelim();
        if (message.title !== "") writer.uint32(106).string(message.title);
        if (message.summary !== "") writer.uint32(114).string(message.summary);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $911d924dc11f762c$var$_m0.Reader ? input : new $911d924dc11f762c$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $911d924dc11f762c$var$createBaseProposal();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.id = reader.uint64();
                    break;
                case 2:
                    message.groupPolicyAddress = reader.string();
                    break;
                case 3:
                    message.metadata = reader.string();
                    break;
                case 4:
                    message.proposers.push(reader.string());
                    break;
                case 5:
                    message.submitTime = $e7eaeedc85b414fc$exports.Timestamp.decode(reader, reader.uint32());
                    break;
                case 6:
                    message.groupVersion = reader.uint64();
                    break;
                case 7:
                    message.groupPolicyVersion = reader.uint64();
                    break;
                case 8:
                    message.status = reader.int32();
                    break;
                case 9:
                    message.finalTallyResult = $911d924dc11f762c$exports.TallyResult.decode(reader, reader.uint32());
                    break;
                case 10:
                    message.votingPeriodEnd = $e7eaeedc85b414fc$exports.Timestamp.decode(reader, reader.uint32());
                    break;
                case 11:
                    message.executorResult = reader.int32();
                    break;
                case 12:
                    message.messages.push($64138e590dcf0cc1$exports.Any.decode(reader, reader.uint32()));
                    break;
                case 13:
                    message.title = reader.string();
                    break;
                case 14:
                    message.summary = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            id: (0, $d5e07fe2518aae94$exports.isSet)(object.id) ? $d5e07fe2518aae94$exports.Long.fromValue(object.id) : $d5e07fe2518aae94$exports.Long.UZERO,
            groupPolicyAddress: (0, $d5e07fe2518aae94$exports.isSet)(object.groupPolicyAddress) ? String(object.groupPolicyAddress) : "",
            metadata: (0, $d5e07fe2518aae94$exports.isSet)(object.metadata) ? String(object.metadata) : "",
            proposers: Array.isArray(object?.proposers) ? object.proposers.map((e)=>String(e)) : [],
            submitTime: (0, $d5e07fe2518aae94$exports.isSet)(object.submitTime) ? (0, $d5e07fe2518aae94$exports.fromJsonTimestamp)(object.submitTime) : undefined,
            groupVersion: (0, $d5e07fe2518aae94$exports.isSet)(object.groupVersion) ? $d5e07fe2518aae94$exports.Long.fromValue(object.groupVersion) : $d5e07fe2518aae94$exports.Long.UZERO,
            groupPolicyVersion: (0, $d5e07fe2518aae94$exports.isSet)(object.groupPolicyVersion) ? $d5e07fe2518aae94$exports.Long.fromValue(object.groupPolicyVersion) : $d5e07fe2518aae94$exports.Long.UZERO,
            status: (0, $d5e07fe2518aae94$exports.isSet)(object.status) ? $911d924dc11f762c$var$proposalStatusFromJSON(object.status) : 0,
            finalTallyResult: (0, $d5e07fe2518aae94$exports.isSet)(object.finalTallyResult) ? $911d924dc11f762c$exports.TallyResult.fromJSON(object.finalTallyResult) : undefined,
            votingPeriodEnd: (0, $d5e07fe2518aae94$exports.isSet)(object.votingPeriodEnd) ? (0, $d5e07fe2518aae94$exports.fromJsonTimestamp)(object.votingPeriodEnd) : undefined,
            executorResult: (0, $d5e07fe2518aae94$exports.isSet)(object.executorResult) ? $911d924dc11f762c$var$proposalExecutorResultFromJSON(object.executorResult) : 0,
            messages: Array.isArray(object?.messages) ? object.messages.map((e)=>$64138e590dcf0cc1$exports.Any.fromJSON(e)) : [],
            title: (0, $d5e07fe2518aae94$exports.isSet)(object.title) ? String(object.title) : "",
            summary: (0, $d5e07fe2518aae94$exports.isSet)(object.summary) ? String(object.summary) : ""
        };
    },
    toJSON (message) {
        const obj = {};
        message.id !== undefined && (obj.id = (message.id || $d5e07fe2518aae94$exports.Long.UZERO).toString());
        message.groupPolicyAddress !== undefined && (obj.groupPolicyAddress = message.groupPolicyAddress);
        message.metadata !== undefined && (obj.metadata = message.metadata);
        if (message.proposers) obj.proposers = message.proposers.map((e)=>e);
        else obj.proposers = [];
        message.submitTime !== undefined && (obj.submitTime = (0, $d5e07fe2518aae94$exports.fromTimestamp)(message.submitTime).toISOString());
        message.groupVersion !== undefined && (obj.groupVersion = (message.groupVersion || $d5e07fe2518aae94$exports.Long.UZERO).toString());
        message.groupPolicyVersion !== undefined && (obj.groupPolicyVersion = (message.groupPolicyVersion || $d5e07fe2518aae94$exports.Long.UZERO).toString());
        message.status !== undefined && (obj.status = $911d924dc11f762c$var$proposalStatusToJSON(message.status));
        message.finalTallyResult !== undefined && (obj.finalTallyResult = message.finalTallyResult ? $911d924dc11f762c$exports.TallyResult.toJSON(message.finalTallyResult) : undefined);
        message.votingPeriodEnd !== undefined && (obj.votingPeriodEnd = (0, $d5e07fe2518aae94$exports.fromTimestamp)(message.votingPeriodEnd).toISOString());
        message.executorResult !== undefined && (obj.executorResult = $911d924dc11f762c$var$proposalExecutorResultToJSON(message.executorResult));
        if (message.messages) obj.messages = message.messages.map((e)=>e ? $64138e590dcf0cc1$exports.Any.toJSON(e) : undefined);
        else obj.messages = [];
        message.title !== undefined && (obj.title = message.title);
        message.summary !== undefined && (obj.summary = message.summary);
        return obj;
    },
    fromPartial (object) {
        const message = $911d924dc11f762c$var$createBaseProposal();
        message.id = object.id !== undefined && object.id !== null ? $d5e07fe2518aae94$exports.Long.fromValue(object.id) : $d5e07fe2518aae94$exports.Long.UZERO;
        message.groupPolicyAddress = object.groupPolicyAddress ?? "";
        message.metadata = object.metadata ?? "";
        message.proposers = object.proposers?.map((e)=>e) || [];
        message.submitTime = object.submitTime !== undefined && object.submitTime !== null ? $e7eaeedc85b414fc$exports.Timestamp.fromPartial(object.submitTime) : undefined;
        message.groupVersion = object.groupVersion !== undefined && object.groupVersion !== null ? $d5e07fe2518aae94$exports.Long.fromValue(object.groupVersion) : $d5e07fe2518aae94$exports.Long.UZERO;
        message.groupPolicyVersion = object.groupPolicyVersion !== undefined && object.groupPolicyVersion !== null ? $d5e07fe2518aae94$exports.Long.fromValue(object.groupPolicyVersion) : $d5e07fe2518aae94$exports.Long.UZERO;
        message.status = object.status ?? 0;
        message.finalTallyResult = object.finalTallyResult !== undefined && object.finalTallyResult !== null ? $911d924dc11f762c$exports.TallyResult.fromPartial(object.finalTallyResult) : undefined;
        message.votingPeriodEnd = object.votingPeriodEnd !== undefined && object.votingPeriodEnd !== null ? $e7eaeedc85b414fc$exports.Timestamp.fromPartial(object.votingPeriodEnd) : undefined;
        message.executorResult = object.executorResult ?? 0;
        message.messages = object.messages?.map((e)=>$64138e590dcf0cc1$exports.Any.fromPartial(e)) || [];
        message.title = object.title ?? "";
        message.summary = object.summary ?? "";
        return message;
    }
};
function $911d924dc11f762c$var$createBaseTallyResult() {
    return {
        yesCount: "",
        abstainCount: "",
        noCount: "",
        noWithVetoCount: ""
    };
}
$911d924dc11f762c$exports.TallyResult = {
    encode (message, writer = $911d924dc11f762c$var$_m0.Writer.create()) {
        if (message.yesCount !== "") writer.uint32(10).string(message.yesCount);
        if (message.abstainCount !== "") writer.uint32(18).string(message.abstainCount);
        if (message.noCount !== "") writer.uint32(26).string(message.noCount);
        if (message.noWithVetoCount !== "") writer.uint32(34).string(message.noWithVetoCount);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $911d924dc11f762c$var$_m0.Reader ? input : new $911d924dc11f762c$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $911d924dc11f762c$var$createBaseTallyResult();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.yesCount = reader.string();
                    break;
                case 2:
                    message.abstainCount = reader.string();
                    break;
                case 3:
                    message.noCount = reader.string();
                    break;
                case 4:
                    message.noWithVetoCount = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            yesCount: (0, $d5e07fe2518aae94$exports.isSet)(object.yesCount) ? String(object.yesCount) : "",
            abstainCount: (0, $d5e07fe2518aae94$exports.isSet)(object.abstainCount) ? String(object.abstainCount) : "",
            noCount: (0, $d5e07fe2518aae94$exports.isSet)(object.noCount) ? String(object.noCount) : "",
            noWithVetoCount: (0, $d5e07fe2518aae94$exports.isSet)(object.noWithVetoCount) ? String(object.noWithVetoCount) : ""
        };
    },
    toJSON (message) {
        const obj = {};
        message.yesCount !== undefined && (obj.yesCount = message.yesCount);
        message.abstainCount !== undefined && (obj.abstainCount = message.abstainCount);
        message.noCount !== undefined && (obj.noCount = message.noCount);
        message.noWithVetoCount !== undefined && (obj.noWithVetoCount = message.noWithVetoCount);
        return obj;
    },
    fromPartial (object) {
        const message = $911d924dc11f762c$var$createBaseTallyResult();
        message.yesCount = object.yesCount ?? "";
        message.abstainCount = object.abstainCount ?? "";
        message.noCount = object.noCount ?? "";
        message.noWithVetoCount = object.noWithVetoCount ?? "";
        return message;
    }
};
function $911d924dc11f762c$var$createBaseVote() {
    return {
        proposalId: $d5e07fe2518aae94$exports.Long.UZERO,
        voter: "",
        option: 0,
        metadata: "",
        submitTime: undefined
    };
}
$911d924dc11f762c$exports.Vote = {
    encode (message, writer = $911d924dc11f762c$var$_m0.Writer.create()) {
        if (!message.proposalId.isZero()) writer.uint32(8).uint64(message.proposalId);
        if (message.voter !== "") writer.uint32(18).string(message.voter);
        if (message.option !== 0) writer.uint32(24).int32(message.option);
        if (message.metadata !== "") writer.uint32(34).string(message.metadata);
        if (message.submitTime !== undefined) $e7eaeedc85b414fc$exports.Timestamp.encode(message.submitTime, writer.uint32(42).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $911d924dc11f762c$var$_m0.Reader ? input : new $911d924dc11f762c$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $911d924dc11f762c$var$createBaseVote();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.proposalId = reader.uint64();
                    break;
                case 2:
                    message.voter = reader.string();
                    break;
                case 3:
                    message.option = reader.int32();
                    break;
                case 4:
                    message.metadata = reader.string();
                    break;
                case 5:
                    message.submitTime = $e7eaeedc85b414fc$exports.Timestamp.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            proposalId: (0, $d5e07fe2518aae94$exports.isSet)(object.proposalId) ? $d5e07fe2518aae94$exports.Long.fromValue(object.proposalId) : $d5e07fe2518aae94$exports.Long.UZERO,
            voter: (0, $d5e07fe2518aae94$exports.isSet)(object.voter) ? String(object.voter) : "",
            option: (0, $d5e07fe2518aae94$exports.isSet)(object.option) ? $911d924dc11f762c$var$voteOptionFromJSON(object.option) : 0,
            metadata: (0, $d5e07fe2518aae94$exports.isSet)(object.metadata) ? String(object.metadata) : "",
            submitTime: (0, $d5e07fe2518aae94$exports.isSet)(object.submitTime) ? (0, $d5e07fe2518aae94$exports.fromJsonTimestamp)(object.submitTime) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.proposalId !== undefined && (obj.proposalId = (message.proposalId || $d5e07fe2518aae94$exports.Long.UZERO).toString());
        message.voter !== undefined && (obj.voter = message.voter);
        message.option !== undefined && (obj.option = $911d924dc11f762c$var$voteOptionToJSON(message.option));
        message.metadata !== undefined && (obj.metadata = message.metadata);
        message.submitTime !== undefined && (obj.submitTime = (0, $d5e07fe2518aae94$exports.fromTimestamp)(message.submitTime).toISOString());
        return obj;
    },
    fromPartial (object) {
        const message = $911d924dc11f762c$var$createBaseVote();
        message.proposalId = object.proposalId !== undefined && object.proposalId !== null ? $d5e07fe2518aae94$exports.Long.fromValue(object.proposalId) : $d5e07fe2518aae94$exports.Long.UZERO;
        message.voter = object.voter ?? "";
        message.option = object.option ?? 0;
        message.metadata = object.metadata ?? "";
        message.submitTime = object.submitTime !== undefined && object.submitTime !== null ? $e7eaeedc85b414fc$exports.Timestamp.fromPartial(object.submitTime) : undefined;
        return message;
    }
};





const $18c75608456c13f7$var$_m0 = $18c75608456c13f7$var$__importStar((parcelRequire("fQBv0")));
$18c75608456c13f7$exports.protobufPackage = "cosmos.group.v1";
/** Exec defines modes of execution of a proposal on creation or on new vote. */ var $18c75608456c13f7$var$Exec;
(function(Exec) {
    /**
     * EXEC_UNSPECIFIED - An empty value means that there should be a separate
     * MsgExec request for the proposal to execute.
     */ Exec[Exec["EXEC_UNSPECIFIED"] = 0] = "EXEC_UNSPECIFIED";
    /**
     * EXEC_TRY - Try to execute the proposal immediately.
     * If the proposal is not allowed per the DecisionPolicy,
     * the proposal will still be open and could
     * be executed at a later point.
     */ Exec[Exec["EXEC_TRY"] = 1] = "EXEC_TRY";
    Exec[Exec["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})($18c75608456c13f7$var$Exec = $18c75608456c13f7$exports.Exec || ($18c75608456c13f7$exports.Exec = {}));
function $18c75608456c13f7$var$execFromJSON(object) {
    switch(object){
        case 0:
        case "EXEC_UNSPECIFIED":
            return $18c75608456c13f7$var$Exec.EXEC_UNSPECIFIED;
        case 1:
        case "EXEC_TRY":
            return $18c75608456c13f7$var$Exec.EXEC_TRY;
        case -1:
        case "UNRECOGNIZED":
        default:
            return $18c75608456c13f7$var$Exec.UNRECOGNIZED;
    }
}
$18c75608456c13f7$exports.execFromJSON = $18c75608456c13f7$var$execFromJSON;
function $18c75608456c13f7$var$execToJSON(object) {
    switch(object){
        case $18c75608456c13f7$var$Exec.EXEC_UNSPECIFIED:
            return "EXEC_UNSPECIFIED";
        case $18c75608456c13f7$var$Exec.EXEC_TRY:
            return "EXEC_TRY";
        case $18c75608456c13f7$var$Exec.UNRECOGNIZED:
        default:
            return "UNRECOGNIZED";
    }
}
$18c75608456c13f7$exports.execToJSON = $18c75608456c13f7$var$execToJSON;
function $18c75608456c13f7$var$createBaseMsgCreateGroup() {
    return {
        admin: "",
        members: [],
        metadata: ""
    };
}
$18c75608456c13f7$exports.MsgCreateGroup = {
    encode (message, writer = $18c75608456c13f7$var$_m0.Writer.create()) {
        if (message.admin !== "") writer.uint32(10).string(message.admin);
        for (const v of message.members)$911d924dc11f762c$exports.MemberRequest.encode(v, writer.uint32(18).fork()).ldelim();
        if (message.metadata !== "") writer.uint32(26).string(message.metadata);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $18c75608456c13f7$var$_m0.Reader ? input : new $18c75608456c13f7$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $18c75608456c13f7$var$createBaseMsgCreateGroup();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.admin = reader.string();
                    break;
                case 2:
                    message.members.push($911d924dc11f762c$exports.MemberRequest.decode(reader, reader.uint32()));
                    break;
                case 3:
                    message.metadata = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            admin: (0, $d5e07fe2518aae94$exports.isSet)(object.admin) ? String(object.admin) : "",
            members: Array.isArray(object?.members) ? object.members.map((e)=>$911d924dc11f762c$exports.MemberRequest.fromJSON(e)) : [],
            metadata: (0, $d5e07fe2518aae94$exports.isSet)(object.metadata) ? String(object.metadata) : ""
        };
    },
    toJSON (message) {
        const obj = {};
        message.admin !== undefined && (obj.admin = message.admin);
        if (message.members) obj.members = message.members.map((e)=>e ? $911d924dc11f762c$exports.MemberRequest.toJSON(e) : undefined);
        else obj.members = [];
        message.metadata !== undefined && (obj.metadata = message.metadata);
        return obj;
    },
    fromPartial (object) {
        const message = $18c75608456c13f7$var$createBaseMsgCreateGroup();
        message.admin = object.admin ?? "";
        message.members = object.members?.map((e)=>$911d924dc11f762c$exports.MemberRequest.fromPartial(e)) || [];
        message.metadata = object.metadata ?? "";
        return message;
    }
};
function $18c75608456c13f7$var$createBaseMsgCreateGroupResponse() {
    return {
        groupId: $d5e07fe2518aae94$exports.Long.UZERO
    };
}
$18c75608456c13f7$exports.MsgCreateGroupResponse = {
    encode (message, writer = $18c75608456c13f7$var$_m0.Writer.create()) {
        if (!message.groupId.isZero()) writer.uint32(8).uint64(message.groupId);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $18c75608456c13f7$var$_m0.Reader ? input : new $18c75608456c13f7$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $18c75608456c13f7$var$createBaseMsgCreateGroupResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.groupId = reader.uint64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            groupId: (0, $d5e07fe2518aae94$exports.isSet)(object.groupId) ? $d5e07fe2518aae94$exports.Long.fromValue(object.groupId) : $d5e07fe2518aae94$exports.Long.UZERO
        };
    },
    toJSON (message) {
        const obj = {};
        message.groupId !== undefined && (obj.groupId = (message.groupId || $d5e07fe2518aae94$exports.Long.UZERO).toString());
        return obj;
    },
    fromPartial (object) {
        const message = $18c75608456c13f7$var$createBaseMsgCreateGroupResponse();
        message.groupId = object.groupId !== undefined && object.groupId !== null ? $d5e07fe2518aae94$exports.Long.fromValue(object.groupId) : $d5e07fe2518aae94$exports.Long.UZERO;
        return message;
    }
};
function $18c75608456c13f7$var$createBaseMsgUpdateGroupMembers() {
    return {
        admin: "",
        groupId: $d5e07fe2518aae94$exports.Long.UZERO,
        memberUpdates: []
    };
}
$18c75608456c13f7$exports.MsgUpdateGroupMembers = {
    encode (message, writer = $18c75608456c13f7$var$_m0.Writer.create()) {
        if (message.admin !== "") writer.uint32(10).string(message.admin);
        if (!message.groupId.isZero()) writer.uint32(16).uint64(message.groupId);
        for (const v of message.memberUpdates)$911d924dc11f762c$exports.MemberRequest.encode(v, writer.uint32(26).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $18c75608456c13f7$var$_m0.Reader ? input : new $18c75608456c13f7$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $18c75608456c13f7$var$createBaseMsgUpdateGroupMembers();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.admin = reader.string();
                    break;
                case 2:
                    message.groupId = reader.uint64();
                    break;
                case 3:
                    message.memberUpdates.push($911d924dc11f762c$exports.MemberRequest.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            admin: (0, $d5e07fe2518aae94$exports.isSet)(object.admin) ? String(object.admin) : "",
            groupId: (0, $d5e07fe2518aae94$exports.isSet)(object.groupId) ? $d5e07fe2518aae94$exports.Long.fromValue(object.groupId) : $d5e07fe2518aae94$exports.Long.UZERO,
            memberUpdates: Array.isArray(object?.memberUpdates) ? object.memberUpdates.map((e)=>$911d924dc11f762c$exports.MemberRequest.fromJSON(e)) : []
        };
    },
    toJSON (message) {
        const obj = {};
        message.admin !== undefined && (obj.admin = message.admin);
        message.groupId !== undefined && (obj.groupId = (message.groupId || $d5e07fe2518aae94$exports.Long.UZERO).toString());
        if (message.memberUpdates) obj.memberUpdates = message.memberUpdates.map((e)=>e ? $911d924dc11f762c$exports.MemberRequest.toJSON(e) : undefined);
        else obj.memberUpdates = [];
        return obj;
    },
    fromPartial (object) {
        const message = $18c75608456c13f7$var$createBaseMsgUpdateGroupMembers();
        message.admin = object.admin ?? "";
        message.groupId = object.groupId !== undefined && object.groupId !== null ? $d5e07fe2518aae94$exports.Long.fromValue(object.groupId) : $d5e07fe2518aae94$exports.Long.UZERO;
        message.memberUpdates = object.memberUpdates?.map((e)=>$911d924dc11f762c$exports.MemberRequest.fromPartial(e)) || [];
        return message;
    }
};
function $18c75608456c13f7$var$createBaseMsgUpdateGroupMembersResponse() {
    return {};
}
$18c75608456c13f7$exports.MsgUpdateGroupMembersResponse = {
    encode (_, writer = $18c75608456c13f7$var$_m0.Writer.create()) {
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $18c75608456c13f7$var$_m0.Reader ? input : new $18c75608456c13f7$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $18c75608456c13f7$var$createBaseMsgUpdateGroupMembersResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            tag;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON (_) {
        return {};
    },
    toJSON (_) {
        const obj = {};
        return obj;
    },
    fromPartial (_) {
        const message = $18c75608456c13f7$var$createBaseMsgUpdateGroupMembersResponse();
        return message;
    }
};
function $18c75608456c13f7$var$createBaseMsgUpdateGroupAdmin() {
    return {
        admin: "",
        groupId: $d5e07fe2518aae94$exports.Long.UZERO,
        newAdmin: ""
    };
}
$18c75608456c13f7$exports.MsgUpdateGroupAdmin = {
    encode (message, writer = $18c75608456c13f7$var$_m0.Writer.create()) {
        if (message.admin !== "") writer.uint32(10).string(message.admin);
        if (!message.groupId.isZero()) writer.uint32(16).uint64(message.groupId);
        if (message.newAdmin !== "") writer.uint32(26).string(message.newAdmin);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $18c75608456c13f7$var$_m0.Reader ? input : new $18c75608456c13f7$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $18c75608456c13f7$var$createBaseMsgUpdateGroupAdmin();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.admin = reader.string();
                    break;
                case 2:
                    message.groupId = reader.uint64();
                    break;
                case 3:
                    message.newAdmin = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            admin: (0, $d5e07fe2518aae94$exports.isSet)(object.admin) ? String(object.admin) : "",
            groupId: (0, $d5e07fe2518aae94$exports.isSet)(object.groupId) ? $d5e07fe2518aae94$exports.Long.fromValue(object.groupId) : $d5e07fe2518aae94$exports.Long.UZERO,
            newAdmin: (0, $d5e07fe2518aae94$exports.isSet)(object.newAdmin) ? String(object.newAdmin) : ""
        };
    },
    toJSON (message) {
        const obj = {};
        message.admin !== undefined && (obj.admin = message.admin);
        message.groupId !== undefined && (obj.groupId = (message.groupId || $d5e07fe2518aae94$exports.Long.UZERO).toString());
        message.newAdmin !== undefined && (obj.newAdmin = message.newAdmin);
        return obj;
    },
    fromPartial (object) {
        const message = $18c75608456c13f7$var$createBaseMsgUpdateGroupAdmin();
        message.admin = object.admin ?? "";
        message.groupId = object.groupId !== undefined && object.groupId !== null ? $d5e07fe2518aae94$exports.Long.fromValue(object.groupId) : $d5e07fe2518aae94$exports.Long.UZERO;
        message.newAdmin = object.newAdmin ?? "";
        return message;
    }
};
function $18c75608456c13f7$var$createBaseMsgUpdateGroupAdminResponse() {
    return {};
}
$18c75608456c13f7$exports.MsgUpdateGroupAdminResponse = {
    encode (_, writer = $18c75608456c13f7$var$_m0.Writer.create()) {
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $18c75608456c13f7$var$_m0.Reader ? input : new $18c75608456c13f7$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $18c75608456c13f7$var$createBaseMsgUpdateGroupAdminResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            tag;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON (_) {
        return {};
    },
    toJSON (_) {
        const obj = {};
        return obj;
    },
    fromPartial (_) {
        const message = $18c75608456c13f7$var$createBaseMsgUpdateGroupAdminResponse();
        return message;
    }
};
function $18c75608456c13f7$var$createBaseMsgUpdateGroupMetadata() {
    return {
        admin: "",
        groupId: $d5e07fe2518aae94$exports.Long.UZERO,
        metadata: ""
    };
}
$18c75608456c13f7$exports.MsgUpdateGroupMetadata = {
    encode (message, writer = $18c75608456c13f7$var$_m0.Writer.create()) {
        if (message.admin !== "") writer.uint32(10).string(message.admin);
        if (!message.groupId.isZero()) writer.uint32(16).uint64(message.groupId);
        if (message.metadata !== "") writer.uint32(26).string(message.metadata);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $18c75608456c13f7$var$_m0.Reader ? input : new $18c75608456c13f7$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $18c75608456c13f7$var$createBaseMsgUpdateGroupMetadata();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.admin = reader.string();
                    break;
                case 2:
                    message.groupId = reader.uint64();
                    break;
                case 3:
                    message.metadata = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            admin: (0, $d5e07fe2518aae94$exports.isSet)(object.admin) ? String(object.admin) : "",
            groupId: (0, $d5e07fe2518aae94$exports.isSet)(object.groupId) ? $d5e07fe2518aae94$exports.Long.fromValue(object.groupId) : $d5e07fe2518aae94$exports.Long.UZERO,
            metadata: (0, $d5e07fe2518aae94$exports.isSet)(object.metadata) ? String(object.metadata) : ""
        };
    },
    toJSON (message) {
        const obj = {};
        message.admin !== undefined && (obj.admin = message.admin);
        message.groupId !== undefined && (obj.groupId = (message.groupId || $d5e07fe2518aae94$exports.Long.UZERO).toString());
        message.metadata !== undefined && (obj.metadata = message.metadata);
        return obj;
    },
    fromPartial (object) {
        const message = $18c75608456c13f7$var$createBaseMsgUpdateGroupMetadata();
        message.admin = object.admin ?? "";
        message.groupId = object.groupId !== undefined && object.groupId !== null ? $d5e07fe2518aae94$exports.Long.fromValue(object.groupId) : $d5e07fe2518aae94$exports.Long.UZERO;
        message.metadata = object.metadata ?? "";
        return message;
    }
};
function $18c75608456c13f7$var$createBaseMsgUpdateGroupMetadataResponse() {
    return {};
}
$18c75608456c13f7$exports.MsgUpdateGroupMetadataResponse = {
    encode (_, writer = $18c75608456c13f7$var$_m0.Writer.create()) {
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $18c75608456c13f7$var$_m0.Reader ? input : new $18c75608456c13f7$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $18c75608456c13f7$var$createBaseMsgUpdateGroupMetadataResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            tag;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON (_) {
        return {};
    },
    toJSON (_) {
        const obj = {};
        return obj;
    },
    fromPartial (_) {
        const message = $18c75608456c13f7$var$createBaseMsgUpdateGroupMetadataResponse();
        return message;
    }
};
function $18c75608456c13f7$var$createBaseMsgCreateGroupPolicy() {
    return {
        admin: "",
        groupId: $d5e07fe2518aae94$exports.Long.UZERO,
        metadata: "",
        decisionPolicy: undefined
    };
}
$18c75608456c13f7$exports.MsgCreateGroupPolicy = {
    encode (message, writer = $18c75608456c13f7$var$_m0.Writer.create()) {
        if (message.admin !== "") writer.uint32(10).string(message.admin);
        if (!message.groupId.isZero()) writer.uint32(16).uint64(message.groupId);
        if (message.metadata !== "") writer.uint32(26).string(message.metadata);
        if (message.decisionPolicy !== undefined) $64138e590dcf0cc1$exports.Any.encode(message.decisionPolicy, writer.uint32(34).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $18c75608456c13f7$var$_m0.Reader ? input : new $18c75608456c13f7$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $18c75608456c13f7$var$createBaseMsgCreateGroupPolicy();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.admin = reader.string();
                    break;
                case 2:
                    message.groupId = reader.uint64();
                    break;
                case 3:
                    message.metadata = reader.string();
                    break;
                case 4:
                    message.decisionPolicy = $64138e590dcf0cc1$exports.Any.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            admin: (0, $d5e07fe2518aae94$exports.isSet)(object.admin) ? String(object.admin) : "",
            groupId: (0, $d5e07fe2518aae94$exports.isSet)(object.groupId) ? $d5e07fe2518aae94$exports.Long.fromValue(object.groupId) : $d5e07fe2518aae94$exports.Long.UZERO,
            metadata: (0, $d5e07fe2518aae94$exports.isSet)(object.metadata) ? String(object.metadata) : "",
            decisionPolicy: (0, $d5e07fe2518aae94$exports.isSet)(object.decisionPolicy) ? $64138e590dcf0cc1$exports.Any.fromJSON(object.decisionPolicy) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.admin !== undefined && (obj.admin = message.admin);
        message.groupId !== undefined && (obj.groupId = (message.groupId || $d5e07fe2518aae94$exports.Long.UZERO).toString());
        message.metadata !== undefined && (obj.metadata = message.metadata);
        message.decisionPolicy !== undefined && (obj.decisionPolicy = message.decisionPolicy ? $64138e590dcf0cc1$exports.Any.toJSON(message.decisionPolicy) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $18c75608456c13f7$var$createBaseMsgCreateGroupPolicy();
        message.admin = object.admin ?? "";
        message.groupId = object.groupId !== undefined && object.groupId !== null ? $d5e07fe2518aae94$exports.Long.fromValue(object.groupId) : $d5e07fe2518aae94$exports.Long.UZERO;
        message.metadata = object.metadata ?? "";
        message.decisionPolicy = object.decisionPolicy !== undefined && object.decisionPolicy !== null ? $64138e590dcf0cc1$exports.Any.fromPartial(object.decisionPolicy) : undefined;
        return message;
    }
};
function $18c75608456c13f7$var$createBaseMsgCreateGroupPolicyResponse() {
    return {
        address: ""
    };
}
$18c75608456c13f7$exports.MsgCreateGroupPolicyResponse = {
    encode (message, writer = $18c75608456c13f7$var$_m0.Writer.create()) {
        if (message.address !== "") writer.uint32(10).string(message.address);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $18c75608456c13f7$var$_m0.Reader ? input : new $18c75608456c13f7$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $18c75608456c13f7$var$createBaseMsgCreateGroupPolicyResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.address = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            address: (0, $d5e07fe2518aae94$exports.isSet)(object.address) ? String(object.address) : ""
        };
    },
    toJSON (message) {
        const obj = {};
        message.address !== undefined && (obj.address = message.address);
        return obj;
    },
    fromPartial (object) {
        const message = $18c75608456c13f7$var$createBaseMsgCreateGroupPolicyResponse();
        message.address = object.address ?? "";
        return message;
    }
};
function $18c75608456c13f7$var$createBaseMsgUpdateGroupPolicyAdmin() {
    return {
        admin: "",
        groupPolicyAddress: "",
        newAdmin: ""
    };
}
$18c75608456c13f7$exports.MsgUpdateGroupPolicyAdmin = {
    encode (message, writer = $18c75608456c13f7$var$_m0.Writer.create()) {
        if (message.admin !== "") writer.uint32(10).string(message.admin);
        if (message.groupPolicyAddress !== "") writer.uint32(18).string(message.groupPolicyAddress);
        if (message.newAdmin !== "") writer.uint32(26).string(message.newAdmin);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $18c75608456c13f7$var$_m0.Reader ? input : new $18c75608456c13f7$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $18c75608456c13f7$var$createBaseMsgUpdateGroupPolicyAdmin();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.admin = reader.string();
                    break;
                case 2:
                    message.groupPolicyAddress = reader.string();
                    break;
                case 3:
                    message.newAdmin = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            admin: (0, $d5e07fe2518aae94$exports.isSet)(object.admin) ? String(object.admin) : "",
            groupPolicyAddress: (0, $d5e07fe2518aae94$exports.isSet)(object.groupPolicyAddress) ? String(object.groupPolicyAddress) : "",
            newAdmin: (0, $d5e07fe2518aae94$exports.isSet)(object.newAdmin) ? String(object.newAdmin) : ""
        };
    },
    toJSON (message) {
        const obj = {};
        message.admin !== undefined && (obj.admin = message.admin);
        message.groupPolicyAddress !== undefined && (obj.groupPolicyAddress = message.groupPolicyAddress);
        message.newAdmin !== undefined && (obj.newAdmin = message.newAdmin);
        return obj;
    },
    fromPartial (object) {
        const message = $18c75608456c13f7$var$createBaseMsgUpdateGroupPolicyAdmin();
        message.admin = object.admin ?? "";
        message.groupPolicyAddress = object.groupPolicyAddress ?? "";
        message.newAdmin = object.newAdmin ?? "";
        return message;
    }
};
function $18c75608456c13f7$var$createBaseMsgUpdateGroupPolicyAdminResponse() {
    return {};
}
$18c75608456c13f7$exports.MsgUpdateGroupPolicyAdminResponse = {
    encode (_, writer = $18c75608456c13f7$var$_m0.Writer.create()) {
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $18c75608456c13f7$var$_m0.Reader ? input : new $18c75608456c13f7$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $18c75608456c13f7$var$createBaseMsgUpdateGroupPolicyAdminResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            tag;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON (_) {
        return {};
    },
    toJSON (_) {
        const obj = {};
        return obj;
    },
    fromPartial (_) {
        const message = $18c75608456c13f7$var$createBaseMsgUpdateGroupPolicyAdminResponse();
        return message;
    }
};
function $18c75608456c13f7$var$createBaseMsgCreateGroupWithPolicy() {
    return {
        admin: "",
        members: [],
        groupMetadata: "",
        groupPolicyMetadata: "",
        groupPolicyAsAdmin: false,
        decisionPolicy: undefined
    };
}
$18c75608456c13f7$exports.MsgCreateGroupWithPolicy = {
    encode (message, writer = $18c75608456c13f7$var$_m0.Writer.create()) {
        if (message.admin !== "") writer.uint32(10).string(message.admin);
        for (const v of message.members)$911d924dc11f762c$exports.MemberRequest.encode(v, writer.uint32(18).fork()).ldelim();
        if (message.groupMetadata !== "") writer.uint32(26).string(message.groupMetadata);
        if (message.groupPolicyMetadata !== "") writer.uint32(34).string(message.groupPolicyMetadata);
        if (message.groupPolicyAsAdmin === true) writer.uint32(40).bool(message.groupPolicyAsAdmin);
        if (message.decisionPolicy !== undefined) $64138e590dcf0cc1$exports.Any.encode(message.decisionPolicy, writer.uint32(50).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $18c75608456c13f7$var$_m0.Reader ? input : new $18c75608456c13f7$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $18c75608456c13f7$var$createBaseMsgCreateGroupWithPolicy();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.admin = reader.string();
                    break;
                case 2:
                    message.members.push($911d924dc11f762c$exports.MemberRequest.decode(reader, reader.uint32()));
                    break;
                case 3:
                    message.groupMetadata = reader.string();
                    break;
                case 4:
                    message.groupPolicyMetadata = reader.string();
                    break;
                case 5:
                    message.groupPolicyAsAdmin = reader.bool();
                    break;
                case 6:
                    message.decisionPolicy = $64138e590dcf0cc1$exports.Any.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            admin: (0, $d5e07fe2518aae94$exports.isSet)(object.admin) ? String(object.admin) : "",
            members: Array.isArray(object?.members) ? object.members.map((e)=>$911d924dc11f762c$exports.MemberRequest.fromJSON(e)) : [],
            groupMetadata: (0, $d5e07fe2518aae94$exports.isSet)(object.groupMetadata) ? String(object.groupMetadata) : "",
            groupPolicyMetadata: (0, $d5e07fe2518aae94$exports.isSet)(object.groupPolicyMetadata) ? String(object.groupPolicyMetadata) : "",
            groupPolicyAsAdmin: (0, $d5e07fe2518aae94$exports.isSet)(object.groupPolicyAsAdmin) ? Boolean(object.groupPolicyAsAdmin) : false,
            decisionPolicy: (0, $d5e07fe2518aae94$exports.isSet)(object.decisionPolicy) ? $64138e590dcf0cc1$exports.Any.fromJSON(object.decisionPolicy) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.admin !== undefined && (obj.admin = message.admin);
        if (message.members) obj.members = message.members.map((e)=>e ? $911d924dc11f762c$exports.MemberRequest.toJSON(e) : undefined);
        else obj.members = [];
        message.groupMetadata !== undefined && (obj.groupMetadata = message.groupMetadata);
        message.groupPolicyMetadata !== undefined && (obj.groupPolicyMetadata = message.groupPolicyMetadata);
        message.groupPolicyAsAdmin !== undefined && (obj.groupPolicyAsAdmin = message.groupPolicyAsAdmin);
        message.decisionPolicy !== undefined && (obj.decisionPolicy = message.decisionPolicy ? $64138e590dcf0cc1$exports.Any.toJSON(message.decisionPolicy) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $18c75608456c13f7$var$createBaseMsgCreateGroupWithPolicy();
        message.admin = object.admin ?? "";
        message.members = object.members?.map((e)=>$911d924dc11f762c$exports.MemberRequest.fromPartial(e)) || [];
        message.groupMetadata = object.groupMetadata ?? "";
        message.groupPolicyMetadata = object.groupPolicyMetadata ?? "";
        message.groupPolicyAsAdmin = object.groupPolicyAsAdmin ?? false;
        message.decisionPolicy = object.decisionPolicy !== undefined && object.decisionPolicy !== null ? $64138e590dcf0cc1$exports.Any.fromPartial(object.decisionPolicy) : undefined;
        return message;
    }
};
function $18c75608456c13f7$var$createBaseMsgCreateGroupWithPolicyResponse() {
    return {
        groupId: $d5e07fe2518aae94$exports.Long.UZERO,
        groupPolicyAddress: ""
    };
}
$18c75608456c13f7$exports.MsgCreateGroupWithPolicyResponse = {
    encode (message, writer = $18c75608456c13f7$var$_m0.Writer.create()) {
        if (!message.groupId.isZero()) writer.uint32(8).uint64(message.groupId);
        if (message.groupPolicyAddress !== "") writer.uint32(18).string(message.groupPolicyAddress);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $18c75608456c13f7$var$_m0.Reader ? input : new $18c75608456c13f7$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $18c75608456c13f7$var$createBaseMsgCreateGroupWithPolicyResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.groupId = reader.uint64();
                    break;
                case 2:
                    message.groupPolicyAddress = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            groupId: (0, $d5e07fe2518aae94$exports.isSet)(object.groupId) ? $d5e07fe2518aae94$exports.Long.fromValue(object.groupId) : $d5e07fe2518aae94$exports.Long.UZERO,
            groupPolicyAddress: (0, $d5e07fe2518aae94$exports.isSet)(object.groupPolicyAddress) ? String(object.groupPolicyAddress) : ""
        };
    },
    toJSON (message) {
        const obj = {};
        message.groupId !== undefined && (obj.groupId = (message.groupId || $d5e07fe2518aae94$exports.Long.UZERO).toString());
        message.groupPolicyAddress !== undefined && (obj.groupPolicyAddress = message.groupPolicyAddress);
        return obj;
    },
    fromPartial (object) {
        const message = $18c75608456c13f7$var$createBaseMsgCreateGroupWithPolicyResponse();
        message.groupId = object.groupId !== undefined && object.groupId !== null ? $d5e07fe2518aae94$exports.Long.fromValue(object.groupId) : $d5e07fe2518aae94$exports.Long.UZERO;
        message.groupPolicyAddress = object.groupPolicyAddress ?? "";
        return message;
    }
};
function $18c75608456c13f7$var$createBaseMsgUpdateGroupPolicyDecisionPolicy() {
    return {
        admin: "",
        groupPolicyAddress: "",
        decisionPolicy: undefined
    };
}
$18c75608456c13f7$exports.MsgUpdateGroupPolicyDecisionPolicy = {
    encode (message, writer = $18c75608456c13f7$var$_m0.Writer.create()) {
        if (message.admin !== "") writer.uint32(10).string(message.admin);
        if (message.groupPolicyAddress !== "") writer.uint32(18).string(message.groupPolicyAddress);
        if (message.decisionPolicy !== undefined) $64138e590dcf0cc1$exports.Any.encode(message.decisionPolicy, writer.uint32(26).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $18c75608456c13f7$var$_m0.Reader ? input : new $18c75608456c13f7$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $18c75608456c13f7$var$createBaseMsgUpdateGroupPolicyDecisionPolicy();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.admin = reader.string();
                    break;
                case 2:
                    message.groupPolicyAddress = reader.string();
                    break;
                case 3:
                    message.decisionPolicy = $64138e590dcf0cc1$exports.Any.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            admin: (0, $d5e07fe2518aae94$exports.isSet)(object.admin) ? String(object.admin) : "",
            groupPolicyAddress: (0, $d5e07fe2518aae94$exports.isSet)(object.groupPolicyAddress) ? String(object.groupPolicyAddress) : "",
            decisionPolicy: (0, $d5e07fe2518aae94$exports.isSet)(object.decisionPolicy) ? $64138e590dcf0cc1$exports.Any.fromJSON(object.decisionPolicy) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.admin !== undefined && (obj.admin = message.admin);
        message.groupPolicyAddress !== undefined && (obj.groupPolicyAddress = message.groupPolicyAddress);
        message.decisionPolicy !== undefined && (obj.decisionPolicy = message.decisionPolicy ? $64138e590dcf0cc1$exports.Any.toJSON(message.decisionPolicy) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $18c75608456c13f7$var$createBaseMsgUpdateGroupPolicyDecisionPolicy();
        message.admin = object.admin ?? "";
        message.groupPolicyAddress = object.groupPolicyAddress ?? "";
        message.decisionPolicy = object.decisionPolicy !== undefined && object.decisionPolicy !== null ? $64138e590dcf0cc1$exports.Any.fromPartial(object.decisionPolicy) : undefined;
        return message;
    }
};
function $18c75608456c13f7$var$createBaseMsgUpdateGroupPolicyDecisionPolicyResponse() {
    return {};
}
$18c75608456c13f7$exports.MsgUpdateGroupPolicyDecisionPolicyResponse = {
    encode (_, writer = $18c75608456c13f7$var$_m0.Writer.create()) {
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $18c75608456c13f7$var$_m0.Reader ? input : new $18c75608456c13f7$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $18c75608456c13f7$var$createBaseMsgUpdateGroupPolicyDecisionPolicyResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            tag;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON (_) {
        return {};
    },
    toJSON (_) {
        const obj = {};
        return obj;
    },
    fromPartial (_) {
        const message = $18c75608456c13f7$var$createBaseMsgUpdateGroupPolicyDecisionPolicyResponse();
        return message;
    }
};
function $18c75608456c13f7$var$createBaseMsgUpdateGroupPolicyMetadata() {
    return {
        admin: "",
        groupPolicyAddress: "",
        metadata: ""
    };
}
$18c75608456c13f7$exports.MsgUpdateGroupPolicyMetadata = {
    encode (message, writer = $18c75608456c13f7$var$_m0.Writer.create()) {
        if (message.admin !== "") writer.uint32(10).string(message.admin);
        if (message.groupPolicyAddress !== "") writer.uint32(18).string(message.groupPolicyAddress);
        if (message.metadata !== "") writer.uint32(26).string(message.metadata);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $18c75608456c13f7$var$_m0.Reader ? input : new $18c75608456c13f7$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $18c75608456c13f7$var$createBaseMsgUpdateGroupPolicyMetadata();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.admin = reader.string();
                    break;
                case 2:
                    message.groupPolicyAddress = reader.string();
                    break;
                case 3:
                    message.metadata = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            admin: (0, $d5e07fe2518aae94$exports.isSet)(object.admin) ? String(object.admin) : "",
            groupPolicyAddress: (0, $d5e07fe2518aae94$exports.isSet)(object.groupPolicyAddress) ? String(object.groupPolicyAddress) : "",
            metadata: (0, $d5e07fe2518aae94$exports.isSet)(object.metadata) ? String(object.metadata) : ""
        };
    },
    toJSON (message) {
        const obj = {};
        message.admin !== undefined && (obj.admin = message.admin);
        message.groupPolicyAddress !== undefined && (obj.groupPolicyAddress = message.groupPolicyAddress);
        message.metadata !== undefined && (obj.metadata = message.metadata);
        return obj;
    },
    fromPartial (object) {
        const message = $18c75608456c13f7$var$createBaseMsgUpdateGroupPolicyMetadata();
        message.admin = object.admin ?? "";
        message.groupPolicyAddress = object.groupPolicyAddress ?? "";
        message.metadata = object.metadata ?? "";
        return message;
    }
};
function $18c75608456c13f7$var$createBaseMsgUpdateGroupPolicyMetadataResponse() {
    return {};
}
$18c75608456c13f7$exports.MsgUpdateGroupPolicyMetadataResponse = {
    encode (_, writer = $18c75608456c13f7$var$_m0.Writer.create()) {
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $18c75608456c13f7$var$_m0.Reader ? input : new $18c75608456c13f7$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $18c75608456c13f7$var$createBaseMsgUpdateGroupPolicyMetadataResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            tag;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON (_) {
        return {};
    },
    toJSON (_) {
        const obj = {};
        return obj;
    },
    fromPartial (_) {
        const message = $18c75608456c13f7$var$createBaseMsgUpdateGroupPolicyMetadataResponse();
        return message;
    }
};
function $18c75608456c13f7$var$createBaseMsgSubmitProposal() {
    return {
        groupPolicyAddress: "",
        proposers: [],
        metadata: "",
        messages: [],
        exec: 0,
        title: "",
        summary: ""
    };
}
$18c75608456c13f7$exports.MsgSubmitProposal = {
    encode (message, writer = $18c75608456c13f7$var$_m0.Writer.create()) {
        if (message.groupPolicyAddress !== "") writer.uint32(10).string(message.groupPolicyAddress);
        for (const v of message.proposers)writer.uint32(18).string(v);
        if (message.metadata !== "") writer.uint32(26).string(message.metadata);
        for (const v of message.messages)$64138e590dcf0cc1$exports.Any.encode(v, writer.uint32(34).fork()).ldelim();
        if (message.exec !== 0) writer.uint32(40).int32(message.exec);
        if (message.title !== "") writer.uint32(50).string(message.title);
        if (message.summary !== "") writer.uint32(58).string(message.summary);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $18c75608456c13f7$var$_m0.Reader ? input : new $18c75608456c13f7$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $18c75608456c13f7$var$createBaseMsgSubmitProposal();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.groupPolicyAddress = reader.string();
                    break;
                case 2:
                    message.proposers.push(reader.string());
                    break;
                case 3:
                    message.metadata = reader.string();
                    break;
                case 4:
                    message.messages.push($64138e590dcf0cc1$exports.Any.decode(reader, reader.uint32()));
                    break;
                case 5:
                    message.exec = reader.int32();
                    break;
                case 6:
                    message.title = reader.string();
                    break;
                case 7:
                    message.summary = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            groupPolicyAddress: (0, $d5e07fe2518aae94$exports.isSet)(object.groupPolicyAddress) ? String(object.groupPolicyAddress) : "",
            proposers: Array.isArray(object?.proposers) ? object.proposers.map((e)=>String(e)) : [],
            metadata: (0, $d5e07fe2518aae94$exports.isSet)(object.metadata) ? String(object.metadata) : "",
            messages: Array.isArray(object?.messages) ? object.messages.map((e)=>$64138e590dcf0cc1$exports.Any.fromJSON(e)) : [],
            exec: (0, $d5e07fe2518aae94$exports.isSet)(object.exec) ? $18c75608456c13f7$var$execFromJSON(object.exec) : 0,
            title: (0, $d5e07fe2518aae94$exports.isSet)(object.title) ? String(object.title) : "",
            summary: (0, $d5e07fe2518aae94$exports.isSet)(object.summary) ? String(object.summary) : ""
        };
    },
    toJSON (message) {
        const obj = {};
        message.groupPolicyAddress !== undefined && (obj.groupPolicyAddress = message.groupPolicyAddress);
        if (message.proposers) obj.proposers = message.proposers.map((e)=>e);
        else obj.proposers = [];
        message.metadata !== undefined && (obj.metadata = message.metadata);
        if (message.messages) obj.messages = message.messages.map((e)=>e ? $64138e590dcf0cc1$exports.Any.toJSON(e) : undefined);
        else obj.messages = [];
        message.exec !== undefined && (obj.exec = $18c75608456c13f7$var$execToJSON(message.exec));
        message.title !== undefined && (obj.title = message.title);
        message.summary !== undefined && (obj.summary = message.summary);
        return obj;
    },
    fromPartial (object) {
        const message = $18c75608456c13f7$var$createBaseMsgSubmitProposal();
        message.groupPolicyAddress = object.groupPolicyAddress ?? "";
        message.proposers = object.proposers?.map((e)=>e) || [];
        message.metadata = object.metadata ?? "";
        message.messages = object.messages?.map((e)=>$64138e590dcf0cc1$exports.Any.fromPartial(e)) || [];
        message.exec = object.exec ?? 0;
        message.title = object.title ?? "";
        message.summary = object.summary ?? "";
        return message;
    }
};
function $18c75608456c13f7$var$createBaseMsgSubmitProposalResponse() {
    return {
        proposalId: $d5e07fe2518aae94$exports.Long.UZERO
    };
}
$18c75608456c13f7$exports.MsgSubmitProposalResponse = {
    encode (message, writer = $18c75608456c13f7$var$_m0.Writer.create()) {
        if (!message.proposalId.isZero()) writer.uint32(8).uint64(message.proposalId);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $18c75608456c13f7$var$_m0.Reader ? input : new $18c75608456c13f7$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $18c75608456c13f7$var$createBaseMsgSubmitProposalResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.proposalId = reader.uint64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            proposalId: (0, $d5e07fe2518aae94$exports.isSet)(object.proposalId) ? $d5e07fe2518aae94$exports.Long.fromValue(object.proposalId) : $d5e07fe2518aae94$exports.Long.UZERO
        };
    },
    toJSON (message) {
        const obj = {};
        message.proposalId !== undefined && (obj.proposalId = (message.proposalId || $d5e07fe2518aae94$exports.Long.UZERO).toString());
        return obj;
    },
    fromPartial (object) {
        const message = $18c75608456c13f7$var$createBaseMsgSubmitProposalResponse();
        message.proposalId = object.proposalId !== undefined && object.proposalId !== null ? $d5e07fe2518aae94$exports.Long.fromValue(object.proposalId) : $d5e07fe2518aae94$exports.Long.UZERO;
        return message;
    }
};
function $18c75608456c13f7$var$createBaseMsgWithdrawProposal() {
    return {
        proposalId: $d5e07fe2518aae94$exports.Long.UZERO,
        address: ""
    };
}
$18c75608456c13f7$exports.MsgWithdrawProposal = {
    encode (message, writer = $18c75608456c13f7$var$_m0.Writer.create()) {
        if (!message.proposalId.isZero()) writer.uint32(8).uint64(message.proposalId);
        if (message.address !== "") writer.uint32(18).string(message.address);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $18c75608456c13f7$var$_m0.Reader ? input : new $18c75608456c13f7$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $18c75608456c13f7$var$createBaseMsgWithdrawProposal();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.proposalId = reader.uint64();
                    break;
                case 2:
                    message.address = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            proposalId: (0, $d5e07fe2518aae94$exports.isSet)(object.proposalId) ? $d5e07fe2518aae94$exports.Long.fromValue(object.proposalId) : $d5e07fe2518aae94$exports.Long.UZERO,
            address: (0, $d5e07fe2518aae94$exports.isSet)(object.address) ? String(object.address) : ""
        };
    },
    toJSON (message) {
        const obj = {};
        message.proposalId !== undefined && (obj.proposalId = (message.proposalId || $d5e07fe2518aae94$exports.Long.UZERO).toString());
        message.address !== undefined && (obj.address = message.address);
        return obj;
    },
    fromPartial (object) {
        const message = $18c75608456c13f7$var$createBaseMsgWithdrawProposal();
        message.proposalId = object.proposalId !== undefined && object.proposalId !== null ? $d5e07fe2518aae94$exports.Long.fromValue(object.proposalId) : $d5e07fe2518aae94$exports.Long.UZERO;
        message.address = object.address ?? "";
        return message;
    }
};
function $18c75608456c13f7$var$createBaseMsgWithdrawProposalResponse() {
    return {};
}
$18c75608456c13f7$exports.MsgWithdrawProposalResponse = {
    encode (_, writer = $18c75608456c13f7$var$_m0.Writer.create()) {
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $18c75608456c13f7$var$_m0.Reader ? input : new $18c75608456c13f7$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $18c75608456c13f7$var$createBaseMsgWithdrawProposalResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            tag;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON (_) {
        return {};
    },
    toJSON (_) {
        const obj = {};
        return obj;
    },
    fromPartial (_) {
        const message = $18c75608456c13f7$var$createBaseMsgWithdrawProposalResponse();
        return message;
    }
};
function $18c75608456c13f7$var$createBaseMsgVote() {
    return {
        proposalId: $d5e07fe2518aae94$exports.Long.UZERO,
        voter: "",
        option: 0,
        metadata: "",
        exec: 0
    };
}
$18c75608456c13f7$exports.MsgVote = {
    encode (message, writer = $18c75608456c13f7$var$_m0.Writer.create()) {
        if (!message.proposalId.isZero()) writer.uint32(8).uint64(message.proposalId);
        if (message.voter !== "") writer.uint32(18).string(message.voter);
        if (message.option !== 0) writer.uint32(24).int32(message.option);
        if (message.metadata !== "") writer.uint32(34).string(message.metadata);
        if (message.exec !== 0) writer.uint32(40).int32(message.exec);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $18c75608456c13f7$var$_m0.Reader ? input : new $18c75608456c13f7$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $18c75608456c13f7$var$createBaseMsgVote();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.proposalId = reader.uint64();
                    break;
                case 2:
                    message.voter = reader.string();
                    break;
                case 3:
                    message.option = reader.int32();
                    break;
                case 4:
                    message.metadata = reader.string();
                    break;
                case 5:
                    message.exec = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            proposalId: (0, $d5e07fe2518aae94$exports.isSet)(object.proposalId) ? $d5e07fe2518aae94$exports.Long.fromValue(object.proposalId) : $d5e07fe2518aae94$exports.Long.UZERO,
            voter: (0, $d5e07fe2518aae94$exports.isSet)(object.voter) ? String(object.voter) : "",
            option: (0, $d5e07fe2518aae94$exports.isSet)(object.option) ? (0, $911d924dc11f762c$exports.voteOptionFromJSON)(object.option) : 0,
            metadata: (0, $d5e07fe2518aae94$exports.isSet)(object.metadata) ? String(object.metadata) : "",
            exec: (0, $d5e07fe2518aae94$exports.isSet)(object.exec) ? $18c75608456c13f7$var$execFromJSON(object.exec) : 0
        };
    },
    toJSON (message) {
        const obj = {};
        message.proposalId !== undefined && (obj.proposalId = (message.proposalId || $d5e07fe2518aae94$exports.Long.UZERO).toString());
        message.voter !== undefined && (obj.voter = message.voter);
        message.option !== undefined && (obj.option = (0, $911d924dc11f762c$exports.voteOptionToJSON)(message.option));
        message.metadata !== undefined && (obj.metadata = message.metadata);
        message.exec !== undefined && (obj.exec = $18c75608456c13f7$var$execToJSON(message.exec));
        return obj;
    },
    fromPartial (object) {
        const message = $18c75608456c13f7$var$createBaseMsgVote();
        message.proposalId = object.proposalId !== undefined && object.proposalId !== null ? $d5e07fe2518aae94$exports.Long.fromValue(object.proposalId) : $d5e07fe2518aae94$exports.Long.UZERO;
        message.voter = object.voter ?? "";
        message.option = object.option ?? 0;
        message.metadata = object.metadata ?? "";
        message.exec = object.exec ?? 0;
        return message;
    }
};
function $18c75608456c13f7$var$createBaseMsgVoteResponse() {
    return {};
}
$18c75608456c13f7$exports.MsgVoteResponse = {
    encode (_, writer = $18c75608456c13f7$var$_m0.Writer.create()) {
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $18c75608456c13f7$var$_m0.Reader ? input : new $18c75608456c13f7$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $18c75608456c13f7$var$createBaseMsgVoteResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            tag;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON (_) {
        return {};
    },
    toJSON (_) {
        const obj = {};
        return obj;
    },
    fromPartial (_) {
        const message = $18c75608456c13f7$var$createBaseMsgVoteResponse();
        return message;
    }
};
function $18c75608456c13f7$var$createBaseMsgExec() {
    return {
        proposalId: $d5e07fe2518aae94$exports.Long.UZERO,
        executor: ""
    };
}
$18c75608456c13f7$exports.MsgExec = {
    encode (message, writer = $18c75608456c13f7$var$_m0.Writer.create()) {
        if (!message.proposalId.isZero()) writer.uint32(8).uint64(message.proposalId);
        if (message.executor !== "") writer.uint32(18).string(message.executor);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $18c75608456c13f7$var$_m0.Reader ? input : new $18c75608456c13f7$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $18c75608456c13f7$var$createBaseMsgExec();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.proposalId = reader.uint64();
                    break;
                case 2:
                    message.executor = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            proposalId: (0, $d5e07fe2518aae94$exports.isSet)(object.proposalId) ? $d5e07fe2518aae94$exports.Long.fromValue(object.proposalId) : $d5e07fe2518aae94$exports.Long.UZERO,
            executor: (0, $d5e07fe2518aae94$exports.isSet)(object.executor) ? String(object.executor) : ""
        };
    },
    toJSON (message) {
        const obj = {};
        message.proposalId !== undefined && (obj.proposalId = (message.proposalId || $d5e07fe2518aae94$exports.Long.UZERO).toString());
        message.executor !== undefined && (obj.executor = message.executor);
        return obj;
    },
    fromPartial (object) {
        const message = $18c75608456c13f7$var$createBaseMsgExec();
        message.proposalId = object.proposalId !== undefined && object.proposalId !== null ? $d5e07fe2518aae94$exports.Long.fromValue(object.proposalId) : $d5e07fe2518aae94$exports.Long.UZERO;
        message.executor = object.executor ?? "";
        return message;
    }
};
function $18c75608456c13f7$var$createBaseMsgExecResponse() {
    return {
        result: 0
    };
}
$18c75608456c13f7$exports.MsgExecResponse = {
    encode (message, writer = $18c75608456c13f7$var$_m0.Writer.create()) {
        if (message.result !== 0) writer.uint32(16).int32(message.result);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $18c75608456c13f7$var$_m0.Reader ? input : new $18c75608456c13f7$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $18c75608456c13f7$var$createBaseMsgExecResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 2:
                    message.result = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            result: (0, $d5e07fe2518aae94$exports.isSet)(object.result) ? (0, $911d924dc11f762c$exports.proposalExecutorResultFromJSON)(object.result) : 0
        };
    },
    toJSON (message) {
        const obj = {};
        message.result !== undefined && (obj.result = (0, $911d924dc11f762c$exports.proposalExecutorResultToJSON)(message.result));
        return obj;
    },
    fromPartial (object) {
        const message = $18c75608456c13f7$var$createBaseMsgExecResponse();
        message.result = object.result ?? 0;
        return message;
    }
};
function $18c75608456c13f7$var$createBaseMsgLeaveGroup() {
    return {
        address: "",
        groupId: $d5e07fe2518aae94$exports.Long.UZERO
    };
}
$18c75608456c13f7$exports.MsgLeaveGroup = {
    encode (message, writer = $18c75608456c13f7$var$_m0.Writer.create()) {
        if (message.address !== "") writer.uint32(10).string(message.address);
        if (!message.groupId.isZero()) writer.uint32(16).uint64(message.groupId);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $18c75608456c13f7$var$_m0.Reader ? input : new $18c75608456c13f7$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $18c75608456c13f7$var$createBaseMsgLeaveGroup();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.address = reader.string();
                    break;
                case 2:
                    message.groupId = reader.uint64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            address: (0, $d5e07fe2518aae94$exports.isSet)(object.address) ? String(object.address) : "",
            groupId: (0, $d5e07fe2518aae94$exports.isSet)(object.groupId) ? $d5e07fe2518aae94$exports.Long.fromValue(object.groupId) : $d5e07fe2518aae94$exports.Long.UZERO
        };
    },
    toJSON (message) {
        const obj = {};
        message.address !== undefined && (obj.address = message.address);
        message.groupId !== undefined && (obj.groupId = (message.groupId || $d5e07fe2518aae94$exports.Long.UZERO).toString());
        return obj;
    },
    fromPartial (object) {
        const message = $18c75608456c13f7$var$createBaseMsgLeaveGroup();
        message.address = object.address ?? "";
        message.groupId = object.groupId !== undefined && object.groupId !== null ? $d5e07fe2518aae94$exports.Long.fromValue(object.groupId) : $d5e07fe2518aae94$exports.Long.UZERO;
        return message;
    }
};
function $18c75608456c13f7$var$createBaseMsgLeaveGroupResponse() {
    return {};
}
$18c75608456c13f7$exports.MsgLeaveGroupResponse = {
    encode (_, writer = $18c75608456c13f7$var$_m0.Writer.create()) {
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $18c75608456c13f7$var$_m0.Reader ? input : new $18c75608456c13f7$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $18c75608456c13f7$var$createBaseMsgLeaveGroupResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            tag;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON (_) {
        return {};
    },
    toJSON (_) {
        const obj = {};
        return obj;
    },
    fromPartial (_) {
        const message = $18c75608456c13f7$var$createBaseMsgLeaveGroupResponse();
        return message;
    }
};
class $18c75608456c13f7$var$MsgClientImpl {
    constructor(rpc){
        this.rpc = rpc;
        this.CreateGroup = this.CreateGroup.bind(this);
        this.UpdateGroupMembers = this.UpdateGroupMembers.bind(this);
        this.UpdateGroupAdmin = this.UpdateGroupAdmin.bind(this);
        this.UpdateGroupMetadata = this.UpdateGroupMetadata.bind(this);
        this.CreateGroupPolicy = this.CreateGroupPolicy.bind(this);
        this.CreateGroupWithPolicy = this.CreateGroupWithPolicy.bind(this);
        this.UpdateGroupPolicyAdmin = this.UpdateGroupPolicyAdmin.bind(this);
        this.UpdateGroupPolicyDecisionPolicy = this.UpdateGroupPolicyDecisionPolicy.bind(this);
        this.UpdateGroupPolicyMetadata = this.UpdateGroupPolicyMetadata.bind(this);
        this.SubmitProposal = this.SubmitProposal.bind(this);
        this.WithdrawProposal = this.WithdrawProposal.bind(this);
        this.Vote = this.Vote.bind(this);
        this.Exec = this.Exec.bind(this);
        this.LeaveGroup = this.LeaveGroup.bind(this);
    }
    CreateGroup(request) {
        const data = $18c75608456c13f7$exports.MsgCreateGroup.encode(request).finish();
        const promise = this.rpc.request("cosmos.group.v1.Msg", "CreateGroup", data);
        return promise.then((data)=>$18c75608456c13f7$exports.MsgCreateGroupResponse.decode(new $18c75608456c13f7$var$_m0.Reader(data)));
    }
    UpdateGroupMembers(request) {
        const data = $18c75608456c13f7$exports.MsgUpdateGroupMembers.encode(request).finish();
        const promise = this.rpc.request("cosmos.group.v1.Msg", "UpdateGroupMembers", data);
        return promise.then((data)=>$18c75608456c13f7$exports.MsgUpdateGroupMembersResponse.decode(new $18c75608456c13f7$var$_m0.Reader(data)));
    }
    UpdateGroupAdmin(request) {
        const data = $18c75608456c13f7$exports.MsgUpdateGroupAdmin.encode(request).finish();
        const promise = this.rpc.request("cosmos.group.v1.Msg", "UpdateGroupAdmin", data);
        return promise.then((data)=>$18c75608456c13f7$exports.MsgUpdateGroupAdminResponse.decode(new $18c75608456c13f7$var$_m0.Reader(data)));
    }
    UpdateGroupMetadata(request) {
        const data = $18c75608456c13f7$exports.MsgUpdateGroupMetadata.encode(request).finish();
        const promise = this.rpc.request("cosmos.group.v1.Msg", "UpdateGroupMetadata", data);
        return promise.then((data)=>$18c75608456c13f7$exports.MsgUpdateGroupMetadataResponse.decode(new $18c75608456c13f7$var$_m0.Reader(data)));
    }
    CreateGroupPolicy(request) {
        const data = $18c75608456c13f7$exports.MsgCreateGroupPolicy.encode(request).finish();
        const promise = this.rpc.request("cosmos.group.v1.Msg", "CreateGroupPolicy", data);
        return promise.then((data)=>$18c75608456c13f7$exports.MsgCreateGroupPolicyResponse.decode(new $18c75608456c13f7$var$_m0.Reader(data)));
    }
    CreateGroupWithPolicy(request) {
        const data = $18c75608456c13f7$exports.MsgCreateGroupWithPolicy.encode(request).finish();
        const promise = this.rpc.request("cosmos.group.v1.Msg", "CreateGroupWithPolicy", data);
        return promise.then((data)=>$18c75608456c13f7$exports.MsgCreateGroupWithPolicyResponse.decode(new $18c75608456c13f7$var$_m0.Reader(data)));
    }
    UpdateGroupPolicyAdmin(request) {
        const data = $18c75608456c13f7$exports.MsgUpdateGroupPolicyAdmin.encode(request).finish();
        const promise = this.rpc.request("cosmos.group.v1.Msg", "UpdateGroupPolicyAdmin", data);
        return promise.then((data)=>$18c75608456c13f7$exports.MsgUpdateGroupPolicyAdminResponse.decode(new $18c75608456c13f7$var$_m0.Reader(data)));
    }
    UpdateGroupPolicyDecisionPolicy(request) {
        const data = $18c75608456c13f7$exports.MsgUpdateGroupPolicyDecisionPolicy.encode(request).finish();
        const promise = this.rpc.request("cosmos.group.v1.Msg", "UpdateGroupPolicyDecisionPolicy", data);
        return promise.then((data)=>$18c75608456c13f7$exports.MsgUpdateGroupPolicyDecisionPolicyResponse.decode(new $18c75608456c13f7$var$_m0.Reader(data)));
    }
    UpdateGroupPolicyMetadata(request) {
        const data = $18c75608456c13f7$exports.MsgUpdateGroupPolicyMetadata.encode(request).finish();
        const promise = this.rpc.request("cosmos.group.v1.Msg", "UpdateGroupPolicyMetadata", data);
        return promise.then((data)=>$18c75608456c13f7$exports.MsgUpdateGroupPolicyMetadataResponse.decode(new $18c75608456c13f7$var$_m0.Reader(data)));
    }
    SubmitProposal(request) {
        const data = $18c75608456c13f7$exports.MsgSubmitProposal.encode(request).finish();
        const promise = this.rpc.request("cosmos.group.v1.Msg", "SubmitProposal", data);
        return promise.then((data)=>$18c75608456c13f7$exports.MsgSubmitProposalResponse.decode(new $18c75608456c13f7$var$_m0.Reader(data)));
    }
    WithdrawProposal(request) {
        const data = $18c75608456c13f7$exports.MsgWithdrawProposal.encode(request).finish();
        const promise = this.rpc.request("cosmos.group.v1.Msg", "WithdrawProposal", data);
        return promise.then((data)=>$18c75608456c13f7$exports.MsgWithdrawProposalResponse.decode(new $18c75608456c13f7$var$_m0.Reader(data)));
    }
    Vote(request) {
        const data = $18c75608456c13f7$exports.MsgVote.encode(request).finish();
        const promise = this.rpc.request("cosmos.group.v1.Msg", "Vote", data);
        return promise.then((data)=>$18c75608456c13f7$exports.MsgVoteResponse.decode(new $18c75608456c13f7$var$_m0.Reader(data)));
    }
    Exec(request) {
        const data = $18c75608456c13f7$exports.MsgExec.encode(request).finish();
        const promise = this.rpc.request("cosmos.group.v1.Msg", "Exec", data);
        return promise.then((data)=>$18c75608456c13f7$exports.MsgExecResponse.decode(new $18c75608456c13f7$var$_m0.Reader(data)));
    }
    LeaveGroup(request) {
        const data = $18c75608456c13f7$exports.MsgLeaveGroup.encode(request).finish();
        const promise = this.rpc.request("cosmos.group.v1.Msg", "LeaveGroup", data);
        return promise.then((data)=>$18c75608456c13f7$exports.MsgLeaveGroupResponse.decode(new $18c75608456c13f7$var$_m0.Reader(data)));
    }
}
$18c75608456c13f7$exports.MsgClientImpl = $18c75608456c13f7$var$MsgClientImpl;


$c6fd43db5b1c9915$exports.groupTypes = [
    [
        "/cosmos.group.v1.MsgCreateGroup",
        $18c75608456c13f7$exports.MsgCreateGroup
    ],
    [
        "/cosmos.group.v1.MsgCreateGroupPolicy",
        $18c75608456c13f7$exports.MsgCreateGroupPolicy
    ],
    [
        "/cosmos.group.v1.MsgCreateGroupWithPolicy",
        $18c75608456c13f7$exports.MsgCreateGroupWithPolicy
    ],
    [
        "/cosmos.group.v1.MsgExec",
        $18c75608456c13f7$exports.MsgExec
    ],
    [
        "/cosmos.group.v1.MsgLeaveGroup",
        $18c75608456c13f7$exports.MsgLeaveGroup
    ],
    [
        "/cosmos.group.v1.MsgSubmitProposal",
        $18c75608456c13f7$exports.MsgSubmitProposal
    ],
    [
        "/cosmos.group.v1.MsgUpdateGroupAdmin",
        $18c75608456c13f7$exports.MsgUpdateGroupAdmin
    ],
    [
        "/cosmos.group.v1.MsgUpdateGroupMembers",
        $18c75608456c13f7$exports.MsgUpdateGroupMembers
    ],
    [
        "/cosmos.group.v1.MsgUpdateGroupMetadata",
        $18c75608456c13f7$exports.MsgUpdateGroupMetadata
    ],
    [
        "/cosmos.group.v1.MsgUpdateGroupPolicyAdmin",
        $18c75608456c13f7$exports.MsgUpdateGroupPolicyAdmin
    ],
    [
        "/cosmos.group.v1.MsgUpdateGroupPolicyDecisionPolicy",
        $18c75608456c13f7$exports.MsgUpdateGroupPolicyDecisionPolicy
    ],
    [
        "/cosmos.group.v1.MsgUpdateGroupPolicyMetadata",
        $18c75608456c13f7$exports.MsgUpdateGroupPolicyMetadata
    ],
    [
        "/cosmos.group.v1.MsgVote",
        $18c75608456c13f7$exports.MsgVote
    ],
    [
        "/cosmos.group.v1.MsgWithdrawProposal",
        $18c75608456c13f7$exports.MsgWithdrawProposal
    ]
]; // There are no EncodeObject implementations for the new v1 message types because
 // those things don't scale (https://github.com/cosmos/cosmjs/issues/1440). We need to
 // address this more fundamentally. Users can use
 // const msg = {
 //   typeUrl: "/cosmos.group.v1.MsgCreateGroup",
 //   value: MsgCreateGroup.fromPartial({ ... })
 // }
 // in their app.


Object.defineProperty($d0d8b6f4712acd9f$exports, "groupTypes", {
    enumerable: true,
    get: function() {
        return $c6fd43db5b1c9915$exports.groupTypes;
    }
});
var $5571164df7100031$exports = {};
"use strict";
var $5571164df7100031$var$__importDefault = $5571164df7100031$exports && $5571164df7100031$exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty($5571164df7100031$exports, "__esModule", {
    value: true
});
$5571164df7100031$exports.createIbcAminoConverters = $5571164df7100031$exports.isAminoMsgTransfer = void 0;
var $32d2cb55dc1dc5c5$exports = {};
"use strict";
var $32d2cb55dc1dc5c5$var$__createBinding = $32d2cb55dc1dc5c5$exports && $32d2cb55dc1dc5c5$exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $32d2cb55dc1dc5c5$var$__setModuleDefault = $32d2cb55dc1dc5c5$exports && $32d2cb55dc1dc5c5$exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $32d2cb55dc1dc5c5$var$__importStar = $32d2cb55dc1dc5c5$exports && $32d2cb55dc1dc5c5$exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $32d2cb55dc1dc5c5$var$__createBinding(result, mod, k);
    }
    $32d2cb55dc1dc5c5$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty($32d2cb55dc1dc5c5$exports, "__esModule", {
    value: true
});
$32d2cb55dc1dc5c5$exports.MsgClientImpl = $32d2cb55dc1dc5c5$exports.MsgTransferResponse = $32d2cb55dc1dc5c5$exports.MsgTransfer = $32d2cb55dc1dc5c5$exports.protobufPackage = void 0;

var $7d28e43a1e22112f$exports = {};
"use strict";
var $7d28e43a1e22112f$var$__createBinding = $7d28e43a1e22112f$exports && $7d28e43a1e22112f$exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $7d28e43a1e22112f$var$__setModuleDefault = $7d28e43a1e22112f$exports && $7d28e43a1e22112f$exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $7d28e43a1e22112f$var$__importStar = $7d28e43a1e22112f$exports && $7d28e43a1e22112f$exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $7d28e43a1e22112f$var$__createBinding(result, mod, k);
    }
    $7d28e43a1e22112f$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty($7d28e43a1e22112f$exports, "__esModule", {
    value: true
});
$7d28e43a1e22112f$exports.Params = $7d28e43a1e22112f$exports.Height = $7d28e43a1e22112f$exports.UpgradeProposal = $7d28e43a1e22112f$exports.ClientUpdateProposal = $7d28e43a1e22112f$exports.ClientConsensusStates = $7d28e43a1e22112f$exports.ConsensusStateWithHeight = $7d28e43a1e22112f$exports.IdentifiedClientState = $7d28e43a1e22112f$exports.protobufPackage = void 0;

var $bd0291c9879d2267$exports = {};
"use strict";
var $bd0291c9879d2267$var$__createBinding = $bd0291c9879d2267$exports && $bd0291c9879d2267$exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $bd0291c9879d2267$var$__setModuleDefault = $bd0291c9879d2267$exports && $bd0291c9879d2267$exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $bd0291c9879d2267$var$__importStar = $bd0291c9879d2267$exports && $bd0291c9879d2267$exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $bd0291c9879d2267$var$__createBinding(result, mod, k);
    }
    $bd0291c9879d2267$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty($bd0291c9879d2267$exports, "__esModule", {
    value: true
});
$bd0291c9879d2267$exports.ModuleVersion = $bd0291c9879d2267$exports.CancelSoftwareUpgradeProposal = $bd0291c9879d2267$exports.SoftwareUpgradeProposal = $bd0291c9879d2267$exports.Plan = $bd0291c9879d2267$exports.protobufPackage = void 0;




const $bd0291c9879d2267$var$_m0 = $bd0291c9879d2267$var$__importStar((parcelRequire("fQBv0")));
$bd0291c9879d2267$exports.protobufPackage = "cosmos.upgrade.v1beta1";
function $bd0291c9879d2267$var$createBasePlan() {
    return {
        name: "",
        time: undefined,
        height: $d5e07fe2518aae94$exports.Long.ZERO,
        info: "",
        upgradedClientState: undefined
    };
}
$bd0291c9879d2267$exports.Plan = {
    encode (message, writer = $bd0291c9879d2267$var$_m0.Writer.create()) {
        if (message.name !== "") writer.uint32(10).string(message.name);
        if (message.time !== undefined) $e7eaeedc85b414fc$exports.Timestamp.encode(message.time, writer.uint32(18).fork()).ldelim();
        if (!message.height.isZero()) writer.uint32(24).int64(message.height);
        if (message.info !== "") writer.uint32(34).string(message.info);
        if (message.upgradedClientState !== undefined) $64138e590dcf0cc1$exports.Any.encode(message.upgradedClientState, writer.uint32(42).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $bd0291c9879d2267$var$_m0.Reader ? input : new $bd0291c9879d2267$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $bd0291c9879d2267$var$createBasePlan();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.name = reader.string();
                    break;
                case 2:
                    message.time = $e7eaeedc85b414fc$exports.Timestamp.decode(reader, reader.uint32());
                    break;
                case 3:
                    message.height = reader.int64();
                    break;
                case 4:
                    message.info = reader.string();
                    break;
                case 5:
                    message.upgradedClientState = $64138e590dcf0cc1$exports.Any.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            name: (0, $d5e07fe2518aae94$exports.isSet)(object.name) ? String(object.name) : "",
            time: (0, $d5e07fe2518aae94$exports.isSet)(object.time) ? (0, $d5e07fe2518aae94$exports.fromJsonTimestamp)(object.time) : undefined,
            height: (0, $d5e07fe2518aae94$exports.isSet)(object.height) ? $d5e07fe2518aae94$exports.Long.fromValue(object.height) : $d5e07fe2518aae94$exports.Long.ZERO,
            info: (0, $d5e07fe2518aae94$exports.isSet)(object.info) ? String(object.info) : "",
            upgradedClientState: (0, $d5e07fe2518aae94$exports.isSet)(object.upgradedClientState) ? $64138e590dcf0cc1$exports.Any.fromJSON(object.upgradedClientState) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.name !== undefined && (obj.name = message.name);
        message.time !== undefined && (obj.time = (0, $d5e07fe2518aae94$exports.fromTimestamp)(message.time).toISOString());
        message.height !== undefined && (obj.height = (message.height || $d5e07fe2518aae94$exports.Long.ZERO).toString());
        message.info !== undefined && (obj.info = message.info);
        message.upgradedClientState !== undefined && (obj.upgradedClientState = message.upgradedClientState ? $64138e590dcf0cc1$exports.Any.toJSON(message.upgradedClientState) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $bd0291c9879d2267$var$createBasePlan();
        message.name = object.name ?? "";
        message.time = object.time !== undefined && object.time !== null ? $e7eaeedc85b414fc$exports.Timestamp.fromPartial(object.time) : undefined;
        message.height = object.height !== undefined && object.height !== null ? $d5e07fe2518aae94$exports.Long.fromValue(object.height) : $d5e07fe2518aae94$exports.Long.ZERO;
        message.info = object.info ?? "";
        message.upgradedClientState = object.upgradedClientState !== undefined && object.upgradedClientState !== null ? $64138e590dcf0cc1$exports.Any.fromPartial(object.upgradedClientState) : undefined;
        return message;
    }
};
function $bd0291c9879d2267$var$createBaseSoftwareUpgradeProposal() {
    return {
        title: "",
        description: "",
        plan: undefined
    };
}
$bd0291c9879d2267$exports.SoftwareUpgradeProposal = {
    encode (message, writer = $bd0291c9879d2267$var$_m0.Writer.create()) {
        if (message.title !== "") writer.uint32(10).string(message.title);
        if (message.description !== "") writer.uint32(18).string(message.description);
        if (message.plan !== undefined) $bd0291c9879d2267$exports.Plan.encode(message.plan, writer.uint32(26).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $bd0291c9879d2267$var$_m0.Reader ? input : new $bd0291c9879d2267$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $bd0291c9879d2267$var$createBaseSoftwareUpgradeProposal();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.title = reader.string();
                    break;
                case 2:
                    message.description = reader.string();
                    break;
                case 3:
                    message.plan = $bd0291c9879d2267$exports.Plan.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            title: (0, $d5e07fe2518aae94$exports.isSet)(object.title) ? String(object.title) : "",
            description: (0, $d5e07fe2518aae94$exports.isSet)(object.description) ? String(object.description) : "",
            plan: (0, $d5e07fe2518aae94$exports.isSet)(object.plan) ? $bd0291c9879d2267$exports.Plan.fromJSON(object.plan) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.title !== undefined && (obj.title = message.title);
        message.description !== undefined && (obj.description = message.description);
        message.plan !== undefined && (obj.plan = message.plan ? $bd0291c9879d2267$exports.Plan.toJSON(message.plan) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $bd0291c9879d2267$var$createBaseSoftwareUpgradeProposal();
        message.title = object.title ?? "";
        message.description = object.description ?? "";
        message.plan = object.plan !== undefined && object.plan !== null ? $bd0291c9879d2267$exports.Plan.fromPartial(object.plan) : undefined;
        return message;
    }
};
function $bd0291c9879d2267$var$createBaseCancelSoftwareUpgradeProposal() {
    return {
        title: "",
        description: ""
    };
}
$bd0291c9879d2267$exports.CancelSoftwareUpgradeProposal = {
    encode (message, writer = $bd0291c9879d2267$var$_m0.Writer.create()) {
        if (message.title !== "") writer.uint32(10).string(message.title);
        if (message.description !== "") writer.uint32(18).string(message.description);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $bd0291c9879d2267$var$_m0.Reader ? input : new $bd0291c9879d2267$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $bd0291c9879d2267$var$createBaseCancelSoftwareUpgradeProposal();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.title = reader.string();
                    break;
                case 2:
                    message.description = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            title: (0, $d5e07fe2518aae94$exports.isSet)(object.title) ? String(object.title) : "",
            description: (0, $d5e07fe2518aae94$exports.isSet)(object.description) ? String(object.description) : ""
        };
    },
    toJSON (message) {
        const obj = {};
        message.title !== undefined && (obj.title = message.title);
        message.description !== undefined && (obj.description = message.description);
        return obj;
    },
    fromPartial (object) {
        const message = $bd0291c9879d2267$var$createBaseCancelSoftwareUpgradeProposal();
        message.title = object.title ?? "";
        message.description = object.description ?? "";
        return message;
    }
};
function $bd0291c9879d2267$var$createBaseModuleVersion() {
    return {
        name: "",
        version: $d5e07fe2518aae94$exports.Long.UZERO
    };
}
$bd0291c9879d2267$exports.ModuleVersion = {
    encode (message, writer = $bd0291c9879d2267$var$_m0.Writer.create()) {
        if (message.name !== "") writer.uint32(10).string(message.name);
        if (!message.version.isZero()) writer.uint32(16).uint64(message.version);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $bd0291c9879d2267$var$_m0.Reader ? input : new $bd0291c9879d2267$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $bd0291c9879d2267$var$createBaseModuleVersion();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.name = reader.string();
                    break;
                case 2:
                    message.version = reader.uint64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            name: (0, $d5e07fe2518aae94$exports.isSet)(object.name) ? String(object.name) : "",
            version: (0, $d5e07fe2518aae94$exports.isSet)(object.version) ? $d5e07fe2518aae94$exports.Long.fromValue(object.version) : $d5e07fe2518aae94$exports.Long.UZERO
        };
    },
    toJSON (message) {
        const obj = {};
        message.name !== undefined && (obj.name = message.name);
        message.version !== undefined && (obj.version = (message.version || $d5e07fe2518aae94$exports.Long.UZERO).toString());
        return obj;
    },
    fromPartial (object) {
        const message = $bd0291c9879d2267$var$createBaseModuleVersion();
        message.name = object.name ?? "";
        message.version = object.version !== undefined && object.version !== null ? $d5e07fe2518aae94$exports.Long.fromValue(object.version) : $d5e07fe2518aae94$exports.Long.UZERO;
        return message;
    }
};




const $7d28e43a1e22112f$var$_m0 = $7d28e43a1e22112f$var$__importStar((parcelRequire("fQBv0")));
$7d28e43a1e22112f$exports.protobufPackage = "ibc.core.client.v1";
function $7d28e43a1e22112f$var$createBaseIdentifiedClientState() {
    return {
        clientId: "",
        clientState: undefined
    };
}
$7d28e43a1e22112f$exports.IdentifiedClientState = {
    encode (message, writer = $7d28e43a1e22112f$var$_m0.Writer.create()) {
        if (message.clientId !== "") writer.uint32(10).string(message.clientId);
        if (message.clientState !== undefined) $64138e590dcf0cc1$exports.Any.encode(message.clientState, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $7d28e43a1e22112f$var$_m0.Reader ? input : new $7d28e43a1e22112f$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $7d28e43a1e22112f$var$createBaseIdentifiedClientState();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.clientId = reader.string();
                    break;
                case 2:
                    message.clientState = $64138e590dcf0cc1$exports.Any.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            clientId: (0, $d5e07fe2518aae94$exports.isSet)(object.clientId) ? String(object.clientId) : "",
            clientState: (0, $d5e07fe2518aae94$exports.isSet)(object.clientState) ? $64138e590dcf0cc1$exports.Any.fromJSON(object.clientState) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.clientId !== undefined && (obj.clientId = message.clientId);
        message.clientState !== undefined && (obj.clientState = message.clientState ? $64138e590dcf0cc1$exports.Any.toJSON(message.clientState) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $7d28e43a1e22112f$var$createBaseIdentifiedClientState();
        message.clientId = object.clientId ?? "";
        message.clientState = object.clientState !== undefined && object.clientState !== null ? $64138e590dcf0cc1$exports.Any.fromPartial(object.clientState) : undefined;
        return message;
    }
};
function $7d28e43a1e22112f$var$createBaseConsensusStateWithHeight() {
    return {
        height: undefined,
        consensusState: undefined
    };
}
$7d28e43a1e22112f$exports.ConsensusStateWithHeight = {
    encode (message, writer = $7d28e43a1e22112f$var$_m0.Writer.create()) {
        if (message.height !== undefined) $7d28e43a1e22112f$exports.Height.encode(message.height, writer.uint32(10).fork()).ldelim();
        if (message.consensusState !== undefined) $64138e590dcf0cc1$exports.Any.encode(message.consensusState, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $7d28e43a1e22112f$var$_m0.Reader ? input : new $7d28e43a1e22112f$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $7d28e43a1e22112f$var$createBaseConsensusStateWithHeight();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.height = $7d28e43a1e22112f$exports.Height.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.consensusState = $64138e590dcf0cc1$exports.Any.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            height: (0, $d5e07fe2518aae94$exports.isSet)(object.height) ? $7d28e43a1e22112f$exports.Height.fromJSON(object.height) : undefined,
            consensusState: (0, $d5e07fe2518aae94$exports.isSet)(object.consensusState) ? $64138e590dcf0cc1$exports.Any.fromJSON(object.consensusState) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.height !== undefined && (obj.height = message.height ? $7d28e43a1e22112f$exports.Height.toJSON(message.height) : undefined);
        message.consensusState !== undefined && (obj.consensusState = message.consensusState ? $64138e590dcf0cc1$exports.Any.toJSON(message.consensusState) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $7d28e43a1e22112f$var$createBaseConsensusStateWithHeight();
        message.height = object.height !== undefined && object.height !== null ? $7d28e43a1e22112f$exports.Height.fromPartial(object.height) : undefined;
        message.consensusState = object.consensusState !== undefined && object.consensusState !== null ? $64138e590dcf0cc1$exports.Any.fromPartial(object.consensusState) : undefined;
        return message;
    }
};
function $7d28e43a1e22112f$var$createBaseClientConsensusStates() {
    return {
        clientId: "",
        consensusStates: []
    };
}
$7d28e43a1e22112f$exports.ClientConsensusStates = {
    encode (message, writer = $7d28e43a1e22112f$var$_m0.Writer.create()) {
        if (message.clientId !== "") writer.uint32(10).string(message.clientId);
        for (const v of message.consensusStates)$7d28e43a1e22112f$exports.ConsensusStateWithHeight.encode(v, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $7d28e43a1e22112f$var$_m0.Reader ? input : new $7d28e43a1e22112f$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $7d28e43a1e22112f$var$createBaseClientConsensusStates();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.clientId = reader.string();
                    break;
                case 2:
                    message.consensusStates.push($7d28e43a1e22112f$exports.ConsensusStateWithHeight.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            clientId: (0, $d5e07fe2518aae94$exports.isSet)(object.clientId) ? String(object.clientId) : "",
            consensusStates: Array.isArray(object?.consensusStates) ? object.consensusStates.map((e)=>$7d28e43a1e22112f$exports.ConsensusStateWithHeight.fromJSON(e)) : []
        };
    },
    toJSON (message) {
        const obj = {};
        message.clientId !== undefined && (obj.clientId = message.clientId);
        if (message.consensusStates) obj.consensusStates = message.consensusStates.map((e)=>e ? $7d28e43a1e22112f$exports.ConsensusStateWithHeight.toJSON(e) : undefined);
        else obj.consensusStates = [];
        return obj;
    },
    fromPartial (object) {
        const message = $7d28e43a1e22112f$var$createBaseClientConsensusStates();
        message.clientId = object.clientId ?? "";
        message.consensusStates = object.consensusStates?.map((e)=>$7d28e43a1e22112f$exports.ConsensusStateWithHeight.fromPartial(e)) || [];
        return message;
    }
};
function $7d28e43a1e22112f$var$createBaseClientUpdateProposal() {
    return {
        title: "",
        description: "",
        subjectClientId: "",
        substituteClientId: ""
    };
}
$7d28e43a1e22112f$exports.ClientUpdateProposal = {
    encode (message, writer = $7d28e43a1e22112f$var$_m0.Writer.create()) {
        if (message.title !== "") writer.uint32(10).string(message.title);
        if (message.description !== "") writer.uint32(18).string(message.description);
        if (message.subjectClientId !== "") writer.uint32(26).string(message.subjectClientId);
        if (message.substituteClientId !== "") writer.uint32(34).string(message.substituteClientId);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $7d28e43a1e22112f$var$_m0.Reader ? input : new $7d28e43a1e22112f$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $7d28e43a1e22112f$var$createBaseClientUpdateProposal();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.title = reader.string();
                    break;
                case 2:
                    message.description = reader.string();
                    break;
                case 3:
                    message.subjectClientId = reader.string();
                    break;
                case 4:
                    message.substituteClientId = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            title: (0, $d5e07fe2518aae94$exports.isSet)(object.title) ? String(object.title) : "",
            description: (0, $d5e07fe2518aae94$exports.isSet)(object.description) ? String(object.description) : "",
            subjectClientId: (0, $d5e07fe2518aae94$exports.isSet)(object.subjectClientId) ? String(object.subjectClientId) : "",
            substituteClientId: (0, $d5e07fe2518aae94$exports.isSet)(object.substituteClientId) ? String(object.substituteClientId) : ""
        };
    },
    toJSON (message) {
        const obj = {};
        message.title !== undefined && (obj.title = message.title);
        message.description !== undefined && (obj.description = message.description);
        message.subjectClientId !== undefined && (obj.subjectClientId = message.subjectClientId);
        message.substituteClientId !== undefined && (obj.substituteClientId = message.substituteClientId);
        return obj;
    },
    fromPartial (object) {
        const message = $7d28e43a1e22112f$var$createBaseClientUpdateProposal();
        message.title = object.title ?? "";
        message.description = object.description ?? "";
        message.subjectClientId = object.subjectClientId ?? "";
        message.substituteClientId = object.substituteClientId ?? "";
        return message;
    }
};
function $7d28e43a1e22112f$var$createBaseUpgradeProposal() {
    return {
        title: "",
        description: "",
        plan: undefined,
        upgradedClientState: undefined
    };
}
$7d28e43a1e22112f$exports.UpgradeProposal = {
    encode (message, writer = $7d28e43a1e22112f$var$_m0.Writer.create()) {
        if (message.title !== "") writer.uint32(10).string(message.title);
        if (message.description !== "") writer.uint32(18).string(message.description);
        if (message.plan !== undefined) $bd0291c9879d2267$exports.Plan.encode(message.plan, writer.uint32(26).fork()).ldelim();
        if (message.upgradedClientState !== undefined) $64138e590dcf0cc1$exports.Any.encode(message.upgradedClientState, writer.uint32(34).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $7d28e43a1e22112f$var$_m0.Reader ? input : new $7d28e43a1e22112f$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $7d28e43a1e22112f$var$createBaseUpgradeProposal();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.title = reader.string();
                    break;
                case 2:
                    message.description = reader.string();
                    break;
                case 3:
                    message.plan = $bd0291c9879d2267$exports.Plan.decode(reader, reader.uint32());
                    break;
                case 4:
                    message.upgradedClientState = $64138e590dcf0cc1$exports.Any.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            title: (0, $d5e07fe2518aae94$exports.isSet)(object.title) ? String(object.title) : "",
            description: (0, $d5e07fe2518aae94$exports.isSet)(object.description) ? String(object.description) : "",
            plan: (0, $d5e07fe2518aae94$exports.isSet)(object.plan) ? $bd0291c9879d2267$exports.Plan.fromJSON(object.plan) : undefined,
            upgradedClientState: (0, $d5e07fe2518aae94$exports.isSet)(object.upgradedClientState) ? $64138e590dcf0cc1$exports.Any.fromJSON(object.upgradedClientState) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.title !== undefined && (obj.title = message.title);
        message.description !== undefined && (obj.description = message.description);
        message.plan !== undefined && (obj.plan = message.plan ? $bd0291c9879d2267$exports.Plan.toJSON(message.plan) : undefined);
        message.upgradedClientState !== undefined && (obj.upgradedClientState = message.upgradedClientState ? $64138e590dcf0cc1$exports.Any.toJSON(message.upgradedClientState) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $7d28e43a1e22112f$var$createBaseUpgradeProposal();
        message.title = object.title ?? "";
        message.description = object.description ?? "";
        message.plan = object.plan !== undefined && object.plan !== null ? $bd0291c9879d2267$exports.Plan.fromPartial(object.plan) : undefined;
        message.upgradedClientState = object.upgradedClientState !== undefined && object.upgradedClientState !== null ? $64138e590dcf0cc1$exports.Any.fromPartial(object.upgradedClientState) : undefined;
        return message;
    }
};
function $7d28e43a1e22112f$var$createBaseHeight() {
    return {
        revisionNumber: $d5e07fe2518aae94$exports.Long.UZERO,
        revisionHeight: $d5e07fe2518aae94$exports.Long.UZERO
    };
}
$7d28e43a1e22112f$exports.Height = {
    encode (message, writer = $7d28e43a1e22112f$var$_m0.Writer.create()) {
        if (!message.revisionNumber.isZero()) writer.uint32(8).uint64(message.revisionNumber);
        if (!message.revisionHeight.isZero()) writer.uint32(16).uint64(message.revisionHeight);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $7d28e43a1e22112f$var$_m0.Reader ? input : new $7d28e43a1e22112f$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $7d28e43a1e22112f$var$createBaseHeight();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.revisionNumber = reader.uint64();
                    break;
                case 2:
                    message.revisionHeight = reader.uint64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            revisionNumber: (0, $d5e07fe2518aae94$exports.isSet)(object.revisionNumber) ? $d5e07fe2518aae94$exports.Long.fromValue(object.revisionNumber) : $d5e07fe2518aae94$exports.Long.UZERO,
            revisionHeight: (0, $d5e07fe2518aae94$exports.isSet)(object.revisionHeight) ? $d5e07fe2518aae94$exports.Long.fromValue(object.revisionHeight) : $d5e07fe2518aae94$exports.Long.UZERO
        };
    },
    toJSON (message) {
        const obj = {};
        message.revisionNumber !== undefined && (obj.revisionNumber = (message.revisionNumber || $d5e07fe2518aae94$exports.Long.UZERO).toString());
        message.revisionHeight !== undefined && (obj.revisionHeight = (message.revisionHeight || $d5e07fe2518aae94$exports.Long.UZERO).toString());
        return obj;
    },
    fromPartial (object) {
        const message = $7d28e43a1e22112f$var$createBaseHeight();
        message.revisionNumber = object.revisionNumber !== undefined && object.revisionNumber !== null ? $d5e07fe2518aae94$exports.Long.fromValue(object.revisionNumber) : $d5e07fe2518aae94$exports.Long.UZERO;
        message.revisionHeight = object.revisionHeight !== undefined && object.revisionHeight !== null ? $d5e07fe2518aae94$exports.Long.fromValue(object.revisionHeight) : $d5e07fe2518aae94$exports.Long.UZERO;
        return message;
    }
};
function $7d28e43a1e22112f$var$createBaseParams() {
    return {
        allowedClients: []
    };
}
$7d28e43a1e22112f$exports.Params = {
    encode (message, writer = $7d28e43a1e22112f$var$_m0.Writer.create()) {
        for (const v of message.allowedClients)writer.uint32(10).string(v);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $7d28e43a1e22112f$var$_m0.Reader ? input : new $7d28e43a1e22112f$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $7d28e43a1e22112f$var$createBaseParams();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.allowedClients.push(reader.string());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            allowedClients: Array.isArray(object?.allowedClients) ? object.allowedClients.map((e)=>String(e)) : []
        };
    },
    toJSON (message) {
        const obj = {};
        if (message.allowedClients) obj.allowedClients = message.allowedClients.map((e)=>e);
        else obj.allowedClients = [];
        return obj;
    },
    fromPartial (object) {
        const message = $7d28e43a1e22112f$var$createBaseParams();
        message.allowedClients = object.allowedClients?.map((e)=>e) || [];
        return message;
    }
};




const $32d2cb55dc1dc5c5$var$_m0 = $32d2cb55dc1dc5c5$var$__importStar((parcelRequire("fQBv0")));
$32d2cb55dc1dc5c5$exports.protobufPackage = "ibc.applications.transfer.v1";
function $32d2cb55dc1dc5c5$var$createBaseMsgTransfer() {
    return {
        sourcePort: "",
        sourceChannel: "",
        token: undefined,
        sender: "",
        receiver: "",
        timeoutHeight: undefined,
        timeoutTimestamp: $d5e07fe2518aae94$exports.Long.UZERO,
        memo: ""
    };
}
$32d2cb55dc1dc5c5$exports.MsgTransfer = {
    encode (message, writer = $32d2cb55dc1dc5c5$var$_m0.Writer.create()) {
        if (message.sourcePort !== "") writer.uint32(10).string(message.sourcePort);
        if (message.sourceChannel !== "") writer.uint32(18).string(message.sourceChannel);
        if (message.token !== undefined) $783dd8715fde0fcf$exports.Coin.encode(message.token, writer.uint32(26).fork()).ldelim();
        if (message.sender !== "") writer.uint32(34).string(message.sender);
        if (message.receiver !== "") writer.uint32(42).string(message.receiver);
        if (message.timeoutHeight !== undefined) $7d28e43a1e22112f$exports.Height.encode(message.timeoutHeight, writer.uint32(50).fork()).ldelim();
        if (!message.timeoutTimestamp.isZero()) writer.uint32(56).uint64(message.timeoutTimestamp);
        if (message.memo !== "") writer.uint32(66).string(message.memo);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $32d2cb55dc1dc5c5$var$_m0.Reader ? input : new $32d2cb55dc1dc5c5$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $32d2cb55dc1dc5c5$var$createBaseMsgTransfer();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.sourcePort = reader.string();
                    break;
                case 2:
                    message.sourceChannel = reader.string();
                    break;
                case 3:
                    message.token = $783dd8715fde0fcf$exports.Coin.decode(reader, reader.uint32());
                    break;
                case 4:
                    message.sender = reader.string();
                    break;
                case 5:
                    message.receiver = reader.string();
                    break;
                case 6:
                    message.timeoutHeight = $7d28e43a1e22112f$exports.Height.decode(reader, reader.uint32());
                    break;
                case 7:
                    message.timeoutTimestamp = reader.uint64();
                    break;
                case 8:
                    message.memo = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            sourcePort: (0, $d5e07fe2518aae94$exports.isSet)(object.sourcePort) ? String(object.sourcePort) : "",
            sourceChannel: (0, $d5e07fe2518aae94$exports.isSet)(object.sourceChannel) ? String(object.sourceChannel) : "",
            token: (0, $d5e07fe2518aae94$exports.isSet)(object.token) ? $783dd8715fde0fcf$exports.Coin.fromJSON(object.token) : undefined,
            sender: (0, $d5e07fe2518aae94$exports.isSet)(object.sender) ? String(object.sender) : "",
            receiver: (0, $d5e07fe2518aae94$exports.isSet)(object.receiver) ? String(object.receiver) : "",
            timeoutHeight: (0, $d5e07fe2518aae94$exports.isSet)(object.timeoutHeight) ? $7d28e43a1e22112f$exports.Height.fromJSON(object.timeoutHeight) : undefined,
            timeoutTimestamp: (0, $d5e07fe2518aae94$exports.isSet)(object.timeoutTimestamp) ? $d5e07fe2518aae94$exports.Long.fromValue(object.timeoutTimestamp) : $d5e07fe2518aae94$exports.Long.UZERO,
            memo: (0, $d5e07fe2518aae94$exports.isSet)(object.memo) ? String(object.memo) : ""
        };
    },
    toJSON (message) {
        const obj = {};
        message.sourcePort !== undefined && (obj.sourcePort = message.sourcePort);
        message.sourceChannel !== undefined && (obj.sourceChannel = message.sourceChannel);
        message.token !== undefined && (obj.token = message.token ? $783dd8715fde0fcf$exports.Coin.toJSON(message.token) : undefined);
        message.sender !== undefined && (obj.sender = message.sender);
        message.receiver !== undefined && (obj.receiver = message.receiver);
        message.timeoutHeight !== undefined && (obj.timeoutHeight = message.timeoutHeight ? $7d28e43a1e22112f$exports.Height.toJSON(message.timeoutHeight) : undefined);
        message.timeoutTimestamp !== undefined && (obj.timeoutTimestamp = (message.timeoutTimestamp || $d5e07fe2518aae94$exports.Long.UZERO).toString());
        message.memo !== undefined && (obj.memo = message.memo);
        return obj;
    },
    fromPartial (object) {
        const message = $32d2cb55dc1dc5c5$var$createBaseMsgTransfer();
        message.sourcePort = object.sourcePort ?? "";
        message.sourceChannel = object.sourceChannel ?? "";
        message.token = object.token !== undefined && object.token !== null ? $783dd8715fde0fcf$exports.Coin.fromPartial(object.token) : undefined;
        message.sender = object.sender ?? "";
        message.receiver = object.receiver ?? "";
        message.timeoutHeight = object.timeoutHeight !== undefined && object.timeoutHeight !== null ? $7d28e43a1e22112f$exports.Height.fromPartial(object.timeoutHeight) : undefined;
        message.timeoutTimestamp = object.timeoutTimestamp !== undefined && object.timeoutTimestamp !== null ? $d5e07fe2518aae94$exports.Long.fromValue(object.timeoutTimestamp) : $d5e07fe2518aae94$exports.Long.UZERO;
        message.memo = object.memo ?? "";
        return message;
    }
};
function $32d2cb55dc1dc5c5$var$createBaseMsgTransferResponse() {
    return {
        sequence: $d5e07fe2518aae94$exports.Long.UZERO
    };
}
$32d2cb55dc1dc5c5$exports.MsgTransferResponse = {
    encode (message, writer = $32d2cb55dc1dc5c5$var$_m0.Writer.create()) {
        if (!message.sequence.isZero()) writer.uint32(8).uint64(message.sequence);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $32d2cb55dc1dc5c5$var$_m0.Reader ? input : new $32d2cb55dc1dc5c5$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $32d2cb55dc1dc5c5$var$createBaseMsgTransferResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.sequence = reader.uint64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            sequence: (0, $d5e07fe2518aae94$exports.isSet)(object.sequence) ? $d5e07fe2518aae94$exports.Long.fromValue(object.sequence) : $d5e07fe2518aae94$exports.Long.UZERO
        };
    },
    toJSON (message) {
        const obj = {};
        message.sequence !== undefined && (obj.sequence = (message.sequence || $d5e07fe2518aae94$exports.Long.UZERO).toString());
        return obj;
    },
    fromPartial (object) {
        const message = $32d2cb55dc1dc5c5$var$createBaseMsgTransferResponse();
        message.sequence = object.sequence !== undefined && object.sequence !== null ? $d5e07fe2518aae94$exports.Long.fromValue(object.sequence) : $d5e07fe2518aae94$exports.Long.UZERO;
        return message;
    }
};
class $32d2cb55dc1dc5c5$var$MsgClientImpl {
    constructor(rpc){
        this.rpc = rpc;
        this.Transfer = this.Transfer.bind(this);
    }
    Transfer(request) {
        const data = $32d2cb55dc1dc5c5$exports.MsgTransfer.encode(request).finish();
        const promise = this.rpc.request("ibc.applications.transfer.v1.Msg", "Transfer", data);
        return promise.then((data)=>$32d2cb55dc1dc5c5$exports.MsgTransferResponse.decode(new $32d2cb55dc1dc5c5$var$_m0.Reader(data)));
    }
}
$32d2cb55dc1dc5c5$exports.MsgClientImpl = $32d2cb55dc1dc5c5$var$MsgClientImpl;



const $5571164df7100031$var$long_1 = $5571164df7100031$var$__importDefault((parcelRequire("jRkuS")));
function $5571164df7100031$var$isAminoMsgTransfer(msg) {
    return msg.type === "cosmos-sdk/MsgTransfer";
}
$5571164df7100031$exports.isAminoMsgTransfer = $5571164df7100031$var$isAminoMsgTransfer;
function $5571164df7100031$var$omitDefault(input) {
    if (typeof input === "string") return input === "" ? undefined : input;
    if (typeof input === "number") return input === 0 ? undefined : input;
    if ($5571164df7100031$var$long_1.default.isLong(input)) return input.isZero() ? undefined : input;
    throw new Error(`Got unsupported type '${typeof input}'`);
}
function $5571164df7100031$var$createIbcAminoConverters() {
    return {
        "/ibc.applications.transfer.v1.MsgTransfer": {
            aminoType: "cosmos-sdk/MsgTransfer",
            toAmino: ({ sourcePort: sourcePort, sourceChannel: sourceChannel, token: token, sender: sender, receiver: receiver, timeoutHeight: timeoutHeight, timeoutTimestamp: timeoutTimestamp, memo: memo })=>({
                    source_port: sourcePort,
                    source_channel: sourceChannel,
                    token: token,
                    sender: sender,
                    receiver: receiver,
                    timeout_height: timeoutHeight ? {
                        revision_height: $5571164df7100031$var$omitDefault(timeoutHeight.revisionHeight)?.toString(),
                        revision_number: $5571164df7100031$var$omitDefault(timeoutHeight.revisionNumber)?.toString()
                    } : {},
                    timeout_timestamp: $5571164df7100031$var$omitDefault(timeoutTimestamp)?.toString(),
                    memo: $5571164df7100031$var$omitDefault(memo)?.toString()
                }),
            fromAmino: ({ source_port: source_port, source_channel: source_channel, token: token, sender: sender, receiver: receiver, timeout_height: timeout_height, timeout_timestamp: timeout_timestamp, memo: memo })=>$32d2cb55dc1dc5c5$exports.MsgTransfer.fromPartial({
                    sourcePort: source_port,
                    sourceChannel: source_channel,
                    token: token,
                    sender: sender,
                    receiver: receiver,
                    timeoutHeight: timeout_height ? {
                        revisionHeight: $5571164df7100031$var$long_1.default.fromString(timeout_height.revision_height || "0", true),
                        revisionNumber: $5571164df7100031$var$long_1.default.fromString(timeout_height.revision_number || "0", true)
                    } : undefined,
                    timeoutTimestamp: $5571164df7100031$var$long_1.default.fromString(timeout_timestamp || "0", true),
                    memo: memo ?? ""
                })
        }
    };
}
$5571164df7100031$exports.createIbcAminoConverters = $5571164df7100031$var$createIbcAminoConverters;


Object.defineProperty($d0d8b6f4712acd9f$exports, "createIbcAminoConverters", {
    enumerable: true,
    get: function() {
        return $5571164df7100031$exports.createIbcAminoConverters;
    }
});
Object.defineProperty($d0d8b6f4712acd9f$exports, "isAminoMsgTransfer", {
    enumerable: true,
    get: function() {
        return $5571164df7100031$exports.isAminoMsgTransfer;
    }
});
var $7ac416bc955857ec$exports = {};
"use strict";
Object.defineProperty($7ac416bc955857ec$exports, "__esModule", {
    value: true
});
$7ac416bc955857ec$exports.isMsgTransferEncodeObject = $7ac416bc955857ec$exports.ibcTypes = void 0;

var $ce17e6d84c94872c$exports = {};
"use strict";
var $ce17e6d84c94872c$var$__createBinding = $ce17e6d84c94872c$exports && $ce17e6d84c94872c$exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $ce17e6d84c94872c$var$__setModuleDefault = $ce17e6d84c94872c$exports && $ce17e6d84c94872c$exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $ce17e6d84c94872c$var$__importStar = $ce17e6d84c94872c$exports && $ce17e6d84c94872c$exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $ce17e6d84c94872c$var$__createBinding(result, mod, k);
    }
    $ce17e6d84c94872c$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty($ce17e6d84c94872c$exports, "__esModule", {
    value: true
});
$ce17e6d84c94872c$exports.MsgClientImpl = $ce17e6d84c94872c$exports.MsgAcknowledgementResponse = $ce17e6d84c94872c$exports.MsgAcknowledgement = $ce17e6d84c94872c$exports.MsgTimeoutOnCloseResponse = $ce17e6d84c94872c$exports.MsgTimeoutOnClose = $ce17e6d84c94872c$exports.MsgTimeoutResponse = $ce17e6d84c94872c$exports.MsgTimeout = $ce17e6d84c94872c$exports.MsgRecvPacketResponse = $ce17e6d84c94872c$exports.MsgRecvPacket = $ce17e6d84c94872c$exports.MsgChannelCloseConfirmResponse = $ce17e6d84c94872c$exports.MsgChannelCloseConfirm = $ce17e6d84c94872c$exports.MsgChannelCloseInitResponse = $ce17e6d84c94872c$exports.MsgChannelCloseInit = $ce17e6d84c94872c$exports.MsgChannelOpenConfirmResponse = $ce17e6d84c94872c$exports.MsgChannelOpenConfirm = $ce17e6d84c94872c$exports.MsgChannelOpenAckResponse = $ce17e6d84c94872c$exports.MsgChannelOpenAck = $ce17e6d84c94872c$exports.MsgChannelOpenTryResponse = $ce17e6d84c94872c$exports.MsgChannelOpenTry = $ce17e6d84c94872c$exports.MsgChannelOpenInitResponse = $ce17e6d84c94872c$exports.MsgChannelOpenInit = $ce17e6d84c94872c$exports.responseResultTypeToJSON = $ce17e6d84c94872c$exports.responseResultTypeFromJSON = $ce17e6d84c94872c$exports.ResponseResultType = $ce17e6d84c94872c$exports.protobufPackage = void 0;
var $e21f9e7cb16364b7$exports = {};
"use strict";
var $e21f9e7cb16364b7$var$__createBinding = $e21f9e7cb16364b7$exports && $e21f9e7cb16364b7$exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $e21f9e7cb16364b7$var$__setModuleDefault = $e21f9e7cb16364b7$exports && $e21f9e7cb16364b7$exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $e21f9e7cb16364b7$var$__importStar = $e21f9e7cb16364b7$exports && $e21f9e7cb16364b7$exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $e21f9e7cb16364b7$var$__createBinding(result, mod, k);
    }
    $e21f9e7cb16364b7$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty($e21f9e7cb16364b7$exports, "__esModule", {
    value: true
});
$e21f9e7cb16364b7$exports.Acknowledgement = $e21f9e7cb16364b7$exports.PacketId = $e21f9e7cb16364b7$exports.PacketState = $e21f9e7cb16364b7$exports.Packet = $e21f9e7cb16364b7$exports.Counterparty = $e21f9e7cb16364b7$exports.IdentifiedChannel = $e21f9e7cb16364b7$exports.Channel = $e21f9e7cb16364b7$exports.orderToJSON = $e21f9e7cb16364b7$exports.orderFromJSON = $e21f9e7cb16364b7$exports.Order = $e21f9e7cb16364b7$exports.stateToJSON = $e21f9e7cb16364b7$exports.stateFromJSON = $e21f9e7cb16364b7$exports.State = $e21f9e7cb16364b7$exports.protobufPackage = void 0;



const $e21f9e7cb16364b7$var$_m0 = $e21f9e7cb16364b7$var$__importStar((parcelRequire("fQBv0")));
$e21f9e7cb16364b7$exports.protobufPackage = "ibc.core.channel.v1";
/**
 * State defines if a channel is in one of the following states:
 * CLOSED, INIT, TRYOPEN, OPEN or UNINITIALIZED.
 */ var $e21f9e7cb16364b7$var$State;
(function(State) {
    /** STATE_UNINITIALIZED_UNSPECIFIED - Default State */ State[State["STATE_UNINITIALIZED_UNSPECIFIED"] = 0] = "STATE_UNINITIALIZED_UNSPECIFIED";
    /** STATE_INIT - A channel has just started the opening handshake. */ State[State["STATE_INIT"] = 1] = "STATE_INIT";
    /** STATE_TRYOPEN - A channel has acknowledged the handshake step on the counterparty chain. */ State[State["STATE_TRYOPEN"] = 2] = "STATE_TRYOPEN";
    /**
     * STATE_OPEN - A channel has completed the handshake. Open channels are
     * ready to send and receive packets.
     */ State[State["STATE_OPEN"] = 3] = "STATE_OPEN";
    /**
     * STATE_CLOSED - A channel has been closed and can no longer be used to send or receive
     * packets.
     */ State[State["STATE_CLOSED"] = 4] = "STATE_CLOSED";
    State[State["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})($e21f9e7cb16364b7$var$State = $e21f9e7cb16364b7$exports.State || ($e21f9e7cb16364b7$exports.State = {}));
function $e21f9e7cb16364b7$var$stateFromJSON(object) {
    switch(object){
        case 0:
        case "STATE_UNINITIALIZED_UNSPECIFIED":
            return $e21f9e7cb16364b7$var$State.STATE_UNINITIALIZED_UNSPECIFIED;
        case 1:
        case "STATE_INIT":
            return $e21f9e7cb16364b7$var$State.STATE_INIT;
        case 2:
        case "STATE_TRYOPEN":
            return $e21f9e7cb16364b7$var$State.STATE_TRYOPEN;
        case 3:
        case "STATE_OPEN":
            return $e21f9e7cb16364b7$var$State.STATE_OPEN;
        case 4:
        case "STATE_CLOSED":
            return $e21f9e7cb16364b7$var$State.STATE_CLOSED;
        case -1:
        case "UNRECOGNIZED":
        default:
            return $e21f9e7cb16364b7$var$State.UNRECOGNIZED;
    }
}
$e21f9e7cb16364b7$exports.stateFromJSON = $e21f9e7cb16364b7$var$stateFromJSON;
function $e21f9e7cb16364b7$var$stateToJSON(object) {
    switch(object){
        case $e21f9e7cb16364b7$var$State.STATE_UNINITIALIZED_UNSPECIFIED:
            return "STATE_UNINITIALIZED_UNSPECIFIED";
        case $e21f9e7cb16364b7$var$State.STATE_INIT:
            return "STATE_INIT";
        case $e21f9e7cb16364b7$var$State.STATE_TRYOPEN:
            return "STATE_TRYOPEN";
        case $e21f9e7cb16364b7$var$State.STATE_OPEN:
            return "STATE_OPEN";
        case $e21f9e7cb16364b7$var$State.STATE_CLOSED:
            return "STATE_CLOSED";
        case $e21f9e7cb16364b7$var$State.UNRECOGNIZED:
        default:
            return "UNRECOGNIZED";
    }
}
$e21f9e7cb16364b7$exports.stateToJSON = $e21f9e7cb16364b7$var$stateToJSON;
/** Order defines if a channel is ORDERED or UNORDERED */ var $e21f9e7cb16364b7$var$Order;
(function(Order) {
    /** ORDER_NONE_UNSPECIFIED - zero-value for channel ordering */ Order[Order["ORDER_NONE_UNSPECIFIED"] = 0] = "ORDER_NONE_UNSPECIFIED";
    /**
     * ORDER_UNORDERED - packets can be delivered in any order, which may differ from the order in
     * which they were sent.
     */ Order[Order["ORDER_UNORDERED"] = 1] = "ORDER_UNORDERED";
    /** ORDER_ORDERED - packets are delivered exactly in the order which they were sent */ Order[Order["ORDER_ORDERED"] = 2] = "ORDER_ORDERED";
    Order[Order["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})($e21f9e7cb16364b7$var$Order = $e21f9e7cb16364b7$exports.Order || ($e21f9e7cb16364b7$exports.Order = {}));
function $e21f9e7cb16364b7$var$orderFromJSON(object) {
    switch(object){
        case 0:
        case "ORDER_NONE_UNSPECIFIED":
            return $e21f9e7cb16364b7$var$Order.ORDER_NONE_UNSPECIFIED;
        case 1:
        case "ORDER_UNORDERED":
            return $e21f9e7cb16364b7$var$Order.ORDER_UNORDERED;
        case 2:
        case "ORDER_ORDERED":
            return $e21f9e7cb16364b7$var$Order.ORDER_ORDERED;
        case -1:
        case "UNRECOGNIZED":
        default:
            return $e21f9e7cb16364b7$var$Order.UNRECOGNIZED;
    }
}
$e21f9e7cb16364b7$exports.orderFromJSON = $e21f9e7cb16364b7$var$orderFromJSON;
function $e21f9e7cb16364b7$var$orderToJSON(object) {
    switch(object){
        case $e21f9e7cb16364b7$var$Order.ORDER_NONE_UNSPECIFIED:
            return "ORDER_NONE_UNSPECIFIED";
        case $e21f9e7cb16364b7$var$Order.ORDER_UNORDERED:
            return "ORDER_UNORDERED";
        case $e21f9e7cb16364b7$var$Order.ORDER_ORDERED:
            return "ORDER_ORDERED";
        case $e21f9e7cb16364b7$var$Order.UNRECOGNIZED:
        default:
            return "UNRECOGNIZED";
    }
}
$e21f9e7cb16364b7$exports.orderToJSON = $e21f9e7cb16364b7$var$orderToJSON;
function $e21f9e7cb16364b7$var$createBaseChannel() {
    return {
        state: 0,
        ordering: 0,
        counterparty: undefined,
        connectionHops: [],
        version: ""
    };
}
$e21f9e7cb16364b7$exports.Channel = {
    encode (message, writer = $e21f9e7cb16364b7$var$_m0.Writer.create()) {
        if (message.state !== 0) writer.uint32(8).int32(message.state);
        if (message.ordering !== 0) writer.uint32(16).int32(message.ordering);
        if (message.counterparty !== undefined) $e21f9e7cb16364b7$exports.Counterparty.encode(message.counterparty, writer.uint32(26).fork()).ldelim();
        for (const v of message.connectionHops)writer.uint32(34).string(v);
        if (message.version !== "") writer.uint32(42).string(message.version);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $e21f9e7cb16364b7$var$_m0.Reader ? input : new $e21f9e7cb16364b7$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $e21f9e7cb16364b7$var$createBaseChannel();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.state = reader.int32();
                    break;
                case 2:
                    message.ordering = reader.int32();
                    break;
                case 3:
                    message.counterparty = $e21f9e7cb16364b7$exports.Counterparty.decode(reader, reader.uint32());
                    break;
                case 4:
                    message.connectionHops.push(reader.string());
                    break;
                case 5:
                    message.version = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            state: (0, $d5e07fe2518aae94$exports.isSet)(object.state) ? $e21f9e7cb16364b7$var$stateFromJSON(object.state) : 0,
            ordering: (0, $d5e07fe2518aae94$exports.isSet)(object.ordering) ? $e21f9e7cb16364b7$var$orderFromJSON(object.ordering) : 0,
            counterparty: (0, $d5e07fe2518aae94$exports.isSet)(object.counterparty) ? $e21f9e7cb16364b7$exports.Counterparty.fromJSON(object.counterparty) : undefined,
            connectionHops: Array.isArray(object?.connectionHops) ? object.connectionHops.map((e)=>String(e)) : [],
            version: (0, $d5e07fe2518aae94$exports.isSet)(object.version) ? String(object.version) : ""
        };
    },
    toJSON (message) {
        const obj = {};
        message.state !== undefined && (obj.state = $e21f9e7cb16364b7$var$stateToJSON(message.state));
        message.ordering !== undefined && (obj.ordering = $e21f9e7cb16364b7$var$orderToJSON(message.ordering));
        message.counterparty !== undefined && (obj.counterparty = message.counterparty ? $e21f9e7cb16364b7$exports.Counterparty.toJSON(message.counterparty) : undefined);
        if (message.connectionHops) obj.connectionHops = message.connectionHops.map((e)=>e);
        else obj.connectionHops = [];
        message.version !== undefined && (obj.version = message.version);
        return obj;
    },
    fromPartial (object) {
        const message = $e21f9e7cb16364b7$var$createBaseChannel();
        message.state = object.state ?? 0;
        message.ordering = object.ordering ?? 0;
        message.counterparty = object.counterparty !== undefined && object.counterparty !== null ? $e21f9e7cb16364b7$exports.Counterparty.fromPartial(object.counterparty) : undefined;
        message.connectionHops = object.connectionHops?.map((e)=>e) || [];
        message.version = object.version ?? "";
        return message;
    }
};
function $e21f9e7cb16364b7$var$createBaseIdentifiedChannel() {
    return {
        state: 0,
        ordering: 0,
        counterparty: undefined,
        connectionHops: [],
        version: "",
        portId: "",
        channelId: ""
    };
}
$e21f9e7cb16364b7$exports.IdentifiedChannel = {
    encode (message, writer = $e21f9e7cb16364b7$var$_m0.Writer.create()) {
        if (message.state !== 0) writer.uint32(8).int32(message.state);
        if (message.ordering !== 0) writer.uint32(16).int32(message.ordering);
        if (message.counterparty !== undefined) $e21f9e7cb16364b7$exports.Counterparty.encode(message.counterparty, writer.uint32(26).fork()).ldelim();
        for (const v of message.connectionHops)writer.uint32(34).string(v);
        if (message.version !== "") writer.uint32(42).string(message.version);
        if (message.portId !== "") writer.uint32(50).string(message.portId);
        if (message.channelId !== "") writer.uint32(58).string(message.channelId);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $e21f9e7cb16364b7$var$_m0.Reader ? input : new $e21f9e7cb16364b7$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $e21f9e7cb16364b7$var$createBaseIdentifiedChannel();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.state = reader.int32();
                    break;
                case 2:
                    message.ordering = reader.int32();
                    break;
                case 3:
                    message.counterparty = $e21f9e7cb16364b7$exports.Counterparty.decode(reader, reader.uint32());
                    break;
                case 4:
                    message.connectionHops.push(reader.string());
                    break;
                case 5:
                    message.version = reader.string();
                    break;
                case 6:
                    message.portId = reader.string();
                    break;
                case 7:
                    message.channelId = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            state: (0, $d5e07fe2518aae94$exports.isSet)(object.state) ? $e21f9e7cb16364b7$var$stateFromJSON(object.state) : 0,
            ordering: (0, $d5e07fe2518aae94$exports.isSet)(object.ordering) ? $e21f9e7cb16364b7$var$orderFromJSON(object.ordering) : 0,
            counterparty: (0, $d5e07fe2518aae94$exports.isSet)(object.counterparty) ? $e21f9e7cb16364b7$exports.Counterparty.fromJSON(object.counterparty) : undefined,
            connectionHops: Array.isArray(object?.connectionHops) ? object.connectionHops.map((e)=>String(e)) : [],
            version: (0, $d5e07fe2518aae94$exports.isSet)(object.version) ? String(object.version) : "",
            portId: (0, $d5e07fe2518aae94$exports.isSet)(object.portId) ? String(object.portId) : "",
            channelId: (0, $d5e07fe2518aae94$exports.isSet)(object.channelId) ? String(object.channelId) : ""
        };
    },
    toJSON (message) {
        const obj = {};
        message.state !== undefined && (obj.state = $e21f9e7cb16364b7$var$stateToJSON(message.state));
        message.ordering !== undefined && (obj.ordering = $e21f9e7cb16364b7$var$orderToJSON(message.ordering));
        message.counterparty !== undefined && (obj.counterparty = message.counterparty ? $e21f9e7cb16364b7$exports.Counterparty.toJSON(message.counterparty) : undefined);
        if (message.connectionHops) obj.connectionHops = message.connectionHops.map((e)=>e);
        else obj.connectionHops = [];
        message.version !== undefined && (obj.version = message.version);
        message.portId !== undefined && (obj.portId = message.portId);
        message.channelId !== undefined && (obj.channelId = message.channelId);
        return obj;
    },
    fromPartial (object) {
        const message = $e21f9e7cb16364b7$var$createBaseIdentifiedChannel();
        message.state = object.state ?? 0;
        message.ordering = object.ordering ?? 0;
        message.counterparty = object.counterparty !== undefined && object.counterparty !== null ? $e21f9e7cb16364b7$exports.Counterparty.fromPartial(object.counterparty) : undefined;
        message.connectionHops = object.connectionHops?.map((e)=>e) || [];
        message.version = object.version ?? "";
        message.portId = object.portId ?? "";
        message.channelId = object.channelId ?? "";
        return message;
    }
};
function $e21f9e7cb16364b7$var$createBaseCounterparty() {
    return {
        portId: "",
        channelId: ""
    };
}
$e21f9e7cb16364b7$exports.Counterparty = {
    encode (message, writer = $e21f9e7cb16364b7$var$_m0.Writer.create()) {
        if (message.portId !== "") writer.uint32(10).string(message.portId);
        if (message.channelId !== "") writer.uint32(18).string(message.channelId);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $e21f9e7cb16364b7$var$_m0.Reader ? input : new $e21f9e7cb16364b7$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $e21f9e7cb16364b7$var$createBaseCounterparty();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.portId = reader.string();
                    break;
                case 2:
                    message.channelId = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            portId: (0, $d5e07fe2518aae94$exports.isSet)(object.portId) ? String(object.portId) : "",
            channelId: (0, $d5e07fe2518aae94$exports.isSet)(object.channelId) ? String(object.channelId) : ""
        };
    },
    toJSON (message) {
        const obj = {};
        message.portId !== undefined && (obj.portId = message.portId);
        message.channelId !== undefined && (obj.channelId = message.channelId);
        return obj;
    },
    fromPartial (object) {
        const message = $e21f9e7cb16364b7$var$createBaseCounterparty();
        message.portId = object.portId ?? "";
        message.channelId = object.channelId ?? "";
        return message;
    }
};
function $e21f9e7cb16364b7$var$createBasePacket() {
    return {
        sequence: $d5e07fe2518aae94$exports.Long.UZERO,
        sourcePort: "",
        sourceChannel: "",
        destinationPort: "",
        destinationChannel: "",
        data: new Uint8Array(),
        timeoutHeight: undefined,
        timeoutTimestamp: $d5e07fe2518aae94$exports.Long.UZERO
    };
}
$e21f9e7cb16364b7$exports.Packet = {
    encode (message, writer = $e21f9e7cb16364b7$var$_m0.Writer.create()) {
        if (!message.sequence.isZero()) writer.uint32(8).uint64(message.sequence);
        if (message.sourcePort !== "") writer.uint32(18).string(message.sourcePort);
        if (message.sourceChannel !== "") writer.uint32(26).string(message.sourceChannel);
        if (message.destinationPort !== "") writer.uint32(34).string(message.destinationPort);
        if (message.destinationChannel !== "") writer.uint32(42).string(message.destinationChannel);
        if (message.data.length !== 0) writer.uint32(50).bytes(message.data);
        if (message.timeoutHeight !== undefined) $7d28e43a1e22112f$exports.Height.encode(message.timeoutHeight, writer.uint32(58).fork()).ldelim();
        if (!message.timeoutTimestamp.isZero()) writer.uint32(64).uint64(message.timeoutTimestamp);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $e21f9e7cb16364b7$var$_m0.Reader ? input : new $e21f9e7cb16364b7$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $e21f9e7cb16364b7$var$createBasePacket();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.sequence = reader.uint64();
                    break;
                case 2:
                    message.sourcePort = reader.string();
                    break;
                case 3:
                    message.sourceChannel = reader.string();
                    break;
                case 4:
                    message.destinationPort = reader.string();
                    break;
                case 5:
                    message.destinationChannel = reader.string();
                    break;
                case 6:
                    message.data = reader.bytes();
                    break;
                case 7:
                    message.timeoutHeight = $7d28e43a1e22112f$exports.Height.decode(reader, reader.uint32());
                    break;
                case 8:
                    message.timeoutTimestamp = reader.uint64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            sequence: (0, $d5e07fe2518aae94$exports.isSet)(object.sequence) ? $d5e07fe2518aae94$exports.Long.fromValue(object.sequence) : $d5e07fe2518aae94$exports.Long.UZERO,
            sourcePort: (0, $d5e07fe2518aae94$exports.isSet)(object.sourcePort) ? String(object.sourcePort) : "",
            sourceChannel: (0, $d5e07fe2518aae94$exports.isSet)(object.sourceChannel) ? String(object.sourceChannel) : "",
            destinationPort: (0, $d5e07fe2518aae94$exports.isSet)(object.destinationPort) ? String(object.destinationPort) : "",
            destinationChannel: (0, $d5e07fe2518aae94$exports.isSet)(object.destinationChannel) ? String(object.destinationChannel) : "",
            data: (0, $d5e07fe2518aae94$exports.isSet)(object.data) ? (0, $d5e07fe2518aae94$exports.bytesFromBase64)(object.data) : new Uint8Array(),
            timeoutHeight: (0, $d5e07fe2518aae94$exports.isSet)(object.timeoutHeight) ? $7d28e43a1e22112f$exports.Height.fromJSON(object.timeoutHeight) : undefined,
            timeoutTimestamp: (0, $d5e07fe2518aae94$exports.isSet)(object.timeoutTimestamp) ? $d5e07fe2518aae94$exports.Long.fromValue(object.timeoutTimestamp) : $d5e07fe2518aae94$exports.Long.UZERO
        };
    },
    toJSON (message) {
        const obj = {};
        message.sequence !== undefined && (obj.sequence = (message.sequence || $d5e07fe2518aae94$exports.Long.UZERO).toString());
        message.sourcePort !== undefined && (obj.sourcePort = message.sourcePort);
        message.sourceChannel !== undefined && (obj.sourceChannel = message.sourceChannel);
        message.destinationPort !== undefined && (obj.destinationPort = message.destinationPort);
        message.destinationChannel !== undefined && (obj.destinationChannel = message.destinationChannel);
        message.data !== undefined && (obj.data = (0, $d5e07fe2518aae94$exports.base64FromBytes)(message.data !== undefined ? message.data : new Uint8Array()));
        message.timeoutHeight !== undefined && (obj.timeoutHeight = message.timeoutHeight ? $7d28e43a1e22112f$exports.Height.toJSON(message.timeoutHeight) : undefined);
        message.timeoutTimestamp !== undefined && (obj.timeoutTimestamp = (message.timeoutTimestamp || $d5e07fe2518aae94$exports.Long.UZERO).toString());
        return obj;
    },
    fromPartial (object) {
        const message = $e21f9e7cb16364b7$var$createBasePacket();
        message.sequence = object.sequence !== undefined && object.sequence !== null ? $d5e07fe2518aae94$exports.Long.fromValue(object.sequence) : $d5e07fe2518aae94$exports.Long.UZERO;
        message.sourcePort = object.sourcePort ?? "";
        message.sourceChannel = object.sourceChannel ?? "";
        message.destinationPort = object.destinationPort ?? "";
        message.destinationChannel = object.destinationChannel ?? "";
        message.data = object.data ?? new Uint8Array();
        message.timeoutHeight = object.timeoutHeight !== undefined && object.timeoutHeight !== null ? $7d28e43a1e22112f$exports.Height.fromPartial(object.timeoutHeight) : undefined;
        message.timeoutTimestamp = object.timeoutTimestamp !== undefined && object.timeoutTimestamp !== null ? $d5e07fe2518aae94$exports.Long.fromValue(object.timeoutTimestamp) : $d5e07fe2518aae94$exports.Long.UZERO;
        return message;
    }
};
function $e21f9e7cb16364b7$var$createBasePacketState() {
    return {
        portId: "",
        channelId: "",
        sequence: $d5e07fe2518aae94$exports.Long.UZERO,
        data: new Uint8Array()
    };
}
$e21f9e7cb16364b7$exports.PacketState = {
    encode (message, writer = $e21f9e7cb16364b7$var$_m0.Writer.create()) {
        if (message.portId !== "") writer.uint32(10).string(message.portId);
        if (message.channelId !== "") writer.uint32(18).string(message.channelId);
        if (!message.sequence.isZero()) writer.uint32(24).uint64(message.sequence);
        if (message.data.length !== 0) writer.uint32(34).bytes(message.data);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $e21f9e7cb16364b7$var$_m0.Reader ? input : new $e21f9e7cb16364b7$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $e21f9e7cb16364b7$var$createBasePacketState();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.portId = reader.string();
                    break;
                case 2:
                    message.channelId = reader.string();
                    break;
                case 3:
                    message.sequence = reader.uint64();
                    break;
                case 4:
                    message.data = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            portId: (0, $d5e07fe2518aae94$exports.isSet)(object.portId) ? String(object.portId) : "",
            channelId: (0, $d5e07fe2518aae94$exports.isSet)(object.channelId) ? String(object.channelId) : "",
            sequence: (0, $d5e07fe2518aae94$exports.isSet)(object.sequence) ? $d5e07fe2518aae94$exports.Long.fromValue(object.sequence) : $d5e07fe2518aae94$exports.Long.UZERO,
            data: (0, $d5e07fe2518aae94$exports.isSet)(object.data) ? (0, $d5e07fe2518aae94$exports.bytesFromBase64)(object.data) : new Uint8Array()
        };
    },
    toJSON (message) {
        const obj = {};
        message.portId !== undefined && (obj.portId = message.portId);
        message.channelId !== undefined && (obj.channelId = message.channelId);
        message.sequence !== undefined && (obj.sequence = (message.sequence || $d5e07fe2518aae94$exports.Long.UZERO).toString());
        message.data !== undefined && (obj.data = (0, $d5e07fe2518aae94$exports.base64FromBytes)(message.data !== undefined ? message.data : new Uint8Array()));
        return obj;
    },
    fromPartial (object) {
        const message = $e21f9e7cb16364b7$var$createBasePacketState();
        message.portId = object.portId ?? "";
        message.channelId = object.channelId ?? "";
        message.sequence = object.sequence !== undefined && object.sequence !== null ? $d5e07fe2518aae94$exports.Long.fromValue(object.sequence) : $d5e07fe2518aae94$exports.Long.UZERO;
        message.data = object.data ?? new Uint8Array();
        return message;
    }
};
function $e21f9e7cb16364b7$var$createBasePacketId() {
    return {
        portId: "",
        channelId: "",
        sequence: $d5e07fe2518aae94$exports.Long.UZERO
    };
}
$e21f9e7cb16364b7$exports.PacketId = {
    encode (message, writer = $e21f9e7cb16364b7$var$_m0.Writer.create()) {
        if (message.portId !== "") writer.uint32(10).string(message.portId);
        if (message.channelId !== "") writer.uint32(18).string(message.channelId);
        if (!message.sequence.isZero()) writer.uint32(24).uint64(message.sequence);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $e21f9e7cb16364b7$var$_m0.Reader ? input : new $e21f9e7cb16364b7$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $e21f9e7cb16364b7$var$createBasePacketId();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.portId = reader.string();
                    break;
                case 2:
                    message.channelId = reader.string();
                    break;
                case 3:
                    message.sequence = reader.uint64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            portId: (0, $d5e07fe2518aae94$exports.isSet)(object.portId) ? String(object.portId) : "",
            channelId: (0, $d5e07fe2518aae94$exports.isSet)(object.channelId) ? String(object.channelId) : "",
            sequence: (0, $d5e07fe2518aae94$exports.isSet)(object.sequence) ? $d5e07fe2518aae94$exports.Long.fromValue(object.sequence) : $d5e07fe2518aae94$exports.Long.UZERO
        };
    },
    toJSON (message) {
        const obj = {};
        message.portId !== undefined && (obj.portId = message.portId);
        message.channelId !== undefined && (obj.channelId = message.channelId);
        message.sequence !== undefined && (obj.sequence = (message.sequence || $d5e07fe2518aae94$exports.Long.UZERO).toString());
        return obj;
    },
    fromPartial (object) {
        const message = $e21f9e7cb16364b7$var$createBasePacketId();
        message.portId = object.portId ?? "";
        message.channelId = object.channelId ?? "";
        message.sequence = object.sequence !== undefined && object.sequence !== null ? $d5e07fe2518aae94$exports.Long.fromValue(object.sequence) : $d5e07fe2518aae94$exports.Long.UZERO;
        return message;
    }
};
function $e21f9e7cb16364b7$var$createBaseAcknowledgement() {
    return {
        result: undefined,
        error: undefined
    };
}
$e21f9e7cb16364b7$exports.Acknowledgement = {
    encode (message, writer = $e21f9e7cb16364b7$var$_m0.Writer.create()) {
        if (message.result !== undefined) writer.uint32(170).bytes(message.result);
        if (message.error !== undefined) writer.uint32(178).string(message.error);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $e21f9e7cb16364b7$var$_m0.Reader ? input : new $e21f9e7cb16364b7$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $e21f9e7cb16364b7$var$createBaseAcknowledgement();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 21:
                    message.result = reader.bytes();
                    break;
                case 22:
                    message.error = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            result: (0, $d5e07fe2518aae94$exports.isSet)(object.result) ? (0, $d5e07fe2518aae94$exports.bytesFromBase64)(object.result) : undefined,
            error: (0, $d5e07fe2518aae94$exports.isSet)(object.error) ? String(object.error) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.result !== undefined && (obj.result = message.result !== undefined ? (0, $d5e07fe2518aae94$exports.base64FromBytes)(message.result) : undefined);
        message.error !== undefined && (obj.error = message.error);
        return obj;
    },
    fromPartial (object) {
        const message = $e21f9e7cb16364b7$var$createBaseAcknowledgement();
        message.result = object.result ?? undefined;
        message.error = object.error ?? undefined;
        return message;
    }
};





const $ce17e6d84c94872c$var$_m0 = $ce17e6d84c94872c$var$__importStar((parcelRequire("fQBv0")));
$ce17e6d84c94872c$exports.protobufPackage = "ibc.core.channel.v1";
/** ResponseResultType defines the possible outcomes of the execution of a message */ var $ce17e6d84c94872c$var$ResponseResultType;
(function(ResponseResultType) {
    /** RESPONSE_RESULT_TYPE_UNSPECIFIED - Default zero value enumeration */ ResponseResultType[ResponseResultType["RESPONSE_RESULT_TYPE_UNSPECIFIED"] = 0] = "RESPONSE_RESULT_TYPE_UNSPECIFIED";
    /** RESPONSE_RESULT_TYPE_NOOP - The message did not call the IBC application callbacks (because, for example, the packet had already been relayed) */ ResponseResultType[ResponseResultType["RESPONSE_RESULT_TYPE_NOOP"] = 1] = "RESPONSE_RESULT_TYPE_NOOP";
    /** RESPONSE_RESULT_TYPE_SUCCESS - The message was executed successfully */ ResponseResultType[ResponseResultType["RESPONSE_RESULT_TYPE_SUCCESS"] = 2] = "RESPONSE_RESULT_TYPE_SUCCESS";
    ResponseResultType[ResponseResultType["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})($ce17e6d84c94872c$var$ResponseResultType = $ce17e6d84c94872c$exports.ResponseResultType || ($ce17e6d84c94872c$exports.ResponseResultType = {}));
function $ce17e6d84c94872c$var$responseResultTypeFromJSON(object) {
    switch(object){
        case 0:
        case "RESPONSE_RESULT_TYPE_UNSPECIFIED":
            return $ce17e6d84c94872c$var$ResponseResultType.RESPONSE_RESULT_TYPE_UNSPECIFIED;
        case 1:
        case "RESPONSE_RESULT_TYPE_NOOP":
            return $ce17e6d84c94872c$var$ResponseResultType.RESPONSE_RESULT_TYPE_NOOP;
        case 2:
        case "RESPONSE_RESULT_TYPE_SUCCESS":
            return $ce17e6d84c94872c$var$ResponseResultType.RESPONSE_RESULT_TYPE_SUCCESS;
        case -1:
        case "UNRECOGNIZED":
        default:
            return $ce17e6d84c94872c$var$ResponseResultType.UNRECOGNIZED;
    }
}
$ce17e6d84c94872c$exports.responseResultTypeFromJSON = $ce17e6d84c94872c$var$responseResultTypeFromJSON;
function $ce17e6d84c94872c$var$responseResultTypeToJSON(object) {
    switch(object){
        case $ce17e6d84c94872c$var$ResponseResultType.RESPONSE_RESULT_TYPE_UNSPECIFIED:
            return "RESPONSE_RESULT_TYPE_UNSPECIFIED";
        case $ce17e6d84c94872c$var$ResponseResultType.RESPONSE_RESULT_TYPE_NOOP:
            return "RESPONSE_RESULT_TYPE_NOOP";
        case $ce17e6d84c94872c$var$ResponseResultType.RESPONSE_RESULT_TYPE_SUCCESS:
            return "RESPONSE_RESULT_TYPE_SUCCESS";
        case $ce17e6d84c94872c$var$ResponseResultType.UNRECOGNIZED:
        default:
            return "UNRECOGNIZED";
    }
}
$ce17e6d84c94872c$exports.responseResultTypeToJSON = $ce17e6d84c94872c$var$responseResultTypeToJSON;
function $ce17e6d84c94872c$var$createBaseMsgChannelOpenInit() {
    return {
        portId: "",
        channel: undefined,
        signer: ""
    };
}
$ce17e6d84c94872c$exports.MsgChannelOpenInit = {
    encode (message, writer = $ce17e6d84c94872c$var$_m0.Writer.create()) {
        if (message.portId !== "") writer.uint32(10).string(message.portId);
        if (message.channel !== undefined) $e21f9e7cb16364b7$exports.Channel.encode(message.channel, writer.uint32(18).fork()).ldelim();
        if (message.signer !== "") writer.uint32(26).string(message.signer);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $ce17e6d84c94872c$var$_m0.Reader ? input : new $ce17e6d84c94872c$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $ce17e6d84c94872c$var$createBaseMsgChannelOpenInit();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.portId = reader.string();
                    break;
                case 2:
                    message.channel = $e21f9e7cb16364b7$exports.Channel.decode(reader, reader.uint32());
                    break;
                case 3:
                    message.signer = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            portId: (0, $d5e07fe2518aae94$exports.isSet)(object.portId) ? String(object.portId) : "",
            channel: (0, $d5e07fe2518aae94$exports.isSet)(object.channel) ? $e21f9e7cb16364b7$exports.Channel.fromJSON(object.channel) : undefined,
            signer: (0, $d5e07fe2518aae94$exports.isSet)(object.signer) ? String(object.signer) : ""
        };
    },
    toJSON (message) {
        const obj = {};
        message.portId !== undefined && (obj.portId = message.portId);
        message.channel !== undefined && (obj.channel = message.channel ? $e21f9e7cb16364b7$exports.Channel.toJSON(message.channel) : undefined);
        message.signer !== undefined && (obj.signer = message.signer);
        return obj;
    },
    fromPartial (object) {
        const message = $ce17e6d84c94872c$var$createBaseMsgChannelOpenInit();
        message.portId = object.portId ?? "";
        message.channel = object.channel !== undefined && object.channel !== null ? $e21f9e7cb16364b7$exports.Channel.fromPartial(object.channel) : undefined;
        message.signer = object.signer ?? "";
        return message;
    }
};
function $ce17e6d84c94872c$var$createBaseMsgChannelOpenInitResponse() {
    return {
        channelId: "",
        version: ""
    };
}
$ce17e6d84c94872c$exports.MsgChannelOpenInitResponse = {
    encode (message, writer = $ce17e6d84c94872c$var$_m0.Writer.create()) {
        if (message.channelId !== "") writer.uint32(10).string(message.channelId);
        if (message.version !== "") writer.uint32(18).string(message.version);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $ce17e6d84c94872c$var$_m0.Reader ? input : new $ce17e6d84c94872c$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $ce17e6d84c94872c$var$createBaseMsgChannelOpenInitResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.channelId = reader.string();
                    break;
                case 2:
                    message.version = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            channelId: (0, $d5e07fe2518aae94$exports.isSet)(object.channelId) ? String(object.channelId) : "",
            version: (0, $d5e07fe2518aae94$exports.isSet)(object.version) ? String(object.version) : ""
        };
    },
    toJSON (message) {
        const obj = {};
        message.channelId !== undefined && (obj.channelId = message.channelId);
        message.version !== undefined && (obj.version = message.version);
        return obj;
    },
    fromPartial (object) {
        const message = $ce17e6d84c94872c$var$createBaseMsgChannelOpenInitResponse();
        message.channelId = object.channelId ?? "";
        message.version = object.version ?? "";
        return message;
    }
};
function $ce17e6d84c94872c$var$createBaseMsgChannelOpenTry() {
    return {
        portId: "",
        previousChannelId: "",
        channel: undefined,
        counterpartyVersion: "",
        proofInit: new Uint8Array(),
        proofHeight: undefined,
        signer: ""
    };
}
$ce17e6d84c94872c$exports.MsgChannelOpenTry = {
    encode (message, writer = $ce17e6d84c94872c$var$_m0.Writer.create()) {
        if (message.portId !== "") writer.uint32(10).string(message.portId);
        if (message.previousChannelId !== "") writer.uint32(18).string(message.previousChannelId);
        if (message.channel !== undefined) $e21f9e7cb16364b7$exports.Channel.encode(message.channel, writer.uint32(26).fork()).ldelim();
        if (message.counterpartyVersion !== "") writer.uint32(34).string(message.counterpartyVersion);
        if (message.proofInit.length !== 0) writer.uint32(42).bytes(message.proofInit);
        if (message.proofHeight !== undefined) $7d28e43a1e22112f$exports.Height.encode(message.proofHeight, writer.uint32(50).fork()).ldelim();
        if (message.signer !== "") writer.uint32(58).string(message.signer);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $ce17e6d84c94872c$var$_m0.Reader ? input : new $ce17e6d84c94872c$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $ce17e6d84c94872c$var$createBaseMsgChannelOpenTry();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.portId = reader.string();
                    break;
                case 2:
                    message.previousChannelId = reader.string();
                    break;
                case 3:
                    message.channel = $e21f9e7cb16364b7$exports.Channel.decode(reader, reader.uint32());
                    break;
                case 4:
                    message.counterpartyVersion = reader.string();
                    break;
                case 5:
                    message.proofInit = reader.bytes();
                    break;
                case 6:
                    message.proofHeight = $7d28e43a1e22112f$exports.Height.decode(reader, reader.uint32());
                    break;
                case 7:
                    message.signer = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            portId: (0, $d5e07fe2518aae94$exports.isSet)(object.portId) ? String(object.portId) : "",
            previousChannelId: (0, $d5e07fe2518aae94$exports.isSet)(object.previousChannelId) ? String(object.previousChannelId) : "",
            channel: (0, $d5e07fe2518aae94$exports.isSet)(object.channel) ? $e21f9e7cb16364b7$exports.Channel.fromJSON(object.channel) : undefined,
            counterpartyVersion: (0, $d5e07fe2518aae94$exports.isSet)(object.counterpartyVersion) ? String(object.counterpartyVersion) : "",
            proofInit: (0, $d5e07fe2518aae94$exports.isSet)(object.proofInit) ? (0, $d5e07fe2518aae94$exports.bytesFromBase64)(object.proofInit) : new Uint8Array(),
            proofHeight: (0, $d5e07fe2518aae94$exports.isSet)(object.proofHeight) ? $7d28e43a1e22112f$exports.Height.fromJSON(object.proofHeight) : undefined,
            signer: (0, $d5e07fe2518aae94$exports.isSet)(object.signer) ? String(object.signer) : ""
        };
    },
    toJSON (message) {
        const obj = {};
        message.portId !== undefined && (obj.portId = message.portId);
        message.previousChannelId !== undefined && (obj.previousChannelId = message.previousChannelId);
        message.channel !== undefined && (obj.channel = message.channel ? $e21f9e7cb16364b7$exports.Channel.toJSON(message.channel) : undefined);
        message.counterpartyVersion !== undefined && (obj.counterpartyVersion = message.counterpartyVersion);
        message.proofInit !== undefined && (obj.proofInit = (0, $d5e07fe2518aae94$exports.base64FromBytes)(message.proofInit !== undefined ? message.proofInit : new Uint8Array()));
        message.proofHeight !== undefined && (obj.proofHeight = message.proofHeight ? $7d28e43a1e22112f$exports.Height.toJSON(message.proofHeight) : undefined);
        message.signer !== undefined && (obj.signer = message.signer);
        return obj;
    },
    fromPartial (object) {
        const message = $ce17e6d84c94872c$var$createBaseMsgChannelOpenTry();
        message.portId = object.portId ?? "";
        message.previousChannelId = object.previousChannelId ?? "";
        message.channel = object.channel !== undefined && object.channel !== null ? $e21f9e7cb16364b7$exports.Channel.fromPartial(object.channel) : undefined;
        message.counterpartyVersion = object.counterpartyVersion ?? "";
        message.proofInit = object.proofInit ?? new Uint8Array();
        message.proofHeight = object.proofHeight !== undefined && object.proofHeight !== null ? $7d28e43a1e22112f$exports.Height.fromPartial(object.proofHeight) : undefined;
        message.signer = object.signer ?? "";
        return message;
    }
};
function $ce17e6d84c94872c$var$createBaseMsgChannelOpenTryResponse() {
    return {
        version: ""
    };
}
$ce17e6d84c94872c$exports.MsgChannelOpenTryResponse = {
    encode (message, writer = $ce17e6d84c94872c$var$_m0.Writer.create()) {
        if (message.version !== "") writer.uint32(10).string(message.version);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $ce17e6d84c94872c$var$_m0.Reader ? input : new $ce17e6d84c94872c$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $ce17e6d84c94872c$var$createBaseMsgChannelOpenTryResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.version = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            version: (0, $d5e07fe2518aae94$exports.isSet)(object.version) ? String(object.version) : ""
        };
    },
    toJSON (message) {
        const obj = {};
        message.version !== undefined && (obj.version = message.version);
        return obj;
    },
    fromPartial (object) {
        const message = $ce17e6d84c94872c$var$createBaseMsgChannelOpenTryResponse();
        message.version = object.version ?? "";
        return message;
    }
};
function $ce17e6d84c94872c$var$createBaseMsgChannelOpenAck() {
    return {
        portId: "",
        channelId: "",
        counterpartyChannelId: "",
        counterpartyVersion: "",
        proofTry: new Uint8Array(),
        proofHeight: undefined,
        signer: ""
    };
}
$ce17e6d84c94872c$exports.MsgChannelOpenAck = {
    encode (message, writer = $ce17e6d84c94872c$var$_m0.Writer.create()) {
        if (message.portId !== "") writer.uint32(10).string(message.portId);
        if (message.channelId !== "") writer.uint32(18).string(message.channelId);
        if (message.counterpartyChannelId !== "") writer.uint32(26).string(message.counterpartyChannelId);
        if (message.counterpartyVersion !== "") writer.uint32(34).string(message.counterpartyVersion);
        if (message.proofTry.length !== 0) writer.uint32(42).bytes(message.proofTry);
        if (message.proofHeight !== undefined) $7d28e43a1e22112f$exports.Height.encode(message.proofHeight, writer.uint32(50).fork()).ldelim();
        if (message.signer !== "") writer.uint32(58).string(message.signer);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $ce17e6d84c94872c$var$_m0.Reader ? input : new $ce17e6d84c94872c$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $ce17e6d84c94872c$var$createBaseMsgChannelOpenAck();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.portId = reader.string();
                    break;
                case 2:
                    message.channelId = reader.string();
                    break;
                case 3:
                    message.counterpartyChannelId = reader.string();
                    break;
                case 4:
                    message.counterpartyVersion = reader.string();
                    break;
                case 5:
                    message.proofTry = reader.bytes();
                    break;
                case 6:
                    message.proofHeight = $7d28e43a1e22112f$exports.Height.decode(reader, reader.uint32());
                    break;
                case 7:
                    message.signer = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            portId: (0, $d5e07fe2518aae94$exports.isSet)(object.portId) ? String(object.portId) : "",
            channelId: (0, $d5e07fe2518aae94$exports.isSet)(object.channelId) ? String(object.channelId) : "",
            counterpartyChannelId: (0, $d5e07fe2518aae94$exports.isSet)(object.counterpartyChannelId) ? String(object.counterpartyChannelId) : "",
            counterpartyVersion: (0, $d5e07fe2518aae94$exports.isSet)(object.counterpartyVersion) ? String(object.counterpartyVersion) : "",
            proofTry: (0, $d5e07fe2518aae94$exports.isSet)(object.proofTry) ? (0, $d5e07fe2518aae94$exports.bytesFromBase64)(object.proofTry) : new Uint8Array(),
            proofHeight: (0, $d5e07fe2518aae94$exports.isSet)(object.proofHeight) ? $7d28e43a1e22112f$exports.Height.fromJSON(object.proofHeight) : undefined,
            signer: (0, $d5e07fe2518aae94$exports.isSet)(object.signer) ? String(object.signer) : ""
        };
    },
    toJSON (message) {
        const obj = {};
        message.portId !== undefined && (obj.portId = message.portId);
        message.channelId !== undefined && (obj.channelId = message.channelId);
        message.counterpartyChannelId !== undefined && (obj.counterpartyChannelId = message.counterpartyChannelId);
        message.counterpartyVersion !== undefined && (obj.counterpartyVersion = message.counterpartyVersion);
        message.proofTry !== undefined && (obj.proofTry = (0, $d5e07fe2518aae94$exports.base64FromBytes)(message.proofTry !== undefined ? message.proofTry : new Uint8Array()));
        message.proofHeight !== undefined && (obj.proofHeight = message.proofHeight ? $7d28e43a1e22112f$exports.Height.toJSON(message.proofHeight) : undefined);
        message.signer !== undefined && (obj.signer = message.signer);
        return obj;
    },
    fromPartial (object) {
        const message = $ce17e6d84c94872c$var$createBaseMsgChannelOpenAck();
        message.portId = object.portId ?? "";
        message.channelId = object.channelId ?? "";
        message.counterpartyChannelId = object.counterpartyChannelId ?? "";
        message.counterpartyVersion = object.counterpartyVersion ?? "";
        message.proofTry = object.proofTry ?? new Uint8Array();
        message.proofHeight = object.proofHeight !== undefined && object.proofHeight !== null ? $7d28e43a1e22112f$exports.Height.fromPartial(object.proofHeight) : undefined;
        message.signer = object.signer ?? "";
        return message;
    }
};
function $ce17e6d84c94872c$var$createBaseMsgChannelOpenAckResponse() {
    return {};
}
$ce17e6d84c94872c$exports.MsgChannelOpenAckResponse = {
    encode (_, writer = $ce17e6d84c94872c$var$_m0.Writer.create()) {
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $ce17e6d84c94872c$var$_m0.Reader ? input : new $ce17e6d84c94872c$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $ce17e6d84c94872c$var$createBaseMsgChannelOpenAckResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            tag;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON (_) {
        return {};
    },
    toJSON (_) {
        const obj = {};
        return obj;
    },
    fromPartial (_) {
        const message = $ce17e6d84c94872c$var$createBaseMsgChannelOpenAckResponse();
        return message;
    }
};
function $ce17e6d84c94872c$var$createBaseMsgChannelOpenConfirm() {
    return {
        portId: "",
        channelId: "",
        proofAck: new Uint8Array(),
        proofHeight: undefined,
        signer: ""
    };
}
$ce17e6d84c94872c$exports.MsgChannelOpenConfirm = {
    encode (message, writer = $ce17e6d84c94872c$var$_m0.Writer.create()) {
        if (message.portId !== "") writer.uint32(10).string(message.portId);
        if (message.channelId !== "") writer.uint32(18).string(message.channelId);
        if (message.proofAck.length !== 0) writer.uint32(26).bytes(message.proofAck);
        if (message.proofHeight !== undefined) $7d28e43a1e22112f$exports.Height.encode(message.proofHeight, writer.uint32(34).fork()).ldelim();
        if (message.signer !== "") writer.uint32(42).string(message.signer);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $ce17e6d84c94872c$var$_m0.Reader ? input : new $ce17e6d84c94872c$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $ce17e6d84c94872c$var$createBaseMsgChannelOpenConfirm();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.portId = reader.string();
                    break;
                case 2:
                    message.channelId = reader.string();
                    break;
                case 3:
                    message.proofAck = reader.bytes();
                    break;
                case 4:
                    message.proofHeight = $7d28e43a1e22112f$exports.Height.decode(reader, reader.uint32());
                    break;
                case 5:
                    message.signer = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            portId: (0, $d5e07fe2518aae94$exports.isSet)(object.portId) ? String(object.portId) : "",
            channelId: (0, $d5e07fe2518aae94$exports.isSet)(object.channelId) ? String(object.channelId) : "",
            proofAck: (0, $d5e07fe2518aae94$exports.isSet)(object.proofAck) ? (0, $d5e07fe2518aae94$exports.bytesFromBase64)(object.proofAck) : new Uint8Array(),
            proofHeight: (0, $d5e07fe2518aae94$exports.isSet)(object.proofHeight) ? $7d28e43a1e22112f$exports.Height.fromJSON(object.proofHeight) : undefined,
            signer: (0, $d5e07fe2518aae94$exports.isSet)(object.signer) ? String(object.signer) : ""
        };
    },
    toJSON (message) {
        const obj = {};
        message.portId !== undefined && (obj.portId = message.portId);
        message.channelId !== undefined && (obj.channelId = message.channelId);
        message.proofAck !== undefined && (obj.proofAck = (0, $d5e07fe2518aae94$exports.base64FromBytes)(message.proofAck !== undefined ? message.proofAck : new Uint8Array()));
        message.proofHeight !== undefined && (obj.proofHeight = message.proofHeight ? $7d28e43a1e22112f$exports.Height.toJSON(message.proofHeight) : undefined);
        message.signer !== undefined && (obj.signer = message.signer);
        return obj;
    },
    fromPartial (object) {
        const message = $ce17e6d84c94872c$var$createBaseMsgChannelOpenConfirm();
        message.portId = object.portId ?? "";
        message.channelId = object.channelId ?? "";
        message.proofAck = object.proofAck ?? new Uint8Array();
        message.proofHeight = object.proofHeight !== undefined && object.proofHeight !== null ? $7d28e43a1e22112f$exports.Height.fromPartial(object.proofHeight) : undefined;
        message.signer = object.signer ?? "";
        return message;
    }
};
function $ce17e6d84c94872c$var$createBaseMsgChannelOpenConfirmResponse() {
    return {};
}
$ce17e6d84c94872c$exports.MsgChannelOpenConfirmResponse = {
    encode (_, writer = $ce17e6d84c94872c$var$_m0.Writer.create()) {
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $ce17e6d84c94872c$var$_m0.Reader ? input : new $ce17e6d84c94872c$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $ce17e6d84c94872c$var$createBaseMsgChannelOpenConfirmResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            tag;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON (_) {
        return {};
    },
    toJSON (_) {
        const obj = {};
        return obj;
    },
    fromPartial (_) {
        const message = $ce17e6d84c94872c$var$createBaseMsgChannelOpenConfirmResponse();
        return message;
    }
};
function $ce17e6d84c94872c$var$createBaseMsgChannelCloseInit() {
    return {
        portId: "",
        channelId: "",
        signer: ""
    };
}
$ce17e6d84c94872c$exports.MsgChannelCloseInit = {
    encode (message, writer = $ce17e6d84c94872c$var$_m0.Writer.create()) {
        if (message.portId !== "") writer.uint32(10).string(message.portId);
        if (message.channelId !== "") writer.uint32(18).string(message.channelId);
        if (message.signer !== "") writer.uint32(26).string(message.signer);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $ce17e6d84c94872c$var$_m0.Reader ? input : new $ce17e6d84c94872c$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $ce17e6d84c94872c$var$createBaseMsgChannelCloseInit();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.portId = reader.string();
                    break;
                case 2:
                    message.channelId = reader.string();
                    break;
                case 3:
                    message.signer = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            portId: (0, $d5e07fe2518aae94$exports.isSet)(object.portId) ? String(object.portId) : "",
            channelId: (0, $d5e07fe2518aae94$exports.isSet)(object.channelId) ? String(object.channelId) : "",
            signer: (0, $d5e07fe2518aae94$exports.isSet)(object.signer) ? String(object.signer) : ""
        };
    },
    toJSON (message) {
        const obj = {};
        message.portId !== undefined && (obj.portId = message.portId);
        message.channelId !== undefined && (obj.channelId = message.channelId);
        message.signer !== undefined && (obj.signer = message.signer);
        return obj;
    },
    fromPartial (object) {
        const message = $ce17e6d84c94872c$var$createBaseMsgChannelCloseInit();
        message.portId = object.portId ?? "";
        message.channelId = object.channelId ?? "";
        message.signer = object.signer ?? "";
        return message;
    }
};
function $ce17e6d84c94872c$var$createBaseMsgChannelCloseInitResponse() {
    return {};
}
$ce17e6d84c94872c$exports.MsgChannelCloseInitResponse = {
    encode (_, writer = $ce17e6d84c94872c$var$_m0.Writer.create()) {
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $ce17e6d84c94872c$var$_m0.Reader ? input : new $ce17e6d84c94872c$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $ce17e6d84c94872c$var$createBaseMsgChannelCloseInitResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            tag;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON (_) {
        return {};
    },
    toJSON (_) {
        const obj = {};
        return obj;
    },
    fromPartial (_) {
        const message = $ce17e6d84c94872c$var$createBaseMsgChannelCloseInitResponse();
        return message;
    }
};
function $ce17e6d84c94872c$var$createBaseMsgChannelCloseConfirm() {
    return {
        portId: "",
        channelId: "",
        proofInit: new Uint8Array(),
        proofHeight: undefined,
        signer: ""
    };
}
$ce17e6d84c94872c$exports.MsgChannelCloseConfirm = {
    encode (message, writer = $ce17e6d84c94872c$var$_m0.Writer.create()) {
        if (message.portId !== "") writer.uint32(10).string(message.portId);
        if (message.channelId !== "") writer.uint32(18).string(message.channelId);
        if (message.proofInit.length !== 0) writer.uint32(26).bytes(message.proofInit);
        if (message.proofHeight !== undefined) $7d28e43a1e22112f$exports.Height.encode(message.proofHeight, writer.uint32(34).fork()).ldelim();
        if (message.signer !== "") writer.uint32(42).string(message.signer);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $ce17e6d84c94872c$var$_m0.Reader ? input : new $ce17e6d84c94872c$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $ce17e6d84c94872c$var$createBaseMsgChannelCloseConfirm();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.portId = reader.string();
                    break;
                case 2:
                    message.channelId = reader.string();
                    break;
                case 3:
                    message.proofInit = reader.bytes();
                    break;
                case 4:
                    message.proofHeight = $7d28e43a1e22112f$exports.Height.decode(reader, reader.uint32());
                    break;
                case 5:
                    message.signer = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            portId: (0, $d5e07fe2518aae94$exports.isSet)(object.portId) ? String(object.portId) : "",
            channelId: (0, $d5e07fe2518aae94$exports.isSet)(object.channelId) ? String(object.channelId) : "",
            proofInit: (0, $d5e07fe2518aae94$exports.isSet)(object.proofInit) ? (0, $d5e07fe2518aae94$exports.bytesFromBase64)(object.proofInit) : new Uint8Array(),
            proofHeight: (0, $d5e07fe2518aae94$exports.isSet)(object.proofHeight) ? $7d28e43a1e22112f$exports.Height.fromJSON(object.proofHeight) : undefined,
            signer: (0, $d5e07fe2518aae94$exports.isSet)(object.signer) ? String(object.signer) : ""
        };
    },
    toJSON (message) {
        const obj = {};
        message.portId !== undefined && (obj.portId = message.portId);
        message.channelId !== undefined && (obj.channelId = message.channelId);
        message.proofInit !== undefined && (obj.proofInit = (0, $d5e07fe2518aae94$exports.base64FromBytes)(message.proofInit !== undefined ? message.proofInit : new Uint8Array()));
        message.proofHeight !== undefined && (obj.proofHeight = message.proofHeight ? $7d28e43a1e22112f$exports.Height.toJSON(message.proofHeight) : undefined);
        message.signer !== undefined && (obj.signer = message.signer);
        return obj;
    },
    fromPartial (object) {
        const message = $ce17e6d84c94872c$var$createBaseMsgChannelCloseConfirm();
        message.portId = object.portId ?? "";
        message.channelId = object.channelId ?? "";
        message.proofInit = object.proofInit ?? new Uint8Array();
        message.proofHeight = object.proofHeight !== undefined && object.proofHeight !== null ? $7d28e43a1e22112f$exports.Height.fromPartial(object.proofHeight) : undefined;
        message.signer = object.signer ?? "";
        return message;
    }
};
function $ce17e6d84c94872c$var$createBaseMsgChannelCloseConfirmResponse() {
    return {};
}
$ce17e6d84c94872c$exports.MsgChannelCloseConfirmResponse = {
    encode (_, writer = $ce17e6d84c94872c$var$_m0.Writer.create()) {
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $ce17e6d84c94872c$var$_m0.Reader ? input : new $ce17e6d84c94872c$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $ce17e6d84c94872c$var$createBaseMsgChannelCloseConfirmResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            tag;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON (_) {
        return {};
    },
    toJSON (_) {
        const obj = {};
        return obj;
    },
    fromPartial (_) {
        const message = $ce17e6d84c94872c$var$createBaseMsgChannelCloseConfirmResponse();
        return message;
    }
};
function $ce17e6d84c94872c$var$createBaseMsgRecvPacket() {
    return {
        packet: undefined,
        proofCommitment: new Uint8Array(),
        proofHeight: undefined,
        signer: ""
    };
}
$ce17e6d84c94872c$exports.MsgRecvPacket = {
    encode (message, writer = $ce17e6d84c94872c$var$_m0.Writer.create()) {
        if (message.packet !== undefined) $e21f9e7cb16364b7$exports.Packet.encode(message.packet, writer.uint32(10).fork()).ldelim();
        if (message.proofCommitment.length !== 0) writer.uint32(18).bytes(message.proofCommitment);
        if (message.proofHeight !== undefined) $7d28e43a1e22112f$exports.Height.encode(message.proofHeight, writer.uint32(26).fork()).ldelim();
        if (message.signer !== "") writer.uint32(34).string(message.signer);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $ce17e6d84c94872c$var$_m0.Reader ? input : new $ce17e6d84c94872c$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $ce17e6d84c94872c$var$createBaseMsgRecvPacket();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.packet = $e21f9e7cb16364b7$exports.Packet.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.proofCommitment = reader.bytes();
                    break;
                case 3:
                    message.proofHeight = $7d28e43a1e22112f$exports.Height.decode(reader, reader.uint32());
                    break;
                case 4:
                    message.signer = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            packet: (0, $d5e07fe2518aae94$exports.isSet)(object.packet) ? $e21f9e7cb16364b7$exports.Packet.fromJSON(object.packet) : undefined,
            proofCommitment: (0, $d5e07fe2518aae94$exports.isSet)(object.proofCommitment) ? (0, $d5e07fe2518aae94$exports.bytesFromBase64)(object.proofCommitment) : new Uint8Array(),
            proofHeight: (0, $d5e07fe2518aae94$exports.isSet)(object.proofHeight) ? $7d28e43a1e22112f$exports.Height.fromJSON(object.proofHeight) : undefined,
            signer: (0, $d5e07fe2518aae94$exports.isSet)(object.signer) ? String(object.signer) : ""
        };
    },
    toJSON (message) {
        const obj = {};
        message.packet !== undefined && (obj.packet = message.packet ? $e21f9e7cb16364b7$exports.Packet.toJSON(message.packet) : undefined);
        message.proofCommitment !== undefined && (obj.proofCommitment = (0, $d5e07fe2518aae94$exports.base64FromBytes)(message.proofCommitment !== undefined ? message.proofCommitment : new Uint8Array()));
        message.proofHeight !== undefined && (obj.proofHeight = message.proofHeight ? $7d28e43a1e22112f$exports.Height.toJSON(message.proofHeight) : undefined);
        message.signer !== undefined && (obj.signer = message.signer);
        return obj;
    },
    fromPartial (object) {
        const message = $ce17e6d84c94872c$var$createBaseMsgRecvPacket();
        message.packet = object.packet !== undefined && object.packet !== null ? $e21f9e7cb16364b7$exports.Packet.fromPartial(object.packet) : undefined;
        message.proofCommitment = object.proofCommitment ?? new Uint8Array();
        message.proofHeight = object.proofHeight !== undefined && object.proofHeight !== null ? $7d28e43a1e22112f$exports.Height.fromPartial(object.proofHeight) : undefined;
        message.signer = object.signer ?? "";
        return message;
    }
};
function $ce17e6d84c94872c$var$createBaseMsgRecvPacketResponse() {
    return {
        result: 0
    };
}
$ce17e6d84c94872c$exports.MsgRecvPacketResponse = {
    encode (message, writer = $ce17e6d84c94872c$var$_m0.Writer.create()) {
        if (message.result !== 0) writer.uint32(8).int32(message.result);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $ce17e6d84c94872c$var$_m0.Reader ? input : new $ce17e6d84c94872c$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $ce17e6d84c94872c$var$createBaseMsgRecvPacketResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.result = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            result: (0, $d5e07fe2518aae94$exports.isSet)(object.result) ? $ce17e6d84c94872c$var$responseResultTypeFromJSON(object.result) : 0
        };
    },
    toJSON (message) {
        const obj = {};
        message.result !== undefined && (obj.result = $ce17e6d84c94872c$var$responseResultTypeToJSON(message.result));
        return obj;
    },
    fromPartial (object) {
        const message = $ce17e6d84c94872c$var$createBaseMsgRecvPacketResponse();
        message.result = object.result ?? 0;
        return message;
    }
};
function $ce17e6d84c94872c$var$createBaseMsgTimeout() {
    return {
        packet: undefined,
        proofUnreceived: new Uint8Array(),
        proofHeight: undefined,
        nextSequenceRecv: $d5e07fe2518aae94$exports.Long.UZERO,
        signer: ""
    };
}
$ce17e6d84c94872c$exports.MsgTimeout = {
    encode (message, writer = $ce17e6d84c94872c$var$_m0.Writer.create()) {
        if (message.packet !== undefined) $e21f9e7cb16364b7$exports.Packet.encode(message.packet, writer.uint32(10).fork()).ldelim();
        if (message.proofUnreceived.length !== 0) writer.uint32(18).bytes(message.proofUnreceived);
        if (message.proofHeight !== undefined) $7d28e43a1e22112f$exports.Height.encode(message.proofHeight, writer.uint32(26).fork()).ldelim();
        if (!message.nextSequenceRecv.isZero()) writer.uint32(32).uint64(message.nextSequenceRecv);
        if (message.signer !== "") writer.uint32(42).string(message.signer);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $ce17e6d84c94872c$var$_m0.Reader ? input : new $ce17e6d84c94872c$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $ce17e6d84c94872c$var$createBaseMsgTimeout();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.packet = $e21f9e7cb16364b7$exports.Packet.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.proofUnreceived = reader.bytes();
                    break;
                case 3:
                    message.proofHeight = $7d28e43a1e22112f$exports.Height.decode(reader, reader.uint32());
                    break;
                case 4:
                    message.nextSequenceRecv = reader.uint64();
                    break;
                case 5:
                    message.signer = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            packet: (0, $d5e07fe2518aae94$exports.isSet)(object.packet) ? $e21f9e7cb16364b7$exports.Packet.fromJSON(object.packet) : undefined,
            proofUnreceived: (0, $d5e07fe2518aae94$exports.isSet)(object.proofUnreceived) ? (0, $d5e07fe2518aae94$exports.bytesFromBase64)(object.proofUnreceived) : new Uint8Array(),
            proofHeight: (0, $d5e07fe2518aae94$exports.isSet)(object.proofHeight) ? $7d28e43a1e22112f$exports.Height.fromJSON(object.proofHeight) : undefined,
            nextSequenceRecv: (0, $d5e07fe2518aae94$exports.isSet)(object.nextSequenceRecv) ? $d5e07fe2518aae94$exports.Long.fromValue(object.nextSequenceRecv) : $d5e07fe2518aae94$exports.Long.UZERO,
            signer: (0, $d5e07fe2518aae94$exports.isSet)(object.signer) ? String(object.signer) : ""
        };
    },
    toJSON (message) {
        const obj = {};
        message.packet !== undefined && (obj.packet = message.packet ? $e21f9e7cb16364b7$exports.Packet.toJSON(message.packet) : undefined);
        message.proofUnreceived !== undefined && (obj.proofUnreceived = (0, $d5e07fe2518aae94$exports.base64FromBytes)(message.proofUnreceived !== undefined ? message.proofUnreceived : new Uint8Array()));
        message.proofHeight !== undefined && (obj.proofHeight = message.proofHeight ? $7d28e43a1e22112f$exports.Height.toJSON(message.proofHeight) : undefined);
        message.nextSequenceRecv !== undefined && (obj.nextSequenceRecv = (message.nextSequenceRecv || $d5e07fe2518aae94$exports.Long.UZERO).toString());
        message.signer !== undefined && (obj.signer = message.signer);
        return obj;
    },
    fromPartial (object) {
        const message = $ce17e6d84c94872c$var$createBaseMsgTimeout();
        message.packet = object.packet !== undefined && object.packet !== null ? $e21f9e7cb16364b7$exports.Packet.fromPartial(object.packet) : undefined;
        message.proofUnreceived = object.proofUnreceived ?? new Uint8Array();
        message.proofHeight = object.proofHeight !== undefined && object.proofHeight !== null ? $7d28e43a1e22112f$exports.Height.fromPartial(object.proofHeight) : undefined;
        message.nextSequenceRecv = object.nextSequenceRecv !== undefined && object.nextSequenceRecv !== null ? $d5e07fe2518aae94$exports.Long.fromValue(object.nextSequenceRecv) : $d5e07fe2518aae94$exports.Long.UZERO;
        message.signer = object.signer ?? "";
        return message;
    }
};
function $ce17e6d84c94872c$var$createBaseMsgTimeoutResponse() {
    return {
        result: 0
    };
}
$ce17e6d84c94872c$exports.MsgTimeoutResponse = {
    encode (message, writer = $ce17e6d84c94872c$var$_m0.Writer.create()) {
        if (message.result !== 0) writer.uint32(8).int32(message.result);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $ce17e6d84c94872c$var$_m0.Reader ? input : new $ce17e6d84c94872c$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $ce17e6d84c94872c$var$createBaseMsgTimeoutResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.result = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            result: (0, $d5e07fe2518aae94$exports.isSet)(object.result) ? $ce17e6d84c94872c$var$responseResultTypeFromJSON(object.result) : 0
        };
    },
    toJSON (message) {
        const obj = {};
        message.result !== undefined && (obj.result = $ce17e6d84c94872c$var$responseResultTypeToJSON(message.result));
        return obj;
    },
    fromPartial (object) {
        const message = $ce17e6d84c94872c$var$createBaseMsgTimeoutResponse();
        message.result = object.result ?? 0;
        return message;
    }
};
function $ce17e6d84c94872c$var$createBaseMsgTimeoutOnClose() {
    return {
        packet: undefined,
        proofUnreceived: new Uint8Array(),
        proofClose: new Uint8Array(),
        proofHeight: undefined,
        nextSequenceRecv: $d5e07fe2518aae94$exports.Long.UZERO,
        signer: ""
    };
}
$ce17e6d84c94872c$exports.MsgTimeoutOnClose = {
    encode (message, writer = $ce17e6d84c94872c$var$_m0.Writer.create()) {
        if (message.packet !== undefined) $e21f9e7cb16364b7$exports.Packet.encode(message.packet, writer.uint32(10).fork()).ldelim();
        if (message.proofUnreceived.length !== 0) writer.uint32(18).bytes(message.proofUnreceived);
        if (message.proofClose.length !== 0) writer.uint32(26).bytes(message.proofClose);
        if (message.proofHeight !== undefined) $7d28e43a1e22112f$exports.Height.encode(message.proofHeight, writer.uint32(34).fork()).ldelim();
        if (!message.nextSequenceRecv.isZero()) writer.uint32(40).uint64(message.nextSequenceRecv);
        if (message.signer !== "") writer.uint32(50).string(message.signer);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $ce17e6d84c94872c$var$_m0.Reader ? input : new $ce17e6d84c94872c$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $ce17e6d84c94872c$var$createBaseMsgTimeoutOnClose();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.packet = $e21f9e7cb16364b7$exports.Packet.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.proofUnreceived = reader.bytes();
                    break;
                case 3:
                    message.proofClose = reader.bytes();
                    break;
                case 4:
                    message.proofHeight = $7d28e43a1e22112f$exports.Height.decode(reader, reader.uint32());
                    break;
                case 5:
                    message.nextSequenceRecv = reader.uint64();
                    break;
                case 6:
                    message.signer = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            packet: (0, $d5e07fe2518aae94$exports.isSet)(object.packet) ? $e21f9e7cb16364b7$exports.Packet.fromJSON(object.packet) : undefined,
            proofUnreceived: (0, $d5e07fe2518aae94$exports.isSet)(object.proofUnreceived) ? (0, $d5e07fe2518aae94$exports.bytesFromBase64)(object.proofUnreceived) : new Uint8Array(),
            proofClose: (0, $d5e07fe2518aae94$exports.isSet)(object.proofClose) ? (0, $d5e07fe2518aae94$exports.bytesFromBase64)(object.proofClose) : new Uint8Array(),
            proofHeight: (0, $d5e07fe2518aae94$exports.isSet)(object.proofHeight) ? $7d28e43a1e22112f$exports.Height.fromJSON(object.proofHeight) : undefined,
            nextSequenceRecv: (0, $d5e07fe2518aae94$exports.isSet)(object.nextSequenceRecv) ? $d5e07fe2518aae94$exports.Long.fromValue(object.nextSequenceRecv) : $d5e07fe2518aae94$exports.Long.UZERO,
            signer: (0, $d5e07fe2518aae94$exports.isSet)(object.signer) ? String(object.signer) : ""
        };
    },
    toJSON (message) {
        const obj = {};
        message.packet !== undefined && (obj.packet = message.packet ? $e21f9e7cb16364b7$exports.Packet.toJSON(message.packet) : undefined);
        message.proofUnreceived !== undefined && (obj.proofUnreceived = (0, $d5e07fe2518aae94$exports.base64FromBytes)(message.proofUnreceived !== undefined ? message.proofUnreceived : new Uint8Array()));
        message.proofClose !== undefined && (obj.proofClose = (0, $d5e07fe2518aae94$exports.base64FromBytes)(message.proofClose !== undefined ? message.proofClose : new Uint8Array()));
        message.proofHeight !== undefined && (obj.proofHeight = message.proofHeight ? $7d28e43a1e22112f$exports.Height.toJSON(message.proofHeight) : undefined);
        message.nextSequenceRecv !== undefined && (obj.nextSequenceRecv = (message.nextSequenceRecv || $d5e07fe2518aae94$exports.Long.UZERO).toString());
        message.signer !== undefined && (obj.signer = message.signer);
        return obj;
    },
    fromPartial (object) {
        const message = $ce17e6d84c94872c$var$createBaseMsgTimeoutOnClose();
        message.packet = object.packet !== undefined && object.packet !== null ? $e21f9e7cb16364b7$exports.Packet.fromPartial(object.packet) : undefined;
        message.proofUnreceived = object.proofUnreceived ?? new Uint8Array();
        message.proofClose = object.proofClose ?? new Uint8Array();
        message.proofHeight = object.proofHeight !== undefined && object.proofHeight !== null ? $7d28e43a1e22112f$exports.Height.fromPartial(object.proofHeight) : undefined;
        message.nextSequenceRecv = object.nextSequenceRecv !== undefined && object.nextSequenceRecv !== null ? $d5e07fe2518aae94$exports.Long.fromValue(object.nextSequenceRecv) : $d5e07fe2518aae94$exports.Long.UZERO;
        message.signer = object.signer ?? "";
        return message;
    }
};
function $ce17e6d84c94872c$var$createBaseMsgTimeoutOnCloseResponse() {
    return {
        result: 0
    };
}
$ce17e6d84c94872c$exports.MsgTimeoutOnCloseResponse = {
    encode (message, writer = $ce17e6d84c94872c$var$_m0.Writer.create()) {
        if (message.result !== 0) writer.uint32(8).int32(message.result);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $ce17e6d84c94872c$var$_m0.Reader ? input : new $ce17e6d84c94872c$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $ce17e6d84c94872c$var$createBaseMsgTimeoutOnCloseResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.result = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            result: (0, $d5e07fe2518aae94$exports.isSet)(object.result) ? $ce17e6d84c94872c$var$responseResultTypeFromJSON(object.result) : 0
        };
    },
    toJSON (message) {
        const obj = {};
        message.result !== undefined && (obj.result = $ce17e6d84c94872c$var$responseResultTypeToJSON(message.result));
        return obj;
    },
    fromPartial (object) {
        const message = $ce17e6d84c94872c$var$createBaseMsgTimeoutOnCloseResponse();
        message.result = object.result ?? 0;
        return message;
    }
};
function $ce17e6d84c94872c$var$createBaseMsgAcknowledgement() {
    return {
        packet: undefined,
        acknowledgement: new Uint8Array(),
        proofAcked: new Uint8Array(),
        proofHeight: undefined,
        signer: ""
    };
}
$ce17e6d84c94872c$exports.MsgAcknowledgement = {
    encode (message, writer = $ce17e6d84c94872c$var$_m0.Writer.create()) {
        if (message.packet !== undefined) $e21f9e7cb16364b7$exports.Packet.encode(message.packet, writer.uint32(10).fork()).ldelim();
        if (message.acknowledgement.length !== 0) writer.uint32(18).bytes(message.acknowledgement);
        if (message.proofAcked.length !== 0) writer.uint32(26).bytes(message.proofAcked);
        if (message.proofHeight !== undefined) $7d28e43a1e22112f$exports.Height.encode(message.proofHeight, writer.uint32(34).fork()).ldelim();
        if (message.signer !== "") writer.uint32(42).string(message.signer);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $ce17e6d84c94872c$var$_m0.Reader ? input : new $ce17e6d84c94872c$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $ce17e6d84c94872c$var$createBaseMsgAcknowledgement();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.packet = $e21f9e7cb16364b7$exports.Packet.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.acknowledgement = reader.bytes();
                    break;
                case 3:
                    message.proofAcked = reader.bytes();
                    break;
                case 4:
                    message.proofHeight = $7d28e43a1e22112f$exports.Height.decode(reader, reader.uint32());
                    break;
                case 5:
                    message.signer = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            packet: (0, $d5e07fe2518aae94$exports.isSet)(object.packet) ? $e21f9e7cb16364b7$exports.Packet.fromJSON(object.packet) : undefined,
            acknowledgement: (0, $d5e07fe2518aae94$exports.isSet)(object.acknowledgement) ? (0, $d5e07fe2518aae94$exports.bytesFromBase64)(object.acknowledgement) : new Uint8Array(),
            proofAcked: (0, $d5e07fe2518aae94$exports.isSet)(object.proofAcked) ? (0, $d5e07fe2518aae94$exports.bytesFromBase64)(object.proofAcked) : new Uint8Array(),
            proofHeight: (0, $d5e07fe2518aae94$exports.isSet)(object.proofHeight) ? $7d28e43a1e22112f$exports.Height.fromJSON(object.proofHeight) : undefined,
            signer: (0, $d5e07fe2518aae94$exports.isSet)(object.signer) ? String(object.signer) : ""
        };
    },
    toJSON (message) {
        const obj = {};
        message.packet !== undefined && (obj.packet = message.packet ? $e21f9e7cb16364b7$exports.Packet.toJSON(message.packet) : undefined);
        message.acknowledgement !== undefined && (obj.acknowledgement = (0, $d5e07fe2518aae94$exports.base64FromBytes)(message.acknowledgement !== undefined ? message.acknowledgement : new Uint8Array()));
        message.proofAcked !== undefined && (obj.proofAcked = (0, $d5e07fe2518aae94$exports.base64FromBytes)(message.proofAcked !== undefined ? message.proofAcked : new Uint8Array()));
        message.proofHeight !== undefined && (obj.proofHeight = message.proofHeight ? $7d28e43a1e22112f$exports.Height.toJSON(message.proofHeight) : undefined);
        message.signer !== undefined && (obj.signer = message.signer);
        return obj;
    },
    fromPartial (object) {
        const message = $ce17e6d84c94872c$var$createBaseMsgAcknowledgement();
        message.packet = object.packet !== undefined && object.packet !== null ? $e21f9e7cb16364b7$exports.Packet.fromPartial(object.packet) : undefined;
        message.acknowledgement = object.acknowledgement ?? new Uint8Array();
        message.proofAcked = object.proofAcked ?? new Uint8Array();
        message.proofHeight = object.proofHeight !== undefined && object.proofHeight !== null ? $7d28e43a1e22112f$exports.Height.fromPartial(object.proofHeight) : undefined;
        message.signer = object.signer ?? "";
        return message;
    }
};
function $ce17e6d84c94872c$var$createBaseMsgAcknowledgementResponse() {
    return {
        result: 0
    };
}
$ce17e6d84c94872c$exports.MsgAcknowledgementResponse = {
    encode (message, writer = $ce17e6d84c94872c$var$_m0.Writer.create()) {
        if (message.result !== 0) writer.uint32(8).int32(message.result);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $ce17e6d84c94872c$var$_m0.Reader ? input : new $ce17e6d84c94872c$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $ce17e6d84c94872c$var$createBaseMsgAcknowledgementResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.result = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            result: (0, $d5e07fe2518aae94$exports.isSet)(object.result) ? $ce17e6d84c94872c$var$responseResultTypeFromJSON(object.result) : 0
        };
    },
    toJSON (message) {
        const obj = {};
        message.result !== undefined && (obj.result = $ce17e6d84c94872c$var$responseResultTypeToJSON(message.result));
        return obj;
    },
    fromPartial (object) {
        const message = $ce17e6d84c94872c$var$createBaseMsgAcknowledgementResponse();
        message.result = object.result ?? 0;
        return message;
    }
};
class $ce17e6d84c94872c$var$MsgClientImpl {
    constructor(rpc){
        this.rpc = rpc;
        this.ChannelOpenInit = this.ChannelOpenInit.bind(this);
        this.ChannelOpenTry = this.ChannelOpenTry.bind(this);
        this.ChannelOpenAck = this.ChannelOpenAck.bind(this);
        this.ChannelOpenConfirm = this.ChannelOpenConfirm.bind(this);
        this.ChannelCloseInit = this.ChannelCloseInit.bind(this);
        this.ChannelCloseConfirm = this.ChannelCloseConfirm.bind(this);
        this.RecvPacket = this.RecvPacket.bind(this);
        this.Timeout = this.Timeout.bind(this);
        this.TimeoutOnClose = this.TimeoutOnClose.bind(this);
        this.Acknowledgement = this.Acknowledgement.bind(this);
    }
    ChannelOpenInit(request) {
        const data = $ce17e6d84c94872c$exports.MsgChannelOpenInit.encode(request).finish();
        const promise = this.rpc.request("ibc.core.channel.v1.Msg", "ChannelOpenInit", data);
        return promise.then((data)=>$ce17e6d84c94872c$exports.MsgChannelOpenInitResponse.decode(new $ce17e6d84c94872c$var$_m0.Reader(data)));
    }
    ChannelOpenTry(request) {
        const data = $ce17e6d84c94872c$exports.MsgChannelOpenTry.encode(request).finish();
        const promise = this.rpc.request("ibc.core.channel.v1.Msg", "ChannelOpenTry", data);
        return promise.then((data)=>$ce17e6d84c94872c$exports.MsgChannelOpenTryResponse.decode(new $ce17e6d84c94872c$var$_m0.Reader(data)));
    }
    ChannelOpenAck(request) {
        const data = $ce17e6d84c94872c$exports.MsgChannelOpenAck.encode(request).finish();
        const promise = this.rpc.request("ibc.core.channel.v1.Msg", "ChannelOpenAck", data);
        return promise.then((data)=>$ce17e6d84c94872c$exports.MsgChannelOpenAckResponse.decode(new $ce17e6d84c94872c$var$_m0.Reader(data)));
    }
    ChannelOpenConfirm(request) {
        const data = $ce17e6d84c94872c$exports.MsgChannelOpenConfirm.encode(request).finish();
        const promise = this.rpc.request("ibc.core.channel.v1.Msg", "ChannelOpenConfirm", data);
        return promise.then((data)=>$ce17e6d84c94872c$exports.MsgChannelOpenConfirmResponse.decode(new $ce17e6d84c94872c$var$_m0.Reader(data)));
    }
    ChannelCloseInit(request) {
        const data = $ce17e6d84c94872c$exports.MsgChannelCloseInit.encode(request).finish();
        const promise = this.rpc.request("ibc.core.channel.v1.Msg", "ChannelCloseInit", data);
        return promise.then((data)=>$ce17e6d84c94872c$exports.MsgChannelCloseInitResponse.decode(new $ce17e6d84c94872c$var$_m0.Reader(data)));
    }
    ChannelCloseConfirm(request) {
        const data = $ce17e6d84c94872c$exports.MsgChannelCloseConfirm.encode(request).finish();
        const promise = this.rpc.request("ibc.core.channel.v1.Msg", "ChannelCloseConfirm", data);
        return promise.then((data)=>$ce17e6d84c94872c$exports.MsgChannelCloseConfirmResponse.decode(new $ce17e6d84c94872c$var$_m0.Reader(data)));
    }
    RecvPacket(request) {
        const data = $ce17e6d84c94872c$exports.MsgRecvPacket.encode(request).finish();
        const promise = this.rpc.request("ibc.core.channel.v1.Msg", "RecvPacket", data);
        return promise.then((data)=>$ce17e6d84c94872c$exports.MsgRecvPacketResponse.decode(new $ce17e6d84c94872c$var$_m0.Reader(data)));
    }
    Timeout(request) {
        const data = $ce17e6d84c94872c$exports.MsgTimeout.encode(request).finish();
        const promise = this.rpc.request("ibc.core.channel.v1.Msg", "Timeout", data);
        return promise.then((data)=>$ce17e6d84c94872c$exports.MsgTimeoutResponse.decode(new $ce17e6d84c94872c$var$_m0.Reader(data)));
    }
    TimeoutOnClose(request) {
        const data = $ce17e6d84c94872c$exports.MsgTimeoutOnClose.encode(request).finish();
        const promise = this.rpc.request("ibc.core.channel.v1.Msg", "TimeoutOnClose", data);
        return promise.then((data)=>$ce17e6d84c94872c$exports.MsgTimeoutOnCloseResponse.decode(new $ce17e6d84c94872c$var$_m0.Reader(data)));
    }
    Acknowledgement(request) {
        const data = $ce17e6d84c94872c$exports.MsgAcknowledgement.encode(request).finish();
        const promise = this.rpc.request("ibc.core.channel.v1.Msg", "Acknowledgement", data);
        return promise.then((data)=>$ce17e6d84c94872c$exports.MsgAcknowledgementResponse.decode(new $ce17e6d84c94872c$var$_m0.Reader(data)));
    }
}
$ce17e6d84c94872c$exports.MsgClientImpl = $ce17e6d84c94872c$var$MsgClientImpl;


var $1ffe4eb8410e0d1d$exports = {};
"use strict";
var $1ffe4eb8410e0d1d$var$__createBinding = $1ffe4eb8410e0d1d$exports && $1ffe4eb8410e0d1d$exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $1ffe4eb8410e0d1d$var$__setModuleDefault = $1ffe4eb8410e0d1d$exports && $1ffe4eb8410e0d1d$exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $1ffe4eb8410e0d1d$var$__importStar = $1ffe4eb8410e0d1d$exports && $1ffe4eb8410e0d1d$exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $1ffe4eb8410e0d1d$var$__createBinding(result, mod, k);
    }
    $1ffe4eb8410e0d1d$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty($1ffe4eb8410e0d1d$exports, "__esModule", {
    value: true
});
$1ffe4eb8410e0d1d$exports.MsgClientImpl = $1ffe4eb8410e0d1d$exports.MsgSubmitMisbehaviourResponse = $1ffe4eb8410e0d1d$exports.MsgSubmitMisbehaviour = $1ffe4eb8410e0d1d$exports.MsgUpgradeClientResponse = $1ffe4eb8410e0d1d$exports.MsgUpgradeClient = $1ffe4eb8410e0d1d$exports.MsgUpdateClientResponse = $1ffe4eb8410e0d1d$exports.MsgUpdateClient = $1ffe4eb8410e0d1d$exports.MsgCreateClientResponse = $1ffe4eb8410e0d1d$exports.MsgCreateClient = $1ffe4eb8410e0d1d$exports.protobufPackage = void 0;


const $1ffe4eb8410e0d1d$var$_m0 = $1ffe4eb8410e0d1d$var$__importStar((parcelRequire("fQBv0")));

$1ffe4eb8410e0d1d$exports.protobufPackage = "ibc.core.client.v1";
function $1ffe4eb8410e0d1d$var$createBaseMsgCreateClient() {
    return {
        clientState: undefined,
        consensusState: undefined,
        signer: ""
    };
}
$1ffe4eb8410e0d1d$exports.MsgCreateClient = {
    encode (message, writer = $1ffe4eb8410e0d1d$var$_m0.Writer.create()) {
        if (message.clientState !== undefined) $64138e590dcf0cc1$exports.Any.encode(message.clientState, writer.uint32(10).fork()).ldelim();
        if (message.consensusState !== undefined) $64138e590dcf0cc1$exports.Any.encode(message.consensusState, writer.uint32(18).fork()).ldelim();
        if (message.signer !== "") writer.uint32(26).string(message.signer);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $1ffe4eb8410e0d1d$var$_m0.Reader ? input : new $1ffe4eb8410e0d1d$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $1ffe4eb8410e0d1d$var$createBaseMsgCreateClient();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.clientState = $64138e590dcf0cc1$exports.Any.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.consensusState = $64138e590dcf0cc1$exports.Any.decode(reader, reader.uint32());
                    break;
                case 3:
                    message.signer = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            clientState: (0, $d5e07fe2518aae94$exports.isSet)(object.clientState) ? $64138e590dcf0cc1$exports.Any.fromJSON(object.clientState) : undefined,
            consensusState: (0, $d5e07fe2518aae94$exports.isSet)(object.consensusState) ? $64138e590dcf0cc1$exports.Any.fromJSON(object.consensusState) : undefined,
            signer: (0, $d5e07fe2518aae94$exports.isSet)(object.signer) ? String(object.signer) : ""
        };
    },
    toJSON (message) {
        const obj = {};
        message.clientState !== undefined && (obj.clientState = message.clientState ? $64138e590dcf0cc1$exports.Any.toJSON(message.clientState) : undefined);
        message.consensusState !== undefined && (obj.consensusState = message.consensusState ? $64138e590dcf0cc1$exports.Any.toJSON(message.consensusState) : undefined);
        message.signer !== undefined && (obj.signer = message.signer);
        return obj;
    },
    fromPartial (object) {
        const message = $1ffe4eb8410e0d1d$var$createBaseMsgCreateClient();
        message.clientState = object.clientState !== undefined && object.clientState !== null ? $64138e590dcf0cc1$exports.Any.fromPartial(object.clientState) : undefined;
        message.consensusState = object.consensusState !== undefined && object.consensusState !== null ? $64138e590dcf0cc1$exports.Any.fromPartial(object.consensusState) : undefined;
        message.signer = object.signer ?? "";
        return message;
    }
};
function $1ffe4eb8410e0d1d$var$createBaseMsgCreateClientResponse() {
    return {};
}
$1ffe4eb8410e0d1d$exports.MsgCreateClientResponse = {
    encode (_, writer = $1ffe4eb8410e0d1d$var$_m0.Writer.create()) {
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $1ffe4eb8410e0d1d$var$_m0.Reader ? input : new $1ffe4eb8410e0d1d$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $1ffe4eb8410e0d1d$var$createBaseMsgCreateClientResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            tag;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON (_) {
        return {};
    },
    toJSON (_) {
        const obj = {};
        return obj;
    },
    fromPartial (_) {
        const message = $1ffe4eb8410e0d1d$var$createBaseMsgCreateClientResponse();
        return message;
    }
};
function $1ffe4eb8410e0d1d$var$createBaseMsgUpdateClient() {
    return {
        clientId: "",
        clientMessage: undefined,
        signer: ""
    };
}
$1ffe4eb8410e0d1d$exports.MsgUpdateClient = {
    encode (message, writer = $1ffe4eb8410e0d1d$var$_m0.Writer.create()) {
        if (message.clientId !== "") writer.uint32(10).string(message.clientId);
        if (message.clientMessage !== undefined) $64138e590dcf0cc1$exports.Any.encode(message.clientMessage, writer.uint32(18).fork()).ldelim();
        if (message.signer !== "") writer.uint32(26).string(message.signer);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $1ffe4eb8410e0d1d$var$_m0.Reader ? input : new $1ffe4eb8410e0d1d$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $1ffe4eb8410e0d1d$var$createBaseMsgUpdateClient();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.clientId = reader.string();
                    break;
                case 2:
                    message.clientMessage = $64138e590dcf0cc1$exports.Any.decode(reader, reader.uint32());
                    break;
                case 3:
                    message.signer = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            clientId: (0, $d5e07fe2518aae94$exports.isSet)(object.clientId) ? String(object.clientId) : "",
            clientMessage: (0, $d5e07fe2518aae94$exports.isSet)(object.clientMessage) ? $64138e590dcf0cc1$exports.Any.fromJSON(object.clientMessage) : undefined,
            signer: (0, $d5e07fe2518aae94$exports.isSet)(object.signer) ? String(object.signer) : ""
        };
    },
    toJSON (message) {
        const obj = {};
        message.clientId !== undefined && (obj.clientId = message.clientId);
        message.clientMessage !== undefined && (obj.clientMessage = message.clientMessage ? $64138e590dcf0cc1$exports.Any.toJSON(message.clientMessage) : undefined);
        message.signer !== undefined && (obj.signer = message.signer);
        return obj;
    },
    fromPartial (object) {
        const message = $1ffe4eb8410e0d1d$var$createBaseMsgUpdateClient();
        message.clientId = object.clientId ?? "";
        message.clientMessage = object.clientMessage !== undefined && object.clientMessage !== null ? $64138e590dcf0cc1$exports.Any.fromPartial(object.clientMessage) : undefined;
        message.signer = object.signer ?? "";
        return message;
    }
};
function $1ffe4eb8410e0d1d$var$createBaseMsgUpdateClientResponse() {
    return {};
}
$1ffe4eb8410e0d1d$exports.MsgUpdateClientResponse = {
    encode (_, writer = $1ffe4eb8410e0d1d$var$_m0.Writer.create()) {
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $1ffe4eb8410e0d1d$var$_m0.Reader ? input : new $1ffe4eb8410e0d1d$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $1ffe4eb8410e0d1d$var$createBaseMsgUpdateClientResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            tag;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON (_) {
        return {};
    },
    toJSON (_) {
        const obj = {};
        return obj;
    },
    fromPartial (_) {
        const message = $1ffe4eb8410e0d1d$var$createBaseMsgUpdateClientResponse();
        return message;
    }
};
function $1ffe4eb8410e0d1d$var$createBaseMsgUpgradeClient() {
    return {
        clientId: "",
        clientState: undefined,
        consensusState: undefined,
        proofUpgradeClient: new Uint8Array(),
        proofUpgradeConsensusState: new Uint8Array(),
        signer: ""
    };
}
$1ffe4eb8410e0d1d$exports.MsgUpgradeClient = {
    encode (message, writer = $1ffe4eb8410e0d1d$var$_m0.Writer.create()) {
        if (message.clientId !== "") writer.uint32(10).string(message.clientId);
        if (message.clientState !== undefined) $64138e590dcf0cc1$exports.Any.encode(message.clientState, writer.uint32(18).fork()).ldelim();
        if (message.consensusState !== undefined) $64138e590dcf0cc1$exports.Any.encode(message.consensusState, writer.uint32(26).fork()).ldelim();
        if (message.proofUpgradeClient.length !== 0) writer.uint32(34).bytes(message.proofUpgradeClient);
        if (message.proofUpgradeConsensusState.length !== 0) writer.uint32(42).bytes(message.proofUpgradeConsensusState);
        if (message.signer !== "") writer.uint32(50).string(message.signer);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $1ffe4eb8410e0d1d$var$_m0.Reader ? input : new $1ffe4eb8410e0d1d$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $1ffe4eb8410e0d1d$var$createBaseMsgUpgradeClient();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.clientId = reader.string();
                    break;
                case 2:
                    message.clientState = $64138e590dcf0cc1$exports.Any.decode(reader, reader.uint32());
                    break;
                case 3:
                    message.consensusState = $64138e590dcf0cc1$exports.Any.decode(reader, reader.uint32());
                    break;
                case 4:
                    message.proofUpgradeClient = reader.bytes();
                    break;
                case 5:
                    message.proofUpgradeConsensusState = reader.bytes();
                    break;
                case 6:
                    message.signer = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            clientId: (0, $d5e07fe2518aae94$exports.isSet)(object.clientId) ? String(object.clientId) : "",
            clientState: (0, $d5e07fe2518aae94$exports.isSet)(object.clientState) ? $64138e590dcf0cc1$exports.Any.fromJSON(object.clientState) : undefined,
            consensusState: (0, $d5e07fe2518aae94$exports.isSet)(object.consensusState) ? $64138e590dcf0cc1$exports.Any.fromJSON(object.consensusState) : undefined,
            proofUpgradeClient: (0, $d5e07fe2518aae94$exports.isSet)(object.proofUpgradeClient) ? (0, $d5e07fe2518aae94$exports.bytesFromBase64)(object.proofUpgradeClient) : new Uint8Array(),
            proofUpgradeConsensusState: (0, $d5e07fe2518aae94$exports.isSet)(object.proofUpgradeConsensusState) ? (0, $d5e07fe2518aae94$exports.bytesFromBase64)(object.proofUpgradeConsensusState) : new Uint8Array(),
            signer: (0, $d5e07fe2518aae94$exports.isSet)(object.signer) ? String(object.signer) : ""
        };
    },
    toJSON (message) {
        const obj = {};
        message.clientId !== undefined && (obj.clientId = message.clientId);
        message.clientState !== undefined && (obj.clientState = message.clientState ? $64138e590dcf0cc1$exports.Any.toJSON(message.clientState) : undefined);
        message.consensusState !== undefined && (obj.consensusState = message.consensusState ? $64138e590dcf0cc1$exports.Any.toJSON(message.consensusState) : undefined);
        message.proofUpgradeClient !== undefined && (obj.proofUpgradeClient = (0, $d5e07fe2518aae94$exports.base64FromBytes)(message.proofUpgradeClient !== undefined ? message.proofUpgradeClient : new Uint8Array()));
        message.proofUpgradeConsensusState !== undefined && (obj.proofUpgradeConsensusState = (0, $d5e07fe2518aae94$exports.base64FromBytes)(message.proofUpgradeConsensusState !== undefined ? message.proofUpgradeConsensusState : new Uint8Array()));
        message.signer !== undefined && (obj.signer = message.signer);
        return obj;
    },
    fromPartial (object) {
        const message = $1ffe4eb8410e0d1d$var$createBaseMsgUpgradeClient();
        message.clientId = object.clientId ?? "";
        message.clientState = object.clientState !== undefined && object.clientState !== null ? $64138e590dcf0cc1$exports.Any.fromPartial(object.clientState) : undefined;
        message.consensusState = object.consensusState !== undefined && object.consensusState !== null ? $64138e590dcf0cc1$exports.Any.fromPartial(object.consensusState) : undefined;
        message.proofUpgradeClient = object.proofUpgradeClient ?? new Uint8Array();
        message.proofUpgradeConsensusState = object.proofUpgradeConsensusState ?? new Uint8Array();
        message.signer = object.signer ?? "";
        return message;
    }
};
function $1ffe4eb8410e0d1d$var$createBaseMsgUpgradeClientResponse() {
    return {};
}
$1ffe4eb8410e0d1d$exports.MsgUpgradeClientResponse = {
    encode (_, writer = $1ffe4eb8410e0d1d$var$_m0.Writer.create()) {
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $1ffe4eb8410e0d1d$var$_m0.Reader ? input : new $1ffe4eb8410e0d1d$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $1ffe4eb8410e0d1d$var$createBaseMsgUpgradeClientResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            tag;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON (_) {
        return {};
    },
    toJSON (_) {
        const obj = {};
        return obj;
    },
    fromPartial (_) {
        const message = $1ffe4eb8410e0d1d$var$createBaseMsgUpgradeClientResponse();
        return message;
    }
};
function $1ffe4eb8410e0d1d$var$createBaseMsgSubmitMisbehaviour() {
    return {
        clientId: "",
        misbehaviour: undefined,
        signer: ""
    };
}
$1ffe4eb8410e0d1d$exports.MsgSubmitMisbehaviour = {
    encode (message, writer = $1ffe4eb8410e0d1d$var$_m0.Writer.create()) {
        if (message.clientId !== "") writer.uint32(10).string(message.clientId);
        if (message.misbehaviour !== undefined) $64138e590dcf0cc1$exports.Any.encode(message.misbehaviour, writer.uint32(18).fork()).ldelim();
        if (message.signer !== "") writer.uint32(26).string(message.signer);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $1ffe4eb8410e0d1d$var$_m0.Reader ? input : new $1ffe4eb8410e0d1d$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $1ffe4eb8410e0d1d$var$createBaseMsgSubmitMisbehaviour();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.clientId = reader.string();
                    break;
                case 2:
                    message.misbehaviour = $64138e590dcf0cc1$exports.Any.decode(reader, reader.uint32());
                    break;
                case 3:
                    message.signer = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            clientId: (0, $d5e07fe2518aae94$exports.isSet)(object.clientId) ? String(object.clientId) : "",
            misbehaviour: (0, $d5e07fe2518aae94$exports.isSet)(object.misbehaviour) ? $64138e590dcf0cc1$exports.Any.fromJSON(object.misbehaviour) : undefined,
            signer: (0, $d5e07fe2518aae94$exports.isSet)(object.signer) ? String(object.signer) : ""
        };
    },
    toJSON (message) {
        const obj = {};
        message.clientId !== undefined && (obj.clientId = message.clientId);
        message.misbehaviour !== undefined && (obj.misbehaviour = message.misbehaviour ? $64138e590dcf0cc1$exports.Any.toJSON(message.misbehaviour) : undefined);
        message.signer !== undefined && (obj.signer = message.signer);
        return obj;
    },
    fromPartial (object) {
        const message = $1ffe4eb8410e0d1d$var$createBaseMsgSubmitMisbehaviour();
        message.clientId = object.clientId ?? "";
        message.misbehaviour = object.misbehaviour !== undefined && object.misbehaviour !== null ? $64138e590dcf0cc1$exports.Any.fromPartial(object.misbehaviour) : undefined;
        message.signer = object.signer ?? "";
        return message;
    }
};
function $1ffe4eb8410e0d1d$var$createBaseMsgSubmitMisbehaviourResponse() {
    return {};
}
$1ffe4eb8410e0d1d$exports.MsgSubmitMisbehaviourResponse = {
    encode (_, writer = $1ffe4eb8410e0d1d$var$_m0.Writer.create()) {
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $1ffe4eb8410e0d1d$var$_m0.Reader ? input : new $1ffe4eb8410e0d1d$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $1ffe4eb8410e0d1d$var$createBaseMsgSubmitMisbehaviourResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            tag;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON (_) {
        return {};
    },
    toJSON (_) {
        const obj = {};
        return obj;
    },
    fromPartial (_) {
        const message = $1ffe4eb8410e0d1d$var$createBaseMsgSubmitMisbehaviourResponse();
        return message;
    }
};
class $1ffe4eb8410e0d1d$var$MsgClientImpl {
    constructor(rpc){
        this.rpc = rpc;
        this.CreateClient = this.CreateClient.bind(this);
        this.UpdateClient = this.UpdateClient.bind(this);
        this.UpgradeClient = this.UpgradeClient.bind(this);
        this.SubmitMisbehaviour = this.SubmitMisbehaviour.bind(this);
    }
    CreateClient(request) {
        const data = $1ffe4eb8410e0d1d$exports.MsgCreateClient.encode(request).finish();
        const promise = this.rpc.request("ibc.core.client.v1.Msg", "CreateClient", data);
        return promise.then((data)=>$1ffe4eb8410e0d1d$exports.MsgCreateClientResponse.decode(new $1ffe4eb8410e0d1d$var$_m0.Reader(data)));
    }
    UpdateClient(request) {
        const data = $1ffe4eb8410e0d1d$exports.MsgUpdateClient.encode(request).finish();
        const promise = this.rpc.request("ibc.core.client.v1.Msg", "UpdateClient", data);
        return promise.then((data)=>$1ffe4eb8410e0d1d$exports.MsgUpdateClientResponse.decode(new $1ffe4eb8410e0d1d$var$_m0.Reader(data)));
    }
    UpgradeClient(request) {
        const data = $1ffe4eb8410e0d1d$exports.MsgUpgradeClient.encode(request).finish();
        const promise = this.rpc.request("ibc.core.client.v1.Msg", "UpgradeClient", data);
        return promise.then((data)=>$1ffe4eb8410e0d1d$exports.MsgUpgradeClientResponse.decode(new $1ffe4eb8410e0d1d$var$_m0.Reader(data)));
    }
    SubmitMisbehaviour(request) {
        const data = $1ffe4eb8410e0d1d$exports.MsgSubmitMisbehaviour.encode(request).finish();
        const promise = this.rpc.request("ibc.core.client.v1.Msg", "SubmitMisbehaviour", data);
        return promise.then((data)=>$1ffe4eb8410e0d1d$exports.MsgSubmitMisbehaviourResponse.decode(new $1ffe4eb8410e0d1d$var$_m0.Reader(data)));
    }
}
$1ffe4eb8410e0d1d$exports.MsgClientImpl = $1ffe4eb8410e0d1d$var$MsgClientImpl;


var $38161549ebd31952$exports = {};
"use strict";
var $38161549ebd31952$var$__createBinding = $38161549ebd31952$exports && $38161549ebd31952$exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $38161549ebd31952$var$__setModuleDefault = $38161549ebd31952$exports && $38161549ebd31952$exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $38161549ebd31952$var$__importStar = $38161549ebd31952$exports && $38161549ebd31952$exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $38161549ebd31952$var$__createBinding(result, mod, k);
    }
    $38161549ebd31952$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty($38161549ebd31952$exports, "__esModule", {
    value: true
});
$38161549ebd31952$exports.MsgClientImpl = $38161549ebd31952$exports.MsgConnectionOpenConfirmResponse = $38161549ebd31952$exports.MsgConnectionOpenConfirm = $38161549ebd31952$exports.MsgConnectionOpenAckResponse = $38161549ebd31952$exports.MsgConnectionOpenAck = $38161549ebd31952$exports.MsgConnectionOpenTryResponse = $38161549ebd31952$exports.MsgConnectionOpenTry = $38161549ebd31952$exports.MsgConnectionOpenInitResponse = $38161549ebd31952$exports.MsgConnectionOpenInit = $38161549ebd31952$exports.protobufPackage = void 0;
var $42dc008ab8b50be1$exports = {};
"use strict";
var $42dc008ab8b50be1$var$__createBinding = $42dc008ab8b50be1$exports && $42dc008ab8b50be1$exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $42dc008ab8b50be1$var$__setModuleDefault = $42dc008ab8b50be1$exports && $42dc008ab8b50be1$exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $42dc008ab8b50be1$var$__importStar = $42dc008ab8b50be1$exports && $42dc008ab8b50be1$exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $42dc008ab8b50be1$var$__createBinding(result, mod, k);
    }
    $42dc008ab8b50be1$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty($42dc008ab8b50be1$exports, "__esModule", {
    value: true
});
$42dc008ab8b50be1$exports.Params = $42dc008ab8b50be1$exports.Version = $42dc008ab8b50be1$exports.ConnectionPaths = $42dc008ab8b50be1$exports.ClientPaths = $42dc008ab8b50be1$exports.Counterparty = $42dc008ab8b50be1$exports.IdentifiedConnection = $42dc008ab8b50be1$exports.ConnectionEnd = $42dc008ab8b50be1$exports.stateToJSON = $42dc008ab8b50be1$exports.stateFromJSON = $42dc008ab8b50be1$exports.State = $42dc008ab8b50be1$exports.protobufPackage = void 0;
var $e7e3d90550b1093b$exports = {};
"use strict";
var $e7e3d90550b1093b$var$__createBinding = $e7e3d90550b1093b$exports && $e7e3d90550b1093b$exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $e7e3d90550b1093b$var$__setModuleDefault = $e7e3d90550b1093b$exports && $e7e3d90550b1093b$exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $e7e3d90550b1093b$var$__importStar = $e7e3d90550b1093b$exports && $e7e3d90550b1093b$exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $e7e3d90550b1093b$var$__createBinding(result, mod, k);
    }
    $e7e3d90550b1093b$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty($e7e3d90550b1093b$exports, "__esModule", {
    value: true
});
$e7e3d90550b1093b$exports.MerkleProof = $e7e3d90550b1093b$exports.MerklePath = $e7e3d90550b1093b$exports.MerklePrefix = $e7e3d90550b1093b$exports.MerkleRoot = $e7e3d90550b1093b$exports.protobufPackage = void 0;
var $bd613a5d258cd296$exports = {};
"use strict";
var $bd613a5d258cd296$var$__createBinding = $bd613a5d258cd296$exports && $bd613a5d258cd296$exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $bd613a5d258cd296$var$__setModuleDefault = $bd613a5d258cd296$exports && $bd613a5d258cd296$exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $bd613a5d258cd296$var$__importStar = $bd613a5d258cd296$exports && $bd613a5d258cd296$exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $bd613a5d258cd296$var$__createBinding(result, mod, k);
    }
    $bd613a5d258cd296$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty($bd613a5d258cd296$exports, "__esModule", {
    value: true
});
$bd613a5d258cd296$exports.CompressedNonExistenceProof = $bd613a5d258cd296$exports.CompressedExistenceProof = $bd613a5d258cd296$exports.CompressedBatchEntry = $bd613a5d258cd296$exports.CompressedBatchProof = $bd613a5d258cd296$exports.BatchEntry = $bd613a5d258cd296$exports.BatchProof = $bd613a5d258cd296$exports.InnerSpec = $bd613a5d258cd296$exports.ProofSpec = $bd613a5d258cd296$exports.InnerOp = $bd613a5d258cd296$exports.LeafOp = $bd613a5d258cd296$exports.CommitmentProof = $bd613a5d258cd296$exports.NonExistenceProof = $bd613a5d258cd296$exports.ExistenceProof = $bd613a5d258cd296$exports.lengthOpToJSON = $bd613a5d258cd296$exports.lengthOpFromJSON = $bd613a5d258cd296$exports.LengthOp = $bd613a5d258cd296$exports.hashOpToJSON = $bd613a5d258cd296$exports.hashOpFromJSON = $bd613a5d258cd296$exports.HashOp = $bd613a5d258cd296$exports.protobufPackage = void 0;

/* eslint-disable */ const $bd613a5d258cd296$var$_m0 = $bd613a5d258cd296$var$__importStar((parcelRequire("fQBv0")));

$bd613a5d258cd296$exports.protobufPackage = "cosmos.ics23.v1";
var $bd613a5d258cd296$var$HashOp;
(function(HashOp) {
    /** NO_HASH - NO_HASH is the default if no data passed. Note this is an illegal argument some places. */ HashOp[HashOp["NO_HASH"] = 0] = "NO_HASH";
    HashOp[HashOp["SHA256"] = 1] = "SHA256";
    HashOp[HashOp["SHA512"] = 2] = "SHA512";
    HashOp[HashOp["KECCAK"] = 3] = "KECCAK";
    HashOp[HashOp["RIPEMD160"] = 4] = "RIPEMD160";
    /** BITCOIN - ripemd160(sha256(x)) */ HashOp[HashOp["BITCOIN"] = 5] = "BITCOIN";
    HashOp[HashOp["SHA512_256"] = 6] = "SHA512_256";
    HashOp[HashOp["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})($bd613a5d258cd296$var$HashOp = $bd613a5d258cd296$exports.HashOp || ($bd613a5d258cd296$exports.HashOp = {}));
function $bd613a5d258cd296$var$hashOpFromJSON(object) {
    switch(object){
        case 0:
        case "NO_HASH":
            return $bd613a5d258cd296$var$HashOp.NO_HASH;
        case 1:
        case "SHA256":
            return $bd613a5d258cd296$var$HashOp.SHA256;
        case 2:
        case "SHA512":
            return $bd613a5d258cd296$var$HashOp.SHA512;
        case 3:
        case "KECCAK":
            return $bd613a5d258cd296$var$HashOp.KECCAK;
        case 4:
        case "RIPEMD160":
            return $bd613a5d258cd296$var$HashOp.RIPEMD160;
        case 5:
        case "BITCOIN":
            return $bd613a5d258cd296$var$HashOp.BITCOIN;
        case 6:
        case "SHA512_256":
            return $bd613a5d258cd296$var$HashOp.SHA512_256;
        case -1:
        case "UNRECOGNIZED":
        default:
            return $bd613a5d258cd296$var$HashOp.UNRECOGNIZED;
    }
}
$bd613a5d258cd296$exports.hashOpFromJSON = $bd613a5d258cd296$var$hashOpFromJSON;
function $bd613a5d258cd296$var$hashOpToJSON(object) {
    switch(object){
        case $bd613a5d258cd296$var$HashOp.NO_HASH:
            return "NO_HASH";
        case $bd613a5d258cd296$var$HashOp.SHA256:
            return "SHA256";
        case $bd613a5d258cd296$var$HashOp.SHA512:
            return "SHA512";
        case $bd613a5d258cd296$var$HashOp.KECCAK:
            return "KECCAK";
        case $bd613a5d258cd296$var$HashOp.RIPEMD160:
            return "RIPEMD160";
        case $bd613a5d258cd296$var$HashOp.BITCOIN:
            return "BITCOIN";
        case $bd613a5d258cd296$var$HashOp.SHA512_256:
            return "SHA512_256";
        case $bd613a5d258cd296$var$HashOp.UNRECOGNIZED:
        default:
            return "UNRECOGNIZED";
    }
}
$bd613a5d258cd296$exports.hashOpToJSON = $bd613a5d258cd296$var$hashOpToJSON;
/**
 * LengthOp defines how to process the key and value of the LeafOp
 * to include length information. After encoding the length with the given
 * algorithm, the length will be prepended to the key and value bytes.
 * (Each one with it's own encoded length)
 */ var $bd613a5d258cd296$var$LengthOp;
(function(LengthOp) {
    /** NO_PREFIX - NO_PREFIX don't include any length info */ LengthOp[LengthOp["NO_PREFIX"] = 0] = "NO_PREFIX";
    /** VAR_PROTO - VAR_PROTO uses protobuf (and go-amino) varint encoding of the length */ LengthOp[LengthOp["VAR_PROTO"] = 1] = "VAR_PROTO";
    /** VAR_RLP - VAR_RLP uses rlp int encoding of the length */ LengthOp[LengthOp["VAR_RLP"] = 2] = "VAR_RLP";
    /** FIXED32_BIG - FIXED32_BIG uses big-endian encoding of the length as a 32 bit integer */ LengthOp[LengthOp["FIXED32_BIG"] = 3] = "FIXED32_BIG";
    /** FIXED32_LITTLE - FIXED32_LITTLE uses little-endian encoding of the length as a 32 bit integer */ LengthOp[LengthOp["FIXED32_LITTLE"] = 4] = "FIXED32_LITTLE";
    /** FIXED64_BIG - FIXED64_BIG uses big-endian encoding of the length as a 64 bit integer */ LengthOp[LengthOp["FIXED64_BIG"] = 5] = "FIXED64_BIG";
    /** FIXED64_LITTLE - FIXED64_LITTLE uses little-endian encoding of the length as a 64 bit integer */ LengthOp[LengthOp["FIXED64_LITTLE"] = 6] = "FIXED64_LITTLE";
    /** REQUIRE_32_BYTES - REQUIRE_32_BYTES is like NONE, but will fail if the input is not exactly 32 bytes (sha256 output) */ LengthOp[LengthOp["REQUIRE_32_BYTES"] = 7] = "REQUIRE_32_BYTES";
    /** REQUIRE_64_BYTES - REQUIRE_64_BYTES is like NONE, but will fail if the input is not exactly 64 bytes (sha512 output) */ LengthOp[LengthOp["REQUIRE_64_BYTES"] = 8] = "REQUIRE_64_BYTES";
    LengthOp[LengthOp["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})($bd613a5d258cd296$var$LengthOp = $bd613a5d258cd296$exports.LengthOp || ($bd613a5d258cd296$exports.LengthOp = {}));
function $bd613a5d258cd296$var$lengthOpFromJSON(object) {
    switch(object){
        case 0:
        case "NO_PREFIX":
            return $bd613a5d258cd296$var$LengthOp.NO_PREFIX;
        case 1:
        case "VAR_PROTO":
            return $bd613a5d258cd296$var$LengthOp.VAR_PROTO;
        case 2:
        case "VAR_RLP":
            return $bd613a5d258cd296$var$LengthOp.VAR_RLP;
        case 3:
        case "FIXED32_BIG":
            return $bd613a5d258cd296$var$LengthOp.FIXED32_BIG;
        case 4:
        case "FIXED32_LITTLE":
            return $bd613a5d258cd296$var$LengthOp.FIXED32_LITTLE;
        case 5:
        case "FIXED64_BIG":
            return $bd613a5d258cd296$var$LengthOp.FIXED64_BIG;
        case 6:
        case "FIXED64_LITTLE":
            return $bd613a5d258cd296$var$LengthOp.FIXED64_LITTLE;
        case 7:
        case "REQUIRE_32_BYTES":
            return $bd613a5d258cd296$var$LengthOp.REQUIRE_32_BYTES;
        case 8:
        case "REQUIRE_64_BYTES":
            return $bd613a5d258cd296$var$LengthOp.REQUIRE_64_BYTES;
        case -1:
        case "UNRECOGNIZED":
        default:
            return $bd613a5d258cd296$var$LengthOp.UNRECOGNIZED;
    }
}
$bd613a5d258cd296$exports.lengthOpFromJSON = $bd613a5d258cd296$var$lengthOpFromJSON;
function $bd613a5d258cd296$var$lengthOpToJSON(object) {
    switch(object){
        case $bd613a5d258cd296$var$LengthOp.NO_PREFIX:
            return "NO_PREFIX";
        case $bd613a5d258cd296$var$LengthOp.VAR_PROTO:
            return "VAR_PROTO";
        case $bd613a5d258cd296$var$LengthOp.VAR_RLP:
            return "VAR_RLP";
        case $bd613a5d258cd296$var$LengthOp.FIXED32_BIG:
            return "FIXED32_BIG";
        case $bd613a5d258cd296$var$LengthOp.FIXED32_LITTLE:
            return "FIXED32_LITTLE";
        case $bd613a5d258cd296$var$LengthOp.FIXED64_BIG:
            return "FIXED64_BIG";
        case $bd613a5d258cd296$var$LengthOp.FIXED64_LITTLE:
            return "FIXED64_LITTLE";
        case $bd613a5d258cd296$var$LengthOp.REQUIRE_32_BYTES:
            return "REQUIRE_32_BYTES";
        case $bd613a5d258cd296$var$LengthOp.REQUIRE_64_BYTES:
            return "REQUIRE_64_BYTES";
        case $bd613a5d258cd296$var$LengthOp.UNRECOGNIZED:
        default:
            return "UNRECOGNIZED";
    }
}
$bd613a5d258cd296$exports.lengthOpToJSON = $bd613a5d258cd296$var$lengthOpToJSON;
function $bd613a5d258cd296$var$createBaseExistenceProof() {
    return {
        key: new Uint8Array(),
        value: new Uint8Array(),
        leaf: undefined,
        path: []
    };
}
$bd613a5d258cd296$exports.ExistenceProof = {
    encode (message, writer = $bd613a5d258cd296$var$_m0.Writer.create()) {
        if (message.key.length !== 0) writer.uint32(10).bytes(message.key);
        if (message.value.length !== 0) writer.uint32(18).bytes(message.value);
        if (message.leaf !== undefined) $bd613a5d258cd296$exports.LeafOp.encode(message.leaf, writer.uint32(26).fork()).ldelim();
        for (const v of message.path)$bd613a5d258cd296$exports.InnerOp.encode(v, writer.uint32(34).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $bd613a5d258cd296$var$_m0.Reader ? input : new $bd613a5d258cd296$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $bd613a5d258cd296$var$createBaseExistenceProof();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.key = reader.bytes();
                    break;
                case 2:
                    message.value = reader.bytes();
                    break;
                case 3:
                    message.leaf = $bd613a5d258cd296$exports.LeafOp.decode(reader, reader.uint32());
                    break;
                case 4:
                    message.path.push($bd613a5d258cd296$exports.InnerOp.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            key: (0, $d5e07fe2518aae94$exports.isSet)(object.key) ? (0, $d5e07fe2518aae94$exports.bytesFromBase64)(object.key) : new Uint8Array(),
            value: (0, $d5e07fe2518aae94$exports.isSet)(object.value) ? (0, $d5e07fe2518aae94$exports.bytesFromBase64)(object.value) : new Uint8Array(),
            leaf: (0, $d5e07fe2518aae94$exports.isSet)(object.leaf) ? $bd613a5d258cd296$exports.LeafOp.fromJSON(object.leaf) : undefined,
            path: Array.isArray(object?.path) ? object.path.map((e)=>$bd613a5d258cd296$exports.InnerOp.fromJSON(e)) : []
        };
    },
    toJSON (message) {
        const obj = {};
        message.key !== undefined && (obj.key = (0, $d5e07fe2518aae94$exports.base64FromBytes)(message.key !== undefined ? message.key : new Uint8Array()));
        message.value !== undefined && (obj.value = (0, $d5e07fe2518aae94$exports.base64FromBytes)(message.value !== undefined ? message.value : new Uint8Array()));
        message.leaf !== undefined && (obj.leaf = message.leaf ? $bd613a5d258cd296$exports.LeafOp.toJSON(message.leaf) : undefined);
        if (message.path) obj.path = message.path.map((e)=>e ? $bd613a5d258cd296$exports.InnerOp.toJSON(e) : undefined);
        else obj.path = [];
        return obj;
    },
    fromPartial (object) {
        const message = $bd613a5d258cd296$var$createBaseExistenceProof();
        message.key = object.key ?? new Uint8Array();
        message.value = object.value ?? new Uint8Array();
        message.leaf = object.leaf !== undefined && object.leaf !== null ? $bd613a5d258cd296$exports.LeafOp.fromPartial(object.leaf) : undefined;
        message.path = object.path?.map((e)=>$bd613a5d258cd296$exports.InnerOp.fromPartial(e)) || [];
        return message;
    }
};
function $bd613a5d258cd296$var$createBaseNonExistenceProof() {
    return {
        key: new Uint8Array(),
        left: undefined,
        right: undefined
    };
}
$bd613a5d258cd296$exports.NonExistenceProof = {
    encode (message, writer = $bd613a5d258cd296$var$_m0.Writer.create()) {
        if (message.key.length !== 0) writer.uint32(10).bytes(message.key);
        if (message.left !== undefined) $bd613a5d258cd296$exports.ExistenceProof.encode(message.left, writer.uint32(18).fork()).ldelim();
        if (message.right !== undefined) $bd613a5d258cd296$exports.ExistenceProof.encode(message.right, writer.uint32(26).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $bd613a5d258cd296$var$_m0.Reader ? input : new $bd613a5d258cd296$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $bd613a5d258cd296$var$createBaseNonExistenceProof();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.key = reader.bytes();
                    break;
                case 2:
                    message.left = $bd613a5d258cd296$exports.ExistenceProof.decode(reader, reader.uint32());
                    break;
                case 3:
                    message.right = $bd613a5d258cd296$exports.ExistenceProof.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            key: (0, $d5e07fe2518aae94$exports.isSet)(object.key) ? (0, $d5e07fe2518aae94$exports.bytesFromBase64)(object.key) : new Uint8Array(),
            left: (0, $d5e07fe2518aae94$exports.isSet)(object.left) ? $bd613a5d258cd296$exports.ExistenceProof.fromJSON(object.left) : undefined,
            right: (0, $d5e07fe2518aae94$exports.isSet)(object.right) ? $bd613a5d258cd296$exports.ExistenceProof.fromJSON(object.right) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.key !== undefined && (obj.key = (0, $d5e07fe2518aae94$exports.base64FromBytes)(message.key !== undefined ? message.key : new Uint8Array()));
        message.left !== undefined && (obj.left = message.left ? $bd613a5d258cd296$exports.ExistenceProof.toJSON(message.left) : undefined);
        message.right !== undefined && (obj.right = message.right ? $bd613a5d258cd296$exports.ExistenceProof.toJSON(message.right) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $bd613a5d258cd296$var$createBaseNonExistenceProof();
        message.key = object.key ?? new Uint8Array();
        message.left = object.left !== undefined && object.left !== null ? $bd613a5d258cd296$exports.ExistenceProof.fromPartial(object.left) : undefined;
        message.right = object.right !== undefined && object.right !== null ? $bd613a5d258cd296$exports.ExistenceProof.fromPartial(object.right) : undefined;
        return message;
    }
};
function $bd613a5d258cd296$var$createBaseCommitmentProof() {
    return {
        exist: undefined,
        nonexist: undefined,
        batch: undefined,
        compressed: undefined
    };
}
$bd613a5d258cd296$exports.CommitmentProof = {
    encode (message, writer = $bd613a5d258cd296$var$_m0.Writer.create()) {
        if (message.exist !== undefined) $bd613a5d258cd296$exports.ExistenceProof.encode(message.exist, writer.uint32(10).fork()).ldelim();
        if (message.nonexist !== undefined) $bd613a5d258cd296$exports.NonExistenceProof.encode(message.nonexist, writer.uint32(18).fork()).ldelim();
        if (message.batch !== undefined) $bd613a5d258cd296$exports.BatchProof.encode(message.batch, writer.uint32(26).fork()).ldelim();
        if (message.compressed !== undefined) $bd613a5d258cd296$exports.CompressedBatchProof.encode(message.compressed, writer.uint32(34).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $bd613a5d258cd296$var$_m0.Reader ? input : new $bd613a5d258cd296$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $bd613a5d258cd296$var$createBaseCommitmentProof();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.exist = $bd613a5d258cd296$exports.ExistenceProof.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.nonexist = $bd613a5d258cd296$exports.NonExistenceProof.decode(reader, reader.uint32());
                    break;
                case 3:
                    message.batch = $bd613a5d258cd296$exports.BatchProof.decode(reader, reader.uint32());
                    break;
                case 4:
                    message.compressed = $bd613a5d258cd296$exports.CompressedBatchProof.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            exist: (0, $d5e07fe2518aae94$exports.isSet)(object.exist) ? $bd613a5d258cd296$exports.ExistenceProof.fromJSON(object.exist) : undefined,
            nonexist: (0, $d5e07fe2518aae94$exports.isSet)(object.nonexist) ? $bd613a5d258cd296$exports.NonExistenceProof.fromJSON(object.nonexist) : undefined,
            batch: (0, $d5e07fe2518aae94$exports.isSet)(object.batch) ? $bd613a5d258cd296$exports.BatchProof.fromJSON(object.batch) : undefined,
            compressed: (0, $d5e07fe2518aae94$exports.isSet)(object.compressed) ? $bd613a5d258cd296$exports.CompressedBatchProof.fromJSON(object.compressed) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.exist !== undefined && (obj.exist = message.exist ? $bd613a5d258cd296$exports.ExistenceProof.toJSON(message.exist) : undefined);
        message.nonexist !== undefined && (obj.nonexist = message.nonexist ? $bd613a5d258cd296$exports.NonExistenceProof.toJSON(message.nonexist) : undefined);
        message.batch !== undefined && (obj.batch = message.batch ? $bd613a5d258cd296$exports.BatchProof.toJSON(message.batch) : undefined);
        message.compressed !== undefined && (obj.compressed = message.compressed ? $bd613a5d258cd296$exports.CompressedBatchProof.toJSON(message.compressed) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $bd613a5d258cd296$var$createBaseCommitmentProof();
        message.exist = object.exist !== undefined && object.exist !== null ? $bd613a5d258cd296$exports.ExistenceProof.fromPartial(object.exist) : undefined;
        message.nonexist = object.nonexist !== undefined && object.nonexist !== null ? $bd613a5d258cd296$exports.NonExistenceProof.fromPartial(object.nonexist) : undefined;
        message.batch = object.batch !== undefined && object.batch !== null ? $bd613a5d258cd296$exports.BatchProof.fromPartial(object.batch) : undefined;
        message.compressed = object.compressed !== undefined && object.compressed !== null ? $bd613a5d258cd296$exports.CompressedBatchProof.fromPartial(object.compressed) : undefined;
        return message;
    }
};
function $bd613a5d258cd296$var$createBaseLeafOp() {
    return {
        hash: 0,
        prehashKey: 0,
        prehashValue: 0,
        length: 0,
        prefix: new Uint8Array()
    };
}
$bd613a5d258cd296$exports.LeafOp = {
    encode (message, writer = $bd613a5d258cd296$var$_m0.Writer.create()) {
        if (message.hash !== 0) writer.uint32(8).int32(message.hash);
        if (message.prehashKey !== 0) writer.uint32(16).int32(message.prehashKey);
        if (message.prehashValue !== 0) writer.uint32(24).int32(message.prehashValue);
        if (message.length !== 0) writer.uint32(32).int32(message.length);
        if (message.prefix.length !== 0) writer.uint32(42).bytes(message.prefix);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $bd613a5d258cd296$var$_m0.Reader ? input : new $bd613a5d258cd296$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $bd613a5d258cd296$var$createBaseLeafOp();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.hash = reader.int32();
                    break;
                case 2:
                    message.prehashKey = reader.int32();
                    break;
                case 3:
                    message.prehashValue = reader.int32();
                    break;
                case 4:
                    message.length = reader.int32();
                    break;
                case 5:
                    message.prefix = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            hash: (0, $d5e07fe2518aae94$exports.isSet)(object.hash) ? $bd613a5d258cd296$var$hashOpFromJSON(object.hash) : 0,
            prehashKey: (0, $d5e07fe2518aae94$exports.isSet)(object.prehashKey) ? $bd613a5d258cd296$var$hashOpFromJSON(object.prehashKey) : 0,
            prehashValue: (0, $d5e07fe2518aae94$exports.isSet)(object.prehashValue) ? $bd613a5d258cd296$var$hashOpFromJSON(object.prehashValue) : 0,
            length: (0, $d5e07fe2518aae94$exports.isSet)(object.length) ? $bd613a5d258cd296$var$lengthOpFromJSON(object.length) : 0,
            prefix: (0, $d5e07fe2518aae94$exports.isSet)(object.prefix) ? (0, $d5e07fe2518aae94$exports.bytesFromBase64)(object.prefix) : new Uint8Array()
        };
    },
    toJSON (message) {
        const obj = {};
        message.hash !== undefined && (obj.hash = $bd613a5d258cd296$var$hashOpToJSON(message.hash));
        message.prehashKey !== undefined && (obj.prehashKey = $bd613a5d258cd296$var$hashOpToJSON(message.prehashKey));
        message.prehashValue !== undefined && (obj.prehashValue = $bd613a5d258cd296$var$hashOpToJSON(message.prehashValue));
        message.length !== undefined && (obj.length = $bd613a5d258cd296$var$lengthOpToJSON(message.length));
        message.prefix !== undefined && (obj.prefix = (0, $d5e07fe2518aae94$exports.base64FromBytes)(message.prefix !== undefined ? message.prefix : new Uint8Array()));
        return obj;
    },
    fromPartial (object) {
        const message = $bd613a5d258cd296$var$createBaseLeafOp();
        message.hash = object.hash ?? 0;
        message.prehashKey = object.prehashKey ?? 0;
        message.prehashValue = object.prehashValue ?? 0;
        message.length = object.length ?? 0;
        message.prefix = object.prefix ?? new Uint8Array();
        return message;
    }
};
function $bd613a5d258cd296$var$createBaseInnerOp() {
    return {
        hash: 0,
        prefix: new Uint8Array(),
        suffix: new Uint8Array()
    };
}
$bd613a5d258cd296$exports.InnerOp = {
    encode (message, writer = $bd613a5d258cd296$var$_m0.Writer.create()) {
        if (message.hash !== 0) writer.uint32(8).int32(message.hash);
        if (message.prefix.length !== 0) writer.uint32(18).bytes(message.prefix);
        if (message.suffix.length !== 0) writer.uint32(26).bytes(message.suffix);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $bd613a5d258cd296$var$_m0.Reader ? input : new $bd613a5d258cd296$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $bd613a5d258cd296$var$createBaseInnerOp();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.hash = reader.int32();
                    break;
                case 2:
                    message.prefix = reader.bytes();
                    break;
                case 3:
                    message.suffix = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            hash: (0, $d5e07fe2518aae94$exports.isSet)(object.hash) ? $bd613a5d258cd296$var$hashOpFromJSON(object.hash) : 0,
            prefix: (0, $d5e07fe2518aae94$exports.isSet)(object.prefix) ? (0, $d5e07fe2518aae94$exports.bytesFromBase64)(object.prefix) : new Uint8Array(),
            suffix: (0, $d5e07fe2518aae94$exports.isSet)(object.suffix) ? (0, $d5e07fe2518aae94$exports.bytesFromBase64)(object.suffix) : new Uint8Array()
        };
    },
    toJSON (message) {
        const obj = {};
        message.hash !== undefined && (obj.hash = $bd613a5d258cd296$var$hashOpToJSON(message.hash));
        message.prefix !== undefined && (obj.prefix = (0, $d5e07fe2518aae94$exports.base64FromBytes)(message.prefix !== undefined ? message.prefix : new Uint8Array()));
        message.suffix !== undefined && (obj.suffix = (0, $d5e07fe2518aae94$exports.base64FromBytes)(message.suffix !== undefined ? message.suffix : new Uint8Array()));
        return obj;
    },
    fromPartial (object) {
        const message = $bd613a5d258cd296$var$createBaseInnerOp();
        message.hash = object.hash ?? 0;
        message.prefix = object.prefix ?? new Uint8Array();
        message.suffix = object.suffix ?? new Uint8Array();
        return message;
    }
};
function $bd613a5d258cd296$var$createBaseProofSpec() {
    return {
        leafSpec: undefined,
        innerSpec: undefined,
        maxDepth: 0,
        minDepth: 0
    };
}
$bd613a5d258cd296$exports.ProofSpec = {
    encode (message, writer = $bd613a5d258cd296$var$_m0.Writer.create()) {
        if (message.leafSpec !== undefined) $bd613a5d258cd296$exports.LeafOp.encode(message.leafSpec, writer.uint32(10).fork()).ldelim();
        if (message.innerSpec !== undefined) $bd613a5d258cd296$exports.InnerSpec.encode(message.innerSpec, writer.uint32(18).fork()).ldelim();
        if (message.maxDepth !== 0) writer.uint32(24).int32(message.maxDepth);
        if (message.minDepth !== 0) writer.uint32(32).int32(message.minDepth);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $bd613a5d258cd296$var$_m0.Reader ? input : new $bd613a5d258cd296$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $bd613a5d258cd296$var$createBaseProofSpec();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.leafSpec = $bd613a5d258cd296$exports.LeafOp.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.innerSpec = $bd613a5d258cd296$exports.InnerSpec.decode(reader, reader.uint32());
                    break;
                case 3:
                    message.maxDepth = reader.int32();
                    break;
                case 4:
                    message.minDepth = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            leafSpec: (0, $d5e07fe2518aae94$exports.isSet)(object.leafSpec) ? $bd613a5d258cd296$exports.LeafOp.fromJSON(object.leafSpec) : undefined,
            innerSpec: (0, $d5e07fe2518aae94$exports.isSet)(object.innerSpec) ? $bd613a5d258cd296$exports.InnerSpec.fromJSON(object.innerSpec) : undefined,
            maxDepth: (0, $d5e07fe2518aae94$exports.isSet)(object.maxDepth) ? Number(object.maxDepth) : 0,
            minDepth: (0, $d5e07fe2518aae94$exports.isSet)(object.minDepth) ? Number(object.minDepth) : 0
        };
    },
    toJSON (message) {
        const obj = {};
        message.leafSpec !== undefined && (obj.leafSpec = message.leafSpec ? $bd613a5d258cd296$exports.LeafOp.toJSON(message.leafSpec) : undefined);
        message.innerSpec !== undefined && (obj.innerSpec = message.innerSpec ? $bd613a5d258cd296$exports.InnerSpec.toJSON(message.innerSpec) : undefined);
        message.maxDepth !== undefined && (obj.maxDepth = Math.round(message.maxDepth));
        message.minDepth !== undefined && (obj.minDepth = Math.round(message.minDepth));
        return obj;
    },
    fromPartial (object) {
        const message = $bd613a5d258cd296$var$createBaseProofSpec();
        message.leafSpec = object.leafSpec !== undefined && object.leafSpec !== null ? $bd613a5d258cd296$exports.LeafOp.fromPartial(object.leafSpec) : undefined;
        message.innerSpec = object.innerSpec !== undefined && object.innerSpec !== null ? $bd613a5d258cd296$exports.InnerSpec.fromPartial(object.innerSpec) : undefined;
        message.maxDepth = object.maxDepth ?? 0;
        message.minDepth = object.minDepth ?? 0;
        return message;
    }
};
function $bd613a5d258cd296$var$createBaseInnerSpec() {
    return {
        childOrder: [],
        childSize: 0,
        minPrefixLength: 0,
        maxPrefixLength: 0,
        emptyChild: new Uint8Array(),
        hash: 0
    };
}
$bd613a5d258cd296$exports.InnerSpec = {
    encode (message, writer = $bd613a5d258cd296$var$_m0.Writer.create()) {
        writer.uint32(10).fork();
        for (const v of message.childOrder)writer.int32(v);
        writer.ldelim();
        if (message.childSize !== 0) writer.uint32(16).int32(message.childSize);
        if (message.minPrefixLength !== 0) writer.uint32(24).int32(message.minPrefixLength);
        if (message.maxPrefixLength !== 0) writer.uint32(32).int32(message.maxPrefixLength);
        if (message.emptyChild.length !== 0) writer.uint32(42).bytes(message.emptyChild);
        if (message.hash !== 0) writer.uint32(48).int32(message.hash);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $bd613a5d258cd296$var$_m0.Reader ? input : new $bd613a5d258cd296$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $bd613a5d258cd296$var$createBaseInnerSpec();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    if ((tag & 7) === 2) {
                        const end2 = reader.uint32() + reader.pos;
                        while(reader.pos < end2)message.childOrder.push(reader.int32());
                    } else message.childOrder.push(reader.int32());
                    break;
                case 2:
                    message.childSize = reader.int32();
                    break;
                case 3:
                    message.minPrefixLength = reader.int32();
                    break;
                case 4:
                    message.maxPrefixLength = reader.int32();
                    break;
                case 5:
                    message.emptyChild = reader.bytes();
                    break;
                case 6:
                    message.hash = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            childOrder: Array.isArray(object?.childOrder) ? object.childOrder.map((e)=>Number(e)) : [],
            childSize: (0, $d5e07fe2518aae94$exports.isSet)(object.childSize) ? Number(object.childSize) : 0,
            minPrefixLength: (0, $d5e07fe2518aae94$exports.isSet)(object.minPrefixLength) ? Number(object.minPrefixLength) : 0,
            maxPrefixLength: (0, $d5e07fe2518aae94$exports.isSet)(object.maxPrefixLength) ? Number(object.maxPrefixLength) : 0,
            emptyChild: (0, $d5e07fe2518aae94$exports.isSet)(object.emptyChild) ? (0, $d5e07fe2518aae94$exports.bytesFromBase64)(object.emptyChild) : new Uint8Array(),
            hash: (0, $d5e07fe2518aae94$exports.isSet)(object.hash) ? $bd613a5d258cd296$var$hashOpFromJSON(object.hash) : 0
        };
    },
    toJSON (message) {
        const obj = {};
        if (message.childOrder) obj.childOrder = message.childOrder.map((e)=>Math.round(e));
        else obj.childOrder = [];
        message.childSize !== undefined && (obj.childSize = Math.round(message.childSize));
        message.minPrefixLength !== undefined && (obj.minPrefixLength = Math.round(message.minPrefixLength));
        message.maxPrefixLength !== undefined && (obj.maxPrefixLength = Math.round(message.maxPrefixLength));
        message.emptyChild !== undefined && (obj.emptyChild = (0, $d5e07fe2518aae94$exports.base64FromBytes)(message.emptyChild !== undefined ? message.emptyChild : new Uint8Array()));
        message.hash !== undefined && (obj.hash = $bd613a5d258cd296$var$hashOpToJSON(message.hash));
        return obj;
    },
    fromPartial (object) {
        const message = $bd613a5d258cd296$var$createBaseInnerSpec();
        message.childOrder = object.childOrder?.map((e)=>e) || [];
        message.childSize = object.childSize ?? 0;
        message.minPrefixLength = object.minPrefixLength ?? 0;
        message.maxPrefixLength = object.maxPrefixLength ?? 0;
        message.emptyChild = object.emptyChild ?? new Uint8Array();
        message.hash = object.hash ?? 0;
        return message;
    }
};
function $bd613a5d258cd296$var$createBaseBatchProof() {
    return {
        entries: []
    };
}
$bd613a5d258cd296$exports.BatchProof = {
    encode (message, writer = $bd613a5d258cd296$var$_m0.Writer.create()) {
        for (const v of message.entries)$bd613a5d258cd296$exports.BatchEntry.encode(v, writer.uint32(10).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $bd613a5d258cd296$var$_m0.Reader ? input : new $bd613a5d258cd296$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $bd613a5d258cd296$var$createBaseBatchProof();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.entries.push($bd613a5d258cd296$exports.BatchEntry.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            entries: Array.isArray(object?.entries) ? object.entries.map((e)=>$bd613a5d258cd296$exports.BatchEntry.fromJSON(e)) : []
        };
    },
    toJSON (message) {
        const obj = {};
        if (message.entries) obj.entries = message.entries.map((e)=>e ? $bd613a5d258cd296$exports.BatchEntry.toJSON(e) : undefined);
        else obj.entries = [];
        return obj;
    },
    fromPartial (object) {
        const message = $bd613a5d258cd296$var$createBaseBatchProof();
        message.entries = object.entries?.map((e)=>$bd613a5d258cd296$exports.BatchEntry.fromPartial(e)) || [];
        return message;
    }
};
function $bd613a5d258cd296$var$createBaseBatchEntry() {
    return {
        exist: undefined,
        nonexist: undefined
    };
}
$bd613a5d258cd296$exports.BatchEntry = {
    encode (message, writer = $bd613a5d258cd296$var$_m0.Writer.create()) {
        if (message.exist !== undefined) $bd613a5d258cd296$exports.ExistenceProof.encode(message.exist, writer.uint32(10).fork()).ldelim();
        if (message.nonexist !== undefined) $bd613a5d258cd296$exports.NonExistenceProof.encode(message.nonexist, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $bd613a5d258cd296$var$_m0.Reader ? input : new $bd613a5d258cd296$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $bd613a5d258cd296$var$createBaseBatchEntry();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.exist = $bd613a5d258cd296$exports.ExistenceProof.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.nonexist = $bd613a5d258cd296$exports.NonExistenceProof.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            exist: (0, $d5e07fe2518aae94$exports.isSet)(object.exist) ? $bd613a5d258cd296$exports.ExistenceProof.fromJSON(object.exist) : undefined,
            nonexist: (0, $d5e07fe2518aae94$exports.isSet)(object.nonexist) ? $bd613a5d258cd296$exports.NonExistenceProof.fromJSON(object.nonexist) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.exist !== undefined && (obj.exist = message.exist ? $bd613a5d258cd296$exports.ExistenceProof.toJSON(message.exist) : undefined);
        message.nonexist !== undefined && (obj.nonexist = message.nonexist ? $bd613a5d258cd296$exports.NonExistenceProof.toJSON(message.nonexist) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $bd613a5d258cd296$var$createBaseBatchEntry();
        message.exist = object.exist !== undefined && object.exist !== null ? $bd613a5d258cd296$exports.ExistenceProof.fromPartial(object.exist) : undefined;
        message.nonexist = object.nonexist !== undefined && object.nonexist !== null ? $bd613a5d258cd296$exports.NonExistenceProof.fromPartial(object.nonexist) : undefined;
        return message;
    }
};
function $bd613a5d258cd296$var$createBaseCompressedBatchProof() {
    return {
        entries: [],
        lookupInners: []
    };
}
$bd613a5d258cd296$exports.CompressedBatchProof = {
    encode (message, writer = $bd613a5d258cd296$var$_m0.Writer.create()) {
        for (const v of message.entries)$bd613a5d258cd296$exports.CompressedBatchEntry.encode(v, writer.uint32(10).fork()).ldelim();
        for (const v of message.lookupInners)$bd613a5d258cd296$exports.InnerOp.encode(v, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $bd613a5d258cd296$var$_m0.Reader ? input : new $bd613a5d258cd296$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $bd613a5d258cd296$var$createBaseCompressedBatchProof();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.entries.push($bd613a5d258cd296$exports.CompressedBatchEntry.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.lookupInners.push($bd613a5d258cd296$exports.InnerOp.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            entries: Array.isArray(object?.entries) ? object.entries.map((e)=>$bd613a5d258cd296$exports.CompressedBatchEntry.fromJSON(e)) : [],
            lookupInners: Array.isArray(object?.lookupInners) ? object.lookupInners.map((e)=>$bd613a5d258cd296$exports.InnerOp.fromJSON(e)) : []
        };
    },
    toJSON (message) {
        const obj = {};
        if (message.entries) obj.entries = message.entries.map((e)=>e ? $bd613a5d258cd296$exports.CompressedBatchEntry.toJSON(e) : undefined);
        else obj.entries = [];
        if (message.lookupInners) obj.lookupInners = message.lookupInners.map((e)=>e ? $bd613a5d258cd296$exports.InnerOp.toJSON(e) : undefined);
        else obj.lookupInners = [];
        return obj;
    },
    fromPartial (object) {
        const message = $bd613a5d258cd296$var$createBaseCompressedBatchProof();
        message.entries = object.entries?.map((e)=>$bd613a5d258cd296$exports.CompressedBatchEntry.fromPartial(e)) || [];
        message.lookupInners = object.lookupInners?.map((e)=>$bd613a5d258cd296$exports.InnerOp.fromPartial(e)) || [];
        return message;
    }
};
function $bd613a5d258cd296$var$createBaseCompressedBatchEntry() {
    return {
        exist: undefined,
        nonexist: undefined
    };
}
$bd613a5d258cd296$exports.CompressedBatchEntry = {
    encode (message, writer = $bd613a5d258cd296$var$_m0.Writer.create()) {
        if (message.exist !== undefined) $bd613a5d258cd296$exports.CompressedExistenceProof.encode(message.exist, writer.uint32(10).fork()).ldelim();
        if (message.nonexist !== undefined) $bd613a5d258cd296$exports.CompressedNonExistenceProof.encode(message.nonexist, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $bd613a5d258cd296$var$_m0.Reader ? input : new $bd613a5d258cd296$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $bd613a5d258cd296$var$createBaseCompressedBatchEntry();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.exist = $bd613a5d258cd296$exports.CompressedExistenceProof.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.nonexist = $bd613a5d258cd296$exports.CompressedNonExistenceProof.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            exist: (0, $d5e07fe2518aae94$exports.isSet)(object.exist) ? $bd613a5d258cd296$exports.CompressedExistenceProof.fromJSON(object.exist) : undefined,
            nonexist: (0, $d5e07fe2518aae94$exports.isSet)(object.nonexist) ? $bd613a5d258cd296$exports.CompressedNonExistenceProof.fromJSON(object.nonexist) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.exist !== undefined && (obj.exist = message.exist ? $bd613a5d258cd296$exports.CompressedExistenceProof.toJSON(message.exist) : undefined);
        message.nonexist !== undefined && (obj.nonexist = message.nonexist ? $bd613a5d258cd296$exports.CompressedNonExistenceProof.toJSON(message.nonexist) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $bd613a5d258cd296$var$createBaseCompressedBatchEntry();
        message.exist = object.exist !== undefined && object.exist !== null ? $bd613a5d258cd296$exports.CompressedExistenceProof.fromPartial(object.exist) : undefined;
        message.nonexist = object.nonexist !== undefined && object.nonexist !== null ? $bd613a5d258cd296$exports.CompressedNonExistenceProof.fromPartial(object.nonexist) : undefined;
        return message;
    }
};
function $bd613a5d258cd296$var$createBaseCompressedExistenceProof() {
    return {
        key: new Uint8Array(),
        value: new Uint8Array(),
        leaf: undefined,
        path: []
    };
}
$bd613a5d258cd296$exports.CompressedExistenceProof = {
    encode (message, writer = $bd613a5d258cd296$var$_m0.Writer.create()) {
        if (message.key.length !== 0) writer.uint32(10).bytes(message.key);
        if (message.value.length !== 0) writer.uint32(18).bytes(message.value);
        if (message.leaf !== undefined) $bd613a5d258cd296$exports.LeafOp.encode(message.leaf, writer.uint32(26).fork()).ldelim();
        writer.uint32(34).fork();
        for (const v of message.path)writer.int32(v);
        writer.ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $bd613a5d258cd296$var$_m0.Reader ? input : new $bd613a5d258cd296$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $bd613a5d258cd296$var$createBaseCompressedExistenceProof();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.key = reader.bytes();
                    break;
                case 2:
                    message.value = reader.bytes();
                    break;
                case 3:
                    message.leaf = $bd613a5d258cd296$exports.LeafOp.decode(reader, reader.uint32());
                    break;
                case 4:
                    if ((tag & 7) === 2) {
                        const end2 = reader.uint32() + reader.pos;
                        while(reader.pos < end2)message.path.push(reader.int32());
                    } else message.path.push(reader.int32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            key: (0, $d5e07fe2518aae94$exports.isSet)(object.key) ? (0, $d5e07fe2518aae94$exports.bytesFromBase64)(object.key) : new Uint8Array(),
            value: (0, $d5e07fe2518aae94$exports.isSet)(object.value) ? (0, $d5e07fe2518aae94$exports.bytesFromBase64)(object.value) : new Uint8Array(),
            leaf: (0, $d5e07fe2518aae94$exports.isSet)(object.leaf) ? $bd613a5d258cd296$exports.LeafOp.fromJSON(object.leaf) : undefined,
            path: Array.isArray(object?.path) ? object.path.map((e)=>Number(e)) : []
        };
    },
    toJSON (message) {
        const obj = {};
        message.key !== undefined && (obj.key = (0, $d5e07fe2518aae94$exports.base64FromBytes)(message.key !== undefined ? message.key : new Uint8Array()));
        message.value !== undefined && (obj.value = (0, $d5e07fe2518aae94$exports.base64FromBytes)(message.value !== undefined ? message.value : new Uint8Array()));
        message.leaf !== undefined && (obj.leaf = message.leaf ? $bd613a5d258cd296$exports.LeafOp.toJSON(message.leaf) : undefined);
        if (message.path) obj.path = message.path.map((e)=>Math.round(e));
        else obj.path = [];
        return obj;
    },
    fromPartial (object) {
        const message = $bd613a5d258cd296$var$createBaseCompressedExistenceProof();
        message.key = object.key ?? new Uint8Array();
        message.value = object.value ?? new Uint8Array();
        message.leaf = object.leaf !== undefined && object.leaf !== null ? $bd613a5d258cd296$exports.LeafOp.fromPartial(object.leaf) : undefined;
        message.path = object.path?.map((e)=>e) || [];
        return message;
    }
};
function $bd613a5d258cd296$var$createBaseCompressedNonExistenceProof() {
    return {
        key: new Uint8Array(),
        left: undefined,
        right: undefined
    };
}
$bd613a5d258cd296$exports.CompressedNonExistenceProof = {
    encode (message, writer = $bd613a5d258cd296$var$_m0.Writer.create()) {
        if (message.key.length !== 0) writer.uint32(10).bytes(message.key);
        if (message.left !== undefined) $bd613a5d258cd296$exports.CompressedExistenceProof.encode(message.left, writer.uint32(18).fork()).ldelim();
        if (message.right !== undefined) $bd613a5d258cd296$exports.CompressedExistenceProof.encode(message.right, writer.uint32(26).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $bd613a5d258cd296$var$_m0.Reader ? input : new $bd613a5d258cd296$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $bd613a5d258cd296$var$createBaseCompressedNonExistenceProof();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.key = reader.bytes();
                    break;
                case 2:
                    message.left = $bd613a5d258cd296$exports.CompressedExistenceProof.decode(reader, reader.uint32());
                    break;
                case 3:
                    message.right = $bd613a5d258cd296$exports.CompressedExistenceProof.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            key: (0, $d5e07fe2518aae94$exports.isSet)(object.key) ? (0, $d5e07fe2518aae94$exports.bytesFromBase64)(object.key) : new Uint8Array(),
            left: (0, $d5e07fe2518aae94$exports.isSet)(object.left) ? $bd613a5d258cd296$exports.CompressedExistenceProof.fromJSON(object.left) : undefined,
            right: (0, $d5e07fe2518aae94$exports.isSet)(object.right) ? $bd613a5d258cd296$exports.CompressedExistenceProof.fromJSON(object.right) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.key !== undefined && (obj.key = (0, $d5e07fe2518aae94$exports.base64FromBytes)(message.key !== undefined ? message.key : new Uint8Array()));
        message.left !== undefined && (obj.left = message.left ? $bd613a5d258cd296$exports.CompressedExistenceProof.toJSON(message.left) : undefined);
        message.right !== undefined && (obj.right = message.right ? $bd613a5d258cd296$exports.CompressedExistenceProof.toJSON(message.right) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $bd613a5d258cd296$var$createBaseCompressedNonExistenceProof();
        message.key = object.key ?? new Uint8Array();
        message.left = object.left !== undefined && object.left !== null ? $bd613a5d258cd296$exports.CompressedExistenceProof.fromPartial(object.left) : undefined;
        message.right = object.right !== undefined && object.right !== null ? $bd613a5d258cd296$exports.CompressedExistenceProof.fromPartial(object.right) : undefined;
        return message;
    }
};



const $e7e3d90550b1093b$var$_m0 = $e7e3d90550b1093b$var$__importStar((parcelRequire("fQBv0")));

$e7e3d90550b1093b$exports.protobufPackage = "ibc.core.commitment.v1";
function $e7e3d90550b1093b$var$createBaseMerkleRoot() {
    return {
        hash: new Uint8Array()
    };
}
$e7e3d90550b1093b$exports.MerkleRoot = {
    encode (message, writer = $e7e3d90550b1093b$var$_m0.Writer.create()) {
        if (message.hash.length !== 0) writer.uint32(10).bytes(message.hash);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $e7e3d90550b1093b$var$_m0.Reader ? input : new $e7e3d90550b1093b$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $e7e3d90550b1093b$var$createBaseMerkleRoot();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.hash = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            hash: (0, $d5e07fe2518aae94$exports.isSet)(object.hash) ? (0, $d5e07fe2518aae94$exports.bytesFromBase64)(object.hash) : new Uint8Array()
        };
    },
    toJSON (message) {
        const obj = {};
        message.hash !== undefined && (obj.hash = (0, $d5e07fe2518aae94$exports.base64FromBytes)(message.hash !== undefined ? message.hash : new Uint8Array()));
        return obj;
    },
    fromPartial (object) {
        const message = $e7e3d90550b1093b$var$createBaseMerkleRoot();
        message.hash = object.hash ?? new Uint8Array();
        return message;
    }
};
function $e7e3d90550b1093b$var$createBaseMerklePrefix() {
    return {
        keyPrefix: new Uint8Array()
    };
}
$e7e3d90550b1093b$exports.MerklePrefix = {
    encode (message, writer = $e7e3d90550b1093b$var$_m0.Writer.create()) {
        if (message.keyPrefix.length !== 0) writer.uint32(10).bytes(message.keyPrefix);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $e7e3d90550b1093b$var$_m0.Reader ? input : new $e7e3d90550b1093b$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $e7e3d90550b1093b$var$createBaseMerklePrefix();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.keyPrefix = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            keyPrefix: (0, $d5e07fe2518aae94$exports.isSet)(object.keyPrefix) ? (0, $d5e07fe2518aae94$exports.bytesFromBase64)(object.keyPrefix) : new Uint8Array()
        };
    },
    toJSON (message) {
        const obj = {};
        message.keyPrefix !== undefined && (obj.keyPrefix = (0, $d5e07fe2518aae94$exports.base64FromBytes)(message.keyPrefix !== undefined ? message.keyPrefix : new Uint8Array()));
        return obj;
    },
    fromPartial (object) {
        const message = $e7e3d90550b1093b$var$createBaseMerklePrefix();
        message.keyPrefix = object.keyPrefix ?? new Uint8Array();
        return message;
    }
};
function $e7e3d90550b1093b$var$createBaseMerklePath() {
    return {
        keyPath: []
    };
}
$e7e3d90550b1093b$exports.MerklePath = {
    encode (message, writer = $e7e3d90550b1093b$var$_m0.Writer.create()) {
        for (const v of message.keyPath)writer.uint32(10).string(v);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $e7e3d90550b1093b$var$_m0.Reader ? input : new $e7e3d90550b1093b$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $e7e3d90550b1093b$var$createBaseMerklePath();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.keyPath.push(reader.string());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            keyPath: Array.isArray(object?.keyPath) ? object.keyPath.map((e)=>String(e)) : []
        };
    },
    toJSON (message) {
        const obj = {};
        if (message.keyPath) obj.keyPath = message.keyPath.map((e)=>e);
        else obj.keyPath = [];
        return obj;
    },
    fromPartial (object) {
        const message = $e7e3d90550b1093b$var$createBaseMerklePath();
        message.keyPath = object.keyPath?.map((e)=>e) || [];
        return message;
    }
};
function $e7e3d90550b1093b$var$createBaseMerkleProof() {
    return {
        proofs: []
    };
}
$e7e3d90550b1093b$exports.MerkleProof = {
    encode (message, writer = $e7e3d90550b1093b$var$_m0.Writer.create()) {
        for (const v of message.proofs)$bd613a5d258cd296$exports.CommitmentProof.encode(v, writer.uint32(10).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $e7e3d90550b1093b$var$_m0.Reader ? input : new $e7e3d90550b1093b$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $e7e3d90550b1093b$var$createBaseMerkleProof();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.proofs.push($bd613a5d258cd296$exports.CommitmentProof.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            proofs: Array.isArray(object?.proofs) ? object.proofs.map((e)=>$bd613a5d258cd296$exports.CommitmentProof.fromJSON(e)) : []
        };
    },
    toJSON (message) {
        const obj = {};
        if (message.proofs) obj.proofs = message.proofs.map((e)=>e ? $bd613a5d258cd296$exports.CommitmentProof.toJSON(e) : undefined);
        else obj.proofs = [];
        return obj;
    },
    fromPartial (object) {
        const message = $e7e3d90550b1093b$var$createBaseMerkleProof();
        message.proofs = object.proofs?.map((e)=>$bd613a5d258cd296$exports.CommitmentProof.fromPartial(e)) || [];
        return message;
    }
};




const $42dc008ab8b50be1$var$_m0 = $42dc008ab8b50be1$var$__importStar((parcelRequire("fQBv0")));
$42dc008ab8b50be1$exports.protobufPackage = "ibc.core.connection.v1";
/**
 * State defines if a connection is in one of the following states:
 * INIT, TRYOPEN, OPEN or UNINITIALIZED.
 */ var $42dc008ab8b50be1$var$State;
(function(State) {
    /** STATE_UNINITIALIZED_UNSPECIFIED - Default State */ State[State["STATE_UNINITIALIZED_UNSPECIFIED"] = 0] = "STATE_UNINITIALIZED_UNSPECIFIED";
    /** STATE_INIT - A connection end has just started the opening handshake. */ State[State["STATE_INIT"] = 1] = "STATE_INIT";
    /**
     * STATE_TRYOPEN - A connection end has acknowledged the handshake step on the counterparty
     * chain.
     */ State[State["STATE_TRYOPEN"] = 2] = "STATE_TRYOPEN";
    /** STATE_OPEN - A connection end has completed the handshake. */ State[State["STATE_OPEN"] = 3] = "STATE_OPEN";
    State[State["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})($42dc008ab8b50be1$var$State = $42dc008ab8b50be1$exports.State || ($42dc008ab8b50be1$exports.State = {}));
function $42dc008ab8b50be1$var$stateFromJSON(object) {
    switch(object){
        case 0:
        case "STATE_UNINITIALIZED_UNSPECIFIED":
            return $42dc008ab8b50be1$var$State.STATE_UNINITIALIZED_UNSPECIFIED;
        case 1:
        case "STATE_INIT":
            return $42dc008ab8b50be1$var$State.STATE_INIT;
        case 2:
        case "STATE_TRYOPEN":
            return $42dc008ab8b50be1$var$State.STATE_TRYOPEN;
        case 3:
        case "STATE_OPEN":
            return $42dc008ab8b50be1$var$State.STATE_OPEN;
        case -1:
        case "UNRECOGNIZED":
        default:
            return $42dc008ab8b50be1$var$State.UNRECOGNIZED;
    }
}
$42dc008ab8b50be1$exports.stateFromJSON = $42dc008ab8b50be1$var$stateFromJSON;
function $42dc008ab8b50be1$var$stateToJSON(object) {
    switch(object){
        case $42dc008ab8b50be1$var$State.STATE_UNINITIALIZED_UNSPECIFIED:
            return "STATE_UNINITIALIZED_UNSPECIFIED";
        case $42dc008ab8b50be1$var$State.STATE_INIT:
            return "STATE_INIT";
        case $42dc008ab8b50be1$var$State.STATE_TRYOPEN:
            return "STATE_TRYOPEN";
        case $42dc008ab8b50be1$var$State.STATE_OPEN:
            return "STATE_OPEN";
        case $42dc008ab8b50be1$var$State.UNRECOGNIZED:
        default:
            return "UNRECOGNIZED";
    }
}
$42dc008ab8b50be1$exports.stateToJSON = $42dc008ab8b50be1$var$stateToJSON;
function $42dc008ab8b50be1$var$createBaseConnectionEnd() {
    return {
        clientId: "",
        versions: [],
        state: 0,
        counterparty: undefined,
        delayPeriod: $d5e07fe2518aae94$exports.Long.UZERO
    };
}
$42dc008ab8b50be1$exports.ConnectionEnd = {
    encode (message, writer = $42dc008ab8b50be1$var$_m0.Writer.create()) {
        if (message.clientId !== "") writer.uint32(10).string(message.clientId);
        for (const v of message.versions)$42dc008ab8b50be1$exports.Version.encode(v, writer.uint32(18).fork()).ldelim();
        if (message.state !== 0) writer.uint32(24).int32(message.state);
        if (message.counterparty !== undefined) $42dc008ab8b50be1$exports.Counterparty.encode(message.counterparty, writer.uint32(34).fork()).ldelim();
        if (!message.delayPeriod.isZero()) writer.uint32(40).uint64(message.delayPeriod);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $42dc008ab8b50be1$var$_m0.Reader ? input : new $42dc008ab8b50be1$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $42dc008ab8b50be1$var$createBaseConnectionEnd();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.clientId = reader.string();
                    break;
                case 2:
                    message.versions.push($42dc008ab8b50be1$exports.Version.decode(reader, reader.uint32()));
                    break;
                case 3:
                    message.state = reader.int32();
                    break;
                case 4:
                    message.counterparty = $42dc008ab8b50be1$exports.Counterparty.decode(reader, reader.uint32());
                    break;
                case 5:
                    message.delayPeriod = reader.uint64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            clientId: (0, $d5e07fe2518aae94$exports.isSet)(object.clientId) ? String(object.clientId) : "",
            versions: Array.isArray(object?.versions) ? object.versions.map((e)=>$42dc008ab8b50be1$exports.Version.fromJSON(e)) : [],
            state: (0, $d5e07fe2518aae94$exports.isSet)(object.state) ? $42dc008ab8b50be1$var$stateFromJSON(object.state) : 0,
            counterparty: (0, $d5e07fe2518aae94$exports.isSet)(object.counterparty) ? $42dc008ab8b50be1$exports.Counterparty.fromJSON(object.counterparty) : undefined,
            delayPeriod: (0, $d5e07fe2518aae94$exports.isSet)(object.delayPeriod) ? $d5e07fe2518aae94$exports.Long.fromValue(object.delayPeriod) : $d5e07fe2518aae94$exports.Long.UZERO
        };
    },
    toJSON (message) {
        const obj = {};
        message.clientId !== undefined && (obj.clientId = message.clientId);
        if (message.versions) obj.versions = message.versions.map((e)=>e ? $42dc008ab8b50be1$exports.Version.toJSON(e) : undefined);
        else obj.versions = [];
        message.state !== undefined && (obj.state = $42dc008ab8b50be1$var$stateToJSON(message.state));
        message.counterparty !== undefined && (obj.counterparty = message.counterparty ? $42dc008ab8b50be1$exports.Counterparty.toJSON(message.counterparty) : undefined);
        message.delayPeriod !== undefined && (obj.delayPeriod = (message.delayPeriod || $d5e07fe2518aae94$exports.Long.UZERO).toString());
        return obj;
    },
    fromPartial (object) {
        const message = $42dc008ab8b50be1$var$createBaseConnectionEnd();
        message.clientId = object.clientId ?? "";
        message.versions = object.versions?.map((e)=>$42dc008ab8b50be1$exports.Version.fromPartial(e)) || [];
        message.state = object.state ?? 0;
        message.counterparty = object.counterparty !== undefined && object.counterparty !== null ? $42dc008ab8b50be1$exports.Counterparty.fromPartial(object.counterparty) : undefined;
        message.delayPeriod = object.delayPeriod !== undefined && object.delayPeriod !== null ? $d5e07fe2518aae94$exports.Long.fromValue(object.delayPeriod) : $d5e07fe2518aae94$exports.Long.UZERO;
        return message;
    }
};
function $42dc008ab8b50be1$var$createBaseIdentifiedConnection() {
    return {
        id: "",
        clientId: "",
        versions: [],
        state: 0,
        counterparty: undefined,
        delayPeriod: $d5e07fe2518aae94$exports.Long.UZERO
    };
}
$42dc008ab8b50be1$exports.IdentifiedConnection = {
    encode (message, writer = $42dc008ab8b50be1$var$_m0.Writer.create()) {
        if (message.id !== "") writer.uint32(10).string(message.id);
        if (message.clientId !== "") writer.uint32(18).string(message.clientId);
        for (const v of message.versions)$42dc008ab8b50be1$exports.Version.encode(v, writer.uint32(26).fork()).ldelim();
        if (message.state !== 0) writer.uint32(32).int32(message.state);
        if (message.counterparty !== undefined) $42dc008ab8b50be1$exports.Counterparty.encode(message.counterparty, writer.uint32(42).fork()).ldelim();
        if (!message.delayPeriod.isZero()) writer.uint32(48).uint64(message.delayPeriod);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $42dc008ab8b50be1$var$_m0.Reader ? input : new $42dc008ab8b50be1$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $42dc008ab8b50be1$var$createBaseIdentifiedConnection();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.id = reader.string();
                    break;
                case 2:
                    message.clientId = reader.string();
                    break;
                case 3:
                    message.versions.push($42dc008ab8b50be1$exports.Version.decode(reader, reader.uint32()));
                    break;
                case 4:
                    message.state = reader.int32();
                    break;
                case 5:
                    message.counterparty = $42dc008ab8b50be1$exports.Counterparty.decode(reader, reader.uint32());
                    break;
                case 6:
                    message.delayPeriod = reader.uint64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            id: (0, $d5e07fe2518aae94$exports.isSet)(object.id) ? String(object.id) : "",
            clientId: (0, $d5e07fe2518aae94$exports.isSet)(object.clientId) ? String(object.clientId) : "",
            versions: Array.isArray(object?.versions) ? object.versions.map((e)=>$42dc008ab8b50be1$exports.Version.fromJSON(e)) : [],
            state: (0, $d5e07fe2518aae94$exports.isSet)(object.state) ? $42dc008ab8b50be1$var$stateFromJSON(object.state) : 0,
            counterparty: (0, $d5e07fe2518aae94$exports.isSet)(object.counterparty) ? $42dc008ab8b50be1$exports.Counterparty.fromJSON(object.counterparty) : undefined,
            delayPeriod: (0, $d5e07fe2518aae94$exports.isSet)(object.delayPeriod) ? $d5e07fe2518aae94$exports.Long.fromValue(object.delayPeriod) : $d5e07fe2518aae94$exports.Long.UZERO
        };
    },
    toJSON (message) {
        const obj = {};
        message.id !== undefined && (obj.id = message.id);
        message.clientId !== undefined && (obj.clientId = message.clientId);
        if (message.versions) obj.versions = message.versions.map((e)=>e ? $42dc008ab8b50be1$exports.Version.toJSON(e) : undefined);
        else obj.versions = [];
        message.state !== undefined && (obj.state = $42dc008ab8b50be1$var$stateToJSON(message.state));
        message.counterparty !== undefined && (obj.counterparty = message.counterparty ? $42dc008ab8b50be1$exports.Counterparty.toJSON(message.counterparty) : undefined);
        message.delayPeriod !== undefined && (obj.delayPeriod = (message.delayPeriod || $d5e07fe2518aae94$exports.Long.UZERO).toString());
        return obj;
    },
    fromPartial (object) {
        const message = $42dc008ab8b50be1$var$createBaseIdentifiedConnection();
        message.id = object.id ?? "";
        message.clientId = object.clientId ?? "";
        message.versions = object.versions?.map((e)=>$42dc008ab8b50be1$exports.Version.fromPartial(e)) || [];
        message.state = object.state ?? 0;
        message.counterparty = object.counterparty !== undefined && object.counterparty !== null ? $42dc008ab8b50be1$exports.Counterparty.fromPartial(object.counterparty) : undefined;
        message.delayPeriod = object.delayPeriod !== undefined && object.delayPeriod !== null ? $d5e07fe2518aae94$exports.Long.fromValue(object.delayPeriod) : $d5e07fe2518aae94$exports.Long.UZERO;
        return message;
    }
};
function $42dc008ab8b50be1$var$createBaseCounterparty() {
    return {
        clientId: "",
        connectionId: "",
        prefix: undefined
    };
}
$42dc008ab8b50be1$exports.Counterparty = {
    encode (message, writer = $42dc008ab8b50be1$var$_m0.Writer.create()) {
        if (message.clientId !== "") writer.uint32(10).string(message.clientId);
        if (message.connectionId !== "") writer.uint32(18).string(message.connectionId);
        if (message.prefix !== undefined) $e7e3d90550b1093b$exports.MerklePrefix.encode(message.prefix, writer.uint32(26).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $42dc008ab8b50be1$var$_m0.Reader ? input : new $42dc008ab8b50be1$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $42dc008ab8b50be1$var$createBaseCounterparty();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.clientId = reader.string();
                    break;
                case 2:
                    message.connectionId = reader.string();
                    break;
                case 3:
                    message.prefix = $e7e3d90550b1093b$exports.MerklePrefix.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            clientId: (0, $d5e07fe2518aae94$exports.isSet)(object.clientId) ? String(object.clientId) : "",
            connectionId: (0, $d5e07fe2518aae94$exports.isSet)(object.connectionId) ? String(object.connectionId) : "",
            prefix: (0, $d5e07fe2518aae94$exports.isSet)(object.prefix) ? $e7e3d90550b1093b$exports.MerklePrefix.fromJSON(object.prefix) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.clientId !== undefined && (obj.clientId = message.clientId);
        message.connectionId !== undefined && (obj.connectionId = message.connectionId);
        message.prefix !== undefined && (obj.prefix = message.prefix ? $e7e3d90550b1093b$exports.MerklePrefix.toJSON(message.prefix) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $42dc008ab8b50be1$var$createBaseCounterparty();
        message.clientId = object.clientId ?? "";
        message.connectionId = object.connectionId ?? "";
        message.prefix = object.prefix !== undefined && object.prefix !== null ? $e7e3d90550b1093b$exports.MerklePrefix.fromPartial(object.prefix) : undefined;
        return message;
    }
};
function $42dc008ab8b50be1$var$createBaseClientPaths() {
    return {
        paths: []
    };
}
$42dc008ab8b50be1$exports.ClientPaths = {
    encode (message, writer = $42dc008ab8b50be1$var$_m0.Writer.create()) {
        for (const v of message.paths)writer.uint32(10).string(v);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $42dc008ab8b50be1$var$_m0.Reader ? input : new $42dc008ab8b50be1$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $42dc008ab8b50be1$var$createBaseClientPaths();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.paths.push(reader.string());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            paths: Array.isArray(object?.paths) ? object.paths.map((e)=>String(e)) : []
        };
    },
    toJSON (message) {
        const obj = {};
        if (message.paths) obj.paths = message.paths.map((e)=>e);
        else obj.paths = [];
        return obj;
    },
    fromPartial (object) {
        const message = $42dc008ab8b50be1$var$createBaseClientPaths();
        message.paths = object.paths?.map((e)=>e) || [];
        return message;
    }
};
function $42dc008ab8b50be1$var$createBaseConnectionPaths() {
    return {
        clientId: "",
        paths: []
    };
}
$42dc008ab8b50be1$exports.ConnectionPaths = {
    encode (message, writer = $42dc008ab8b50be1$var$_m0.Writer.create()) {
        if (message.clientId !== "") writer.uint32(10).string(message.clientId);
        for (const v of message.paths)writer.uint32(18).string(v);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $42dc008ab8b50be1$var$_m0.Reader ? input : new $42dc008ab8b50be1$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $42dc008ab8b50be1$var$createBaseConnectionPaths();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.clientId = reader.string();
                    break;
                case 2:
                    message.paths.push(reader.string());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            clientId: (0, $d5e07fe2518aae94$exports.isSet)(object.clientId) ? String(object.clientId) : "",
            paths: Array.isArray(object?.paths) ? object.paths.map((e)=>String(e)) : []
        };
    },
    toJSON (message) {
        const obj = {};
        message.clientId !== undefined && (obj.clientId = message.clientId);
        if (message.paths) obj.paths = message.paths.map((e)=>e);
        else obj.paths = [];
        return obj;
    },
    fromPartial (object) {
        const message = $42dc008ab8b50be1$var$createBaseConnectionPaths();
        message.clientId = object.clientId ?? "";
        message.paths = object.paths?.map((e)=>e) || [];
        return message;
    }
};
function $42dc008ab8b50be1$var$createBaseVersion() {
    return {
        identifier: "",
        features: []
    };
}
$42dc008ab8b50be1$exports.Version = {
    encode (message, writer = $42dc008ab8b50be1$var$_m0.Writer.create()) {
        if (message.identifier !== "") writer.uint32(10).string(message.identifier);
        for (const v of message.features)writer.uint32(18).string(v);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $42dc008ab8b50be1$var$_m0.Reader ? input : new $42dc008ab8b50be1$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $42dc008ab8b50be1$var$createBaseVersion();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.identifier = reader.string();
                    break;
                case 2:
                    message.features.push(reader.string());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            identifier: (0, $d5e07fe2518aae94$exports.isSet)(object.identifier) ? String(object.identifier) : "",
            features: Array.isArray(object?.features) ? object.features.map((e)=>String(e)) : []
        };
    },
    toJSON (message) {
        const obj = {};
        message.identifier !== undefined && (obj.identifier = message.identifier);
        if (message.features) obj.features = message.features.map((e)=>e);
        else obj.features = [];
        return obj;
    },
    fromPartial (object) {
        const message = $42dc008ab8b50be1$var$createBaseVersion();
        message.identifier = object.identifier ?? "";
        message.features = object.features?.map((e)=>e) || [];
        return message;
    }
};
function $42dc008ab8b50be1$var$createBaseParams() {
    return {
        maxExpectedTimePerBlock: $d5e07fe2518aae94$exports.Long.UZERO
    };
}
$42dc008ab8b50be1$exports.Params = {
    encode (message, writer = $42dc008ab8b50be1$var$_m0.Writer.create()) {
        if (!message.maxExpectedTimePerBlock.isZero()) writer.uint32(8).uint64(message.maxExpectedTimePerBlock);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $42dc008ab8b50be1$var$_m0.Reader ? input : new $42dc008ab8b50be1$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $42dc008ab8b50be1$var$createBaseParams();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.maxExpectedTimePerBlock = reader.uint64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            maxExpectedTimePerBlock: (0, $d5e07fe2518aae94$exports.isSet)(object.maxExpectedTimePerBlock) ? $d5e07fe2518aae94$exports.Long.fromValue(object.maxExpectedTimePerBlock) : $d5e07fe2518aae94$exports.Long.UZERO
        };
    },
    toJSON (message) {
        const obj = {};
        message.maxExpectedTimePerBlock !== undefined && (obj.maxExpectedTimePerBlock = (message.maxExpectedTimePerBlock || $d5e07fe2518aae94$exports.Long.UZERO).toString());
        return obj;
    },
    fromPartial (object) {
        const message = $42dc008ab8b50be1$var$createBaseParams();
        message.maxExpectedTimePerBlock = object.maxExpectedTimePerBlock !== undefined && object.maxExpectedTimePerBlock !== null ? $d5e07fe2518aae94$exports.Long.fromValue(object.maxExpectedTimePerBlock) : $d5e07fe2518aae94$exports.Long.UZERO;
        return message;
    }
};






const $38161549ebd31952$var$_m0 = $38161549ebd31952$var$__importStar((parcelRequire("fQBv0")));
$38161549ebd31952$exports.protobufPackage = "ibc.core.connection.v1";
function $38161549ebd31952$var$createBaseMsgConnectionOpenInit() {
    return {
        clientId: "",
        counterparty: undefined,
        version: undefined,
        delayPeriod: $d5e07fe2518aae94$exports.Long.UZERO,
        signer: ""
    };
}
$38161549ebd31952$exports.MsgConnectionOpenInit = {
    encode (message, writer = $38161549ebd31952$var$_m0.Writer.create()) {
        if (message.clientId !== "") writer.uint32(10).string(message.clientId);
        if (message.counterparty !== undefined) $42dc008ab8b50be1$exports.Counterparty.encode(message.counterparty, writer.uint32(18).fork()).ldelim();
        if (message.version !== undefined) $42dc008ab8b50be1$exports.Version.encode(message.version, writer.uint32(26).fork()).ldelim();
        if (!message.delayPeriod.isZero()) writer.uint32(32).uint64(message.delayPeriod);
        if (message.signer !== "") writer.uint32(42).string(message.signer);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $38161549ebd31952$var$_m0.Reader ? input : new $38161549ebd31952$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $38161549ebd31952$var$createBaseMsgConnectionOpenInit();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.clientId = reader.string();
                    break;
                case 2:
                    message.counterparty = $42dc008ab8b50be1$exports.Counterparty.decode(reader, reader.uint32());
                    break;
                case 3:
                    message.version = $42dc008ab8b50be1$exports.Version.decode(reader, reader.uint32());
                    break;
                case 4:
                    message.delayPeriod = reader.uint64();
                    break;
                case 5:
                    message.signer = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            clientId: (0, $d5e07fe2518aae94$exports.isSet)(object.clientId) ? String(object.clientId) : "",
            counterparty: (0, $d5e07fe2518aae94$exports.isSet)(object.counterparty) ? $42dc008ab8b50be1$exports.Counterparty.fromJSON(object.counterparty) : undefined,
            version: (0, $d5e07fe2518aae94$exports.isSet)(object.version) ? $42dc008ab8b50be1$exports.Version.fromJSON(object.version) : undefined,
            delayPeriod: (0, $d5e07fe2518aae94$exports.isSet)(object.delayPeriod) ? $d5e07fe2518aae94$exports.Long.fromValue(object.delayPeriod) : $d5e07fe2518aae94$exports.Long.UZERO,
            signer: (0, $d5e07fe2518aae94$exports.isSet)(object.signer) ? String(object.signer) : ""
        };
    },
    toJSON (message) {
        const obj = {};
        message.clientId !== undefined && (obj.clientId = message.clientId);
        message.counterparty !== undefined && (obj.counterparty = message.counterparty ? $42dc008ab8b50be1$exports.Counterparty.toJSON(message.counterparty) : undefined);
        message.version !== undefined && (obj.version = message.version ? $42dc008ab8b50be1$exports.Version.toJSON(message.version) : undefined);
        message.delayPeriod !== undefined && (obj.delayPeriod = (message.delayPeriod || $d5e07fe2518aae94$exports.Long.UZERO).toString());
        message.signer !== undefined && (obj.signer = message.signer);
        return obj;
    },
    fromPartial (object) {
        const message = $38161549ebd31952$var$createBaseMsgConnectionOpenInit();
        message.clientId = object.clientId ?? "";
        message.counterparty = object.counterparty !== undefined && object.counterparty !== null ? $42dc008ab8b50be1$exports.Counterparty.fromPartial(object.counterparty) : undefined;
        message.version = object.version !== undefined && object.version !== null ? $42dc008ab8b50be1$exports.Version.fromPartial(object.version) : undefined;
        message.delayPeriod = object.delayPeriod !== undefined && object.delayPeriod !== null ? $d5e07fe2518aae94$exports.Long.fromValue(object.delayPeriod) : $d5e07fe2518aae94$exports.Long.UZERO;
        message.signer = object.signer ?? "";
        return message;
    }
};
function $38161549ebd31952$var$createBaseMsgConnectionOpenInitResponse() {
    return {};
}
$38161549ebd31952$exports.MsgConnectionOpenInitResponse = {
    encode (_, writer = $38161549ebd31952$var$_m0.Writer.create()) {
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $38161549ebd31952$var$_m0.Reader ? input : new $38161549ebd31952$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $38161549ebd31952$var$createBaseMsgConnectionOpenInitResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            tag;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON (_) {
        return {};
    },
    toJSON (_) {
        const obj = {};
        return obj;
    },
    fromPartial (_) {
        const message = $38161549ebd31952$var$createBaseMsgConnectionOpenInitResponse();
        return message;
    }
};
function $38161549ebd31952$var$createBaseMsgConnectionOpenTry() {
    return {
        clientId: "",
        previousConnectionId: "",
        clientState: undefined,
        counterparty: undefined,
        delayPeriod: $d5e07fe2518aae94$exports.Long.UZERO,
        counterpartyVersions: [],
        proofHeight: undefined,
        proofInit: new Uint8Array(),
        proofClient: new Uint8Array(),
        proofConsensus: new Uint8Array(),
        consensusHeight: undefined,
        signer: "",
        hostConsensusStateProof: new Uint8Array()
    };
}
$38161549ebd31952$exports.MsgConnectionOpenTry = {
    encode (message, writer = $38161549ebd31952$var$_m0.Writer.create()) {
        if (message.clientId !== "") writer.uint32(10).string(message.clientId);
        if (message.previousConnectionId !== "") writer.uint32(18).string(message.previousConnectionId);
        if (message.clientState !== undefined) $64138e590dcf0cc1$exports.Any.encode(message.clientState, writer.uint32(26).fork()).ldelim();
        if (message.counterparty !== undefined) $42dc008ab8b50be1$exports.Counterparty.encode(message.counterparty, writer.uint32(34).fork()).ldelim();
        if (!message.delayPeriod.isZero()) writer.uint32(40).uint64(message.delayPeriod);
        for (const v of message.counterpartyVersions)$42dc008ab8b50be1$exports.Version.encode(v, writer.uint32(50).fork()).ldelim();
        if (message.proofHeight !== undefined) $7d28e43a1e22112f$exports.Height.encode(message.proofHeight, writer.uint32(58).fork()).ldelim();
        if (message.proofInit.length !== 0) writer.uint32(66).bytes(message.proofInit);
        if (message.proofClient.length !== 0) writer.uint32(74).bytes(message.proofClient);
        if (message.proofConsensus.length !== 0) writer.uint32(82).bytes(message.proofConsensus);
        if (message.consensusHeight !== undefined) $7d28e43a1e22112f$exports.Height.encode(message.consensusHeight, writer.uint32(90).fork()).ldelim();
        if (message.signer !== "") writer.uint32(98).string(message.signer);
        if (message.hostConsensusStateProof.length !== 0) writer.uint32(106).bytes(message.hostConsensusStateProof);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $38161549ebd31952$var$_m0.Reader ? input : new $38161549ebd31952$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $38161549ebd31952$var$createBaseMsgConnectionOpenTry();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.clientId = reader.string();
                    break;
                case 2:
                    message.previousConnectionId = reader.string();
                    break;
                case 3:
                    message.clientState = $64138e590dcf0cc1$exports.Any.decode(reader, reader.uint32());
                    break;
                case 4:
                    message.counterparty = $42dc008ab8b50be1$exports.Counterparty.decode(reader, reader.uint32());
                    break;
                case 5:
                    message.delayPeriod = reader.uint64();
                    break;
                case 6:
                    message.counterpartyVersions.push($42dc008ab8b50be1$exports.Version.decode(reader, reader.uint32()));
                    break;
                case 7:
                    message.proofHeight = $7d28e43a1e22112f$exports.Height.decode(reader, reader.uint32());
                    break;
                case 8:
                    message.proofInit = reader.bytes();
                    break;
                case 9:
                    message.proofClient = reader.bytes();
                    break;
                case 10:
                    message.proofConsensus = reader.bytes();
                    break;
                case 11:
                    message.consensusHeight = $7d28e43a1e22112f$exports.Height.decode(reader, reader.uint32());
                    break;
                case 12:
                    message.signer = reader.string();
                    break;
                case 13:
                    message.hostConsensusStateProof = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            clientId: (0, $d5e07fe2518aae94$exports.isSet)(object.clientId) ? String(object.clientId) : "",
            previousConnectionId: (0, $d5e07fe2518aae94$exports.isSet)(object.previousConnectionId) ? String(object.previousConnectionId) : "",
            clientState: (0, $d5e07fe2518aae94$exports.isSet)(object.clientState) ? $64138e590dcf0cc1$exports.Any.fromJSON(object.clientState) : undefined,
            counterparty: (0, $d5e07fe2518aae94$exports.isSet)(object.counterparty) ? $42dc008ab8b50be1$exports.Counterparty.fromJSON(object.counterparty) : undefined,
            delayPeriod: (0, $d5e07fe2518aae94$exports.isSet)(object.delayPeriod) ? $d5e07fe2518aae94$exports.Long.fromValue(object.delayPeriod) : $d5e07fe2518aae94$exports.Long.UZERO,
            counterpartyVersions: Array.isArray(object?.counterpartyVersions) ? object.counterpartyVersions.map((e)=>$42dc008ab8b50be1$exports.Version.fromJSON(e)) : [],
            proofHeight: (0, $d5e07fe2518aae94$exports.isSet)(object.proofHeight) ? $7d28e43a1e22112f$exports.Height.fromJSON(object.proofHeight) : undefined,
            proofInit: (0, $d5e07fe2518aae94$exports.isSet)(object.proofInit) ? (0, $d5e07fe2518aae94$exports.bytesFromBase64)(object.proofInit) : new Uint8Array(),
            proofClient: (0, $d5e07fe2518aae94$exports.isSet)(object.proofClient) ? (0, $d5e07fe2518aae94$exports.bytesFromBase64)(object.proofClient) : new Uint8Array(),
            proofConsensus: (0, $d5e07fe2518aae94$exports.isSet)(object.proofConsensus) ? (0, $d5e07fe2518aae94$exports.bytesFromBase64)(object.proofConsensus) : new Uint8Array(),
            consensusHeight: (0, $d5e07fe2518aae94$exports.isSet)(object.consensusHeight) ? $7d28e43a1e22112f$exports.Height.fromJSON(object.consensusHeight) : undefined,
            signer: (0, $d5e07fe2518aae94$exports.isSet)(object.signer) ? String(object.signer) : "",
            hostConsensusStateProof: (0, $d5e07fe2518aae94$exports.isSet)(object.hostConsensusStateProof) ? (0, $d5e07fe2518aae94$exports.bytesFromBase64)(object.hostConsensusStateProof) : new Uint8Array()
        };
    },
    toJSON (message) {
        const obj = {};
        message.clientId !== undefined && (obj.clientId = message.clientId);
        message.previousConnectionId !== undefined && (obj.previousConnectionId = message.previousConnectionId);
        message.clientState !== undefined && (obj.clientState = message.clientState ? $64138e590dcf0cc1$exports.Any.toJSON(message.clientState) : undefined);
        message.counterparty !== undefined && (obj.counterparty = message.counterparty ? $42dc008ab8b50be1$exports.Counterparty.toJSON(message.counterparty) : undefined);
        message.delayPeriod !== undefined && (obj.delayPeriod = (message.delayPeriod || $d5e07fe2518aae94$exports.Long.UZERO).toString());
        if (message.counterpartyVersions) obj.counterpartyVersions = message.counterpartyVersions.map((e)=>e ? $42dc008ab8b50be1$exports.Version.toJSON(e) : undefined);
        else obj.counterpartyVersions = [];
        message.proofHeight !== undefined && (obj.proofHeight = message.proofHeight ? $7d28e43a1e22112f$exports.Height.toJSON(message.proofHeight) : undefined);
        message.proofInit !== undefined && (obj.proofInit = (0, $d5e07fe2518aae94$exports.base64FromBytes)(message.proofInit !== undefined ? message.proofInit : new Uint8Array()));
        message.proofClient !== undefined && (obj.proofClient = (0, $d5e07fe2518aae94$exports.base64FromBytes)(message.proofClient !== undefined ? message.proofClient : new Uint8Array()));
        message.proofConsensus !== undefined && (obj.proofConsensus = (0, $d5e07fe2518aae94$exports.base64FromBytes)(message.proofConsensus !== undefined ? message.proofConsensus : new Uint8Array()));
        message.consensusHeight !== undefined && (obj.consensusHeight = message.consensusHeight ? $7d28e43a1e22112f$exports.Height.toJSON(message.consensusHeight) : undefined);
        message.signer !== undefined && (obj.signer = message.signer);
        message.hostConsensusStateProof !== undefined && (obj.hostConsensusStateProof = (0, $d5e07fe2518aae94$exports.base64FromBytes)(message.hostConsensusStateProof !== undefined ? message.hostConsensusStateProof : new Uint8Array()));
        return obj;
    },
    fromPartial (object) {
        const message = $38161549ebd31952$var$createBaseMsgConnectionOpenTry();
        message.clientId = object.clientId ?? "";
        message.previousConnectionId = object.previousConnectionId ?? "";
        message.clientState = object.clientState !== undefined && object.clientState !== null ? $64138e590dcf0cc1$exports.Any.fromPartial(object.clientState) : undefined;
        message.counterparty = object.counterparty !== undefined && object.counterparty !== null ? $42dc008ab8b50be1$exports.Counterparty.fromPartial(object.counterparty) : undefined;
        message.delayPeriod = object.delayPeriod !== undefined && object.delayPeriod !== null ? $d5e07fe2518aae94$exports.Long.fromValue(object.delayPeriod) : $d5e07fe2518aae94$exports.Long.UZERO;
        message.counterpartyVersions = object.counterpartyVersions?.map((e)=>$42dc008ab8b50be1$exports.Version.fromPartial(e)) || [];
        message.proofHeight = object.proofHeight !== undefined && object.proofHeight !== null ? $7d28e43a1e22112f$exports.Height.fromPartial(object.proofHeight) : undefined;
        message.proofInit = object.proofInit ?? new Uint8Array();
        message.proofClient = object.proofClient ?? new Uint8Array();
        message.proofConsensus = object.proofConsensus ?? new Uint8Array();
        message.consensusHeight = object.consensusHeight !== undefined && object.consensusHeight !== null ? $7d28e43a1e22112f$exports.Height.fromPartial(object.consensusHeight) : undefined;
        message.signer = object.signer ?? "";
        message.hostConsensusStateProof = object.hostConsensusStateProof ?? new Uint8Array();
        return message;
    }
};
function $38161549ebd31952$var$createBaseMsgConnectionOpenTryResponse() {
    return {};
}
$38161549ebd31952$exports.MsgConnectionOpenTryResponse = {
    encode (_, writer = $38161549ebd31952$var$_m0.Writer.create()) {
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $38161549ebd31952$var$_m0.Reader ? input : new $38161549ebd31952$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $38161549ebd31952$var$createBaseMsgConnectionOpenTryResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            tag;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON (_) {
        return {};
    },
    toJSON (_) {
        const obj = {};
        return obj;
    },
    fromPartial (_) {
        const message = $38161549ebd31952$var$createBaseMsgConnectionOpenTryResponse();
        return message;
    }
};
function $38161549ebd31952$var$createBaseMsgConnectionOpenAck() {
    return {
        connectionId: "",
        counterpartyConnectionId: "",
        version: undefined,
        clientState: undefined,
        proofHeight: undefined,
        proofTry: new Uint8Array(),
        proofClient: new Uint8Array(),
        proofConsensus: new Uint8Array(),
        consensusHeight: undefined,
        signer: "",
        hostConsensusStateProof: new Uint8Array()
    };
}
$38161549ebd31952$exports.MsgConnectionOpenAck = {
    encode (message, writer = $38161549ebd31952$var$_m0.Writer.create()) {
        if (message.connectionId !== "") writer.uint32(10).string(message.connectionId);
        if (message.counterpartyConnectionId !== "") writer.uint32(18).string(message.counterpartyConnectionId);
        if (message.version !== undefined) $42dc008ab8b50be1$exports.Version.encode(message.version, writer.uint32(26).fork()).ldelim();
        if (message.clientState !== undefined) $64138e590dcf0cc1$exports.Any.encode(message.clientState, writer.uint32(34).fork()).ldelim();
        if (message.proofHeight !== undefined) $7d28e43a1e22112f$exports.Height.encode(message.proofHeight, writer.uint32(42).fork()).ldelim();
        if (message.proofTry.length !== 0) writer.uint32(50).bytes(message.proofTry);
        if (message.proofClient.length !== 0) writer.uint32(58).bytes(message.proofClient);
        if (message.proofConsensus.length !== 0) writer.uint32(66).bytes(message.proofConsensus);
        if (message.consensusHeight !== undefined) $7d28e43a1e22112f$exports.Height.encode(message.consensusHeight, writer.uint32(74).fork()).ldelim();
        if (message.signer !== "") writer.uint32(82).string(message.signer);
        if (message.hostConsensusStateProof.length !== 0) writer.uint32(90).bytes(message.hostConsensusStateProof);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $38161549ebd31952$var$_m0.Reader ? input : new $38161549ebd31952$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $38161549ebd31952$var$createBaseMsgConnectionOpenAck();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.connectionId = reader.string();
                    break;
                case 2:
                    message.counterpartyConnectionId = reader.string();
                    break;
                case 3:
                    message.version = $42dc008ab8b50be1$exports.Version.decode(reader, reader.uint32());
                    break;
                case 4:
                    message.clientState = $64138e590dcf0cc1$exports.Any.decode(reader, reader.uint32());
                    break;
                case 5:
                    message.proofHeight = $7d28e43a1e22112f$exports.Height.decode(reader, reader.uint32());
                    break;
                case 6:
                    message.proofTry = reader.bytes();
                    break;
                case 7:
                    message.proofClient = reader.bytes();
                    break;
                case 8:
                    message.proofConsensus = reader.bytes();
                    break;
                case 9:
                    message.consensusHeight = $7d28e43a1e22112f$exports.Height.decode(reader, reader.uint32());
                    break;
                case 10:
                    message.signer = reader.string();
                    break;
                case 11:
                    message.hostConsensusStateProof = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            connectionId: (0, $d5e07fe2518aae94$exports.isSet)(object.connectionId) ? String(object.connectionId) : "",
            counterpartyConnectionId: (0, $d5e07fe2518aae94$exports.isSet)(object.counterpartyConnectionId) ? String(object.counterpartyConnectionId) : "",
            version: (0, $d5e07fe2518aae94$exports.isSet)(object.version) ? $42dc008ab8b50be1$exports.Version.fromJSON(object.version) : undefined,
            clientState: (0, $d5e07fe2518aae94$exports.isSet)(object.clientState) ? $64138e590dcf0cc1$exports.Any.fromJSON(object.clientState) : undefined,
            proofHeight: (0, $d5e07fe2518aae94$exports.isSet)(object.proofHeight) ? $7d28e43a1e22112f$exports.Height.fromJSON(object.proofHeight) : undefined,
            proofTry: (0, $d5e07fe2518aae94$exports.isSet)(object.proofTry) ? (0, $d5e07fe2518aae94$exports.bytesFromBase64)(object.proofTry) : new Uint8Array(),
            proofClient: (0, $d5e07fe2518aae94$exports.isSet)(object.proofClient) ? (0, $d5e07fe2518aae94$exports.bytesFromBase64)(object.proofClient) : new Uint8Array(),
            proofConsensus: (0, $d5e07fe2518aae94$exports.isSet)(object.proofConsensus) ? (0, $d5e07fe2518aae94$exports.bytesFromBase64)(object.proofConsensus) : new Uint8Array(),
            consensusHeight: (0, $d5e07fe2518aae94$exports.isSet)(object.consensusHeight) ? $7d28e43a1e22112f$exports.Height.fromJSON(object.consensusHeight) : undefined,
            signer: (0, $d5e07fe2518aae94$exports.isSet)(object.signer) ? String(object.signer) : "",
            hostConsensusStateProof: (0, $d5e07fe2518aae94$exports.isSet)(object.hostConsensusStateProof) ? (0, $d5e07fe2518aae94$exports.bytesFromBase64)(object.hostConsensusStateProof) : new Uint8Array()
        };
    },
    toJSON (message) {
        const obj = {};
        message.connectionId !== undefined && (obj.connectionId = message.connectionId);
        message.counterpartyConnectionId !== undefined && (obj.counterpartyConnectionId = message.counterpartyConnectionId);
        message.version !== undefined && (obj.version = message.version ? $42dc008ab8b50be1$exports.Version.toJSON(message.version) : undefined);
        message.clientState !== undefined && (obj.clientState = message.clientState ? $64138e590dcf0cc1$exports.Any.toJSON(message.clientState) : undefined);
        message.proofHeight !== undefined && (obj.proofHeight = message.proofHeight ? $7d28e43a1e22112f$exports.Height.toJSON(message.proofHeight) : undefined);
        message.proofTry !== undefined && (obj.proofTry = (0, $d5e07fe2518aae94$exports.base64FromBytes)(message.proofTry !== undefined ? message.proofTry : new Uint8Array()));
        message.proofClient !== undefined && (obj.proofClient = (0, $d5e07fe2518aae94$exports.base64FromBytes)(message.proofClient !== undefined ? message.proofClient : new Uint8Array()));
        message.proofConsensus !== undefined && (obj.proofConsensus = (0, $d5e07fe2518aae94$exports.base64FromBytes)(message.proofConsensus !== undefined ? message.proofConsensus : new Uint8Array()));
        message.consensusHeight !== undefined && (obj.consensusHeight = message.consensusHeight ? $7d28e43a1e22112f$exports.Height.toJSON(message.consensusHeight) : undefined);
        message.signer !== undefined && (obj.signer = message.signer);
        message.hostConsensusStateProof !== undefined && (obj.hostConsensusStateProof = (0, $d5e07fe2518aae94$exports.base64FromBytes)(message.hostConsensusStateProof !== undefined ? message.hostConsensusStateProof : new Uint8Array()));
        return obj;
    },
    fromPartial (object) {
        const message = $38161549ebd31952$var$createBaseMsgConnectionOpenAck();
        message.connectionId = object.connectionId ?? "";
        message.counterpartyConnectionId = object.counterpartyConnectionId ?? "";
        message.version = object.version !== undefined && object.version !== null ? $42dc008ab8b50be1$exports.Version.fromPartial(object.version) : undefined;
        message.clientState = object.clientState !== undefined && object.clientState !== null ? $64138e590dcf0cc1$exports.Any.fromPartial(object.clientState) : undefined;
        message.proofHeight = object.proofHeight !== undefined && object.proofHeight !== null ? $7d28e43a1e22112f$exports.Height.fromPartial(object.proofHeight) : undefined;
        message.proofTry = object.proofTry ?? new Uint8Array();
        message.proofClient = object.proofClient ?? new Uint8Array();
        message.proofConsensus = object.proofConsensus ?? new Uint8Array();
        message.consensusHeight = object.consensusHeight !== undefined && object.consensusHeight !== null ? $7d28e43a1e22112f$exports.Height.fromPartial(object.consensusHeight) : undefined;
        message.signer = object.signer ?? "";
        message.hostConsensusStateProof = object.hostConsensusStateProof ?? new Uint8Array();
        return message;
    }
};
function $38161549ebd31952$var$createBaseMsgConnectionOpenAckResponse() {
    return {};
}
$38161549ebd31952$exports.MsgConnectionOpenAckResponse = {
    encode (_, writer = $38161549ebd31952$var$_m0.Writer.create()) {
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $38161549ebd31952$var$_m0.Reader ? input : new $38161549ebd31952$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $38161549ebd31952$var$createBaseMsgConnectionOpenAckResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            tag;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON (_) {
        return {};
    },
    toJSON (_) {
        const obj = {};
        return obj;
    },
    fromPartial (_) {
        const message = $38161549ebd31952$var$createBaseMsgConnectionOpenAckResponse();
        return message;
    }
};
function $38161549ebd31952$var$createBaseMsgConnectionOpenConfirm() {
    return {
        connectionId: "",
        proofAck: new Uint8Array(),
        proofHeight: undefined,
        signer: ""
    };
}
$38161549ebd31952$exports.MsgConnectionOpenConfirm = {
    encode (message, writer = $38161549ebd31952$var$_m0.Writer.create()) {
        if (message.connectionId !== "") writer.uint32(10).string(message.connectionId);
        if (message.proofAck.length !== 0) writer.uint32(18).bytes(message.proofAck);
        if (message.proofHeight !== undefined) $7d28e43a1e22112f$exports.Height.encode(message.proofHeight, writer.uint32(26).fork()).ldelim();
        if (message.signer !== "") writer.uint32(34).string(message.signer);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $38161549ebd31952$var$_m0.Reader ? input : new $38161549ebd31952$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $38161549ebd31952$var$createBaseMsgConnectionOpenConfirm();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.connectionId = reader.string();
                    break;
                case 2:
                    message.proofAck = reader.bytes();
                    break;
                case 3:
                    message.proofHeight = $7d28e43a1e22112f$exports.Height.decode(reader, reader.uint32());
                    break;
                case 4:
                    message.signer = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            connectionId: (0, $d5e07fe2518aae94$exports.isSet)(object.connectionId) ? String(object.connectionId) : "",
            proofAck: (0, $d5e07fe2518aae94$exports.isSet)(object.proofAck) ? (0, $d5e07fe2518aae94$exports.bytesFromBase64)(object.proofAck) : new Uint8Array(),
            proofHeight: (0, $d5e07fe2518aae94$exports.isSet)(object.proofHeight) ? $7d28e43a1e22112f$exports.Height.fromJSON(object.proofHeight) : undefined,
            signer: (0, $d5e07fe2518aae94$exports.isSet)(object.signer) ? String(object.signer) : ""
        };
    },
    toJSON (message) {
        const obj = {};
        message.connectionId !== undefined && (obj.connectionId = message.connectionId);
        message.proofAck !== undefined && (obj.proofAck = (0, $d5e07fe2518aae94$exports.base64FromBytes)(message.proofAck !== undefined ? message.proofAck : new Uint8Array()));
        message.proofHeight !== undefined && (obj.proofHeight = message.proofHeight ? $7d28e43a1e22112f$exports.Height.toJSON(message.proofHeight) : undefined);
        message.signer !== undefined && (obj.signer = message.signer);
        return obj;
    },
    fromPartial (object) {
        const message = $38161549ebd31952$var$createBaseMsgConnectionOpenConfirm();
        message.connectionId = object.connectionId ?? "";
        message.proofAck = object.proofAck ?? new Uint8Array();
        message.proofHeight = object.proofHeight !== undefined && object.proofHeight !== null ? $7d28e43a1e22112f$exports.Height.fromPartial(object.proofHeight) : undefined;
        message.signer = object.signer ?? "";
        return message;
    }
};
function $38161549ebd31952$var$createBaseMsgConnectionOpenConfirmResponse() {
    return {};
}
$38161549ebd31952$exports.MsgConnectionOpenConfirmResponse = {
    encode (_, writer = $38161549ebd31952$var$_m0.Writer.create()) {
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $38161549ebd31952$var$_m0.Reader ? input : new $38161549ebd31952$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $38161549ebd31952$var$createBaseMsgConnectionOpenConfirmResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            tag;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON (_) {
        return {};
    },
    toJSON (_) {
        const obj = {};
        return obj;
    },
    fromPartial (_) {
        const message = $38161549ebd31952$var$createBaseMsgConnectionOpenConfirmResponse();
        return message;
    }
};
class $38161549ebd31952$var$MsgClientImpl {
    constructor(rpc){
        this.rpc = rpc;
        this.ConnectionOpenInit = this.ConnectionOpenInit.bind(this);
        this.ConnectionOpenTry = this.ConnectionOpenTry.bind(this);
        this.ConnectionOpenAck = this.ConnectionOpenAck.bind(this);
        this.ConnectionOpenConfirm = this.ConnectionOpenConfirm.bind(this);
    }
    ConnectionOpenInit(request) {
        const data = $38161549ebd31952$exports.MsgConnectionOpenInit.encode(request).finish();
        const promise = this.rpc.request("ibc.core.connection.v1.Msg", "ConnectionOpenInit", data);
        return promise.then((data)=>$38161549ebd31952$exports.MsgConnectionOpenInitResponse.decode(new $38161549ebd31952$var$_m0.Reader(data)));
    }
    ConnectionOpenTry(request) {
        const data = $38161549ebd31952$exports.MsgConnectionOpenTry.encode(request).finish();
        const promise = this.rpc.request("ibc.core.connection.v1.Msg", "ConnectionOpenTry", data);
        return promise.then((data)=>$38161549ebd31952$exports.MsgConnectionOpenTryResponse.decode(new $38161549ebd31952$var$_m0.Reader(data)));
    }
    ConnectionOpenAck(request) {
        const data = $38161549ebd31952$exports.MsgConnectionOpenAck.encode(request).finish();
        const promise = this.rpc.request("ibc.core.connection.v1.Msg", "ConnectionOpenAck", data);
        return promise.then((data)=>$38161549ebd31952$exports.MsgConnectionOpenAckResponse.decode(new $38161549ebd31952$var$_m0.Reader(data)));
    }
    ConnectionOpenConfirm(request) {
        const data = $38161549ebd31952$exports.MsgConnectionOpenConfirm.encode(request).finish();
        const promise = this.rpc.request("ibc.core.connection.v1.Msg", "ConnectionOpenConfirm", data);
        return promise.then((data)=>$38161549ebd31952$exports.MsgConnectionOpenConfirmResponse.decode(new $38161549ebd31952$var$_m0.Reader(data)));
    }
}
$38161549ebd31952$exports.MsgClientImpl = $38161549ebd31952$var$MsgClientImpl;


$7ac416bc955857ec$exports.ibcTypes = [
    [
        "/ibc.applications.transfer.v1.MsgTransfer",
        $32d2cb55dc1dc5c5$exports.MsgTransfer
    ],
    [
        "/ibc.core.channel.v1.MsgAcknowledgement",
        $ce17e6d84c94872c$exports.MsgAcknowledgement
    ],
    [
        "/ibc.core.channel.v1.MsgChannelCloseConfirm",
        $ce17e6d84c94872c$exports.MsgChannelCloseConfirm
    ],
    [
        "/ibc.core.channel.v1.MsgChannelCloseInit",
        $ce17e6d84c94872c$exports.MsgChannelCloseInit
    ],
    [
        "/ibc.core.channel.v1.MsgChannelOpenAck",
        $ce17e6d84c94872c$exports.MsgChannelOpenAck
    ],
    [
        "/ibc.core.channel.v1.MsgChannelOpenConfirm",
        $ce17e6d84c94872c$exports.MsgChannelOpenConfirm
    ],
    [
        "/ibc.core.channel.v1.MsgChannelOpenInit",
        $ce17e6d84c94872c$exports.MsgChannelOpenInit
    ],
    [
        "/ibc.core.channel.v1.MsgChannelOpenTry",
        $ce17e6d84c94872c$exports.MsgChannelOpenTry
    ],
    [
        "/ibc.core.channel.v1.MsgRecvPacket",
        $ce17e6d84c94872c$exports.MsgRecvPacket
    ],
    [
        "/ibc.core.channel.v1.MsgTimeout",
        $ce17e6d84c94872c$exports.MsgTimeout
    ],
    [
        "/ibc.core.channel.v1.MsgTimeoutOnClose",
        $ce17e6d84c94872c$exports.MsgTimeoutOnClose
    ],
    [
        "/ibc.core.client.v1.MsgCreateClient",
        $1ffe4eb8410e0d1d$exports.MsgCreateClient
    ],
    [
        "/ibc.core.client.v1.MsgSubmitMisbehaviour",
        $1ffe4eb8410e0d1d$exports.MsgSubmitMisbehaviour
    ],
    [
        "/ibc.core.client.v1.MsgUpdateClient",
        $1ffe4eb8410e0d1d$exports.MsgUpdateClient
    ],
    [
        "/ibc.core.client.v1.MsgUpgradeClient",
        $1ffe4eb8410e0d1d$exports.MsgUpgradeClient
    ],
    [
        "/ibc.core.connection.v1.MsgConnectionOpenAck",
        $38161549ebd31952$exports.MsgConnectionOpenAck
    ],
    [
        "/ibc.core.connection.v1.MsgConnectionOpenConfirm",
        $38161549ebd31952$exports.MsgConnectionOpenConfirm
    ],
    [
        "/ibc.core.connection.v1.MsgConnectionOpenInit",
        $38161549ebd31952$exports.MsgConnectionOpenInit
    ],
    [
        "/ibc.core.connection.v1.MsgConnectionOpenTry",
        $38161549ebd31952$exports.MsgConnectionOpenTry
    ]
];
function $7ac416bc955857ec$var$isMsgTransferEncodeObject(object) {
    return object.typeUrl === "/ibc.applications.transfer.v1.MsgTransfer";
}
$7ac416bc955857ec$exports.isMsgTransferEncodeObject = $7ac416bc955857ec$var$isMsgTransferEncodeObject;


Object.defineProperty($d0d8b6f4712acd9f$exports, "ibcTypes", {
    enumerable: true,
    get: function() {
        return $7ac416bc955857ec$exports.ibcTypes;
    }
});
Object.defineProperty($d0d8b6f4712acd9f$exports, "isMsgTransferEncodeObject", {
    enumerable: true,
    get: function() {
        return $7ac416bc955857ec$exports.isMsgTransferEncodeObject;
    }
});
var $d7164694ea2af9e2$exports = {};
"use strict";
var $d7164694ea2af9e2$var$__importDefault = $d7164694ea2af9e2$exports && $d7164694ea2af9e2$exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty($d7164694ea2af9e2$exports, "__esModule", {
    value: true
});
$d7164694ea2af9e2$exports.setupIbcExtension = void 0;

var $6XcLW = parcelRequire("6XcLW");

var $7UsfE = parcelRequire("7UsfE");
var $03f3fe1b5012bca2$exports = {};
"use strict";
var $03f3fe1b5012bca2$var$__createBinding = $03f3fe1b5012bca2$exports && $03f3fe1b5012bca2$exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $03f3fe1b5012bca2$var$__setModuleDefault = $03f3fe1b5012bca2$exports && $03f3fe1b5012bca2$exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $03f3fe1b5012bca2$var$__importStar = $03f3fe1b5012bca2$exports && $03f3fe1b5012bca2$exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $03f3fe1b5012bca2$var$__createBinding(result, mod, k);
    }
    $03f3fe1b5012bca2$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty($03f3fe1b5012bca2$exports, "__esModule", {
    value: true
});
$03f3fe1b5012bca2$exports.QueryClientImpl = $03f3fe1b5012bca2$exports.QueryEscrowAddressResponse = $03f3fe1b5012bca2$exports.QueryEscrowAddressRequest = $03f3fe1b5012bca2$exports.QueryDenomHashResponse = $03f3fe1b5012bca2$exports.QueryDenomHashRequest = $03f3fe1b5012bca2$exports.QueryParamsResponse = $03f3fe1b5012bca2$exports.QueryParamsRequest = $03f3fe1b5012bca2$exports.QueryDenomTracesResponse = $03f3fe1b5012bca2$exports.QueryDenomTracesRequest = $03f3fe1b5012bca2$exports.QueryDenomTraceResponse = $03f3fe1b5012bca2$exports.QueryDenomTraceRequest = $03f3fe1b5012bca2$exports.protobufPackage = void 0;

var $c6ee281acec202f0$exports = {};
"use strict";
var $c6ee281acec202f0$var$__createBinding = $c6ee281acec202f0$exports && $c6ee281acec202f0$exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $c6ee281acec202f0$var$__setModuleDefault = $c6ee281acec202f0$exports && $c6ee281acec202f0$exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $c6ee281acec202f0$var$__importStar = $c6ee281acec202f0$exports && $c6ee281acec202f0$exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $c6ee281acec202f0$var$__createBinding(result, mod, k);
    }
    $c6ee281acec202f0$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty($c6ee281acec202f0$exports, "__esModule", {
    value: true
});
$c6ee281acec202f0$exports.Params = $c6ee281acec202f0$exports.DenomTrace = $c6ee281acec202f0$exports.protobufPackage = void 0;

/* eslint-disable */ const $c6ee281acec202f0$var$_m0 = $c6ee281acec202f0$var$__importStar((parcelRequire("fQBv0")));

$c6ee281acec202f0$exports.protobufPackage = "ibc.applications.transfer.v1";
function $c6ee281acec202f0$var$createBaseDenomTrace() {
    return {
        path: "",
        baseDenom: ""
    };
}
$c6ee281acec202f0$exports.DenomTrace = {
    encode (message, writer = $c6ee281acec202f0$var$_m0.Writer.create()) {
        if (message.path !== "") writer.uint32(10).string(message.path);
        if (message.baseDenom !== "") writer.uint32(18).string(message.baseDenom);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $c6ee281acec202f0$var$_m0.Reader ? input : new $c6ee281acec202f0$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $c6ee281acec202f0$var$createBaseDenomTrace();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.path = reader.string();
                    break;
                case 2:
                    message.baseDenom = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            path: (0, $d5e07fe2518aae94$exports.isSet)(object.path) ? String(object.path) : "",
            baseDenom: (0, $d5e07fe2518aae94$exports.isSet)(object.baseDenom) ? String(object.baseDenom) : ""
        };
    },
    toJSON (message) {
        const obj = {};
        message.path !== undefined && (obj.path = message.path);
        message.baseDenom !== undefined && (obj.baseDenom = message.baseDenom);
        return obj;
    },
    fromPartial (object) {
        const message = $c6ee281acec202f0$var$createBaseDenomTrace();
        message.path = object.path ?? "";
        message.baseDenom = object.baseDenom ?? "";
        return message;
    }
};
function $c6ee281acec202f0$var$createBaseParams() {
    return {
        sendEnabled: false,
        receiveEnabled: false
    };
}
$c6ee281acec202f0$exports.Params = {
    encode (message, writer = $c6ee281acec202f0$var$_m0.Writer.create()) {
        if (message.sendEnabled === true) writer.uint32(8).bool(message.sendEnabled);
        if (message.receiveEnabled === true) writer.uint32(16).bool(message.receiveEnabled);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $c6ee281acec202f0$var$_m0.Reader ? input : new $c6ee281acec202f0$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $c6ee281acec202f0$var$createBaseParams();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.sendEnabled = reader.bool();
                    break;
                case 2:
                    message.receiveEnabled = reader.bool();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            sendEnabled: (0, $d5e07fe2518aae94$exports.isSet)(object.sendEnabled) ? Boolean(object.sendEnabled) : false,
            receiveEnabled: (0, $d5e07fe2518aae94$exports.isSet)(object.receiveEnabled) ? Boolean(object.receiveEnabled) : false
        };
    },
    toJSON (message) {
        const obj = {};
        message.sendEnabled !== undefined && (obj.sendEnabled = message.sendEnabled);
        message.receiveEnabled !== undefined && (obj.receiveEnabled = message.receiveEnabled);
        return obj;
    },
    fromPartial (object) {
        const message = $c6ee281acec202f0$var$createBaseParams();
        message.sendEnabled = object.sendEnabled ?? false;
        message.receiveEnabled = object.receiveEnabled ?? false;
        return message;
    }
};



const $03f3fe1b5012bca2$var$_m0 = $03f3fe1b5012bca2$var$__importStar((parcelRequire("fQBv0")));

$03f3fe1b5012bca2$exports.protobufPackage = "ibc.applications.transfer.v1";
function $03f3fe1b5012bca2$var$createBaseQueryDenomTraceRequest() {
    return {
        hash: ""
    };
}
$03f3fe1b5012bca2$exports.QueryDenomTraceRequest = {
    encode (message, writer = $03f3fe1b5012bca2$var$_m0.Writer.create()) {
        if (message.hash !== "") writer.uint32(10).string(message.hash);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $03f3fe1b5012bca2$var$_m0.Reader ? input : new $03f3fe1b5012bca2$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $03f3fe1b5012bca2$var$createBaseQueryDenomTraceRequest();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.hash = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            hash: (0, $d5e07fe2518aae94$exports.isSet)(object.hash) ? String(object.hash) : ""
        };
    },
    toJSON (message) {
        const obj = {};
        message.hash !== undefined && (obj.hash = message.hash);
        return obj;
    },
    fromPartial (object) {
        const message = $03f3fe1b5012bca2$var$createBaseQueryDenomTraceRequest();
        message.hash = object.hash ?? "";
        return message;
    }
};
function $03f3fe1b5012bca2$var$createBaseQueryDenomTraceResponse() {
    return {
        denomTrace: undefined
    };
}
$03f3fe1b5012bca2$exports.QueryDenomTraceResponse = {
    encode (message, writer = $03f3fe1b5012bca2$var$_m0.Writer.create()) {
        if (message.denomTrace !== undefined) $c6ee281acec202f0$exports.DenomTrace.encode(message.denomTrace, writer.uint32(10).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $03f3fe1b5012bca2$var$_m0.Reader ? input : new $03f3fe1b5012bca2$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $03f3fe1b5012bca2$var$createBaseQueryDenomTraceResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.denomTrace = $c6ee281acec202f0$exports.DenomTrace.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            denomTrace: (0, $d5e07fe2518aae94$exports.isSet)(object.denomTrace) ? $c6ee281acec202f0$exports.DenomTrace.fromJSON(object.denomTrace) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.denomTrace !== undefined && (obj.denomTrace = message.denomTrace ? $c6ee281acec202f0$exports.DenomTrace.toJSON(message.denomTrace) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $03f3fe1b5012bca2$var$createBaseQueryDenomTraceResponse();
        message.denomTrace = object.denomTrace !== undefined && object.denomTrace !== null ? $c6ee281acec202f0$exports.DenomTrace.fromPartial(object.denomTrace) : undefined;
        return message;
    }
};
function $03f3fe1b5012bca2$var$createBaseQueryDenomTracesRequest() {
    return {
        pagination: undefined
    };
}
$03f3fe1b5012bca2$exports.QueryDenomTracesRequest = {
    encode (message, writer = $03f3fe1b5012bca2$var$_m0.Writer.create()) {
        if (message.pagination !== undefined) $5eae5f3cc99e92ab$exports.PageRequest.encode(message.pagination, writer.uint32(10).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $03f3fe1b5012bca2$var$_m0.Reader ? input : new $03f3fe1b5012bca2$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $03f3fe1b5012bca2$var$createBaseQueryDenomTracesRequest();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.pagination = $5eae5f3cc99e92ab$exports.PageRequest.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            pagination: (0, $d5e07fe2518aae94$exports.isSet)(object.pagination) ? $5eae5f3cc99e92ab$exports.PageRequest.fromJSON(object.pagination) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.pagination !== undefined && (obj.pagination = message.pagination ? $5eae5f3cc99e92ab$exports.PageRequest.toJSON(message.pagination) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $03f3fe1b5012bca2$var$createBaseQueryDenomTracesRequest();
        message.pagination = object.pagination !== undefined && object.pagination !== null ? $5eae5f3cc99e92ab$exports.PageRequest.fromPartial(object.pagination) : undefined;
        return message;
    }
};
function $03f3fe1b5012bca2$var$createBaseQueryDenomTracesResponse() {
    return {
        denomTraces: [],
        pagination: undefined
    };
}
$03f3fe1b5012bca2$exports.QueryDenomTracesResponse = {
    encode (message, writer = $03f3fe1b5012bca2$var$_m0.Writer.create()) {
        for (const v of message.denomTraces)$c6ee281acec202f0$exports.DenomTrace.encode(v, writer.uint32(10).fork()).ldelim();
        if (message.pagination !== undefined) $5eae5f3cc99e92ab$exports.PageResponse.encode(message.pagination, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $03f3fe1b5012bca2$var$_m0.Reader ? input : new $03f3fe1b5012bca2$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $03f3fe1b5012bca2$var$createBaseQueryDenomTracesResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.denomTraces.push($c6ee281acec202f0$exports.DenomTrace.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.pagination = $5eae5f3cc99e92ab$exports.PageResponse.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            denomTraces: Array.isArray(object?.denomTraces) ? object.denomTraces.map((e)=>$c6ee281acec202f0$exports.DenomTrace.fromJSON(e)) : [],
            pagination: (0, $d5e07fe2518aae94$exports.isSet)(object.pagination) ? $5eae5f3cc99e92ab$exports.PageResponse.fromJSON(object.pagination) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        if (message.denomTraces) obj.denomTraces = message.denomTraces.map((e)=>e ? $c6ee281acec202f0$exports.DenomTrace.toJSON(e) : undefined);
        else obj.denomTraces = [];
        message.pagination !== undefined && (obj.pagination = message.pagination ? $5eae5f3cc99e92ab$exports.PageResponse.toJSON(message.pagination) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $03f3fe1b5012bca2$var$createBaseQueryDenomTracesResponse();
        message.denomTraces = object.denomTraces?.map((e)=>$c6ee281acec202f0$exports.DenomTrace.fromPartial(e)) || [];
        message.pagination = object.pagination !== undefined && object.pagination !== null ? $5eae5f3cc99e92ab$exports.PageResponse.fromPartial(object.pagination) : undefined;
        return message;
    }
};
function $03f3fe1b5012bca2$var$createBaseQueryParamsRequest() {
    return {};
}
$03f3fe1b5012bca2$exports.QueryParamsRequest = {
    encode (_, writer = $03f3fe1b5012bca2$var$_m0.Writer.create()) {
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $03f3fe1b5012bca2$var$_m0.Reader ? input : new $03f3fe1b5012bca2$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $03f3fe1b5012bca2$var$createBaseQueryParamsRequest();
        while(reader.pos < end){
            const tag = reader.uint32();
            tag;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON (_) {
        return {};
    },
    toJSON (_) {
        const obj = {};
        return obj;
    },
    fromPartial (_) {
        const message = $03f3fe1b5012bca2$var$createBaseQueryParamsRequest();
        return message;
    }
};
function $03f3fe1b5012bca2$var$createBaseQueryParamsResponse() {
    return {
        params: undefined
    };
}
$03f3fe1b5012bca2$exports.QueryParamsResponse = {
    encode (message, writer = $03f3fe1b5012bca2$var$_m0.Writer.create()) {
        if (message.params !== undefined) $c6ee281acec202f0$exports.Params.encode(message.params, writer.uint32(10).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $03f3fe1b5012bca2$var$_m0.Reader ? input : new $03f3fe1b5012bca2$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $03f3fe1b5012bca2$var$createBaseQueryParamsResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.params = $c6ee281acec202f0$exports.Params.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            params: (0, $d5e07fe2518aae94$exports.isSet)(object.params) ? $c6ee281acec202f0$exports.Params.fromJSON(object.params) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.params !== undefined && (obj.params = message.params ? $c6ee281acec202f0$exports.Params.toJSON(message.params) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $03f3fe1b5012bca2$var$createBaseQueryParamsResponse();
        message.params = object.params !== undefined && object.params !== null ? $c6ee281acec202f0$exports.Params.fromPartial(object.params) : undefined;
        return message;
    }
};
function $03f3fe1b5012bca2$var$createBaseQueryDenomHashRequest() {
    return {
        trace: ""
    };
}
$03f3fe1b5012bca2$exports.QueryDenomHashRequest = {
    encode (message, writer = $03f3fe1b5012bca2$var$_m0.Writer.create()) {
        if (message.trace !== "") writer.uint32(10).string(message.trace);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $03f3fe1b5012bca2$var$_m0.Reader ? input : new $03f3fe1b5012bca2$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $03f3fe1b5012bca2$var$createBaseQueryDenomHashRequest();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.trace = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            trace: (0, $d5e07fe2518aae94$exports.isSet)(object.trace) ? String(object.trace) : ""
        };
    },
    toJSON (message) {
        const obj = {};
        message.trace !== undefined && (obj.trace = message.trace);
        return obj;
    },
    fromPartial (object) {
        const message = $03f3fe1b5012bca2$var$createBaseQueryDenomHashRequest();
        message.trace = object.trace ?? "";
        return message;
    }
};
function $03f3fe1b5012bca2$var$createBaseQueryDenomHashResponse() {
    return {
        hash: ""
    };
}
$03f3fe1b5012bca2$exports.QueryDenomHashResponse = {
    encode (message, writer = $03f3fe1b5012bca2$var$_m0.Writer.create()) {
        if (message.hash !== "") writer.uint32(10).string(message.hash);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $03f3fe1b5012bca2$var$_m0.Reader ? input : new $03f3fe1b5012bca2$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $03f3fe1b5012bca2$var$createBaseQueryDenomHashResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.hash = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            hash: (0, $d5e07fe2518aae94$exports.isSet)(object.hash) ? String(object.hash) : ""
        };
    },
    toJSON (message) {
        const obj = {};
        message.hash !== undefined && (obj.hash = message.hash);
        return obj;
    },
    fromPartial (object) {
        const message = $03f3fe1b5012bca2$var$createBaseQueryDenomHashResponse();
        message.hash = object.hash ?? "";
        return message;
    }
};
function $03f3fe1b5012bca2$var$createBaseQueryEscrowAddressRequest() {
    return {
        portId: "",
        channelId: ""
    };
}
$03f3fe1b5012bca2$exports.QueryEscrowAddressRequest = {
    encode (message, writer = $03f3fe1b5012bca2$var$_m0.Writer.create()) {
        if (message.portId !== "") writer.uint32(10).string(message.portId);
        if (message.channelId !== "") writer.uint32(18).string(message.channelId);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $03f3fe1b5012bca2$var$_m0.Reader ? input : new $03f3fe1b5012bca2$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $03f3fe1b5012bca2$var$createBaseQueryEscrowAddressRequest();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.portId = reader.string();
                    break;
                case 2:
                    message.channelId = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            portId: (0, $d5e07fe2518aae94$exports.isSet)(object.portId) ? String(object.portId) : "",
            channelId: (0, $d5e07fe2518aae94$exports.isSet)(object.channelId) ? String(object.channelId) : ""
        };
    },
    toJSON (message) {
        const obj = {};
        message.portId !== undefined && (obj.portId = message.portId);
        message.channelId !== undefined && (obj.channelId = message.channelId);
        return obj;
    },
    fromPartial (object) {
        const message = $03f3fe1b5012bca2$var$createBaseQueryEscrowAddressRequest();
        message.portId = object.portId ?? "";
        message.channelId = object.channelId ?? "";
        return message;
    }
};
function $03f3fe1b5012bca2$var$createBaseQueryEscrowAddressResponse() {
    return {
        escrowAddress: ""
    };
}
$03f3fe1b5012bca2$exports.QueryEscrowAddressResponse = {
    encode (message, writer = $03f3fe1b5012bca2$var$_m0.Writer.create()) {
        if (message.escrowAddress !== "") writer.uint32(10).string(message.escrowAddress);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $03f3fe1b5012bca2$var$_m0.Reader ? input : new $03f3fe1b5012bca2$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $03f3fe1b5012bca2$var$createBaseQueryEscrowAddressResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.escrowAddress = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            escrowAddress: (0, $d5e07fe2518aae94$exports.isSet)(object.escrowAddress) ? String(object.escrowAddress) : ""
        };
    },
    toJSON (message) {
        const obj = {};
        message.escrowAddress !== undefined && (obj.escrowAddress = message.escrowAddress);
        return obj;
    },
    fromPartial (object) {
        const message = $03f3fe1b5012bca2$var$createBaseQueryEscrowAddressResponse();
        message.escrowAddress = object.escrowAddress ?? "";
        return message;
    }
};
class $03f3fe1b5012bca2$var$QueryClientImpl {
    constructor(rpc){
        this.rpc = rpc;
        this.DenomTrace = this.DenomTrace.bind(this);
        this.DenomTraces = this.DenomTraces.bind(this);
        this.Params = this.Params.bind(this);
        this.DenomHash = this.DenomHash.bind(this);
        this.EscrowAddress = this.EscrowAddress.bind(this);
    }
    DenomTrace(request) {
        const data = $03f3fe1b5012bca2$exports.QueryDenomTraceRequest.encode(request).finish();
        const promise = this.rpc.request("ibc.applications.transfer.v1.Query", "DenomTrace", data);
        return promise.then((data)=>$03f3fe1b5012bca2$exports.QueryDenomTraceResponse.decode(new $03f3fe1b5012bca2$var$_m0.Reader(data)));
    }
    DenomTraces(request = {
        pagination: undefined
    }) {
        const data = $03f3fe1b5012bca2$exports.QueryDenomTracesRequest.encode(request).finish();
        const promise = this.rpc.request("ibc.applications.transfer.v1.Query", "DenomTraces", data);
        return promise.then((data)=>$03f3fe1b5012bca2$exports.QueryDenomTracesResponse.decode(new $03f3fe1b5012bca2$var$_m0.Reader(data)));
    }
    Params(request = {}) {
        const data = $03f3fe1b5012bca2$exports.QueryParamsRequest.encode(request).finish();
        const promise = this.rpc.request("ibc.applications.transfer.v1.Query", "Params", data);
        return promise.then((data)=>$03f3fe1b5012bca2$exports.QueryParamsResponse.decode(new $03f3fe1b5012bca2$var$_m0.Reader(data)));
    }
    DenomHash(request) {
        const data = $03f3fe1b5012bca2$exports.QueryDenomHashRequest.encode(request).finish();
        const promise = this.rpc.request("ibc.applications.transfer.v1.Query", "DenomHash", data);
        return promise.then((data)=>$03f3fe1b5012bca2$exports.QueryDenomHashResponse.decode(new $03f3fe1b5012bca2$var$_m0.Reader(data)));
    }
    EscrowAddress(request) {
        const data = $03f3fe1b5012bca2$exports.QueryEscrowAddressRequest.encode(request).finish();
        const promise = this.rpc.request("ibc.applications.transfer.v1.Query", "EscrowAddress", data);
        return promise.then((data)=>$03f3fe1b5012bca2$exports.QueryEscrowAddressResponse.decode(new $03f3fe1b5012bca2$var$_m0.Reader(data)));
    }
}
$03f3fe1b5012bca2$exports.QueryClientImpl = $03f3fe1b5012bca2$var$QueryClientImpl;



var $8ac3b8b757f7662f$exports = {};
"use strict";
var $8ac3b8b757f7662f$var$__createBinding = $8ac3b8b757f7662f$exports && $8ac3b8b757f7662f$exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $8ac3b8b757f7662f$var$__setModuleDefault = $8ac3b8b757f7662f$exports && $8ac3b8b757f7662f$exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $8ac3b8b757f7662f$var$__importStar = $8ac3b8b757f7662f$exports && $8ac3b8b757f7662f$exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $8ac3b8b757f7662f$var$__createBinding(result, mod, k);
    }
    $8ac3b8b757f7662f$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty($8ac3b8b757f7662f$exports, "__esModule", {
    value: true
});
$8ac3b8b757f7662f$exports.QueryClientImpl = $8ac3b8b757f7662f$exports.QueryNextSequenceReceiveResponse = $8ac3b8b757f7662f$exports.QueryNextSequenceReceiveRequest = $8ac3b8b757f7662f$exports.QueryUnreceivedAcksResponse = $8ac3b8b757f7662f$exports.QueryUnreceivedAcksRequest = $8ac3b8b757f7662f$exports.QueryUnreceivedPacketsResponse = $8ac3b8b757f7662f$exports.QueryUnreceivedPacketsRequest = $8ac3b8b757f7662f$exports.QueryPacketAcknowledgementsResponse = $8ac3b8b757f7662f$exports.QueryPacketAcknowledgementsRequest = $8ac3b8b757f7662f$exports.QueryPacketAcknowledgementResponse = $8ac3b8b757f7662f$exports.QueryPacketAcknowledgementRequest = $8ac3b8b757f7662f$exports.QueryPacketReceiptResponse = $8ac3b8b757f7662f$exports.QueryPacketReceiptRequest = $8ac3b8b757f7662f$exports.QueryPacketCommitmentsResponse = $8ac3b8b757f7662f$exports.QueryPacketCommitmentsRequest = $8ac3b8b757f7662f$exports.QueryPacketCommitmentResponse = $8ac3b8b757f7662f$exports.QueryPacketCommitmentRequest = $8ac3b8b757f7662f$exports.QueryChannelConsensusStateResponse = $8ac3b8b757f7662f$exports.QueryChannelConsensusStateRequest = $8ac3b8b757f7662f$exports.QueryChannelClientStateResponse = $8ac3b8b757f7662f$exports.QueryChannelClientStateRequest = $8ac3b8b757f7662f$exports.QueryConnectionChannelsResponse = $8ac3b8b757f7662f$exports.QueryConnectionChannelsRequest = $8ac3b8b757f7662f$exports.QueryChannelsResponse = $8ac3b8b757f7662f$exports.QueryChannelsRequest = $8ac3b8b757f7662f$exports.QueryChannelResponse = $8ac3b8b757f7662f$exports.QueryChannelRequest = $8ac3b8b757f7662f$exports.protobufPackage = void 0;






const $8ac3b8b757f7662f$var$_m0 = $8ac3b8b757f7662f$var$__importStar((parcelRequire("fQBv0")));
$8ac3b8b757f7662f$exports.protobufPackage = "ibc.core.channel.v1";
function $8ac3b8b757f7662f$var$createBaseQueryChannelRequest() {
    return {
        portId: "",
        channelId: ""
    };
}
$8ac3b8b757f7662f$exports.QueryChannelRequest = {
    encode (message, writer = $8ac3b8b757f7662f$var$_m0.Writer.create()) {
        if (message.portId !== "") writer.uint32(10).string(message.portId);
        if (message.channelId !== "") writer.uint32(18).string(message.channelId);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $8ac3b8b757f7662f$var$_m0.Reader ? input : new $8ac3b8b757f7662f$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $8ac3b8b757f7662f$var$createBaseQueryChannelRequest();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.portId = reader.string();
                    break;
                case 2:
                    message.channelId = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            portId: (0, $d5e07fe2518aae94$exports.isSet)(object.portId) ? String(object.portId) : "",
            channelId: (0, $d5e07fe2518aae94$exports.isSet)(object.channelId) ? String(object.channelId) : ""
        };
    },
    toJSON (message) {
        const obj = {};
        message.portId !== undefined && (obj.portId = message.portId);
        message.channelId !== undefined && (obj.channelId = message.channelId);
        return obj;
    },
    fromPartial (object) {
        const message = $8ac3b8b757f7662f$var$createBaseQueryChannelRequest();
        message.portId = object.portId ?? "";
        message.channelId = object.channelId ?? "";
        return message;
    }
};
function $8ac3b8b757f7662f$var$createBaseQueryChannelResponse() {
    return {
        channel: undefined,
        proof: new Uint8Array(),
        proofHeight: undefined
    };
}
$8ac3b8b757f7662f$exports.QueryChannelResponse = {
    encode (message, writer = $8ac3b8b757f7662f$var$_m0.Writer.create()) {
        if (message.channel !== undefined) $e21f9e7cb16364b7$exports.Channel.encode(message.channel, writer.uint32(10).fork()).ldelim();
        if (message.proof.length !== 0) writer.uint32(18).bytes(message.proof);
        if (message.proofHeight !== undefined) $7d28e43a1e22112f$exports.Height.encode(message.proofHeight, writer.uint32(26).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $8ac3b8b757f7662f$var$_m0.Reader ? input : new $8ac3b8b757f7662f$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $8ac3b8b757f7662f$var$createBaseQueryChannelResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.channel = $e21f9e7cb16364b7$exports.Channel.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.proof = reader.bytes();
                    break;
                case 3:
                    message.proofHeight = $7d28e43a1e22112f$exports.Height.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            channel: (0, $d5e07fe2518aae94$exports.isSet)(object.channel) ? $e21f9e7cb16364b7$exports.Channel.fromJSON(object.channel) : undefined,
            proof: (0, $d5e07fe2518aae94$exports.isSet)(object.proof) ? (0, $d5e07fe2518aae94$exports.bytesFromBase64)(object.proof) : new Uint8Array(),
            proofHeight: (0, $d5e07fe2518aae94$exports.isSet)(object.proofHeight) ? $7d28e43a1e22112f$exports.Height.fromJSON(object.proofHeight) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.channel !== undefined && (obj.channel = message.channel ? $e21f9e7cb16364b7$exports.Channel.toJSON(message.channel) : undefined);
        message.proof !== undefined && (obj.proof = (0, $d5e07fe2518aae94$exports.base64FromBytes)(message.proof !== undefined ? message.proof : new Uint8Array()));
        message.proofHeight !== undefined && (obj.proofHeight = message.proofHeight ? $7d28e43a1e22112f$exports.Height.toJSON(message.proofHeight) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $8ac3b8b757f7662f$var$createBaseQueryChannelResponse();
        message.channel = object.channel !== undefined && object.channel !== null ? $e21f9e7cb16364b7$exports.Channel.fromPartial(object.channel) : undefined;
        message.proof = object.proof ?? new Uint8Array();
        message.proofHeight = object.proofHeight !== undefined && object.proofHeight !== null ? $7d28e43a1e22112f$exports.Height.fromPartial(object.proofHeight) : undefined;
        return message;
    }
};
function $8ac3b8b757f7662f$var$createBaseQueryChannelsRequest() {
    return {
        pagination: undefined
    };
}
$8ac3b8b757f7662f$exports.QueryChannelsRequest = {
    encode (message, writer = $8ac3b8b757f7662f$var$_m0.Writer.create()) {
        if (message.pagination !== undefined) $5eae5f3cc99e92ab$exports.PageRequest.encode(message.pagination, writer.uint32(10).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $8ac3b8b757f7662f$var$_m0.Reader ? input : new $8ac3b8b757f7662f$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $8ac3b8b757f7662f$var$createBaseQueryChannelsRequest();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.pagination = $5eae5f3cc99e92ab$exports.PageRequest.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            pagination: (0, $d5e07fe2518aae94$exports.isSet)(object.pagination) ? $5eae5f3cc99e92ab$exports.PageRequest.fromJSON(object.pagination) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.pagination !== undefined && (obj.pagination = message.pagination ? $5eae5f3cc99e92ab$exports.PageRequest.toJSON(message.pagination) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $8ac3b8b757f7662f$var$createBaseQueryChannelsRequest();
        message.pagination = object.pagination !== undefined && object.pagination !== null ? $5eae5f3cc99e92ab$exports.PageRequest.fromPartial(object.pagination) : undefined;
        return message;
    }
};
function $8ac3b8b757f7662f$var$createBaseQueryChannelsResponse() {
    return {
        channels: [],
        pagination: undefined,
        height: undefined
    };
}
$8ac3b8b757f7662f$exports.QueryChannelsResponse = {
    encode (message, writer = $8ac3b8b757f7662f$var$_m0.Writer.create()) {
        for (const v of message.channels)$e21f9e7cb16364b7$exports.IdentifiedChannel.encode(v, writer.uint32(10).fork()).ldelim();
        if (message.pagination !== undefined) $5eae5f3cc99e92ab$exports.PageResponse.encode(message.pagination, writer.uint32(18).fork()).ldelim();
        if (message.height !== undefined) $7d28e43a1e22112f$exports.Height.encode(message.height, writer.uint32(26).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $8ac3b8b757f7662f$var$_m0.Reader ? input : new $8ac3b8b757f7662f$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $8ac3b8b757f7662f$var$createBaseQueryChannelsResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.channels.push($e21f9e7cb16364b7$exports.IdentifiedChannel.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.pagination = $5eae5f3cc99e92ab$exports.PageResponse.decode(reader, reader.uint32());
                    break;
                case 3:
                    message.height = $7d28e43a1e22112f$exports.Height.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            channels: Array.isArray(object?.channels) ? object.channels.map((e)=>$e21f9e7cb16364b7$exports.IdentifiedChannel.fromJSON(e)) : [],
            pagination: (0, $d5e07fe2518aae94$exports.isSet)(object.pagination) ? $5eae5f3cc99e92ab$exports.PageResponse.fromJSON(object.pagination) : undefined,
            height: (0, $d5e07fe2518aae94$exports.isSet)(object.height) ? $7d28e43a1e22112f$exports.Height.fromJSON(object.height) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        if (message.channels) obj.channels = message.channels.map((e)=>e ? $e21f9e7cb16364b7$exports.IdentifiedChannel.toJSON(e) : undefined);
        else obj.channels = [];
        message.pagination !== undefined && (obj.pagination = message.pagination ? $5eae5f3cc99e92ab$exports.PageResponse.toJSON(message.pagination) : undefined);
        message.height !== undefined && (obj.height = message.height ? $7d28e43a1e22112f$exports.Height.toJSON(message.height) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $8ac3b8b757f7662f$var$createBaseQueryChannelsResponse();
        message.channels = object.channels?.map((e)=>$e21f9e7cb16364b7$exports.IdentifiedChannel.fromPartial(e)) || [];
        message.pagination = object.pagination !== undefined && object.pagination !== null ? $5eae5f3cc99e92ab$exports.PageResponse.fromPartial(object.pagination) : undefined;
        message.height = object.height !== undefined && object.height !== null ? $7d28e43a1e22112f$exports.Height.fromPartial(object.height) : undefined;
        return message;
    }
};
function $8ac3b8b757f7662f$var$createBaseQueryConnectionChannelsRequest() {
    return {
        connection: "",
        pagination: undefined
    };
}
$8ac3b8b757f7662f$exports.QueryConnectionChannelsRequest = {
    encode (message, writer = $8ac3b8b757f7662f$var$_m0.Writer.create()) {
        if (message.connection !== "") writer.uint32(10).string(message.connection);
        if (message.pagination !== undefined) $5eae5f3cc99e92ab$exports.PageRequest.encode(message.pagination, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $8ac3b8b757f7662f$var$_m0.Reader ? input : new $8ac3b8b757f7662f$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $8ac3b8b757f7662f$var$createBaseQueryConnectionChannelsRequest();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.connection = reader.string();
                    break;
                case 2:
                    message.pagination = $5eae5f3cc99e92ab$exports.PageRequest.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            connection: (0, $d5e07fe2518aae94$exports.isSet)(object.connection) ? String(object.connection) : "",
            pagination: (0, $d5e07fe2518aae94$exports.isSet)(object.pagination) ? $5eae5f3cc99e92ab$exports.PageRequest.fromJSON(object.pagination) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.connection !== undefined && (obj.connection = message.connection);
        message.pagination !== undefined && (obj.pagination = message.pagination ? $5eae5f3cc99e92ab$exports.PageRequest.toJSON(message.pagination) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $8ac3b8b757f7662f$var$createBaseQueryConnectionChannelsRequest();
        message.connection = object.connection ?? "";
        message.pagination = object.pagination !== undefined && object.pagination !== null ? $5eae5f3cc99e92ab$exports.PageRequest.fromPartial(object.pagination) : undefined;
        return message;
    }
};
function $8ac3b8b757f7662f$var$createBaseQueryConnectionChannelsResponse() {
    return {
        channels: [],
        pagination: undefined,
        height: undefined
    };
}
$8ac3b8b757f7662f$exports.QueryConnectionChannelsResponse = {
    encode (message, writer = $8ac3b8b757f7662f$var$_m0.Writer.create()) {
        for (const v of message.channels)$e21f9e7cb16364b7$exports.IdentifiedChannel.encode(v, writer.uint32(10).fork()).ldelim();
        if (message.pagination !== undefined) $5eae5f3cc99e92ab$exports.PageResponse.encode(message.pagination, writer.uint32(18).fork()).ldelim();
        if (message.height !== undefined) $7d28e43a1e22112f$exports.Height.encode(message.height, writer.uint32(26).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $8ac3b8b757f7662f$var$_m0.Reader ? input : new $8ac3b8b757f7662f$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $8ac3b8b757f7662f$var$createBaseQueryConnectionChannelsResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.channels.push($e21f9e7cb16364b7$exports.IdentifiedChannel.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.pagination = $5eae5f3cc99e92ab$exports.PageResponse.decode(reader, reader.uint32());
                    break;
                case 3:
                    message.height = $7d28e43a1e22112f$exports.Height.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            channels: Array.isArray(object?.channels) ? object.channels.map((e)=>$e21f9e7cb16364b7$exports.IdentifiedChannel.fromJSON(e)) : [],
            pagination: (0, $d5e07fe2518aae94$exports.isSet)(object.pagination) ? $5eae5f3cc99e92ab$exports.PageResponse.fromJSON(object.pagination) : undefined,
            height: (0, $d5e07fe2518aae94$exports.isSet)(object.height) ? $7d28e43a1e22112f$exports.Height.fromJSON(object.height) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        if (message.channels) obj.channels = message.channels.map((e)=>e ? $e21f9e7cb16364b7$exports.IdentifiedChannel.toJSON(e) : undefined);
        else obj.channels = [];
        message.pagination !== undefined && (obj.pagination = message.pagination ? $5eae5f3cc99e92ab$exports.PageResponse.toJSON(message.pagination) : undefined);
        message.height !== undefined && (obj.height = message.height ? $7d28e43a1e22112f$exports.Height.toJSON(message.height) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $8ac3b8b757f7662f$var$createBaseQueryConnectionChannelsResponse();
        message.channels = object.channels?.map((e)=>$e21f9e7cb16364b7$exports.IdentifiedChannel.fromPartial(e)) || [];
        message.pagination = object.pagination !== undefined && object.pagination !== null ? $5eae5f3cc99e92ab$exports.PageResponse.fromPartial(object.pagination) : undefined;
        message.height = object.height !== undefined && object.height !== null ? $7d28e43a1e22112f$exports.Height.fromPartial(object.height) : undefined;
        return message;
    }
};
function $8ac3b8b757f7662f$var$createBaseQueryChannelClientStateRequest() {
    return {
        portId: "",
        channelId: ""
    };
}
$8ac3b8b757f7662f$exports.QueryChannelClientStateRequest = {
    encode (message, writer = $8ac3b8b757f7662f$var$_m0.Writer.create()) {
        if (message.portId !== "") writer.uint32(10).string(message.portId);
        if (message.channelId !== "") writer.uint32(18).string(message.channelId);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $8ac3b8b757f7662f$var$_m0.Reader ? input : new $8ac3b8b757f7662f$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $8ac3b8b757f7662f$var$createBaseQueryChannelClientStateRequest();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.portId = reader.string();
                    break;
                case 2:
                    message.channelId = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            portId: (0, $d5e07fe2518aae94$exports.isSet)(object.portId) ? String(object.portId) : "",
            channelId: (0, $d5e07fe2518aae94$exports.isSet)(object.channelId) ? String(object.channelId) : ""
        };
    },
    toJSON (message) {
        const obj = {};
        message.portId !== undefined && (obj.portId = message.portId);
        message.channelId !== undefined && (obj.channelId = message.channelId);
        return obj;
    },
    fromPartial (object) {
        const message = $8ac3b8b757f7662f$var$createBaseQueryChannelClientStateRequest();
        message.portId = object.portId ?? "";
        message.channelId = object.channelId ?? "";
        return message;
    }
};
function $8ac3b8b757f7662f$var$createBaseQueryChannelClientStateResponse() {
    return {
        identifiedClientState: undefined,
        proof: new Uint8Array(),
        proofHeight: undefined
    };
}
$8ac3b8b757f7662f$exports.QueryChannelClientStateResponse = {
    encode (message, writer = $8ac3b8b757f7662f$var$_m0.Writer.create()) {
        if (message.identifiedClientState !== undefined) $7d28e43a1e22112f$exports.IdentifiedClientState.encode(message.identifiedClientState, writer.uint32(10).fork()).ldelim();
        if (message.proof.length !== 0) writer.uint32(18).bytes(message.proof);
        if (message.proofHeight !== undefined) $7d28e43a1e22112f$exports.Height.encode(message.proofHeight, writer.uint32(26).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $8ac3b8b757f7662f$var$_m0.Reader ? input : new $8ac3b8b757f7662f$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $8ac3b8b757f7662f$var$createBaseQueryChannelClientStateResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.identifiedClientState = $7d28e43a1e22112f$exports.IdentifiedClientState.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.proof = reader.bytes();
                    break;
                case 3:
                    message.proofHeight = $7d28e43a1e22112f$exports.Height.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            identifiedClientState: (0, $d5e07fe2518aae94$exports.isSet)(object.identifiedClientState) ? $7d28e43a1e22112f$exports.IdentifiedClientState.fromJSON(object.identifiedClientState) : undefined,
            proof: (0, $d5e07fe2518aae94$exports.isSet)(object.proof) ? (0, $d5e07fe2518aae94$exports.bytesFromBase64)(object.proof) : new Uint8Array(),
            proofHeight: (0, $d5e07fe2518aae94$exports.isSet)(object.proofHeight) ? $7d28e43a1e22112f$exports.Height.fromJSON(object.proofHeight) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.identifiedClientState !== undefined && (obj.identifiedClientState = message.identifiedClientState ? $7d28e43a1e22112f$exports.IdentifiedClientState.toJSON(message.identifiedClientState) : undefined);
        message.proof !== undefined && (obj.proof = (0, $d5e07fe2518aae94$exports.base64FromBytes)(message.proof !== undefined ? message.proof : new Uint8Array()));
        message.proofHeight !== undefined && (obj.proofHeight = message.proofHeight ? $7d28e43a1e22112f$exports.Height.toJSON(message.proofHeight) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $8ac3b8b757f7662f$var$createBaseQueryChannelClientStateResponse();
        message.identifiedClientState = object.identifiedClientState !== undefined && object.identifiedClientState !== null ? $7d28e43a1e22112f$exports.IdentifiedClientState.fromPartial(object.identifiedClientState) : undefined;
        message.proof = object.proof ?? new Uint8Array();
        message.proofHeight = object.proofHeight !== undefined && object.proofHeight !== null ? $7d28e43a1e22112f$exports.Height.fromPartial(object.proofHeight) : undefined;
        return message;
    }
};
function $8ac3b8b757f7662f$var$createBaseQueryChannelConsensusStateRequest() {
    return {
        portId: "",
        channelId: "",
        revisionNumber: $d5e07fe2518aae94$exports.Long.UZERO,
        revisionHeight: $d5e07fe2518aae94$exports.Long.UZERO
    };
}
$8ac3b8b757f7662f$exports.QueryChannelConsensusStateRequest = {
    encode (message, writer = $8ac3b8b757f7662f$var$_m0.Writer.create()) {
        if (message.portId !== "") writer.uint32(10).string(message.portId);
        if (message.channelId !== "") writer.uint32(18).string(message.channelId);
        if (!message.revisionNumber.isZero()) writer.uint32(24).uint64(message.revisionNumber);
        if (!message.revisionHeight.isZero()) writer.uint32(32).uint64(message.revisionHeight);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $8ac3b8b757f7662f$var$_m0.Reader ? input : new $8ac3b8b757f7662f$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $8ac3b8b757f7662f$var$createBaseQueryChannelConsensusStateRequest();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.portId = reader.string();
                    break;
                case 2:
                    message.channelId = reader.string();
                    break;
                case 3:
                    message.revisionNumber = reader.uint64();
                    break;
                case 4:
                    message.revisionHeight = reader.uint64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            portId: (0, $d5e07fe2518aae94$exports.isSet)(object.portId) ? String(object.portId) : "",
            channelId: (0, $d5e07fe2518aae94$exports.isSet)(object.channelId) ? String(object.channelId) : "",
            revisionNumber: (0, $d5e07fe2518aae94$exports.isSet)(object.revisionNumber) ? $d5e07fe2518aae94$exports.Long.fromValue(object.revisionNumber) : $d5e07fe2518aae94$exports.Long.UZERO,
            revisionHeight: (0, $d5e07fe2518aae94$exports.isSet)(object.revisionHeight) ? $d5e07fe2518aae94$exports.Long.fromValue(object.revisionHeight) : $d5e07fe2518aae94$exports.Long.UZERO
        };
    },
    toJSON (message) {
        const obj = {};
        message.portId !== undefined && (obj.portId = message.portId);
        message.channelId !== undefined && (obj.channelId = message.channelId);
        message.revisionNumber !== undefined && (obj.revisionNumber = (message.revisionNumber || $d5e07fe2518aae94$exports.Long.UZERO).toString());
        message.revisionHeight !== undefined && (obj.revisionHeight = (message.revisionHeight || $d5e07fe2518aae94$exports.Long.UZERO).toString());
        return obj;
    },
    fromPartial (object) {
        const message = $8ac3b8b757f7662f$var$createBaseQueryChannelConsensusStateRequest();
        message.portId = object.portId ?? "";
        message.channelId = object.channelId ?? "";
        message.revisionNumber = object.revisionNumber !== undefined && object.revisionNumber !== null ? $d5e07fe2518aae94$exports.Long.fromValue(object.revisionNumber) : $d5e07fe2518aae94$exports.Long.UZERO;
        message.revisionHeight = object.revisionHeight !== undefined && object.revisionHeight !== null ? $d5e07fe2518aae94$exports.Long.fromValue(object.revisionHeight) : $d5e07fe2518aae94$exports.Long.UZERO;
        return message;
    }
};
function $8ac3b8b757f7662f$var$createBaseQueryChannelConsensusStateResponse() {
    return {
        consensusState: undefined,
        clientId: "",
        proof: new Uint8Array(),
        proofHeight: undefined
    };
}
$8ac3b8b757f7662f$exports.QueryChannelConsensusStateResponse = {
    encode (message, writer = $8ac3b8b757f7662f$var$_m0.Writer.create()) {
        if (message.consensusState !== undefined) $64138e590dcf0cc1$exports.Any.encode(message.consensusState, writer.uint32(10).fork()).ldelim();
        if (message.clientId !== "") writer.uint32(18).string(message.clientId);
        if (message.proof.length !== 0) writer.uint32(26).bytes(message.proof);
        if (message.proofHeight !== undefined) $7d28e43a1e22112f$exports.Height.encode(message.proofHeight, writer.uint32(34).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $8ac3b8b757f7662f$var$_m0.Reader ? input : new $8ac3b8b757f7662f$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $8ac3b8b757f7662f$var$createBaseQueryChannelConsensusStateResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.consensusState = $64138e590dcf0cc1$exports.Any.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.clientId = reader.string();
                    break;
                case 3:
                    message.proof = reader.bytes();
                    break;
                case 4:
                    message.proofHeight = $7d28e43a1e22112f$exports.Height.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            consensusState: (0, $d5e07fe2518aae94$exports.isSet)(object.consensusState) ? $64138e590dcf0cc1$exports.Any.fromJSON(object.consensusState) : undefined,
            clientId: (0, $d5e07fe2518aae94$exports.isSet)(object.clientId) ? String(object.clientId) : "",
            proof: (0, $d5e07fe2518aae94$exports.isSet)(object.proof) ? (0, $d5e07fe2518aae94$exports.bytesFromBase64)(object.proof) : new Uint8Array(),
            proofHeight: (0, $d5e07fe2518aae94$exports.isSet)(object.proofHeight) ? $7d28e43a1e22112f$exports.Height.fromJSON(object.proofHeight) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.consensusState !== undefined && (obj.consensusState = message.consensusState ? $64138e590dcf0cc1$exports.Any.toJSON(message.consensusState) : undefined);
        message.clientId !== undefined && (obj.clientId = message.clientId);
        message.proof !== undefined && (obj.proof = (0, $d5e07fe2518aae94$exports.base64FromBytes)(message.proof !== undefined ? message.proof : new Uint8Array()));
        message.proofHeight !== undefined && (obj.proofHeight = message.proofHeight ? $7d28e43a1e22112f$exports.Height.toJSON(message.proofHeight) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $8ac3b8b757f7662f$var$createBaseQueryChannelConsensusStateResponse();
        message.consensusState = object.consensusState !== undefined && object.consensusState !== null ? $64138e590dcf0cc1$exports.Any.fromPartial(object.consensusState) : undefined;
        message.clientId = object.clientId ?? "";
        message.proof = object.proof ?? new Uint8Array();
        message.proofHeight = object.proofHeight !== undefined && object.proofHeight !== null ? $7d28e43a1e22112f$exports.Height.fromPartial(object.proofHeight) : undefined;
        return message;
    }
};
function $8ac3b8b757f7662f$var$createBaseQueryPacketCommitmentRequest() {
    return {
        portId: "",
        channelId: "",
        sequence: $d5e07fe2518aae94$exports.Long.UZERO
    };
}
$8ac3b8b757f7662f$exports.QueryPacketCommitmentRequest = {
    encode (message, writer = $8ac3b8b757f7662f$var$_m0.Writer.create()) {
        if (message.portId !== "") writer.uint32(10).string(message.portId);
        if (message.channelId !== "") writer.uint32(18).string(message.channelId);
        if (!message.sequence.isZero()) writer.uint32(24).uint64(message.sequence);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $8ac3b8b757f7662f$var$_m0.Reader ? input : new $8ac3b8b757f7662f$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $8ac3b8b757f7662f$var$createBaseQueryPacketCommitmentRequest();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.portId = reader.string();
                    break;
                case 2:
                    message.channelId = reader.string();
                    break;
                case 3:
                    message.sequence = reader.uint64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            portId: (0, $d5e07fe2518aae94$exports.isSet)(object.portId) ? String(object.portId) : "",
            channelId: (0, $d5e07fe2518aae94$exports.isSet)(object.channelId) ? String(object.channelId) : "",
            sequence: (0, $d5e07fe2518aae94$exports.isSet)(object.sequence) ? $d5e07fe2518aae94$exports.Long.fromValue(object.sequence) : $d5e07fe2518aae94$exports.Long.UZERO
        };
    },
    toJSON (message) {
        const obj = {};
        message.portId !== undefined && (obj.portId = message.portId);
        message.channelId !== undefined && (obj.channelId = message.channelId);
        message.sequence !== undefined && (obj.sequence = (message.sequence || $d5e07fe2518aae94$exports.Long.UZERO).toString());
        return obj;
    },
    fromPartial (object) {
        const message = $8ac3b8b757f7662f$var$createBaseQueryPacketCommitmentRequest();
        message.portId = object.portId ?? "";
        message.channelId = object.channelId ?? "";
        message.sequence = object.sequence !== undefined && object.sequence !== null ? $d5e07fe2518aae94$exports.Long.fromValue(object.sequence) : $d5e07fe2518aae94$exports.Long.UZERO;
        return message;
    }
};
function $8ac3b8b757f7662f$var$createBaseQueryPacketCommitmentResponse() {
    return {
        commitment: new Uint8Array(),
        proof: new Uint8Array(),
        proofHeight: undefined
    };
}
$8ac3b8b757f7662f$exports.QueryPacketCommitmentResponse = {
    encode (message, writer = $8ac3b8b757f7662f$var$_m0.Writer.create()) {
        if (message.commitment.length !== 0) writer.uint32(10).bytes(message.commitment);
        if (message.proof.length !== 0) writer.uint32(18).bytes(message.proof);
        if (message.proofHeight !== undefined) $7d28e43a1e22112f$exports.Height.encode(message.proofHeight, writer.uint32(26).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $8ac3b8b757f7662f$var$_m0.Reader ? input : new $8ac3b8b757f7662f$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $8ac3b8b757f7662f$var$createBaseQueryPacketCommitmentResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.commitment = reader.bytes();
                    break;
                case 2:
                    message.proof = reader.bytes();
                    break;
                case 3:
                    message.proofHeight = $7d28e43a1e22112f$exports.Height.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            commitment: (0, $d5e07fe2518aae94$exports.isSet)(object.commitment) ? (0, $d5e07fe2518aae94$exports.bytesFromBase64)(object.commitment) : new Uint8Array(),
            proof: (0, $d5e07fe2518aae94$exports.isSet)(object.proof) ? (0, $d5e07fe2518aae94$exports.bytesFromBase64)(object.proof) : new Uint8Array(),
            proofHeight: (0, $d5e07fe2518aae94$exports.isSet)(object.proofHeight) ? $7d28e43a1e22112f$exports.Height.fromJSON(object.proofHeight) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.commitment !== undefined && (obj.commitment = (0, $d5e07fe2518aae94$exports.base64FromBytes)(message.commitment !== undefined ? message.commitment : new Uint8Array()));
        message.proof !== undefined && (obj.proof = (0, $d5e07fe2518aae94$exports.base64FromBytes)(message.proof !== undefined ? message.proof : new Uint8Array()));
        message.proofHeight !== undefined && (obj.proofHeight = message.proofHeight ? $7d28e43a1e22112f$exports.Height.toJSON(message.proofHeight) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $8ac3b8b757f7662f$var$createBaseQueryPacketCommitmentResponse();
        message.commitment = object.commitment ?? new Uint8Array();
        message.proof = object.proof ?? new Uint8Array();
        message.proofHeight = object.proofHeight !== undefined && object.proofHeight !== null ? $7d28e43a1e22112f$exports.Height.fromPartial(object.proofHeight) : undefined;
        return message;
    }
};
function $8ac3b8b757f7662f$var$createBaseQueryPacketCommitmentsRequest() {
    return {
        portId: "",
        channelId: "",
        pagination: undefined
    };
}
$8ac3b8b757f7662f$exports.QueryPacketCommitmentsRequest = {
    encode (message, writer = $8ac3b8b757f7662f$var$_m0.Writer.create()) {
        if (message.portId !== "") writer.uint32(10).string(message.portId);
        if (message.channelId !== "") writer.uint32(18).string(message.channelId);
        if (message.pagination !== undefined) $5eae5f3cc99e92ab$exports.PageRequest.encode(message.pagination, writer.uint32(26).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $8ac3b8b757f7662f$var$_m0.Reader ? input : new $8ac3b8b757f7662f$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $8ac3b8b757f7662f$var$createBaseQueryPacketCommitmentsRequest();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.portId = reader.string();
                    break;
                case 2:
                    message.channelId = reader.string();
                    break;
                case 3:
                    message.pagination = $5eae5f3cc99e92ab$exports.PageRequest.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            portId: (0, $d5e07fe2518aae94$exports.isSet)(object.portId) ? String(object.portId) : "",
            channelId: (0, $d5e07fe2518aae94$exports.isSet)(object.channelId) ? String(object.channelId) : "",
            pagination: (0, $d5e07fe2518aae94$exports.isSet)(object.pagination) ? $5eae5f3cc99e92ab$exports.PageRequest.fromJSON(object.pagination) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.portId !== undefined && (obj.portId = message.portId);
        message.channelId !== undefined && (obj.channelId = message.channelId);
        message.pagination !== undefined && (obj.pagination = message.pagination ? $5eae5f3cc99e92ab$exports.PageRequest.toJSON(message.pagination) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $8ac3b8b757f7662f$var$createBaseQueryPacketCommitmentsRequest();
        message.portId = object.portId ?? "";
        message.channelId = object.channelId ?? "";
        message.pagination = object.pagination !== undefined && object.pagination !== null ? $5eae5f3cc99e92ab$exports.PageRequest.fromPartial(object.pagination) : undefined;
        return message;
    }
};
function $8ac3b8b757f7662f$var$createBaseQueryPacketCommitmentsResponse() {
    return {
        commitments: [],
        pagination: undefined,
        height: undefined
    };
}
$8ac3b8b757f7662f$exports.QueryPacketCommitmentsResponse = {
    encode (message, writer = $8ac3b8b757f7662f$var$_m0.Writer.create()) {
        for (const v of message.commitments)$e21f9e7cb16364b7$exports.PacketState.encode(v, writer.uint32(10).fork()).ldelim();
        if (message.pagination !== undefined) $5eae5f3cc99e92ab$exports.PageResponse.encode(message.pagination, writer.uint32(18).fork()).ldelim();
        if (message.height !== undefined) $7d28e43a1e22112f$exports.Height.encode(message.height, writer.uint32(26).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $8ac3b8b757f7662f$var$_m0.Reader ? input : new $8ac3b8b757f7662f$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $8ac3b8b757f7662f$var$createBaseQueryPacketCommitmentsResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.commitments.push($e21f9e7cb16364b7$exports.PacketState.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.pagination = $5eae5f3cc99e92ab$exports.PageResponse.decode(reader, reader.uint32());
                    break;
                case 3:
                    message.height = $7d28e43a1e22112f$exports.Height.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            commitments: Array.isArray(object?.commitments) ? object.commitments.map((e)=>$e21f9e7cb16364b7$exports.PacketState.fromJSON(e)) : [],
            pagination: (0, $d5e07fe2518aae94$exports.isSet)(object.pagination) ? $5eae5f3cc99e92ab$exports.PageResponse.fromJSON(object.pagination) : undefined,
            height: (0, $d5e07fe2518aae94$exports.isSet)(object.height) ? $7d28e43a1e22112f$exports.Height.fromJSON(object.height) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        if (message.commitments) obj.commitments = message.commitments.map((e)=>e ? $e21f9e7cb16364b7$exports.PacketState.toJSON(e) : undefined);
        else obj.commitments = [];
        message.pagination !== undefined && (obj.pagination = message.pagination ? $5eae5f3cc99e92ab$exports.PageResponse.toJSON(message.pagination) : undefined);
        message.height !== undefined && (obj.height = message.height ? $7d28e43a1e22112f$exports.Height.toJSON(message.height) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $8ac3b8b757f7662f$var$createBaseQueryPacketCommitmentsResponse();
        message.commitments = object.commitments?.map((e)=>$e21f9e7cb16364b7$exports.PacketState.fromPartial(e)) || [];
        message.pagination = object.pagination !== undefined && object.pagination !== null ? $5eae5f3cc99e92ab$exports.PageResponse.fromPartial(object.pagination) : undefined;
        message.height = object.height !== undefined && object.height !== null ? $7d28e43a1e22112f$exports.Height.fromPartial(object.height) : undefined;
        return message;
    }
};
function $8ac3b8b757f7662f$var$createBaseQueryPacketReceiptRequest() {
    return {
        portId: "",
        channelId: "",
        sequence: $d5e07fe2518aae94$exports.Long.UZERO
    };
}
$8ac3b8b757f7662f$exports.QueryPacketReceiptRequest = {
    encode (message, writer = $8ac3b8b757f7662f$var$_m0.Writer.create()) {
        if (message.portId !== "") writer.uint32(10).string(message.portId);
        if (message.channelId !== "") writer.uint32(18).string(message.channelId);
        if (!message.sequence.isZero()) writer.uint32(24).uint64(message.sequence);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $8ac3b8b757f7662f$var$_m0.Reader ? input : new $8ac3b8b757f7662f$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $8ac3b8b757f7662f$var$createBaseQueryPacketReceiptRequest();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.portId = reader.string();
                    break;
                case 2:
                    message.channelId = reader.string();
                    break;
                case 3:
                    message.sequence = reader.uint64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            portId: (0, $d5e07fe2518aae94$exports.isSet)(object.portId) ? String(object.portId) : "",
            channelId: (0, $d5e07fe2518aae94$exports.isSet)(object.channelId) ? String(object.channelId) : "",
            sequence: (0, $d5e07fe2518aae94$exports.isSet)(object.sequence) ? $d5e07fe2518aae94$exports.Long.fromValue(object.sequence) : $d5e07fe2518aae94$exports.Long.UZERO
        };
    },
    toJSON (message) {
        const obj = {};
        message.portId !== undefined && (obj.portId = message.portId);
        message.channelId !== undefined && (obj.channelId = message.channelId);
        message.sequence !== undefined && (obj.sequence = (message.sequence || $d5e07fe2518aae94$exports.Long.UZERO).toString());
        return obj;
    },
    fromPartial (object) {
        const message = $8ac3b8b757f7662f$var$createBaseQueryPacketReceiptRequest();
        message.portId = object.portId ?? "";
        message.channelId = object.channelId ?? "";
        message.sequence = object.sequence !== undefined && object.sequence !== null ? $d5e07fe2518aae94$exports.Long.fromValue(object.sequence) : $d5e07fe2518aae94$exports.Long.UZERO;
        return message;
    }
};
function $8ac3b8b757f7662f$var$createBaseQueryPacketReceiptResponse() {
    return {
        received: false,
        proof: new Uint8Array(),
        proofHeight: undefined
    };
}
$8ac3b8b757f7662f$exports.QueryPacketReceiptResponse = {
    encode (message, writer = $8ac3b8b757f7662f$var$_m0.Writer.create()) {
        if (message.received === true) writer.uint32(16).bool(message.received);
        if (message.proof.length !== 0) writer.uint32(26).bytes(message.proof);
        if (message.proofHeight !== undefined) $7d28e43a1e22112f$exports.Height.encode(message.proofHeight, writer.uint32(34).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $8ac3b8b757f7662f$var$_m0.Reader ? input : new $8ac3b8b757f7662f$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $8ac3b8b757f7662f$var$createBaseQueryPacketReceiptResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 2:
                    message.received = reader.bool();
                    break;
                case 3:
                    message.proof = reader.bytes();
                    break;
                case 4:
                    message.proofHeight = $7d28e43a1e22112f$exports.Height.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            received: (0, $d5e07fe2518aae94$exports.isSet)(object.received) ? Boolean(object.received) : false,
            proof: (0, $d5e07fe2518aae94$exports.isSet)(object.proof) ? (0, $d5e07fe2518aae94$exports.bytesFromBase64)(object.proof) : new Uint8Array(),
            proofHeight: (0, $d5e07fe2518aae94$exports.isSet)(object.proofHeight) ? $7d28e43a1e22112f$exports.Height.fromJSON(object.proofHeight) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.received !== undefined && (obj.received = message.received);
        message.proof !== undefined && (obj.proof = (0, $d5e07fe2518aae94$exports.base64FromBytes)(message.proof !== undefined ? message.proof : new Uint8Array()));
        message.proofHeight !== undefined && (obj.proofHeight = message.proofHeight ? $7d28e43a1e22112f$exports.Height.toJSON(message.proofHeight) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $8ac3b8b757f7662f$var$createBaseQueryPacketReceiptResponse();
        message.received = object.received ?? false;
        message.proof = object.proof ?? new Uint8Array();
        message.proofHeight = object.proofHeight !== undefined && object.proofHeight !== null ? $7d28e43a1e22112f$exports.Height.fromPartial(object.proofHeight) : undefined;
        return message;
    }
};
function $8ac3b8b757f7662f$var$createBaseQueryPacketAcknowledgementRequest() {
    return {
        portId: "",
        channelId: "",
        sequence: $d5e07fe2518aae94$exports.Long.UZERO
    };
}
$8ac3b8b757f7662f$exports.QueryPacketAcknowledgementRequest = {
    encode (message, writer = $8ac3b8b757f7662f$var$_m0.Writer.create()) {
        if (message.portId !== "") writer.uint32(10).string(message.portId);
        if (message.channelId !== "") writer.uint32(18).string(message.channelId);
        if (!message.sequence.isZero()) writer.uint32(24).uint64(message.sequence);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $8ac3b8b757f7662f$var$_m0.Reader ? input : new $8ac3b8b757f7662f$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $8ac3b8b757f7662f$var$createBaseQueryPacketAcknowledgementRequest();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.portId = reader.string();
                    break;
                case 2:
                    message.channelId = reader.string();
                    break;
                case 3:
                    message.sequence = reader.uint64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            portId: (0, $d5e07fe2518aae94$exports.isSet)(object.portId) ? String(object.portId) : "",
            channelId: (0, $d5e07fe2518aae94$exports.isSet)(object.channelId) ? String(object.channelId) : "",
            sequence: (0, $d5e07fe2518aae94$exports.isSet)(object.sequence) ? $d5e07fe2518aae94$exports.Long.fromValue(object.sequence) : $d5e07fe2518aae94$exports.Long.UZERO
        };
    },
    toJSON (message) {
        const obj = {};
        message.portId !== undefined && (obj.portId = message.portId);
        message.channelId !== undefined && (obj.channelId = message.channelId);
        message.sequence !== undefined && (obj.sequence = (message.sequence || $d5e07fe2518aae94$exports.Long.UZERO).toString());
        return obj;
    },
    fromPartial (object) {
        const message = $8ac3b8b757f7662f$var$createBaseQueryPacketAcknowledgementRequest();
        message.portId = object.portId ?? "";
        message.channelId = object.channelId ?? "";
        message.sequence = object.sequence !== undefined && object.sequence !== null ? $d5e07fe2518aae94$exports.Long.fromValue(object.sequence) : $d5e07fe2518aae94$exports.Long.UZERO;
        return message;
    }
};
function $8ac3b8b757f7662f$var$createBaseQueryPacketAcknowledgementResponse() {
    return {
        acknowledgement: new Uint8Array(),
        proof: new Uint8Array(),
        proofHeight: undefined
    };
}
$8ac3b8b757f7662f$exports.QueryPacketAcknowledgementResponse = {
    encode (message, writer = $8ac3b8b757f7662f$var$_m0.Writer.create()) {
        if (message.acknowledgement.length !== 0) writer.uint32(10).bytes(message.acknowledgement);
        if (message.proof.length !== 0) writer.uint32(18).bytes(message.proof);
        if (message.proofHeight !== undefined) $7d28e43a1e22112f$exports.Height.encode(message.proofHeight, writer.uint32(26).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $8ac3b8b757f7662f$var$_m0.Reader ? input : new $8ac3b8b757f7662f$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $8ac3b8b757f7662f$var$createBaseQueryPacketAcknowledgementResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.acknowledgement = reader.bytes();
                    break;
                case 2:
                    message.proof = reader.bytes();
                    break;
                case 3:
                    message.proofHeight = $7d28e43a1e22112f$exports.Height.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            acknowledgement: (0, $d5e07fe2518aae94$exports.isSet)(object.acknowledgement) ? (0, $d5e07fe2518aae94$exports.bytesFromBase64)(object.acknowledgement) : new Uint8Array(),
            proof: (0, $d5e07fe2518aae94$exports.isSet)(object.proof) ? (0, $d5e07fe2518aae94$exports.bytesFromBase64)(object.proof) : new Uint8Array(),
            proofHeight: (0, $d5e07fe2518aae94$exports.isSet)(object.proofHeight) ? $7d28e43a1e22112f$exports.Height.fromJSON(object.proofHeight) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.acknowledgement !== undefined && (obj.acknowledgement = (0, $d5e07fe2518aae94$exports.base64FromBytes)(message.acknowledgement !== undefined ? message.acknowledgement : new Uint8Array()));
        message.proof !== undefined && (obj.proof = (0, $d5e07fe2518aae94$exports.base64FromBytes)(message.proof !== undefined ? message.proof : new Uint8Array()));
        message.proofHeight !== undefined && (obj.proofHeight = message.proofHeight ? $7d28e43a1e22112f$exports.Height.toJSON(message.proofHeight) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $8ac3b8b757f7662f$var$createBaseQueryPacketAcknowledgementResponse();
        message.acknowledgement = object.acknowledgement ?? new Uint8Array();
        message.proof = object.proof ?? new Uint8Array();
        message.proofHeight = object.proofHeight !== undefined && object.proofHeight !== null ? $7d28e43a1e22112f$exports.Height.fromPartial(object.proofHeight) : undefined;
        return message;
    }
};
function $8ac3b8b757f7662f$var$createBaseQueryPacketAcknowledgementsRequest() {
    return {
        portId: "",
        channelId: "",
        pagination: undefined,
        packetCommitmentSequences: []
    };
}
$8ac3b8b757f7662f$exports.QueryPacketAcknowledgementsRequest = {
    encode (message, writer = $8ac3b8b757f7662f$var$_m0.Writer.create()) {
        if (message.portId !== "") writer.uint32(10).string(message.portId);
        if (message.channelId !== "") writer.uint32(18).string(message.channelId);
        if (message.pagination !== undefined) $5eae5f3cc99e92ab$exports.PageRequest.encode(message.pagination, writer.uint32(26).fork()).ldelim();
        writer.uint32(34).fork();
        for (const v of message.packetCommitmentSequences)writer.uint64(v);
        writer.ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $8ac3b8b757f7662f$var$_m0.Reader ? input : new $8ac3b8b757f7662f$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $8ac3b8b757f7662f$var$createBaseQueryPacketAcknowledgementsRequest();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.portId = reader.string();
                    break;
                case 2:
                    message.channelId = reader.string();
                    break;
                case 3:
                    message.pagination = $5eae5f3cc99e92ab$exports.PageRequest.decode(reader, reader.uint32());
                    break;
                case 4:
                    if ((tag & 7) === 2) {
                        const end2 = reader.uint32() + reader.pos;
                        while(reader.pos < end2)message.packetCommitmentSequences.push(reader.uint64());
                    } else message.packetCommitmentSequences.push(reader.uint64());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            portId: (0, $d5e07fe2518aae94$exports.isSet)(object.portId) ? String(object.portId) : "",
            channelId: (0, $d5e07fe2518aae94$exports.isSet)(object.channelId) ? String(object.channelId) : "",
            pagination: (0, $d5e07fe2518aae94$exports.isSet)(object.pagination) ? $5eae5f3cc99e92ab$exports.PageRequest.fromJSON(object.pagination) : undefined,
            packetCommitmentSequences: Array.isArray(object?.packetCommitmentSequences) ? object.packetCommitmentSequences.map((e)=>$d5e07fe2518aae94$exports.Long.fromValue(e)) : []
        };
    },
    toJSON (message) {
        const obj = {};
        message.portId !== undefined && (obj.portId = message.portId);
        message.channelId !== undefined && (obj.channelId = message.channelId);
        message.pagination !== undefined && (obj.pagination = message.pagination ? $5eae5f3cc99e92ab$exports.PageRequest.toJSON(message.pagination) : undefined);
        if (message.packetCommitmentSequences) obj.packetCommitmentSequences = message.packetCommitmentSequences.map((e)=>(e || $d5e07fe2518aae94$exports.Long.UZERO).toString());
        else obj.packetCommitmentSequences = [];
        return obj;
    },
    fromPartial (object) {
        const message = $8ac3b8b757f7662f$var$createBaseQueryPacketAcknowledgementsRequest();
        message.portId = object.portId ?? "";
        message.channelId = object.channelId ?? "";
        message.pagination = object.pagination !== undefined && object.pagination !== null ? $5eae5f3cc99e92ab$exports.PageRequest.fromPartial(object.pagination) : undefined;
        message.packetCommitmentSequences = object.packetCommitmentSequences?.map((e)=>$d5e07fe2518aae94$exports.Long.fromValue(e)) || [];
        return message;
    }
};
function $8ac3b8b757f7662f$var$createBaseQueryPacketAcknowledgementsResponse() {
    return {
        acknowledgements: [],
        pagination: undefined,
        height: undefined
    };
}
$8ac3b8b757f7662f$exports.QueryPacketAcknowledgementsResponse = {
    encode (message, writer = $8ac3b8b757f7662f$var$_m0.Writer.create()) {
        for (const v of message.acknowledgements)$e21f9e7cb16364b7$exports.PacketState.encode(v, writer.uint32(10).fork()).ldelim();
        if (message.pagination !== undefined) $5eae5f3cc99e92ab$exports.PageResponse.encode(message.pagination, writer.uint32(18).fork()).ldelim();
        if (message.height !== undefined) $7d28e43a1e22112f$exports.Height.encode(message.height, writer.uint32(26).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $8ac3b8b757f7662f$var$_m0.Reader ? input : new $8ac3b8b757f7662f$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $8ac3b8b757f7662f$var$createBaseQueryPacketAcknowledgementsResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.acknowledgements.push($e21f9e7cb16364b7$exports.PacketState.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.pagination = $5eae5f3cc99e92ab$exports.PageResponse.decode(reader, reader.uint32());
                    break;
                case 3:
                    message.height = $7d28e43a1e22112f$exports.Height.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            acknowledgements: Array.isArray(object?.acknowledgements) ? object.acknowledgements.map((e)=>$e21f9e7cb16364b7$exports.PacketState.fromJSON(e)) : [],
            pagination: (0, $d5e07fe2518aae94$exports.isSet)(object.pagination) ? $5eae5f3cc99e92ab$exports.PageResponse.fromJSON(object.pagination) : undefined,
            height: (0, $d5e07fe2518aae94$exports.isSet)(object.height) ? $7d28e43a1e22112f$exports.Height.fromJSON(object.height) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        if (message.acknowledgements) obj.acknowledgements = message.acknowledgements.map((e)=>e ? $e21f9e7cb16364b7$exports.PacketState.toJSON(e) : undefined);
        else obj.acknowledgements = [];
        message.pagination !== undefined && (obj.pagination = message.pagination ? $5eae5f3cc99e92ab$exports.PageResponse.toJSON(message.pagination) : undefined);
        message.height !== undefined && (obj.height = message.height ? $7d28e43a1e22112f$exports.Height.toJSON(message.height) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $8ac3b8b757f7662f$var$createBaseQueryPacketAcknowledgementsResponse();
        message.acknowledgements = object.acknowledgements?.map((e)=>$e21f9e7cb16364b7$exports.PacketState.fromPartial(e)) || [];
        message.pagination = object.pagination !== undefined && object.pagination !== null ? $5eae5f3cc99e92ab$exports.PageResponse.fromPartial(object.pagination) : undefined;
        message.height = object.height !== undefined && object.height !== null ? $7d28e43a1e22112f$exports.Height.fromPartial(object.height) : undefined;
        return message;
    }
};
function $8ac3b8b757f7662f$var$createBaseQueryUnreceivedPacketsRequest() {
    return {
        portId: "",
        channelId: "",
        packetCommitmentSequences: []
    };
}
$8ac3b8b757f7662f$exports.QueryUnreceivedPacketsRequest = {
    encode (message, writer = $8ac3b8b757f7662f$var$_m0.Writer.create()) {
        if (message.portId !== "") writer.uint32(10).string(message.portId);
        if (message.channelId !== "") writer.uint32(18).string(message.channelId);
        writer.uint32(26).fork();
        for (const v of message.packetCommitmentSequences)writer.uint64(v);
        writer.ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $8ac3b8b757f7662f$var$_m0.Reader ? input : new $8ac3b8b757f7662f$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $8ac3b8b757f7662f$var$createBaseQueryUnreceivedPacketsRequest();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.portId = reader.string();
                    break;
                case 2:
                    message.channelId = reader.string();
                    break;
                case 3:
                    if ((tag & 7) === 2) {
                        const end2 = reader.uint32() + reader.pos;
                        while(reader.pos < end2)message.packetCommitmentSequences.push(reader.uint64());
                    } else message.packetCommitmentSequences.push(reader.uint64());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            portId: (0, $d5e07fe2518aae94$exports.isSet)(object.portId) ? String(object.portId) : "",
            channelId: (0, $d5e07fe2518aae94$exports.isSet)(object.channelId) ? String(object.channelId) : "",
            packetCommitmentSequences: Array.isArray(object?.packetCommitmentSequences) ? object.packetCommitmentSequences.map((e)=>$d5e07fe2518aae94$exports.Long.fromValue(e)) : []
        };
    },
    toJSON (message) {
        const obj = {};
        message.portId !== undefined && (obj.portId = message.portId);
        message.channelId !== undefined && (obj.channelId = message.channelId);
        if (message.packetCommitmentSequences) obj.packetCommitmentSequences = message.packetCommitmentSequences.map((e)=>(e || $d5e07fe2518aae94$exports.Long.UZERO).toString());
        else obj.packetCommitmentSequences = [];
        return obj;
    },
    fromPartial (object) {
        const message = $8ac3b8b757f7662f$var$createBaseQueryUnreceivedPacketsRequest();
        message.portId = object.portId ?? "";
        message.channelId = object.channelId ?? "";
        message.packetCommitmentSequences = object.packetCommitmentSequences?.map((e)=>$d5e07fe2518aae94$exports.Long.fromValue(e)) || [];
        return message;
    }
};
function $8ac3b8b757f7662f$var$createBaseQueryUnreceivedPacketsResponse() {
    return {
        sequences: [],
        height: undefined
    };
}
$8ac3b8b757f7662f$exports.QueryUnreceivedPacketsResponse = {
    encode (message, writer = $8ac3b8b757f7662f$var$_m0.Writer.create()) {
        writer.uint32(10).fork();
        for (const v of message.sequences)writer.uint64(v);
        writer.ldelim();
        if (message.height !== undefined) $7d28e43a1e22112f$exports.Height.encode(message.height, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $8ac3b8b757f7662f$var$_m0.Reader ? input : new $8ac3b8b757f7662f$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $8ac3b8b757f7662f$var$createBaseQueryUnreceivedPacketsResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    if ((tag & 7) === 2) {
                        const end2 = reader.uint32() + reader.pos;
                        while(reader.pos < end2)message.sequences.push(reader.uint64());
                    } else message.sequences.push(reader.uint64());
                    break;
                case 2:
                    message.height = $7d28e43a1e22112f$exports.Height.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            sequences: Array.isArray(object?.sequences) ? object.sequences.map((e)=>$d5e07fe2518aae94$exports.Long.fromValue(e)) : [],
            height: (0, $d5e07fe2518aae94$exports.isSet)(object.height) ? $7d28e43a1e22112f$exports.Height.fromJSON(object.height) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        if (message.sequences) obj.sequences = message.sequences.map((e)=>(e || $d5e07fe2518aae94$exports.Long.UZERO).toString());
        else obj.sequences = [];
        message.height !== undefined && (obj.height = message.height ? $7d28e43a1e22112f$exports.Height.toJSON(message.height) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $8ac3b8b757f7662f$var$createBaseQueryUnreceivedPacketsResponse();
        message.sequences = object.sequences?.map((e)=>$d5e07fe2518aae94$exports.Long.fromValue(e)) || [];
        message.height = object.height !== undefined && object.height !== null ? $7d28e43a1e22112f$exports.Height.fromPartial(object.height) : undefined;
        return message;
    }
};
function $8ac3b8b757f7662f$var$createBaseQueryUnreceivedAcksRequest() {
    return {
        portId: "",
        channelId: "",
        packetAckSequences: []
    };
}
$8ac3b8b757f7662f$exports.QueryUnreceivedAcksRequest = {
    encode (message, writer = $8ac3b8b757f7662f$var$_m0.Writer.create()) {
        if (message.portId !== "") writer.uint32(10).string(message.portId);
        if (message.channelId !== "") writer.uint32(18).string(message.channelId);
        writer.uint32(26).fork();
        for (const v of message.packetAckSequences)writer.uint64(v);
        writer.ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $8ac3b8b757f7662f$var$_m0.Reader ? input : new $8ac3b8b757f7662f$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $8ac3b8b757f7662f$var$createBaseQueryUnreceivedAcksRequest();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.portId = reader.string();
                    break;
                case 2:
                    message.channelId = reader.string();
                    break;
                case 3:
                    if ((tag & 7) === 2) {
                        const end2 = reader.uint32() + reader.pos;
                        while(reader.pos < end2)message.packetAckSequences.push(reader.uint64());
                    } else message.packetAckSequences.push(reader.uint64());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            portId: (0, $d5e07fe2518aae94$exports.isSet)(object.portId) ? String(object.portId) : "",
            channelId: (0, $d5e07fe2518aae94$exports.isSet)(object.channelId) ? String(object.channelId) : "",
            packetAckSequences: Array.isArray(object?.packetAckSequences) ? object.packetAckSequences.map((e)=>$d5e07fe2518aae94$exports.Long.fromValue(e)) : []
        };
    },
    toJSON (message) {
        const obj = {};
        message.portId !== undefined && (obj.portId = message.portId);
        message.channelId !== undefined && (obj.channelId = message.channelId);
        if (message.packetAckSequences) obj.packetAckSequences = message.packetAckSequences.map((e)=>(e || $d5e07fe2518aae94$exports.Long.UZERO).toString());
        else obj.packetAckSequences = [];
        return obj;
    },
    fromPartial (object) {
        const message = $8ac3b8b757f7662f$var$createBaseQueryUnreceivedAcksRequest();
        message.portId = object.portId ?? "";
        message.channelId = object.channelId ?? "";
        message.packetAckSequences = object.packetAckSequences?.map((e)=>$d5e07fe2518aae94$exports.Long.fromValue(e)) || [];
        return message;
    }
};
function $8ac3b8b757f7662f$var$createBaseQueryUnreceivedAcksResponse() {
    return {
        sequences: [],
        height: undefined
    };
}
$8ac3b8b757f7662f$exports.QueryUnreceivedAcksResponse = {
    encode (message, writer = $8ac3b8b757f7662f$var$_m0.Writer.create()) {
        writer.uint32(10).fork();
        for (const v of message.sequences)writer.uint64(v);
        writer.ldelim();
        if (message.height !== undefined) $7d28e43a1e22112f$exports.Height.encode(message.height, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $8ac3b8b757f7662f$var$_m0.Reader ? input : new $8ac3b8b757f7662f$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $8ac3b8b757f7662f$var$createBaseQueryUnreceivedAcksResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    if ((tag & 7) === 2) {
                        const end2 = reader.uint32() + reader.pos;
                        while(reader.pos < end2)message.sequences.push(reader.uint64());
                    } else message.sequences.push(reader.uint64());
                    break;
                case 2:
                    message.height = $7d28e43a1e22112f$exports.Height.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            sequences: Array.isArray(object?.sequences) ? object.sequences.map((e)=>$d5e07fe2518aae94$exports.Long.fromValue(e)) : [],
            height: (0, $d5e07fe2518aae94$exports.isSet)(object.height) ? $7d28e43a1e22112f$exports.Height.fromJSON(object.height) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        if (message.sequences) obj.sequences = message.sequences.map((e)=>(e || $d5e07fe2518aae94$exports.Long.UZERO).toString());
        else obj.sequences = [];
        message.height !== undefined && (obj.height = message.height ? $7d28e43a1e22112f$exports.Height.toJSON(message.height) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $8ac3b8b757f7662f$var$createBaseQueryUnreceivedAcksResponse();
        message.sequences = object.sequences?.map((e)=>$d5e07fe2518aae94$exports.Long.fromValue(e)) || [];
        message.height = object.height !== undefined && object.height !== null ? $7d28e43a1e22112f$exports.Height.fromPartial(object.height) : undefined;
        return message;
    }
};
function $8ac3b8b757f7662f$var$createBaseQueryNextSequenceReceiveRequest() {
    return {
        portId: "",
        channelId: ""
    };
}
$8ac3b8b757f7662f$exports.QueryNextSequenceReceiveRequest = {
    encode (message, writer = $8ac3b8b757f7662f$var$_m0.Writer.create()) {
        if (message.portId !== "") writer.uint32(10).string(message.portId);
        if (message.channelId !== "") writer.uint32(18).string(message.channelId);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $8ac3b8b757f7662f$var$_m0.Reader ? input : new $8ac3b8b757f7662f$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $8ac3b8b757f7662f$var$createBaseQueryNextSequenceReceiveRequest();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.portId = reader.string();
                    break;
                case 2:
                    message.channelId = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            portId: (0, $d5e07fe2518aae94$exports.isSet)(object.portId) ? String(object.portId) : "",
            channelId: (0, $d5e07fe2518aae94$exports.isSet)(object.channelId) ? String(object.channelId) : ""
        };
    },
    toJSON (message) {
        const obj = {};
        message.portId !== undefined && (obj.portId = message.portId);
        message.channelId !== undefined && (obj.channelId = message.channelId);
        return obj;
    },
    fromPartial (object) {
        const message = $8ac3b8b757f7662f$var$createBaseQueryNextSequenceReceiveRequest();
        message.portId = object.portId ?? "";
        message.channelId = object.channelId ?? "";
        return message;
    }
};
function $8ac3b8b757f7662f$var$createBaseQueryNextSequenceReceiveResponse() {
    return {
        nextSequenceReceive: $d5e07fe2518aae94$exports.Long.UZERO,
        proof: new Uint8Array(),
        proofHeight: undefined
    };
}
$8ac3b8b757f7662f$exports.QueryNextSequenceReceiveResponse = {
    encode (message, writer = $8ac3b8b757f7662f$var$_m0.Writer.create()) {
        if (!message.nextSequenceReceive.isZero()) writer.uint32(8).uint64(message.nextSequenceReceive);
        if (message.proof.length !== 0) writer.uint32(18).bytes(message.proof);
        if (message.proofHeight !== undefined) $7d28e43a1e22112f$exports.Height.encode(message.proofHeight, writer.uint32(26).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $8ac3b8b757f7662f$var$_m0.Reader ? input : new $8ac3b8b757f7662f$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $8ac3b8b757f7662f$var$createBaseQueryNextSequenceReceiveResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.nextSequenceReceive = reader.uint64();
                    break;
                case 2:
                    message.proof = reader.bytes();
                    break;
                case 3:
                    message.proofHeight = $7d28e43a1e22112f$exports.Height.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            nextSequenceReceive: (0, $d5e07fe2518aae94$exports.isSet)(object.nextSequenceReceive) ? $d5e07fe2518aae94$exports.Long.fromValue(object.nextSequenceReceive) : $d5e07fe2518aae94$exports.Long.UZERO,
            proof: (0, $d5e07fe2518aae94$exports.isSet)(object.proof) ? (0, $d5e07fe2518aae94$exports.bytesFromBase64)(object.proof) : new Uint8Array(),
            proofHeight: (0, $d5e07fe2518aae94$exports.isSet)(object.proofHeight) ? $7d28e43a1e22112f$exports.Height.fromJSON(object.proofHeight) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.nextSequenceReceive !== undefined && (obj.nextSequenceReceive = (message.nextSequenceReceive || $d5e07fe2518aae94$exports.Long.UZERO).toString());
        message.proof !== undefined && (obj.proof = (0, $d5e07fe2518aae94$exports.base64FromBytes)(message.proof !== undefined ? message.proof : new Uint8Array()));
        message.proofHeight !== undefined && (obj.proofHeight = message.proofHeight ? $7d28e43a1e22112f$exports.Height.toJSON(message.proofHeight) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $8ac3b8b757f7662f$var$createBaseQueryNextSequenceReceiveResponse();
        message.nextSequenceReceive = object.nextSequenceReceive !== undefined && object.nextSequenceReceive !== null ? $d5e07fe2518aae94$exports.Long.fromValue(object.nextSequenceReceive) : $d5e07fe2518aae94$exports.Long.UZERO;
        message.proof = object.proof ?? new Uint8Array();
        message.proofHeight = object.proofHeight !== undefined && object.proofHeight !== null ? $7d28e43a1e22112f$exports.Height.fromPartial(object.proofHeight) : undefined;
        return message;
    }
};
class $8ac3b8b757f7662f$var$QueryClientImpl {
    constructor(rpc){
        this.rpc = rpc;
        this.Channel = this.Channel.bind(this);
        this.Channels = this.Channels.bind(this);
        this.ConnectionChannels = this.ConnectionChannels.bind(this);
        this.ChannelClientState = this.ChannelClientState.bind(this);
        this.ChannelConsensusState = this.ChannelConsensusState.bind(this);
        this.PacketCommitment = this.PacketCommitment.bind(this);
        this.PacketCommitments = this.PacketCommitments.bind(this);
        this.PacketReceipt = this.PacketReceipt.bind(this);
        this.PacketAcknowledgement = this.PacketAcknowledgement.bind(this);
        this.PacketAcknowledgements = this.PacketAcknowledgements.bind(this);
        this.UnreceivedPackets = this.UnreceivedPackets.bind(this);
        this.UnreceivedAcks = this.UnreceivedAcks.bind(this);
        this.NextSequenceReceive = this.NextSequenceReceive.bind(this);
    }
    Channel(request) {
        const data = $8ac3b8b757f7662f$exports.QueryChannelRequest.encode(request).finish();
        const promise = this.rpc.request("ibc.core.channel.v1.Query", "Channel", data);
        return promise.then((data)=>$8ac3b8b757f7662f$exports.QueryChannelResponse.decode(new $8ac3b8b757f7662f$var$_m0.Reader(data)));
    }
    Channels(request = {
        pagination: undefined
    }) {
        const data = $8ac3b8b757f7662f$exports.QueryChannelsRequest.encode(request).finish();
        const promise = this.rpc.request("ibc.core.channel.v1.Query", "Channels", data);
        return promise.then((data)=>$8ac3b8b757f7662f$exports.QueryChannelsResponse.decode(new $8ac3b8b757f7662f$var$_m0.Reader(data)));
    }
    ConnectionChannels(request) {
        const data = $8ac3b8b757f7662f$exports.QueryConnectionChannelsRequest.encode(request).finish();
        const promise = this.rpc.request("ibc.core.channel.v1.Query", "ConnectionChannels", data);
        return promise.then((data)=>$8ac3b8b757f7662f$exports.QueryConnectionChannelsResponse.decode(new $8ac3b8b757f7662f$var$_m0.Reader(data)));
    }
    ChannelClientState(request) {
        const data = $8ac3b8b757f7662f$exports.QueryChannelClientStateRequest.encode(request).finish();
        const promise = this.rpc.request("ibc.core.channel.v1.Query", "ChannelClientState", data);
        return promise.then((data)=>$8ac3b8b757f7662f$exports.QueryChannelClientStateResponse.decode(new $8ac3b8b757f7662f$var$_m0.Reader(data)));
    }
    ChannelConsensusState(request) {
        const data = $8ac3b8b757f7662f$exports.QueryChannelConsensusStateRequest.encode(request).finish();
        const promise = this.rpc.request("ibc.core.channel.v1.Query", "ChannelConsensusState", data);
        return promise.then((data)=>$8ac3b8b757f7662f$exports.QueryChannelConsensusStateResponse.decode(new $8ac3b8b757f7662f$var$_m0.Reader(data)));
    }
    PacketCommitment(request) {
        const data = $8ac3b8b757f7662f$exports.QueryPacketCommitmentRequest.encode(request).finish();
        const promise = this.rpc.request("ibc.core.channel.v1.Query", "PacketCommitment", data);
        return promise.then((data)=>$8ac3b8b757f7662f$exports.QueryPacketCommitmentResponse.decode(new $8ac3b8b757f7662f$var$_m0.Reader(data)));
    }
    PacketCommitments(request) {
        const data = $8ac3b8b757f7662f$exports.QueryPacketCommitmentsRequest.encode(request).finish();
        const promise = this.rpc.request("ibc.core.channel.v1.Query", "PacketCommitments", data);
        return promise.then((data)=>$8ac3b8b757f7662f$exports.QueryPacketCommitmentsResponse.decode(new $8ac3b8b757f7662f$var$_m0.Reader(data)));
    }
    PacketReceipt(request) {
        const data = $8ac3b8b757f7662f$exports.QueryPacketReceiptRequest.encode(request).finish();
        const promise = this.rpc.request("ibc.core.channel.v1.Query", "PacketReceipt", data);
        return promise.then((data)=>$8ac3b8b757f7662f$exports.QueryPacketReceiptResponse.decode(new $8ac3b8b757f7662f$var$_m0.Reader(data)));
    }
    PacketAcknowledgement(request) {
        const data = $8ac3b8b757f7662f$exports.QueryPacketAcknowledgementRequest.encode(request).finish();
        const promise = this.rpc.request("ibc.core.channel.v1.Query", "PacketAcknowledgement", data);
        return promise.then((data)=>$8ac3b8b757f7662f$exports.QueryPacketAcknowledgementResponse.decode(new $8ac3b8b757f7662f$var$_m0.Reader(data)));
    }
    PacketAcknowledgements(request) {
        const data = $8ac3b8b757f7662f$exports.QueryPacketAcknowledgementsRequest.encode(request).finish();
        const promise = this.rpc.request("ibc.core.channel.v1.Query", "PacketAcknowledgements", data);
        return promise.then((data)=>$8ac3b8b757f7662f$exports.QueryPacketAcknowledgementsResponse.decode(new $8ac3b8b757f7662f$var$_m0.Reader(data)));
    }
    UnreceivedPackets(request) {
        const data = $8ac3b8b757f7662f$exports.QueryUnreceivedPacketsRequest.encode(request).finish();
        const promise = this.rpc.request("ibc.core.channel.v1.Query", "UnreceivedPackets", data);
        return promise.then((data)=>$8ac3b8b757f7662f$exports.QueryUnreceivedPacketsResponse.decode(new $8ac3b8b757f7662f$var$_m0.Reader(data)));
    }
    UnreceivedAcks(request) {
        const data = $8ac3b8b757f7662f$exports.QueryUnreceivedAcksRequest.encode(request).finish();
        const promise = this.rpc.request("ibc.core.channel.v1.Query", "UnreceivedAcks", data);
        return promise.then((data)=>$8ac3b8b757f7662f$exports.QueryUnreceivedAcksResponse.decode(new $8ac3b8b757f7662f$var$_m0.Reader(data)));
    }
    NextSequenceReceive(request) {
        const data = $8ac3b8b757f7662f$exports.QueryNextSequenceReceiveRequest.encode(request).finish();
        const promise = this.rpc.request("ibc.core.channel.v1.Query", "NextSequenceReceive", data);
        return promise.then((data)=>$8ac3b8b757f7662f$exports.QueryNextSequenceReceiveResponse.decode(new $8ac3b8b757f7662f$var$_m0.Reader(data)));
    }
}
$8ac3b8b757f7662f$exports.QueryClientImpl = $8ac3b8b757f7662f$var$QueryClientImpl;


var $368c5d14b6acc6e3$exports = {};
"use strict";
var $368c5d14b6acc6e3$var$__createBinding = $368c5d14b6acc6e3$exports && $368c5d14b6acc6e3$exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $368c5d14b6acc6e3$var$__setModuleDefault = $368c5d14b6acc6e3$exports && $368c5d14b6acc6e3$exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $368c5d14b6acc6e3$var$__importStar = $368c5d14b6acc6e3$exports && $368c5d14b6acc6e3$exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $368c5d14b6acc6e3$var$__createBinding(result, mod, k);
    }
    $368c5d14b6acc6e3$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty($368c5d14b6acc6e3$exports, "__esModule", {
    value: true
});
$368c5d14b6acc6e3$exports.QueryClientImpl = $368c5d14b6acc6e3$exports.QueryUpgradedConsensusStateResponse = $368c5d14b6acc6e3$exports.QueryUpgradedConsensusStateRequest = $368c5d14b6acc6e3$exports.QueryUpgradedClientStateResponse = $368c5d14b6acc6e3$exports.QueryUpgradedClientStateRequest = $368c5d14b6acc6e3$exports.QueryClientParamsResponse = $368c5d14b6acc6e3$exports.QueryClientParamsRequest = $368c5d14b6acc6e3$exports.QueryClientStatusResponse = $368c5d14b6acc6e3$exports.QueryClientStatusRequest = $368c5d14b6acc6e3$exports.QueryConsensusStateHeightsResponse = $368c5d14b6acc6e3$exports.QueryConsensusStateHeightsRequest = $368c5d14b6acc6e3$exports.QueryConsensusStatesResponse = $368c5d14b6acc6e3$exports.QueryConsensusStatesRequest = $368c5d14b6acc6e3$exports.QueryConsensusStateResponse = $368c5d14b6acc6e3$exports.QueryConsensusStateRequest = $368c5d14b6acc6e3$exports.QueryClientStatesResponse = $368c5d14b6acc6e3$exports.QueryClientStatesRequest = $368c5d14b6acc6e3$exports.QueryClientStateResponse = $368c5d14b6acc6e3$exports.QueryClientStateRequest = $368c5d14b6acc6e3$exports.protobufPackage = void 0;





const $368c5d14b6acc6e3$var$_m0 = $368c5d14b6acc6e3$var$__importStar((parcelRequire("fQBv0")));
$368c5d14b6acc6e3$exports.protobufPackage = "ibc.core.client.v1";
function $368c5d14b6acc6e3$var$createBaseQueryClientStateRequest() {
    return {
        clientId: ""
    };
}
$368c5d14b6acc6e3$exports.QueryClientStateRequest = {
    encode (message, writer = $368c5d14b6acc6e3$var$_m0.Writer.create()) {
        if (message.clientId !== "") writer.uint32(10).string(message.clientId);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $368c5d14b6acc6e3$var$_m0.Reader ? input : new $368c5d14b6acc6e3$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $368c5d14b6acc6e3$var$createBaseQueryClientStateRequest();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.clientId = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            clientId: (0, $d5e07fe2518aae94$exports.isSet)(object.clientId) ? String(object.clientId) : ""
        };
    },
    toJSON (message) {
        const obj = {};
        message.clientId !== undefined && (obj.clientId = message.clientId);
        return obj;
    },
    fromPartial (object) {
        const message = $368c5d14b6acc6e3$var$createBaseQueryClientStateRequest();
        message.clientId = object.clientId ?? "";
        return message;
    }
};
function $368c5d14b6acc6e3$var$createBaseQueryClientStateResponse() {
    return {
        clientState: undefined,
        proof: new Uint8Array(),
        proofHeight: undefined
    };
}
$368c5d14b6acc6e3$exports.QueryClientStateResponse = {
    encode (message, writer = $368c5d14b6acc6e3$var$_m0.Writer.create()) {
        if (message.clientState !== undefined) $64138e590dcf0cc1$exports.Any.encode(message.clientState, writer.uint32(10).fork()).ldelim();
        if (message.proof.length !== 0) writer.uint32(18).bytes(message.proof);
        if (message.proofHeight !== undefined) $7d28e43a1e22112f$exports.Height.encode(message.proofHeight, writer.uint32(26).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $368c5d14b6acc6e3$var$_m0.Reader ? input : new $368c5d14b6acc6e3$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $368c5d14b6acc6e3$var$createBaseQueryClientStateResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.clientState = $64138e590dcf0cc1$exports.Any.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.proof = reader.bytes();
                    break;
                case 3:
                    message.proofHeight = $7d28e43a1e22112f$exports.Height.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            clientState: (0, $d5e07fe2518aae94$exports.isSet)(object.clientState) ? $64138e590dcf0cc1$exports.Any.fromJSON(object.clientState) : undefined,
            proof: (0, $d5e07fe2518aae94$exports.isSet)(object.proof) ? (0, $d5e07fe2518aae94$exports.bytesFromBase64)(object.proof) : new Uint8Array(),
            proofHeight: (0, $d5e07fe2518aae94$exports.isSet)(object.proofHeight) ? $7d28e43a1e22112f$exports.Height.fromJSON(object.proofHeight) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.clientState !== undefined && (obj.clientState = message.clientState ? $64138e590dcf0cc1$exports.Any.toJSON(message.clientState) : undefined);
        message.proof !== undefined && (obj.proof = (0, $d5e07fe2518aae94$exports.base64FromBytes)(message.proof !== undefined ? message.proof : new Uint8Array()));
        message.proofHeight !== undefined && (obj.proofHeight = message.proofHeight ? $7d28e43a1e22112f$exports.Height.toJSON(message.proofHeight) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $368c5d14b6acc6e3$var$createBaseQueryClientStateResponse();
        message.clientState = object.clientState !== undefined && object.clientState !== null ? $64138e590dcf0cc1$exports.Any.fromPartial(object.clientState) : undefined;
        message.proof = object.proof ?? new Uint8Array();
        message.proofHeight = object.proofHeight !== undefined && object.proofHeight !== null ? $7d28e43a1e22112f$exports.Height.fromPartial(object.proofHeight) : undefined;
        return message;
    }
};
function $368c5d14b6acc6e3$var$createBaseQueryClientStatesRequest() {
    return {
        pagination: undefined
    };
}
$368c5d14b6acc6e3$exports.QueryClientStatesRequest = {
    encode (message, writer = $368c5d14b6acc6e3$var$_m0.Writer.create()) {
        if (message.pagination !== undefined) $5eae5f3cc99e92ab$exports.PageRequest.encode(message.pagination, writer.uint32(10).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $368c5d14b6acc6e3$var$_m0.Reader ? input : new $368c5d14b6acc6e3$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $368c5d14b6acc6e3$var$createBaseQueryClientStatesRequest();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.pagination = $5eae5f3cc99e92ab$exports.PageRequest.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            pagination: (0, $d5e07fe2518aae94$exports.isSet)(object.pagination) ? $5eae5f3cc99e92ab$exports.PageRequest.fromJSON(object.pagination) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.pagination !== undefined && (obj.pagination = message.pagination ? $5eae5f3cc99e92ab$exports.PageRequest.toJSON(message.pagination) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $368c5d14b6acc6e3$var$createBaseQueryClientStatesRequest();
        message.pagination = object.pagination !== undefined && object.pagination !== null ? $5eae5f3cc99e92ab$exports.PageRequest.fromPartial(object.pagination) : undefined;
        return message;
    }
};
function $368c5d14b6acc6e3$var$createBaseQueryClientStatesResponse() {
    return {
        clientStates: [],
        pagination: undefined
    };
}
$368c5d14b6acc6e3$exports.QueryClientStatesResponse = {
    encode (message, writer = $368c5d14b6acc6e3$var$_m0.Writer.create()) {
        for (const v of message.clientStates)$7d28e43a1e22112f$exports.IdentifiedClientState.encode(v, writer.uint32(10).fork()).ldelim();
        if (message.pagination !== undefined) $5eae5f3cc99e92ab$exports.PageResponse.encode(message.pagination, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $368c5d14b6acc6e3$var$_m0.Reader ? input : new $368c5d14b6acc6e3$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $368c5d14b6acc6e3$var$createBaseQueryClientStatesResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.clientStates.push($7d28e43a1e22112f$exports.IdentifiedClientState.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.pagination = $5eae5f3cc99e92ab$exports.PageResponse.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            clientStates: Array.isArray(object?.clientStates) ? object.clientStates.map((e)=>$7d28e43a1e22112f$exports.IdentifiedClientState.fromJSON(e)) : [],
            pagination: (0, $d5e07fe2518aae94$exports.isSet)(object.pagination) ? $5eae5f3cc99e92ab$exports.PageResponse.fromJSON(object.pagination) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        if (message.clientStates) obj.clientStates = message.clientStates.map((e)=>e ? $7d28e43a1e22112f$exports.IdentifiedClientState.toJSON(e) : undefined);
        else obj.clientStates = [];
        message.pagination !== undefined && (obj.pagination = message.pagination ? $5eae5f3cc99e92ab$exports.PageResponse.toJSON(message.pagination) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $368c5d14b6acc6e3$var$createBaseQueryClientStatesResponse();
        message.clientStates = object.clientStates?.map((e)=>$7d28e43a1e22112f$exports.IdentifiedClientState.fromPartial(e)) || [];
        message.pagination = object.pagination !== undefined && object.pagination !== null ? $5eae5f3cc99e92ab$exports.PageResponse.fromPartial(object.pagination) : undefined;
        return message;
    }
};
function $368c5d14b6acc6e3$var$createBaseQueryConsensusStateRequest() {
    return {
        clientId: "",
        revisionNumber: $d5e07fe2518aae94$exports.Long.UZERO,
        revisionHeight: $d5e07fe2518aae94$exports.Long.UZERO,
        latestHeight: false
    };
}
$368c5d14b6acc6e3$exports.QueryConsensusStateRequest = {
    encode (message, writer = $368c5d14b6acc6e3$var$_m0.Writer.create()) {
        if (message.clientId !== "") writer.uint32(10).string(message.clientId);
        if (!message.revisionNumber.isZero()) writer.uint32(16).uint64(message.revisionNumber);
        if (!message.revisionHeight.isZero()) writer.uint32(24).uint64(message.revisionHeight);
        if (message.latestHeight === true) writer.uint32(32).bool(message.latestHeight);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $368c5d14b6acc6e3$var$_m0.Reader ? input : new $368c5d14b6acc6e3$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $368c5d14b6acc6e3$var$createBaseQueryConsensusStateRequest();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.clientId = reader.string();
                    break;
                case 2:
                    message.revisionNumber = reader.uint64();
                    break;
                case 3:
                    message.revisionHeight = reader.uint64();
                    break;
                case 4:
                    message.latestHeight = reader.bool();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            clientId: (0, $d5e07fe2518aae94$exports.isSet)(object.clientId) ? String(object.clientId) : "",
            revisionNumber: (0, $d5e07fe2518aae94$exports.isSet)(object.revisionNumber) ? $d5e07fe2518aae94$exports.Long.fromValue(object.revisionNumber) : $d5e07fe2518aae94$exports.Long.UZERO,
            revisionHeight: (0, $d5e07fe2518aae94$exports.isSet)(object.revisionHeight) ? $d5e07fe2518aae94$exports.Long.fromValue(object.revisionHeight) : $d5e07fe2518aae94$exports.Long.UZERO,
            latestHeight: (0, $d5e07fe2518aae94$exports.isSet)(object.latestHeight) ? Boolean(object.latestHeight) : false
        };
    },
    toJSON (message) {
        const obj = {};
        message.clientId !== undefined && (obj.clientId = message.clientId);
        message.revisionNumber !== undefined && (obj.revisionNumber = (message.revisionNumber || $d5e07fe2518aae94$exports.Long.UZERO).toString());
        message.revisionHeight !== undefined && (obj.revisionHeight = (message.revisionHeight || $d5e07fe2518aae94$exports.Long.UZERO).toString());
        message.latestHeight !== undefined && (obj.latestHeight = message.latestHeight);
        return obj;
    },
    fromPartial (object) {
        const message = $368c5d14b6acc6e3$var$createBaseQueryConsensusStateRequest();
        message.clientId = object.clientId ?? "";
        message.revisionNumber = object.revisionNumber !== undefined && object.revisionNumber !== null ? $d5e07fe2518aae94$exports.Long.fromValue(object.revisionNumber) : $d5e07fe2518aae94$exports.Long.UZERO;
        message.revisionHeight = object.revisionHeight !== undefined && object.revisionHeight !== null ? $d5e07fe2518aae94$exports.Long.fromValue(object.revisionHeight) : $d5e07fe2518aae94$exports.Long.UZERO;
        message.latestHeight = object.latestHeight ?? false;
        return message;
    }
};
function $368c5d14b6acc6e3$var$createBaseQueryConsensusStateResponse() {
    return {
        consensusState: undefined,
        proof: new Uint8Array(),
        proofHeight: undefined
    };
}
$368c5d14b6acc6e3$exports.QueryConsensusStateResponse = {
    encode (message, writer = $368c5d14b6acc6e3$var$_m0.Writer.create()) {
        if (message.consensusState !== undefined) $64138e590dcf0cc1$exports.Any.encode(message.consensusState, writer.uint32(10).fork()).ldelim();
        if (message.proof.length !== 0) writer.uint32(18).bytes(message.proof);
        if (message.proofHeight !== undefined) $7d28e43a1e22112f$exports.Height.encode(message.proofHeight, writer.uint32(26).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $368c5d14b6acc6e3$var$_m0.Reader ? input : new $368c5d14b6acc6e3$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $368c5d14b6acc6e3$var$createBaseQueryConsensusStateResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.consensusState = $64138e590dcf0cc1$exports.Any.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.proof = reader.bytes();
                    break;
                case 3:
                    message.proofHeight = $7d28e43a1e22112f$exports.Height.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            consensusState: (0, $d5e07fe2518aae94$exports.isSet)(object.consensusState) ? $64138e590dcf0cc1$exports.Any.fromJSON(object.consensusState) : undefined,
            proof: (0, $d5e07fe2518aae94$exports.isSet)(object.proof) ? (0, $d5e07fe2518aae94$exports.bytesFromBase64)(object.proof) : new Uint8Array(),
            proofHeight: (0, $d5e07fe2518aae94$exports.isSet)(object.proofHeight) ? $7d28e43a1e22112f$exports.Height.fromJSON(object.proofHeight) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.consensusState !== undefined && (obj.consensusState = message.consensusState ? $64138e590dcf0cc1$exports.Any.toJSON(message.consensusState) : undefined);
        message.proof !== undefined && (obj.proof = (0, $d5e07fe2518aae94$exports.base64FromBytes)(message.proof !== undefined ? message.proof : new Uint8Array()));
        message.proofHeight !== undefined && (obj.proofHeight = message.proofHeight ? $7d28e43a1e22112f$exports.Height.toJSON(message.proofHeight) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $368c5d14b6acc6e3$var$createBaseQueryConsensusStateResponse();
        message.consensusState = object.consensusState !== undefined && object.consensusState !== null ? $64138e590dcf0cc1$exports.Any.fromPartial(object.consensusState) : undefined;
        message.proof = object.proof ?? new Uint8Array();
        message.proofHeight = object.proofHeight !== undefined && object.proofHeight !== null ? $7d28e43a1e22112f$exports.Height.fromPartial(object.proofHeight) : undefined;
        return message;
    }
};
function $368c5d14b6acc6e3$var$createBaseQueryConsensusStatesRequest() {
    return {
        clientId: "",
        pagination: undefined
    };
}
$368c5d14b6acc6e3$exports.QueryConsensusStatesRequest = {
    encode (message, writer = $368c5d14b6acc6e3$var$_m0.Writer.create()) {
        if (message.clientId !== "") writer.uint32(10).string(message.clientId);
        if (message.pagination !== undefined) $5eae5f3cc99e92ab$exports.PageRequest.encode(message.pagination, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $368c5d14b6acc6e3$var$_m0.Reader ? input : new $368c5d14b6acc6e3$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $368c5d14b6acc6e3$var$createBaseQueryConsensusStatesRequest();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.clientId = reader.string();
                    break;
                case 2:
                    message.pagination = $5eae5f3cc99e92ab$exports.PageRequest.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            clientId: (0, $d5e07fe2518aae94$exports.isSet)(object.clientId) ? String(object.clientId) : "",
            pagination: (0, $d5e07fe2518aae94$exports.isSet)(object.pagination) ? $5eae5f3cc99e92ab$exports.PageRequest.fromJSON(object.pagination) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.clientId !== undefined && (obj.clientId = message.clientId);
        message.pagination !== undefined && (obj.pagination = message.pagination ? $5eae5f3cc99e92ab$exports.PageRequest.toJSON(message.pagination) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $368c5d14b6acc6e3$var$createBaseQueryConsensusStatesRequest();
        message.clientId = object.clientId ?? "";
        message.pagination = object.pagination !== undefined && object.pagination !== null ? $5eae5f3cc99e92ab$exports.PageRequest.fromPartial(object.pagination) : undefined;
        return message;
    }
};
function $368c5d14b6acc6e3$var$createBaseQueryConsensusStatesResponse() {
    return {
        consensusStates: [],
        pagination: undefined
    };
}
$368c5d14b6acc6e3$exports.QueryConsensusStatesResponse = {
    encode (message, writer = $368c5d14b6acc6e3$var$_m0.Writer.create()) {
        for (const v of message.consensusStates)$7d28e43a1e22112f$exports.ConsensusStateWithHeight.encode(v, writer.uint32(10).fork()).ldelim();
        if (message.pagination !== undefined) $5eae5f3cc99e92ab$exports.PageResponse.encode(message.pagination, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $368c5d14b6acc6e3$var$_m0.Reader ? input : new $368c5d14b6acc6e3$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $368c5d14b6acc6e3$var$createBaseQueryConsensusStatesResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.consensusStates.push($7d28e43a1e22112f$exports.ConsensusStateWithHeight.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.pagination = $5eae5f3cc99e92ab$exports.PageResponse.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            consensusStates: Array.isArray(object?.consensusStates) ? object.consensusStates.map((e)=>$7d28e43a1e22112f$exports.ConsensusStateWithHeight.fromJSON(e)) : [],
            pagination: (0, $d5e07fe2518aae94$exports.isSet)(object.pagination) ? $5eae5f3cc99e92ab$exports.PageResponse.fromJSON(object.pagination) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        if (message.consensusStates) obj.consensusStates = message.consensusStates.map((e)=>e ? $7d28e43a1e22112f$exports.ConsensusStateWithHeight.toJSON(e) : undefined);
        else obj.consensusStates = [];
        message.pagination !== undefined && (obj.pagination = message.pagination ? $5eae5f3cc99e92ab$exports.PageResponse.toJSON(message.pagination) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $368c5d14b6acc6e3$var$createBaseQueryConsensusStatesResponse();
        message.consensusStates = object.consensusStates?.map((e)=>$7d28e43a1e22112f$exports.ConsensusStateWithHeight.fromPartial(e)) || [];
        message.pagination = object.pagination !== undefined && object.pagination !== null ? $5eae5f3cc99e92ab$exports.PageResponse.fromPartial(object.pagination) : undefined;
        return message;
    }
};
function $368c5d14b6acc6e3$var$createBaseQueryConsensusStateHeightsRequest() {
    return {
        clientId: "",
        pagination: undefined
    };
}
$368c5d14b6acc6e3$exports.QueryConsensusStateHeightsRequest = {
    encode (message, writer = $368c5d14b6acc6e3$var$_m0.Writer.create()) {
        if (message.clientId !== "") writer.uint32(10).string(message.clientId);
        if (message.pagination !== undefined) $5eae5f3cc99e92ab$exports.PageRequest.encode(message.pagination, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $368c5d14b6acc6e3$var$_m0.Reader ? input : new $368c5d14b6acc6e3$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $368c5d14b6acc6e3$var$createBaseQueryConsensusStateHeightsRequest();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.clientId = reader.string();
                    break;
                case 2:
                    message.pagination = $5eae5f3cc99e92ab$exports.PageRequest.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            clientId: (0, $d5e07fe2518aae94$exports.isSet)(object.clientId) ? String(object.clientId) : "",
            pagination: (0, $d5e07fe2518aae94$exports.isSet)(object.pagination) ? $5eae5f3cc99e92ab$exports.PageRequest.fromJSON(object.pagination) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.clientId !== undefined && (obj.clientId = message.clientId);
        message.pagination !== undefined && (obj.pagination = message.pagination ? $5eae5f3cc99e92ab$exports.PageRequest.toJSON(message.pagination) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $368c5d14b6acc6e3$var$createBaseQueryConsensusStateHeightsRequest();
        message.clientId = object.clientId ?? "";
        message.pagination = object.pagination !== undefined && object.pagination !== null ? $5eae5f3cc99e92ab$exports.PageRequest.fromPartial(object.pagination) : undefined;
        return message;
    }
};
function $368c5d14b6acc6e3$var$createBaseQueryConsensusStateHeightsResponse() {
    return {
        consensusStateHeights: [],
        pagination: undefined
    };
}
$368c5d14b6acc6e3$exports.QueryConsensusStateHeightsResponse = {
    encode (message, writer = $368c5d14b6acc6e3$var$_m0.Writer.create()) {
        for (const v of message.consensusStateHeights)$7d28e43a1e22112f$exports.Height.encode(v, writer.uint32(10).fork()).ldelim();
        if (message.pagination !== undefined) $5eae5f3cc99e92ab$exports.PageResponse.encode(message.pagination, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $368c5d14b6acc6e3$var$_m0.Reader ? input : new $368c5d14b6acc6e3$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $368c5d14b6acc6e3$var$createBaseQueryConsensusStateHeightsResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.consensusStateHeights.push($7d28e43a1e22112f$exports.Height.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.pagination = $5eae5f3cc99e92ab$exports.PageResponse.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            consensusStateHeights: Array.isArray(object?.consensusStateHeights) ? object.consensusStateHeights.map((e)=>$7d28e43a1e22112f$exports.Height.fromJSON(e)) : [],
            pagination: (0, $d5e07fe2518aae94$exports.isSet)(object.pagination) ? $5eae5f3cc99e92ab$exports.PageResponse.fromJSON(object.pagination) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        if (message.consensusStateHeights) obj.consensusStateHeights = message.consensusStateHeights.map((e)=>e ? $7d28e43a1e22112f$exports.Height.toJSON(e) : undefined);
        else obj.consensusStateHeights = [];
        message.pagination !== undefined && (obj.pagination = message.pagination ? $5eae5f3cc99e92ab$exports.PageResponse.toJSON(message.pagination) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $368c5d14b6acc6e3$var$createBaseQueryConsensusStateHeightsResponse();
        message.consensusStateHeights = object.consensusStateHeights?.map((e)=>$7d28e43a1e22112f$exports.Height.fromPartial(e)) || [];
        message.pagination = object.pagination !== undefined && object.pagination !== null ? $5eae5f3cc99e92ab$exports.PageResponse.fromPartial(object.pagination) : undefined;
        return message;
    }
};
function $368c5d14b6acc6e3$var$createBaseQueryClientStatusRequest() {
    return {
        clientId: ""
    };
}
$368c5d14b6acc6e3$exports.QueryClientStatusRequest = {
    encode (message, writer = $368c5d14b6acc6e3$var$_m0.Writer.create()) {
        if (message.clientId !== "") writer.uint32(10).string(message.clientId);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $368c5d14b6acc6e3$var$_m0.Reader ? input : new $368c5d14b6acc6e3$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $368c5d14b6acc6e3$var$createBaseQueryClientStatusRequest();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.clientId = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            clientId: (0, $d5e07fe2518aae94$exports.isSet)(object.clientId) ? String(object.clientId) : ""
        };
    },
    toJSON (message) {
        const obj = {};
        message.clientId !== undefined && (obj.clientId = message.clientId);
        return obj;
    },
    fromPartial (object) {
        const message = $368c5d14b6acc6e3$var$createBaseQueryClientStatusRequest();
        message.clientId = object.clientId ?? "";
        return message;
    }
};
function $368c5d14b6acc6e3$var$createBaseQueryClientStatusResponse() {
    return {
        status: ""
    };
}
$368c5d14b6acc6e3$exports.QueryClientStatusResponse = {
    encode (message, writer = $368c5d14b6acc6e3$var$_m0.Writer.create()) {
        if (message.status !== "") writer.uint32(10).string(message.status);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $368c5d14b6acc6e3$var$_m0.Reader ? input : new $368c5d14b6acc6e3$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $368c5d14b6acc6e3$var$createBaseQueryClientStatusResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.status = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            status: (0, $d5e07fe2518aae94$exports.isSet)(object.status) ? String(object.status) : ""
        };
    },
    toJSON (message) {
        const obj = {};
        message.status !== undefined && (obj.status = message.status);
        return obj;
    },
    fromPartial (object) {
        const message = $368c5d14b6acc6e3$var$createBaseQueryClientStatusResponse();
        message.status = object.status ?? "";
        return message;
    }
};
function $368c5d14b6acc6e3$var$createBaseQueryClientParamsRequest() {
    return {};
}
$368c5d14b6acc6e3$exports.QueryClientParamsRequest = {
    encode (_, writer = $368c5d14b6acc6e3$var$_m0.Writer.create()) {
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $368c5d14b6acc6e3$var$_m0.Reader ? input : new $368c5d14b6acc6e3$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $368c5d14b6acc6e3$var$createBaseQueryClientParamsRequest();
        while(reader.pos < end){
            const tag = reader.uint32();
            tag;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON (_) {
        return {};
    },
    toJSON (_) {
        const obj = {};
        return obj;
    },
    fromPartial (_) {
        const message = $368c5d14b6acc6e3$var$createBaseQueryClientParamsRequest();
        return message;
    }
};
function $368c5d14b6acc6e3$var$createBaseQueryClientParamsResponse() {
    return {
        params: undefined
    };
}
$368c5d14b6acc6e3$exports.QueryClientParamsResponse = {
    encode (message, writer = $368c5d14b6acc6e3$var$_m0.Writer.create()) {
        if (message.params !== undefined) $7d28e43a1e22112f$exports.Params.encode(message.params, writer.uint32(10).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $368c5d14b6acc6e3$var$_m0.Reader ? input : new $368c5d14b6acc6e3$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $368c5d14b6acc6e3$var$createBaseQueryClientParamsResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.params = $7d28e43a1e22112f$exports.Params.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            params: (0, $d5e07fe2518aae94$exports.isSet)(object.params) ? $7d28e43a1e22112f$exports.Params.fromJSON(object.params) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.params !== undefined && (obj.params = message.params ? $7d28e43a1e22112f$exports.Params.toJSON(message.params) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $368c5d14b6acc6e3$var$createBaseQueryClientParamsResponse();
        message.params = object.params !== undefined && object.params !== null ? $7d28e43a1e22112f$exports.Params.fromPartial(object.params) : undefined;
        return message;
    }
};
function $368c5d14b6acc6e3$var$createBaseQueryUpgradedClientStateRequest() {
    return {};
}
$368c5d14b6acc6e3$exports.QueryUpgradedClientStateRequest = {
    encode (_, writer = $368c5d14b6acc6e3$var$_m0.Writer.create()) {
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $368c5d14b6acc6e3$var$_m0.Reader ? input : new $368c5d14b6acc6e3$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $368c5d14b6acc6e3$var$createBaseQueryUpgradedClientStateRequest();
        while(reader.pos < end){
            const tag = reader.uint32();
            tag;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON (_) {
        return {};
    },
    toJSON (_) {
        const obj = {};
        return obj;
    },
    fromPartial (_) {
        const message = $368c5d14b6acc6e3$var$createBaseQueryUpgradedClientStateRequest();
        return message;
    }
};
function $368c5d14b6acc6e3$var$createBaseQueryUpgradedClientStateResponse() {
    return {
        upgradedClientState: undefined
    };
}
$368c5d14b6acc6e3$exports.QueryUpgradedClientStateResponse = {
    encode (message, writer = $368c5d14b6acc6e3$var$_m0.Writer.create()) {
        if (message.upgradedClientState !== undefined) $64138e590dcf0cc1$exports.Any.encode(message.upgradedClientState, writer.uint32(10).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $368c5d14b6acc6e3$var$_m0.Reader ? input : new $368c5d14b6acc6e3$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $368c5d14b6acc6e3$var$createBaseQueryUpgradedClientStateResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.upgradedClientState = $64138e590dcf0cc1$exports.Any.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            upgradedClientState: (0, $d5e07fe2518aae94$exports.isSet)(object.upgradedClientState) ? $64138e590dcf0cc1$exports.Any.fromJSON(object.upgradedClientState) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.upgradedClientState !== undefined && (obj.upgradedClientState = message.upgradedClientState ? $64138e590dcf0cc1$exports.Any.toJSON(message.upgradedClientState) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $368c5d14b6acc6e3$var$createBaseQueryUpgradedClientStateResponse();
        message.upgradedClientState = object.upgradedClientState !== undefined && object.upgradedClientState !== null ? $64138e590dcf0cc1$exports.Any.fromPartial(object.upgradedClientState) : undefined;
        return message;
    }
};
function $368c5d14b6acc6e3$var$createBaseQueryUpgradedConsensusStateRequest() {
    return {};
}
$368c5d14b6acc6e3$exports.QueryUpgradedConsensusStateRequest = {
    encode (_, writer = $368c5d14b6acc6e3$var$_m0.Writer.create()) {
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $368c5d14b6acc6e3$var$_m0.Reader ? input : new $368c5d14b6acc6e3$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $368c5d14b6acc6e3$var$createBaseQueryUpgradedConsensusStateRequest();
        while(reader.pos < end){
            const tag = reader.uint32();
            tag;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON (_) {
        return {};
    },
    toJSON (_) {
        const obj = {};
        return obj;
    },
    fromPartial (_) {
        const message = $368c5d14b6acc6e3$var$createBaseQueryUpgradedConsensusStateRequest();
        return message;
    }
};
function $368c5d14b6acc6e3$var$createBaseQueryUpgradedConsensusStateResponse() {
    return {
        upgradedConsensusState: undefined
    };
}
$368c5d14b6acc6e3$exports.QueryUpgradedConsensusStateResponse = {
    encode (message, writer = $368c5d14b6acc6e3$var$_m0.Writer.create()) {
        if (message.upgradedConsensusState !== undefined) $64138e590dcf0cc1$exports.Any.encode(message.upgradedConsensusState, writer.uint32(10).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $368c5d14b6acc6e3$var$_m0.Reader ? input : new $368c5d14b6acc6e3$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $368c5d14b6acc6e3$var$createBaseQueryUpgradedConsensusStateResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.upgradedConsensusState = $64138e590dcf0cc1$exports.Any.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            upgradedConsensusState: (0, $d5e07fe2518aae94$exports.isSet)(object.upgradedConsensusState) ? $64138e590dcf0cc1$exports.Any.fromJSON(object.upgradedConsensusState) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.upgradedConsensusState !== undefined && (obj.upgradedConsensusState = message.upgradedConsensusState ? $64138e590dcf0cc1$exports.Any.toJSON(message.upgradedConsensusState) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $368c5d14b6acc6e3$var$createBaseQueryUpgradedConsensusStateResponse();
        message.upgradedConsensusState = object.upgradedConsensusState !== undefined && object.upgradedConsensusState !== null ? $64138e590dcf0cc1$exports.Any.fromPartial(object.upgradedConsensusState) : undefined;
        return message;
    }
};
class $368c5d14b6acc6e3$var$QueryClientImpl {
    constructor(rpc){
        this.rpc = rpc;
        this.ClientState = this.ClientState.bind(this);
        this.ClientStates = this.ClientStates.bind(this);
        this.ConsensusState = this.ConsensusState.bind(this);
        this.ConsensusStates = this.ConsensusStates.bind(this);
        this.ConsensusStateHeights = this.ConsensusStateHeights.bind(this);
        this.ClientStatus = this.ClientStatus.bind(this);
        this.ClientParams = this.ClientParams.bind(this);
        this.UpgradedClientState = this.UpgradedClientState.bind(this);
        this.UpgradedConsensusState = this.UpgradedConsensusState.bind(this);
    }
    ClientState(request) {
        const data = $368c5d14b6acc6e3$exports.QueryClientStateRequest.encode(request).finish();
        const promise = this.rpc.request("ibc.core.client.v1.Query", "ClientState", data);
        return promise.then((data)=>$368c5d14b6acc6e3$exports.QueryClientStateResponse.decode(new $368c5d14b6acc6e3$var$_m0.Reader(data)));
    }
    ClientStates(request = {
        pagination: undefined
    }) {
        const data = $368c5d14b6acc6e3$exports.QueryClientStatesRequest.encode(request).finish();
        const promise = this.rpc.request("ibc.core.client.v1.Query", "ClientStates", data);
        return promise.then((data)=>$368c5d14b6acc6e3$exports.QueryClientStatesResponse.decode(new $368c5d14b6acc6e3$var$_m0.Reader(data)));
    }
    ConsensusState(request) {
        const data = $368c5d14b6acc6e3$exports.QueryConsensusStateRequest.encode(request).finish();
        const promise = this.rpc.request("ibc.core.client.v1.Query", "ConsensusState", data);
        return promise.then((data)=>$368c5d14b6acc6e3$exports.QueryConsensusStateResponse.decode(new $368c5d14b6acc6e3$var$_m0.Reader(data)));
    }
    ConsensusStates(request) {
        const data = $368c5d14b6acc6e3$exports.QueryConsensusStatesRequest.encode(request).finish();
        const promise = this.rpc.request("ibc.core.client.v1.Query", "ConsensusStates", data);
        return promise.then((data)=>$368c5d14b6acc6e3$exports.QueryConsensusStatesResponse.decode(new $368c5d14b6acc6e3$var$_m0.Reader(data)));
    }
    ConsensusStateHeights(request) {
        const data = $368c5d14b6acc6e3$exports.QueryConsensusStateHeightsRequest.encode(request).finish();
        const promise = this.rpc.request("ibc.core.client.v1.Query", "ConsensusStateHeights", data);
        return promise.then((data)=>$368c5d14b6acc6e3$exports.QueryConsensusStateHeightsResponse.decode(new $368c5d14b6acc6e3$var$_m0.Reader(data)));
    }
    ClientStatus(request) {
        const data = $368c5d14b6acc6e3$exports.QueryClientStatusRequest.encode(request).finish();
        const promise = this.rpc.request("ibc.core.client.v1.Query", "ClientStatus", data);
        return promise.then((data)=>$368c5d14b6acc6e3$exports.QueryClientStatusResponse.decode(new $368c5d14b6acc6e3$var$_m0.Reader(data)));
    }
    ClientParams(request = {}) {
        const data = $368c5d14b6acc6e3$exports.QueryClientParamsRequest.encode(request).finish();
        const promise = this.rpc.request("ibc.core.client.v1.Query", "ClientParams", data);
        return promise.then((data)=>$368c5d14b6acc6e3$exports.QueryClientParamsResponse.decode(new $368c5d14b6acc6e3$var$_m0.Reader(data)));
    }
    UpgradedClientState(request = {}) {
        const data = $368c5d14b6acc6e3$exports.QueryUpgradedClientStateRequest.encode(request).finish();
        const promise = this.rpc.request("ibc.core.client.v1.Query", "UpgradedClientState", data);
        return promise.then((data)=>$368c5d14b6acc6e3$exports.QueryUpgradedClientStateResponse.decode(new $368c5d14b6acc6e3$var$_m0.Reader(data)));
    }
    UpgradedConsensusState(request = {}) {
        const data = $368c5d14b6acc6e3$exports.QueryUpgradedConsensusStateRequest.encode(request).finish();
        const promise = this.rpc.request("ibc.core.client.v1.Query", "UpgradedConsensusState", data);
        return promise.then((data)=>$368c5d14b6acc6e3$exports.QueryUpgradedConsensusStateResponse.decode(new $368c5d14b6acc6e3$var$_m0.Reader(data)));
    }
}
$368c5d14b6acc6e3$exports.QueryClientImpl = $368c5d14b6acc6e3$var$QueryClientImpl;


var $272eae30937addce$exports = {};
"use strict";
var $272eae30937addce$var$__createBinding = $272eae30937addce$exports && $272eae30937addce$exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $272eae30937addce$var$__setModuleDefault = $272eae30937addce$exports && $272eae30937addce$exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $272eae30937addce$var$__importStar = $272eae30937addce$exports && $272eae30937addce$exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $272eae30937addce$var$__createBinding(result, mod, k);
    }
    $272eae30937addce$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty($272eae30937addce$exports, "__esModule", {
    value: true
});
$272eae30937addce$exports.QueryClientImpl = $272eae30937addce$exports.QueryConnectionParamsResponse = $272eae30937addce$exports.QueryConnectionParamsRequest = $272eae30937addce$exports.QueryConnectionConsensusStateResponse = $272eae30937addce$exports.QueryConnectionConsensusStateRequest = $272eae30937addce$exports.QueryConnectionClientStateResponse = $272eae30937addce$exports.QueryConnectionClientStateRequest = $272eae30937addce$exports.QueryClientConnectionsResponse = $272eae30937addce$exports.QueryClientConnectionsRequest = $272eae30937addce$exports.QueryConnectionsResponse = $272eae30937addce$exports.QueryConnectionsRequest = $272eae30937addce$exports.QueryConnectionResponse = $272eae30937addce$exports.QueryConnectionRequest = $272eae30937addce$exports.protobufPackage = void 0;






const $272eae30937addce$var$_m0 = $272eae30937addce$var$__importStar((parcelRequire("fQBv0")));
$272eae30937addce$exports.protobufPackage = "ibc.core.connection.v1";
function $272eae30937addce$var$createBaseQueryConnectionRequest() {
    return {
        connectionId: ""
    };
}
$272eae30937addce$exports.QueryConnectionRequest = {
    encode (message, writer = $272eae30937addce$var$_m0.Writer.create()) {
        if (message.connectionId !== "") writer.uint32(10).string(message.connectionId);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $272eae30937addce$var$_m0.Reader ? input : new $272eae30937addce$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $272eae30937addce$var$createBaseQueryConnectionRequest();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.connectionId = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            connectionId: (0, $d5e07fe2518aae94$exports.isSet)(object.connectionId) ? String(object.connectionId) : ""
        };
    },
    toJSON (message) {
        const obj = {};
        message.connectionId !== undefined && (obj.connectionId = message.connectionId);
        return obj;
    },
    fromPartial (object) {
        const message = $272eae30937addce$var$createBaseQueryConnectionRequest();
        message.connectionId = object.connectionId ?? "";
        return message;
    }
};
function $272eae30937addce$var$createBaseQueryConnectionResponse() {
    return {
        connection: undefined,
        proof: new Uint8Array(),
        proofHeight: undefined
    };
}
$272eae30937addce$exports.QueryConnectionResponse = {
    encode (message, writer = $272eae30937addce$var$_m0.Writer.create()) {
        if (message.connection !== undefined) $42dc008ab8b50be1$exports.ConnectionEnd.encode(message.connection, writer.uint32(10).fork()).ldelim();
        if (message.proof.length !== 0) writer.uint32(18).bytes(message.proof);
        if (message.proofHeight !== undefined) $7d28e43a1e22112f$exports.Height.encode(message.proofHeight, writer.uint32(26).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $272eae30937addce$var$_m0.Reader ? input : new $272eae30937addce$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $272eae30937addce$var$createBaseQueryConnectionResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.connection = $42dc008ab8b50be1$exports.ConnectionEnd.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.proof = reader.bytes();
                    break;
                case 3:
                    message.proofHeight = $7d28e43a1e22112f$exports.Height.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            connection: (0, $d5e07fe2518aae94$exports.isSet)(object.connection) ? $42dc008ab8b50be1$exports.ConnectionEnd.fromJSON(object.connection) : undefined,
            proof: (0, $d5e07fe2518aae94$exports.isSet)(object.proof) ? (0, $d5e07fe2518aae94$exports.bytesFromBase64)(object.proof) : new Uint8Array(),
            proofHeight: (0, $d5e07fe2518aae94$exports.isSet)(object.proofHeight) ? $7d28e43a1e22112f$exports.Height.fromJSON(object.proofHeight) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.connection !== undefined && (obj.connection = message.connection ? $42dc008ab8b50be1$exports.ConnectionEnd.toJSON(message.connection) : undefined);
        message.proof !== undefined && (obj.proof = (0, $d5e07fe2518aae94$exports.base64FromBytes)(message.proof !== undefined ? message.proof : new Uint8Array()));
        message.proofHeight !== undefined && (obj.proofHeight = message.proofHeight ? $7d28e43a1e22112f$exports.Height.toJSON(message.proofHeight) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $272eae30937addce$var$createBaseQueryConnectionResponse();
        message.connection = object.connection !== undefined && object.connection !== null ? $42dc008ab8b50be1$exports.ConnectionEnd.fromPartial(object.connection) : undefined;
        message.proof = object.proof ?? new Uint8Array();
        message.proofHeight = object.proofHeight !== undefined && object.proofHeight !== null ? $7d28e43a1e22112f$exports.Height.fromPartial(object.proofHeight) : undefined;
        return message;
    }
};
function $272eae30937addce$var$createBaseQueryConnectionsRequest() {
    return {
        pagination: undefined
    };
}
$272eae30937addce$exports.QueryConnectionsRequest = {
    encode (message, writer = $272eae30937addce$var$_m0.Writer.create()) {
        if (message.pagination !== undefined) $5eae5f3cc99e92ab$exports.PageRequest.encode(message.pagination, writer.uint32(10).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $272eae30937addce$var$_m0.Reader ? input : new $272eae30937addce$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $272eae30937addce$var$createBaseQueryConnectionsRequest();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.pagination = $5eae5f3cc99e92ab$exports.PageRequest.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            pagination: (0, $d5e07fe2518aae94$exports.isSet)(object.pagination) ? $5eae5f3cc99e92ab$exports.PageRequest.fromJSON(object.pagination) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.pagination !== undefined && (obj.pagination = message.pagination ? $5eae5f3cc99e92ab$exports.PageRequest.toJSON(message.pagination) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $272eae30937addce$var$createBaseQueryConnectionsRequest();
        message.pagination = object.pagination !== undefined && object.pagination !== null ? $5eae5f3cc99e92ab$exports.PageRequest.fromPartial(object.pagination) : undefined;
        return message;
    }
};
function $272eae30937addce$var$createBaseQueryConnectionsResponse() {
    return {
        connections: [],
        pagination: undefined,
        height: undefined
    };
}
$272eae30937addce$exports.QueryConnectionsResponse = {
    encode (message, writer = $272eae30937addce$var$_m0.Writer.create()) {
        for (const v of message.connections)$42dc008ab8b50be1$exports.IdentifiedConnection.encode(v, writer.uint32(10).fork()).ldelim();
        if (message.pagination !== undefined) $5eae5f3cc99e92ab$exports.PageResponse.encode(message.pagination, writer.uint32(18).fork()).ldelim();
        if (message.height !== undefined) $7d28e43a1e22112f$exports.Height.encode(message.height, writer.uint32(26).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $272eae30937addce$var$_m0.Reader ? input : new $272eae30937addce$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $272eae30937addce$var$createBaseQueryConnectionsResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.connections.push($42dc008ab8b50be1$exports.IdentifiedConnection.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.pagination = $5eae5f3cc99e92ab$exports.PageResponse.decode(reader, reader.uint32());
                    break;
                case 3:
                    message.height = $7d28e43a1e22112f$exports.Height.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            connections: Array.isArray(object?.connections) ? object.connections.map((e)=>$42dc008ab8b50be1$exports.IdentifiedConnection.fromJSON(e)) : [],
            pagination: (0, $d5e07fe2518aae94$exports.isSet)(object.pagination) ? $5eae5f3cc99e92ab$exports.PageResponse.fromJSON(object.pagination) : undefined,
            height: (0, $d5e07fe2518aae94$exports.isSet)(object.height) ? $7d28e43a1e22112f$exports.Height.fromJSON(object.height) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        if (message.connections) obj.connections = message.connections.map((e)=>e ? $42dc008ab8b50be1$exports.IdentifiedConnection.toJSON(e) : undefined);
        else obj.connections = [];
        message.pagination !== undefined && (obj.pagination = message.pagination ? $5eae5f3cc99e92ab$exports.PageResponse.toJSON(message.pagination) : undefined);
        message.height !== undefined && (obj.height = message.height ? $7d28e43a1e22112f$exports.Height.toJSON(message.height) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $272eae30937addce$var$createBaseQueryConnectionsResponse();
        message.connections = object.connections?.map((e)=>$42dc008ab8b50be1$exports.IdentifiedConnection.fromPartial(e)) || [];
        message.pagination = object.pagination !== undefined && object.pagination !== null ? $5eae5f3cc99e92ab$exports.PageResponse.fromPartial(object.pagination) : undefined;
        message.height = object.height !== undefined && object.height !== null ? $7d28e43a1e22112f$exports.Height.fromPartial(object.height) : undefined;
        return message;
    }
};
function $272eae30937addce$var$createBaseQueryClientConnectionsRequest() {
    return {
        clientId: ""
    };
}
$272eae30937addce$exports.QueryClientConnectionsRequest = {
    encode (message, writer = $272eae30937addce$var$_m0.Writer.create()) {
        if (message.clientId !== "") writer.uint32(10).string(message.clientId);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $272eae30937addce$var$_m0.Reader ? input : new $272eae30937addce$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $272eae30937addce$var$createBaseQueryClientConnectionsRequest();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.clientId = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            clientId: (0, $d5e07fe2518aae94$exports.isSet)(object.clientId) ? String(object.clientId) : ""
        };
    },
    toJSON (message) {
        const obj = {};
        message.clientId !== undefined && (obj.clientId = message.clientId);
        return obj;
    },
    fromPartial (object) {
        const message = $272eae30937addce$var$createBaseQueryClientConnectionsRequest();
        message.clientId = object.clientId ?? "";
        return message;
    }
};
function $272eae30937addce$var$createBaseQueryClientConnectionsResponse() {
    return {
        connectionPaths: [],
        proof: new Uint8Array(),
        proofHeight: undefined
    };
}
$272eae30937addce$exports.QueryClientConnectionsResponse = {
    encode (message, writer = $272eae30937addce$var$_m0.Writer.create()) {
        for (const v of message.connectionPaths)writer.uint32(10).string(v);
        if (message.proof.length !== 0) writer.uint32(18).bytes(message.proof);
        if (message.proofHeight !== undefined) $7d28e43a1e22112f$exports.Height.encode(message.proofHeight, writer.uint32(26).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $272eae30937addce$var$_m0.Reader ? input : new $272eae30937addce$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $272eae30937addce$var$createBaseQueryClientConnectionsResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.connectionPaths.push(reader.string());
                    break;
                case 2:
                    message.proof = reader.bytes();
                    break;
                case 3:
                    message.proofHeight = $7d28e43a1e22112f$exports.Height.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            connectionPaths: Array.isArray(object?.connectionPaths) ? object.connectionPaths.map((e)=>String(e)) : [],
            proof: (0, $d5e07fe2518aae94$exports.isSet)(object.proof) ? (0, $d5e07fe2518aae94$exports.bytesFromBase64)(object.proof) : new Uint8Array(),
            proofHeight: (0, $d5e07fe2518aae94$exports.isSet)(object.proofHeight) ? $7d28e43a1e22112f$exports.Height.fromJSON(object.proofHeight) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        if (message.connectionPaths) obj.connectionPaths = message.connectionPaths.map((e)=>e);
        else obj.connectionPaths = [];
        message.proof !== undefined && (obj.proof = (0, $d5e07fe2518aae94$exports.base64FromBytes)(message.proof !== undefined ? message.proof : new Uint8Array()));
        message.proofHeight !== undefined && (obj.proofHeight = message.proofHeight ? $7d28e43a1e22112f$exports.Height.toJSON(message.proofHeight) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $272eae30937addce$var$createBaseQueryClientConnectionsResponse();
        message.connectionPaths = object.connectionPaths?.map((e)=>e) || [];
        message.proof = object.proof ?? new Uint8Array();
        message.proofHeight = object.proofHeight !== undefined && object.proofHeight !== null ? $7d28e43a1e22112f$exports.Height.fromPartial(object.proofHeight) : undefined;
        return message;
    }
};
function $272eae30937addce$var$createBaseQueryConnectionClientStateRequest() {
    return {
        connectionId: ""
    };
}
$272eae30937addce$exports.QueryConnectionClientStateRequest = {
    encode (message, writer = $272eae30937addce$var$_m0.Writer.create()) {
        if (message.connectionId !== "") writer.uint32(10).string(message.connectionId);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $272eae30937addce$var$_m0.Reader ? input : new $272eae30937addce$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $272eae30937addce$var$createBaseQueryConnectionClientStateRequest();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.connectionId = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            connectionId: (0, $d5e07fe2518aae94$exports.isSet)(object.connectionId) ? String(object.connectionId) : ""
        };
    },
    toJSON (message) {
        const obj = {};
        message.connectionId !== undefined && (obj.connectionId = message.connectionId);
        return obj;
    },
    fromPartial (object) {
        const message = $272eae30937addce$var$createBaseQueryConnectionClientStateRequest();
        message.connectionId = object.connectionId ?? "";
        return message;
    }
};
function $272eae30937addce$var$createBaseQueryConnectionClientStateResponse() {
    return {
        identifiedClientState: undefined,
        proof: new Uint8Array(),
        proofHeight: undefined
    };
}
$272eae30937addce$exports.QueryConnectionClientStateResponse = {
    encode (message, writer = $272eae30937addce$var$_m0.Writer.create()) {
        if (message.identifiedClientState !== undefined) $7d28e43a1e22112f$exports.IdentifiedClientState.encode(message.identifiedClientState, writer.uint32(10).fork()).ldelim();
        if (message.proof.length !== 0) writer.uint32(18).bytes(message.proof);
        if (message.proofHeight !== undefined) $7d28e43a1e22112f$exports.Height.encode(message.proofHeight, writer.uint32(26).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $272eae30937addce$var$_m0.Reader ? input : new $272eae30937addce$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $272eae30937addce$var$createBaseQueryConnectionClientStateResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.identifiedClientState = $7d28e43a1e22112f$exports.IdentifiedClientState.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.proof = reader.bytes();
                    break;
                case 3:
                    message.proofHeight = $7d28e43a1e22112f$exports.Height.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            identifiedClientState: (0, $d5e07fe2518aae94$exports.isSet)(object.identifiedClientState) ? $7d28e43a1e22112f$exports.IdentifiedClientState.fromJSON(object.identifiedClientState) : undefined,
            proof: (0, $d5e07fe2518aae94$exports.isSet)(object.proof) ? (0, $d5e07fe2518aae94$exports.bytesFromBase64)(object.proof) : new Uint8Array(),
            proofHeight: (0, $d5e07fe2518aae94$exports.isSet)(object.proofHeight) ? $7d28e43a1e22112f$exports.Height.fromJSON(object.proofHeight) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.identifiedClientState !== undefined && (obj.identifiedClientState = message.identifiedClientState ? $7d28e43a1e22112f$exports.IdentifiedClientState.toJSON(message.identifiedClientState) : undefined);
        message.proof !== undefined && (obj.proof = (0, $d5e07fe2518aae94$exports.base64FromBytes)(message.proof !== undefined ? message.proof : new Uint8Array()));
        message.proofHeight !== undefined && (obj.proofHeight = message.proofHeight ? $7d28e43a1e22112f$exports.Height.toJSON(message.proofHeight) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $272eae30937addce$var$createBaseQueryConnectionClientStateResponse();
        message.identifiedClientState = object.identifiedClientState !== undefined && object.identifiedClientState !== null ? $7d28e43a1e22112f$exports.IdentifiedClientState.fromPartial(object.identifiedClientState) : undefined;
        message.proof = object.proof ?? new Uint8Array();
        message.proofHeight = object.proofHeight !== undefined && object.proofHeight !== null ? $7d28e43a1e22112f$exports.Height.fromPartial(object.proofHeight) : undefined;
        return message;
    }
};
function $272eae30937addce$var$createBaseQueryConnectionConsensusStateRequest() {
    return {
        connectionId: "",
        revisionNumber: $d5e07fe2518aae94$exports.Long.UZERO,
        revisionHeight: $d5e07fe2518aae94$exports.Long.UZERO
    };
}
$272eae30937addce$exports.QueryConnectionConsensusStateRequest = {
    encode (message, writer = $272eae30937addce$var$_m0.Writer.create()) {
        if (message.connectionId !== "") writer.uint32(10).string(message.connectionId);
        if (!message.revisionNumber.isZero()) writer.uint32(16).uint64(message.revisionNumber);
        if (!message.revisionHeight.isZero()) writer.uint32(24).uint64(message.revisionHeight);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $272eae30937addce$var$_m0.Reader ? input : new $272eae30937addce$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $272eae30937addce$var$createBaseQueryConnectionConsensusStateRequest();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.connectionId = reader.string();
                    break;
                case 2:
                    message.revisionNumber = reader.uint64();
                    break;
                case 3:
                    message.revisionHeight = reader.uint64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            connectionId: (0, $d5e07fe2518aae94$exports.isSet)(object.connectionId) ? String(object.connectionId) : "",
            revisionNumber: (0, $d5e07fe2518aae94$exports.isSet)(object.revisionNumber) ? $d5e07fe2518aae94$exports.Long.fromValue(object.revisionNumber) : $d5e07fe2518aae94$exports.Long.UZERO,
            revisionHeight: (0, $d5e07fe2518aae94$exports.isSet)(object.revisionHeight) ? $d5e07fe2518aae94$exports.Long.fromValue(object.revisionHeight) : $d5e07fe2518aae94$exports.Long.UZERO
        };
    },
    toJSON (message) {
        const obj = {};
        message.connectionId !== undefined && (obj.connectionId = message.connectionId);
        message.revisionNumber !== undefined && (obj.revisionNumber = (message.revisionNumber || $d5e07fe2518aae94$exports.Long.UZERO).toString());
        message.revisionHeight !== undefined && (obj.revisionHeight = (message.revisionHeight || $d5e07fe2518aae94$exports.Long.UZERO).toString());
        return obj;
    },
    fromPartial (object) {
        const message = $272eae30937addce$var$createBaseQueryConnectionConsensusStateRequest();
        message.connectionId = object.connectionId ?? "";
        message.revisionNumber = object.revisionNumber !== undefined && object.revisionNumber !== null ? $d5e07fe2518aae94$exports.Long.fromValue(object.revisionNumber) : $d5e07fe2518aae94$exports.Long.UZERO;
        message.revisionHeight = object.revisionHeight !== undefined && object.revisionHeight !== null ? $d5e07fe2518aae94$exports.Long.fromValue(object.revisionHeight) : $d5e07fe2518aae94$exports.Long.UZERO;
        return message;
    }
};
function $272eae30937addce$var$createBaseQueryConnectionConsensusStateResponse() {
    return {
        consensusState: undefined,
        clientId: "",
        proof: new Uint8Array(),
        proofHeight: undefined
    };
}
$272eae30937addce$exports.QueryConnectionConsensusStateResponse = {
    encode (message, writer = $272eae30937addce$var$_m0.Writer.create()) {
        if (message.consensusState !== undefined) $64138e590dcf0cc1$exports.Any.encode(message.consensusState, writer.uint32(10).fork()).ldelim();
        if (message.clientId !== "") writer.uint32(18).string(message.clientId);
        if (message.proof.length !== 0) writer.uint32(26).bytes(message.proof);
        if (message.proofHeight !== undefined) $7d28e43a1e22112f$exports.Height.encode(message.proofHeight, writer.uint32(34).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $272eae30937addce$var$_m0.Reader ? input : new $272eae30937addce$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $272eae30937addce$var$createBaseQueryConnectionConsensusStateResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.consensusState = $64138e590dcf0cc1$exports.Any.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.clientId = reader.string();
                    break;
                case 3:
                    message.proof = reader.bytes();
                    break;
                case 4:
                    message.proofHeight = $7d28e43a1e22112f$exports.Height.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            consensusState: (0, $d5e07fe2518aae94$exports.isSet)(object.consensusState) ? $64138e590dcf0cc1$exports.Any.fromJSON(object.consensusState) : undefined,
            clientId: (0, $d5e07fe2518aae94$exports.isSet)(object.clientId) ? String(object.clientId) : "",
            proof: (0, $d5e07fe2518aae94$exports.isSet)(object.proof) ? (0, $d5e07fe2518aae94$exports.bytesFromBase64)(object.proof) : new Uint8Array(),
            proofHeight: (0, $d5e07fe2518aae94$exports.isSet)(object.proofHeight) ? $7d28e43a1e22112f$exports.Height.fromJSON(object.proofHeight) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.consensusState !== undefined && (obj.consensusState = message.consensusState ? $64138e590dcf0cc1$exports.Any.toJSON(message.consensusState) : undefined);
        message.clientId !== undefined && (obj.clientId = message.clientId);
        message.proof !== undefined && (obj.proof = (0, $d5e07fe2518aae94$exports.base64FromBytes)(message.proof !== undefined ? message.proof : new Uint8Array()));
        message.proofHeight !== undefined && (obj.proofHeight = message.proofHeight ? $7d28e43a1e22112f$exports.Height.toJSON(message.proofHeight) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $272eae30937addce$var$createBaseQueryConnectionConsensusStateResponse();
        message.consensusState = object.consensusState !== undefined && object.consensusState !== null ? $64138e590dcf0cc1$exports.Any.fromPartial(object.consensusState) : undefined;
        message.clientId = object.clientId ?? "";
        message.proof = object.proof ?? new Uint8Array();
        message.proofHeight = object.proofHeight !== undefined && object.proofHeight !== null ? $7d28e43a1e22112f$exports.Height.fromPartial(object.proofHeight) : undefined;
        return message;
    }
};
function $272eae30937addce$var$createBaseQueryConnectionParamsRequest() {
    return {};
}
$272eae30937addce$exports.QueryConnectionParamsRequest = {
    encode (_, writer = $272eae30937addce$var$_m0.Writer.create()) {
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $272eae30937addce$var$_m0.Reader ? input : new $272eae30937addce$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $272eae30937addce$var$createBaseQueryConnectionParamsRequest();
        while(reader.pos < end){
            const tag = reader.uint32();
            tag;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON (_) {
        return {};
    },
    toJSON (_) {
        const obj = {};
        return obj;
    },
    fromPartial (_) {
        const message = $272eae30937addce$var$createBaseQueryConnectionParamsRequest();
        return message;
    }
};
function $272eae30937addce$var$createBaseQueryConnectionParamsResponse() {
    return {
        params: undefined
    };
}
$272eae30937addce$exports.QueryConnectionParamsResponse = {
    encode (message, writer = $272eae30937addce$var$_m0.Writer.create()) {
        if (message.params !== undefined) $7d28e43a1e22112f$exports.Params.encode(message.params, writer.uint32(10).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $272eae30937addce$var$_m0.Reader ? input : new $272eae30937addce$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $272eae30937addce$var$createBaseQueryConnectionParamsResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.params = $7d28e43a1e22112f$exports.Params.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            params: (0, $d5e07fe2518aae94$exports.isSet)(object.params) ? $7d28e43a1e22112f$exports.Params.fromJSON(object.params) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.params !== undefined && (obj.params = message.params ? $7d28e43a1e22112f$exports.Params.toJSON(message.params) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $272eae30937addce$var$createBaseQueryConnectionParamsResponse();
        message.params = object.params !== undefined && object.params !== null ? $7d28e43a1e22112f$exports.Params.fromPartial(object.params) : undefined;
        return message;
    }
};
class $272eae30937addce$var$QueryClientImpl {
    constructor(rpc){
        this.rpc = rpc;
        this.Connection = this.Connection.bind(this);
        this.Connections = this.Connections.bind(this);
        this.ClientConnections = this.ClientConnections.bind(this);
        this.ConnectionClientState = this.ConnectionClientState.bind(this);
        this.ConnectionConsensusState = this.ConnectionConsensusState.bind(this);
        this.ConnectionParams = this.ConnectionParams.bind(this);
    }
    Connection(request) {
        const data = $272eae30937addce$exports.QueryConnectionRequest.encode(request).finish();
        const promise = this.rpc.request("ibc.core.connection.v1.Query", "Connection", data);
        return promise.then((data)=>$272eae30937addce$exports.QueryConnectionResponse.decode(new $272eae30937addce$var$_m0.Reader(data)));
    }
    Connections(request = {
        pagination: undefined
    }) {
        const data = $272eae30937addce$exports.QueryConnectionsRequest.encode(request).finish();
        const promise = this.rpc.request("ibc.core.connection.v1.Query", "Connections", data);
        return promise.then((data)=>$272eae30937addce$exports.QueryConnectionsResponse.decode(new $272eae30937addce$var$_m0.Reader(data)));
    }
    ClientConnections(request) {
        const data = $272eae30937addce$exports.QueryClientConnectionsRequest.encode(request).finish();
        const promise = this.rpc.request("ibc.core.connection.v1.Query", "ClientConnections", data);
        return promise.then((data)=>$272eae30937addce$exports.QueryClientConnectionsResponse.decode(new $272eae30937addce$var$_m0.Reader(data)));
    }
    ConnectionClientState(request) {
        const data = $272eae30937addce$exports.QueryConnectionClientStateRequest.encode(request).finish();
        const promise = this.rpc.request("ibc.core.connection.v1.Query", "ConnectionClientState", data);
        return promise.then((data)=>$272eae30937addce$exports.QueryConnectionClientStateResponse.decode(new $272eae30937addce$var$_m0.Reader(data)));
    }
    ConnectionConsensusState(request) {
        const data = $272eae30937addce$exports.QueryConnectionConsensusStateRequest.encode(request).finish();
        const promise = this.rpc.request("ibc.core.connection.v1.Query", "ConnectionConsensusState", data);
        return promise.then((data)=>$272eae30937addce$exports.QueryConnectionConsensusStateResponse.decode(new $272eae30937addce$var$_m0.Reader(data)));
    }
    ConnectionParams(request = {}) {
        const data = $272eae30937addce$exports.QueryConnectionParamsRequest.encode(request).finish();
        const promise = this.rpc.request("ibc.core.connection.v1.Query", "ConnectionParams", data);
        return promise.then((data)=>$272eae30937addce$exports.QueryConnectionParamsResponse.decode(new $272eae30937addce$var$_m0.Reader(data)));
    }
}
$272eae30937addce$exports.QueryClientImpl = $272eae30937addce$var$QueryClientImpl;


var $26160fa4309ffb51$exports = {};
"use strict";
var $26160fa4309ffb51$var$__createBinding = $26160fa4309ffb51$exports && $26160fa4309ffb51$exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $26160fa4309ffb51$var$__setModuleDefault = $26160fa4309ffb51$exports && $26160fa4309ffb51$exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $26160fa4309ffb51$var$__importStar = $26160fa4309ffb51$exports && $26160fa4309ffb51$exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $26160fa4309ffb51$var$__createBinding(result, mod, k);
    }
    $26160fa4309ffb51$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty($26160fa4309ffb51$exports, "__esModule", {
    value: true
});
$26160fa4309ffb51$exports.Fraction = $26160fa4309ffb51$exports.Header = $26160fa4309ffb51$exports.Misbehaviour = $26160fa4309ffb51$exports.ConsensusState = $26160fa4309ffb51$exports.ClientState = $26160fa4309ffb51$exports.protobufPackage = void 0;





var $c51af120eef1efed$exports = {};
"use strict";
var $c51af120eef1efed$var$__createBinding = $c51af120eef1efed$exports && $c51af120eef1efed$exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $c51af120eef1efed$var$__setModuleDefault = $c51af120eef1efed$exports && $c51af120eef1efed$exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $c51af120eef1efed$var$__importStar = $c51af120eef1efed$exports && $c51af120eef1efed$exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $c51af120eef1efed$var$__createBinding(result, mod, k);
    }
    $c51af120eef1efed$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty($c51af120eef1efed$exports, "__esModule", {
    value: true
});
$c51af120eef1efed$exports.TxProof = $c51af120eef1efed$exports.BlockMeta = $c51af120eef1efed$exports.LightBlock = $c51af120eef1efed$exports.SignedHeader = $c51af120eef1efed$exports.Proposal = $c51af120eef1efed$exports.CommitSig = $c51af120eef1efed$exports.Commit = $c51af120eef1efed$exports.Vote = $c51af120eef1efed$exports.Data = $c51af120eef1efed$exports.Header = $c51af120eef1efed$exports.BlockID = $c51af120eef1efed$exports.Part = $c51af120eef1efed$exports.PartSetHeader = $c51af120eef1efed$exports.signedMsgTypeToJSON = $c51af120eef1efed$exports.signedMsgTypeFromJSON = $c51af120eef1efed$exports.SignedMsgType = $c51af120eef1efed$exports.blockIDFlagToJSON = $c51af120eef1efed$exports.blockIDFlagFromJSON = $c51af120eef1efed$exports.BlockIDFlag = $c51af120eef1efed$exports.protobufPackage = void 0;
var $705dca31272f1c70$exports = {};
"use strict";
var $705dca31272f1c70$var$__createBinding = $705dca31272f1c70$exports && $705dca31272f1c70$exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $705dca31272f1c70$var$__setModuleDefault = $705dca31272f1c70$exports && $705dca31272f1c70$exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $705dca31272f1c70$var$__importStar = $705dca31272f1c70$exports && $705dca31272f1c70$exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $705dca31272f1c70$var$__createBinding(result, mod, k);
    }
    $705dca31272f1c70$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty($705dca31272f1c70$exports, "__esModule", {
    value: true
});
$705dca31272f1c70$exports.ProofOps = $705dca31272f1c70$exports.ProofOp = $705dca31272f1c70$exports.DominoOp = $705dca31272f1c70$exports.ValueOp = $705dca31272f1c70$exports.Proof = $705dca31272f1c70$exports.protobufPackage = void 0;


const $705dca31272f1c70$var$_m0 = $705dca31272f1c70$var$__importStar((parcelRequire("fQBv0")));
$705dca31272f1c70$exports.protobufPackage = "tendermint.crypto";
function $705dca31272f1c70$var$createBaseProof() {
    return {
        total: $d5e07fe2518aae94$exports.Long.ZERO,
        index: $d5e07fe2518aae94$exports.Long.ZERO,
        leafHash: new Uint8Array(),
        aunts: []
    };
}
$705dca31272f1c70$exports.Proof = {
    encode (message, writer = $705dca31272f1c70$var$_m0.Writer.create()) {
        if (!message.total.isZero()) writer.uint32(8).int64(message.total);
        if (!message.index.isZero()) writer.uint32(16).int64(message.index);
        if (message.leafHash.length !== 0) writer.uint32(26).bytes(message.leafHash);
        for (const v of message.aunts)writer.uint32(34).bytes(v);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $705dca31272f1c70$var$_m0.Reader ? input : new $705dca31272f1c70$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $705dca31272f1c70$var$createBaseProof();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.total = reader.int64();
                    break;
                case 2:
                    message.index = reader.int64();
                    break;
                case 3:
                    message.leafHash = reader.bytes();
                    break;
                case 4:
                    message.aunts.push(reader.bytes());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            total: (0, $d5e07fe2518aae94$exports.isSet)(object.total) ? $d5e07fe2518aae94$exports.Long.fromValue(object.total) : $d5e07fe2518aae94$exports.Long.ZERO,
            index: (0, $d5e07fe2518aae94$exports.isSet)(object.index) ? $d5e07fe2518aae94$exports.Long.fromValue(object.index) : $d5e07fe2518aae94$exports.Long.ZERO,
            leafHash: (0, $d5e07fe2518aae94$exports.isSet)(object.leafHash) ? (0, $d5e07fe2518aae94$exports.bytesFromBase64)(object.leafHash) : new Uint8Array(),
            aunts: Array.isArray(object?.aunts) ? object.aunts.map((e)=>(0, $d5e07fe2518aae94$exports.bytesFromBase64)(e)) : []
        };
    },
    toJSON (message) {
        const obj = {};
        message.total !== undefined && (obj.total = (message.total || $d5e07fe2518aae94$exports.Long.ZERO).toString());
        message.index !== undefined && (obj.index = (message.index || $d5e07fe2518aae94$exports.Long.ZERO).toString());
        message.leafHash !== undefined && (obj.leafHash = (0, $d5e07fe2518aae94$exports.base64FromBytes)(message.leafHash !== undefined ? message.leafHash : new Uint8Array()));
        if (message.aunts) obj.aunts = message.aunts.map((e)=>(0, $d5e07fe2518aae94$exports.base64FromBytes)(e !== undefined ? e : new Uint8Array()));
        else obj.aunts = [];
        return obj;
    },
    fromPartial (object) {
        const message = $705dca31272f1c70$var$createBaseProof();
        message.total = object.total !== undefined && object.total !== null ? $d5e07fe2518aae94$exports.Long.fromValue(object.total) : $d5e07fe2518aae94$exports.Long.ZERO;
        message.index = object.index !== undefined && object.index !== null ? $d5e07fe2518aae94$exports.Long.fromValue(object.index) : $d5e07fe2518aae94$exports.Long.ZERO;
        message.leafHash = object.leafHash ?? new Uint8Array();
        message.aunts = object.aunts?.map((e)=>e) || [];
        return message;
    }
};
function $705dca31272f1c70$var$createBaseValueOp() {
    return {
        key: new Uint8Array(),
        proof: undefined
    };
}
$705dca31272f1c70$exports.ValueOp = {
    encode (message, writer = $705dca31272f1c70$var$_m0.Writer.create()) {
        if (message.key.length !== 0) writer.uint32(10).bytes(message.key);
        if (message.proof !== undefined) $705dca31272f1c70$exports.Proof.encode(message.proof, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $705dca31272f1c70$var$_m0.Reader ? input : new $705dca31272f1c70$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $705dca31272f1c70$var$createBaseValueOp();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.key = reader.bytes();
                    break;
                case 2:
                    message.proof = $705dca31272f1c70$exports.Proof.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            key: (0, $d5e07fe2518aae94$exports.isSet)(object.key) ? (0, $d5e07fe2518aae94$exports.bytesFromBase64)(object.key) : new Uint8Array(),
            proof: (0, $d5e07fe2518aae94$exports.isSet)(object.proof) ? $705dca31272f1c70$exports.Proof.fromJSON(object.proof) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.key !== undefined && (obj.key = (0, $d5e07fe2518aae94$exports.base64FromBytes)(message.key !== undefined ? message.key : new Uint8Array()));
        message.proof !== undefined && (obj.proof = message.proof ? $705dca31272f1c70$exports.Proof.toJSON(message.proof) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $705dca31272f1c70$var$createBaseValueOp();
        message.key = object.key ?? new Uint8Array();
        message.proof = object.proof !== undefined && object.proof !== null ? $705dca31272f1c70$exports.Proof.fromPartial(object.proof) : undefined;
        return message;
    }
};
function $705dca31272f1c70$var$createBaseDominoOp() {
    return {
        key: "",
        input: "",
        output: ""
    };
}
$705dca31272f1c70$exports.DominoOp = {
    encode (message, writer = $705dca31272f1c70$var$_m0.Writer.create()) {
        if (message.key !== "") writer.uint32(10).string(message.key);
        if (message.input !== "") writer.uint32(18).string(message.input);
        if (message.output !== "") writer.uint32(26).string(message.output);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $705dca31272f1c70$var$_m0.Reader ? input : new $705dca31272f1c70$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $705dca31272f1c70$var$createBaseDominoOp();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.key = reader.string();
                    break;
                case 2:
                    message.input = reader.string();
                    break;
                case 3:
                    message.output = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            key: (0, $d5e07fe2518aae94$exports.isSet)(object.key) ? String(object.key) : "",
            input: (0, $d5e07fe2518aae94$exports.isSet)(object.input) ? String(object.input) : "",
            output: (0, $d5e07fe2518aae94$exports.isSet)(object.output) ? String(object.output) : ""
        };
    },
    toJSON (message) {
        const obj = {};
        message.key !== undefined && (obj.key = message.key);
        message.input !== undefined && (obj.input = message.input);
        message.output !== undefined && (obj.output = message.output);
        return obj;
    },
    fromPartial (object) {
        const message = $705dca31272f1c70$var$createBaseDominoOp();
        message.key = object.key ?? "";
        message.input = object.input ?? "";
        message.output = object.output ?? "";
        return message;
    }
};
function $705dca31272f1c70$var$createBaseProofOp() {
    return {
        type: "",
        key: new Uint8Array(),
        data: new Uint8Array()
    };
}
$705dca31272f1c70$exports.ProofOp = {
    encode (message, writer = $705dca31272f1c70$var$_m0.Writer.create()) {
        if (message.type !== "") writer.uint32(10).string(message.type);
        if (message.key.length !== 0) writer.uint32(18).bytes(message.key);
        if (message.data.length !== 0) writer.uint32(26).bytes(message.data);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $705dca31272f1c70$var$_m0.Reader ? input : new $705dca31272f1c70$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $705dca31272f1c70$var$createBaseProofOp();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.type = reader.string();
                    break;
                case 2:
                    message.key = reader.bytes();
                    break;
                case 3:
                    message.data = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            type: (0, $d5e07fe2518aae94$exports.isSet)(object.type) ? String(object.type) : "",
            key: (0, $d5e07fe2518aae94$exports.isSet)(object.key) ? (0, $d5e07fe2518aae94$exports.bytesFromBase64)(object.key) : new Uint8Array(),
            data: (0, $d5e07fe2518aae94$exports.isSet)(object.data) ? (0, $d5e07fe2518aae94$exports.bytesFromBase64)(object.data) : new Uint8Array()
        };
    },
    toJSON (message) {
        const obj = {};
        message.type !== undefined && (obj.type = message.type);
        message.key !== undefined && (obj.key = (0, $d5e07fe2518aae94$exports.base64FromBytes)(message.key !== undefined ? message.key : new Uint8Array()));
        message.data !== undefined && (obj.data = (0, $d5e07fe2518aae94$exports.base64FromBytes)(message.data !== undefined ? message.data : new Uint8Array()));
        return obj;
    },
    fromPartial (object) {
        const message = $705dca31272f1c70$var$createBaseProofOp();
        message.type = object.type ?? "";
        message.key = object.key ?? new Uint8Array();
        message.data = object.data ?? new Uint8Array();
        return message;
    }
};
function $705dca31272f1c70$var$createBaseProofOps() {
    return {
        ops: []
    };
}
$705dca31272f1c70$exports.ProofOps = {
    encode (message, writer = $705dca31272f1c70$var$_m0.Writer.create()) {
        for (const v of message.ops)$705dca31272f1c70$exports.ProofOp.encode(v, writer.uint32(10).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $705dca31272f1c70$var$_m0.Reader ? input : new $705dca31272f1c70$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $705dca31272f1c70$var$createBaseProofOps();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.ops.push($705dca31272f1c70$exports.ProofOp.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            ops: Array.isArray(object?.ops) ? object.ops.map((e)=>$705dca31272f1c70$exports.ProofOp.fromJSON(e)) : []
        };
    },
    toJSON (message) {
        const obj = {};
        if (message.ops) obj.ops = message.ops.map((e)=>e ? $705dca31272f1c70$exports.ProofOp.toJSON(e) : undefined);
        else obj.ops = [];
        return obj;
    },
    fromPartial (object) {
        const message = $705dca31272f1c70$var$createBaseProofOps();
        message.ops = object.ops?.map((e)=>$705dca31272f1c70$exports.ProofOp.fromPartial(e)) || [];
        return message;
    }
};


var $0b4e5611992ea593$exports = {};
"use strict";
var $0b4e5611992ea593$var$__createBinding = $0b4e5611992ea593$exports && $0b4e5611992ea593$exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $0b4e5611992ea593$var$__setModuleDefault = $0b4e5611992ea593$exports && $0b4e5611992ea593$exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $0b4e5611992ea593$var$__importStar = $0b4e5611992ea593$exports && $0b4e5611992ea593$exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $0b4e5611992ea593$var$__createBinding(result, mod, k);
    }
    $0b4e5611992ea593$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty($0b4e5611992ea593$exports, "__esModule", {
    value: true
});
$0b4e5611992ea593$exports.Consensus = $0b4e5611992ea593$exports.App = $0b4e5611992ea593$exports.protobufPackage = void 0;


const $0b4e5611992ea593$var$_m0 = $0b4e5611992ea593$var$__importStar((parcelRequire("fQBv0")));
$0b4e5611992ea593$exports.protobufPackage = "tendermint.version";
function $0b4e5611992ea593$var$createBaseApp() {
    return {
        protocol: $d5e07fe2518aae94$exports.Long.UZERO,
        software: ""
    };
}
$0b4e5611992ea593$exports.App = {
    encode (message, writer = $0b4e5611992ea593$var$_m0.Writer.create()) {
        if (!message.protocol.isZero()) writer.uint32(8).uint64(message.protocol);
        if (message.software !== "") writer.uint32(18).string(message.software);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $0b4e5611992ea593$var$_m0.Reader ? input : new $0b4e5611992ea593$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $0b4e5611992ea593$var$createBaseApp();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.protocol = reader.uint64();
                    break;
                case 2:
                    message.software = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            protocol: (0, $d5e07fe2518aae94$exports.isSet)(object.protocol) ? $d5e07fe2518aae94$exports.Long.fromValue(object.protocol) : $d5e07fe2518aae94$exports.Long.UZERO,
            software: (0, $d5e07fe2518aae94$exports.isSet)(object.software) ? String(object.software) : ""
        };
    },
    toJSON (message) {
        const obj = {};
        message.protocol !== undefined && (obj.protocol = (message.protocol || $d5e07fe2518aae94$exports.Long.UZERO).toString());
        message.software !== undefined && (obj.software = message.software);
        return obj;
    },
    fromPartial (object) {
        const message = $0b4e5611992ea593$var$createBaseApp();
        message.protocol = object.protocol !== undefined && object.protocol !== null ? $d5e07fe2518aae94$exports.Long.fromValue(object.protocol) : $d5e07fe2518aae94$exports.Long.UZERO;
        message.software = object.software ?? "";
        return message;
    }
};
function $0b4e5611992ea593$var$createBaseConsensus() {
    return {
        block: $d5e07fe2518aae94$exports.Long.UZERO,
        app: $d5e07fe2518aae94$exports.Long.UZERO
    };
}
$0b4e5611992ea593$exports.Consensus = {
    encode (message, writer = $0b4e5611992ea593$var$_m0.Writer.create()) {
        if (!message.block.isZero()) writer.uint32(8).uint64(message.block);
        if (!message.app.isZero()) writer.uint32(16).uint64(message.app);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $0b4e5611992ea593$var$_m0.Reader ? input : new $0b4e5611992ea593$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $0b4e5611992ea593$var$createBaseConsensus();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.block = reader.uint64();
                    break;
                case 2:
                    message.app = reader.uint64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            block: (0, $d5e07fe2518aae94$exports.isSet)(object.block) ? $d5e07fe2518aae94$exports.Long.fromValue(object.block) : $d5e07fe2518aae94$exports.Long.UZERO,
            app: (0, $d5e07fe2518aae94$exports.isSet)(object.app) ? $d5e07fe2518aae94$exports.Long.fromValue(object.app) : $d5e07fe2518aae94$exports.Long.UZERO
        };
    },
    toJSON (message) {
        const obj = {};
        message.block !== undefined && (obj.block = (message.block || $d5e07fe2518aae94$exports.Long.UZERO).toString());
        message.app !== undefined && (obj.app = (message.app || $d5e07fe2518aae94$exports.Long.UZERO).toString());
        return obj;
    },
    fromPartial (object) {
        const message = $0b4e5611992ea593$var$createBaseConsensus();
        message.block = object.block !== undefined && object.block !== null ? $d5e07fe2518aae94$exports.Long.fromValue(object.block) : $d5e07fe2518aae94$exports.Long.UZERO;
        message.app = object.app !== undefined && object.app !== null ? $d5e07fe2518aae94$exports.Long.fromValue(object.app) : $d5e07fe2518aae94$exports.Long.UZERO;
        return message;
    }
};



var $4715d952d1c6c017$exports = {};
"use strict";
var $4715d952d1c6c017$var$__createBinding = $4715d952d1c6c017$exports && $4715d952d1c6c017$exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $4715d952d1c6c017$var$__setModuleDefault = $4715d952d1c6c017$exports && $4715d952d1c6c017$exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $4715d952d1c6c017$var$__importStar = $4715d952d1c6c017$exports && $4715d952d1c6c017$exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $4715d952d1c6c017$var$__createBinding(result, mod, k);
    }
    $4715d952d1c6c017$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty($4715d952d1c6c017$exports, "__esModule", {
    value: true
});
$4715d952d1c6c017$exports.SimpleValidator = $4715d952d1c6c017$exports.Validator = $4715d952d1c6c017$exports.ValidatorSet = $4715d952d1c6c017$exports.protobufPackage = void 0;
var $0f072fab6e1713a0$exports = {};
"use strict";
var $0f072fab6e1713a0$var$__createBinding = $0f072fab6e1713a0$exports && $0f072fab6e1713a0$exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $0f072fab6e1713a0$var$__setModuleDefault = $0f072fab6e1713a0$exports && $0f072fab6e1713a0$exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $0f072fab6e1713a0$var$__importStar = $0f072fab6e1713a0$exports && $0f072fab6e1713a0$exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $0f072fab6e1713a0$var$__createBinding(result, mod, k);
    }
    $0f072fab6e1713a0$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty($0f072fab6e1713a0$exports, "__esModule", {
    value: true
});
$0f072fab6e1713a0$exports.PublicKey = $0f072fab6e1713a0$exports.protobufPackage = void 0;

/* eslint-disable */ const $0f072fab6e1713a0$var$_m0 = $0f072fab6e1713a0$var$__importStar((parcelRequire("fQBv0")));

$0f072fab6e1713a0$exports.protobufPackage = "tendermint.crypto";
function $0f072fab6e1713a0$var$createBasePublicKey() {
    return {
        ed25519: undefined,
        secp256k1: undefined
    };
}
$0f072fab6e1713a0$exports.PublicKey = {
    encode (message, writer = $0f072fab6e1713a0$var$_m0.Writer.create()) {
        if (message.ed25519 !== undefined) writer.uint32(10).bytes(message.ed25519);
        if (message.secp256k1 !== undefined) writer.uint32(18).bytes(message.secp256k1);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $0f072fab6e1713a0$var$_m0.Reader ? input : new $0f072fab6e1713a0$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $0f072fab6e1713a0$var$createBasePublicKey();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.ed25519 = reader.bytes();
                    break;
                case 2:
                    message.secp256k1 = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            ed25519: (0, $d5e07fe2518aae94$exports.isSet)(object.ed25519) ? (0, $d5e07fe2518aae94$exports.bytesFromBase64)(object.ed25519) : undefined,
            secp256k1: (0, $d5e07fe2518aae94$exports.isSet)(object.secp256k1) ? (0, $d5e07fe2518aae94$exports.bytesFromBase64)(object.secp256k1) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.ed25519 !== undefined && (obj.ed25519 = message.ed25519 !== undefined ? (0, $d5e07fe2518aae94$exports.base64FromBytes)(message.ed25519) : undefined);
        message.secp256k1 !== undefined && (obj.secp256k1 = message.secp256k1 !== undefined ? (0, $d5e07fe2518aae94$exports.base64FromBytes)(message.secp256k1) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $0f072fab6e1713a0$var$createBasePublicKey();
        message.ed25519 = object.ed25519 ?? undefined;
        message.secp256k1 = object.secp256k1 ?? undefined;
        return message;
    }
};




const $4715d952d1c6c017$var$_m0 = $4715d952d1c6c017$var$__importStar((parcelRequire("fQBv0")));
$4715d952d1c6c017$exports.protobufPackage = "tendermint.types";
function $4715d952d1c6c017$var$createBaseValidatorSet() {
    return {
        validators: [],
        proposer: undefined,
        totalVotingPower: $d5e07fe2518aae94$exports.Long.ZERO
    };
}
$4715d952d1c6c017$exports.ValidatorSet = {
    encode (message, writer = $4715d952d1c6c017$var$_m0.Writer.create()) {
        for (const v of message.validators)$4715d952d1c6c017$exports.Validator.encode(v, writer.uint32(10).fork()).ldelim();
        if (message.proposer !== undefined) $4715d952d1c6c017$exports.Validator.encode(message.proposer, writer.uint32(18).fork()).ldelim();
        if (!message.totalVotingPower.isZero()) writer.uint32(24).int64(message.totalVotingPower);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $4715d952d1c6c017$var$_m0.Reader ? input : new $4715d952d1c6c017$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $4715d952d1c6c017$var$createBaseValidatorSet();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.validators.push($4715d952d1c6c017$exports.Validator.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.proposer = $4715d952d1c6c017$exports.Validator.decode(reader, reader.uint32());
                    break;
                case 3:
                    message.totalVotingPower = reader.int64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            validators: Array.isArray(object?.validators) ? object.validators.map((e)=>$4715d952d1c6c017$exports.Validator.fromJSON(e)) : [],
            proposer: (0, $d5e07fe2518aae94$exports.isSet)(object.proposer) ? $4715d952d1c6c017$exports.Validator.fromJSON(object.proposer) : undefined,
            totalVotingPower: (0, $d5e07fe2518aae94$exports.isSet)(object.totalVotingPower) ? $d5e07fe2518aae94$exports.Long.fromValue(object.totalVotingPower) : $d5e07fe2518aae94$exports.Long.ZERO
        };
    },
    toJSON (message) {
        const obj = {};
        if (message.validators) obj.validators = message.validators.map((e)=>e ? $4715d952d1c6c017$exports.Validator.toJSON(e) : undefined);
        else obj.validators = [];
        message.proposer !== undefined && (obj.proposer = message.proposer ? $4715d952d1c6c017$exports.Validator.toJSON(message.proposer) : undefined);
        message.totalVotingPower !== undefined && (obj.totalVotingPower = (message.totalVotingPower || $d5e07fe2518aae94$exports.Long.ZERO).toString());
        return obj;
    },
    fromPartial (object) {
        const message = $4715d952d1c6c017$var$createBaseValidatorSet();
        message.validators = object.validators?.map((e)=>$4715d952d1c6c017$exports.Validator.fromPartial(e)) || [];
        message.proposer = object.proposer !== undefined && object.proposer !== null ? $4715d952d1c6c017$exports.Validator.fromPartial(object.proposer) : undefined;
        message.totalVotingPower = object.totalVotingPower !== undefined && object.totalVotingPower !== null ? $d5e07fe2518aae94$exports.Long.fromValue(object.totalVotingPower) : $d5e07fe2518aae94$exports.Long.ZERO;
        return message;
    }
};
function $4715d952d1c6c017$var$createBaseValidator() {
    return {
        address: new Uint8Array(),
        pubKey: undefined,
        votingPower: $d5e07fe2518aae94$exports.Long.ZERO,
        proposerPriority: $d5e07fe2518aae94$exports.Long.ZERO
    };
}
$4715d952d1c6c017$exports.Validator = {
    encode (message, writer = $4715d952d1c6c017$var$_m0.Writer.create()) {
        if (message.address.length !== 0) writer.uint32(10).bytes(message.address);
        if (message.pubKey !== undefined) $0f072fab6e1713a0$exports.PublicKey.encode(message.pubKey, writer.uint32(18).fork()).ldelim();
        if (!message.votingPower.isZero()) writer.uint32(24).int64(message.votingPower);
        if (!message.proposerPriority.isZero()) writer.uint32(32).int64(message.proposerPriority);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $4715d952d1c6c017$var$_m0.Reader ? input : new $4715d952d1c6c017$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $4715d952d1c6c017$var$createBaseValidator();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.address = reader.bytes();
                    break;
                case 2:
                    message.pubKey = $0f072fab6e1713a0$exports.PublicKey.decode(reader, reader.uint32());
                    break;
                case 3:
                    message.votingPower = reader.int64();
                    break;
                case 4:
                    message.proposerPriority = reader.int64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            address: (0, $d5e07fe2518aae94$exports.isSet)(object.address) ? (0, $d5e07fe2518aae94$exports.bytesFromBase64)(object.address) : new Uint8Array(),
            pubKey: (0, $d5e07fe2518aae94$exports.isSet)(object.pubKey) ? $0f072fab6e1713a0$exports.PublicKey.fromJSON(object.pubKey) : undefined,
            votingPower: (0, $d5e07fe2518aae94$exports.isSet)(object.votingPower) ? $d5e07fe2518aae94$exports.Long.fromValue(object.votingPower) : $d5e07fe2518aae94$exports.Long.ZERO,
            proposerPriority: (0, $d5e07fe2518aae94$exports.isSet)(object.proposerPriority) ? $d5e07fe2518aae94$exports.Long.fromValue(object.proposerPriority) : $d5e07fe2518aae94$exports.Long.ZERO
        };
    },
    toJSON (message) {
        const obj = {};
        message.address !== undefined && (obj.address = (0, $d5e07fe2518aae94$exports.base64FromBytes)(message.address !== undefined ? message.address : new Uint8Array()));
        message.pubKey !== undefined && (obj.pubKey = message.pubKey ? $0f072fab6e1713a0$exports.PublicKey.toJSON(message.pubKey) : undefined);
        message.votingPower !== undefined && (obj.votingPower = (message.votingPower || $d5e07fe2518aae94$exports.Long.ZERO).toString());
        message.proposerPriority !== undefined && (obj.proposerPriority = (message.proposerPriority || $d5e07fe2518aae94$exports.Long.ZERO).toString());
        return obj;
    },
    fromPartial (object) {
        const message = $4715d952d1c6c017$var$createBaseValidator();
        message.address = object.address ?? new Uint8Array();
        message.pubKey = object.pubKey !== undefined && object.pubKey !== null ? $0f072fab6e1713a0$exports.PublicKey.fromPartial(object.pubKey) : undefined;
        message.votingPower = object.votingPower !== undefined && object.votingPower !== null ? $d5e07fe2518aae94$exports.Long.fromValue(object.votingPower) : $d5e07fe2518aae94$exports.Long.ZERO;
        message.proposerPriority = object.proposerPriority !== undefined && object.proposerPriority !== null ? $d5e07fe2518aae94$exports.Long.fromValue(object.proposerPriority) : $d5e07fe2518aae94$exports.Long.ZERO;
        return message;
    }
};
function $4715d952d1c6c017$var$createBaseSimpleValidator() {
    return {
        pubKey: undefined,
        votingPower: $d5e07fe2518aae94$exports.Long.ZERO
    };
}
$4715d952d1c6c017$exports.SimpleValidator = {
    encode (message, writer = $4715d952d1c6c017$var$_m0.Writer.create()) {
        if (message.pubKey !== undefined) $0f072fab6e1713a0$exports.PublicKey.encode(message.pubKey, writer.uint32(10).fork()).ldelim();
        if (!message.votingPower.isZero()) writer.uint32(16).int64(message.votingPower);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $4715d952d1c6c017$var$_m0.Reader ? input : new $4715d952d1c6c017$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $4715d952d1c6c017$var$createBaseSimpleValidator();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.pubKey = $0f072fab6e1713a0$exports.PublicKey.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.votingPower = reader.int64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            pubKey: (0, $d5e07fe2518aae94$exports.isSet)(object.pubKey) ? $0f072fab6e1713a0$exports.PublicKey.fromJSON(object.pubKey) : undefined,
            votingPower: (0, $d5e07fe2518aae94$exports.isSet)(object.votingPower) ? $d5e07fe2518aae94$exports.Long.fromValue(object.votingPower) : $d5e07fe2518aae94$exports.Long.ZERO
        };
    },
    toJSON (message) {
        const obj = {};
        message.pubKey !== undefined && (obj.pubKey = message.pubKey ? $0f072fab6e1713a0$exports.PublicKey.toJSON(message.pubKey) : undefined);
        message.votingPower !== undefined && (obj.votingPower = (message.votingPower || $d5e07fe2518aae94$exports.Long.ZERO).toString());
        return obj;
    },
    fromPartial (object) {
        const message = $4715d952d1c6c017$var$createBaseSimpleValidator();
        message.pubKey = object.pubKey !== undefined && object.pubKey !== null ? $0f072fab6e1713a0$exports.PublicKey.fromPartial(object.pubKey) : undefined;
        message.votingPower = object.votingPower !== undefined && object.votingPower !== null ? $d5e07fe2518aae94$exports.Long.fromValue(object.votingPower) : $d5e07fe2518aae94$exports.Long.ZERO;
        return message;
    }
};




const $c51af120eef1efed$var$_m0 = $c51af120eef1efed$var$__importStar((parcelRequire("fQBv0")));
$c51af120eef1efed$exports.protobufPackage = "tendermint.types";
/** BlockIdFlag indicates which BlcokID the signature is for */ var $c51af120eef1efed$var$BlockIDFlag;
(function(BlockIDFlag) {
    BlockIDFlag[BlockIDFlag["BLOCK_ID_FLAG_UNKNOWN"] = 0] = "BLOCK_ID_FLAG_UNKNOWN";
    BlockIDFlag[BlockIDFlag["BLOCK_ID_FLAG_ABSENT"] = 1] = "BLOCK_ID_FLAG_ABSENT";
    BlockIDFlag[BlockIDFlag["BLOCK_ID_FLAG_COMMIT"] = 2] = "BLOCK_ID_FLAG_COMMIT";
    BlockIDFlag[BlockIDFlag["BLOCK_ID_FLAG_NIL"] = 3] = "BLOCK_ID_FLAG_NIL";
    BlockIDFlag[BlockIDFlag["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})($c51af120eef1efed$var$BlockIDFlag = $c51af120eef1efed$exports.BlockIDFlag || ($c51af120eef1efed$exports.BlockIDFlag = {}));
function $c51af120eef1efed$var$blockIDFlagFromJSON(object) {
    switch(object){
        case 0:
        case "BLOCK_ID_FLAG_UNKNOWN":
            return $c51af120eef1efed$var$BlockIDFlag.BLOCK_ID_FLAG_UNKNOWN;
        case 1:
        case "BLOCK_ID_FLAG_ABSENT":
            return $c51af120eef1efed$var$BlockIDFlag.BLOCK_ID_FLAG_ABSENT;
        case 2:
        case "BLOCK_ID_FLAG_COMMIT":
            return $c51af120eef1efed$var$BlockIDFlag.BLOCK_ID_FLAG_COMMIT;
        case 3:
        case "BLOCK_ID_FLAG_NIL":
            return $c51af120eef1efed$var$BlockIDFlag.BLOCK_ID_FLAG_NIL;
        case -1:
        case "UNRECOGNIZED":
        default:
            return $c51af120eef1efed$var$BlockIDFlag.UNRECOGNIZED;
    }
}
$c51af120eef1efed$exports.blockIDFlagFromJSON = $c51af120eef1efed$var$blockIDFlagFromJSON;
function $c51af120eef1efed$var$blockIDFlagToJSON(object) {
    switch(object){
        case $c51af120eef1efed$var$BlockIDFlag.BLOCK_ID_FLAG_UNKNOWN:
            return "BLOCK_ID_FLAG_UNKNOWN";
        case $c51af120eef1efed$var$BlockIDFlag.BLOCK_ID_FLAG_ABSENT:
            return "BLOCK_ID_FLAG_ABSENT";
        case $c51af120eef1efed$var$BlockIDFlag.BLOCK_ID_FLAG_COMMIT:
            return "BLOCK_ID_FLAG_COMMIT";
        case $c51af120eef1efed$var$BlockIDFlag.BLOCK_ID_FLAG_NIL:
            return "BLOCK_ID_FLAG_NIL";
        case $c51af120eef1efed$var$BlockIDFlag.UNRECOGNIZED:
        default:
            return "UNRECOGNIZED";
    }
}
$c51af120eef1efed$exports.blockIDFlagToJSON = $c51af120eef1efed$var$blockIDFlagToJSON;
/** SignedMsgType is a type of signed message in the consensus. */ var $c51af120eef1efed$var$SignedMsgType;
(function(SignedMsgType) {
    SignedMsgType[SignedMsgType["SIGNED_MSG_TYPE_UNKNOWN"] = 0] = "SIGNED_MSG_TYPE_UNKNOWN";
    /** SIGNED_MSG_TYPE_PREVOTE - Votes */ SignedMsgType[SignedMsgType["SIGNED_MSG_TYPE_PREVOTE"] = 1] = "SIGNED_MSG_TYPE_PREVOTE";
    SignedMsgType[SignedMsgType["SIGNED_MSG_TYPE_PRECOMMIT"] = 2] = "SIGNED_MSG_TYPE_PRECOMMIT";
    /** SIGNED_MSG_TYPE_PROPOSAL - Proposals */ SignedMsgType[SignedMsgType["SIGNED_MSG_TYPE_PROPOSAL"] = 32] = "SIGNED_MSG_TYPE_PROPOSAL";
    SignedMsgType[SignedMsgType["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})($c51af120eef1efed$var$SignedMsgType = $c51af120eef1efed$exports.SignedMsgType || ($c51af120eef1efed$exports.SignedMsgType = {}));
function $c51af120eef1efed$var$signedMsgTypeFromJSON(object) {
    switch(object){
        case 0:
        case "SIGNED_MSG_TYPE_UNKNOWN":
            return $c51af120eef1efed$var$SignedMsgType.SIGNED_MSG_TYPE_UNKNOWN;
        case 1:
        case "SIGNED_MSG_TYPE_PREVOTE":
            return $c51af120eef1efed$var$SignedMsgType.SIGNED_MSG_TYPE_PREVOTE;
        case 2:
        case "SIGNED_MSG_TYPE_PRECOMMIT":
            return $c51af120eef1efed$var$SignedMsgType.SIGNED_MSG_TYPE_PRECOMMIT;
        case 32:
        case "SIGNED_MSG_TYPE_PROPOSAL":
            return $c51af120eef1efed$var$SignedMsgType.SIGNED_MSG_TYPE_PROPOSAL;
        case -1:
        case "UNRECOGNIZED":
        default:
            return $c51af120eef1efed$var$SignedMsgType.UNRECOGNIZED;
    }
}
$c51af120eef1efed$exports.signedMsgTypeFromJSON = $c51af120eef1efed$var$signedMsgTypeFromJSON;
function $c51af120eef1efed$var$signedMsgTypeToJSON(object) {
    switch(object){
        case $c51af120eef1efed$var$SignedMsgType.SIGNED_MSG_TYPE_UNKNOWN:
            return "SIGNED_MSG_TYPE_UNKNOWN";
        case $c51af120eef1efed$var$SignedMsgType.SIGNED_MSG_TYPE_PREVOTE:
            return "SIGNED_MSG_TYPE_PREVOTE";
        case $c51af120eef1efed$var$SignedMsgType.SIGNED_MSG_TYPE_PRECOMMIT:
            return "SIGNED_MSG_TYPE_PRECOMMIT";
        case $c51af120eef1efed$var$SignedMsgType.SIGNED_MSG_TYPE_PROPOSAL:
            return "SIGNED_MSG_TYPE_PROPOSAL";
        case $c51af120eef1efed$var$SignedMsgType.UNRECOGNIZED:
        default:
            return "UNRECOGNIZED";
    }
}
$c51af120eef1efed$exports.signedMsgTypeToJSON = $c51af120eef1efed$var$signedMsgTypeToJSON;
function $c51af120eef1efed$var$createBasePartSetHeader() {
    return {
        total: 0,
        hash: new Uint8Array()
    };
}
$c51af120eef1efed$exports.PartSetHeader = {
    encode (message, writer = $c51af120eef1efed$var$_m0.Writer.create()) {
        if (message.total !== 0) writer.uint32(8).uint32(message.total);
        if (message.hash.length !== 0) writer.uint32(18).bytes(message.hash);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $c51af120eef1efed$var$_m0.Reader ? input : new $c51af120eef1efed$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $c51af120eef1efed$var$createBasePartSetHeader();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.total = reader.uint32();
                    break;
                case 2:
                    message.hash = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            total: (0, $d5e07fe2518aae94$exports.isSet)(object.total) ? Number(object.total) : 0,
            hash: (0, $d5e07fe2518aae94$exports.isSet)(object.hash) ? (0, $d5e07fe2518aae94$exports.bytesFromBase64)(object.hash) : new Uint8Array()
        };
    },
    toJSON (message) {
        const obj = {};
        message.total !== undefined && (obj.total = Math.round(message.total));
        message.hash !== undefined && (obj.hash = (0, $d5e07fe2518aae94$exports.base64FromBytes)(message.hash !== undefined ? message.hash : new Uint8Array()));
        return obj;
    },
    fromPartial (object) {
        const message = $c51af120eef1efed$var$createBasePartSetHeader();
        message.total = object.total ?? 0;
        message.hash = object.hash ?? new Uint8Array();
        return message;
    }
};
function $c51af120eef1efed$var$createBasePart() {
    return {
        index: 0,
        bytes: new Uint8Array(),
        proof: undefined
    };
}
$c51af120eef1efed$exports.Part = {
    encode (message, writer = $c51af120eef1efed$var$_m0.Writer.create()) {
        if (message.index !== 0) writer.uint32(8).uint32(message.index);
        if (message.bytes.length !== 0) writer.uint32(18).bytes(message.bytes);
        if (message.proof !== undefined) $705dca31272f1c70$exports.Proof.encode(message.proof, writer.uint32(26).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $c51af120eef1efed$var$_m0.Reader ? input : new $c51af120eef1efed$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $c51af120eef1efed$var$createBasePart();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.index = reader.uint32();
                    break;
                case 2:
                    message.bytes = reader.bytes();
                    break;
                case 3:
                    message.proof = $705dca31272f1c70$exports.Proof.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            index: (0, $d5e07fe2518aae94$exports.isSet)(object.index) ? Number(object.index) : 0,
            bytes: (0, $d5e07fe2518aae94$exports.isSet)(object.bytes) ? (0, $d5e07fe2518aae94$exports.bytesFromBase64)(object.bytes) : new Uint8Array(),
            proof: (0, $d5e07fe2518aae94$exports.isSet)(object.proof) ? $705dca31272f1c70$exports.Proof.fromJSON(object.proof) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.index !== undefined && (obj.index = Math.round(message.index));
        message.bytes !== undefined && (obj.bytes = (0, $d5e07fe2518aae94$exports.base64FromBytes)(message.bytes !== undefined ? message.bytes : new Uint8Array()));
        message.proof !== undefined && (obj.proof = message.proof ? $705dca31272f1c70$exports.Proof.toJSON(message.proof) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $c51af120eef1efed$var$createBasePart();
        message.index = object.index ?? 0;
        message.bytes = object.bytes ?? new Uint8Array();
        message.proof = object.proof !== undefined && object.proof !== null ? $705dca31272f1c70$exports.Proof.fromPartial(object.proof) : undefined;
        return message;
    }
};
function $c51af120eef1efed$var$createBaseBlockID() {
    return {
        hash: new Uint8Array(),
        partSetHeader: undefined
    };
}
$c51af120eef1efed$exports.BlockID = {
    encode (message, writer = $c51af120eef1efed$var$_m0.Writer.create()) {
        if (message.hash.length !== 0) writer.uint32(10).bytes(message.hash);
        if (message.partSetHeader !== undefined) $c51af120eef1efed$exports.PartSetHeader.encode(message.partSetHeader, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $c51af120eef1efed$var$_m0.Reader ? input : new $c51af120eef1efed$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $c51af120eef1efed$var$createBaseBlockID();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.hash = reader.bytes();
                    break;
                case 2:
                    message.partSetHeader = $c51af120eef1efed$exports.PartSetHeader.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            hash: (0, $d5e07fe2518aae94$exports.isSet)(object.hash) ? (0, $d5e07fe2518aae94$exports.bytesFromBase64)(object.hash) : new Uint8Array(),
            partSetHeader: (0, $d5e07fe2518aae94$exports.isSet)(object.partSetHeader) ? $c51af120eef1efed$exports.PartSetHeader.fromJSON(object.partSetHeader) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.hash !== undefined && (obj.hash = (0, $d5e07fe2518aae94$exports.base64FromBytes)(message.hash !== undefined ? message.hash : new Uint8Array()));
        message.partSetHeader !== undefined && (obj.partSetHeader = message.partSetHeader ? $c51af120eef1efed$exports.PartSetHeader.toJSON(message.partSetHeader) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $c51af120eef1efed$var$createBaseBlockID();
        message.hash = object.hash ?? new Uint8Array();
        message.partSetHeader = object.partSetHeader !== undefined && object.partSetHeader !== null ? $c51af120eef1efed$exports.PartSetHeader.fromPartial(object.partSetHeader) : undefined;
        return message;
    }
};
function $c51af120eef1efed$var$createBaseHeader() {
    return {
        version: undefined,
        chainId: "",
        height: $d5e07fe2518aae94$exports.Long.ZERO,
        time: undefined,
        lastBlockId: undefined,
        lastCommitHash: new Uint8Array(),
        dataHash: new Uint8Array(),
        validatorsHash: new Uint8Array(),
        nextValidatorsHash: new Uint8Array(),
        consensusHash: new Uint8Array(),
        appHash: new Uint8Array(),
        lastResultsHash: new Uint8Array(),
        evidenceHash: new Uint8Array(),
        proposerAddress: new Uint8Array()
    };
}
$c51af120eef1efed$exports.Header = {
    encode (message, writer = $c51af120eef1efed$var$_m0.Writer.create()) {
        if (message.version !== undefined) $0b4e5611992ea593$exports.Consensus.encode(message.version, writer.uint32(10).fork()).ldelim();
        if (message.chainId !== "") writer.uint32(18).string(message.chainId);
        if (!message.height.isZero()) writer.uint32(24).int64(message.height);
        if (message.time !== undefined) $e7eaeedc85b414fc$exports.Timestamp.encode(message.time, writer.uint32(34).fork()).ldelim();
        if (message.lastBlockId !== undefined) $c51af120eef1efed$exports.BlockID.encode(message.lastBlockId, writer.uint32(42).fork()).ldelim();
        if (message.lastCommitHash.length !== 0) writer.uint32(50).bytes(message.lastCommitHash);
        if (message.dataHash.length !== 0) writer.uint32(58).bytes(message.dataHash);
        if (message.validatorsHash.length !== 0) writer.uint32(66).bytes(message.validatorsHash);
        if (message.nextValidatorsHash.length !== 0) writer.uint32(74).bytes(message.nextValidatorsHash);
        if (message.consensusHash.length !== 0) writer.uint32(82).bytes(message.consensusHash);
        if (message.appHash.length !== 0) writer.uint32(90).bytes(message.appHash);
        if (message.lastResultsHash.length !== 0) writer.uint32(98).bytes(message.lastResultsHash);
        if (message.evidenceHash.length !== 0) writer.uint32(106).bytes(message.evidenceHash);
        if (message.proposerAddress.length !== 0) writer.uint32(114).bytes(message.proposerAddress);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $c51af120eef1efed$var$_m0.Reader ? input : new $c51af120eef1efed$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $c51af120eef1efed$var$createBaseHeader();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.version = $0b4e5611992ea593$exports.Consensus.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.chainId = reader.string();
                    break;
                case 3:
                    message.height = reader.int64();
                    break;
                case 4:
                    message.time = $e7eaeedc85b414fc$exports.Timestamp.decode(reader, reader.uint32());
                    break;
                case 5:
                    message.lastBlockId = $c51af120eef1efed$exports.BlockID.decode(reader, reader.uint32());
                    break;
                case 6:
                    message.lastCommitHash = reader.bytes();
                    break;
                case 7:
                    message.dataHash = reader.bytes();
                    break;
                case 8:
                    message.validatorsHash = reader.bytes();
                    break;
                case 9:
                    message.nextValidatorsHash = reader.bytes();
                    break;
                case 10:
                    message.consensusHash = reader.bytes();
                    break;
                case 11:
                    message.appHash = reader.bytes();
                    break;
                case 12:
                    message.lastResultsHash = reader.bytes();
                    break;
                case 13:
                    message.evidenceHash = reader.bytes();
                    break;
                case 14:
                    message.proposerAddress = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            version: (0, $d5e07fe2518aae94$exports.isSet)(object.version) ? $0b4e5611992ea593$exports.Consensus.fromJSON(object.version) : undefined,
            chainId: (0, $d5e07fe2518aae94$exports.isSet)(object.chainId) ? String(object.chainId) : "",
            height: (0, $d5e07fe2518aae94$exports.isSet)(object.height) ? $d5e07fe2518aae94$exports.Long.fromValue(object.height) : $d5e07fe2518aae94$exports.Long.ZERO,
            time: (0, $d5e07fe2518aae94$exports.isSet)(object.time) ? (0, $d5e07fe2518aae94$exports.fromJsonTimestamp)(object.time) : undefined,
            lastBlockId: (0, $d5e07fe2518aae94$exports.isSet)(object.lastBlockId) ? $c51af120eef1efed$exports.BlockID.fromJSON(object.lastBlockId) : undefined,
            lastCommitHash: (0, $d5e07fe2518aae94$exports.isSet)(object.lastCommitHash) ? (0, $d5e07fe2518aae94$exports.bytesFromBase64)(object.lastCommitHash) : new Uint8Array(),
            dataHash: (0, $d5e07fe2518aae94$exports.isSet)(object.dataHash) ? (0, $d5e07fe2518aae94$exports.bytesFromBase64)(object.dataHash) : new Uint8Array(),
            validatorsHash: (0, $d5e07fe2518aae94$exports.isSet)(object.validatorsHash) ? (0, $d5e07fe2518aae94$exports.bytesFromBase64)(object.validatorsHash) : new Uint8Array(),
            nextValidatorsHash: (0, $d5e07fe2518aae94$exports.isSet)(object.nextValidatorsHash) ? (0, $d5e07fe2518aae94$exports.bytesFromBase64)(object.nextValidatorsHash) : new Uint8Array(),
            consensusHash: (0, $d5e07fe2518aae94$exports.isSet)(object.consensusHash) ? (0, $d5e07fe2518aae94$exports.bytesFromBase64)(object.consensusHash) : new Uint8Array(),
            appHash: (0, $d5e07fe2518aae94$exports.isSet)(object.appHash) ? (0, $d5e07fe2518aae94$exports.bytesFromBase64)(object.appHash) : new Uint8Array(),
            lastResultsHash: (0, $d5e07fe2518aae94$exports.isSet)(object.lastResultsHash) ? (0, $d5e07fe2518aae94$exports.bytesFromBase64)(object.lastResultsHash) : new Uint8Array(),
            evidenceHash: (0, $d5e07fe2518aae94$exports.isSet)(object.evidenceHash) ? (0, $d5e07fe2518aae94$exports.bytesFromBase64)(object.evidenceHash) : new Uint8Array(),
            proposerAddress: (0, $d5e07fe2518aae94$exports.isSet)(object.proposerAddress) ? (0, $d5e07fe2518aae94$exports.bytesFromBase64)(object.proposerAddress) : new Uint8Array()
        };
    },
    toJSON (message) {
        const obj = {};
        message.version !== undefined && (obj.version = message.version ? $0b4e5611992ea593$exports.Consensus.toJSON(message.version) : undefined);
        message.chainId !== undefined && (obj.chainId = message.chainId);
        message.height !== undefined && (obj.height = (message.height || $d5e07fe2518aae94$exports.Long.ZERO).toString());
        message.time !== undefined && (obj.time = (0, $d5e07fe2518aae94$exports.fromTimestamp)(message.time).toISOString());
        message.lastBlockId !== undefined && (obj.lastBlockId = message.lastBlockId ? $c51af120eef1efed$exports.BlockID.toJSON(message.lastBlockId) : undefined);
        message.lastCommitHash !== undefined && (obj.lastCommitHash = (0, $d5e07fe2518aae94$exports.base64FromBytes)(message.lastCommitHash !== undefined ? message.lastCommitHash : new Uint8Array()));
        message.dataHash !== undefined && (obj.dataHash = (0, $d5e07fe2518aae94$exports.base64FromBytes)(message.dataHash !== undefined ? message.dataHash : new Uint8Array()));
        message.validatorsHash !== undefined && (obj.validatorsHash = (0, $d5e07fe2518aae94$exports.base64FromBytes)(message.validatorsHash !== undefined ? message.validatorsHash : new Uint8Array()));
        message.nextValidatorsHash !== undefined && (obj.nextValidatorsHash = (0, $d5e07fe2518aae94$exports.base64FromBytes)(message.nextValidatorsHash !== undefined ? message.nextValidatorsHash : new Uint8Array()));
        message.consensusHash !== undefined && (obj.consensusHash = (0, $d5e07fe2518aae94$exports.base64FromBytes)(message.consensusHash !== undefined ? message.consensusHash : new Uint8Array()));
        message.appHash !== undefined && (obj.appHash = (0, $d5e07fe2518aae94$exports.base64FromBytes)(message.appHash !== undefined ? message.appHash : new Uint8Array()));
        message.lastResultsHash !== undefined && (obj.lastResultsHash = (0, $d5e07fe2518aae94$exports.base64FromBytes)(message.lastResultsHash !== undefined ? message.lastResultsHash : new Uint8Array()));
        message.evidenceHash !== undefined && (obj.evidenceHash = (0, $d5e07fe2518aae94$exports.base64FromBytes)(message.evidenceHash !== undefined ? message.evidenceHash : new Uint8Array()));
        message.proposerAddress !== undefined && (obj.proposerAddress = (0, $d5e07fe2518aae94$exports.base64FromBytes)(message.proposerAddress !== undefined ? message.proposerAddress : new Uint8Array()));
        return obj;
    },
    fromPartial (object) {
        const message = $c51af120eef1efed$var$createBaseHeader();
        message.version = object.version !== undefined && object.version !== null ? $0b4e5611992ea593$exports.Consensus.fromPartial(object.version) : undefined;
        message.chainId = object.chainId ?? "";
        message.height = object.height !== undefined && object.height !== null ? $d5e07fe2518aae94$exports.Long.fromValue(object.height) : $d5e07fe2518aae94$exports.Long.ZERO;
        message.time = object.time !== undefined && object.time !== null ? $e7eaeedc85b414fc$exports.Timestamp.fromPartial(object.time) : undefined;
        message.lastBlockId = object.lastBlockId !== undefined && object.lastBlockId !== null ? $c51af120eef1efed$exports.BlockID.fromPartial(object.lastBlockId) : undefined;
        message.lastCommitHash = object.lastCommitHash ?? new Uint8Array();
        message.dataHash = object.dataHash ?? new Uint8Array();
        message.validatorsHash = object.validatorsHash ?? new Uint8Array();
        message.nextValidatorsHash = object.nextValidatorsHash ?? new Uint8Array();
        message.consensusHash = object.consensusHash ?? new Uint8Array();
        message.appHash = object.appHash ?? new Uint8Array();
        message.lastResultsHash = object.lastResultsHash ?? new Uint8Array();
        message.evidenceHash = object.evidenceHash ?? new Uint8Array();
        message.proposerAddress = object.proposerAddress ?? new Uint8Array();
        return message;
    }
};
function $c51af120eef1efed$var$createBaseData() {
    return {
        txs: []
    };
}
$c51af120eef1efed$exports.Data = {
    encode (message, writer = $c51af120eef1efed$var$_m0.Writer.create()) {
        for (const v of message.txs)writer.uint32(10).bytes(v);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $c51af120eef1efed$var$_m0.Reader ? input : new $c51af120eef1efed$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $c51af120eef1efed$var$createBaseData();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.txs.push(reader.bytes());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            txs: Array.isArray(object?.txs) ? object.txs.map((e)=>(0, $d5e07fe2518aae94$exports.bytesFromBase64)(e)) : []
        };
    },
    toJSON (message) {
        const obj = {};
        if (message.txs) obj.txs = message.txs.map((e)=>(0, $d5e07fe2518aae94$exports.base64FromBytes)(e !== undefined ? e : new Uint8Array()));
        else obj.txs = [];
        return obj;
    },
    fromPartial (object) {
        const message = $c51af120eef1efed$var$createBaseData();
        message.txs = object.txs?.map((e)=>e) || [];
        return message;
    }
};
function $c51af120eef1efed$var$createBaseVote() {
    return {
        type: 0,
        height: $d5e07fe2518aae94$exports.Long.ZERO,
        round: 0,
        blockId: undefined,
        timestamp: undefined,
        validatorAddress: new Uint8Array(),
        validatorIndex: 0,
        signature: new Uint8Array()
    };
}
$c51af120eef1efed$exports.Vote = {
    encode (message, writer = $c51af120eef1efed$var$_m0.Writer.create()) {
        if (message.type !== 0) writer.uint32(8).int32(message.type);
        if (!message.height.isZero()) writer.uint32(16).int64(message.height);
        if (message.round !== 0) writer.uint32(24).int32(message.round);
        if (message.blockId !== undefined) $c51af120eef1efed$exports.BlockID.encode(message.blockId, writer.uint32(34).fork()).ldelim();
        if (message.timestamp !== undefined) $e7eaeedc85b414fc$exports.Timestamp.encode(message.timestamp, writer.uint32(42).fork()).ldelim();
        if (message.validatorAddress.length !== 0) writer.uint32(50).bytes(message.validatorAddress);
        if (message.validatorIndex !== 0) writer.uint32(56).int32(message.validatorIndex);
        if (message.signature.length !== 0) writer.uint32(66).bytes(message.signature);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $c51af120eef1efed$var$_m0.Reader ? input : new $c51af120eef1efed$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $c51af120eef1efed$var$createBaseVote();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.type = reader.int32();
                    break;
                case 2:
                    message.height = reader.int64();
                    break;
                case 3:
                    message.round = reader.int32();
                    break;
                case 4:
                    message.blockId = $c51af120eef1efed$exports.BlockID.decode(reader, reader.uint32());
                    break;
                case 5:
                    message.timestamp = $e7eaeedc85b414fc$exports.Timestamp.decode(reader, reader.uint32());
                    break;
                case 6:
                    message.validatorAddress = reader.bytes();
                    break;
                case 7:
                    message.validatorIndex = reader.int32();
                    break;
                case 8:
                    message.signature = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            type: (0, $d5e07fe2518aae94$exports.isSet)(object.type) ? $c51af120eef1efed$var$signedMsgTypeFromJSON(object.type) : 0,
            height: (0, $d5e07fe2518aae94$exports.isSet)(object.height) ? $d5e07fe2518aae94$exports.Long.fromValue(object.height) : $d5e07fe2518aae94$exports.Long.ZERO,
            round: (0, $d5e07fe2518aae94$exports.isSet)(object.round) ? Number(object.round) : 0,
            blockId: (0, $d5e07fe2518aae94$exports.isSet)(object.blockId) ? $c51af120eef1efed$exports.BlockID.fromJSON(object.blockId) : undefined,
            timestamp: (0, $d5e07fe2518aae94$exports.isSet)(object.timestamp) ? (0, $d5e07fe2518aae94$exports.fromJsonTimestamp)(object.timestamp) : undefined,
            validatorAddress: (0, $d5e07fe2518aae94$exports.isSet)(object.validatorAddress) ? (0, $d5e07fe2518aae94$exports.bytesFromBase64)(object.validatorAddress) : new Uint8Array(),
            validatorIndex: (0, $d5e07fe2518aae94$exports.isSet)(object.validatorIndex) ? Number(object.validatorIndex) : 0,
            signature: (0, $d5e07fe2518aae94$exports.isSet)(object.signature) ? (0, $d5e07fe2518aae94$exports.bytesFromBase64)(object.signature) : new Uint8Array()
        };
    },
    toJSON (message) {
        const obj = {};
        message.type !== undefined && (obj.type = $c51af120eef1efed$var$signedMsgTypeToJSON(message.type));
        message.height !== undefined && (obj.height = (message.height || $d5e07fe2518aae94$exports.Long.ZERO).toString());
        message.round !== undefined && (obj.round = Math.round(message.round));
        message.blockId !== undefined && (obj.blockId = message.blockId ? $c51af120eef1efed$exports.BlockID.toJSON(message.blockId) : undefined);
        message.timestamp !== undefined && (obj.timestamp = (0, $d5e07fe2518aae94$exports.fromTimestamp)(message.timestamp).toISOString());
        message.validatorAddress !== undefined && (obj.validatorAddress = (0, $d5e07fe2518aae94$exports.base64FromBytes)(message.validatorAddress !== undefined ? message.validatorAddress : new Uint8Array()));
        message.validatorIndex !== undefined && (obj.validatorIndex = Math.round(message.validatorIndex));
        message.signature !== undefined && (obj.signature = (0, $d5e07fe2518aae94$exports.base64FromBytes)(message.signature !== undefined ? message.signature : new Uint8Array()));
        return obj;
    },
    fromPartial (object) {
        const message = $c51af120eef1efed$var$createBaseVote();
        message.type = object.type ?? 0;
        message.height = object.height !== undefined && object.height !== null ? $d5e07fe2518aae94$exports.Long.fromValue(object.height) : $d5e07fe2518aae94$exports.Long.ZERO;
        message.round = object.round ?? 0;
        message.blockId = object.blockId !== undefined && object.blockId !== null ? $c51af120eef1efed$exports.BlockID.fromPartial(object.blockId) : undefined;
        message.timestamp = object.timestamp !== undefined && object.timestamp !== null ? $e7eaeedc85b414fc$exports.Timestamp.fromPartial(object.timestamp) : undefined;
        message.validatorAddress = object.validatorAddress ?? new Uint8Array();
        message.validatorIndex = object.validatorIndex ?? 0;
        message.signature = object.signature ?? new Uint8Array();
        return message;
    }
};
function $c51af120eef1efed$var$createBaseCommit() {
    return {
        height: $d5e07fe2518aae94$exports.Long.ZERO,
        round: 0,
        blockId: undefined,
        signatures: []
    };
}
$c51af120eef1efed$exports.Commit = {
    encode (message, writer = $c51af120eef1efed$var$_m0.Writer.create()) {
        if (!message.height.isZero()) writer.uint32(8).int64(message.height);
        if (message.round !== 0) writer.uint32(16).int32(message.round);
        if (message.blockId !== undefined) $c51af120eef1efed$exports.BlockID.encode(message.blockId, writer.uint32(26).fork()).ldelim();
        for (const v of message.signatures)$c51af120eef1efed$exports.CommitSig.encode(v, writer.uint32(34).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $c51af120eef1efed$var$_m0.Reader ? input : new $c51af120eef1efed$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $c51af120eef1efed$var$createBaseCommit();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.height = reader.int64();
                    break;
                case 2:
                    message.round = reader.int32();
                    break;
                case 3:
                    message.blockId = $c51af120eef1efed$exports.BlockID.decode(reader, reader.uint32());
                    break;
                case 4:
                    message.signatures.push($c51af120eef1efed$exports.CommitSig.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            height: (0, $d5e07fe2518aae94$exports.isSet)(object.height) ? $d5e07fe2518aae94$exports.Long.fromValue(object.height) : $d5e07fe2518aae94$exports.Long.ZERO,
            round: (0, $d5e07fe2518aae94$exports.isSet)(object.round) ? Number(object.round) : 0,
            blockId: (0, $d5e07fe2518aae94$exports.isSet)(object.blockId) ? $c51af120eef1efed$exports.BlockID.fromJSON(object.blockId) : undefined,
            signatures: Array.isArray(object?.signatures) ? object.signatures.map((e)=>$c51af120eef1efed$exports.CommitSig.fromJSON(e)) : []
        };
    },
    toJSON (message) {
        const obj = {};
        message.height !== undefined && (obj.height = (message.height || $d5e07fe2518aae94$exports.Long.ZERO).toString());
        message.round !== undefined && (obj.round = Math.round(message.round));
        message.blockId !== undefined && (obj.blockId = message.blockId ? $c51af120eef1efed$exports.BlockID.toJSON(message.blockId) : undefined);
        if (message.signatures) obj.signatures = message.signatures.map((e)=>e ? $c51af120eef1efed$exports.CommitSig.toJSON(e) : undefined);
        else obj.signatures = [];
        return obj;
    },
    fromPartial (object) {
        const message = $c51af120eef1efed$var$createBaseCommit();
        message.height = object.height !== undefined && object.height !== null ? $d5e07fe2518aae94$exports.Long.fromValue(object.height) : $d5e07fe2518aae94$exports.Long.ZERO;
        message.round = object.round ?? 0;
        message.blockId = object.blockId !== undefined && object.blockId !== null ? $c51af120eef1efed$exports.BlockID.fromPartial(object.blockId) : undefined;
        message.signatures = object.signatures?.map((e)=>$c51af120eef1efed$exports.CommitSig.fromPartial(e)) || [];
        return message;
    }
};
function $c51af120eef1efed$var$createBaseCommitSig() {
    return {
        blockIdFlag: 0,
        validatorAddress: new Uint8Array(),
        timestamp: undefined,
        signature: new Uint8Array()
    };
}
$c51af120eef1efed$exports.CommitSig = {
    encode (message, writer = $c51af120eef1efed$var$_m0.Writer.create()) {
        if (message.blockIdFlag !== 0) writer.uint32(8).int32(message.blockIdFlag);
        if (message.validatorAddress.length !== 0) writer.uint32(18).bytes(message.validatorAddress);
        if (message.timestamp !== undefined) $e7eaeedc85b414fc$exports.Timestamp.encode(message.timestamp, writer.uint32(26).fork()).ldelim();
        if (message.signature.length !== 0) writer.uint32(34).bytes(message.signature);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $c51af120eef1efed$var$_m0.Reader ? input : new $c51af120eef1efed$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $c51af120eef1efed$var$createBaseCommitSig();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.blockIdFlag = reader.int32();
                    break;
                case 2:
                    message.validatorAddress = reader.bytes();
                    break;
                case 3:
                    message.timestamp = $e7eaeedc85b414fc$exports.Timestamp.decode(reader, reader.uint32());
                    break;
                case 4:
                    message.signature = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            blockIdFlag: (0, $d5e07fe2518aae94$exports.isSet)(object.blockIdFlag) ? $c51af120eef1efed$var$blockIDFlagFromJSON(object.blockIdFlag) : 0,
            validatorAddress: (0, $d5e07fe2518aae94$exports.isSet)(object.validatorAddress) ? (0, $d5e07fe2518aae94$exports.bytesFromBase64)(object.validatorAddress) : new Uint8Array(),
            timestamp: (0, $d5e07fe2518aae94$exports.isSet)(object.timestamp) ? (0, $d5e07fe2518aae94$exports.fromJsonTimestamp)(object.timestamp) : undefined,
            signature: (0, $d5e07fe2518aae94$exports.isSet)(object.signature) ? (0, $d5e07fe2518aae94$exports.bytesFromBase64)(object.signature) : new Uint8Array()
        };
    },
    toJSON (message) {
        const obj = {};
        message.blockIdFlag !== undefined && (obj.blockIdFlag = $c51af120eef1efed$var$blockIDFlagToJSON(message.blockIdFlag));
        message.validatorAddress !== undefined && (obj.validatorAddress = (0, $d5e07fe2518aae94$exports.base64FromBytes)(message.validatorAddress !== undefined ? message.validatorAddress : new Uint8Array()));
        message.timestamp !== undefined && (obj.timestamp = (0, $d5e07fe2518aae94$exports.fromTimestamp)(message.timestamp).toISOString());
        message.signature !== undefined && (obj.signature = (0, $d5e07fe2518aae94$exports.base64FromBytes)(message.signature !== undefined ? message.signature : new Uint8Array()));
        return obj;
    },
    fromPartial (object) {
        const message = $c51af120eef1efed$var$createBaseCommitSig();
        message.blockIdFlag = object.blockIdFlag ?? 0;
        message.validatorAddress = object.validatorAddress ?? new Uint8Array();
        message.timestamp = object.timestamp !== undefined && object.timestamp !== null ? $e7eaeedc85b414fc$exports.Timestamp.fromPartial(object.timestamp) : undefined;
        message.signature = object.signature ?? new Uint8Array();
        return message;
    }
};
function $c51af120eef1efed$var$createBaseProposal() {
    return {
        type: 0,
        height: $d5e07fe2518aae94$exports.Long.ZERO,
        round: 0,
        polRound: 0,
        blockId: undefined,
        timestamp: undefined,
        signature: new Uint8Array()
    };
}
$c51af120eef1efed$exports.Proposal = {
    encode (message, writer = $c51af120eef1efed$var$_m0.Writer.create()) {
        if (message.type !== 0) writer.uint32(8).int32(message.type);
        if (!message.height.isZero()) writer.uint32(16).int64(message.height);
        if (message.round !== 0) writer.uint32(24).int32(message.round);
        if (message.polRound !== 0) writer.uint32(32).int32(message.polRound);
        if (message.blockId !== undefined) $c51af120eef1efed$exports.BlockID.encode(message.blockId, writer.uint32(42).fork()).ldelim();
        if (message.timestamp !== undefined) $e7eaeedc85b414fc$exports.Timestamp.encode(message.timestamp, writer.uint32(50).fork()).ldelim();
        if (message.signature.length !== 0) writer.uint32(58).bytes(message.signature);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $c51af120eef1efed$var$_m0.Reader ? input : new $c51af120eef1efed$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $c51af120eef1efed$var$createBaseProposal();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.type = reader.int32();
                    break;
                case 2:
                    message.height = reader.int64();
                    break;
                case 3:
                    message.round = reader.int32();
                    break;
                case 4:
                    message.polRound = reader.int32();
                    break;
                case 5:
                    message.blockId = $c51af120eef1efed$exports.BlockID.decode(reader, reader.uint32());
                    break;
                case 6:
                    message.timestamp = $e7eaeedc85b414fc$exports.Timestamp.decode(reader, reader.uint32());
                    break;
                case 7:
                    message.signature = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            type: (0, $d5e07fe2518aae94$exports.isSet)(object.type) ? $c51af120eef1efed$var$signedMsgTypeFromJSON(object.type) : 0,
            height: (0, $d5e07fe2518aae94$exports.isSet)(object.height) ? $d5e07fe2518aae94$exports.Long.fromValue(object.height) : $d5e07fe2518aae94$exports.Long.ZERO,
            round: (0, $d5e07fe2518aae94$exports.isSet)(object.round) ? Number(object.round) : 0,
            polRound: (0, $d5e07fe2518aae94$exports.isSet)(object.polRound) ? Number(object.polRound) : 0,
            blockId: (0, $d5e07fe2518aae94$exports.isSet)(object.blockId) ? $c51af120eef1efed$exports.BlockID.fromJSON(object.blockId) : undefined,
            timestamp: (0, $d5e07fe2518aae94$exports.isSet)(object.timestamp) ? (0, $d5e07fe2518aae94$exports.fromJsonTimestamp)(object.timestamp) : undefined,
            signature: (0, $d5e07fe2518aae94$exports.isSet)(object.signature) ? (0, $d5e07fe2518aae94$exports.bytesFromBase64)(object.signature) : new Uint8Array()
        };
    },
    toJSON (message) {
        const obj = {};
        message.type !== undefined && (obj.type = $c51af120eef1efed$var$signedMsgTypeToJSON(message.type));
        message.height !== undefined && (obj.height = (message.height || $d5e07fe2518aae94$exports.Long.ZERO).toString());
        message.round !== undefined && (obj.round = Math.round(message.round));
        message.polRound !== undefined && (obj.polRound = Math.round(message.polRound));
        message.blockId !== undefined && (obj.blockId = message.blockId ? $c51af120eef1efed$exports.BlockID.toJSON(message.blockId) : undefined);
        message.timestamp !== undefined && (obj.timestamp = (0, $d5e07fe2518aae94$exports.fromTimestamp)(message.timestamp).toISOString());
        message.signature !== undefined && (obj.signature = (0, $d5e07fe2518aae94$exports.base64FromBytes)(message.signature !== undefined ? message.signature : new Uint8Array()));
        return obj;
    },
    fromPartial (object) {
        const message = $c51af120eef1efed$var$createBaseProposal();
        message.type = object.type ?? 0;
        message.height = object.height !== undefined && object.height !== null ? $d5e07fe2518aae94$exports.Long.fromValue(object.height) : $d5e07fe2518aae94$exports.Long.ZERO;
        message.round = object.round ?? 0;
        message.polRound = object.polRound ?? 0;
        message.blockId = object.blockId !== undefined && object.blockId !== null ? $c51af120eef1efed$exports.BlockID.fromPartial(object.blockId) : undefined;
        message.timestamp = object.timestamp !== undefined && object.timestamp !== null ? $e7eaeedc85b414fc$exports.Timestamp.fromPartial(object.timestamp) : undefined;
        message.signature = object.signature ?? new Uint8Array();
        return message;
    }
};
function $c51af120eef1efed$var$createBaseSignedHeader() {
    return {
        header: undefined,
        commit: undefined
    };
}
$c51af120eef1efed$exports.SignedHeader = {
    encode (message, writer = $c51af120eef1efed$var$_m0.Writer.create()) {
        if (message.header !== undefined) $c51af120eef1efed$exports.Header.encode(message.header, writer.uint32(10).fork()).ldelim();
        if (message.commit !== undefined) $c51af120eef1efed$exports.Commit.encode(message.commit, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $c51af120eef1efed$var$_m0.Reader ? input : new $c51af120eef1efed$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $c51af120eef1efed$var$createBaseSignedHeader();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.header = $c51af120eef1efed$exports.Header.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.commit = $c51af120eef1efed$exports.Commit.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            header: (0, $d5e07fe2518aae94$exports.isSet)(object.header) ? $c51af120eef1efed$exports.Header.fromJSON(object.header) : undefined,
            commit: (0, $d5e07fe2518aae94$exports.isSet)(object.commit) ? $c51af120eef1efed$exports.Commit.fromJSON(object.commit) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.header !== undefined && (obj.header = message.header ? $c51af120eef1efed$exports.Header.toJSON(message.header) : undefined);
        message.commit !== undefined && (obj.commit = message.commit ? $c51af120eef1efed$exports.Commit.toJSON(message.commit) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $c51af120eef1efed$var$createBaseSignedHeader();
        message.header = object.header !== undefined && object.header !== null ? $c51af120eef1efed$exports.Header.fromPartial(object.header) : undefined;
        message.commit = object.commit !== undefined && object.commit !== null ? $c51af120eef1efed$exports.Commit.fromPartial(object.commit) : undefined;
        return message;
    }
};
function $c51af120eef1efed$var$createBaseLightBlock() {
    return {
        signedHeader: undefined,
        validatorSet: undefined
    };
}
$c51af120eef1efed$exports.LightBlock = {
    encode (message, writer = $c51af120eef1efed$var$_m0.Writer.create()) {
        if (message.signedHeader !== undefined) $c51af120eef1efed$exports.SignedHeader.encode(message.signedHeader, writer.uint32(10).fork()).ldelim();
        if (message.validatorSet !== undefined) $4715d952d1c6c017$exports.ValidatorSet.encode(message.validatorSet, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $c51af120eef1efed$var$_m0.Reader ? input : new $c51af120eef1efed$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $c51af120eef1efed$var$createBaseLightBlock();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.signedHeader = $c51af120eef1efed$exports.SignedHeader.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.validatorSet = $4715d952d1c6c017$exports.ValidatorSet.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            signedHeader: (0, $d5e07fe2518aae94$exports.isSet)(object.signedHeader) ? $c51af120eef1efed$exports.SignedHeader.fromJSON(object.signedHeader) : undefined,
            validatorSet: (0, $d5e07fe2518aae94$exports.isSet)(object.validatorSet) ? $4715d952d1c6c017$exports.ValidatorSet.fromJSON(object.validatorSet) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.signedHeader !== undefined && (obj.signedHeader = message.signedHeader ? $c51af120eef1efed$exports.SignedHeader.toJSON(message.signedHeader) : undefined);
        message.validatorSet !== undefined && (obj.validatorSet = message.validatorSet ? $4715d952d1c6c017$exports.ValidatorSet.toJSON(message.validatorSet) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $c51af120eef1efed$var$createBaseLightBlock();
        message.signedHeader = object.signedHeader !== undefined && object.signedHeader !== null ? $c51af120eef1efed$exports.SignedHeader.fromPartial(object.signedHeader) : undefined;
        message.validatorSet = object.validatorSet !== undefined && object.validatorSet !== null ? $4715d952d1c6c017$exports.ValidatorSet.fromPartial(object.validatorSet) : undefined;
        return message;
    }
};
function $c51af120eef1efed$var$createBaseBlockMeta() {
    return {
        blockId: undefined,
        blockSize: $d5e07fe2518aae94$exports.Long.ZERO,
        header: undefined,
        numTxs: $d5e07fe2518aae94$exports.Long.ZERO
    };
}
$c51af120eef1efed$exports.BlockMeta = {
    encode (message, writer = $c51af120eef1efed$var$_m0.Writer.create()) {
        if (message.blockId !== undefined) $c51af120eef1efed$exports.BlockID.encode(message.blockId, writer.uint32(10).fork()).ldelim();
        if (!message.blockSize.isZero()) writer.uint32(16).int64(message.blockSize);
        if (message.header !== undefined) $c51af120eef1efed$exports.Header.encode(message.header, writer.uint32(26).fork()).ldelim();
        if (!message.numTxs.isZero()) writer.uint32(32).int64(message.numTxs);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $c51af120eef1efed$var$_m0.Reader ? input : new $c51af120eef1efed$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $c51af120eef1efed$var$createBaseBlockMeta();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.blockId = $c51af120eef1efed$exports.BlockID.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.blockSize = reader.int64();
                    break;
                case 3:
                    message.header = $c51af120eef1efed$exports.Header.decode(reader, reader.uint32());
                    break;
                case 4:
                    message.numTxs = reader.int64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            blockId: (0, $d5e07fe2518aae94$exports.isSet)(object.blockId) ? $c51af120eef1efed$exports.BlockID.fromJSON(object.blockId) : undefined,
            blockSize: (0, $d5e07fe2518aae94$exports.isSet)(object.blockSize) ? $d5e07fe2518aae94$exports.Long.fromValue(object.blockSize) : $d5e07fe2518aae94$exports.Long.ZERO,
            header: (0, $d5e07fe2518aae94$exports.isSet)(object.header) ? $c51af120eef1efed$exports.Header.fromJSON(object.header) : undefined,
            numTxs: (0, $d5e07fe2518aae94$exports.isSet)(object.numTxs) ? $d5e07fe2518aae94$exports.Long.fromValue(object.numTxs) : $d5e07fe2518aae94$exports.Long.ZERO
        };
    },
    toJSON (message) {
        const obj = {};
        message.blockId !== undefined && (obj.blockId = message.blockId ? $c51af120eef1efed$exports.BlockID.toJSON(message.blockId) : undefined);
        message.blockSize !== undefined && (obj.blockSize = (message.blockSize || $d5e07fe2518aae94$exports.Long.ZERO).toString());
        message.header !== undefined && (obj.header = message.header ? $c51af120eef1efed$exports.Header.toJSON(message.header) : undefined);
        message.numTxs !== undefined && (obj.numTxs = (message.numTxs || $d5e07fe2518aae94$exports.Long.ZERO).toString());
        return obj;
    },
    fromPartial (object) {
        const message = $c51af120eef1efed$var$createBaseBlockMeta();
        message.blockId = object.blockId !== undefined && object.blockId !== null ? $c51af120eef1efed$exports.BlockID.fromPartial(object.blockId) : undefined;
        message.blockSize = object.blockSize !== undefined && object.blockSize !== null ? $d5e07fe2518aae94$exports.Long.fromValue(object.blockSize) : $d5e07fe2518aae94$exports.Long.ZERO;
        message.header = object.header !== undefined && object.header !== null ? $c51af120eef1efed$exports.Header.fromPartial(object.header) : undefined;
        message.numTxs = object.numTxs !== undefined && object.numTxs !== null ? $d5e07fe2518aae94$exports.Long.fromValue(object.numTxs) : $d5e07fe2518aae94$exports.Long.ZERO;
        return message;
    }
};
function $c51af120eef1efed$var$createBaseTxProof() {
    return {
        rootHash: new Uint8Array(),
        data: new Uint8Array(),
        proof: undefined
    };
}
$c51af120eef1efed$exports.TxProof = {
    encode (message, writer = $c51af120eef1efed$var$_m0.Writer.create()) {
        if (message.rootHash.length !== 0) writer.uint32(10).bytes(message.rootHash);
        if (message.data.length !== 0) writer.uint32(18).bytes(message.data);
        if (message.proof !== undefined) $705dca31272f1c70$exports.Proof.encode(message.proof, writer.uint32(26).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $c51af120eef1efed$var$_m0.Reader ? input : new $c51af120eef1efed$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $c51af120eef1efed$var$createBaseTxProof();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.rootHash = reader.bytes();
                    break;
                case 2:
                    message.data = reader.bytes();
                    break;
                case 3:
                    message.proof = $705dca31272f1c70$exports.Proof.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            rootHash: (0, $d5e07fe2518aae94$exports.isSet)(object.rootHash) ? (0, $d5e07fe2518aae94$exports.bytesFromBase64)(object.rootHash) : new Uint8Array(),
            data: (0, $d5e07fe2518aae94$exports.isSet)(object.data) ? (0, $d5e07fe2518aae94$exports.bytesFromBase64)(object.data) : new Uint8Array(),
            proof: (0, $d5e07fe2518aae94$exports.isSet)(object.proof) ? $705dca31272f1c70$exports.Proof.fromJSON(object.proof) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.rootHash !== undefined && (obj.rootHash = (0, $d5e07fe2518aae94$exports.base64FromBytes)(message.rootHash !== undefined ? message.rootHash : new Uint8Array()));
        message.data !== undefined && (obj.data = (0, $d5e07fe2518aae94$exports.base64FromBytes)(message.data !== undefined ? message.data : new Uint8Array()));
        message.proof !== undefined && (obj.proof = message.proof ? $705dca31272f1c70$exports.Proof.toJSON(message.proof) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $c51af120eef1efed$var$createBaseTxProof();
        message.rootHash = object.rootHash ?? new Uint8Array();
        message.data = object.data ?? new Uint8Array();
        message.proof = object.proof !== undefined && object.proof !== null ? $705dca31272f1c70$exports.Proof.fromPartial(object.proof) : undefined;
        return message;
    }
};





const $26160fa4309ffb51$var$_m0 = $26160fa4309ffb51$var$__importStar((parcelRequire("fQBv0")));
$26160fa4309ffb51$exports.protobufPackage = "ibc.lightclients.tendermint.v1";
function $26160fa4309ffb51$var$createBaseClientState() {
    return {
        chainId: "",
        trustLevel: undefined,
        trustingPeriod: undefined,
        unbondingPeriod: undefined,
        maxClockDrift: undefined,
        frozenHeight: undefined,
        latestHeight: undefined,
        proofSpecs: [],
        upgradePath: [],
        allowUpdateAfterExpiry: false,
        allowUpdateAfterMisbehaviour: false
    };
}
$26160fa4309ffb51$exports.ClientState = {
    encode (message, writer = $26160fa4309ffb51$var$_m0.Writer.create()) {
        if (message.chainId !== "") writer.uint32(10).string(message.chainId);
        if (message.trustLevel !== undefined) $26160fa4309ffb51$exports.Fraction.encode(message.trustLevel, writer.uint32(18).fork()).ldelim();
        if (message.trustingPeriod !== undefined) $fe534fae4538ccbf$exports.Duration.encode(message.trustingPeriod, writer.uint32(26).fork()).ldelim();
        if (message.unbondingPeriod !== undefined) $fe534fae4538ccbf$exports.Duration.encode(message.unbondingPeriod, writer.uint32(34).fork()).ldelim();
        if (message.maxClockDrift !== undefined) $fe534fae4538ccbf$exports.Duration.encode(message.maxClockDrift, writer.uint32(42).fork()).ldelim();
        if (message.frozenHeight !== undefined) $7d28e43a1e22112f$exports.Height.encode(message.frozenHeight, writer.uint32(50).fork()).ldelim();
        if (message.latestHeight !== undefined) $7d28e43a1e22112f$exports.Height.encode(message.latestHeight, writer.uint32(58).fork()).ldelim();
        for (const v of message.proofSpecs)$bd613a5d258cd296$exports.ProofSpec.encode(v, writer.uint32(66).fork()).ldelim();
        for (const v of message.upgradePath)writer.uint32(74).string(v);
        if (message.allowUpdateAfterExpiry === true) writer.uint32(80).bool(message.allowUpdateAfterExpiry);
        if (message.allowUpdateAfterMisbehaviour === true) writer.uint32(88).bool(message.allowUpdateAfterMisbehaviour);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $26160fa4309ffb51$var$_m0.Reader ? input : new $26160fa4309ffb51$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $26160fa4309ffb51$var$createBaseClientState();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.chainId = reader.string();
                    break;
                case 2:
                    message.trustLevel = $26160fa4309ffb51$exports.Fraction.decode(reader, reader.uint32());
                    break;
                case 3:
                    message.trustingPeriod = $fe534fae4538ccbf$exports.Duration.decode(reader, reader.uint32());
                    break;
                case 4:
                    message.unbondingPeriod = $fe534fae4538ccbf$exports.Duration.decode(reader, reader.uint32());
                    break;
                case 5:
                    message.maxClockDrift = $fe534fae4538ccbf$exports.Duration.decode(reader, reader.uint32());
                    break;
                case 6:
                    message.frozenHeight = $7d28e43a1e22112f$exports.Height.decode(reader, reader.uint32());
                    break;
                case 7:
                    message.latestHeight = $7d28e43a1e22112f$exports.Height.decode(reader, reader.uint32());
                    break;
                case 8:
                    message.proofSpecs.push($bd613a5d258cd296$exports.ProofSpec.decode(reader, reader.uint32()));
                    break;
                case 9:
                    message.upgradePath.push(reader.string());
                    break;
                case 10:
                    message.allowUpdateAfterExpiry = reader.bool();
                    break;
                case 11:
                    message.allowUpdateAfterMisbehaviour = reader.bool();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            chainId: (0, $d5e07fe2518aae94$exports.isSet)(object.chainId) ? String(object.chainId) : "",
            trustLevel: (0, $d5e07fe2518aae94$exports.isSet)(object.trustLevel) ? $26160fa4309ffb51$exports.Fraction.fromJSON(object.trustLevel) : undefined,
            trustingPeriod: (0, $d5e07fe2518aae94$exports.isSet)(object.trustingPeriod) ? $fe534fae4538ccbf$exports.Duration.fromJSON(object.trustingPeriod) : undefined,
            unbondingPeriod: (0, $d5e07fe2518aae94$exports.isSet)(object.unbondingPeriod) ? $fe534fae4538ccbf$exports.Duration.fromJSON(object.unbondingPeriod) : undefined,
            maxClockDrift: (0, $d5e07fe2518aae94$exports.isSet)(object.maxClockDrift) ? $fe534fae4538ccbf$exports.Duration.fromJSON(object.maxClockDrift) : undefined,
            frozenHeight: (0, $d5e07fe2518aae94$exports.isSet)(object.frozenHeight) ? $7d28e43a1e22112f$exports.Height.fromJSON(object.frozenHeight) : undefined,
            latestHeight: (0, $d5e07fe2518aae94$exports.isSet)(object.latestHeight) ? $7d28e43a1e22112f$exports.Height.fromJSON(object.latestHeight) : undefined,
            proofSpecs: Array.isArray(object?.proofSpecs) ? object.proofSpecs.map((e)=>$bd613a5d258cd296$exports.ProofSpec.fromJSON(e)) : [],
            upgradePath: Array.isArray(object?.upgradePath) ? object.upgradePath.map((e)=>String(e)) : [],
            allowUpdateAfterExpiry: (0, $d5e07fe2518aae94$exports.isSet)(object.allowUpdateAfterExpiry) ? Boolean(object.allowUpdateAfterExpiry) : false,
            allowUpdateAfterMisbehaviour: (0, $d5e07fe2518aae94$exports.isSet)(object.allowUpdateAfterMisbehaviour) ? Boolean(object.allowUpdateAfterMisbehaviour) : false
        };
    },
    toJSON (message) {
        const obj = {};
        message.chainId !== undefined && (obj.chainId = message.chainId);
        message.trustLevel !== undefined && (obj.trustLevel = message.trustLevel ? $26160fa4309ffb51$exports.Fraction.toJSON(message.trustLevel) : undefined);
        message.trustingPeriod !== undefined && (obj.trustingPeriod = message.trustingPeriod ? $fe534fae4538ccbf$exports.Duration.toJSON(message.trustingPeriod) : undefined);
        message.unbondingPeriod !== undefined && (obj.unbondingPeriod = message.unbondingPeriod ? $fe534fae4538ccbf$exports.Duration.toJSON(message.unbondingPeriod) : undefined);
        message.maxClockDrift !== undefined && (obj.maxClockDrift = message.maxClockDrift ? $fe534fae4538ccbf$exports.Duration.toJSON(message.maxClockDrift) : undefined);
        message.frozenHeight !== undefined && (obj.frozenHeight = message.frozenHeight ? $7d28e43a1e22112f$exports.Height.toJSON(message.frozenHeight) : undefined);
        message.latestHeight !== undefined && (obj.latestHeight = message.latestHeight ? $7d28e43a1e22112f$exports.Height.toJSON(message.latestHeight) : undefined);
        if (message.proofSpecs) obj.proofSpecs = message.proofSpecs.map((e)=>e ? $bd613a5d258cd296$exports.ProofSpec.toJSON(e) : undefined);
        else obj.proofSpecs = [];
        if (message.upgradePath) obj.upgradePath = message.upgradePath.map((e)=>e);
        else obj.upgradePath = [];
        message.allowUpdateAfterExpiry !== undefined && (obj.allowUpdateAfterExpiry = message.allowUpdateAfterExpiry);
        message.allowUpdateAfterMisbehaviour !== undefined && (obj.allowUpdateAfterMisbehaviour = message.allowUpdateAfterMisbehaviour);
        return obj;
    },
    fromPartial (object) {
        const message = $26160fa4309ffb51$var$createBaseClientState();
        message.chainId = object.chainId ?? "";
        message.trustLevel = object.trustLevel !== undefined && object.trustLevel !== null ? $26160fa4309ffb51$exports.Fraction.fromPartial(object.trustLevel) : undefined;
        message.trustingPeriod = object.trustingPeriod !== undefined && object.trustingPeriod !== null ? $fe534fae4538ccbf$exports.Duration.fromPartial(object.trustingPeriod) : undefined;
        message.unbondingPeriod = object.unbondingPeriod !== undefined && object.unbondingPeriod !== null ? $fe534fae4538ccbf$exports.Duration.fromPartial(object.unbondingPeriod) : undefined;
        message.maxClockDrift = object.maxClockDrift !== undefined && object.maxClockDrift !== null ? $fe534fae4538ccbf$exports.Duration.fromPartial(object.maxClockDrift) : undefined;
        message.frozenHeight = object.frozenHeight !== undefined && object.frozenHeight !== null ? $7d28e43a1e22112f$exports.Height.fromPartial(object.frozenHeight) : undefined;
        message.latestHeight = object.latestHeight !== undefined && object.latestHeight !== null ? $7d28e43a1e22112f$exports.Height.fromPartial(object.latestHeight) : undefined;
        message.proofSpecs = object.proofSpecs?.map((e)=>$bd613a5d258cd296$exports.ProofSpec.fromPartial(e)) || [];
        message.upgradePath = object.upgradePath?.map((e)=>e) || [];
        message.allowUpdateAfterExpiry = object.allowUpdateAfterExpiry ?? false;
        message.allowUpdateAfterMisbehaviour = object.allowUpdateAfterMisbehaviour ?? false;
        return message;
    }
};
function $26160fa4309ffb51$var$createBaseConsensusState() {
    return {
        timestamp: undefined,
        root: undefined,
        nextValidatorsHash: new Uint8Array()
    };
}
$26160fa4309ffb51$exports.ConsensusState = {
    encode (message, writer = $26160fa4309ffb51$var$_m0.Writer.create()) {
        if (message.timestamp !== undefined) $e7eaeedc85b414fc$exports.Timestamp.encode(message.timestamp, writer.uint32(10).fork()).ldelim();
        if (message.root !== undefined) $e7e3d90550b1093b$exports.MerkleRoot.encode(message.root, writer.uint32(18).fork()).ldelim();
        if (message.nextValidatorsHash.length !== 0) writer.uint32(26).bytes(message.nextValidatorsHash);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $26160fa4309ffb51$var$_m0.Reader ? input : new $26160fa4309ffb51$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $26160fa4309ffb51$var$createBaseConsensusState();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.timestamp = $e7eaeedc85b414fc$exports.Timestamp.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.root = $e7e3d90550b1093b$exports.MerkleRoot.decode(reader, reader.uint32());
                    break;
                case 3:
                    message.nextValidatorsHash = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            timestamp: (0, $d5e07fe2518aae94$exports.isSet)(object.timestamp) ? (0, $d5e07fe2518aae94$exports.fromJsonTimestamp)(object.timestamp) : undefined,
            root: (0, $d5e07fe2518aae94$exports.isSet)(object.root) ? $e7e3d90550b1093b$exports.MerkleRoot.fromJSON(object.root) : undefined,
            nextValidatorsHash: (0, $d5e07fe2518aae94$exports.isSet)(object.nextValidatorsHash) ? (0, $d5e07fe2518aae94$exports.bytesFromBase64)(object.nextValidatorsHash) : new Uint8Array()
        };
    },
    toJSON (message) {
        const obj = {};
        message.timestamp !== undefined && (obj.timestamp = (0, $d5e07fe2518aae94$exports.fromTimestamp)(message.timestamp).toISOString());
        message.root !== undefined && (obj.root = message.root ? $e7e3d90550b1093b$exports.MerkleRoot.toJSON(message.root) : undefined);
        message.nextValidatorsHash !== undefined && (obj.nextValidatorsHash = (0, $d5e07fe2518aae94$exports.base64FromBytes)(message.nextValidatorsHash !== undefined ? message.nextValidatorsHash : new Uint8Array()));
        return obj;
    },
    fromPartial (object) {
        const message = $26160fa4309ffb51$var$createBaseConsensusState();
        message.timestamp = object.timestamp !== undefined && object.timestamp !== null ? $e7eaeedc85b414fc$exports.Timestamp.fromPartial(object.timestamp) : undefined;
        message.root = object.root !== undefined && object.root !== null ? $e7e3d90550b1093b$exports.MerkleRoot.fromPartial(object.root) : undefined;
        message.nextValidatorsHash = object.nextValidatorsHash ?? new Uint8Array();
        return message;
    }
};
function $26160fa4309ffb51$var$createBaseMisbehaviour() {
    return {
        clientId: "",
        header1: undefined,
        header2: undefined
    };
}
$26160fa4309ffb51$exports.Misbehaviour = {
    encode (message, writer = $26160fa4309ffb51$var$_m0.Writer.create()) {
        if (message.clientId !== "") writer.uint32(10).string(message.clientId);
        if (message.header1 !== undefined) $26160fa4309ffb51$exports.Header.encode(message.header1, writer.uint32(18).fork()).ldelim();
        if (message.header2 !== undefined) $26160fa4309ffb51$exports.Header.encode(message.header2, writer.uint32(26).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $26160fa4309ffb51$var$_m0.Reader ? input : new $26160fa4309ffb51$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $26160fa4309ffb51$var$createBaseMisbehaviour();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.clientId = reader.string();
                    break;
                case 2:
                    message.header1 = $26160fa4309ffb51$exports.Header.decode(reader, reader.uint32());
                    break;
                case 3:
                    message.header2 = $26160fa4309ffb51$exports.Header.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            clientId: (0, $d5e07fe2518aae94$exports.isSet)(object.clientId) ? String(object.clientId) : "",
            header1: (0, $d5e07fe2518aae94$exports.isSet)(object.header1) ? $26160fa4309ffb51$exports.Header.fromJSON(object.header1) : undefined,
            header2: (0, $d5e07fe2518aae94$exports.isSet)(object.header2) ? $26160fa4309ffb51$exports.Header.fromJSON(object.header2) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.clientId !== undefined && (obj.clientId = message.clientId);
        message.header1 !== undefined && (obj.header1 = message.header1 ? $26160fa4309ffb51$exports.Header.toJSON(message.header1) : undefined);
        message.header2 !== undefined && (obj.header2 = message.header2 ? $26160fa4309ffb51$exports.Header.toJSON(message.header2) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $26160fa4309ffb51$var$createBaseMisbehaviour();
        message.clientId = object.clientId ?? "";
        message.header1 = object.header1 !== undefined && object.header1 !== null ? $26160fa4309ffb51$exports.Header.fromPartial(object.header1) : undefined;
        message.header2 = object.header2 !== undefined && object.header2 !== null ? $26160fa4309ffb51$exports.Header.fromPartial(object.header2) : undefined;
        return message;
    }
};
function $26160fa4309ffb51$var$createBaseHeader() {
    return {
        signedHeader: undefined,
        validatorSet: undefined,
        trustedHeight: undefined,
        trustedValidators: undefined
    };
}
$26160fa4309ffb51$exports.Header = {
    encode (message, writer = $26160fa4309ffb51$var$_m0.Writer.create()) {
        if (message.signedHeader !== undefined) $c51af120eef1efed$exports.SignedHeader.encode(message.signedHeader, writer.uint32(10).fork()).ldelim();
        if (message.validatorSet !== undefined) $4715d952d1c6c017$exports.ValidatorSet.encode(message.validatorSet, writer.uint32(18).fork()).ldelim();
        if (message.trustedHeight !== undefined) $7d28e43a1e22112f$exports.Height.encode(message.trustedHeight, writer.uint32(26).fork()).ldelim();
        if (message.trustedValidators !== undefined) $4715d952d1c6c017$exports.ValidatorSet.encode(message.trustedValidators, writer.uint32(34).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $26160fa4309ffb51$var$_m0.Reader ? input : new $26160fa4309ffb51$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $26160fa4309ffb51$var$createBaseHeader();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.signedHeader = $c51af120eef1efed$exports.SignedHeader.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.validatorSet = $4715d952d1c6c017$exports.ValidatorSet.decode(reader, reader.uint32());
                    break;
                case 3:
                    message.trustedHeight = $7d28e43a1e22112f$exports.Height.decode(reader, reader.uint32());
                    break;
                case 4:
                    message.trustedValidators = $4715d952d1c6c017$exports.ValidatorSet.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            signedHeader: (0, $d5e07fe2518aae94$exports.isSet)(object.signedHeader) ? $c51af120eef1efed$exports.SignedHeader.fromJSON(object.signedHeader) : undefined,
            validatorSet: (0, $d5e07fe2518aae94$exports.isSet)(object.validatorSet) ? $4715d952d1c6c017$exports.ValidatorSet.fromJSON(object.validatorSet) : undefined,
            trustedHeight: (0, $d5e07fe2518aae94$exports.isSet)(object.trustedHeight) ? $7d28e43a1e22112f$exports.Height.fromJSON(object.trustedHeight) : undefined,
            trustedValidators: (0, $d5e07fe2518aae94$exports.isSet)(object.trustedValidators) ? $4715d952d1c6c017$exports.ValidatorSet.fromJSON(object.trustedValidators) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.signedHeader !== undefined && (obj.signedHeader = message.signedHeader ? $c51af120eef1efed$exports.SignedHeader.toJSON(message.signedHeader) : undefined);
        message.validatorSet !== undefined && (obj.validatorSet = message.validatorSet ? $4715d952d1c6c017$exports.ValidatorSet.toJSON(message.validatorSet) : undefined);
        message.trustedHeight !== undefined && (obj.trustedHeight = message.trustedHeight ? $7d28e43a1e22112f$exports.Height.toJSON(message.trustedHeight) : undefined);
        message.trustedValidators !== undefined && (obj.trustedValidators = message.trustedValidators ? $4715d952d1c6c017$exports.ValidatorSet.toJSON(message.trustedValidators) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $26160fa4309ffb51$var$createBaseHeader();
        message.signedHeader = object.signedHeader !== undefined && object.signedHeader !== null ? $c51af120eef1efed$exports.SignedHeader.fromPartial(object.signedHeader) : undefined;
        message.validatorSet = object.validatorSet !== undefined && object.validatorSet !== null ? $4715d952d1c6c017$exports.ValidatorSet.fromPartial(object.validatorSet) : undefined;
        message.trustedHeight = object.trustedHeight !== undefined && object.trustedHeight !== null ? $7d28e43a1e22112f$exports.Height.fromPartial(object.trustedHeight) : undefined;
        message.trustedValidators = object.trustedValidators !== undefined && object.trustedValidators !== null ? $4715d952d1c6c017$exports.ValidatorSet.fromPartial(object.trustedValidators) : undefined;
        return message;
    }
};
function $26160fa4309ffb51$var$createBaseFraction() {
    return {
        numerator: $d5e07fe2518aae94$exports.Long.UZERO,
        denominator: $d5e07fe2518aae94$exports.Long.UZERO
    };
}
$26160fa4309ffb51$exports.Fraction = {
    encode (message, writer = $26160fa4309ffb51$var$_m0.Writer.create()) {
        if (!message.numerator.isZero()) writer.uint32(8).uint64(message.numerator);
        if (!message.denominator.isZero()) writer.uint32(16).uint64(message.denominator);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $26160fa4309ffb51$var$_m0.Reader ? input : new $26160fa4309ffb51$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $26160fa4309ffb51$var$createBaseFraction();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.numerator = reader.uint64();
                    break;
                case 2:
                    message.denominator = reader.uint64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            numerator: (0, $d5e07fe2518aae94$exports.isSet)(object.numerator) ? $d5e07fe2518aae94$exports.Long.fromValue(object.numerator) : $d5e07fe2518aae94$exports.Long.UZERO,
            denominator: (0, $d5e07fe2518aae94$exports.isSet)(object.denominator) ? $d5e07fe2518aae94$exports.Long.fromValue(object.denominator) : $d5e07fe2518aae94$exports.Long.UZERO
        };
    },
    toJSON (message) {
        const obj = {};
        message.numerator !== undefined && (obj.numerator = (message.numerator || $d5e07fe2518aae94$exports.Long.UZERO).toString());
        message.denominator !== undefined && (obj.denominator = (message.denominator || $d5e07fe2518aae94$exports.Long.UZERO).toString());
        return obj;
    },
    fromPartial (object) {
        const message = $26160fa4309ffb51$var$createBaseFraction();
        message.numerator = object.numerator !== undefined && object.numerator !== null ? $d5e07fe2518aae94$exports.Long.fromValue(object.numerator) : $d5e07fe2518aae94$exports.Long.UZERO;
        message.denominator = object.denominator !== undefined && object.denominator !== null ? $d5e07fe2518aae94$exports.Long.fromValue(object.denominator) : $d5e07fe2518aae94$exports.Long.UZERO;
        return message;
    }
};



const $d7164694ea2af9e2$var$long_1 = $d7164694ea2af9e2$var$__importDefault((parcelRequire("jRkuS")));

function $d7164694ea2af9e2$var$decodeTendermintClientStateAny(clientState) {
    if (clientState?.typeUrl !== "/ibc.lightclients.tendermint.v1.ClientState") throw new Error(`Unexpected client state type: ${clientState?.typeUrl}`);
    return $26160fa4309ffb51$exports.ClientState.decode(clientState.value);
}
function $d7164694ea2af9e2$var$decodeTendermintConsensusStateAny(clientState) {
    if (clientState?.typeUrl !== "/ibc.lightclients.tendermint.v1.ConsensusState") throw new Error(`Unexpected client state type: ${clientState?.typeUrl}`);
    return $26160fa4309ffb51$exports.ConsensusState.decode(clientState.value);
}
function $d7164694ea2af9e2$var$setupIbcExtension(base) {
    const rpc = (0, $a3959936d2cce854$exports.createProtobufRpcClient)(base);
    // Use these services to get easy typed access to query methods
    // These cannot be used for proof verification
    const channelQueryService = new $8ac3b8b757f7662f$exports.QueryClientImpl(rpc);
    const clientQueryService = new $368c5d14b6acc6e3$exports.QueryClientImpl(rpc);
    const connectionQueryService = new $272eae30937addce$exports.QueryClientImpl(rpc);
    const transferQueryService = new $03f3fe1b5012bca2$exports.QueryClientImpl(rpc);
    return {
        ibc: {
            channel: {
                channel: async (portId, channelId)=>channelQueryService.Channel({
                        portId: portId,
                        channelId: channelId
                    }),
                channels: async (paginationKey)=>channelQueryService.Channels({
                        pagination: (0, $a3959936d2cce854$exports.createPagination)(paginationKey)
                    }),
                allChannels: async ()=>{
                    const channels = [];
                    let response;
                    let key;
                    do {
                        response = await channelQueryService.Channels({
                            pagination: (0, $a3959936d2cce854$exports.createPagination)(key)
                        });
                        channels.push(...response.channels);
                        key = response.pagination?.nextKey;
                    }while (key && key.length);
                    return {
                        channels: channels,
                        height: response.height
                    };
                },
                connectionChannels: async (connection, paginationKey)=>channelQueryService.ConnectionChannels({
                        connection: connection,
                        pagination: (0, $a3959936d2cce854$exports.createPagination)(paginationKey)
                    }),
                allConnectionChannels: async (connection)=>{
                    const channels = [];
                    let response;
                    let key;
                    do {
                        response = await channelQueryService.ConnectionChannels({
                            connection: connection,
                            pagination: (0, $a3959936d2cce854$exports.createPagination)(key)
                        });
                        channels.push(...response.channels);
                        key = response.pagination?.nextKey;
                    }while (key && key.length);
                    return {
                        channels: channels,
                        height: response.height
                    };
                },
                clientState: async (portId, channelId)=>channelQueryService.ChannelClientState({
                        portId: portId,
                        channelId: channelId
                    }),
                consensusState: async (portId, channelId, revisionNumber, revisionHeight)=>channelQueryService.ChannelConsensusState({
                        portId: portId,
                        channelId: channelId,
                        revisionNumber: $d7164694ea2af9e2$var$long_1.default.fromNumber(revisionNumber, true),
                        revisionHeight: $d7164694ea2af9e2$var$long_1.default.fromNumber(revisionHeight, true)
                    }),
                packetCommitment: async (portId, channelId, sequence)=>channelQueryService.PacketCommitment({
                        portId: portId,
                        channelId: channelId,
                        sequence: $d7164694ea2af9e2$var$long_1.default.fromNumber(sequence, true)
                    }),
                packetCommitments: async (portId, channelId, paginationKey)=>channelQueryService.PacketCommitments({
                        channelId: channelId,
                        portId: portId,
                        pagination: (0, $a3959936d2cce854$exports.createPagination)(paginationKey)
                    }),
                allPacketCommitments: async (portId, channelId)=>{
                    const commitments = [];
                    let response;
                    let key;
                    do {
                        response = await channelQueryService.PacketCommitments({
                            channelId: channelId,
                            portId: portId,
                            pagination: (0, $a3959936d2cce854$exports.createPagination)(key)
                        });
                        commitments.push(...response.commitments);
                        key = response.pagination?.nextKey;
                    }while (key && key.length);
                    return {
                        commitments: commitments,
                        height: response.height
                    };
                },
                packetReceipt: async (portId, channelId, sequence)=>channelQueryService.PacketReceipt({
                        portId: portId,
                        channelId: channelId,
                        sequence: $d7164694ea2af9e2$var$long_1.default.fromNumber(sequence, true)
                    }),
                packetAcknowledgement: async (portId, channelId, sequence)=>channelQueryService.PacketAcknowledgement({
                        portId: portId,
                        channelId: channelId,
                        sequence: $d7164694ea2af9e2$var$long_1.default.fromNumber(sequence, true)
                    }),
                packetAcknowledgements: async (portId, channelId, paginationKey)=>{
                    const request = $8ac3b8b757f7662f$exports.QueryPacketAcknowledgementsRequest.fromPartial({
                        portId: portId,
                        channelId: channelId,
                        pagination: (0, $a3959936d2cce854$exports.createPagination)(paginationKey)
                    });
                    return channelQueryService.PacketAcknowledgements(request);
                },
                allPacketAcknowledgements: async (portId, channelId)=>{
                    const acknowledgements = [];
                    let response;
                    let key;
                    do {
                        const request = $8ac3b8b757f7662f$exports.QueryPacketAcknowledgementsRequest.fromPartial({
                            channelId: channelId,
                            portId: portId,
                            pagination: (0, $a3959936d2cce854$exports.createPagination)(key)
                        });
                        response = await channelQueryService.PacketAcknowledgements(request);
                        acknowledgements.push(...response.acknowledgements);
                        key = response.pagination?.nextKey;
                    }while (key && key.length);
                    return {
                        acknowledgements: acknowledgements,
                        height: response.height
                    };
                },
                unreceivedPackets: async (portId, channelId, packetCommitmentSequences)=>channelQueryService.UnreceivedPackets({
                        portId: portId,
                        channelId: channelId,
                        packetCommitmentSequences: packetCommitmentSequences.map((s)=>$d7164694ea2af9e2$var$long_1.default.fromNumber(s, true))
                    }),
                unreceivedAcks: async (portId, channelId, packetAckSequences)=>channelQueryService.UnreceivedAcks({
                        portId: portId,
                        channelId: channelId,
                        packetAckSequences: packetAckSequences.map((s)=>$d7164694ea2af9e2$var$long_1.default.fromNumber(s, true))
                    }),
                nextSequenceReceive: async (portId, channelId)=>channelQueryService.NextSequenceReceive({
                        portId: portId,
                        channelId: channelId
                    })
            },
            client: {
                state: async (clientId)=>clientQueryService.ClientState({
                        clientId: clientId
                    }),
                states: async (paginationKey)=>clientQueryService.ClientStates({
                        pagination: (0, $a3959936d2cce854$exports.createPagination)(paginationKey)
                    }),
                allStates: async ()=>{
                    const clientStates = [];
                    let response;
                    let key;
                    do {
                        response = await clientQueryService.ClientStates({
                            pagination: (0, $a3959936d2cce854$exports.createPagination)(key)
                        });
                        clientStates.push(...response.clientStates);
                        key = response.pagination?.nextKey;
                    }while (key && key.length);
                    return {
                        clientStates: clientStates
                    };
                },
                consensusState: async (clientId, consensusHeight)=>clientQueryService.ConsensusState($368c5d14b6acc6e3$exports.QueryConsensusStateRequest.fromPartial({
                        clientId: clientId,
                        revisionHeight: consensusHeight !== undefined ? $d7164694ea2af9e2$var$long_1.default.fromNumber(consensusHeight, true) : undefined,
                        latestHeight: consensusHeight === undefined
                    })),
                consensusStates: async (clientId, paginationKey)=>clientQueryService.ConsensusStates({
                        clientId: clientId,
                        pagination: (0, $a3959936d2cce854$exports.createPagination)(paginationKey)
                    }),
                allConsensusStates: async (clientId)=>{
                    const consensusStates = [];
                    let response;
                    let key;
                    do {
                        response = await clientQueryService.ConsensusStates({
                            clientId: clientId,
                            pagination: (0, $a3959936d2cce854$exports.createPagination)(key)
                        });
                        consensusStates.push(...response.consensusStates);
                        key = response.pagination?.nextKey;
                    }while (key && key.length);
                    return {
                        consensusStates: consensusStates
                    };
                },
                params: async ()=>clientQueryService.ClientParams({}),
                stateTm: async (clientId)=>{
                    const response = await clientQueryService.ClientState({
                        clientId: clientId
                    });
                    return $d7164694ea2af9e2$var$decodeTendermintClientStateAny(response.clientState);
                },
                statesTm: async (paginationKey)=>{
                    const { clientStates: clientStates } = await clientQueryService.ClientStates({
                        pagination: (0, $a3959936d2cce854$exports.createPagination)(paginationKey)
                    });
                    return clientStates.map(({ clientState: clientState })=>$d7164694ea2af9e2$var$decodeTendermintClientStateAny(clientState));
                },
                allStatesTm: async ()=>{
                    const clientStates = [];
                    let response;
                    let key;
                    do {
                        response = await clientQueryService.ClientStates({
                            pagination: (0, $a3959936d2cce854$exports.createPagination)(key)
                        });
                        clientStates.push(...response.clientStates);
                        key = response.pagination?.nextKey;
                    }while (key && key.length);
                    return clientStates.map(({ clientState: clientState })=>$d7164694ea2af9e2$var$decodeTendermintClientStateAny(clientState));
                },
                consensusStateTm: async (clientId, consensusHeight)=>{
                    const response = await clientQueryService.ConsensusState($368c5d14b6acc6e3$exports.QueryConsensusStateRequest.fromPartial({
                        clientId: clientId,
                        revisionHeight: consensusHeight?.revisionHeight,
                        revisionNumber: consensusHeight?.revisionNumber,
                        latestHeight: consensusHeight === undefined
                    }));
                    return $d7164694ea2af9e2$var$decodeTendermintConsensusStateAny(response.consensusState);
                }
            },
            connection: {
                connection: async (connectionId)=>connectionQueryService.Connection({
                        connectionId: connectionId
                    }),
                connections: async (paginationKey)=>connectionQueryService.Connections({
                        pagination: (0, $a3959936d2cce854$exports.createPagination)(paginationKey)
                    }),
                allConnections: async ()=>{
                    const connections = [];
                    let response;
                    let key;
                    do {
                        response = await connectionQueryService.Connections({
                            pagination: (0, $a3959936d2cce854$exports.createPagination)(key)
                        });
                        connections.push(...response.connections);
                        key = response.pagination?.nextKey;
                    }while (key && key.length);
                    return {
                        connections: connections,
                        height: response.height
                    };
                },
                clientConnections: async (clientId)=>connectionQueryService.ClientConnections({
                        clientId: clientId
                    }),
                clientState: async (connectionId)=>connectionQueryService.ConnectionClientState({
                        connectionId: connectionId
                    }),
                consensusState: async (connectionId, revisionHeight)=>connectionQueryService.ConnectionConsensusState($272eae30937addce$exports.QueryConnectionConsensusStateRequest.fromPartial({
                        connectionId: connectionId,
                        revisionHeight: $d7164694ea2af9e2$var$long_1.default.fromNumber(revisionHeight, true)
                    }))
            },
            transfer: {
                denomTrace: async (hash)=>transferQueryService.DenomTrace({
                        hash: hash
                    }),
                denomTraces: async (paginationKey)=>transferQueryService.DenomTraces({
                        pagination: (0, $a3959936d2cce854$exports.createPagination)(paginationKey)
                    }),
                allDenomTraces: async ()=>{
                    const denomTraces = [];
                    let response;
                    let key;
                    do {
                        response = await transferQueryService.DenomTraces({
                            pagination: (0, $a3959936d2cce854$exports.createPagination)(key)
                        });
                        denomTraces.push(...response.denomTraces);
                        key = response.pagination?.nextKey;
                    }while (key && key.length);
                    return {
                        denomTraces: denomTraces
                    };
                },
                params: async ()=>transferQueryService.Params({})
            },
            verified: {
                channel: {
                    channel: async (portId, channelId)=>{
                        // keeper: https://github.com/cosmos/cosmos-sdk/blob/3bafd8255a502e5a9cee07391cf8261538245dfd/x/ibc/04-channel/keeper/keeper.go#L55-L65
                        // key: https://github.com/cosmos/cosmos-sdk/blob/ef0a7344af345882729598bc2958a21143930a6b/x/ibc/24-host/keys.go#L117-L120
                        const key = (0, $6XcLW.toAscii)(`channelEnds/ports/${portId}/channels/${channelId}`);
                        const { value: value } = await base.queryStoreVerified("ibc", key);
                        return value.length ? $e21f9e7cb16364b7$exports.Channel.decode(value) : null;
                    },
                    packetCommitment: async (portId, channelId, sequence)=>{
                        // keeper: https://github.com/cosmos/cosmos-sdk/blob/3bafd8255a502e5a9cee07391cf8261538245dfd/x/ibc/04-channel/keeper/keeper.go#L128-L133
                        // key: https://github.com/cosmos/cosmos-sdk/blob/ef0a7344af345882729598bc2958a21143930a6b/x/ibc/24-host/keys.go#L183-L185
                        const key = (0, $6XcLW.toAscii)(`commitments/ports/${portId}/channels/${channelId}/packets/${sequence}`);
                        const { value: value } = await base.queryStoreVerified("ibc", key);
                        // keeper code doesn't parse, but returns raw
                        return value;
                    },
                    packetAcknowledgement: async (portId, channelId, sequence)=>{
                        // keeper: https://github.com/cosmos/cosmos-sdk/blob/3bafd8255a502e5a9cee07391cf8261538245dfd/x/ibc/04-channel/keeper/keeper.go#L159-L166
                        // key: https://github.com/cosmos/cosmos-sdk/blob/ef0a7344af345882729598bc2958a21143930a6b/x/ibc/24-host/keys.go#L153-L156
                        const key = (0, $6XcLW.toAscii)(`acks/ports/${portId}/channels/${channelId}/acknowledgements/${sequence}`);
                        const { value: value } = await base.queryStoreVerified("ibc", key);
                        // keeper code doesn't parse, but returns raw
                        return value;
                    },
                    nextSequenceReceive: async (portId, channelId)=>{
                        // keeper: https://github.com/cosmos/cosmos-sdk/blob/3bafd8255a502e5a9cee07391cf8261538245dfd/x/ibc/04-channel/keeper/keeper.go#L92-L101
                        // key: https://github.com/cosmos/cosmos-sdk/blob/ef0a7344af345882729598bc2958a21143930a6b/x/ibc/24-host/keys.go#L133-L136
                        const key = (0, $6XcLW.toAscii)(`seqAcks/ports/${portId}/channels/${channelId}/nextSequenceAck`);
                        const { value: value } = await base.queryStoreVerified("ibc", key);
                        return value.length ? $7UsfE.Uint64.fromBytes(value).toNumber() : null;
                    }
                }
            }
        }
    };
}
$d7164694ea2af9e2$exports.setupIbcExtension = $d7164694ea2af9e2$var$setupIbcExtension;


Object.defineProperty($d0d8b6f4712acd9f$exports, "setupIbcExtension", {
    enumerable: true,
    get: function() {
        return $d7164694ea2af9e2$exports.setupIbcExtension;
    }
});
var $f3b93f0b330ebf07$exports = {};
"use strict";
Object.defineProperty($f3b93f0b330ebf07$exports, "__esModule", {
    value: true
});
$f3b93f0b330ebf07$exports.setupMintExtension = void 0;

var $fZwG5 = parcelRequire("fZwG5");
var $9357730f8e33e60a$exports = {};
"use strict";
var $9357730f8e33e60a$var$__createBinding = $9357730f8e33e60a$exports && $9357730f8e33e60a$exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $9357730f8e33e60a$var$__setModuleDefault = $9357730f8e33e60a$exports && $9357730f8e33e60a$exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $9357730f8e33e60a$var$__importStar = $9357730f8e33e60a$exports && $9357730f8e33e60a$exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $9357730f8e33e60a$var$__createBinding(result, mod, k);
    }
    $9357730f8e33e60a$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty($9357730f8e33e60a$exports, "__esModule", {
    value: true
});
$9357730f8e33e60a$exports.QueryClientImpl = $9357730f8e33e60a$exports.QueryAnnualProvisionsResponse = $9357730f8e33e60a$exports.QueryAnnualProvisionsRequest = $9357730f8e33e60a$exports.QueryInflationResponse = $9357730f8e33e60a$exports.QueryInflationRequest = $9357730f8e33e60a$exports.QueryParamsResponse = $9357730f8e33e60a$exports.QueryParamsRequest = $9357730f8e33e60a$exports.protobufPackage = void 0;
var $cb3ddb0a3111dc7b$exports = {};
"use strict";
var $cb3ddb0a3111dc7b$var$__createBinding = $cb3ddb0a3111dc7b$exports && $cb3ddb0a3111dc7b$exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $cb3ddb0a3111dc7b$var$__setModuleDefault = $cb3ddb0a3111dc7b$exports && $cb3ddb0a3111dc7b$exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $cb3ddb0a3111dc7b$var$__importStar = $cb3ddb0a3111dc7b$exports && $cb3ddb0a3111dc7b$exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $cb3ddb0a3111dc7b$var$__createBinding(result, mod, k);
    }
    $cb3ddb0a3111dc7b$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty($cb3ddb0a3111dc7b$exports, "__esModule", {
    value: true
});
$cb3ddb0a3111dc7b$exports.Params = $cb3ddb0a3111dc7b$exports.Minter = $cb3ddb0a3111dc7b$exports.protobufPackage = void 0;


const $cb3ddb0a3111dc7b$var$_m0 = $cb3ddb0a3111dc7b$var$__importStar((parcelRequire("fQBv0")));
$cb3ddb0a3111dc7b$exports.protobufPackage = "cosmos.mint.v1beta1";
function $cb3ddb0a3111dc7b$var$createBaseMinter() {
    return {
        inflation: "",
        annualProvisions: ""
    };
}
$cb3ddb0a3111dc7b$exports.Minter = {
    encode (message, writer = $cb3ddb0a3111dc7b$var$_m0.Writer.create()) {
        if (message.inflation !== "") writer.uint32(10).string(message.inflation);
        if (message.annualProvisions !== "") writer.uint32(18).string(message.annualProvisions);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $cb3ddb0a3111dc7b$var$_m0.Reader ? input : new $cb3ddb0a3111dc7b$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $cb3ddb0a3111dc7b$var$createBaseMinter();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.inflation = reader.string();
                    break;
                case 2:
                    message.annualProvisions = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            inflation: (0, $d5e07fe2518aae94$exports.isSet)(object.inflation) ? String(object.inflation) : "",
            annualProvisions: (0, $d5e07fe2518aae94$exports.isSet)(object.annualProvisions) ? String(object.annualProvisions) : ""
        };
    },
    toJSON (message) {
        const obj = {};
        message.inflation !== undefined && (obj.inflation = message.inflation);
        message.annualProvisions !== undefined && (obj.annualProvisions = message.annualProvisions);
        return obj;
    },
    fromPartial (object) {
        const message = $cb3ddb0a3111dc7b$var$createBaseMinter();
        message.inflation = object.inflation ?? "";
        message.annualProvisions = object.annualProvisions ?? "";
        return message;
    }
};
function $cb3ddb0a3111dc7b$var$createBaseParams() {
    return {
        mintDenom: "",
        inflationRateChange: "",
        inflationMax: "",
        inflationMin: "",
        goalBonded: "",
        blocksPerYear: $d5e07fe2518aae94$exports.Long.UZERO
    };
}
$cb3ddb0a3111dc7b$exports.Params = {
    encode (message, writer = $cb3ddb0a3111dc7b$var$_m0.Writer.create()) {
        if (message.mintDenom !== "") writer.uint32(10).string(message.mintDenom);
        if (message.inflationRateChange !== "") writer.uint32(18).string(message.inflationRateChange);
        if (message.inflationMax !== "") writer.uint32(26).string(message.inflationMax);
        if (message.inflationMin !== "") writer.uint32(34).string(message.inflationMin);
        if (message.goalBonded !== "") writer.uint32(42).string(message.goalBonded);
        if (!message.blocksPerYear.isZero()) writer.uint32(48).uint64(message.blocksPerYear);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $cb3ddb0a3111dc7b$var$_m0.Reader ? input : new $cb3ddb0a3111dc7b$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $cb3ddb0a3111dc7b$var$createBaseParams();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.mintDenom = reader.string();
                    break;
                case 2:
                    message.inflationRateChange = reader.string();
                    break;
                case 3:
                    message.inflationMax = reader.string();
                    break;
                case 4:
                    message.inflationMin = reader.string();
                    break;
                case 5:
                    message.goalBonded = reader.string();
                    break;
                case 6:
                    message.blocksPerYear = reader.uint64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            mintDenom: (0, $d5e07fe2518aae94$exports.isSet)(object.mintDenom) ? String(object.mintDenom) : "",
            inflationRateChange: (0, $d5e07fe2518aae94$exports.isSet)(object.inflationRateChange) ? String(object.inflationRateChange) : "",
            inflationMax: (0, $d5e07fe2518aae94$exports.isSet)(object.inflationMax) ? String(object.inflationMax) : "",
            inflationMin: (0, $d5e07fe2518aae94$exports.isSet)(object.inflationMin) ? String(object.inflationMin) : "",
            goalBonded: (0, $d5e07fe2518aae94$exports.isSet)(object.goalBonded) ? String(object.goalBonded) : "",
            blocksPerYear: (0, $d5e07fe2518aae94$exports.isSet)(object.blocksPerYear) ? $d5e07fe2518aae94$exports.Long.fromValue(object.blocksPerYear) : $d5e07fe2518aae94$exports.Long.UZERO
        };
    },
    toJSON (message) {
        const obj = {};
        message.mintDenom !== undefined && (obj.mintDenom = message.mintDenom);
        message.inflationRateChange !== undefined && (obj.inflationRateChange = message.inflationRateChange);
        message.inflationMax !== undefined && (obj.inflationMax = message.inflationMax);
        message.inflationMin !== undefined && (obj.inflationMin = message.inflationMin);
        message.goalBonded !== undefined && (obj.goalBonded = message.goalBonded);
        message.blocksPerYear !== undefined && (obj.blocksPerYear = (message.blocksPerYear || $d5e07fe2518aae94$exports.Long.UZERO).toString());
        return obj;
    },
    fromPartial (object) {
        const message = $cb3ddb0a3111dc7b$var$createBaseParams();
        message.mintDenom = object.mintDenom ?? "";
        message.inflationRateChange = object.inflationRateChange ?? "";
        message.inflationMax = object.inflationMax ?? "";
        message.inflationMin = object.inflationMin ?? "";
        message.goalBonded = object.goalBonded ?? "";
        message.blocksPerYear = object.blocksPerYear !== undefined && object.blocksPerYear !== null ? $d5e07fe2518aae94$exports.Long.fromValue(object.blocksPerYear) : $d5e07fe2518aae94$exports.Long.UZERO;
        return message;
    }
};



const $9357730f8e33e60a$var$_m0 = $9357730f8e33e60a$var$__importStar((parcelRequire("fQBv0")));

$9357730f8e33e60a$exports.protobufPackage = "cosmos.mint.v1beta1";
function $9357730f8e33e60a$var$createBaseQueryParamsRequest() {
    return {};
}
$9357730f8e33e60a$exports.QueryParamsRequest = {
    encode (_, writer = $9357730f8e33e60a$var$_m0.Writer.create()) {
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $9357730f8e33e60a$var$_m0.Reader ? input : new $9357730f8e33e60a$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $9357730f8e33e60a$var$createBaseQueryParamsRequest();
        while(reader.pos < end){
            const tag = reader.uint32();
            tag;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON (_) {
        return {};
    },
    toJSON (_) {
        const obj = {};
        return obj;
    },
    fromPartial (_) {
        const message = $9357730f8e33e60a$var$createBaseQueryParamsRequest();
        return message;
    }
};
function $9357730f8e33e60a$var$createBaseQueryParamsResponse() {
    return {
        params: undefined
    };
}
$9357730f8e33e60a$exports.QueryParamsResponse = {
    encode (message, writer = $9357730f8e33e60a$var$_m0.Writer.create()) {
        if (message.params !== undefined) $cb3ddb0a3111dc7b$exports.Params.encode(message.params, writer.uint32(10).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $9357730f8e33e60a$var$_m0.Reader ? input : new $9357730f8e33e60a$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $9357730f8e33e60a$var$createBaseQueryParamsResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.params = $cb3ddb0a3111dc7b$exports.Params.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            params: (0, $d5e07fe2518aae94$exports.isSet)(object.params) ? $cb3ddb0a3111dc7b$exports.Params.fromJSON(object.params) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.params !== undefined && (obj.params = message.params ? $cb3ddb0a3111dc7b$exports.Params.toJSON(message.params) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $9357730f8e33e60a$var$createBaseQueryParamsResponse();
        message.params = object.params !== undefined && object.params !== null ? $cb3ddb0a3111dc7b$exports.Params.fromPartial(object.params) : undefined;
        return message;
    }
};
function $9357730f8e33e60a$var$createBaseQueryInflationRequest() {
    return {};
}
$9357730f8e33e60a$exports.QueryInflationRequest = {
    encode (_, writer = $9357730f8e33e60a$var$_m0.Writer.create()) {
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $9357730f8e33e60a$var$_m0.Reader ? input : new $9357730f8e33e60a$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $9357730f8e33e60a$var$createBaseQueryInflationRequest();
        while(reader.pos < end){
            const tag = reader.uint32();
            tag;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON (_) {
        return {};
    },
    toJSON (_) {
        const obj = {};
        return obj;
    },
    fromPartial (_) {
        const message = $9357730f8e33e60a$var$createBaseQueryInflationRequest();
        return message;
    }
};
function $9357730f8e33e60a$var$createBaseQueryInflationResponse() {
    return {
        inflation: new Uint8Array()
    };
}
$9357730f8e33e60a$exports.QueryInflationResponse = {
    encode (message, writer = $9357730f8e33e60a$var$_m0.Writer.create()) {
        if (message.inflation.length !== 0) writer.uint32(10).bytes(message.inflation);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $9357730f8e33e60a$var$_m0.Reader ? input : new $9357730f8e33e60a$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $9357730f8e33e60a$var$createBaseQueryInflationResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.inflation = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            inflation: (0, $d5e07fe2518aae94$exports.isSet)(object.inflation) ? (0, $d5e07fe2518aae94$exports.bytesFromBase64)(object.inflation) : new Uint8Array()
        };
    },
    toJSON (message) {
        const obj = {};
        message.inflation !== undefined && (obj.inflation = (0, $d5e07fe2518aae94$exports.base64FromBytes)(message.inflation !== undefined ? message.inflation : new Uint8Array()));
        return obj;
    },
    fromPartial (object) {
        const message = $9357730f8e33e60a$var$createBaseQueryInflationResponse();
        message.inflation = object.inflation ?? new Uint8Array();
        return message;
    }
};
function $9357730f8e33e60a$var$createBaseQueryAnnualProvisionsRequest() {
    return {};
}
$9357730f8e33e60a$exports.QueryAnnualProvisionsRequest = {
    encode (_, writer = $9357730f8e33e60a$var$_m0.Writer.create()) {
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $9357730f8e33e60a$var$_m0.Reader ? input : new $9357730f8e33e60a$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $9357730f8e33e60a$var$createBaseQueryAnnualProvisionsRequest();
        while(reader.pos < end){
            const tag = reader.uint32();
            tag;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON (_) {
        return {};
    },
    toJSON (_) {
        const obj = {};
        return obj;
    },
    fromPartial (_) {
        const message = $9357730f8e33e60a$var$createBaseQueryAnnualProvisionsRequest();
        return message;
    }
};
function $9357730f8e33e60a$var$createBaseQueryAnnualProvisionsResponse() {
    return {
        annualProvisions: new Uint8Array()
    };
}
$9357730f8e33e60a$exports.QueryAnnualProvisionsResponse = {
    encode (message, writer = $9357730f8e33e60a$var$_m0.Writer.create()) {
        if (message.annualProvisions.length !== 0) writer.uint32(10).bytes(message.annualProvisions);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $9357730f8e33e60a$var$_m0.Reader ? input : new $9357730f8e33e60a$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $9357730f8e33e60a$var$createBaseQueryAnnualProvisionsResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.annualProvisions = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            annualProvisions: (0, $d5e07fe2518aae94$exports.isSet)(object.annualProvisions) ? (0, $d5e07fe2518aae94$exports.bytesFromBase64)(object.annualProvisions) : new Uint8Array()
        };
    },
    toJSON (message) {
        const obj = {};
        message.annualProvisions !== undefined && (obj.annualProvisions = (0, $d5e07fe2518aae94$exports.base64FromBytes)(message.annualProvisions !== undefined ? message.annualProvisions : new Uint8Array()));
        return obj;
    },
    fromPartial (object) {
        const message = $9357730f8e33e60a$var$createBaseQueryAnnualProvisionsResponse();
        message.annualProvisions = object.annualProvisions ?? new Uint8Array();
        return message;
    }
};
class $9357730f8e33e60a$var$QueryClientImpl {
    constructor(rpc){
        this.rpc = rpc;
        this.Params = this.Params.bind(this);
        this.Inflation = this.Inflation.bind(this);
        this.AnnualProvisions = this.AnnualProvisions.bind(this);
    }
    Params(request = {}) {
        const data = $9357730f8e33e60a$exports.QueryParamsRequest.encode(request).finish();
        const promise = this.rpc.request("cosmos.mint.v1beta1.Query", "Params", data);
        return promise.then((data)=>$9357730f8e33e60a$exports.QueryParamsResponse.decode(new $9357730f8e33e60a$var$_m0.Reader(data)));
    }
    Inflation(request = {}) {
        const data = $9357730f8e33e60a$exports.QueryInflationRequest.encode(request).finish();
        const promise = this.rpc.request("cosmos.mint.v1beta1.Query", "Inflation", data);
        return promise.then((data)=>$9357730f8e33e60a$exports.QueryInflationResponse.decode(new $9357730f8e33e60a$var$_m0.Reader(data)));
    }
    AnnualProvisions(request = {}) {
        const data = $9357730f8e33e60a$exports.QueryAnnualProvisionsRequest.encode(request).finish();
        const promise = this.rpc.request("cosmos.mint.v1beta1.Query", "AnnualProvisions", data);
        return promise.then((data)=>$9357730f8e33e60a$exports.QueryAnnualProvisionsResponse.decode(new $9357730f8e33e60a$var$_m0.Reader(data)));
    }
}
$9357730f8e33e60a$exports.QueryClientImpl = $9357730f8e33e60a$var$QueryClientImpl;



function $f3b93f0b330ebf07$var$setupMintExtension(base) {
    const rpc = (0, $a3959936d2cce854$exports.createProtobufRpcClient)(base);
    // Use this service to get easy typed access to query methods
    // This cannot be used for proof verification
    const queryService = new $9357730f8e33e60a$exports.QueryClientImpl(rpc);
    return {
        mint: {
            params: async ()=>{
                const { params: params } = await queryService.Params({});
                (0, $fZwG5.assert)(params);
                return {
                    blocksPerYear: params.blocksPerYear,
                    goalBonded: (0, $a3959936d2cce854$exports.decodeCosmosSdkDecFromProto)(params.goalBonded),
                    inflationMin: (0, $a3959936d2cce854$exports.decodeCosmosSdkDecFromProto)(params.inflationMin),
                    inflationMax: (0, $a3959936d2cce854$exports.decodeCosmosSdkDecFromProto)(params.inflationMax),
                    inflationRateChange: (0, $a3959936d2cce854$exports.decodeCosmosSdkDecFromProto)(params.inflationRateChange),
                    mintDenom: params.mintDenom
                };
            },
            inflation: async ()=>{
                const { inflation: inflation } = await queryService.Inflation({});
                return (0, $a3959936d2cce854$exports.decodeCosmosSdkDecFromProto)(inflation);
            },
            annualProvisions: async ()=>{
                const { annualProvisions: annualProvisions } = await queryService.AnnualProvisions({});
                return (0, $a3959936d2cce854$exports.decodeCosmosSdkDecFromProto)(annualProvisions);
            }
        }
    };
}
$f3b93f0b330ebf07$exports.setupMintExtension = $f3b93f0b330ebf07$var$setupMintExtension;


Object.defineProperty($d0d8b6f4712acd9f$exports, "setupMintExtension", {
    enumerable: true,
    get: function() {
        return $f3b93f0b330ebf07$exports.setupMintExtension;
    }
});
var $ff94cca0783ba803$exports = {};
"use strict";
Object.defineProperty($ff94cca0783ba803$exports, "__esModule", {
    value: true
});
$ff94cca0783ba803$exports.createSlashingAminoConverters = $ff94cca0783ba803$exports.isAminoMsgUnjail = void 0;
function $ff94cca0783ba803$var$isAminoMsgUnjail(msg) {
    return msg.type === "cosmos-sdk/MsgUnjail";
}
$ff94cca0783ba803$exports.isAminoMsgUnjail = $ff94cca0783ba803$var$isAminoMsgUnjail;
function $ff94cca0783ba803$var$createSlashingAminoConverters() {
    throw new Error("Not implemented");
}
$ff94cca0783ba803$exports.createSlashingAminoConverters = $ff94cca0783ba803$var$createSlashingAminoConverters;


Object.defineProperty($d0d8b6f4712acd9f$exports, "createSlashingAminoConverters", {
    enumerable: true,
    get: function() {
        return $ff94cca0783ba803$exports.createSlashingAminoConverters;
    }
});
Object.defineProperty($d0d8b6f4712acd9f$exports, "isAminoMsgUnjail", {
    enumerable: true,
    get: function() {
        return $ff94cca0783ba803$exports.isAminoMsgUnjail;
    }
});
var $d1438751511f507f$exports = {};
"use strict";
Object.defineProperty($d1438751511f507f$exports, "__esModule", {
    value: true
});
$d1438751511f507f$exports.setupSlashingExtension = void 0;
var $3aef5d592bb6300a$exports = {};
"use strict";
var $3aef5d592bb6300a$var$__createBinding = $3aef5d592bb6300a$exports && $3aef5d592bb6300a$exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $3aef5d592bb6300a$var$__setModuleDefault = $3aef5d592bb6300a$exports && $3aef5d592bb6300a$exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $3aef5d592bb6300a$var$__importStar = $3aef5d592bb6300a$exports && $3aef5d592bb6300a$exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $3aef5d592bb6300a$var$__createBinding(result, mod, k);
    }
    $3aef5d592bb6300a$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty($3aef5d592bb6300a$exports, "__esModule", {
    value: true
});
$3aef5d592bb6300a$exports.QueryClientImpl = $3aef5d592bb6300a$exports.QuerySigningInfosResponse = $3aef5d592bb6300a$exports.QuerySigningInfosRequest = $3aef5d592bb6300a$exports.QuerySigningInfoResponse = $3aef5d592bb6300a$exports.QuerySigningInfoRequest = $3aef5d592bb6300a$exports.QueryParamsResponse = $3aef5d592bb6300a$exports.QueryParamsRequest = $3aef5d592bb6300a$exports.protobufPackage = void 0;

var $d05bcb7e1edae208$exports = {};
"use strict";
var $d05bcb7e1edae208$var$__createBinding = $d05bcb7e1edae208$exports && $d05bcb7e1edae208$exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $d05bcb7e1edae208$var$__setModuleDefault = $d05bcb7e1edae208$exports && $d05bcb7e1edae208$exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $d05bcb7e1edae208$var$__importStar = $d05bcb7e1edae208$exports && $d05bcb7e1edae208$exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $d05bcb7e1edae208$var$__createBinding(result, mod, k);
    }
    $d05bcb7e1edae208$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty($d05bcb7e1edae208$exports, "__esModule", {
    value: true
});
$d05bcb7e1edae208$exports.Params = $d05bcb7e1edae208$exports.ValidatorSigningInfo = $d05bcb7e1edae208$exports.protobufPackage = void 0;




const $d05bcb7e1edae208$var$_m0 = $d05bcb7e1edae208$var$__importStar((parcelRequire("fQBv0")));
$d05bcb7e1edae208$exports.protobufPackage = "cosmos.slashing.v1beta1";
function $d05bcb7e1edae208$var$createBaseValidatorSigningInfo() {
    return {
        address: "",
        startHeight: $d5e07fe2518aae94$exports.Long.ZERO,
        indexOffset: $d5e07fe2518aae94$exports.Long.ZERO,
        jailedUntil: undefined,
        tombstoned: false,
        missedBlocksCounter: $d5e07fe2518aae94$exports.Long.ZERO
    };
}
$d05bcb7e1edae208$exports.ValidatorSigningInfo = {
    encode (message, writer = $d05bcb7e1edae208$var$_m0.Writer.create()) {
        if (message.address !== "") writer.uint32(10).string(message.address);
        if (!message.startHeight.isZero()) writer.uint32(16).int64(message.startHeight);
        if (!message.indexOffset.isZero()) writer.uint32(24).int64(message.indexOffset);
        if (message.jailedUntil !== undefined) $e7eaeedc85b414fc$exports.Timestamp.encode(message.jailedUntil, writer.uint32(34).fork()).ldelim();
        if (message.tombstoned === true) writer.uint32(40).bool(message.tombstoned);
        if (!message.missedBlocksCounter.isZero()) writer.uint32(48).int64(message.missedBlocksCounter);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $d05bcb7e1edae208$var$_m0.Reader ? input : new $d05bcb7e1edae208$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $d05bcb7e1edae208$var$createBaseValidatorSigningInfo();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.address = reader.string();
                    break;
                case 2:
                    message.startHeight = reader.int64();
                    break;
                case 3:
                    message.indexOffset = reader.int64();
                    break;
                case 4:
                    message.jailedUntil = $e7eaeedc85b414fc$exports.Timestamp.decode(reader, reader.uint32());
                    break;
                case 5:
                    message.tombstoned = reader.bool();
                    break;
                case 6:
                    message.missedBlocksCounter = reader.int64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            address: (0, $d5e07fe2518aae94$exports.isSet)(object.address) ? String(object.address) : "",
            startHeight: (0, $d5e07fe2518aae94$exports.isSet)(object.startHeight) ? $d5e07fe2518aae94$exports.Long.fromValue(object.startHeight) : $d5e07fe2518aae94$exports.Long.ZERO,
            indexOffset: (0, $d5e07fe2518aae94$exports.isSet)(object.indexOffset) ? $d5e07fe2518aae94$exports.Long.fromValue(object.indexOffset) : $d5e07fe2518aae94$exports.Long.ZERO,
            jailedUntil: (0, $d5e07fe2518aae94$exports.isSet)(object.jailedUntil) ? (0, $d5e07fe2518aae94$exports.fromJsonTimestamp)(object.jailedUntil) : undefined,
            tombstoned: (0, $d5e07fe2518aae94$exports.isSet)(object.tombstoned) ? Boolean(object.tombstoned) : false,
            missedBlocksCounter: (0, $d5e07fe2518aae94$exports.isSet)(object.missedBlocksCounter) ? $d5e07fe2518aae94$exports.Long.fromValue(object.missedBlocksCounter) : $d5e07fe2518aae94$exports.Long.ZERO
        };
    },
    toJSON (message) {
        const obj = {};
        message.address !== undefined && (obj.address = message.address);
        message.startHeight !== undefined && (obj.startHeight = (message.startHeight || $d5e07fe2518aae94$exports.Long.ZERO).toString());
        message.indexOffset !== undefined && (obj.indexOffset = (message.indexOffset || $d5e07fe2518aae94$exports.Long.ZERO).toString());
        message.jailedUntil !== undefined && (obj.jailedUntil = (0, $d5e07fe2518aae94$exports.fromTimestamp)(message.jailedUntil).toISOString());
        message.tombstoned !== undefined && (obj.tombstoned = message.tombstoned);
        message.missedBlocksCounter !== undefined && (obj.missedBlocksCounter = (message.missedBlocksCounter || $d5e07fe2518aae94$exports.Long.ZERO).toString());
        return obj;
    },
    fromPartial (object) {
        const message = $d05bcb7e1edae208$var$createBaseValidatorSigningInfo();
        message.address = object.address ?? "";
        message.startHeight = object.startHeight !== undefined && object.startHeight !== null ? $d5e07fe2518aae94$exports.Long.fromValue(object.startHeight) : $d5e07fe2518aae94$exports.Long.ZERO;
        message.indexOffset = object.indexOffset !== undefined && object.indexOffset !== null ? $d5e07fe2518aae94$exports.Long.fromValue(object.indexOffset) : $d5e07fe2518aae94$exports.Long.ZERO;
        message.jailedUntil = object.jailedUntil !== undefined && object.jailedUntil !== null ? $e7eaeedc85b414fc$exports.Timestamp.fromPartial(object.jailedUntil) : undefined;
        message.tombstoned = object.tombstoned ?? false;
        message.missedBlocksCounter = object.missedBlocksCounter !== undefined && object.missedBlocksCounter !== null ? $d5e07fe2518aae94$exports.Long.fromValue(object.missedBlocksCounter) : $d5e07fe2518aae94$exports.Long.ZERO;
        return message;
    }
};
function $d05bcb7e1edae208$var$createBaseParams() {
    return {
        signedBlocksWindow: $d5e07fe2518aae94$exports.Long.ZERO,
        minSignedPerWindow: new Uint8Array(),
        downtimeJailDuration: undefined,
        slashFractionDoubleSign: new Uint8Array(),
        slashFractionDowntime: new Uint8Array()
    };
}
$d05bcb7e1edae208$exports.Params = {
    encode (message, writer = $d05bcb7e1edae208$var$_m0.Writer.create()) {
        if (!message.signedBlocksWindow.isZero()) writer.uint32(8).int64(message.signedBlocksWindow);
        if (message.minSignedPerWindow.length !== 0) writer.uint32(18).bytes(message.minSignedPerWindow);
        if (message.downtimeJailDuration !== undefined) $fe534fae4538ccbf$exports.Duration.encode(message.downtimeJailDuration, writer.uint32(26).fork()).ldelim();
        if (message.slashFractionDoubleSign.length !== 0) writer.uint32(34).bytes(message.slashFractionDoubleSign);
        if (message.slashFractionDowntime.length !== 0) writer.uint32(42).bytes(message.slashFractionDowntime);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $d05bcb7e1edae208$var$_m0.Reader ? input : new $d05bcb7e1edae208$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $d05bcb7e1edae208$var$createBaseParams();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.signedBlocksWindow = reader.int64();
                    break;
                case 2:
                    message.minSignedPerWindow = reader.bytes();
                    break;
                case 3:
                    message.downtimeJailDuration = $fe534fae4538ccbf$exports.Duration.decode(reader, reader.uint32());
                    break;
                case 4:
                    message.slashFractionDoubleSign = reader.bytes();
                    break;
                case 5:
                    message.slashFractionDowntime = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            signedBlocksWindow: (0, $d5e07fe2518aae94$exports.isSet)(object.signedBlocksWindow) ? $d5e07fe2518aae94$exports.Long.fromValue(object.signedBlocksWindow) : $d5e07fe2518aae94$exports.Long.ZERO,
            minSignedPerWindow: (0, $d5e07fe2518aae94$exports.isSet)(object.minSignedPerWindow) ? (0, $d5e07fe2518aae94$exports.bytesFromBase64)(object.minSignedPerWindow) : new Uint8Array(),
            downtimeJailDuration: (0, $d5e07fe2518aae94$exports.isSet)(object.downtimeJailDuration) ? $fe534fae4538ccbf$exports.Duration.fromJSON(object.downtimeJailDuration) : undefined,
            slashFractionDoubleSign: (0, $d5e07fe2518aae94$exports.isSet)(object.slashFractionDoubleSign) ? (0, $d5e07fe2518aae94$exports.bytesFromBase64)(object.slashFractionDoubleSign) : new Uint8Array(),
            slashFractionDowntime: (0, $d5e07fe2518aae94$exports.isSet)(object.slashFractionDowntime) ? (0, $d5e07fe2518aae94$exports.bytesFromBase64)(object.slashFractionDowntime) : new Uint8Array()
        };
    },
    toJSON (message) {
        const obj = {};
        message.signedBlocksWindow !== undefined && (obj.signedBlocksWindow = (message.signedBlocksWindow || $d5e07fe2518aae94$exports.Long.ZERO).toString());
        message.minSignedPerWindow !== undefined && (obj.minSignedPerWindow = (0, $d5e07fe2518aae94$exports.base64FromBytes)(message.minSignedPerWindow !== undefined ? message.minSignedPerWindow : new Uint8Array()));
        message.downtimeJailDuration !== undefined && (obj.downtimeJailDuration = message.downtimeJailDuration ? $fe534fae4538ccbf$exports.Duration.toJSON(message.downtimeJailDuration) : undefined);
        message.slashFractionDoubleSign !== undefined && (obj.slashFractionDoubleSign = (0, $d5e07fe2518aae94$exports.base64FromBytes)(message.slashFractionDoubleSign !== undefined ? message.slashFractionDoubleSign : new Uint8Array()));
        message.slashFractionDowntime !== undefined && (obj.slashFractionDowntime = (0, $d5e07fe2518aae94$exports.base64FromBytes)(message.slashFractionDowntime !== undefined ? message.slashFractionDowntime : new Uint8Array()));
        return obj;
    },
    fromPartial (object) {
        const message = $d05bcb7e1edae208$var$createBaseParams();
        message.signedBlocksWindow = object.signedBlocksWindow !== undefined && object.signedBlocksWindow !== null ? $d5e07fe2518aae94$exports.Long.fromValue(object.signedBlocksWindow) : $d5e07fe2518aae94$exports.Long.ZERO;
        message.minSignedPerWindow = object.minSignedPerWindow ?? new Uint8Array();
        message.downtimeJailDuration = object.downtimeJailDuration !== undefined && object.downtimeJailDuration !== null ? $fe534fae4538ccbf$exports.Duration.fromPartial(object.downtimeJailDuration) : undefined;
        message.slashFractionDoubleSign = object.slashFractionDoubleSign ?? new Uint8Array();
        message.slashFractionDowntime = object.slashFractionDowntime ?? new Uint8Array();
        return message;
    }
};



const $3aef5d592bb6300a$var$_m0 = $3aef5d592bb6300a$var$__importStar((parcelRequire("fQBv0")));

$3aef5d592bb6300a$exports.protobufPackage = "cosmos.slashing.v1beta1";
function $3aef5d592bb6300a$var$createBaseQueryParamsRequest() {
    return {};
}
$3aef5d592bb6300a$exports.QueryParamsRequest = {
    encode (_, writer = $3aef5d592bb6300a$var$_m0.Writer.create()) {
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $3aef5d592bb6300a$var$_m0.Reader ? input : new $3aef5d592bb6300a$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $3aef5d592bb6300a$var$createBaseQueryParamsRequest();
        while(reader.pos < end){
            const tag = reader.uint32();
            tag;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON (_) {
        return {};
    },
    toJSON (_) {
        const obj = {};
        return obj;
    },
    fromPartial (_) {
        const message = $3aef5d592bb6300a$var$createBaseQueryParamsRequest();
        return message;
    }
};
function $3aef5d592bb6300a$var$createBaseQueryParamsResponse() {
    return {
        params: undefined
    };
}
$3aef5d592bb6300a$exports.QueryParamsResponse = {
    encode (message, writer = $3aef5d592bb6300a$var$_m0.Writer.create()) {
        if (message.params !== undefined) $d05bcb7e1edae208$exports.Params.encode(message.params, writer.uint32(10).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $3aef5d592bb6300a$var$_m0.Reader ? input : new $3aef5d592bb6300a$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $3aef5d592bb6300a$var$createBaseQueryParamsResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.params = $d05bcb7e1edae208$exports.Params.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            params: (0, $d5e07fe2518aae94$exports.isSet)(object.params) ? $d05bcb7e1edae208$exports.Params.fromJSON(object.params) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.params !== undefined && (obj.params = message.params ? $d05bcb7e1edae208$exports.Params.toJSON(message.params) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $3aef5d592bb6300a$var$createBaseQueryParamsResponse();
        message.params = object.params !== undefined && object.params !== null ? $d05bcb7e1edae208$exports.Params.fromPartial(object.params) : undefined;
        return message;
    }
};
function $3aef5d592bb6300a$var$createBaseQuerySigningInfoRequest() {
    return {
        consAddress: ""
    };
}
$3aef5d592bb6300a$exports.QuerySigningInfoRequest = {
    encode (message, writer = $3aef5d592bb6300a$var$_m0.Writer.create()) {
        if (message.consAddress !== "") writer.uint32(10).string(message.consAddress);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $3aef5d592bb6300a$var$_m0.Reader ? input : new $3aef5d592bb6300a$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $3aef5d592bb6300a$var$createBaseQuerySigningInfoRequest();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.consAddress = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            consAddress: (0, $d5e07fe2518aae94$exports.isSet)(object.consAddress) ? String(object.consAddress) : ""
        };
    },
    toJSON (message) {
        const obj = {};
        message.consAddress !== undefined && (obj.consAddress = message.consAddress);
        return obj;
    },
    fromPartial (object) {
        const message = $3aef5d592bb6300a$var$createBaseQuerySigningInfoRequest();
        message.consAddress = object.consAddress ?? "";
        return message;
    }
};
function $3aef5d592bb6300a$var$createBaseQuerySigningInfoResponse() {
    return {
        valSigningInfo: undefined
    };
}
$3aef5d592bb6300a$exports.QuerySigningInfoResponse = {
    encode (message, writer = $3aef5d592bb6300a$var$_m0.Writer.create()) {
        if (message.valSigningInfo !== undefined) $d05bcb7e1edae208$exports.ValidatorSigningInfo.encode(message.valSigningInfo, writer.uint32(10).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $3aef5d592bb6300a$var$_m0.Reader ? input : new $3aef5d592bb6300a$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $3aef5d592bb6300a$var$createBaseQuerySigningInfoResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.valSigningInfo = $d05bcb7e1edae208$exports.ValidatorSigningInfo.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            valSigningInfo: (0, $d5e07fe2518aae94$exports.isSet)(object.valSigningInfo) ? $d05bcb7e1edae208$exports.ValidatorSigningInfo.fromJSON(object.valSigningInfo) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.valSigningInfo !== undefined && (obj.valSigningInfo = message.valSigningInfo ? $d05bcb7e1edae208$exports.ValidatorSigningInfo.toJSON(message.valSigningInfo) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $3aef5d592bb6300a$var$createBaseQuerySigningInfoResponse();
        message.valSigningInfo = object.valSigningInfo !== undefined && object.valSigningInfo !== null ? $d05bcb7e1edae208$exports.ValidatorSigningInfo.fromPartial(object.valSigningInfo) : undefined;
        return message;
    }
};
function $3aef5d592bb6300a$var$createBaseQuerySigningInfosRequest() {
    return {
        pagination: undefined
    };
}
$3aef5d592bb6300a$exports.QuerySigningInfosRequest = {
    encode (message, writer = $3aef5d592bb6300a$var$_m0.Writer.create()) {
        if (message.pagination !== undefined) $5eae5f3cc99e92ab$exports.PageRequest.encode(message.pagination, writer.uint32(10).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $3aef5d592bb6300a$var$_m0.Reader ? input : new $3aef5d592bb6300a$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $3aef5d592bb6300a$var$createBaseQuerySigningInfosRequest();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.pagination = $5eae5f3cc99e92ab$exports.PageRequest.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            pagination: (0, $d5e07fe2518aae94$exports.isSet)(object.pagination) ? $5eae5f3cc99e92ab$exports.PageRequest.fromJSON(object.pagination) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.pagination !== undefined && (obj.pagination = message.pagination ? $5eae5f3cc99e92ab$exports.PageRequest.toJSON(message.pagination) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $3aef5d592bb6300a$var$createBaseQuerySigningInfosRequest();
        message.pagination = object.pagination !== undefined && object.pagination !== null ? $5eae5f3cc99e92ab$exports.PageRequest.fromPartial(object.pagination) : undefined;
        return message;
    }
};
function $3aef5d592bb6300a$var$createBaseQuerySigningInfosResponse() {
    return {
        info: [],
        pagination: undefined
    };
}
$3aef5d592bb6300a$exports.QuerySigningInfosResponse = {
    encode (message, writer = $3aef5d592bb6300a$var$_m0.Writer.create()) {
        for (const v of message.info)$d05bcb7e1edae208$exports.ValidatorSigningInfo.encode(v, writer.uint32(10).fork()).ldelim();
        if (message.pagination !== undefined) $5eae5f3cc99e92ab$exports.PageResponse.encode(message.pagination, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $3aef5d592bb6300a$var$_m0.Reader ? input : new $3aef5d592bb6300a$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $3aef5d592bb6300a$var$createBaseQuerySigningInfosResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.info.push($d05bcb7e1edae208$exports.ValidatorSigningInfo.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.pagination = $5eae5f3cc99e92ab$exports.PageResponse.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            info: Array.isArray(object?.info) ? object.info.map((e)=>$d05bcb7e1edae208$exports.ValidatorSigningInfo.fromJSON(e)) : [],
            pagination: (0, $d5e07fe2518aae94$exports.isSet)(object.pagination) ? $5eae5f3cc99e92ab$exports.PageResponse.fromJSON(object.pagination) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        if (message.info) obj.info = message.info.map((e)=>e ? $d05bcb7e1edae208$exports.ValidatorSigningInfo.toJSON(e) : undefined);
        else obj.info = [];
        message.pagination !== undefined && (obj.pagination = message.pagination ? $5eae5f3cc99e92ab$exports.PageResponse.toJSON(message.pagination) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $3aef5d592bb6300a$var$createBaseQuerySigningInfosResponse();
        message.info = object.info?.map((e)=>$d05bcb7e1edae208$exports.ValidatorSigningInfo.fromPartial(e)) || [];
        message.pagination = object.pagination !== undefined && object.pagination !== null ? $5eae5f3cc99e92ab$exports.PageResponse.fromPartial(object.pagination) : undefined;
        return message;
    }
};
class $3aef5d592bb6300a$var$QueryClientImpl {
    constructor(rpc){
        this.rpc = rpc;
        this.Params = this.Params.bind(this);
        this.SigningInfo = this.SigningInfo.bind(this);
        this.SigningInfos = this.SigningInfos.bind(this);
    }
    Params(request = {}) {
        const data = $3aef5d592bb6300a$exports.QueryParamsRequest.encode(request).finish();
        const promise = this.rpc.request("cosmos.slashing.v1beta1.Query", "Params", data);
        return promise.then((data)=>$3aef5d592bb6300a$exports.QueryParamsResponse.decode(new $3aef5d592bb6300a$var$_m0.Reader(data)));
    }
    SigningInfo(request) {
        const data = $3aef5d592bb6300a$exports.QuerySigningInfoRequest.encode(request).finish();
        const promise = this.rpc.request("cosmos.slashing.v1beta1.Query", "SigningInfo", data);
        return promise.then((data)=>$3aef5d592bb6300a$exports.QuerySigningInfoResponse.decode(new $3aef5d592bb6300a$var$_m0.Reader(data)));
    }
    SigningInfos(request = {
        pagination: undefined
    }) {
        const data = $3aef5d592bb6300a$exports.QuerySigningInfosRequest.encode(request).finish();
        const promise = this.rpc.request("cosmos.slashing.v1beta1.Query", "SigningInfos", data);
        return promise.then((data)=>$3aef5d592bb6300a$exports.QuerySigningInfosResponse.decode(new $3aef5d592bb6300a$var$_m0.Reader(data)));
    }
}
$3aef5d592bb6300a$exports.QueryClientImpl = $3aef5d592bb6300a$var$QueryClientImpl;



function $d1438751511f507f$var$setupSlashingExtension(base) {
    const rpc = (0, $a3959936d2cce854$exports.createProtobufRpcClient)(base);
    const queryService = new $3aef5d592bb6300a$exports.QueryClientImpl(rpc);
    return {
        slashing: {
            signingInfo: async (consAddress)=>{
                const response = await queryService.SigningInfo({
                    consAddress: consAddress
                });
                return response;
            },
            signingInfos: async (paginationKey)=>{
                const response = await queryService.SigningInfos({
                    pagination: (0, $a3959936d2cce854$exports.createPagination)(paginationKey)
                });
                return response;
            },
            params: async ()=>{
                const response = await queryService.Params({});
                return response;
            }
        }
    };
}
$d1438751511f507f$exports.setupSlashingExtension = $d1438751511f507f$var$setupSlashingExtension;


Object.defineProperty($d0d8b6f4712acd9f$exports, "setupSlashingExtension", {
    enumerable: true,
    get: function() {
        return $d1438751511f507f$exports.setupSlashingExtension;
    }
});
var $4d76f5f9967ab345$exports = {};
"use strict";
Object.defineProperty($4d76f5f9967ab345$exports, "__esModule", {
    value: true
});
$4d76f5f9967ab345$exports.createStakingAminoConverters = $4d76f5f9967ab345$exports.isAminoMsgUndelegate = $4d76f5f9967ab345$exports.isAminoMsgBeginRedelegate = $4d76f5f9967ab345$exports.isAminoMsgDelegate = $4d76f5f9967ab345$exports.isAminoMsgEditValidator = $4d76f5f9967ab345$exports.isAminoMsgCreateValidator = $4d76f5f9967ab345$exports.protoDecimalToJson = void 0;

var $7UsfE = parcelRequire("7UsfE");


var $fZwG5 = parcelRequire("fZwG5");
function $4d76f5f9967ab345$var$protoDecimalToJson(decimal) {
    const parsed = $7UsfE.Decimal.fromAtomics(decimal, 18);
    const [whole, fractional] = parsed.toString().split(".");
    return `${whole}.${(fractional ?? "").padEnd(18, "0")}`;
}
$4d76f5f9967ab345$exports.protoDecimalToJson = $4d76f5f9967ab345$var$protoDecimalToJson;
function $4d76f5f9967ab345$var$jsonDecimalToProto(decimal) {
    const parsed = $7UsfE.Decimal.fromUserInput(decimal, 18);
    return parsed.atomics;
}
function $4d76f5f9967ab345$var$isAminoMsgCreateValidator(msg) {
    return msg.type === "cosmos-sdk/MsgCreateValidator";
}
$4d76f5f9967ab345$exports.isAminoMsgCreateValidator = $4d76f5f9967ab345$var$isAminoMsgCreateValidator;
function $4d76f5f9967ab345$var$isAminoMsgEditValidator(msg) {
    return msg.type === "cosmos-sdk/MsgEditValidator";
}
$4d76f5f9967ab345$exports.isAminoMsgEditValidator = $4d76f5f9967ab345$var$isAminoMsgEditValidator;
function $4d76f5f9967ab345$var$isAminoMsgDelegate(msg) {
    return msg.type === "cosmos-sdk/MsgDelegate";
}
$4d76f5f9967ab345$exports.isAminoMsgDelegate = $4d76f5f9967ab345$var$isAminoMsgDelegate;
function $4d76f5f9967ab345$var$isAminoMsgBeginRedelegate(msg) {
    return msg.type === "cosmos-sdk/MsgBeginRedelegate";
}
$4d76f5f9967ab345$exports.isAminoMsgBeginRedelegate = $4d76f5f9967ab345$var$isAminoMsgBeginRedelegate;
function $4d76f5f9967ab345$var$isAminoMsgUndelegate(msg) {
    return msg.type === "cosmos-sdk/MsgUndelegate";
}
$4d76f5f9967ab345$exports.isAminoMsgUndelegate = $4d76f5f9967ab345$var$isAminoMsgUndelegate;
function $4d76f5f9967ab345$var$createStakingAminoConverters() {
    return {
        "/cosmos.staking.v1beta1.MsgBeginRedelegate": {
            aminoType: "cosmos-sdk/MsgBeginRedelegate",
            toAmino: ({ delegatorAddress: delegatorAddress, validatorSrcAddress: validatorSrcAddress, validatorDstAddress: validatorDstAddress, amount: amount })=>{
                (0, $fZwG5.assertDefinedAndNotNull)(amount, "missing amount");
                return {
                    delegator_address: delegatorAddress,
                    validator_src_address: validatorSrcAddress,
                    validator_dst_address: validatorDstAddress,
                    amount: amount
                };
            },
            fromAmino: ({ delegator_address: delegator_address, validator_src_address: validator_src_address, validator_dst_address: validator_dst_address, amount: amount })=>({
                    delegatorAddress: delegator_address,
                    validatorSrcAddress: validator_src_address,
                    validatorDstAddress: validator_dst_address,
                    amount: amount
                })
        },
        "/cosmos.staking.v1beta1.MsgCreateValidator": {
            aminoType: "cosmos-sdk/MsgCreateValidator",
            toAmino: ({ description: description, commission: commission, minSelfDelegation: minSelfDelegation, delegatorAddress: delegatorAddress, validatorAddress: validatorAddress, pubkey: pubkey, value: value })=>{
                (0, $fZwG5.assertDefinedAndNotNull)(description, "missing description");
                (0, $fZwG5.assertDefinedAndNotNull)(commission, "missing commission");
                (0, $fZwG5.assertDefinedAndNotNull)(pubkey, "missing pubkey");
                (0, $fZwG5.assertDefinedAndNotNull)(value, "missing value");
                return {
                    description: {
                        moniker: description.moniker,
                        identity: description.identity,
                        website: description.website,
                        security_contact: description.securityContact,
                        details: description.details
                    },
                    commission: {
                        rate: $4d76f5f9967ab345$var$protoDecimalToJson(commission.rate),
                        max_rate: $4d76f5f9967ab345$var$protoDecimalToJson(commission.maxRate),
                        max_change_rate: $4d76f5f9967ab345$var$protoDecimalToJson(commission.maxChangeRate)
                    },
                    min_self_delegation: minSelfDelegation,
                    delegator_address: delegatorAddress,
                    validator_address: validatorAddress,
                    pubkey: (0, $c0a9381c50e8ee56$exports.decodePubkey)(pubkey),
                    value: value
                };
            },
            fromAmino: ({ description: description, commission: commission, min_self_delegation: min_self_delegation, delegator_address: delegator_address, validator_address: validator_address, pubkey: pubkey, value: value })=>{
                return {
                    description: {
                        moniker: description.moniker,
                        identity: description.identity,
                        website: description.website,
                        securityContact: description.security_contact,
                        details: description.details
                    },
                    commission: {
                        rate: $4d76f5f9967ab345$var$jsonDecimalToProto(commission.rate),
                        maxRate: $4d76f5f9967ab345$var$jsonDecimalToProto(commission.max_rate),
                        maxChangeRate: $4d76f5f9967ab345$var$jsonDecimalToProto(commission.max_change_rate)
                    },
                    minSelfDelegation: min_self_delegation,
                    delegatorAddress: delegator_address,
                    validatorAddress: validator_address,
                    pubkey: (0, $c0a9381c50e8ee56$exports.encodePubkey)(pubkey),
                    value: value
                };
            }
        },
        "/cosmos.staking.v1beta1.MsgDelegate": {
            aminoType: "cosmos-sdk/MsgDelegate",
            toAmino: ({ delegatorAddress: delegatorAddress, validatorAddress: validatorAddress, amount: amount })=>{
                (0, $fZwG5.assertDefinedAndNotNull)(amount, "missing amount");
                return {
                    delegator_address: delegatorAddress,
                    validator_address: validatorAddress,
                    amount: amount
                };
            },
            fromAmino: ({ delegator_address: delegator_address, validator_address: validator_address, amount: amount })=>({
                    delegatorAddress: delegator_address,
                    validatorAddress: validator_address,
                    amount: amount
                })
        },
        "/cosmos.staking.v1beta1.MsgEditValidator": {
            aminoType: "cosmos-sdk/MsgEditValidator",
            toAmino: ({ description: description, commissionRate: commissionRate, minSelfDelegation: minSelfDelegation, validatorAddress: validatorAddress })=>{
                (0, $fZwG5.assertDefinedAndNotNull)(description, "missing description");
                return {
                    description: {
                        moniker: description.moniker,
                        identity: description.identity,
                        website: description.website,
                        security_contact: description.securityContact,
                        details: description.details
                    },
                    // empty string in the protobuf document means "do not change"
                    commission_rate: commissionRate ? $4d76f5f9967ab345$var$protoDecimalToJson(commissionRate) : undefined,
                    // empty string in the protobuf document means "do not change"
                    min_self_delegation: minSelfDelegation ? minSelfDelegation : undefined,
                    validator_address: validatorAddress
                };
            },
            fromAmino: ({ description: description, commission_rate: commission_rate, min_self_delegation: min_self_delegation, validator_address: validator_address })=>({
                    description: {
                        moniker: description.moniker,
                        identity: description.identity,
                        website: description.website,
                        securityContact: description.security_contact,
                        details: description.details
                    },
                    // empty string in the protobuf document means "do not change"
                    commissionRate: commission_rate ? $4d76f5f9967ab345$var$jsonDecimalToProto(commission_rate) : "",
                    // empty string in the protobuf document means "do not change"
                    minSelfDelegation: min_self_delegation ?? "",
                    validatorAddress: validator_address
                })
        },
        "/cosmos.staking.v1beta1.MsgUndelegate": {
            aminoType: "cosmos-sdk/MsgUndelegate",
            toAmino: ({ delegatorAddress: delegatorAddress, validatorAddress: validatorAddress, amount: amount })=>{
                (0, $fZwG5.assertDefinedAndNotNull)(amount, "missing amount");
                return {
                    delegator_address: delegatorAddress,
                    validator_address: validatorAddress,
                    amount: amount
                };
            },
            fromAmino: ({ delegator_address: delegator_address, validator_address: validator_address, amount: amount })=>({
                    delegatorAddress: delegator_address,
                    validatorAddress: validator_address,
                    amount: amount
                })
        }
    };
}
$4d76f5f9967ab345$exports.createStakingAminoConverters = $4d76f5f9967ab345$var$createStakingAminoConverters;


Object.defineProperty($d0d8b6f4712acd9f$exports, "createStakingAminoConverters", {
    enumerable: true,
    get: function() {
        return $4d76f5f9967ab345$exports.createStakingAminoConverters;
    }
});
Object.defineProperty($d0d8b6f4712acd9f$exports, "isAminoMsgBeginRedelegate", {
    enumerable: true,
    get: function() {
        return $4d76f5f9967ab345$exports.isAminoMsgBeginRedelegate;
    }
});
Object.defineProperty($d0d8b6f4712acd9f$exports, "isAminoMsgCreateValidator", {
    enumerable: true,
    get: function() {
        return $4d76f5f9967ab345$exports.isAminoMsgCreateValidator;
    }
});
Object.defineProperty($d0d8b6f4712acd9f$exports, "isAminoMsgDelegate", {
    enumerable: true,
    get: function() {
        return $4d76f5f9967ab345$exports.isAminoMsgDelegate;
    }
});
Object.defineProperty($d0d8b6f4712acd9f$exports, "isAminoMsgEditValidator", {
    enumerable: true,
    get: function() {
        return $4d76f5f9967ab345$exports.isAminoMsgEditValidator;
    }
});
Object.defineProperty($d0d8b6f4712acd9f$exports, "isAminoMsgUndelegate", {
    enumerable: true,
    get: function() {
        return $4d76f5f9967ab345$exports.isAminoMsgUndelegate;
    }
});
var $629136b718486c26$exports = {};
"use strict";
Object.defineProperty($629136b718486c26$exports, "__esModule", {
    value: true
});
$629136b718486c26$exports.isMsgUndelegateEncodeObject = $629136b718486c26$exports.isMsgEditValidatorEncodeObject = $629136b718486c26$exports.isMsgDelegateEncodeObject = $629136b718486c26$exports.isMsgCreateValidatorEncodeObject = $629136b718486c26$exports.isMsgBeginRedelegateEncodeObject = $629136b718486c26$exports.stakingTypes = void 0;
var $732d6a51596ab26e$exports = {};
"use strict";
var $732d6a51596ab26e$var$__createBinding = $732d6a51596ab26e$exports && $732d6a51596ab26e$exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $732d6a51596ab26e$var$__setModuleDefault = $732d6a51596ab26e$exports && $732d6a51596ab26e$exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $732d6a51596ab26e$var$__importStar = $732d6a51596ab26e$exports && $732d6a51596ab26e$exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $732d6a51596ab26e$var$__createBinding(result, mod, k);
    }
    $732d6a51596ab26e$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty($732d6a51596ab26e$exports, "__esModule", {
    value: true
});
$732d6a51596ab26e$exports.MsgClientImpl = $732d6a51596ab26e$exports.MsgUpdateParamsResponse = $732d6a51596ab26e$exports.MsgUpdateParams = $732d6a51596ab26e$exports.MsgCancelUnbondingDelegationResponse = $732d6a51596ab26e$exports.MsgCancelUnbondingDelegation = $732d6a51596ab26e$exports.MsgUndelegateResponse = $732d6a51596ab26e$exports.MsgUndelegate = $732d6a51596ab26e$exports.MsgBeginRedelegateResponse = $732d6a51596ab26e$exports.MsgBeginRedelegate = $732d6a51596ab26e$exports.MsgDelegateResponse = $732d6a51596ab26e$exports.MsgDelegate = $732d6a51596ab26e$exports.MsgEditValidatorResponse = $732d6a51596ab26e$exports.MsgEditValidator = $732d6a51596ab26e$exports.MsgCreateValidatorResponse = $732d6a51596ab26e$exports.MsgCreateValidator = $732d6a51596ab26e$exports.protobufPackage = void 0;
var $a040057dd8961d62$exports = {};
"use strict";
var $a040057dd8961d62$var$__createBinding = $a040057dd8961d62$exports && $a040057dd8961d62$exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $a040057dd8961d62$var$__setModuleDefault = $a040057dd8961d62$exports && $a040057dd8961d62$exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $a040057dd8961d62$var$__importStar = $a040057dd8961d62$exports && $a040057dd8961d62$exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $a040057dd8961d62$var$__createBinding(result, mod, k);
    }
    $a040057dd8961d62$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty($a040057dd8961d62$exports, "__esModule", {
    value: true
});
$a040057dd8961d62$exports.ValidatorUpdates = $a040057dd8961d62$exports.Pool = $a040057dd8961d62$exports.RedelegationResponse = $a040057dd8961d62$exports.RedelegationEntryResponse = $a040057dd8961d62$exports.DelegationResponse = $a040057dd8961d62$exports.Params = $a040057dd8961d62$exports.Redelegation = $a040057dd8961d62$exports.RedelegationEntry = $a040057dd8961d62$exports.UnbondingDelegationEntry = $a040057dd8961d62$exports.UnbondingDelegation = $a040057dd8961d62$exports.Delegation = $a040057dd8961d62$exports.DVVTriplets = $a040057dd8961d62$exports.DVVTriplet = $a040057dd8961d62$exports.DVPairs = $a040057dd8961d62$exports.DVPair = $a040057dd8961d62$exports.ValAddresses = $a040057dd8961d62$exports.Validator = $a040057dd8961d62$exports.Description = $a040057dd8961d62$exports.Commission = $a040057dd8961d62$exports.CommissionRates = $a040057dd8961d62$exports.HistoricalInfo = $a040057dd8961d62$exports.infractionToJSON = $a040057dd8961d62$exports.infractionFromJSON = $a040057dd8961d62$exports.Infraction = $a040057dd8961d62$exports.bondStatusToJSON = $a040057dd8961d62$exports.bondStatusFromJSON = $a040057dd8961d62$exports.BondStatus = $a040057dd8961d62$exports.protobufPackage = void 0;





var $55d7da6fb7010b2f$exports = {};
"use strict";
var $55d7da6fb7010b2f$var$__createBinding = $55d7da6fb7010b2f$exports && $55d7da6fb7010b2f$exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $55d7da6fb7010b2f$var$__setModuleDefault = $55d7da6fb7010b2f$exports && $55d7da6fb7010b2f$exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $55d7da6fb7010b2f$var$__importStar = $55d7da6fb7010b2f$exports && $55d7da6fb7010b2f$exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $55d7da6fb7010b2f$var$__createBinding(result, mod, k);
    }
    $55d7da6fb7010b2f$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty($55d7da6fb7010b2f$exports, "__esModule", {
    value: true
});
$55d7da6fb7010b2f$exports.ResponsePrepareProposal = $55d7da6fb7010b2f$exports.ResponseApplySnapshotChunk = $55d7da6fb7010b2f$exports.ResponseLoadSnapshotChunk = $55d7da6fb7010b2f$exports.ResponseOfferSnapshot = $55d7da6fb7010b2f$exports.ResponseListSnapshots = $55d7da6fb7010b2f$exports.ResponseCommit = $55d7da6fb7010b2f$exports.ResponseEndBlock = $55d7da6fb7010b2f$exports.ResponseDeliverTx = $55d7da6fb7010b2f$exports.ResponseCheckTx = $55d7da6fb7010b2f$exports.ResponseBeginBlock = $55d7da6fb7010b2f$exports.ResponseQuery = $55d7da6fb7010b2f$exports.ResponseInitChain = $55d7da6fb7010b2f$exports.ResponseInfo = $55d7da6fb7010b2f$exports.ResponseFlush = $55d7da6fb7010b2f$exports.ResponseEcho = $55d7da6fb7010b2f$exports.ResponseException = $55d7da6fb7010b2f$exports.Response = $55d7da6fb7010b2f$exports.RequestProcessProposal = $55d7da6fb7010b2f$exports.RequestPrepareProposal = $55d7da6fb7010b2f$exports.RequestApplySnapshotChunk = $55d7da6fb7010b2f$exports.RequestLoadSnapshotChunk = $55d7da6fb7010b2f$exports.RequestOfferSnapshot = $55d7da6fb7010b2f$exports.RequestListSnapshots = $55d7da6fb7010b2f$exports.RequestCommit = $55d7da6fb7010b2f$exports.RequestEndBlock = $55d7da6fb7010b2f$exports.RequestDeliverTx = $55d7da6fb7010b2f$exports.RequestCheckTx = $55d7da6fb7010b2f$exports.RequestBeginBlock = $55d7da6fb7010b2f$exports.RequestQuery = $55d7da6fb7010b2f$exports.RequestInitChain = $55d7da6fb7010b2f$exports.RequestInfo = $55d7da6fb7010b2f$exports.RequestFlush = $55d7da6fb7010b2f$exports.RequestEcho = $55d7da6fb7010b2f$exports.Request = $55d7da6fb7010b2f$exports.misbehaviorTypeToJSON = $55d7da6fb7010b2f$exports.misbehaviorTypeFromJSON = $55d7da6fb7010b2f$exports.MisbehaviorType = $55d7da6fb7010b2f$exports.responseProcessProposal_ProposalStatusToJSON = $55d7da6fb7010b2f$exports.responseProcessProposal_ProposalStatusFromJSON = $55d7da6fb7010b2f$exports.ResponseProcessProposal_ProposalStatus = $55d7da6fb7010b2f$exports.responseApplySnapshotChunk_ResultToJSON = $55d7da6fb7010b2f$exports.responseApplySnapshotChunk_ResultFromJSON = $55d7da6fb7010b2f$exports.ResponseApplySnapshotChunk_Result = $55d7da6fb7010b2f$exports.responseOfferSnapshot_ResultToJSON = $55d7da6fb7010b2f$exports.responseOfferSnapshot_ResultFromJSON = $55d7da6fb7010b2f$exports.ResponseOfferSnapshot_Result = $55d7da6fb7010b2f$exports.checkTxTypeToJSON = $55d7da6fb7010b2f$exports.checkTxTypeFromJSON = $55d7da6fb7010b2f$exports.CheckTxType = $55d7da6fb7010b2f$exports.protobufPackage = void 0;
$55d7da6fb7010b2f$exports.ABCIApplicationClientImpl = $55d7da6fb7010b2f$exports.Snapshot = $55d7da6fb7010b2f$exports.Misbehavior = $55d7da6fb7010b2f$exports.ExtendedVoteInfo = $55d7da6fb7010b2f$exports.VoteInfo = $55d7da6fb7010b2f$exports.ValidatorUpdate = $55d7da6fb7010b2f$exports.Validator = $55d7da6fb7010b2f$exports.TxResult = $55d7da6fb7010b2f$exports.EventAttribute = $55d7da6fb7010b2f$exports.Event = $55d7da6fb7010b2f$exports.ExtendedCommitInfo = $55d7da6fb7010b2f$exports.CommitInfo = $55d7da6fb7010b2f$exports.ResponseProcessProposal = void 0;

var $134a665e0e74d535$exports = {};
"use strict";
var $134a665e0e74d535$var$__createBinding = $134a665e0e74d535$exports && $134a665e0e74d535$exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $134a665e0e74d535$var$__setModuleDefault = $134a665e0e74d535$exports && $134a665e0e74d535$exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $134a665e0e74d535$var$__importStar = $134a665e0e74d535$exports && $134a665e0e74d535$exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $134a665e0e74d535$var$__createBinding(result, mod, k);
    }
    $134a665e0e74d535$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty($134a665e0e74d535$exports, "__esModule", {
    value: true
});
$134a665e0e74d535$exports.HashedParams = $134a665e0e74d535$exports.VersionParams = $134a665e0e74d535$exports.ValidatorParams = $134a665e0e74d535$exports.EvidenceParams = $134a665e0e74d535$exports.BlockParams = $134a665e0e74d535$exports.ConsensusParams = $134a665e0e74d535$exports.protobufPackage = void 0;



const $134a665e0e74d535$var$_m0 = $134a665e0e74d535$var$__importStar((parcelRequire("fQBv0")));
$134a665e0e74d535$exports.protobufPackage = "tendermint.types";
function $134a665e0e74d535$var$createBaseConsensusParams() {
    return {
        block: undefined,
        evidence: undefined,
        validator: undefined,
        version: undefined
    };
}
$134a665e0e74d535$exports.ConsensusParams = {
    encode (message, writer = $134a665e0e74d535$var$_m0.Writer.create()) {
        if (message.block !== undefined) $134a665e0e74d535$exports.BlockParams.encode(message.block, writer.uint32(10).fork()).ldelim();
        if (message.evidence !== undefined) $134a665e0e74d535$exports.EvidenceParams.encode(message.evidence, writer.uint32(18).fork()).ldelim();
        if (message.validator !== undefined) $134a665e0e74d535$exports.ValidatorParams.encode(message.validator, writer.uint32(26).fork()).ldelim();
        if (message.version !== undefined) $134a665e0e74d535$exports.VersionParams.encode(message.version, writer.uint32(34).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $134a665e0e74d535$var$_m0.Reader ? input : new $134a665e0e74d535$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $134a665e0e74d535$var$createBaseConsensusParams();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.block = $134a665e0e74d535$exports.BlockParams.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.evidence = $134a665e0e74d535$exports.EvidenceParams.decode(reader, reader.uint32());
                    break;
                case 3:
                    message.validator = $134a665e0e74d535$exports.ValidatorParams.decode(reader, reader.uint32());
                    break;
                case 4:
                    message.version = $134a665e0e74d535$exports.VersionParams.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            block: (0, $d5e07fe2518aae94$exports.isSet)(object.block) ? $134a665e0e74d535$exports.BlockParams.fromJSON(object.block) : undefined,
            evidence: (0, $d5e07fe2518aae94$exports.isSet)(object.evidence) ? $134a665e0e74d535$exports.EvidenceParams.fromJSON(object.evidence) : undefined,
            validator: (0, $d5e07fe2518aae94$exports.isSet)(object.validator) ? $134a665e0e74d535$exports.ValidatorParams.fromJSON(object.validator) : undefined,
            version: (0, $d5e07fe2518aae94$exports.isSet)(object.version) ? $134a665e0e74d535$exports.VersionParams.fromJSON(object.version) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.block !== undefined && (obj.block = message.block ? $134a665e0e74d535$exports.BlockParams.toJSON(message.block) : undefined);
        message.evidence !== undefined && (obj.evidence = message.evidence ? $134a665e0e74d535$exports.EvidenceParams.toJSON(message.evidence) : undefined);
        message.validator !== undefined && (obj.validator = message.validator ? $134a665e0e74d535$exports.ValidatorParams.toJSON(message.validator) : undefined);
        message.version !== undefined && (obj.version = message.version ? $134a665e0e74d535$exports.VersionParams.toJSON(message.version) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $134a665e0e74d535$var$createBaseConsensusParams();
        message.block = object.block !== undefined && object.block !== null ? $134a665e0e74d535$exports.BlockParams.fromPartial(object.block) : undefined;
        message.evidence = object.evidence !== undefined && object.evidence !== null ? $134a665e0e74d535$exports.EvidenceParams.fromPartial(object.evidence) : undefined;
        message.validator = object.validator !== undefined && object.validator !== null ? $134a665e0e74d535$exports.ValidatorParams.fromPartial(object.validator) : undefined;
        message.version = object.version !== undefined && object.version !== null ? $134a665e0e74d535$exports.VersionParams.fromPartial(object.version) : undefined;
        return message;
    }
};
function $134a665e0e74d535$var$createBaseBlockParams() {
    return {
        maxBytes: $d5e07fe2518aae94$exports.Long.ZERO,
        maxGas: $d5e07fe2518aae94$exports.Long.ZERO
    };
}
$134a665e0e74d535$exports.BlockParams = {
    encode (message, writer = $134a665e0e74d535$var$_m0.Writer.create()) {
        if (!message.maxBytes.isZero()) writer.uint32(8).int64(message.maxBytes);
        if (!message.maxGas.isZero()) writer.uint32(16).int64(message.maxGas);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $134a665e0e74d535$var$_m0.Reader ? input : new $134a665e0e74d535$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $134a665e0e74d535$var$createBaseBlockParams();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.maxBytes = reader.int64();
                    break;
                case 2:
                    message.maxGas = reader.int64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            maxBytes: (0, $d5e07fe2518aae94$exports.isSet)(object.maxBytes) ? $d5e07fe2518aae94$exports.Long.fromValue(object.maxBytes) : $d5e07fe2518aae94$exports.Long.ZERO,
            maxGas: (0, $d5e07fe2518aae94$exports.isSet)(object.maxGas) ? $d5e07fe2518aae94$exports.Long.fromValue(object.maxGas) : $d5e07fe2518aae94$exports.Long.ZERO
        };
    },
    toJSON (message) {
        const obj = {};
        message.maxBytes !== undefined && (obj.maxBytes = (message.maxBytes || $d5e07fe2518aae94$exports.Long.ZERO).toString());
        message.maxGas !== undefined && (obj.maxGas = (message.maxGas || $d5e07fe2518aae94$exports.Long.ZERO).toString());
        return obj;
    },
    fromPartial (object) {
        const message = $134a665e0e74d535$var$createBaseBlockParams();
        message.maxBytes = object.maxBytes !== undefined && object.maxBytes !== null ? $d5e07fe2518aae94$exports.Long.fromValue(object.maxBytes) : $d5e07fe2518aae94$exports.Long.ZERO;
        message.maxGas = object.maxGas !== undefined && object.maxGas !== null ? $d5e07fe2518aae94$exports.Long.fromValue(object.maxGas) : $d5e07fe2518aae94$exports.Long.ZERO;
        return message;
    }
};
function $134a665e0e74d535$var$createBaseEvidenceParams() {
    return {
        maxAgeNumBlocks: $d5e07fe2518aae94$exports.Long.ZERO,
        maxAgeDuration: undefined,
        maxBytes: $d5e07fe2518aae94$exports.Long.ZERO
    };
}
$134a665e0e74d535$exports.EvidenceParams = {
    encode (message, writer = $134a665e0e74d535$var$_m0.Writer.create()) {
        if (!message.maxAgeNumBlocks.isZero()) writer.uint32(8).int64(message.maxAgeNumBlocks);
        if (message.maxAgeDuration !== undefined) $fe534fae4538ccbf$exports.Duration.encode(message.maxAgeDuration, writer.uint32(18).fork()).ldelim();
        if (!message.maxBytes.isZero()) writer.uint32(24).int64(message.maxBytes);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $134a665e0e74d535$var$_m0.Reader ? input : new $134a665e0e74d535$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $134a665e0e74d535$var$createBaseEvidenceParams();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.maxAgeNumBlocks = reader.int64();
                    break;
                case 2:
                    message.maxAgeDuration = $fe534fae4538ccbf$exports.Duration.decode(reader, reader.uint32());
                    break;
                case 3:
                    message.maxBytes = reader.int64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            maxAgeNumBlocks: (0, $d5e07fe2518aae94$exports.isSet)(object.maxAgeNumBlocks) ? $d5e07fe2518aae94$exports.Long.fromValue(object.maxAgeNumBlocks) : $d5e07fe2518aae94$exports.Long.ZERO,
            maxAgeDuration: (0, $d5e07fe2518aae94$exports.isSet)(object.maxAgeDuration) ? $fe534fae4538ccbf$exports.Duration.fromJSON(object.maxAgeDuration) : undefined,
            maxBytes: (0, $d5e07fe2518aae94$exports.isSet)(object.maxBytes) ? $d5e07fe2518aae94$exports.Long.fromValue(object.maxBytes) : $d5e07fe2518aae94$exports.Long.ZERO
        };
    },
    toJSON (message) {
        const obj = {};
        message.maxAgeNumBlocks !== undefined && (obj.maxAgeNumBlocks = (message.maxAgeNumBlocks || $d5e07fe2518aae94$exports.Long.ZERO).toString());
        message.maxAgeDuration !== undefined && (obj.maxAgeDuration = message.maxAgeDuration ? $fe534fae4538ccbf$exports.Duration.toJSON(message.maxAgeDuration) : undefined);
        message.maxBytes !== undefined && (obj.maxBytes = (message.maxBytes || $d5e07fe2518aae94$exports.Long.ZERO).toString());
        return obj;
    },
    fromPartial (object) {
        const message = $134a665e0e74d535$var$createBaseEvidenceParams();
        message.maxAgeNumBlocks = object.maxAgeNumBlocks !== undefined && object.maxAgeNumBlocks !== null ? $d5e07fe2518aae94$exports.Long.fromValue(object.maxAgeNumBlocks) : $d5e07fe2518aae94$exports.Long.ZERO;
        message.maxAgeDuration = object.maxAgeDuration !== undefined && object.maxAgeDuration !== null ? $fe534fae4538ccbf$exports.Duration.fromPartial(object.maxAgeDuration) : undefined;
        message.maxBytes = object.maxBytes !== undefined && object.maxBytes !== null ? $d5e07fe2518aae94$exports.Long.fromValue(object.maxBytes) : $d5e07fe2518aae94$exports.Long.ZERO;
        return message;
    }
};
function $134a665e0e74d535$var$createBaseValidatorParams() {
    return {
        pubKeyTypes: []
    };
}
$134a665e0e74d535$exports.ValidatorParams = {
    encode (message, writer = $134a665e0e74d535$var$_m0.Writer.create()) {
        for (const v of message.pubKeyTypes)writer.uint32(10).string(v);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $134a665e0e74d535$var$_m0.Reader ? input : new $134a665e0e74d535$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $134a665e0e74d535$var$createBaseValidatorParams();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.pubKeyTypes.push(reader.string());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            pubKeyTypes: Array.isArray(object?.pubKeyTypes) ? object.pubKeyTypes.map((e)=>String(e)) : []
        };
    },
    toJSON (message) {
        const obj = {};
        if (message.pubKeyTypes) obj.pubKeyTypes = message.pubKeyTypes.map((e)=>e);
        else obj.pubKeyTypes = [];
        return obj;
    },
    fromPartial (object) {
        const message = $134a665e0e74d535$var$createBaseValidatorParams();
        message.pubKeyTypes = object.pubKeyTypes?.map((e)=>e) || [];
        return message;
    }
};
function $134a665e0e74d535$var$createBaseVersionParams() {
    return {
        app: $d5e07fe2518aae94$exports.Long.UZERO
    };
}
$134a665e0e74d535$exports.VersionParams = {
    encode (message, writer = $134a665e0e74d535$var$_m0.Writer.create()) {
        if (!message.app.isZero()) writer.uint32(8).uint64(message.app);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $134a665e0e74d535$var$_m0.Reader ? input : new $134a665e0e74d535$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $134a665e0e74d535$var$createBaseVersionParams();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.app = reader.uint64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            app: (0, $d5e07fe2518aae94$exports.isSet)(object.app) ? $d5e07fe2518aae94$exports.Long.fromValue(object.app) : $d5e07fe2518aae94$exports.Long.UZERO
        };
    },
    toJSON (message) {
        const obj = {};
        message.app !== undefined && (obj.app = (message.app || $d5e07fe2518aae94$exports.Long.UZERO).toString());
        return obj;
    },
    fromPartial (object) {
        const message = $134a665e0e74d535$var$createBaseVersionParams();
        message.app = object.app !== undefined && object.app !== null ? $d5e07fe2518aae94$exports.Long.fromValue(object.app) : $d5e07fe2518aae94$exports.Long.UZERO;
        return message;
    }
};
function $134a665e0e74d535$var$createBaseHashedParams() {
    return {
        blockMaxBytes: $d5e07fe2518aae94$exports.Long.ZERO,
        blockMaxGas: $d5e07fe2518aae94$exports.Long.ZERO
    };
}
$134a665e0e74d535$exports.HashedParams = {
    encode (message, writer = $134a665e0e74d535$var$_m0.Writer.create()) {
        if (!message.blockMaxBytes.isZero()) writer.uint32(8).int64(message.blockMaxBytes);
        if (!message.blockMaxGas.isZero()) writer.uint32(16).int64(message.blockMaxGas);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $134a665e0e74d535$var$_m0.Reader ? input : new $134a665e0e74d535$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $134a665e0e74d535$var$createBaseHashedParams();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.blockMaxBytes = reader.int64();
                    break;
                case 2:
                    message.blockMaxGas = reader.int64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            blockMaxBytes: (0, $d5e07fe2518aae94$exports.isSet)(object.blockMaxBytes) ? $d5e07fe2518aae94$exports.Long.fromValue(object.blockMaxBytes) : $d5e07fe2518aae94$exports.Long.ZERO,
            blockMaxGas: (0, $d5e07fe2518aae94$exports.isSet)(object.blockMaxGas) ? $d5e07fe2518aae94$exports.Long.fromValue(object.blockMaxGas) : $d5e07fe2518aae94$exports.Long.ZERO
        };
    },
    toJSON (message) {
        const obj = {};
        message.blockMaxBytes !== undefined && (obj.blockMaxBytes = (message.blockMaxBytes || $d5e07fe2518aae94$exports.Long.ZERO).toString());
        message.blockMaxGas !== undefined && (obj.blockMaxGas = (message.blockMaxGas || $d5e07fe2518aae94$exports.Long.ZERO).toString());
        return obj;
    },
    fromPartial (object) {
        const message = $134a665e0e74d535$var$createBaseHashedParams();
        message.blockMaxBytes = object.blockMaxBytes !== undefined && object.blockMaxBytes !== null ? $d5e07fe2518aae94$exports.Long.fromValue(object.blockMaxBytes) : $d5e07fe2518aae94$exports.Long.ZERO;
        message.blockMaxGas = object.blockMaxGas !== undefined && object.blockMaxGas !== null ? $d5e07fe2518aae94$exports.Long.fromValue(object.blockMaxGas) : $d5e07fe2518aae94$exports.Long.ZERO;
        return message;
    }
};







const $55d7da6fb7010b2f$var$_m0 = $55d7da6fb7010b2f$var$__importStar((parcelRequire("fQBv0")));
$55d7da6fb7010b2f$exports.protobufPackage = "tendermint.abci";
var $55d7da6fb7010b2f$var$CheckTxType;
(function(CheckTxType) {
    CheckTxType[CheckTxType["NEW"] = 0] = "NEW";
    CheckTxType[CheckTxType["RECHECK"] = 1] = "RECHECK";
    CheckTxType[CheckTxType["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})($55d7da6fb7010b2f$var$CheckTxType = $55d7da6fb7010b2f$exports.CheckTxType || ($55d7da6fb7010b2f$exports.CheckTxType = {}));
function $55d7da6fb7010b2f$var$checkTxTypeFromJSON(object) {
    switch(object){
        case 0:
        case "NEW":
            return $55d7da6fb7010b2f$var$CheckTxType.NEW;
        case 1:
        case "RECHECK":
            return $55d7da6fb7010b2f$var$CheckTxType.RECHECK;
        case -1:
        case "UNRECOGNIZED":
        default:
            return $55d7da6fb7010b2f$var$CheckTxType.UNRECOGNIZED;
    }
}
$55d7da6fb7010b2f$exports.checkTxTypeFromJSON = $55d7da6fb7010b2f$var$checkTxTypeFromJSON;
function $55d7da6fb7010b2f$var$checkTxTypeToJSON(object) {
    switch(object){
        case $55d7da6fb7010b2f$var$CheckTxType.NEW:
            return "NEW";
        case $55d7da6fb7010b2f$var$CheckTxType.RECHECK:
            return "RECHECK";
        case $55d7da6fb7010b2f$var$CheckTxType.UNRECOGNIZED:
        default:
            return "UNRECOGNIZED";
    }
}
$55d7da6fb7010b2f$exports.checkTxTypeToJSON = $55d7da6fb7010b2f$var$checkTxTypeToJSON;
var $55d7da6fb7010b2f$var$ResponseOfferSnapshot_Result;
(function(ResponseOfferSnapshot_Result) {
    /** UNKNOWN - Unknown result, abort all snapshot restoration */ ResponseOfferSnapshot_Result[ResponseOfferSnapshot_Result["UNKNOWN"] = 0] = "UNKNOWN";
    /** ACCEPT - Snapshot accepted, apply chunks */ ResponseOfferSnapshot_Result[ResponseOfferSnapshot_Result["ACCEPT"] = 1] = "ACCEPT";
    /** ABORT - Abort all snapshot restoration */ ResponseOfferSnapshot_Result[ResponseOfferSnapshot_Result["ABORT"] = 2] = "ABORT";
    /** REJECT - Reject this specific snapshot, try others */ ResponseOfferSnapshot_Result[ResponseOfferSnapshot_Result["REJECT"] = 3] = "REJECT";
    /** REJECT_FORMAT - Reject all snapshots of this format, try others */ ResponseOfferSnapshot_Result[ResponseOfferSnapshot_Result["REJECT_FORMAT"] = 4] = "REJECT_FORMAT";
    /** REJECT_SENDER - Reject all snapshots from the sender(s), try others */ ResponseOfferSnapshot_Result[ResponseOfferSnapshot_Result["REJECT_SENDER"] = 5] = "REJECT_SENDER";
    ResponseOfferSnapshot_Result[ResponseOfferSnapshot_Result["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})($55d7da6fb7010b2f$var$ResponseOfferSnapshot_Result = $55d7da6fb7010b2f$exports.ResponseOfferSnapshot_Result || ($55d7da6fb7010b2f$exports.ResponseOfferSnapshot_Result = {}));
function $55d7da6fb7010b2f$var$responseOfferSnapshot_ResultFromJSON(object) {
    switch(object){
        case 0:
        case "UNKNOWN":
            return $55d7da6fb7010b2f$var$ResponseOfferSnapshot_Result.UNKNOWN;
        case 1:
        case "ACCEPT":
            return $55d7da6fb7010b2f$var$ResponseOfferSnapshot_Result.ACCEPT;
        case 2:
        case "ABORT":
            return $55d7da6fb7010b2f$var$ResponseOfferSnapshot_Result.ABORT;
        case 3:
        case "REJECT":
            return $55d7da6fb7010b2f$var$ResponseOfferSnapshot_Result.REJECT;
        case 4:
        case "REJECT_FORMAT":
            return $55d7da6fb7010b2f$var$ResponseOfferSnapshot_Result.REJECT_FORMAT;
        case 5:
        case "REJECT_SENDER":
            return $55d7da6fb7010b2f$var$ResponseOfferSnapshot_Result.REJECT_SENDER;
        case -1:
        case "UNRECOGNIZED":
        default:
            return $55d7da6fb7010b2f$var$ResponseOfferSnapshot_Result.UNRECOGNIZED;
    }
}
$55d7da6fb7010b2f$exports.responseOfferSnapshot_ResultFromJSON = $55d7da6fb7010b2f$var$responseOfferSnapshot_ResultFromJSON;
function $55d7da6fb7010b2f$var$responseOfferSnapshot_ResultToJSON(object) {
    switch(object){
        case $55d7da6fb7010b2f$var$ResponseOfferSnapshot_Result.UNKNOWN:
            return "UNKNOWN";
        case $55d7da6fb7010b2f$var$ResponseOfferSnapshot_Result.ACCEPT:
            return "ACCEPT";
        case $55d7da6fb7010b2f$var$ResponseOfferSnapshot_Result.ABORT:
            return "ABORT";
        case $55d7da6fb7010b2f$var$ResponseOfferSnapshot_Result.REJECT:
            return "REJECT";
        case $55d7da6fb7010b2f$var$ResponseOfferSnapshot_Result.REJECT_FORMAT:
            return "REJECT_FORMAT";
        case $55d7da6fb7010b2f$var$ResponseOfferSnapshot_Result.REJECT_SENDER:
            return "REJECT_SENDER";
        case $55d7da6fb7010b2f$var$ResponseOfferSnapshot_Result.UNRECOGNIZED:
        default:
            return "UNRECOGNIZED";
    }
}
$55d7da6fb7010b2f$exports.responseOfferSnapshot_ResultToJSON = $55d7da6fb7010b2f$var$responseOfferSnapshot_ResultToJSON;
var $55d7da6fb7010b2f$var$ResponseApplySnapshotChunk_Result;
(function(ResponseApplySnapshotChunk_Result) {
    /** UNKNOWN - Unknown result, abort all snapshot restoration */ ResponseApplySnapshotChunk_Result[ResponseApplySnapshotChunk_Result["UNKNOWN"] = 0] = "UNKNOWN";
    /** ACCEPT - Chunk successfully accepted */ ResponseApplySnapshotChunk_Result[ResponseApplySnapshotChunk_Result["ACCEPT"] = 1] = "ACCEPT";
    /** ABORT - Abort all snapshot restoration */ ResponseApplySnapshotChunk_Result[ResponseApplySnapshotChunk_Result["ABORT"] = 2] = "ABORT";
    /** RETRY - Retry chunk (combine with refetch and reject) */ ResponseApplySnapshotChunk_Result[ResponseApplySnapshotChunk_Result["RETRY"] = 3] = "RETRY";
    /** RETRY_SNAPSHOT - Retry snapshot (combine with refetch and reject) */ ResponseApplySnapshotChunk_Result[ResponseApplySnapshotChunk_Result["RETRY_SNAPSHOT"] = 4] = "RETRY_SNAPSHOT";
    /** REJECT_SNAPSHOT - Reject this snapshot, try others */ ResponseApplySnapshotChunk_Result[ResponseApplySnapshotChunk_Result["REJECT_SNAPSHOT"] = 5] = "REJECT_SNAPSHOT";
    ResponseApplySnapshotChunk_Result[ResponseApplySnapshotChunk_Result["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})($55d7da6fb7010b2f$var$ResponseApplySnapshotChunk_Result = $55d7da6fb7010b2f$exports.ResponseApplySnapshotChunk_Result || ($55d7da6fb7010b2f$exports.ResponseApplySnapshotChunk_Result = {}));
function $55d7da6fb7010b2f$var$responseApplySnapshotChunk_ResultFromJSON(object) {
    switch(object){
        case 0:
        case "UNKNOWN":
            return $55d7da6fb7010b2f$var$ResponseApplySnapshotChunk_Result.UNKNOWN;
        case 1:
        case "ACCEPT":
            return $55d7da6fb7010b2f$var$ResponseApplySnapshotChunk_Result.ACCEPT;
        case 2:
        case "ABORT":
            return $55d7da6fb7010b2f$var$ResponseApplySnapshotChunk_Result.ABORT;
        case 3:
        case "RETRY":
            return $55d7da6fb7010b2f$var$ResponseApplySnapshotChunk_Result.RETRY;
        case 4:
        case "RETRY_SNAPSHOT":
            return $55d7da6fb7010b2f$var$ResponseApplySnapshotChunk_Result.RETRY_SNAPSHOT;
        case 5:
        case "REJECT_SNAPSHOT":
            return $55d7da6fb7010b2f$var$ResponseApplySnapshotChunk_Result.REJECT_SNAPSHOT;
        case -1:
        case "UNRECOGNIZED":
        default:
            return $55d7da6fb7010b2f$var$ResponseApplySnapshotChunk_Result.UNRECOGNIZED;
    }
}
$55d7da6fb7010b2f$exports.responseApplySnapshotChunk_ResultFromJSON = $55d7da6fb7010b2f$var$responseApplySnapshotChunk_ResultFromJSON;
function $55d7da6fb7010b2f$var$responseApplySnapshotChunk_ResultToJSON(object) {
    switch(object){
        case $55d7da6fb7010b2f$var$ResponseApplySnapshotChunk_Result.UNKNOWN:
            return "UNKNOWN";
        case $55d7da6fb7010b2f$var$ResponseApplySnapshotChunk_Result.ACCEPT:
            return "ACCEPT";
        case $55d7da6fb7010b2f$var$ResponseApplySnapshotChunk_Result.ABORT:
            return "ABORT";
        case $55d7da6fb7010b2f$var$ResponseApplySnapshotChunk_Result.RETRY:
            return "RETRY";
        case $55d7da6fb7010b2f$var$ResponseApplySnapshotChunk_Result.RETRY_SNAPSHOT:
            return "RETRY_SNAPSHOT";
        case $55d7da6fb7010b2f$var$ResponseApplySnapshotChunk_Result.REJECT_SNAPSHOT:
            return "REJECT_SNAPSHOT";
        case $55d7da6fb7010b2f$var$ResponseApplySnapshotChunk_Result.UNRECOGNIZED:
        default:
            return "UNRECOGNIZED";
    }
}
$55d7da6fb7010b2f$exports.responseApplySnapshotChunk_ResultToJSON = $55d7da6fb7010b2f$var$responseApplySnapshotChunk_ResultToJSON;
var $55d7da6fb7010b2f$var$ResponseProcessProposal_ProposalStatus;
(function(ResponseProcessProposal_ProposalStatus) {
    ResponseProcessProposal_ProposalStatus[ResponseProcessProposal_ProposalStatus["UNKNOWN"] = 0] = "UNKNOWN";
    ResponseProcessProposal_ProposalStatus[ResponseProcessProposal_ProposalStatus["ACCEPT"] = 1] = "ACCEPT";
    ResponseProcessProposal_ProposalStatus[ResponseProcessProposal_ProposalStatus["REJECT"] = 2] = "REJECT";
    ResponseProcessProposal_ProposalStatus[ResponseProcessProposal_ProposalStatus["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})($55d7da6fb7010b2f$var$ResponseProcessProposal_ProposalStatus = $55d7da6fb7010b2f$exports.ResponseProcessProposal_ProposalStatus || ($55d7da6fb7010b2f$exports.ResponseProcessProposal_ProposalStatus = {}));
function $55d7da6fb7010b2f$var$responseProcessProposal_ProposalStatusFromJSON(object) {
    switch(object){
        case 0:
        case "UNKNOWN":
            return $55d7da6fb7010b2f$var$ResponseProcessProposal_ProposalStatus.UNKNOWN;
        case 1:
        case "ACCEPT":
            return $55d7da6fb7010b2f$var$ResponseProcessProposal_ProposalStatus.ACCEPT;
        case 2:
        case "REJECT":
            return $55d7da6fb7010b2f$var$ResponseProcessProposal_ProposalStatus.REJECT;
        case -1:
        case "UNRECOGNIZED":
        default:
            return $55d7da6fb7010b2f$var$ResponseProcessProposal_ProposalStatus.UNRECOGNIZED;
    }
}
$55d7da6fb7010b2f$exports.responseProcessProposal_ProposalStatusFromJSON = $55d7da6fb7010b2f$var$responseProcessProposal_ProposalStatusFromJSON;
function $55d7da6fb7010b2f$var$responseProcessProposal_ProposalStatusToJSON(object) {
    switch(object){
        case $55d7da6fb7010b2f$var$ResponseProcessProposal_ProposalStatus.UNKNOWN:
            return "UNKNOWN";
        case $55d7da6fb7010b2f$var$ResponseProcessProposal_ProposalStatus.ACCEPT:
            return "ACCEPT";
        case $55d7da6fb7010b2f$var$ResponseProcessProposal_ProposalStatus.REJECT:
            return "REJECT";
        case $55d7da6fb7010b2f$var$ResponseProcessProposal_ProposalStatus.UNRECOGNIZED:
        default:
            return "UNRECOGNIZED";
    }
}
$55d7da6fb7010b2f$exports.responseProcessProposal_ProposalStatusToJSON = $55d7da6fb7010b2f$var$responseProcessProposal_ProposalStatusToJSON;
var $55d7da6fb7010b2f$var$MisbehaviorType;
(function(MisbehaviorType) {
    MisbehaviorType[MisbehaviorType["UNKNOWN"] = 0] = "UNKNOWN";
    MisbehaviorType[MisbehaviorType["DUPLICATE_VOTE"] = 1] = "DUPLICATE_VOTE";
    MisbehaviorType[MisbehaviorType["LIGHT_CLIENT_ATTACK"] = 2] = "LIGHT_CLIENT_ATTACK";
    MisbehaviorType[MisbehaviorType["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})($55d7da6fb7010b2f$var$MisbehaviorType = $55d7da6fb7010b2f$exports.MisbehaviorType || ($55d7da6fb7010b2f$exports.MisbehaviorType = {}));
function $55d7da6fb7010b2f$var$misbehaviorTypeFromJSON(object) {
    switch(object){
        case 0:
        case "UNKNOWN":
            return $55d7da6fb7010b2f$var$MisbehaviorType.UNKNOWN;
        case 1:
        case "DUPLICATE_VOTE":
            return $55d7da6fb7010b2f$var$MisbehaviorType.DUPLICATE_VOTE;
        case 2:
        case "LIGHT_CLIENT_ATTACK":
            return $55d7da6fb7010b2f$var$MisbehaviorType.LIGHT_CLIENT_ATTACK;
        case -1:
        case "UNRECOGNIZED":
        default:
            return $55d7da6fb7010b2f$var$MisbehaviorType.UNRECOGNIZED;
    }
}
$55d7da6fb7010b2f$exports.misbehaviorTypeFromJSON = $55d7da6fb7010b2f$var$misbehaviorTypeFromJSON;
function $55d7da6fb7010b2f$var$misbehaviorTypeToJSON(object) {
    switch(object){
        case $55d7da6fb7010b2f$var$MisbehaviorType.UNKNOWN:
            return "UNKNOWN";
        case $55d7da6fb7010b2f$var$MisbehaviorType.DUPLICATE_VOTE:
            return "DUPLICATE_VOTE";
        case $55d7da6fb7010b2f$var$MisbehaviorType.LIGHT_CLIENT_ATTACK:
            return "LIGHT_CLIENT_ATTACK";
        case $55d7da6fb7010b2f$var$MisbehaviorType.UNRECOGNIZED:
        default:
            return "UNRECOGNIZED";
    }
}
$55d7da6fb7010b2f$exports.misbehaviorTypeToJSON = $55d7da6fb7010b2f$var$misbehaviorTypeToJSON;
function $55d7da6fb7010b2f$var$createBaseRequest() {
    return {
        echo: undefined,
        flush: undefined,
        info: undefined,
        initChain: undefined,
        query: undefined,
        beginBlock: undefined,
        checkTx: undefined,
        deliverTx: undefined,
        endBlock: undefined,
        commit: undefined,
        listSnapshots: undefined,
        offerSnapshot: undefined,
        loadSnapshotChunk: undefined,
        applySnapshotChunk: undefined,
        prepareProposal: undefined,
        processProposal: undefined
    };
}
$55d7da6fb7010b2f$exports.Request = {
    encode (message, writer = $55d7da6fb7010b2f$var$_m0.Writer.create()) {
        if (message.echo !== undefined) $55d7da6fb7010b2f$exports.RequestEcho.encode(message.echo, writer.uint32(10).fork()).ldelim();
        if (message.flush !== undefined) $55d7da6fb7010b2f$exports.RequestFlush.encode(message.flush, writer.uint32(18).fork()).ldelim();
        if (message.info !== undefined) $55d7da6fb7010b2f$exports.RequestInfo.encode(message.info, writer.uint32(26).fork()).ldelim();
        if (message.initChain !== undefined) $55d7da6fb7010b2f$exports.RequestInitChain.encode(message.initChain, writer.uint32(42).fork()).ldelim();
        if (message.query !== undefined) $55d7da6fb7010b2f$exports.RequestQuery.encode(message.query, writer.uint32(50).fork()).ldelim();
        if (message.beginBlock !== undefined) $55d7da6fb7010b2f$exports.RequestBeginBlock.encode(message.beginBlock, writer.uint32(58).fork()).ldelim();
        if (message.checkTx !== undefined) $55d7da6fb7010b2f$exports.RequestCheckTx.encode(message.checkTx, writer.uint32(66).fork()).ldelim();
        if (message.deliverTx !== undefined) $55d7da6fb7010b2f$exports.RequestDeliverTx.encode(message.deliverTx, writer.uint32(74).fork()).ldelim();
        if (message.endBlock !== undefined) $55d7da6fb7010b2f$exports.RequestEndBlock.encode(message.endBlock, writer.uint32(82).fork()).ldelim();
        if (message.commit !== undefined) $55d7da6fb7010b2f$exports.RequestCommit.encode(message.commit, writer.uint32(90).fork()).ldelim();
        if (message.listSnapshots !== undefined) $55d7da6fb7010b2f$exports.RequestListSnapshots.encode(message.listSnapshots, writer.uint32(98).fork()).ldelim();
        if (message.offerSnapshot !== undefined) $55d7da6fb7010b2f$exports.RequestOfferSnapshot.encode(message.offerSnapshot, writer.uint32(106).fork()).ldelim();
        if (message.loadSnapshotChunk !== undefined) $55d7da6fb7010b2f$exports.RequestLoadSnapshotChunk.encode(message.loadSnapshotChunk, writer.uint32(114).fork()).ldelim();
        if (message.applySnapshotChunk !== undefined) $55d7da6fb7010b2f$exports.RequestApplySnapshotChunk.encode(message.applySnapshotChunk, writer.uint32(122).fork()).ldelim();
        if (message.prepareProposal !== undefined) $55d7da6fb7010b2f$exports.RequestPrepareProposal.encode(message.prepareProposal, writer.uint32(130).fork()).ldelim();
        if (message.processProposal !== undefined) $55d7da6fb7010b2f$exports.RequestProcessProposal.encode(message.processProposal, writer.uint32(138).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $55d7da6fb7010b2f$var$_m0.Reader ? input : new $55d7da6fb7010b2f$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $55d7da6fb7010b2f$var$createBaseRequest();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.echo = $55d7da6fb7010b2f$exports.RequestEcho.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.flush = $55d7da6fb7010b2f$exports.RequestFlush.decode(reader, reader.uint32());
                    break;
                case 3:
                    message.info = $55d7da6fb7010b2f$exports.RequestInfo.decode(reader, reader.uint32());
                    break;
                case 5:
                    message.initChain = $55d7da6fb7010b2f$exports.RequestInitChain.decode(reader, reader.uint32());
                    break;
                case 6:
                    message.query = $55d7da6fb7010b2f$exports.RequestQuery.decode(reader, reader.uint32());
                    break;
                case 7:
                    message.beginBlock = $55d7da6fb7010b2f$exports.RequestBeginBlock.decode(reader, reader.uint32());
                    break;
                case 8:
                    message.checkTx = $55d7da6fb7010b2f$exports.RequestCheckTx.decode(reader, reader.uint32());
                    break;
                case 9:
                    message.deliverTx = $55d7da6fb7010b2f$exports.RequestDeliverTx.decode(reader, reader.uint32());
                    break;
                case 10:
                    message.endBlock = $55d7da6fb7010b2f$exports.RequestEndBlock.decode(reader, reader.uint32());
                    break;
                case 11:
                    message.commit = $55d7da6fb7010b2f$exports.RequestCommit.decode(reader, reader.uint32());
                    break;
                case 12:
                    message.listSnapshots = $55d7da6fb7010b2f$exports.RequestListSnapshots.decode(reader, reader.uint32());
                    break;
                case 13:
                    message.offerSnapshot = $55d7da6fb7010b2f$exports.RequestOfferSnapshot.decode(reader, reader.uint32());
                    break;
                case 14:
                    message.loadSnapshotChunk = $55d7da6fb7010b2f$exports.RequestLoadSnapshotChunk.decode(reader, reader.uint32());
                    break;
                case 15:
                    message.applySnapshotChunk = $55d7da6fb7010b2f$exports.RequestApplySnapshotChunk.decode(reader, reader.uint32());
                    break;
                case 16:
                    message.prepareProposal = $55d7da6fb7010b2f$exports.RequestPrepareProposal.decode(reader, reader.uint32());
                    break;
                case 17:
                    message.processProposal = $55d7da6fb7010b2f$exports.RequestProcessProposal.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            echo: (0, $d5e07fe2518aae94$exports.isSet)(object.echo) ? $55d7da6fb7010b2f$exports.RequestEcho.fromJSON(object.echo) : undefined,
            flush: (0, $d5e07fe2518aae94$exports.isSet)(object.flush) ? $55d7da6fb7010b2f$exports.RequestFlush.fromJSON(object.flush) : undefined,
            info: (0, $d5e07fe2518aae94$exports.isSet)(object.info) ? $55d7da6fb7010b2f$exports.RequestInfo.fromJSON(object.info) : undefined,
            initChain: (0, $d5e07fe2518aae94$exports.isSet)(object.initChain) ? $55d7da6fb7010b2f$exports.RequestInitChain.fromJSON(object.initChain) : undefined,
            query: (0, $d5e07fe2518aae94$exports.isSet)(object.query) ? $55d7da6fb7010b2f$exports.RequestQuery.fromJSON(object.query) : undefined,
            beginBlock: (0, $d5e07fe2518aae94$exports.isSet)(object.beginBlock) ? $55d7da6fb7010b2f$exports.RequestBeginBlock.fromJSON(object.beginBlock) : undefined,
            checkTx: (0, $d5e07fe2518aae94$exports.isSet)(object.checkTx) ? $55d7da6fb7010b2f$exports.RequestCheckTx.fromJSON(object.checkTx) : undefined,
            deliverTx: (0, $d5e07fe2518aae94$exports.isSet)(object.deliverTx) ? $55d7da6fb7010b2f$exports.RequestDeliverTx.fromJSON(object.deliverTx) : undefined,
            endBlock: (0, $d5e07fe2518aae94$exports.isSet)(object.endBlock) ? $55d7da6fb7010b2f$exports.RequestEndBlock.fromJSON(object.endBlock) : undefined,
            commit: (0, $d5e07fe2518aae94$exports.isSet)(object.commit) ? $55d7da6fb7010b2f$exports.RequestCommit.fromJSON(object.commit) : undefined,
            listSnapshots: (0, $d5e07fe2518aae94$exports.isSet)(object.listSnapshots) ? $55d7da6fb7010b2f$exports.RequestListSnapshots.fromJSON(object.listSnapshots) : undefined,
            offerSnapshot: (0, $d5e07fe2518aae94$exports.isSet)(object.offerSnapshot) ? $55d7da6fb7010b2f$exports.RequestOfferSnapshot.fromJSON(object.offerSnapshot) : undefined,
            loadSnapshotChunk: (0, $d5e07fe2518aae94$exports.isSet)(object.loadSnapshotChunk) ? $55d7da6fb7010b2f$exports.RequestLoadSnapshotChunk.fromJSON(object.loadSnapshotChunk) : undefined,
            applySnapshotChunk: (0, $d5e07fe2518aae94$exports.isSet)(object.applySnapshotChunk) ? $55d7da6fb7010b2f$exports.RequestApplySnapshotChunk.fromJSON(object.applySnapshotChunk) : undefined,
            prepareProposal: (0, $d5e07fe2518aae94$exports.isSet)(object.prepareProposal) ? $55d7da6fb7010b2f$exports.RequestPrepareProposal.fromJSON(object.prepareProposal) : undefined,
            processProposal: (0, $d5e07fe2518aae94$exports.isSet)(object.processProposal) ? $55d7da6fb7010b2f$exports.RequestProcessProposal.fromJSON(object.processProposal) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.echo !== undefined && (obj.echo = message.echo ? $55d7da6fb7010b2f$exports.RequestEcho.toJSON(message.echo) : undefined);
        message.flush !== undefined && (obj.flush = message.flush ? $55d7da6fb7010b2f$exports.RequestFlush.toJSON(message.flush) : undefined);
        message.info !== undefined && (obj.info = message.info ? $55d7da6fb7010b2f$exports.RequestInfo.toJSON(message.info) : undefined);
        message.initChain !== undefined && (obj.initChain = message.initChain ? $55d7da6fb7010b2f$exports.RequestInitChain.toJSON(message.initChain) : undefined);
        message.query !== undefined && (obj.query = message.query ? $55d7da6fb7010b2f$exports.RequestQuery.toJSON(message.query) : undefined);
        message.beginBlock !== undefined && (obj.beginBlock = message.beginBlock ? $55d7da6fb7010b2f$exports.RequestBeginBlock.toJSON(message.beginBlock) : undefined);
        message.checkTx !== undefined && (obj.checkTx = message.checkTx ? $55d7da6fb7010b2f$exports.RequestCheckTx.toJSON(message.checkTx) : undefined);
        message.deliverTx !== undefined && (obj.deliverTx = message.deliverTx ? $55d7da6fb7010b2f$exports.RequestDeliverTx.toJSON(message.deliverTx) : undefined);
        message.endBlock !== undefined && (obj.endBlock = message.endBlock ? $55d7da6fb7010b2f$exports.RequestEndBlock.toJSON(message.endBlock) : undefined);
        message.commit !== undefined && (obj.commit = message.commit ? $55d7da6fb7010b2f$exports.RequestCommit.toJSON(message.commit) : undefined);
        message.listSnapshots !== undefined && (obj.listSnapshots = message.listSnapshots ? $55d7da6fb7010b2f$exports.RequestListSnapshots.toJSON(message.listSnapshots) : undefined);
        message.offerSnapshot !== undefined && (obj.offerSnapshot = message.offerSnapshot ? $55d7da6fb7010b2f$exports.RequestOfferSnapshot.toJSON(message.offerSnapshot) : undefined);
        message.loadSnapshotChunk !== undefined && (obj.loadSnapshotChunk = message.loadSnapshotChunk ? $55d7da6fb7010b2f$exports.RequestLoadSnapshotChunk.toJSON(message.loadSnapshotChunk) : undefined);
        message.applySnapshotChunk !== undefined && (obj.applySnapshotChunk = message.applySnapshotChunk ? $55d7da6fb7010b2f$exports.RequestApplySnapshotChunk.toJSON(message.applySnapshotChunk) : undefined);
        message.prepareProposal !== undefined && (obj.prepareProposal = message.prepareProposal ? $55d7da6fb7010b2f$exports.RequestPrepareProposal.toJSON(message.prepareProposal) : undefined);
        message.processProposal !== undefined && (obj.processProposal = message.processProposal ? $55d7da6fb7010b2f$exports.RequestProcessProposal.toJSON(message.processProposal) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $55d7da6fb7010b2f$var$createBaseRequest();
        message.echo = object.echo !== undefined && object.echo !== null ? $55d7da6fb7010b2f$exports.RequestEcho.fromPartial(object.echo) : undefined;
        message.flush = object.flush !== undefined && object.flush !== null ? $55d7da6fb7010b2f$exports.RequestFlush.fromPartial(object.flush) : undefined;
        message.info = object.info !== undefined && object.info !== null ? $55d7da6fb7010b2f$exports.RequestInfo.fromPartial(object.info) : undefined;
        message.initChain = object.initChain !== undefined && object.initChain !== null ? $55d7da6fb7010b2f$exports.RequestInitChain.fromPartial(object.initChain) : undefined;
        message.query = object.query !== undefined && object.query !== null ? $55d7da6fb7010b2f$exports.RequestQuery.fromPartial(object.query) : undefined;
        message.beginBlock = object.beginBlock !== undefined && object.beginBlock !== null ? $55d7da6fb7010b2f$exports.RequestBeginBlock.fromPartial(object.beginBlock) : undefined;
        message.checkTx = object.checkTx !== undefined && object.checkTx !== null ? $55d7da6fb7010b2f$exports.RequestCheckTx.fromPartial(object.checkTx) : undefined;
        message.deliverTx = object.deliverTx !== undefined && object.deliverTx !== null ? $55d7da6fb7010b2f$exports.RequestDeliverTx.fromPartial(object.deliverTx) : undefined;
        message.endBlock = object.endBlock !== undefined && object.endBlock !== null ? $55d7da6fb7010b2f$exports.RequestEndBlock.fromPartial(object.endBlock) : undefined;
        message.commit = object.commit !== undefined && object.commit !== null ? $55d7da6fb7010b2f$exports.RequestCommit.fromPartial(object.commit) : undefined;
        message.listSnapshots = object.listSnapshots !== undefined && object.listSnapshots !== null ? $55d7da6fb7010b2f$exports.RequestListSnapshots.fromPartial(object.listSnapshots) : undefined;
        message.offerSnapshot = object.offerSnapshot !== undefined && object.offerSnapshot !== null ? $55d7da6fb7010b2f$exports.RequestOfferSnapshot.fromPartial(object.offerSnapshot) : undefined;
        message.loadSnapshotChunk = object.loadSnapshotChunk !== undefined && object.loadSnapshotChunk !== null ? $55d7da6fb7010b2f$exports.RequestLoadSnapshotChunk.fromPartial(object.loadSnapshotChunk) : undefined;
        message.applySnapshotChunk = object.applySnapshotChunk !== undefined && object.applySnapshotChunk !== null ? $55d7da6fb7010b2f$exports.RequestApplySnapshotChunk.fromPartial(object.applySnapshotChunk) : undefined;
        message.prepareProposal = object.prepareProposal !== undefined && object.prepareProposal !== null ? $55d7da6fb7010b2f$exports.RequestPrepareProposal.fromPartial(object.prepareProposal) : undefined;
        message.processProposal = object.processProposal !== undefined && object.processProposal !== null ? $55d7da6fb7010b2f$exports.RequestProcessProposal.fromPartial(object.processProposal) : undefined;
        return message;
    }
};
function $55d7da6fb7010b2f$var$createBaseRequestEcho() {
    return {
        message: ""
    };
}
$55d7da6fb7010b2f$exports.RequestEcho = {
    encode (message, writer = $55d7da6fb7010b2f$var$_m0.Writer.create()) {
        if (message.message !== "") writer.uint32(10).string(message.message);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $55d7da6fb7010b2f$var$_m0.Reader ? input : new $55d7da6fb7010b2f$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $55d7da6fb7010b2f$var$createBaseRequestEcho();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.message = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            message: (0, $d5e07fe2518aae94$exports.isSet)(object.message) ? String(object.message) : ""
        };
    },
    toJSON (message) {
        const obj = {};
        message.message !== undefined && (obj.message = message.message);
        return obj;
    },
    fromPartial (object) {
        const message = $55d7da6fb7010b2f$var$createBaseRequestEcho();
        message.message = object.message ?? "";
        return message;
    }
};
function $55d7da6fb7010b2f$var$createBaseRequestFlush() {
    return {};
}
$55d7da6fb7010b2f$exports.RequestFlush = {
    encode (_, writer = $55d7da6fb7010b2f$var$_m0.Writer.create()) {
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $55d7da6fb7010b2f$var$_m0.Reader ? input : new $55d7da6fb7010b2f$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $55d7da6fb7010b2f$var$createBaseRequestFlush();
        while(reader.pos < end){
            const tag = reader.uint32();
            tag;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON (_) {
        return {};
    },
    toJSON (_) {
        const obj = {};
        return obj;
    },
    fromPartial (_) {
        const message = $55d7da6fb7010b2f$var$createBaseRequestFlush();
        return message;
    }
};
function $55d7da6fb7010b2f$var$createBaseRequestInfo() {
    return {
        version: "",
        blockVersion: $d5e07fe2518aae94$exports.Long.UZERO,
        p2pVersion: $d5e07fe2518aae94$exports.Long.UZERO,
        abciVersion: ""
    };
}
$55d7da6fb7010b2f$exports.RequestInfo = {
    encode (message, writer = $55d7da6fb7010b2f$var$_m0.Writer.create()) {
        if (message.version !== "") writer.uint32(10).string(message.version);
        if (!message.blockVersion.isZero()) writer.uint32(16).uint64(message.blockVersion);
        if (!message.p2pVersion.isZero()) writer.uint32(24).uint64(message.p2pVersion);
        if (message.abciVersion !== "") writer.uint32(34).string(message.abciVersion);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $55d7da6fb7010b2f$var$_m0.Reader ? input : new $55d7da6fb7010b2f$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $55d7da6fb7010b2f$var$createBaseRequestInfo();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.version = reader.string();
                    break;
                case 2:
                    message.blockVersion = reader.uint64();
                    break;
                case 3:
                    message.p2pVersion = reader.uint64();
                    break;
                case 4:
                    message.abciVersion = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            version: (0, $d5e07fe2518aae94$exports.isSet)(object.version) ? String(object.version) : "",
            blockVersion: (0, $d5e07fe2518aae94$exports.isSet)(object.blockVersion) ? $d5e07fe2518aae94$exports.Long.fromValue(object.blockVersion) : $d5e07fe2518aae94$exports.Long.UZERO,
            p2pVersion: (0, $d5e07fe2518aae94$exports.isSet)(object.p2pVersion) ? $d5e07fe2518aae94$exports.Long.fromValue(object.p2pVersion) : $d5e07fe2518aae94$exports.Long.UZERO,
            abciVersion: (0, $d5e07fe2518aae94$exports.isSet)(object.abciVersion) ? String(object.abciVersion) : ""
        };
    },
    toJSON (message) {
        const obj = {};
        message.version !== undefined && (obj.version = message.version);
        message.blockVersion !== undefined && (obj.blockVersion = (message.blockVersion || $d5e07fe2518aae94$exports.Long.UZERO).toString());
        message.p2pVersion !== undefined && (obj.p2pVersion = (message.p2pVersion || $d5e07fe2518aae94$exports.Long.UZERO).toString());
        message.abciVersion !== undefined && (obj.abciVersion = message.abciVersion);
        return obj;
    },
    fromPartial (object) {
        const message = $55d7da6fb7010b2f$var$createBaseRequestInfo();
        message.version = object.version ?? "";
        message.blockVersion = object.blockVersion !== undefined && object.blockVersion !== null ? $d5e07fe2518aae94$exports.Long.fromValue(object.blockVersion) : $d5e07fe2518aae94$exports.Long.UZERO;
        message.p2pVersion = object.p2pVersion !== undefined && object.p2pVersion !== null ? $d5e07fe2518aae94$exports.Long.fromValue(object.p2pVersion) : $d5e07fe2518aae94$exports.Long.UZERO;
        message.abciVersion = object.abciVersion ?? "";
        return message;
    }
};
function $55d7da6fb7010b2f$var$createBaseRequestInitChain() {
    return {
        time: undefined,
        chainId: "",
        consensusParams: undefined,
        validators: [],
        appStateBytes: new Uint8Array(),
        initialHeight: $d5e07fe2518aae94$exports.Long.ZERO
    };
}
$55d7da6fb7010b2f$exports.RequestInitChain = {
    encode (message, writer = $55d7da6fb7010b2f$var$_m0.Writer.create()) {
        if (message.time !== undefined) $e7eaeedc85b414fc$exports.Timestamp.encode(message.time, writer.uint32(10).fork()).ldelim();
        if (message.chainId !== "") writer.uint32(18).string(message.chainId);
        if (message.consensusParams !== undefined) $134a665e0e74d535$exports.ConsensusParams.encode(message.consensusParams, writer.uint32(26).fork()).ldelim();
        for (const v of message.validators)$55d7da6fb7010b2f$exports.ValidatorUpdate.encode(v, writer.uint32(34).fork()).ldelim();
        if (message.appStateBytes.length !== 0) writer.uint32(42).bytes(message.appStateBytes);
        if (!message.initialHeight.isZero()) writer.uint32(48).int64(message.initialHeight);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $55d7da6fb7010b2f$var$_m0.Reader ? input : new $55d7da6fb7010b2f$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $55d7da6fb7010b2f$var$createBaseRequestInitChain();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.time = $e7eaeedc85b414fc$exports.Timestamp.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.chainId = reader.string();
                    break;
                case 3:
                    message.consensusParams = $134a665e0e74d535$exports.ConsensusParams.decode(reader, reader.uint32());
                    break;
                case 4:
                    message.validators.push($55d7da6fb7010b2f$exports.ValidatorUpdate.decode(reader, reader.uint32()));
                    break;
                case 5:
                    message.appStateBytes = reader.bytes();
                    break;
                case 6:
                    message.initialHeight = reader.int64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            time: (0, $d5e07fe2518aae94$exports.isSet)(object.time) ? (0, $d5e07fe2518aae94$exports.fromJsonTimestamp)(object.time) : undefined,
            chainId: (0, $d5e07fe2518aae94$exports.isSet)(object.chainId) ? String(object.chainId) : "",
            consensusParams: (0, $d5e07fe2518aae94$exports.isSet)(object.consensusParams) ? $134a665e0e74d535$exports.ConsensusParams.fromJSON(object.consensusParams) : undefined,
            validators: Array.isArray(object?.validators) ? object.validators.map((e)=>$55d7da6fb7010b2f$exports.ValidatorUpdate.fromJSON(e)) : [],
            appStateBytes: (0, $d5e07fe2518aae94$exports.isSet)(object.appStateBytes) ? (0, $d5e07fe2518aae94$exports.bytesFromBase64)(object.appStateBytes) : new Uint8Array(),
            initialHeight: (0, $d5e07fe2518aae94$exports.isSet)(object.initialHeight) ? $d5e07fe2518aae94$exports.Long.fromValue(object.initialHeight) : $d5e07fe2518aae94$exports.Long.ZERO
        };
    },
    toJSON (message) {
        const obj = {};
        message.time !== undefined && (obj.time = (0, $d5e07fe2518aae94$exports.fromTimestamp)(message.time).toISOString());
        message.chainId !== undefined && (obj.chainId = message.chainId);
        message.consensusParams !== undefined && (obj.consensusParams = message.consensusParams ? $134a665e0e74d535$exports.ConsensusParams.toJSON(message.consensusParams) : undefined);
        if (message.validators) obj.validators = message.validators.map((e)=>e ? $55d7da6fb7010b2f$exports.ValidatorUpdate.toJSON(e) : undefined);
        else obj.validators = [];
        message.appStateBytes !== undefined && (obj.appStateBytes = (0, $d5e07fe2518aae94$exports.base64FromBytes)(message.appStateBytes !== undefined ? message.appStateBytes : new Uint8Array()));
        message.initialHeight !== undefined && (obj.initialHeight = (message.initialHeight || $d5e07fe2518aae94$exports.Long.ZERO).toString());
        return obj;
    },
    fromPartial (object) {
        const message = $55d7da6fb7010b2f$var$createBaseRequestInitChain();
        message.time = object.time !== undefined && object.time !== null ? $e7eaeedc85b414fc$exports.Timestamp.fromPartial(object.time) : undefined;
        message.chainId = object.chainId ?? "";
        message.consensusParams = object.consensusParams !== undefined && object.consensusParams !== null ? $134a665e0e74d535$exports.ConsensusParams.fromPartial(object.consensusParams) : undefined;
        message.validators = object.validators?.map((e)=>$55d7da6fb7010b2f$exports.ValidatorUpdate.fromPartial(e)) || [];
        message.appStateBytes = object.appStateBytes ?? new Uint8Array();
        message.initialHeight = object.initialHeight !== undefined && object.initialHeight !== null ? $d5e07fe2518aae94$exports.Long.fromValue(object.initialHeight) : $d5e07fe2518aae94$exports.Long.ZERO;
        return message;
    }
};
function $55d7da6fb7010b2f$var$createBaseRequestQuery() {
    return {
        data: new Uint8Array(),
        path: "",
        height: $d5e07fe2518aae94$exports.Long.ZERO,
        prove: false
    };
}
$55d7da6fb7010b2f$exports.RequestQuery = {
    encode (message, writer = $55d7da6fb7010b2f$var$_m0.Writer.create()) {
        if (message.data.length !== 0) writer.uint32(10).bytes(message.data);
        if (message.path !== "") writer.uint32(18).string(message.path);
        if (!message.height.isZero()) writer.uint32(24).int64(message.height);
        if (message.prove === true) writer.uint32(32).bool(message.prove);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $55d7da6fb7010b2f$var$_m0.Reader ? input : new $55d7da6fb7010b2f$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $55d7da6fb7010b2f$var$createBaseRequestQuery();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.data = reader.bytes();
                    break;
                case 2:
                    message.path = reader.string();
                    break;
                case 3:
                    message.height = reader.int64();
                    break;
                case 4:
                    message.prove = reader.bool();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            data: (0, $d5e07fe2518aae94$exports.isSet)(object.data) ? (0, $d5e07fe2518aae94$exports.bytesFromBase64)(object.data) : new Uint8Array(),
            path: (0, $d5e07fe2518aae94$exports.isSet)(object.path) ? String(object.path) : "",
            height: (0, $d5e07fe2518aae94$exports.isSet)(object.height) ? $d5e07fe2518aae94$exports.Long.fromValue(object.height) : $d5e07fe2518aae94$exports.Long.ZERO,
            prove: (0, $d5e07fe2518aae94$exports.isSet)(object.prove) ? Boolean(object.prove) : false
        };
    },
    toJSON (message) {
        const obj = {};
        message.data !== undefined && (obj.data = (0, $d5e07fe2518aae94$exports.base64FromBytes)(message.data !== undefined ? message.data : new Uint8Array()));
        message.path !== undefined && (obj.path = message.path);
        message.height !== undefined && (obj.height = (message.height || $d5e07fe2518aae94$exports.Long.ZERO).toString());
        message.prove !== undefined && (obj.prove = message.prove);
        return obj;
    },
    fromPartial (object) {
        const message = $55d7da6fb7010b2f$var$createBaseRequestQuery();
        message.data = object.data ?? new Uint8Array();
        message.path = object.path ?? "";
        message.height = object.height !== undefined && object.height !== null ? $d5e07fe2518aae94$exports.Long.fromValue(object.height) : $d5e07fe2518aae94$exports.Long.ZERO;
        message.prove = object.prove ?? false;
        return message;
    }
};
function $55d7da6fb7010b2f$var$createBaseRequestBeginBlock() {
    return {
        hash: new Uint8Array(),
        header: undefined,
        lastCommitInfo: undefined,
        byzantineValidators: []
    };
}
$55d7da6fb7010b2f$exports.RequestBeginBlock = {
    encode (message, writer = $55d7da6fb7010b2f$var$_m0.Writer.create()) {
        if (message.hash.length !== 0) writer.uint32(10).bytes(message.hash);
        if (message.header !== undefined) $c51af120eef1efed$exports.Header.encode(message.header, writer.uint32(18).fork()).ldelim();
        if (message.lastCommitInfo !== undefined) $55d7da6fb7010b2f$exports.CommitInfo.encode(message.lastCommitInfo, writer.uint32(26).fork()).ldelim();
        for (const v of message.byzantineValidators)$55d7da6fb7010b2f$exports.Misbehavior.encode(v, writer.uint32(34).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $55d7da6fb7010b2f$var$_m0.Reader ? input : new $55d7da6fb7010b2f$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $55d7da6fb7010b2f$var$createBaseRequestBeginBlock();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.hash = reader.bytes();
                    break;
                case 2:
                    message.header = $c51af120eef1efed$exports.Header.decode(reader, reader.uint32());
                    break;
                case 3:
                    message.lastCommitInfo = $55d7da6fb7010b2f$exports.CommitInfo.decode(reader, reader.uint32());
                    break;
                case 4:
                    message.byzantineValidators.push($55d7da6fb7010b2f$exports.Misbehavior.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            hash: (0, $d5e07fe2518aae94$exports.isSet)(object.hash) ? (0, $d5e07fe2518aae94$exports.bytesFromBase64)(object.hash) : new Uint8Array(),
            header: (0, $d5e07fe2518aae94$exports.isSet)(object.header) ? $c51af120eef1efed$exports.Header.fromJSON(object.header) : undefined,
            lastCommitInfo: (0, $d5e07fe2518aae94$exports.isSet)(object.lastCommitInfo) ? $55d7da6fb7010b2f$exports.CommitInfo.fromJSON(object.lastCommitInfo) : undefined,
            byzantineValidators: Array.isArray(object?.byzantineValidators) ? object.byzantineValidators.map((e)=>$55d7da6fb7010b2f$exports.Misbehavior.fromJSON(e)) : []
        };
    },
    toJSON (message) {
        const obj = {};
        message.hash !== undefined && (obj.hash = (0, $d5e07fe2518aae94$exports.base64FromBytes)(message.hash !== undefined ? message.hash : new Uint8Array()));
        message.header !== undefined && (obj.header = message.header ? $c51af120eef1efed$exports.Header.toJSON(message.header) : undefined);
        message.lastCommitInfo !== undefined && (obj.lastCommitInfo = message.lastCommitInfo ? $55d7da6fb7010b2f$exports.CommitInfo.toJSON(message.lastCommitInfo) : undefined);
        if (message.byzantineValidators) obj.byzantineValidators = message.byzantineValidators.map((e)=>e ? $55d7da6fb7010b2f$exports.Misbehavior.toJSON(e) : undefined);
        else obj.byzantineValidators = [];
        return obj;
    },
    fromPartial (object) {
        const message = $55d7da6fb7010b2f$var$createBaseRequestBeginBlock();
        message.hash = object.hash ?? new Uint8Array();
        message.header = object.header !== undefined && object.header !== null ? $c51af120eef1efed$exports.Header.fromPartial(object.header) : undefined;
        message.lastCommitInfo = object.lastCommitInfo !== undefined && object.lastCommitInfo !== null ? $55d7da6fb7010b2f$exports.CommitInfo.fromPartial(object.lastCommitInfo) : undefined;
        message.byzantineValidators = object.byzantineValidators?.map((e)=>$55d7da6fb7010b2f$exports.Misbehavior.fromPartial(e)) || [];
        return message;
    }
};
function $55d7da6fb7010b2f$var$createBaseRequestCheckTx() {
    return {
        tx: new Uint8Array(),
        type: 0
    };
}
$55d7da6fb7010b2f$exports.RequestCheckTx = {
    encode (message, writer = $55d7da6fb7010b2f$var$_m0.Writer.create()) {
        if (message.tx.length !== 0) writer.uint32(10).bytes(message.tx);
        if (message.type !== 0) writer.uint32(16).int32(message.type);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $55d7da6fb7010b2f$var$_m0.Reader ? input : new $55d7da6fb7010b2f$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $55d7da6fb7010b2f$var$createBaseRequestCheckTx();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.tx = reader.bytes();
                    break;
                case 2:
                    message.type = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            tx: (0, $d5e07fe2518aae94$exports.isSet)(object.tx) ? (0, $d5e07fe2518aae94$exports.bytesFromBase64)(object.tx) : new Uint8Array(),
            type: (0, $d5e07fe2518aae94$exports.isSet)(object.type) ? $55d7da6fb7010b2f$var$checkTxTypeFromJSON(object.type) : 0
        };
    },
    toJSON (message) {
        const obj = {};
        message.tx !== undefined && (obj.tx = (0, $d5e07fe2518aae94$exports.base64FromBytes)(message.tx !== undefined ? message.tx : new Uint8Array()));
        message.type !== undefined && (obj.type = $55d7da6fb7010b2f$var$checkTxTypeToJSON(message.type));
        return obj;
    },
    fromPartial (object) {
        const message = $55d7da6fb7010b2f$var$createBaseRequestCheckTx();
        message.tx = object.tx ?? new Uint8Array();
        message.type = object.type ?? 0;
        return message;
    }
};
function $55d7da6fb7010b2f$var$createBaseRequestDeliverTx() {
    return {
        tx: new Uint8Array()
    };
}
$55d7da6fb7010b2f$exports.RequestDeliverTx = {
    encode (message, writer = $55d7da6fb7010b2f$var$_m0.Writer.create()) {
        if (message.tx.length !== 0) writer.uint32(10).bytes(message.tx);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $55d7da6fb7010b2f$var$_m0.Reader ? input : new $55d7da6fb7010b2f$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $55d7da6fb7010b2f$var$createBaseRequestDeliverTx();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.tx = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            tx: (0, $d5e07fe2518aae94$exports.isSet)(object.tx) ? (0, $d5e07fe2518aae94$exports.bytesFromBase64)(object.tx) : new Uint8Array()
        };
    },
    toJSON (message) {
        const obj = {};
        message.tx !== undefined && (obj.tx = (0, $d5e07fe2518aae94$exports.base64FromBytes)(message.tx !== undefined ? message.tx : new Uint8Array()));
        return obj;
    },
    fromPartial (object) {
        const message = $55d7da6fb7010b2f$var$createBaseRequestDeliverTx();
        message.tx = object.tx ?? new Uint8Array();
        return message;
    }
};
function $55d7da6fb7010b2f$var$createBaseRequestEndBlock() {
    return {
        height: $d5e07fe2518aae94$exports.Long.ZERO
    };
}
$55d7da6fb7010b2f$exports.RequestEndBlock = {
    encode (message, writer = $55d7da6fb7010b2f$var$_m0.Writer.create()) {
        if (!message.height.isZero()) writer.uint32(8).int64(message.height);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $55d7da6fb7010b2f$var$_m0.Reader ? input : new $55d7da6fb7010b2f$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $55d7da6fb7010b2f$var$createBaseRequestEndBlock();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.height = reader.int64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            height: (0, $d5e07fe2518aae94$exports.isSet)(object.height) ? $d5e07fe2518aae94$exports.Long.fromValue(object.height) : $d5e07fe2518aae94$exports.Long.ZERO
        };
    },
    toJSON (message) {
        const obj = {};
        message.height !== undefined && (obj.height = (message.height || $d5e07fe2518aae94$exports.Long.ZERO).toString());
        return obj;
    },
    fromPartial (object) {
        const message = $55d7da6fb7010b2f$var$createBaseRequestEndBlock();
        message.height = object.height !== undefined && object.height !== null ? $d5e07fe2518aae94$exports.Long.fromValue(object.height) : $d5e07fe2518aae94$exports.Long.ZERO;
        return message;
    }
};
function $55d7da6fb7010b2f$var$createBaseRequestCommit() {
    return {};
}
$55d7da6fb7010b2f$exports.RequestCommit = {
    encode (_, writer = $55d7da6fb7010b2f$var$_m0.Writer.create()) {
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $55d7da6fb7010b2f$var$_m0.Reader ? input : new $55d7da6fb7010b2f$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $55d7da6fb7010b2f$var$createBaseRequestCommit();
        while(reader.pos < end){
            const tag = reader.uint32();
            tag;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON (_) {
        return {};
    },
    toJSON (_) {
        const obj = {};
        return obj;
    },
    fromPartial (_) {
        const message = $55d7da6fb7010b2f$var$createBaseRequestCommit();
        return message;
    }
};
function $55d7da6fb7010b2f$var$createBaseRequestListSnapshots() {
    return {};
}
$55d7da6fb7010b2f$exports.RequestListSnapshots = {
    encode (_, writer = $55d7da6fb7010b2f$var$_m0.Writer.create()) {
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $55d7da6fb7010b2f$var$_m0.Reader ? input : new $55d7da6fb7010b2f$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $55d7da6fb7010b2f$var$createBaseRequestListSnapshots();
        while(reader.pos < end){
            const tag = reader.uint32();
            tag;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON (_) {
        return {};
    },
    toJSON (_) {
        const obj = {};
        return obj;
    },
    fromPartial (_) {
        const message = $55d7da6fb7010b2f$var$createBaseRequestListSnapshots();
        return message;
    }
};
function $55d7da6fb7010b2f$var$createBaseRequestOfferSnapshot() {
    return {
        snapshot: undefined,
        appHash: new Uint8Array()
    };
}
$55d7da6fb7010b2f$exports.RequestOfferSnapshot = {
    encode (message, writer = $55d7da6fb7010b2f$var$_m0.Writer.create()) {
        if (message.snapshot !== undefined) $55d7da6fb7010b2f$exports.Snapshot.encode(message.snapshot, writer.uint32(10).fork()).ldelim();
        if (message.appHash.length !== 0) writer.uint32(18).bytes(message.appHash);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $55d7da6fb7010b2f$var$_m0.Reader ? input : new $55d7da6fb7010b2f$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $55d7da6fb7010b2f$var$createBaseRequestOfferSnapshot();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.snapshot = $55d7da6fb7010b2f$exports.Snapshot.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.appHash = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            snapshot: (0, $d5e07fe2518aae94$exports.isSet)(object.snapshot) ? $55d7da6fb7010b2f$exports.Snapshot.fromJSON(object.snapshot) : undefined,
            appHash: (0, $d5e07fe2518aae94$exports.isSet)(object.appHash) ? (0, $d5e07fe2518aae94$exports.bytesFromBase64)(object.appHash) : new Uint8Array()
        };
    },
    toJSON (message) {
        const obj = {};
        message.snapshot !== undefined && (obj.snapshot = message.snapshot ? $55d7da6fb7010b2f$exports.Snapshot.toJSON(message.snapshot) : undefined);
        message.appHash !== undefined && (obj.appHash = (0, $d5e07fe2518aae94$exports.base64FromBytes)(message.appHash !== undefined ? message.appHash : new Uint8Array()));
        return obj;
    },
    fromPartial (object) {
        const message = $55d7da6fb7010b2f$var$createBaseRequestOfferSnapshot();
        message.snapshot = object.snapshot !== undefined && object.snapshot !== null ? $55d7da6fb7010b2f$exports.Snapshot.fromPartial(object.snapshot) : undefined;
        message.appHash = object.appHash ?? new Uint8Array();
        return message;
    }
};
function $55d7da6fb7010b2f$var$createBaseRequestLoadSnapshotChunk() {
    return {
        height: $d5e07fe2518aae94$exports.Long.UZERO,
        format: 0,
        chunk: 0
    };
}
$55d7da6fb7010b2f$exports.RequestLoadSnapshotChunk = {
    encode (message, writer = $55d7da6fb7010b2f$var$_m0.Writer.create()) {
        if (!message.height.isZero()) writer.uint32(8).uint64(message.height);
        if (message.format !== 0) writer.uint32(16).uint32(message.format);
        if (message.chunk !== 0) writer.uint32(24).uint32(message.chunk);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $55d7da6fb7010b2f$var$_m0.Reader ? input : new $55d7da6fb7010b2f$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $55d7da6fb7010b2f$var$createBaseRequestLoadSnapshotChunk();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.height = reader.uint64();
                    break;
                case 2:
                    message.format = reader.uint32();
                    break;
                case 3:
                    message.chunk = reader.uint32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            height: (0, $d5e07fe2518aae94$exports.isSet)(object.height) ? $d5e07fe2518aae94$exports.Long.fromValue(object.height) : $d5e07fe2518aae94$exports.Long.UZERO,
            format: (0, $d5e07fe2518aae94$exports.isSet)(object.format) ? Number(object.format) : 0,
            chunk: (0, $d5e07fe2518aae94$exports.isSet)(object.chunk) ? Number(object.chunk) : 0
        };
    },
    toJSON (message) {
        const obj = {};
        message.height !== undefined && (obj.height = (message.height || $d5e07fe2518aae94$exports.Long.UZERO).toString());
        message.format !== undefined && (obj.format = Math.round(message.format));
        message.chunk !== undefined && (obj.chunk = Math.round(message.chunk));
        return obj;
    },
    fromPartial (object) {
        const message = $55d7da6fb7010b2f$var$createBaseRequestLoadSnapshotChunk();
        message.height = object.height !== undefined && object.height !== null ? $d5e07fe2518aae94$exports.Long.fromValue(object.height) : $d5e07fe2518aae94$exports.Long.UZERO;
        message.format = object.format ?? 0;
        message.chunk = object.chunk ?? 0;
        return message;
    }
};
function $55d7da6fb7010b2f$var$createBaseRequestApplySnapshotChunk() {
    return {
        index: 0,
        chunk: new Uint8Array(),
        sender: ""
    };
}
$55d7da6fb7010b2f$exports.RequestApplySnapshotChunk = {
    encode (message, writer = $55d7da6fb7010b2f$var$_m0.Writer.create()) {
        if (message.index !== 0) writer.uint32(8).uint32(message.index);
        if (message.chunk.length !== 0) writer.uint32(18).bytes(message.chunk);
        if (message.sender !== "") writer.uint32(26).string(message.sender);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $55d7da6fb7010b2f$var$_m0.Reader ? input : new $55d7da6fb7010b2f$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $55d7da6fb7010b2f$var$createBaseRequestApplySnapshotChunk();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.index = reader.uint32();
                    break;
                case 2:
                    message.chunk = reader.bytes();
                    break;
                case 3:
                    message.sender = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            index: (0, $d5e07fe2518aae94$exports.isSet)(object.index) ? Number(object.index) : 0,
            chunk: (0, $d5e07fe2518aae94$exports.isSet)(object.chunk) ? (0, $d5e07fe2518aae94$exports.bytesFromBase64)(object.chunk) : new Uint8Array(),
            sender: (0, $d5e07fe2518aae94$exports.isSet)(object.sender) ? String(object.sender) : ""
        };
    },
    toJSON (message) {
        const obj = {};
        message.index !== undefined && (obj.index = Math.round(message.index));
        message.chunk !== undefined && (obj.chunk = (0, $d5e07fe2518aae94$exports.base64FromBytes)(message.chunk !== undefined ? message.chunk : new Uint8Array()));
        message.sender !== undefined && (obj.sender = message.sender);
        return obj;
    },
    fromPartial (object) {
        const message = $55d7da6fb7010b2f$var$createBaseRequestApplySnapshotChunk();
        message.index = object.index ?? 0;
        message.chunk = object.chunk ?? new Uint8Array();
        message.sender = object.sender ?? "";
        return message;
    }
};
function $55d7da6fb7010b2f$var$createBaseRequestPrepareProposal() {
    return {
        maxTxBytes: $d5e07fe2518aae94$exports.Long.ZERO,
        txs: [],
        localLastCommit: undefined,
        misbehavior: [],
        height: $d5e07fe2518aae94$exports.Long.ZERO,
        time: undefined,
        nextValidatorsHash: new Uint8Array(),
        proposerAddress: new Uint8Array()
    };
}
$55d7da6fb7010b2f$exports.RequestPrepareProposal = {
    encode (message, writer = $55d7da6fb7010b2f$var$_m0.Writer.create()) {
        if (!message.maxTxBytes.isZero()) writer.uint32(8).int64(message.maxTxBytes);
        for (const v of message.txs)writer.uint32(18).bytes(v);
        if (message.localLastCommit !== undefined) $55d7da6fb7010b2f$exports.ExtendedCommitInfo.encode(message.localLastCommit, writer.uint32(26).fork()).ldelim();
        for (const v of message.misbehavior)$55d7da6fb7010b2f$exports.Misbehavior.encode(v, writer.uint32(34).fork()).ldelim();
        if (!message.height.isZero()) writer.uint32(40).int64(message.height);
        if (message.time !== undefined) $e7eaeedc85b414fc$exports.Timestamp.encode(message.time, writer.uint32(50).fork()).ldelim();
        if (message.nextValidatorsHash.length !== 0) writer.uint32(58).bytes(message.nextValidatorsHash);
        if (message.proposerAddress.length !== 0) writer.uint32(66).bytes(message.proposerAddress);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $55d7da6fb7010b2f$var$_m0.Reader ? input : new $55d7da6fb7010b2f$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $55d7da6fb7010b2f$var$createBaseRequestPrepareProposal();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.maxTxBytes = reader.int64();
                    break;
                case 2:
                    message.txs.push(reader.bytes());
                    break;
                case 3:
                    message.localLastCommit = $55d7da6fb7010b2f$exports.ExtendedCommitInfo.decode(reader, reader.uint32());
                    break;
                case 4:
                    message.misbehavior.push($55d7da6fb7010b2f$exports.Misbehavior.decode(reader, reader.uint32()));
                    break;
                case 5:
                    message.height = reader.int64();
                    break;
                case 6:
                    message.time = $e7eaeedc85b414fc$exports.Timestamp.decode(reader, reader.uint32());
                    break;
                case 7:
                    message.nextValidatorsHash = reader.bytes();
                    break;
                case 8:
                    message.proposerAddress = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            maxTxBytes: (0, $d5e07fe2518aae94$exports.isSet)(object.maxTxBytes) ? $d5e07fe2518aae94$exports.Long.fromValue(object.maxTxBytes) : $d5e07fe2518aae94$exports.Long.ZERO,
            txs: Array.isArray(object?.txs) ? object.txs.map((e)=>(0, $d5e07fe2518aae94$exports.bytesFromBase64)(e)) : [],
            localLastCommit: (0, $d5e07fe2518aae94$exports.isSet)(object.localLastCommit) ? $55d7da6fb7010b2f$exports.ExtendedCommitInfo.fromJSON(object.localLastCommit) : undefined,
            misbehavior: Array.isArray(object?.misbehavior) ? object.misbehavior.map((e)=>$55d7da6fb7010b2f$exports.Misbehavior.fromJSON(e)) : [],
            height: (0, $d5e07fe2518aae94$exports.isSet)(object.height) ? $d5e07fe2518aae94$exports.Long.fromValue(object.height) : $d5e07fe2518aae94$exports.Long.ZERO,
            time: (0, $d5e07fe2518aae94$exports.isSet)(object.time) ? (0, $d5e07fe2518aae94$exports.fromJsonTimestamp)(object.time) : undefined,
            nextValidatorsHash: (0, $d5e07fe2518aae94$exports.isSet)(object.nextValidatorsHash) ? (0, $d5e07fe2518aae94$exports.bytesFromBase64)(object.nextValidatorsHash) : new Uint8Array(),
            proposerAddress: (0, $d5e07fe2518aae94$exports.isSet)(object.proposerAddress) ? (0, $d5e07fe2518aae94$exports.bytesFromBase64)(object.proposerAddress) : new Uint8Array()
        };
    },
    toJSON (message) {
        const obj = {};
        message.maxTxBytes !== undefined && (obj.maxTxBytes = (message.maxTxBytes || $d5e07fe2518aae94$exports.Long.ZERO).toString());
        if (message.txs) obj.txs = message.txs.map((e)=>(0, $d5e07fe2518aae94$exports.base64FromBytes)(e !== undefined ? e : new Uint8Array()));
        else obj.txs = [];
        message.localLastCommit !== undefined && (obj.localLastCommit = message.localLastCommit ? $55d7da6fb7010b2f$exports.ExtendedCommitInfo.toJSON(message.localLastCommit) : undefined);
        if (message.misbehavior) obj.misbehavior = message.misbehavior.map((e)=>e ? $55d7da6fb7010b2f$exports.Misbehavior.toJSON(e) : undefined);
        else obj.misbehavior = [];
        message.height !== undefined && (obj.height = (message.height || $d5e07fe2518aae94$exports.Long.ZERO).toString());
        message.time !== undefined && (obj.time = (0, $d5e07fe2518aae94$exports.fromTimestamp)(message.time).toISOString());
        message.nextValidatorsHash !== undefined && (obj.nextValidatorsHash = (0, $d5e07fe2518aae94$exports.base64FromBytes)(message.nextValidatorsHash !== undefined ? message.nextValidatorsHash : new Uint8Array()));
        message.proposerAddress !== undefined && (obj.proposerAddress = (0, $d5e07fe2518aae94$exports.base64FromBytes)(message.proposerAddress !== undefined ? message.proposerAddress : new Uint8Array()));
        return obj;
    },
    fromPartial (object) {
        const message = $55d7da6fb7010b2f$var$createBaseRequestPrepareProposal();
        message.maxTxBytes = object.maxTxBytes !== undefined && object.maxTxBytes !== null ? $d5e07fe2518aae94$exports.Long.fromValue(object.maxTxBytes) : $d5e07fe2518aae94$exports.Long.ZERO;
        message.txs = object.txs?.map((e)=>e) || [];
        message.localLastCommit = object.localLastCommit !== undefined && object.localLastCommit !== null ? $55d7da6fb7010b2f$exports.ExtendedCommitInfo.fromPartial(object.localLastCommit) : undefined;
        message.misbehavior = object.misbehavior?.map((e)=>$55d7da6fb7010b2f$exports.Misbehavior.fromPartial(e)) || [];
        message.height = object.height !== undefined && object.height !== null ? $d5e07fe2518aae94$exports.Long.fromValue(object.height) : $d5e07fe2518aae94$exports.Long.ZERO;
        message.time = object.time !== undefined && object.time !== null ? $e7eaeedc85b414fc$exports.Timestamp.fromPartial(object.time) : undefined;
        message.nextValidatorsHash = object.nextValidatorsHash ?? new Uint8Array();
        message.proposerAddress = object.proposerAddress ?? new Uint8Array();
        return message;
    }
};
function $55d7da6fb7010b2f$var$createBaseRequestProcessProposal() {
    return {
        txs: [],
        proposedLastCommit: undefined,
        misbehavior: [],
        hash: new Uint8Array(),
        height: $d5e07fe2518aae94$exports.Long.ZERO,
        time: undefined,
        nextValidatorsHash: new Uint8Array(),
        proposerAddress: new Uint8Array()
    };
}
$55d7da6fb7010b2f$exports.RequestProcessProposal = {
    encode (message, writer = $55d7da6fb7010b2f$var$_m0.Writer.create()) {
        for (const v of message.txs)writer.uint32(10).bytes(v);
        if (message.proposedLastCommit !== undefined) $55d7da6fb7010b2f$exports.CommitInfo.encode(message.proposedLastCommit, writer.uint32(18).fork()).ldelim();
        for (const v of message.misbehavior)$55d7da6fb7010b2f$exports.Misbehavior.encode(v, writer.uint32(26).fork()).ldelim();
        if (message.hash.length !== 0) writer.uint32(34).bytes(message.hash);
        if (!message.height.isZero()) writer.uint32(40).int64(message.height);
        if (message.time !== undefined) $e7eaeedc85b414fc$exports.Timestamp.encode(message.time, writer.uint32(50).fork()).ldelim();
        if (message.nextValidatorsHash.length !== 0) writer.uint32(58).bytes(message.nextValidatorsHash);
        if (message.proposerAddress.length !== 0) writer.uint32(66).bytes(message.proposerAddress);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $55d7da6fb7010b2f$var$_m0.Reader ? input : new $55d7da6fb7010b2f$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $55d7da6fb7010b2f$var$createBaseRequestProcessProposal();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.txs.push(reader.bytes());
                    break;
                case 2:
                    message.proposedLastCommit = $55d7da6fb7010b2f$exports.CommitInfo.decode(reader, reader.uint32());
                    break;
                case 3:
                    message.misbehavior.push($55d7da6fb7010b2f$exports.Misbehavior.decode(reader, reader.uint32()));
                    break;
                case 4:
                    message.hash = reader.bytes();
                    break;
                case 5:
                    message.height = reader.int64();
                    break;
                case 6:
                    message.time = $e7eaeedc85b414fc$exports.Timestamp.decode(reader, reader.uint32());
                    break;
                case 7:
                    message.nextValidatorsHash = reader.bytes();
                    break;
                case 8:
                    message.proposerAddress = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            txs: Array.isArray(object?.txs) ? object.txs.map((e)=>(0, $d5e07fe2518aae94$exports.bytesFromBase64)(e)) : [],
            proposedLastCommit: (0, $d5e07fe2518aae94$exports.isSet)(object.proposedLastCommit) ? $55d7da6fb7010b2f$exports.CommitInfo.fromJSON(object.proposedLastCommit) : undefined,
            misbehavior: Array.isArray(object?.misbehavior) ? object.misbehavior.map((e)=>$55d7da6fb7010b2f$exports.Misbehavior.fromJSON(e)) : [],
            hash: (0, $d5e07fe2518aae94$exports.isSet)(object.hash) ? (0, $d5e07fe2518aae94$exports.bytesFromBase64)(object.hash) : new Uint8Array(),
            height: (0, $d5e07fe2518aae94$exports.isSet)(object.height) ? $d5e07fe2518aae94$exports.Long.fromValue(object.height) : $d5e07fe2518aae94$exports.Long.ZERO,
            time: (0, $d5e07fe2518aae94$exports.isSet)(object.time) ? (0, $d5e07fe2518aae94$exports.fromJsonTimestamp)(object.time) : undefined,
            nextValidatorsHash: (0, $d5e07fe2518aae94$exports.isSet)(object.nextValidatorsHash) ? (0, $d5e07fe2518aae94$exports.bytesFromBase64)(object.nextValidatorsHash) : new Uint8Array(),
            proposerAddress: (0, $d5e07fe2518aae94$exports.isSet)(object.proposerAddress) ? (0, $d5e07fe2518aae94$exports.bytesFromBase64)(object.proposerAddress) : new Uint8Array()
        };
    },
    toJSON (message) {
        const obj = {};
        if (message.txs) obj.txs = message.txs.map((e)=>(0, $d5e07fe2518aae94$exports.base64FromBytes)(e !== undefined ? e : new Uint8Array()));
        else obj.txs = [];
        message.proposedLastCommit !== undefined && (obj.proposedLastCommit = message.proposedLastCommit ? $55d7da6fb7010b2f$exports.CommitInfo.toJSON(message.proposedLastCommit) : undefined);
        if (message.misbehavior) obj.misbehavior = message.misbehavior.map((e)=>e ? $55d7da6fb7010b2f$exports.Misbehavior.toJSON(e) : undefined);
        else obj.misbehavior = [];
        message.hash !== undefined && (obj.hash = (0, $d5e07fe2518aae94$exports.base64FromBytes)(message.hash !== undefined ? message.hash : new Uint8Array()));
        message.height !== undefined && (obj.height = (message.height || $d5e07fe2518aae94$exports.Long.ZERO).toString());
        message.time !== undefined && (obj.time = (0, $d5e07fe2518aae94$exports.fromTimestamp)(message.time).toISOString());
        message.nextValidatorsHash !== undefined && (obj.nextValidatorsHash = (0, $d5e07fe2518aae94$exports.base64FromBytes)(message.nextValidatorsHash !== undefined ? message.nextValidatorsHash : new Uint8Array()));
        message.proposerAddress !== undefined && (obj.proposerAddress = (0, $d5e07fe2518aae94$exports.base64FromBytes)(message.proposerAddress !== undefined ? message.proposerAddress : new Uint8Array()));
        return obj;
    },
    fromPartial (object) {
        const message = $55d7da6fb7010b2f$var$createBaseRequestProcessProposal();
        message.txs = object.txs?.map((e)=>e) || [];
        message.proposedLastCommit = object.proposedLastCommit !== undefined && object.proposedLastCommit !== null ? $55d7da6fb7010b2f$exports.CommitInfo.fromPartial(object.proposedLastCommit) : undefined;
        message.misbehavior = object.misbehavior?.map((e)=>$55d7da6fb7010b2f$exports.Misbehavior.fromPartial(e)) || [];
        message.hash = object.hash ?? new Uint8Array();
        message.height = object.height !== undefined && object.height !== null ? $d5e07fe2518aae94$exports.Long.fromValue(object.height) : $d5e07fe2518aae94$exports.Long.ZERO;
        message.time = object.time !== undefined && object.time !== null ? $e7eaeedc85b414fc$exports.Timestamp.fromPartial(object.time) : undefined;
        message.nextValidatorsHash = object.nextValidatorsHash ?? new Uint8Array();
        message.proposerAddress = object.proposerAddress ?? new Uint8Array();
        return message;
    }
};
function $55d7da6fb7010b2f$var$createBaseResponse() {
    return {
        exception: undefined,
        echo: undefined,
        flush: undefined,
        info: undefined,
        initChain: undefined,
        query: undefined,
        beginBlock: undefined,
        checkTx: undefined,
        deliverTx: undefined,
        endBlock: undefined,
        commit: undefined,
        listSnapshots: undefined,
        offerSnapshot: undefined,
        loadSnapshotChunk: undefined,
        applySnapshotChunk: undefined,
        prepareProposal: undefined,
        processProposal: undefined
    };
}
$55d7da6fb7010b2f$exports.Response = {
    encode (message, writer = $55d7da6fb7010b2f$var$_m0.Writer.create()) {
        if (message.exception !== undefined) $55d7da6fb7010b2f$exports.ResponseException.encode(message.exception, writer.uint32(10).fork()).ldelim();
        if (message.echo !== undefined) $55d7da6fb7010b2f$exports.ResponseEcho.encode(message.echo, writer.uint32(18).fork()).ldelim();
        if (message.flush !== undefined) $55d7da6fb7010b2f$exports.ResponseFlush.encode(message.flush, writer.uint32(26).fork()).ldelim();
        if (message.info !== undefined) $55d7da6fb7010b2f$exports.ResponseInfo.encode(message.info, writer.uint32(34).fork()).ldelim();
        if (message.initChain !== undefined) $55d7da6fb7010b2f$exports.ResponseInitChain.encode(message.initChain, writer.uint32(50).fork()).ldelim();
        if (message.query !== undefined) $55d7da6fb7010b2f$exports.ResponseQuery.encode(message.query, writer.uint32(58).fork()).ldelim();
        if (message.beginBlock !== undefined) $55d7da6fb7010b2f$exports.ResponseBeginBlock.encode(message.beginBlock, writer.uint32(66).fork()).ldelim();
        if (message.checkTx !== undefined) $55d7da6fb7010b2f$exports.ResponseCheckTx.encode(message.checkTx, writer.uint32(74).fork()).ldelim();
        if (message.deliverTx !== undefined) $55d7da6fb7010b2f$exports.ResponseDeliverTx.encode(message.deliverTx, writer.uint32(82).fork()).ldelim();
        if (message.endBlock !== undefined) $55d7da6fb7010b2f$exports.ResponseEndBlock.encode(message.endBlock, writer.uint32(90).fork()).ldelim();
        if (message.commit !== undefined) $55d7da6fb7010b2f$exports.ResponseCommit.encode(message.commit, writer.uint32(98).fork()).ldelim();
        if (message.listSnapshots !== undefined) $55d7da6fb7010b2f$exports.ResponseListSnapshots.encode(message.listSnapshots, writer.uint32(106).fork()).ldelim();
        if (message.offerSnapshot !== undefined) $55d7da6fb7010b2f$exports.ResponseOfferSnapshot.encode(message.offerSnapshot, writer.uint32(114).fork()).ldelim();
        if (message.loadSnapshotChunk !== undefined) $55d7da6fb7010b2f$exports.ResponseLoadSnapshotChunk.encode(message.loadSnapshotChunk, writer.uint32(122).fork()).ldelim();
        if (message.applySnapshotChunk !== undefined) $55d7da6fb7010b2f$exports.ResponseApplySnapshotChunk.encode(message.applySnapshotChunk, writer.uint32(130).fork()).ldelim();
        if (message.prepareProposal !== undefined) $55d7da6fb7010b2f$exports.ResponsePrepareProposal.encode(message.prepareProposal, writer.uint32(138).fork()).ldelim();
        if (message.processProposal !== undefined) $55d7da6fb7010b2f$exports.ResponseProcessProposal.encode(message.processProposal, writer.uint32(146).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $55d7da6fb7010b2f$var$_m0.Reader ? input : new $55d7da6fb7010b2f$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $55d7da6fb7010b2f$var$createBaseResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.exception = $55d7da6fb7010b2f$exports.ResponseException.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.echo = $55d7da6fb7010b2f$exports.ResponseEcho.decode(reader, reader.uint32());
                    break;
                case 3:
                    message.flush = $55d7da6fb7010b2f$exports.ResponseFlush.decode(reader, reader.uint32());
                    break;
                case 4:
                    message.info = $55d7da6fb7010b2f$exports.ResponseInfo.decode(reader, reader.uint32());
                    break;
                case 6:
                    message.initChain = $55d7da6fb7010b2f$exports.ResponseInitChain.decode(reader, reader.uint32());
                    break;
                case 7:
                    message.query = $55d7da6fb7010b2f$exports.ResponseQuery.decode(reader, reader.uint32());
                    break;
                case 8:
                    message.beginBlock = $55d7da6fb7010b2f$exports.ResponseBeginBlock.decode(reader, reader.uint32());
                    break;
                case 9:
                    message.checkTx = $55d7da6fb7010b2f$exports.ResponseCheckTx.decode(reader, reader.uint32());
                    break;
                case 10:
                    message.deliverTx = $55d7da6fb7010b2f$exports.ResponseDeliverTx.decode(reader, reader.uint32());
                    break;
                case 11:
                    message.endBlock = $55d7da6fb7010b2f$exports.ResponseEndBlock.decode(reader, reader.uint32());
                    break;
                case 12:
                    message.commit = $55d7da6fb7010b2f$exports.ResponseCommit.decode(reader, reader.uint32());
                    break;
                case 13:
                    message.listSnapshots = $55d7da6fb7010b2f$exports.ResponseListSnapshots.decode(reader, reader.uint32());
                    break;
                case 14:
                    message.offerSnapshot = $55d7da6fb7010b2f$exports.ResponseOfferSnapshot.decode(reader, reader.uint32());
                    break;
                case 15:
                    message.loadSnapshotChunk = $55d7da6fb7010b2f$exports.ResponseLoadSnapshotChunk.decode(reader, reader.uint32());
                    break;
                case 16:
                    message.applySnapshotChunk = $55d7da6fb7010b2f$exports.ResponseApplySnapshotChunk.decode(reader, reader.uint32());
                    break;
                case 17:
                    message.prepareProposal = $55d7da6fb7010b2f$exports.ResponsePrepareProposal.decode(reader, reader.uint32());
                    break;
                case 18:
                    message.processProposal = $55d7da6fb7010b2f$exports.ResponseProcessProposal.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            exception: (0, $d5e07fe2518aae94$exports.isSet)(object.exception) ? $55d7da6fb7010b2f$exports.ResponseException.fromJSON(object.exception) : undefined,
            echo: (0, $d5e07fe2518aae94$exports.isSet)(object.echo) ? $55d7da6fb7010b2f$exports.ResponseEcho.fromJSON(object.echo) : undefined,
            flush: (0, $d5e07fe2518aae94$exports.isSet)(object.flush) ? $55d7da6fb7010b2f$exports.ResponseFlush.fromJSON(object.flush) : undefined,
            info: (0, $d5e07fe2518aae94$exports.isSet)(object.info) ? $55d7da6fb7010b2f$exports.ResponseInfo.fromJSON(object.info) : undefined,
            initChain: (0, $d5e07fe2518aae94$exports.isSet)(object.initChain) ? $55d7da6fb7010b2f$exports.ResponseInitChain.fromJSON(object.initChain) : undefined,
            query: (0, $d5e07fe2518aae94$exports.isSet)(object.query) ? $55d7da6fb7010b2f$exports.ResponseQuery.fromJSON(object.query) : undefined,
            beginBlock: (0, $d5e07fe2518aae94$exports.isSet)(object.beginBlock) ? $55d7da6fb7010b2f$exports.ResponseBeginBlock.fromJSON(object.beginBlock) : undefined,
            checkTx: (0, $d5e07fe2518aae94$exports.isSet)(object.checkTx) ? $55d7da6fb7010b2f$exports.ResponseCheckTx.fromJSON(object.checkTx) : undefined,
            deliverTx: (0, $d5e07fe2518aae94$exports.isSet)(object.deliverTx) ? $55d7da6fb7010b2f$exports.ResponseDeliverTx.fromJSON(object.deliverTx) : undefined,
            endBlock: (0, $d5e07fe2518aae94$exports.isSet)(object.endBlock) ? $55d7da6fb7010b2f$exports.ResponseEndBlock.fromJSON(object.endBlock) : undefined,
            commit: (0, $d5e07fe2518aae94$exports.isSet)(object.commit) ? $55d7da6fb7010b2f$exports.ResponseCommit.fromJSON(object.commit) : undefined,
            listSnapshots: (0, $d5e07fe2518aae94$exports.isSet)(object.listSnapshots) ? $55d7da6fb7010b2f$exports.ResponseListSnapshots.fromJSON(object.listSnapshots) : undefined,
            offerSnapshot: (0, $d5e07fe2518aae94$exports.isSet)(object.offerSnapshot) ? $55d7da6fb7010b2f$exports.ResponseOfferSnapshot.fromJSON(object.offerSnapshot) : undefined,
            loadSnapshotChunk: (0, $d5e07fe2518aae94$exports.isSet)(object.loadSnapshotChunk) ? $55d7da6fb7010b2f$exports.ResponseLoadSnapshotChunk.fromJSON(object.loadSnapshotChunk) : undefined,
            applySnapshotChunk: (0, $d5e07fe2518aae94$exports.isSet)(object.applySnapshotChunk) ? $55d7da6fb7010b2f$exports.ResponseApplySnapshotChunk.fromJSON(object.applySnapshotChunk) : undefined,
            prepareProposal: (0, $d5e07fe2518aae94$exports.isSet)(object.prepareProposal) ? $55d7da6fb7010b2f$exports.ResponsePrepareProposal.fromJSON(object.prepareProposal) : undefined,
            processProposal: (0, $d5e07fe2518aae94$exports.isSet)(object.processProposal) ? $55d7da6fb7010b2f$exports.ResponseProcessProposal.fromJSON(object.processProposal) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.exception !== undefined && (obj.exception = message.exception ? $55d7da6fb7010b2f$exports.ResponseException.toJSON(message.exception) : undefined);
        message.echo !== undefined && (obj.echo = message.echo ? $55d7da6fb7010b2f$exports.ResponseEcho.toJSON(message.echo) : undefined);
        message.flush !== undefined && (obj.flush = message.flush ? $55d7da6fb7010b2f$exports.ResponseFlush.toJSON(message.flush) : undefined);
        message.info !== undefined && (obj.info = message.info ? $55d7da6fb7010b2f$exports.ResponseInfo.toJSON(message.info) : undefined);
        message.initChain !== undefined && (obj.initChain = message.initChain ? $55d7da6fb7010b2f$exports.ResponseInitChain.toJSON(message.initChain) : undefined);
        message.query !== undefined && (obj.query = message.query ? $55d7da6fb7010b2f$exports.ResponseQuery.toJSON(message.query) : undefined);
        message.beginBlock !== undefined && (obj.beginBlock = message.beginBlock ? $55d7da6fb7010b2f$exports.ResponseBeginBlock.toJSON(message.beginBlock) : undefined);
        message.checkTx !== undefined && (obj.checkTx = message.checkTx ? $55d7da6fb7010b2f$exports.ResponseCheckTx.toJSON(message.checkTx) : undefined);
        message.deliverTx !== undefined && (obj.deliverTx = message.deliverTx ? $55d7da6fb7010b2f$exports.ResponseDeliverTx.toJSON(message.deliverTx) : undefined);
        message.endBlock !== undefined && (obj.endBlock = message.endBlock ? $55d7da6fb7010b2f$exports.ResponseEndBlock.toJSON(message.endBlock) : undefined);
        message.commit !== undefined && (obj.commit = message.commit ? $55d7da6fb7010b2f$exports.ResponseCommit.toJSON(message.commit) : undefined);
        message.listSnapshots !== undefined && (obj.listSnapshots = message.listSnapshots ? $55d7da6fb7010b2f$exports.ResponseListSnapshots.toJSON(message.listSnapshots) : undefined);
        message.offerSnapshot !== undefined && (obj.offerSnapshot = message.offerSnapshot ? $55d7da6fb7010b2f$exports.ResponseOfferSnapshot.toJSON(message.offerSnapshot) : undefined);
        message.loadSnapshotChunk !== undefined && (obj.loadSnapshotChunk = message.loadSnapshotChunk ? $55d7da6fb7010b2f$exports.ResponseLoadSnapshotChunk.toJSON(message.loadSnapshotChunk) : undefined);
        message.applySnapshotChunk !== undefined && (obj.applySnapshotChunk = message.applySnapshotChunk ? $55d7da6fb7010b2f$exports.ResponseApplySnapshotChunk.toJSON(message.applySnapshotChunk) : undefined);
        message.prepareProposal !== undefined && (obj.prepareProposal = message.prepareProposal ? $55d7da6fb7010b2f$exports.ResponsePrepareProposal.toJSON(message.prepareProposal) : undefined);
        message.processProposal !== undefined && (obj.processProposal = message.processProposal ? $55d7da6fb7010b2f$exports.ResponseProcessProposal.toJSON(message.processProposal) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $55d7da6fb7010b2f$var$createBaseResponse();
        message.exception = object.exception !== undefined && object.exception !== null ? $55d7da6fb7010b2f$exports.ResponseException.fromPartial(object.exception) : undefined;
        message.echo = object.echo !== undefined && object.echo !== null ? $55d7da6fb7010b2f$exports.ResponseEcho.fromPartial(object.echo) : undefined;
        message.flush = object.flush !== undefined && object.flush !== null ? $55d7da6fb7010b2f$exports.ResponseFlush.fromPartial(object.flush) : undefined;
        message.info = object.info !== undefined && object.info !== null ? $55d7da6fb7010b2f$exports.ResponseInfo.fromPartial(object.info) : undefined;
        message.initChain = object.initChain !== undefined && object.initChain !== null ? $55d7da6fb7010b2f$exports.ResponseInitChain.fromPartial(object.initChain) : undefined;
        message.query = object.query !== undefined && object.query !== null ? $55d7da6fb7010b2f$exports.ResponseQuery.fromPartial(object.query) : undefined;
        message.beginBlock = object.beginBlock !== undefined && object.beginBlock !== null ? $55d7da6fb7010b2f$exports.ResponseBeginBlock.fromPartial(object.beginBlock) : undefined;
        message.checkTx = object.checkTx !== undefined && object.checkTx !== null ? $55d7da6fb7010b2f$exports.ResponseCheckTx.fromPartial(object.checkTx) : undefined;
        message.deliverTx = object.deliverTx !== undefined && object.deliverTx !== null ? $55d7da6fb7010b2f$exports.ResponseDeliverTx.fromPartial(object.deliverTx) : undefined;
        message.endBlock = object.endBlock !== undefined && object.endBlock !== null ? $55d7da6fb7010b2f$exports.ResponseEndBlock.fromPartial(object.endBlock) : undefined;
        message.commit = object.commit !== undefined && object.commit !== null ? $55d7da6fb7010b2f$exports.ResponseCommit.fromPartial(object.commit) : undefined;
        message.listSnapshots = object.listSnapshots !== undefined && object.listSnapshots !== null ? $55d7da6fb7010b2f$exports.ResponseListSnapshots.fromPartial(object.listSnapshots) : undefined;
        message.offerSnapshot = object.offerSnapshot !== undefined && object.offerSnapshot !== null ? $55d7da6fb7010b2f$exports.ResponseOfferSnapshot.fromPartial(object.offerSnapshot) : undefined;
        message.loadSnapshotChunk = object.loadSnapshotChunk !== undefined && object.loadSnapshotChunk !== null ? $55d7da6fb7010b2f$exports.ResponseLoadSnapshotChunk.fromPartial(object.loadSnapshotChunk) : undefined;
        message.applySnapshotChunk = object.applySnapshotChunk !== undefined && object.applySnapshotChunk !== null ? $55d7da6fb7010b2f$exports.ResponseApplySnapshotChunk.fromPartial(object.applySnapshotChunk) : undefined;
        message.prepareProposal = object.prepareProposal !== undefined && object.prepareProposal !== null ? $55d7da6fb7010b2f$exports.ResponsePrepareProposal.fromPartial(object.prepareProposal) : undefined;
        message.processProposal = object.processProposal !== undefined && object.processProposal !== null ? $55d7da6fb7010b2f$exports.ResponseProcessProposal.fromPartial(object.processProposal) : undefined;
        return message;
    }
};
function $55d7da6fb7010b2f$var$createBaseResponseException() {
    return {
        error: ""
    };
}
$55d7da6fb7010b2f$exports.ResponseException = {
    encode (message, writer = $55d7da6fb7010b2f$var$_m0.Writer.create()) {
        if (message.error !== "") writer.uint32(10).string(message.error);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $55d7da6fb7010b2f$var$_m0.Reader ? input : new $55d7da6fb7010b2f$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $55d7da6fb7010b2f$var$createBaseResponseException();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.error = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            error: (0, $d5e07fe2518aae94$exports.isSet)(object.error) ? String(object.error) : ""
        };
    },
    toJSON (message) {
        const obj = {};
        message.error !== undefined && (obj.error = message.error);
        return obj;
    },
    fromPartial (object) {
        const message = $55d7da6fb7010b2f$var$createBaseResponseException();
        message.error = object.error ?? "";
        return message;
    }
};
function $55d7da6fb7010b2f$var$createBaseResponseEcho() {
    return {
        message: ""
    };
}
$55d7da6fb7010b2f$exports.ResponseEcho = {
    encode (message, writer = $55d7da6fb7010b2f$var$_m0.Writer.create()) {
        if (message.message !== "") writer.uint32(10).string(message.message);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $55d7da6fb7010b2f$var$_m0.Reader ? input : new $55d7da6fb7010b2f$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $55d7da6fb7010b2f$var$createBaseResponseEcho();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.message = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            message: (0, $d5e07fe2518aae94$exports.isSet)(object.message) ? String(object.message) : ""
        };
    },
    toJSON (message) {
        const obj = {};
        message.message !== undefined && (obj.message = message.message);
        return obj;
    },
    fromPartial (object) {
        const message = $55d7da6fb7010b2f$var$createBaseResponseEcho();
        message.message = object.message ?? "";
        return message;
    }
};
function $55d7da6fb7010b2f$var$createBaseResponseFlush() {
    return {};
}
$55d7da6fb7010b2f$exports.ResponseFlush = {
    encode (_, writer = $55d7da6fb7010b2f$var$_m0.Writer.create()) {
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $55d7da6fb7010b2f$var$_m0.Reader ? input : new $55d7da6fb7010b2f$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $55d7da6fb7010b2f$var$createBaseResponseFlush();
        while(reader.pos < end){
            const tag = reader.uint32();
            tag;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON (_) {
        return {};
    },
    toJSON (_) {
        const obj = {};
        return obj;
    },
    fromPartial (_) {
        const message = $55d7da6fb7010b2f$var$createBaseResponseFlush();
        return message;
    }
};
function $55d7da6fb7010b2f$var$createBaseResponseInfo() {
    return {
        data: "",
        version: "",
        appVersion: $d5e07fe2518aae94$exports.Long.UZERO,
        lastBlockHeight: $d5e07fe2518aae94$exports.Long.ZERO,
        lastBlockAppHash: new Uint8Array()
    };
}
$55d7da6fb7010b2f$exports.ResponseInfo = {
    encode (message, writer = $55d7da6fb7010b2f$var$_m0.Writer.create()) {
        if (message.data !== "") writer.uint32(10).string(message.data);
        if (message.version !== "") writer.uint32(18).string(message.version);
        if (!message.appVersion.isZero()) writer.uint32(24).uint64(message.appVersion);
        if (!message.lastBlockHeight.isZero()) writer.uint32(32).int64(message.lastBlockHeight);
        if (message.lastBlockAppHash.length !== 0) writer.uint32(42).bytes(message.lastBlockAppHash);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $55d7da6fb7010b2f$var$_m0.Reader ? input : new $55d7da6fb7010b2f$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $55d7da6fb7010b2f$var$createBaseResponseInfo();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.data = reader.string();
                    break;
                case 2:
                    message.version = reader.string();
                    break;
                case 3:
                    message.appVersion = reader.uint64();
                    break;
                case 4:
                    message.lastBlockHeight = reader.int64();
                    break;
                case 5:
                    message.lastBlockAppHash = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            data: (0, $d5e07fe2518aae94$exports.isSet)(object.data) ? String(object.data) : "",
            version: (0, $d5e07fe2518aae94$exports.isSet)(object.version) ? String(object.version) : "",
            appVersion: (0, $d5e07fe2518aae94$exports.isSet)(object.appVersion) ? $d5e07fe2518aae94$exports.Long.fromValue(object.appVersion) : $d5e07fe2518aae94$exports.Long.UZERO,
            lastBlockHeight: (0, $d5e07fe2518aae94$exports.isSet)(object.lastBlockHeight) ? $d5e07fe2518aae94$exports.Long.fromValue(object.lastBlockHeight) : $d5e07fe2518aae94$exports.Long.ZERO,
            lastBlockAppHash: (0, $d5e07fe2518aae94$exports.isSet)(object.lastBlockAppHash) ? (0, $d5e07fe2518aae94$exports.bytesFromBase64)(object.lastBlockAppHash) : new Uint8Array()
        };
    },
    toJSON (message) {
        const obj = {};
        message.data !== undefined && (obj.data = message.data);
        message.version !== undefined && (obj.version = message.version);
        message.appVersion !== undefined && (obj.appVersion = (message.appVersion || $d5e07fe2518aae94$exports.Long.UZERO).toString());
        message.lastBlockHeight !== undefined && (obj.lastBlockHeight = (message.lastBlockHeight || $d5e07fe2518aae94$exports.Long.ZERO).toString());
        message.lastBlockAppHash !== undefined && (obj.lastBlockAppHash = (0, $d5e07fe2518aae94$exports.base64FromBytes)(message.lastBlockAppHash !== undefined ? message.lastBlockAppHash : new Uint8Array()));
        return obj;
    },
    fromPartial (object) {
        const message = $55d7da6fb7010b2f$var$createBaseResponseInfo();
        message.data = object.data ?? "";
        message.version = object.version ?? "";
        message.appVersion = object.appVersion !== undefined && object.appVersion !== null ? $d5e07fe2518aae94$exports.Long.fromValue(object.appVersion) : $d5e07fe2518aae94$exports.Long.UZERO;
        message.lastBlockHeight = object.lastBlockHeight !== undefined && object.lastBlockHeight !== null ? $d5e07fe2518aae94$exports.Long.fromValue(object.lastBlockHeight) : $d5e07fe2518aae94$exports.Long.ZERO;
        message.lastBlockAppHash = object.lastBlockAppHash ?? new Uint8Array();
        return message;
    }
};
function $55d7da6fb7010b2f$var$createBaseResponseInitChain() {
    return {
        consensusParams: undefined,
        validators: [],
        appHash: new Uint8Array()
    };
}
$55d7da6fb7010b2f$exports.ResponseInitChain = {
    encode (message, writer = $55d7da6fb7010b2f$var$_m0.Writer.create()) {
        if (message.consensusParams !== undefined) $134a665e0e74d535$exports.ConsensusParams.encode(message.consensusParams, writer.uint32(10).fork()).ldelim();
        for (const v of message.validators)$55d7da6fb7010b2f$exports.ValidatorUpdate.encode(v, writer.uint32(18).fork()).ldelim();
        if (message.appHash.length !== 0) writer.uint32(26).bytes(message.appHash);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $55d7da6fb7010b2f$var$_m0.Reader ? input : new $55d7da6fb7010b2f$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $55d7da6fb7010b2f$var$createBaseResponseInitChain();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.consensusParams = $134a665e0e74d535$exports.ConsensusParams.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.validators.push($55d7da6fb7010b2f$exports.ValidatorUpdate.decode(reader, reader.uint32()));
                    break;
                case 3:
                    message.appHash = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            consensusParams: (0, $d5e07fe2518aae94$exports.isSet)(object.consensusParams) ? $134a665e0e74d535$exports.ConsensusParams.fromJSON(object.consensusParams) : undefined,
            validators: Array.isArray(object?.validators) ? object.validators.map((e)=>$55d7da6fb7010b2f$exports.ValidatorUpdate.fromJSON(e)) : [],
            appHash: (0, $d5e07fe2518aae94$exports.isSet)(object.appHash) ? (0, $d5e07fe2518aae94$exports.bytesFromBase64)(object.appHash) : new Uint8Array()
        };
    },
    toJSON (message) {
        const obj = {};
        message.consensusParams !== undefined && (obj.consensusParams = message.consensusParams ? $134a665e0e74d535$exports.ConsensusParams.toJSON(message.consensusParams) : undefined);
        if (message.validators) obj.validators = message.validators.map((e)=>e ? $55d7da6fb7010b2f$exports.ValidatorUpdate.toJSON(e) : undefined);
        else obj.validators = [];
        message.appHash !== undefined && (obj.appHash = (0, $d5e07fe2518aae94$exports.base64FromBytes)(message.appHash !== undefined ? message.appHash : new Uint8Array()));
        return obj;
    },
    fromPartial (object) {
        const message = $55d7da6fb7010b2f$var$createBaseResponseInitChain();
        message.consensusParams = object.consensusParams !== undefined && object.consensusParams !== null ? $134a665e0e74d535$exports.ConsensusParams.fromPartial(object.consensusParams) : undefined;
        message.validators = object.validators?.map((e)=>$55d7da6fb7010b2f$exports.ValidatorUpdate.fromPartial(e)) || [];
        message.appHash = object.appHash ?? new Uint8Array();
        return message;
    }
};
function $55d7da6fb7010b2f$var$createBaseResponseQuery() {
    return {
        code: 0,
        log: "",
        info: "",
        index: $d5e07fe2518aae94$exports.Long.ZERO,
        key: new Uint8Array(),
        value: new Uint8Array(),
        proofOps: undefined,
        height: $d5e07fe2518aae94$exports.Long.ZERO,
        codespace: ""
    };
}
$55d7da6fb7010b2f$exports.ResponseQuery = {
    encode (message, writer = $55d7da6fb7010b2f$var$_m0.Writer.create()) {
        if (message.code !== 0) writer.uint32(8).uint32(message.code);
        if (message.log !== "") writer.uint32(26).string(message.log);
        if (message.info !== "") writer.uint32(34).string(message.info);
        if (!message.index.isZero()) writer.uint32(40).int64(message.index);
        if (message.key.length !== 0) writer.uint32(50).bytes(message.key);
        if (message.value.length !== 0) writer.uint32(58).bytes(message.value);
        if (message.proofOps !== undefined) $705dca31272f1c70$exports.ProofOps.encode(message.proofOps, writer.uint32(66).fork()).ldelim();
        if (!message.height.isZero()) writer.uint32(72).int64(message.height);
        if (message.codespace !== "") writer.uint32(82).string(message.codespace);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $55d7da6fb7010b2f$var$_m0.Reader ? input : new $55d7da6fb7010b2f$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $55d7da6fb7010b2f$var$createBaseResponseQuery();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.code = reader.uint32();
                    break;
                case 3:
                    message.log = reader.string();
                    break;
                case 4:
                    message.info = reader.string();
                    break;
                case 5:
                    message.index = reader.int64();
                    break;
                case 6:
                    message.key = reader.bytes();
                    break;
                case 7:
                    message.value = reader.bytes();
                    break;
                case 8:
                    message.proofOps = $705dca31272f1c70$exports.ProofOps.decode(reader, reader.uint32());
                    break;
                case 9:
                    message.height = reader.int64();
                    break;
                case 10:
                    message.codespace = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            code: (0, $d5e07fe2518aae94$exports.isSet)(object.code) ? Number(object.code) : 0,
            log: (0, $d5e07fe2518aae94$exports.isSet)(object.log) ? String(object.log) : "",
            info: (0, $d5e07fe2518aae94$exports.isSet)(object.info) ? String(object.info) : "",
            index: (0, $d5e07fe2518aae94$exports.isSet)(object.index) ? $d5e07fe2518aae94$exports.Long.fromValue(object.index) : $d5e07fe2518aae94$exports.Long.ZERO,
            key: (0, $d5e07fe2518aae94$exports.isSet)(object.key) ? (0, $d5e07fe2518aae94$exports.bytesFromBase64)(object.key) : new Uint8Array(),
            value: (0, $d5e07fe2518aae94$exports.isSet)(object.value) ? (0, $d5e07fe2518aae94$exports.bytesFromBase64)(object.value) : new Uint8Array(),
            proofOps: (0, $d5e07fe2518aae94$exports.isSet)(object.proofOps) ? $705dca31272f1c70$exports.ProofOps.fromJSON(object.proofOps) : undefined,
            height: (0, $d5e07fe2518aae94$exports.isSet)(object.height) ? $d5e07fe2518aae94$exports.Long.fromValue(object.height) : $d5e07fe2518aae94$exports.Long.ZERO,
            codespace: (0, $d5e07fe2518aae94$exports.isSet)(object.codespace) ? String(object.codespace) : ""
        };
    },
    toJSON (message) {
        const obj = {};
        message.code !== undefined && (obj.code = Math.round(message.code));
        message.log !== undefined && (obj.log = message.log);
        message.info !== undefined && (obj.info = message.info);
        message.index !== undefined && (obj.index = (message.index || $d5e07fe2518aae94$exports.Long.ZERO).toString());
        message.key !== undefined && (obj.key = (0, $d5e07fe2518aae94$exports.base64FromBytes)(message.key !== undefined ? message.key : new Uint8Array()));
        message.value !== undefined && (obj.value = (0, $d5e07fe2518aae94$exports.base64FromBytes)(message.value !== undefined ? message.value : new Uint8Array()));
        message.proofOps !== undefined && (obj.proofOps = message.proofOps ? $705dca31272f1c70$exports.ProofOps.toJSON(message.proofOps) : undefined);
        message.height !== undefined && (obj.height = (message.height || $d5e07fe2518aae94$exports.Long.ZERO).toString());
        message.codespace !== undefined && (obj.codespace = message.codespace);
        return obj;
    },
    fromPartial (object) {
        const message = $55d7da6fb7010b2f$var$createBaseResponseQuery();
        message.code = object.code ?? 0;
        message.log = object.log ?? "";
        message.info = object.info ?? "";
        message.index = object.index !== undefined && object.index !== null ? $d5e07fe2518aae94$exports.Long.fromValue(object.index) : $d5e07fe2518aae94$exports.Long.ZERO;
        message.key = object.key ?? new Uint8Array();
        message.value = object.value ?? new Uint8Array();
        message.proofOps = object.proofOps !== undefined && object.proofOps !== null ? $705dca31272f1c70$exports.ProofOps.fromPartial(object.proofOps) : undefined;
        message.height = object.height !== undefined && object.height !== null ? $d5e07fe2518aae94$exports.Long.fromValue(object.height) : $d5e07fe2518aae94$exports.Long.ZERO;
        message.codespace = object.codespace ?? "";
        return message;
    }
};
function $55d7da6fb7010b2f$var$createBaseResponseBeginBlock() {
    return {
        events: []
    };
}
$55d7da6fb7010b2f$exports.ResponseBeginBlock = {
    encode (message, writer = $55d7da6fb7010b2f$var$_m0.Writer.create()) {
        for (const v of message.events)$55d7da6fb7010b2f$exports.Event.encode(v, writer.uint32(10).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $55d7da6fb7010b2f$var$_m0.Reader ? input : new $55d7da6fb7010b2f$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $55d7da6fb7010b2f$var$createBaseResponseBeginBlock();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.events.push($55d7da6fb7010b2f$exports.Event.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            events: Array.isArray(object?.events) ? object.events.map((e)=>$55d7da6fb7010b2f$exports.Event.fromJSON(e)) : []
        };
    },
    toJSON (message) {
        const obj = {};
        if (message.events) obj.events = message.events.map((e)=>e ? $55d7da6fb7010b2f$exports.Event.toJSON(e) : undefined);
        else obj.events = [];
        return obj;
    },
    fromPartial (object) {
        const message = $55d7da6fb7010b2f$var$createBaseResponseBeginBlock();
        message.events = object.events?.map((e)=>$55d7da6fb7010b2f$exports.Event.fromPartial(e)) || [];
        return message;
    }
};
function $55d7da6fb7010b2f$var$createBaseResponseCheckTx() {
    return {
        code: 0,
        data: new Uint8Array(),
        log: "",
        info: "",
        gasWanted: $d5e07fe2518aae94$exports.Long.ZERO,
        gasUsed: $d5e07fe2518aae94$exports.Long.ZERO,
        events: [],
        codespace: "",
        sender: "",
        priority: $d5e07fe2518aae94$exports.Long.ZERO,
        mempoolError: ""
    };
}
$55d7da6fb7010b2f$exports.ResponseCheckTx = {
    encode (message, writer = $55d7da6fb7010b2f$var$_m0.Writer.create()) {
        if (message.code !== 0) writer.uint32(8).uint32(message.code);
        if (message.data.length !== 0) writer.uint32(18).bytes(message.data);
        if (message.log !== "") writer.uint32(26).string(message.log);
        if (message.info !== "") writer.uint32(34).string(message.info);
        if (!message.gasWanted.isZero()) writer.uint32(40).int64(message.gasWanted);
        if (!message.gasUsed.isZero()) writer.uint32(48).int64(message.gasUsed);
        for (const v of message.events)$55d7da6fb7010b2f$exports.Event.encode(v, writer.uint32(58).fork()).ldelim();
        if (message.codespace !== "") writer.uint32(66).string(message.codespace);
        if (message.sender !== "") writer.uint32(74).string(message.sender);
        if (!message.priority.isZero()) writer.uint32(80).int64(message.priority);
        if (message.mempoolError !== "") writer.uint32(90).string(message.mempoolError);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $55d7da6fb7010b2f$var$_m0.Reader ? input : new $55d7da6fb7010b2f$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $55d7da6fb7010b2f$var$createBaseResponseCheckTx();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.code = reader.uint32();
                    break;
                case 2:
                    message.data = reader.bytes();
                    break;
                case 3:
                    message.log = reader.string();
                    break;
                case 4:
                    message.info = reader.string();
                    break;
                case 5:
                    message.gasWanted = reader.int64();
                    break;
                case 6:
                    message.gasUsed = reader.int64();
                    break;
                case 7:
                    message.events.push($55d7da6fb7010b2f$exports.Event.decode(reader, reader.uint32()));
                    break;
                case 8:
                    message.codespace = reader.string();
                    break;
                case 9:
                    message.sender = reader.string();
                    break;
                case 10:
                    message.priority = reader.int64();
                    break;
                case 11:
                    message.mempoolError = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            code: (0, $d5e07fe2518aae94$exports.isSet)(object.code) ? Number(object.code) : 0,
            data: (0, $d5e07fe2518aae94$exports.isSet)(object.data) ? (0, $d5e07fe2518aae94$exports.bytesFromBase64)(object.data) : new Uint8Array(),
            log: (0, $d5e07fe2518aae94$exports.isSet)(object.log) ? String(object.log) : "",
            info: (0, $d5e07fe2518aae94$exports.isSet)(object.info) ? String(object.info) : "",
            gasWanted: (0, $d5e07fe2518aae94$exports.isSet)(object.gas_wanted) ? $d5e07fe2518aae94$exports.Long.fromValue(object.gas_wanted) : $d5e07fe2518aae94$exports.Long.ZERO,
            gasUsed: (0, $d5e07fe2518aae94$exports.isSet)(object.gas_used) ? $d5e07fe2518aae94$exports.Long.fromValue(object.gas_used) : $d5e07fe2518aae94$exports.Long.ZERO,
            events: Array.isArray(object?.events) ? object.events.map((e)=>$55d7da6fb7010b2f$exports.Event.fromJSON(e)) : [],
            codespace: (0, $d5e07fe2518aae94$exports.isSet)(object.codespace) ? String(object.codespace) : "",
            sender: (0, $d5e07fe2518aae94$exports.isSet)(object.sender) ? String(object.sender) : "",
            priority: (0, $d5e07fe2518aae94$exports.isSet)(object.priority) ? $d5e07fe2518aae94$exports.Long.fromValue(object.priority) : $d5e07fe2518aae94$exports.Long.ZERO,
            mempoolError: (0, $d5e07fe2518aae94$exports.isSet)(object.mempoolError) ? String(object.mempoolError) : ""
        };
    },
    toJSON (message) {
        const obj = {};
        message.code !== undefined && (obj.code = Math.round(message.code));
        message.data !== undefined && (obj.data = (0, $d5e07fe2518aae94$exports.base64FromBytes)(message.data !== undefined ? message.data : new Uint8Array()));
        message.log !== undefined && (obj.log = message.log);
        message.info !== undefined && (obj.info = message.info);
        message.gasWanted !== undefined && (obj.gas_wanted = (message.gasWanted || $d5e07fe2518aae94$exports.Long.ZERO).toString());
        message.gasUsed !== undefined && (obj.gas_used = (message.gasUsed || $d5e07fe2518aae94$exports.Long.ZERO).toString());
        if (message.events) obj.events = message.events.map((e)=>e ? $55d7da6fb7010b2f$exports.Event.toJSON(e) : undefined);
        else obj.events = [];
        message.codespace !== undefined && (obj.codespace = message.codespace);
        message.sender !== undefined && (obj.sender = message.sender);
        message.priority !== undefined && (obj.priority = (message.priority || $d5e07fe2518aae94$exports.Long.ZERO).toString());
        message.mempoolError !== undefined && (obj.mempoolError = message.mempoolError);
        return obj;
    },
    fromPartial (object) {
        const message = $55d7da6fb7010b2f$var$createBaseResponseCheckTx();
        message.code = object.code ?? 0;
        message.data = object.data ?? new Uint8Array();
        message.log = object.log ?? "";
        message.info = object.info ?? "";
        message.gasWanted = object.gasWanted !== undefined && object.gasWanted !== null ? $d5e07fe2518aae94$exports.Long.fromValue(object.gasWanted) : $d5e07fe2518aae94$exports.Long.ZERO;
        message.gasUsed = object.gasUsed !== undefined && object.gasUsed !== null ? $d5e07fe2518aae94$exports.Long.fromValue(object.gasUsed) : $d5e07fe2518aae94$exports.Long.ZERO;
        message.events = object.events?.map((e)=>$55d7da6fb7010b2f$exports.Event.fromPartial(e)) || [];
        message.codespace = object.codespace ?? "";
        message.sender = object.sender ?? "";
        message.priority = object.priority !== undefined && object.priority !== null ? $d5e07fe2518aae94$exports.Long.fromValue(object.priority) : $d5e07fe2518aae94$exports.Long.ZERO;
        message.mempoolError = object.mempoolError ?? "";
        return message;
    }
};
function $55d7da6fb7010b2f$var$createBaseResponseDeliverTx() {
    return {
        code: 0,
        data: new Uint8Array(),
        log: "",
        info: "",
        gasWanted: $d5e07fe2518aae94$exports.Long.ZERO,
        gasUsed: $d5e07fe2518aae94$exports.Long.ZERO,
        events: [],
        codespace: ""
    };
}
$55d7da6fb7010b2f$exports.ResponseDeliverTx = {
    encode (message, writer = $55d7da6fb7010b2f$var$_m0.Writer.create()) {
        if (message.code !== 0) writer.uint32(8).uint32(message.code);
        if (message.data.length !== 0) writer.uint32(18).bytes(message.data);
        if (message.log !== "") writer.uint32(26).string(message.log);
        if (message.info !== "") writer.uint32(34).string(message.info);
        if (!message.gasWanted.isZero()) writer.uint32(40).int64(message.gasWanted);
        if (!message.gasUsed.isZero()) writer.uint32(48).int64(message.gasUsed);
        for (const v of message.events)$55d7da6fb7010b2f$exports.Event.encode(v, writer.uint32(58).fork()).ldelim();
        if (message.codespace !== "") writer.uint32(66).string(message.codespace);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $55d7da6fb7010b2f$var$_m0.Reader ? input : new $55d7da6fb7010b2f$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $55d7da6fb7010b2f$var$createBaseResponseDeliverTx();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.code = reader.uint32();
                    break;
                case 2:
                    message.data = reader.bytes();
                    break;
                case 3:
                    message.log = reader.string();
                    break;
                case 4:
                    message.info = reader.string();
                    break;
                case 5:
                    message.gasWanted = reader.int64();
                    break;
                case 6:
                    message.gasUsed = reader.int64();
                    break;
                case 7:
                    message.events.push($55d7da6fb7010b2f$exports.Event.decode(reader, reader.uint32()));
                    break;
                case 8:
                    message.codespace = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            code: (0, $d5e07fe2518aae94$exports.isSet)(object.code) ? Number(object.code) : 0,
            data: (0, $d5e07fe2518aae94$exports.isSet)(object.data) ? (0, $d5e07fe2518aae94$exports.bytesFromBase64)(object.data) : new Uint8Array(),
            log: (0, $d5e07fe2518aae94$exports.isSet)(object.log) ? String(object.log) : "",
            info: (0, $d5e07fe2518aae94$exports.isSet)(object.info) ? String(object.info) : "",
            gasWanted: (0, $d5e07fe2518aae94$exports.isSet)(object.gas_wanted) ? $d5e07fe2518aae94$exports.Long.fromValue(object.gas_wanted) : $d5e07fe2518aae94$exports.Long.ZERO,
            gasUsed: (0, $d5e07fe2518aae94$exports.isSet)(object.gas_used) ? $d5e07fe2518aae94$exports.Long.fromValue(object.gas_used) : $d5e07fe2518aae94$exports.Long.ZERO,
            events: Array.isArray(object?.events) ? object.events.map((e)=>$55d7da6fb7010b2f$exports.Event.fromJSON(e)) : [],
            codespace: (0, $d5e07fe2518aae94$exports.isSet)(object.codespace) ? String(object.codespace) : ""
        };
    },
    toJSON (message) {
        const obj = {};
        message.code !== undefined && (obj.code = Math.round(message.code));
        message.data !== undefined && (obj.data = (0, $d5e07fe2518aae94$exports.base64FromBytes)(message.data !== undefined ? message.data : new Uint8Array()));
        message.log !== undefined && (obj.log = message.log);
        message.info !== undefined && (obj.info = message.info);
        message.gasWanted !== undefined && (obj.gas_wanted = (message.gasWanted || $d5e07fe2518aae94$exports.Long.ZERO).toString());
        message.gasUsed !== undefined && (obj.gas_used = (message.gasUsed || $d5e07fe2518aae94$exports.Long.ZERO).toString());
        if (message.events) obj.events = message.events.map((e)=>e ? $55d7da6fb7010b2f$exports.Event.toJSON(e) : undefined);
        else obj.events = [];
        message.codespace !== undefined && (obj.codespace = message.codespace);
        return obj;
    },
    fromPartial (object) {
        const message = $55d7da6fb7010b2f$var$createBaseResponseDeliverTx();
        message.code = object.code ?? 0;
        message.data = object.data ?? new Uint8Array();
        message.log = object.log ?? "";
        message.info = object.info ?? "";
        message.gasWanted = object.gasWanted !== undefined && object.gasWanted !== null ? $d5e07fe2518aae94$exports.Long.fromValue(object.gasWanted) : $d5e07fe2518aae94$exports.Long.ZERO;
        message.gasUsed = object.gasUsed !== undefined && object.gasUsed !== null ? $d5e07fe2518aae94$exports.Long.fromValue(object.gasUsed) : $d5e07fe2518aae94$exports.Long.ZERO;
        message.events = object.events?.map((e)=>$55d7da6fb7010b2f$exports.Event.fromPartial(e)) || [];
        message.codespace = object.codespace ?? "";
        return message;
    }
};
function $55d7da6fb7010b2f$var$createBaseResponseEndBlock() {
    return {
        validatorUpdates: [],
        consensusParamUpdates: undefined,
        events: []
    };
}
$55d7da6fb7010b2f$exports.ResponseEndBlock = {
    encode (message, writer = $55d7da6fb7010b2f$var$_m0.Writer.create()) {
        for (const v of message.validatorUpdates)$55d7da6fb7010b2f$exports.ValidatorUpdate.encode(v, writer.uint32(10).fork()).ldelim();
        if (message.consensusParamUpdates !== undefined) $134a665e0e74d535$exports.ConsensusParams.encode(message.consensusParamUpdates, writer.uint32(18).fork()).ldelim();
        for (const v of message.events)$55d7da6fb7010b2f$exports.Event.encode(v, writer.uint32(26).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $55d7da6fb7010b2f$var$_m0.Reader ? input : new $55d7da6fb7010b2f$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $55d7da6fb7010b2f$var$createBaseResponseEndBlock();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.validatorUpdates.push($55d7da6fb7010b2f$exports.ValidatorUpdate.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.consensusParamUpdates = $134a665e0e74d535$exports.ConsensusParams.decode(reader, reader.uint32());
                    break;
                case 3:
                    message.events.push($55d7da6fb7010b2f$exports.Event.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            validatorUpdates: Array.isArray(object?.validatorUpdates) ? object.validatorUpdates.map((e)=>$55d7da6fb7010b2f$exports.ValidatorUpdate.fromJSON(e)) : [],
            consensusParamUpdates: (0, $d5e07fe2518aae94$exports.isSet)(object.consensusParamUpdates) ? $134a665e0e74d535$exports.ConsensusParams.fromJSON(object.consensusParamUpdates) : undefined,
            events: Array.isArray(object?.events) ? object.events.map((e)=>$55d7da6fb7010b2f$exports.Event.fromJSON(e)) : []
        };
    },
    toJSON (message) {
        const obj = {};
        if (message.validatorUpdates) obj.validatorUpdates = message.validatorUpdates.map((e)=>e ? $55d7da6fb7010b2f$exports.ValidatorUpdate.toJSON(e) : undefined);
        else obj.validatorUpdates = [];
        message.consensusParamUpdates !== undefined && (obj.consensusParamUpdates = message.consensusParamUpdates ? $134a665e0e74d535$exports.ConsensusParams.toJSON(message.consensusParamUpdates) : undefined);
        if (message.events) obj.events = message.events.map((e)=>e ? $55d7da6fb7010b2f$exports.Event.toJSON(e) : undefined);
        else obj.events = [];
        return obj;
    },
    fromPartial (object) {
        const message = $55d7da6fb7010b2f$var$createBaseResponseEndBlock();
        message.validatorUpdates = object.validatorUpdates?.map((e)=>$55d7da6fb7010b2f$exports.ValidatorUpdate.fromPartial(e)) || [];
        message.consensusParamUpdates = object.consensusParamUpdates !== undefined && object.consensusParamUpdates !== null ? $134a665e0e74d535$exports.ConsensusParams.fromPartial(object.consensusParamUpdates) : undefined;
        message.events = object.events?.map((e)=>$55d7da6fb7010b2f$exports.Event.fromPartial(e)) || [];
        return message;
    }
};
function $55d7da6fb7010b2f$var$createBaseResponseCommit() {
    return {
        data: new Uint8Array(),
        retainHeight: $d5e07fe2518aae94$exports.Long.ZERO
    };
}
$55d7da6fb7010b2f$exports.ResponseCommit = {
    encode (message, writer = $55d7da6fb7010b2f$var$_m0.Writer.create()) {
        if (message.data.length !== 0) writer.uint32(18).bytes(message.data);
        if (!message.retainHeight.isZero()) writer.uint32(24).int64(message.retainHeight);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $55d7da6fb7010b2f$var$_m0.Reader ? input : new $55d7da6fb7010b2f$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $55d7da6fb7010b2f$var$createBaseResponseCommit();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 2:
                    message.data = reader.bytes();
                    break;
                case 3:
                    message.retainHeight = reader.int64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            data: (0, $d5e07fe2518aae94$exports.isSet)(object.data) ? (0, $d5e07fe2518aae94$exports.bytesFromBase64)(object.data) : new Uint8Array(),
            retainHeight: (0, $d5e07fe2518aae94$exports.isSet)(object.retainHeight) ? $d5e07fe2518aae94$exports.Long.fromValue(object.retainHeight) : $d5e07fe2518aae94$exports.Long.ZERO
        };
    },
    toJSON (message) {
        const obj = {};
        message.data !== undefined && (obj.data = (0, $d5e07fe2518aae94$exports.base64FromBytes)(message.data !== undefined ? message.data : new Uint8Array()));
        message.retainHeight !== undefined && (obj.retainHeight = (message.retainHeight || $d5e07fe2518aae94$exports.Long.ZERO).toString());
        return obj;
    },
    fromPartial (object) {
        const message = $55d7da6fb7010b2f$var$createBaseResponseCommit();
        message.data = object.data ?? new Uint8Array();
        message.retainHeight = object.retainHeight !== undefined && object.retainHeight !== null ? $d5e07fe2518aae94$exports.Long.fromValue(object.retainHeight) : $d5e07fe2518aae94$exports.Long.ZERO;
        return message;
    }
};
function $55d7da6fb7010b2f$var$createBaseResponseListSnapshots() {
    return {
        snapshots: []
    };
}
$55d7da6fb7010b2f$exports.ResponseListSnapshots = {
    encode (message, writer = $55d7da6fb7010b2f$var$_m0.Writer.create()) {
        for (const v of message.snapshots)$55d7da6fb7010b2f$exports.Snapshot.encode(v, writer.uint32(10).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $55d7da6fb7010b2f$var$_m0.Reader ? input : new $55d7da6fb7010b2f$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $55d7da6fb7010b2f$var$createBaseResponseListSnapshots();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.snapshots.push($55d7da6fb7010b2f$exports.Snapshot.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            snapshots: Array.isArray(object?.snapshots) ? object.snapshots.map((e)=>$55d7da6fb7010b2f$exports.Snapshot.fromJSON(e)) : []
        };
    },
    toJSON (message) {
        const obj = {};
        if (message.snapshots) obj.snapshots = message.snapshots.map((e)=>e ? $55d7da6fb7010b2f$exports.Snapshot.toJSON(e) : undefined);
        else obj.snapshots = [];
        return obj;
    },
    fromPartial (object) {
        const message = $55d7da6fb7010b2f$var$createBaseResponseListSnapshots();
        message.snapshots = object.snapshots?.map((e)=>$55d7da6fb7010b2f$exports.Snapshot.fromPartial(e)) || [];
        return message;
    }
};
function $55d7da6fb7010b2f$var$createBaseResponseOfferSnapshot() {
    return {
        result: 0
    };
}
$55d7da6fb7010b2f$exports.ResponseOfferSnapshot = {
    encode (message, writer = $55d7da6fb7010b2f$var$_m0.Writer.create()) {
        if (message.result !== 0) writer.uint32(8).int32(message.result);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $55d7da6fb7010b2f$var$_m0.Reader ? input : new $55d7da6fb7010b2f$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $55d7da6fb7010b2f$var$createBaseResponseOfferSnapshot();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.result = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            result: (0, $d5e07fe2518aae94$exports.isSet)(object.result) ? $55d7da6fb7010b2f$var$responseOfferSnapshot_ResultFromJSON(object.result) : 0
        };
    },
    toJSON (message) {
        const obj = {};
        message.result !== undefined && (obj.result = $55d7da6fb7010b2f$var$responseOfferSnapshot_ResultToJSON(message.result));
        return obj;
    },
    fromPartial (object) {
        const message = $55d7da6fb7010b2f$var$createBaseResponseOfferSnapshot();
        message.result = object.result ?? 0;
        return message;
    }
};
function $55d7da6fb7010b2f$var$createBaseResponseLoadSnapshotChunk() {
    return {
        chunk: new Uint8Array()
    };
}
$55d7da6fb7010b2f$exports.ResponseLoadSnapshotChunk = {
    encode (message, writer = $55d7da6fb7010b2f$var$_m0.Writer.create()) {
        if (message.chunk.length !== 0) writer.uint32(10).bytes(message.chunk);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $55d7da6fb7010b2f$var$_m0.Reader ? input : new $55d7da6fb7010b2f$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $55d7da6fb7010b2f$var$createBaseResponseLoadSnapshotChunk();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.chunk = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            chunk: (0, $d5e07fe2518aae94$exports.isSet)(object.chunk) ? (0, $d5e07fe2518aae94$exports.bytesFromBase64)(object.chunk) : new Uint8Array()
        };
    },
    toJSON (message) {
        const obj = {};
        message.chunk !== undefined && (obj.chunk = (0, $d5e07fe2518aae94$exports.base64FromBytes)(message.chunk !== undefined ? message.chunk : new Uint8Array()));
        return obj;
    },
    fromPartial (object) {
        const message = $55d7da6fb7010b2f$var$createBaseResponseLoadSnapshotChunk();
        message.chunk = object.chunk ?? new Uint8Array();
        return message;
    }
};
function $55d7da6fb7010b2f$var$createBaseResponseApplySnapshotChunk() {
    return {
        result: 0,
        refetchChunks: [],
        rejectSenders: []
    };
}
$55d7da6fb7010b2f$exports.ResponseApplySnapshotChunk = {
    encode (message, writer = $55d7da6fb7010b2f$var$_m0.Writer.create()) {
        if (message.result !== 0) writer.uint32(8).int32(message.result);
        writer.uint32(18).fork();
        for (const v of message.refetchChunks)writer.uint32(v);
        writer.ldelim();
        for (const v of message.rejectSenders)writer.uint32(26).string(v);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $55d7da6fb7010b2f$var$_m0.Reader ? input : new $55d7da6fb7010b2f$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $55d7da6fb7010b2f$var$createBaseResponseApplySnapshotChunk();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.result = reader.int32();
                    break;
                case 2:
                    if ((tag & 7) === 2) {
                        const end2 = reader.uint32() + reader.pos;
                        while(reader.pos < end2)message.refetchChunks.push(reader.uint32());
                    } else message.refetchChunks.push(reader.uint32());
                    break;
                case 3:
                    message.rejectSenders.push(reader.string());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            result: (0, $d5e07fe2518aae94$exports.isSet)(object.result) ? $55d7da6fb7010b2f$var$responseApplySnapshotChunk_ResultFromJSON(object.result) : 0,
            refetchChunks: Array.isArray(object?.refetchChunks) ? object.refetchChunks.map((e)=>Number(e)) : [],
            rejectSenders: Array.isArray(object?.rejectSenders) ? object.rejectSenders.map((e)=>String(e)) : []
        };
    },
    toJSON (message) {
        const obj = {};
        message.result !== undefined && (obj.result = $55d7da6fb7010b2f$var$responseApplySnapshotChunk_ResultToJSON(message.result));
        if (message.refetchChunks) obj.refetchChunks = message.refetchChunks.map((e)=>Math.round(e));
        else obj.refetchChunks = [];
        if (message.rejectSenders) obj.rejectSenders = message.rejectSenders.map((e)=>e);
        else obj.rejectSenders = [];
        return obj;
    },
    fromPartial (object) {
        const message = $55d7da6fb7010b2f$var$createBaseResponseApplySnapshotChunk();
        message.result = object.result ?? 0;
        message.refetchChunks = object.refetchChunks?.map((e)=>e) || [];
        message.rejectSenders = object.rejectSenders?.map((e)=>e) || [];
        return message;
    }
};
function $55d7da6fb7010b2f$var$createBaseResponsePrepareProposal() {
    return {
        txs: []
    };
}
$55d7da6fb7010b2f$exports.ResponsePrepareProposal = {
    encode (message, writer = $55d7da6fb7010b2f$var$_m0.Writer.create()) {
        for (const v of message.txs)writer.uint32(10).bytes(v);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $55d7da6fb7010b2f$var$_m0.Reader ? input : new $55d7da6fb7010b2f$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $55d7da6fb7010b2f$var$createBaseResponsePrepareProposal();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.txs.push(reader.bytes());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            txs: Array.isArray(object?.txs) ? object.txs.map((e)=>(0, $d5e07fe2518aae94$exports.bytesFromBase64)(e)) : []
        };
    },
    toJSON (message) {
        const obj = {};
        if (message.txs) obj.txs = message.txs.map((e)=>(0, $d5e07fe2518aae94$exports.base64FromBytes)(e !== undefined ? e : new Uint8Array()));
        else obj.txs = [];
        return obj;
    },
    fromPartial (object) {
        const message = $55d7da6fb7010b2f$var$createBaseResponsePrepareProposal();
        message.txs = object.txs?.map((e)=>e) || [];
        return message;
    }
};
function $55d7da6fb7010b2f$var$createBaseResponseProcessProposal() {
    return {
        status: 0
    };
}
$55d7da6fb7010b2f$exports.ResponseProcessProposal = {
    encode (message, writer = $55d7da6fb7010b2f$var$_m0.Writer.create()) {
        if (message.status !== 0) writer.uint32(8).int32(message.status);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $55d7da6fb7010b2f$var$_m0.Reader ? input : new $55d7da6fb7010b2f$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $55d7da6fb7010b2f$var$createBaseResponseProcessProposal();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.status = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            status: (0, $d5e07fe2518aae94$exports.isSet)(object.status) ? $55d7da6fb7010b2f$var$responseProcessProposal_ProposalStatusFromJSON(object.status) : 0
        };
    },
    toJSON (message) {
        const obj = {};
        message.status !== undefined && (obj.status = $55d7da6fb7010b2f$var$responseProcessProposal_ProposalStatusToJSON(message.status));
        return obj;
    },
    fromPartial (object) {
        const message = $55d7da6fb7010b2f$var$createBaseResponseProcessProposal();
        message.status = object.status ?? 0;
        return message;
    }
};
function $55d7da6fb7010b2f$var$createBaseCommitInfo() {
    return {
        round: 0,
        votes: []
    };
}
$55d7da6fb7010b2f$exports.CommitInfo = {
    encode (message, writer = $55d7da6fb7010b2f$var$_m0.Writer.create()) {
        if (message.round !== 0) writer.uint32(8).int32(message.round);
        for (const v of message.votes)$55d7da6fb7010b2f$exports.VoteInfo.encode(v, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $55d7da6fb7010b2f$var$_m0.Reader ? input : new $55d7da6fb7010b2f$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $55d7da6fb7010b2f$var$createBaseCommitInfo();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.round = reader.int32();
                    break;
                case 2:
                    message.votes.push($55d7da6fb7010b2f$exports.VoteInfo.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            round: (0, $d5e07fe2518aae94$exports.isSet)(object.round) ? Number(object.round) : 0,
            votes: Array.isArray(object?.votes) ? object.votes.map((e)=>$55d7da6fb7010b2f$exports.VoteInfo.fromJSON(e)) : []
        };
    },
    toJSON (message) {
        const obj = {};
        message.round !== undefined && (obj.round = Math.round(message.round));
        if (message.votes) obj.votes = message.votes.map((e)=>e ? $55d7da6fb7010b2f$exports.VoteInfo.toJSON(e) : undefined);
        else obj.votes = [];
        return obj;
    },
    fromPartial (object) {
        const message = $55d7da6fb7010b2f$var$createBaseCommitInfo();
        message.round = object.round ?? 0;
        message.votes = object.votes?.map((e)=>$55d7da6fb7010b2f$exports.VoteInfo.fromPartial(e)) || [];
        return message;
    }
};
function $55d7da6fb7010b2f$var$createBaseExtendedCommitInfo() {
    return {
        round: 0,
        votes: []
    };
}
$55d7da6fb7010b2f$exports.ExtendedCommitInfo = {
    encode (message, writer = $55d7da6fb7010b2f$var$_m0.Writer.create()) {
        if (message.round !== 0) writer.uint32(8).int32(message.round);
        for (const v of message.votes)$55d7da6fb7010b2f$exports.ExtendedVoteInfo.encode(v, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $55d7da6fb7010b2f$var$_m0.Reader ? input : new $55d7da6fb7010b2f$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $55d7da6fb7010b2f$var$createBaseExtendedCommitInfo();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.round = reader.int32();
                    break;
                case 2:
                    message.votes.push($55d7da6fb7010b2f$exports.ExtendedVoteInfo.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            round: (0, $d5e07fe2518aae94$exports.isSet)(object.round) ? Number(object.round) : 0,
            votes: Array.isArray(object?.votes) ? object.votes.map((e)=>$55d7da6fb7010b2f$exports.ExtendedVoteInfo.fromJSON(e)) : []
        };
    },
    toJSON (message) {
        const obj = {};
        message.round !== undefined && (obj.round = Math.round(message.round));
        if (message.votes) obj.votes = message.votes.map((e)=>e ? $55d7da6fb7010b2f$exports.ExtendedVoteInfo.toJSON(e) : undefined);
        else obj.votes = [];
        return obj;
    },
    fromPartial (object) {
        const message = $55d7da6fb7010b2f$var$createBaseExtendedCommitInfo();
        message.round = object.round ?? 0;
        message.votes = object.votes?.map((e)=>$55d7da6fb7010b2f$exports.ExtendedVoteInfo.fromPartial(e)) || [];
        return message;
    }
};
function $55d7da6fb7010b2f$var$createBaseEvent() {
    return {
        type: "",
        attributes: []
    };
}
$55d7da6fb7010b2f$exports.Event = {
    encode (message, writer = $55d7da6fb7010b2f$var$_m0.Writer.create()) {
        if (message.type !== "") writer.uint32(10).string(message.type);
        for (const v of message.attributes)$55d7da6fb7010b2f$exports.EventAttribute.encode(v, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $55d7da6fb7010b2f$var$_m0.Reader ? input : new $55d7da6fb7010b2f$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $55d7da6fb7010b2f$var$createBaseEvent();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.type = reader.string();
                    break;
                case 2:
                    message.attributes.push($55d7da6fb7010b2f$exports.EventAttribute.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            type: (0, $d5e07fe2518aae94$exports.isSet)(object.type) ? String(object.type) : "",
            attributes: Array.isArray(object?.attributes) ? object.attributes.map((e)=>$55d7da6fb7010b2f$exports.EventAttribute.fromJSON(e)) : []
        };
    },
    toJSON (message) {
        const obj = {};
        message.type !== undefined && (obj.type = message.type);
        if (message.attributes) obj.attributes = message.attributes.map((e)=>e ? $55d7da6fb7010b2f$exports.EventAttribute.toJSON(e) : undefined);
        else obj.attributes = [];
        return obj;
    },
    fromPartial (object) {
        const message = $55d7da6fb7010b2f$var$createBaseEvent();
        message.type = object.type ?? "";
        message.attributes = object.attributes?.map((e)=>$55d7da6fb7010b2f$exports.EventAttribute.fromPartial(e)) || [];
        return message;
    }
};
function $55d7da6fb7010b2f$var$createBaseEventAttribute() {
    return {
        key: "",
        value: "",
        index: false
    };
}
$55d7da6fb7010b2f$exports.EventAttribute = {
    encode (message, writer = $55d7da6fb7010b2f$var$_m0.Writer.create()) {
        if (message.key !== "") writer.uint32(10).string(message.key);
        if (message.value !== "") writer.uint32(18).string(message.value);
        if (message.index === true) writer.uint32(24).bool(message.index);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $55d7da6fb7010b2f$var$_m0.Reader ? input : new $55d7da6fb7010b2f$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $55d7da6fb7010b2f$var$createBaseEventAttribute();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.key = reader.string();
                    break;
                case 2:
                    message.value = reader.string();
                    break;
                case 3:
                    message.index = reader.bool();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            key: (0, $d5e07fe2518aae94$exports.isSet)(object.key) ? String(object.key) : "",
            value: (0, $d5e07fe2518aae94$exports.isSet)(object.value) ? String(object.value) : "",
            index: (0, $d5e07fe2518aae94$exports.isSet)(object.index) ? Boolean(object.index) : false
        };
    },
    toJSON (message) {
        const obj = {};
        message.key !== undefined && (obj.key = message.key);
        message.value !== undefined && (obj.value = message.value);
        message.index !== undefined && (obj.index = message.index);
        return obj;
    },
    fromPartial (object) {
        const message = $55d7da6fb7010b2f$var$createBaseEventAttribute();
        message.key = object.key ?? "";
        message.value = object.value ?? "";
        message.index = object.index ?? false;
        return message;
    }
};
function $55d7da6fb7010b2f$var$createBaseTxResult() {
    return {
        height: $d5e07fe2518aae94$exports.Long.ZERO,
        index: 0,
        tx: new Uint8Array(),
        result: undefined
    };
}
$55d7da6fb7010b2f$exports.TxResult = {
    encode (message, writer = $55d7da6fb7010b2f$var$_m0.Writer.create()) {
        if (!message.height.isZero()) writer.uint32(8).int64(message.height);
        if (message.index !== 0) writer.uint32(16).uint32(message.index);
        if (message.tx.length !== 0) writer.uint32(26).bytes(message.tx);
        if (message.result !== undefined) $55d7da6fb7010b2f$exports.ResponseDeliverTx.encode(message.result, writer.uint32(34).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $55d7da6fb7010b2f$var$_m0.Reader ? input : new $55d7da6fb7010b2f$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $55d7da6fb7010b2f$var$createBaseTxResult();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.height = reader.int64();
                    break;
                case 2:
                    message.index = reader.uint32();
                    break;
                case 3:
                    message.tx = reader.bytes();
                    break;
                case 4:
                    message.result = $55d7da6fb7010b2f$exports.ResponseDeliverTx.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            height: (0, $d5e07fe2518aae94$exports.isSet)(object.height) ? $d5e07fe2518aae94$exports.Long.fromValue(object.height) : $d5e07fe2518aae94$exports.Long.ZERO,
            index: (0, $d5e07fe2518aae94$exports.isSet)(object.index) ? Number(object.index) : 0,
            tx: (0, $d5e07fe2518aae94$exports.isSet)(object.tx) ? (0, $d5e07fe2518aae94$exports.bytesFromBase64)(object.tx) : new Uint8Array(),
            result: (0, $d5e07fe2518aae94$exports.isSet)(object.result) ? $55d7da6fb7010b2f$exports.ResponseDeliverTx.fromJSON(object.result) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.height !== undefined && (obj.height = (message.height || $d5e07fe2518aae94$exports.Long.ZERO).toString());
        message.index !== undefined && (obj.index = Math.round(message.index));
        message.tx !== undefined && (obj.tx = (0, $d5e07fe2518aae94$exports.base64FromBytes)(message.tx !== undefined ? message.tx : new Uint8Array()));
        message.result !== undefined && (obj.result = message.result ? $55d7da6fb7010b2f$exports.ResponseDeliverTx.toJSON(message.result) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $55d7da6fb7010b2f$var$createBaseTxResult();
        message.height = object.height !== undefined && object.height !== null ? $d5e07fe2518aae94$exports.Long.fromValue(object.height) : $d5e07fe2518aae94$exports.Long.ZERO;
        message.index = object.index ?? 0;
        message.tx = object.tx ?? new Uint8Array();
        message.result = object.result !== undefined && object.result !== null ? $55d7da6fb7010b2f$exports.ResponseDeliverTx.fromPartial(object.result) : undefined;
        return message;
    }
};
function $55d7da6fb7010b2f$var$createBaseValidator() {
    return {
        address: new Uint8Array(),
        power: $d5e07fe2518aae94$exports.Long.ZERO
    };
}
$55d7da6fb7010b2f$exports.Validator = {
    encode (message, writer = $55d7da6fb7010b2f$var$_m0.Writer.create()) {
        if (message.address.length !== 0) writer.uint32(10).bytes(message.address);
        if (!message.power.isZero()) writer.uint32(24).int64(message.power);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $55d7da6fb7010b2f$var$_m0.Reader ? input : new $55d7da6fb7010b2f$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $55d7da6fb7010b2f$var$createBaseValidator();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.address = reader.bytes();
                    break;
                case 3:
                    message.power = reader.int64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            address: (0, $d5e07fe2518aae94$exports.isSet)(object.address) ? (0, $d5e07fe2518aae94$exports.bytesFromBase64)(object.address) : new Uint8Array(),
            power: (0, $d5e07fe2518aae94$exports.isSet)(object.power) ? $d5e07fe2518aae94$exports.Long.fromValue(object.power) : $d5e07fe2518aae94$exports.Long.ZERO
        };
    },
    toJSON (message) {
        const obj = {};
        message.address !== undefined && (obj.address = (0, $d5e07fe2518aae94$exports.base64FromBytes)(message.address !== undefined ? message.address : new Uint8Array()));
        message.power !== undefined && (obj.power = (message.power || $d5e07fe2518aae94$exports.Long.ZERO).toString());
        return obj;
    },
    fromPartial (object) {
        const message = $55d7da6fb7010b2f$var$createBaseValidator();
        message.address = object.address ?? new Uint8Array();
        message.power = object.power !== undefined && object.power !== null ? $d5e07fe2518aae94$exports.Long.fromValue(object.power) : $d5e07fe2518aae94$exports.Long.ZERO;
        return message;
    }
};
function $55d7da6fb7010b2f$var$createBaseValidatorUpdate() {
    return {
        pubKey: undefined,
        power: $d5e07fe2518aae94$exports.Long.ZERO
    };
}
$55d7da6fb7010b2f$exports.ValidatorUpdate = {
    encode (message, writer = $55d7da6fb7010b2f$var$_m0.Writer.create()) {
        if (message.pubKey !== undefined) $0f072fab6e1713a0$exports.PublicKey.encode(message.pubKey, writer.uint32(10).fork()).ldelim();
        if (!message.power.isZero()) writer.uint32(16).int64(message.power);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $55d7da6fb7010b2f$var$_m0.Reader ? input : new $55d7da6fb7010b2f$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $55d7da6fb7010b2f$var$createBaseValidatorUpdate();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.pubKey = $0f072fab6e1713a0$exports.PublicKey.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.power = reader.int64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            pubKey: (0, $d5e07fe2518aae94$exports.isSet)(object.pubKey) ? $0f072fab6e1713a0$exports.PublicKey.fromJSON(object.pubKey) : undefined,
            power: (0, $d5e07fe2518aae94$exports.isSet)(object.power) ? $d5e07fe2518aae94$exports.Long.fromValue(object.power) : $d5e07fe2518aae94$exports.Long.ZERO
        };
    },
    toJSON (message) {
        const obj = {};
        message.pubKey !== undefined && (obj.pubKey = message.pubKey ? $0f072fab6e1713a0$exports.PublicKey.toJSON(message.pubKey) : undefined);
        message.power !== undefined && (obj.power = (message.power || $d5e07fe2518aae94$exports.Long.ZERO).toString());
        return obj;
    },
    fromPartial (object) {
        const message = $55d7da6fb7010b2f$var$createBaseValidatorUpdate();
        message.pubKey = object.pubKey !== undefined && object.pubKey !== null ? $0f072fab6e1713a0$exports.PublicKey.fromPartial(object.pubKey) : undefined;
        message.power = object.power !== undefined && object.power !== null ? $d5e07fe2518aae94$exports.Long.fromValue(object.power) : $d5e07fe2518aae94$exports.Long.ZERO;
        return message;
    }
};
function $55d7da6fb7010b2f$var$createBaseVoteInfo() {
    return {
        validator: undefined,
        signedLastBlock: false
    };
}
$55d7da6fb7010b2f$exports.VoteInfo = {
    encode (message, writer = $55d7da6fb7010b2f$var$_m0.Writer.create()) {
        if (message.validator !== undefined) $55d7da6fb7010b2f$exports.Validator.encode(message.validator, writer.uint32(10).fork()).ldelim();
        if (message.signedLastBlock === true) writer.uint32(16).bool(message.signedLastBlock);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $55d7da6fb7010b2f$var$_m0.Reader ? input : new $55d7da6fb7010b2f$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $55d7da6fb7010b2f$var$createBaseVoteInfo();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.validator = $55d7da6fb7010b2f$exports.Validator.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.signedLastBlock = reader.bool();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            validator: (0, $d5e07fe2518aae94$exports.isSet)(object.validator) ? $55d7da6fb7010b2f$exports.Validator.fromJSON(object.validator) : undefined,
            signedLastBlock: (0, $d5e07fe2518aae94$exports.isSet)(object.signedLastBlock) ? Boolean(object.signedLastBlock) : false
        };
    },
    toJSON (message) {
        const obj = {};
        message.validator !== undefined && (obj.validator = message.validator ? $55d7da6fb7010b2f$exports.Validator.toJSON(message.validator) : undefined);
        message.signedLastBlock !== undefined && (obj.signedLastBlock = message.signedLastBlock);
        return obj;
    },
    fromPartial (object) {
        const message = $55d7da6fb7010b2f$var$createBaseVoteInfo();
        message.validator = object.validator !== undefined && object.validator !== null ? $55d7da6fb7010b2f$exports.Validator.fromPartial(object.validator) : undefined;
        message.signedLastBlock = object.signedLastBlock ?? false;
        return message;
    }
};
function $55d7da6fb7010b2f$var$createBaseExtendedVoteInfo() {
    return {
        validator: undefined,
        signedLastBlock: false,
        voteExtension: new Uint8Array()
    };
}
$55d7da6fb7010b2f$exports.ExtendedVoteInfo = {
    encode (message, writer = $55d7da6fb7010b2f$var$_m0.Writer.create()) {
        if (message.validator !== undefined) $55d7da6fb7010b2f$exports.Validator.encode(message.validator, writer.uint32(10).fork()).ldelim();
        if (message.signedLastBlock === true) writer.uint32(16).bool(message.signedLastBlock);
        if (message.voteExtension.length !== 0) writer.uint32(26).bytes(message.voteExtension);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $55d7da6fb7010b2f$var$_m0.Reader ? input : new $55d7da6fb7010b2f$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $55d7da6fb7010b2f$var$createBaseExtendedVoteInfo();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.validator = $55d7da6fb7010b2f$exports.Validator.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.signedLastBlock = reader.bool();
                    break;
                case 3:
                    message.voteExtension = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            validator: (0, $d5e07fe2518aae94$exports.isSet)(object.validator) ? $55d7da6fb7010b2f$exports.Validator.fromJSON(object.validator) : undefined,
            signedLastBlock: (0, $d5e07fe2518aae94$exports.isSet)(object.signedLastBlock) ? Boolean(object.signedLastBlock) : false,
            voteExtension: (0, $d5e07fe2518aae94$exports.isSet)(object.voteExtension) ? (0, $d5e07fe2518aae94$exports.bytesFromBase64)(object.voteExtension) : new Uint8Array()
        };
    },
    toJSON (message) {
        const obj = {};
        message.validator !== undefined && (obj.validator = message.validator ? $55d7da6fb7010b2f$exports.Validator.toJSON(message.validator) : undefined);
        message.signedLastBlock !== undefined && (obj.signedLastBlock = message.signedLastBlock);
        message.voteExtension !== undefined && (obj.voteExtension = (0, $d5e07fe2518aae94$exports.base64FromBytes)(message.voteExtension !== undefined ? message.voteExtension : new Uint8Array()));
        return obj;
    },
    fromPartial (object) {
        const message = $55d7da6fb7010b2f$var$createBaseExtendedVoteInfo();
        message.validator = object.validator !== undefined && object.validator !== null ? $55d7da6fb7010b2f$exports.Validator.fromPartial(object.validator) : undefined;
        message.signedLastBlock = object.signedLastBlock ?? false;
        message.voteExtension = object.voteExtension ?? new Uint8Array();
        return message;
    }
};
function $55d7da6fb7010b2f$var$createBaseMisbehavior() {
    return {
        type: 0,
        validator: undefined,
        height: $d5e07fe2518aae94$exports.Long.ZERO,
        time: undefined,
        totalVotingPower: $d5e07fe2518aae94$exports.Long.ZERO
    };
}
$55d7da6fb7010b2f$exports.Misbehavior = {
    encode (message, writer = $55d7da6fb7010b2f$var$_m0.Writer.create()) {
        if (message.type !== 0) writer.uint32(8).int32(message.type);
        if (message.validator !== undefined) $55d7da6fb7010b2f$exports.Validator.encode(message.validator, writer.uint32(18).fork()).ldelim();
        if (!message.height.isZero()) writer.uint32(24).int64(message.height);
        if (message.time !== undefined) $e7eaeedc85b414fc$exports.Timestamp.encode(message.time, writer.uint32(34).fork()).ldelim();
        if (!message.totalVotingPower.isZero()) writer.uint32(40).int64(message.totalVotingPower);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $55d7da6fb7010b2f$var$_m0.Reader ? input : new $55d7da6fb7010b2f$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $55d7da6fb7010b2f$var$createBaseMisbehavior();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.type = reader.int32();
                    break;
                case 2:
                    message.validator = $55d7da6fb7010b2f$exports.Validator.decode(reader, reader.uint32());
                    break;
                case 3:
                    message.height = reader.int64();
                    break;
                case 4:
                    message.time = $e7eaeedc85b414fc$exports.Timestamp.decode(reader, reader.uint32());
                    break;
                case 5:
                    message.totalVotingPower = reader.int64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            type: (0, $d5e07fe2518aae94$exports.isSet)(object.type) ? $55d7da6fb7010b2f$var$misbehaviorTypeFromJSON(object.type) : 0,
            validator: (0, $d5e07fe2518aae94$exports.isSet)(object.validator) ? $55d7da6fb7010b2f$exports.Validator.fromJSON(object.validator) : undefined,
            height: (0, $d5e07fe2518aae94$exports.isSet)(object.height) ? $d5e07fe2518aae94$exports.Long.fromValue(object.height) : $d5e07fe2518aae94$exports.Long.ZERO,
            time: (0, $d5e07fe2518aae94$exports.isSet)(object.time) ? (0, $d5e07fe2518aae94$exports.fromJsonTimestamp)(object.time) : undefined,
            totalVotingPower: (0, $d5e07fe2518aae94$exports.isSet)(object.totalVotingPower) ? $d5e07fe2518aae94$exports.Long.fromValue(object.totalVotingPower) : $d5e07fe2518aae94$exports.Long.ZERO
        };
    },
    toJSON (message) {
        const obj = {};
        message.type !== undefined && (obj.type = $55d7da6fb7010b2f$var$misbehaviorTypeToJSON(message.type));
        message.validator !== undefined && (obj.validator = message.validator ? $55d7da6fb7010b2f$exports.Validator.toJSON(message.validator) : undefined);
        message.height !== undefined && (obj.height = (message.height || $d5e07fe2518aae94$exports.Long.ZERO).toString());
        message.time !== undefined && (obj.time = (0, $d5e07fe2518aae94$exports.fromTimestamp)(message.time).toISOString());
        message.totalVotingPower !== undefined && (obj.totalVotingPower = (message.totalVotingPower || $d5e07fe2518aae94$exports.Long.ZERO).toString());
        return obj;
    },
    fromPartial (object) {
        const message = $55d7da6fb7010b2f$var$createBaseMisbehavior();
        message.type = object.type ?? 0;
        message.validator = object.validator !== undefined && object.validator !== null ? $55d7da6fb7010b2f$exports.Validator.fromPartial(object.validator) : undefined;
        message.height = object.height !== undefined && object.height !== null ? $d5e07fe2518aae94$exports.Long.fromValue(object.height) : $d5e07fe2518aae94$exports.Long.ZERO;
        message.time = object.time !== undefined && object.time !== null ? $e7eaeedc85b414fc$exports.Timestamp.fromPartial(object.time) : undefined;
        message.totalVotingPower = object.totalVotingPower !== undefined && object.totalVotingPower !== null ? $d5e07fe2518aae94$exports.Long.fromValue(object.totalVotingPower) : $d5e07fe2518aae94$exports.Long.ZERO;
        return message;
    }
};
function $55d7da6fb7010b2f$var$createBaseSnapshot() {
    return {
        height: $d5e07fe2518aae94$exports.Long.UZERO,
        format: 0,
        chunks: 0,
        hash: new Uint8Array(),
        metadata: new Uint8Array()
    };
}
$55d7da6fb7010b2f$exports.Snapshot = {
    encode (message, writer = $55d7da6fb7010b2f$var$_m0.Writer.create()) {
        if (!message.height.isZero()) writer.uint32(8).uint64(message.height);
        if (message.format !== 0) writer.uint32(16).uint32(message.format);
        if (message.chunks !== 0) writer.uint32(24).uint32(message.chunks);
        if (message.hash.length !== 0) writer.uint32(34).bytes(message.hash);
        if (message.metadata.length !== 0) writer.uint32(42).bytes(message.metadata);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $55d7da6fb7010b2f$var$_m0.Reader ? input : new $55d7da6fb7010b2f$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $55d7da6fb7010b2f$var$createBaseSnapshot();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.height = reader.uint64();
                    break;
                case 2:
                    message.format = reader.uint32();
                    break;
                case 3:
                    message.chunks = reader.uint32();
                    break;
                case 4:
                    message.hash = reader.bytes();
                    break;
                case 5:
                    message.metadata = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            height: (0, $d5e07fe2518aae94$exports.isSet)(object.height) ? $d5e07fe2518aae94$exports.Long.fromValue(object.height) : $d5e07fe2518aae94$exports.Long.UZERO,
            format: (0, $d5e07fe2518aae94$exports.isSet)(object.format) ? Number(object.format) : 0,
            chunks: (0, $d5e07fe2518aae94$exports.isSet)(object.chunks) ? Number(object.chunks) : 0,
            hash: (0, $d5e07fe2518aae94$exports.isSet)(object.hash) ? (0, $d5e07fe2518aae94$exports.bytesFromBase64)(object.hash) : new Uint8Array(),
            metadata: (0, $d5e07fe2518aae94$exports.isSet)(object.metadata) ? (0, $d5e07fe2518aae94$exports.bytesFromBase64)(object.metadata) : new Uint8Array()
        };
    },
    toJSON (message) {
        const obj = {};
        message.height !== undefined && (obj.height = (message.height || $d5e07fe2518aae94$exports.Long.UZERO).toString());
        message.format !== undefined && (obj.format = Math.round(message.format));
        message.chunks !== undefined && (obj.chunks = Math.round(message.chunks));
        message.hash !== undefined && (obj.hash = (0, $d5e07fe2518aae94$exports.base64FromBytes)(message.hash !== undefined ? message.hash : new Uint8Array()));
        message.metadata !== undefined && (obj.metadata = (0, $d5e07fe2518aae94$exports.base64FromBytes)(message.metadata !== undefined ? message.metadata : new Uint8Array()));
        return obj;
    },
    fromPartial (object) {
        const message = $55d7da6fb7010b2f$var$createBaseSnapshot();
        message.height = object.height !== undefined && object.height !== null ? $d5e07fe2518aae94$exports.Long.fromValue(object.height) : $d5e07fe2518aae94$exports.Long.UZERO;
        message.format = object.format ?? 0;
        message.chunks = object.chunks ?? 0;
        message.hash = object.hash ?? new Uint8Array();
        message.metadata = object.metadata ?? new Uint8Array();
        return message;
    }
};
class $55d7da6fb7010b2f$var$ABCIApplicationClientImpl {
    constructor(rpc){
        this.rpc = rpc;
        this.Echo = this.Echo.bind(this);
        this.Flush = this.Flush.bind(this);
        this.Info = this.Info.bind(this);
        this.DeliverTx = this.DeliverTx.bind(this);
        this.CheckTx = this.CheckTx.bind(this);
        this.Query = this.Query.bind(this);
        this.Commit = this.Commit.bind(this);
        this.InitChain = this.InitChain.bind(this);
        this.BeginBlock = this.BeginBlock.bind(this);
        this.EndBlock = this.EndBlock.bind(this);
        this.ListSnapshots = this.ListSnapshots.bind(this);
        this.OfferSnapshot = this.OfferSnapshot.bind(this);
        this.LoadSnapshotChunk = this.LoadSnapshotChunk.bind(this);
        this.ApplySnapshotChunk = this.ApplySnapshotChunk.bind(this);
        this.PrepareProposal = this.PrepareProposal.bind(this);
        this.ProcessProposal = this.ProcessProposal.bind(this);
    }
    Echo(request) {
        const data = $55d7da6fb7010b2f$exports.RequestEcho.encode(request).finish();
        const promise = this.rpc.request("tendermint.abci.ABCIApplication", "Echo", data);
        return promise.then((data)=>$55d7da6fb7010b2f$exports.ResponseEcho.decode(new $55d7da6fb7010b2f$var$_m0.Reader(data)));
    }
    Flush(request = {}) {
        const data = $55d7da6fb7010b2f$exports.RequestFlush.encode(request).finish();
        const promise = this.rpc.request("tendermint.abci.ABCIApplication", "Flush", data);
        return promise.then((data)=>$55d7da6fb7010b2f$exports.ResponseFlush.decode(new $55d7da6fb7010b2f$var$_m0.Reader(data)));
    }
    Info(request) {
        const data = $55d7da6fb7010b2f$exports.RequestInfo.encode(request).finish();
        const promise = this.rpc.request("tendermint.abci.ABCIApplication", "Info", data);
        return promise.then((data)=>$55d7da6fb7010b2f$exports.ResponseInfo.decode(new $55d7da6fb7010b2f$var$_m0.Reader(data)));
    }
    DeliverTx(request) {
        const data = $55d7da6fb7010b2f$exports.RequestDeliverTx.encode(request).finish();
        const promise = this.rpc.request("tendermint.abci.ABCIApplication", "DeliverTx", data);
        return promise.then((data)=>$55d7da6fb7010b2f$exports.ResponseDeliverTx.decode(new $55d7da6fb7010b2f$var$_m0.Reader(data)));
    }
    CheckTx(request) {
        const data = $55d7da6fb7010b2f$exports.RequestCheckTx.encode(request).finish();
        const promise = this.rpc.request("tendermint.abci.ABCIApplication", "CheckTx", data);
        return promise.then((data)=>$55d7da6fb7010b2f$exports.ResponseCheckTx.decode(new $55d7da6fb7010b2f$var$_m0.Reader(data)));
    }
    Query(request) {
        const data = $55d7da6fb7010b2f$exports.RequestQuery.encode(request).finish();
        const promise = this.rpc.request("tendermint.abci.ABCIApplication", "Query", data);
        return promise.then((data)=>$55d7da6fb7010b2f$exports.ResponseQuery.decode(new $55d7da6fb7010b2f$var$_m0.Reader(data)));
    }
    Commit(request = {}) {
        const data = $55d7da6fb7010b2f$exports.RequestCommit.encode(request).finish();
        const promise = this.rpc.request("tendermint.abci.ABCIApplication", "Commit", data);
        return promise.then((data)=>$55d7da6fb7010b2f$exports.ResponseCommit.decode(new $55d7da6fb7010b2f$var$_m0.Reader(data)));
    }
    InitChain(request) {
        const data = $55d7da6fb7010b2f$exports.RequestInitChain.encode(request).finish();
        const promise = this.rpc.request("tendermint.abci.ABCIApplication", "InitChain", data);
        return promise.then((data)=>$55d7da6fb7010b2f$exports.ResponseInitChain.decode(new $55d7da6fb7010b2f$var$_m0.Reader(data)));
    }
    BeginBlock(request) {
        const data = $55d7da6fb7010b2f$exports.RequestBeginBlock.encode(request).finish();
        const promise = this.rpc.request("tendermint.abci.ABCIApplication", "BeginBlock", data);
        return promise.then((data)=>$55d7da6fb7010b2f$exports.ResponseBeginBlock.decode(new $55d7da6fb7010b2f$var$_m0.Reader(data)));
    }
    EndBlock(request) {
        const data = $55d7da6fb7010b2f$exports.RequestEndBlock.encode(request).finish();
        const promise = this.rpc.request("tendermint.abci.ABCIApplication", "EndBlock", data);
        return promise.then((data)=>$55d7da6fb7010b2f$exports.ResponseEndBlock.decode(new $55d7da6fb7010b2f$var$_m0.Reader(data)));
    }
    ListSnapshots(request = {}) {
        const data = $55d7da6fb7010b2f$exports.RequestListSnapshots.encode(request).finish();
        const promise = this.rpc.request("tendermint.abci.ABCIApplication", "ListSnapshots", data);
        return promise.then((data)=>$55d7da6fb7010b2f$exports.ResponseListSnapshots.decode(new $55d7da6fb7010b2f$var$_m0.Reader(data)));
    }
    OfferSnapshot(request) {
        const data = $55d7da6fb7010b2f$exports.RequestOfferSnapshot.encode(request).finish();
        const promise = this.rpc.request("tendermint.abci.ABCIApplication", "OfferSnapshot", data);
        return promise.then((data)=>$55d7da6fb7010b2f$exports.ResponseOfferSnapshot.decode(new $55d7da6fb7010b2f$var$_m0.Reader(data)));
    }
    LoadSnapshotChunk(request) {
        const data = $55d7da6fb7010b2f$exports.RequestLoadSnapshotChunk.encode(request).finish();
        const promise = this.rpc.request("tendermint.abci.ABCIApplication", "LoadSnapshotChunk", data);
        return promise.then((data)=>$55d7da6fb7010b2f$exports.ResponseLoadSnapshotChunk.decode(new $55d7da6fb7010b2f$var$_m0.Reader(data)));
    }
    ApplySnapshotChunk(request) {
        const data = $55d7da6fb7010b2f$exports.RequestApplySnapshotChunk.encode(request).finish();
        const promise = this.rpc.request("tendermint.abci.ABCIApplication", "ApplySnapshotChunk", data);
        return promise.then((data)=>$55d7da6fb7010b2f$exports.ResponseApplySnapshotChunk.decode(new $55d7da6fb7010b2f$var$_m0.Reader(data)));
    }
    PrepareProposal(request) {
        const data = $55d7da6fb7010b2f$exports.RequestPrepareProposal.encode(request).finish();
        const promise = this.rpc.request("tendermint.abci.ABCIApplication", "PrepareProposal", data);
        return promise.then((data)=>$55d7da6fb7010b2f$exports.ResponsePrepareProposal.decode(new $55d7da6fb7010b2f$var$_m0.Reader(data)));
    }
    ProcessProposal(request) {
        const data = $55d7da6fb7010b2f$exports.RequestProcessProposal.encode(request).finish();
        const promise = this.rpc.request("tendermint.abci.ABCIApplication", "ProcessProposal", data);
        return promise.then((data)=>$55d7da6fb7010b2f$exports.ResponseProcessProposal.decode(new $55d7da6fb7010b2f$var$_m0.Reader(data)));
    }
}
$55d7da6fb7010b2f$exports.ABCIApplicationClientImpl = $55d7da6fb7010b2f$var$ABCIApplicationClientImpl;




const $a040057dd8961d62$var$_m0 = $a040057dd8961d62$var$__importStar((parcelRequire("fQBv0")));
$a040057dd8961d62$exports.protobufPackage = "cosmos.staking.v1beta1";
/** BondStatus is the status of a validator. */ var $a040057dd8961d62$var$BondStatus;
(function(BondStatus) {
    /** BOND_STATUS_UNSPECIFIED - UNSPECIFIED defines an invalid validator status. */ BondStatus[BondStatus["BOND_STATUS_UNSPECIFIED"] = 0] = "BOND_STATUS_UNSPECIFIED";
    /** BOND_STATUS_UNBONDED - UNBONDED defines a validator that is not bonded. */ BondStatus[BondStatus["BOND_STATUS_UNBONDED"] = 1] = "BOND_STATUS_UNBONDED";
    /** BOND_STATUS_UNBONDING - UNBONDING defines a validator that is unbonding. */ BondStatus[BondStatus["BOND_STATUS_UNBONDING"] = 2] = "BOND_STATUS_UNBONDING";
    /** BOND_STATUS_BONDED - BONDED defines a validator that is bonded. */ BondStatus[BondStatus["BOND_STATUS_BONDED"] = 3] = "BOND_STATUS_BONDED";
    BondStatus[BondStatus["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})($a040057dd8961d62$var$BondStatus = $a040057dd8961d62$exports.BondStatus || ($a040057dd8961d62$exports.BondStatus = {}));
function $a040057dd8961d62$var$bondStatusFromJSON(object) {
    switch(object){
        case 0:
        case "BOND_STATUS_UNSPECIFIED":
            return $a040057dd8961d62$var$BondStatus.BOND_STATUS_UNSPECIFIED;
        case 1:
        case "BOND_STATUS_UNBONDED":
            return $a040057dd8961d62$var$BondStatus.BOND_STATUS_UNBONDED;
        case 2:
        case "BOND_STATUS_UNBONDING":
            return $a040057dd8961d62$var$BondStatus.BOND_STATUS_UNBONDING;
        case 3:
        case "BOND_STATUS_BONDED":
            return $a040057dd8961d62$var$BondStatus.BOND_STATUS_BONDED;
        case -1:
        case "UNRECOGNIZED":
        default:
            return $a040057dd8961d62$var$BondStatus.UNRECOGNIZED;
    }
}
$a040057dd8961d62$exports.bondStatusFromJSON = $a040057dd8961d62$var$bondStatusFromJSON;
function $a040057dd8961d62$var$bondStatusToJSON(object) {
    switch(object){
        case $a040057dd8961d62$var$BondStatus.BOND_STATUS_UNSPECIFIED:
            return "BOND_STATUS_UNSPECIFIED";
        case $a040057dd8961d62$var$BondStatus.BOND_STATUS_UNBONDED:
            return "BOND_STATUS_UNBONDED";
        case $a040057dd8961d62$var$BondStatus.BOND_STATUS_UNBONDING:
            return "BOND_STATUS_UNBONDING";
        case $a040057dd8961d62$var$BondStatus.BOND_STATUS_BONDED:
            return "BOND_STATUS_BONDED";
        case $a040057dd8961d62$var$BondStatus.UNRECOGNIZED:
        default:
            return "UNRECOGNIZED";
    }
}
$a040057dd8961d62$exports.bondStatusToJSON = $a040057dd8961d62$var$bondStatusToJSON;
/** Infraction indicates the infraction a validator commited. */ var $a040057dd8961d62$var$Infraction;
(function(Infraction) {
    /** INFRACTION_UNSPECIFIED - UNSPECIFIED defines an empty infraction. */ Infraction[Infraction["INFRACTION_UNSPECIFIED"] = 0] = "INFRACTION_UNSPECIFIED";
    /** INFRACTION_DOUBLE_SIGN - DOUBLE_SIGN defines a validator that double-signs a block. */ Infraction[Infraction["INFRACTION_DOUBLE_SIGN"] = 1] = "INFRACTION_DOUBLE_SIGN";
    /** INFRACTION_DOWNTIME - DOWNTIME defines a validator that missed signing too many blocks. */ Infraction[Infraction["INFRACTION_DOWNTIME"] = 2] = "INFRACTION_DOWNTIME";
    Infraction[Infraction["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})($a040057dd8961d62$var$Infraction = $a040057dd8961d62$exports.Infraction || ($a040057dd8961d62$exports.Infraction = {}));
function $a040057dd8961d62$var$infractionFromJSON(object) {
    switch(object){
        case 0:
        case "INFRACTION_UNSPECIFIED":
            return $a040057dd8961d62$var$Infraction.INFRACTION_UNSPECIFIED;
        case 1:
        case "INFRACTION_DOUBLE_SIGN":
            return $a040057dd8961d62$var$Infraction.INFRACTION_DOUBLE_SIGN;
        case 2:
        case "INFRACTION_DOWNTIME":
            return $a040057dd8961d62$var$Infraction.INFRACTION_DOWNTIME;
        case -1:
        case "UNRECOGNIZED":
        default:
            return $a040057dd8961d62$var$Infraction.UNRECOGNIZED;
    }
}
$a040057dd8961d62$exports.infractionFromJSON = $a040057dd8961d62$var$infractionFromJSON;
function $a040057dd8961d62$var$infractionToJSON(object) {
    switch(object){
        case $a040057dd8961d62$var$Infraction.INFRACTION_UNSPECIFIED:
            return "INFRACTION_UNSPECIFIED";
        case $a040057dd8961d62$var$Infraction.INFRACTION_DOUBLE_SIGN:
            return "INFRACTION_DOUBLE_SIGN";
        case $a040057dd8961d62$var$Infraction.INFRACTION_DOWNTIME:
            return "INFRACTION_DOWNTIME";
        case $a040057dd8961d62$var$Infraction.UNRECOGNIZED:
        default:
            return "UNRECOGNIZED";
    }
}
$a040057dd8961d62$exports.infractionToJSON = $a040057dd8961d62$var$infractionToJSON;
function $a040057dd8961d62$var$createBaseHistoricalInfo() {
    return {
        header: undefined,
        valset: []
    };
}
$a040057dd8961d62$exports.HistoricalInfo = {
    encode (message, writer = $a040057dd8961d62$var$_m0.Writer.create()) {
        if (message.header !== undefined) $c51af120eef1efed$exports.Header.encode(message.header, writer.uint32(10).fork()).ldelim();
        for (const v of message.valset)$a040057dd8961d62$exports.Validator.encode(v, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $a040057dd8961d62$var$_m0.Reader ? input : new $a040057dd8961d62$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $a040057dd8961d62$var$createBaseHistoricalInfo();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.header = $c51af120eef1efed$exports.Header.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.valset.push($a040057dd8961d62$exports.Validator.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            header: (0, $d5e07fe2518aae94$exports.isSet)(object.header) ? $c51af120eef1efed$exports.Header.fromJSON(object.header) : undefined,
            valset: Array.isArray(object?.valset) ? object.valset.map((e)=>$a040057dd8961d62$exports.Validator.fromJSON(e)) : []
        };
    },
    toJSON (message) {
        const obj = {};
        message.header !== undefined && (obj.header = message.header ? $c51af120eef1efed$exports.Header.toJSON(message.header) : undefined);
        if (message.valset) obj.valset = message.valset.map((e)=>e ? $a040057dd8961d62$exports.Validator.toJSON(e) : undefined);
        else obj.valset = [];
        return obj;
    },
    fromPartial (object) {
        const message = $a040057dd8961d62$var$createBaseHistoricalInfo();
        message.header = object.header !== undefined && object.header !== null ? $c51af120eef1efed$exports.Header.fromPartial(object.header) : undefined;
        message.valset = object.valset?.map((e)=>$a040057dd8961d62$exports.Validator.fromPartial(e)) || [];
        return message;
    }
};
function $a040057dd8961d62$var$createBaseCommissionRates() {
    return {
        rate: "",
        maxRate: "",
        maxChangeRate: ""
    };
}
$a040057dd8961d62$exports.CommissionRates = {
    encode (message, writer = $a040057dd8961d62$var$_m0.Writer.create()) {
        if (message.rate !== "") writer.uint32(10).string(message.rate);
        if (message.maxRate !== "") writer.uint32(18).string(message.maxRate);
        if (message.maxChangeRate !== "") writer.uint32(26).string(message.maxChangeRate);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $a040057dd8961d62$var$_m0.Reader ? input : new $a040057dd8961d62$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $a040057dd8961d62$var$createBaseCommissionRates();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.rate = reader.string();
                    break;
                case 2:
                    message.maxRate = reader.string();
                    break;
                case 3:
                    message.maxChangeRate = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            rate: (0, $d5e07fe2518aae94$exports.isSet)(object.rate) ? String(object.rate) : "",
            maxRate: (0, $d5e07fe2518aae94$exports.isSet)(object.maxRate) ? String(object.maxRate) : "",
            maxChangeRate: (0, $d5e07fe2518aae94$exports.isSet)(object.maxChangeRate) ? String(object.maxChangeRate) : ""
        };
    },
    toJSON (message) {
        const obj = {};
        message.rate !== undefined && (obj.rate = message.rate);
        message.maxRate !== undefined && (obj.maxRate = message.maxRate);
        message.maxChangeRate !== undefined && (obj.maxChangeRate = message.maxChangeRate);
        return obj;
    },
    fromPartial (object) {
        const message = $a040057dd8961d62$var$createBaseCommissionRates();
        message.rate = object.rate ?? "";
        message.maxRate = object.maxRate ?? "";
        message.maxChangeRate = object.maxChangeRate ?? "";
        return message;
    }
};
function $a040057dd8961d62$var$createBaseCommission() {
    return {
        commissionRates: undefined,
        updateTime: undefined
    };
}
$a040057dd8961d62$exports.Commission = {
    encode (message, writer = $a040057dd8961d62$var$_m0.Writer.create()) {
        if (message.commissionRates !== undefined) $a040057dd8961d62$exports.CommissionRates.encode(message.commissionRates, writer.uint32(10).fork()).ldelim();
        if (message.updateTime !== undefined) $e7eaeedc85b414fc$exports.Timestamp.encode(message.updateTime, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $a040057dd8961d62$var$_m0.Reader ? input : new $a040057dd8961d62$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $a040057dd8961d62$var$createBaseCommission();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.commissionRates = $a040057dd8961d62$exports.CommissionRates.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.updateTime = $e7eaeedc85b414fc$exports.Timestamp.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            commissionRates: (0, $d5e07fe2518aae94$exports.isSet)(object.commissionRates) ? $a040057dd8961d62$exports.CommissionRates.fromJSON(object.commissionRates) : undefined,
            updateTime: (0, $d5e07fe2518aae94$exports.isSet)(object.updateTime) ? (0, $d5e07fe2518aae94$exports.fromJsonTimestamp)(object.updateTime) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.commissionRates !== undefined && (obj.commissionRates = message.commissionRates ? $a040057dd8961d62$exports.CommissionRates.toJSON(message.commissionRates) : undefined);
        message.updateTime !== undefined && (obj.updateTime = (0, $d5e07fe2518aae94$exports.fromTimestamp)(message.updateTime).toISOString());
        return obj;
    },
    fromPartial (object) {
        const message = $a040057dd8961d62$var$createBaseCommission();
        message.commissionRates = object.commissionRates !== undefined && object.commissionRates !== null ? $a040057dd8961d62$exports.CommissionRates.fromPartial(object.commissionRates) : undefined;
        message.updateTime = object.updateTime !== undefined && object.updateTime !== null ? $e7eaeedc85b414fc$exports.Timestamp.fromPartial(object.updateTime) : undefined;
        return message;
    }
};
function $a040057dd8961d62$var$createBaseDescription() {
    return {
        moniker: "",
        identity: "",
        website: "",
        securityContact: "",
        details: ""
    };
}
$a040057dd8961d62$exports.Description = {
    encode (message, writer = $a040057dd8961d62$var$_m0.Writer.create()) {
        if (message.moniker !== "") writer.uint32(10).string(message.moniker);
        if (message.identity !== "") writer.uint32(18).string(message.identity);
        if (message.website !== "") writer.uint32(26).string(message.website);
        if (message.securityContact !== "") writer.uint32(34).string(message.securityContact);
        if (message.details !== "") writer.uint32(42).string(message.details);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $a040057dd8961d62$var$_m0.Reader ? input : new $a040057dd8961d62$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $a040057dd8961d62$var$createBaseDescription();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.moniker = reader.string();
                    break;
                case 2:
                    message.identity = reader.string();
                    break;
                case 3:
                    message.website = reader.string();
                    break;
                case 4:
                    message.securityContact = reader.string();
                    break;
                case 5:
                    message.details = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            moniker: (0, $d5e07fe2518aae94$exports.isSet)(object.moniker) ? String(object.moniker) : "",
            identity: (0, $d5e07fe2518aae94$exports.isSet)(object.identity) ? String(object.identity) : "",
            website: (0, $d5e07fe2518aae94$exports.isSet)(object.website) ? String(object.website) : "",
            securityContact: (0, $d5e07fe2518aae94$exports.isSet)(object.securityContact) ? String(object.securityContact) : "",
            details: (0, $d5e07fe2518aae94$exports.isSet)(object.details) ? String(object.details) : ""
        };
    },
    toJSON (message) {
        const obj = {};
        message.moniker !== undefined && (obj.moniker = message.moniker);
        message.identity !== undefined && (obj.identity = message.identity);
        message.website !== undefined && (obj.website = message.website);
        message.securityContact !== undefined && (obj.securityContact = message.securityContact);
        message.details !== undefined && (obj.details = message.details);
        return obj;
    },
    fromPartial (object) {
        const message = $a040057dd8961d62$var$createBaseDescription();
        message.moniker = object.moniker ?? "";
        message.identity = object.identity ?? "";
        message.website = object.website ?? "";
        message.securityContact = object.securityContact ?? "";
        message.details = object.details ?? "";
        return message;
    }
};
function $a040057dd8961d62$var$createBaseValidator() {
    return {
        operatorAddress: "",
        consensusPubkey: undefined,
        jailed: false,
        status: 0,
        tokens: "",
        delegatorShares: "",
        description: undefined,
        unbondingHeight: $d5e07fe2518aae94$exports.Long.ZERO,
        unbondingTime: undefined,
        commission: undefined,
        minSelfDelegation: "",
        unbondingOnHoldRefCount: $d5e07fe2518aae94$exports.Long.ZERO,
        unbondingIds: []
    };
}
$a040057dd8961d62$exports.Validator = {
    encode (message, writer = $a040057dd8961d62$var$_m0.Writer.create()) {
        if (message.operatorAddress !== "") writer.uint32(10).string(message.operatorAddress);
        if (message.consensusPubkey !== undefined) $64138e590dcf0cc1$exports.Any.encode(message.consensusPubkey, writer.uint32(18).fork()).ldelim();
        if (message.jailed === true) writer.uint32(24).bool(message.jailed);
        if (message.status !== 0) writer.uint32(32).int32(message.status);
        if (message.tokens !== "") writer.uint32(42).string(message.tokens);
        if (message.delegatorShares !== "") writer.uint32(50).string(message.delegatorShares);
        if (message.description !== undefined) $a040057dd8961d62$exports.Description.encode(message.description, writer.uint32(58).fork()).ldelim();
        if (!message.unbondingHeight.isZero()) writer.uint32(64).int64(message.unbondingHeight);
        if (message.unbondingTime !== undefined) $e7eaeedc85b414fc$exports.Timestamp.encode(message.unbondingTime, writer.uint32(74).fork()).ldelim();
        if (message.commission !== undefined) $a040057dd8961d62$exports.Commission.encode(message.commission, writer.uint32(82).fork()).ldelim();
        if (message.minSelfDelegation !== "") writer.uint32(90).string(message.minSelfDelegation);
        if (!message.unbondingOnHoldRefCount.isZero()) writer.uint32(96).int64(message.unbondingOnHoldRefCount);
        writer.uint32(106).fork();
        for (const v of message.unbondingIds)writer.uint64(v);
        writer.ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $a040057dd8961d62$var$_m0.Reader ? input : new $a040057dd8961d62$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $a040057dd8961d62$var$createBaseValidator();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.operatorAddress = reader.string();
                    break;
                case 2:
                    message.consensusPubkey = $64138e590dcf0cc1$exports.Any.decode(reader, reader.uint32());
                    break;
                case 3:
                    message.jailed = reader.bool();
                    break;
                case 4:
                    message.status = reader.int32();
                    break;
                case 5:
                    message.tokens = reader.string();
                    break;
                case 6:
                    message.delegatorShares = reader.string();
                    break;
                case 7:
                    message.description = $a040057dd8961d62$exports.Description.decode(reader, reader.uint32());
                    break;
                case 8:
                    message.unbondingHeight = reader.int64();
                    break;
                case 9:
                    message.unbondingTime = $e7eaeedc85b414fc$exports.Timestamp.decode(reader, reader.uint32());
                    break;
                case 10:
                    message.commission = $a040057dd8961d62$exports.Commission.decode(reader, reader.uint32());
                    break;
                case 11:
                    message.minSelfDelegation = reader.string();
                    break;
                case 12:
                    message.unbondingOnHoldRefCount = reader.int64();
                    break;
                case 13:
                    if ((tag & 7) === 2) {
                        const end2 = reader.uint32() + reader.pos;
                        while(reader.pos < end2)message.unbondingIds.push(reader.uint64());
                    } else message.unbondingIds.push(reader.uint64());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            operatorAddress: (0, $d5e07fe2518aae94$exports.isSet)(object.operatorAddress) ? String(object.operatorAddress) : "",
            consensusPubkey: (0, $d5e07fe2518aae94$exports.isSet)(object.consensusPubkey) ? $64138e590dcf0cc1$exports.Any.fromJSON(object.consensusPubkey) : undefined,
            jailed: (0, $d5e07fe2518aae94$exports.isSet)(object.jailed) ? Boolean(object.jailed) : false,
            status: (0, $d5e07fe2518aae94$exports.isSet)(object.status) ? $a040057dd8961d62$var$bondStatusFromJSON(object.status) : 0,
            tokens: (0, $d5e07fe2518aae94$exports.isSet)(object.tokens) ? String(object.tokens) : "",
            delegatorShares: (0, $d5e07fe2518aae94$exports.isSet)(object.delegatorShares) ? String(object.delegatorShares) : "",
            description: (0, $d5e07fe2518aae94$exports.isSet)(object.description) ? $a040057dd8961d62$exports.Description.fromJSON(object.description) : undefined,
            unbondingHeight: (0, $d5e07fe2518aae94$exports.isSet)(object.unbondingHeight) ? $d5e07fe2518aae94$exports.Long.fromValue(object.unbondingHeight) : $d5e07fe2518aae94$exports.Long.ZERO,
            unbondingTime: (0, $d5e07fe2518aae94$exports.isSet)(object.unbondingTime) ? (0, $d5e07fe2518aae94$exports.fromJsonTimestamp)(object.unbondingTime) : undefined,
            commission: (0, $d5e07fe2518aae94$exports.isSet)(object.commission) ? $a040057dd8961d62$exports.Commission.fromJSON(object.commission) : undefined,
            minSelfDelegation: (0, $d5e07fe2518aae94$exports.isSet)(object.minSelfDelegation) ? String(object.minSelfDelegation) : "",
            unbondingOnHoldRefCount: (0, $d5e07fe2518aae94$exports.isSet)(object.unbondingOnHoldRefCount) ? $d5e07fe2518aae94$exports.Long.fromValue(object.unbondingOnHoldRefCount) : $d5e07fe2518aae94$exports.Long.ZERO,
            unbondingIds: Array.isArray(object?.unbondingIds) ? object.unbondingIds.map((e)=>$d5e07fe2518aae94$exports.Long.fromValue(e)) : []
        };
    },
    toJSON (message) {
        const obj = {};
        message.operatorAddress !== undefined && (obj.operatorAddress = message.operatorAddress);
        message.consensusPubkey !== undefined && (obj.consensusPubkey = message.consensusPubkey ? $64138e590dcf0cc1$exports.Any.toJSON(message.consensusPubkey) : undefined);
        message.jailed !== undefined && (obj.jailed = message.jailed);
        message.status !== undefined && (obj.status = $a040057dd8961d62$var$bondStatusToJSON(message.status));
        message.tokens !== undefined && (obj.tokens = message.tokens);
        message.delegatorShares !== undefined && (obj.delegatorShares = message.delegatorShares);
        message.description !== undefined && (obj.description = message.description ? $a040057dd8961d62$exports.Description.toJSON(message.description) : undefined);
        message.unbondingHeight !== undefined && (obj.unbondingHeight = (message.unbondingHeight || $d5e07fe2518aae94$exports.Long.ZERO).toString());
        message.unbondingTime !== undefined && (obj.unbondingTime = (0, $d5e07fe2518aae94$exports.fromTimestamp)(message.unbondingTime).toISOString());
        message.commission !== undefined && (obj.commission = message.commission ? $a040057dd8961d62$exports.Commission.toJSON(message.commission) : undefined);
        message.minSelfDelegation !== undefined && (obj.minSelfDelegation = message.minSelfDelegation);
        message.unbondingOnHoldRefCount !== undefined && (obj.unbondingOnHoldRefCount = (message.unbondingOnHoldRefCount || $d5e07fe2518aae94$exports.Long.ZERO).toString());
        if (message.unbondingIds) obj.unbondingIds = message.unbondingIds.map((e)=>(e || $d5e07fe2518aae94$exports.Long.UZERO).toString());
        else obj.unbondingIds = [];
        return obj;
    },
    fromPartial (object) {
        const message = $a040057dd8961d62$var$createBaseValidator();
        message.operatorAddress = object.operatorAddress ?? "";
        message.consensusPubkey = object.consensusPubkey !== undefined && object.consensusPubkey !== null ? $64138e590dcf0cc1$exports.Any.fromPartial(object.consensusPubkey) : undefined;
        message.jailed = object.jailed ?? false;
        message.status = object.status ?? 0;
        message.tokens = object.tokens ?? "";
        message.delegatorShares = object.delegatorShares ?? "";
        message.description = object.description !== undefined && object.description !== null ? $a040057dd8961d62$exports.Description.fromPartial(object.description) : undefined;
        message.unbondingHeight = object.unbondingHeight !== undefined && object.unbondingHeight !== null ? $d5e07fe2518aae94$exports.Long.fromValue(object.unbondingHeight) : $d5e07fe2518aae94$exports.Long.ZERO;
        message.unbondingTime = object.unbondingTime !== undefined && object.unbondingTime !== null ? $e7eaeedc85b414fc$exports.Timestamp.fromPartial(object.unbondingTime) : undefined;
        message.commission = object.commission !== undefined && object.commission !== null ? $a040057dd8961d62$exports.Commission.fromPartial(object.commission) : undefined;
        message.minSelfDelegation = object.minSelfDelegation ?? "";
        message.unbondingOnHoldRefCount = object.unbondingOnHoldRefCount !== undefined && object.unbondingOnHoldRefCount !== null ? $d5e07fe2518aae94$exports.Long.fromValue(object.unbondingOnHoldRefCount) : $d5e07fe2518aae94$exports.Long.ZERO;
        message.unbondingIds = object.unbondingIds?.map((e)=>$d5e07fe2518aae94$exports.Long.fromValue(e)) || [];
        return message;
    }
};
function $a040057dd8961d62$var$createBaseValAddresses() {
    return {
        addresses: []
    };
}
$a040057dd8961d62$exports.ValAddresses = {
    encode (message, writer = $a040057dd8961d62$var$_m0.Writer.create()) {
        for (const v of message.addresses)writer.uint32(10).string(v);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $a040057dd8961d62$var$_m0.Reader ? input : new $a040057dd8961d62$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $a040057dd8961d62$var$createBaseValAddresses();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.addresses.push(reader.string());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            addresses: Array.isArray(object?.addresses) ? object.addresses.map((e)=>String(e)) : []
        };
    },
    toJSON (message) {
        const obj = {};
        if (message.addresses) obj.addresses = message.addresses.map((e)=>e);
        else obj.addresses = [];
        return obj;
    },
    fromPartial (object) {
        const message = $a040057dd8961d62$var$createBaseValAddresses();
        message.addresses = object.addresses?.map((e)=>e) || [];
        return message;
    }
};
function $a040057dd8961d62$var$createBaseDVPair() {
    return {
        delegatorAddress: "",
        validatorAddress: ""
    };
}
$a040057dd8961d62$exports.DVPair = {
    encode (message, writer = $a040057dd8961d62$var$_m0.Writer.create()) {
        if (message.delegatorAddress !== "") writer.uint32(10).string(message.delegatorAddress);
        if (message.validatorAddress !== "") writer.uint32(18).string(message.validatorAddress);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $a040057dd8961d62$var$_m0.Reader ? input : new $a040057dd8961d62$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $a040057dd8961d62$var$createBaseDVPair();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.delegatorAddress = reader.string();
                    break;
                case 2:
                    message.validatorAddress = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            delegatorAddress: (0, $d5e07fe2518aae94$exports.isSet)(object.delegatorAddress) ? String(object.delegatorAddress) : "",
            validatorAddress: (0, $d5e07fe2518aae94$exports.isSet)(object.validatorAddress) ? String(object.validatorAddress) : ""
        };
    },
    toJSON (message) {
        const obj = {};
        message.delegatorAddress !== undefined && (obj.delegatorAddress = message.delegatorAddress);
        message.validatorAddress !== undefined && (obj.validatorAddress = message.validatorAddress);
        return obj;
    },
    fromPartial (object) {
        const message = $a040057dd8961d62$var$createBaseDVPair();
        message.delegatorAddress = object.delegatorAddress ?? "";
        message.validatorAddress = object.validatorAddress ?? "";
        return message;
    }
};
function $a040057dd8961d62$var$createBaseDVPairs() {
    return {
        pairs: []
    };
}
$a040057dd8961d62$exports.DVPairs = {
    encode (message, writer = $a040057dd8961d62$var$_m0.Writer.create()) {
        for (const v of message.pairs)$a040057dd8961d62$exports.DVPair.encode(v, writer.uint32(10).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $a040057dd8961d62$var$_m0.Reader ? input : new $a040057dd8961d62$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $a040057dd8961d62$var$createBaseDVPairs();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.pairs.push($a040057dd8961d62$exports.DVPair.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            pairs: Array.isArray(object?.pairs) ? object.pairs.map((e)=>$a040057dd8961d62$exports.DVPair.fromJSON(e)) : []
        };
    },
    toJSON (message) {
        const obj = {};
        if (message.pairs) obj.pairs = message.pairs.map((e)=>e ? $a040057dd8961d62$exports.DVPair.toJSON(e) : undefined);
        else obj.pairs = [];
        return obj;
    },
    fromPartial (object) {
        const message = $a040057dd8961d62$var$createBaseDVPairs();
        message.pairs = object.pairs?.map((e)=>$a040057dd8961d62$exports.DVPair.fromPartial(e)) || [];
        return message;
    }
};
function $a040057dd8961d62$var$createBaseDVVTriplet() {
    return {
        delegatorAddress: "",
        validatorSrcAddress: "",
        validatorDstAddress: ""
    };
}
$a040057dd8961d62$exports.DVVTriplet = {
    encode (message, writer = $a040057dd8961d62$var$_m0.Writer.create()) {
        if (message.delegatorAddress !== "") writer.uint32(10).string(message.delegatorAddress);
        if (message.validatorSrcAddress !== "") writer.uint32(18).string(message.validatorSrcAddress);
        if (message.validatorDstAddress !== "") writer.uint32(26).string(message.validatorDstAddress);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $a040057dd8961d62$var$_m0.Reader ? input : new $a040057dd8961d62$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $a040057dd8961d62$var$createBaseDVVTriplet();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.delegatorAddress = reader.string();
                    break;
                case 2:
                    message.validatorSrcAddress = reader.string();
                    break;
                case 3:
                    message.validatorDstAddress = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            delegatorAddress: (0, $d5e07fe2518aae94$exports.isSet)(object.delegatorAddress) ? String(object.delegatorAddress) : "",
            validatorSrcAddress: (0, $d5e07fe2518aae94$exports.isSet)(object.validatorSrcAddress) ? String(object.validatorSrcAddress) : "",
            validatorDstAddress: (0, $d5e07fe2518aae94$exports.isSet)(object.validatorDstAddress) ? String(object.validatorDstAddress) : ""
        };
    },
    toJSON (message) {
        const obj = {};
        message.delegatorAddress !== undefined && (obj.delegatorAddress = message.delegatorAddress);
        message.validatorSrcAddress !== undefined && (obj.validatorSrcAddress = message.validatorSrcAddress);
        message.validatorDstAddress !== undefined && (obj.validatorDstAddress = message.validatorDstAddress);
        return obj;
    },
    fromPartial (object) {
        const message = $a040057dd8961d62$var$createBaseDVVTriplet();
        message.delegatorAddress = object.delegatorAddress ?? "";
        message.validatorSrcAddress = object.validatorSrcAddress ?? "";
        message.validatorDstAddress = object.validatorDstAddress ?? "";
        return message;
    }
};
function $a040057dd8961d62$var$createBaseDVVTriplets() {
    return {
        triplets: []
    };
}
$a040057dd8961d62$exports.DVVTriplets = {
    encode (message, writer = $a040057dd8961d62$var$_m0.Writer.create()) {
        for (const v of message.triplets)$a040057dd8961d62$exports.DVVTriplet.encode(v, writer.uint32(10).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $a040057dd8961d62$var$_m0.Reader ? input : new $a040057dd8961d62$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $a040057dd8961d62$var$createBaseDVVTriplets();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.triplets.push($a040057dd8961d62$exports.DVVTriplet.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            triplets: Array.isArray(object?.triplets) ? object.triplets.map((e)=>$a040057dd8961d62$exports.DVVTriplet.fromJSON(e)) : []
        };
    },
    toJSON (message) {
        const obj = {};
        if (message.triplets) obj.triplets = message.triplets.map((e)=>e ? $a040057dd8961d62$exports.DVVTriplet.toJSON(e) : undefined);
        else obj.triplets = [];
        return obj;
    },
    fromPartial (object) {
        const message = $a040057dd8961d62$var$createBaseDVVTriplets();
        message.triplets = object.triplets?.map((e)=>$a040057dd8961d62$exports.DVVTriplet.fromPartial(e)) || [];
        return message;
    }
};
function $a040057dd8961d62$var$createBaseDelegation() {
    return {
        delegatorAddress: "",
        validatorAddress: "",
        shares: ""
    };
}
$a040057dd8961d62$exports.Delegation = {
    encode (message, writer = $a040057dd8961d62$var$_m0.Writer.create()) {
        if (message.delegatorAddress !== "") writer.uint32(10).string(message.delegatorAddress);
        if (message.validatorAddress !== "") writer.uint32(18).string(message.validatorAddress);
        if (message.shares !== "") writer.uint32(26).string(message.shares);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $a040057dd8961d62$var$_m0.Reader ? input : new $a040057dd8961d62$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $a040057dd8961d62$var$createBaseDelegation();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.delegatorAddress = reader.string();
                    break;
                case 2:
                    message.validatorAddress = reader.string();
                    break;
                case 3:
                    message.shares = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            delegatorAddress: (0, $d5e07fe2518aae94$exports.isSet)(object.delegatorAddress) ? String(object.delegatorAddress) : "",
            validatorAddress: (0, $d5e07fe2518aae94$exports.isSet)(object.validatorAddress) ? String(object.validatorAddress) : "",
            shares: (0, $d5e07fe2518aae94$exports.isSet)(object.shares) ? String(object.shares) : ""
        };
    },
    toJSON (message) {
        const obj = {};
        message.delegatorAddress !== undefined && (obj.delegatorAddress = message.delegatorAddress);
        message.validatorAddress !== undefined && (obj.validatorAddress = message.validatorAddress);
        message.shares !== undefined && (obj.shares = message.shares);
        return obj;
    },
    fromPartial (object) {
        const message = $a040057dd8961d62$var$createBaseDelegation();
        message.delegatorAddress = object.delegatorAddress ?? "";
        message.validatorAddress = object.validatorAddress ?? "";
        message.shares = object.shares ?? "";
        return message;
    }
};
function $a040057dd8961d62$var$createBaseUnbondingDelegation() {
    return {
        delegatorAddress: "",
        validatorAddress: "",
        entries: []
    };
}
$a040057dd8961d62$exports.UnbondingDelegation = {
    encode (message, writer = $a040057dd8961d62$var$_m0.Writer.create()) {
        if (message.delegatorAddress !== "") writer.uint32(10).string(message.delegatorAddress);
        if (message.validatorAddress !== "") writer.uint32(18).string(message.validatorAddress);
        for (const v of message.entries)$a040057dd8961d62$exports.UnbondingDelegationEntry.encode(v, writer.uint32(26).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $a040057dd8961d62$var$_m0.Reader ? input : new $a040057dd8961d62$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $a040057dd8961d62$var$createBaseUnbondingDelegation();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.delegatorAddress = reader.string();
                    break;
                case 2:
                    message.validatorAddress = reader.string();
                    break;
                case 3:
                    message.entries.push($a040057dd8961d62$exports.UnbondingDelegationEntry.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            delegatorAddress: (0, $d5e07fe2518aae94$exports.isSet)(object.delegatorAddress) ? String(object.delegatorAddress) : "",
            validatorAddress: (0, $d5e07fe2518aae94$exports.isSet)(object.validatorAddress) ? String(object.validatorAddress) : "",
            entries: Array.isArray(object?.entries) ? object.entries.map((e)=>$a040057dd8961d62$exports.UnbondingDelegationEntry.fromJSON(e)) : []
        };
    },
    toJSON (message) {
        const obj = {};
        message.delegatorAddress !== undefined && (obj.delegatorAddress = message.delegatorAddress);
        message.validatorAddress !== undefined && (obj.validatorAddress = message.validatorAddress);
        if (message.entries) obj.entries = message.entries.map((e)=>e ? $a040057dd8961d62$exports.UnbondingDelegationEntry.toJSON(e) : undefined);
        else obj.entries = [];
        return obj;
    },
    fromPartial (object) {
        const message = $a040057dd8961d62$var$createBaseUnbondingDelegation();
        message.delegatorAddress = object.delegatorAddress ?? "";
        message.validatorAddress = object.validatorAddress ?? "";
        message.entries = object.entries?.map((e)=>$a040057dd8961d62$exports.UnbondingDelegationEntry.fromPartial(e)) || [];
        return message;
    }
};
function $a040057dd8961d62$var$createBaseUnbondingDelegationEntry() {
    return {
        creationHeight: $d5e07fe2518aae94$exports.Long.ZERO,
        completionTime: undefined,
        initialBalance: "",
        balance: "",
        unbondingId: $d5e07fe2518aae94$exports.Long.UZERO,
        unbondingOnHoldRefCount: $d5e07fe2518aae94$exports.Long.ZERO
    };
}
$a040057dd8961d62$exports.UnbondingDelegationEntry = {
    encode (message, writer = $a040057dd8961d62$var$_m0.Writer.create()) {
        if (!message.creationHeight.isZero()) writer.uint32(8).int64(message.creationHeight);
        if (message.completionTime !== undefined) $e7eaeedc85b414fc$exports.Timestamp.encode(message.completionTime, writer.uint32(18).fork()).ldelim();
        if (message.initialBalance !== "") writer.uint32(26).string(message.initialBalance);
        if (message.balance !== "") writer.uint32(34).string(message.balance);
        if (!message.unbondingId.isZero()) writer.uint32(40).uint64(message.unbondingId);
        if (!message.unbondingOnHoldRefCount.isZero()) writer.uint32(48).int64(message.unbondingOnHoldRefCount);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $a040057dd8961d62$var$_m0.Reader ? input : new $a040057dd8961d62$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $a040057dd8961d62$var$createBaseUnbondingDelegationEntry();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.creationHeight = reader.int64();
                    break;
                case 2:
                    message.completionTime = $e7eaeedc85b414fc$exports.Timestamp.decode(reader, reader.uint32());
                    break;
                case 3:
                    message.initialBalance = reader.string();
                    break;
                case 4:
                    message.balance = reader.string();
                    break;
                case 5:
                    message.unbondingId = reader.uint64();
                    break;
                case 6:
                    message.unbondingOnHoldRefCount = reader.int64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            creationHeight: (0, $d5e07fe2518aae94$exports.isSet)(object.creationHeight) ? $d5e07fe2518aae94$exports.Long.fromValue(object.creationHeight) : $d5e07fe2518aae94$exports.Long.ZERO,
            completionTime: (0, $d5e07fe2518aae94$exports.isSet)(object.completionTime) ? (0, $d5e07fe2518aae94$exports.fromJsonTimestamp)(object.completionTime) : undefined,
            initialBalance: (0, $d5e07fe2518aae94$exports.isSet)(object.initialBalance) ? String(object.initialBalance) : "",
            balance: (0, $d5e07fe2518aae94$exports.isSet)(object.balance) ? String(object.balance) : "",
            unbondingId: (0, $d5e07fe2518aae94$exports.isSet)(object.unbondingId) ? $d5e07fe2518aae94$exports.Long.fromValue(object.unbondingId) : $d5e07fe2518aae94$exports.Long.UZERO,
            unbondingOnHoldRefCount: (0, $d5e07fe2518aae94$exports.isSet)(object.unbondingOnHoldRefCount) ? $d5e07fe2518aae94$exports.Long.fromValue(object.unbondingOnHoldRefCount) : $d5e07fe2518aae94$exports.Long.ZERO
        };
    },
    toJSON (message) {
        const obj = {};
        message.creationHeight !== undefined && (obj.creationHeight = (message.creationHeight || $d5e07fe2518aae94$exports.Long.ZERO).toString());
        message.completionTime !== undefined && (obj.completionTime = (0, $d5e07fe2518aae94$exports.fromTimestamp)(message.completionTime).toISOString());
        message.initialBalance !== undefined && (obj.initialBalance = message.initialBalance);
        message.balance !== undefined && (obj.balance = message.balance);
        message.unbondingId !== undefined && (obj.unbondingId = (message.unbondingId || $d5e07fe2518aae94$exports.Long.UZERO).toString());
        message.unbondingOnHoldRefCount !== undefined && (obj.unbondingOnHoldRefCount = (message.unbondingOnHoldRefCount || $d5e07fe2518aae94$exports.Long.ZERO).toString());
        return obj;
    },
    fromPartial (object) {
        const message = $a040057dd8961d62$var$createBaseUnbondingDelegationEntry();
        message.creationHeight = object.creationHeight !== undefined && object.creationHeight !== null ? $d5e07fe2518aae94$exports.Long.fromValue(object.creationHeight) : $d5e07fe2518aae94$exports.Long.ZERO;
        message.completionTime = object.completionTime !== undefined && object.completionTime !== null ? $e7eaeedc85b414fc$exports.Timestamp.fromPartial(object.completionTime) : undefined;
        message.initialBalance = object.initialBalance ?? "";
        message.balance = object.balance ?? "";
        message.unbondingId = object.unbondingId !== undefined && object.unbondingId !== null ? $d5e07fe2518aae94$exports.Long.fromValue(object.unbondingId) : $d5e07fe2518aae94$exports.Long.UZERO;
        message.unbondingOnHoldRefCount = object.unbondingOnHoldRefCount !== undefined && object.unbondingOnHoldRefCount !== null ? $d5e07fe2518aae94$exports.Long.fromValue(object.unbondingOnHoldRefCount) : $d5e07fe2518aae94$exports.Long.ZERO;
        return message;
    }
};
function $a040057dd8961d62$var$createBaseRedelegationEntry() {
    return {
        creationHeight: $d5e07fe2518aae94$exports.Long.ZERO,
        completionTime: undefined,
        initialBalance: "",
        sharesDst: "",
        unbondingId: $d5e07fe2518aae94$exports.Long.UZERO,
        unbondingOnHoldRefCount: $d5e07fe2518aae94$exports.Long.ZERO
    };
}
$a040057dd8961d62$exports.RedelegationEntry = {
    encode (message, writer = $a040057dd8961d62$var$_m0.Writer.create()) {
        if (!message.creationHeight.isZero()) writer.uint32(8).int64(message.creationHeight);
        if (message.completionTime !== undefined) $e7eaeedc85b414fc$exports.Timestamp.encode(message.completionTime, writer.uint32(18).fork()).ldelim();
        if (message.initialBalance !== "") writer.uint32(26).string(message.initialBalance);
        if (message.sharesDst !== "") writer.uint32(34).string(message.sharesDst);
        if (!message.unbondingId.isZero()) writer.uint32(40).uint64(message.unbondingId);
        if (!message.unbondingOnHoldRefCount.isZero()) writer.uint32(48).int64(message.unbondingOnHoldRefCount);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $a040057dd8961d62$var$_m0.Reader ? input : new $a040057dd8961d62$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $a040057dd8961d62$var$createBaseRedelegationEntry();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.creationHeight = reader.int64();
                    break;
                case 2:
                    message.completionTime = $e7eaeedc85b414fc$exports.Timestamp.decode(reader, reader.uint32());
                    break;
                case 3:
                    message.initialBalance = reader.string();
                    break;
                case 4:
                    message.sharesDst = reader.string();
                    break;
                case 5:
                    message.unbondingId = reader.uint64();
                    break;
                case 6:
                    message.unbondingOnHoldRefCount = reader.int64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            creationHeight: (0, $d5e07fe2518aae94$exports.isSet)(object.creationHeight) ? $d5e07fe2518aae94$exports.Long.fromValue(object.creationHeight) : $d5e07fe2518aae94$exports.Long.ZERO,
            completionTime: (0, $d5e07fe2518aae94$exports.isSet)(object.completionTime) ? (0, $d5e07fe2518aae94$exports.fromJsonTimestamp)(object.completionTime) : undefined,
            initialBalance: (0, $d5e07fe2518aae94$exports.isSet)(object.initialBalance) ? String(object.initialBalance) : "",
            sharesDst: (0, $d5e07fe2518aae94$exports.isSet)(object.sharesDst) ? String(object.sharesDst) : "",
            unbondingId: (0, $d5e07fe2518aae94$exports.isSet)(object.unbondingId) ? $d5e07fe2518aae94$exports.Long.fromValue(object.unbondingId) : $d5e07fe2518aae94$exports.Long.UZERO,
            unbondingOnHoldRefCount: (0, $d5e07fe2518aae94$exports.isSet)(object.unbondingOnHoldRefCount) ? $d5e07fe2518aae94$exports.Long.fromValue(object.unbondingOnHoldRefCount) : $d5e07fe2518aae94$exports.Long.ZERO
        };
    },
    toJSON (message) {
        const obj = {};
        message.creationHeight !== undefined && (obj.creationHeight = (message.creationHeight || $d5e07fe2518aae94$exports.Long.ZERO).toString());
        message.completionTime !== undefined && (obj.completionTime = (0, $d5e07fe2518aae94$exports.fromTimestamp)(message.completionTime).toISOString());
        message.initialBalance !== undefined && (obj.initialBalance = message.initialBalance);
        message.sharesDst !== undefined && (obj.sharesDst = message.sharesDst);
        message.unbondingId !== undefined && (obj.unbondingId = (message.unbondingId || $d5e07fe2518aae94$exports.Long.UZERO).toString());
        message.unbondingOnHoldRefCount !== undefined && (obj.unbondingOnHoldRefCount = (message.unbondingOnHoldRefCount || $d5e07fe2518aae94$exports.Long.ZERO).toString());
        return obj;
    },
    fromPartial (object) {
        const message = $a040057dd8961d62$var$createBaseRedelegationEntry();
        message.creationHeight = object.creationHeight !== undefined && object.creationHeight !== null ? $d5e07fe2518aae94$exports.Long.fromValue(object.creationHeight) : $d5e07fe2518aae94$exports.Long.ZERO;
        message.completionTime = object.completionTime !== undefined && object.completionTime !== null ? $e7eaeedc85b414fc$exports.Timestamp.fromPartial(object.completionTime) : undefined;
        message.initialBalance = object.initialBalance ?? "";
        message.sharesDst = object.sharesDst ?? "";
        message.unbondingId = object.unbondingId !== undefined && object.unbondingId !== null ? $d5e07fe2518aae94$exports.Long.fromValue(object.unbondingId) : $d5e07fe2518aae94$exports.Long.UZERO;
        message.unbondingOnHoldRefCount = object.unbondingOnHoldRefCount !== undefined && object.unbondingOnHoldRefCount !== null ? $d5e07fe2518aae94$exports.Long.fromValue(object.unbondingOnHoldRefCount) : $d5e07fe2518aae94$exports.Long.ZERO;
        return message;
    }
};
function $a040057dd8961d62$var$createBaseRedelegation() {
    return {
        delegatorAddress: "",
        validatorSrcAddress: "",
        validatorDstAddress: "",
        entries: []
    };
}
$a040057dd8961d62$exports.Redelegation = {
    encode (message, writer = $a040057dd8961d62$var$_m0.Writer.create()) {
        if (message.delegatorAddress !== "") writer.uint32(10).string(message.delegatorAddress);
        if (message.validatorSrcAddress !== "") writer.uint32(18).string(message.validatorSrcAddress);
        if (message.validatorDstAddress !== "") writer.uint32(26).string(message.validatorDstAddress);
        for (const v of message.entries)$a040057dd8961d62$exports.RedelegationEntry.encode(v, writer.uint32(34).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $a040057dd8961d62$var$_m0.Reader ? input : new $a040057dd8961d62$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $a040057dd8961d62$var$createBaseRedelegation();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.delegatorAddress = reader.string();
                    break;
                case 2:
                    message.validatorSrcAddress = reader.string();
                    break;
                case 3:
                    message.validatorDstAddress = reader.string();
                    break;
                case 4:
                    message.entries.push($a040057dd8961d62$exports.RedelegationEntry.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            delegatorAddress: (0, $d5e07fe2518aae94$exports.isSet)(object.delegatorAddress) ? String(object.delegatorAddress) : "",
            validatorSrcAddress: (0, $d5e07fe2518aae94$exports.isSet)(object.validatorSrcAddress) ? String(object.validatorSrcAddress) : "",
            validatorDstAddress: (0, $d5e07fe2518aae94$exports.isSet)(object.validatorDstAddress) ? String(object.validatorDstAddress) : "",
            entries: Array.isArray(object?.entries) ? object.entries.map((e)=>$a040057dd8961d62$exports.RedelegationEntry.fromJSON(e)) : []
        };
    },
    toJSON (message) {
        const obj = {};
        message.delegatorAddress !== undefined && (obj.delegatorAddress = message.delegatorAddress);
        message.validatorSrcAddress !== undefined && (obj.validatorSrcAddress = message.validatorSrcAddress);
        message.validatorDstAddress !== undefined && (obj.validatorDstAddress = message.validatorDstAddress);
        if (message.entries) obj.entries = message.entries.map((e)=>e ? $a040057dd8961d62$exports.RedelegationEntry.toJSON(e) : undefined);
        else obj.entries = [];
        return obj;
    },
    fromPartial (object) {
        const message = $a040057dd8961d62$var$createBaseRedelegation();
        message.delegatorAddress = object.delegatorAddress ?? "";
        message.validatorSrcAddress = object.validatorSrcAddress ?? "";
        message.validatorDstAddress = object.validatorDstAddress ?? "";
        message.entries = object.entries?.map((e)=>$a040057dd8961d62$exports.RedelegationEntry.fromPartial(e)) || [];
        return message;
    }
};
function $a040057dd8961d62$var$createBaseParams() {
    return {
        unbondingTime: undefined,
        maxValidators: 0,
        maxEntries: 0,
        historicalEntries: 0,
        bondDenom: "",
        minCommissionRate: ""
    };
}
$a040057dd8961d62$exports.Params = {
    encode (message, writer = $a040057dd8961d62$var$_m0.Writer.create()) {
        if (message.unbondingTime !== undefined) $fe534fae4538ccbf$exports.Duration.encode(message.unbondingTime, writer.uint32(10).fork()).ldelim();
        if (message.maxValidators !== 0) writer.uint32(16).uint32(message.maxValidators);
        if (message.maxEntries !== 0) writer.uint32(24).uint32(message.maxEntries);
        if (message.historicalEntries !== 0) writer.uint32(32).uint32(message.historicalEntries);
        if (message.bondDenom !== "") writer.uint32(42).string(message.bondDenom);
        if (message.minCommissionRate !== "") writer.uint32(50).string(message.minCommissionRate);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $a040057dd8961d62$var$_m0.Reader ? input : new $a040057dd8961d62$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $a040057dd8961d62$var$createBaseParams();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.unbondingTime = $fe534fae4538ccbf$exports.Duration.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.maxValidators = reader.uint32();
                    break;
                case 3:
                    message.maxEntries = reader.uint32();
                    break;
                case 4:
                    message.historicalEntries = reader.uint32();
                    break;
                case 5:
                    message.bondDenom = reader.string();
                    break;
                case 6:
                    message.minCommissionRate = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            unbondingTime: (0, $d5e07fe2518aae94$exports.isSet)(object.unbondingTime) ? $fe534fae4538ccbf$exports.Duration.fromJSON(object.unbondingTime) : undefined,
            maxValidators: (0, $d5e07fe2518aae94$exports.isSet)(object.maxValidators) ? Number(object.maxValidators) : 0,
            maxEntries: (0, $d5e07fe2518aae94$exports.isSet)(object.maxEntries) ? Number(object.maxEntries) : 0,
            historicalEntries: (0, $d5e07fe2518aae94$exports.isSet)(object.historicalEntries) ? Number(object.historicalEntries) : 0,
            bondDenom: (0, $d5e07fe2518aae94$exports.isSet)(object.bondDenom) ? String(object.bondDenom) : "",
            minCommissionRate: (0, $d5e07fe2518aae94$exports.isSet)(object.minCommissionRate) ? String(object.minCommissionRate) : ""
        };
    },
    toJSON (message) {
        const obj = {};
        message.unbondingTime !== undefined && (obj.unbondingTime = message.unbondingTime ? $fe534fae4538ccbf$exports.Duration.toJSON(message.unbondingTime) : undefined);
        message.maxValidators !== undefined && (obj.maxValidators = Math.round(message.maxValidators));
        message.maxEntries !== undefined && (obj.maxEntries = Math.round(message.maxEntries));
        message.historicalEntries !== undefined && (obj.historicalEntries = Math.round(message.historicalEntries));
        message.bondDenom !== undefined && (obj.bondDenom = message.bondDenom);
        message.minCommissionRate !== undefined && (obj.minCommissionRate = message.minCommissionRate);
        return obj;
    },
    fromPartial (object) {
        const message = $a040057dd8961d62$var$createBaseParams();
        message.unbondingTime = object.unbondingTime !== undefined && object.unbondingTime !== null ? $fe534fae4538ccbf$exports.Duration.fromPartial(object.unbondingTime) : undefined;
        message.maxValidators = object.maxValidators ?? 0;
        message.maxEntries = object.maxEntries ?? 0;
        message.historicalEntries = object.historicalEntries ?? 0;
        message.bondDenom = object.bondDenom ?? "";
        message.minCommissionRate = object.minCommissionRate ?? "";
        return message;
    }
};
function $a040057dd8961d62$var$createBaseDelegationResponse() {
    return {
        delegation: undefined,
        balance: undefined
    };
}
$a040057dd8961d62$exports.DelegationResponse = {
    encode (message, writer = $a040057dd8961d62$var$_m0.Writer.create()) {
        if (message.delegation !== undefined) $a040057dd8961d62$exports.Delegation.encode(message.delegation, writer.uint32(10).fork()).ldelim();
        if (message.balance !== undefined) $783dd8715fde0fcf$exports.Coin.encode(message.balance, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $a040057dd8961d62$var$_m0.Reader ? input : new $a040057dd8961d62$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $a040057dd8961d62$var$createBaseDelegationResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.delegation = $a040057dd8961d62$exports.Delegation.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.balance = $783dd8715fde0fcf$exports.Coin.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            delegation: (0, $d5e07fe2518aae94$exports.isSet)(object.delegation) ? $a040057dd8961d62$exports.Delegation.fromJSON(object.delegation) : undefined,
            balance: (0, $d5e07fe2518aae94$exports.isSet)(object.balance) ? $783dd8715fde0fcf$exports.Coin.fromJSON(object.balance) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.delegation !== undefined && (obj.delegation = message.delegation ? $a040057dd8961d62$exports.Delegation.toJSON(message.delegation) : undefined);
        message.balance !== undefined && (obj.balance = message.balance ? $783dd8715fde0fcf$exports.Coin.toJSON(message.balance) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $a040057dd8961d62$var$createBaseDelegationResponse();
        message.delegation = object.delegation !== undefined && object.delegation !== null ? $a040057dd8961d62$exports.Delegation.fromPartial(object.delegation) : undefined;
        message.balance = object.balance !== undefined && object.balance !== null ? $783dd8715fde0fcf$exports.Coin.fromPartial(object.balance) : undefined;
        return message;
    }
};
function $a040057dd8961d62$var$createBaseRedelegationEntryResponse() {
    return {
        redelegationEntry: undefined,
        balance: ""
    };
}
$a040057dd8961d62$exports.RedelegationEntryResponse = {
    encode (message, writer = $a040057dd8961d62$var$_m0.Writer.create()) {
        if (message.redelegationEntry !== undefined) $a040057dd8961d62$exports.RedelegationEntry.encode(message.redelegationEntry, writer.uint32(10).fork()).ldelim();
        if (message.balance !== "") writer.uint32(34).string(message.balance);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $a040057dd8961d62$var$_m0.Reader ? input : new $a040057dd8961d62$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $a040057dd8961d62$var$createBaseRedelegationEntryResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.redelegationEntry = $a040057dd8961d62$exports.RedelegationEntry.decode(reader, reader.uint32());
                    break;
                case 4:
                    message.balance = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            redelegationEntry: (0, $d5e07fe2518aae94$exports.isSet)(object.redelegationEntry) ? $a040057dd8961d62$exports.RedelegationEntry.fromJSON(object.redelegationEntry) : undefined,
            balance: (0, $d5e07fe2518aae94$exports.isSet)(object.balance) ? String(object.balance) : ""
        };
    },
    toJSON (message) {
        const obj = {};
        message.redelegationEntry !== undefined && (obj.redelegationEntry = message.redelegationEntry ? $a040057dd8961d62$exports.RedelegationEntry.toJSON(message.redelegationEntry) : undefined);
        message.balance !== undefined && (obj.balance = message.balance);
        return obj;
    },
    fromPartial (object) {
        const message = $a040057dd8961d62$var$createBaseRedelegationEntryResponse();
        message.redelegationEntry = object.redelegationEntry !== undefined && object.redelegationEntry !== null ? $a040057dd8961d62$exports.RedelegationEntry.fromPartial(object.redelegationEntry) : undefined;
        message.balance = object.balance ?? "";
        return message;
    }
};
function $a040057dd8961d62$var$createBaseRedelegationResponse() {
    return {
        redelegation: undefined,
        entries: []
    };
}
$a040057dd8961d62$exports.RedelegationResponse = {
    encode (message, writer = $a040057dd8961d62$var$_m0.Writer.create()) {
        if (message.redelegation !== undefined) $a040057dd8961d62$exports.Redelegation.encode(message.redelegation, writer.uint32(10).fork()).ldelim();
        for (const v of message.entries)$a040057dd8961d62$exports.RedelegationEntryResponse.encode(v, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $a040057dd8961d62$var$_m0.Reader ? input : new $a040057dd8961d62$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $a040057dd8961d62$var$createBaseRedelegationResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.redelegation = $a040057dd8961d62$exports.Redelegation.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.entries.push($a040057dd8961d62$exports.RedelegationEntryResponse.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            redelegation: (0, $d5e07fe2518aae94$exports.isSet)(object.redelegation) ? $a040057dd8961d62$exports.Redelegation.fromJSON(object.redelegation) : undefined,
            entries: Array.isArray(object?.entries) ? object.entries.map((e)=>$a040057dd8961d62$exports.RedelegationEntryResponse.fromJSON(e)) : []
        };
    },
    toJSON (message) {
        const obj = {};
        message.redelegation !== undefined && (obj.redelegation = message.redelegation ? $a040057dd8961d62$exports.Redelegation.toJSON(message.redelegation) : undefined);
        if (message.entries) obj.entries = message.entries.map((e)=>e ? $a040057dd8961d62$exports.RedelegationEntryResponse.toJSON(e) : undefined);
        else obj.entries = [];
        return obj;
    },
    fromPartial (object) {
        const message = $a040057dd8961d62$var$createBaseRedelegationResponse();
        message.redelegation = object.redelegation !== undefined && object.redelegation !== null ? $a040057dd8961d62$exports.Redelegation.fromPartial(object.redelegation) : undefined;
        message.entries = object.entries?.map((e)=>$a040057dd8961d62$exports.RedelegationEntryResponse.fromPartial(e)) || [];
        return message;
    }
};
function $a040057dd8961d62$var$createBasePool() {
    return {
        notBondedTokens: "",
        bondedTokens: ""
    };
}
$a040057dd8961d62$exports.Pool = {
    encode (message, writer = $a040057dd8961d62$var$_m0.Writer.create()) {
        if (message.notBondedTokens !== "") writer.uint32(10).string(message.notBondedTokens);
        if (message.bondedTokens !== "") writer.uint32(18).string(message.bondedTokens);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $a040057dd8961d62$var$_m0.Reader ? input : new $a040057dd8961d62$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $a040057dd8961d62$var$createBasePool();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.notBondedTokens = reader.string();
                    break;
                case 2:
                    message.bondedTokens = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            notBondedTokens: (0, $d5e07fe2518aae94$exports.isSet)(object.notBondedTokens) ? String(object.notBondedTokens) : "",
            bondedTokens: (0, $d5e07fe2518aae94$exports.isSet)(object.bondedTokens) ? String(object.bondedTokens) : ""
        };
    },
    toJSON (message) {
        const obj = {};
        message.notBondedTokens !== undefined && (obj.notBondedTokens = message.notBondedTokens);
        message.bondedTokens !== undefined && (obj.bondedTokens = message.bondedTokens);
        return obj;
    },
    fromPartial (object) {
        const message = $a040057dd8961d62$var$createBasePool();
        message.notBondedTokens = object.notBondedTokens ?? "";
        message.bondedTokens = object.bondedTokens ?? "";
        return message;
    }
};
function $a040057dd8961d62$var$createBaseValidatorUpdates() {
    return {
        updates: []
    };
}
$a040057dd8961d62$exports.ValidatorUpdates = {
    encode (message, writer = $a040057dd8961d62$var$_m0.Writer.create()) {
        for (const v of message.updates)$55d7da6fb7010b2f$exports.ValidatorUpdate.encode(v, writer.uint32(10).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $a040057dd8961d62$var$_m0.Reader ? input : new $a040057dd8961d62$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $a040057dd8961d62$var$createBaseValidatorUpdates();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.updates.push($55d7da6fb7010b2f$exports.ValidatorUpdate.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            updates: Array.isArray(object?.updates) ? object.updates.map((e)=>$55d7da6fb7010b2f$exports.ValidatorUpdate.fromJSON(e)) : []
        };
    },
    toJSON (message) {
        const obj = {};
        if (message.updates) obj.updates = message.updates.map((e)=>e ? $55d7da6fb7010b2f$exports.ValidatorUpdate.toJSON(e) : undefined);
        else obj.updates = [];
        return obj;
    },
    fromPartial (object) {
        const message = $a040057dd8961d62$var$createBaseValidatorUpdates();
        message.updates = object.updates?.map((e)=>$55d7da6fb7010b2f$exports.ValidatorUpdate.fromPartial(e)) || [];
        return message;
    }
};







const $732d6a51596ab26e$var$_m0 = $732d6a51596ab26e$var$__importStar((parcelRequire("fQBv0")));
$732d6a51596ab26e$exports.protobufPackage = "cosmos.staking.v1beta1";
function $732d6a51596ab26e$var$createBaseMsgCreateValidator() {
    return {
        description: undefined,
        commission: undefined,
        minSelfDelegation: "",
        delegatorAddress: "",
        validatorAddress: "",
        pubkey: undefined,
        value: undefined
    };
}
$732d6a51596ab26e$exports.MsgCreateValidator = {
    encode (message, writer = $732d6a51596ab26e$var$_m0.Writer.create()) {
        if (message.description !== undefined) $a040057dd8961d62$exports.Description.encode(message.description, writer.uint32(10).fork()).ldelim();
        if (message.commission !== undefined) $a040057dd8961d62$exports.CommissionRates.encode(message.commission, writer.uint32(18).fork()).ldelim();
        if (message.minSelfDelegation !== "") writer.uint32(26).string(message.minSelfDelegation);
        if (message.delegatorAddress !== "") writer.uint32(34).string(message.delegatorAddress);
        if (message.validatorAddress !== "") writer.uint32(42).string(message.validatorAddress);
        if (message.pubkey !== undefined) $64138e590dcf0cc1$exports.Any.encode(message.pubkey, writer.uint32(50).fork()).ldelim();
        if (message.value !== undefined) $783dd8715fde0fcf$exports.Coin.encode(message.value, writer.uint32(58).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $732d6a51596ab26e$var$_m0.Reader ? input : new $732d6a51596ab26e$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $732d6a51596ab26e$var$createBaseMsgCreateValidator();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.description = $a040057dd8961d62$exports.Description.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.commission = $a040057dd8961d62$exports.CommissionRates.decode(reader, reader.uint32());
                    break;
                case 3:
                    message.minSelfDelegation = reader.string();
                    break;
                case 4:
                    message.delegatorAddress = reader.string();
                    break;
                case 5:
                    message.validatorAddress = reader.string();
                    break;
                case 6:
                    message.pubkey = $64138e590dcf0cc1$exports.Any.decode(reader, reader.uint32());
                    break;
                case 7:
                    message.value = $783dd8715fde0fcf$exports.Coin.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            description: (0, $d5e07fe2518aae94$exports.isSet)(object.description) ? $a040057dd8961d62$exports.Description.fromJSON(object.description) : undefined,
            commission: (0, $d5e07fe2518aae94$exports.isSet)(object.commission) ? $a040057dd8961d62$exports.CommissionRates.fromJSON(object.commission) : undefined,
            minSelfDelegation: (0, $d5e07fe2518aae94$exports.isSet)(object.minSelfDelegation) ? String(object.minSelfDelegation) : "",
            delegatorAddress: (0, $d5e07fe2518aae94$exports.isSet)(object.delegatorAddress) ? String(object.delegatorAddress) : "",
            validatorAddress: (0, $d5e07fe2518aae94$exports.isSet)(object.validatorAddress) ? String(object.validatorAddress) : "",
            pubkey: (0, $d5e07fe2518aae94$exports.isSet)(object.pubkey) ? $64138e590dcf0cc1$exports.Any.fromJSON(object.pubkey) : undefined,
            value: (0, $d5e07fe2518aae94$exports.isSet)(object.value) ? $783dd8715fde0fcf$exports.Coin.fromJSON(object.value) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.description !== undefined && (obj.description = message.description ? $a040057dd8961d62$exports.Description.toJSON(message.description) : undefined);
        message.commission !== undefined && (obj.commission = message.commission ? $a040057dd8961d62$exports.CommissionRates.toJSON(message.commission) : undefined);
        message.minSelfDelegation !== undefined && (obj.minSelfDelegation = message.minSelfDelegation);
        message.delegatorAddress !== undefined && (obj.delegatorAddress = message.delegatorAddress);
        message.validatorAddress !== undefined && (obj.validatorAddress = message.validatorAddress);
        message.pubkey !== undefined && (obj.pubkey = message.pubkey ? $64138e590dcf0cc1$exports.Any.toJSON(message.pubkey) : undefined);
        message.value !== undefined && (obj.value = message.value ? $783dd8715fde0fcf$exports.Coin.toJSON(message.value) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $732d6a51596ab26e$var$createBaseMsgCreateValidator();
        message.description = object.description !== undefined && object.description !== null ? $a040057dd8961d62$exports.Description.fromPartial(object.description) : undefined;
        message.commission = object.commission !== undefined && object.commission !== null ? $a040057dd8961d62$exports.CommissionRates.fromPartial(object.commission) : undefined;
        message.minSelfDelegation = object.minSelfDelegation ?? "";
        message.delegatorAddress = object.delegatorAddress ?? "";
        message.validatorAddress = object.validatorAddress ?? "";
        message.pubkey = object.pubkey !== undefined && object.pubkey !== null ? $64138e590dcf0cc1$exports.Any.fromPartial(object.pubkey) : undefined;
        message.value = object.value !== undefined && object.value !== null ? $783dd8715fde0fcf$exports.Coin.fromPartial(object.value) : undefined;
        return message;
    }
};
function $732d6a51596ab26e$var$createBaseMsgCreateValidatorResponse() {
    return {};
}
$732d6a51596ab26e$exports.MsgCreateValidatorResponse = {
    encode (_, writer = $732d6a51596ab26e$var$_m0.Writer.create()) {
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $732d6a51596ab26e$var$_m0.Reader ? input : new $732d6a51596ab26e$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $732d6a51596ab26e$var$createBaseMsgCreateValidatorResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            tag;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON (_) {
        return {};
    },
    toJSON (_) {
        const obj = {};
        return obj;
    },
    fromPartial (_) {
        const message = $732d6a51596ab26e$var$createBaseMsgCreateValidatorResponse();
        return message;
    }
};
function $732d6a51596ab26e$var$createBaseMsgEditValidator() {
    return {
        description: undefined,
        validatorAddress: "",
        commissionRate: "",
        minSelfDelegation: ""
    };
}
$732d6a51596ab26e$exports.MsgEditValidator = {
    encode (message, writer = $732d6a51596ab26e$var$_m0.Writer.create()) {
        if (message.description !== undefined) $a040057dd8961d62$exports.Description.encode(message.description, writer.uint32(10).fork()).ldelim();
        if (message.validatorAddress !== "") writer.uint32(18).string(message.validatorAddress);
        if (message.commissionRate !== "") writer.uint32(26).string(message.commissionRate);
        if (message.minSelfDelegation !== "") writer.uint32(34).string(message.minSelfDelegation);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $732d6a51596ab26e$var$_m0.Reader ? input : new $732d6a51596ab26e$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $732d6a51596ab26e$var$createBaseMsgEditValidator();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.description = $a040057dd8961d62$exports.Description.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.validatorAddress = reader.string();
                    break;
                case 3:
                    message.commissionRate = reader.string();
                    break;
                case 4:
                    message.minSelfDelegation = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            description: (0, $d5e07fe2518aae94$exports.isSet)(object.description) ? $a040057dd8961d62$exports.Description.fromJSON(object.description) : undefined,
            validatorAddress: (0, $d5e07fe2518aae94$exports.isSet)(object.validatorAddress) ? String(object.validatorAddress) : "",
            commissionRate: (0, $d5e07fe2518aae94$exports.isSet)(object.commissionRate) ? String(object.commissionRate) : "",
            minSelfDelegation: (0, $d5e07fe2518aae94$exports.isSet)(object.minSelfDelegation) ? String(object.minSelfDelegation) : ""
        };
    },
    toJSON (message) {
        const obj = {};
        message.description !== undefined && (obj.description = message.description ? $a040057dd8961d62$exports.Description.toJSON(message.description) : undefined);
        message.validatorAddress !== undefined && (obj.validatorAddress = message.validatorAddress);
        message.commissionRate !== undefined && (obj.commissionRate = message.commissionRate);
        message.minSelfDelegation !== undefined && (obj.minSelfDelegation = message.minSelfDelegation);
        return obj;
    },
    fromPartial (object) {
        const message = $732d6a51596ab26e$var$createBaseMsgEditValidator();
        message.description = object.description !== undefined && object.description !== null ? $a040057dd8961d62$exports.Description.fromPartial(object.description) : undefined;
        message.validatorAddress = object.validatorAddress ?? "";
        message.commissionRate = object.commissionRate ?? "";
        message.minSelfDelegation = object.minSelfDelegation ?? "";
        return message;
    }
};
function $732d6a51596ab26e$var$createBaseMsgEditValidatorResponse() {
    return {};
}
$732d6a51596ab26e$exports.MsgEditValidatorResponse = {
    encode (_, writer = $732d6a51596ab26e$var$_m0.Writer.create()) {
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $732d6a51596ab26e$var$_m0.Reader ? input : new $732d6a51596ab26e$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $732d6a51596ab26e$var$createBaseMsgEditValidatorResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            tag;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON (_) {
        return {};
    },
    toJSON (_) {
        const obj = {};
        return obj;
    },
    fromPartial (_) {
        const message = $732d6a51596ab26e$var$createBaseMsgEditValidatorResponse();
        return message;
    }
};
function $732d6a51596ab26e$var$createBaseMsgDelegate() {
    return {
        delegatorAddress: "",
        validatorAddress: "",
        amount: undefined
    };
}
$732d6a51596ab26e$exports.MsgDelegate = {
    encode (message, writer = $732d6a51596ab26e$var$_m0.Writer.create()) {
        if (message.delegatorAddress !== "") writer.uint32(10).string(message.delegatorAddress);
        if (message.validatorAddress !== "") writer.uint32(18).string(message.validatorAddress);
        if (message.amount !== undefined) $783dd8715fde0fcf$exports.Coin.encode(message.amount, writer.uint32(26).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $732d6a51596ab26e$var$_m0.Reader ? input : new $732d6a51596ab26e$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $732d6a51596ab26e$var$createBaseMsgDelegate();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.delegatorAddress = reader.string();
                    break;
                case 2:
                    message.validatorAddress = reader.string();
                    break;
                case 3:
                    message.amount = $783dd8715fde0fcf$exports.Coin.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            delegatorAddress: (0, $d5e07fe2518aae94$exports.isSet)(object.delegatorAddress) ? String(object.delegatorAddress) : "",
            validatorAddress: (0, $d5e07fe2518aae94$exports.isSet)(object.validatorAddress) ? String(object.validatorAddress) : "",
            amount: (0, $d5e07fe2518aae94$exports.isSet)(object.amount) ? $783dd8715fde0fcf$exports.Coin.fromJSON(object.amount) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.delegatorAddress !== undefined && (obj.delegatorAddress = message.delegatorAddress);
        message.validatorAddress !== undefined && (obj.validatorAddress = message.validatorAddress);
        message.amount !== undefined && (obj.amount = message.amount ? $783dd8715fde0fcf$exports.Coin.toJSON(message.amount) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $732d6a51596ab26e$var$createBaseMsgDelegate();
        message.delegatorAddress = object.delegatorAddress ?? "";
        message.validatorAddress = object.validatorAddress ?? "";
        message.amount = object.amount !== undefined && object.amount !== null ? $783dd8715fde0fcf$exports.Coin.fromPartial(object.amount) : undefined;
        return message;
    }
};
function $732d6a51596ab26e$var$createBaseMsgDelegateResponse() {
    return {};
}
$732d6a51596ab26e$exports.MsgDelegateResponse = {
    encode (_, writer = $732d6a51596ab26e$var$_m0.Writer.create()) {
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $732d6a51596ab26e$var$_m0.Reader ? input : new $732d6a51596ab26e$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $732d6a51596ab26e$var$createBaseMsgDelegateResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            tag;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON (_) {
        return {};
    },
    toJSON (_) {
        const obj = {};
        return obj;
    },
    fromPartial (_) {
        const message = $732d6a51596ab26e$var$createBaseMsgDelegateResponse();
        return message;
    }
};
function $732d6a51596ab26e$var$createBaseMsgBeginRedelegate() {
    return {
        delegatorAddress: "",
        validatorSrcAddress: "",
        validatorDstAddress: "",
        amount: undefined
    };
}
$732d6a51596ab26e$exports.MsgBeginRedelegate = {
    encode (message, writer = $732d6a51596ab26e$var$_m0.Writer.create()) {
        if (message.delegatorAddress !== "") writer.uint32(10).string(message.delegatorAddress);
        if (message.validatorSrcAddress !== "") writer.uint32(18).string(message.validatorSrcAddress);
        if (message.validatorDstAddress !== "") writer.uint32(26).string(message.validatorDstAddress);
        if (message.amount !== undefined) $783dd8715fde0fcf$exports.Coin.encode(message.amount, writer.uint32(34).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $732d6a51596ab26e$var$_m0.Reader ? input : new $732d6a51596ab26e$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $732d6a51596ab26e$var$createBaseMsgBeginRedelegate();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.delegatorAddress = reader.string();
                    break;
                case 2:
                    message.validatorSrcAddress = reader.string();
                    break;
                case 3:
                    message.validatorDstAddress = reader.string();
                    break;
                case 4:
                    message.amount = $783dd8715fde0fcf$exports.Coin.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            delegatorAddress: (0, $d5e07fe2518aae94$exports.isSet)(object.delegatorAddress) ? String(object.delegatorAddress) : "",
            validatorSrcAddress: (0, $d5e07fe2518aae94$exports.isSet)(object.validatorSrcAddress) ? String(object.validatorSrcAddress) : "",
            validatorDstAddress: (0, $d5e07fe2518aae94$exports.isSet)(object.validatorDstAddress) ? String(object.validatorDstAddress) : "",
            amount: (0, $d5e07fe2518aae94$exports.isSet)(object.amount) ? $783dd8715fde0fcf$exports.Coin.fromJSON(object.amount) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.delegatorAddress !== undefined && (obj.delegatorAddress = message.delegatorAddress);
        message.validatorSrcAddress !== undefined && (obj.validatorSrcAddress = message.validatorSrcAddress);
        message.validatorDstAddress !== undefined && (obj.validatorDstAddress = message.validatorDstAddress);
        message.amount !== undefined && (obj.amount = message.amount ? $783dd8715fde0fcf$exports.Coin.toJSON(message.amount) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $732d6a51596ab26e$var$createBaseMsgBeginRedelegate();
        message.delegatorAddress = object.delegatorAddress ?? "";
        message.validatorSrcAddress = object.validatorSrcAddress ?? "";
        message.validatorDstAddress = object.validatorDstAddress ?? "";
        message.amount = object.amount !== undefined && object.amount !== null ? $783dd8715fde0fcf$exports.Coin.fromPartial(object.amount) : undefined;
        return message;
    }
};
function $732d6a51596ab26e$var$createBaseMsgBeginRedelegateResponse() {
    return {
        completionTime: undefined
    };
}
$732d6a51596ab26e$exports.MsgBeginRedelegateResponse = {
    encode (message, writer = $732d6a51596ab26e$var$_m0.Writer.create()) {
        if (message.completionTime !== undefined) $e7eaeedc85b414fc$exports.Timestamp.encode(message.completionTime, writer.uint32(10).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $732d6a51596ab26e$var$_m0.Reader ? input : new $732d6a51596ab26e$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $732d6a51596ab26e$var$createBaseMsgBeginRedelegateResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.completionTime = $e7eaeedc85b414fc$exports.Timestamp.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            completionTime: (0, $d5e07fe2518aae94$exports.isSet)(object.completionTime) ? (0, $d5e07fe2518aae94$exports.fromJsonTimestamp)(object.completionTime) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.completionTime !== undefined && (obj.completionTime = (0, $d5e07fe2518aae94$exports.fromTimestamp)(message.completionTime).toISOString());
        return obj;
    },
    fromPartial (object) {
        const message = $732d6a51596ab26e$var$createBaseMsgBeginRedelegateResponse();
        message.completionTime = object.completionTime !== undefined && object.completionTime !== null ? $e7eaeedc85b414fc$exports.Timestamp.fromPartial(object.completionTime) : undefined;
        return message;
    }
};
function $732d6a51596ab26e$var$createBaseMsgUndelegate() {
    return {
        delegatorAddress: "",
        validatorAddress: "",
        amount: undefined
    };
}
$732d6a51596ab26e$exports.MsgUndelegate = {
    encode (message, writer = $732d6a51596ab26e$var$_m0.Writer.create()) {
        if (message.delegatorAddress !== "") writer.uint32(10).string(message.delegatorAddress);
        if (message.validatorAddress !== "") writer.uint32(18).string(message.validatorAddress);
        if (message.amount !== undefined) $783dd8715fde0fcf$exports.Coin.encode(message.amount, writer.uint32(26).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $732d6a51596ab26e$var$_m0.Reader ? input : new $732d6a51596ab26e$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $732d6a51596ab26e$var$createBaseMsgUndelegate();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.delegatorAddress = reader.string();
                    break;
                case 2:
                    message.validatorAddress = reader.string();
                    break;
                case 3:
                    message.amount = $783dd8715fde0fcf$exports.Coin.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            delegatorAddress: (0, $d5e07fe2518aae94$exports.isSet)(object.delegatorAddress) ? String(object.delegatorAddress) : "",
            validatorAddress: (0, $d5e07fe2518aae94$exports.isSet)(object.validatorAddress) ? String(object.validatorAddress) : "",
            amount: (0, $d5e07fe2518aae94$exports.isSet)(object.amount) ? $783dd8715fde0fcf$exports.Coin.fromJSON(object.amount) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.delegatorAddress !== undefined && (obj.delegatorAddress = message.delegatorAddress);
        message.validatorAddress !== undefined && (obj.validatorAddress = message.validatorAddress);
        message.amount !== undefined && (obj.amount = message.amount ? $783dd8715fde0fcf$exports.Coin.toJSON(message.amount) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $732d6a51596ab26e$var$createBaseMsgUndelegate();
        message.delegatorAddress = object.delegatorAddress ?? "";
        message.validatorAddress = object.validatorAddress ?? "";
        message.amount = object.amount !== undefined && object.amount !== null ? $783dd8715fde0fcf$exports.Coin.fromPartial(object.amount) : undefined;
        return message;
    }
};
function $732d6a51596ab26e$var$createBaseMsgUndelegateResponse() {
    return {
        completionTime: undefined
    };
}
$732d6a51596ab26e$exports.MsgUndelegateResponse = {
    encode (message, writer = $732d6a51596ab26e$var$_m0.Writer.create()) {
        if (message.completionTime !== undefined) $e7eaeedc85b414fc$exports.Timestamp.encode(message.completionTime, writer.uint32(10).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $732d6a51596ab26e$var$_m0.Reader ? input : new $732d6a51596ab26e$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $732d6a51596ab26e$var$createBaseMsgUndelegateResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.completionTime = $e7eaeedc85b414fc$exports.Timestamp.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            completionTime: (0, $d5e07fe2518aae94$exports.isSet)(object.completionTime) ? (0, $d5e07fe2518aae94$exports.fromJsonTimestamp)(object.completionTime) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.completionTime !== undefined && (obj.completionTime = (0, $d5e07fe2518aae94$exports.fromTimestamp)(message.completionTime).toISOString());
        return obj;
    },
    fromPartial (object) {
        const message = $732d6a51596ab26e$var$createBaseMsgUndelegateResponse();
        message.completionTime = object.completionTime !== undefined && object.completionTime !== null ? $e7eaeedc85b414fc$exports.Timestamp.fromPartial(object.completionTime) : undefined;
        return message;
    }
};
function $732d6a51596ab26e$var$createBaseMsgCancelUnbondingDelegation() {
    return {
        delegatorAddress: "",
        validatorAddress: "",
        amount: undefined,
        creationHeight: $d5e07fe2518aae94$exports.Long.ZERO
    };
}
$732d6a51596ab26e$exports.MsgCancelUnbondingDelegation = {
    encode (message, writer = $732d6a51596ab26e$var$_m0.Writer.create()) {
        if (message.delegatorAddress !== "") writer.uint32(10).string(message.delegatorAddress);
        if (message.validatorAddress !== "") writer.uint32(18).string(message.validatorAddress);
        if (message.amount !== undefined) $783dd8715fde0fcf$exports.Coin.encode(message.amount, writer.uint32(26).fork()).ldelim();
        if (!message.creationHeight.isZero()) writer.uint32(32).int64(message.creationHeight);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $732d6a51596ab26e$var$_m0.Reader ? input : new $732d6a51596ab26e$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $732d6a51596ab26e$var$createBaseMsgCancelUnbondingDelegation();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.delegatorAddress = reader.string();
                    break;
                case 2:
                    message.validatorAddress = reader.string();
                    break;
                case 3:
                    message.amount = $783dd8715fde0fcf$exports.Coin.decode(reader, reader.uint32());
                    break;
                case 4:
                    message.creationHeight = reader.int64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            delegatorAddress: (0, $d5e07fe2518aae94$exports.isSet)(object.delegatorAddress) ? String(object.delegatorAddress) : "",
            validatorAddress: (0, $d5e07fe2518aae94$exports.isSet)(object.validatorAddress) ? String(object.validatorAddress) : "",
            amount: (0, $d5e07fe2518aae94$exports.isSet)(object.amount) ? $783dd8715fde0fcf$exports.Coin.fromJSON(object.amount) : undefined,
            creationHeight: (0, $d5e07fe2518aae94$exports.isSet)(object.creationHeight) ? $d5e07fe2518aae94$exports.Long.fromValue(object.creationHeight) : $d5e07fe2518aae94$exports.Long.ZERO
        };
    },
    toJSON (message) {
        const obj = {};
        message.delegatorAddress !== undefined && (obj.delegatorAddress = message.delegatorAddress);
        message.validatorAddress !== undefined && (obj.validatorAddress = message.validatorAddress);
        message.amount !== undefined && (obj.amount = message.amount ? $783dd8715fde0fcf$exports.Coin.toJSON(message.amount) : undefined);
        message.creationHeight !== undefined && (obj.creationHeight = (message.creationHeight || $d5e07fe2518aae94$exports.Long.ZERO).toString());
        return obj;
    },
    fromPartial (object) {
        const message = $732d6a51596ab26e$var$createBaseMsgCancelUnbondingDelegation();
        message.delegatorAddress = object.delegatorAddress ?? "";
        message.validatorAddress = object.validatorAddress ?? "";
        message.amount = object.amount !== undefined && object.amount !== null ? $783dd8715fde0fcf$exports.Coin.fromPartial(object.amount) : undefined;
        message.creationHeight = object.creationHeight !== undefined && object.creationHeight !== null ? $d5e07fe2518aae94$exports.Long.fromValue(object.creationHeight) : $d5e07fe2518aae94$exports.Long.ZERO;
        return message;
    }
};
function $732d6a51596ab26e$var$createBaseMsgCancelUnbondingDelegationResponse() {
    return {};
}
$732d6a51596ab26e$exports.MsgCancelUnbondingDelegationResponse = {
    encode (_, writer = $732d6a51596ab26e$var$_m0.Writer.create()) {
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $732d6a51596ab26e$var$_m0.Reader ? input : new $732d6a51596ab26e$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $732d6a51596ab26e$var$createBaseMsgCancelUnbondingDelegationResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            tag;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON (_) {
        return {};
    },
    toJSON (_) {
        const obj = {};
        return obj;
    },
    fromPartial (_) {
        const message = $732d6a51596ab26e$var$createBaseMsgCancelUnbondingDelegationResponse();
        return message;
    }
};
function $732d6a51596ab26e$var$createBaseMsgUpdateParams() {
    return {
        authority: "",
        params: undefined
    };
}
$732d6a51596ab26e$exports.MsgUpdateParams = {
    encode (message, writer = $732d6a51596ab26e$var$_m0.Writer.create()) {
        if (message.authority !== "") writer.uint32(10).string(message.authority);
        if (message.params !== undefined) $a040057dd8961d62$exports.Params.encode(message.params, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $732d6a51596ab26e$var$_m0.Reader ? input : new $732d6a51596ab26e$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $732d6a51596ab26e$var$createBaseMsgUpdateParams();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.authority = reader.string();
                    break;
                case 2:
                    message.params = $a040057dd8961d62$exports.Params.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            authority: (0, $d5e07fe2518aae94$exports.isSet)(object.authority) ? String(object.authority) : "",
            params: (0, $d5e07fe2518aae94$exports.isSet)(object.params) ? $a040057dd8961d62$exports.Params.fromJSON(object.params) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.authority !== undefined && (obj.authority = message.authority);
        message.params !== undefined && (obj.params = message.params ? $a040057dd8961d62$exports.Params.toJSON(message.params) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $732d6a51596ab26e$var$createBaseMsgUpdateParams();
        message.authority = object.authority ?? "";
        message.params = object.params !== undefined && object.params !== null ? $a040057dd8961d62$exports.Params.fromPartial(object.params) : undefined;
        return message;
    }
};
function $732d6a51596ab26e$var$createBaseMsgUpdateParamsResponse() {
    return {};
}
$732d6a51596ab26e$exports.MsgUpdateParamsResponse = {
    encode (_, writer = $732d6a51596ab26e$var$_m0.Writer.create()) {
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $732d6a51596ab26e$var$_m0.Reader ? input : new $732d6a51596ab26e$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $732d6a51596ab26e$var$createBaseMsgUpdateParamsResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            tag;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON (_) {
        return {};
    },
    toJSON (_) {
        const obj = {};
        return obj;
    },
    fromPartial (_) {
        const message = $732d6a51596ab26e$var$createBaseMsgUpdateParamsResponse();
        return message;
    }
};
class $732d6a51596ab26e$var$MsgClientImpl {
    constructor(rpc){
        this.rpc = rpc;
        this.CreateValidator = this.CreateValidator.bind(this);
        this.EditValidator = this.EditValidator.bind(this);
        this.Delegate = this.Delegate.bind(this);
        this.BeginRedelegate = this.BeginRedelegate.bind(this);
        this.Undelegate = this.Undelegate.bind(this);
        this.CancelUnbondingDelegation = this.CancelUnbondingDelegation.bind(this);
        this.UpdateParams = this.UpdateParams.bind(this);
    }
    CreateValidator(request) {
        const data = $732d6a51596ab26e$exports.MsgCreateValidator.encode(request).finish();
        const promise = this.rpc.request("cosmos.staking.v1beta1.Msg", "CreateValidator", data);
        return promise.then((data)=>$732d6a51596ab26e$exports.MsgCreateValidatorResponse.decode(new $732d6a51596ab26e$var$_m0.Reader(data)));
    }
    EditValidator(request) {
        const data = $732d6a51596ab26e$exports.MsgEditValidator.encode(request).finish();
        const promise = this.rpc.request("cosmos.staking.v1beta1.Msg", "EditValidator", data);
        return promise.then((data)=>$732d6a51596ab26e$exports.MsgEditValidatorResponse.decode(new $732d6a51596ab26e$var$_m0.Reader(data)));
    }
    Delegate(request) {
        const data = $732d6a51596ab26e$exports.MsgDelegate.encode(request).finish();
        const promise = this.rpc.request("cosmos.staking.v1beta1.Msg", "Delegate", data);
        return promise.then((data)=>$732d6a51596ab26e$exports.MsgDelegateResponse.decode(new $732d6a51596ab26e$var$_m0.Reader(data)));
    }
    BeginRedelegate(request) {
        const data = $732d6a51596ab26e$exports.MsgBeginRedelegate.encode(request).finish();
        const promise = this.rpc.request("cosmos.staking.v1beta1.Msg", "BeginRedelegate", data);
        return promise.then((data)=>$732d6a51596ab26e$exports.MsgBeginRedelegateResponse.decode(new $732d6a51596ab26e$var$_m0.Reader(data)));
    }
    Undelegate(request) {
        const data = $732d6a51596ab26e$exports.MsgUndelegate.encode(request).finish();
        const promise = this.rpc.request("cosmos.staking.v1beta1.Msg", "Undelegate", data);
        return promise.then((data)=>$732d6a51596ab26e$exports.MsgUndelegateResponse.decode(new $732d6a51596ab26e$var$_m0.Reader(data)));
    }
    CancelUnbondingDelegation(request) {
        const data = $732d6a51596ab26e$exports.MsgCancelUnbondingDelegation.encode(request).finish();
        const promise = this.rpc.request("cosmos.staking.v1beta1.Msg", "CancelUnbondingDelegation", data);
        return promise.then((data)=>$732d6a51596ab26e$exports.MsgCancelUnbondingDelegationResponse.decode(new $732d6a51596ab26e$var$_m0.Reader(data)));
    }
    UpdateParams(request) {
        const data = $732d6a51596ab26e$exports.MsgUpdateParams.encode(request).finish();
        const promise = this.rpc.request("cosmos.staking.v1beta1.Msg", "UpdateParams", data);
        return promise.then((data)=>$732d6a51596ab26e$exports.MsgUpdateParamsResponse.decode(new $732d6a51596ab26e$var$_m0.Reader(data)));
    }
}
$732d6a51596ab26e$exports.MsgClientImpl = $732d6a51596ab26e$var$MsgClientImpl;


$629136b718486c26$exports.stakingTypes = [
    [
        "/cosmos.staking.v1beta1.MsgBeginRedelegate",
        $732d6a51596ab26e$exports.MsgBeginRedelegate
    ],
    [
        "/cosmos.staking.v1beta1.MsgCreateValidator",
        $732d6a51596ab26e$exports.MsgCreateValidator
    ],
    [
        "/cosmos.staking.v1beta1.MsgDelegate",
        $732d6a51596ab26e$exports.MsgDelegate
    ],
    [
        "/cosmos.staking.v1beta1.MsgEditValidator",
        $732d6a51596ab26e$exports.MsgEditValidator
    ],
    [
        "/cosmos.staking.v1beta1.MsgUndelegate",
        $732d6a51596ab26e$exports.MsgUndelegate
    ]
];
function $629136b718486c26$var$isMsgBeginRedelegateEncodeObject(o) {
    return o.typeUrl === "/cosmos.staking.v1beta1.MsgBeginRedelegate";
}
$629136b718486c26$exports.isMsgBeginRedelegateEncodeObject = $629136b718486c26$var$isMsgBeginRedelegateEncodeObject;
function $629136b718486c26$var$isMsgCreateValidatorEncodeObject(o) {
    return o.typeUrl === "/cosmos.staking.v1beta1.MsgCreateValidator";
}
$629136b718486c26$exports.isMsgCreateValidatorEncodeObject = $629136b718486c26$var$isMsgCreateValidatorEncodeObject;
function $629136b718486c26$var$isMsgDelegateEncodeObject(object) {
    return object.typeUrl === "/cosmos.staking.v1beta1.MsgDelegate";
}
$629136b718486c26$exports.isMsgDelegateEncodeObject = $629136b718486c26$var$isMsgDelegateEncodeObject;
function $629136b718486c26$var$isMsgEditValidatorEncodeObject(o) {
    return o.typeUrl === "/cosmos.staking.v1beta1.MsgEditValidator";
}
$629136b718486c26$exports.isMsgEditValidatorEncodeObject = $629136b718486c26$var$isMsgEditValidatorEncodeObject;
function $629136b718486c26$var$isMsgUndelegateEncodeObject(object) {
    return object.typeUrl === "/cosmos.staking.v1beta1.MsgUndelegate";
}
$629136b718486c26$exports.isMsgUndelegateEncodeObject = $629136b718486c26$var$isMsgUndelegateEncodeObject;


Object.defineProperty($d0d8b6f4712acd9f$exports, "isMsgBeginRedelegateEncodeObject", {
    enumerable: true,
    get: function() {
        return $629136b718486c26$exports.isMsgBeginRedelegateEncodeObject;
    }
});
Object.defineProperty($d0d8b6f4712acd9f$exports, "isMsgCreateValidatorEncodeObject", {
    enumerable: true,
    get: function() {
        return $629136b718486c26$exports.isMsgCreateValidatorEncodeObject;
    }
});
Object.defineProperty($d0d8b6f4712acd9f$exports, "isMsgDelegateEncodeObject", {
    enumerable: true,
    get: function() {
        return $629136b718486c26$exports.isMsgDelegateEncodeObject;
    }
});
Object.defineProperty($d0d8b6f4712acd9f$exports, "isMsgEditValidatorEncodeObject", {
    enumerable: true,
    get: function() {
        return $629136b718486c26$exports.isMsgEditValidatorEncodeObject;
    }
});
Object.defineProperty($d0d8b6f4712acd9f$exports, "isMsgUndelegateEncodeObject", {
    enumerable: true,
    get: function() {
        return $629136b718486c26$exports.isMsgUndelegateEncodeObject;
    }
});
Object.defineProperty($d0d8b6f4712acd9f$exports, "stakingTypes", {
    enumerable: true,
    get: function() {
        return $629136b718486c26$exports.stakingTypes;
    }
});
var $3d81be017edc450a$exports = {};
"use strict";
var $3d81be017edc450a$var$__importDefault = $3d81be017edc450a$exports && $3d81be017edc450a$exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty($3d81be017edc450a$exports, "__esModule", {
    value: true
});
$3d81be017edc450a$exports.setupStakingExtension = void 0;
var $0309913a6a030f9f$exports = {};
"use strict";
var $0309913a6a030f9f$var$__createBinding = $0309913a6a030f9f$exports && $0309913a6a030f9f$exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $0309913a6a030f9f$var$__setModuleDefault = $0309913a6a030f9f$exports && $0309913a6a030f9f$exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $0309913a6a030f9f$var$__importStar = $0309913a6a030f9f$exports && $0309913a6a030f9f$exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $0309913a6a030f9f$var$__createBinding(result, mod, k);
    }
    $0309913a6a030f9f$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty($0309913a6a030f9f$exports, "__esModule", {
    value: true
});
$0309913a6a030f9f$exports.QueryClientImpl = $0309913a6a030f9f$exports.QueryParamsResponse = $0309913a6a030f9f$exports.QueryParamsRequest = $0309913a6a030f9f$exports.QueryPoolResponse = $0309913a6a030f9f$exports.QueryPoolRequest = $0309913a6a030f9f$exports.QueryHistoricalInfoResponse = $0309913a6a030f9f$exports.QueryHistoricalInfoRequest = $0309913a6a030f9f$exports.QueryDelegatorValidatorResponse = $0309913a6a030f9f$exports.QueryDelegatorValidatorRequest = $0309913a6a030f9f$exports.QueryDelegatorValidatorsResponse = $0309913a6a030f9f$exports.QueryDelegatorValidatorsRequest = $0309913a6a030f9f$exports.QueryRedelegationsResponse = $0309913a6a030f9f$exports.QueryRedelegationsRequest = $0309913a6a030f9f$exports.QueryDelegatorUnbondingDelegationsResponse = $0309913a6a030f9f$exports.QueryDelegatorUnbondingDelegationsRequest = $0309913a6a030f9f$exports.QueryDelegatorDelegationsResponse = $0309913a6a030f9f$exports.QueryDelegatorDelegationsRequest = $0309913a6a030f9f$exports.QueryUnbondingDelegationResponse = $0309913a6a030f9f$exports.QueryUnbondingDelegationRequest = $0309913a6a030f9f$exports.QueryDelegationResponse = $0309913a6a030f9f$exports.QueryDelegationRequest = $0309913a6a030f9f$exports.QueryValidatorUnbondingDelegationsResponse = $0309913a6a030f9f$exports.QueryValidatorUnbondingDelegationsRequest = $0309913a6a030f9f$exports.QueryValidatorDelegationsResponse = $0309913a6a030f9f$exports.QueryValidatorDelegationsRequest = $0309913a6a030f9f$exports.QueryValidatorResponse = $0309913a6a030f9f$exports.QueryValidatorRequest = $0309913a6a030f9f$exports.QueryValidatorsResponse = $0309913a6a030f9f$exports.QueryValidatorsRequest = $0309913a6a030f9f$exports.protobufPackage = void 0;




const $0309913a6a030f9f$var$_m0 = $0309913a6a030f9f$var$__importStar((parcelRequire("fQBv0")));
$0309913a6a030f9f$exports.protobufPackage = "cosmos.staking.v1beta1";
function $0309913a6a030f9f$var$createBaseQueryValidatorsRequest() {
    return {
        status: "",
        pagination: undefined
    };
}
$0309913a6a030f9f$exports.QueryValidatorsRequest = {
    encode (message, writer = $0309913a6a030f9f$var$_m0.Writer.create()) {
        if (message.status !== "") writer.uint32(10).string(message.status);
        if (message.pagination !== undefined) $5eae5f3cc99e92ab$exports.PageRequest.encode(message.pagination, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $0309913a6a030f9f$var$_m0.Reader ? input : new $0309913a6a030f9f$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $0309913a6a030f9f$var$createBaseQueryValidatorsRequest();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.status = reader.string();
                    break;
                case 2:
                    message.pagination = $5eae5f3cc99e92ab$exports.PageRequest.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            status: (0, $d5e07fe2518aae94$exports.isSet)(object.status) ? String(object.status) : "",
            pagination: (0, $d5e07fe2518aae94$exports.isSet)(object.pagination) ? $5eae5f3cc99e92ab$exports.PageRequest.fromJSON(object.pagination) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.status !== undefined && (obj.status = message.status);
        message.pagination !== undefined && (obj.pagination = message.pagination ? $5eae5f3cc99e92ab$exports.PageRequest.toJSON(message.pagination) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $0309913a6a030f9f$var$createBaseQueryValidatorsRequest();
        message.status = object.status ?? "";
        message.pagination = object.pagination !== undefined && object.pagination !== null ? $5eae5f3cc99e92ab$exports.PageRequest.fromPartial(object.pagination) : undefined;
        return message;
    }
};
function $0309913a6a030f9f$var$createBaseQueryValidatorsResponse() {
    return {
        validators: [],
        pagination: undefined
    };
}
$0309913a6a030f9f$exports.QueryValidatorsResponse = {
    encode (message, writer = $0309913a6a030f9f$var$_m0.Writer.create()) {
        for (const v of message.validators)$a040057dd8961d62$exports.Validator.encode(v, writer.uint32(10).fork()).ldelim();
        if (message.pagination !== undefined) $5eae5f3cc99e92ab$exports.PageResponse.encode(message.pagination, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $0309913a6a030f9f$var$_m0.Reader ? input : new $0309913a6a030f9f$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $0309913a6a030f9f$var$createBaseQueryValidatorsResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.validators.push($a040057dd8961d62$exports.Validator.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.pagination = $5eae5f3cc99e92ab$exports.PageResponse.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            validators: Array.isArray(object?.validators) ? object.validators.map((e)=>$a040057dd8961d62$exports.Validator.fromJSON(e)) : [],
            pagination: (0, $d5e07fe2518aae94$exports.isSet)(object.pagination) ? $5eae5f3cc99e92ab$exports.PageResponse.fromJSON(object.pagination) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        if (message.validators) obj.validators = message.validators.map((e)=>e ? $a040057dd8961d62$exports.Validator.toJSON(e) : undefined);
        else obj.validators = [];
        message.pagination !== undefined && (obj.pagination = message.pagination ? $5eae5f3cc99e92ab$exports.PageResponse.toJSON(message.pagination) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $0309913a6a030f9f$var$createBaseQueryValidatorsResponse();
        message.validators = object.validators?.map((e)=>$a040057dd8961d62$exports.Validator.fromPartial(e)) || [];
        message.pagination = object.pagination !== undefined && object.pagination !== null ? $5eae5f3cc99e92ab$exports.PageResponse.fromPartial(object.pagination) : undefined;
        return message;
    }
};
function $0309913a6a030f9f$var$createBaseQueryValidatorRequest() {
    return {
        validatorAddr: ""
    };
}
$0309913a6a030f9f$exports.QueryValidatorRequest = {
    encode (message, writer = $0309913a6a030f9f$var$_m0.Writer.create()) {
        if (message.validatorAddr !== "") writer.uint32(10).string(message.validatorAddr);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $0309913a6a030f9f$var$_m0.Reader ? input : new $0309913a6a030f9f$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $0309913a6a030f9f$var$createBaseQueryValidatorRequest();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.validatorAddr = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            validatorAddr: (0, $d5e07fe2518aae94$exports.isSet)(object.validatorAddr) ? String(object.validatorAddr) : ""
        };
    },
    toJSON (message) {
        const obj = {};
        message.validatorAddr !== undefined && (obj.validatorAddr = message.validatorAddr);
        return obj;
    },
    fromPartial (object) {
        const message = $0309913a6a030f9f$var$createBaseQueryValidatorRequest();
        message.validatorAddr = object.validatorAddr ?? "";
        return message;
    }
};
function $0309913a6a030f9f$var$createBaseQueryValidatorResponse() {
    return {
        validator: undefined
    };
}
$0309913a6a030f9f$exports.QueryValidatorResponse = {
    encode (message, writer = $0309913a6a030f9f$var$_m0.Writer.create()) {
        if (message.validator !== undefined) $a040057dd8961d62$exports.Validator.encode(message.validator, writer.uint32(10).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $0309913a6a030f9f$var$_m0.Reader ? input : new $0309913a6a030f9f$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $0309913a6a030f9f$var$createBaseQueryValidatorResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.validator = $a040057dd8961d62$exports.Validator.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            validator: (0, $d5e07fe2518aae94$exports.isSet)(object.validator) ? $a040057dd8961d62$exports.Validator.fromJSON(object.validator) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.validator !== undefined && (obj.validator = message.validator ? $a040057dd8961d62$exports.Validator.toJSON(message.validator) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $0309913a6a030f9f$var$createBaseQueryValidatorResponse();
        message.validator = object.validator !== undefined && object.validator !== null ? $a040057dd8961d62$exports.Validator.fromPartial(object.validator) : undefined;
        return message;
    }
};
function $0309913a6a030f9f$var$createBaseQueryValidatorDelegationsRequest() {
    return {
        validatorAddr: "",
        pagination: undefined
    };
}
$0309913a6a030f9f$exports.QueryValidatorDelegationsRequest = {
    encode (message, writer = $0309913a6a030f9f$var$_m0.Writer.create()) {
        if (message.validatorAddr !== "") writer.uint32(10).string(message.validatorAddr);
        if (message.pagination !== undefined) $5eae5f3cc99e92ab$exports.PageRequest.encode(message.pagination, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $0309913a6a030f9f$var$_m0.Reader ? input : new $0309913a6a030f9f$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $0309913a6a030f9f$var$createBaseQueryValidatorDelegationsRequest();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.validatorAddr = reader.string();
                    break;
                case 2:
                    message.pagination = $5eae5f3cc99e92ab$exports.PageRequest.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            validatorAddr: (0, $d5e07fe2518aae94$exports.isSet)(object.validatorAddr) ? String(object.validatorAddr) : "",
            pagination: (0, $d5e07fe2518aae94$exports.isSet)(object.pagination) ? $5eae5f3cc99e92ab$exports.PageRequest.fromJSON(object.pagination) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.validatorAddr !== undefined && (obj.validatorAddr = message.validatorAddr);
        message.pagination !== undefined && (obj.pagination = message.pagination ? $5eae5f3cc99e92ab$exports.PageRequest.toJSON(message.pagination) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $0309913a6a030f9f$var$createBaseQueryValidatorDelegationsRequest();
        message.validatorAddr = object.validatorAddr ?? "";
        message.pagination = object.pagination !== undefined && object.pagination !== null ? $5eae5f3cc99e92ab$exports.PageRequest.fromPartial(object.pagination) : undefined;
        return message;
    }
};
function $0309913a6a030f9f$var$createBaseQueryValidatorDelegationsResponse() {
    return {
        delegationResponses: [],
        pagination: undefined
    };
}
$0309913a6a030f9f$exports.QueryValidatorDelegationsResponse = {
    encode (message, writer = $0309913a6a030f9f$var$_m0.Writer.create()) {
        for (const v of message.delegationResponses)$a040057dd8961d62$exports.DelegationResponse.encode(v, writer.uint32(10).fork()).ldelim();
        if (message.pagination !== undefined) $5eae5f3cc99e92ab$exports.PageResponse.encode(message.pagination, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $0309913a6a030f9f$var$_m0.Reader ? input : new $0309913a6a030f9f$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $0309913a6a030f9f$var$createBaseQueryValidatorDelegationsResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.delegationResponses.push($a040057dd8961d62$exports.DelegationResponse.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.pagination = $5eae5f3cc99e92ab$exports.PageResponse.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            delegationResponses: Array.isArray(object?.delegationResponses) ? object.delegationResponses.map((e)=>$a040057dd8961d62$exports.DelegationResponse.fromJSON(e)) : [],
            pagination: (0, $d5e07fe2518aae94$exports.isSet)(object.pagination) ? $5eae5f3cc99e92ab$exports.PageResponse.fromJSON(object.pagination) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        if (message.delegationResponses) obj.delegationResponses = message.delegationResponses.map((e)=>e ? $a040057dd8961d62$exports.DelegationResponse.toJSON(e) : undefined);
        else obj.delegationResponses = [];
        message.pagination !== undefined && (obj.pagination = message.pagination ? $5eae5f3cc99e92ab$exports.PageResponse.toJSON(message.pagination) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $0309913a6a030f9f$var$createBaseQueryValidatorDelegationsResponse();
        message.delegationResponses = object.delegationResponses?.map((e)=>$a040057dd8961d62$exports.DelegationResponse.fromPartial(e)) || [];
        message.pagination = object.pagination !== undefined && object.pagination !== null ? $5eae5f3cc99e92ab$exports.PageResponse.fromPartial(object.pagination) : undefined;
        return message;
    }
};
function $0309913a6a030f9f$var$createBaseQueryValidatorUnbondingDelegationsRequest() {
    return {
        validatorAddr: "",
        pagination: undefined
    };
}
$0309913a6a030f9f$exports.QueryValidatorUnbondingDelegationsRequest = {
    encode (message, writer = $0309913a6a030f9f$var$_m0.Writer.create()) {
        if (message.validatorAddr !== "") writer.uint32(10).string(message.validatorAddr);
        if (message.pagination !== undefined) $5eae5f3cc99e92ab$exports.PageRequest.encode(message.pagination, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $0309913a6a030f9f$var$_m0.Reader ? input : new $0309913a6a030f9f$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $0309913a6a030f9f$var$createBaseQueryValidatorUnbondingDelegationsRequest();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.validatorAddr = reader.string();
                    break;
                case 2:
                    message.pagination = $5eae5f3cc99e92ab$exports.PageRequest.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            validatorAddr: (0, $d5e07fe2518aae94$exports.isSet)(object.validatorAddr) ? String(object.validatorAddr) : "",
            pagination: (0, $d5e07fe2518aae94$exports.isSet)(object.pagination) ? $5eae5f3cc99e92ab$exports.PageRequest.fromJSON(object.pagination) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.validatorAddr !== undefined && (obj.validatorAddr = message.validatorAddr);
        message.pagination !== undefined && (obj.pagination = message.pagination ? $5eae5f3cc99e92ab$exports.PageRequest.toJSON(message.pagination) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $0309913a6a030f9f$var$createBaseQueryValidatorUnbondingDelegationsRequest();
        message.validatorAddr = object.validatorAddr ?? "";
        message.pagination = object.pagination !== undefined && object.pagination !== null ? $5eae5f3cc99e92ab$exports.PageRequest.fromPartial(object.pagination) : undefined;
        return message;
    }
};
function $0309913a6a030f9f$var$createBaseQueryValidatorUnbondingDelegationsResponse() {
    return {
        unbondingResponses: [],
        pagination: undefined
    };
}
$0309913a6a030f9f$exports.QueryValidatorUnbondingDelegationsResponse = {
    encode (message, writer = $0309913a6a030f9f$var$_m0.Writer.create()) {
        for (const v of message.unbondingResponses)$a040057dd8961d62$exports.UnbondingDelegation.encode(v, writer.uint32(10).fork()).ldelim();
        if (message.pagination !== undefined) $5eae5f3cc99e92ab$exports.PageResponse.encode(message.pagination, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $0309913a6a030f9f$var$_m0.Reader ? input : new $0309913a6a030f9f$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $0309913a6a030f9f$var$createBaseQueryValidatorUnbondingDelegationsResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.unbondingResponses.push($a040057dd8961d62$exports.UnbondingDelegation.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.pagination = $5eae5f3cc99e92ab$exports.PageResponse.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            unbondingResponses: Array.isArray(object?.unbondingResponses) ? object.unbondingResponses.map((e)=>$a040057dd8961d62$exports.UnbondingDelegation.fromJSON(e)) : [],
            pagination: (0, $d5e07fe2518aae94$exports.isSet)(object.pagination) ? $5eae5f3cc99e92ab$exports.PageResponse.fromJSON(object.pagination) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        if (message.unbondingResponses) obj.unbondingResponses = message.unbondingResponses.map((e)=>e ? $a040057dd8961d62$exports.UnbondingDelegation.toJSON(e) : undefined);
        else obj.unbondingResponses = [];
        message.pagination !== undefined && (obj.pagination = message.pagination ? $5eae5f3cc99e92ab$exports.PageResponse.toJSON(message.pagination) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $0309913a6a030f9f$var$createBaseQueryValidatorUnbondingDelegationsResponse();
        message.unbondingResponses = object.unbondingResponses?.map((e)=>$a040057dd8961d62$exports.UnbondingDelegation.fromPartial(e)) || [];
        message.pagination = object.pagination !== undefined && object.pagination !== null ? $5eae5f3cc99e92ab$exports.PageResponse.fromPartial(object.pagination) : undefined;
        return message;
    }
};
function $0309913a6a030f9f$var$createBaseQueryDelegationRequest() {
    return {
        delegatorAddr: "",
        validatorAddr: ""
    };
}
$0309913a6a030f9f$exports.QueryDelegationRequest = {
    encode (message, writer = $0309913a6a030f9f$var$_m0.Writer.create()) {
        if (message.delegatorAddr !== "") writer.uint32(10).string(message.delegatorAddr);
        if (message.validatorAddr !== "") writer.uint32(18).string(message.validatorAddr);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $0309913a6a030f9f$var$_m0.Reader ? input : new $0309913a6a030f9f$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $0309913a6a030f9f$var$createBaseQueryDelegationRequest();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.delegatorAddr = reader.string();
                    break;
                case 2:
                    message.validatorAddr = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            delegatorAddr: (0, $d5e07fe2518aae94$exports.isSet)(object.delegatorAddr) ? String(object.delegatorAddr) : "",
            validatorAddr: (0, $d5e07fe2518aae94$exports.isSet)(object.validatorAddr) ? String(object.validatorAddr) : ""
        };
    },
    toJSON (message) {
        const obj = {};
        message.delegatorAddr !== undefined && (obj.delegatorAddr = message.delegatorAddr);
        message.validatorAddr !== undefined && (obj.validatorAddr = message.validatorAddr);
        return obj;
    },
    fromPartial (object) {
        const message = $0309913a6a030f9f$var$createBaseQueryDelegationRequest();
        message.delegatorAddr = object.delegatorAddr ?? "";
        message.validatorAddr = object.validatorAddr ?? "";
        return message;
    }
};
function $0309913a6a030f9f$var$createBaseQueryDelegationResponse() {
    return {
        delegationResponse: undefined
    };
}
$0309913a6a030f9f$exports.QueryDelegationResponse = {
    encode (message, writer = $0309913a6a030f9f$var$_m0.Writer.create()) {
        if (message.delegationResponse !== undefined) $a040057dd8961d62$exports.DelegationResponse.encode(message.delegationResponse, writer.uint32(10).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $0309913a6a030f9f$var$_m0.Reader ? input : new $0309913a6a030f9f$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $0309913a6a030f9f$var$createBaseQueryDelegationResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.delegationResponse = $a040057dd8961d62$exports.DelegationResponse.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            delegationResponse: (0, $d5e07fe2518aae94$exports.isSet)(object.delegationResponse) ? $a040057dd8961d62$exports.DelegationResponse.fromJSON(object.delegationResponse) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.delegationResponse !== undefined && (obj.delegationResponse = message.delegationResponse ? $a040057dd8961d62$exports.DelegationResponse.toJSON(message.delegationResponse) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $0309913a6a030f9f$var$createBaseQueryDelegationResponse();
        message.delegationResponse = object.delegationResponse !== undefined && object.delegationResponse !== null ? $a040057dd8961d62$exports.DelegationResponse.fromPartial(object.delegationResponse) : undefined;
        return message;
    }
};
function $0309913a6a030f9f$var$createBaseQueryUnbondingDelegationRequest() {
    return {
        delegatorAddr: "",
        validatorAddr: ""
    };
}
$0309913a6a030f9f$exports.QueryUnbondingDelegationRequest = {
    encode (message, writer = $0309913a6a030f9f$var$_m0.Writer.create()) {
        if (message.delegatorAddr !== "") writer.uint32(10).string(message.delegatorAddr);
        if (message.validatorAddr !== "") writer.uint32(18).string(message.validatorAddr);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $0309913a6a030f9f$var$_m0.Reader ? input : new $0309913a6a030f9f$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $0309913a6a030f9f$var$createBaseQueryUnbondingDelegationRequest();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.delegatorAddr = reader.string();
                    break;
                case 2:
                    message.validatorAddr = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            delegatorAddr: (0, $d5e07fe2518aae94$exports.isSet)(object.delegatorAddr) ? String(object.delegatorAddr) : "",
            validatorAddr: (0, $d5e07fe2518aae94$exports.isSet)(object.validatorAddr) ? String(object.validatorAddr) : ""
        };
    },
    toJSON (message) {
        const obj = {};
        message.delegatorAddr !== undefined && (obj.delegatorAddr = message.delegatorAddr);
        message.validatorAddr !== undefined && (obj.validatorAddr = message.validatorAddr);
        return obj;
    },
    fromPartial (object) {
        const message = $0309913a6a030f9f$var$createBaseQueryUnbondingDelegationRequest();
        message.delegatorAddr = object.delegatorAddr ?? "";
        message.validatorAddr = object.validatorAddr ?? "";
        return message;
    }
};
function $0309913a6a030f9f$var$createBaseQueryUnbondingDelegationResponse() {
    return {
        unbond: undefined
    };
}
$0309913a6a030f9f$exports.QueryUnbondingDelegationResponse = {
    encode (message, writer = $0309913a6a030f9f$var$_m0.Writer.create()) {
        if (message.unbond !== undefined) $a040057dd8961d62$exports.UnbondingDelegation.encode(message.unbond, writer.uint32(10).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $0309913a6a030f9f$var$_m0.Reader ? input : new $0309913a6a030f9f$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $0309913a6a030f9f$var$createBaseQueryUnbondingDelegationResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.unbond = $a040057dd8961d62$exports.UnbondingDelegation.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            unbond: (0, $d5e07fe2518aae94$exports.isSet)(object.unbond) ? $a040057dd8961d62$exports.UnbondingDelegation.fromJSON(object.unbond) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.unbond !== undefined && (obj.unbond = message.unbond ? $a040057dd8961d62$exports.UnbondingDelegation.toJSON(message.unbond) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $0309913a6a030f9f$var$createBaseQueryUnbondingDelegationResponse();
        message.unbond = object.unbond !== undefined && object.unbond !== null ? $a040057dd8961d62$exports.UnbondingDelegation.fromPartial(object.unbond) : undefined;
        return message;
    }
};
function $0309913a6a030f9f$var$createBaseQueryDelegatorDelegationsRequest() {
    return {
        delegatorAddr: "",
        pagination: undefined
    };
}
$0309913a6a030f9f$exports.QueryDelegatorDelegationsRequest = {
    encode (message, writer = $0309913a6a030f9f$var$_m0.Writer.create()) {
        if (message.delegatorAddr !== "") writer.uint32(10).string(message.delegatorAddr);
        if (message.pagination !== undefined) $5eae5f3cc99e92ab$exports.PageRequest.encode(message.pagination, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $0309913a6a030f9f$var$_m0.Reader ? input : new $0309913a6a030f9f$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $0309913a6a030f9f$var$createBaseQueryDelegatorDelegationsRequest();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.delegatorAddr = reader.string();
                    break;
                case 2:
                    message.pagination = $5eae5f3cc99e92ab$exports.PageRequest.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            delegatorAddr: (0, $d5e07fe2518aae94$exports.isSet)(object.delegatorAddr) ? String(object.delegatorAddr) : "",
            pagination: (0, $d5e07fe2518aae94$exports.isSet)(object.pagination) ? $5eae5f3cc99e92ab$exports.PageRequest.fromJSON(object.pagination) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.delegatorAddr !== undefined && (obj.delegatorAddr = message.delegatorAddr);
        message.pagination !== undefined && (obj.pagination = message.pagination ? $5eae5f3cc99e92ab$exports.PageRequest.toJSON(message.pagination) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $0309913a6a030f9f$var$createBaseQueryDelegatorDelegationsRequest();
        message.delegatorAddr = object.delegatorAddr ?? "";
        message.pagination = object.pagination !== undefined && object.pagination !== null ? $5eae5f3cc99e92ab$exports.PageRequest.fromPartial(object.pagination) : undefined;
        return message;
    }
};
function $0309913a6a030f9f$var$createBaseQueryDelegatorDelegationsResponse() {
    return {
        delegationResponses: [],
        pagination: undefined
    };
}
$0309913a6a030f9f$exports.QueryDelegatorDelegationsResponse = {
    encode (message, writer = $0309913a6a030f9f$var$_m0.Writer.create()) {
        for (const v of message.delegationResponses)$a040057dd8961d62$exports.DelegationResponse.encode(v, writer.uint32(10).fork()).ldelim();
        if (message.pagination !== undefined) $5eae5f3cc99e92ab$exports.PageResponse.encode(message.pagination, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $0309913a6a030f9f$var$_m0.Reader ? input : new $0309913a6a030f9f$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $0309913a6a030f9f$var$createBaseQueryDelegatorDelegationsResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.delegationResponses.push($a040057dd8961d62$exports.DelegationResponse.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.pagination = $5eae5f3cc99e92ab$exports.PageResponse.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            delegationResponses: Array.isArray(object?.delegationResponses) ? object.delegationResponses.map((e)=>$a040057dd8961d62$exports.DelegationResponse.fromJSON(e)) : [],
            pagination: (0, $d5e07fe2518aae94$exports.isSet)(object.pagination) ? $5eae5f3cc99e92ab$exports.PageResponse.fromJSON(object.pagination) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        if (message.delegationResponses) obj.delegationResponses = message.delegationResponses.map((e)=>e ? $a040057dd8961d62$exports.DelegationResponse.toJSON(e) : undefined);
        else obj.delegationResponses = [];
        message.pagination !== undefined && (obj.pagination = message.pagination ? $5eae5f3cc99e92ab$exports.PageResponse.toJSON(message.pagination) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $0309913a6a030f9f$var$createBaseQueryDelegatorDelegationsResponse();
        message.delegationResponses = object.delegationResponses?.map((e)=>$a040057dd8961d62$exports.DelegationResponse.fromPartial(e)) || [];
        message.pagination = object.pagination !== undefined && object.pagination !== null ? $5eae5f3cc99e92ab$exports.PageResponse.fromPartial(object.pagination) : undefined;
        return message;
    }
};
function $0309913a6a030f9f$var$createBaseQueryDelegatorUnbondingDelegationsRequest() {
    return {
        delegatorAddr: "",
        pagination: undefined
    };
}
$0309913a6a030f9f$exports.QueryDelegatorUnbondingDelegationsRequest = {
    encode (message, writer = $0309913a6a030f9f$var$_m0.Writer.create()) {
        if (message.delegatorAddr !== "") writer.uint32(10).string(message.delegatorAddr);
        if (message.pagination !== undefined) $5eae5f3cc99e92ab$exports.PageRequest.encode(message.pagination, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $0309913a6a030f9f$var$_m0.Reader ? input : new $0309913a6a030f9f$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $0309913a6a030f9f$var$createBaseQueryDelegatorUnbondingDelegationsRequest();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.delegatorAddr = reader.string();
                    break;
                case 2:
                    message.pagination = $5eae5f3cc99e92ab$exports.PageRequest.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            delegatorAddr: (0, $d5e07fe2518aae94$exports.isSet)(object.delegatorAddr) ? String(object.delegatorAddr) : "",
            pagination: (0, $d5e07fe2518aae94$exports.isSet)(object.pagination) ? $5eae5f3cc99e92ab$exports.PageRequest.fromJSON(object.pagination) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.delegatorAddr !== undefined && (obj.delegatorAddr = message.delegatorAddr);
        message.pagination !== undefined && (obj.pagination = message.pagination ? $5eae5f3cc99e92ab$exports.PageRequest.toJSON(message.pagination) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $0309913a6a030f9f$var$createBaseQueryDelegatorUnbondingDelegationsRequest();
        message.delegatorAddr = object.delegatorAddr ?? "";
        message.pagination = object.pagination !== undefined && object.pagination !== null ? $5eae5f3cc99e92ab$exports.PageRequest.fromPartial(object.pagination) : undefined;
        return message;
    }
};
function $0309913a6a030f9f$var$createBaseQueryDelegatorUnbondingDelegationsResponse() {
    return {
        unbondingResponses: [],
        pagination: undefined
    };
}
$0309913a6a030f9f$exports.QueryDelegatorUnbondingDelegationsResponse = {
    encode (message, writer = $0309913a6a030f9f$var$_m0.Writer.create()) {
        for (const v of message.unbondingResponses)$a040057dd8961d62$exports.UnbondingDelegation.encode(v, writer.uint32(10).fork()).ldelim();
        if (message.pagination !== undefined) $5eae5f3cc99e92ab$exports.PageResponse.encode(message.pagination, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $0309913a6a030f9f$var$_m0.Reader ? input : new $0309913a6a030f9f$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $0309913a6a030f9f$var$createBaseQueryDelegatorUnbondingDelegationsResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.unbondingResponses.push($a040057dd8961d62$exports.UnbondingDelegation.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.pagination = $5eae5f3cc99e92ab$exports.PageResponse.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            unbondingResponses: Array.isArray(object?.unbondingResponses) ? object.unbondingResponses.map((e)=>$a040057dd8961d62$exports.UnbondingDelegation.fromJSON(e)) : [],
            pagination: (0, $d5e07fe2518aae94$exports.isSet)(object.pagination) ? $5eae5f3cc99e92ab$exports.PageResponse.fromJSON(object.pagination) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        if (message.unbondingResponses) obj.unbondingResponses = message.unbondingResponses.map((e)=>e ? $a040057dd8961d62$exports.UnbondingDelegation.toJSON(e) : undefined);
        else obj.unbondingResponses = [];
        message.pagination !== undefined && (obj.pagination = message.pagination ? $5eae5f3cc99e92ab$exports.PageResponse.toJSON(message.pagination) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $0309913a6a030f9f$var$createBaseQueryDelegatorUnbondingDelegationsResponse();
        message.unbondingResponses = object.unbondingResponses?.map((e)=>$a040057dd8961d62$exports.UnbondingDelegation.fromPartial(e)) || [];
        message.pagination = object.pagination !== undefined && object.pagination !== null ? $5eae5f3cc99e92ab$exports.PageResponse.fromPartial(object.pagination) : undefined;
        return message;
    }
};
function $0309913a6a030f9f$var$createBaseQueryRedelegationsRequest() {
    return {
        delegatorAddr: "",
        srcValidatorAddr: "",
        dstValidatorAddr: "",
        pagination: undefined
    };
}
$0309913a6a030f9f$exports.QueryRedelegationsRequest = {
    encode (message, writer = $0309913a6a030f9f$var$_m0.Writer.create()) {
        if (message.delegatorAddr !== "") writer.uint32(10).string(message.delegatorAddr);
        if (message.srcValidatorAddr !== "") writer.uint32(18).string(message.srcValidatorAddr);
        if (message.dstValidatorAddr !== "") writer.uint32(26).string(message.dstValidatorAddr);
        if (message.pagination !== undefined) $5eae5f3cc99e92ab$exports.PageRequest.encode(message.pagination, writer.uint32(34).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $0309913a6a030f9f$var$_m0.Reader ? input : new $0309913a6a030f9f$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $0309913a6a030f9f$var$createBaseQueryRedelegationsRequest();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.delegatorAddr = reader.string();
                    break;
                case 2:
                    message.srcValidatorAddr = reader.string();
                    break;
                case 3:
                    message.dstValidatorAddr = reader.string();
                    break;
                case 4:
                    message.pagination = $5eae5f3cc99e92ab$exports.PageRequest.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            delegatorAddr: (0, $d5e07fe2518aae94$exports.isSet)(object.delegatorAddr) ? String(object.delegatorAddr) : "",
            srcValidatorAddr: (0, $d5e07fe2518aae94$exports.isSet)(object.srcValidatorAddr) ? String(object.srcValidatorAddr) : "",
            dstValidatorAddr: (0, $d5e07fe2518aae94$exports.isSet)(object.dstValidatorAddr) ? String(object.dstValidatorAddr) : "",
            pagination: (0, $d5e07fe2518aae94$exports.isSet)(object.pagination) ? $5eae5f3cc99e92ab$exports.PageRequest.fromJSON(object.pagination) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.delegatorAddr !== undefined && (obj.delegatorAddr = message.delegatorAddr);
        message.srcValidatorAddr !== undefined && (obj.srcValidatorAddr = message.srcValidatorAddr);
        message.dstValidatorAddr !== undefined && (obj.dstValidatorAddr = message.dstValidatorAddr);
        message.pagination !== undefined && (obj.pagination = message.pagination ? $5eae5f3cc99e92ab$exports.PageRequest.toJSON(message.pagination) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $0309913a6a030f9f$var$createBaseQueryRedelegationsRequest();
        message.delegatorAddr = object.delegatorAddr ?? "";
        message.srcValidatorAddr = object.srcValidatorAddr ?? "";
        message.dstValidatorAddr = object.dstValidatorAddr ?? "";
        message.pagination = object.pagination !== undefined && object.pagination !== null ? $5eae5f3cc99e92ab$exports.PageRequest.fromPartial(object.pagination) : undefined;
        return message;
    }
};
function $0309913a6a030f9f$var$createBaseQueryRedelegationsResponse() {
    return {
        redelegationResponses: [],
        pagination: undefined
    };
}
$0309913a6a030f9f$exports.QueryRedelegationsResponse = {
    encode (message, writer = $0309913a6a030f9f$var$_m0.Writer.create()) {
        for (const v of message.redelegationResponses)$a040057dd8961d62$exports.RedelegationResponse.encode(v, writer.uint32(10).fork()).ldelim();
        if (message.pagination !== undefined) $5eae5f3cc99e92ab$exports.PageResponse.encode(message.pagination, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $0309913a6a030f9f$var$_m0.Reader ? input : new $0309913a6a030f9f$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $0309913a6a030f9f$var$createBaseQueryRedelegationsResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.redelegationResponses.push($a040057dd8961d62$exports.RedelegationResponse.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.pagination = $5eae5f3cc99e92ab$exports.PageResponse.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            redelegationResponses: Array.isArray(object?.redelegationResponses) ? object.redelegationResponses.map((e)=>$a040057dd8961d62$exports.RedelegationResponse.fromJSON(e)) : [],
            pagination: (0, $d5e07fe2518aae94$exports.isSet)(object.pagination) ? $5eae5f3cc99e92ab$exports.PageResponse.fromJSON(object.pagination) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        if (message.redelegationResponses) obj.redelegationResponses = message.redelegationResponses.map((e)=>e ? $a040057dd8961d62$exports.RedelegationResponse.toJSON(e) : undefined);
        else obj.redelegationResponses = [];
        message.pagination !== undefined && (obj.pagination = message.pagination ? $5eae5f3cc99e92ab$exports.PageResponse.toJSON(message.pagination) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $0309913a6a030f9f$var$createBaseQueryRedelegationsResponse();
        message.redelegationResponses = object.redelegationResponses?.map((e)=>$a040057dd8961d62$exports.RedelegationResponse.fromPartial(e)) || [];
        message.pagination = object.pagination !== undefined && object.pagination !== null ? $5eae5f3cc99e92ab$exports.PageResponse.fromPartial(object.pagination) : undefined;
        return message;
    }
};
function $0309913a6a030f9f$var$createBaseQueryDelegatorValidatorsRequest() {
    return {
        delegatorAddr: "",
        pagination: undefined
    };
}
$0309913a6a030f9f$exports.QueryDelegatorValidatorsRequest = {
    encode (message, writer = $0309913a6a030f9f$var$_m0.Writer.create()) {
        if (message.delegatorAddr !== "") writer.uint32(10).string(message.delegatorAddr);
        if (message.pagination !== undefined) $5eae5f3cc99e92ab$exports.PageRequest.encode(message.pagination, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $0309913a6a030f9f$var$_m0.Reader ? input : new $0309913a6a030f9f$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $0309913a6a030f9f$var$createBaseQueryDelegatorValidatorsRequest();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.delegatorAddr = reader.string();
                    break;
                case 2:
                    message.pagination = $5eae5f3cc99e92ab$exports.PageRequest.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            delegatorAddr: (0, $d5e07fe2518aae94$exports.isSet)(object.delegatorAddr) ? String(object.delegatorAddr) : "",
            pagination: (0, $d5e07fe2518aae94$exports.isSet)(object.pagination) ? $5eae5f3cc99e92ab$exports.PageRequest.fromJSON(object.pagination) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.delegatorAddr !== undefined && (obj.delegatorAddr = message.delegatorAddr);
        message.pagination !== undefined && (obj.pagination = message.pagination ? $5eae5f3cc99e92ab$exports.PageRequest.toJSON(message.pagination) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $0309913a6a030f9f$var$createBaseQueryDelegatorValidatorsRequest();
        message.delegatorAddr = object.delegatorAddr ?? "";
        message.pagination = object.pagination !== undefined && object.pagination !== null ? $5eae5f3cc99e92ab$exports.PageRequest.fromPartial(object.pagination) : undefined;
        return message;
    }
};
function $0309913a6a030f9f$var$createBaseQueryDelegatorValidatorsResponse() {
    return {
        validators: [],
        pagination: undefined
    };
}
$0309913a6a030f9f$exports.QueryDelegatorValidatorsResponse = {
    encode (message, writer = $0309913a6a030f9f$var$_m0.Writer.create()) {
        for (const v of message.validators)$a040057dd8961d62$exports.Validator.encode(v, writer.uint32(10).fork()).ldelim();
        if (message.pagination !== undefined) $5eae5f3cc99e92ab$exports.PageResponse.encode(message.pagination, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $0309913a6a030f9f$var$_m0.Reader ? input : new $0309913a6a030f9f$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $0309913a6a030f9f$var$createBaseQueryDelegatorValidatorsResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.validators.push($a040057dd8961d62$exports.Validator.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.pagination = $5eae5f3cc99e92ab$exports.PageResponse.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            validators: Array.isArray(object?.validators) ? object.validators.map((e)=>$a040057dd8961d62$exports.Validator.fromJSON(e)) : [],
            pagination: (0, $d5e07fe2518aae94$exports.isSet)(object.pagination) ? $5eae5f3cc99e92ab$exports.PageResponse.fromJSON(object.pagination) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        if (message.validators) obj.validators = message.validators.map((e)=>e ? $a040057dd8961d62$exports.Validator.toJSON(e) : undefined);
        else obj.validators = [];
        message.pagination !== undefined && (obj.pagination = message.pagination ? $5eae5f3cc99e92ab$exports.PageResponse.toJSON(message.pagination) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $0309913a6a030f9f$var$createBaseQueryDelegatorValidatorsResponse();
        message.validators = object.validators?.map((e)=>$a040057dd8961d62$exports.Validator.fromPartial(e)) || [];
        message.pagination = object.pagination !== undefined && object.pagination !== null ? $5eae5f3cc99e92ab$exports.PageResponse.fromPartial(object.pagination) : undefined;
        return message;
    }
};
function $0309913a6a030f9f$var$createBaseQueryDelegatorValidatorRequest() {
    return {
        delegatorAddr: "",
        validatorAddr: ""
    };
}
$0309913a6a030f9f$exports.QueryDelegatorValidatorRequest = {
    encode (message, writer = $0309913a6a030f9f$var$_m0.Writer.create()) {
        if (message.delegatorAddr !== "") writer.uint32(10).string(message.delegatorAddr);
        if (message.validatorAddr !== "") writer.uint32(18).string(message.validatorAddr);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $0309913a6a030f9f$var$_m0.Reader ? input : new $0309913a6a030f9f$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $0309913a6a030f9f$var$createBaseQueryDelegatorValidatorRequest();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.delegatorAddr = reader.string();
                    break;
                case 2:
                    message.validatorAddr = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            delegatorAddr: (0, $d5e07fe2518aae94$exports.isSet)(object.delegatorAddr) ? String(object.delegatorAddr) : "",
            validatorAddr: (0, $d5e07fe2518aae94$exports.isSet)(object.validatorAddr) ? String(object.validatorAddr) : ""
        };
    },
    toJSON (message) {
        const obj = {};
        message.delegatorAddr !== undefined && (obj.delegatorAddr = message.delegatorAddr);
        message.validatorAddr !== undefined && (obj.validatorAddr = message.validatorAddr);
        return obj;
    },
    fromPartial (object) {
        const message = $0309913a6a030f9f$var$createBaseQueryDelegatorValidatorRequest();
        message.delegatorAddr = object.delegatorAddr ?? "";
        message.validatorAddr = object.validatorAddr ?? "";
        return message;
    }
};
function $0309913a6a030f9f$var$createBaseQueryDelegatorValidatorResponse() {
    return {
        validator: undefined
    };
}
$0309913a6a030f9f$exports.QueryDelegatorValidatorResponse = {
    encode (message, writer = $0309913a6a030f9f$var$_m0.Writer.create()) {
        if (message.validator !== undefined) $a040057dd8961d62$exports.Validator.encode(message.validator, writer.uint32(10).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $0309913a6a030f9f$var$_m0.Reader ? input : new $0309913a6a030f9f$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $0309913a6a030f9f$var$createBaseQueryDelegatorValidatorResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.validator = $a040057dd8961d62$exports.Validator.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            validator: (0, $d5e07fe2518aae94$exports.isSet)(object.validator) ? $a040057dd8961d62$exports.Validator.fromJSON(object.validator) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.validator !== undefined && (obj.validator = message.validator ? $a040057dd8961d62$exports.Validator.toJSON(message.validator) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $0309913a6a030f9f$var$createBaseQueryDelegatorValidatorResponse();
        message.validator = object.validator !== undefined && object.validator !== null ? $a040057dd8961d62$exports.Validator.fromPartial(object.validator) : undefined;
        return message;
    }
};
function $0309913a6a030f9f$var$createBaseQueryHistoricalInfoRequest() {
    return {
        height: $d5e07fe2518aae94$exports.Long.ZERO
    };
}
$0309913a6a030f9f$exports.QueryHistoricalInfoRequest = {
    encode (message, writer = $0309913a6a030f9f$var$_m0.Writer.create()) {
        if (!message.height.isZero()) writer.uint32(8).int64(message.height);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $0309913a6a030f9f$var$_m0.Reader ? input : new $0309913a6a030f9f$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $0309913a6a030f9f$var$createBaseQueryHistoricalInfoRequest();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.height = reader.int64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            height: (0, $d5e07fe2518aae94$exports.isSet)(object.height) ? $d5e07fe2518aae94$exports.Long.fromValue(object.height) : $d5e07fe2518aae94$exports.Long.ZERO
        };
    },
    toJSON (message) {
        const obj = {};
        message.height !== undefined && (obj.height = (message.height || $d5e07fe2518aae94$exports.Long.ZERO).toString());
        return obj;
    },
    fromPartial (object) {
        const message = $0309913a6a030f9f$var$createBaseQueryHistoricalInfoRequest();
        message.height = object.height !== undefined && object.height !== null ? $d5e07fe2518aae94$exports.Long.fromValue(object.height) : $d5e07fe2518aae94$exports.Long.ZERO;
        return message;
    }
};
function $0309913a6a030f9f$var$createBaseQueryHistoricalInfoResponse() {
    return {
        hist: undefined
    };
}
$0309913a6a030f9f$exports.QueryHistoricalInfoResponse = {
    encode (message, writer = $0309913a6a030f9f$var$_m0.Writer.create()) {
        if (message.hist !== undefined) $a040057dd8961d62$exports.HistoricalInfo.encode(message.hist, writer.uint32(10).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $0309913a6a030f9f$var$_m0.Reader ? input : new $0309913a6a030f9f$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $0309913a6a030f9f$var$createBaseQueryHistoricalInfoResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.hist = $a040057dd8961d62$exports.HistoricalInfo.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            hist: (0, $d5e07fe2518aae94$exports.isSet)(object.hist) ? $a040057dd8961d62$exports.HistoricalInfo.fromJSON(object.hist) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.hist !== undefined && (obj.hist = message.hist ? $a040057dd8961d62$exports.HistoricalInfo.toJSON(message.hist) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $0309913a6a030f9f$var$createBaseQueryHistoricalInfoResponse();
        message.hist = object.hist !== undefined && object.hist !== null ? $a040057dd8961d62$exports.HistoricalInfo.fromPartial(object.hist) : undefined;
        return message;
    }
};
function $0309913a6a030f9f$var$createBaseQueryPoolRequest() {
    return {};
}
$0309913a6a030f9f$exports.QueryPoolRequest = {
    encode (_, writer = $0309913a6a030f9f$var$_m0.Writer.create()) {
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $0309913a6a030f9f$var$_m0.Reader ? input : new $0309913a6a030f9f$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $0309913a6a030f9f$var$createBaseQueryPoolRequest();
        while(reader.pos < end){
            const tag = reader.uint32();
            tag;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON (_) {
        return {};
    },
    toJSON (_) {
        const obj = {};
        return obj;
    },
    fromPartial (_) {
        const message = $0309913a6a030f9f$var$createBaseQueryPoolRequest();
        return message;
    }
};
function $0309913a6a030f9f$var$createBaseQueryPoolResponse() {
    return {
        pool: undefined
    };
}
$0309913a6a030f9f$exports.QueryPoolResponse = {
    encode (message, writer = $0309913a6a030f9f$var$_m0.Writer.create()) {
        if (message.pool !== undefined) $a040057dd8961d62$exports.Pool.encode(message.pool, writer.uint32(10).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $0309913a6a030f9f$var$_m0.Reader ? input : new $0309913a6a030f9f$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $0309913a6a030f9f$var$createBaseQueryPoolResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.pool = $a040057dd8961d62$exports.Pool.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            pool: (0, $d5e07fe2518aae94$exports.isSet)(object.pool) ? $a040057dd8961d62$exports.Pool.fromJSON(object.pool) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.pool !== undefined && (obj.pool = message.pool ? $a040057dd8961d62$exports.Pool.toJSON(message.pool) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $0309913a6a030f9f$var$createBaseQueryPoolResponse();
        message.pool = object.pool !== undefined && object.pool !== null ? $a040057dd8961d62$exports.Pool.fromPartial(object.pool) : undefined;
        return message;
    }
};
function $0309913a6a030f9f$var$createBaseQueryParamsRequest() {
    return {};
}
$0309913a6a030f9f$exports.QueryParamsRequest = {
    encode (_, writer = $0309913a6a030f9f$var$_m0.Writer.create()) {
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $0309913a6a030f9f$var$_m0.Reader ? input : new $0309913a6a030f9f$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $0309913a6a030f9f$var$createBaseQueryParamsRequest();
        while(reader.pos < end){
            const tag = reader.uint32();
            tag;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON (_) {
        return {};
    },
    toJSON (_) {
        const obj = {};
        return obj;
    },
    fromPartial (_) {
        const message = $0309913a6a030f9f$var$createBaseQueryParamsRequest();
        return message;
    }
};
function $0309913a6a030f9f$var$createBaseQueryParamsResponse() {
    return {
        params: undefined
    };
}
$0309913a6a030f9f$exports.QueryParamsResponse = {
    encode (message, writer = $0309913a6a030f9f$var$_m0.Writer.create()) {
        if (message.params !== undefined) $a040057dd8961d62$exports.Params.encode(message.params, writer.uint32(10).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $0309913a6a030f9f$var$_m0.Reader ? input : new $0309913a6a030f9f$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $0309913a6a030f9f$var$createBaseQueryParamsResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.params = $a040057dd8961d62$exports.Params.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            params: (0, $d5e07fe2518aae94$exports.isSet)(object.params) ? $a040057dd8961d62$exports.Params.fromJSON(object.params) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.params !== undefined && (obj.params = message.params ? $a040057dd8961d62$exports.Params.toJSON(message.params) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $0309913a6a030f9f$var$createBaseQueryParamsResponse();
        message.params = object.params !== undefined && object.params !== null ? $a040057dd8961d62$exports.Params.fromPartial(object.params) : undefined;
        return message;
    }
};
class $0309913a6a030f9f$var$QueryClientImpl {
    constructor(rpc){
        this.rpc = rpc;
        this.Validators = this.Validators.bind(this);
        this.Validator = this.Validator.bind(this);
        this.ValidatorDelegations = this.ValidatorDelegations.bind(this);
        this.ValidatorUnbondingDelegations = this.ValidatorUnbondingDelegations.bind(this);
        this.Delegation = this.Delegation.bind(this);
        this.UnbondingDelegation = this.UnbondingDelegation.bind(this);
        this.DelegatorDelegations = this.DelegatorDelegations.bind(this);
        this.DelegatorUnbondingDelegations = this.DelegatorUnbondingDelegations.bind(this);
        this.Redelegations = this.Redelegations.bind(this);
        this.DelegatorValidators = this.DelegatorValidators.bind(this);
        this.DelegatorValidator = this.DelegatorValidator.bind(this);
        this.HistoricalInfo = this.HistoricalInfo.bind(this);
        this.Pool = this.Pool.bind(this);
        this.Params = this.Params.bind(this);
    }
    Validators(request) {
        const data = $0309913a6a030f9f$exports.QueryValidatorsRequest.encode(request).finish();
        const promise = this.rpc.request("cosmos.staking.v1beta1.Query", "Validators", data);
        return promise.then((data)=>$0309913a6a030f9f$exports.QueryValidatorsResponse.decode(new $0309913a6a030f9f$var$_m0.Reader(data)));
    }
    Validator(request) {
        const data = $0309913a6a030f9f$exports.QueryValidatorRequest.encode(request).finish();
        const promise = this.rpc.request("cosmos.staking.v1beta1.Query", "Validator", data);
        return promise.then((data)=>$0309913a6a030f9f$exports.QueryValidatorResponse.decode(new $0309913a6a030f9f$var$_m0.Reader(data)));
    }
    ValidatorDelegations(request) {
        const data = $0309913a6a030f9f$exports.QueryValidatorDelegationsRequest.encode(request).finish();
        const promise = this.rpc.request("cosmos.staking.v1beta1.Query", "ValidatorDelegations", data);
        return promise.then((data)=>$0309913a6a030f9f$exports.QueryValidatorDelegationsResponse.decode(new $0309913a6a030f9f$var$_m0.Reader(data)));
    }
    ValidatorUnbondingDelegations(request) {
        const data = $0309913a6a030f9f$exports.QueryValidatorUnbondingDelegationsRequest.encode(request).finish();
        const promise = this.rpc.request("cosmos.staking.v1beta1.Query", "ValidatorUnbondingDelegations", data);
        return promise.then((data)=>$0309913a6a030f9f$exports.QueryValidatorUnbondingDelegationsResponse.decode(new $0309913a6a030f9f$var$_m0.Reader(data)));
    }
    Delegation(request) {
        const data = $0309913a6a030f9f$exports.QueryDelegationRequest.encode(request).finish();
        const promise = this.rpc.request("cosmos.staking.v1beta1.Query", "Delegation", data);
        return promise.then((data)=>$0309913a6a030f9f$exports.QueryDelegationResponse.decode(new $0309913a6a030f9f$var$_m0.Reader(data)));
    }
    UnbondingDelegation(request) {
        const data = $0309913a6a030f9f$exports.QueryUnbondingDelegationRequest.encode(request).finish();
        const promise = this.rpc.request("cosmos.staking.v1beta1.Query", "UnbondingDelegation", data);
        return promise.then((data)=>$0309913a6a030f9f$exports.QueryUnbondingDelegationResponse.decode(new $0309913a6a030f9f$var$_m0.Reader(data)));
    }
    DelegatorDelegations(request) {
        const data = $0309913a6a030f9f$exports.QueryDelegatorDelegationsRequest.encode(request).finish();
        const promise = this.rpc.request("cosmos.staking.v1beta1.Query", "DelegatorDelegations", data);
        return promise.then((data)=>$0309913a6a030f9f$exports.QueryDelegatorDelegationsResponse.decode(new $0309913a6a030f9f$var$_m0.Reader(data)));
    }
    DelegatorUnbondingDelegations(request) {
        const data = $0309913a6a030f9f$exports.QueryDelegatorUnbondingDelegationsRequest.encode(request).finish();
        const promise = this.rpc.request("cosmos.staking.v1beta1.Query", "DelegatorUnbondingDelegations", data);
        return promise.then((data)=>$0309913a6a030f9f$exports.QueryDelegatorUnbondingDelegationsResponse.decode(new $0309913a6a030f9f$var$_m0.Reader(data)));
    }
    Redelegations(request) {
        const data = $0309913a6a030f9f$exports.QueryRedelegationsRequest.encode(request).finish();
        const promise = this.rpc.request("cosmos.staking.v1beta1.Query", "Redelegations", data);
        return promise.then((data)=>$0309913a6a030f9f$exports.QueryRedelegationsResponse.decode(new $0309913a6a030f9f$var$_m0.Reader(data)));
    }
    DelegatorValidators(request) {
        const data = $0309913a6a030f9f$exports.QueryDelegatorValidatorsRequest.encode(request).finish();
        const promise = this.rpc.request("cosmos.staking.v1beta1.Query", "DelegatorValidators", data);
        return promise.then((data)=>$0309913a6a030f9f$exports.QueryDelegatorValidatorsResponse.decode(new $0309913a6a030f9f$var$_m0.Reader(data)));
    }
    DelegatorValidator(request) {
        const data = $0309913a6a030f9f$exports.QueryDelegatorValidatorRequest.encode(request).finish();
        const promise = this.rpc.request("cosmos.staking.v1beta1.Query", "DelegatorValidator", data);
        return promise.then((data)=>$0309913a6a030f9f$exports.QueryDelegatorValidatorResponse.decode(new $0309913a6a030f9f$var$_m0.Reader(data)));
    }
    HistoricalInfo(request) {
        const data = $0309913a6a030f9f$exports.QueryHistoricalInfoRequest.encode(request).finish();
        const promise = this.rpc.request("cosmos.staking.v1beta1.Query", "HistoricalInfo", data);
        return promise.then((data)=>$0309913a6a030f9f$exports.QueryHistoricalInfoResponse.decode(new $0309913a6a030f9f$var$_m0.Reader(data)));
    }
    Pool(request = {}) {
        const data = $0309913a6a030f9f$exports.QueryPoolRequest.encode(request).finish();
        const promise = this.rpc.request("cosmos.staking.v1beta1.Query", "Pool", data);
        return promise.then((data)=>$0309913a6a030f9f$exports.QueryPoolResponse.decode(new $0309913a6a030f9f$var$_m0.Reader(data)));
    }
    Params(request = {}) {
        const data = $0309913a6a030f9f$exports.QueryParamsRequest.encode(request).finish();
        const promise = this.rpc.request("cosmos.staking.v1beta1.Query", "Params", data);
        return promise.then((data)=>$0309913a6a030f9f$exports.QueryParamsResponse.decode(new $0309913a6a030f9f$var$_m0.Reader(data)));
    }
}
$0309913a6a030f9f$exports.QueryClientImpl = $0309913a6a030f9f$var$QueryClientImpl;



const $3d81be017edc450a$var$long_1 = $3d81be017edc450a$var$__importDefault((parcelRequire("jRkuS")));

function $3d81be017edc450a$var$setupStakingExtension(base) {
    // Use this service to get easy typed access to query methods
    // This cannot be used for proof verification
    const rpc = (0, $a3959936d2cce854$exports.createProtobufRpcClient)(base);
    const queryService = new $0309913a6a030f9f$exports.QueryClientImpl(rpc);
    return {
        staking: {
            delegation: async (delegatorAddress, validatorAddress)=>{
                const response = await queryService.Delegation({
                    delegatorAddr: delegatorAddress,
                    validatorAddr: validatorAddress
                });
                return response;
            },
            delegatorDelegations: async (delegatorAddress, paginationKey)=>{
                const response = await queryService.DelegatorDelegations({
                    delegatorAddr: delegatorAddress,
                    pagination: (0, $a3959936d2cce854$exports.createPagination)(paginationKey)
                });
                return response;
            },
            delegatorUnbondingDelegations: async (delegatorAddress, paginationKey)=>{
                const response = await queryService.DelegatorUnbondingDelegations({
                    delegatorAddr: delegatorAddress,
                    pagination: (0, $a3959936d2cce854$exports.createPagination)(paginationKey)
                });
                return response;
            },
            delegatorValidator: async (delegatorAddress, validatorAddress)=>{
                const response = await queryService.DelegatorValidator({
                    delegatorAddr: delegatorAddress,
                    validatorAddr: validatorAddress
                });
                return response;
            },
            delegatorValidators: async (delegatorAddress, paginationKey)=>{
                const response = await queryService.DelegatorValidators({
                    delegatorAddr: delegatorAddress,
                    pagination: (0, $a3959936d2cce854$exports.createPagination)(paginationKey)
                });
                return response;
            },
            historicalInfo: async (height)=>{
                const response = await queryService.HistoricalInfo({
                    height: $3d81be017edc450a$var$long_1.default.fromNumber(height, true)
                });
                return response;
            },
            params: async ()=>{
                const response = await queryService.Params({});
                return response;
            },
            pool: async ()=>{
                const response = await queryService.Pool({});
                return response;
            },
            redelegations: async (delegatorAddress, sourceValidatorAddress, destinationValidatorAddress, paginationKey)=>{
                const response = await queryService.Redelegations({
                    delegatorAddr: delegatorAddress,
                    srcValidatorAddr: sourceValidatorAddress,
                    dstValidatorAddr: destinationValidatorAddress,
                    pagination: (0, $a3959936d2cce854$exports.createPagination)(paginationKey)
                });
                return response;
            },
            unbondingDelegation: async (delegatorAddress, validatorAddress)=>{
                const response = await queryService.UnbondingDelegation({
                    delegatorAddr: delegatorAddress,
                    validatorAddr: validatorAddress
                });
                return response;
            },
            validator: async (validatorAddress)=>{
                const response = await queryService.Validator({
                    validatorAddr: validatorAddress
                });
                return response;
            },
            validatorDelegations: async (validatorAddress, paginationKey)=>{
                const response = await queryService.ValidatorDelegations({
                    validatorAddr: validatorAddress,
                    pagination: (0, $a3959936d2cce854$exports.createPagination)(paginationKey)
                });
                return response;
            },
            validators: async (status, paginationKey)=>{
                const response = await queryService.Validators({
                    status: status,
                    pagination: (0, $a3959936d2cce854$exports.createPagination)(paginationKey)
                });
                return response;
            },
            validatorUnbondingDelegations: async (validatorAddress, paginationKey)=>{
                const response = await queryService.ValidatorUnbondingDelegations({
                    validatorAddr: validatorAddress,
                    pagination: (0, $a3959936d2cce854$exports.createPagination)(paginationKey)
                });
                return response;
            }
        }
    };
}
$3d81be017edc450a$exports.setupStakingExtension = $3d81be017edc450a$var$setupStakingExtension;


Object.defineProperty($d0d8b6f4712acd9f$exports, "setupStakingExtension", {
    enumerable: true,
    get: function() {
        return $3d81be017edc450a$exports.setupStakingExtension;
    }
});
var $f2d5c2d4fccc9533$exports = {};
"use strict";
var $f2d5c2d4fccc9533$var$__importDefault = $f2d5c2d4fccc9533$exports && $f2d5c2d4fccc9533$exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty($f2d5c2d4fccc9533$exports, "__esModule", {
    value: true
});
$f2d5c2d4fccc9533$exports.setupTxExtension = void 0;


var $323b2a98c050ad7c$exports = {};
"use strict";
var $323b2a98c050ad7c$var$__createBinding = $323b2a98c050ad7c$exports && $323b2a98c050ad7c$exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $323b2a98c050ad7c$var$__setModuleDefault = $323b2a98c050ad7c$exports && $323b2a98c050ad7c$exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $323b2a98c050ad7c$var$__importStar = $323b2a98c050ad7c$exports && $323b2a98c050ad7c$exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $323b2a98c050ad7c$var$__createBinding(result, mod, k);
    }
    $323b2a98c050ad7c$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty($323b2a98c050ad7c$exports, "__esModule", {
    value: true
});
$323b2a98c050ad7c$exports.ServiceClientImpl = $323b2a98c050ad7c$exports.TxDecodeAminoResponse = $323b2a98c050ad7c$exports.TxDecodeAminoRequest = $323b2a98c050ad7c$exports.TxEncodeAminoResponse = $323b2a98c050ad7c$exports.TxEncodeAminoRequest = $323b2a98c050ad7c$exports.TxEncodeResponse = $323b2a98c050ad7c$exports.TxEncodeRequest = $323b2a98c050ad7c$exports.TxDecodeResponse = $323b2a98c050ad7c$exports.TxDecodeRequest = $323b2a98c050ad7c$exports.GetBlockWithTxsResponse = $323b2a98c050ad7c$exports.GetBlockWithTxsRequest = $323b2a98c050ad7c$exports.GetTxResponse = $323b2a98c050ad7c$exports.GetTxRequest = $323b2a98c050ad7c$exports.SimulateResponse = $323b2a98c050ad7c$exports.SimulateRequest = $323b2a98c050ad7c$exports.BroadcastTxResponse = $323b2a98c050ad7c$exports.BroadcastTxRequest = $323b2a98c050ad7c$exports.GetTxsEventResponse = $323b2a98c050ad7c$exports.GetTxsEventRequest = $323b2a98c050ad7c$exports.broadcastModeToJSON = $323b2a98c050ad7c$exports.broadcastModeFromJSON = $323b2a98c050ad7c$exports.BroadcastMode = $323b2a98c050ad7c$exports.orderByToJSON = $323b2a98c050ad7c$exports.orderByFromJSON = $323b2a98c050ad7c$exports.OrderBy = $323b2a98c050ad7c$exports.protobufPackage = void 0;


var $17fd3ea9d729df0d$exports = {};
"use strict";
var $17fd3ea9d729df0d$var$__createBinding = $17fd3ea9d729df0d$exports && $17fd3ea9d729df0d$exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $17fd3ea9d729df0d$var$__setModuleDefault = $17fd3ea9d729df0d$exports && $17fd3ea9d729df0d$exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $17fd3ea9d729df0d$var$__importStar = $17fd3ea9d729df0d$exports && $17fd3ea9d729df0d$exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $17fd3ea9d729df0d$var$__createBinding(result, mod, k);
    }
    $17fd3ea9d729df0d$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty($17fd3ea9d729df0d$exports, "__esModule", {
    value: true
});
$17fd3ea9d729df0d$exports.SearchTxsResult = $17fd3ea9d729df0d$exports.TxMsgData = $17fd3ea9d729df0d$exports.MsgData = $17fd3ea9d729df0d$exports.SimulationResponse = $17fd3ea9d729df0d$exports.Result = $17fd3ea9d729df0d$exports.GasInfo = $17fd3ea9d729df0d$exports.Attribute = $17fd3ea9d729df0d$exports.StringEvent = $17fd3ea9d729df0d$exports.ABCIMessageLog = $17fd3ea9d729df0d$exports.TxResponse = $17fd3ea9d729df0d$exports.protobufPackage = void 0;




const $17fd3ea9d729df0d$var$_m0 = $17fd3ea9d729df0d$var$__importStar((parcelRequire("fQBv0")));
$17fd3ea9d729df0d$exports.protobufPackage = "cosmos.base.abci.v1beta1";
function $17fd3ea9d729df0d$var$createBaseTxResponse() {
    return {
        height: $d5e07fe2518aae94$exports.Long.ZERO,
        txhash: "",
        codespace: "",
        code: 0,
        data: "",
        rawLog: "",
        logs: [],
        info: "",
        gasWanted: $d5e07fe2518aae94$exports.Long.ZERO,
        gasUsed: $d5e07fe2518aae94$exports.Long.ZERO,
        tx: undefined,
        timestamp: "",
        events: []
    };
}
$17fd3ea9d729df0d$exports.TxResponse = {
    encode (message, writer = $17fd3ea9d729df0d$var$_m0.Writer.create()) {
        if (!message.height.isZero()) writer.uint32(8).int64(message.height);
        if (message.txhash !== "") writer.uint32(18).string(message.txhash);
        if (message.codespace !== "") writer.uint32(26).string(message.codespace);
        if (message.code !== 0) writer.uint32(32).uint32(message.code);
        if (message.data !== "") writer.uint32(42).string(message.data);
        if (message.rawLog !== "") writer.uint32(50).string(message.rawLog);
        for (const v of message.logs)$17fd3ea9d729df0d$exports.ABCIMessageLog.encode(v, writer.uint32(58).fork()).ldelim();
        if (message.info !== "") writer.uint32(66).string(message.info);
        if (!message.gasWanted.isZero()) writer.uint32(72).int64(message.gasWanted);
        if (!message.gasUsed.isZero()) writer.uint32(80).int64(message.gasUsed);
        if (message.tx !== undefined) $64138e590dcf0cc1$exports.Any.encode(message.tx, writer.uint32(90).fork()).ldelim();
        if (message.timestamp !== "") writer.uint32(98).string(message.timestamp);
        for (const v of message.events)$55d7da6fb7010b2f$exports.Event.encode(v, writer.uint32(106).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $17fd3ea9d729df0d$var$_m0.Reader ? input : new $17fd3ea9d729df0d$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $17fd3ea9d729df0d$var$createBaseTxResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.height = reader.int64();
                    break;
                case 2:
                    message.txhash = reader.string();
                    break;
                case 3:
                    message.codespace = reader.string();
                    break;
                case 4:
                    message.code = reader.uint32();
                    break;
                case 5:
                    message.data = reader.string();
                    break;
                case 6:
                    message.rawLog = reader.string();
                    break;
                case 7:
                    message.logs.push($17fd3ea9d729df0d$exports.ABCIMessageLog.decode(reader, reader.uint32()));
                    break;
                case 8:
                    message.info = reader.string();
                    break;
                case 9:
                    message.gasWanted = reader.int64();
                    break;
                case 10:
                    message.gasUsed = reader.int64();
                    break;
                case 11:
                    message.tx = $64138e590dcf0cc1$exports.Any.decode(reader, reader.uint32());
                    break;
                case 12:
                    message.timestamp = reader.string();
                    break;
                case 13:
                    message.events.push($55d7da6fb7010b2f$exports.Event.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            height: (0, $d5e07fe2518aae94$exports.isSet)(object.height) ? $d5e07fe2518aae94$exports.Long.fromValue(object.height) : $d5e07fe2518aae94$exports.Long.ZERO,
            txhash: (0, $d5e07fe2518aae94$exports.isSet)(object.txhash) ? String(object.txhash) : "",
            codespace: (0, $d5e07fe2518aae94$exports.isSet)(object.codespace) ? String(object.codespace) : "",
            code: (0, $d5e07fe2518aae94$exports.isSet)(object.code) ? Number(object.code) : 0,
            data: (0, $d5e07fe2518aae94$exports.isSet)(object.data) ? String(object.data) : "",
            rawLog: (0, $d5e07fe2518aae94$exports.isSet)(object.rawLog) ? String(object.rawLog) : "",
            logs: Array.isArray(object?.logs) ? object.logs.map((e)=>$17fd3ea9d729df0d$exports.ABCIMessageLog.fromJSON(e)) : [],
            info: (0, $d5e07fe2518aae94$exports.isSet)(object.info) ? String(object.info) : "",
            gasWanted: (0, $d5e07fe2518aae94$exports.isSet)(object.gasWanted) ? $d5e07fe2518aae94$exports.Long.fromValue(object.gasWanted) : $d5e07fe2518aae94$exports.Long.ZERO,
            gasUsed: (0, $d5e07fe2518aae94$exports.isSet)(object.gasUsed) ? $d5e07fe2518aae94$exports.Long.fromValue(object.gasUsed) : $d5e07fe2518aae94$exports.Long.ZERO,
            tx: (0, $d5e07fe2518aae94$exports.isSet)(object.tx) ? $64138e590dcf0cc1$exports.Any.fromJSON(object.tx) : undefined,
            timestamp: (0, $d5e07fe2518aae94$exports.isSet)(object.timestamp) ? String(object.timestamp) : "",
            events: Array.isArray(object?.events) ? object.events.map((e)=>$55d7da6fb7010b2f$exports.Event.fromJSON(e)) : []
        };
    },
    toJSON (message) {
        const obj = {};
        message.height !== undefined && (obj.height = (message.height || $d5e07fe2518aae94$exports.Long.ZERO).toString());
        message.txhash !== undefined && (obj.txhash = message.txhash);
        message.codespace !== undefined && (obj.codespace = message.codespace);
        message.code !== undefined && (obj.code = Math.round(message.code));
        message.data !== undefined && (obj.data = message.data);
        message.rawLog !== undefined && (obj.rawLog = message.rawLog);
        if (message.logs) obj.logs = message.logs.map((e)=>e ? $17fd3ea9d729df0d$exports.ABCIMessageLog.toJSON(e) : undefined);
        else obj.logs = [];
        message.info !== undefined && (obj.info = message.info);
        message.gasWanted !== undefined && (obj.gasWanted = (message.gasWanted || $d5e07fe2518aae94$exports.Long.ZERO).toString());
        message.gasUsed !== undefined && (obj.gasUsed = (message.gasUsed || $d5e07fe2518aae94$exports.Long.ZERO).toString());
        message.tx !== undefined && (obj.tx = message.tx ? $64138e590dcf0cc1$exports.Any.toJSON(message.tx) : undefined);
        message.timestamp !== undefined && (obj.timestamp = message.timestamp);
        if (message.events) obj.events = message.events.map((e)=>e ? $55d7da6fb7010b2f$exports.Event.toJSON(e) : undefined);
        else obj.events = [];
        return obj;
    },
    fromPartial (object) {
        const message = $17fd3ea9d729df0d$var$createBaseTxResponse();
        message.height = object.height !== undefined && object.height !== null ? $d5e07fe2518aae94$exports.Long.fromValue(object.height) : $d5e07fe2518aae94$exports.Long.ZERO;
        message.txhash = object.txhash ?? "";
        message.codespace = object.codespace ?? "";
        message.code = object.code ?? 0;
        message.data = object.data ?? "";
        message.rawLog = object.rawLog ?? "";
        message.logs = object.logs?.map((e)=>$17fd3ea9d729df0d$exports.ABCIMessageLog.fromPartial(e)) || [];
        message.info = object.info ?? "";
        message.gasWanted = object.gasWanted !== undefined && object.gasWanted !== null ? $d5e07fe2518aae94$exports.Long.fromValue(object.gasWanted) : $d5e07fe2518aae94$exports.Long.ZERO;
        message.gasUsed = object.gasUsed !== undefined && object.gasUsed !== null ? $d5e07fe2518aae94$exports.Long.fromValue(object.gasUsed) : $d5e07fe2518aae94$exports.Long.ZERO;
        message.tx = object.tx !== undefined && object.tx !== null ? $64138e590dcf0cc1$exports.Any.fromPartial(object.tx) : undefined;
        message.timestamp = object.timestamp ?? "";
        message.events = object.events?.map((e)=>$55d7da6fb7010b2f$exports.Event.fromPartial(e)) || [];
        return message;
    }
};
function $17fd3ea9d729df0d$var$createBaseABCIMessageLog() {
    return {
        msgIndex: 0,
        log: "",
        events: []
    };
}
$17fd3ea9d729df0d$exports.ABCIMessageLog = {
    encode (message, writer = $17fd3ea9d729df0d$var$_m0.Writer.create()) {
        if (message.msgIndex !== 0) writer.uint32(8).uint32(message.msgIndex);
        if (message.log !== "") writer.uint32(18).string(message.log);
        for (const v of message.events)$17fd3ea9d729df0d$exports.StringEvent.encode(v, writer.uint32(26).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $17fd3ea9d729df0d$var$_m0.Reader ? input : new $17fd3ea9d729df0d$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $17fd3ea9d729df0d$var$createBaseABCIMessageLog();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.msgIndex = reader.uint32();
                    break;
                case 2:
                    message.log = reader.string();
                    break;
                case 3:
                    message.events.push($17fd3ea9d729df0d$exports.StringEvent.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            msgIndex: (0, $d5e07fe2518aae94$exports.isSet)(object.msgIndex) ? Number(object.msgIndex) : 0,
            log: (0, $d5e07fe2518aae94$exports.isSet)(object.log) ? String(object.log) : "",
            events: Array.isArray(object?.events) ? object.events.map((e)=>$17fd3ea9d729df0d$exports.StringEvent.fromJSON(e)) : []
        };
    },
    toJSON (message) {
        const obj = {};
        message.msgIndex !== undefined && (obj.msgIndex = Math.round(message.msgIndex));
        message.log !== undefined && (obj.log = message.log);
        if (message.events) obj.events = message.events.map((e)=>e ? $17fd3ea9d729df0d$exports.StringEvent.toJSON(e) : undefined);
        else obj.events = [];
        return obj;
    },
    fromPartial (object) {
        const message = $17fd3ea9d729df0d$var$createBaseABCIMessageLog();
        message.msgIndex = object.msgIndex ?? 0;
        message.log = object.log ?? "";
        message.events = object.events?.map((e)=>$17fd3ea9d729df0d$exports.StringEvent.fromPartial(e)) || [];
        return message;
    }
};
function $17fd3ea9d729df0d$var$createBaseStringEvent() {
    return {
        type: "",
        attributes: []
    };
}
$17fd3ea9d729df0d$exports.StringEvent = {
    encode (message, writer = $17fd3ea9d729df0d$var$_m0.Writer.create()) {
        if (message.type !== "") writer.uint32(10).string(message.type);
        for (const v of message.attributes)$17fd3ea9d729df0d$exports.Attribute.encode(v, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $17fd3ea9d729df0d$var$_m0.Reader ? input : new $17fd3ea9d729df0d$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $17fd3ea9d729df0d$var$createBaseStringEvent();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.type = reader.string();
                    break;
                case 2:
                    message.attributes.push($17fd3ea9d729df0d$exports.Attribute.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            type: (0, $d5e07fe2518aae94$exports.isSet)(object.type) ? String(object.type) : "",
            attributes: Array.isArray(object?.attributes) ? object.attributes.map((e)=>$17fd3ea9d729df0d$exports.Attribute.fromJSON(e)) : []
        };
    },
    toJSON (message) {
        const obj = {};
        message.type !== undefined && (obj.type = message.type);
        if (message.attributes) obj.attributes = message.attributes.map((e)=>e ? $17fd3ea9d729df0d$exports.Attribute.toJSON(e) : undefined);
        else obj.attributes = [];
        return obj;
    },
    fromPartial (object) {
        const message = $17fd3ea9d729df0d$var$createBaseStringEvent();
        message.type = object.type ?? "";
        message.attributes = object.attributes?.map((e)=>$17fd3ea9d729df0d$exports.Attribute.fromPartial(e)) || [];
        return message;
    }
};
function $17fd3ea9d729df0d$var$createBaseAttribute() {
    return {
        key: "",
        value: ""
    };
}
$17fd3ea9d729df0d$exports.Attribute = {
    encode (message, writer = $17fd3ea9d729df0d$var$_m0.Writer.create()) {
        if (message.key !== "") writer.uint32(10).string(message.key);
        if (message.value !== "") writer.uint32(18).string(message.value);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $17fd3ea9d729df0d$var$_m0.Reader ? input : new $17fd3ea9d729df0d$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $17fd3ea9d729df0d$var$createBaseAttribute();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.key = reader.string();
                    break;
                case 2:
                    message.value = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            key: (0, $d5e07fe2518aae94$exports.isSet)(object.key) ? String(object.key) : "",
            value: (0, $d5e07fe2518aae94$exports.isSet)(object.value) ? String(object.value) : ""
        };
    },
    toJSON (message) {
        const obj = {};
        message.key !== undefined && (obj.key = message.key);
        message.value !== undefined && (obj.value = message.value);
        return obj;
    },
    fromPartial (object) {
        const message = $17fd3ea9d729df0d$var$createBaseAttribute();
        message.key = object.key ?? "";
        message.value = object.value ?? "";
        return message;
    }
};
function $17fd3ea9d729df0d$var$createBaseGasInfo() {
    return {
        gasWanted: $d5e07fe2518aae94$exports.Long.UZERO,
        gasUsed: $d5e07fe2518aae94$exports.Long.UZERO
    };
}
$17fd3ea9d729df0d$exports.GasInfo = {
    encode (message, writer = $17fd3ea9d729df0d$var$_m0.Writer.create()) {
        if (!message.gasWanted.isZero()) writer.uint32(8).uint64(message.gasWanted);
        if (!message.gasUsed.isZero()) writer.uint32(16).uint64(message.gasUsed);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $17fd3ea9d729df0d$var$_m0.Reader ? input : new $17fd3ea9d729df0d$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $17fd3ea9d729df0d$var$createBaseGasInfo();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.gasWanted = reader.uint64();
                    break;
                case 2:
                    message.gasUsed = reader.uint64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            gasWanted: (0, $d5e07fe2518aae94$exports.isSet)(object.gasWanted) ? $d5e07fe2518aae94$exports.Long.fromValue(object.gasWanted) : $d5e07fe2518aae94$exports.Long.UZERO,
            gasUsed: (0, $d5e07fe2518aae94$exports.isSet)(object.gasUsed) ? $d5e07fe2518aae94$exports.Long.fromValue(object.gasUsed) : $d5e07fe2518aae94$exports.Long.UZERO
        };
    },
    toJSON (message) {
        const obj = {};
        message.gasWanted !== undefined && (obj.gasWanted = (message.gasWanted || $d5e07fe2518aae94$exports.Long.UZERO).toString());
        message.gasUsed !== undefined && (obj.gasUsed = (message.gasUsed || $d5e07fe2518aae94$exports.Long.UZERO).toString());
        return obj;
    },
    fromPartial (object) {
        const message = $17fd3ea9d729df0d$var$createBaseGasInfo();
        message.gasWanted = object.gasWanted !== undefined && object.gasWanted !== null ? $d5e07fe2518aae94$exports.Long.fromValue(object.gasWanted) : $d5e07fe2518aae94$exports.Long.UZERO;
        message.gasUsed = object.gasUsed !== undefined && object.gasUsed !== null ? $d5e07fe2518aae94$exports.Long.fromValue(object.gasUsed) : $d5e07fe2518aae94$exports.Long.UZERO;
        return message;
    }
};
function $17fd3ea9d729df0d$var$createBaseResult() {
    return {
        data: new Uint8Array(),
        log: "",
        events: [],
        msgResponses: []
    };
}
$17fd3ea9d729df0d$exports.Result = {
    encode (message, writer = $17fd3ea9d729df0d$var$_m0.Writer.create()) {
        if (message.data.length !== 0) writer.uint32(10).bytes(message.data);
        if (message.log !== "") writer.uint32(18).string(message.log);
        for (const v of message.events)$55d7da6fb7010b2f$exports.Event.encode(v, writer.uint32(26).fork()).ldelim();
        for (const v of message.msgResponses)$64138e590dcf0cc1$exports.Any.encode(v, writer.uint32(34).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $17fd3ea9d729df0d$var$_m0.Reader ? input : new $17fd3ea9d729df0d$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $17fd3ea9d729df0d$var$createBaseResult();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.data = reader.bytes();
                    break;
                case 2:
                    message.log = reader.string();
                    break;
                case 3:
                    message.events.push($55d7da6fb7010b2f$exports.Event.decode(reader, reader.uint32()));
                    break;
                case 4:
                    message.msgResponses.push($64138e590dcf0cc1$exports.Any.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            data: (0, $d5e07fe2518aae94$exports.isSet)(object.data) ? (0, $d5e07fe2518aae94$exports.bytesFromBase64)(object.data) : new Uint8Array(),
            log: (0, $d5e07fe2518aae94$exports.isSet)(object.log) ? String(object.log) : "",
            events: Array.isArray(object?.events) ? object.events.map((e)=>$55d7da6fb7010b2f$exports.Event.fromJSON(e)) : [],
            msgResponses: Array.isArray(object?.msgResponses) ? object.msgResponses.map((e)=>$64138e590dcf0cc1$exports.Any.fromJSON(e)) : []
        };
    },
    toJSON (message) {
        const obj = {};
        message.data !== undefined && (obj.data = (0, $d5e07fe2518aae94$exports.base64FromBytes)(message.data !== undefined ? message.data : new Uint8Array()));
        message.log !== undefined && (obj.log = message.log);
        if (message.events) obj.events = message.events.map((e)=>e ? $55d7da6fb7010b2f$exports.Event.toJSON(e) : undefined);
        else obj.events = [];
        if (message.msgResponses) obj.msgResponses = message.msgResponses.map((e)=>e ? $64138e590dcf0cc1$exports.Any.toJSON(e) : undefined);
        else obj.msgResponses = [];
        return obj;
    },
    fromPartial (object) {
        const message = $17fd3ea9d729df0d$var$createBaseResult();
        message.data = object.data ?? new Uint8Array();
        message.log = object.log ?? "";
        message.events = object.events?.map((e)=>$55d7da6fb7010b2f$exports.Event.fromPartial(e)) || [];
        message.msgResponses = object.msgResponses?.map((e)=>$64138e590dcf0cc1$exports.Any.fromPartial(e)) || [];
        return message;
    }
};
function $17fd3ea9d729df0d$var$createBaseSimulationResponse() {
    return {
        gasInfo: undefined,
        result: undefined
    };
}
$17fd3ea9d729df0d$exports.SimulationResponse = {
    encode (message, writer = $17fd3ea9d729df0d$var$_m0.Writer.create()) {
        if (message.gasInfo !== undefined) $17fd3ea9d729df0d$exports.GasInfo.encode(message.gasInfo, writer.uint32(10).fork()).ldelim();
        if (message.result !== undefined) $17fd3ea9d729df0d$exports.Result.encode(message.result, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $17fd3ea9d729df0d$var$_m0.Reader ? input : new $17fd3ea9d729df0d$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $17fd3ea9d729df0d$var$createBaseSimulationResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.gasInfo = $17fd3ea9d729df0d$exports.GasInfo.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.result = $17fd3ea9d729df0d$exports.Result.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            gasInfo: (0, $d5e07fe2518aae94$exports.isSet)(object.gasInfo) ? $17fd3ea9d729df0d$exports.GasInfo.fromJSON(object.gasInfo) : undefined,
            result: (0, $d5e07fe2518aae94$exports.isSet)(object.result) ? $17fd3ea9d729df0d$exports.Result.fromJSON(object.result) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.gasInfo !== undefined && (obj.gasInfo = message.gasInfo ? $17fd3ea9d729df0d$exports.GasInfo.toJSON(message.gasInfo) : undefined);
        message.result !== undefined && (obj.result = message.result ? $17fd3ea9d729df0d$exports.Result.toJSON(message.result) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $17fd3ea9d729df0d$var$createBaseSimulationResponse();
        message.gasInfo = object.gasInfo !== undefined && object.gasInfo !== null ? $17fd3ea9d729df0d$exports.GasInfo.fromPartial(object.gasInfo) : undefined;
        message.result = object.result !== undefined && object.result !== null ? $17fd3ea9d729df0d$exports.Result.fromPartial(object.result) : undefined;
        return message;
    }
};
function $17fd3ea9d729df0d$var$createBaseMsgData() {
    return {
        msgType: "",
        data: new Uint8Array()
    };
}
$17fd3ea9d729df0d$exports.MsgData = {
    encode (message, writer = $17fd3ea9d729df0d$var$_m0.Writer.create()) {
        if (message.msgType !== "") writer.uint32(10).string(message.msgType);
        if (message.data.length !== 0) writer.uint32(18).bytes(message.data);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $17fd3ea9d729df0d$var$_m0.Reader ? input : new $17fd3ea9d729df0d$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $17fd3ea9d729df0d$var$createBaseMsgData();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.msgType = reader.string();
                    break;
                case 2:
                    message.data = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            msgType: (0, $d5e07fe2518aae94$exports.isSet)(object.msgType) ? String(object.msgType) : "",
            data: (0, $d5e07fe2518aae94$exports.isSet)(object.data) ? (0, $d5e07fe2518aae94$exports.bytesFromBase64)(object.data) : new Uint8Array()
        };
    },
    toJSON (message) {
        const obj = {};
        message.msgType !== undefined && (obj.msgType = message.msgType);
        message.data !== undefined && (obj.data = (0, $d5e07fe2518aae94$exports.base64FromBytes)(message.data !== undefined ? message.data : new Uint8Array()));
        return obj;
    },
    fromPartial (object) {
        const message = $17fd3ea9d729df0d$var$createBaseMsgData();
        message.msgType = object.msgType ?? "";
        message.data = object.data ?? new Uint8Array();
        return message;
    }
};
function $17fd3ea9d729df0d$var$createBaseTxMsgData() {
    return {
        data: [],
        msgResponses: []
    };
}
$17fd3ea9d729df0d$exports.TxMsgData = {
    encode (message, writer = $17fd3ea9d729df0d$var$_m0.Writer.create()) {
        for (const v of message.data)$17fd3ea9d729df0d$exports.MsgData.encode(v, writer.uint32(10).fork()).ldelim();
        for (const v of message.msgResponses)$64138e590dcf0cc1$exports.Any.encode(v, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $17fd3ea9d729df0d$var$_m0.Reader ? input : new $17fd3ea9d729df0d$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $17fd3ea9d729df0d$var$createBaseTxMsgData();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.data.push($17fd3ea9d729df0d$exports.MsgData.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.msgResponses.push($64138e590dcf0cc1$exports.Any.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            data: Array.isArray(object?.data) ? object.data.map((e)=>$17fd3ea9d729df0d$exports.MsgData.fromJSON(e)) : [],
            msgResponses: Array.isArray(object?.msgResponses) ? object.msgResponses.map((e)=>$64138e590dcf0cc1$exports.Any.fromJSON(e)) : []
        };
    },
    toJSON (message) {
        const obj = {};
        if (message.data) obj.data = message.data.map((e)=>e ? $17fd3ea9d729df0d$exports.MsgData.toJSON(e) : undefined);
        else obj.data = [];
        if (message.msgResponses) obj.msgResponses = message.msgResponses.map((e)=>e ? $64138e590dcf0cc1$exports.Any.toJSON(e) : undefined);
        else obj.msgResponses = [];
        return obj;
    },
    fromPartial (object) {
        const message = $17fd3ea9d729df0d$var$createBaseTxMsgData();
        message.data = object.data?.map((e)=>$17fd3ea9d729df0d$exports.MsgData.fromPartial(e)) || [];
        message.msgResponses = object.msgResponses?.map((e)=>$64138e590dcf0cc1$exports.Any.fromPartial(e)) || [];
        return message;
    }
};
function $17fd3ea9d729df0d$var$createBaseSearchTxsResult() {
    return {
        totalCount: $d5e07fe2518aae94$exports.Long.UZERO,
        count: $d5e07fe2518aae94$exports.Long.UZERO,
        pageNumber: $d5e07fe2518aae94$exports.Long.UZERO,
        pageTotal: $d5e07fe2518aae94$exports.Long.UZERO,
        limit: $d5e07fe2518aae94$exports.Long.UZERO,
        txs: []
    };
}
$17fd3ea9d729df0d$exports.SearchTxsResult = {
    encode (message, writer = $17fd3ea9d729df0d$var$_m0.Writer.create()) {
        if (!message.totalCount.isZero()) writer.uint32(8).uint64(message.totalCount);
        if (!message.count.isZero()) writer.uint32(16).uint64(message.count);
        if (!message.pageNumber.isZero()) writer.uint32(24).uint64(message.pageNumber);
        if (!message.pageTotal.isZero()) writer.uint32(32).uint64(message.pageTotal);
        if (!message.limit.isZero()) writer.uint32(40).uint64(message.limit);
        for (const v of message.txs)$17fd3ea9d729df0d$exports.TxResponse.encode(v, writer.uint32(50).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $17fd3ea9d729df0d$var$_m0.Reader ? input : new $17fd3ea9d729df0d$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $17fd3ea9d729df0d$var$createBaseSearchTxsResult();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.totalCount = reader.uint64();
                    break;
                case 2:
                    message.count = reader.uint64();
                    break;
                case 3:
                    message.pageNumber = reader.uint64();
                    break;
                case 4:
                    message.pageTotal = reader.uint64();
                    break;
                case 5:
                    message.limit = reader.uint64();
                    break;
                case 6:
                    message.txs.push($17fd3ea9d729df0d$exports.TxResponse.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            totalCount: (0, $d5e07fe2518aae94$exports.isSet)(object.totalCount) ? $d5e07fe2518aae94$exports.Long.fromValue(object.totalCount) : $d5e07fe2518aae94$exports.Long.UZERO,
            count: (0, $d5e07fe2518aae94$exports.isSet)(object.count) ? $d5e07fe2518aae94$exports.Long.fromValue(object.count) : $d5e07fe2518aae94$exports.Long.UZERO,
            pageNumber: (0, $d5e07fe2518aae94$exports.isSet)(object.pageNumber) ? $d5e07fe2518aae94$exports.Long.fromValue(object.pageNumber) : $d5e07fe2518aae94$exports.Long.UZERO,
            pageTotal: (0, $d5e07fe2518aae94$exports.isSet)(object.pageTotal) ? $d5e07fe2518aae94$exports.Long.fromValue(object.pageTotal) : $d5e07fe2518aae94$exports.Long.UZERO,
            limit: (0, $d5e07fe2518aae94$exports.isSet)(object.limit) ? $d5e07fe2518aae94$exports.Long.fromValue(object.limit) : $d5e07fe2518aae94$exports.Long.UZERO,
            txs: Array.isArray(object?.txs) ? object.txs.map((e)=>$17fd3ea9d729df0d$exports.TxResponse.fromJSON(e)) : []
        };
    },
    toJSON (message) {
        const obj = {};
        message.totalCount !== undefined && (obj.totalCount = (message.totalCount || $d5e07fe2518aae94$exports.Long.UZERO).toString());
        message.count !== undefined && (obj.count = (message.count || $d5e07fe2518aae94$exports.Long.UZERO).toString());
        message.pageNumber !== undefined && (obj.pageNumber = (message.pageNumber || $d5e07fe2518aae94$exports.Long.UZERO).toString());
        message.pageTotal !== undefined && (obj.pageTotal = (message.pageTotal || $d5e07fe2518aae94$exports.Long.UZERO).toString());
        message.limit !== undefined && (obj.limit = (message.limit || $d5e07fe2518aae94$exports.Long.UZERO).toString());
        if (message.txs) obj.txs = message.txs.map((e)=>e ? $17fd3ea9d729df0d$exports.TxResponse.toJSON(e) : undefined);
        else obj.txs = [];
        return obj;
    },
    fromPartial (object) {
        const message = $17fd3ea9d729df0d$var$createBaseSearchTxsResult();
        message.totalCount = object.totalCount !== undefined && object.totalCount !== null ? $d5e07fe2518aae94$exports.Long.fromValue(object.totalCount) : $d5e07fe2518aae94$exports.Long.UZERO;
        message.count = object.count !== undefined && object.count !== null ? $d5e07fe2518aae94$exports.Long.fromValue(object.count) : $d5e07fe2518aae94$exports.Long.UZERO;
        message.pageNumber = object.pageNumber !== undefined && object.pageNumber !== null ? $d5e07fe2518aae94$exports.Long.fromValue(object.pageNumber) : $d5e07fe2518aae94$exports.Long.UZERO;
        message.pageTotal = object.pageTotal !== undefined && object.pageTotal !== null ? $d5e07fe2518aae94$exports.Long.fromValue(object.pageTotal) : $d5e07fe2518aae94$exports.Long.UZERO;
        message.limit = object.limit !== undefined && object.limit !== null ? $d5e07fe2518aae94$exports.Long.fromValue(object.limit) : $d5e07fe2518aae94$exports.Long.UZERO;
        message.txs = object.txs?.map((e)=>$17fd3ea9d729df0d$exports.TxResponse.fromPartial(e)) || [];
        return message;
    }
};



var $d343d7250542543a$exports = {};
"use strict";
var $d343d7250542543a$var$__createBinding = $d343d7250542543a$exports && $d343d7250542543a$exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $d343d7250542543a$var$__setModuleDefault = $d343d7250542543a$exports && $d343d7250542543a$exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $d343d7250542543a$var$__importStar = $d343d7250542543a$exports && $d343d7250542543a$exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $d343d7250542543a$var$__createBinding(result, mod, k);
    }
    $d343d7250542543a$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty($d343d7250542543a$exports, "__esModule", {
    value: true
});
$d343d7250542543a$exports.Block = $d343d7250542543a$exports.protobufPackage = void 0;

var $ef8604053752c6d9$exports = {};
"use strict";
var $ef8604053752c6d9$var$__createBinding = $ef8604053752c6d9$exports && $ef8604053752c6d9$exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $ef8604053752c6d9$var$__setModuleDefault = $ef8604053752c6d9$exports && $ef8604053752c6d9$exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $ef8604053752c6d9$var$__importStar = $ef8604053752c6d9$exports && $ef8604053752c6d9$exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $ef8604053752c6d9$var$__createBinding(result, mod, k);
    }
    $ef8604053752c6d9$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty($ef8604053752c6d9$exports, "__esModule", {
    value: true
});
$ef8604053752c6d9$exports.EvidenceList = $ef8604053752c6d9$exports.LightClientAttackEvidence = $ef8604053752c6d9$exports.DuplicateVoteEvidence = $ef8604053752c6d9$exports.Evidence = $ef8604053752c6d9$exports.protobufPackage = void 0;





const $ef8604053752c6d9$var$_m0 = $ef8604053752c6d9$var$__importStar((parcelRequire("fQBv0")));
$ef8604053752c6d9$exports.protobufPackage = "tendermint.types";
function $ef8604053752c6d9$var$createBaseEvidence() {
    return {
        duplicateVoteEvidence: undefined,
        lightClientAttackEvidence: undefined
    };
}
$ef8604053752c6d9$exports.Evidence = {
    encode (message, writer = $ef8604053752c6d9$var$_m0.Writer.create()) {
        if (message.duplicateVoteEvidence !== undefined) $ef8604053752c6d9$exports.DuplicateVoteEvidence.encode(message.duplicateVoteEvidence, writer.uint32(10).fork()).ldelim();
        if (message.lightClientAttackEvidence !== undefined) $ef8604053752c6d9$exports.LightClientAttackEvidence.encode(message.lightClientAttackEvidence, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $ef8604053752c6d9$var$_m0.Reader ? input : new $ef8604053752c6d9$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $ef8604053752c6d9$var$createBaseEvidence();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.duplicateVoteEvidence = $ef8604053752c6d9$exports.DuplicateVoteEvidence.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.lightClientAttackEvidence = $ef8604053752c6d9$exports.LightClientAttackEvidence.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            duplicateVoteEvidence: (0, $d5e07fe2518aae94$exports.isSet)(object.duplicateVoteEvidence) ? $ef8604053752c6d9$exports.DuplicateVoteEvidence.fromJSON(object.duplicateVoteEvidence) : undefined,
            lightClientAttackEvidence: (0, $d5e07fe2518aae94$exports.isSet)(object.lightClientAttackEvidence) ? $ef8604053752c6d9$exports.LightClientAttackEvidence.fromJSON(object.lightClientAttackEvidence) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.duplicateVoteEvidence !== undefined && (obj.duplicateVoteEvidence = message.duplicateVoteEvidence ? $ef8604053752c6d9$exports.DuplicateVoteEvidence.toJSON(message.duplicateVoteEvidence) : undefined);
        message.lightClientAttackEvidence !== undefined && (obj.lightClientAttackEvidence = message.lightClientAttackEvidence ? $ef8604053752c6d9$exports.LightClientAttackEvidence.toJSON(message.lightClientAttackEvidence) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $ef8604053752c6d9$var$createBaseEvidence();
        message.duplicateVoteEvidence = object.duplicateVoteEvidence !== undefined && object.duplicateVoteEvidence !== null ? $ef8604053752c6d9$exports.DuplicateVoteEvidence.fromPartial(object.duplicateVoteEvidence) : undefined;
        message.lightClientAttackEvidence = object.lightClientAttackEvidence !== undefined && object.lightClientAttackEvidence !== null ? $ef8604053752c6d9$exports.LightClientAttackEvidence.fromPartial(object.lightClientAttackEvidence) : undefined;
        return message;
    }
};
function $ef8604053752c6d9$var$createBaseDuplicateVoteEvidence() {
    return {
        voteA: undefined,
        voteB: undefined,
        totalVotingPower: $d5e07fe2518aae94$exports.Long.ZERO,
        validatorPower: $d5e07fe2518aae94$exports.Long.ZERO,
        timestamp: undefined
    };
}
$ef8604053752c6d9$exports.DuplicateVoteEvidence = {
    encode (message, writer = $ef8604053752c6d9$var$_m0.Writer.create()) {
        if (message.voteA !== undefined) $c51af120eef1efed$exports.Vote.encode(message.voteA, writer.uint32(10).fork()).ldelim();
        if (message.voteB !== undefined) $c51af120eef1efed$exports.Vote.encode(message.voteB, writer.uint32(18).fork()).ldelim();
        if (!message.totalVotingPower.isZero()) writer.uint32(24).int64(message.totalVotingPower);
        if (!message.validatorPower.isZero()) writer.uint32(32).int64(message.validatorPower);
        if (message.timestamp !== undefined) $e7eaeedc85b414fc$exports.Timestamp.encode(message.timestamp, writer.uint32(42).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $ef8604053752c6d9$var$_m0.Reader ? input : new $ef8604053752c6d9$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $ef8604053752c6d9$var$createBaseDuplicateVoteEvidence();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.voteA = $c51af120eef1efed$exports.Vote.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.voteB = $c51af120eef1efed$exports.Vote.decode(reader, reader.uint32());
                    break;
                case 3:
                    message.totalVotingPower = reader.int64();
                    break;
                case 4:
                    message.validatorPower = reader.int64();
                    break;
                case 5:
                    message.timestamp = $e7eaeedc85b414fc$exports.Timestamp.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            voteA: (0, $d5e07fe2518aae94$exports.isSet)(object.voteA) ? $c51af120eef1efed$exports.Vote.fromJSON(object.voteA) : undefined,
            voteB: (0, $d5e07fe2518aae94$exports.isSet)(object.voteB) ? $c51af120eef1efed$exports.Vote.fromJSON(object.voteB) : undefined,
            totalVotingPower: (0, $d5e07fe2518aae94$exports.isSet)(object.totalVotingPower) ? $d5e07fe2518aae94$exports.Long.fromValue(object.totalVotingPower) : $d5e07fe2518aae94$exports.Long.ZERO,
            validatorPower: (0, $d5e07fe2518aae94$exports.isSet)(object.validatorPower) ? $d5e07fe2518aae94$exports.Long.fromValue(object.validatorPower) : $d5e07fe2518aae94$exports.Long.ZERO,
            timestamp: (0, $d5e07fe2518aae94$exports.isSet)(object.timestamp) ? (0, $d5e07fe2518aae94$exports.fromJsonTimestamp)(object.timestamp) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.voteA !== undefined && (obj.voteA = message.voteA ? $c51af120eef1efed$exports.Vote.toJSON(message.voteA) : undefined);
        message.voteB !== undefined && (obj.voteB = message.voteB ? $c51af120eef1efed$exports.Vote.toJSON(message.voteB) : undefined);
        message.totalVotingPower !== undefined && (obj.totalVotingPower = (message.totalVotingPower || $d5e07fe2518aae94$exports.Long.ZERO).toString());
        message.validatorPower !== undefined && (obj.validatorPower = (message.validatorPower || $d5e07fe2518aae94$exports.Long.ZERO).toString());
        message.timestamp !== undefined && (obj.timestamp = (0, $d5e07fe2518aae94$exports.fromTimestamp)(message.timestamp).toISOString());
        return obj;
    },
    fromPartial (object) {
        const message = $ef8604053752c6d9$var$createBaseDuplicateVoteEvidence();
        message.voteA = object.voteA !== undefined && object.voteA !== null ? $c51af120eef1efed$exports.Vote.fromPartial(object.voteA) : undefined;
        message.voteB = object.voteB !== undefined && object.voteB !== null ? $c51af120eef1efed$exports.Vote.fromPartial(object.voteB) : undefined;
        message.totalVotingPower = object.totalVotingPower !== undefined && object.totalVotingPower !== null ? $d5e07fe2518aae94$exports.Long.fromValue(object.totalVotingPower) : $d5e07fe2518aae94$exports.Long.ZERO;
        message.validatorPower = object.validatorPower !== undefined && object.validatorPower !== null ? $d5e07fe2518aae94$exports.Long.fromValue(object.validatorPower) : $d5e07fe2518aae94$exports.Long.ZERO;
        message.timestamp = object.timestamp !== undefined && object.timestamp !== null ? $e7eaeedc85b414fc$exports.Timestamp.fromPartial(object.timestamp) : undefined;
        return message;
    }
};
function $ef8604053752c6d9$var$createBaseLightClientAttackEvidence() {
    return {
        conflictingBlock: undefined,
        commonHeight: $d5e07fe2518aae94$exports.Long.ZERO,
        byzantineValidators: [],
        totalVotingPower: $d5e07fe2518aae94$exports.Long.ZERO,
        timestamp: undefined
    };
}
$ef8604053752c6d9$exports.LightClientAttackEvidence = {
    encode (message, writer = $ef8604053752c6d9$var$_m0.Writer.create()) {
        if (message.conflictingBlock !== undefined) $c51af120eef1efed$exports.LightBlock.encode(message.conflictingBlock, writer.uint32(10).fork()).ldelim();
        if (!message.commonHeight.isZero()) writer.uint32(16).int64(message.commonHeight);
        for (const v of message.byzantineValidators)$4715d952d1c6c017$exports.Validator.encode(v, writer.uint32(26).fork()).ldelim();
        if (!message.totalVotingPower.isZero()) writer.uint32(32).int64(message.totalVotingPower);
        if (message.timestamp !== undefined) $e7eaeedc85b414fc$exports.Timestamp.encode(message.timestamp, writer.uint32(42).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $ef8604053752c6d9$var$_m0.Reader ? input : new $ef8604053752c6d9$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $ef8604053752c6d9$var$createBaseLightClientAttackEvidence();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.conflictingBlock = $c51af120eef1efed$exports.LightBlock.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.commonHeight = reader.int64();
                    break;
                case 3:
                    message.byzantineValidators.push($4715d952d1c6c017$exports.Validator.decode(reader, reader.uint32()));
                    break;
                case 4:
                    message.totalVotingPower = reader.int64();
                    break;
                case 5:
                    message.timestamp = $e7eaeedc85b414fc$exports.Timestamp.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            conflictingBlock: (0, $d5e07fe2518aae94$exports.isSet)(object.conflictingBlock) ? $c51af120eef1efed$exports.LightBlock.fromJSON(object.conflictingBlock) : undefined,
            commonHeight: (0, $d5e07fe2518aae94$exports.isSet)(object.commonHeight) ? $d5e07fe2518aae94$exports.Long.fromValue(object.commonHeight) : $d5e07fe2518aae94$exports.Long.ZERO,
            byzantineValidators: Array.isArray(object?.byzantineValidators) ? object.byzantineValidators.map((e)=>$4715d952d1c6c017$exports.Validator.fromJSON(e)) : [],
            totalVotingPower: (0, $d5e07fe2518aae94$exports.isSet)(object.totalVotingPower) ? $d5e07fe2518aae94$exports.Long.fromValue(object.totalVotingPower) : $d5e07fe2518aae94$exports.Long.ZERO,
            timestamp: (0, $d5e07fe2518aae94$exports.isSet)(object.timestamp) ? (0, $d5e07fe2518aae94$exports.fromJsonTimestamp)(object.timestamp) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.conflictingBlock !== undefined && (obj.conflictingBlock = message.conflictingBlock ? $c51af120eef1efed$exports.LightBlock.toJSON(message.conflictingBlock) : undefined);
        message.commonHeight !== undefined && (obj.commonHeight = (message.commonHeight || $d5e07fe2518aae94$exports.Long.ZERO).toString());
        if (message.byzantineValidators) obj.byzantineValidators = message.byzantineValidators.map((e)=>e ? $4715d952d1c6c017$exports.Validator.toJSON(e) : undefined);
        else obj.byzantineValidators = [];
        message.totalVotingPower !== undefined && (obj.totalVotingPower = (message.totalVotingPower || $d5e07fe2518aae94$exports.Long.ZERO).toString());
        message.timestamp !== undefined && (obj.timestamp = (0, $d5e07fe2518aae94$exports.fromTimestamp)(message.timestamp).toISOString());
        return obj;
    },
    fromPartial (object) {
        const message = $ef8604053752c6d9$var$createBaseLightClientAttackEvidence();
        message.conflictingBlock = object.conflictingBlock !== undefined && object.conflictingBlock !== null ? $c51af120eef1efed$exports.LightBlock.fromPartial(object.conflictingBlock) : undefined;
        message.commonHeight = object.commonHeight !== undefined && object.commonHeight !== null ? $d5e07fe2518aae94$exports.Long.fromValue(object.commonHeight) : $d5e07fe2518aae94$exports.Long.ZERO;
        message.byzantineValidators = object.byzantineValidators?.map((e)=>$4715d952d1c6c017$exports.Validator.fromPartial(e)) || [];
        message.totalVotingPower = object.totalVotingPower !== undefined && object.totalVotingPower !== null ? $d5e07fe2518aae94$exports.Long.fromValue(object.totalVotingPower) : $d5e07fe2518aae94$exports.Long.ZERO;
        message.timestamp = object.timestamp !== undefined && object.timestamp !== null ? $e7eaeedc85b414fc$exports.Timestamp.fromPartial(object.timestamp) : undefined;
        return message;
    }
};
function $ef8604053752c6d9$var$createBaseEvidenceList() {
    return {
        evidence: []
    };
}
$ef8604053752c6d9$exports.EvidenceList = {
    encode (message, writer = $ef8604053752c6d9$var$_m0.Writer.create()) {
        for (const v of message.evidence)$ef8604053752c6d9$exports.Evidence.encode(v, writer.uint32(10).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $ef8604053752c6d9$var$_m0.Reader ? input : new $ef8604053752c6d9$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $ef8604053752c6d9$var$createBaseEvidenceList();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.evidence.push($ef8604053752c6d9$exports.Evidence.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            evidence: Array.isArray(object?.evidence) ? object.evidence.map((e)=>$ef8604053752c6d9$exports.Evidence.fromJSON(e)) : []
        };
    },
    toJSON (message) {
        const obj = {};
        if (message.evidence) obj.evidence = message.evidence.map((e)=>e ? $ef8604053752c6d9$exports.Evidence.toJSON(e) : undefined);
        else obj.evidence = [];
        return obj;
    },
    fromPartial (object) {
        const message = $ef8604053752c6d9$var$createBaseEvidenceList();
        message.evidence = object.evidence?.map((e)=>$ef8604053752c6d9$exports.Evidence.fromPartial(e)) || [];
        return message;
    }
};



const $d343d7250542543a$var$_m0 = $d343d7250542543a$var$__importStar((parcelRequire("fQBv0")));

$d343d7250542543a$exports.protobufPackage = "tendermint.types";
function $d343d7250542543a$var$createBaseBlock() {
    return {
        header: undefined,
        data: undefined,
        evidence: undefined,
        lastCommit: undefined
    };
}
$d343d7250542543a$exports.Block = {
    encode (message, writer = $d343d7250542543a$var$_m0.Writer.create()) {
        if (message.header !== undefined) $c51af120eef1efed$exports.Header.encode(message.header, writer.uint32(10).fork()).ldelim();
        if (message.data !== undefined) $c51af120eef1efed$exports.Data.encode(message.data, writer.uint32(18).fork()).ldelim();
        if (message.evidence !== undefined) $ef8604053752c6d9$exports.EvidenceList.encode(message.evidence, writer.uint32(26).fork()).ldelim();
        if (message.lastCommit !== undefined) $c51af120eef1efed$exports.Commit.encode(message.lastCommit, writer.uint32(34).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $d343d7250542543a$var$_m0.Reader ? input : new $d343d7250542543a$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $d343d7250542543a$var$createBaseBlock();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.header = $c51af120eef1efed$exports.Header.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.data = $c51af120eef1efed$exports.Data.decode(reader, reader.uint32());
                    break;
                case 3:
                    message.evidence = $ef8604053752c6d9$exports.EvidenceList.decode(reader, reader.uint32());
                    break;
                case 4:
                    message.lastCommit = $c51af120eef1efed$exports.Commit.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            header: (0, $d5e07fe2518aae94$exports.isSet)(object.header) ? $c51af120eef1efed$exports.Header.fromJSON(object.header) : undefined,
            data: (0, $d5e07fe2518aae94$exports.isSet)(object.data) ? $c51af120eef1efed$exports.Data.fromJSON(object.data) : undefined,
            evidence: (0, $d5e07fe2518aae94$exports.isSet)(object.evidence) ? $ef8604053752c6d9$exports.EvidenceList.fromJSON(object.evidence) : undefined,
            lastCommit: (0, $d5e07fe2518aae94$exports.isSet)(object.lastCommit) ? $c51af120eef1efed$exports.Commit.fromJSON(object.lastCommit) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.header !== undefined && (obj.header = message.header ? $c51af120eef1efed$exports.Header.toJSON(message.header) : undefined);
        message.data !== undefined && (obj.data = message.data ? $c51af120eef1efed$exports.Data.toJSON(message.data) : undefined);
        message.evidence !== undefined && (obj.evidence = message.evidence ? $ef8604053752c6d9$exports.EvidenceList.toJSON(message.evidence) : undefined);
        message.lastCommit !== undefined && (obj.lastCommit = message.lastCommit ? $c51af120eef1efed$exports.Commit.toJSON(message.lastCommit) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $d343d7250542543a$var$createBaseBlock();
        message.header = object.header !== undefined && object.header !== null ? $c51af120eef1efed$exports.Header.fromPartial(object.header) : undefined;
        message.data = object.data !== undefined && object.data !== null ? $c51af120eef1efed$exports.Data.fromPartial(object.data) : undefined;
        message.evidence = object.evidence !== undefined && object.evidence !== null ? $ef8604053752c6d9$exports.EvidenceList.fromPartial(object.evidence) : undefined;
        message.lastCommit = object.lastCommit !== undefined && object.lastCommit !== null ? $c51af120eef1efed$exports.Commit.fromPartial(object.lastCommit) : undefined;
        return message;
    }
};




const $323b2a98c050ad7c$var$_m0 = $323b2a98c050ad7c$var$__importStar((parcelRequire("fQBv0")));
$323b2a98c050ad7c$exports.protobufPackage = "cosmos.tx.v1beta1";
/** OrderBy defines the sorting order */ var $323b2a98c050ad7c$var$OrderBy;
(function(OrderBy) {
    /** ORDER_BY_UNSPECIFIED - ORDER_BY_UNSPECIFIED specifies an unknown sorting order. OrderBy defaults to ASC in this case. */ OrderBy[OrderBy["ORDER_BY_UNSPECIFIED"] = 0] = "ORDER_BY_UNSPECIFIED";
    /** ORDER_BY_ASC - ORDER_BY_ASC defines ascending order */ OrderBy[OrderBy["ORDER_BY_ASC"] = 1] = "ORDER_BY_ASC";
    /** ORDER_BY_DESC - ORDER_BY_DESC defines descending order */ OrderBy[OrderBy["ORDER_BY_DESC"] = 2] = "ORDER_BY_DESC";
    OrderBy[OrderBy["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})($323b2a98c050ad7c$var$OrderBy = $323b2a98c050ad7c$exports.OrderBy || ($323b2a98c050ad7c$exports.OrderBy = {}));
function $323b2a98c050ad7c$var$orderByFromJSON(object) {
    switch(object){
        case 0:
        case "ORDER_BY_UNSPECIFIED":
            return $323b2a98c050ad7c$var$OrderBy.ORDER_BY_UNSPECIFIED;
        case 1:
        case "ORDER_BY_ASC":
            return $323b2a98c050ad7c$var$OrderBy.ORDER_BY_ASC;
        case 2:
        case "ORDER_BY_DESC":
            return $323b2a98c050ad7c$var$OrderBy.ORDER_BY_DESC;
        case -1:
        case "UNRECOGNIZED":
        default:
            return $323b2a98c050ad7c$var$OrderBy.UNRECOGNIZED;
    }
}
$323b2a98c050ad7c$exports.orderByFromJSON = $323b2a98c050ad7c$var$orderByFromJSON;
function $323b2a98c050ad7c$var$orderByToJSON(object) {
    switch(object){
        case $323b2a98c050ad7c$var$OrderBy.ORDER_BY_UNSPECIFIED:
            return "ORDER_BY_UNSPECIFIED";
        case $323b2a98c050ad7c$var$OrderBy.ORDER_BY_ASC:
            return "ORDER_BY_ASC";
        case $323b2a98c050ad7c$var$OrderBy.ORDER_BY_DESC:
            return "ORDER_BY_DESC";
        case $323b2a98c050ad7c$var$OrderBy.UNRECOGNIZED:
        default:
            return "UNRECOGNIZED";
    }
}
$323b2a98c050ad7c$exports.orderByToJSON = $323b2a98c050ad7c$var$orderByToJSON;
/** BroadcastMode specifies the broadcast mode for the TxService.Broadcast RPC method. */ var $323b2a98c050ad7c$var$BroadcastMode;
(function(BroadcastMode) {
    /** BROADCAST_MODE_UNSPECIFIED - zero-value for mode ordering */ BroadcastMode[BroadcastMode["BROADCAST_MODE_UNSPECIFIED"] = 0] = "BROADCAST_MODE_UNSPECIFIED";
    /**
     * BROADCAST_MODE_BLOCK - DEPRECATED: use BROADCAST_MODE_SYNC instead,
     * BROADCAST_MODE_BLOCK is not supported by the SDK from v0.47.x onwards.
     */ BroadcastMode[BroadcastMode["BROADCAST_MODE_BLOCK"] = 1] = "BROADCAST_MODE_BLOCK";
    /**
     * BROADCAST_MODE_SYNC - BROADCAST_MODE_SYNC defines a tx broadcasting mode where the client waits for
     * a CheckTx execution response only.
     */ BroadcastMode[BroadcastMode["BROADCAST_MODE_SYNC"] = 2] = "BROADCAST_MODE_SYNC";
    /**
     * BROADCAST_MODE_ASYNC - BROADCAST_MODE_ASYNC defines a tx broadcasting mode where the client returns
     * immediately.
     */ BroadcastMode[BroadcastMode["BROADCAST_MODE_ASYNC"] = 3] = "BROADCAST_MODE_ASYNC";
    BroadcastMode[BroadcastMode["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})($323b2a98c050ad7c$var$BroadcastMode = $323b2a98c050ad7c$exports.BroadcastMode || ($323b2a98c050ad7c$exports.BroadcastMode = {}));
function $323b2a98c050ad7c$var$broadcastModeFromJSON(object) {
    switch(object){
        case 0:
        case "BROADCAST_MODE_UNSPECIFIED":
            return $323b2a98c050ad7c$var$BroadcastMode.BROADCAST_MODE_UNSPECIFIED;
        case 1:
        case "BROADCAST_MODE_BLOCK":
            return $323b2a98c050ad7c$var$BroadcastMode.BROADCAST_MODE_BLOCK;
        case 2:
        case "BROADCAST_MODE_SYNC":
            return $323b2a98c050ad7c$var$BroadcastMode.BROADCAST_MODE_SYNC;
        case 3:
        case "BROADCAST_MODE_ASYNC":
            return $323b2a98c050ad7c$var$BroadcastMode.BROADCAST_MODE_ASYNC;
        case -1:
        case "UNRECOGNIZED":
        default:
            return $323b2a98c050ad7c$var$BroadcastMode.UNRECOGNIZED;
    }
}
$323b2a98c050ad7c$exports.broadcastModeFromJSON = $323b2a98c050ad7c$var$broadcastModeFromJSON;
function $323b2a98c050ad7c$var$broadcastModeToJSON(object) {
    switch(object){
        case $323b2a98c050ad7c$var$BroadcastMode.BROADCAST_MODE_UNSPECIFIED:
            return "BROADCAST_MODE_UNSPECIFIED";
        case $323b2a98c050ad7c$var$BroadcastMode.BROADCAST_MODE_BLOCK:
            return "BROADCAST_MODE_BLOCK";
        case $323b2a98c050ad7c$var$BroadcastMode.BROADCAST_MODE_SYNC:
            return "BROADCAST_MODE_SYNC";
        case $323b2a98c050ad7c$var$BroadcastMode.BROADCAST_MODE_ASYNC:
            return "BROADCAST_MODE_ASYNC";
        case $323b2a98c050ad7c$var$BroadcastMode.UNRECOGNIZED:
        default:
            return "UNRECOGNIZED";
    }
}
$323b2a98c050ad7c$exports.broadcastModeToJSON = $323b2a98c050ad7c$var$broadcastModeToJSON;
function $323b2a98c050ad7c$var$createBaseGetTxsEventRequest() {
    return {
        events: [],
        pagination: undefined,
        orderBy: 0,
        page: $d5e07fe2518aae94$exports.Long.UZERO,
        limit: $d5e07fe2518aae94$exports.Long.UZERO
    };
}
$323b2a98c050ad7c$exports.GetTxsEventRequest = {
    encode (message, writer = $323b2a98c050ad7c$var$_m0.Writer.create()) {
        for (const v of message.events)writer.uint32(10).string(v);
        if (message.pagination !== undefined) $5eae5f3cc99e92ab$exports.PageRequest.encode(message.pagination, writer.uint32(18).fork()).ldelim();
        if (message.orderBy !== 0) writer.uint32(24).int32(message.orderBy);
        if (!message.page.isZero()) writer.uint32(32).uint64(message.page);
        if (!message.limit.isZero()) writer.uint32(40).uint64(message.limit);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $323b2a98c050ad7c$var$_m0.Reader ? input : new $323b2a98c050ad7c$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $323b2a98c050ad7c$var$createBaseGetTxsEventRequest();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.events.push(reader.string());
                    break;
                case 2:
                    message.pagination = $5eae5f3cc99e92ab$exports.PageRequest.decode(reader, reader.uint32());
                    break;
                case 3:
                    message.orderBy = reader.int32();
                    break;
                case 4:
                    message.page = reader.uint64();
                    break;
                case 5:
                    message.limit = reader.uint64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            events: Array.isArray(object?.events) ? object.events.map((e)=>String(e)) : [],
            pagination: (0, $d5e07fe2518aae94$exports.isSet)(object.pagination) ? $5eae5f3cc99e92ab$exports.PageRequest.fromJSON(object.pagination) : undefined,
            orderBy: (0, $d5e07fe2518aae94$exports.isSet)(object.orderBy) ? $323b2a98c050ad7c$var$orderByFromJSON(object.orderBy) : 0,
            page: (0, $d5e07fe2518aae94$exports.isSet)(object.page) ? $d5e07fe2518aae94$exports.Long.fromValue(object.page) : $d5e07fe2518aae94$exports.Long.UZERO,
            limit: (0, $d5e07fe2518aae94$exports.isSet)(object.limit) ? $d5e07fe2518aae94$exports.Long.fromValue(object.limit) : $d5e07fe2518aae94$exports.Long.UZERO
        };
    },
    toJSON (message) {
        const obj = {};
        if (message.events) obj.events = message.events.map((e)=>e);
        else obj.events = [];
        message.pagination !== undefined && (obj.pagination = message.pagination ? $5eae5f3cc99e92ab$exports.PageRequest.toJSON(message.pagination) : undefined);
        message.orderBy !== undefined && (obj.orderBy = $323b2a98c050ad7c$var$orderByToJSON(message.orderBy));
        message.page !== undefined && (obj.page = (message.page || $d5e07fe2518aae94$exports.Long.UZERO).toString());
        message.limit !== undefined && (obj.limit = (message.limit || $d5e07fe2518aae94$exports.Long.UZERO).toString());
        return obj;
    },
    fromPartial (object) {
        const message = $323b2a98c050ad7c$var$createBaseGetTxsEventRequest();
        message.events = object.events?.map((e)=>e) || [];
        message.pagination = object.pagination !== undefined && object.pagination !== null ? $5eae5f3cc99e92ab$exports.PageRequest.fromPartial(object.pagination) : undefined;
        message.orderBy = object.orderBy ?? 0;
        message.page = object.page !== undefined && object.page !== null ? $d5e07fe2518aae94$exports.Long.fromValue(object.page) : $d5e07fe2518aae94$exports.Long.UZERO;
        message.limit = object.limit !== undefined && object.limit !== null ? $d5e07fe2518aae94$exports.Long.fromValue(object.limit) : $d5e07fe2518aae94$exports.Long.UZERO;
        return message;
    }
};
function $323b2a98c050ad7c$var$createBaseGetTxsEventResponse() {
    return {
        txs: [],
        txResponses: [],
        pagination: undefined,
        total: $d5e07fe2518aae94$exports.Long.UZERO
    };
}
$323b2a98c050ad7c$exports.GetTxsEventResponse = {
    encode (message, writer = $323b2a98c050ad7c$var$_m0.Writer.create()) {
        for (const v of message.txs)$eedf6d503be55212$exports.Tx.encode(v, writer.uint32(10).fork()).ldelim();
        for (const v of message.txResponses)$17fd3ea9d729df0d$exports.TxResponse.encode(v, writer.uint32(18).fork()).ldelim();
        if (message.pagination !== undefined) $5eae5f3cc99e92ab$exports.PageResponse.encode(message.pagination, writer.uint32(26).fork()).ldelim();
        if (!message.total.isZero()) writer.uint32(32).uint64(message.total);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $323b2a98c050ad7c$var$_m0.Reader ? input : new $323b2a98c050ad7c$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $323b2a98c050ad7c$var$createBaseGetTxsEventResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.txs.push($eedf6d503be55212$exports.Tx.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.txResponses.push($17fd3ea9d729df0d$exports.TxResponse.decode(reader, reader.uint32()));
                    break;
                case 3:
                    message.pagination = $5eae5f3cc99e92ab$exports.PageResponse.decode(reader, reader.uint32());
                    break;
                case 4:
                    message.total = reader.uint64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            txs: Array.isArray(object?.txs) ? object.txs.map((e)=>$eedf6d503be55212$exports.Tx.fromJSON(e)) : [],
            txResponses: Array.isArray(object?.txResponses) ? object.txResponses.map((e)=>$17fd3ea9d729df0d$exports.TxResponse.fromJSON(e)) : [],
            pagination: (0, $d5e07fe2518aae94$exports.isSet)(object.pagination) ? $5eae5f3cc99e92ab$exports.PageResponse.fromJSON(object.pagination) : undefined,
            total: (0, $d5e07fe2518aae94$exports.isSet)(object.total) ? $d5e07fe2518aae94$exports.Long.fromValue(object.total) : $d5e07fe2518aae94$exports.Long.UZERO
        };
    },
    toJSON (message) {
        const obj = {};
        if (message.txs) obj.txs = message.txs.map((e)=>e ? $eedf6d503be55212$exports.Tx.toJSON(e) : undefined);
        else obj.txs = [];
        if (message.txResponses) obj.txResponses = message.txResponses.map((e)=>e ? $17fd3ea9d729df0d$exports.TxResponse.toJSON(e) : undefined);
        else obj.txResponses = [];
        message.pagination !== undefined && (obj.pagination = message.pagination ? $5eae5f3cc99e92ab$exports.PageResponse.toJSON(message.pagination) : undefined);
        message.total !== undefined && (obj.total = (message.total || $d5e07fe2518aae94$exports.Long.UZERO).toString());
        return obj;
    },
    fromPartial (object) {
        const message = $323b2a98c050ad7c$var$createBaseGetTxsEventResponse();
        message.txs = object.txs?.map((e)=>$eedf6d503be55212$exports.Tx.fromPartial(e)) || [];
        message.txResponses = object.txResponses?.map((e)=>$17fd3ea9d729df0d$exports.TxResponse.fromPartial(e)) || [];
        message.pagination = object.pagination !== undefined && object.pagination !== null ? $5eae5f3cc99e92ab$exports.PageResponse.fromPartial(object.pagination) : undefined;
        message.total = object.total !== undefined && object.total !== null ? $d5e07fe2518aae94$exports.Long.fromValue(object.total) : $d5e07fe2518aae94$exports.Long.UZERO;
        return message;
    }
};
function $323b2a98c050ad7c$var$createBaseBroadcastTxRequest() {
    return {
        txBytes: new Uint8Array(),
        mode: 0
    };
}
$323b2a98c050ad7c$exports.BroadcastTxRequest = {
    encode (message, writer = $323b2a98c050ad7c$var$_m0.Writer.create()) {
        if (message.txBytes.length !== 0) writer.uint32(10).bytes(message.txBytes);
        if (message.mode !== 0) writer.uint32(16).int32(message.mode);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $323b2a98c050ad7c$var$_m0.Reader ? input : new $323b2a98c050ad7c$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $323b2a98c050ad7c$var$createBaseBroadcastTxRequest();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.txBytes = reader.bytes();
                    break;
                case 2:
                    message.mode = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            txBytes: (0, $d5e07fe2518aae94$exports.isSet)(object.txBytes) ? (0, $d5e07fe2518aae94$exports.bytesFromBase64)(object.txBytes) : new Uint8Array(),
            mode: (0, $d5e07fe2518aae94$exports.isSet)(object.mode) ? $323b2a98c050ad7c$var$broadcastModeFromJSON(object.mode) : 0
        };
    },
    toJSON (message) {
        const obj = {};
        message.txBytes !== undefined && (obj.txBytes = (0, $d5e07fe2518aae94$exports.base64FromBytes)(message.txBytes !== undefined ? message.txBytes : new Uint8Array()));
        message.mode !== undefined && (obj.mode = $323b2a98c050ad7c$var$broadcastModeToJSON(message.mode));
        return obj;
    },
    fromPartial (object) {
        const message = $323b2a98c050ad7c$var$createBaseBroadcastTxRequest();
        message.txBytes = object.txBytes ?? new Uint8Array();
        message.mode = object.mode ?? 0;
        return message;
    }
};
function $323b2a98c050ad7c$var$createBaseBroadcastTxResponse() {
    return {
        txResponse: undefined
    };
}
$323b2a98c050ad7c$exports.BroadcastTxResponse = {
    encode (message, writer = $323b2a98c050ad7c$var$_m0.Writer.create()) {
        if (message.txResponse !== undefined) $17fd3ea9d729df0d$exports.TxResponse.encode(message.txResponse, writer.uint32(10).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $323b2a98c050ad7c$var$_m0.Reader ? input : new $323b2a98c050ad7c$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $323b2a98c050ad7c$var$createBaseBroadcastTxResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.txResponse = $17fd3ea9d729df0d$exports.TxResponse.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            txResponse: (0, $d5e07fe2518aae94$exports.isSet)(object.txResponse) ? $17fd3ea9d729df0d$exports.TxResponse.fromJSON(object.txResponse) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.txResponse !== undefined && (obj.txResponse = message.txResponse ? $17fd3ea9d729df0d$exports.TxResponse.toJSON(message.txResponse) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $323b2a98c050ad7c$var$createBaseBroadcastTxResponse();
        message.txResponse = object.txResponse !== undefined && object.txResponse !== null ? $17fd3ea9d729df0d$exports.TxResponse.fromPartial(object.txResponse) : undefined;
        return message;
    }
};
function $323b2a98c050ad7c$var$createBaseSimulateRequest() {
    return {
        tx: undefined,
        txBytes: new Uint8Array()
    };
}
$323b2a98c050ad7c$exports.SimulateRequest = {
    encode (message, writer = $323b2a98c050ad7c$var$_m0.Writer.create()) {
        if (message.tx !== undefined) $eedf6d503be55212$exports.Tx.encode(message.tx, writer.uint32(10).fork()).ldelim();
        if (message.txBytes.length !== 0) writer.uint32(18).bytes(message.txBytes);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $323b2a98c050ad7c$var$_m0.Reader ? input : new $323b2a98c050ad7c$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $323b2a98c050ad7c$var$createBaseSimulateRequest();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.tx = $eedf6d503be55212$exports.Tx.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.txBytes = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            tx: (0, $d5e07fe2518aae94$exports.isSet)(object.tx) ? $eedf6d503be55212$exports.Tx.fromJSON(object.tx) : undefined,
            txBytes: (0, $d5e07fe2518aae94$exports.isSet)(object.txBytes) ? (0, $d5e07fe2518aae94$exports.bytesFromBase64)(object.txBytes) : new Uint8Array()
        };
    },
    toJSON (message) {
        const obj = {};
        message.tx !== undefined && (obj.tx = message.tx ? $eedf6d503be55212$exports.Tx.toJSON(message.tx) : undefined);
        message.txBytes !== undefined && (obj.txBytes = (0, $d5e07fe2518aae94$exports.base64FromBytes)(message.txBytes !== undefined ? message.txBytes : new Uint8Array()));
        return obj;
    },
    fromPartial (object) {
        const message = $323b2a98c050ad7c$var$createBaseSimulateRequest();
        message.tx = object.tx !== undefined && object.tx !== null ? $eedf6d503be55212$exports.Tx.fromPartial(object.tx) : undefined;
        message.txBytes = object.txBytes ?? new Uint8Array();
        return message;
    }
};
function $323b2a98c050ad7c$var$createBaseSimulateResponse() {
    return {
        gasInfo: undefined,
        result: undefined
    };
}
$323b2a98c050ad7c$exports.SimulateResponse = {
    encode (message, writer = $323b2a98c050ad7c$var$_m0.Writer.create()) {
        if (message.gasInfo !== undefined) $17fd3ea9d729df0d$exports.GasInfo.encode(message.gasInfo, writer.uint32(10).fork()).ldelim();
        if (message.result !== undefined) $17fd3ea9d729df0d$exports.Result.encode(message.result, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $323b2a98c050ad7c$var$_m0.Reader ? input : new $323b2a98c050ad7c$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $323b2a98c050ad7c$var$createBaseSimulateResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.gasInfo = $17fd3ea9d729df0d$exports.GasInfo.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.result = $17fd3ea9d729df0d$exports.Result.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            gasInfo: (0, $d5e07fe2518aae94$exports.isSet)(object.gasInfo) ? $17fd3ea9d729df0d$exports.GasInfo.fromJSON(object.gasInfo) : undefined,
            result: (0, $d5e07fe2518aae94$exports.isSet)(object.result) ? $17fd3ea9d729df0d$exports.Result.fromJSON(object.result) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.gasInfo !== undefined && (obj.gasInfo = message.gasInfo ? $17fd3ea9d729df0d$exports.GasInfo.toJSON(message.gasInfo) : undefined);
        message.result !== undefined && (obj.result = message.result ? $17fd3ea9d729df0d$exports.Result.toJSON(message.result) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $323b2a98c050ad7c$var$createBaseSimulateResponse();
        message.gasInfo = object.gasInfo !== undefined && object.gasInfo !== null ? $17fd3ea9d729df0d$exports.GasInfo.fromPartial(object.gasInfo) : undefined;
        message.result = object.result !== undefined && object.result !== null ? $17fd3ea9d729df0d$exports.Result.fromPartial(object.result) : undefined;
        return message;
    }
};
function $323b2a98c050ad7c$var$createBaseGetTxRequest() {
    return {
        hash: ""
    };
}
$323b2a98c050ad7c$exports.GetTxRequest = {
    encode (message, writer = $323b2a98c050ad7c$var$_m0.Writer.create()) {
        if (message.hash !== "") writer.uint32(10).string(message.hash);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $323b2a98c050ad7c$var$_m0.Reader ? input : new $323b2a98c050ad7c$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $323b2a98c050ad7c$var$createBaseGetTxRequest();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.hash = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            hash: (0, $d5e07fe2518aae94$exports.isSet)(object.hash) ? String(object.hash) : ""
        };
    },
    toJSON (message) {
        const obj = {};
        message.hash !== undefined && (obj.hash = message.hash);
        return obj;
    },
    fromPartial (object) {
        const message = $323b2a98c050ad7c$var$createBaseGetTxRequest();
        message.hash = object.hash ?? "";
        return message;
    }
};
function $323b2a98c050ad7c$var$createBaseGetTxResponse() {
    return {
        tx: undefined,
        txResponse: undefined
    };
}
$323b2a98c050ad7c$exports.GetTxResponse = {
    encode (message, writer = $323b2a98c050ad7c$var$_m0.Writer.create()) {
        if (message.tx !== undefined) $eedf6d503be55212$exports.Tx.encode(message.tx, writer.uint32(10).fork()).ldelim();
        if (message.txResponse !== undefined) $17fd3ea9d729df0d$exports.TxResponse.encode(message.txResponse, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $323b2a98c050ad7c$var$_m0.Reader ? input : new $323b2a98c050ad7c$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $323b2a98c050ad7c$var$createBaseGetTxResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.tx = $eedf6d503be55212$exports.Tx.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.txResponse = $17fd3ea9d729df0d$exports.TxResponse.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            tx: (0, $d5e07fe2518aae94$exports.isSet)(object.tx) ? $eedf6d503be55212$exports.Tx.fromJSON(object.tx) : undefined,
            txResponse: (0, $d5e07fe2518aae94$exports.isSet)(object.txResponse) ? $17fd3ea9d729df0d$exports.TxResponse.fromJSON(object.txResponse) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.tx !== undefined && (obj.tx = message.tx ? $eedf6d503be55212$exports.Tx.toJSON(message.tx) : undefined);
        message.txResponse !== undefined && (obj.txResponse = message.txResponse ? $17fd3ea9d729df0d$exports.TxResponse.toJSON(message.txResponse) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $323b2a98c050ad7c$var$createBaseGetTxResponse();
        message.tx = object.tx !== undefined && object.tx !== null ? $eedf6d503be55212$exports.Tx.fromPartial(object.tx) : undefined;
        message.txResponse = object.txResponse !== undefined && object.txResponse !== null ? $17fd3ea9d729df0d$exports.TxResponse.fromPartial(object.txResponse) : undefined;
        return message;
    }
};
function $323b2a98c050ad7c$var$createBaseGetBlockWithTxsRequest() {
    return {
        height: $d5e07fe2518aae94$exports.Long.ZERO,
        pagination: undefined
    };
}
$323b2a98c050ad7c$exports.GetBlockWithTxsRequest = {
    encode (message, writer = $323b2a98c050ad7c$var$_m0.Writer.create()) {
        if (!message.height.isZero()) writer.uint32(8).int64(message.height);
        if (message.pagination !== undefined) $5eae5f3cc99e92ab$exports.PageRequest.encode(message.pagination, writer.uint32(18).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $323b2a98c050ad7c$var$_m0.Reader ? input : new $323b2a98c050ad7c$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $323b2a98c050ad7c$var$createBaseGetBlockWithTxsRequest();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.height = reader.int64();
                    break;
                case 2:
                    message.pagination = $5eae5f3cc99e92ab$exports.PageRequest.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            height: (0, $d5e07fe2518aae94$exports.isSet)(object.height) ? $d5e07fe2518aae94$exports.Long.fromValue(object.height) : $d5e07fe2518aae94$exports.Long.ZERO,
            pagination: (0, $d5e07fe2518aae94$exports.isSet)(object.pagination) ? $5eae5f3cc99e92ab$exports.PageRequest.fromJSON(object.pagination) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.height !== undefined && (obj.height = (message.height || $d5e07fe2518aae94$exports.Long.ZERO).toString());
        message.pagination !== undefined && (obj.pagination = message.pagination ? $5eae5f3cc99e92ab$exports.PageRequest.toJSON(message.pagination) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $323b2a98c050ad7c$var$createBaseGetBlockWithTxsRequest();
        message.height = object.height !== undefined && object.height !== null ? $d5e07fe2518aae94$exports.Long.fromValue(object.height) : $d5e07fe2518aae94$exports.Long.ZERO;
        message.pagination = object.pagination !== undefined && object.pagination !== null ? $5eae5f3cc99e92ab$exports.PageRequest.fromPartial(object.pagination) : undefined;
        return message;
    }
};
function $323b2a98c050ad7c$var$createBaseGetBlockWithTxsResponse() {
    return {
        txs: [],
        blockId: undefined,
        block: undefined,
        pagination: undefined
    };
}
$323b2a98c050ad7c$exports.GetBlockWithTxsResponse = {
    encode (message, writer = $323b2a98c050ad7c$var$_m0.Writer.create()) {
        for (const v of message.txs)$eedf6d503be55212$exports.Tx.encode(v, writer.uint32(10).fork()).ldelim();
        if (message.blockId !== undefined) $c51af120eef1efed$exports.BlockID.encode(message.blockId, writer.uint32(18).fork()).ldelim();
        if (message.block !== undefined) $d343d7250542543a$exports.Block.encode(message.block, writer.uint32(26).fork()).ldelim();
        if (message.pagination !== undefined) $5eae5f3cc99e92ab$exports.PageResponse.encode(message.pagination, writer.uint32(34).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $323b2a98c050ad7c$var$_m0.Reader ? input : new $323b2a98c050ad7c$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $323b2a98c050ad7c$var$createBaseGetBlockWithTxsResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.txs.push($eedf6d503be55212$exports.Tx.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.blockId = $c51af120eef1efed$exports.BlockID.decode(reader, reader.uint32());
                    break;
                case 3:
                    message.block = $d343d7250542543a$exports.Block.decode(reader, reader.uint32());
                    break;
                case 4:
                    message.pagination = $5eae5f3cc99e92ab$exports.PageResponse.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            txs: Array.isArray(object?.txs) ? object.txs.map((e)=>$eedf6d503be55212$exports.Tx.fromJSON(e)) : [],
            blockId: (0, $d5e07fe2518aae94$exports.isSet)(object.blockId) ? $c51af120eef1efed$exports.BlockID.fromJSON(object.blockId) : undefined,
            block: (0, $d5e07fe2518aae94$exports.isSet)(object.block) ? $d343d7250542543a$exports.Block.fromJSON(object.block) : undefined,
            pagination: (0, $d5e07fe2518aae94$exports.isSet)(object.pagination) ? $5eae5f3cc99e92ab$exports.PageResponse.fromJSON(object.pagination) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        if (message.txs) obj.txs = message.txs.map((e)=>e ? $eedf6d503be55212$exports.Tx.toJSON(e) : undefined);
        else obj.txs = [];
        message.blockId !== undefined && (obj.blockId = message.blockId ? $c51af120eef1efed$exports.BlockID.toJSON(message.blockId) : undefined);
        message.block !== undefined && (obj.block = message.block ? $d343d7250542543a$exports.Block.toJSON(message.block) : undefined);
        message.pagination !== undefined && (obj.pagination = message.pagination ? $5eae5f3cc99e92ab$exports.PageResponse.toJSON(message.pagination) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $323b2a98c050ad7c$var$createBaseGetBlockWithTxsResponse();
        message.txs = object.txs?.map((e)=>$eedf6d503be55212$exports.Tx.fromPartial(e)) || [];
        message.blockId = object.blockId !== undefined && object.blockId !== null ? $c51af120eef1efed$exports.BlockID.fromPartial(object.blockId) : undefined;
        message.block = object.block !== undefined && object.block !== null ? $d343d7250542543a$exports.Block.fromPartial(object.block) : undefined;
        message.pagination = object.pagination !== undefined && object.pagination !== null ? $5eae5f3cc99e92ab$exports.PageResponse.fromPartial(object.pagination) : undefined;
        return message;
    }
};
function $323b2a98c050ad7c$var$createBaseTxDecodeRequest() {
    return {
        txBytes: new Uint8Array()
    };
}
$323b2a98c050ad7c$exports.TxDecodeRequest = {
    encode (message, writer = $323b2a98c050ad7c$var$_m0.Writer.create()) {
        if (message.txBytes.length !== 0) writer.uint32(10).bytes(message.txBytes);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $323b2a98c050ad7c$var$_m0.Reader ? input : new $323b2a98c050ad7c$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $323b2a98c050ad7c$var$createBaseTxDecodeRequest();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.txBytes = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            txBytes: (0, $d5e07fe2518aae94$exports.isSet)(object.txBytes) ? (0, $d5e07fe2518aae94$exports.bytesFromBase64)(object.txBytes) : new Uint8Array()
        };
    },
    toJSON (message) {
        const obj = {};
        message.txBytes !== undefined && (obj.txBytes = (0, $d5e07fe2518aae94$exports.base64FromBytes)(message.txBytes !== undefined ? message.txBytes : new Uint8Array()));
        return obj;
    },
    fromPartial (object) {
        const message = $323b2a98c050ad7c$var$createBaseTxDecodeRequest();
        message.txBytes = object.txBytes ?? new Uint8Array();
        return message;
    }
};
function $323b2a98c050ad7c$var$createBaseTxDecodeResponse() {
    return {
        tx: undefined
    };
}
$323b2a98c050ad7c$exports.TxDecodeResponse = {
    encode (message, writer = $323b2a98c050ad7c$var$_m0.Writer.create()) {
        if (message.tx !== undefined) $eedf6d503be55212$exports.Tx.encode(message.tx, writer.uint32(10).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $323b2a98c050ad7c$var$_m0.Reader ? input : new $323b2a98c050ad7c$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $323b2a98c050ad7c$var$createBaseTxDecodeResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.tx = $eedf6d503be55212$exports.Tx.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            tx: (0, $d5e07fe2518aae94$exports.isSet)(object.tx) ? $eedf6d503be55212$exports.Tx.fromJSON(object.tx) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.tx !== undefined && (obj.tx = message.tx ? $eedf6d503be55212$exports.Tx.toJSON(message.tx) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $323b2a98c050ad7c$var$createBaseTxDecodeResponse();
        message.tx = object.tx !== undefined && object.tx !== null ? $eedf6d503be55212$exports.Tx.fromPartial(object.tx) : undefined;
        return message;
    }
};
function $323b2a98c050ad7c$var$createBaseTxEncodeRequest() {
    return {
        tx: undefined
    };
}
$323b2a98c050ad7c$exports.TxEncodeRequest = {
    encode (message, writer = $323b2a98c050ad7c$var$_m0.Writer.create()) {
        if (message.tx !== undefined) $eedf6d503be55212$exports.Tx.encode(message.tx, writer.uint32(10).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $323b2a98c050ad7c$var$_m0.Reader ? input : new $323b2a98c050ad7c$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $323b2a98c050ad7c$var$createBaseTxEncodeRequest();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.tx = $eedf6d503be55212$exports.Tx.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            tx: (0, $d5e07fe2518aae94$exports.isSet)(object.tx) ? $eedf6d503be55212$exports.Tx.fromJSON(object.tx) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.tx !== undefined && (obj.tx = message.tx ? $eedf6d503be55212$exports.Tx.toJSON(message.tx) : undefined);
        return obj;
    },
    fromPartial (object) {
        const message = $323b2a98c050ad7c$var$createBaseTxEncodeRequest();
        message.tx = object.tx !== undefined && object.tx !== null ? $eedf6d503be55212$exports.Tx.fromPartial(object.tx) : undefined;
        return message;
    }
};
function $323b2a98c050ad7c$var$createBaseTxEncodeResponse() {
    return {
        txBytes: new Uint8Array()
    };
}
$323b2a98c050ad7c$exports.TxEncodeResponse = {
    encode (message, writer = $323b2a98c050ad7c$var$_m0.Writer.create()) {
        if (message.txBytes.length !== 0) writer.uint32(10).bytes(message.txBytes);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $323b2a98c050ad7c$var$_m0.Reader ? input : new $323b2a98c050ad7c$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $323b2a98c050ad7c$var$createBaseTxEncodeResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.txBytes = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            txBytes: (0, $d5e07fe2518aae94$exports.isSet)(object.txBytes) ? (0, $d5e07fe2518aae94$exports.bytesFromBase64)(object.txBytes) : new Uint8Array()
        };
    },
    toJSON (message) {
        const obj = {};
        message.txBytes !== undefined && (obj.txBytes = (0, $d5e07fe2518aae94$exports.base64FromBytes)(message.txBytes !== undefined ? message.txBytes : new Uint8Array()));
        return obj;
    },
    fromPartial (object) {
        const message = $323b2a98c050ad7c$var$createBaseTxEncodeResponse();
        message.txBytes = object.txBytes ?? new Uint8Array();
        return message;
    }
};
function $323b2a98c050ad7c$var$createBaseTxEncodeAminoRequest() {
    return {
        aminoJson: ""
    };
}
$323b2a98c050ad7c$exports.TxEncodeAminoRequest = {
    encode (message, writer = $323b2a98c050ad7c$var$_m0.Writer.create()) {
        if (message.aminoJson !== "") writer.uint32(10).string(message.aminoJson);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $323b2a98c050ad7c$var$_m0.Reader ? input : new $323b2a98c050ad7c$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $323b2a98c050ad7c$var$createBaseTxEncodeAminoRequest();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.aminoJson = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            aminoJson: (0, $d5e07fe2518aae94$exports.isSet)(object.aminoJson) ? String(object.aminoJson) : ""
        };
    },
    toJSON (message) {
        const obj = {};
        message.aminoJson !== undefined && (obj.aminoJson = message.aminoJson);
        return obj;
    },
    fromPartial (object) {
        const message = $323b2a98c050ad7c$var$createBaseTxEncodeAminoRequest();
        message.aminoJson = object.aminoJson ?? "";
        return message;
    }
};
function $323b2a98c050ad7c$var$createBaseTxEncodeAminoResponse() {
    return {
        aminoBinary: new Uint8Array()
    };
}
$323b2a98c050ad7c$exports.TxEncodeAminoResponse = {
    encode (message, writer = $323b2a98c050ad7c$var$_m0.Writer.create()) {
        if (message.aminoBinary.length !== 0) writer.uint32(10).bytes(message.aminoBinary);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $323b2a98c050ad7c$var$_m0.Reader ? input : new $323b2a98c050ad7c$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $323b2a98c050ad7c$var$createBaseTxEncodeAminoResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.aminoBinary = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            aminoBinary: (0, $d5e07fe2518aae94$exports.isSet)(object.aminoBinary) ? (0, $d5e07fe2518aae94$exports.bytesFromBase64)(object.aminoBinary) : new Uint8Array()
        };
    },
    toJSON (message) {
        const obj = {};
        message.aminoBinary !== undefined && (obj.aminoBinary = (0, $d5e07fe2518aae94$exports.base64FromBytes)(message.aminoBinary !== undefined ? message.aminoBinary : new Uint8Array()));
        return obj;
    },
    fromPartial (object) {
        const message = $323b2a98c050ad7c$var$createBaseTxEncodeAminoResponse();
        message.aminoBinary = object.aminoBinary ?? new Uint8Array();
        return message;
    }
};
function $323b2a98c050ad7c$var$createBaseTxDecodeAminoRequest() {
    return {
        aminoBinary: new Uint8Array()
    };
}
$323b2a98c050ad7c$exports.TxDecodeAminoRequest = {
    encode (message, writer = $323b2a98c050ad7c$var$_m0.Writer.create()) {
        if (message.aminoBinary.length !== 0) writer.uint32(10).bytes(message.aminoBinary);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $323b2a98c050ad7c$var$_m0.Reader ? input : new $323b2a98c050ad7c$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $323b2a98c050ad7c$var$createBaseTxDecodeAminoRequest();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.aminoBinary = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            aminoBinary: (0, $d5e07fe2518aae94$exports.isSet)(object.aminoBinary) ? (0, $d5e07fe2518aae94$exports.bytesFromBase64)(object.aminoBinary) : new Uint8Array()
        };
    },
    toJSON (message) {
        const obj = {};
        message.aminoBinary !== undefined && (obj.aminoBinary = (0, $d5e07fe2518aae94$exports.base64FromBytes)(message.aminoBinary !== undefined ? message.aminoBinary : new Uint8Array()));
        return obj;
    },
    fromPartial (object) {
        const message = $323b2a98c050ad7c$var$createBaseTxDecodeAminoRequest();
        message.aminoBinary = object.aminoBinary ?? new Uint8Array();
        return message;
    }
};
function $323b2a98c050ad7c$var$createBaseTxDecodeAminoResponse() {
    return {
        aminoJson: ""
    };
}
$323b2a98c050ad7c$exports.TxDecodeAminoResponse = {
    encode (message, writer = $323b2a98c050ad7c$var$_m0.Writer.create()) {
        if (message.aminoJson !== "") writer.uint32(10).string(message.aminoJson);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $323b2a98c050ad7c$var$_m0.Reader ? input : new $323b2a98c050ad7c$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $323b2a98c050ad7c$var$createBaseTxDecodeAminoResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.aminoJson = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            aminoJson: (0, $d5e07fe2518aae94$exports.isSet)(object.aminoJson) ? String(object.aminoJson) : ""
        };
    },
    toJSON (message) {
        const obj = {};
        message.aminoJson !== undefined && (obj.aminoJson = message.aminoJson);
        return obj;
    },
    fromPartial (object) {
        const message = $323b2a98c050ad7c$var$createBaseTxDecodeAminoResponse();
        message.aminoJson = object.aminoJson ?? "";
        return message;
    }
};
class $323b2a98c050ad7c$var$ServiceClientImpl {
    constructor(rpc){
        this.rpc = rpc;
        this.Simulate = this.Simulate.bind(this);
        this.GetTx = this.GetTx.bind(this);
        this.BroadcastTx = this.BroadcastTx.bind(this);
        this.GetTxsEvent = this.GetTxsEvent.bind(this);
        this.GetBlockWithTxs = this.GetBlockWithTxs.bind(this);
        this.TxDecode = this.TxDecode.bind(this);
        this.TxEncode = this.TxEncode.bind(this);
        this.TxEncodeAmino = this.TxEncodeAmino.bind(this);
        this.TxDecodeAmino = this.TxDecodeAmino.bind(this);
    }
    Simulate(request) {
        const data = $323b2a98c050ad7c$exports.SimulateRequest.encode(request).finish();
        const promise = this.rpc.request("cosmos.tx.v1beta1.Service", "Simulate", data);
        return promise.then((data)=>$323b2a98c050ad7c$exports.SimulateResponse.decode(new $323b2a98c050ad7c$var$_m0.Reader(data)));
    }
    GetTx(request) {
        const data = $323b2a98c050ad7c$exports.GetTxRequest.encode(request).finish();
        const promise = this.rpc.request("cosmos.tx.v1beta1.Service", "GetTx", data);
        return promise.then((data)=>$323b2a98c050ad7c$exports.GetTxResponse.decode(new $323b2a98c050ad7c$var$_m0.Reader(data)));
    }
    BroadcastTx(request) {
        const data = $323b2a98c050ad7c$exports.BroadcastTxRequest.encode(request).finish();
        const promise = this.rpc.request("cosmos.tx.v1beta1.Service", "BroadcastTx", data);
        return promise.then((data)=>$323b2a98c050ad7c$exports.BroadcastTxResponse.decode(new $323b2a98c050ad7c$var$_m0.Reader(data)));
    }
    GetTxsEvent(request) {
        const data = $323b2a98c050ad7c$exports.GetTxsEventRequest.encode(request).finish();
        const promise = this.rpc.request("cosmos.tx.v1beta1.Service", "GetTxsEvent", data);
        return promise.then((data)=>$323b2a98c050ad7c$exports.GetTxsEventResponse.decode(new $323b2a98c050ad7c$var$_m0.Reader(data)));
    }
    GetBlockWithTxs(request) {
        const data = $323b2a98c050ad7c$exports.GetBlockWithTxsRequest.encode(request).finish();
        const promise = this.rpc.request("cosmos.tx.v1beta1.Service", "GetBlockWithTxs", data);
        return promise.then((data)=>$323b2a98c050ad7c$exports.GetBlockWithTxsResponse.decode(new $323b2a98c050ad7c$var$_m0.Reader(data)));
    }
    TxDecode(request) {
        const data = $323b2a98c050ad7c$exports.TxDecodeRequest.encode(request).finish();
        const promise = this.rpc.request("cosmos.tx.v1beta1.Service", "TxDecode", data);
        return promise.then((data)=>$323b2a98c050ad7c$exports.TxDecodeResponse.decode(new $323b2a98c050ad7c$var$_m0.Reader(data)));
    }
    TxEncode(request) {
        const data = $323b2a98c050ad7c$exports.TxEncodeRequest.encode(request).finish();
        const promise = this.rpc.request("cosmos.tx.v1beta1.Service", "TxEncode", data);
        return promise.then((data)=>$323b2a98c050ad7c$exports.TxEncodeResponse.decode(new $323b2a98c050ad7c$var$_m0.Reader(data)));
    }
    TxEncodeAmino(request) {
        const data = $323b2a98c050ad7c$exports.TxEncodeAminoRequest.encode(request).finish();
        const promise = this.rpc.request("cosmos.tx.v1beta1.Service", "TxEncodeAmino", data);
        return promise.then((data)=>$323b2a98c050ad7c$exports.TxEncodeAminoResponse.decode(new $323b2a98c050ad7c$var$_m0.Reader(data)));
    }
    TxDecodeAmino(request) {
        const data = $323b2a98c050ad7c$exports.TxDecodeAminoRequest.encode(request).finish();
        const promise = this.rpc.request("cosmos.tx.v1beta1.Service", "TxDecodeAmino", data);
        return promise.then((data)=>$323b2a98c050ad7c$exports.TxDecodeAminoResponse.decode(new $323b2a98c050ad7c$var$_m0.Reader(data)));
    }
}
$323b2a98c050ad7c$exports.ServiceClientImpl = $323b2a98c050ad7c$var$ServiceClientImpl;




const $f2d5c2d4fccc9533$var$long_1 = $f2d5c2d4fccc9533$var$__importDefault((parcelRequire("jRkuS")));

function $f2d5c2d4fccc9533$var$setupTxExtension(base) {
    // Use this service to get easy typed access to query methods
    // This cannot be used for proof verification
    const rpc = (0, $a3959936d2cce854$exports.createProtobufRpcClient)(base);
    const queryService = new $323b2a98c050ad7c$exports.ServiceClientImpl(rpc);
    return {
        tx: {
            getTx: async (txId)=>{
                const request = {
                    hash: txId
                };
                const response = await queryService.GetTx(request);
                return response;
            },
            simulate: async (messages, memo, signer, sequence)=>{
                const tx = $eedf6d503be55212$exports.Tx.fromPartial({
                    authInfo: $eedf6d503be55212$exports.AuthInfo.fromPartial({
                        fee: $eedf6d503be55212$exports.Fee.fromPartial({}),
                        signerInfos: [
                            {
                                publicKey: (0, $c0a9381c50e8ee56$exports.encodePubkey)(signer),
                                sequence: $f2d5c2d4fccc9533$var$long_1.default.fromNumber(sequence, true),
                                modeInfo: {
                                    single: {
                                        mode: $cefef10ba181af21$exports.SignMode.SIGN_MODE_UNSPECIFIED
                                    }
                                }
                            }
                        ]
                    }),
                    body: $eedf6d503be55212$exports.TxBody.fromPartial({
                        messages: Array.from(messages),
                        memo: memo
                    }),
                    signatures: [
                        new Uint8Array()
                    ]
                });
                const request = $323b2a98c050ad7c$exports.SimulateRequest.fromPartial({
                    txBytes: $eedf6d503be55212$exports.Tx.encode(tx).finish()
                });
                const response = await queryService.Simulate(request);
                return response;
            }
        }
    };
}
$f2d5c2d4fccc9533$exports.setupTxExtension = $f2d5c2d4fccc9533$var$setupTxExtension;


Object.defineProperty($d0d8b6f4712acd9f$exports, "setupTxExtension", {
    enumerable: true,
    get: function() {
        return $f2d5c2d4fccc9533$exports.setupTxExtension;
    }
});
var $ee61fed520370c4b$exports = {};
"use strict";
var $ee61fed520370c4b$var$__importDefault = $ee61fed520370c4b$exports && $ee61fed520370c4b$exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty($ee61fed520370c4b$exports, "__esModule", {
    value: true
});
$ee61fed520370c4b$exports.createVestingAminoConverters = $ee61fed520370c4b$exports.isAminoMsgCreateVestingAccount = void 0;

const $ee61fed520370c4b$var$long_1 = $ee61fed520370c4b$var$__importDefault((parcelRequire("jRkuS")));
function $ee61fed520370c4b$var$isAminoMsgCreateVestingAccount(msg) {
    return msg.type === "cosmos-sdk/MsgCreateVestingAccount";
}
$ee61fed520370c4b$exports.isAminoMsgCreateVestingAccount = $ee61fed520370c4b$var$isAminoMsgCreateVestingAccount;
function $ee61fed520370c4b$var$createVestingAminoConverters() {
    return {
        "/cosmos.vesting.v1beta1.MsgCreateVestingAccount": {
            aminoType: "cosmos-sdk/MsgCreateVestingAccount",
            toAmino: ({ fromAddress: fromAddress, toAddress: toAddress, amount: amount, endTime: endTime, delayed: delayed })=>({
                    from_address: fromAddress,
                    to_address: toAddress,
                    amount: [
                        ...amount
                    ],
                    end_time: endTime.toString(),
                    delayed: delayed
                }),
            fromAmino: ({ from_address: from_address, to_address: to_address, amount: amount, end_time: end_time, delayed: delayed })=>({
                    fromAddress: from_address,
                    toAddress: to_address,
                    amount: [
                        ...amount
                    ],
                    endTime: $ee61fed520370c4b$var$long_1.default.fromString(end_time),
                    delayed: delayed
                })
        }
    };
}
$ee61fed520370c4b$exports.createVestingAminoConverters = $ee61fed520370c4b$var$createVestingAminoConverters;


Object.defineProperty($d0d8b6f4712acd9f$exports, "createVestingAminoConverters", {
    enumerable: true,
    get: function() {
        return $ee61fed520370c4b$exports.createVestingAminoConverters;
    }
});
Object.defineProperty($d0d8b6f4712acd9f$exports, "isAminoMsgCreateVestingAccount", {
    enumerable: true,
    get: function() {
        return $ee61fed520370c4b$exports.isAminoMsgCreateVestingAccount;
    }
});
var $e1f07bcad8d20461$exports = {};
"use strict";
Object.defineProperty($e1f07bcad8d20461$exports, "__esModule", {
    value: true
});
$e1f07bcad8d20461$exports.vestingTypes = void 0;
var $dfe36d3c28eb0b40$exports = {};
"use strict";
var $dfe36d3c28eb0b40$var$__createBinding = $dfe36d3c28eb0b40$exports && $dfe36d3c28eb0b40$exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $dfe36d3c28eb0b40$var$__setModuleDefault = $dfe36d3c28eb0b40$exports && $dfe36d3c28eb0b40$exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $dfe36d3c28eb0b40$var$__importStar = $dfe36d3c28eb0b40$exports && $dfe36d3c28eb0b40$exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $dfe36d3c28eb0b40$var$__createBinding(result, mod, k);
    }
    $dfe36d3c28eb0b40$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty($dfe36d3c28eb0b40$exports, "__esModule", {
    value: true
});
$dfe36d3c28eb0b40$exports.MsgClientImpl = $dfe36d3c28eb0b40$exports.MsgCreatePeriodicVestingAccountResponse = $dfe36d3c28eb0b40$exports.MsgCreatePeriodicVestingAccount = $dfe36d3c28eb0b40$exports.MsgCreatePermanentLockedAccountResponse = $dfe36d3c28eb0b40$exports.MsgCreatePermanentLockedAccount = $dfe36d3c28eb0b40$exports.MsgCreateVestingAccountResponse = $dfe36d3c28eb0b40$exports.MsgCreateVestingAccount = $dfe36d3c28eb0b40$exports.protobufPackage = void 0;




const $dfe36d3c28eb0b40$var$_m0 = $dfe36d3c28eb0b40$var$__importStar((parcelRequire("fQBv0")));
$dfe36d3c28eb0b40$exports.protobufPackage = "cosmos.vesting.v1beta1";
function $dfe36d3c28eb0b40$var$createBaseMsgCreateVestingAccount() {
    return {
        fromAddress: "",
        toAddress: "",
        amount: [],
        endTime: $d5e07fe2518aae94$exports.Long.ZERO,
        delayed: false
    };
}
$dfe36d3c28eb0b40$exports.MsgCreateVestingAccount = {
    encode (message, writer = $dfe36d3c28eb0b40$var$_m0.Writer.create()) {
        if (message.fromAddress !== "") writer.uint32(10).string(message.fromAddress);
        if (message.toAddress !== "") writer.uint32(18).string(message.toAddress);
        for (const v of message.amount)$783dd8715fde0fcf$exports.Coin.encode(v, writer.uint32(26).fork()).ldelim();
        if (!message.endTime.isZero()) writer.uint32(32).int64(message.endTime);
        if (message.delayed === true) writer.uint32(40).bool(message.delayed);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $dfe36d3c28eb0b40$var$_m0.Reader ? input : new $dfe36d3c28eb0b40$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $dfe36d3c28eb0b40$var$createBaseMsgCreateVestingAccount();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.fromAddress = reader.string();
                    break;
                case 2:
                    message.toAddress = reader.string();
                    break;
                case 3:
                    message.amount.push($783dd8715fde0fcf$exports.Coin.decode(reader, reader.uint32()));
                    break;
                case 4:
                    message.endTime = reader.int64();
                    break;
                case 5:
                    message.delayed = reader.bool();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            fromAddress: (0, $d5e07fe2518aae94$exports.isSet)(object.fromAddress) ? String(object.fromAddress) : "",
            toAddress: (0, $d5e07fe2518aae94$exports.isSet)(object.toAddress) ? String(object.toAddress) : "",
            amount: Array.isArray(object?.amount) ? object.amount.map((e)=>$783dd8715fde0fcf$exports.Coin.fromJSON(e)) : [],
            endTime: (0, $d5e07fe2518aae94$exports.isSet)(object.endTime) ? $d5e07fe2518aae94$exports.Long.fromValue(object.endTime) : $d5e07fe2518aae94$exports.Long.ZERO,
            delayed: (0, $d5e07fe2518aae94$exports.isSet)(object.delayed) ? Boolean(object.delayed) : false
        };
    },
    toJSON (message) {
        const obj = {};
        message.fromAddress !== undefined && (obj.fromAddress = message.fromAddress);
        message.toAddress !== undefined && (obj.toAddress = message.toAddress);
        if (message.amount) obj.amount = message.amount.map((e)=>e ? $783dd8715fde0fcf$exports.Coin.toJSON(e) : undefined);
        else obj.amount = [];
        message.endTime !== undefined && (obj.endTime = (message.endTime || $d5e07fe2518aae94$exports.Long.ZERO).toString());
        message.delayed !== undefined && (obj.delayed = message.delayed);
        return obj;
    },
    fromPartial (object) {
        const message = $dfe36d3c28eb0b40$var$createBaseMsgCreateVestingAccount();
        message.fromAddress = object.fromAddress ?? "";
        message.toAddress = object.toAddress ?? "";
        message.amount = object.amount?.map((e)=>$783dd8715fde0fcf$exports.Coin.fromPartial(e)) || [];
        message.endTime = object.endTime !== undefined && object.endTime !== null ? $d5e07fe2518aae94$exports.Long.fromValue(object.endTime) : $d5e07fe2518aae94$exports.Long.ZERO;
        message.delayed = object.delayed ?? false;
        return message;
    }
};
function $dfe36d3c28eb0b40$var$createBaseMsgCreateVestingAccountResponse() {
    return {};
}
$dfe36d3c28eb0b40$exports.MsgCreateVestingAccountResponse = {
    encode (_, writer = $dfe36d3c28eb0b40$var$_m0.Writer.create()) {
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $dfe36d3c28eb0b40$var$_m0.Reader ? input : new $dfe36d3c28eb0b40$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $dfe36d3c28eb0b40$var$createBaseMsgCreateVestingAccountResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            tag;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON (_) {
        return {};
    },
    toJSON (_) {
        const obj = {};
        return obj;
    },
    fromPartial (_) {
        const message = $dfe36d3c28eb0b40$var$createBaseMsgCreateVestingAccountResponse();
        return message;
    }
};
function $dfe36d3c28eb0b40$var$createBaseMsgCreatePermanentLockedAccount() {
    return {
        fromAddress: "",
        toAddress: "",
        amount: []
    };
}
$dfe36d3c28eb0b40$exports.MsgCreatePermanentLockedAccount = {
    encode (message, writer = $dfe36d3c28eb0b40$var$_m0.Writer.create()) {
        if (message.fromAddress !== "") writer.uint32(10).string(message.fromAddress);
        if (message.toAddress !== "") writer.uint32(18).string(message.toAddress);
        for (const v of message.amount)$783dd8715fde0fcf$exports.Coin.encode(v, writer.uint32(26).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $dfe36d3c28eb0b40$var$_m0.Reader ? input : new $dfe36d3c28eb0b40$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $dfe36d3c28eb0b40$var$createBaseMsgCreatePermanentLockedAccount();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.fromAddress = reader.string();
                    break;
                case 2:
                    message.toAddress = reader.string();
                    break;
                case 3:
                    message.amount.push($783dd8715fde0fcf$exports.Coin.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            fromAddress: (0, $d5e07fe2518aae94$exports.isSet)(object.fromAddress) ? String(object.fromAddress) : "",
            toAddress: (0, $d5e07fe2518aae94$exports.isSet)(object.toAddress) ? String(object.toAddress) : "",
            amount: Array.isArray(object?.amount) ? object.amount.map((e)=>$783dd8715fde0fcf$exports.Coin.fromJSON(e)) : []
        };
    },
    toJSON (message) {
        const obj = {};
        message.fromAddress !== undefined && (obj.fromAddress = message.fromAddress);
        message.toAddress !== undefined && (obj.toAddress = message.toAddress);
        if (message.amount) obj.amount = message.amount.map((e)=>e ? $783dd8715fde0fcf$exports.Coin.toJSON(e) : undefined);
        else obj.amount = [];
        return obj;
    },
    fromPartial (object) {
        const message = $dfe36d3c28eb0b40$var$createBaseMsgCreatePermanentLockedAccount();
        message.fromAddress = object.fromAddress ?? "";
        message.toAddress = object.toAddress ?? "";
        message.amount = object.amount?.map((e)=>$783dd8715fde0fcf$exports.Coin.fromPartial(e)) || [];
        return message;
    }
};
function $dfe36d3c28eb0b40$var$createBaseMsgCreatePermanentLockedAccountResponse() {
    return {};
}
$dfe36d3c28eb0b40$exports.MsgCreatePermanentLockedAccountResponse = {
    encode (_, writer = $dfe36d3c28eb0b40$var$_m0.Writer.create()) {
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $dfe36d3c28eb0b40$var$_m0.Reader ? input : new $dfe36d3c28eb0b40$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $dfe36d3c28eb0b40$var$createBaseMsgCreatePermanentLockedAccountResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            tag;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON (_) {
        return {};
    },
    toJSON (_) {
        const obj = {};
        return obj;
    },
    fromPartial (_) {
        const message = $dfe36d3c28eb0b40$var$createBaseMsgCreatePermanentLockedAccountResponse();
        return message;
    }
};
function $dfe36d3c28eb0b40$var$createBaseMsgCreatePeriodicVestingAccount() {
    return {
        fromAddress: "",
        toAddress: "",
        startTime: $d5e07fe2518aae94$exports.Long.ZERO,
        vestingPeriods: []
    };
}
$dfe36d3c28eb0b40$exports.MsgCreatePeriodicVestingAccount = {
    encode (message, writer = $dfe36d3c28eb0b40$var$_m0.Writer.create()) {
        if (message.fromAddress !== "") writer.uint32(10).string(message.fromAddress);
        if (message.toAddress !== "") writer.uint32(18).string(message.toAddress);
        if (!message.startTime.isZero()) writer.uint32(24).int64(message.startTime);
        for (const v of message.vestingPeriods)$294964efb46f9b42$exports.Period.encode(v, writer.uint32(34).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $dfe36d3c28eb0b40$var$_m0.Reader ? input : new $dfe36d3c28eb0b40$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $dfe36d3c28eb0b40$var$createBaseMsgCreatePeriodicVestingAccount();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.fromAddress = reader.string();
                    break;
                case 2:
                    message.toAddress = reader.string();
                    break;
                case 3:
                    message.startTime = reader.int64();
                    break;
                case 4:
                    message.vestingPeriods.push($294964efb46f9b42$exports.Period.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            fromAddress: (0, $d5e07fe2518aae94$exports.isSet)(object.fromAddress) ? String(object.fromAddress) : "",
            toAddress: (0, $d5e07fe2518aae94$exports.isSet)(object.toAddress) ? String(object.toAddress) : "",
            startTime: (0, $d5e07fe2518aae94$exports.isSet)(object.startTime) ? $d5e07fe2518aae94$exports.Long.fromValue(object.startTime) : $d5e07fe2518aae94$exports.Long.ZERO,
            vestingPeriods: Array.isArray(object?.vestingPeriods) ? object.vestingPeriods.map((e)=>$294964efb46f9b42$exports.Period.fromJSON(e)) : []
        };
    },
    toJSON (message) {
        const obj = {};
        message.fromAddress !== undefined && (obj.fromAddress = message.fromAddress);
        message.toAddress !== undefined && (obj.toAddress = message.toAddress);
        message.startTime !== undefined && (obj.startTime = (message.startTime || $d5e07fe2518aae94$exports.Long.ZERO).toString());
        if (message.vestingPeriods) obj.vestingPeriods = message.vestingPeriods.map((e)=>e ? $294964efb46f9b42$exports.Period.toJSON(e) : undefined);
        else obj.vestingPeriods = [];
        return obj;
    },
    fromPartial (object) {
        const message = $dfe36d3c28eb0b40$var$createBaseMsgCreatePeriodicVestingAccount();
        message.fromAddress = object.fromAddress ?? "";
        message.toAddress = object.toAddress ?? "";
        message.startTime = object.startTime !== undefined && object.startTime !== null ? $d5e07fe2518aae94$exports.Long.fromValue(object.startTime) : $d5e07fe2518aae94$exports.Long.ZERO;
        message.vestingPeriods = object.vestingPeriods?.map((e)=>$294964efb46f9b42$exports.Period.fromPartial(e)) || [];
        return message;
    }
};
function $dfe36d3c28eb0b40$var$createBaseMsgCreatePeriodicVestingAccountResponse() {
    return {};
}
$dfe36d3c28eb0b40$exports.MsgCreatePeriodicVestingAccountResponse = {
    encode (_, writer = $dfe36d3c28eb0b40$var$_m0.Writer.create()) {
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $dfe36d3c28eb0b40$var$_m0.Reader ? input : new $dfe36d3c28eb0b40$var$_m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $dfe36d3c28eb0b40$var$createBaseMsgCreatePeriodicVestingAccountResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            tag;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON (_) {
        return {};
    },
    toJSON (_) {
        const obj = {};
        return obj;
    },
    fromPartial (_) {
        const message = $dfe36d3c28eb0b40$var$createBaseMsgCreatePeriodicVestingAccountResponse();
        return message;
    }
};
class $dfe36d3c28eb0b40$var$MsgClientImpl {
    constructor(rpc){
        this.rpc = rpc;
        this.CreateVestingAccount = this.CreateVestingAccount.bind(this);
        this.CreatePermanentLockedAccount = this.CreatePermanentLockedAccount.bind(this);
        this.CreatePeriodicVestingAccount = this.CreatePeriodicVestingAccount.bind(this);
    }
    CreateVestingAccount(request) {
        const data = $dfe36d3c28eb0b40$exports.MsgCreateVestingAccount.encode(request).finish();
        const promise = this.rpc.request("cosmos.vesting.v1beta1.Msg", "CreateVestingAccount", data);
        return promise.then((data)=>$dfe36d3c28eb0b40$exports.MsgCreateVestingAccountResponse.decode(new $dfe36d3c28eb0b40$var$_m0.Reader(data)));
    }
    CreatePermanentLockedAccount(request) {
        const data = $dfe36d3c28eb0b40$exports.MsgCreatePermanentLockedAccount.encode(request).finish();
        const promise = this.rpc.request("cosmos.vesting.v1beta1.Msg", "CreatePermanentLockedAccount", data);
        return promise.then((data)=>$dfe36d3c28eb0b40$exports.MsgCreatePermanentLockedAccountResponse.decode(new $dfe36d3c28eb0b40$var$_m0.Reader(data)));
    }
    CreatePeriodicVestingAccount(request) {
        const data = $dfe36d3c28eb0b40$exports.MsgCreatePeriodicVestingAccount.encode(request).finish();
        const promise = this.rpc.request("cosmos.vesting.v1beta1.Msg", "CreatePeriodicVestingAccount", data);
        return promise.then((data)=>$dfe36d3c28eb0b40$exports.MsgCreatePeriodicVestingAccountResponse.decode(new $dfe36d3c28eb0b40$var$_m0.Reader(data)));
    }
}
$dfe36d3c28eb0b40$exports.MsgClientImpl = $dfe36d3c28eb0b40$var$MsgClientImpl;


$e1f07bcad8d20461$exports.vestingTypes = [
    [
        "/cosmos.vesting.v1beta1.MsgCreateVestingAccount",
        $dfe36d3c28eb0b40$exports.MsgCreateVestingAccount
    ]
];


Object.defineProperty($d0d8b6f4712acd9f$exports, "vestingTypes", {
    enumerable: true,
    get: function() {
        return $e1f07bcad8d20461$exports.vestingTypes;
    }
});


Object.defineProperty($ee390ef646431151$exports, "createAuthzAminoConverters", {
    enumerable: true,
    get: function() {
        return $d0d8b6f4712acd9f$exports.createAuthzAminoConverters;
    }
});
Object.defineProperty($ee390ef646431151$exports, "createBankAminoConverters", {
    enumerable: true,
    get: function() {
        return $d0d8b6f4712acd9f$exports.createBankAminoConverters;
    }
});
Object.defineProperty($ee390ef646431151$exports, "createCrysisAminoConverters", {
    enumerable: true,
    get: function() {
        return $d0d8b6f4712acd9f$exports.createCrysisAminoConverters;
    }
});
Object.defineProperty($ee390ef646431151$exports, "createDistributionAminoConverters", {
    enumerable: true,
    get: function() {
        return $d0d8b6f4712acd9f$exports.createDistributionAminoConverters;
    }
});
Object.defineProperty($ee390ef646431151$exports, "createEvidenceAminoConverters", {
    enumerable: true,
    get: function() {
        return $d0d8b6f4712acd9f$exports.createEvidenceAminoConverters;
    }
});
Object.defineProperty($ee390ef646431151$exports, "createFeegrantAminoConverters", {
    enumerable: true,
    get: function() {
        return $d0d8b6f4712acd9f$exports.createFeegrantAminoConverters;
    }
});
Object.defineProperty($ee390ef646431151$exports, "createGovAminoConverters", {
    enumerable: true,
    get: function() {
        return $d0d8b6f4712acd9f$exports.createGovAminoConverters;
    }
});
Object.defineProperty($ee390ef646431151$exports, "createGroupAminoConverters", {
    enumerable: true,
    get: function() {
        return $d0d8b6f4712acd9f$exports.createGroupAminoConverters;
    }
});
Object.defineProperty($ee390ef646431151$exports, "createIbcAminoConverters", {
    enumerable: true,
    get: function() {
        return $d0d8b6f4712acd9f$exports.createIbcAminoConverters;
    }
});
Object.defineProperty($ee390ef646431151$exports, "createSlashingAminoConverters", {
    enumerable: true,
    get: function() {
        return $d0d8b6f4712acd9f$exports.createSlashingAminoConverters;
    }
});
Object.defineProperty($ee390ef646431151$exports, "createStakingAminoConverters", {
    enumerable: true,
    get: function() {
        return $d0d8b6f4712acd9f$exports.createStakingAminoConverters;
    }
});
Object.defineProperty($ee390ef646431151$exports, "createVestingAminoConverters", {
    enumerable: true,
    get: function() {
        return $d0d8b6f4712acd9f$exports.createVestingAminoConverters;
    }
});
Object.defineProperty($ee390ef646431151$exports, "isAminoMsgBeginRedelegate", {
    enumerable: true,
    get: function() {
        return $d0d8b6f4712acd9f$exports.isAminoMsgBeginRedelegate;
    }
});
Object.defineProperty($ee390ef646431151$exports, "isAminoMsgCreateValidator", {
    enumerable: true,
    get: function() {
        return $d0d8b6f4712acd9f$exports.isAminoMsgCreateValidator;
    }
});
Object.defineProperty($ee390ef646431151$exports, "isAminoMsgCreateVestingAccount", {
    enumerable: true,
    get: function() {
        return $d0d8b6f4712acd9f$exports.isAminoMsgCreateVestingAccount;
    }
});
Object.defineProperty($ee390ef646431151$exports, "isAminoMsgDelegate", {
    enumerable: true,
    get: function() {
        return $d0d8b6f4712acd9f$exports.isAminoMsgDelegate;
    }
});
Object.defineProperty($ee390ef646431151$exports, "isAminoMsgDeposit", {
    enumerable: true,
    get: function() {
        return $d0d8b6f4712acd9f$exports.isAminoMsgDeposit;
    }
});
Object.defineProperty($ee390ef646431151$exports, "isAminoMsgEditValidator", {
    enumerable: true,
    get: function() {
        return $d0d8b6f4712acd9f$exports.isAminoMsgEditValidator;
    }
});
Object.defineProperty($ee390ef646431151$exports, "isAminoMsgFundCommunityPool", {
    enumerable: true,
    get: function() {
        return $d0d8b6f4712acd9f$exports.isAminoMsgFundCommunityPool;
    }
});
Object.defineProperty($ee390ef646431151$exports, "isAminoMsgMultiSend", {
    enumerable: true,
    get: function() {
        return $d0d8b6f4712acd9f$exports.isAminoMsgMultiSend;
    }
});
Object.defineProperty($ee390ef646431151$exports, "isAminoMsgSend", {
    enumerable: true,
    get: function() {
        return $d0d8b6f4712acd9f$exports.isAminoMsgSend;
    }
});
Object.defineProperty($ee390ef646431151$exports, "isAminoMsgSetWithdrawAddress", {
    enumerable: true,
    get: function() {
        return $d0d8b6f4712acd9f$exports.isAminoMsgSetWithdrawAddress;
    }
});
Object.defineProperty($ee390ef646431151$exports, "isAminoMsgSubmitEvidence", {
    enumerable: true,
    get: function() {
        return $d0d8b6f4712acd9f$exports.isAminoMsgSubmitEvidence;
    }
});
Object.defineProperty($ee390ef646431151$exports, "isAminoMsgSubmitProposal", {
    enumerable: true,
    get: function() {
        return $d0d8b6f4712acd9f$exports.isAminoMsgSubmitProposal;
    }
});
Object.defineProperty($ee390ef646431151$exports, "isAminoMsgTransfer", {
    enumerable: true,
    get: function() {
        return $d0d8b6f4712acd9f$exports.isAminoMsgTransfer;
    }
});
Object.defineProperty($ee390ef646431151$exports, "isAminoMsgUndelegate", {
    enumerable: true,
    get: function() {
        return $d0d8b6f4712acd9f$exports.isAminoMsgUndelegate;
    }
});
Object.defineProperty($ee390ef646431151$exports, "isAminoMsgUnjail", {
    enumerable: true,
    get: function() {
        return $d0d8b6f4712acd9f$exports.isAminoMsgUnjail;
    }
});
Object.defineProperty($ee390ef646431151$exports, "isAminoMsgVerifyInvariant", {
    enumerable: true,
    get: function() {
        return $d0d8b6f4712acd9f$exports.isAminoMsgVerifyInvariant;
    }
});
Object.defineProperty($ee390ef646431151$exports, "isAminoMsgVote", {
    enumerable: true,
    get: function() {
        return $d0d8b6f4712acd9f$exports.isAminoMsgVote;
    }
});
Object.defineProperty($ee390ef646431151$exports, "isAminoMsgVoteWeighted", {
    enumerable: true,
    get: function() {
        return $d0d8b6f4712acd9f$exports.isAminoMsgVoteWeighted;
    }
});
Object.defineProperty($ee390ef646431151$exports, "isAminoMsgWithdrawDelegatorReward", {
    enumerable: true,
    get: function() {
        return $d0d8b6f4712acd9f$exports.isAminoMsgWithdrawDelegatorReward;
    }
});
Object.defineProperty($ee390ef646431151$exports, "isAminoMsgWithdrawValidatorCommission", {
    enumerable: true,
    get: function() {
        return $d0d8b6f4712acd9f$exports.isAminoMsgWithdrawValidatorCommission;
    }
});
Object.defineProperty($ee390ef646431151$exports, "isMsgBeginRedelegateEncodeObject", {
    enumerable: true,
    get: function() {
        return $d0d8b6f4712acd9f$exports.isMsgBeginRedelegateEncodeObject;
    }
});
Object.defineProperty($ee390ef646431151$exports, "isMsgCreateValidatorEncodeObject", {
    enumerable: true,
    get: function() {
        return $d0d8b6f4712acd9f$exports.isMsgCreateValidatorEncodeObject;
    }
});
Object.defineProperty($ee390ef646431151$exports, "isMsgDelegateEncodeObject", {
    enumerable: true,
    get: function() {
        return $d0d8b6f4712acd9f$exports.isMsgDelegateEncodeObject;
    }
});
Object.defineProperty($ee390ef646431151$exports, "isMsgDepositEncodeObject", {
    enumerable: true,
    get: function() {
        return $d0d8b6f4712acd9f$exports.isMsgDepositEncodeObject;
    }
});
Object.defineProperty($ee390ef646431151$exports, "isMsgEditValidatorEncodeObject", {
    enumerable: true,
    get: function() {
        return $d0d8b6f4712acd9f$exports.isMsgEditValidatorEncodeObject;
    }
});
Object.defineProperty($ee390ef646431151$exports, "isMsgSendEncodeObject", {
    enumerable: true,
    get: function() {
        return $d0d8b6f4712acd9f$exports.isMsgSendEncodeObject;
    }
});
Object.defineProperty($ee390ef646431151$exports, "isMsgSubmitProposalEncodeObject", {
    enumerable: true,
    get: function() {
        return $d0d8b6f4712acd9f$exports.isMsgSubmitProposalEncodeObject;
    }
});
Object.defineProperty($ee390ef646431151$exports, "isMsgTransferEncodeObject", {
    enumerable: true,
    get: function() {
        return $d0d8b6f4712acd9f$exports.isMsgTransferEncodeObject;
    }
});
Object.defineProperty($ee390ef646431151$exports, "isMsgUndelegateEncodeObject", {
    enumerable: true,
    get: function() {
        return $d0d8b6f4712acd9f$exports.isMsgUndelegateEncodeObject;
    }
});
Object.defineProperty($ee390ef646431151$exports, "isMsgVoteEncodeObject", {
    enumerable: true,
    get: function() {
        return $d0d8b6f4712acd9f$exports.isMsgVoteEncodeObject;
    }
});
Object.defineProperty($ee390ef646431151$exports, "isMsgVoteWeightedEncodeObject", {
    enumerable: true,
    get: function() {
        return $d0d8b6f4712acd9f$exports.isMsgVoteWeightedEncodeObject;
    }
});
Object.defineProperty($ee390ef646431151$exports, "isMsgWithdrawDelegatorRewardEncodeObject", {
    enumerable: true,
    get: function() {
        return $d0d8b6f4712acd9f$exports.isMsgWithdrawDelegatorRewardEncodeObject;
    }
});
Object.defineProperty($ee390ef646431151$exports, "setupAuthExtension", {
    enumerable: true,
    get: function() {
        return $d0d8b6f4712acd9f$exports.setupAuthExtension;
    }
});
Object.defineProperty($ee390ef646431151$exports, "setupAuthzExtension", {
    enumerable: true,
    get: function() {
        return $d0d8b6f4712acd9f$exports.setupAuthzExtension;
    }
});
Object.defineProperty($ee390ef646431151$exports, "setupBankExtension", {
    enumerable: true,
    get: function() {
        return $d0d8b6f4712acd9f$exports.setupBankExtension;
    }
});
Object.defineProperty($ee390ef646431151$exports, "setupDistributionExtension", {
    enumerable: true,
    get: function() {
        return $d0d8b6f4712acd9f$exports.setupDistributionExtension;
    }
});
Object.defineProperty($ee390ef646431151$exports, "setupFeegrantExtension", {
    enumerable: true,
    get: function() {
        return $d0d8b6f4712acd9f$exports.setupFeegrantExtension;
    }
});
Object.defineProperty($ee390ef646431151$exports, "setupGovExtension", {
    enumerable: true,
    get: function() {
        return $d0d8b6f4712acd9f$exports.setupGovExtension;
    }
});
Object.defineProperty($ee390ef646431151$exports, "setupIbcExtension", {
    enumerable: true,
    get: function() {
        return $d0d8b6f4712acd9f$exports.setupIbcExtension;
    }
});
Object.defineProperty($ee390ef646431151$exports, "setupMintExtension", {
    enumerable: true,
    get: function() {
        return $d0d8b6f4712acd9f$exports.setupMintExtension;
    }
});
Object.defineProperty($ee390ef646431151$exports, "setupSlashingExtension", {
    enumerable: true,
    get: function() {
        return $d0d8b6f4712acd9f$exports.setupSlashingExtension;
    }
});
Object.defineProperty($ee390ef646431151$exports, "setupStakingExtension", {
    enumerable: true,
    get: function() {
        return $d0d8b6f4712acd9f$exports.setupStakingExtension;
    }
});
Object.defineProperty($ee390ef646431151$exports, "setupTxExtension", {
    enumerable: true,
    get: function() {
        return $d0d8b6f4712acd9f$exports.setupTxExtension;
    }
});
var $57b5c0cfbcb2b434$exports = {};
"use strict";
var $57b5c0cfbcb2b434$var$__importDefault = $57b5c0cfbcb2b434$exports && $57b5c0cfbcb2b434$exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty($57b5c0cfbcb2b434$exports, "__esModule", {
    value: true
});
$57b5c0cfbcb2b434$exports.makeMultisignedTxBytes = $57b5c0cfbcb2b434$exports.makeMultisignedTx = $57b5c0cfbcb2b434$exports.makeCompactBitArray = void 0;


var $6XcLW = parcelRequire("6XcLW");






const $57b5c0cfbcb2b434$var$long_1 = $57b5c0cfbcb2b434$var$__importDefault((parcelRequire("jRkuS")));
function $57b5c0cfbcb2b434$var$makeCompactBitArray(bits) {
    const byteCount = Math.ceil(bits.length / 8);
    const extraBits = bits.length - Math.floor(bits.length / 8) * 8;
    const bytes = new Uint8Array(byteCount); // zero-filled
    bits.forEach((value, index)=>{
        const bytePos = Math.floor(index / 8);
        const bitPos = index % 8;
        // eslint-disable-next-line no-bitwise
        if (value) bytes[bytePos] |= 1 << 7 - bitPos;
    });
    return $49dbfe0929da90f4$exports.CompactBitArray.fromPartial({
        elems: bytes,
        extraBitsStored: extraBits
    });
}
$57b5c0cfbcb2b434$exports.makeCompactBitArray = $57b5c0cfbcb2b434$var$makeCompactBitArray;
/**
 * Creates a signed transaction from signer info, transaction body and signatures.
 * The result can be broadcasted after serialization.
 *
 * Consider using `makeMultisignedTxBytes` instead if you want to broadcast the
 * transaction immediately.
 */ function $57b5c0cfbcb2b434$var$makeMultisignedTx(multisigPubkey, sequence, fee, bodyBytes, signatures) {
    const addresses = Array.from(signatures.keys());
    const prefix = (0, $6XcLW.fromBech32)(addresses[0]).prefix;
    const signers = Array(multisigPubkey.value.pubkeys.length).fill(false);
    const signaturesList = new Array();
    for(let i = 0; i < multisigPubkey.value.pubkeys.length; i++){
        const signerAddress = (0, $6078e8ec636191fb$exports.pubkeyToAddress)(multisigPubkey.value.pubkeys[i], prefix);
        const signature = signatures.get(signerAddress);
        if (signature) {
            signers[i] = true;
            signaturesList.push(signature);
        }
    }
    const signerInfo = {
        publicKey: (0, $c0a9381c50e8ee56$exports.encodePubkey)(multisigPubkey),
        modeInfo: {
            multi: {
                bitarray: $57b5c0cfbcb2b434$var$makeCompactBitArray(signers),
                modeInfos: signaturesList.map((_)=>({
                        single: {
                            mode: $cefef10ba181af21$exports.SignMode.SIGN_MODE_LEGACY_AMINO_JSON
                        }
                    }))
            }
        },
        sequence: $57b5c0cfbcb2b434$var$long_1.default.fromNumber(sequence)
    };
    const authInfo = $eedf6d503be55212$exports.AuthInfo.fromPartial({
        signerInfos: [
            signerInfo
        ],
        fee: {
            amount: [
                ...fee.amount
            ],
            gasLimit: $57b5c0cfbcb2b434$var$long_1.default.fromString(fee.gas)
        }
    });
    const authInfoBytes = $eedf6d503be55212$exports.AuthInfo.encode(authInfo).finish();
    const signedTx = $eedf6d503be55212$exports.TxRaw.fromPartial({
        bodyBytes: bodyBytes,
        authInfoBytes: authInfoBytes,
        signatures: [
            $49dbfe0929da90f4$exports.MultiSignature.encode($49dbfe0929da90f4$exports.MultiSignature.fromPartial({
                signatures: signaturesList
            })).finish()
        ]
    });
    return signedTx;
}
$57b5c0cfbcb2b434$exports.makeMultisignedTx = $57b5c0cfbcb2b434$var$makeMultisignedTx;
/**
 * Creates a signed transaction from signer info, transaction body and signatures.
 * The result can be broadcasted.
 *
 * This is a wrapper around `makeMultisignedTx` that encodes the transaction for broadcasting.
 */ function $57b5c0cfbcb2b434$var$makeMultisignedTxBytes(multisigPubkey, sequence, fee, bodyBytes, signatures) {
    const signedTx = $57b5c0cfbcb2b434$var$makeMultisignedTx(multisigPubkey, sequence, fee, bodyBytes, signatures);
    return Uint8Array.from($eedf6d503be55212$exports.TxRaw.encode(signedTx).finish());
}
$57b5c0cfbcb2b434$exports.makeMultisignedTxBytes = $57b5c0cfbcb2b434$var$makeMultisignedTxBytes;


Object.defineProperty($ee390ef646431151$exports, "makeMultisignedTx", {
    enumerable: true,
    get: function() {
        return $57b5c0cfbcb2b434$exports.makeMultisignedTx;
    }
});
Object.defineProperty($ee390ef646431151$exports, "makeMultisignedTxBytes", {
    enumerable: true,
    get: function() {
        return $57b5c0cfbcb2b434$exports.makeMultisignedTxBytes;
    }
});

Object.defineProperty($ee390ef646431151$exports, "createPagination", {
    enumerable: true,
    get: function() {
        return $a3959936d2cce854$exports.createPagination;
    }
});
Object.defineProperty($ee390ef646431151$exports, "createProtobufRpcClient", {
    enumerable: true,
    get: function() {
        return $a3959936d2cce854$exports.createProtobufRpcClient;
    }
});
Object.defineProperty($ee390ef646431151$exports, "decodeCosmosSdkDecFromProto", {
    enumerable: true,
    get: function() {
        return $a3959936d2cce854$exports.decodeCosmosSdkDecFromProto;
    }
});
Object.defineProperty($ee390ef646431151$exports, "QueryClient", {
    enumerable: true,
    get: function() {
        return $a3959936d2cce854$exports.QueryClient;
    }
});
var $d55b7ddfb58f7fc2$exports = {};
"use strict";
var $d55b7ddfb58f7fc2$var$__importDefault = $d55b7ddfb58f7fc2$exports && $d55b7ddfb58f7fc2$exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty($d55b7ddfb58f7fc2$exports, "__esModule", {
    value: true
});
$d55b7ddfb58f7fc2$exports.SigningStargateClient = $d55b7ddfb58f7fc2$exports.createDefaultAminoConverters = $d55b7ddfb58f7fc2$exports.defaultRegistryTypes = void 0;


var $6XcLW = parcelRequire("6XcLW");

var $7UsfE = parcelRequire("7UsfE");

var $76d53df890d1b5af$exports = {};
"use strict";
var $76d53df890d1b5af$var$__createBinding = $76d53df890d1b5af$exports && $76d53df890d1b5af$exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $76d53df890d1b5af$var$__setModuleDefault = $76d53df890d1b5af$exports && $76d53df890d1b5af$exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $76d53df890d1b5af$var$__importStar = $76d53df890d1b5af$exports && $76d53df890d1b5af$exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $76d53df890d1b5af$var$__createBinding(result, mod, k);
    }
    $76d53df890d1b5af$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty($76d53df890d1b5af$exports, "__esModule", {
    value: true
});
$76d53df890d1b5af$exports.BlockIdFlag = $76d53df890d1b5af$exports.isTendermint37Client = $76d53df890d1b5af$exports.isTendermint34Client = $76d53df890d1b5af$exports.Tendermint37Client = $76d53df890d1b5af$exports.tendermint37 = $76d53df890d1b5af$exports.Tendermint34Client = $76d53df890d1b5af$exports.tendermint34 = $76d53df890d1b5af$exports.VoteType = $76d53df890d1b5af$exports.SubscriptionEventType = $76d53df890d1b5af$exports.Method = $76d53df890d1b5af$exports.broadcastTxSyncSuccess = $76d53df890d1b5af$exports.broadcastTxCommitSuccess = $76d53df890d1b5af$exports.WebsocketClient = $76d53df890d1b5af$exports.HttpClient = $76d53df890d1b5af$exports.HttpBatchClient = $76d53df890d1b5af$exports.toSeconds = $76d53df890d1b5af$exports.toRfc3339WithNanoseconds = $76d53df890d1b5af$exports.fromSeconds = $76d53df890d1b5af$exports.fromRfc3339WithNanoseconds = $76d53df890d1b5af$exports.DateTime = $76d53df890d1b5af$exports.rawSecp256k1PubkeyToRawAddress = $76d53df890d1b5af$exports.rawEd25519PubkeyToRawAddress = $76d53df890d1b5af$exports.pubkeyToRawAddress = $76d53df890d1b5af$exports.pubkeyToAddress = void 0;
var $d7273f093c9ec09c$exports = {};
"use strict";
Object.defineProperty($d7273f093c9ec09c$exports, "__esModule", {
    value: true
});
$d7273f093c9ec09c$exports.pubkeyToAddress = $d7273f093c9ec09c$exports.pubkeyToRawAddress = $d7273f093c9ec09c$exports.rawSecp256k1PubkeyToRawAddress = $d7273f093c9ec09c$exports.rawEd25519PubkeyToRawAddress = void 0;

var $6f1ux = parcelRequire("6f1ux");

var $6XcLW = parcelRequire("6XcLW");
function $d7273f093c9ec09c$var$rawEd25519PubkeyToRawAddress(pubkeyData) {
    if (pubkeyData.length !== 32) throw new Error(`Invalid Ed25519 pubkey length: ${pubkeyData.length}`);
    return (0, $6f1ux.sha256)(pubkeyData).slice(0, 20);
}
$d7273f093c9ec09c$exports.rawEd25519PubkeyToRawAddress = $d7273f093c9ec09c$var$rawEd25519PubkeyToRawAddress;
function $d7273f093c9ec09c$var$rawSecp256k1PubkeyToRawAddress(pubkeyData) {
    if (pubkeyData.length !== 33) throw new Error(`Invalid Secp256k1 pubkey length (compressed): ${pubkeyData.length}`);
    return (0, $6f1ux.ripemd160)((0, $6f1ux.sha256)(pubkeyData));
}
$d7273f093c9ec09c$exports.rawSecp256k1PubkeyToRawAddress = $d7273f093c9ec09c$var$rawSecp256k1PubkeyToRawAddress;
/**
 * Returns Tendermint address as bytes.
 *
 * This is for addresses that are derived by the Tendermint keypair (typically Ed25519).
 * Sometimes those addresses are bech32-encoded and contain the term "cons" in the presix
 * ("cosmosvalcons1...").
 *
 * For secp256k1 this assumes we already have a compressed pubkey, which is the default in Cosmos.
 */ function $d7273f093c9ec09c$var$pubkeyToRawAddress(type, data) {
    switch(type){
        case "ed25519":
            return $d7273f093c9ec09c$var$rawEd25519PubkeyToRawAddress(data);
        case "secp256k1":
            return $d7273f093c9ec09c$var$rawSecp256k1PubkeyToRawAddress(data);
        default:
            // Keep this case here to guard against new types being added but not handled
            throw new Error(`Pubkey type ${type} not supported`);
    }
}
$d7273f093c9ec09c$exports.pubkeyToRawAddress = $d7273f093c9ec09c$var$pubkeyToRawAddress;
/**
 * Returns Tendermint address in uppercase hex format.
 *
 * This is for addresses that are derived by the Tendermint keypair (typically Ed25519).
 * Sometimes those addresses are bech32-encoded and contain the term "cons" in the presix
 * ("cosmosvalcons1...").
 *
 * For secp256k1 this assumes we already have a compressed pubkey, which is the default in Cosmos.
 */ function $d7273f093c9ec09c$var$pubkeyToAddress(type, data) {
    return (0, $6XcLW.toHex)($d7273f093c9ec09c$var$pubkeyToRawAddress(type, data)).toUpperCase();
}
$d7273f093c9ec09c$exports.pubkeyToAddress = $d7273f093c9ec09c$var$pubkeyToAddress;


Object.defineProperty($76d53df890d1b5af$exports, "pubkeyToAddress", {
    enumerable: true,
    get: function() {
        return $d7273f093c9ec09c$exports.pubkeyToAddress;
    }
});
Object.defineProperty($76d53df890d1b5af$exports, "pubkeyToRawAddress", {
    enumerable: true,
    get: function() {
        return $d7273f093c9ec09c$exports.pubkeyToRawAddress;
    }
});
Object.defineProperty($76d53df890d1b5af$exports, "rawEd25519PubkeyToRawAddress", {
    enumerable: true,
    get: function() {
        return $d7273f093c9ec09c$exports.rawEd25519PubkeyToRawAddress;
    }
});
Object.defineProperty($76d53df890d1b5af$exports, "rawSecp256k1PubkeyToRawAddress", {
    enumerable: true,
    get: function() {
        return $d7273f093c9ec09c$exports.rawSecp256k1PubkeyToRawAddress;
    }
});

var $2Sgxm = parcelRequire("2Sgxm");
Object.defineProperty($76d53df890d1b5af$exports, "DateTime", {
    enumerable: true,
    get: function() {
        return $2Sgxm.DateTime;
    }
});
Object.defineProperty($76d53df890d1b5af$exports, "fromRfc3339WithNanoseconds", {
    enumerable: true,
    get: function() {
        return $2Sgxm.fromRfc3339WithNanoseconds;
    }
});
Object.defineProperty($76d53df890d1b5af$exports, "fromSeconds", {
    enumerable: true,
    get: function() {
        return $2Sgxm.fromSeconds;
    }
});
Object.defineProperty($76d53df890d1b5af$exports, "toRfc3339WithNanoseconds", {
    enumerable: true,
    get: function() {
        return $2Sgxm.toRfc3339WithNanoseconds;
    }
});
Object.defineProperty($76d53df890d1b5af$exports, "toSeconds", {
    enumerable: true,
    get: function() {
        return $2Sgxm.toSeconds;
    }
});

var $iPMHy = parcelRequire("iPMHy");
Object.defineProperty($76d53df890d1b5af$exports, "HttpBatchClient", {
    enumerable: true,
    get: function() {
        return $iPMHy.HttpBatchClient;
    }
});
Object.defineProperty($76d53df890d1b5af$exports, "HttpClient", {
    enumerable: true,
    get: function() {
        return $iPMHy.HttpClient;
    }
});
Object.defineProperty($76d53df890d1b5af$exports, "WebsocketClient", {
    enumerable: true,
    get: function() {
        return $iPMHy.WebsocketClient;
    }
});

Object.defineProperty($76d53df890d1b5af$exports, "broadcastTxCommitSuccess", {
    enumerable: true,
    get: function() {
        return (parcelRequire("8Bok5")).broadcastTxCommitSuccess;
    }
});
Object.defineProperty($76d53df890d1b5af$exports, "broadcastTxSyncSuccess", {
    enumerable: true,
    get: function() {
        return (parcelRequire("8Bok5")).broadcastTxSyncSuccess;
    }
});
Object.defineProperty($76d53df890d1b5af$exports, "Method", {
    enumerable: true,
    get: function() {
        return (parcelRequire("8Bok5")).Method;
    }
});
Object.defineProperty($76d53df890d1b5af$exports, "SubscriptionEventType", {
    enumerable: true,
    get: function() {
        return (parcelRequire("8Bok5")).SubscriptionEventType;
    }
});
Object.defineProperty($76d53df890d1b5af$exports, "VoteType", {
    enumerable: true,
    get: function() {
        return (parcelRequire("8Bok5")).VoteType;
    }
});

$76d53df890d1b5af$exports.tendermint34 = $76d53df890d1b5af$var$__importStar((parcelRequire("8Bok5")));

Object.defineProperty($76d53df890d1b5af$exports, "Tendermint34Client", {
    enumerable: true,
    get: function() {
        return (parcelRequire("8Bok5")).Tendermint34Client;
    }
});

$76d53df890d1b5af$exports.tendermint37 = $76d53df890d1b5af$var$__importStar((parcelRequire("bzMo4")));

Object.defineProperty($76d53df890d1b5af$exports, "Tendermint37Client", {
    enumerable: true,
    get: function() {
        return (parcelRequire("bzMo4")).Tendermint37Client;
    }
});
var $ef845afb1833baef$exports = {};
"use strict";
Object.defineProperty($ef845afb1833baef$exports, "__esModule", {
    value: true
});
$ef845afb1833baef$exports.isTendermint37Client = $ef845afb1833baef$exports.isTendermint34Client = void 0;

var $8Bok5 = parcelRequire("8Bok5");

var $bzMo4 = parcelRequire("bzMo4");
function $ef845afb1833baef$var$isTendermint34Client(client) {
    return client instanceof $8Bok5.Tendermint34Client;
}
$ef845afb1833baef$exports.isTendermint34Client = $ef845afb1833baef$var$isTendermint34Client;
function $ef845afb1833baef$var$isTendermint37Client(client) {
    return client instanceof $bzMo4.Tendermint37Client;
}
$ef845afb1833baef$exports.isTendermint37Client = $ef845afb1833baef$var$isTendermint37Client;


Object.defineProperty($76d53df890d1b5af$exports, "isTendermint34Client", {
    enumerable: true,
    get: function() {
        return $ef845afb1833baef$exports.isTendermint34Client;
    }
});
Object.defineProperty($76d53df890d1b5af$exports, "isTendermint37Client", {
    enumerable: true,
    get: function() {
        return $ef845afb1833baef$exports.isTendermint37Client;
    }
});

var $dVoCS = parcelRequire("dVoCS");
Object.defineProperty($76d53df890d1b5af$exports, "BlockIdFlag", {
    enumerable: true,
    get: function() {
        return $dVoCS.BlockIdFlag;
    }
});



var $fZwG5 = parcelRequire("fZwG5");







const $d55b7ddfb58f7fc2$var$long_1 = $d55b7ddfb58f7fc2$var$__importDefault((parcelRequire("jRkuS")));




var $b610d1b6e6077b41$exports = {};
"use strict";
Object.defineProperty($b610d1b6e6077b41$exports, "__esModule", {
    value: true
});
$b610d1b6e6077b41$exports.StargateClient = $b610d1b6e6077b41$exports.BroadcastTxError = $b610d1b6e6077b41$exports.assertIsDeliverTxFailure = $b610d1b6e6077b41$exports.assertIsDeliverTxSuccess = $b610d1b6e6077b41$exports.isDeliverTxSuccess = $b610d1b6e6077b41$exports.isDeliverTxFailure = $b610d1b6e6077b41$exports.TimeoutError = void 0;


var $6XcLW = parcelRequire("6XcLW");

var $7UsfE = parcelRequire("7UsfE");


var $fZwG5 = parcelRequire("fZwG5");





class $b610d1b6e6077b41$var$TimeoutError extends Error {
    constructor(message, txId){
        super(message);
        this.txId = txId;
    }
}
$b610d1b6e6077b41$exports.TimeoutError = $b610d1b6e6077b41$var$TimeoutError;
function $b610d1b6e6077b41$var$isDeliverTxFailure(result) {
    return !!result.code;
}
$b610d1b6e6077b41$exports.isDeliverTxFailure = $b610d1b6e6077b41$var$isDeliverTxFailure;
function $b610d1b6e6077b41$var$isDeliverTxSuccess(result) {
    return !$b610d1b6e6077b41$var$isDeliverTxFailure(result);
}
$b610d1b6e6077b41$exports.isDeliverTxSuccess = $b610d1b6e6077b41$var$isDeliverTxSuccess;
/**
 * Ensures the given result is a success. Throws a detailed error message otherwise.
 */ function $b610d1b6e6077b41$var$assertIsDeliverTxSuccess(result) {
    if ($b610d1b6e6077b41$var$isDeliverTxFailure(result)) throw new Error(`Error when broadcasting tx ${result.transactionHash} at height ${result.height}. Code: ${result.code}; Raw log: ${result.rawLog}`);
}
$b610d1b6e6077b41$exports.assertIsDeliverTxSuccess = $b610d1b6e6077b41$var$assertIsDeliverTxSuccess;
/**
 * Ensures the given result is a failure. Throws a detailed error message otherwise.
 */ function $b610d1b6e6077b41$var$assertIsDeliverTxFailure(result) {
    if ($b610d1b6e6077b41$var$isDeliverTxSuccess(result)) throw new Error(`Transaction ${result.transactionHash} did not fail at height ${result.height}. Code: ${result.code}; Raw log: ${result.rawLog}`);
}
$b610d1b6e6077b41$exports.assertIsDeliverTxFailure = $b610d1b6e6077b41$var$assertIsDeliverTxFailure;
/**
 * An error when broadcasting the transaction. This contains the CheckTx errors
 * from the blockchain. Once a transaction is included in a block no BroadcastTxError
 * is thrown, even if the execution fails (DeliverTx errors).
 */ class $b610d1b6e6077b41$var$BroadcastTxError extends Error {
    constructor(code, codespace, log){
        super(`Broadcasting transaction failed with code ${code} (codespace: ${codespace}). Log: ${log}`);
        this.code = code;
        this.codespace = codespace;
        this.log = log;
    }
}
$b610d1b6e6077b41$exports.BroadcastTxError = $b610d1b6e6077b41$var$BroadcastTxError;
class $b610d1b6e6077b41$var$StargateClient {
    /**
     * Creates an instance by connecting to the given Tendermint RPC endpoint.
     *
     * This uses auto-detection to decide between a Tendermint 0.37 and 0.34 client.
     * To set the Tendermint client explicitly, use `create`.
     */ static async connect(endpoint, options = {}) {
        // Tendermint/CometBFT 0.34/0.37 auto-detection. Starting with 0.37 we seem to get reliable versions again 🎉
        // Using 0.34 as the fallback.
        let tmClient;
        const tm37Client = await $76d53df890d1b5af$exports.Tendermint37Client.connect(endpoint);
        const version = (await tm37Client.status()).nodeInfo.version;
        if (version.startsWith("0.37.")) tmClient = tm37Client;
        else {
            tm37Client.disconnect();
            tmClient = await $76d53df890d1b5af$exports.Tendermint34Client.connect(endpoint);
        }
        return $b610d1b6e6077b41$var$StargateClient.create(tmClient, options);
    }
    /**
     * Creates an instance from a manually created Tendermint client.
     * Use this to use `Tendermint37Client` instead of `Tendermint34Client`.
     */ static async create(tmClient, options = {}) {
        return new $b610d1b6e6077b41$var$StargateClient(tmClient, options);
    }
    constructor(tmClient, options){
        if (tmClient) {
            this.tmClient = tmClient;
            this.queryClient = $a3959936d2cce854$exports.QueryClient.withExtensions(tmClient, $d0d8b6f4712acd9f$exports.setupAuthExtension, $d0d8b6f4712acd9f$exports.setupBankExtension, $d0d8b6f4712acd9f$exports.setupStakingExtension, $d0d8b6f4712acd9f$exports.setupTxExtension);
        }
        const { accountParser: accountParser = $55dae034d780d4b9$exports.accountFromAny } = options;
        this.accountParser = accountParser;
    }
    getTmClient() {
        return this.tmClient;
    }
    forceGetTmClient() {
        if (!this.tmClient) throw new Error("Tendermint client not available. You cannot use online functionality in offline mode.");
        return this.tmClient;
    }
    getQueryClient() {
        return this.queryClient;
    }
    forceGetQueryClient() {
        if (!this.queryClient) throw new Error("Query client not available. You cannot use online functionality in offline mode.");
        return this.queryClient;
    }
    async getChainId() {
        if (!this.chainId) {
            const response = await this.forceGetTmClient().status();
            const chainId = response.nodeInfo.network;
            if (!chainId) throw new Error("Chain ID must not be empty");
            this.chainId = chainId;
        }
        return this.chainId;
    }
    async getHeight() {
        const status = await this.forceGetTmClient().status();
        return status.syncInfo.latestBlockHeight;
    }
    async getAccount(searchAddress) {
        try {
            const account = await this.forceGetQueryClient().auth.account(searchAddress);
            return account ? this.accountParser(account) : null;
        } catch (error) {
            if (/rpc error: code = NotFound/i.test(error.toString())) return null;
            throw error;
        }
    }
    async getSequence(address) {
        const account = await this.getAccount(address);
        if (!account) throw new Error(`Account '${address}' does not exist on chain. Send some tokens there before trying to query sequence.`);
        return {
            accountNumber: account.accountNumber,
            sequence: account.sequence
        };
    }
    async getBlock(height) {
        const response = await this.forceGetTmClient().block(height);
        return {
            id: (0, $6XcLW.toHex)(response.blockId.hash).toUpperCase(),
            header: {
                version: {
                    block: new $7UsfE.Uint53(response.block.header.version.block).toString(),
                    app: new $7UsfE.Uint53(response.block.header.version.app).toString()
                },
                height: response.block.header.height,
                chainId: response.block.header.chainId,
                time: (0, $76d53df890d1b5af$exports.toRfc3339WithNanoseconds)(response.block.header.time)
            },
            txs: response.block.txs
        };
    }
    async getBalance(address, searchDenom) {
        return this.forceGetQueryClient().bank.balance(address, searchDenom);
    }
    /**
     * Queries all balances for all denoms that belong to this address.
     *
     * Uses the grpc queries (which iterates over the store internally), and we cannot get
     * proofs from such a method.
     */ async getAllBalances(address) {
        return this.forceGetQueryClient().bank.allBalances(address);
    }
    async getBalanceStaked(address) {
        const allDelegations = [];
        let startAtKey = undefined;
        do {
            const { delegationResponses: delegationResponses, pagination: pagination } = await this.forceGetQueryClient().staking.delegatorDelegations(address, startAtKey);
            const loadedDelegations = delegationResponses || [];
            allDelegations.push(...loadedDelegations);
            startAtKey = pagination?.nextKey;
        }while (startAtKey !== undefined && startAtKey.length !== 0);
        const sumValues = allDelegations.reduce((previousValue, currentValue)=>{
            // Safe because field is set to non-nullable (https://github.com/cosmos/cosmos-sdk/blob/v0.45.3/proto/cosmos/staking/v1beta1/staking.proto#L295)
            (0, $fZwG5.assert)(currentValue.balance);
            return previousValue !== null ? (0, $6078e8ec636191fb$exports.addCoins)(previousValue, currentValue.balance) : currentValue.balance;
        }, null);
        return sumValues;
    }
    async getDelegation(delegatorAddress, validatorAddress) {
        let delegatedAmount;
        try {
            delegatedAmount = (await this.forceGetQueryClient().staking.delegation(delegatorAddress, validatorAddress)).delegationResponse?.balance;
        } catch (e) {
            if (e.toString().includes("key not found")) ;
            else throw e;
        }
        return delegatedAmount || null;
    }
    async getTx(id) {
        const results = await this.txsQuery(`tx.hash='${id}'`);
        return results[0] ?? null;
    }
    async searchTx(query) {
        let rawQuery;
        if (typeof query === "string") rawQuery = query;
        else if (Array.isArray(query)) rawQuery = query.map((t)=>`${t.key}='${t.value}'`).join(" AND ");
        else throw new Error("Got unsupported query type. See CosmJS 0.31 CHANGELOG for API breaking changes here.");
        return this.txsQuery(rawQuery);
    }
    disconnect() {
        if (this.tmClient) this.tmClient.disconnect();
    }
    /**
     * Broadcasts a signed transaction to the network and monitors its inclusion in a block.
     *
     * If broadcasting is rejected by the node for some reason (e.g. because of a CheckTx failure),
     * an error is thrown.
     *
     * If the transaction is not included in a block before the provided timeout, this errors with a `TimeoutError`.
     *
     * If the transaction is included in a block, a `DeliverTxResponse` is returned. The caller then
     * usually needs to check for execution success or failure.
     */ async broadcastTx(tx, timeoutMs = 60000, pollIntervalMs = 3000) {
        let timedOut = false;
        const txPollTimeout = setTimeout(()=>{
            timedOut = true;
        }, timeoutMs);
        const pollForTx = async (txId)=>{
            if (timedOut) throw new $b610d1b6e6077b41$var$TimeoutError(`Transaction with ID ${txId} was submitted but was not yet found on the chain. You might want to check later. There was a wait of ${timeoutMs / 1000} seconds.`, txId);
            await (0, $fZwG5.sleep)(pollIntervalMs);
            const result = await this.getTx(txId);
            return result ? {
                code: result.code,
                height: result.height,
                txIndex: result.txIndex,
                events: result.events,
                rawLog: result.rawLog,
                transactionHash: txId,
                msgResponses: result.msgResponses,
                gasUsed: result.gasUsed,
                gasWanted: result.gasWanted
            } : pollForTx(txId);
        };
        const transactionId = await this.broadcastTxSync(tx);
        return new Promise((resolve, reject)=>pollForTx(transactionId).then((value)=>{
                clearTimeout(txPollTimeout);
                resolve(value);
            }, (error)=>{
                clearTimeout(txPollTimeout);
                reject(error);
            }));
    }
    /**
     * Broadcasts a signed transaction to the network without monitoring it.
     *
     * If broadcasting is rejected by the node for some reason (e.g. because of a CheckTx failure),
     * an error is thrown.
     *
     * If the transaction is broadcasted, a `string` containing the hash of the transaction is returned. The caller then
     * usually needs to check if the transaction was included in a block and was successful.
     *
     * @returns Returns the hash of the transaction
     */ async broadcastTxSync(tx) {
        const broadcasted = await this.forceGetTmClient().broadcastTxSync({
            tx: tx
        });
        if (broadcasted.code) return Promise.reject(new $b610d1b6e6077b41$var$BroadcastTxError(broadcasted.code, broadcasted.codespace ?? "", broadcasted.log));
        const transactionId = (0, $6XcLW.toHex)(broadcasted.hash).toUpperCase();
        return transactionId;
    }
    async txsQuery(query) {
        const results = await this.forceGetTmClient().txSearchAll({
            query: query
        });
        return results.txs.map((tx)=>{
            const txMsgData = $17fd3ea9d729df0d$exports.TxMsgData.decode(tx.result.data ?? new Uint8Array());
            return {
                height: tx.height,
                txIndex: tx.index,
                hash: (0, $6XcLW.toHex)(tx.hash).toUpperCase(),
                code: tx.result.code,
                events: tx.result.events.map($e8bc1ea6b01ea32f$exports.fromTendermintEvent),
                rawLog: tx.result.log || "",
                tx: tx.tx,
                msgResponses: txMsgData.msgResponses,
                gasUsed: tx.result.gasUsed,
                gasWanted: tx.result.gasWanted
            };
        });
    }
}
$b610d1b6e6077b41$exports.StargateClient = $b610d1b6e6077b41$var$StargateClient;


$d55b7ddfb58f7fc2$exports.defaultRegistryTypes = [
    [
        "/cosmos.base.v1beta1.Coin",
        $783dd8715fde0fcf$exports.Coin
    ],
    ...$d0d8b6f4712acd9f$exports.authzTypes,
    ...$d0d8b6f4712acd9f$exports.bankTypes,
    ...$d0d8b6f4712acd9f$exports.distributionTypes,
    ...$d0d8b6f4712acd9f$exports.feegrantTypes,
    ...$d0d8b6f4712acd9f$exports.govTypes,
    ...$d0d8b6f4712acd9f$exports.groupTypes,
    ...$d0d8b6f4712acd9f$exports.stakingTypes,
    ...$d0d8b6f4712acd9f$exports.ibcTypes,
    ...$d0d8b6f4712acd9f$exports.vestingTypes
];
function $d55b7ddfb58f7fc2$var$createDefaultAminoConverters() {
    return {
        ...(0, $d0d8b6f4712acd9f$exports.createAuthzAminoConverters)(),
        ...(0, $d0d8b6f4712acd9f$exports.createBankAminoConverters)(),
        ...(0, $d0d8b6f4712acd9f$exports.createDistributionAminoConverters)(),
        ...(0, $d0d8b6f4712acd9f$exports.createGovAminoConverters)(),
        ...(0, $d0d8b6f4712acd9f$exports.createStakingAminoConverters)(),
        ...(0, $d0d8b6f4712acd9f$exports.createIbcAminoConverters)(),
        ...(0, $d0d8b6f4712acd9f$exports.createFeegrantAminoConverters)(),
        ...(0, $d0d8b6f4712acd9f$exports.createVestingAminoConverters)()
    };
}
$d55b7ddfb58f7fc2$exports.createDefaultAminoConverters = $d55b7ddfb58f7fc2$var$createDefaultAminoConverters;
class $d55b7ddfb58f7fc2$var$SigningStargateClient extends $b610d1b6e6077b41$exports.StargateClient {
    /**
     * Creates an instance by connecting to the given Tendermint RPC endpoint.
     *
     * This uses auto-detection to decide between a Tendermint 0.37 and 0.34 client.
     * To set the Tendermint client explicitly, use `createWithSigner`.
     */ static async connectWithSigner(endpoint, signer, options = {}) {
        // Tendermint/CometBFT 0.34/0.37 auto-detection. Starting with 0.37 we seem to get reliable versions again 🎉
        // Using 0.34 as the fallback.
        let tmClient;
        const tm37Client = await $76d53df890d1b5af$exports.Tendermint37Client.connect(endpoint);
        const version = (await tm37Client.status()).nodeInfo.version;
        if (version.startsWith("0.37.")) tmClient = tm37Client;
        else {
            tm37Client.disconnect();
            tmClient = await $76d53df890d1b5af$exports.Tendermint34Client.connect(endpoint);
        }
        return $d55b7ddfb58f7fc2$var$SigningStargateClient.createWithSigner(tmClient, signer, options);
    }
    /**
     * Creates an instance from a manually created Tendermint client.
     * Use this to use `Tendermint37Client` instead of `Tendermint34Client`.
     */ static async createWithSigner(tmClient, signer, options = {}) {
        return new $d55b7ddfb58f7fc2$var$SigningStargateClient(tmClient, signer, options);
    }
    /**
     * Creates a client in offline mode.
     *
     * This should only be used in niche cases where you know exactly what you're doing,
     * e.g. when building an offline signing application.
     *
     * When you try to use online functionality with such a signer, an
     * exception will be raised.
     */ static async offline(signer, options = {}) {
        return new $d55b7ddfb58f7fc2$var$SigningStargateClient(undefined, signer, options);
    }
    constructor(tmClient, signer, options){
        super(tmClient, options);
        const { registry: registry = new $c0a9381c50e8ee56$exports.Registry($d55b7ddfb58f7fc2$exports.defaultRegistryTypes), aminoTypes: aminoTypes = new $c23a6866dab6bf09$exports.AminoTypes($d55b7ddfb58f7fc2$var$createDefaultAminoConverters()) } = options;
        this.registry = registry;
        this.aminoTypes = aminoTypes;
        this.signer = signer;
        this.broadcastTimeoutMs = options.broadcastTimeoutMs;
        this.broadcastPollIntervalMs = options.broadcastPollIntervalMs;
        this.gasPrice = options.gasPrice;
    }
    async simulate(signerAddress, messages, memo) {
        const anyMsgs = messages.map((m)=>this.registry.encodeAsAny(m));
        const accountFromSigner = (await this.signer.getAccounts()).find((account)=>account.address === signerAddress);
        if (!accountFromSigner) throw new Error("Failed to retrieve account from signer");
        const pubkey = (0, $6078e8ec636191fb$exports.encodeSecp256k1Pubkey)(accountFromSigner.pubkey);
        const { sequence: sequence } = await this.getSequence(signerAddress);
        const { gasInfo: gasInfo } = await this.forceGetQueryClient().tx.simulate(anyMsgs, memo, pubkey, sequence);
        (0, $fZwG5.assertDefined)(gasInfo);
        return $7UsfE.Uint53.fromString(gasInfo.gasUsed.toString()).toNumber();
    }
    async sendTokens(senderAddress, recipientAddress, amount, fee, memo = "") {
        const sendMsg = {
            typeUrl: "/cosmos.bank.v1beta1.MsgSend",
            value: {
                fromAddress: senderAddress,
                toAddress: recipientAddress,
                amount: [
                    ...amount
                ]
            }
        };
        return this.signAndBroadcast(senderAddress, [
            sendMsg
        ], fee, memo);
    }
    async delegateTokens(delegatorAddress, validatorAddress, amount, fee, memo = "") {
        const delegateMsg = {
            typeUrl: "/cosmos.staking.v1beta1.MsgDelegate",
            value: $732d6a51596ab26e$exports.MsgDelegate.fromPartial({
                delegatorAddress: delegatorAddress,
                validatorAddress: validatorAddress,
                amount: amount
            })
        };
        return this.signAndBroadcast(delegatorAddress, [
            delegateMsg
        ], fee, memo);
    }
    async undelegateTokens(delegatorAddress, validatorAddress, amount, fee, memo = "") {
        const undelegateMsg = {
            typeUrl: "/cosmos.staking.v1beta1.MsgUndelegate",
            value: $732d6a51596ab26e$exports.MsgUndelegate.fromPartial({
                delegatorAddress: delegatorAddress,
                validatorAddress: validatorAddress,
                amount: amount
            })
        };
        return this.signAndBroadcast(delegatorAddress, [
            undelegateMsg
        ], fee, memo);
    }
    async withdrawRewards(delegatorAddress, validatorAddress, fee, memo = "") {
        const withdrawMsg = {
            typeUrl: "/cosmos.distribution.v1beta1.MsgWithdrawDelegatorReward",
            value: $e8f7350709207109$exports.MsgWithdrawDelegatorReward.fromPartial({
                delegatorAddress: delegatorAddress,
                validatorAddress: validatorAddress
            })
        };
        return this.signAndBroadcast(delegatorAddress, [
            withdrawMsg
        ], fee, memo);
    }
    async sendIbcTokens(senderAddress, recipientAddress, transferAmount, sourcePort, sourceChannel, timeoutHeight, /** timeout in seconds */ timeoutTimestamp, fee, memo = "") {
        const timeoutTimestampNanoseconds = timeoutTimestamp ? $d55b7ddfb58f7fc2$var$long_1.default.fromNumber(timeoutTimestamp).multiply(1000000000) : undefined;
        const transferMsg = {
            typeUrl: "/ibc.applications.transfer.v1.MsgTransfer",
            value: $32d2cb55dc1dc5c5$exports.MsgTransfer.fromPartial({
                sourcePort: sourcePort,
                sourceChannel: sourceChannel,
                sender: senderAddress,
                receiver: recipientAddress,
                token: transferAmount,
                timeoutHeight: timeoutHeight,
                timeoutTimestamp: timeoutTimestampNanoseconds
            })
        };
        return this.signAndBroadcast(senderAddress, [
            transferMsg
        ], fee, memo);
    }
    async signAndBroadcast(signerAddress, messages, fee, memo = "") {
        let usedFee;
        if (fee == "auto" || typeof fee === "number") {
            (0, $fZwG5.assertDefined)(this.gasPrice, "Gas price must be set in the client options when auto gas is used.");
            const gasEstimation = await this.simulate(signerAddress, messages, memo);
            // Starting with Cosmos SDK 0.47, we see many cases in which 1.3 is not enough anymore
            // E.g. https://github.com/cosmos/cosmos-sdk/issues/16020
            const multiplier = typeof fee === "number" ? fee : 1.4;
            usedFee = (0, $3c41c4da02081396$exports.calculateFee)(Math.round(gasEstimation * multiplier), this.gasPrice);
        } else usedFee = fee;
        const txRaw = await this.sign(signerAddress, messages, usedFee, memo);
        const txBytes = $eedf6d503be55212$exports.TxRaw.encode(txRaw).finish();
        return this.broadcastTx(txBytes, this.broadcastTimeoutMs, this.broadcastPollIntervalMs);
    }
    /**
     * This method is useful if you want to send a transaction in broadcast,
     * without waiting for it to be placed inside a block, because for example
     * I would like to receive the hash to later track the transaction with another tool.
     * @returns Returns the hash of the transaction
     */ async signAndBroadcastSync(signerAddress, messages, fee, memo = "") {
        let usedFee;
        if (fee == "auto" || typeof fee === "number") {
            (0, $fZwG5.assertDefined)(this.gasPrice, "Gas price must be set in the client options when auto gas is used.");
            const gasEstimation = await this.simulate(signerAddress, messages, memo);
            const multiplier = typeof fee === "number" ? fee : 1.3;
            usedFee = (0, $3c41c4da02081396$exports.calculateFee)(Math.round(gasEstimation * multiplier), this.gasPrice);
        } else usedFee = fee;
        const txRaw = await this.sign(signerAddress, messages, usedFee, memo);
        const txBytes = $eedf6d503be55212$exports.TxRaw.encode(txRaw).finish();
        return this.broadcastTxSync(txBytes);
    }
    /**
     * Gets account number and sequence from the API, creates a sign doc,
     * creates a single signature and assembles the signed transaction.
     *
     * The sign mode (SIGN_MODE_DIRECT or SIGN_MODE_LEGACY_AMINO_JSON) is determined by this client's signer.
     *
     * You can pass signer data (account number, sequence and chain ID) explicitly instead of querying them
     * from the chain. This is needed when signing for a multisig account, but it also allows for offline signing
     * (See the SigningStargateClient.offline constructor).
     */ async sign(signerAddress, messages, fee, memo, explicitSignerData) {
        let signerData;
        if (explicitSignerData) signerData = explicitSignerData;
        else {
            const { accountNumber: accountNumber, sequence: sequence } = await this.getSequence(signerAddress);
            const chainId = await this.getChainId();
            signerData = {
                accountNumber: accountNumber,
                sequence: sequence,
                chainId: chainId
            };
        }
        return (0, $c0a9381c50e8ee56$exports.isOfflineDirectSigner)(this.signer) ? this.signDirect(signerAddress, messages, fee, memo, signerData) : this.signAmino(signerAddress, messages, fee, memo, signerData);
    }
    async signAmino(signerAddress, messages, fee, memo, { accountNumber: accountNumber, sequence: sequence, chainId: chainId }) {
        (0, $fZwG5.assert)(!(0, $c0a9381c50e8ee56$exports.isOfflineDirectSigner)(this.signer));
        const accountFromSigner = (await this.signer.getAccounts()).find((account)=>account.address === signerAddress);
        if (!accountFromSigner) throw new Error("Failed to retrieve account from signer");
        const pubkey = (0, $c0a9381c50e8ee56$exports.encodePubkey)((0, $6078e8ec636191fb$exports.encodeSecp256k1Pubkey)(accountFromSigner.pubkey));
        const signMode = $cefef10ba181af21$exports.SignMode.SIGN_MODE_LEGACY_AMINO_JSON;
        const msgs = messages.map((msg)=>this.aminoTypes.toAmino(msg));
        const signDoc = (0, $6078e8ec636191fb$exports.makeSignDoc)(msgs, fee, chainId, memo, accountNumber, sequence);
        const { signature: signature, signed: signed } = await this.signer.signAmino(signerAddress, signDoc);
        const signedTxBody = {
            messages: signed.msgs.map((msg)=>this.aminoTypes.fromAmino(msg)),
            memo: signed.memo
        };
        const signedTxBodyEncodeObject = {
            typeUrl: "/cosmos.tx.v1beta1.TxBody",
            value: signedTxBody
        };
        const signedTxBodyBytes = this.registry.encode(signedTxBodyEncodeObject);
        const signedGasLimit = $7UsfE.Int53.fromString(signed.fee.gas).toNumber();
        const signedSequence = $7UsfE.Int53.fromString(signed.sequence).toNumber();
        const signedAuthInfoBytes = (0, $c0a9381c50e8ee56$exports.makeAuthInfoBytes)([
            {
                pubkey: pubkey,
                sequence: signedSequence
            }
        ], signed.fee.amount, signedGasLimit, signed.fee.granter, signed.fee.payer, signMode);
        return $eedf6d503be55212$exports.TxRaw.fromPartial({
            bodyBytes: signedTxBodyBytes,
            authInfoBytes: signedAuthInfoBytes,
            signatures: [
                (0, $6XcLW.fromBase64)(signature.signature)
            ]
        });
    }
    async signDirect(signerAddress, messages, fee, memo, { accountNumber: accountNumber, sequence: sequence, chainId: chainId }) {
        (0, $fZwG5.assert)((0, $c0a9381c50e8ee56$exports.isOfflineDirectSigner)(this.signer));
        const accountFromSigner = (await this.signer.getAccounts()).find((account)=>account.address === signerAddress);
        if (!accountFromSigner) throw new Error("Failed to retrieve account from signer");
        const pubkey = (0, $c0a9381c50e8ee56$exports.encodePubkey)((0, $6078e8ec636191fb$exports.encodeSecp256k1Pubkey)(accountFromSigner.pubkey));
        const txBodyEncodeObject = {
            typeUrl: "/cosmos.tx.v1beta1.TxBody",
            value: {
                messages: messages,
                memo: memo
            }
        };
        const txBodyBytes = this.registry.encode(txBodyEncodeObject);
        const gasLimit = $7UsfE.Int53.fromString(fee.gas).toNumber();
        const authInfoBytes = (0, $c0a9381c50e8ee56$exports.makeAuthInfoBytes)([
            {
                pubkey: pubkey,
                sequence: sequence
            }
        ], fee.amount, gasLimit, fee.granter, fee.payer);
        const signDoc = (0, $c0a9381c50e8ee56$exports.makeSignDoc)(txBodyBytes, authInfoBytes, chainId, accountNumber);
        const { signature: signature, signed: signed } = await this.signer.signDirect(signerAddress, signDoc);
        return $eedf6d503be55212$exports.TxRaw.fromPartial({
            bodyBytes: signed.bodyBytes,
            authInfoBytes: signed.authInfoBytes,
            signatures: [
                (0, $6XcLW.fromBase64)(signature.signature)
            ]
        });
    }
}
$d55b7ddfb58f7fc2$exports.SigningStargateClient = $d55b7ddfb58f7fc2$var$SigningStargateClient;


Object.defineProperty($ee390ef646431151$exports, "createDefaultAminoConverters", {
    enumerable: true,
    get: function() {
        return $d55b7ddfb58f7fc2$exports.createDefaultAminoConverters;
    }
});
Object.defineProperty($ee390ef646431151$exports, "defaultRegistryTypes", {
    enumerable: true,
    get: function() {
        return $d55b7ddfb58f7fc2$exports.defaultRegistryTypes;
    }
});
Object.defineProperty($ee390ef646431151$exports, "SigningStargateClient", {
    enumerable: true,
    get: function() {
        return $d55b7ddfb58f7fc2$exports.SigningStargateClient;
    }
});

Object.defineProperty($ee390ef646431151$exports, "assertIsDeliverTxFailure", {
    enumerable: true,
    get: function() {
        return $b610d1b6e6077b41$exports.assertIsDeliverTxFailure;
    }
});
Object.defineProperty($ee390ef646431151$exports, "assertIsDeliverTxSuccess", {
    enumerable: true,
    get: function() {
        return $b610d1b6e6077b41$exports.assertIsDeliverTxSuccess;
    }
});
Object.defineProperty($ee390ef646431151$exports, "BroadcastTxError", {
    enumerable: true,
    get: function() {
        return $b610d1b6e6077b41$exports.BroadcastTxError;
    }
});
Object.defineProperty($ee390ef646431151$exports, "isDeliverTxFailure", {
    enumerable: true,
    get: function() {
        return $b610d1b6e6077b41$exports.isDeliverTxFailure;
    }
});
Object.defineProperty($ee390ef646431151$exports, "isDeliverTxSuccess", {
    enumerable: true,
    get: function() {
        return $b610d1b6e6077b41$exports.isDeliverTxSuccess;
    }
});
Object.defineProperty($ee390ef646431151$exports, "StargateClient", {
    enumerable: true,
    get: function() {
        return $b610d1b6e6077b41$exports.StargateClient;
    }
});
Object.defineProperty($ee390ef646431151$exports, "TimeoutError", {
    enumerable: true,
    get: function() {
        return $b610d1b6e6077b41$exports.TimeoutError;
    }
});

Object.defineProperty($ee390ef646431151$exports, "coin", {
    enumerable: true,
    get: function() {
        return $c0a9381c50e8ee56$exports.coin;
    }
});
Object.defineProperty($ee390ef646431151$exports, "coins", {
    enumerable: true,
    get: function() {
        return $c0a9381c50e8ee56$exports.coins;
    }
});
Object.defineProperty($ee390ef646431151$exports, "makeCosmoshubPath", {
    enumerable: true,
    get: function() {
        return $c0a9381c50e8ee56$exports.makeCosmoshubPath;
    }
});
Object.defineProperty($ee390ef646431151$exports, "parseCoins", {
    enumerable: true,
    get: function() {
        return $c0a9381c50e8ee56$exports.parseCoins;
    }
});


var $4e4e07fbc7086f67$exports = {};
"use strict";
var $4e4e07fbc7086f67$var$__createBinding = $4e4e07fbc7086f67$exports && $4e4e07fbc7086f67$exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, {
        enumerable: true,
        get: function() {
            return m[k];
        }
    });
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $4e4e07fbc7086f67$var$__exportStar = $4e4e07fbc7086f67$exports && $4e4e07fbc7086f67$exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $4e4e07fbc7086f67$var$__createBinding(exports1, m, p);
};
Object.defineProperty($4e4e07fbc7086f67$exports, "__esModule", {
    value: true
});

$4e4e07fbc7086f67$var$__exportStar((parcelRequire("dTrds")), $4e4e07fbc7086f67$exports);

$4e4e07fbc7086f67$var$__exportStar((parcelRequire("lWBwx")), $4e4e07fbc7086f67$exports);

$4e4e07fbc7086f67$var$__exportStar((parcelRequire("4Ve8M")), $4e4e07fbc7086f67$exports);

$4e4e07fbc7086f67$var$__exportStar((parcelRequire("3kRIM")), $4e4e07fbc7086f67$exports);

$4e4e07fbc7086f67$var$__exportStar((parcelRequire("cDipa")), $4e4e07fbc7086f67$exports);

$4e4e07fbc7086f67$var$__exportStar((parcelRequire("SezG1")), $4e4e07fbc7086f67$exports);


var $5e79880e7465f438$exports = {};
"use strict";
var $5e79880e7465f438$var$__importDefault = $5e79880e7465f438$exports && $5e79880e7465f438$exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty($5e79880e7465f438$exports, "__esModule", {
    value: true
});
$5e79880e7465f438$exports.MsgClientImpl = $5e79880e7465f438$exports.MsgClearAdminResponse = $5e79880e7465f438$exports.MsgClearAdmin = $5e79880e7465f438$exports.MsgUpdateAdminResponse = $5e79880e7465f438$exports.MsgUpdateAdmin = $5e79880e7465f438$exports.MsgMigrateContractResponse = $5e79880e7465f438$exports.MsgMigrateContract = $5e79880e7465f438$exports.MsgExecuteContractResponse = $5e79880e7465f438$exports.MsgExecuteContract = $5e79880e7465f438$exports.MsgInstantiateContractResponse = $5e79880e7465f438$exports.MsgInstantiateContract = $5e79880e7465f438$exports.MsgStoreCodeResponse = $5e79880e7465f438$exports.MsgStoreCode = $5e79880e7465f438$exports.protobufPackage = void 0;

/* eslint-disable */ const $5e79880e7465f438$var$long_1 = $5e79880e7465f438$var$__importDefault((parcelRequire("24cgb")));

const $5e79880e7465f438$var$minimal_1 = $5e79880e7465f438$var$__importDefault((parcelRequire("fQBv0")));
var $556c463580a8e5c3$exports = {};
"use strict";
var $556c463580a8e5c3$var$__importDefault = $556c463580a8e5c3$exports && $556c463580a8e5c3$exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty($556c463580a8e5c3$exports, "__esModule", {
    value: true
});
$556c463580a8e5c3$exports.DecProto = $556c463580a8e5c3$exports.IntProto = $556c463580a8e5c3$exports.DecCoin = $556c463580a8e5c3$exports.Coin = $556c463580a8e5c3$exports.protobufPackage = void 0;

/* eslint-disable */ const $556c463580a8e5c3$var$long_1 = $556c463580a8e5c3$var$__importDefault((parcelRequire("24cgb")));

const $556c463580a8e5c3$var$minimal_1 = $556c463580a8e5c3$var$__importDefault((parcelRequire("fQBv0")));
$556c463580a8e5c3$exports.protobufPackage = "cosmos.base.v1beta1";
function $556c463580a8e5c3$var$createBaseCoin() {
    return {
        denom: "",
        amount: ""
    };
}
$556c463580a8e5c3$exports.Coin = {
    encode (message, writer = $556c463580a8e5c3$var$minimal_1.default.Writer.create()) {
        if (message.denom !== "") writer.uint32(10).string(message.denom);
        if (message.amount !== "") writer.uint32(18).string(message.amount);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $556c463580a8e5c3$var$minimal_1.default.Reader ? input : new $556c463580a8e5c3$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $556c463580a8e5c3$var$createBaseCoin();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.denom = reader.string();
                    break;
                case 2:
                    message.amount = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            denom: $556c463580a8e5c3$var$isSet(object.denom) ? String(object.denom) : "",
            amount: $556c463580a8e5c3$var$isSet(object.amount) ? String(object.amount) : ""
        };
    },
    toJSON (message) {
        const obj = {};
        message.denom !== undefined && (obj.denom = message.denom);
        message.amount !== undefined && (obj.amount = message.amount);
        return obj;
    },
    fromPartial (object) {
        var _a, _b;
        const message = $556c463580a8e5c3$var$createBaseCoin();
        message.denom = (_a = object.denom) !== null && _a !== void 0 ? _a : "";
        message.amount = (_b = object.amount) !== null && _b !== void 0 ? _b : "";
        return message;
    }
};
function $556c463580a8e5c3$var$createBaseDecCoin() {
    return {
        denom: "",
        amount: ""
    };
}
$556c463580a8e5c3$exports.DecCoin = {
    encode (message, writer = $556c463580a8e5c3$var$minimal_1.default.Writer.create()) {
        if (message.denom !== "") writer.uint32(10).string(message.denom);
        if (message.amount !== "") writer.uint32(18).string(message.amount);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $556c463580a8e5c3$var$minimal_1.default.Reader ? input : new $556c463580a8e5c3$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $556c463580a8e5c3$var$createBaseDecCoin();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.denom = reader.string();
                    break;
                case 2:
                    message.amount = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            denom: $556c463580a8e5c3$var$isSet(object.denom) ? String(object.denom) : "",
            amount: $556c463580a8e5c3$var$isSet(object.amount) ? String(object.amount) : ""
        };
    },
    toJSON (message) {
        const obj = {};
        message.denom !== undefined && (obj.denom = message.denom);
        message.amount !== undefined && (obj.amount = message.amount);
        return obj;
    },
    fromPartial (object) {
        var _a, _b;
        const message = $556c463580a8e5c3$var$createBaseDecCoin();
        message.denom = (_a = object.denom) !== null && _a !== void 0 ? _a : "";
        message.amount = (_b = object.amount) !== null && _b !== void 0 ? _b : "";
        return message;
    }
};
function $556c463580a8e5c3$var$createBaseIntProto() {
    return {
        int: ""
    };
}
$556c463580a8e5c3$exports.IntProto = {
    encode (message, writer = $556c463580a8e5c3$var$minimal_1.default.Writer.create()) {
        if (message.int !== "") writer.uint32(10).string(message.int);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $556c463580a8e5c3$var$minimal_1.default.Reader ? input : new $556c463580a8e5c3$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $556c463580a8e5c3$var$createBaseIntProto();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.int = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            int: $556c463580a8e5c3$var$isSet(object.int) ? String(object.int) : ""
        };
    },
    toJSON (message) {
        const obj = {};
        message.int !== undefined && (obj.int = message.int);
        return obj;
    },
    fromPartial (object) {
        var _a;
        const message = $556c463580a8e5c3$var$createBaseIntProto();
        message.int = (_a = object.int) !== null && _a !== void 0 ? _a : "";
        return message;
    }
};
function $556c463580a8e5c3$var$createBaseDecProto() {
    return {
        dec: ""
    };
}
$556c463580a8e5c3$exports.DecProto = {
    encode (message, writer = $556c463580a8e5c3$var$minimal_1.default.Writer.create()) {
        if (message.dec !== "") writer.uint32(10).string(message.dec);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $556c463580a8e5c3$var$minimal_1.default.Reader ? input : new $556c463580a8e5c3$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $556c463580a8e5c3$var$createBaseDecProto();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.dec = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            dec: $556c463580a8e5c3$var$isSet(object.dec) ? String(object.dec) : ""
        };
    },
    toJSON (message) {
        const obj = {};
        message.dec !== undefined && (obj.dec = message.dec);
        return obj;
    },
    fromPartial (object) {
        var _a;
        const message = $556c463580a8e5c3$var$createBaseDecProto();
        message.dec = (_a = object.dec) !== null && _a !== void 0 ? _a : "";
        return message;
    }
};
if ($556c463580a8e5c3$var$minimal_1.default.util.Long !== $556c463580a8e5c3$var$long_1.default) {
    $556c463580a8e5c3$var$minimal_1.default.util.Long = $556c463580a8e5c3$var$long_1.default;
    $556c463580a8e5c3$var$minimal_1.default.configure();
}
function $556c463580a8e5c3$var$isSet(value) {
    return value !== null && value !== undefined;
}


var $7fcfeae3898d0f34$exports = {};
"use strict";
var $7fcfeae3898d0f34$var$__importDefault = $7fcfeae3898d0f34$exports && $7fcfeae3898d0f34$exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty($7fcfeae3898d0f34$exports, "__esModule", {
    value: true
});
$7fcfeae3898d0f34$exports.Model = $7fcfeae3898d0f34$exports.AbsoluteTxPosition = $7fcfeae3898d0f34$exports.ContractCodeHistoryEntry = $7fcfeae3898d0f34$exports.ContractInfo = $7fcfeae3898d0f34$exports.CodeInfo = $7fcfeae3898d0f34$exports.Params = $7fcfeae3898d0f34$exports.AccessConfig = $7fcfeae3898d0f34$exports.AccessTypeParam = $7fcfeae3898d0f34$exports.contractCodeHistoryOperationTypeToJSON = $7fcfeae3898d0f34$exports.contractCodeHistoryOperationTypeFromJSON = $7fcfeae3898d0f34$exports.ContractCodeHistoryOperationType = $7fcfeae3898d0f34$exports.accessTypeToJSON = $7fcfeae3898d0f34$exports.accessTypeFromJSON = $7fcfeae3898d0f34$exports.AccessType = $7fcfeae3898d0f34$exports.protobufPackage = void 0;

/* eslint-disable */ const $7fcfeae3898d0f34$var$long_1 = $7fcfeae3898d0f34$var$__importDefault((parcelRequire("24cgb")));

const $7fcfeae3898d0f34$var$minimal_1 = $7fcfeae3898d0f34$var$__importDefault((parcelRequire("fQBv0")));
var $f68f58f1e7b3dfff$exports = {};
"use strict";
var $f68f58f1e7b3dfff$var$__importDefault = $f68f58f1e7b3dfff$exports && $f68f58f1e7b3dfff$exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty($f68f58f1e7b3dfff$exports, "__esModule", {
    value: true
});
$f68f58f1e7b3dfff$exports.Any = $f68f58f1e7b3dfff$exports.protobufPackage = void 0;

/* eslint-disable */ const $f68f58f1e7b3dfff$var$long_1 = $f68f58f1e7b3dfff$var$__importDefault((parcelRequire("24cgb")));

const $f68f58f1e7b3dfff$var$minimal_1 = $f68f58f1e7b3dfff$var$__importDefault((parcelRequire("fQBv0")));
$f68f58f1e7b3dfff$exports.protobufPackage = "google.protobuf";
function $f68f58f1e7b3dfff$var$createBaseAny() {
    return {
        typeUrl: "",
        value: new Uint8Array()
    };
}
$f68f58f1e7b3dfff$exports.Any = {
    encode (message, writer = $f68f58f1e7b3dfff$var$minimal_1.default.Writer.create()) {
        if (message.typeUrl !== "") writer.uint32(10).string(message.typeUrl);
        if (message.value.length !== 0) writer.uint32(18).bytes(message.value);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $f68f58f1e7b3dfff$var$minimal_1.default.Reader ? input : new $f68f58f1e7b3dfff$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $f68f58f1e7b3dfff$var$createBaseAny();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.typeUrl = reader.string();
                    break;
                case 2:
                    message.value = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            typeUrl: $f68f58f1e7b3dfff$var$isSet(object.typeUrl) ? String(object.typeUrl) : "",
            value: $f68f58f1e7b3dfff$var$isSet(object.value) ? $f68f58f1e7b3dfff$var$bytesFromBase64(object.value) : new Uint8Array()
        };
    },
    toJSON (message) {
        const obj = {};
        message.typeUrl !== undefined && (obj.typeUrl = message.typeUrl);
        message.value !== undefined && (obj.value = $f68f58f1e7b3dfff$var$base64FromBytes(message.value !== undefined ? message.value : new Uint8Array()));
        return obj;
    },
    fromPartial (object) {
        var _a, _b;
        const message = $f68f58f1e7b3dfff$var$createBaseAny();
        message.typeUrl = (_a = object.typeUrl) !== null && _a !== void 0 ? _a : "";
        message.value = (_b = object.value) !== null && _b !== void 0 ? _b : new Uint8Array();
        return message;
    }
};
var $f68f58f1e7b3dfff$var$globalThis = (()=>{
    if (typeof $f68f58f1e7b3dfff$var$globalThis !== "undefined") return $f68f58f1e7b3dfff$var$globalThis;
    if (typeof self !== "undefined") return self;
    if (typeof window !== "undefined") return window;
    if (typeof $parcel$global !== "undefined") return $parcel$global;
    throw "Unable to locate global object";
})();
function $f68f58f1e7b3dfff$var$bytesFromBase64(b64) {
    if ($f68f58f1e7b3dfff$var$globalThis.Buffer) return Uint8Array.from($f68f58f1e7b3dfff$var$globalThis.Buffer.from(b64, "base64"));
    else {
        const bin = $f68f58f1e7b3dfff$var$globalThis.atob(b64);
        const arr = new Uint8Array(bin.length);
        for(let i = 0; i < bin.length; ++i)arr[i] = bin.charCodeAt(i);
        return arr;
    }
}
function $f68f58f1e7b3dfff$var$base64FromBytes(arr) {
    if ($f68f58f1e7b3dfff$var$globalThis.Buffer) return $f68f58f1e7b3dfff$var$globalThis.Buffer.from(arr).toString("base64");
    else {
        const bin = [];
        arr.forEach((byte)=>{
            bin.push(String.fromCharCode(byte));
        });
        return $f68f58f1e7b3dfff$var$globalThis.btoa(bin.join(""));
    }
}
if ($f68f58f1e7b3dfff$var$minimal_1.default.util.Long !== $f68f58f1e7b3dfff$var$long_1.default) {
    $f68f58f1e7b3dfff$var$minimal_1.default.util.Long = $f68f58f1e7b3dfff$var$long_1.default;
    $f68f58f1e7b3dfff$var$minimal_1.default.configure();
}
function $f68f58f1e7b3dfff$var$isSet(value) {
    return value !== null && value !== undefined;
}


$7fcfeae3898d0f34$exports.protobufPackage = "cosmwasm.wasm.v1";
/** AccessType permission types */ var $7fcfeae3898d0f34$var$AccessType;
(function(AccessType) {
    /** ACCESS_TYPE_UNSPECIFIED - AccessTypeUnspecified placeholder for empty value */ AccessType[AccessType["ACCESS_TYPE_UNSPECIFIED"] = 0] = "ACCESS_TYPE_UNSPECIFIED";
    /** ACCESS_TYPE_NOBODY - AccessTypeNobody forbidden */ AccessType[AccessType["ACCESS_TYPE_NOBODY"] = 1] = "ACCESS_TYPE_NOBODY";
    /** ACCESS_TYPE_ONLY_ADDRESS - AccessTypeOnlyAddress restricted to an address */ AccessType[AccessType["ACCESS_TYPE_ONLY_ADDRESS"] = 2] = "ACCESS_TYPE_ONLY_ADDRESS";
    /** ACCESS_TYPE_EVERYBODY - AccessTypeEverybody unrestricted */ AccessType[AccessType["ACCESS_TYPE_EVERYBODY"] = 3] = "ACCESS_TYPE_EVERYBODY";
    AccessType[AccessType["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})($7fcfeae3898d0f34$var$AccessType = $7fcfeae3898d0f34$exports.AccessType || ($7fcfeae3898d0f34$exports.AccessType = {}));
function $7fcfeae3898d0f34$var$accessTypeFromJSON(object) {
    switch(object){
        case 0:
        case "ACCESS_TYPE_UNSPECIFIED":
            return $7fcfeae3898d0f34$var$AccessType.ACCESS_TYPE_UNSPECIFIED;
        case 1:
        case "ACCESS_TYPE_NOBODY":
            return $7fcfeae3898d0f34$var$AccessType.ACCESS_TYPE_NOBODY;
        case 2:
        case "ACCESS_TYPE_ONLY_ADDRESS":
            return $7fcfeae3898d0f34$var$AccessType.ACCESS_TYPE_ONLY_ADDRESS;
        case 3:
        case "ACCESS_TYPE_EVERYBODY":
            return $7fcfeae3898d0f34$var$AccessType.ACCESS_TYPE_EVERYBODY;
        case -1:
        case "UNRECOGNIZED":
        default:
            return $7fcfeae3898d0f34$var$AccessType.UNRECOGNIZED;
    }
}
$7fcfeae3898d0f34$exports.accessTypeFromJSON = $7fcfeae3898d0f34$var$accessTypeFromJSON;
function $7fcfeae3898d0f34$var$accessTypeToJSON(object) {
    switch(object){
        case $7fcfeae3898d0f34$var$AccessType.ACCESS_TYPE_UNSPECIFIED:
            return "ACCESS_TYPE_UNSPECIFIED";
        case $7fcfeae3898d0f34$var$AccessType.ACCESS_TYPE_NOBODY:
            return "ACCESS_TYPE_NOBODY";
        case $7fcfeae3898d0f34$var$AccessType.ACCESS_TYPE_ONLY_ADDRESS:
            return "ACCESS_TYPE_ONLY_ADDRESS";
        case $7fcfeae3898d0f34$var$AccessType.ACCESS_TYPE_EVERYBODY:
            return "ACCESS_TYPE_EVERYBODY";
        case $7fcfeae3898d0f34$var$AccessType.UNRECOGNIZED:
        default:
            return "UNRECOGNIZED";
    }
}
$7fcfeae3898d0f34$exports.accessTypeToJSON = $7fcfeae3898d0f34$var$accessTypeToJSON;
/** ContractCodeHistoryOperationType actions that caused a code change */ var $7fcfeae3898d0f34$var$ContractCodeHistoryOperationType;
(function(ContractCodeHistoryOperationType) {
    /** CONTRACT_CODE_HISTORY_OPERATION_TYPE_UNSPECIFIED - ContractCodeHistoryOperationTypeUnspecified placeholder for empty value */ ContractCodeHistoryOperationType[ContractCodeHistoryOperationType["CONTRACT_CODE_HISTORY_OPERATION_TYPE_UNSPECIFIED"] = 0] = "CONTRACT_CODE_HISTORY_OPERATION_TYPE_UNSPECIFIED";
    /** CONTRACT_CODE_HISTORY_OPERATION_TYPE_INIT - ContractCodeHistoryOperationTypeInit on chain contract instantiation */ ContractCodeHistoryOperationType[ContractCodeHistoryOperationType["CONTRACT_CODE_HISTORY_OPERATION_TYPE_INIT"] = 1] = "CONTRACT_CODE_HISTORY_OPERATION_TYPE_INIT";
    /** CONTRACT_CODE_HISTORY_OPERATION_TYPE_MIGRATE - ContractCodeHistoryOperationTypeMigrate code migration */ ContractCodeHistoryOperationType[ContractCodeHistoryOperationType["CONTRACT_CODE_HISTORY_OPERATION_TYPE_MIGRATE"] = 2] = "CONTRACT_CODE_HISTORY_OPERATION_TYPE_MIGRATE";
    /** CONTRACT_CODE_HISTORY_OPERATION_TYPE_GENESIS - ContractCodeHistoryOperationTypeGenesis based on genesis data */ ContractCodeHistoryOperationType[ContractCodeHistoryOperationType["CONTRACT_CODE_HISTORY_OPERATION_TYPE_GENESIS"] = 3] = "CONTRACT_CODE_HISTORY_OPERATION_TYPE_GENESIS";
    ContractCodeHistoryOperationType[ContractCodeHistoryOperationType["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})($7fcfeae3898d0f34$var$ContractCodeHistoryOperationType = $7fcfeae3898d0f34$exports.ContractCodeHistoryOperationType || ($7fcfeae3898d0f34$exports.ContractCodeHistoryOperationType = {}));
function $7fcfeae3898d0f34$var$contractCodeHistoryOperationTypeFromJSON(object) {
    switch(object){
        case 0:
        case "CONTRACT_CODE_HISTORY_OPERATION_TYPE_UNSPECIFIED":
            return $7fcfeae3898d0f34$var$ContractCodeHistoryOperationType.CONTRACT_CODE_HISTORY_OPERATION_TYPE_UNSPECIFIED;
        case 1:
        case "CONTRACT_CODE_HISTORY_OPERATION_TYPE_INIT":
            return $7fcfeae3898d0f34$var$ContractCodeHistoryOperationType.CONTRACT_CODE_HISTORY_OPERATION_TYPE_INIT;
        case 2:
        case "CONTRACT_CODE_HISTORY_OPERATION_TYPE_MIGRATE":
            return $7fcfeae3898d0f34$var$ContractCodeHistoryOperationType.CONTRACT_CODE_HISTORY_OPERATION_TYPE_MIGRATE;
        case 3:
        case "CONTRACT_CODE_HISTORY_OPERATION_TYPE_GENESIS":
            return $7fcfeae3898d0f34$var$ContractCodeHistoryOperationType.CONTRACT_CODE_HISTORY_OPERATION_TYPE_GENESIS;
        case -1:
        case "UNRECOGNIZED":
        default:
            return $7fcfeae3898d0f34$var$ContractCodeHistoryOperationType.UNRECOGNIZED;
    }
}
$7fcfeae3898d0f34$exports.contractCodeHistoryOperationTypeFromJSON = $7fcfeae3898d0f34$var$contractCodeHistoryOperationTypeFromJSON;
function $7fcfeae3898d0f34$var$contractCodeHistoryOperationTypeToJSON(object) {
    switch(object){
        case $7fcfeae3898d0f34$var$ContractCodeHistoryOperationType.CONTRACT_CODE_HISTORY_OPERATION_TYPE_UNSPECIFIED:
            return "CONTRACT_CODE_HISTORY_OPERATION_TYPE_UNSPECIFIED";
        case $7fcfeae3898d0f34$var$ContractCodeHistoryOperationType.CONTRACT_CODE_HISTORY_OPERATION_TYPE_INIT:
            return "CONTRACT_CODE_HISTORY_OPERATION_TYPE_INIT";
        case $7fcfeae3898d0f34$var$ContractCodeHistoryOperationType.CONTRACT_CODE_HISTORY_OPERATION_TYPE_MIGRATE:
            return "CONTRACT_CODE_HISTORY_OPERATION_TYPE_MIGRATE";
        case $7fcfeae3898d0f34$var$ContractCodeHistoryOperationType.CONTRACT_CODE_HISTORY_OPERATION_TYPE_GENESIS:
            return "CONTRACT_CODE_HISTORY_OPERATION_TYPE_GENESIS";
        case $7fcfeae3898d0f34$var$ContractCodeHistoryOperationType.UNRECOGNIZED:
        default:
            return "UNRECOGNIZED";
    }
}
$7fcfeae3898d0f34$exports.contractCodeHistoryOperationTypeToJSON = $7fcfeae3898d0f34$var$contractCodeHistoryOperationTypeToJSON;
function $7fcfeae3898d0f34$var$createBaseAccessTypeParam() {
    return {
        value: 0
    };
}
$7fcfeae3898d0f34$exports.AccessTypeParam = {
    encode (message, writer = $7fcfeae3898d0f34$var$minimal_1.default.Writer.create()) {
        if (message.value !== 0) writer.uint32(8).int32(message.value);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $7fcfeae3898d0f34$var$minimal_1.default.Reader ? input : new $7fcfeae3898d0f34$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $7fcfeae3898d0f34$var$createBaseAccessTypeParam();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.value = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            value: $7fcfeae3898d0f34$var$isSet(object.value) ? $7fcfeae3898d0f34$var$accessTypeFromJSON(object.value) : 0
        };
    },
    toJSON (message) {
        const obj = {};
        message.value !== undefined && (obj.value = $7fcfeae3898d0f34$var$accessTypeToJSON(message.value));
        return obj;
    },
    fromPartial (object) {
        var _a;
        const message = $7fcfeae3898d0f34$var$createBaseAccessTypeParam();
        message.value = (_a = object.value) !== null && _a !== void 0 ? _a : 0;
        return message;
    }
};
function $7fcfeae3898d0f34$var$createBaseAccessConfig() {
    return {
        permission: 0,
        address: ""
    };
}
$7fcfeae3898d0f34$exports.AccessConfig = {
    encode (message, writer = $7fcfeae3898d0f34$var$minimal_1.default.Writer.create()) {
        if (message.permission !== 0) writer.uint32(8).int32(message.permission);
        if (message.address !== "") writer.uint32(18).string(message.address);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $7fcfeae3898d0f34$var$minimal_1.default.Reader ? input : new $7fcfeae3898d0f34$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $7fcfeae3898d0f34$var$createBaseAccessConfig();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.permission = reader.int32();
                    break;
                case 2:
                    message.address = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            permission: $7fcfeae3898d0f34$var$isSet(object.permission) ? $7fcfeae3898d0f34$var$accessTypeFromJSON(object.permission) : 0,
            address: $7fcfeae3898d0f34$var$isSet(object.address) ? String(object.address) : ""
        };
    },
    toJSON (message) {
        const obj = {};
        message.permission !== undefined && (obj.permission = $7fcfeae3898d0f34$var$accessTypeToJSON(message.permission));
        message.address !== undefined && (obj.address = message.address);
        return obj;
    },
    fromPartial (object) {
        var _a, _b;
        const message = $7fcfeae3898d0f34$var$createBaseAccessConfig();
        message.permission = (_a = object.permission) !== null && _a !== void 0 ? _a : 0;
        message.address = (_b = object.address) !== null && _b !== void 0 ? _b : "";
        return message;
    }
};
function $7fcfeae3898d0f34$var$createBaseParams() {
    return {
        codeUploadAccess: undefined,
        instantiateDefaultPermission: 0
    };
}
$7fcfeae3898d0f34$exports.Params = {
    encode (message, writer = $7fcfeae3898d0f34$var$minimal_1.default.Writer.create()) {
        if (message.codeUploadAccess !== undefined) $7fcfeae3898d0f34$exports.AccessConfig.encode(message.codeUploadAccess, writer.uint32(10).fork()).ldelim();
        if (message.instantiateDefaultPermission !== 0) writer.uint32(16).int32(message.instantiateDefaultPermission);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $7fcfeae3898d0f34$var$minimal_1.default.Reader ? input : new $7fcfeae3898d0f34$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $7fcfeae3898d0f34$var$createBaseParams();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.codeUploadAccess = $7fcfeae3898d0f34$exports.AccessConfig.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.instantiateDefaultPermission = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            codeUploadAccess: $7fcfeae3898d0f34$var$isSet(object.codeUploadAccess) ? $7fcfeae3898d0f34$exports.AccessConfig.fromJSON(object.codeUploadAccess) : undefined,
            instantiateDefaultPermission: $7fcfeae3898d0f34$var$isSet(object.instantiateDefaultPermission) ? $7fcfeae3898d0f34$var$accessTypeFromJSON(object.instantiateDefaultPermission) : 0
        };
    },
    toJSON (message) {
        const obj = {};
        message.codeUploadAccess !== undefined && (obj.codeUploadAccess = message.codeUploadAccess ? $7fcfeae3898d0f34$exports.AccessConfig.toJSON(message.codeUploadAccess) : undefined);
        message.instantiateDefaultPermission !== undefined && (obj.instantiateDefaultPermission = $7fcfeae3898d0f34$var$accessTypeToJSON(message.instantiateDefaultPermission));
        return obj;
    },
    fromPartial (object) {
        var _a;
        const message = $7fcfeae3898d0f34$var$createBaseParams();
        message.codeUploadAccess = object.codeUploadAccess !== undefined && object.codeUploadAccess !== null ? $7fcfeae3898d0f34$exports.AccessConfig.fromPartial(object.codeUploadAccess) : undefined;
        message.instantiateDefaultPermission = (_a = object.instantiateDefaultPermission) !== null && _a !== void 0 ? _a : 0;
        return message;
    }
};
function $7fcfeae3898d0f34$var$createBaseCodeInfo() {
    return {
        codeHash: new Uint8Array(),
        creator: "",
        instantiateConfig: undefined
    };
}
$7fcfeae3898d0f34$exports.CodeInfo = {
    encode (message, writer = $7fcfeae3898d0f34$var$minimal_1.default.Writer.create()) {
        if (message.codeHash.length !== 0) writer.uint32(10).bytes(message.codeHash);
        if (message.creator !== "") writer.uint32(18).string(message.creator);
        if (message.instantiateConfig !== undefined) $7fcfeae3898d0f34$exports.AccessConfig.encode(message.instantiateConfig, writer.uint32(42).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $7fcfeae3898d0f34$var$minimal_1.default.Reader ? input : new $7fcfeae3898d0f34$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $7fcfeae3898d0f34$var$createBaseCodeInfo();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.codeHash = reader.bytes();
                    break;
                case 2:
                    message.creator = reader.string();
                    break;
                case 5:
                    message.instantiateConfig = $7fcfeae3898d0f34$exports.AccessConfig.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            codeHash: $7fcfeae3898d0f34$var$isSet(object.codeHash) ? $7fcfeae3898d0f34$var$bytesFromBase64(object.codeHash) : new Uint8Array(),
            creator: $7fcfeae3898d0f34$var$isSet(object.creator) ? String(object.creator) : "",
            instantiateConfig: $7fcfeae3898d0f34$var$isSet(object.instantiateConfig) ? $7fcfeae3898d0f34$exports.AccessConfig.fromJSON(object.instantiateConfig) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.codeHash !== undefined && (obj.codeHash = $7fcfeae3898d0f34$var$base64FromBytes(message.codeHash !== undefined ? message.codeHash : new Uint8Array()));
        message.creator !== undefined && (obj.creator = message.creator);
        message.instantiateConfig !== undefined && (obj.instantiateConfig = message.instantiateConfig ? $7fcfeae3898d0f34$exports.AccessConfig.toJSON(message.instantiateConfig) : undefined);
        return obj;
    },
    fromPartial (object) {
        var _a, _b;
        const message = $7fcfeae3898d0f34$var$createBaseCodeInfo();
        message.codeHash = (_a = object.codeHash) !== null && _a !== void 0 ? _a : new Uint8Array();
        message.creator = (_b = object.creator) !== null && _b !== void 0 ? _b : "";
        message.instantiateConfig = object.instantiateConfig !== undefined && object.instantiateConfig !== null ? $7fcfeae3898d0f34$exports.AccessConfig.fromPartial(object.instantiateConfig) : undefined;
        return message;
    }
};
function $7fcfeae3898d0f34$var$createBaseContractInfo() {
    return {
        codeId: $7fcfeae3898d0f34$var$long_1.default.UZERO,
        creator: "",
        admin: "",
        label: "",
        created: undefined,
        ibcPortId: "",
        extension: undefined
    };
}
$7fcfeae3898d0f34$exports.ContractInfo = {
    encode (message, writer = $7fcfeae3898d0f34$var$minimal_1.default.Writer.create()) {
        if (!message.codeId.isZero()) writer.uint32(8).uint64(message.codeId);
        if (message.creator !== "") writer.uint32(18).string(message.creator);
        if (message.admin !== "") writer.uint32(26).string(message.admin);
        if (message.label !== "") writer.uint32(34).string(message.label);
        if (message.created !== undefined) $7fcfeae3898d0f34$exports.AbsoluteTxPosition.encode(message.created, writer.uint32(42).fork()).ldelim();
        if (message.ibcPortId !== "") writer.uint32(50).string(message.ibcPortId);
        if (message.extension !== undefined) $f68f58f1e7b3dfff$exports.Any.encode(message.extension, writer.uint32(58).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $7fcfeae3898d0f34$var$minimal_1.default.Reader ? input : new $7fcfeae3898d0f34$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $7fcfeae3898d0f34$var$createBaseContractInfo();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.codeId = reader.uint64();
                    break;
                case 2:
                    message.creator = reader.string();
                    break;
                case 3:
                    message.admin = reader.string();
                    break;
                case 4:
                    message.label = reader.string();
                    break;
                case 5:
                    message.created = $7fcfeae3898d0f34$exports.AbsoluteTxPosition.decode(reader, reader.uint32());
                    break;
                case 6:
                    message.ibcPortId = reader.string();
                    break;
                case 7:
                    message.extension = $f68f58f1e7b3dfff$exports.Any.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            codeId: $7fcfeae3898d0f34$var$isSet(object.codeId) ? $7fcfeae3898d0f34$var$long_1.default.fromValue(object.codeId) : $7fcfeae3898d0f34$var$long_1.default.UZERO,
            creator: $7fcfeae3898d0f34$var$isSet(object.creator) ? String(object.creator) : "",
            admin: $7fcfeae3898d0f34$var$isSet(object.admin) ? String(object.admin) : "",
            label: $7fcfeae3898d0f34$var$isSet(object.label) ? String(object.label) : "",
            created: $7fcfeae3898d0f34$var$isSet(object.created) ? $7fcfeae3898d0f34$exports.AbsoluteTxPosition.fromJSON(object.created) : undefined,
            ibcPortId: $7fcfeae3898d0f34$var$isSet(object.ibcPortId) ? String(object.ibcPortId) : "",
            extension: $7fcfeae3898d0f34$var$isSet(object.extension) ? $f68f58f1e7b3dfff$exports.Any.fromJSON(object.extension) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.codeId !== undefined && (obj.codeId = (message.codeId || $7fcfeae3898d0f34$var$long_1.default.UZERO).toString());
        message.creator !== undefined && (obj.creator = message.creator);
        message.admin !== undefined && (obj.admin = message.admin);
        message.label !== undefined && (obj.label = message.label);
        message.created !== undefined && (obj.created = message.created ? $7fcfeae3898d0f34$exports.AbsoluteTxPosition.toJSON(message.created) : undefined);
        message.ibcPortId !== undefined && (obj.ibcPortId = message.ibcPortId);
        message.extension !== undefined && (obj.extension = message.extension ? $f68f58f1e7b3dfff$exports.Any.toJSON(message.extension) : undefined);
        return obj;
    },
    fromPartial (object) {
        var _a, _b, _c, _d;
        const message = $7fcfeae3898d0f34$var$createBaseContractInfo();
        message.codeId = object.codeId !== undefined && object.codeId !== null ? $7fcfeae3898d0f34$var$long_1.default.fromValue(object.codeId) : $7fcfeae3898d0f34$var$long_1.default.UZERO;
        message.creator = (_a = object.creator) !== null && _a !== void 0 ? _a : "";
        message.admin = (_b = object.admin) !== null && _b !== void 0 ? _b : "";
        message.label = (_c = object.label) !== null && _c !== void 0 ? _c : "";
        message.created = object.created !== undefined && object.created !== null ? $7fcfeae3898d0f34$exports.AbsoluteTxPosition.fromPartial(object.created) : undefined;
        message.ibcPortId = (_d = object.ibcPortId) !== null && _d !== void 0 ? _d : "";
        message.extension = object.extension !== undefined && object.extension !== null ? $f68f58f1e7b3dfff$exports.Any.fromPartial(object.extension) : undefined;
        return message;
    }
};
function $7fcfeae3898d0f34$var$createBaseContractCodeHistoryEntry() {
    return {
        operation: 0,
        codeId: $7fcfeae3898d0f34$var$long_1.default.UZERO,
        updated: undefined,
        msg: new Uint8Array()
    };
}
$7fcfeae3898d0f34$exports.ContractCodeHistoryEntry = {
    encode (message, writer = $7fcfeae3898d0f34$var$minimal_1.default.Writer.create()) {
        if (message.operation !== 0) writer.uint32(8).int32(message.operation);
        if (!message.codeId.isZero()) writer.uint32(16).uint64(message.codeId);
        if (message.updated !== undefined) $7fcfeae3898d0f34$exports.AbsoluteTxPosition.encode(message.updated, writer.uint32(26).fork()).ldelim();
        if (message.msg.length !== 0) writer.uint32(34).bytes(message.msg);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $7fcfeae3898d0f34$var$minimal_1.default.Reader ? input : new $7fcfeae3898d0f34$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $7fcfeae3898d0f34$var$createBaseContractCodeHistoryEntry();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.operation = reader.int32();
                    break;
                case 2:
                    message.codeId = reader.uint64();
                    break;
                case 3:
                    message.updated = $7fcfeae3898d0f34$exports.AbsoluteTxPosition.decode(reader, reader.uint32());
                    break;
                case 4:
                    message.msg = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            operation: $7fcfeae3898d0f34$var$isSet(object.operation) ? $7fcfeae3898d0f34$var$contractCodeHistoryOperationTypeFromJSON(object.operation) : 0,
            codeId: $7fcfeae3898d0f34$var$isSet(object.codeId) ? $7fcfeae3898d0f34$var$long_1.default.fromValue(object.codeId) : $7fcfeae3898d0f34$var$long_1.default.UZERO,
            updated: $7fcfeae3898d0f34$var$isSet(object.updated) ? $7fcfeae3898d0f34$exports.AbsoluteTxPosition.fromJSON(object.updated) : undefined,
            msg: $7fcfeae3898d0f34$var$isSet(object.msg) ? $7fcfeae3898d0f34$var$bytesFromBase64(object.msg) : new Uint8Array()
        };
    },
    toJSON (message) {
        const obj = {};
        message.operation !== undefined && (obj.operation = $7fcfeae3898d0f34$var$contractCodeHistoryOperationTypeToJSON(message.operation));
        message.codeId !== undefined && (obj.codeId = (message.codeId || $7fcfeae3898d0f34$var$long_1.default.UZERO).toString());
        message.updated !== undefined && (obj.updated = message.updated ? $7fcfeae3898d0f34$exports.AbsoluteTxPosition.toJSON(message.updated) : undefined);
        message.msg !== undefined && (obj.msg = $7fcfeae3898d0f34$var$base64FromBytes(message.msg !== undefined ? message.msg : new Uint8Array()));
        return obj;
    },
    fromPartial (object) {
        var _a, _b;
        const message = $7fcfeae3898d0f34$var$createBaseContractCodeHistoryEntry();
        message.operation = (_a = object.operation) !== null && _a !== void 0 ? _a : 0;
        message.codeId = object.codeId !== undefined && object.codeId !== null ? $7fcfeae3898d0f34$var$long_1.default.fromValue(object.codeId) : $7fcfeae3898d0f34$var$long_1.default.UZERO;
        message.updated = object.updated !== undefined && object.updated !== null ? $7fcfeae3898d0f34$exports.AbsoluteTxPosition.fromPartial(object.updated) : undefined;
        message.msg = (_b = object.msg) !== null && _b !== void 0 ? _b : new Uint8Array();
        return message;
    }
};
function $7fcfeae3898d0f34$var$createBaseAbsoluteTxPosition() {
    return {
        blockHeight: $7fcfeae3898d0f34$var$long_1.default.UZERO,
        txIndex: $7fcfeae3898d0f34$var$long_1.default.UZERO
    };
}
$7fcfeae3898d0f34$exports.AbsoluteTxPosition = {
    encode (message, writer = $7fcfeae3898d0f34$var$minimal_1.default.Writer.create()) {
        if (!message.blockHeight.isZero()) writer.uint32(8).uint64(message.blockHeight);
        if (!message.txIndex.isZero()) writer.uint32(16).uint64(message.txIndex);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $7fcfeae3898d0f34$var$minimal_1.default.Reader ? input : new $7fcfeae3898d0f34$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $7fcfeae3898d0f34$var$createBaseAbsoluteTxPosition();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.blockHeight = reader.uint64();
                    break;
                case 2:
                    message.txIndex = reader.uint64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            blockHeight: $7fcfeae3898d0f34$var$isSet(object.blockHeight) ? $7fcfeae3898d0f34$var$long_1.default.fromValue(object.blockHeight) : $7fcfeae3898d0f34$var$long_1.default.UZERO,
            txIndex: $7fcfeae3898d0f34$var$isSet(object.txIndex) ? $7fcfeae3898d0f34$var$long_1.default.fromValue(object.txIndex) : $7fcfeae3898d0f34$var$long_1.default.UZERO
        };
    },
    toJSON (message) {
        const obj = {};
        message.blockHeight !== undefined && (obj.blockHeight = (message.blockHeight || $7fcfeae3898d0f34$var$long_1.default.UZERO).toString());
        message.txIndex !== undefined && (obj.txIndex = (message.txIndex || $7fcfeae3898d0f34$var$long_1.default.UZERO).toString());
        return obj;
    },
    fromPartial (object) {
        const message = $7fcfeae3898d0f34$var$createBaseAbsoluteTxPosition();
        message.blockHeight = object.blockHeight !== undefined && object.blockHeight !== null ? $7fcfeae3898d0f34$var$long_1.default.fromValue(object.blockHeight) : $7fcfeae3898d0f34$var$long_1.default.UZERO;
        message.txIndex = object.txIndex !== undefined && object.txIndex !== null ? $7fcfeae3898d0f34$var$long_1.default.fromValue(object.txIndex) : $7fcfeae3898d0f34$var$long_1.default.UZERO;
        return message;
    }
};
function $7fcfeae3898d0f34$var$createBaseModel() {
    return {
        key: new Uint8Array(),
        value: new Uint8Array()
    };
}
$7fcfeae3898d0f34$exports.Model = {
    encode (message, writer = $7fcfeae3898d0f34$var$minimal_1.default.Writer.create()) {
        if (message.key.length !== 0) writer.uint32(10).bytes(message.key);
        if (message.value.length !== 0) writer.uint32(18).bytes(message.value);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $7fcfeae3898d0f34$var$minimal_1.default.Reader ? input : new $7fcfeae3898d0f34$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $7fcfeae3898d0f34$var$createBaseModel();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.key = reader.bytes();
                    break;
                case 2:
                    message.value = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            key: $7fcfeae3898d0f34$var$isSet(object.key) ? $7fcfeae3898d0f34$var$bytesFromBase64(object.key) : new Uint8Array(),
            value: $7fcfeae3898d0f34$var$isSet(object.value) ? $7fcfeae3898d0f34$var$bytesFromBase64(object.value) : new Uint8Array()
        };
    },
    toJSON (message) {
        const obj = {};
        message.key !== undefined && (obj.key = $7fcfeae3898d0f34$var$base64FromBytes(message.key !== undefined ? message.key : new Uint8Array()));
        message.value !== undefined && (obj.value = $7fcfeae3898d0f34$var$base64FromBytes(message.value !== undefined ? message.value : new Uint8Array()));
        return obj;
    },
    fromPartial (object) {
        var _a, _b;
        const message = $7fcfeae3898d0f34$var$createBaseModel();
        message.key = (_a = object.key) !== null && _a !== void 0 ? _a : new Uint8Array();
        message.value = (_b = object.value) !== null && _b !== void 0 ? _b : new Uint8Array();
        return message;
    }
};
var $7fcfeae3898d0f34$var$globalThis = (()=>{
    if (typeof $7fcfeae3898d0f34$var$globalThis !== "undefined") return $7fcfeae3898d0f34$var$globalThis;
    if (typeof self !== "undefined") return self;
    if (typeof window !== "undefined") return window;
    if (typeof $parcel$global !== "undefined") return $parcel$global;
    throw "Unable to locate global object";
})();
function $7fcfeae3898d0f34$var$bytesFromBase64(b64) {
    if ($7fcfeae3898d0f34$var$globalThis.Buffer) return Uint8Array.from($7fcfeae3898d0f34$var$globalThis.Buffer.from(b64, "base64"));
    else {
        const bin = $7fcfeae3898d0f34$var$globalThis.atob(b64);
        const arr = new Uint8Array(bin.length);
        for(let i = 0; i < bin.length; ++i)arr[i] = bin.charCodeAt(i);
        return arr;
    }
}
function $7fcfeae3898d0f34$var$base64FromBytes(arr) {
    if ($7fcfeae3898d0f34$var$globalThis.Buffer) return $7fcfeae3898d0f34$var$globalThis.Buffer.from(arr).toString("base64");
    else {
        const bin = [];
        arr.forEach((byte)=>{
            bin.push(String.fromCharCode(byte));
        });
        return $7fcfeae3898d0f34$var$globalThis.btoa(bin.join(""));
    }
}
if ($7fcfeae3898d0f34$var$minimal_1.default.util.Long !== $7fcfeae3898d0f34$var$long_1.default) {
    $7fcfeae3898d0f34$var$minimal_1.default.util.Long = $7fcfeae3898d0f34$var$long_1.default;
    $7fcfeae3898d0f34$var$minimal_1.default.configure();
}
function $7fcfeae3898d0f34$var$isSet(value) {
    return value !== null && value !== undefined;
}


$5e79880e7465f438$exports.protobufPackage = "cosmwasm.wasm.v1";
function $5e79880e7465f438$var$createBaseMsgStoreCode() {
    return {
        sender: "",
        wasmByteCode: new Uint8Array(),
        instantiatePermission: undefined
    };
}
$5e79880e7465f438$exports.MsgStoreCode = {
    encode (message, writer = $5e79880e7465f438$var$minimal_1.default.Writer.create()) {
        if (message.sender !== "") writer.uint32(10).string(message.sender);
        if (message.wasmByteCode.length !== 0) writer.uint32(18).bytes(message.wasmByteCode);
        if (message.instantiatePermission !== undefined) $7fcfeae3898d0f34$exports.AccessConfig.encode(message.instantiatePermission, writer.uint32(42).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $5e79880e7465f438$var$minimal_1.default.Reader ? input : new $5e79880e7465f438$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $5e79880e7465f438$var$createBaseMsgStoreCode();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.sender = reader.string();
                    break;
                case 2:
                    message.wasmByteCode = reader.bytes();
                    break;
                case 5:
                    message.instantiatePermission = $7fcfeae3898d0f34$exports.AccessConfig.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            sender: $5e79880e7465f438$var$isSet(object.sender) ? String(object.sender) : "",
            wasmByteCode: $5e79880e7465f438$var$isSet(object.wasmByteCode) ? $5e79880e7465f438$var$bytesFromBase64(object.wasmByteCode) : new Uint8Array(),
            instantiatePermission: $5e79880e7465f438$var$isSet(object.instantiatePermission) ? $7fcfeae3898d0f34$exports.AccessConfig.fromJSON(object.instantiatePermission) : undefined
        };
    },
    toJSON (message) {
        const obj = {};
        message.sender !== undefined && (obj.sender = message.sender);
        message.wasmByteCode !== undefined && (obj.wasmByteCode = $5e79880e7465f438$var$base64FromBytes(message.wasmByteCode !== undefined ? message.wasmByteCode : new Uint8Array()));
        message.instantiatePermission !== undefined && (obj.instantiatePermission = message.instantiatePermission ? $7fcfeae3898d0f34$exports.AccessConfig.toJSON(message.instantiatePermission) : undefined);
        return obj;
    },
    fromPartial (object) {
        var _a, _b;
        const message = $5e79880e7465f438$var$createBaseMsgStoreCode();
        message.sender = (_a = object.sender) !== null && _a !== void 0 ? _a : "";
        message.wasmByteCode = (_b = object.wasmByteCode) !== null && _b !== void 0 ? _b : new Uint8Array();
        message.instantiatePermission = object.instantiatePermission !== undefined && object.instantiatePermission !== null ? $7fcfeae3898d0f34$exports.AccessConfig.fromPartial(object.instantiatePermission) : undefined;
        return message;
    }
};
function $5e79880e7465f438$var$createBaseMsgStoreCodeResponse() {
    return {
        codeId: $5e79880e7465f438$var$long_1.default.UZERO
    };
}
$5e79880e7465f438$exports.MsgStoreCodeResponse = {
    encode (message, writer = $5e79880e7465f438$var$minimal_1.default.Writer.create()) {
        if (!message.codeId.isZero()) writer.uint32(8).uint64(message.codeId);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $5e79880e7465f438$var$minimal_1.default.Reader ? input : new $5e79880e7465f438$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $5e79880e7465f438$var$createBaseMsgStoreCodeResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.codeId = reader.uint64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            codeId: $5e79880e7465f438$var$isSet(object.codeId) ? $5e79880e7465f438$var$long_1.default.fromValue(object.codeId) : $5e79880e7465f438$var$long_1.default.UZERO
        };
    },
    toJSON (message) {
        const obj = {};
        message.codeId !== undefined && (obj.codeId = (message.codeId || $5e79880e7465f438$var$long_1.default.UZERO).toString());
        return obj;
    },
    fromPartial (object) {
        const message = $5e79880e7465f438$var$createBaseMsgStoreCodeResponse();
        message.codeId = object.codeId !== undefined && object.codeId !== null ? $5e79880e7465f438$var$long_1.default.fromValue(object.codeId) : $5e79880e7465f438$var$long_1.default.UZERO;
        return message;
    }
};
function $5e79880e7465f438$var$createBaseMsgInstantiateContract() {
    return {
        sender: "",
        admin: "",
        codeId: $5e79880e7465f438$var$long_1.default.UZERO,
        label: "",
        msg: new Uint8Array(),
        funds: []
    };
}
$5e79880e7465f438$exports.MsgInstantiateContract = {
    encode (message, writer = $5e79880e7465f438$var$minimal_1.default.Writer.create()) {
        if (message.sender !== "") writer.uint32(10).string(message.sender);
        if (message.admin !== "") writer.uint32(18).string(message.admin);
        if (!message.codeId.isZero()) writer.uint32(24).uint64(message.codeId);
        if (message.label !== "") writer.uint32(34).string(message.label);
        if (message.msg.length !== 0) writer.uint32(42).bytes(message.msg);
        for (const v of message.funds)$556c463580a8e5c3$exports.Coin.encode(v, writer.uint32(50).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $5e79880e7465f438$var$minimal_1.default.Reader ? input : new $5e79880e7465f438$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $5e79880e7465f438$var$createBaseMsgInstantiateContract();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.sender = reader.string();
                    break;
                case 2:
                    message.admin = reader.string();
                    break;
                case 3:
                    message.codeId = reader.uint64();
                    break;
                case 4:
                    message.label = reader.string();
                    break;
                case 5:
                    message.msg = reader.bytes();
                    break;
                case 6:
                    message.funds.push($556c463580a8e5c3$exports.Coin.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            sender: $5e79880e7465f438$var$isSet(object.sender) ? String(object.sender) : "",
            admin: $5e79880e7465f438$var$isSet(object.admin) ? String(object.admin) : "",
            codeId: $5e79880e7465f438$var$isSet(object.codeId) ? $5e79880e7465f438$var$long_1.default.fromValue(object.codeId) : $5e79880e7465f438$var$long_1.default.UZERO,
            label: $5e79880e7465f438$var$isSet(object.label) ? String(object.label) : "",
            msg: $5e79880e7465f438$var$isSet(object.msg) ? $5e79880e7465f438$var$bytesFromBase64(object.msg) : new Uint8Array(),
            funds: Array.isArray(object === null || object === void 0 ? void 0 : object.funds) ? object.funds.map((e)=>$556c463580a8e5c3$exports.Coin.fromJSON(e)) : []
        };
    },
    toJSON (message) {
        const obj = {};
        message.sender !== undefined && (obj.sender = message.sender);
        message.admin !== undefined && (obj.admin = message.admin);
        message.codeId !== undefined && (obj.codeId = (message.codeId || $5e79880e7465f438$var$long_1.default.UZERO).toString());
        message.label !== undefined && (obj.label = message.label);
        message.msg !== undefined && (obj.msg = $5e79880e7465f438$var$base64FromBytes(message.msg !== undefined ? message.msg : new Uint8Array()));
        if (message.funds) obj.funds = message.funds.map((e)=>e ? $556c463580a8e5c3$exports.Coin.toJSON(e) : undefined);
        else obj.funds = [];
        return obj;
    },
    fromPartial (object) {
        var _a, _b, _c, _d, _e;
        const message = $5e79880e7465f438$var$createBaseMsgInstantiateContract();
        message.sender = (_a = object.sender) !== null && _a !== void 0 ? _a : "";
        message.admin = (_b = object.admin) !== null && _b !== void 0 ? _b : "";
        message.codeId = object.codeId !== undefined && object.codeId !== null ? $5e79880e7465f438$var$long_1.default.fromValue(object.codeId) : $5e79880e7465f438$var$long_1.default.UZERO;
        message.label = (_c = object.label) !== null && _c !== void 0 ? _c : "";
        message.msg = (_d = object.msg) !== null && _d !== void 0 ? _d : new Uint8Array();
        message.funds = ((_e = object.funds) === null || _e === void 0 ? void 0 : _e.map((e)=>$556c463580a8e5c3$exports.Coin.fromPartial(e))) || [];
        return message;
    }
};
function $5e79880e7465f438$var$createBaseMsgInstantiateContractResponse() {
    return {
        address: "",
        data: new Uint8Array()
    };
}
$5e79880e7465f438$exports.MsgInstantiateContractResponse = {
    encode (message, writer = $5e79880e7465f438$var$minimal_1.default.Writer.create()) {
        if (message.address !== "") writer.uint32(10).string(message.address);
        if (message.data.length !== 0) writer.uint32(18).bytes(message.data);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $5e79880e7465f438$var$minimal_1.default.Reader ? input : new $5e79880e7465f438$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $5e79880e7465f438$var$createBaseMsgInstantiateContractResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.address = reader.string();
                    break;
                case 2:
                    message.data = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            address: $5e79880e7465f438$var$isSet(object.address) ? String(object.address) : "",
            data: $5e79880e7465f438$var$isSet(object.data) ? $5e79880e7465f438$var$bytesFromBase64(object.data) : new Uint8Array()
        };
    },
    toJSON (message) {
        const obj = {};
        message.address !== undefined && (obj.address = message.address);
        message.data !== undefined && (obj.data = $5e79880e7465f438$var$base64FromBytes(message.data !== undefined ? message.data : new Uint8Array()));
        return obj;
    },
    fromPartial (object) {
        var _a, _b;
        const message = $5e79880e7465f438$var$createBaseMsgInstantiateContractResponse();
        message.address = (_a = object.address) !== null && _a !== void 0 ? _a : "";
        message.data = (_b = object.data) !== null && _b !== void 0 ? _b : new Uint8Array();
        return message;
    }
};
function $5e79880e7465f438$var$createBaseMsgExecuteContract() {
    return {
        sender: "",
        contract: "",
        msg: new Uint8Array(),
        funds: []
    };
}
$5e79880e7465f438$exports.MsgExecuteContract = {
    encode (message, writer = $5e79880e7465f438$var$minimal_1.default.Writer.create()) {
        if (message.sender !== "") writer.uint32(10).string(message.sender);
        if (message.contract !== "") writer.uint32(18).string(message.contract);
        if (message.msg.length !== 0) writer.uint32(26).bytes(message.msg);
        for (const v of message.funds)$556c463580a8e5c3$exports.Coin.encode(v, writer.uint32(42).fork()).ldelim();
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $5e79880e7465f438$var$minimal_1.default.Reader ? input : new $5e79880e7465f438$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $5e79880e7465f438$var$createBaseMsgExecuteContract();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.sender = reader.string();
                    break;
                case 2:
                    message.contract = reader.string();
                    break;
                case 3:
                    message.msg = reader.bytes();
                    break;
                case 5:
                    message.funds.push($556c463580a8e5c3$exports.Coin.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            sender: $5e79880e7465f438$var$isSet(object.sender) ? String(object.sender) : "",
            contract: $5e79880e7465f438$var$isSet(object.contract) ? String(object.contract) : "",
            msg: $5e79880e7465f438$var$isSet(object.msg) ? $5e79880e7465f438$var$bytesFromBase64(object.msg) : new Uint8Array(),
            funds: Array.isArray(object === null || object === void 0 ? void 0 : object.funds) ? object.funds.map((e)=>$556c463580a8e5c3$exports.Coin.fromJSON(e)) : []
        };
    },
    toJSON (message) {
        const obj = {};
        message.sender !== undefined && (obj.sender = message.sender);
        message.contract !== undefined && (obj.contract = message.contract);
        message.msg !== undefined && (obj.msg = $5e79880e7465f438$var$base64FromBytes(message.msg !== undefined ? message.msg : new Uint8Array()));
        if (message.funds) obj.funds = message.funds.map((e)=>e ? $556c463580a8e5c3$exports.Coin.toJSON(e) : undefined);
        else obj.funds = [];
        return obj;
    },
    fromPartial (object) {
        var _a, _b, _c, _d;
        const message = $5e79880e7465f438$var$createBaseMsgExecuteContract();
        message.sender = (_a = object.sender) !== null && _a !== void 0 ? _a : "";
        message.contract = (_b = object.contract) !== null && _b !== void 0 ? _b : "";
        message.msg = (_c = object.msg) !== null && _c !== void 0 ? _c : new Uint8Array();
        message.funds = ((_d = object.funds) === null || _d === void 0 ? void 0 : _d.map((e)=>$556c463580a8e5c3$exports.Coin.fromPartial(e))) || [];
        return message;
    }
};
function $5e79880e7465f438$var$createBaseMsgExecuteContractResponse() {
    return {
        data: new Uint8Array()
    };
}
$5e79880e7465f438$exports.MsgExecuteContractResponse = {
    encode (message, writer = $5e79880e7465f438$var$minimal_1.default.Writer.create()) {
        if (message.data.length !== 0) writer.uint32(10).bytes(message.data);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $5e79880e7465f438$var$minimal_1.default.Reader ? input : new $5e79880e7465f438$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $5e79880e7465f438$var$createBaseMsgExecuteContractResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.data = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            data: $5e79880e7465f438$var$isSet(object.data) ? $5e79880e7465f438$var$bytesFromBase64(object.data) : new Uint8Array()
        };
    },
    toJSON (message) {
        const obj = {};
        message.data !== undefined && (obj.data = $5e79880e7465f438$var$base64FromBytes(message.data !== undefined ? message.data : new Uint8Array()));
        return obj;
    },
    fromPartial (object) {
        var _a;
        const message = $5e79880e7465f438$var$createBaseMsgExecuteContractResponse();
        message.data = (_a = object.data) !== null && _a !== void 0 ? _a : new Uint8Array();
        return message;
    }
};
function $5e79880e7465f438$var$createBaseMsgMigrateContract() {
    return {
        sender: "",
        contract: "",
        codeId: $5e79880e7465f438$var$long_1.default.UZERO,
        msg: new Uint8Array()
    };
}
$5e79880e7465f438$exports.MsgMigrateContract = {
    encode (message, writer = $5e79880e7465f438$var$minimal_1.default.Writer.create()) {
        if (message.sender !== "") writer.uint32(10).string(message.sender);
        if (message.contract !== "") writer.uint32(18).string(message.contract);
        if (!message.codeId.isZero()) writer.uint32(24).uint64(message.codeId);
        if (message.msg.length !== 0) writer.uint32(34).bytes(message.msg);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $5e79880e7465f438$var$minimal_1.default.Reader ? input : new $5e79880e7465f438$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $5e79880e7465f438$var$createBaseMsgMigrateContract();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.sender = reader.string();
                    break;
                case 2:
                    message.contract = reader.string();
                    break;
                case 3:
                    message.codeId = reader.uint64();
                    break;
                case 4:
                    message.msg = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            sender: $5e79880e7465f438$var$isSet(object.sender) ? String(object.sender) : "",
            contract: $5e79880e7465f438$var$isSet(object.contract) ? String(object.contract) : "",
            codeId: $5e79880e7465f438$var$isSet(object.codeId) ? $5e79880e7465f438$var$long_1.default.fromValue(object.codeId) : $5e79880e7465f438$var$long_1.default.UZERO,
            msg: $5e79880e7465f438$var$isSet(object.msg) ? $5e79880e7465f438$var$bytesFromBase64(object.msg) : new Uint8Array()
        };
    },
    toJSON (message) {
        const obj = {};
        message.sender !== undefined && (obj.sender = message.sender);
        message.contract !== undefined && (obj.contract = message.contract);
        message.codeId !== undefined && (obj.codeId = (message.codeId || $5e79880e7465f438$var$long_1.default.UZERO).toString());
        message.msg !== undefined && (obj.msg = $5e79880e7465f438$var$base64FromBytes(message.msg !== undefined ? message.msg : new Uint8Array()));
        return obj;
    },
    fromPartial (object) {
        var _a, _b, _c;
        const message = $5e79880e7465f438$var$createBaseMsgMigrateContract();
        message.sender = (_a = object.sender) !== null && _a !== void 0 ? _a : "";
        message.contract = (_b = object.contract) !== null && _b !== void 0 ? _b : "";
        message.codeId = object.codeId !== undefined && object.codeId !== null ? $5e79880e7465f438$var$long_1.default.fromValue(object.codeId) : $5e79880e7465f438$var$long_1.default.UZERO;
        message.msg = (_c = object.msg) !== null && _c !== void 0 ? _c : new Uint8Array();
        return message;
    }
};
function $5e79880e7465f438$var$createBaseMsgMigrateContractResponse() {
    return {
        data: new Uint8Array()
    };
}
$5e79880e7465f438$exports.MsgMigrateContractResponse = {
    encode (message, writer = $5e79880e7465f438$var$minimal_1.default.Writer.create()) {
        if (message.data.length !== 0) writer.uint32(10).bytes(message.data);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $5e79880e7465f438$var$minimal_1.default.Reader ? input : new $5e79880e7465f438$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $5e79880e7465f438$var$createBaseMsgMigrateContractResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.data = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            data: $5e79880e7465f438$var$isSet(object.data) ? $5e79880e7465f438$var$bytesFromBase64(object.data) : new Uint8Array()
        };
    },
    toJSON (message) {
        const obj = {};
        message.data !== undefined && (obj.data = $5e79880e7465f438$var$base64FromBytes(message.data !== undefined ? message.data : new Uint8Array()));
        return obj;
    },
    fromPartial (object) {
        var _a;
        const message = $5e79880e7465f438$var$createBaseMsgMigrateContractResponse();
        message.data = (_a = object.data) !== null && _a !== void 0 ? _a : new Uint8Array();
        return message;
    }
};
function $5e79880e7465f438$var$createBaseMsgUpdateAdmin() {
    return {
        sender: "",
        newAdmin: "",
        contract: ""
    };
}
$5e79880e7465f438$exports.MsgUpdateAdmin = {
    encode (message, writer = $5e79880e7465f438$var$minimal_1.default.Writer.create()) {
        if (message.sender !== "") writer.uint32(10).string(message.sender);
        if (message.newAdmin !== "") writer.uint32(18).string(message.newAdmin);
        if (message.contract !== "") writer.uint32(26).string(message.contract);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $5e79880e7465f438$var$minimal_1.default.Reader ? input : new $5e79880e7465f438$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $5e79880e7465f438$var$createBaseMsgUpdateAdmin();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.sender = reader.string();
                    break;
                case 2:
                    message.newAdmin = reader.string();
                    break;
                case 3:
                    message.contract = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            sender: $5e79880e7465f438$var$isSet(object.sender) ? String(object.sender) : "",
            newAdmin: $5e79880e7465f438$var$isSet(object.newAdmin) ? String(object.newAdmin) : "",
            contract: $5e79880e7465f438$var$isSet(object.contract) ? String(object.contract) : ""
        };
    },
    toJSON (message) {
        const obj = {};
        message.sender !== undefined && (obj.sender = message.sender);
        message.newAdmin !== undefined && (obj.newAdmin = message.newAdmin);
        message.contract !== undefined && (obj.contract = message.contract);
        return obj;
    },
    fromPartial (object) {
        var _a, _b, _c;
        const message = $5e79880e7465f438$var$createBaseMsgUpdateAdmin();
        message.sender = (_a = object.sender) !== null && _a !== void 0 ? _a : "";
        message.newAdmin = (_b = object.newAdmin) !== null && _b !== void 0 ? _b : "";
        message.contract = (_c = object.contract) !== null && _c !== void 0 ? _c : "";
        return message;
    }
};
function $5e79880e7465f438$var$createBaseMsgUpdateAdminResponse() {
    return {};
}
$5e79880e7465f438$exports.MsgUpdateAdminResponse = {
    encode (_, writer = $5e79880e7465f438$var$minimal_1.default.Writer.create()) {
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $5e79880e7465f438$var$minimal_1.default.Reader ? input : new $5e79880e7465f438$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $5e79880e7465f438$var$createBaseMsgUpdateAdminResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            tag;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON (_) {
        return {};
    },
    toJSON (_) {
        const obj = {};
        return obj;
    },
    fromPartial (_) {
        const message = $5e79880e7465f438$var$createBaseMsgUpdateAdminResponse();
        return message;
    }
};
function $5e79880e7465f438$var$createBaseMsgClearAdmin() {
    return {
        sender: "",
        contract: ""
    };
}
$5e79880e7465f438$exports.MsgClearAdmin = {
    encode (message, writer = $5e79880e7465f438$var$minimal_1.default.Writer.create()) {
        if (message.sender !== "") writer.uint32(10).string(message.sender);
        if (message.contract !== "") writer.uint32(26).string(message.contract);
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $5e79880e7465f438$var$minimal_1.default.Reader ? input : new $5e79880e7465f438$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $5e79880e7465f438$var$createBaseMsgClearAdmin();
        while(reader.pos < end){
            const tag = reader.uint32();
            switch(tag >>> 3){
                case 1:
                    message.sender = reader.string();
                    break;
                case 3:
                    message.contract = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON (object) {
        return {
            sender: $5e79880e7465f438$var$isSet(object.sender) ? String(object.sender) : "",
            contract: $5e79880e7465f438$var$isSet(object.contract) ? String(object.contract) : ""
        };
    },
    toJSON (message) {
        const obj = {};
        message.sender !== undefined && (obj.sender = message.sender);
        message.contract !== undefined && (obj.contract = message.contract);
        return obj;
    },
    fromPartial (object) {
        var _a, _b;
        const message = $5e79880e7465f438$var$createBaseMsgClearAdmin();
        message.sender = (_a = object.sender) !== null && _a !== void 0 ? _a : "";
        message.contract = (_b = object.contract) !== null && _b !== void 0 ? _b : "";
        return message;
    }
};
function $5e79880e7465f438$var$createBaseMsgClearAdminResponse() {
    return {};
}
$5e79880e7465f438$exports.MsgClearAdminResponse = {
    encode (_, writer = $5e79880e7465f438$var$minimal_1.default.Writer.create()) {
        return writer;
    },
    decode (input, length) {
        const reader = input instanceof $5e79880e7465f438$var$minimal_1.default.Reader ? input : new $5e79880e7465f438$var$minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = $5e79880e7465f438$var$createBaseMsgClearAdminResponse();
        while(reader.pos < end){
            const tag = reader.uint32();
            tag;
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON (_) {
        return {};
    },
    toJSON (_) {
        const obj = {};
        return obj;
    },
    fromPartial (_) {
        const message = $5e79880e7465f438$var$createBaseMsgClearAdminResponse();
        return message;
    }
};
class $5e79880e7465f438$var$MsgClientImpl {
    constructor(rpc){
        this.rpc = rpc;
        this.StoreCode = this.StoreCode.bind(this);
        this.InstantiateContract = this.InstantiateContract.bind(this);
        this.ExecuteContract = this.ExecuteContract.bind(this);
        this.MigrateContract = this.MigrateContract.bind(this);
        this.UpdateAdmin = this.UpdateAdmin.bind(this);
        this.ClearAdmin = this.ClearAdmin.bind(this);
    }
    StoreCode(request) {
        const data = $5e79880e7465f438$exports.MsgStoreCode.encode(request).finish();
        const promise = this.rpc.request("cosmwasm.wasm.v1.Msg", "StoreCode", data);
        return promise.then((data)=>$5e79880e7465f438$exports.MsgStoreCodeResponse.decode(new $5e79880e7465f438$var$minimal_1.default.Reader(data)));
    }
    InstantiateContract(request) {
        const data = $5e79880e7465f438$exports.MsgInstantiateContract.encode(request).finish();
        const promise = this.rpc.request("cosmwasm.wasm.v1.Msg", "InstantiateContract", data);
        return promise.then((data)=>$5e79880e7465f438$exports.MsgInstantiateContractResponse.decode(new $5e79880e7465f438$var$minimal_1.default.Reader(data)));
    }
    ExecuteContract(request) {
        const data = $5e79880e7465f438$exports.MsgExecuteContract.encode(request).finish();
        const promise = this.rpc.request("cosmwasm.wasm.v1.Msg", "ExecuteContract", data);
        return promise.then((data)=>$5e79880e7465f438$exports.MsgExecuteContractResponse.decode(new $5e79880e7465f438$var$minimal_1.default.Reader(data)));
    }
    MigrateContract(request) {
        const data = $5e79880e7465f438$exports.MsgMigrateContract.encode(request).finish();
        const promise = this.rpc.request("cosmwasm.wasm.v1.Msg", "MigrateContract", data);
        return promise.then((data)=>$5e79880e7465f438$exports.MsgMigrateContractResponse.decode(new $5e79880e7465f438$var$minimal_1.default.Reader(data)));
    }
    UpdateAdmin(request) {
        const data = $5e79880e7465f438$exports.MsgUpdateAdmin.encode(request).finish();
        const promise = this.rpc.request("cosmwasm.wasm.v1.Msg", "UpdateAdmin", data);
        return promise.then((data)=>$5e79880e7465f438$exports.MsgUpdateAdminResponse.decode(new $5e79880e7465f438$var$minimal_1.default.Reader(data)));
    }
    ClearAdmin(request) {
        const data = $5e79880e7465f438$exports.MsgClearAdmin.encode(request).finish();
        const promise = this.rpc.request("cosmwasm.wasm.v1.Msg", "ClearAdmin", data);
        return promise.then((data)=>$5e79880e7465f438$exports.MsgClearAdminResponse.decode(new $5e79880e7465f438$var$minimal_1.default.Reader(data)));
    }
}
$5e79880e7465f438$exports.MsgClientImpl = $5e79880e7465f438$var$MsgClientImpl;
var $5e79880e7465f438$var$globalThis = (()=>{
    if (typeof $5e79880e7465f438$var$globalThis !== "undefined") return $5e79880e7465f438$var$globalThis;
    if (typeof self !== "undefined") return self;
    if (typeof window !== "undefined") return window;
    if (typeof $parcel$global !== "undefined") return $parcel$global;
    throw "Unable to locate global object";
})();
function $5e79880e7465f438$var$bytesFromBase64(b64) {
    if ($5e79880e7465f438$var$globalThis.Buffer) return Uint8Array.from($5e79880e7465f438$var$globalThis.Buffer.from(b64, "base64"));
    else {
        const bin = $5e79880e7465f438$var$globalThis.atob(b64);
        const arr = new Uint8Array(bin.length);
        for(let i = 0; i < bin.length; ++i)arr[i] = bin.charCodeAt(i);
        return arr;
    }
}
function $5e79880e7465f438$var$base64FromBytes(arr) {
    if ($5e79880e7465f438$var$globalThis.Buffer) return $5e79880e7465f438$var$globalThis.Buffer.from(arr).toString("base64");
    else {
        const bin = [];
        arr.forEach((byte)=>{
            bin.push(String.fromCharCode(byte));
        });
        return $5e79880e7465f438$var$globalThis.btoa(bin.join(""));
    }
}
if ($5e79880e7465f438$var$minimal_1.default.util.Long !== $5e79880e7465f438$var$long_1.default) {
    $5e79880e7465f438$var$minimal_1.default.util.Long = $5e79880e7465f438$var$long_1.default;
    $5e79880e7465f438$var$minimal_1.default.configure();
}
function $5e79880e7465f438$var$isSet(value) {
    return value !== null && value !== undefined;
}


var $b1dd3cab00755b37$exports = {};
// GENERATED FILE. DO NOT EDIT.
var $b1dd3cab00755b37$var$Long = function(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
        value: true
    });
    exports.default = void 0;
    /**
   * @license
   * Copyright 2009 The Closure Library Authors
   * Copyright 2020 Daniel Wirtz / The long.js Authors.
   *
   * Licensed under the Apache License, Version 2.0 (the "License");
   * you may not use this file except in compliance with the License.
   * You may obtain a copy of the License at
   *
   *     http://www.apache.org/licenses/LICENSE-2.0
   *
   * Unless required by applicable law or agreed to in writing, software
   * distributed under the License is distributed on an "AS IS" BASIS,
   * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
   * See the License for the specific language governing permissions and
   * limitations under the License.
   *
   * SPDX-License-Identifier: Apache-2.0
   */ // WebAssembly optimizations to do native i64 multiplication and divide
    var wasm = null;
    try {
        wasm = new WebAssembly.Instance(new WebAssembly.Module(new Uint8Array([
            0,
            97,
            115,
            109,
            1,
            0,
            0,
            0,
            1,
            13,
            2,
            96,
            0,
            1,
            127,
            96,
            4,
            127,
            127,
            127,
            127,
            1,
            127,
            3,
            7,
            6,
            0,
            1,
            1,
            1,
            1,
            1,
            6,
            6,
            1,
            127,
            1,
            65,
            0,
            11,
            7,
            50,
            6,
            3,
            109,
            117,
            108,
            0,
            1,
            5,
            100,
            105,
            118,
            95,
            115,
            0,
            2,
            5,
            100,
            105,
            118,
            95,
            117,
            0,
            3,
            5,
            114,
            101,
            109,
            95,
            115,
            0,
            4,
            5,
            114,
            101,
            109,
            95,
            117,
            0,
            5,
            8,
            103,
            101,
            116,
            95,
            104,
            105,
            103,
            104,
            0,
            0,
            10,
            191,
            1,
            6,
            4,
            0,
            35,
            0,
            11,
            36,
            1,
            1,
            126,
            32,
            0,
            173,
            32,
            1,
            173,
            66,
            32,
            134,
            132,
            32,
            2,
            173,
            32,
            3,
            173,
            66,
            32,
            134,
            132,
            126,
            34,
            4,
            66,
            32,
            135,
            167,
            36,
            0,
            32,
            4,
            167,
            11,
            36,
            1,
            1,
            126,
            32,
            0,
            173,
            32,
            1,
            173,
            66,
            32,
            134,
            132,
            32,
            2,
            173,
            32,
            3,
            173,
            66,
            32,
            134,
            132,
            127,
            34,
            4,
            66,
            32,
            135,
            167,
            36,
            0,
            32,
            4,
            167,
            11,
            36,
            1,
            1,
            126,
            32,
            0,
            173,
            32,
            1,
            173,
            66,
            32,
            134,
            132,
            32,
            2,
            173,
            32,
            3,
            173,
            66,
            32,
            134,
            132,
            128,
            34,
            4,
            66,
            32,
            135,
            167,
            36,
            0,
            32,
            4,
            167,
            11,
            36,
            1,
            1,
            126,
            32,
            0,
            173,
            32,
            1,
            173,
            66,
            32,
            134,
            132,
            32,
            2,
            173,
            32,
            3,
            173,
            66,
            32,
            134,
            132,
            129,
            34,
            4,
            66,
            32,
            135,
            167,
            36,
            0,
            32,
            4,
            167,
            11,
            36,
            1,
            1,
            126,
            32,
            0,
            173,
            32,
            1,
            173,
            66,
            32,
            134,
            132,
            32,
            2,
            173,
            32,
            3,
            173,
            66,
            32,
            134,
            132,
            130,
            34,
            4,
            66,
            32,
            135,
            167,
            36,
            0,
            32,
            4,
            167,
            11
        ])), {}).exports;
    } catch (e) {}
    /**
   * Constructs a 64 bit two's-complement integer, given its low and high 32 bit values as *signed* integers.
   *  See the from* functions below for more convenient ways of constructing Longs.
   * @exports Long
   * @class A Long class for representing a 64 bit two's-complement integer value.
   * @param {number} low The low (signed) 32 bits of the long
   * @param {number} high The high (signed) 32 bits of the long
   * @param {boolean=} unsigned Whether unsigned or not, defaults to signed
   * @constructor
   */ function Long(low, high, unsigned) {
        /**
     * The low 32 bits as a signed value.
     * @type {number}
     */ this.low = low | 0;
        /**
     * The high 32 bits as a signed value.
     * @type {number}
     */ this.high = high | 0;
        /**
     * Whether unsigned or not.
     * @type {boolean}
     */ this.unsigned = !!unsigned;
    } // The internal representation of a long is the two given signed, 32-bit values.
    // We use 32-bit pieces because these are the size of integers on which
    // Javascript performs bit-operations.  For operations like addition and
    // multiplication, we split each number into 16 bit pieces, which can easily be
    // multiplied within Javascript's floating-point representation without overflow
    // or change in sign.
    //
    // In the algorithms below, we frequently reduce the negative case to the
    // positive case by negating the input(s) and then post-processing the result.
    // Note that we must ALWAYS check specially whether those values are MIN_VALUE
    // (-2^63) because -MIN_VALUE == MIN_VALUE (since 2^63 cannot be represented as
    // a positive number, it overflows back into a negative).  Not handling this
    // case would often result in infinite recursion.
    //
    // Common constant values ZERO, ONE, NEG_ONE, etc. are defined below the from*
    // methods on which they depend.
    /**
   * An indicator used to reliably determine if an object is a Long or not.
   * @type {boolean}
   * @const
   * @private
   */ Long.prototype.__isLong__;
    Object.defineProperty(Long.prototype, "__isLong__", {
        value: true
    });
    /**
   * @function
   * @param {*} obj Object
   * @returns {boolean}
   * @inner
   */ function isLong(obj) {
        return (obj && obj["__isLong__"]) === true;
    }
    /**
   * @function
   * @param {*} value number
   * @returns {number}
   * @inner
   */ function ctz32(value) {
        var c = Math.clz32(value & -value);
        return value ? 31 - c : c;
    }
    /**
   * Tests if the specified object is a Long.
   * @function
   * @param {*} obj Object
   * @returns {boolean}
   */ Long.isLong = isLong;
    /**
   * A cache of the Long representations of small integer values.
   * @type {!Object}
   * @inner
   */ var INT_CACHE = {};
    /**
   * A cache of the Long representations of small unsigned integer values.
   * @type {!Object}
   * @inner
   */ var UINT_CACHE = {};
    /**
   * @param {number} value
   * @param {boolean=} unsigned
   * @returns {!Long}
   * @inner
   */ function fromInt(value, unsigned) {
        var obj, cachedObj, cache;
        if (unsigned) {
            value >>>= 0;
            if (cache = 0 <= value && value < 256) {
                cachedObj = UINT_CACHE[value];
                if (cachedObj) return cachedObj;
            }
            obj = fromBits(value, 0, true);
            if (cache) UINT_CACHE[value] = obj;
            return obj;
        } else {
            value |= 0;
            if (cache = -128 <= value && value < 128) {
                cachedObj = INT_CACHE[value];
                if (cachedObj) return cachedObj;
            }
            obj = fromBits(value, value < 0 ? -1 : 0, false);
            if (cache) INT_CACHE[value] = obj;
            return obj;
        }
    }
    /**
   * Returns a Long representing the given 32 bit integer value.
   * @function
   * @param {number} value The 32 bit integer in question
   * @param {boolean=} unsigned Whether unsigned or not, defaults to signed
   * @returns {!Long} The corresponding Long value
   */ Long.fromInt = fromInt;
    /**
   * @param {number} value
   * @param {boolean=} unsigned
   * @returns {!Long}
   * @inner
   */ function fromNumber(value, unsigned) {
        if (isNaN(value)) return unsigned ? UZERO : ZERO;
        if (unsigned) {
            if (value < 0) return UZERO;
            if (value >= TWO_PWR_64_DBL) return MAX_UNSIGNED_VALUE;
        } else {
            if (value <= -TWO_PWR_63_DBL) return MIN_VALUE;
            if (value + 1 >= TWO_PWR_63_DBL) return MAX_VALUE;
        }
        if (value < 0) return fromNumber(-value, unsigned).neg();
        return fromBits(value % TWO_PWR_32_DBL | 0, value / TWO_PWR_32_DBL | 0, unsigned);
    }
    /**
   * Returns a Long representing the given value, provided that it is a finite number. Otherwise, zero is returned.
   * @function
   * @param {number} value The number in question
   * @param {boolean=} unsigned Whether unsigned or not, defaults to signed
   * @returns {!Long} The corresponding Long value
   */ Long.fromNumber = fromNumber;
    /**
   * @param {number} lowBits
   * @param {number} highBits
   * @param {boolean=} unsigned
   * @returns {!Long}
   * @inner
   */ function fromBits(lowBits, highBits, unsigned) {
        return new Long(lowBits, highBits, unsigned);
    }
    /**
   * Returns a Long representing the 64 bit integer that comes by concatenating the given low and high bits. Each is
   *  assumed to use 32 bits.
   * @function
   * @param {number} lowBits The low 32 bits
   * @param {number} highBits The high 32 bits
   * @param {boolean=} unsigned Whether unsigned or not, defaults to signed
   * @returns {!Long} The corresponding Long value
   */ Long.fromBits = fromBits;
    /**
   * @function
   * @param {number} base
   * @param {number} exponent
   * @returns {number}
   * @inner
   */ var pow_dbl = Math.pow; // Used 4 times (4*8 to 15+4)
    /**
   * @param {string} str
   * @param {(boolean|number)=} unsigned
   * @param {number=} radix
   * @returns {!Long}
   * @inner
   */ function fromString(str, unsigned, radix) {
        if (str.length === 0) throw Error("empty string");
        if (typeof unsigned === "number") {
            // For goog.math.long compatibility
            radix = unsigned;
            unsigned = false;
        } else unsigned = !!unsigned;
        if (str === "NaN" || str === "Infinity" || str === "+Infinity" || str === "-Infinity") return unsigned ? UZERO : ZERO;
        radix = radix || 10;
        if (radix < 2 || 36 < radix) throw RangeError("radix");
        var p;
        if ((p = str.indexOf("-")) > 0) throw Error("interior hyphen");
        else if (p === 0) return fromString(str.substring(1), unsigned, radix).neg();
         // Do several (8) digits each time through the loop, so as to
        // minimize the calls to the very expensive emulated div.
        var radixToPower = fromNumber(pow_dbl(radix, 8));
        var result = ZERO;
        for(var i = 0; i < str.length; i += 8){
            var size = Math.min(8, str.length - i), value = parseInt(str.substring(i, i + size), radix);
            if (size < 8) {
                var power = fromNumber(pow_dbl(radix, size));
                result = result.mul(power).add(fromNumber(value));
            } else {
                result = result.mul(radixToPower);
                result = result.add(fromNumber(value));
            }
        }
        result.unsigned = unsigned;
        return result;
    }
    /**
   * Returns a Long representation of the given string, written using the specified radix.
   * @function
   * @param {string} str The textual representation of the Long
   * @param {(boolean|number)=} unsigned Whether unsigned or not, defaults to signed
   * @param {number=} radix The radix in which the text is written (2-36), defaults to 10
   * @returns {!Long} The corresponding Long value
   */ Long.fromString = fromString;
    /**
   * @function
   * @param {!Long|number|string|!{low: number, high: number, unsigned: boolean}} val
   * @param {boolean=} unsigned
   * @returns {!Long}
   * @inner
   */ function fromValue(val, unsigned) {
        if (typeof val === "number") return fromNumber(val, unsigned);
        if (typeof val === "string") return fromString(val, unsigned); // Throws for non-objects, converts non-instanceof Long:
        return fromBits(val.low, val.high, typeof unsigned === "boolean" ? unsigned : val.unsigned);
    }
    /**
   * Converts the specified value to a Long using the appropriate from* function for its type.
   * @function
   * @param {!Long|number|string|!{low: number, high: number, unsigned: boolean}} val Value
   * @param {boolean=} unsigned Whether unsigned or not, defaults to signed
   * @returns {!Long}
   */ Long.fromValue = fromValue; // NOTE: the compiler should inline these constant values below and then remove these variables, so there should be
    // no runtime penalty for these.
    /**
   * @type {number}
   * @const
   * @inner
   */ var TWO_PWR_16_DBL = 65536;
    /**
   * @type {number}
   * @const
   * @inner
   */ var TWO_PWR_24_DBL = 16777216;
    /**
   * @type {number}
   * @const
   * @inner
   */ var TWO_PWR_32_DBL = TWO_PWR_16_DBL * TWO_PWR_16_DBL;
    /**
   * @type {number}
   * @const
   * @inner
   */ var TWO_PWR_64_DBL = TWO_PWR_32_DBL * TWO_PWR_32_DBL;
    /**
   * @type {number}
   * @const
   * @inner
   */ var TWO_PWR_63_DBL = TWO_PWR_64_DBL / 2;
    /**
   * @type {!Long}
   * @const
   * @inner
   */ var TWO_PWR_24 = fromInt(TWO_PWR_24_DBL);
    /**
   * @type {!Long}
   * @inner
   */ var ZERO = fromInt(0);
    /**
   * Signed zero.
   * @type {!Long}
   */ Long.ZERO = ZERO;
    /**
   * @type {!Long}
   * @inner
   */ var UZERO = fromInt(0, true);
    /**
   * Unsigned zero.
   * @type {!Long}
   */ Long.UZERO = UZERO;
    /**
   * @type {!Long}
   * @inner
   */ var ONE = fromInt(1);
    /**
   * Signed one.
   * @type {!Long}
   */ Long.ONE = ONE;
    /**
   * @type {!Long}
   * @inner
   */ var UONE = fromInt(1, true);
    /**
   * Unsigned one.
   * @type {!Long}
   */ Long.UONE = UONE;
    /**
   * @type {!Long}
   * @inner
   */ var NEG_ONE = fromInt(-1);
    /**
   * Signed negative one.
   * @type {!Long}
   */ Long.NEG_ONE = NEG_ONE;
    /**
   * @type {!Long}
   * @inner
   */ var MAX_VALUE = fromBits(-1, 2147483647, false);
    /**
   * Maximum signed value.
   * @type {!Long}
   */ Long.MAX_VALUE = MAX_VALUE;
    /**
   * @type {!Long}
   * @inner
   */ var MAX_UNSIGNED_VALUE = fromBits(-1, -1, true);
    /**
   * Maximum unsigned value.
   * @type {!Long}
   */ Long.MAX_UNSIGNED_VALUE = MAX_UNSIGNED_VALUE;
    /**
   * @type {!Long}
   * @inner
   */ var MIN_VALUE = fromBits(0, -2147483648, false);
    /**
   * Minimum signed value.
   * @type {!Long}
   */ Long.MIN_VALUE = MIN_VALUE;
    /**
   * @alias Long.prototype
   * @inner
   */ var LongPrototype = Long.prototype;
    /**
   * Converts the Long to a 32 bit integer, assuming it is a 32 bit integer.
   * @this {!Long}
   * @returns {number}
   */ LongPrototype.toInt = function toInt() {
        return this.unsigned ? this.low >>> 0 : this.low;
    };
    /**
   * Converts the Long to a the nearest floating-point representation of this value (double, 53 bit mantissa).
   * @this {!Long}
   * @returns {number}
   */ LongPrototype.toNumber = function toNumber() {
        if (this.unsigned) return (this.high >>> 0) * TWO_PWR_32_DBL + (this.low >>> 0);
        return this.high * TWO_PWR_32_DBL + (this.low >>> 0);
    };
    /**
   * Converts the Long to a string written in the specified radix.
   * @this {!Long}
   * @param {number=} radix Radix (2-36), defaults to 10
   * @returns {string}
   * @override
   * @throws {RangeError} If `radix` is out of range
   */ LongPrototype.toString = function toString(radix) {
        radix = radix || 10;
        if (radix < 2 || 36 < radix) throw RangeError("radix");
        if (this.isZero()) return "0";
        if (this.isNegative()) {
            // Unsigned Longs are never negative
            if (this.eq(MIN_VALUE)) {
                // We need to change the Long value before it can be negated, so we remove
                // the bottom-most digit in this base and then recurse to do the rest.
                var radixLong = fromNumber(radix), div = this.div(radixLong), rem1 = div.mul(radixLong).sub(this);
                return div.toString(radix) + rem1.toInt().toString(radix);
            } else return "-" + this.neg().toString(radix);
        } // Do several (6) digits each time through the loop, so as to
        // minimize the calls to the very expensive emulated div.
        var radixToPower = fromNumber(pow_dbl(radix, 6), this.unsigned), rem = this;
        var result = "";
        while(true){
            var remDiv = rem.div(radixToPower), intval = rem.sub(remDiv.mul(radixToPower)).toInt() >>> 0, digits = intval.toString(radix);
            rem = remDiv;
            if (rem.isZero()) return digits + result;
            else {
                while(digits.length < 6)digits = "0" + digits;
                result = "" + digits + result;
            }
        }
    };
    /**
   * Gets the high 32 bits as a signed integer.
   * @this {!Long}
   * @returns {number} Signed high bits
   */ LongPrototype.getHighBits = function getHighBits() {
        return this.high;
    };
    /**
   * Gets the high 32 bits as an unsigned integer.
   * @this {!Long}
   * @returns {number} Unsigned high bits
   */ LongPrototype.getHighBitsUnsigned = function getHighBitsUnsigned() {
        return this.high >>> 0;
    };
    /**
   * Gets the low 32 bits as a signed integer.
   * @this {!Long}
   * @returns {number} Signed low bits
   */ LongPrototype.getLowBits = function getLowBits() {
        return this.low;
    };
    /**
   * Gets the low 32 bits as an unsigned integer.
   * @this {!Long}
   * @returns {number} Unsigned low bits
   */ LongPrototype.getLowBitsUnsigned = function getLowBitsUnsigned() {
        return this.low >>> 0;
    };
    /**
   * Gets the number of bits needed to represent the absolute value of this Long.
   * @this {!Long}
   * @returns {number}
   */ LongPrototype.getNumBitsAbs = function getNumBitsAbs() {
        if (this.isNegative()) return this.eq(MIN_VALUE) ? 64 : this.neg().getNumBitsAbs();
        var val = this.high != 0 ? this.high : this.low;
        for(var bit = 31; bit > 0; bit--)if ((val & 1 << bit) != 0) break;
        return this.high != 0 ? bit + 33 : bit + 1;
    };
    /**
   * Tests if this Long's value equals zero.
   * @this {!Long}
   * @returns {boolean}
   */ LongPrototype.isZero = function isZero() {
        return this.high === 0 && this.low === 0;
    };
    /**
   * Tests if this Long's value equals zero. This is an alias of {@link Long#isZero}.
   * @returns {boolean}
   */ LongPrototype.eqz = LongPrototype.isZero;
    /**
   * Tests if this Long's value is negative.
   * @this {!Long}
   * @returns {boolean}
   */ LongPrototype.isNegative = function isNegative() {
        return !this.unsigned && this.high < 0;
    };
    /**
   * Tests if this Long's value is positive or zero.
   * @this {!Long}
   * @returns {boolean}
   */ LongPrototype.isPositive = function isPositive() {
        return this.unsigned || this.high >= 0;
    };
    /**
   * Tests if this Long's value is odd.
   * @this {!Long}
   * @returns {boolean}
   */ LongPrototype.isOdd = function isOdd() {
        return (this.low & 1) === 1;
    };
    /**
   * Tests if this Long's value is even.
   * @this {!Long}
   * @returns {boolean}
   */ LongPrototype.isEven = function isEven() {
        return (this.low & 1) === 0;
    };
    /**
   * Tests if this Long's value equals the specified's.
   * @this {!Long}
   * @param {!Long|number|string} other Other value
   * @returns {boolean}
   */ LongPrototype.equals = function equals(other) {
        if (!isLong(other)) other = fromValue(other);
        if (this.unsigned !== other.unsigned && this.high >>> 31 === 1 && other.high >>> 31 === 1) return false;
        return this.high === other.high && this.low === other.low;
    };
    /**
   * Tests if this Long's value equals the specified's. This is an alias of {@link Long#equals}.
   * @function
   * @param {!Long|number|string} other Other value
   * @returns {boolean}
   */ LongPrototype.eq = LongPrototype.equals;
    /**
   * Tests if this Long's value differs from the specified's.
   * @this {!Long}
   * @param {!Long|number|string} other Other value
   * @returns {boolean}
   */ LongPrototype.notEquals = function notEquals(other) {
        return !this.eq(/* validates */ other);
    };
    /**
   * Tests if this Long's value differs from the specified's. This is an alias of {@link Long#notEquals}.
   * @function
   * @param {!Long|number|string} other Other value
   * @returns {boolean}
   */ LongPrototype.neq = LongPrototype.notEquals;
    /**
   * Tests if this Long's value differs from the specified's. This is an alias of {@link Long#notEquals}.
   * @function
   * @param {!Long|number|string} other Other value
   * @returns {boolean}
   */ LongPrototype.ne = LongPrototype.notEquals;
    /**
   * Tests if this Long's value is less than the specified's.
   * @this {!Long}
   * @param {!Long|number|string} other Other value
   * @returns {boolean}
   */ LongPrototype.lessThan = function lessThan(other) {
        return this.comp(/* validates */ other) < 0;
    };
    /**
   * Tests if this Long's value is less than the specified's. This is an alias of {@link Long#lessThan}.
   * @function
   * @param {!Long|number|string} other Other value
   * @returns {boolean}
   */ LongPrototype.lt = LongPrototype.lessThan;
    /**
   * Tests if this Long's value is less than or equal the specified's.
   * @this {!Long}
   * @param {!Long|number|string} other Other value
   * @returns {boolean}
   */ LongPrototype.lessThanOrEqual = function lessThanOrEqual(other) {
        return this.comp(/* validates */ other) <= 0;
    };
    /**
   * Tests if this Long's value is less than or equal the specified's. This is an alias of {@link Long#lessThanOrEqual}.
   * @function
   * @param {!Long|number|string} other Other value
   * @returns {boolean}
   */ LongPrototype.lte = LongPrototype.lessThanOrEqual;
    /**
   * Tests if this Long's value is less than or equal the specified's. This is an alias of {@link Long#lessThanOrEqual}.
   * @function
   * @param {!Long|number|string} other Other value
   * @returns {boolean}
   */ LongPrototype.le = LongPrototype.lessThanOrEqual;
    /**
   * Tests if this Long's value is greater than the specified's.
   * @this {!Long}
   * @param {!Long|number|string} other Other value
   * @returns {boolean}
   */ LongPrototype.greaterThan = function greaterThan(other) {
        return this.comp(/* validates */ other) > 0;
    };
    /**
   * Tests if this Long's value is greater than the specified's. This is an alias of {@link Long#greaterThan}.
   * @function
   * @param {!Long|number|string} other Other value
   * @returns {boolean}
   */ LongPrototype.gt = LongPrototype.greaterThan;
    /**
   * Tests if this Long's value is greater than or equal the specified's.
   * @this {!Long}
   * @param {!Long|number|string} other Other value
   * @returns {boolean}
   */ LongPrototype.greaterThanOrEqual = function greaterThanOrEqual(other) {
        return this.comp(/* validates */ other) >= 0;
    };
    /**
   * Tests if this Long's value is greater than or equal the specified's. This is an alias of {@link Long#greaterThanOrEqual}.
   * @function
   * @param {!Long|number|string} other Other value
   * @returns {boolean}
   */ LongPrototype.gte = LongPrototype.greaterThanOrEqual;
    /**
   * Tests if this Long's value is greater than or equal the specified's. This is an alias of {@link Long#greaterThanOrEqual}.
   * @function
   * @param {!Long|number|string} other Other value
   * @returns {boolean}
   */ LongPrototype.ge = LongPrototype.greaterThanOrEqual;
    /**
   * Compares this Long's value with the specified's.
   * @this {!Long}
   * @param {!Long|number|string} other Other value
   * @returns {number} 0 if they are the same, 1 if the this is greater and -1
   *  if the given one is greater
   */ LongPrototype.compare = function compare(other) {
        if (!isLong(other)) other = fromValue(other);
        if (this.eq(other)) return 0;
        var thisNeg = this.isNegative(), otherNeg = other.isNegative();
        if (thisNeg && !otherNeg) return -1;
        if (!thisNeg && otherNeg) return 1; // At this point the sign bits are the same
        if (!this.unsigned) return this.sub(other).isNegative() ? -1 : 1; // Both are positive if at least one is unsigned
        return other.high >>> 0 > this.high >>> 0 || other.high === this.high && other.low >>> 0 > this.low >>> 0 ? -1 : 1;
    };
    /**
   * Compares this Long's value with the specified's. This is an alias of {@link Long#compare}.
   * @function
   * @param {!Long|number|string} other Other value
   * @returns {number} 0 if they are the same, 1 if the this is greater and -1
   *  if the given one is greater
   */ LongPrototype.comp = LongPrototype.compare;
    /**
   * Negates this Long's value.
   * @this {!Long}
   * @returns {!Long} Negated Long
   */ LongPrototype.negate = function negate() {
        if (!this.unsigned && this.eq(MIN_VALUE)) return MIN_VALUE;
        return this.not().add(ONE);
    };
    /**
   * Negates this Long's value. This is an alias of {@link Long#negate}.
   * @function
   * @returns {!Long} Negated Long
   */ LongPrototype.neg = LongPrototype.negate;
    /**
   * Returns the sum of this and the specified Long.
   * @this {!Long}
   * @param {!Long|number|string} addend Addend
   * @returns {!Long} Sum
   */ LongPrototype.add = function add(addend) {
        if (!isLong(addend)) addend = fromValue(addend); // Divide each number into 4 chunks of 16 bits, and then sum the chunks.
        var a48 = this.high >>> 16;
        var a32 = this.high & 0xFFFF;
        var a16 = this.low >>> 16;
        var a00 = this.low & 0xFFFF;
        var b48 = addend.high >>> 16;
        var b32 = addend.high & 0xFFFF;
        var b16 = addend.low >>> 16;
        var b00 = addend.low & 0xFFFF;
        var c48 = 0, c32 = 0, c16 = 0, c00 = 0;
        c00 += a00 + b00;
        c16 += c00 >>> 16;
        c00 &= 0xFFFF;
        c16 += a16 + b16;
        c32 += c16 >>> 16;
        c16 &= 0xFFFF;
        c32 += a32 + b32;
        c48 += c32 >>> 16;
        c32 &= 0xFFFF;
        c48 += a48 + b48;
        c48 &= 0xFFFF;
        return fromBits(c16 << 16 | c00, c48 << 16 | c32, this.unsigned);
    };
    /**
   * Returns the difference of this and the specified Long.
   * @this {!Long}
   * @param {!Long|number|string} subtrahend Subtrahend
   * @returns {!Long} Difference
   */ LongPrototype.subtract = function subtract(subtrahend) {
        if (!isLong(subtrahend)) subtrahend = fromValue(subtrahend);
        return this.add(subtrahend.neg());
    };
    /**
   * Returns the difference of this and the specified Long. This is an alias of {@link Long#subtract}.
   * @function
   * @param {!Long|number|string} subtrahend Subtrahend
   * @returns {!Long} Difference
   */ LongPrototype.sub = LongPrototype.subtract;
    /**
   * Returns the product of this and the specified Long.
   * @this {!Long}
   * @param {!Long|number|string} multiplier Multiplier
   * @returns {!Long} Product
   */ LongPrototype.multiply = function multiply(multiplier) {
        if (this.isZero()) return this;
        if (!isLong(multiplier)) multiplier = fromValue(multiplier); // use wasm support if present
        if (wasm) {
            var low = wasm["mul"](this.low, this.high, multiplier.low, multiplier.high);
            return fromBits(low, wasm["get_high"](), this.unsigned);
        }
        if (multiplier.isZero()) return this.unsigned ? UZERO : ZERO;
        if (this.eq(MIN_VALUE)) return multiplier.isOdd() ? MIN_VALUE : ZERO;
        if (multiplier.eq(MIN_VALUE)) return this.isOdd() ? MIN_VALUE : ZERO;
        if (this.isNegative()) {
            if (multiplier.isNegative()) return this.neg().mul(multiplier.neg());
            else return this.neg().mul(multiplier).neg();
        } else if (multiplier.isNegative()) return this.mul(multiplier.neg()).neg(); // If both longs are small, use float multiplication
        if (this.lt(TWO_PWR_24) && multiplier.lt(TWO_PWR_24)) return fromNumber(this.toNumber() * multiplier.toNumber(), this.unsigned); // Divide each long into 4 chunks of 16 bits, and then add up 4x4 products.
        // We can skip products that would overflow.
        var a48 = this.high >>> 16;
        var a32 = this.high & 0xFFFF;
        var a16 = this.low >>> 16;
        var a00 = this.low & 0xFFFF;
        var b48 = multiplier.high >>> 16;
        var b32 = multiplier.high & 0xFFFF;
        var b16 = multiplier.low >>> 16;
        var b00 = multiplier.low & 0xFFFF;
        var c48 = 0, c32 = 0, c16 = 0, c00 = 0;
        c00 += a00 * b00;
        c16 += c00 >>> 16;
        c00 &= 0xFFFF;
        c16 += a16 * b00;
        c32 += c16 >>> 16;
        c16 &= 0xFFFF;
        c16 += a00 * b16;
        c32 += c16 >>> 16;
        c16 &= 0xFFFF;
        c32 += a32 * b00;
        c48 += c32 >>> 16;
        c32 &= 0xFFFF;
        c32 += a16 * b16;
        c48 += c32 >>> 16;
        c32 &= 0xFFFF;
        c32 += a00 * b32;
        c48 += c32 >>> 16;
        c32 &= 0xFFFF;
        c48 += a48 * b00 + a32 * b16 + a16 * b32 + a00 * b48;
        c48 &= 0xFFFF;
        return fromBits(c16 << 16 | c00, c48 << 16 | c32, this.unsigned);
    };
    /**
   * Returns the product of this and the specified Long. This is an alias of {@link Long#multiply}.
   * @function
   * @param {!Long|number|string} multiplier Multiplier
   * @returns {!Long} Product
   */ LongPrototype.mul = LongPrototype.multiply;
    /**
   * Returns this Long divided by the specified. The result is signed if this Long is signed or
   *  unsigned if this Long is unsigned.
   * @this {!Long}
   * @param {!Long|number|string} divisor Divisor
   * @returns {!Long} Quotient
   */ LongPrototype.divide = function divide(divisor) {
        if (!isLong(divisor)) divisor = fromValue(divisor);
        if (divisor.isZero()) throw Error("division by zero"); // use wasm support if present
        if (wasm) {
            // guard against signed division overflow: the largest
            // negative number / -1 would be 1 larger than the largest
            // positive number, due to two's complement.
            if (!this.unsigned && this.high === -2147483648 && divisor.low === -1 && divisor.high === -1) // be consistent with non-wasm code path
            return this;
            var low = (this.unsigned ? wasm["div_u"] : wasm["div_s"])(this.low, this.high, divisor.low, divisor.high);
            return fromBits(low, wasm["get_high"](), this.unsigned);
        }
        if (this.isZero()) return this.unsigned ? UZERO : ZERO;
        var approx, rem, res;
        if (!this.unsigned) {
            // This section is only relevant for signed longs and is derived from the
            // closure library as a whole.
            if (this.eq(MIN_VALUE)) {
                if (divisor.eq(ONE) || divisor.eq(NEG_ONE)) return MIN_VALUE; // recall that -MIN_VALUE == MIN_VALUE
                else if (divisor.eq(MIN_VALUE)) return ONE;
                else {
                    // At this point, we have |other| >= 2, so |this/other| < |MIN_VALUE|.
                    var halfThis = this.shr(1);
                    approx = halfThis.div(divisor).shl(1);
                    if (approx.eq(ZERO)) return divisor.isNegative() ? ONE : NEG_ONE;
                    else {
                        rem = this.sub(divisor.mul(approx));
                        res = approx.add(rem.div(divisor));
                        return res;
                    }
                }
            } else if (divisor.eq(MIN_VALUE)) return this.unsigned ? UZERO : ZERO;
            if (this.isNegative()) {
                if (divisor.isNegative()) return this.neg().div(divisor.neg());
                return this.neg().div(divisor).neg();
            } else if (divisor.isNegative()) return this.div(divisor.neg()).neg();
            res = ZERO;
        } else {
            // The algorithm below has not been made for unsigned longs. It's therefore
            // required to take special care of the MSB prior to running it.
            if (!divisor.unsigned) divisor = divisor.toUnsigned();
            if (divisor.gt(this)) return UZERO;
            if (divisor.gt(this.shru(1))) return UONE;
            res = UZERO;
        } // Repeat the following until the remainder is less than other:  find a
        // floating-point that approximates remainder / other *from below*, add this
        // into the result, and subtract it from the remainder.  It is critical that
        // the approximate value is less than or equal to the real value so that the
        // remainder never becomes negative.
        rem = this;
        while(rem.gte(divisor)){
            // Approximate the result of division. This may be a little greater or
            // smaller than the actual value.
            approx = Math.max(1, Math.floor(rem.toNumber() / divisor.toNumber())); // We will tweak the approximate result by changing it in the 48-th digit or
            // the smallest non-fractional digit, whichever is larger.
            var log2 = Math.ceil(Math.log(approx) / Math.LN2), delta = log2 <= 48 ? 1 : pow_dbl(2, log2 - 48), // Decrease the approximation until it is smaller than the remainder.  Note
            // that if it is too large, the product overflows and is negative.
            approxRes = fromNumber(approx), approxRem = approxRes.mul(divisor);
            while(approxRem.isNegative() || approxRem.gt(rem)){
                approx -= delta;
                approxRes = fromNumber(approx, this.unsigned);
                approxRem = approxRes.mul(divisor);
            } // We know the answer can't be zero... and actually, zero would cause
            // infinite recursion since we would make no progress.
            if (approxRes.isZero()) approxRes = ONE;
            res = res.add(approxRes);
            rem = rem.sub(approxRem);
        }
        return res;
    };
    /**
   * Returns this Long divided by the specified. This is an alias of {@link Long#divide}.
   * @function
   * @param {!Long|number|string} divisor Divisor
   * @returns {!Long} Quotient
   */ LongPrototype.div = LongPrototype.divide;
    /**
   * Returns this Long modulo the specified.
   * @this {!Long}
   * @param {!Long|number|string} divisor Divisor
   * @returns {!Long} Remainder
   */ LongPrototype.modulo = function modulo(divisor) {
        if (!isLong(divisor)) divisor = fromValue(divisor); // use wasm support if present
        if (wasm) {
            var low = (this.unsigned ? wasm["rem_u"] : wasm["rem_s"])(this.low, this.high, divisor.low, divisor.high);
            return fromBits(low, wasm["get_high"](), this.unsigned);
        }
        return this.sub(this.div(divisor).mul(divisor));
    };
    /**
   * Returns this Long modulo the specified. This is an alias of {@link Long#modulo}.
   * @function
   * @param {!Long|number|string} divisor Divisor
   * @returns {!Long} Remainder
   */ LongPrototype.mod = LongPrototype.modulo;
    /**
   * Returns this Long modulo the specified. This is an alias of {@link Long#modulo}.
   * @function
   * @param {!Long|number|string} divisor Divisor
   * @returns {!Long} Remainder
   */ LongPrototype.rem = LongPrototype.modulo;
    /**
   * Returns the bitwise NOT of this Long.
   * @this {!Long}
   * @returns {!Long}
   */ LongPrototype.not = function not() {
        return fromBits(~this.low, ~this.high, this.unsigned);
    };
    /**
   * Returns count leading zeros of this Long.
   * @this {!Long}
   * @returns {!number}
   */ LongPrototype.countLeadingZeros = function countLeadingZeros() {
        return this.high ? Math.clz32(this.high) : Math.clz32(this.low) + 32;
    };
    /**
   * Returns count leading zeros. This is an alias of {@link Long#countLeadingZeros}.
   * @function
   * @param {!Long}
   * @returns {!number}
   */ LongPrototype.clz = LongPrototype.countLeadingZeros;
    /**
   * Returns count trailing zeros of this Long.
   * @this {!Long}
   * @returns {!number}
   */ LongPrototype.countTrailingZeros = function countTrailingZeros() {
        return this.low ? ctz32(this.low) : ctz32(this.high) + 32;
    };
    /**
   * Returns count trailing zeros. This is an alias of {@link Long#countTrailingZeros}.
   * @function
   * @param {!Long}
   * @returns {!number}
   */ LongPrototype.ctz = LongPrototype.countTrailingZeros;
    /**
   * Returns the bitwise AND of this Long and the specified.
   * @this {!Long}
   * @param {!Long|number|string} other Other Long
   * @returns {!Long}
   */ LongPrototype.and = function and(other) {
        if (!isLong(other)) other = fromValue(other);
        return fromBits(this.low & other.low, this.high & other.high, this.unsigned);
    };
    /**
   * Returns the bitwise OR of this Long and the specified.
   * @this {!Long}
   * @param {!Long|number|string} other Other Long
   * @returns {!Long}
   */ LongPrototype.or = function or(other) {
        if (!isLong(other)) other = fromValue(other);
        return fromBits(this.low | other.low, this.high | other.high, this.unsigned);
    };
    /**
   * Returns the bitwise XOR of this Long and the given one.
   * @this {!Long}
   * @param {!Long|number|string} other Other Long
   * @returns {!Long}
   */ LongPrototype.xor = function xor(other) {
        if (!isLong(other)) other = fromValue(other);
        return fromBits(this.low ^ other.low, this.high ^ other.high, this.unsigned);
    };
    /**
   * Returns this Long with bits shifted to the left by the given amount.
   * @this {!Long}
   * @param {number|!Long} numBits Number of bits
   * @returns {!Long} Shifted Long
   */ LongPrototype.shiftLeft = function shiftLeft(numBits) {
        if (isLong(numBits)) numBits = numBits.toInt();
        if ((numBits &= 63) === 0) return this;
        else if (numBits < 32) return fromBits(this.low << numBits, this.high << numBits | this.low >>> 32 - numBits, this.unsigned);
        else return fromBits(0, this.low << numBits - 32, this.unsigned);
    };
    /**
   * Returns this Long with bits shifted to the left by the given amount. This is an alias of {@link Long#shiftLeft}.
   * @function
   * @param {number|!Long} numBits Number of bits
   * @returns {!Long} Shifted Long
   */ LongPrototype.shl = LongPrototype.shiftLeft;
    /**
   * Returns this Long with bits arithmetically shifted to the right by the given amount.
   * @this {!Long}
   * @param {number|!Long} numBits Number of bits
   * @returns {!Long} Shifted Long
   */ LongPrototype.shiftRight = function shiftRight(numBits) {
        if (isLong(numBits)) numBits = numBits.toInt();
        if ((numBits &= 63) === 0) return this;
        else if (numBits < 32) return fromBits(this.low >>> numBits | this.high << 32 - numBits, this.high >> numBits, this.unsigned);
        else return fromBits(this.high >> numBits - 32, this.high >= 0 ? 0 : -1, this.unsigned);
    };
    /**
   * Returns this Long with bits arithmetically shifted to the right by the given amount. This is an alias of {@link Long#shiftRight}.
   * @function
   * @param {number|!Long} numBits Number of bits
   * @returns {!Long} Shifted Long
   */ LongPrototype.shr = LongPrototype.shiftRight;
    /**
   * Returns this Long with bits logically shifted to the right by the given amount.
   * @this {!Long}
   * @param {number|!Long} numBits Number of bits
   * @returns {!Long} Shifted Long
   */ LongPrototype.shiftRightUnsigned = function shiftRightUnsigned(numBits) {
        if (isLong(numBits)) numBits = numBits.toInt();
        if ((numBits &= 63) === 0) return this;
        if (numBits < 32) return fromBits(this.low >>> numBits | this.high << 32 - numBits, this.high >>> numBits, this.unsigned);
        if (numBits === 32) return fromBits(this.high, 0, this.unsigned);
        return fromBits(this.high >>> numBits - 32, 0, this.unsigned);
    };
    /**
   * Returns this Long with bits logically shifted to the right by the given amount. This is an alias of {@link Long#shiftRightUnsigned}.
   * @function
   * @param {number|!Long} numBits Number of bits
   * @returns {!Long} Shifted Long
   */ LongPrototype.shru = LongPrototype.shiftRightUnsigned;
    /**
   * Returns this Long with bits logically shifted to the right by the given amount. This is an alias of {@link Long#shiftRightUnsigned}.
   * @function
   * @param {number|!Long} numBits Number of bits
   * @returns {!Long} Shifted Long
   */ LongPrototype.shr_u = LongPrototype.shiftRightUnsigned;
    /**
   * Returns this Long with bits rotated to the left by the given amount.
   * @this {!Long}
   * @param {number|!Long} numBits Number of bits
   * @returns {!Long} Rotated Long
   */ LongPrototype.rotateLeft = function rotateLeft(numBits) {
        var b;
        if (isLong(numBits)) numBits = numBits.toInt();
        if ((numBits &= 63) === 0) return this;
        if (numBits === 32) return fromBits(this.high, this.low, this.unsigned);
        if (numBits < 32) {
            b = 32 - numBits;
            return fromBits(this.low << numBits | this.high >>> b, this.high << numBits | this.low >>> b, this.unsigned);
        }
        numBits -= 32;
        b = 32 - numBits;
        return fromBits(this.high << numBits | this.low >>> b, this.low << numBits | this.high >>> b, this.unsigned);
    };
    /**
   * Returns this Long with bits rotated to the left by the given amount. This is an alias of {@link Long#rotateLeft}.
   * @function
   * @param {number|!Long} numBits Number of bits
   * @returns {!Long} Rotated Long
   */ LongPrototype.rotl = LongPrototype.rotateLeft;
    /**
   * Returns this Long with bits rotated to the right by the given amount.
   * @this {!Long}
   * @param {number|!Long} numBits Number of bits
   * @returns {!Long} Rotated Long
   */ LongPrototype.rotateRight = function rotateRight(numBits) {
        var b;
        if (isLong(numBits)) numBits = numBits.toInt();
        if ((numBits &= 63) === 0) return this;
        if (numBits === 32) return fromBits(this.high, this.low, this.unsigned);
        if (numBits < 32) {
            b = 32 - numBits;
            return fromBits(this.high << b | this.low >>> numBits, this.low << b | this.high >>> numBits, this.unsigned);
        }
        numBits -= 32;
        b = 32 - numBits;
        return fromBits(this.low << b | this.high >>> numBits, this.high << b | this.low >>> numBits, this.unsigned);
    };
    /**
   * Returns this Long with bits rotated to the right by the given amount. This is an alias of {@link Long#rotateRight}.
   * @function
   * @param {number|!Long} numBits Number of bits
   * @returns {!Long} Rotated Long
   */ LongPrototype.rotr = LongPrototype.rotateRight;
    /**
   * Converts this Long to signed.
   * @this {!Long}
   * @returns {!Long} Signed long
   */ LongPrototype.toSigned = function toSigned() {
        if (!this.unsigned) return this;
        return fromBits(this.low, this.high, false);
    };
    /**
   * Converts this Long to unsigned.
   * @this {!Long}
   * @returns {!Long} Unsigned long
   */ LongPrototype.toUnsigned = function toUnsigned() {
        if (this.unsigned) return this;
        return fromBits(this.low, this.high, true);
    };
    /**
   * Converts this Long to its byte representation.
   * @param {boolean=} le Whether little or big endian, defaults to big endian
   * @this {!Long}
   * @returns {!Array.<number>} Byte representation
   */ LongPrototype.toBytes = function toBytes(le) {
        return le ? this.toBytesLE() : this.toBytesBE();
    };
    /**
   * Converts this Long to its little endian byte representation.
   * @this {!Long}
   * @returns {!Array.<number>} Little endian byte representation
   */ LongPrototype.toBytesLE = function toBytesLE() {
        var hi = this.high, lo = this.low;
        return [
            lo & 0xff,
            lo >>> 8 & 0xff,
            lo >>> 16 & 0xff,
            lo >>> 24,
            hi & 0xff,
            hi >>> 8 & 0xff,
            hi >>> 16 & 0xff,
            hi >>> 24
        ];
    };
    /**
   * Converts this Long to its big endian byte representation.
   * @this {!Long}
   * @returns {!Array.<number>} Big endian byte representation
   */ LongPrototype.toBytesBE = function toBytesBE() {
        var hi = this.high, lo = this.low;
        return [
            hi >>> 24,
            hi >>> 16 & 0xff,
            hi >>> 8 & 0xff,
            hi & 0xff,
            lo >>> 24,
            lo >>> 16 & 0xff,
            lo >>> 8 & 0xff,
            lo & 0xff
        ];
    };
    /**
   * Creates a Long from its byte representation.
   * @param {!Array.<number>} bytes Byte representation
   * @param {boolean=} unsigned Whether unsigned or not, defaults to signed
   * @param {boolean=} le Whether little or big endian, defaults to big endian
   * @returns {Long} The corresponding Long value
   */ Long.fromBytes = function fromBytes(bytes, unsigned, le) {
        return le ? Long.fromBytesLE(bytes, unsigned) : Long.fromBytesBE(bytes, unsigned);
    };
    /**
   * Creates a Long from its little endian byte representation.
   * @param {!Array.<number>} bytes Little endian byte representation
   * @param {boolean=} unsigned Whether unsigned or not, defaults to signed
   * @returns {Long} The corresponding Long value
   */ Long.fromBytesLE = function fromBytesLE(bytes, unsigned) {
        return new Long(bytes[0] | bytes[1] << 8 | bytes[2] << 16 | bytes[3] << 24, bytes[4] | bytes[5] << 8 | bytes[6] << 16 | bytes[7] << 24, unsigned);
    };
    /**
   * Creates a Long from its big endian byte representation.
   * @param {!Array.<number>} bytes Big endian byte representation
   * @param {boolean=} unsigned Whether unsigned or not, defaults to signed
   * @returns {Long} The corresponding Long value
   */ Long.fromBytesBE = function fromBytesBE(bytes, unsigned) {
        return new Long(bytes[4] << 24 | bytes[5] << 16 | bytes[6] << 8 | bytes[7], bytes[0] << 24 | bytes[1] << 16 | bytes[2] << 8 | bytes[3], unsigned);
    };
    var _default = Long;
    exports.default = _default;
    return "default" in exports ? exports.default : exports;
}({});
if (typeof define === "function" && define.amd) define([], function() {
    return $b1dd3cab00755b37$var$Long;
});
else $b1dd3cab00755b37$exports = $b1dd3cab00755b37$var$Long;




var $ihoyg = parcelRequire("ihoyg");
var $53c0ee1b384ace61$require$Buffer = $ihoyg.Buffer;
var $53c0ee1b384ace61$var$_ = Object.defineProperty;
var $53c0ee1b384ace61$var$i = (r, e)=>$53c0ee1b384ace61$var$_(r, "name", {
        value: e,
        configurable: !0
    });
var $53c0ee1b384ace61$var$M = {
    gasLimits: {
        transfer: 25e4
    }
}, $53c0ee1b384ace61$var$N = $53c0ee1b384ace61$var$i((r)=>$53c0ee1b384ace61$require$Buffer.from(r).toString("hex"), "uint8ArrayToHex"), $53c0ee1b384ace61$export$54a04b74f24ea36d = $53c0ee1b384ace61$var$i(async (r, e)=>{
    if (!e) throw (0, $6bf9e406f810d981$exports.SignerError).AssertionFailed("wallet is null!");
    try {
        let { memo: t, sequence: s, account_number: d, chainId: a, msgs: C, fee: o, signType: p, rpcUrl: E } = r.data, T = C.map((m)=>({
                ...m,
                __type: void 0,
                "@type": void 0
            }));
        if (!a) throw (0, $6bf9e406f810d981$exports.SignerError).AssertionFailed("chainId is undefined from server");
        if (!d) throw (0, $6bf9e406f810d981$exports.SignerError).AssertionFailed("account_number is undefined from server");
        if (!s) throw (0, $6bf9e406f810d981$exports.SignerError).AssertionFailed("sequence is undefined from server");
        if (p === "AMINO") {
            let m = (0, $b8ae3714266935c3$exports.makeSignDoc)(T, o, a, t || void 0, d, s), g = {};
            r.data.chainId === "osmosis-1" && o?.amount[0]?.amount === "0" && (g = {
                preferNoSetFee: !0
            });
            let f;
            try {
                f = await e.signAmino(a, r.fromWalletAddress, m, g);
            } catch (w) {
                throw new (0, $6bf9e406f810d981$exports.SignerError)((0, $6bf9e406f810d981$exports.SignerErrorCode).SIGN_TX_ERROR, void 0, w);
            }
            let l = $53c0ee1b384ace61$export$ebcc0d81997987a(r, f), y = await e.sendTx(a, l, (0, $b8ae3714266935c3$exports.BroadcastMode).Async);
            return $53c0ee1b384ace61$var$N(y);
        } else if (p === "DIRECT") {
            let m = e?.getOfflineSigner(a), g = await (0, $ee390ef646431151$exports.SigningStargateClient)?.connectWithSigner(E, m, {});
            g.registry.register("/cosmwasm.wasm.v1.MsgExecuteContract", (0, $5e79880e7465f438$exports.MsgExecuteContract));
            let f = o?.amount[0] ? [
                {
                    denom: o.amount[0].denom,
                    amount: o?.amount[0].amount
                }
            ] : [], l = $53c0ee1b384ace61$var$M.gasLimits.transfer.toString(), y = typeof o?.gas == "string" ? (0, (/*@__PURE__*/$parcel$interopDefault($b1dd3cab00755b37$exports))).fromString(o?.gas).toString() : l;
            return (await g.signAndBroadcast(r.fromWalletAddress, T, {
                gas: y,
                amount: f
            })).transactionHash;
        }
        throw new (0, $6bf9e406f810d981$exports.SignerError)((0, $6bf9e406f810d981$exports.SignerErrorCode).OPERATION_UNSUPPORTED, `Sign type for cosmos not supported, type: ${p}`);
    } catch (t) {
        throw console.log({
            err: t
        }), (0, $6bf9e406f810d981$exports.SignerError).isSignerError(t) ? t : new (0, $6bf9e406f810d981$exports.SignerError)((0, $6bf9e406f810d981$exports.SignerErrorCode).SEND_TX_ERROR, void 0, t);
    }
}, "executeCosmosTransaction");
function $53c0ee1b384ace61$export$ebcc0d81997987a(r, e) {
    let t;
    if (r.data.protoMsgs.length > 0) t = (0, $4e4e07fbc7086f67$exports.cosmos).tx.v1beta1.TxRaw.encode({
        bodyBytes: (0, $4e4e07fbc7086f67$exports.cosmos).tx.v1beta1.TxBody.encode({
            messages: r.data.protoMsgs.map((s)=>({
                    type_url: s.type_url,
                    value: new Uint8Array(s.value)
                })),
            memo: e.signed.memo
        }).finish(),
        authInfoBytes: (0, $4e4e07fbc7086f67$exports.cosmos).tx.v1beta1.AuthInfo.encode({
            signerInfos: [
                {
                    publicKey: {
                        type_url: "/cosmos.crypto.secp256k1.PubKey",
                        value: (0, $4e4e07fbc7086f67$exports.cosmos).crypto.secp256k1.PubKey.encode({
                            key: $53c0ee1b384ace61$require$Buffer.from(e.signature.pub_key.value, "base64")
                        }).finish()
                    },
                    modeInfo: {
                        single: {
                            mode: (0, $4e4e07fbc7086f67$exports.cosmos).tx.signing.v1beta1.SignMode.SIGN_MODE_LEGACY_AMINO_JSON
                        }
                    },
                    sequence: (0, (/*@__PURE__*/$parcel$interopDefault($b1dd3cab00755b37$exports))).fromString(e.signed.sequence)
                }
            ],
            fee: {
                amount: e.signed.fee.amount,
                gasLimit: (0, (/*@__PURE__*/$parcel$interopDefault($b1dd3cab00755b37$exports))).fromString(e.signed.fee.gas)
            }
        }).finish(),
        signatures: [
            $53c0ee1b384ace61$require$Buffer.from(e.signature.signature, "base64")
        ]
    }).finish();
    else throw (0, $6bf9e406f810d981$exports.SignerError).AssertionFailed("protoMsgs is required in Amino messages");
    return t;
}
$53c0ee1b384ace61$var$i($53c0ee1b384ace61$export$ebcc0d81997987a, "getsignedTx");
var $53c0ee1b384ace61$export$e64e415bb1c84b08 = class {
    constructor(e){
        this.provider = e;
    }
    async signMessage(e, t, s) {
        if (!s) throw Error("ChainId is required");
        let { signature: d } = await this.provider.signArbitrary(s, t, e);
        return d;
    }
    async signAndSendTx(e) {
        return {
            hash: await $53c0ee1b384ace61$export$54a04b74f24ea36d(e, this.provider)
        };
    }
};
$53c0ee1b384ace61$var$i($53c0ee1b384ace61$export$e64e415bb1c84b08, "DefaultCosmosSigner");


var $4ececec3958d7516$var$c = Object.defineProperty;
var $4ececec3958d7516$var$r = (e, o)=>$4ececec3958d7516$var$c(e, "name", {
        value: o,
        configurable: !0
    });
function $4ececec3958d7516$var$s() {
    return window.keplr || null;
}
$4ececec3958d7516$var$r($4ececec3958d7516$var$s, "keplr");
function $4ececec3958d7516$var$n(e) {
    let o = (0, $c7b1ddb572c90b38$export$2029b78bc980a576)(e, (0, $c7b1ddb572c90b38$export$2e8191f482a38ccd).COSMOS), t = new (0, $b0f7ab1c178913fc$export$2006fb7614e99307);
    return t.registerSigner((0, $6fc89aa3c0b05299$export$d513b00599f845d4).COSMOS, new (0, $53c0ee1b384ace61$export$e64e415bb1c84b08)(o)), t;
}
$4ececec3958d7516$var$r($4ececec3958d7516$var$n, "getSigners");
var $4ececec3958d7516$var$u = (0, $c7b1ddb572c90b38$export$b80cfa133c9c182d).KEPLR, $4ececec3958d7516$export$e506a1d27d1eaa20 = {
    type: $4ececec3958d7516$var$u,
    defaultNetwork: (0, $c7b1ddb572c90b38$export$2e8191f482a38ccd).COSMOS
}, $4ececec3958d7516$export$8bedcca5bbd73999 = $4ececec3958d7516$var$s, $4ececec3958d7516$export$64605811ab45167f = $4ececec3958d7516$var$r(async ({ instance: e, network: o, meta: t })=>await (0, $c7b1ddb572c90b38$export$d4d8333f992ebe8c)({
        instance: e,
        meta: t,
        network: o
    }), "connect"), $4ececec3958d7516$export$ec068583843480e7 = $4ececec3958d7516$var$r(({ connect: e, disconnect: o })=>{
    let t = $4ececec3958d7516$var$r(()=>{
        o(), e();
    }, "handleAccountsChanged");
    return window.addEventListener("keplr_keystorechange", t), ()=>{
        window.removeEventListener("keplr_keystorechange", t);
    };
}, "subscribe"), $4ececec3958d7516$export$b0b3f4ef5d856594 = (0, $c7b1ddb572c90b38$export$d873bd134feb393), $4ececec3958d7516$export$6352a17a50193ded = $4ececec3958d7516$var$n, $4ececec3958d7516$export$e5b9d96c6aeb3ff7 = $4ececec3958d7516$var$r((e)=>{
    let o = (0, $cd8bb37a306c2b01$export$7a136f0d6bb0d722)(e);
    return {
        name: "Keplr",
        img: "https://raw.githubusercontent.com/rango-exchange/assets/main/wallets/keplr/icon.svg",
        installLink: {
            CHROME: "https://chrome.google.com/webstore/detail/keplr/dmkamcknogkgcdfhhbddcghachkejeap",
            BRAVE: "https://chrome.google.com/webstore/detail/keplr/dmkamcknogkgcdfhhbddcghachkejeap",
            FIREFOX: "https://addons.mozilla.org/en-US/firefox/addon/keplr",
            DEFAULT: "https://www.keplr.app"
        },
        color: "#3898e5",
        supportedChains: o.filter((t)=>!!t.info)
    };
}, "getWalletInfo");


var $8702f288516fd747$exports = {};

$parcel$export($8702f288516fd747$exports, "config", function () { return $8702f288516fd747$export$e506a1d27d1eaa20; });
$parcel$export($8702f288516fd747$exports, "getInstance", function () { return $8702f288516fd747$export$8bedcca5bbd73999; });
$parcel$export($8702f288516fd747$exports, "connect", function () { return $8702f288516fd747$export$64605811ab45167f; });
$parcel$export($8702f288516fd747$exports, "subscribe", function () { return $8702f288516fd747$export$ec068583843480e7; });
$parcel$export($8702f288516fd747$exports, "canSwitchNetworkTo", function () { return $8702f288516fd747$export$3b3cf9ab9019de20; });
$parcel$export($8702f288516fd747$exports, "getSigners", function () { return $8702f288516fd747$export$6352a17a50193ded; });
$parcel$export($8702f288516fd747$exports, "canEagerConnect", function () { return $8702f288516fd747$export$be9f3c5ed1d25e42; });
$parcel$export($8702f288516fd747$exports, "getWalletInfo", function () { return $8702f288516fd747$export$e5b9d96c6aeb3ff7; });


/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ var $5ed0747d5916bbd8$export$a143d493d941bafc;
var $5ed0747d5916bbd8$export$e4cf37d7f6fb9e0a;
var $5ed0747d5916bbd8$export$f99ded8fe4b79145;
var $5ed0747d5916bbd8$export$599f31c3813fae4d;
"use strict";

var $hqZtu = parcelRequire("hqZtu");

var $5WQj6 = parcelRequire("5WQj6");
const $5ed0747d5916bbd8$var$customInspectSymbol = typeof Symbol === "function" && typeof Symbol["for"] === "function" // eslint-disable-line dot-notation
 ? Symbol["for"]("nodejs.util.inspect.custom") // eslint-disable-line dot-notation
 : null;
$5ed0747d5916bbd8$export$a143d493d941bafc = $5ed0747d5916bbd8$var$Buffer;
$5ed0747d5916bbd8$export$e4cf37d7f6fb9e0a = $5ed0747d5916bbd8$var$SlowBuffer;
$5ed0747d5916bbd8$export$f99ded8fe4b79145 = 50;
const $5ed0747d5916bbd8$var$K_MAX_LENGTH = 0x7fffffff;
$5ed0747d5916bbd8$export$599f31c3813fae4d = $5ed0747d5916bbd8$var$K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ $5ed0747d5916bbd8$var$Buffer.TYPED_ARRAY_SUPPORT = $5ed0747d5916bbd8$var$typedArraySupport();
if (!$5ed0747d5916bbd8$var$Buffer.TYPED_ARRAY_SUPPORT && typeof console !== "undefined" && typeof console.error === "function") console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function $5ed0747d5916bbd8$var$typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        const arr = new Uint8Array(1);
        const proto = {
            foo: function() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty($5ed0747d5916bbd8$var$Buffer.prototype, "parent", {
    enumerable: true,
    get: function() {
        if (!$5ed0747d5916bbd8$var$Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty($5ed0747d5916bbd8$var$Buffer.prototype, "offset", {
    enumerable: true,
    get: function() {
        if (!$5ed0747d5916bbd8$var$Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function $5ed0747d5916bbd8$var$createBuffer(length) {
    if (length > $5ed0747d5916bbd8$var$K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    const buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, $5ed0747d5916bbd8$var$Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $5ed0747d5916bbd8$var$Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === "number") {
        if (typeof encodingOrOffset === "string") throw new TypeError('The "string" argument must be of type string. Received type number');
        return $5ed0747d5916bbd8$var$allocUnsafe(arg);
    }
    return $5ed0747d5916bbd8$var$from(arg, encodingOrOffset, length);
}
$5ed0747d5916bbd8$var$Buffer.poolSize = 8192 // not used by this implementation
;
function $5ed0747d5916bbd8$var$from(value, encodingOrOffset, length) {
    if (typeof value === "string") return $5ed0747d5916bbd8$var$fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return $5ed0747d5916bbd8$var$fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
    if ($5ed0747d5916bbd8$var$isInstance(value, ArrayBuffer) || value && $5ed0747d5916bbd8$var$isInstance(value.buffer, ArrayBuffer)) return $5ed0747d5916bbd8$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== "undefined" && ($5ed0747d5916bbd8$var$isInstance(value, SharedArrayBuffer) || value && $5ed0747d5916bbd8$var$isInstance(value.buffer, SharedArrayBuffer))) return $5ed0747d5916bbd8$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === "number") throw new TypeError('The "value" argument must not be of type number. Received type number');
    const valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return $5ed0747d5916bbd8$var$Buffer.from(valueOf, encodingOrOffset, length);
    const b = $5ed0747d5916bbd8$var$fromObject(value);
    if (b) return b;
    if (typeof Symbol !== "undefined" && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === "function") return $5ed0747d5916bbd8$var$Buffer.from(value[Symbol.toPrimitive]("string"), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $5ed0747d5916bbd8$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $5ed0747d5916bbd8$var$from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf($5ed0747d5916bbd8$var$Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf($5ed0747d5916bbd8$var$Buffer, Uint8Array);
function $5ed0747d5916bbd8$var$assertSize(size) {
    if (typeof size !== "number") throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function $5ed0747d5916bbd8$var$alloc(size, fill, encoding) {
    $5ed0747d5916bbd8$var$assertSize(size);
    if (size <= 0) return $5ed0747d5916bbd8$var$createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === "string" ? $5ed0747d5916bbd8$var$createBuffer(size).fill(fill, encoding) : $5ed0747d5916bbd8$var$createBuffer(size).fill(fill);
    return $5ed0747d5916bbd8$var$createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $5ed0747d5916bbd8$var$Buffer.alloc = function(size, fill, encoding) {
    return $5ed0747d5916bbd8$var$alloc(size, fill, encoding);
};
function $5ed0747d5916bbd8$var$allocUnsafe(size) {
    $5ed0747d5916bbd8$var$assertSize(size);
    return $5ed0747d5916bbd8$var$createBuffer(size < 0 ? 0 : $5ed0747d5916bbd8$var$checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $5ed0747d5916bbd8$var$Buffer.allocUnsafe = function(size) {
    return $5ed0747d5916bbd8$var$allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $5ed0747d5916bbd8$var$Buffer.allocUnsafeSlow = function(size) {
    return $5ed0747d5916bbd8$var$allocUnsafe(size);
};
function $5ed0747d5916bbd8$var$fromString(string, encoding) {
    if (typeof encoding !== "string" || encoding === "") encoding = "utf8";
    if (!$5ed0747d5916bbd8$var$Buffer.isEncoding(encoding)) throw new TypeError("Unknown encoding: " + encoding);
    const length = $5ed0747d5916bbd8$var$byteLength(string, encoding) | 0;
    let buf = $5ed0747d5916bbd8$var$createBuffer(length);
    const actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function $5ed0747d5916bbd8$var$fromArrayLike(array) {
    const length = array.length < 0 ? 0 : $5ed0747d5916bbd8$var$checked(array.length) | 0;
    const buf = $5ed0747d5916bbd8$var$createBuffer(length);
    for(let i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function $5ed0747d5916bbd8$var$fromArrayView(arrayView) {
    if ($5ed0747d5916bbd8$var$isInstance(arrayView, Uint8Array)) {
        const copy = new Uint8Array(arrayView);
        return $5ed0747d5916bbd8$var$fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return $5ed0747d5916bbd8$var$fromArrayLike(arrayView);
}
function $5ed0747d5916bbd8$var$fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    let buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, $5ed0747d5916bbd8$var$Buffer.prototype);
    return buf;
}
function $5ed0747d5916bbd8$var$fromObject(obj) {
    if ($5ed0747d5916bbd8$var$Buffer.isBuffer(obj)) {
        const len = $5ed0747d5916bbd8$var$checked(obj.length) | 0;
        const buf = $5ed0747d5916bbd8$var$createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== "number" || $5ed0747d5916bbd8$var$numberIsNaN(obj.length)) return $5ed0747d5916bbd8$var$createBuffer(0);
        return $5ed0747d5916bbd8$var$fromArrayLike(obj);
    }
    if (obj.type === "Buffer" && Array.isArray(obj.data)) return $5ed0747d5916bbd8$var$fromArrayLike(obj.data);
}
function $5ed0747d5916bbd8$var$checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $5ed0747d5916bbd8$var$K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $5ed0747d5916bbd8$var$K_MAX_LENGTH.toString(16) + " bytes");
    return length | 0;
}
function $5ed0747d5916bbd8$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $5ed0747d5916bbd8$var$Buffer.alloc(+length);
}
$5ed0747d5916bbd8$var$Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== $5ed0747d5916bbd8$var$Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
$5ed0747d5916bbd8$var$Buffer.compare = function compare(a, b) {
    if ($5ed0747d5916bbd8$var$isInstance(a, Uint8Array)) a = $5ed0747d5916bbd8$var$Buffer.from(a, a.offset, a.byteLength);
    if ($5ed0747d5916bbd8$var$isInstance(b, Uint8Array)) b = $5ed0747d5916bbd8$var$Buffer.from(b, b.offset, b.byteLength);
    if (!$5ed0747d5916bbd8$var$Buffer.isBuffer(a) || !$5ed0747d5916bbd8$var$Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    let x = a.length;
    let y = b.length;
    for(let i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$5ed0747d5916bbd8$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case "hex":
        case "utf8":
        case "utf-8":
        case "ascii":
        case "latin1":
        case "binary":
        case "base64":
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return true;
        default:
            return false;
    }
};
$5ed0747d5916bbd8$var$Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $5ed0747d5916bbd8$var$Buffer.alloc(0);
    let i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    const buffer = $5ed0747d5916bbd8$var$Buffer.allocUnsafe(length);
    let pos = 0;
    for(i = 0; i < list.length; ++i){
        let buf = list[i];
        if ($5ed0747d5916bbd8$var$isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) {
                if (!$5ed0747d5916bbd8$var$Buffer.isBuffer(buf)) buf = $5ed0747d5916bbd8$var$Buffer.from(buf);
                buf.copy(buffer, pos);
            } else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!$5ed0747d5916bbd8$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $5ed0747d5916bbd8$var$byteLength(string, encoding) {
    if ($5ed0747d5916bbd8$var$Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || $5ed0747d5916bbd8$var$isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== "string") throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string);
    const len = string.length;
    const mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    let loweredCase = false;
    for(;;)switch(encoding){
        case "ascii":
        case "latin1":
        case "binary":
            return len;
        case "utf8":
        case "utf-8":
            return $5ed0747d5916bbd8$var$utf8ToBytes(string).length;
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return len * 2;
        case "hex":
            return len >>> 1;
        case "base64":
            return $5ed0747d5916bbd8$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : $5ed0747d5916bbd8$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ("" + encoding).toLowerCase();
            loweredCase = true;
    }
}
$5ed0747d5916bbd8$var$Buffer.byteLength = $5ed0747d5916bbd8$var$byteLength;
function $5ed0747d5916bbd8$var$slowToString(encoding, start, end) {
    let loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return "";
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return "";
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return "";
    if (!encoding) encoding = "utf8";
    while(true)switch(encoding){
        case "hex":
            return $5ed0747d5916bbd8$var$hexSlice(this, start, end);
        case "utf8":
        case "utf-8":
            return $5ed0747d5916bbd8$var$utf8Slice(this, start, end);
        case "ascii":
            return $5ed0747d5916bbd8$var$asciiSlice(this, start, end);
        case "latin1":
        case "binary":
            return $5ed0747d5916bbd8$var$latin1Slice(this, start, end);
        case "base64":
            return $5ed0747d5916bbd8$var$base64Slice(this, start, end);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return $5ed0747d5916bbd8$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
            encoding = (encoding + "").toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
$5ed0747d5916bbd8$var$Buffer.prototype._isBuffer = true;
function $5ed0747d5916bbd8$var$swap(b, n, m) {
    const i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$5ed0747d5916bbd8$var$Buffer.prototype.swap16 = function swap16() {
    const len = this.length;
    if (len % 2 !== 0) throw new RangeError("Buffer size must be a multiple of 16-bits");
    for(let i = 0; i < len; i += 2)$5ed0747d5916bbd8$var$swap(this, i, i + 1);
    return this;
};
$5ed0747d5916bbd8$var$Buffer.prototype.swap32 = function swap32() {
    const len = this.length;
    if (len % 4 !== 0) throw new RangeError("Buffer size must be a multiple of 32-bits");
    for(let i = 0; i < len; i += 4){
        $5ed0747d5916bbd8$var$swap(this, i, i + 3);
        $5ed0747d5916bbd8$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$5ed0747d5916bbd8$var$Buffer.prototype.swap64 = function swap64() {
    const len = this.length;
    if (len % 8 !== 0) throw new RangeError("Buffer size must be a multiple of 64-bits");
    for(let i = 0; i < len; i += 8){
        $5ed0747d5916bbd8$var$swap(this, i, i + 7);
        $5ed0747d5916bbd8$var$swap(this, i + 1, i + 6);
        $5ed0747d5916bbd8$var$swap(this, i + 2, i + 5);
        $5ed0747d5916bbd8$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$5ed0747d5916bbd8$var$Buffer.prototype.toString = function toString() {
    const length = this.length;
    if (length === 0) return "";
    if (arguments.length === 0) return $5ed0747d5916bbd8$var$utf8Slice(this, 0, length);
    return $5ed0747d5916bbd8$var$slowToString.apply(this, arguments);
};
$5ed0747d5916bbd8$var$Buffer.prototype.toLocaleString = $5ed0747d5916bbd8$var$Buffer.prototype.toString;
$5ed0747d5916bbd8$var$Buffer.prototype.equals = function equals(b) {
    if (!$5ed0747d5916bbd8$var$Buffer.isBuffer(b)) throw new TypeError("Argument must be a Buffer");
    if (this === b) return true;
    return $5ed0747d5916bbd8$var$Buffer.compare(this, b) === 0;
};
$5ed0747d5916bbd8$var$Buffer.prototype.inspect = function inspect() {
    let str = "";
    const max = $5ed0747d5916bbd8$export$f99ded8fe4b79145;
    str = this.toString("hex", 0, max).replace(/(.{2})/g, "$1 ").trim();
    if (this.length > max) str += " ... ";
    return "<Buffer " + str + ">";
};
if ($5ed0747d5916bbd8$var$customInspectSymbol) $5ed0747d5916bbd8$var$Buffer.prototype[$5ed0747d5916bbd8$var$customInspectSymbol] = $5ed0747d5916bbd8$var$Buffer.prototype.inspect;
$5ed0747d5916bbd8$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if ($5ed0747d5916bbd8$var$isInstance(target, Uint8Array)) target = $5ed0747d5916bbd8$var$Buffer.from(target, target.offset, target.byteLength);
    if (!$5ed0747d5916bbd8$var$Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target);
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError("out of range index");
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    let x = thisEnd - thisStart;
    let y = end - start;
    const len = Math.min(x, y);
    const thisCopy = this.slice(thisStart, thisEnd);
    const targetCopy = target.slice(start, end);
    for(let i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $5ed0747d5916bbd8$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === "string") {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if ($5ed0747d5916bbd8$var$numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === "string") val = $5ed0747d5916bbd8$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($5ed0747d5916bbd8$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $5ed0747d5916bbd8$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === "number") {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === "function") {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $5ed0747d5916bbd8$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError("val must be string, number or Buffer");
}
function $5ed0747d5916bbd8$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    let indexSize = 1;
    let arrLength = arr.length;
    let valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === "ucs2" || encoding === "ucs-2" || encoding === "utf16le" || encoding === "utf-16le") {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    let i;
    if (dir) {
        let foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            let found = true;
            for(let j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$5ed0747d5916bbd8$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$5ed0747d5916bbd8$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $5ed0747d5916bbd8$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$5ed0747d5916bbd8$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $5ed0747d5916bbd8$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $5ed0747d5916bbd8$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    const remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    const strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    let i;
    for(i = 0; i < length; ++i){
        const parsed = parseInt(string.substr(i * 2, 2), 16);
        if ($5ed0747d5916bbd8$var$numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $5ed0747d5916bbd8$var$utf8Write(buf, string, offset, length) {
    return $5ed0747d5916bbd8$var$blitBuffer($5ed0747d5916bbd8$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $5ed0747d5916bbd8$var$asciiWrite(buf, string, offset, length) {
    return $5ed0747d5916bbd8$var$blitBuffer($5ed0747d5916bbd8$var$asciiToBytes(string), buf, offset, length);
}
function $5ed0747d5916bbd8$var$base64Write(buf, string, offset, length) {
    return $5ed0747d5916bbd8$var$blitBuffer($5ed0747d5916bbd8$var$base64ToBytes(string), buf, offset, length);
}
function $5ed0747d5916bbd8$var$ucs2Write(buf, string, offset, length) {
    return $5ed0747d5916bbd8$var$blitBuffer($5ed0747d5916bbd8$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$5ed0747d5916bbd8$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = "utf8";
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === "string") {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = "utf8";
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error("Buffer.write(string, encoding, offset[, length]) is no longer supported");
    const remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError("Attempt to write outside buffer bounds");
    if (!encoding) encoding = "utf8";
    let loweredCase = false;
    for(;;)switch(encoding){
        case "hex":
            return $5ed0747d5916bbd8$var$hexWrite(this, string, offset, length);
        case "utf8":
        case "utf-8":
            return $5ed0747d5916bbd8$var$utf8Write(this, string, offset, length);
        case "ascii":
        case "latin1":
        case "binary":
            return $5ed0747d5916bbd8$var$asciiWrite(this, string, offset, length);
        case "base64":
            // Warning: maxLength not taken into account in base64Write
            return $5ed0747d5916bbd8$var$base64Write(this, string, offset, length);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return $5ed0747d5916bbd8$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
            encoding = ("" + encoding).toLowerCase();
            loweredCase = true;
    }
};
$5ed0747d5916bbd8$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: "Buffer",
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $5ed0747d5916bbd8$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $hqZtu.fromByteArray(buf);
    else return $hqZtu.fromByteArray(buf.slice(start, end));
}
function $5ed0747d5916bbd8$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    const res = [];
    let i = start;
    while(i < end){
        const firstByte = buf[i];
        let codePoint = null;
        let bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            let secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $5ed0747d5916bbd8$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
const $5ed0747d5916bbd8$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $5ed0747d5916bbd8$var$decodeCodePointsArray(codePoints) {
    const len = codePoints.length;
    if (len <= $5ed0747d5916bbd8$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    let res = "";
    let i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $5ed0747d5916bbd8$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $5ed0747d5916bbd8$var$asciiSlice(buf, start, end) {
    let ret = "";
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $5ed0747d5916bbd8$var$latin1Slice(buf, start, end) {
    let ret = "";
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $5ed0747d5916bbd8$var$hexSlice(buf, start, end) {
    const len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    let out = "";
    for(let i = start; i < end; ++i)out += $5ed0747d5916bbd8$var$hexSliceLookupTable[buf[i]];
    return out;
}
function $5ed0747d5916bbd8$var$utf16leSlice(buf, start, end) {
    const bytes = buf.slice(start, end);
    let res = "";
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(let i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$5ed0747d5916bbd8$var$Buffer.prototype.slice = function slice(start, end) {
    const len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    const newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, $5ed0747d5916bbd8$var$Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $5ed0747d5916bbd8$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError("offset is not uint");
    if (offset + ext > length) throw new RangeError("Trying to access beyond buffer length");
}
$5ed0747d5916bbd8$var$Buffer.prototype.readUintLE = $5ed0747d5916bbd8$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $5ed0747d5916bbd8$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$5ed0747d5916bbd8$var$Buffer.prototype.readUintBE = $5ed0747d5916bbd8$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $5ed0747d5916bbd8$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset + --byteLength];
    let mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$5ed0747d5916bbd8$var$Buffer.prototype.readUint8 = $5ed0747d5916bbd8$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $5ed0747d5916bbd8$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$5ed0747d5916bbd8$var$Buffer.prototype.readUint16LE = $5ed0747d5916bbd8$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $5ed0747d5916bbd8$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$5ed0747d5916bbd8$var$Buffer.prototype.readUint16BE = $5ed0747d5916bbd8$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $5ed0747d5916bbd8$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$5ed0747d5916bbd8$var$Buffer.prototype.readUint32LE = $5ed0747d5916bbd8$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $5ed0747d5916bbd8$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$5ed0747d5916bbd8$var$Buffer.prototype.readUint32BE = $5ed0747d5916bbd8$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $5ed0747d5916bbd8$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$5ed0747d5916bbd8$var$Buffer.prototype.readBigUInt64LE = $5ed0747d5916bbd8$var$defineBigIntMethod(function readBigUInt64LE(offset) {
    offset = offset >>> 0;
    $5ed0747d5916bbd8$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $5ed0747d5916bbd8$var$boundsError(offset, this.length - 8);
    const lo = first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24;
    const hi = this[++offset] + this[++offset] * 256 + this[++offset] * 2 ** 16 + last * 2 ** 24;
    return BigInt(lo) + (BigInt(hi) << BigInt(32));
});
$5ed0747d5916bbd8$var$Buffer.prototype.readBigUInt64BE = $5ed0747d5916bbd8$var$defineBigIntMethod(function readBigUInt64BE(offset) {
    offset = offset >>> 0;
    $5ed0747d5916bbd8$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $5ed0747d5916bbd8$var$boundsError(offset, this.length - 8);
    const hi = first * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    const lo = this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last;
    return (BigInt(hi) << BigInt(32)) + BigInt(lo);
});
$5ed0747d5916bbd8$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $5ed0747d5916bbd8$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$5ed0747d5916bbd8$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $5ed0747d5916bbd8$var$checkOffset(offset, byteLength, this.length);
    let i = byteLength;
    let mul = 1;
    let val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$5ed0747d5916bbd8$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $5ed0747d5916bbd8$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$5ed0747d5916bbd8$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $5ed0747d5916bbd8$var$checkOffset(offset, 2, this.length);
    const val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$5ed0747d5916bbd8$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $5ed0747d5916bbd8$var$checkOffset(offset, 2, this.length);
    const val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$5ed0747d5916bbd8$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $5ed0747d5916bbd8$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$5ed0747d5916bbd8$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $5ed0747d5916bbd8$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$5ed0747d5916bbd8$var$Buffer.prototype.readBigInt64LE = $5ed0747d5916bbd8$var$defineBigIntMethod(function readBigInt64LE(offset) {
    offset = offset >>> 0;
    $5ed0747d5916bbd8$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $5ed0747d5916bbd8$var$boundsError(offset, this.length - 8);
    const val = this[offset + 4] + this[offset + 5] * 256 + this[offset + 6] * 2 ** 16 + (last << 24 // Overflow
    );
    return (BigInt(val) << BigInt(32)) + BigInt(first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24);
});
$5ed0747d5916bbd8$var$Buffer.prototype.readBigInt64BE = $5ed0747d5916bbd8$var$defineBigIntMethod(function readBigInt64BE(offset) {
    offset = offset >>> 0;
    $5ed0747d5916bbd8$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $5ed0747d5916bbd8$var$boundsError(offset, this.length - 8);
    const val = (first << 24) + // Overflow
    this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    return (BigInt(val) << BigInt(32)) + BigInt(this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last);
});
$5ed0747d5916bbd8$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $5ed0747d5916bbd8$var$checkOffset(offset, 4, this.length);
    return $5WQj6.read(this, offset, true, 23, 4);
};
$5ed0747d5916bbd8$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $5ed0747d5916bbd8$var$checkOffset(offset, 4, this.length);
    return $5WQj6.read(this, offset, false, 23, 4);
};
$5ed0747d5916bbd8$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $5ed0747d5916bbd8$var$checkOffset(offset, 8, this.length);
    return $5WQj6.read(this, offset, true, 52, 8);
};
$5ed0747d5916bbd8$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $5ed0747d5916bbd8$var$checkOffset(offset, 8, this.length);
    return $5WQj6.read(this, offset, false, 52, 8);
};
function $5ed0747d5916bbd8$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$5ed0747d5916bbd8$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError("Index out of range");
}
$5ed0747d5916bbd8$var$Buffer.prototype.writeUintLE = $5ed0747d5916bbd8$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $5ed0747d5916bbd8$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let mul = 1;
    let i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$5ed0747d5916bbd8$var$Buffer.prototype.writeUintBE = $5ed0747d5916bbd8$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $5ed0747d5916bbd8$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let i = byteLength - 1;
    let mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$5ed0747d5916bbd8$var$Buffer.prototype.writeUint8 = $5ed0747d5916bbd8$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $5ed0747d5916bbd8$var$checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
$5ed0747d5916bbd8$var$Buffer.prototype.writeUint16LE = $5ed0747d5916bbd8$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $5ed0747d5916bbd8$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$5ed0747d5916bbd8$var$Buffer.prototype.writeUint16BE = $5ed0747d5916bbd8$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $5ed0747d5916bbd8$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$5ed0747d5916bbd8$var$Buffer.prototype.writeUint32LE = $5ed0747d5916bbd8$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $5ed0747d5916bbd8$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
$5ed0747d5916bbd8$var$Buffer.prototype.writeUint32BE = $5ed0747d5916bbd8$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $5ed0747d5916bbd8$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function $5ed0747d5916bbd8$var$wrtBigUInt64LE(buf, value, offset, min, max) {
    $5ed0747d5916bbd8$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    return offset;
}
function $5ed0747d5916bbd8$var$wrtBigUInt64BE(buf, value, offset, min, max) {
    $5ed0747d5916bbd8$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset + 7] = lo;
    lo = lo >> 8;
    buf[offset + 6] = lo;
    lo = lo >> 8;
    buf[offset + 5] = lo;
    lo = lo >> 8;
    buf[offset + 4] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset + 3] = hi;
    hi = hi >> 8;
    buf[offset + 2] = hi;
    hi = hi >> 8;
    buf[offset + 1] = hi;
    hi = hi >> 8;
    buf[offset] = hi;
    return offset + 8;
}
$5ed0747d5916bbd8$var$Buffer.prototype.writeBigUInt64LE = $5ed0747d5916bbd8$var$defineBigIntMethod(function writeBigUInt64LE(value, offset = 0) {
    return $5ed0747d5916bbd8$var$wrtBigUInt64LE(this, value, offset, BigInt(0), BigInt("0xffffffffffffffff"));
});
$5ed0747d5916bbd8$var$Buffer.prototype.writeBigUInt64BE = $5ed0747d5916bbd8$var$defineBigIntMethod(function writeBigUInt64BE(value, offset = 0) {
    return $5ed0747d5916bbd8$var$wrtBigUInt64BE(this, value, offset, BigInt(0), BigInt("0xffffffffffffffff"));
});
$5ed0747d5916bbd8$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $5ed0747d5916bbd8$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = 0;
    let mul = 1;
    let sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$5ed0747d5916bbd8$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $5ed0747d5916bbd8$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = byteLength - 1;
    let mul = 1;
    let sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$5ed0747d5916bbd8$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $5ed0747d5916bbd8$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$5ed0747d5916bbd8$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $5ed0747d5916bbd8$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$5ed0747d5916bbd8$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $5ed0747d5916bbd8$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$5ed0747d5916bbd8$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $5ed0747d5916bbd8$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
$5ed0747d5916bbd8$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $5ed0747d5916bbd8$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
$5ed0747d5916bbd8$var$Buffer.prototype.writeBigInt64LE = $5ed0747d5916bbd8$var$defineBigIntMethod(function writeBigInt64LE(value, offset = 0) {
    return $5ed0747d5916bbd8$var$wrtBigUInt64LE(this, value, offset, -BigInt("0x8000000000000000"), BigInt("0x7fffffffffffffff"));
});
$5ed0747d5916bbd8$var$Buffer.prototype.writeBigInt64BE = $5ed0747d5916bbd8$var$defineBigIntMethod(function writeBigInt64BE(value, offset = 0) {
    return $5ed0747d5916bbd8$var$wrtBigUInt64BE(this, value, offset, -BigInt("0x8000000000000000"), BigInt("0x7fffffffffffffff"));
});
function $5ed0747d5916bbd8$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError("Index out of range");
    if (offset < 0) throw new RangeError("Index out of range");
}
function $5ed0747d5916bbd8$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $5ed0747d5916bbd8$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $5WQj6.write(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$5ed0747d5916bbd8$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $5ed0747d5916bbd8$var$writeFloat(this, value, offset, true, noAssert);
};
$5ed0747d5916bbd8$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $5ed0747d5916bbd8$var$writeFloat(this, value, offset, false, noAssert);
};
function $5ed0747d5916bbd8$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $5ed0747d5916bbd8$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $5WQj6.write(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$5ed0747d5916bbd8$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $5ed0747d5916bbd8$var$writeDouble(this, value, offset, true, noAssert);
};
$5ed0747d5916bbd8$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $5ed0747d5916bbd8$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$5ed0747d5916bbd8$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!$5ed0747d5916bbd8$var$Buffer.isBuffer(target)) throw new TypeError("argument should be a Buffer");
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError("targetStart out of bounds");
    if (start < 0 || start >= this.length) throw new RangeError("Index out of range");
    if (end < 0) throw new RangeError("sourceEnd out of bounds");
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    const len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === "function") // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$5ed0747d5916bbd8$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === "string") {
        if (typeof start === "string") {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === "string") {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== "string") throw new TypeError("encoding must be a string");
        if (typeof encoding === "string" && !$5ed0747d5916bbd8$var$Buffer.isEncoding(encoding)) throw new TypeError("Unknown encoding: " + encoding);
        if (val.length === 1) {
            const code = val.charCodeAt(0);
            if (encoding === "utf8" && code < 128 || encoding === "latin1") // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === "number") val = val & 255;
    else if (typeof val === "boolean") val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError("Out of range index");
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    let i;
    if (typeof val === "number") for(i = start; i < end; ++i)this[i] = val;
    else {
        const bytes = $5ed0747d5916bbd8$var$Buffer.isBuffer(val) ? val : $5ed0747d5916bbd8$var$Buffer.from(val, encoding);
        const len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// CUSTOM ERRORS
// =============
// Simplified versions from Node, changed for Buffer-only usage
const $5ed0747d5916bbd8$var$errors = {};
function $5ed0747d5916bbd8$var$E(sym, getMessage, Base) {
    $5ed0747d5916bbd8$var$errors[sym] = class NodeError extends Base {
        constructor(){
            super();
            Object.defineProperty(this, "message", {
                value: getMessage.apply(this, arguments),
                writable: true,
                configurable: true
            });
            // Add the error code to the name to include it in the stack trace.
            this.name = `${this.name} [${sym}]`;
            // Access the stack to generate the error message including the error code
            // from the name.
            this.stack // eslint-disable-line no-unused-expressions
            ;
            // Reset the name to the actual name.
            delete this.name;
        }
        get code() {
            return sym;
        }
        set code(value) {
            Object.defineProperty(this, "code", {
                configurable: true,
                enumerable: true,
                value: value,
                writable: true
            });
        }
        toString() {
            return `${this.name} [${sym}]: ${this.message}`;
        }
    };
}
$5ed0747d5916bbd8$var$E("ERR_BUFFER_OUT_OF_BOUNDS", function(name) {
    if (name) return `${name} is outside of buffer bounds`;
    return "Attempt to access memory outside buffer bounds";
}, RangeError);
$5ed0747d5916bbd8$var$E("ERR_INVALID_ARG_TYPE", function(name, actual) {
    return `The "${name}" argument must be of type number. Received type ${typeof actual}`;
}, TypeError);
$5ed0747d5916bbd8$var$E("ERR_OUT_OF_RANGE", function(str, range, input) {
    let msg = `The value of "${str}" is out of range.`;
    let received = input;
    if (Number.isInteger(input) && Math.abs(input) > 2 ** 32) received = $5ed0747d5916bbd8$var$addNumericalSeparator(String(input));
    else if (typeof input === "bigint") {
        received = String(input);
        if (input > BigInt(2) ** BigInt(32) || input < -(BigInt(2) ** BigInt(32))) received = $5ed0747d5916bbd8$var$addNumericalSeparator(received);
        received += "n";
    }
    msg += ` It must be ${range}. Received ${received}`;
    return msg;
}, RangeError);
function $5ed0747d5916bbd8$var$addNumericalSeparator(val) {
    let res = "";
    let i = val.length;
    const start = val[0] === "-" ? 1 : 0;
    for(; i >= start + 4; i -= 3)res = `_${val.slice(i - 3, i)}${res}`;
    return `${val.slice(0, i)}${res}`;
}
// CHECK FUNCTIONS
// ===============
function $5ed0747d5916bbd8$var$checkBounds(buf, offset, byteLength) {
    $5ed0747d5916bbd8$var$validateNumber(offset, "offset");
    if (buf[offset] === undefined || buf[offset + byteLength] === undefined) $5ed0747d5916bbd8$var$boundsError(offset, buf.length - (byteLength + 1));
}
function $5ed0747d5916bbd8$var$checkIntBI(value, min, max, buf, offset, byteLength) {
    if (value > max || value < min) {
        const n = typeof min === "bigint" ? "n" : "";
        let range;
        if (byteLength > 3) {
            if (min === 0 || min === BigInt(0)) range = `>= 0${n} and < 2${n} ** ${(byteLength + 1) * 8}${n}`;
            else range = `>= -(2${n} ** ${(byteLength + 1) * 8 - 1}${n}) and < 2 ** ` + `${(byteLength + 1) * 8 - 1}${n}`;
        } else range = `>= ${min}${n} and <= ${max}${n}`;
        throw new $5ed0747d5916bbd8$var$errors.ERR_OUT_OF_RANGE("value", range, value);
    }
    $5ed0747d5916bbd8$var$checkBounds(buf, offset, byteLength);
}
function $5ed0747d5916bbd8$var$validateNumber(value, name) {
    if (typeof value !== "number") throw new $5ed0747d5916bbd8$var$errors.ERR_INVALID_ARG_TYPE(name, "number", value);
}
function $5ed0747d5916bbd8$var$boundsError(value, length, type) {
    if (Math.floor(value) !== value) {
        $5ed0747d5916bbd8$var$validateNumber(value, type);
        throw new $5ed0747d5916bbd8$var$errors.ERR_OUT_OF_RANGE(type || "offset", "an integer", value);
    }
    if (length < 0) throw new $5ed0747d5916bbd8$var$errors.ERR_BUFFER_OUT_OF_BOUNDS();
    throw new $5ed0747d5916bbd8$var$errors.ERR_OUT_OF_RANGE(type || "offset", `>= ${type ? 1 : 0} and <= ${length}`, value);
}
// HELPER FUNCTIONS
// ================
const $5ed0747d5916bbd8$var$INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function $5ed0747d5916bbd8$var$base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split("=")[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace($5ed0747d5916bbd8$var$INVALID_BASE64_RE, "");
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return "";
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + "=";
    return str;
}
function $5ed0747d5916bbd8$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    let codePoint;
    const length = string.length;
    let leadSurrogate = null;
    const bytes = [];
    for(let i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error("Invalid code point");
    }
    return bytes;
}
function $5ed0747d5916bbd8$var$asciiToBytes(str) {
    const byteArray = [];
    for(let i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $5ed0747d5916bbd8$var$utf16leToBytes(str, units) {
    let c, hi, lo;
    const byteArray = [];
    for(let i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $5ed0747d5916bbd8$var$base64ToBytes(str) {
    return $hqZtu.toByteArray($5ed0747d5916bbd8$var$base64clean(str));
}
function $5ed0747d5916bbd8$var$blitBuffer(src, dst, offset, length) {
    let i;
    for(i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function $5ed0747d5916bbd8$var$isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function $5ed0747d5916bbd8$var$numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
const $5ed0747d5916bbd8$var$hexSliceLookupTable = function() {
    const alphabet = "0123456789abcdef";
    const table = new Array(256);
    for(let i = 0; i < 16; ++i){
        const i16 = i * 16;
        for(let j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();
// Return not function with Error if BigInt not supported
function $5ed0747d5916bbd8$var$defineBigIntMethod(fn) {
    return typeof BigInt === "undefined" ? $5ed0747d5916bbd8$var$BufferBigIntNotDefined : fn;
}
function $5ed0747d5916bbd8$var$BufferBigIntNotDefined() {
    throw new Error("BigInt not supported");
}


var $eff1b194c9d09a4e$exports = {};
"use strict";
Object.defineProperty($eff1b194c9d09a4e$exports, "__esModule", {
    value: true
});
$eff1b194c9d09a4e$exports.hash_to_ristretto255 = $eff1b194c9d09a4e$exports.hashToRistretto255 = $eff1b194c9d09a4e$exports.RistrettoPoint = $eff1b194c9d09a4e$exports.encodeToCurve = $eff1b194c9d09a4e$exports.hashToCurve = $eff1b194c9d09a4e$exports.edwardsToMontgomeryPriv = $eff1b194c9d09a4e$exports.edwardsToMontgomery = $eff1b194c9d09a4e$exports.edwardsToMontgomeryPub = $eff1b194c9d09a4e$exports.x25519 = $eff1b194c9d09a4e$exports.ed25519ph = $eff1b194c9d09a4e$exports.ed25519ctx = $eff1b194c9d09a4e$exports.ed25519 = $eff1b194c9d09a4e$exports.ED25519_TORSION_SUBGROUP = void 0;

var $fJ9Lg = parcelRequire("fJ9Lg");

var $ebEok = parcelRequire("ebEok");
var $05b353c83d290c67$exports = {};
"use strict";
Object.defineProperty($05b353c83d290c67$exports, "__esModule", {
    value: true
});
$05b353c83d290c67$exports.twistedEdwards = void 0;
var $f4225407683e7e63$exports = {};
"use strict";
Object.defineProperty($f4225407683e7e63$exports, "__esModule", {
    value: true
});
$f4225407683e7e63$exports.mapHashToField = $f4225407683e7e63$exports.getMinHashLength = $f4225407683e7e63$exports.getFieldBytesLength = $f4225407683e7e63$exports.hashToPrivateScalar = $f4225407683e7e63$exports.FpSqrtEven = $f4225407683e7e63$exports.FpSqrtOdd = $f4225407683e7e63$exports.Field = $f4225407683e7e63$exports.nLength = $f4225407683e7e63$exports.FpIsSquare = $f4225407683e7e63$exports.FpDiv = $f4225407683e7e63$exports.FpInvertBatch = $f4225407683e7e63$exports.FpPow = $f4225407683e7e63$exports.validateField = $f4225407683e7e63$exports.isNegativeLE = $f4225407683e7e63$exports.FpSqrt = $f4225407683e7e63$exports.tonelliShanks = $f4225407683e7e63$exports.invert = $f4225407683e7e63$exports.pow2 = $f4225407683e7e63$exports.pow = $f4225407683e7e63$exports.mod = void 0;
var $a53222754f250272$exports = {};
"use strict";
Object.defineProperty($a53222754f250272$exports, "__esModule", {
    value: true
});
$a53222754f250272$exports.validateObject = $a53222754f250272$exports.createHmacDrbg = $a53222754f250272$exports.bitMask = $a53222754f250272$exports.bitSet = $a53222754f250272$exports.bitGet = $a53222754f250272$exports.bitLen = $a53222754f250272$exports.utf8ToBytes = $a53222754f250272$exports.equalBytes = $a53222754f250272$exports.concatBytes = $a53222754f250272$exports.ensureBytes = $a53222754f250272$exports.numberToVarBytesBE = $a53222754f250272$exports.numberToBytesLE = $a53222754f250272$exports.numberToBytesBE = $a53222754f250272$exports.bytesToNumberLE = $a53222754f250272$exports.bytesToNumberBE = $a53222754f250272$exports.hexToBytes = $a53222754f250272$exports.hexToNumber = $a53222754f250272$exports.numberToHexUnpadded = $a53222754f250272$exports.bytesToHex = $a53222754f250272$exports.isBytes = void 0;
/*! noble-curves - MIT License (c) 2022 Paul Miller (paulmillr.com) */ // 100 lines of code in the file are duplicated from noble-hashes (utils).
// This is OK: `abstract` directory does not use noble-hashes.
// User may opt-in into using different hashing library. This way, noble-hashes
// won't be included into their bundle.
const $a53222754f250272$var$_0n = BigInt(0);
const $a53222754f250272$var$_1n = BigInt(1);
const $a53222754f250272$var$_2n = BigInt(2);
function $a53222754f250272$var$isBytes(a) {
    return a instanceof Uint8Array || a != null && typeof a === "object" && a.constructor.name === "Uint8Array";
}
$a53222754f250272$exports.isBytes = $a53222754f250272$var$isBytes;
// Array where index 0xf0 (240) is mapped to string 'f0'
const $a53222754f250272$var$hexes = /* @__PURE__ */ Array.from({
    length: 256
}, (_, i)=>i.toString(16).padStart(2, "0"));
/**
 * @example bytesToHex(Uint8Array.from([0xca, 0xfe, 0x01, 0x23])) // 'cafe0123'
 */ function $a53222754f250272$var$bytesToHex(bytes) {
    if (!$a53222754f250272$var$isBytes(bytes)) throw new Error("Uint8Array expected");
    // pre-caching improves the speed 6x
    let hex = "";
    for(let i = 0; i < bytes.length; i++)hex += $a53222754f250272$var$hexes[bytes[i]];
    return hex;
}
$a53222754f250272$exports.bytesToHex = $a53222754f250272$var$bytesToHex;
function $a53222754f250272$var$numberToHexUnpadded(num) {
    const hex = num.toString(16);
    return hex.length & 1 ? `0${hex}` : hex;
}
$a53222754f250272$exports.numberToHexUnpadded = $a53222754f250272$var$numberToHexUnpadded;
function $a53222754f250272$var$hexToNumber(hex) {
    if (typeof hex !== "string") throw new Error("hex string expected, got " + typeof hex);
    // Big Endian
    return BigInt(hex === "" ? "0" : `0x${hex}`);
}
$a53222754f250272$exports.hexToNumber = $a53222754f250272$var$hexToNumber;
// We use optimized technique to convert hex string to byte array
const $a53222754f250272$var$asciis = {
    _0: 48,
    _9: 57,
    _A: 65,
    _F: 70,
    _a: 97,
    _f: 102
};
function $a53222754f250272$var$asciiToBase16(char) {
    if (char >= $a53222754f250272$var$asciis._0 && char <= $a53222754f250272$var$asciis._9) return char - $a53222754f250272$var$asciis._0;
    if (char >= $a53222754f250272$var$asciis._A && char <= $a53222754f250272$var$asciis._F) return char - ($a53222754f250272$var$asciis._A - 10);
    if (char >= $a53222754f250272$var$asciis._a && char <= $a53222754f250272$var$asciis._f) return char - ($a53222754f250272$var$asciis._a - 10);
    return;
}
/**
 * @example hexToBytes('cafe0123') // Uint8Array.from([0xca, 0xfe, 0x01, 0x23])
 */ function $a53222754f250272$var$hexToBytes(hex) {
    if (typeof hex !== "string") throw new Error("hex string expected, got " + typeof hex);
    const hl = hex.length;
    const al = hl / 2;
    if (hl % 2) throw new Error("padded hex string expected, got unpadded hex of length " + hl);
    const array = new Uint8Array(al);
    for(let ai = 0, hi = 0; ai < al; ai++, hi += 2){
        const n1 = $a53222754f250272$var$asciiToBase16(hex.charCodeAt(hi));
        const n2 = $a53222754f250272$var$asciiToBase16(hex.charCodeAt(hi + 1));
        if (n1 === undefined || n2 === undefined) {
            const char = hex[hi] + hex[hi + 1];
            throw new Error('hex string expected, got non-hex character "' + char + '" at index ' + hi);
        }
        array[ai] = n1 * 16 + n2;
    }
    return array;
}
$a53222754f250272$exports.hexToBytes = $a53222754f250272$var$hexToBytes;
// BE: Big Endian, LE: Little Endian
function $a53222754f250272$var$bytesToNumberBE(bytes) {
    return $a53222754f250272$var$hexToNumber($a53222754f250272$var$bytesToHex(bytes));
}
$a53222754f250272$exports.bytesToNumberBE = $a53222754f250272$var$bytesToNumberBE;
function $a53222754f250272$var$bytesToNumberLE(bytes) {
    if (!$a53222754f250272$var$isBytes(bytes)) throw new Error("Uint8Array expected");
    return $a53222754f250272$var$hexToNumber($a53222754f250272$var$bytesToHex(Uint8Array.from(bytes).reverse()));
}
$a53222754f250272$exports.bytesToNumberLE = $a53222754f250272$var$bytesToNumberLE;
function $a53222754f250272$var$numberToBytesBE(n, len) {
    return $a53222754f250272$var$hexToBytes(n.toString(16).padStart(len * 2, "0"));
}
$a53222754f250272$exports.numberToBytesBE = $a53222754f250272$var$numberToBytesBE;
function $a53222754f250272$var$numberToBytesLE(n, len) {
    return $a53222754f250272$var$numberToBytesBE(n, len).reverse();
}
$a53222754f250272$exports.numberToBytesLE = $a53222754f250272$var$numberToBytesLE;
// Unpadded, rarely used
function $a53222754f250272$var$numberToVarBytesBE(n) {
    return $a53222754f250272$var$hexToBytes($a53222754f250272$var$numberToHexUnpadded(n));
}
$a53222754f250272$exports.numberToVarBytesBE = $a53222754f250272$var$numberToVarBytesBE;
/**
 * Takes hex string or Uint8Array, converts to Uint8Array.
 * Validates output length.
 * Will throw error for other types.
 * @param title descriptive title for an error e.g. 'private key'
 * @param hex hex string or Uint8Array
 * @param expectedLength optional, will compare to result array's length
 * @returns
 */ function $a53222754f250272$var$ensureBytes(title, hex, expectedLength) {
    let res;
    if (typeof hex === "string") try {
        res = $a53222754f250272$var$hexToBytes(hex);
    } catch (e) {
        throw new Error(`${title} must be valid hex string, got "${hex}". Cause: ${e}`);
    }
    else if ($a53222754f250272$var$isBytes(hex)) // Uint8Array.from() instead of hash.slice() because node.js Buffer
    // is instance of Uint8Array, and its slice() creates **mutable** copy
    res = Uint8Array.from(hex);
    else throw new Error(`${title} must be hex string or Uint8Array`);
    const len = res.length;
    if (typeof expectedLength === "number" && len !== expectedLength) throw new Error(`${title} expected ${expectedLength} bytes, got ${len}`);
    return res;
}
$a53222754f250272$exports.ensureBytes = $a53222754f250272$var$ensureBytes;
/**
 * Copies several Uint8Arrays into one.
 */ function $a53222754f250272$var$concatBytes(...arrays) {
    let sum = 0;
    for(let i = 0; i < arrays.length; i++){
        const a = arrays[i];
        if (!$a53222754f250272$var$isBytes(a)) throw new Error("Uint8Array expected");
        sum += a.length;
    }
    let res = new Uint8Array(sum);
    let pad = 0;
    for(let i = 0; i < arrays.length; i++){
        const a = arrays[i];
        res.set(a, pad);
        pad += a.length;
    }
    return res;
}
$a53222754f250272$exports.concatBytes = $a53222754f250272$var$concatBytes;
// Compares 2 u8a-s in kinda constant time
function $a53222754f250272$var$equalBytes(a, b) {
    if (a.length !== b.length) return false;
    let diff = 0;
    for(let i = 0; i < a.length; i++)diff |= a[i] ^ b[i];
    return diff === 0;
}
$a53222754f250272$exports.equalBytes = $a53222754f250272$var$equalBytes;
/**
 * @example utf8ToBytes('abc') // new Uint8Array([97, 98, 99])
 */ function $a53222754f250272$var$utf8ToBytes(str) {
    if (typeof str !== "string") throw new Error(`utf8ToBytes expected string, got ${typeof str}`);
    return new Uint8Array(new TextEncoder().encode(str)); // https://bugzil.la/1681809
}
$a53222754f250272$exports.utf8ToBytes = $a53222754f250272$var$utf8ToBytes;
// Bit operations
/**
 * Calculates amount of bits in a bigint.
 * Same as `n.toString(2).length`
 */ function $a53222754f250272$var$bitLen(n) {
    let len;
    for(len = 0; n > $a53222754f250272$var$_0n; n >>= $a53222754f250272$var$_1n, len += 1);
    return len;
}
$a53222754f250272$exports.bitLen = $a53222754f250272$var$bitLen;
/**
 * Gets single bit at position.
 * NOTE: first bit position is 0 (same as arrays)
 * Same as `!!+Array.from(n.toString(2)).reverse()[pos]`
 */ function $a53222754f250272$var$bitGet(n, pos) {
    return n >> BigInt(pos) & $a53222754f250272$var$_1n;
}
$a53222754f250272$exports.bitGet = $a53222754f250272$var$bitGet;
/**
 * Sets single bit at position.
 */ const $a53222754f250272$var$bitSet = (n, pos, value)=>{
    return n | (value ? $a53222754f250272$var$_1n : $a53222754f250272$var$_0n) << BigInt(pos);
};
$a53222754f250272$exports.bitSet = $a53222754f250272$var$bitSet;
/**
 * Calculate mask for N bits. Not using ** operator with bigints because of old engines.
 * Same as BigInt(`0b${Array(i).fill('1').join('')}`)
 */ const $a53222754f250272$var$bitMask = (n)=>($a53222754f250272$var$_2n << BigInt(n - 1)) - $a53222754f250272$var$_1n;
$a53222754f250272$exports.bitMask = $a53222754f250272$var$bitMask;
// DRBG
const $a53222754f250272$var$u8n = (data)=>new Uint8Array(data); // creates Uint8Array
const $a53222754f250272$var$u8fr = (arr)=>Uint8Array.from(arr); // another shortcut
/**
 * Minimal HMAC-DRBG from NIST 800-90 for RFC6979 sigs.
 * @returns function that will call DRBG until 2nd arg returns something meaningful
 * @example
 *   const drbg = createHmacDRBG<Key>(32, 32, hmac);
 *   drbg(seed, bytesToKey); // bytesToKey must return Key or undefined
 */ function $a53222754f250272$var$createHmacDrbg(hashLen, qByteLen, hmacFn) {
    if (typeof hashLen !== "number" || hashLen < 2) throw new Error("hashLen must be a number");
    if (typeof qByteLen !== "number" || qByteLen < 2) throw new Error("qByteLen must be a number");
    if (typeof hmacFn !== "function") throw new Error("hmacFn must be a function");
    // Step B, Step C: set hashLen to 8*ceil(hlen/8)
    let v = $a53222754f250272$var$u8n(hashLen); // Minimal non-full-spec HMAC-DRBG from NIST 800-90 for RFC6979 sigs.
    let k = $a53222754f250272$var$u8n(hashLen); // Steps B and C of RFC6979 3.2: set hashLen, in our case always same
    let i = 0; // Iterations counter, will throw when over 1000
    const reset = ()=>{
        v.fill(1);
        k.fill(0);
        i = 0;
    };
    const h = (...b)=>hmacFn(k, v, ...b); // hmac(k)(v, ...values)
    const reseed = (seed = $a53222754f250272$var$u8n())=>{
        // HMAC-DRBG reseed() function. Steps D-G
        k = h($a53222754f250272$var$u8fr([
            0x00
        ]), seed); // k = hmac(k || v || 0x00 || seed)
        v = h(); // v = hmac(k || v)
        if (seed.length === 0) return;
        k = h($a53222754f250272$var$u8fr([
            0x01
        ]), seed); // k = hmac(k || v || 0x01 || seed)
        v = h(); // v = hmac(k || v)
    };
    const gen = ()=>{
        // HMAC-DRBG generate() function
        if (i++ >= 1000) throw new Error("drbg: tried 1000 values");
        let len = 0;
        const out = [];
        while(len < qByteLen){
            v = h();
            const sl = v.slice();
            out.push(sl);
            len += v.length;
        }
        return $a53222754f250272$var$concatBytes(...out);
    };
    const genUntil = (seed, pred)=>{
        reset();
        reseed(seed); // Steps D-G
        let res = undefined; // Step H: grind until k is in [1..n-1]
        while(!(res = pred(gen())))reseed();
        reset();
        return res;
    };
    return genUntil;
}
$a53222754f250272$exports.createHmacDrbg = $a53222754f250272$var$createHmacDrbg;
// Validating curves and fields
const $a53222754f250272$var$validatorFns = {
    bigint: (val)=>typeof val === "bigint",
    function: (val)=>typeof val === "function",
    boolean: (val)=>typeof val === "boolean",
    string: (val)=>typeof val === "string",
    stringOrUint8Array: (val)=>typeof val === "string" || $a53222754f250272$var$isBytes(val),
    isSafeInteger: (val)=>Number.isSafeInteger(val),
    array: (val)=>Array.isArray(val),
    field: (val, object)=>object.Fp.isValid(val),
    hash: (val)=>typeof val === "function" && Number.isSafeInteger(val.outputLen)
};
// type Record<K extends string | number | symbol, T> = { [P in K]: T; }
function $a53222754f250272$var$validateObject(object, validators, optValidators = {}) {
    const checkField = (fieldName, type, isOptional)=>{
        const checkVal = $a53222754f250272$var$validatorFns[type];
        if (typeof checkVal !== "function") throw new Error(`Invalid validator "${type}", expected function`);
        const val = object[fieldName];
        if (isOptional && val === undefined) return;
        if (!checkVal(val, object)) throw new Error(`Invalid param ${String(fieldName)}=${val} (${typeof val}), expected ${type}`);
    };
    for (const [fieldName, type] of Object.entries(validators))checkField(fieldName, type, false);
    for (const [fieldName, type] of Object.entries(optValidators))checkField(fieldName, type, true);
    return object;
}
$a53222754f250272$exports.validateObject = $a53222754f250272$var$validateObject; // validate type tests
 // const o: { a: number; b: number; c: number } = { a: 1, b: 5, c: 6 };
 // const z0 = validateObject(o, { a: 'isSafeInteger' }, { c: 'bigint' }); // Ok!
 // // Should fail type-check
 // const z1 = validateObject(o, { a: 'tmp' }, { c: 'zz' });
 // const z2 = validateObject(o, { a: 'isSafeInteger' }, { c: 'zz' });
 // const z3 = validateObject(o, { test: 'boolean', z: 'bug' });
 // const z4 = validateObject(o, { a: 'boolean', z: 'bug' });


// prettier-ignore
const $f4225407683e7e63$var$_0n = BigInt(0), $f4225407683e7e63$var$_1n = BigInt(1), $f4225407683e7e63$var$_2n = BigInt(2), $f4225407683e7e63$var$_3n = BigInt(3);
// prettier-ignore
const $f4225407683e7e63$var$_4n = BigInt(4), $f4225407683e7e63$var$_5n = BigInt(5), $f4225407683e7e63$var$_8n = BigInt(8);
// prettier-ignore
const $f4225407683e7e63$var$_9n = BigInt(9), $f4225407683e7e63$var$_16n = BigInt(16);
// Calculates a modulo b
function $f4225407683e7e63$var$mod(a, b) {
    const result = a % b;
    return result >= $f4225407683e7e63$var$_0n ? result : b + result;
}
$f4225407683e7e63$exports.mod = $f4225407683e7e63$var$mod;
/**
 * Efficiently raise num to power and do modular division.
 * Unsafe in some contexts: uses ladder, so can expose bigint bits.
 * @example
 * pow(2n, 6n, 11n) // 64n % 11n == 9n
 */ // TODO: use field version && remove
function $f4225407683e7e63$var$pow(num, power, modulo) {
    if (modulo <= $f4225407683e7e63$var$_0n || power < $f4225407683e7e63$var$_0n) throw new Error("Expected power/modulo > 0");
    if (modulo === $f4225407683e7e63$var$_1n) return $f4225407683e7e63$var$_0n;
    let res = $f4225407683e7e63$var$_1n;
    while(power > $f4225407683e7e63$var$_0n){
        if (power & $f4225407683e7e63$var$_1n) res = res * num % modulo;
        num = num * num % modulo;
        power >>= $f4225407683e7e63$var$_1n;
    }
    return res;
}
$f4225407683e7e63$exports.pow = $f4225407683e7e63$var$pow;
// Does x ^ (2 ^ power) mod p. pow2(30, 4) == 30 ^ (2 ^ 4)
function $f4225407683e7e63$var$pow2(x, power, modulo) {
    let res = x;
    while(power-- > $f4225407683e7e63$var$_0n){
        res *= res;
        res %= modulo;
    }
    return res;
}
$f4225407683e7e63$exports.pow2 = $f4225407683e7e63$var$pow2;
// Inverses number over modulo
function $f4225407683e7e63$var$invert(number, modulo) {
    if (number === $f4225407683e7e63$var$_0n || modulo <= $f4225407683e7e63$var$_0n) throw new Error(`invert: expected positive integers, got n=${number} mod=${modulo}`);
    // Euclidean GCD https://brilliant.org/wiki/extended-euclidean-algorithm/
    // Fermat's little theorem "CT-like" version inv(n) = n^(m-2) mod m is 30x slower.
    let a = $f4225407683e7e63$var$mod(number, modulo);
    let b = modulo;
    // prettier-ignore
    let x = $f4225407683e7e63$var$_0n, y = $f4225407683e7e63$var$_1n, u = $f4225407683e7e63$var$_1n, v = $f4225407683e7e63$var$_0n;
    while(a !== $f4225407683e7e63$var$_0n){
        // JIT applies optimization if those two lines follow each other
        const q = b / a;
        const r = b % a;
        const m = x - u * q;
        const n = y - v * q;
        // prettier-ignore
        b = a, a = r, x = u, y = v, u = m, v = n;
    }
    const gcd = b;
    if (gcd !== $f4225407683e7e63$var$_1n) throw new Error("invert: does not exist");
    return $f4225407683e7e63$var$mod(x, modulo);
}
$f4225407683e7e63$exports.invert = $f4225407683e7e63$var$invert;
/**
 * Tonelli-Shanks square root search algorithm.
 * 1. https://eprint.iacr.org/2012/685.pdf (page 12)
 * 2. Square Roots from 1; 24, 51, 10 to Dan Shanks
 * Will start an infinite loop if field order P is not prime.
 * @param P field order
 * @returns function that takes field Fp (created from P) and number n
 */ function $f4225407683e7e63$var$tonelliShanks(P) {
    // Legendre constant: used to calculate Legendre symbol (a | p),
    // which denotes the value of a^((p-1)/2) (mod p).
    // (a | p) ≡ 1    if a is a square (mod p)
    // (a | p) ≡ -1   if a is not a square (mod p)
    // (a | p) ≡ 0    if a ≡ 0 (mod p)
    const legendreC = (P - $f4225407683e7e63$var$_1n) / $f4225407683e7e63$var$_2n;
    let Q, S, Z;
    // Step 1: By factoring out powers of 2 from p - 1,
    // find q and s such that p - 1 = q*(2^s) with q odd
    for(Q = P - $f4225407683e7e63$var$_1n, S = 0; Q % $f4225407683e7e63$var$_2n === $f4225407683e7e63$var$_0n; Q /= $f4225407683e7e63$var$_2n, S++);
    // Step 2: Select a non-square z such that (z | p) ≡ -1 and set c ≡ zq
    for(Z = $f4225407683e7e63$var$_2n; Z < P && $f4225407683e7e63$var$pow(Z, legendreC, P) !== P - $f4225407683e7e63$var$_1n; Z++);
    // Fast-path
    if (S === 1) {
        const p1div4 = (P + $f4225407683e7e63$var$_1n) / $f4225407683e7e63$var$_4n;
        return function tonelliFast(Fp, n) {
            const root = Fp.pow(n, p1div4);
            if (!Fp.eql(Fp.sqr(root), n)) throw new Error("Cannot find square root");
            return root;
        };
    }
    // Slow-path
    const Q1div2 = (Q + $f4225407683e7e63$var$_1n) / $f4225407683e7e63$var$_2n;
    return function tonelliSlow(Fp, n) {
        // Step 0: Check that n is indeed a square: (n | p) should not be ≡ -1
        if (Fp.pow(n, legendreC) === Fp.neg(Fp.ONE)) throw new Error("Cannot find square root");
        let r = S;
        // TODO: will fail at Fp2/etc
        let g = Fp.pow(Fp.mul(Fp.ONE, Z), Q); // will update both x and b
        let x = Fp.pow(n, Q1div2); // first guess at the square root
        let b = Fp.pow(n, Q); // first guess at the fudge factor
        while(!Fp.eql(b, Fp.ONE)){
            if (Fp.eql(b, Fp.ZERO)) return Fp.ZERO; // https://en.wikipedia.org/wiki/Tonelli%E2%80%93Shanks_algorithm (4. If t = 0, return r = 0)
            // Find m such b^(2^m)==1
            let m = 1;
            for(let t2 = Fp.sqr(b); m < r; m++){
                if (Fp.eql(t2, Fp.ONE)) break;
                t2 = Fp.sqr(t2); // t2 *= t2
            }
            // NOTE: r-m-1 can be bigger than 32, need to convert to bigint before shift, otherwise there will be overflow
            const ge = Fp.pow(g, $f4225407683e7e63$var$_1n << BigInt(r - m - 1)); // ge = 2^(r-m-1)
            g = Fp.sqr(ge); // g = ge * ge
            x = Fp.mul(x, ge); // x *= ge
            b = Fp.mul(b, g); // b *= g
            r = m;
        }
        return x;
    };
}
$f4225407683e7e63$exports.tonelliShanks = $f4225407683e7e63$var$tonelliShanks;
function $f4225407683e7e63$var$FpSqrt(P) {
    // NOTE: different algorithms can give different roots, it is up to user to decide which one they want.
    // For example there is FpSqrtOdd/FpSqrtEven to choice root based on oddness (used for hash-to-curve).
    // P ≡ 3 (mod 4)
    // √n = n^((P+1)/4)
    if (P % $f4225407683e7e63$var$_4n === $f4225407683e7e63$var$_3n) {
        // Not all roots possible!
        // const ORDER =
        //   0x1a0111ea397fe69a4b1ba7b6434bacd764774b84f38512bf6730d2a0f6b0f6241eabfffeb153ffffb9feffffffffaaabn;
        // const NUM = 72057594037927816n;
        const p1div4 = (P + $f4225407683e7e63$var$_1n) / $f4225407683e7e63$var$_4n;
        return function sqrt3mod4(Fp, n) {
            const root = Fp.pow(n, p1div4);
            // Throw if root**2 != n
            if (!Fp.eql(Fp.sqr(root), n)) throw new Error("Cannot find square root");
            return root;
        };
    }
    // Atkin algorithm for q ≡ 5 (mod 8), https://eprint.iacr.org/2012/685.pdf (page 10)
    if (P % $f4225407683e7e63$var$_8n === $f4225407683e7e63$var$_5n) {
        const c1 = (P - $f4225407683e7e63$var$_5n) / $f4225407683e7e63$var$_8n;
        return function sqrt5mod8(Fp, n) {
            const n2 = Fp.mul(n, $f4225407683e7e63$var$_2n);
            const v = Fp.pow(n2, c1);
            const nv = Fp.mul(n, v);
            const i = Fp.mul(Fp.mul(nv, $f4225407683e7e63$var$_2n), v);
            const root = Fp.mul(nv, Fp.sub(i, Fp.ONE));
            if (!Fp.eql(Fp.sqr(root), n)) throw new Error("Cannot find square root");
            return root;
        };
    }
    $f4225407683e7e63$var$_9n;
    // Other cases: Tonelli-Shanks algorithm
    return $f4225407683e7e63$var$tonelliShanks(P);
}
$f4225407683e7e63$exports.FpSqrt = $f4225407683e7e63$var$FpSqrt;
// Little-endian check for first LE bit (last BE bit);
const $f4225407683e7e63$var$isNegativeLE = (num, modulo)=>($f4225407683e7e63$var$mod(num, modulo) & $f4225407683e7e63$var$_1n) === $f4225407683e7e63$var$_1n;
$f4225407683e7e63$exports.isNegativeLE = $f4225407683e7e63$var$isNegativeLE;
// prettier-ignore
const $f4225407683e7e63$var$FIELD_FIELDS = [
    "create",
    "isValid",
    "is0",
    "neg",
    "inv",
    "sqrt",
    "sqr",
    "eql",
    "add",
    "sub",
    "mul",
    "pow",
    "div",
    "addN",
    "subN",
    "mulN",
    "sqrN"
];
function $f4225407683e7e63$var$validateField(field) {
    const initial = {
        ORDER: "bigint",
        MASK: "bigint",
        BYTES: "isSafeInteger",
        BITS: "isSafeInteger"
    };
    const opts = $f4225407683e7e63$var$FIELD_FIELDS.reduce((map, val)=>{
        map[val] = "function";
        return map;
    }, initial);
    return (0, $a53222754f250272$exports.validateObject)(field, opts);
}
$f4225407683e7e63$exports.validateField = $f4225407683e7e63$var$validateField;
// Generic field functions
/**
 * Same as `pow` but for Fp: non-constant-time.
 * Unsafe in some contexts: uses ladder, so can expose bigint bits.
 */ function $f4225407683e7e63$var$FpPow(f, num, power) {
    // Should have same speed as pow for bigints
    // TODO: benchmark!
    if (power < $f4225407683e7e63$var$_0n) throw new Error("Expected power > 0");
    if (power === $f4225407683e7e63$var$_0n) return f.ONE;
    if (power === $f4225407683e7e63$var$_1n) return num;
    let p = f.ONE;
    let d = num;
    while(power > $f4225407683e7e63$var$_0n){
        if (power & $f4225407683e7e63$var$_1n) p = f.mul(p, d);
        d = f.sqr(d);
        power >>= $f4225407683e7e63$var$_1n;
    }
    return p;
}
$f4225407683e7e63$exports.FpPow = $f4225407683e7e63$var$FpPow;
/**
 * Efficiently invert an array of Field elements.
 * `inv(0)` will return `undefined` here: make sure to throw an error.
 */ function $f4225407683e7e63$var$FpInvertBatch(f, nums) {
    const tmp = new Array(nums.length);
    // Walk from first to last, multiply them by each other MOD p
    const lastMultiplied = nums.reduce((acc, num, i)=>{
        if (f.is0(num)) return acc;
        tmp[i] = acc;
        return f.mul(acc, num);
    }, f.ONE);
    // Invert last element
    const inverted = f.inv(lastMultiplied);
    // Walk from last to first, multiply them by inverted each other MOD p
    nums.reduceRight((acc, num, i)=>{
        if (f.is0(num)) return acc;
        tmp[i] = f.mul(acc, tmp[i]);
        return f.mul(acc, num);
    }, inverted);
    return tmp;
}
$f4225407683e7e63$exports.FpInvertBatch = $f4225407683e7e63$var$FpInvertBatch;
function $f4225407683e7e63$var$FpDiv(f, lhs, rhs) {
    return f.mul(lhs, typeof rhs === "bigint" ? $f4225407683e7e63$var$invert(rhs, f.ORDER) : f.inv(rhs));
}
$f4225407683e7e63$exports.FpDiv = $f4225407683e7e63$var$FpDiv;
// This function returns True whenever the value x is a square in the field F.
function $f4225407683e7e63$var$FpIsSquare(f) {
    const legendreConst = (f.ORDER - $f4225407683e7e63$var$_1n) / $f4225407683e7e63$var$_2n; // Integer arithmetic
    return (x)=>{
        const p = f.pow(x, legendreConst);
        return f.eql(p, f.ZERO) || f.eql(p, f.ONE);
    };
}
$f4225407683e7e63$exports.FpIsSquare = $f4225407683e7e63$var$FpIsSquare;
// CURVE.n lengths
function $f4225407683e7e63$var$nLength(n, nBitLength) {
    // Bit size, byte size of CURVE.n
    const _nBitLength = nBitLength !== undefined ? nBitLength : n.toString(2).length;
    const nByteLength = Math.ceil(_nBitLength / 8);
    return {
        nBitLength: _nBitLength,
        nByteLength: nByteLength
    };
}
$f4225407683e7e63$exports.nLength = $f4225407683e7e63$var$nLength;
/**
 * Initializes a finite field over prime. **Non-primes are not supported.**
 * Do not init in loop: slow. Very fragile: always run a benchmark on a change.
 * Major performance optimizations:
 * * a) denormalized operations like mulN instead of mul
 * * b) same object shape: never add or remove keys
 * * c) Object.freeze
 * @param ORDER prime positive bigint
 * @param bitLen how many bits the field consumes
 * @param isLE (def: false) if encoding / decoding should be in little-endian
 * @param redef optional faster redefinitions of sqrt and other methods
 */ function $f4225407683e7e63$var$Field(ORDER, bitLen, isLE = false, redef = {}) {
    if (ORDER <= $f4225407683e7e63$var$_0n) throw new Error(`Expected Field ORDER > 0, got ${ORDER}`);
    const { nBitLength: BITS, nByteLength: BYTES } = $f4225407683e7e63$var$nLength(ORDER, bitLen);
    if (BYTES > 2048) throw new Error("Field lengths over 2048 bytes are not supported");
    const sqrtP = $f4225407683e7e63$var$FpSqrt(ORDER);
    const f = Object.freeze({
        ORDER: ORDER,
        BITS: BITS,
        BYTES: BYTES,
        MASK: (0, $a53222754f250272$exports.bitMask)(BITS),
        ZERO: $f4225407683e7e63$var$_0n,
        ONE: $f4225407683e7e63$var$_1n,
        create: (num)=>$f4225407683e7e63$var$mod(num, ORDER),
        isValid: (num)=>{
            if (typeof num !== "bigint") throw new Error(`Invalid field element: expected bigint, got ${typeof num}`);
            return $f4225407683e7e63$var$_0n <= num && num < ORDER; // 0 is valid element, but it's not invertible
        },
        is0: (num)=>num === $f4225407683e7e63$var$_0n,
        isOdd: (num)=>(num & $f4225407683e7e63$var$_1n) === $f4225407683e7e63$var$_1n,
        neg: (num)=>$f4225407683e7e63$var$mod(-num, ORDER),
        eql: (lhs, rhs)=>lhs === rhs,
        sqr: (num)=>$f4225407683e7e63$var$mod(num * num, ORDER),
        add: (lhs, rhs)=>$f4225407683e7e63$var$mod(lhs + rhs, ORDER),
        sub: (lhs, rhs)=>$f4225407683e7e63$var$mod(lhs - rhs, ORDER),
        mul: (lhs, rhs)=>$f4225407683e7e63$var$mod(lhs * rhs, ORDER),
        pow: (num, power)=>$f4225407683e7e63$var$FpPow(f, num, power),
        div: (lhs, rhs)=>$f4225407683e7e63$var$mod(lhs * $f4225407683e7e63$var$invert(rhs, ORDER), ORDER),
        // Same as above, but doesn't normalize
        sqrN: (num)=>num * num,
        addN: (lhs, rhs)=>lhs + rhs,
        subN: (lhs, rhs)=>lhs - rhs,
        mulN: (lhs, rhs)=>lhs * rhs,
        inv: (num)=>$f4225407683e7e63$var$invert(num, ORDER),
        sqrt: redef.sqrt || ((n)=>sqrtP(f, n)),
        invertBatch: (lst)=>$f4225407683e7e63$var$FpInvertBatch(f, lst),
        // TODO: do we really need constant cmov?
        // We don't have const-time bigints anyway, so probably will be not very useful
        cmov: (a, b, c)=>c ? b : a,
        toBytes: (num)=>isLE ? (0, $a53222754f250272$exports.numberToBytesLE)(num, BYTES) : (0, $a53222754f250272$exports.numberToBytesBE)(num, BYTES),
        fromBytes: (bytes)=>{
            if (bytes.length !== BYTES) throw new Error(`Fp.fromBytes: expected ${BYTES}, got ${bytes.length}`);
            return isLE ? (0, $a53222754f250272$exports.bytesToNumberLE)(bytes) : (0, $a53222754f250272$exports.bytesToNumberBE)(bytes);
        }
    });
    return Object.freeze(f);
}
$f4225407683e7e63$exports.Field = $f4225407683e7e63$var$Field;
function $f4225407683e7e63$var$FpSqrtOdd(Fp, elm) {
    if (!Fp.isOdd) throw new Error(`Field doesn't have isOdd`);
    const root = Fp.sqrt(elm);
    return Fp.isOdd(root) ? root : Fp.neg(root);
}
$f4225407683e7e63$exports.FpSqrtOdd = $f4225407683e7e63$var$FpSqrtOdd;
function $f4225407683e7e63$var$FpSqrtEven(Fp, elm) {
    if (!Fp.isOdd) throw new Error(`Field doesn't have isOdd`);
    const root = Fp.sqrt(elm);
    return Fp.isOdd(root) ? Fp.neg(root) : root;
}
$f4225407683e7e63$exports.FpSqrtEven = $f4225407683e7e63$var$FpSqrtEven;
/**
 * "Constant-time" private key generation utility.
 * Same as mapKeyToField, but accepts less bytes (40 instead of 48 for 32-byte field).
 * Which makes it slightly more biased, less secure.
 * @deprecated use mapKeyToField instead
 */ function $f4225407683e7e63$var$hashToPrivateScalar(hash, groupOrder, isLE = false) {
    hash = (0, $a53222754f250272$exports.ensureBytes)("privateHash", hash);
    const hashLen = hash.length;
    const minLen = $f4225407683e7e63$var$nLength(groupOrder).nByteLength + 8;
    if (minLen < 24 || hashLen < minLen || hashLen > 1024) throw new Error(`hashToPrivateScalar: expected ${minLen}-1024 bytes of input, got ${hashLen}`);
    const num = isLE ? (0, $a53222754f250272$exports.bytesToNumberLE)(hash) : (0, $a53222754f250272$exports.bytesToNumberBE)(hash);
    return $f4225407683e7e63$var$mod(num, groupOrder - $f4225407683e7e63$var$_1n) + $f4225407683e7e63$var$_1n;
}
$f4225407683e7e63$exports.hashToPrivateScalar = $f4225407683e7e63$var$hashToPrivateScalar;
/**
 * Returns total number of bytes consumed by the field element.
 * For example, 32 bytes for usual 256-bit weierstrass curve.
 * @param fieldOrder number of field elements, usually CURVE.n
 * @returns byte length of field
 */ function $f4225407683e7e63$var$getFieldBytesLength(fieldOrder) {
    if (typeof fieldOrder !== "bigint") throw new Error("field order must be bigint");
    const bitLength = fieldOrder.toString(2).length;
    return Math.ceil(bitLength / 8);
}
$f4225407683e7e63$exports.getFieldBytesLength = $f4225407683e7e63$var$getFieldBytesLength;
/**
 * Returns minimal amount of bytes that can be safely reduced
 * by field order.
 * Should be 2^-128 for 128-bit curve such as P256.
 * @param fieldOrder number of field elements, usually CURVE.n
 * @returns byte length of target hash
 */ function $f4225407683e7e63$var$getMinHashLength(fieldOrder) {
    const length = $f4225407683e7e63$var$getFieldBytesLength(fieldOrder);
    return length + Math.ceil(length / 2);
}
$f4225407683e7e63$exports.getMinHashLength = $f4225407683e7e63$var$getMinHashLength;
/**
 * "Constant-time" private key generation utility.
 * Can take (n + n/2) or more bytes of uniform input e.g. from CSPRNG or KDF
 * and convert them into private scalar, with the modulo bias being negligible.
 * Needs at least 48 bytes of input for 32-byte private key.
 * https://research.kudelskisecurity.com/2020/07/28/the-definitive-guide-to-modulo-bias-and-how-to-avoid-it/
 * FIPS 186-5, A.2 https://csrc.nist.gov/publications/detail/fips/186/5/final
 * RFC 9380, https://www.rfc-editor.org/rfc/rfc9380#section-5
 * @param hash hash output from SHA3 or a similar function
 * @param groupOrder size of subgroup - (e.g. secp256k1.CURVE.n)
 * @param isLE interpret hash bytes as LE num
 * @returns valid private scalar
 */ function $f4225407683e7e63$var$mapHashToField(key, fieldOrder, isLE = false) {
    const len = key.length;
    const fieldLen = $f4225407683e7e63$var$getFieldBytesLength(fieldOrder);
    const minLen = $f4225407683e7e63$var$getMinHashLength(fieldOrder);
    // No small numbers: need to understand bias story. No huge numbers: easier to detect JS timings.
    if (len < 16 || len < minLen || len > 1024) throw new Error(`expected ${minLen}-1024 bytes of input, got ${len}`);
    const num = isLE ? (0, $a53222754f250272$exports.bytesToNumberBE)(key) : (0, $a53222754f250272$exports.bytesToNumberLE)(key);
    // `mod(x, 11)` can sometimes produce 0. `mod(x, 10) + 1` is the same, but no 0
    const reduced = $f4225407683e7e63$var$mod(num, fieldOrder - $f4225407683e7e63$var$_1n) + $f4225407683e7e63$var$_1n;
    return isLE ? (0, $a53222754f250272$exports.numberToBytesLE)(reduced, fieldLen) : (0, $a53222754f250272$exports.numberToBytesBE)(reduced, fieldLen);
}
$f4225407683e7e63$exports.mapHashToField = $f4225407683e7e63$var$mapHashToField;




var $3754823f21a54f54$exports = {};
"use strict";
Object.defineProperty($3754823f21a54f54$exports, "__esModule", {
    value: true
});
$3754823f21a54f54$exports.validateBasic = $3754823f21a54f54$exports.wNAF = void 0;


const $3754823f21a54f54$var$_0n = BigInt(0);
const $3754823f21a54f54$var$_1n = BigInt(1);
// Elliptic curve multiplication of Point by scalar. Fragile.
// Scalars should always be less than curve order: this should be checked inside of a curve itself.
// Creates precomputation tables for fast multiplication:
// - private scalar is split by fixed size windows of W bits
// - every window point is collected from window's table & added to accumulator
// - since windows are different, same point inside tables won't be accessed more than once per calc
// - each multiplication is 'Math.ceil(CURVE_ORDER / 𝑊) + 1' point additions (fixed for any scalar)
// - +1 window is neccessary for wNAF
// - wNAF reduces table size: 2x less memory + 2x faster generation, but 10% slower multiplication
// TODO: Research returning 2d JS array of windows, instead of a single window. This would allow
// windows to be in different memory locations
function $3754823f21a54f54$var$wNAF(c, bits) {
    const constTimeNegate = (condition, item)=>{
        const neg = item.negate();
        return condition ? neg : item;
    };
    const opts = (W)=>{
        const windows = Math.ceil(bits / W) + 1; // +1, because
        const windowSize = 2 ** (W - 1); // -1 because we skip zero
        return {
            windows: windows,
            windowSize: windowSize
        };
    };
    return {
        constTimeNegate: constTimeNegate,
        // non-const time multiplication ladder
        unsafeLadder (elm, n) {
            let p = c.ZERO;
            let d = elm;
            while(n > $3754823f21a54f54$var$_0n){
                if (n & $3754823f21a54f54$var$_1n) p = p.add(d);
                d = d.double();
                n >>= $3754823f21a54f54$var$_1n;
            }
            return p;
        },
        /**
         * Creates a wNAF precomputation window. Used for caching.
         * Default window size is set by `utils.precompute()` and is equal to 8.
         * Number of precomputed points depends on the curve size:
         * 2^(𝑊−1) * (Math.ceil(𝑛 / 𝑊) + 1), where:
         * - 𝑊 is the window size
         * - 𝑛 is the bitlength of the curve order.
         * For a 256-bit curve and window size 8, the number of precomputed points is 128 * 33 = 4224.
         * @returns precomputed point tables flattened to a single array
         */ precomputeWindow (elm, W) {
            const { windows: windows, windowSize: windowSize } = opts(W);
            const points = [];
            let p = elm;
            let base = p;
            for(let window = 0; window < windows; window++){
                base = p;
                points.push(base);
                // =1, because we skip zero
                for(let i = 1; i < windowSize; i++){
                    base = base.add(p);
                    points.push(base);
                }
                p = base.double();
            }
            return points;
        },
        /**
         * Implements ec multiplication using precomputed tables and w-ary non-adjacent form.
         * @param W window size
         * @param precomputes precomputed tables
         * @param n scalar (we don't check here, but should be less than curve order)
         * @returns real and fake (for const-time) points
         */ wNAF (W, precomputes, n) {
            // TODO: maybe check that scalar is less than group order? wNAF behavious is undefined otherwise
            // But need to carefully remove other checks before wNAF. ORDER == bits here
            const { windows: windows, windowSize: windowSize } = opts(W);
            let p = c.ZERO;
            let f = c.BASE;
            const mask = BigInt(2 ** W - 1); // Create mask with W ones: 0b1111 for W=4 etc.
            const maxNumber = 2 ** W;
            const shiftBy = BigInt(W);
            for(let window = 0; window < windows; window++){
                const offset = window * windowSize;
                // Extract W bits.
                let wbits = Number(n & mask);
                // Shift number by W bits.
                n >>= shiftBy;
                // If the bits are bigger than max size, we'll split those.
                // +224 => 256 - 32
                if (wbits > windowSize) {
                    wbits -= maxNumber;
                    n += $3754823f21a54f54$var$_1n;
                }
                // This code was first written with assumption that 'f' and 'p' will never be infinity point:
                // since each addition is multiplied by 2 ** W, it cannot cancel each other. However,
                // there is negate now: it is possible that negated element from low value
                // would be the same as high element, which will create carry into next window.
                // It's not obvious how this can fail, but still worth investigating later.
                // Check if we're onto Zero point.
                // Add random point inside current window to f.
                const offset1 = offset;
                const offset2 = offset + Math.abs(wbits) - 1; // -1 because we skip zero
                const cond1 = window % 2 !== 0;
                const cond2 = wbits < 0;
                if (wbits === 0) // The most important part for const-time getPublicKey
                f = f.add(constTimeNegate(cond1, precomputes[offset1]));
                else p = p.add(constTimeNegate(cond2, precomputes[offset2]));
            }
            // JIT-compiler should not eliminate f here, since it will later be used in normalizeZ()
            // Even if the variable is still unused, there are some checks which will
            // throw an exception, so compiler needs to prove they won't happen, which is hard.
            // At this point there is a way to F be infinity-point even if p is not,
            // which makes it less const-time: around 1 bigint multiply.
            return {
                p: p,
                f: f
            };
        },
        wNAFCached (P, precomputesMap, n, transform) {
            // @ts-ignore
            const W = P._WINDOW_SIZE || 1;
            // Calculate precomputes on a first run, reuse them after
            let comp = precomputesMap.get(P);
            if (!comp) {
                comp = this.precomputeWindow(P, W);
                if (W !== 1) precomputesMap.set(P, transform(comp));
            }
            return this.wNAF(W, comp, n);
        }
    };
}
$3754823f21a54f54$exports.wNAF = $3754823f21a54f54$var$wNAF;
function $3754823f21a54f54$var$validateBasic(curve) {
    (0, $f4225407683e7e63$exports.validateField)(curve.Fp);
    (0, $a53222754f250272$exports.validateObject)(curve, {
        n: "bigint",
        h: "bigint",
        Gx: "field",
        Gy: "field"
    }, {
        nBitLength: "isSafeInteger",
        nByteLength: "isSafeInteger"
    });
    // Set defaults
    return Object.freeze({
        ...(0, $f4225407683e7e63$exports.nLength)(curve.n, curve.nBitLength),
        ...curve,
        p: curve.Fp.ORDER
    });
}
$3754823f21a54f54$exports.validateBasic = $3754823f21a54f54$var$validateBasic;


// Be friendly to bad ECMAScript parsers by not using bigint literals
// prettier-ignore
const $05b353c83d290c67$var$_0n = BigInt(0), $05b353c83d290c67$var$_1n = BigInt(1), $05b353c83d290c67$var$_2n = BigInt(2), $05b353c83d290c67$var$_8n = BigInt(8);
// verification rule is either zip215 or rfc8032 / nist186-5. Consult fromHex:
const $05b353c83d290c67$var$VERIFY_DEFAULT = {
    zip215: true
};
function $05b353c83d290c67$var$validateOpts(curve) {
    const opts = (0, $3754823f21a54f54$exports.validateBasic)(curve);
    $a53222754f250272$exports.validateObject(curve, {
        hash: "function",
        a: "bigint",
        d: "bigint",
        randomBytes: "function"
    }, {
        adjustScalarBytes: "function",
        domain: "function",
        uvRatio: "function",
        mapToCurve: "function"
    });
    // Set defaults
    return Object.freeze({
        ...opts
    });
}
// It is not generic twisted curve for now, but ed25519/ed448 generic implementation
function $05b353c83d290c67$var$twistedEdwards(curveDef) {
    const CURVE = $05b353c83d290c67$var$validateOpts(curveDef);
    const { Fp: Fp, n: CURVE_ORDER, prehash: prehash, hash: cHash, randomBytes: randomBytes, nByteLength: nByteLength, h: cofactor } = CURVE;
    const MASK = $05b353c83d290c67$var$_2n << BigInt(nByteLength * 8) - $05b353c83d290c67$var$_1n;
    const modP = Fp.create; // Function overrides
    // sqrt(u/v)
    const uvRatio = CURVE.uvRatio || ((u, v)=>{
        try {
            return {
                isValid: true,
                value: Fp.sqrt(u * Fp.inv(v))
            };
        } catch (e) {
            return {
                isValid: false,
                value: $05b353c83d290c67$var$_0n
            };
        }
    });
    const adjustScalarBytes = CURVE.adjustScalarBytes || ((bytes)=>bytes); // NOOP
    const domain = CURVE.domain || ((data, ctx, phflag)=>{
        if (ctx.length || phflag) throw new Error("Contexts/pre-hash are not supported");
        return data;
    }); // NOOP
    const inBig = (n)=>typeof n === "bigint" && $05b353c83d290c67$var$_0n < n; // n in [1..]
    const inRange = (n, max)=>inBig(n) && inBig(max) && n < max; // n in [1..max-1]
    const in0MaskRange = (n)=>n === $05b353c83d290c67$var$_0n || inRange(n, MASK); // n in [0..MASK-1]
    function assertInRange(n, max) {
        // n in [1..max-1]
        if (inRange(n, max)) return n;
        throw new Error(`Expected valid scalar < ${max}, got ${typeof n} ${n}`);
    }
    function assertGE0(n) {
        // n in [0..CURVE_ORDER-1]
        return n === $05b353c83d290c67$var$_0n ? n : assertInRange(n, CURVE_ORDER); // GE = prime subgroup, not full group
    }
    const pointPrecomputes = new Map();
    function isPoint(other) {
        if (!(other instanceof Point)) throw new Error("ExtendedPoint expected");
    }
    // Extended Point works in extended coordinates: (x, y, z, t) ∋ (x=x/z, y=y/z, t=xy).
    // https://en.wikipedia.org/wiki/Twisted_Edwards_curve#Extended_coordinates
    class Point {
        constructor(ex, ey, ez, et){
            this.ex = ex;
            this.ey = ey;
            this.ez = ez;
            this.et = et;
            if (!in0MaskRange(ex)) throw new Error("x required");
            if (!in0MaskRange(ey)) throw new Error("y required");
            if (!in0MaskRange(ez)) throw new Error("z required");
            if (!in0MaskRange(et)) throw new Error("t required");
        }
        get x() {
            return this.toAffine().x;
        }
        get y() {
            return this.toAffine().y;
        }
        static fromAffine(p) {
            if (p instanceof Point) throw new Error("extended point not allowed");
            const { x: x, y: y } = p || {};
            if (!in0MaskRange(x) || !in0MaskRange(y)) throw new Error("invalid affine point");
            return new Point(x, y, $05b353c83d290c67$var$_1n, modP(x * y));
        }
        static normalizeZ(points) {
            const toInv = Fp.invertBatch(points.map((p)=>p.ez));
            return points.map((p, i)=>p.toAffine(toInv[i])).map(Point.fromAffine);
        }
        // "Private method", don't use it directly
        _setWindowSize(windowSize) {
            this._WINDOW_SIZE = windowSize;
            pointPrecomputes.delete(this);
        }
        // Not required for fromHex(), which always creates valid points.
        // Could be useful for fromAffine().
        assertValidity() {
            const { a: a, d: d } = CURVE;
            if (this.is0()) throw new Error("bad point: ZERO"); // TODO: optimize, with vars below?
            // Equation in affine coordinates: ax² + y² = 1 + dx²y²
            // Equation in projective coordinates (X/Z, Y/Z, Z):  (aX² + Y²)Z² = Z⁴ + dX²Y²
            const { ex: X, ey: Y, ez: Z, et: T } = this;
            const X2 = modP(X * X); // X²
            const Y2 = modP(Y * Y); // Y²
            const Z2 = modP(Z * Z); // Z²
            const Z4 = modP(Z2 * Z2); // Z⁴
            const aX2 = modP(X2 * a); // aX²
            const left = modP(Z2 * modP(aX2 + Y2)); // (aX² + Y²)Z²
            const right = modP(Z4 + modP(d * modP(X2 * Y2))); // Z⁴ + dX²Y²
            if (left !== right) throw new Error("bad point: equation left != right (1)");
            // In Extended coordinates we also have T, which is x*y=T/Z: check X*Y == Z*T
            const XY = modP(X * Y);
            const ZT = modP(Z * T);
            if (XY !== ZT) throw new Error("bad point: equation left != right (2)");
        }
        // Compare one point to another.
        equals(other) {
            isPoint(other);
            const { ex: X1, ey: Y1, ez: Z1 } = this;
            const { ex: X2, ey: Y2, ez: Z2 } = other;
            const X1Z2 = modP(X1 * Z2);
            const X2Z1 = modP(X2 * Z1);
            const Y1Z2 = modP(Y1 * Z2);
            const Y2Z1 = modP(Y2 * Z1);
            return X1Z2 === X2Z1 && Y1Z2 === Y2Z1;
        }
        is0() {
            return this.equals(Point.ZERO);
        }
        negate() {
            // Flips point sign to a negative one (-x, y in affine coords)
            return new Point(modP(-this.ex), this.ey, this.ez, modP(-this.et));
        }
        // Fast algo for doubling Extended Point.
        // https://hyperelliptic.org/EFD/g1p/auto-twisted-extended.html#doubling-dbl-2008-hwcd
        // Cost: 4M + 4S + 1*a + 6add + 1*2.
        double() {
            const { a: a } = CURVE;
            const { ex: X1, ey: Y1, ez: Z1 } = this;
            const A = modP(X1 * X1); // A = X12
            const B = modP(Y1 * Y1); // B = Y12
            const C = modP($05b353c83d290c67$var$_2n * modP(Z1 * Z1)); // C = 2*Z12
            const D = modP(a * A); // D = a*A
            const x1y1 = X1 + Y1;
            const E = modP(modP(x1y1 * x1y1) - A - B); // E = (X1+Y1)2-A-B
            const G = D + B; // G = D+B
            const F = G - C; // F = G-C
            const H = D - B; // H = D-B
            const X3 = modP(E * F); // X3 = E*F
            const Y3 = modP(G * H); // Y3 = G*H
            const T3 = modP(E * H); // T3 = E*H
            const Z3 = modP(F * G); // Z3 = F*G
            return new Point(X3, Y3, Z3, T3);
        }
        // Fast algo for adding 2 Extended Points.
        // https://hyperelliptic.org/EFD/g1p/auto-twisted-extended.html#addition-add-2008-hwcd
        // Cost: 9M + 1*a + 1*d + 7add.
        add(other) {
            isPoint(other);
            const { a: a, d: d } = CURVE;
            const { ex: X1, ey: Y1, ez: Z1, et: T1 } = this;
            const { ex: X2, ey: Y2, ez: Z2, et: T2 } = other;
            // Faster algo for adding 2 Extended Points when curve's a=-1.
            // http://hyperelliptic.org/EFD/g1p/auto-twisted-extended-1.html#addition-add-2008-hwcd-4
            // Cost: 8M + 8add + 2*2.
            // Note: It does not check whether the `other` point is valid.
            if (a === BigInt(-1)) {
                const A = modP((Y1 - X1) * (Y2 + X2));
                const B = modP((Y1 + X1) * (Y2 - X2));
                const F = modP(B - A);
                if (F === $05b353c83d290c67$var$_0n) return this.double(); // Same point. Tests say it doesn't affect timing
                const C = modP(Z1 * $05b353c83d290c67$var$_2n * T2);
                const D = modP(T1 * $05b353c83d290c67$var$_2n * Z2);
                const E = D + C;
                const G = B + A;
                const H = D - C;
                const X3 = modP(E * F);
                const Y3 = modP(G * H);
                const T3 = modP(E * H);
                const Z3 = modP(F * G);
                return new Point(X3, Y3, Z3, T3);
            }
            const A = modP(X1 * X2); // A = X1*X2
            const B = modP(Y1 * Y2); // B = Y1*Y2
            const C = modP(T1 * d * T2); // C = T1*d*T2
            const D = modP(Z1 * Z2); // D = Z1*Z2
            const E = modP((X1 + Y1) * (X2 + Y2) - A - B); // E = (X1+Y1)*(X2+Y2)-A-B
            const F = D - C; // F = D-C
            const G = D + C; // G = D+C
            const H = modP(B - a * A); // H = B-a*A
            const X3 = modP(E * F); // X3 = E*F
            const Y3 = modP(G * H); // Y3 = G*H
            const T3 = modP(E * H); // T3 = E*H
            const Z3 = modP(F * G); // Z3 = F*G
            return new Point(X3, Y3, Z3, T3);
        }
        subtract(other) {
            return this.add(other.negate());
        }
        wNAF(n) {
            return wnaf.wNAFCached(this, pointPrecomputes, n, Point.normalizeZ);
        }
        // Constant-time multiplication.
        multiply(scalar) {
            const { p: p, f: f } = this.wNAF(assertInRange(scalar, CURVE_ORDER));
            return Point.normalizeZ([
                p,
                f
            ])[0];
        }
        // Non-constant-time multiplication. Uses double-and-add algorithm.
        // It's faster, but should only be used when you don't care about
        // an exposed private key e.g. sig verification.
        // Does NOT allow scalars higher than CURVE.n.
        multiplyUnsafe(scalar) {
            let n = assertGE0(scalar); // 0 <= scalar < CURVE.n
            if (n === $05b353c83d290c67$var$_0n) return I;
            if (this.equals(I) || n === $05b353c83d290c67$var$_1n) return this;
            if (this.equals(G)) return this.wNAF(n).p;
            return wnaf.unsafeLadder(this, n);
        }
        // Checks if point is of small order.
        // If you add something to small order point, you will have "dirty"
        // point with torsion component.
        // Multiplies point by cofactor and checks if the result is 0.
        isSmallOrder() {
            return this.multiplyUnsafe(cofactor).is0();
        }
        // Multiplies point by curve order and checks if the result is 0.
        // Returns `false` is the point is dirty.
        isTorsionFree() {
            return wnaf.unsafeLadder(this, CURVE_ORDER).is0();
        }
        // Converts Extended point to default (x, y) coordinates.
        // Can accept precomputed Z^-1 - for example, from invertBatch.
        toAffine(iz) {
            const { ex: x, ey: y, ez: z } = this;
            const is0 = this.is0();
            if (iz == null) iz = is0 ? $05b353c83d290c67$var$_8n : Fp.inv(z); // 8 was chosen arbitrarily
            const ax = modP(x * iz);
            const ay = modP(y * iz);
            const zz = modP(z * iz);
            if (is0) return {
                x: $05b353c83d290c67$var$_0n,
                y: $05b353c83d290c67$var$_1n
            };
            if (zz !== $05b353c83d290c67$var$_1n) throw new Error("invZ was invalid");
            return {
                x: ax,
                y: ay
            };
        }
        clearCofactor() {
            const { h: cofactor } = CURVE;
            if (cofactor === $05b353c83d290c67$var$_1n) return this;
            return this.multiplyUnsafe(cofactor);
        }
        // Converts hash string or Uint8Array to Point.
        // Uses algo from RFC8032 5.1.3.
        static fromHex(hex, zip215 = false) {
            const { d: d, a: a } = CURVE;
            const len = Fp.BYTES;
            hex = (0, $a53222754f250272$exports.ensureBytes)("pointHex", hex, len); // copy hex to a new array
            const normed = hex.slice(); // copy again, we'll manipulate it
            const lastByte = hex[len - 1]; // select last byte
            normed[len - 1] = lastByte & -129; // clear last bit
            const y = $a53222754f250272$exports.bytesToNumberLE(normed);
            if (y === $05b353c83d290c67$var$_0n) ;
            else // RFC8032 prohibits >= p, but ZIP215 doesn't
            if (zip215) assertInRange(y, MASK); // zip215=true [1..P-1] (2^255-19-1 for ed25519)
            else assertInRange(y, Fp.ORDER); // zip215=false [1..MASK-1] (2^256-1 for ed25519)
            // Ed25519: x² = (y²-1)/(dy²+1) mod p. Ed448: x² = (y²-1)/(dy²-1) mod p. Generic case:
            // ax²+y²=1+dx²y² => y²-1=dx²y²-ax² => y²-1=x²(dy²-a) => x²=(y²-1)/(dy²-a)
            const y2 = modP(y * y); // denominator is always non-0 mod p.
            const u = modP(y2 - $05b353c83d290c67$var$_1n); // u = y² - 1
            const v = modP(d * y2 - a); // v = d y² + 1.
            let { isValid: isValid, value: x } = uvRatio(u, v); // √(u/v)
            if (!isValid) throw new Error("Point.fromHex: invalid y coordinate");
            const isXOdd = (x & $05b353c83d290c67$var$_1n) === $05b353c83d290c67$var$_1n; // There are 2 square roots. Use x_0 bit to select proper
            const isLastByteOdd = (lastByte & 0x80) !== 0; // x_0, last bit
            if (!zip215 && x === $05b353c83d290c67$var$_0n && isLastByteOdd) // if x=0 and x_0 = 1, fail
            throw new Error("Point.fromHex: x=0 and x_0=1");
            if (isLastByteOdd !== isXOdd) x = modP(-x); // if x_0 != x mod 2, set x = p-x
            return Point.fromAffine({
                x: x,
                y: y
            });
        }
        static fromPrivateKey(privKey) {
            return getExtendedPublicKey(privKey).point;
        }
        toRawBytes() {
            const { x: x, y: y } = this.toAffine();
            const bytes = $a53222754f250272$exports.numberToBytesLE(y, Fp.BYTES); // each y has 2 x values (x, -y)
            bytes[bytes.length - 1] |= x & $05b353c83d290c67$var$_1n ? 0x80 : 0; // when compressing, it's enough to store y
            return bytes; // and use the last byte to encode sign of x
        }
        toHex() {
            return $a53222754f250272$exports.bytesToHex(this.toRawBytes()); // Same as toRawBytes, but returns string.
        }
    }
    Point.BASE = new Point(CURVE.Gx, CURVE.Gy, $05b353c83d290c67$var$_1n, modP(CURVE.Gx * CURVE.Gy));
    Point.ZERO = new Point($05b353c83d290c67$var$_0n, $05b353c83d290c67$var$_1n, $05b353c83d290c67$var$_1n, $05b353c83d290c67$var$_0n); // 0, 1, 1, 0
    const { BASE: G, ZERO: I } = Point;
    const wnaf = (0, $3754823f21a54f54$exports.wNAF)(Point, nByteLength * 8);
    function modN(a) {
        return (0, $f4225407683e7e63$exports.mod)(a, CURVE_ORDER);
    }
    // Little-endian SHA512 with modulo n
    function modN_LE(hash) {
        return modN($a53222754f250272$exports.bytesToNumberLE(hash));
    }
    /** Convenience method that creates public key and other stuff. RFC8032 5.1.5 */ function getExtendedPublicKey(key) {
        const len = nByteLength;
        key = (0, $a53222754f250272$exports.ensureBytes)("private key", key, len);
        // Hash private key with curve's hash function to produce uniformingly random input
        // Check byte lengths: ensure(64, h(ensure(32, key)))
        const hashed = (0, $a53222754f250272$exports.ensureBytes)("hashed private key", cHash(key), 2 * len);
        const head = adjustScalarBytes(hashed.slice(0, len)); // clear first half bits, produce FE
        const prefix = hashed.slice(len, 2 * len); // second half is called key prefix (5.1.6)
        const scalar = modN_LE(head); // The actual private scalar
        const point = G.multiply(scalar); // Point on Edwards curve aka public key
        const pointBytes = point.toRawBytes(); // Uint8Array representation
        return {
            head: head,
            prefix: prefix,
            scalar: scalar,
            point: point,
            pointBytes: pointBytes
        };
    }
    // Calculates EdDSA pub key. RFC8032 5.1.5. Privkey is hashed. Use first half with 3 bits cleared
    function getPublicKey(privKey) {
        return getExtendedPublicKey(privKey).pointBytes;
    }
    // int('LE', SHA512(dom2(F, C) || msgs)) mod N
    function hashDomainToScalar(context = new Uint8Array(), ...msgs) {
        const msg = $a53222754f250272$exports.concatBytes(...msgs);
        return modN_LE(cHash(domain(msg, (0, $a53222754f250272$exports.ensureBytes)("context", context), !!prehash)));
    }
    /** Signs message with privateKey. RFC8032 5.1.6 */ function sign(msg, privKey, options = {}) {
        msg = (0, $a53222754f250272$exports.ensureBytes)("message", msg);
        if (prehash) msg = prehash(msg); // for ed25519ph etc.
        const { prefix: prefix, scalar: scalar, pointBytes: pointBytes } = getExtendedPublicKey(privKey);
        const r = hashDomainToScalar(options.context, prefix, msg); // r = dom2(F, C) || prefix || PH(M)
        const R = G.multiply(r).toRawBytes(); // R = rG
        const k = hashDomainToScalar(options.context, R, pointBytes, msg); // R || A || PH(M)
        const s = modN(r + k * scalar); // S = (r + k * s) mod L
        assertGE0(s); // 0 <= s < l
        const res = $a53222754f250272$exports.concatBytes(R, $a53222754f250272$exports.numberToBytesLE(s, Fp.BYTES));
        return (0, $a53222754f250272$exports.ensureBytes)("result", res, nByteLength * 2); // 64-byte signature
    }
    const verifyOpts = $05b353c83d290c67$var$VERIFY_DEFAULT;
    function verify(sig, msg, publicKey, options = verifyOpts) {
        const { context: context, zip215: zip215 } = options;
        const len = Fp.BYTES; // Verifies EdDSA signature against message and public key. RFC8032 5.1.7.
        sig = (0, $a53222754f250272$exports.ensureBytes)("signature", sig, 2 * len); // An extended group equation is checked.
        msg = (0, $a53222754f250272$exports.ensureBytes)("message", msg);
        if (prehash) msg = prehash(msg); // for ed25519ph, etc
        const s = $a53222754f250272$exports.bytesToNumberLE(sig.slice(len, 2 * len));
        // zip215: true is good for consensus-critical apps and allows points < 2^256
        // zip215: false follows RFC8032 / NIST186-5 and restricts points to CURVE.p
        let A, R, SB;
        try {
            A = Point.fromHex(publicKey, zip215);
            R = Point.fromHex(sig.slice(0, len), zip215);
            SB = G.multiplyUnsafe(s); // 0 <= s < l is done inside
        } catch (error) {
            return false;
        }
        if (!zip215 && A.isSmallOrder()) return false;
        const k = hashDomainToScalar(context, R.toRawBytes(), A.toRawBytes(), msg);
        const RkA = R.add(A.multiplyUnsafe(k));
        // [8][S]B = [8]R + [8][k]A'
        return RkA.subtract(SB).clearCofactor().equals(Point.ZERO);
    }
    G._setWindowSize(8); // Enable precomputes. Slows down first publicKey computation by 20ms.
    const utils = {
        getExtendedPublicKey: getExtendedPublicKey,
        // ed25519 private keys are uniform 32b. No need to check for modulo bias, like in secp256k1.
        randomPrivateKey: ()=>randomBytes(Fp.BYTES),
        /**
         * We're doing scalar multiplication (used in getPublicKey etc) with precomputed BASE_POINT
         * values. This slows down first getPublicKey() by milliseconds (see Speed section),
         * but allows to speed-up subsequent getPublicKey() calls up to 20x.
         * @param windowSize 2, 4, 8, 16
         */ precompute (windowSize = 8, point = Point.BASE) {
            point._setWindowSize(windowSize);
            point.multiply(BigInt(3));
            return point;
        }
    };
    return {
        CURVE: CURVE,
        getPublicKey: getPublicKey,
        sign: sign,
        verify: verify,
        ExtendedPoint: Point,
        utils: utils
    };
}
$05b353c83d290c67$exports.twistedEdwards = $05b353c83d290c67$var$twistedEdwards;


var $552a6eb3fc007bc2$exports = {};
"use strict";
Object.defineProperty($552a6eb3fc007bc2$exports, "__esModule", {
    value: true
});
$552a6eb3fc007bc2$exports.montgomery = void 0;


const $552a6eb3fc007bc2$var$_0n = BigInt(0);
const $552a6eb3fc007bc2$var$_1n = BigInt(1);
function $552a6eb3fc007bc2$var$validateOpts(curve) {
    (0, $a53222754f250272$exports.validateObject)(curve, {
        a: "bigint"
    }, {
        montgomeryBits: "isSafeInteger",
        nByteLength: "isSafeInteger",
        adjustScalarBytes: "function",
        domain: "function",
        powPminus2: "function",
        Gu: "bigint"
    });
    // Set defaults
    return Object.freeze({
        ...curve
    });
}
// NOTE: not really montgomery curve, just bunch of very specific methods for X25519/X448 (RFC 7748, https://www.rfc-editor.org/rfc/rfc7748)
// Uses only one coordinate instead of two
function $552a6eb3fc007bc2$var$montgomery(curveDef) {
    const CURVE = $552a6eb3fc007bc2$var$validateOpts(curveDef);
    const { P: P } = CURVE;
    const modP = (n)=>(0, $f4225407683e7e63$exports.mod)(n, P);
    const montgomeryBits = CURVE.montgomeryBits;
    const montgomeryBytes = Math.ceil(montgomeryBits / 8);
    const fieldLen = CURVE.nByteLength;
    const adjustScalarBytes = CURVE.adjustScalarBytes || ((bytes)=>bytes);
    const powPminus2 = CURVE.powPminus2 || ((x)=>(0, $f4225407683e7e63$exports.pow)(x, P - BigInt(2), P));
    // cswap from RFC7748. But it is not from RFC7748!
    /*
      cswap(swap, x_2, x_3):
           dummy = mask(swap) AND (x_2 XOR x_3)
           x_2 = x_2 XOR dummy
           x_3 = x_3 XOR dummy
           Return (x_2, x_3)
    Where mask(swap) is the all-1 or all-0 word of the same length as x_2
     and x_3, computed, e.g., as mask(swap) = 0 - swap.
    */ function cswap(swap, x_2, x_3) {
        const dummy = modP(swap * (x_2 - x_3));
        x_2 = modP(x_2 - dummy);
        x_3 = modP(x_3 + dummy);
        return [
            x_2,
            x_3
        ];
    }
    // Accepts 0 as well
    function assertFieldElement(n) {
        if (typeof n === "bigint" && $552a6eb3fc007bc2$var$_0n <= n && n < P) return n;
        throw new Error("Expected valid scalar 0 < scalar < CURVE.P");
    }
    // x25519 from 4
    // The constant a24 is (486662 - 2) / 4 = 121665 for curve25519/X25519
    const a24 = (CURVE.a - BigInt(2)) / BigInt(4);
    /**
     *
     * @param pointU u coordinate (x) on Montgomery Curve 25519
     * @param scalar by which the point would be multiplied
     * @returns new Point on Montgomery curve
     */ function montgomeryLadder(pointU, scalar) {
        const u = assertFieldElement(pointU);
        // Section 5: Implementations MUST accept non-canonical values and process them as
        // if they had been reduced modulo the field prime.
        const k = assertFieldElement(scalar);
        const x_1 = u;
        let x_2 = $552a6eb3fc007bc2$var$_1n;
        let z_2 = $552a6eb3fc007bc2$var$_0n;
        let x_3 = u;
        let z_3 = $552a6eb3fc007bc2$var$_1n;
        let swap = $552a6eb3fc007bc2$var$_0n;
        let sw;
        for(let t = BigInt(montgomeryBits - 1); t >= $552a6eb3fc007bc2$var$_0n; t--){
            const k_t = k >> t & $552a6eb3fc007bc2$var$_1n;
            swap ^= k_t;
            sw = cswap(swap, x_2, x_3);
            x_2 = sw[0];
            x_3 = sw[1];
            sw = cswap(swap, z_2, z_3);
            z_2 = sw[0];
            z_3 = sw[1];
            swap = k_t;
            const A = x_2 + z_2;
            const AA = modP(A * A);
            const B = x_2 - z_2;
            const BB = modP(B * B);
            const E = AA - BB;
            const C = x_3 + z_3;
            const D = x_3 - z_3;
            const DA = modP(D * A);
            const CB = modP(C * B);
            const dacb = DA + CB;
            const da_cb = DA - CB;
            x_3 = modP(dacb * dacb);
            z_3 = modP(x_1 * modP(da_cb * da_cb));
            x_2 = modP(AA * BB);
            z_2 = modP(E * (AA + modP(a24 * E)));
        }
        // (x_2, x_3) = cswap(swap, x_2, x_3)
        sw = cswap(swap, x_2, x_3);
        x_2 = sw[0];
        x_3 = sw[1];
        // (z_2, z_3) = cswap(swap, z_2, z_3)
        sw = cswap(swap, z_2, z_3);
        z_2 = sw[0];
        z_3 = sw[1];
        // z_2^(p - 2)
        const z2 = powPminus2(z_2);
        // Return x_2 * (z_2^(p - 2))
        return modP(x_2 * z2);
    }
    function encodeUCoordinate(u) {
        return (0, $a53222754f250272$exports.numberToBytesLE)(modP(u), montgomeryBytes);
    }
    function decodeUCoordinate(uEnc) {
        // Section 5: When receiving such an array, implementations of X25519
        // MUST mask the most significant bit in the final byte.
        const u = (0, $a53222754f250272$exports.ensureBytes)("u coordinate", uEnc, montgomeryBytes);
        if (fieldLen === 32) u[31] &= 127; // 0b0111_1111
        return (0, $a53222754f250272$exports.bytesToNumberLE)(u);
    }
    function decodeScalar(n) {
        const bytes = (0, $a53222754f250272$exports.ensureBytes)("scalar", n);
        const len = bytes.length;
        if (len !== montgomeryBytes && len !== fieldLen) throw new Error(`Expected ${montgomeryBytes} or ${fieldLen} bytes, got ${len}`);
        return (0, $a53222754f250272$exports.bytesToNumberLE)(adjustScalarBytes(bytes));
    }
    function scalarMult(scalar, u) {
        const pointU = decodeUCoordinate(u);
        const _scalar = decodeScalar(scalar);
        const pu = montgomeryLadder(pointU, _scalar);
        // The result was not contributory
        // https://cr.yp.to/ecdh.html#validate
        if (pu === $552a6eb3fc007bc2$var$_0n) throw new Error("Invalid private or public key received");
        return encodeUCoordinate(pu);
    }
    // Computes public key from private. By doing scalar multiplication of base point.
    const GuBytes = encodeUCoordinate(CURVE.Gu);
    function scalarMultBase(scalar) {
        return scalarMult(scalar, GuBytes);
    }
    return {
        scalarMult: scalarMult,
        scalarMultBase: scalarMultBase,
        getSharedSecret: (privateKey, publicKey)=>scalarMult(privateKey, publicKey),
        getPublicKey: (privateKey)=>scalarMultBase(privateKey),
        utils: {
            randomPrivateKey: ()=>CURVE.randomBytes(CURVE.nByteLength)
        },
        GuBytes: GuBytes
    };
}
$552a6eb3fc007bc2$exports.montgomery = $552a6eb3fc007bc2$var$montgomery;




var $4aa17946f6094e60$exports = {};
"use strict";
Object.defineProperty($4aa17946f6094e60$exports, "__esModule", {
    value: true
});
$4aa17946f6094e60$exports.createHasher = $4aa17946f6094e60$exports.isogenyMap = $4aa17946f6094e60$exports.hash_to_field = $4aa17946f6094e60$exports.expand_message_xof = $4aa17946f6094e60$exports.expand_message_xmd = void 0;


function $4aa17946f6094e60$var$validateDST(dst) {
    if ((0, $a53222754f250272$exports.isBytes)(dst)) return dst;
    if (typeof dst === "string") return (0, $a53222754f250272$exports.utf8ToBytes)(dst);
    throw new Error("DST must be Uint8Array or string");
}
// Octet Stream to Integer. "spec" implementation of os2ip is 2.5x slower vs bytesToNumberBE.
const $4aa17946f6094e60$var$os2ip = $a53222754f250272$exports.bytesToNumberBE;
// Integer to Octet Stream (numberToBytesBE)
function $4aa17946f6094e60$var$i2osp(value, length) {
    if (value < 0 || value >= 1 << 8 * length) throw new Error(`bad I2OSP call: value=${value} length=${length}`);
    const res = Array.from({
        length: length
    }).fill(0);
    for(let i = length - 1; i >= 0; i--){
        res[i] = value & 0xff;
        value >>>= 8;
    }
    return new Uint8Array(res);
}
function $4aa17946f6094e60$var$strxor(a, b) {
    const arr = new Uint8Array(a.length);
    for(let i = 0; i < a.length; i++)arr[i] = a[i] ^ b[i];
    return arr;
}
function $4aa17946f6094e60$var$abytes(item) {
    if (!(0, $a53222754f250272$exports.isBytes)(item)) throw new Error("Uint8Array expected");
}
function $4aa17946f6094e60$var$isNum(item) {
    if (!Number.isSafeInteger(item)) throw new Error("number expected");
}
// Produces a uniformly random byte string using a cryptographic hash function H that outputs b bits
// https://www.rfc-editor.org/rfc/rfc9380#section-5.3.1
function $4aa17946f6094e60$var$expand_message_xmd(msg, DST, lenInBytes, H) {
    $4aa17946f6094e60$var$abytes(msg);
    $4aa17946f6094e60$var$abytes(DST);
    $4aa17946f6094e60$var$isNum(lenInBytes);
    // https://www.rfc-editor.org/rfc/rfc9380#section-5.3.3
    if (DST.length > 255) DST = H((0, $a53222754f250272$exports.concatBytes)((0, $a53222754f250272$exports.utf8ToBytes)("H2C-OVERSIZE-DST-"), DST));
    const { outputLen: b_in_bytes, blockLen: r_in_bytes } = H;
    const ell = Math.ceil(lenInBytes / b_in_bytes);
    if (ell > 255) throw new Error("Invalid xmd length");
    const DST_prime = (0, $a53222754f250272$exports.concatBytes)(DST, $4aa17946f6094e60$var$i2osp(DST.length, 1));
    const Z_pad = $4aa17946f6094e60$var$i2osp(0, r_in_bytes);
    const l_i_b_str = $4aa17946f6094e60$var$i2osp(lenInBytes, 2); // len_in_bytes_str
    const b = new Array(ell);
    const b_0 = H((0, $a53222754f250272$exports.concatBytes)(Z_pad, msg, l_i_b_str, $4aa17946f6094e60$var$i2osp(0, 1), DST_prime));
    b[0] = H((0, $a53222754f250272$exports.concatBytes)(b_0, $4aa17946f6094e60$var$i2osp(1, 1), DST_prime));
    for(let i = 1; i <= ell; i++){
        const args = [
            $4aa17946f6094e60$var$strxor(b_0, b[i - 1]),
            $4aa17946f6094e60$var$i2osp(i + 1, 1),
            DST_prime
        ];
        b[i] = H((0, $a53222754f250272$exports.concatBytes)(...args));
    }
    const pseudo_random_bytes = (0, $a53222754f250272$exports.concatBytes)(...b);
    return pseudo_random_bytes.slice(0, lenInBytes);
}
$4aa17946f6094e60$exports.expand_message_xmd = $4aa17946f6094e60$var$expand_message_xmd;
// Produces a uniformly random byte string using an extendable-output function (XOF) H.
// 1. The collision resistance of H MUST be at least k bits.
// 2. H MUST be an XOF that has been proved indifferentiable from
//    a random oracle under a reasonable cryptographic assumption.
// https://www.rfc-editor.org/rfc/rfc9380#section-5.3.2
function $4aa17946f6094e60$var$expand_message_xof(msg, DST, lenInBytes, k, H) {
    $4aa17946f6094e60$var$abytes(msg);
    $4aa17946f6094e60$var$abytes(DST);
    $4aa17946f6094e60$var$isNum(lenInBytes);
    // https://www.rfc-editor.org/rfc/rfc9380#section-5.3.3
    // DST = H('H2C-OVERSIZE-DST-' || a_very_long_DST, Math.ceil((lenInBytes * k) / 8));
    if (DST.length > 255) {
        const dkLen = Math.ceil(2 * k / 8);
        DST = H.create({
            dkLen: dkLen
        }).update((0, $a53222754f250272$exports.utf8ToBytes)("H2C-OVERSIZE-DST-")).update(DST).digest();
    }
    if (lenInBytes > 65535 || DST.length > 255) throw new Error("expand_message_xof: invalid lenInBytes");
    return H.create({
        dkLen: lenInBytes
    }).update(msg).update($4aa17946f6094e60$var$i2osp(lenInBytes, 2))// 2. DST_prime = DST || I2OSP(len(DST), 1)
    .update(DST).update($4aa17946f6094e60$var$i2osp(DST.length, 1)).digest();
}
$4aa17946f6094e60$exports.expand_message_xof = $4aa17946f6094e60$var$expand_message_xof;
/**
 * Hashes arbitrary-length byte strings to a list of one or more elements of a finite field F
 * https://www.rfc-editor.org/rfc/rfc9380#section-5.2
 * @param msg a byte string containing the message to hash
 * @param count the number of elements of F to output
 * @param options `{DST: string, p: bigint, m: number, k: number, expand: 'xmd' | 'xof', hash: H}`, see above
 * @returns [u_0, ..., u_(count - 1)], a list of field elements.
 */ function $4aa17946f6094e60$var$hash_to_field(msg, count, options) {
    (0, $a53222754f250272$exports.validateObject)(options, {
        DST: "stringOrUint8Array",
        p: "bigint",
        m: "isSafeInteger",
        k: "isSafeInteger",
        hash: "hash"
    });
    const { p: p, k: k, m: m, hash: hash, expand: expand, DST: _DST } = options;
    $4aa17946f6094e60$var$abytes(msg);
    $4aa17946f6094e60$var$isNum(count);
    const DST = $4aa17946f6094e60$var$validateDST(_DST);
    const log2p = p.toString(2).length;
    const L = Math.ceil((log2p + k) / 8); // section 5.1 of ietf draft link above
    const len_in_bytes = count * m * L;
    let prb; // pseudo_random_bytes
    if (expand === "xmd") prb = $4aa17946f6094e60$var$expand_message_xmd(msg, DST, len_in_bytes, hash);
    else if (expand === "xof") prb = $4aa17946f6094e60$var$expand_message_xof(msg, DST, len_in_bytes, k, hash);
    else if (expand === "_internal_pass") // for internal tests only
    prb = msg;
    else throw new Error('expand must be "xmd" or "xof"');
    const u = new Array(count);
    for(let i = 0; i < count; i++){
        const e = new Array(m);
        for(let j = 0; j < m; j++){
            const elm_offset = L * (j + i * m);
            const tv = prb.subarray(elm_offset, elm_offset + L);
            e[j] = (0, $f4225407683e7e63$exports.mod)($4aa17946f6094e60$var$os2ip(tv), p);
        }
        u[i] = e;
    }
    return u;
}
$4aa17946f6094e60$exports.hash_to_field = $4aa17946f6094e60$var$hash_to_field;
function $4aa17946f6094e60$var$isogenyMap(field, map) {
    // Make same order as in spec
    const COEFF = map.map((i)=>Array.from(i).reverse());
    return (x, y)=>{
        const [xNum, xDen, yNum, yDen] = COEFF.map((val)=>val.reduce((acc, i)=>field.add(field.mul(acc, x), i)));
        x = field.div(xNum, xDen); // xNum / xDen
        y = field.mul(y, field.div(yNum, yDen)); // y * (yNum / yDev)
        return {
            x: x,
            y: y
        };
    };
}
$4aa17946f6094e60$exports.isogenyMap = $4aa17946f6094e60$var$isogenyMap;
function $4aa17946f6094e60$var$createHasher(Point, mapToCurve, def) {
    if (typeof mapToCurve !== "function") throw new Error("mapToCurve() must be defined");
    return {
        // Encodes byte string to elliptic curve.
        // hash_to_curve from https://www.rfc-editor.org/rfc/rfc9380#section-3
        hashToCurve (msg, options) {
            const u = $4aa17946f6094e60$var$hash_to_field(msg, 2, {
                ...def,
                DST: def.DST,
                ...options
            });
            const u0 = Point.fromAffine(mapToCurve(u[0]));
            const u1 = Point.fromAffine(mapToCurve(u[1]));
            const P = u0.add(u1).clearCofactor();
            P.assertValidity();
            return P;
        },
        // Encodes byte string to elliptic curve.
        // encode_to_curve from https://www.rfc-editor.org/rfc/rfc9380#section-3
        encodeToCurve (msg, options) {
            const u = $4aa17946f6094e60$var$hash_to_field(msg, 1, {
                ...def,
                DST: def.encodeDST,
                ...options
            });
            const P = Point.fromAffine(mapToCurve(u[0])).clearCofactor();
            P.assertValidity();
            return P;
        }
    };
}
$4aa17946f6094e60$exports.createHasher = $4aa17946f6094e60$var$createHasher;


/**
 * ed25519 Twisted Edwards curve with following addons:
 * - X25519 ECDH
 * - Ristretto cofactor elimination
 * - Elligator hash-to-group / point indistinguishability
 */ const $eff1b194c9d09a4e$var$ED25519_P = BigInt("57896044618658097711785492504343953926634992332820282019728792003956564819949");
// √(-1) aka √(a) aka 2^((p-1)/4)
const $eff1b194c9d09a4e$var$ED25519_SQRT_M1 = BigInt("19681161376707505956807079304988542015446066515923890162744021073123829784752");
// prettier-ignore
const $eff1b194c9d09a4e$var$_0n = BigInt(0), $eff1b194c9d09a4e$var$_1n = BigInt(1), $eff1b194c9d09a4e$var$_2n = BigInt(2), $eff1b194c9d09a4e$var$_5n = BigInt(5);
// prettier-ignore
const $eff1b194c9d09a4e$var$_10n = BigInt(10), $eff1b194c9d09a4e$var$_20n = BigInt(20), $eff1b194c9d09a4e$var$_40n = BigInt(40), $eff1b194c9d09a4e$var$_80n = BigInt(80);
function $eff1b194c9d09a4e$var$ed25519_pow_2_252_3(x) {
    const P = $eff1b194c9d09a4e$var$ED25519_P;
    const x2 = x * x % P;
    const b2 = x2 * x % P; // x^3, 11
    const b4 = (0, $f4225407683e7e63$exports.pow2)(b2, $eff1b194c9d09a4e$var$_2n, P) * b2 % P; // x^15, 1111
    const b5 = (0, $f4225407683e7e63$exports.pow2)(b4, $eff1b194c9d09a4e$var$_1n, P) * x % P; // x^31
    const b10 = (0, $f4225407683e7e63$exports.pow2)(b5, $eff1b194c9d09a4e$var$_5n, P) * b5 % P;
    const b20 = (0, $f4225407683e7e63$exports.pow2)(b10, $eff1b194c9d09a4e$var$_10n, P) * b10 % P;
    const b40 = (0, $f4225407683e7e63$exports.pow2)(b20, $eff1b194c9d09a4e$var$_20n, P) * b20 % P;
    const b80 = (0, $f4225407683e7e63$exports.pow2)(b40, $eff1b194c9d09a4e$var$_40n, P) * b40 % P;
    const b160 = (0, $f4225407683e7e63$exports.pow2)(b80, $eff1b194c9d09a4e$var$_80n, P) * b80 % P;
    const b240 = (0, $f4225407683e7e63$exports.pow2)(b160, $eff1b194c9d09a4e$var$_80n, P) * b80 % P;
    const b250 = (0, $f4225407683e7e63$exports.pow2)(b240, $eff1b194c9d09a4e$var$_10n, P) * b10 % P;
    const pow_p_5_8 = (0, $f4225407683e7e63$exports.pow2)(b250, $eff1b194c9d09a4e$var$_2n, P) * x % P;
    // ^ To pow to (p+3)/8, multiply it by x.
    return {
        pow_p_5_8: pow_p_5_8,
        b2: b2
    };
}
function $eff1b194c9d09a4e$var$adjustScalarBytes(bytes) {
    // Section 5: For X25519, in order to decode 32 random bytes as an integer scalar,
    // set the three least significant bits of the first byte
    bytes[0] &= 248; // 0b1111_1000
    // and the most significant bit of the last to zero,
    bytes[31] &= 127; // 0b0111_1111
    // set the second most significant bit of the last byte to 1
    bytes[31] |= 64; // 0b0100_0000
    return bytes;
}
// sqrt(u/v)
function $eff1b194c9d09a4e$var$uvRatio(u, v) {
    const P = $eff1b194c9d09a4e$var$ED25519_P;
    const v3 = (0, $f4225407683e7e63$exports.mod)(v * v * v, P); // v³
    const v7 = (0, $f4225407683e7e63$exports.mod)(v3 * v3 * v, P); // v⁷
    // (p+3)/8 and (p-5)/8
    const pow = $eff1b194c9d09a4e$var$ed25519_pow_2_252_3(u * v7).pow_p_5_8;
    let x = (0, $f4225407683e7e63$exports.mod)(u * v3 * pow, P); // (uv³)(uv⁷)^(p-5)/8
    const vx2 = (0, $f4225407683e7e63$exports.mod)(v * x * x, P); // vx²
    const root1 = x; // First root candidate
    const root2 = (0, $f4225407683e7e63$exports.mod)(x * $eff1b194c9d09a4e$var$ED25519_SQRT_M1, P); // Second root candidate
    const useRoot1 = vx2 === u; // If vx² = u (mod p), x is a square root
    const useRoot2 = vx2 === (0, $f4225407683e7e63$exports.mod)(-u, P); // If vx² = -u, set x <-- x * 2^((p-1)/4)
    const noRoot = vx2 === (0, $f4225407683e7e63$exports.mod)(-u * $eff1b194c9d09a4e$var$ED25519_SQRT_M1, P); // There is no valid root, vx² = -u√(-1)
    if (useRoot1) x = root1;
    if (useRoot2 || noRoot) x = root2; // We return root2 anyway, for const-time
    if ((0, $f4225407683e7e63$exports.isNegativeLE)(x, P)) x = (0, $f4225407683e7e63$exports.mod)(-x, P);
    return {
        isValid: useRoot1 || useRoot2,
        value: x
    };
}
// Just in case
$eff1b194c9d09a4e$exports.ED25519_TORSION_SUBGROUP = [
    "0100000000000000000000000000000000000000000000000000000000000000",
    "c7176a703d4dd84fba3c0b760d10670f2a2053fa2c39ccc64ec7fd7792ac037a",
    "0000000000000000000000000000000000000000000000000000000000000080",
    "26e8958fc2b227b045c3f489f2ef98f0d5dfac05d3c63339b13802886d53fc05",
    "ecffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff7f",
    "26e8958fc2b227b045c3f489f2ef98f0d5dfac05d3c63339b13802886d53fc85",
    "0000000000000000000000000000000000000000000000000000000000000000",
    "c7176a703d4dd84fba3c0b760d10670f2a2053fa2c39ccc64ec7fd7792ac03fa"
];
const $eff1b194c9d09a4e$var$Fp = (0, $f4225407683e7e63$exports.Field)($eff1b194c9d09a4e$var$ED25519_P, undefined, true);
const $eff1b194c9d09a4e$var$ed25519Defaults = {
    // Param: a
    a: BigInt(-1),
    // d is equal to -121665/121666 over finite field.
    // Negative number is P - number, and division is invert(number, P)
    d: BigInt("37095705934669439343138083508754565189542113879843219016388785533085940283555"),
    Fp: // Finite field 𝔽p over which we'll do calculations; 2n**255n - 19n
    $eff1b194c9d09a4e$var$Fp,
    // Subgroup order: how many points curve has
    // 2n**252n + 27742317777372353535851937790883648493n;
    n: BigInt("7237005577332262213973186563042994240857116359379907606001950938285454250989"),
    // Cofactor
    h: BigInt(8),
    // Base point (x, y) aka generator point
    Gx: BigInt("15112221349535400772501151409588531511454012693041857206046113283949847762202"),
    Gy: BigInt("46316835694926478169428394003475163141307993866256225615783033603165251855960"),
    hash: $fJ9Lg.sha512,
    randomBytes: $ebEok.randomBytes,
    adjustScalarBytes: $eff1b194c9d09a4e$var$adjustScalarBytes,
    uvRatio: // dom2
    // Ratio of u to v. Allows us to combine inversion and square root. Uses algo from RFC8032 5.1.3.
    // Constant-time, u/√v
    $eff1b194c9d09a4e$var$uvRatio
};
$eff1b194c9d09a4e$exports.ed25519 = (0, $05b353c83d290c67$exports.twistedEdwards)($eff1b194c9d09a4e$var$ed25519Defaults);
function $eff1b194c9d09a4e$var$ed25519_domain(data, ctx, phflag) {
    if (ctx.length > 255) throw new Error("Context is too big");
    return (0, $ebEok.concatBytes)((0, $ebEok.utf8ToBytes)("SigEd25519 no Ed25519 collisions"), new Uint8Array([
        phflag ? 1 : 0,
        ctx.length
    ]), ctx, data);
}
$eff1b194c9d09a4e$exports.ed25519ctx = (0, $05b353c83d290c67$exports.twistedEdwards)({
    ...$eff1b194c9d09a4e$var$ed25519Defaults,
    domain: $eff1b194c9d09a4e$var$ed25519_domain
});
$eff1b194c9d09a4e$exports.ed25519ph = (0, $05b353c83d290c67$exports.twistedEdwards)({
    ...$eff1b194c9d09a4e$var$ed25519Defaults,
    domain: $eff1b194c9d09a4e$var$ed25519_domain,
    prehash: $fJ9Lg.sha512
});
$eff1b194c9d09a4e$exports.x25519 = (()=>(0, $552a6eb3fc007bc2$exports.montgomery)({
        P: $eff1b194c9d09a4e$var$ED25519_P,
        a: BigInt(486662),
        montgomeryBits: 255,
        nByteLength: 32,
        Gu: BigInt(9),
        powPminus2: (x)=>{
            const P = $eff1b194c9d09a4e$var$ED25519_P;
            // x^(p-2) aka x^(2^255-21)
            const { pow_p_5_8: pow_p_5_8, b2: b2 } = $eff1b194c9d09a4e$var$ed25519_pow_2_252_3(x);
            return (0, $f4225407683e7e63$exports.mod)((0, $f4225407683e7e63$exports.pow2)(pow_p_5_8, BigInt(3), P) * b2, P);
        },
        adjustScalarBytes: $eff1b194c9d09a4e$var$adjustScalarBytes,
        randomBytes: $ebEok.randomBytes
    }))();
/**
 * Converts ed25519 public key to x25519 public key. Uses formula:
 * * `(u, v) = ((1+y)/(1-y), sqrt(-486664)*u/x)`
 * * `(x, y) = (sqrt(-486664)*u/v, (u-1)/(u+1))`
 * @example
 *   const someonesPub = ed25519.getPublicKey(ed25519.utils.randomPrivateKey());
 *   const aPriv = x25519.utils.randomPrivateKey();
 *   x25519.getSharedSecret(aPriv, edwardsToMontgomeryPub(someonesPub))
 */ function $eff1b194c9d09a4e$var$edwardsToMontgomeryPub(edwardsPub) {
    const { y: y } = $eff1b194c9d09a4e$exports.ed25519.ExtendedPoint.fromHex(edwardsPub);
    const _1n = BigInt(1);
    return $eff1b194c9d09a4e$var$Fp.toBytes($eff1b194c9d09a4e$var$Fp.create((_1n + y) * $eff1b194c9d09a4e$var$Fp.inv(_1n - y)));
}
$eff1b194c9d09a4e$exports.edwardsToMontgomeryPub = $eff1b194c9d09a4e$var$edwardsToMontgomeryPub;
$eff1b194c9d09a4e$exports.edwardsToMontgomery = $eff1b194c9d09a4e$var$edwardsToMontgomeryPub; // deprecated
/**
 * Converts ed25519 secret key to x25519 secret key.
 * @example
 *   const someonesPub = x25519.getPublicKey(x25519.utils.randomPrivateKey());
 *   const aPriv = ed25519.utils.randomPrivateKey();
 *   x25519.getSharedSecret(edwardsToMontgomeryPriv(aPriv), someonesPub)
 */ function $eff1b194c9d09a4e$var$edwardsToMontgomeryPriv(edwardsPriv) {
    const hashed = $eff1b194c9d09a4e$var$ed25519Defaults.hash(edwardsPriv.subarray(0, 32));
    return $eff1b194c9d09a4e$var$ed25519Defaults.adjustScalarBytes(hashed).subarray(0, 32);
}
$eff1b194c9d09a4e$exports.edwardsToMontgomeryPriv = $eff1b194c9d09a4e$var$edwardsToMontgomeryPriv;
// Hash To Curve Elligator2 Map (NOTE: different from ristretto255 elligator)
// NOTE: very important part is usage of FpSqrtEven for ELL2_C1_EDWARDS, since
// SageMath returns different root first and everything falls apart
const $eff1b194c9d09a4e$var$ELL2_C1 = ($eff1b194c9d09a4e$var$Fp.ORDER + BigInt(3)) / BigInt(8); // 1. c1 = (q + 3) / 8       # Integer arithmetic
const $eff1b194c9d09a4e$var$ELL2_C2 = $eff1b194c9d09a4e$var$Fp.pow($eff1b194c9d09a4e$var$_2n, $eff1b194c9d09a4e$var$ELL2_C1); // 2. c2 = 2^c1
const $eff1b194c9d09a4e$var$ELL2_C3 = $eff1b194c9d09a4e$var$Fp.sqrt($eff1b194c9d09a4e$var$Fp.neg($eff1b194c9d09a4e$var$Fp.ONE)); // 3. c3 = sqrt(-1)
const $eff1b194c9d09a4e$var$ELL2_C4 = ($eff1b194c9d09a4e$var$Fp.ORDER - BigInt(5)) / BigInt(8); // 4. c4 = (q - 5) / 8       # Integer arithmetic
const $eff1b194c9d09a4e$var$ELL2_J = BigInt(486662);
// prettier-ignore
function $eff1b194c9d09a4e$var$map_to_curve_elligator2_curve25519(u) {
    let tv1 = $eff1b194c9d09a4e$var$Fp.sqr(u); //  1.  tv1 = u^2
    tv1 = $eff1b194c9d09a4e$var$Fp.mul(tv1, $eff1b194c9d09a4e$var$_2n); //  2.  tv1 = 2 * tv1
    let xd = $eff1b194c9d09a4e$var$Fp.add(tv1, $eff1b194c9d09a4e$var$Fp.ONE); //  3.   xd = tv1 + 1         # Nonzero: -1 is square (mod p), tv1 is not
    let x1n = $eff1b194c9d09a4e$var$Fp.neg($eff1b194c9d09a4e$var$ELL2_J); //  4.  x1n = -J              # x1 = x1n / xd = -J / (1 + 2 * u^2)
    let tv2 = $eff1b194c9d09a4e$var$Fp.sqr(xd); //  5.  tv2 = xd^2
    let gxd = $eff1b194c9d09a4e$var$Fp.mul(tv2, xd); //  6.  gxd = tv2 * xd        # gxd = xd^3
    let gx1 = $eff1b194c9d09a4e$var$Fp.mul(tv1, $eff1b194c9d09a4e$var$ELL2_J); //  7.  gx1 = J * tv1         # x1n + J * xd
    gx1 = $eff1b194c9d09a4e$var$Fp.mul(gx1, x1n); //  8.  gx1 = gx1 * x1n       # x1n^2 + J * x1n * xd
    gx1 = $eff1b194c9d09a4e$var$Fp.add(gx1, tv2); //  9.  gx1 = gx1 + tv2       # x1n^2 + J * x1n * xd + xd^2
    gx1 = $eff1b194c9d09a4e$var$Fp.mul(gx1, x1n); //  10. gx1 = gx1 * x1n       # x1n^3 + J * x1n^2 * xd + x1n * xd^2
    let tv3 = $eff1b194c9d09a4e$var$Fp.sqr(gxd); //  11. tv3 = gxd^2
    tv2 = $eff1b194c9d09a4e$var$Fp.sqr(tv3); //  12. tv2 = tv3^2           # gxd^4
    tv3 = $eff1b194c9d09a4e$var$Fp.mul(tv3, gxd); //  13. tv3 = tv3 * gxd       # gxd^3
    tv3 = $eff1b194c9d09a4e$var$Fp.mul(tv3, gx1); //  14. tv3 = tv3 * gx1       # gx1 * gxd^3
    tv2 = $eff1b194c9d09a4e$var$Fp.mul(tv2, tv3); //  15. tv2 = tv2 * tv3       # gx1 * gxd^7
    let y11 = $eff1b194c9d09a4e$var$Fp.pow(tv2, $eff1b194c9d09a4e$var$ELL2_C4); //  16. y11 = tv2^c4        # (gx1 * gxd^7)^((p - 5) / 8)
    y11 = $eff1b194c9d09a4e$var$Fp.mul(y11, tv3); //  17. y11 = y11 * tv3       # gx1*gxd^3*(gx1*gxd^7)^((p-5)/8)
    let y12 = $eff1b194c9d09a4e$var$Fp.mul(y11, $eff1b194c9d09a4e$var$ELL2_C3); //  18. y12 = y11 * c3
    tv2 = $eff1b194c9d09a4e$var$Fp.sqr(y11); //  19. tv2 = y11^2
    tv2 = $eff1b194c9d09a4e$var$Fp.mul(tv2, gxd); //  20. tv2 = tv2 * gxd
    let e1 = $eff1b194c9d09a4e$var$Fp.eql(tv2, gx1); //  21.  e1 = tv2 == gx1
    let y1 = $eff1b194c9d09a4e$var$Fp.cmov(y12, y11, e1); //  22.  y1 = CMOV(y12, y11, e1)  # If g(x1) is square, this is its sqrt
    let x2n = $eff1b194c9d09a4e$var$Fp.mul(x1n, tv1); //  23. x2n = x1n * tv1       # x2 = x2n / xd = 2 * u^2 * x1n / xd
    let y21 = $eff1b194c9d09a4e$var$Fp.mul(y11, u); //  24. y21 = y11 * u
    y21 = $eff1b194c9d09a4e$var$Fp.mul(y21, $eff1b194c9d09a4e$var$ELL2_C2); //  25. y21 = y21 * c2
    let y22 = $eff1b194c9d09a4e$var$Fp.mul(y21, $eff1b194c9d09a4e$var$ELL2_C3); //  26. y22 = y21 * c3
    let gx2 = $eff1b194c9d09a4e$var$Fp.mul(gx1, tv1); //  27. gx2 = gx1 * tv1       # g(x2) = gx2 / gxd = 2 * u^2 * g(x1)
    tv2 = $eff1b194c9d09a4e$var$Fp.sqr(y21); //  28. tv2 = y21^2
    tv2 = $eff1b194c9d09a4e$var$Fp.mul(tv2, gxd); //  29. tv2 = tv2 * gxd
    let e2 = $eff1b194c9d09a4e$var$Fp.eql(tv2, gx2); //  30.  e2 = tv2 == gx2
    let y2 = $eff1b194c9d09a4e$var$Fp.cmov(y22, y21, e2); //  31.  y2 = CMOV(y22, y21, e2)  # If g(x2) is square, this is its sqrt
    tv2 = $eff1b194c9d09a4e$var$Fp.sqr(y1); //  32. tv2 = y1^2
    tv2 = $eff1b194c9d09a4e$var$Fp.mul(tv2, gxd); //  33. tv2 = tv2 * gxd
    let e3 = $eff1b194c9d09a4e$var$Fp.eql(tv2, gx1); //  34.  e3 = tv2 == gx1
    let xn = $eff1b194c9d09a4e$var$Fp.cmov(x2n, x1n, e3); //  35.  xn = CMOV(x2n, x1n, e3)  # If e3, x = x1, else x = x2
    let y = $eff1b194c9d09a4e$var$Fp.cmov(y2, y1, e3); //  36.   y = CMOV(y2, y1, e3)    # If e3, y = y1, else y = y2
    let e4 = $eff1b194c9d09a4e$var$Fp.isOdd(y); //  37.  e4 = sgn0(y) == 1        # Fix sign of y
    y = $eff1b194c9d09a4e$var$Fp.cmov(y, $eff1b194c9d09a4e$var$Fp.neg(y), e3 !== e4); //  38.   y = CMOV(y, -y, e3 XOR e4)
    return {
        xMn: xn,
        xMd: xd,
        yMn: y,
        yMd: $eff1b194c9d09a4e$var$_1n
    }; //  39. return (xn, xd, y, 1)
}
const $eff1b194c9d09a4e$var$ELL2_C1_EDWARDS = (0, $f4225407683e7e63$exports.FpSqrtEven)($eff1b194c9d09a4e$var$Fp, $eff1b194c9d09a4e$var$Fp.neg(BigInt(486664))); // sgn0(c1) MUST equal 0
function $eff1b194c9d09a4e$var$map_to_curve_elligator2_edwards25519(u) {
    const { xMn: xMn, xMd: xMd, yMn: yMn, yMd: yMd } = $eff1b194c9d09a4e$var$map_to_curve_elligator2_curve25519(u); //  1.  (xMn, xMd, yMn, yMd) =
    // map_to_curve_elligator2_curve25519(u)
    let xn = $eff1b194c9d09a4e$var$Fp.mul(xMn, yMd); //  2.  xn = xMn * yMd
    xn = $eff1b194c9d09a4e$var$Fp.mul(xn, $eff1b194c9d09a4e$var$ELL2_C1_EDWARDS); //  3.  xn = xn * c1
    let xd = $eff1b194c9d09a4e$var$Fp.mul(xMd, yMn); //  4.  xd = xMd * yMn    # xn / xd = c1 * xM / yM
    let yn = $eff1b194c9d09a4e$var$Fp.sub(xMn, xMd); //  5.  yn = xMn - xMd
    let yd = $eff1b194c9d09a4e$var$Fp.add(xMn, xMd); //  6.  yd = xMn + xMd    # (n / d - 1) / (n / d + 1) = (n - d) / (n + d)
    let tv1 = $eff1b194c9d09a4e$var$Fp.mul(xd, yd); //  7. tv1 = xd * yd
    let e = $eff1b194c9d09a4e$var$Fp.eql(tv1, $eff1b194c9d09a4e$var$Fp.ZERO); //  8.   e = tv1 == 0
    xn = $eff1b194c9d09a4e$var$Fp.cmov(xn, $eff1b194c9d09a4e$var$Fp.ZERO, e); //  9.  xn = CMOV(xn, 0, e)
    xd = $eff1b194c9d09a4e$var$Fp.cmov(xd, $eff1b194c9d09a4e$var$Fp.ONE, e); //  10. xd = CMOV(xd, 1, e)
    yn = $eff1b194c9d09a4e$var$Fp.cmov(yn, $eff1b194c9d09a4e$var$Fp.ONE, e); //  11. yn = CMOV(yn, 1, e)
    yd = $eff1b194c9d09a4e$var$Fp.cmov(yd, $eff1b194c9d09a4e$var$Fp.ONE, e); //  12. yd = CMOV(yd, 1, e)
    const inv = $eff1b194c9d09a4e$var$Fp.invertBatch([
        xd,
        yd
    ]); // batch division
    return {
        x: $eff1b194c9d09a4e$var$Fp.mul(xn, inv[0]),
        y: $eff1b194c9d09a4e$var$Fp.mul(yn, inv[1])
    }; //  13. return (xn, xd, yn, yd)
}
const $eff1b194c9d09a4e$var$htf = /* @__PURE__ */ (()=>(0, $4aa17946f6094e60$exports.createHasher)($eff1b194c9d09a4e$exports.ed25519.ExtendedPoint, (scalars)=>$eff1b194c9d09a4e$var$map_to_curve_elligator2_edwards25519(scalars[0]), {
        DST: "edwards25519_XMD:SHA-512_ELL2_RO_",
        encodeDST: "edwards25519_XMD:SHA-512_ELL2_NU_",
        p: $eff1b194c9d09a4e$var$Fp.ORDER,
        m: 1,
        k: 128,
        expand: "xmd",
        hash: $fJ9Lg.sha512
    }))();
$eff1b194c9d09a4e$exports.hashToCurve = (()=>$eff1b194c9d09a4e$var$htf.hashToCurve)();
$eff1b194c9d09a4e$exports.encodeToCurve = (()=>$eff1b194c9d09a4e$var$htf.encodeToCurve)();
function $eff1b194c9d09a4e$var$assertRstPoint(other) {
    if (!(other instanceof $eff1b194c9d09a4e$var$RistPoint)) throw new Error("RistrettoPoint expected");
}
// √(-1) aka √(a) aka 2^((p-1)/4)
const $eff1b194c9d09a4e$var$SQRT_M1 = $eff1b194c9d09a4e$var$ED25519_SQRT_M1;
// √(ad - 1)
const $eff1b194c9d09a4e$var$SQRT_AD_MINUS_ONE = BigInt("25063068953384623474111414158702152701244531502492656460079210482610430750235");
// 1 / √(a-d)
const $eff1b194c9d09a4e$var$INVSQRT_A_MINUS_D = BigInt("54469307008909316920995813868745141605393597292927456921205312896311721017578");
// 1-d²
const $eff1b194c9d09a4e$var$ONE_MINUS_D_SQ = BigInt("1159843021668779879193775521855586647937357759715417654439879720876111806838");
// (d-1)²
const $eff1b194c9d09a4e$var$D_MINUS_ONE_SQ = BigInt("40440834346308536858101042469323190826248399146238708352240133220865137265952");
// Calculates 1/√(number)
const $eff1b194c9d09a4e$var$invertSqrt = (number)=>$eff1b194c9d09a4e$var$uvRatio($eff1b194c9d09a4e$var$_1n, number);
const $eff1b194c9d09a4e$var$MAX_255B = BigInt("0x7fffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff");
const $eff1b194c9d09a4e$var$bytes255ToNumberLE = (bytes)=>$eff1b194c9d09a4e$exports.ed25519.CURVE.Fp.create((0, $a53222754f250272$exports.bytesToNumberLE)(bytes) & $eff1b194c9d09a4e$var$MAX_255B);
// Computes Elligator map for Ristretto
// https://ristretto.group/formulas/elligator.html
function $eff1b194c9d09a4e$var$calcElligatorRistrettoMap(r0) {
    const { d: d } = $eff1b194c9d09a4e$exports.ed25519.CURVE;
    const P = $eff1b194c9d09a4e$exports.ed25519.CURVE.Fp.ORDER;
    const mod = $eff1b194c9d09a4e$exports.ed25519.CURVE.Fp.create;
    const r = mod($eff1b194c9d09a4e$var$SQRT_M1 * r0 * r0); // 1
    const Ns = mod((r + $eff1b194c9d09a4e$var$_1n) * $eff1b194c9d09a4e$var$ONE_MINUS_D_SQ); // 2
    let c = BigInt(-1); // 3
    const D = mod((c - d * r) * mod(r + d)); // 4
    let { isValid: Ns_D_is_sq, value: s } = $eff1b194c9d09a4e$var$uvRatio(Ns, D); // 5
    let s_ = mod(s * r0); // 6
    if (!(0, $f4225407683e7e63$exports.isNegativeLE)(s_, P)) s_ = mod(-s_);
    if (!Ns_D_is_sq) s = s_; // 7
    if (!Ns_D_is_sq) c = r; // 8
    const Nt = mod(c * (r - $eff1b194c9d09a4e$var$_1n) * $eff1b194c9d09a4e$var$D_MINUS_ONE_SQ - D); // 9
    const s2 = s * s;
    const W0 = mod((s + s) * D); // 10
    const W1 = mod(Nt * $eff1b194c9d09a4e$var$SQRT_AD_MINUS_ONE); // 11
    const W2 = mod($eff1b194c9d09a4e$var$_1n - s2); // 12
    const W3 = mod($eff1b194c9d09a4e$var$_1n + s2); // 13
    return new $eff1b194c9d09a4e$exports.ed25519.ExtendedPoint(mod(W0 * W3), mod(W2 * W1), mod(W1 * W3), mod(W0 * W2));
}
/**
 * Each ed25519/ExtendedPoint has 8 different equivalent points. This can be
 * a source of bugs for protocols like ring signatures. Ristretto was created to solve this.
 * Ristretto point operates in X:Y:Z:T extended coordinates like ExtendedPoint,
 * but it should work in its own namespace: do not combine those two.
 * https://datatracker.ietf.org/doc/html/draft-irtf-cfrg-ristretto255-decaf448
 */ class $eff1b194c9d09a4e$var$RistPoint {
    // Private property to discourage combining ExtendedPoint + RistrettoPoint
    // Always use Ristretto encoding/decoding instead.
    constructor(ep){
        this.ep = ep;
    }
    static fromAffine(ap) {
        return new $eff1b194c9d09a4e$var$RistPoint($eff1b194c9d09a4e$exports.ed25519.ExtendedPoint.fromAffine(ap));
    }
    /**
     * Takes uniform output of 64-byte hash function like sha512 and converts it to `RistrettoPoint`.
     * The hash-to-group operation applies Elligator twice and adds the results.
     * **Note:** this is one-way map, there is no conversion from point to hash.
     * https://ristretto.group/formulas/elligator.html
     * @param hex 64-byte output of a hash function
     */ static hashToCurve(hex) {
        hex = (0, $a53222754f250272$exports.ensureBytes)("ristrettoHash", hex, 64);
        const r1 = $eff1b194c9d09a4e$var$bytes255ToNumberLE(hex.slice(0, 32));
        const R1 = $eff1b194c9d09a4e$var$calcElligatorRistrettoMap(r1);
        const r2 = $eff1b194c9d09a4e$var$bytes255ToNumberLE(hex.slice(32, 64));
        const R2 = $eff1b194c9d09a4e$var$calcElligatorRistrettoMap(r2);
        return new $eff1b194c9d09a4e$var$RistPoint(R1.add(R2));
    }
    /**
     * Converts ristretto-encoded string to ristretto point.
     * https://ristretto.group/formulas/decoding.html
     * @param hex Ristretto-encoded 32 bytes. Not every 32-byte string is valid ristretto encoding
     */ static fromHex(hex) {
        hex = (0, $a53222754f250272$exports.ensureBytes)("ristrettoHex", hex, 32);
        const { a: a, d: d } = $eff1b194c9d09a4e$exports.ed25519.CURVE;
        const P = $eff1b194c9d09a4e$exports.ed25519.CURVE.Fp.ORDER;
        const mod = $eff1b194c9d09a4e$exports.ed25519.CURVE.Fp.create;
        const emsg = "RistrettoPoint.fromHex: the hex is not valid encoding of RistrettoPoint";
        const s = $eff1b194c9d09a4e$var$bytes255ToNumberLE(hex);
        // 1. Check that s_bytes is the canonical encoding of a field element, or else abort.
        // 3. Check that s is non-negative, or else abort
        if (!(0, $a53222754f250272$exports.equalBytes)((0, $a53222754f250272$exports.numberToBytesLE)(s, 32), hex) || (0, $f4225407683e7e63$exports.isNegativeLE)(s, P)) throw new Error(emsg);
        const s2 = mod(s * s);
        const u1 = mod($eff1b194c9d09a4e$var$_1n + a * s2); // 4 (a is -1)
        const u2 = mod($eff1b194c9d09a4e$var$_1n - a * s2); // 5
        const u1_2 = mod(u1 * u1);
        const u2_2 = mod(u2 * u2);
        const v = mod(a * d * u1_2 - u2_2); // 6
        const { isValid: isValid, value: I } = $eff1b194c9d09a4e$var$invertSqrt(mod(v * u2_2)); // 7
        const Dx = mod(I * u2); // 8
        const Dy = mod(I * Dx * v); // 9
        let x = mod((s + s) * Dx); // 10
        if ((0, $f4225407683e7e63$exports.isNegativeLE)(x, P)) x = mod(-x); // 10
        const y = mod(u1 * Dy); // 11
        const t = mod(x * y); // 12
        if (!isValid || (0, $f4225407683e7e63$exports.isNegativeLE)(t, P) || y === $eff1b194c9d09a4e$var$_0n) throw new Error(emsg);
        return new $eff1b194c9d09a4e$var$RistPoint(new $eff1b194c9d09a4e$exports.ed25519.ExtendedPoint(x, y, $eff1b194c9d09a4e$var$_1n, t));
    }
    /**
     * Encodes ristretto point to Uint8Array.
     * https://ristretto.group/formulas/encoding.html
     */ toRawBytes() {
        let { ex: x, ey: y, ez: z, et: t } = this.ep;
        const P = $eff1b194c9d09a4e$exports.ed25519.CURVE.Fp.ORDER;
        const mod = $eff1b194c9d09a4e$exports.ed25519.CURVE.Fp.create;
        const u1 = mod(mod(z + y) * mod(z - y)); // 1
        const u2 = mod(x * y); // 2
        // Square root always exists
        const u2sq = mod(u2 * u2);
        const { value: invsqrt } = $eff1b194c9d09a4e$var$invertSqrt(mod(u1 * u2sq)); // 3
        const D1 = mod(invsqrt * u1); // 4
        const D2 = mod(invsqrt * u2); // 5
        const zInv = mod(D1 * D2 * t); // 6
        let D; // 7
        if ((0, $f4225407683e7e63$exports.isNegativeLE)(t * zInv, P)) {
            let _x = mod(y * $eff1b194c9d09a4e$var$SQRT_M1);
            let _y = mod(x * $eff1b194c9d09a4e$var$SQRT_M1);
            x = _x;
            y = _y;
            D = mod(D1 * $eff1b194c9d09a4e$var$INVSQRT_A_MINUS_D);
        } else D = D2; // 8
        if ((0, $f4225407683e7e63$exports.isNegativeLE)(x * zInv, P)) y = mod(-y); // 9
        let s = mod((z - y) * D); // 10 (check footer's note, no sqrt(-a))
        if ((0, $f4225407683e7e63$exports.isNegativeLE)(s, P)) s = mod(-s);
        return (0, $a53222754f250272$exports.numberToBytesLE)(s, 32); // 11
    }
    toHex() {
        return (0, $a53222754f250272$exports.bytesToHex)(this.toRawBytes());
    }
    toString() {
        return this.toHex();
    }
    // Compare one point to another.
    equals(other) {
        $eff1b194c9d09a4e$var$assertRstPoint(other);
        const { ex: X1, ey: Y1 } = this.ep;
        const { ex: X2, ey: Y2 } = other.ep;
        const mod = $eff1b194c9d09a4e$exports.ed25519.CURVE.Fp.create;
        // (x1 * y2 == y1 * x2) | (y1 * y2 == x1 * x2)
        const one = mod(X1 * Y2) === mod(Y1 * X2);
        const two = mod(Y1 * Y2) === mod(X1 * X2);
        return one || two;
    }
    add(other) {
        $eff1b194c9d09a4e$var$assertRstPoint(other);
        return new $eff1b194c9d09a4e$var$RistPoint(this.ep.add(other.ep));
    }
    subtract(other) {
        $eff1b194c9d09a4e$var$assertRstPoint(other);
        return new $eff1b194c9d09a4e$var$RistPoint(this.ep.subtract(other.ep));
    }
    multiply(scalar) {
        return new $eff1b194c9d09a4e$var$RistPoint(this.ep.multiply(scalar));
    }
    multiplyUnsafe(scalar) {
        return new $eff1b194c9d09a4e$var$RistPoint(this.ep.multiplyUnsafe(scalar));
    }
    double() {
        return new $eff1b194c9d09a4e$var$RistPoint(this.ep.double());
    }
    negate() {
        return new $eff1b194c9d09a4e$var$RistPoint(this.ep.negate());
    }
}
$eff1b194c9d09a4e$exports.RistrettoPoint = (()=>{
    if (!$eff1b194c9d09a4e$var$RistPoint.BASE) $eff1b194c9d09a4e$var$RistPoint.BASE = new $eff1b194c9d09a4e$var$RistPoint($eff1b194c9d09a4e$exports.ed25519.ExtendedPoint.BASE);
    if (!$eff1b194c9d09a4e$var$RistPoint.ZERO) $eff1b194c9d09a4e$var$RistPoint.ZERO = new $eff1b194c9d09a4e$var$RistPoint($eff1b194c9d09a4e$exports.ed25519.ExtendedPoint.ZERO);
    return $eff1b194c9d09a4e$var$RistPoint;
})();
// Hashing to ristretto255. https://www.rfc-editor.org/rfc/rfc9380#appendix-B
const $eff1b194c9d09a4e$var$hashToRistretto255 = (msg, options)=>{
    const d = options.DST;
    const DST = typeof d === "string" ? (0, $ebEok.utf8ToBytes)(d) : d;
    const uniform_bytes = (0, $4aa17946f6094e60$exports.expand_message_xmd)(msg, DST, 64, $fJ9Lg.sha512);
    const P = $eff1b194c9d09a4e$var$RistPoint.hashToCurve(uniform_bytes);
    return P;
};
$eff1b194c9d09a4e$exports.hashToRistretto255 = $eff1b194c9d09a4e$var$hashToRistretto255;
$eff1b194c9d09a4e$exports.hash_to_ristretto255 = $eff1b194c9d09a4e$exports.hashToRistretto255; // legacy



var $fnQBP = parcelRequire("fnQBP");

var $hZS7n = parcelRequire("hZS7n");

var $lrsL3 = parcelRequire("lrsL3");
var $34e3e5c42c9dc29c$exports = {};

var $ihoyg = parcelRequire("ihoyg");
var $34e3e5c42c9dc29c$require$Buffer = $ihoyg.Buffer;
"use strict";
var $34e3e5c42c9dc29c$var$__createBinding = $34e3e5c42c9dc29c$exports && $34e3e5c42c9dc29c$exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, {
        enumerable: true,
        get: function() {
            return m[k];
        }
    });
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $34e3e5c42c9dc29c$var$__setModuleDefault = $34e3e5c42c9dc29c$exports && $34e3e5c42c9dc29c$exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $34e3e5c42c9dc29c$var$__decorate = $34e3e5c42c9dc29c$exports && $34e3e5c42c9dc29c$exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $34e3e5c42c9dc29c$var$__importStar = $34e3e5c42c9dc29c$exports && $34e3e5c42c9dc29c$exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.hasOwnProperty.call(mod, k)) $34e3e5c42c9dc29c$var$__createBinding(result, mod, k);
    }
    $34e3e5c42c9dc29c$var$__setModuleDefault(result, mod);
    return result;
};
var $34e3e5c42c9dc29c$var$__importDefault = $34e3e5c42c9dc29c$exports && $34e3e5c42c9dc29c$exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty($34e3e5c42c9dc29c$exports, "__esModule", {
    value: true
});
$34e3e5c42c9dc29c$exports.deserializeUnchecked = $34e3e5c42c9dc29c$exports.deserialize = $34e3e5c42c9dc29c$exports.serialize = $34e3e5c42c9dc29c$exports.BinaryReader = $34e3e5c42c9dc29c$exports.BinaryWriter = $34e3e5c42c9dc29c$exports.BorshError = $34e3e5c42c9dc29c$exports.baseDecode = $34e3e5c42c9dc29c$exports.baseEncode = void 0;

const $34e3e5c42c9dc29c$var$bn_js_1 = $34e3e5c42c9dc29c$var$__importDefault((parcelRequire("jAZWd")));

const $34e3e5c42c9dc29c$var$bs58_1 = $34e3e5c42c9dc29c$var$__importDefault((parcelRequire("hZS7n")));

// TODO: Make sure this polyfill not included when not required
const $34e3e5c42c9dc29c$var$encoding = $34e3e5c42c9dc29c$var$__importStar((parcelRequire("9vosj")));
const $34e3e5c42c9dc29c$var$ResolvedTextDecoder = typeof TextDecoder !== "function" ? $34e3e5c42c9dc29c$var$encoding.TextDecoder : TextDecoder;
const $34e3e5c42c9dc29c$var$textDecoder = new $34e3e5c42c9dc29c$var$ResolvedTextDecoder("utf-8", {
    fatal: true
});
function $34e3e5c42c9dc29c$var$baseEncode(value) {
    if (typeof value === "string") value = $34e3e5c42c9dc29c$require$Buffer.from(value, "utf8");
    return $34e3e5c42c9dc29c$var$bs58_1.default.encode($34e3e5c42c9dc29c$require$Buffer.from(value));
}
$34e3e5c42c9dc29c$exports.baseEncode = $34e3e5c42c9dc29c$var$baseEncode;
function $34e3e5c42c9dc29c$var$baseDecode(value) {
    return $34e3e5c42c9dc29c$require$Buffer.from($34e3e5c42c9dc29c$var$bs58_1.default.decode(value));
}
$34e3e5c42c9dc29c$exports.baseDecode = $34e3e5c42c9dc29c$var$baseDecode;
const $34e3e5c42c9dc29c$var$INITIAL_LENGTH = 1024;
class $34e3e5c42c9dc29c$var$BorshError extends Error {
    constructor(message){
        super(message);
        this.fieldPath = [];
        this.originalMessage = message;
    }
    addToFieldPath(fieldName) {
        this.fieldPath.splice(0, 0, fieldName);
        // NOTE: Modifying message directly as jest doesn't use .toString()
        this.message = this.originalMessage + ": " + this.fieldPath.join(".");
    }
}
$34e3e5c42c9dc29c$exports.BorshError = $34e3e5c42c9dc29c$var$BorshError;
/// Binary encoder.
class $34e3e5c42c9dc29c$var$BinaryWriter {
    constructor(){
        this.buf = $34e3e5c42c9dc29c$require$Buffer.alloc($34e3e5c42c9dc29c$var$INITIAL_LENGTH);
        this.length = 0;
    }
    maybeResize() {
        if (this.buf.length < 16 + this.length) this.buf = $34e3e5c42c9dc29c$require$Buffer.concat([
            this.buf,
            $34e3e5c42c9dc29c$require$Buffer.alloc($34e3e5c42c9dc29c$var$INITIAL_LENGTH)
        ]);
    }
    writeU8(value) {
        this.maybeResize();
        this.buf.writeUInt8(value, this.length);
        this.length += 1;
    }
    writeU16(value) {
        this.maybeResize();
        this.buf.writeUInt16LE(value, this.length);
        this.length += 2;
    }
    writeU32(value) {
        this.maybeResize();
        this.buf.writeUInt32LE(value, this.length);
        this.length += 4;
    }
    writeU64(value) {
        this.maybeResize();
        this.writeBuffer($34e3e5c42c9dc29c$require$Buffer.from(new $34e3e5c42c9dc29c$var$bn_js_1.default(value).toArray("le", 8)));
    }
    writeU128(value) {
        this.maybeResize();
        this.writeBuffer($34e3e5c42c9dc29c$require$Buffer.from(new $34e3e5c42c9dc29c$var$bn_js_1.default(value).toArray("le", 16)));
    }
    writeU256(value) {
        this.maybeResize();
        this.writeBuffer($34e3e5c42c9dc29c$require$Buffer.from(new $34e3e5c42c9dc29c$var$bn_js_1.default(value).toArray("le", 32)));
    }
    writeU512(value) {
        this.maybeResize();
        this.writeBuffer($34e3e5c42c9dc29c$require$Buffer.from(new $34e3e5c42c9dc29c$var$bn_js_1.default(value).toArray("le", 64)));
    }
    writeBuffer(buffer) {
        // Buffer.from is needed as this.buf.subarray can return plain Uint8Array in browser
        this.buf = $34e3e5c42c9dc29c$require$Buffer.concat([
            $34e3e5c42c9dc29c$require$Buffer.from(this.buf.subarray(0, this.length)),
            buffer,
            $34e3e5c42c9dc29c$require$Buffer.alloc($34e3e5c42c9dc29c$var$INITIAL_LENGTH)
        ]);
        this.length += buffer.length;
    }
    writeString(str) {
        this.maybeResize();
        const b = $34e3e5c42c9dc29c$require$Buffer.from(str, "utf8");
        this.writeU32(b.length);
        this.writeBuffer(b);
    }
    writeFixedArray(array) {
        this.writeBuffer($34e3e5c42c9dc29c$require$Buffer.from(array));
    }
    writeArray(array, fn) {
        this.maybeResize();
        this.writeU32(array.length);
        for (const elem of array){
            this.maybeResize();
            fn(elem);
        }
    }
    toArray() {
        return this.buf.subarray(0, this.length);
    }
}
$34e3e5c42c9dc29c$exports.BinaryWriter = $34e3e5c42c9dc29c$var$BinaryWriter;
function $34e3e5c42c9dc29c$var$handlingRangeError(target, propertyKey, propertyDescriptor) {
    const originalMethod = propertyDescriptor.value;
    propertyDescriptor.value = function(...args) {
        try {
            return originalMethod.apply(this, args);
        } catch (e) {
            if (e instanceof RangeError) {
                const code = e.code;
                if ([
                    "ERR_BUFFER_OUT_OF_BOUNDS",
                    "ERR_OUT_OF_RANGE"
                ].indexOf(code) >= 0) throw new $34e3e5c42c9dc29c$var$BorshError("Reached the end of buffer when deserializing");
            }
            throw e;
        }
    };
}
class $34e3e5c42c9dc29c$var$BinaryReader {
    constructor(buf){
        this.buf = buf;
        this.offset = 0;
    }
    readU8() {
        const value = this.buf.readUInt8(this.offset);
        this.offset += 1;
        return value;
    }
    readU16() {
        const value = this.buf.readUInt16LE(this.offset);
        this.offset += 2;
        return value;
    }
    readU32() {
        const value = this.buf.readUInt32LE(this.offset);
        this.offset += 4;
        return value;
    }
    readU64() {
        const buf = this.readBuffer(8);
        return new $34e3e5c42c9dc29c$var$bn_js_1.default(buf, "le");
    }
    readU128() {
        const buf = this.readBuffer(16);
        return new $34e3e5c42c9dc29c$var$bn_js_1.default(buf, "le");
    }
    readU256() {
        const buf = this.readBuffer(32);
        return new $34e3e5c42c9dc29c$var$bn_js_1.default(buf, "le");
    }
    readU512() {
        const buf = this.readBuffer(64);
        return new $34e3e5c42c9dc29c$var$bn_js_1.default(buf, "le");
    }
    readBuffer(len) {
        if (this.offset + len > this.buf.length) throw new $34e3e5c42c9dc29c$var$BorshError(`Expected buffer length ${len} isn't within bounds`);
        const result = this.buf.slice(this.offset, this.offset + len);
        this.offset += len;
        return result;
    }
    readString() {
        const len = this.readU32();
        const buf = this.readBuffer(len);
        try {
            // NOTE: Using TextDecoder to fail on invalid UTF-8
            return $34e3e5c42c9dc29c$var$textDecoder.decode(buf);
        } catch (e) {
            throw new $34e3e5c42c9dc29c$var$BorshError(`Error decoding UTF-8 string: ${e}`);
        }
    }
    readFixedArray(len) {
        return new Uint8Array(this.readBuffer(len));
    }
    readArray(fn) {
        const len = this.readU32();
        const result = Array();
        for(let i = 0; i < len; ++i)result.push(fn());
        return result;
    }
}
$34e3e5c42c9dc29c$var$__decorate([
    $34e3e5c42c9dc29c$var$handlingRangeError
], $34e3e5c42c9dc29c$var$BinaryReader.prototype, "readU8", null);
$34e3e5c42c9dc29c$var$__decorate([
    $34e3e5c42c9dc29c$var$handlingRangeError
], $34e3e5c42c9dc29c$var$BinaryReader.prototype, "readU16", null);
$34e3e5c42c9dc29c$var$__decorate([
    $34e3e5c42c9dc29c$var$handlingRangeError
], $34e3e5c42c9dc29c$var$BinaryReader.prototype, "readU32", null);
$34e3e5c42c9dc29c$var$__decorate([
    $34e3e5c42c9dc29c$var$handlingRangeError
], $34e3e5c42c9dc29c$var$BinaryReader.prototype, "readU64", null);
$34e3e5c42c9dc29c$var$__decorate([
    $34e3e5c42c9dc29c$var$handlingRangeError
], $34e3e5c42c9dc29c$var$BinaryReader.prototype, "readU128", null);
$34e3e5c42c9dc29c$var$__decorate([
    $34e3e5c42c9dc29c$var$handlingRangeError
], $34e3e5c42c9dc29c$var$BinaryReader.prototype, "readU256", null);
$34e3e5c42c9dc29c$var$__decorate([
    $34e3e5c42c9dc29c$var$handlingRangeError
], $34e3e5c42c9dc29c$var$BinaryReader.prototype, "readU512", null);
$34e3e5c42c9dc29c$var$__decorate([
    $34e3e5c42c9dc29c$var$handlingRangeError
], $34e3e5c42c9dc29c$var$BinaryReader.prototype, "readString", null);
$34e3e5c42c9dc29c$var$__decorate([
    $34e3e5c42c9dc29c$var$handlingRangeError
], $34e3e5c42c9dc29c$var$BinaryReader.prototype, "readFixedArray", null);
$34e3e5c42c9dc29c$var$__decorate([
    $34e3e5c42c9dc29c$var$handlingRangeError
], $34e3e5c42c9dc29c$var$BinaryReader.prototype, "readArray", null);
$34e3e5c42c9dc29c$exports.BinaryReader = $34e3e5c42c9dc29c$var$BinaryReader;
function $34e3e5c42c9dc29c$var$capitalizeFirstLetter(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
}
function $34e3e5c42c9dc29c$var$serializeField(schema, fieldName, value, fieldType, writer) {
    try {
        // TODO: Handle missing values properly (make sure they never result in just skipped write)
        if (typeof fieldType === "string") writer[`write${$34e3e5c42c9dc29c$var$capitalizeFirstLetter(fieldType)}`](value);
        else if (fieldType instanceof Array) {
            if (typeof fieldType[0] === "number") {
                if (value.length !== fieldType[0]) throw new $34e3e5c42c9dc29c$var$BorshError(`Expecting byte array of length ${fieldType[0]}, but got ${value.length} bytes`);
                writer.writeFixedArray(value);
            } else if (fieldType.length === 2 && typeof fieldType[1] === "number") {
                if (value.length !== fieldType[1]) throw new $34e3e5c42c9dc29c$var$BorshError(`Expecting byte array of length ${fieldType[1]}, but got ${value.length} bytes`);
                for(let i = 0; i < fieldType[1]; i++)$34e3e5c42c9dc29c$var$serializeField(schema, null, value[i], fieldType[0], writer);
            } else writer.writeArray(value, (item)=>{
                $34e3e5c42c9dc29c$var$serializeField(schema, fieldName, item, fieldType[0], writer);
            });
        } else if (fieldType.kind !== undefined) switch(fieldType.kind){
            case "option":
                if (value === null || value === undefined) writer.writeU8(0);
                else {
                    writer.writeU8(1);
                    $34e3e5c42c9dc29c$var$serializeField(schema, fieldName, value, fieldType.type, writer);
                }
                break;
            case "map":
                writer.writeU32(value.size);
                value.forEach((val, key)=>{
                    $34e3e5c42c9dc29c$var$serializeField(schema, fieldName, key, fieldType.key, writer);
                    $34e3e5c42c9dc29c$var$serializeField(schema, fieldName, val, fieldType.value, writer);
                });
                break;
            default:
                throw new $34e3e5c42c9dc29c$var$BorshError(`FieldType ${fieldType} unrecognized`);
        }
        else $34e3e5c42c9dc29c$var$serializeStruct(schema, value, writer);
    } catch (error) {
        if (error instanceof $34e3e5c42c9dc29c$var$BorshError) error.addToFieldPath(fieldName);
        throw error;
    }
}
function $34e3e5c42c9dc29c$var$serializeStruct(schema, obj, writer) {
    if (typeof obj.borshSerialize === "function") {
        obj.borshSerialize(writer);
        return;
    }
    const structSchema = schema.get(obj.constructor);
    if (!structSchema) throw new $34e3e5c42c9dc29c$var$BorshError(`Class ${obj.constructor.name} is missing in schema`);
    if (structSchema.kind === "struct") structSchema.fields.map(([fieldName, fieldType])=>{
        $34e3e5c42c9dc29c$var$serializeField(schema, fieldName, obj[fieldName], fieldType, writer);
    });
    else if (structSchema.kind === "enum") {
        const name = obj[structSchema.field];
        for(let idx = 0; idx < structSchema.values.length; ++idx){
            const [fieldName, fieldType] = structSchema.values[idx];
            if (fieldName === name) {
                writer.writeU8(idx);
                $34e3e5c42c9dc29c$var$serializeField(schema, fieldName, obj[fieldName], fieldType, writer);
                break;
            }
        }
    } else throw new $34e3e5c42c9dc29c$var$BorshError(`Unexpected schema kind: ${structSchema.kind} for ${obj.constructor.name}`);
}
/// Serialize given object using schema of the form:
/// { class_name -> [ [field_name, field_type], .. ], .. }
function $34e3e5c42c9dc29c$var$serialize(schema, obj, Writer = $34e3e5c42c9dc29c$var$BinaryWriter) {
    const writer = new Writer();
    $34e3e5c42c9dc29c$var$serializeStruct(schema, obj, writer);
    return writer.toArray();
}
$34e3e5c42c9dc29c$exports.serialize = $34e3e5c42c9dc29c$var$serialize;
function $34e3e5c42c9dc29c$var$deserializeField(schema, fieldName, fieldType, reader) {
    try {
        if (typeof fieldType === "string") return reader[`read${$34e3e5c42c9dc29c$var$capitalizeFirstLetter(fieldType)}`]();
        if (fieldType instanceof Array) {
            if (typeof fieldType[0] === "number") return reader.readFixedArray(fieldType[0]);
            else if (typeof fieldType[1] === "number") {
                const arr = [];
                for(let i = 0; i < fieldType[1]; i++)arr.push($34e3e5c42c9dc29c$var$deserializeField(schema, null, fieldType[0], reader));
                return arr;
            } else return reader.readArray(()=>$34e3e5c42c9dc29c$var$deserializeField(schema, fieldName, fieldType[0], reader));
        }
        if (fieldType.kind === "option") {
            const option = reader.readU8();
            if (option) return $34e3e5c42c9dc29c$var$deserializeField(schema, fieldName, fieldType.type, reader);
            return undefined;
        }
        if (fieldType.kind === "map") {
            let map = new Map();
            const length = reader.readU32();
            for(let i = 0; i < length; i++){
                const key = $34e3e5c42c9dc29c$var$deserializeField(schema, fieldName, fieldType.key, reader);
                const val = $34e3e5c42c9dc29c$var$deserializeField(schema, fieldName, fieldType.value, reader);
                map.set(key, val);
            }
            return map;
        }
        return $34e3e5c42c9dc29c$var$deserializeStruct(schema, fieldType, reader);
    } catch (error) {
        if (error instanceof $34e3e5c42c9dc29c$var$BorshError) error.addToFieldPath(fieldName);
        throw error;
    }
}
function $34e3e5c42c9dc29c$var$deserializeStruct(schema, classType, reader) {
    if (typeof classType.borshDeserialize === "function") return classType.borshDeserialize(reader);
    const structSchema = schema.get(classType);
    if (!structSchema) throw new $34e3e5c42c9dc29c$var$BorshError(`Class ${classType.name} is missing in schema`);
    if (structSchema.kind === "struct") {
        const result = {};
        for (const [fieldName, fieldType] of schema.get(classType).fields)result[fieldName] = $34e3e5c42c9dc29c$var$deserializeField(schema, fieldName, fieldType, reader);
        return new classType(result);
    }
    if (structSchema.kind === "enum") {
        const idx = reader.readU8();
        if (idx >= structSchema.values.length) throw new $34e3e5c42c9dc29c$var$BorshError(`Enum index: ${idx} is out of range`);
        const [fieldName, fieldType] = structSchema.values[idx];
        const fieldValue = $34e3e5c42c9dc29c$var$deserializeField(schema, fieldName, fieldType, reader);
        return new classType({
            [fieldName]: fieldValue
        });
    }
    throw new $34e3e5c42c9dc29c$var$BorshError(`Unexpected schema kind: ${structSchema.kind} for ${classType.constructor.name}`);
}
/// Deserializes object from bytes using schema.
function $34e3e5c42c9dc29c$var$deserialize(schema, classType, buffer, Reader = $34e3e5c42c9dc29c$var$BinaryReader) {
    const reader = new Reader(buffer);
    const result = $34e3e5c42c9dc29c$var$deserializeStruct(schema, classType, reader);
    if (reader.offset < buffer.length) throw new $34e3e5c42c9dc29c$var$BorshError(`Unexpected ${buffer.length - reader.offset} bytes after deserialized data`);
    return result;
}
$34e3e5c42c9dc29c$exports.deserialize = $34e3e5c42c9dc29c$var$deserialize;
/// Deserializes object from bytes using schema, without checking the length read
function $34e3e5c42c9dc29c$var$deserializeUnchecked(schema, classType, buffer, Reader = $34e3e5c42c9dc29c$var$BinaryReader) {
    const reader = new Reader(buffer);
    return $34e3e5c42c9dc29c$var$deserializeStruct(schema, classType, reader);
}
$34e3e5c42c9dc29c$exports.deserializeUnchecked = $34e3e5c42c9dc29c$var$deserializeUnchecked;


var $2913ed74210dce84$exports = {};
/* The MIT License (MIT)
 *
 * Copyright 2015-2018 Peter A. Bigot
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 */ /**
 * Support for translating between Uint8Array instances and JavaScript
 * native types.
 *
 * {@link module:Layout~Layout|Layout} is the basis of a class
 * hierarchy that associates property names with sequences of encoded
 * bytes.
 *
 * Layouts are supported for these scalar (numeric) types:
 * * {@link module:Layout~UInt|Unsigned integers in little-endian
 *   format} with {@link module:Layout.u8|8-bit}, {@link
 *   module:Layout.u16|16-bit}, {@link module:Layout.u24|24-bit},
 *   {@link module:Layout.u32|32-bit}, {@link
 *   module:Layout.u40|40-bit}, and {@link module:Layout.u48|48-bit}
 *   representation ranges;
 * * {@link module:Layout~UIntBE|Unsigned integers in big-endian
 *   format} with {@link module:Layout.u16be|16-bit}, {@link
 *   module:Layout.u24be|24-bit}, {@link module:Layout.u32be|32-bit},
 *   {@link module:Layout.u40be|40-bit}, and {@link
 *   module:Layout.u48be|48-bit} representation ranges;
 * * {@link module:Layout~Int|Signed integers in little-endian
 *   format} with {@link module:Layout.s8|8-bit}, {@link
 *   module:Layout.s16|16-bit}, {@link module:Layout.s24|24-bit},
 *   {@link module:Layout.s32|32-bit}, {@link
 *   module:Layout.s40|40-bit}, and {@link module:Layout.s48|48-bit}
 *   representation ranges;
 * * {@link module:Layout~IntBE|Signed integers in big-endian format}
 *   with {@link module:Layout.s16be|16-bit}, {@link
 *   module:Layout.s24be|24-bit}, {@link module:Layout.s32be|32-bit},
 *   {@link module:Layout.s40be|40-bit}, and {@link
 *   module:Layout.s48be|48-bit} representation ranges;
 * * 64-bit integral values that decode to an exact (if magnitude is
 *   less than 2^53) or nearby integral Number in {@link
 *   module:Layout.nu64|unsigned little-endian}, {@link
 *   module:Layout.nu64be|unsigned big-endian}, {@link
 *   module:Layout.ns64|signed little-endian}, and {@link
 *   module:Layout.ns64be|unsigned big-endian} encodings;
 * * 32-bit floating point values with {@link
 *   module:Layout.f32|little-endian} and {@link
 *   module:Layout.f32be|big-endian} representations;
 * * 64-bit floating point values with {@link
 *   module:Layout.f64|little-endian} and {@link
 *   module:Layout.f64be|big-endian} representations;
 * * {@link module:Layout.const|Constants} that take no space in the
 *   encoded expression.
 *
 * and for these aggregate types:
 * * {@link module:Layout.seq|Sequence}s of instances of a {@link
 *   module:Layout~Layout|Layout}, with JavaScript representation as
 *   an Array and constant or data-dependent {@link
 *   module:Layout~Sequence#count|length};
 * * {@link module:Layout.struct|Structure}s that aggregate a
 *   heterogeneous sequence of {@link module:Layout~Layout|Layout}
 *   instances, with JavaScript representation as an Object;
 * * {@link module:Layout.union|Union}s that support multiple {@link
 *   module:Layout~VariantLayout|variant layouts} over a fixed
 *   (padded) or variable (not padded) span of bytes, using an
 *   unsigned integer at the start of the data or a separate {@link
 *   module:Layout.unionLayoutDiscriminator|layout element} to
 *   determine which layout to use when interpreting the buffer
 *   contents;
 * * {@link module:Layout.bits|BitStructure}s that contain a sequence
 *   of individual {@link
 *   module:Layout~BitStructure#addField|BitField}s packed into an 8,
 *   16, 24, or 32-bit unsigned integer starting at the least- or
 *   most-significant bit;
 * * {@link module:Layout.cstr|C strings} of varying length;
 * * {@link module:Layout.blob|Blobs} of fixed- or variable-{@link
 *   module:Layout~Blob#length|length} raw data.
 *
 * All {@link module:Layout~Layout|Layout} instances are immutable
 * after construction, to prevent internal state from becoming
 * inconsistent.
 *
 * @local Layout
 * @local ExternalLayout
 * @local GreedyCount
 * @local OffsetLayout
 * @local UInt
 * @local UIntBE
 * @local Int
 * @local IntBE
 * @local NearUInt64
 * @local NearUInt64BE
 * @local NearInt64
 * @local NearInt64BE
 * @local Float
 * @local FloatBE
 * @local Double
 * @local DoubleBE
 * @local Sequence
 * @local Structure
 * @local UnionDiscriminator
 * @local UnionLayoutDiscriminator
 * @local Union
 * @local VariantLayout
 * @local BitStructure
 * @local BitField
 * @local Boolean
 * @local Blob
 * @local CString
 * @local Constant
 * @local bindConstructorLayout
 * @module Layout
 * @license MIT
 * @author Peter A. Bigot
 * @see {@link https://github.com/pabigot/buffer-layout|buffer-layout on GitHub}
 */ "use strict";
Object.defineProperty($2913ed74210dce84$exports, "__esModule", {
    value: true
});
$2913ed74210dce84$exports.s16 = $2913ed74210dce84$exports.s8 = $2913ed74210dce84$exports.nu64be = $2913ed74210dce84$exports.u48be = $2913ed74210dce84$exports.u40be = $2913ed74210dce84$exports.u32be = $2913ed74210dce84$exports.u24be = $2913ed74210dce84$exports.u16be = $2913ed74210dce84$exports.nu64 = $2913ed74210dce84$exports.u48 = $2913ed74210dce84$exports.u40 = $2913ed74210dce84$exports.u32 = $2913ed74210dce84$exports.u24 = $2913ed74210dce84$exports.u16 = $2913ed74210dce84$exports.u8 = $2913ed74210dce84$exports.offset = $2913ed74210dce84$exports.greedy = $2913ed74210dce84$exports.Constant = $2913ed74210dce84$exports.UTF8 = $2913ed74210dce84$exports.CString = $2913ed74210dce84$exports.Blob = $2913ed74210dce84$exports.Boolean = $2913ed74210dce84$exports.BitField = $2913ed74210dce84$exports.BitStructure = $2913ed74210dce84$exports.VariantLayout = $2913ed74210dce84$exports.Union = $2913ed74210dce84$exports.UnionLayoutDiscriminator = $2913ed74210dce84$exports.UnionDiscriminator = $2913ed74210dce84$exports.Structure = $2913ed74210dce84$exports.Sequence = $2913ed74210dce84$exports.DoubleBE = $2913ed74210dce84$exports.Double = $2913ed74210dce84$exports.FloatBE = $2913ed74210dce84$exports.Float = $2913ed74210dce84$exports.NearInt64BE = $2913ed74210dce84$exports.NearInt64 = $2913ed74210dce84$exports.NearUInt64BE = $2913ed74210dce84$exports.NearUInt64 = $2913ed74210dce84$exports.IntBE = $2913ed74210dce84$exports.Int = $2913ed74210dce84$exports.UIntBE = $2913ed74210dce84$exports.UInt = $2913ed74210dce84$exports.OffsetLayout = $2913ed74210dce84$exports.GreedyCount = $2913ed74210dce84$exports.ExternalLayout = $2913ed74210dce84$exports.bindConstructorLayout = $2913ed74210dce84$exports.nameWithProperty = $2913ed74210dce84$exports.Layout = $2913ed74210dce84$exports.uint8ArrayToBuffer = $2913ed74210dce84$exports.checkUint8Array = void 0;
$2913ed74210dce84$exports.constant = $2913ed74210dce84$exports.utf8 = $2913ed74210dce84$exports.cstr = $2913ed74210dce84$exports.blob = $2913ed74210dce84$exports.unionLayoutDiscriminator = $2913ed74210dce84$exports.union = $2913ed74210dce84$exports.seq = $2913ed74210dce84$exports.bits = $2913ed74210dce84$exports.struct = $2913ed74210dce84$exports.f64be = $2913ed74210dce84$exports.f64 = $2913ed74210dce84$exports.f32be = $2913ed74210dce84$exports.f32 = $2913ed74210dce84$exports.ns64be = $2913ed74210dce84$exports.s48be = $2913ed74210dce84$exports.s40be = $2913ed74210dce84$exports.s32be = $2913ed74210dce84$exports.s24be = $2913ed74210dce84$exports.s16be = $2913ed74210dce84$exports.ns64 = $2913ed74210dce84$exports.s48 = $2913ed74210dce84$exports.s40 = $2913ed74210dce84$exports.s32 = $2913ed74210dce84$exports.s24 = void 0;
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ var $5f7a215ef2b330e3$export$a143d493d941bafc;
var $5f7a215ef2b330e3$export$e4cf37d7f6fb9e0a;
var $5f7a215ef2b330e3$export$f99ded8fe4b79145;
var $5f7a215ef2b330e3$export$599f31c3813fae4d;
"use strict";

var $hqZtu = parcelRequire("hqZtu");

var $5WQj6 = parcelRequire("5WQj6");
const $5f7a215ef2b330e3$var$customInspectSymbol = typeof Symbol === "function" && typeof Symbol["for"] === "function" // eslint-disable-line dot-notation
 ? Symbol["for"]("nodejs.util.inspect.custom") // eslint-disable-line dot-notation
 : null;
$5f7a215ef2b330e3$export$a143d493d941bafc = $5f7a215ef2b330e3$var$Buffer;
$5f7a215ef2b330e3$export$e4cf37d7f6fb9e0a = $5f7a215ef2b330e3$var$SlowBuffer;
$5f7a215ef2b330e3$export$f99ded8fe4b79145 = 50;
const $5f7a215ef2b330e3$var$K_MAX_LENGTH = 0x7fffffff;
$5f7a215ef2b330e3$export$599f31c3813fae4d = $5f7a215ef2b330e3$var$K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ $5f7a215ef2b330e3$var$Buffer.TYPED_ARRAY_SUPPORT = $5f7a215ef2b330e3$var$typedArraySupport();
if (!$5f7a215ef2b330e3$var$Buffer.TYPED_ARRAY_SUPPORT && typeof console !== "undefined" && typeof console.error === "function") console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function $5f7a215ef2b330e3$var$typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        const arr = new Uint8Array(1);
        const proto = {
            foo: function() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty($5f7a215ef2b330e3$var$Buffer.prototype, "parent", {
    enumerable: true,
    get: function() {
        if (!$5f7a215ef2b330e3$var$Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty($5f7a215ef2b330e3$var$Buffer.prototype, "offset", {
    enumerable: true,
    get: function() {
        if (!$5f7a215ef2b330e3$var$Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function $5f7a215ef2b330e3$var$createBuffer(length) {
    if (length > $5f7a215ef2b330e3$var$K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    const buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, $5f7a215ef2b330e3$var$Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $5f7a215ef2b330e3$var$Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === "number") {
        if (typeof encodingOrOffset === "string") throw new TypeError('The "string" argument must be of type string. Received type number');
        return $5f7a215ef2b330e3$var$allocUnsafe(arg);
    }
    return $5f7a215ef2b330e3$var$from(arg, encodingOrOffset, length);
}
$5f7a215ef2b330e3$var$Buffer.poolSize = 8192 // not used by this implementation
;
function $5f7a215ef2b330e3$var$from(value, encodingOrOffset, length) {
    if (typeof value === "string") return $5f7a215ef2b330e3$var$fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return $5f7a215ef2b330e3$var$fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
    if ($5f7a215ef2b330e3$var$isInstance(value, ArrayBuffer) || value && $5f7a215ef2b330e3$var$isInstance(value.buffer, ArrayBuffer)) return $5f7a215ef2b330e3$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== "undefined" && ($5f7a215ef2b330e3$var$isInstance(value, SharedArrayBuffer) || value && $5f7a215ef2b330e3$var$isInstance(value.buffer, SharedArrayBuffer))) return $5f7a215ef2b330e3$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === "number") throw new TypeError('The "value" argument must not be of type number. Received type number');
    const valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return $5f7a215ef2b330e3$var$Buffer.from(valueOf, encodingOrOffset, length);
    const b = $5f7a215ef2b330e3$var$fromObject(value);
    if (b) return b;
    if (typeof Symbol !== "undefined" && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === "function") return $5f7a215ef2b330e3$var$Buffer.from(value[Symbol.toPrimitive]("string"), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $5f7a215ef2b330e3$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $5f7a215ef2b330e3$var$from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf($5f7a215ef2b330e3$var$Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf($5f7a215ef2b330e3$var$Buffer, Uint8Array);
function $5f7a215ef2b330e3$var$assertSize(size) {
    if (typeof size !== "number") throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function $5f7a215ef2b330e3$var$alloc(size, fill, encoding) {
    $5f7a215ef2b330e3$var$assertSize(size);
    if (size <= 0) return $5f7a215ef2b330e3$var$createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === "string" ? $5f7a215ef2b330e3$var$createBuffer(size).fill(fill, encoding) : $5f7a215ef2b330e3$var$createBuffer(size).fill(fill);
    return $5f7a215ef2b330e3$var$createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $5f7a215ef2b330e3$var$Buffer.alloc = function(size, fill, encoding) {
    return $5f7a215ef2b330e3$var$alloc(size, fill, encoding);
};
function $5f7a215ef2b330e3$var$allocUnsafe(size) {
    $5f7a215ef2b330e3$var$assertSize(size);
    return $5f7a215ef2b330e3$var$createBuffer(size < 0 ? 0 : $5f7a215ef2b330e3$var$checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $5f7a215ef2b330e3$var$Buffer.allocUnsafe = function(size) {
    return $5f7a215ef2b330e3$var$allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $5f7a215ef2b330e3$var$Buffer.allocUnsafeSlow = function(size) {
    return $5f7a215ef2b330e3$var$allocUnsafe(size);
};
function $5f7a215ef2b330e3$var$fromString(string, encoding) {
    if (typeof encoding !== "string" || encoding === "") encoding = "utf8";
    if (!$5f7a215ef2b330e3$var$Buffer.isEncoding(encoding)) throw new TypeError("Unknown encoding: " + encoding);
    const length = $5f7a215ef2b330e3$var$byteLength(string, encoding) | 0;
    let buf = $5f7a215ef2b330e3$var$createBuffer(length);
    const actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function $5f7a215ef2b330e3$var$fromArrayLike(array) {
    const length = array.length < 0 ? 0 : $5f7a215ef2b330e3$var$checked(array.length) | 0;
    const buf = $5f7a215ef2b330e3$var$createBuffer(length);
    for(let i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function $5f7a215ef2b330e3$var$fromArrayView(arrayView) {
    if ($5f7a215ef2b330e3$var$isInstance(arrayView, Uint8Array)) {
        const copy = new Uint8Array(arrayView);
        return $5f7a215ef2b330e3$var$fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return $5f7a215ef2b330e3$var$fromArrayLike(arrayView);
}
function $5f7a215ef2b330e3$var$fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    let buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, $5f7a215ef2b330e3$var$Buffer.prototype);
    return buf;
}
function $5f7a215ef2b330e3$var$fromObject(obj) {
    if ($5f7a215ef2b330e3$var$Buffer.isBuffer(obj)) {
        const len = $5f7a215ef2b330e3$var$checked(obj.length) | 0;
        const buf = $5f7a215ef2b330e3$var$createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== "number" || $5f7a215ef2b330e3$var$numberIsNaN(obj.length)) return $5f7a215ef2b330e3$var$createBuffer(0);
        return $5f7a215ef2b330e3$var$fromArrayLike(obj);
    }
    if (obj.type === "Buffer" && Array.isArray(obj.data)) return $5f7a215ef2b330e3$var$fromArrayLike(obj.data);
}
function $5f7a215ef2b330e3$var$checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $5f7a215ef2b330e3$var$K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $5f7a215ef2b330e3$var$K_MAX_LENGTH.toString(16) + " bytes");
    return length | 0;
}
function $5f7a215ef2b330e3$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $5f7a215ef2b330e3$var$Buffer.alloc(+length);
}
$5f7a215ef2b330e3$var$Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== $5f7a215ef2b330e3$var$Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
$5f7a215ef2b330e3$var$Buffer.compare = function compare(a, b) {
    if ($5f7a215ef2b330e3$var$isInstance(a, Uint8Array)) a = $5f7a215ef2b330e3$var$Buffer.from(a, a.offset, a.byteLength);
    if ($5f7a215ef2b330e3$var$isInstance(b, Uint8Array)) b = $5f7a215ef2b330e3$var$Buffer.from(b, b.offset, b.byteLength);
    if (!$5f7a215ef2b330e3$var$Buffer.isBuffer(a) || !$5f7a215ef2b330e3$var$Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    let x = a.length;
    let y = b.length;
    for(let i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$5f7a215ef2b330e3$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case "hex":
        case "utf8":
        case "utf-8":
        case "ascii":
        case "latin1":
        case "binary":
        case "base64":
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return true;
        default:
            return false;
    }
};
$5f7a215ef2b330e3$var$Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $5f7a215ef2b330e3$var$Buffer.alloc(0);
    let i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    const buffer = $5f7a215ef2b330e3$var$Buffer.allocUnsafe(length);
    let pos = 0;
    for(i = 0; i < list.length; ++i){
        let buf = list[i];
        if ($5f7a215ef2b330e3$var$isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) {
                if (!$5f7a215ef2b330e3$var$Buffer.isBuffer(buf)) buf = $5f7a215ef2b330e3$var$Buffer.from(buf);
                buf.copy(buffer, pos);
            } else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!$5f7a215ef2b330e3$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $5f7a215ef2b330e3$var$byteLength(string, encoding) {
    if ($5f7a215ef2b330e3$var$Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || $5f7a215ef2b330e3$var$isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== "string") throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string);
    const len = string.length;
    const mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    let loweredCase = false;
    for(;;)switch(encoding){
        case "ascii":
        case "latin1":
        case "binary":
            return len;
        case "utf8":
        case "utf-8":
            return $5f7a215ef2b330e3$var$utf8ToBytes(string).length;
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return len * 2;
        case "hex":
            return len >>> 1;
        case "base64":
            return $5f7a215ef2b330e3$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : $5f7a215ef2b330e3$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ("" + encoding).toLowerCase();
            loweredCase = true;
    }
}
$5f7a215ef2b330e3$var$Buffer.byteLength = $5f7a215ef2b330e3$var$byteLength;
function $5f7a215ef2b330e3$var$slowToString(encoding, start, end) {
    let loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return "";
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return "";
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return "";
    if (!encoding) encoding = "utf8";
    while(true)switch(encoding){
        case "hex":
            return $5f7a215ef2b330e3$var$hexSlice(this, start, end);
        case "utf8":
        case "utf-8":
            return $5f7a215ef2b330e3$var$utf8Slice(this, start, end);
        case "ascii":
            return $5f7a215ef2b330e3$var$asciiSlice(this, start, end);
        case "latin1":
        case "binary":
            return $5f7a215ef2b330e3$var$latin1Slice(this, start, end);
        case "base64":
            return $5f7a215ef2b330e3$var$base64Slice(this, start, end);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return $5f7a215ef2b330e3$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
            encoding = (encoding + "").toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
$5f7a215ef2b330e3$var$Buffer.prototype._isBuffer = true;
function $5f7a215ef2b330e3$var$swap(b, n, m) {
    const i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$5f7a215ef2b330e3$var$Buffer.prototype.swap16 = function swap16() {
    const len = this.length;
    if (len % 2 !== 0) throw new RangeError("Buffer size must be a multiple of 16-bits");
    for(let i = 0; i < len; i += 2)$5f7a215ef2b330e3$var$swap(this, i, i + 1);
    return this;
};
$5f7a215ef2b330e3$var$Buffer.prototype.swap32 = function swap32() {
    const len = this.length;
    if (len % 4 !== 0) throw new RangeError("Buffer size must be a multiple of 32-bits");
    for(let i = 0; i < len; i += 4){
        $5f7a215ef2b330e3$var$swap(this, i, i + 3);
        $5f7a215ef2b330e3$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$5f7a215ef2b330e3$var$Buffer.prototype.swap64 = function swap64() {
    const len = this.length;
    if (len % 8 !== 0) throw new RangeError("Buffer size must be a multiple of 64-bits");
    for(let i = 0; i < len; i += 8){
        $5f7a215ef2b330e3$var$swap(this, i, i + 7);
        $5f7a215ef2b330e3$var$swap(this, i + 1, i + 6);
        $5f7a215ef2b330e3$var$swap(this, i + 2, i + 5);
        $5f7a215ef2b330e3$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$5f7a215ef2b330e3$var$Buffer.prototype.toString = function toString() {
    const length = this.length;
    if (length === 0) return "";
    if (arguments.length === 0) return $5f7a215ef2b330e3$var$utf8Slice(this, 0, length);
    return $5f7a215ef2b330e3$var$slowToString.apply(this, arguments);
};
$5f7a215ef2b330e3$var$Buffer.prototype.toLocaleString = $5f7a215ef2b330e3$var$Buffer.prototype.toString;
$5f7a215ef2b330e3$var$Buffer.prototype.equals = function equals(b) {
    if (!$5f7a215ef2b330e3$var$Buffer.isBuffer(b)) throw new TypeError("Argument must be a Buffer");
    if (this === b) return true;
    return $5f7a215ef2b330e3$var$Buffer.compare(this, b) === 0;
};
$5f7a215ef2b330e3$var$Buffer.prototype.inspect = function inspect() {
    let str = "";
    const max = $5f7a215ef2b330e3$export$f99ded8fe4b79145;
    str = this.toString("hex", 0, max).replace(/(.{2})/g, "$1 ").trim();
    if (this.length > max) str += " ... ";
    return "<Buffer " + str + ">";
};
if ($5f7a215ef2b330e3$var$customInspectSymbol) $5f7a215ef2b330e3$var$Buffer.prototype[$5f7a215ef2b330e3$var$customInspectSymbol] = $5f7a215ef2b330e3$var$Buffer.prototype.inspect;
$5f7a215ef2b330e3$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if ($5f7a215ef2b330e3$var$isInstance(target, Uint8Array)) target = $5f7a215ef2b330e3$var$Buffer.from(target, target.offset, target.byteLength);
    if (!$5f7a215ef2b330e3$var$Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target);
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError("out of range index");
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    let x = thisEnd - thisStart;
    let y = end - start;
    const len = Math.min(x, y);
    const thisCopy = this.slice(thisStart, thisEnd);
    const targetCopy = target.slice(start, end);
    for(let i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $5f7a215ef2b330e3$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === "string") {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if ($5f7a215ef2b330e3$var$numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === "string") val = $5f7a215ef2b330e3$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($5f7a215ef2b330e3$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $5f7a215ef2b330e3$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === "number") {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === "function") {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $5f7a215ef2b330e3$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError("val must be string, number or Buffer");
}
function $5f7a215ef2b330e3$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    let indexSize = 1;
    let arrLength = arr.length;
    let valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === "ucs2" || encoding === "ucs-2" || encoding === "utf16le" || encoding === "utf-16le") {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    let i;
    if (dir) {
        let foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            let found = true;
            for(let j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$5f7a215ef2b330e3$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$5f7a215ef2b330e3$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $5f7a215ef2b330e3$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$5f7a215ef2b330e3$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $5f7a215ef2b330e3$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $5f7a215ef2b330e3$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    const remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    const strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    let i;
    for(i = 0; i < length; ++i){
        const parsed = parseInt(string.substr(i * 2, 2), 16);
        if ($5f7a215ef2b330e3$var$numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $5f7a215ef2b330e3$var$utf8Write(buf, string, offset, length) {
    return $5f7a215ef2b330e3$var$blitBuffer($5f7a215ef2b330e3$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $5f7a215ef2b330e3$var$asciiWrite(buf, string, offset, length) {
    return $5f7a215ef2b330e3$var$blitBuffer($5f7a215ef2b330e3$var$asciiToBytes(string), buf, offset, length);
}
function $5f7a215ef2b330e3$var$base64Write(buf, string, offset, length) {
    return $5f7a215ef2b330e3$var$blitBuffer($5f7a215ef2b330e3$var$base64ToBytes(string), buf, offset, length);
}
function $5f7a215ef2b330e3$var$ucs2Write(buf, string, offset, length) {
    return $5f7a215ef2b330e3$var$blitBuffer($5f7a215ef2b330e3$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$5f7a215ef2b330e3$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = "utf8";
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === "string") {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = "utf8";
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error("Buffer.write(string, encoding, offset[, length]) is no longer supported");
    const remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError("Attempt to write outside buffer bounds");
    if (!encoding) encoding = "utf8";
    let loweredCase = false;
    for(;;)switch(encoding){
        case "hex":
            return $5f7a215ef2b330e3$var$hexWrite(this, string, offset, length);
        case "utf8":
        case "utf-8":
            return $5f7a215ef2b330e3$var$utf8Write(this, string, offset, length);
        case "ascii":
        case "latin1":
        case "binary":
            return $5f7a215ef2b330e3$var$asciiWrite(this, string, offset, length);
        case "base64":
            // Warning: maxLength not taken into account in base64Write
            return $5f7a215ef2b330e3$var$base64Write(this, string, offset, length);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return $5f7a215ef2b330e3$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
            encoding = ("" + encoding).toLowerCase();
            loweredCase = true;
    }
};
$5f7a215ef2b330e3$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: "Buffer",
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $5f7a215ef2b330e3$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $hqZtu.fromByteArray(buf);
    else return $hqZtu.fromByteArray(buf.slice(start, end));
}
function $5f7a215ef2b330e3$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    const res = [];
    let i = start;
    while(i < end){
        const firstByte = buf[i];
        let codePoint = null;
        let bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            let secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $5f7a215ef2b330e3$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
const $5f7a215ef2b330e3$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $5f7a215ef2b330e3$var$decodeCodePointsArray(codePoints) {
    const len = codePoints.length;
    if (len <= $5f7a215ef2b330e3$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    let res = "";
    let i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $5f7a215ef2b330e3$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $5f7a215ef2b330e3$var$asciiSlice(buf, start, end) {
    let ret = "";
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $5f7a215ef2b330e3$var$latin1Slice(buf, start, end) {
    let ret = "";
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $5f7a215ef2b330e3$var$hexSlice(buf, start, end) {
    const len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    let out = "";
    for(let i = start; i < end; ++i)out += $5f7a215ef2b330e3$var$hexSliceLookupTable[buf[i]];
    return out;
}
function $5f7a215ef2b330e3$var$utf16leSlice(buf, start, end) {
    const bytes = buf.slice(start, end);
    let res = "";
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(let i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$5f7a215ef2b330e3$var$Buffer.prototype.slice = function slice(start, end) {
    const len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    const newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, $5f7a215ef2b330e3$var$Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $5f7a215ef2b330e3$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError("offset is not uint");
    if (offset + ext > length) throw new RangeError("Trying to access beyond buffer length");
}
$5f7a215ef2b330e3$var$Buffer.prototype.readUintLE = $5f7a215ef2b330e3$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $5f7a215ef2b330e3$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$5f7a215ef2b330e3$var$Buffer.prototype.readUintBE = $5f7a215ef2b330e3$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $5f7a215ef2b330e3$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset + --byteLength];
    let mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$5f7a215ef2b330e3$var$Buffer.prototype.readUint8 = $5f7a215ef2b330e3$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $5f7a215ef2b330e3$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$5f7a215ef2b330e3$var$Buffer.prototype.readUint16LE = $5f7a215ef2b330e3$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $5f7a215ef2b330e3$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$5f7a215ef2b330e3$var$Buffer.prototype.readUint16BE = $5f7a215ef2b330e3$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $5f7a215ef2b330e3$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$5f7a215ef2b330e3$var$Buffer.prototype.readUint32LE = $5f7a215ef2b330e3$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $5f7a215ef2b330e3$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$5f7a215ef2b330e3$var$Buffer.prototype.readUint32BE = $5f7a215ef2b330e3$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $5f7a215ef2b330e3$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$5f7a215ef2b330e3$var$Buffer.prototype.readBigUInt64LE = $5f7a215ef2b330e3$var$defineBigIntMethod(function readBigUInt64LE(offset) {
    offset = offset >>> 0;
    $5f7a215ef2b330e3$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $5f7a215ef2b330e3$var$boundsError(offset, this.length - 8);
    const lo = first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24;
    const hi = this[++offset] + this[++offset] * 256 + this[++offset] * 2 ** 16 + last * 2 ** 24;
    return BigInt(lo) + (BigInt(hi) << BigInt(32));
});
$5f7a215ef2b330e3$var$Buffer.prototype.readBigUInt64BE = $5f7a215ef2b330e3$var$defineBigIntMethod(function readBigUInt64BE(offset) {
    offset = offset >>> 0;
    $5f7a215ef2b330e3$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $5f7a215ef2b330e3$var$boundsError(offset, this.length - 8);
    const hi = first * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    const lo = this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last;
    return (BigInt(hi) << BigInt(32)) + BigInt(lo);
});
$5f7a215ef2b330e3$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $5f7a215ef2b330e3$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$5f7a215ef2b330e3$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $5f7a215ef2b330e3$var$checkOffset(offset, byteLength, this.length);
    let i = byteLength;
    let mul = 1;
    let val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$5f7a215ef2b330e3$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $5f7a215ef2b330e3$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$5f7a215ef2b330e3$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $5f7a215ef2b330e3$var$checkOffset(offset, 2, this.length);
    const val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$5f7a215ef2b330e3$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $5f7a215ef2b330e3$var$checkOffset(offset, 2, this.length);
    const val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$5f7a215ef2b330e3$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $5f7a215ef2b330e3$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$5f7a215ef2b330e3$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $5f7a215ef2b330e3$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$5f7a215ef2b330e3$var$Buffer.prototype.readBigInt64LE = $5f7a215ef2b330e3$var$defineBigIntMethod(function readBigInt64LE(offset) {
    offset = offset >>> 0;
    $5f7a215ef2b330e3$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $5f7a215ef2b330e3$var$boundsError(offset, this.length - 8);
    const val = this[offset + 4] + this[offset + 5] * 256 + this[offset + 6] * 2 ** 16 + (last << 24 // Overflow
    );
    return (BigInt(val) << BigInt(32)) + BigInt(first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24);
});
$5f7a215ef2b330e3$var$Buffer.prototype.readBigInt64BE = $5f7a215ef2b330e3$var$defineBigIntMethod(function readBigInt64BE(offset) {
    offset = offset >>> 0;
    $5f7a215ef2b330e3$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $5f7a215ef2b330e3$var$boundsError(offset, this.length - 8);
    const val = (first << 24) + // Overflow
    this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    return (BigInt(val) << BigInt(32)) + BigInt(this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last);
});
$5f7a215ef2b330e3$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $5f7a215ef2b330e3$var$checkOffset(offset, 4, this.length);
    return $5WQj6.read(this, offset, true, 23, 4);
};
$5f7a215ef2b330e3$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $5f7a215ef2b330e3$var$checkOffset(offset, 4, this.length);
    return $5WQj6.read(this, offset, false, 23, 4);
};
$5f7a215ef2b330e3$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $5f7a215ef2b330e3$var$checkOffset(offset, 8, this.length);
    return $5WQj6.read(this, offset, true, 52, 8);
};
$5f7a215ef2b330e3$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $5f7a215ef2b330e3$var$checkOffset(offset, 8, this.length);
    return $5WQj6.read(this, offset, false, 52, 8);
};
function $5f7a215ef2b330e3$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$5f7a215ef2b330e3$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError("Index out of range");
}
$5f7a215ef2b330e3$var$Buffer.prototype.writeUintLE = $5f7a215ef2b330e3$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $5f7a215ef2b330e3$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let mul = 1;
    let i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$5f7a215ef2b330e3$var$Buffer.prototype.writeUintBE = $5f7a215ef2b330e3$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $5f7a215ef2b330e3$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let i = byteLength - 1;
    let mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$5f7a215ef2b330e3$var$Buffer.prototype.writeUint8 = $5f7a215ef2b330e3$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $5f7a215ef2b330e3$var$checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
$5f7a215ef2b330e3$var$Buffer.prototype.writeUint16LE = $5f7a215ef2b330e3$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $5f7a215ef2b330e3$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$5f7a215ef2b330e3$var$Buffer.prototype.writeUint16BE = $5f7a215ef2b330e3$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $5f7a215ef2b330e3$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$5f7a215ef2b330e3$var$Buffer.prototype.writeUint32LE = $5f7a215ef2b330e3$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $5f7a215ef2b330e3$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
$5f7a215ef2b330e3$var$Buffer.prototype.writeUint32BE = $5f7a215ef2b330e3$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $5f7a215ef2b330e3$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function $5f7a215ef2b330e3$var$wrtBigUInt64LE(buf, value, offset, min, max) {
    $5f7a215ef2b330e3$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    return offset;
}
function $5f7a215ef2b330e3$var$wrtBigUInt64BE(buf, value, offset, min, max) {
    $5f7a215ef2b330e3$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset + 7] = lo;
    lo = lo >> 8;
    buf[offset + 6] = lo;
    lo = lo >> 8;
    buf[offset + 5] = lo;
    lo = lo >> 8;
    buf[offset + 4] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset + 3] = hi;
    hi = hi >> 8;
    buf[offset + 2] = hi;
    hi = hi >> 8;
    buf[offset + 1] = hi;
    hi = hi >> 8;
    buf[offset] = hi;
    return offset + 8;
}
$5f7a215ef2b330e3$var$Buffer.prototype.writeBigUInt64LE = $5f7a215ef2b330e3$var$defineBigIntMethod(function writeBigUInt64LE(value, offset = 0) {
    return $5f7a215ef2b330e3$var$wrtBigUInt64LE(this, value, offset, BigInt(0), BigInt("0xffffffffffffffff"));
});
$5f7a215ef2b330e3$var$Buffer.prototype.writeBigUInt64BE = $5f7a215ef2b330e3$var$defineBigIntMethod(function writeBigUInt64BE(value, offset = 0) {
    return $5f7a215ef2b330e3$var$wrtBigUInt64BE(this, value, offset, BigInt(0), BigInt("0xffffffffffffffff"));
});
$5f7a215ef2b330e3$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $5f7a215ef2b330e3$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = 0;
    let mul = 1;
    let sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$5f7a215ef2b330e3$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $5f7a215ef2b330e3$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = byteLength - 1;
    let mul = 1;
    let sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$5f7a215ef2b330e3$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $5f7a215ef2b330e3$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$5f7a215ef2b330e3$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $5f7a215ef2b330e3$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$5f7a215ef2b330e3$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $5f7a215ef2b330e3$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$5f7a215ef2b330e3$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $5f7a215ef2b330e3$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
$5f7a215ef2b330e3$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $5f7a215ef2b330e3$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
$5f7a215ef2b330e3$var$Buffer.prototype.writeBigInt64LE = $5f7a215ef2b330e3$var$defineBigIntMethod(function writeBigInt64LE(value, offset = 0) {
    return $5f7a215ef2b330e3$var$wrtBigUInt64LE(this, value, offset, -BigInt("0x8000000000000000"), BigInt("0x7fffffffffffffff"));
});
$5f7a215ef2b330e3$var$Buffer.prototype.writeBigInt64BE = $5f7a215ef2b330e3$var$defineBigIntMethod(function writeBigInt64BE(value, offset = 0) {
    return $5f7a215ef2b330e3$var$wrtBigUInt64BE(this, value, offset, -BigInt("0x8000000000000000"), BigInt("0x7fffffffffffffff"));
});
function $5f7a215ef2b330e3$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError("Index out of range");
    if (offset < 0) throw new RangeError("Index out of range");
}
function $5f7a215ef2b330e3$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $5f7a215ef2b330e3$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $5WQj6.write(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$5f7a215ef2b330e3$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $5f7a215ef2b330e3$var$writeFloat(this, value, offset, true, noAssert);
};
$5f7a215ef2b330e3$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $5f7a215ef2b330e3$var$writeFloat(this, value, offset, false, noAssert);
};
function $5f7a215ef2b330e3$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $5f7a215ef2b330e3$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $5WQj6.write(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$5f7a215ef2b330e3$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $5f7a215ef2b330e3$var$writeDouble(this, value, offset, true, noAssert);
};
$5f7a215ef2b330e3$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $5f7a215ef2b330e3$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$5f7a215ef2b330e3$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!$5f7a215ef2b330e3$var$Buffer.isBuffer(target)) throw new TypeError("argument should be a Buffer");
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError("targetStart out of bounds");
    if (start < 0 || start >= this.length) throw new RangeError("Index out of range");
    if (end < 0) throw new RangeError("sourceEnd out of bounds");
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    const len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === "function") // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$5f7a215ef2b330e3$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === "string") {
        if (typeof start === "string") {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === "string") {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== "string") throw new TypeError("encoding must be a string");
        if (typeof encoding === "string" && !$5f7a215ef2b330e3$var$Buffer.isEncoding(encoding)) throw new TypeError("Unknown encoding: " + encoding);
        if (val.length === 1) {
            const code = val.charCodeAt(0);
            if (encoding === "utf8" && code < 128 || encoding === "latin1") // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === "number") val = val & 255;
    else if (typeof val === "boolean") val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError("Out of range index");
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    let i;
    if (typeof val === "number") for(i = start; i < end; ++i)this[i] = val;
    else {
        const bytes = $5f7a215ef2b330e3$var$Buffer.isBuffer(val) ? val : $5f7a215ef2b330e3$var$Buffer.from(val, encoding);
        const len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// CUSTOM ERRORS
// =============
// Simplified versions from Node, changed for Buffer-only usage
const $5f7a215ef2b330e3$var$errors = {};
function $5f7a215ef2b330e3$var$E(sym, getMessage, Base) {
    $5f7a215ef2b330e3$var$errors[sym] = class NodeError extends Base {
        constructor(){
            super();
            Object.defineProperty(this, "message", {
                value: getMessage.apply(this, arguments),
                writable: true,
                configurable: true
            });
            // Add the error code to the name to include it in the stack trace.
            this.name = `${this.name} [${sym}]`;
            // Access the stack to generate the error message including the error code
            // from the name.
            this.stack // eslint-disable-line no-unused-expressions
            ;
            // Reset the name to the actual name.
            delete this.name;
        }
        get code() {
            return sym;
        }
        set code(value) {
            Object.defineProperty(this, "code", {
                configurable: true,
                enumerable: true,
                value: value,
                writable: true
            });
        }
        toString() {
            return `${this.name} [${sym}]: ${this.message}`;
        }
    };
}
$5f7a215ef2b330e3$var$E("ERR_BUFFER_OUT_OF_BOUNDS", function(name) {
    if (name) return `${name} is outside of buffer bounds`;
    return "Attempt to access memory outside buffer bounds";
}, RangeError);
$5f7a215ef2b330e3$var$E("ERR_INVALID_ARG_TYPE", function(name, actual) {
    return `The "${name}" argument must be of type number. Received type ${typeof actual}`;
}, TypeError);
$5f7a215ef2b330e3$var$E("ERR_OUT_OF_RANGE", function(str, range, input) {
    let msg = `The value of "${str}" is out of range.`;
    let received = input;
    if (Number.isInteger(input) && Math.abs(input) > 2 ** 32) received = $5f7a215ef2b330e3$var$addNumericalSeparator(String(input));
    else if (typeof input === "bigint") {
        received = String(input);
        if (input > BigInt(2) ** BigInt(32) || input < -(BigInt(2) ** BigInt(32))) received = $5f7a215ef2b330e3$var$addNumericalSeparator(received);
        received += "n";
    }
    msg += ` It must be ${range}. Received ${received}`;
    return msg;
}, RangeError);
function $5f7a215ef2b330e3$var$addNumericalSeparator(val) {
    let res = "";
    let i = val.length;
    const start = val[0] === "-" ? 1 : 0;
    for(; i >= start + 4; i -= 3)res = `_${val.slice(i - 3, i)}${res}`;
    return `${val.slice(0, i)}${res}`;
}
// CHECK FUNCTIONS
// ===============
function $5f7a215ef2b330e3$var$checkBounds(buf, offset, byteLength) {
    $5f7a215ef2b330e3$var$validateNumber(offset, "offset");
    if (buf[offset] === undefined || buf[offset + byteLength] === undefined) $5f7a215ef2b330e3$var$boundsError(offset, buf.length - (byteLength + 1));
}
function $5f7a215ef2b330e3$var$checkIntBI(value, min, max, buf, offset, byteLength) {
    if (value > max || value < min) {
        const n = typeof min === "bigint" ? "n" : "";
        let range;
        if (byteLength > 3) {
            if (min === 0 || min === BigInt(0)) range = `>= 0${n} and < 2${n} ** ${(byteLength + 1) * 8}${n}`;
            else range = `>= -(2${n} ** ${(byteLength + 1) * 8 - 1}${n}) and < 2 ** ` + `${(byteLength + 1) * 8 - 1}${n}`;
        } else range = `>= ${min}${n} and <= ${max}${n}`;
        throw new $5f7a215ef2b330e3$var$errors.ERR_OUT_OF_RANGE("value", range, value);
    }
    $5f7a215ef2b330e3$var$checkBounds(buf, offset, byteLength);
}
function $5f7a215ef2b330e3$var$validateNumber(value, name) {
    if (typeof value !== "number") throw new $5f7a215ef2b330e3$var$errors.ERR_INVALID_ARG_TYPE(name, "number", value);
}
function $5f7a215ef2b330e3$var$boundsError(value, length, type) {
    if (Math.floor(value) !== value) {
        $5f7a215ef2b330e3$var$validateNumber(value, type);
        throw new $5f7a215ef2b330e3$var$errors.ERR_OUT_OF_RANGE(type || "offset", "an integer", value);
    }
    if (length < 0) throw new $5f7a215ef2b330e3$var$errors.ERR_BUFFER_OUT_OF_BOUNDS();
    throw new $5f7a215ef2b330e3$var$errors.ERR_OUT_OF_RANGE(type || "offset", `>= ${type ? 1 : 0} and <= ${length}`, value);
}
// HELPER FUNCTIONS
// ================
const $5f7a215ef2b330e3$var$INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function $5f7a215ef2b330e3$var$base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split("=")[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace($5f7a215ef2b330e3$var$INVALID_BASE64_RE, "");
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return "";
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + "=";
    return str;
}
function $5f7a215ef2b330e3$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    let codePoint;
    const length = string.length;
    let leadSurrogate = null;
    const bytes = [];
    for(let i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error("Invalid code point");
    }
    return bytes;
}
function $5f7a215ef2b330e3$var$asciiToBytes(str) {
    const byteArray = [];
    for(let i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $5f7a215ef2b330e3$var$utf16leToBytes(str, units) {
    let c, hi, lo;
    const byteArray = [];
    for(let i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $5f7a215ef2b330e3$var$base64ToBytes(str) {
    return $hqZtu.toByteArray($5f7a215ef2b330e3$var$base64clean(str));
}
function $5f7a215ef2b330e3$var$blitBuffer(src, dst, offset, length) {
    let i;
    for(i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function $5f7a215ef2b330e3$var$isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function $5f7a215ef2b330e3$var$numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
const $5f7a215ef2b330e3$var$hexSliceLookupTable = function() {
    const alphabet = "0123456789abcdef";
    const table = new Array(256);
    for(let i = 0; i < 16; ++i){
        const i16 = i * 16;
        for(let j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();
// Return not function with Error if BigInt not supported
function $5f7a215ef2b330e3$var$defineBigIntMethod(fn) {
    return typeof BigInt === "undefined" ? $5f7a215ef2b330e3$var$BufferBigIntNotDefined : fn;
}
function $5f7a215ef2b330e3$var$BufferBigIntNotDefined() {
    throw new Error("BigInt not supported");
}


/* Check if a value is a Uint8Array.
 *
 * @ignore */ function $2913ed74210dce84$var$checkUint8Array(b) {
    if (!(b instanceof Uint8Array)) throw new TypeError("b must be a Uint8Array");
}
$2913ed74210dce84$exports.checkUint8Array = $2913ed74210dce84$var$checkUint8Array;
/* Create a Buffer instance from a Uint8Array.
 *
 * @ignore */ function $2913ed74210dce84$var$uint8ArrayToBuffer(b) {
    $2913ed74210dce84$var$checkUint8Array(b);
    return $5f7a215ef2b330e3$export$a143d493d941bafc.from(b.buffer, b.byteOffset, b.length);
}
$2913ed74210dce84$exports.uint8ArrayToBuffer = $2913ed74210dce84$var$uint8ArrayToBuffer;
/**
 * Base class for layout objects.
 *
 * **NOTE** This is an abstract base class; you can create instances
 * if it amuses you, but they won't support the {@link
 * Layout#encode|encode} or {@link Layout#decode|decode} functions.
 *
 * @param {Number} span - Initializer for {@link Layout#span|span}.  The
 * parameter must be an integer; a negative value signifies that the
 * span is {@link Layout#getSpan|value-specific}.
 *
 * @param {string} [property] - Initializer for {@link
 * Layout#property|property}.
 *
 * @abstract
 */ class $2913ed74210dce84$var$Layout {
    constructor(span, property){
        if (!Number.isInteger(span)) throw new TypeError("span must be an integer");
        /** The span of the layout in bytes.
         *
         * Positive values are generally expected.
         *
         * Zero will only appear in {@link Constant}s and in {@link
         * Sequence}s where the {@link Sequence#count|count} is zero.
         *
         * A negative value indicates that the span is value-specific, and
         * must be obtained using {@link Layout#getSpan|getSpan}. */ this.span = span;
        /** The property name used when this layout is represented in an
         * Object.
         *
         * Used only for layouts that {@link Layout#decode|decode} to Object
         * instances.  If left undefined the span of the unnamed layout will
         * be treated as padding: it will not be mutated by {@link
         * Layout#encode|encode} nor represented as a property in the
         * decoded Object. */ this.property = property;
    }
    /** Function to create an Object into which decoded properties will
     * be written.
     *
     * Used only for layouts that {@link Layout#decode|decode} to Object
     * instances, which means:
     * * {@link Structure}
     * * {@link Union}
     * * {@link VariantLayout}
     * * {@link BitStructure}
     *
     * If left undefined the JavaScript representation of these layouts
     * will be Object instances.
     *
     * See {@link bindConstructorLayout}.
     */ makeDestinationObject() {
        return {};
    }
    /**
     * Calculate the span of a specific instance of a layout.
     *
     * @param {Uint8Array} b - the buffer that contains an encoded instance.
     *
     * @param {Number} [offset] - the offset at which the encoded instance
     * starts.  If absent a zero offset is inferred.
     *
     * @return {Number} - the number of bytes covered by the layout
     * instance.  If this method is not overridden in a subclass the
     * definition-time constant {@link Layout#span|span} will be
     * returned.
     *
     * @throws {RangeError} - if the length of the value cannot be
     * determined.
     */ getSpan(b, offset) {
        if (0 > this.span) throw new RangeError("indeterminate span");
        return this.span;
    }
    /**
     * Replicate the layout using a new property.
     *
     * This function must be used to get a structurally-equivalent layout
     * with a different name since all {@link Layout} instances are
     * immutable.
     *
     * **NOTE** This is a shallow copy.  All fields except {@link
     * Layout#property|property} are strictly equal to the origin layout.
     *
     * @param {String} property - the value for {@link
     * Layout#property|property} in the replica.
     *
     * @returns {Layout} - the copy with {@link Layout#property|property}
     * set to `property`.
     */ replicate(property) {
        const rv = Object.create(this.constructor.prototype);
        Object.assign(rv, this);
        rv.property = property;
        return rv;
    }
    /**
     * Create an object from layout properties and an array of values.
     *
     * **NOTE** This function returns `undefined` if invoked on a layout
     * that does not return its value as an Object.  Objects are
     * returned for things that are a {@link Structure}, which includes
     * {@link VariantLayout|variant layouts} if they are structures, and
     * excludes {@link Union}s.  If you want this feature for a union
     * you must use {@link Union.getVariant|getVariant} to select the
     * desired layout.
     *
     * @param {Array} values - an array of values that correspond to the
     * default order for properties.  As with {@link Layout#decode|decode}
     * layout elements that have no property name are skipped when
     * iterating over the array values.  Only the top-level properties are
     * assigned; arguments are not assigned to properties of contained
     * layouts.  Any unused values are ignored.
     *
     * @return {(Object|undefined)}
     */ fromArray(values) {
        return undefined;
    }
}
$2913ed74210dce84$exports.Layout = $2913ed74210dce84$var$Layout;
/* Provide text that carries a name (such as for a function that will
 * be throwing an error) annotated with the property of a given layout
 * (such as one for which the value was unacceptable).
 *
 * @ignore */ function $2913ed74210dce84$var$nameWithProperty(name, lo) {
    if (lo.property) return name + "[" + lo.property + "]";
    return name;
}
$2913ed74210dce84$exports.nameWithProperty = $2913ed74210dce84$var$nameWithProperty;
/**
 * Augment a class so that instances can be encoded/decoded using a
 * given layout.
 *
 * Calling this function couples `Class` with `layout` in several ways:
 *
 * * `Class.layout_` becomes a static member property equal to `layout`;
 * * `layout.boundConstructor_` becomes a static member property equal
 *    to `Class`;
 * * The {@link Layout#makeDestinationObject|makeDestinationObject()}
 *   property of `layout` is set to a function that returns a `new
 *   Class()`;
 * * `Class.decode(b, offset)` becomes a static member function that
 *   delegates to {@link Layout#decode|layout.decode}.  The
 *   synthesized function may be captured and extended.
 * * `Class.prototype.encode(b, offset)` provides an instance member
 *   function that delegates to {@link Layout#encode|layout.encode}
 *   with `src` set to `this`.  The synthesized function may be
 *   captured and extended, but when the extension is invoked `this`
 *   must be explicitly bound to the instance.
 *
 * @param {class} Class - a JavaScript class with a nullary
 * constructor.
 *
 * @param {Layout} layout - the {@link Layout} instance used to encode
 * instances of `Class`.
 */ // `Class` must be a constructor Function, but the assignment of a `layout_` property to it makes it difficult to type
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
function $2913ed74210dce84$var$bindConstructorLayout(Class, layout) {
    if ("function" !== typeof Class) throw new TypeError("Class must be constructor");
    if (Object.prototype.hasOwnProperty.call(Class, "layout_")) throw new Error("Class is already bound to a layout");
    if (!(layout && layout instanceof $2913ed74210dce84$var$Layout)) throw new TypeError("layout must be a Layout");
    if (Object.prototype.hasOwnProperty.call(layout, "boundConstructor_")) throw new Error("layout is already bound to a constructor");
    Class.layout_ = layout;
    layout.boundConstructor_ = Class;
    layout.makeDestinationObject = ()=>new Class();
    Object.defineProperty(Class.prototype, "encode", {
        value (b, offset) {
            return layout.encode(this, b, offset);
        },
        writable: true
    });
    Object.defineProperty(Class, "decode", {
        value (b, offset) {
            return layout.decode(b, offset);
        },
        writable: true
    });
}
$2913ed74210dce84$exports.bindConstructorLayout = $2913ed74210dce84$var$bindConstructorLayout;
/**
 * An object that behaves like a layout but does not consume space
 * within its containing layout.
 *
 * This is primarily used to obtain metadata about a member, such as a
 * {@link OffsetLayout} that can provide data about a {@link
 * Layout#getSpan|value-specific span}.
 *
 * **NOTE** This is an abstract base class; you can create instances
 * if it amuses you, but they won't support {@link
 * ExternalLayout#isCount|isCount} or other {@link Layout} functions.
 *
 * @param {Number} span - initializer for {@link Layout#span|span}.
 * The parameter can range from 1 through 6.
 *
 * @param {string} [property] - initializer for {@link
 * Layout#property|property}.
 *
 * @abstract
 * @augments {Layout}
 */ class $2913ed74210dce84$var$ExternalLayout extends $2913ed74210dce84$var$Layout {
    /**
     * Return `true` iff the external layout decodes to an unsigned
     * integer layout.
     *
     * In that case it can be used as the source of {@link
     * Sequence#count|Sequence counts}, {@link Blob#length|Blob lengths},
     * or as {@link UnionLayoutDiscriminator#layout|external union
     * discriminators}.
     *
     * @abstract
     */ isCount() {
        throw new Error("ExternalLayout is abstract");
    }
}
$2913ed74210dce84$exports.ExternalLayout = $2913ed74210dce84$var$ExternalLayout;
/**
 * An {@link ExternalLayout} that determines its {@link
 * Layout#decode|value} based on offset into and length of the buffer
 * on which it is invoked.
 *
 * *Factory*: {@link module:Layout.greedy|greedy}
 *
 * @param {Number} [elementSpan] - initializer for {@link
 * GreedyCount#elementSpan|elementSpan}.
 *
 * @param {string} [property] - initializer for {@link
 * Layout#property|property}.
 *
 * @augments {ExternalLayout}
 */ class $2913ed74210dce84$var$GreedyCount extends $2913ed74210dce84$var$ExternalLayout {
    constructor(elementSpan = 1, property){
        if (!Number.isInteger(elementSpan) || 0 >= elementSpan) throw new TypeError("elementSpan must be a (positive) integer");
        super(-1, property);
        /** The layout for individual elements of the sequence.  The value
         * must be a positive integer.  If not provided, the value will be
         * 1. */ this.elementSpan = elementSpan;
    }
    /** @override */ isCount() {
        return true;
    }
    /** @override */ decode(b, offset = 0) {
        $2913ed74210dce84$var$checkUint8Array(b);
        const rem = b.length - offset;
        return Math.floor(rem / this.elementSpan);
    }
    /** @override */ encode(src, b, offset) {
        return 0;
    }
}
$2913ed74210dce84$exports.GreedyCount = $2913ed74210dce84$var$GreedyCount;
/**
 * An {@link ExternalLayout} that supports accessing a {@link Layout}
 * at a fixed offset from the start of another Layout.  The offset may
 * be before, within, or after the base layout.
 *
 * *Factory*: {@link module:Layout.offset|offset}
 *
 * @param {Layout} layout - initializer for {@link
 * OffsetLayout#layout|layout}, modulo `property`.
 *
 * @param {Number} [offset] - Initializes {@link
 * OffsetLayout#offset|offset}.  Defaults to zero.
 *
 * @param {string} [property] - Optional new property name for a
 * {@link Layout#replicate| replica} of `layout` to be used as {@link
 * OffsetLayout#layout|layout}.  If not provided the `layout` is used
 * unchanged.
 *
 * @augments {Layout}
 */ class $2913ed74210dce84$var$OffsetLayout extends $2913ed74210dce84$var$ExternalLayout {
    constructor(layout, offset = 0, property){
        if (!(layout instanceof $2913ed74210dce84$var$Layout)) throw new TypeError("layout must be a Layout");
        if (!Number.isInteger(offset)) throw new TypeError("offset must be integer or undefined");
        super(layout.span, property || layout.property);
        /** The subordinated layout. */ this.layout = layout;
        /** The location of {@link OffsetLayout#layout} relative to the
         * start of another layout.
         *
         * The value may be positive or negative, but an error will thrown
         * if at the point of use it goes outside the span of the Uint8Array
         * being accessed.  */ this.offset = offset;
    }
    /** @override */ isCount() {
        return this.layout instanceof $2913ed74210dce84$var$UInt || this.layout instanceof $2913ed74210dce84$var$UIntBE;
    }
    /** @override */ decode(b, offset = 0) {
        return this.layout.decode(b, offset + this.offset);
    }
    /** @override */ encode(src, b, offset = 0) {
        return this.layout.encode(src, b, offset + this.offset);
    }
}
$2913ed74210dce84$exports.OffsetLayout = $2913ed74210dce84$var$OffsetLayout;
/**
 * Represent an unsigned integer in little-endian format.
 *
 * *Factory*: {@link module:Layout.u8|u8}, {@link
 *  module:Layout.u16|u16}, {@link module:Layout.u24|u24}, {@link
 *  module:Layout.u32|u32}, {@link module:Layout.u40|u40}, {@link
 *  module:Layout.u48|u48}
 *
 * @param {Number} span - initializer for {@link Layout#span|span}.
 * The parameter can range from 1 through 6.
 *
 * @param {string} [property] - initializer for {@link
 * Layout#property|property}.
 *
 * @augments {Layout}
 */ class $2913ed74210dce84$var$UInt extends $2913ed74210dce84$var$Layout {
    constructor(span, property){
        super(span, property);
        if (6 < this.span) throw new RangeError("span must not exceed 6 bytes");
    }
    /** @override */ decode(b, offset = 0) {
        return $2913ed74210dce84$var$uint8ArrayToBuffer(b).readUIntLE(offset, this.span);
    }
    /** @override */ encode(src, b, offset = 0) {
        $2913ed74210dce84$var$uint8ArrayToBuffer(b).writeUIntLE(src, offset, this.span);
        return this.span;
    }
}
$2913ed74210dce84$exports.UInt = $2913ed74210dce84$var$UInt;
/**
 * Represent an unsigned integer in big-endian format.
 *
 * *Factory*: {@link module:Layout.u8be|u8be}, {@link
 * module:Layout.u16be|u16be}, {@link module:Layout.u24be|u24be},
 * {@link module:Layout.u32be|u32be}, {@link
 * module:Layout.u40be|u40be}, {@link module:Layout.u48be|u48be}
 *
 * @param {Number} span - initializer for {@link Layout#span|span}.
 * The parameter can range from 1 through 6.
 *
 * @param {string} [property] - initializer for {@link
 * Layout#property|property}.
 *
 * @augments {Layout}
 */ class $2913ed74210dce84$var$UIntBE extends $2913ed74210dce84$var$Layout {
    constructor(span, property){
        super(span, property);
        if (6 < this.span) throw new RangeError("span must not exceed 6 bytes");
    }
    /** @override */ decode(b, offset = 0) {
        return $2913ed74210dce84$var$uint8ArrayToBuffer(b).readUIntBE(offset, this.span);
    }
    /** @override */ encode(src, b, offset = 0) {
        $2913ed74210dce84$var$uint8ArrayToBuffer(b).writeUIntBE(src, offset, this.span);
        return this.span;
    }
}
$2913ed74210dce84$exports.UIntBE = $2913ed74210dce84$var$UIntBE;
/**
 * Represent a signed integer in little-endian format.
 *
 * *Factory*: {@link module:Layout.s8|s8}, {@link
 *  module:Layout.s16|s16}, {@link module:Layout.s24|s24}, {@link
 *  module:Layout.s32|s32}, {@link module:Layout.s40|s40}, {@link
 *  module:Layout.s48|s48}
 *
 * @param {Number} span - initializer for {@link Layout#span|span}.
 * The parameter can range from 1 through 6.
 *
 * @param {string} [property] - initializer for {@link
 * Layout#property|property}.
 *
 * @augments {Layout}
 */ class $2913ed74210dce84$var$Int extends $2913ed74210dce84$var$Layout {
    constructor(span, property){
        super(span, property);
        if (6 < this.span) throw new RangeError("span must not exceed 6 bytes");
    }
    /** @override */ decode(b, offset = 0) {
        return $2913ed74210dce84$var$uint8ArrayToBuffer(b).readIntLE(offset, this.span);
    }
    /** @override */ encode(src, b, offset = 0) {
        $2913ed74210dce84$var$uint8ArrayToBuffer(b).writeIntLE(src, offset, this.span);
        return this.span;
    }
}
$2913ed74210dce84$exports.Int = $2913ed74210dce84$var$Int;
/**
 * Represent a signed integer in big-endian format.
 *
 * *Factory*: {@link module:Layout.s8be|s8be}, {@link
 * module:Layout.s16be|s16be}, {@link module:Layout.s24be|s24be},
 * {@link module:Layout.s32be|s32be}, {@link
 * module:Layout.s40be|s40be}, {@link module:Layout.s48be|s48be}
 *
 * @param {Number} span - initializer for {@link Layout#span|span}.
 * The parameter can range from 1 through 6.
 *
 * @param {string} [property] - initializer for {@link
 * Layout#property|property}.
 *
 * @augments {Layout}
 */ class $2913ed74210dce84$var$IntBE extends $2913ed74210dce84$var$Layout {
    constructor(span, property){
        super(span, property);
        if (6 < this.span) throw new RangeError("span must not exceed 6 bytes");
    }
    /** @override */ decode(b, offset = 0) {
        return $2913ed74210dce84$var$uint8ArrayToBuffer(b).readIntBE(offset, this.span);
    }
    /** @override */ encode(src, b, offset = 0) {
        $2913ed74210dce84$var$uint8ArrayToBuffer(b).writeIntBE(src, offset, this.span);
        return this.span;
    }
}
$2913ed74210dce84$exports.IntBE = $2913ed74210dce84$var$IntBE;
const $2913ed74210dce84$var$V2E32 = Math.pow(2, 32);
/* True modulus high and low 32-bit words, where low word is always
 * non-negative. */ function $2913ed74210dce84$var$divmodInt64(src) {
    const hi32 = Math.floor(src / $2913ed74210dce84$var$V2E32);
    const lo32 = src - hi32 * $2913ed74210dce84$var$V2E32;
    return {
        hi32: hi32,
        lo32: lo32
    };
}
/* Reconstruct Number from quotient and non-negative remainder */ function $2913ed74210dce84$var$roundedInt64(hi32, lo32) {
    return hi32 * $2913ed74210dce84$var$V2E32 + lo32;
}
/**
 * Represent an unsigned 64-bit integer in little-endian format when
 * encoded and as a near integral JavaScript Number when decoded.
 *
 * *Factory*: {@link module:Layout.nu64|nu64}
 *
 * **NOTE** Values with magnitude greater than 2^52 may not decode to
 * the exact value of the encoded representation.
 *
 * @augments {Layout}
 */ class $2913ed74210dce84$var$NearUInt64 extends $2913ed74210dce84$var$Layout {
    constructor(property){
        super(8, property);
    }
    /** @override */ decode(b, offset = 0) {
        const buffer = $2913ed74210dce84$var$uint8ArrayToBuffer(b);
        const lo32 = buffer.readUInt32LE(offset);
        const hi32 = buffer.readUInt32LE(offset + 4);
        return $2913ed74210dce84$var$roundedInt64(hi32, lo32);
    }
    /** @override */ encode(src, b, offset = 0) {
        const split = $2913ed74210dce84$var$divmodInt64(src);
        const buffer = $2913ed74210dce84$var$uint8ArrayToBuffer(b);
        buffer.writeUInt32LE(split.lo32, offset);
        buffer.writeUInt32LE(split.hi32, offset + 4);
        return 8;
    }
}
$2913ed74210dce84$exports.NearUInt64 = $2913ed74210dce84$var$NearUInt64;
/**
 * Represent an unsigned 64-bit integer in big-endian format when
 * encoded and as a near integral JavaScript Number when decoded.
 *
 * *Factory*: {@link module:Layout.nu64be|nu64be}
 *
 * **NOTE** Values with magnitude greater than 2^52 may not decode to
 * the exact value of the encoded representation.
 *
 * @augments {Layout}
 */ class $2913ed74210dce84$var$NearUInt64BE extends $2913ed74210dce84$var$Layout {
    constructor(property){
        super(8, property);
    }
    /** @override */ decode(b, offset = 0) {
        const buffer = $2913ed74210dce84$var$uint8ArrayToBuffer(b);
        const hi32 = buffer.readUInt32BE(offset);
        const lo32 = buffer.readUInt32BE(offset + 4);
        return $2913ed74210dce84$var$roundedInt64(hi32, lo32);
    }
    /** @override */ encode(src, b, offset = 0) {
        const split = $2913ed74210dce84$var$divmodInt64(src);
        const buffer = $2913ed74210dce84$var$uint8ArrayToBuffer(b);
        buffer.writeUInt32BE(split.hi32, offset);
        buffer.writeUInt32BE(split.lo32, offset + 4);
        return 8;
    }
}
$2913ed74210dce84$exports.NearUInt64BE = $2913ed74210dce84$var$NearUInt64BE;
/**
 * Represent a signed 64-bit integer in little-endian format when
 * encoded and as a near integral JavaScript Number when decoded.
 *
 * *Factory*: {@link module:Layout.ns64|ns64}
 *
 * **NOTE** Values with magnitude greater than 2^52 may not decode to
 * the exact value of the encoded representation.
 *
 * @augments {Layout}
 */ class $2913ed74210dce84$var$NearInt64 extends $2913ed74210dce84$var$Layout {
    constructor(property){
        super(8, property);
    }
    /** @override */ decode(b, offset = 0) {
        const buffer = $2913ed74210dce84$var$uint8ArrayToBuffer(b);
        const lo32 = buffer.readUInt32LE(offset);
        const hi32 = buffer.readInt32LE(offset + 4);
        return $2913ed74210dce84$var$roundedInt64(hi32, lo32);
    }
    /** @override */ encode(src, b, offset = 0) {
        const split = $2913ed74210dce84$var$divmodInt64(src);
        const buffer = $2913ed74210dce84$var$uint8ArrayToBuffer(b);
        buffer.writeUInt32LE(split.lo32, offset);
        buffer.writeInt32LE(split.hi32, offset + 4);
        return 8;
    }
}
$2913ed74210dce84$exports.NearInt64 = $2913ed74210dce84$var$NearInt64;
/**
 * Represent a signed 64-bit integer in big-endian format when
 * encoded and as a near integral JavaScript Number when decoded.
 *
 * *Factory*: {@link module:Layout.ns64be|ns64be}
 *
 * **NOTE** Values with magnitude greater than 2^52 may not decode to
 * the exact value of the encoded representation.
 *
 * @augments {Layout}
 */ class $2913ed74210dce84$var$NearInt64BE extends $2913ed74210dce84$var$Layout {
    constructor(property){
        super(8, property);
    }
    /** @override */ decode(b, offset = 0) {
        const buffer = $2913ed74210dce84$var$uint8ArrayToBuffer(b);
        const hi32 = buffer.readInt32BE(offset);
        const lo32 = buffer.readUInt32BE(offset + 4);
        return $2913ed74210dce84$var$roundedInt64(hi32, lo32);
    }
    /** @override */ encode(src, b, offset = 0) {
        const split = $2913ed74210dce84$var$divmodInt64(src);
        const buffer = $2913ed74210dce84$var$uint8ArrayToBuffer(b);
        buffer.writeInt32BE(split.hi32, offset);
        buffer.writeUInt32BE(split.lo32, offset + 4);
        return 8;
    }
}
$2913ed74210dce84$exports.NearInt64BE = $2913ed74210dce84$var$NearInt64BE;
/**
 * Represent a 32-bit floating point number in little-endian format.
 *
 * *Factory*: {@link module:Layout.f32|f32}
 *
 * @param {string} [property] - initializer for {@link
 * Layout#property|property}.
 *
 * @augments {Layout}
 */ class $2913ed74210dce84$var$Float extends $2913ed74210dce84$var$Layout {
    constructor(property){
        super(4, property);
    }
    /** @override */ decode(b, offset = 0) {
        return $2913ed74210dce84$var$uint8ArrayToBuffer(b).readFloatLE(offset);
    }
    /** @override */ encode(src, b, offset = 0) {
        $2913ed74210dce84$var$uint8ArrayToBuffer(b).writeFloatLE(src, offset);
        return 4;
    }
}
$2913ed74210dce84$exports.Float = $2913ed74210dce84$var$Float;
/**
 * Represent a 32-bit floating point number in big-endian format.
 *
 * *Factory*: {@link module:Layout.f32be|f32be}
 *
 * @param {string} [property] - initializer for {@link
 * Layout#property|property}.
 *
 * @augments {Layout}
 */ class $2913ed74210dce84$var$FloatBE extends $2913ed74210dce84$var$Layout {
    constructor(property){
        super(4, property);
    }
    /** @override */ decode(b, offset = 0) {
        return $2913ed74210dce84$var$uint8ArrayToBuffer(b).readFloatBE(offset);
    }
    /** @override */ encode(src, b, offset = 0) {
        $2913ed74210dce84$var$uint8ArrayToBuffer(b).writeFloatBE(src, offset);
        return 4;
    }
}
$2913ed74210dce84$exports.FloatBE = $2913ed74210dce84$var$FloatBE;
/**
 * Represent a 64-bit floating point number in little-endian format.
 *
 * *Factory*: {@link module:Layout.f64|f64}
 *
 * @param {string} [property] - initializer for {@link
 * Layout#property|property}.
 *
 * @augments {Layout}
 */ class $2913ed74210dce84$var$Double extends $2913ed74210dce84$var$Layout {
    constructor(property){
        super(8, property);
    }
    /** @override */ decode(b, offset = 0) {
        return $2913ed74210dce84$var$uint8ArrayToBuffer(b).readDoubleLE(offset);
    }
    /** @override */ encode(src, b, offset = 0) {
        $2913ed74210dce84$var$uint8ArrayToBuffer(b).writeDoubleLE(src, offset);
        return 8;
    }
}
$2913ed74210dce84$exports.Double = $2913ed74210dce84$var$Double;
/**
 * Represent a 64-bit floating point number in big-endian format.
 *
 * *Factory*: {@link module:Layout.f64be|f64be}
 *
 * @param {string} [property] - initializer for {@link
 * Layout#property|property}.
 *
 * @augments {Layout}
 */ class $2913ed74210dce84$var$DoubleBE extends $2913ed74210dce84$var$Layout {
    constructor(property){
        super(8, property);
    }
    /** @override */ decode(b, offset = 0) {
        return $2913ed74210dce84$var$uint8ArrayToBuffer(b).readDoubleBE(offset);
    }
    /** @override */ encode(src, b, offset = 0) {
        $2913ed74210dce84$var$uint8ArrayToBuffer(b).writeDoubleBE(src, offset);
        return 8;
    }
}
$2913ed74210dce84$exports.DoubleBE = $2913ed74210dce84$var$DoubleBE;
/**
 * Represent a contiguous sequence of a specific layout as an Array.
 *
 * *Factory*: {@link module:Layout.seq|seq}
 *
 * @param {Layout} elementLayout - initializer for {@link
 * Sequence#elementLayout|elementLayout}.
 *
 * @param {(Number|ExternalLayout)} count - initializer for {@link
 * Sequence#count|count}.  The parameter must be either a positive
 * integer or an instance of {@link ExternalLayout}.
 *
 * @param {string} [property] - initializer for {@link
 * Layout#property|property}.
 *
 * @augments {Layout}
 */ class $2913ed74210dce84$var$Sequence extends $2913ed74210dce84$var$Layout {
    constructor(elementLayout, count, property){
        if (!(elementLayout instanceof $2913ed74210dce84$var$Layout)) throw new TypeError("elementLayout must be a Layout");
        if (!(count instanceof $2913ed74210dce84$var$ExternalLayout && count.isCount() || Number.isInteger(count) && 0 <= count)) throw new TypeError("count must be non-negative integer or an unsigned integer ExternalLayout");
        let span = -1;
        if (!(count instanceof $2913ed74210dce84$var$ExternalLayout) && 0 < elementLayout.span) span = count * elementLayout.span;
        super(span, property);
        /** The layout for individual elements of the sequence. */ this.elementLayout = elementLayout;
        /** The number of elements in the sequence.
         *
         * This will be either a non-negative integer or an instance of
         * {@link ExternalLayout} for which {@link
         * ExternalLayout#isCount|isCount()} is `true`. */ this.count = count;
    }
    /** @override */ getSpan(b, offset = 0) {
        if (0 <= this.span) return this.span;
        let span = 0;
        let count = this.count;
        if (count instanceof $2913ed74210dce84$var$ExternalLayout) count = count.decode(b, offset);
        if (0 < this.elementLayout.span) span = count * this.elementLayout.span;
        else {
            let idx = 0;
            while(idx < count){
                span += this.elementLayout.getSpan(b, offset + span);
                ++idx;
            }
        }
        return span;
    }
    /** @override */ decode(b, offset = 0) {
        const rv = [];
        let i = 0;
        let count = this.count;
        if (count instanceof $2913ed74210dce84$var$ExternalLayout) count = count.decode(b, offset);
        while(i < count){
            rv.push(this.elementLayout.decode(b, offset));
            offset += this.elementLayout.getSpan(b, offset);
            i += 1;
        }
        return rv;
    }
    /** Implement {@link Layout#encode|encode} for {@link Sequence}.
     *
     * **NOTE** If `src` is shorter than {@link Sequence#count|count} then
     * the unused space in the buffer is left unchanged.  If `src` is
     * longer than {@link Sequence#count|count} the unneeded elements are
     * ignored.
     *
     * **NOTE** If {@link Layout#count|count} is an instance of {@link
     * ExternalLayout} then the length of `src` will be encoded as the
     * count after `src` is encoded. */ encode(src, b, offset = 0) {
        const elo = this.elementLayout;
        const span = src.reduce((span, v)=>{
            return span + elo.encode(v, b, offset + span);
        }, 0);
        if (this.count instanceof $2913ed74210dce84$var$ExternalLayout) this.count.encode(src.length, b, offset);
        return span;
    }
}
$2913ed74210dce84$exports.Sequence = $2913ed74210dce84$var$Sequence;
/**
 * Represent a contiguous sequence of arbitrary layout elements as an
 * Object.
 *
 * *Factory*: {@link module:Layout.struct|struct}
 *
 * **NOTE** The {@link Layout#span|span} of the structure is variable
 * if any layout in {@link Structure#fields|fields} has a variable
 * span.  When {@link Layout#encode|encoding} we must have a value for
 * all variable-length fields, or we wouldn't be able to figure out
 * how much space to use for storage.  We can only identify the value
 * for a field when it has a {@link Layout#property|property}.  As
 * such, although a structure may contain both unnamed fields and
 * variable-length fields, it cannot contain an unnamed
 * variable-length field.
 *
 * @param {Layout[]} fields - initializer for {@link
 * Structure#fields|fields}.  An error is raised if this contains a
 * variable-length field for which a {@link Layout#property|property}
 * is not defined.
 *
 * @param {string} [property] - initializer for {@link
 * Layout#property|property}.
 *
 * @param {Boolean} [decodePrefixes] - initializer for {@link
 * Structure#decodePrefixes|property}.
 *
 * @throws {Error} - if `fields` contains an unnamed variable-length
 * layout.
 *
 * @augments {Layout}
 */ class $2913ed74210dce84$var$Structure extends $2913ed74210dce84$var$Layout {
    constructor(fields, property, decodePrefixes){
        if (!(Array.isArray(fields) && fields.reduce((acc, v)=>acc && v instanceof $2913ed74210dce84$var$Layout, true))) throw new TypeError("fields must be array of Layout instances");
        if ("boolean" === typeof property && undefined === decodePrefixes) {
            decodePrefixes = property;
            property = undefined;
        }
        /* Verify absence of unnamed variable-length fields. */ for (const fd of fields){
            if (0 > fd.span && undefined === fd.property) throw new Error("fields cannot contain unnamed variable-length layout");
        }
        let span = -1;
        try {
            span = fields.reduce((span, fd)=>span + fd.getSpan(), 0);
        } catch (e) {
        // ignore error
        }
        super(span, property);
        /** The sequence of {@link Layout} values that comprise the
         * structure.
         *
         * The individual elements need not be the same type, and may be
         * either scalar or aggregate layouts.  If a member layout leaves
         * its {@link Layout#property|property} undefined the
         * corresponding region of the buffer associated with the element
         * will not be mutated.
         *
         * @type {Layout[]} */ this.fields = fields;
        /** Control behavior of {@link Layout#decode|decode()} given short
         * buffers.
         *
         * In some situations a structure many be extended with additional
         * fields over time, with older installations providing only a
         * prefix of the full structure.  If this property is `true`
         * decoding will accept those buffers and leave subsequent fields
         * undefined, as long as the buffer ends at a field boundary.
         * Defaults to `false`. */ this.decodePrefixes = !!decodePrefixes;
    }
    /** @override */ getSpan(b, offset = 0) {
        if (0 <= this.span) return this.span;
        let span = 0;
        try {
            span = this.fields.reduce((span, fd)=>{
                const fsp = fd.getSpan(b, offset);
                offset += fsp;
                return span + fsp;
            }, 0);
        } catch (e) {
            throw new RangeError("indeterminate span");
        }
        return span;
    }
    /** @override */ decode(b, offset = 0) {
        $2913ed74210dce84$var$checkUint8Array(b);
        const dest = this.makeDestinationObject();
        for (const fd of this.fields){
            if (undefined !== fd.property) dest[fd.property] = fd.decode(b, offset);
            offset += fd.getSpan(b, offset);
            if (this.decodePrefixes && b.length === offset) break;
        }
        return dest;
    }
    /** Implement {@link Layout#encode|encode} for {@link Structure}.
     *
     * If `src` is missing a property for a member with a defined {@link
     * Layout#property|property} the corresponding region of the buffer is
     * left unmodified. */ encode(src, b, offset = 0) {
        const firstOffset = offset;
        let lastOffset = 0;
        let lastWrote = 0;
        for (const fd of this.fields){
            let span = fd.span;
            lastWrote = 0 < span ? span : 0;
            if (undefined !== fd.property) {
                const fv = src[fd.property];
                if (undefined !== fv) {
                    lastWrote = fd.encode(fv, b, offset);
                    if (0 > span) /* Read the as-encoded span, which is not necessarily the
                         * same as what we wrote. */ span = fd.getSpan(b, offset);
                }
            }
            lastOffset = offset;
            offset += span;
        }
        /* Use (lastOffset + lastWrote) instead of offset because the last
         * item may have had a dynamic length and we don't want to include
         * the padding between it and the end of the space reserved for
         * it. */ return lastOffset + lastWrote - firstOffset;
    }
    /** @override */ fromArray(values) {
        const dest = this.makeDestinationObject();
        for (const fd of this.fields)if (undefined !== fd.property && 0 < values.length) dest[fd.property] = values.shift();
        return dest;
    }
    /**
     * Get access to the layout of a given property.
     *
     * @param {String} property - the structure member of interest.
     *
     * @return {Layout} - the layout associated with `property`, or
     * undefined if there is no such property.
     */ layoutFor(property) {
        if ("string" !== typeof property) throw new TypeError("property must be string");
        for (const fd of this.fields){
            if (fd.property === property) return fd;
        }
        return undefined;
    }
    /**
     * Get the offset of a structure member.
     *
     * @param {String} property - the structure member of interest.
     *
     * @return {Number} - the offset in bytes to the start of `property`
     * within the structure, or undefined if `property` is not a field
     * within the structure.  If the property is a member but follows a
     * variable-length structure member a negative number will be
     * returned.
     */ offsetOf(property) {
        if ("string" !== typeof property) throw new TypeError("property must be string");
        let offset = 0;
        for (const fd of this.fields){
            if (fd.property === property) return offset;
            if (0 > fd.span) offset = -1;
            else if (0 <= offset) offset += fd.span;
        }
        return undefined;
    }
}
$2913ed74210dce84$exports.Structure = $2913ed74210dce84$var$Structure;
/**
 * An object that can provide a {@link
 * Union#discriminator|discriminator} API for {@link Union}.
 *
 * **NOTE** This is an abstract base class; you can create instances
 * if it amuses you, but they won't support the {@link
 * UnionDiscriminator#encode|encode} or {@link
 * UnionDiscriminator#decode|decode} functions.
 *
 * @param {string} [property] - Default for {@link
 * UnionDiscriminator#property|property}.
 *
 * @abstract
 */ class $2913ed74210dce84$var$UnionDiscriminator {
    constructor(property){
        /** The {@link Layout#property|property} to be used when the
         * discriminator is referenced in isolation (generally when {@link
         * Union#decode|Union decode} cannot delegate to a specific
         * variant). */ this.property = property;
    }
    /** Analog to {@link Layout#decode|Layout decode} for union discriminators.
     *
     * The implementation of this method need not reference the buffer if
     * variant information is available through other means. */ decode(b, offset) {
        throw new Error("UnionDiscriminator is abstract");
    }
    /** Analog to {@link Layout#decode|Layout encode} for union discriminators.
     *
     * The implementation of this method need not store the value if
     * variant information is maintained through other means. */ encode(src, b, offset) {
        throw new Error("UnionDiscriminator is abstract");
    }
}
$2913ed74210dce84$exports.UnionDiscriminator = $2913ed74210dce84$var$UnionDiscriminator;
/**
 * An object that can provide a {@link
 * UnionDiscriminator|discriminator API} for {@link Union} using an
 * unsigned integral {@link Layout} instance located either inside or
 * outside the union.
 *
 * @param {ExternalLayout} layout - initializes {@link
 * UnionLayoutDiscriminator#layout|layout}.  Must satisfy {@link
 * ExternalLayout#isCount|isCount()}.
 *
 * @param {string} [property] - Default for {@link
 * UnionDiscriminator#property|property}, superseding the property
 * from `layout`, but defaulting to `variant` if neither `property`
 * nor layout provide a property name.
 *
 * @augments {UnionDiscriminator}
 */ class $2913ed74210dce84$var$UnionLayoutDiscriminator extends $2913ed74210dce84$var$UnionDiscriminator {
    constructor(layout, property){
        if (!(layout instanceof $2913ed74210dce84$var$ExternalLayout && layout.isCount())) throw new TypeError("layout must be an unsigned integer ExternalLayout");
        super(property || layout.property || "variant");
        /** The {@link ExternalLayout} used to access the discriminator
         * value. */ this.layout = layout;
    }
    /** Delegate decoding to {@link UnionLayoutDiscriminator#layout|layout}. */ decode(b, offset) {
        return this.layout.decode(b, offset);
    }
    /** Delegate encoding to {@link UnionLayoutDiscriminator#layout|layout}. */ encode(src, b, offset) {
        return this.layout.encode(src, b, offset);
    }
}
$2913ed74210dce84$exports.UnionLayoutDiscriminator = $2913ed74210dce84$var$UnionLayoutDiscriminator;
/**
 * Represent any number of span-compatible layouts.
 *
 * *Factory*: {@link module:Layout.union|union}
 *
 * If the union has a {@link Union#defaultLayout|default layout} that
 * layout must have a non-negative {@link Layout#span|span}.  The span
 * of a fixed-span union includes its {@link
 * Union#discriminator|discriminator} if the variant is a {@link
 * Union#usesPrefixDiscriminator|prefix of the union}, plus the span
 * of its {@link Union#defaultLayout|default layout}.
 *
 * If the union does not have a default layout then the encoded span
 * of the union depends on the encoded span of its variant (which may
 * be fixed or variable).
 *
 * {@link VariantLayout#layout|Variant layout}s are added through
 * {@link Union#addVariant|addVariant}.  If the union has a default
 * layout, the span of the {@link VariantLayout#layout|layout
 * contained by the variant} must not exceed the span of the {@link
 * Union#defaultLayout|default layout} (minus the span of a {@link
 * Union#usesPrefixDiscriminator|prefix disriminator}, if used).  The
 * span of the variant will equal the span of the union itself.
 *
 * The variant for a buffer can only be identified from the {@link
 * Union#discriminator|discriminator} {@link
 * UnionDiscriminator#property|property} (in the case of the {@link
 * Union#defaultLayout|default layout}), or by using {@link
 * Union#getVariant|getVariant} and examining the resulting {@link
 * VariantLayout} instance.
 *
 * A variant compatible with a JavaScript object can be identified
 * using {@link Union#getSourceVariant|getSourceVariant}.
 *
 * @param {(UnionDiscriminator|ExternalLayout|Layout)} discr - How to
 * identify the layout used to interpret the union contents.  The
 * parameter must be an instance of {@link UnionDiscriminator}, an
 * {@link ExternalLayout} that satisfies {@link
 * ExternalLayout#isCount|isCount()}, or {@link UInt} (or {@link
 * UIntBE}).  When a non-external layout element is passed the layout
 * appears at the start of the union.  In all cases the (synthesized)
 * {@link UnionDiscriminator} instance is recorded as {@link
 * Union#discriminator|discriminator}.
 *
 * @param {(Layout|null)} defaultLayout - initializer for {@link
 * Union#defaultLayout|defaultLayout}.  If absent defaults to `null`.
 * If `null` there is no default layout: the union has data-dependent
 * length and attempts to decode or encode unrecognized variants will
 * throw an exception.  A {@link Layout} instance must have a
 * non-negative {@link Layout#span|span}, and if it lacks a {@link
 * Layout#property|property} the {@link
 * Union#defaultLayout|defaultLayout} will be a {@link
 * Layout#replicate|replica} with property `content`.
 *
 * @param {string} [property] - initializer for {@link
 * Layout#property|property}.
 *
 * @augments {Layout}
 */ class $2913ed74210dce84$var$Union extends $2913ed74210dce84$var$Layout {
    constructor(discr, defaultLayout, property){
        let discriminator;
        if (discr instanceof $2913ed74210dce84$var$UInt || discr instanceof $2913ed74210dce84$var$UIntBE) discriminator = new $2913ed74210dce84$var$UnionLayoutDiscriminator(new $2913ed74210dce84$var$OffsetLayout(discr));
        else if (discr instanceof $2913ed74210dce84$var$ExternalLayout && discr.isCount()) discriminator = new $2913ed74210dce84$var$UnionLayoutDiscriminator(discr);
        else if (!(discr instanceof $2913ed74210dce84$var$UnionDiscriminator)) throw new TypeError("discr must be a UnionDiscriminator or an unsigned integer layout");
        else discriminator = discr;
        if (undefined === defaultLayout) defaultLayout = null;
        if (!(null === defaultLayout || defaultLayout instanceof $2913ed74210dce84$var$Layout)) throw new TypeError("defaultLayout must be null or a Layout");
        if (null !== defaultLayout) {
            if (0 > defaultLayout.span) throw new Error("defaultLayout must have constant span");
            if (undefined === defaultLayout.property) defaultLayout = defaultLayout.replicate("content");
        }
        /* The union span can be estimated only if there's a default
         * layout.  The union spans its default layout, plus any prefix
         * variant layout.  By construction both layouts, if present, have
         * non-negative span. */ let span = -1;
        if (defaultLayout) {
            span = defaultLayout.span;
            if (0 <= span && (discr instanceof $2913ed74210dce84$var$UInt || discr instanceof $2913ed74210dce84$var$UIntBE)) span += discriminator.layout.span;
        }
        super(span, property);
        /** The interface for the discriminator value in isolation.
         *
         * This a {@link UnionDiscriminator} either passed to the
         * constructor or synthesized from the `discr` constructor
         * argument.  {@link
         * Union#usesPrefixDiscriminator|usesPrefixDiscriminator} will be
         * `true` iff the `discr` parameter was a non-offset {@link
         * Layout} instance. */ this.discriminator = discriminator;
        /** `true` if the {@link Union#discriminator|discriminator} is the
         * first field in the union.
         *
         * If `false` the discriminator is obtained from somewhere
         * else. */ this.usesPrefixDiscriminator = discr instanceof $2913ed74210dce84$var$UInt || discr instanceof $2913ed74210dce84$var$UIntBE;
        /** The layout for non-discriminator content when the value of the
         * discriminator is not recognized.
         *
         * This is the value passed to the constructor.  It is
         * structurally equivalent to the second component of {@link
         * Union#layout|layout} but may have a different property
         * name. */ this.defaultLayout = defaultLayout;
        /** A registry of allowed variants.
         *
         * The keys are unsigned integers which should be compatible with
         * {@link Union.discriminator|discriminator}.  The property value
         * is the corresponding {@link VariantLayout} instances assigned
         * to this union by {@link Union#addVariant|addVariant}.
         *
         * **NOTE** The registry remains mutable so that variants can be
         * {@link Union#addVariant|added} at any time.  Users should not
         * manipulate the content of this property. */ this.registry = {};
        /* Private variable used when invoking getSourceVariant */ let boundGetSourceVariant = this.defaultGetSourceVariant.bind(this);
        /** Function to infer the variant selected by a source object.
         *
         * Defaults to {@link
         * Union#defaultGetSourceVariant|defaultGetSourceVariant} but may
         * be overridden using {@link
         * Union#configGetSourceVariant|configGetSourceVariant}.
         *
         * @param {Object} src - as with {@link
         * Union#defaultGetSourceVariant|defaultGetSourceVariant}.
         *
         * @returns {(undefined|VariantLayout)} The default variant
         * (`undefined`) or first registered variant that uses a property
         * available in `src`. */ this.getSourceVariant = function(src) {
            return boundGetSourceVariant(src);
        };
        /** Function to override the implementation of {@link
         * Union#getSourceVariant|getSourceVariant}.
         *
         * Use this if the desired variant cannot be identified using the
         * algorithm of {@link
         * Union#defaultGetSourceVariant|defaultGetSourceVariant}.
         *
         * **NOTE** The provided function will be invoked bound to this
         * Union instance, providing local access to {@link
         * Union#registry|registry}.
         *
         * @param {Function} gsv - a function that follows the API of
         * {@link Union#defaultGetSourceVariant|defaultGetSourceVariant}. */ this.configGetSourceVariant = function(gsv) {
            boundGetSourceVariant = gsv.bind(this);
        };
    }
    /** @override */ getSpan(b, offset = 0) {
        if (0 <= this.span) return this.span;
        /* Default layouts always have non-negative span, so we don't have
         * one and we have to recognize the variant which will in turn
         * determine the span. */ const vlo = this.getVariant(b, offset);
        if (!vlo) throw new Error("unable to determine span for unrecognized variant");
        return vlo.getSpan(b, offset);
    }
    /**
     * Method to infer a registered Union variant compatible with `src`.
     *
     * The first satisfied rule in the following sequence defines the
     * return value:
     * * If `src` has properties matching the Union discriminator and
     *   the default layout, `undefined` is returned regardless of the
     *   value of the discriminator property (this ensures the default
     *   layout will be used);
     * * If `src` has a property matching the Union discriminator, the
     *   value of the discriminator identifies a registered variant, and
     *   either (a) the variant has no layout, or (b) `src` has the
     *   variant's property, then the variant is returned (because the
     *   source satisfies the constraints of the variant it identifies);
     * * If `src` does not have a property matching the Union
     *   discriminator, but does have a property matching a registered
     *   variant, then the variant is returned (because the source
     *   matches a variant without an explicit conflict);
     * * An error is thrown (because we either can't identify a variant,
     *   or we were explicitly told the variant but can't satisfy it).
     *
     * @param {Object} src - an object presumed to be compatible with
     * the content of the Union.
     *
     * @return {(undefined|VariantLayout)} - as described above.
     *
     * @throws {Error} - if `src` cannot be associated with a default or
     * registered variant.
     */ defaultGetSourceVariant(src) {
        if (Object.prototype.hasOwnProperty.call(src, this.discriminator.property)) {
            if (this.defaultLayout && this.defaultLayout.property && Object.prototype.hasOwnProperty.call(src, this.defaultLayout.property)) return undefined;
            const vlo = this.registry[src[this.discriminator.property]];
            if (vlo && (!vlo.layout || vlo.property && Object.prototype.hasOwnProperty.call(src, vlo.property))) return vlo;
        } else for(const tag in this.registry){
            const vlo = this.registry[tag];
            if (vlo.property && Object.prototype.hasOwnProperty.call(src, vlo.property)) return vlo;
        }
        throw new Error("unable to infer src variant");
    }
    /** Implement {@link Layout#decode|decode} for {@link Union}.
     *
     * If the variant is {@link Union#addVariant|registered} the return
     * value is an instance of that variant, with no explicit
     * discriminator.  Otherwise the {@link Union#defaultLayout|default
     * layout} is used to decode the content. */ decode(b, offset = 0) {
        let dest;
        const dlo = this.discriminator;
        const discr = dlo.decode(b, offset);
        const clo = this.registry[discr];
        if (undefined === clo) {
            const defaultLayout = this.defaultLayout;
            let contentOffset = 0;
            if (this.usesPrefixDiscriminator) contentOffset = dlo.layout.span;
            dest = this.makeDestinationObject();
            dest[dlo.property] = discr;
            // defaultLayout.property can be undefined, but this is allowed by buffer-layout
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            dest[defaultLayout.property] = defaultLayout.decode(b, offset + contentOffset);
        } else dest = clo.decode(b, offset);
        return dest;
    }
    /** Implement {@link Layout#encode|encode} for {@link Union}.
     *
     * This API assumes the `src` object is consistent with the union's
     * {@link Union#defaultLayout|default layout}.  To encode variants
     * use the appropriate variant-specific {@link VariantLayout#encode}
     * method. */ encode(src, b, offset = 0) {
        const vlo = this.getSourceVariant(src);
        if (undefined === vlo) {
            const dlo = this.discriminator;
            // this.defaultLayout is not undefined when vlo is undefined
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            const clo = this.defaultLayout;
            let contentOffset = 0;
            if (this.usesPrefixDiscriminator) contentOffset = dlo.layout.span;
            dlo.encode(src[dlo.property], b, offset);
            // clo.property is not undefined when vlo is undefined
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            return contentOffset + clo.encode(src[clo.property], b, offset + contentOffset);
        }
        return vlo.encode(src, b, offset);
    }
    /** Register a new variant structure within a union.  The newly
     * created variant is returned.
     *
     * @param {Number} variant - initializer for {@link
     * VariantLayout#variant|variant}.
     *
     * @param {Layout} layout - initializer for {@link
     * VariantLayout#layout|layout}.
     *
     * @param {String} property - initializer for {@link
     * Layout#property|property}.
     *
     * @return {VariantLayout} */ addVariant(variant, layout, property) {
        const rv = new $2913ed74210dce84$var$VariantLayout(this, variant, layout, property);
        this.registry[variant] = rv;
        return rv;
    }
    /**
     * Get the layout associated with a registered variant.
     *
     * If `vb` does not produce a registered variant the function returns
     * `undefined`.
     *
     * @param {(Number|Uint8Array)} vb - either the variant number, or a
     * buffer from which the discriminator is to be read.
     *
     * @param {Number} offset - offset into `vb` for the start of the
     * union.  Used only when `vb` is an instance of {Uint8Array}.
     *
     * @return {({VariantLayout}|undefined)}
     */ getVariant(vb, offset = 0) {
        let variant;
        if (vb instanceof Uint8Array) variant = this.discriminator.decode(vb, offset);
        else variant = vb;
        return this.registry[variant];
    }
}
$2913ed74210dce84$exports.Union = $2913ed74210dce84$var$Union;
/**
 * Represent a specific variant within a containing union.
 *
 * **NOTE** The {@link Layout#span|span} of the variant may include
 * the span of the {@link Union#discriminator|discriminator} used to
 * identify it, but values read and written using the variant strictly
 * conform to the content of {@link VariantLayout#layout|layout}.
 *
 * **NOTE** User code should not invoke this constructor directly.  Use
 * the union {@link Union#addVariant|addVariant} helper method.
 *
 * @param {Union} union - initializer for {@link
 * VariantLayout#union|union}.
 *
 * @param {Number} variant - initializer for {@link
 * VariantLayout#variant|variant}.
 *
 * @param {Layout} [layout] - initializer for {@link
 * VariantLayout#layout|layout}.  If absent the variant carries no
 * data.
 *
 * @param {String} [property] - initializer for {@link
 * Layout#property|property}.  Unlike many other layouts, variant
 * layouts normally include a property name so they can be identified
 * within their containing {@link Union}.  The property identifier may
 * be absent only if `layout` is is absent.
 *
 * @augments {Layout}
 */ class $2913ed74210dce84$var$VariantLayout extends $2913ed74210dce84$var$Layout {
    constructor(union, variant, layout, property){
        if (!(union instanceof $2913ed74210dce84$var$Union)) throw new TypeError("union must be a Union");
        if (!Number.isInteger(variant) || 0 > variant) throw new TypeError("variant must be a (non-negative) integer");
        if ("string" === typeof layout && undefined === property) {
            property = layout;
            layout = null;
        }
        if (layout) {
            if (!(layout instanceof $2913ed74210dce84$var$Layout)) throw new TypeError("layout must be a Layout");
            if (null !== union.defaultLayout && 0 <= layout.span && layout.span > union.defaultLayout.span) throw new Error("variant span exceeds span of containing union");
            if ("string" !== typeof property) throw new TypeError("variant must have a String property");
        }
        let span = union.span;
        if (0 > union.span) {
            span = layout ? layout.span : 0;
            if (0 <= span && union.usesPrefixDiscriminator) span += union.discriminator.layout.span;
        }
        super(span, property);
        /** The {@link Union} to which this variant belongs. */ this.union = union;
        /** The unsigned integral value identifying this variant within
         * the {@link Union#discriminator|discriminator} of the containing
         * union. */ this.variant = variant;
        /** The {@link Layout} to be used when reading/writing the
         * non-discriminator part of the {@link
         * VariantLayout#union|union}.  If `null` the variant carries no
         * data. */ this.layout = layout || null;
    }
    /** @override */ getSpan(b, offset = 0) {
        if (0 <= this.span) /* Will be equal to the containing union span if that is not
             * variable. */ return this.span;
        let contentOffset = 0;
        if (this.union.usesPrefixDiscriminator) contentOffset = this.union.discriminator.layout.span;
        /* Span is defined solely by the variant (and prefix discriminator) */ let span = 0;
        if (this.layout) span = this.layout.getSpan(b, offset + contentOffset);
        return contentOffset + span;
    }
    /** @override */ decode(b, offset = 0) {
        const dest = this.makeDestinationObject();
        if (this !== this.union.getVariant(b, offset)) throw new Error("variant mismatch");
        let contentOffset = 0;
        if (this.union.usesPrefixDiscriminator) contentOffset = this.union.discriminator.layout.span;
        if (this.layout) dest[this.property] = this.layout.decode(b, offset + contentOffset);
        else if (this.property) dest[this.property] = true;
        else if (this.union.usesPrefixDiscriminator) dest[this.union.discriminator.property] = this.variant;
        return dest;
    }
    /** @override */ encode(src, b, offset = 0) {
        let contentOffset = 0;
        if (this.union.usesPrefixDiscriminator) contentOffset = this.union.discriminator.layout.span;
        if (this.layout && !Object.prototype.hasOwnProperty.call(src, this.property)) throw new TypeError("variant lacks property " + this.property);
        this.union.discriminator.encode(this.variant, b, offset);
        let span = contentOffset;
        if (this.layout) {
            this.layout.encode(src[this.property], b, offset + contentOffset);
            span += this.layout.getSpan(b, offset + contentOffset);
            if (0 <= this.union.span && span > this.union.span) throw new Error("encoded variant overruns containing union");
        }
        return span;
    }
    /** Delegate {@link Layout#fromArray|fromArray} to {@link
     * VariantLayout#layout|layout}. */ fromArray(values) {
        if (this.layout) return this.layout.fromArray(values);
        return undefined;
    }
}
$2913ed74210dce84$exports.VariantLayout = $2913ed74210dce84$var$VariantLayout;
/** JavaScript chose to define bitwise operations as operating on
 * signed 32-bit values in 2's complement form, meaning any integer
 * with bit 31 set is going to look negative.  For right shifts that's
 * not a problem, because `>>>` is a logical shift, but for every
 * other bitwise operator we have to compensate for possible negative
 * results. */ function $2913ed74210dce84$var$fixBitwiseResult(v) {
    if (0 > v) v += 0x100000000;
    return v;
}
/**
 * Contain a sequence of bit fields as an unsigned integer.
 *
 * *Factory*: {@link module:Layout.bits|bits}
 *
 * This is a container element; within it there are {@link BitField}
 * instances that provide the extracted properties.  The container
 * simply defines the aggregate representation and its bit ordering.
 * The representation is an object containing properties with numeric
 * or {@link Boolean} values.
 *
 * {@link BitField}s are added with the {@link
 * BitStructure#addField|addField} and {@link
 * BitStructure#addBoolean|addBoolean} methods.

 * @param {Layout} word - initializer for {@link
 * BitStructure#word|word}.  The parameter must be an instance of
 * {@link UInt} (or {@link UIntBE}) that is no more than 4 bytes wide.
 *
 * @param {bool} [msb] - `true` if the bit numbering starts at the
 * most significant bit of the containing word; `false` (default) if
 * it starts at the least significant bit of the containing word.  If
 * the parameter at this position is a string and `property` is
 * `undefined` the value of this argument will instead be used as the
 * value of `property`.
 *
 * @param {string} [property] - initializer for {@link
 * Layout#property|property}.
 *
 * @augments {Layout}
 */ class $2913ed74210dce84$var$BitStructure extends $2913ed74210dce84$var$Layout {
    constructor(word, msb, property){
        if (!(word instanceof $2913ed74210dce84$var$UInt || word instanceof $2913ed74210dce84$var$UIntBE)) throw new TypeError("word must be a UInt or UIntBE layout");
        if ("string" === typeof msb && undefined === property) {
            property = msb;
            msb = false;
        }
        if (4 < word.span) throw new RangeError("word cannot exceed 32 bits");
        super(word.span, property);
        /** The layout used for the packed value.  {@link BitField}
         * instances are packed sequentially depending on {@link
         * BitStructure#msb|msb}. */ this.word = word;
        /** Whether the bit sequences are packed starting at the most
         * significant bit growing down (`true`), or the least significant
         * bit growing up (`false`).
         *
         * **NOTE** Regardless of this value, the least significant bit of
         * any {@link BitField} value is the least significant bit of the
         * corresponding section of the packed value. */ this.msb = !!msb;
        /** The sequence of {@link BitField} layouts that comprise the
         * packed structure.
         *
         * **NOTE** The array remains mutable to allow fields to be {@link
         * BitStructure#addField|added} after construction.  Users should
         * not manipulate the content of this property.*/ this.fields = [];
        /* Storage for the value.  Capture a variable instead of using an
         * instance property because we don't want anything to change the
         * value without going through the mutator. */ let value = 0;
        this._packedSetValue = function(v) {
            value = $2913ed74210dce84$var$fixBitwiseResult(v);
            return this;
        };
        this._packedGetValue = function() {
            return value;
        };
    }
    /** @override */ decode(b, offset = 0) {
        const dest = this.makeDestinationObject();
        const value = this.word.decode(b, offset);
        this._packedSetValue(value);
        for (const fd of this.fields)if (undefined !== fd.property) dest[fd.property] = fd.decode(b);
        return dest;
    }
    /** Implement {@link Layout#encode|encode} for {@link BitStructure}.
     *
     * If `src` is missing a property for a member with a defined {@link
     * Layout#property|property} the corresponding region of the packed
     * value is left unmodified.  Unused bits are also left unmodified. */ encode(src, b, offset = 0) {
        const value = this.word.decode(b, offset);
        this._packedSetValue(value);
        for (const fd of this.fields)if (undefined !== fd.property) {
            const fv = src[fd.property];
            if (undefined !== fv) fd.encode(fv);
        }
        return this.word.encode(this._packedGetValue(), b, offset);
    }
    /** Register a new bitfield with a containing bit structure.  The
     * resulting bitfield is returned.
     *
     * @param {Number} bits - initializer for {@link BitField#bits|bits}.
     *
     * @param {string} property - initializer for {@link
     * Layout#property|property}.
     *
     * @return {BitField} */ addField(bits, property) {
        const bf = new $2913ed74210dce84$var$BitField(this, bits, property);
        this.fields.push(bf);
        return bf;
    }
    /** As with {@link BitStructure#addField|addField} for single-bit
     * fields with `boolean` value representation.
     *
     * @param {string} property - initializer for {@link
     * Layout#property|property}.
     *
     * @return {Boolean} */ // `Boolean` conflicts with the native primitive type
    // eslint-disable-next-line @typescript-eslint/ban-types
    addBoolean(property) {
        // This is my Boolean, not the Javascript one.
        const bf = new $2913ed74210dce84$var$Boolean(this, property);
        this.fields.push(bf);
        return bf;
    }
    /**
     * Get access to the bit field for a given property.
     *
     * @param {String} property - the bit field of interest.
     *
     * @return {BitField} - the field associated with `property`, or
     * undefined if there is no such property.
     */ fieldFor(property) {
        if ("string" !== typeof property) throw new TypeError("property must be string");
        for (const fd of this.fields){
            if (fd.property === property) return fd;
        }
        return undefined;
    }
}
$2913ed74210dce84$exports.BitStructure = $2913ed74210dce84$var$BitStructure;
/**
 * Represent a sequence of bits within a {@link BitStructure}.
 *
 * All bit field values are represented as unsigned integers.
 *
 * **NOTE** User code should not invoke this constructor directly.
 * Use the container {@link BitStructure#addField|addField} helper
 * method.
 *
 * **NOTE** BitField instances are not instances of {@link Layout}
 * since {@link Layout#span|span} measures 8-bit units.
 *
 * @param {BitStructure} container - initializer for {@link
 * BitField#container|container}.
 *
 * @param {Number} bits - initializer for {@link BitField#bits|bits}.
 *
 * @param {string} [property] - initializer for {@link
 * Layout#property|property}.
 */ class $2913ed74210dce84$var$BitField {
    constructor(container, bits, property){
        if (!(container instanceof $2913ed74210dce84$var$BitStructure)) throw new TypeError("container must be a BitStructure");
        if (!Number.isInteger(bits) || 0 >= bits) throw new TypeError("bits must be positive integer");
        const totalBits = 8 * container.span;
        const usedBits = container.fields.reduce((sum, fd)=>sum + fd.bits, 0);
        if (bits + usedBits > totalBits) throw new Error("bits too long for span remainder (" + (totalBits - usedBits) + " of " + totalBits + " remain)");
        /** The {@link BitStructure} instance to which this bit field
         * belongs. */ this.container = container;
        /** The span of this value in bits. */ this.bits = bits;
        /** A mask of {@link BitField#bits|bits} bits isolating value bits
         * that fit within the field.
         *
         * That is, it masks a value that has not yet been shifted into
         * position within its containing packed integer. */ this.valueMask = (1 << bits) - 1;
        if (32 === bits) this.valueMask = 0xFFFFFFFF;
        /** The offset of the value within the containing packed unsigned
         * integer.  The least significant bit of the packed value is at
         * offset zero, regardless of bit ordering used. */ this.start = usedBits;
        if (this.container.msb) this.start = totalBits - usedBits - bits;
        /** A mask of {@link BitField#bits|bits} isolating the field value
         * within the containing packed unsigned integer. */ this.wordMask = $2913ed74210dce84$var$fixBitwiseResult(this.valueMask << this.start);
        /** The property name used when this bitfield is represented in an
         * Object.
         *
         * Intended to be functionally equivalent to {@link
         * Layout#property}.
         *
         * If left undefined the corresponding span of bits will be
         * treated as padding: it will not be mutated by {@link
         * Layout#encode|encode} nor represented as a property in the
         * decoded Object. */ this.property = property;
    }
    /** Store a value into the corresponding subsequence of the containing
     * bit field. */ decode(b, offset) {
        const word = this.container._packedGetValue();
        const wordValue = $2913ed74210dce84$var$fixBitwiseResult(word & this.wordMask);
        const value = wordValue >>> this.start;
        return value;
    }
    /** Store a value into the corresponding subsequence of the containing
     * bit field.
     *
     * **NOTE** This is not a specialization of {@link
     * Layout#encode|Layout.encode} and there is no return value. */ encode(value) {
        if ("number" !== typeof value || !Number.isInteger(value) || value !== $2913ed74210dce84$var$fixBitwiseResult(value & this.valueMask)) throw new TypeError($2913ed74210dce84$var$nameWithProperty("BitField.encode", this) + " value must be integer not exceeding " + this.valueMask);
        const word = this.container._packedGetValue();
        const wordValue = $2913ed74210dce84$var$fixBitwiseResult(value << this.start);
        this.container._packedSetValue($2913ed74210dce84$var$fixBitwiseResult(word & ~this.wordMask) | wordValue);
    }
}
$2913ed74210dce84$exports.BitField = $2913ed74210dce84$var$BitField;
/**
 * Represent a single bit within a {@link BitStructure} as a
 * JavaScript boolean.
 *
 * **NOTE** User code should not invoke this constructor directly.
 * Use the container {@link BitStructure#addBoolean|addBoolean} helper
 * method.
 *
 * @param {BitStructure} container - initializer for {@link
 * BitField#container|container}.
 *
 * @param {string} [property] - initializer for {@link
 * Layout#property|property}.
 *
 * @augments {BitField}
 */ /* eslint-disable no-extend-native */ class $2913ed74210dce84$var$Boolean extends $2913ed74210dce84$var$BitField {
    constructor(container, property){
        super(container, 1, property);
    }
    /** Override {@link BitField#decode|decode} for {@link Boolean|Boolean}.
     *
     * @returns {boolean} */ decode(b, offset) {
        return !!super.decode(b, offset);
    }
    /** @override */ encode(value) {
        if ("boolean" === typeof value) // BitField requires integer values
        value = +value;
        super.encode(value);
    }
}
$2913ed74210dce84$exports.Boolean = $2913ed74210dce84$var$Boolean;
/* eslint-enable no-extend-native */ /**
 * Contain a fixed-length block of arbitrary data, represented as a
 * Uint8Array.
 *
 * *Factory*: {@link module:Layout.blob|blob}
 *
 * @param {(Number|ExternalLayout)} length - initializes {@link
 * Blob#length|length}.
 *
 * @param {String} [property] - initializer for {@link
 * Layout#property|property}.
 *
 * @augments {Layout}
 */ class $2913ed74210dce84$var$Blob extends $2913ed74210dce84$var$Layout {
    constructor(length, property){
        if (!(length instanceof $2913ed74210dce84$var$ExternalLayout && length.isCount() || Number.isInteger(length) && 0 <= length)) throw new TypeError("length must be positive integer or an unsigned integer ExternalLayout");
        let span = -1;
        if (!(length instanceof $2913ed74210dce84$var$ExternalLayout)) span = length;
        super(span, property);
        /** The number of bytes in the blob.
         *
         * This may be a non-negative integer, or an instance of {@link
         * ExternalLayout} that satisfies {@link
         * ExternalLayout#isCount|isCount()}. */ this.length = length;
    }
    /** @override */ getSpan(b, offset) {
        let span = this.span;
        if (0 > span) span = this.length.decode(b, offset);
        return span;
    }
    /** @override */ decode(b, offset = 0) {
        let span = this.span;
        if (0 > span) span = this.length.decode(b, offset);
        return $2913ed74210dce84$var$uint8ArrayToBuffer(b).slice(offset, offset + span);
    }
    /** Implement {@link Layout#encode|encode} for {@link Blob}.
     *
     * **NOTE** If {@link Layout#count|count} is an instance of {@link
     * ExternalLayout} then the length of `src` will be encoded as the
     * count after `src` is encoded. */ encode(src, b, offset) {
        let span = this.length;
        if (this.length instanceof $2913ed74210dce84$var$ExternalLayout) span = src.length;
        if (!(src instanceof Uint8Array && span === src.length)) throw new TypeError($2913ed74210dce84$var$nameWithProperty("Blob.encode", this) + " requires (length " + span + ") Uint8Array as src");
        if (offset + span > b.length) throw new RangeError("encoding overruns Uint8Array");
        const srcBuffer = $2913ed74210dce84$var$uint8ArrayToBuffer(src);
        $2913ed74210dce84$var$uint8ArrayToBuffer(b).write(srcBuffer.toString("hex"), offset, span, "hex");
        if (this.length instanceof $2913ed74210dce84$var$ExternalLayout) this.length.encode(span, b, offset);
        return span;
    }
}
$2913ed74210dce84$exports.Blob = $2913ed74210dce84$var$Blob;
/**
 * Contain a `NUL`-terminated UTF8 string.
 *
 * *Factory*: {@link module:Layout.cstr|cstr}
 *
 * **NOTE** Any UTF8 string that incorporates a zero-valued byte will
 * not be correctly decoded by this layout.
 *
 * @param {String} [property] - initializer for {@link
 * Layout#property|property}.
 *
 * @augments {Layout}
 */ class $2913ed74210dce84$var$CString extends $2913ed74210dce84$var$Layout {
    constructor(property){
        super(-1, property);
    }
    /** @override */ getSpan(b, offset = 0) {
        $2913ed74210dce84$var$checkUint8Array(b);
        let idx = offset;
        while(idx < b.length && 0 !== b[idx])idx += 1;
        return 1 + idx - offset;
    }
    /** @override */ decode(b, offset = 0) {
        const span = this.getSpan(b, offset);
        return $2913ed74210dce84$var$uint8ArrayToBuffer(b).slice(offset, offset + span - 1).toString("utf-8");
    }
    /** @override */ encode(src, b, offset = 0) {
        /* Must force this to a string, lest it be a number and the
         * "utf8-encoding" below actually allocate a buffer of length
         * src */ if ("string" !== typeof src) src = String(src);
        const srcb = $5f7a215ef2b330e3$export$a143d493d941bafc.from(src, "utf8");
        const span = srcb.length;
        if (offset + span > b.length) throw new RangeError("encoding overruns Buffer");
        const buffer = $2913ed74210dce84$var$uint8ArrayToBuffer(b);
        srcb.copy(buffer, offset);
        buffer[offset + span] = 0;
        return span + 1;
    }
}
$2913ed74210dce84$exports.CString = $2913ed74210dce84$var$CString;
/**
 * Contain a UTF8 string with implicit length.
 *
 * *Factory*: {@link module:Layout.utf8|utf8}
 *
 * **NOTE** Because the length is implicit in the size of the buffer
 * this layout should be used only in isolation, or in a situation
 * where the length can be expressed by operating on a slice of the
 * containing buffer.
 *
 * @param {Number} [maxSpan] - the maximum length allowed for encoded
 * string content.  If not provided there is no bound on the allowed
 * content.
 *
 * @param {String} [property] - initializer for {@link
 * Layout#property|property}.
 *
 * @augments {Layout}
 */ class $2913ed74210dce84$var$UTF8 extends $2913ed74210dce84$var$Layout {
    constructor(maxSpan, property){
        if ("string" === typeof maxSpan && undefined === property) {
            property = maxSpan;
            maxSpan = undefined;
        }
        if (undefined === maxSpan) maxSpan = -1;
        else if (!Number.isInteger(maxSpan)) throw new TypeError("maxSpan must be an integer");
        super(-1, property);
        /** The maximum span of the layout in bytes.
         *
         * Positive values are generally expected.  Zero is abnormal.
         * Attempts to encode or decode a value that exceeds this length
         * will throw a `RangeError`.
         *
         * A negative value indicates that there is no bound on the length
         * of the content. */ this.maxSpan = maxSpan;
    }
    /** @override */ getSpan(b, offset = 0) {
        $2913ed74210dce84$var$checkUint8Array(b);
        return b.length - offset;
    }
    /** @override */ decode(b, offset = 0) {
        const span = this.getSpan(b, offset);
        if (0 <= this.maxSpan && this.maxSpan < span) throw new RangeError("text length exceeds maxSpan");
        return $2913ed74210dce84$var$uint8ArrayToBuffer(b).slice(offset, offset + span).toString("utf-8");
    }
    /** @override */ encode(src, b, offset = 0) {
        /* Must force this to a string, lest it be a number and the
         * "utf8-encoding" below actually allocate a buffer of length
         * src */ if ("string" !== typeof src) src = String(src);
        const srcb = $5f7a215ef2b330e3$export$a143d493d941bafc.from(src, "utf8");
        const span = srcb.length;
        if (0 <= this.maxSpan && this.maxSpan < span) throw new RangeError("text length exceeds maxSpan");
        if (offset + span > b.length) throw new RangeError("encoding overruns Buffer");
        srcb.copy($2913ed74210dce84$var$uint8ArrayToBuffer(b), offset);
        return span;
    }
}
$2913ed74210dce84$exports.UTF8 = $2913ed74210dce84$var$UTF8;
/**
 * Contain a constant value.
 *
 * This layout may be used in cases where a JavaScript value can be
 * inferred without an expression in the binary encoding.  An example
 * would be a {@link VariantLayout|variant layout} where the content
 * is implied by the union {@link Union#discriminator|discriminator}.
 *
 * @param {Object|Number|String} value - initializer for {@link
 * Constant#value|value}.  If the value is an object (or array) and
 * the application intends the object to remain unchanged regardless
 * of what is done to values decoded by this layout, the value should
 * be frozen prior passing it to this constructor.
 *
 * @param {String} [property] - initializer for {@link
 * Layout#property|property}.
 *
 * @augments {Layout}
 */ class $2913ed74210dce84$var$Constant extends $2913ed74210dce84$var$Layout {
    constructor(value, property){
        super(0, property);
        /** The value produced by this constant when the layout is {@link
         * Constant#decode|decoded}.
         *
         * Any JavaScript value including `null` and `undefined` is
         * permitted.
         *
         * **WARNING** If `value` passed in the constructor was not
         * frozen, it is possible for users of decoded values to change
         * the content of the value. */ this.value = value;
    }
    /** @override */ decode(b, offset) {
        return this.value;
    }
    /** @override */ encode(src, b, offset) {
        /* Constants take no space */ return 0;
    }
}
$2913ed74210dce84$exports.Constant = $2913ed74210dce84$var$Constant;
/** Factory for {@link GreedyCount}. */ $2913ed74210dce84$exports.greedy = (elementSpan, property)=>new $2913ed74210dce84$var$GreedyCount(elementSpan, property);
/** Factory for {@link OffsetLayout}. */ $2913ed74210dce84$exports.offset = (layout, offset, property)=>new $2913ed74210dce84$var$OffsetLayout(layout, offset, property);
/** Factory for {@link UInt|unsigned int layouts} spanning one
 * byte. */ $2913ed74210dce84$exports.u8 = (property)=>new $2913ed74210dce84$var$UInt(1, property);
/** Factory for {@link UInt|little-endian unsigned int layouts}
 * spanning two bytes. */ $2913ed74210dce84$exports.u16 = (property)=>new $2913ed74210dce84$var$UInt(2, property);
/** Factory for {@link UInt|little-endian unsigned int layouts}
 * spanning three bytes. */ $2913ed74210dce84$exports.u24 = (property)=>new $2913ed74210dce84$var$UInt(3, property);
/** Factory for {@link UInt|little-endian unsigned int layouts}
 * spanning four bytes. */ $2913ed74210dce84$exports.u32 = (property)=>new $2913ed74210dce84$var$UInt(4, property);
/** Factory for {@link UInt|little-endian unsigned int layouts}
 * spanning five bytes. */ $2913ed74210dce84$exports.u40 = (property)=>new $2913ed74210dce84$var$UInt(5, property);
/** Factory for {@link UInt|little-endian unsigned int layouts}
 * spanning six bytes. */ $2913ed74210dce84$exports.u48 = (property)=>new $2913ed74210dce84$var$UInt(6, property);
/** Factory for {@link NearUInt64|little-endian unsigned int
 * layouts} interpreted as Numbers. */ $2913ed74210dce84$exports.nu64 = (property)=>new $2913ed74210dce84$var$NearUInt64(property);
/** Factory for {@link UInt|big-endian unsigned int layouts}
 * spanning two bytes. */ $2913ed74210dce84$exports.u16be = (property)=>new $2913ed74210dce84$var$UIntBE(2, property);
/** Factory for {@link UInt|big-endian unsigned int layouts}
 * spanning three bytes. */ $2913ed74210dce84$exports.u24be = (property)=>new $2913ed74210dce84$var$UIntBE(3, property);
/** Factory for {@link UInt|big-endian unsigned int layouts}
 * spanning four bytes. */ $2913ed74210dce84$exports.u32be = (property)=>new $2913ed74210dce84$var$UIntBE(4, property);
/** Factory for {@link UInt|big-endian unsigned int layouts}
 * spanning five bytes. */ $2913ed74210dce84$exports.u40be = (property)=>new $2913ed74210dce84$var$UIntBE(5, property);
/** Factory for {@link UInt|big-endian unsigned int layouts}
 * spanning six bytes. */ $2913ed74210dce84$exports.u48be = (property)=>new $2913ed74210dce84$var$UIntBE(6, property);
/** Factory for {@link NearUInt64BE|big-endian unsigned int
 * layouts} interpreted as Numbers. */ $2913ed74210dce84$exports.nu64be = (property)=>new $2913ed74210dce84$var$NearUInt64BE(property);
/** Factory for {@link Int|signed int layouts} spanning one
 * byte. */ $2913ed74210dce84$exports.s8 = (property)=>new $2913ed74210dce84$var$Int(1, property);
/** Factory for {@link Int|little-endian signed int layouts}
 * spanning two bytes. */ $2913ed74210dce84$exports.s16 = (property)=>new $2913ed74210dce84$var$Int(2, property);
/** Factory for {@link Int|little-endian signed int layouts}
 * spanning three bytes. */ $2913ed74210dce84$exports.s24 = (property)=>new $2913ed74210dce84$var$Int(3, property);
/** Factory for {@link Int|little-endian signed int layouts}
 * spanning four bytes. */ $2913ed74210dce84$exports.s32 = (property)=>new $2913ed74210dce84$var$Int(4, property);
/** Factory for {@link Int|little-endian signed int layouts}
 * spanning five bytes. */ $2913ed74210dce84$exports.s40 = (property)=>new $2913ed74210dce84$var$Int(5, property);
/** Factory for {@link Int|little-endian signed int layouts}
 * spanning six bytes. */ $2913ed74210dce84$exports.s48 = (property)=>new $2913ed74210dce84$var$Int(6, property);
/** Factory for {@link NearInt64|little-endian signed int layouts}
 * interpreted as Numbers. */ $2913ed74210dce84$exports.ns64 = (property)=>new $2913ed74210dce84$var$NearInt64(property);
/** Factory for {@link Int|big-endian signed int layouts}
 * spanning two bytes. */ $2913ed74210dce84$exports.s16be = (property)=>new $2913ed74210dce84$var$IntBE(2, property);
/** Factory for {@link Int|big-endian signed int layouts}
 * spanning three bytes. */ $2913ed74210dce84$exports.s24be = (property)=>new $2913ed74210dce84$var$IntBE(3, property);
/** Factory for {@link Int|big-endian signed int layouts}
 * spanning four bytes. */ $2913ed74210dce84$exports.s32be = (property)=>new $2913ed74210dce84$var$IntBE(4, property);
/** Factory for {@link Int|big-endian signed int layouts}
 * spanning five bytes. */ $2913ed74210dce84$exports.s40be = (property)=>new $2913ed74210dce84$var$IntBE(5, property);
/** Factory for {@link Int|big-endian signed int layouts}
 * spanning six bytes. */ $2913ed74210dce84$exports.s48be = (property)=>new $2913ed74210dce84$var$IntBE(6, property);
/** Factory for {@link NearInt64BE|big-endian signed int layouts}
 * interpreted as Numbers. */ $2913ed74210dce84$exports.ns64be = (property)=>new $2913ed74210dce84$var$NearInt64BE(property);
/** Factory for {@link Float|little-endian 32-bit floating point} values. */ $2913ed74210dce84$exports.f32 = (property)=>new $2913ed74210dce84$var$Float(property);
/** Factory for {@link FloatBE|big-endian 32-bit floating point} values. */ $2913ed74210dce84$exports.f32be = (property)=>new $2913ed74210dce84$var$FloatBE(property);
/** Factory for {@link Double|little-endian 64-bit floating point} values. */ $2913ed74210dce84$exports.f64 = (property)=>new $2913ed74210dce84$var$Double(property);
/** Factory for {@link DoubleBE|big-endian 64-bit floating point} values. */ $2913ed74210dce84$exports.f64be = (property)=>new $2913ed74210dce84$var$DoubleBE(property);
/** Factory for {@link Structure} values. */ $2913ed74210dce84$exports.struct = (fields, property, decodePrefixes)=>new $2913ed74210dce84$var$Structure(fields, property, decodePrefixes);
/** Factory for {@link BitStructure} values. */ $2913ed74210dce84$exports.bits = (word, msb, property)=>new $2913ed74210dce84$var$BitStructure(word, msb, property);
/** Factory for {@link Sequence} values. */ $2913ed74210dce84$exports.seq = (elementLayout, count, property)=>new $2913ed74210dce84$var$Sequence(elementLayout, count, property);
/** Factory for {@link Union} values. */ $2913ed74210dce84$exports.union = (discr, defaultLayout, property)=>new $2913ed74210dce84$var$Union(discr, defaultLayout, property);
/** Factory for {@link UnionLayoutDiscriminator} values. */ $2913ed74210dce84$exports.unionLayoutDiscriminator = (layout, property)=>new $2913ed74210dce84$var$UnionLayoutDiscriminator(layout, property);
/** Factory for {@link Blob} values. */ $2913ed74210dce84$exports.blob = (length, property)=>new $2913ed74210dce84$var$Blob(length, property);
/** Factory for {@link CString} values. */ $2913ed74210dce84$exports.cstr = (property)=>new $2913ed74210dce84$var$CString(property);
/** Factory for {@link UTF8} values. */ $2913ed74210dce84$exports.utf8 = (maxSpan, property)=>new $2913ed74210dce84$var$UTF8(maxSpan, property);
/** Factory for {@link Constant} values. */ $2913ed74210dce84$exports.constant = (value, property)=>new $2913ed74210dce84$var$Constant(value, property);


var $bc91bf67ed8c7241$exports = {};

var $ihoyg = parcelRequire("ihoyg");
var $bc91bf67ed8c7241$require$Buffer = $ihoyg.Buffer;
"use strict";
Object.defineProperty($bc91bf67ed8c7241$exports, "__esModule", {
    value: true
});
let $bc91bf67ed8c7241$var$converter;
/**
 * Convert a little-endian buffer into a BigInt.
 * @param buf The little-endian buffer to convert
 * @returns A BigInt with the little-endian representation of buf.
 */ function $bc91bf67ed8c7241$var$toBigIntLE(buf) {
    {
        const reversed = $bc91bf67ed8c7241$require$Buffer.from(buf);
        reversed.reverse();
        const hex = reversed.toString("hex");
        if (hex.length === 0) return BigInt(0);
        return BigInt(`0x${hex}`);
    }
    return $bc91bf67ed8c7241$var$converter.toBigInt(buf, false);
}
$bc91bf67ed8c7241$exports.toBigIntLE = $bc91bf67ed8c7241$var$toBigIntLE;
/**
 * Convert a big-endian buffer into a BigInt
 * @param buf The big-endian buffer to convert.
 * @returns A BigInt with the big-endian representation of buf.
 */ function $bc91bf67ed8c7241$var$toBigIntBE(buf) {
    {
        const hex = buf.toString("hex");
        if (hex.length === 0) return BigInt(0);
        return BigInt(`0x${hex}`);
    }
    return $bc91bf67ed8c7241$var$converter.toBigInt(buf, true);
}
$bc91bf67ed8c7241$exports.toBigIntBE = $bc91bf67ed8c7241$var$toBigIntBE;
/**
 * Convert a BigInt to a little-endian buffer.
 * @param num   The BigInt to convert.
 * @param width The number of bytes that the resulting buffer should be.
 * @returns A little-endian buffer representation of num.
 */ function $bc91bf67ed8c7241$var$toBufferLE(num, width) {
    {
        const hex = num.toString(16);
        const buffer = $bc91bf67ed8c7241$require$Buffer.from(hex.padStart(width * 2, "0").slice(0, width * 2), "hex");
        buffer.reverse();
        return buffer;
    }
    // Allocation is done here, since it is slower using napi in C
    return $bc91bf67ed8c7241$var$converter.fromBigInt(num, $bc91bf67ed8c7241$require$Buffer.allocUnsafe(width), false);
}
$bc91bf67ed8c7241$exports.toBufferLE = $bc91bf67ed8c7241$var$toBufferLE;
/**
 * Convert a BigInt to a big-endian buffer.
 * @param num   The BigInt to convert.
 * @param width The number of bytes that the resulting buffer should be.
 * @returns A big-endian buffer representation of num.
 */ function $bc91bf67ed8c7241$var$toBufferBE(num, width) {
    {
        const hex = num.toString(16);
        return $bc91bf67ed8c7241$require$Buffer.from(hex.padStart(width * 2, "0").slice(0, width * 2), "hex");
    }
    return $bc91bf67ed8c7241$var$converter.fromBigInt(num, $bc91bf67ed8c7241$require$Buffer.allocUnsafe(width), true);
}
$bc91bf67ed8c7241$exports.toBufferBE = $bc91bf67ed8c7241$var$toBufferBE;


/**
 * A `StructFailure` represents a single specific failure in validation.
 */ /**
 * `StructError` objects are thrown (or returned) when validation fails.
 *
 * Validation logic is design to exit early for maximum performance. The error
 * represents the first error encountered during validation. For more detail,
 * the `error.failures` property is a generator function that can be run to
 * continue validation and receive all the failures in the data.
 */ class $7154594b4f0d1928$export$58cc9131e3e8861b extends TypeError {
    constructor(failure, failures){
        let cached;
        const { message: message, ...rest } = failure;
        const { path: path } = failure;
        const msg = path.length === 0 ? message : "At path: " + path.join(".") + " -- " + message;
        super(msg);
        Object.assign(this, rest);
        this.name = this.constructor.name;
        this.failures = ()=>{
            var _cached;
            return (_cached = cached) != null ? _cached : cached = [
                failure,
                ...failures()
            ];
        };
    }
}
/**
 * Check if a value is an iterator.
 */ function $7154594b4f0d1928$var$isIterable(x) {
    return $7154594b4f0d1928$var$isObject(x) && typeof x[Symbol.iterator] === "function";
}
/**
 * Check if a value is a plain object.
 */ function $7154594b4f0d1928$var$isObject(x) {
    return typeof x === "object" && x != null;
}
/**
 * Check if a value is a plain object.
 */ function $7154594b4f0d1928$var$isPlainObject(x) {
    if (Object.prototype.toString.call(x) !== "[object Object]") return false;
    const prototype = Object.getPrototypeOf(x);
    return prototype === null || prototype === Object.prototype;
}
/**
 * Return a value as a printable string.
 */ function $7154594b4f0d1928$var$print(value) {
    return typeof value === "string" ? JSON.stringify(value) : "" + value;
}
/**
 * Shifts (removes and returns) the first value from the `input` iterator.
 * Like `Array.prototype.shift()` but for an `Iterator`.
 */ function $7154594b4f0d1928$var$shiftIterator(input) {
    const { done: done, value: value } = input.next();
    return done ? undefined : value;
}
/**
 * Convert a single validation result to a failure.
 */ function $7154594b4f0d1928$var$toFailure(result, context, struct, value) {
    if (result === true) return;
    else if (result === false) result = {};
    else if (typeof result === "string") result = {
        message: result
    };
    const { path: path, branch: branch } = context;
    const { type: type } = struct;
    const { refinement: refinement, message: message = "Expected a value of type `" + type + "`" + (refinement ? " with refinement `" + refinement + "`" : "") + ", but received: `" + $7154594b4f0d1928$var$print(value) + "`" } = result;
    return {
        value: value,
        type: type,
        refinement: refinement,
        key: path[path.length - 1],
        path: path,
        branch: branch,
        ...result,
        message: message
    };
}
/**
 * Convert a validation result to an iterable of failures.
 */ function* $7154594b4f0d1928$var$toFailures(result, context, struct, value) {
    if (!$7154594b4f0d1928$var$isIterable(result)) result = [
        result
    ];
    for (const r of result){
        const failure = $7154594b4f0d1928$var$toFailure(r, context, struct, value);
        if (failure) yield failure;
    }
}
/**
 * Check a value against a struct, traversing deeply into nested values, and
 * returning an iterator of failures or success.
 */ function* $7154594b4f0d1928$var$run(value, struct, options = {}) {
    const { path: path = [], branch: branch = [
        value
    ], coerce: coerce = false, mask: mask = false } = options;
    const ctx = {
        path: path,
        branch: branch
    };
    if (coerce) {
        value = struct.coercer(value, ctx);
        if (mask && struct.type !== "type" && $7154594b4f0d1928$var$isObject(struct.schema) && $7154594b4f0d1928$var$isObject(value) && !Array.isArray(value)) {
            for(const key in value)if (struct.schema[key] === undefined) delete value[key];
        }
    }
    let valid = true;
    for (const failure of struct.validator(value, ctx)){
        valid = false;
        yield [
            failure,
            undefined
        ];
    }
    for (let [k, v, s] of struct.entries(value, ctx)){
        const ts = $7154594b4f0d1928$var$run(v, s, {
            path: k === undefined ? path : [
                ...path,
                k
            ],
            branch: k === undefined ? branch : [
                ...branch,
                v
            ],
            coerce: coerce,
            mask: mask
        });
        for (const t of ts){
            if (t[0]) {
                valid = false;
                yield [
                    t[0],
                    undefined
                ];
            } else if (coerce) {
                v = t[1];
                if (k === undefined) value = v;
                else if (value instanceof Map) value.set(k, v);
                else if (value instanceof Set) value.add(v);
                else if ($7154594b4f0d1928$var$isObject(value)) value[k] = v;
            }
        }
    }
    if (valid) for (const failure of struct.refiner(value, ctx)){
        valid = false;
        yield [
            failure,
            undefined
        ];
    }
    if (valid) yield [
        undefined,
        value
    ];
}
/**
 * `Struct` objects encapsulate the validation logic for a specific type of
 * values. Once constructed, you use the `assert`, `is` or `validate` helpers to
 * validate unknown input data against the struct.
 */ class $7154594b4f0d1928$export$eabc71f011df675a {
    constructor(props){
        const { type: type, schema: schema, validator: validator, refiner: refiner, coercer: coercer = (value)=>value, entries: entries = function*() {} } = props;
        this.type = type;
        this.schema = schema;
        this.entries = entries;
        this.coercer = coercer;
        if (validator) this.validator = (value, context)=>{
            const result = validator(value, context);
            return $7154594b4f0d1928$var$toFailures(result, context, this, value);
        };
        else this.validator = ()=>[];
        if (refiner) this.refiner = (value, context)=>{
            const result = refiner(value, context);
            return $7154594b4f0d1928$var$toFailures(result, context, this, value);
        };
        else this.refiner = ()=>[];
    }
    /**
   * Assert that a value passes the struct's validation, throwing if it doesn't.
   */ assert(value) {
        return $7154594b4f0d1928$export$a7a9523472993e97(value, this);
    }
    /**
   * Create a value with the struct's coercion logic, then validate it.
   */ create(value) {
        return $7154594b4f0d1928$export$185802fd694ee1f5(value, this);
    }
    /**
   * Check if a value passes the struct's validation.
   */ is(value) {
        return $7154594b4f0d1928$export$226b3eccf92c9ed9(value, this);
    }
    /**
   * Mask a value, coercing and validating it, but returning only the subset of
   * properties defined by the struct's schema.
   */ mask(value) {
        return $7154594b4f0d1928$export$d99f0801a68bbcf1(value, this);
    }
    /**
   * Validate a value with the struct's validation logic, returning a tuple
   * representing the result.
   *
   * You may optionally pass `true` for the `withCoercion` argument to coerce
   * the value before attempting to validate it. If you do, the result will
   * contain the coerced result when successful.
   */ validate(value, options = {}) {
        return $7154594b4f0d1928$export$a22775fa5e2eebd9(value, this, options);
    }
}
/**
 * Assert that a value passes a struct, throwing if it doesn't.
 */ function $7154594b4f0d1928$export$a7a9523472993e97(value, struct) {
    const result = $7154594b4f0d1928$export$a22775fa5e2eebd9(value, struct);
    if (result[0]) throw result[0];
}
/**
 * Create a value with the coercion logic of struct and validate it.
 */ function $7154594b4f0d1928$export$185802fd694ee1f5(value, struct) {
    const result = $7154594b4f0d1928$export$a22775fa5e2eebd9(value, struct, {
        coerce: true
    });
    if (result[0]) throw result[0];
    else return result[1];
}
/**
 * Mask a value, returning only the subset of properties defined by a struct.
 */ function $7154594b4f0d1928$export$d99f0801a68bbcf1(value, struct) {
    const result = $7154594b4f0d1928$export$a22775fa5e2eebd9(value, struct, {
        coerce: true,
        mask: true
    });
    if (result[0]) throw result[0];
    else return result[1];
}
/**
 * Check if a value passes a struct.
 */ function $7154594b4f0d1928$export$226b3eccf92c9ed9(value, struct) {
    const result = $7154594b4f0d1928$export$a22775fa5e2eebd9(value, struct);
    return !result[0];
}
/**
 * Validate a value against a struct, returning an error if invalid, or the
 * value (with potential coercion) if valid.
 */ function $7154594b4f0d1928$export$a22775fa5e2eebd9(value, struct, options = {}) {
    const tuples = $7154594b4f0d1928$var$run(value, struct, options);
    const tuple = $7154594b4f0d1928$var$shiftIterator(tuples);
    if (tuple[0]) {
        const error = new $7154594b4f0d1928$export$58cc9131e3e8861b(tuple[0], function*() {
            for (const t of tuples)if (t[0]) yield t[0];
        });
        return [
            error,
            undefined
        ];
    } else {
        const v = tuple[1];
        return [
            undefined,
            v
        ];
    }
}
function $7154594b4f0d1928$export$e6e34fd1f2686227(...Structs) {
    const schemas = Structs.map((s)=>s.schema);
    const schema = Object.assign({}, ...schemas);
    return $7154594b4f0d1928$export$be5493f9613cbbe(schema);
}
/**
 * Define a new struct type with a custom validation function.
 */ function $7154594b4f0d1928$export$f36d6a7a5c09a23e(name, validator) {
    return new $7154594b4f0d1928$export$eabc71f011df675a({
        type: name,
        schema: null,
        validator: validator
    });
}
/**
 * Create a new struct based on an existing struct, but the value is allowed to
 * be `undefined`. `log` will be called if the value is not `undefined`.
 */ function $7154594b4f0d1928$export$cdd73fc4100a6ef4(struct, log) {
    return new $7154594b4f0d1928$export$eabc71f011df675a({
        ...struct,
        refiner: (value, ctx)=>value === undefined || struct.refiner(value, ctx),
        validator (value, ctx) {
            if (value === undefined) return true;
            else {
                log(value, ctx);
                return struct.validator(value, ctx);
            }
        }
    });
}
/**
 * Create a struct with dynamic validation logic.
 *
 * The callback will receive the value currently being validated, and must
 * return a struct object to validate it with. This can be useful to model
 * validation logic that changes based on its input.
 */ function $7154594b4f0d1928$export$7077912c31975674(fn) {
    return new $7154594b4f0d1928$export$eabc71f011df675a({
        type: "dynamic",
        schema: null,
        *entries (value, ctx) {
            const struct = fn(value, ctx);
            yield* struct.entries(value, ctx);
        },
        validator (value, ctx) {
            const struct = fn(value, ctx);
            return struct.validator(value, ctx);
        },
        coercer (value, ctx) {
            const struct = fn(value, ctx);
            return struct.coercer(value, ctx);
        }
    });
}
/**
 * Create a struct with lazily evaluated validation logic.
 *
 * The first time validation is run with the struct, the callback will be called
 * and must return a struct object to use. This is useful for cases where you
 * want to have self-referential structs for nested data structures to avoid a
 * circular definition problem.
 */ function $7154594b4f0d1928$export$488013bae63b21da(fn) {
    let struct;
    return new $7154594b4f0d1928$export$eabc71f011df675a({
        type: "lazy",
        schema: null,
        *entries (value, ctx) {
            var _struct;
            (_struct = struct) != null ? _struct : struct = fn();
            yield* struct.entries(value, ctx);
        },
        validator (value, ctx) {
            var _struct2;
            (_struct2 = struct) != null ? _struct2 : struct = fn();
            return struct.validator(value, ctx);
        },
        coercer (value, ctx) {
            var _struct3;
            (_struct3 = struct) != null ? _struct3 : struct = fn();
            return struct.coercer(value, ctx);
        }
    });
}
/**
 * Create a new struct based on an existing object struct, but excluding
 * specific properties.
 *
 * Like TypeScript's `Omit` utility.
 */ function $7154594b4f0d1928$export$30a06c8d3562193f(struct, keys) {
    const { schema: schema } = struct;
    const subschema = {
        ...schema
    };
    for (const key of keys)delete subschema[key];
    return $7154594b4f0d1928$export$be5493f9613cbbe(subschema);
}
/**
 * Create a new struct based on an existing object struct, but with all of its
 * properties allowed to be `undefined`.
 *
 * Like TypeScript's `Partial` utility.
 */ function $7154594b4f0d1928$export$e45945969df8035a(struct) {
    const schema = struct instanceof $7154594b4f0d1928$export$eabc71f011df675a ? {
        ...struct.schema
    } : {
        ...struct
    };
    for(const key in schema)schema[key] = $7154594b4f0d1928$export$516e28dec6a4b6d4(schema[key]);
    return $7154594b4f0d1928$export$be5493f9613cbbe(schema);
}
/**
 * Create a new struct based on an existing object struct, but only including
 * specific properties.
 *
 * Like TypeScript's `Pick` utility.
 */ function $7154594b4f0d1928$export$357523c63a2253b9(struct, keys) {
    const { schema: schema } = struct;
    const subschema = {};
    for (const key of keys)subschema[key] = schema[key];
    return $7154594b4f0d1928$export$be5493f9613cbbe(subschema);
}
/**
 * Define a new struct type with a custom validation function.
 *
 * @deprecated This function has been renamed to `define`.
 */ function $7154594b4f0d1928$export$8cf3da7c1c9174ea(name, validator) {
    console.warn("superstruct@0.11 - The `struct` helper has been renamed to `define`.");
    return $7154594b4f0d1928$export$f36d6a7a5c09a23e(name, validator);
}
/**
 * Ensure that any value passes validation.
 */ function $7154594b4f0d1928$export$4154a199d7d90455() {
    return $7154594b4f0d1928$export$f36d6a7a5c09a23e("any", ()=>true);
}
function $7154594b4f0d1928$export$2f23118c22fb2630(Element) {
    return new $7154594b4f0d1928$export$eabc71f011df675a({
        type: "array",
        schema: Element,
        *entries (value) {
            if (Element && Array.isArray(value)) for (const [i, v] of value.entries())yield [
                i,
                v,
                Element
            ];
        },
        coercer (value) {
            return Array.isArray(value) ? value.slice() : value;
        },
        validator (value) {
            return Array.isArray(value) || "Expected an array value, but received: " + $7154594b4f0d1928$var$print(value);
        }
    });
}
/**
 * Ensure that a value is a boolean.
 */ function $7154594b4f0d1928$export$4a21f16c33752377() {
    return $7154594b4f0d1928$export$f36d6a7a5c09a23e("boolean", (value)=>{
        return typeof value === "boolean";
    });
}
/**
 * Ensure that a value is a valid `Date`.
 *
 * Note: this also ensures that the value is *not* an invalid `Date` object,
 * which can occur when parsing a date fails but still returns a `Date`.
 */ function $7154594b4f0d1928$export$324d90190a8b822a() {
    return $7154594b4f0d1928$export$f36d6a7a5c09a23e("date", (value)=>{
        return value instanceof Date && !isNaN(value.getTime()) || "Expected a valid `Date` object, but received: " + $7154594b4f0d1928$var$print(value);
    });
}
function $7154594b4f0d1928$export$9b16c434df8cc259(values) {
    const schema = {};
    const description = values.map((v)=>$7154594b4f0d1928$var$print(v)).join();
    for (const key of values)schema[key] = key;
    return new $7154594b4f0d1928$export$eabc71f011df675a({
        type: "enums",
        schema: schema,
        validator (value) {
            return values.includes(value) || "Expected one of `" + description + "`, but received: " + $7154594b4f0d1928$var$print(value);
        }
    });
}
/**
 * Ensure that a value is a function.
 */ function $7154594b4f0d1928$export$86951950244e2001() {
    return $7154594b4f0d1928$export$f36d6a7a5c09a23e("func", (value)=>{
        return typeof value === "function" || "Expected a function, but received: " + $7154594b4f0d1928$var$print(value);
    });
}
/**
 * Ensure that a value is an instance of a specific class.
 */ function $7154594b4f0d1928$export$9544d5bb712b01ea(Class) {
    return $7154594b4f0d1928$export$f36d6a7a5c09a23e("instance", (value)=>{
        return value instanceof Class || "Expected a `" + Class.name + "` instance, but received: " + $7154594b4f0d1928$var$print(value);
    });
}
/**
 * Ensure that a value is an integer.
 */ function $7154594b4f0d1928$export$32744b5b3bba4764() {
    return $7154594b4f0d1928$export$f36d6a7a5c09a23e("integer", (value)=>{
        return typeof value === "number" && !isNaN(value) && Number.isInteger(value) || "Expected an integer, but received: " + $7154594b4f0d1928$var$print(value);
    });
}
function $7154594b4f0d1928$export$bc86dfbf7795668c(Structs) {
    return new $7154594b4f0d1928$export$eabc71f011df675a({
        type: "intersection",
        schema: null,
        *entries (value, ctx) {
            for (const S of Structs)yield* S.entries(value, ctx);
        },
        *validator (value, ctx) {
            for (const S of Structs)yield* S.validator(value, ctx);
        },
        *refiner (value, ctx) {
            for (const S of Structs)yield* S.refiner(value, ctx);
        }
    });
}
function $7154594b4f0d1928$export$c8ec6e1ec9fefcb0(constant) {
    const description = $7154594b4f0d1928$var$print(constant);
    const t = typeof constant;
    return new $7154594b4f0d1928$export$eabc71f011df675a({
        type: "literal",
        schema: t === "string" || t === "number" || t === "boolean" ? constant : null,
        validator (value) {
            return value === constant || "Expected the literal `" + description + "`, but received: " + $7154594b4f0d1928$var$print(value);
        }
    });
}
function $7154594b4f0d1928$export$871de8747c9eaa88(Key, Value) {
    return new $7154594b4f0d1928$export$eabc71f011df675a({
        type: "map",
        schema: null,
        *entries (value) {
            if (Key && Value && value instanceof Map) for (const [k, v] of value.entries()){
                yield [
                    k,
                    k,
                    Key
                ];
                yield [
                    k,
                    v,
                    Value
                ];
            }
        },
        coercer (value) {
            return value instanceof Map ? new Map(value) : value;
        },
        validator (value) {
            return value instanceof Map || "Expected a `Map` object, but received: " + $7154594b4f0d1928$var$print(value);
        }
    });
}
/**
 * Ensure that no value ever passes validation.
 */ function $7154594b4f0d1928$export$b3e22bcfd64c1022() {
    return $7154594b4f0d1928$export$f36d6a7a5c09a23e("never", ()=>false);
}
/**
 * Augment an existing struct to allow `null` values.
 */ function $7154594b4f0d1928$export$133fc36489ac9add(struct) {
    return new $7154594b4f0d1928$export$eabc71f011df675a({
        ...struct,
        validator: (value, ctx)=>value === null || struct.validator(value, ctx),
        refiner: (value, ctx)=>value === null || struct.refiner(value, ctx)
    });
}
/**
 * Ensure that a value is a number.
 */ function $7154594b4f0d1928$export$98e628dec113755e() {
    return $7154594b4f0d1928$export$f36d6a7a5c09a23e("number", (value)=>{
        return typeof value === "number" && !isNaN(value) || "Expected a number, but received: " + $7154594b4f0d1928$var$print(value);
    });
}
function $7154594b4f0d1928$export$be5493f9613cbbe(schema) {
    const knowns = schema ? Object.keys(schema) : [];
    const Never = $7154594b4f0d1928$export$b3e22bcfd64c1022();
    return new $7154594b4f0d1928$export$eabc71f011df675a({
        type: "object",
        schema: schema ? schema : null,
        *entries (value) {
            if (schema && $7154594b4f0d1928$var$isObject(value)) {
                const unknowns = new Set(Object.keys(value));
                for (const key of knowns){
                    unknowns.delete(key);
                    yield [
                        key,
                        value[key],
                        schema[key]
                    ];
                }
                for (const key of unknowns)yield [
                    key,
                    value[key],
                    Never
                ];
            }
        },
        validator (value) {
            return $7154594b4f0d1928$var$isObject(value) || "Expected an object, but received: " + $7154594b4f0d1928$var$print(value);
        },
        coercer (value) {
            return $7154594b4f0d1928$var$isObject(value) ? {
                ...value
            } : value;
        }
    });
}
/**
 * Augment a struct to allow `undefined` values.
 */ function $7154594b4f0d1928$export$516e28dec6a4b6d4(struct) {
    return new $7154594b4f0d1928$export$eabc71f011df675a({
        ...struct,
        validator: (value, ctx)=>value === undefined || struct.validator(value, ctx),
        refiner: (value, ctx)=>value === undefined || struct.refiner(value, ctx)
    });
}
/**
 * Ensure that a value is an object with keys and values of specific types, but
 * without ensuring any specific shape of properties.
 *
 * Like TypeScript's `Record` utility.
 */ function $7154594b4f0d1928$export$e5185e241753e543(Key, Value) {
    return new $7154594b4f0d1928$export$eabc71f011df675a({
        type: "record",
        schema: null,
        *entries (value) {
            if ($7154594b4f0d1928$var$isObject(value)) for(const k in value){
                const v = value[k];
                yield [
                    k,
                    k,
                    Key
                ];
                yield [
                    k,
                    v,
                    Value
                ];
            }
        },
        validator (value) {
            return $7154594b4f0d1928$var$isObject(value) || "Expected an object, but received: " + $7154594b4f0d1928$var$print(value);
        }
    });
}
/**
 * Ensure that a value is a `RegExp`.
 *
 * Note: this does not test the value against the regular expression! For that
 * you need to use the `pattern()` refinement.
 */ function $7154594b4f0d1928$export$efdc1e5bdb609bb() {
    return $7154594b4f0d1928$export$f36d6a7a5c09a23e("regexp", (value)=>{
        return value instanceof RegExp;
    });
}
function $7154594b4f0d1928$export$adaa4cf7ef1b65be(Element) {
    return new $7154594b4f0d1928$export$eabc71f011df675a({
        type: "set",
        schema: null,
        *entries (value) {
            if (Element && value instanceof Set) for (const v of value)yield [
                v,
                v,
                Element
            ];
        },
        coercer (value) {
            return value instanceof Set ? new Set(value) : value;
        },
        validator (value) {
            return value instanceof Set || "Expected a `Set` object, but received: " + $7154594b4f0d1928$var$print(value);
        }
    });
}
/**
 * Ensure that a value is a string.
 */ function $7154594b4f0d1928$export$22b082955e083ec3() {
    return $7154594b4f0d1928$export$f36d6a7a5c09a23e("string", (value)=>{
        return typeof value === "string" || "Expected a string, but received: " + $7154594b4f0d1928$var$print(value);
    });
}
function $7154594b4f0d1928$export$65e3907585753458(Elements) {
    const Never = $7154594b4f0d1928$export$b3e22bcfd64c1022();
    return new $7154594b4f0d1928$export$eabc71f011df675a({
        type: "tuple",
        schema: null,
        *entries (value) {
            if (Array.isArray(value)) {
                const length = Math.max(Elements.length, value.length);
                for(let i = 0; i < length; i++)yield [
                    i,
                    value[i],
                    Elements[i] || Never
                ];
            }
        },
        validator (value) {
            return Array.isArray(value) || "Expected an array, but received: " + $7154594b4f0d1928$var$print(value);
        }
    });
}
/**
 * Ensure that a value has a set of known properties of specific types.
 *
 * Note: Unrecognized properties are allowed and untouched. This is similar to
 * how TypeScript's structural typing works.
 */ function $7154594b4f0d1928$export$bf9fb029d174d554(schema) {
    const keys = Object.keys(schema);
    return new $7154594b4f0d1928$export$eabc71f011df675a({
        type: "type",
        schema: schema,
        *entries (value) {
            if ($7154594b4f0d1928$var$isObject(value)) for (const k of keys)yield [
                k,
                value[k],
                schema[k]
            ];
        },
        validator (value) {
            return $7154594b4f0d1928$var$isObject(value) || "Expected an object, but received: " + $7154594b4f0d1928$var$print(value);
        }
    });
}
function $7154594b4f0d1928$export$971dd5b0dfd021b6(Structs) {
    const description = Structs.map((s)=>s.type).join(" | ");
    return new $7154594b4f0d1928$export$eabc71f011df675a({
        type: "union",
        schema: null,
        validator (value, ctx) {
            const failures = [];
            for (const S of Structs){
                const [...tuples] = $7154594b4f0d1928$var$run(value, S, ctx);
                const [first] = tuples;
                if (!first[0]) return [];
                else {
                    for (const [failure] of tuples)if (failure) failures.push(failure);
                }
            }
            return [
                "Expected the value to satisfy a union of `" + description + "`, but received: " + $7154594b4f0d1928$var$print(value),
                ...failures
            ];
        }
    });
}
/**
 * Ensure that any value passes validation, without widening its type to `any`.
 */ function $7154594b4f0d1928$export$19282c40b967aec6() {
    return $7154594b4f0d1928$export$f36d6a7a5c09a23e("unknown", ()=>true);
}
/**
 * Augment a `Struct` to add an additional coercion step to its input.
 *
 * This allows you to transform input data before validating it, to increase the
 * likelihood that it passes validation—for example for default values, parsing
 * different formats, etc.
 *
 * Note: You must use `create(value, Struct)` on the value to have the coercion
 * take effect! Using simply `assert()` or `is()` will not use coercion.
 */ function $7154594b4f0d1928$export$8c14e57e778d3873(struct, condition, coercer) {
    return new $7154594b4f0d1928$export$eabc71f011df675a({
        ...struct,
        coercer: (value, ctx)=>{
            return $7154594b4f0d1928$export$226b3eccf92c9ed9(value, condition) ? struct.coercer(coercer(value, ctx), ctx) : struct.coercer(value, ctx);
        }
    });
}
/**
 * Augment a struct to replace `undefined` values with a default.
 *
 * Note: You must use `create(value, Struct)` on the value to have the coercion
 * take effect! Using simply `assert()` or `is()` will not use coercion.
 */ function $7154594b4f0d1928$export$83c510c4356017ae(struct, fallback, options = {}) {
    return $7154594b4f0d1928$export$8c14e57e778d3873(struct, $7154594b4f0d1928$export$19282c40b967aec6(), (x)=>{
        const f = typeof fallback === "function" ? fallback() : fallback;
        if (x === undefined) return f;
        if (!options.strict && $7154594b4f0d1928$var$isPlainObject(x) && $7154594b4f0d1928$var$isPlainObject(f)) {
            const ret = {
                ...x
            };
            let changed = false;
            for(const key in f)if (ret[key] === undefined) {
                ret[key] = f[key];
                changed = true;
            }
            if (changed) return ret;
        }
        return x;
    });
}
/**
 * Augment a struct to trim string inputs.
 *
 * Note: You must use `create(value, Struct)` on the value to have the coercion
 * take effect! Using simply `assert()` or `is()` will not use coercion.
 */ function $7154594b4f0d1928$export$41f369984ed28930(struct) {
    return $7154594b4f0d1928$export$8c14e57e778d3873(struct, $7154594b4f0d1928$export$22b082955e083ec3(), (x)=>x.trim());
}
/**
 * Ensure that a string, array, map, or set is empty.
 */ function $7154594b4f0d1928$export$6e22c362a0406a2c(struct) {
    const expected = "Expected an empty " + struct.type;
    return $7154594b4f0d1928$export$edc9d475108b3212(struct, "empty", (value)=>{
        if (value instanceof Map || value instanceof Set) {
            const { size: size } = value;
            return size === 0 || expected + " but received one with a size of `" + size + "`";
        } else {
            const { length: length } = value;
            return length === 0 || expected + " but received one with a length of `" + length + "`";
        }
    });
}
/**
 * Ensure that a number or date is below a threshold.
 */ function $7154594b4f0d1928$export$8960430cfd85939f(struct, threshold, options = {}) {
    const { exclusive: exclusive } = options;
    return $7154594b4f0d1928$export$edc9d475108b3212(struct, "max", (value)=>{
        return exclusive ? value < threshold : value <= threshold || "Expected a " + struct.type + " greater than " + (exclusive ? "" : "or equal to ") + threshold + " but received `" + value + "`";
    });
}
/**
 * Ensure that a number or date is above a threshold.
 */ function $7154594b4f0d1928$export$96ec731ed4dcb222(struct, threshold, options = {}) {
    const { exclusive: exclusive } = options;
    return $7154594b4f0d1928$export$edc9d475108b3212(struct, "min", (value)=>{
        return exclusive ? value > threshold : value >= threshold || "Expected a " + struct.type + " greater than " + (exclusive ? "" : "or equal to ") + threshold + " but received `" + value + "`";
    });
}
/**
 * Ensure that a string matches a regular expression.
 */ function $7154594b4f0d1928$export$24f82734ea047e6f(struct, regexp) {
    return $7154594b4f0d1928$export$edc9d475108b3212(struct, "pattern", (value)=>{
        return regexp.test(value) || "Expected a " + struct.type + " matching `/" + regexp.source + '/` but received "' + value + '"';
    });
}
/**
 * Ensure that a string, array, number, date, map, or set has a size (or length, or time) between `min` and `max`.
 */ function $7154594b4f0d1928$export$346677f925de839c(struct, min, max = min) {
    const expected = "Expected a " + struct.type;
    const of = min === max ? "of `" + min + "`" : "between `" + min + "` and `" + max + "`";
    return $7154594b4f0d1928$export$edc9d475108b3212(struct, "size", (value)=>{
        if (typeof value === "number" || value instanceof Date) return min <= value && value <= max || expected + " " + of + " but received `" + value + "`";
        else if (value instanceof Map || value instanceof Set) {
            const { size: size } = value;
            return min <= size && size <= max || expected + " with a size " + of + " but received one with a size of `" + size + "`";
        } else {
            const { length: length } = value;
            return min <= length && length <= max || expected + " with a length " + of + " but received one with a length of `" + length + "`";
        }
    });
}
/**
 * Augment a `Struct` to add an additional refinement to the validation.
 *
 * The refiner function is guaranteed to receive a value of the struct's type,
 * because the struct's existing validation will already have passed. This
 * allows you to layer additional validation on top of existing structs.
 */ function $7154594b4f0d1928$export$edc9d475108b3212(struct, name, refiner) {
    return new $7154594b4f0d1928$export$eabc71f011df675a({
        ...struct,
        *refiner (value, ctx) {
            yield* struct.refiner(value, ctx);
            const result = refiner(value, ctx);
            const failures = $7154594b4f0d1928$var$toFailures(result, ctx, struct, value);
            for (const failure of failures)yield {
                ...failure,
                refinement: name
            };
        }
    });
}


var $b673f3d4b64776a3$exports = {};
"use strict";
// Unique ID creation requires a high quality random # generator. In the browser we therefore
// require the crypto API and do not support built-in fallback to lower quality random number
// generators (like Math.random()).
var $ecc82b4b4d5334a5$var$getRandomValues;
var $ecc82b4b4d5334a5$var$rnds8 = new Uint8Array(16);
function $ecc82b4b4d5334a5$export$2e2bcd8739ae039() {
    // lazy load so that environments that need to polyfill have a chance to do so
    if (!$ecc82b4b4d5334a5$var$getRandomValues) {
        // getRandomValues needs to be invoked in a context where "this" is a Crypto implementation. Also,
        // find the complete implementation of crypto (msCrypto) on IE11.
        $ecc82b4b4d5334a5$var$getRandomValues = typeof crypto !== "undefined" && crypto.getRandomValues && crypto.getRandomValues.bind(crypto) || typeof msCrypto !== "undefined" && typeof msCrypto.getRandomValues === "function" && msCrypto.getRandomValues.bind(msCrypto);
        if (!$ecc82b4b4d5334a5$var$getRandomValues) throw new Error("crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported");
    }
    return $ecc82b4b4d5334a5$var$getRandomValues($ecc82b4b4d5334a5$var$rnds8);
}


var $83c241de251331e8$export$2e2bcd8739ae039 = /^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000)$/i;


function $e70e86397c656fa2$var$validate(uuid) {
    return typeof uuid === "string" && (0, $83c241de251331e8$export$2e2bcd8739ae039).test(uuid);
}
var $e70e86397c656fa2$export$2e2bcd8739ae039 = $e70e86397c656fa2$var$validate;


/**
 * Convert array of 16 byte values to UUID string format of the form:
 * XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX
 */ var $5ce84198744ccadf$var$byteToHex = [];
for(var $5ce84198744ccadf$var$i = 0; $5ce84198744ccadf$var$i < 256; ++$5ce84198744ccadf$var$i)$5ce84198744ccadf$var$byteToHex.push(($5ce84198744ccadf$var$i + 0x100).toString(16).substr(1));
function $5ce84198744ccadf$var$stringify(arr) {
    var offset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    // Note: Be careful editing this code!  It's been tuned for performance
    // and works in ways you may not expect. See https://github.com/uuidjs/uuid/pull/434
    var uuid = ($5ce84198744ccadf$var$byteToHex[arr[offset + 0]] + $5ce84198744ccadf$var$byteToHex[arr[offset + 1]] + $5ce84198744ccadf$var$byteToHex[arr[offset + 2]] + $5ce84198744ccadf$var$byteToHex[arr[offset + 3]] + "-" + $5ce84198744ccadf$var$byteToHex[arr[offset + 4]] + $5ce84198744ccadf$var$byteToHex[arr[offset + 5]] + "-" + $5ce84198744ccadf$var$byteToHex[arr[offset + 6]] + $5ce84198744ccadf$var$byteToHex[arr[offset + 7]] + "-" + $5ce84198744ccadf$var$byteToHex[arr[offset + 8]] + $5ce84198744ccadf$var$byteToHex[arr[offset + 9]] + "-" + $5ce84198744ccadf$var$byteToHex[arr[offset + 10]] + $5ce84198744ccadf$var$byteToHex[arr[offset + 11]] + $5ce84198744ccadf$var$byteToHex[arr[offset + 12]] + $5ce84198744ccadf$var$byteToHex[arr[offset + 13]] + $5ce84198744ccadf$var$byteToHex[arr[offset + 14]] + $5ce84198744ccadf$var$byteToHex[arr[offset + 15]]).toLowerCase(); // Consistency check for valid UUID.  If this throws, it's likely due to one
    // of the following:
    // - One or more input array values don't map to a hex octet (leading to
    // "undefined" in the uuid)
    // - Invalid input values for the RFC `version` or `variant` fields
    if (!(0, $e70e86397c656fa2$export$2e2bcd8739ae039)(uuid)) throw TypeError("Stringified UUID is invalid");
    return uuid;
}
var $5ce84198744ccadf$export$2e2bcd8739ae039 = $5ce84198744ccadf$var$stringify;


function $87befc68df50040c$var$v4(options, buf, offset) {
    options = options || {};
    var rnds = options.random || (options.rng || (0, $ecc82b4b4d5334a5$export$2e2bcd8739ae039))(); // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`
    rnds[6] = rnds[6] & 0x0f | 0x40;
    rnds[8] = rnds[8] & 0x3f | 0x80; // Copy bytes to buffer, if provided
    if (buf) {
        offset = offset || 0;
        for(var i = 0; i < 16; ++i)buf[offset + i] = rnds[i];
        return buf;
    }
    return (0, $5ce84198744ccadf$export$2e2bcd8739ae039)(rnds);
}
var $87befc68df50040c$export$2e2bcd8739ae039 = $87befc68df50040c$var$v4;


var $b673f3d4b64776a3$require$uuid = $87befc68df50040c$export$2e2bcd8739ae039;
var $d7c9167c515e7513$exports = {};
"use strict";

var $d7c9167c515e7513$require$uuid = $87befc68df50040c$export$2e2bcd8739ae039;
/**
 *  Generates a JSON-RPC 1.0 or 2.0 request
 *  @param {String} method Name of method to call
 *  @param {Array|Object} params Array of parameters passed to the method as specified, or an object of parameter names and corresponding value
 *  @param {String|Number|null} [id] Request ID can be a string, number, null for explicit notification or left out for automatic generation
 *  @param {Object} [options]
 *  @param {Number} [options.version=2] JSON-RPC version to use (1 or 2)
 *  @param {Boolean} [options.notificationIdNull=false] When true, version 2 requests will set id to null instead of omitting it
 *  @param {Function} [options.generator] Passed the request, and the options object and is expected to return a request ID
 *  @throws {TypeError} If any of the parameters are invalid
 *  @return {Object} A JSON-RPC 1.0 or 2.0 request
 *  @memberOf Utils
 */ const $d7c9167c515e7513$var$generateRequest = function(method, params, id, options) {
    if (typeof method !== "string") throw new TypeError(method + " must be a string");
    options = options || {};
    // check valid version provided
    const version = typeof options.version === "number" ? options.version : 2;
    if (version !== 1 && version !== 2) throw new TypeError(version + " must be 1 or 2");
    const request = {
        method: method
    };
    if (version === 2) request.jsonrpc = "2.0";
    if (params) {
        // params given, but invalid?
        if (typeof params !== "object" && !Array.isArray(params)) throw new TypeError(params + " must be an object, array or omitted");
        request.params = params;
    }
    // if id was left out, generate one (null means explicit notification)
    if (typeof id === "undefined") {
        const generator = typeof options.generator === "function" ? options.generator : function() {
            return $d7c9167c515e7513$require$uuid();
        };
        request.id = generator(request, options);
    } else if (version === 2 && id === null) // we have a version 2 notification
    {
        if (options.notificationIdNull) request.id = null; // id will not be set at all unless option provided
    } else request.id = id;
    return request;
};
$d7c9167c515e7513$exports = $d7c9167c515e7513$var$generateRequest;


/**
 * Constructor for a Jayson Browser Client that does not depend any node.js core libraries
 * @class ClientBrowser
 * @param {Function} callServer Method that calls the server, receives the stringified request and a regular node-style callback
 * @param {Object} [options]
 * @param {Function} [options.reviver] Reviver function for JSON
 * @param {Function} [options.replacer] Replacer function for JSON
 * @param {Number} [options.version=2] JSON-RPC version to use (1|2)
 * @param {Function} [options.generator] Function to use for generating request IDs
 *  @param {Boolean} [options.notificationIdNull=false] When true, version 2 requests will set id to null instead of omitting it
 * @return {ClientBrowser}
 */ const $b673f3d4b64776a3$var$ClientBrowser = function(callServer, options) {
    if (!(this instanceof $b673f3d4b64776a3$var$ClientBrowser)) return new $b673f3d4b64776a3$var$ClientBrowser(callServer, options);
    if (!options) options = {};
    this.options = {
        reviver: typeof options.reviver !== "undefined" ? options.reviver : null,
        replacer: typeof options.replacer !== "undefined" ? options.replacer : null,
        generator: typeof options.generator !== "undefined" ? options.generator : function() {
            return $b673f3d4b64776a3$require$uuid();
        },
        version: typeof options.version !== "undefined" ? options.version : 2,
        notificationIdNull: typeof options.notificationIdNull === "boolean" ? options.notificationIdNull : false
    };
    this.callServer = callServer;
};
$b673f3d4b64776a3$exports = $b673f3d4b64776a3$var$ClientBrowser;
/**
 *  Creates a request and dispatches it if given a callback.
 *  @param {String|Array} method A batch request if passed an Array, or a method name if passed a String
 *  @param {Array|Object} [params] Parameters for the method
 *  @param {String|Number} [id] Optional id. If undefined an id will be generated. If null it creates a notification request
 *  @param {Function} [callback] Request callback. If specified, executes the request rather than only returning it.
 *  @throws {TypeError} Invalid parameters
 *  @return {Object} JSON-RPC 1.0 or 2.0 compatible request
 */ $b673f3d4b64776a3$var$ClientBrowser.prototype.request = function(method, params, id, callback) {
    const self = this;
    let request = null;
    // is this a batch request?
    const isBatch = Array.isArray(method) && typeof params === "function";
    if (this.options.version === 1 && isBatch) throw new TypeError("JSON-RPC 1.0 does not support batching");
    // is this a raw request?
    const isRaw = !isBatch && method && typeof method === "object" && typeof params === "function";
    if (isBatch || isRaw) {
        callback = params;
        request = method;
    } else {
        if (typeof id === "function") {
            callback = id;
            // specifically undefined because "null" is a notification request
            id = undefined;
        }
        const hasCallback = typeof callback === "function";
        try {
            request = $d7c9167c515e7513$exports(method, params, id, {
                generator: this.options.generator,
                version: this.options.version,
                notificationIdNull: this.options.notificationIdNull
            });
        } catch (err) {
            if (hasCallback) return callback(err);
            throw err;
        }
        // no callback means we should just return a raw request
        if (!hasCallback) return request;
    }
    let message;
    try {
        message = JSON.stringify(request, this.options.replacer);
    } catch (err) {
        return callback(err);
    }
    this.callServer(message, function(err, response) {
        self._parseResponse(err, response, callback);
    });
    // always return the raw request
    return request;
};
/**
 * Parses a response from a server
 * @param {Object} err Error to pass on that is unrelated to the actual response
 * @param {String} responseText JSON-RPC 1.0 or 2.0 response
 * @param {Function} callback Callback that will receive different arguments depending on the amount of parameters
 * @private
 */ $b673f3d4b64776a3$var$ClientBrowser.prototype._parseResponse = function(err, responseText, callback) {
    if (err) {
        callback(err);
        return;
    }
    if (!responseText) // empty response text, assume that is correct because it could be a
    // notification which jayson does not give any body for
    return callback();
    let response;
    try {
        response = JSON.parse(responseText, this.options.reviver);
    } catch (err) {
        return callback(err);
    }
    if (callback.length === 3) {
        // if callback length is 3, we split callback arguments on error and response
        // is batch response?
        if (Array.isArray(response)) {
            // neccesary to split strictly on validity according to spec here
            const isError = function(res) {
                return typeof res.error !== "undefined";
            };
            const isNotError = function(res) {
                return !isError(res);
            };
            return callback(null, response.filter(isError), response.filter(isNotError));
        } else // split regardless of validity
        return callback(null, response.error, response.result);
    }
    callback(null, response);
};


var $5d5e6dd86cf1d7bc$exports = {};
/**
 * "Client" wraps "ws" or a browser-implemented "WebSocket" library
 * according to the environment providing JSON RPC 2.0 support on top.
 * @module Client
 */ 
var $ihoyg = parcelRequire("ihoyg");
var $5d5e6dd86cf1d7bc$require$Buffer = $ihoyg.Buffer;
"use strict";
var $3bdfd5a77b6ae4db$exports = {};
function $3bdfd5a77b6ae4db$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
$3bdfd5a77b6ae4db$exports = $3bdfd5a77b6ae4db$var$_interopRequireDefault, $3bdfd5a77b6ae4db$exports.__esModule = true, $3bdfd5a77b6ae4db$exports["default"] = $3bdfd5a77b6ae4db$exports;


Object.defineProperty($5d5e6dd86cf1d7bc$exports, "__esModule", {
    value: true
});
$5d5e6dd86cf1d7bc$exports["default"] = void 0;

var $5d5e6dd86cf1d7bc$var$_regenerator = $3bdfd5a77b6ae4db$exports((parcelRequire("iETYi")));

var $5d5e6dd86cf1d7bc$var$_asyncToGenerator2 = $3bdfd5a77b6ae4db$exports((parcelRequire("fxszz")));

var $5d5e6dd86cf1d7bc$var$_typeof2 = $3bdfd5a77b6ae4db$exports((parcelRequire("5m0al")));

var $5d5e6dd86cf1d7bc$var$_classCallCheck2 = $3bdfd5a77b6ae4db$exports((parcelRequire("96Ltc")));

var $5d5e6dd86cf1d7bc$var$_createClass2 = $3bdfd5a77b6ae4db$exports((parcelRequire("8LpR2")));

var $5d5e6dd86cf1d7bc$var$_inherits2 = $3bdfd5a77b6ae4db$exports((parcelRequire("9f5Dq")));

var $5d5e6dd86cf1d7bc$var$_possibleConstructorReturn2 = $3bdfd5a77b6ae4db$exports((parcelRequire("iPNqH")));

var $5d5e6dd86cf1d7bc$var$_getPrototypeOf2 = $3bdfd5a77b6ae4db$exports((parcelRequire("iAciy")));
var $4a9976ca6ebf6735$exports = {};
"use strict";
var $4a9976ca6ebf6735$var$has = Object.prototype.hasOwnProperty, $4a9976ca6ebf6735$var$prefix = "~";
/**
 * Constructor to create a storage for our `EE` objects.
 * An `Events` instance is a plain object whose properties are event names.
 *
 * @constructor
 * @private
 */ function $4a9976ca6ebf6735$var$Events() {}
//
// We try to not inherit from `Object.prototype`. In some engines creating an
// instance in this way is faster than calling `Object.create(null)` directly.
// If `Object.create(null)` is not supported we prefix the event names with a
// character to make sure that the built-in object properties are not
// overridden or used as an attack vector.
//
if (Object.create) {
    $4a9976ca6ebf6735$var$Events.prototype = Object.create(null);
    //
    // This hack is needed because the `__proto__` property is still inherited in
    // some old browsers like Android 4, iPhone 5.1, Opera 11 and Safari 5.
    //
    if (!new $4a9976ca6ebf6735$var$Events().__proto__) $4a9976ca6ebf6735$var$prefix = false;
}
/**
 * Representation of a single event listener.
 *
 * @param {Function} fn The listener function.
 * @param {*} context The context to invoke the listener with.
 * @param {Boolean} [once=false] Specify if the listener is a one-time listener.
 * @constructor
 * @private
 */ function $4a9976ca6ebf6735$var$EE(fn, context, once) {
    this.fn = fn;
    this.context = context;
    this.once = once || false;
}
/**
 * Add a listener for a given event.
 *
 * @param {EventEmitter} emitter Reference to the `EventEmitter` instance.
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} context The context to invoke the listener with.
 * @param {Boolean} once Specify if the listener is a one-time listener.
 * @returns {EventEmitter}
 * @private
 */ function $4a9976ca6ebf6735$var$addListener(emitter, event, fn, context, once) {
    if (typeof fn !== "function") throw new TypeError("The listener must be a function");
    var listener = new $4a9976ca6ebf6735$var$EE(fn, context || emitter, once), evt = $4a9976ca6ebf6735$var$prefix ? $4a9976ca6ebf6735$var$prefix + event : event;
    if (!emitter._events[evt]) emitter._events[evt] = listener, emitter._eventsCount++;
    else if (!emitter._events[evt].fn) emitter._events[evt].push(listener);
    else emitter._events[evt] = [
        emitter._events[evt],
        listener
    ];
    return emitter;
}
/**
 * Clear event by name.
 *
 * @param {EventEmitter} emitter Reference to the `EventEmitter` instance.
 * @param {(String|Symbol)} evt The Event name.
 * @private
 */ function $4a9976ca6ebf6735$var$clearEvent(emitter, evt) {
    if (--emitter._eventsCount === 0) emitter._events = new $4a9976ca6ebf6735$var$Events();
    else delete emitter._events[evt];
}
/**
 * Minimal `EventEmitter` interface that is molded against the Node.js
 * `EventEmitter` interface.
 *
 * @constructor
 * @public
 */ function $4a9976ca6ebf6735$var$EventEmitter() {
    this._events = new $4a9976ca6ebf6735$var$Events();
    this._eventsCount = 0;
}
/**
 * Return an array listing the events for which the emitter has registered
 * listeners.
 *
 * @returns {Array}
 * @public
 */ $4a9976ca6ebf6735$var$EventEmitter.prototype.eventNames = function eventNames() {
    var names = [], events, name;
    if (this._eventsCount === 0) return names;
    for(name in events = this._events)if ($4a9976ca6ebf6735$var$has.call(events, name)) names.push($4a9976ca6ebf6735$var$prefix ? name.slice(1) : name);
    if (Object.getOwnPropertySymbols) return names.concat(Object.getOwnPropertySymbols(events));
    return names;
};
/**
 * Return the listeners registered for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Array} The registered listeners.
 * @public
 */ $4a9976ca6ebf6735$var$EventEmitter.prototype.listeners = function listeners(event) {
    var evt = $4a9976ca6ebf6735$var$prefix ? $4a9976ca6ebf6735$var$prefix + event : event, handlers = this._events[evt];
    if (!handlers) return [];
    if (handlers.fn) return [
        handlers.fn
    ];
    for(var i = 0, l = handlers.length, ee = new Array(l); i < l; i++)ee[i] = handlers[i].fn;
    return ee;
};
/**
 * Return the number of listeners listening to a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Number} The number of listeners.
 * @public
 */ $4a9976ca6ebf6735$var$EventEmitter.prototype.listenerCount = function listenerCount(event) {
    var evt = $4a9976ca6ebf6735$var$prefix ? $4a9976ca6ebf6735$var$prefix + event : event, listeners = this._events[evt];
    if (!listeners) return 0;
    if (listeners.fn) return 1;
    return listeners.length;
};
/**
 * Calls each of the listeners registered for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Boolean} `true` if the event had listeners, else `false`.
 * @public
 */ $4a9976ca6ebf6735$var$EventEmitter.prototype.emit = function emit(event, a1, a2, a3, a4, a5) {
    var evt = $4a9976ca6ebf6735$var$prefix ? $4a9976ca6ebf6735$var$prefix + event : event;
    if (!this._events[evt]) return false;
    var listeners = this._events[evt], len = arguments.length, args, i;
    if (listeners.fn) {
        if (listeners.once) this.removeListener(event, listeners.fn, undefined, true);
        switch(len){
            case 1:
                return listeners.fn.call(listeners.context), true;
            case 2:
                return listeners.fn.call(listeners.context, a1), true;
            case 3:
                return listeners.fn.call(listeners.context, a1, a2), true;
            case 4:
                return listeners.fn.call(listeners.context, a1, a2, a3), true;
            case 5:
                return listeners.fn.call(listeners.context, a1, a2, a3, a4), true;
            case 6:
                return listeners.fn.call(listeners.context, a1, a2, a3, a4, a5), true;
        }
        for(i = 1, args = new Array(len - 1); i < len; i++)args[i - 1] = arguments[i];
        listeners.fn.apply(listeners.context, args);
    } else {
        var length = listeners.length, j;
        for(i = 0; i < length; i++){
            if (listeners[i].once) this.removeListener(event, listeners[i].fn, undefined, true);
            switch(len){
                case 1:
                    listeners[i].fn.call(listeners[i].context);
                    break;
                case 2:
                    listeners[i].fn.call(listeners[i].context, a1);
                    break;
                case 3:
                    listeners[i].fn.call(listeners[i].context, a1, a2);
                    break;
                case 4:
                    listeners[i].fn.call(listeners[i].context, a1, a2, a3);
                    break;
                default:
                    if (!args) for(j = 1, args = new Array(len - 1); j < len; j++)args[j - 1] = arguments[j];
                    listeners[i].fn.apply(listeners[i].context, args);
            }
        }
    }
    return true;
};
/**
 * Add a listener for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} [context=this] The context to invoke the listener with.
 * @returns {EventEmitter} `this`.
 * @public
 */ $4a9976ca6ebf6735$var$EventEmitter.prototype.on = function on(event, fn, context) {
    return $4a9976ca6ebf6735$var$addListener(this, event, fn, context, false);
};
/**
 * Add a one-time listener for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} [context=this] The context to invoke the listener with.
 * @returns {EventEmitter} `this`.
 * @public
 */ $4a9976ca6ebf6735$var$EventEmitter.prototype.once = function once(event, fn, context) {
    return $4a9976ca6ebf6735$var$addListener(this, event, fn, context, true);
};
/**
 * Remove the listeners of a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn Only remove the listeners that match this function.
 * @param {*} context Only remove the listeners that have this context.
 * @param {Boolean} once Only remove one-time listeners.
 * @returns {EventEmitter} `this`.
 * @public
 */ $4a9976ca6ebf6735$var$EventEmitter.prototype.removeListener = function removeListener(event, fn, context, once) {
    var evt = $4a9976ca6ebf6735$var$prefix ? $4a9976ca6ebf6735$var$prefix + event : event;
    if (!this._events[evt]) return this;
    if (!fn) {
        $4a9976ca6ebf6735$var$clearEvent(this, evt);
        return this;
    }
    var listeners = this._events[evt];
    if (listeners.fn) {
        if (listeners.fn === fn && (!once || listeners.once) && (!context || listeners.context === context)) $4a9976ca6ebf6735$var$clearEvent(this, evt);
    } else {
        for(var i = 0, events = [], length = listeners.length; i < length; i++)if (listeners[i].fn !== fn || once && !listeners[i].once || context && listeners[i].context !== context) events.push(listeners[i]);
        //
        // Reset the array, or remove it completely if we have no more listeners.
        //
        if (events.length) this._events[evt] = events.length === 1 ? events[0] : events;
        else $4a9976ca6ebf6735$var$clearEvent(this, evt);
    }
    return this;
};
/**
 * Remove all listeners, or those of the specified event.
 *
 * @param {(String|Symbol)} [event] The event name.
 * @returns {EventEmitter} `this`.
 * @public
 */ $4a9976ca6ebf6735$var$EventEmitter.prototype.removeAllListeners = function removeAllListeners(event) {
    var evt;
    if (event) {
        evt = $4a9976ca6ebf6735$var$prefix ? $4a9976ca6ebf6735$var$prefix + event : event;
        if (this._events[evt]) $4a9976ca6ebf6735$var$clearEvent(this, evt);
    } else {
        this._events = new $4a9976ca6ebf6735$var$Events();
        this._eventsCount = 0;
    }
    return this;
};
//
// Alias methods names because people roll like that.
//
$4a9976ca6ebf6735$var$EventEmitter.prototype.off = $4a9976ca6ebf6735$var$EventEmitter.prototype.removeListener;
$4a9976ca6ebf6735$var$EventEmitter.prototype.addListener = $4a9976ca6ebf6735$var$EventEmitter.prototype.on;
//
// Expose the prefix.
//
$4a9976ca6ebf6735$var$EventEmitter.prefixed = $4a9976ca6ebf6735$var$prefix;
//
// Allow `EventEmitter` to be imported as module namespace.
//
$4a9976ca6ebf6735$var$EventEmitter.EventEmitter = $4a9976ca6ebf6735$var$EventEmitter;
$4a9976ca6ebf6735$exports = $4a9976ca6ebf6735$var$EventEmitter;


var $640ebe6e674b49c7$exports = {};
"use strict";

Object.defineProperty($640ebe6e674b49c7$exports, "__esModule", {
    value: true
});
$640ebe6e674b49c7$exports.DefaultDataPack = void 0;
$640ebe6e674b49c7$exports.createError = $640ebe6e674b49c7$var$createError;

var $640ebe6e674b49c7$var$_classCallCheck2 = $3bdfd5a77b6ae4db$exports((parcelRequire("96Ltc")));

var $640ebe6e674b49c7$var$_createClass2 = $3bdfd5a77b6ae4db$exports((parcelRequire("8LpR2")));
var $640ebe6e674b49c7$var$errors = new Map([
    [
        -32000,
        "Event not provided"
    ],
    [
        -32600,
        "Invalid Request"
    ],
    [
        -32601,
        "Method not found"
    ],
    [
        -32602,
        "Invalid params"
    ],
    [
        -32603,
        "Internal error"
    ],
    [
        -32604,
        "Params not found"
    ],
    [
        -32605,
        "Method forbidden"
    ],
    [
        -32606,
        "Event forbidden"
    ],
    [
        -32700,
        "Parse error"
    ]
]);
var $640ebe6e674b49c7$var$DefaultDataPack = /*#__PURE__*/ function() {
    function DefaultDataPack() {
        (0, $640ebe6e674b49c7$var$_classCallCheck2["default"])(this, DefaultDataPack);
    }
    (0, $640ebe6e674b49c7$var$_createClass2["default"])(DefaultDataPack, [
        {
            key: "encode",
            value: function encode(value) {
                return JSON.stringify(value);
            }
        },
        {
            key: "decode",
            value: function decode(value) {
                return JSON.parse(value);
            }
        }
    ]);
    return DefaultDataPack;
}();
/**
 * Creates a JSON-RPC 2.0-compliant error.
 * @param {Number} code - error code
 * @param {String} details - error details
 * @return {Object}
 */ $640ebe6e674b49c7$exports.DefaultDataPack = $640ebe6e674b49c7$var$DefaultDataPack;
function $640ebe6e674b49c7$var$createError(code, details) {
    var error = {
        code: code,
        message: $640ebe6e674b49c7$var$errors.get(code) || "Internal Server Error"
    };
    if (details) error["data"] = details;
    return error;
}


function $5d5e6dd86cf1d7bc$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $5d5e6dd86cf1d7bc$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = (0, $5d5e6dd86cf1d7bc$var$_getPrototypeOf2["default"])(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, $5d5e6dd86cf1d7bc$var$_getPrototypeOf2["default"])(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, $5d5e6dd86cf1d7bc$var$_possibleConstructorReturn2["default"])(this, result);
    };
}
function $5d5e6dd86cf1d7bc$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
var $5d5e6dd86cf1d7bc$var$__rest = function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
// @ts-ignore
var $5d5e6dd86cf1d7bc$var$CommonClient = /*#__PURE__*/ function(_EventEmitter) {
    (0, $5d5e6dd86cf1d7bc$var$_inherits2["default"])(CommonClient, _EventEmitter);
    var _super = $5d5e6dd86cf1d7bc$var$_createSuper(CommonClient);
    /**
   * Instantiate a Client class.
   * @constructor
   * @param {webSocketFactory} webSocketFactory - factory method for WebSocket
   * @param {String} address - url to a websocket server
   * @param {Object} options - ws options object with reconnect parameters
   * @param {Function} generate_request_id - custom generation request Id
   * @param {DataPack} dataPack - data pack contains encoder and decoder
   * @return {CommonClient}
   */ function CommonClient(webSocketFactory) {
        var _this;
        var address = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "ws://localhost:8080";
        var _a = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        var generate_request_id = arguments.length > 3 ? arguments[3] : undefined;
        var dataPack = arguments.length > 4 ? arguments[4] : undefined;
        (0, $5d5e6dd86cf1d7bc$var$_classCallCheck2["default"])(this, CommonClient);
        var _a$autoconnect = _a.autoconnect, autoconnect = _a$autoconnect === void 0 ? true : _a$autoconnect, _a$reconnect = _a.reconnect, reconnect = _a$reconnect === void 0 ? true : _a$reconnect, _a$reconnect_interval = _a.reconnect_interval, reconnect_interval = _a$reconnect_interval === void 0 ? 1000 : _a$reconnect_interval, _a$max_reconnects = _a.max_reconnects, max_reconnects = _a$max_reconnects === void 0 ? 5 : _a$max_reconnects, rest_options = $5d5e6dd86cf1d7bc$var$__rest(_a, [
            "autoconnect",
            "reconnect",
            "reconnect_interval",
            "max_reconnects"
        ]);
        _this = _super.call(this);
        _this.webSocketFactory = webSocketFactory;
        _this.queue = {};
        _this.rpc_id = 0;
        _this.address = address;
        _this.autoconnect = autoconnect;
        _this.ready = false;
        _this.reconnect = reconnect;
        _this.reconnect_timer_id = undefined;
        _this.reconnect_interval = reconnect_interval;
        _this.max_reconnects = max_reconnects;
        _this.rest_options = rest_options;
        _this.current_reconnects = 0;
        _this.generate_request_id = generate_request_id || function() {
            return ++_this.rpc_id;
        };
        if (!dataPack) _this.dataPack = new $640ebe6e674b49c7$exports.DefaultDataPack();
        else _this.dataPack = dataPack;
        if (_this.autoconnect) _this._connect(_this.address, Object.assign({
            autoconnect: _this.autoconnect,
            reconnect: _this.reconnect,
            reconnect_interval: _this.reconnect_interval,
            max_reconnects: _this.max_reconnects
        }, _this.rest_options));
        return _this;
    }
    /**
   * Connects to a defined server if not connected already.
   * @method
   * @return {Undefined}
   */ (0, $5d5e6dd86cf1d7bc$var$_createClass2["default"])(CommonClient, [
        {
            key: "connect",
            value: function connect() {
                if (this.socket) return;
                this._connect(this.address, Object.assign({
                    autoconnect: this.autoconnect,
                    reconnect: this.reconnect,
                    reconnect_interval: this.reconnect_interval,
                    max_reconnects: this.max_reconnects
                }, this.rest_options));
            }
        },
        {
            key: "call",
            value: function call(method, params, timeout, ws_opts) {
                var _this2 = this;
                if (!ws_opts && "object" === (0, $5d5e6dd86cf1d7bc$var$_typeof2["default"])(timeout)) {
                    ws_opts = timeout;
                    timeout = null;
                }
                return new Promise(function(resolve, reject) {
                    if (!_this2.ready) return reject(new Error("socket not ready"));
                    var rpc_id = _this2.generate_request_id(method, params);
                    var message = {
                        jsonrpc: "2.0",
                        method: method,
                        params: params || undefined,
                        id: rpc_id
                    };
                    _this2.socket.send(_this2.dataPack.encode(message), ws_opts, function(error) {
                        if (error) return reject(error);
                        _this2.queue[rpc_id] = {
                            promise: [
                                resolve,
                                reject
                            ]
                        };
                        if (timeout) _this2.queue[rpc_id].timeout = setTimeout(function() {
                            delete _this2.queue[rpc_id];
                            reject(new Error("reply timeout"));
                        }, timeout);
                    });
                });
            }
        },
        {
            key: "login",
            value: function() {
                var _login = (0, $5d5e6dd86cf1d7bc$var$_asyncToGenerator2["default"])(/*#__PURE__*/ $5d5e6dd86cf1d7bc$var$_regenerator["default"].mark(function _callee(params) {
                    var resp;
                    return $5d5e6dd86cf1d7bc$var$_regenerator["default"].wrap(function _callee$(_context) {
                        while(true)switch(_context.prev = _context.next){
                            case 0:
                                _context.next = 2;
                                return this.call("rpc.login", params);
                            case 2:
                                resp = _context.sent;
                                if (resp) {
                                    _context.next = 5;
                                    break;
                                }
                                throw new Error("authentication failed");
                            case 5:
                                return _context.abrupt("return", resp);
                            case 6:
                            case "end":
                                return _context.stop();
                        }
                    }, _callee, this);
                }));
                function login(_x) {
                    return _login.apply(this, arguments);
                }
                return login;
            }()
        },
        {
            key: "listMethods",
            value: function() {
                var _listMethods = (0, $5d5e6dd86cf1d7bc$var$_asyncToGenerator2["default"])(/*#__PURE__*/ $5d5e6dd86cf1d7bc$var$_regenerator["default"].mark(function _callee2() {
                    return $5d5e6dd86cf1d7bc$var$_regenerator["default"].wrap(function _callee2$(_context2) {
                        while(true)switch(_context2.prev = _context2.next){
                            case 0:
                                _context2.next = 2;
                                return this.call("__listMethods");
                            case 2:
                                return _context2.abrupt("return", _context2.sent);
                            case 3:
                            case "end":
                                return _context2.stop();
                        }
                    }, _callee2, this);
                }));
                function listMethods() {
                    return _listMethods.apply(this, arguments);
                }
                return listMethods;
            }()
        },
        {
            key: "notify",
            value: function notify(method, params) {
                var _this3 = this;
                return new Promise(function(resolve, reject) {
                    if (!_this3.ready) return reject(new Error("socket not ready"));
                    var message = {
                        jsonrpc: "2.0",
                        method: method,
                        params: params
                    };
                    _this3.socket.send(_this3.dataPack.encode(message), function(error) {
                        if (error) return reject(error);
                        resolve();
                    });
                });
            }
        },
        {
            key: "subscribe",
            value: function() {
                var _subscribe = (0, $5d5e6dd86cf1d7bc$var$_asyncToGenerator2["default"])(/*#__PURE__*/ $5d5e6dd86cf1d7bc$var$_regenerator["default"].mark(function _callee3(event) {
                    var result;
                    return $5d5e6dd86cf1d7bc$var$_regenerator["default"].wrap(function _callee3$(_context3) {
                        while(true)switch(_context3.prev = _context3.next){
                            case 0:
                                if (typeof event === "string") event = [
                                    event
                                ];
                                _context3.next = 3;
                                return this.call("rpc.on", event);
                            case 3:
                                result = _context3.sent;
                                if (!(typeof event === "string" && result[event] !== "ok")) {
                                    _context3.next = 6;
                                    break;
                                }
                                throw new Error("Failed subscribing to an event '" + event + "' with: " + result[event]);
                            case 6:
                                return _context3.abrupt("return", result);
                            case 7:
                            case "end":
                                return _context3.stop();
                        }
                    }, _callee3, this);
                }));
                function subscribe(_x2) {
                    return _subscribe.apply(this, arguments);
                }
                return subscribe;
            }()
        },
        {
            key: "unsubscribe",
            value: function() {
                var _unsubscribe = (0, $5d5e6dd86cf1d7bc$var$_asyncToGenerator2["default"])(/*#__PURE__*/ $5d5e6dd86cf1d7bc$var$_regenerator["default"].mark(function _callee4(event) {
                    var result;
                    return $5d5e6dd86cf1d7bc$var$_regenerator["default"].wrap(function _callee4$(_context4) {
                        while(true)switch(_context4.prev = _context4.next){
                            case 0:
                                if (typeof event === "string") event = [
                                    event
                                ];
                                _context4.next = 3;
                                return this.call("rpc.off", event);
                            case 3:
                                result = _context4.sent;
                                if (!(typeof event === "string" && result[event] !== "ok")) {
                                    _context4.next = 6;
                                    break;
                                }
                                throw new Error("Failed unsubscribing from an event with: " + result);
                            case 6:
                                return _context4.abrupt("return", result);
                            case 7:
                            case "end":
                                return _context4.stop();
                        }
                    }, _callee4, this);
                }));
                function unsubscribe(_x3) {
                    return _unsubscribe.apply(this, arguments);
                }
                return unsubscribe;
            }()
        },
        {
            key: "close",
            value: function close(code, data) {
                this.socket.close(code || 1000, data);
            }
        },
        {
            key: "_connect",
            value: function _connect(address, options) {
                var _this4 = this;
                clearTimeout(this.reconnect_timer_id);
                this.socket = this.webSocketFactory(address, options);
                this.socket.addEventListener("open", function() {
                    _this4.ready = true;
                    _this4.emit("open");
                    _this4.current_reconnects = 0;
                });
                this.socket.addEventListener("message", function(_ref) {
                    var message = _ref.data;
                    if (message instanceof ArrayBuffer) message = $5d5e6dd86cf1d7bc$require$Buffer.from(message).toString();
                    try {
                        message = _this4.dataPack.decode(message);
                    } catch (error) {
                        return;
                    }
                    // check if any listeners are attached and forward event
                    if (message.notification && _this4.listeners(message.notification).length) {
                        if (!Object.keys(message.params).length) return _this4.emit(message.notification);
                        var args = [
                            message.notification
                        ];
                        if (message.params.constructor === Object) args.push(message.params);
                        else // using for-loop instead of unshift/spread because performance is better
                        for(var i = 0; i < message.params.length; i++)args.push(message.params[i]);
                        // run as microtask so that pending queue messages are resolved first
                        // eslint-disable-next-line prefer-spread
                        return Promise.resolve().then(function() {
                            _this4.emit.apply(_this4, args);
                        });
                    }
                    if (!_this4.queue[message.id]) {
                        // general JSON RPC 2.0 events
                        if (message.method) // run as microtask so that pending queue messages are resolved first
                        return Promise.resolve().then(function() {
                            _this4.emit(message.method, message === null || message === void 0 ? void 0 : message.params);
                        });
                        return;
                    }
                    // reject early since server's response is invalid
                    if ("error" in message === "result" in message) _this4.queue[message.id].promise[1](new Error('Server response malformed. Response must include either "result" or "error", but not both.'));
                    if (_this4.queue[message.id].timeout) clearTimeout(_this4.queue[message.id].timeout);
                    if (message.error) _this4.queue[message.id].promise[1](message.error);
                    else _this4.queue[message.id].promise[0](message.result);
                    delete _this4.queue[message.id];
                });
                this.socket.addEventListener("error", function(error) {
                    return _this4.emit("error", error);
                });
                this.socket.addEventListener("close", function(_ref2) {
                    var code = _ref2.code, reason = _ref2.reason;
                    if (_this4.ready) // Delay close event until internal state is updated
                    setTimeout(function() {
                        return _this4.emit("close", code, reason);
                    }, 0);
                    _this4.ready = false;
                    _this4.socket = undefined;
                    if (code === 1000) return;
                    _this4.current_reconnects++;
                    if (_this4.reconnect && (_this4.max_reconnects > _this4.current_reconnects || _this4.max_reconnects === 0)) _this4.reconnect_timer_id = setTimeout(function() {
                        return _this4._connect(address, options);
                    }, _this4.reconnect_interval);
                });
            }
        }
    ]);
    return CommonClient;
}($4a9976ca6ebf6735$exports.EventEmitter);
$5d5e6dd86cf1d7bc$exports["default"] = $5d5e6dd86cf1d7bc$var$CommonClient;


var $506ecc9a680f3f9d$exports = {};
/**
 * WebSocket implements a browser-side WebSocket specification.
 * @module Client
 */ "use strict";

Object.defineProperty($506ecc9a680f3f9d$exports, "__esModule", {
    value: true
});
$506ecc9a680f3f9d$exports["default"] = $506ecc9a680f3f9d$var$_default;

var $506ecc9a680f3f9d$var$_classCallCheck2 = $3bdfd5a77b6ae4db$exports((parcelRequire("96Ltc")));

var $506ecc9a680f3f9d$var$_createClass2 = $3bdfd5a77b6ae4db$exports((parcelRequire("8LpR2")));

var $506ecc9a680f3f9d$var$_inherits2 = $3bdfd5a77b6ae4db$exports((parcelRequire("9f5Dq")));

var $506ecc9a680f3f9d$var$_possibleConstructorReturn2 = $3bdfd5a77b6ae4db$exports((parcelRequire("iPNqH")));

var $506ecc9a680f3f9d$var$_getPrototypeOf2 = $3bdfd5a77b6ae4db$exports((parcelRequire("iAciy")));

function $506ecc9a680f3f9d$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $506ecc9a680f3f9d$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = (0, $506ecc9a680f3f9d$var$_getPrototypeOf2["default"])(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, $506ecc9a680f3f9d$var$_getPrototypeOf2["default"])(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, $506ecc9a680f3f9d$var$_possibleConstructorReturn2["default"])(this, result);
    };
}
function $506ecc9a680f3f9d$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
var $506ecc9a680f3f9d$var$WebSocketBrowserImpl = /*#__PURE__*/ function(_EventEmitter) {
    (0, $506ecc9a680f3f9d$var$_inherits2["default"])(WebSocketBrowserImpl, _EventEmitter);
    var _super = $506ecc9a680f3f9d$var$_createSuper(WebSocketBrowserImpl);
    /** Instantiate a WebSocket class
   * @constructor
   * @param {String} address - url to a websocket server
   * @param {(Object)} options - websocket options
   * @param {(String|Array)} protocols - a list of protocols
   * @return {WebSocketBrowserImpl} - returns a WebSocket instance
   */ function WebSocketBrowserImpl(address, options, protocols) {
        var _this;
        (0, $506ecc9a680f3f9d$var$_classCallCheck2["default"])(this, WebSocketBrowserImpl);
        _this = _super.call(this);
        _this.socket = new window.WebSocket(address, protocols);
        _this.socket.onopen = function() {
            return _this.emit("open");
        };
        _this.socket.onmessage = function(event) {
            return _this.emit("message", event.data);
        };
        _this.socket.onerror = function(error) {
            return _this.emit("error", error);
        };
        _this.socket.onclose = function(event) {
            _this.emit("close", event.code, event.reason);
        };
        return _this;
    }
    /**
   * Sends data through a websocket connection
   * @method
   * @param {(String|Object)} data - data to be sent via websocket
   * @param {Object} optionsOrCallback - ws options
   * @param {Function} callback - a callback called once the data is sent
   * @return {Undefined}
   */ (0, $506ecc9a680f3f9d$var$_createClass2["default"])(WebSocketBrowserImpl, [
        {
            key: "send",
            value: function send(data, optionsOrCallback, callback) {
                var cb = callback || optionsOrCallback;
                try {
                    this.socket.send(data);
                    cb();
                } catch (error) {
                    cb(error);
                }
            }
        },
        {
            key: "close",
            value: function close(code, reason) {
                this.socket.close(code, reason);
            }
        },
        {
            key: "addEventListener",
            value: function addEventListener(type, listener, options) {
                this.socket.addEventListener(type, listener, options);
            }
        }
    ]);
    return WebSocketBrowserImpl;
}($4a9976ca6ebf6735$exports.EventEmitter);
/**
 * factory method for common WebSocket instance
 * @method
 * @param {String} address - url to a websocket server
 * @param {(Object)} options - websocket options
 * @return {Undefined}
 */ function $506ecc9a680f3f9d$var$_default(address, options) {
    return new $506ecc9a680f3f9d$var$WebSocketBrowserImpl(address, options);
}



var $jDAn2 = parcelRequire("jDAn2");
var $b7c00ec1cc5daba7$exports = {};
"use strict";
Object.defineProperty($b7c00ec1cc5daba7$exports, "__esModule", {
    value: true
});
$b7c00ec1cc5daba7$exports.encodeToCurve = $b7c00ec1cc5daba7$exports.hashToCurve = $b7c00ec1cc5daba7$exports.schnorr = $b7c00ec1cc5daba7$exports.secp256k1 = void 0;

var $lrsL3 = parcelRequire("lrsL3");

var $ebEok = parcelRequire("ebEok");

var $b472b1d3a53ce762$exports = {};
"use strict";
Object.defineProperty($b472b1d3a53ce762$exports, "__esModule", {
    value: true
});
$b472b1d3a53ce762$exports.mapToCurveSimpleSWU = $b472b1d3a53ce762$exports.SWUFpSqrtRatio = $b472b1d3a53ce762$exports.weierstrass = $b472b1d3a53ce762$exports.weierstrassPoints = $b472b1d3a53ce762$exports.DER = void 0;




function $b472b1d3a53ce762$var$validatePointOpts(curve) {
    const opts = (0, $3754823f21a54f54$exports.validateBasic)(curve);
    $a53222754f250272$exports.validateObject(opts, {
        a: "field",
        b: "field"
    }, {
        allowedPrivateKeyLengths: "array",
        wrapPrivateKey: "boolean",
        isTorsionFree: "function",
        clearCofactor: "function",
        allowInfinityPoint: "boolean",
        fromBytes: "function",
        toBytes: "function"
    });
    const { endo: endo, Fp: Fp, a: a } = opts;
    if (endo) {
        if (!Fp.eql(a, Fp.ZERO)) throw new Error("Endomorphism can only be defined for Koblitz curves that have a=0");
        if (typeof endo !== "object" || typeof endo.beta !== "bigint" || typeof endo.splitScalar !== "function") throw new Error("Expected endomorphism with beta: bigint and splitScalar: function");
    }
    return Object.freeze({
        ...opts
    });
}
// ASN.1 DER encoding utilities
const { bytesToNumberBE: $b472b1d3a53ce762$var$b2n, hexToBytes: $b472b1d3a53ce762$var$h2b } = $a53222754f250272$exports;
$b472b1d3a53ce762$exports.DER = {
    // asn.1 DER encoding utils
    Err: class DERErr extends Error {
        constructor(m = ""){
            super(m);
        }
    },
    _parseInt (data) {
        const { Err: E } = $b472b1d3a53ce762$exports.DER;
        if (data.length < 2 || data[0] !== 0x02) throw new E("Invalid signature integer tag");
        const len = data[1];
        const res = data.subarray(2, len + 2);
        if (!len || res.length !== len) throw new E("Invalid signature integer: wrong length");
        // https://crypto.stackexchange.com/a/57734 Leftmost bit of first byte is 'negative' flag,
        // since we always use positive integers here. It must always be empty:
        // - add zero byte if exists
        // - if next byte doesn't have a flag, leading zero is not allowed (minimal encoding)
        if (res[0] & 128) throw new E("Invalid signature integer: negative");
        if (res[0] === 0x00 && !(res[1] & 128)) throw new E("Invalid signature integer: unnecessary leading zero");
        return {
            d: $b472b1d3a53ce762$var$b2n(res),
            l: data.subarray(len + 2)
        }; // d is data, l is left
    },
    toSig (hex) {
        // parse DER signature
        const { Err: E } = $b472b1d3a53ce762$exports.DER;
        const data = typeof hex === "string" ? $b472b1d3a53ce762$var$h2b(hex) : hex;
        if (!$a53222754f250272$exports.isBytes(data)) throw new Error("ui8a expected");
        let l = data.length;
        if (l < 2 || data[0] != 0x30) throw new E("Invalid signature tag");
        if (data[1] !== l - 2) throw new E("Invalid signature: incorrect length");
        const { d: r, l: sBytes } = $b472b1d3a53ce762$exports.DER._parseInt(data.subarray(2));
        const { d: s, l: rBytesLeft } = $b472b1d3a53ce762$exports.DER._parseInt(sBytes);
        if (rBytesLeft.length) throw new E("Invalid signature: left bytes after parsing");
        return {
            r: r,
            s: s
        };
    },
    hexFromSig (sig) {
        // Add leading zero if first byte has negative bit enabled. More details in '_parseInt'
        const slice = (s)=>Number.parseInt(s[0], 16) & 8 ? "00" + s : s;
        const h = (num)=>{
            const hex = num.toString(16);
            return hex.length & 1 ? `0${hex}` : hex;
        };
        const s = slice(h(sig.s));
        const r = slice(h(sig.r));
        const shl = s.length / 2;
        const rhl = r.length / 2;
        const sl = h(shl);
        const rl = h(rhl);
        return `30${h(rhl + shl + 4)}02${rl}${r}02${sl}${s}`;
    }
};
// Be friendly to bad ECMAScript parsers by not using bigint literals
// prettier-ignore
const $b472b1d3a53ce762$var$_0n = BigInt(0), $b472b1d3a53ce762$var$_1n = BigInt(1), $b472b1d3a53ce762$var$_2n = BigInt(2), $b472b1d3a53ce762$var$_3n = BigInt(3), $b472b1d3a53ce762$var$_4n = BigInt(4);
function $b472b1d3a53ce762$var$weierstrassPoints(opts) {
    const CURVE = $b472b1d3a53ce762$var$validatePointOpts(opts);
    const { Fp: Fp } = CURVE; // All curves has same field / group length as for now, but they can differ
    const toBytes = CURVE.toBytes || ((_c, point, _isCompressed)=>{
        const a = point.toAffine();
        return $a53222754f250272$exports.concatBytes(Uint8Array.from([
            0x04
        ]), Fp.toBytes(a.x), Fp.toBytes(a.y));
    });
    const fromBytes = CURVE.fromBytes || ((bytes)=>{
        // const head = bytes[0];
        const tail = bytes.subarray(1);
        // if (head !== 0x04) throw new Error('Only non-compressed encoding is supported');
        const x = Fp.fromBytes(tail.subarray(0, Fp.BYTES));
        const y = Fp.fromBytes(tail.subarray(Fp.BYTES, 2 * Fp.BYTES));
        return {
            x: x,
            y: y
        };
    });
    /**
     * y² = x³ + ax + b: Short weierstrass curve formula
     * @returns y²
     */ function weierstrassEquation(x) {
        const { a: a, b: b } = CURVE;
        const x2 = Fp.sqr(x); // x * x
        const x3 = Fp.mul(x2, x); // x2 * x
        return Fp.add(Fp.add(x3, Fp.mul(x, a)), b); // x3 + a * x + b
    }
    // Validate whether the passed curve params are valid.
    // We check if curve equation works for generator point.
    // `assertValidity()` won't work: `isTorsionFree()` is not available at this point in bls12-381.
    // ProjectivePoint class has not been initialized yet.
    if (!Fp.eql(Fp.sqr(CURVE.Gy), weierstrassEquation(CURVE.Gx))) throw new Error("bad generator point: equation left != right");
    // Valid group elements reside in range 1..n-1
    function isWithinCurveOrder(num) {
        return typeof num === "bigint" && $b472b1d3a53ce762$var$_0n < num && num < CURVE.n;
    }
    function assertGE(num) {
        if (!isWithinCurveOrder(num)) throw new Error("Expected valid bigint: 0 < bigint < curve.n");
    }
    // Validates if priv key is valid and converts it to bigint.
    // Supports options allowedPrivateKeyLengths and wrapPrivateKey.
    function normPrivateKeyToScalar(key) {
        const { allowedPrivateKeyLengths: lengths, nByteLength: nByteLength, wrapPrivateKey: wrapPrivateKey, n: n } = CURVE;
        if (lengths && typeof key !== "bigint") {
            if ($a53222754f250272$exports.isBytes(key)) key = $a53222754f250272$exports.bytesToHex(key);
            // Normalize to hex string, pad. E.g. P521 would norm 130-132 char hex to 132-char bytes
            if (typeof key !== "string" || !lengths.includes(key.length)) throw new Error("Invalid key");
            key = key.padStart(nByteLength * 2, "0");
        }
        let num;
        try {
            num = typeof key === "bigint" ? key : $a53222754f250272$exports.bytesToNumberBE((0, $a53222754f250272$exports.ensureBytes)("private key", key, nByteLength));
        } catch (error) {
            throw new Error(`private key must be ${nByteLength} bytes, hex or bigint, not ${typeof key}`);
        }
        if (wrapPrivateKey) num = $f4225407683e7e63$exports.mod(num, n); // disabled by default, enabled for BLS
        assertGE(num); // num in range [1..N-1]
        return num;
    }
    const pointPrecomputes = new Map();
    function assertPrjPoint(other) {
        if (!(other instanceof Point)) throw new Error("ProjectivePoint expected");
    }
    /**
     * Projective Point works in 3d / projective (homogeneous) coordinates: (x, y, z) ∋ (x=x/z, y=y/z)
     * Default Point works in 2d / affine coordinates: (x, y)
     * We're doing calculations in projective, because its operations don't require costly inversion.
     */ class Point {
        constructor(px, py, pz){
            this.px = px;
            this.py = py;
            this.pz = pz;
            if (px == null || !Fp.isValid(px)) throw new Error("x required");
            if (py == null || !Fp.isValid(py)) throw new Error("y required");
            if (pz == null || !Fp.isValid(pz)) throw new Error("z required");
        }
        // Does not validate if the point is on-curve.
        // Use fromHex instead, or call assertValidity() later.
        static fromAffine(p) {
            const { x: x, y: y } = p || {};
            if (!p || !Fp.isValid(x) || !Fp.isValid(y)) throw new Error("invalid affine point");
            if (p instanceof Point) throw new Error("projective point not allowed");
            const is0 = (i)=>Fp.eql(i, Fp.ZERO);
            // fromAffine(x:0, y:0) would produce (x:0, y:0, z:1), but we need (x:0, y:1, z:0)
            if (is0(x) && is0(y)) return Point.ZERO;
            return new Point(x, y, Fp.ONE);
        }
        get x() {
            return this.toAffine().x;
        }
        get y() {
            return this.toAffine().y;
        }
        /**
         * Takes a bunch of Projective Points but executes only one
         * inversion on all of them. Inversion is very slow operation,
         * so this improves performance massively.
         * Optimization: converts a list of projective points to a list of identical points with Z=1.
         */ static normalizeZ(points) {
            const toInv = Fp.invertBatch(points.map((p)=>p.pz));
            return points.map((p, i)=>p.toAffine(toInv[i])).map(Point.fromAffine);
        }
        /**
         * Converts hash string or Uint8Array to Point.
         * @param hex short/long ECDSA hex
         */ static fromHex(hex) {
            const P = Point.fromAffine(fromBytes((0, $a53222754f250272$exports.ensureBytes)("pointHex", hex)));
            P.assertValidity();
            return P;
        }
        // Multiplies generator point by privateKey.
        static fromPrivateKey(privateKey) {
            return Point.BASE.multiply(normPrivateKeyToScalar(privateKey));
        }
        // "Private method", don't use it directly
        _setWindowSize(windowSize) {
            this._WINDOW_SIZE = windowSize;
            pointPrecomputes.delete(this);
        }
        // A point on curve is valid if it conforms to equation.
        assertValidity() {
            if (this.is0()) {
                // (0, 1, 0) aka ZERO is invalid in most contexts.
                // In BLS, ZERO can be serialized, so we allow it.
                // (0, 0, 0) is wrong representation of ZERO and is always invalid.
                if (CURVE.allowInfinityPoint && !Fp.is0(this.py)) return;
                throw new Error("bad point: ZERO");
            }
            // Some 3rd-party test vectors require different wording between here & `fromCompressedHex`
            const { x: x, y: y } = this.toAffine();
            // Check if x, y are valid field elements
            if (!Fp.isValid(x) || !Fp.isValid(y)) throw new Error("bad point: x or y not FE");
            const left = Fp.sqr(y); // y²
            const right = weierstrassEquation(x); // x³ + ax + b
            if (!Fp.eql(left, right)) throw new Error("bad point: equation left != right");
            if (!this.isTorsionFree()) throw new Error("bad point: not in prime-order subgroup");
        }
        hasEvenY() {
            const { y: y } = this.toAffine();
            if (Fp.isOdd) return !Fp.isOdd(y);
            throw new Error("Field doesn't support isOdd");
        }
        /**
         * Compare one point to another.
         */ equals(other) {
            assertPrjPoint(other);
            const { px: X1, py: Y1, pz: Z1 } = this;
            const { px: X2, py: Y2, pz: Z2 } = other;
            const U1 = Fp.eql(Fp.mul(X1, Z2), Fp.mul(X2, Z1));
            const U2 = Fp.eql(Fp.mul(Y1, Z2), Fp.mul(Y2, Z1));
            return U1 && U2;
        }
        /**
         * Flips point to one corresponding to (x, -y) in Affine coordinates.
         */ negate() {
            return new Point(this.px, Fp.neg(this.py), this.pz);
        }
        // Renes-Costello-Batina exception-free doubling formula.
        // There is 30% faster Jacobian formula, but it is not complete.
        // https://eprint.iacr.org/2015/1060, algorithm 3
        // Cost: 8M + 3S + 3*a + 2*b3 + 15add.
        double() {
            const { a: a, b: b } = CURVE;
            const b3 = Fp.mul(b, $b472b1d3a53ce762$var$_3n);
            const { px: X1, py: Y1, pz: Z1 } = this;
            let X3 = Fp.ZERO, Y3 = Fp.ZERO, Z3 = Fp.ZERO; // prettier-ignore
            let t0 = Fp.mul(X1, X1); // step 1
            let t1 = Fp.mul(Y1, Y1);
            let t2 = Fp.mul(Z1, Z1);
            let t3 = Fp.mul(X1, Y1);
            t3 = Fp.add(t3, t3); // step 5
            Z3 = Fp.mul(X1, Z1);
            Z3 = Fp.add(Z3, Z3);
            X3 = Fp.mul(a, Z3);
            Y3 = Fp.mul(b3, t2);
            Y3 = Fp.add(X3, Y3); // step 10
            X3 = Fp.sub(t1, Y3);
            Y3 = Fp.add(t1, Y3);
            Y3 = Fp.mul(X3, Y3);
            X3 = Fp.mul(t3, X3);
            Z3 = Fp.mul(b3, Z3); // step 15
            t2 = Fp.mul(a, t2);
            t3 = Fp.sub(t0, t2);
            t3 = Fp.mul(a, t3);
            t3 = Fp.add(t3, Z3);
            Z3 = Fp.add(t0, t0); // step 20
            t0 = Fp.add(Z3, t0);
            t0 = Fp.add(t0, t2);
            t0 = Fp.mul(t0, t3);
            Y3 = Fp.add(Y3, t0);
            t2 = Fp.mul(Y1, Z1); // step 25
            t2 = Fp.add(t2, t2);
            t0 = Fp.mul(t2, t3);
            X3 = Fp.sub(X3, t0);
            Z3 = Fp.mul(t2, t1);
            Z3 = Fp.add(Z3, Z3); // step 30
            Z3 = Fp.add(Z3, Z3);
            return new Point(X3, Y3, Z3);
        }
        // Renes-Costello-Batina exception-free addition formula.
        // There is 30% faster Jacobian formula, but it is not complete.
        // https://eprint.iacr.org/2015/1060, algorithm 1
        // Cost: 12M + 0S + 3*a + 3*b3 + 23add.
        add(other) {
            assertPrjPoint(other);
            const { px: X1, py: Y1, pz: Z1 } = this;
            const { px: X2, py: Y2, pz: Z2 } = other;
            let X3 = Fp.ZERO, Y3 = Fp.ZERO, Z3 = Fp.ZERO; // prettier-ignore
            const a = CURVE.a;
            const b3 = Fp.mul(CURVE.b, $b472b1d3a53ce762$var$_3n);
            let t0 = Fp.mul(X1, X2); // step 1
            let t1 = Fp.mul(Y1, Y2);
            let t2 = Fp.mul(Z1, Z2);
            let t3 = Fp.add(X1, Y1);
            let t4 = Fp.add(X2, Y2); // step 5
            t3 = Fp.mul(t3, t4);
            t4 = Fp.add(t0, t1);
            t3 = Fp.sub(t3, t4);
            t4 = Fp.add(X1, Z1);
            let t5 = Fp.add(X2, Z2); // step 10
            t4 = Fp.mul(t4, t5);
            t5 = Fp.add(t0, t2);
            t4 = Fp.sub(t4, t5);
            t5 = Fp.add(Y1, Z1);
            X3 = Fp.add(Y2, Z2); // step 15
            t5 = Fp.mul(t5, X3);
            X3 = Fp.add(t1, t2);
            t5 = Fp.sub(t5, X3);
            Z3 = Fp.mul(a, t4);
            X3 = Fp.mul(b3, t2); // step 20
            Z3 = Fp.add(X3, Z3);
            X3 = Fp.sub(t1, Z3);
            Z3 = Fp.add(t1, Z3);
            Y3 = Fp.mul(X3, Z3);
            t1 = Fp.add(t0, t0); // step 25
            t1 = Fp.add(t1, t0);
            t2 = Fp.mul(a, t2);
            t4 = Fp.mul(b3, t4);
            t1 = Fp.add(t1, t2);
            t2 = Fp.sub(t0, t2); // step 30
            t2 = Fp.mul(a, t2);
            t4 = Fp.add(t4, t2);
            t0 = Fp.mul(t1, t4);
            Y3 = Fp.add(Y3, t0);
            t0 = Fp.mul(t5, t4); // step 35
            X3 = Fp.mul(t3, X3);
            X3 = Fp.sub(X3, t0);
            t0 = Fp.mul(t3, t1);
            Z3 = Fp.mul(t5, Z3);
            Z3 = Fp.add(Z3, t0); // step 40
            return new Point(X3, Y3, Z3);
        }
        subtract(other) {
            return this.add(other.negate());
        }
        is0() {
            return this.equals(Point.ZERO);
        }
        wNAF(n) {
            return wnaf.wNAFCached(this, pointPrecomputes, n, (comp)=>{
                const toInv = Fp.invertBatch(comp.map((p)=>p.pz));
                return comp.map((p, i)=>p.toAffine(toInv[i])).map(Point.fromAffine);
            });
        }
        /**
         * Non-constant-time multiplication. Uses double-and-add algorithm.
         * It's faster, but should only be used when you don't care about
         * an exposed private key e.g. sig verification, which works over *public* keys.
         */ multiplyUnsafe(n) {
            const I = Point.ZERO;
            if (n === $b472b1d3a53ce762$var$_0n) return I;
            assertGE(n); // Will throw on 0
            if (n === $b472b1d3a53ce762$var$_1n) return this;
            const { endo: endo } = CURVE;
            if (!endo) return wnaf.unsafeLadder(this, n);
            // Apply endomorphism
            let { k1neg: k1neg, k1: k1, k2neg: k2neg, k2: k2 } = endo.splitScalar(n);
            let k1p = I;
            let k2p = I;
            let d = this;
            while(k1 > $b472b1d3a53ce762$var$_0n || k2 > $b472b1d3a53ce762$var$_0n){
                if (k1 & $b472b1d3a53ce762$var$_1n) k1p = k1p.add(d);
                if (k2 & $b472b1d3a53ce762$var$_1n) k2p = k2p.add(d);
                d = d.double();
                k1 >>= $b472b1d3a53ce762$var$_1n;
                k2 >>= $b472b1d3a53ce762$var$_1n;
            }
            if (k1neg) k1p = k1p.negate();
            if (k2neg) k2p = k2p.negate();
            k2p = new Point(Fp.mul(k2p.px, endo.beta), k2p.py, k2p.pz);
            return k1p.add(k2p);
        }
        /**
         * Constant time multiplication.
         * Uses wNAF method. Windowed method may be 10% faster,
         * but takes 2x longer to generate and consumes 2x memory.
         * Uses precomputes when available.
         * Uses endomorphism for Koblitz curves.
         * @param scalar by which the point would be multiplied
         * @returns New point
         */ multiply(scalar) {
            assertGE(scalar);
            let n = scalar;
            let point, fake; // Fake point is used to const-time mult
            const { endo: endo } = CURVE;
            if (endo) {
                const { k1neg: k1neg, k1: k1, k2neg: k2neg, k2: k2 } = endo.splitScalar(n);
                let { p: k1p, f: f1p } = this.wNAF(k1);
                let { p: k2p, f: f2p } = this.wNAF(k2);
                k1p = wnaf.constTimeNegate(k1neg, k1p);
                k2p = wnaf.constTimeNegate(k2neg, k2p);
                k2p = new Point(Fp.mul(k2p.px, endo.beta), k2p.py, k2p.pz);
                point = k1p.add(k2p);
                fake = f1p.add(f2p);
            } else {
                const { p: p, f: f } = this.wNAF(n);
                point = p;
                fake = f;
            }
            // Normalize `z` for both points, but return only real one
            return Point.normalizeZ([
                point,
                fake
            ])[0];
        }
        /**
         * Efficiently calculate `aP + bQ`. Unsafe, can expose private key, if used incorrectly.
         * Not using Strauss-Shamir trick: precomputation tables are faster.
         * The trick could be useful if both P and Q are not G (not in our case).
         * @returns non-zero affine point
         */ multiplyAndAddUnsafe(Q, a, b) {
            const G = Point.BASE; // No Strauss-Shamir trick: we have 10% faster G precomputes
            const mul = (P, a // Select faster multiply() method
            )=>a === $b472b1d3a53ce762$var$_0n || a === $b472b1d3a53ce762$var$_1n || !P.equals(G) ? P.multiplyUnsafe(a) : P.multiply(a);
            const sum = mul(this, a).add(mul(Q, b));
            return sum.is0() ? undefined : sum;
        }
        // Converts Projective point to affine (x, y) coordinates.
        // Can accept precomputed Z^-1 - for example, from invertBatch.
        // (x, y, z) ∋ (x=x/z, y=y/z)
        toAffine(iz) {
            const { px: x, py: y, pz: z } = this;
            const is0 = this.is0();
            // If invZ was 0, we return zero point. However we still want to execute
            // all operations, so we replace invZ with a random number, 1.
            if (iz == null) iz = is0 ? Fp.ONE : Fp.inv(z);
            const ax = Fp.mul(x, iz);
            const ay = Fp.mul(y, iz);
            const zz = Fp.mul(z, iz);
            if (is0) return {
                x: Fp.ZERO,
                y: Fp.ZERO
            };
            if (!Fp.eql(zz, Fp.ONE)) throw new Error("invZ was invalid");
            return {
                x: ax,
                y: ay
            };
        }
        isTorsionFree() {
            const { h: cofactor, isTorsionFree: isTorsionFree } = CURVE;
            if (cofactor === $b472b1d3a53ce762$var$_1n) return true; // No subgroups, always torsion-free
            if (isTorsionFree) return isTorsionFree(Point, this);
            throw new Error("isTorsionFree() has not been declared for the elliptic curve");
        }
        clearCofactor() {
            const { h: cofactor, clearCofactor: clearCofactor } = CURVE;
            if (cofactor === $b472b1d3a53ce762$var$_1n) return this; // Fast-path
            if (clearCofactor) return clearCofactor(Point, this);
            return this.multiplyUnsafe(CURVE.h);
        }
        toRawBytes(isCompressed = true) {
            this.assertValidity();
            return toBytes(Point, this, isCompressed);
        }
        toHex(isCompressed = true) {
            return $a53222754f250272$exports.bytesToHex(this.toRawBytes(isCompressed));
        }
    }
    Point.BASE = new Point(CURVE.Gx, CURVE.Gy, Fp.ONE);
    Point.ZERO = new Point(Fp.ZERO, Fp.ONE, Fp.ZERO);
    const _bits = CURVE.nBitLength;
    const wnaf = (0, $3754823f21a54f54$exports.wNAF)(Point, CURVE.endo ? Math.ceil(_bits / 2) : _bits);
    // Validate if generator point is on curve
    return {
        CURVE: CURVE,
        ProjectivePoint: Point,
        normPrivateKeyToScalar: normPrivateKeyToScalar,
        weierstrassEquation: weierstrassEquation,
        isWithinCurveOrder: isWithinCurveOrder
    };
}
$b472b1d3a53ce762$exports.weierstrassPoints = $b472b1d3a53ce762$var$weierstrassPoints;
function $b472b1d3a53ce762$var$validateOpts(curve) {
    const opts = (0, $3754823f21a54f54$exports.validateBasic)(curve);
    $a53222754f250272$exports.validateObject(opts, {
        hash: "hash",
        hmac: "function",
        randomBytes: "function"
    }, {
        bits2int: "function",
        bits2int_modN: "function",
        lowS: "boolean"
    });
    return Object.freeze({
        lowS: true,
        ...opts
    });
}
function $b472b1d3a53ce762$var$weierstrass(curveDef) {
    const CURVE = $b472b1d3a53ce762$var$validateOpts(curveDef);
    const { Fp: Fp, n: CURVE_ORDER } = CURVE;
    const compressedLen = Fp.BYTES + 1; // e.g. 33 for 32
    const uncompressedLen = 2 * Fp.BYTES + 1; // e.g. 65 for 32
    function isValidFieldElement(num) {
        return $b472b1d3a53ce762$var$_0n < num && num < Fp.ORDER; // 0 is banned since it's not invertible FE
    }
    function modN(a) {
        return $f4225407683e7e63$exports.mod(a, CURVE_ORDER);
    }
    function invN(a) {
        return $f4225407683e7e63$exports.invert(a, CURVE_ORDER);
    }
    const { ProjectivePoint: Point, normPrivateKeyToScalar: normPrivateKeyToScalar, weierstrassEquation: weierstrassEquation, isWithinCurveOrder: isWithinCurveOrder } = $b472b1d3a53ce762$var$weierstrassPoints({
        ...CURVE,
        toBytes (_c, point, isCompressed) {
            const a = point.toAffine();
            const x = Fp.toBytes(a.x);
            const cat = $a53222754f250272$exports.concatBytes;
            if (isCompressed) return cat(Uint8Array.from([
                point.hasEvenY() ? 0x02 : 0x03
            ]), x);
            else return cat(Uint8Array.from([
                0x04
            ]), x, Fp.toBytes(a.y));
        },
        fromBytes (bytes) {
            const len = bytes.length;
            const head = bytes[0];
            const tail = bytes.subarray(1);
            // this.assertValidity() is done inside of fromHex
            if (len === compressedLen && (head === 0x02 || head === 0x03)) {
                const x = $a53222754f250272$exports.bytesToNumberBE(tail);
                if (!isValidFieldElement(x)) throw new Error("Point is not on curve");
                const y2 = weierstrassEquation(x); // y² = x³ + ax + b
                let y = Fp.sqrt(y2); // y = y² ^ (p+1)/4
                const isYOdd = (y & $b472b1d3a53ce762$var$_1n) === $b472b1d3a53ce762$var$_1n;
                // ECDSA
                const isHeadOdd = (head & 1) === 1;
                if (isHeadOdd !== isYOdd) y = Fp.neg(y);
                return {
                    x: x,
                    y: y
                };
            } else if (len === uncompressedLen && head === 0x04) {
                const x = Fp.fromBytes(tail.subarray(0, Fp.BYTES));
                const y = Fp.fromBytes(tail.subarray(Fp.BYTES, 2 * Fp.BYTES));
                return {
                    x: x,
                    y: y
                };
            } else throw new Error(`Point of length ${len} was invalid. Expected ${compressedLen} compressed bytes or ${uncompressedLen} uncompressed bytes`);
        }
    });
    const numToNByteStr = (num)=>$a53222754f250272$exports.bytesToHex($a53222754f250272$exports.numberToBytesBE(num, CURVE.nByteLength));
    function isBiggerThanHalfOrder(number) {
        const HALF = CURVE_ORDER >> $b472b1d3a53ce762$var$_1n;
        return number > HALF;
    }
    function normalizeS(s) {
        return isBiggerThanHalfOrder(s) ? modN(-s) : s;
    }
    // slice bytes num
    const slcNum = (b, from, to)=>$a53222754f250272$exports.bytesToNumberBE(b.slice(from, to));
    /**
     * ECDSA signature with its (r, s) properties. Supports DER & compact representations.
     */ class Signature {
        constructor(r, s, recovery){
            this.r = r;
            this.s = s;
            this.recovery = recovery;
            this.assertValidity();
        }
        // pair (bytes of r, bytes of s)
        static fromCompact(hex) {
            const l = CURVE.nByteLength;
            hex = (0, $a53222754f250272$exports.ensureBytes)("compactSignature", hex, l * 2);
            return new Signature(slcNum(hex, 0, l), slcNum(hex, l, 2 * l));
        }
        // DER encoded ECDSA signature
        // https://bitcoin.stackexchange.com/questions/57644/what-are-the-parts-of-a-bitcoin-transaction-input-script
        static fromDER(hex) {
            const { r: r, s: s } = $b472b1d3a53ce762$exports.DER.toSig((0, $a53222754f250272$exports.ensureBytes)("DER", hex));
            return new Signature(r, s);
        }
        assertValidity() {
            // can use assertGE here
            if (!isWithinCurveOrder(this.r)) throw new Error("r must be 0 < r < CURVE.n");
            if (!isWithinCurveOrder(this.s)) throw new Error("s must be 0 < s < CURVE.n");
        }
        addRecoveryBit(recovery) {
            return new Signature(this.r, this.s, recovery);
        }
        recoverPublicKey(msgHash) {
            const { r: r, s: s, recovery: rec } = this;
            const h = bits2int_modN((0, $a53222754f250272$exports.ensureBytes)("msgHash", msgHash)); // Truncate hash
            if (rec == null || ![
                0,
                1,
                2,
                3
            ].includes(rec)) throw new Error("recovery id invalid");
            const radj = rec === 2 || rec === 3 ? r + CURVE.n : r;
            if (radj >= Fp.ORDER) throw new Error("recovery id 2 or 3 invalid");
            const prefix = (rec & 1) === 0 ? "02" : "03";
            const R = Point.fromHex(prefix + numToNByteStr(radj));
            const ir = invN(radj); // r^-1
            const u1 = modN(-h * ir); // -hr^-1
            const u2 = modN(s * ir); // sr^-1
            const Q = Point.BASE.multiplyAndAddUnsafe(R, u1, u2); // (sr^-1)R-(hr^-1)G = -(hr^-1)G + (sr^-1)
            if (!Q) throw new Error("point at infinify"); // unsafe is fine: no priv data leaked
            Q.assertValidity();
            return Q;
        }
        // Signatures should be low-s, to prevent malleability.
        hasHighS() {
            return isBiggerThanHalfOrder(this.s);
        }
        normalizeS() {
            return this.hasHighS() ? new Signature(this.r, modN(-this.s), this.recovery) : this;
        }
        // DER-encoded
        toDERRawBytes() {
            return $a53222754f250272$exports.hexToBytes(this.toDERHex());
        }
        toDERHex() {
            return $b472b1d3a53ce762$exports.DER.hexFromSig({
                r: this.r,
                s: this.s
            });
        }
        // padded bytes of r, then padded bytes of s
        toCompactRawBytes() {
            return $a53222754f250272$exports.hexToBytes(this.toCompactHex());
        }
        toCompactHex() {
            return numToNByteStr(this.r) + numToNByteStr(this.s);
        }
    }
    const utils = {
        isValidPrivateKey (privateKey) {
            try {
                normPrivateKeyToScalar(privateKey);
                return true;
            } catch (error) {
                return false;
            }
        },
        normPrivateKeyToScalar: normPrivateKeyToScalar,
        /**
         * Produces cryptographically secure private key from random of size
         * (groupLen + ceil(groupLen / 2)) with modulo bias being negligible.
         */ randomPrivateKey: ()=>{
            const length = $f4225407683e7e63$exports.getMinHashLength(CURVE.n);
            return $f4225407683e7e63$exports.mapHashToField(CURVE.randomBytes(length), CURVE.n);
        },
        /**
         * Creates precompute table for an arbitrary EC point. Makes point "cached".
         * Allows to massively speed-up `point.multiply(scalar)`.
         * @returns cached point
         * @example
         * const fast = utils.precompute(8, ProjectivePoint.fromHex(someonesPubKey));
         * fast.multiply(privKey); // much faster ECDH now
         */ precompute (windowSize = 8, point = Point.BASE) {
            point._setWindowSize(windowSize);
            point.multiply(BigInt(3)); // 3 is arbitrary, just need any number here
            return point;
        }
    };
    /**
     * Computes public key for a private key. Checks for validity of the private key.
     * @param privateKey private key
     * @param isCompressed whether to return compact (default), or full key
     * @returns Public key, full when isCompressed=false; short when isCompressed=true
     */ function getPublicKey(privateKey, isCompressed = true) {
        return Point.fromPrivateKey(privateKey).toRawBytes(isCompressed);
    }
    /**
     * Quick and dirty check for item being public key. Does not validate hex, or being on-curve.
     */ function isProbPub(item) {
        const arr = $a53222754f250272$exports.isBytes(item);
        const str = typeof item === "string";
        const len = (arr || str) && item.length;
        if (arr) return len === compressedLen || len === uncompressedLen;
        if (str) return len === 2 * compressedLen || len === 2 * uncompressedLen;
        if (item instanceof Point) return true;
        return false;
    }
    /**
     * ECDH (Elliptic Curve Diffie Hellman).
     * Computes shared public key from private key and public key.
     * Checks: 1) private key validity 2) shared key is on-curve.
     * Does NOT hash the result.
     * @param privateA private key
     * @param publicB different public key
     * @param isCompressed whether to return compact (default), or full key
     * @returns shared public key
     */ function getSharedSecret(privateA, publicB, isCompressed = true) {
        if (isProbPub(privateA)) throw new Error("first arg must be private key");
        if (!isProbPub(publicB)) throw new Error("second arg must be public key");
        const b = Point.fromHex(publicB); // check for being on-curve
        return b.multiply(normPrivateKeyToScalar(privateA)).toRawBytes(isCompressed);
    }
    // RFC6979: ensure ECDSA msg is X bytes and < N. RFC suggests optional truncating via bits2octets.
    // FIPS 186-4 4.6 suggests the leftmost min(nBitLen, outLen) bits, which matches bits2int.
    // bits2int can produce res>N, we can do mod(res, N) since the bitLen is the same.
    // int2octets can't be used; pads small msgs with 0: unacceptatble for trunc as per RFC vectors
    const bits2int = CURVE.bits2int || function(bytes) {
        // For curves with nBitLength % 8 !== 0: bits2octets(bits2octets(m)) !== bits2octets(m)
        // for some cases, since bytes.length * 8 is not actual bitLength.
        const num = $a53222754f250272$exports.bytesToNumberBE(bytes); // check for == u8 done here
        const delta = bytes.length * 8 - CURVE.nBitLength; // truncate to nBitLength leftmost bits
        return delta > 0 ? num >> BigInt(delta) : num;
    };
    const bits2int_modN = CURVE.bits2int_modN || function(bytes) {
        return modN(bits2int(bytes)); // can't use bytesToNumberBE here
    };
    // NOTE: pads output with zero as per spec
    const ORDER_MASK = $a53222754f250272$exports.bitMask(CURVE.nBitLength);
    /**
     * Converts to bytes. Checks if num in `[0..ORDER_MASK-1]` e.g.: `[0..2^256-1]`.
     */ function int2octets(num) {
        if (typeof num !== "bigint") throw new Error("bigint expected");
        if (!($b472b1d3a53ce762$var$_0n <= num && num < ORDER_MASK)) throw new Error(`bigint expected < 2^${CURVE.nBitLength}`);
        // works with order, can have different size than numToField!
        return $a53222754f250272$exports.numberToBytesBE(num, CURVE.nByteLength);
    }
    // Steps A, D of RFC6979 3.2
    // Creates RFC6979 seed; converts msg/privKey to numbers.
    // Used only in sign, not in verify.
    // NOTE: we cannot assume here that msgHash has same amount of bytes as curve order, this will be wrong at least for P521.
    // Also it can be bigger for P224 + SHA256
    function prepSig(msgHash, privateKey, opts = defaultSigOpts) {
        if ([
            "recovered",
            "canonical"
        ].some((k)=>k in opts)) throw new Error("sign() legacy options not supported");
        const { hash: hash, randomBytes: randomBytes } = CURVE;
        let { lowS: lowS, prehash: prehash, extraEntropy: ent } = opts; // generates low-s sigs by default
        if (lowS == null) lowS = true; // RFC6979 3.2: we skip step A, because we already provide hash
        msgHash = (0, $a53222754f250272$exports.ensureBytes)("msgHash", msgHash);
        if (prehash) msgHash = (0, $a53222754f250272$exports.ensureBytes)("prehashed msgHash", hash(msgHash));
        // We can't later call bits2octets, since nested bits2int is broken for curves
        // with nBitLength % 8 !== 0. Because of that, we unwrap it here as int2octets call.
        // const bits2octets = (bits) => int2octets(bits2int_modN(bits))
        const h1int = bits2int_modN(msgHash);
        const d = normPrivateKeyToScalar(privateKey); // validate private key, convert to bigint
        const seedArgs = [
            int2octets(d),
            int2octets(h1int)
        ];
        // extraEntropy. RFC6979 3.6: additional k' (optional).
        if (ent != null) {
            // K = HMAC_K(V || 0x00 || int2octets(x) || bits2octets(h1) || k')
            const e = ent === true ? randomBytes(Fp.BYTES) : ent; // generate random bytes OR pass as-is
            seedArgs.push((0, $a53222754f250272$exports.ensureBytes)("extraEntropy", e)); // check for being bytes
        }
        const seed = $a53222754f250272$exports.concatBytes(...seedArgs); // Step D of RFC6979 3.2
        const m = h1int; // NOTE: no need to call bits2int second time here, it is inside truncateHash!
        // Converts signature params into point w r/s, checks result for validity.
        function k2sig(kBytes) {
            // RFC 6979 Section 3.2, step 3: k = bits2int(T)
            const k = bits2int(kBytes); // Cannot use fields methods, since it is group element
            if (!isWithinCurveOrder(k)) return; // Important: all mod() calls here must be done over N
            const ik = invN(k); // k^-1 mod n
            const q = Point.BASE.multiply(k).toAffine(); // q = Gk
            const r = modN(q.x); // r = q.x mod n
            if (r === $b472b1d3a53ce762$var$_0n) return;
            // Can use scalar blinding b^-1(bm + bdr) where b ∈ [1,q−1] according to
            // https://tches.iacr.org/index.php/TCHES/article/view/7337/6509. We've decided against it:
            // a) dependency on CSPRNG b) 15% slowdown c) doesn't really help since bigints are not CT
            const s = modN(ik * modN(m + r * d)); // Not using blinding here
            if (s === $b472b1d3a53ce762$var$_0n) return;
            let recovery = (q.x === r ? 0 : 2) | Number(q.y & $b472b1d3a53ce762$var$_1n); // recovery bit (2 or 3, when q.x > n)
            let normS = s;
            if (lowS && isBiggerThanHalfOrder(s)) {
                normS = normalizeS(s); // if lowS was passed, ensure s is always
                recovery ^= 1; // // in the bottom half of N
            }
            return new Signature(r, normS, recovery); // use normS, not s
        }
        return {
            seed: seed,
            k2sig: k2sig
        };
    }
    const defaultSigOpts = {
        lowS: CURVE.lowS,
        prehash: false
    };
    const defaultVerOpts = {
        lowS: CURVE.lowS,
        prehash: false
    };
    /**
     * Signs message hash with a private key.
     * ```
     * sign(m, d, k) where
     *   (x, y) = G × k
     *   r = x mod n
     *   s = (m + dr)/k mod n
     * ```
     * @param msgHash NOT message. msg needs to be hashed to `msgHash`, or use `prehash`.
     * @param privKey private key
     * @param opts lowS for non-malleable sigs. extraEntropy for mixing randomness into k. prehash will hash first arg.
     * @returns signature with recovery param
     */ function sign(msgHash, privKey, opts = defaultSigOpts) {
        const { seed: seed, k2sig: k2sig } = prepSig(msgHash, privKey, opts); // Steps A, D of RFC6979 3.2.
        const C = CURVE;
        const drbg = $a53222754f250272$exports.createHmacDrbg(C.hash.outputLen, C.nByteLength, C.hmac);
        return drbg(seed, k2sig); // Steps B, C, D, E, F, G
    }
    // Enable precomputes. Slows down first publicKey computation by 20ms.
    Point.BASE._setWindowSize(8);
    // utils.precompute(8, ProjectivePoint.BASE)
    /**
     * Verifies a signature against message hash and public key.
     * Rejects lowS signatures by default: to override,
     * specify option `{lowS: false}`. Implements section 4.1.4 from https://www.secg.org/sec1-v2.pdf:
     *
     * ```
     * verify(r, s, h, P) where
     *   U1 = hs^-1 mod n
     *   U2 = rs^-1 mod n
     *   R = U1⋅G - U2⋅P
     *   mod(R.x, n) == r
     * ```
     */ function verify(signature, msgHash, publicKey, opts = defaultVerOpts) {
        const sg = signature;
        msgHash = (0, $a53222754f250272$exports.ensureBytes)("msgHash", msgHash);
        publicKey = (0, $a53222754f250272$exports.ensureBytes)("publicKey", publicKey);
        if ("strict" in opts) throw new Error("options.strict was renamed to lowS");
        const { lowS: lowS, prehash: prehash } = opts;
        let _sig = undefined;
        let P;
        try {
            if (typeof sg === "string" || $a53222754f250272$exports.isBytes(sg)) // Signature can be represented in 2 ways: compact (2*nByteLength) & DER (variable-length).
            // Since DER can also be 2*nByteLength bytes, we check for it first.
            try {
                _sig = Signature.fromDER(sg);
            } catch (derError) {
                if (!(derError instanceof $b472b1d3a53ce762$exports.DER.Err)) throw derError;
                _sig = Signature.fromCompact(sg);
            }
            else if (typeof sg === "object" && typeof sg.r === "bigint" && typeof sg.s === "bigint") {
                const { r: r, s: s } = sg;
                _sig = new Signature(r, s);
            } else throw new Error("PARSE");
            P = Point.fromHex(publicKey);
        } catch (error) {
            if (error.message === "PARSE") throw new Error(`signature must be Signature instance, Uint8Array or hex string`);
            return false;
        }
        if (lowS && _sig.hasHighS()) return false;
        if (prehash) msgHash = CURVE.hash(msgHash);
        const { r: r, s: s } = _sig;
        const h = bits2int_modN(msgHash); // Cannot use fields methods, since it is group element
        const is = invN(s); // s^-1
        const u1 = modN(h * is); // u1 = hs^-1 mod n
        const u2 = modN(r * is); // u2 = rs^-1 mod n
        const R = Point.BASE.multiplyAndAddUnsafe(P, u1, u2)?.toAffine(); // R = u1⋅G + u2⋅P
        if (!R) return false;
        const v = modN(R.x);
        return v === r;
    }
    return {
        CURVE: CURVE,
        getPublicKey: getPublicKey,
        getSharedSecret: getSharedSecret,
        sign: sign,
        verify: verify,
        ProjectivePoint: Point,
        Signature: Signature,
        utils: utils
    };
}
$b472b1d3a53ce762$exports.weierstrass = $b472b1d3a53ce762$var$weierstrass;
/**
 * Implementation of the Shallue and van de Woestijne method for any weierstrass curve.
 * TODO: check if there is a way to merge this with uvRatio in Edwards; move to modular.
 * b = True and y = sqrt(u / v) if (u / v) is square in F, and
 * b = False and y = sqrt(Z * (u / v)) otherwise.
 * @param Fp
 * @param Z
 * @returns
 */ function $b472b1d3a53ce762$var$SWUFpSqrtRatio(Fp, Z) {
    // Generic implementation
    const q = Fp.ORDER;
    let l = $b472b1d3a53ce762$var$_0n;
    for(let o = q - $b472b1d3a53ce762$var$_1n; o % $b472b1d3a53ce762$var$_2n === $b472b1d3a53ce762$var$_0n; o /= $b472b1d3a53ce762$var$_2n)l += $b472b1d3a53ce762$var$_1n;
    const c1 = l; // 1. c1, the largest integer such that 2^c1 divides q - 1.
    // We need 2n ** c1 and 2n ** (c1-1). We can't use **; but we can use <<.
    // 2n ** c1 == 2n << (c1-1)
    const _2n_pow_c1_1 = $b472b1d3a53ce762$var$_2n << c1 - $b472b1d3a53ce762$var$_1n - $b472b1d3a53ce762$var$_1n;
    const _2n_pow_c1 = _2n_pow_c1_1 * $b472b1d3a53ce762$var$_2n;
    const c2 = (q - $b472b1d3a53ce762$var$_1n) / _2n_pow_c1; // 2. c2 = (q - 1) / (2^c1)  # Integer arithmetic
    const c3 = (c2 - $b472b1d3a53ce762$var$_1n) / $b472b1d3a53ce762$var$_2n; // 3. c3 = (c2 - 1) / 2            # Integer arithmetic
    const c4 = _2n_pow_c1 - $b472b1d3a53ce762$var$_1n; // 4. c4 = 2^c1 - 1                # Integer arithmetic
    const c5 = _2n_pow_c1_1; // 5. c5 = 2^(c1 - 1)                  # Integer arithmetic
    const c6 = Fp.pow(Z, c2); // 6. c6 = Z^c2
    const c7 = Fp.pow(Z, (c2 + $b472b1d3a53ce762$var$_1n) / $b472b1d3a53ce762$var$_2n); // 7. c7 = Z^((c2 + 1) / 2)
    let sqrtRatio = (u, v)=>{
        let tv1 = c6; // 1. tv1 = c6
        let tv2 = Fp.pow(v, c4); // 2. tv2 = v^c4
        let tv3 = Fp.sqr(tv2); // 3. tv3 = tv2^2
        tv3 = Fp.mul(tv3, v); // 4. tv3 = tv3 * v
        let tv5 = Fp.mul(u, tv3); // 5. tv5 = u * tv3
        tv5 = Fp.pow(tv5, c3); // 6. tv5 = tv5^c3
        tv5 = Fp.mul(tv5, tv2); // 7. tv5 = tv5 * tv2
        tv2 = Fp.mul(tv5, v); // 8. tv2 = tv5 * v
        tv3 = Fp.mul(tv5, u); // 9. tv3 = tv5 * u
        let tv4 = Fp.mul(tv3, tv2); // 10. tv4 = tv3 * tv2
        tv5 = Fp.pow(tv4, c5); // 11. tv5 = tv4^c5
        let isQR = Fp.eql(tv5, Fp.ONE); // 12. isQR = tv5 == 1
        tv2 = Fp.mul(tv3, c7); // 13. tv2 = tv3 * c7
        tv5 = Fp.mul(tv4, tv1); // 14. tv5 = tv4 * tv1
        tv3 = Fp.cmov(tv2, tv3, isQR); // 15. tv3 = CMOV(tv2, tv3, isQR)
        tv4 = Fp.cmov(tv5, tv4, isQR); // 16. tv4 = CMOV(tv5, tv4, isQR)
        // 17. for i in (c1, c1 - 1, ..., 2):
        for(let i = c1; i > $b472b1d3a53ce762$var$_1n; i--){
            let tv5 = i - $b472b1d3a53ce762$var$_2n; // 18.    tv5 = i - 2
            tv5 = $b472b1d3a53ce762$var$_2n << tv5 - $b472b1d3a53ce762$var$_1n; // 19.    tv5 = 2^tv5
            let tvv5 = Fp.pow(tv4, tv5); // 20.    tv5 = tv4^tv5
            const e1 = Fp.eql(tvv5, Fp.ONE); // 21.    e1 = tv5 == 1
            tv2 = Fp.mul(tv3, tv1); // 22.    tv2 = tv3 * tv1
            tv1 = Fp.mul(tv1, tv1); // 23.    tv1 = tv1 * tv1
            tvv5 = Fp.mul(tv4, tv1); // 24.    tv5 = tv4 * tv1
            tv3 = Fp.cmov(tv2, tv3, e1); // 25.    tv3 = CMOV(tv2, tv3, e1)
            tv4 = Fp.cmov(tvv5, tv4, e1); // 26.    tv4 = CMOV(tv5, tv4, e1)
        }
        return {
            isValid: isQR,
            value: tv3
        };
    };
    if (Fp.ORDER % $b472b1d3a53ce762$var$_4n === $b472b1d3a53ce762$var$_3n) {
        // sqrt_ratio_3mod4(u, v)
        const c1 = (Fp.ORDER - $b472b1d3a53ce762$var$_3n) / $b472b1d3a53ce762$var$_4n; // 1. c1 = (q - 3) / 4     # Integer arithmetic
        const c2 = Fp.sqrt(Fp.neg(Z)); // 2. c2 = sqrt(-Z)
        sqrtRatio = (u, v)=>{
            let tv1 = Fp.sqr(v); // 1. tv1 = v^2
            const tv2 = Fp.mul(u, v); // 2. tv2 = u * v
            tv1 = Fp.mul(tv1, tv2); // 3. tv1 = tv1 * tv2
            let y1 = Fp.pow(tv1, c1); // 4. y1 = tv1^c1
            y1 = Fp.mul(y1, tv2); // 5. y1 = y1 * tv2
            const y2 = Fp.mul(y1, c2); // 6. y2 = y1 * c2
            const tv3 = Fp.mul(Fp.sqr(y1), v); // 7. tv3 = y1^2; 8. tv3 = tv3 * v
            const isQR = Fp.eql(tv3, u); // 9. isQR = tv3 == u
            let y = Fp.cmov(y2, y1, isQR); // 10. y = CMOV(y2, y1, isQR)
            return {
                isValid: isQR,
                value: y
            }; // 11. return (isQR, y) isQR ? y : y*c2
        };
    }
    // No curves uses that
    // if (Fp.ORDER % _8n === _5n) // sqrt_ratio_5mod8
    return sqrtRatio;
}
$b472b1d3a53ce762$exports.SWUFpSqrtRatio = $b472b1d3a53ce762$var$SWUFpSqrtRatio;
/**
 * Simplified Shallue-van de Woestijne-Ulas Method
 * https://www.rfc-editor.org/rfc/rfc9380#section-6.6.2
 */ function $b472b1d3a53ce762$var$mapToCurveSimpleSWU(Fp, opts) {
    $f4225407683e7e63$exports.validateField(Fp);
    if (!Fp.isValid(opts.A) || !Fp.isValid(opts.B) || !Fp.isValid(opts.Z)) throw new Error("mapToCurveSimpleSWU: invalid opts");
    const sqrtRatio = $b472b1d3a53ce762$var$SWUFpSqrtRatio(Fp, opts.Z);
    if (!Fp.isOdd) throw new Error("Fp.isOdd is not implemented!");
    // Input: u, an element of F.
    // Output: (x, y), a point on E.
    return (u)=>{
        // prettier-ignore
        let tv1, tv2, tv3, tv4, tv5, tv6, x, y;
        tv1 = Fp.sqr(u); // 1.  tv1 = u^2
        tv1 = Fp.mul(tv1, opts.Z); // 2.  tv1 = Z * tv1
        tv2 = Fp.sqr(tv1); // 3.  tv2 = tv1^2
        tv2 = Fp.add(tv2, tv1); // 4.  tv2 = tv2 + tv1
        tv3 = Fp.add(tv2, Fp.ONE); // 5.  tv3 = tv2 + 1
        tv3 = Fp.mul(tv3, opts.B); // 6.  tv3 = B * tv3
        tv4 = Fp.cmov(opts.Z, Fp.neg(tv2), !Fp.eql(tv2, Fp.ZERO)); // 7.  tv4 = CMOV(Z, -tv2, tv2 != 0)
        tv4 = Fp.mul(tv4, opts.A); // 8.  tv4 = A * tv4
        tv2 = Fp.sqr(tv3); // 9.  tv2 = tv3^2
        tv6 = Fp.sqr(tv4); // 10. tv6 = tv4^2
        tv5 = Fp.mul(tv6, opts.A); // 11. tv5 = A * tv6
        tv2 = Fp.add(tv2, tv5); // 12. tv2 = tv2 + tv5
        tv2 = Fp.mul(tv2, tv3); // 13. tv2 = tv2 * tv3
        tv6 = Fp.mul(tv6, tv4); // 14. tv6 = tv6 * tv4
        tv5 = Fp.mul(tv6, opts.B); // 15. tv5 = B * tv6
        tv2 = Fp.add(tv2, tv5); // 16. tv2 = tv2 + tv5
        x = Fp.mul(tv1, tv3); // 17.   x = tv1 * tv3
        const { isValid: isValid, value: value } = sqrtRatio(tv2, tv6); // 18. (is_gx1_square, y1) = sqrt_ratio(tv2, tv6)
        y = Fp.mul(tv1, u); // 19.   y = tv1 * u  -> Z * u^3 * y1
        y = Fp.mul(y, value); // 20.   y = y * y1
        x = Fp.cmov(x, tv3, isValid); // 21.   x = CMOV(x, tv3, is_gx1_square)
        y = Fp.cmov(y, value, isValid); // 22.   y = CMOV(y, y1, is_gx1_square)
        const e1 = Fp.isOdd(u) === Fp.isOdd(y); // 23.  e1 = sgn0(u) == sgn0(y)
        y = Fp.cmov(Fp.neg(y), y, e1); // 24.   y = CMOV(-y, y, e1)
        x = Fp.div(x, tv4); // 25.   x = x / tv4
        return {
            x: x,
            y: y
        };
    };
}
$b472b1d3a53ce762$exports.mapToCurveSimpleSWU = $b472b1d3a53ce762$var$mapToCurveSimpleSWU;




var $e1e3ae774b62fefe$exports = {};
"use strict";
Object.defineProperty($e1e3ae774b62fefe$exports, "__esModule", {
    value: true
});
$e1e3ae774b62fefe$exports.createCurve = $e1e3ae774b62fefe$exports.getHash = void 0;

var $63hPu = parcelRequire("63hPu");

var $ebEok = parcelRequire("ebEok");

// connects noble-curves to noble-hashes
function $e1e3ae774b62fefe$var$getHash(hash) {
    return {
        hash: hash,
        hmac: (key, ...msgs)=>(0, $63hPu.hmac)(hash, key, (0, $ebEok.concatBytes)(...msgs)),
        randomBytes: $ebEok.randomBytes
    };
}
$e1e3ae774b62fefe$exports.getHash = $e1e3ae774b62fefe$var$getHash;
function $e1e3ae774b62fefe$var$createCurve(curveDef, defHash) {
    const create = (hash)=>(0, $b472b1d3a53ce762$exports.weierstrass)({
            ...curveDef,
            ...$e1e3ae774b62fefe$var$getHash(hash)
        });
    return Object.freeze({
        ...create(defHash),
        create: create
    });
}
$e1e3ae774b62fefe$exports.createCurve = $e1e3ae774b62fefe$var$createCurve;


const $b7c00ec1cc5daba7$var$secp256k1P = BigInt("0xfffffffffffffffffffffffffffffffffffffffffffffffffffffffefffffc2f");
const $b7c00ec1cc5daba7$var$secp256k1N = BigInt("0xfffffffffffffffffffffffffffffffebaaedce6af48a03bbfd25e8cd0364141");
const $b7c00ec1cc5daba7$var$_1n = BigInt(1);
const $b7c00ec1cc5daba7$var$_2n = BigInt(2);
const $b7c00ec1cc5daba7$var$divNearest = (a, b)=>(a + b / $b7c00ec1cc5daba7$var$_2n) / b;
/**
 * √n = n^((p+1)/4) for fields p = 3 mod 4. We unwrap the loop and multiply bit-by-bit.
 * (P+1n/4n).toString(2) would produce bits [223x 1, 0, 22x 1, 4x 0, 11, 00]
 */ function $b7c00ec1cc5daba7$var$sqrtMod(y) {
    const P = $b7c00ec1cc5daba7$var$secp256k1P;
    // prettier-ignore
    const _3n = BigInt(3), _6n = BigInt(6), _11n = BigInt(11), _22n = BigInt(22);
    // prettier-ignore
    const _23n = BigInt(23), _44n = BigInt(44), _88n = BigInt(88);
    const b2 = y * y * y % P; // x^3, 11
    const b3 = b2 * b2 * y % P; // x^7
    const b6 = (0, $f4225407683e7e63$exports.pow2)(b3, _3n, P) * b3 % P;
    const b9 = (0, $f4225407683e7e63$exports.pow2)(b6, _3n, P) * b3 % P;
    const b11 = (0, $f4225407683e7e63$exports.pow2)(b9, $b7c00ec1cc5daba7$var$_2n, P) * b2 % P;
    const b22 = (0, $f4225407683e7e63$exports.pow2)(b11, _11n, P) * b11 % P;
    const b44 = (0, $f4225407683e7e63$exports.pow2)(b22, _22n, P) * b22 % P;
    const b88 = (0, $f4225407683e7e63$exports.pow2)(b44, _44n, P) * b44 % P;
    const b176 = (0, $f4225407683e7e63$exports.pow2)(b88, _88n, P) * b88 % P;
    const b220 = (0, $f4225407683e7e63$exports.pow2)(b176, _44n, P) * b44 % P;
    const b223 = (0, $f4225407683e7e63$exports.pow2)(b220, _3n, P) * b3 % P;
    const t1 = (0, $f4225407683e7e63$exports.pow2)(b223, _23n, P) * b22 % P;
    const t2 = (0, $f4225407683e7e63$exports.pow2)(t1, _6n, P) * b2 % P;
    const root = (0, $f4225407683e7e63$exports.pow2)(t2, $b7c00ec1cc5daba7$var$_2n, P);
    if (!$b7c00ec1cc5daba7$var$Fp.eql($b7c00ec1cc5daba7$var$Fp.sqr(root), y)) throw new Error("Cannot find square root");
    return root;
}
const $b7c00ec1cc5daba7$var$Fp = (0, $f4225407683e7e63$exports.Field)($b7c00ec1cc5daba7$var$secp256k1P, undefined, undefined, {
    sqrt: $b7c00ec1cc5daba7$var$sqrtMod
});
$b7c00ec1cc5daba7$exports.secp256k1 = (0, $e1e3ae774b62fefe$exports.createCurve)({
    a: BigInt(0),
    b: BigInt(7),
    Fp: $b7c00ec1cc5daba7$var$Fp,
    n: $b7c00ec1cc5daba7$var$secp256k1N,
    // Base point (x, y) aka generator point
    Gx: BigInt("55066263022277343669578718895168534326250603453777594175500187360389116729240"),
    Gy: BigInt("32670510020758816978083085130507043184471273380659243275938904335757337482424"),
    h: BigInt(1),
    lowS: true,
    /**
     * secp256k1 belongs to Koblitz curves: it has efficiently computable endomorphism.
     * Endomorphism uses 2x less RAM, speeds up precomputation by 2x and ECDH / key recovery by 20%.
     * For precomputed wNAF it trades off 1/2 init time & 1/3 ram for 20% perf hit.
     * Explanation: https://gist.github.com/paulmillr/eb670806793e84df628a7c434a873066
     */ endo: {
        beta: BigInt("0x7ae96a2b657c07106e64479eac3434e99cf0497512f58995c1396c28719501ee"),
        splitScalar: (k)=>{
            const n = $b7c00ec1cc5daba7$var$secp256k1N;
            const a1 = BigInt("0x3086d221a7d46bcde86c90e49284eb15");
            const b1 = -$b7c00ec1cc5daba7$var$_1n * BigInt("0xe4437ed6010e88286f547fa90abfe4c3");
            const a2 = BigInt("0x114ca50f7a8e2f3f657c1108d9d44cfd8");
            const b2 = a1;
            const POW_2_128 = BigInt("0x100000000000000000000000000000000"); // (2n**128n).toString(16)
            const c1 = $b7c00ec1cc5daba7$var$divNearest(b2 * k, n);
            const c2 = $b7c00ec1cc5daba7$var$divNearest(-b1 * k, n);
            let k1 = (0, $f4225407683e7e63$exports.mod)(k - c1 * a1 - c2 * a2, n);
            let k2 = (0, $f4225407683e7e63$exports.mod)(-c1 * b1 - c2 * b2, n);
            const k1neg = k1 > POW_2_128;
            const k2neg = k2 > POW_2_128;
            if (k1neg) k1 = n - k1;
            if (k2neg) k2 = n - k2;
            if (k1 > POW_2_128 || k2 > POW_2_128) throw new Error("splitScalar: Endomorphism failed, k=" + k);
            return {
                k1neg: k1neg,
                k1: k1,
                k2neg: k2neg,
                k2: k2
            };
        }
    }
}, $lrsL3.sha256);
// Schnorr signatures are superior to ECDSA from above. Below is Schnorr-specific BIP0340 code.
// https://github.com/bitcoin/bips/blob/master/bip-0340.mediawiki
const $b7c00ec1cc5daba7$var$_0n = BigInt(0);
const $b7c00ec1cc5daba7$var$fe = (x)=>typeof x === "bigint" && $b7c00ec1cc5daba7$var$_0n < x && x < $b7c00ec1cc5daba7$var$secp256k1P;
const $b7c00ec1cc5daba7$var$ge = (x)=>typeof x === "bigint" && $b7c00ec1cc5daba7$var$_0n < x && x < $b7c00ec1cc5daba7$var$secp256k1N;
/** An object mapping tags to their tagged hash prefix of [SHA256(tag) | SHA256(tag)] */ const $b7c00ec1cc5daba7$var$TAGGED_HASH_PREFIXES = {};
function $b7c00ec1cc5daba7$var$taggedHash(tag, ...messages) {
    let tagP = $b7c00ec1cc5daba7$var$TAGGED_HASH_PREFIXES[tag];
    if (tagP === undefined) {
        const tagH = (0, $lrsL3.sha256)(Uint8Array.from(tag, (c)=>c.charCodeAt(0)));
        tagP = (0, $a53222754f250272$exports.concatBytes)(tagH, tagH);
        $b7c00ec1cc5daba7$var$TAGGED_HASH_PREFIXES[tag] = tagP;
    }
    return (0, $lrsL3.sha256)((0, $a53222754f250272$exports.concatBytes)(tagP, ...messages));
}
// ECDSA compact points are 33-byte. Schnorr is 32: we strip first byte 0x02 or 0x03
const $b7c00ec1cc5daba7$var$pointToBytes = (point)=>point.toRawBytes(true).slice(1);
const $b7c00ec1cc5daba7$var$numTo32b = (n)=>(0, $a53222754f250272$exports.numberToBytesBE)(n, 32);
const $b7c00ec1cc5daba7$var$modP = (x)=>(0, $f4225407683e7e63$exports.mod)(x, $b7c00ec1cc5daba7$var$secp256k1P);
const $b7c00ec1cc5daba7$var$modN = (x)=>(0, $f4225407683e7e63$exports.mod)(x, $b7c00ec1cc5daba7$var$secp256k1N);
const $b7c00ec1cc5daba7$var$Point = $b7c00ec1cc5daba7$exports.secp256k1.ProjectivePoint;
const $b7c00ec1cc5daba7$var$GmulAdd = (Q, a, b)=>$b7c00ec1cc5daba7$var$Point.BASE.multiplyAndAddUnsafe(Q, a, b);
// Calculate point, scalar and bytes
function $b7c00ec1cc5daba7$var$schnorrGetExtPubKey(priv) {
    let d_ = $b7c00ec1cc5daba7$exports.secp256k1.utils.normPrivateKeyToScalar(priv); // same method executed in fromPrivateKey
    let p = $b7c00ec1cc5daba7$var$Point.fromPrivateKey(d_); // P = d'⋅G; 0 < d' < n check is done inside
    const scalar = p.hasEvenY() ? d_ : $b7c00ec1cc5daba7$var$modN(-d_);
    return {
        scalar: scalar,
        bytes: $b7c00ec1cc5daba7$var$pointToBytes(p)
    };
}
/**
 * lift_x from BIP340. Convert 32-byte x coordinate to elliptic curve point.
 * @returns valid point checked for being on-curve
 */ function $b7c00ec1cc5daba7$var$lift_x(x) {
    if (!$b7c00ec1cc5daba7$var$fe(x)) throw new Error("bad x: need 0 < x < p"); // Fail if x ≥ p.
    const xx = $b7c00ec1cc5daba7$var$modP(x * x);
    const c = $b7c00ec1cc5daba7$var$modP(xx * x + BigInt(7)); // Let c = x³ + 7 mod p.
    let y = $b7c00ec1cc5daba7$var$sqrtMod(c); // Let y = c^(p+1)/4 mod p.
    if (y % $b7c00ec1cc5daba7$var$_2n !== $b7c00ec1cc5daba7$var$_0n) y = $b7c00ec1cc5daba7$var$modP(-y); // Return the unique point P such that x(P) = x and
    const p = new $b7c00ec1cc5daba7$var$Point(x, y, $b7c00ec1cc5daba7$var$_1n); // y(P) = y if y mod 2 = 0 or y(P) = p-y otherwise.
    p.assertValidity();
    return p;
}
/**
 * Create tagged hash, convert it to bigint, reduce modulo-n.
 */ function $b7c00ec1cc5daba7$var$challenge(...args) {
    return $b7c00ec1cc5daba7$var$modN((0, $a53222754f250272$exports.bytesToNumberBE)($b7c00ec1cc5daba7$var$taggedHash("BIP0340/challenge", ...args)));
}
/**
 * Schnorr public key is just `x` coordinate of Point as per BIP340.
 */ function $b7c00ec1cc5daba7$var$schnorrGetPublicKey(privateKey) {
    return $b7c00ec1cc5daba7$var$schnorrGetExtPubKey(privateKey).bytes; // d'=int(sk). Fail if d'=0 or d'≥n. Ret bytes(d'⋅G)
}
/**
 * Creates Schnorr signature as per BIP340. Verifies itself before returning anything.
 * auxRand is optional and is not the sole source of k generation: bad CSPRNG won't be dangerous.
 */ function $b7c00ec1cc5daba7$var$schnorrSign(message, privateKey, auxRand = (0, $ebEok.randomBytes)(32)) {
    const m = (0, $a53222754f250272$exports.ensureBytes)("message", message);
    const { bytes: px, scalar: d } = $b7c00ec1cc5daba7$var$schnorrGetExtPubKey(privateKey); // checks for isWithinCurveOrder
    const a = (0, $a53222754f250272$exports.ensureBytes)("auxRand", auxRand, 32); // Auxiliary random data a: a 32-byte array
    const t = $b7c00ec1cc5daba7$var$numTo32b(d ^ (0, $a53222754f250272$exports.bytesToNumberBE)($b7c00ec1cc5daba7$var$taggedHash("BIP0340/aux", a))); // Let t be the byte-wise xor of bytes(d) and hash/aux(a)
    const rand = $b7c00ec1cc5daba7$var$taggedHash("BIP0340/nonce", t, px, m); // Let rand = hash/nonce(t || bytes(P) || m)
    const k_ = $b7c00ec1cc5daba7$var$modN((0, $a53222754f250272$exports.bytesToNumberBE)(rand)); // Let k' = int(rand) mod n
    if (k_ === $b7c00ec1cc5daba7$var$_0n) throw new Error("sign failed: k is zero"); // Fail if k' = 0.
    const { bytes: rx, scalar: k } = $b7c00ec1cc5daba7$var$schnorrGetExtPubKey(k_); // Let R = k'⋅G.
    const e = $b7c00ec1cc5daba7$var$challenge(rx, px, m); // Let e = int(hash/challenge(bytes(R) || bytes(P) || m)) mod n.
    const sig = new Uint8Array(64); // Let sig = bytes(R) || bytes((k + ed) mod n).
    sig.set(rx, 0);
    sig.set($b7c00ec1cc5daba7$var$numTo32b($b7c00ec1cc5daba7$var$modN(k + e * d)), 32);
    // If Verify(bytes(P), m, sig) (see below) returns failure, abort
    if (!$b7c00ec1cc5daba7$var$schnorrVerify(sig, m, px)) throw new Error("sign: Invalid signature produced");
    return sig;
}
/**
 * Verifies Schnorr signature.
 * Will swallow errors & return false except for initial type validation of arguments.
 */ function $b7c00ec1cc5daba7$var$schnorrVerify(signature, message, publicKey) {
    const sig = (0, $a53222754f250272$exports.ensureBytes)("signature", signature, 64);
    const m = (0, $a53222754f250272$exports.ensureBytes)("message", message);
    const pub = (0, $a53222754f250272$exports.ensureBytes)("publicKey", publicKey, 32);
    try {
        const P = $b7c00ec1cc5daba7$var$lift_x((0, $a53222754f250272$exports.bytesToNumberBE)(pub)); // P = lift_x(int(pk)); fail if that fails
        const r = (0, $a53222754f250272$exports.bytesToNumberBE)(sig.subarray(0, 32)); // Let r = int(sig[0:32]); fail if r ≥ p.
        if (!$b7c00ec1cc5daba7$var$fe(r)) return false;
        const s = (0, $a53222754f250272$exports.bytesToNumberBE)(sig.subarray(32, 64)); // Let s = int(sig[32:64]); fail if s ≥ n.
        if (!$b7c00ec1cc5daba7$var$ge(s)) return false;
        const e = $b7c00ec1cc5daba7$var$challenge($b7c00ec1cc5daba7$var$numTo32b(r), $b7c00ec1cc5daba7$var$pointToBytes(P), m); // int(challenge(bytes(r)||bytes(P)||m))%n
        const R = $b7c00ec1cc5daba7$var$GmulAdd(P, s, $b7c00ec1cc5daba7$var$modN(-e)); // R = s⋅G - e⋅P
        if (!R || !R.hasEvenY() || R.toAffine().x !== r) return false; // -eP == (n-e)P
        return true; // Fail if is_infinite(R) / not has_even_y(R) / x(R) ≠ r.
    } catch (error) {
        return false;
    }
}
$b7c00ec1cc5daba7$exports.schnorr = (()=>({
        getPublicKey: $b7c00ec1cc5daba7$var$schnorrGetPublicKey,
        sign: $b7c00ec1cc5daba7$var$schnorrSign,
        verify: $b7c00ec1cc5daba7$var$schnorrVerify,
        utils: {
            randomPrivateKey: $b7c00ec1cc5daba7$exports.secp256k1.utils.randomPrivateKey,
            lift_x: $b7c00ec1cc5daba7$var$lift_x,
            pointToBytes: $b7c00ec1cc5daba7$var$pointToBytes,
            numberToBytesBE: $a53222754f250272$exports.numberToBytesBE,
            bytesToNumberBE: $a53222754f250272$exports.bytesToNumberBE,
            taggedHash: $b7c00ec1cc5daba7$var$taggedHash,
            mod: $f4225407683e7e63$exports.mod
        }
    }))();
const $b7c00ec1cc5daba7$var$isoMap = /* @__PURE__ */ (()=>(0, $4aa17946f6094e60$exports.isogenyMap)($b7c00ec1cc5daba7$var$Fp, [
        // xNum
        [
            "0x8e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38daaaaa8c7",
            "0x7d3d4c80bc321d5b9f315cea7fd44c5d595d2fc0bf63b92dfff1044f17c6581",
            "0x534c328d23f234e6e2a413deca25caece4506144037c40314ecbd0b53d9dd262",
            "0x8e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38daaaaa88c"
        ],
        // xDen
        [
            "0xd35771193d94918a9ca34ccbb7b640dd86cd409542f8487d9fe6b745781eb49b",
            "0xedadc6f64383dc1df7c4b2d51b54225406d36b641f5e41bbc52a56612a8c6d14",
            "0x0000000000000000000000000000000000000000000000000000000000000001"
        ],
        // yNum
        [
            "0x4bda12f684bda12f684bda12f684bda12f684bda12f684bda12f684b8e38e23c",
            "0xc75e0c32d5cb7c0fa9d0a54b12a0a6d5647ab046d686da6fdffc90fc201d71a3",
            "0x29a6194691f91a73715209ef6512e576722830a201be2018a765e85a9ecee931",
            "0x2f684bda12f684bda12f684bda12f684bda12f684bda12f684bda12f38e38d84"
        ],
        // yDen
        [
            "0xfffffffffffffffffffffffffffffffffffffffffffffffffffffffefffff93b",
            "0x7a06534bb8bdb49fd5e9e6632722c2989467c1bfc8e8d978dfb425d2685c2573",
            "0x6484aa716545ca2cf3a70c3fa8fe337e0a3d21162f0d6299a7bf8192bfd2a76f",
            "0x0000000000000000000000000000000000000000000000000000000000000001"
        ]
    ].map((i)=>i.map((j)=>BigInt(j)))))();
const $b7c00ec1cc5daba7$var$mapSWU = /* @__PURE__ */ (()=>(0, $b472b1d3a53ce762$exports.mapToCurveSimpleSWU)($b7c00ec1cc5daba7$var$Fp, {
        A: BigInt("0x3f8731abdd661adca08a5558f0f5d272e953d363cb6f0e5d405447c01a444533"),
        B: BigInt("1771"),
        Z: $b7c00ec1cc5daba7$var$Fp.create(BigInt("-11"))
    }))();
const $b7c00ec1cc5daba7$var$htf = /* @__PURE__ */ (()=>(0, $4aa17946f6094e60$exports.createHasher)($b7c00ec1cc5daba7$exports.secp256k1.ProjectivePoint, (scalars)=>{
        const { x: x, y: y } = $b7c00ec1cc5daba7$var$mapSWU($b7c00ec1cc5daba7$var$Fp.create(scalars[0]));
        return $b7c00ec1cc5daba7$var$isoMap(x, y);
    }, {
        DST: "secp256k1_XMD:SHA-256_SSWU_RO_",
        encodeDST: "secp256k1_XMD:SHA-256_SSWU_NU_",
        p: $b7c00ec1cc5daba7$var$Fp.ORDER,
        m: 1,
        k: 128,
        expand: "xmd",
        hash: $lrsL3.sha256
    }))();
$b7c00ec1cc5daba7$exports.hashToCurve = (()=>$b7c00ec1cc5daba7$var$htf.hashToCurve)();
$b7c00ec1cc5daba7$exports.encodeToCurve = (()=>$b7c00ec1cc5daba7$var$htf.encodeToCurve)();


/**
 * A 64 byte secret key, the first 32 bytes of which is the
 * private scalar and the last 32 bytes is the public key.
 * Read more: https://blog.mozilla.org/warner/2011/11/29/ed25519-keys/
 */ /**
 * Ed25519 Keypair
 */ const $163ae62b92845c86$var$generatePrivateKey = (0, $eff1b194c9d09a4e$exports.ed25519).utils.randomPrivateKey;
const $163ae62b92845c86$var$generateKeypair = ()=>{
    const privateScalar = (0, $eff1b194c9d09a4e$exports.ed25519).utils.randomPrivateKey();
    const publicKey = $163ae62b92845c86$var$getPublicKey(privateScalar);
    const secretKey = new Uint8Array(64);
    secretKey.set(privateScalar);
    secretKey.set(publicKey, 32);
    return {
        publicKey: publicKey,
        secretKey: secretKey
    };
};
const $163ae62b92845c86$var$getPublicKey = (0, $eff1b194c9d09a4e$exports.ed25519).getPublicKey;
function $163ae62b92845c86$var$isOnCurve(publicKey) {
    try {
        (0, $eff1b194c9d09a4e$exports.ed25519).ExtendedPoint.fromHex(publicKey);
        return true;
    } catch  {
        return false;
    }
}
const $163ae62b92845c86$var$sign = (message, secretKey)=>(0, $eff1b194c9d09a4e$exports.ed25519).sign(message, secretKey.slice(0, 32));
const $163ae62b92845c86$var$verify = (0, $eff1b194c9d09a4e$exports.ed25519).verify;
const $163ae62b92845c86$var$toBuffer = (arr)=>{
    if ((0, $5ed0747d5916bbd8$export$a143d493d941bafc).isBuffer(arr)) return arr;
    else if (arr instanceof Uint8Array) return (0, $5ed0747d5916bbd8$export$a143d493d941bafc).from(arr.buffer, arr.byteOffset, arr.byteLength);
    else return (0, $5ed0747d5916bbd8$export$a143d493d941bafc).from(arr);
};
// Class wrapping a plain object
class $163ae62b92845c86$export$eabc71f011df675a {
    constructor(properties){
        Object.assign(this, properties);
    }
    encode() {
        return (0, $5ed0747d5916bbd8$export$a143d493d941bafc).from((0, $34e3e5c42c9dc29c$exports.serialize)($163ae62b92845c86$export$68d13ce9b4cc48f3, this));
    }
    static decode(data) {
        return (0, $34e3e5c42c9dc29c$exports.deserialize)($163ae62b92845c86$export$68d13ce9b4cc48f3, this, data);
    }
    static decodeUnchecked(data) {
        return (0, $34e3e5c42c9dc29c$exports.deserializeUnchecked)($163ae62b92845c86$export$68d13ce9b4cc48f3, this, data);
    }
}
// Class representing a Rust-compatible enum, since enums are only strings or
// numbers in pure JS
class $163ae62b92845c86$export$deb82508dd66d288 extends $163ae62b92845c86$export$eabc71f011df675a {
    constructor(properties){
        super(properties);
        this.enum = "";
        if (Object.keys(properties).length !== 1) throw new Error("Enum can only take single value");
        Object.keys(properties).map((key)=>{
            this.enum = key;
        });
    }
}
const $163ae62b92845c86$export$68d13ce9b4cc48f3 = new Map();
var $163ae62b92845c86$var$_class;
let $163ae62b92845c86$var$_Symbol$toStringTag;
/**
 * Maximum length of derived pubkey seed
 */ const $163ae62b92845c86$export$8240f9da84ad7873 = 32;
/**
 * Size of public key in bytes
 */ const $163ae62b92845c86$export$84fc0a248cc54343 = 32;
/**
 * Value to be converted into public key
 */ /**
 * JSON object representation of PublicKey class
 */ function $163ae62b92845c86$var$isPublicKeyData(value) {
    return value._bn !== undefined;
}
// local counter used by PublicKey.unique()
let $163ae62b92845c86$var$uniquePublicKeyCounter = 1;
/**
 * A public key
 */ $163ae62b92845c86$var$_Symbol$toStringTag = Symbol.toStringTag;
class $163ae62b92845c86$export$ca8b6604d6ce14de extends $163ae62b92845c86$export$eabc71f011df675a {
    /**
   * Create a new PublicKey object
   * @param value ed25519 public key as buffer or base-58 encoded string
   */ constructor(value){
        super({});
        /** @internal */ this._bn = void 0;
        if ($163ae62b92845c86$var$isPublicKeyData(value)) this._bn = value._bn;
        else {
            if (typeof value === "string") {
                // assume base 58 encoding by default
                const decoded = (0, (/*@__PURE__*/$parcel$interopDefault($hZS7n))).decode(value);
                if (decoded.length != $163ae62b92845c86$export$84fc0a248cc54343) throw new Error(`Invalid public key input`);
                this._bn = new (0, (/*@__PURE__*/$parcel$interopDefault($fnQBP)))(decoded);
            } else this._bn = new (0, (/*@__PURE__*/$parcel$interopDefault($fnQBP)))(value);
            if (this._bn.byteLength() > $163ae62b92845c86$export$84fc0a248cc54343) throw new Error(`Invalid public key input`);
        }
    }
    /**
   * Returns a unique PublicKey for tests and benchmarks using a counter
   */ static unique() {
        const key = new $163ae62b92845c86$export$ca8b6604d6ce14de($163ae62b92845c86$var$uniquePublicKeyCounter);
        $163ae62b92845c86$var$uniquePublicKeyCounter += 1;
        return new $163ae62b92845c86$export$ca8b6604d6ce14de(key.toBuffer());
    }
    /**
   * Default public key value. The base58-encoded string representation is all ones (as seen below)
   * The underlying BN number is 32 bytes that are all zeros
   */ /**
   * Checks if two publicKeys are equal
   */ equals(publicKey) {
        return this._bn.eq(publicKey._bn);
    }
    /**
   * Return the base-58 representation of the public key
   */ toBase58() {
        return (0, (/*@__PURE__*/$parcel$interopDefault($hZS7n))).encode(this.toBytes());
    }
    toJSON() {
        return this.toBase58();
    }
    /**
   * Return the byte array representation of the public key in big endian
   */ toBytes() {
        const buf = this.toBuffer();
        return new Uint8Array(buf.buffer, buf.byteOffset, buf.byteLength);
    }
    /**
   * Return the Buffer representation of the public key in big endian
   */ toBuffer() {
        const b = this._bn.toArrayLike((0, $5ed0747d5916bbd8$export$a143d493d941bafc));
        if (b.length === $163ae62b92845c86$export$84fc0a248cc54343) return b;
        const zeroPad = (0, $5ed0747d5916bbd8$export$a143d493d941bafc).alloc(32);
        b.copy(zeroPad, 32 - b.length);
        return zeroPad;
    }
    get [$163ae62b92845c86$var$_Symbol$toStringTag]() {
        return `PublicKey(${this.toString()})`;
    }
    /**
   * Return the base-58 representation of the public key
   */ toString() {
        return this.toBase58();
    }
    /**
   * Derive a public key from another key, a seed, and a program ID.
   * The program ID will also serve as the owner of the public key, giving
   * it permission to write data to the account.
   */ /* eslint-disable require-await */ static async createWithSeed(fromPublicKey, seed, programId) {
        const buffer = (0, $5ed0747d5916bbd8$export$a143d493d941bafc).concat([
            fromPublicKey.toBuffer(),
            (0, $5ed0747d5916bbd8$export$a143d493d941bafc).from(seed),
            programId.toBuffer()
        ]);
        const publicKeyBytes = (0, $lrsL3.sha256)(buffer);
        return new $163ae62b92845c86$export$ca8b6604d6ce14de(publicKeyBytes);
    }
    /**
   * Derive a program address from seeds and a program ID.
   */ /* eslint-disable require-await */ static createProgramAddressSync(seeds, programId) {
        let buffer = (0, $5ed0747d5916bbd8$export$a143d493d941bafc).alloc(0);
        seeds.forEach(function(seed) {
            if (seed.length > $163ae62b92845c86$export$8240f9da84ad7873) throw new TypeError(`Max seed length exceeded`);
            buffer = (0, $5ed0747d5916bbd8$export$a143d493d941bafc).concat([
                buffer,
                $163ae62b92845c86$var$toBuffer(seed)
            ]);
        });
        buffer = (0, $5ed0747d5916bbd8$export$a143d493d941bafc).concat([
            buffer,
            programId.toBuffer(),
            (0, $5ed0747d5916bbd8$export$a143d493d941bafc).from("ProgramDerivedAddress")
        ]);
        const publicKeyBytes = (0, $lrsL3.sha256)(buffer);
        if ($163ae62b92845c86$var$isOnCurve(publicKeyBytes)) throw new Error(`Invalid seeds, address must fall off the curve`);
        return new $163ae62b92845c86$export$ca8b6604d6ce14de(publicKeyBytes);
    }
    /**
   * Async version of createProgramAddressSync
   * For backwards compatibility
   *
   * @deprecated Use {@link createProgramAddressSync} instead
   */ /* eslint-disable require-await */ static async createProgramAddress(seeds, programId) {
        return this.createProgramAddressSync(seeds, programId);
    }
    /**
   * Find a valid program address
   *
   * Valid program addresses must fall off the ed25519 curve.  This function
   * iterates a nonce until it finds one that when combined with the seeds
   * results in a valid program address.
   */ static findProgramAddressSync(seeds, programId) {
        let nonce = 255;
        let address;
        while(nonce != 0){
            try {
                const seedsWithNonce = seeds.concat((0, $5ed0747d5916bbd8$export$a143d493d941bafc).from([
                    nonce
                ]));
                address = this.createProgramAddressSync(seedsWithNonce, programId);
            } catch (err) {
                if (err instanceof TypeError) throw err;
                nonce--;
                continue;
            }
            return [
                address,
                nonce
            ];
        }
        throw new Error(`Unable to find a viable program address nonce`);
    }
    /**
   * Async version of findProgramAddressSync
   * For backwards compatibility
   *
   * @deprecated Use {@link findProgramAddressSync} instead
   */ static async findProgramAddress(seeds, programId) {
        return this.findProgramAddressSync(seeds, programId);
    }
    /**
   * Check that a pubkey is on the ed25519 curve.
   */ static isOnCurve(pubkeyData) {
        const pubkey = new $163ae62b92845c86$export$ca8b6604d6ce14de(pubkeyData);
        return $163ae62b92845c86$var$isOnCurve(pubkey.toBytes());
    }
}
$163ae62b92845c86$var$_class = $163ae62b92845c86$export$ca8b6604d6ce14de;
$163ae62b92845c86$export$ca8b6604d6ce14de.default = new $163ae62b92845c86$var$_class("11111111111111111111111111111111");
$163ae62b92845c86$export$68d13ce9b4cc48f3.set($163ae62b92845c86$export$ca8b6604d6ce14de, {
    kind: "struct",
    fields: [
        [
            "_bn",
            "u256"
        ]
    ]
});
/**
 * An account key pair (public and secret keys).
 *
 * @deprecated since v1.10.0, please use {@link Keypair} instead.
 */ class $163ae62b92845c86$export$1ed4b10e4aba04a7 {
    /**
   * Create a new Account object
   *
   * If the secretKey parameter is not provided a new key pair is randomly
   * created for the account
   *
   * @param secretKey Secret key for the account
   */ constructor(secretKey){
        /** @internal */ this._publicKey = void 0;
        /** @internal */ this._secretKey = void 0;
        if (secretKey) {
            const secretKeyBuffer = $163ae62b92845c86$var$toBuffer(secretKey);
            if (secretKey.length !== 64) throw new Error("bad secret key size");
            this._publicKey = secretKeyBuffer.slice(32, 64);
            this._secretKey = secretKeyBuffer.slice(0, 32);
        } else {
            this._secretKey = $163ae62b92845c86$var$toBuffer($163ae62b92845c86$var$generatePrivateKey());
            this._publicKey = $163ae62b92845c86$var$toBuffer($163ae62b92845c86$var$getPublicKey(this._secretKey));
        }
    }
    /**
   * The public key for this account
   */ get publicKey() {
        return new $163ae62b92845c86$export$ca8b6604d6ce14de(this._publicKey);
    }
    /**
   * The **unencrypted** secret key for this account. The first 32 bytes
   * is the private scalar and the last 32 bytes is the public key.
   * Read more: https://blog.mozilla.org/warner/2011/11/29/ed25519-keys/
   */ get secretKey() {
        return (0, $5ed0747d5916bbd8$export$a143d493d941bafc).concat([
            this._secretKey,
            this._publicKey
        ], 64);
    }
}
const $163ae62b92845c86$export$42bd37c1c64962b6 = new $163ae62b92845c86$export$ca8b6604d6ce14de("BPFLoader1111111111111111111111111111111111");
/**
 * Maximum over-the-wire size of a Transaction
 *
 * 1280 is IPv6 minimum MTU
 * 40 bytes is the size of the IPv6 header
 * 8 bytes is the size of the fragment header
 */ const $163ae62b92845c86$export$4c6d5b89e1596f26 = 1232;
const $163ae62b92845c86$export$3c3793d809f8b858 = 0x7f;
const $163ae62b92845c86$export$14aee086fde78fa6 = 64;
class $163ae62b92845c86$export$718fcd78527f88ed extends Error {
    constructor(signature){
        super(`Signature ${signature} has expired: block height exceeded.`);
        this.signature = void 0;
        this.signature = signature;
    }
}
Object.defineProperty($163ae62b92845c86$export$718fcd78527f88ed.prototype, "name", {
    value: "TransactionExpiredBlockheightExceededError"
});
class $163ae62b92845c86$export$b822204c22e46bdf extends Error {
    constructor(signature, timeoutSeconds){
        super(`Transaction was not confirmed in ${timeoutSeconds.toFixed(2)} seconds. It is ` + "unknown if it succeeded or failed. Check signature " + `${signature} using the Solana Explorer or CLI tools.`);
        this.signature = void 0;
        this.signature = signature;
    }
}
Object.defineProperty($163ae62b92845c86$export$b822204c22e46bdf.prototype, "name", {
    value: "TransactionExpiredTimeoutError"
});
class $163ae62b92845c86$export$a3e7565a95f5a1e5 extends Error {
    constructor(signature){
        super(`Signature ${signature} has expired: the nonce is no longer valid.`);
        this.signature = void 0;
        this.signature = signature;
    }
}
Object.defineProperty($163ae62b92845c86$export$a3e7565a95f5a1e5.prototype, "name", {
    value: "TransactionExpiredNonceInvalidError"
});
class $163ae62b92845c86$export$109914c107623102 {
    constructor(staticAccountKeys, accountKeysFromLookups){
        this.staticAccountKeys = void 0;
        this.accountKeysFromLookups = void 0;
        this.staticAccountKeys = staticAccountKeys;
        this.accountKeysFromLookups = accountKeysFromLookups;
    }
    keySegments() {
        const keySegments = [
            this.staticAccountKeys
        ];
        if (this.accountKeysFromLookups) {
            keySegments.push(this.accountKeysFromLookups.writable);
            keySegments.push(this.accountKeysFromLookups.readonly);
        }
        return keySegments;
    }
    get(index) {
        for (const keySegment of this.keySegments()){
            if (index < keySegment.length) return keySegment[index];
            else index -= keySegment.length;
        }
        return;
    }
    get length() {
        return this.keySegments().flat().length;
    }
    compileInstructions(instructions) {
        // Bail early if any account indexes would overflow a u8
        const U8_MAX = 255;
        if (this.length > U8_MAX + 1) throw new Error("Account index overflow encountered during compilation");
        const keyIndexMap = new Map();
        this.keySegments().flat().forEach((key, index)=>{
            keyIndexMap.set(key.toBase58(), index);
        });
        const findKeyIndex = (key)=>{
            const keyIndex = keyIndexMap.get(key.toBase58());
            if (keyIndex === undefined) throw new Error("Encountered an unknown instruction account key during compilation");
            return keyIndex;
        };
        return instructions.map((instruction)=>{
            return {
                programIdIndex: findKeyIndex(instruction.programId),
                accountKeyIndexes: instruction.keys.map((meta)=>findKeyIndex(meta.pubkey)),
                data: instruction.data
            };
        });
    }
}
/**
 * Layout for a public key
 */ const $163ae62b92845c86$var$publicKey = (property = "publicKey")=>{
    return $2913ed74210dce84$exports.blob(32, property);
};
/**
 * Layout for a signature
 */ const $163ae62b92845c86$var$signature = (property = "signature")=>{
    return $2913ed74210dce84$exports.blob(64, property);
};
/**
 * Layout for a Rust String type
 */ const $163ae62b92845c86$var$rustString = (property = "string")=>{
    const rsl = $2913ed74210dce84$exports.struct([
        $2913ed74210dce84$exports.u32("length"),
        $2913ed74210dce84$exports.u32("lengthPadding"),
        $2913ed74210dce84$exports.blob($2913ed74210dce84$exports.offset($2913ed74210dce84$exports.u32(), -8), "chars")
    ], property);
    const _decode = rsl.decode.bind(rsl);
    const _encode = rsl.encode.bind(rsl);
    const rslShim = rsl;
    rslShim.decode = (b, offset)=>{
        const data = _decode(b, offset);
        return data["chars"].toString();
    };
    rslShim.encode = (str, b, offset)=>{
        const data = {
            chars: (0, $5ed0747d5916bbd8$export$a143d493d941bafc).from(str, "utf8")
        };
        return _encode(data, b, offset);
    };
    rslShim.alloc = (str)=>{
        return $2913ed74210dce84$exports.u32().span + $2913ed74210dce84$exports.u32().span + (0, $5ed0747d5916bbd8$export$a143d493d941bafc).from(str, "utf8").length;
    };
    return rslShim;
};
/**
 * Layout for an Authorized object
 */ const $163ae62b92845c86$var$authorized = (property = "authorized")=>{
    return $2913ed74210dce84$exports.struct([
        $163ae62b92845c86$var$publicKey("staker"),
        $163ae62b92845c86$var$publicKey("withdrawer")
    ], property);
};
/**
 * Layout for a Lockup object
 */ const $163ae62b92845c86$var$lockup = (property = "lockup")=>{
    return $2913ed74210dce84$exports.struct([
        $2913ed74210dce84$exports.ns64("unixTimestamp"),
        $2913ed74210dce84$exports.ns64("epoch"),
        $163ae62b92845c86$var$publicKey("custodian")
    ], property);
};
/**
 *  Layout for a VoteInit object
 */ const $163ae62b92845c86$var$voteInit = (property = "voteInit")=>{
    return $2913ed74210dce84$exports.struct([
        $163ae62b92845c86$var$publicKey("nodePubkey"),
        $163ae62b92845c86$var$publicKey("authorizedVoter"),
        $163ae62b92845c86$var$publicKey("authorizedWithdrawer"),
        $2913ed74210dce84$exports.u8("commission")
    ], property);
};
/**
 *  Layout for a VoteAuthorizeWithSeedArgs object
 */ const $163ae62b92845c86$var$voteAuthorizeWithSeedArgs = (property = "voteAuthorizeWithSeedArgs")=>{
    return $2913ed74210dce84$exports.struct([
        $2913ed74210dce84$exports.u32("voteAuthorizationType"),
        $163ae62b92845c86$var$publicKey("currentAuthorityDerivedKeyOwnerPubkey"),
        $163ae62b92845c86$var$rustString("currentAuthorityDerivedKeySeed"),
        $163ae62b92845c86$var$publicKey("newAuthorized")
    ], property);
};
function $163ae62b92845c86$var$getAlloc(type, fields) {
    const getItemAlloc = (item)=>{
        if (item.span >= 0) return item.span;
        else if (typeof item.alloc === "function") return item.alloc(fields[item.property]);
        else if ("count" in item && "elementLayout" in item) {
            const field = fields[item.property];
            if (Array.isArray(field)) return field.length * getItemAlloc(item.elementLayout);
        } else if ("fields" in item) // This is a `Structure` whose size needs to be recursively measured.
        return $163ae62b92845c86$var$getAlloc({
            layout: item
        }, fields[item.property]);
        // Couldn't determine allocated size of layout
        return 0;
    };
    let alloc = 0;
    type.layout.fields.forEach((item)=>{
        alloc += getItemAlloc(item);
    });
    return alloc;
}
function $163ae62b92845c86$var$decodeLength(bytes) {
    let len = 0;
    let size = 0;
    for(;;){
        let elem = bytes.shift();
        len |= (elem & 0x7f) << size * 7;
        size += 1;
        if ((elem & 0x80) === 0) break;
    }
    return len;
}
function $163ae62b92845c86$var$encodeLength(bytes, len) {
    let rem_len = len;
    for(;;){
        let elem = rem_len & 0x7f;
        rem_len >>= 7;
        if (rem_len == 0) {
            bytes.push(elem);
            break;
        } else {
            elem |= 0x80;
            bytes.push(elem);
        }
    }
}
function $163ae62b92845c86$var$assert(condition, message) {
    if (!condition) throw new Error(message || "Assertion failed");
}
class $163ae62b92845c86$var$CompiledKeys {
    constructor(payer, keyMetaMap){
        this.payer = void 0;
        this.keyMetaMap = void 0;
        this.payer = payer;
        this.keyMetaMap = keyMetaMap;
    }
    static compile(instructions, payer) {
        const keyMetaMap = new Map();
        const getOrInsertDefault = (pubkey)=>{
            const address = pubkey.toBase58();
            let keyMeta = keyMetaMap.get(address);
            if (keyMeta === undefined) {
                keyMeta = {
                    isSigner: false,
                    isWritable: false,
                    isInvoked: false
                };
                keyMetaMap.set(address, keyMeta);
            }
            return keyMeta;
        };
        const payerKeyMeta = getOrInsertDefault(payer);
        payerKeyMeta.isSigner = true;
        payerKeyMeta.isWritable = true;
        for (const ix of instructions){
            getOrInsertDefault(ix.programId).isInvoked = true;
            for (const accountMeta of ix.keys){
                const keyMeta = getOrInsertDefault(accountMeta.pubkey);
                keyMeta.isSigner ||= accountMeta.isSigner;
                keyMeta.isWritable ||= accountMeta.isWritable;
            }
        }
        return new $163ae62b92845c86$var$CompiledKeys(payer, keyMetaMap);
    }
    getMessageComponents() {
        const mapEntries = [
            ...this.keyMetaMap.entries()
        ];
        $163ae62b92845c86$var$assert(mapEntries.length <= 256, "Max static account keys length exceeded");
        const writableSigners = mapEntries.filter(([, meta])=>meta.isSigner && meta.isWritable);
        const readonlySigners = mapEntries.filter(([, meta])=>meta.isSigner && !meta.isWritable);
        const writableNonSigners = mapEntries.filter(([, meta])=>!meta.isSigner && meta.isWritable);
        const readonlyNonSigners = mapEntries.filter(([, meta])=>!meta.isSigner && !meta.isWritable);
        const header = {
            numRequiredSignatures: writableSigners.length + readonlySigners.length,
            numReadonlySignedAccounts: readonlySigners.length,
            numReadonlyUnsignedAccounts: readonlyNonSigners.length
        };
        // sanity checks
        {
            $163ae62b92845c86$var$assert(writableSigners.length > 0, "Expected at least one writable signer key");
            const [payerAddress] = writableSigners[0];
            $163ae62b92845c86$var$assert(payerAddress === this.payer.toBase58(), "Expected first writable signer key to be the fee payer");
        }
        const staticAccountKeys = [
            ...writableSigners.map(([address])=>new $163ae62b92845c86$export$ca8b6604d6ce14de(address)),
            ...readonlySigners.map(([address])=>new $163ae62b92845c86$export$ca8b6604d6ce14de(address)),
            ...writableNonSigners.map(([address])=>new $163ae62b92845c86$export$ca8b6604d6ce14de(address)),
            ...readonlyNonSigners.map(([address])=>new $163ae62b92845c86$export$ca8b6604d6ce14de(address))
        ];
        return [
            header,
            staticAccountKeys
        ];
    }
    extractTableLookup(lookupTable) {
        const [writableIndexes, drainedWritableKeys] = this.drainKeysFoundInLookupTable(lookupTable.state.addresses, (keyMeta)=>!keyMeta.isSigner && !keyMeta.isInvoked && keyMeta.isWritable);
        const [readonlyIndexes, drainedReadonlyKeys] = this.drainKeysFoundInLookupTable(lookupTable.state.addresses, (keyMeta)=>!keyMeta.isSigner && !keyMeta.isInvoked && !keyMeta.isWritable);
        // Don't extract lookup if no keys were found
        if (writableIndexes.length === 0 && readonlyIndexes.length === 0) return;
        return [
            {
                accountKey: lookupTable.key,
                writableIndexes: writableIndexes,
                readonlyIndexes: readonlyIndexes
            },
            {
                writable: drainedWritableKeys,
                readonly: drainedReadonlyKeys
            }
        ];
    }
    /** @internal */ drainKeysFoundInLookupTable(lookupTableEntries, keyMetaFilter) {
        const lookupTableIndexes = new Array();
        const drainedKeys = new Array();
        for (const [address, keyMeta] of this.keyMetaMap.entries())if (keyMetaFilter(keyMeta)) {
            const key = new $163ae62b92845c86$export$ca8b6604d6ce14de(address);
            const lookupTableIndex = lookupTableEntries.findIndex((entry)=>entry.equals(key));
            if (lookupTableIndex >= 0) {
                $163ae62b92845c86$var$assert(lookupTableIndex < 256, "Max lookup table index exceeded");
                lookupTableIndexes.push(lookupTableIndex);
                drainedKeys.push(key);
                this.keyMetaMap.delete(address);
            }
        }
        return [
            lookupTableIndexes,
            drainedKeys
        ];
    }
}
/**
 * An instruction to execute by a program
 *
 * @property {number} programIdIndex
 * @property {number[]} accounts
 * @property {string} data
 */ /**
 * Message constructor arguments
 */ /**
 * List of instructions to be processed atomically
 */ class $163ae62b92845c86$export$f69c19e57285b83a {
    constructor(args){
        this.header = void 0;
        this.accountKeys = void 0;
        this.recentBlockhash = void 0;
        this.instructions = void 0;
        this.indexToProgramIds = new Map();
        this.header = args.header;
        this.accountKeys = args.accountKeys.map((account)=>new $163ae62b92845c86$export$ca8b6604d6ce14de(account));
        this.recentBlockhash = args.recentBlockhash;
        this.instructions = args.instructions;
        this.instructions.forEach((ix)=>this.indexToProgramIds.set(ix.programIdIndex, this.accountKeys[ix.programIdIndex]));
    }
    get version() {
        return "legacy";
    }
    get staticAccountKeys() {
        return this.accountKeys;
    }
    get compiledInstructions() {
        return this.instructions.map((ix)=>({
                programIdIndex: ix.programIdIndex,
                accountKeyIndexes: ix.accounts,
                data: (0, (/*@__PURE__*/$parcel$interopDefault($hZS7n))).decode(ix.data)
            }));
    }
    get addressTableLookups() {
        return [];
    }
    getAccountKeys() {
        return new $163ae62b92845c86$export$109914c107623102(this.staticAccountKeys);
    }
    static compile(args) {
        const compiledKeys = $163ae62b92845c86$var$CompiledKeys.compile(args.instructions, args.payerKey);
        const [header, staticAccountKeys] = compiledKeys.getMessageComponents();
        const accountKeys = new $163ae62b92845c86$export$109914c107623102(staticAccountKeys);
        const instructions = accountKeys.compileInstructions(args.instructions).map((ix)=>({
                programIdIndex: ix.programIdIndex,
                accounts: ix.accountKeyIndexes,
                data: (0, (/*@__PURE__*/$parcel$interopDefault($hZS7n))).encode(ix.data)
            }));
        return new $163ae62b92845c86$export$f69c19e57285b83a({
            header: header,
            accountKeys: staticAccountKeys,
            recentBlockhash: args.recentBlockhash,
            instructions: instructions
        });
    }
    isAccountSigner(index) {
        return index < this.header.numRequiredSignatures;
    }
    isAccountWritable(index) {
        const numSignedAccounts = this.header.numRequiredSignatures;
        if (index >= this.header.numRequiredSignatures) {
            const unsignedAccountIndex = index - numSignedAccounts;
            const numUnsignedAccounts = this.accountKeys.length - numSignedAccounts;
            const numWritableUnsignedAccounts = numUnsignedAccounts - this.header.numReadonlyUnsignedAccounts;
            return unsignedAccountIndex < numWritableUnsignedAccounts;
        } else {
            const numWritableSignedAccounts = numSignedAccounts - this.header.numReadonlySignedAccounts;
            return index < numWritableSignedAccounts;
        }
    }
    isProgramId(index) {
        return this.indexToProgramIds.has(index);
    }
    programIds() {
        return [
            ...this.indexToProgramIds.values()
        ];
    }
    nonProgramIds() {
        return this.accountKeys.filter((_, index)=>!this.isProgramId(index));
    }
    serialize() {
        const numKeys = this.accountKeys.length;
        let keyCount = [];
        $163ae62b92845c86$var$encodeLength(keyCount, numKeys);
        const instructions = this.instructions.map((instruction)=>{
            const { accounts: accounts, programIdIndex: programIdIndex } = instruction;
            const data = Array.from((0, (/*@__PURE__*/$parcel$interopDefault($hZS7n))).decode(instruction.data));
            let keyIndicesCount = [];
            $163ae62b92845c86$var$encodeLength(keyIndicesCount, accounts.length);
            let dataCount = [];
            $163ae62b92845c86$var$encodeLength(dataCount, data.length);
            return {
                programIdIndex: programIdIndex,
                keyIndicesCount: (0, $5ed0747d5916bbd8$export$a143d493d941bafc).from(keyIndicesCount),
                keyIndices: accounts,
                dataLength: (0, $5ed0747d5916bbd8$export$a143d493d941bafc).from(dataCount),
                data: data
            };
        });
        let instructionCount = [];
        $163ae62b92845c86$var$encodeLength(instructionCount, instructions.length);
        let instructionBuffer = (0, $5ed0747d5916bbd8$export$a143d493d941bafc).alloc($163ae62b92845c86$export$4c6d5b89e1596f26);
        (0, $5ed0747d5916bbd8$export$a143d493d941bafc).from(instructionCount).copy(instructionBuffer);
        let instructionBufferLength = instructionCount.length;
        instructions.forEach((instruction)=>{
            const instructionLayout = $2913ed74210dce84$exports.struct([
                $2913ed74210dce84$exports.u8("programIdIndex"),
                $2913ed74210dce84$exports.blob(instruction.keyIndicesCount.length, "keyIndicesCount"),
                $2913ed74210dce84$exports.seq($2913ed74210dce84$exports.u8("keyIndex"), instruction.keyIndices.length, "keyIndices"),
                $2913ed74210dce84$exports.blob(instruction.dataLength.length, "dataLength"),
                $2913ed74210dce84$exports.seq($2913ed74210dce84$exports.u8("userdatum"), instruction.data.length, "data")
            ]);
            const length = instructionLayout.encode(instruction, instructionBuffer, instructionBufferLength);
            instructionBufferLength += length;
        });
        instructionBuffer = instructionBuffer.slice(0, instructionBufferLength);
        const signDataLayout = $2913ed74210dce84$exports.struct([
            $2913ed74210dce84$exports.blob(1, "numRequiredSignatures"),
            $2913ed74210dce84$exports.blob(1, "numReadonlySignedAccounts"),
            $2913ed74210dce84$exports.blob(1, "numReadonlyUnsignedAccounts"),
            $2913ed74210dce84$exports.blob(keyCount.length, "keyCount"),
            $2913ed74210dce84$exports.seq($163ae62b92845c86$var$publicKey("key"), numKeys, "keys"),
            $163ae62b92845c86$var$publicKey("recentBlockhash")
        ]);
        const transaction = {
            numRequiredSignatures: (0, $5ed0747d5916bbd8$export$a143d493d941bafc).from([
                this.header.numRequiredSignatures
            ]),
            numReadonlySignedAccounts: (0, $5ed0747d5916bbd8$export$a143d493d941bafc).from([
                this.header.numReadonlySignedAccounts
            ]),
            numReadonlyUnsignedAccounts: (0, $5ed0747d5916bbd8$export$a143d493d941bafc).from([
                this.header.numReadonlyUnsignedAccounts
            ]),
            keyCount: (0, $5ed0747d5916bbd8$export$a143d493d941bafc).from(keyCount),
            keys: this.accountKeys.map((key)=>$163ae62b92845c86$var$toBuffer(key.toBytes())),
            recentBlockhash: (0, (/*@__PURE__*/$parcel$interopDefault($hZS7n))).decode(this.recentBlockhash)
        };
        let signData = (0, $5ed0747d5916bbd8$export$a143d493d941bafc).alloc(2048);
        const length = signDataLayout.encode(transaction, signData);
        instructionBuffer.copy(signData, length);
        return signData.slice(0, length + instructionBuffer.length);
    }
    /**
   * Decode a compiled message into a Message object.
   */ static from(buffer) {
        // Slice up wire data
        let byteArray = [
            ...buffer
        ];
        const numRequiredSignatures = byteArray.shift();
        if (numRequiredSignatures !== (numRequiredSignatures & $163ae62b92845c86$export$3c3793d809f8b858)) throw new Error("Versioned messages must be deserialized with VersionedMessage.deserialize()");
        const numReadonlySignedAccounts = byteArray.shift();
        const numReadonlyUnsignedAccounts = byteArray.shift();
        const accountCount = $163ae62b92845c86$var$decodeLength(byteArray);
        let accountKeys = [];
        for(let i = 0; i < accountCount; i++){
            const account = byteArray.slice(0, $163ae62b92845c86$export$84fc0a248cc54343);
            byteArray = byteArray.slice($163ae62b92845c86$export$84fc0a248cc54343);
            accountKeys.push(new $163ae62b92845c86$export$ca8b6604d6ce14de((0, $5ed0747d5916bbd8$export$a143d493d941bafc).from(account)));
        }
        const recentBlockhash = byteArray.slice(0, $163ae62b92845c86$export$84fc0a248cc54343);
        byteArray = byteArray.slice($163ae62b92845c86$export$84fc0a248cc54343);
        const instructionCount = $163ae62b92845c86$var$decodeLength(byteArray);
        let instructions = [];
        for(let i = 0; i < instructionCount; i++){
            const programIdIndex = byteArray.shift();
            const accountCount = $163ae62b92845c86$var$decodeLength(byteArray);
            const accounts = byteArray.slice(0, accountCount);
            byteArray = byteArray.slice(accountCount);
            const dataLength = $163ae62b92845c86$var$decodeLength(byteArray);
            const dataSlice = byteArray.slice(0, dataLength);
            const data = (0, (/*@__PURE__*/$parcel$interopDefault($hZS7n))).encode((0, $5ed0747d5916bbd8$export$a143d493d941bafc).from(dataSlice));
            byteArray = byteArray.slice(dataLength);
            instructions.push({
                programIdIndex: programIdIndex,
                accounts: accounts,
                data: data
            });
        }
        const messageArgs = {
            header: {
                numRequiredSignatures: numRequiredSignatures,
                numReadonlySignedAccounts: numReadonlySignedAccounts,
                numReadonlyUnsignedAccounts: numReadonlyUnsignedAccounts
            },
            recentBlockhash: (0, (/*@__PURE__*/$parcel$interopDefault($hZS7n))).encode((0, $5ed0747d5916bbd8$export$a143d493d941bafc).from(recentBlockhash)),
            accountKeys: accountKeys,
            instructions: instructions
        };
        return new $163ae62b92845c86$export$f69c19e57285b83a(messageArgs);
    }
}
/**
 * Message constructor arguments
 */ class $163ae62b92845c86$export$ee274c70e0fae590 {
    constructor(args){
        this.header = void 0;
        this.staticAccountKeys = void 0;
        this.recentBlockhash = void 0;
        this.compiledInstructions = void 0;
        this.addressTableLookups = void 0;
        this.header = args.header;
        this.staticAccountKeys = args.staticAccountKeys;
        this.recentBlockhash = args.recentBlockhash;
        this.compiledInstructions = args.compiledInstructions;
        this.addressTableLookups = args.addressTableLookups;
    }
    get version() {
        return 0;
    }
    get numAccountKeysFromLookups() {
        let count = 0;
        for (const lookup of this.addressTableLookups)count += lookup.readonlyIndexes.length + lookup.writableIndexes.length;
        return count;
    }
    getAccountKeys(args) {
        let accountKeysFromLookups;
        if (args && "accountKeysFromLookups" in args && args.accountKeysFromLookups) {
            if (this.numAccountKeysFromLookups != args.accountKeysFromLookups.writable.length + args.accountKeysFromLookups.readonly.length) throw new Error("Failed to get account keys because of a mismatch in the number of account keys from lookups");
            accountKeysFromLookups = args.accountKeysFromLookups;
        } else if (args && "addressLookupTableAccounts" in args && args.addressLookupTableAccounts) accountKeysFromLookups = this.resolveAddressTableLookups(args.addressLookupTableAccounts);
        else if (this.addressTableLookups.length > 0) throw new Error("Failed to get account keys because address table lookups were not resolved");
        return new $163ae62b92845c86$export$109914c107623102(this.staticAccountKeys, accountKeysFromLookups);
    }
    isAccountSigner(index) {
        return index < this.header.numRequiredSignatures;
    }
    isAccountWritable(index) {
        const numSignedAccounts = this.header.numRequiredSignatures;
        const numStaticAccountKeys = this.staticAccountKeys.length;
        if (index >= numStaticAccountKeys) {
            const lookupAccountKeysIndex = index - numStaticAccountKeys;
            const numWritableLookupAccountKeys = this.addressTableLookups.reduce((count, lookup)=>count + lookup.writableIndexes.length, 0);
            return lookupAccountKeysIndex < numWritableLookupAccountKeys;
        } else if (index >= this.header.numRequiredSignatures) {
            const unsignedAccountIndex = index - numSignedAccounts;
            const numUnsignedAccounts = numStaticAccountKeys - numSignedAccounts;
            const numWritableUnsignedAccounts = numUnsignedAccounts - this.header.numReadonlyUnsignedAccounts;
            return unsignedAccountIndex < numWritableUnsignedAccounts;
        } else {
            const numWritableSignedAccounts = numSignedAccounts - this.header.numReadonlySignedAccounts;
            return index < numWritableSignedAccounts;
        }
    }
    resolveAddressTableLookups(addressLookupTableAccounts) {
        const accountKeysFromLookups = {
            writable: [],
            readonly: []
        };
        for (const tableLookup of this.addressTableLookups){
            const tableAccount = addressLookupTableAccounts.find((account)=>account.key.equals(tableLookup.accountKey));
            if (!tableAccount) throw new Error(`Failed to find address lookup table account for table key ${tableLookup.accountKey.toBase58()}`);
            for (const index of tableLookup.writableIndexes){
                if (index < tableAccount.state.addresses.length) accountKeysFromLookups.writable.push(tableAccount.state.addresses[index]);
                else throw new Error(`Failed to find address for index ${index} in address lookup table ${tableLookup.accountKey.toBase58()}`);
            }
            for (const index of tableLookup.readonlyIndexes){
                if (index < tableAccount.state.addresses.length) accountKeysFromLookups.readonly.push(tableAccount.state.addresses[index]);
                else throw new Error(`Failed to find address for index ${index} in address lookup table ${tableLookup.accountKey.toBase58()}`);
            }
        }
        return accountKeysFromLookups;
    }
    static compile(args) {
        const compiledKeys = $163ae62b92845c86$var$CompiledKeys.compile(args.instructions, args.payerKey);
        const addressTableLookups = new Array();
        const accountKeysFromLookups = {
            writable: new Array(),
            readonly: new Array()
        };
        const lookupTableAccounts = args.addressLookupTableAccounts || [];
        for (const lookupTable of lookupTableAccounts){
            const extractResult = compiledKeys.extractTableLookup(lookupTable);
            if (extractResult !== undefined) {
                const [addressTableLookup, { writable: writable, readonly: readonly }] = extractResult;
                addressTableLookups.push(addressTableLookup);
                accountKeysFromLookups.writable.push(...writable);
                accountKeysFromLookups.readonly.push(...readonly);
            }
        }
        const [header, staticAccountKeys] = compiledKeys.getMessageComponents();
        const accountKeys = new $163ae62b92845c86$export$109914c107623102(staticAccountKeys, accountKeysFromLookups);
        const compiledInstructions = accountKeys.compileInstructions(args.instructions);
        return new $163ae62b92845c86$export$ee274c70e0fae590({
            header: header,
            staticAccountKeys: staticAccountKeys,
            recentBlockhash: args.recentBlockhash,
            compiledInstructions: compiledInstructions,
            addressTableLookups: addressTableLookups
        });
    }
    serialize() {
        const encodedStaticAccountKeysLength = Array();
        $163ae62b92845c86$var$encodeLength(encodedStaticAccountKeysLength, this.staticAccountKeys.length);
        const serializedInstructions = this.serializeInstructions();
        const encodedInstructionsLength = Array();
        $163ae62b92845c86$var$encodeLength(encodedInstructionsLength, this.compiledInstructions.length);
        const serializedAddressTableLookups = this.serializeAddressTableLookups();
        const encodedAddressTableLookupsLength = Array();
        $163ae62b92845c86$var$encodeLength(encodedAddressTableLookupsLength, this.addressTableLookups.length);
        const messageLayout = $2913ed74210dce84$exports.struct([
            $2913ed74210dce84$exports.u8("prefix"),
            $2913ed74210dce84$exports.struct([
                $2913ed74210dce84$exports.u8("numRequiredSignatures"),
                $2913ed74210dce84$exports.u8("numReadonlySignedAccounts"),
                $2913ed74210dce84$exports.u8("numReadonlyUnsignedAccounts")
            ], "header"),
            $2913ed74210dce84$exports.blob(encodedStaticAccountKeysLength.length, "staticAccountKeysLength"),
            $2913ed74210dce84$exports.seq($163ae62b92845c86$var$publicKey(), this.staticAccountKeys.length, "staticAccountKeys"),
            $163ae62b92845c86$var$publicKey("recentBlockhash"),
            $2913ed74210dce84$exports.blob(encodedInstructionsLength.length, "instructionsLength"),
            $2913ed74210dce84$exports.blob(serializedInstructions.length, "serializedInstructions"),
            $2913ed74210dce84$exports.blob(encodedAddressTableLookupsLength.length, "addressTableLookupsLength"),
            $2913ed74210dce84$exports.blob(serializedAddressTableLookups.length, "serializedAddressTableLookups")
        ]);
        const serializedMessage = new Uint8Array($163ae62b92845c86$export$4c6d5b89e1596f26);
        const MESSAGE_VERSION_0_PREFIX = 128;
        const serializedMessageLength = messageLayout.encode({
            prefix: MESSAGE_VERSION_0_PREFIX,
            header: this.header,
            staticAccountKeysLength: new Uint8Array(encodedStaticAccountKeysLength),
            staticAccountKeys: this.staticAccountKeys.map((key)=>key.toBytes()),
            recentBlockhash: (0, (/*@__PURE__*/$parcel$interopDefault($hZS7n))).decode(this.recentBlockhash),
            instructionsLength: new Uint8Array(encodedInstructionsLength),
            serializedInstructions: serializedInstructions,
            addressTableLookupsLength: new Uint8Array(encodedAddressTableLookupsLength),
            serializedAddressTableLookups: serializedAddressTableLookups
        }, serializedMessage);
        return serializedMessage.slice(0, serializedMessageLength);
    }
    serializeInstructions() {
        let serializedLength = 0;
        const serializedInstructions = new Uint8Array($163ae62b92845c86$export$4c6d5b89e1596f26);
        for (const instruction of this.compiledInstructions){
            const encodedAccountKeyIndexesLength = Array();
            $163ae62b92845c86$var$encodeLength(encodedAccountKeyIndexesLength, instruction.accountKeyIndexes.length);
            const encodedDataLength = Array();
            $163ae62b92845c86$var$encodeLength(encodedDataLength, instruction.data.length);
            const instructionLayout = $2913ed74210dce84$exports.struct([
                $2913ed74210dce84$exports.u8("programIdIndex"),
                $2913ed74210dce84$exports.blob(encodedAccountKeyIndexesLength.length, "encodedAccountKeyIndexesLength"),
                $2913ed74210dce84$exports.seq($2913ed74210dce84$exports.u8(), instruction.accountKeyIndexes.length, "accountKeyIndexes"),
                $2913ed74210dce84$exports.blob(encodedDataLength.length, "encodedDataLength"),
                $2913ed74210dce84$exports.blob(instruction.data.length, "data")
            ]);
            serializedLength += instructionLayout.encode({
                programIdIndex: instruction.programIdIndex,
                encodedAccountKeyIndexesLength: new Uint8Array(encodedAccountKeyIndexesLength),
                accountKeyIndexes: instruction.accountKeyIndexes,
                encodedDataLength: new Uint8Array(encodedDataLength),
                data: instruction.data
            }, serializedInstructions, serializedLength);
        }
        return serializedInstructions.slice(0, serializedLength);
    }
    serializeAddressTableLookups() {
        let serializedLength = 0;
        const serializedAddressTableLookups = new Uint8Array($163ae62b92845c86$export$4c6d5b89e1596f26);
        for (const lookup of this.addressTableLookups){
            const encodedWritableIndexesLength = Array();
            $163ae62b92845c86$var$encodeLength(encodedWritableIndexesLength, lookup.writableIndexes.length);
            const encodedReadonlyIndexesLength = Array();
            $163ae62b92845c86$var$encodeLength(encodedReadonlyIndexesLength, lookup.readonlyIndexes.length);
            const addressTableLookupLayout = $2913ed74210dce84$exports.struct([
                $163ae62b92845c86$var$publicKey("accountKey"),
                $2913ed74210dce84$exports.blob(encodedWritableIndexesLength.length, "encodedWritableIndexesLength"),
                $2913ed74210dce84$exports.seq($2913ed74210dce84$exports.u8(), lookup.writableIndexes.length, "writableIndexes"),
                $2913ed74210dce84$exports.blob(encodedReadonlyIndexesLength.length, "encodedReadonlyIndexesLength"),
                $2913ed74210dce84$exports.seq($2913ed74210dce84$exports.u8(), lookup.readonlyIndexes.length, "readonlyIndexes")
            ]);
            serializedLength += addressTableLookupLayout.encode({
                accountKey: lookup.accountKey.toBytes(),
                encodedWritableIndexesLength: new Uint8Array(encodedWritableIndexesLength),
                writableIndexes: lookup.writableIndexes,
                encodedReadonlyIndexesLength: new Uint8Array(encodedReadonlyIndexesLength),
                readonlyIndexes: lookup.readonlyIndexes
            }, serializedAddressTableLookups, serializedLength);
        }
        return serializedAddressTableLookups.slice(0, serializedLength);
    }
    static deserialize(serializedMessage) {
        let byteArray = [
            ...serializedMessage
        ];
        const prefix = byteArray.shift();
        const maskedPrefix = prefix & $163ae62b92845c86$export$3c3793d809f8b858;
        $163ae62b92845c86$var$assert(prefix !== maskedPrefix, `Expected versioned message but received legacy message`);
        const version = maskedPrefix;
        $163ae62b92845c86$var$assert(version === 0, `Expected versioned message with version 0 but found version ${version}`);
        const header = {
            numRequiredSignatures: byteArray.shift(),
            numReadonlySignedAccounts: byteArray.shift(),
            numReadonlyUnsignedAccounts: byteArray.shift()
        };
        const staticAccountKeys = [];
        const staticAccountKeysLength = $163ae62b92845c86$var$decodeLength(byteArray);
        for(let i = 0; i < staticAccountKeysLength; i++)staticAccountKeys.push(new $163ae62b92845c86$export$ca8b6604d6ce14de(byteArray.splice(0, $163ae62b92845c86$export$84fc0a248cc54343)));
        const recentBlockhash = (0, (/*@__PURE__*/$parcel$interopDefault($hZS7n))).encode(byteArray.splice(0, $163ae62b92845c86$export$84fc0a248cc54343));
        const instructionCount = $163ae62b92845c86$var$decodeLength(byteArray);
        const compiledInstructions = [];
        for(let i = 0; i < instructionCount; i++){
            const programIdIndex = byteArray.shift();
            const accountKeyIndexesLength = $163ae62b92845c86$var$decodeLength(byteArray);
            const accountKeyIndexes = byteArray.splice(0, accountKeyIndexesLength);
            const dataLength = $163ae62b92845c86$var$decodeLength(byteArray);
            const data = new Uint8Array(byteArray.splice(0, dataLength));
            compiledInstructions.push({
                programIdIndex: programIdIndex,
                accountKeyIndexes: accountKeyIndexes,
                data: data
            });
        }
        const addressTableLookupsCount = $163ae62b92845c86$var$decodeLength(byteArray);
        const addressTableLookups = [];
        for(let i = 0; i < addressTableLookupsCount; i++){
            const accountKey = new $163ae62b92845c86$export$ca8b6604d6ce14de(byteArray.splice(0, $163ae62b92845c86$export$84fc0a248cc54343));
            const writableIndexesLength = $163ae62b92845c86$var$decodeLength(byteArray);
            const writableIndexes = byteArray.splice(0, writableIndexesLength);
            const readonlyIndexesLength = $163ae62b92845c86$var$decodeLength(byteArray);
            const readonlyIndexes = byteArray.splice(0, readonlyIndexesLength);
            addressTableLookups.push({
                accountKey: accountKey,
                writableIndexes: writableIndexes,
                readonlyIndexes: readonlyIndexes
            });
        }
        return new $163ae62b92845c86$export$ee274c70e0fae590({
            header: header,
            staticAccountKeys: staticAccountKeys,
            recentBlockhash: recentBlockhash,
            compiledInstructions: compiledInstructions,
            addressTableLookups: addressTableLookups
        });
    }
}
// eslint-disable-next-line no-redeclare
const $163ae62b92845c86$export$b0a61927d00ede7f = {
    deserializeMessageVersion (serializedMessage) {
        const prefix = serializedMessage[0];
        const maskedPrefix = prefix & $163ae62b92845c86$export$3c3793d809f8b858;
        // if the highest bit of the prefix is not set, the message is not versioned
        if (maskedPrefix === prefix) return "legacy";
        // the lower 7 bits of the prefix indicate the message version
        return maskedPrefix;
    },
    deserialize: (serializedMessage)=>{
        const version = $163ae62b92845c86$export$b0a61927d00ede7f.deserializeMessageVersion(serializedMessage);
        if (version === "legacy") return $163ae62b92845c86$export$f69c19e57285b83a.from(serializedMessage);
        if (version === 0) return $163ae62b92845c86$export$ee274c70e0fae590.deserialize(serializedMessage);
        else throw new Error(`Transaction message version ${version} deserialization is not supported`);
    }
};
/** @internal */ /**
 * Transaction signature as base-58 encoded string
 */ let $163ae62b92845c86$export$7c391bd3b61d2374 = /*#__PURE__*/ function(TransactionStatus) {
    TransactionStatus[TransactionStatus["BLOCKHEIGHT_EXCEEDED"] = 0] = "BLOCKHEIGHT_EXCEEDED";
    TransactionStatus[TransactionStatus["PROCESSED"] = 1] = "PROCESSED";
    TransactionStatus[TransactionStatus["TIMED_OUT"] = 2] = "TIMED_OUT";
    TransactionStatus[TransactionStatus["NONCE_INVALID"] = 3] = "NONCE_INVALID";
    return TransactionStatus;
}({});
/**
 * Default (empty) signature
 */ const $163ae62b92845c86$var$DEFAULT_SIGNATURE = (0, $5ed0747d5916bbd8$export$a143d493d941bafc).alloc($163ae62b92845c86$export$14aee086fde78fa6).fill(0);
/**
 * Account metadata used to define instructions
 */ /**
 * List of TransactionInstruction object fields that may be initialized at construction
 */ /**
 * Configuration object for Transaction.serialize()
 */ /**
 * @internal
 */ /**
 * Transaction Instruction class
 */ class $163ae62b92845c86$export$a7a3aa8360ac9f59 {
    constructor(opts){
        /**
     * Public keys to include in this transaction
     * Boolean represents whether this pubkey needs to sign the transaction
     */ this.keys = void 0;
        /**
     * Program Id to execute
     */ this.programId = void 0;
        /**
     * Program input
     */ this.data = (0, $5ed0747d5916bbd8$export$a143d493d941bafc).alloc(0);
        this.programId = opts.programId;
        this.keys = opts.keys;
        if (opts.data) this.data = opts.data;
    }
    /**
   * @internal
   */ toJSON() {
        return {
            keys: this.keys.map(({ pubkey: pubkey, isSigner: isSigner, isWritable: isWritable })=>({
                    pubkey: pubkey.toJSON(),
                    isSigner: isSigner,
                    isWritable: isWritable
                })),
            programId: this.programId.toJSON(),
            data: [
                ...this.data
            ]
        };
    }
}
/**
 * Pair of signature and corresponding public key
 */ /**
 * List of Transaction object fields that may be initialized at construction
 */ // For backward compatibility; an unfortunate consequence of being
// forced to over-export types by the documentation generator.
// See https://github.com/solana-labs/solana/pull/25820
/**
 * Blockhash-based transactions have a lifetime that are defined by
 * the blockhash they include. Any transaction whose blockhash is
 * too old will be rejected.
 */ /**
 * Use these options to construct a durable nonce transaction.
 */ /**
 * Nonce information to be used to build an offline Transaction.
 */ /**
 * @internal
 */ /**
 * Transaction class
 */ class $163ae62b92845c86$export$febc5573c75cefb0 {
    /**
   * The first (payer) Transaction signature
   *
   * @returns {Buffer | null} Buffer of payer's signature
   */ get signature() {
        if (this.signatures.length > 0) return this.signatures[0].signature;
        return null;
    }
    /**
   * The transaction fee payer
   */ // Construct a transaction with a blockhash and lastValidBlockHeight
    // Construct a transaction using a durable nonce
    /**
   * @deprecated `TransactionCtorFields` has been deprecated and will be removed in a future version.
   * Please supply a `TransactionBlockhashCtor` instead.
   */ /**
   * Construct an empty Transaction
   */ constructor(opts){
        /**
     * Signatures for the transaction.  Typically created by invoking the
     * `sign()` method
     */ this.signatures = [];
        this.feePayer = void 0;
        /**
     * The instructions to atomically execute
     */ this.instructions = [];
        /**
     * A recent transaction id. Must be populated by the caller
     */ this.recentBlockhash = void 0;
        /**
     * the last block chain can advance to before tx is declared expired
     * */ this.lastValidBlockHeight = void 0;
        /**
     * Optional Nonce information. If populated, transaction will use a durable
     * Nonce hash instead of a recentBlockhash. Must be populated by the caller
     */ this.nonceInfo = void 0;
        /**
     * If this is a nonce transaction this represents the minimum slot from which
     * to evaluate if the nonce has advanced when attempting to confirm the
     * transaction. This protects against a case where the transaction confirmation
     * logic loads the nonce account from an old slot and assumes the mismatch in
     * nonce value implies that the nonce has been advanced.
     */ this.minNonceContextSlot = void 0;
        /**
     * @internal
     */ this._message = void 0;
        /**
     * @internal
     */ this._json = void 0;
        if (!opts) return;
        if (opts.feePayer) this.feePayer = opts.feePayer;
        if (opts.signatures) this.signatures = opts.signatures;
        if (Object.prototype.hasOwnProperty.call(opts, "nonceInfo")) {
            const { minContextSlot: minContextSlot, nonceInfo: nonceInfo } = opts;
            this.minNonceContextSlot = minContextSlot;
            this.nonceInfo = nonceInfo;
        } else if (Object.prototype.hasOwnProperty.call(opts, "lastValidBlockHeight")) {
            const { blockhash: blockhash, lastValidBlockHeight: lastValidBlockHeight } = opts;
            this.recentBlockhash = blockhash;
            this.lastValidBlockHeight = lastValidBlockHeight;
        } else {
            const { recentBlockhash: recentBlockhash, nonceInfo: nonceInfo } = opts;
            if (nonceInfo) this.nonceInfo = nonceInfo;
            this.recentBlockhash = recentBlockhash;
        }
    }
    /**
   * @internal
   */ toJSON() {
        return {
            recentBlockhash: this.recentBlockhash || null,
            feePayer: this.feePayer ? this.feePayer.toJSON() : null,
            nonceInfo: this.nonceInfo ? {
                nonce: this.nonceInfo.nonce,
                nonceInstruction: this.nonceInfo.nonceInstruction.toJSON()
            } : null,
            instructions: this.instructions.map((instruction)=>instruction.toJSON()),
            signers: this.signatures.map(({ publicKey: publicKey })=>{
                return publicKey.toJSON();
            })
        };
    }
    /**
   * Add one or more instructions to this Transaction
   *
   * @param {Array< Transaction | TransactionInstruction | TransactionInstructionCtorFields >} items - Instructions to add to the Transaction
   */ add(...items) {
        if (items.length === 0) throw new Error("No instructions");
        items.forEach((item)=>{
            if ("instructions" in item) this.instructions = this.instructions.concat(item.instructions);
            else if ("data" in item && "programId" in item && "keys" in item) this.instructions.push(item);
            else this.instructions.push(new $163ae62b92845c86$export$a7a3aa8360ac9f59(item));
        });
        return this;
    }
    /**
   * Compile transaction data
   */ compileMessage() {
        if (this._message && JSON.stringify(this.toJSON()) === JSON.stringify(this._json)) return this._message;
        let recentBlockhash;
        let instructions;
        if (this.nonceInfo) {
            recentBlockhash = this.nonceInfo.nonce;
            if (this.instructions[0] != this.nonceInfo.nonceInstruction) instructions = [
                this.nonceInfo.nonceInstruction,
                ...this.instructions
            ];
            else instructions = this.instructions;
        } else {
            recentBlockhash = this.recentBlockhash;
            instructions = this.instructions;
        }
        if (!recentBlockhash) throw new Error("Transaction recentBlockhash required");
        if (instructions.length < 1) console.warn("No instructions provided");
        let feePayer;
        if (this.feePayer) feePayer = this.feePayer;
        else if (this.signatures.length > 0 && this.signatures[0].publicKey) // Use implicit fee payer
        feePayer = this.signatures[0].publicKey;
        else throw new Error("Transaction fee payer required");
        for(let i = 0; i < instructions.length; i++){
            if (instructions[i].programId === undefined) throw new Error(`Transaction instruction index ${i} has undefined program id`);
        }
        const programIds = [];
        const accountMetas = [];
        instructions.forEach((instruction)=>{
            instruction.keys.forEach((accountMeta)=>{
                accountMetas.push({
                    ...accountMeta
                });
            });
            const programId = instruction.programId.toString();
            if (!programIds.includes(programId)) programIds.push(programId);
        });
        // Append programID account metas
        programIds.forEach((programId)=>{
            accountMetas.push({
                pubkey: new $163ae62b92845c86$export$ca8b6604d6ce14de(programId),
                isSigner: false,
                isWritable: false
            });
        });
        // Cull duplicate account metas
        const uniqueMetas = [];
        accountMetas.forEach((accountMeta)=>{
            const pubkeyString = accountMeta.pubkey.toString();
            const uniqueIndex = uniqueMetas.findIndex((x)=>{
                return x.pubkey.toString() === pubkeyString;
            });
            if (uniqueIndex > -1) {
                uniqueMetas[uniqueIndex].isWritable = uniqueMetas[uniqueIndex].isWritable || accountMeta.isWritable;
                uniqueMetas[uniqueIndex].isSigner = uniqueMetas[uniqueIndex].isSigner || accountMeta.isSigner;
            } else uniqueMetas.push(accountMeta);
        });
        // Sort. Prioritizing first by signer, then by writable
        uniqueMetas.sort(function(x, y) {
            if (x.isSigner !== y.isSigner) // Signers always come before non-signers
            return x.isSigner ? -1 : 1;
            if (x.isWritable !== y.isWritable) // Writable accounts always come before read-only accounts
            return x.isWritable ? -1 : 1;
            // Otherwise, sort by pubkey, stringwise.
            const options = {
                localeMatcher: "best fit",
                usage: "sort",
                sensitivity: "variant",
                ignorePunctuation: false,
                numeric: false,
                caseFirst: "lower"
            };
            return x.pubkey.toBase58().localeCompare(y.pubkey.toBase58(), "en", options);
        });
        // Move fee payer to the front
        const feePayerIndex = uniqueMetas.findIndex((x)=>{
            return x.pubkey.equals(feePayer);
        });
        if (feePayerIndex > -1) {
            const [payerMeta] = uniqueMetas.splice(feePayerIndex, 1);
            payerMeta.isSigner = true;
            payerMeta.isWritable = true;
            uniqueMetas.unshift(payerMeta);
        } else uniqueMetas.unshift({
            pubkey: feePayer,
            isSigner: true,
            isWritable: true
        });
        // Disallow unknown signers
        for (const signature of this.signatures){
            const uniqueIndex = uniqueMetas.findIndex((x)=>{
                return x.pubkey.equals(signature.publicKey);
            });
            if (uniqueIndex > -1) {
                if (!uniqueMetas[uniqueIndex].isSigner) {
                    uniqueMetas[uniqueIndex].isSigner = true;
                    console.warn("Transaction references a signature that is unnecessary, only the fee payer and instruction signer accounts should sign a transaction. This behavior is deprecated and will throw an error in the next major version release.");
                }
            } else throw new Error(`unknown signer: ${signature.publicKey.toString()}`);
        }
        let numRequiredSignatures = 0;
        let numReadonlySignedAccounts = 0;
        let numReadonlyUnsignedAccounts = 0;
        // Split out signing from non-signing keys and count header values
        const signedKeys = [];
        const unsignedKeys = [];
        uniqueMetas.forEach(({ pubkey: pubkey, isSigner: isSigner, isWritable: isWritable })=>{
            if (isSigner) {
                signedKeys.push(pubkey.toString());
                numRequiredSignatures += 1;
                if (!isWritable) numReadonlySignedAccounts += 1;
            } else {
                unsignedKeys.push(pubkey.toString());
                if (!isWritable) numReadonlyUnsignedAccounts += 1;
            }
        });
        const accountKeys = signedKeys.concat(unsignedKeys);
        const compiledInstructions = instructions.map((instruction)=>{
            const { data: data, programId: programId } = instruction;
            return {
                programIdIndex: accountKeys.indexOf(programId.toString()),
                accounts: instruction.keys.map((meta)=>accountKeys.indexOf(meta.pubkey.toString())),
                data: (0, (/*@__PURE__*/$parcel$interopDefault($hZS7n))).encode(data)
            };
        });
        compiledInstructions.forEach((instruction)=>{
            $163ae62b92845c86$var$assert(instruction.programIdIndex >= 0);
            instruction.accounts.forEach((keyIndex)=>$163ae62b92845c86$var$assert(keyIndex >= 0));
        });
        return new $163ae62b92845c86$export$f69c19e57285b83a({
            header: {
                numRequiredSignatures: numRequiredSignatures,
                numReadonlySignedAccounts: numReadonlySignedAccounts,
                numReadonlyUnsignedAccounts: numReadonlyUnsignedAccounts
            },
            accountKeys: accountKeys,
            recentBlockhash: recentBlockhash,
            instructions: compiledInstructions
        });
    }
    /**
   * @internal
   */ _compile() {
        const message = this.compileMessage();
        const signedKeys = message.accountKeys.slice(0, message.header.numRequiredSignatures);
        if (this.signatures.length === signedKeys.length) {
            const valid = this.signatures.every((pair, index)=>{
                return signedKeys[index].equals(pair.publicKey);
            });
            if (valid) return message;
        }
        this.signatures = signedKeys.map((publicKey)=>({
                signature: null,
                publicKey: publicKey
            }));
        return message;
    }
    /**
   * Get a buffer of the Transaction data that need to be covered by signatures
   */ serializeMessage() {
        return this._compile().serialize();
    }
    /**
   * Get the estimated fee associated with a transaction
   *
   * @param {Connection} connection Connection to RPC Endpoint.
   *
   * @returns {Promise<number | null>} The estimated fee for the transaction
   */ async getEstimatedFee(connection) {
        return (await connection.getFeeForMessage(this.compileMessage())).value;
    }
    /**
   * Specify the public keys which will be used to sign the Transaction.
   * The first signer will be used as the transaction fee payer account.
   *
   * Signatures can be added with either `partialSign` or `addSignature`
   *
   * @deprecated Deprecated since v0.84.0. Only the fee payer needs to be
   * specified and it can be set in the Transaction constructor or with the
   * `feePayer` property.
   */ setSigners(...signers) {
        if (signers.length === 0) throw new Error("No signers");
        const seen = new Set();
        this.signatures = signers.filter((publicKey)=>{
            const key = publicKey.toString();
            if (seen.has(key)) return false;
            else {
                seen.add(key);
                return true;
            }
        }).map((publicKey)=>({
                signature: null,
                publicKey: publicKey
            }));
    }
    /**
   * Sign the Transaction with the specified signers. Multiple signatures may
   * be applied to a Transaction. The first signature is considered "primary"
   * and is used identify and confirm transactions.
   *
   * If the Transaction `feePayer` is not set, the first signer will be used
   * as the transaction fee payer account.
   *
   * Transaction fields should not be modified after the first call to `sign`,
   * as doing so may invalidate the signature and cause the Transaction to be
   * rejected.
   *
   * The Transaction must be assigned a valid `recentBlockhash` before invoking this method
   *
   * @param {Array<Signer>} signers Array of signers that will sign the transaction
   */ sign(...signers) {
        if (signers.length === 0) throw new Error("No signers");
        // Dedupe signers
        const seen = new Set();
        const uniqueSigners = [];
        for (const signer of signers){
            const key = signer.publicKey.toString();
            if (seen.has(key)) continue;
            else {
                seen.add(key);
                uniqueSigners.push(signer);
            }
        }
        this.signatures = uniqueSigners.map((signer)=>({
                signature: null,
                publicKey: signer.publicKey
            }));
        const message = this._compile();
        this._partialSign(message, ...uniqueSigners);
    }
    /**
   * Partially sign a transaction with the specified accounts. All accounts must
   * correspond to either the fee payer or a signer account in the transaction
   * instructions.
   *
   * All the caveats from the `sign` method apply to `partialSign`
   *
   * @param {Array<Signer>} signers Array of signers that will sign the transaction
   */ partialSign(...signers) {
        if (signers.length === 0) throw new Error("No signers");
        // Dedupe signers
        const seen = new Set();
        const uniqueSigners = [];
        for (const signer of signers){
            const key = signer.publicKey.toString();
            if (seen.has(key)) continue;
            else {
                seen.add(key);
                uniqueSigners.push(signer);
            }
        }
        const message = this._compile();
        this._partialSign(message, ...uniqueSigners);
    }
    /**
   * @internal
   */ _partialSign(message, ...signers) {
        const signData = message.serialize();
        signers.forEach((signer)=>{
            const signature = $163ae62b92845c86$var$sign(signData, signer.secretKey);
            this._addSignature(signer.publicKey, $163ae62b92845c86$var$toBuffer(signature));
        });
    }
    /**
   * Add an externally created signature to a transaction. The public key
   * must correspond to either the fee payer or a signer account in the transaction
   * instructions.
   *
   * @param {PublicKey} pubkey Public key that will be added to the transaction.
   * @param {Buffer} signature An externally created signature to add to the transaction.
   */ addSignature(pubkey, signature) {
        this._compile(); // Ensure signatures array is populated
        this._addSignature(pubkey, signature);
    }
    /**
   * @internal
   */ _addSignature(pubkey, signature) {
        $163ae62b92845c86$var$assert(signature.length === 64);
        const index = this.signatures.findIndex((sigpair)=>pubkey.equals(sigpair.publicKey));
        if (index < 0) throw new Error(`unknown signer: ${pubkey.toString()}`);
        this.signatures[index].signature = (0, $5ed0747d5916bbd8$export$a143d493d941bafc).from(signature);
    }
    /**
   * Verify signatures of a Transaction
   * Optional parameter specifies if we're expecting a fully signed Transaction or a partially signed one.
   * If no boolean is provided, we expect a fully signed Transaction by default.
   *
   * @param {boolean} [requireAllSignatures=true] Require a fully signed Transaction
   */ verifySignatures(requireAllSignatures = true) {
        const signatureErrors = this._getMessageSignednessErrors(this.serializeMessage(), requireAllSignatures);
        return !signatureErrors;
    }
    /**
   * @internal
   */ _getMessageSignednessErrors(message, requireAllSignatures) {
        const errors = {};
        for (const { signature: signature, publicKey: publicKey } of this.signatures){
            if (signature === null) {
                if (requireAllSignatures) (errors.missing ||= []).push(publicKey);
            } else if (!$163ae62b92845c86$var$verify(signature, message, publicKey.toBytes())) (errors.invalid ||= []).push(publicKey);
        }
        return errors.invalid || errors.missing ? errors : undefined;
    }
    /**
   * Serialize the Transaction in the wire format.
   *
   * @param {Buffer} [config] Config of transaction.
   *
   * @returns {Buffer} Signature of transaction in wire format.
   */ serialize(config) {
        const { requireAllSignatures: requireAllSignatures, verifySignatures: verifySignatures } = Object.assign({
            requireAllSignatures: true,
            verifySignatures: true
        }, config);
        const signData = this.serializeMessage();
        if (verifySignatures) {
            const sigErrors = this._getMessageSignednessErrors(signData, requireAllSignatures);
            if (sigErrors) {
                let errorMessage = "Signature verification failed.";
                if (sigErrors.invalid) errorMessage += `\nInvalid signature for public key${sigErrors.invalid.length === 1 ? "" : "(s)"} [\`${sigErrors.invalid.map((p)=>p.toBase58()).join("`, `")}\`].`;
                if (sigErrors.missing) errorMessage += `\nMissing signature for public key${sigErrors.missing.length === 1 ? "" : "(s)"} [\`${sigErrors.missing.map((p)=>p.toBase58()).join("`, `")}\`].`;
                throw new Error(errorMessage);
            }
        }
        return this._serialize(signData);
    }
    /**
   * @internal
   */ _serialize(signData) {
        const { signatures: signatures } = this;
        const signatureCount = [];
        $163ae62b92845c86$var$encodeLength(signatureCount, signatures.length);
        const transactionLength = signatureCount.length + signatures.length * 64 + signData.length;
        const wireTransaction = (0, $5ed0747d5916bbd8$export$a143d493d941bafc).alloc(transactionLength);
        $163ae62b92845c86$var$assert(signatures.length < 256);
        (0, $5ed0747d5916bbd8$export$a143d493d941bafc).from(signatureCount).copy(wireTransaction, 0);
        signatures.forEach(({ signature: signature }, index)=>{
            if (signature !== null) {
                $163ae62b92845c86$var$assert(signature.length === 64, `signature has invalid length`);
                (0, $5ed0747d5916bbd8$export$a143d493d941bafc).from(signature).copy(wireTransaction, signatureCount.length + index * 64);
            }
        });
        signData.copy(wireTransaction, signatureCount.length + signatures.length * 64);
        $163ae62b92845c86$var$assert(wireTransaction.length <= $163ae62b92845c86$export$4c6d5b89e1596f26, `Transaction too large: ${wireTransaction.length} > ${$163ae62b92845c86$export$4c6d5b89e1596f26}`);
        return wireTransaction;
    }
    /**
   * Deprecated method
   * @internal
   */ get keys() {
        $163ae62b92845c86$var$assert(this.instructions.length === 1);
        return this.instructions[0].keys.map((keyObj)=>keyObj.pubkey);
    }
    /**
   * Deprecated method
   * @internal
   */ get programId() {
        $163ae62b92845c86$var$assert(this.instructions.length === 1);
        return this.instructions[0].programId;
    }
    /**
   * Deprecated method
   * @internal
   */ get data() {
        $163ae62b92845c86$var$assert(this.instructions.length === 1);
        return this.instructions[0].data;
    }
    /**
   * Parse a wire transaction into a Transaction object.
   *
   * @param {Buffer | Uint8Array | Array<number>} buffer Signature of wire Transaction
   *
   * @returns {Transaction} Transaction associated with the signature
   */ static from(buffer) {
        // Slice up wire data
        let byteArray = [
            ...buffer
        ];
        const signatureCount = $163ae62b92845c86$var$decodeLength(byteArray);
        let signatures = [];
        for(let i = 0; i < signatureCount; i++){
            const signature = byteArray.slice(0, $163ae62b92845c86$export$14aee086fde78fa6);
            byteArray = byteArray.slice($163ae62b92845c86$export$14aee086fde78fa6);
            signatures.push((0, (/*@__PURE__*/$parcel$interopDefault($hZS7n))).encode((0, $5ed0747d5916bbd8$export$a143d493d941bafc).from(signature)));
        }
        return $163ae62b92845c86$export$febc5573c75cefb0.populate($163ae62b92845c86$export$f69c19e57285b83a.from(byteArray), signatures);
    }
    /**
   * Populate Transaction object from message and signatures
   *
   * @param {Message} message Message of transaction
   * @param {Array<string>} signatures List of signatures to assign to the transaction
   *
   * @returns {Transaction} The populated Transaction
   */ static populate(message, signatures = []) {
        const transaction = new $163ae62b92845c86$export$febc5573c75cefb0();
        transaction.recentBlockhash = message.recentBlockhash;
        if (message.header.numRequiredSignatures > 0) transaction.feePayer = message.accountKeys[0];
        signatures.forEach((signature, index)=>{
            const sigPubkeyPair = {
                signature: signature == (0, (/*@__PURE__*/$parcel$interopDefault($hZS7n))).encode($163ae62b92845c86$var$DEFAULT_SIGNATURE) ? null : (0, (/*@__PURE__*/$parcel$interopDefault($hZS7n))).decode(signature),
                publicKey: message.accountKeys[index]
            };
            transaction.signatures.push(sigPubkeyPair);
        });
        message.instructions.forEach((instruction)=>{
            const keys = instruction.accounts.map((account)=>{
                const pubkey = message.accountKeys[account];
                return {
                    pubkey: pubkey,
                    isSigner: transaction.signatures.some((keyObj)=>keyObj.publicKey.toString() === pubkey.toString()) || message.isAccountSigner(account),
                    isWritable: message.isAccountWritable(account)
                };
            });
            transaction.instructions.push(new $163ae62b92845c86$export$a7a3aa8360ac9f59({
                keys: keys,
                programId: message.accountKeys[instruction.programIdIndex],
                data: (0, (/*@__PURE__*/$parcel$interopDefault($hZS7n))).decode(instruction.data)
            }));
        });
        transaction._message = message;
        transaction._json = transaction.toJSON();
        return transaction;
    }
}
class $163ae62b92845c86$export$eb15f3e001dd262d {
    constructor(args){
        this.payerKey = void 0;
        this.instructions = void 0;
        this.recentBlockhash = void 0;
        this.payerKey = args.payerKey;
        this.instructions = args.instructions;
        this.recentBlockhash = args.recentBlockhash;
    }
    static decompile(message, args) {
        const { header: header, compiledInstructions: compiledInstructions, recentBlockhash: recentBlockhash } = message;
        const { numRequiredSignatures: numRequiredSignatures, numReadonlySignedAccounts: numReadonlySignedAccounts, numReadonlyUnsignedAccounts: numReadonlyUnsignedAccounts } = header;
        const numWritableSignedAccounts = numRequiredSignatures - numReadonlySignedAccounts;
        $163ae62b92845c86$var$assert(numWritableSignedAccounts > 0, "Message header is invalid");
        const numWritableUnsignedAccounts = message.staticAccountKeys.length - numRequiredSignatures - numReadonlyUnsignedAccounts;
        $163ae62b92845c86$var$assert(numWritableUnsignedAccounts >= 0, "Message header is invalid");
        const accountKeys = message.getAccountKeys(args);
        const payerKey = accountKeys.get(0);
        if (payerKey === undefined) throw new Error("Failed to decompile message because no account keys were found");
        const instructions = [];
        for (const compiledIx of compiledInstructions){
            const keys = [];
            for (const keyIndex of compiledIx.accountKeyIndexes){
                const pubkey = accountKeys.get(keyIndex);
                if (pubkey === undefined) throw new Error(`Failed to find key for account key index ${keyIndex}`);
                const isSigner = keyIndex < numRequiredSignatures;
                let isWritable;
                if (isSigner) isWritable = keyIndex < numWritableSignedAccounts;
                else if (keyIndex < accountKeys.staticAccountKeys.length) isWritable = keyIndex - numRequiredSignatures < numWritableUnsignedAccounts;
                else isWritable = keyIndex - accountKeys.staticAccountKeys.length < // accountKeysFromLookups cannot be undefined because we already found a pubkey for this index above
                accountKeys.accountKeysFromLookups.writable.length;
                keys.push({
                    pubkey: pubkey,
                    isSigner: keyIndex < header.numRequiredSignatures,
                    isWritable: isWritable
                });
            }
            const programId = accountKeys.get(compiledIx.programIdIndex);
            if (programId === undefined) throw new Error(`Failed to find program id for program id index ${compiledIx.programIdIndex}`);
            instructions.push(new $163ae62b92845c86$export$a7a3aa8360ac9f59({
                programId: programId,
                data: $163ae62b92845c86$var$toBuffer(compiledIx.data),
                keys: keys
            }));
        }
        return new $163ae62b92845c86$export$eb15f3e001dd262d({
            payerKey: payerKey,
            instructions: instructions,
            recentBlockhash: recentBlockhash
        });
    }
    compileToLegacyMessage() {
        return $163ae62b92845c86$export$f69c19e57285b83a.compile({
            payerKey: this.payerKey,
            recentBlockhash: this.recentBlockhash,
            instructions: this.instructions
        });
    }
    compileToV0Message(addressLookupTableAccounts) {
        return $163ae62b92845c86$export$ee274c70e0fae590.compile({
            payerKey: this.payerKey,
            recentBlockhash: this.recentBlockhash,
            instructions: this.instructions,
            addressLookupTableAccounts: addressLookupTableAccounts
        });
    }
}
/**
 * Versioned transaction class
 */ class $163ae62b92845c86$export$232cc3f078dcc284 {
    get version() {
        return this.message.version;
    }
    constructor(message, signatures){
        this.signatures = void 0;
        this.message = void 0;
        if (signatures !== undefined) {
            $163ae62b92845c86$var$assert(signatures.length === message.header.numRequiredSignatures, "Expected signatures length to be equal to the number of required signatures");
            this.signatures = signatures;
        } else {
            const defaultSignatures = [];
            for(let i = 0; i < message.header.numRequiredSignatures; i++)defaultSignatures.push(new Uint8Array($163ae62b92845c86$export$14aee086fde78fa6));
            this.signatures = defaultSignatures;
        }
        this.message = message;
    }
    serialize() {
        const serializedMessage = this.message.serialize();
        const encodedSignaturesLength = Array();
        $163ae62b92845c86$var$encodeLength(encodedSignaturesLength, this.signatures.length);
        const transactionLayout = $2913ed74210dce84$exports.struct([
            $2913ed74210dce84$exports.blob(encodedSignaturesLength.length, "encodedSignaturesLength"),
            $2913ed74210dce84$exports.seq($163ae62b92845c86$var$signature(), this.signatures.length, "signatures"),
            $2913ed74210dce84$exports.blob(serializedMessage.length, "serializedMessage")
        ]);
        const serializedTransaction = new Uint8Array(2048);
        const serializedTransactionLength = transactionLayout.encode({
            encodedSignaturesLength: new Uint8Array(encodedSignaturesLength),
            signatures: this.signatures,
            serializedMessage: serializedMessage
        }, serializedTransaction);
        return serializedTransaction.slice(0, serializedTransactionLength);
    }
    static deserialize(serializedTransaction) {
        let byteArray = [
            ...serializedTransaction
        ];
        const signatures = [];
        const signaturesLength = $163ae62b92845c86$var$decodeLength(byteArray);
        for(let i = 0; i < signaturesLength; i++)signatures.push(new Uint8Array(byteArray.splice(0, $163ae62b92845c86$export$14aee086fde78fa6)));
        const message = $163ae62b92845c86$export$b0a61927d00ede7f.deserialize(new Uint8Array(byteArray));
        return new $163ae62b92845c86$export$232cc3f078dcc284(message, signatures);
    }
    sign(signers) {
        const messageData = this.message.serialize();
        const signerPubkeys = this.message.staticAccountKeys.slice(0, this.message.header.numRequiredSignatures);
        for (const signer of signers){
            const signerIndex = signerPubkeys.findIndex((pubkey)=>pubkey.equals(signer.publicKey));
            $163ae62b92845c86$var$assert(signerIndex >= 0, `Cannot sign with non signer key ${signer.publicKey.toBase58()}`);
            this.signatures[signerIndex] = $163ae62b92845c86$var$sign(messageData, signer.secretKey);
        }
    }
    addSignature(publicKey, signature) {
        $163ae62b92845c86$var$assert(signature.byteLength === 64, "Signature must be 64 bytes long");
        const signerPubkeys = this.message.staticAccountKeys.slice(0, this.message.header.numRequiredSignatures);
        const signerIndex = signerPubkeys.findIndex((pubkey)=>pubkey.equals(publicKey));
        $163ae62b92845c86$var$assert(signerIndex >= 0, `Can not add signature; \`${publicKey.toBase58()}\` is not required to sign this transaction`);
        this.signatures[signerIndex] = signature;
    }
}
// TODO: These constants should be removed in favor of reading them out of a
// Syscall account
/**
 * @internal
 */ const $163ae62b92845c86$var$NUM_TICKS_PER_SECOND = 160;
/**
 * @internal
 */ const $163ae62b92845c86$var$DEFAULT_TICKS_PER_SLOT = 64;
/**
 * @internal
 */ const $163ae62b92845c86$var$NUM_SLOTS_PER_SECOND = $163ae62b92845c86$var$NUM_TICKS_PER_SECOND / $163ae62b92845c86$var$DEFAULT_TICKS_PER_SLOT;
/**
 * @internal
 */ const $163ae62b92845c86$var$MS_PER_SLOT = 1000 / $163ae62b92845c86$var$NUM_SLOTS_PER_SECOND;
const $163ae62b92845c86$export$393aa1412d47050e = new $163ae62b92845c86$export$ca8b6604d6ce14de("SysvarC1ock11111111111111111111111111111111");
const $163ae62b92845c86$export$2b71d479444d2f4 = new $163ae62b92845c86$export$ca8b6604d6ce14de("SysvarEpochSchedu1e111111111111111111111111");
const $163ae62b92845c86$export$54419cc1a3ece8d6 = new $163ae62b92845c86$export$ca8b6604d6ce14de("Sysvar1nstructions1111111111111111111111111");
const $163ae62b92845c86$export$e74201139e9833db = new $163ae62b92845c86$export$ca8b6604d6ce14de("SysvarRecentB1ockHashes11111111111111111111");
const $163ae62b92845c86$export$970d0190cdb3a8e9 = new $163ae62b92845c86$export$ca8b6604d6ce14de("SysvarRent111111111111111111111111111111111");
const $163ae62b92845c86$export$da3b38d796bc1af1 = new $163ae62b92845c86$export$ca8b6604d6ce14de("SysvarRewards111111111111111111111111111111");
const $163ae62b92845c86$export$7b3a057916a4a7ae = new $163ae62b92845c86$export$ca8b6604d6ce14de("SysvarS1otHashes111111111111111111111111111");
const $163ae62b92845c86$export$3272815bf0633907 = new $163ae62b92845c86$export$ca8b6604d6ce14de("SysvarS1otHistory11111111111111111111111111");
const $163ae62b92845c86$export$ca994171317280ea = new $163ae62b92845c86$export$ca8b6604d6ce14de("SysvarStakeHistory1111111111111111111111111");
/**
 * Sign, send and confirm a transaction.
 *
 * If `commitment` option is not specified, defaults to 'max' commitment.
 *
 * @param {Connection} connection
 * @param {Transaction} transaction
 * @param {Array<Signer>} signers
 * @param {ConfirmOptions} [options]
 * @returns {Promise<TransactionSignature>}
 */ async function $163ae62b92845c86$export$4ad6fe6dae0b6bc3(connection, transaction, signers, options) {
    const sendOptions = options && {
        skipPreflight: options.skipPreflight,
        preflightCommitment: options.preflightCommitment || options.commitment,
        maxRetries: options.maxRetries,
        minContextSlot: options.minContextSlot
    };
    const signature = await connection.sendTransaction(transaction, signers, sendOptions);
    let status;
    if (transaction.recentBlockhash != null && transaction.lastValidBlockHeight != null) status = (await connection.confirmTransaction({
        abortSignal: options?.abortSignal,
        signature: signature,
        blockhash: transaction.recentBlockhash,
        lastValidBlockHeight: transaction.lastValidBlockHeight
    }, options && options.commitment)).value;
    else if (transaction.minNonceContextSlot != null && transaction.nonceInfo != null) {
        const { nonceInstruction: nonceInstruction } = transaction.nonceInfo;
        const nonceAccountPubkey = nonceInstruction.keys[0].pubkey;
        status = (await connection.confirmTransaction({
            abortSignal: options?.abortSignal,
            minContextSlot: transaction.minNonceContextSlot,
            nonceAccountPubkey: nonceAccountPubkey,
            nonceValue: transaction.nonceInfo.nonce,
            signature: signature
        }, options && options.commitment)).value;
    } else {
        if (options?.abortSignal != null) console.warn("sendAndConfirmTransaction(): A transaction with a deprecated confirmation strategy was supplied along with an `abortSignal`. Only transactions having `lastValidBlockHeight` or a combination of `nonceInfo` and `minNonceContextSlot` are abortable.");
        status = (await connection.confirmTransaction(signature, options && options.commitment)).value;
    }
    if (status.err) throw new Error(`Transaction ${signature} failed (${JSON.stringify(status)})`);
    return signature;
}
// zzz
function $163ae62b92845c86$var$sleep(ms) {
    return new Promise((resolve)=>setTimeout(resolve, ms));
}
/**
 * @internal
 */ /**
 * Populate a buffer of instruction data using an InstructionType
 * @internal
 */ function $163ae62b92845c86$var$encodeData(type, fields) {
    const allocLength = type.layout.span >= 0 ? type.layout.span : $163ae62b92845c86$var$getAlloc(type, fields);
    const data = (0, $5ed0747d5916bbd8$export$a143d493d941bafc).alloc(allocLength);
    const layoutFields = Object.assign({
        instruction: type.index
    }, fields);
    type.layout.encode(layoutFields, data);
    return data;
}
/**
 * Decode instruction data buffer using an InstructionType
 * @internal
 */ function $163ae62b92845c86$var$decodeData$1(type, buffer) {
    let data;
    try {
        data = type.layout.decode(buffer);
    } catch (err) {
        throw new Error("invalid instruction; " + err);
    }
    if (data.instruction !== type.index) throw new Error(`invalid instruction; instruction index mismatch ${data.instruction} != ${type.index}`);
    return data;
}
/**
 * https://github.com/solana-labs/solana/blob/90bedd7e067b5b8f3ddbb45da00a4e9cabb22c62/sdk/src/fee_calculator.rs#L7-L11
 *
 * @internal
 */ const $163ae62b92845c86$export$d1cc579b1c48f515 = $2913ed74210dce84$exports.nu64("lamportsPerSignature");
/**
 * Calculator for transaction fees.
 *
 * @deprecated Deprecated since Solana v1.8.0.
 */ /**
 * See https://github.com/solana-labs/solana/blob/0ea2843ec9cdc517572b8e62c959f41b55cf4453/sdk/src/nonce_state.rs#L29-L32
 *
 * @internal
 */ const $163ae62b92845c86$var$NonceAccountLayout = $2913ed74210dce84$exports.struct([
    $2913ed74210dce84$exports.u32("version"),
    $2913ed74210dce84$exports.u32("state"),
    $163ae62b92845c86$var$publicKey("authorizedPubkey"),
    $163ae62b92845c86$var$publicKey("nonce"),
    $2913ed74210dce84$exports.struct([
        $163ae62b92845c86$export$d1cc579b1c48f515
    ], "feeCalculator")
]);
const $163ae62b92845c86$export$7126250b6d8bd94a = $163ae62b92845c86$var$NonceAccountLayout.span;
/**
 * A durable nonce is a 32 byte value encoded as a base58 string.
 */ /**
 * NonceAccount class
 */ class $163ae62b92845c86$export$ed1c2356ce604759 {
    /**
   * @internal
   */ constructor(args){
        this.authorizedPubkey = void 0;
        this.nonce = void 0;
        this.feeCalculator = void 0;
        this.authorizedPubkey = args.authorizedPubkey;
        this.nonce = args.nonce;
        this.feeCalculator = args.feeCalculator;
    }
    /**
   * Deserialize NonceAccount from the account data.
   *
   * @param buffer account data
   * @return NonceAccount
   */ static fromAccountData(buffer) {
        const nonceAccount = $163ae62b92845c86$var$NonceAccountLayout.decode($163ae62b92845c86$var$toBuffer(buffer), 0);
        return new $163ae62b92845c86$export$ed1c2356ce604759({
            authorizedPubkey: new $163ae62b92845c86$export$ca8b6604d6ce14de(nonceAccount.authorizedPubkey),
            nonce: new $163ae62b92845c86$export$ca8b6604d6ce14de(nonceAccount.nonce).toString(),
            feeCalculator: nonceAccount.feeCalculator
        });
    }
}
const $163ae62b92845c86$var$encodeDecode = (layout)=>{
    const decode = layout.decode.bind(layout);
    const encode = layout.encode.bind(layout);
    return {
        decode: decode,
        encode: encode
    };
};
const $163ae62b92845c86$var$bigInt = (length)=>(property)=>{
        const layout = (0, $2913ed74210dce84$exports.blob)(length, property);
        const { encode: encode, decode: decode } = $163ae62b92845c86$var$encodeDecode(layout);
        const bigIntLayout = layout;
        bigIntLayout.decode = (buffer, offset)=>{
            const src = decode(buffer, offset);
            return (0, $bc91bf67ed8c7241$exports.toBigIntLE)((0, $5ed0747d5916bbd8$export$a143d493d941bafc).from(src));
        };
        bigIntLayout.encode = (bigInt, buffer, offset)=>{
            const src = (0, $bc91bf67ed8c7241$exports.toBufferLE)(bigInt, length);
            return encode(src, buffer, offset);
        };
        return bigIntLayout;
    };
const $163ae62b92845c86$var$u64 = $163ae62b92845c86$var$bigInt(8);
/**
 * Create account system transaction params
 */ /**
 * Transfer system transaction params
 */ /**
 * Assign system transaction params
 */ /**
 * Create account with seed system transaction params
 */ /**
 * Create nonce account system transaction params
 */ /**
 * Create nonce account with seed system transaction params
 */ /**
 * Initialize nonce account system instruction params
 */ /**
 * Advance nonce account system instruction params
 */ /**
 * Withdraw nonce account system transaction params
 */ /**
 * Authorize nonce account system transaction params
 */ /**
 * Allocate account system transaction params
 */ /**
 * Allocate account with seed system transaction params
 */ /**
 * Assign account with seed system transaction params
 */ /**
 * Transfer with seed system transaction params
 */ /** Decoded transfer system transaction instruction */ /** Decoded transferWithSeed system transaction instruction */ /**
 * System Instruction class
 */ class $163ae62b92845c86$export$f009802131fa3d06 {
    /**
   * @internal
   */ constructor(){}
    /**
   * Decode a system instruction and retrieve the instruction type.
   */ static decodeInstructionType(instruction) {
        this.checkProgramId(instruction.programId);
        const instructionTypeLayout = $2913ed74210dce84$exports.u32("instruction");
        const typeIndex = instructionTypeLayout.decode(instruction.data);
        let type;
        for (const [ixType, layout] of Object.entries($163ae62b92845c86$export$74bdf41d8d1e7108))if (layout.index == typeIndex) {
            type = ixType;
            break;
        }
        if (!type) throw new Error("Instruction type incorrect; not a SystemInstruction");
        return type;
    }
    /**
   * Decode a create account system instruction and retrieve the instruction params.
   */ static decodeCreateAccount(instruction) {
        this.checkProgramId(instruction.programId);
        this.checkKeyLength(instruction.keys, 2);
        const { lamports: lamports, space: space, programId: programId } = $163ae62b92845c86$var$decodeData$1($163ae62b92845c86$export$74bdf41d8d1e7108.Create, instruction.data);
        return {
            fromPubkey: instruction.keys[0].pubkey,
            newAccountPubkey: instruction.keys[1].pubkey,
            lamports: lamports,
            space: space,
            programId: new $163ae62b92845c86$export$ca8b6604d6ce14de(programId)
        };
    }
    /**
   * Decode a transfer system instruction and retrieve the instruction params.
   */ static decodeTransfer(instruction) {
        this.checkProgramId(instruction.programId);
        this.checkKeyLength(instruction.keys, 2);
        const { lamports: lamports } = $163ae62b92845c86$var$decodeData$1($163ae62b92845c86$export$74bdf41d8d1e7108.Transfer, instruction.data);
        return {
            fromPubkey: instruction.keys[0].pubkey,
            toPubkey: instruction.keys[1].pubkey,
            lamports: lamports
        };
    }
    /**
   * Decode a transfer with seed system instruction and retrieve the instruction params.
   */ static decodeTransferWithSeed(instruction) {
        this.checkProgramId(instruction.programId);
        this.checkKeyLength(instruction.keys, 3);
        const { lamports: lamports, seed: seed, programId: programId } = $163ae62b92845c86$var$decodeData$1($163ae62b92845c86$export$74bdf41d8d1e7108.TransferWithSeed, instruction.data);
        return {
            fromPubkey: instruction.keys[0].pubkey,
            basePubkey: instruction.keys[1].pubkey,
            toPubkey: instruction.keys[2].pubkey,
            lamports: lamports,
            seed: seed,
            programId: new $163ae62b92845c86$export$ca8b6604d6ce14de(programId)
        };
    }
    /**
   * Decode an allocate system instruction and retrieve the instruction params.
   */ static decodeAllocate(instruction) {
        this.checkProgramId(instruction.programId);
        this.checkKeyLength(instruction.keys, 1);
        const { space: space } = $163ae62b92845c86$var$decodeData$1($163ae62b92845c86$export$74bdf41d8d1e7108.Allocate, instruction.data);
        return {
            accountPubkey: instruction.keys[0].pubkey,
            space: space
        };
    }
    /**
   * Decode an allocate with seed system instruction and retrieve the instruction params.
   */ static decodeAllocateWithSeed(instruction) {
        this.checkProgramId(instruction.programId);
        this.checkKeyLength(instruction.keys, 1);
        const { base: base, seed: seed, space: space, programId: programId } = $163ae62b92845c86$var$decodeData$1($163ae62b92845c86$export$74bdf41d8d1e7108.AllocateWithSeed, instruction.data);
        return {
            accountPubkey: instruction.keys[0].pubkey,
            basePubkey: new $163ae62b92845c86$export$ca8b6604d6ce14de(base),
            seed: seed,
            space: space,
            programId: new $163ae62b92845c86$export$ca8b6604d6ce14de(programId)
        };
    }
    /**
   * Decode an assign system instruction and retrieve the instruction params.
   */ static decodeAssign(instruction) {
        this.checkProgramId(instruction.programId);
        this.checkKeyLength(instruction.keys, 1);
        const { programId: programId } = $163ae62b92845c86$var$decodeData$1($163ae62b92845c86$export$74bdf41d8d1e7108.Assign, instruction.data);
        return {
            accountPubkey: instruction.keys[0].pubkey,
            programId: new $163ae62b92845c86$export$ca8b6604d6ce14de(programId)
        };
    }
    /**
   * Decode an assign with seed system instruction and retrieve the instruction params.
   */ static decodeAssignWithSeed(instruction) {
        this.checkProgramId(instruction.programId);
        this.checkKeyLength(instruction.keys, 1);
        const { base: base, seed: seed, programId: programId } = $163ae62b92845c86$var$decodeData$1($163ae62b92845c86$export$74bdf41d8d1e7108.AssignWithSeed, instruction.data);
        return {
            accountPubkey: instruction.keys[0].pubkey,
            basePubkey: new $163ae62b92845c86$export$ca8b6604d6ce14de(base),
            seed: seed,
            programId: new $163ae62b92845c86$export$ca8b6604d6ce14de(programId)
        };
    }
    /**
   * Decode a create account with seed system instruction and retrieve the instruction params.
   */ static decodeCreateWithSeed(instruction) {
        this.checkProgramId(instruction.programId);
        this.checkKeyLength(instruction.keys, 2);
        const { base: base, seed: seed, lamports: lamports, space: space, programId: programId } = $163ae62b92845c86$var$decodeData$1($163ae62b92845c86$export$74bdf41d8d1e7108.CreateWithSeed, instruction.data);
        return {
            fromPubkey: instruction.keys[0].pubkey,
            newAccountPubkey: instruction.keys[1].pubkey,
            basePubkey: new $163ae62b92845c86$export$ca8b6604d6ce14de(base),
            seed: seed,
            lamports: lamports,
            space: space,
            programId: new $163ae62b92845c86$export$ca8b6604d6ce14de(programId)
        };
    }
    /**
   * Decode a nonce initialize system instruction and retrieve the instruction params.
   */ static decodeNonceInitialize(instruction) {
        this.checkProgramId(instruction.programId);
        this.checkKeyLength(instruction.keys, 3);
        const { authorized: authorized } = $163ae62b92845c86$var$decodeData$1($163ae62b92845c86$export$74bdf41d8d1e7108.InitializeNonceAccount, instruction.data);
        return {
            noncePubkey: instruction.keys[0].pubkey,
            authorizedPubkey: new $163ae62b92845c86$export$ca8b6604d6ce14de(authorized)
        };
    }
    /**
   * Decode a nonce advance system instruction and retrieve the instruction params.
   */ static decodeNonceAdvance(instruction) {
        this.checkProgramId(instruction.programId);
        this.checkKeyLength(instruction.keys, 3);
        $163ae62b92845c86$var$decodeData$1($163ae62b92845c86$export$74bdf41d8d1e7108.AdvanceNonceAccount, instruction.data);
        return {
            noncePubkey: instruction.keys[0].pubkey,
            authorizedPubkey: instruction.keys[2].pubkey
        };
    }
    /**
   * Decode a nonce withdraw system instruction and retrieve the instruction params.
   */ static decodeNonceWithdraw(instruction) {
        this.checkProgramId(instruction.programId);
        this.checkKeyLength(instruction.keys, 5);
        const { lamports: lamports } = $163ae62b92845c86$var$decodeData$1($163ae62b92845c86$export$74bdf41d8d1e7108.WithdrawNonceAccount, instruction.data);
        return {
            noncePubkey: instruction.keys[0].pubkey,
            toPubkey: instruction.keys[1].pubkey,
            authorizedPubkey: instruction.keys[4].pubkey,
            lamports: lamports
        };
    }
    /**
   * Decode a nonce authorize system instruction and retrieve the instruction params.
   */ static decodeNonceAuthorize(instruction) {
        this.checkProgramId(instruction.programId);
        this.checkKeyLength(instruction.keys, 2);
        const { authorized: authorized } = $163ae62b92845c86$var$decodeData$1($163ae62b92845c86$export$74bdf41d8d1e7108.AuthorizeNonceAccount, instruction.data);
        return {
            noncePubkey: instruction.keys[0].pubkey,
            authorizedPubkey: instruction.keys[1].pubkey,
            newAuthorizedPubkey: new $163ae62b92845c86$export$ca8b6604d6ce14de(authorized)
        };
    }
    /**
   * @internal
   */ static checkProgramId(programId) {
        if (!programId.equals($163ae62b92845c86$export$d8c4e17726848113.programId)) throw new Error("invalid instruction; programId is not SystemProgram");
    }
    /**
   * @internal
   */ static checkKeyLength(keys, expectedLength) {
        if (keys.length < expectedLength) throw new Error(`invalid instruction; found ${keys.length} keys, expected at least ${expectedLength}`);
    }
}
/**
 * An enumeration of valid SystemInstructionType's
 */ /**
 * An enumeration of valid system InstructionType's
 * @internal
 */ const $163ae62b92845c86$export$74bdf41d8d1e7108 = Object.freeze({
    Create: {
        index: 0,
        layout: $2913ed74210dce84$exports.struct([
            $2913ed74210dce84$exports.u32("instruction"),
            $2913ed74210dce84$exports.ns64("lamports"),
            $2913ed74210dce84$exports.ns64("space"),
            $163ae62b92845c86$var$publicKey("programId")
        ])
    },
    Assign: {
        index: 1,
        layout: $2913ed74210dce84$exports.struct([
            $2913ed74210dce84$exports.u32("instruction"),
            $163ae62b92845c86$var$publicKey("programId")
        ])
    },
    Transfer: {
        index: 2,
        layout: $2913ed74210dce84$exports.struct([
            $2913ed74210dce84$exports.u32("instruction"),
            $163ae62b92845c86$var$u64("lamports")
        ])
    },
    CreateWithSeed: {
        index: 3,
        layout: $2913ed74210dce84$exports.struct([
            $2913ed74210dce84$exports.u32("instruction"),
            $163ae62b92845c86$var$publicKey("base"),
            $163ae62b92845c86$var$rustString("seed"),
            $2913ed74210dce84$exports.ns64("lamports"),
            $2913ed74210dce84$exports.ns64("space"),
            $163ae62b92845c86$var$publicKey("programId")
        ])
    },
    AdvanceNonceAccount: {
        index: 4,
        layout: $2913ed74210dce84$exports.struct([
            $2913ed74210dce84$exports.u32("instruction")
        ])
    },
    WithdrawNonceAccount: {
        index: 5,
        layout: $2913ed74210dce84$exports.struct([
            $2913ed74210dce84$exports.u32("instruction"),
            $2913ed74210dce84$exports.ns64("lamports")
        ])
    },
    InitializeNonceAccount: {
        index: 6,
        layout: $2913ed74210dce84$exports.struct([
            $2913ed74210dce84$exports.u32("instruction"),
            $163ae62b92845c86$var$publicKey("authorized")
        ])
    },
    AuthorizeNonceAccount: {
        index: 7,
        layout: $2913ed74210dce84$exports.struct([
            $2913ed74210dce84$exports.u32("instruction"),
            $163ae62b92845c86$var$publicKey("authorized")
        ])
    },
    Allocate: {
        index: 8,
        layout: $2913ed74210dce84$exports.struct([
            $2913ed74210dce84$exports.u32("instruction"),
            $2913ed74210dce84$exports.ns64("space")
        ])
    },
    AllocateWithSeed: {
        index: 9,
        layout: $2913ed74210dce84$exports.struct([
            $2913ed74210dce84$exports.u32("instruction"),
            $163ae62b92845c86$var$publicKey("base"),
            $163ae62b92845c86$var$rustString("seed"),
            $2913ed74210dce84$exports.ns64("space"),
            $163ae62b92845c86$var$publicKey("programId")
        ])
    },
    AssignWithSeed: {
        index: 10,
        layout: $2913ed74210dce84$exports.struct([
            $2913ed74210dce84$exports.u32("instruction"),
            $163ae62b92845c86$var$publicKey("base"),
            $163ae62b92845c86$var$rustString("seed"),
            $163ae62b92845c86$var$publicKey("programId")
        ])
    },
    TransferWithSeed: {
        index: 11,
        layout: $2913ed74210dce84$exports.struct([
            $2913ed74210dce84$exports.u32("instruction"),
            $163ae62b92845c86$var$u64("lamports"),
            $163ae62b92845c86$var$rustString("seed"),
            $163ae62b92845c86$var$publicKey("programId")
        ])
    },
    UpgradeNonceAccount: {
        index: 12,
        layout: $2913ed74210dce84$exports.struct([
            $2913ed74210dce84$exports.u32("instruction")
        ])
    }
});
/**
 * Factory class for transactions to interact with the System program
 */ class $163ae62b92845c86$export$d8c4e17726848113 {
    /**
   * @internal
   */ constructor(){}
    /**
   * Public key that identifies the System program
   */ /**
   * Generate a transaction instruction that creates a new account
   */ static createAccount(params) {
        const type = $163ae62b92845c86$export$74bdf41d8d1e7108.Create;
        const data = $163ae62b92845c86$var$encodeData(type, {
            lamports: params.lamports,
            space: params.space,
            programId: $163ae62b92845c86$var$toBuffer(params.programId.toBuffer())
        });
        return new $163ae62b92845c86$export$a7a3aa8360ac9f59({
            keys: [
                {
                    pubkey: params.fromPubkey,
                    isSigner: true,
                    isWritable: true
                },
                {
                    pubkey: params.newAccountPubkey,
                    isSigner: true,
                    isWritable: true
                }
            ],
            programId: this.programId,
            data: data
        });
    }
    /**
   * Generate a transaction instruction that transfers lamports from one account to another
   */ static transfer(params) {
        let data;
        let keys;
        if ("basePubkey" in params) {
            const type = $163ae62b92845c86$export$74bdf41d8d1e7108.TransferWithSeed;
            data = $163ae62b92845c86$var$encodeData(type, {
                lamports: BigInt(params.lamports),
                seed: params.seed,
                programId: $163ae62b92845c86$var$toBuffer(params.programId.toBuffer())
            });
            keys = [
                {
                    pubkey: params.fromPubkey,
                    isSigner: false,
                    isWritable: true
                },
                {
                    pubkey: params.basePubkey,
                    isSigner: true,
                    isWritable: false
                },
                {
                    pubkey: params.toPubkey,
                    isSigner: false,
                    isWritable: true
                }
            ];
        } else {
            const type = $163ae62b92845c86$export$74bdf41d8d1e7108.Transfer;
            data = $163ae62b92845c86$var$encodeData(type, {
                lamports: BigInt(params.lamports)
            });
            keys = [
                {
                    pubkey: params.fromPubkey,
                    isSigner: true,
                    isWritable: true
                },
                {
                    pubkey: params.toPubkey,
                    isSigner: false,
                    isWritable: true
                }
            ];
        }
        return new $163ae62b92845c86$export$a7a3aa8360ac9f59({
            keys: keys,
            programId: this.programId,
            data: data
        });
    }
    /**
   * Generate a transaction instruction that assigns an account to a program
   */ static assign(params) {
        let data;
        let keys;
        if ("basePubkey" in params) {
            const type = $163ae62b92845c86$export$74bdf41d8d1e7108.AssignWithSeed;
            data = $163ae62b92845c86$var$encodeData(type, {
                base: $163ae62b92845c86$var$toBuffer(params.basePubkey.toBuffer()),
                seed: params.seed,
                programId: $163ae62b92845c86$var$toBuffer(params.programId.toBuffer())
            });
            keys = [
                {
                    pubkey: params.accountPubkey,
                    isSigner: false,
                    isWritable: true
                },
                {
                    pubkey: params.basePubkey,
                    isSigner: true,
                    isWritable: false
                }
            ];
        } else {
            const type = $163ae62b92845c86$export$74bdf41d8d1e7108.Assign;
            data = $163ae62b92845c86$var$encodeData(type, {
                programId: $163ae62b92845c86$var$toBuffer(params.programId.toBuffer())
            });
            keys = [
                {
                    pubkey: params.accountPubkey,
                    isSigner: true,
                    isWritable: true
                }
            ];
        }
        return new $163ae62b92845c86$export$a7a3aa8360ac9f59({
            keys: keys,
            programId: this.programId,
            data: data
        });
    }
    /**
   * Generate a transaction instruction that creates a new account at
   *   an address generated with `from`, a seed, and programId
   */ static createAccountWithSeed(params) {
        const type = $163ae62b92845c86$export$74bdf41d8d1e7108.CreateWithSeed;
        const data = $163ae62b92845c86$var$encodeData(type, {
            base: $163ae62b92845c86$var$toBuffer(params.basePubkey.toBuffer()),
            seed: params.seed,
            lamports: params.lamports,
            space: params.space,
            programId: $163ae62b92845c86$var$toBuffer(params.programId.toBuffer())
        });
        let keys = [
            {
                pubkey: params.fromPubkey,
                isSigner: true,
                isWritable: true
            },
            {
                pubkey: params.newAccountPubkey,
                isSigner: false,
                isWritable: true
            }
        ];
        if (params.basePubkey != params.fromPubkey) keys.push({
            pubkey: params.basePubkey,
            isSigner: true,
            isWritable: false
        });
        return new $163ae62b92845c86$export$a7a3aa8360ac9f59({
            keys: keys,
            programId: this.programId,
            data: data
        });
    }
    /**
   * Generate a transaction that creates a new Nonce account
   */ static createNonceAccount(params) {
        const transaction = new $163ae62b92845c86$export$febc5573c75cefb0();
        if ("basePubkey" in params && "seed" in params) transaction.add($163ae62b92845c86$export$d8c4e17726848113.createAccountWithSeed({
            fromPubkey: params.fromPubkey,
            newAccountPubkey: params.noncePubkey,
            basePubkey: params.basePubkey,
            seed: params.seed,
            lamports: params.lamports,
            space: $163ae62b92845c86$export$7126250b6d8bd94a,
            programId: this.programId
        }));
        else transaction.add($163ae62b92845c86$export$d8c4e17726848113.createAccount({
            fromPubkey: params.fromPubkey,
            newAccountPubkey: params.noncePubkey,
            lamports: params.lamports,
            space: $163ae62b92845c86$export$7126250b6d8bd94a,
            programId: this.programId
        }));
        const initParams = {
            noncePubkey: params.noncePubkey,
            authorizedPubkey: params.authorizedPubkey
        };
        transaction.add(this.nonceInitialize(initParams));
        return transaction;
    }
    /**
   * Generate an instruction to initialize a Nonce account
   */ static nonceInitialize(params) {
        const type = $163ae62b92845c86$export$74bdf41d8d1e7108.InitializeNonceAccount;
        const data = $163ae62b92845c86$var$encodeData(type, {
            authorized: $163ae62b92845c86$var$toBuffer(params.authorizedPubkey.toBuffer())
        });
        const instructionData = {
            keys: [
                {
                    pubkey: params.noncePubkey,
                    isSigner: false,
                    isWritable: true
                },
                {
                    pubkey: $163ae62b92845c86$export$e74201139e9833db,
                    isSigner: false,
                    isWritable: false
                },
                {
                    pubkey: $163ae62b92845c86$export$970d0190cdb3a8e9,
                    isSigner: false,
                    isWritable: false
                }
            ],
            programId: this.programId,
            data: data
        };
        return new $163ae62b92845c86$export$a7a3aa8360ac9f59(instructionData);
    }
    /**
   * Generate an instruction to advance the nonce in a Nonce account
   */ static nonceAdvance(params) {
        const type = $163ae62b92845c86$export$74bdf41d8d1e7108.AdvanceNonceAccount;
        const data = $163ae62b92845c86$var$encodeData(type);
        const instructionData = {
            keys: [
                {
                    pubkey: params.noncePubkey,
                    isSigner: false,
                    isWritable: true
                },
                {
                    pubkey: $163ae62b92845c86$export$e74201139e9833db,
                    isSigner: false,
                    isWritable: false
                },
                {
                    pubkey: params.authorizedPubkey,
                    isSigner: true,
                    isWritable: false
                }
            ],
            programId: this.programId,
            data: data
        };
        return new $163ae62b92845c86$export$a7a3aa8360ac9f59(instructionData);
    }
    /**
   * Generate a transaction instruction that withdraws lamports from a Nonce account
   */ static nonceWithdraw(params) {
        const type = $163ae62b92845c86$export$74bdf41d8d1e7108.WithdrawNonceAccount;
        const data = $163ae62b92845c86$var$encodeData(type, {
            lamports: params.lamports
        });
        return new $163ae62b92845c86$export$a7a3aa8360ac9f59({
            keys: [
                {
                    pubkey: params.noncePubkey,
                    isSigner: false,
                    isWritable: true
                },
                {
                    pubkey: params.toPubkey,
                    isSigner: false,
                    isWritable: true
                },
                {
                    pubkey: $163ae62b92845c86$export$e74201139e9833db,
                    isSigner: false,
                    isWritable: false
                },
                {
                    pubkey: $163ae62b92845c86$export$970d0190cdb3a8e9,
                    isSigner: false,
                    isWritable: false
                },
                {
                    pubkey: params.authorizedPubkey,
                    isSigner: true,
                    isWritable: false
                }
            ],
            programId: this.programId,
            data: data
        });
    }
    /**
   * Generate a transaction instruction that authorizes a new PublicKey as the authority
   * on a Nonce account.
   */ static nonceAuthorize(params) {
        const type = $163ae62b92845c86$export$74bdf41d8d1e7108.AuthorizeNonceAccount;
        const data = $163ae62b92845c86$var$encodeData(type, {
            authorized: $163ae62b92845c86$var$toBuffer(params.newAuthorizedPubkey.toBuffer())
        });
        return new $163ae62b92845c86$export$a7a3aa8360ac9f59({
            keys: [
                {
                    pubkey: params.noncePubkey,
                    isSigner: false,
                    isWritable: true
                },
                {
                    pubkey: params.authorizedPubkey,
                    isSigner: true,
                    isWritable: false
                }
            ],
            programId: this.programId,
            data: data
        });
    }
    /**
   * Generate a transaction instruction that allocates space in an account without funding
   */ static allocate(params) {
        let data;
        let keys;
        if ("basePubkey" in params) {
            const type = $163ae62b92845c86$export$74bdf41d8d1e7108.AllocateWithSeed;
            data = $163ae62b92845c86$var$encodeData(type, {
                base: $163ae62b92845c86$var$toBuffer(params.basePubkey.toBuffer()),
                seed: params.seed,
                space: params.space,
                programId: $163ae62b92845c86$var$toBuffer(params.programId.toBuffer())
            });
            keys = [
                {
                    pubkey: params.accountPubkey,
                    isSigner: false,
                    isWritable: true
                },
                {
                    pubkey: params.basePubkey,
                    isSigner: true,
                    isWritable: false
                }
            ];
        } else {
            const type = $163ae62b92845c86$export$74bdf41d8d1e7108.Allocate;
            data = $163ae62b92845c86$var$encodeData(type, {
                space: params.space
            });
            keys = [
                {
                    pubkey: params.accountPubkey,
                    isSigner: true,
                    isWritable: true
                }
            ];
        }
        return new $163ae62b92845c86$export$a7a3aa8360ac9f59({
            keys: keys,
            programId: this.programId,
            data: data
        });
    }
}
$163ae62b92845c86$export$d8c4e17726848113.programId = new $163ae62b92845c86$export$ca8b6604d6ce14de("11111111111111111111111111111111");
// Keep program chunks under PACKET_DATA_SIZE, leaving enough room for the
// rest of the Transaction fields
//
// TODO: replace 300 with a proper constant for the size of the other
// Transaction fields
const $163ae62b92845c86$var$CHUNK_SIZE = $163ae62b92845c86$export$4c6d5b89e1596f26 - 300;
/**
 * Program loader interface
 */ class $163ae62b92845c86$export$3b0d6d7590275603 {
    /**
   * @internal
   */ constructor(){}
    /**
   * Amount of program data placed in each load Transaction
   */ /**
   * Minimum number of signatures required to load a program not including
   * retries
   *
   * Can be used to calculate transaction fees
   */ static getMinNumSignatures(dataLength) {
        return 2 * // Every transaction requires two signatures (payer + program)
        (Math.ceil(dataLength / $163ae62b92845c86$export$3b0d6d7590275603.chunkSize) + 1 + // Add one for Create transaction
        1 // Add one for Finalize transaction
        );
    }
    /**
   * Loads a generic program
   *
   * @param connection The connection to use
   * @param payer System account that pays to load the program
   * @param program Account to load the program into
   * @param programId Public key that identifies the loader
   * @param data Program octets
   * @return true if program was loaded successfully, false if program was already loaded
   */ static async load(connection, payer, program, programId, data) {
        {
            const balanceNeeded = await connection.getMinimumBalanceForRentExemption(data.length);
            // Fetch program account info to check if it has already been created
            const programInfo = await connection.getAccountInfo(program.publicKey, "confirmed");
            let transaction = null;
            if (programInfo !== null) {
                if (programInfo.executable) {
                    console.error("Program load failed, account is already executable");
                    return false;
                }
                if (programInfo.data.length !== data.length) {
                    transaction = transaction || new $163ae62b92845c86$export$febc5573c75cefb0();
                    transaction.add($163ae62b92845c86$export$d8c4e17726848113.allocate({
                        accountPubkey: program.publicKey,
                        space: data.length
                    }));
                }
                if (!programInfo.owner.equals(programId)) {
                    transaction = transaction || new $163ae62b92845c86$export$febc5573c75cefb0();
                    transaction.add($163ae62b92845c86$export$d8c4e17726848113.assign({
                        accountPubkey: program.publicKey,
                        programId: programId
                    }));
                }
                if (programInfo.lamports < balanceNeeded) {
                    transaction = transaction || new $163ae62b92845c86$export$febc5573c75cefb0();
                    transaction.add($163ae62b92845c86$export$d8c4e17726848113.transfer({
                        fromPubkey: payer.publicKey,
                        toPubkey: program.publicKey,
                        lamports: balanceNeeded - programInfo.lamports
                    }));
                }
            } else transaction = new $163ae62b92845c86$export$febc5573c75cefb0().add($163ae62b92845c86$export$d8c4e17726848113.createAccount({
                fromPubkey: payer.publicKey,
                newAccountPubkey: program.publicKey,
                lamports: balanceNeeded > 0 ? balanceNeeded : 1,
                space: data.length,
                programId: programId
            }));
            // If the account is already created correctly, skip this step
            // and proceed directly to loading instructions
            if (transaction !== null) await $163ae62b92845c86$export$4ad6fe6dae0b6bc3(connection, transaction, [
                payer,
                program
            ], {
                commitment: "confirmed"
            });
        }
        const dataLayout = $2913ed74210dce84$exports.struct([
            $2913ed74210dce84$exports.u32("instruction"),
            $2913ed74210dce84$exports.u32("offset"),
            $2913ed74210dce84$exports.u32("bytesLength"),
            $2913ed74210dce84$exports.u32("bytesLengthPadding"),
            $2913ed74210dce84$exports.seq($2913ed74210dce84$exports.u8("byte"), $2913ed74210dce84$exports.offset($2913ed74210dce84$exports.u32(), -8), "bytes")
        ]);
        const chunkSize = $163ae62b92845c86$export$3b0d6d7590275603.chunkSize;
        let offset = 0;
        let array = data;
        let transactions = [];
        while(array.length > 0){
            const bytes = array.slice(0, chunkSize);
            const data = (0, $5ed0747d5916bbd8$export$a143d493d941bafc).alloc(chunkSize + 16);
            dataLayout.encode({
                instruction: 0,
                offset: // Load instruction
                offset,
                bytes: bytes,
                bytesLength: 0,
                bytesLengthPadding: 0
            }, data);
            const transaction = new $163ae62b92845c86$export$febc5573c75cefb0().add({
                keys: [
                    {
                        pubkey: program.publicKey,
                        isSigner: true,
                        isWritable: true
                    }
                ],
                programId: programId,
                data: data
            });
            transactions.push($163ae62b92845c86$export$4ad6fe6dae0b6bc3(connection, transaction, [
                payer,
                program
            ], {
                commitment: "confirmed"
            }));
            // Delay between sends in an attempt to reduce rate limit errors
            if (connection._rpcEndpoint.includes("solana.com")) {
                const REQUESTS_PER_SECOND = 4;
                await $163ae62b92845c86$var$sleep(1000 / REQUESTS_PER_SECOND);
            }
            offset += chunkSize;
            array = array.slice(chunkSize);
        }
        await Promise.all(transactions);
        // Finalize the account loaded with program data for execution
        {
            const dataLayout = $2913ed74210dce84$exports.struct([
                $2913ed74210dce84$exports.u32("instruction")
            ]);
            const data = (0, $5ed0747d5916bbd8$export$a143d493d941bafc).alloc(dataLayout.span);
            dataLayout.encode({
                instruction: 1 // Finalize instruction
            }, data);
            const transaction = new $163ae62b92845c86$export$febc5573c75cefb0().add({
                keys: [
                    {
                        pubkey: program.publicKey,
                        isSigner: true,
                        isWritable: true
                    },
                    {
                        pubkey: $163ae62b92845c86$export$970d0190cdb3a8e9,
                        isSigner: false,
                        isWritable: false
                    }
                ],
                programId: programId,
                data: data
            });
            const deployCommitment = "processed";
            const finalizeSignature = await connection.sendTransaction(transaction, [
                payer,
                program
            ], {
                preflightCommitment: deployCommitment
            });
            const { context: context, value: value } = await connection.confirmTransaction({
                signature: finalizeSignature,
                lastValidBlockHeight: transaction.lastValidBlockHeight,
                blockhash: transaction.recentBlockhash
            }, deployCommitment);
            if (value.err) throw new Error(`Transaction ${finalizeSignature} failed (${JSON.stringify(value)})`);
            // We prevent programs from being usable until the slot after their deployment.
            // See https://github.com/solana-labs/solana/pull/29654
            while(true // eslint-disable-line no-constant-condition
            ){
                try {
                    const currentSlot = await connection.getSlot({
                        commitment: deployCommitment
                    });
                    if (currentSlot > context.slot) break;
                } catch  {
                /* empty */ }
                await new Promise((resolve)=>setTimeout(resolve, Math.round($163ae62b92845c86$var$MS_PER_SLOT / 2)));
            }
        }
        // success
        return true;
    }
}
$163ae62b92845c86$export$3b0d6d7590275603.chunkSize = $163ae62b92845c86$var$CHUNK_SIZE;
const $163ae62b92845c86$export$59833422f998b937 = new $163ae62b92845c86$export$ca8b6604d6ce14de("BPFLoader2111111111111111111111111111111111");
/**
 * Factory class for transactions to interact with a program loader
 */ class $163ae62b92845c86$export$493be68e6a240d3b {
    /**
   * Minimum number of signatures required to load a program not including
   * retries
   *
   * Can be used to calculate transaction fees
   */ static getMinNumSignatures(dataLength) {
        return $163ae62b92845c86$export$3b0d6d7590275603.getMinNumSignatures(dataLength);
    }
    /**
   * Load a SBF program
   *
   * @param connection The connection to use
   * @param payer Account that will pay program loading fees
   * @param program Account to load the program into
   * @param elf The entire ELF containing the SBF program
   * @param loaderProgramId The program id of the BPF loader to use
   * @return true if program was loaded successfully, false if program was already loaded
   */ static load(connection, payer, program, elf, loaderProgramId) {
        return $163ae62b92845c86$export$3b0d6d7590275603.load(connection, payer, program, loaderProgramId, elf);
    }
}
function $163ae62b92845c86$var$getDefaultExportFromCjs(x) {
    return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, "default") ? x["default"] : x;
}
var $163ae62b92845c86$var$objToString = Object.prototype.toString;
var $163ae62b92845c86$var$objKeys = Object.keys || function(obj) {
    var keys = [];
    for(var name in obj)keys.push(name);
    return keys;
};
function $163ae62b92845c86$var$stringify(val, isArrayProp) {
    var i, max, str, keys, key, propVal, toStr;
    if (val === true) return "true";
    if (val === false) return "false";
    switch(typeof val){
        case "object":
            if (val === null) return null;
            else if (val.toJSON && typeof val.toJSON === "function") return $163ae62b92845c86$var$stringify(val.toJSON(), isArrayProp);
            else {
                toStr = $163ae62b92845c86$var$objToString.call(val);
                if (toStr === "[object Array]") {
                    str = "[";
                    max = val.length - 1;
                    for(i = 0; i < max; i++)str += $163ae62b92845c86$var$stringify(val[i], true) + ",";
                    if (max > -1) str += $163ae62b92845c86$var$stringify(val[i], true);
                    return str + "]";
                } else if (toStr === "[object Object]") {
                    // only object is left
                    keys = $163ae62b92845c86$var$objKeys(val).sort();
                    max = keys.length;
                    str = "";
                    i = 0;
                    while(i < max){
                        key = keys[i];
                        propVal = $163ae62b92845c86$var$stringify(val[key], false);
                        if (propVal !== undefined) {
                            if (str) str += ",";
                            str += JSON.stringify(key) + ":" + propVal;
                        }
                        i++;
                    }
                    return "{" + str + "}";
                } else return JSON.stringify(val);
            }
        case "function":
        case "undefined":
            return isArrayProp ? null : undefined;
        case "string":
            return JSON.stringify(val);
        default:
            return isFinite(val) ? val : null;
    }
}
var $163ae62b92845c86$var$fastStableStringify = function(val) {
    var returnVal = $163ae62b92845c86$var$stringify(val, false);
    if (returnVal !== undefined) return "" + returnVal;
};
var $163ae62b92845c86$var$fastStableStringify$1 = /*@__PURE__*/ $163ae62b92845c86$var$getDefaultExportFromCjs($163ae62b92845c86$var$fastStableStringify);
const $163ae62b92845c86$var$MINIMUM_SLOT_PER_EPOCH = 32;
// Returns the number of trailing zeros in the binary representation of self.
function $163ae62b92845c86$var$trailingZeros(n) {
    let trailingZeros = 0;
    while(n > 1){
        n /= 2;
        trailingZeros++;
    }
    return trailingZeros;
}
// Returns the smallest power of two greater than or equal to n
function $163ae62b92845c86$var$nextPowerOfTwo(n) {
    if (n === 0) return 1;
    n--;
    n |= n >> 1;
    n |= n >> 2;
    n |= n >> 4;
    n |= n >> 8;
    n |= n >> 16;
    n |= n >> 32;
    return n + 1;
}
/**
 * Epoch schedule
 * (see https://docs.solana.com/terminology#epoch)
 * Can be retrieved with the {@link Connection.getEpochSchedule} method
 */ class $163ae62b92845c86$export$df8ed3e830b1d591 {
    constructor(slotsPerEpoch, leaderScheduleSlotOffset, warmup, firstNormalEpoch, firstNormalSlot){
        /** The maximum number of slots in each epoch */ this.slotsPerEpoch = void 0;
        /** The number of slots before beginning of an epoch to calculate a leader schedule for that epoch */ this.leaderScheduleSlotOffset = void 0;
        /** Indicates whether epochs start short and grow */ this.warmup = void 0;
        /** The first epoch with `slotsPerEpoch` slots */ this.firstNormalEpoch = void 0;
        /** The first slot of `firstNormalEpoch` */ this.firstNormalSlot = void 0;
        this.slotsPerEpoch = slotsPerEpoch;
        this.leaderScheduleSlotOffset = leaderScheduleSlotOffset;
        this.warmup = warmup;
        this.firstNormalEpoch = firstNormalEpoch;
        this.firstNormalSlot = firstNormalSlot;
    }
    getEpoch(slot) {
        return this.getEpochAndSlotIndex(slot)[0];
    }
    getEpochAndSlotIndex(slot) {
        if (slot < this.firstNormalSlot) {
            const epoch = $163ae62b92845c86$var$trailingZeros($163ae62b92845c86$var$nextPowerOfTwo(slot + $163ae62b92845c86$var$MINIMUM_SLOT_PER_EPOCH + 1)) - $163ae62b92845c86$var$trailingZeros($163ae62b92845c86$var$MINIMUM_SLOT_PER_EPOCH) - 1;
            const epochLen = this.getSlotsInEpoch(epoch);
            const slotIndex = slot - (epochLen - $163ae62b92845c86$var$MINIMUM_SLOT_PER_EPOCH);
            return [
                epoch,
                slotIndex
            ];
        } else {
            const normalSlotIndex = slot - this.firstNormalSlot;
            const normalEpochIndex = Math.floor(normalSlotIndex / this.slotsPerEpoch);
            const epoch = this.firstNormalEpoch + normalEpochIndex;
            const slotIndex = normalSlotIndex % this.slotsPerEpoch;
            return [
                epoch,
                slotIndex
            ];
        }
    }
    getFirstSlotInEpoch(epoch) {
        if (epoch <= this.firstNormalEpoch) return (Math.pow(2, epoch) - 1) * $163ae62b92845c86$var$MINIMUM_SLOT_PER_EPOCH;
        else return (epoch - this.firstNormalEpoch) * this.slotsPerEpoch + this.firstNormalSlot;
    }
    getLastSlotInEpoch(epoch) {
        return this.getFirstSlotInEpoch(epoch) + this.getSlotsInEpoch(epoch) - 1;
    }
    getSlotsInEpoch(epoch) {
        if (epoch < this.firstNormalEpoch) return Math.pow(2, epoch + $163ae62b92845c86$var$trailingZeros($163ae62b92845c86$var$MINIMUM_SLOT_PER_EPOCH));
        else return this.slotsPerEpoch;
    }
}
class $163ae62b92845c86$export$121e803f723b3045 extends Error {
    constructor(message, logs){
        super(message);
        this.logs = void 0;
        this.logs = logs;
    }
}
// Keep in sync with client/src/rpc_custom_errors.rs
// Typescript `enums` thwart tree-shaking. See https://bargsten.org/jsts/enums/
const $163ae62b92845c86$export$e5e9869922dd22f8 = {
    JSON_RPC_SERVER_ERROR_BLOCK_CLEANED_UP: -32001,
    JSON_RPC_SERVER_ERROR_SEND_TRANSACTION_PREFLIGHT_FAILURE: -32002,
    JSON_RPC_SERVER_ERROR_TRANSACTION_SIGNATURE_VERIFICATION_FAILURE: -32003,
    JSON_RPC_SERVER_ERROR_BLOCK_NOT_AVAILABLE: -32004,
    JSON_RPC_SERVER_ERROR_NODE_UNHEALTHY: -32005,
    JSON_RPC_SERVER_ERROR_TRANSACTION_PRECOMPILE_VERIFICATION_FAILURE: -32006,
    JSON_RPC_SERVER_ERROR_SLOT_SKIPPED: -32007,
    JSON_RPC_SERVER_ERROR_NO_SNAPSHOT: -32008,
    JSON_RPC_SERVER_ERROR_LONG_TERM_STORAGE_SLOT_SKIPPED: -32009,
    JSON_RPC_SERVER_ERROR_KEY_EXCLUDED_FROM_SECONDARY_INDEX: -32010,
    JSON_RPC_SERVER_ERROR_TRANSACTION_HISTORY_NOT_AVAILABLE: -32011,
    JSON_RPC_SCAN_ERROR: -32012,
    JSON_RPC_SERVER_ERROR_TRANSACTION_SIGNATURE_LEN_MISMATCH: -32013,
    JSON_RPC_SERVER_ERROR_BLOCK_STATUS_NOT_AVAILABLE_YET: -32014,
    JSON_RPC_SERVER_ERROR_UNSUPPORTED_TRANSACTION_VERSION: -32015,
    JSON_RPC_SERVER_ERROR_MIN_CONTEXT_SLOT_NOT_REACHED: -32016
};
class $163ae62b92845c86$export$ea1b1a1bba5c14ad extends Error {
    constructor({ code: code, message: message, data: data }, customMessage){
        super(customMessage != null ? `${customMessage}: ${message}` : message);
        this.code = void 0;
        this.data = void 0;
        this.code = code;
        this.data = data;
        this.name = "SolanaJSONRPCError";
    }
}
var $163ae62b92845c86$var$fetchImpl = globalThis.fetch;
class $163ae62b92845c86$var$RpcWebSocketClient extends (0, (/*@__PURE__*/$parcel$interopDefault($5d5e6dd86cf1d7bc$exports))) {
    constructor(address, options, generate_request_id){
        const webSocketFactory = (url)=>{
            const rpc = (0, (/*@__PURE__*/$parcel$interopDefault($506ecc9a680f3f9d$exports)))(url, {
                autoconnect: true,
                max_reconnects: 5,
                reconnect: true,
                reconnect_interval: 1000,
                ...options
            });
            if ("socket" in rpc) this.underlyingSocket = rpc.socket;
            else this.underlyingSocket = rpc;
            return rpc;
        };
        super(webSocketFactory, address, options, generate_request_id);
        this.underlyingSocket = void 0;
    }
    call(...args) {
        const readyState = this.underlyingSocket?.readyState;
        if (readyState === 1 /* WebSocket.OPEN */ ) return super.call(...args);
        return Promise.reject(new Error("Tried to call a JSON-RPC method `" + args[0] + "` but the socket was not `CONNECTING` or `OPEN` (`readyState` was " + readyState + ")"));
    }
    notify(...args) {
        const readyState = this.underlyingSocket?.readyState;
        if (readyState === 1 /* WebSocket.OPEN */ ) return super.notify(...args);
        return Promise.reject(new Error("Tried to send a JSON-RPC notification `" + args[0] + "` but the socket was not `CONNECTING` or `OPEN` (`readyState` was " + readyState + ")"));
    }
}
/**
 * @internal
 */ /**
 * Decode account data buffer using an AccountType
 * @internal
 */ function $163ae62b92845c86$var$decodeData(type, data) {
    let decoded;
    try {
        decoded = type.layout.decode(data);
    } catch (err) {
        throw new Error("invalid instruction; " + err);
    }
    if (decoded.typeIndex !== type.index) throw new Error(`invalid account data; account type mismatch ${decoded.typeIndex} != ${type.index}`);
    return decoded;
}
/// The serialized size of lookup table metadata
const $163ae62b92845c86$var$LOOKUP_TABLE_META_SIZE = 56;
class $163ae62b92845c86$export$5b2310da10e607da {
    constructor(args){
        this.key = void 0;
        this.state = void 0;
        this.key = args.key;
        this.state = args.state;
    }
    isActive() {
        const U64_MAX = BigInt("0xffffffffffffffff");
        return this.state.deactivationSlot === U64_MAX;
    }
    static deserialize(accountData) {
        const meta = $163ae62b92845c86$var$decodeData($163ae62b92845c86$var$LookupTableMetaLayout, accountData);
        const serializedAddressesLen = accountData.length - $163ae62b92845c86$var$LOOKUP_TABLE_META_SIZE;
        $163ae62b92845c86$var$assert(serializedAddressesLen >= 0, "lookup table is invalid");
        $163ae62b92845c86$var$assert(serializedAddressesLen % 32 === 0, "lookup table is invalid");
        const numSerializedAddresses = serializedAddressesLen / 32;
        const { addresses: addresses } = $2913ed74210dce84$exports.struct([
            $2913ed74210dce84$exports.seq($163ae62b92845c86$var$publicKey(), numSerializedAddresses, "addresses")
        ]).decode(accountData.slice($163ae62b92845c86$var$LOOKUP_TABLE_META_SIZE));
        return {
            deactivationSlot: meta.deactivationSlot,
            lastExtendedSlot: meta.lastExtendedSlot,
            lastExtendedSlotStartIndex: meta.lastExtendedStartIndex,
            authority: meta.authority.length !== 0 ? new $163ae62b92845c86$export$ca8b6604d6ce14de(meta.authority[0]) : undefined,
            addresses: addresses.map((address)=>new $163ae62b92845c86$export$ca8b6604d6ce14de(address))
        };
    }
}
const $163ae62b92845c86$var$LookupTableMetaLayout = {
    index: 1,
    layout: $2913ed74210dce84$exports.struct([
        $2913ed74210dce84$exports.u32("typeIndex"),
        $163ae62b92845c86$var$u64("deactivationSlot"),
        $2913ed74210dce84$exports.nu64("lastExtendedSlot"),
        $2913ed74210dce84$exports.u8("lastExtendedStartIndex"),
        $2913ed74210dce84$exports.u8(),
        // option
        $2913ed74210dce84$exports.seq($163ae62b92845c86$var$publicKey(), $2913ed74210dce84$exports.offset($2913ed74210dce84$exports.u8(), -1), "authority")
    ])
};
const $163ae62b92845c86$var$URL_RE = /^[^:]+:\/\/([^:[]+|\[[^\]]+\])(:\d+)?(.*)/i;
function $163ae62b92845c86$var$makeWebsocketUrl(endpoint) {
    const matches = endpoint.match($163ae62b92845c86$var$URL_RE);
    if (matches == null) throw TypeError(`Failed to validate endpoint URL \`${endpoint}\``);
    const [_, // eslint-disable-line @typescript-eslint/no-unused-vars
    hostish, portWithColon, rest] = matches;
    const protocol = endpoint.startsWith("https:") ? "wss:" : "ws:";
    const startPort = portWithColon == null ? null : parseInt(portWithColon.slice(1), 10);
    const websocketPort = // Only shift the port by +1 as a convention for ws(s) only if given endpoint
    // is explicitly specifying the endpoint port (HTTP-based RPC), assuming
    // we're directly trying to connect to solana-validator's ws listening port.
    // When the endpoint omits the port, we're connecting to the protocol
    // default ports: http(80) or https(443) and it's assumed we're behind a reverse
    // proxy which manages WebSocket upgrade and backend port redirection.
    startPort == null ? "" : `:${startPort + 1}`;
    return `${protocol}//${hostish}${websocketPort}${rest}`;
}
const $163ae62b92845c86$var$PublicKeyFromString = (0, $7154594b4f0d1928$export$8c14e57e778d3873)((0, $7154594b4f0d1928$export$9544d5bb712b01ea)($163ae62b92845c86$export$ca8b6604d6ce14de), (0, $7154594b4f0d1928$export$22b082955e083ec3)(), (value)=>new $163ae62b92845c86$export$ca8b6604d6ce14de(value));
const $163ae62b92845c86$var$RawAccountDataResult = (0, $7154594b4f0d1928$export$65e3907585753458)([
    (0, $7154594b4f0d1928$export$22b082955e083ec3)(),
    (0, $7154594b4f0d1928$export$c8ec6e1ec9fefcb0)("base64")
]);
const $163ae62b92845c86$var$BufferFromRawAccountData = (0, $7154594b4f0d1928$export$8c14e57e778d3873)((0, $7154594b4f0d1928$export$9544d5bb712b01ea)((0, $5ed0747d5916bbd8$export$a143d493d941bafc)), $163ae62b92845c86$var$RawAccountDataResult, (value)=>(0, $5ed0747d5916bbd8$export$a143d493d941bafc).from(value[0], "base64"));
/**
 * Attempt to use a recent blockhash for up to 30 seconds
 * @internal
 */ const $163ae62b92845c86$export$fcb705732fb5c597 = 30000;
/**
 * HACK.
 * Copied from rpc-websockets/dist/lib/client.
 * Otherwise, `yarn build` fails with:
 * https://gist.github.com/steveluscher/c057eca81d479ef705cdb53162f9971d
 */ /** @internal */ /** @internal */ /** @internal */ /** @internal */ /** @internal */ /**
 * @internal
 * Every subscription contains the args used to open the subscription with
 * the server, and a list of callers interested in notifications.
 */ /**
 * @internal
 * A subscription may be in various states of connectedness. Only when it is
 * fully connected will it have a server subscription id associated with it.
 * This id can be returned to the server to unsubscribe the client entirely.
 */ /**
 * A type that encapsulates a subscription's RPC method
 * names and notification (callback) signature.
 */ /**
 * @internal
 * Utility type that keeps tagged unions intact while omitting properties.
 */ /**
 * @internal
 * This type represents a single subscribable 'topic.' It's made up of:
 *
 * - The args used to open the subscription with the server,
 * - The state of the subscription, in terms of its connectedness, and
 * - The set of callbacks to call when the server publishes notifications
 *
 * This record gets indexed by `SubscriptionConfigHash` and is used to
 * set up subscriptions, fan out notifications, and track subscription state.
 */ /**
 * @internal
 */ /**
 * Extra contextual information for RPC responses
 */ /**
 * Options for sending transactions
 */ /**
 * Options for confirming transactions
 */ /**
 * Options for getConfirmedSignaturesForAddress2
 */ /**
 * Options for getSignaturesForAddress
 */ /**
 * RPC Response with extra contextual information
 */ /**
 * A strategy for confirming transactions that uses the last valid
 * block height for a given blockhash to check for transaction expiration.
 */ /**
 * A strategy for confirming durable nonce transactions.
 */ /**
 * Properties shared by all transaction confirmation strategies
 */ /**
 * This type represents all transaction confirmation strategies
 */ /* @internal */ function $163ae62b92845c86$var$assertEndpointUrl(putativeUrl) {
    if (/^https?:/.test(putativeUrl) === false) throw new TypeError("Endpoint URL must start with `http:` or `https:`.");
    return putativeUrl;
}
/** @internal */ function $163ae62b92845c86$var$extractCommitmentFromConfig(commitmentOrConfig) {
    let commitment;
    let config;
    if (typeof commitmentOrConfig === "string") commitment = commitmentOrConfig;
    else if (commitmentOrConfig) {
        const { commitment: specifiedCommitment, ...specifiedConfig } = commitmentOrConfig;
        commitment = specifiedCommitment;
        config = specifiedConfig;
    }
    return {
        commitment: commitment,
        config: config
    };
}
/**
 * @internal
 */ function $163ae62b92845c86$var$createRpcResult(result) {
    return (0, $7154594b4f0d1928$export$971dd5b0dfd021b6)([
        (0, $7154594b4f0d1928$export$bf9fb029d174d554)({
            jsonrpc: (0, $7154594b4f0d1928$export$c8ec6e1ec9fefcb0)("2.0"),
            id: (0, $7154594b4f0d1928$export$22b082955e083ec3)(),
            result: result
        }),
        (0, $7154594b4f0d1928$export$bf9fb029d174d554)({
            jsonrpc: (0, $7154594b4f0d1928$export$c8ec6e1ec9fefcb0)("2.0"),
            id: (0, $7154594b4f0d1928$export$22b082955e083ec3)(),
            error: (0, $7154594b4f0d1928$export$bf9fb029d174d554)({
                code: (0, $7154594b4f0d1928$export$19282c40b967aec6)(),
                message: (0, $7154594b4f0d1928$export$22b082955e083ec3)(),
                data: (0, $7154594b4f0d1928$export$516e28dec6a4b6d4)((0, $7154594b4f0d1928$export$4154a199d7d90455)())
            })
        })
    ]);
}
const $163ae62b92845c86$var$UnknownRpcResult = $163ae62b92845c86$var$createRpcResult((0, $7154594b4f0d1928$export$19282c40b967aec6)());
/**
 * @internal
 */ function $163ae62b92845c86$var$jsonRpcResult(schema) {
    return (0, $7154594b4f0d1928$export$8c14e57e778d3873)($163ae62b92845c86$var$createRpcResult(schema), $163ae62b92845c86$var$UnknownRpcResult, (value)=>{
        if ("error" in value) return value;
        else return {
            ...value,
            result: (0, $7154594b4f0d1928$export$185802fd694ee1f5)(value.result, schema)
        };
    });
}
/**
 * @internal
 */ function $163ae62b92845c86$var$jsonRpcResultAndContext(value) {
    return $163ae62b92845c86$var$jsonRpcResult((0, $7154594b4f0d1928$export$bf9fb029d174d554)({
        context: (0, $7154594b4f0d1928$export$bf9fb029d174d554)({
            slot: (0, $7154594b4f0d1928$export$98e628dec113755e)()
        }),
        value: value
    }));
}
/**
 * @internal
 */ function $163ae62b92845c86$var$notificationResultAndContext(value) {
    return (0, $7154594b4f0d1928$export$bf9fb029d174d554)({
        context: (0, $7154594b4f0d1928$export$bf9fb029d174d554)({
            slot: (0, $7154594b4f0d1928$export$98e628dec113755e)()
        }),
        value: value
    });
}
/**
 * @internal
 */ function $163ae62b92845c86$var$versionedMessageFromResponse(version, response) {
    if (version === 0) return new $163ae62b92845c86$export$ee274c70e0fae590({
        header: response.header,
        staticAccountKeys: response.accountKeys.map((accountKey)=>new $163ae62b92845c86$export$ca8b6604d6ce14de(accountKey)),
        recentBlockhash: response.recentBlockhash,
        compiledInstructions: response.instructions.map((ix)=>({
                programIdIndex: ix.programIdIndex,
                accountKeyIndexes: ix.accounts,
                data: (0, (/*@__PURE__*/$parcel$interopDefault($hZS7n))).decode(ix.data)
            })),
        addressTableLookups: response.addressTableLookups
    });
    else return new $163ae62b92845c86$export$f69c19e57285b83a(response);
}
/**
 * The level of commitment desired when querying state
 * <pre>
 *   'processed': Query the most recent block which has reached 1 confirmation by the connected node
 *   'confirmed': Query the most recent block which has reached 1 confirmation by the cluster
 *   'finalized': Query the most recent block which has been finalized by the cluster
 * </pre>
 */ // Deprecated as of v1.5.5
/**
 * A subset of Commitment levels, which are at least optimistically confirmed
 * <pre>
 *   'confirmed': Query the most recent block which has reached 1 confirmation by the cluster
 *   'finalized': Query the most recent block which has been finalized by the cluster
 * </pre>
 */ /**
 * Filter for largest accounts query
 * <pre>
 *   'circulating':    Return the largest accounts that are part of the circulating supply
 *   'nonCirculating': Return the largest accounts that are not part of the circulating supply
 * </pre>
 */ /**
 * Configuration object for changing `getAccountInfo` query behavior
 */ /**
 * Configuration object for changing `getBalance` query behavior
 */ /**
 * Configuration object for changing `getBlock` query behavior
 */ /**
 * Configuration object for changing `getBlock` query behavior
 */ /**
 * Configuration object for changing `getStakeMinimumDelegation` query behavior
 */ /**
 * Configuration object for changing `getBlockHeight` query behavior
 */ /**
 * Configuration object for changing `getEpochInfo` query behavior
 */ /**
 * Configuration object for changing `getInflationReward` query behavior
 */ /**
 * Configuration object for changing `getLatestBlockhash` query behavior
 */ /**
 * Configuration object for changing `isBlockhashValid` query behavior
 */ /**
 * Configuration object for changing `getSlot` query behavior
 */ /**
 * Configuration object for changing `getSlotLeader` query behavior
 */ /**
 * Configuration object for changing `getTransaction` query behavior
 */ /**
 * Configuration object for changing `getTransaction` query behavior
 */ /**
 * Configuration object for changing `getLargestAccounts` query behavior
 */ /**
 * Configuration object for changing `getSupply` request behavior
 */ /**
 * Configuration object for changing query behavior
 */ /**
 * Information describing a cluster node
 */ /**
 * Information describing a vote account
 */ /**
 * A collection of cluster vote accounts
 */ /**
 * Network Inflation
 * (see https://docs.solana.com/implemented-proposals/ed_overview)
 */ const $163ae62b92845c86$var$GetInflationGovernorResult = (0, $7154594b4f0d1928$export$bf9fb029d174d554)({
    foundation: (0, $7154594b4f0d1928$export$98e628dec113755e)(),
    foundationTerm: (0, $7154594b4f0d1928$export$98e628dec113755e)(),
    initial: (0, $7154594b4f0d1928$export$98e628dec113755e)(),
    taper: (0, $7154594b4f0d1928$export$98e628dec113755e)(),
    terminal: (0, $7154594b4f0d1928$export$98e628dec113755e)()
});
/**
 * The inflation reward for an epoch
 */ /**
 * Expected JSON RPC response for the "getInflationReward" message
 */ const $163ae62b92845c86$var$GetInflationRewardResult = $163ae62b92845c86$var$jsonRpcResult((0, $7154594b4f0d1928$export$2f23118c22fb2630)((0, $7154594b4f0d1928$export$133fc36489ac9add)((0, $7154594b4f0d1928$export$bf9fb029d174d554)({
    epoch: (0, $7154594b4f0d1928$export$98e628dec113755e)(),
    effectiveSlot: (0, $7154594b4f0d1928$export$98e628dec113755e)(),
    amount: (0, $7154594b4f0d1928$export$98e628dec113755e)(),
    postBalance: (0, $7154594b4f0d1928$export$98e628dec113755e)(),
    commission: (0, $7154594b4f0d1928$export$516e28dec6a4b6d4)((0, $7154594b4f0d1928$export$133fc36489ac9add)((0, $7154594b4f0d1928$export$98e628dec113755e)()))
}))));
/**
 * Configuration object for changing `getRecentPrioritizationFees` query behavior
 */ /**
 * Expected JSON RPC response for the "getRecentPrioritizationFees" message
 */ const $163ae62b92845c86$var$GetRecentPrioritizationFeesResult = (0, $7154594b4f0d1928$export$2f23118c22fb2630)((0, $7154594b4f0d1928$export$bf9fb029d174d554)({
    slot: (0, $7154594b4f0d1928$export$98e628dec113755e)(),
    prioritizationFee: (0, $7154594b4f0d1928$export$98e628dec113755e)()
}));
/**
 * Expected JSON RPC response for the "getInflationRate" message
 */ const $163ae62b92845c86$var$GetInflationRateResult = (0, $7154594b4f0d1928$export$bf9fb029d174d554)({
    total: (0, $7154594b4f0d1928$export$98e628dec113755e)(),
    validator: (0, $7154594b4f0d1928$export$98e628dec113755e)(),
    foundation: (0, $7154594b4f0d1928$export$98e628dec113755e)(),
    epoch: (0, $7154594b4f0d1928$export$98e628dec113755e)()
});
/**
 * Information about the current epoch
 */ const $163ae62b92845c86$var$GetEpochInfoResult = (0, $7154594b4f0d1928$export$bf9fb029d174d554)({
    epoch: (0, $7154594b4f0d1928$export$98e628dec113755e)(),
    slotIndex: (0, $7154594b4f0d1928$export$98e628dec113755e)(),
    slotsInEpoch: (0, $7154594b4f0d1928$export$98e628dec113755e)(),
    absoluteSlot: (0, $7154594b4f0d1928$export$98e628dec113755e)(),
    blockHeight: (0, $7154594b4f0d1928$export$516e28dec6a4b6d4)((0, $7154594b4f0d1928$export$98e628dec113755e)()),
    transactionCount: (0, $7154594b4f0d1928$export$516e28dec6a4b6d4)((0, $7154594b4f0d1928$export$98e628dec113755e)())
});
const $163ae62b92845c86$var$GetEpochScheduleResult = (0, $7154594b4f0d1928$export$bf9fb029d174d554)({
    slotsPerEpoch: (0, $7154594b4f0d1928$export$98e628dec113755e)(),
    leaderScheduleSlotOffset: (0, $7154594b4f0d1928$export$98e628dec113755e)(),
    warmup: (0, $7154594b4f0d1928$export$4a21f16c33752377)(),
    firstNormalEpoch: (0, $7154594b4f0d1928$export$98e628dec113755e)(),
    firstNormalSlot: (0, $7154594b4f0d1928$export$98e628dec113755e)()
});
/**
 * Leader schedule
 * (see https://docs.solana.com/terminology#leader-schedule)
 */ const $163ae62b92845c86$var$GetLeaderScheduleResult = (0, $7154594b4f0d1928$export$e5185e241753e543)((0, $7154594b4f0d1928$export$22b082955e083ec3)(), (0, $7154594b4f0d1928$export$2f23118c22fb2630)((0, $7154594b4f0d1928$export$98e628dec113755e)()));
/**
 * Transaction error or null
 */ const $163ae62b92845c86$var$TransactionErrorResult = (0, $7154594b4f0d1928$export$133fc36489ac9add)((0, $7154594b4f0d1928$export$971dd5b0dfd021b6)([
    (0, $7154594b4f0d1928$export$bf9fb029d174d554)({}),
    (0, $7154594b4f0d1928$export$22b082955e083ec3)()
]));
/**
 * Signature status for a transaction
 */ const $163ae62b92845c86$var$SignatureStatusResult = (0, $7154594b4f0d1928$export$bf9fb029d174d554)({
    err: $163ae62b92845c86$var$TransactionErrorResult
});
/**
 * Transaction signature received notification
 */ const $163ae62b92845c86$var$SignatureReceivedResult = (0, $7154594b4f0d1928$export$c8ec6e1ec9fefcb0)("receivedSignature");
/**
 * Version info for a node
 */ const $163ae62b92845c86$var$VersionResult = (0, $7154594b4f0d1928$export$bf9fb029d174d554)({
    "solana-core": (0, $7154594b4f0d1928$export$22b082955e083ec3)(),
    "feature-set": (0, $7154594b4f0d1928$export$516e28dec6a4b6d4)((0, $7154594b4f0d1928$export$98e628dec113755e)())
});
const $163ae62b92845c86$var$SimulatedTransactionResponseStruct = $163ae62b92845c86$var$jsonRpcResultAndContext((0, $7154594b4f0d1928$export$bf9fb029d174d554)({
    err: (0, $7154594b4f0d1928$export$133fc36489ac9add)((0, $7154594b4f0d1928$export$971dd5b0dfd021b6)([
        (0, $7154594b4f0d1928$export$bf9fb029d174d554)({}),
        (0, $7154594b4f0d1928$export$22b082955e083ec3)()
    ])),
    logs: (0, $7154594b4f0d1928$export$133fc36489ac9add)((0, $7154594b4f0d1928$export$2f23118c22fb2630)((0, $7154594b4f0d1928$export$22b082955e083ec3)())),
    accounts: (0, $7154594b4f0d1928$export$516e28dec6a4b6d4)((0, $7154594b4f0d1928$export$133fc36489ac9add)((0, $7154594b4f0d1928$export$2f23118c22fb2630)((0, $7154594b4f0d1928$export$133fc36489ac9add)((0, $7154594b4f0d1928$export$bf9fb029d174d554)({
        executable: (0, $7154594b4f0d1928$export$4a21f16c33752377)(),
        owner: (0, $7154594b4f0d1928$export$22b082955e083ec3)(),
        lamports: (0, $7154594b4f0d1928$export$98e628dec113755e)(),
        data: (0, $7154594b4f0d1928$export$2f23118c22fb2630)((0, $7154594b4f0d1928$export$22b082955e083ec3)()),
        rentEpoch: (0, $7154594b4f0d1928$export$516e28dec6a4b6d4)((0, $7154594b4f0d1928$export$98e628dec113755e)())
    }))))),
    unitsConsumed: (0, $7154594b4f0d1928$export$516e28dec6a4b6d4)((0, $7154594b4f0d1928$export$98e628dec113755e)()),
    returnData: (0, $7154594b4f0d1928$export$516e28dec6a4b6d4)((0, $7154594b4f0d1928$export$133fc36489ac9add)((0, $7154594b4f0d1928$export$bf9fb029d174d554)({
        programId: (0, $7154594b4f0d1928$export$22b082955e083ec3)(),
        data: (0, $7154594b4f0d1928$export$65e3907585753458)([
            (0, $7154594b4f0d1928$export$22b082955e083ec3)(),
            (0, $7154594b4f0d1928$export$c8ec6e1ec9fefcb0)("base64")
        ])
    })))
}));
/**
 * Metadata for a parsed confirmed transaction on the ledger
 *
 * @deprecated Deprecated since Solana v1.8.0. Please use {@link ParsedTransactionMeta} instead.
 */ /**
 * Collection of addresses loaded by a transaction using address table lookups
 */ /**
 * Metadata for a parsed transaction on the ledger
 */ /**
 * Metadata for a confirmed transaction on the ledger
 */ /**
 * A processed transaction from the RPC API
 */ /**
 * A processed transaction from the RPC API
 */ /**
 * A processed transaction message from the RPC API
 */ /**
 * A confirmed transaction on the ledger
 *
 * @deprecated Deprecated since Solana v1.8.0.
 */ /**
 * A partially decoded transaction instruction
 */ /**
 * A parsed transaction message account
 */ /**
 * A parsed transaction instruction
 */ /**
 * A parsed address table lookup
 */ /**
 * A parsed transaction message
 */ /**
 * A parsed transaction
 */ /**
 * A parsed and confirmed transaction on the ledger
 *
 * @deprecated Deprecated since Solana v1.8.0. Please use {@link ParsedTransactionWithMeta} instead.
 */ /**
 * A parsed transaction on the ledger with meta
 */ /**
 * A processed block fetched from the RPC API
 */ /**
 * A processed block fetched from the RPC API where the `transactionDetails` mode is `accounts`
 */ /**
 * A processed block fetched from the RPC API where the `transactionDetails` mode is `none`
 */ /**
 * A block with parsed transactions
 */ /**
 * A block with parsed transactions where the `transactionDetails` mode is `accounts`
 */ /**
 * A block with parsed transactions where the `transactionDetails` mode is `none`
 */ /**
 * A processed block fetched from the RPC API
 */ /**
 * A processed block fetched from the RPC API where the `transactionDetails` mode is `accounts`
 */ /**
 * A processed block fetched from the RPC API where the `transactionDetails` mode is `none`
 */ /**
 * A confirmed block on the ledger
 *
 * @deprecated Deprecated since Solana v1.8.0.
 */ /**
 * A Block on the ledger with signatures only
 */ /**
 * recent block production information
 */ /**
 * Expected JSON RPC response for the "getBlockProduction" message
 */ const $163ae62b92845c86$var$BlockProductionResponseStruct = $163ae62b92845c86$var$jsonRpcResultAndContext((0, $7154594b4f0d1928$export$bf9fb029d174d554)({
    byIdentity: (0, $7154594b4f0d1928$export$e5185e241753e543)((0, $7154594b4f0d1928$export$22b082955e083ec3)(), (0, $7154594b4f0d1928$export$2f23118c22fb2630)((0, $7154594b4f0d1928$export$98e628dec113755e)())),
    range: (0, $7154594b4f0d1928$export$bf9fb029d174d554)({
        firstSlot: (0, $7154594b4f0d1928$export$98e628dec113755e)(),
        lastSlot: (0, $7154594b4f0d1928$export$98e628dec113755e)()
    })
}));
/**
 * A performance sample
 */ function $163ae62b92845c86$var$createRpcClient(url, httpHeaders, customFetch, fetchMiddleware, disableRetryOnRateLimit, httpAgent) {
    const fetch = customFetch ? customFetch : $163ae62b92845c86$var$fetchImpl;
    let agent;
    if (httpAgent != null) console.warn("You have supplied an `httpAgent` when creating a `Connection` in a browser environment.It has been ignored; `httpAgent` is only used in Node environments.");
    let fetchWithMiddleware;
    if (fetchMiddleware) fetchWithMiddleware = async (info, init)=>{
        const modifiedFetchArgs = await new Promise((resolve, reject)=>{
            try {
                fetchMiddleware(info, init, (modifiedInfo, modifiedInit)=>resolve([
                        modifiedInfo,
                        modifiedInit
                    ]));
            } catch (error) {
                reject(error);
            }
        });
        return await fetch(...modifiedFetchArgs);
    };
    const clientBrowser = new (0, (/*@__PURE__*/$parcel$interopDefault($b673f3d4b64776a3$exports)))(async (request, callback)=>{
        const options = {
            method: "POST",
            body: request,
            agent: agent,
            headers: Object.assign({
                "Content-Type": "application/json"
            }, httpHeaders || {}, $163ae62b92845c86$var$COMMON_HTTP_HEADERS)
        };
        try {
            let too_many_requests_retries = 5;
            let res;
            let waitTime = 500;
            for(;;){
                if (fetchWithMiddleware) res = await fetchWithMiddleware(url, options);
                else res = await fetch(url, options);
                if (res.status !== 429 /* Too many requests */ ) break;
                if (disableRetryOnRateLimit === true) break;
                too_many_requests_retries -= 1;
                if (too_many_requests_retries === 0) break;
                console.error(`Server responded with ${res.status} ${res.statusText}.  Retrying after ${waitTime}ms delay...`);
                await $163ae62b92845c86$var$sleep(waitTime);
                waitTime *= 2;
            }
            const text = await res.text();
            if (res.ok) callback(null, text);
            else callback(new Error(`${res.status} ${res.statusText}: ${text}`));
        } catch (err) {
            if (err instanceof Error) callback(err);
        }
    }, {});
    return clientBrowser;
}
function $163ae62b92845c86$var$createRpcRequest(client) {
    return (method, args)=>{
        return new Promise((resolve, reject)=>{
            client.request(method, args, (err, response)=>{
                if (err) {
                    reject(err);
                    return;
                }
                resolve(response);
            });
        });
    };
}
function $163ae62b92845c86$var$createRpcBatchRequest(client) {
    return (requests)=>{
        return new Promise((resolve, reject)=>{
            // Do nothing if requests is empty
            if (requests.length === 0) resolve([]);
            const batch = requests.map((params)=>{
                return client.request(params.methodName, params.args);
            });
            client.request(batch, (err, response)=>{
                if (err) {
                    reject(err);
                    return;
                }
                resolve(response);
            });
        });
    };
}
/**
 * Expected JSON RPC response for the "getInflationGovernor" message
 */ const $163ae62b92845c86$var$GetInflationGovernorRpcResult = $163ae62b92845c86$var$jsonRpcResult($163ae62b92845c86$var$GetInflationGovernorResult);
/**
 * Expected JSON RPC response for the "getInflationRate" message
 */ const $163ae62b92845c86$var$GetInflationRateRpcResult = $163ae62b92845c86$var$jsonRpcResult($163ae62b92845c86$var$GetInflationRateResult);
/**
 * Expected JSON RPC response for the "getRecentPrioritizationFees" message
 */ const $163ae62b92845c86$var$GetRecentPrioritizationFeesRpcResult = $163ae62b92845c86$var$jsonRpcResult($163ae62b92845c86$var$GetRecentPrioritizationFeesResult);
/**
 * Expected JSON RPC response for the "getEpochInfo" message
 */ const $163ae62b92845c86$var$GetEpochInfoRpcResult = $163ae62b92845c86$var$jsonRpcResult($163ae62b92845c86$var$GetEpochInfoResult);
/**
 * Expected JSON RPC response for the "getEpochSchedule" message
 */ const $163ae62b92845c86$var$GetEpochScheduleRpcResult = $163ae62b92845c86$var$jsonRpcResult($163ae62b92845c86$var$GetEpochScheduleResult);
/**
 * Expected JSON RPC response for the "getLeaderSchedule" message
 */ const $163ae62b92845c86$var$GetLeaderScheduleRpcResult = $163ae62b92845c86$var$jsonRpcResult($163ae62b92845c86$var$GetLeaderScheduleResult);
/**
 * Expected JSON RPC response for the "minimumLedgerSlot" and "getFirstAvailableBlock" messages
 */ const $163ae62b92845c86$var$SlotRpcResult = $163ae62b92845c86$var$jsonRpcResult((0, $7154594b4f0d1928$export$98e628dec113755e)());
/**
 * Supply
 */ /**
 * Expected JSON RPC response for the "getSupply" message
 */ const $163ae62b92845c86$var$GetSupplyRpcResult = $163ae62b92845c86$var$jsonRpcResultAndContext((0, $7154594b4f0d1928$export$bf9fb029d174d554)({
    total: (0, $7154594b4f0d1928$export$98e628dec113755e)(),
    circulating: (0, $7154594b4f0d1928$export$98e628dec113755e)(),
    nonCirculating: (0, $7154594b4f0d1928$export$98e628dec113755e)(),
    nonCirculatingAccounts: (0, $7154594b4f0d1928$export$2f23118c22fb2630)($163ae62b92845c86$var$PublicKeyFromString)
}));
/**
 * Token amount object which returns a token amount in different formats
 * for various client use cases.
 */ /**
 * Expected JSON RPC structure for token amounts
 */ const $163ae62b92845c86$var$TokenAmountResult = (0, $7154594b4f0d1928$export$bf9fb029d174d554)({
    amount: (0, $7154594b4f0d1928$export$22b082955e083ec3)(),
    uiAmount: (0, $7154594b4f0d1928$export$133fc36489ac9add)((0, $7154594b4f0d1928$export$98e628dec113755e)()),
    decimals: (0, $7154594b4f0d1928$export$98e628dec113755e)(),
    uiAmountString: (0, $7154594b4f0d1928$export$516e28dec6a4b6d4)((0, $7154594b4f0d1928$export$22b082955e083ec3)())
});
/**
 * Token address and balance.
 */ /**
 * Expected JSON RPC response for the "getTokenLargestAccounts" message
 */ const $163ae62b92845c86$var$GetTokenLargestAccountsResult = $163ae62b92845c86$var$jsonRpcResultAndContext((0, $7154594b4f0d1928$export$2f23118c22fb2630)((0, $7154594b4f0d1928$export$bf9fb029d174d554)({
    address: $163ae62b92845c86$var$PublicKeyFromString,
    amount: (0, $7154594b4f0d1928$export$22b082955e083ec3)(),
    uiAmount: (0, $7154594b4f0d1928$export$133fc36489ac9add)((0, $7154594b4f0d1928$export$98e628dec113755e)()),
    decimals: (0, $7154594b4f0d1928$export$98e628dec113755e)(),
    uiAmountString: (0, $7154594b4f0d1928$export$516e28dec6a4b6d4)((0, $7154594b4f0d1928$export$22b082955e083ec3)())
})));
/**
 * Expected JSON RPC response for the "getTokenAccountsByOwner" message
 */ const $163ae62b92845c86$var$GetTokenAccountsByOwner = $163ae62b92845c86$var$jsonRpcResultAndContext((0, $7154594b4f0d1928$export$2f23118c22fb2630)((0, $7154594b4f0d1928$export$bf9fb029d174d554)({
    pubkey: $163ae62b92845c86$var$PublicKeyFromString,
    account: (0, $7154594b4f0d1928$export$bf9fb029d174d554)({
        executable: (0, $7154594b4f0d1928$export$4a21f16c33752377)(),
        owner: $163ae62b92845c86$var$PublicKeyFromString,
        lamports: (0, $7154594b4f0d1928$export$98e628dec113755e)(),
        data: $163ae62b92845c86$var$BufferFromRawAccountData,
        rentEpoch: (0, $7154594b4f0d1928$export$98e628dec113755e)()
    })
})));
const $163ae62b92845c86$var$ParsedAccountDataResult = (0, $7154594b4f0d1928$export$bf9fb029d174d554)({
    program: (0, $7154594b4f0d1928$export$22b082955e083ec3)(),
    parsed: (0, $7154594b4f0d1928$export$19282c40b967aec6)(),
    space: (0, $7154594b4f0d1928$export$98e628dec113755e)()
});
/**
 * Expected JSON RPC response for the "getTokenAccountsByOwner" message with parsed data
 */ const $163ae62b92845c86$var$GetParsedTokenAccountsByOwner = $163ae62b92845c86$var$jsonRpcResultAndContext((0, $7154594b4f0d1928$export$2f23118c22fb2630)((0, $7154594b4f0d1928$export$bf9fb029d174d554)({
    pubkey: $163ae62b92845c86$var$PublicKeyFromString,
    account: (0, $7154594b4f0d1928$export$bf9fb029d174d554)({
        executable: (0, $7154594b4f0d1928$export$4a21f16c33752377)(),
        owner: $163ae62b92845c86$var$PublicKeyFromString,
        lamports: (0, $7154594b4f0d1928$export$98e628dec113755e)(),
        data: $163ae62b92845c86$var$ParsedAccountDataResult,
        rentEpoch: (0, $7154594b4f0d1928$export$98e628dec113755e)()
    })
})));
/**
 * Pair of an account address and its balance
 */ /**
 * Expected JSON RPC response for the "getLargestAccounts" message
 */ const $163ae62b92845c86$var$GetLargestAccountsRpcResult = $163ae62b92845c86$var$jsonRpcResultAndContext((0, $7154594b4f0d1928$export$2f23118c22fb2630)((0, $7154594b4f0d1928$export$bf9fb029d174d554)({
    lamports: (0, $7154594b4f0d1928$export$98e628dec113755e)(),
    address: $163ae62b92845c86$var$PublicKeyFromString
})));
/**
 * @internal
 */ const $163ae62b92845c86$var$AccountInfoResult = (0, $7154594b4f0d1928$export$bf9fb029d174d554)({
    executable: (0, $7154594b4f0d1928$export$4a21f16c33752377)(),
    owner: $163ae62b92845c86$var$PublicKeyFromString,
    lamports: (0, $7154594b4f0d1928$export$98e628dec113755e)(),
    data: $163ae62b92845c86$var$BufferFromRawAccountData,
    rentEpoch: (0, $7154594b4f0d1928$export$98e628dec113755e)()
});
/**
 * @internal
 */ const $163ae62b92845c86$var$KeyedAccountInfoResult = (0, $7154594b4f0d1928$export$bf9fb029d174d554)({
    pubkey: $163ae62b92845c86$var$PublicKeyFromString,
    account: $163ae62b92845c86$var$AccountInfoResult
});
const $163ae62b92845c86$var$ParsedOrRawAccountData = (0, $7154594b4f0d1928$export$8c14e57e778d3873)((0, $7154594b4f0d1928$export$971dd5b0dfd021b6)([
    (0, $7154594b4f0d1928$export$9544d5bb712b01ea)((0, $5ed0747d5916bbd8$export$a143d493d941bafc)),
    $163ae62b92845c86$var$ParsedAccountDataResult
]), (0, $7154594b4f0d1928$export$971dd5b0dfd021b6)([
    $163ae62b92845c86$var$RawAccountDataResult,
    $163ae62b92845c86$var$ParsedAccountDataResult
]), (value)=>{
    if (Array.isArray(value)) return (0, $7154594b4f0d1928$export$185802fd694ee1f5)(value, $163ae62b92845c86$var$BufferFromRawAccountData);
    else return value;
});
/**
 * @internal
 */ const $163ae62b92845c86$var$ParsedAccountInfoResult = (0, $7154594b4f0d1928$export$bf9fb029d174d554)({
    executable: (0, $7154594b4f0d1928$export$4a21f16c33752377)(),
    owner: $163ae62b92845c86$var$PublicKeyFromString,
    lamports: (0, $7154594b4f0d1928$export$98e628dec113755e)(),
    data: $163ae62b92845c86$var$ParsedOrRawAccountData,
    rentEpoch: (0, $7154594b4f0d1928$export$98e628dec113755e)()
});
const $163ae62b92845c86$var$KeyedParsedAccountInfoResult = (0, $7154594b4f0d1928$export$bf9fb029d174d554)({
    pubkey: $163ae62b92845c86$var$PublicKeyFromString,
    account: $163ae62b92845c86$var$ParsedAccountInfoResult
});
/**
 * @internal
 */ const $163ae62b92845c86$var$StakeActivationResult = (0, $7154594b4f0d1928$export$bf9fb029d174d554)({
    state: (0, $7154594b4f0d1928$export$971dd5b0dfd021b6)([
        (0, $7154594b4f0d1928$export$c8ec6e1ec9fefcb0)("active"),
        (0, $7154594b4f0d1928$export$c8ec6e1ec9fefcb0)("inactive"),
        (0, $7154594b4f0d1928$export$c8ec6e1ec9fefcb0)("activating"),
        (0, $7154594b4f0d1928$export$c8ec6e1ec9fefcb0)("deactivating")
    ]),
    active: (0, $7154594b4f0d1928$export$98e628dec113755e)(),
    inactive: (0, $7154594b4f0d1928$export$98e628dec113755e)()
});
/**
 * Expected JSON RPC response for the "getConfirmedSignaturesForAddress2" message
 */ const $163ae62b92845c86$var$GetConfirmedSignaturesForAddress2RpcResult = $163ae62b92845c86$var$jsonRpcResult((0, $7154594b4f0d1928$export$2f23118c22fb2630)((0, $7154594b4f0d1928$export$bf9fb029d174d554)({
    signature: (0, $7154594b4f0d1928$export$22b082955e083ec3)(),
    slot: (0, $7154594b4f0d1928$export$98e628dec113755e)(),
    err: $163ae62b92845c86$var$TransactionErrorResult,
    memo: (0, $7154594b4f0d1928$export$133fc36489ac9add)((0, $7154594b4f0d1928$export$22b082955e083ec3)()),
    blockTime: (0, $7154594b4f0d1928$export$516e28dec6a4b6d4)((0, $7154594b4f0d1928$export$133fc36489ac9add)((0, $7154594b4f0d1928$export$98e628dec113755e)()))
})));
/**
 * Expected JSON RPC response for the "getSignaturesForAddress" message
 */ const $163ae62b92845c86$var$GetSignaturesForAddressRpcResult = $163ae62b92845c86$var$jsonRpcResult((0, $7154594b4f0d1928$export$2f23118c22fb2630)((0, $7154594b4f0d1928$export$bf9fb029d174d554)({
    signature: (0, $7154594b4f0d1928$export$22b082955e083ec3)(),
    slot: (0, $7154594b4f0d1928$export$98e628dec113755e)(),
    err: $163ae62b92845c86$var$TransactionErrorResult,
    memo: (0, $7154594b4f0d1928$export$133fc36489ac9add)((0, $7154594b4f0d1928$export$22b082955e083ec3)()),
    blockTime: (0, $7154594b4f0d1928$export$516e28dec6a4b6d4)((0, $7154594b4f0d1928$export$133fc36489ac9add)((0, $7154594b4f0d1928$export$98e628dec113755e)()))
})));
/***
 * Expected JSON RPC response for the "accountNotification" message
 */ const $163ae62b92845c86$var$AccountNotificationResult = (0, $7154594b4f0d1928$export$bf9fb029d174d554)({
    subscription: (0, $7154594b4f0d1928$export$98e628dec113755e)(),
    result: $163ae62b92845c86$var$notificationResultAndContext($163ae62b92845c86$var$AccountInfoResult)
});
/**
 * @internal
 */ const $163ae62b92845c86$var$ProgramAccountInfoResult = (0, $7154594b4f0d1928$export$bf9fb029d174d554)({
    pubkey: $163ae62b92845c86$var$PublicKeyFromString,
    account: $163ae62b92845c86$var$AccountInfoResult
});
/***
 * Expected JSON RPC response for the "programNotification" message
 */ const $163ae62b92845c86$var$ProgramAccountNotificationResult = (0, $7154594b4f0d1928$export$bf9fb029d174d554)({
    subscription: (0, $7154594b4f0d1928$export$98e628dec113755e)(),
    result: $163ae62b92845c86$var$notificationResultAndContext($163ae62b92845c86$var$ProgramAccountInfoResult)
});
/**
 * @internal
 */ const $163ae62b92845c86$var$SlotInfoResult = (0, $7154594b4f0d1928$export$bf9fb029d174d554)({
    parent: (0, $7154594b4f0d1928$export$98e628dec113755e)(),
    slot: (0, $7154594b4f0d1928$export$98e628dec113755e)(),
    root: (0, $7154594b4f0d1928$export$98e628dec113755e)()
});
/**
 * Expected JSON RPC response for the "slotNotification" message
 */ const $163ae62b92845c86$var$SlotNotificationResult = (0, $7154594b4f0d1928$export$bf9fb029d174d554)({
    subscription: (0, $7154594b4f0d1928$export$98e628dec113755e)(),
    result: $163ae62b92845c86$var$SlotInfoResult
});
/**
 * Slot updates which can be used for tracking the live progress of a cluster.
 * - `"firstShredReceived"`: connected node received the first shred of a block.
 * Indicates that a new block that is being produced.
 * - `"completed"`: connected node has received all shreds of a block. Indicates
 * a block was recently produced.
 * - `"optimisticConfirmation"`: block was optimistically confirmed by the
 * cluster. It is not guaranteed that an optimistic confirmation notification
 * will be sent for every finalized blocks.
 * - `"root"`: the connected node rooted this block.
 * - `"createdBank"`: the connected node has started validating this block.
 * - `"frozen"`: the connected node has validated this block.
 * - `"dead"`: the connected node failed to validate this block.
 */ /**
 * @internal
 */ const $163ae62b92845c86$var$SlotUpdateResult = (0, $7154594b4f0d1928$export$971dd5b0dfd021b6)([
    (0, $7154594b4f0d1928$export$bf9fb029d174d554)({
        type: (0, $7154594b4f0d1928$export$971dd5b0dfd021b6)([
            (0, $7154594b4f0d1928$export$c8ec6e1ec9fefcb0)("firstShredReceived"),
            (0, $7154594b4f0d1928$export$c8ec6e1ec9fefcb0)("completed"),
            (0, $7154594b4f0d1928$export$c8ec6e1ec9fefcb0)("optimisticConfirmation"),
            (0, $7154594b4f0d1928$export$c8ec6e1ec9fefcb0)("root")
        ]),
        slot: (0, $7154594b4f0d1928$export$98e628dec113755e)(),
        timestamp: (0, $7154594b4f0d1928$export$98e628dec113755e)()
    }),
    (0, $7154594b4f0d1928$export$bf9fb029d174d554)({
        type: (0, $7154594b4f0d1928$export$c8ec6e1ec9fefcb0)("createdBank"),
        parent: (0, $7154594b4f0d1928$export$98e628dec113755e)(),
        slot: (0, $7154594b4f0d1928$export$98e628dec113755e)(),
        timestamp: (0, $7154594b4f0d1928$export$98e628dec113755e)()
    }),
    (0, $7154594b4f0d1928$export$bf9fb029d174d554)({
        type: (0, $7154594b4f0d1928$export$c8ec6e1ec9fefcb0)("frozen"),
        slot: (0, $7154594b4f0d1928$export$98e628dec113755e)(),
        timestamp: (0, $7154594b4f0d1928$export$98e628dec113755e)(),
        stats: (0, $7154594b4f0d1928$export$bf9fb029d174d554)({
            numTransactionEntries: (0, $7154594b4f0d1928$export$98e628dec113755e)(),
            numSuccessfulTransactions: (0, $7154594b4f0d1928$export$98e628dec113755e)(),
            numFailedTransactions: (0, $7154594b4f0d1928$export$98e628dec113755e)(),
            maxTransactionsPerEntry: (0, $7154594b4f0d1928$export$98e628dec113755e)()
        })
    }),
    (0, $7154594b4f0d1928$export$bf9fb029d174d554)({
        type: (0, $7154594b4f0d1928$export$c8ec6e1ec9fefcb0)("dead"),
        slot: (0, $7154594b4f0d1928$export$98e628dec113755e)(),
        timestamp: (0, $7154594b4f0d1928$export$98e628dec113755e)(),
        err: (0, $7154594b4f0d1928$export$22b082955e083ec3)()
    })
]);
/**
 * Expected JSON RPC response for the "slotsUpdatesNotification" message
 */ const $163ae62b92845c86$var$SlotUpdateNotificationResult = (0, $7154594b4f0d1928$export$bf9fb029d174d554)({
    subscription: (0, $7154594b4f0d1928$export$98e628dec113755e)(),
    result: $163ae62b92845c86$var$SlotUpdateResult
});
/**
 * Expected JSON RPC response for the "signatureNotification" message
 */ const $163ae62b92845c86$var$SignatureNotificationResult = (0, $7154594b4f0d1928$export$bf9fb029d174d554)({
    subscription: (0, $7154594b4f0d1928$export$98e628dec113755e)(),
    result: $163ae62b92845c86$var$notificationResultAndContext((0, $7154594b4f0d1928$export$971dd5b0dfd021b6)([
        $163ae62b92845c86$var$SignatureStatusResult,
        $163ae62b92845c86$var$SignatureReceivedResult
    ]))
});
/**
 * Expected JSON RPC response for the "rootNotification" message
 */ const $163ae62b92845c86$var$RootNotificationResult = (0, $7154594b4f0d1928$export$bf9fb029d174d554)({
    subscription: (0, $7154594b4f0d1928$export$98e628dec113755e)(),
    result: (0, $7154594b4f0d1928$export$98e628dec113755e)()
});
const $163ae62b92845c86$var$ContactInfoResult = (0, $7154594b4f0d1928$export$bf9fb029d174d554)({
    pubkey: (0, $7154594b4f0d1928$export$22b082955e083ec3)(),
    gossip: (0, $7154594b4f0d1928$export$133fc36489ac9add)((0, $7154594b4f0d1928$export$22b082955e083ec3)()),
    tpu: (0, $7154594b4f0d1928$export$133fc36489ac9add)((0, $7154594b4f0d1928$export$22b082955e083ec3)()),
    rpc: (0, $7154594b4f0d1928$export$133fc36489ac9add)((0, $7154594b4f0d1928$export$22b082955e083ec3)()),
    version: (0, $7154594b4f0d1928$export$133fc36489ac9add)((0, $7154594b4f0d1928$export$22b082955e083ec3)())
});
const $163ae62b92845c86$var$VoteAccountInfoResult = (0, $7154594b4f0d1928$export$bf9fb029d174d554)({
    votePubkey: (0, $7154594b4f0d1928$export$22b082955e083ec3)(),
    nodePubkey: (0, $7154594b4f0d1928$export$22b082955e083ec3)(),
    activatedStake: (0, $7154594b4f0d1928$export$98e628dec113755e)(),
    epochVoteAccount: (0, $7154594b4f0d1928$export$4a21f16c33752377)(),
    epochCredits: (0, $7154594b4f0d1928$export$2f23118c22fb2630)((0, $7154594b4f0d1928$export$65e3907585753458)([
        (0, $7154594b4f0d1928$export$98e628dec113755e)(),
        (0, $7154594b4f0d1928$export$98e628dec113755e)(),
        (0, $7154594b4f0d1928$export$98e628dec113755e)()
    ])),
    commission: (0, $7154594b4f0d1928$export$98e628dec113755e)(),
    lastVote: (0, $7154594b4f0d1928$export$98e628dec113755e)(),
    rootSlot: (0, $7154594b4f0d1928$export$133fc36489ac9add)((0, $7154594b4f0d1928$export$98e628dec113755e)())
});
/**
 * Expected JSON RPC response for the "getVoteAccounts" message
 */ const $163ae62b92845c86$var$GetVoteAccounts = $163ae62b92845c86$var$jsonRpcResult((0, $7154594b4f0d1928$export$bf9fb029d174d554)({
    current: (0, $7154594b4f0d1928$export$2f23118c22fb2630)($163ae62b92845c86$var$VoteAccountInfoResult),
    delinquent: (0, $7154594b4f0d1928$export$2f23118c22fb2630)($163ae62b92845c86$var$VoteAccountInfoResult)
}));
const $163ae62b92845c86$var$ConfirmationStatus = (0, $7154594b4f0d1928$export$971dd5b0dfd021b6)([
    (0, $7154594b4f0d1928$export$c8ec6e1ec9fefcb0)("processed"),
    (0, $7154594b4f0d1928$export$c8ec6e1ec9fefcb0)("confirmed"),
    (0, $7154594b4f0d1928$export$c8ec6e1ec9fefcb0)("finalized")
]);
const $163ae62b92845c86$var$SignatureStatusResponse = (0, $7154594b4f0d1928$export$bf9fb029d174d554)({
    slot: (0, $7154594b4f0d1928$export$98e628dec113755e)(),
    confirmations: (0, $7154594b4f0d1928$export$133fc36489ac9add)((0, $7154594b4f0d1928$export$98e628dec113755e)()),
    err: $163ae62b92845c86$var$TransactionErrorResult,
    confirmationStatus: (0, $7154594b4f0d1928$export$516e28dec6a4b6d4)($163ae62b92845c86$var$ConfirmationStatus)
});
/**
 * Expected JSON RPC response for the "getSignatureStatuses" message
 */ const $163ae62b92845c86$var$GetSignatureStatusesRpcResult = $163ae62b92845c86$var$jsonRpcResultAndContext((0, $7154594b4f0d1928$export$2f23118c22fb2630)((0, $7154594b4f0d1928$export$133fc36489ac9add)($163ae62b92845c86$var$SignatureStatusResponse)));
/**
 * Expected JSON RPC response for the "getMinimumBalanceForRentExemption" message
 */ const $163ae62b92845c86$var$GetMinimumBalanceForRentExemptionRpcResult = $163ae62b92845c86$var$jsonRpcResult((0, $7154594b4f0d1928$export$98e628dec113755e)());
const $163ae62b92845c86$var$AddressTableLookupStruct = (0, $7154594b4f0d1928$export$bf9fb029d174d554)({
    accountKey: $163ae62b92845c86$var$PublicKeyFromString,
    writableIndexes: (0, $7154594b4f0d1928$export$2f23118c22fb2630)((0, $7154594b4f0d1928$export$98e628dec113755e)()),
    readonlyIndexes: (0, $7154594b4f0d1928$export$2f23118c22fb2630)((0, $7154594b4f0d1928$export$98e628dec113755e)())
});
const $163ae62b92845c86$var$ConfirmedTransactionResult = (0, $7154594b4f0d1928$export$bf9fb029d174d554)({
    signatures: (0, $7154594b4f0d1928$export$2f23118c22fb2630)((0, $7154594b4f0d1928$export$22b082955e083ec3)()),
    message: (0, $7154594b4f0d1928$export$bf9fb029d174d554)({
        accountKeys: (0, $7154594b4f0d1928$export$2f23118c22fb2630)((0, $7154594b4f0d1928$export$22b082955e083ec3)()),
        header: (0, $7154594b4f0d1928$export$bf9fb029d174d554)({
            numRequiredSignatures: (0, $7154594b4f0d1928$export$98e628dec113755e)(),
            numReadonlySignedAccounts: (0, $7154594b4f0d1928$export$98e628dec113755e)(),
            numReadonlyUnsignedAccounts: (0, $7154594b4f0d1928$export$98e628dec113755e)()
        }),
        instructions: (0, $7154594b4f0d1928$export$2f23118c22fb2630)((0, $7154594b4f0d1928$export$bf9fb029d174d554)({
            accounts: (0, $7154594b4f0d1928$export$2f23118c22fb2630)((0, $7154594b4f0d1928$export$98e628dec113755e)()),
            data: (0, $7154594b4f0d1928$export$22b082955e083ec3)(),
            programIdIndex: (0, $7154594b4f0d1928$export$98e628dec113755e)()
        })),
        recentBlockhash: (0, $7154594b4f0d1928$export$22b082955e083ec3)(),
        addressTableLookups: (0, $7154594b4f0d1928$export$516e28dec6a4b6d4)((0, $7154594b4f0d1928$export$2f23118c22fb2630)($163ae62b92845c86$var$AddressTableLookupStruct))
    })
});
const $163ae62b92845c86$var$AnnotatedAccountKey = (0, $7154594b4f0d1928$export$bf9fb029d174d554)({
    pubkey: $163ae62b92845c86$var$PublicKeyFromString,
    signer: (0, $7154594b4f0d1928$export$4a21f16c33752377)(),
    writable: (0, $7154594b4f0d1928$export$4a21f16c33752377)(),
    source: (0, $7154594b4f0d1928$export$516e28dec6a4b6d4)((0, $7154594b4f0d1928$export$971dd5b0dfd021b6)([
        (0, $7154594b4f0d1928$export$c8ec6e1ec9fefcb0)("transaction"),
        (0, $7154594b4f0d1928$export$c8ec6e1ec9fefcb0)("lookupTable")
    ]))
});
const $163ae62b92845c86$var$ConfirmedTransactionAccountsModeResult = (0, $7154594b4f0d1928$export$bf9fb029d174d554)({
    accountKeys: (0, $7154594b4f0d1928$export$2f23118c22fb2630)($163ae62b92845c86$var$AnnotatedAccountKey),
    signatures: (0, $7154594b4f0d1928$export$2f23118c22fb2630)((0, $7154594b4f0d1928$export$22b082955e083ec3)())
});
const $163ae62b92845c86$var$ParsedInstructionResult = (0, $7154594b4f0d1928$export$bf9fb029d174d554)({
    parsed: (0, $7154594b4f0d1928$export$19282c40b967aec6)(),
    program: (0, $7154594b4f0d1928$export$22b082955e083ec3)(),
    programId: $163ae62b92845c86$var$PublicKeyFromString
});
const $163ae62b92845c86$var$RawInstructionResult = (0, $7154594b4f0d1928$export$bf9fb029d174d554)({
    accounts: (0, $7154594b4f0d1928$export$2f23118c22fb2630)($163ae62b92845c86$var$PublicKeyFromString),
    data: (0, $7154594b4f0d1928$export$22b082955e083ec3)(),
    programId: $163ae62b92845c86$var$PublicKeyFromString
});
const $163ae62b92845c86$var$InstructionResult = (0, $7154594b4f0d1928$export$971dd5b0dfd021b6)([
    $163ae62b92845c86$var$RawInstructionResult,
    $163ae62b92845c86$var$ParsedInstructionResult
]);
const $163ae62b92845c86$var$UnknownInstructionResult = (0, $7154594b4f0d1928$export$971dd5b0dfd021b6)([
    (0, $7154594b4f0d1928$export$bf9fb029d174d554)({
        parsed: (0, $7154594b4f0d1928$export$19282c40b967aec6)(),
        program: (0, $7154594b4f0d1928$export$22b082955e083ec3)(),
        programId: (0, $7154594b4f0d1928$export$22b082955e083ec3)()
    }),
    (0, $7154594b4f0d1928$export$bf9fb029d174d554)({
        accounts: (0, $7154594b4f0d1928$export$2f23118c22fb2630)((0, $7154594b4f0d1928$export$22b082955e083ec3)()),
        data: (0, $7154594b4f0d1928$export$22b082955e083ec3)(),
        programId: (0, $7154594b4f0d1928$export$22b082955e083ec3)()
    })
]);
const $163ae62b92845c86$var$ParsedOrRawInstruction = (0, $7154594b4f0d1928$export$8c14e57e778d3873)($163ae62b92845c86$var$InstructionResult, $163ae62b92845c86$var$UnknownInstructionResult, (value)=>{
    if ("accounts" in value) return (0, $7154594b4f0d1928$export$185802fd694ee1f5)(value, $163ae62b92845c86$var$RawInstructionResult);
    else return (0, $7154594b4f0d1928$export$185802fd694ee1f5)(value, $163ae62b92845c86$var$ParsedInstructionResult);
});
/**
 * @internal
 */ const $163ae62b92845c86$var$ParsedConfirmedTransactionResult = (0, $7154594b4f0d1928$export$bf9fb029d174d554)({
    signatures: (0, $7154594b4f0d1928$export$2f23118c22fb2630)((0, $7154594b4f0d1928$export$22b082955e083ec3)()),
    message: (0, $7154594b4f0d1928$export$bf9fb029d174d554)({
        accountKeys: (0, $7154594b4f0d1928$export$2f23118c22fb2630)($163ae62b92845c86$var$AnnotatedAccountKey),
        instructions: (0, $7154594b4f0d1928$export$2f23118c22fb2630)($163ae62b92845c86$var$ParsedOrRawInstruction),
        recentBlockhash: (0, $7154594b4f0d1928$export$22b082955e083ec3)(),
        addressTableLookups: (0, $7154594b4f0d1928$export$516e28dec6a4b6d4)((0, $7154594b4f0d1928$export$133fc36489ac9add)((0, $7154594b4f0d1928$export$2f23118c22fb2630)($163ae62b92845c86$var$AddressTableLookupStruct)))
    })
});
const $163ae62b92845c86$var$TokenBalanceResult = (0, $7154594b4f0d1928$export$bf9fb029d174d554)({
    accountIndex: (0, $7154594b4f0d1928$export$98e628dec113755e)(),
    mint: (0, $7154594b4f0d1928$export$22b082955e083ec3)(),
    owner: (0, $7154594b4f0d1928$export$516e28dec6a4b6d4)((0, $7154594b4f0d1928$export$22b082955e083ec3)()),
    uiTokenAmount: $163ae62b92845c86$var$TokenAmountResult
});
const $163ae62b92845c86$var$LoadedAddressesResult = (0, $7154594b4f0d1928$export$bf9fb029d174d554)({
    writable: (0, $7154594b4f0d1928$export$2f23118c22fb2630)($163ae62b92845c86$var$PublicKeyFromString),
    readonly: (0, $7154594b4f0d1928$export$2f23118c22fb2630)($163ae62b92845c86$var$PublicKeyFromString)
});
/**
 * @internal
 */ const $163ae62b92845c86$var$ConfirmedTransactionMetaResult = (0, $7154594b4f0d1928$export$bf9fb029d174d554)({
    err: $163ae62b92845c86$var$TransactionErrorResult,
    fee: (0, $7154594b4f0d1928$export$98e628dec113755e)(),
    innerInstructions: (0, $7154594b4f0d1928$export$516e28dec6a4b6d4)((0, $7154594b4f0d1928$export$133fc36489ac9add)((0, $7154594b4f0d1928$export$2f23118c22fb2630)((0, $7154594b4f0d1928$export$bf9fb029d174d554)({
        index: (0, $7154594b4f0d1928$export$98e628dec113755e)(),
        instructions: (0, $7154594b4f0d1928$export$2f23118c22fb2630)((0, $7154594b4f0d1928$export$bf9fb029d174d554)({
            accounts: (0, $7154594b4f0d1928$export$2f23118c22fb2630)((0, $7154594b4f0d1928$export$98e628dec113755e)()),
            data: (0, $7154594b4f0d1928$export$22b082955e083ec3)(),
            programIdIndex: (0, $7154594b4f0d1928$export$98e628dec113755e)()
        }))
    })))),
    preBalances: (0, $7154594b4f0d1928$export$2f23118c22fb2630)((0, $7154594b4f0d1928$export$98e628dec113755e)()),
    postBalances: (0, $7154594b4f0d1928$export$2f23118c22fb2630)((0, $7154594b4f0d1928$export$98e628dec113755e)()),
    logMessages: (0, $7154594b4f0d1928$export$516e28dec6a4b6d4)((0, $7154594b4f0d1928$export$133fc36489ac9add)((0, $7154594b4f0d1928$export$2f23118c22fb2630)((0, $7154594b4f0d1928$export$22b082955e083ec3)()))),
    preTokenBalances: (0, $7154594b4f0d1928$export$516e28dec6a4b6d4)((0, $7154594b4f0d1928$export$133fc36489ac9add)((0, $7154594b4f0d1928$export$2f23118c22fb2630)($163ae62b92845c86$var$TokenBalanceResult))),
    postTokenBalances: (0, $7154594b4f0d1928$export$516e28dec6a4b6d4)((0, $7154594b4f0d1928$export$133fc36489ac9add)((0, $7154594b4f0d1928$export$2f23118c22fb2630)($163ae62b92845c86$var$TokenBalanceResult))),
    loadedAddresses: (0, $7154594b4f0d1928$export$516e28dec6a4b6d4)($163ae62b92845c86$var$LoadedAddressesResult),
    computeUnitsConsumed: (0, $7154594b4f0d1928$export$516e28dec6a4b6d4)((0, $7154594b4f0d1928$export$98e628dec113755e)())
});
/**
 * @internal
 */ const $163ae62b92845c86$var$ParsedConfirmedTransactionMetaResult = (0, $7154594b4f0d1928$export$bf9fb029d174d554)({
    err: $163ae62b92845c86$var$TransactionErrorResult,
    fee: (0, $7154594b4f0d1928$export$98e628dec113755e)(),
    innerInstructions: (0, $7154594b4f0d1928$export$516e28dec6a4b6d4)((0, $7154594b4f0d1928$export$133fc36489ac9add)((0, $7154594b4f0d1928$export$2f23118c22fb2630)((0, $7154594b4f0d1928$export$bf9fb029d174d554)({
        index: (0, $7154594b4f0d1928$export$98e628dec113755e)(),
        instructions: (0, $7154594b4f0d1928$export$2f23118c22fb2630)($163ae62b92845c86$var$ParsedOrRawInstruction)
    })))),
    preBalances: (0, $7154594b4f0d1928$export$2f23118c22fb2630)((0, $7154594b4f0d1928$export$98e628dec113755e)()),
    postBalances: (0, $7154594b4f0d1928$export$2f23118c22fb2630)((0, $7154594b4f0d1928$export$98e628dec113755e)()),
    logMessages: (0, $7154594b4f0d1928$export$516e28dec6a4b6d4)((0, $7154594b4f0d1928$export$133fc36489ac9add)((0, $7154594b4f0d1928$export$2f23118c22fb2630)((0, $7154594b4f0d1928$export$22b082955e083ec3)()))),
    preTokenBalances: (0, $7154594b4f0d1928$export$516e28dec6a4b6d4)((0, $7154594b4f0d1928$export$133fc36489ac9add)((0, $7154594b4f0d1928$export$2f23118c22fb2630)($163ae62b92845c86$var$TokenBalanceResult))),
    postTokenBalances: (0, $7154594b4f0d1928$export$516e28dec6a4b6d4)((0, $7154594b4f0d1928$export$133fc36489ac9add)((0, $7154594b4f0d1928$export$2f23118c22fb2630)($163ae62b92845c86$var$TokenBalanceResult))),
    loadedAddresses: (0, $7154594b4f0d1928$export$516e28dec6a4b6d4)($163ae62b92845c86$var$LoadedAddressesResult),
    computeUnitsConsumed: (0, $7154594b4f0d1928$export$516e28dec6a4b6d4)((0, $7154594b4f0d1928$export$98e628dec113755e)())
});
const $163ae62b92845c86$var$TransactionVersionStruct = (0, $7154594b4f0d1928$export$971dd5b0dfd021b6)([
    (0, $7154594b4f0d1928$export$c8ec6e1ec9fefcb0)(0),
    (0, $7154594b4f0d1928$export$c8ec6e1ec9fefcb0)("legacy")
]);
/** @internal */ const $163ae62b92845c86$var$RewardsResult = (0, $7154594b4f0d1928$export$bf9fb029d174d554)({
    pubkey: (0, $7154594b4f0d1928$export$22b082955e083ec3)(),
    lamports: (0, $7154594b4f0d1928$export$98e628dec113755e)(),
    postBalance: (0, $7154594b4f0d1928$export$133fc36489ac9add)((0, $7154594b4f0d1928$export$98e628dec113755e)()),
    rewardType: (0, $7154594b4f0d1928$export$133fc36489ac9add)((0, $7154594b4f0d1928$export$22b082955e083ec3)()),
    commission: (0, $7154594b4f0d1928$export$516e28dec6a4b6d4)((0, $7154594b4f0d1928$export$133fc36489ac9add)((0, $7154594b4f0d1928$export$98e628dec113755e)()))
});
/**
 * Expected JSON RPC response for the "getBlock" message
 */ const $163ae62b92845c86$var$GetBlockRpcResult = $163ae62b92845c86$var$jsonRpcResult((0, $7154594b4f0d1928$export$133fc36489ac9add)((0, $7154594b4f0d1928$export$bf9fb029d174d554)({
    blockhash: (0, $7154594b4f0d1928$export$22b082955e083ec3)(),
    previousBlockhash: (0, $7154594b4f0d1928$export$22b082955e083ec3)(),
    parentSlot: (0, $7154594b4f0d1928$export$98e628dec113755e)(),
    transactions: (0, $7154594b4f0d1928$export$2f23118c22fb2630)((0, $7154594b4f0d1928$export$bf9fb029d174d554)({
        transaction: $163ae62b92845c86$var$ConfirmedTransactionResult,
        meta: (0, $7154594b4f0d1928$export$133fc36489ac9add)($163ae62b92845c86$var$ConfirmedTransactionMetaResult),
        version: (0, $7154594b4f0d1928$export$516e28dec6a4b6d4)($163ae62b92845c86$var$TransactionVersionStruct)
    })),
    rewards: (0, $7154594b4f0d1928$export$516e28dec6a4b6d4)((0, $7154594b4f0d1928$export$2f23118c22fb2630)($163ae62b92845c86$var$RewardsResult)),
    blockTime: (0, $7154594b4f0d1928$export$133fc36489ac9add)((0, $7154594b4f0d1928$export$98e628dec113755e)()),
    blockHeight: (0, $7154594b4f0d1928$export$133fc36489ac9add)((0, $7154594b4f0d1928$export$98e628dec113755e)())
})));
/**
 * Expected JSON RPC response for the "getBlock" message when `transactionDetails` is `none`
 */ const $163ae62b92845c86$var$GetNoneModeBlockRpcResult = $163ae62b92845c86$var$jsonRpcResult((0, $7154594b4f0d1928$export$133fc36489ac9add)((0, $7154594b4f0d1928$export$bf9fb029d174d554)({
    blockhash: (0, $7154594b4f0d1928$export$22b082955e083ec3)(),
    previousBlockhash: (0, $7154594b4f0d1928$export$22b082955e083ec3)(),
    parentSlot: (0, $7154594b4f0d1928$export$98e628dec113755e)(),
    rewards: (0, $7154594b4f0d1928$export$516e28dec6a4b6d4)((0, $7154594b4f0d1928$export$2f23118c22fb2630)($163ae62b92845c86$var$RewardsResult)),
    blockTime: (0, $7154594b4f0d1928$export$133fc36489ac9add)((0, $7154594b4f0d1928$export$98e628dec113755e)()),
    blockHeight: (0, $7154594b4f0d1928$export$133fc36489ac9add)((0, $7154594b4f0d1928$export$98e628dec113755e)())
})));
/**
 * Expected JSON RPC response for the "getBlock" message when `transactionDetails` is `accounts`
 */ const $163ae62b92845c86$var$GetAccountsModeBlockRpcResult = $163ae62b92845c86$var$jsonRpcResult((0, $7154594b4f0d1928$export$133fc36489ac9add)((0, $7154594b4f0d1928$export$bf9fb029d174d554)({
    blockhash: (0, $7154594b4f0d1928$export$22b082955e083ec3)(),
    previousBlockhash: (0, $7154594b4f0d1928$export$22b082955e083ec3)(),
    parentSlot: (0, $7154594b4f0d1928$export$98e628dec113755e)(),
    transactions: (0, $7154594b4f0d1928$export$2f23118c22fb2630)((0, $7154594b4f0d1928$export$bf9fb029d174d554)({
        transaction: $163ae62b92845c86$var$ConfirmedTransactionAccountsModeResult,
        meta: (0, $7154594b4f0d1928$export$133fc36489ac9add)($163ae62b92845c86$var$ConfirmedTransactionMetaResult),
        version: (0, $7154594b4f0d1928$export$516e28dec6a4b6d4)($163ae62b92845c86$var$TransactionVersionStruct)
    })),
    rewards: (0, $7154594b4f0d1928$export$516e28dec6a4b6d4)((0, $7154594b4f0d1928$export$2f23118c22fb2630)($163ae62b92845c86$var$RewardsResult)),
    blockTime: (0, $7154594b4f0d1928$export$133fc36489ac9add)((0, $7154594b4f0d1928$export$98e628dec113755e)()),
    blockHeight: (0, $7154594b4f0d1928$export$133fc36489ac9add)((0, $7154594b4f0d1928$export$98e628dec113755e)())
})));
/**
 * Expected parsed JSON RPC response for the "getBlock" message
 */ const $163ae62b92845c86$var$GetParsedBlockRpcResult = $163ae62b92845c86$var$jsonRpcResult((0, $7154594b4f0d1928$export$133fc36489ac9add)((0, $7154594b4f0d1928$export$bf9fb029d174d554)({
    blockhash: (0, $7154594b4f0d1928$export$22b082955e083ec3)(),
    previousBlockhash: (0, $7154594b4f0d1928$export$22b082955e083ec3)(),
    parentSlot: (0, $7154594b4f0d1928$export$98e628dec113755e)(),
    transactions: (0, $7154594b4f0d1928$export$2f23118c22fb2630)((0, $7154594b4f0d1928$export$bf9fb029d174d554)({
        transaction: $163ae62b92845c86$var$ParsedConfirmedTransactionResult,
        meta: (0, $7154594b4f0d1928$export$133fc36489ac9add)($163ae62b92845c86$var$ParsedConfirmedTransactionMetaResult),
        version: (0, $7154594b4f0d1928$export$516e28dec6a4b6d4)($163ae62b92845c86$var$TransactionVersionStruct)
    })),
    rewards: (0, $7154594b4f0d1928$export$516e28dec6a4b6d4)((0, $7154594b4f0d1928$export$2f23118c22fb2630)($163ae62b92845c86$var$RewardsResult)),
    blockTime: (0, $7154594b4f0d1928$export$133fc36489ac9add)((0, $7154594b4f0d1928$export$98e628dec113755e)()),
    blockHeight: (0, $7154594b4f0d1928$export$133fc36489ac9add)((0, $7154594b4f0d1928$export$98e628dec113755e)())
})));
/**
 * Expected parsed JSON RPC response for the "getBlock" message  when `transactionDetails` is `accounts`
 */ const $163ae62b92845c86$var$GetParsedAccountsModeBlockRpcResult = $163ae62b92845c86$var$jsonRpcResult((0, $7154594b4f0d1928$export$133fc36489ac9add)((0, $7154594b4f0d1928$export$bf9fb029d174d554)({
    blockhash: (0, $7154594b4f0d1928$export$22b082955e083ec3)(),
    previousBlockhash: (0, $7154594b4f0d1928$export$22b082955e083ec3)(),
    parentSlot: (0, $7154594b4f0d1928$export$98e628dec113755e)(),
    transactions: (0, $7154594b4f0d1928$export$2f23118c22fb2630)((0, $7154594b4f0d1928$export$bf9fb029d174d554)({
        transaction: $163ae62b92845c86$var$ConfirmedTransactionAccountsModeResult,
        meta: (0, $7154594b4f0d1928$export$133fc36489ac9add)($163ae62b92845c86$var$ParsedConfirmedTransactionMetaResult),
        version: (0, $7154594b4f0d1928$export$516e28dec6a4b6d4)($163ae62b92845c86$var$TransactionVersionStruct)
    })),
    rewards: (0, $7154594b4f0d1928$export$516e28dec6a4b6d4)((0, $7154594b4f0d1928$export$2f23118c22fb2630)($163ae62b92845c86$var$RewardsResult)),
    blockTime: (0, $7154594b4f0d1928$export$133fc36489ac9add)((0, $7154594b4f0d1928$export$98e628dec113755e)()),
    blockHeight: (0, $7154594b4f0d1928$export$133fc36489ac9add)((0, $7154594b4f0d1928$export$98e628dec113755e)())
})));
/**
 * Expected parsed JSON RPC response for the "getBlock" message  when `transactionDetails` is `none`
 */ const $163ae62b92845c86$var$GetParsedNoneModeBlockRpcResult = $163ae62b92845c86$var$jsonRpcResult((0, $7154594b4f0d1928$export$133fc36489ac9add)((0, $7154594b4f0d1928$export$bf9fb029d174d554)({
    blockhash: (0, $7154594b4f0d1928$export$22b082955e083ec3)(),
    previousBlockhash: (0, $7154594b4f0d1928$export$22b082955e083ec3)(),
    parentSlot: (0, $7154594b4f0d1928$export$98e628dec113755e)(),
    rewards: (0, $7154594b4f0d1928$export$516e28dec6a4b6d4)((0, $7154594b4f0d1928$export$2f23118c22fb2630)($163ae62b92845c86$var$RewardsResult)),
    blockTime: (0, $7154594b4f0d1928$export$133fc36489ac9add)((0, $7154594b4f0d1928$export$98e628dec113755e)()),
    blockHeight: (0, $7154594b4f0d1928$export$133fc36489ac9add)((0, $7154594b4f0d1928$export$98e628dec113755e)())
})));
/**
 * Expected JSON RPC response for the "getConfirmedBlock" message
 *
 * @deprecated Deprecated since Solana v1.8.0. Please use {@link GetBlockRpcResult} instead.
 */ const $163ae62b92845c86$var$GetConfirmedBlockRpcResult = $163ae62b92845c86$var$jsonRpcResult((0, $7154594b4f0d1928$export$133fc36489ac9add)((0, $7154594b4f0d1928$export$bf9fb029d174d554)({
    blockhash: (0, $7154594b4f0d1928$export$22b082955e083ec3)(),
    previousBlockhash: (0, $7154594b4f0d1928$export$22b082955e083ec3)(),
    parentSlot: (0, $7154594b4f0d1928$export$98e628dec113755e)(),
    transactions: (0, $7154594b4f0d1928$export$2f23118c22fb2630)((0, $7154594b4f0d1928$export$bf9fb029d174d554)({
        transaction: $163ae62b92845c86$var$ConfirmedTransactionResult,
        meta: (0, $7154594b4f0d1928$export$133fc36489ac9add)($163ae62b92845c86$var$ConfirmedTransactionMetaResult)
    })),
    rewards: (0, $7154594b4f0d1928$export$516e28dec6a4b6d4)((0, $7154594b4f0d1928$export$2f23118c22fb2630)($163ae62b92845c86$var$RewardsResult)),
    blockTime: (0, $7154594b4f0d1928$export$133fc36489ac9add)((0, $7154594b4f0d1928$export$98e628dec113755e)())
})));
/**
 * Expected JSON RPC response for the "getBlock" message
 */ const $163ae62b92845c86$var$GetBlockSignaturesRpcResult = $163ae62b92845c86$var$jsonRpcResult((0, $7154594b4f0d1928$export$133fc36489ac9add)((0, $7154594b4f0d1928$export$bf9fb029d174d554)({
    blockhash: (0, $7154594b4f0d1928$export$22b082955e083ec3)(),
    previousBlockhash: (0, $7154594b4f0d1928$export$22b082955e083ec3)(),
    parentSlot: (0, $7154594b4f0d1928$export$98e628dec113755e)(),
    signatures: (0, $7154594b4f0d1928$export$2f23118c22fb2630)((0, $7154594b4f0d1928$export$22b082955e083ec3)()),
    blockTime: (0, $7154594b4f0d1928$export$133fc36489ac9add)((0, $7154594b4f0d1928$export$98e628dec113755e)())
})));
/**
 * Expected JSON RPC response for the "getTransaction" message
 */ const $163ae62b92845c86$var$GetTransactionRpcResult = $163ae62b92845c86$var$jsonRpcResult((0, $7154594b4f0d1928$export$133fc36489ac9add)((0, $7154594b4f0d1928$export$bf9fb029d174d554)({
    slot: (0, $7154594b4f0d1928$export$98e628dec113755e)(),
    meta: (0, $7154594b4f0d1928$export$133fc36489ac9add)($163ae62b92845c86$var$ConfirmedTransactionMetaResult),
    blockTime: (0, $7154594b4f0d1928$export$516e28dec6a4b6d4)((0, $7154594b4f0d1928$export$133fc36489ac9add)((0, $7154594b4f0d1928$export$98e628dec113755e)())),
    transaction: $163ae62b92845c86$var$ConfirmedTransactionResult,
    version: (0, $7154594b4f0d1928$export$516e28dec6a4b6d4)($163ae62b92845c86$var$TransactionVersionStruct)
})));
/**
 * Expected parsed JSON RPC response for the "getTransaction" message
 */ const $163ae62b92845c86$var$GetParsedTransactionRpcResult = $163ae62b92845c86$var$jsonRpcResult((0, $7154594b4f0d1928$export$133fc36489ac9add)((0, $7154594b4f0d1928$export$bf9fb029d174d554)({
    slot: (0, $7154594b4f0d1928$export$98e628dec113755e)(),
    transaction: $163ae62b92845c86$var$ParsedConfirmedTransactionResult,
    meta: (0, $7154594b4f0d1928$export$133fc36489ac9add)($163ae62b92845c86$var$ParsedConfirmedTransactionMetaResult),
    blockTime: (0, $7154594b4f0d1928$export$516e28dec6a4b6d4)((0, $7154594b4f0d1928$export$133fc36489ac9add)((0, $7154594b4f0d1928$export$98e628dec113755e)())),
    version: (0, $7154594b4f0d1928$export$516e28dec6a4b6d4)($163ae62b92845c86$var$TransactionVersionStruct)
})));
/**
 * Expected JSON RPC response for the "getRecentBlockhash" message
 *
 * @deprecated Deprecated since Solana v1.8.0. Please use {@link GetLatestBlockhashRpcResult} instead.
 */ const $163ae62b92845c86$var$GetRecentBlockhashAndContextRpcResult = $163ae62b92845c86$var$jsonRpcResultAndContext((0, $7154594b4f0d1928$export$bf9fb029d174d554)({
    blockhash: (0, $7154594b4f0d1928$export$22b082955e083ec3)(),
    feeCalculator: (0, $7154594b4f0d1928$export$bf9fb029d174d554)({
        lamportsPerSignature: (0, $7154594b4f0d1928$export$98e628dec113755e)()
    })
}));
/**
 * Expected JSON RPC response for the "getLatestBlockhash" message
 */ const $163ae62b92845c86$var$GetLatestBlockhashRpcResult = $163ae62b92845c86$var$jsonRpcResultAndContext((0, $7154594b4f0d1928$export$bf9fb029d174d554)({
    blockhash: (0, $7154594b4f0d1928$export$22b082955e083ec3)(),
    lastValidBlockHeight: (0, $7154594b4f0d1928$export$98e628dec113755e)()
}));
/**
 * Expected JSON RPC response for the "isBlockhashValid" message
 */ const $163ae62b92845c86$var$IsBlockhashValidRpcResult = $163ae62b92845c86$var$jsonRpcResultAndContext((0, $7154594b4f0d1928$export$4a21f16c33752377)());
const $163ae62b92845c86$var$PerfSampleResult = (0, $7154594b4f0d1928$export$bf9fb029d174d554)({
    slot: (0, $7154594b4f0d1928$export$98e628dec113755e)(),
    numTransactions: (0, $7154594b4f0d1928$export$98e628dec113755e)(),
    numSlots: (0, $7154594b4f0d1928$export$98e628dec113755e)(),
    samplePeriodSecs: (0, $7154594b4f0d1928$export$98e628dec113755e)()
});
/*
 * Expected JSON RPC response for "getRecentPerformanceSamples" message
 */ const $163ae62b92845c86$var$GetRecentPerformanceSamplesRpcResult = $163ae62b92845c86$var$jsonRpcResult((0, $7154594b4f0d1928$export$2f23118c22fb2630)($163ae62b92845c86$var$PerfSampleResult));
/**
 * Expected JSON RPC response for the "getFeeCalculatorForBlockhash" message
 */ const $163ae62b92845c86$var$GetFeeCalculatorRpcResult = $163ae62b92845c86$var$jsonRpcResultAndContext((0, $7154594b4f0d1928$export$133fc36489ac9add)((0, $7154594b4f0d1928$export$bf9fb029d174d554)({
    feeCalculator: (0, $7154594b4f0d1928$export$bf9fb029d174d554)({
        lamportsPerSignature: (0, $7154594b4f0d1928$export$98e628dec113755e)()
    })
})));
/**
 * Expected JSON RPC response for the "requestAirdrop" message
 */ const $163ae62b92845c86$var$RequestAirdropRpcResult = $163ae62b92845c86$var$jsonRpcResult((0, $7154594b4f0d1928$export$22b082955e083ec3)());
/**
 * Expected JSON RPC response for the "sendTransaction" message
 */ const $163ae62b92845c86$var$SendTransactionRpcResult = $163ae62b92845c86$var$jsonRpcResult((0, $7154594b4f0d1928$export$22b082955e083ec3)());
/**
 * Information about the latest slot being processed by a node
 */ /**
 * Parsed account data
 */ /**
 * Stake Activation data
 */ /**
 * Data slice argument for getProgramAccounts
 */ /**
 * Memory comparison filter for getProgramAccounts
 */ /**
 * Data size comparison filter for getProgramAccounts
 */ /**
 * A filter object for getProgramAccounts
 */ /**
 * Configuration object for getProgramAccounts requests
 */ /**
 * Configuration object for getParsedProgramAccounts
 */ /**
 * Configuration object for getMultipleAccounts
 */ /**
 * Configuration object for `getStakeActivation`
 */ /**
 * Configuration object for `getStakeActivation`
 */ /**
 * Configuration object for `getStakeActivation`
 */ /**
 * Configuration object for `getNonce`
 */ /**
 * Configuration object for `getNonceAndContext`
 */ /**
 * Information describing an account
 */ /**
 * Account information identified by pubkey
 */ /**
 * Callback function for account change notifications
 */ /**
 * Callback function for program account change notifications
 */ /**
 * Callback function for slot change notifications
 */ /**
 * Callback function for slot update notifications
 */ /**
 * Callback function for signature status notifications
 */ /**
 * Signature status notification with transaction result
 */ /**
 * Signature received notification
 */ /**
 * Callback function for signature notifications
 */ /**
 * Signature subscription options
 */ /**
 * Callback function for root change notifications
 */ /**
 * @internal
 */ const $163ae62b92845c86$var$LogsResult = (0, $7154594b4f0d1928$export$bf9fb029d174d554)({
    err: $163ae62b92845c86$var$TransactionErrorResult,
    logs: (0, $7154594b4f0d1928$export$2f23118c22fb2630)((0, $7154594b4f0d1928$export$22b082955e083ec3)()),
    signature: (0, $7154594b4f0d1928$export$22b082955e083ec3)()
});
/**
 * Logs result.
 */ /**
 * Expected JSON RPC response for the "logsNotification" message.
 */ const $163ae62b92845c86$var$LogsNotificationResult = (0, $7154594b4f0d1928$export$bf9fb029d174d554)({
    result: $163ae62b92845c86$var$notificationResultAndContext($163ae62b92845c86$var$LogsResult),
    subscription: (0, $7154594b4f0d1928$export$98e628dec113755e)()
});
/**
 * Filter for log subscriptions.
 */ /**
 * Callback function for log notifications.
 */ /**
 * Signature result
 */ /**
 * Transaction error
 */ /**
 * Transaction confirmation status
 * <pre>
 *   'processed': Transaction landed in a block which has reached 1 confirmation by the connected node
 *   'confirmed': Transaction landed in a block which has reached 1 confirmation by the cluster
 *   'finalized': Transaction landed in a block which has been finalized by the cluster
 * </pre>
 */ /**
 * Signature status
 */ /**
 * A confirmed signature with its status
 */ /**
 * An object defining headers to be passed to the RPC server
 */ /**
 * The type of the JavaScript `fetch()` API
 */ /**
 * A callback used to augment the outgoing HTTP request
 */ /**
 * Configuration for instantiating a Connection
 */ /** @internal */ const $163ae62b92845c86$var$COMMON_HTTP_HEADERS = {
    "solana-client": `js/${"0.0.0-development"}`
};
/**
 * A connection to a fullnode JSON RPC endpoint
 */ class $163ae62b92845c86$export$98b66c25bb38499d {
    /**
   * Establish a JSON RPC connection
   *
   * @param endpoint URL to the fullnode JSON RPC endpoint
   * @param commitmentOrConfig optional default commitment level or optional ConnectionConfig configuration object
   */ constructor(endpoint, _commitmentOrConfig){
        /** @internal */ this._commitment = void 0;
        /** @internal */ this._confirmTransactionInitialTimeout = void 0;
        /** @internal */ this._rpcEndpoint = void 0;
        /** @internal */ this._rpcWsEndpoint = void 0;
        /** @internal */ this._rpcClient = void 0;
        /** @internal */ this._rpcRequest = void 0;
        /** @internal */ this._rpcBatchRequest = void 0;
        /** @internal */ this._rpcWebSocket = void 0;
        /** @internal */ this._rpcWebSocketConnected = false;
        /** @internal */ this._rpcWebSocketHeartbeat = null;
        /** @internal */ this._rpcWebSocketIdleTimeout = null;
        /** @internal
     * A number that we increment every time an active connection closes.
     * Used to determine whether the same socket connection that was open
     * when an async operation started is the same one that's active when
     * its continuation fires.
     *
     */ this._rpcWebSocketGeneration = 0;
        /** @internal */ this._disableBlockhashCaching = false;
        /** @internal */ this._pollingBlockhash = false;
        /** @internal */ this._blockhashInfo = {
            latestBlockhash: null,
            lastFetch: 0,
            transactionSignatures: [],
            simulatedSignatures: []
        };
        /** @internal */ this._nextClientSubscriptionId = 0;
        /** @internal */ this._subscriptionDisposeFunctionsByClientSubscriptionId = {};
        /** @internal */ this._subscriptionHashByClientSubscriptionId = {};
        /** @internal */ this._subscriptionStateChangeCallbacksByHash = {};
        /** @internal */ this._subscriptionCallbacksByServerSubscriptionId = {};
        /** @internal */ this._subscriptionsByHash = {};
        /**
     * Special case.
     * After a signature is processed, RPCs automatically dispose of the
     * subscription on the server side. We need to track which of these
     * subscriptions have been disposed in such a way, so that we know
     * whether the client is dealing with a not-yet-processed signature
     * (in which case we must tear down the server subscription) or an
     * already-processed signature (in which case the client can simply
     * clear out the subscription locally without telling the server).
     *
     * NOTE: There is a proposal to eliminate this special case, here:
     * https://github.com/solana-labs/solana/issues/18892
     */ /** @internal */ this._subscriptionsAutoDisposedByRpc = new Set();
        /*
     * Returns the current block height of the node
     */ this.getBlockHeight = (()=>{
            const requestPromises = {};
            return async (commitmentOrConfig)=>{
                const { commitment: commitment, config: config } = $163ae62b92845c86$var$extractCommitmentFromConfig(commitmentOrConfig);
                const args = this._buildArgs([], commitment, undefined /* encoding */ , config);
                const requestHash = $163ae62b92845c86$var$fastStableStringify$1(args);
                requestPromises[requestHash] = requestPromises[requestHash] ?? (async ()=>{
                    try {
                        const unsafeRes = await this._rpcRequest("getBlockHeight", args);
                        const res = (0, $7154594b4f0d1928$export$185802fd694ee1f5)(unsafeRes, $163ae62b92845c86$var$jsonRpcResult((0, $7154594b4f0d1928$export$98e628dec113755e)()));
                        if ("error" in res) throw new $163ae62b92845c86$export$ea1b1a1bba5c14ad(res.error, "failed to get block height information");
                        return res.result;
                    } finally{
                        delete requestPromises[requestHash];
                    }
                })();
                return await requestPromises[requestHash];
            };
        })();
        let wsEndpoint;
        let httpHeaders;
        let fetch;
        let fetchMiddleware;
        let disableRetryOnRateLimit;
        let httpAgent;
        if (_commitmentOrConfig && typeof _commitmentOrConfig === "string") this._commitment = _commitmentOrConfig;
        else if (_commitmentOrConfig) {
            this._commitment = _commitmentOrConfig.commitment;
            this._confirmTransactionInitialTimeout = _commitmentOrConfig.confirmTransactionInitialTimeout;
            wsEndpoint = _commitmentOrConfig.wsEndpoint;
            httpHeaders = _commitmentOrConfig.httpHeaders;
            fetch = _commitmentOrConfig.fetch;
            fetchMiddleware = _commitmentOrConfig.fetchMiddleware;
            disableRetryOnRateLimit = _commitmentOrConfig.disableRetryOnRateLimit;
            httpAgent = _commitmentOrConfig.httpAgent;
        }
        this._rpcEndpoint = $163ae62b92845c86$var$assertEndpointUrl(endpoint);
        this._rpcWsEndpoint = wsEndpoint || $163ae62b92845c86$var$makeWebsocketUrl(endpoint);
        this._rpcClient = $163ae62b92845c86$var$createRpcClient(endpoint, httpHeaders, fetch, fetchMiddleware, disableRetryOnRateLimit, httpAgent);
        this._rpcRequest = $163ae62b92845c86$var$createRpcRequest(this._rpcClient);
        this._rpcBatchRequest = $163ae62b92845c86$var$createRpcBatchRequest(this._rpcClient);
        this._rpcWebSocket = new $163ae62b92845c86$var$RpcWebSocketClient(this._rpcWsEndpoint, {
            autoconnect: false,
            max_reconnects: Infinity
        });
        this._rpcWebSocket.on("open", this._wsOnOpen.bind(this));
        this._rpcWebSocket.on("error", this._wsOnError.bind(this));
        this._rpcWebSocket.on("close", this._wsOnClose.bind(this));
        this._rpcWebSocket.on("accountNotification", this._wsOnAccountNotification.bind(this));
        this._rpcWebSocket.on("programNotification", this._wsOnProgramAccountNotification.bind(this));
        this._rpcWebSocket.on("slotNotification", this._wsOnSlotNotification.bind(this));
        this._rpcWebSocket.on("slotsUpdatesNotification", this._wsOnSlotUpdatesNotification.bind(this));
        this._rpcWebSocket.on("signatureNotification", this._wsOnSignatureNotification.bind(this));
        this._rpcWebSocket.on("rootNotification", this._wsOnRootNotification.bind(this));
        this._rpcWebSocket.on("logsNotification", this._wsOnLogsNotification.bind(this));
    }
    /**
   * The default commitment used for requests
   */ get commitment() {
        return this._commitment;
    }
    /**
   * The RPC endpoint
   */ get rpcEndpoint() {
        return this._rpcEndpoint;
    }
    /**
   * Fetch the balance for the specified public key, return with context
   */ async getBalanceAndContext(publicKey, commitmentOrConfig) {
        /** @internal */ const { commitment: commitment, config: config } = $163ae62b92845c86$var$extractCommitmentFromConfig(commitmentOrConfig);
        const args = this._buildArgs([
            publicKey.toBase58()
        ], commitment, undefined /* encoding */ , config);
        const unsafeRes = await this._rpcRequest("getBalance", args);
        const res = (0, $7154594b4f0d1928$export$185802fd694ee1f5)(unsafeRes, $163ae62b92845c86$var$jsonRpcResultAndContext((0, $7154594b4f0d1928$export$98e628dec113755e)()));
        if ("error" in res) throw new $163ae62b92845c86$export$ea1b1a1bba5c14ad(res.error, `failed to get balance for ${publicKey.toBase58()}`);
        return res.result;
    }
    /**
   * Fetch the balance for the specified public key
   */ async getBalance(publicKey, commitmentOrConfig) {
        return await this.getBalanceAndContext(publicKey, commitmentOrConfig).then((x)=>x.value).catch((e)=>{
            throw new Error("failed to get balance of account " + publicKey.toBase58() + ": " + e);
        });
    }
    /**
   * Fetch the estimated production time of a block
   */ async getBlockTime(slot) {
        const unsafeRes = await this._rpcRequest("getBlockTime", [
            slot
        ]);
        const res = (0, $7154594b4f0d1928$export$185802fd694ee1f5)(unsafeRes, $163ae62b92845c86$var$jsonRpcResult((0, $7154594b4f0d1928$export$133fc36489ac9add)((0, $7154594b4f0d1928$export$98e628dec113755e)())));
        if ("error" in res) throw new $163ae62b92845c86$export$ea1b1a1bba5c14ad(res.error, `failed to get block time for slot ${slot}`);
        return res.result;
    }
    /**
   * Fetch the lowest slot that the node has information about in its ledger.
   * This value may increase over time if the node is configured to purge older ledger data
   */ async getMinimumLedgerSlot() {
        const unsafeRes = await this._rpcRequest("minimumLedgerSlot", []);
        const res = (0, $7154594b4f0d1928$export$185802fd694ee1f5)(unsafeRes, $163ae62b92845c86$var$jsonRpcResult((0, $7154594b4f0d1928$export$98e628dec113755e)()));
        if ("error" in res) throw new $163ae62b92845c86$export$ea1b1a1bba5c14ad(res.error, "failed to get minimum ledger slot");
        return res.result;
    }
    /**
   * Fetch the slot of the lowest confirmed block that has not been purged from the ledger
   */ async getFirstAvailableBlock() {
        const unsafeRes = await this._rpcRequest("getFirstAvailableBlock", []);
        const res = (0, $7154594b4f0d1928$export$185802fd694ee1f5)(unsafeRes, $163ae62b92845c86$var$SlotRpcResult);
        if ("error" in res) throw new $163ae62b92845c86$export$ea1b1a1bba5c14ad(res.error, "failed to get first available block");
        return res.result;
    }
    /**
   * Fetch information about the current supply
   */ async getSupply(config) {
        let configArg = {};
        if (typeof config === "string") configArg = {
            commitment: config
        };
        else if (config) configArg = {
            ...config,
            commitment: config && config.commitment || this.commitment
        };
        else configArg = {
            commitment: this.commitment
        };
        const unsafeRes = await this._rpcRequest("getSupply", [
            configArg
        ]);
        const res = (0, $7154594b4f0d1928$export$185802fd694ee1f5)(unsafeRes, $163ae62b92845c86$var$GetSupplyRpcResult);
        if ("error" in res) throw new $163ae62b92845c86$export$ea1b1a1bba5c14ad(res.error, "failed to get supply");
        return res.result;
    }
    /**
   * Fetch the current supply of a token mint
   */ async getTokenSupply(tokenMintAddress, commitment) {
        const args = this._buildArgs([
            tokenMintAddress.toBase58()
        ], commitment);
        const unsafeRes = await this._rpcRequest("getTokenSupply", args);
        const res = (0, $7154594b4f0d1928$export$185802fd694ee1f5)(unsafeRes, $163ae62b92845c86$var$jsonRpcResultAndContext($163ae62b92845c86$var$TokenAmountResult));
        if ("error" in res) throw new $163ae62b92845c86$export$ea1b1a1bba5c14ad(res.error, "failed to get token supply");
        return res.result;
    }
    /**
   * Fetch the current balance of a token account
   */ async getTokenAccountBalance(tokenAddress, commitment) {
        const args = this._buildArgs([
            tokenAddress.toBase58()
        ], commitment);
        const unsafeRes = await this._rpcRequest("getTokenAccountBalance", args);
        const res = (0, $7154594b4f0d1928$export$185802fd694ee1f5)(unsafeRes, $163ae62b92845c86$var$jsonRpcResultAndContext($163ae62b92845c86$var$TokenAmountResult));
        if ("error" in res) throw new $163ae62b92845c86$export$ea1b1a1bba5c14ad(res.error, "failed to get token account balance");
        return res.result;
    }
    /**
   * Fetch all the token accounts owned by the specified account
   *
   * @return {Promise<RpcResponseAndContext<GetProgramAccountsResponse>}
   */ async getTokenAccountsByOwner(ownerAddress, filter, commitmentOrConfig) {
        const { commitment: commitment, config: config } = $163ae62b92845c86$var$extractCommitmentFromConfig(commitmentOrConfig);
        let _args = [
            ownerAddress.toBase58()
        ];
        if ("mint" in filter) _args.push({
            mint: filter.mint.toBase58()
        });
        else _args.push({
            programId: filter.programId.toBase58()
        });
        const args = this._buildArgs(_args, commitment, "base64", config);
        const unsafeRes = await this._rpcRequest("getTokenAccountsByOwner", args);
        const res = (0, $7154594b4f0d1928$export$185802fd694ee1f5)(unsafeRes, $163ae62b92845c86$var$GetTokenAccountsByOwner);
        if ("error" in res) throw new $163ae62b92845c86$export$ea1b1a1bba5c14ad(res.error, `failed to get token accounts owned by account ${ownerAddress.toBase58()}`);
        return res.result;
    }
    /**
   * Fetch parsed token accounts owned by the specified account
   *
   * @return {Promise<RpcResponseAndContext<Array<{pubkey: PublicKey, account: AccountInfo<ParsedAccountData>}>>>}
   */ async getParsedTokenAccountsByOwner(ownerAddress, filter, commitment) {
        let _args = [
            ownerAddress.toBase58()
        ];
        if ("mint" in filter) _args.push({
            mint: filter.mint.toBase58()
        });
        else _args.push({
            programId: filter.programId.toBase58()
        });
        const args = this._buildArgs(_args, commitment, "jsonParsed");
        const unsafeRes = await this._rpcRequest("getTokenAccountsByOwner", args);
        const res = (0, $7154594b4f0d1928$export$185802fd694ee1f5)(unsafeRes, $163ae62b92845c86$var$GetParsedTokenAccountsByOwner);
        if ("error" in res) throw new $163ae62b92845c86$export$ea1b1a1bba5c14ad(res.error, `failed to get token accounts owned by account ${ownerAddress.toBase58()}`);
        return res.result;
    }
    /**
   * Fetch the 20 largest accounts with their current balances
   */ async getLargestAccounts(config) {
        const arg = {
            ...config,
            commitment: config && config.commitment || this.commitment
        };
        const args = arg.filter || arg.commitment ? [
            arg
        ] : [];
        const unsafeRes = await this._rpcRequest("getLargestAccounts", args);
        const res = (0, $7154594b4f0d1928$export$185802fd694ee1f5)(unsafeRes, $163ae62b92845c86$var$GetLargestAccountsRpcResult);
        if ("error" in res) throw new $163ae62b92845c86$export$ea1b1a1bba5c14ad(res.error, "failed to get largest accounts");
        return res.result;
    }
    /**
   * Fetch the 20 largest token accounts with their current balances
   * for a given mint.
   */ async getTokenLargestAccounts(mintAddress, commitment) {
        const args = this._buildArgs([
            mintAddress.toBase58()
        ], commitment);
        const unsafeRes = await this._rpcRequest("getTokenLargestAccounts", args);
        const res = (0, $7154594b4f0d1928$export$185802fd694ee1f5)(unsafeRes, $163ae62b92845c86$var$GetTokenLargestAccountsResult);
        if ("error" in res) throw new $163ae62b92845c86$export$ea1b1a1bba5c14ad(res.error, "failed to get token largest accounts");
        return res.result;
    }
    /**
   * Fetch all the account info for the specified public key, return with context
   */ async getAccountInfoAndContext(publicKey, commitmentOrConfig) {
        const { commitment: commitment, config: config } = $163ae62b92845c86$var$extractCommitmentFromConfig(commitmentOrConfig);
        const args = this._buildArgs([
            publicKey.toBase58()
        ], commitment, "base64", config);
        const unsafeRes = await this._rpcRequest("getAccountInfo", args);
        const res = (0, $7154594b4f0d1928$export$185802fd694ee1f5)(unsafeRes, $163ae62b92845c86$var$jsonRpcResultAndContext((0, $7154594b4f0d1928$export$133fc36489ac9add)($163ae62b92845c86$var$AccountInfoResult)));
        if ("error" in res) throw new $163ae62b92845c86$export$ea1b1a1bba5c14ad(res.error, `failed to get info about account ${publicKey.toBase58()}`);
        return res.result;
    }
    /**
   * Fetch parsed account info for the specified public key
   */ async getParsedAccountInfo(publicKey, commitmentOrConfig) {
        const { commitment: commitment, config: config } = $163ae62b92845c86$var$extractCommitmentFromConfig(commitmentOrConfig);
        const args = this._buildArgs([
            publicKey.toBase58()
        ], commitment, "jsonParsed", config);
        const unsafeRes = await this._rpcRequest("getAccountInfo", args);
        const res = (0, $7154594b4f0d1928$export$185802fd694ee1f5)(unsafeRes, $163ae62b92845c86$var$jsonRpcResultAndContext((0, $7154594b4f0d1928$export$133fc36489ac9add)($163ae62b92845c86$var$ParsedAccountInfoResult)));
        if ("error" in res) throw new $163ae62b92845c86$export$ea1b1a1bba5c14ad(res.error, `failed to get info about account ${publicKey.toBase58()}`);
        return res.result;
    }
    /**
   * Fetch all the account info for the specified public key
   */ async getAccountInfo(publicKey, commitmentOrConfig) {
        try {
            const res = await this.getAccountInfoAndContext(publicKey, commitmentOrConfig);
            return res.value;
        } catch (e) {
            throw new Error("failed to get info about account " + publicKey.toBase58() + ": " + e);
        }
    }
    /**
   * Fetch all the account info for multiple accounts specified by an array of public keys, return with context
   */ async getMultipleParsedAccounts(publicKeys, rawConfig) {
        const { commitment: commitment, config: config } = $163ae62b92845c86$var$extractCommitmentFromConfig(rawConfig);
        const keys = publicKeys.map((key)=>key.toBase58());
        const args = this._buildArgs([
            keys
        ], commitment, "jsonParsed", config);
        const unsafeRes = await this._rpcRequest("getMultipleAccounts", args);
        const res = (0, $7154594b4f0d1928$export$185802fd694ee1f5)(unsafeRes, $163ae62b92845c86$var$jsonRpcResultAndContext((0, $7154594b4f0d1928$export$2f23118c22fb2630)((0, $7154594b4f0d1928$export$133fc36489ac9add)($163ae62b92845c86$var$ParsedAccountInfoResult))));
        if ("error" in res) throw new $163ae62b92845c86$export$ea1b1a1bba5c14ad(res.error, `failed to get info for accounts ${keys}`);
        return res.result;
    }
    /**
   * Fetch all the account info for multiple accounts specified by an array of public keys, return with context
   */ async getMultipleAccountsInfoAndContext(publicKeys, commitmentOrConfig) {
        const { commitment: commitment, config: config } = $163ae62b92845c86$var$extractCommitmentFromConfig(commitmentOrConfig);
        const keys = publicKeys.map((key)=>key.toBase58());
        const args = this._buildArgs([
            keys
        ], commitment, "base64", config);
        const unsafeRes = await this._rpcRequest("getMultipleAccounts", args);
        const res = (0, $7154594b4f0d1928$export$185802fd694ee1f5)(unsafeRes, $163ae62b92845c86$var$jsonRpcResultAndContext((0, $7154594b4f0d1928$export$2f23118c22fb2630)((0, $7154594b4f0d1928$export$133fc36489ac9add)($163ae62b92845c86$var$AccountInfoResult))));
        if ("error" in res) throw new $163ae62b92845c86$export$ea1b1a1bba5c14ad(res.error, `failed to get info for accounts ${keys}`);
        return res.result;
    }
    /**
   * Fetch all the account info for multiple accounts specified by an array of public keys
   */ async getMultipleAccountsInfo(publicKeys, commitmentOrConfig) {
        const res = await this.getMultipleAccountsInfoAndContext(publicKeys, commitmentOrConfig);
        return res.value;
    }
    /**
   * Returns epoch activation information for a stake account that has been delegated
   */ async getStakeActivation(publicKey, commitmentOrConfig, epoch) {
        const { commitment: commitment, config: config } = $163ae62b92845c86$var$extractCommitmentFromConfig(commitmentOrConfig);
        const args = this._buildArgs([
            publicKey.toBase58()
        ], commitment, undefined /* encoding */ , {
            ...config,
            epoch: epoch != null ? epoch : config?.epoch
        });
        const unsafeRes = await this._rpcRequest("getStakeActivation", args);
        const res = (0, $7154594b4f0d1928$export$185802fd694ee1f5)(unsafeRes, $163ae62b92845c86$var$jsonRpcResult($163ae62b92845c86$var$StakeActivationResult));
        if ("error" in res) throw new $163ae62b92845c86$export$ea1b1a1bba5c14ad(res.error, `failed to get Stake Activation ${publicKey.toBase58()}`);
        return res.result;
    }
    /**
   * Fetch all the accounts owned by the specified program id
   *
   * @return {Promise<Array<{pubkey: PublicKey, account: AccountInfo<Buffer>}>>}
   */ // eslint-disable-next-line no-dupe-class-members
    // eslint-disable-next-line no-dupe-class-members
    async getProgramAccounts(programId, configOrCommitment) {
        const { commitment: commitment, config: config } = $163ae62b92845c86$var$extractCommitmentFromConfig(configOrCommitment);
        const { encoding: encoding, ...configWithoutEncoding } = config || {};
        const args = this._buildArgs([
            programId.toBase58()
        ], commitment, encoding || "base64", configWithoutEncoding);
        const unsafeRes = await this._rpcRequest("getProgramAccounts", args);
        const baseSchema = (0, $7154594b4f0d1928$export$2f23118c22fb2630)($163ae62b92845c86$var$KeyedAccountInfoResult);
        const res = configWithoutEncoding.withContext === true ? (0, $7154594b4f0d1928$export$185802fd694ee1f5)(unsafeRes, $163ae62b92845c86$var$jsonRpcResultAndContext(baseSchema)) : (0, $7154594b4f0d1928$export$185802fd694ee1f5)(unsafeRes, $163ae62b92845c86$var$jsonRpcResult(baseSchema));
        if ("error" in res) throw new $163ae62b92845c86$export$ea1b1a1bba5c14ad(res.error, `failed to get accounts owned by program ${programId.toBase58()}`);
        return res.result;
    }
    /**
   * Fetch and parse all the accounts owned by the specified program id
   *
   * @return {Promise<Array<{pubkey: PublicKey, account: AccountInfo<Buffer | ParsedAccountData>}>>}
   */ async getParsedProgramAccounts(programId, configOrCommitment) {
        const { commitment: commitment, config: config } = $163ae62b92845c86$var$extractCommitmentFromConfig(configOrCommitment);
        const args = this._buildArgs([
            programId.toBase58()
        ], commitment, "jsonParsed", config);
        const unsafeRes = await this._rpcRequest("getProgramAccounts", args);
        const res = (0, $7154594b4f0d1928$export$185802fd694ee1f5)(unsafeRes, $163ae62b92845c86$var$jsonRpcResult((0, $7154594b4f0d1928$export$2f23118c22fb2630)($163ae62b92845c86$var$KeyedParsedAccountInfoResult)));
        if ("error" in res) throw new $163ae62b92845c86$export$ea1b1a1bba5c14ad(res.error, `failed to get accounts owned by program ${programId.toBase58()}`);
        return res.result;
    }
    /** @deprecated Instead, call `confirmTransaction` and pass in {@link TransactionConfirmationStrategy} */ // eslint-disable-next-line no-dupe-class-members
    // eslint-disable-next-line no-dupe-class-members
    async confirmTransaction(strategy, commitment) {
        let rawSignature;
        if (typeof strategy == "string") rawSignature = strategy;
        else {
            const config = strategy;
            if (config.abortSignal?.aborted) return Promise.reject(config.abortSignal.reason);
            rawSignature = config.signature;
        }
        let decodedSignature;
        try {
            decodedSignature = (0, (/*@__PURE__*/$parcel$interopDefault($hZS7n))).decode(rawSignature);
        } catch (err) {
            throw new Error("signature must be base58 encoded: " + rawSignature);
        }
        $163ae62b92845c86$var$assert(decodedSignature.length === 64, "signature has invalid length");
        if (typeof strategy === "string") return await this.confirmTransactionUsingLegacyTimeoutStrategy({
            commitment: commitment || this.commitment,
            signature: rawSignature
        });
        else if ("lastValidBlockHeight" in strategy) return await this.confirmTransactionUsingBlockHeightExceedanceStrategy({
            commitment: commitment || this.commitment,
            strategy: strategy
        });
        else return await this.confirmTransactionUsingDurableNonceStrategy({
            commitment: commitment || this.commitment,
            strategy: strategy
        });
    }
    getCancellationPromise(signal) {
        return new Promise((_, reject)=>{
            if (signal == null) return;
            if (signal.aborted) reject(signal.reason);
            else signal.addEventListener("abort", ()=>{
                reject(signal.reason);
            });
        });
    }
    getTransactionConfirmationPromise({ commitment: commitment, signature: signature }) {
        let signatureSubscriptionId;
        let disposeSignatureSubscriptionStateChangeObserver;
        let done = false;
        const confirmationPromise = new Promise((resolve, reject)=>{
            try {
                signatureSubscriptionId = this.onSignature(signature, (result, context)=>{
                    signatureSubscriptionId = undefined;
                    const response = {
                        context: context,
                        value: result
                    };
                    resolve({
                        __type: $163ae62b92845c86$export$7c391bd3b61d2374.PROCESSED,
                        response: response
                    });
                }, commitment);
                const subscriptionSetupPromise = new Promise((resolveSubscriptionSetup)=>{
                    if (signatureSubscriptionId == null) resolveSubscriptionSetup();
                    else disposeSignatureSubscriptionStateChangeObserver = this._onSubscriptionStateChange(signatureSubscriptionId, (nextState)=>{
                        if (nextState === "subscribed") resolveSubscriptionSetup();
                    });
                });
                (async ()=>{
                    await subscriptionSetupPromise;
                    if (done) return;
                    const response = await this.getSignatureStatus(signature);
                    if (done) return;
                    if (response == null) return;
                    const { context: context, value: value } = response;
                    if (value == null) return;
                    if (value?.err) reject(value.err);
                    else {
                        switch(commitment){
                            case "confirmed":
                            case "single":
                            case "singleGossip":
                                if (value.confirmationStatus === "processed") return;
                                break;
                            case "finalized":
                            case "max":
                            case "root":
                                if (value.confirmationStatus === "processed" || value.confirmationStatus === "confirmed") return;
                                break;
                            // exhaust enums to ensure full coverage
                            case "processed":
                            case "recent":
                        }
                        done = true;
                        resolve({
                            __type: $163ae62b92845c86$export$7c391bd3b61d2374.PROCESSED,
                            response: {
                                context: context,
                                value: value
                            }
                        });
                    }
                })();
            } catch (err) {
                reject(err);
            }
        });
        const abortConfirmation = ()=>{
            if (disposeSignatureSubscriptionStateChangeObserver) {
                disposeSignatureSubscriptionStateChangeObserver();
                disposeSignatureSubscriptionStateChangeObserver = undefined;
            }
            if (signatureSubscriptionId != null) {
                this.removeSignatureListener(signatureSubscriptionId);
                signatureSubscriptionId = undefined;
            }
        };
        return {
            abortConfirmation: abortConfirmation,
            confirmationPromise: confirmationPromise
        };
    }
    async confirmTransactionUsingBlockHeightExceedanceStrategy({ commitment: commitment, strategy: { abortSignal: abortSignal, lastValidBlockHeight: lastValidBlockHeight, signature: signature } }) {
        let done = false;
        const expiryPromise = new Promise((resolve)=>{
            const checkBlockHeight = async ()=>{
                try {
                    const blockHeight = await this.getBlockHeight(commitment);
                    return blockHeight;
                } catch (_e) {
                    return -1;
                }
            };
            (async ()=>{
                let currentBlockHeight = await checkBlockHeight();
                if (done) return;
                while(currentBlockHeight <= lastValidBlockHeight){
                    await $163ae62b92845c86$var$sleep(1000);
                    if (done) return;
                    currentBlockHeight = await checkBlockHeight();
                    if (done) return;
                }
                resolve({
                    __type: $163ae62b92845c86$export$7c391bd3b61d2374.BLOCKHEIGHT_EXCEEDED
                });
            })();
        });
        const { abortConfirmation: abortConfirmation, confirmationPromise: confirmationPromise } = this.getTransactionConfirmationPromise({
            commitment: commitment,
            signature: signature
        });
        const cancellationPromise = this.getCancellationPromise(abortSignal);
        let result;
        try {
            const outcome = await Promise.race([
                cancellationPromise,
                confirmationPromise,
                expiryPromise
            ]);
            if (outcome.__type === $163ae62b92845c86$export$7c391bd3b61d2374.PROCESSED) result = outcome.response;
            else throw new $163ae62b92845c86$export$718fcd78527f88ed(signature);
        } finally{
            done = true;
            abortConfirmation();
        }
        return result;
    }
    async confirmTransactionUsingDurableNonceStrategy({ commitment: commitment, strategy: { abortSignal: abortSignal, minContextSlot: minContextSlot, nonceAccountPubkey: nonceAccountPubkey, nonceValue: nonceValue, signature: signature } }) {
        let done = false;
        const expiryPromise = new Promise((resolve)=>{
            let currentNonceValue = nonceValue;
            let lastCheckedSlot = null;
            const getCurrentNonceValue = async ()=>{
                try {
                    const { context: context, value: nonceAccount } = await this.getNonceAndContext(nonceAccountPubkey, {
                        commitment: commitment,
                        minContextSlot: minContextSlot
                    });
                    lastCheckedSlot = context.slot;
                    return nonceAccount?.nonce;
                } catch (e) {
                    // If for whatever reason we can't reach/read the nonce
                    // account, just keep using the last-known value.
                    return currentNonceValue;
                }
            };
            (async ()=>{
                currentNonceValue = await getCurrentNonceValue();
                if (done) return;
                while(true // eslint-disable-line no-constant-condition
                ){
                    if (nonceValue !== currentNonceValue) {
                        resolve({
                            __type: $163ae62b92845c86$export$7c391bd3b61d2374.NONCE_INVALID,
                            slotInWhichNonceDidAdvance: lastCheckedSlot
                        });
                        return;
                    }
                    await $163ae62b92845c86$var$sleep(2000);
                    if (done) return;
                    currentNonceValue = await getCurrentNonceValue();
                    if (done) return;
                }
            })();
        });
        const { abortConfirmation: abortConfirmation, confirmationPromise: confirmationPromise } = this.getTransactionConfirmationPromise({
            commitment: commitment,
            signature: signature
        });
        const cancellationPromise = this.getCancellationPromise(abortSignal);
        let result;
        try {
            const outcome = await Promise.race([
                cancellationPromise,
                confirmationPromise,
                expiryPromise
            ]);
            if (outcome.__type === $163ae62b92845c86$export$7c391bd3b61d2374.PROCESSED) result = outcome.response;
            else {
                // Double check that the transaction is indeed unconfirmed.
                let signatureStatus;
                while(true // eslint-disable-line no-constant-condition
                ){
                    const status = await this.getSignatureStatus(signature);
                    if (status == null) break;
                    if (status.context.slot < (outcome.slotInWhichNonceDidAdvance ?? minContextSlot)) {
                        await $163ae62b92845c86$var$sleep(400);
                        continue;
                    }
                    signatureStatus = status;
                    break;
                }
                if (signatureStatus?.value) {
                    const commitmentForStatus = commitment || "finalized";
                    const { confirmationStatus: confirmationStatus } = signatureStatus.value;
                    switch(commitmentForStatus){
                        case "processed":
                        case "recent":
                            if (confirmationStatus !== "processed" && confirmationStatus !== "confirmed" && confirmationStatus !== "finalized") throw new $163ae62b92845c86$export$a3e7565a95f5a1e5(signature);
                            break;
                        case "confirmed":
                        case "single":
                        case "singleGossip":
                            if (confirmationStatus !== "confirmed" && confirmationStatus !== "finalized") throw new $163ae62b92845c86$export$a3e7565a95f5a1e5(signature);
                            break;
                        case "finalized":
                        case "max":
                        case "root":
                            if (confirmationStatus !== "finalized") throw new $163ae62b92845c86$export$a3e7565a95f5a1e5(signature);
                            break;
                        default:
                            // Exhaustive switch.
                            // eslint-disable-next-line @typescript-eslint/no-unused-vars
                            ((_)=>{})(commitmentForStatus);
                    }
                    result = {
                        context: signatureStatus.context,
                        value: {
                            err: signatureStatus.value.err
                        }
                    };
                } else throw new $163ae62b92845c86$export$a3e7565a95f5a1e5(signature);
            }
        } finally{
            done = true;
            abortConfirmation();
        }
        return result;
    }
    async confirmTransactionUsingLegacyTimeoutStrategy({ commitment: commitment, signature: signature }) {
        let timeoutId;
        const expiryPromise = new Promise((resolve)=>{
            let timeoutMs = this._confirmTransactionInitialTimeout || 60000;
            switch(commitment){
                case "processed":
                case "recent":
                case "single":
                case "confirmed":
                case "singleGossip":
                    timeoutMs = this._confirmTransactionInitialTimeout || 30000;
                    break;
            }
            timeoutId = setTimeout(()=>resolve({
                    __type: $163ae62b92845c86$export$7c391bd3b61d2374.TIMED_OUT,
                    timeoutMs: timeoutMs
                }), timeoutMs);
        });
        const { abortConfirmation: abortConfirmation, confirmationPromise: confirmationPromise } = this.getTransactionConfirmationPromise({
            commitment: commitment,
            signature: signature
        });
        let result;
        try {
            const outcome = await Promise.race([
                confirmationPromise,
                expiryPromise
            ]);
            if (outcome.__type === $163ae62b92845c86$export$7c391bd3b61d2374.PROCESSED) result = outcome.response;
            else throw new $163ae62b92845c86$export$b822204c22e46bdf(signature, outcome.timeoutMs / 1000);
        } finally{
            clearTimeout(timeoutId);
            abortConfirmation();
        }
        return result;
    }
    /**
   * Return the list of nodes that are currently participating in the cluster
   */ async getClusterNodes() {
        const unsafeRes = await this._rpcRequest("getClusterNodes", []);
        const res = (0, $7154594b4f0d1928$export$185802fd694ee1f5)(unsafeRes, $163ae62b92845c86$var$jsonRpcResult((0, $7154594b4f0d1928$export$2f23118c22fb2630)($163ae62b92845c86$var$ContactInfoResult)));
        if ("error" in res) throw new $163ae62b92845c86$export$ea1b1a1bba5c14ad(res.error, "failed to get cluster nodes");
        return res.result;
    }
    /**
   * Return the list of nodes that are currently participating in the cluster
   */ async getVoteAccounts(commitment) {
        const args = this._buildArgs([], commitment);
        const unsafeRes = await this._rpcRequest("getVoteAccounts", args);
        const res = (0, $7154594b4f0d1928$export$185802fd694ee1f5)(unsafeRes, $163ae62b92845c86$var$GetVoteAccounts);
        if ("error" in res) throw new $163ae62b92845c86$export$ea1b1a1bba5c14ad(res.error, "failed to get vote accounts");
        return res.result;
    }
    /**
   * Fetch the current slot that the node is processing
   */ async getSlot(commitmentOrConfig) {
        const { commitment: commitment, config: config } = $163ae62b92845c86$var$extractCommitmentFromConfig(commitmentOrConfig);
        const args = this._buildArgs([], commitment, undefined /* encoding */ , config);
        const unsafeRes = await this._rpcRequest("getSlot", args);
        const res = (0, $7154594b4f0d1928$export$185802fd694ee1f5)(unsafeRes, $163ae62b92845c86$var$jsonRpcResult((0, $7154594b4f0d1928$export$98e628dec113755e)()));
        if ("error" in res) throw new $163ae62b92845c86$export$ea1b1a1bba5c14ad(res.error, "failed to get slot");
        return res.result;
    }
    /**
   * Fetch the current slot leader of the cluster
   */ async getSlotLeader(commitmentOrConfig) {
        const { commitment: commitment, config: config } = $163ae62b92845c86$var$extractCommitmentFromConfig(commitmentOrConfig);
        const args = this._buildArgs([], commitment, undefined /* encoding */ , config);
        const unsafeRes = await this._rpcRequest("getSlotLeader", args);
        const res = (0, $7154594b4f0d1928$export$185802fd694ee1f5)(unsafeRes, $163ae62b92845c86$var$jsonRpcResult((0, $7154594b4f0d1928$export$22b082955e083ec3)()));
        if ("error" in res) throw new $163ae62b92845c86$export$ea1b1a1bba5c14ad(res.error, "failed to get slot leader");
        return res.result;
    }
    /**
   * Fetch `limit` number of slot leaders starting from `startSlot`
   *
   * @param startSlot fetch slot leaders starting from this slot
   * @param limit number of slot leaders to return
   */ async getSlotLeaders(startSlot, limit) {
        const args = [
            startSlot,
            limit
        ];
        const unsafeRes = await this._rpcRequest("getSlotLeaders", args);
        const res = (0, $7154594b4f0d1928$export$185802fd694ee1f5)(unsafeRes, $163ae62b92845c86$var$jsonRpcResult((0, $7154594b4f0d1928$export$2f23118c22fb2630)($163ae62b92845c86$var$PublicKeyFromString)));
        if ("error" in res) throw new $163ae62b92845c86$export$ea1b1a1bba5c14ad(res.error, "failed to get slot leaders");
        return res.result;
    }
    /**
   * Fetch the current status of a signature
   */ async getSignatureStatus(signature, config) {
        const { context: context, value: values } = await this.getSignatureStatuses([
            signature
        ], config);
        $163ae62b92845c86$var$assert(values.length === 1);
        const value = values[0];
        return {
            context: context,
            value: value
        };
    }
    /**
   * Fetch the current statuses of a batch of signatures
   */ async getSignatureStatuses(signatures, config) {
        const params = [
            signatures
        ];
        if (config) params.push(config);
        const unsafeRes = await this._rpcRequest("getSignatureStatuses", params);
        const res = (0, $7154594b4f0d1928$export$185802fd694ee1f5)(unsafeRes, $163ae62b92845c86$var$GetSignatureStatusesRpcResult);
        if ("error" in res) throw new $163ae62b92845c86$export$ea1b1a1bba5c14ad(res.error, "failed to get signature status");
        return res.result;
    }
    /**
   * Fetch the current transaction count of the cluster
   */ async getTransactionCount(commitmentOrConfig) {
        const { commitment: commitment, config: config } = $163ae62b92845c86$var$extractCommitmentFromConfig(commitmentOrConfig);
        const args = this._buildArgs([], commitment, undefined /* encoding */ , config);
        const unsafeRes = await this._rpcRequest("getTransactionCount", args);
        const res = (0, $7154594b4f0d1928$export$185802fd694ee1f5)(unsafeRes, $163ae62b92845c86$var$jsonRpcResult((0, $7154594b4f0d1928$export$98e628dec113755e)()));
        if ("error" in res) throw new $163ae62b92845c86$export$ea1b1a1bba5c14ad(res.error, "failed to get transaction count");
        return res.result;
    }
    /**
   * Fetch the current total currency supply of the cluster in lamports
   *
   * @deprecated Deprecated since v1.2.8. Please use {@link getSupply} instead.
   */ async getTotalSupply(commitment) {
        const result = await this.getSupply({
            commitment: commitment,
            excludeNonCirculatingAccountsList: true
        });
        return result.value.total;
    }
    /**
   * Fetch the cluster InflationGovernor parameters
   */ async getInflationGovernor(commitment) {
        const args = this._buildArgs([], commitment);
        const unsafeRes = await this._rpcRequest("getInflationGovernor", args);
        const res = (0, $7154594b4f0d1928$export$185802fd694ee1f5)(unsafeRes, $163ae62b92845c86$var$GetInflationGovernorRpcResult);
        if ("error" in res) throw new $163ae62b92845c86$export$ea1b1a1bba5c14ad(res.error, "failed to get inflation");
        return res.result;
    }
    /**
   * Fetch the inflation reward for a list of addresses for an epoch
   */ async getInflationReward(addresses, epoch, commitmentOrConfig) {
        const { commitment: commitment, config: config } = $163ae62b92845c86$var$extractCommitmentFromConfig(commitmentOrConfig);
        const args = this._buildArgs([
            addresses.map((pubkey)=>pubkey.toBase58())
        ], commitment, undefined /* encoding */ , {
            ...config,
            epoch: epoch != null ? epoch : config?.epoch
        });
        const unsafeRes = await this._rpcRequest("getInflationReward", args);
        const res = (0, $7154594b4f0d1928$export$185802fd694ee1f5)(unsafeRes, $163ae62b92845c86$var$GetInflationRewardResult);
        if ("error" in res) throw new $163ae62b92845c86$export$ea1b1a1bba5c14ad(res.error, "failed to get inflation reward");
        return res.result;
    }
    /**
   * Fetch the specific inflation values for the current epoch
   */ async getInflationRate() {
        const unsafeRes = await this._rpcRequest("getInflationRate", []);
        const res = (0, $7154594b4f0d1928$export$185802fd694ee1f5)(unsafeRes, $163ae62b92845c86$var$GetInflationRateRpcResult);
        if ("error" in res) throw new $163ae62b92845c86$export$ea1b1a1bba5c14ad(res.error, "failed to get inflation rate");
        return res.result;
    }
    /**
   * Fetch the Epoch Info parameters
   */ async getEpochInfo(commitmentOrConfig) {
        const { commitment: commitment, config: config } = $163ae62b92845c86$var$extractCommitmentFromConfig(commitmentOrConfig);
        const args = this._buildArgs([], commitment, undefined /* encoding */ , config);
        const unsafeRes = await this._rpcRequest("getEpochInfo", args);
        const res = (0, $7154594b4f0d1928$export$185802fd694ee1f5)(unsafeRes, $163ae62b92845c86$var$GetEpochInfoRpcResult);
        if ("error" in res) throw new $163ae62b92845c86$export$ea1b1a1bba5c14ad(res.error, "failed to get epoch info");
        return res.result;
    }
    /**
   * Fetch the Epoch Schedule parameters
   */ async getEpochSchedule() {
        const unsafeRes = await this._rpcRequest("getEpochSchedule", []);
        const res = (0, $7154594b4f0d1928$export$185802fd694ee1f5)(unsafeRes, $163ae62b92845c86$var$GetEpochScheduleRpcResult);
        if ("error" in res) throw new $163ae62b92845c86$export$ea1b1a1bba5c14ad(res.error, "failed to get epoch schedule");
        const epochSchedule = res.result;
        return new $163ae62b92845c86$export$df8ed3e830b1d591(epochSchedule.slotsPerEpoch, epochSchedule.leaderScheduleSlotOffset, epochSchedule.warmup, epochSchedule.firstNormalEpoch, epochSchedule.firstNormalSlot);
    }
    /**
   * Fetch the leader schedule for the current epoch
   * @return {Promise<RpcResponseAndContext<LeaderSchedule>>}
   */ async getLeaderSchedule() {
        const unsafeRes = await this._rpcRequest("getLeaderSchedule", []);
        const res = (0, $7154594b4f0d1928$export$185802fd694ee1f5)(unsafeRes, $163ae62b92845c86$var$GetLeaderScheduleRpcResult);
        if ("error" in res) throw new $163ae62b92845c86$export$ea1b1a1bba5c14ad(res.error, "failed to get leader schedule");
        return res.result;
    }
    /**
   * Fetch the minimum balance needed to exempt an account of `dataLength`
   * size from rent
   */ async getMinimumBalanceForRentExemption(dataLength, commitment) {
        const args = this._buildArgs([
            dataLength
        ], commitment);
        const unsafeRes = await this._rpcRequest("getMinimumBalanceForRentExemption", args);
        const res = (0, $7154594b4f0d1928$export$185802fd694ee1f5)(unsafeRes, $163ae62b92845c86$var$GetMinimumBalanceForRentExemptionRpcResult);
        if ("error" in res) {
            console.warn("Unable to fetch minimum balance for rent exemption");
            return 0;
        }
        return res.result;
    }
    /**
   * Fetch a recent blockhash from the cluster, return with context
   * @return {Promise<RpcResponseAndContext<{blockhash: Blockhash, feeCalculator: FeeCalculator}>>}
   *
   * @deprecated Deprecated since Solana v1.8.0. Please use {@link getLatestBlockhash} instead.
   */ async getRecentBlockhashAndContext(commitment) {
        const args = this._buildArgs([], commitment);
        const unsafeRes = await this._rpcRequest("getRecentBlockhash", args);
        const res = (0, $7154594b4f0d1928$export$185802fd694ee1f5)(unsafeRes, $163ae62b92845c86$var$GetRecentBlockhashAndContextRpcResult);
        if ("error" in res) throw new $163ae62b92845c86$export$ea1b1a1bba5c14ad(res.error, "failed to get recent blockhash");
        return res.result;
    }
    /**
   * Fetch recent performance samples
   * @return {Promise<Array<PerfSample>>}
   */ async getRecentPerformanceSamples(limit) {
        const unsafeRes = await this._rpcRequest("getRecentPerformanceSamples", limit ? [
            limit
        ] : []);
        const res = (0, $7154594b4f0d1928$export$185802fd694ee1f5)(unsafeRes, $163ae62b92845c86$var$GetRecentPerformanceSamplesRpcResult);
        if ("error" in res) throw new $163ae62b92845c86$export$ea1b1a1bba5c14ad(res.error, "failed to get recent performance samples");
        return res.result;
    }
    /**
   * Fetch the fee calculator for a recent blockhash from the cluster, return with context
   *
   * @deprecated Deprecated since Solana v1.8.0. Please use {@link getFeeForMessage} instead.
   */ async getFeeCalculatorForBlockhash(blockhash, commitment) {
        const args = this._buildArgs([
            blockhash
        ], commitment);
        const unsafeRes = await this._rpcRequest("getFeeCalculatorForBlockhash", args);
        const res = (0, $7154594b4f0d1928$export$185802fd694ee1f5)(unsafeRes, $163ae62b92845c86$var$GetFeeCalculatorRpcResult);
        if ("error" in res) throw new $163ae62b92845c86$export$ea1b1a1bba5c14ad(res.error, "failed to get fee calculator");
        const { context: context, value: value } = res.result;
        return {
            context: context,
            value: value !== null ? value.feeCalculator : null
        };
    }
    /**
   * Fetch the fee for a message from the cluster, return with context
   */ async getFeeForMessage(message, commitment) {
        const wireMessage = $163ae62b92845c86$var$toBuffer(message.serialize()).toString("base64");
        const args = this._buildArgs([
            wireMessage
        ], commitment);
        const unsafeRes = await this._rpcRequest("getFeeForMessage", args);
        const res = (0, $7154594b4f0d1928$export$185802fd694ee1f5)(unsafeRes, $163ae62b92845c86$var$jsonRpcResultAndContext((0, $7154594b4f0d1928$export$133fc36489ac9add)((0, $7154594b4f0d1928$export$98e628dec113755e)())));
        if ("error" in res) throw new $163ae62b92845c86$export$ea1b1a1bba5c14ad(res.error, "failed to get fee for message");
        if (res.result === null) throw new Error("invalid blockhash");
        return res.result;
    }
    /**
   * Fetch a list of prioritization fees from recent blocks.
   */ async getRecentPrioritizationFees(config) {
        const accounts = config?.lockedWritableAccounts?.map((key)=>key.toBase58());
        const args = accounts?.length ? [
            accounts
        ] : [];
        const unsafeRes = await this._rpcRequest("getRecentPrioritizationFees", args);
        const res = (0, $7154594b4f0d1928$export$185802fd694ee1f5)(unsafeRes, $163ae62b92845c86$var$GetRecentPrioritizationFeesRpcResult);
        if ("error" in res) throw new $163ae62b92845c86$export$ea1b1a1bba5c14ad(res.error, "failed to get recent prioritization fees");
        return res.result;
    }
    /**
   * Fetch a recent blockhash from the cluster
   * @return {Promise<{blockhash: Blockhash, feeCalculator: FeeCalculator}>}
   *
   * @deprecated Deprecated since Solana v1.8.0. Please use {@link getLatestBlockhash} instead.
   */ async getRecentBlockhash(commitment) {
        try {
            const res = await this.getRecentBlockhashAndContext(commitment);
            return res.value;
        } catch (e) {
            throw new Error("failed to get recent blockhash: " + e);
        }
    }
    /**
   * Fetch the latest blockhash from the cluster
   * @return {Promise<BlockhashWithExpiryBlockHeight>}
   */ async getLatestBlockhash(commitmentOrConfig) {
        try {
            const res = await this.getLatestBlockhashAndContext(commitmentOrConfig);
            return res.value;
        } catch (e) {
            throw new Error("failed to get recent blockhash: " + e);
        }
    }
    /**
   * Fetch the latest blockhash from the cluster
   * @return {Promise<BlockhashWithExpiryBlockHeight>}
   */ async getLatestBlockhashAndContext(commitmentOrConfig) {
        const { commitment: commitment, config: config } = $163ae62b92845c86$var$extractCommitmentFromConfig(commitmentOrConfig);
        const args = this._buildArgs([], commitment, undefined /* encoding */ , config);
        const unsafeRes = await this._rpcRequest("getLatestBlockhash", args);
        const res = (0, $7154594b4f0d1928$export$185802fd694ee1f5)(unsafeRes, $163ae62b92845c86$var$GetLatestBlockhashRpcResult);
        if ("error" in res) throw new $163ae62b92845c86$export$ea1b1a1bba5c14ad(res.error, "failed to get latest blockhash");
        return res.result;
    }
    /**
   * Returns whether a blockhash is still valid or not
   */ async isBlockhashValid(blockhash, rawConfig) {
        const { commitment: commitment, config: config } = $163ae62b92845c86$var$extractCommitmentFromConfig(rawConfig);
        const args = this._buildArgs([
            blockhash
        ], commitment, undefined /* encoding */ , config);
        const unsafeRes = await this._rpcRequest("isBlockhashValid", args);
        const res = (0, $7154594b4f0d1928$export$185802fd694ee1f5)(unsafeRes, $163ae62b92845c86$var$IsBlockhashValidRpcResult);
        if ("error" in res) throw new $163ae62b92845c86$export$ea1b1a1bba5c14ad(res.error, "failed to determine if the blockhash `" + blockhash + "`is valid");
        return res.result;
    }
    /**
   * Fetch the node version
   */ async getVersion() {
        const unsafeRes = await this._rpcRequest("getVersion", []);
        const res = (0, $7154594b4f0d1928$export$185802fd694ee1f5)(unsafeRes, $163ae62b92845c86$var$jsonRpcResult($163ae62b92845c86$var$VersionResult));
        if ("error" in res) throw new $163ae62b92845c86$export$ea1b1a1bba5c14ad(res.error, "failed to get version");
        return res.result;
    }
    /**
   * Fetch the genesis hash
   */ async getGenesisHash() {
        const unsafeRes = await this._rpcRequest("getGenesisHash", []);
        const res = (0, $7154594b4f0d1928$export$185802fd694ee1f5)(unsafeRes, $163ae62b92845c86$var$jsonRpcResult((0, $7154594b4f0d1928$export$22b082955e083ec3)()));
        if ("error" in res) throw new $163ae62b92845c86$export$ea1b1a1bba5c14ad(res.error, "failed to get genesis hash");
        return res.result;
    }
    /**
   * Fetch a processed block from the cluster.
   *
   * @deprecated Instead, call `getBlock` using a `GetVersionedBlockConfig` by
   * setting the `maxSupportedTransactionVersion` property.
   */ /**
   * @deprecated Instead, call `getBlock` using a `GetVersionedBlockConfig` by
   * setting the `maxSupportedTransactionVersion` property.
   */ // eslint-disable-next-line no-dupe-class-members
    /**
   * @deprecated Instead, call `getBlock` using a `GetVersionedBlockConfig` by
   * setting the `maxSupportedTransactionVersion` property.
   */ // eslint-disable-next-line no-dupe-class-members
    /**
   * Fetch a processed block from the cluster.
   */ // eslint-disable-next-line no-dupe-class-members
    // eslint-disable-next-line no-dupe-class-members
    // eslint-disable-next-line no-dupe-class-members
    /**
   * Fetch a processed block from the cluster.
   */ // eslint-disable-next-line no-dupe-class-members
    async getBlock(slot, rawConfig) {
        const { commitment: commitment, config: config } = $163ae62b92845c86$var$extractCommitmentFromConfig(rawConfig);
        const args = this._buildArgsAtLeastConfirmed([
            slot
        ], commitment, undefined /* encoding */ , config);
        const unsafeRes = await this._rpcRequest("getBlock", args);
        try {
            switch(config?.transactionDetails){
                case "accounts":
                    {
                        const res = (0, $7154594b4f0d1928$export$185802fd694ee1f5)(unsafeRes, $163ae62b92845c86$var$GetAccountsModeBlockRpcResult);
                        if ("error" in res) throw res.error;
                        return res.result;
                    }
                case "none":
                    {
                        const res = (0, $7154594b4f0d1928$export$185802fd694ee1f5)(unsafeRes, $163ae62b92845c86$var$GetNoneModeBlockRpcResult);
                        if ("error" in res) throw res.error;
                        return res.result;
                    }
                default:
                    {
                        const res = (0, $7154594b4f0d1928$export$185802fd694ee1f5)(unsafeRes, $163ae62b92845c86$var$GetBlockRpcResult);
                        if ("error" in res) throw res.error;
                        const { result: result } = res;
                        return result ? {
                            ...result,
                            transactions: result.transactions.map(({ transaction: transaction, meta: meta, version: version })=>({
                                    meta: meta,
                                    transaction: {
                                        ...transaction,
                                        message: $163ae62b92845c86$var$versionedMessageFromResponse(version, transaction.message)
                                    },
                                    version: version
                                }))
                        } : null;
                    }
            }
        } catch (e) {
            throw new $163ae62b92845c86$export$ea1b1a1bba5c14ad(e, "failed to get confirmed block");
        }
    }
    /**
   * Fetch parsed transaction details for a confirmed or finalized block
   */ // eslint-disable-next-line no-dupe-class-members
    // eslint-disable-next-line no-dupe-class-members
    // eslint-disable-next-line no-dupe-class-members
    async getParsedBlock(slot, rawConfig) {
        const { commitment: commitment, config: config } = $163ae62b92845c86$var$extractCommitmentFromConfig(rawConfig);
        const args = this._buildArgsAtLeastConfirmed([
            slot
        ], commitment, "jsonParsed", config);
        const unsafeRes = await this._rpcRequest("getBlock", args);
        try {
            switch(config?.transactionDetails){
                case "accounts":
                    {
                        const res = (0, $7154594b4f0d1928$export$185802fd694ee1f5)(unsafeRes, $163ae62b92845c86$var$GetParsedAccountsModeBlockRpcResult);
                        if ("error" in res) throw res.error;
                        return res.result;
                    }
                case "none":
                    {
                        const res = (0, $7154594b4f0d1928$export$185802fd694ee1f5)(unsafeRes, $163ae62b92845c86$var$GetParsedNoneModeBlockRpcResult);
                        if ("error" in res) throw res.error;
                        return res.result;
                    }
                default:
                    {
                        const res = (0, $7154594b4f0d1928$export$185802fd694ee1f5)(unsafeRes, $163ae62b92845c86$var$GetParsedBlockRpcResult);
                        if ("error" in res) throw res.error;
                        return res.result;
                    }
            }
        } catch (e) {
            throw new $163ae62b92845c86$export$ea1b1a1bba5c14ad(e, "failed to get block");
        }
    }
    /*
   * Returns recent block production information from the current or previous epoch
   */ async getBlockProduction(configOrCommitment) {
        let extra;
        let commitment;
        if (typeof configOrCommitment === "string") commitment = configOrCommitment;
        else if (configOrCommitment) {
            const { commitment: c, ...rest } = configOrCommitment;
            commitment = c;
            extra = rest;
        }
        const args = this._buildArgs([], commitment, "base64", extra);
        const unsafeRes = await this._rpcRequest("getBlockProduction", args);
        const res = (0, $7154594b4f0d1928$export$185802fd694ee1f5)(unsafeRes, $163ae62b92845c86$var$BlockProductionResponseStruct);
        if ("error" in res) throw new $163ae62b92845c86$export$ea1b1a1bba5c14ad(res.error, "failed to get block production information");
        return res.result;
    }
    /**
   * Fetch a confirmed or finalized transaction from the cluster.
   *
   * @deprecated Instead, call `getTransaction` using a
   * `GetVersionedTransactionConfig` by setting the
   * `maxSupportedTransactionVersion` property.
   */ /**
   * Fetch a confirmed or finalized transaction from the cluster.
   */ // eslint-disable-next-line no-dupe-class-members
    /**
   * Fetch a confirmed or finalized transaction from the cluster.
   */ // eslint-disable-next-line no-dupe-class-members
    async getTransaction(signature, rawConfig) {
        const { commitment: commitment, config: config } = $163ae62b92845c86$var$extractCommitmentFromConfig(rawConfig);
        const args = this._buildArgsAtLeastConfirmed([
            signature
        ], commitment, undefined /* encoding */ , config);
        const unsafeRes = await this._rpcRequest("getTransaction", args);
        const res = (0, $7154594b4f0d1928$export$185802fd694ee1f5)(unsafeRes, $163ae62b92845c86$var$GetTransactionRpcResult);
        if ("error" in res) throw new $163ae62b92845c86$export$ea1b1a1bba5c14ad(res.error, "failed to get transaction");
        const result = res.result;
        if (!result) return result;
        return {
            ...result,
            transaction: {
                ...result.transaction,
                message: $163ae62b92845c86$var$versionedMessageFromResponse(result.version, result.transaction.message)
            }
        };
    }
    /**
   * Fetch parsed transaction details for a confirmed or finalized transaction
   */ async getParsedTransaction(signature, commitmentOrConfig) {
        const { commitment: commitment, config: config } = $163ae62b92845c86$var$extractCommitmentFromConfig(commitmentOrConfig);
        const args = this._buildArgsAtLeastConfirmed([
            signature
        ], commitment, "jsonParsed", config);
        const unsafeRes = await this._rpcRequest("getTransaction", args);
        const res = (0, $7154594b4f0d1928$export$185802fd694ee1f5)(unsafeRes, $163ae62b92845c86$var$GetParsedTransactionRpcResult);
        if ("error" in res) throw new $163ae62b92845c86$export$ea1b1a1bba5c14ad(res.error, "failed to get transaction");
        return res.result;
    }
    /**
   * Fetch parsed transaction details for a batch of confirmed transactions
   */ async getParsedTransactions(signatures, commitmentOrConfig) {
        const { commitment: commitment, config: config } = $163ae62b92845c86$var$extractCommitmentFromConfig(commitmentOrConfig);
        const batch = signatures.map((signature)=>{
            const args = this._buildArgsAtLeastConfirmed([
                signature
            ], commitment, "jsonParsed", config);
            return {
                methodName: "getTransaction",
                args: args
            };
        });
        const unsafeRes = await this._rpcBatchRequest(batch);
        const res = unsafeRes.map((unsafeRes)=>{
            const res = (0, $7154594b4f0d1928$export$185802fd694ee1f5)(unsafeRes, $163ae62b92845c86$var$GetParsedTransactionRpcResult);
            if ("error" in res) throw new $163ae62b92845c86$export$ea1b1a1bba5c14ad(res.error, "failed to get transactions");
            return res.result;
        });
        return res;
    }
    /**
   * Fetch transaction details for a batch of confirmed transactions.
   * Similar to {@link getParsedTransactions} but returns a {@link TransactionResponse}.
   *
   * @deprecated Instead, call `getTransactions` using a
   * `GetVersionedTransactionConfig` by setting the
   * `maxSupportedTransactionVersion` property.
   */ /**
   * Fetch transaction details for a batch of confirmed transactions.
   * Similar to {@link getParsedTransactions} but returns a {@link
   * VersionedTransactionResponse}.
   */ // eslint-disable-next-line no-dupe-class-members
    /**
   * Fetch transaction details for a batch of confirmed transactions.
   * Similar to {@link getParsedTransactions} but returns a {@link
   * VersionedTransactionResponse}.
   */ // eslint-disable-next-line no-dupe-class-members
    async getTransactions(signatures, commitmentOrConfig) {
        const { commitment: commitment, config: config } = $163ae62b92845c86$var$extractCommitmentFromConfig(commitmentOrConfig);
        const batch = signatures.map((signature)=>{
            const args = this._buildArgsAtLeastConfirmed([
                signature
            ], commitment, undefined /* encoding */ , config);
            return {
                methodName: "getTransaction",
                args: args
            };
        });
        const unsafeRes = await this._rpcBatchRequest(batch);
        const res = unsafeRes.map((unsafeRes)=>{
            const res = (0, $7154594b4f0d1928$export$185802fd694ee1f5)(unsafeRes, $163ae62b92845c86$var$GetTransactionRpcResult);
            if ("error" in res) throw new $163ae62b92845c86$export$ea1b1a1bba5c14ad(res.error, "failed to get transactions");
            const result = res.result;
            if (!result) return result;
            return {
                ...result,
                transaction: {
                    ...result.transaction,
                    message: $163ae62b92845c86$var$versionedMessageFromResponse(result.version, result.transaction.message)
                }
            };
        });
        return res;
    }
    /**
   * Fetch a list of Transactions and transaction statuses from the cluster
   * for a confirmed block.
   *
   * @deprecated Deprecated since v1.13.0. Please use {@link getBlock} instead.
   */ async getConfirmedBlock(slot, commitment) {
        const args = this._buildArgsAtLeastConfirmed([
            slot
        ], commitment);
        const unsafeRes = await this._rpcRequest("getConfirmedBlock", args);
        const res = (0, $7154594b4f0d1928$export$185802fd694ee1f5)(unsafeRes, $163ae62b92845c86$var$GetConfirmedBlockRpcResult);
        if ("error" in res) throw new $163ae62b92845c86$export$ea1b1a1bba5c14ad(res.error, "failed to get confirmed block");
        const result = res.result;
        if (!result) throw new Error("Confirmed block " + slot + " not found");
        const block = {
            ...result,
            transactions: result.transactions.map(({ transaction: transaction, meta: meta })=>{
                const message = new $163ae62b92845c86$export$f69c19e57285b83a(transaction.message);
                return {
                    meta: meta,
                    transaction: {
                        ...transaction,
                        message: message
                    }
                };
            })
        };
        return {
            ...block,
            transactions: block.transactions.map(({ transaction: transaction, meta: meta })=>{
                return {
                    meta: meta,
                    transaction: $163ae62b92845c86$export$febc5573c75cefb0.populate(transaction.message, transaction.signatures)
                };
            })
        };
    }
    /**
   * Fetch confirmed blocks between two slots
   */ async getBlocks(startSlot, endSlot, commitment) {
        const args = this._buildArgsAtLeastConfirmed(endSlot !== undefined ? [
            startSlot,
            endSlot
        ] : [
            startSlot
        ], commitment);
        const unsafeRes = await this._rpcRequest("getBlocks", args);
        const res = (0, $7154594b4f0d1928$export$185802fd694ee1f5)(unsafeRes, $163ae62b92845c86$var$jsonRpcResult((0, $7154594b4f0d1928$export$2f23118c22fb2630)((0, $7154594b4f0d1928$export$98e628dec113755e)())));
        if ("error" in res) throw new $163ae62b92845c86$export$ea1b1a1bba5c14ad(res.error, "failed to get blocks");
        return res.result;
    }
    /**
   * Fetch a list of Signatures from the cluster for a block, excluding rewards
   */ async getBlockSignatures(slot, commitment) {
        const args = this._buildArgsAtLeastConfirmed([
            slot
        ], commitment, undefined, {
            transactionDetails: "signatures",
            rewards: false
        });
        const unsafeRes = await this._rpcRequest("getBlock", args);
        const res = (0, $7154594b4f0d1928$export$185802fd694ee1f5)(unsafeRes, $163ae62b92845c86$var$GetBlockSignaturesRpcResult);
        if ("error" in res) throw new $163ae62b92845c86$export$ea1b1a1bba5c14ad(res.error, "failed to get block");
        const result = res.result;
        if (!result) throw new Error("Block " + slot + " not found");
        return result;
    }
    /**
   * Fetch a list of Signatures from the cluster for a confirmed block, excluding rewards
   *
   * @deprecated Deprecated since Solana v1.8.0. Please use {@link getBlockSignatures} instead.
   */ async getConfirmedBlockSignatures(slot, commitment) {
        const args = this._buildArgsAtLeastConfirmed([
            slot
        ], commitment, undefined, {
            transactionDetails: "signatures",
            rewards: false
        });
        const unsafeRes = await this._rpcRequest("getConfirmedBlock", args);
        const res = (0, $7154594b4f0d1928$export$185802fd694ee1f5)(unsafeRes, $163ae62b92845c86$var$GetBlockSignaturesRpcResult);
        if ("error" in res) throw new $163ae62b92845c86$export$ea1b1a1bba5c14ad(res.error, "failed to get confirmed block");
        const result = res.result;
        if (!result) throw new Error("Confirmed block " + slot + " not found");
        return result;
    }
    /**
   * Fetch a transaction details for a confirmed transaction
   *
   * @deprecated Deprecated since Solana v1.8.0. Please use {@link getTransaction} instead.
   */ async getConfirmedTransaction(signature, commitment) {
        const args = this._buildArgsAtLeastConfirmed([
            signature
        ], commitment);
        const unsafeRes = await this._rpcRequest("getConfirmedTransaction", args);
        const res = (0, $7154594b4f0d1928$export$185802fd694ee1f5)(unsafeRes, $163ae62b92845c86$var$GetTransactionRpcResult);
        if ("error" in res) throw new $163ae62b92845c86$export$ea1b1a1bba5c14ad(res.error, "failed to get transaction");
        const result = res.result;
        if (!result) return result;
        const message = new $163ae62b92845c86$export$f69c19e57285b83a(result.transaction.message);
        const signatures = result.transaction.signatures;
        return {
            ...result,
            transaction: $163ae62b92845c86$export$febc5573c75cefb0.populate(message, signatures)
        };
    }
    /**
   * Fetch parsed transaction details for a confirmed transaction
   *
   * @deprecated Deprecated since Solana v1.8.0. Please use {@link getParsedTransaction} instead.
   */ async getParsedConfirmedTransaction(signature, commitment) {
        const args = this._buildArgsAtLeastConfirmed([
            signature
        ], commitment, "jsonParsed");
        const unsafeRes = await this._rpcRequest("getConfirmedTransaction", args);
        const res = (0, $7154594b4f0d1928$export$185802fd694ee1f5)(unsafeRes, $163ae62b92845c86$var$GetParsedTransactionRpcResult);
        if ("error" in res) throw new $163ae62b92845c86$export$ea1b1a1bba5c14ad(res.error, "failed to get confirmed transaction");
        return res.result;
    }
    /**
   * Fetch parsed transaction details for a batch of confirmed transactions
   *
   * @deprecated Deprecated since Solana v1.8.0. Please use {@link getParsedTransactions} instead.
   */ async getParsedConfirmedTransactions(signatures, commitment) {
        const batch = signatures.map((signature)=>{
            const args = this._buildArgsAtLeastConfirmed([
                signature
            ], commitment, "jsonParsed");
            return {
                methodName: "getConfirmedTransaction",
                args: args
            };
        });
        const unsafeRes = await this._rpcBatchRequest(batch);
        const res = unsafeRes.map((unsafeRes)=>{
            const res = (0, $7154594b4f0d1928$export$185802fd694ee1f5)(unsafeRes, $163ae62b92845c86$var$GetParsedTransactionRpcResult);
            if ("error" in res) throw new $163ae62b92845c86$export$ea1b1a1bba5c14ad(res.error, "failed to get confirmed transactions");
            return res.result;
        });
        return res;
    }
    /**
   * Fetch a list of all the confirmed signatures for transactions involving an address
   * within a specified slot range. Max range allowed is 10,000 slots.
   *
   * @deprecated Deprecated since v1.3. Please use {@link getConfirmedSignaturesForAddress2} instead.
   *
   * @param address queried address
   * @param startSlot start slot, inclusive
   * @param endSlot end slot, inclusive
   */ async getConfirmedSignaturesForAddress(address, startSlot, endSlot) {
        let options = {};
        let firstAvailableBlock = await this.getFirstAvailableBlock();
        while(!("until" in options)){
            startSlot--;
            if (startSlot <= 0 || startSlot < firstAvailableBlock) break;
            try {
                const block = await this.getConfirmedBlockSignatures(startSlot, "finalized");
                if (block.signatures.length > 0) options.until = block.signatures[block.signatures.length - 1].toString();
            } catch (err) {
                if (err instanceof Error && err.message.includes("skipped")) continue;
                else throw err;
            }
        }
        let highestConfirmedRoot = await this.getSlot("finalized");
        while(!("before" in options)){
            endSlot++;
            if (endSlot > highestConfirmedRoot) break;
            try {
                const block = await this.getConfirmedBlockSignatures(endSlot);
                if (block.signatures.length > 0) options.before = block.signatures[block.signatures.length - 1].toString();
            } catch (err) {
                if (err instanceof Error && err.message.includes("skipped")) continue;
                else throw err;
            }
        }
        const confirmedSignatureInfo = await this.getConfirmedSignaturesForAddress2(address, options);
        return confirmedSignatureInfo.map((info)=>info.signature);
    }
    /**
   * Returns confirmed signatures for transactions involving an
   * address backwards in time from the provided signature or most recent confirmed block
   *
   *
   * @param address queried address
   * @param options
   */ async getConfirmedSignaturesForAddress2(address, options, commitment) {
        const args = this._buildArgsAtLeastConfirmed([
            address.toBase58()
        ], commitment, undefined, options);
        const unsafeRes = await this._rpcRequest("getConfirmedSignaturesForAddress2", args);
        const res = (0, $7154594b4f0d1928$export$185802fd694ee1f5)(unsafeRes, $163ae62b92845c86$var$GetConfirmedSignaturesForAddress2RpcResult);
        if ("error" in res) throw new $163ae62b92845c86$export$ea1b1a1bba5c14ad(res.error, "failed to get confirmed signatures for address");
        return res.result;
    }
    /**
   * Returns confirmed signatures for transactions involving an
   * address backwards in time from the provided signature or most recent confirmed block
   *
   *
   * @param address queried address
   * @param options
   */ async getSignaturesForAddress(address, options, commitment) {
        const args = this._buildArgsAtLeastConfirmed([
            address.toBase58()
        ], commitment, undefined, options);
        const unsafeRes = await this._rpcRequest("getSignaturesForAddress", args);
        const res = (0, $7154594b4f0d1928$export$185802fd694ee1f5)(unsafeRes, $163ae62b92845c86$var$GetSignaturesForAddressRpcResult);
        if ("error" in res) throw new $163ae62b92845c86$export$ea1b1a1bba5c14ad(res.error, "failed to get signatures for address");
        return res.result;
    }
    async getAddressLookupTable(accountKey, config) {
        const { context: context, value: accountInfo } = await this.getAccountInfoAndContext(accountKey, config);
        let value = null;
        if (accountInfo !== null) value = new $163ae62b92845c86$export$5b2310da10e607da({
            key: accountKey,
            state: $163ae62b92845c86$export$5b2310da10e607da.deserialize(accountInfo.data)
        });
        return {
            context: context,
            value: value
        };
    }
    /**
   * Fetch the contents of a Nonce account from the cluster, return with context
   */ async getNonceAndContext(nonceAccount, commitmentOrConfig) {
        const { context: context, value: accountInfo } = await this.getAccountInfoAndContext(nonceAccount, commitmentOrConfig);
        let value = null;
        if (accountInfo !== null) value = $163ae62b92845c86$export$ed1c2356ce604759.fromAccountData(accountInfo.data);
        return {
            context: context,
            value: value
        };
    }
    /**
   * Fetch the contents of a Nonce account from the cluster
   */ async getNonce(nonceAccount, commitmentOrConfig) {
        return await this.getNonceAndContext(nonceAccount, commitmentOrConfig).then((x)=>x.value).catch((e)=>{
            throw new Error("failed to get nonce for account " + nonceAccount.toBase58() + ": " + e);
        });
    }
    /**
   * Request an allocation of lamports to the specified address
   *
   * ```typescript
   * import { Connection, PublicKey, LAMPORTS_PER_SOL } from "@solana/web3.js";
   *
   * (async () => {
   *   const connection = new Connection("https://api.testnet.solana.com", "confirmed");
   *   const myAddress = new PublicKey("2nr1bHFT86W9tGnyvmYW4vcHKsQB3sVQfnddasz4kExM");
   *   const signature = await connection.requestAirdrop(myAddress, LAMPORTS_PER_SOL);
   *   await connection.confirmTransaction(signature);
   * })();
   * ```
   */ async requestAirdrop(to, lamports) {
        const unsafeRes = await this._rpcRequest("requestAirdrop", [
            to.toBase58(),
            lamports
        ]);
        const res = (0, $7154594b4f0d1928$export$185802fd694ee1f5)(unsafeRes, $163ae62b92845c86$var$RequestAirdropRpcResult);
        if ("error" in res) throw new $163ae62b92845c86$export$ea1b1a1bba5c14ad(res.error, `airdrop to ${to.toBase58()} failed`);
        return res.result;
    }
    /**
   * @internal
   */ async _blockhashWithExpiryBlockHeight(disableCache) {
        if (!disableCache) {
            // Wait for polling to finish
            while(this._pollingBlockhash)await $163ae62b92845c86$var$sleep(100);
            const timeSinceFetch = Date.now() - this._blockhashInfo.lastFetch;
            const expired = timeSinceFetch >= $163ae62b92845c86$export$fcb705732fb5c597;
            if (this._blockhashInfo.latestBlockhash !== null && !expired) return this._blockhashInfo.latestBlockhash;
        }
        return await this._pollNewBlockhash();
    }
    /**
   * @internal
   */ async _pollNewBlockhash() {
        this._pollingBlockhash = true;
        try {
            const startTime = Date.now();
            const cachedLatestBlockhash = this._blockhashInfo.latestBlockhash;
            const cachedBlockhash = cachedLatestBlockhash ? cachedLatestBlockhash.blockhash : null;
            for(let i = 0; i < 50; i++){
                const latestBlockhash = await this.getLatestBlockhash("finalized");
                if (cachedBlockhash !== latestBlockhash.blockhash) {
                    this._blockhashInfo = {
                        latestBlockhash: latestBlockhash,
                        lastFetch: Date.now(),
                        transactionSignatures: [],
                        simulatedSignatures: []
                    };
                    return latestBlockhash;
                }
                // Sleep for approximately half a slot
                await $163ae62b92845c86$var$sleep($163ae62b92845c86$var$MS_PER_SLOT / 2);
            }
            throw new Error(`Unable to obtain a new blockhash after ${Date.now() - startTime}ms`);
        } finally{
            this._pollingBlockhash = false;
        }
    }
    /**
   * get the stake minimum delegation
   */ async getStakeMinimumDelegation(config) {
        const { commitment: commitment, config: configArg } = $163ae62b92845c86$var$extractCommitmentFromConfig(config);
        const args = this._buildArgs([], commitment, "base64", configArg);
        const unsafeRes = await this._rpcRequest("getStakeMinimumDelegation", args);
        const res = (0, $7154594b4f0d1928$export$185802fd694ee1f5)(unsafeRes, $163ae62b92845c86$var$jsonRpcResultAndContext((0, $7154594b4f0d1928$export$98e628dec113755e)()));
        if ("error" in res) throw new $163ae62b92845c86$export$ea1b1a1bba5c14ad(res.error, `failed to get stake minimum delegation`);
        return res.result;
    }
    /**
   * Simulate a transaction
   *
   * @deprecated Instead, call {@link simulateTransaction} with {@link
   * VersionedTransaction} and {@link SimulateTransactionConfig} parameters
   */ /**
   * Simulate a transaction
   */ // eslint-disable-next-line no-dupe-class-members
    /**
   * Simulate a transaction
   */ // eslint-disable-next-line no-dupe-class-members
    async simulateTransaction(transactionOrMessage, configOrSigners, includeAccounts) {
        if ("message" in transactionOrMessage) {
            const versionedTx = transactionOrMessage;
            const wireTransaction = versionedTx.serialize();
            const encodedTransaction = (0, $5ed0747d5916bbd8$export$a143d493d941bafc).from(wireTransaction).toString("base64");
            if (Array.isArray(configOrSigners) || includeAccounts !== undefined) throw new Error("Invalid arguments");
            const config = configOrSigners || {};
            config.encoding = "base64";
            if (!("commitment" in config)) config.commitment = this.commitment;
            const args = [
                encodedTransaction,
                config
            ];
            const unsafeRes = await this._rpcRequest("simulateTransaction", args);
            const res = (0, $7154594b4f0d1928$export$185802fd694ee1f5)(unsafeRes, $163ae62b92845c86$var$SimulatedTransactionResponseStruct);
            if ("error" in res) throw new Error("failed to simulate transaction: " + res.error.message);
            return res.result;
        }
        let transaction;
        if (transactionOrMessage instanceof $163ae62b92845c86$export$febc5573c75cefb0) {
            let originalTx = transactionOrMessage;
            transaction = new $163ae62b92845c86$export$febc5573c75cefb0();
            transaction.feePayer = originalTx.feePayer;
            transaction.instructions = transactionOrMessage.instructions;
            transaction.nonceInfo = originalTx.nonceInfo;
            transaction.signatures = originalTx.signatures;
        } else {
            transaction = $163ae62b92845c86$export$febc5573c75cefb0.populate(transactionOrMessage);
            // HACK: this function relies on mutating the populated transaction
            transaction._message = transaction._json = undefined;
        }
        if (configOrSigners !== undefined && !Array.isArray(configOrSigners)) throw new Error("Invalid arguments");
        const signers = configOrSigners;
        if (transaction.nonceInfo && signers) transaction.sign(...signers);
        else {
            let disableCache = this._disableBlockhashCaching;
            for(;;){
                const latestBlockhash = await this._blockhashWithExpiryBlockHeight(disableCache);
                transaction.lastValidBlockHeight = latestBlockhash.lastValidBlockHeight;
                transaction.recentBlockhash = latestBlockhash.blockhash;
                if (!signers) break;
                transaction.sign(...signers);
                if (!transaction.signature) throw new Error("!signature"); // should never happen
                const signature = transaction.signature.toString("base64");
                if (!this._blockhashInfo.simulatedSignatures.includes(signature) && !this._blockhashInfo.transactionSignatures.includes(signature)) {
                    // The signature of this transaction has not been seen before with the
                    // current recentBlockhash, all done. Let's break
                    this._blockhashInfo.simulatedSignatures.push(signature);
                    break;
                } else // This transaction would be treated as duplicate (its derived signature
                // matched to one of already recorded signatures).
                // So, we must fetch a new blockhash for a different signature by disabling
                // our cache not to wait for the cache expiration (BLOCKHASH_CACHE_TIMEOUT_MS).
                disableCache = true;
            }
        }
        const message = transaction._compile();
        const signData = message.serialize();
        const wireTransaction = transaction._serialize(signData);
        const encodedTransaction = wireTransaction.toString("base64");
        const config = {
            encoding: "base64",
            commitment: this.commitment
        };
        if (includeAccounts) {
            const addresses = (Array.isArray(includeAccounts) ? includeAccounts : message.nonProgramIds()).map((key)=>key.toBase58());
            config["accounts"] = {
                encoding: "base64",
                addresses: addresses
            };
        }
        if (signers) config.sigVerify = true;
        const args = [
            encodedTransaction,
            config
        ];
        const unsafeRes = await this._rpcRequest("simulateTransaction", args);
        const res = (0, $7154594b4f0d1928$export$185802fd694ee1f5)(unsafeRes, $163ae62b92845c86$var$SimulatedTransactionResponseStruct);
        if ("error" in res) {
            let logs;
            if ("data" in res.error) {
                logs = res.error.data.logs;
                if (logs && Array.isArray(logs)) {
                    const traceIndent = "\n    ";
                    const logTrace = traceIndent + logs.join(traceIndent);
                    console.error(res.error.message, logTrace);
                }
            }
            throw new $163ae62b92845c86$export$121e803f723b3045("failed to simulate transaction: " + res.error.message, logs);
        }
        return res.result;
    }
    /**
   * Sign and send a transaction
   *
   * @deprecated Instead, call {@link sendTransaction} with a {@link
   * VersionedTransaction}
   */ /**
   * Send a signed transaction
   */ // eslint-disable-next-line no-dupe-class-members
    /**
   * Sign and send a transaction
   */ // eslint-disable-next-line no-dupe-class-members
    async sendTransaction(transaction, signersOrOptions, options) {
        if ("version" in transaction) {
            if (signersOrOptions && Array.isArray(signersOrOptions)) throw new Error("Invalid arguments");
            const wireTransaction = transaction.serialize();
            return await this.sendRawTransaction(wireTransaction, signersOrOptions);
        }
        if (signersOrOptions === undefined || !Array.isArray(signersOrOptions)) throw new Error("Invalid arguments");
        const signers = signersOrOptions;
        if (transaction.nonceInfo) transaction.sign(...signers);
        else {
            let disableCache = this._disableBlockhashCaching;
            for(;;){
                const latestBlockhash = await this._blockhashWithExpiryBlockHeight(disableCache);
                transaction.lastValidBlockHeight = latestBlockhash.lastValidBlockHeight;
                transaction.recentBlockhash = latestBlockhash.blockhash;
                transaction.sign(...signers);
                if (!transaction.signature) throw new Error("!signature"); // should never happen
                const signature = transaction.signature.toString("base64");
                if (!this._blockhashInfo.transactionSignatures.includes(signature)) {
                    // The signature of this transaction has not been seen before with the
                    // current recentBlockhash, all done. Let's break
                    this._blockhashInfo.transactionSignatures.push(signature);
                    break;
                } else // This transaction would be treated as duplicate (its derived signature
                // matched to one of already recorded signatures).
                // So, we must fetch a new blockhash for a different signature by disabling
                // our cache not to wait for the cache expiration (BLOCKHASH_CACHE_TIMEOUT_MS).
                disableCache = true;
            }
        }
        const wireTransaction = transaction.serialize();
        return await this.sendRawTransaction(wireTransaction, options);
    }
    /**
   * Send a transaction that has already been signed and serialized into the
   * wire format
   */ async sendRawTransaction(rawTransaction, options) {
        const encodedTransaction = $163ae62b92845c86$var$toBuffer(rawTransaction).toString("base64");
        const result = await this.sendEncodedTransaction(encodedTransaction, options);
        return result;
    }
    /**
   * Send a transaction that has already been signed, serialized into the
   * wire format, and encoded as a base64 string
   */ async sendEncodedTransaction(encodedTransaction, options) {
        const config = {
            encoding: "base64"
        };
        const skipPreflight = options && options.skipPreflight;
        const preflightCommitment = options && options.preflightCommitment || this.commitment;
        if (options && options.maxRetries != null) config.maxRetries = options.maxRetries;
        if (options && options.minContextSlot != null) config.minContextSlot = options.minContextSlot;
        if (skipPreflight) config.skipPreflight = skipPreflight;
        if (preflightCommitment) config.preflightCommitment = preflightCommitment;
        const args = [
            encodedTransaction,
            config
        ];
        const unsafeRes = await this._rpcRequest("sendTransaction", args);
        const res = (0, $7154594b4f0d1928$export$185802fd694ee1f5)(unsafeRes, $163ae62b92845c86$var$SendTransactionRpcResult);
        if ("error" in res) {
            let logs;
            if ("data" in res.error) logs = res.error.data.logs;
            throw new $163ae62b92845c86$export$121e803f723b3045("failed to send transaction: " + res.error.message, logs);
        }
        return res.result;
    }
    /**
   * @internal
   */ _wsOnOpen() {
        this._rpcWebSocketConnected = true;
        this._rpcWebSocketHeartbeat = setInterval(()=>{
            // Ping server every 5s to prevent idle timeouts
            (async ()=>{
                try {
                    await this._rpcWebSocket.notify("ping");
                // eslint-disable-next-line no-empty
                } catch  {}
            })();
        }, 5000);
        this._updateSubscriptions();
    }
    /**
   * @internal
   */ _wsOnError(err) {
        this._rpcWebSocketConnected = false;
        console.error("ws error:", err.message);
    }
    /**
   * @internal
   */ _wsOnClose(code) {
        this._rpcWebSocketConnected = false;
        this._rpcWebSocketGeneration = (this._rpcWebSocketGeneration + 1) % Number.MAX_SAFE_INTEGER;
        if (this._rpcWebSocketIdleTimeout) {
            clearTimeout(this._rpcWebSocketIdleTimeout);
            this._rpcWebSocketIdleTimeout = null;
        }
        if (this._rpcWebSocketHeartbeat) {
            clearInterval(this._rpcWebSocketHeartbeat);
            this._rpcWebSocketHeartbeat = null;
        }
        if (code === 1000) {
            // explicit close, check if any subscriptions have been made since close
            this._updateSubscriptions();
            return;
        }
        // implicit close, prepare subscriptions for auto-reconnect
        this._subscriptionCallbacksByServerSubscriptionId = {};
        Object.entries(this._subscriptionsByHash).forEach(([hash, subscription])=>{
            this._setSubscription(hash, {
                ...subscription,
                state: "pending"
            });
        });
    }
    /**
   * @internal
   */ _setSubscription(hash, nextSubscription) {
        const prevState = this._subscriptionsByHash[hash]?.state;
        this._subscriptionsByHash[hash] = nextSubscription;
        if (prevState !== nextSubscription.state) {
            const stateChangeCallbacks = this._subscriptionStateChangeCallbacksByHash[hash];
            if (stateChangeCallbacks) stateChangeCallbacks.forEach((cb)=>{
                try {
                    cb(nextSubscription.state);
                // eslint-disable-next-line no-empty
                } catch  {}
            });
        }
    }
    /**
   * @internal
   */ _onSubscriptionStateChange(clientSubscriptionId, callback) {
        const hash = this._subscriptionHashByClientSubscriptionId[clientSubscriptionId];
        if (hash == null) return ()=>{};
        const stateChangeCallbacks = this._subscriptionStateChangeCallbacksByHash[hash] ||= new Set();
        stateChangeCallbacks.add(callback);
        return ()=>{
            stateChangeCallbacks.delete(callback);
            if (stateChangeCallbacks.size === 0) delete this._subscriptionStateChangeCallbacksByHash[hash];
        };
    }
    /**
   * @internal
   */ async _updateSubscriptions() {
        if (Object.keys(this._subscriptionsByHash).length === 0) {
            if (this._rpcWebSocketConnected) {
                this._rpcWebSocketConnected = false;
                this._rpcWebSocketIdleTimeout = setTimeout(()=>{
                    this._rpcWebSocketIdleTimeout = null;
                    try {
                        this._rpcWebSocket.close();
                    } catch (err) {
                        // swallow error if socket has already been closed.
                        if (err instanceof Error) console.log(`Error when closing socket connection: ${err.message}`);
                    }
                }, 500);
            }
            return;
        }
        if (this._rpcWebSocketIdleTimeout !== null) {
            clearTimeout(this._rpcWebSocketIdleTimeout);
            this._rpcWebSocketIdleTimeout = null;
            this._rpcWebSocketConnected = true;
        }
        if (!this._rpcWebSocketConnected) {
            this._rpcWebSocket.connect();
            return;
        }
        const activeWebSocketGeneration = this._rpcWebSocketGeneration;
        const isCurrentConnectionStillActive = ()=>{
            return activeWebSocketGeneration === this._rpcWebSocketGeneration;
        };
        await Promise.all(// Don't be tempted to change this to `Object.entries`. We call
        // `_updateSubscriptions` recursively when processing the state,
        // so it's important that we look up the *current* version of
        // each subscription, every time we process a hash.
        Object.keys(this._subscriptionsByHash).map(async (hash)=>{
            const subscription = this._subscriptionsByHash[hash];
            if (subscription === undefined) // This entry has since been deleted. Skip.
            return;
            switch(subscription.state){
                case "pending":
                case "unsubscribed":
                    if (subscription.callbacks.size === 0) {
                        /**
             * You can end up here when:
             *
             * - a subscription has recently unsubscribed
             *   without having new callbacks added to it
             *   while the unsubscribe was in flight, or
             * - when a pending subscription has its
             *   listeners removed before a request was
             *   sent to the server.
             *
             * Being that nobody is interested in this
             * subscription any longer, delete it.
             */ delete this._subscriptionsByHash[hash];
                        if (subscription.state === "unsubscribed") delete this._subscriptionCallbacksByServerSubscriptionId[subscription.serverSubscriptionId];
                        await this._updateSubscriptions();
                        return;
                    }
                    await (async ()=>{
                        const { args: args, method: method } = subscription;
                        try {
                            this._setSubscription(hash, {
                                ...subscription,
                                state: "subscribing"
                            });
                            const serverSubscriptionId = await this._rpcWebSocket.call(method, args);
                            this._setSubscription(hash, {
                                ...subscription,
                                serverSubscriptionId: serverSubscriptionId,
                                state: "subscribed"
                            });
                            this._subscriptionCallbacksByServerSubscriptionId[serverSubscriptionId] = subscription.callbacks;
                            await this._updateSubscriptions();
                        } catch (e) {
                            if (e instanceof Error) console.error(`${method} error for argument`, args, e.message);
                            if (!isCurrentConnectionStillActive()) return;
                            // TODO: Maybe add an 'errored' state or a retry limit?
                            this._setSubscription(hash, {
                                ...subscription,
                                state: "pending"
                            });
                            await this._updateSubscriptions();
                        }
                    })();
                    break;
                case "subscribed":
                    if (subscription.callbacks.size === 0) // By the time we successfully set up a subscription
                    // with the server, the client stopped caring about it.
                    // Tear it down now.
                    await (async ()=>{
                        const { serverSubscriptionId: serverSubscriptionId, unsubscribeMethod: unsubscribeMethod } = subscription;
                        if (this._subscriptionsAutoDisposedByRpc.has(serverSubscriptionId)) /**
                 * Special case.
                 * If we're dealing with a subscription that has been auto-
                 * disposed by the RPC, then we can skip the RPC call to
                 * tear down the subscription here.
                 *
                 * NOTE: There is a proposal to eliminate this special case, here:
                 * https://github.com/solana-labs/solana/issues/18892
                 */ this._subscriptionsAutoDisposedByRpc.delete(serverSubscriptionId);
                        else {
                            this._setSubscription(hash, {
                                ...subscription,
                                state: "unsubscribing"
                            });
                            this._setSubscription(hash, {
                                ...subscription,
                                state: "unsubscribing"
                            });
                            try {
                                await this._rpcWebSocket.call(unsubscribeMethod, [
                                    serverSubscriptionId
                                ]);
                            } catch (e) {
                                if (e instanceof Error) console.error(`${unsubscribeMethod} error:`, e.message);
                                if (!isCurrentConnectionStillActive()) return;
                                // TODO: Maybe add an 'errored' state or a retry limit?
                                this._setSubscription(hash, {
                                    ...subscription,
                                    state: "subscribed"
                                });
                                await this._updateSubscriptions();
                                return;
                            }
                        }
                        this._setSubscription(hash, {
                            ...subscription,
                            state: "unsubscribed"
                        });
                        await this._updateSubscriptions();
                    })();
                    break;
            }
        }));
    }
    /**
   * @internal
   */ _handleServerNotification(serverSubscriptionId, callbackArgs) {
        const callbacks = this._subscriptionCallbacksByServerSubscriptionId[serverSubscriptionId];
        if (callbacks === undefined) return;
        callbacks.forEach((cb)=>{
            try {
                cb(// I failed to find a way to convince TypeScript that `cb` is of type
                // `TCallback` which is certainly compatible with `Parameters<TCallback>`.
                // See https://github.com/microsoft/TypeScript/issues/47615
                // @ts-ignore
                ...callbackArgs);
            } catch (e) {
                console.error(e);
            }
        });
    }
    /**
   * @internal
   */ _wsOnAccountNotification(notification) {
        const { result: result, subscription: subscription } = (0, $7154594b4f0d1928$export$185802fd694ee1f5)(notification, $163ae62b92845c86$var$AccountNotificationResult);
        this._handleServerNotification(subscription, [
            result.value,
            result.context
        ]);
    }
    /**
   * @internal
   */ _makeSubscription(subscriptionConfig, /**
   * When preparing `args` for a call to `_makeSubscription`, be sure
   * to carefully apply a default `commitment` property, if necessary.
   *
   * - If the user supplied a `commitment` use that.
   * - Otherwise, if the `Connection::commitment` is set, use that.
   * - Otherwise, set it to the RPC server default: `finalized`.
   *
   * This is extremely important to ensure that these two fundamentally
   * identical subscriptions produce the same identifying hash:
   *
   * - A subscription made without specifying a commitment.
   * - A subscription made where the commitment specified is the same
   *   as the default applied to the subscription above.
   *
   * Example; these two subscriptions must produce the same hash:
   *
   * - An `accountSubscribe` subscription for `'PUBKEY'`
   * - An `accountSubscribe` subscription for `'PUBKEY'` with commitment
   *   `'finalized'`.
   *
   * See the 'making a subscription with defaulted params omitted' test
   * in `connection-subscriptions.ts` for more.
   */ args) {
        const clientSubscriptionId = this._nextClientSubscriptionId++;
        const hash = $163ae62b92845c86$var$fastStableStringify$1([
            subscriptionConfig.method,
            args
        ], true);
        const existingSubscription = this._subscriptionsByHash[hash];
        if (existingSubscription === undefined) this._subscriptionsByHash[hash] = {
            ...subscriptionConfig,
            args: args,
            callbacks: new Set([
                subscriptionConfig.callback
            ]),
            state: "pending"
        };
        else existingSubscription.callbacks.add(subscriptionConfig.callback);
        this._subscriptionHashByClientSubscriptionId[clientSubscriptionId] = hash;
        this._subscriptionDisposeFunctionsByClientSubscriptionId[clientSubscriptionId] = async ()=>{
            delete this._subscriptionDisposeFunctionsByClientSubscriptionId[clientSubscriptionId];
            delete this._subscriptionHashByClientSubscriptionId[clientSubscriptionId];
            const subscription = this._subscriptionsByHash[hash];
            $163ae62b92845c86$var$assert(subscription !== undefined, `Could not find a \`Subscription\` when tearing down client subscription #${clientSubscriptionId}`);
            subscription.callbacks.delete(subscriptionConfig.callback);
            await this._updateSubscriptions();
        };
        this._updateSubscriptions();
        return clientSubscriptionId;
    }
    /**
   * Register a callback to be invoked whenever the specified account changes
   *
   * @param publicKey Public key of the account to monitor
   * @param callback Function to invoke whenever the account is changed
   * @param commitment Specify the commitment level account changes must reach before notification
   * @return subscription id
   */ onAccountChange(publicKey, callback, commitment) {
        const args = this._buildArgs([
            publicKey.toBase58()
        ], commitment || this._commitment || "finalized", // Apply connection/server default.
        "base64");
        return this._makeSubscription({
            callback: callback,
            method: "accountSubscribe",
            unsubscribeMethod: "accountUnsubscribe"
        }, args);
    }
    /**
   * Deregister an account notification callback
   *
   * @param id client subscription id to deregister
   */ async removeAccountChangeListener(clientSubscriptionId) {
        await this._unsubscribeClientSubscription(clientSubscriptionId, "account change");
    }
    /**
   * @internal
   */ _wsOnProgramAccountNotification(notification) {
        const { result: result, subscription: subscription } = (0, $7154594b4f0d1928$export$185802fd694ee1f5)(notification, $163ae62b92845c86$var$ProgramAccountNotificationResult);
        this._handleServerNotification(subscription, [
            {
                accountId: result.value.pubkey,
                accountInfo: result.value.account
            },
            result.context
        ]);
    }
    /**
   * Register a callback to be invoked whenever accounts owned by the
   * specified program change
   *
   * @param programId Public key of the program to monitor
   * @param callback Function to invoke whenever the account is changed
   * @param commitment Specify the commitment level account changes must reach before notification
   * @param filters The program account filters to pass into the RPC method
   * @return subscription id
   */ onProgramAccountChange(programId, callback, commitment, filters) {
        const args = this._buildArgs([
            programId.toBase58()
        ], commitment || this._commitment || "finalized", // Apply connection/server default.
        "base64" /* encoding */ , filters ? {
            filters: filters
        } : undefined /* extra */ );
        return this._makeSubscription({
            callback: callback,
            method: "programSubscribe",
            unsubscribeMethod: "programUnsubscribe"
        }, args);
    }
    /**
   * Deregister an account notification callback
   *
   * @param id client subscription id to deregister
   */ async removeProgramAccountChangeListener(clientSubscriptionId) {
        await this._unsubscribeClientSubscription(clientSubscriptionId, "program account change");
    }
    /**
   * Registers a callback to be invoked whenever logs are emitted.
   */ onLogs(filter, callback, commitment) {
        const args = this._buildArgs([
            typeof filter === "object" ? {
                mentions: [
                    filter.toString()
                ]
            } : filter
        ], commitment || this._commitment || "finalized" // Apply connection/server default.
        );
        return this._makeSubscription({
            callback: callback,
            method: "logsSubscribe",
            unsubscribeMethod: "logsUnsubscribe"
        }, args);
    }
    /**
   * Deregister a logs callback.
   *
   * @param id client subscription id to deregister.
   */ async removeOnLogsListener(clientSubscriptionId) {
        await this._unsubscribeClientSubscription(clientSubscriptionId, "logs");
    }
    /**
   * @internal
   */ _wsOnLogsNotification(notification) {
        const { result: result, subscription: subscription } = (0, $7154594b4f0d1928$export$185802fd694ee1f5)(notification, $163ae62b92845c86$var$LogsNotificationResult);
        this._handleServerNotification(subscription, [
            result.value,
            result.context
        ]);
    }
    /**
   * @internal
   */ _wsOnSlotNotification(notification) {
        const { result: result, subscription: subscription } = (0, $7154594b4f0d1928$export$185802fd694ee1f5)(notification, $163ae62b92845c86$var$SlotNotificationResult);
        this._handleServerNotification(subscription, [
            result
        ]);
    }
    /**
   * Register a callback to be invoked upon slot changes
   *
   * @param callback Function to invoke whenever the slot changes
   * @return subscription id
   */ onSlotChange(callback) {
        return this._makeSubscription({
            callback: callback,
            method: "slotSubscribe",
            unsubscribeMethod: "slotUnsubscribe"
        }, []);
    }
    /**
   * Deregister a slot notification callback
   *
   * @param id client subscription id to deregister
   */ async removeSlotChangeListener(clientSubscriptionId) {
        await this._unsubscribeClientSubscription(clientSubscriptionId, "slot change");
    }
    /**
   * @internal
   */ _wsOnSlotUpdatesNotification(notification) {
        const { result: result, subscription: subscription } = (0, $7154594b4f0d1928$export$185802fd694ee1f5)(notification, $163ae62b92845c86$var$SlotUpdateNotificationResult);
        this._handleServerNotification(subscription, [
            result
        ]);
    }
    /**
   * Register a callback to be invoked upon slot updates. {@link SlotUpdate}'s
   * may be useful to track live progress of a cluster.
   *
   * @param callback Function to invoke whenever the slot updates
   * @return subscription id
   */ onSlotUpdate(callback) {
        return this._makeSubscription({
            callback: callback,
            method: "slotsUpdatesSubscribe",
            unsubscribeMethod: "slotsUpdatesUnsubscribe"
        }, []);
    }
    /**
   * Deregister a slot update notification callback
   *
   * @param id client subscription id to deregister
   */ async removeSlotUpdateListener(clientSubscriptionId) {
        await this._unsubscribeClientSubscription(clientSubscriptionId, "slot update");
    }
    /**
   * @internal
   */ async _unsubscribeClientSubscription(clientSubscriptionId, subscriptionName) {
        const dispose = this._subscriptionDisposeFunctionsByClientSubscriptionId[clientSubscriptionId];
        if (dispose) await dispose();
        else console.warn("Ignored unsubscribe request because an active subscription with id " + `\`${clientSubscriptionId}\` for '${subscriptionName}' events ` + "could not be found.");
    }
    _buildArgs(args, override, encoding, extra) {
        const commitment = override || this._commitment;
        if (commitment || encoding || extra) {
            let options = {};
            if (encoding) options.encoding = encoding;
            if (commitment) options.commitment = commitment;
            if (extra) options = Object.assign(options, extra);
            args.push(options);
        }
        return args;
    }
    /**
   * @internal
   */ _buildArgsAtLeastConfirmed(args, override, encoding, extra) {
        const commitment = override || this._commitment;
        if (commitment && ![
            "confirmed",
            "finalized"
        ].includes(commitment)) throw new Error("Using Connection with default commitment: `" + this._commitment + "`, but method requires at least `confirmed`");
        return this._buildArgs(args, override, encoding, extra);
    }
    /**
   * @internal
   */ _wsOnSignatureNotification(notification) {
        const { result: result, subscription: subscription } = (0, $7154594b4f0d1928$export$185802fd694ee1f5)(notification, $163ae62b92845c86$var$SignatureNotificationResult);
        if (result.value !== "receivedSignature") /**
       * Special case.
       * After a signature is processed, RPCs automatically dispose of the
       * subscription on the server side. We need to track which of these
       * subscriptions have been disposed in such a way, so that we know
       * whether the client is dealing with a not-yet-processed signature
       * (in which case we must tear down the server subscription) or an
       * already-processed signature (in which case the client can simply
       * clear out the subscription locally without telling the server).
       *
       * NOTE: There is a proposal to eliminate this special case, here:
       * https://github.com/solana-labs/solana/issues/18892
       */ this._subscriptionsAutoDisposedByRpc.add(subscription);
        this._handleServerNotification(subscription, result.value === "receivedSignature" ? [
            {
                type: "received"
            },
            result.context
        ] : [
            {
                type: "status",
                result: result.value
            },
            result.context
        ]);
    }
    /**
   * Register a callback to be invoked upon signature updates
   *
   * @param signature Transaction signature string in base 58
   * @param callback Function to invoke on signature notifications
   * @param commitment Specify the commitment level signature must reach before notification
   * @return subscription id
   */ onSignature(signature, callback, commitment) {
        const args = this._buildArgs([
            signature
        ], commitment || this._commitment || "finalized" // Apply connection/server default.
        );
        const clientSubscriptionId = this._makeSubscription({
            callback: (notification, context)=>{
                if (notification.type === "status") {
                    callback(notification.result, context);
                    // Signatures subscriptions are auto-removed by the RPC service
                    // so no need to explicitly send an unsubscribe message.
                    try {
                        this.removeSignatureListener(clientSubscriptionId);
                    // eslint-disable-next-line no-empty
                    } catch (_err) {
                    // Already removed.
                    }
                }
            },
            method: "signatureSubscribe",
            unsubscribeMethod: "signatureUnsubscribe"
        }, args);
        return clientSubscriptionId;
    }
    /**
   * Register a callback to be invoked when a transaction is
   * received and/or processed.
   *
   * @param signature Transaction signature string in base 58
   * @param callback Function to invoke on signature notifications
   * @param options Enable received notifications and set the commitment
   *   level that signature must reach before notification
   * @return subscription id
   */ onSignatureWithOptions(signature, callback, options) {
        const { commitment: commitment, ...extra } = {
            ...options,
            commitment: options && options.commitment || this._commitment || "finalized" // Apply connection/server default.
        };
        const args = this._buildArgs([
            signature
        ], commitment, undefined /* encoding */ , extra);
        const clientSubscriptionId = this._makeSubscription({
            callback: (notification, context)=>{
                callback(notification, context);
                // Signatures subscriptions are auto-removed by the RPC service
                // so no need to explicitly send an unsubscribe message.
                try {
                    this.removeSignatureListener(clientSubscriptionId);
                // eslint-disable-next-line no-empty
                } catch (_err) {
                // Already removed.
                }
            },
            method: "signatureSubscribe",
            unsubscribeMethod: "signatureUnsubscribe"
        }, args);
        return clientSubscriptionId;
    }
    /**
   * Deregister a signature notification callback
   *
   * @param id client subscription id to deregister
   */ async removeSignatureListener(clientSubscriptionId) {
        await this._unsubscribeClientSubscription(clientSubscriptionId, "signature result");
    }
    /**
   * @internal
   */ _wsOnRootNotification(notification) {
        const { result: result, subscription: subscription } = (0, $7154594b4f0d1928$export$185802fd694ee1f5)(notification, $163ae62b92845c86$var$RootNotificationResult);
        this._handleServerNotification(subscription, [
            result
        ]);
    }
    /**
   * Register a callback to be invoked upon root changes
   *
   * @param callback Function to invoke whenever the root changes
   * @return subscription id
   */ onRootChange(callback) {
        return this._makeSubscription({
            callback: callback,
            method: "rootSubscribe",
            unsubscribeMethod: "rootUnsubscribe"
        }, []);
    }
    /**
   * Deregister a root notification callback
   *
   * @param id client subscription id to deregister
   */ async removeRootChangeListener(clientSubscriptionId) {
        await this._unsubscribeClientSubscription(clientSubscriptionId, "root change");
    }
}
/**
 * Keypair signer interface
 */ /**
 * An account keypair used for signing transactions.
 */ class $163ae62b92845c86$export$c53bca448cf33676 {
    /**
   * Create a new keypair instance.
   * Generate random keypair if no {@link Ed25519Keypair} is provided.
   *
   * @param {Ed25519Keypair} keypair ed25519 keypair
   */ constructor(keypair){
        this._keypair = void 0;
        this._keypair = keypair ?? $163ae62b92845c86$var$generateKeypair();
    }
    /**
   * Generate a new random keypair
   *
   * @returns {Keypair} Keypair
   */ static generate() {
        return new $163ae62b92845c86$export$c53bca448cf33676($163ae62b92845c86$var$generateKeypair());
    }
    /**
   * Create a keypair from a raw secret key byte array.
   *
   * This method should only be used to recreate a keypair from a previously
   * generated secret key. Generating keypairs from a random seed should be done
   * with the {@link Keypair.fromSeed} method.
   *
   * @throws error if the provided secret key is invalid and validation is not skipped.
   *
   * @param secretKey secret key byte array
   * @param options skip secret key validation
   *
   * @returns {Keypair} Keypair
   */ static fromSecretKey(secretKey, options) {
        if (secretKey.byteLength !== 64) throw new Error("bad secret key size");
        const publicKey = secretKey.slice(32, 64);
        if (!options || !options.skipValidation) {
            const privateScalar = secretKey.slice(0, 32);
            const computedPublicKey = $163ae62b92845c86$var$getPublicKey(privateScalar);
            for(let ii = 0; ii < 32; ii++){
                if (publicKey[ii] !== computedPublicKey[ii]) throw new Error("provided secretKey is invalid");
            }
        }
        return new $163ae62b92845c86$export$c53bca448cf33676({
            publicKey: publicKey,
            secretKey: secretKey
        });
    }
    /**
   * Generate a keypair from a 32 byte seed.
   *
   * @param seed seed byte array
   *
   * @returns {Keypair} Keypair
   */ static fromSeed(seed) {
        const publicKey = $163ae62b92845c86$var$getPublicKey(seed);
        const secretKey = new Uint8Array(64);
        secretKey.set(seed);
        secretKey.set(publicKey, 32);
        return new $163ae62b92845c86$export$c53bca448cf33676({
            publicKey: publicKey,
            secretKey: secretKey
        });
    }
    /**
   * The public key for this keypair
   *
   * @returns {PublicKey} PublicKey
   */ get publicKey() {
        return new $163ae62b92845c86$export$ca8b6604d6ce14de(this._keypair.publicKey);
    }
    /**
   * The raw secret key for this keypair
   * @returns {Uint8Array} Secret key in an array of Uint8 bytes
   */ get secretKey() {
        return new Uint8Array(this._keypair.secretKey);
    }
}
/**
 * An enumeration of valid LookupTableInstructionType's
 */ /**
 * An enumeration of valid address lookup table InstructionType's
 * @internal
 */ const $163ae62b92845c86$export$7d102200c3a357d6 = Object.freeze({
    CreateLookupTable: {
        index: 0,
        layout: $2913ed74210dce84$exports.struct([
            $2913ed74210dce84$exports.u32("instruction"),
            $163ae62b92845c86$var$u64("recentSlot"),
            $2913ed74210dce84$exports.u8("bumpSeed")
        ])
    },
    FreezeLookupTable: {
        index: 1,
        layout: $2913ed74210dce84$exports.struct([
            $2913ed74210dce84$exports.u32("instruction")
        ])
    },
    ExtendLookupTable: {
        index: 2,
        layout: $2913ed74210dce84$exports.struct([
            $2913ed74210dce84$exports.u32("instruction"),
            $163ae62b92845c86$var$u64(),
            $2913ed74210dce84$exports.seq($163ae62b92845c86$var$publicKey(), $2913ed74210dce84$exports.offset($2913ed74210dce84$exports.u32(), -8), "addresses")
        ])
    },
    DeactivateLookupTable: {
        index: 3,
        layout: $2913ed74210dce84$exports.struct([
            $2913ed74210dce84$exports.u32("instruction")
        ])
    },
    CloseLookupTable: {
        index: 4,
        layout: $2913ed74210dce84$exports.struct([
            $2913ed74210dce84$exports.u32("instruction")
        ])
    }
});
class $163ae62b92845c86$export$3ab2b24d551f0dc2 {
    /**
   * @internal
   */ constructor(){}
    static decodeInstructionType(instruction) {
        this.checkProgramId(instruction.programId);
        const instructionTypeLayout = $2913ed74210dce84$exports.u32("instruction");
        const index = instructionTypeLayout.decode(instruction.data);
        let type;
        for (const [layoutType, layout] of Object.entries($163ae62b92845c86$export$7d102200c3a357d6))if (layout.index == index) {
            type = layoutType;
            break;
        }
        if (!type) throw new Error("Invalid Instruction. Should be a LookupTable Instruction");
        return type;
    }
    static decodeCreateLookupTable(instruction) {
        this.checkProgramId(instruction.programId);
        this.checkKeysLength(instruction.keys, 4);
        const { recentSlot: recentSlot } = $163ae62b92845c86$var$decodeData$1($163ae62b92845c86$export$7d102200c3a357d6.CreateLookupTable, instruction.data);
        return {
            authority: instruction.keys[1].pubkey,
            payer: instruction.keys[2].pubkey,
            recentSlot: Number(recentSlot)
        };
    }
    static decodeExtendLookupTable(instruction) {
        this.checkProgramId(instruction.programId);
        if (instruction.keys.length < 2) throw new Error(`invalid instruction; found ${instruction.keys.length} keys, expected at least 2`);
        const { addresses: addresses } = $163ae62b92845c86$var$decodeData$1($163ae62b92845c86$export$7d102200c3a357d6.ExtendLookupTable, instruction.data);
        return {
            lookupTable: instruction.keys[0].pubkey,
            authority: instruction.keys[1].pubkey,
            payer: instruction.keys.length > 2 ? instruction.keys[2].pubkey : undefined,
            addresses: addresses.map((buffer)=>new $163ae62b92845c86$export$ca8b6604d6ce14de(buffer))
        };
    }
    static decodeCloseLookupTable(instruction) {
        this.checkProgramId(instruction.programId);
        this.checkKeysLength(instruction.keys, 3);
        return {
            lookupTable: instruction.keys[0].pubkey,
            authority: instruction.keys[1].pubkey,
            recipient: instruction.keys[2].pubkey
        };
    }
    static decodeFreezeLookupTable(instruction) {
        this.checkProgramId(instruction.programId);
        this.checkKeysLength(instruction.keys, 2);
        return {
            lookupTable: instruction.keys[0].pubkey,
            authority: instruction.keys[1].pubkey
        };
    }
    static decodeDeactivateLookupTable(instruction) {
        this.checkProgramId(instruction.programId);
        this.checkKeysLength(instruction.keys, 2);
        return {
            lookupTable: instruction.keys[0].pubkey,
            authority: instruction.keys[1].pubkey
        };
    }
    /**
   * @internal
   */ static checkProgramId(programId) {
        if (!programId.equals($163ae62b92845c86$export$5147a345798de168.programId)) throw new Error("invalid instruction; programId is not AddressLookupTable Program");
    }
    /**
   * @internal
   */ static checkKeysLength(keys, expectedLength) {
        if (keys.length < expectedLength) throw new Error(`invalid instruction; found ${keys.length} keys, expected at least ${expectedLength}`);
    }
}
class $163ae62b92845c86$export$5147a345798de168 {
    /**
   * @internal
   */ constructor(){}
    static createLookupTable(params) {
        const [lookupTableAddress, bumpSeed] = $163ae62b92845c86$export$ca8b6604d6ce14de.findProgramAddressSync([
            params.authority.toBuffer(),
            (0, $bc91bf67ed8c7241$exports.toBufferLE)(BigInt(params.recentSlot), 8)
        ], this.programId);
        const type = $163ae62b92845c86$export$7d102200c3a357d6.CreateLookupTable;
        const data = $163ae62b92845c86$var$encodeData(type, {
            recentSlot: BigInt(params.recentSlot),
            bumpSeed: bumpSeed
        });
        const keys = [
            {
                pubkey: lookupTableAddress,
                isSigner: false,
                isWritable: true
            },
            {
                pubkey: params.authority,
                isSigner: true,
                isWritable: false
            },
            {
                pubkey: params.payer,
                isSigner: true,
                isWritable: true
            },
            {
                pubkey: $163ae62b92845c86$export$d8c4e17726848113.programId,
                isSigner: false,
                isWritable: false
            }
        ];
        return [
            new $163ae62b92845c86$export$a7a3aa8360ac9f59({
                programId: this.programId,
                keys: keys,
                data: data
            }),
            lookupTableAddress
        ];
    }
    static freezeLookupTable(params) {
        const type = $163ae62b92845c86$export$7d102200c3a357d6.FreezeLookupTable;
        const data = $163ae62b92845c86$var$encodeData(type);
        const keys = [
            {
                pubkey: params.lookupTable,
                isSigner: false,
                isWritable: true
            },
            {
                pubkey: params.authority,
                isSigner: true,
                isWritable: false
            }
        ];
        return new $163ae62b92845c86$export$a7a3aa8360ac9f59({
            programId: this.programId,
            keys: keys,
            data: data
        });
    }
    static extendLookupTable(params) {
        const type = $163ae62b92845c86$export$7d102200c3a357d6.ExtendLookupTable;
        const data = $163ae62b92845c86$var$encodeData(type, {
            addresses: params.addresses.map((addr)=>addr.toBytes())
        });
        const keys = [
            {
                pubkey: params.lookupTable,
                isSigner: false,
                isWritable: true
            },
            {
                pubkey: params.authority,
                isSigner: true,
                isWritable: false
            }
        ];
        if (params.payer) keys.push({
            pubkey: params.payer,
            isSigner: true,
            isWritable: true
        }, {
            pubkey: $163ae62b92845c86$export$d8c4e17726848113.programId,
            isSigner: false,
            isWritable: false
        });
        return new $163ae62b92845c86$export$a7a3aa8360ac9f59({
            programId: this.programId,
            keys: keys,
            data: data
        });
    }
    static deactivateLookupTable(params) {
        const type = $163ae62b92845c86$export$7d102200c3a357d6.DeactivateLookupTable;
        const data = $163ae62b92845c86$var$encodeData(type);
        const keys = [
            {
                pubkey: params.lookupTable,
                isSigner: false,
                isWritable: true
            },
            {
                pubkey: params.authority,
                isSigner: true,
                isWritable: false
            }
        ];
        return new $163ae62b92845c86$export$a7a3aa8360ac9f59({
            programId: this.programId,
            keys: keys,
            data: data
        });
    }
    static closeLookupTable(params) {
        const type = $163ae62b92845c86$export$7d102200c3a357d6.CloseLookupTable;
        const data = $163ae62b92845c86$var$encodeData(type);
        const keys = [
            {
                pubkey: params.lookupTable,
                isSigner: false,
                isWritable: true
            },
            {
                pubkey: params.authority,
                isSigner: true,
                isWritable: false
            },
            {
                pubkey: params.recipient,
                isSigner: false,
                isWritable: true
            }
        ];
        return new $163ae62b92845c86$export$a7a3aa8360ac9f59({
            programId: this.programId,
            keys: keys,
            data: data
        });
    }
}
$163ae62b92845c86$export$5147a345798de168.programId = new $163ae62b92845c86$export$ca8b6604d6ce14de("AddressLookupTab1e1111111111111111111111111");
/**
 * Compute Budget Instruction class
 */ class $163ae62b92845c86$export$bc4776847c641a67 {
    /**
   * @internal
   */ constructor(){}
    /**
   * Decode a compute budget instruction and retrieve the instruction type.
   */ static decodeInstructionType(instruction) {
        this.checkProgramId(instruction.programId);
        const instructionTypeLayout = $2913ed74210dce84$exports.u8("instruction");
        const typeIndex = instructionTypeLayout.decode(instruction.data);
        let type;
        for (const [ixType, layout] of Object.entries($163ae62b92845c86$export$b7c79c50764da3d6))if (layout.index == typeIndex) {
            type = ixType;
            break;
        }
        if (!type) throw new Error("Instruction type incorrect; not a ComputeBudgetInstruction");
        return type;
    }
    /**
   * Decode request units compute budget instruction and retrieve the instruction params.
   */ static decodeRequestUnits(instruction) {
        this.checkProgramId(instruction.programId);
        const { units: units, additionalFee: additionalFee } = $163ae62b92845c86$var$decodeData$1($163ae62b92845c86$export$b7c79c50764da3d6.RequestUnits, instruction.data);
        return {
            units: units,
            additionalFee: additionalFee
        };
    }
    /**
   * Decode request heap frame compute budget instruction and retrieve the instruction params.
   */ static decodeRequestHeapFrame(instruction) {
        this.checkProgramId(instruction.programId);
        const { bytes: bytes } = $163ae62b92845c86$var$decodeData$1($163ae62b92845c86$export$b7c79c50764da3d6.RequestHeapFrame, instruction.data);
        return {
            bytes: bytes
        };
    }
    /**
   * Decode set compute unit limit compute budget instruction and retrieve the instruction params.
   */ static decodeSetComputeUnitLimit(instruction) {
        this.checkProgramId(instruction.programId);
        const { units: units } = $163ae62b92845c86$var$decodeData$1($163ae62b92845c86$export$b7c79c50764da3d6.SetComputeUnitLimit, instruction.data);
        return {
            units: units
        };
    }
    /**
   * Decode set compute unit price compute budget instruction and retrieve the instruction params.
   */ static decodeSetComputeUnitPrice(instruction) {
        this.checkProgramId(instruction.programId);
        const { microLamports: microLamports } = $163ae62b92845c86$var$decodeData$1($163ae62b92845c86$export$b7c79c50764da3d6.SetComputeUnitPrice, instruction.data);
        return {
            microLamports: microLamports
        };
    }
    /**
   * @internal
   */ static checkProgramId(programId) {
        if (!programId.equals($163ae62b92845c86$export$11585db5942bcdb7.programId)) throw new Error("invalid instruction; programId is not ComputeBudgetProgram");
    }
}
/**
 * An enumeration of valid ComputeBudgetInstructionType's
 */ /**
 * Request units instruction params
 */ /**
 * Request heap frame instruction params
 */ /**
 * Set compute unit limit instruction params
 */ /**
 * Set compute unit price instruction params
 */ /**
 * An enumeration of valid ComputeBudget InstructionType's
 * @internal
 */ const $163ae62b92845c86$export$b7c79c50764da3d6 = Object.freeze({
    RequestUnits: {
        index: 0,
        layout: $2913ed74210dce84$exports.struct([
            $2913ed74210dce84$exports.u8("instruction"),
            $2913ed74210dce84$exports.u32("units"),
            $2913ed74210dce84$exports.u32("additionalFee")
        ])
    },
    RequestHeapFrame: {
        index: 1,
        layout: $2913ed74210dce84$exports.struct([
            $2913ed74210dce84$exports.u8("instruction"),
            $2913ed74210dce84$exports.u32("bytes")
        ])
    },
    SetComputeUnitLimit: {
        index: 2,
        layout: $2913ed74210dce84$exports.struct([
            $2913ed74210dce84$exports.u8("instruction"),
            $2913ed74210dce84$exports.u32("units")
        ])
    },
    SetComputeUnitPrice: {
        index: 3,
        layout: $2913ed74210dce84$exports.struct([
            $2913ed74210dce84$exports.u8("instruction"),
            $163ae62b92845c86$var$u64("microLamports")
        ])
    }
});
/**
 * Factory class for transaction instructions to interact with the Compute Budget program
 */ class $163ae62b92845c86$export$11585db5942bcdb7 {
    /**
   * @internal
   */ constructor(){}
    /**
   * Public key that identifies the Compute Budget program
   */ /**
   * @deprecated Instead, call {@link setComputeUnitLimit} and/or {@link setComputeUnitPrice}
   */ static requestUnits(params) {
        const type = $163ae62b92845c86$export$b7c79c50764da3d6.RequestUnits;
        const data = $163ae62b92845c86$var$encodeData(type, params);
        return new $163ae62b92845c86$export$a7a3aa8360ac9f59({
            keys: [],
            programId: this.programId,
            data: data
        });
    }
    static requestHeapFrame(params) {
        const type = $163ae62b92845c86$export$b7c79c50764da3d6.RequestHeapFrame;
        const data = $163ae62b92845c86$var$encodeData(type, params);
        return new $163ae62b92845c86$export$a7a3aa8360ac9f59({
            keys: [],
            programId: this.programId,
            data: data
        });
    }
    static setComputeUnitLimit(params) {
        const type = $163ae62b92845c86$export$b7c79c50764da3d6.SetComputeUnitLimit;
        const data = $163ae62b92845c86$var$encodeData(type, params);
        return new $163ae62b92845c86$export$a7a3aa8360ac9f59({
            keys: [],
            programId: this.programId,
            data: data
        });
    }
    static setComputeUnitPrice(params) {
        const type = $163ae62b92845c86$export$b7c79c50764da3d6.SetComputeUnitPrice;
        const data = $163ae62b92845c86$var$encodeData(type, {
            microLamports: BigInt(params.microLamports)
        });
        return new $163ae62b92845c86$export$a7a3aa8360ac9f59({
            keys: [],
            programId: this.programId,
            data: data
        });
    }
}
$163ae62b92845c86$export$11585db5942bcdb7.programId = new $163ae62b92845c86$export$ca8b6604d6ce14de("ComputeBudget111111111111111111111111111111");
const $163ae62b92845c86$var$PRIVATE_KEY_BYTES$1 = 64;
const $163ae62b92845c86$var$PUBLIC_KEY_BYTES$1 = 32;
const $163ae62b92845c86$var$SIGNATURE_BYTES = 64;
/**
 * Params for creating an ed25519 instruction using a public key
 */ /**
 * Params for creating an ed25519 instruction using a private key
 */ const $163ae62b92845c86$var$ED25519_INSTRUCTION_LAYOUT = $2913ed74210dce84$exports.struct([
    $2913ed74210dce84$exports.u8("numSignatures"),
    $2913ed74210dce84$exports.u8("padding"),
    $2913ed74210dce84$exports.u16("signatureOffset"),
    $2913ed74210dce84$exports.u16("signatureInstructionIndex"),
    $2913ed74210dce84$exports.u16("publicKeyOffset"),
    $2913ed74210dce84$exports.u16("publicKeyInstructionIndex"),
    $2913ed74210dce84$exports.u16("messageDataOffset"),
    $2913ed74210dce84$exports.u16("messageDataSize"),
    $2913ed74210dce84$exports.u16("messageInstructionIndex")
]);
class $163ae62b92845c86$export$e5087aea02631e {
    /**
   * @internal
   */ constructor(){}
    /**
   * Public key that identifies the ed25519 program
   */ /**
   * Create an ed25519 instruction with a public key and signature. The
   * public key must be a buffer that is 32 bytes long, and the signature
   * must be a buffer of 64 bytes.
   */ static createInstructionWithPublicKey(params) {
        const { publicKey: publicKey, message: message, signature: signature, instructionIndex: instructionIndex } = params;
        $163ae62b92845c86$var$assert(publicKey.length === $163ae62b92845c86$var$PUBLIC_KEY_BYTES$1, `Public Key must be ${$163ae62b92845c86$var$PUBLIC_KEY_BYTES$1} bytes but received ${publicKey.length} bytes`);
        $163ae62b92845c86$var$assert(signature.length === $163ae62b92845c86$var$SIGNATURE_BYTES, `Signature must be ${$163ae62b92845c86$var$SIGNATURE_BYTES} bytes but received ${signature.length} bytes`);
        const publicKeyOffset = $163ae62b92845c86$var$ED25519_INSTRUCTION_LAYOUT.span;
        const signatureOffset = publicKeyOffset + publicKey.length;
        const messageDataOffset = signatureOffset + signature.length;
        const numSignatures = 1;
        const instructionData = (0, $5ed0747d5916bbd8$export$a143d493d941bafc).alloc(messageDataOffset + message.length);
        const index = instructionIndex == null ? 0xffff // An index of `u16::MAX` makes it default to the current instruction.
         : instructionIndex;
        $163ae62b92845c86$var$ED25519_INSTRUCTION_LAYOUT.encode({
            numSignatures: numSignatures,
            padding: 0,
            signatureOffset: signatureOffset,
            signatureInstructionIndex: index,
            publicKeyOffset: publicKeyOffset,
            publicKeyInstructionIndex: index,
            messageDataOffset: messageDataOffset,
            messageDataSize: message.length,
            messageInstructionIndex: index
        }, instructionData);
        instructionData.fill(publicKey, publicKeyOffset);
        instructionData.fill(signature, signatureOffset);
        instructionData.fill(message, messageDataOffset);
        return new $163ae62b92845c86$export$a7a3aa8360ac9f59({
            keys: [],
            programId: $163ae62b92845c86$export$e5087aea02631e.programId,
            data: instructionData
        });
    }
    /**
   * Create an ed25519 instruction with a private key. The private key
   * must be a buffer that is 64 bytes long.
   */ static createInstructionWithPrivateKey(params) {
        const { privateKey: privateKey, message: message, instructionIndex: instructionIndex } = params;
        $163ae62b92845c86$var$assert(privateKey.length === $163ae62b92845c86$var$PRIVATE_KEY_BYTES$1, `Private key must be ${$163ae62b92845c86$var$PRIVATE_KEY_BYTES$1} bytes but received ${privateKey.length} bytes`);
        try {
            const keypair = $163ae62b92845c86$export$c53bca448cf33676.fromSecretKey(privateKey);
            const publicKey = keypair.publicKey.toBytes();
            const signature = $163ae62b92845c86$var$sign(message, keypair.secretKey);
            return this.createInstructionWithPublicKey({
                publicKey: publicKey,
                message: message,
                signature: signature,
                instructionIndex: instructionIndex
            });
        } catch (error) {
            throw new Error(`Error creating instruction; ${error}`);
        }
    }
}
$163ae62b92845c86$export$e5087aea02631e.programId = new $163ae62b92845c86$export$ca8b6604d6ce14de("Ed25519SigVerify111111111111111111111111111");
const $163ae62b92845c86$var$ecdsaSign = (msgHash, privKey)=>{
    const signature = (0, $b7c00ec1cc5daba7$exports.secp256k1).sign(msgHash, privKey);
    return [
        signature.toCompactRawBytes(),
        signature.recovery
    ];
};
(0, $b7c00ec1cc5daba7$exports.secp256k1).utils.isValidPrivateKey;
const $163ae62b92845c86$var$publicKeyCreate = (0, $b7c00ec1cc5daba7$exports.secp256k1).getPublicKey;
const $163ae62b92845c86$var$PRIVATE_KEY_BYTES = 32;
const $163ae62b92845c86$var$ETHEREUM_ADDRESS_BYTES = 20;
const $163ae62b92845c86$var$PUBLIC_KEY_BYTES = 64;
const $163ae62b92845c86$var$SIGNATURE_OFFSETS_SERIALIZED_SIZE = 11;
/**
 * Params for creating an secp256k1 instruction using a public key
 */ /**
 * Params for creating an secp256k1 instruction using an Ethereum address
 */ /**
 * Params for creating an secp256k1 instruction using a private key
 */ const $163ae62b92845c86$var$SECP256K1_INSTRUCTION_LAYOUT = $2913ed74210dce84$exports.struct([
    $2913ed74210dce84$exports.u8("numSignatures"),
    $2913ed74210dce84$exports.u16("signatureOffset"),
    $2913ed74210dce84$exports.u8("signatureInstructionIndex"),
    $2913ed74210dce84$exports.u16("ethAddressOffset"),
    $2913ed74210dce84$exports.u8("ethAddressInstructionIndex"),
    $2913ed74210dce84$exports.u16("messageDataOffset"),
    $2913ed74210dce84$exports.u16("messageDataSize"),
    $2913ed74210dce84$exports.u8("messageInstructionIndex"),
    $2913ed74210dce84$exports.blob(20, "ethAddress"),
    $2913ed74210dce84$exports.blob(64, "signature"),
    $2913ed74210dce84$exports.u8("recoveryId")
]);
class $163ae62b92845c86$export$d85dd4c1161d13c9 {
    /**
   * @internal
   */ constructor(){}
    /**
   * Public key that identifies the secp256k1 program
   */ /**
   * Construct an Ethereum address from a secp256k1 public key buffer.
   * @param {Buffer} publicKey a 64 byte secp256k1 public key buffer
   */ static publicKeyToEthAddress(publicKey) {
        $163ae62b92845c86$var$assert(publicKey.length === $163ae62b92845c86$var$PUBLIC_KEY_BYTES, `Public key must be ${$163ae62b92845c86$var$PUBLIC_KEY_BYTES} bytes but received ${publicKey.length} bytes`);
        try {
            return (0, $5ed0747d5916bbd8$export$a143d493d941bafc).from((0, $jDAn2.keccak_256)($163ae62b92845c86$var$toBuffer(publicKey))).slice(-$163ae62b92845c86$var$ETHEREUM_ADDRESS_BYTES);
        } catch (error) {
            throw new Error(`Error constructing Ethereum address: ${error}`);
        }
    }
    /**
   * Create an secp256k1 instruction with a public key. The public key
   * must be a buffer that is 64 bytes long.
   */ static createInstructionWithPublicKey(params) {
        const { publicKey: publicKey, message: message, signature: signature, recoveryId: recoveryId, instructionIndex: instructionIndex } = params;
        return $163ae62b92845c86$export$d85dd4c1161d13c9.createInstructionWithEthAddress({
            ethAddress: $163ae62b92845c86$export$d85dd4c1161d13c9.publicKeyToEthAddress(publicKey),
            message: message,
            signature: signature,
            recoveryId: recoveryId,
            instructionIndex: instructionIndex
        });
    }
    /**
   * Create an secp256k1 instruction with an Ethereum address. The address
   * must be a hex string or a buffer that is 20 bytes long.
   */ static createInstructionWithEthAddress(params) {
        const { ethAddress: rawAddress, message: message, signature: signature, recoveryId: recoveryId, instructionIndex: instructionIndex = 0 } = params;
        let ethAddress;
        if (typeof rawAddress === "string") {
            if (rawAddress.startsWith("0x")) ethAddress = (0, $5ed0747d5916bbd8$export$a143d493d941bafc).from(rawAddress.substr(2), "hex");
            else ethAddress = (0, $5ed0747d5916bbd8$export$a143d493d941bafc).from(rawAddress, "hex");
        } else ethAddress = rawAddress;
        $163ae62b92845c86$var$assert(ethAddress.length === $163ae62b92845c86$var$ETHEREUM_ADDRESS_BYTES, `Address must be ${$163ae62b92845c86$var$ETHEREUM_ADDRESS_BYTES} bytes but received ${ethAddress.length} bytes`);
        const dataStart = 1 + $163ae62b92845c86$var$SIGNATURE_OFFSETS_SERIALIZED_SIZE;
        const ethAddressOffset = dataStart;
        const signatureOffset = dataStart + ethAddress.length;
        const messageDataOffset = signatureOffset + signature.length + 1;
        const numSignatures = 1;
        const instructionData = (0, $5ed0747d5916bbd8$export$a143d493d941bafc).alloc($163ae62b92845c86$var$SECP256K1_INSTRUCTION_LAYOUT.span + message.length);
        $163ae62b92845c86$var$SECP256K1_INSTRUCTION_LAYOUT.encode({
            numSignatures: numSignatures,
            signatureOffset: signatureOffset,
            signatureInstructionIndex: instructionIndex,
            ethAddressOffset: ethAddressOffset,
            ethAddressInstructionIndex: instructionIndex,
            messageDataOffset: messageDataOffset,
            messageDataSize: message.length,
            messageInstructionIndex: instructionIndex,
            signature: $163ae62b92845c86$var$toBuffer(signature),
            ethAddress: $163ae62b92845c86$var$toBuffer(ethAddress),
            recoveryId: recoveryId
        }, instructionData);
        instructionData.fill($163ae62b92845c86$var$toBuffer(message), $163ae62b92845c86$var$SECP256K1_INSTRUCTION_LAYOUT.span);
        return new $163ae62b92845c86$export$a7a3aa8360ac9f59({
            keys: [],
            programId: $163ae62b92845c86$export$d85dd4c1161d13c9.programId,
            data: instructionData
        });
    }
    /**
   * Create an secp256k1 instruction with a private key. The private key
   * must be a buffer that is 32 bytes long.
   */ static createInstructionWithPrivateKey(params) {
        const { privateKey: pkey, message: message, instructionIndex: instructionIndex } = params;
        $163ae62b92845c86$var$assert(pkey.length === $163ae62b92845c86$var$PRIVATE_KEY_BYTES, `Private key must be ${$163ae62b92845c86$var$PRIVATE_KEY_BYTES} bytes but received ${pkey.length} bytes`);
        try {
            const privateKey = $163ae62b92845c86$var$toBuffer(pkey);
            const publicKey = $163ae62b92845c86$var$publicKeyCreate(privateKey, false).slice(1); // throw away leading byte
            const messageHash = (0, $5ed0747d5916bbd8$export$a143d493d941bafc).from((0, $jDAn2.keccak_256)($163ae62b92845c86$var$toBuffer(message)));
            const [signature, recoveryId] = $163ae62b92845c86$var$ecdsaSign(messageHash, privateKey);
            return this.createInstructionWithPublicKey({
                publicKey: publicKey,
                message: message,
                signature: signature,
                recoveryId: recoveryId,
                instructionIndex: instructionIndex
            });
        } catch (error) {
            throw new Error(`Error creating instruction; ${error}`);
        }
    }
}
$163ae62b92845c86$export$d85dd4c1161d13c9.programId = new $163ae62b92845c86$export$ca8b6604d6ce14de("KeccakSecp256k11111111111111111111111111111");
var $163ae62b92845c86$var$_class2;
/**
 * Address of the stake config account which configures the rate
 * of stake warmup and cooldown as well as the slashing penalty.
 */ const $163ae62b92845c86$export$18aac71979bdd08f = new $163ae62b92845c86$export$ca8b6604d6ce14de("StakeConfig11111111111111111111111111111111");
/**
 * Stake account authority info
 */ class $163ae62b92845c86$export$9ac74ae66932a145 {
    /**
   * Create a new Authorized object
   * @param staker the stake authority
   * @param withdrawer the withdraw authority
   */ constructor(staker, withdrawer){
        /** stake authority */ this.staker = void 0;
        /** withdraw authority */ this.withdrawer = void 0;
        this.staker = staker;
        this.withdrawer = withdrawer;
    }
}
/**
 * Stake account lockup info
 */ class $163ae62b92845c86$export$e7f3941ade35598c {
    /**
   * Create a new Lockup object
   */ constructor(unixTimestamp, epoch, custodian){
        /** Unix timestamp of lockup expiration */ this.unixTimestamp = void 0;
        /** Epoch of lockup expiration */ this.epoch = void 0;
        /** Lockup custodian authority */ this.custodian = void 0;
        this.unixTimestamp = unixTimestamp;
        this.epoch = epoch;
        this.custodian = custodian;
    }
}
$163ae62b92845c86$var$_class2 = $163ae62b92845c86$export$e7f3941ade35598c;
$163ae62b92845c86$export$e7f3941ade35598c.default = new $163ae62b92845c86$var$_class2(0, 0, $163ae62b92845c86$export$ca8b6604d6ce14de.default);
/**
 * Create stake account transaction params
 */ /**
 * Create stake account with seed transaction params
 */ /**
 * Initialize stake instruction params
 */ /**
 * Delegate stake instruction params
 */ /**
 * Authorize stake instruction params
 */ /**
 * Authorize stake instruction params using a derived key
 */ /**
 * Split stake instruction params
 */ /**
 * Split with seed transaction params
 */ /**
 * Withdraw stake instruction params
 */ /**
 * Deactivate stake instruction params
 */ /**
 * Merge stake instruction params
 */ /**
 * Stake Instruction class
 */ class $163ae62b92845c86$export$aded313c3a4800f9 {
    /**
   * @internal
   */ constructor(){}
    /**
   * Decode a stake instruction and retrieve the instruction type.
   */ static decodeInstructionType(instruction) {
        this.checkProgramId(instruction.programId);
        const instructionTypeLayout = $2913ed74210dce84$exports.u32("instruction");
        const typeIndex = instructionTypeLayout.decode(instruction.data);
        let type;
        for (const [ixType, layout] of Object.entries($163ae62b92845c86$export$c89793bd2bba8b2e))if (layout.index == typeIndex) {
            type = ixType;
            break;
        }
        if (!type) throw new Error("Instruction type incorrect; not a StakeInstruction");
        return type;
    }
    /**
   * Decode a initialize stake instruction and retrieve the instruction params.
   */ static decodeInitialize(instruction) {
        this.checkProgramId(instruction.programId);
        this.checkKeyLength(instruction.keys, 2);
        const { authorized: authorized, lockup: lockup } = $163ae62b92845c86$var$decodeData$1($163ae62b92845c86$export$c89793bd2bba8b2e.Initialize, instruction.data);
        return {
            stakePubkey: instruction.keys[0].pubkey,
            authorized: new $163ae62b92845c86$export$9ac74ae66932a145(new $163ae62b92845c86$export$ca8b6604d6ce14de(authorized.staker), new $163ae62b92845c86$export$ca8b6604d6ce14de(authorized.withdrawer)),
            lockup: new $163ae62b92845c86$export$e7f3941ade35598c(lockup.unixTimestamp, lockup.epoch, new $163ae62b92845c86$export$ca8b6604d6ce14de(lockup.custodian))
        };
    }
    /**
   * Decode a delegate stake instruction and retrieve the instruction params.
   */ static decodeDelegate(instruction) {
        this.checkProgramId(instruction.programId);
        this.checkKeyLength(instruction.keys, 6);
        $163ae62b92845c86$var$decodeData$1($163ae62b92845c86$export$c89793bd2bba8b2e.Delegate, instruction.data);
        return {
            stakePubkey: instruction.keys[0].pubkey,
            votePubkey: instruction.keys[1].pubkey,
            authorizedPubkey: instruction.keys[5].pubkey
        };
    }
    /**
   * Decode an authorize stake instruction and retrieve the instruction params.
   */ static decodeAuthorize(instruction) {
        this.checkProgramId(instruction.programId);
        this.checkKeyLength(instruction.keys, 3);
        const { newAuthorized: newAuthorized, stakeAuthorizationType: stakeAuthorizationType } = $163ae62b92845c86$var$decodeData$1($163ae62b92845c86$export$c89793bd2bba8b2e.Authorize, instruction.data);
        const o = {
            stakePubkey: instruction.keys[0].pubkey,
            authorizedPubkey: instruction.keys[2].pubkey,
            newAuthorizedPubkey: new $163ae62b92845c86$export$ca8b6604d6ce14de(newAuthorized),
            stakeAuthorizationType: {
                index: stakeAuthorizationType
            }
        };
        if (instruction.keys.length > 3) o.custodianPubkey = instruction.keys[3].pubkey;
        return o;
    }
    /**
   * Decode an authorize-with-seed stake instruction and retrieve the instruction params.
   */ static decodeAuthorizeWithSeed(instruction) {
        this.checkProgramId(instruction.programId);
        this.checkKeyLength(instruction.keys, 2);
        const { newAuthorized: newAuthorized, stakeAuthorizationType: stakeAuthorizationType, authoritySeed: authoritySeed, authorityOwner: authorityOwner } = $163ae62b92845c86$var$decodeData$1($163ae62b92845c86$export$c89793bd2bba8b2e.AuthorizeWithSeed, instruction.data);
        const o = {
            stakePubkey: instruction.keys[0].pubkey,
            authorityBase: instruction.keys[1].pubkey,
            authoritySeed: authoritySeed,
            authorityOwner: new $163ae62b92845c86$export$ca8b6604d6ce14de(authorityOwner),
            newAuthorizedPubkey: new $163ae62b92845c86$export$ca8b6604d6ce14de(newAuthorized),
            stakeAuthorizationType: {
                index: stakeAuthorizationType
            }
        };
        if (instruction.keys.length > 3) o.custodianPubkey = instruction.keys[3].pubkey;
        return o;
    }
    /**
   * Decode a split stake instruction and retrieve the instruction params.
   */ static decodeSplit(instruction) {
        this.checkProgramId(instruction.programId);
        this.checkKeyLength(instruction.keys, 3);
        const { lamports: lamports } = $163ae62b92845c86$var$decodeData$1($163ae62b92845c86$export$c89793bd2bba8b2e.Split, instruction.data);
        return {
            stakePubkey: instruction.keys[0].pubkey,
            splitStakePubkey: instruction.keys[1].pubkey,
            authorizedPubkey: instruction.keys[2].pubkey,
            lamports: lamports
        };
    }
    /**
   * Decode a merge stake instruction and retrieve the instruction params.
   */ static decodeMerge(instruction) {
        this.checkProgramId(instruction.programId);
        this.checkKeyLength(instruction.keys, 3);
        $163ae62b92845c86$var$decodeData$1($163ae62b92845c86$export$c89793bd2bba8b2e.Merge, instruction.data);
        return {
            stakePubkey: instruction.keys[0].pubkey,
            sourceStakePubKey: instruction.keys[1].pubkey,
            authorizedPubkey: instruction.keys[4].pubkey
        };
    }
    /**
   * Decode a withdraw stake instruction and retrieve the instruction params.
   */ static decodeWithdraw(instruction) {
        this.checkProgramId(instruction.programId);
        this.checkKeyLength(instruction.keys, 5);
        const { lamports: lamports } = $163ae62b92845c86$var$decodeData$1($163ae62b92845c86$export$c89793bd2bba8b2e.Withdraw, instruction.data);
        const o = {
            stakePubkey: instruction.keys[0].pubkey,
            toPubkey: instruction.keys[1].pubkey,
            authorizedPubkey: instruction.keys[4].pubkey,
            lamports: lamports
        };
        if (instruction.keys.length > 5) o.custodianPubkey = instruction.keys[5].pubkey;
        return o;
    }
    /**
   * Decode a deactivate stake instruction and retrieve the instruction params.
   */ static decodeDeactivate(instruction) {
        this.checkProgramId(instruction.programId);
        this.checkKeyLength(instruction.keys, 3);
        $163ae62b92845c86$var$decodeData$1($163ae62b92845c86$export$c89793bd2bba8b2e.Deactivate, instruction.data);
        return {
            stakePubkey: instruction.keys[0].pubkey,
            authorizedPubkey: instruction.keys[2].pubkey
        };
    }
    /**
   * @internal
   */ static checkProgramId(programId) {
        if (!programId.equals($163ae62b92845c86$export$df86f933e9f8fb15.programId)) throw new Error("invalid instruction; programId is not StakeProgram");
    }
    /**
   * @internal
   */ static checkKeyLength(keys, expectedLength) {
        if (keys.length < expectedLength) throw new Error(`invalid instruction; found ${keys.length} keys, expected at least ${expectedLength}`);
    }
}
/**
 * An enumeration of valid StakeInstructionType's
 */ /**
 * An enumeration of valid stake InstructionType's
 * @internal
 */ const $163ae62b92845c86$export$c89793bd2bba8b2e = Object.freeze({
    Initialize: {
        index: 0,
        layout: $2913ed74210dce84$exports.struct([
            $2913ed74210dce84$exports.u32("instruction"),
            $163ae62b92845c86$var$authorized(),
            $163ae62b92845c86$var$lockup()
        ])
    },
    Authorize: {
        index: 1,
        layout: $2913ed74210dce84$exports.struct([
            $2913ed74210dce84$exports.u32("instruction"),
            $163ae62b92845c86$var$publicKey("newAuthorized"),
            $2913ed74210dce84$exports.u32("stakeAuthorizationType")
        ])
    },
    Delegate: {
        index: 2,
        layout: $2913ed74210dce84$exports.struct([
            $2913ed74210dce84$exports.u32("instruction")
        ])
    },
    Split: {
        index: 3,
        layout: $2913ed74210dce84$exports.struct([
            $2913ed74210dce84$exports.u32("instruction"),
            $2913ed74210dce84$exports.ns64("lamports")
        ])
    },
    Withdraw: {
        index: 4,
        layout: $2913ed74210dce84$exports.struct([
            $2913ed74210dce84$exports.u32("instruction"),
            $2913ed74210dce84$exports.ns64("lamports")
        ])
    },
    Deactivate: {
        index: 5,
        layout: $2913ed74210dce84$exports.struct([
            $2913ed74210dce84$exports.u32("instruction")
        ])
    },
    Merge: {
        index: 7,
        layout: $2913ed74210dce84$exports.struct([
            $2913ed74210dce84$exports.u32("instruction")
        ])
    },
    AuthorizeWithSeed: {
        index: 8,
        layout: $2913ed74210dce84$exports.struct([
            $2913ed74210dce84$exports.u32("instruction"),
            $163ae62b92845c86$var$publicKey("newAuthorized"),
            $2913ed74210dce84$exports.u32("stakeAuthorizationType"),
            $163ae62b92845c86$var$rustString("authoritySeed"),
            $163ae62b92845c86$var$publicKey("authorityOwner")
        ])
    }
});
/**
 * Stake authorization type
 */ /**
 * An enumeration of valid StakeAuthorizationLayout's
 */ const $163ae62b92845c86$export$4783920eadd34361 = Object.freeze({
    Staker: {
        index: 0
    },
    Withdrawer: {
        index: 1
    }
});
/**
 * Factory class for transactions to interact with the Stake program
 */ class $163ae62b92845c86$export$df86f933e9f8fb15 {
    /**
   * @internal
   */ constructor(){}
    /**
   * Public key that identifies the Stake program
   */ /**
   * Generate an Initialize instruction to add to a Stake Create transaction
   */ static initialize(params) {
        const { stakePubkey: stakePubkey, authorized: authorized, lockup: maybeLockup } = params;
        const lockup = maybeLockup || $163ae62b92845c86$export$e7f3941ade35598c.default;
        const type = $163ae62b92845c86$export$c89793bd2bba8b2e.Initialize;
        const data = $163ae62b92845c86$var$encodeData(type, {
            authorized: {
                staker: $163ae62b92845c86$var$toBuffer(authorized.staker.toBuffer()),
                withdrawer: $163ae62b92845c86$var$toBuffer(authorized.withdrawer.toBuffer())
            },
            lockup: {
                unixTimestamp: lockup.unixTimestamp,
                epoch: lockup.epoch,
                custodian: $163ae62b92845c86$var$toBuffer(lockup.custodian.toBuffer())
            }
        });
        const instructionData = {
            keys: [
                {
                    pubkey: stakePubkey,
                    isSigner: false,
                    isWritable: true
                },
                {
                    pubkey: $163ae62b92845c86$export$970d0190cdb3a8e9,
                    isSigner: false,
                    isWritable: false
                }
            ],
            programId: this.programId,
            data: data
        };
        return new $163ae62b92845c86$export$a7a3aa8360ac9f59(instructionData);
    }
    /**
   * Generate a Transaction that creates a new Stake account at
   *   an address generated with `from`, a seed, and the Stake programId
   */ static createAccountWithSeed(params) {
        const transaction = new $163ae62b92845c86$export$febc5573c75cefb0();
        transaction.add($163ae62b92845c86$export$d8c4e17726848113.createAccountWithSeed({
            fromPubkey: params.fromPubkey,
            newAccountPubkey: params.stakePubkey,
            basePubkey: params.basePubkey,
            seed: params.seed,
            lamports: params.lamports,
            space: this.space,
            programId: this.programId
        }));
        const { stakePubkey: stakePubkey, authorized: authorized, lockup: lockup } = params;
        return transaction.add(this.initialize({
            stakePubkey: stakePubkey,
            authorized: authorized,
            lockup: lockup
        }));
    }
    /**
   * Generate a Transaction that creates a new Stake account
   */ static createAccount(params) {
        const transaction = new $163ae62b92845c86$export$febc5573c75cefb0();
        transaction.add($163ae62b92845c86$export$d8c4e17726848113.createAccount({
            fromPubkey: params.fromPubkey,
            newAccountPubkey: params.stakePubkey,
            lamports: params.lamports,
            space: this.space,
            programId: this.programId
        }));
        const { stakePubkey: stakePubkey, authorized: authorized, lockup: lockup } = params;
        return transaction.add(this.initialize({
            stakePubkey: stakePubkey,
            authorized: authorized,
            lockup: lockup
        }));
    }
    /**
   * Generate a Transaction that delegates Stake tokens to a validator
   * Vote PublicKey. This transaction can also be used to redelegate Stake
   * to a new validator Vote PublicKey.
   */ static delegate(params) {
        const { stakePubkey: stakePubkey, authorizedPubkey: authorizedPubkey, votePubkey: votePubkey } = params;
        const type = $163ae62b92845c86$export$c89793bd2bba8b2e.Delegate;
        const data = $163ae62b92845c86$var$encodeData(type);
        return new $163ae62b92845c86$export$febc5573c75cefb0().add({
            keys: [
                {
                    pubkey: stakePubkey,
                    isSigner: false,
                    isWritable: true
                },
                {
                    pubkey: votePubkey,
                    isSigner: false,
                    isWritable: false
                },
                {
                    pubkey: $163ae62b92845c86$export$393aa1412d47050e,
                    isSigner: false,
                    isWritable: false
                },
                {
                    pubkey: $163ae62b92845c86$export$ca994171317280ea,
                    isSigner: false,
                    isWritable: false
                },
                {
                    pubkey: $163ae62b92845c86$export$18aac71979bdd08f,
                    isSigner: false,
                    isWritable: false
                },
                {
                    pubkey: authorizedPubkey,
                    isSigner: true,
                    isWritable: false
                }
            ],
            programId: this.programId,
            data: data
        });
    }
    /**
   * Generate a Transaction that authorizes a new PublicKey as Staker
   * or Withdrawer on the Stake account.
   */ static authorize(params) {
        const { stakePubkey: stakePubkey, authorizedPubkey: authorizedPubkey, newAuthorizedPubkey: newAuthorizedPubkey, stakeAuthorizationType: stakeAuthorizationType, custodianPubkey: custodianPubkey } = params;
        const type = $163ae62b92845c86$export$c89793bd2bba8b2e.Authorize;
        const data = $163ae62b92845c86$var$encodeData(type, {
            newAuthorized: $163ae62b92845c86$var$toBuffer(newAuthorizedPubkey.toBuffer()),
            stakeAuthorizationType: stakeAuthorizationType.index
        });
        const keys = [
            {
                pubkey: stakePubkey,
                isSigner: false,
                isWritable: true
            },
            {
                pubkey: $163ae62b92845c86$export$393aa1412d47050e,
                isSigner: false,
                isWritable: true
            },
            {
                pubkey: authorizedPubkey,
                isSigner: true,
                isWritable: false
            }
        ];
        if (custodianPubkey) keys.push({
            pubkey: custodianPubkey,
            isSigner: true,
            isWritable: false
        });
        return new $163ae62b92845c86$export$febc5573c75cefb0().add({
            keys: keys,
            programId: this.programId,
            data: data
        });
    }
    /**
   * Generate a Transaction that authorizes a new PublicKey as Staker
   * or Withdrawer on the Stake account.
   */ static authorizeWithSeed(params) {
        const { stakePubkey: stakePubkey, authorityBase: authorityBase, authoritySeed: authoritySeed, authorityOwner: authorityOwner, newAuthorizedPubkey: newAuthorizedPubkey, stakeAuthorizationType: stakeAuthorizationType, custodianPubkey: custodianPubkey } = params;
        const type = $163ae62b92845c86$export$c89793bd2bba8b2e.AuthorizeWithSeed;
        const data = $163ae62b92845c86$var$encodeData(type, {
            newAuthorized: $163ae62b92845c86$var$toBuffer(newAuthorizedPubkey.toBuffer()),
            stakeAuthorizationType: stakeAuthorizationType.index,
            authoritySeed: authoritySeed,
            authorityOwner: $163ae62b92845c86$var$toBuffer(authorityOwner.toBuffer())
        });
        const keys = [
            {
                pubkey: stakePubkey,
                isSigner: false,
                isWritable: true
            },
            {
                pubkey: authorityBase,
                isSigner: true,
                isWritable: false
            },
            {
                pubkey: $163ae62b92845c86$export$393aa1412d47050e,
                isSigner: false,
                isWritable: false
            }
        ];
        if (custodianPubkey) keys.push({
            pubkey: custodianPubkey,
            isSigner: true,
            isWritable: false
        });
        return new $163ae62b92845c86$export$febc5573c75cefb0().add({
            keys: keys,
            programId: this.programId,
            data: data
        });
    }
    /**
   * @internal
   */ static splitInstruction(params) {
        const { stakePubkey: stakePubkey, authorizedPubkey: authorizedPubkey, splitStakePubkey: splitStakePubkey, lamports: lamports } = params;
        const type = $163ae62b92845c86$export$c89793bd2bba8b2e.Split;
        const data = $163ae62b92845c86$var$encodeData(type, {
            lamports: lamports
        });
        return new $163ae62b92845c86$export$a7a3aa8360ac9f59({
            keys: [
                {
                    pubkey: stakePubkey,
                    isSigner: false,
                    isWritable: true
                },
                {
                    pubkey: splitStakePubkey,
                    isSigner: false,
                    isWritable: true
                },
                {
                    pubkey: authorizedPubkey,
                    isSigner: true,
                    isWritable: false
                }
            ],
            programId: this.programId,
            data: data
        });
    }
    /**
   * Generate a Transaction that splits Stake tokens into another stake account
   */ static split(params) {
        const transaction = new $163ae62b92845c86$export$febc5573c75cefb0();
        transaction.add($163ae62b92845c86$export$d8c4e17726848113.createAccount({
            fromPubkey: params.authorizedPubkey,
            newAccountPubkey: params.splitStakePubkey,
            lamports: 0,
            space: this.space,
            programId: this.programId
        }));
        return transaction.add(this.splitInstruction(params));
    }
    /**
   * Generate a Transaction that splits Stake tokens into another account
   * derived from a base public key and seed
   */ static splitWithSeed(params) {
        const { stakePubkey: stakePubkey, authorizedPubkey: authorizedPubkey, splitStakePubkey: splitStakePubkey, basePubkey: basePubkey, seed: seed, lamports: lamports } = params;
        const transaction = new $163ae62b92845c86$export$febc5573c75cefb0();
        transaction.add($163ae62b92845c86$export$d8c4e17726848113.allocate({
            accountPubkey: splitStakePubkey,
            basePubkey: basePubkey,
            seed: seed,
            space: this.space,
            programId: this.programId
        }));
        return transaction.add(this.splitInstruction({
            stakePubkey: stakePubkey,
            authorizedPubkey: authorizedPubkey,
            splitStakePubkey: splitStakePubkey,
            lamports: lamports
        }));
    }
    /**
   * Generate a Transaction that merges Stake accounts.
   */ static merge(params) {
        const { stakePubkey: stakePubkey, sourceStakePubKey: sourceStakePubKey, authorizedPubkey: authorizedPubkey } = params;
        const type = $163ae62b92845c86$export$c89793bd2bba8b2e.Merge;
        const data = $163ae62b92845c86$var$encodeData(type);
        return new $163ae62b92845c86$export$febc5573c75cefb0().add({
            keys: [
                {
                    pubkey: stakePubkey,
                    isSigner: false,
                    isWritable: true
                },
                {
                    pubkey: sourceStakePubKey,
                    isSigner: false,
                    isWritable: true
                },
                {
                    pubkey: $163ae62b92845c86$export$393aa1412d47050e,
                    isSigner: false,
                    isWritable: false
                },
                {
                    pubkey: $163ae62b92845c86$export$ca994171317280ea,
                    isSigner: false,
                    isWritable: false
                },
                {
                    pubkey: authorizedPubkey,
                    isSigner: true,
                    isWritable: false
                }
            ],
            programId: this.programId,
            data: data
        });
    }
    /**
   * Generate a Transaction that withdraws deactivated Stake tokens.
   */ static withdraw(params) {
        const { stakePubkey: stakePubkey, authorizedPubkey: authorizedPubkey, toPubkey: toPubkey, lamports: lamports, custodianPubkey: custodianPubkey } = params;
        const type = $163ae62b92845c86$export$c89793bd2bba8b2e.Withdraw;
        const data = $163ae62b92845c86$var$encodeData(type, {
            lamports: lamports
        });
        const keys = [
            {
                pubkey: stakePubkey,
                isSigner: false,
                isWritable: true
            },
            {
                pubkey: toPubkey,
                isSigner: false,
                isWritable: true
            },
            {
                pubkey: $163ae62b92845c86$export$393aa1412d47050e,
                isSigner: false,
                isWritable: false
            },
            {
                pubkey: $163ae62b92845c86$export$ca994171317280ea,
                isSigner: false,
                isWritable: false
            },
            {
                pubkey: authorizedPubkey,
                isSigner: true,
                isWritable: false
            }
        ];
        if (custodianPubkey) keys.push({
            pubkey: custodianPubkey,
            isSigner: true,
            isWritable: false
        });
        return new $163ae62b92845c86$export$febc5573c75cefb0().add({
            keys: keys,
            programId: this.programId,
            data: data
        });
    }
    /**
   * Generate a Transaction that deactivates Stake tokens.
   */ static deactivate(params) {
        const { stakePubkey: stakePubkey, authorizedPubkey: authorizedPubkey } = params;
        const type = $163ae62b92845c86$export$c89793bd2bba8b2e.Deactivate;
        const data = $163ae62b92845c86$var$encodeData(type);
        return new $163ae62b92845c86$export$febc5573c75cefb0().add({
            keys: [
                {
                    pubkey: stakePubkey,
                    isSigner: false,
                    isWritable: true
                },
                {
                    pubkey: $163ae62b92845c86$export$393aa1412d47050e,
                    isSigner: false,
                    isWritable: false
                },
                {
                    pubkey: authorizedPubkey,
                    isSigner: true,
                    isWritable: false
                }
            ],
            programId: this.programId,
            data: data
        });
    }
}
$163ae62b92845c86$export$df86f933e9f8fb15.programId = new $163ae62b92845c86$export$ca8b6604d6ce14de("Stake11111111111111111111111111111111111111");
/**
 * Max space of a Stake account
 *
 * This is generated from the solana-stake-program StakeState struct as
 * `StakeState::size_of()`:
 * https://docs.rs/solana-stake-program/latest/solana_stake_program/stake_state/enum.StakeState.html
 */ $163ae62b92845c86$export$df86f933e9f8fb15.space = 200;
/**
 * Vote account info
 */ class $163ae62b92845c86$export$3f9d1b16ff840d7 {
    /** [0, 100] */ constructor(nodePubkey, authorizedVoter, authorizedWithdrawer, commission){
        this.nodePubkey = void 0;
        this.authorizedVoter = void 0;
        this.authorizedWithdrawer = void 0;
        this.commission = void 0;
        this.nodePubkey = nodePubkey;
        this.authorizedVoter = authorizedVoter;
        this.authorizedWithdrawer = authorizedWithdrawer;
        this.commission = commission;
    }
}
/**
 * Create vote account transaction params
 */ /**
 * InitializeAccount instruction params
 */ /**
 * Authorize instruction params
 */ /**
 * AuthorizeWithSeed instruction params
 */ /**
 * Withdraw from vote account transaction params
 */ /**
 * Vote Instruction class
 */ class $163ae62b92845c86$export$af8300401fc56047 {
    /**
   * @internal
   */ constructor(){}
    /**
   * Decode a vote instruction and retrieve the instruction type.
   */ static decodeInstructionType(instruction) {
        this.checkProgramId(instruction.programId);
        const instructionTypeLayout = $2913ed74210dce84$exports.u32("instruction");
        const typeIndex = instructionTypeLayout.decode(instruction.data);
        let type;
        for (const [ixType, layout] of Object.entries($163ae62b92845c86$var$VOTE_INSTRUCTION_LAYOUTS))if (layout.index == typeIndex) {
            type = ixType;
            break;
        }
        if (!type) throw new Error("Instruction type incorrect; not a VoteInstruction");
        return type;
    }
    /**
   * Decode an initialize vote instruction and retrieve the instruction params.
   */ static decodeInitializeAccount(instruction) {
        this.checkProgramId(instruction.programId);
        this.checkKeyLength(instruction.keys, 4);
        const { voteInit: voteInit } = $163ae62b92845c86$var$decodeData$1($163ae62b92845c86$var$VOTE_INSTRUCTION_LAYOUTS.InitializeAccount, instruction.data);
        return {
            votePubkey: instruction.keys[0].pubkey,
            nodePubkey: instruction.keys[3].pubkey,
            voteInit: new $163ae62b92845c86$export$3f9d1b16ff840d7(new $163ae62b92845c86$export$ca8b6604d6ce14de(voteInit.nodePubkey), new $163ae62b92845c86$export$ca8b6604d6ce14de(voteInit.authorizedVoter), new $163ae62b92845c86$export$ca8b6604d6ce14de(voteInit.authorizedWithdrawer), voteInit.commission)
        };
    }
    /**
   * Decode an authorize instruction and retrieve the instruction params.
   */ static decodeAuthorize(instruction) {
        this.checkProgramId(instruction.programId);
        this.checkKeyLength(instruction.keys, 3);
        const { newAuthorized: newAuthorized, voteAuthorizationType: voteAuthorizationType } = $163ae62b92845c86$var$decodeData$1($163ae62b92845c86$var$VOTE_INSTRUCTION_LAYOUTS.Authorize, instruction.data);
        return {
            votePubkey: instruction.keys[0].pubkey,
            authorizedPubkey: instruction.keys[2].pubkey,
            newAuthorizedPubkey: new $163ae62b92845c86$export$ca8b6604d6ce14de(newAuthorized),
            voteAuthorizationType: {
                index: voteAuthorizationType
            }
        };
    }
    /**
   * Decode an authorize instruction and retrieve the instruction params.
   */ static decodeAuthorizeWithSeed(instruction) {
        this.checkProgramId(instruction.programId);
        this.checkKeyLength(instruction.keys, 3);
        const { voteAuthorizeWithSeedArgs: { currentAuthorityDerivedKeyOwnerPubkey: currentAuthorityDerivedKeyOwnerPubkey, currentAuthorityDerivedKeySeed: currentAuthorityDerivedKeySeed, newAuthorized: newAuthorized, voteAuthorizationType: voteAuthorizationType } } = $163ae62b92845c86$var$decodeData$1($163ae62b92845c86$var$VOTE_INSTRUCTION_LAYOUTS.AuthorizeWithSeed, instruction.data);
        return {
            currentAuthorityDerivedKeyBasePubkey: instruction.keys[2].pubkey,
            currentAuthorityDerivedKeyOwnerPubkey: new $163ae62b92845c86$export$ca8b6604d6ce14de(currentAuthorityDerivedKeyOwnerPubkey),
            currentAuthorityDerivedKeySeed: currentAuthorityDerivedKeySeed,
            newAuthorizedPubkey: new $163ae62b92845c86$export$ca8b6604d6ce14de(newAuthorized),
            voteAuthorizationType: {
                index: voteAuthorizationType
            },
            votePubkey: instruction.keys[0].pubkey
        };
    }
    /**
   * Decode a withdraw instruction and retrieve the instruction params.
   */ static decodeWithdraw(instruction) {
        this.checkProgramId(instruction.programId);
        this.checkKeyLength(instruction.keys, 3);
        const { lamports: lamports } = $163ae62b92845c86$var$decodeData$1($163ae62b92845c86$var$VOTE_INSTRUCTION_LAYOUTS.Withdraw, instruction.data);
        return {
            votePubkey: instruction.keys[0].pubkey,
            authorizedWithdrawerPubkey: instruction.keys[2].pubkey,
            lamports: lamports,
            toPubkey: instruction.keys[1].pubkey
        };
    }
    /**
   * @internal
   */ static checkProgramId(programId) {
        if (!programId.equals($163ae62b92845c86$export$83db2bc702bee1eb.programId)) throw new Error("invalid instruction; programId is not VoteProgram");
    }
    /**
   * @internal
   */ static checkKeyLength(keys, expectedLength) {
        if (keys.length < expectedLength) throw new Error(`invalid instruction; found ${keys.length} keys, expected at least ${expectedLength}`);
    }
}
/**
 * An enumeration of valid VoteInstructionType's
 */ /** @internal */ const $163ae62b92845c86$var$VOTE_INSTRUCTION_LAYOUTS = Object.freeze({
    InitializeAccount: {
        index: 0,
        layout: $2913ed74210dce84$exports.struct([
            $2913ed74210dce84$exports.u32("instruction"),
            $163ae62b92845c86$var$voteInit()
        ])
    },
    Authorize: {
        index: 1,
        layout: $2913ed74210dce84$exports.struct([
            $2913ed74210dce84$exports.u32("instruction"),
            $163ae62b92845c86$var$publicKey("newAuthorized"),
            $2913ed74210dce84$exports.u32("voteAuthorizationType")
        ])
    },
    Withdraw: {
        index: 3,
        layout: $2913ed74210dce84$exports.struct([
            $2913ed74210dce84$exports.u32("instruction"),
            $2913ed74210dce84$exports.ns64("lamports")
        ])
    },
    AuthorizeWithSeed: {
        index: 10,
        layout: $2913ed74210dce84$exports.struct([
            $2913ed74210dce84$exports.u32("instruction"),
            $163ae62b92845c86$var$voteAuthorizeWithSeedArgs()
        ])
    }
});
/**
 * VoteAuthorize type
 */ /**
 * An enumeration of valid VoteAuthorization layouts.
 */ const $163ae62b92845c86$export$3f2a92246fa9f71c = Object.freeze({
    Voter: {
        index: 0
    },
    Withdrawer: {
        index: 1
    }
});
/**
 * Factory class for transactions to interact with the Vote program
 */ class $163ae62b92845c86$export$83db2bc702bee1eb {
    /**
   * @internal
   */ constructor(){}
    /**
   * Public key that identifies the Vote program
   */ /**
   * Generate an Initialize instruction.
   */ static initializeAccount(params) {
        const { votePubkey: votePubkey, nodePubkey: nodePubkey, voteInit: voteInit } = params;
        const type = $163ae62b92845c86$var$VOTE_INSTRUCTION_LAYOUTS.InitializeAccount;
        const data = $163ae62b92845c86$var$encodeData(type, {
            voteInit: {
                nodePubkey: $163ae62b92845c86$var$toBuffer(voteInit.nodePubkey.toBuffer()),
                authorizedVoter: $163ae62b92845c86$var$toBuffer(voteInit.authorizedVoter.toBuffer()),
                authorizedWithdrawer: $163ae62b92845c86$var$toBuffer(voteInit.authorizedWithdrawer.toBuffer()),
                commission: voteInit.commission
            }
        });
        const instructionData = {
            keys: [
                {
                    pubkey: votePubkey,
                    isSigner: false,
                    isWritable: true
                },
                {
                    pubkey: $163ae62b92845c86$export$970d0190cdb3a8e9,
                    isSigner: false,
                    isWritable: false
                },
                {
                    pubkey: $163ae62b92845c86$export$393aa1412d47050e,
                    isSigner: false,
                    isWritable: false
                },
                {
                    pubkey: nodePubkey,
                    isSigner: true,
                    isWritable: false
                }
            ],
            programId: this.programId,
            data: data
        };
        return new $163ae62b92845c86$export$a7a3aa8360ac9f59(instructionData);
    }
    /**
   * Generate a transaction that creates a new Vote account.
   */ static createAccount(params) {
        const transaction = new $163ae62b92845c86$export$febc5573c75cefb0();
        transaction.add($163ae62b92845c86$export$d8c4e17726848113.createAccount({
            fromPubkey: params.fromPubkey,
            newAccountPubkey: params.votePubkey,
            lamports: params.lamports,
            space: this.space,
            programId: this.programId
        }));
        return transaction.add(this.initializeAccount({
            votePubkey: params.votePubkey,
            nodePubkey: params.voteInit.nodePubkey,
            voteInit: params.voteInit
        }));
    }
    /**
   * Generate a transaction that authorizes a new Voter or Withdrawer on the Vote account.
   */ static authorize(params) {
        const { votePubkey: votePubkey, authorizedPubkey: authorizedPubkey, newAuthorizedPubkey: newAuthorizedPubkey, voteAuthorizationType: voteAuthorizationType } = params;
        const type = $163ae62b92845c86$var$VOTE_INSTRUCTION_LAYOUTS.Authorize;
        const data = $163ae62b92845c86$var$encodeData(type, {
            newAuthorized: $163ae62b92845c86$var$toBuffer(newAuthorizedPubkey.toBuffer()),
            voteAuthorizationType: voteAuthorizationType.index
        });
        const keys = [
            {
                pubkey: votePubkey,
                isSigner: false,
                isWritable: true
            },
            {
                pubkey: $163ae62b92845c86$export$393aa1412d47050e,
                isSigner: false,
                isWritable: false
            },
            {
                pubkey: authorizedPubkey,
                isSigner: true,
                isWritable: false
            }
        ];
        return new $163ae62b92845c86$export$febc5573c75cefb0().add({
            keys: keys,
            programId: this.programId,
            data: data
        });
    }
    /**
   * Generate a transaction that authorizes a new Voter or Withdrawer on the Vote account
   * where the current Voter or Withdrawer authority is a derived key.
   */ static authorizeWithSeed(params) {
        const { currentAuthorityDerivedKeyBasePubkey: currentAuthorityDerivedKeyBasePubkey, currentAuthorityDerivedKeyOwnerPubkey: currentAuthorityDerivedKeyOwnerPubkey, currentAuthorityDerivedKeySeed: currentAuthorityDerivedKeySeed, newAuthorizedPubkey: newAuthorizedPubkey, voteAuthorizationType: voteAuthorizationType, votePubkey: votePubkey } = params;
        const type = $163ae62b92845c86$var$VOTE_INSTRUCTION_LAYOUTS.AuthorizeWithSeed;
        const data = $163ae62b92845c86$var$encodeData(type, {
            voteAuthorizeWithSeedArgs: {
                currentAuthorityDerivedKeyOwnerPubkey: $163ae62b92845c86$var$toBuffer(currentAuthorityDerivedKeyOwnerPubkey.toBuffer()),
                currentAuthorityDerivedKeySeed: currentAuthorityDerivedKeySeed,
                newAuthorized: $163ae62b92845c86$var$toBuffer(newAuthorizedPubkey.toBuffer()),
                voteAuthorizationType: voteAuthorizationType.index
            }
        });
        const keys = [
            {
                pubkey: votePubkey,
                isSigner: false,
                isWritable: true
            },
            {
                pubkey: $163ae62b92845c86$export$393aa1412d47050e,
                isSigner: false,
                isWritable: false
            },
            {
                pubkey: currentAuthorityDerivedKeyBasePubkey,
                isSigner: true,
                isWritable: false
            }
        ];
        return new $163ae62b92845c86$export$febc5573c75cefb0().add({
            keys: keys,
            programId: this.programId,
            data: data
        });
    }
    /**
   * Generate a transaction to withdraw from a Vote account.
   */ static withdraw(params) {
        const { votePubkey: votePubkey, authorizedWithdrawerPubkey: authorizedWithdrawerPubkey, lamports: lamports, toPubkey: toPubkey } = params;
        const type = $163ae62b92845c86$var$VOTE_INSTRUCTION_LAYOUTS.Withdraw;
        const data = $163ae62b92845c86$var$encodeData(type, {
            lamports: lamports
        });
        const keys = [
            {
                pubkey: votePubkey,
                isSigner: false,
                isWritable: true
            },
            {
                pubkey: toPubkey,
                isSigner: false,
                isWritable: true
            },
            {
                pubkey: authorizedWithdrawerPubkey,
                isSigner: true,
                isWritable: false
            }
        ];
        return new $163ae62b92845c86$export$febc5573c75cefb0().add({
            keys: keys,
            programId: this.programId,
            data: data
        });
    }
    /**
   * Generate a transaction to withdraw safely from a Vote account.
   *
   * This function was created as a safeguard for vote accounts running validators, `safeWithdraw`
   * checks that the withdraw amount will not exceed the specified balance while leaving enough left
   * to cover rent. If you wish to close the vote account by withdrawing the full amount, call the
   * `withdraw` method directly.
   */ static safeWithdraw(params, currentVoteAccountBalance, rentExemptMinimum) {
        if (params.lamports > currentVoteAccountBalance - rentExemptMinimum) throw new Error("Withdraw will leave vote account with insuffcient funds.");
        return $163ae62b92845c86$export$83db2bc702bee1eb.withdraw(params);
    }
}
$163ae62b92845c86$export$83db2bc702bee1eb.programId = new $163ae62b92845c86$export$ca8b6604d6ce14de("Vote111111111111111111111111111111111111111");
/**
 * Max space of a Vote account
 *
 * This is generated from the solana-vote-program VoteState struct as
 * `VoteState::size_of()`:
 * https://docs.rs/solana-vote-program/1.9.5/solana_vote_program/vote_state/struct.VoteState.html#method.size_of
 *
 * KEEP IN SYNC WITH `VoteState::size_of()` in https://github.com/solana-labs/solana/blob/a474cb24b9238f5edcc982f65c0b37d4a1046f7e/sdk/program/src/vote/state/mod.rs#L340-L342
 */ $163ae62b92845c86$export$83db2bc702bee1eb.space = 3731;
const $163ae62b92845c86$export$afdb09d3afdde87c = new $163ae62b92845c86$export$ca8b6604d6ce14de("Va1idator1nfo111111111111111111111111111111");
/**
 * @internal
 */ /**
 * Info used to identity validators.
 */ const $163ae62b92845c86$var$InfoString = (0, $7154594b4f0d1928$export$bf9fb029d174d554)({
    name: (0, $7154594b4f0d1928$export$22b082955e083ec3)(),
    website: (0, $7154594b4f0d1928$export$516e28dec6a4b6d4)((0, $7154594b4f0d1928$export$22b082955e083ec3)()),
    details: (0, $7154594b4f0d1928$export$516e28dec6a4b6d4)((0, $7154594b4f0d1928$export$22b082955e083ec3)()),
    keybaseUsername: (0, $7154594b4f0d1928$export$516e28dec6a4b6d4)((0, $7154594b4f0d1928$export$22b082955e083ec3)())
});
/**
 * ValidatorInfo class
 */ class $163ae62b92845c86$export$152d279cf067309b {
    /**
   * Construct a valid ValidatorInfo
   *
   * @param key validator public key
   * @param info validator information
   */ constructor(key, info){
        /**
     * validator public key
     */ this.key = void 0;
        /**
     * validator information
     */ this.info = void 0;
        this.key = key;
        this.info = info;
    }
    /**
   * Deserialize ValidatorInfo from the config account data. Exactly two config
   * keys are required in the data.
   *
   * @param buffer config account data
   * @return null if info was not found
   */ static fromConfigData(buffer) {
        let byteArray = [
            ...buffer
        ];
        const configKeyCount = $163ae62b92845c86$var$decodeLength(byteArray);
        if (configKeyCount !== 2) return null;
        const configKeys = [];
        for(let i = 0; i < 2; i++){
            const publicKey = new $163ae62b92845c86$export$ca8b6604d6ce14de(byteArray.slice(0, $163ae62b92845c86$export$84fc0a248cc54343));
            byteArray = byteArray.slice($163ae62b92845c86$export$84fc0a248cc54343);
            const isSigner = byteArray.slice(0, 1)[0] === 1;
            byteArray = byteArray.slice(1);
            configKeys.push({
                publicKey: publicKey,
                isSigner: isSigner
            });
        }
        if (configKeys[0].publicKey.equals($163ae62b92845c86$export$afdb09d3afdde87c)) {
            if (configKeys[1].isSigner) {
                const rawInfo = $163ae62b92845c86$var$rustString().decode((0, $5ed0747d5916bbd8$export$a143d493d941bafc).from(byteArray));
                const info = JSON.parse(rawInfo);
                (0, $7154594b4f0d1928$export$a7a9523472993e97)(info, $163ae62b92845c86$var$InfoString);
                return new $163ae62b92845c86$export$152d279cf067309b(configKeys[1].publicKey, info);
            }
        }
        return null;
    }
}
const $163ae62b92845c86$export$90bca02a3aea0768 = new $163ae62b92845c86$export$ca8b6604d6ce14de("Vote111111111111111111111111111111111111111");
/**
 * History of how many credits earned by the end of each epoch
 */ /**
 * See https://github.com/solana-labs/solana/blob/8a12ed029cfa38d4a45400916c2463fb82bbec8c/programs/vote_api/src/vote_state.rs#L68-L88
 *
 * @internal
 */ const $163ae62b92845c86$var$VoteAccountLayout = $2913ed74210dce84$exports.struct([
    $163ae62b92845c86$var$publicKey("nodePubkey"),
    $163ae62b92845c86$var$publicKey("authorizedWithdrawer"),
    $2913ed74210dce84$exports.u8("commission"),
    $2913ed74210dce84$exports.nu64(),
    // votes.length
    $2913ed74210dce84$exports.seq($2913ed74210dce84$exports.struct([
        $2913ed74210dce84$exports.nu64("slot"),
        $2913ed74210dce84$exports.u32("confirmationCount")
    ]), $2913ed74210dce84$exports.offset($2913ed74210dce84$exports.u32(), -8), "votes"),
    $2913ed74210dce84$exports.u8("rootSlotValid"),
    $2913ed74210dce84$exports.nu64("rootSlot"),
    $2913ed74210dce84$exports.nu64(),
    // authorizedVoters.length
    $2913ed74210dce84$exports.seq($2913ed74210dce84$exports.struct([
        $2913ed74210dce84$exports.nu64("epoch"),
        $163ae62b92845c86$var$publicKey("authorizedVoter")
    ]), $2913ed74210dce84$exports.offset($2913ed74210dce84$exports.u32(), -8), "authorizedVoters"),
    $2913ed74210dce84$exports.struct([
        $2913ed74210dce84$exports.seq($2913ed74210dce84$exports.struct([
            $163ae62b92845c86$var$publicKey("authorizedPubkey"),
            $2913ed74210dce84$exports.nu64("epochOfLastAuthorizedSwitch"),
            $2913ed74210dce84$exports.nu64("targetEpoch")
        ]), 32, "buf"),
        $2913ed74210dce84$exports.nu64("idx"),
        $2913ed74210dce84$exports.u8("isEmpty")
    ], "priorVoters"),
    $2913ed74210dce84$exports.nu64(),
    // epochCredits.length
    $2913ed74210dce84$exports.seq($2913ed74210dce84$exports.struct([
        $2913ed74210dce84$exports.nu64("epoch"),
        $2913ed74210dce84$exports.nu64("credits"),
        $2913ed74210dce84$exports.nu64("prevCredits")
    ]), $2913ed74210dce84$exports.offset($2913ed74210dce84$exports.u32(), -8), "epochCredits"),
    $2913ed74210dce84$exports.struct([
        $2913ed74210dce84$exports.nu64("slot"),
        $2913ed74210dce84$exports.nu64("timestamp")
    ], "lastTimestamp")
]);
/**
 * VoteAccount class
 */ class $163ae62b92845c86$export$89ef186f708d638b {
    /**
   * @internal
   */ constructor(args){
        this.nodePubkey = void 0;
        this.authorizedWithdrawer = void 0;
        this.commission = void 0;
        this.rootSlot = void 0;
        this.votes = void 0;
        this.authorizedVoters = void 0;
        this.priorVoters = void 0;
        this.epochCredits = void 0;
        this.lastTimestamp = void 0;
        this.nodePubkey = args.nodePubkey;
        this.authorizedWithdrawer = args.authorizedWithdrawer;
        this.commission = args.commission;
        this.rootSlot = args.rootSlot;
        this.votes = args.votes;
        this.authorizedVoters = args.authorizedVoters;
        this.priorVoters = args.priorVoters;
        this.epochCredits = args.epochCredits;
        this.lastTimestamp = args.lastTimestamp;
    }
    /**
   * Deserialize VoteAccount from the account data.
   *
   * @param buffer account data
   * @return VoteAccount
   */ static fromAccountData(buffer) {
        const versionOffset = 4;
        const va = $163ae62b92845c86$var$VoteAccountLayout.decode($163ae62b92845c86$var$toBuffer(buffer), versionOffset);
        let rootSlot = va.rootSlot;
        if (!va.rootSlotValid) rootSlot = null;
        return new $163ae62b92845c86$export$89ef186f708d638b({
            nodePubkey: new $163ae62b92845c86$export$ca8b6604d6ce14de(va.nodePubkey),
            authorizedWithdrawer: new $163ae62b92845c86$export$ca8b6604d6ce14de(va.authorizedWithdrawer),
            commission: va.commission,
            votes: va.votes,
            rootSlot: rootSlot,
            authorizedVoters: va.authorizedVoters.map($163ae62b92845c86$var$parseAuthorizedVoter),
            priorVoters: $163ae62b92845c86$var$getPriorVoters(va.priorVoters),
            epochCredits: va.epochCredits,
            lastTimestamp: va.lastTimestamp
        });
    }
}
function $163ae62b92845c86$var$parseAuthorizedVoter({ authorizedVoter: authorizedVoter, epoch: epoch }) {
    return {
        epoch: epoch,
        authorizedVoter: new $163ae62b92845c86$export$ca8b6604d6ce14de(authorizedVoter)
    };
}
function $163ae62b92845c86$var$parsePriorVoters({ authorizedPubkey: authorizedPubkey, epochOfLastAuthorizedSwitch: epochOfLastAuthorizedSwitch, targetEpoch: targetEpoch }) {
    return {
        authorizedPubkey: new $163ae62b92845c86$export$ca8b6604d6ce14de(authorizedPubkey),
        epochOfLastAuthorizedSwitch: epochOfLastAuthorizedSwitch,
        targetEpoch: targetEpoch
    };
}
function $163ae62b92845c86$var$getPriorVoters({ buf: buf, idx: idx, isEmpty: isEmpty }) {
    if (isEmpty) return [];
    return [
        ...buf.slice(idx + 1).map($163ae62b92845c86$var$parsePriorVoters),
        ...buf.slice(0, idx).map($163ae62b92845c86$var$parsePriorVoters)
    ];
}
const $163ae62b92845c86$var$endpoint = {
    http: {
        devnet: "http://api.devnet.solana.com",
        testnet: "http://api.testnet.solana.com",
        "mainnet-beta": "http://api.mainnet-beta.solana.com/"
    },
    https: {
        devnet: "https://api.devnet.solana.com",
        testnet: "https://api.testnet.solana.com",
        "mainnet-beta": "https://api.mainnet-beta.solana.com/"
    }
};
/**
 * Retrieves the RPC API URL for the specified cluster
 * @param {Cluster} [cluster="devnet"] - The cluster name of the RPC API URL to use. Possible options: 'devnet' | 'testnet' | 'mainnet-beta'
 * @param {boolean} [tls="http"] - Use TLS when connecting to cluster.
 *
 * @returns {string} URL string of the RPC endpoint
 */ function $163ae62b92845c86$export$11656287b4eb76ff(cluster, tls) {
    const key = tls === false ? "http" : "https";
    if (!cluster) return $163ae62b92845c86$var$endpoint[key]["devnet"];
    const url = $163ae62b92845c86$var$endpoint[key][cluster];
    if (!url) throw new Error(`Unknown ${key} cluster: ${cluster}`);
    return url;
}
/**
 * Send and confirm a raw transaction
 *
 * If `commitment` option is not specified, defaults to 'max' commitment.
 *
 * @param {Connection} connection
 * @param {Buffer} rawTransaction
 * @param {TransactionConfirmationStrategy} confirmationStrategy
 * @param {ConfirmOptions} [options]
 * @returns {Promise<TransactionSignature>}
 */ /**
 * @deprecated Calling `sendAndConfirmRawTransaction()` without a `confirmationStrategy`
 * is no longer supported and will be removed in a future version.
 */ // eslint-disable-next-line no-redeclare
// eslint-disable-next-line no-redeclare
async function $163ae62b92845c86$export$554271b88fdb7843(connection, rawTransaction, confirmationStrategyOrConfirmOptions, maybeConfirmOptions) {
    let confirmationStrategy;
    let options;
    if (confirmationStrategyOrConfirmOptions && Object.prototype.hasOwnProperty.call(confirmationStrategyOrConfirmOptions, "lastValidBlockHeight")) {
        confirmationStrategy = confirmationStrategyOrConfirmOptions;
        options = maybeConfirmOptions;
    } else if (confirmationStrategyOrConfirmOptions && Object.prototype.hasOwnProperty.call(confirmationStrategyOrConfirmOptions, "nonceValue")) {
        confirmationStrategy = confirmationStrategyOrConfirmOptions;
        options = maybeConfirmOptions;
    } else options = confirmationStrategyOrConfirmOptions;
    const sendOptions = options && {
        skipPreflight: options.skipPreflight,
        preflightCommitment: options.preflightCommitment || options.commitment,
        minContextSlot: options.minContextSlot
    };
    const signature = await connection.sendRawTransaction(rawTransaction, sendOptions);
    const commitment = options && options.commitment;
    const confirmationPromise = confirmationStrategy ? connection.confirmTransaction(confirmationStrategy, commitment) : connection.confirmTransaction(signature, commitment);
    const status = (await confirmationPromise).value;
    if (status.err) throw new Error(`Raw transaction ${signature} failed (${JSON.stringify(status)})`);
    return signature;
}
/**
 * There are 1-billion lamports in one SOL
 */ const $163ae62b92845c86$export$5f6a2f2669741bbe = 1000000000;




var $ihoyg = parcelRequire("ihoyg");
var $5b224895d7132d06$require$Buffer = $ihoyg.Buffer;
var $5b224895d7132d06$var$w = Object.defineProperty;
var $5b224895d7132d06$var$t = (n, a)=>$5b224895d7132d06$var$w(n, "name", {
        value: a,
        configurable: !0
    });
async function $5b224895d7132d06$var$m(n, a, o, i = null) {
    let r = a;
    for(; r > 0;)try {
        let e = await Promise.race([
            n,
            new Promise((c, s)=>setTimeout(()=>s(new Error("timeout")), o))
        ]);
        if (r > 1 && i != null && !i(e)) throw new Error("bad result");
        return e;
    } catch (e) {
        console.log("cant get result. time=" + new Date().toLocaleTimeString() + " i=" + r + " , err=", e), r--;
    }
    throw new (0, $6bf9e406f810d981$exports.SignerError)((0, $6bf9e406f810d981$exports.SignerErrorCode).SEND_TX_ERROR, "function reached max retry count");
}
$5b224895d7132d06$var$t($5b224895d7132d06$var$m, "retryPromise");
function $5b224895d7132d06$var$R(n) {
    let a = Math.floor(Math.random() * 9e3) + 1e3;
    return "failed::" + n.identifier + "::" + a;
}
$5b224895d7132d06$var$t($5b224895d7132d06$var$R, "getFailedHash");
var $5b224895d7132d06$var$_ = false, $5b224895d7132d06$var$k = $5b224895d7132d06$var$_ ? "https://fluent-still-scion.solana-mainnet.discover.quiknode.pro/fc8be9b8ac7aea382ec591359628e16d8c52ef6a/" : "https://icy-crimson-wind.solana-mainnet.quiknode.pro/c83f94ebeb39a6d6a9d2ab03d4cba2c2af83c5c0/";
function $5b224895d7132d06$var$T() {
    return new (0, $163ae62b92845c86$export$98b66c25bb38499d)($5b224895d7132d06$var$k, {
        commitment: "confirmed",
        disableRetryOnRateLimit: !1
    });
}
$5b224895d7132d06$var$t($5b224895d7132d06$var$T, "getSolanaConnection");
function $5b224895d7132d06$var$v(n) {
    return new Promise(async function(a, o) {
        let i = 3, r = !1;
        for(; i > 0;){
            try {
                let e = await $5b224895d7132d06$var$T().confirmTransaction(n);
                if (e && e.value && e.value.err == null) {
                    r = !0;
                    break;
                } else i === 1 && e && e.value && e.value.err && o(e.value.err);
            } catch (e) {
                i === 1 && o(e);
            }
            i -= 1;
        }
        a(r);
    });
}
$5b224895d7132d06$var$t($5b224895d7132d06$var$v, "confirmTx");
var $5b224895d7132d06$export$2c46e2eb81692c02 = $5b224895d7132d06$var$t(async (n, a)=>{
    let o = $5b224895d7132d06$var$T(), i, r;
    if (n.serializedMessage != null) {
        if (n.txType === "VERSIONED") {
            i = (0, $163ae62b92845c86$export$232cc3f078dcc284).deserialize(new Uint8Array(n.serializedMessage));
            let e = (await $5b224895d7132d06$var$m(o.getLatestBlockhash("confirmed"), 5, 1e4)).blockhash;
            e && (i.message.recentBlockhash = e);
        } else n.txType === "LEGACY" && (r = (0, $163ae62b92845c86$export$febc5573c75cefb0).from($5b224895d7132d06$require$Buffer.from(new Uint8Array(n.serializedMessage))), r.feePayer = new (0, $163ae62b92845c86$export$ca8b6604d6ce14de)(n.from), r.recentBlockhash = void 0);
    } else r = new (0, $163ae62b92845c86$export$febc5573c75cefb0), r.feePayer = new (0, $163ae62b92845c86$export$ca8b6604d6ce14de)(n.from), n.recentBlockhash ? r.recentBlockhash = n.recentBlockhash : r.recentBlockhash = (await $5b224895d7132d06$var$m(o.getLatestBlockhash("confirmed"), 5, 1e4)).blockhash, n.instructions.forEach((e)=>{
        r?.add(new (0, $163ae62b92845c86$export$a7a3aa8360ac9f59)({
            keys: e.keys.map((c)=>({
                    pubkey: new (0, $163ae62b92845c86$export$ca8b6604d6ce14de)(c.pubkey),
                    isSigner: c.isSigner,
                    isWritable: c.isWritable
                })),
            programId: new (0, $163ae62b92845c86$export$ca8b6604d6ce14de)(e.programId),
            data: $5b224895d7132d06$require$Buffer.from(e.data)
        }));
    }), n.signatures.forEach(function(e) {
        let c = $5b224895d7132d06$require$Buffer.from(new Uint8Array(e.signature)), s = new (0, $163ae62b92845c86$export$ca8b6604d6ce14de)(e.publicKey);
        r?.addSignature(s, c);
    });
    try {
        let e;
        if (r) e = r;
        else if (i) e = i;
        else throw new Error("error creating transaction");
        let c = await a(e), s = await $5b224895d7132d06$var$m(o.sendRawTransaction(c), 2, 3e4);
        if (!s) throw new Error("tx cant send to blockchain. signature=" + s);
        if (!await $5b224895d7132d06$var$v(s)) throw new Error("tx cant confirm on blockchain. signature=" + s);
        return s;
    } catch (e) {
        if (e && (0, $6bf9e406f810d981$exports.SignerError).isSignerError(e) && e.code === (0, $6bf9e406f810d981$exports.SignerErrorCode).REJECTED_BY_USER) throw e;
        if (e && e.hasOwnProperty("code") && e.code === 4001) throw new (0, $6bf9e406f810d981$exports.SignerError)((0, $6bf9e406f810d981$exports.SignerErrorCode).REJECTED_BY_USER, void 0, e);
        return $5b224895d7132d06$var$R(n);
    }
}, "generalSolanaTransactionExecutor");
async function $5b224895d7132d06$var$y(n, a) {
    return await $5b224895d7132d06$export$2c46e2eb81692c02(n, $5b224895d7132d06$var$t(async (i)=>{
        try {
            return (await a.signTransaction(i)).serialize();
        } catch (r) {
            throw new (0, $6bf9e406f810d981$exports.SignerError)((0, $6bf9e406f810d981$exports.SignerErrorCode).SIGN_TX_ERROR, void 0, r);
        }
    }, "DefaultSolanaSigner"));
}
$5b224895d7132d06$var$t($5b224895d7132d06$var$y, "executeSolanaTransaction");
var $5b224895d7132d06$export$38f28568c8f589a4 = class {
    constructor(a){
        this.provider = a;
    }
    async signMessage(a) {
        try {
            let o = new TextEncoder().encode(a), { signature: i } = await this.provider.request({
                method: "signMessage",
                params: {
                    message: o
                }
            });
            return i;
        } catch (o) {
            throw new (0, $6bf9e406f810d981$exports.SignerError)((0, $6bf9e406f810d981$exports.SignerErrorCode).SIGN_TX_ERROR, void 0, o);
        }
    }
    async signAndSendTx(a) {
        try {
            return {
                hash: await $5b224895d7132d06$var$y(a, this.provider)
            };
        } catch (o) {
            throw new (0, $6bf9e406f810d981$exports.SignerError)((0, $6bf9e406f810d981$exports.SignerErrorCode).SEND_TX_ERROR, void 0, o);
        }
    }
};
$5b224895d7132d06$var$t($5b224895d7132d06$export$38f28568c8f589a4, "DefaultSolanaSigner");


var $8702f288516fd747$var$l = Object.defineProperty;
var $8702f288516fd747$var$n = (t, o)=>$8702f288516fd747$var$l(t, "name", {
        value: o,
        configurable: !0
    });
function $8702f288516fd747$var$s() {
    if ("phantom" in window) {
        let t = window.phantom?.solana;
        if (t?.isPhantom) return t;
    }
    return null;
}
$8702f288516fd747$var$n($8702f288516fd747$var$s, "phantom");
function $8702f288516fd747$var$r(t) {
    let o = (0, $c7b1ddb572c90b38$export$2029b78bc980a576)(t, (0, $c7b1ddb572c90b38$export$2e8191f482a38ccd).SOLANA), e = new (0, $b0f7ab1c178913fc$export$2006fb7614e99307);
    return e.registerSigner((0, $6fc89aa3c0b05299$export$d513b00599f845d4).SOLANA, new (0, $5b224895d7132d06$export$38f28568c8f589a4)(o)), e;
}
$8702f288516fd747$var$n($8702f288516fd747$var$r, "getSigners");
var $8702f288516fd747$var$C = (0, $c7b1ddb572c90b38$export$b80cfa133c9c182d).PHANTOM, $8702f288516fd747$export$e506a1d27d1eaa20 = {
    type: $8702f288516fd747$var$C
}, $8702f288516fd747$export$8bedcca5bbd73999 = $8702f288516fd747$var$s, $8702f288516fd747$export$64605811ab45167f = (0, $c7b1ddb572c90b38$export$a009f0f0c363aa6c), $8702f288516fd747$export$ec068583843480e7 = $8702f288516fd747$var$n(({ instance: t, updateAccounts: o, connect: e })=>{
    let a = $8702f288516fd747$var$n(async (c)=>{
        let i = (0, $c7b1ddb572c90b38$export$2e8191f482a38ccd).SOLANA;
        if (c) {
            let p = c.toString();
            o([
                p
            ]);
        } else e(i);
    }, "handleAccountsChanged");
    return t?.on("accountChanged", a), ()=>{
        t?.off("accountChanged", a);
    };
}, "subscribe"), $8702f288516fd747$export$3b3cf9ab9019de20 = $8702f288516fd747$var$n(()=>!1, "canSwitchNetworkTo"), $8702f288516fd747$export$6352a17a50193ded = $8702f288516fd747$var$r, $8702f288516fd747$export$be9f3c5ed1d25e42 = $8702f288516fd747$var$n(async ({ instance: t })=>{
    try {
        return !!await t.connect({
            onlyIfTrusted: !0
        });
    } catch  {
        return !1;
    }
}, "canEagerConnect"), $8702f288516fd747$export$e5b9d96c6aeb3ff7 = $8702f288516fd747$var$n((t)=>{
    let o = (0, $cd8bb37a306c2b01$export$11a35c42f4dd4832)(t);
    return {
        name: "Phantom",
        img: "https://raw.githubusercontent.com/rango-exchange/assets/main/wallets/phantom/icon.svg",
        installLink: {
            CHROME: "https://chrome.google.com/webstore/detail/phantom/bfnaelmomeimhlpmgjnjophhpkkoljpa",
            DEFAULT: "https://phantom.app/"
        },
        color: "#4d40c6",
        supportedChains: o
    };
}, "getWalletInfo");


var $1b7a54a36665fb13$exports = {};

$parcel$export($1b7a54a36665fb13$exports, "config", function () { return $1b7a54a36665fb13$export$e506a1d27d1eaa20; });
$parcel$export($1b7a54a36665fb13$exports, "getInstance", function () { return $1b7a54a36665fb13$export$8bedcca5bbd73999; });
$parcel$export($1b7a54a36665fb13$exports, "connect", function () { return $1b7a54a36665fb13$export$64605811ab45167f; });
$parcel$export($1b7a54a36665fb13$exports, "subscribe", function () { return $1b7a54a36665fb13$export$ec068583843480e7; });
$parcel$export($1b7a54a36665fb13$exports, "canSwitchNetworkTo", function () { return $1b7a54a36665fb13$export$3b3cf9ab9019de20; });
$parcel$export($1b7a54a36665fb13$exports, "getSigners", function () { return $1b7a54a36665fb13$export$6352a17a50193ded; });
$parcel$export($1b7a54a36665fb13$exports, "getWalletInfo", function () { return $1b7a54a36665fb13$export$e5b9d96c6aeb3ff7; });



var $ihoyg = parcelRequire("ihoyg");
var $95d7c41759820f7d$require$Buffer = $ihoyg.Buffer;
var $95d7c41759820f7d$var$M = Object.defineProperty;
var $95d7c41759820f7d$var$a = (e, n)=>$95d7c41759820f7d$var$M(e, "name", {
        value: n,
        configurable: !0
    });
var $95d7c41759820f7d$export$3fce19fdf0c5de73 = false, $95d7c41759820f7d$export$dfe7f2fe52a04245 = $95d7c41759820f7d$var$a((e, n)=>(e = typeof e == "string" && e.startsWith("0x") ? parseInt(e) : e, Object.values($95d7c41759820f7d$export$2e8191f482a38ccd).includes(String(e)) ? e : e === "Binance-Chain-Tigris" ? "BNB" : n.filter((r)=>!!r.chainId).find((r)=>(r.chainId?.startsWith("0x") ? parseInt(r.chainId) : r.chainId) == e)?.name || null), "getBlockChainNameFromId"), $95d7c41759820f7d$export$d840d807f640aaf5 = $95d7c41759820f7d$var$a((e, n)=>n[e]?.chainId || null, "getBlockchainChainIdByName"), $95d7c41759820f7d$export$c44b02fb03dbac82 = $95d7c41759820f7d$var$a((e)=>$95d7c41759820f7d$require$Buffer.from(e).toString("hex"), "uint8ArrayToHex"), $95d7c41759820f7d$export$b80cfa133c9c182d = ((s)=>(s.DEFAULT = "default", s.META_MASK = "metamask", s.WALLET_CONNECT_2 = "wallet-connect-2", s.TRUST_WALLET = "trust-wallet", s.KEPLR = "keplr", s.PHANTOM = "phantom", s.BITGET = "bitget", s.TRON_LINK = "tron-link", s.COINBASE = "coinbase", s.XDEFI = "xdefi", s.CLOVER = "clover", s.ARGENTX = "argentx", s.FRONTIER = "frontier", s.COSMOSTATION = "cosmostation", s.COIN98 = "coin98", s.SAFEPAL = "safepal", s.SAFE = "safe", s.TOKEN_POCKET = "token-pocket", s.BRAVE = "brave", s.BRAAVOS = "braavos", s.MATH = "math", s.EXODUS = "exodus", s.OKX = "okx", s.HALO = "halo", s.LEAP = "leap", s.LEAP_COSMOS = "leap-cosmos", s.STATION = "station", s.ENKRYPT = "enkrypt", s.TAHO = "taho", s.MY_TON_WALLET = "mytonwallet", s))($95d7c41759820f7d$export$b80cfa133c9c182d || {}), $95d7c41759820f7d$export$2e8191f482a38ccd = ((o)=>(o.BTC = "BTC", o.BSC = "BSC", o.LTC = "LTC", o.THORCHAIN = "THOR", o.BCH = "BCH", o.BINANCE = "BNB", o.ETHEREUM = "ETH", o.POLYGON = "POLYGON", o.TERRA = "TERRA", o.POLKADOT = "", o.TRON = "TRON", o.DOGE = "DOGE", o.HARMONY = "HARMONY", o.AVAX_CCHAIN = "AVAX_CCHAIN", o.FANTOM = "FANTOM", o.MOONBEAM = "MOONBEAM", o.ARBITRUM = "ARBITRUM", o.BOBA = "BOBA", o.OPTIMISM = "OPTIMISM", o.FUSE = "FUSE", o.CRONOS = "CRONOS", o.SOLANA = "SOLANA", o.MOONRIVER = "MOONRIVER", o.GNOSIS = "GNOSIS", o.COSMOS = "COSMOS", o.OSMOSIS = "OSMOSIS", o.AXELAR = "AXELAR", o.MARS = "MARS", o.STRIDE = "STRIDE", o.MAYA = "MAYA", o.AKASH = "AKASH", o.IRIS = "IRIS", o.PERSISTENCE = "PERSISTENCE", o.SENTINEL = "SENTINEL", o.REGEN = "REGEN", o.CRYPTO_ORG = "CRYPTO_ORG", o.SIF = "SIF", o.CHIHUAHUA = "CHIHUAHUA", o.JUNO = "JUNO", o.KUJIRA = "KUJIRA", o.STARNAME = "STARNAME", o.COMDEX = "COMDEX", o.STARGAZE = "STARGAZE", o.DESMOS = "DESMOS", o.BITCANNA = "BITCANNA", o.SECRET = "SECRET", o.INJECTIVE = "INJECTIVE", o.LUMNETWORK = "LUMNETWORK", o.BANDCHAIN = "BANDCHAIN", o.EMONEY = "EMONEY", o.BITSONG = "BITSONG", o.KI = "KI", o.MEDIBLOC = "MEDIBLOC", o.KONSTELLATION = "KONSTELLATION", o.UMEE = "UMEE", o.STARKNET = "STARKNET", o.TON = "TON", o.Unknown = "Unkown", o))($95d7c41759820f7d$export$2e8191f482a38ccd || {}), $95d7c41759820f7d$export$7289d9aba3deaf99 = [
    "BTC",
    "LTC",
    "THOR",
    "BCH",
    "BNB",
    "MAYA",
    "DOGE"
], $95d7c41759820f7d$export$12e8aeb69ff35d9 = [
    "keplr",
    "cosmostation",
    "leap-cosmos"
], $95d7c41759820f7d$export$832fb1b437e459ec = "https://cosmos-rpc.polkachu.com";
function $95d7c41759820f7d$export$6c40052bed430212(e) {
    let n;
    if (e == null || typeof e != "object") return e;
    if (e instanceof Date) return n = new Date, n.setTime(e.getTime()), n;
    if (e instanceof Array) {
        n = [];
        for(let t = 0, r = e.length; t < r; t++)n[t] = $95d7c41759820f7d$export$6c40052bed430212(e[t]);
        return n;
    }
    if (e instanceof Object) {
        n = {};
        for(let t in e)Object.prototype.hasOwnProperty.call(e, t) && (n[t] = $95d7c41759820f7d$export$6c40052bed430212(e[t]));
        return n;
    }
    throw new Error("Unable to copy obj! Its type isn't supported.");
}
$95d7c41759820f7d$var$a($95d7c41759820f7d$export$6c40052bed430212, "deepCopy");
async function $95d7c41759820f7d$export$56ce9af15430dcbb(e, n, t) {
    let r = t[n];
    try {
        await e.request({
            method: "wallet_switchEthereumChain",
            params: [
                {
                    chainId: r?.chainId
                }
            ]
        });
    } catch (i) {
        let u = i;
        if (r) (u.code === 4902 || !u.code) && await e.request({
            method: "wallet_addEthereumChain",
            params: [
                r
            ]
        });
        else throw new Error(`It seems you don't have ${n} network on your wallet. Please add it manually.`);
        throw i;
    }
}
$95d7c41759820f7d$var$a($95d7c41759820f7d$export$56ce9af15430dcbb, "switchOrAddNetworkForMetamaskCompatibleWallets");
async function $95d7c41759820f7d$export$83e74882c5df8fe1(e, n) {
    let t = new Promise((r, i)=>{
        setTimeout(()=>{
            i("Timeout!");
        }, n);
    });
    return Promise.race([
        e,
        t
    ]);
}
$95d7c41759820f7d$var$a($95d7c41759820f7d$export$83e74882c5df8fe1, "timeout");
var $95d7c41759820f7d$export$f0e13d51b5c692b6 = $95d7c41759820f7d$var$a((e)=>e.reduce((n, t)=>(n[t.name] = {
            chainName: t.info.chainName,
            chainId: t.chainId,
            nativeCurrency: t.info.nativeCurrency,
            rpcUrls: t.info.rpcUrls,
            blockExplorerUrls: t.info.blockExplorerUrls
        }, n), {}), "convertEvmBlockchainMetaToEvmChainInfo"), $95d7c41759820f7d$export$6965bcf5cb20b5b5 = $95d7c41759820f7d$var$a((e)=>Object.fromEntries(new Map(Object.keys(e).map((n)=>{
        let t = e[n];
        return t ? [
            parseInt(t.chainId),
            t.rpcUrls[0]
        ] : [
            0,
            ""
        ];
    }))), "evmChainsToRpcMap"), $95d7c41759820f7d$export$a009f0f0c363aa6c = $95d7c41759820f7d$var$a(async ({ instance: e })=>({
        accounts: [
            (await e.connect()).publicKey.toString()
        ],
        chainId: "SOLANA"
    }), "getSolanaAccounts");
function $95d7c41759820f7d$export$bc1a75e20816804a(e = "coinbase") {
    let { ethereum: n, coinbaseSolana: t } = window, r = new Map;
    if (n) {
        let i = e === "metamask" ? "isMetaMask" : "isCoinbaseWallet";
        if (e === "coinbase" && n[i]) r.set("ETH", n);
        else if (n.providers?.length) {
            let u = n.providers.find((c)=>c[i]);
            r.set("ETH", u);
        }
    }
    return t && e === "coinbase" && r.set("SOLANA", t), r.size === 0 ? null : e === "metamask" ? r.get("ETH") : r;
}
$95d7c41759820f7d$var$a($95d7c41759820f7d$export$bc1a75e20816804a, "getCoinbaseInstance");
function $95d7c41759820f7d$export$83c5a315dd1cff42(e) {
    return e.sort((n, t)=>Number(t.connected) - Number(n.connected) || Number(t.extensionAvailable) - Number(n.extensionAvailable));
}
$95d7c41759820f7d$var$a($95d7c41759820f7d$export$83c5a315dd1cff42, "sortWalletsBasedOnState");
function $95d7c41759820f7d$var$x() {
    let e = !1, n = navigator;
    return n.brave && n.brave.isBrave && n.brave.isBrave().then((t)=>{
        t && (e = !0);
    }), e;
}
$95d7c41759820f7d$var$a($95d7c41759820f7d$var$x, "isBrave");
function $95d7c41759820f7d$export$fd0008baca2bf83d(e) {
    if (typeof e != "object") return e;
    let n;
    return $95d7c41759820f7d$var$x() ? n = e.BRAVE : navigator.userAgent?.toLowerCase().indexOf("chrome") !== -1 ? n = e.CHROME : navigator.userAgent?.toLowerCase().indexOf("firefox") !== -1 ? n = e.FIREFOX : navigator.userAgent?.toLowerCase().indexOf("edge") !== -1 && (n = e.EDGE), n || e.DEFAULT;
}
$95d7c41759820f7d$var$a($95d7c41759820f7d$export$fd0008baca2bf83d, "detectInstallLink");
function $95d7c41759820f7d$export$486f06d416851c61() {
    return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
}
$95d7c41759820f7d$var$a($95d7c41759820f7d$export$486f06d416851c61, "detectMobileScreens");
function $95d7c41759820f7d$export$7925cdcd51d3102(e) {
    let t = (e?.split(":")[0] || "").split("-"), r = t[t.length - 1], i = t.slice(0, -1);
    return i[i.length - 1] === r && i.pop(), [
        i.join("-"),
        r
    ];
}
$95d7c41759820f7d$var$a($95d7c41759820f7d$export$7925cdcd51d3102, "splitWalletNetwork");
async function $95d7c41759820f7d$export$785cd5e95d0717c1(e) {
    let [n, t] = await Promise.all([
        e.request({
            method: "eth_requestAccounts"
        }),
        e.request({
            method: "eth_chainId"
        })
    ]);
    return {
        accounts: n,
        chainId: t
    };
}
$95d7c41759820f7d$var$a($95d7c41759820f7d$export$785cd5e95d0717c1, "getEvmAccounts");
var $95d7c41759820f7d$export$dae4ecb17c5c4020 = $95d7c41759820f7d$var$a(({ instance: e, state: n, updateChainId: t, updateAccounts: r })=>{
    let i = $95d7c41759820f7d$var$a((l)=>{
        n.connected && r(l);
    }, "handleAccountsChanged"), u = $95d7c41759820f7d$var$a((l)=>{
        t(l);
    }, "handleChainChanged");
    return e?.on?.("accountsChanged", i), e?.on?.("chainChanged", u), $95d7c41759820f7d$var$a(()=>{
        e?.off?.("accountsChanged", i), e?.off?.("chainChanged", u);
    }, "cleanup");
}, "subscribeToEvm"), $95d7c41759820f7d$export$4e65aae37dd4fc2c = $95d7c41759820f7d$var$a(async ({ instance: e })=>{
    try {
        return !!(await e.request({
            method: "eth_accounts"
        })).length;
    } catch  {
        return !1;
    }
}, "canEagerlyConnectToEvm"), $95d7c41759820f7d$export$394219efce660c44 = $95d7c41759820f7d$var$a(async ({ instance: e, network: n, meta: t })=>{
    let r = t.filter((0, $cd8bb37a306c2b01$export$9d749b8b357dfab2)), i = $95d7c41759820f7d$export$2029b78bc980a576(e, "ETH");
    await $95d7c41759820f7d$export$56ce9af15430dcbb(i, n, $95d7c41759820f7d$export$f0e13d51b5c692b6(r));
}, "switchNetworkForEvm"), $95d7c41759820f7d$export$86abff8ce014c125 = $95d7c41759820f7d$var$a(({ network: e, meta: n })=>$95d7c41759820f7d$export$9c76cdd331bb450e(n).includes(e), "canSwitchNetworkToEvm");
function $95d7c41759820f7d$export$9c76cdd331bb450e(e) {
    return e.filter((0, $cd8bb37a306c2b01$export$9d749b8b357dfab2)).map((n)=>n.name);
}
$95d7c41759820f7d$var$a($95d7c41759820f7d$export$9c76cdd331bb450e, "evmNetworkNames");
function $95d7c41759820f7d$export$d1cfcb1ce8ae2e4e(e, n) {
    return e && $95d7c41759820f7d$export$9c76cdd331bb450e(n).includes(e) ? "ETH" : null;
}
$95d7c41759820f7d$var$a($95d7c41759820f7d$export$d1cfcb1ce8ae2e4e, "getEthChainsInstance");
function $95d7c41759820f7d$var$T(e, n) {
    return e ? $95d7c41759820f7d$export$9c76cdd331bb450e(n).includes(e) : !1;
}
$95d7c41759820f7d$var$a($95d7c41759820f7d$var$T, "isEvmNetwork");
function $95d7c41759820f7d$export$b1eab42bc9b6c7a3(e, n, t) {
    t = t || "ETH";
    let r = $95d7c41759820f7d$var$T(t, n) ? $95d7c41759820f7d$export$d1cfcb1ce8ae2e4e(t, n) : t;
    return e && r ? e.get(r) : null;
}
$95d7c41759820f7d$var$a($95d7c41759820f7d$export$b1eab42bc9b6c7a3, "chooseInstance");
function $95d7c41759820f7d$export$2029b78bc980a576(e, n) {
    return e.size ? e.get(n) : e;
}
$95d7c41759820f7d$var$a($95d7c41759820f7d$export$2029b78bc980a576, "getNetworkInstance");
function $95d7c41759820f7d$export$2515b173249f2353(e, n) {
    return n && e[n] ? e[n].size ? e[n].get("ETH") : e[n] : null;
}
$95d7c41759820f7d$var$a($95d7c41759820f7d$export$2515b173249f2353, "getEvmProvider");
var $95d7c41759820f7d$var$R = $95d7c41759820f7d$var$a((e)=>e.filter((n)=>!n.info?.experimental).map((n)=>n.chainId).filter((n)=>!!n), "getCosmosMainChainsIds"), $95d7c41759820f7d$var$v = $95d7c41759820f7d$var$a((e)=>e.filter((n)=>n.info?.experimental).map((n)=>n.chainId).filter((n)=>!!n), "getCosmosMiscChainsIds"), $95d7c41759820f7d$export$9a5d8b9457d52deb = $95d7c41759820f7d$var$a((e)=>e.filter((n)=>!!n.info).filter((n)=>!!n.chainId).reduce((n, t)=>{
        let r = $95d7c41759820f7d$export$6c40052bed430212(t.info);
        r.stakeCurrency.coinImageUrl = window.location.origin + r.stakeCurrency.coinImageUrl, r.currencies = r.currencies.map((c)=>({
                ...c,
                coinImageUrl: window.location.origin + c.coinImageUrl
            })), r.feeCurrencies = r.feeCurrencies.map((c)=>({
                ...c,
                coinImageUrl: window.location.origin + c.coinImageUrl
            })), r.gasPriceStep || delete r.gasPriceStep;
        let { experimental: i, ...u } = r;
        return n[t.name] = {
            id: t.chainId,
            info: {
                ...u,
                chainId: t.chainId
            },
            experimental: i
        }, n;
    }, {}), "getCosmosExperimentalChainInfo");
async function $95d7c41759820f7d$var$P({ desiredChainIds: e, instance: n }) {
    let t = e.map((c)=>({
            signer: n.getOfflineSigner(c),
            chainId: c
        })).filter(Boolean), r = t.map(({ signer: c })=>c.getAccounts()), i = await Promise.allSettled(r), u = [];
    return i.forEach((c, l)=>{
        if (c.status !== "fulfilled") return;
        let m = c.value, { chainId: E } = t[l], h = m.map((C)=>C.address);
        u.push({
            accounts: h,
            chainId: E
        });
    }), u;
}
$95d7c41759820f7d$var$a($95d7c41759820f7d$var$P, "getMainAccounts");
async function $95d7c41759820f7d$var$b({ excludedChain: e, instance: n, meta: t }) {
    let r = $95d7c41759820f7d$var$v(t).filter((l)=>l !== e).map((l)=>({
            signer: n.getOfflineSigner(l),
            chainId: l
        })), i = r.map(async ({ signer: l })=>l.getAccounts()), u = await Promise.allSettled(i), c = [];
    return u.forEach((l, m)=>{
        if (l.status !== "fulfilled") return;
        let E = l.value, { chainId: h } = r[m], C = E.map((S)=>S.address);
        c.push({
            accounts: C,
            chainId: h
        });
    }), c;
}
$95d7c41759820f7d$var$a($95d7c41759820f7d$var$b, "tryRequestMiscAccounts");
var $95d7c41759820f7d$export$d4d8333f992ebe8c = $95d7c41759820f7d$var$a(async ({ instance: e, network: n, meta: t })=>{
    let r = n ? $95d7c41759820f7d$export$9a5d8b9457d52deb(t)[n] : null;
    if (n && !r) throw new Error(`You need to add ${n} to "COSMOS_EXPERIMENTAL_CHAINS_INFO" first.`);
    r && await e.experimentalSuggestChain(r.info);
    let i = $95d7c41759820f7d$var$R(t);
    r && i.push(r.id), i = Array.from(new Set(i)).filter(Boolean), await e.enable(i);
    let u = await $95d7c41759820f7d$var$P({
        desiredChainIds: i,
        instance: e
    }), c = r ? r.id : void 0, l = c ? await $95d7c41759820f7d$var$b({
        instance: e,
        meta: t,
        excludedChain: c
    }) : [];
    return [
        ...u,
        ...l
    ];
}, "getCosmosAccounts"), $95d7c41759820f7d$export$d873bd134feb393 = $95d7c41759820f7d$var$a(async (e)=>{
    let { instance: n, meta: t, network: r } = e, i = r ? $95d7c41759820f7d$export$9a5d8b9457d52deb(t)[r] : null;
    if (!i) throw new Error(`You need to add ${r} to "COSMOS_EXPERIMENTAL_CHAINS_INFO" first.`);
    await n.experimentalSuggestChain(i.info);
}, "suggestCosmosChain");




var $fcc296907f9c929f$var$o = Object.defineProperty;
var $fcc296907f9c929f$var$i = (n, r)=>$fcc296907f9c929f$var$o(n, "name", {
        value: r,
        configurable: !0
    });
var $fcc296907f9c929f$export$65c59bcc664c25fe = class {
    constructor(r){
        this.provider = r;
    }
    async signMessage() {
        throw (0, $6bf9e406f810d981$exports.SignerError).UnimplementedError("signMessage");
    }
    async signAndSendTx(r) {
        try {
            let a = $fcc296907f9c929f$export$65c59bcc664c25fe.buildTx(r), s = await this.provider.tronWeb.trx.sign(a);
            return {
                hash: (await this.provider.tronWeb.trx.sendRawTransaction(s))?.transaction?.txID
            };
        } catch (a) {
            throw new (0, $6bf9e406f810d981$exports.SignerError)((0, $6bf9e406f810d981$exports.SignerErrorCode).SEND_TX_ERROR, void 0, a);
        }
    }
    static buildTx(r) {
        let a = {};
        return r.txID && (a = {
            ...a,
            txID: r.txID
        }), r.visible !== void 0 && (a = {
            ...a,
            visible: r.visible
        }), r.__payload__ && (a = {
            ...a,
            __payload__: r.__payload__
        }), r.raw_data && (a = {
            ...a,
            raw_data: r.raw_data
        }), r.raw_data_hex && (a = {
            ...a,
            raw_data_hex: r.raw_data_hex
        }), a;
    }
};
$fcc296907f9c929f$var$i($fcc296907f9c929f$export$65c59bcc664c25fe, "DefaultTronSigner");


var $1b7a54a36665fb13$var$c = Object.defineProperty;
var $1b7a54a36665fb13$var$o = (e, t)=>$1b7a54a36665fb13$var$c(e, "name", {
        value: t,
        configurable: !0
    });
function $1b7a54a36665fb13$var$a() {
    let { tronLink: e } = window;
    return e || null;
}
$1b7a54a36665fb13$var$o($1b7a54a36665fb13$var$a, "tronLink");
function $1b7a54a36665fb13$var$s(e) {
    let t = new (0, $b0f7ab1c178913fc$export$2006fb7614e99307);
    return t.registerSigner((0, $6fc89aa3c0b05299$export$d513b00599f845d4).TRON, new (0, $fcc296907f9c929f$export$65c59bcc664c25fe)(e)), t;
}
$1b7a54a36665fb13$var$o($1b7a54a36665fb13$var$s, "getSigners");
var $1b7a54a36665fb13$var$f = (0, $95d7c41759820f7d$export$b80cfa133c9c182d).TRON_LINK, $1b7a54a36665fb13$export$e506a1d27d1eaa20 = {
    type: $1b7a54a36665fb13$var$f,
    defaultNetwork: (0, $95d7c41759820f7d$export$2e8191f482a38ccd).TRON
}, $1b7a54a36665fb13$export$8bedcca5bbd73999 = $1b7a54a36665fb13$var$a, $1b7a54a36665fb13$export$64605811ab45167f = $1b7a54a36665fb13$var$o(async ({ instance: e })=>{
    let t;
    if (e && !e.ready) {
        if (t = await e.request({
            method: "tron_requestAccounts"
        }), !t) throw new Error("Please unlock your TronLink extension first.");
        if (t?.code !== 200 && t.message) throw new Error(t.message);
    }
    let r = e.tronWeb.defaultAddress.base58;
    return {
        accounts: r ? [
            r
        ] : [],
        chainId: (0, $95d7c41759820f7d$export$2e8191f482a38ccd).TRON
    };
}, "connect"), $1b7a54a36665fb13$export$ec068583843480e7 = $1b7a54a36665fb13$var$o(({ updateAccounts: e, disconnect: t })=>{
    window.addEventListener("message", (n)=>{
        if (n.data.isTronLink && n.data.message && n.data.message.action == "accountsChanged") {
            let r = n?.data?.message?.data?.address;
            r ? e([
                r
            ]) : t();
        }
    });
}, "subscribe"), $1b7a54a36665fb13$export$3b3cf9ab9019de20 = $1b7a54a36665fb13$var$o(()=>!1, "canSwitchNetworkTo"), $1b7a54a36665fb13$export$6352a17a50193ded = $1b7a54a36665fb13$var$s, $1b7a54a36665fb13$export$e5b9d96c6aeb3ff7 = $1b7a54a36665fb13$var$o((e)=>{
    let t = (0, $cd8bb37a306c2b01$export$61a2144ef91f3622)(e);
    return {
        name: "TronLink",
        img: "https://raw.githubusercontent.com/rango-exchange/assets/main/wallets/tronlink/icon.svg",
        installLink: {
            CHROME: "https://chrome.google.com/webstore/detail/tronlink/ibnejdfjmmkpcnlpebklmnkoeoihofec",
            BRAVE: "https://chrome.google.com/webstore/detail/tronlink/ibnejdfjmmkpcnlpebklmnkoeoihofec",
            DEFAULT: "https://www.tronlink.org"
        },
        color: "#96e7ed",
        supportedChains: t
    };
}, "getWalletInfo");


var $bf12e64f553d2fc9$exports = {};

$parcel$export($bf12e64f553d2fc9$exports, "config", function () { return $bf12e64f553d2fc9$export$e506a1d27d1eaa20; });
$parcel$export($bf12e64f553d2fc9$exports, "getInstance", function () { return $bf12e64f553d2fc9$export$8bedcca5bbd73999; });
$parcel$export($bf12e64f553d2fc9$exports, "connect", function () { return $bf12e64f553d2fc9$export$64605811ab45167f; });
$parcel$export($bf12e64f553d2fc9$exports, "subscribe", function () { return $bf12e64f553d2fc9$export$ec068583843480e7; });
$parcel$export($bf12e64f553d2fc9$exports, "switchNetwork", function () { return $bf12e64f553d2fc9$export$f3473d805e486329; });
$parcel$export($bf12e64f553d2fc9$exports, "canSwitchNetworkTo", function () { return $bf12e64f553d2fc9$export$3b3cf9ab9019de20; });
$parcel$export($bf12e64f553d2fc9$exports, "getSigners", function () { return $bf12e64f553d2fc9$export$6352a17a50193ded; });
$parcel$export($bf12e64f553d2fc9$exports, "canEagerConnect", function () { return $bf12e64f553d2fc9$export$be9f3c5ed1d25e42; });
$parcel$export($bf12e64f553d2fc9$exports, "getWalletInfo", function () { return $bf12e64f553d2fc9$export$e5b9d96c6aeb3ff7; });





var $bf12e64f553d2fc9$var$M = Object.defineProperty;
var $bf12e64f553d2fc9$var$s = (e, r)=>$bf12e64f553d2fc9$var$M(e, "name", {
        value: r,
        configurable: !0
    });
var $bf12e64f553d2fc9$var$R = (0, $c7b1ddb572c90b38$export$7289d9aba3deaf99), $bf12e64f553d2fc9$var$C = [
    (0, $c7b1ddb572c90b38$export$2e8191f482a38ccd).POLYGON,
    (0, $c7b1ddb572c90b38$export$2e8191f482a38ccd).ETHEREUM,
    (0, $c7b1ddb572c90b38$export$2e8191f482a38ccd).BSC,
    (0, $c7b1ddb572c90b38$export$2e8191f482a38ccd).AVAX_CCHAIN,
    (0, $c7b1ddb572c90b38$export$2e8191f482a38ccd).FANTOM,
    (0, $c7b1ddb572c90b38$export$2e8191f482a38ccd).ARBITRUM
], $bf12e64f553d2fc9$var$A = [
    (0, $c7b1ddb572c90b38$export$2e8191f482a38ccd).COSMOS,
    (0, $c7b1ddb572c90b38$export$2e8191f482a38ccd).AKASH,
    (0, $c7b1ddb572c90b38$export$2e8191f482a38ccd).AXELAR,
    (0, $c7b1ddb572c90b38$export$2e8191f482a38ccd).CRYPTO_ORG,
    (0, $c7b1ddb572c90b38$export$2e8191f482a38ccd).JUNO,
    (0, $c7b1ddb572c90b38$export$2e8191f482a38ccd).KUJIRA,
    (0, $c7b1ddb572c90b38$export$2e8191f482a38ccd).MARS,
    (0, $c7b1ddb572c90b38$export$2e8191f482a38ccd).OSMOSIS,
    (0, $c7b1ddb572c90b38$export$2e8191f482a38ccd).STARGAZE,
    (0, $c7b1ddb572c90b38$export$2e8191f482a38ccd).STRIDE
];
function $bf12e64f553d2fc9$var$y() {
    let { xfi: e, ethereum: r } = window;
    if (!e) return null;
    let t = new Map;
    return e.bitcoin && t.set((0, $c7b1ddb572c90b38$export$2e8191f482a38ccd).BTC, e.bitcoin), e.litecoin && t.set((0, $c7b1ddb572c90b38$export$2e8191f482a38ccd).LTC, e.litecoin), e.thorchain && t.set((0, $c7b1ddb572c90b38$export$2e8191f482a38ccd).THORCHAIN, e.thorchain), e.bitcoincash && t.set((0, $c7b1ddb572c90b38$export$2e8191f482a38ccd).BCH, e.bitcoincash), e.binance && t.set((0, $c7b1ddb572c90b38$export$2e8191f482a38ccd).BINANCE, e.binance), r?.__XDEFI && t.set((0, $c7b1ddb572c90b38$export$2e8191f482a38ccd).ETHEREUM, r), e.dogecoin && t.set((0, $c7b1ddb572c90b38$export$2e8191f482a38ccd).DOGE, e.dogecoin), e.solana && t.set((0, $c7b1ddb572c90b38$export$2e8191f482a38ccd).SOLANA, e.solana), e.mayachain && t.set((0, $c7b1ddb572c90b38$export$2e8191f482a38ccd).MAYA, e.mayachain), e.keplr && t.set((0, $c7b1ddb572c90b38$export$2e8191f482a38ccd).COSMOS, e.keplr), t;
}
$bf12e64f553d2fc9$var$s($bf12e64f553d2fc9$var$y, "xdefi");
async function $bf12e64f553d2fc9$var$O(e) {
    let t = $bf12e64f553d2fc9$var$R.filter((o)=>o !== (0, $c7b1ddb572c90b38$export$2e8191f482a38ccd).ETHEREUM).map(async (o)=>new Promise((a, m)=>{
            e.get(o).request({
                method: "request_accounts",
                params: []
            }, (c, E)=>{
                if (c) return m(c), c;
                a({
                    accounts: E,
                    chainId: o
                });
            });
        }));
    return await Promise.all(t);
}
$bf12e64f553d2fc9$var$s($bf12e64f553d2fc9$var$O, "getNonEvmAccounts");
async function $bf12e64f553d2fc9$var$S(e, r, t, n, o, a, m, f, c) {
    return new Promise(function(E, g) {
        let h = {
            asset: {
                chain: e,
                symbol: r,
                ticker: r
            },
            from: t,
            amount: {
                amount: n,
                decimals: o
            },
            memo: c
        };
        a && (h.recipient = a), m.request({
            method: f,
            params: [
                h
            ]
        }, (u, k)=>{
            u ? g(new (0, $6bf9e406f810d981$exports.SignerError)((0, $6bf9e406f810d981$exports.SignerErrorCode).SEND_TX_ERROR, void 0, u)) : E(k);
        });
    });
}
$bf12e64f553d2fc9$var$s($bf12e64f553d2fc9$var$S, "xdefiTransfer");
var $bf12e64f553d2fc9$var$w = class {
    static #_ = (()=>{
        $bf12e64f553d2fc9$var$s(this, "CustomCosmosSigner");
    })();
    provider;
    constructor(r){
        this.provider = r;
    }
    async signMessage() {
        throw (0, $6bf9e406f810d981$exports.SignerError).UnimplementedError("signMessage");
    }
    async signAndSendTx(r) {
        if (r.rawTransfer === null) {
            let u = (0, $c7b1ddb572c90b38$export$2029b78bc980a576)(this.provider, (0, $c7b1ddb572c90b38$export$2e8191f482a38ccd).COSMOS);
            return {
                hash: await (0, $53c0ee1b384ace61$export$54a04b74f24ea36d)(r, u)
            };
        }
        let t = (0, $c7b1ddb572c90b38$export$2029b78bc980a576)(this.provider, (0, $c7b1ddb572c90b38$export$2e8191f482a38ccd).BINANCE), n = r.fromWalletAddress, { method: o, memo: a, recipient: m, decimals: f, amount: c, asset: E } = r.rawTransfer, g = r.blockChain;
        return {
            hash: await $bf12e64f553d2fc9$var$S(g, E.ticker, n, c, f, m, t, o, a)
        };
    }
};
var $bf12e64f553d2fc9$var$T = class {
    static #_ = (()=>{
        $bf12e64f553d2fc9$var$s(this, "CustomTransferSigner");
    })();
    provider;
    constructor(r){
        this.provider = r;
    }
    async signMessage() {
        throw (0, $6bf9e406f810d981$exports.SignerError).UnimplementedError("signMessage");
    }
    async signAndSendTx(r) {
        let { blockchain: t } = r.asset;
        if (!(0, $c7b1ddb572c90b38$export$7289d9aba3deaf99).includes(t)) throw new Error(`blockchain: ${t} transfer not implemented yet.`);
        let n = (0, $c7b1ddb572c90b38$export$2029b78bc980a576)(this.provider, t), { method: o, memo: a, recipientAddress: m, decimals: f, amount: c, fromWalletAddress: E, asset: g } = r;
        return {
            hash: await $bf12e64f553d2fc9$var$S(t, g.ticker, E, c, f, m, n, o, a)
        };
    }
};
function $bf12e64f553d2fc9$var$P(e) {
    let r = (0, $c7b1ddb572c90b38$export$2029b78bc980a576)(e, (0, $c7b1ddb572c90b38$export$2e8191f482a38ccd).ETHEREUM), t = (0, $c7b1ddb572c90b38$export$2029b78bc980a576)(e, (0, $c7b1ddb572c90b38$export$2e8191f482a38ccd).SOLANA), n = new (0, $b0f7ab1c178913fc$export$2006fb7614e99307);
    return n.registerSigner((0, $6fc89aa3c0b05299$export$d513b00599f845d4).EVM, new (0, $5d1e44928e4bdfed$export$363eea3e7285b95a)(r)), n.registerSigner((0, $6fc89aa3c0b05299$export$d513b00599f845d4).SOLANA, new (0, $5b224895d7132d06$export$38f28568c8f589a4)(t)), n.registerSigner((0, $6fc89aa3c0b05299$export$d513b00599f845d4).COSMOS, new $bf12e64f553d2fc9$var$w(e)), n.registerSigner((0, $6fc89aa3c0b05299$export$d513b00599f845d4).TRANSFER, new $bf12e64f553d2fc9$var$T(e)), n;
}
$bf12e64f553d2fc9$var$s($bf12e64f553d2fc9$var$P, "getSigners");
var $bf12e64f553d2fc9$var$te = (0, $c7b1ddb572c90b38$export$2e8191f482a38ccd).ETHEREUM, $bf12e64f553d2fc9$var$ne = (0, $c7b1ddb572c90b38$export$b80cfa133c9c182d).XDEFI, $bf12e64f553d2fc9$export$e506a1d27d1eaa20 = {
    type: $bf12e64f553d2fc9$var$ne,
    defaultNetwork: $bf12e64f553d2fc9$var$te
}, $bf12e64f553d2fc9$export$8bedcca5bbd73999 = $bf12e64f553d2fc9$var$y, $bf12e64f553d2fc9$export$64605811ab45167f = $bf12e64f553d2fc9$var$s(async ({ instance: e, meta: r })=>{
    let t = (0, $c7b1ddb572c90b38$export$b1eab42bc9b6c7a3)(e, r, (0, $c7b1ddb572c90b38$export$2e8191f482a38ccd).ETHEREUM), n = (0, $c7b1ddb572c90b38$export$b1eab42bc9b6c7a3)(e, r, (0, $c7b1ddb572c90b38$export$2e8191f482a38ccd).SOLANA), o = (0, $c7b1ddb572c90b38$export$b1eab42bc9b6c7a3)(e, r, (0, $c7b1ddb572c90b38$export$2e8191f482a38ccd).COSMOS);
    if (!t || !t.__XDEFI) throw new Error("Please 'Prioritise' XDEFI and refresh the page.");
    let a = await (0, $c7b1ddb572c90b38$export$785cd5e95d0717c1)(t), m = await $bf12e64f553d2fc9$var$O(e), f = await (0, $c7b1ddb572c90b38$export$a009f0f0c363aa6c)({
        instance: n,
        meta: r
    }), c = [];
    if (o) {
        let E = r.filter((u)=>(0, $cd8bb37a306c2b01$export$d917e9e8a70036a6)(u) && $bf12e64f553d2fc9$var$A.includes(u.name)), g = (0, $c7b1ddb572c90b38$export$2e8191f482a38ccd).COSMOS, h = await (0, $c7b1ddb572c90b38$export$d4d8333f992ebe8c)({
            instance: o,
            meta: E,
            network: g
        });
        Array.isArray(h) ? c.push(...h) : c.push(h);
    }
    return [
        a,
        ...m,
        f,
        ...c
    ];
}, "connect"), $bf12e64f553d2fc9$export$ec068583843480e7 = $bf12e64f553d2fc9$var$s(({ instance: e, meta: r, updateChainId: t, connect: n })=>{
    let o = $bf12e64f553d2fc9$var$s((m)=>{
        let f = (0, $c7b1ddb572c90b38$export$dfe7f2fe52a04245)(m, r) || (0, $c7b1ddb572c90b38$export$2e8191f482a38ccd).Unknown;
        t(m), n(f);
    }, "handleChainChanged"), a = (0, $c7b1ddb572c90b38$export$b1eab42bc9b6c7a3)(e, r, (0, $c7b1ddb572c90b38$export$2e8191f482a38ccd).ETHEREUM);
    return a?.on("chainChanged", o), ()=>{
        a?.off("chainChanged", o);
    };
}, "subscribe"), $bf12e64f553d2fc9$export$f3473d805e486329 = (0, $c7b1ddb572c90b38$export$394219efce660c44), $bf12e64f553d2fc9$export$3b3cf9ab9019de20 = (0, $c7b1ddb572c90b38$export$86abff8ce014c125), $bf12e64f553d2fc9$export$6352a17a50193ded = $bf12e64f553d2fc9$var$P, $bf12e64f553d2fc9$export$be9f3c5ed1d25e42 = $bf12e64f553d2fc9$var$s(async ({ instance: e, meta: r })=>{
    let t = (0, $c7b1ddb572c90b38$export$b1eab42bc9b6c7a3)(e, r, (0, $c7b1ddb572c90b38$export$2e8191f482a38ccd).ETHEREUM);
    return t ? (0, $c7b1ddb572c90b38$export$4e65aae37dd4fc2c)({
        instance: t,
        meta: r
    }) : Promise.resolve(!1);
}, "canEagerConnect"), $bf12e64f553d2fc9$export$e5b9d96c6aeb3ff7 = $bf12e64f553d2fc9$var$s((e)=>{
    let r = (0, $cd8bb37a306c2b01$export$7a136f0d6bb0d722)(e).filter((n)=>!!n.info && $bf12e64f553d2fc9$var$A.includes(n.name)), t = [
        ...e.filter((n)=>[
                ...$bf12e64f553d2fc9$var$C,
                ...(0, $c7b1ddb572c90b38$export$7289d9aba3deaf99),
                (0, $c7b1ddb572c90b38$export$2e8191f482a38ccd).SOLANA
            ].includes(n.name)),
        ...r
    ];
    return {
        name: "XDefi",
        img: "https://raw.githubusercontent.com/rango-exchange/assets/main/wallets/xdefi/icon.svg",
        installLink: {
            CHROME: "https://chrome.google.com/webstore/detail/xdefi-wallet/hmeobnfnfcmdkdcmlblgagmfpfboieaf",
            BRAVE: "https://chrome.google.com/webstore/detail/xdefi-wallet/hmeobnfnfcmdkdcmlblgagmfpfboieaf",
            DEFAULT: "https://xdefi.io/"
        },
        color: "#0646c7",
        supportedChains: t
    };
}, "getWalletInfo");




var $bh6RR = parcelRequire("bh6RR");
function $39ab41060f0dd572$export$2e2bcd8739ae039() {
    $39ab41060f0dd572$export$2e2bcd8739ae039 = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $39ab41060f0dd572$export$2e2bcd8739ae039.apply(this, arguments);
}



var $bh6RR = parcelRequire("bh6RR");
function $93dfa6b8fe6a3629$export$b9ecd428b558ff10(originalEventHandler, ourEventHandler, { checkForDefaultPrevented: checkForDefaultPrevented = true } = {}) {
    return function handleEvent(event) {
        originalEventHandler === null || originalEventHandler === void 0 || originalEventHandler(event);
        if (checkForDefaultPrevented === false || !event.defaultPrevented) return ourEventHandler === null || ourEventHandler === void 0 ? void 0 : ourEventHandler(event);
    };
}



var $bh6RR = parcelRequire("bh6RR");
/**
 * Set a given ref to a given value
 * This utility takes care of different types of refs: callback refs and RefObject(s)
 */ function $e52f713866128e60$var$$6ed0406888f73fc4$var$setRef(ref, value) {
    if (typeof ref === "function") ref(value);
    else if (ref !== null && ref !== undefined) ref.current = value;
}
/**
 * A utility to compose multiple refs together
 * Accepts callback refs and RefObject(s)
 */ function $e52f713866128e60$export$43e446d32b3d21af(...refs) {
    return (node)=>refs.forEach((ref)=>$e52f713866128e60$var$$6ed0406888f73fc4$var$setRef(ref, node));
}
/**
 * A custom hook that composes multiple refs
 * Accepts callback refs and RefObject(s)
 */ function $e52f713866128e60$export$c7b2cbe3552a0d05(...refs) {
    // eslint-disable-next-line react-hooks/exhaustive-deps
    return (0, $bh6RR.useCallback)($e52f713866128e60$export$43e446d32b3d21af(...refs), refs);
}



var $bh6RR = parcelRequire("bh6RR");
function $1cecd1d75f085228$export$fd42f52fd3ae1109(rootComponentName, defaultContext) {
    const Context = /*#__PURE__*/ (0, $bh6RR.createContext)(defaultContext);
    function Provider(props) {
        const { children: children, ...context } = props; // Only re-memoize when prop values change
        // eslint-disable-next-line react-hooks/exhaustive-deps
        const value = (0, $bh6RR.useMemo)(()=>context, Object.values(context));
        return /*#__PURE__*/ (0, $bh6RR.createElement)(Context.Provider, {
            value: value
        }, children);
    }
    function useContext(consumerName) {
        const context = (0, $bh6RR.useContext)(Context);
        if (context) return context;
        if (defaultContext !== undefined) return defaultContext; // if a defaultContext wasn't specified, it's a required context.
        throw new Error(`\`${consumerName}\` must be used within \`${rootComponentName}\``);
    }
    Provider.displayName = rootComponentName + "Provider";
    return [
        Provider,
        useContext
    ];
}
/* -------------------------------------------------------------------------------------------------
 * createContextScope
 * -----------------------------------------------------------------------------------------------*/ function $1cecd1d75f085228$export$50c7b4e9d9f19c1(scopeName, createContextScopeDeps = []) {
    let defaultContexts = [];
    /* -----------------------------------------------------------------------------------------------
   * createContext
   * ---------------------------------------------------------------------------------------------*/ function $c512c27ab02ef895$export$fd42f52fd3ae1109(rootComponentName, defaultContext) {
        const BaseContext = /*#__PURE__*/ (0, $bh6RR.createContext)(defaultContext);
        const index = defaultContexts.length;
        defaultContexts = [
            ...defaultContexts,
            defaultContext
        ];
        function Provider(props) {
            const { scope: scope, children: children, ...context } = props;
            const Context = (scope === null || scope === void 0 ? void 0 : scope[scopeName][index]) || BaseContext; // Only re-memoize when prop values change
            // eslint-disable-next-line react-hooks/exhaustive-deps
            const value = (0, $bh6RR.useMemo)(()=>context, Object.values(context));
            return /*#__PURE__*/ (0, $bh6RR.createElement)(Context.Provider, {
                value: value
            }, children);
        }
        function useContext(consumerName, scope) {
            const Context = (scope === null || scope === void 0 ? void 0 : scope[scopeName][index]) || BaseContext;
            const context = (0, $bh6RR.useContext)(Context);
            if (context) return context;
            if (defaultContext !== undefined) return defaultContext; // if a defaultContext wasn't specified, it's a required context.
            throw new Error(`\`${consumerName}\` must be used within \`${rootComponentName}\``);
        }
        Provider.displayName = rootComponentName + "Provider";
        return [
            Provider,
            useContext
        ];
    }
    /* -----------------------------------------------------------------------------------------------
   * createScope
   * ---------------------------------------------------------------------------------------------*/ const createScope = ()=>{
        const scopeContexts = defaultContexts.map((defaultContext)=>{
            return /*#__PURE__*/ (0, $bh6RR.createContext)(defaultContext);
        });
        return function useScope(scope) {
            const contexts = (scope === null || scope === void 0 ? void 0 : scope[scopeName]) || scopeContexts;
            return (0, $bh6RR.useMemo)(()=>({
                    [`__scope${scopeName}`]: {
                        ...scope,
                        [scopeName]: contexts
                    }
                }), [
                scope,
                contexts
            ]);
        };
    };
    createScope.scopeName = scopeName;
    return [
        $c512c27ab02ef895$export$fd42f52fd3ae1109,
        $1cecd1d75f085228$var$$c512c27ab02ef895$var$composeContextScopes(createScope, ...createContextScopeDeps)
    ];
}
/* -------------------------------------------------------------------------------------------------
 * composeContextScopes
 * -----------------------------------------------------------------------------------------------*/ function $1cecd1d75f085228$var$$c512c27ab02ef895$var$composeContextScopes(...scopes) {
    const baseScope = scopes[0];
    if (scopes.length === 1) return baseScope;
    const createScope1 = ()=>{
        const scopeHooks = scopes.map((createScope)=>({
                useScope: createScope(),
                scopeName: createScope.scopeName
            }));
        return function useComposedScopes(overrideScopes) {
            const nextScopes1 = scopeHooks.reduce((nextScopes, { useScope: useScope, scopeName: scopeName })=>{
                // We are calling a hook inside a callback which React warns against to avoid inconsistent
                // renders, however, scoping doesn't have render side effects so we ignore the rule.
                // eslint-disable-next-line react-hooks/rules-of-hooks
                const scopeProps = useScope(overrideScopes);
                const currentScope = scopeProps[`__scope${scopeName}`];
                return {
                    ...nextScopes,
                    ...currentScope
                };
            }, {});
            return (0, $bh6RR.useMemo)(()=>({
                    [`__scope${baseScope.scopeName}`]: nextScopes1
                }), [
                nextScopes1
            ]);
        };
    };
    createScope1.scopeName = baseScope.scopeName;
    return createScope1;
}




var $bh6RR = parcelRequire("bh6RR");



var $bh6RR = parcelRequire("bh6RR");



var $bh6RR = parcelRequire("bh6RR");

/* -------------------------------------------------------------------------------------------------
 * Slot
 * -----------------------------------------------------------------------------------------------*/ const $18fd289ffa468154$export$8c6ed5c666ac1360 = /*#__PURE__*/ (0, $bh6RR.forwardRef)((props, forwardedRef)=>{
    const { children: children, ...slotProps } = props;
    const childrenArray = (0, $bh6RR.Children).toArray(children);
    const slottable = childrenArray.find($18fd289ffa468154$var$$5e63c961fc1ce211$var$isSlottable);
    if (slottable) {
        // the new element to render is the one passed as a child of `Slottable`
        const newElement = slottable.props.children;
        const newChildren = childrenArray.map((child)=>{
            if (child === slottable) {
                // because the new element will be the one rendered, we are only interested
                // in grabbing its children (`newElement.props.children`)
                if ((0, $bh6RR.Children).count(newElement) > 1) return (0, $bh6RR.Children).only(null);
                return /*#__PURE__*/ (0, $bh6RR.isValidElement)(newElement) ? newElement.props.children : null;
            } else return child;
        });
        return /*#__PURE__*/ (0, $bh6RR.createElement)($18fd289ffa468154$var$$5e63c961fc1ce211$var$SlotClone, (0, $39ab41060f0dd572$export$2e2bcd8739ae039)({}, slotProps, {
            ref: forwardedRef
        }), /*#__PURE__*/ (0, $bh6RR.isValidElement)(newElement) ? /*#__PURE__*/ (0, $bh6RR.cloneElement)(newElement, undefined, newChildren) : null);
    }
    return /*#__PURE__*/ (0, $bh6RR.createElement)($18fd289ffa468154$var$$5e63c961fc1ce211$var$SlotClone, (0, $39ab41060f0dd572$export$2e2bcd8739ae039)({}, slotProps, {
        ref: forwardedRef
    }), children);
});
$18fd289ffa468154$export$8c6ed5c666ac1360.displayName = "Slot";
/* -------------------------------------------------------------------------------------------------
 * SlotClone
 * -----------------------------------------------------------------------------------------------*/ const $18fd289ffa468154$var$$5e63c961fc1ce211$var$SlotClone = /*#__PURE__*/ (0, $bh6RR.forwardRef)((props, forwardedRef)=>{
    const { children: children, ...slotProps } = props;
    if (/*#__PURE__*/ (0, $bh6RR.isValidElement)(children)) return /*#__PURE__*/ (0, $bh6RR.cloneElement)(children, {
        ...$18fd289ffa468154$var$$5e63c961fc1ce211$var$mergeProps(slotProps, children.props),
        ref: forwardedRef ? (0, $e52f713866128e60$export$43e446d32b3d21af)(forwardedRef, children.ref) : children.ref
    });
    return (0, $bh6RR.Children).count(children) > 1 ? (0, $bh6RR.Children).only(null) : null;
});
$18fd289ffa468154$var$$5e63c961fc1ce211$var$SlotClone.displayName = "SlotClone";
/* -------------------------------------------------------------------------------------------------
 * Slottable
 * -----------------------------------------------------------------------------------------------*/ const $18fd289ffa468154$export$d9f1ccf0bdb05d45 = ({ children: children })=>{
    return /*#__PURE__*/ (0, $bh6RR.createElement)((0, $bh6RR.Fragment), null, children);
};
/* ---------------------------------------------------------------------------------------------- */ function $18fd289ffa468154$var$$5e63c961fc1ce211$var$isSlottable(child) {
    return /*#__PURE__*/ (0, $bh6RR.isValidElement)(child) && child.type === $18fd289ffa468154$export$d9f1ccf0bdb05d45;
}
function $18fd289ffa468154$var$$5e63c961fc1ce211$var$mergeProps(slotProps, childProps) {
    // all child props should override
    const overrideProps = {
        ...childProps
    };
    for(const propName in childProps){
        const slotPropValue = slotProps[propName];
        const childPropValue = childProps[propName];
        const isHandler = /^on[A-Z]/.test(propName);
        if (isHandler) {
            // if the handler exists on both, we compose them
            if (slotPropValue && childPropValue) overrideProps[propName] = (...args)=>{
                childPropValue(...args);
                slotPropValue(...args);
            };
            else if (slotPropValue) overrideProps[propName] = slotPropValue;
        } else if (propName === "style") overrideProps[propName] = {
            ...slotPropValue,
            ...childPropValue
        };
        else if (propName === "className") overrideProps[propName] = [
            slotPropValue,
            childPropValue
        ].filter(Boolean).join(" ");
    }
    return {
        ...slotProps,
        ...overrideProps
    };
}
const $18fd289ffa468154$export$be92b6f5f03c0fe9 = $18fd289ffa468154$export$8c6ed5c666ac1360;


const $793b1a0f4d9647b1$var$$8927f6f2acc4f386$var$NODES = [
    "a",
    "button",
    "div",
    "form",
    "h2",
    "h3",
    "img",
    "input",
    "label",
    "li",
    "nav",
    "ol",
    "p",
    "span",
    "svg",
    "ul"
]; // Temporary while we await merge of this fix:
// https://github.com/DefinitelyTyped/DefinitelyTyped/pull/55396
// prettier-ignore
/* -------------------------------------------------------------------------------------------------
 * Primitive
 * -----------------------------------------------------------------------------------------------*/ const $793b1a0f4d9647b1$export$250ffa63cdc0d034 = $793b1a0f4d9647b1$var$$8927f6f2acc4f386$var$NODES.reduce((primitive, node)=>{
    const Node = /*#__PURE__*/ (0, $bh6RR.forwardRef)((props, forwardedRef)=>{
        const { asChild: asChild, ...primitiveProps } = props;
        const Comp = asChild ? (0, $18fd289ffa468154$export$8c6ed5c666ac1360) : node;
        (0, $bh6RR.useEffect)(()=>{
            window[Symbol.for("radix-ui")] = true;
        }, []);
        return /*#__PURE__*/ (0, $bh6RR.createElement)(Comp, (0, $39ab41060f0dd572$export$2e2bcd8739ae039)({}, primitiveProps, {
            ref: forwardedRef
        }));
    });
    Node.displayName = `Primitive.${node}`;
    return {
        ...primitive,
        [node]: Node
    };
}, {});
/* -------------------------------------------------------------------------------------------------
 * Utils
 * -----------------------------------------------------------------------------------------------*/ /**
 * Flush custom event dispatch
 * https://github.com/radix-ui/primitives/pull/1378
 *
 * React batches *all* event handlers since version 18, this introduces certain considerations when using custom event types.
 *
 * Internally, React prioritises events in the following order:
 *  - discrete
 *  - continuous
 *  - default
 *
 * https://github.com/facebook/react/blob/a8a4742f1c54493df00da648a3f9d26e3db9c8b5/packages/react-dom/src/events/ReactDOMEventListener.js#L294-L350
 *
 * `discrete` is an  important distinction as updates within these events are applied immediately.
 * React however, is not able to infer the priority of custom event types due to how they are detected internally.
 * Because of this, it's possible for updates from custom events to be unexpectedly batched when
 * dispatched by another `discrete` event.
 *
 * In order to ensure that updates from custom events are applied predictably, we need to manually flush the batch.
 * This utility should be used when dispatching a custom event from within another `discrete` event, this utility
 * is not nessesary when dispatching known event types, or if dispatching a custom type inside a non-discrete event.
 * For example:
 *
 * dispatching a known click 👎
 * target.dispatchEvent(new Event(‘click’))
 *
 * dispatching a custom type within a non-discrete event 👎
 * onScroll={(event) => event.target.dispatchEvent(new CustomEvent(‘customType’))}
 *
 * dispatching a custom type within a `discrete` event 👍
 * onPointerDown={(event) => dispatchDiscreteCustomEvent(event.target, new CustomEvent(‘customType’))}
 *
 * Note: though React classifies `focus`, `focusin` and `focusout` events as `discrete`, it's  not recommended to use
 * this utility with them. This is because it's possible for those handlers to be called implicitly during render
 * e.g. when focus is within a component as it is unmounted, or when managing focus on mount.
 */ function $793b1a0f4d9647b1$export$6d1a0317bde7de7f(target, event) {
    if (target) (0, $47cfd4084854a574$exports.flushSync)(()=>target.dispatchEvent(event));
}
/* -----------------------------------------------------------------------------------------------*/ const $793b1a0f4d9647b1$export$be92b6f5f03c0fe9 = $793b1a0f4d9647b1$export$250ffa63cdc0d034;




var $bh6RR = parcelRequire("bh6RR");
/**
 * A custom hook that converts a callback to a ref to avoid triggering re-renders when passed as a
 * prop or avoid re-executing effects when passed as a dependency
 */ function $c901973c35f9b07b$export$25bec8c6f54ee79a(callback) {
    const callbackRef = (0, $bh6RR.useRef)(callback);
    (0, $bh6RR.useEffect)(()=>{
        callbackRef.current = callback;
    }); // https://github.com/facebook/react/issues/19240
    return (0, $bh6RR.useMemo)(()=>(...args)=>{
            var _callbackRef$current;
            return (_callbackRef$current = callbackRef.current) === null || _callbackRef$current === void 0 ? void 0 : _callbackRef$current.call(callbackRef, ...args);
        }, []);
}



var $bh6RR = parcelRequire("bh6RR");

/**
 * Listens for when the escape key is down
 */ function $879e0a3f7f60ef06$export$3a72a57244d6e765(onEscapeKeyDownProp, ownerDocument = globalThis === null || globalThis === void 0 ? void 0 : globalThis.document) {
    const onEscapeKeyDown = (0, $c901973c35f9b07b$export$25bec8c6f54ee79a)(onEscapeKeyDownProp);
    (0, $bh6RR.useEffect)(()=>{
        const handleKeyDown = (event)=>{
            if (event.key === "Escape") onEscapeKeyDown(event);
        };
        ownerDocument.addEventListener("keydown", handleKeyDown);
        return ()=>ownerDocument.removeEventListener("keydown", handleKeyDown);
    }, [
        onEscapeKeyDown,
        ownerDocument
    ]);
}


/* -------------------------------------------------------------------------------------------------
 * DismissableLayer
 * -----------------------------------------------------------------------------------------------*/ const $8473b83e333b07d4$var$$5cb92bef7577960e$var$DISMISSABLE_LAYER_NAME = "DismissableLayer";
const $8473b83e333b07d4$var$$5cb92bef7577960e$var$CONTEXT_UPDATE = "dismissableLayer.update";
const $8473b83e333b07d4$var$$5cb92bef7577960e$var$POINTER_DOWN_OUTSIDE = "dismissableLayer.pointerDownOutside";
const $8473b83e333b07d4$var$$5cb92bef7577960e$var$FOCUS_OUTSIDE = "dismissableLayer.focusOutside";
let $8473b83e333b07d4$var$$5cb92bef7577960e$var$originalBodyPointerEvents;
const $8473b83e333b07d4$var$$5cb92bef7577960e$var$DismissableLayerContext = /*#__PURE__*/ (0, $bh6RR.createContext)({
    layers: new Set(),
    layersWithOutsidePointerEventsDisabled: new Set(),
    branches: new Set()
});
const $8473b83e333b07d4$export$177fb62ff3ec1f22 = /*#__PURE__*/ (0, $bh6RR.forwardRef)((props, forwardedRef)=>{
    var _node$ownerDocument;
    const { disableOutsidePointerEvents: disableOutsidePointerEvents = false, onEscapeKeyDown: onEscapeKeyDown, onPointerDownOutside: onPointerDownOutside, onFocusOutside: onFocusOutside, onInteractOutside: onInteractOutside, onDismiss: onDismiss, ...layerProps } = props;
    const context = (0, $bh6RR.useContext)($8473b83e333b07d4$var$$5cb92bef7577960e$var$DismissableLayerContext);
    const [node1, setNode] = (0, $bh6RR.useState)(null);
    const ownerDocument = (_node$ownerDocument = node1 === null || node1 === void 0 ? void 0 : node1.ownerDocument) !== null && _node$ownerDocument !== void 0 ? _node$ownerDocument : globalThis === null || globalThis === void 0 ? void 0 : globalThis.document;
    const [, force] = (0, $bh6RR.useState)({});
    const composedRefs = (0, $e52f713866128e60$export$c7b2cbe3552a0d05)(forwardedRef, (node)=>setNode(node));
    const layers = Array.from(context.layers);
    const [highestLayerWithOutsidePointerEventsDisabled] = [
        ...context.layersWithOutsidePointerEventsDisabled
    ].slice(-1); // prettier-ignore
    const highestLayerWithOutsidePointerEventsDisabledIndex = layers.indexOf(highestLayerWithOutsidePointerEventsDisabled); // prettier-ignore
    const index = node1 ? layers.indexOf(node1) : -1;
    const isBodyPointerEventsDisabled = context.layersWithOutsidePointerEventsDisabled.size > 0;
    const isPointerEventsEnabled = index >= highestLayerWithOutsidePointerEventsDisabledIndex;
    const pointerDownOutside = $8473b83e333b07d4$var$$5cb92bef7577960e$var$usePointerDownOutside((event)=>{
        const target = event.target;
        const isPointerDownOnBranch = [
            ...context.branches
        ].some((branch)=>branch.contains(target));
        if (!isPointerEventsEnabled || isPointerDownOnBranch) return;
        onPointerDownOutside === null || onPointerDownOutside === void 0 || onPointerDownOutside(event);
        onInteractOutside === null || onInteractOutside === void 0 || onInteractOutside(event);
        if (!event.defaultPrevented) onDismiss === null || onDismiss === void 0 || onDismiss();
    }, ownerDocument);
    const focusOutside = $8473b83e333b07d4$var$$5cb92bef7577960e$var$useFocusOutside((event)=>{
        const target = event.target;
        const isFocusInBranch = [
            ...context.branches
        ].some((branch)=>branch.contains(target));
        if (isFocusInBranch) return;
        onFocusOutside === null || onFocusOutside === void 0 || onFocusOutside(event);
        onInteractOutside === null || onInteractOutside === void 0 || onInteractOutside(event);
        if (!event.defaultPrevented) onDismiss === null || onDismiss === void 0 || onDismiss();
    }, ownerDocument);
    (0, $879e0a3f7f60ef06$export$3a72a57244d6e765)((event)=>{
        const isHighestLayer = index === context.layers.size - 1;
        if (!isHighestLayer) return;
        onEscapeKeyDown === null || onEscapeKeyDown === void 0 || onEscapeKeyDown(event);
        if (!event.defaultPrevented && onDismiss) {
            event.preventDefault();
            onDismiss();
        }
    }, ownerDocument);
    (0, $bh6RR.useEffect)(()=>{
        if (!node1) return;
        if (disableOutsidePointerEvents) {
            if (context.layersWithOutsidePointerEventsDisabled.size === 0) {
                $8473b83e333b07d4$var$$5cb92bef7577960e$var$originalBodyPointerEvents = ownerDocument.body.style.pointerEvents;
                ownerDocument.body.style.pointerEvents = "none";
            }
            context.layersWithOutsidePointerEventsDisabled.add(node1);
        }
        context.layers.add(node1);
        $8473b83e333b07d4$var$$5cb92bef7577960e$var$dispatchUpdate();
        return ()=>{
            if (disableOutsidePointerEvents && context.layersWithOutsidePointerEventsDisabled.size === 1) ownerDocument.body.style.pointerEvents = $8473b83e333b07d4$var$$5cb92bef7577960e$var$originalBodyPointerEvents;
        };
    }, [
        node1,
        ownerDocument,
        disableOutsidePointerEvents,
        context
    ]);
    /**
   * We purposefully prevent combining this effect with the `disableOutsidePointerEvents` effect
   * because a change to `disableOutsidePointerEvents` would remove this layer from the stack
   * and add it to the end again so the layering order wouldn't be _creation order_.
   * We only want them to be removed from context stacks when unmounted.
   */ (0, $bh6RR.useEffect)(()=>{
        return ()=>{
            if (!node1) return;
            context.layers.delete(node1);
            context.layersWithOutsidePointerEventsDisabled.delete(node1);
            $8473b83e333b07d4$var$$5cb92bef7577960e$var$dispatchUpdate();
        };
    }, [
        node1,
        context
    ]);
    (0, $bh6RR.useEffect)(()=>{
        const handleUpdate = ()=>force({});
        document.addEventListener($8473b83e333b07d4$var$$5cb92bef7577960e$var$CONTEXT_UPDATE, handleUpdate);
        return ()=>document.removeEventListener($8473b83e333b07d4$var$$5cb92bef7577960e$var$CONTEXT_UPDATE, handleUpdate);
    }, []);
    return /*#__PURE__*/ (0, $bh6RR.createElement)((0, $793b1a0f4d9647b1$export$250ffa63cdc0d034).div, (0, $39ab41060f0dd572$export$2e2bcd8739ae039)({}, layerProps, {
        ref: composedRefs,
        style: {
            pointerEvents: isBodyPointerEventsDisabled ? isPointerEventsEnabled ? "auto" : "none" : undefined,
            ...props.style
        },
        onFocusCapture: (0, $93dfa6b8fe6a3629$export$b9ecd428b558ff10)(props.onFocusCapture, focusOutside.onFocusCapture),
        onBlurCapture: (0, $93dfa6b8fe6a3629$export$b9ecd428b558ff10)(props.onBlurCapture, focusOutside.onBlurCapture),
        onPointerDownCapture: (0, $93dfa6b8fe6a3629$export$b9ecd428b558ff10)(props.onPointerDownCapture, pointerDownOutside.onPointerDownCapture)
    }));
});
/*#__PURE__*/ Object.assign($8473b83e333b07d4$export$177fb62ff3ec1f22, {
    displayName: $8473b83e333b07d4$var$$5cb92bef7577960e$var$DISMISSABLE_LAYER_NAME
});
/* -------------------------------------------------------------------------------------------------
 * DismissableLayerBranch
 * -----------------------------------------------------------------------------------------------*/ const $8473b83e333b07d4$var$$5cb92bef7577960e$var$BRANCH_NAME = "DismissableLayerBranch";
const $8473b83e333b07d4$export$4d5eb2109db14228 = /*#__PURE__*/ (0, $bh6RR.forwardRef)((props, forwardedRef)=>{
    const context = (0, $bh6RR.useContext)($8473b83e333b07d4$var$$5cb92bef7577960e$var$DismissableLayerContext);
    const ref = (0, $bh6RR.useRef)(null);
    const composedRefs = (0, $e52f713866128e60$export$c7b2cbe3552a0d05)(forwardedRef, ref);
    (0, $bh6RR.useEffect)(()=>{
        const node = ref.current;
        if (node) {
            context.branches.add(node);
            return ()=>{
                context.branches.delete(node);
            };
        }
    }, [
        context.branches
    ]);
    return /*#__PURE__*/ (0, $bh6RR.createElement)((0, $793b1a0f4d9647b1$export$250ffa63cdc0d034).div, (0, $39ab41060f0dd572$export$2e2bcd8739ae039)({}, props, {
        ref: composedRefs
    }));
});
/*#__PURE__*/ Object.assign($8473b83e333b07d4$export$4d5eb2109db14228, {
    displayName: $8473b83e333b07d4$var$$5cb92bef7577960e$var$BRANCH_NAME
});
/* -----------------------------------------------------------------------------------------------*/ /**
 * Listens for `pointerdown` outside a react subtree. We use `pointerdown` rather than `pointerup`
 * to mimic layer dismissing behaviour present in OS.
 * Returns props to pass to the node we want to check for outside events.
 */ function $8473b83e333b07d4$var$$5cb92bef7577960e$var$usePointerDownOutside(onPointerDownOutside, ownerDocument = globalThis === null || globalThis === void 0 ? void 0 : globalThis.document) {
    const handlePointerDownOutside = (0, $c901973c35f9b07b$export$25bec8c6f54ee79a)(onPointerDownOutside);
    const isPointerInsideReactTreeRef = (0, $bh6RR.useRef)(false);
    const handleClickRef = (0, $bh6RR.useRef)(()=>{});
    (0, $bh6RR.useEffect)(()=>{
        const handlePointerDown = (event)=>{
            if (event.target && !isPointerInsideReactTreeRef.current) {
                const eventDetail = {
                    originalEvent: event
                };
                function handleAndDispatchPointerDownOutsideEvent() {
                    $8473b83e333b07d4$var$$5cb92bef7577960e$var$handleAndDispatchCustomEvent($8473b83e333b07d4$var$$5cb92bef7577960e$var$POINTER_DOWN_OUTSIDE, handlePointerDownOutside, eventDetail, {
                        discrete: true
                    });
                }
                /**
         * On touch devices, we need to wait for a click event because browsers implement
         * a ~350ms delay between the time the user stops touching the display and when the
         * browser executres events. We need to ensure we don't reactivate pointer-events within
         * this timeframe otherwise the browser may execute events that should have been prevented.
         *
         * Additionally, this also lets us deal automatically with cancellations when a click event
         * isn't raised because the page was considered scrolled/drag-scrolled, long-pressed, etc.
         *
         * This is why we also continuously remove the previous listener, because we cannot be
         * certain that it was raised, and therefore cleaned-up.
         */ if (event.pointerType === "touch") {
                    ownerDocument.removeEventListener("click", handleClickRef.current);
                    handleClickRef.current = handleAndDispatchPointerDownOutsideEvent;
                    ownerDocument.addEventListener("click", handleClickRef.current, {
                        once: true
                    });
                } else handleAndDispatchPointerDownOutsideEvent();
            }
            isPointerInsideReactTreeRef.current = false;
        };
        /**
     * if this hook executes in a component that mounts via a `pointerdown` event, the event
     * would bubble up to the document and trigger a `pointerDownOutside` event. We avoid
     * this by delaying the event listener registration on the document.
     * This is not React specific, but rather how the DOM works, ie:
     * ```
     * button.addEventListener('pointerdown', () => {
     *   console.log('I will log');
     *   document.addEventListener('pointerdown', () => {
     *     console.log('I will also log');
     *   })
     * });
     */ const timerId = window.setTimeout(()=>{
            ownerDocument.addEventListener("pointerdown", handlePointerDown);
        }, 0);
        return ()=>{
            window.clearTimeout(timerId);
            ownerDocument.removeEventListener("pointerdown", handlePointerDown);
            ownerDocument.removeEventListener("click", handleClickRef.current);
        };
    }, [
        ownerDocument,
        handlePointerDownOutside
    ]);
    return {
        // ensures we check React component tree (not just DOM tree)
        onPointerDownCapture: ()=>isPointerInsideReactTreeRef.current = true
    };
}
/**
 * Listens for when focus happens outside a react subtree.
 * Returns props to pass to the root (node) of the subtree we want to check.
 */ function $8473b83e333b07d4$var$$5cb92bef7577960e$var$useFocusOutside(onFocusOutside, ownerDocument = globalThis === null || globalThis === void 0 ? void 0 : globalThis.document) {
    const handleFocusOutside = (0, $c901973c35f9b07b$export$25bec8c6f54ee79a)(onFocusOutside);
    const isFocusInsideReactTreeRef = (0, $bh6RR.useRef)(false);
    (0, $bh6RR.useEffect)(()=>{
        const handleFocus = (event)=>{
            if (event.target && !isFocusInsideReactTreeRef.current) {
                const eventDetail = {
                    originalEvent: event
                };
                $8473b83e333b07d4$var$$5cb92bef7577960e$var$handleAndDispatchCustomEvent($8473b83e333b07d4$var$$5cb92bef7577960e$var$FOCUS_OUTSIDE, handleFocusOutside, eventDetail, {
                    discrete: false
                });
            }
        };
        ownerDocument.addEventListener("focusin", handleFocus);
        return ()=>ownerDocument.removeEventListener("focusin", handleFocus);
    }, [
        ownerDocument,
        handleFocusOutside
    ]);
    return {
        onFocusCapture: ()=>isFocusInsideReactTreeRef.current = true,
        onBlurCapture: ()=>isFocusInsideReactTreeRef.current = false
    };
}
function $8473b83e333b07d4$var$$5cb92bef7577960e$var$dispatchUpdate() {
    const event = new CustomEvent($8473b83e333b07d4$var$$5cb92bef7577960e$var$CONTEXT_UPDATE);
    document.dispatchEvent(event);
}
function $8473b83e333b07d4$var$$5cb92bef7577960e$var$handleAndDispatchCustomEvent(name, handler, detail, { discrete: discrete }) {
    const target = detail.originalEvent.target;
    const event = new CustomEvent(name, {
        bubbles: false,
        cancelable: true,
        detail: detail
    });
    if (handler) target.addEventListener(name, handler, {
        once: true
    });
    if (discrete) (0, $793b1a0f4d9647b1$export$6d1a0317bde7de7f)(target, event);
    else target.dispatchEvent(event);
}
const $8473b83e333b07d4$export$be92b6f5f03c0fe9 = $8473b83e333b07d4$export$177fb62ff3ec1f22;
const $8473b83e333b07d4$export$aecb2ddcb55c95be = $8473b83e333b07d4$export$4d5eb2109db14228;



var $bh6RR = parcelRequire("bh6RR");

var $bh6RR = parcelRequire("bh6RR");
/**
 * On the server, React emits a warning when calling `useLayoutEffect`.
 * This is because neither `useLayoutEffect` nor `useEffect` run on the server.
 * We use this safe version which suppresses the warning by replacing it with a noop on the server.
 *
 * See: https://reactjs.org/docs/hooks-reference.html#uselayouteffect
 */ const $8b7ab17803b8e6f8$export$e5c5a5f917a5871c = Boolean(globalThis === null || globalThis === void 0 ? void 0 : globalThis.document) ? (0, $bh6RR.useLayoutEffect) : ()=>{};


const $d172fcbd2da23bac$var$$1746a345f3d73bb7$var$useReactId = $bh6RR["useId".toString()] || (()=>undefined);
let $d172fcbd2da23bac$var$$1746a345f3d73bb7$var$count = 0;
function $d172fcbd2da23bac$export$f680877a34711e37(deterministicId) {
    const [id, setId] = $bh6RR.useState($d172fcbd2da23bac$var$$1746a345f3d73bb7$var$useReactId()); // React versions older than 18 will have client-side ids only.
    (0, $8b7ab17803b8e6f8$export$e5c5a5f917a5871c)(()=>{
        if (!deterministicId) setId((reactId)=>reactId !== null && reactId !== void 0 ? reactId : String($d172fcbd2da23bac$var$$1746a345f3d73bb7$var$count++));
    }, [
        deterministicId
    ]);
    return deterministicId || (id ? `radix-${id}` : "");
}




var $bh6RR = parcelRequire("bh6RR");
const $168a40e325c04e1b$export$832b6fa47fa053d2 = [
    "top",
    "right",
    "bottom",
    "left"
];
const $168a40e325c04e1b$export$27b07d8a310ed8b5 = [
    "start",
    "end"
];
const $168a40e325c04e1b$export$803cd8101b6c182b = /*#__PURE__*/ $168a40e325c04e1b$export$832b6fa47fa053d2.reduce((acc, side)=>acc.concat(side, side + "-" + $168a40e325c04e1b$export$27b07d8a310ed8b5[0], side + "-" + $168a40e325c04e1b$export$27b07d8a310ed8b5[1]), []);
const $168a40e325c04e1b$export$96ec731ed4dcb222 = Math.min;
const $168a40e325c04e1b$export$8960430cfd85939f = Math.max;
const $168a40e325c04e1b$export$2077e0241d6afd3c = Math.round;
const $168a40e325c04e1b$export$a3fe094919f356fd = Math.floor;
const $168a40e325c04e1b$export$a397704b5e280835 = (v)=>({
        x: v,
        y: v
    });
const $168a40e325c04e1b$var$oppositeSideMap = {
    left: "right",
    right: "left",
    bottom: "top",
    top: "bottom"
};
const $168a40e325c04e1b$var$oppositeAlignmentMap = {
    start: "end",
    end: "start"
};
function $168a40e325c04e1b$export$7d15b64cf5a3a4c4(start, value, end) {
    return $168a40e325c04e1b$export$8960430cfd85939f(start, $168a40e325c04e1b$export$96ec731ed4dcb222(value, end));
}
function $168a40e325c04e1b$export$fef61f332f2c0afc(value, param) {
    return typeof value === "function" ? value(param) : value;
}
function $168a40e325c04e1b$export$3c915306cb7fc97a(placement) {
    return placement.split("-")[0];
}
function $168a40e325c04e1b$export$f0989780f32bfcda(placement) {
    return placement.split("-")[1];
}
function $168a40e325c04e1b$export$8a000a963141ac32(axis) {
    return axis === "x" ? "y" : "x";
}
function $168a40e325c04e1b$export$320bd9d53520c68a(axis) {
    return axis === "y" ? "height" : "width";
}
function $168a40e325c04e1b$export$f28e8f882010718a(placement) {
    return [
        "top",
        "bottom"
    ].includes($168a40e325c04e1b$export$3c915306cb7fc97a(placement)) ? "y" : "x";
}
function $168a40e325c04e1b$export$2b57e0052a6d6d4c(placement) {
    return $168a40e325c04e1b$export$8a000a963141ac32($168a40e325c04e1b$export$f28e8f882010718a(placement));
}
function $168a40e325c04e1b$export$be42861551f17911(placement, rects, rtl) {
    if (rtl === void 0) rtl = false;
    const alignment = $168a40e325c04e1b$export$f0989780f32bfcda(placement);
    const alignmentAxis = $168a40e325c04e1b$export$2b57e0052a6d6d4c(placement);
    const length = $168a40e325c04e1b$export$320bd9d53520c68a(alignmentAxis);
    let mainAlignmentSide = alignmentAxis === "x" ? alignment === (rtl ? "end" : "start") ? "right" : "left" : alignment === "start" ? "bottom" : "top";
    if (rects.reference[length] > rects.floating[length]) mainAlignmentSide = $168a40e325c04e1b$export$9c5e28bad23365fa(mainAlignmentSide);
    return [
        mainAlignmentSide,
        $168a40e325c04e1b$export$9c5e28bad23365fa(mainAlignmentSide)
    ];
}
function $168a40e325c04e1b$export$496432a3699e50b1(placement) {
    const oppositePlacement = $168a40e325c04e1b$export$9c5e28bad23365fa(placement);
    return [
        $168a40e325c04e1b$export$2b182c584985588b(placement),
        oppositePlacement,
        $168a40e325c04e1b$export$2b182c584985588b(oppositePlacement)
    ];
}
function $168a40e325c04e1b$export$2b182c584985588b(placement) {
    return placement.replace(/start|end/g, (alignment)=>$168a40e325c04e1b$var$oppositeAlignmentMap[alignment]);
}
function $168a40e325c04e1b$var$getSideList(side, isStart, rtl) {
    const lr = [
        "left",
        "right"
    ];
    const rl = [
        "right",
        "left"
    ];
    const tb = [
        "top",
        "bottom"
    ];
    const bt = [
        "bottom",
        "top"
    ];
    switch(side){
        case "top":
        case "bottom":
            if (rtl) return isStart ? rl : lr;
            return isStart ? lr : rl;
        case "left":
        case "right":
            return isStart ? tb : bt;
        default:
            return [];
    }
}
function $168a40e325c04e1b$export$a9b6fb18fd92c3ec(placement, flipAlignment, direction, rtl) {
    const alignment = $168a40e325c04e1b$export$f0989780f32bfcda(placement);
    let list = $168a40e325c04e1b$var$getSideList($168a40e325c04e1b$export$3c915306cb7fc97a(placement), direction === "start", rtl);
    if (alignment) {
        list = list.map((side)=>side + "-" + alignment);
        if (flipAlignment) list = list.concat(list.map($168a40e325c04e1b$export$2b182c584985588b));
    }
    return list;
}
function $168a40e325c04e1b$export$9c5e28bad23365fa(placement) {
    return placement.replace(/left|right|bottom|top/g, (side)=>$168a40e325c04e1b$var$oppositeSideMap[side]);
}
function $168a40e325c04e1b$export$1c66dbf1a9e34223(padding) {
    return {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0,
        ...padding
    };
}
function $168a40e325c04e1b$export$598c291c29bc2e71(padding) {
    return typeof padding !== "number" ? $168a40e325c04e1b$export$1c66dbf1a9e34223(padding) : {
        top: padding,
        right: padding,
        bottom: padding,
        left: padding
    };
}
function $168a40e325c04e1b$export$ee05aea0aeecbad4(rect) {
    return {
        ...rect,
        top: rect.y,
        left: rect.x,
        right: rect.x + rect.width,
        bottom: rect.y + rect.height
    };
}


function $926256944d3cd62f$var$computeCoordsFromPlacement(_ref, placement, rtl) {
    let { reference: reference, floating: floating } = _ref;
    const sideAxis = (0, $168a40e325c04e1b$export$f28e8f882010718a)(placement);
    const alignmentAxis = (0, $168a40e325c04e1b$export$2b57e0052a6d6d4c)(placement);
    const alignLength = (0, $168a40e325c04e1b$export$320bd9d53520c68a)(alignmentAxis);
    const side = (0, $168a40e325c04e1b$export$3c915306cb7fc97a)(placement);
    const isVertical = sideAxis === "y";
    const commonX = reference.x + reference.width / 2 - floating.width / 2;
    const commonY = reference.y + reference.height / 2 - floating.height / 2;
    const commonAlign = reference[alignLength] / 2 - floating[alignLength] / 2;
    let coords;
    switch(side){
        case "top":
            coords = {
                x: commonX,
                y: reference.y - floating.height
            };
            break;
        case "bottom":
            coords = {
                x: commonX,
                y: reference.y + reference.height
            };
            break;
        case "right":
            coords = {
                x: reference.x + reference.width,
                y: commonY
            };
            break;
        case "left":
            coords = {
                x: reference.x - floating.width,
                y: commonY
            };
            break;
        default:
            coords = {
                x: reference.x,
                y: reference.y
            };
    }
    switch((0, $168a40e325c04e1b$export$f0989780f32bfcda)(placement)){
        case "start":
            coords[alignmentAxis] -= commonAlign * (rtl && isVertical ? -1 : 1);
            break;
        case "end":
            coords[alignmentAxis] += commonAlign * (rtl && isVertical ? -1 : 1);
            break;
    }
    return coords;
}
/**
 * Computes the `x` and `y` coordinates that will place the floating element
 * next to a reference element when it is given a certain positioning strategy.
 *
 * This export does not have any `platform` interface logic. You will need to
 * write one for the platform you are using Floating UI with.
 */ const $926256944d3cd62f$export$48a53dcb22e581d0 = async (reference, floating, config)=>{
    const { placement: placement = "bottom", strategy: strategy = "absolute", middleware: middleware = [], platform: platform } = config;
    const validMiddleware = middleware.filter(Boolean);
    const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(floating));
    let rects = await platform.getElementRects({
        reference: reference,
        floating: floating,
        strategy: strategy
    });
    let { x: x, y: y } = $926256944d3cd62f$var$computeCoordsFromPlacement(rects, placement, rtl);
    let statefulPlacement = placement;
    let middlewareData = {};
    let resetCount = 0;
    for(let i = 0; i < validMiddleware.length; i++){
        const { name: name, fn: fn } = validMiddleware[i];
        const { x: nextX, y: nextY, data: data, reset: reset } = await fn({
            x: x,
            y: y,
            initialPlacement: placement,
            placement: statefulPlacement,
            strategy: strategy,
            middlewareData: middlewareData,
            rects: rects,
            platform: platform,
            elements: {
                reference: reference,
                floating: floating
            }
        });
        x = nextX != null ? nextX : x;
        y = nextY != null ? nextY : y;
        middlewareData = {
            ...middlewareData,
            [name]: {
                ...middlewareData[name],
                ...data
            }
        };
        if (reset && resetCount <= 50) {
            resetCount++;
            if (typeof reset === "object") {
                if (reset.placement) statefulPlacement = reset.placement;
                if (reset.rects) rects = reset.rects === true ? await platform.getElementRects({
                    reference: reference,
                    floating: floating,
                    strategy: strategy
                }) : reset.rects;
                ({ x: x, y: y } = $926256944d3cd62f$var$computeCoordsFromPlacement(rects, statefulPlacement, rtl));
            }
            i = -1;
            continue;
        }
    }
    return {
        x: x,
        y: y,
        placement: statefulPlacement,
        strategy: strategy,
        middlewareData: middlewareData
    };
};
/**
 * Resolves with an object of overflow side offsets that determine how much the
 * element is overflowing a given clipping boundary on each side.
 * - positive = overflowing the boundary by that number of pixels
 * - negative = how many pixels left before it will overflow
 * - 0 = lies flush with the boundary
 * @see https://floating-ui.com/docs/detectOverflow
 */ async function $926256944d3cd62f$export$37b6bde19b108ecc(state, options) {
    var _await$platform$isEle;
    if (options === void 0) options = {};
    const { x: x, y: y, platform: platform, rects: rects, elements: elements, strategy: strategy } = state;
    const { boundary: boundary = "clippingAncestors", rootBoundary: rootBoundary = "viewport", elementContext: elementContext = "floating", altBoundary: altBoundary = false, padding: padding = 0 } = (0, $168a40e325c04e1b$export$fef61f332f2c0afc)(options, state);
    const paddingObject = (0, $168a40e325c04e1b$export$598c291c29bc2e71)(padding);
    const altContext = elementContext === "floating" ? "reference" : "floating";
    const element = elements[altBoundary ? altContext : elementContext];
    const clippingClientRect = (0, $168a40e325c04e1b$export$ee05aea0aeecbad4)(await platform.getClippingRect({
        element: ((_await$platform$isEle = await (platform.isElement == null ? void 0 : platform.isElement(element))) != null ? _await$platform$isEle : true) ? element : element.contextElement || await (platform.getDocumentElement == null ? void 0 : platform.getDocumentElement(elements.floating)),
        boundary: boundary,
        rootBoundary: rootBoundary,
        strategy: strategy
    }));
    const rect = elementContext === "floating" ? {
        ...rects.floating,
        x: x,
        y: y
    } : rects.reference;
    const offsetParent = await (platform.getOffsetParent == null ? void 0 : platform.getOffsetParent(elements.floating));
    const offsetScale = await (platform.isElement == null ? void 0 : platform.isElement(offsetParent)) ? await (platform.getScale == null ? void 0 : platform.getScale(offsetParent)) || {
        x: 1,
        y: 1
    } : {
        x: 1,
        y: 1
    };
    const elementClientRect = (0, $168a40e325c04e1b$export$ee05aea0aeecbad4)(platform.convertOffsetParentRelativeRectToViewportRelativeRect ? await platform.convertOffsetParentRelativeRectToViewportRelativeRect({
        rect: rect,
        offsetParent: offsetParent,
        strategy: strategy
    }) : rect);
    return {
        top: (clippingClientRect.top - elementClientRect.top + paddingObject.top) / offsetScale.y,
        bottom: (elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom) / offsetScale.y,
        left: (clippingClientRect.left - elementClientRect.left + paddingObject.left) / offsetScale.x,
        right: (elementClientRect.right - clippingClientRect.right + paddingObject.right) / offsetScale.x
    };
}
/**
 * Provides data to position an inner element of the floating element so that it
 * appears centered to the reference element.
 * @see https://floating-ui.com/docs/arrow
 */ const $926256944d3cd62f$export$f2120bbfa5450bd2 = (options)=>({
        name: "arrow",
        options: options,
        async fn (state) {
            const { x: x, y: y, placement: placement, rects: rects, platform: platform, elements: elements } = state;
            // Since `element` is required, we don't Partial<> the type.
            const { element: element, padding: padding = 0 } = (0, $168a40e325c04e1b$export$fef61f332f2c0afc)(options, state) || {};
            if (element == null) return {};
            const paddingObject = (0, $168a40e325c04e1b$export$598c291c29bc2e71)(padding);
            const coords = {
                x: x,
                y: y
            };
            const axis = (0, $168a40e325c04e1b$export$2b57e0052a6d6d4c)(placement);
            const length = (0, $168a40e325c04e1b$export$320bd9d53520c68a)(axis);
            const arrowDimensions = await platform.getDimensions(element);
            const isYAxis = axis === "y";
            const minProp = isYAxis ? "top" : "left";
            const maxProp = isYAxis ? "bottom" : "right";
            const clientProp = isYAxis ? "clientHeight" : "clientWidth";
            const endDiff = rects.reference[length] + rects.reference[axis] - coords[axis] - rects.floating[length];
            const startDiff = coords[axis] - rects.reference[axis];
            const arrowOffsetParent = await (platform.getOffsetParent == null ? void 0 : platform.getOffsetParent(element));
            let clientSize = arrowOffsetParent ? arrowOffsetParent[clientProp] : 0;
            // DOM platform can return `window` as the `offsetParent`.
            if (!clientSize || !await (platform.isElement == null ? void 0 : platform.isElement(arrowOffsetParent))) clientSize = elements.floating[clientProp] || rects.floating[length];
            const centerToReference = endDiff / 2 - startDiff / 2;
            // If the padding is large enough that it causes the arrow to no longer be
            // centered, modify the padding so that it is centered.
            const largestPossiblePadding = clientSize / 2 - arrowDimensions[length] / 2 - 1;
            const minPadding = (0, $168a40e325c04e1b$export$96ec731ed4dcb222)(paddingObject[minProp], largestPossiblePadding);
            const maxPadding = (0, $168a40e325c04e1b$export$96ec731ed4dcb222)(paddingObject[maxProp], largestPossiblePadding);
            // Make sure the arrow doesn't overflow the floating element if the center
            // point is outside the floating element's bounds.
            const min$1 = minPadding;
            const max = clientSize - arrowDimensions[length] - maxPadding;
            const center = clientSize / 2 - arrowDimensions[length] / 2 + centerToReference;
            const offset = (0, $168a40e325c04e1b$export$7d15b64cf5a3a4c4)(min$1, center, max);
            // If the reference is small enough that the arrow's padding causes it to
            // to point to nothing for an aligned placement, adjust the offset of the
            // floating element itself. This stops `shift()` from taking action, but can
            // be worked around by calling it again after the `arrow()` if desired.
            const shouldAddOffset = (0, $168a40e325c04e1b$export$f0989780f32bfcda)(placement) != null && center != offset && rects.reference[length] / 2 - (center < min$1 ? minPadding : maxPadding) - arrowDimensions[length] / 2 < 0;
            const alignmentOffset = shouldAddOffset ? center < min$1 ? min$1 - center : max - center : 0;
            return {
                [axis]: coords[axis] - alignmentOffset,
                data: {
                    [axis]: offset,
                    centerOffset: center - offset + alignmentOffset
                }
            };
        }
    });
function $926256944d3cd62f$var$getPlacementList(alignment, autoAlignment, allowedPlacements) {
    const allowedPlacementsSortedByAlignment = alignment ? [
        ...allowedPlacements.filter((placement)=>(0, $168a40e325c04e1b$export$f0989780f32bfcda)(placement) === alignment),
        ...allowedPlacements.filter((placement)=>(0, $168a40e325c04e1b$export$f0989780f32bfcda)(placement) !== alignment)
    ] : allowedPlacements.filter((placement)=>(0, $168a40e325c04e1b$export$3c915306cb7fc97a)(placement) === placement);
    return allowedPlacementsSortedByAlignment.filter((placement)=>{
        if (alignment) return (0, $168a40e325c04e1b$export$f0989780f32bfcda)(placement) === alignment || (autoAlignment ? (0, $168a40e325c04e1b$export$2b182c584985588b)(placement) !== placement : false);
        return true;
    });
}
/**
 * Optimizes the visibility of the floating element by choosing the placement
 * that has the most space available automatically, without needing to specify a
 * preferred placement. Alternative to `flip`.
 * @see https://floating-ui.com/docs/autoPlacement
 */ const $926256944d3cd62f$export$91fb6ecbd551914 = function(options) {
    if (options === void 0) options = {};
    return {
        name: "autoPlacement",
        options: options,
        async fn (state) {
            var _middlewareData$autoP, _middlewareData$autoP2, _placementsThatFitOnE;
            const { rects: rects, middlewareData: middlewareData, placement: placement, platform: platform, elements: elements } = state;
            const { crossAxis: crossAxis = false, alignment: alignment, allowedPlacements: allowedPlacements = (0, $168a40e325c04e1b$export$803cd8101b6c182b), autoAlignment: autoAlignment = true, ...detectOverflowOptions } = (0, $168a40e325c04e1b$export$fef61f332f2c0afc)(options, state);
            const placements$1 = alignment !== undefined || allowedPlacements === (0, $168a40e325c04e1b$export$803cd8101b6c182b) ? $926256944d3cd62f$var$getPlacementList(alignment || null, autoAlignment, allowedPlacements) : allowedPlacements;
            const overflow = await $926256944d3cd62f$export$37b6bde19b108ecc(state, detectOverflowOptions);
            const currentIndex = ((_middlewareData$autoP = middlewareData.autoPlacement) == null ? void 0 : _middlewareData$autoP.index) || 0;
            const currentPlacement = placements$1[currentIndex];
            if (currentPlacement == null) return {};
            const alignmentSides = (0, $168a40e325c04e1b$export$be42861551f17911)(currentPlacement, rects, await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating)));
            // Make `computeCoords` start from the right place.
            if (placement !== currentPlacement) return {
                reset: {
                    placement: placements$1[0]
                }
            };
            const currentOverflows = [
                overflow[(0, $168a40e325c04e1b$export$3c915306cb7fc97a)(currentPlacement)],
                overflow[alignmentSides[0]],
                overflow[alignmentSides[1]]
            ];
            const allOverflows = [
                ...((_middlewareData$autoP2 = middlewareData.autoPlacement) == null ? void 0 : _middlewareData$autoP2.overflows) || [],
                {
                    placement: currentPlacement,
                    overflows: currentOverflows
                }
            ];
            const nextPlacement = placements$1[currentIndex + 1];
            // There are more placements to check.
            if (nextPlacement) return {
                data: {
                    index: currentIndex + 1,
                    overflows: allOverflows
                },
                reset: {
                    placement: nextPlacement
                }
            };
            const placementsSortedByMostSpace = allOverflows.map((d)=>{
                const alignment = (0, $168a40e325c04e1b$export$f0989780f32bfcda)(d.placement);
                return [
                    d.placement,
                    alignment && crossAxis ? // Check along the mainAxis and main crossAxis side.
                    d.overflows.slice(0, 2).reduce((acc, v)=>acc + v, 0) : // Check only the mainAxis.
                    d.overflows[0],
                    d.overflows
                ];
            }).sort((a, b)=>a[1] - b[1]);
            const placementsThatFitOnEachSide = placementsSortedByMostSpace.filter((d)=>d[2].slice(0, // Aligned placements should not check their opposite crossAxis
                // side.
                (0, $168a40e325c04e1b$export$f0989780f32bfcda)(d[0]) ? 2 : 3).every((v)=>v <= 0));
            const resetPlacement = ((_placementsThatFitOnE = placementsThatFitOnEachSide[0]) == null ? void 0 : _placementsThatFitOnE[0]) || placementsSortedByMostSpace[0][0];
            if (resetPlacement !== placement) return {
                data: {
                    index: currentIndex + 1,
                    overflows: allOverflows
                },
                reset: {
                    placement: resetPlacement
                }
            };
            return {};
        }
    };
};
/**
 * Optimizes the visibility of the floating element by flipping the `placement`
 * in order to keep it in view when the preferred placement(s) will overflow the
 * clipping boundary. Alternative to `autoPlacement`.
 * @see https://floating-ui.com/docs/flip
 */ const $926256944d3cd62f$export$8a83211c878a3f1f = function(options) {
    if (options === void 0) options = {};
    return {
        name: "flip",
        options: options,
        async fn (state) {
            var _middlewareData$flip;
            const { placement: placement, middlewareData: middlewareData, rects: rects, initialPlacement: initialPlacement, platform: platform, elements: elements } = state;
            const { mainAxis: checkMainAxis = true, crossAxis: checkCrossAxis = true, fallbackPlacements: specifiedFallbackPlacements, fallbackStrategy: fallbackStrategy = "bestFit", fallbackAxisSideDirection: fallbackAxisSideDirection = "none", flipAlignment: flipAlignment = true, ...detectOverflowOptions } = (0, $168a40e325c04e1b$export$fef61f332f2c0afc)(options, state);
            const side = (0, $168a40e325c04e1b$export$3c915306cb7fc97a)(placement);
            const isBasePlacement = (0, $168a40e325c04e1b$export$3c915306cb7fc97a)(initialPlacement) === initialPlacement;
            const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating));
            const fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipAlignment ? [
                (0, $168a40e325c04e1b$export$9c5e28bad23365fa)(initialPlacement)
            ] : (0, $168a40e325c04e1b$export$496432a3699e50b1)(initialPlacement));
            if (!specifiedFallbackPlacements && fallbackAxisSideDirection !== "none") fallbackPlacements.push(...(0, $168a40e325c04e1b$export$a9b6fb18fd92c3ec)(initialPlacement, flipAlignment, fallbackAxisSideDirection, rtl));
            const placements = [
                initialPlacement,
                ...fallbackPlacements
            ];
            const overflow = await $926256944d3cd62f$export$37b6bde19b108ecc(state, detectOverflowOptions);
            const overflows = [];
            let overflowsData = ((_middlewareData$flip = middlewareData.flip) == null ? void 0 : _middlewareData$flip.overflows) || [];
            if (checkMainAxis) overflows.push(overflow[side]);
            if (checkCrossAxis) {
                const sides = (0, $168a40e325c04e1b$export$be42861551f17911)(placement, rects, rtl);
                overflows.push(overflow[sides[0]], overflow[sides[1]]);
            }
            overflowsData = [
                ...overflowsData,
                {
                    placement: placement,
                    overflows: overflows
                }
            ];
            // One or more sides is overflowing.
            if (!overflows.every((side)=>side <= 0)) {
                var _middlewareData$flip2, _overflowsData$filter;
                const nextIndex = (((_middlewareData$flip2 = middlewareData.flip) == null ? void 0 : _middlewareData$flip2.index) || 0) + 1;
                const nextPlacement = placements[nextIndex];
                if (nextPlacement) // Try next placement and re-run the lifecycle.
                return {
                    data: {
                        index: nextIndex,
                        overflows: overflowsData
                    },
                    reset: {
                        placement: nextPlacement
                    }
                };
                // First, find the candidates that fit on the mainAxis side of overflow,
                // then find the placement that fits the best on the main crossAxis side.
                let resetPlacement = (_overflowsData$filter = overflowsData.filter((d)=>d.overflows[0] <= 0).sort((a, b)=>a.overflows[1] - b.overflows[1])[0]) == null ? void 0 : _overflowsData$filter.placement;
                // Otherwise fallback.
                if (!resetPlacement) switch(fallbackStrategy){
                    case "bestFit":
                        {
                            var _overflowsData$map$so;
                            const placement = (_overflowsData$map$so = overflowsData.map((d)=>[
                                    d.placement,
                                    d.overflows.filter((overflow)=>overflow > 0).reduce((acc, overflow)=>acc + overflow, 0)
                                ]).sort((a, b)=>a[1] - b[1])[0]) == null ? void 0 : _overflowsData$map$so[0];
                            if (placement) resetPlacement = placement;
                            break;
                        }
                    case "initialPlacement":
                        resetPlacement = initialPlacement;
                        break;
                }
                if (placement !== resetPlacement) return {
                    reset: {
                        placement: resetPlacement
                    }
                };
            }
            return {};
        }
    };
};
function $926256944d3cd62f$var$getSideOffsets(overflow, rect) {
    return {
        top: overflow.top - rect.height,
        right: overflow.right - rect.width,
        bottom: overflow.bottom - rect.height,
        left: overflow.left - rect.width
    };
}
function $926256944d3cd62f$var$isAnySideFullyClipped(overflow) {
    return (0, $168a40e325c04e1b$export$832b6fa47fa053d2).some((side)=>overflow[side] >= 0);
}
/**
 * Provides data to hide the floating element in applicable situations, such as
 * when it is not in the same clipping context as the reference element.
 * @see https://floating-ui.com/docs/hide
 */ const $926256944d3cd62f$export$fe8985bb6374093c = function(options) {
    if (options === void 0) options = {};
    return {
        name: "hide",
        options: options,
        async fn (state) {
            const { rects: rects } = state;
            const { strategy: strategy = "referenceHidden", ...detectOverflowOptions } = (0, $168a40e325c04e1b$export$fef61f332f2c0afc)(options, state);
            switch(strategy){
                case "referenceHidden":
                    {
                        const overflow = await $926256944d3cd62f$export$37b6bde19b108ecc(state, {
                            ...detectOverflowOptions,
                            elementContext: "reference"
                        });
                        const offsets = $926256944d3cd62f$var$getSideOffsets(overflow, rects.reference);
                        return {
                            data: {
                                referenceHiddenOffsets: offsets,
                                referenceHidden: $926256944d3cd62f$var$isAnySideFullyClipped(offsets)
                            }
                        };
                    }
                case "escaped":
                    {
                        const overflow = await $926256944d3cd62f$export$37b6bde19b108ecc(state, {
                            ...detectOverflowOptions,
                            altBoundary: true
                        });
                        const offsets = $926256944d3cd62f$var$getSideOffsets(overflow, rects.floating);
                        return {
                            data: {
                                escapedOffsets: offsets,
                                escaped: $926256944d3cd62f$var$isAnySideFullyClipped(offsets)
                            }
                        };
                    }
                default:
                    return {};
            }
        }
    };
};
function $926256944d3cd62f$var$getBoundingRect(rects) {
    const minX = (0, $168a40e325c04e1b$export$96ec731ed4dcb222)(...rects.map((rect)=>rect.left));
    const minY = (0, $168a40e325c04e1b$export$96ec731ed4dcb222)(...rects.map((rect)=>rect.top));
    const maxX = (0, $168a40e325c04e1b$export$8960430cfd85939f)(...rects.map((rect)=>rect.right));
    const maxY = (0, $168a40e325c04e1b$export$8960430cfd85939f)(...rects.map((rect)=>rect.bottom));
    return {
        x: minX,
        y: minY,
        width: maxX - minX,
        height: maxY - minY
    };
}
function $926256944d3cd62f$var$getRectsByLine(rects) {
    const sortedRects = rects.slice().sort((a, b)=>a.y - b.y);
    const groups = [];
    let prevRect = null;
    for(let i = 0; i < sortedRects.length; i++){
        const rect = sortedRects[i];
        if (!prevRect || rect.y - prevRect.y > prevRect.height / 2) groups.push([
            rect
        ]);
        else groups[groups.length - 1].push(rect);
        prevRect = rect;
    }
    return groups.map((rect)=>(0, $168a40e325c04e1b$export$ee05aea0aeecbad4)($926256944d3cd62f$var$getBoundingRect(rect)));
}
/**
 * Provides improved positioning for inline reference elements that can span
 * over multiple lines, such as hyperlinks or range selections.
 * @see https://floating-ui.com/docs/inline
 */ const $926256944d3cd62f$export$18c8ad048e32c7d5 = function(options) {
    if (options === void 0) options = {};
    return {
        name: "inline",
        options: options,
        async fn (state) {
            const { placement: placement, elements: elements, rects: rects, platform: platform, strategy: strategy } = state;
            // A MouseEvent's client{X,Y} coords can be up to 2 pixels off a
            // ClientRect's bounds, despite the event listener being triggered. A
            // padding of 2 seems to handle this issue.
            const { padding: padding = 2, x: x, y: y } = (0, $168a40e325c04e1b$export$fef61f332f2c0afc)(options, state);
            const nativeClientRects = Array.from(await (platform.getClientRects == null ? void 0 : platform.getClientRects(elements.reference)) || []);
            const clientRects = $926256944d3cd62f$var$getRectsByLine(nativeClientRects);
            const fallback = (0, $168a40e325c04e1b$export$ee05aea0aeecbad4)($926256944d3cd62f$var$getBoundingRect(nativeClientRects));
            const paddingObject = (0, $168a40e325c04e1b$export$598c291c29bc2e71)(padding);
            function getBoundingClientRect() {
                // There are two rects and they are disjoined.
                if (clientRects.length === 2 && clientRects[0].left > clientRects[1].right && x != null && y != null) // Find the first rect in which the point is fully inside.
                return clientRects.find((rect)=>x > rect.left - paddingObject.left && x < rect.right + paddingObject.right && y > rect.top - paddingObject.top && y < rect.bottom + paddingObject.bottom) || fallback;
                // There are 2 or more connected rects.
                if (clientRects.length >= 2) {
                    if ((0, $168a40e325c04e1b$export$f28e8f882010718a)(placement) === "y") {
                        const firstRect = clientRects[0];
                        const lastRect = clientRects[clientRects.length - 1];
                        const isTop = (0, $168a40e325c04e1b$export$3c915306cb7fc97a)(placement) === "top";
                        const top = firstRect.top;
                        const bottom = lastRect.bottom;
                        const left = isTop ? firstRect.left : lastRect.left;
                        const right = isTop ? firstRect.right : lastRect.right;
                        const width = right - left;
                        const height = bottom - top;
                        return {
                            top: top,
                            bottom: bottom,
                            left: left,
                            right: right,
                            width: width,
                            height: height,
                            x: left,
                            y: top
                        };
                    }
                    const isLeftSide = (0, $168a40e325c04e1b$export$3c915306cb7fc97a)(placement) === "left";
                    const maxRight = (0, $168a40e325c04e1b$export$8960430cfd85939f)(...clientRects.map((rect)=>rect.right));
                    const minLeft = (0, $168a40e325c04e1b$export$96ec731ed4dcb222)(...clientRects.map((rect)=>rect.left));
                    const measureRects = clientRects.filter((rect)=>isLeftSide ? rect.left === minLeft : rect.right === maxRight);
                    const top = measureRects[0].top;
                    const bottom = measureRects[measureRects.length - 1].bottom;
                    const left = minLeft;
                    const right = maxRight;
                    const width = right - left;
                    const height = bottom - top;
                    return {
                        top: top,
                        bottom: bottom,
                        left: left,
                        right: right,
                        width: width,
                        height: height,
                        x: left,
                        y: top
                    };
                }
                return fallback;
            }
            const resetRects = await platform.getElementRects({
                reference: {
                    getBoundingClientRect: getBoundingClientRect
                },
                floating: elements.floating,
                strategy: strategy
            });
            if (rects.reference.x !== resetRects.reference.x || rects.reference.y !== resetRects.reference.y || rects.reference.width !== resetRects.reference.width || rects.reference.height !== resetRects.reference.height) return {
                reset: {
                    rects: resetRects
                }
            };
            return {};
        }
    };
};
// For type backwards-compatibility, the `OffsetOptions` type was also
// Derivable.
async function $926256944d3cd62f$var$convertValueToCoords(state, options) {
    const { placement: placement, platform: platform, elements: elements } = state;
    const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating));
    const side = (0, $168a40e325c04e1b$export$3c915306cb7fc97a)(placement);
    const alignment = (0, $168a40e325c04e1b$export$f0989780f32bfcda)(placement);
    const isVertical = (0, $168a40e325c04e1b$export$f28e8f882010718a)(placement) === "y";
    const mainAxisMulti = [
        "left",
        "top"
    ].includes(side) ? -1 : 1;
    const crossAxisMulti = rtl && isVertical ? -1 : 1;
    const rawValue = (0, $168a40e325c04e1b$export$fef61f332f2c0afc)(options, state);
    // eslint-disable-next-line prefer-const
    let { mainAxis: mainAxis, crossAxis: crossAxis, alignmentAxis: alignmentAxis } = typeof rawValue === "number" ? {
        mainAxis: rawValue,
        crossAxis: 0,
        alignmentAxis: null
    } : {
        mainAxis: 0,
        crossAxis: 0,
        alignmentAxis: null,
        ...rawValue
    };
    if (alignment && typeof alignmentAxis === "number") crossAxis = alignment === "end" ? alignmentAxis * -1 : alignmentAxis;
    return isVertical ? {
        x: crossAxis * crossAxisMulti,
        y: mainAxis * mainAxisMulti
    } : {
        x: mainAxis * mainAxisMulti,
        y: crossAxis * crossAxisMulti
    };
}
/**
 * Modifies the placement by translating the floating element along the
 * specified axes.
 * A number (shorthand for `mainAxis` or distance), or an axes configuration
 * object may be passed.
 * @see https://floating-ui.com/docs/offset
 */ const $926256944d3cd62f$export$cc800923e997bb8 = function(options) {
    if (options === void 0) options = 0;
    return {
        name: "offset",
        options: options,
        async fn (state) {
            const { x: x, y: y } = state;
            const diffCoords = await $926256944d3cd62f$var$convertValueToCoords(state, options);
            return {
                x: x + diffCoords.x,
                y: y + diffCoords.y,
                data: diffCoords
            };
        }
    };
};
/**
 * Optimizes the visibility of the floating element by shifting it in order to
 * keep it in view when it will overflow the clipping boundary.
 * @see https://floating-ui.com/docs/shift
 */ const $926256944d3cd62f$export$fba63a578e423eb = function(options) {
    if (options === void 0) options = {};
    return {
        name: "shift",
        options: options,
        async fn (state) {
            const { x: x, y: y, placement: placement } = state;
            const { mainAxis: checkMainAxis = true, crossAxis: checkCrossAxis = false, limiter: limiter = {
                fn: (_ref)=>{
                    let { x: x, y: y } = _ref;
                    return {
                        x: x,
                        y: y
                    };
                }
            }, ...detectOverflowOptions } = (0, $168a40e325c04e1b$export$fef61f332f2c0afc)(options, state);
            const coords = {
                x: x,
                y: y
            };
            const overflow = await $926256944d3cd62f$export$37b6bde19b108ecc(state, detectOverflowOptions);
            const crossAxis = (0, $168a40e325c04e1b$export$f28e8f882010718a)((0, $168a40e325c04e1b$export$3c915306cb7fc97a)(placement));
            const mainAxis = (0, $168a40e325c04e1b$export$8a000a963141ac32)(crossAxis);
            let mainAxisCoord = coords[mainAxis];
            let crossAxisCoord = coords[crossAxis];
            if (checkMainAxis) {
                const minSide = mainAxis === "y" ? "top" : "left";
                const maxSide = mainAxis === "y" ? "bottom" : "right";
                const min = mainAxisCoord + overflow[minSide];
                const max = mainAxisCoord - overflow[maxSide];
                mainAxisCoord = (0, $168a40e325c04e1b$export$7d15b64cf5a3a4c4)(min, mainAxisCoord, max);
            }
            if (checkCrossAxis) {
                const minSide = crossAxis === "y" ? "top" : "left";
                const maxSide = crossAxis === "y" ? "bottom" : "right";
                const min = crossAxisCoord + overflow[minSide];
                const max = crossAxisCoord - overflow[maxSide];
                crossAxisCoord = (0, $168a40e325c04e1b$export$7d15b64cf5a3a4c4)(min, crossAxisCoord, max);
            }
            const limitedCoords = limiter.fn({
                ...state,
                [mainAxis]: mainAxisCoord,
                [crossAxis]: crossAxisCoord
            });
            return {
                ...limitedCoords,
                data: {
                    x: limitedCoords.x - x,
                    y: limitedCoords.y - y
                }
            };
        }
    };
};
/**
 * Built-in `limiter` that will stop `shift()` at a certain point.
 */ const $926256944d3cd62f$export$7bf07e38f3dc4b69 = function(options) {
    if (options === void 0) options = {};
    return {
        options: options,
        fn (state) {
            const { x: x, y: y, placement: placement, rects: rects, middlewareData: middlewareData } = state;
            const { offset: offset = 0, mainAxis: checkMainAxis = true, crossAxis: checkCrossAxis = true } = (0, $168a40e325c04e1b$export$fef61f332f2c0afc)(options, state);
            const coords = {
                x: x,
                y: y
            };
            const crossAxis = (0, $168a40e325c04e1b$export$f28e8f882010718a)(placement);
            const mainAxis = (0, $168a40e325c04e1b$export$8a000a963141ac32)(crossAxis);
            let mainAxisCoord = coords[mainAxis];
            let crossAxisCoord = coords[crossAxis];
            const rawOffset = (0, $168a40e325c04e1b$export$fef61f332f2c0afc)(offset, state);
            const computedOffset = typeof rawOffset === "number" ? {
                mainAxis: rawOffset,
                crossAxis: 0
            } : {
                mainAxis: 0,
                crossAxis: 0,
                ...rawOffset
            };
            if (checkMainAxis) {
                const len = mainAxis === "y" ? "height" : "width";
                const limitMin = rects.reference[mainAxis] - rects.floating[len] + computedOffset.mainAxis;
                const limitMax = rects.reference[mainAxis] + rects.reference[len] - computedOffset.mainAxis;
                if (mainAxisCoord < limitMin) mainAxisCoord = limitMin;
                else if (mainAxisCoord > limitMax) mainAxisCoord = limitMax;
            }
            if (checkCrossAxis) {
                var _middlewareData$offse, _middlewareData$offse2;
                const len = mainAxis === "y" ? "width" : "height";
                const isOriginSide = [
                    "top",
                    "left"
                ].includes((0, $168a40e325c04e1b$export$3c915306cb7fc97a)(placement));
                const limitMin = rects.reference[crossAxis] - rects.floating[len] + (isOriginSide ? ((_middlewareData$offse = middlewareData.offset) == null ? void 0 : _middlewareData$offse[crossAxis]) || 0 : 0) + (isOriginSide ? 0 : computedOffset.crossAxis);
                const limitMax = rects.reference[crossAxis] + rects.reference[len] + (isOriginSide ? 0 : ((_middlewareData$offse2 = middlewareData.offset) == null ? void 0 : _middlewareData$offse2[crossAxis]) || 0) - (isOriginSide ? computedOffset.crossAxis : 0);
                if (crossAxisCoord < limitMin) crossAxisCoord = limitMin;
                else if (crossAxisCoord > limitMax) crossAxisCoord = limitMax;
            }
            return {
                [mainAxis]: mainAxisCoord,
                [crossAxis]: crossAxisCoord
            };
        }
    };
};
/**
 * Provides data that allows you to change the size of the floating element —
 * for instance, prevent it from overflowing the clipping boundary or match the
 * width of the reference element.
 * @see https://floating-ui.com/docs/size
 */ const $926256944d3cd62f$export$346677f925de839c = function(options) {
    if (options === void 0) options = {};
    return {
        name: "size",
        options: options,
        async fn (state) {
            const { placement: placement, rects: rects, platform: platform, elements: elements } = state;
            const { apply: apply = ()=>{}, ...detectOverflowOptions } = (0, $168a40e325c04e1b$export$fef61f332f2c0afc)(options, state);
            const overflow = await $926256944d3cd62f$export$37b6bde19b108ecc(state, detectOverflowOptions);
            const side = (0, $168a40e325c04e1b$export$3c915306cb7fc97a)(placement);
            const alignment = (0, $168a40e325c04e1b$export$f0989780f32bfcda)(placement);
            const isYAxis = (0, $168a40e325c04e1b$export$f28e8f882010718a)(placement) === "y";
            const { width: width, height: height } = rects.floating;
            let heightSide;
            let widthSide;
            if (side === "top" || side === "bottom") {
                heightSide = side;
                widthSide = alignment === (await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating)) ? "start" : "end") ? "left" : "right";
            } else {
                widthSide = side;
                heightSide = alignment === "end" ? "top" : "bottom";
            }
            const overflowAvailableHeight = height - overflow[heightSide];
            const overflowAvailableWidth = width - overflow[widthSide];
            const noShift = !state.middlewareData.shift;
            let availableHeight = overflowAvailableHeight;
            let availableWidth = overflowAvailableWidth;
            if (isYAxis) {
                const maximumClippingWidth = width - overflow.left - overflow.right;
                availableWidth = alignment || noShift ? (0, $168a40e325c04e1b$export$96ec731ed4dcb222)(overflowAvailableWidth, maximumClippingWidth) : maximumClippingWidth;
            } else {
                const maximumClippingHeight = height - overflow.top - overflow.bottom;
                availableHeight = alignment || noShift ? (0, $168a40e325c04e1b$export$96ec731ed4dcb222)(overflowAvailableHeight, maximumClippingHeight) : maximumClippingHeight;
            }
            if (noShift && !alignment) {
                const xMin = (0, $168a40e325c04e1b$export$8960430cfd85939f)(overflow.left, 0);
                const xMax = (0, $168a40e325c04e1b$export$8960430cfd85939f)(overflow.right, 0);
                const yMin = (0, $168a40e325c04e1b$export$8960430cfd85939f)(overflow.top, 0);
                const yMax = (0, $168a40e325c04e1b$export$8960430cfd85939f)(overflow.bottom, 0);
                if (isYAxis) availableWidth = width - 2 * (xMin !== 0 || xMax !== 0 ? xMin + xMax : (0, $168a40e325c04e1b$export$8960430cfd85939f)(overflow.left, overflow.right));
                else availableHeight = height - 2 * (yMin !== 0 || yMax !== 0 ? yMin + yMax : (0, $168a40e325c04e1b$export$8960430cfd85939f)(overflow.top, overflow.bottom));
            }
            await apply({
                ...state,
                availableWidth: availableWidth,
                availableHeight: availableHeight
            });
            const nextDimensions = await platform.getDimensions(elements.floating);
            if (width !== nextDimensions.width || height !== nextDimensions.height) return {
                reset: {
                    rects: true
                }
            };
            return {};
        }
    };
};



function $e2c1d25bdd91a12d$export$651544f548703224(node) {
    if ($e2c1d25bdd91a12d$export$8ee0fc9ee280b4ee(node)) return (node.nodeName || "").toLowerCase();
    // Mocked nodes in testing environments may not be instances of Node. By
    // returning `#document` an infinite loop won't occur.
    // https://github.com/floating-ui/floating-ui/issues/2317
    return "#document";
}
function $e2c1d25bdd91a12d$export$38b2d434cce3ea22(node) {
    var _node$ownerDocument;
    return (node == null ? void 0 : (_node$ownerDocument = node.ownerDocument) == null ? void 0 : _node$ownerDocument.defaultView) || window;
}
function $e2c1d25bdd91a12d$export$e495491855dc5418(node) {
    var _ref;
    return (_ref = ($e2c1d25bdd91a12d$export$8ee0fc9ee280b4ee(node) ? node.ownerDocument : node.document) || window.document) == null ? void 0 : _ref.documentElement;
}
function $e2c1d25bdd91a12d$export$8ee0fc9ee280b4ee(value) {
    return value instanceof Node || value instanceof $e2c1d25bdd91a12d$export$38b2d434cce3ea22(value).Node;
}
function $e2c1d25bdd91a12d$export$45a5e7f76e0caa8d(value) {
    return value instanceof Element || value instanceof $e2c1d25bdd91a12d$export$38b2d434cce3ea22(value).Element;
}
function $e2c1d25bdd91a12d$export$1b3bfaa9684536aa(value) {
    return value instanceof HTMLElement || value instanceof $e2c1d25bdd91a12d$export$38b2d434cce3ea22(value).HTMLElement;
}
function $e2c1d25bdd91a12d$export$af51f0f06c0f328a(value) {
    // Browsers without `ShadowRoot` support.
    if (typeof ShadowRoot === "undefined") return false;
    return value instanceof ShadowRoot || value instanceof $e2c1d25bdd91a12d$export$38b2d434cce3ea22(value).ShadowRoot;
}
function $e2c1d25bdd91a12d$export$989e911fa9af580a(element) {
    const { overflow: overflow, overflowX: overflowX, overflowY: overflowY, display: display } = $e2c1d25bdd91a12d$export$3735103072e4a80(element);
    return /auto|scroll|overlay|hidden|clip/.test(overflow + overflowY + overflowX) && ![
        "inline",
        "contents"
    ].includes(display);
}
function $e2c1d25bdd91a12d$export$71535ffaa902797f(element) {
    return [
        "table",
        "td",
        "th"
    ].includes($e2c1d25bdd91a12d$export$651544f548703224(element));
}
function $e2c1d25bdd91a12d$export$d6c4e8150c35fed1(element) {
    const webkit = $e2c1d25bdd91a12d$export$78551043582a6a98();
    const css = $e2c1d25bdd91a12d$export$3735103072e4a80(element);
    // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
    return css.transform !== "none" || css.perspective !== "none" || (css.containerType ? css.containerType !== "normal" : false) || !webkit && (css.backdropFilter ? css.backdropFilter !== "none" : false) || !webkit && (css.filter ? css.filter !== "none" : false) || [
        "transform",
        "perspective",
        "filter"
    ].some((value)=>(css.willChange || "").includes(value)) || [
        "paint",
        "layout",
        "strict",
        "content"
    ].some((value)=>(css.contain || "").includes(value));
}
function $e2c1d25bdd91a12d$export$940d8225183e1404(element) {
    let currentNode = $e2c1d25bdd91a12d$export$4e12058fc4d51d56(element);
    while($e2c1d25bdd91a12d$export$1b3bfaa9684536aa(currentNode) && !$e2c1d25bdd91a12d$export$d1162fb0b6d4cd51(currentNode)){
        if ($e2c1d25bdd91a12d$export$d6c4e8150c35fed1(currentNode)) return currentNode;
        else currentNode = $e2c1d25bdd91a12d$export$4e12058fc4d51d56(currentNode);
    }
    return null;
}
function $e2c1d25bdd91a12d$export$78551043582a6a98() {
    if (typeof CSS === "undefined" || !CSS.supports) return false;
    return CSS.supports("-webkit-backdrop-filter", "none");
}
function $e2c1d25bdd91a12d$export$d1162fb0b6d4cd51(node) {
    return [
        "html",
        "body",
        "#document"
    ].includes($e2c1d25bdd91a12d$export$651544f548703224(node));
}
function $e2c1d25bdd91a12d$export$3735103072e4a80(element) {
    return $e2c1d25bdd91a12d$export$38b2d434cce3ea22(element).getComputedStyle(element);
}
function $e2c1d25bdd91a12d$export$dc8fc79fa2800137(element) {
    if ($e2c1d25bdd91a12d$export$45a5e7f76e0caa8d(element)) return {
        scrollLeft: element.scrollLeft,
        scrollTop: element.scrollTop
    };
    return {
        scrollLeft: element.pageXOffset,
        scrollTop: element.pageYOffset
    };
}
function $e2c1d25bdd91a12d$export$4e12058fc4d51d56(node) {
    if ($e2c1d25bdd91a12d$export$651544f548703224(node) === "html") return node;
    const result = // Step into the shadow DOM of the parent of a slotted node.
    node.assignedSlot || // DOM Element detected.
    node.parentNode || // ShadowRoot detected.
    $e2c1d25bdd91a12d$export$af51f0f06c0f328a(node) && node.host || // Fallback.
    $e2c1d25bdd91a12d$export$e495491855dc5418(node);
    return $e2c1d25bdd91a12d$export$af51f0f06c0f328a(result) ? result.host : result;
}
function $e2c1d25bdd91a12d$export$7cd01a57c8ca906c(node) {
    const parentNode = $e2c1d25bdd91a12d$export$4e12058fc4d51d56(node);
    if ($e2c1d25bdd91a12d$export$d1162fb0b6d4cd51(parentNode)) return node.ownerDocument ? node.ownerDocument.body : node.body;
    if ($e2c1d25bdd91a12d$export$1b3bfaa9684536aa(parentNode) && $e2c1d25bdd91a12d$export$989e911fa9af580a(parentNode)) return parentNode;
    return $e2c1d25bdd91a12d$export$7cd01a57c8ca906c(parentNode);
}
function $e2c1d25bdd91a12d$export$3b57c1601291186b(node, list) {
    var _node$ownerDocument2;
    if (list === void 0) list = [];
    const scrollableAncestor = $e2c1d25bdd91a12d$export$7cd01a57c8ca906c(node);
    const isBody = scrollableAncestor === ((_node$ownerDocument2 = node.ownerDocument) == null ? void 0 : _node$ownerDocument2.body);
    const win = $e2c1d25bdd91a12d$export$38b2d434cce3ea22(scrollableAncestor);
    if (isBody) return list.concat(win, win.visualViewport || [], $e2c1d25bdd91a12d$export$989e911fa9af580a(scrollableAncestor) ? scrollableAncestor : []);
    return list.concat(scrollableAncestor, $e2c1d25bdd91a12d$export$3b57c1601291186b(scrollableAncestor));
}


function $985fd6054d85832a$var$getCssDimensions(element) {
    const css = (0, $e2c1d25bdd91a12d$export$3735103072e4a80)(element);
    // In testing environments, the `width` and `height` properties are empty
    // strings for SVG elements, returning NaN. Fallback to `0` in this case.
    let width = parseFloat(css.width) || 0;
    let height = parseFloat(css.height) || 0;
    const hasOffset = (0, $e2c1d25bdd91a12d$export$1b3bfaa9684536aa)(element);
    const offsetWidth = hasOffset ? element.offsetWidth : width;
    const offsetHeight = hasOffset ? element.offsetHeight : height;
    const shouldFallback = (0, $168a40e325c04e1b$export$2077e0241d6afd3c)(width) !== offsetWidth || (0, $168a40e325c04e1b$export$2077e0241d6afd3c)(height) !== offsetHeight;
    if (shouldFallback) {
        width = offsetWidth;
        height = offsetHeight;
    }
    return {
        width: width,
        height: height,
        $: shouldFallback
    };
}
function $985fd6054d85832a$var$unwrapElement(element) {
    return !(0, $e2c1d25bdd91a12d$export$45a5e7f76e0caa8d)(element) ? element.contextElement : element;
}
function $985fd6054d85832a$var$getScale(element) {
    const domElement = $985fd6054d85832a$var$unwrapElement(element);
    if (!(0, $e2c1d25bdd91a12d$export$1b3bfaa9684536aa)(domElement)) return (0, $168a40e325c04e1b$export$a397704b5e280835)(1);
    const rect = domElement.getBoundingClientRect();
    const { width: width, height: height, $: $ } = $985fd6054d85832a$var$getCssDimensions(domElement);
    let x = ($ ? (0, $168a40e325c04e1b$export$2077e0241d6afd3c)(rect.width) : rect.width) / width;
    let y = ($ ? (0, $168a40e325c04e1b$export$2077e0241d6afd3c)(rect.height) : rect.height) / height;
    // 0, NaN, or Infinity should always fallback to 1.
    if (!x || !Number.isFinite(x)) x = 1;
    if (!y || !Number.isFinite(y)) y = 1;
    return {
        x: x,
        y: y
    };
}
const $985fd6054d85832a$var$noOffsets = /*#__PURE__*/ (0, $168a40e325c04e1b$export$a397704b5e280835)(0);
function $985fd6054d85832a$var$getVisualOffsets(element) {
    const win = (0, $e2c1d25bdd91a12d$export$38b2d434cce3ea22)(element);
    if (!(0, $e2c1d25bdd91a12d$export$78551043582a6a98)() || !win.visualViewport) return $985fd6054d85832a$var$noOffsets;
    return {
        x: win.visualViewport.offsetLeft,
        y: win.visualViewport.offsetTop
    };
}
function $985fd6054d85832a$var$shouldAddVisualOffsets(element, isFixed, floatingOffsetParent) {
    if (isFixed === void 0) isFixed = false;
    if (!floatingOffsetParent || isFixed && floatingOffsetParent !== (0, $e2c1d25bdd91a12d$export$38b2d434cce3ea22)(element)) return false;
    return isFixed;
}
function $985fd6054d85832a$var$getBoundingClientRect(element, includeScale, isFixedStrategy, offsetParent) {
    if (includeScale === void 0) includeScale = false;
    if (isFixedStrategy === void 0) isFixedStrategy = false;
    const clientRect = element.getBoundingClientRect();
    const domElement = $985fd6054d85832a$var$unwrapElement(element);
    let scale = (0, $168a40e325c04e1b$export$a397704b5e280835)(1);
    if (includeScale) {
        if (offsetParent) {
            if ((0, $e2c1d25bdd91a12d$export$45a5e7f76e0caa8d)(offsetParent)) scale = $985fd6054d85832a$var$getScale(offsetParent);
        } else scale = $985fd6054d85832a$var$getScale(element);
    }
    const visualOffsets = $985fd6054d85832a$var$shouldAddVisualOffsets(domElement, isFixedStrategy, offsetParent) ? $985fd6054d85832a$var$getVisualOffsets(domElement) : (0, $168a40e325c04e1b$export$a397704b5e280835)(0);
    let x = (clientRect.left + visualOffsets.x) / scale.x;
    let y = (clientRect.top + visualOffsets.y) / scale.y;
    let width = clientRect.width / scale.x;
    let height = clientRect.height / scale.y;
    if (domElement) {
        const win = (0, $e2c1d25bdd91a12d$export$38b2d434cce3ea22)(domElement);
        const offsetWin = offsetParent && (0, $e2c1d25bdd91a12d$export$45a5e7f76e0caa8d)(offsetParent) ? (0, $e2c1d25bdd91a12d$export$38b2d434cce3ea22)(offsetParent) : offsetParent;
        let currentIFrame = win.frameElement;
        while(currentIFrame && offsetParent && offsetWin !== win){
            const iframeScale = $985fd6054d85832a$var$getScale(currentIFrame);
            const iframeRect = currentIFrame.getBoundingClientRect();
            const css = (0, $e2c1d25bdd91a12d$export$3735103072e4a80)(currentIFrame);
            const left = iframeRect.left + (currentIFrame.clientLeft + parseFloat(css.paddingLeft)) * iframeScale.x;
            const top = iframeRect.top + (currentIFrame.clientTop + parseFloat(css.paddingTop)) * iframeScale.y;
            x *= iframeScale.x;
            y *= iframeScale.y;
            width *= iframeScale.x;
            height *= iframeScale.y;
            x += left;
            y += top;
            currentIFrame = (0, $e2c1d25bdd91a12d$export$38b2d434cce3ea22)(currentIFrame).frameElement;
        }
    }
    return (0, $168a40e325c04e1b$export$ee05aea0aeecbad4)({
        width: width,
        height: height,
        x: x,
        y: y
    });
}
function $985fd6054d85832a$var$convertOffsetParentRelativeRectToViewportRelativeRect(_ref) {
    let { rect: rect, offsetParent: offsetParent, strategy: strategy } = _ref;
    const isOffsetParentAnElement = (0, $e2c1d25bdd91a12d$export$1b3bfaa9684536aa)(offsetParent);
    const documentElement = (0, $e2c1d25bdd91a12d$export$e495491855dc5418)(offsetParent);
    if (offsetParent === documentElement) return rect;
    let scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    let scale = (0, $168a40e325c04e1b$export$a397704b5e280835)(1);
    const offsets = (0, $168a40e325c04e1b$export$a397704b5e280835)(0);
    if (isOffsetParentAnElement || !isOffsetParentAnElement && strategy !== "fixed") {
        if ((0, $e2c1d25bdd91a12d$export$651544f548703224)(offsetParent) !== "body" || (0, $e2c1d25bdd91a12d$export$989e911fa9af580a)(documentElement)) scroll = (0, $e2c1d25bdd91a12d$export$dc8fc79fa2800137)(offsetParent);
        if ((0, $e2c1d25bdd91a12d$export$1b3bfaa9684536aa)(offsetParent)) {
            const offsetRect = $985fd6054d85832a$var$getBoundingClientRect(offsetParent);
            scale = $985fd6054d85832a$var$getScale(offsetParent);
            offsets.x = offsetRect.x + offsetParent.clientLeft;
            offsets.y = offsetRect.y + offsetParent.clientTop;
        }
    }
    return {
        width: rect.width * scale.x,
        height: rect.height * scale.y,
        x: rect.x * scale.x - scroll.scrollLeft * scale.x + offsets.x,
        y: rect.y * scale.y - scroll.scrollTop * scale.y + offsets.y
    };
}
function $985fd6054d85832a$var$getClientRects(element) {
    return Array.from(element.getClientRects());
}
function $985fd6054d85832a$var$getWindowScrollBarX(element) {
    // If <html> has a CSS width greater than the viewport, then this will be
    // incorrect for RTL.
    return $985fd6054d85832a$var$getBoundingClientRect((0, $e2c1d25bdd91a12d$export$e495491855dc5418)(element)).left + (0, $e2c1d25bdd91a12d$export$dc8fc79fa2800137)(element).scrollLeft;
}
// Gets the entire size of the scrollable document area, even extending outside
// of the `<html>` and `<body>` rect bounds if horizontally scrollable.
function $985fd6054d85832a$var$getDocumentRect(element) {
    const html = (0, $e2c1d25bdd91a12d$export$e495491855dc5418)(element);
    const scroll = (0, $e2c1d25bdd91a12d$export$dc8fc79fa2800137)(element);
    const body = element.ownerDocument.body;
    const width = (0, $168a40e325c04e1b$export$8960430cfd85939f)(html.scrollWidth, html.clientWidth, body.scrollWidth, body.clientWidth);
    const height = (0, $168a40e325c04e1b$export$8960430cfd85939f)(html.scrollHeight, html.clientHeight, body.scrollHeight, body.clientHeight);
    let x = -scroll.scrollLeft + $985fd6054d85832a$var$getWindowScrollBarX(element);
    const y = -scroll.scrollTop;
    if ((0, $e2c1d25bdd91a12d$export$3735103072e4a80)(body).direction === "rtl") x += (0, $168a40e325c04e1b$export$8960430cfd85939f)(html.clientWidth, body.clientWidth) - width;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}
function $985fd6054d85832a$var$getViewportRect(element, strategy) {
    const win = (0, $e2c1d25bdd91a12d$export$38b2d434cce3ea22)(element);
    const html = (0, $e2c1d25bdd91a12d$export$e495491855dc5418)(element);
    const visualViewport = win.visualViewport;
    let width = html.clientWidth;
    let height = html.clientHeight;
    let x = 0;
    let y = 0;
    if (visualViewport) {
        width = visualViewport.width;
        height = visualViewport.height;
        const visualViewportBased = (0, $e2c1d25bdd91a12d$export$78551043582a6a98)();
        if (!visualViewportBased || visualViewportBased && strategy === "fixed") {
            x = visualViewport.offsetLeft;
            y = visualViewport.offsetTop;
        }
    }
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}
// Returns the inner client rect, subtracting scrollbars if present.
function $985fd6054d85832a$var$getInnerBoundingClientRect(element, strategy) {
    const clientRect = $985fd6054d85832a$var$getBoundingClientRect(element, true, strategy === "fixed");
    const top = clientRect.top + element.clientTop;
    const left = clientRect.left + element.clientLeft;
    const scale = (0, $e2c1d25bdd91a12d$export$1b3bfaa9684536aa)(element) ? $985fd6054d85832a$var$getScale(element) : (0, $168a40e325c04e1b$export$a397704b5e280835)(1);
    const width = element.clientWidth * scale.x;
    const height = element.clientHeight * scale.y;
    const x = left * scale.x;
    const y = top * scale.y;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}
function $985fd6054d85832a$var$getClientRectFromClippingAncestor(element, clippingAncestor, strategy) {
    let rect;
    if (clippingAncestor === "viewport") rect = $985fd6054d85832a$var$getViewportRect(element, strategy);
    else if (clippingAncestor === "document") rect = $985fd6054d85832a$var$getDocumentRect((0, $e2c1d25bdd91a12d$export$e495491855dc5418)(element));
    else if ((0, $e2c1d25bdd91a12d$export$45a5e7f76e0caa8d)(clippingAncestor)) rect = $985fd6054d85832a$var$getInnerBoundingClientRect(clippingAncestor, strategy);
    else {
        const visualOffsets = $985fd6054d85832a$var$getVisualOffsets(element);
        rect = {
            ...clippingAncestor,
            x: clippingAncestor.x - visualOffsets.x,
            y: clippingAncestor.y - visualOffsets.y
        };
    }
    return (0, $168a40e325c04e1b$export$ee05aea0aeecbad4)(rect);
}
function $985fd6054d85832a$var$hasFixedPositionAncestor(element, stopNode) {
    const parentNode = (0, $e2c1d25bdd91a12d$export$4e12058fc4d51d56)(element);
    if (parentNode === stopNode || !(0, $e2c1d25bdd91a12d$export$45a5e7f76e0caa8d)(parentNode) || (0, $e2c1d25bdd91a12d$export$d1162fb0b6d4cd51)(parentNode)) return false;
    return (0, $e2c1d25bdd91a12d$export$3735103072e4a80)(parentNode).position === "fixed" || $985fd6054d85832a$var$hasFixedPositionAncestor(parentNode, stopNode);
}
// A "clipping ancestor" is an `overflow` element with the characteristic of
// clipping (or hiding) child elements. This returns all clipping ancestors
// of the given element up the tree.
function $985fd6054d85832a$var$getClippingElementAncestors(element, cache) {
    const cachedResult = cache.get(element);
    if (cachedResult) return cachedResult;
    let result = (0, $e2c1d25bdd91a12d$export$3b57c1601291186b)(element).filter((el)=>(0, $e2c1d25bdd91a12d$export$45a5e7f76e0caa8d)(el) && (0, $e2c1d25bdd91a12d$export$651544f548703224)(el) !== "body");
    let currentContainingBlockComputedStyle = null;
    const elementIsFixed = (0, $e2c1d25bdd91a12d$export$3735103072e4a80)(element).position === "fixed";
    let currentNode = elementIsFixed ? (0, $e2c1d25bdd91a12d$export$4e12058fc4d51d56)(element) : element;
    // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
    while((0, $e2c1d25bdd91a12d$export$45a5e7f76e0caa8d)(currentNode) && !(0, $e2c1d25bdd91a12d$export$d1162fb0b6d4cd51)(currentNode)){
        const computedStyle = (0, $e2c1d25bdd91a12d$export$3735103072e4a80)(currentNode);
        const currentNodeIsContaining = (0, $e2c1d25bdd91a12d$export$d6c4e8150c35fed1)(currentNode);
        if (!currentNodeIsContaining && computedStyle.position === "fixed") currentContainingBlockComputedStyle = null;
        const shouldDropCurrentNode = elementIsFixed ? !currentNodeIsContaining && !currentContainingBlockComputedStyle : !currentNodeIsContaining && computedStyle.position === "static" && !!currentContainingBlockComputedStyle && [
            "absolute",
            "fixed"
        ].includes(currentContainingBlockComputedStyle.position) || (0, $e2c1d25bdd91a12d$export$989e911fa9af580a)(currentNode) && !currentNodeIsContaining && $985fd6054d85832a$var$hasFixedPositionAncestor(element, currentNode);
        if (shouldDropCurrentNode) // Drop non-containing blocks.
        result = result.filter((ancestor)=>ancestor !== currentNode);
        else // Record last containing block for next iteration.
        currentContainingBlockComputedStyle = computedStyle;
        currentNode = (0, $e2c1d25bdd91a12d$export$4e12058fc4d51d56)(currentNode);
    }
    cache.set(element, result);
    return result;
}
// Gets the maximum area that the element is visible in due to any number of
// clipping ancestors.
function $985fd6054d85832a$var$getClippingRect(_ref) {
    let { element: element, boundary: boundary, rootBoundary: rootBoundary, strategy: strategy } = _ref;
    const elementClippingAncestors = boundary === "clippingAncestors" ? $985fd6054d85832a$var$getClippingElementAncestors(element, this._c) : [].concat(boundary);
    const clippingAncestors = [
        ...elementClippingAncestors,
        rootBoundary
    ];
    const firstClippingAncestor = clippingAncestors[0];
    const clippingRect = clippingAncestors.reduce((accRect, clippingAncestor)=>{
        const rect = $985fd6054d85832a$var$getClientRectFromClippingAncestor(element, clippingAncestor, strategy);
        accRect.top = (0, $168a40e325c04e1b$export$8960430cfd85939f)(rect.top, accRect.top);
        accRect.right = (0, $168a40e325c04e1b$export$96ec731ed4dcb222)(rect.right, accRect.right);
        accRect.bottom = (0, $168a40e325c04e1b$export$96ec731ed4dcb222)(rect.bottom, accRect.bottom);
        accRect.left = (0, $168a40e325c04e1b$export$8960430cfd85939f)(rect.left, accRect.left);
        return accRect;
    }, $985fd6054d85832a$var$getClientRectFromClippingAncestor(element, firstClippingAncestor, strategy));
    return {
        width: clippingRect.right - clippingRect.left,
        height: clippingRect.bottom - clippingRect.top,
        x: clippingRect.left,
        y: clippingRect.top
    };
}
function $985fd6054d85832a$var$getDimensions(element) {
    return $985fd6054d85832a$var$getCssDimensions(element);
}
function $985fd6054d85832a$var$getRectRelativeToOffsetParent(element, offsetParent, strategy) {
    const isOffsetParentAnElement = (0, $e2c1d25bdd91a12d$export$1b3bfaa9684536aa)(offsetParent);
    const documentElement = (0, $e2c1d25bdd91a12d$export$e495491855dc5418)(offsetParent);
    const isFixed = strategy === "fixed";
    const rect = $985fd6054d85832a$var$getBoundingClientRect(element, true, isFixed, offsetParent);
    let scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    const offsets = (0, $168a40e325c04e1b$export$a397704b5e280835)(0);
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ((0, $e2c1d25bdd91a12d$export$651544f548703224)(offsetParent) !== "body" || (0, $e2c1d25bdd91a12d$export$989e911fa9af580a)(documentElement)) scroll = (0, $e2c1d25bdd91a12d$export$dc8fc79fa2800137)(offsetParent);
        if (isOffsetParentAnElement) {
            const offsetRect = $985fd6054d85832a$var$getBoundingClientRect(offsetParent, true, isFixed, offsetParent);
            offsets.x = offsetRect.x + offsetParent.clientLeft;
            offsets.y = offsetRect.y + offsetParent.clientTop;
        } else if (documentElement) offsets.x = $985fd6054d85832a$var$getWindowScrollBarX(documentElement);
    }
    return {
        x: rect.left + scroll.scrollLeft - offsets.x,
        y: rect.top + scroll.scrollTop - offsets.y,
        width: rect.width,
        height: rect.height
    };
}
function $985fd6054d85832a$var$getTrueOffsetParent(element, polyfill) {
    if (!(0, $e2c1d25bdd91a12d$export$1b3bfaa9684536aa)(element) || (0, $e2c1d25bdd91a12d$export$3735103072e4a80)(element).position === "fixed") return null;
    if (polyfill) return polyfill(element);
    return element.offsetParent;
}
// Gets the closest ancestor positioned element. Handles some edge cases,
// such as table ancestors and cross browser bugs.
function $985fd6054d85832a$var$getOffsetParent(element, polyfill) {
    const window = (0, $e2c1d25bdd91a12d$export$38b2d434cce3ea22)(element);
    if (!(0, $e2c1d25bdd91a12d$export$1b3bfaa9684536aa)(element)) return window;
    let offsetParent = $985fd6054d85832a$var$getTrueOffsetParent(element, polyfill);
    while(offsetParent && (0, $e2c1d25bdd91a12d$export$71535ffaa902797f)(offsetParent) && (0, $e2c1d25bdd91a12d$export$3735103072e4a80)(offsetParent).position === "static")offsetParent = $985fd6054d85832a$var$getTrueOffsetParent(offsetParent, polyfill);
    if (offsetParent && ((0, $e2c1d25bdd91a12d$export$651544f548703224)(offsetParent) === "html" || (0, $e2c1d25bdd91a12d$export$651544f548703224)(offsetParent) === "body" && (0, $e2c1d25bdd91a12d$export$3735103072e4a80)(offsetParent).position === "static" && !(0, $e2c1d25bdd91a12d$export$d6c4e8150c35fed1)(offsetParent))) return window;
    return offsetParent || (0, $e2c1d25bdd91a12d$export$940d8225183e1404)(element) || window;
}
const $985fd6054d85832a$var$getElementRects = async function(_ref) {
    let { reference: reference, floating: floating, strategy: strategy } = _ref;
    const getOffsetParentFn = this.getOffsetParent || $985fd6054d85832a$var$getOffsetParent;
    const getDimensionsFn = this.getDimensions;
    return {
        reference: $985fd6054d85832a$var$getRectRelativeToOffsetParent(reference, await getOffsetParentFn(floating), strategy),
        floating: {
            x: 0,
            y: 0,
            ...await getDimensionsFn(floating)
        }
    };
};
function $985fd6054d85832a$var$isRTL(element) {
    return (0, $e2c1d25bdd91a12d$export$3735103072e4a80)(element).direction === "rtl";
}
const $985fd6054d85832a$export$722a64dea1b767dc = {
    convertOffsetParentRelativeRectToViewportRelativeRect: $985fd6054d85832a$var$convertOffsetParentRelativeRectToViewportRelativeRect,
    getDocumentElement: $e2c1d25bdd91a12d$export$e495491855dc5418,
    getClippingRect: $985fd6054d85832a$var$getClippingRect,
    getOffsetParent: $985fd6054d85832a$var$getOffsetParent,
    getElementRects: $985fd6054d85832a$var$getElementRects,
    getClientRects: $985fd6054d85832a$var$getClientRects,
    getDimensions: $985fd6054d85832a$var$getDimensions,
    getScale: $985fd6054d85832a$var$getScale,
    isElement: $e2c1d25bdd91a12d$export$45a5e7f76e0caa8d,
    isRTL: $985fd6054d85832a$var$isRTL
};
// https://samthor.au/2021/observing-dom/
function $985fd6054d85832a$var$observeMove(element, onMove) {
    let io = null;
    let timeoutId;
    const root = (0, $e2c1d25bdd91a12d$export$e495491855dc5418)(element);
    function cleanup() {
        clearTimeout(timeoutId);
        io && io.disconnect();
        io = null;
    }
    function refresh(skip, threshold) {
        if (skip === void 0) skip = false;
        if (threshold === void 0) threshold = 1;
        cleanup();
        const { left: left, top: top, width: width, height: height } = element.getBoundingClientRect();
        if (!skip) onMove();
        if (!width || !height) return;
        const insetTop = (0, $168a40e325c04e1b$export$a3fe094919f356fd)(top);
        const insetRight = (0, $168a40e325c04e1b$export$a3fe094919f356fd)(root.clientWidth - (left + width));
        const insetBottom = (0, $168a40e325c04e1b$export$a3fe094919f356fd)(root.clientHeight - (top + height));
        const insetLeft = (0, $168a40e325c04e1b$export$a3fe094919f356fd)(left);
        const rootMargin = -insetTop + "px " + -insetRight + "px " + -insetBottom + "px " + -insetLeft + "px";
        const options = {
            rootMargin: rootMargin,
            threshold: (0, $168a40e325c04e1b$export$8960430cfd85939f)(0, (0, $168a40e325c04e1b$export$96ec731ed4dcb222)(1, threshold)) || 1
        };
        let isFirstUpdate = true;
        function handleObserve(entries) {
            const ratio = entries[0].intersectionRatio;
            if (ratio !== threshold) {
                if (!isFirstUpdate) return refresh();
                if (!ratio) timeoutId = setTimeout(()=>{
                    refresh(false, 1e-7);
                }, 100);
                else refresh(false, ratio);
            }
            isFirstUpdate = false;
        }
        // Older browsers don't support a `document` as the root and will throw an
        // error.
        try {
            io = new IntersectionObserver(handleObserve, {
                ...options,
                // Handle <iframe>s
                root: root.ownerDocument
            });
        } catch (e) {
            io = new IntersectionObserver(handleObserve, options);
        }
        io.observe(element);
    }
    refresh(true);
    return cleanup;
}
/**
 * Automatically updates the position of the floating element when necessary.
 * Should only be called when the floating element is mounted on the DOM or
 * visible on the screen.
 * @returns cleanup function that should be invoked when the floating element is
 * removed from the DOM or hidden from the screen.
 * @see https://floating-ui.com/docs/autoUpdate
 */ function $985fd6054d85832a$export$deee3a793edee05f(reference, floating, update, options) {
    if (options === void 0) options = {};
    const { ancestorScroll: ancestorScroll = true, ancestorResize: ancestorResize = true, elementResize: elementResize = typeof ResizeObserver === "function", layoutShift: layoutShift = typeof IntersectionObserver === "function", animationFrame: animationFrame = false } = options;
    const referenceEl = $985fd6054d85832a$var$unwrapElement(reference);
    const ancestors = ancestorScroll || ancestorResize ? [
        ...referenceEl ? (0, $e2c1d25bdd91a12d$export$3b57c1601291186b)(referenceEl) : [],
        ...(0, $e2c1d25bdd91a12d$export$3b57c1601291186b)(floating)
    ] : [];
    ancestors.forEach((ancestor)=>{
        ancestorScroll && ancestor.addEventListener("scroll", update, {
            passive: true
        });
        ancestorResize && ancestor.addEventListener("resize", update);
    });
    const cleanupIo = referenceEl && layoutShift ? $985fd6054d85832a$var$observeMove(referenceEl, update) : null;
    let reobserveFrame = -1;
    let resizeObserver = null;
    if (elementResize) {
        resizeObserver = new ResizeObserver((_ref)=>{
            let [firstEntry] = _ref;
            if (firstEntry && firstEntry.target === referenceEl && resizeObserver) {
                // Prevent update loops when using the `size` middleware.
                // https://github.com/floating-ui/floating-ui/issues/1740
                resizeObserver.unobserve(floating);
                cancelAnimationFrame(reobserveFrame);
                reobserveFrame = requestAnimationFrame(()=>{
                    resizeObserver && resizeObserver.observe(floating);
                });
            }
            update();
        });
        if (referenceEl && !animationFrame) resizeObserver.observe(referenceEl);
        resizeObserver.observe(floating);
    }
    let frameId;
    let prevRefRect = animationFrame ? $985fd6054d85832a$var$getBoundingClientRect(reference) : null;
    if (animationFrame) frameLoop();
    function frameLoop() {
        const nextRefRect = $985fd6054d85832a$var$getBoundingClientRect(reference);
        if (prevRefRect && (nextRefRect.x !== prevRefRect.x || nextRefRect.y !== prevRefRect.y || nextRefRect.width !== prevRefRect.width || nextRefRect.height !== prevRefRect.height)) update();
        prevRefRect = nextRefRect;
        frameId = requestAnimationFrame(frameLoop);
    }
    update();
    return ()=>{
        ancestors.forEach((ancestor)=>{
            ancestorScroll && ancestor.removeEventListener("scroll", update);
            ancestorResize && ancestor.removeEventListener("resize", update);
        });
        cleanupIo && cleanupIo();
        resizeObserver && resizeObserver.disconnect();
        resizeObserver = null;
        if (animationFrame) cancelAnimationFrame(frameId);
    };
}
/**
 * Computes the `x` and `y` coordinates that will place the floating element
 * next to a reference element when it is given a certain CSS positioning
 * strategy.
 */ const $985fd6054d85832a$export$48a53dcb22e581d0 = (reference, floating, options)=>{
    // This caches the expensive `getClippingElementAncestors` function so that
    // multiple lifecycle resets re-use the same result. It only lives for a
    // single call. If other functions become expensive, we can add them as well.
    const cache = new Map();
    const mergedOptions = {
        platform: $985fd6054d85832a$export$722a64dea1b767dc,
        ...options
    };
    const platformWithCache = {
        ...mergedOptions.platform,
        _c: cache
    };
    return (0, $926256944d3cd62f$export$48a53dcb22e581d0)(reference, floating, {
        ...mergedOptions,
        platform: platformWithCache
    });
};



var $bh6RR = parcelRequire("bh6RR");

/**
 * Provides data to position an inner element of the floating element so that it
 * appears centered to the reference element.
 * This wraps the core `arrow` middleware to allow React refs as the element.
 * @see https://floating-ui.com/docs/arrow
 */ const $f0eb2bc09271deae$export$f2120bbfa5450bd2 = (options)=>{
    function isRef(value) {
        return ({}).hasOwnProperty.call(value, "current");
    }
    return {
        name: "arrow",
        options: options,
        fn (state) {
            const { element: element, padding: padding } = typeof options === "function" ? options(state) : options;
            if (element && isRef(element)) {
                if (element.current != null) return (0, $926256944d3cd62f$export$f2120bbfa5450bd2)({
                    element: element.current,
                    padding: padding
                }).fn(state);
                return {};
            } else if (element) return (0, $926256944d3cd62f$export$f2120bbfa5450bd2)({
                element: element,
                padding: padding
            }).fn(state);
            return {};
        }
    };
};
var $f0eb2bc09271deae$var$index = typeof document !== "undefined" ? (0, $bh6RR.useLayoutEffect) : (0, $bh6RR.useEffect);
// Fork of `fast-deep-equal` that only does the comparisons we need and compares
// functions
function $f0eb2bc09271deae$var$deepEqual(a, b) {
    if (a === b) return true;
    if (typeof a !== typeof b) return false;
    if (typeof a === "function" && a.toString() === b.toString()) return true;
    let length, i, keys;
    if (a && b && typeof a == "object") {
        if (Array.isArray(a)) {
            length = a.length;
            if (length != b.length) return false;
            for(i = length; i-- !== 0;){
                if (!$f0eb2bc09271deae$var$deepEqual(a[i], b[i])) return false;
            }
            return true;
        }
        keys = Object.keys(a);
        length = keys.length;
        if (length !== Object.keys(b).length) return false;
        for(i = length; i-- !== 0;){
            if (!({}).hasOwnProperty.call(b, keys[i])) return false;
        }
        for(i = length; i-- !== 0;){
            const key = keys[i];
            if (key === "_owner" && a.$$typeof) continue;
            if (!$f0eb2bc09271deae$var$deepEqual(a[key], b[key])) return false;
        }
        return true;
    }
    return a !== a && b !== b;
}
function $f0eb2bc09271deae$var$getDPR(element) {
    if (typeof window === "undefined") return 1;
    const win = element.ownerDocument.defaultView || window;
    return win.devicePixelRatio || 1;
}
function $f0eb2bc09271deae$var$roundByDPR(element, value) {
    const dpr = $f0eb2bc09271deae$var$getDPR(element);
    return Math.round(value * dpr) / dpr;
}
function $f0eb2bc09271deae$var$useLatestRef(value) {
    const ref = $bh6RR.useRef(value);
    $f0eb2bc09271deae$var$index(()=>{
        ref.current = value;
    });
    return ref;
}
/**
 * Provides data to position a floating element.
 * @see https://floating-ui.com/docs/react
 */ function $f0eb2bc09271deae$export$4e02a5c1d08bac65(options) {
    if (options === void 0) options = {};
    const { placement: placement = "bottom", strategy: strategy = "absolute", middleware: middleware = [], platform: platform, elements: { reference: externalReference, floating: externalFloating } = {}, transform: transform = true, whileElementsMounted: whileElementsMounted, open: open } = options;
    const [data, setData] = $bh6RR.useState({
        x: 0,
        y: 0,
        strategy: strategy,
        placement: placement,
        middlewareData: {},
        isPositioned: false
    });
    const [latestMiddleware, setLatestMiddleware] = $bh6RR.useState(middleware);
    if (!$f0eb2bc09271deae$var$deepEqual(latestMiddleware, middleware)) setLatestMiddleware(middleware);
    const [_reference, _setReference] = $bh6RR.useState(null);
    const [_floating, _setFloating] = $bh6RR.useState(null);
    const setReference = $bh6RR.useCallback((node)=>{
        if (node != referenceRef.current) {
            referenceRef.current = node;
            _setReference(node);
        }
    }, [
        _setReference
    ]);
    const setFloating = $bh6RR.useCallback((node)=>{
        if (node !== floatingRef.current) {
            floatingRef.current = node;
            _setFloating(node);
        }
    }, [
        _setFloating
    ]);
    const referenceEl = externalReference || _reference;
    const floatingEl = externalFloating || _floating;
    const referenceRef = $bh6RR.useRef(null);
    const floatingRef = $bh6RR.useRef(null);
    const dataRef = $bh6RR.useRef(data);
    const whileElementsMountedRef = $f0eb2bc09271deae$var$useLatestRef(whileElementsMounted);
    const platformRef = $f0eb2bc09271deae$var$useLatestRef(platform);
    const update = $bh6RR.useCallback(()=>{
        if (!referenceRef.current || !floatingRef.current) return;
        const config = {
            placement: placement,
            strategy: strategy,
            middleware: latestMiddleware
        };
        if (platformRef.current) config.platform = platformRef.current;
        (0, $985fd6054d85832a$export$48a53dcb22e581d0)(referenceRef.current, floatingRef.current, config).then((data)=>{
            const fullData = {
                ...data,
                isPositioned: true
            };
            if (isMountedRef.current && !$f0eb2bc09271deae$var$deepEqual(dataRef.current, fullData)) {
                dataRef.current = fullData;
                $47cfd4084854a574$exports.flushSync(()=>{
                    setData(fullData);
                });
            }
        });
    }, [
        latestMiddleware,
        placement,
        strategy,
        platformRef
    ]);
    $f0eb2bc09271deae$var$index(()=>{
        if (open === false && dataRef.current.isPositioned) {
            dataRef.current.isPositioned = false;
            setData((data)=>({
                    ...data,
                    isPositioned: false
                }));
        }
    }, [
        open
    ]);
    const isMountedRef = $bh6RR.useRef(false);
    $f0eb2bc09271deae$var$index(()=>{
        isMountedRef.current = true;
        return ()=>{
            isMountedRef.current = false;
        };
    }, []);
    $f0eb2bc09271deae$var$index(()=>{
        if (referenceEl) referenceRef.current = referenceEl;
        if (floatingEl) floatingRef.current = floatingEl;
        if (referenceEl && floatingEl) {
            if (whileElementsMountedRef.current) return whileElementsMountedRef.current(referenceEl, floatingEl, update);
            else update();
        }
    }, [
        referenceEl,
        floatingEl,
        update,
        whileElementsMountedRef
    ]);
    const refs = $bh6RR.useMemo(()=>({
            reference: referenceRef,
            floating: floatingRef,
            setReference: setReference,
            setFloating: setFloating
        }), [
        setReference,
        setFloating
    ]);
    const elements = $bh6RR.useMemo(()=>({
            reference: referenceEl,
            floating: floatingEl
        }), [
        referenceEl,
        floatingEl
    ]);
    const floatingStyles = $bh6RR.useMemo(()=>{
        const initialStyles = {
            position: strategy,
            left: 0,
            top: 0
        };
        if (!elements.floating) return initialStyles;
        const x = $f0eb2bc09271deae$var$roundByDPR(elements.floating, data.x);
        const y = $f0eb2bc09271deae$var$roundByDPR(elements.floating, data.y);
        if (transform) return {
            ...initialStyles,
            transform: "translate(" + x + "px, " + y + "px)",
            ...$f0eb2bc09271deae$var$getDPR(elements.floating) >= 1.5 && {
                willChange: "transform"
            }
        };
        return {
            position: strategy,
            left: x,
            top: y
        };
    }, [
        strategy,
        transform,
        elements.floating,
        data.x,
        data.y
    ]);
    return $bh6RR.useMemo(()=>({
            ...data,
            update: update,
            refs: refs,
            elements: elements,
            floatingStyles: floatingStyles
        }), [
        data,
        update,
        refs,
        elements,
        floatingStyles
    ]);
}




var $bh6RR = parcelRequire("bh6RR");

/* -------------------------------------------------------------------------------------------------
 * Arrow
 * -----------------------------------------------------------------------------------------------*/ const $0cab61c36b921768$var$$7e8f5cd07187803e$var$NAME = "Arrow";
const $0cab61c36b921768$export$21b07c8f274aebd5 = /*#__PURE__*/ (0, $bh6RR.forwardRef)((props, forwardedRef)=>{
    const { children: children, width: width = 10, height: height = 5, ...arrowProps } = props;
    return /*#__PURE__*/ (0, $bh6RR.createElement)((0, $793b1a0f4d9647b1$export$250ffa63cdc0d034).svg, (0, $39ab41060f0dd572$export$2e2bcd8739ae039)({}, arrowProps, {
        ref: forwardedRef,
        width: width,
        height: height,
        viewBox: "0 0 30 10",
        preserveAspectRatio: "none"
    }), props.asChild ? children : /*#__PURE__*/ (0, $bh6RR.createElement)("polygon", {
        points: "0,0 30,0 15,10"
    }));
});
/*#__PURE__*/ Object.assign($0cab61c36b921768$export$21b07c8f274aebd5, {
    displayName: $0cab61c36b921768$var$$7e8f5cd07187803e$var$NAME
});
/* -----------------------------------------------------------------------------------------------*/ const $0cab61c36b921768$export$be92b6f5f03c0fe9 = $0cab61c36b921768$export$21b07c8f274aebd5;








var $bh6RR = parcelRequire("bh6RR");

function $3193bf9be93d584d$export$1ab7ae714698c4b8(element) {
    const [size, setSize] = (0, $bh6RR.useState)(undefined);
    (0, $8b7ab17803b8e6f8$export$e5c5a5f917a5871c)(()=>{
        if (element) {
            // provide size as early as possible
            setSize({
                width: element.offsetWidth,
                height: element.offsetHeight
            });
            const resizeObserver = new ResizeObserver((entries)=>{
                if (!Array.isArray(entries)) return;
                // Since we only observe the one element, we don't need to loop over the
                // array
                if (!entries.length) return;
                const entry = entries[0];
                let width;
                let height;
                if ("borderBoxSize" in entry) {
                    const borderSizeEntry = entry["borderBoxSize"]; // iron out differences between browsers
                    const borderSize = Array.isArray(borderSizeEntry) ? borderSizeEntry[0] : borderSizeEntry;
                    width = borderSize["inlineSize"];
                    height = borderSize["blockSize"];
                } else {
                    // for browsers that don't support `borderBoxSize`
                    // we calculate it ourselves to get the correct border box.
                    width = element.offsetWidth;
                    height = element.offsetHeight;
                }
                setSize({
                    width: width,
                    height: height
                });
            });
            resizeObserver.observe(element, {
                box: "border-box"
            });
            return ()=>resizeObserver.unobserve(element);
        } else // not if it changes to another element.
        setSize(undefined);
    }, [
        element
    ]);
    return size;
}


const $b539e51fb424541d$export$36f0086da09c4b9f = [
    "top",
    "right",
    "bottom",
    "left"
];
const $b539e51fb424541d$export$3671ffab7b302fc9 = [
    "start",
    "center",
    "end"
];
/* -------------------------------------------------------------------------------------------------
 * Popper
 * -----------------------------------------------------------------------------------------------*/ const $b539e51fb424541d$var$$cf1ac5d9fe0e8206$var$POPPER_NAME = "Popper";
const [$b539e51fb424541d$var$$cf1ac5d9fe0e8206$var$createPopperContext, $b539e51fb424541d$export$722aac194ae923] = (0, $1cecd1d75f085228$export$50c7b4e9d9f19c1)($b539e51fb424541d$var$$cf1ac5d9fe0e8206$var$POPPER_NAME);
const [$b539e51fb424541d$var$$cf1ac5d9fe0e8206$var$PopperProvider, $b539e51fb424541d$var$$cf1ac5d9fe0e8206$var$usePopperContext] = $b539e51fb424541d$var$$cf1ac5d9fe0e8206$var$createPopperContext($b539e51fb424541d$var$$cf1ac5d9fe0e8206$var$POPPER_NAME);
const $b539e51fb424541d$export$badac9ada3a0bdf9 = (props)=>{
    const { __scopePopper: __scopePopper, children: children } = props;
    const [anchor, setAnchor] = (0, $bh6RR.useState)(null);
    return /*#__PURE__*/ (0, $bh6RR.createElement)($b539e51fb424541d$var$$cf1ac5d9fe0e8206$var$PopperProvider, {
        scope: __scopePopper,
        anchor: anchor,
        onAnchorChange: setAnchor
    }, children);
};
/*#__PURE__*/ Object.assign($b539e51fb424541d$export$badac9ada3a0bdf9, {
    displayName: $b539e51fb424541d$var$$cf1ac5d9fe0e8206$var$POPPER_NAME
});
/* -------------------------------------------------------------------------------------------------
 * PopperAnchor
 * -----------------------------------------------------------------------------------------------*/ const $b539e51fb424541d$var$$cf1ac5d9fe0e8206$var$ANCHOR_NAME = "PopperAnchor";
const $b539e51fb424541d$export$ecd4e1ccab6ed6d = /*#__PURE__*/ (0, $bh6RR.forwardRef)((props, forwardedRef)=>{
    const { __scopePopper: __scopePopper, virtualRef: virtualRef, ...anchorProps } = props;
    const context = $b539e51fb424541d$var$$cf1ac5d9fe0e8206$var$usePopperContext($b539e51fb424541d$var$$cf1ac5d9fe0e8206$var$ANCHOR_NAME, __scopePopper);
    const ref = (0, $bh6RR.useRef)(null);
    const composedRefs = (0, $e52f713866128e60$export$c7b2cbe3552a0d05)(forwardedRef, ref);
    (0, $bh6RR.useEffect)(()=>{
        // Consumer can anchor the popper to something that isn't
        // a DOM node e.g. pointer position, so we override the
        // `anchorRef` with their virtual ref in this case.
        context.onAnchorChange((virtualRef === null || virtualRef === void 0 ? void 0 : virtualRef.current) || ref.current);
    });
    return virtualRef ? null : /*#__PURE__*/ (0, $bh6RR.createElement)((0, $793b1a0f4d9647b1$export$250ffa63cdc0d034).div, (0, $39ab41060f0dd572$export$2e2bcd8739ae039)({}, anchorProps, {
        ref: composedRefs
    }));
});
/*#__PURE__*/ Object.assign($b539e51fb424541d$export$ecd4e1ccab6ed6d, {
    displayName: $b539e51fb424541d$var$$cf1ac5d9fe0e8206$var$ANCHOR_NAME
});
/* -------------------------------------------------------------------------------------------------
 * PopperContent
 * -----------------------------------------------------------------------------------------------*/ const $b539e51fb424541d$var$$cf1ac5d9fe0e8206$var$CONTENT_NAME = "PopperContent";
const [$b539e51fb424541d$var$$cf1ac5d9fe0e8206$var$PopperContentProvider, $b539e51fb424541d$var$$cf1ac5d9fe0e8206$var$useContentContext] = $b539e51fb424541d$var$$cf1ac5d9fe0e8206$var$createPopperContext($b539e51fb424541d$var$$cf1ac5d9fe0e8206$var$CONTENT_NAME);
const $b539e51fb424541d$export$bc4ae5855d3c4fc = /*#__PURE__*/ (0, $bh6RR.forwardRef)((props, forwardedRef)=>{
    var _arrowSize$width, _arrowSize$height, _middlewareData$arrow, _middlewareData$arrow2, _middlewareData$arrow3, _middlewareData$trans, _middlewareData$trans2, _middlewareData$hide;
    const { __scopePopper: __scopePopper, side: side = "bottom", sideOffset: sideOffset = 0, align: align = "center", alignOffset: alignOffset = 0, arrowPadding: arrowPadding = 0, collisionBoundary: collisionBoundary = [], collisionPadding: collisionPaddingProp = 0, sticky: sticky = "partial", hideWhenDetached: hideWhenDetached = false, avoidCollisions: avoidCollisions = true, onPlaced: onPlaced, ...contentProps } = props;
    const context = $b539e51fb424541d$var$$cf1ac5d9fe0e8206$var$usePopperContext($b539e51fb424541d$var$$cf1ac5d9fe0e8206$var$CONTENT_NAME, __scopePopper);
    const [content, setContent] = (0, $bh6RR.useState)(null);
    const composedRefs = (0, $e52f713866128e60$export$c7b2cbe3552a0d05)(forwardedRef, (node)=>setContent(node));
    const [arrow, setArrow] = (0, $bh6RR.useState)(null);
    const arrowSize = (0, $3193bf9be93d584d$export$1ab7ae714698c4b8)(arrow);
    const arrowWidth = (_arrowSize$width = arrowSize === null || arrowSize === void 0 ? void 0 : arrowSize.width) !== null && _arrowSize$width !== void 0 ? _arrowSize$width : 0;
    const arrowHeight = (_arrowSize$height = arrowSize === null || arrowSize === void 0 ? void 0 : arrowSize.height) !== null && _arrowSize$height !== void 0 ? _arrowSize$height : 0;
    const desiredPlacement = side + (align !== "center" ? "-" + align : "");
    const collisionPadding = typeof collisionPaddingProp === "number" ? collisionPaddingProp : {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0,
        ...collisionPaddingProp
    };
    const boundary = Array.isArray(collisionBoundary) ? collisionBoundary : [
        collisionBoundary
    ];
    const hasExplicitBoundaries = boundary.length > 0;
    const detectOverflowOptions = {
        padding: collisionPadding,
        boundary: boundary.filter($b539e51fb424541d$var$$cf1ac5d9fe0e8206$var$isNotNull),
        // with `strategy: 'fixed'`, this is the only way to get it to respect boundaries
        altBoundary: hasExplicitBoundaries
    };
    const { refs: refs, floatingStyles: floatingStyles, placement: placement, isPositioned: isPositioned, middlewareData: middlewareData } = (0, $f0eb2bc09271deae$export$4e02a5c1d08bac65)({
        // default to `fixed` strategy so users don't have to pick and we also avoid focus scroll issues
        strategy: "fixed",
        placement: desiredPlacement,
        whileElementsMounted: (0, $985fd6054d85832a$export$deee3a793edee05f),
        elements: {
            reference: context.anchor
        },
        middleware: [
            (0, $926256944d3cd62f$export$cc800923e997bb8)({
                mainAxis: sideOffset + arrowHeight,
                alignmentAxis: alignOffset
            }),
            avoidCollisions && (0, $926256944d3cd62f$export$fba63a578e423eb)({
                mainAxis: true,
                crossAxis: false,
                limiter: sticky === "partial" ? (0, $926256944d3cd62f$export$7bf07e38f3dc4b69)() : undefined,
                ...detectOverflowOptions
            }),
            avoidCollisions && (0, $926256944d3cd62f$export$8a83211c878a3f1f)({
                ...detectOverflowOptions
            }),
            (0, $926256944d3cd62f$export$346677f925de839c)({
                ...detectOverflowOptions,
                apply: ({ elements: elements, rects: rects, availableWidth: availableWidth, availableHeight: availableHeight })=>{
                    const { width: anchorWidth, height: anchorHeight } = rects.reference;
                    const contentStyle = elements.floating.style;
                    contentStyle.setProperty("--radix-popper-available-width", `${availableWidth}px`);
                    contentStyle.setProperty("--radix-popper-available-height", `${availableHeight}px`);
                    contentStyle.setProperty("--radix-popper-anchor-width", `${anchorWidth}px`);
                    contentStyle.setProperty("--radix-popper-anchor-height", `${anchorHeight}px`);
                }
            }),
            arrow && (0, $f0eb2bc09271deae$export$f2120bbfa5450bd2)({
                element: arrow,
                padding: arrowPadding
            }),
            $b539e51fb424541d$var$$cf1ac5d9fe0e8206$var$transformOrigin({
                arrowWidth: arrowWidth,
                arrowHeight: arrowHeight
            }),
            hideWhenDetached && (0, $926256944d3cd62f$export$fe8985bb6374093c)({
                strategy: "referenceHidden"
            })
        ]
    });
    const [placedSide, placedAlign] = $b539e51fb424541d$var$$cf1ac5d9fe0e8206$var$getSideAndAlignFromPlacement(placement);
    const handlePlaced = (0, $c901973c35f9b07b$export$25bec8c6f54ee79a)(onPlaced);
    (0, $8b7ab17803b8e6f8$export$e5c5a5f917a5871c)(()=>{
        if (isPositioned) handlePlaced === null || handlePlaced === void 0 || handlePlaced();
    }, [
        isPositioned,
        handlePlaced
    ]);
    const arrowX = (_middlewareData$arrow = middlewareData.arrow) === null || _middlewareData$arrow === void 0 ? void 0 : _middlewareData$arrow.x;
    const arrowY = (_middlewareData$arrow2 = middlewareData.arrow) === null || _middlewareData$arrow2 === void 0 ? void 0 : _middlewareData$arrow2.y;
    const cannotCenterArrow = ((_middlewareData$arrow3 = middlewareData.arrow) === null || _middlewareData$arrow3 === void 0 ? void 0 : _middlewareData$arrow3.centerOffset) !== 0;
    const [contentZIndex, setContentZIndex] = (0, $bh6RR.useState)();
    (0, $8b7ab17803b8e6f8$export$e5c5a5f917a5871c)(()=>{
        if (content) setContentZIndex(window.getComputedStyle(content).zIndex);
    }, [
        content
    ]);
    return /*#__PURE__*/ (0, $bh6RR.createElement)("div", {
        ref: refs.setFloating,
        "data-radix-popper-content-wrapper": "",
        style: {
            ...floatingStyles,
            transform: isPositioned ? floatingStyles.transform : "translate(0, -200%)",
            // keep off the page when measuring
            minWidth: "max-content",
            zIndex: contentZIndex,
            ["--radix-popper-transform-origin"]: [
                (_middlewareData$trans = middlewareData.transformOrigin) === null || _middlewareData$trans === void 0 ? void 0 : _middlewareData$trans.x,
                (_middlewareData$trans2 = middlewareData.transformOrigin) === null || _middlewareData$trans2 === void 0 ? void 0 : _middlewareData$trans2.y
            ].join(" ")
        } // Floating UI interally calculates logical alignment based the `dir` attribute on
        ,
        dir: props.dir
    }, /*#__PURE__*/ (0, $bh6RR.createElement)($b539e51fb424541d$var$$cf1ac5d9fe0e8206$var$PopperContentProvider, {
        scope: __scopePopper,
        placedSide: placedSide,
        onArrowChange: setArrow,
        arrowX: arrowX,
        arrowY: arrowY,
        shouldHideArrow: cannotCenterArrow
    }, /*#__PURE__*/ (0, $bh6RR.createElement)((0, $793b1a0f4d9647b1$export$250ffa63cdc0d034).div, (0, $39ab41060f0dd572$export$2e2bcd8739ae039)({
        "data-side": placedSide,
        "data-align": placedAlign
    }, contentProps, {
        ref: composedRefs,
        style: {
            ...contentProps.style,
            // if the PopperContent hasn't been placed yet (not all measurements done)
            // we prevent animations so that users's animation don't kick in too early referring wrong sides
            animation: !isPositioned ? "none" : undefined,
            // hide the content if using the hide middleware and should be hidden
            opacity: (_middlewareData$hide = middlewareData.hide) !== null && _middlewareData$hide !== void 0 && _middlewareData$hide.referenceHidden ? 0 : undefined
        }
    }))));
});
/*#__PURE__*/ Object.assign($b539e51fb424541d$export$bc4ae5855d3c4fc, {
    displayName: $b539e51fb424541d$var$$cf1ac5d9fe0e8206$var$CONTENT_NAME
});
/* -------------------------------------------------------------------------------------------------
 * PopperArrow
 * -----------------------------------------------------------------------------------------------*/ const $b539e51fb424541d$var$$cf1ac5d9fe0e8206$var$ARROW_NAME = "PopperArrow";
const $b539e51fb424541d$var$$cf1ac5d9fe0e8206$var$OPPOSITE_SIDE = {
    top: "bottom",
    right: "left",
    bottom: "top",
    left: "right"
};
const $b539e51fb424541d$export$79d62cd4e10a3fd0 = /*#__PURE__*/ (0, $bh6RR.forwardRef)(function $cf1ac5d9fe0e8206$export$79d62cd4e10a3fd0(props, forwardedRef) {
    const { __scopePopper: __scopePopper, ...arrowProps } = props;
    const contentContext = $b539e51fb424541d$var$$cf1ac5d9fe0e8206$var$useContentContext($b539e51fb424541d$var$$cf1ac5d9fe0e8206$var$ARROW_NAME, __scopePopper);
    const baseSide = $b539e51fb424541d$var$$cf1ac5d9fe0e8206$var$OPPOSITE_SIDE[contentContext.placedSide];
    return(/*#__PURE__*/ // doesn't report size as we'd expect on SVG elements.
    // it reports their bounding box which is effectively the largest path inside the SVG.
    (0, $bh6RR.createElement)("span", {
        ref: contentContext.onArrowChange,
        style: {
            position: "absolute",
            left: contentContext.arrowX,
            top: contentContext.arrowY,
            [baseSide]: 0,
            transformOrigin: {
                top: "",
                right: "0 0",
                bottom: "center 0",
                left: "100% 0"
            }[contentContext.placedSide],
            transform: {
                top: "translateY(100%)",
                right: "translateY(50%) rotate(90deg) translateX(-50%)",
                bottom: `rotate(180deg)`,
                left: "translateY(50%) rotate(-90deg) translateX(50%)"
            }[contentContext.placedSide],
            visibility: contentContext.shouldHideArrow ? "hidden" : undefined
        }
    }, /*#__PURE__*/ (0, $bh6RR.createElement)((0, $0cab61c36b921768$export$be92b6f5f03c0fe9), (0, $39ab41060f0dd572$export$2e2bcd8739ae039)({}, arrowProps, {
        ref: forwardedRef,
        style: {
            ...arrowProps.style,
            // ensures the element can be measured correctly (mostly for if SVG)
            display: "block"
        }
    }))));
});
/*#__PURE__*/ Object.assign($b539e51fb424541d$export$79d62cd4e10a3fd0, {
    displayName: $b539e51fb424541d$var$$cf1ac5d9fe0e8206$var$ARROW_NAME
});
/* -----------------------------------------------------------------------------------------------*/ function $b539e51fb424541d$var$$cf1ac5d9fe0e8206$var$isNotNull(value) {
    return value !== null;
}
const $b539e51fb424541d$var$$cf1ac5d9fe0e8206$var$transformOrigin = (options)=>({
        name: "transformOrigin",
        options: options,
        fn (data) {
            var _middlewareData$arrow4, _middlewareData$arrow5, _middlewareData$arrow6, _middlewareData$arrow7, _middlewareData$arrow8;
            const { placement: placement, rects: rects, middlewareData: middlewareData } = data;
            const cannotCenterArrow = ((_middlewareData$arrow4 = middlewareData.arrow) === null || _middlewareData$arrow4 === void 0 ? void 0 : _middlewareData$arrow4.centerOffset) !== 0;
            const isArrowHidden = cannotCenterArrow;
            const arrowWidth = isArrowHidden ? 0 : options.arrowWidth;
            const arrowHeight = isArrowHidden ? 0 : options.arrowHeight;
            const [placedSide, placedAlign] = $b539e51fb424541d$var$$cf1ac5d9fe0e8206$var$getSideAndAlignFromPlacement(placement);
            const noArrowAlign = {
                start: "0%",
                center: "50%",
                end: "100%"
            }[placedAlign];
            const arrowXCenter = ((_middlewareData$arrow5 = (_middlewareData$arrow6 = middlewareData.arrow) === null || _middlewareData$arrow6 === void 0 ? void 0 : _middlewareData$arrow6.x) !== null && _middlewareData$arrow5 !== void 0 ? _middlewareData$arrow5 : 0) + arrowWidth / 2;
            const arrowYCenter = ((_middlewareData$arrow7 = (_middlewareData$arrow8 = middlewareData.arrow) === null || _middlewareData$arrow8 === void 0 ? void 0 : _middlewareData$arrow8.y) !== null && _middlewareData$arrow7 !== void 0 ? _middlewareData$arrow7 : 0) + arrowHeight / 2;
            let x = "";
            let y = "";
            if (placedSide === "bottom") {
                x = isArrowHidden ? noArrowAlign : `${arrowXCenter}px`;
                y = `${-arrowHeight}px`;
            } else if (placedSide === "top") {
                x = isArrowHidden ? noArrowAlign : `${arrowXCenter}px`;
                y = `${rects.floating.height + arrowHeight}px`;
            } else if (placedSide === "right") {
                x = `${-arrowHeight}px`;
                y = isArrowHidden ? noArrowAlign : `${arrowYCenter}px`;
            } else if (placedSide === "left") {
                x = `${rects.floating.width + arrowHeight}px`;
                y = isArrowHidden ? noArrowAlign : `${arrowYCenter}px`;
            }
            return {
                data: {
                    x: x,
                    y: y
                }
            };
        }
    });
function $b539e51fb424541d$var$$cf1ac5d9fe0e8206$var$getSideAndAlignFromPlacement(placement) {
    const [side, align = "center"] = placement.split("-");
    return [
        side,
        align
    ];
}
const $b539e51fb424541d$export$be92b6f5f03c0fe9 = $b539e51fb424541d$export$badac9ada3a0bdf9;
const $b539e51fb424541d$export$b688253958b8dfe7 = $b539e51fb424541d$export$ecd4e1ccab6ed6d;
const $b539e51fb424541d$export$7c6e2c02157bb7d2 = $b539e51fb424541d$export$bc4ae5855d3c4fc;
const $b539e51fb424541d$export$21b07c8f274aebd5 = $b539e51fb424541d$export$79d62cd4e10a3fd0;




var $bh6RR = parcelRequire("bh6RR");


/* -------------------------------------------------------------------------------------------------
 * Portal
 * -----------------------------------------------------------------------------------------------*/ const $252b3d40eb00b07a$var$$f1701beae083dbae$var$PORTAL_NAME = "Portal";
const $252b3d40eb00b07a$export$602eac185826482c = /*#__PURE__*/ (0, $bh6RR.forwardRef)((props, forwardedRef)=>{
    var _globalThis$document;
    const { container: container = globalThis === null || globalThis === void 0 ? void 0 : (_globalThis$document = globalThis.document) === null || _globalThis$document === void 0 ? void 0 : _globalThis$document.body, ...portalProps } = props;
    return container ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($47cfd4084854a574$exports))).createPortal(/*#__PURE__*/ (0, $bh6RR.createElement)((0, $793b1a0f4d9647b1$export$250ffa63cdc0d034).div, (0, $39ab41060f0dd572$export$2e2bcd8739ae039)({}, portalProps, {
        ref: forwardedRef
    })), container) : null;
});
/*#__PURE__*/ Object.assign($252b3d40eb00b07a$export$602eac185826482c, {
    displayName: $252b3d40eb00b07a$var$$f1701beae083dbae$var$PORTAL_NAME
});
/* -----------------------------------------------------------------------------------------------*/ const $252b3d40eb00b07a$export$be92b6f5f03c0fe9 = $252b3d40eb00b07a$export$602eac185826482c;



var $bh6RR = parcelRequire("bh6RR");



function $e651d1dc516f7371$var$$fe963b355347cc68$export$3e6543de14f8614f(initialState, machine) {
    return (0, $bh6RR.useReducer)((state, event)=>{
        const nextState = machine[state][event];
        return nextState !== null && nextState !== void 0 ? nextState : state;
    }, initialState);
}
const $e651d1dc516f7371$export$99c2b779aa4e8b8b = (props)=>{
    const { present: present, children: children } = props;
    const presence = $e651d1dc516f7371$var$$921a889cee6df7e8$var$usePresence(present);
    const child = typeof children === "function" ? children({
        present: presence.isPresent
    }) : (0, $bh6RR.Children).only(children);
    const ref = (0, $e52f713866128e60$export$c7b2cbe3552a0d05)(presence.ref, child.ref);
    const forceMount = typeof children === "function";
    return forceMount || presence.isPresent ? /*#__PURE__*/ (0, $bh6RR.cloneElement)(child, {
        ref: ref
    }) : null;
};
$e651d1dc516f7371$export$99c2b779aa4e8b8b.displayName = "Presence";
/* -------------------------------------------------------------------------------------------------
 * usePresence
 * -----------------------------------------------------------------------------------------------*/ function $e651d1dc516f7371$var$$921a889cee6df7e8$var$usePresence(present) {
    const [node1, setNode] = (0, $bh6RR.useState)();
    const stylesRef = (0, $bh6RR.useRef)({});
    const prevPresentRef = (0, $bh6RR.useRef)(present);
    const prevAnimationNameRef = (0, $bh6RR.useRef)("none");
    const initialState = present ? "mounted" : "unmounted";
    const [state, send] = $e651d1dc516f7371$var$$fe963b355347cc68$export$3e6543de14f8614f(initialState, {
        mounted: {
            UNMOUNT: "unmounted",
            ANIMATION_OUT: "unmountSuspended"
        },
        unmountSuspended: {
            MOUNT: "mounted",
            ANIMATION_END: "unmounted"
        },
        unmounted: {
            MOUNT: "mounted"
        }
    });
    (0, $bh6RR.useEffect)(()=>{
        const currentAnimationName = $e651d1dc516f7371$var$$921a889cee6df7e8$var$getAnimationName(stylesRef.current);
        prevAnimationNameRef.current = state === "mounted" ? currentAnimationName : "none";
    }, [
        state
    ]);
    (0, $8b7ab17803b8e6f8$export$e5c5a5f917a5871c)(()=>{
        const styles = stylesRef.current;
        const wasPresent = prevPresentRef.current;
        const hasPresentChanged = wasPresent !== present;
        if (hasPresentChanged) {
            const prevAnimationName = prevAnimationNameRef.current;
            const currentAnimationName = $e651d1dc516f7371$var$$921a889cee6df7e8$var$getAnimationName(styles);
            if (present) send("MOUNT");
            else if (currentAnimationName === "none" || (styles === null || styles === void 0 ? void 0 : styles.display) === "none") // so we unmount instantly
            send("UNMOUNT");
            else {
                /**
         * When `present` changes to `false`, we check changes to animation-name to
         * determine whether an animation has started. We chose this approach (reading
         * computed styles) because there is no `animationrun` event and `animationstart`
         * fires after `animation-delay` has expired which would be too late.
         */ const isAnimating = prevAnimationName !== currentAnimationName;
                if (wasPresent && isAnimating) send("ANIMATION_OUT");
                else send("UNMOUNT");
            }
            prevPresentRef.current = present;
        }
    }, [
        present,
        send
    ]);
    (0, $8b7ab17803b8e6f8$export$e5c5a5f917a5871c)(()=>{
        if (node1) {
            /**
       * Triggering an ANIMATION_OUT during an ANIMATION_IN will fire an `animationcancel`
       * event for ANIMATION_IN after we have entered `unmountSuspended` state. So, we
       * make sure we only trigger ANIMATION_END for the currently active animation.
       */ const handleAnimationEnd = (event)=>{
                const currentAnimationName = $e651d1dc516f7371$var$$921a889cee6df7e8$var$getAnimationName(stylesRef.current);
                const isCurrentAnimation = currentAnimationName.includes(event.animationName);
                if (event.target === node1 && isCurrentAnimation) // a frame after the animation ends, creating a flash of visible content.
                // By manually flushing we ensure they sync within a frame, removing the flash.
                (0, $47cfd4084854a574$exports.flushSync)(()=>send("ANIMATION_END"));
            };
            const handleAnimationStart = (event)=>{
                if (event.target === node1) prevAnimationNameRef.current = $e651d1dc516f7371$var$$921a889cee6df7e8$var$getAnimationName(stylesRef.current);
            };
            node1.addEventListener("animationstart", handleAnimationStart);
            node1.addEventListener("animationcancel", handleAnimationEnd);
            node1.addEventListener("animationend", handleAnimationEnd);
            return ()=>{
                node1.removeEventListener("animationstart", handleAnimationStart);
                node1.removeEventListener("animationcancel", handleAnimationEnd);
                node1.removeEventListener("animationend", handleAnimationEnd);
            };
        } else // We avoid doing so during cleanup as the node may change but still exist.
        send("ANIMATION_END");
    }, [
        node1,
        send
    ]);
    return {
        isPresent: [
            "mounted",
            "unmountSuspended"
        ].includes(state),
        ref: (0, $bh6RR.useCallback)((node)=>{
            if (node) stylesRef.current = getComputedStyle(node);
            setNode(node);
        }, [])
    };
}
/* -----------------------------------------------------------------------------------------------*/ function $e651d1dc516f7371$var$$921a889cee6df7e8$var$getAnimationName(styles) {
    return (styles === null || styles === void 0 ? void 0 : styles.animationName) || "none";
}





var $bh6RR = parcelRequire("bh6RR");

function $dfcfc7aa8980054c$export$6f32135080cb4c3({ prop: prop, defaultProp: defaultProp, onChange: onChange = ()=>{} }) {
    const [uncontrolledProp, setUncontrolledProp] = $dfcfc7aa8980054c$var$$71cd76cc60e0454e$var$useUncontrolledState({
        defaultProp: defaultProp,
        onChange: onChange
    });
    const isControlled = prop !== undefined;
    const value1 = isControlled ? prop : uncontrolledProp;
    const handleChange = (0, $c901973c35f9b07b$export$25bec8c6f54ee79a)(onChange);
    const setValue = (0, $bh6RR.useCallback)((nextValue)=>{
        if (isControlled) {
            const setter = nextValue;
            const value = typeof nextValue === "function" ? setter(prop) : nextValue;
            if (value !== prop) handleChange(value);
        } else setUncontrolledProp(nextValue);
    }, [
        isControlled,
        prop,
        setUncontrolledProp,
        handleChange
    ]);
    return [
        value1,
        setValue
    ];
}
function $dfcfc7aa8980054c$var$$71cd76cc60e0454e$var$useUncontrolledState({ defaultProp: defaultProp, onChange: onChange }) {
    const uncontrolledState = (0, $bh6RR.useState)(defaultProp);
    const [value] = uncontrolledState;
    const prevValueRef = (0, $bh6RR.useRef)(value);
    const handleChange = (0, $c901973c35f9b07b$export$25bec8c6f54ee79a)(onChange);
    (0, $bh6RR.useEffect)(()=>{
        if (prevValueRef.current !== value) {
            handleChange(value);
            prevValueRef.current = value;
        }
    }, [
        value,
        prevValueRef,
        handleChange
    ]);
    return uncontrolledState;
}




var $bh6RR = parcelRequire("bh6RR");

/* -------------------------------------------------------------------------------------------------
 * VisuallyHidden
 * -----------------------------------------------------------------------------------------------*/ const $91436baa4104b247$var$$ea1ef594cf570d83$var$NAME = "VisuallyHidden";
const $91436baa4104b247$export$439d29a4e110a164 = /*#__PURE__*/ (0, $bh6RR.forwardRef)((props, forwardedRef)=>{
    return /*#__PURE__*/ (0, $bh6RR.createElement)((0, $793b1a0f4d9647b1$export$250ffa63cdc0d034).span, (0, $39ab41060f0dd572$export$2e2bcd8739ae039)({}, props, {
        ref: forwardedRef,
        style: {
            // See: https://github.com/twbs/bootstrap/blob/master/scss/mixins/_screen-reader.scss
            position: "absolute",
            border: 0,
            width: 1,
            height: 1,
            padding: 0,
            margin: -1,
            overflow: "hidden",
            clip: "rect(0, 0, 0, 0)",
            whiteSpace: "nowrap",
            wordWrap: "normal",
            ...props.style
        }
    }));
});
/*#__PURE__*/ Object.assign($91436baa4104b247$export$439d29a4e110a164, {
    displayName: $91436baa4104b247$var$$ea1ef594cf570d83$var$NAME
});
/* -----------------------------------------------------------------------------------------------*/ const $91436baa4104b247$export$be92b6f5f03c0fe9 = $91436baa4104b247$export$439d29a4e110a164;


const [$07f3afa847a16c98$var$$a093c7e1ec25a057$var$createTooltipContext, $07f3afa847a16c98$export$1c540a2224f0d865] = (0, $1cecd1d75f085228$export$50c7b4e9d9f19c1)("Tooltip", [
    (0, $b539e51fb424541d$export$722aac194ae923)
]);
const $07f3afa847a16c98$var$$a093c7e1ec25a057$var$usePopperScope = (0, $b539e51fb424541d$export$722aac194ae923)();
/* -------------------------------------------------------------------------------------------------
 * TooltipProvider
 * -----------------------------------------------------------------------------------------------*/ const $07f3afa847a16c98$var$$a093c7e1ec25a057$var$PROVIDER_NAME = "TooltipProvider";
const $07f3afa847a16c98$var$$a093c7e1ec25a057$var$DEFAULT_DELAY_DURATION = 700;
const $07f3afa847a16c98$var$$a093c7e1ec25a057$var$TOOLTIP_OPEN = "tooltip.open";
const [$07f3afa847a16c98$var$$a093c7e1ec25a057$var$TooltipProviderContextProvider, $07f3afa847a16c98$var$$a093c7e1ec25a057$var$useTooltipProviderContext] = $07f3afa847a16c98$var$$a093c7e1ec25a057$var$createTooltipContext($07f3afa847a16c98$var$$a093c7e1ec25a057$var$PROVIDER_NAME);
const $07f3afa847a16c98$export$f78649fb9ca566b8 = (props)=>{
    const { __scopeTooltip: __scopeTooltip, delayDuration: delayDuration = $07f3afa847a16c98$var$$a093c7e1ec25a057$var$DEFAULT_DELAY_DURATION, skipDelayDuration: skipDelayDuration = 300, disableHoverableContent: disableHoverableContent = false, children: children } = props;
    const [isOpenDelayed, setIsOpenDelayed] = (0, $bh6RR.useState)(true);
    const isPointerInTransitRef = (0, $bh6RR.useRef)(false);
    const skipDelayTimerRef = (0, $bh6RR.useRef)(0);
    (0, $bh6RR.useEffect)(()=>{
        const skipDelayTimer = skipDelayTimerRef.current;
        return ()=>window.clearTimeout(skipDelayTimer);
    }, []);
    return /*#__PURE__*/ (0, $bh6RR.createElement)($07f3afa847a16c98$var$$a093c7e1ec25a057$var$TooltipProviderContextProvider, {
        scope: __scopeTooltip,
        isOpenDelayed: isOpenDelayed,
        delayDuration: delayDuration,
        onOpen: (0, $bh6RR.useCallback)(()=>{
            window.clearTimeout(skipDelayTimerRef.current);
            setIsOpenDelayed(false);
        }, []),
        onClose: (0, $bh6RR.useCallback)(()=>{
            window.clearTimeout(skipDelayTimerRef.current);
            skipDelayTimerRef.current = window.setTimeout(()=>setIsOpenDelayed(true), skipDelayDuration);
        }, [
            skipDelayDuration
        ]),
        isPointerInTransitRef: isPointerInTransitRef,
        onPointerInTransitChange: (0, $bh6RR.useCallback)((inTransit)=>{
            isPointerInTransitRef.current = inTransit;
        }, []),
        disableHoverableContent: disableHoverableContent
    }, children);
};
/*#__PURE__*/ Object.assign($07f3afa847a16c98$export$f78649fb9ca566b8, {
    displayName: $07f3afa847a16c98$var$$a093c7e1ec25a057$var$PROVIDER_NAME
});
/* -------------------------------------------------------------------------------------------------
 * Tooltip
 * -----------------------------------------------------------------------------------------------*/ const $07f3afa847a16c98$var$$a093c7e1ec25a057$var$TOOLTIP_NAME = "Tooltip";
const [$07f3afa847a16c98$var$$a093c7e1ec25a057$var$TooltipContextProvider, $07f3afa847a16c98$var$$a093c7e1ec25a057$var$useTooltipContext] = $07f3afa847a16c98$var$$a093c7e1ec25a057$var$createTooltipContext($07f3afa847a16c98$var$$a093c7e1ec25a057$var$TOOLTIP_NAME);
const $07f3afa847a16c98$export$28c660c63b792dea = (props)=>{
    const { __scopeTooltip: __scopeTooltip, children: children, open: openProp, defaultOpen: defaultOpen = false, onOpenChange: onOpenChange, disableHoverableContent: disableHoverableContentProp, delayDuration: delayDurationProp } = props;
    const providerContext = $07f3afa847a16c98$var$$a093c7e1ec25a057$var$useTooltipProviderContext($07f3afa847a16c98$var$$a093c7e1ec25a057$var$TOOLTIP_NAME, props.__scopeTooltip);
    const popperScope = $07f3afa847a16c98$var$$a093c7e1ec25a057$var$usePopperScope(__scopeTooltip);
    const [trigger, setTrigger] = (0, $bh6RR.useState)(null);
    const contentId = (0, $d172fcbd2da23bac$export$f680877a34711e37)();
    const openTimerRef = (0, $bh6RR.useRef)(0);
    const disableHoverableContent = disableHoverableContentProp !== null && disableHoverableContentProp !== void 0 ? disableHoverableContentProp : providerContext.disableHoverableContent;
    const delayDuration = delayDurationProp !== null && delayDurationProp !== void 0 ? delayDurationProp : providerContext.delayDuration;
    const wasOpenDelayedRef = (0, $bh6RR.useRef)(false);
    const [open1 = false, setOpen] = (0, $dfcfc7aa8980054c$export$6f32135080cb4c3)({
        prop: openProp,
        defaultProp: defaultOpen,
        onChange: (open)=>{
            if (open) {
                providerContext.onOpen(); // as `onChange` is called within a lifecycle method we
                // avoid dispatching via `dispatchDiscreteCustomEvent`.
                document.dispatchEvent(new CustomEvent($07f3afa847a16c98$var$$a093c7e1ec25a057$var$TOOLTIP_OPEN));
            } else providerContext.onClose();
            onOpenChange === null || onOpenChange === void 0 || onOpenChange(open);
        }
    });
    const stateAttribute = (0, $bh6RR.useMemo)(()=>{
        return open1 ? wasOpenDelayedRef.current ? "delayed-open" : "instant-open" : "closed";
    }, [
        open1
    ]);
    const handleOpen = (0, $bh6RR.useCallback)(()=>{
        window.clearTimeout(openTimerRef.current);
        wasOpenDelayedRef.current = false;
        setOpen(true);
    }, [
        setOpen
    ]);
    const handleClose = (0, $bh6RR.useCallback)(()=>{
        window.clearTimeout(openTimerRef.current);
        setOpen(false);
    }, [
        setOpen
    ]);
    const handleDelayedOpen = (0, $bh6RR.useCallback)(()=>{
        window.clearTimeout(openTimerRef.current);
        openTimerRef.current = window.setTimeout(()=>{
            wasOpenDelayedRef.current = true;
            setOpen(true);
        }, delayDuration);
    }, [
        delayDuration,
        setOpen
    ]);
    (0, $bh6RR.useEffect)(()=>{
        return ()=>window.clearTimeout(openTimerRef.current);
    }, []);
    return /*#__PURE__*/ (0, $bh6RR.createElement)((0, $b539e51fb424541d$export$be92b6f5f03c0fe9), popperScope, /*#__PURE__*/ (0, $bh6RR.createElement)($07f3afa847a16c98$var$$a093c7e1ec25a057$var$TooltipContextProvider, {
        scope: __scopeTooltip,
        contentId: contentId,
        open: open1,
        stateAttribute: stateAttribute,
        trigger: trigger,
        onTriggerChange: setTrigger,
        onTriggerEnter: (0, $bh6RR.useCallback)(()=>{
            if (providerContext.isOpenDelayed) handleDelayedOpen();
            else handleOpen();
        }, [
            providerContext.isOpenDelayed,
            handleDelayedOpen,
            handleOpen
        ]),
        onTriggerLeave: (0, $bh6RR.useCallback)(()=>{
            if (disableHoverableContent) handleClose();
            else window.clearTimeout(openTimerRef.current);
        }, [
            handleClose,
            disableHoverableContent
        ]),
        onOpen: handleOpen,
        onClose: handleClose,
        disableHoverableContent: disableHoverableContent
    }, children));
};
/*#__PURE__*/ Object.assign($07f3afa847a16c98$export$28c660c63b792dea, {
    displayName: $07f3afa847a16c98$var$$a093c7e1ec25a057$var$TOOLTIP_NAME
});
/* -------------------------------------------------------------------------------------------------
 * TooltipTrigger
 * -----------------------------------------------------------------------------------------------*/ const $07f3afa847a16c98$var$$a093c7e1ec25a057$var$TRIGGER_NAME = "TooltipTrigger";
const $07f3afa847a16c98$export$8c610744efcf8a1d = /*#__PURE__*/ (0, $bh6RR.forwardRef)((props, forwardedRef)=>{
    const { __scopeTooltip: __scopeTooltip, ...triggerProps } = props;
    const context = $07f3afa847a16c98$var$$a093c7e1ec25a057$var$useTooltipContext($07f3afa847a16c98$var$$a093c7e1ec25a057$var$TRIGGER_NAME, __scopeTooltip);
    const providerContext = $07f3afa847a16c98$var$$a093c7e1ec25a057$var$useTooltipProviderContext($07f3afa847a16c98$var$$a093c7e1ec25a057$var$TRIGGER_NAME, __scopeTooltip);
    const popperScope = $07f3afa847a16c98$var$$a093c7e1ec25a057$var$usePopperScope(__scopeTooltip);
    const ref = (0, $bh6RR.useRef)(null);
    const composedRefs = (0, $e52f713866128e60$export$c7b2cbe3552a0d05)(forwardedRef, ref, context.onTriggerChange);
    const isPointerDownRef = (0, $bh6RR.useRef)(false);
    const hasPointerMoveOpenedRef = (0, $bh6RR.useRef)(false);
    const handlePointerUp = (0, $bh6RR.useCallback)(()=>isPointerDownRef.current = false, []);
    (0, $bh6RR.useEffect)(()=>{
        return ()=>document.removeEventListener("pointerup", handlePointerUp);
    }, [
        handlePointerUp
    ]);
    return /*#__PURE__*/ (0, $bh6RR.createElement)((0, $b539e51fb424541d$export$b688253958b8dfe7), (0, $39ab41060f0dd572$export$2e2bcd8739ae039)({
        asChild: true
    }, popperScope), /*#__PURE__*/ (0, $bh6RR.createElement)((0, $793b1a0f4d9647b1$export$250ffa63cdc0d034).button, (0, $39ab41060f0dd572$export$2e2bcd8739ae039)({
        // We purposefully avoid adding `type=button` here because tooltip triggers are also
        // commonly anchors and the anchor `type` attribute signifies MIME type.
        "aria-describedby": context.open ? context.contentId : undefined,
        "data-state": context.stateAttribute
    }, triggerProps, {
        ref: composedRefs,
        onPointerMove: (0, $93dfa6b8fe6a3629$export$b9ecd428b558ff10)(props.onPointerMove, (event)=>{
            if (event.pointerType === "touch") return;
            if (!hasPointerMoveOpenedRef.current && !providerContext.isPointerInTransitRef.current) {
                context.onTriggerEnter();
                hasPointerMoveOpenedRef.current = true;
            }
        }),
        onPointerLeave: (0, $93dfa6b8fe6a3629$export$b9ecd428b558ff10)(props.onPointerLeave, ()=>{
            context.onTriggerLeave();
            hasPointerMoveOpenedRef.current = false;
        }),
        onPointerDown: (0, $93dfa6b8fe6a3629$export$b9ecd428b558ff10)(props.onPointerDown, ()=>{
            isPointerDownRef.current = true;
            document.addEventListener("pointerup", handlePointerUp, {
                once: true
            });
        }),
        onFocus: (0, $93dfa6b8fe6a3629$export$b9ecd428b558ff10)(props.onFocus, ()=>{
            if (!isPointerDownRef.current) context.onOpen();
        }),
        onBlur: (0, $93dfa6b8fe6a3629$export$b9ecd428b558ff10)(props.onBlur, context.onClose),
        onClick: (0, $93dfa6b8fe6a3629$export$b9ecd428b558ff10)(props.onClick, context.onClose)
    })));
});
/*#__PURE__*/ Object.assign($07f3afa847a16c98$export$8c610744efcf8a1d, {
    displayName: $07f3afa847a16c98$var$$a093c7e1ec25a057$var$TRIGGER_NAME
});
/* -------------------------------------------------------------------------------------------------
 * TooltipPortal
 * -----------------------------------------------------------------------------------------------*/ const $07f3afa847a16c98$var$$a093c7e1ec25a057$var$PORTAL_NAME = "TooltipPortal";
const [$07f3afa847a16c98$var$$a093c7e1ec25a057$var$PortalProvider, $07f3afa847a16c98$var$$a093c7e1ec25a057$var$usePortalContext] = $07f3afa847a16c98$var$$a093c7e1ec25a057$var$createTooltipContext($07f3afa847a16c98$var$$a093c7e1ec25a057$var$PORTAL_NAME, {
    forceMount: undefined
});
const $07f3afa847a16c98$export$7b36b8f925ab7497 = (props)=>{
    const { __scopeTooltip: __scopeTooltip, forceMount: forceMount, children: children, container: container } = props;
    const context = $07f3afa847a16c98$var$$a093c7e1ec25a057$var$useTooltipContext($07f3afa847a16c98$var$$a093c7e1ec25a057$var$PORTAL_NAME, __scopeTooltip);
    return /*#__PURE__*/ (0, $bh6RR.createElement)($07f3afa847a16c98$var$$a093c7e1ec25a057$var$PortalProvider, {
        scope: __scopeTooltip,
        forceMount: forceMount
    }, /*#__PURE__*/ (0, $bh6RR.createElement)((0, $e651d1dc516f7371$export$99c2b779aa4e8b8b), {
        present: forceMount || context.open
    }, /*#__PURE__*/ (0, $bh6RR.createElement)((0, $252b3d40eb00b07a$export$602eac185826482c), {
        asChild: true,
        container: container
    }, children)));
};
/*#__PURE__*/ Object.assign($07f3afa847a16c98$export$7b36b8f925ab7497, {
    displayName: $07f3afa847a16c98$var$$a093c7e1ec25a057$var$PORTAL_NAME
});
/* -------------------------------------------------------------------------------------------------
 * TooltipContent
 * -----------------------------------------------------------------------------------------------*/ const $07f3afa847a16c98$var$$a093c7e1ec25a057$var$CONTENT_NAME = "TooltipContent";
const $07f3afa847a16c98$export$e9003e2be37ec060 = /*#__PURE__*/ (0, $bh6RR.forwardRef)((props, forwardedRef)=>{
    const portalContext = $07f3afa847a16c98$var$$a093c7e1ec25a057$var$usePortalContext($07f3afa847a16c98$var$$a093c7e1ec25a057$var$CONTENT_NAME, props.__scopeTooltip);
    const { forceMount: forceMount = portalContext.forceMount, side: side = "top", ...contentProps } = props;
    const context = $07f3afa847a16c98$var$$a093c7e1ec25a057$var$useTooltipContext($07f3afa847a16c98$var$$a093c7e1ec25a057$var$CONTENT_NAME, props.__scopeTooltip);
    return /*#__PURE__*/ (0, $bh6RR.createElement)((0, $e651d1dc516f7371$export$99c2b779aa4e8b8b), {
        present: forceMount || context.open
    }, context.disableHoverableContent ? /*#__PURE__*/ (0, $bh6RR.createElement)($07f3afa847a16c98$var$$a093c7e1ec25a057$var$TooltipContentImpl, (0, $39ab41060f0dd572$export$2e2bcd8739ae039)({
        side: side
    }, contentProps, {
        ref: forwardedRef
    })) : /*#__PURE__*/ (0, $bh6RR.createElement)($07f3afa847a16c98$var$$a093c7e1ec25a057$var$TooltipContentHoverable, (0, $39ab41060f0dd572$export$2e2bcd8739ae039)({
        side: side
    }, contentProps, {
        ref: forwardedRef
    })));
});
const $07f3afa847a16c98$var$$a093c7e1ec25a057$var$TooltipContentHoverable = /*#__PURE__*/ (0, $bh6RR.forwardRef)((props, forwardedRef)=>{
    const context = $07f3afa847a16c98$var$$a093c7e1ec25a057$var$useTooltipContext($07f3afa847a16c98$var$$a093c7e1ec25a057$var$CONTENT_NAME, props.__scopeTooltip);
    const providerContext = $07f3afa847a16c98$var$$a093c7e1ec25a057$var$useTooltipProviderContext($07f3afa847a16c98$var$$a093c7e1ec25a057$var$CONTENT_NAME, props.__scopeTooltip);
    const ref = (0, $bh6RR.useRef)(null);
    const composedRefs = (0, $e52f713866128e60$export$c7b2cbe3552a0d05)(forwardedRef, ref);
    const [pointerGraceArea, setPointerGraceArea] = (0, $bh6RR.useState)(null);
    const { trigger: trigger, onClose: onClose } = context;
    const content = ref.current;
    const { onPointerInTransitChange: onPointerInTransitChange } = providerContext;
    const handleRemoveGraceArea = (0, $bh6RR.useCallback)(()=>{
        setPointerGraceArea(null);
        onPointerInTransitChange(false);
    }, [
        onPointerInTransitChange
    ]);
    const handleCreateGraceArea = (0, $bh6RR.useCallback)((event, hoverTarget)=>{
        const currentTarget = event.currentTarget;
        const exitPoint = {
            x: event.clientX,
            y: event.clientY
        };
        const exitSide = $07f3afa847a16c98$var$$a093c7e1ec25a057$var$getExitSideFromRect(exitPoint, currentTarget.getBoundingClientRect());
        const paddedExitPoints = $07f3afa847a16c98$var$$a093c7e1ec25a057$var$getPaddedExitPoints(exitPoint, exitSide);
        const hoverTargetPoints = $07f3afa847a16c98$var$$a093c7e1ec25a057$var$getPointsFromRect(hoverTarget.getBoundingClientRect());
        const graceArea = $07f3afa847a16c98$var$$a093c7e1ec25a057$var$getHull([
            ...paddedExitPoints,
            ...hoverTargetPoints
        ]);
        setPointerGraceArea(graceArea);
        onPointerInTransitChange(true);
    }, [
        onPointerInTransitChange
    ]);
    (0, $bh6RR.useEffect)(()=>{
        return ()=>handleRemoveGraceArea();
    }, [
        handleRemoveGraceArea
    ]);
    (0, $bh6RR.useEffect)(()=>{
        if (trigger && content) {
            const handleTriggerLeave = (event)=>handleCreateGraceArea(event, content);
            const handleContentLeave = (event)=>handleCreateGraceArea(event, trigger);
            trigger.addEventListener("pointerleave", handleTriggerLeave);
            content.addEventListener("pointerleave", handleContentLeave);
            return ()=>{
                trigger.removeEventListener("pointerleave", handleTriggerLeave);
                content.removeEventListener("pointerleave", handleContentLeave);
            };
        }
    }, [
        trigger,
        content,
        handleCreateGraceArea,
        handleRemoveGraceArea
    ]);
    (0, $bh6RR.useEffect)(()=>{
        if (pointerGraceArea) {
            const handleTrackPointerGrace = (event)=>{
                const target = event.target;
                const pointerPosition = {
                    x: event.clientX,
                    y: event.clientY
                };
                const hasEnteredTarget = (trigger === null || trigger === void 0 ? void 0 : trigger.contains(target)) || (content === null || content === void 0 ? void 0 : content.contains(target));
                const isPointerOutsideGraceArea = !$07f3afa847a16c98$var$$a093c7e1ec25a057$var$isPointInPolygon(pointerPosition, pointerGraceArea);
                if (hasEnteredTarget) handleRemoveGraceArea();
                else if (isPointerOutsideGraceArea) {
                    handleRemoveGraceArea();
                    onClose();
                }
            };
            document.addEventListener("pointermove", handleTrackPointerGrace);
            return ()=>document.removeEventListener("pointermove", handleTrackPointerGrace);
        }
    }, [
        trigger,
        content,
        pointerGraceArea,
        onClose,
        handleRemoveGraceArea
    ]);
    return /*#__PURE__*/ (0, $bh6RR.createElement)($07f3afa847a16c98$var$$a093c7e1ec25a057$var$TooltipContentImpl, (0, $39ab41060f0dd572$export$2e2bcd8739ae039)({}, props, {
        ref: composedRefs
    }));
});
const [$07f3afa847a16c98$var$$a093c7e1ec25a057$var$VisuallyHiddenContentContextProvider, $07f3afa847a16c98$var$$a093c7e1ec25a057$var$useVisuallyHiddenContentContext] = $07f3afa847a16c98$var$$a093c7e1ec25a057$var$createTooltipContext($07f3afa847a16c98$var$$a093c7e1ec25a057$var$TOOLTIP_NAME, {
    isInside: false
});
const $07f3afa847a16c98$var$$a093c7e1ec25a057$var$TooltipContentImpl = /*#__PURE__*/ (0, $bh6RR.forwardRef)((props, forwardedRef)=>{
    const { __scopeTooltip: __scopeTooltip, children: children, "aria-label": ariaLabel, onEscapeKeyDown: onEscapeKeyDown, onPointerDownOutside: onPointerDownOutside, ...contentProps } = props;
    const context = $07f3afa847a16c98$var$$a093c7e1ec25a057$var$useTooltipContext($07f3afa847a16c98$var$$a093c7e1ec25a057$var$CONTENT_NAME, __scopeTooltip);
    const popperScope = $07f3afa847a16c98$var$$a093c7e1ec25a057$var$usePopperScope(__scopeTooltip);
    const { onClose: onClose } = context; // Close this tooltip if another one opens
    (0, $bh6RR.useEffect)(()=>{
        document.addEventListener($07f3afa847a16c98$var$$a093c7e1ec25a057$var$TOOLTIP_OPEN, onClose);
        return ()=>document.removeEventListener($07f3afa847a16c98$var$$a093c7e1ec25a057$var$TOOLTIP_OPEN, onClose);
    }, [
        onClose
    ]); // Close the tooltip if the trigger is scrolled
    (0, $bh6RR.useEffect)(()=>{
        if (context.trigger) {
            const handleScroll = (event)=>{
                const target = event.target;
                if (target !== null && target !== void 0 && target.contains(context.trigger)) onClose();
            };
            window.addEventListener("scroll", handleScroll, {
                capture: true
            });
            return ()=>window.removeEventListener("scroll", handleScroll, {
                    capture: true
                });
        }
    }, [
        context.trigger,
        onClose
    ]);
    return /*#__PURE__*/ (0, $bh6RR.createElement)((0, $8473b83e333b07d4$export$177fb62ff3ec1f22), {
        asChild: true,
        disableOutsidePointerEvents: false,
        onEscapeKeyDown: onEscapeKeyDown,
        onPointerDownOutside: onPointerDownOutside,
        onFocusOutside: (event)=>event.preventDefault(),
        onDismiss: onClose
    }, /*#__PURE__*/ (0, $bh6RR.createElement)((0, $b539e51fb424541d$export$7c6e2c02157bb7d2), (0, $39ab41060f0dd572$export$2e2bcd8739ae039)({
        "data-state": context.stateAttribute
    }, popperScope, contentProps, {
        ref: forwardedRef,
        style: {
            ...contentProps.style,
            "--radix-tooltip-content-transform-origin": "var(--radix-popper-transform-origin)",
            "--radix-tooltip-content-available-width": "var(--radix-popper-available-width)",
            "--radix-tooltip-content-available-height": "var(--radix-popper-available-height)",
            "--radix-tooltip-trigger-width": "var(--radix-popper-anchor-width)",
            "--radix-tooltip-trigger-height": "var(--radix-popper-anchor-height)"
        }
    }), /*#__PURE__*/ (0, $bh6RR.createElement)((0, $18fd289ffa468154$export$d9f1ccf0bdb05d45), null, children), /*#__PURE__*/ (0, $bh6RR.createElement)($07f3afa847a16c98$var$$a093c7e1ec25a057$var$VisuallyHiddenContentContextProvider, {
        scope: __scopeTooltip,
        isInside: true
    }, /*#__PURE__*/ (0, $bh6RR.createElement)((0, $91436baa4104b247$export$be92b6f5f03c0fe9), {
        id: context.contentId,
        role: "tooltip"
    }, ariaLabel || children))));
});
/*#__PURE__*/ Object.assign($07f3afa847a16c98$export$e9003e2be37ec060, {
    displayName: $07f3afa847a16c98$var$$a093c7e1ec25a057$var$CONTENT_NAME
});
/* -------------------------------------------------------------------------------------------------
 * TooltipArrow
 * -----------------------------------------------------------------------------------------------*/ const $07f3afa847a16c98$var$$a093c7e1ec25a057$var$ARROW_NAME = "TooltipArrow";
const $07f3afa847a16c98$export$c27ee0ad710f7559 = /*#__PURE__*/ (0, $bh6RR.forwardRef)((props, forwardedRef)=>{
    const { __scopeTooltip: __scopeTooltip, ...arrowProps } = props;
    const popperScope = $07f3afa847a16c98$var$$a093c7e1ec25a057$var$usePopperScope(__scopeTooltip);
    const visuallyHiddenContentContext = $07f3afa847a16c98$var$$a093c7e1ec25a057$var$useVisuallyHiddenContentContext($07f3afa847a16c98$var$$a093c7e1ec25a057$var$ARROW_NAME, __scopeTooltip); // if the arrow is inside the `VisuallyHidden`, we don't want to render it all to
    // prevent issues in positioning the arrow due to the duplicate
    return visuallyHiddenContentContext.isInside ? null : /*#__PURE__*/ (0, $bh6RR.createElement)((0, $b539e51fb424541d$export$21b07c8f274aebd5), (0, $39ab41060f0dd572$export$2e2bcd8739ae039)({}, popperScope, arrowProps, {
        ref: forwardedRef
    }));
});
/*#__PURE__*/ Object.assign($07f3afa847a16c98$export$c27ee0ad710f7559, {
    displayName: $07f3afa847a16c98$var$$a093c7e1ec25a057$var$ARROW_NAME
});
/* -----------------------------------------------------------------------------------------------*/ function $07f3afa847a16c98$var$$a093c7e1ec25a057$var$getExitSideFromRect(point, rect) {
    const top = Math.abs(rect.top - point.y);
    const bottom = Math.abs(rect.bottom - point.y);
    const right = Math.abs(rect.right - point.x);
    const left = Math.abs(rect.left - point.x);
    switch(Math.min(top, bottom, right, left)){
        case left:
            return "left";
        case right:
            return "right";
        case top:
            return "top";
        case bottom:
            return "bottom";
        default:
            throw new Error("unreachable");
    }
}
function $07f3afa847a16c98$var$$a093c7e1ec25a057$var$getPaddedExitPoints(exitPoint, exitSide, padding = 5) {
    const paddedExitPoints = [];
    switch(exitSide){
        case "top":
            paddedExitPoints.push({
                x: exitPoint.x - padding,
                y: exitPoint.y + padding
            }, {
                x: exitPoint.x + padding,
                y: exitPoint.y + padding
            });
            break;
        case "bottom":
            paddedExitPoints.push({
                x: exitPoint.x - padding,
                y: exitPoint.y - padding
            }, {
                x: exitPoint.x + padding,
                y: exitPoint.y - padding
            });
            break;
        case "left":
            paddedExitPoints.push({
                x: exitPoint.x + padding,
                y: exitPoint.y - padding
            }, {
                x: exitPoint.x + padding,
                y: exitPoint.y + padding
            });
            break;
        case "right":
            paddedExitPoints.push({
                x: exitPoint.x - padding,
                y: exitPoint.y - padding
            }, {
                x: exitPoint.x - padding,
                y: exitPoint.y + padding
            });
            break;
    }
    return paddedExitPoints;
}
function $07f3afa847a16c98$var$$a093c7e1ec25a057$var$getPointsFromRect(rect) {
    const { top: top, right: right, bottom: bottom, left: left } = rect;
    return [
        {
            x: left,
            y: top
        },
        {
            x: right,
            y: top
        },
        {
            x: right,
            y: bottom
        },
        {
            x: left,
            y: bottom
        }
    ];
} // Determine if a point is inside of a polygon.
// Based on https://github.com/substack/point-in-polygon
function $07f3afa847a16c98$var$$a093c7e1ec25a057$var$isPointInPolygon(point, polygon) {
    const { x: x, y: y } = point;
    let inside = false;
    for(let i = 0, j = polygon.length - 1; i < polygon.length; j = i++){
        const xi = polygon[i].x;
        const yi = polygon[i].y;
        const xj = polygon[j].x;
        const yj = polygon[j].y; // prettier-ignore
        const intersect = yi > y !== yj > y && x < (xj - xi) * (y - yi) / (yj - yi) + xi;
        if (intersect) inside = !inside;
    }
    return inside;
} // Returns a new array of points representing the convex hull of the given set of points.
// https://www.nayuki.io/page/convex-hull-algorithm
function $07f3afa847a16c98$var$$a093c7e1ec25a057$var$getHull(points) {
    const newPoints = points.slice();
    newPoints.sort((a, b)=>{
        if (a.x < b.x) return -1;
        else if (a.x > b.x) return 1;
        else if (a.y < b.y) return -1;
        else if (a.y > b.y) return 1;
        else return 0;
    });
    return $07f3afa847a16c98$var$$a093c7e1ec25a057$var$getHullPresorted(newPoints);
} // Returns the convex hull, assuming that each points[i] <= points[i + 1]. Runs in O(n) time.
function $07f3afa847a16c98$var$$a093c7e1ec25a057$var$getHullPresorted(points) {
    if (points.length <= 1) return points.slice();
    const upperHull = [];
    for(let i = 0; i < points.length; i++){
        const p = points[i];
        while(upperHull.length >= 2){
            const q = upperHull[upperHull.length - 1];
            const r = upperHull[upperHull.length - 2];
            if ((q.x - r.x) * (p.y - r.y) >= (q.y - r.y) * (p.x - r.x)) upperHull.pop();
            else break;
        }
        upperHull.push(p);
    }
    upperHull.pop();
    const lowerHull = [];
    for(let i1 = points.length - 1; i1 >= 0; i1--){
        const p = points[i1];
        while(lowerHull.length >= 2){
            const q = lowerHull[lowerHull.length - 1];
            const r = lowerHull[lowerHull.length - 2];
            if ((q.x - r.x) * (p.y - r.y) >= (q.y - r.y) * (p.x - r.x)) lowerHull.pop();
            else break;
        }
        lowerHull.push(p);
    }
    lowerHull.pop();
    if (upperHull.length === 1 && lowerHull.length === 1 && upperHull[0].x === lowerHull[0].x && upperHull[0].y === lowerHull[0].y) return upperHull;
    else return upperHull.concat(lowerHull);
}
const $07f3afa847a16c98$export$2881499e37b75b9a = $07f3afa847a16c98$export$f78649fb9ca566b8;
const $07f3afa847a16c98$export$be92b6f5f03c0fe9 = $07f3afa847a16c98$export$28c660c63b792dea;
const $07f3afa847a16c98$export$41fb9f06171c75f4 = $07f3afa847a16c98$export$8c610744efcf8a1d;
const $07f3afa847a16c98$export$602eac185826482c = $07f3afa847a16c98$export$7b36b8f925ab7497;
const $07f3afa847a16c98$export$7c6e2c02157bb7d2 = $07f3afa847a16c98$export$e9003e2be37ec060;
const $07f3afa847a16c98$export$21b07c8f274aebd5 = $07f3afa847a16c98$export$c27ee0ad710f7559;



function $cb0e0834598ff6d6$export$2e2bcd8739ae039(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}


function $ca073d81f2a471af$export$2e2bcd8739ae039(o, p) {
    $ca073d81f2a471af$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $ca073d81f2a471af$export$2e2bcd8739ae039(o, p);
}


function $c375c92967c25393$export$2e2bcd8739ae039(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    (0, $ca073d81f2a471af$export$2e2bcd8739ae039)(subClass, superClass);
}


var $16d5efbf3de5c533$var$safeIsNaN = Number.isNaN || function ponyfill(value) {
    return typeof value === "number" && value !== value;
};
function $16d5efbf3de5c533$var$isEqual(first, second) {
    if (first === second) return true;
    if ($16d5efbf3de5c533$var$safeIsNaN(first) && $16d5efbf3de5c533$var$safeIsNaN(second)) return true;
    return false;
}
function $16d5efbf3de5c533$var$areInputsEqual(newInputs, lastInputs) {
    if (newInputs.length !== lastInputs.length) return false;
    for(var i = 0; i < newInputs.length; i++){
        if (!$16d5efbf3de5c533$var$isEqual(newInputs[i], lastInputs[i])) return false;
    }
    return true;
}
function $16d5efbf3de5c533$var$memoizeOne(resultFn, isEqual) {
    if (isEqual === void 0) isEqual = $16d5efbf3de5c533$var$areInputsEqual;
    var lastThis;
    var lastArgs = [];
    var lastResult;
    var calledOnce = false;
    function memoized() {
        var newArgs = [];
        for(var _i = 0; _i < arguments.length; _i++)newArgs[_i] = arguments[_i];
        if (calledOnce && lastThis === this && isEqual(newArgs, lastArgs)) return lastResult;
        lastResult = resultFn.apply(this, newArgs);
        calledOnce = true;
        lastThis = this;
        lastArgs = newArgs;
        return lastResult;
    }
    return memoized;
}
var $16d5efbf3de5c533$export$2e2bcd8739ae039 = $16d5efbf3de5c533$var$memoizeOne;



var $bh6RR = parcelRequire("bh6RR");
function $cd488cd9c287f883$export$2e2bcd8739ae039(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}


// Animation frame based implementation of setTimeout.
// Inspired by Joe Lambert, https://gist.github.com/joelambert/1002116#file-requesttimeout-js
var $3cc8a1e45b82291d$var$hasNativePerformanceNow = typeof performance === "object" && typeof performance.now === "function";
var $3cc8a1e45b82291d$var$now = $3cc8a1e45b82291d$var$hasNativePerformanceNow ? function() {
    return performance.now();
} : function() {
    return Date.now();
};
function $3cc8a1e45b82291d$var$cancelTimeout(timeoutID) {
    cancelAnimationFrame(timeoutID.id);
}
function $3cc8a1e45b82291d$var$requestTimeout(callback, delay) {
    var start = $3cc8a1e45b82291d$var$now();
    function tick() {
        if ($3cc8a1e45b82291d$var$now() - start >= delay) callback.call(null);
        else timeoutID.id = requestAnimationFrame(tick);
    }
    var timeoutID = {
        id: requestAnimationFrame(tick)
    };
    return timeoutID;
}
var $3cc8a1e45b82291d$var$size = -1; // This utility copied from "dom-helpers" package.
function $3cc8a1e45b82291d$var$getScrollbarSize(recalculate) {
    if (recalculate === void 0) recalculate = false;
    if ($3cc8a1e45b82291d$var$size === -1 || recalculate) {
        var div = document.createElement("div");
        var style = div.style;
        style.width = "50px";
        style.height = "50px";
        style.overflow = "scroll";
        document.body.appendChild(div);
        $3cc8a1e45b82291d$var$size = div.offsetWidth - div.clientWidth;
        document.body.removeChild(div);
    }
    return $3cc8a1e45b82291d$var$size;
}
var $3cc8a1e45b82291d$var$cachedRTLResult = null; // TRICKY According to the spec, scrollLeft should be negative for RTL aligned elements.
// Chrome does not seem to adhere; its scrollLeft values are positive (measured relative to the left).
// Safari's elastic bounce makes detecting this even more complicated wrt potential false positives.
// The safest way to check this is to intentionally set a negative offset,
// and then verify that the subsequent "scroll" event matches the negative offset.
// If it does not match, then we can assume a non-standard RTL scroll implementation.
function $3cc8a1e45b82291d$var$getRTLOffsetType(recalculate) {
    if (recalculate === void 0) recalculate = false;
    if ($3cc8a1e45b82291d$var$cachedRTLResult === null || recalculate) {
        var outerDiv = document.createElement("div");
        var outerStyle = outerDiv.style;
        outerStyle.width = "50px";
        outerStyle.height = "50px";
        outerStyle.overflow = "scroll";
        outerStyle.direction = "rtl";
        var innerDiv = document.createElement("div");
        var innerStyle = innerDiv.style;
        innerStyle.width = "100px";
        innerStyle.height = "100px";
        outerDiv.appendChild(innerDiv);
        document.body.appendChild(outerDiv);
        if (outerDiv.scrollLeft > 0) $3cc8a1e45b82291d$var$cachedRTLResult = "positive-descending";
        else {
            outerDiv.scrollLeft = 1;
            if (outerDiv.scrollLeft === 0) $3cc8a1e45b82291d$var$cachedRTLResult = "negative";
            else $3cc8a1e45b82291d$var$cachedRTLResult = "positive-ascending";
        }
        document.body.removeChild(outerDiv);
        return $3cc8a1e45b82291d$var$cachedRTLResult;
    }
    return $3cc8a1e45b82291d$var$cachedRTLResult;
}
var $3cc8a1e45b82291d$var$IS_SCROLLING_DEBOUNCE_INTERVAL = 150;
var $3cc8a1e45b82291d$var$defaultItemKey = function defaultItemKey(_ref) {
    var columnIndex = _ref.columnIndex, data = _ref.data, rowIndex = _ref.rowIndex;
    return rowIndex + ":" + columnIndex;
}; // In DEV mode, this Set helps us only log a warning once per component instance.
// This avoids spamming the console every time a render happens.
var $3cc8a1e45b82291d$var$devWarningsOverscanCount = null;
var $3cc8a1e45b82291d$var$devWarningsOverscanRowsColumnsCount = null;
var $3cc8a1e45b82291d$var$devWarningsTagName = null;
function $3cc8a1e45b82291d$var$createGridComponent(_ref2) {
    var _class;
    var getColumnOffset = _ref2.getColumnOffset, getColumnStartIndexForOffset = _ref2.getColumnStartIndexForOffset, getColumnStopIndexForStartIndex = _ref2.getColumnStopIndexForStartIndex, getColumnWidth = _ref2.getColumnWidth, getEstimatedTotalHeight = _ref2.getEstimatedTotalHeight, getEstimatedTotalWidth = _ref2.getEstimatedTotalWidth, getOffsetForColumnAndAlignment = _ref2.getOffsetForColumnAndAlignment, getOffsetForRowAndAlignment = _ref2.getOffsetForRowAndAlignment, getRowHeight = _ref2.getRowHeight, getRowOffset = _ref2.getRowOffset, getRowStartIndexForOffset = _ref2.getRowStartIndexForOffset, getRowStopIndexForStartIndex = _ref2.getRowStopIndexForStartIndex, initInstanceProps = _ref2.initInstanceProps, shouldResetStyleCacheOnItemSizeChange = _ref2.shouldResetStyleCacheOnItemSizeChange, validateProps = _ref2.validateProps;
    return _class = /*#__PURE__*/ function(_PureComponent) {
        (0, $c375c92967c25393$export$2e2bcd8739ae039)(Grid, _PureComponent);
        // Always use explicit constructor for React components.
        // It produces less code after transpilation. (#26)
        // eslint-disable-next-line no-useless-constructor
        function Grid(props) {
            var _this;
            _this = _PureComponent.call(this, props) || this;
            _this._instanceProps = initInstanceProps(_this.props, (0, $cb0e0834598ff6d6$export$2e2bcd8739ae039)(_this));
            _this._resetIsScrollingTimeoutId = null;
            _this._outerRef = void 0;
            _this.state = {
                instance: (0, $cb0e0834598ff6d6$export$2e2bcd8739ae039)(_this),
                isScrolling: false,
                horizontalScrollDirection: "forward",
                scrollLeft: typeof _this.props.initialScrollLeft === "number" ? _this.props.initialScrollLeft : 0,
                scrollTop: typeof _this.props.initialScrollTop === "number" ? _this.props.initialScrollTop : 0,
                scrollUpdateWasRequested: false,
                verticalScrollDirection: "forward"
            };
            _this._callOnItemsRendered = void 0;
            _this._callOnItemsRendered = (0, $16d5efbf3de5c533$export$2e2bcd8739ae039)(function(overscanColumnStartIndex, overscanColumnStopIndex, overscanRowStartIndex, overscanRowStopIndex, visibleColumnStartIndex, visibleColumnStopIndex, visibleRowStartIndex, visibleRowStopIndex) {
                return _this.props.onItemsRendered({
                    overscanColumnStartIndex: overscanColumnStartIndex,
                    overscanColumnStopIndex: overscanColumnStopIndex,
                    overscanRowStartIndex: overscanRowStartIndex,
                    overscanRowStopIndex: overscanRowStopIndex,
                    visibleColumnStartIndex: visibleColumnStartIndex,
                    visibleColumnStopIndex: visibleColumnStopIndex,
                    visibleRowStartIndex: visibleRowStartIndex,
                    visibleRowStopIndex: visibleRowStopIndex
                });
            });
            _this._callOnScroll = void 0;
            _this._callOnScroll = (0, $16d5efbf3de5c533$export$2e2bcd8739ae039)(function(scrollLeft, scrollTop, horizontalScrollDirection, verticalScrollDirection, scrollUpdateWasRequested) {
                return _this.props.onScroll({
                    horizontalScrollDirection: horizontalScrollDirection,
                    scrollLeft: scrollLeft,
                    scrollTop: scrollTop,
                    verticalScrollDirection: verticalScrollDirection,
                    scrollUpdateWasRequested: scrollUpdateWasRequested
                });
            });
            _this._getItemStyle = void 0;
            _this._getItemStyle = function(rowIndex, columnIndex) {
                var _this$props = _this.props, columnWidth = _this$props.columnWidth, direction = _this$props.direction, rowHeight = _this$props.rowHeight;
                var itemStyleCache = _this._getItemStyleCache(shouldResetStyleCacheOnItemSizeChange && columnWidth, shouldResetStyleCacheOnItemSizeChange && direction, shouldResetStyleCacheOnItemSizeChange && rowHeight);
                var key = rowIndex + ":" + columnIndex;
                var style;
                if (itemStyleCache.hasOwnProperty(key)) style = itemStyleCache[key];
                else {
                    var _offset = getColumnOffset(_this.props, columnIndex, _this._instanceProps);
                    var isRtl = direction === "rtl";
                    itemStyleCache[key] = style = {
                        position: "absolute",
                        left: isRtl ? undefined : _offset,
                        right: isRtl ? _offset : undefined,
                        top: getRowOffset(_this.props, rowIndex, _this._instanceProps),
                        height: getRowHeight(_this.props, rowIndex, _this._instanceProps),
                        width: getColumnWidth(_this.props, columnIndex, _this._instanceProps)
                    };
                }
                return style;
            };
            _this._getItemStyleCache = void 0;
            _this._getItemStyleCache = (0, $16d5efbf3de5c533$export$2e2bcd8739ae039)(function(_, __, ___) {
                return {};
            });
            _this._onScroll = function(event) {
                var _event$currentTarget = event.currentTarget, clientHeight = _event$currentTarget.clientHeight, clientWidth = _event$currentTarget.clientWidth, scrollLeft = _event$currentTarget.scrollLeft, scrollTop = _event$currentTarget.scrollTop, scrollHeight = _event$currentTarget.scrollHeight, scrollWidth = _event$currentTarget.scrollWidth;
                _this.setState(function(prevState) {
                    if (prevState.scrollLeft === scrollLeft && prevState.scrollTop === scrollTop) // Scroll position may have been updated by cDM/cDU,
                    // In which case we don't need to trigger another render,
                    // And we don't want to update state.isScrolling.
                    return null;
                    var direction = _this.props.direction; // TRICKY According to the spec, scrollLeft should be negative for RTL aligned elements.
                    // This is not the case for all browsers though (e.g. Chrome reports values as positive, measured relative to the left).
                    // It's also easier for this component if we convert offsets to the same format as they would be in for ltr.
                    // So the simplest solution is to determine which browser behavior we're dealing with, and convert based on it.
                    var calculatedScrollLeft = scrollLeft;
                    if (direction === "rtl") switch($3cc8a1e45b82291d$var$getRTLOffsetType()){
                        case "negative":
                            calculatedScrollLeft = -scrollLeft;
                            break;
                        case "positive-descending":
                            calculatedScrollLeft = scrollWidth - clientWidth - scrollLeft;
                            break;
                    }
                     // Prevent Safari's elastic scrolling from causing visual shaking when scrolling past bounds.
                    calculatedScrollLeft = Math.max(0, Math.min(calculatedScrollLeft, scrollWidth - clientWidth));
                    var calculatedScrollTop = Math.max(0, Math.min(scrollTop, scrollHeight - clientHeight));
                    return {
                        isScrolling: true,
                        horizontalScrollDirection: prevState.scrollLeft < scrollLeft ? "forward" : "backward",
                        scrollLeft: calculatedScrollLeft,
                        scrollTop: calculatedScrollTop,
                        verticalScrollDirection: prevState.scrollTop < scrollTop ? "forward" : "backward",
                        scrollUpdateWasRequested: false
                    };
                }, _this._resetIsScrollingDebounced);
            };
            _this._outerRefSetter = function(ref) {
                var outerRef = _this.props.outerRef;
                _this._outerRef = ref;
                if (typeof outerRef === "function") outerRef(ref);
                else if (outerRef != null && typeof outerRef === "object" && outerRef.hasOwnProperty("current")) outerRef.current = ref;
            };
            _this._resetIsScrollingDebounced = function() {
                if (_this._resetIsScrollingTimeoutId !== null) $3cc8a1e45b82291d$var$cancelTimeout(_this._resetIsScrollingTimeoutId);
                _this._resetIsScrollingTimeoutId = $3cc8a1e45b82291d$var$requestTimeout(_this._resetIsScrolling, $3cc8a1e45b82291d$var$IS_SCROLLING_DEBOUNCE_INTERVAL);
            };
            _this._resetIsScrolling = function() {
                _this._resetIsScrollingTimeoutId = null;
                _this.setState({
                    isScrolling: false
                }, function() {
                    // Clear style cache after state update has been committed.
                    // This way we don't break pure sCU for items that don't use isScrolling param.
                    _this._getItemStyleCache(-1);
                });
            };
            return _this;
        }
        Grid.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps, prevState) {
            $3cc8a1e45b82291d$var$validateSharedProps(nextProps, prevState);
            validateProps(nextProps);
            return null;
        };
        var _proto = Grid.prototype;
        _proto.scrollTo = function scrollTo(_ref3) {
            var scrollLeft = _ref3.scrollLeft, scrollTop = _ref3.scrollTop;
            if (scrollLeft !== undefined) scrollLeft = Math.max(0, scrollLeft);
            if (scrollTop !== undefined) scrollTop = Math.max(0, scrollTop);
            this.setState(function(prevState) {
                if (scrollLeft === undefined) scrollLeft = prevState.scrollLeft;
                if (scrollTop === undefined) scrollTop = prevState.scrollTop;
                if (prevState.scrollLeft === scrollLeft && prevState.scrollTop === scrollTop) return null;
                return {
                    horizontalScrollDirection: prevState.scrollLeft < scrollLeft ? "forward" : "backward",
                    scrollLeft: scrollLeft,
                    scrollTop: scrollTop,
                    scrollUpdateWasRequested: true,
                    verticalScrollDirection: prevState.scrollTop < scrollTop ? "forward" : "backward"
                };
            }, this._resetIsScrollingDebounced);
        };
        _proto.scrollToItem = function scrollToItem(_ref4) {
            var _ref4$align = _ref4.align, align = _ref4$align === void 0 ? "auto" : _ref4$align, columnIndex = _ref4.columnIndex, rowIndex = _ref4.rowIndex;
            var _this$props2 = this.props, columnCount = _this$props2.columnCount, height = _this$props2.height, rowCount = _this$props2.rowCount, width = _this$props2.width;
            var _this$state = this.state, scrollLeft = _this$state.scrollLeft, scrollTop = _this$state.scrollTop;
            var scrollbarSize = $3cc8a1e45b82291d$var$getScrollbarSize();
            if (columnIndex !== undefined) columnIndex = Math.max(0, Math.min(columnIndex, columnCount - 1));
            if (rowIndex !== undefined) rowIndex = Math.max(0, Math.min(rowIndex, rowCount - 1));
            var estimatedTotalHeight = getEstimatedTotalHeight(this.props, this._instanceProps);
            var estimatedTotalWidth = getEstimatedTotalWidth(this.props, this._instanceProps); // The scrollbar size should be considered when scrolling an item into view,
            // to ensure it's fully visible.
            // But we only need to account for its size when it's actually visible.
            var horizontalScrollbarSize = estimatedTotalWidth > width ? scrollbarSize : 0;
            var verticalScrollbarSize = estimatedTotalHeight > height ? scrollbarSize : 0;
            this.scrollTo({
                scrollLeft: columnIndex !== undefined ? getOffsetForColumnAndAlignment(this.props, columnIndex, align, scrollLeft, this._instanceProps, verticalScrollbarSize) : scrollLeft,
                scrollTop: rowIndex !== undefined ? getOffsetForRowAndAlignment(this.props, rowIndex, align, scrollTop, this._instanceProps, horizontalScrollbarSize) : scrollTop
            });
        };
        _proto.componentDidMount = function componentDidMount() {
            var _this$props3 = this.props, initialScrollLeft = _this$props3.initialScrollLeft, initialScrollTop = _this$props3.initialScrollTop;
            if (this._outerRef != null) {
                var outerRef = this._outerRef;
                if (typeof initialScrollLeft === "number") outerRef.scrollLeft = initialScrollLeft;
                if (typeof initialScrollTop === "number") outerRef.scrollTop = initialScrollTop;
            }
            this._callPropsCallbacks();
        };
        _proto.componentDidUpdate = function componentDidUpdate() {
            var direction = this.props.direction;
            var _this$state2 = this.state, scrollLeft = _this$state2.scrollLeft, scrollTop = _this$state2.scrollTop, scrollUpdateWasRequested = _this$state2.scrollUpdateWasRequested;
            if (scrollUpdateWasRequested && this._outerRef != null) {
                // TRICKY According to the spec, scrollLeft should be negative for RTL aligned elements.
                // This is not the case for all browsers though (e.g. Chrome reports values as positive, measured relative to the left).
                // So we need to determine which browser behavior we're dealing with, and mimic it.
                var outerRef = this._outerRef;
                if (direction === "rtl") switch($3cc8a1e45b82291d$var$getRTLOffsetType()){
                    case "negative":
                        outerRef.scrollLeft = -scrollLeft;
                        break;
                    case "positive-ascending":
                        outerRef.scrollLeft = scrollLeft;
                        break;
                    default:
                        var clientWidth = outerRef.clientWidth, scrollWidth = outerRef.scrollWidth;
                        outerRef.scrollLeft = scrollWidth - clientWidth - scrollLeft;
                        break;
                }
                else outerRef.scrollLeft = Math.max(0, scrollLeft);
                outerRef.scrollTop = Math.max(0, scrollTop);
            }
            this._callPropsCallbacks();
        };
        _proto.componentWillUnmount = function componentWillUnmount() {
            if (this._resetIsScrollingTimeoutId !== null) $3cc8a1e45b82291d$var$cancelTimeout(this._resetIsScrollingTimeoutId);
        };
        _proto.render = function render() {
            var _this$props4 = this.props, children = _this$props4.children, className = _this$props4.className, columnCount = _this$props4.columnCount, direction = _this$props4.direction, height = _this$props4.height, innerRef = _this$props4.innerRef, innerElementType = _this$props4.innerElementType, innerTagName = _this$props4.innerTagName, itemData = _this$props4.itemData, _this$props4$itemKey = _this$props4.itemKey, itemKey = _this$props4$itemKey === void 0 ? $3cc8a1e45b82291d$var$defaultItemKey : _this$props4$itemKey, outerElementType = _this$props4.outerElementType, outerTagName = _this$props4.outerTagName, rowCount = _this$props4.rowCount, style = _this$props4.style, useIsScrolling = _this$props4.useIsScrolling, width = _this$props4.width;
            var isScrolling = this.state.isScrolling;
            var _this$_getHorizontalR = this._getHorizontalRangeToRender(), columnStartIndex = _this$_getHorizontalR[0], columnStopIndex = _this$_getHorizontalR[1];
            var _this$_getVerticalRan = this._getVerticalRangeToRender(), rowStartIndex = _this$_getVerticalRan[0], rowStopIndex = _this$_getVerticalRan[1];
            var items = [];
            if (columnCount > 0 && rowCount) {
                for(var _rowIndex = rowStartIndex; _rowIndex <= rowStopIndex; _rowIndex++)for(var _columnIndex = columnStartIndex; _columnIndex <= columnStopIndex; _columnIndex++)items.push((0, $bh6RR.createElement)(children, {
                    columnIndex: _columnIndex,
                    data: itemData,
                    isScrolling: useIsScrolling ? isScrolling : undefined,
                    key: itemKey({
                        columnIndex: _columnIndex,
                        data: itemData,
                        rowIndex: _rowIndex
                    }),
                    rowIndex: _rowIndex,
                    style: this._getItemStyle(_rowIndex, _columnIndex)
                }));
            } // Read this value AFTER items have been created,
            // So their actual sizes (if variable) are taken into consideration.
            var estimatedTotalHeight = getEstimatedTotalHeight(this.props, this._instanceProps);
            var estimatedTotalWidth = getEstimatedTotalWidth(this.props, this._instanceProps);
            return (0, $bh6RR.createElement)(outerElementType || outerTagName || "div", {
                className: className,
                onScroll: this._onScroll,
                ref: this._outerRefSetter,
                style: (0, $39ab41060f0dd572$export$2e2bcd8739ae039)({
                    position: "relative",
                    height: height,
                    width: width,
                    overflow: "auto",
                    WebkitOverflowScrolling: "touch",
                    willChange: "transform",
                    direction: direction
                }, style)
            }, (0, $bh6RR.createElement)(innerElementType || innerTagName || "div", {
                children: items,
                ref: innerRef,
                style: {
                    height: estimatedTotalHeight,
                    pointerEvents: isScrolling ? "none" : undefined,
                    width: estimatedTotalWidth
                }
            }));
        };
        _proto._callPropsCallbacks = function _callPropsCallbacks() {
            var _this$props5 = this.props, columnCount = _this$props5.columnCount, onItemsRendered = _this$props5.onItemsRendered, onScroll = _this$props5.onScroll, rowCount = _this$props5.rowCount;
            if (typeof onItemsRendered === "function") {
                if (columnCount > 0 && rowCount > 0) {
                    var _this$_getHorizontalR2 = this._getHorizontalRangeToRender(), _overscanColumnStartIndex = _this$_getHorizontalR2[0], _overscanColumnStopIndex = _this$_getHorizontalR2[1], _visibleColumnStartIndex = _this$_getHorizontalR2[2], _visibleColumnStopIndex = _this$_getHorizontalR2[3];
                    var _this$_getVerticalRan2 = this._getVerticalRangeToRender(), _overscanRowStartIndex = _this$_getVerticalRan2[0], _overscanRowStopIndex = _this$_getVerticalRan2[1], _visibleRowStartIndex = _this$_getVerticalRan2[2], _visibleRowStopIndex = _this$_getVerticalRan2[3];
                    this._callOnItemsRendered(_overscanColumnStartIndex, _overscanColumnStopIndex, _overscanRowStartIndex, _overscanRowStopIndex, _visibleColumnStartIndex, _visibleColumnStopIndex, _visibleRowStartIndex, _visibleRowStopIndex);
                }
            }
            if (typeof onScroll === "function") {
                var _this$state3 = this.state, _horizontalScrollDirection = _this$state3.horizontalScrollDirection, _scrollLeft = _this$state3.scrollLeft, _scrollTop = _this$state3.scrollTop, _scrollUpdateWasRequested = _this$state3.scrollUpdateWasRequested, _verticalScrollDirection = _this$state3.verticalScrollDirection;
                this._callOnScroll(_scrollLeft, _scrollTop, _horizontalScrollDirection, _verticalScrollDirection, _scrollUpdateWasRequested);
            }
        } // Lazily create and cache item styles while scrolling,
        ;
        _proto._getHorizontalRangeToRender = function _getHorizontalRangeToRender() {
            var _this$props6 = this.props, columnCount = _this$props6.columnCount, overscanColumnCount = _this$props6.overscanColumnCount, overscanColumnsCount = _this$props6.overscanColumnsCount, overscanCount = _this$props6.overscanCount, rowCount = _this$props6.rowCount;
            var _this$state4 = this.state, horizontalScrollDirection = _this$state4.horizontalScrollDirection, isScrolling = _this$state4.isScrolling, scrollLeft = _this$state4.scrollLeft;
            var overscanCountResolved = overscanColumnCount || overscanColumnsCount || overscanCount || 1;
            if (columnCount === 0 || rowCount === 0) return [
                0,
                0,
                0,
                0
            ];
            var startIndex = getColumnStartIndexForOffset(this.props, scrollLeft, this._instanceProps);
            var stopIndex = getColumnStopIndexForStartIndex(this.props, startIndex, scrollLeft, this._instanceProps); // Overscan by one item in each direction so that tab/focus works.
            // If there isn't at least one extra item, tab loops back around.
            var overscanBackward = !isScrolling || horizontalScrollDirection === "backward" ? Math.max(1, overscanCountResolved) : 1;
            var overscanForward = !isScrolling || horizontalScrollDirection === "forward" ? Math.max(1, overscanCountResolved) : 1;
            return [
                Math.max(0, startIndex - overscanBackward),
                Math.max(0, Math.min(columnCount - 1, stopIndex + overscanForward)),
                startIndex,
                stopIndex
            ];
        };
        _proto._getVerticalRangeToRender = function _getVerticalRangeToRender() {
            var _this$props7 = this.props, columnCount = _this$props7.columnCount, overscanCount = _this$props7.overscanCount, overscanRowCount = _this$props7.overscanRowCount, overscanRowsCount = _this$props7.overscanRowsCount, rowCount = _this$props7.rowCount;
            var _this$state5 = this.state, isScrolling = _this$state5.isScrolling, verticalScrollDirection = _this$state5.verticalScrollDirection, scrollTop = _this$state5.scrollTop;
            var overscanCountResolved = overscanRowCount || overscanRowsCount || overscanCount || 1;
            if (columnCount === 0 || rowCount === 0) return [
                0,
                0,
                0,
                0
            ];
            var startIndex = getRowStartIndexForOffset(this.props, scrollTop, this._instanceProps);
            var stopIndex = getRowStopIndexForStartIndex(this.props, startIndex, scrollTop, this._instanceProps); // Overscan by one item in each direction so that tab/focus works.
            // If there isn't at least one extra item, tab loops back around.
            var overscanBackward = !isScrolling || verticalScrollDirection === "backward" ? Math.max(1, overscanCountResolved) : 1;
            var overscanForward = !isScrolling || verticalScrollDirection === "forward" ? Math.max(1, overscanCountResolved) : 1;
            return [
                Math.max(0, startIndex - overscanBackward),
                Math.max(0, Math.min(rowCount - 1, stopIndex + overscanForward)),
                startIndex,
                stopIndex
            ];
        };
        return Grid;
    }((0, $bh6RR.PureComponent)), _class.defaultProps = {
        direction: "ltr",
        itemData: undefined,
        useIsScrolling: false
    }, _class;
}
var $3cc8a1e45b82291d$var$validateSharedProps = function validateSharedProps(_ref5, _ref6) {
    var children = _ref5.children, direction = _ref5.direction, height = _ref5.height, innerTagName = _ref5.innerTagName, outerTagName = _ref5.outerTagName, overscanColumnsCount = _ref5.overscanColumnsCount, overscanCount = _ref5.overscanCount, overscanRowsCount = _ref5.overscanRowsCount, width = _ref5.width;
    var instance = _ref6.instance;
};
var $3cc8a1e45b82291d$var$DEFAULT_ESTIMATED_ITEM_SIZE = 50;
var $3cc8a1e45b82291d$var$getEstimatedTotalHeight = function getEstimatedTotalHeight(_ref, _ref2) {
    var rowCount = _ref.rowCount;
    var rowMetadataMap = _ref2.rowMetadataMap, estimatedRowHeight = _ref2.estimatedRowHeight, lastMeasuredRowIndex = _ref2.lastMeasuredRowIndex;
    var totalSizeOfMeasuredRows = 0; // Edge case check for when the number of items decreases while a scroll is in progress.
    // https://github.com/bvaughn/react-window/pull/138
    if (lastMeasuredRowIndex >= rowCount) lastMeasuredRowIndex = rowCount - 1;
    if (lastMeasuredRowIndex >= 0) {
        var itemMetadata = rowMetadataMap[lastMeasuredRowIndex];
        totalSizeOfMeasuredRows = itemMetadata.offset + itemMetadata.size;
    }
    var numUnmeasuredItems = rowCount - lastMeasuredRowIndex - 1;
    var totalSizeOfUnmeasuredItems = numUnmeasuredItems * estimatedRowHeight;
    return totalSizeOfMeasuredRows + totalSizeOfUnmeasuredItems;
};
var $3cc8a1e45b82291d$var$getEstimatedTotalWidth = function getEstimatedTotalWidth(_ref3, _ref4) {
    var columnCount = _ref3.columnCount;
    var columnMetadataMap = _ref4.columnMetadataMap, estimatedColumnWidth = _ref4.estimatedColumnWidth, lastMeasuredColumnIndex = _ref4.lastMeasuredColumnIndex;
    var totalSizeOfMeasuredRows = 0; // Edge case check for when the number of items decreases while a scroll is in progress.
    // https://github.com/bvaughn/react-window/pull/138
    if (lastMeasuredColumnIndex >= columnCount) lastMeasuredColumnIndex = columnCount - 1;
    if (lastMeasuredColumnIndex >= 0) {
        var itemMetadata = columnMetadataMap[lastMeasuredColumnIndex];
        totalSizeOfMeasuredRows = itemMetadata.offset + itemMetadata.size;
    }
    var numUnmeasuredItems = columnCount - lastMeasuredColumnIndex - 1;
    var totalSizeOfUnmeasuredItems = numUnmeasuredItems * estimatedColumnWidth;
    return totalSizeOfMeasuredRows + totalSizeOfUnmeasuredItems;
};
var $3cc8a1e45b82291d$var$getItemMetadata = function getItemMetadata(itemType, props, index, instanceProps) {
    var itemMetadataMap, itemSize, lastMeasuredIndex;
    if (itemType === "column") {
        itemMetadataMap = instanceProps.columnMetadataMap;
        itemSize = props.columnWidth;
        lastMeasuredIndex = instanceProps.lastMeasuredColumnIndex;
    } else {
        itemMetadataMap = instanceProps.rowMetadataMap;
        itemSize = props.rowHeight;
        lastMeasuredIndex = instanceProps.lastMeasuredRowIndex;
    }
    if (index > lastMeasuredIndex) {
        var offset = 0;
        if (lastMeasuredIndex >= 0) {
            var itemMetadata = itemMetadataMap[lastMeasuredIndex];
            offset = itemMetadata.offset + itemMetadata.size;
        }
        for(var i = lastMeasuredIndex + 1; i <= index; i++){
            var size = itemSize(i);
            itemMetadataMap[i] = {
                offset: offset,
                size: size
            };
            offset += size;
        }
        if (itemType === "column") instanceProps.lastMeasuredColumnIndex = index;
        else instanceProps.lastMeasuredRowIndex = index;
    }
    return itemMetadataMap[index];
};
var $3cc8a1e45b82291d$var$findNearestItem = function findNearestItem(itemType, props, instanceProps, offset) {
    var itemMetadataMap, lastMeasuredIndex;
    if (itemType === "column") {
        itemMetadataMap = instanceProps.columnMetadataMap;
        lastMeasuredIndex = instanceProps.lastMeasuredColumnIndex;
    } else {
        itemMetadataMap = instanceProps.rowMetadataMap;
        lastMeasuredIndex = instanceProps.lastMeasuredRowIndex;
    }
    var lastMeasuredItemOffset = lastMeasuredIndex > 0 ? itemMetadataMap[lastMeasuredIndex].offset : 0;
    if (lastMeasuredItemOffset >= offset) // If we've already measured items within this range just use a binary search as it's faster.
    return $3cc8a1e45b82291d$var$findNearestItemBinarySearch(itemType, props, instanceProps, lastMeasuredIndex, 0, offset);
    else // If we haven't yet measured this high, fallback to an exponential search with an inner binary search.
    // The exponential search avoids pre-computing sizes for the full set of items as a binary search would.
    // The overall complexity for this approach is O(log n).
    return $3cc8a1e45b82291d$var$findNearestItemExponentialSearch(itemType, props, instanceProps, Math.max(0, lastMeasuredIndex), offset);
};
var $3cc8a1e45b82291d$var$findNearestItemBinarySearch = function findNearestItemBinarySearch(itemType, props, instanceProps, high, low, offset) {
    while(low <= high){
        var middle = low + Math.floor((high - low) / 2);
        var currentOffset = $3cc8a1e45b82291d$var$getItemMetadata(itemType, props, middle, instanceProps).offset;
        if (currentOffset === offset) return middle;
        else if (currentOffset < offset) low = middle + 1;
        else if (currentOffset > offset) high = middle - 1;
    }
    if (low > 0) return low - 1;
    else return 0;
};
var $3cc8a1e45b82291d$var$findNearestItemExponentialSearch = function findNearestItemExponentialSearch(itemType, props, instanceProps, index, offset) {
    var itemCount = itemType === "column" ? props.columnCount : props.rowCount;
    var interval = 1;
    while(index < itemCount && $3cc8a1e45b82291d$var$getItemMetadata(itemType, props, index, instanceProps).offset < offset){
        index += interval;
        interval *= 2;
    }
    return $3cc8a1e45b82291d$var$findNearestItemBinarySearch(itemType, props, instanceProps, Math.min(index, itemCount - 1), Math.floor(index / 2), offset);
};
var $3cc8a1e45b82291d$var$getOffsetForIndexAndAlignment = function getOffsetForIndexAndAlignment(itemType, props, index, align, scrollOffset, instanceProps, scrollbarSize) {
    var size = itemType === "column" ? props.width : props.height;
    var itemMetadata = $3cc8a1e45b82291d$var$getItemMetadata(itemType, props, index, instanceProps); // Get estimated total size after ItemMetadata is computed,
    // To ensure it reflects actual measurements instead of just estimates.
    var estimatedTotalSize = itemType === "column" ? $3cc8a1e45b82291d$var$getEstimatedTotalWidth(props, instanceProps) : $3cc8a1e45b82291d$var$getEstimatedTotalHeight(props, instanceProps);
    var maxOffset = Math.max(0, Math.min(estimatedTotalSize - size, itemMetadata.offset));
    var minOffset = Math.max(0, itemMetadata.offset - size + scrollbarSize + itemMetadata.size);
    if (align === "smart") {
        if (scrollOffset >= minOffset - size && scrollOffset <= maxOffset + size) align = "auto";
        else align = "center";
    }
    switch(align){
        case "start":
            return maxOffset;
        case "end":
            return minOffset;
        case "center":
            return Math.round(minOffset + (maxOffset - minOffset) / 2);
        case "auto":
        default:
            if (scrollOffset >= minOffset && scrollOffset <= maxOffset) return scrollOffset;
            else if (minOffset > maxOffset) // Because we only take into account the scrollbar size when calculating minOffset
            // this value can be larger than maxOffset when at the end of the list
            return minOffset;
            else if (scrollOffset < minOffset) return minOffset;
            else return maxOffset;
    }
};
var $3cc8a1e45b82291d$export$32c206c84102e73c = /*#__PURE__*/ $3cc8a1e45b82291d$var$createGridComponent({
    getColumnOffset: function getColumnOffset(props, index, instanceProps) {
        return $3cc8a1e45b82291d$var$getItemMetadata("column", props, index, instanceProps).offset;
    },
    getColumnStartIndexForOffset: function getColumnStartIndexForOffset(props, scrollLeft, instanceProps) {
        return $3cc8a1e45b82291d$var$findNearestItem("column", props, instanceProps, scrollLeft);
    },
    getColumnStopIndexForStartIndex: function getColumnStopIndexForStartIndex(props, startIndex, scrollLeft, instanceProps) {
        var columnCount = props.columnCount, width = props.width;
        var itemMetadata = $3cc8a1e45b82291d$var$getItemMetadata("column", props, startIndex, instanceProps);
        var maxOffset = scrollLeft + width;
        var offset = itemMetadata.offset + itemMetadata.size;
        var stopIndex = startIndex;
        while(stopIndex < columnCount - 1 && offset < maxOffset){
            stopIndex++;
            offset += $3cc8a1e45b82291d$var$getItemMetadata("column", props, stopIndex, instanceProps).size;
        }
        return stopIndex;
    },
    getColumnWidth: function getColumnWidth(props, index, instanceProps) {
        return instanceProps.columnMetadataMap[index].size;
    },
    getEstimatedTotalHeight: $3cc8a1e45b82291d$var$getEstimatedTotalHeight,
    getEstimatedTotalWidth: $3cc8a1e45b82291d$var$getEstimatedTotalWidth,
    getOffsetForColumnAndAlignment: function getOffsetForColumnAndAlignment(props, index, align, scrollOffset, instanceProps, scrollbarSize) {
        return $3cc8a1e45b82291d$var$getOffsetForIndexAndAlignment("column", props, index, align, scrollOffset, instanceProps, scrollbarSize);
    },
    getOffsetForRowAndAlignment: function getOffsetForRowAndAlignment(props, index, align, scrollOffset, instanceProps, scrollbarSize) {
        return $3cc8a1e45b82291d$var$getOffsetForIndexAndAlignment("row", props, index, align, scrollOffset, instanceProps, scrollbarSize);
    },
    getRowOffset: function getRowOffset(props, index, instanceProps) {
        return $3cc8a1e45b82291d$var$getItemMetadata("row", props, index, instanceProps).offset;
    },
    getRowHeight: function getRowHeight(props, index, instanceProps) {
        return instanceProps.rowMetadataMap[index].size;
    },
    getRowStartIndexForOffset: function getRowStartIndexForOffset(props, scrollTop, instanceProps) {
        return $3cc8a1e45b82291d$var$findNearestItem("row", props, instanceProps, scrollTop);
    },
    getRowStopIndexForStartIndex: function getRowStopIndexForStartIndex(props, startIndex, scrollTop, instanceProps) {
        var rowCount = props.rowCount, height = props.height;
        var itemMetadata = $3cc8a1e45b82291d$var$getItemMetadata("row", props, startIndex, instanceProps);
        var maxOffset = scrollTop + height;
        var offset = itemMetadata.offset + itemMetadata.size;
        var stopIndex = startIndex;
        while(stopIndex < rowCount - 1 && offset < maxOffset){
            stopIndex++;
            offset += $3cc8a1e45b82291d$var$getItemMetadata("row", props, stopIndex, instanceProps).size;
        }
        return stopIndex;
    },
    initInstanceProps: function initInstanceProps(props, instance) {
        var _ref5 = props, estimatedColumnWidth = _ref5.estimatedColumnWidth, estimatedRowHeight = _ref5.estimatedRowHeight;
        var instanceProps = {
            columnMetadataMap: {},
            estimatedColumnWidth: estimatedColumnWidth || $3cc8a1e45b82291d$var$DEFAULT_ESTIMATED_ITEM_SIZE,
            estimatedRowHeight: estimatedRowHeight || $3cc8a1e45b82291d$var$DEFAULT_ESTIMATED_ITEM_SIZE,
            lastMeasuredColumnIndex: -1,
            lastMeasuredRowIndex: -1,
            rowMetadataMap: {}
        };
        instance.resetAfterColumnIndex = function(columnIndex, shouldForceUpdate) {
            if (shouldForceUpdate === void 0) shouldForceUpdate = true;
            instance.resetAfterIndices({
                columnIndex: columnIndex,
                shouldForceUpdate: shouldForceUpdate
            });
        };
        instance.resetAfterRowIndex = function(rowIndex, shouldForceUpdate) {
            if (shouldForceUpdate === void 0) shouldForceUpdate = true;
            instance.resetAfterIndices({
                rowIndex: rowIndex,
                shouldForceUpdate: shouldForceUpdate
            });
        };
        instance.resetAfterIndices = function(_ref6) {
            var columnIndex = _ref6.columnIndex, rowIndex = _ref6.rowIndex, _ref6$shouldForceUpda = _ref6.shouldForceUpdate, shouldForceUpdate = _ref6$shouldForceUpda === void 0 ? true : _ref6$shouldForceUpda;
            if (typeof columnIndex === "number") instanceProps.lastMeasuredColumnIndex = Math.min(instanceProps.lastMeasuredColumnIndex, columnIndex - 1);
            if (typeof rowIndex === "number") instanceProps.lastMeasuredRowIndex = Math.min(instanceProps.lastMeasuredRowIndex, rowIndex - 1);
             // We could potentially optimize further by only evicting styles after this index,
            // But since styles are only cached while scrolling is in progress-
            // It seems an unnecessary optimization.
            // It's unlikely that resetAfterIndex() will be called while a user is scrolling.
            instance._getItemStyleCache(-1);
            if (shouldForceUpdate) instance.forceUpdate();
        };
        return instanceProps;
    },
    shouldResetStyleCacheOnItemSizeChange: false,
    validateProps: function validateProps(_ref7) {
        var columnWidth = _ref7.columnWidth, rowHeight = _ref7.rowHeight;
    }
});
var $3cc8a1e45b82291d$var$IS_SCROLLING_DEBOUNCE_INTERVAL$1 = 150;
var $3cc8a1e45b82291d$var$defaultItemKey$1 = function defaultItemKey(index, data) {
    return index;
}; // In DEV mode, this Set helps us only log a warning once per component instance.
// This avoids spamming the console every time a render happens.
var $3cc8a1e45b82291d$var$devWarningsDirection = null;
var $3cc8a1e45b82291d$var$devWarningsTagName$1 = null;
function $3cc8a1e45b82291d$var$createListComponent(_ref) {
    var _class;
    var getItemOffset = _ref.getItemOffset, getEstimatedTotalSize = _ref.getEstimatedTotalSize, getItemSize = _ref.getItemSize, getOffsetForIndexAndAlignment = _ref.getOffsetForIndexAndAlignment, getStartIndexForOffset = _ref.getStartIndexForOffset, getStopIndexForStartIndex = _ref.getStopIndexForStartIndex, initInstanceProps = _ref.initInstanceProps, shouldResetStyleCacheOnItemSizeChange = _ref.shouldResetStyleCacheOnItemSizeChange, validateProps = _ref.validateProps;
    return _class = /*#__PURE__*/ function(_PureComponent) {
        (0, $c375c92967c25393$export$2e2bcd8739ae039)(List, _PureComponent);
        // Always use explicit constructor for React components.
        // It produces less code after transpilation. (#26)
        // eslint-disable-next-line no-useless-constructor
        function List(props) {
            var _this;
            _this = _PureComponent.call(this, props) || this;
            _this._instanceProps = initInstanceProps(_this.props, (0, $cb0e0834598ff6d6$export$2e2bcd8739ae039)(_this));
            _this._outerRef = void 0;
            _this._resetIsScrollingTimeoutId = null;
            _this.state = {
                instance: (0, $cb0e0834598ff6d6$export$2e2bcd8739ae039)(_this),
                isScrolling: false,
                scrollDirection: "forward",
                scrollOffset: typeof _this.props.initialScrollOffset === "number" ? _this.props.initialScrollOffset : 0,
                scrollUpdateWasRequested: false
            };
            _this._callOnItemsRendered = void 0;
            _this._callOnItemsRendered = (0, $16d5efbf3de5c533$export$2e2bcd8739ae039)(function(overscanStartIndex, overscanStopIndex, visibleStartIndex, visibleStopIndex) {
                return _this.props.onItemsRendered({
                    overscanStartIndex: overscanStartIndex,
                    overscanStopIndex: overscanStopIndex,
                    visibleStartIndex: visibleStartIndex,
                    visibleStopIndex: visibleStopIndex
                });
            });
            _this._callOnScroll = void 0;
            _this._callOnScroll = (0, $16d5efbf3de5c533$export$2e2bcd8739ae039)(function(scrollDirection, scrollOffset, scrollUpdateWasRequested) {
                return _this.props.onScroll({
                    scrollDirection: scrollDirection,
                    scrollOffset: scrollOffset,
                    scrollUpdateWasRequested: scrollUpdateWasRequested
                });
            });
            _this._getItemStyle = void 0;
            _this._getItemStyle = function(index) {
                var _this$props = _this.props, direction = _this$props.direction, itemSize = _this$props.itemSize, layout = _this$props.layout;
                var itemStyleCache = _this._getItemStyleCache(shouldResetStyleCacheOnItemSizeChange && itemSize, shouldResetStyleCacheOnItemSizeChange && layout, shouldResetStyleCacheOnItemSizeChange && direction);
                var style;
                if (itemStyleCache.hasOwnProperty(index)) style = itemStyleCache[index];
                else {
                    var _offset = getItemOffset(_this.props, index, _this._instanceProps);
                    var size = getItemSize(_this.props, index, _this._instanceProps); // TODO Deprecate direction "horizontal"
                    var isHorizontal = direction === "horizontal" || layout === "horizontal";
                    var isRtl = direction === "rtl";
                    var offsetHorizontal = isHorizontal ? _offset : 0;
                    itemStyleCache[index] = style = {
                        position: "absolute",
                        left: isRtl ? undefined : offsetHorizontal,
                        right: isRtl ? offsetHorizontal : undefined,
                        top: !isHorizontal ? _offset : 0,
                        height: !isHorizontal ? size : "100%",
                        width: isHorizontal ? size : "100%"
                    };
                }
                return style;
            };
            _this._getItemStyleCache = void 0;
            _this._getItemStyleCache = (0, $16d5efbf3de5c533$export$2e2bcd8739ae039)(function(_, __, ___) {
                return {};
            });
            _this._onScrollHorizontal = function(event) {
                var _event$currentTarget = event.currentTarget, clientWidth = _event$currentTarget.clientWidth, scrollLeft = _event$currentTarget.scrollLeft, scrollWidth = _event$currentTarget.scrollWidth;
                _this.setState(function(prevState) {
                    if (prevState.scrollOffset === scrollLeft) // Scroll position may have been updated by cDM/cDU,
                    // In which case we don't need to trigger another render,
                    // And we don't want to update state.isScrolling.
                    return null;
                    var direction = _this.props.direction;
                    var scrollOffset = scrollLeft;
                    if (direction === "rtl") // TRICKY According to the spec, scrollLeft should be negative for RTL aligned elements.
                    // This is not the case for all browsers though (e.g. Chrome reports values as positive, measured relative to the left).
                    // It's also easier for this component if we convert offsets to the same format as they would be in for ltr.
                    // So the simplest solution is to determine which browser behavior we're dealing with, and convert based on it.
                    switch($3cc8a1e45b82291d$var$getRTLOffsetType()){
                        case "negative":
                            scrollOffset = -scrollLeft;
                            break;
                        case "positive-descending":
                            scrollOffset = scrollWidth - clientWidth - scrollLeft;
                            break;
                    }
                     // Prevent Safari's elastic scrolling from causing visual shaking when scrolling past bounds.
                    scrollOffset = Math.max(0, Math.min(scrollOffset, scrollWidth - clientWidth));
                    return {
                        isScrolling: true,
                        scrollDirection: prevState.scrollOffset < scrollLeft ? "forward" : "backward",
                        scrollOffset: scrollOffset,
                        scrollUpdateWasRequested: false
                    };
                }, _this._resetIsScrollingDebounced);
            };
            _this._onScrollVertical = function(event) {
                var _event$currentTarget2 = event.currentTarget, clientHeight = _event$currentTarget2.clientHeight, scrollHeight = _event$currentTarget2.scrollHeight, scrollTop = _event$currentTarget2.scrollTop;
                _this.setState(function(prevState) {
                    if (prevState.scrollOffset === scrollTop) // Scroll position may have been updated by cDM/cDU,
                    // In which case we don't need to trigger another render,
                    // And we don't want to update state.isScrolling.
                    return null;
                     // Prevent Safari's elastic scrolling from causing visual shaking when scrolling past bounds.
                    var scrollOffset = Math.max(0, Math.min(scrollTop, scrollHeight - clientHeight));
                    return {
                        isScrolling: true,
                        scrollDirection: prevState.scrollOffset < scrollOffset ? "forward" : "backward",
                        scrollOffset: scrollOffset,
                        scrollUpdateWasRequested: false
                    };
                }, _this._resetIsScrollingDebounced);
            };
            _this._outerRefSetter = function(ref) {
                var outerRef = _this.props.outerRef;
                _this._outerRef = ref;
                if (typeof outerRef === "function") outerRef(ref);
                else if (outerRef != null && typeof outerRef === "object" && outerRef.hasOwnProperty("current")) outerRef.current = ref;
            };
            _this._resetIsScrollingDebounced = function() {
                if (_this._resetIsScrollingTimeoutId !== null) $3cc8a1e45b82291d$var$cancelTimeout(_this._resetIsScrollingTimeoutId);
                _this._resetIsScrollingTimeoutId = $3cc8a1e45b82291d$var$requestTimeout(_this._resetIsScrolling, $3cc8a1e45b82291d$var$IS_SCROLLING_DEBOUNCE_INTERVAL$1);
            };
            _this._resetIsScrolling = function() {
                _this._resetIsScrollingTimeoutId = null;
                _this.setState({
                    isScrolling: false
                }, function() {
                    // Clear style cache after state update has been committed.
                    // This way we don't break pure sCU for items that don't use isScrolling param.
                    _this._getItemStyleCache(-1, null);
                });
            };
            return _this;
        }
        List.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps, prevState) {
            $3cc8a1e45b82291d$var$validateSharedProps$1(nextProps, prevState);
            validateProps(nextProps);
            return null;
        };
        var _proto = List.prototype;
        _proto.scrollTo = function scrollTo(scrollOffset) {
            scrollOffset = Math.max(0, scrollOffset);
            this.setState(function(prevState) {
                if (prevState.scrollOffset === scrollOffset) return null;
                return {
                    scrollDirection: prevState.scrollOffset < scrollOffset ? "forward" : "backward",
                    scrollOffset: scrollOffset,
                    scrollUpdateWasRequested: true
                };
            }, this._resetIsScrollingDebounced);
        };
        _proto.scrollToItem = function scrollToItem(index, align) {
            if (align === void 0) align = "auto";
            var _this$props2 = this.props, itemCount = _this$props2.itemCount, layout = _this$props2.layout;
            var scrollOffset = this.state.scrollOffset;
            index = Math.max(0, Math.min(index, itemCount - 1)); // The scrollbar size should be considered when scrolling an item into view, to ensure it's fully visible.
            // But we only need to account for its size when it's actually visible.
            // This is an edge case for lists; normally they only scroll in the dominant direction.
            var scrollbarSize = 0;
            if (this._outerRef) {
                var outerRef = this._outerRef;
                if (layout === "vertical") scrollbarSize = outerRef.scrollWidth > outerRef.clientWidth ? $3cc8a1e45b82291d$var$getScrollbarSize() : 0;
                else scrollbarSize = outerRef.scrollHeight > outerRef.clientHeight ? $3cc8a1e45b82291d$var$getScrollbarSize() : 0;
            }
            this.scrollTo(getOffsetForIndexAndAlignment(this.props, index, align, scrollOffset, this._instanceProps, scrollbarSize));
        };
        _proto.componentDidMount = function componentDidMount() {
            var _this$props3 = this.props, direction = _this$props3.direction, initialScrollOffset = _this$props3.initialScrollOffset, layout = _this$props3.layout;
            if (typeof initialScrollOffset === "number" && this._outerRef != null) {
                var outerRef = this._outerRef; // TODO Deprecate direction "horizontal"
                if (direction === "horizontal" || layout === "horizontal") outerRef.scrollLeft = initialScrollOffset;
                else outerRef.scrollTop = initialScrollOffset;
            }
            this._callPropsCallbacks();
        };
        _proto.componentDidUpdate = function componentDidUpdate() {
            var _this$props4 = this.props, direction = _this$props4.direction, layout = _this$props4.layout;
            var _this$state = this.state, scrollOffset = _this$state.scrollOffset, scrollUpdateWasRequested = _this$state.scrollUpdateWasRequested;
            if (scrollUpdateWasRequested && this._outerRef != null) {
                var outerRef = this._outerRef; // TODO Deprecate direction "horizontal"
                if (direction === "horizontal" || layout === "horizontal") {
                    if (direction === "rtl") // TRICKY According to the spec, scrollLeft should be negative for RTL aligned elements.
                    // This is not the case for all browsers though (e.g. Chrome reports values as positive, measured relative to the left).
                    // So we need to determine which browser behavior we're dealing with, and mimic it.
                    switch($3cc8a1e45b82291d$var$getRTLOffsetType()){
                        case "negative":
                            outerRef.scrollLeft = -scrollOffset;
                            break;
                        case "positive-ascending":
                            outerRef.scrollLeft = scrollOffset;
                            break;
                        default:
                            var clientWidth = outerRef.clientWidth, scrollWidth = outerRef.scrollWidth;
                            outerRef.scrollLeft = scrollWidth - clientWidth - scrollOffset;
                            break;
                    }
                    else outerRef.scrollLeft = scrollOffset;
                } else outerRef.scrollTop = scrollOffset;
            }
            this._callPropsCallbacks();
        };
        _proto.componentWillUnmount = function componentWillUnmount() {
            if (this._resetIsScrollingTimeoutId !== null) $3cc8a1e45b82291d$var$cancelTimeout(this._resetIsScrollingTimeoutId);
        };
        _proto.render = function render() {
            var _this$props5 = this.props, children = _this$props5.children, className = _this$props5.className, direction = _this$props5.direction, height = _this$props5.height, innerRef = _this$props5.innerRef, innerElementType = _this$props5.innerElementType, innerTagName = _this$props5.innerTagName, itemCount = _this$props5.itemCount, itemData = _this$props5.itemData, _this$props5$itemKey = _this$props5.itemKey, itemKey = _this$props5$itemKey === void 0 ? $3cc8a1e45b82291d$var$defaultItemKey$1 : _this$props5$itemKey, layout = _this$props5.layout, outerElementType = _this$props5.outerElementType, outerTagName = _this$props5.outerTagName, style = _this$props5.style, useIsScrolling = _this$props5.useIsScrolling, width = _this$props5.width;
            var isScrolling = this.state.isScrolling; // TODO Deprecate direction "horizontal"
            var isHorizontal = direction === "horizontal" || layout === "horizontal";
            var onScroll = isHorizontal ? this._onScrollHorizontal : this._onScrollVertical;
            var _this$_getRangeToRend = this._getRangeToRender(), startIndex = _this$_getRangeToRend[0], stopIndex = _this$_getRangeToRend[1];
            var items = [];
            if (itemCount > 0) for(var _index = startIndex; _index <= stopIndex; _index++)items.push((0, $bh6RR.createElement)(children, {
                data: itemData,
                key: itemKey(_index, itemData),
                index: _index,
                isScrolling: useIsScrolling ? isScrolling : undefined,
                style: this._getItemStyle(_index)
            }));
             // Read this value AFTER items have been created,
            // So their actual sizes (if variable) are taken into consideration.
            var estimatedTotalSize = getEstimatedTotalSize(this.props, this._instanceProps);
            return (0, $bh6RR.createElement)(outerElementType || outerTagName || "div", {
                className: className,
                onScroll: onScroll,
                ref: this._outerRefSetter,
                style: (0, $39ab41060f0dd572$export$2e2bcd8739ae039)({
                    position: "relative",
                    height: height,
                    width: width,
                    overflow: "auto",
                    WebkitOverflowScrolling: "touch",
                    willChange: "transform",
                    direction: direction
                }, style)
            }, (0, $bh6RR.createElement)(innerElementType || innerTagName || "div", {
                children: items,
                ref: innerRef,
                style: {
                    height: isHorizontal ? "100%" : estimatedTotalSize,
                    pointerEvents: isScrolling ? "none" : undefined,
                    width: isHorizontal ? estimatedTotalSize : "100%"
                }
            }));
        };
        _proto._callPropsCallbacks = function _callPropsCallbacks() {
            if (typeof this.props.onItemsRendered === "function") {
                var itemCount = this.props.itemCount;
                if (itemCount > 0) {
                    var _this$_getRangeToRend2 = this._getRangeToRender(), _overscanStartIndex = _this$_getRangeToRend2[0], _overscanStopIndex = _this$_getRangeToRend2[1], _visibleStartIndex = _this$_getRangeToRend2[2], _visibleStopIndex = _this$_getRangeToRend2[3];
                    this._callOnItemsRendered(_overscanStartIndex, _overscanStopIndex, _visibleStartIndex, _visibleStopIndex);
                }
            }
            if (typeof this.props.onScroll === "function") {
                var _this$state2 = this.state, _scrollDirection = _this$state2.scrollDirection, _scrollOffset = _this$state2.scrollOffset, _scrollUpdateWasRequested = _this$state2.scrollUpdateWasRequested;
                this._callOnScroll(_scrollDirection, _scrollOffset, _scrollUpdateWasRequested);
            }
        } // Lazily create and cache item styles while scrolling,
        ;
        _proto._getRangeToRender = function _getRangeToRender() {
            var _this$props6 = this.props, itemCount = _this$props6.itemCount, overscanCount = _this$props6.overscanCount;
            var _this$state3 = this.state, isScrolling = _this$state3.isScrolling, scrollDirection = _this$state3.scrollDirection, scrollOffset = _this$state3.scrollOffset;
            if (itemCount === 0) return [
                0,
                0,
                0,
                0
            ];
            var startIndex = getStartIndexForOffset(this.props, scrollOffset, this._instanceProps);
            var stopIndex = getStopIndexForStartIndex(this.props, startIndex, scrollOffset, this._instanceProps); // Overscan by one item in each direction so that tab/focus works.
            // If there isn't at least one extra item, tab loops back around.
            var overscanBackward = !isScrolling || scrollDirection === "backward" ? Math.max(1, overscanCount) : 1;
            var overscanForward = !isScrolling || scrollDirection === "forward" ? Math.max(1, overscanCount) : 1;
            return [
                Math.max(0, startIndex - overscanBackward),
                Math.max(0, Math.min(itemCount - 1, stopIndex + overscanForward)),
                startIndex,
                stopIndex
            ];
        };
        return List;
    }((0, $bh6RR.PureComponent)), _class.defaultProps = {
        direction: "ltr",
        itemData: undefined,
        layout: "vertical",
        overscanCount: 2,
        useIsScrolling: false
    }, _class;
} // NOTE: I considered further wrapping individual items with a pure ListItem component.
// This would avoid ever calling the render function for the same index more than once,
// But it would also add the overhead of a lot of components/fibers.
// I assume people already do this (render function returning a class component),
// So my doing it would just unnecessarily double the wrappers.
var $3cc8a1e45b82291d$var$validateSharedProps$1 = function validateSharedProps(_ref2, _ref3) {
    var children = _ref2.children, direction = _ref2.direction, height = _ref2.height, layout = _ref2.layout, innerTagName = _ref2.innerTagName, outerTagName = _ref2.outerTagName, width = _ref2.width;
    var instance = _ref3.instance;
    var isHorizontal;
};
var $3cc8a1e45b82291d$var$DEFAULT_ESTIMATED_ITEM_SIZE$1 = 50;
var $3cc8a1e45b82291d$var$getItemMetadata$1 = function getItemMetadata(props, index, instanceProps) {
    var _ref = props, itemSize = _ref.itemSize;
    var itemMetadataMap = instanceProps.itemMetadataMap, lastMeasuredIndex = instanceProps.lastMeasuredIndex;
    if (index > lastMeasuredIndex) {
        var offset = 0;
        if (lastMeasuredIndex >= 0) {
            var itemMetadata = itemMetadataMap[lastMeasuredIndex];
            offset = itemMetadata.offset + itemMetadata.size;
        }
        for(var i = lastMeasuredIndex + 1; i <= index; i++){
            var size = itemSize(i);
            itemMetadataMap[i] = {
                offset: offset,
                size: size
            };
            offset += size;
        }
        instanceProps.lastMeasuredIndex = index;
    }
    return itemMetadataMap[index];
};
var $3cc8a1e45b82291d$var$findNearestItem$1 = function findNearestItem(props, instanceProps, offset) {
    var itemMetadataMap = instanceProps.itemMetadataMap, lastMeasuredIndex = instanceProps.lastMeasuredIndex;
    var lastMeasuredItemOffset = lastMeasuredIndex > 0 ? itemMetadataMap[lastMeasuredIndex].offset : 0;
    if (lastMeasuredItemOffset >= offset) // If we've already measured items within this range just use a binary search as it's faster.
    return $3cc8a1e45b82291d$var$findNearestItemBinarySearch$1(props, instanceProps, lastMeasuredIndex, 0, offset);
    else // If we haven't yet measured this high, fallback to an exponential search with an inner binary search.
    // The exponential search avoids pre-computing sizes for the full set of items as a binary search would.
    // The overall complexity for this approach is O(log n).
    return $3cc8a1e45b82291d$var$findNearestItemExponentialSearch$1(props, instanceProps, Math.max(0, lastMeasuredIndex), offset);
};
var $3cc8a1e45b82291d$var$findNearestItemBinarySearch$1 = function findNearestItemBinarySearch(props, instanceProps, high, low, offset) {
    while(low <= high){
        var middle = low + Math.floor((high - low) / 2);
        var currentOffset = $3cc8a1e45b82291d$var$getItemMetadata$1(props, middle, instanceProps).offset;
        if (currentOffset === offset) return middle;
        else if (currentOffset < offset) low = middle + 1;
        else if (currentOffset > offset) high = middle - 1;
    }
    if (low > 0) return low - 1;
    else return 0;
};
var $3cc8a1e45b82291d$var$findNearestItemExponentialSearch$1 = function findNearestItemExponentialSearch(props, instanceProps, index, offset) {
    var itemCount = props.itemCount;
    var interval = 1;
    while(index < itemCount && $3cc8a1e45b82291d$var$getItemMetadata$1(props, index, instanceProps).offset < offset){
        index += interval;
        interval *= 2;
    }
    return $3cc8a1e45b82291d$var$findNearestItemBinarySearch$1(props, instanceProps, Math.min(index, itemCount - 1), Math.floor(index / 2), offset);
};
var $3cc8a1e45b82291d$var$getEstimatedTotalSize = function getEstimatedTotalSize(_ref2, _ref3) {
    var itemCount = _ref2.itemCount;
    var itemMetadataMap = _ref3.itemMetadataMap, estimatedItemSize = _ref3.estimatedItemSize, lastMeasuredIndex = _ref3.lastMeasuredIndex;
    var totalSizeOfMeasuredItems = 0; // Edge case check for when the number of items decreases while a scroll is in progress.
    // https://github.com/bvaughn/react-window/pull/138
    if (lastMeasuredIndex >= itemCount) lastMeasuredIndex = itemCount - 1;
    if (lastMeasuredIndex >= 0) {
        var itemMetadata = itemMetadataMap[lastMeasuredIndex];
        totalSizeOfMeasuredItems = itemMetadata.offset + itemMetadata.size;
    }
    var numUnmeasuredItems = itemCount - lastMeasuredIndex - 1;
    var totalSizeOfUnmeasuredItems = numUnmeasuredItems * estimatedItemSize;
    return totalSizeOfMeasuredItems + totalSizeOfUnmeasuredItems;
};
var $3cc8a1e45b82291d$export$d8ac3b6b20be856e = /*#__PURE__*/ $3cc8a1e45b82291d$var$createListComponent({
    getItemOffset: function getItemOffset(props, index, instanceProps) {
        return $3cc8a1e45b82291d$var$getItemMetadata$1(props, index, instanceProps).offset;
    },
    getItemSize: function getItemSize(props, index, instanceProps) {
        return instanceProps.itemMetadataMap[index].size;
    },
    getEstimatedTotalSize: $3cc8a1e45b82291d$var$getEstimatedTotalSize,
    getOffsetForIndexAndAlignment: function getOffsetForIndexAndAlignment(props, index, align, scrollOffset, instanceProps, scrollbarSize) {
        var direction = props.direction, height = props.height, layout = props.layout, width = props.width; // TODO Deprecate direction "horizontal"
        var isHorizontal = direction === "horizontal" || layout === "horizontal";
        var size = isHorizontal ? width : height;
        var itemMetadata = $3cc8a1e45b82291d$var$getItemMetadata$1(props, index, instanceProps); // Get estimated total size after ItemMetadata is computed,
        // To ensure it reflects actual measurements instead of just estimates.
        var estimatedTotalSize = $3cc8a1e45b82291d$var$getEstimatedTotalSize(props, instanceProps);
        var maxOffset = Math.max(0, Math.min(estimatedTotalSize - size, itemMetadata.offset));
        var minOffset = Math.max(0, itemMetadata.offset - size + itemMetadata.size + scrollbarSize);
        if (align === "smart") {
            if (scrollOffset >= minOffset - size && scrollOffset <= maxOffset + size) align = "auto";
            else align = "center";
        }
        switch(align){
            case "start":
                return maxOffset;
            case "end":
                return minOffset;
            case "center":
                return Math.round(minOffset + (maxOffset - minOffset) / 2);
            case "auto":
            default:
                if (scrollOffset >= minOffset && scrollOffset <= maxOffset) return scrollOffset;
                else if (scrollOffset < minOffset) return minOffset;
                else return maxOffset;
        }
    },
    getStartIndexForOffset: function getStartIndexForOffset(props, offset, instanceProps) {
        return $3cc8a1e45b82291d$var$findNearestItem$1(props, instanceProps, offset);
    },
    getStopIndexForStartIndex: function getStopIndexForStartIndex(props, startIndex, scrollOffset, instanceProps) {
        var direction = props.direction, height = props.height, itemCount = props.itemCount, layout = props.layout, width = props.width; // TODO Deprecate direction "horizontal"
        var isHorizontal = direction === "horizontal" || layout === "horizontal";
        var size = isHorizontal ? width : height;
        var itemMetadata = $3cc8a1e45b82291d$var$getItemMetadata$1(props, startIndex, instanceProps);
        var maxOffset = scrollOffset + size;
        var offset = itemMetadata.offset + itemMetadata.size;
        var stopIndex = startIndex;
        while(stopIndex < itemCount - 1 && offset < maxOffset){
            stopIndex++;
            offset += $3cc8a1e45b82291d$var$getItemMetadata$1(props, stopIndex, instanceProps).size;
        }
        return stopIndex;
    },
    initInstanceProps: function initInstanceProps(props, instance) {
        var _ref4 = props, estimatedItemSize = _ref4.estimatedItemSize;
        var instanceProps = {
            itemMetadataMap: {},
            estimatedItemSize: estimatedItemSize || $3cc8a1e45b82291d$var$DEFAULT_ESTIMATED_ITEM_SIZE$1,
            lastMeasuredIndex: -1
        };
        instance.resetAfterIndex = function(index, shouldForceUpdate) {
            if (shouldForceUpdate === void 0) shouldForceUpdate = true;
            instanceProps.lastMeasuredIndex = Math.min(instanceProps.lastMeasuredIndex, index - 1); // We could potentially optimize further by only evicting styles after this index,
            // But since styles are only cached while scrolling is in progress-
            // It seems an unnecessary optimization.
            // It's unlikely that resetAfterIndex() will be called while a user is scrolling.
            instance._getItemStyleCache(-1);
            if (shouldForceUpdate) instance.forceUpdate();
        };
        return instanceProps;
    },
    shouldResetStyleCacheOnItemSizeChange: false,
    validateProps: function validateProps(_ref5) {
        var itemSize = _ref5.itemSize;
    }
});
var $3cc8a1e45b82291d$export$f331158cccad7361 = /*#__PURE__*/ $3cc8a1e45b82291d$var$createGridComponent({
    getColumnOffset: function getColumnOffset(_ref, index) {
        var columnWidth = _ref.columnWidth;
        return index * columnWidth;
    },
    getColumnWidth: function getColumnWidth(_ref2, index) {
        var columnWidth = _ref2.columnWidth;
        return columnWidth;
    },
    getRowOffset: function getRowOffset(_ref3, index) {
        var rowHeight = _ref3.rowHeight;
        return index * rowHeight;
    },
    getRowHeight: function getRowHeight(_ref4, index) {
        var rowHeight = _ref4.rowHeight;
        return rowHeight;
    },
    getEstimatedTotalHeight: function getEstimatedTotalHeight(_ref5) {
        var rowCount = _ref5.rowCount, rowHeight = _ref5.rowHeight;
        return rowHeight * rowCount;
    },
    getEstimatedTotalWidth: function getEstimatedTotalWidth(_ref6) {
        var columnCount = _ref6.columnCount, columnWidth = _ref6.columnWidth;
        return columnWidth * columnCount;
    },
    getOffsetForColumnAndAlignment: function getOffsetForColumnAndAlignment(_ref7, columnIndex, align, scrollLeft, instanceProps, scrollbarSize) {
        var columnCount = _ref7.columnCount, columnWidth = _ref7.columnWidth, width = _ref7.width;
        var lastColumnOffset = Math.max(0, columnCount * columnWidth - width);
        var maxOffset = Math.min(lastColumnOffset, columnIndex * columnWidth);
        var minOffset = Math.max(0, columnIndex * columnWidth - width + scrollbarSize + columnWidth);
        if (align === "smart") {
            if (scrollLeft >= minOffset - width && scrollLeft <= maxOffset + width) align = "auto";
            else align = "center";
        }
        switch(align){
            case "start":
                return maxOffset;
            case "end":
                return minOffset;
            case "center":
                // "Centered" offset is usually the average of the min and max.
                // But near the edges of the list, this doesn't hold true.
                var middleOffset = Math.round(minOffset + (maxOffset - minOffset) / 2);
                if (middleOffset < Math.ceil(width / 2)) return 0; // near the beginning
                else if (middleOffset > lastColumnOffset + Math.floor(width / 2)) return lastColumnOffset; // near the end
                else return middleOffset;
            case "auto":
            default:
                if (scrollLeft >= minOffset && scrollLeft <= maxOffset) return scrollLeft;
                else if (minOffset > maxOffset) // Because we only take into account the scrollbar size when calculating minOffset
                // this value can be larger than maxOffset when at the end of the list
                return minOffset;
                else if (scrollLeft < minOffset) return minOffset;
                else return maxOffset;
        }
    },
    getOffsetForRowAndAlignment: function getOffsetForRowAndAlignment(_ref8, rowIndex, align, scrollTop, instanceProps, scrollbarSize) {
        var rowHeight = _ref8.rowHeight, height = _ref8.height, rowCount = _ref8.rowCount;
        var lastRowOffset = Math.max(0, rowCount * rowHeight - height);
        var maxOffset = Math.min(lastRowOffset, rowIndex * rowHeight);
        var minOffset = Math.max(0, rowIndex * rowHeight - height + scrollbarSize + rowHeight);
        if (align === "smart") {
            if (scrollTop >= minOffset - height && scrollTop <= maxOffset + height) align = "auto";
            else align = "center";
        }
        switch(align){
            case "start":
                return maxOffset;
            case "end":
                return minOffset;
            case "center":
                // "Centered" offset is usually the average of the min and max.
                // But near the edges of the list, this doesn't hold true.
                var middleOffset = Math.round(minOffset + (maxOffset - minOffset) / 2);
                if (middleOffset < Math.ceil(height / 2)) return 0; // near the beginning
                else if (middleOffset > lastRowOffset + Math.floor(height / 2)) return lastRowOffset; // near the end
                else return middleOffset;
            case "auto":
            default:
                if (scrollTop >= minOffset && scrollTop <= maxOffset) return scrollTop;
                else if (minOffset > maxOffset) // Because we only take into account the scrollbar size when calculating minOffset
                // this value can be larger than maxOffset when at the end of the list
                return minOffset;
                else if (scrollTop < minOffset) return minOffset;
                else return maxOffset;
        }
    },
    getColumnStartIndexForOffset: function getColumnStartIndexForOffset(_ref9, scrollLeft) {
        var columnWidth = _ref9.columnWidth, columnCount = _ref9.columnCount;
        return Math.max(0, Math.min(columnCount - 1, Math.floor(scrollLeft / columnWidth)));
    },
    getColumnStopIndexForStartIndex: function getColumnStopIndexForStartIndex(_ref10, startIndex, scrollLeft) {
        var columnWidth = _ref10.columnWidth, columnCount = _ref10.columnCount, width = _ref10.width;
        var left = startIndex * columnWidth;
        var numVisibleColumns = Math.ceil((width + scrollLeft - left) / columnWidth);
        return Math.max(0, Math.min(columnCount - 1, startIndex + numVisibleColumns - 1 // -1 is because stop index is inclusive
        ));
    },
    getRowStartIndexForOffset: function getRowStartIndexForOffset(_ref11, scrollTop) {
        var rowHeight = _ref11.rowHeight, rowCount = _ref11.rowCount;
        return Math.max(0, Math.min(rowCount - 1, Math.floor(scrollTop / rowHeight)));
    },
    getRowStopIndexForStartIndex: function getRowStopIndexForStartIndex(_ref12, startIndex, scrollTop) {
        var rowHeight = _ref12.rowHeight, rowCount = _ref12.rowCount, height = _ref12.height;
        var top = startIndex * rowHeight;
        var numVisibleRows = Math.ceil((height + scrollTop - top) / rowHeight);
        return Math.max(0, Math.min(rowCount - 1, startIndex + numVisibleRows - 1 // -1 is because stop index is inclusive
        ));
    },
    initInstanceProps: function initInstanceProps(props) {},
    shouldResetStyleCacheOnItemSizeChange: true,
    validateProps: function validateProps(_ref13) {
        var columnWidth = _ref13.columnWidth, rowHeight = _ref13.rowHeight;
    }
});
var $3cc8a1e45b82291d$export$ae9e55e1d8a2f4b7 = /*#__PURE__*/ $3cc8a1e45b82291d$var$createListComponent({
    getItemOffset: function getItemOffset(_ref, index) {
        var itemSize = _ref.itemSize;
        return index * itemSize;
    },
    getItemSize: function getItemSize(_ref2, index) {
        var itemSize = _ref2.itemSize;
        return itemSize;
    },
    getEstimatedTotalSize: function getEstimatedTotalSize(_ref3) {
        var itemCount = _ref3.itemCount, itemSize = _ref3.itemSize;
        return itemSize * itemCount;
    },
    getOffsetForIndexAndAlignment: function getOffsetForIndexAndAlignment(_ref4, index, align, scrollOffset, instanceProps, scrollbarSize) {
        var direction = _ref4.direction, height = _ref4.height, itemCount = _ref4.itemCount, itemSize = _ref4.itemSize, layout = _ref4.layout, width = _ref4.width;
        // TODO Deprecate direction "horizontal"
        var isHorizontal = direction === "horizontal" || layout === "horizontal";
        var size = isHorizontal ? width : height;
        var lastItemOffset = Math.max(0, itemCount * itemSize - size);
        var maxOffset = Math.min(lastItemOffset, index * itemSize);
        var minOffset = Math.max(0, index * itemSize - size + itemSize + scrollbarSize);
        if (align === "smart") {
            if (scrollOffset >= minOffset - size && scrollOffset <= maxOffset + size) align = "auto";
            else align = "center";
        }
        switch(align){
            case "start":
                return maxOffset;
            case "end":
                return minOffset;
            case "center":
                // "Centered" offset is usually the average of the min and max.
                // But near the edges of the list, this doesn't hold true.
                var middleOffset = Math.round(minOffset + (maxOffset - minOffset) / 2);
                if (middleOffset < Math.ceil(size / 2)) return 0; // near the beginning
                else if (middleOffset > lastItemOffset + Math.floor(size / 2)) return lastItemOffset; // near the end
                else return middleOffset;
            case "auto":
            default:
                if (scrollOffset >= minOffset && scrollOffset <= maxOffset) return scrollOffset;
                else if (scrollOffset < minOffset) return minOffset;
                else return maxOffset;
        }
    },
    getStartIndexForOffset: function getStartIndexForOffset(_ref5, offset) {
        var itemCount = _ref5.itemCount, itemSize = _ref5.itemSize;
        return Math.max(0, Math.min(itemCount - 1, Math.floor(offset / itemSize)));
    },
    getStopIndexForStartIndex: function getStopIndexForStartIndex(_ref6, startIndex, scrollOffset) {
        var direction = _ref6.direction, height = _ref6.height, itemCount = _ref6.itemCount, itemSize = _ref6.itemSize, layout = _ref6.layout, width = _ref6.width;
        // TODO Deprecate direction "horizontal"
        var isHorizontal = direction === "horizontal" || layout === "horizontal";
        var offset = startIndex * itemSize;
        var size = isHorizontal ? width : height;
        var numVisibleItems = Math.ceil((size + scrollOffset - offset) / itemSize);
        return Math.max(0, Math.min(itemCount - 1, startIndex + numVisibleItems - 1 // -1 is because stop index is inclusive
        ));
    },
    initInstanceProps: function initInstanceProps(props) {},
    shouldResetStyleCacheOnItemSizeChange: true,
    validateProps: function validateProps(_ref7) {
        var itemSize = _ref7.itemSize;
    }
});
// Pulled from react-compat
// https://github.com/developit/preact-compat/blob/7c5de00e7c85e2ffd011bf3af02899b63f699d3a/src/index.js#L349
function $3cc8a1e45b82291d$var$shallowDiffers(prev, next) {
    for(var attribute in prev){
        if (!(attribute in next)) return true;
    }
    for(var _attribute in next){
        if (prev[_attribute] !== next[_attribute]) return true;
    }
    return false;
}
var $3cc8a1e45b82291d$var$_excluded = [
    "style"
], $3cc8a1e45b82291d$var$_excluded2 = [
    "style"
];
// It knows to compare individual style props and ignore the wrapper object.
// See https://reactjs.org/docs/react-api.html#reactmemo
function $3cc8a1e45b82291d$export$b141efd0b0fb9174(prevProps, nextProps) {
    var prevStyle = prevProps.style, prevRest = (0, $cd488cd9c287f883$export$2e2bcd8739ae039)(prevProps, $3cc8a1e45b82291d$var$_excluded);
    var nextStyle = nextProps.style, nextRest = (0, $cd488cd9c287f883$export$2e2bcd8739ae039)(nextProps, $3cc8a1e45b82291d$var$_excluded2);
    return !$3cc8a1e45b82291d$var$shallowDiffers(prevStyle, nextStyle) && !$3cc8a1e45b82291d$var$shallowDiffers(prevRest, nextRest);
}
// It knows to compare individual style props and ignore the wrapper object.
// See https://reactjs.org/docs/react-component.html#shouldcomponentupdate
function $3cc8a1e45b82291d$export$aa365c903ed149ff(nextProps, nextState) {
    return !$3cc8a1e45b82291d$export$b141efd0b0fb9174(this.props, nextProps) || $3cc8a1e45b82291d$var$shallowDiffers(this.state, nextState);
}



var $bh6RR = parcelRequire("bh6RR");
function $5c6694274ebe20d5$var$isInteger(value) {
    return typeof value === "number" && isFinite(value) && Math.floor(value) === value;
}
function $5c6694274ebe20d5$var$isRangeVisible(_ref) {
    var lastRenderedStartIndex = _ref.lastRenderedStartIndex, lastRenderedStopIndex = _ref.lastRenderedStopIndex, startIndex = _ref.startIndex, stopIndex = _ref.stopIndex;
    return !(startIndex > lastRenderedStopIndex || stopIndex < lastRenderedStartIndex);
}
function $5c6694274ebe20d5$var$scanForUnloadedRanges(_ref) {
    var isItemLoaded = _ref.isItemLoaded, itemCount = _ref.itemCount, minimumBatchSize = _ref.minimumBatchSize, startIndex = _ref.startIndex, stopIndex = _ref.stopIndex;
    var unloadedRanges = [];
    var rangeStartIndex = null;
    var rangeStopIndex = null;
    for(var _index = startIndex; _index <= stopIndex; _index++){
        var loaded = isItemLoaded(_index);
        if (!loaded) {
            rangeStopIndex = _index;
            if (rangeStartIndex === null) rangeStartIndex = _index;
        } else if (rangeStopIndex !== null) {
            unloadedRanges.push(rangeStartIndex, rangeStopIndex);
            rangeStartIndex = rangeStopIndex = null;
        }
    }
    // If :rangeStopIndex is not null it means we haven't ran out of unloaded rows.
    // Scan forward to try filling our :minimumBatchSize.
    if (rangeStopIndex !== null) {
        var potentialStopIndex = Math.min(Math.max(rangeStopIndex, rangeStartIndex + minimumBatchSize - 1), itemCount - 1);
        for(var _index2 = rangeStopIndex + 1; _index2 <= potentialStopIndex; _index2++){
            if (!isItemLoaded(_index2)) rangeStopIndex = _index2;
            else break;
        }
        unloadedRanges.push(rangeStartIndex, rangeStopIndex);
    }
    // Check to see if our first range ended prematurely.
    // In this case we should scan backwards to try filling our :minimumBatchSize.
    if (unloadedRanges.length) while(unloadedRanges[1] - unloadedRanges[0] + 1 < minimumBatchSize && unloadedRanges[0] > 0){
        var _index3 = unloadedRanges[0] - 1;
        if (!isItemLoaded(_index3)) unloadedRanges[0] = _index3;
        else break;
    }
    return unloadedRanges;
}
var $5c6694274ebe20d5$var$classCallCheck = function(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
};
var $5c6694274ebe20d5$var$createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();
var $5c6694274ebe20d5$var$inherits = function(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
};
var $5c6694274ebe20d5$var$possibleConstructorReturn = function(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
};
var $5c6694274ebe20d5$var$InfiniteLoader = function(_PureComponent) {
    $5c6694274ebe20d5$var$inherits(InfiniteLoader, _PureComponent);
    function InfiniteLoader() {
        var _ref;
        var _temp, _this, _ret;
        $5c6694274ebe20d5$var$classCallCheck(this, InfiniteLoader);
        for(var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return _ret = (_temp = (_this = $5c6694274ebe20d5$var$possibleConstructorReturn(this, (_ref = InfiniteLoader.__proto__ || Object.getPrototypeOf(InfiniteLoader)).call.apply(_ref, [
            this
        ].concat(args))), _this), _this._lastRenderedStartIndex = -1, _this._lastRenderedStopIndex = -1, _this._memoizedUnloadedRanges = [], _this._onItemsRendered = function(_ref2) {
            var visibleStartIndex = _ref2.visibleStartIndex, visibleStopIndex = _ref2.visibleStopIndex;
            _this._lastRenderedStartIndex = visibleStartIndex;
            _this._lastRenderedStopIndex = visibleStopIndex;
            _this._ensureRowsLoaded(visibleStartIndex, visibleStopIndex);
        }, _this._setRef = function(listRef) {
            _this._listRef = listRef;
        }, _temp), $5c6694274ebe20d5$var$possibleConstructorReturn(_this, _ret);
    }
    $5c6694274ebe20d5$var$createClass(InfiniteLoader, [
        {
            key: "resetloadMoreItemsCache",
            value: function resetloadMoreItemsCache() {
                var autoReload = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
                this._memoizedUnloadedRanges = [];
                if (autoReload) this._ensureRowsLoaded(this._lastRenderedStartIndex, this._lastRenderedStopIndex);
            }
        },
        {
            key: "componentDidMount",
            value: function componentDidMount() {}
        },
        {
            key: "render",
            value: function render() {
                var children = this.props.children;
                return children({
                    onItemsRendered: this._onItemsRendered,
                    ref: this._setRef
                });
            }
        },
        {
            key: "_ensureRowsLoaded",
            value: function _ensureRowsLoaded(startIndex, stopIndex) {
                var _props = this.props, isItemLoaded = _props.isItemLoaded, itemCount = _props.itemCount, _props$minimumBatchSi = _props.minimumBatchSize, minimumBatchSize = _props$minimumBatchSi === undefined ? 10 : _props$minimumBatchSi, _props$threshold = _props.threshold, threshold = _props$threshold === undefined ? 15 : _props$threshold;
                var unloadedRanges = $5c6694274ebe20d5$var$scanForUnloadedRanges({
                    isItemLoaded: isItemLoaded,
                    itemCount: itemCount,
                    minimumBatchSize: minimumBatchSize,
                    startIndex: Math.max(0, startIndex - threshold),
                    stopIndex: Math.min(itemCount - 1, stopIndex + threshold)
                });
                // Avoid calling load-rows unless range has changed.
                // This shouldn't be strictly necessary, but is maybe nice to do.
                if (this._memoizedUnloadedRanges.length !== unloadedRanges.length || this._memoizedUnloadedRanges.some(function(startOrStop, index) {
                    return unloadedRanges[index] !== startOrStop;
                })) {
                    this._memoizedUnloadedRanges = unloadedRanges;
                    this._loadUnloadedRanges(unloadedRanges);
                }
            }
        },
        {
            key: "_loadUnloadedRanges",
            value: function _loadUnloadedRanges(unloadedRanges) {
                var _this2 = this;
                // loadMoreRows was renamed to loadMoreItems in v1.0.3; will be removed in v2.0
                var loadMoreItems = this.props.loadMoreItems || this.props.loadMoreRows;
                var _loop = function _loop(i) {
                    var startIndex = unloadedRanges[i];
                    var stopIndex = unloadedRanges[i + 1];
                    var promise = loadMoreItems(startIndex, stopIndex);
                    if (promise != null) promise.then(function() {
                        // Refresh the visible rows if any of them have just been loaded.
                        // Otherwise they will remain in their unloaded visual state.
                        if ($5c6694274ebe20d5$var$isRangeVisible({
                            lastRenderedStartIndex: _this2._lastRenderedStartIndex,
                            lastRenderedStopIndex: _this2._lastRenderedStopIndex,
                            startIndex: startIndex,
                            stopIndex: stopIndex
                        })) {
                            // Handle an unmount while promises are still in flight.
                            if (_this2._listRef == null) return;
                            // Resize cached row sizes for VariableSizeList,
                            // otherwise just re-render the list.
                            if (typeof _this2._listRef.resetAfterIndex === "function") _this2._listRef.resetAfterIndex(startIndex, true);
                            else {
                                // HACK reset temporarily cached item styles to force PureComponent to re-render.
                                // This is pretty gross, but I'm okay with it for now.
                                // Don't judge me.
                                if (typeof _this2._listRef._getItemStyleCache === "function") _this2._listRef._getItemStyleCache(-1);
                                _this2._listRef.forceUpdate();
                            }
                        }
                    });
                };
                for(var i = 0; i < unloadedRanges.length; i += 2)_loop(i);
            }
        }
    ]);
    return InfiniteLoader;
}((0, $bh6RR.PureComponent));
var $5c6694274ebe20d5$export$2e2bcd8739ae039 = $5c6694274ebe20d5$var$InfiniteLoader;



var $bh6RR = parcelRequire("bh6RR");
/**
 * Detect Element Resize.
 * https://github.com/sdecima/javascript-detect-element-resize
 * Sebastian Decima
 *
 * Forked from version 0.5.3; includes the following modifications:
 * 1) Guard against unsafe 'window' and 'document' references (to support SSR).
 * 2) Defer initialization code via a top-level function wrapper (to support SSR).
 * 3) Avoid unnecessary reflows by not measuring size for scroll events bubbling from children.
 * 4) Add nonce for style element.
 * 5) Use 'export' statement over 'module.exports' assignment
 **/ // Check `document` and `window` in case of server-side rendering
let $745f79e052554264$var$windowObject;
if (typeof window !== "undefined") $745f79e052554264$var$windowObject = window;
else if (typeof self !== "undefined") // eslint-disable-next-line no-restricted-globals
$745f79e052554264$var$windowObject = self;
else $745f79e052554264$var$windowObject = $parcel$global;
let $745f79e052554264$var$cancelFrame = null;
let $745f79e052554264$var$requestFrame = null;
const $745f79e052554264$var$TIMEOUT_DURATION = 20;
const $745f79e052554264$var$clearTimeoutFn = $745f79e052554264$var$windowObject.clearTimeout;
const $745f79e052554264$var$setTimeoutFn = $745f79e052554264$var$windowObject.setTimeout;
const $745f79e052554264$var$cancelAnimationFrameFn = $745f79e052554264$var$windowObject.cancelAnimationFrame || $745f79e052554264$var$windowObject.mozCancelAnimationFrame || $745f79e052554264$var$windowObject.webkitCancelAnimationFrame;
const $745f79e052554264$var$requestAnimationFrameFn = $745f79e052554264$var$windowObject.requestAnimationFrame || $745f79e052554264$var$windowObject.mozRequestAnimationFrame || $745f79e052554264$var$windowObject.webkitRequestAnimationFrame;
if ($745f79e052554264$var$cancelAnimationFrameFn == null || $745f79e052554264$var$requestAnimationFrameFn == null) {
    // For environments that don't support animation frame,
    // fallback to a setTimeout based approach.
    $745f79e052554264$var$cancelFrame = $745f79e052554264$var$clearTimeoutFn;
    $745f79e052554264$var$requestFrame = function requestAnimationFrameViaSetTimeout(callback) {
        return $745f79e052554264$var$setTimeoutFn(callback, $745f79e052554264$var$TIMEOUT_DURATION);
    };
} else {
    // Counter intuitively, environments that support animation frames can be trickier.
    // Chrome's "Throttle non-visible cross-origin iframes" flag can prevent rAFs from being called.
    // In this case, we should fallback to a setTimeout() implementation.
    $745f79e052554264$var$cancelFrame = function cancelFrame([animationFrameID, timeoutID]) {
        $745f79e052554264$var$cancelAnimationFrameFn(animationFrameID);
        $745f79e052554264$var$clearTimeoutFn(timeoutID);
    };
    $745f79e052554264$var$requestFrame = function requestAnimationFrameWithSetTimeoutFallback(callback) {
        const animationFrameID = $745f79e052554264$var$requestAnimationFrameFn(function animationFrameCallback() {
            $745f79e052554264$var$clearTimeoutFn(timeoutID);
            callback();
        });
        const timeoutID = $745f79e052554264$var$setTimeoutFn(function timeoutCallback() {
            $745f79e052554264$var$cancelAnimationFrameFn(animationFrameID);
            callback();
        }, $745f79e052554264$var$TIMEOUT_DURATION);
        return [
            animationFrameID,
            timeoutID
        ];
    };
}
function $745f79e052554264$var$createDetectElementResize(nonce) {
    let animationKeyframes;
    let animationName;
    let animationStartEvent;
    let animationStyle;
    let checkTriggers;
    let resetTriggers;
    let scrollListener;
    const attachEvent = typeof document !== "undefined" && document.attachEvent;
    if (!attachEvent) {
        resetTriggers = function(element) {
            const triggers = element.__resizeTriggers__, expand = triggers.firstElementChild, contract = triggers.lastElementChild, expandChild = expand.firstElementChild;
            contract.scrollLeft = contract.scrollWidth;
            contract.scrollTop = contract.scrollHeight;
            expandChild.style.width = expand.offsetWidth + 1 + "px";
            expandChild.style.height = expand.offsetHeight + 1 + "px";
            expand.scrollLeft = expand.scrollWidth;
            expand.scrollTop = expand.scrollHeight;
        };
        checkTriggers = function(element) {
            return element.offsetWidth !== element.__resizeLast__.width || element.offsetHeight !== element.__resizeLast__.height;
        };
        scrollListener = function(e) {
            // Don't measure (which forces) reflow for scrolls that happen inside of children!
            if (e.target.className && typeof e.target.className.indexOf === "function" && e.target.className.indexOf("contract-trigger") < 0 && e.target.className.indexOf("expand-trigger") < 0) return;
            const element = this;
            resetTriggers(this);
            if (this.__resizeRAF__) $745f79e052554264$var$cancelFrame(this.__resizeRAF__);
            this.__resizeRAF__ = $745f79e052554264$var$requestFrame(function animationFrame() {
                if (checkTriggers(element)) {
                    element.__resizeLast__.width = element.offsetWidth;
                    element.__resizeLast__.height = element.offsetHeight;
                    element.__resizeListeners__.forEach(function forEachResizeListener(fn) {
                        fn.call(element, e);
                    });
                }
            });
        };
        /* Detect CSS Animations support to detect element display/re-attach */ let animation = false;
        let keyframeprefix = "";
        animationStartEvent = "animationstart";
        const domPrefixes = "Webkit Moz O ms".split(" ");
        let startEvents = "webkitAnimationStart animationstart oAnimationStart MSAnimationStart".split(" ");
        let pfx = "";
        {
            const elm = document.createElement("fakeelement");
            if (elm.style.animationName !== undefined) animation = true;
            if (animation === false) {
                for(let i = 0; i < domPrefixes.length; i++)if (elm.style[domPrefixes[i] + "AnimationName"] !== undefined) {
                    pfx = domPrefixes[i];
                    keyframeprefix = "-" + pfx.toLowerCase() + "-";
                    animationStartEvent = startEvents[i];
                    animation = true;
                    break;
                }
            }
        }
        animationName = "resizeanim";
        animationKeyframes = "@" + keyframeprefix + "keyframes " + animationName + " { from { opacity: 0; } to { opacity: 0; } } ";
        animationStyle = keyframeprefix + "animation: 1ms " + animationName + "; ";
    }
    const createStyles = function(doc) {
        if (!doc.getElementById("detectElementResize")) {
            //opacity:0 works around a chrome bug https://code.google.com/p/chromium/issues/detail?id=286360
            const css = (animationKeyframes ? animationKeyframes : "") + ".resize-triggers { " + (animationStyle ? animationStyle : "") + "visibility: hidden; opacity: 0; } " + '.resize-triggers, .resize-triggers > div, .contract-trigger:before { content: " "; display: block; position: absolute; top: 0; left: 0; height: 100%; width: 100%; overflow: hidden; z-index: -1; } .resize-triggers > div { background: #eee; overflow: auto; } .contract-trigger:before { width: 200%; height: 200%; }', head = doc.head || doc.getElementsByTagName("head")[0], style = doc.createElement("style");
            style.id = "detectElementResize";
            style.type = "text/css";
            if (nonce != null) style.setAttribute("nonce", nonce);
            if (style.styleSheet) style.styleSheet.cssText = css;
            else style.appendChild(doc.createTextNode(css));
            head.appendChild(style);
        }
    };
    const addResizeListener = function(element, fn) {
        if (attachEvent) element.attachEvent("onresize", fn);
        else {
            if (!element.__resizeTriggers__) {
                const doc = element.ownerDocument;
                const elementStyle = $745f79e052554264$var$windowObject.getComputedStyle(element);
                if (elementStyle && elementStyle.position === "static") element.style.position = "relative";
                createStyles(doc);
                element.__resizeLast__ = {};
                element.__resizeListeners__ = [];
                (element.__resizeTriggers__ = doc.createElement("div")).className = "resize-triggers";
                const expandTrigger = doc.createElement("div");
                expandTrigger.className = "expand-trigger";
                expandTrigger.appendChild(doc.createElement("div"));
                const contractTrigger = doc.createElement("div");
                contractTrigger.className = "contract-trigger";
                element.__resizeTriggers__.appendChild(expandTrigger);
                element.__resizeTriggers__.appendChild(contractTrigger);
                element.appendChild(element.__resizeTriggers__);
                resetTriggers(element);
                element.addEventListener("scroll", scrollListener, true);
                /* Listen for a css animation to detect element display/re-attach */ if (animationStartEvent) {
                    element.__resizeTriggers__.__animationListener__ = function animationListener(e) {
                        if (e.animationName === animationName) resetTriggers(element);
                    };
                    element.__resizeTriggers__.addEventListener(animationStartEvent, element.__resizeTriggers__.__animationListener__);
                }
            }
            element.__resizeListeners__.push(fn);
        }
    };
    const removeResizeListener = function(element, fn) {
        if (attachEvent) element.detachEvent("onresize", fn);
        else {
            element.__resizeListeners__.splice(element.__resizeListeners__.indexOf(fn), 1);
            if (!element.__resizeListeners__.length) {
                element.removeEventListener("scroll", scrollListener, true);
                if (element.__resizeTriggers__.__animationListener__) {
                    element.__resizeTriggers__.removeEventListener(animationStartEvent, element.__resizeTriggers__.__animationListener__);
                    element.__resizeTriggers__.__animationListener__ = null;
                }
                try {
                    element.__resizeTriggers__ = !element.removeChild(element.__resizeTriggers__);
                } catch (e) {
                // Preact compat; see developit/preact-compat/issues/228
                }
            }
        }
    };
    return {
        addResizeListener: addResizeListener,
        removeResizeListener: removeResizeListener
    };
}
class $745f79e052554264$export$2e2bcd8739ae039 extends (0, $bh6RR.Component) {
    constructor(...args){
        super(...args);
        this.state = {
            height: this.props.defaultHeight || 0,
            scaledHeight: this.props.defaultHeight || 0,
            scaledWidth: this.props.defaultWidth || 0,
            width: this.props.defaultWidth || 0
        };
        this._autoSizer = null;
        this._detectElementResize = null;
        this._parentNode = null;
        this._resizeObserver = null;
        this._timeoutId = null;
        this._onResize = ()=>{
            this._timeoutId = null;
            const { disableHeight: disableHeight, disableWidth: disableWidth, onResize: onResize } = this.props;
            if (this._parentNode) {
                var _style$paddingLeft, _style$paddingRight, _style$paddingTop, _style$paddingBottom;
                // Guard against AutoSizer component being removed from the DOM immediately after being added.
                // This can result in invalid style values which can result in NaN values if we don't handle them.
                // See issue #150 for more context.
                const style = window.getComputedStyle(this._parentNode) || {};
                const paddingLeft = parseFloat((_style$paddingLeft = style.paddingLeft) !== null && _style$paddingLeft !== void 0 ? _style$paddingLeft : "0");
                const paddingRight = parseFloat((_style$paddingRight = style.paddingRight) !== null && _style$paddingRight !== void 0 ? _style$paddingRight : "0");
                const paddingTop = parseFloat((_style$paddingTop = style.paddingTop) !== null && _style$paddingTop !== void 0 ? _style$paddingTop : "0");
                const paddingBottom = parseFloat((_style$paddingBottom = style.paddingBottom) !== null && _style$paddingBottom !== void 0 ? _style$paddingBottom : "0");
                const rect = this._parentNode.getBoundingClientRect();
                const scaledHeight = rect.height - paddingTop - paddingBottom;
                const scaledWidth = rect.width - paddingLeft - paddingRight;
                const height = this._parentNode.offsetHeight - paddingTop - paddingBottom;
                const width = this._parentNode.offsetWidth - paddingLeft - paddingRight;
                if (!disableHeight && (this.state.height !== height || this.state.scaledHeight !== scaledHeight) || !disableWidth && (this.state.width !== width || this.state.scaledWidth !== scaledWidth)) {
                    this.setState({
                        height: height,
                        width: width,
                        scaledHeight: scaledHeight,
                        scaledWidth: scaledWidth
                    });
                    if (typeof onResize === "function") onResize({
                        height: height,
                        scaledHeight: scaledHeight,
                        scaledWidth: scaledWidth,
                        width: width
                    });
                }
            }
        };
        this._setRef = (autoSizer)=>{
            this._autoSizer = autoSizer;
        };
    }
    componentDidMount() {
        const { nonce: nonce } = this.props;
        if (this._autoSizer && this._autoSizer.parentNode && this._autoSizer.parentNode.ownerDocument && this._autoSizer.parentNode.ownerDocument.defaultView && this._autoSizer.parentNode instanceof this._autoSizer.parentNode.ownerDocument.defaultView.HTMLElement) {
            // Delay access of parentNode until mount.
            // This handles edge-cases where the component has already been unmounted before its ref has been set,
            // As well as libraries like react-lite which have a slightly different lifecycle.
            this._parentNode = this._autoSizer.parentNode;
            // Defer requiring resize handler in order to support server-side rendering.
            // See issue #41
            if (this._parentNode != null) {
                if (typeof ResizeObserver !== "undefined") {
                    this._resizeObserver = new ResizeObserver(()=>{
                        // Guard against "ResizeObserver loop limit exceeded" error;
                        // could be triggered if the state update causes the ResizeObserver handler to run long.
                        // See https://github.com/bvaughn/react-virtualized-auto-sizer/issues/55
                        this._timeoutId = setTimeout(this._onResize, 0);
                    });
                    this._resizeObserver.observe(this._parentNode);
                } else {
                    this._detectElementResize = $745f79e052554264$var$createDetectElementResize(nonce);
                    this._detectElementResize.addResizeListener(this._parentNode, this._onResize);
                }
                this._onResize();
            }
        }
    }
    componentWillUnmount() {
        if (this._parentNode) {
            if (this._detectElementResize) this._detectElementResize.removeResizeListener(this._parentNode, this._onResize);
            if (this._timeoutId !== null) clearTimeout(this._timeoutId);
            if (this._resizeObserver) {
                this._resizeObserver.observe(this._parentNode);
                this._resizeObserver.disconnect();
            }
        }
    }
    render() {
        const { children: children, defaultHeight: defaultHeight, defaultWidth: defaultWidth, disableHeight: disableHeight = false, disableWidth: disableWidth = false, nonce: nonce, onResize: onResize, style: style = {}, tagName: tagName = "div", ...rest } = this.props;
        const { height: height, scaledHeight: scaledHeight, scaledWidth: scaledWidth, width: width } = this.state;
        // Outer div should not force width/height since that may prevent containers from shrinking.
        // Inner component should overflow and use calculated width/height.
        // See issue #68 for more information.
        const outerStyle = {
            overflow: "visible"
        };
        const childParams = {};
        // Avoid rendering children before the initial measurements have been collected.
        // At best this would just be wasting cycles.
        let bailoutOnChildren = false;
        if (!disableHeight) {
            if (height === 0) bailoutOnChildren = true;
            outerStyle.height = 0;
            childParams.height = height;
            childParams.scaledHeight = scaledHeight;
        }
        if (!disableWidth) {
            if (width === 0) bailoutOnChildren = true;
            outerStyle.width = 0;
            childParams.width = width;
            childParams.scaledWidth = scaledWidth;
        }
        return (0, $bh6RR.createElement)(tagName, {
            ref: this._setRef,
            style: {
                ...outerStyle,
                ...style
            },
            ...rest
        }, !bailoutOnChildren && children(childParams));
    }
}
function $745f79e052554264$export$6a9e233b3261c1f(props) {
    return props && props.disableHeight !== true && props.disableWidth !== true;
}
function $745f79e052554264$export$232069b3e05ce32a(props) {
    return props && props.disableHeight !== true && props.disableWidth === true;
}
function $745f79e052554264$export$10ec32941a097f36(props) {
    return props && props.disableHeight === true && props.disableWidth !== true;
}




var $bh6RR = parcelRequire("bh6RR");





var $bh6RR = parcelRequire("bh6RR");
function $50865d54cfb9b593$export$5cae361ad82dce8b(value) {
    const ref = (0, $bh6RR.useRef)({
        value: value,
        previous: value
    }); // We compare values before making an update to ensure that
    // a change has been made. This ensures the previous value is
    // persisted correctly between renders.
    return (0, $bh6RR.useMemo)(()=>{
        if (ref.current.value !== value) {
            ref.current.previous = ref.current.value;
            ref.current.value = value;
        }
        return ref.current.previous;
    }, [
        value
    ]);
}





/* -------------------------------------------------------------------------------------------------
 * Checkbox
 * -----------------------------------------------------------------------------------------------*/ const $25220ff17b40fd53$var$$e698a72e93240346$var$CHECKBOX_NAME = "Checkbox";
const [$25220ff17b40fd53$var$$e698a72e93240346$var$createCheckboxContext, $25220ff17b40fd53$export$b566c4ff5488ea01] = (0, $1cecd1d75f085228$export$50c7b4e9d9f19c1)($25220ff17b40fd53$var$$e698a72e93240346$var$CHECKBOX_NAME);
const [$25220ff17b40fd53$var$$e698a72e93240346$var$CheckboxProvider, $25220ff17b40fd53$var$$e698a72e93240346$var$useCheckboxContext] = $25220ff17b40fd53$var$$e698a72e93240346$var$createCheckboxContext($25220ff17b40fd53$var$$e698a72e93240346$var$CHECKBOX_NAME);
const $25220ff17b40fd53$export$48513f6b9f8ce62d = /*#__PURE__*/ (0, $bh6RR.forwardRef)((props, forwardedRef)=>{
    const { __scopeCheckbox: __scopeCheckbox, name: name, checked: checkedProp, defaultChecked: defaultChecked, required: required, disabled: disabled, value: value = "on", onCheckedChange: onCheckedChange, ...checkboxProps } = props;
    const [button, setButton] = (0, $bh6RR.useState)(null);
    const composedRefs = (0, $e52f713866128e60$export$c7b2cbe3552a0d05)(forwardedRef, (node)=>setButton(node));
    const hasConsumerStoppedPropagationRef = (0, $bh6RR.useRef)(false); // We set this to true by default so that events bubble to forms without JS (SSR)
    const isFormControl = button ? Boolean(button.closest("form")) : true;
    const [checked = false, setChecked] = (0, $dfcfc7aa8980054c$export$6f32135080cb4c3)({
        prop: checkedProp,
        defaultProp: defaultChecked,
        onChange: onCheckedChange
    });
    const initialCheckedStateRef = (0, $bh6RR.useRef)(checked);
    (0, $bh6RR.useEffect)(()=>{
        const form = button === null || button === void 0 ? void 0 : button.form;
        if (form) {
            const reset = ()=>setChecked(initialCheckedStateRef.current);
            form.addEventListener("reset", reset);
            return ()=>form.removeEventListener("reset", reset);
        }
    }, [
        button,
        setChecked
    ]);
    return /*#__PURE__*/ (0, $bh6RR.createElement)($25220ff17b40fd53$var$$e698a72e93240346$var$CheckboxProvider, {
        scope: __scopeCheckbox,
        state: checked,
        disabled: disabled
    }, /*#__PURE__*/ (0, $bh6RR.createElement)((0, $793b1a0f4d9647b1$export$250ffa63cdc0d034).button, (0, $39ab41060f0dd572$export$2e2bcd8739ae039)({
        type: "button",
        role: "checkbox",
        "aria-checked": $25220ff17b40fd53$var$$e698a72e93240346$var$isIndeterminate(checked) ? "mixed" : checked,
        "aria-required": required,
        "data-state": $25220ff17b40fd53$var$$e698a72e93240346$var$getState(checked),
        "data-disabled": disabled ? "" : undefined,
        disabled: disabled,
        value: value
    }, checkboxProps, {
        ref: composedRefs,
        onKeyDown: (0, $93dfa6b8fe6a3629$export$b9ecd428b558ff10)(props.onKeyDown, (event)=>{
            // According to WAI ARIA, Checkboxes don't activate on enter keypress
            if (event.key === "Enter") event.preventDefault();
        }),
        onClick: (0, $93dfa6b8fe6a3629$export$b9ecd428b558ff10)(props.onClick, (event)=>{
            setChecked((prevChecked)=>$25220ff17b40fd53$var$$e698a72e93240346$var$isIndeterminate(prevChecked) ? true : !prevChecked);
            if (isFormControl) {
                hasConsumerStoppedPropagationRef.current = event.isPropagationStopped(); // if checkbox is in a form, stop propagation from the button so that we only propagate
                // one click event (from the input). We propagate changes from an input so that native
                // form validation works and form events reflect checkbox updates.
                if (!hasConsumerStoppedPropagationRef.current) event.stopPropagation();
            }
        })
    })), isFormControl && /*#__PURE__*/ (0, $bh6RR.createElement)($25220ff17b40fd53$var$$e698a72e93240346$var$BubbleInput, {
        control: button,
        bubbles: !hasConsumerStoppedPropagationRef.current,
        name: name,
        value: value,
        checked: checked,
        required: required,
        disabled: disabled // We transform because the input is absolutely positioned but we have
        ,
        style: {
            transform: "translateX(-100%)"
        }
    }));
});
/*#__PURE__*/ Object.assign($25220ff17b40fd53$export$48513f6b9f8ce62d, {
    displayName: $25220ff17b40fd53$var$$e698a72e93240346$var$CHECKBOX_NAME
});
/* -------------------------------------------------------------------------------------------------
 * CheckboxIndicator
 * -----------------------------------------------------------------------------------------------*/ const $25220ff17b40fd53$var$$e698a72e93240346$var$INDICATOR_NAME = "CheckboxIndicator";
const $25220ff17b40fd53$export$59aad738f51d1c05 = /*#__PURE__*/ (0, $bh6RR.forwardRef)((props, forwardedRef)=>{
    const { __scopeCheckbox: __scopeCheckbox, forceMount: forceMount, ...indicatorProps } = props;
    const context = $25220ff17b40fd53$var$$e698a72e93240346$var$useCheckboxContext($25220ff17b40fd53$var$$e698a72e93240346$var$INDICATOR_NAME, __scopeCheckbox);
    return /*#__PURE__*/ (0, $bh6RR.createElement)((0, $e651d1dc516f7371$export$99c2b779aa4e8b8b), {
        present: forceMount || $25220ff17b40fd53$var$$e698a72e93240346$var$isIndeterminate(context.state) || context.state === true
    }, /*#__PURE__*/ (0, $bh6RR.createElement)((0, $793b1a0f4d9647b1$export$250ffa63cdc0d034).span, (0, $39ab41060f0dd572$export$2e2bcd8739ae039)({
        "data-state": $25220ff17b40fd53$var$$e698a72e93240346$var$getState(context.state),
        "data-disabled": context.disabled ? "" : undefined
    }, indicatorProps, {
        ref: forwardedRef,
        style: {
            pointerEvents: "none",
            ...props.style
        }
    })));
});
/*#__PURE__*/ Object.assign($25220ff17b40fd53$export$59aad738f51d1c05, {
    displayName: $25220ff17b40fd53$var$$e698a72e93240346$var$INDICATOR_NAME
});
/* ---------------------------------------------------------------------------------------------- */ const $25220ff17b40fd53$var$$e698a72e93240346$var$BubbleInput = (props)=>{
    const { control: control, checked: checked, bubbles: bubbles = true, ...inputProps } = props;
    const ref = (0, $bh6RR.useRef)(null);
    const prevChecked = (0, $50865d54cfb9b593$export$5cae361ad82dce8b)(checked);
    const controlSize = (0, $3193bf9be93d584d$export$1ab7ae714698c4b8)(control); // Bubble checked change to parents (e.g form change event)
    (0, $bh6RR.useEffect)(()=>{
        const input = ref.current;
        const inputProto = window.HTMLInputElement.prototype;
        const descriptor = Object.getOwnPropertyDescriptor(inputProto, "checked");
        const setChecked = descriptor.set;
        if (prevChecked !== checked && setChecked) {
            const event = new Event("click", {
                bubbles: bubbles
            });
            input.indeterminate = $25220ff17b40fd53$var$$e698a72e93240346$var$isIndeterminate(checked);
            setChecked.call(input, $25220ff17b40fd53$var$$e698a72e93240346$var$isIndeterminate(checked) ? false : checked);
            input.dispatchEvent(event);
        }
    }, [
        prevChecked,
        checked,
        bubbles
    ]);
    return /*#__PURE__*/ (0, $bh6RR.createElement)("input", (0, $39ab41060f0dd572$export$2e2bcd8739ae039)({
        type: "checkbox",
        "aria-hidden": true,
        defaultChecked: $25220ff17b40fd53$var$$e698a72e93240346$var$isIndeterminate(checked) ? false : checked
    }, inputProps, {
        tabIndex: -1,
        ref: ref,
        style: {
            ...props.style,
            ...controlSize,
            position: "absolute",
            pointerEvents: "none",
            opacity: 0,
            margin: 0
        }
    }));
};
function $25220ff17b40fd53$var$$e698a72e93240346$var$isIndeterminate(checked) {
    return checked === "indeterminate";
}
function $25220ff17b40fd53$var$$e698a72e93240346$var$getState(checked) {
    return $25220ff17b40fd53$var$$e698a72e93240346$var$isIndeterminate(checked) ? "indeterminate" : checked ? "checked" : "unchecked";
}
const $25220ff17b40fd53$export$be92b6f5f03c0fe9 = $25220ff17b40fd53$export$48513f6b9f8ce62d;
const $25220ff17b40fd53$export$adb584737d712b70 = $25220ff17b40fd53$export$59aad738f51d1c05;




var $eaf2992787dfa231$exports = {};
$parcel$export($eaf2992787dfa231$exports, "isEvmBlockchain", function () { return $0e1ef2a85d809a3e$export$9d749b8b357dfab2; });
$parcel$export($eaf2992787dfa231$exports, "isEvmBlockchain", function () { return $c99f1fde93f890d6$exports.isEvmBlockchain; });












/**
 * Routing Result Type
 *
 */ var $9a2249edcc2d28c7$export$9244fb3192b4c649;
(function(RoutingResultType) {
    RoutingResultType["OK"] = "OK";
    RoutingResultType["HIGH_IMPACT"] = "HIGH_IMPACT";
    RoutingResultType["NO_ROUTE"] = "NO_ROUTE";
    RoutingResultType["INPUT_LIMIT_ISSUE"] = "INPUT_LIMIT_ISSUE";
})($9a2249edcc2d28c7$export$9244fb3192b4c649 || ($9a2249edcc2d28c7$export$9244fb3192b4c649 = {}));


/**
 * The type of transaction
 */ var $5d2683ae60ca88de$export$d513b00599f845d4;
(function(TransactionType) {
    TransactionType["EVM"] = "EVM";
    TransactionType["TRANSFER"] = "TRANSFER";
    TransactionType["COSMOS"] = "COSMOS";
    TransactionType["SOLANA"] = "SOLANA";
    TransactionType["TRON"] = "TRON";
    TransactionType["STARKNET"] = "STARKNET";
    TransactionType["TON"] = "TON";
})($5d2683ae60ca88de$export$d513b00599f845d4 || ($5d2683ae60ca88de$export$d513b00599f845d4 = {}));
var $5d2683ae60ca88de$export$d5c0ec10a1bea971;
(function(GenericTransactionType) {
    GenericTransactionType["EVM"] = "EVM";
    GenericTransactionType["TRANSFER"] = "TRANSFER";
    GenericTransactionType["COSMOS"] = "COSMOS";
    GenericTransactionType["SOLANA"] = "SOLANA";
})($5d2683ae60ca88de$export$d5c0ec10a1bea971 || ($5d2683ae60ca88de$export$d5c0ec10a1bea971 = {}));
function $5d2683ae60ca88de$export$882b4f79e45cc211(value) {
    return [
        "TX_FAIL",
        "TX_EXPIRED",
        "FETCH_TX_FAILED",
        "USER_REJECT",
        "USER_CANCEL",
        "USER_CANCELED_TX",
        "CALL_WALLET_FAILED",
        "SEND_TX_FAILED",
        "CALL_OR_SEND_FAILED",
        "TX_FAILED_IN_BLOCKCHAIN",
        "CLIENT_UNEXPECTED_BEHAVIOUR",
        "INSUFFICIENT_APPROVE"
    ].includes(value);
}
var $5d2683ae60ca88de$export$7c391bd3b61d2374;
(function(TransactionStatus) {
    TransactionStatus["FAILED"] = "failed";
    TransactionStatus["RUNNING"] = "running";
    TransactionStatus["SUCCESS"] = "success";
})($5d2683ae60ca88de$export$7c391bd3b61d2374 || ($5d2683ae60ca88de$export$7c391bd3b61d2374 = {}));





var $b2e620fa85cbbf21$export$16073528a91c8d2a = function(transaction) {
    return transaction.type === (0, $5d2683ae60ca88de$export$d513b00599f845d4).COSMOS;
};



var $c0dff173fa9a7879$export$b1818bc93202fd47 = function(transaction) {
    return transaction.type === (0, $5d2683ae60ca88de$export$d513b00599f845d4).SOLANA;
};



var $2287747133c92e4a$export$a6e014f972e5c64c = function(transaction) {
    return transaction.type === (0, $5d2683ae60ca88de$export$d513b00599f845d4).TRANSFER;
};



var $febb06c4c78eb9bd$export$fd5286d9851f07f6 = function(transaction) {
    return transaction.type === (0, $5d2683ae60ca88de$export$d513b00599f845d4).STARKNET;
};



var $fe455afcc68cfc13$export$9fd5291d9179852a = function(transaction) {
    return transaction.type === (0, $5d2683ae60ca88de$export$d513b00599f845d4).TRON;
};



var $04c36cb25a5aeb26$export$6ef804aee1395a14;
(function(TonChainID) {
    TonChainID["MAINNET"] = "-239";
    TonChainID["TESTNET"] = "-3";
})($04c36cb25a5aeb26$export$6ef804aee1395a14 || ($04c36cb25a5aeb26$export$6ef804aee1395a14 = {}));
var $04c36cb25a5aeb26$export$232916af2d90d322 = function(transaction) {
    return transaction.type === (0, $5d2683ae60ca88de$export$d513b00599f845d4).TON;
};




var $0e1ef2a85d809a3e$export$9d749b8b357dfab2 = function(blockchainMeta) {
    return blockchainMeta.type === "EVM";
};
var $0e1ef2a85d809a3e$export$d917e9e8a70036a6 = function(blockchainMeta) {
    return blockchainMeta.type === "COSMOS";
};
var $0e1ef2a85d809a3e$export$ff5a0a65a8982bf2 = function(blockchainMeta) {
    return blockchainMeta.type === "SOLANA";
};
var $0e1ef2a85d809a3e$export$744fa0907a94ca40 = function(blockchainMeta) {
    return blockchainMeta.type === "TRON";
};
var $0e1ef2a85d809a3e$export$83b5ebc3a9031095 = function(blockchainMeta) {
    return blockchainMeta.type === "TRANSFER";
};
var $0e1ef2a85d809a3e$export$80db8fd9e7a31db2 = function(blockchainMeta) {
    return blockchainMeta.type === "STARKNET";
};
var $0e1ef2a85d809a3e$export$9500a92ad5d775aa = function(blockchainMeta) {
    return blockchainMeta.type === "TON";
};
var $0e1ef2a85d809a3e$export$e2a694e57950e88e = function(blockchains) {
    return blockchains.filter($0e1ef2a85d809a3e$export$9d749b8b357dfab2);
};
var $0e1ef2a85d809a3e$export$11a35c42f4dd4832 = function(blockchains) {
    return blockchains.filter($0e1ef2a85d809a3e$export$ff5a0a65a8982bf2);
};
var $0e1ef2a85d809a3e$export$e1f5443c7a926d0f = function(blockchains) {
    return blockchains.filter($0e1ef2a85d809a3e$export$80db8fd9e7a31db2);
};
var $0e1ef2a85d809a3e$export$61a2144ef91f3622 = function(blockchains) {
    return blockchains.filter($0e1ef2a85d809a3e$export$744fa0907a94ca40);
};
var $0e1ef2a85d809a3e$export$7a136f0d6bb0d722 = function(blockchains) {
    return blockchains.filter($0e1ef2a85d809a3e$export$d917e9e8a70036a6);
};
var $0e1ef2a85d809a3e$export$80dff8c560b1e7ce = function(blockchains) {
    return blockchains.filter($0e1ef2a85d809a3e$export$83b5ebc3a9031095);
};
var $0e1ef2a85d809a3e$export$e38bf62be0c23ec5 = function(blockchains) {
    return blockchains.filter($0e1ef2a85d809a3e$export$9500a92ad5d775aa);
};










var $efdb004caf155fd3$export$b9109202fe95a066 = function(transaction) {
    return transaction.type === (0, $5d2683ae60ca88de$export$d513b00599f845d4).EVM;
};





































var $4b175466707c5cb9$export$b9109202fe95a066 = function(transaction) {
    return transaction.type === (0, $5d2683ae60ca88de$export$d513b00599f845d4).EVM;
};













var $c99f1fde93f890d6$exports = {};
var $c99f1fde93f890d6$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $c99f1fde93f890d6$export$1105a941ceaa4b25;
(function(SignerErrorCode) {
    SignerErrorCode["REJECTED_BY_USER"] = "REJECTED_BY_USER";
    SignerErrorCode["SIGN_TX_ERROR"] = "SIGN_TX_ERROR";
    SignerErrorCode["SEND_TX_ERROR"] = "SEND_TX_ERROR";
    SignerErrorCode["TX_FAILED_IN_BLOCKCHAIN"] = "TX_FAILED_IN_BLOCKCHAIN";
    SignerErrorCode["OPERATION_UNSUPPORTED"] = "OPERATION_UNSUPPORTED";
    SignerErrorCode["UNEXPECTED_BEHAVIOUR"] = "UNEXPECTED_BEHAVIOUR";
    SignerErrorCode["NOT_IMPLEMENTED"] = "NOT_IMPLEMENTED";
})($c99f1fde93f890d6$export$1105a941ceaa4b25 || ($c99f1fde93f890d6$export$1105a941ceaa4b25 = {}));
var $c99f1fde93f890d6$export$618932a85b762ea3;
(function(RPCErrorCode) {
    RPCErrorCode["REJECTION"] = "REJECTION";
    RPCErrorCode["UNDER_PRICED"] = "UNDER_PRICED";
    RPCErrorCode["OUT_OF_GAS"] = "OUT_OF_GAS";
    RPCErrorCode["CALL_EXCEPTION"] = "CALL_EXCEPTION";
    RPCErrorCode["INSUFFICIENT_FUNDS"] = "INSUFFICIENT_FUNDS";
    RPCErrorCode["INTERNAL"] = "INTERNAL";
    RPCErrorCode["SLIPPAGE"] = "SLIPPAGE";
    RPCErrorCode["UNKNOWN_ERROR"] = "UNKNOWN";
})($c99f1fde93f890d6$export$618932a85b762ea3 || ($c99f1fde93f890d6$export$618932a85b762ea3 = {}));
function $c99f1fde93f890d6$export$be10b575629ad8f(value) {
    return Object.keys($c99f1fde93f890d6$export$1105a941ceaa4b25).includes(value);
}
function $c99f1fde93f890d6$export$714f3eb4b9ca37c5(code) {
    var _a;
    var errorMap = (_a = {}, _a[$c99f1fde93f890d6$export$1105a941ceaa4b25.REJECTED_BY_USER] = "User rejected the transaction", _a[$c99f1fde93f890d6$export$1105a941ceaa4b25.SIGN_TX_ERROR] = "Error signing the transaction", _a[$c99f1fde93f890d6$export$1105a941ceaa4b25.SEND_TX_ERROR] = "Error sending the transaction", _a[$c99f1fde93f890d6$export$1105a941ceaa4b25.NOT_IMPLEMENTED] = "Operation not implemented", _a[$c99f1fde93f890d6$export$1105a941ceaa4b25.OPERATION_UNSUPPORTED] = "Unsupported operation", _a[$c99f1fde93f890d6$export$1105a941ceaa4b25.TX_FAILED_IN_BLOCKCHAIN] = "Transaction failed in blockchain", _a[$c99f1fde93f890d6$export$1105a941ceaa4b25.UNEXPECTED_BEHAVIOUR] = "Unexpected error", _a);
    return errorMap[code];
}
var $c99f1fde93f890d6$export$7cc7da8fa05ccee8 = /** @class */ function(_super) {
    $c99f1fde93f890d6$var$__extends(SignerError, _super);
    function SignerError(code, m, root, rpcCode, trace) {
        var _this = _super.call(this, m || $c99f1fde93f890d6$export$714f3eb4b9ca37c5(code)) || this;
        _this._isSignerError = true;
        Object.setPrototypeOf(_this, SignerError.prototype);
        SignerError.prototype._isSignerError = true;
        _this.code = code;
        _this.root = root;
        _this.rpcCode = rpcCode;
        _this.trace = trace;
        if (_this.code === $c99f1fde93f890d6$export$1105a941ceaa4b25.REJECTED_BY_USER || SignerError.isRejectedError(root)) {
            _this.code = $c99f1fde93f890d6$export$1105a941ceaa4b25.REJECTED_BY_USER;
            _this.message = "User rejected the transaction";
            _this.root = undefined;
        }
        return _this;
    }
    SignerError.isSignerError = function(obj) {
        return obj instanceof SignerError || Object.prototype.hasOwnProperty.call(obj, "_isSignerError");
    };
    SignerError.isRejectedError = function(error) {
        var POSSIBLE_REJECTION_ERRORS = [
            "rejected by user",
            "rejected by the user",
            "user canceled",
            "user rejected",
            "user denied",
            "request rejected",
            "user abort",
            "declined by user"
        ];
        if (!!error && typeof error === "string") for(var _i = 0, POSSIBLE_REJECTION_ERRORS_1 = POSSIBLE_REJECTION_ERRORS; _i < POSSIBLE_REJECTION_ERRORS_1.length; _i++){
            var msg = POSSIBLE_REJECTION_ERRORS_1[_i];
            if (error.toLowerCase().includes(msg.toLowerCase())) return true;
        }
        else if (!!error && typeof error === "object") {
            if ((error === null || error === void 0 ? void 0 : error.code) === 4001) return true;
            for(var _a = 0, POSSIBLE_REJECTION_ERRORS_2 = POSSIBLE_REJECTION_ERRORS; _a < POSSIBLE_REJECTION_ERRORS_2.length; _a++){
                var msg = POSSIBLE_REJECTION_ERRORS_2[_a];
                if (JSON.stringify(error).toLowerCase().includes(msg.toLowerCase()) || ((error === null || error === void 0 ? void 0 : error.message) || "").toLowerCase().includes(msg.toLowerCase())) return true;
            }
        }
        return false;
    };
    SignerError.UnsupportedError = function(operation) {
        return new SignerError($c99f1fde93f890d6$export$1105a941ceaa4b25.OPERATION_UNSUPPORTED, "'".concat(operation, "' is not supported by the signer"));
    };
    SignerError.UnimplementedError = function(operation) {
        return new SignerError($c99f1fde93f890d6$export$1105a941ceaa4b25.NOT_IMPLEMENTED, "'".concat(operation, "' is not implemented by the signer"));
    };
    SignerError.AssertionFailed = function(m) {
        return new SignerError($c99f1fde93f890d6$export$1105a941ceaa4b25.UNEXPECTED_BEHAVIOUR, "Assertion failed: " + m);
    };
    SignerError.prototype.getErrorDetail = function() {
        var _a;
        if (this.code === $c99f1fde93f890d6$export$1105a941ceaa4b25.REJECTED_BY_USER) return {
            code: this.code,
            message: this.message,
            detail: ((_a = this.root) === null || _a === void 0 ? void 0 : _a.message) || "User rejected the transaction"
        };
        var rawMessage = typeof this.root === "object" && this.root && this.root.error ? this.root.error : JSON.stringify(this.root);
        var rootStr = typeof this.root === "string" ? this.root : this.root instanceof Error ? this.root.message : rawMessage;
        return {
            code: this.code,
            message: this.message,
            detail: rootStr
        };
    };
    return SignerError;
}(Error);


var $2bedd37d8466fda3$export$2006fb7614e99307 = /** @class */ function() {
    function DefaultSignerFactory() {
        this.signers = {};
        this.signers = {};
    }
    DefaultSignerFactory.prototype.registerSigner = function(txType, signer) {
        this.signers[txType] = signer;
    };
    DefaultSignerFactory.prototype.getSigner = function(txType) {
        if (this.signers && txType in this.signers) {
            var signer = this.signers[txType];
            if (!!signer) return signer;
        }
        throw new Error("Signer not found for " + txType);
    };
    return DefaultSignerFactory;
}();




var $4404a18bbf3a7078$export$b1569e7f9d4064a9;
(function(PendingSwapNetworkStatus) {
    PendingSwapNetworkStatus["WaitingForConnectingWallet"] = "waitingForConnectingWallet";
    PendingSwapNetworkStatus["WaitingForQueue"] = "waitingForQueue";
    PendingSwapNetworkStatus["WaitingForNetworkChange"] = "waitingForNetworkChange";
    PendingSwapNetworkStatus["NetworkChanged"] = "networkChanged";
})($4404a18bbf3a7078$export$b1569e7f9d4064a9 || ($4404a18bbf3a7078$export$b1569e7f9d4064a9 = {}));
var $4404a18bbf3a7078$export$bb45678bd9ad9127;
(function(MessageSeverity) {
    MessageSeverity["error"] = "error";
    MessageSeverity["warning"] = "warning";
    MessageSeverity["info"] = "info";
    MessageSeverity["success"] = "success";
})($4404a18bbf3a7078$export$bb45678bd9ad9127 || ($4404a18bbf3a7078$export$bb45678bd9ad9127 = {}));





var $ihoyg = parcelRequire("ihoyg");
var $341e29ad9d46e7f7$require$Buffer = $ihoyg.Buffer;
function $341e29ad9d46e7f7$var$_regeneratorRuntime() {
    $341e29ad9d46e7f7$var$_regeneratorRuntime = function() {
        return exports;
    };
    var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, defineProperty = Object.defineProperty || function(obj, key, desc) {
        obj[key] = desc.value;
    }, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";
    function define(obj, key, value) {
        return Object.defineProperty(obj, key, {
            value: value,
            enumerable: !0,
            configurable: !0,
            writable: !0
        }), obj[key];
    }
    try {
        define({}, "");
    } catch (err) {
        define = function(obj, key, value) {
            return obj[key] = value;
        };
    }
    function wrap(innerFn, outerFn, self, tryLocsList) {
        var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []);
        return defineProperty(generator, "_invoke", {
            value: makeInvokeMethod(innerFn, self, context)
        }), generator;
    }
    function tryCatch(fn, obj, arg) {
        try {
            return {
                type: "normal",
                arg: fn.call(obj, arg)
            };
        } catch (err) {
            return {
                type: "throw",
                arg: err
            };
        }
    }
    exports.wrap = wrap;
    var ContinueSentinel = {};
    function Generator() {}
    function GeneratorFunction() {}
    function GeneratorFunctionPrototype() {}
    var IteratorPrototype = {};
    define(IteratorPrototype, iteratorSymbol, function() {
        return this;
    });
    var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([])));
    NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype);
    var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype);
    function defineIteratorMethods(prototype) {
        [
            "next",
            "throw",
            "return"
        ].forEach(function(method) {
            define(prototype, method, function(arg) {
                return this._invoke(method, arg);
            });
        });
    }
    function AsyncIterator(generator, PromiseImpl) {
        function invoke(method, arg, resolve, reject) {
            var record = tryCatch(generator[method], generator, arg);
            if ("throw" !== record.type) {
                var result = record.arg, value = result.value;
                return value && "object" == typeof value && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function(value) {
                    invoke("next", value, resolve, reject);
                }, function(err) {
                    invoke("throw", err, resolve, reject);
                }) : PromiseImpl.resolve(value).then(function(unwrapped) {
                    result.value = unwrapped, resolve(result);
                }, function(error) {
                    return invoke("throw", error, resolve, reject);
                });
            }
            reject(record.arg);
        }
        var previousPromise;
        defineProperty(this, "_invoke", {
            value: function(method, arg) {
                function callInvokeWithMethodAndArg() {
                    return new PromiseImpl(function(resolve, reject) {
                        invoke(method, arg, resolve, reject);
                    });
                }
                return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
            }
        });
    }
    function makeInvokeMethod(innerFn, self, context) {
        var state = "suspendedStart";
        return function(method, arg) {
            if ("executing" === state) throw new Error("Generator is already running");
            if ("completed" === state) {
                if ("throw" === method) throw arg;
                return doneResult();
            }
            for(context.method = method, context.arg = arg;;){
                var delegate = context.delegate;
                if (delegate) {
                    var delegateResult = maybeInvokeDelegate(delegate, context);
                    if (delegateResult) {
                        if (delegateResult === ContinueSentinel) continue;
                        return delegateResult;
                    }
                }
                if ("next" === context.method) context.sent = context._sent = context.arg;
                else if ("throw" === context.method) {
                    if ("suspendedStart" === state) throw state = "completed", context.arg;
                    context.dispatchException(context.arg);
                } else "return" === context.method && context.abrupt("return", context.arg);
                state = "executing";
                var record = tryCatch(innerFn, self, context);
                if ("normal" === record.type) {
                    if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue;
                    return {
                        value: record.arg,
                        done: context.done
                    };
                }
                "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg);
            }
        };
    }
    function maybeInvokeDelegate(delegate, context) {
        var methodName = context.method, method = delegate.iterator[methodName];
        if (undefined === method) return context.delegate = null, "throw" === methodName && delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method) || "return" !== methodName && (context.method = "throw", context.arg = new TypeError("The iterator does not provide a '" + methodName + "' method")), ContinueSentinel;
        var record = tryCatch(method, delegate.iterator, context.arg);
        if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel;
        var info = record.arg;
        return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel);
    }
    function pushTryEntry(locs) {
        var entry = {
            tryLoc: locs[0]
        };
        1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry);
    }
    function resetTryEntry(entry) {
        var record = entry.completion || {};
        record.type = "normal", delete record.arg, entry.completion = record;
    }
    function Context(tryLocsList) {
        this.tryEntries = [
            {
                tryLoc: "root"
            }
        ], tryLocsList.forEach(pushTryEntry, this), this.reset(!0);
    }
    function values(iterable) {
        if (iterable) {
            var iteratorMethod = iterable[iteratorSymbol];
            if (iteratorMethod) return iteratorMethod.call(iterable);
            if ("function" == typeof iterable.next) return iterable;
            if (!isNaN(iterable.length)) {
                var i = -1, next = function next() {
                    for(; ++i < iterable.length;)if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next;
                    return next.value = undefined, next.done = !0, next;
                };
                return next.next = next;
            }
        }
        return {
            next: doneResult
        };
    }
    function doneResult() {
        return {
            value: undefined,
            done: !0
        };
    }
    return GeneratorFunction.prototype = GeneratorFunctionPrototype, defineProperty(Gp, "constructor", {
        value: GeneratorFunctionPrototype,
        configurable: !0
    }), defineProperty(GeneratorFunctionPrototype, "constructor", {
        value: GeneratorFunction,
        configurable: !0
    }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function(genFun) {
        var ctor = "function" == typeof genFun && genFun.constructor;
        return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name));
    }, exports.mark = function(genFun) {
        return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun;
    }, exports.awrap = function(arg) {
        return {
            __await: arg
        };
    }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function() {
        return this;
    }), exports.AsyncIterator = AsyncIterator, exports.async = function(innerFn, outerFn, self, tryLocsList, PromiseImpl) {
        void 0 === PromiseImpl && (PromiseImpl = Promise);
        var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl);
        return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function(result) {
            return result.done ? result.value : iter.next();
        });
    }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function() {
        return this;
    }), define(Gp, "toString", function() {
        return "[object Generator]";
    }), exports.keys = function(val) {
        var object = Object(val), keys = [];
        for(var key in object)keys.push(key);
        return keys.reverse(), function next() {
            for(; keys.length;){
                var key = keys.pop();
                if (key in object) return next.value = key, next.done = !1, next;
            }
            return next.done = !0, next;
        };
    }, exports.values = values, Context.prototype = {
        constructor: Context,
        reset: function(skipTempReset) {
            if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for(var name in this)"t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined);
        },
        stop: function() {
            this.done = !0;
            var rootRecord = this.tryEntries[0].completion;
            if ("throw" === rootRecord.type) throw rootRecord.arg;
            return this.rval;
        },
        dispatchException: function(exception) {
            if (this.done) throw exception;
            var context = this;
            function handle(loc, caught) {
                return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught;
            }
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i], record = entry.completion;
                if ("root" === entry.tryLoc) return handle("end");
                if (entry.tryLoc <= this.prev) {
                    var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc");
                    if (hasCatch && hasFinally) {
                        if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0);
                        if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
                    } else if (hasCatch) {
                        if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0);
                    } else {
                        if (!hasFinally) throw new Error("try statement without catch or finally");
                        if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
                    }
                }
            }
        },
        abrupt: function(type, arg) {
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i];
                if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) {
                    var finallyEntry = entry;
                    break;
                }
            }
            finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null);
            var record = finallyEntry ? finallyEntry.completion : {};
            return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record);
        },
        complete: function(record, afterLoc) {
            if ("throw" === record.type) throw record.arg;
            return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel;
        },
        finish: function(finallyLoc) {
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i];
                if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel;
            }
        },
        catch: function(tryLoc) {
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i];
                if (entry.tryLoc === tryLoc) {
                    var record = entry.completion;
                    if ("throw" === record.type) {
                        var thrown = record.arg;
                        resetTryEntry(entry);
                    }
                    return thrown;
                }
            }
            throw new Error("illegal catch attempt");
        },
        delegateYield: function(iterable, resultName, nextLoc) {
            return this.delegate = {
                iterator: values(iterable),
                resultName: resultName,
                nextLoc: nextLoc
            }, "next" === this.method && (this.arg = undefined), ContinueSentinel;
        }
    }, exports;
}
function $341e29ad9d46e7f7$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) resolve(value);
    else Promise.resolve(value).then(_next, _throw);
}
function $341e29ad9d46e7f7$var$_asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                $341e29ad9d46e7f7$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                $341e29ad9d46e7f7$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function $341e29ad9d46e7f7$var$_extends() {
    $341e29ad9d46e7f7$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $341e29ad9d46e7f7$var$_extends.apply(this, arguments);
}
function $341e29ad9d46e7f7$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $341e29ad9d46e7f7$export$3fce19fdf0c5de73 = false;
var $341e29ad9d46e7f7$export$dfe7f2fe52a04245 = function getBlockChainNameFromId(chainId, blockchains) {
    var _blockchains$filter$f;
    chainId = typeof chainId === "string" && chainId.startsWith("0x") ? parseInt(chainId) : chainId;
    // Sometimes providers are passing `Network` as chainId.
    // If chainId is a `Network`, we return itself.
    var allNetworks = Object.values($341e29ad9d46e7f7$export$95be4ae94445245a);
    if (allNetworks.includes(String(chainId))) return chainId;
    if (chainId === "Binance-Chain-Tigris") return $341e29ad9d46e7f7$export$95be4ae94445245a.BINANCE;
    return ((_blockchains$filter$f = blockchains.filter(function(blockchainMeta) {
        return !!blockchainMeta.chainId;
    }).find(function(blockchainMeta) {
        var _blockchainMeta$chain;
        var blockchainChainId = (_blockchainMeta$chain = blockchainMeta.chainId) != null && _blockchainMeta$chain.startsWith("0x") ? parseInt(blockchainMeta.chainId) : blockchainMeta.chainId;
        return blockchainChainId == chainId;
    })) == null ? void 0 : _blockchains$filter$f.name) || null;
};
var $341e29ad9d46e7f7$export$d840d807f640aaf5 = function getBlockchainChainIdByName(netwok, allBlockChains) {
    var _allBlockChains$netwo;
    return ((_allBlockChains$netwo = allBlockChains[netwok]) == null ? void 0 : _allBlockChains$netwo.chainId) || null;
};
var $341e29ad9d46e7f7$export$c44b02fb03dbac82 = function uint8ArrayToHex(buffer) {
    return $341e29ad9d46e7f7$require$Buffer.from(buffer).toString("hex");
};
var $341e29ad9d46e7f7$export$5d6973e21e6f88d9;
(function(WalletType) {
    WalletType["META_MASK"] = "metamask";
    WalletType["WALLET_CONNECT"] = "wallet-connect";
    WalletType["TRUST_WALLET"] = "trust-wallet";
    WalletType["KEPLR"] = "keplr";
    WalletType["PHANTOM"] = "phantom";
    WalletType["BINANCE_CHAIN"] = "binance-chain";
    WalletType["TRON_LINK"] = "tron-link";
    WalletType["COINBASE"] = "coinbase";
    WalletType["XDEFI"] = "xdefi";
    WalletType["CLOVER"] = "clover";
    WalletType["ARGENTX"] = "argentx";
    WalletType["FRONTIER"] = "frontier";
    WalletType["COSMOSTATION"] = "cosmostation";
    WalletType["COIN98"] = "coin98";
    WalletType["SAFEPAL"] = "safepal";
    WalletType["TOKEN_POCKET"] = "token-pocket";
    WalletType["BRAVE"] = "brave";
    WalletType["MATH"] = "math";
    WalletType["EXODUS"] = "exodus";
    WalletType["OKX"] = "okx";
    WalletType["KUCOIN"] = "kucoin";
    WalletType["LEAP"] = "leap";
    WalletType["LEAP_COSMOS"] = "leap-cosmos";
    WalletType["STATION"] = "station";
    WalletType["UNKNOWN"] = "unknown";
    WalletType["ENKRYPT"] = "enkrypt";
})($341e29ad9d46e7f7$export$5d6973e21e6f88d9 || ($341e29ad9d46e7f7$export$5d6973e21e6f88d9 = {}));
var $341e29ad9d46e7f7$export$95be4ae94445245a;
(function(Network) {
    Network["BTC"] = "BTC";
    Network["BSC"] = "BSC";
    Network["LTC"] = "LTC";
    Network["THORCHAIN"] = "THOR";
    Network["BCH"] = "BCH";
    Network["BINANCE"] = "BNB";
    Network["ETHEREUM"] = "ETH";
    Network["POLYGON"] = "POLYGON";
    Network["TERRA"] = "TERRA";
    Network["POLKADOT"] = "";
    Network["TRON"] = "TRON";
    Network["DOGE"] = "DOGE";
    Network["HARMONY"] = "HARMONY";
    Network["AVAX_CCHAIN"] = "AVAX_CCHAIN";
    Network["FANTOM"] = "FANTOM";
    Network["MOONBEAM"] = "MOONBEAM";
    Network["ARBITRUM"] = "ARBITRUM";
    Network["BOBA"] = "BOBA";
    Network["OPTIMISM"] = "OPTIMISM";
    Network["FUSE"] = "FUSE";
    Network["CRONOS"] = "CRONOS";
    Network["SOLANA"] = "SOLANA";
    Network["MOONRIVER"] = "MOONRIVER";
    Network["GNOSIS"] = "GNOSIS";
    Network["COSMOS"] = "COSMOS";
    Network["OSMOSIS"] = "OSMOSIS";
    Network["AKASH"] = "AKASH";
    Network["IRIS"] = "IRIS";
    Network["PERSISTENCE"] = "PERSISTENCE";
    Network["SENTINEL"] = "SENTINEL";
    Network["REGEN"] = "REGEN";
    Network["CRYPTO_ORG"] = "CRYPTO_ORG";
    Network["SIF"] = "SIF";
    Network["CHIHUAHUA"] = "CHIHUAHUA";
    Network["JUNO"] = "JUNO";
    Network["KUJIRA"] = "KUJIRA";
    Network["STARNAME"] = "STARNAME";
    Network["COMDEX"] = "COMDEX";
    Network["STARGAZE"] = "STARGAZE";
    Network["DESMOS"] = "DESMOS";
    Network["BITCANNA"] = "BITCANNA";
    Network["SECRET"] = "SECRET";
    Network["INJECTIVE"] = "INJECTIVE";
    Network["LUMNETWORK"] = "LUMNETWORK";
    Network["BANDCHAIN"] = "BANDCHAIN";
    Network["EMONEY"] = "EMONEY";
    Network["BITSONG"] = "BITSONG";
    Network["KI"] = "KI";
    Network["MEDIBLOC"] = "MEDIBLOC";
    Network["KONSTELLATION"] = "KONSTELLATION";
    Network["UMEE"] = "UMEE";
    Network["STARKNET"] = "STARKNET";
    // Using instead of null
    Network["Unknown"] = "Unkown";
})($341e29ad9d46e7f7$export$95be4ae94445245a || ($341e29ad9d46e7f7$export$95be4ae94445245a = {}));
var $341e29ad9d46e7f7$export$7289d9aba3deaf99 = [
    $341e29ad9d46e7f7$export$95be4ae94445245a.BTC,
    $341e29ad9d46e7f7$export$95be4ae94445245a.LTC,
    $341e29ad9d46e7f7$export$95be4ae94445245a.THORCHAIN,
    $341e29ad9d46e7f7$export$95be4ae94445245a.BCH,
    $341e29ad9d46e7f7$export$95be4ae94445245a.BINANCE
];
var $341e29ad9d46e7f7$export$12e8aeb69ff35d9 = [
    $341e29ad9d46e7f7$export$5d6973e21e6f88d9.KEPLR,
    $341e29ad9d46e7f7$export$5d6973e21e6f88d9.COSMOSTATION
];
function $341e29ad9d46e7f7$export$6c40052bed430212(obj) {
    var copy;
    // Handle the 3 simple types, and null or undefined
    if (null == obj || "object" != typeof obj) return obj;
    // Handle Date
    if (obj instanceof Date) {
        copy = new Date();
        copy.setTime(obj.getTime());
        return copy;
    }
    // Handle Array
    if (obj instanceof Array) {
        copy = [];
        for(var i = 0, len = obj.length; i < len; i++)copy[i] = $341e29ad9d46e7f7$export$6c40052bed430212(obj[i]);
        return copy;
    }
    // Handle Object
    if (obj instanceof Object) {
        copy = {};
        for(var attr in obj)if (Object.prototype.hasOwnProperty.call(obj, attr)) copy[attr] = $341e29ad9d46e7f7$export$6c40052bed430212(obj[attr]);
        return copy;
    }
    throw new Error("Unable to copy obj! Its type isn't supported.");
}
function $341e29ad9d46e7f7$export$56ce9af15430dcbb(_x, _x2, _x3) {
    return $341e29ad9d46e7f7$var$_switchOrAddNetworkForMetamaskCompatibleWallets.apply(this, arguments);
}
function $341e29ad9d46e7f7$var$_switchOrAddNetworkForMetamaskCompatibleWallets() {
    $341e29ad9d46e7f7$var$_switchOrAddNetworkForMetamaskCompatibleWallets = $341e29ad9d46e7f7$var$_asyncToGenerator(/*#__PURE__*/ $341e29ad9d46e7f7$var$_regeneratorRuntime().mark(function _callee2(instance, network, evmNetworksChainInfo) {
        var targetChain, error;
        return $341e29ad9d46e7f7$var$_regeneratorRuntime().wrap(function _callee2$(_context2) {
            while(true)switch(_context2.prev = _context2.next){
                case 0:
                    targetChain = evmNetworksChainInfo[network];
                    _context2.prev = 1;
                    _context2.next = 4;
                    return instance.request({
                        method: "wallet_switchEthereumChain",
                        params: [
                            {
                                chainId: targetChain == null ? void 0 : targetChain.chainId
                            }
                        ]
                    });
                case 4:
                    _context2.next = 17;
                    break;
                case 6:
                    _context2.prev = 6;
                    _context2.t0 = _context2["catch"](1);
                    // @ts-ignore
                    // To resolve this error: Catch clause variable type annotation must be any or unknown if specified
                    error = _context2.t0;
                    if (targetChain) {
                        _context2.next = 13;
                        break;
                    }
                    throw new Error("It seems you don't have " + network + " network on your wallet. Please add it manually.");
                case 13:
                    if (!(error.code === 4902 || !error.code)) {
                        _context2.next = 16;
                        break;
                    }
                    _context2.next = 16;
                    return instance.request({
                        method: "wallet_addEthereumChain",
                        params: [
                            targetChain
                        ]
                    });
                case 16:
                    throw _context2.t0;
                case 17:
                case "end":
                    return _context2.stop();
            }
        }, _callee2, null, [
            [
                1,
                6
            ]
        ]);
    }));
    return $341e29ad9d46e7f7$var$_switchOrAddNetworkForMetamaskCompatibleWallets.apply(this, arguments);
}
function $341e29ad9d46e7f7$export$83e74882c5df8fe1(forPromise, time) {
    var timeoutPromise = new Promise(function(_, reject) {
        setTimeout(function() {
            reject("Timeout!");
        }, time);
    });
    return Promise.race([
        forPromise,
        timeoutPromise
    ]);
}
var $341e29ad9d46e7f7$export$f0e13d51b5c692b6 = function convertEvmBlockchainMetaToEvmChainInfo(evmBlockchains) {
    return evmBlockchains.reduce(function(evmNetWorksChainInfo, blockchainMeta) {
        return evmNetWorksChainInfo[blockchainMeta.name] = {
            chainName: blockchainMeta.info.chainName,
            chainId: blockchainMeta.chainId,
            nativeCurrency: blockchainMeta.info.nativeCurrency,
            rpcUrls: blockchainMeta.info.rpcUrls,
            blockExplorerUrls: blockchainMeta.info.blockExplorerUrls
        }, evmNetWorksChainInfo;
    }, {});
};
var $341e29ad9d46e7f7$export$6965bcf5cb20b5b5 = function evmChainsToRpcMap(evmNetworkChainInfo) {
    return Object.fromEntries(new Map(Object.keys(evmNetworkChainInfo).map(function(chainName) {
        var info = evmNetworkChainInfo[chainName];
        // This `if` is only used for satisfying typescript,
        // Because we iterating over Object.keys(EVM_NETWORKS_CHAIN_INFO)
        // And obviously it cannot be `undefined` and always has a value.
        if (!!info) return [
            parseInt(info.chainId),
            info.rpcUrls[0]
        ];
        return [
            0,
            ""
        ];
    })));
};
var $341e29ad9d46e7f7$export$a009f0f0c363aa6c = /*#__PURE__*/ function() {
    var _ref2 = /*#__PURE__*/ $341e29ad9d46e7f7$var$_asyncToGenerator(/*#__PURE__*/ $341e29ad9d46e7f7$var$_regeneratorRuntime().mark(function _callee(_ref) {
        var instance, solanaResponse, account;
        return $341e29ad9d46e7f7$var$_regeneratorRuntime().wrap(function _callee$(_context) {
            while(true)switch(_context.prev = _context.next){
                case 0:
                    instance = _ref.instance;
                    _context.prev = 1;
                    _context.next = 4;
                    return instance.connect();
                case 4:
                    solanaResponse = _context.sent;
                    _context.next = 10;
                    break;
                case 7:
                    _context.prev = 7;
                    _context.t0 = _context["catch"](1);
                    throw _context.t0;
                case 10:
                    account = solanaResponse.publicKey.toString();
                    return _context.abrupt("return", {
                        accounts: [
                            account
                        ],
                        chainId: $341e29ad9d46e7f7$export$95be4ae94445245a.SOLANA
                    });
                case 12:
                case "end":
                    return _context.stop();
            }
        }, _callee, null, [
            [
                1,
                7
            ]
        ]);
    }));
    return function getSolanaAccounts(_x4) {
        return _ref2.apply(this, arguments);
    };
}();
function $341e29ad9d46e7f7$export$bc1a75e20816804a(lookingFor) {
    if (lookingFor === void 0) lookingFor = "coinbase";
    var _window = window, ethereum = _window.ethereum, coinbaseSolana = _window.coinbaseSolana;
    var instances = new Map();
    if (!!ethereum) {
        var _ethereum$providers;
        var checker = lookingFor === "metamask" ? "isMetaMask" : "isCoinbaseWallet";
        // If only Coinbase Wallet is installed
        if (lookingFor === "coinbase" && ethereum[checker]) instances.set($341e29ad9d46e7f7$export$95be4ae94445245a.ETHEREUM, ethereum);
        else if ((_ethereum$providers = ethereum.providers) != null && _ethereum$providers.length) {
            var ethInstance = ethereum.providers.find(function(provider) {
                return provider[checker];
            });
            instances.set($341e29ad9d46e7f7$export$95be4ae94445245a.ETHEREUM, ethInstance);
        }
    }
    if (!!coinbaseSolana && lookingFor === "coinbase") instances.set($341e29ad9d46e7f7$export$95be4ae94445245a.SOLANA, coinbaseSolana);
    if (instances.size === 0) return null;
    if (lookingFor === "metamask") return instances.get($341e29ad9d46e7f7$export$95be4ae94445245a.ETHEREUM);
    return instances;
}
function $341e29ad9d46e7f7$export$83c5a315dd1cff42(wallets) {
    return wallets.sort(function(a, b) {
        return Number(b.connected) - Number(a.connected) || Number(b.extensionAvailable) - Number(a.extensionAvailable);
    });
}
function $341e29ad9d46e7f7$var$isBrave() {
    var isBrave = false;
    var nav = navigator;
    if (nav.brave && nav.brave.isBrave) nav.brave.isBrave().then(function(res) {
        if (res) isBrave = true;
    });
    return isBrave;
}
function $341e29ad9d46e7f7$export$fd0008baca2bf83d(install) {
    if (typeof install !== "object") return install;
    else {
        var _navigator$userAgent, _navigator$userAgent2, _navigator$userAgent3;
        var link;
        if ($341e29ad9d46e7f7$var$isBrave()) link = install.BRAVE;
        else if (((_navigator$userAgent = navigator.userAgent) == null ? void 0 : _navigator$userAgent.toLowerCase().indexOf("chrome")) !== -1) link = install.CHROME;
        else if (((_navigator$userAgent2 = navigator.userAgent) == null ? void 0 : _navigator$userAgent2.toLowerCase().indexOf("firefox")) !== -1) link = install.FIREFOX;
        else if (((_navigator$userAgent3 = navigator.userAgent) == null ? void 0 : _navigator$userAgent3.toLowerCase().indexOf("edge")) !== -1) link = install.EDGE;
        return link || install.DEFAULT;
    }
}
function $341e29ad9d46e7f7$export$486f06d416851c61() {
    return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
}
function $341e29ad9d46e7f7$export$785cd5e95d0717c1(_x) {
    return $341e29ad9d46e7f7$var$_getEvmAccounts.apply(this, arguments);
}
function $341e29ad9d46e7f7$var$_getEvmAccounts() {
    $341e29ad9d46e7f7$var$_getEvmAccounts = $341e29ad9d46e7f7$var$_asyncToGenerator(/*#__PURE__*/ $341e29ad9d46e7f7$var$_regeneratorRuntime().mark(function _callee2(instance) {
        var _yield$Promise$all, accounts, chainId;
        return $341e29ad9d46e7f7$var$_regeneratorRuntime().wrap(function _callee2$(_context2) {
            while(true)switch(_context2.prev = _context2.next){
                case 0:
                    _context2.next = 2;
                    return Promise.all([
                        instance.request({
                            method: "eth_requestAccounts"
                        }),
                        instance.request({
                            method: "eth_chainId"
                        })
                    ]);
                case 2:
                    _yield$Promise$all = _context2.sent;
                    accounts = _yield$Promise$all[0];
                    chainId = _yield$Promise$all[1];
                    return _context2.abrupt("return", {
                        accounts: accounts,
                        chainId: chainId
                    });
                case 6:
                case "end":
                    return _context2.stop();
            }
        }, _callee2);
    }));
    return $341e29ad9d46e7f7$var$_getEvmAccounts.apply(this, arguments);
}
var $341e29ad9d46e7f7$export$dae4ecb17c5c4020 = function subscribeToEvm(_ref) {
    var instance = _ref.instance, state = _ref.state, updateChainId = _ref.updateChainId, updateAccounts = _ref.updateAccounts;
    instance == null || instance.on("accountsChanged", function(addresses) {
        // TODO: after enabling autoconnect, we can consider this condition
        // to be removed.
        // The problem was if a user already connected its wallet,
        // Metamask is triggering this event on first load, so when autoconnect is disabled,
        // it's automaticlally change the state of wallet to `connected`.
        if (state.connected) updateAccounts(addresses);
    });
    instance == null || instance.on("chainChanged", function(chainId) {
        updateChainId(chainId);
    });
};
var $341e29ad9d46e7f7$export$394219efce660c44 = /*#__PURE__*/ function() {
    var _ref3 = /*#__PURE__*/ $341e29ad9d46e7f7$var$_asyncToGenerator(/*#__PURE__*/ $341e29ad9d46e7f7$var$_regeneratorRuntime().mark(function _callee(_ref2) {
        var instance, network, meta, evmBlockchains, evmInstance;
        return $341e29ad9d46e7f7$var$_regeneratorRuntime().wrap(function _callee$(_context) {
            while(true)switch(_context.prev = _context.next){
                case 0:
                    instance = _ref2.instance, network = _ref2.network, meta = _ref2.meta;
                    evmBlockchains = meta.filter((0, $0e1ef2a85d809a3e$export$9d749b8b357dfab2));
                    evmInstance = $341e29ad9d46e7f7$export$2029b78bc980a576(instance, $341e29ad9d46e7f7$export$95be4ae94445245a.ETHEREUM);
                    _context.next = 5;
                    return $341e29ad9d46e7f7$export$56ce9af15430dcbb(evmInstance, network, $341e29ad9d46e7f7$export$f0e13d51b5c692b6(evmBlockchains));
                case 5:
                case "end":
                    return _context.stop();
            }
        }, _callee);
    }));
    return function switchNetworkForEvm(_x2) {
        return _ref3.apply(this, arguments);
    };
}();
var $341e29ad9d46e7f7$export$86abff8ce014c125 = function canSwitchNetworkToEvm(_ref4) {
    var network = _ref4.network, meta = _ref4.meta;
    return $341e29ad9d46e7f7$export$9c76cdd331bb450e(meta).includes(network);
};
function $341e29ad9d46e7f7$export$9c76cdd331bb450e(meta) {
    return meta.filter((0, $0e1ef2a85d809a3e$export$9d749b8b357dfab2)).map(function(blockchain) {
        return blockchain.name;
    });
}
function $341e29ad9d46e7f7$export$d1cfcb1ce8ae2e4e(network, meta) {
    if (!network) return null;
    var evmBlockchains = $341e29ad9d46e7f7$export$9c76cdd331bb450e(meta);
    return evmBlockchains.includes(network) ? $341e29ad9d46e7f7$export$95be4ae94445245a.ETHEREUM : null;
}
function $341e29ad9d46e7f7$var$isEvmNetwork(network, meta) {
    if (!network) return false;
    return $341e29ad9d46e7f7$export$9c76cdd331bb450e(meta).includes(network);
}
function $341e29ad9d46e7f7$export$b1eab42bc9b6c7a3(instances, meta, network) {
    // If there is no `network` we fallback to default network.
    network = network || $341e29ad9d46e7f7$export$95be4ae94445245a.ETHEREUM;
    var instance_network_name = $341e29ad9d46e7f7$var$isEvmNetwork(network, meta) ? $341e29ad9d46e7f7$export$d1cfcb1ce8ae2e4e(network, meta) : network;
    var instance = !!instances && !!instance_network_name ? instances.get(instance_network_name) : null;
    return instance;
}
function $341e29ad9d46e7f7$export$2029b78bc980a576(provider, network) {
    return provider.size ? provider.get(network) : provider;
}
var $341e29ad9d46e7f7$var$_excluded = [
    "experimental"
];
var $341e29ad9d46e7f7$var$getCosmosMainChainsIds = function getCosmosMainChainsIds(blockchains) {
    return blockchains.filter(function(blockchain) {
        var _blockchain$info;
        return !((_blockchain$info = blockchain.info) != null && _blockchain$info.experimental);
    }).map(function(blockchain) {
        return blockchain.chainId;
    }).filter(function(chainId) {
        return !!chainId;
    });
};
var $341e29ad9d46e7f7$var$getCosmosMiscChainsIds = function getCosmosMiscChainsIds(blockchains) {
    return blockchains.filter(function(blockchain) {
        var _blockchain$info2;
        return (_blockchain$info2 = blockchain.info) == null ? void 0 : _blockchain$info2.experimental;
    }).map(function(blockchain) {
        return blockchain.chainId;
    }).filter(function(chainId) {
        return !!chainId;
    });
};
var $341e29ad9d46e7f7$export$9a5d8b9457d52deb = function getCosmosExperimentalChainInfo(blockchains) {
    return blockchains.filter(function(blockchain) {
        return !!blockchain.info;
    }).filter(function(blockchain) {
        return !!blockchain.chainId;
    }).reduce(function(cosmosExperimentalChainsInfo, blockchain) {
        var info = $341e29ad9d46e7f7$export$6c40052bed430212(blockchain.info);
        info.stakeCurrency.coinImageUrl = window.location.origin + info.stakeCurrency.coinImageUrl;
        info.currencies = info.currencies.map(function(currency) {
            return $341e29ad9d46e7f7$var$_extends({}, currency, {
                coinImageUrl: window.location.origin + currency.coinImageUrl
            });
        });
        info.feeCurrencies = info.feeCurrencies.map(function(currency) {
            return $341e29ad9d46e7f7$var$_extends({}, currency, {
                coinImageUrl: window.location.origin + currency.coinImageUrl
            });
        });
        if (!info.gasPriceStep) delete info.gasPriceStep;
        var experimental = info.experimental, otherProperties = $341e29ad9d46e7f7$var$_objectWithoutPropertiesLoose(info, $341e29ad9d46e7f7$var$_excluded);
        return cosmosExperimentalChainsInfo[blockchain.name] = {
            id: blockchain.chainId,
            info: $341e29ad9d46e7f7$var$_extends({}, otherProperties, {
                chainId: blockchain.chainId
            }),
            experimental: experimental
        }, cosmosExperimentalChainsInfo;
    }, {});
};
function $341e29ad9d46e7f7$var$getMainAccounts(_x) {
    return $341e29ad9d46e7f7$var$_getMainAccounts.apply(this, arguments);
}
function $341e29ad9d46e7f7$var$_getMainAccounts() {
    $341e29ad9d46e7f7$var$_getMainAccounts = $341e29ad9d46e7f7$var$_asyncToGenerator(/*#__PURE__*/ $341e29ad9d46e7f7$var$_regeneratorRuntime().mark(function _callee2(_ref) {
        var desiredChainIds, instance, offlineSigners, accountsPromises, availableAccountForChains, resolvedAccounts;
        return $341e29ad9d46e7f7$var$_regeneratorRuntime().wrap(function _callee2$(_context2) {
            while(true)switch(_context2.prev = _context2.next){
                case 0:
                    desiredChainIds = _ref.desiredChainIds, instance = _ref.instance;
                    // Trying to get accounts from all chains
                    offlineSigners = desiredChainIds.map(function(chainId) {
                        var signer = instance.getOfflineSigner(chainId);
                        return {
                            signer: signer,
                            chainId: chainId
                        };
                    }).filter(Boolean);
                    accountsPromises = offlineSigners.map(function(_ref5) {
                        var signer = _ref5.signer;
                        return signer.getAccounts();
                    });
                    _context2.next = 5;
                    return Promise.allSettled(accountsPromises);
                case 5:
                    availableAccountForChains = _context2.sent;
                    resolvedAccounts = [];
                    availableAccountForChains.forEach(function(result, index) {
                        if (result.status !== "fulfilled") return;
                        var accounts = result.value;
                        var chainId = offlineSigners[index].chainId;
                        var addresses = accounts.map(function(account) {
                            return account.address;
                        });
                        resolvedAccounts.push({
                            accounts: addresses,
                            chainId: chainId
                        });
                    });
                    return _context2.abrupt("return", resolvedAccounts);
                case 9:
                case "end":
                    return _context2.stop();
            }
        }, _callee2);
    }));
    return $341e29ad9d46e7f7$var$_getMainAccounts.apply(this, arguments);
}
function $341e29ad9d46e7f7$var$tryRequestMiscAccounts(_x2) {
    return $341e29ad9d46e7f7$var$_tryRequestMiscAccounts.apply(this, arguments);
}
function $341e29ad9d46e7f7$var$_tryRequestMiscAccounts() {
    $341e29ad9d46e7f7$var$_tryRequestMiscAccounts = $341e29ad9d46e7f7$var$_asyncToGenerator(/*#__PURE__*/ $341e29ad9d46e7f7$var$_regeneratorRuntime().mark(function _callee3(_ref2) {
        var excludedChain, instance, meta, offlineSigners, accountsPromises, availableAccountForChains, resolvedAccounts;
        return $341e29ad9d46e7f7$var$_regeneratorRuntime().wrap(function _callee3$(_context3) {
            while(true)switch(_context3.prev = _context3.next){
                case 0:
                    excludedChain = _ref2.excludedChain, instance = _ref2.instance, meta = _ref2.meta;
                    offlineSigners = $341e29ad9d46e7f7$var$getCosmosMiscChainsIds(meta).filter(function(id) {
                        return id !== excludedChain;
                    }).map(function(chainId) {
                        var signer = instance.getOfflineSigner(chainId);
                        return {
                            signer: signer,
                            chainId: chainId
                        };
                    });
                    accountsPromises = offlineSigners.map(function(_ref6) {
                        var signer = _ref6.signer;
                        return signer.getAccounts();
                    });
                    _context3.next = 5;
                    return Promise.allSettled(accountsPromises);
                case 5:
                    availableAccountForChains = _context3.sent;
                    resolvedAccounts = [];
                    availableAccountForChains.forEach(function(result, index) {
                        if (result.status !== "fulfilled") return;
                        var accounts = result.value;
                        var chainId = offlineSigners[index].chainId;
                        var addresses = accounts.map(function(account) {
                            return account.address;
                        });
                        resolvedAccounts.push({
                            accounts: addresses,
                            chainId: chainId
                        });
                    });
                    return _context3.abrupt("return", resolvedAccounts);
                case 9:
                case "end":
                    return _context3.stop();
            }
        }, _callee3);
    }));
    return $341e29ad9d46e7f7$var$_tryRequestMiscAccounts.apply(this, arguments);
}
var $341e29ad9d46e7f7$export$d4d8333f992ebe8c = /*#__PURE__*/ function() {
    var _ref4 = /*#__PURE__*/ $341e29ad9d46e7f7$var$_asyncToGenerator(/*#__PURE__*/ $341e29ad9d46e7f7$var$_regeneratorRuntime().mark(function _callee(_ref3) {
        var instance, network, meta, chainInfo, desiredChainIds, mainAccounts, exclude, miscAccounts, results;
        return $341e29ad9d46e7f7$var$_regeneratorRuntime().wrap(function _callee$(_context) {
            while(true)switch(_context.prev = _context.next){
                case 0:
                    instance = _ref3.instance, network = _ref3.network, meta = _ref3.meta;
                    chainInfo = network ? $341e29ad9d46e7f7$export$9a5d8b9457d52deb(meta)[network] : null;
                    if (!(!!network && !chainInfo)) {
                        _context.next = 4;
                        break;
                    }
                    throw new Error("You need to add " + network + ' to "COSMOS_EXPERIMENTAL_CHAINS_INFO" first.');
                case 4:
                    if (!chainInfo) {
                        _context.next = 7;
                        break;
                    }
                    _context.next = 7;
                    return instance.experimentalSuggestChain(chainInfo.info);
                case 7:
                    // Getting main chains + target network
                    desiredChainIds = $341e29ad9d46e7f7$var$getCosmosMainChainsIds(meta);
                    if (!!chainInfo) desiredChainIds.push(chainInfo.id);
                    desiredChainIds = Array.from(new Set(desiredChainIds)).filter(Boolean);
                    _context.next = 12;
                    return instance.enable(desiredChainIds);
                case 12:
                    _context.next = 14;
                    return $341e29ad9d46e7f7$var$getMainAccounts({
                        desiredChainIds: desiredChainIds,
                        instance: instance
                    });
                case 14:
                    mainAccounts = _context.sent;
                    exclude = !!chainInfo ? chainInfo.id : undefined;
                    if (!exclude) {
                        _context.next = 22;
                        break;
                    }
                    _context.next = 19;
                    return $341e29ad9d46e7f7$var$tryRequestMiscAccounts({
                        instance: instance,
                        meta: meta,
                        excludedChain: exclude
                    });
                case 19:
                    _context.t0 = _context.sent;
                    _context.next = 23;
                    break;
                case 22:
                    _context.t0 = [];
                case 23:
                    miscAccounts = _context.t0;
                    results = [].concat(mainAccounts, miscAccounts);
                    return _context.abrupt("return", results);
                case 26:
                case "end":
                    return _context.stop();
            }
        }, _callee);
    }));
    return function getCosmosAccounts(_x3) {
        return _ref4.apply(this, arguments);
    };
}();




var $bh6RR = parcelRequire("bh6RR");







/* -------------------------------------------------------------------------------------------------
 * Switch
 * -----------------------------------------------------------------------------------------------*/ const $172ff4f047b7b6ce$var$$6be4966fd9bbc698$var$SWITCH_NAME = "Switch";
const [$172ff4f047b7b6ce$var$$6be4966fd9bbc698$var$createSwitchContext, $172ff4f047b7b6ce$export$cf7f5f17f69cbd43] = (0, $1cecd1d75f085228$export$50c7b4e9d9f19c1)($172ff4f047b7b6ce$var$$6be4966fd9bbc698$var$SWITCH_NAME);
const [$172ff4f047b7b6ce$var$$6be4966fd9bbc698$var$SwitchProvider, $172ff4f047b7b6ce$var$$6be4966fd9bbc698$var$useSwitchContext] = $172ff4f047b7b6ce$var$$6be4966fd9bbc698$var$createSwitchContext($172ff4f047b7b6ce$var$$6be4966fd9bbc698$var$SWITCH_NAME);
const $172ff4f047b7b6ce$export$b5d5cf8927ab7262 = /*#__PURE__*/ (0, $bh6RR.forwardRef)((props, forwardedRef)=>{
    const { __scopeSwitch: __scopeSwitch, name: name, checked: checkedProp, defaultChecked: defaultChecked, required: required, disabled: disabled, value: value = "on", onCheckedChange: onCheckedChange, ...switchProps } = props;
    const [button, setButton] = (0, $bh6RR.useState)(null);
    const composedRefs = (0, $e52f713866128e60$export$c7b2cbe3552a0d05)(forwardedRef, (node)=>setButton(node));
    const hasConsumerStoppedPropagationRef = (0, $bh6RR.useRef)(false); // We set this to true by default so that events bubble to forms without JS (SSR)
    const isFormControl = button ? Boolean(button.closest("form")) : true;
    const [checked = false, setChecked] = (0, $dfcfc7aa8980054c$export$6f32135080cb4c3)({
        prop: checkedProp,
        defaultProp: defaultChecked,
        onChange: onCheckedChange
    });
    return /*#__PURE__*/ (0, $bh6RR.createElement)($172ff4f047b7b6ce$var$$6be4966fd9bbc698$var$SwitchProvider, {
        scope: __scopeSwitch,
        checked: checked,
        disabled: disabled
    }, /*#__PURE__*/ (0, $bh6RR.createElement)((0, $793b1a0f4d9647b1$export$250ffa63cdc0d034).button, (0, $39ab41060f0dd572$export$2e2bcd8739ae039)({
        type: "button",
        role: "switch",
        "aria-checked": checked,
        "aria-required": required,
        "data-state": $172ff4f047b7b6ce$var$$6be4966fd9bbc698$var$getState(checked),
        "data-disabled": disabled ? "" : undefined,
        disabled: disabled,
        value: value
    }, switchProps, {
        ref: composedRefs,
        onClick: (0, $93dfa6b8fe6a3629$export$b9ecd428b558ff10)(props.onClick, (event)=>{
            setChecked((prevChecked)=>!prevChecked);
            if (isFormControl) {
                hasConsumerStoppedPropagationRef.current = event.isPropagationStopped(); // if switch is in a form, stop propagation from the button so that we only propagate
                // one click event (from the input). We propagate changes from an input so that native
                // form validation works and form events reflect switch updates.
                if (!hasConsumerStoppedPropagationRef.current) event.stopPropagation();
            }
        })
    })), isFormControl && /*#__PURE__*/ (0, $bh6RR.createElement)($172ff4f047b7b6ce$var$$6be4966fd9bbc698$var$BubbleInput, {
        control: button,
        bubbles: !hasConsumerStoppedPropagationRef.current,
        name: name,
        value: value,
        checked: checked,
        required: required,
        disabled: disabled // We transform because the input is absolutely positioned but we have
        ,
        style: {
            transform: "translateX(-100%)"
        }
    }));
});
/*#__PURE__*/ Object.assign($172ff4f047b7b6ce$export$b5d5cf8927ab7262, {
    displayName: $172ff4f047b7b6ce$var$$6be4966fd9bbc698$var$SWITCH_NAME
});
/* -------------------------------------------------------------------------------------------------
 * SwitchThumb
 * -----------------------------------------------------------------------------------------------*/ const $172ff4f047b7b6ce$var$$6be4966fd9bbc698$var$THUMB_NAME = "SwitchThumb";
const $172ff4f047b7b6ce$export$4d07bf653ea69106 = /*#__PURE__*/ (0, $bh6RR.forwardRef)((props, forwardedRef)=>{
    const { __scopeSwitch: __scopeSwitch, ...thumbProps } = props;
    const context = $172ff4f047b7b6ce$var$$6be4966fd9bbc698$var$useSwitchContext($172ff4f047b7b6ce$var$$6be4966fd9bbc698$var$THUMB_NAME, __scopeSwitch);
    return /*#__PURE__*/ (0, $bh6RR.createElement)((0, $793b1a0f4d9647b1$export$250ffa63cdc0d034).span, (0, $39ab41060f0dd572$export$2e2bcd8739ae039)({
        "data-state": $172ff4f047b7b6ce$var$$6be4966fd9bbc698$var$getState(context.checked),
        "data-disabled": context.disabled ? "" : undefined
    }, thumbProps, {
        ref: forwardedRef
    }));
});
/*#__PURE__*/ Object.assign($172ff4f047b7b6ce$export$4d07bf653ea69106, {
    displayName: $172ff4f047b7b6ce$var$$6be4966fd9bbc698$var$THUMB_NAME
});
/* ---------------------------------------------------------------------------------------------- */ const $172ff4f047b7b6ce$var$$6be4966fd9bbc698$var$BubbleInput = (props)=>{
    const { control: control, checked: checked, bubbles: bubbles = true, ...inputProps } = props;
    const ref = (0, $bh6RR.useRef)(null);
    const prevChecked = (0, $50865d54cfb9b593$export$5cae361ad82dce8b)(checked);
    const controlSize = (0, $3193bf9be93d584d$export$1ab7ae714698c4b8)(control); // Bubble checked change to parents (e.g form change event)
    (0, $bh6RR.useEffect)(()=>{
        const input = ref.current;
        const inputProto = window.HTMLInputElement.prototype;
        const descriptor = Object.getOwnPropertyDescriptor(inputProto, "checked");
        const setChecked = descriptor.set;
        if (prevChecked !== checked && setChecked) {
            const event = new Event("click", {
                bubbles: bubbles
            });
            setChecked.call(input, checked);
            input.dispatchEvent(event);
        }
    }, [
        prevChecked,
        checked,
        bubbles
    ]);
    return /*#__PURE__*/ (0, $bh6RR.createElement)("input", (0, $39ab41060f0dd572$export$2e2bcd8739ae039)({
        type: "checkbox",
        "aria-hidden": true,
        defaultChecked: checked
    }, inputProps, {
        tabIndex: -1,
        ref: ref,
        style: {
            ...props.style,
            ...controlSize,
            position: "absolute",
            pointerEvents: "none",
            opacity: 0,
            margin: 0
        }
    }));
};
function $172ff4f047b7b6ce$var$$6be4966fd9bbc698$var$getState(checked) {
    return checked ? "checked" : "unchecked";
}
const $172ff4f047b7b6ce$export$be92b6f5f03c0fe9 = $172ff4f047b7b6ce$export$b5d5cf8927ab7262;
const $172ff4f047b7b6ce$export$6521433ed15a34db = $172ff4f047b7b6ce$export$4d07bf653ea69106;




var $bh6RR = parcelRequire("bh6RR");






var $bh6RR = parcelRequire("bh6RR");


var $bh6RR = parcelRequire("bh6RR");



// We have resorted to returning slots directly rather than exposing primitives that can then
// be slotted like `<CollectionItem as={Slot}>…</CollectionItem>`.
// This is because we encountered issues with generic types that cannot be statically analysed
// due to creating them dynamically via createCollection.
function $c43a6ccc42422c95$export$c74125a8e3af6bb2(name) {
    /* -----------------------------------------------------------------------------------------------
   * CollectionProvider
   * ---------------------------------------------------------------------------------------------*/ const PROVIDER_NAME = name + "CollectionProvider";
    const [createCollectionContext, createCollectionScope] = (0, $1cecd1d75f085228$export$50c7b4e9d9f19c1)(PROVIDER_NAME);
    const [CollectionProviderImpl, useCollectionContext] = createCollectionContext(PROVIDER_NAME, {
        collectionRef: {
            current: null
        },
        itemMap: new Map()
    });
    const CollectionProvider = (props)=>{
        const { scope: scope, children: children } = props;
        const ref = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useRef(null);
        const itemMap = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useRef(new Map()).current;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement(CollectionProviderImpl, {
            scope: scope,
            itemMap: itemMap,
            collectionRef: ref
        }, children);
    };
    /*#__PURE__*/ Object.assign(CollectionProvider, {
        displayName: PROVIDER_NAME
    });
    /* -----------------------------------------------------------------------------------------------
   * CollectionSlot
   * ---------------------------------------------------------------------------------------------*/ const COLLECTION_SLOT_NAME = name + "CollectionSlot";
    const CollectionSlot = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).forwardRef((props, forwardedRef)=>{
        const { scope: scope, children: children } = props;
        const context = useCollectionContext(COLLECTION_SLOT_NAME, scope);
        const composedRefs = (0, $e52f713866128e60$export$c7b2cbe3552a0d05)(forwardedRef, context.collectionRef);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $18fd289ffa468154$export$8c6ed5c666ac1360), {
            ref: composedRefs
        }, children);
    });
    /*#__PURE__*/ Object.assign(CollectionSlot, {
        displayName: COLLECTION_SLOT_NAME
    });
    /* -----------------------------------------------------------------------------------------------
   * CollectionItem
   * ---------------------------------------------------------------------------------------------*/ const ITEM_SLOT_NAME = name + "CollectionItemSlot";
    const ITEM_DATA_ATTR = "data-radix-collection-item";
    const CollectionItemSlot = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).forwardRef((props, forwardedRef)=>{
        const { scope: scope, children: children, ...itemData } = props;
        const ref = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useRef(null);
        const composedRefs = (0, $e52f713866128e60$export$c7b2cbe3552a0d05)(forwardedRef, ref);
        const context = useCollectionContext(ITEM_SLOT_NAME, scope);
        (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useEffect(()=>{
            context.itemMap.set(ref, {
                ref: ref,
                ...itemData
            });
            return ()=>void context.itemMap.delete(ref);
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $18fd289ffa468154$export$8c6ed5c666ac1360), {
            [ITEM_DATA_ATTR]: "",
            ref: composedRefs
        }, children);
    });
    /*#__PURE__*/ Object.assign(CollectionItemSlot, {
        displayName: ITEM_SLOT_NAME
    });
    /* -----------------------------------------------------------------------------------------------
   * useCollection
   * ---------------------------------------------------------------------------------------------*/ function useCollection(scope) {
        const context = useCollectionContext(name + "CollectionConsumer", scope);
        const getItems = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useCallback(()=>{
            const collectionNode = context.collectionRef.current;
            if (!collectionNode) return [];
            const orderedNodes = Array.from(collectionNode.querySelectorAll(`[${ITEM_DATA_ATTR}]`));
            const items = Array.from(context.itemMap.values());
            const orderedItems = items.sort((a, b)=>orderedNodes.indexOf(a.ref.current) - orderedNodes.indexOf(b.ref.current));
            return orderedItems;
        }, [
            context.collectionRef,
            context.itemMap
        ]);
        return getItems;
    }
    return [
        {
            Provider: CollectionProvider,
            Slot: CollectionSlot,
            ItemSlot: CollectionItemSlot
        },
        useCollection,
        createCollectionScope
    ];
}









var $bh6RR = parcelRequire("bh6RR");
const $4ac4e2f5e0780c9a$var$$f631663db3294ace$var$DirectionContext = /*#__PURE__*/ (0, $bh6RR.createContext)(undefined);
/* -------------------------------------------------------------------------------------------------
 * Direction
 * -----------------------------------------------------------------------------------------------*/ const $4ac4e2f5e0780c9a$export$c760c09fdd558351 = (props)=>{
    const { dir: dir, children: children } = props;
    return /*#__PURE__*/ (0, $bh6RR.createElement)($4ac4e2f5e0780c9a$var$$f631663db3294ace$var$DirectionContext.Provider, {
        value: dir
    }, children);
};
/* -----------------------------------------------------------------------------------------------*/ function $4ac4e2f5e0780c9a$export$b39126d51d94e6f3(localDir) {
    const globalDir = (0, $bh6RR.useContext)($4ac4e2f5e0780c9a$var$$f631663db3294ace$var$DirectionContext);
    return localDir || globalDir || "ltr";
}
const $4ac4e2f5e0780c9a$export$2881499e37b75b9a = $4ac4e2f5e0780c9a$export$c760c09fdd558351;


const $1a384a7578ffd5f3$var$$d7bdfb9eb0fdf311$var$ENTRY_FOCUS = "rovingFocusGroup.onEntryFocus";
const $1a384a7578ffd5f3$var$$d7bdfb9eb0fdf311$var$EVENT_OPTIONS = {
    bubbles: false,
    cancelable: true
};
/* -------------------------------------------------------------------------------------------------
 * RovingFocusGroup
 * -----------------------------------------------------------------------------------------------*/ const $1a384a7578ffd5f3$var$$d7bdfb9eb0fdf311$var$GROUP_NAME = "RovingFocusGroup";
const [$1a384a7578ffd5f3$var$$d7bdfb9eb0fdf311$var$Collection, $1a384a7578ffd5f3$var$$d7bdfb9eb0fdf311$var$useCollection, $1a384a7578ffd5f3$var$$d7bdfb9eb0fdf311$var$createCollectionScope] = (0, $c43a6ccc42422c95$export$c74125a8e3af6bb2)($1a384a7578ffd5f3$var$$d7bdfb9eb0fdf311$var$GROUP_NAME);
const [$1a384a7578ffd5f3$var$$d7bdfb9eb0fdf311$var$createRovingFocusGroupContext, $1a384a7578ffd5f3$export$c7109489551a4f4] = (0, $1cecd1d75f085228$export$50c7b4e9d9f19c1)($1a384a7578ffd5f3$var$$d7bdfb9eb0fdf311$var$GROUP_NAME, [
    $1a384a7578ffd5f3$var$$d7bdfb9eb0fdf311$var$createCollectionScope
]);
const [$1a384a7578ffd5f3$var$$d7bdfb9eb0fdf311$var$RovingFocusProvider, $1a384a7578ffd5f3$var$$d7bdfb9eb0fdf311$var$useRovingFocusContext] = $1a384a7578ffd5f3$var$$d7bdfb9eb0fdf311$var$createRovingFocusGroupContext($1a384a7578ffd5f3$var$$d7bdfb9eb0fdf311$var$GROUP_NAME);
const $1a384a7578ffd5f3$export$8699f7c8af148338 = /*#__PURE__*/ (0, $bh6RR.forwardRef)((props, forwardedRef)=>{
    return /*#__PURE__*/ (0, $bh6RR.createElement)($1a384a7578ffd5f3$var$$d7bdfb9eb0fdf311$var$Collection.Provider, {
        scope: props.__scopeRovingFocusGroup
    }, /*#__PURE__*/ (0, $bh6RR.createElement)($1a384a7578ffd5f3$var$$d7bdfb9eb0fdf311$var$Collection.Slot, {
        scope: props.__scopeRovingFocusGroup
    }, /*#__PURE__*/ (0, $bh6RR.createElement)($1a384a7578ffd5f3$var$$d7bdfb9eb0fdf311$var$RovingFocusGroupImpl, (0, $39ab41060f0dd572$export$2e2bcd8739ae039)({}, props, {
        ref: forwardedRef
    }))));
});
/*#__PURE__*/ Object.assign($1a384a7578ffd5f3$export$8699f7c8af148338, {
    displayName: $1a384a7578ffd5f3$var$$d7bdfb9eb0fdf311$var$GROUP_NAME
});
/* -----------------------------------------------------------------------------------------------*/ const $1a384a7578ffd5f3$var$$d7bdfb9eb0fdf311$var$RovingFocusGroupImpl = /*#__PURE__*/ (0, $bh6RR.forwardRef)((props, forwardedRef)=>{
    const { __scopeRovingFocusGroup: __scopeRovingFocusGroup, orientation: orientation, loop: loop = false, dir: dir, currentTabStopId: currentTabStopIdProp, defaultCurrentTabStopId: defaultCurrentTabStopId, onCurrentTabStopIdChange: onCurrentTabStopIdChange, onEntryFocus: onEntryFocus, ...groupProps } = props;
    const ref = (0, $bh6RR.useRef)(null);
    const composedRefs = (0, $e52f713866128e60$export$c7b2cbe3552a0d05)(forwardedRef, ref);
    const direction = (0, $4ac4e2f5e0780c9a$export$b39126d51d94e6f3)(dir);
    const [currentTabStopId = null, setCurrentTabStopId] = (0, $dfcfc7aa8980054c$export$6f32135080cb4c3)({
        prop: currentTabStopIdProp,
        defaultProp: defaultCurrentTabStopId,
        onChange: onCurrentTabStopIdChange
    });
    const [isTabbingBackOut, setIsTabbingBackOut] = (0, $bh6RR.useState)(false);
    const handleEntryFocus = (0, $c901973c35f9b07b$export$25bec8c6f54ee79a)(onEntryFocus);
    const getItems = $1a384a7578ffd5f3$var$$d7bdfb9eb0fdf311$var$useCollection(__scopeRovingFocusGroup);
    const isClickFocusRef = (0, $bh6RR.useRef)(false);
    const [focusableItemsCount, setFocusableItemsCount] = (0, $bh6RR.useState)(0);
    (0, $bh6RR.useEffect)(()=>{
        const node = ref.current;
        if (node) {
            node.addEventListener($1a384a7578ffd5f3$var$$d7bdfb9eb0fdf311$var$ENTRY_FOCUS, handleEntryFocus);
            return ()=>node.removeEventListener($1a384a7578ffd5f3$var$$d7bdfb9eb0fdf311$var$ENTRY_FOCUS, handleEntryFocus);
        }
    }, [
        handleEntryFocus
    ]);
    return /*#__PURE__*/ (0, $bh6RR.createElement)($1a384a7578ffd5f3$var$$d7bdfb9eb0fdf311$var$RovingFocusProvider, {
        scope: __scopeRovingFocusGroup,
        orientation: orientation,
        dir: direction,
        loop: loop,
        currentTabStopId: currentTabStopId,
        onItemFocus: (0, $bh6RR.useCallback)((tabStopId)=>setCurrentTabStopId(tabStopId), [
            setCurrentTabStopId
        ]),
        onItemShiftTab: (0, $bh6RR.useCallback)(()=>setIsTabbingBackOut(true), []),
        onFocusableItemAdd: (0, $bh6RR.useCallback)(()=>setFocusableItemsCount((prevCount)=>prevCount + 1), []),
        onFocusableItemRemove: (0, $bh6RR.useCallback)(()=>setFocusableItemsCount((prevCount)=>prevCount - 1), [])
    }, /*#__PURE__*/ (0, $bh6RR.createElement)((0, $793b1a0f4d9647b1$export$250ffa63cdc0d034).div, (0, $39ab41060f0dd572$export$2e2bcd8739ae039)({
        tabIndex: isTabbingBackOut || focusableItemsCount === 0 ? -1 : 0,
        "data-orientation": orientation
    }, groupProps, {
        ref: composedRefs,
        style: {
            outline: "none",
            ...props.style
        },
        onMouseDown: (0, $93dfa6b8fe6a3629$export$b9ecd428b558ff10)(props.onMouseDown, ()=>{
            isClickFocusRef.current = true;
        }),
        onFocus: (0, $93dfa6b8fe6a3629$export$b9ecd428b558ff10)(props.onFocus, (event)=>{
            // We normally wouldn't need this check, because we already check
            // that the focus is on the current target and not bubbling to it.
            // We do this because Safari doesn't focus buttons when clicked, and
            // instead, the wrapper will get focused and not through a bubbling event.
            const isKeyboardFocus = !isClickFocusRef.current;
            if (event.target === event.currentTarget && isKeyboardFocus && !isTabbingBackOut) {
                const entryFocusEvent = new CustomEvent($1a384a7578ffd5f3$var$$d7bdfb9eb0fdf311$var$ENTRY_FOCUS, $1a384a7578ffd5f3$var$$d7bdfb9eb0fdf311$var$EVENT_OPTIONS);
                event.currentTarget.dispatchEvent(entryFocusEvent);
                if (!entryFocusEvent.defaultPrevented) {
                    const items = getItems().filter((item)=>item.focusable);
                    const activeItem = items.find((item)=>item.active);
                    const currentItem = items.find((item)=>item.id === currentTabStopId);
                    const candidateItems = [
                        activeItem,
                        currentItem,
                        ...items
                    ].filter(Boolean);
                    const candidateNodes = candidateItems.map((item)=>item.ref.current);
                    $1a384a7578ffd5f3$var$$d7bdfb9eb0fdf311$var$focusFirst(candidateNodes);
                }
            }
            isClickFocusRef.current = false;
        }),
        onBlur: (0, $93dfa6b8fe6a3629$export$b9ecd428b558ff10)(props.onBlur, ()=>setIsTabbingBackOut(false))
    })));
});
/* -------------------------------------------------------------------------------------------------
 * RovingFocusGroupItem
 * -----------------------------------------------------------------------------------------------*/ const $1a384a7578ffd5f3$var$$d7bdfb9eb0fdf311$var$ITEM_NAME = "RovingFocusGroupItem";
const $1a384a7578ffd5f3$export$ab9df7c53fe8454 = /*#__PURE__*/ (0, $bh6RR.forwardRef)((props, forwardedRef)=>{
    const { __scopeRovingFocusGroup: __scopeRovingFocusGroup, focusable: focusable = true, active: active = false, tabStopId: tabStopId, ...itemProps } = props;
    const autoId = (0, $d172fcbd2da23bac$export$f680877a34711e37)();
    const id = tabStopId || autoId;
    const context = $1a384a7578ffd5f3$var$$d7bdfb9eb0fdf311$var$useRovingFocusContext($1a384a7578ffd5f3$var$$d7bdfb9eb0fdf311$var$ITEM_NAME, __scopeRovingFocusGroup);
    const isCurrentTabStop = context.currentTabStopId === id;
    const getItems = $1a384a7578ffd5f3$var$$d7bdfb9eb0fdf311$var$useCollection(__scopeRovingFocusGroup);
    const { onFocusableItemAdd: onFocusableItemAdd, onFocusableItemRemove: onFocusableItemRemove } = context;
    (0, $bh6RR.useEffect)(()=>{
        if (focusable) {
            onFocusableItemAdd();
            return ()=>onFocusableItemRemove();
        }
    }, [
        focusable,
        onFocusableItemAdd,
        onFocusableItemRemove
    ]);
    return /*#__PURE__*/ (0, $bh6RR.createElement)($1a384a7578ffd5f3$var$$d7bdfb9eb0fdf311$var$Collection.ItemSlot, {
        scope: __scopeRovingFocusGroup,
        id: id,
        focusable: focusable,
        active: active
    }, /*#__PURE__*/ (0, $bh6RR.createElement)((0, $793b1a0f4d9647b1$export$250ffa63cdc0d034).span, (0, $39ab41060f0dd572$export$2e2bcd8739ae039)({
        tabIndex: isCurrentTabStop ? 0 : -1,
        "data-orientation": context.orientation
    }, itemProps, {
        ref: forwardedRef,
        onMouseDown: (0, $93dfa6b8fe6a3629$export$b9ecd428b558ff10)(props.onMouseDown, (event)=>{
            // We prevent focusing non-focusable items on `mousedown`.
            // Even though the item has tabIndex={-1}, that only means take it out of the tab order.
            if (!focusable) event.preventDefault(); // Safari doesn't focus a button when clicked so we run our logic on mousedown also
            else context.onItemFocus(id);
        }),
        onFocus: (0, $93dfa6b8fe6a3629$export$b9ecd428b558ff10)(props.onFocus, ()=>context.onItemFocus(id)),
        onKeyDown: (0, $93dfa6b8fe6a3629$export$b9ecd428b558ff10)(props.onKeyDown, (event)=>{
            if (event.key === "Tab" && event.shiftKey) {
                context.onItemShiftTab();
                return;
            }
            if (event.target !== event.currentTarget) return;
            const focusIntent = $1a384a7578ffd5f3$var$$d7bdfb9eb0fdf311$var$getFocusIntent(event, context.orientation, context.dir);
            if (focusIntent !== undefined) {
                event.preventDefault();
                const items = getItems().filter((item)=>item.focusable);
                let candidateNodes = items.map((item)=>item.ref.current);
                if (focusIntent === "last") candidateNodes.reverse();
                else if (focusIntent === "prev" || focusIntent === "next") {
                    if (focusIntent === "prev") candidateNodes.reverse();
                    const currentIndex = candidateNodes.indexOf(event.currentTarget);
                    candidateNodes = context.loop ? $1a384a7578ffd5f3$var$$d7bdfb9eb0fdf311$var$wrapArray(candidateNodes, currentIndex + 1) : candidateNodes.slice(currentIndex + 1);
                }
                /**
         * Imperative focus during keydown is risky so we prevent React's batching updates
         * to avoid potential bugs. See: https://github.com/facebook/react/issues/20332
         */ setTimeout(()=>$1a384a7578ffd5f3$var$$d7bdfb9eb0fdf311$var$focusFirst(candidateNodes));
            }
        })
    })));
});
/*#__PURE__*/ Object.assign($1a384a7578ffd5f3$export$ab9df7c53fe8454, {
    displayName: $1a384a7578ffd5f3$var$$d7bdfb9eb0fdf311$var$ITEM_NAME
});
/* -----------------------------------------------------------------------------------------------*/ // prettier-ignore
const $1a384a7578ffd5f3$var$$d7bdfb9eb0fdf311$var$MAP_KEY_TO_FOCUS_INTENT = {
    ArrowLeft: "prev",
    ArrowUp: "prev",
    ArrowRight: "next",
    ArrowDown: "next",
    PageUp: "first",
    Home: "first",
    PageDown: "last",
    End: "last"
};
function $1a384a7578ffd5f3$var$$d7bdfb9eb0fdf311$var$getDirectionAwareKey(key, dir) {
    if (dir !== "rtl") return key;
    return key === "ArrowLeft" ? "ArrowRight" : key === "ArrowRight" ? "ArrowLeft" : key;
}
function $1a384a7578ffd5f3$var$$d7bdfb9eb0fdf311$var$getFocusIntent(event, orientation, dir) {
    const key = $1a384a7578ffd5f3$var$$d7bdfb9eb0fdf311$var$getDirectionAwareKey(event.key, dir);
    if (orientation === "vertical" && [
        "ArrowLeft",
        "ArrowRight"
    ].includes(key)) return undefined;
    if (orientation === "horizontal" && [
        "ArrowUp",
        "ArrowDown"
    ].includes(key)) return undefined;
    return $1a384a7578ffd5f3$var$$d7bdfb9eb0fdf311$var$MAP_KEY_TO_FOCUS_INTENT[key];
}
function $1a384a7578ffd5f3$var$$d7bdfb9eb0fdf311$var$focusFirst(candidates) {
    const PREVIOUSLY_FOCUSED_ELEMENT = document.activeElement;
    for (const candidate of candidates){
        // if focus is already where we want to go, we don't want to keep going through the candidates
        if (candidate === PREVIOUSLY_FOCUSED_ELEMENT) return;
        candidate.focus();
        if (document.activeElement !== PREVIOUSLY_FOCUSED_ELEMENT) return;
    }
}
/**
 * Wraps an array around itself at a given start index
 * Example: `wrapArray(['a', 'b', 'c', 'd'], 2) === ['c', 'd', 'a', 'b']`
 */ function $1a384a7578ffd5f3$var$$d7bdfb9eb0fdf311$var$wrapArray(array, startIndex) {
    return array.map((_, index)=>array[(startIndex + index) % array.length]);
}
const $1a384a7578ffd5f3$export$be92b6f5f03c0fe9 = $1a384a7578ffd5f3$export$8699f7c8af148338;
const $1a384a7578ffd5f3$export$6d08773d2e66f8f2 = $1a384a7578ffd5f3$export$ab9df7c53fe8454;







/* -------------------------------------------------------------------------------------------------
 * Radio
 * -----------------------------------------------------------------------------------------------*/ const $a0caedef5e243859$var$$ce77a8961b41be9e$var$RADIO_NAME = "Radio";
const [$a0caedef5e243859$var$$ce77a8961b41be9e$var$createRadioContext, $a0caedef5e243859$var$$ce77a8961b41be9e$export$67d2296460f1b002] = (0, $1cecd1d75f085228$export$50c7b4e9d9f19c1)($a0caedef5e243859$var$$ce77a8961b41be9e$var$RADIO_NAME);
const [$a0caedef5e243859$var$$ce77a8961b41be9e$var$RadioProvider, $a0caedef5e243859$var$$ce77a8961b41be9e$var$useRadioContext] = $a0caedef5e243859$var$$ce77a8961b41be9e$var$createRadioContext($a0caedef5e243859$var$$ce77a8961b41be9e$var$RADIO_NAME);
const $a0caedef5e243859$var$$ce77a8961b41be9e$export$d7b12c4107be0d61 = /*#__PURE__*/ (0, $bh6RR.forwardRef)((props, forwardedRef)=>{
    const { __scopeRadio: __scopeRadio, name: name, checked: checked = false, required: required, disabled: disabled, value: value = "on", onCheck: onCheck, ...radioProps } = props;
    const [button, setButton] = (0, $bh6RR.useState)(null);
    const composedRefs = (0, $e52f713866128e60$export$c7b2cbe3552a0d05)(forwardedRef, (node)=>setButton(node));
    const hasConsumerStoppedPropagationRef = (0, $bh6RR.useRef)(false); // We set this to true by default so that events bubble to forms without JS (SSR)
    const isFormControl = button ? Boolean(button.closest("form")) : true;
    return /*#__PURE__*/ (0, $bh6RR.createElement)($a0caedef5e243859$var$$ce77a8961b41be9e$var$RadioProvider, {
        scope: __scopeRadio,
        checked: checked,
        disabled: disabled
    }, /*#__PURE__*/ (0, $bh6RR.createElement)((0, $793b1a0f4d9647b1$export$250ffa63cdc0d034).button, (0, $39ab41060f0dd572$export$2e2bcd8739ae039)({
        type: "button",
        role: "radio",
        "aria-checked": checked,
        "data-state": $a0caedef5e243859$var$$ce77a8961b41be9e$var$getState(checked),
        "data-disabled": disabled ? "" : undefined,
        disabled: disabled,
        value: value
    }, radioProps, {
        ref: composedRefs,
        onClick: (0, $93dfa6b8fe6a3629$export$b9ecd428b558ff10)(props.onClick, (event)=>{
            // radios cannot be unchecked so we only communicate a checked state
            if (!checked) onCheck === null || onCheck === void 0 || onCheck();
            if (isFormControl) {
                hasConsumerStoppedPropagationRef.current = event.isPropagationStopped(); // if radio is in a form, stop propagation from the button so that we only propagate
                // one click event (from the input). We propagate changes from an input so that native
                // form validation works and form events reflect radio updates.
                if (!hasConsumerStoppedPropagationRef.current) event.stopPropagation();
            }
        })
    })), isFormControl && /*#__PURE__*/ (0, $bh6RR.createElement)($a0caedef5e243859$var$$ce77a8961b41be9e$var$BubbleInput, {
        control: button,
        bubbles: !hasConsumerStoppedPropagationRef.current,
        name: name,
        value: value,
        checked: checked,
        required: required,
        disabled: disabled // We transform because the input is absolutely positioned but we have
        ,
        style: {
            transform: "translateX(-100%)"
        }
    }));
});
/*#__PURE__*/ Object.assign($a0caedef5e243859$var$$ce77a8961b41be9e$export$d7b12c4107be0d61, {
    displayName: $a0caedef5e243859$var$$ce77a8961b41be9e$var$RADIO_NAME
});
/* -------------------------------------------------------------------------------------------------
 * RadioIndicator
 * -----------------------------------------------------------------------------------------------*/ const $a0caedef5e243859$var$$ce77a8961b41be9e$var$INDICATOR_NAME = "RadioIndicator";
const $a0caedef5e243859$var$$ce77a8961b41be9e$export$d35a9ffa9a04f9e7 = /*#__PURE__*/ (0, $bh6RR.forwardRef)((props, forwardedRef)=>{
    const { __scopeRadio: __scopeRadio, forceMount: forceMount, ...indicatorProps } = props;
    const context = $a0caedef5e243859$var$$ce77a8961b41be9e$var$useRadioContext($a0caedef5e243859$var$$ce77a8961b41be9e$var$INDICATOR_NAME, __scopeRadio);
    return /*#__PURE__*/ (0, $bh6RR.createElement)((0, $e651d1dc516f7371$export$99c2b779aa4e8b8b), {
        present: forceMount || context.checked
    }, /*#__PURE__*/ (0, $bh6RR.createElement)((0, $793b1a0f4d9647b1$export$250ffa63cdc0d034).span, (0, $39ab41060f0dd572$export$2e2bcd8739ae039)({
        "data-state": $a0caedef5e243859$var$$ce77a8961b41be9e$var$getState(context.checked),
        "data-disabled": context.disabled ? "" : undefined
    }, indicatorProps, {
        ref: forwardedRef
    })));
});
/*#__PURE__*/ Object.assign($a0caedef5e243859$var$$ce77a8961b41be9e$export$d35a9ffa9a04f9e7, {
    displayName: $a0caedef5e243859$var$$ce77a8961b41be9e$var$INDICATOR_NAME
});
/* ---------------------------------------------------------------------------------------------- */ const $a0caedef5e243859$var$$ce77a8961b41be9e$var$BubbleInput = (props)=>{
    const { control: control, checked: checked, bubbles: bubbles = true, ...inputProps } = props;
    const ref = (0, $bh6RR.useRef)(null);
    const prevChecked = (0, $50865d54cfb9b593$export$5cae361ad82dce8b)(checked);
    const controlSize = (0, $3193bf9be93d584d$export$1ab7ae714698c4b8)(control); // Bubble checked change to parents (e.g form change event)
    (0, $bh6RR.useEffect)(()=>{
        const input = ref.current;
        const inputProto = window.HTMLInputElement.prototype;
        const descriptor = Object.getOwnPropertyDescriptor(inputProto, "checked");
        const setChecked = descriptor.set;
        if (prevChecked !== checked && setChecked) {
            const event = new Event("click", {
                bubbles: bubbles
            });
            setChecked.call(input, checked);
            input.dispatchEvent(event);
        }
    }, [
        prevChecked,
        checked,
        bubbles
    ]);
    return /*#__PURE__*/ (0, $bh6RR.createElement)("input", (0, $39ab41060f0dd572$export$2e2bcd8739ae039)({
        type: "radio",
        "aria-hidden": true,
        defaultChecked: checked
    }, inputProps, {
        tabIndex: -1,
        ref: ref,
        style: {
            ...props.style,
            ...controlSize,
            position: "absolute",
            pointerEvents: "none",
            opacity: 0,
            margin: 0
        }
    }));
};
function $a0caedef5e243859$var$$ce77a8961b41be9e$var$getState(checked) {
    return checked ? "checked" : "unchecked";
}
const $a0caedef5e243859$var$$f99a8c78507165f7$var$ARROW_KEYS = [
    "ArrowUp",
    "ArrowDown",
    "ArrowLeft",
    "ArrowRight"
];
/* -------------------------------------------------------------------------------------------------
 * RadioGroup
 * -----------------------------------------------------------------------------------------------*/ const $a0caedef5e243859$var$$f99a8c78507165f7$var$RADIO_GROUP_NAME = "RadioGroup";
const [$a0caedef5e243859$var$$f99a8c78507165f7$var$createRadioGroupContext, $a0caedef5e243859$export$c547093f11b76da2] = (0, $1cecd1d75f085228$export$50c7b4e9d9f19c1)($a0caedef5e243859$var$$f99a8c78507165f7$var$RADIO_GROUP_NAME, [
    (0, $1a384a7578ffd5f3$export$c7109489551a4f4),
    $a0caedef5e243859$var$$ce77a8961b41be9e$export$67d2296460f1b002
]);
const $a0caedef5e243859$var$$f99a8c78507165f7$var$useRovingFocusGroupScope = (0, $1a384a7578ffd5f3$export$c7109489551a4f4)();
const $a0caedef5e243859$var$$f99a8c78507165f7$var$useRadioScope = $a0caedef5e243859$var$$ce77a8961b41be9e$export$67d2296460f1b002();
const [$a0caedef5e243859$var$$f99a8c78507165f7$var$RadioGroupProvider, $a0caedef5e243859$var$$f99a8c78507165f7$var$useRadioGroupContext] = $a0caedef5e243859$var$$f99a8c78507165f7$var$createRadioGroupContext($a0caedef5e243859$var$$f99a8c78507165f7$var$RADIO_GROUP_NAME);
const $a0caedef5e243859$export$a98f0dcb43a68a25 = /*#__PURE__*/ (0, $bh6RR.forwardRef)((props, forwardedRef)=>{
    const { __scopeRadioGroup: __scopeRadioGroup, name: name, defaultValue: defaultValue, value: valueProp, required: required = false, disabled: disabled = false, orientation: orientation, dir: dir, loop: loop = true, onValueChange: onValueChange, ...groupProps } = props;
    const rovingFocusGroupScope = $a0caedef5e243859$var$$f99a8c78507165f7$var$useRovingFocusGroupScope(__scopeRadioGroup);
    const direction = (0, $4ac4e2f5e0780c9a$export$b39126d51d94e6f3)(dir);
    const [value, setValue] = (0, $dfcfc7aa8980054c$export$6f32135080cb4c3)({
        prop: valueProp,
        defaultProp: defaultValue,
        onChange: onValueChange
    });
    return /*#__PURE__*/ (0, $bh6RR.createElement)($a0caedef5e243859$var$$f99a8c78507165f7$var$RadioGroupProvider, {
        scope: __scopeRadioGroup,
        name: name,
        required: required,
        disabled: disabled,
        value: value,
        onValueChange: setValue
    }, /*#__PURE__*/ (0, $bh6RR.createElement)((0, $1a384a7578ffd5f3$export$be92b6f5f03c0fe9), (0, $39ab41060f0dd572$export$2e2bcd8739ae039)({
        asChild: true
    }, rovingFocusGroupScope, {
        orientation: orientation,
        dir: direction,
        loop: loop
    }), /*#__PURE__*/ (0, $bh6RR.createElement)((0, $793b1a0f4d9647b1$export$250ffa63cdc0d034).div, (0, $39ab41060f0dd572$export$2e2bcd8739ae039)({
        role: "radiogroup",
        "aria-required": required,
        "aria-orientation": orientation,
        "data-disabled": disabled ? "" : undefined,
        dir: direction
    }, groupProps, {
        ref: forwardedRef
    }))));
});
/*#__PURE__*/ Object.assign($a0caedef5e243859$export$a98f0dcb43a68a25, {
    displayName: $a0caedef5e243859$var$$f99a8c78507165f7$var$RADIO_GROUP_NAME
});
/* -------------------------------------------------------------------------------------------------
 * RadioGroupItem
 * -----------------------------------------------------------------------------------------------*/ const $a0caedef5e243859$var$$f99a8c78507165f7$var$ITEM_NAME = "RadioGroupItem";
const $a0caedef5e243859$export$9f866c100ef519e4 = /*#__PURE__*/ (0, $bh6RR.forwardRef)((props, forwardedRef)=>{
    const { __scopeRadioGroup: __scopeRadioGroup, disabled: disabled, ...itemProps } = props;
    const context = $a0caedef5e243859$var$$f99a8c78507165f7$var$useRadioGroupContext($a0caedef5e243859$var$$f99a8c78507165f7$var$ITEM_NAME, __scopeRadioGroup);
    const isDisabled = context.disabled || disabled;
    const rovingFocusGroupScope = $a0caedef5e243859$var$$f99a8c78507165f7$var$useRovingFocusGroupScope(__scopeRadioGroup);
    const radioScope = $a0caedef5e243859$var$$f99a8c78507165f7$var$useRadioScope(__scopeRadioGroup);
    const ref = (0, $bh6RR.useRef)(null);
    const composedRefs = (0, $e52f713866128e60$export$c7b2cbe3552a0d05)(forwardedRef, ref);
    const checked = context.value === itemProps.value;
    const isArrowKeyPressedRef = (0, $bh6RR.useRef)(false);
    (0, $bh6RR.useEffect)(()=>{
        const handleKeyDown = (event)=>{
            if ($a0caedef5e243859$var$$f99a8c78507165f7$var$ARROW_KEYS.includes(event.key)) isArrowKeyPressedRef.current = true;
        };
        const handleKeyUp = ()=>isArrowKeyPressedRef.current = false;
        document.addEventListener("keydown", handleKeyDown);
        document.addEventListener("keyup", handleKeyUp);
        return ()=>{
            document.removeEventListener("keydown", handleKeyDown);
            document.removeEventListener("keyup", handleKeyUp);
        };
    }, []);
    return /*#__PURE__*/ (0, $bh6RR.createElement)((0, $1a384a7578ffd5f3$export$6d08773d2e66f8f2), (0, $39ab41060f0dd572$export$2e2bcd8739ae039)({
        asChild: true
    }, rovingFocusGroupScope, {
        focusable: !isDisabled,
        active: checked
    }), /*#__PURE__*/ (0, $bh6RR.createElement)($a0caedef5e243859$var$$ce77a8961b41be9e$export$d7b12c4107be0d61, (0, $39ab41060f0dd572$export$2e2bcd8739ae039)({
        disabled: isDisabled,
        required: context.required,
        checked: checked
    }, radioScope, itemProps, {
        name: context.name,
        ref: composedRefs,
        onCheck: ()=>context.onValueChange(itemProps.value),
        onKeyDown: (0, $93dfa6b8fe6a3629$export$b9ecd428b558ff10)((event)=>{
            // According to WAI ARIA, radio groups don't activate items on enter keypress
            if (event.key === "Enter") event.preventDefault();
        }),
        onFocus: (0, $93dfa6b8fe6a3629$export$b9ecd428b558ff10)(itemProps.onFocus, ()=>{
            var _ref$current;
            /**
       * Our `RovingFocusGroup` will focus the radio when navigating with arrow keys
       * and we need to "check" it in that case. We click it to "check" it (instead
       * of updating `context.value`) so that the radio change event fires.
       */ if (isArrowKeyPressedRef.current) (_ref$current = ref.current) === null || _ref$current === void 0 || _ref$current.click();
        })
    })));
});
/*#__PURE__*/ Object.assign($a0caedef5e243859$export$9f866c100ef519e4, {
    displayName: $a0caedef5e243859$var$$f99a8c78507165f7$var$ITEM_NAME
});
/* -------------------------------------------------------------------------------------------------
 * RadioGroupIndicator
 * -----------------------------------------------------------------------------------------------*/ const $a0caedef5e243859$var$$f99a8c78507165f7$var$INDICATOR_NAME = "RadioGroupIndicator";
const $a0caedef5e243859$export$5fb54c671a65c88 = /*#__PURE__*/ (0, $bh6RR.forwardRef)((props, forwardedRef)=>{
    const { __scopeRadioGroup: __scopeRadioGroup, ...indicatorProps } = props;
    const radioScope = $a0caedef5e243859$var$$f99a8c78507165f7$var$useRadioScope(__scopeRadioGroup);
    return /*#__PURE__*/ (0, $bh6RR.createElement)($a0caedef5e243859$var$$ce77a8961b41be9e$export$d35a9ffa9a04f9e7, (0, $39ab41060f0dd572$export$2e2bcd8739ae039)({}, radioScope, indicatorProps, {
        ref: forwardedRef
    }));
});
/*#__PURE__*/ Object.assign($a0caedef5e243859$export$5fb54c671a65c88, {
    displayName: $a0caedef5e243859$var$$f99a8c78507165f7$var$INDICATOR_NAME
});
/* ---------------------------------------------------------------------------------------------- */ const $a0caedef5e243859$export$be92b6f5f03c0fe9 = $a0caedef5e243859$export$a98f0dcb43a68a25;
const $a0caedef5e243859$export$6d08773d2e66f8f2 = $a0caedef5e243859$export$9f866c100ef519e4;
const $a0caedef5e243859$export$adb584737d712b70 = $a0caedef5e243859$export$5fb54c671a65c88;



var $bh6RR = parcelRequire("bh6RR");
var $1e6d325bf7ec7d53$exports = {};
"use strict";
Object.defineProperty($1e6d325bf7ec7d53$exports, "__esModule", {
    value: true
});
$1e6d325bf7ec7d53$exports.ReactCSS = $1e6d325bf7ec7d53$exports.loop = $1e6d325bf7ec7d53$exports.handleActive = $1e6d325bf7ec7d53$exports.handleHover = $1e6d325bf7ec7d53$exports.hover = undefined;
var $788957905510a05a$exports = {};
"use strict";
Object.defineProperty($788957905510a05a$exports, "__esModule", {
    value: true
});
$788957905510a05a$exports.flattenNames = undefined;
var $9f6d31f4b784b7df$exports = {};
var $396b15940342a7f1$exports = {};
var $2388da93fa592950$exports = {};

var $dnnhb = parcelRequire("dnnhb");
/** Built-in value references. */ var $2388da93fa592950$var$Symbol = $dnnhb.Symbol;
$2388da93fa592950$exports = $2388da93fa592950$var$Symbol;


var $8005b8efeeb9f4e7$exports = {};

/** Used for built-in method references. */ var $8005b8efeeb9f4e7$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $8005b8efeeb9f4e7$var$hasOwnProperty = $8005b8efeeb9f4e7$var$objectProto.hasOwnProperty;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $8005b8efeeb9f4e7$var$nativeObjectToString = $8005b8efeeb9f4e7$var$objectProto.toString;
/** Built-in value references. */ var $8005b8efeeb9f4e7$var$symToStringTag = $2388da93fa592950$exports ? $2388da93fa592950$exports.toStringTag : undefined;
/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */ function $8005b8efeeb9f4e7$var$getRawTag(value) {
    var isOwn = $8005b8efeeb9f4e7$var$hasOwnProperty.call(value, $8005b8efeeb9f4e7$var$symToStringTag), tag = value[$8005b8efeeb9f4e7$var$symToStringTag];
    try {
        value[$8005b8efeeb9f4e7$var$symToStringTag] = undefined;
        var unmasked = true;
    } catch (e) {}
    var result = $8005b8efeeb9f4e7$var$nativeObjectToString.call(value);
    if (unmasked) {
        if (isOwn) value[$8005b8efeeb9f4e7$var$symToStringTag] = tag;
        else delete value[$8005b8efeeb9f4e7$var$symToStringTag];
    }
    return result;
}
$8005b8efeeb9f4e7$exports = $8005b8efeeb9f4e7$var$getRawTag;


var $8777fc9d1b1902f9$exports = {};
/** Used for built-in method references. */ var $8777fc9d1b1902f9$var$objectProto = Object.prototype;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $8777fc9d1b1902f9$var$nativeObjectToString = $8777fc9d1b1902f9$var$objectProto.toString;
/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */ function $8777fc9d1b1902f9$var$objectToString(value) {
    return $8777fc9d1b1902f9$var$nativeObjectToString.call(value);
}
$8777fc9d1b1902f9$exports = $8777fc9d1b1902f9$var$objectToString;


/** `Object#toString` result references. */ var $396b15940342a7f1$var$nullTag = "[object Null]", $396b15940342a7f1$var$undefinedTag = "[object Undefined]";
/** Built-in value references. */ var $396b15940342a7f1$var$symToStringTag = $2388da93fa592950$exports ? $2388da93fa592950$exports.toStringTag : undefined;
/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ function $396b15940342a7f1$var$baseGetTag(value) {
    if (value == null) return value === undefined ? $396b15940342a7f1$var$undefinedTag : $396b15940342a7f1$var$nullTag;
    return $396b15940342a7f1$var$symToStringTag && $396b15940342a7f1$var$symToStringTag in Object(value) ? $8005b8efeeb9f4e7$exports(value) : $8777fc9d1b1902f9$exports(value);
}
$396b15940342a7f1$exports = $396b15940342a7f1$var$baseGetTag;


var $730d1b366662da48$exports = {};
/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */ var $730d1b366662da48$var$isArray = Array.isArray;
$730d1b366662da48$exports = $730d1b366662da48$var$isArray;


var $4a94b44c4940d5a5$exports = {};
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function $4a94b44c4940d5a5$var$isObjectLike(value) {
    return value != null && typeof value == "object";
}
$4a94b44c4940d5a5$exports = $4a94b44c4940d5a5$var$isObjectLike;


/** `Object#toString` result references. */ var $9f6d31f4b784b7df$var$stringTag = "[object String]";
/**
 * Checks if `value` is classified as a `String` primitive or object.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a string, else `false`.
 * @example
 *
 * _.isString('abc');
 * // => true
 *
 * _.isString(1);
 * // => false
 */ function $9f6d31f4b784b7df$var$isString(value) {
    return typeof value == "string" || !$730d1b366662da48$exports(value) && $4a94b44c4940d5a5$exports(value) && $396b15940342a7f1$exports(value) == $9f6d31f4b784b7df$var$stringTag;
}
$9f6d31f4b784b7df$exports = $9f6d31f4b784b7df$var$isString;


var $788957905510a05a$var$_isString3 = $788957905510a05a$var$_interopRequireDefault($9f6d31f4b784b7df$exports);
var $7d0496aa3b6c593c$exports = {};
var $9a2fd95e744f294f$exports = {};
var $2ffd2d73f118f911$exports = {};
var $39a9db840e8a5122$exports = {};
/**
 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */ function $39a9db840e8a5122$var$createBaseFor(fromRight) {
    return function(object, iteratee, keysFunc) {
        var index = -1, iterable = Object(object), props = keysFunc(object), length = props.length;
        while(length--){
            var key = props[fromRight ? length : ++index];
            if (iteratee(iterable[key], key, iterable) === false) break;
        }
        return object;
    };
}
$39a9db840e8a5122$exports = $39a9db840e8a5122$var$createBaseFor;


/**
 * The base implementation of `baseForOwn` which iterates over `object`
 * properties returned by `keysFunc` and invokes `iteratee` for each property.
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */ var $2ffd2d73f118f911$var$baseFor = $39a9db840e8a5122$exports();
$2ffd2d73f118f911$exports = $2ffd2d73f118f911$var$baseFor;


var $cf65da43818f725f$exports = {};
var $39a283488d173d50$exports = {};
var $7f7a679ab009c8e0$exports = {};
/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */ function $7f7a679ab009c8e0$var$baseTimes(n, iteratee) {
    var index = -1, result = Array(n);
    while(++index < n)result[index] = iteratee(index);
    return result;
}
$7f7a679ab009c8e0$exports = $7f7a679ab009c8e0$var$baseTimes;


var $dd94877d05f10850$exports = {};
var $8f38f8261e818ef2$exports = {};


/** `Object#toString` result references. */ var $8f38f8261e818ef2$var$argsTag = "[object Arguments]";
/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */ function $8f38f8261e818ef2$var$baseIsArguments(value) {
    return $4a94b44c4940d5a5$exports(value) && $396b15940342a7f1$exports(value) == $8f38f8261e818ef2$var$argsTag;
}
$8f38f8261e818ef2$exports = $8f38f8261e818ef2$var$baseIsArguments;



/** Used for built-in method references. */ var $dd94877d05f10850$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $dd94877d05f10850$var$hasOwnProperty = $dd94877d05f10850$var$objectProto.hasOwnProperty;
/** Built-in value references. */ var $dd94877d05f10850$var$propertyIsEnumerable = $dd94877d05f10850$var$objectProto.propertyIsEnumerable;
/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */ var $dd94877d05f10850$var$isArguments = $8f38f8261e818ef2$exports(function() {
    return arguments;
}()) ? $8f38f8261e818ef2$exports : function(value) {
    return $4a94b44c4940d5a5$exports(value) && $dd94877d05f10850$var$hasOwnProperty.call(value, "callee") && !$dd94877d05f10850$var$propertyIsEnumerable.call(value, "callee");
};
$dd94877d05f10850$exports = $dd94877d05f10850$var$isArguments;




var $8TKuU = parcelRequire("8TKuU");
var $ec0ca5ffb2ff14ec$exports = {};
/** Used as references for various `Number` constants. */ var $ec0ca5ffb2ff14ec$var$MAX_SAFE_INTEGER = 9007199254740991;
/** Used to detect unsigned integer values. */ var $ec0ca5ffb2ff14ec$var$reIsUint = /^(?:0|[1-9]\d*)$/;
/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */ function $ec0ca5ffb2ff14ec$var$isIndex(value, length) {
    var type = typeof value;
    length = length == null ? $ec0ca5ffb2ff14ec$var$MAX_SAFE_INTEGER : length;
    return !!length && (type == "number" || type != "symbol" && $ec0ca5ffb2ff14ec$var$reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
}
$ec0ca5ffb2ff14ec$exports = $ec0ca5ffb2ff14ec$var$isIndex;


var $54ae0102d9b8cfdf$exports = {};
var $f4e10a0fb2366352$exports = {};

var $cb5309a5575a37b9$exports = {};
/** Used as references for various `Number` constants. */ var $cb5309a5575a37b9$var$MAX_SAFE_INTEGER = 9007199254740991;
/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */ function $cb5309a5575a37b9$var$isLength(value) {
    return typeof value == "number" && value > -1 && value % 1 == 0 && value <= $cb5309a5575a37b9$var$MAX_SAFE_INTEGER;
}
$cb5309a5575a37b9$exports = $cb5309a5575a37b9$var$isLength;



/** `Object#toString` result references. */ var $f4e10a0fb2366352$var$argsTag = "[object Arguments]", $f4e10a0fb2366352$var$arrayTag = "[object Array]", $f4e10a0fb2366352$var$boolTag = "[object Boolean]", $f4e10a0fb2366352$var$dateTag = "[object Date]", $f4e10a0fb2366352$var$errorTag = "[object Error]", $f4e10a0fb2366352$var$funcTag = "[object Function]", $f4e10a0fb2366352$var$mapTag = "[object Map]", $f4e10a0fb2366352$var$numberTag = "[object Number]", $f4e10a0fb2366352$var$objectTag = "[object Object]", $f4e10a0fb2366352$var$regexpTag = "[object RegExp]", $f4e10a0fb2366352$var$setTag = "[object Set]", $f4e10a0fb2366352$var$stringTag = "[object String]", $f4e10a0fb2366352$var$weakMapTag = "[object WeakMap]";
var $f4e10a0fb2366352$var$arrayBufferTag = "[object ArrayBuffer]", $f4e10a0fb2366352$var$dataViewTag = "[object DataView]", $f4e10a0fb2366352$var$float32Tag = "[object Float32Array]", $f4e10a0fb2366352$var$float64Tag = "[object Float64Array]", $f4e10a0fb2366352$var$int8Tag = "[object Int8Array]", $f4e10a0fb2366352$var$int16Tag = "[object Int16Array]", $f4e10a0fb2366352$var$int32Tag = "[object Int32Array]", $f4e10a0fb2366352$var$uint8Tag = "[object Uint8Array]", $f4e10a0fb2366352$var$uint8ClampedTag = "[object Uint8ClampedArray]", $f4e10a0fb2366352$var$uint16Tag = "[object Uint16Array]", $f4e10a0fb2366352$var$uint32Tag = "[object Uint32Array]";
/** Used to identify `toStringTag` values of typed arrays. */ var $f4e10a0fb2366352$var$typedArrayTags = {};
$f4e10a0fb2366352$var$typedArrayTags[$f4e10a0fb2366352$var$float32Tag] = $f4e10a0fb2366352$var$typedArrayTags[$f4e10a0fb2366352$var$float64Tag] = $f4e10a0fb2366352$var$typedArrayTags[$f4e10a0fb2366352$var$int8Tag] = $f4e10a0fb2366352$var$typedArrayTags[$f4e10a0fb2366352$var$int16Tag] = $f4e10a0fb2366352$var$typedArrayTags[$f4e10a0fb2366352$var$int32Tag] = $f4e10a0fb2366352$var$typedArrayTags[$f4e10a0fb2366352$var$uint8Tag] = $f4e10a0fb2366352$var$typedArrayTags[$f4e10a0fb2366352$var$uint8ClampedTag] = $f4e10a0fb2366352$var$typedArrayTags[$f4e10a0fb2366352$var$uint16Tag] = $f4e10a0fb2366352$var$typedArrayTags[$f4e10a0fb2366352$var$uint32Tag] = true;
$f4e10a0fb2366352$var$typedArrayTags[$f4e10a0fb2366352$var$argsTag] = $f4e10a0fb2366352$var$typedArrayTags[$f4e10a0fb2366352$var$arrayTag] = $f4e10a0fb2366352$var$typedArrayTags[$f4e10a0fb2366352$var$arrayBufferTag] = $f4e10a0fb2366352$var$typedArrayTags[$f4e10a0fb2366352$var$boolTag] = $f4e10a0fb2366352$var$typedArrayTags[$f4e10a0fb2366352$var$dataViewTag] = $f4e10a0fb2366352$var$typedArrayTags[$f4e10a0fb2366352$var$dateTag] = $f4e10a0fb2366352$var$typedArrayTags[$f4e10a0fb2366352$var$errorTag] = $f4e10a0fb2366352$var$typedArrayTags[$f4e10a0fb2366352$var$funcTag] = $f4e10a0fb2366352$var$typedArrayTags[$f4e10a0fb2366352$var$mapTag] = $f4e10a0fb2366352$var$typedArrayTags[$f4e10a0fb2366352$var$numberTag] = $f4e10a0fb2366352$var$typedArrayTags[$f4e10a0fb2366352$var$objectTag] = $f4e10a0fb2366352$var$typedArrayTags[$f4e10a0fb2366352$var$regexpTag] = $f4e10a0fb2366352$var$typedArrayTags[$f4e10a0fb2366352$var$setTag] = $f4e10a0fb2366352$var$typedArrayTags[$f4e10a0fb2366352$var$stringTag] = $f4e10a0fb2366352$var$typedArrayTags[$f4e10a0fb2366352$var$weakMapTag] = false;
/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */ function $f4e10a0fb2366352$var$baseIsTypedArray(value) {
    return $4a94b44c4940d5a5$exports(value) && $cb5309a5575a37b9$exports(value.length) && !!$f4e10a0fb2366352$var$typedArrayTags[$396b15940342a7f1$exports(value)];
}
$f4e10a0fb2366352$exports = $f4e10a0fb2366352$var$baseIsTypedArray;


var $82313b399bb9d3fb$exports = {};
/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */ function $82313b399bb9d3fb$var$baseUnary(func) {
    return function(value) {
        return func(value);
    };
}
$82313b399bb9d3fb$exports = $82313b399bb9d3fb$var$baseUnary;



var $1mm29 = parcelRequire("1mm29");
/* Node.js helper references. */ var $54ae0102d9b8cfdf$var$nodeIsTypedArray = $1mm29 && $1mm29.isTypedArray;
/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */ var $54ae0102d9b8cfdf$var$isTypedArray = $54ae0102d9b8cfdf$var$nodeIsTypedArray ? $82313b399bb9d3fb$exports($54ae0102d9b8cfdf$var$nodeIsTypedArray) : $f4e10a0fb2366352$exports;
$54ae0102d9b8cfdf$exports = $54ae0102d9b8cfdf$var$isTypedArray;


/** Used for built-in method references. */ var $39a283488d173d50$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $39a283488d173d50$var$hasOwnProperty = $39a283488d173d50$var$objectProto.hasOwnProperty;
/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */ function $39a283488d173d50$var$arrayLikeKeys(value, inherited) {
    var isArr = $730d1b366662da48$exports(value), isArg = !isArr && $dd94877d05f10850$exports(value), isBuff = !isArr && !isArg && $8TKuU(value), isType = !isArr && !isArg && !isBuff && $54ae0102d9b8cfdf$exports(value), skipIndexes = isArr || isArg || isBuff || isType, result = skipIndexes ? $7f7a679ab009c8e0$exports(value.length, String) : [], length = result.length;
    for(var key in value)if ((inherited || $39a283488d173d50$var$hasOwnProperty.call(value, key)) && !(skipIndexes && // Safari 9 has enumerable `arguments.length` in strict mode.
    (key == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
    isBuff && (key == "offset" || key == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    isType && (key == "buffer" || key == "byteLength" || key == "byteOffset") || // Skip index properties.
    $ec0ca5ffb2ff14ec$exports(key, length)))) result.push(key);
    return result;
}
$39a283488d173d50$exports = $39a283488d173d50$var$arrayLikeKeys;


var $409962ffb97dfa14$exports = {};
var $966736caab723063$exports = {};
/** Used for built-in method references. */ var $966736caab723063$var$objectProto = Object.prototype;
/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */ function $966736caab723063$var$isPrototype(value) {
    var Ctor = value && value.constructor, proto = typeof Ctor == "function" && Ctor.prototype || $966736caab723063$var$objectProto;
    return value === proto;
}
$966736caab723063$exports = $966736caab723063$var$isPrototype;


var $6a42e4b2642f3889$exports = {};
var $fd668335d1985147$exports = {};
/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */ function $fd668335d1985147$var$overArg(func, transform) {
    return function(arg) {
        return func(transform(arg));
    };
}
$fd668335d1985147$exports = $fd668335d1985147$var$overArg;


/* Built-in method references for those with the same name as other `lodash` methods. */ var $6a42e4b2642f3889$var$nativeKeys = $fd668335d1985147$exports(Object.keys, Object);
$6a42e4b2642f3889$exports = $6a42e4b2642f3889$var$nativeKeys;


/** Used for built-in method references. */ var $409962ffb97dfa14$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $409962ffb97dfa14$var$hasOwnProperty = $409962ffb97dfa14$var$objectProto.hasOwnProperty;
/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function $409962ffb97dfa14$var$baseKeys(object) {
    if (!$966736caab723063$exports(object)) return $6a42e4b2642f3889$exports(object);
    var result = [];
    for(var key in Object(object))if ($409962ffb97dfa14$var$hasOwnProperty.call(object, key) && key != "constructor") result.push(key);
    return result;
}
$409962ffb97dfa14$exports = $409962ffb97dfa14$var$baseKeys;


var $681032a0f414881e$exports = {};
var $3c413d87f292fe2c$exports = {};

var $e4bea0192758232a$exports = {};
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function $e4bea0192758232a$var$isObject(value) {
    var type = typeof value;
    return value != null && (type == "object" || type == "function");
}
$e4bea0192758232a$exports = $e4bea0192758232a$var$isObject;


/** `Object#toString` result references. */ var $3c413d87f292fe2c$var$asyncTag = "[object AsyncFunction]", $3c413d87f292fe2c$var$funcTag = "[object Function]", $3c413d87f292fe2c$var$genTag = "[object GeneratorFunction]", $3c413d87f292fe2c$var$proxyTag = "[object Proxy]";
/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */ function $3c413d87f292fe2c$var$isFunction(value) {
    if (!$e4bea0192758232a$exports(value)) return false;
    // The use of `Object#toString` avoids issues with the `typeof` operator
    // in Safari 9 which returns 'object' for typed arrays and other constructors.
    var tag = $396b15940342a7f1$exports(value);
    return tag == $3c413d87f292fe2c$var$funcTag || tag == $3c413d87f292fe2c$var$genTag || tag == $3c413d87f292fe2c$var$asyncTag || tag == $3c413d87f292fe2c$var$proxyTag;
}
$3c413d87f292fe2c$exports = $3c413d87f292fe2c$var$isFunction;



/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */ function $681032a0f414881e$var$isArrayLike(value) {
    return value != null && $cb5309a5575a37b9$exports(value.length) && !$3c413d87f292fe2c$exports(value);
}
$681032a0f414881e$exports = $681032a0f414881e$var$isArrayLike;


/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */ function $cf65da43818f725f$var$keys(object) {
    return $681032a0f414881e$exports(object) ? $39a283488d173d50$exports(object) : $409962ffb97dfa14$exports(object);
}
$cf65da43818f725f$exports = $cf65da43818f725f$var$keys;


/**
 * The base implementation of `_.forOwn` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Object} Returns `object`.
 */ function $9a2fd95e744f294f$var$baseForOwn(object, iteratee) {
    return object && $2ffd2d73f118f911$exports(object, iteratee, $cf65da43818f725f$exports);
}
$9a2fd95e744f294f$exports = $9a2fd95e744f294f$var$baseForOwn;


var $55146360e6f14e65$exports = {};
var $a961fb58d7bfedbf$exports = {};
/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */ function $a961fb58d7bfedbf$var$identity(value) {
    return value;
}
$a961fb58d7bfedbf$exports = $a961fb58d7bfedbf$var$identity;


/**
 * Casts `value` to `identity` if it's not a function.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {Function} Returns cast function.
 */ function $55146360e6f14e65$var$castFunction(value) {
    return typeof value == "function" ? value : $a961fb58d7bfedbf$exports;
}
$55146360e6f14e65$exports = $55146360e6f14e65$var$castFunction;


/**
 * Iterates over own enumerable string keyed properties of an object and
 * invokes `iteratee` for each property. The iteratee is invoked with three
 * arguments: (value, key, object). Iteratee functions may exit iteration
 * early by explicitly returning `false`.
 *
 * @static
 * @memberOf _
 * @since 0.3.0
 * @category Object
 * @param {Object} object The object to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Object} Returns `object`.
 * @see _.forOwnRight
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.forOwn(new Foo, function(value, key) {
 *   console.log(key);
 * });
 * // => Logs 'a' then 'b' (iteration order is not guaranteed).
 */ function $7d0496aa3b6c593c$var$forOwn(object, iteratee) {
    return object && $9a2fd95e744f294f$exports(object, $55146360e6f14e65$exports(iteratee));
}
$7d0496aa3b6c593c$exports = $7d0496aa3b6c593c$var$forOwn;


var $788957905510a05a$var$_forOwn3 = $788957905510a05a$var$_interopRequireDefault($7d0496aa3b6c593c$exports);
var $c9257f602da58ccf$exports = {};

var $8d6291835bea81d5$exports = {};

/** Built-in value references. */ var $8d6291835bea81d5$var$getPrototype = $fd668335d1985147$exports(Object.getPrototypeOf, Object);
$8d6291835bea81d5$exports = $8d6291835bea81d5$var$getPrototype;



/** `Object#toString` result references. */ var $c9257f602da58ccf$var$objectTag = "[object Object]";
/** Used for built-in method references. */ var $c9257f602da58ccf$var$funcProto = Function.prototype, $c9257f602da58ccf$var$objectProto = Object.prototype;
/** Used to resolve the decompiled source of functions. */ var $c9257f602da58ccf$var$funcToString = $c9257f602da58ccf$var$funcProto.toString;
/** Used to check objects for own properties. */ var $c9257f602da58ccf$var$hasOwnProperty = $c9257f602da58ccf$var$objectProto.hasOwnProperty;
/** Used to infer the `Object` constructor. */ var $c9257f602da58ccf$var$objectCtorString = $c9257f602da58ccf$var$funcToString.call(Object);
/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */ function $c9257f602da58ccf$var$isPlainObject(value) {
    if (!$4a94b44c4940d5a5$exports(value) || $396b15940342a7f1$exports(value) != $c9257f602da58ccf$var$objectTag) return false;
    var proto = $8d6291835bea81d5$exports(value);
    if (proto === null) return true;
    var Ctor = $c9257f602da58ccf$var$hasOwnProperty.call(proto, "constructor") && proto.constructor;
    return typeof Ctor == "function" && Ctor instanceof Ctor && $c9257f602da58ccf$var$funcToString.call(Ctor) == $c9257f602da58ccf$var$objectCtorString;
}
$c9257f602da58ccf$exports = $c9257f602da58ccf$var$isPlainObject;


var $788957905510a05a$var$_isPlainObject3 = $788957905510a05a$var$_interopRequireDefault($c9257f602da58ccf$exports);
var $55eb60374a0d0544$exports = {};
var $2984cf9c242fe53a$exports = {};
/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */ function $2984cf9c242fe53a$var$arrayMap(array, iteratee) {
    var index = -1, length = array == null ? 0 : array.length, result = Array(length);
    while(++index < length)result[index] = iteratee(array[index], index, array);
    return result;
}
$2984cf9c242fe53a$exports = $2984cf9c242fe53a$var$arrayMap;


var $9cb616549df16e8a$exports = {};
var $0eb3b1f0b77150e5$exports = {};
var $f85ee30bf79cc837$exports = {};
var $419ba895b4ae45e6$exports = {};
var $6600d6a94bbfda55$exports = {};
var $88f8a458a1ebfb99$exports = {};
/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */ function $88f8a458a1ebfb99$var$listCacheClear() {
    this.__data__ = [];
    this.size = 0;
}
$88f8a458a1ebfb99$exports = $88f8a458a1ebfb99$var$listCacheClear;


var $ed3d1b1aa1c6eb21$exports = {};
var $f0b9af7eb68dc1e4$exports = {};
var $d3b5784bbbc55641$exports = {};
/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */ function $d3b5784bbbc55641$var$eq(value, other) {
    return value === other || value !== value && other !== other;
}
$d3b5784bbbc55641$exports = $d3b5784bbbc55641$var$eq;


/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $f0b9af7eb68dc1e4$var$assocIndexOf(array, key) {
    var length = array.length;
    while(length--){
        if ($d3b5784bbbc55641$exports(array[length][0], key)) return length;
    }
    return -1;
}
$f0b9af7eb68dc1e4$exports = $f0b9af7eb68dc1e4$var$assocIndexOf;


/** Used for built-in method references. */ var $ed3d1b1aa1c6eb21$var$arrayProto = Array.prototype;
/** Built-in value references. */ var $ed3d1b1aa1c6eb21$var$splice = $ed3d1b1aa1c6eb21$var$arrayProto.splice;
/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $ed3d1b1aa1c6eb21$var$listCacheDelete(key) {
    var data = this.__data__, index = $f0b9af7eb68dc1e4$exports(data, key);
    if (index < 0) return false;
    var lastIndex = data.length - 1;
    if (index == lastIndex) data.pop();
    else $ed3d1b1aa1c6eb21$var$splice.call(data, index, 1);
    --this.size;
    return true;
}
$ed3d1b1aa1c6eb21$exports = $ed3d1b1aa1c6eb21$var$listCacheDelete;


var $22784f0ffcbfc03d$exports = {};

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $22784f0ffcbfc03d$var$listCacheGet(key) {
    var data = this.__data__, index = $f0b9af7eb68dc1e4$exports(data, key);
    return index < 0 ? undefined : data[index][1];
}
$22784f0ffcbfc03d$exports = $22784f0ffcbfc03d$var$listCacheGet;


var $4d131af2d890865b$exports = {};

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $4d131af2d890865b$var$listCacheHas(key) {
    return $f0b9af7eb68dc1e4$exports(this.__data__, key) > -1;
}
$4d131af2d890865b$exports = $4d131af2d890865b$var$listCacheHas;


var $0a2d0ac185e5d2a7$exports = {};

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */ function $0a2d0ac185e5d2a7$var$listCacheSet(key, value) {
    var data = this.__data__, index = $f0b9af7eb68dc1e4$exports(data, key);
    if (index < 0) {
        ++this.size;
        data.push([
            key,
            value
        ]);
    } else data[index][1] = value;
    return this;
}
$0a2d0ac185e5d2a7$exports = $0a2d0ac185e5d2a7$var$listCacheSet;


/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $6600d6a94bbfda55$var$ListCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `ListCache`.
$6600d6a94bbfda55$var$ListCache.prototype.clear = $88f8a458a1ebfb99$exports;
$6600d6a94bbfda55$var$ListCache.prototype["delete"] = $ed3d1b1aa1c6eb21$exports;
$6600d6a94bbfda55$var$ListCache.prototype.get = $22784f0ffcbfc03d$exports;
$6600d6a94bbfda55$var$ListCache.prototype.has = $4d131af2d890865b$exports;
$6600d6a94bbfda55$var$ListCache.prototype.set = $0a2d0ac185e5d2a7$exports;
$6600d6a94bbfda55$exports = $6600d6a94bbfda55$var$ListCache;


var $9d1ea3c08850b010$exports = {};

/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */ function $9d1ea3c08850b010$var$stackClear() {
    this.__data__ = new $6600d6a94bbfda55$exports;
    this.size = 0;
}
$9d1ea3c08850b010$exports = $9d1ea3c08850b010$var$stackClear;


var $0ff58e43e318c414$exports = {};
/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $0ff58e43e318c414$var$stackDelete(key) {
    var data = this.__data__, result = data["delete"](key);
    this.size = data.size;
    return result;
}
$0ff58e43e318c414$exports = $0ff58e43e318c414$var$stackDelete;


var $81d58a22530578d0$exports = {};
/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $81d58a22530578d0$var$stackGet(key) {
    return this.__data__.get(key);
}
$81d58a22530578d0$exports = $81d58a22530578d0$var$stackGet;


var $48cf88273b00b4ea$exports = {};
/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $48cf88273b00b4ea$var$stackHas(key) {
    return this.__data__.has(key);
}
$48cf88273b00b4ea$exports = $48cf88273b00b4ea$var$stackHas;


var $37ff411d932fb6f2$exports = {};

var $ab52caa45642ed43$exports = {};
var $507cda0e3d4397c2$exports = {};
var $8d02eb250319088c$exports = {};

var $53e75170d73e0e3c$exports = {};
var $558079b1ab119fea$exports = {};

var $dnnhb = parcelRequire("dnnhb");
/** Used to detect overreaching core-js shims. */ var $558079b1ab119fea$var$coreJsData = $dnnhb["__core-js_shared__"];
$558079b1ab119fea$exports = $558079b1ab119fea$var$coreJsData;


/** Used to detect methods masquerading as native. */ var $53e75170d73e0e3c$var$maskSrcKey = function() {
    var uid = /[^.]+$/.exec($558079b1ab119fea$exports && $558079b1ab119fea$exports.keys && $558079b1ab119fea$exports.keys.IE_PROTO || "");
    return uid ? "Symbol(src)_1." + uid : "";
}();
/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */ function $53e75170d73e0e3c$var$isMasked(func) {
    return !!$53e75170d73e0e3c$var$maskSrcKey && $53e75170d73e0e3c$var$maskSrcKey in func;
}
$53e75170d73e0e3c$exports = $53e75170d73e0e3c$var$isMasked;



var $5d4c9208b54c16cf$exports = {};
/** Used for built-in method references. */ var $5d4c9208b54c16cf$var$funcProto = Function.prototype;
/** Used to resolve the decompiled source of functions. */ var $5d4c9208b54c16cf$var$funcToString = $5d4c9208b54c16cf$var$funcProto.toString;
/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */ function $5d4c9208b54c16cf$var$toSource(func) {
    if (func != null) {
        try {
            return $5d4c9208b54c16cf$var$funcToString.call(func);
        } catch (e) {}
        try {
            return func + "";
        } catch (e) {}
    }
    return "";
}
$5d4c9208b54c16cf$exports = $5d4c9208b54c16cf$var$toSource;


/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */ var $8d02eb250319088c$var$reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
/** Used to detect host constructors (Safari). */ var $8d02eb250319088c$var$reIsHostCtor = /^\[object .+?Constructor\]$/;
/** Used for built-in method references. */ var $8d02eb250319088c$var$funcProto = Function.prototype, $8d02eb250319088c$var$objectProto = Object.prototype;
/** Used to resolve the decompiled source of functions. */ var $8d02eb250319088c$var$funcToString = $8d02eb250319088c$var$funcProto.toString;
/** Used to check objects for own properties. */ var $8d02eb250319088c$var$hasOwnProperty = $8d02eb250319088c$var$objectProto.hasOwnProperty;
/** Used to detect if a method is native. */ var $8d02eb250319088c$var$reIsNative = RegExp("^" + $8d02eb250319088c$var$funcToString.call($8d02eb250319088c$var$hasOwnProperty).replace($8d02eb250319088c$var$reRegExpChar, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$");
/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */ function $8d02eb250319088c$var$baseIsNative(value) {
    if (!$e4bea0192758232a$exports(value) || $53e75170d73e0e3c$exports(value)) return false;
    var pattern = $3c413d87f292fe2c$exports(value) ? $8d02eb250319088c$var$reIsNative : $8d02eb250319088c$var$reIsHostCtor;
    return pattern.test($5d4c9208b54c16cf$exports(value));
}
$8d02eb250319088c$exports = $8d02eb250319088c$var$baseIsNative;


var $d117e89f87247905$exports = {};
/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */ function $d117e89f87247905$var$getValue(object, key) {
    return object == null ? undefined : object[key];
}
$d117e89f87247905$exports = $d117e89f87247905$var$getValue;


/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */ function $507cda0e3d4397c2$var$getNative(object, key) {
    var value = $d117e89f87247905$exports(object, key);
    return $8d02eb250319088c$exports(value) ? value : undefined;
}
$507cda0e3d4397c2$exports = $507cda0e3d4397c2$var$getNative;



var $dnnhb = parcelRequire("dnnhb");
/* Built-in method references that are verified to be native. */ var $ab52caa45642ed43$var$Map = $507cda0e3d4397c2$exports($dnnhb, "Map");
$ab52caa45642ed43$exports = $ab52caa45642ed43$var$Map;


var $eb2847cf8b43e448$exports = {};
var $0ef93b41d443d840$exports = {};
var $096b6e8d9d98217d$exports = {};
var $a41c4150a4a0597c$exports = {};
var $3775533b2ea97104$exports = {};

/* Built-in method references that are verified to be native. */ var $3775533b2ea97104$var$nativeCreate = $507cda0e3d4397c2$exports(Object, "create");
$3775533b2ea97104$exports = $3775533b2ea97104$var$nativeCreate;


/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */ function $a41c4150a4a0597c$var$hashClear() {
    this.__data__ = $3775533b2ea97104$exports ? $3775533b2ea97104$exports(null) : {};
    this.size = 0;
}
$a41c4150a4a0597c$exports = $a41c4150a4a0597c$var$hashClear;


var $512e538f8ec06abe$exports = {};
/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $512e538f8ec06abe$var$hashDelete(key) {
    var result = this.has(key) && delete this.__data__[key];
    this.size -= result ? 1 : 0;
    return result;
}
$512e538f8ec06abe$exports = $512e538f8ec06abe$var$hashDelete;


var $305befcd54445446$exports = {};

/** Used to stand-in for `undefined` hash values. */ var $305befcd54445446$var$HASH_UNDEFINED = "__lodash_hash_undefined__";
/** Used for built-in method references. */ var $305befcd54445446$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $305befcd54445446$var$hasOwnProperty = $305befcd54445446$var$objectProto.hasOwnProperty;
/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $305befcd54445446$var$hashGet(key) {
    var data = this.__data__;
    if ($3775533b2ea97104$exports) {
        var result = data[key];
        return result === $305befcd54445446$var$HASH_UNDEFINED ? undefined : result;
    }
    return $305befcd54445446$var$hasOwnProperty.call(data, key) ? data[key] : undefined;
}
$305befcd54445446$exports = $305befcd54445446$var$hashGet;


var $e98c409e6c78ac8d$exports = {};

/** Used for built-in method references. */ var $e98c409e6c78ac8d$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $e98c409e6c78ac8d$var$hasOwnProperty = $e98c409e6c78ac8d$var$objectProto.hasOwnProperty;
/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $e98c409e6c78ac8d$var$hashHas(key) {
    var data = this.__data__;
    return $3775533b2ea97104$exports ? data[key] !== undefined : $e98c409e6c78ac8d$var$hasOwnProperty.call(data, key);
}
$e98c409e6c78ac8d$exports = $e98c409e6c78ac8d$var$hashHas;


var $5aa4d120853b2dad$exports = {};

/** Used to stand-in for `undefined` hash values. */ var $5aa4d120853b2dad$var$HASH_UNDEFINED = "__lodash_hash_undefined__";
/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */ function $5aa4d120853b2dad$var$hashSet(key, value) {
    var data = this.__data__;
    this.size += this.has(key) ? 0 : 1;
    data[key] = $3775533b2ea97104$exports && value === undefined ? $5aa4d120853b2dad$var$HASH_UNDEFINED : value;
    return this;
}
$5aa4d120853b2dad$exports = $5aa4d120853b2dad$var$hashSet;


/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $096b6e8d9d98217d$var$Hash(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `Hash`.
$096b6e8d9d98217d$var$Hash.prototype.clear = $a41c4150a4a0597c$exports;
$096b6e8d9d98217d$var$Hash.prototype["delete"] = $512e538f8ec06abe$exports;
$096b6e8d9d98217d$var$Hash.prototype.get = $305befcd54445446$exports;
$096b6e8d9d98217d$var$Hash.prototype.has = $e98c409e6c78ac8d$exports;
$096b6e8d9d98217d$var$Hash.prototype.set = $5aa4d120853b2dad$exports;
$096b6e8d9d98217d$exports = $096b6e8d9d98217d$var$Hash;




/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */ function $0ef93b41d443d840$var$mapCacheClear() {
    this.size = 0;
    this.__data__ = {
        "hash": new $096b6e8d9d98217d$exports,
        "map": new ($ab52caa45642ed43$exports || $6600d6a94bbfda55$exports),
        "string": new $096b6e8d9d98217d$exports
    };
}
$0ef93b41d443d840$exports = $0ef93b41d443d840$var$mapCacheClear;


var $d766380f20569b4b$exports = {};
var $134523692be3fdae$exports = {};
var $674a762a247d0e5a$exports = {};
/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */ function $674a762a247d0e5a$var$isKeyable(value) {
    var type = typeof value;
    return type == "string" || type == "number" || type == "symbol" || type == "boolean" ? value !== "__proto__" : value === null;
}
$674a762a247d0e5a$exports = $674a762a247d0e5a$var$isKeyable;


/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */ function $134523692be3fdae$var$getMapData(map, key) {
    var data = map.__data__;
    return $674a762a247d0e5a$exports(key) ? data[typeof key == "string" ? "string" : "hash"] : data.map;
}
$134523692be3fdae$exports = $134523692be3fdae$var$getMapData;


/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $d766380f20569b4b$var$mapCacheDelete(key) {
    var result = $134523692be3fdae$exports(this, key)["delete"](key);
    this.size -= result ? 1 : 0;
    return result;
}
$d766380f20569b4b$exports = $d766380f20569b4b$var$mapCacheDelete;


var $31567d8d775c5c8a$exports = {};

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $31567d8d775c5c8a$var$mapCacheGet(key) {
    return $134523692be3fdae$exports(this, key).get(key);
}
$31567d8d775c5c8a$exports = $31567d8d775c5c8a$var$mapCacheGet;


var $3d8e18ae61a2fd42$exports = {};

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $3d8e18ae61a2fd42$var$mapCacheHas(key) {
    return $134523692be3fdae$exports(this, key).has(key);
}
$3d8e18ae61a2fd42$exports = $3d8e18ae61a2fd42$var$mapCacheHas;


var $908883b24173d38c$exports = {};

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */ function $908883b24173d38c$var$mapCacheSet(key, value) {
    var data = $134523692be3fdae$exports(this, key), size = data.size;
    data.set(key, value);
    this.size += data.size == size ? 0 : 1;
    return this;
}
$908883b24173d38c$exports = $908883b24173d38c$var$mapCacheSet;


/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $eb2847cf8b43e448$var$MapCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `MapCache`.
$eb2847cf8b43e448$var$MapCache.prototype.clear = $0ef93b41d443d840$exports;
$eb2847cf8b43e448$var$MapCache.prototype["delete"] = $d766380f20569b4b$exports;
$eb2847cf8b43e448$var$MapCache.prototype.get = $31567d8d775c5c8a$exports;
$eb2847cf8b43e448$var$MapCache.prototype.has = $3d8e18ae61a2fd42$exports;
$eb2847cf8b43e448$var$MapCache.prototype.set = $908883b24173d38c$exports;
$eb2847cf8b43e448$exports = $eb2847cf8b43e448$var$MapCache;


/** Used as the size to enable large array optimizations. */ var $37ff411d932fb6f2$var$LARGE_ARRAY_SIZE = 200;
/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */ function $37ff411d932fb6f2$var$stackSet(key, value) {
    var data = this.__data__;
    if (data instanceof $6600d6a94bbfda55$exports) {
        var pairs = data.__data__;
        if (!$ab52caa45642ed43$exports || pairs.length < $37ff411d932fb6f2$var$LARGE_ARRAY_SIZE - 1) {
            pairs.push([
                key,
                value
            ]);
            this.size = ++data.size;
            return this;
        }
        data = this.__data__ = new $eb2847cf8b43e448$exports(pairs);
    }
    data.set(key, value);
    this.size = data.size;
    return this;
}
$37ff411d932fb6f2$exports = $37ff411d932fb6f2$var$stackSet;


/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $419ba895b4ae45e6$var$Stack(entries) {
    var data = this.__data__ = new $6600d6a94bbfda55$exports(entries);
    this.size = data.size;
}
// Add methods to `Stack`.
$419ba895b4ae45e6$var$Stack.prototype.clear = $9d1ea3c08850b010$exports;
$419ba895b4ae45e6$var$Stack.prototype["delete"] = $0ff58e43e318c414$exports;
$419ba895b4ae45e6$var$Stack.prototype.get = $81d58a22530578d0$exports;
$419ba895b4ae45e6$var$Stack.prototype.has = $48cf88273b00b4ea$exports;
$419ba895b4ae45e6$var$Stack.prototype.set = $37ff411d932fb6f2$exports;
$419ba895b4ae45e6$exports = $419ba895b4ae45e6$var$Stack;


var $f62f68a862120e6f$exports = {};
var $c81129c59aef2ccf$exports = {};

var $0f039f12cd2ac022$exports = {};
var $cb3d1d2f030b3948$exports = {};

var $975c698101e172f2$exports = {};
/** Used to stand-in for `undefined` hash values. */ var $975c698101e172f2$var$HASH_UNDEFINED = "__lodash_hash_undefined__";
/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */ function $975c698101e172f2$var$setCacheAdd(value) {
    this.__data__.set(value, $975c698101e172f2$var$HASH_UNDEFINED);
    return this;
}
$975c698101e172f2$exports = $975c698101e172f2$var$setCacheAdd;


var $2b07a45d13b540cb$exports = {};
/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */ function $2b07a45d13b540cb$var$setCacheHas(value) {
    return this.__data__.has(value);
}
$2b07a45d13b540cb$exports = $2b07a45d13b540cb$var$setCacheHas;


/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */ function $cb3d1d2f030b3948$var$SetCache(values) {
    var index = -1, length = values == null ? 0 : values.length;
    this.__data__ = new $eb2847cf8b43e448$exports;
    while(++index < length)this.add(values[index]);
}
// Add methods to `SetCache`.
$cb3d1d2f030b3948$var$SetCache.prototype.add = $cb3d1d2f030b3948$var$SetCache.prototype.push = $975c698101e172f2$exports;
$cb3d1d2f030b3948$var$SetCache.prototype.has = $2b07a45d13b540cb$exports;
$cb3d1d2f030b3948$exports = $cb3d1d2f030b3948$var$SetCache;


var $c0ac884d1efe56ee$exports = {};
/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */ function $c0ac884d1efe56ee$var$arraySome(array, predicate) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        if (predicate(array[index], index, array)) return true;
    }
    return false;
}
$c0ac884d1efe56ee$exports = $c0ac884d1efe56ee$var$arraySome;


var $058827dcb6837216$exports = {};
/**
 * Checks if a `cache` value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $058827dcb6837216$var$cacheHas(cache, key) {
    return cache.has(key);
}
$058827dcb6837216$exports = $058827dcb6837216$var$cacheHas;


/** Used to compose bitmasks for value comparisons. */ var $0f039f12cd2ac022$var$COMPARE_PARTIAL_FLAG = 1, $0f039f12cd2ac022$var$COMPARE_UNORDERED_FLAG = 2;
/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */ function $0f039f12cd2ac022$var$equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
    var isPartial = bitmask & $0f039f12cd2ac022$var$COMPARE_PARTIAL_FLAG, arrLength = array.length, othLength = other.length;
    if (arrLength != othLength && !(isPartial && othLength > arrLength)) return false;
    // Check that cyclic values are equal.
    var arrStacked = stack.get(array);
    var othStacked = stack.get(other);
    if (arrStacked && othStacked) return arrStacked == other && othStacked == array;
    var index = -1, result = true, seen = bitmask & $0f039f12cd2ac022$var$COMPARE_UNORDERED_FLAG ? new $cb3d1d2f030b3948$exports : undefined;
    stack.set(array, other);
    stack.set(other, array);
    // Ignore non-index properties.
    while(++index < arrLength){
        var arrValue = array[index], othValue = other[index];
        if (customizer) var compared = isPartial ? customizer(othValue, arrValue, index, other, array, stack) : customizer(arrValue, othValue, index, array, other, stack);
        if (compared !== undefined) {
            if (compared) continue;
            result = false;
            break;
        }
        // Recursively compare arrays (susceptible to call stack limits).
        if (seen) {
            if (!$c0ac884d1efe56ee$exports(other, function(othValue, othIndex) {
                if (!$058827dcb6837216$exports(seen, othIndex) && (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) return seen.push(othIndex);
            })) {
                result = false;
                break;
            }
        } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
            result = false;
            break;
        }
    }
    stack["delete"](array);
    stack["delete"](other);
    return result;
}
$0f039f12cd2ac022$exports = $0f039f12cd2ac022$var$equalArrays;


var $e7b4f0da30108603$exports = {};

var $f3f1e8c287dc271d$exports = {};

var $dnnhb = parcelRequire("dnnhb");
/** Built-in value references. */ var $f3f1e8c287dc271d$var$Uint8Array = $dnnhb.Uint8Array;
$f3f1e8c287dc271d$exports = $f3f1e8c287dc271d$var$Uint8Array;




var $aa101734006c8cb4$exports = {};
/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */ function $aa101734006c8cb4$var$mapToArray(map) {
    var index = -1, result = Array(map.size);
    map.forEach(function(value, key) {
        result[++index] = [
            key,
            value
        ];
    });
    return result;
}
$aa101734006c8cb4$exports = $aa101734006c8cb4$var$mapToArray;


var $3fc617daaa01c913$exports = {};
/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */ function $3fc617daaa01c913$var$setToArray(set) {
    var index = -1, result = Array(set.size);
    set.forEach(function(value) {
        result[++index] = value;
    });
    return result;
}
$3fc617daaa01c913$exports = $3fc617daaa01c913$var$setToArray;


/** Used to compose bitmasks for value comparisons. */ var $e7b4f0da30108603$var$COMPARE_PARTIAL_FLAG = 1, $e7b4f0da30108603$var$COMPARE_UNORDERED_FLAG = 2;
/** `Object#toString` result references. */ var $e7b4f0da30108603$var$boolTag = "[object Boolean]", $e7b4f0da30108603$var$dateTag = "[object Date]", $e7b4f0da30108603$var$errorTag = "[object Error]", $e7b4f0da30108603$var$mapTag = "[object Map]", $e7b4f0da30108603$var$numberTag = "[object Number]", $e7b4f0da30108603$var$regexpTag = "[object RegExp]", $e7b4f0da30108603$var$setTag = "[object Set]", $e7b4f0da30108603$var$stringTag = "[object String]", $e7b4f0da30108603$var$symbolTag = "[object Symbol]";
var $e7b4f0da30108603$var$arrayBufferTag = "[object ArrayBuffer]", $e7b4f0da30108603$var$dataViewTag = "[object DataView]";
/** Used to convert symbols to primitives and strings. */ var $e7b4f0da30108603$var$symbolProto = $2388da93fa592950$exports ? $2388da93fa592950$exports.prototype : undefined, $e7b4f0da30108603$var$symbolValueOf = $e7b4f0da30108603$var$symbolProto ? $e7b4f0da30108603$var$symbolProto.valueOf : undefined;
/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function $e7b4f0da30108603$var$equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
    switch(tag){
        case $e7b4f0da30108603$var$dataViewTag:
            if (object.byteLength != other.byteLength || object.byteOffset != other.byteOffset) return false;
            object = object.buffer;
            other = other.buffer;
        case $e7b4f0da30108603$var$arrayBufferTag:
            if (object.byteLength != other.byteLength || !equalFunc(new $f3f1e8c287dc271d$exports(object), new $f3f1e8c287dc271d$exports(other))) return false;
            return true;
        case $e7b4f0da30108603$var$boolTag:
        case $e7b4f0da30108603$var$dateTag:
        case $e7b4f0da30108603$var$numberTag:
            // Coerce booleans to `1` or `0` and dates to milliseconds.
            // Invalid dates are coerced to `NaN`.
            return $d3b5784bbbc55641$exports(+object, +other);
        case $e7b4f0da30108603$var$errorTag:
            return object.name == other.name && object.message == other.message;
        case $e7b4f0da30108603$var$regexpTag:
        case $e7b4f0da30108603$var$stringTag:
            // Coerce regexes to strings and treat strings, primitives and objects,
            // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
            // for more details.
            return object == other + "";
        case $e7b4f0da30108603$var$mapTag:
            var convert = $aa101734006c8cb4$exports;
        case $e7b4f0da30108603$var$setTag:
            var isPartial = bitmask & $e7b4f0da30108603$var$COMPARE_PARTIAL_FLAG;
            convert || (convert = $3fc617daaa01c913$exports);
            if (object.size != other.size && !isPartial) return false;
            // Assume cyclic values are equal.
            var stacked = stack.get(object);
            if (stacked) return stacked == other;
            bitmask |= $e7b4f0da30108603$var$COMPARE_UNORDERED_FLAG;
            // Recursively compare objects (susceptible to call stack limits).
            stack.set(object, other);
            var result = $0f039f12cd2ac022$exports(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
            stack["delete"](object);
            return result;
        case $e7b4f0da30108603$var$symbolTag:
            if ($e7b4f0da30108603$var$symbolValueOf) return $e7b4f0da30108603$var$symbolValueOf.call(object) == $e7b4f0da30108603$var$symbolValueOf.call(other);
    }
    return false;
}
$e7b4f0da30108603$exports = $e7b4f0da30108603$var$equalByTag;


var $a7b235c007594e3f$exports = {};
var $3087323db8ebdb4a$exports = {};
var $8ff55e87051475e3$exports = {};
var $ce3fbf26bf92081d$exports = {};
/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */ function $ce3fbf26bf92081d$var$arrayPush(array, values) {
    var index = -1, length = values.length, offset = array.length;
    while(++index < length)array[offset + index] = values[index];
    return array;
}
$ce3fbf26bf92081d$exports = $ce3fbf26bf92081d$var$arrayPush;



/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */ function $8ff55e87051475e3$var$baseGetAllKeys(object, keysFunc, symbolsFunc) {
    var result = keysFunc(object);
    return $730d1b366662da48$exports(object) ? result : $ce3fbf26bf92081d$exports(result, symbolsFunc(object));
}
$8ff55e87051475e3$exports = $8ff55e87051475e3$var$baseGetAllKeys;


var $6f0ffdf0419abb03$exports = {};
var $4f67014188a0aed7$exports = {};
/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */ function $4f67014188a0aed7$var$arrayFilter(array, predicate) {
    var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
    while(++index < length){
        var value = array[index];
        if (predicate(value, index, array)) result[resIndex++] = value;
    }
    return result;
}
$4f67014188a0aed7$exports = $4f67014188a0aed7$var$arrayFilter;


var $be064eff5dc241cd$exports = {};
/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */ function $be064eff5dc241cd$var$stubArray() {
    return [];
}
$be064eff5dc241cd$exports = $be064eff5dc241cd$var$stubArray;


/** Used for built-in method references. */ var $6f0ffdf0419abb03$var$objectProto = Object.prototype;
/** Built-in value references. */ var $6f0ffdf0419abb03$var$propertyIsEnumerable = $6f0ffdf0419abb03$var$objectProto.propertyIsEnumerable;
/* Built-in method references for those with the same name as other `lodash` methods. */ var $6f0ffdf0419abb03$var$nativeGetSymbols = Object.getOwnPropertySymbols;
/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */ var $6f0ffdf0419abb03$var$getSymbols = !$6f0ffdf0419abb03$var$nativeGetSymbols ? $be064eff5dc241cd$exports : function(object) {
    if (object == null) return [];
    object = Object(object);
    return $4f67014188a0aed7$exports($6f0ffdf0419abb03$var$nativeGetSymbols(object), function(symbol) {
        return $6f0ffdf0419abb03$var$propertyIsEnumerable.call(object, symbol);
    });
};
$6f0ffdf0419abb03$exports = $6f0ffdf0419abb03$var$getSymbols;



/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */ function $3087323db8ebdb4a$var$getAllKeys(object) {
    return $8ff55e87051475e3$exports(object, $cf65da43818f725f$exports, $6f0ffdf0419abb03$exports);
}
$3087323db8ebdb4a$exports = $3087323db8ebdb4a$var$getAllKeys;


/** Used to compose bitmasks for value comparisons. */ var $a7b235c007594e3f$var$COMPARE_PARTIAL_FLAG = 1;
/** Used for built-in method references. */ var $a7b235c007594e3f$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $a7b235c007594e3f$var$hasOwnProperty = $a7b235c007594e3f$var$objectProto.hasOwnProperty;
/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function $a7b235c007594e3f$var$equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
    var isPartial = bitmask & $a7b235c007594e3f$var$COMPARE_PARTIAL_FLAG, objProps = $3087323db8ebdb4a$exports(object), objLength = objProps.length, othProps = $3087323db8ebdb4a$exports(other), othLength = othProps.length;
    if (objLength != othLength && !isPartial) return false;
    var index = objLength;
    while(index--){
        var key = objProps[index];
        if (!(isPartial ? key in other : $a7b235c007594e3f$var$hasOwnProperty.call(other, key))) return false;
    }
    // Check that cyclic values are equal.
    var objStacked = stack.get(object);
    var othStacked = stack.get(other);
    if (objStacked && othStacked) return objStacked == other && othStacked == object;
    var result = true;
    stack.set(object, other);
    stack.set(other, object);
    var skipCtor = isPartial;
    while(++index < objLength){
        key = objProps[index];
        var objValue = object[key], othValue = other[key];
        if (customizer) var compared = isPartial ? customizer(othValue, objValue, key, other, object, stack) : customizer(objValue, othValue, key, object, other, stack);
        // Recursively compare objects (susceptible to call stack limits).
        if (!(compared === undefined ? objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack) : compared)) {
            result = false;
            break;
        }
        skipCtor || (skipCtor = key == "constructor");
    }
    if (result && !skipCtor) {
        var objCtor = object.constructor, othCtor = other.constructor;
        // Non `Object` object instances with different constructors are not equal.
        if (objCtor != othCtor && "constructor" in object && "constructor" in other && !(typeof objCtor == "function" && objCtor instanceof objCtor && typeof othCtor == "function" && othCtor instanceof othCtor)) result = false;
    }
    stack["delete"](object);
    stack["delete"](other);
    return result;
}
$a7b235c007594e3f$exports = $a7b235c007594e3f$var$equalObjects;


var $79d963e32ece07b6$exports = {};
var $bc0c33c3265e5ae1$exports = {};


var $dnnhb = parcelRequire("dnnhb");
/* Built-in method references that are verified to be native. */ var $bc0c33c3265e5ae1$var$DataView = $507cda0e3d4397c2$exports($dnnhb, "DataView");
$bc0c33c3265e5ae1$exports = $bc0c33c3265e5ae1$var$DataView;



var $692fc18a853ab7b1$exports = {};


var $dnnhb = parcelRequire("dnnhb");
/* Built-in method references that are verified to be native. */ var $692fc18a853ab7b1$var$Promise = $507cda0e3d4397c2$exports($dnnhb, "Promise");
$692fc18a853ab7b1$exports = $692fc18a853ab7b1$var$Promise;


var $2f7af927ce68d1f1$exports = {};


var $dnnhb = parcelRequire("dnnhb");
/* Built-in method references that are verified to be native. */ var $2f7af927ce68d1f1$var$Set = $507cda0e3d4397c2$exports($dnnhb, "Set");
$2f7af927ce68d1f1$exports = $2f7af927ce68d1f1$var$Set;


var $47cc78defb163815$exports = {};


var $dnnhb = parcelRequire("dnnhb");
/* Built-in method references that are verified to be native. */ var $47cc78defb163815$var$WeakMap = $507cda0e3d4397c2$exports($dnnhb, "WeakMap");
$47cc78defb163815$exports = $47cc78defb163815$var$WeakMap;




/** `Object#toString` result references. */ var $79d963e32ece07b6$var$mapTag = "[object Map]", $79d963e32ece07b6$var$objectTag = "[object Object]", $79d963e32ece07b6$var$promiseTag = "[object Promise]", $79d963e32ece07b6$var$setTag = "[object Set]", $79d963e32ece07b6$var$weakMapTag = "[object WeakMap]";
var $79d963e32ece07b6$var$dataViewTag = "[object DataView]";
/** Used to detect maps, sets, and weakmaps. */ var $79d963e32ece07b6$var$dataViewCtorString = $5d4c9208b54c16cf$exports($bc0c33c3265e5ae1$exports), $79d963e32ece07b6$var$mapCtorString = $5d4c9208b54c16cf$exports($ab52caa45642ed43$exports), $79d963e32ece07b6$var$promiseCtorString = $5d4c9208b54c16cf$exports($692fc18a853ab7b1$exports), $79d963e32ece07b6$var$setCtorString = $5d4c9208b54c16cf$exports($2f7af927ce68d1f1$exports), $79d963e32ece07b6$var$weakMapCtorString = $5d4c9208b54c16cf$exports($47cc78defb163815$exports);
/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ var $79d963e32ece07b6$var$getTag = $396b15940342a7f1$exports;
// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if ($bc0c33c3265e5ae1$exports && $79d963e32ece07b6$var$getTag(new $bc0c33c3265e5ae1$exports(new ArrayBuffer(1))) != $79d963e32ece07b6$var$dataViewTag || $ab52caa45642ed43$exports && $79d963e32ece07b6$var$getTag(new $ab52caa45642ed43$exports) != $79d963e32ece07b6$var$mapTag || $692fc18a853ab7b1$exports && $79d963e32ece07b6$var$getTag($692fc18a853ab7b1$exports.resolve()) != $79d963e32ece07b6$var$promiseTag || $2f7af927ce68d1f1$exports && $79d963e32ece07b6$var$getTag(new $2f7af927ce68d1f1$exports) != $79d963e32ece07b6$var$setTag || $47cc78defb163815$exports && $79d963e32ece07b6$var$getTag(new $47cc78defb163815$exports) != $79d963e32ece07b6$var$weakMapTag) $79d963e32ece07b6$var$getTag = function(value) {
    var result = $396b15940342a7f1$exports(value), Ctor = result == $79d963e32ece07b6$var$objectTag ? value.constructor : undefined, ctorString = Ctor ? $5d4c9208b54c16cf$exports(Ctor) : "";
    if (ctorString) switch(ctorString){
        case $79d963e32ece07b6$var$dataViewCtorString:
            return $79d963e32ece07b6$var$dataViewTag;
        case $79d963e32ece07b6$var$mapCtorString:
            return $79d963e32ece07b6$var$mapTag;
        case $79d963e32ece07b6$var$promiseCtorString:
            return $79d963e32ece07b6$var$promiseTag;
        case $79d963e32ece07b6$var$setCtorString:
            return $79d963e32ece07b6$var$setTag;
        case $79d963e32ece07b6$var$weakMapCtorString:
            return $79d963e32ece07b6$var$weakMapTag;
    }
    return result;
};
$79d963e32ece07b6$exports = $79d963e32ece07b6$var$getTag;




var $8TKuU = parcelRequire("8TKuU");

/** Used to compose bitmasks for value comparisons. */ var $c81129c59aef2ccf$var$COMPARE_PARTIAL_FLAG = 1;
/** `Object#toString` result references. */ var $c81129c59aef2ccf$var$argsTag = "[object Arguments]", $c81129c59aef2ccf$var$arrayTag = "[object Array]", $c81129c59aef2ccf$var$objectTag = "[object Object]";
/** Used for built-in method references. */ var $c81129c59aef2ccf$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $c81129c59aef2ccf$var$hasOwnProperty = $c81129c59aef2ccf$var$objectProto.hasOwnProperty;
/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function $c81129c59aef2ccf$var$baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
    var objIsArr = $730d1b366662da48$exports(object), othIsArr = $730d1b366662da48$exports(other), objTag = objIsArr ? $c81129c59aef2ccf$var$arrayTag : $79d963e32ece07b6$exports(object), othTag = othIsArr ? $c81129c59aef2ccf$var$arrayTag : $79d963e32ece07b6$exports(other);
    objTag = objTag == $c81129c59aef2ccf$var$argsTag ? $c81129c59aef2ccf$var$objectTag : objTag;
    othTag = othTag == $c81129c59aef2ccf$var$argsTag ? $c81129c59aef2ccf$var$objectTag : othTag;
    var objIsObj = objTag == $c81129c59aef2ccf$var$objectTag, othIsObj = othTag == $c81129c59aef2ccf$var$objectTag, isSameTag = objTag == othTag;
    if (isSameTag && $8TKuU(object)) {
        if (!$8TKuU(other)) return false;
        objIsArr = true;
        objIsObj = false;
    }
    if (isSameTag && !objIsObj) {
        stack || (stack = new $419ba895b4ae45e6$exports);
        return objIsArr || $54ae0102d9b8cfdf$exports(object) ? $0f039f12cd2ac022$exports(object, other, bitmask, customizer, equalFunc, stack) : $e7b4f0da30108603$exports(object, other, objTag, bitmask, customizer, equalFunc, stack);
    }
    if (!(bitmask & $c81129c59aef2ccf$var$COMPARE_PARTIAL_FLAG)) {
        var objIsWrapped = objIsObj && $c81129c59aef2ccf$var$hasOwnProperty.call(object, "__wrapped__"), othIsWrapped = othIsObj && $c81129c59aef2ccf$var$hasOwnProperty.call(other, "__wrapped__");
        if (objIsWrapped || othIsWrapped) {
            var objUnwrapped = objIsWrapped ? object.value() : object, othUnwrapped = othIsWrapped ? other.value() : other;
            stack || (stack = new $419ba895b4ae45e6$exports);
            return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
        }
    }
    if (!isSameTag) return false;
    stack || (stack = new $419ba895b4ae45e6$exports);
    return $a7b235c007594e3f$exports(object, other, bitmask, customizer, equalFunc, stack);
}
$c81129c59aef2ccf$exports = $c81129c59aef2ccf$var$baseIsEqualDeep;



/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Unordered comparison
 *  2 - Partial comparison
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */ function $f62f68a862120e6f$var$baseIsEqual(value, other, bitmask, customizer, stack) {
    if (value === other) return true;
    if (value == null || other == null || !$4a94b44c4940d5a5$exports(value) && !$4a94b44c4940d5a5$exports(other)) return value !== value && other !== other;
    return $c81129c59aef2ccf$exports(value, other, bitmask, customizer, $f62f68a862120e6f$var$baseIsEqual, stack);
}
$f62f68a862120e6f$exports = $f62f68a862120e6f$var$baseIsEqual;


/** Used to compose bitmasks for value comparisons. */ var $f85ee30bf79cc837$var$COMPARE_PARTIAL_FLAG = 1, $f85ee30bf79cc837$var$COMPARE_UNORDERED_FLAG = 2;
/**
 * The base implementation of `_.isMatch` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to inspect.
 * @param {Object} source The object of property values to match.
 * @param {Array} matchData The property names, values, and compare flags to match.
 * @param {Function} [customizer] The function to customize comparisons.
 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
 */ function $f85ee30bf79cc837$var$baseIsMatch(object, source, matchData, customizer) {
    var index = matchData.length, length = index, noCustomizer = !customizer;
    if (object == null) return !length;
    object = Object(object);
    while(index--){
        var data = matchData[index];
        if (noCustomizer && data[2] ? data[1] !== object[data[0]] : !(data[0] in object)) return false;
    }
    while(++index < length){
        data = matchData[index];
        var key = data[0], objValue = object[key], srcValue = data[1];
        if (noCustomizer && data[2]) {
            if (objValue === undefined && !(key in object)) return false;
        } else {
            var stack = new $419ba895b4ae45e6$exports;
            if (customizer) var result = customizer(objValue, srcValue, key, object, source, stack);
            if (!(result === undefined ? $f62f68a862120e6f$exports(srcValue, objValue, $f85ee30bf79cc837$var$COMPARE_PARTIAL_FLAG | $f85ee30bf79cc837$var$COMPARE_UNORDERED_FLAG, customizer, stack) : result)) return false;
        }
    }
    return true;
}
$f85ee30bf79cc837$exports = $f85ee30bf79cc837$var$baseIsMatch;


var $9cf3abfcab32b22c$exports = {};
var $9de722725cfbc330$exports = {};

/**
 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` if suitable for strict
 *  equality comparisons, else `false`.
 */ function $9de722725cfbc330$var$isStrictComparable(value) {
    return value === value && !$e4bea0192758232a$exports(value);
}
$9de722725cfbc330$exports = $9de722725cfbc330$var$isStrictComparable;



/**
 * Gets the property names, values, and compare flags of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the match data of `object`.
 */ function $9cf3abfcab32b22c$var$getMatchData(object) {
    var result = $cf65da43818f725f$exports(object), length = result.length;
    while(length--){
        var key = result[length], value = object[key];
        result[length] = [
            key,
            value,
            $9de722725cfbc330$exports(value)
        ];
    }
    return result;
}
$9cf3abfcab32b22c$exports = $9cf3abfcab32b22c$var$getMatchData;


var $e1a2bd7c53e7bf62$exports = {};
/**
 * A specialized version of `matchesProperty` for source values suitable
 * for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */ function $e1a2bd7c53e7bf62$var$matchesStrictComparable(key, srcValue) {
    return function(object) {
        if (object == null) return false;
        return object[key] === srcValue && (srcValue !== undefined || key in Object(object));
    };
}
$e1a2bd7c53e7bf62$exports = $e1a2bd7c53e7bf62$var$matchesStrictComparable;


/**
 * The base implementation of `_.matches` which doesn't clone `source`.
 *
 * @private
 * @param {Object} source The object of property values to match.
 * @returns {Function} Returns the new spec function.
 */ function $0eb3b1f0b77150e5$var$baseMatches(source) {
    var matchData = $9cf3abfcab32b22c$exports(source);
    if (matchData.length == 1 && matchData[0][2]) return $e1a2bd7c53e7bf62$exports(matchData[0][0], matchData[0][1]);
    return function(object) {
        return object === source || $f85ee30bf79cc837$exports(object, source, matchData);
    };
}
$0eb3b1f0b77150e5$exports = $0eb3b1f0b77150e5$var$baseMatches;


var $b73195e081a09370$exports = {};

var $2edb8fed42c63e28$exports = {};
var $eabd71162fd83291$exports = {};
var $fe9c73848a5358a3$exports = {};

var $b862d544b65a608a$exports = {};

var $42e9ee7d3311848a$exports = {};


/** `Object#toString` result references. */ var $42e9ee7d3311848a$var$symbolTag = "[object Symbol]";
/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */ function $42e9ee7d3311848a$var$isSymbol(value) {
    return typeof value == "symbol" || $4a94b44c4940d5a5$exports(value) && $396b15940342a7f1$exports(value) == $42e9ee7d3311848a$var$symbolTag;
}
$42e9ee7d3311848a$exports = $42e9ee7d3311848a$var$isSymbol;


/** Used to match property names within property paths. */ var $b862d544b65a608a$var$reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, $b862d544b65a608a$var$reIsPlainProp = /^\w*$/;
/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */ function $b862d544b65a608a$var$isKey(value, object) {
    if ($730d1b366662da48$exports(value)) return false;
    var type = typeof value;
    if (type == "number" || type == "symbol" || type == "boolean" || value == null || $42e9ee7d3311848a$exports(value)) return true;
    return $b862d544b65a608a$var$reIsPlainProp.test(value) || !$b862d544b65a608a$var$reIsDeepProp.test(value) || object != null && value in Object(object);
}
$b862d544b65a608a$exports = $b862d544b65a608a$var$isKey;


var $151c0e66f55bb8a0$exports = {};
var $31b0b104ae58f2f5$exports = {};
var $78841c5cb95dbb3f$exports = {};

/** Error message constants. */ var $78841c5cb95dbb3f$var$FUNC_ERROR_TEXT = "Expected a function";
/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */ function $78841c5cb95dbb3f$var$memoize(func, resolver) {
    if (typeof func != "function" || resolver != null && typeof resolver != "function") throw new TypeError($78841c5cb95dbb3f$var$FUNC_ERROR_TEXT);
    var memoized = function() {
        var args = arguments, key = resolver ? resolver.apply(this, args) : args[0], cache = memoized.cache;
        if (cache.has(key)) return cache.get(key);
        var result = func.apply(this, args);
        memoized.cache = cache.set(key, result) || cache;
        return result;
    };
    memoized.cache = new ($78841c5cb95dbb3f$var$memoize.Cache || $eb2847cf8b43e448$exports);
    return memoized;
}
// Expose `MapCache`.
$78841c5cb95dbb3f$var$memoize.Cache = $eb2847cf8b43e448$exports;
$78841c5cb95dbb3f$exports = $78841c5cb95dbb3f$var$memoize;


/** Used as the maximum memoize cache size. */ var $31b0b104ae58f2f5$var$MAX_MEMOIZE_SIZE = 500;
/**
 * A specialized version of `_.memoize` which clears the memoized function's
 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
 *
 * @private
 * @param {Function} func The function to have its output memoized.
 * @returns {Function} Returns the new memoized function.
 */ function $31b0b104ae58f2f5$var$memoizeCapped(func) {
    var result = $78841c5cb95dbb3f$exports(func, function(key) {
        if (cache.size === $31b0b104ae58f2f5$var$MAX_MEMOIZE_SIZE) cache.clear();
        return key;
    });
    var cache = result.cache;
    return result;
}
$31b0b104ae58f2f5$exports = $31b0b104ae58f2f5$var$memoizeCapped;


/** Used to match property names within property paths. */ var $151c0e66f55bb8a0$var$rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
/** Used to match backslashes in property paths. */ var $151c0e66f55bb8a0$var$reEscapeChar = /\\(\\)?/g;
/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */ var $151c0e66f55bb8a0$var$stringToPath = $31b0b104ae58f2f5$exports(function(string) {
    var result = [];
    if (string.charCodeAt(0) === 46 /* . */ ) result.push("");
    string.replace($151c0e66f55bb8a0$var$rePropName, function(match, number, quote, subString) {
        result.push(quote ? subString.replace($151c0e66f55bb8a0$var$reEscapeChar, "$1") : number || match);
    });
    return result;
});
$151c0e66f55bb8a0$exports = $151c0e66f55bb8a0$var$stringToPath;


var $a863ad98b2851f02$exports = {};
var $2859adc7c6ec1638$exports = {};




/** Used as references for various `Number` constants. */ var $2859adc7c6ec1638$var$INFINITY = 1 / 0;
/** Used to convert symbols to primitives and strings. */ var $2859adc7c6ec1638$var$symbolProto = $2388da93fa592950$exports ? $2388da93fa592950$exports.prototype : undefined, $2859adc7c6ec1638$var$symbolToString = $2859adc7c6ec1638$var$symbolProto ? $2859adc7c6ec1638$var$symbolProto.toString : undefined;
/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */ function $2859adc7c6ec1638$var$baseToString(value) {
    // Exit early for strings to avoid a performance hit in some environments.
    if (typeof value == "string") return value;
    if ($730d1b366662da48$exports(value)) // Recursively convert values (susceptible to call stack limits).
    return $2984cf9c242fe53a$exports(value, $2859adc7c6ec1638$var$baseToString) + "";
    if ($42e9ee7d3311848a$exports(value)) return $2859adc7c6ec1638$var$symbolToString ? $2859adc7c6ec1638$var$symbolToString.call(value) : "";
    var result = value + "";
    return result == "0" && 1 / value == -$2859adc7c6ec1638$var$INFINITY ? "-0" : result;
}
$2859adc7c6ec1638$exports = $2859adc7c6ec1638$var$baseToString;


/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */ function $a863ad98b2851f02$var$toString(value) {
    return value == null ? "" : $2859adc7c6ec1638$exports(value);
}
$a863ad98b2851f02$exports = $a863ad98b2851f02$var$toString;


/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {Object} [object] The object to query keys on.
 * @returns {Array} Returns the cast property path array.
 */ function $fe9c73848a5358a3$var$castPath(value, object) {
    if ($730d1b366662da48$exports(value)) return value;
    return $b862d544b65a608a$exports(value, object) ? [
        value
    ] : $151c0e66f55bb8a0$exports($a863ad98b2851f02$exports(value));
}
$fe9c73848a5358a3$exports = $fe9c73848a5358a3$var$castPath;


var $c4981d9c30ac136e$exports = {};

/** Used as references for various `Number` constants. */ var $c4981d9c30ac136e$var$INFINITY = 1 / 0;
/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */ function $c4981d9c30ac136e$var$toKey(value) {
    if (typeof value == "string" || $42e9ee7d3311848a$exports(value)) return value;
    var result = value + "";
    return result == "0" && 1 / value == -$c4981d9c30ac136e$var$INFINITY ? "-0" : result;
}
$c4981d9c30ac136e$exports = $c4981d9c30ac136e$var$toKey;


/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */ function $eabd71162fd83291$var$baseGet(object, path) {
    path = $fe9c73848a5358a3$exports(path, object);
    var index = 0, length = path.length;
    while(object != null && index < length)object = object[$c4981d9c30ac136e$exports(path[index++])];
    return index && index == length ? object : undefined;
}
$eabd71162fd83291$exports = $eabd71162fd83291$var$baseGet;


/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */ function $2edb8fed42c63e28$var$get(object, path, defaultValue) {
    var result = object == null ? undefined : $eabd71162fd83291$exports(object, path);
    return result === undefined ? defaultValue : result;
}
$2edb8fed42c63e28$exports = $2edb8fed42c63e28$var$get;


var $095bca068d70c25b$exports = {};
var $3cd7cedfbee269d1$exports = {};
/**
 * The base implementation of `_.hasIn` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */ function $3cd7cedfbee269d1$var$baseHasIn(object, key) {
    return object != null && key in Object(object);
}
$3cd7cedfbee269d1$exports = $3cd7cedfbee269d1$var$baseHasIn;


var $15587d13e03f2293$exports = {};






/**
 * Checks if `path` exists on `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @param {Function} hasFunc The function to check properties.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 */ function $15587d13e03f2293$var$hasPath(object, path, hasFunc) {
    path = $fe9c73848a5358a3$exports(path, object);
    var index = -1, length = path.length, result = false;
    while(++index < length){
        var key = $c4981d9c30ac136e$exports(path[index]);
        if (!(result = object != null && hasFunc(object, key))) break;
        object = object[key];
    }
    if (result || ++index != length) return result;
    length = object == null ? 0 : object.length;
    return !!length && $cb5309a5575a37b9$exports(length) && $ec0ca5ffb2ff14ec$exports(key, length) && ($730d1b366662da48$exports(object) || $dd94877d05f10850$exports(object));
}
$15587d13e03f2293$exports = $15587d13e03f2293$var$hasPath;


/**
 * Checks if `path` is a direct or inherited property of `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.hasIn(object, 'a');
 * // => true
 *
 * _.hasIn(object, 'a.b');
 * // => true
 *
 * _.hasIn(object, ['a', 'b']);
 * // => true
 *
 * _.hasIn(object, 'b');
 * // => false
 */ function $095bca068d70c25b$var$hasIn(object, path) {
    return object != null && $15587d13e03f2293$exports(object, path, $3cd7cedfbee269d1$exports);
}
$095bca068d70c25b$exports = $095bca068d70c25b$var$hasIn;






/** Used to compose bitmasks for value comparisons. */ var $b73195e081a09370$var$COMPARE_PARTIAL_FLAG = 1, $b73195e081a09370$var$COMPARE_UNORDERED_FLAG = 2;
/**
 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
 *
 * @private
 * @param {string} path The path of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */ function $b73195e081a09370$var$baseMatchesProperty(path, srcValue) {
    if ($b862d544b65a608a$exports(path) && $9de722725cfbc330$exports(srcValue)) return $e1a2bd7c53e7bf62$exports($c4981d9c30ac136e$exports(path), srcValue);
    return function(object) {
        var objValue = $2edb8fed42c63e28$exports(object, path);
        return objValue === undefined && objValue === srcValue ? $095bca068d70c25b$exports(object, path) : $f62f68a862120e6f$exports(srcValue, objValue, $b73195e081a09370$var$COMPARE_PARTIAL_FLAG | $b73195e081a09370$var$COMPARE_UNORDERED_FLAG);
    };
}
$b73195e081a09370$exports = $b73195e081a09370$var$baseMatchesProperty;




var $6f16c695e053e5a0$exports = {};
var $7a7ff6914d162e21$exports = {};
/**
 * The base implementation of `_.property` without support for deep paths.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @returns {Function} Returns the new accessor function.
 */ function $7a7ff6914d162e21$var$baseProperty(key) {
    return function(object) {
        return object == null ? undefined : object[key];
    };
}
$7a7ff6914d162e21$exports = $7a7ff6914d162e21$var$baseProperty;


var $280ff13719d2f033$exports = {};

/**
 * A specialized version of `baseProperty` which supports deep paths.
 *
 * @private
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 */ function $280ff13719d2f033$var$basePropertyDeep(path) {
    return function(object) {
        return $eabd71162fd83291$exports(object, path);
    };
}
$280ff13719d2f033$exports = $280ff13719d2f033$var$basePropertyDeep;




/**
 * Creates a function that returns the value at `path` of a given object.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 * @example
 *
 * var objects = [
 *   { 'a': { 'b': 2 } },
 *   { 'a': { 'b': 1 } }
 * ];
 *
 * _.map(objects, _.property('a.b'));
 * // => [2, 1]
 *
 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
 * // => [1, 2]
 */ function $6f16c695e053e5a0$var$property(path) {
    return $b862d544b65a608a$exports(path) ? $7a7ff6914d162e21$exports($c4981d9c30ac136e$exports(path)) : $280ff13719d2f033$exports(path);
}
$6f16c695e053e5a0$exports = $6f16c695e053e5a0$var$property;


/**
 * The base implementation of `_.iteratee`.
 *
 * @private
 * @param {*} [value=_.identity] The value to convert to an iteratee.
 * @returns {Function} Returns the iteratee.
 */ function $9cb616549df16e8a$var$baseIteratee(value) {
    // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
    // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
    if (typeof value == "function") return value;
    if (value == null) return $a961fb58d7bfedbf$exports;
    if (typeof value == "object") return $730d1b366662da48$exports(value) ? $b73195e081a09370$exports(value[0], value[1]) : $0eb3b1f0b77150e5$exports(value);
    return $6f16c695e053e5a0$exports(value);
}
$9cb616549df16e8a$exports = $9cb616549df16e8a$var$baseIteratee;


var $0fdae29d8726b4f1$exports = {};
var $8dcac6ca15a0f645$exports = {};

var $c6130166bc2dc766$exports = {};

/**
 * Creates a `baseEach` or `baseEachRight` function.
 *
 * @private
 * @param {Function} eachFunc The function to iterate over a collection.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */ function $c6130166bc2dc766$var$createBaseEach(eachFunc, fromRight) {
    return function(collection, iteratee) {
        if (collection == null) return collection;
        if (!$681032a0f414881e$exports(collection)) return eachFunc(collection, iteratee);
        var length = collection.length, index = fromRight ? length : -1, iterable = Object(collection);
        while(fromRight ? index-- : ++index < length){
            if (iteratee(iterable[index], index, iterable) === false) break;
        }
        return collection;
    };
}
$c6130166bc2dc766$exports = $c6130166bc2dc766$var$createBaseEach;


/**
 * The base implementation of `_.forEach` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array|Object} Returns `collection`.
 */ var $8dcac6ca15a0f645$var$baseEach = $c6130166bc2dc766$exports($9a2fd95e744f294f$exports);
$8dcac6ca15a0f645$exports = $8dcac6ca15a0f645$var$baseEach;



/**
 * The base implementation of `_.map` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */ function $0fdae29d8726b4f1$var$baseMap(collection, iteratee) {
    var index = -1, result = $681032a0f414881e$exports(collection) ? Array(collection.length) : [];
    $8dcac6ca15a0f645$exports(collection, function(value, key, collection) {
        result[++index] = iteratee(value, key, collection);
    });
    return result;
}
$0fdae29d8726b4f1$exports = $0fdae29d8726b4f1$var$baseMap;



/**
 * Creates an array of values by running each element in `collection` thru
 * `iteratee`. The iteratee is invoked with three arguments:
 * (value, index|key, collection).
 *
 * Many lodash methods are guarded to work as iteratees for methods like
 * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
 *
 * The guarded methods are:
 * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
 * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
 * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
 * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 * @example
 *
 * function square(n) {
 *   return n * n;
 * }
 *
 * _.map([4, 8], square);
 * // => [16, 64]
 *
 * _.map({ 'a': 4, 'b': 8 }, square);
 * // => [16, 64] (iteration order is not guaranteed)
 *
 * var users = [
 *   { 'user': 'barney' },
 *   { 'user': 'fred' }
 * ];
 *
 * // The `_.property` iteratee shorthand.
 * _.map(users, 'user');
 * // => ['barney', 'fred']
 */ function $55eb60374a0d0544$var$map(collection, iteratee) {
    var func = $730d1b366662da48$exports(collection) ? $2984cf9c242fe53a$exports : $0fdae29d8726b4f1$exports;
    return func(collection, $9cb616549df16e8a$exports(iteratee, 3));
}
$55eb60374a0d0544$exports = $55eb60374a0d0544$var$map;


var $788957905510a05a$var$_map3 = $788957905510a05a$var$_interopRequireDefault($55eb60374a0d0544$exports);
function $788957905510a05a$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $788957905510a05a$var$flattenNames = $788957905510a05a$exports.flattenNames = function flattenNames() {
    var things = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    var names = [];
    (0, $788957905510a05a$var$_map3.default)(things, function(thing) {
        if (Array.isArray(thing)) flattenNames(thing).map(function(name) {
            return names.push(name);
        });
        else if ((0, $788957905510a05a$var$_isPlainObject3.default)(thing)) (0, $788957905510a05a$var$_forOwn3.default)(thing, function(value, key) {
            value === true && names.push(key);
            names.push(key + "-" + value);
        });
        else if ((0, $788957905510a05a$var$_isString3.default)(thing)) names.push(thing);
    });
    return names;
};
$788957905510a05a$exports.default = $788957905510a05a$var$flattenNames;


var $1e6d325bf7ec7d53$var$_flattenNames2 = $1e6d325bf7ec7d53$var$_interopRequireDefault($788957905510a05a$exports);
var $1383c021b781a06b$exports = {};
"use strict";
Object.defineProperty($1383c021b781a06b$exports, "__esModule", {
    value: true
});
$1383c021b781a06b$exports.mergeClasses = undefined;

var $1383c021b781a06b$var$_forOwn3 = $1383c021b781a06b$var$_interopRequireDefault($7d0496aa3b6c593c$exports);
var $c02d91ca210759b6$exports = {};
var $b088d9492958b86a$exports = {};

var $f9d15d04601708d3$exports = {};
/**
 * A specialized version of `_.forEach` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns `array`.
 */ function $f9d15d04601708d3$var$arrayEach(array, iteratee) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        if (iteratee(array[index], index, array) === false) break;
    }
    return array;
}
$f9d15d04601708d3$exports = $f9d15d04601708d3$var$arrayEach;


var $a6884b19e70e77c0$exports = {};
var $7ac8911b657c3928$exports = {};
var $63ec4d08c2de17a4$exports = {};

var $63ec4d08c2de17a4$var$defineProperty = function() {
    try {
        var func = $507cda0e3d4397c2$exports(Object, "defineProperty");
        func({}, "", {});
        return func;
    } catch (e) {}
}();
$63ec4d08c2de17a4$exports = $63ec4d08c2de17a4$var$defineProperty;


/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function $7ac8911b657c3928$var$baseAssignValue(object, key, value) {
    if (key == "__proto__" && $63ec4d08c2de17a4$exports) $63ec4d08c2de17a4$exports(object, key, {
        "configurable": true,
        "enumerable": true,
        "value": value,
        "writable": true
    });
    else object[key] = value;
}
$7ac8911b657c3928$exports = $7ac8911b657c3928$var$baseAssignValue;



/** Used for built-in method references. */ var $a6884b19e70e77c0$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $a6884b19e70e77c0$var$hasOwnProperty = $a6884b19e70e77c0$var$objectProto.hasOwnProperty;
/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function $a6884b19e70e77c0$var$assignValue(object, key, value) {
    var objValue = object[key];
    if (!($a6884b19e70e77c0$var$hasOwnProperty.call(object, key) && $d3b5784bbbc55641$exports(objValue, value)) || value === undefined && !(key in object)) $7ac8911b657c3928$exports(object, key, value);
}
$a6884b19e70e77c0$exports = $a6884b19e70e77c0$var$assignValue;


var $6f969ca017a22d9b$exports = {};
var $a23bb041d0b5f68f$exports = {};


/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */ function $a23bb041d0b5f68f$var$copyObject(source, props, object, customizer) {
    var isNew = !object;
    object || (object = {});
    var index = -1, length = props.length;
    while(++index < length){
        var key = props[index];
        var newValue = customizer ? customizer(object[key], source[key], key, object, source) : undefined;
        if (newValue === undefined) newValue = source[key];
        if (isNew) $7ac8911b657c3928$exports(object, key, newValue);
        else $a6884b19e70e77c0$exports(object, key, newValue);
    }
    return object;
}
$a23bb041d0b5f68f$exports = $a23bb041d0b5f68f$var$copyObject;



/**
 * The base implementation of `_.assign` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */ function $6f969ca017a22d9b$var$baseAssign(object, source) {
    return object && $a23bb041d0b5f68f$exports(source, $cf65da43818f725f$exports(source), object);
}
$6f969ca017a22d9b$exports = $6f969ca017a22d9b$var$baseAssign;


var $13bd911a1f53b96a$exports = {};

var $d888293c43fbc328$exports = {};

var $522e1a52d1a3638a$exports = {};


var $6bff007b7d933e2e$exports = {};
/**
 * This function is like
 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * except that it includes inherited enumerable properties.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function $6bff007b7d933e2e$var$nativeKeysIn(object) {
    var result = [];
    if (object != null) for(var key in Object(object))result.push(key);
    return result;
}
$6bff007b7d933e2e$exports = $6bff007b7d933e2e$var$nativeKeysIn;


/** Used for built-in method references. */ var $522e1a52d1a3638a$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $522e1a52d1a3638a$var$hasOwnProperty = $522e1a52d1a3638a$var$objectProto.hasOwnProperty;
/**
 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function $522e1a52d1a3638a$var$baseKeysIn(object) {
    if (!$e4bea0192758232a$exports(object)) return $6bff007b7d933e2e$exports(object);
    var isProto = $966736caab723063$exports(object), result = [];
    for(var key in object)if (!(key == "constructor" && (isProto || !$522e1a52d1a3638a$var$hasOwnProperty.call(object, key)))) result.push(key);
    return result;
}
$522e1a52d1a3638a$exports = $522e1a52d1a3638a$var$baseKeysIn;



/**
 * Creates an array of the own and inherited enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keysIn(new Foo);
 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
 */ function $d888293c43fbc328$var$keysIn(object) {
    return $681032a0f414881e$exports(object) ? $39a283488d173d50$exports(object, true) : $522e1a52d1a3638a$exports(object);
}
$d888293c43fbc328$exports = $d888293c43fbc328$var$keysIn;


/**
 * The base implementation of `_.assignIn` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */ function $13bd911a1f53b96a$var$baseAssignIn(object, source) {
    return object && $a23bb041d0b5f68f$exports(source, $d888293c43fbc328$exports(source), object);
}
$13bd911a1f53b96a$exports = $13bd911a1f53b96a$var$baseAssignIn;



var $1JdxE = parcelRequire("1JdxE");
var $cfc6a1002f96b26a$exports = {};
/**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */ function $cfc6a1002f96b26a$var$copyArray(source, array) {
    var index = -1, length = source.length;
    array || (array = Array(length));
    while(++index < length)array[index] = source[index];
    return array;
}
$cfc6a1002f96b26a$exports = $cfc6a1002f96b26a$var$copyArray;


var $d658f1b20078c07d$exports = {};


/**
 * Copies own symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */ function $d658f1b20078c07d$var$copySymbols(source, object) {
    return $a23bb041d0b5f68f$exports(source, $6f0ffdf0419abb03$exports(source), object);
}
$d658f1b20078c07d$exports = $d658f1b20078c07d$var$copySymbols;


var $bb68243eb7bc9e48$exports = {};

var $289116ad5890dd05$exports = {};




/* Built-in method references for those with the same name as other `lodash` methods. */ var $289116ad5890dd05$var$nativeGetSymbols = Object.getOwnPropertySymbols;
/**
 * Creates an array of the own and inherited enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */ var $289116ad5890dd05$var$getSymbolsIn = !$289116ad5890dd05$var$nativeGetSymbols ? $be064eff5dc241cd$exports : function(object) {
    var result = [];
    while(object){
        $ce3fbf26bf92081d$exports(result, $6f0ffdf0419abb03$exports(object));
        object = $8d6291835bea81d5$exports(object);
    }
    return result;
};
$289116ad5890dd05$exports = $289116ad5890dd05$var$getSymbolsIn;


/**
 * Copies own and inherited symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */ function $bb68243eb7bc9e48$var$copySymbolsIn(source, object) {
    return $a23bb041d0b5f68f$exports(source, $289116ad5890dd05$exports(source), object);
}
$bb68243eb7bc9e48$exports = $bb68243eb7bc9e48$var$copySymbolsIn;



var $7e4aedae7e99bfb4$exports = {};



/**
 * Creates an array of own and inherited enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */ function $7e4aedae7e99bfb4$var$getAllKeysIn(object) {
    return $8ff55e87051475e3$exports(object, $d888293c43fbc328$exports, $289116ad5890dd05$exports);
}
$7e4aedae7e99bfb4$exports = $7e4aedae7e99bfb4$var$getAllKeysIn;



var $3c407a992bffea0b$exports = {};
/** Used for built-in method references. */ var $3c407a992bffea0b$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $3c407a992bffea0b$var$hasOwnProperty = $3c407a992bffea0b$var$objectProto.hasOwnProperty;
/**
 * Initializes an array clone.
 *
 * @private
 * @param {Array} array The array to clone.
 * @returns {Array} Returns the initialized clone.
 */ function $3c407a992bffea0b$var$initCloneArray(array) {
    var length = array.length, result = new array.constructor(length);
    // Add properties assigned by `RegExp#exec`.
    if (length && typeof array[0] == "string" && $3c407a992bffea0b$var$hasOwnProperty.call(array, "index")) {
        result.index = array.index;
        result.input = array.input;
    }
    return result;
}
$3c407a992bffea0b$exports = $3c407a992bffea0b$var$initCloneArray;


var $bfa02819da0ae67a$exports = {};
var $1ceca6a14d74df11$exports = {};

/**
 * Creates a clone of `arrayBuffer`.
 *
 * @private
 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
 * @returns {ArrayBuffer} Returns the cloned array buffer.
 */ function $1ceca6a14d74df11$var$cloneArrayBuffer(arrayBuffer) {
    var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
    new $f3f1e8c287dc271d$exports(result).set(new $f3f1e8c287dc271d$exports(arrayBuffer));
    return result;
}
$1ceca6a14d74df11$exports = $1ceca6a14d74df11$var$cloneArrayBuffer;


var $f3aa4e5d07c75f7b$exports = {};

/**
 * Creates a clone of `dataView`.
 *
 * @private
 * @param {Object} dataView The data view to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned data view.
 */ function $f3aa4e5d07c75f7b$var$cloneDataView(dataView, isDeep) {
    var buffer = isDeep ? $1ceca6a14d74df11$exports(dataView.buffer) : dataView.buffer;
    return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
}
$f3aa4e5d07c75f7b$exports = $f3aa4e5d07c75f7b$var$cloneDataView;


var $2bb0c87ab765dc20$exports = {};
/** Used to match `RegExp` flags from their coerced string values. */ var $2bb0c87ab765dc20$var$reFlags = /\w*$/;
/**
 * Creates a clone of `regexp`.
 *
 * @private
 * @param {Object} regexp The regexp to clone.
 * @returns {Object} Returns the cloned regexp.
 */ function $2bb0c87ab765dc20$var$cloneRegExp(regexp) {
    var result = new regexp.constructor(regexp.source, $2bb0c87ab765dc20$var$reFlags.exec(regexp));
    result.lastIndex = regexp.lastIndex;
    return result;
}
$2bb0c87ab765dc20$exports = $2bb0c87ab765dc20$var$cloneRegExp;


var $7cbf93bc2396f53c$exports = {};

/** Used to convert symbols to primitives and strings. */ var $7cbf93bc2396f53c$var$symbolProto = $2388da93fa592950$exports ? $2388da93fa592950$exports.prototype : undefined, $7cbf93bc2396f53c$var$symbolValueOf = $7cbf93bc2396f53c$var$symbolProto ? $7cbf93bc2396f53c$var$symbolProto.valueOf : undefined;
/**
 * Creates a clone of the `symbol` object.
 *
 * @private
 * @param {Object} symbol The symbol object to clone.
 * @returns {Object} Returns the cloned symbol object.
 */ function $7cbf93bc2396f53c$var$cloneSymbol(symbol) {
    return $7cbf93bc2396f53c$var$symbolValueOf ? Object($7cbf93bc2396f53c$var$symbolValueOf.call(symbol)) : {};
}
$7cbf93bc2396f53c$exports = $7cbf93bc2396f53c$var$cloneSymbol;


var $b33ea0f77925bbf8$exports = {};

/**
 * Creates a clone of `typedArray`.
 *
 * @private
 * @param {Object} typedArray The typed array to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned typed array.
 */ function $b33ea0f77925bbf8$var$cloneTypedArray(typedArray, isDeep) {
    var buffer = isDeep ? $1ceca6a14d74df11$exports(typedArray.buffer) : typedArray.buffer;
    return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
}
$b33ea0f77925bbf8$exports = $b33ea0f77925bbf8$var$cloneTypedArray;


/** `Object#toString` result references. */ var $bfa02819da0ae67a$var$boolTag = "[object Boolean]", $bfa02819da0ae67a$var$dateTag = "[object Date]", $bfa02819da0ae67a$var$mapTag = "[object Map]", $bfa02819da0ae67a$var$numberTag = "[object Number]", $bfa02819da0ae67a$var$regexpTag = "[object RegExp]", $bfa02819da0ae67a$var$setTag = "[object Set]", $bfa02819da0ae67a$var$stringTag = "[object String]", $bfa02819da0ae67a$var$symbolTag = "[object Symbol]";
var $bfa02819da0ae67a$var$arrayBufferTag = "[object ArrayBuffer]", $bfa02819da0ae67a$var$dataViewTag = "[object DataView]", $bfa02819da0ae67a$var$float32Tag = "[object Float32Array]", $bfa02819da0ae67a$var$float64Tag = "[object Float64Array]", $bfa02819da0ae67a$var$int8Tag = "[object Int8Array]", $bfa02819da0ae67a$var$int16Tag = "[object Int16Array]", $bfa02819da0ae67a$var$int32Tag = "[object Int32Array]", $bfa02819da0ae67a$var$uint8Tag = "[object Uint8Array]", $bfa02819da0ae67a$var$uint8ClampedTag = "[object Uint8ClampedArray]", $bfa02819da0ae67a$var$uint16Tag = "[object Uint16Array]", $bfa02819da0ae67a$var$uint32Tag = "[object Uint32Array]";
/**
 * Initializes an object clone based on its `toStringTag`.
 *
 * **Note:** This function only supports cloning values with tags of
 * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
 *
 * @private
 * @param {Object} object The object to clone.
 * @param {string} tag The `toStringTag` of the object to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the initialized clone.
 */ function $bfa02819da0ae67a$var$initCloneByTag(object, tag, isDeep) {
    var Ctor = object.constructor;
    switch(tag){
        case $bfa02819da0ae67a$var$arrayBufferTag:
            return $1ceca6a14d74df11$exports(object);
        case $bfa02819da0ae67a$var$boolTag:
        case $bfa02819da0ae67a$var$dateTag:
            return new Ctor(+object);
        case $bfa02819da0ae67a$var$dataViewTag:
            return $f3aa4e5d07c75f7b$exports(object, isDeep);
        case $bfa02819da0ae67a$var$float32Tag:
        case $bfa02819da0ae67a$var$float64Tag:
        case $bfa02819da0ae67a$var$int8Tag:
        case $bfa02819da0ae67a$var$int16Tag:
        case $bfa02819da0ae67a$var$int32Tag:
        case $bfa02819da0ae67a$var$uint8Tag:
        case $bfa02819da0ae67a$var$uint8ClampedTag:
        case $bfa02819da0ae67a$var$uint16Tag:
        case $bfa02819da0ae67a$var$uint32Tag:
            return $b33ea0f77925bbf8$exports(object, isDeep);
        case $bfa02819da0ae67a$var$mapTag:
            return new Ctor;
        case $bfa02819da0ae67a$var$numberTag:
        case $bfa02819da0ae67a$var$stringTag:
            return new Ctor(object);
        case $bfa02819da0ae67a$var$regexpTag:
            return $2bb0c87ab765dc20$exports(object);
        case $bfa02819da0ae67a$var$setTag:
            return new Ctor;
        case $bfa02819da0ae67a$var$symbolTag:
            return $7cbf93bc2396f53c$exports(object);
    }
}
$bfa02819da0ae67a$exports = $bfa02819da0ae67a$var$initCloneByTag;


var $93495b169a910c59$exports = {};
var $e8202c3f19fe331f$exports = {};

/** Built-in value references. */ var $e8202c3f19fe331f$var$objectCreate = Object.create;
/**
 * The base implementation of `_.create` without support for assigning
 * properties to the created object.
 *
 * @private
 * @param {Object} proto The object to inherit from.
 * @returns {Object} Returns the new object.
 */ var $e8202c3f19fe331f$var$baseCreate = function() {
    function object() {}
    return function(proto) {
        if (!$e4bea0192758232a$exports(proto)) return {};
        if ($e8202c3f19fe331f$var$objectCreate) return $e8202c3f19fe331f$var$objectCreate(proto);
        object.prototype = proto;
        var result = new object;
        object.prototype = undefined;
        return result;
    };
}();
$e8202c3f19fe331f$exports = $e8202c3f19fe331f$var$baseCreate;




/**
 * Initializes an object clone.
 *
 * @private
 * @param {Object} object The object to clone.
 * @returns {Object} Returns the initialized clone.
 */ function $93495b169a910c59$var$initCloneObject(object) {
    return typeof object.constructor == "function" && !$966736caab723063$exports(object) ? $e8202c3f19fe331f$exports($8d6291835bea81d5$exports(object)) : {};
}
$93495b169a910c59$exports = $93495b169a910c59$var$initCloneObject;




var $8TKuU = parcelRequire("8TKuU");
var $7527b8b830b84dcf$exports = {};
var $e469c606f18738f4$exports = {};


/** `Object#toString` result references. */ var $e469c606f18738f4$var$mapTag = "[object Map]";
/**
 * The base implementation of `_.isMap` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 */ function $e469c606f18738f4$var$baseIsMap(value) {
    return $4a94b44c4940d5a5$exports(value) && $79d963e32ece07b6$exports(value) == $e469c606f18738f4$var$mapTag;
}
$e469c606f18738f4$exports = $e469c606f18738f4$var$baseIsMap;




var $1mm29 = parcelRequire("1mm29");
/* Node.js helper references. */ var $7527b8b830b84dcf$var$nodeIsMap = $1mm29 && $1mm29.isMap;
/**
 * Checks if `value` is classified as a `Map` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 * @example
 *
 * _.isMap(new Map);
 * // => true
 *
 * _.isMap(new WeakMap);
 * // => false
 */ var $7527b8b830b84dcf$var$isMap = $7527b8b830b84dcf$var$nodeIsMap ? $82313b399bb9d3fb$exports($7527b8b830b84dcf$var$nodeIsMap) : $e469c606f18738f4$exports;
$7527b8b830b84dcf$exports = $7527b8b830b84dcf$var$isMap;



var $aa0f046793e32950$exports = {};
var $53b7cfab3dee8703$exports = {};


/** `Object#toString` result references. */ var $53b7cfab3dee8703$var$setTag = "[object Set]";
/**
 * The base implementation of `_.isSet` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 */ function $53b7cfab3dee8703$var$baseIsSet(value) {
    return $4a94b44c4940d5a5$exports(value) && $79d963e32ece07b6$exports(value) == $53b7cfab3dee8703$var$setTag;
}
$53b7cfab3dee8703$exports = $53b7cfab3dee8703$var$baseIsSet;




var $1mm29 = parcelRequire("1mm29");
/* Node.js helper references. */ var $aa0f046793e32950$var$nodeIsSet = $1mm29 && $1mm29.isSet;
/**
 * Checks if `value` is classified as a `Set` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 * @example
 *
 * _.isSet(new Set);
 * // => true
 *
 * _.isSet(new WeakSet);
 * // => false
 */ var $aa0f046793e32950$var$isSet = $aa0f046793e32950$var$nodeIsSet ? $82313b399bb9d3fb$exports($aa0f046793e32950$var$nodeIsSet) : $53b7cfab3dee8703$exports;
$aa0f046793e32950$exports = $aa0f046793e32950$var$isSet;




/** Used to compose bitmasks for cloning. */ var $b088d9492958b86a$var$CLONE_DEEP_FLAG = 1, $b088d9492958b86a$var$CLONE_FLAT_FLAG = 2, $b088d9492958b86a$var$CLONE_SYMBOLS_FLAG = 4;
/** `Object#toString` result references. */ var $b088d9492958b86a$var$argsTag = "[object Arguments]", $b088d9492958b86a$var$arrayTag = "[object Array]", $b088d9492958b86a$var$boolTag = "[object Boolean]", $b088d9492958b86a$var$dateTag = "[object Date]", $b088d9492958b86a$var$errorTag = "[object Error]", $b088d9492958b86a$var$funcTag = "[object Function]", $b088d9492958b86a$var$genTag = "[object GeneratorFunction]", $b088d9492958b86a$var$mapTag = "[object Map]", $b088d9492958b86a$var$numberTag = "[object Number]", $b088d9492958b86a$var$objectTag = "[object Object]", $b088d9492958b86a$var$regexpTag = "[object RegExp]", $b088d9492958b86a$var$setTag = "[object Set]", $b088d9492958b86a$var$stringTag = "[object String]", $b088d9492958b86a$var$symbolTag = "[object Symbol]", $b088d9492958b86a$var$weakMapTag = "[object WeakMap]";
var $b088d9492958b86a$var$arrayBufferTag = "[object ArrayBuffer]", $b088d9492958b86a$var$dataViewTag = "[object DataView]", $b088d9492958b86a$var$float32Tag = "[object Float32Array]", $b088d9492958b86a$var$float64Tag = "[object Float64Array]", $b088d9492958b86a$var$int8Tag = "[object Int8Array]", $b088d9492958b86a$var$int16Tag = "[object Int16Array]", $b088d9492958b86a$var$int32Tag = "[object Int32Array]", $b088d9492958b86a$var$uint8Tag = "[object Uint8Array]", $b088d9492958b86a$var$uint8ClampedTag = "[object Uint8ClampedArray]", $b088d9492958b86a$var$uint16Tag = "[object Uint16Array]", $b088d9492958b86a$var$uint32Tag = "[object Uint32Array]";
/** Used to identify `toStringTag` values supported by `_.clone`. */ var $b088d9492958b86a$var$cloneableTags = {};
$b088d9492958b86a$var$cloneableTags[$b088d9492958b86a$var$argsTag] = $b088d9492958b86a$var$cloneableTags[$b088d9492958b86a$var$arrayTag] = $b088d9492958b86a$var$cloneableTags[$b088d9492958b86a$var$arrayBufferTag] = $b088d9492958b86a$var$cloneableTags[$b088d9492958b86a$var$dataViewTag] = $b088d9492958b86a$var$cloneableTags[$b088d9492958b86a$var$boolTag] = $b088d9492958b86a$var$cloneableTags[$b088d9492958b86a$var$dateTag] = $b088d9492958b86a$var$cloneableTags[$b088d9492958b86a$var$float32Tag] = $b088d9492958b86a$var$cloneableTags[$b088d9492958b86a$var$float64Tag] = $b088d9492958b86a$var$cloneableTags[$b088d9492958b86a$var$int8Tag] = $b088d9492958b86a$var$cloneableTags[$b088d9492958b86a$var$int16Tag] = $b088d9492958b86a$var$cloneableTags[$b088d9492958b86a$var$int32Tag] = $b088d9492958b86a$var$cloneableTags[$b088d9492958b86a$var$mapTag] = $b088d9492958b86a$var$cloneableTags[$b088d9492958b86a$var$numberTag] = $b088d9492958b86a$var$cloneableTags[$b088d9492958b86a$var$objectTag] = $b088d9492958b86a$var$cloneableTags[$b088d9492958b86a$var$regexpTag] = $b088d9492958b86a$var$cloneableTags[$b088d9492958b86a$var$setTag] = $b088d9492958b86a$var$cloneableTags[$b088d9492958b86a$var$stringTag] = $b088d9492958b86a$var$cloneableTags[$b088d9492958b86a$var$symbolTag] = $b088d9492958b86a$var$cloneableTags[$b088d9492958b86a$var$uint8Tag] = $b088d9492958b86a$var$cloneableTags[$b088d9492958b86a$var$uint8ClampedTag] = $b088d9492958b86a$var$cloneableTags[$b088d9492958b86a$var$uint16Tag] = $b088d9492958b86a$var$cloneableTags[$b088d9492958b86a$var$uint32Tag] = true;
$b088d9492958b86a$var$cloneableTags[$b088d9492958b86a$var$errorTag] = $b088d9492958b86a$var$cloneableTags[$b088d9492958b86a$var$funcTag] = $b088d9492958b86a$var$cloneableTags[$b088d9492958b86a$var$weakMapTag] = false;
/**
 * The base implementation of `_.clone` and `_.cloneDeep` which tracks
 * traversed objects.
 *
 * @private
 * @param {*} value The value to clone.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Deep clone
 *  2 - Flatten inherited properties
 *  4 - Clone symbols
 * @param {Function} [customizer] The function to customize cloning.
 * @param {string} [key] The key of `value`.
 * @param {Object} [object] The parent object of `value`.
 * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
 * @returns {*} Returns the cloned value.
 */ function $b088d9492958b86a$var$baseClone(value, bitmask, customizer, key, object, stack) {
    var result, isDeep = bitmask & $b088d9492958b86a$var$CLONE_DEEP_FLAG, isFlat = bitmask & $b088d9492958b86a$var$CLONE_FLAT_FLAG, isFull = bitmask & $b088d9492958b86a$var$CLONE_SYMBOLS_FLAG;
    if (customizer) result = object ? customizer(value, key, object, stack) : customizer(value);
    if (result !== undefined) return result;
    if (!$e4bea0192758232a$exports(value)) return value;
    var isArr = $730d1b366662da48$exports(value);
    if (isArr) {
        result = $3c407a992bffea0b$exports(value);
        if (!isDeep) return $cfc6a1002f96b26a$exports(value, result);
    } else {
        var tag = $79d963e32ece07b6$exports(value), isFunc = tag == $b088d9492958b86a$var$funcTag || tag == $b088d9492958b86a$var$genTag;
        if ($8TKuU(value)) return $1JdxE(value, isDeep);
        if (tag == $b088d9492958b86a$var$objectTag || tag == $b088d9492958b86a$var$argsTag || isFunc && !object) {
            result = isFlat || isFunc ? {} : $93495b169a910c59$exports(value);
            if (!isDeep) return isFlat ? $bb68243eb7bc9e48$exports(value, $13bd911a1f53b96a$exports(result, value)) : $d658f1b20078c07d$exports(value, $6f969ca017a22d9b$exports(result, value));
        } else {
            if (!$b088d9492958b86a$var$cloneableTags[tag]) return object ? value : {};
            result = $bfa02819da0ae67a$exports(value, tag, isDeep);
        }
    }
    // Check for circular references and return its corresponding clone.
    stack || (stack = new $419ba895b4ae45e6$exports);
    var stacked = stack.get(value);
    if (stacked) return stacked;
    stack.set(value, result);
    if ($aa0f046793e32950$exports(value)) value.forEach(function(subValue) {
        result.add($b088d9492958b86a$var$baseClone(subValue, bitmask, customizer, subValue, value, stack));
    });
    else if ($7527b8b830b84dcf$exports(value)) value.forEach(function(subValue, key) {
        result.set(key, $b088d9492958b86a$var$baseClone(subValue, bitmask, customizer, key, value, stack));
    });
    var keysFunc = isFull ? isFlat ? $7e4aedae7e99bfb4$exports : $3087323db8ebdb4a$exports : isFlat ? $d888293c43fbc328$exports : $cf65da43818f725f$exports;
    var props = isArr ? undefined : keysFunc(value);
    $f9d15d04601708d3$exports(props || value, function(subValue, key) {
        if (props) {
            key = subValue;
            subValue = value[key];
        }
        // Recursively populate clone (susceptible to call stack limits).
        $a6884b19e70e77c0$exports(result, key, $b088d9492958b86a$var$baseClone(subValue, bitmask, customizer, key, value, stack));
    });
    return result;
}
$b088d9492958b86a$exports = $b088d9492958b86a$var$baseClone;


/** Used to compose bitmasks for cloning. */ var $c02d91ca210759b6$var$CLONE_DEEP_FLAG = 1, $c02d91ca210759b6$var$CLONE_SYMBOLS_FLAG = 4;
/**
 * This method is like `_.clone` except that it recursively clones `value`.
 *
 * @static
 * @memberOf _
 * @since 1.0.0
 * @category Lang
 * @param {*} value The value to recursively clone.
 * @returns {*} Returns the deep cloned value.
 * @see _.clone
 * @example
 *
 * var objects = [{ 'a': 1 }, { 'b': 2 }];
 *
 * var deep = _.cloneDeep(objects);
 * console.log(deep[0] === objects[0]);
 * // => false
 */ function $c02d91ca210759b6$var$cloneDeep(value) {
    return $b088d9492958b86a$exports(value, $c02d91ca210759b6$var$CLONE_DEEP_FLAG | $c02d91ca210759b6$var$CLONE_SYMBOLS_FLAG);
}
$c02d91ca210759b6$exports = $c02d91ca210759b6$var$cloneDeep;


var $1383c021b781a06b$var$_cloneDeep3 = $1383c021b781a06b$var$_interopRequireDefault($c02d91ca210759b6$exports);
var $1383c021b781a06b$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
function $1383c021b781a06b$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $1383c021b781a06b$var$mergeClasses = $1383c021b781a06b$exports.mergeClasses = function mergeClasses(classes) {
    var activeNames = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
    var styles = classes.default && (0, $1383c021b781a06b$var$_cloneDeep3.default)(classes.default) || {};
    activeNames.map(function(name) {
        var toMerge = classes[name];
        if (toMerge) (0, $1383c021b781a06b$var$_forOwn3.default)(toMerge, function(value, key) {
            if (!styles[key]) styles[key] = {};
            styles[key] = $1383c021b781a06b$var$_extends({}, styles[key], toMerge[key]);
        });
        return name;
    });
    return styles;
};
$1383c021b781a06b$exports.default = $1383c021b781a06b$var$mergeClasses;


var $1e6d325bf7ec7d53$var$_mergeClasses2 = $1e6d325bf7ec7d53$var$_interopRequireDefault($1383c021b781a06b$exports);
var $41f39bded5fde2fc$exports = {};
"use strict";
Object.defineProperty($41f39bded5fde2fc$exports, "__esModule", {
    value: true
});
$41f39bded5fde2fc$exports.autoprefix = undefined;

var $41f39bded5fde2fc$var$_forOwn3 = $41f39bded5fde2fc$var$_interopRequireDefault($7d0496aa3b6c593c$exports);
var $41f39bded5fde2fc$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
function $41f39bded5fde2fc$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $41f39bded5fde2fc$var$transforms = {
    borderRadius: function borderRadius(value) {
        return {
            msBorderRadius: value,
            MozBorderRadius: value,
            OBorderRadius: value,
            WebkitBorderRadius: value,
            borderRadius: value
        };
    },
    boxShadow: function boxShadow(value) {
        return {
            msBoxShadow: value,
            MozBoxShadow: value,
            OBoxShadow: value,
            WebkitBoxShadow: value,
            boxShadow: value
        };
    },
    userSelect: function userSelect(value) {
        return {
            WebkitTouchCallout: value,
            KhtmlUserSelect: value,
            MozUserSelect: value,
            msUserSelect: value,
            WebkitUserSelect: value,
            userSelect: value
        };
    },
    flex: function flex(value) {
        return {
            WebkitBoxFlex: value,
            MozBoxFlex: value,
            WebkitFlex: value,
            msFlex: value,
            flex: value
        };
    },
    flexBasis: function flexBasis(value) {
        return {
            WebkitFlexBasis: value,
            flexBasis: value
        };
    },
    justifyContent: function justifyContent(value) {
        return {
            WebkitJustifyContent: value,
            justifyContent: value
        };
    },
    transition: function transition(value) {
        return {
            msTransition: value,
            MozTransition: value,
            OTransition: value,
            WebkitTransition: value,
            transition: value
        };
    },
    transform: function transform(value) {
        return {
            msTransform: value,
            MozTransform: value,
            OTransform: value,
            WebkitTransform: value,
            transform: value
        };
    },
    absolute: function absolute(value) {
        var direction = value && value.split(" ");
        return {
            position: "absolute",
            top: direction && direction[0],
            right: direction && direction[1],
            bottom: direction && direction[2],
            left: direction && direction[3]
        };
    },
    extend: function extend(name, otherElementStyles) {
        var otherStyle = otherElementStyles[name];
        if (otherStyle) return otherStyle;
        return {
            "extend": name
        };
    }
};
var $41f39bded5fde2fc$var$autoprefix = $41f39bded5fde2fc$exports.autoprefix = function autoprefix(elements) {
    var prefixed = {};
    (0, $41f39bded5fde2fc$var$_forOwn3.default)(elements, function(styles, element) {
        var expanded = {};
        (0, $41f39bded5fde2fc$var$_forOwn3.default)(styles, function(value, key) {
            var transform = $41f39bded5fde2fc$var$transforms[key];
            if (transform) expanded = $41f39bded5fde2fc$var$_extends({}, expanded, transform(value));
            else expanded[key] = value;
        });
        prefixed[element] = expanded;
    });
    return prefixed;
};
$41f39bded5fde2fc$exports.default = $41f39bded5fde2fc$var$autoprefix;


var $1e6d325bf7ec7d53$var$_autoprefix2 = $1e6d325bf7ec7d53$var$_interopRequireDefault($41f39bded5fde2fc$exports);
var $1d593ea4d372f30e$exports = {};
"use strict";
Object.defineProperty($1d593ea4d372f30e$exports, "__esModule", {
    value: true
});
$1d593ea4d372f30e$exports.hover = undefined;
var $1d593ea4d372f30e$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};

var $bh6RR = parcelRequire("bh6RR");
var $1d593ea4d372f30e$var$_react2 = $1d593ea4d372f30e$var$_interopRequireDefault($bh6RR);
function $1d593ea4d372f30e$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $1d593ea4d372f30e$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $1d593ea4d372f30e$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $1d593ea4d372f30e$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var $1d593ea4d372f30e$var$hover = $1d593ea4d372f30e$exports.hover = function hover(Component) {
    var Span = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "span";
    return function(_React$Component) {
        $1d593ea4d372f30e$var$_inherits(Hover, _React$Component);
        function Hover() {
            var _ref;
            var _temp, _this, _ret;
            $1d593ea4d372f30e$var$_classCallCheck(this, Hover);
            for(var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            return _ret = (_temp = (_this = $1d593ea4d372f30e$var$_possibleConstructorReturn(this, (_ref = Hover.__proto__ || Object.getPrototypeOf(Hover)).call.apply(_ref, [
                this
            ].concat(args))), _this), _this.state = {
                hover: false
            }, _this.handleMouseOver = function() {
                return _this.setState({
                    hover: true
                });
            }, _this.handleMouseOut = function() {
                return _this.setState({
                    hover: false
                });
            }, _this.render = function() {
                return $1d593ea4d372f30e$var$_react2.default.createElement(Span, {
                    onMouseOver: _this.handleMouseOver,
                    onMouseOut: _this.handleMouseOut
                }, $1d593ea4d372f30e$var$_react2.default.createElement(Component, $1d593ea4d372f30e$var$_extends({}, _this.props, _this.state)));
            }, _temp), $1d593ea4d372f30e$var$_possibleConstructorReturn(_this, _ret);
        }
        return Hover;
    }($1d593ea4d372f30e$var$_react2.default.Component);
};
$1d593ea4d372f30e$exports.default = $1d593ea4d372f30e$var$hover;


var $1e6d325bf7ec7d53$var$_hover3 = $1e6d325bf7ec7d53$var$_interopRequireDefault($1d593ea4d372f30e$exports);
var $e6efbc78c695a836$exports = {};
"use strict";
Object.defineProperty($e6efbc78c695a836$exports, "__esModule", {
    value: true
});
$e6efbc78c695a836$exports.active = undefined;
var $e6efbc78c695a836$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};

var $bh6RR = parcelRequire("bh6RR");
var $e6efbc78c695a836$var$_react2 = $e6efbc78c695a836$var$_interopRequireDefault($bh6RR);
function $e6efbc78c695a836$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $e6efbc78c695a836$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $e6efbc78c695a836$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $e6efbc78c695a836$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var $e6efbc78c695a836$var$active = $e6efbc78c695a836$exports.active = function active(Component) {
    var Span = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "span";
    return function(_React$Component) {
        $e6efbc78c695a836$var$_inherits(Active, _React$Component);
        function Active() {
            var _ref;
            var _temp, _this, _ret;
            $e6efbc78c695a836$var$_classCallCheck(this, Active);
            for(var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            return _ret = (_temp = (_this = $e6efbc78c695a836$var$_possibleConstructorReturn(this, (_ref = Active.__proto__ || Object.getPrototypeOf(Active)).call.apply(_ref, [
                this
            ].concat(args))), _this), _this.state = {
                active: false
            }, _this.handleMouseDown = function() {
                return _this.setState({
                    active: true
                });
            }, _this.handleMouseUp = function() {
                return _this.setState({
                    active: false
                });
            }, _this.render = function() {
                return $e6efbc78c695a836$var$_react2.default.createElement(Span, {
                    onMouseDown: _this.handleMouseDown,
                    onMouseUp: _this.handleMouseUp
                }, $e6efbc78c695a836$var$_react2.default.createElement(Component, $e6efbc78c695a836$var$_extends({}, _this.props, _this.state)));
            }, _temp), $e6efbc78c695a836$var$_possibleConstructorReturn(_this, _ret);
        }
        return Active;
    }($e6efbc78c695a836$var$_react2.default.Component);
};
$e6efbc78c695a836$exports.default = $e6efbc78c695a836$var$active;


var $1e6d325bf7ec7d53$var$_active2 = $1e6d325bf7ec7d53$var$_interopRequireDefault($e6efbc78c695a836$exports);
var $ab8e89fa50f42720$exports = {};
"use strict";
Object.defineProperty($ab8e89fa50f42720$exports, "__esModule", {
    value: true
});
var $ab8e89fa50f42720$var$loopable = function loopable(i, length) {
    var props = {};
    var setProp = function setProp(name) {
        var value = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
        props[name] = value;
    };
    i === 0 && setProp("first-child");
    i === length - 1 && setProp("last-child");
    (i === 0 || i % 2 === 0) && setProp("even");
    Math.abs(i % 2) === 1 && setProp("odd");
    setProp("nth-child", i);
    return props;
};
$ab8e89fa50f42720$exports.default = $ab8e89fa50f42720$var$loopable;


var $1e6d325bf7ec7d53$var$_loop3 = $1e6d325bf7ec7d53$var$_interopRequireDefault($ab8e89fa50f42720$exports);
function $1e6d325bf7ec7d53$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
$1e6d325bf7ec7d53$exports.hover = $1e6d325bf7ec7d53$var$_hover3.default;
$1e6d325bf7ec7d53$exports.handleHover = $1e6d325bf7ec7d53$var$_hover3.default;
$1e6d325bf7ec7d53$exports.handleActive = $1e6d325bf7ec7d53$var$_active2.default;
$1e6d325bf7ec7d53$exports.loop = $1e6d325bf7ec7d53$var$_loop3.default;
var $1e6d325bf7ec7d53$var$ReactCSS = $1e6d325bf7ec7d53$exports.ReactCSS = function ReactCSS(classes) {
    for(var _len = arguments.length, activations = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)activations[_key - 1] = arguments[_key];
    var activeNames = (0, $1e6d325bf7ec7d53$var$_flattenNames2.default)(activations);
    var merged = (0, $1e6d325bf7ec7d53$var$_mergeClasses2.default)(classes, activeNames);
    return (0, $1e6d325bf7ec7d53$var$_autoprefix2.default)(merged);
};
$1e6d325bf7ec7d53$exports.default = $1e6d325bf7ec7d53$var$ReactCSS;



var $bh6RR = parcelRequire("bh6RR");

var $fd5a261083d81c9c$export$a056a977bf6a9a3c = function calculateChange(e, hsl, direction, initialA, container) {
    var containerWidth = container.clientWidth;
    var containerHeight = container.clientHeight;
    var x = typeof e.pageX === "number" ? e.pageX : e.touches[0].pageX;
    var y = typeof e.pageY === "number" ? e.pageY : e.touches[0].pageY;
    var left = x - (container.getBoundingClientRect().left + window.pageXOffset);
    var top = y - (container.getBoundingClientRect().top + window.pageYOffset);
    if (direction === "vertical") {
        var a = void 0;
        if (top < 0) a = 0;
        else if (top > containerHeight) a = 1;
        else a = Math.round(top * 100 / containerHeight) / 100;
        if (hsl.a !== a) return {
            h: hsl.h,
            s: hsl.s,
            l: hsl.l,
            a: a,
            source: "rgb"
        };
    } else {
        var _a = void 0;
        if (left < 0) _a = 0;
        else if (left > containerWidth) _a = 1;
        else _a = Math.round(left * 100 / containerWidth) / 100;
        if (initialA !== _a) return {
            h: hsl.h,
            s: hsl.s,
            l: hsl.l,
            a: _a,
            source: "rgb"
        };
    }
    return null;
};



var $bh6RR = parcelRequire("bh6RR");

var $b6b1edef535cf07f$var$checkboardCache = {};
var $b6b1edef535cf07f$export$b3890eb0ae9dca99 = function render(c1, c2, size, serverCanvas) {
    if (typeof document === "undefined" && !serverCanvas) return null;
    var canvas = serverCanvas ? new serverCanvas() : document.createElement("canvas");
    canvas.width = size * 2;
    canvas.height = size * 2;
    var ctx = canvas.getContext("2d");
    if (!ctx) return null;
     // If no context can be found, return early.
    ctx.fillStyle = c1;
    ctx.fillRect(0, 0, canvas.width, canvas.height);
    ctx.fillStyle = c2;
    ctx.fillRect(0, 0, size, size);
    ctx.translate(size, size);
    ctx.fillRect(0, 0, size, size);
    return canvas.toDataURL();
};
var $b6b1edef535cf07f$export$3988ae62b71be9a3 = function get(c1, c2, size, serverCanvas) {
    var key = c1 + "-" + c2 + "-" + size + (serverCanvas ? "-server" : "");
    if ($b6b1edef535cf07f$var$checkboardCache[key]) return $b6b1edef535cf07f$var$checkboardCache[key];
    var checkboard = $b6b1edef535cf07f$export$b3890eb0ae9dca99(c1, c2, size, serverCanvas);
    $b6b1edef535cf07f$var$checkboardCache[key] = checkboard;
    return checkboard;
};


var $fb5ac1bea6cb3f9f$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var $fb5ac1bea6cb3f9f$export$457ff74489f64b4a = function Checkboard(_ref) {
    var white = _ref.white, grey = _ref.grey, size = _ref.size, renderers = _ref.renderers, borderRadius = _ref.borderRadius, boxShadow = _ref.boxShadow, children = _ref.children;
    var styles = (0, (/*@__PURE__*/$parcel$interopDefault($1e6d325bf7ec7d53$exports)))({
        "default": {
            grid: {
                borderRadius: borderRadius,
                boxShadow: boxShadow,
                absolute: "0px 0px 0px 0px",
                background: "url(" + $b6b1edef535cf07f$export$3988ae62b71be9a3(white, grey, size, renderers.canvas) + ") center left"
            }
        }
    });
    return (0, $bh6RR.isValidElement)(children) ? (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).cloneElement(children, $fb5ac1bea6cb3f9f$var$_extends({}, children.props, {
        style: $fb5ac1bea6cb3f9f$var$_extends({}, children.props.style, styles.grid)
    })) : (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("div", {
        style: styles.grid
    });
};
$fb5ac1bea6cb3f9f$export$457ff74489f64b4a.defaultProps = {
    size: 8,
    white: "transparent",
    grey: "rgba(0,0,0,.08)",
    renderers: {}
};
var $fb5ac1bea6cb3f9f$export$2e2bcd8739ae039 = $fb5ac1bea6cb3f9f$export$457ff74489f64b4a;


var $2b76dc783bc34760$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var $2b76dc783bc34760$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();
function $2b76dc783bc34760$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $2b76dc783bc34760$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $2b76dc783bc34760$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var $2b76dc783bc34760$export$b3d0ceb706f8af43 = function(_ref) {
    $2b76dc783bc34760$var$_inherits(Alpha, _ref);
    function Alpha() {
        var _ref2;
        var _temp, _this, _ret;
        $2b76dc783bc34760$var$_classCallCheck(this, Alpha);
        for(var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return _ret = (_temp = (_this = $2b76dc783bc34760$var$_possibleConstructorReturn(this, (_ref2 = Alpha.__proto__ || Object.getPrototypeOf(Alpha)).call.apply(_ref2, [
            this
        ].concat(args))), _this), _this.handleChange = function(e) {
            var change = $fd5a261083d81c9c$export$a056a977bf6a9a3c(e, _this.props.hsl, _this.props.direction, _this.props.a, _this.container);
            change && typeof _this.props.onChange === "function" && _this.props.onChange(change, e);
        }, _this.handleMouseDown = function(e) {
            _this.handleChange(e);
            window.addEventListener("mousemove", _this.handleChange);
            window.addEventListener("mouseup", _this.handleMouseUp);
        }, _this.handleMouseUp = function() {
            _this.unbindEventListeners();
        }, _this.unbindEventListeners = function() {
            window.removeEventListener("mousemove", _this.handleChange);
            window.removeEventListener("mouseup", _this.handleMouseUp);
        }, _temp), $2b76dc783bc34760$var$_possibleConstructorReturn(_this, _ret);
    }
    $2b76dc783bc34760$var$_createClass(Alpha, [
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                this.unbindEventListeners();
            }
        },
        {
            key: "render",
            value: function render() {
                var _this2 = this;
                var rgb = this.props.rgb;
                var styles = (0, (/*@__PURE__*/$parcel$interopDefault($1e6d325bf7ec7d53$exports)))({
                    "default": {
                        alpha: {
                            absolute: "0px 0px 0px 0px",
                            borderRadius: this.props.radius
                        },
                        checkboard: {
                            absolute: "0px 0px 0px 0px",
                            overflow: "hidden",
                            borderRadius: this.props.radius
                        },
                        gradient: {
                            absolute: "0px 0px 0px 0px",
                            background: "linear-gradient(to right, rgba(" + rgb.r + "," + rgb.g + "," + rgb.b + ", 0) 0%,\n           rgba(" + rgb.r + "," + rgb.g + "," + rgb.b + ", 1) 100%)",
                            boxShadow: this.props.shadow,
                            borderRadius: this.props.radius
                        },
                        container: {
                            position: "relative",
                            height: "100%",
                            margin: "0 3px"
                        },
                        pointer: {
                            position: "absolute",
                            left: rgb.a * 100 + "%"
                        },
                        slider: {
                            width: "4px",
                            borderRadius: "1px",
                            height: "8px",
                            boxShadow: "0 0 2px rgba(0, 0, 0, .6)",
                            background: "#fff",
                            marginTop: "1px",
                            transform: "translateX(-2px)"
                        }
                    },
                    "vertical": {
                        gradient: {
                            background: "linear-gradient(to bottom, rgba(" + rgb.r + "," + rgb.g + "," + rgb.b + ", 0) 0%,\n           rgba(" + rgb.r + "," + rgb.g + "," + rgb.b + ", 1) 100%)"
                        },
                        pointer: {
                            left: 0,
                            top: rgb.a * 100 + "%"
                        }
                    },
                    "overwrite": $2b76dc783bc34760$var$_extends({}, this.props.style)
                }, {
                    vertical: this.props.direction === "vertical",
                    overwrite: true
                });
                return (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("div", {
                    style: styles.alpha
                }, (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("div", {
                    style: styles.checkboard
                }, (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $fb5ac1bea6cb3f9f$export$2e2bcd8739ae039), {
                    renderers: this.props.renderers
                })), (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("div", {
                    style: styles.gradient
                }), (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("div", {
                    style: styles.container,
                    ref: function ref(container) {
                        return _this2.container = container;
                    },
                    onMouseDown: this.handleMouseDown,
                    onTouchMove: this.handleChange,
                    onTouchStart: this.handleChange
                }, (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("div", {
                    style: styles.pointer
                }, this.props.pointer ? (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement(this.props.pointer, this.props) : (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("div", {
                    style: styles.slider
                }))));
            }
        }
    ]);
    return Alpha;
}((0, $bh6RR.PureComponent) || (0, $bh6RR.Component));
var $2b76dc783bc34760$export$2e2bcd8739ae039 = $2b76dc783bc34760$export$b3d0ceb706f8af43;




var $bh6RR = parcelRequire("bh6RR");

var $daa8013ee334d911$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();
function $daa8013ee334d911$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $daa8013ee334d911$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $daa8013ee334d911$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $daa8013ee334d911$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var $daa8013ee334d911$var$DEFAULT_ARROW_OFFSET = 1;
var $daa8013ee334d911$var$UP_KEY_CODE = 38;
var $daa8013ee334d911$var$DOWN_KEY_CODE = 40;
var $daa8013ee334d911$var$VALID_KEY_CODES = [
    $daa8013ee334d911$var$UP_KEY_CODE,
    $daa8013ee334d911$var$DOWN_KEY_CODE
];
var $daa8013ee334d911$var$isValidKeyCode = function isValidKeyCode(keyCode) {
    return $daa8013ee334d911$var$VALID_KEY_CODES.indexOf(keyCode) > -1;
};
var $daa8013ee334d911$var$getNumberValue = function getNumberValue(value) {
    return Number(String(value).replace(/%/g, ""));
};
var $daa8013ee334d911$var$idCounter = 1;
var $daa8013ee334d911$export$bfb3cbb78d3c298 = function(_ref) {
    $daa8013ee334d911$var$_inherits(EditableInput, _ref);
    function EditableInput(props) {
        $daa8013ee334d911$var$_classCallCheck(this, EditableInput);
        var _this = $daa8013ee334d911$var$_possibleConstructorReturn(this, (EditableInput.__proto__ || Object.getPrototypeOf(EditableInput)).call(this));
        _this.handleBlur = function() {
            if (_this.state.blurValue) _this.setState({
                value: _this.state.blurValue,
                blurValue: null
            });
        };
        _this.handleChange = function(e) {
            _this.setUpdatedValue(e.target.value, e);
        };
        _this.handleKeyDown = function(e) {
            // In case `e.target.value` is a percentage remove the `%` character
            // and update accordingly with a percentage
            // https://github.com/casesandberg/react-color/issues/383
            var value = $daa8013ee334d911$var$getNumberValue(e.target.value);
            if (!isNaN(value) && $daa8013ee334d911$var$isValidKeyCode(e.keyCode)) {
                var offset = _this.getArrowOffset();
                var updatedValue = e.keyCode === $daa8013ee334d911$var$UP_KEY_CODE ? value + offset : value - offset;
                _this.setUpdatedValue(updatedValue, e);
            }
        };
        _this.handleDrag = function(e) {
            if (_this.props.dragLabel) {
                var newValue = Math.round(_this.props.value + e.movementX);
                if (newValue >= 0 && newValue <= _this.props.dragMax) _this.props.onChange && _this.props.onChange(_this.getValueObjectWithLabel(newValue), e);
            }
        };
        _this.handleMouseDown = function(e) {
            if (_this.props.dragLabel) {
                e.preventDefault();
                _this.handleDrag(e);
                window.addEventListener("mousemove", _this.handleDrag);
                window.addEventListener("mouseup", _this.handleMouseUp);
            }
        };
        _this.handleMouseUp = function() {
            _this.unbindEventListeners();
        };
        _this.unbindEventListeners = function() {
            window.removeEventListener("mousemove", _this.handleDrag);
            window.removeEventListener("mouseup", _this.handleMouseUp);
        };
        _this.state = {
            value: String(props.value).toUpperCase(),
            blurValue: String(props.value).toUpperCase()
        };
        _this.inputId = "rc-editable-input-" + $daa8013ee334d911$var$idCounter++;
        return _this;
    }
    $daa8013ee334d911$var$_createClass(EditableInput, [
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate(prevProps, prevState) {
                if (this.props.value !== this.state.value && (prevProps.value !== this.props.value || prevState.value !== this.state.value)) {
                    if (this.input === document.activeElement) this.setState({
                        blurValue: String(this.props.value).toUpperCase()
                    });
                    else this.setState({
                        value: String(this.props.value).toUpperCase(),
                        blurValue: !this.state.blurValue && String(this.props.value).toUpperCase()
                    });
                }
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                this.unbindEventListeners();
            }
        },
        {
            key: "getValueObjectWithLabel",
            value: function getValueObjectWithLabel(value) {
                return $daa8013ee334d911$var$_defineProperty({}, this.props.label, value);
            }
        },
        {
            key: "getArrowOffset",
            value: function getArrowOffset() {
                return this.props.arrowOffset || $daa8013ee334d911$var$DEFAULT_ARROW_OFFSET;
            }
        },
        {
            key: "setUpdatedValue",
            value: function setUpdatedValue(value, e) {
                var onChangeValue = this.props.label ? this.getValueObjectWithLabel(value) : value;
                this.props.onChange && this.props.onChange(onChangeValue, e);
                this.setState({
                    value: value
                });
            }
        },
        {
            key: "render",
            value: function render() {
                var _this2 = this;
                var styles = (0, (/*@__PURE__*/$parcel$interopDefault($1e6d325bf7ec7d53$exports)))({
                    "default": {
                        wrap: {
                            position: "relative"
                        }
                    },
                    "user-override": {
                        wrap: this.props.style && this.props.style.wrap ? this.props.style.wrap : {},
                        input: this.props.style && this.props.style.input ? this.props.style.input : {},
                        label: this.props.style && this.props.style.label ? this.props.style.label : {}
                    },
                    "dragLabel-true": {
                        label: {
                            cursor: "ew-resize"
                        }
                    }
                }, {
                    "user-override": true
                }, this.props);
                return (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("div", {
                    style: styles.wrap
                }, (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("input", {
                    id: this.inputId,
                    style: styles.input,
                    ref: function ref(input) {
                        return _this2.input = input;
                    },
                    value: this.state.value,
                    onKeyDown: this.handleKeyDown,
                    onChange: this.handleChange,
                    onBlur: this.handleBlur,
                    placeholder: this.props.placeholder,
                    spellCheck: "false"
                }), this.props.label && !this.props.hideLabel ? (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("label", {
                    htmlFor: this.inputId,
                    style: styles.label,
                    onMouseDown: this.handleMouseDown
                }, this.props.label) : null);
            }
        }
    ]);
    return EditableInput;
}((0, $bh6RR.PureComponent) || (0, $bh6RR.Component));
var $daa8013ee334d911$export$2e2bcd8739ae039 = $daa8013ee334d911$export$bfb3cbb78d3c298;



var $bh6RR = parcelRequire("bh6RR");

var $e82e1c5ac58c80df$export$a056a977bf6a9a3c = function calculateChange(e, direction, hsl, container) {
    var containerWidth = container.clientWidth;
    var containerHeight = container.clientHeight;
    var x = typeof e.pageX === "number" ? e.pageX : e.touches[0].pageX;
    var y = typeof e.pageY === "number" ? e.pageY : e.touches[0].pageY;
    var left = x - (container.getBoundingClientRect().left + window.pageXOffset);
    var top = y - (container.getBoundingClientRect().top + window.pageYOffset);
    if (direction === "vertical") {
        var h = void 0;
        if (top < 0) h = 359;
        else if (top > containerHeight) h = 0;
        else {
            var percent = -(top * 100 / containerHeight) + 100;
            h = 360 * percent / 100;
        }
        if (hsl.h !== h) return {
            h: h,
            s: hsl.s,
            l: hsl.l,
            a: hsl.a,
            source: "hsl"
        };
    } else {
        var _h = void 0;
        if (left < 0) _h = 0;
        else if (left > containerWidth) _h = 359;
        else {
            var _percent = left * 100 / containerWidth;
            _h = 360 * _percent / 100;
        }
        if (hsl.h !== _h) return {
            h: _h,
            s: hsl.s,
            l: hsl.l,
            a: hsl.a,
            source: "hsl"
        };
    }
    return null;
};


var $27b1902952abffb6$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();
function $27b1902952abffb6$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $27b1902952abffb6$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $27b1902952abffb6$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var $27b1902952abffb6$export$3e22a96a58989a47 = function(_ref) {
    $27b1902952abffb6$var$_inherits(Hue, _ref);
    function Hue() {
        var _ref2;
        var _temp, _this, _ret;
        $27b1902952abffb6$var$_classCallCheck(this, Hue);
        for(var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return _ret = (_temp = (_this = $27b1902952abffb6$var$_possibleConstructorReturn(this, (_ref2 = Hue.__proto__ || Object.getPrototypeOf(Hue)).call.apply(_ref2, [
            this
        ].concat(args))), _this), _this.handleChange = function(e) {
            var change = $e82e1c5ac58c80df$export$a056a977bf6a9a3c(e, _this.props.direction, _this.props.hsl, _this.container);
            change && typeof _this.props.onChange === "function" && _this.props.onChange(change, e);
        }, _this.handleMouseDown = function(e) {
            _this.handleChange(e);
            window.addEventListener("mousemove", _this.handleChange);
            window.addEventListener("mouseup", _this.handleMouseUp);
        }, _this.handleMouseUp = function() {
            _this.unbindEventListeners();
        }, _temp), $27b1902952abffb6$var$_possibleConstructorReturn(_this, _ret);
    }
    $27b1902952abffb6$var$_createClass(Hue, [
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                this.unbindEventListeners();
            }
        },
        {
            key: "unbindEventListeners",
            value: function unbindEventListeners() {
                window.removeEventListener("mousemove", this.handleChange);
                window.removeEventListener("mouseup", this.handleMouseUp);
            }
        },
        {
            key: "render",
            value: function render() {
                var _this2 = this;
                var _props$direction = this.props.direction, direction = _props$direction === undefined ? "horizontal" : _props$direction;
                var styles = (0, (/*@__PURE__*/$parcel$interopDefault($1e6d325bf7ec7d53$exports)))({
                    "default": {
                        hue: {
                            absolute: "0px 0px 0px 0px",
                            borderRadius: this.props.radius,
                            boxShadow: this.props.shadow
                        },
                        container: {
                            padding: "0 2px",
                            position: "relative",
                            height: "100%",
                            borderRadius: this.props.radius
                        },
                        pointer: {
                            position: "absolute",
                            left: this.props.hsl.h * 100 / 360 + "%"
                        },
                        slider: {
                            marginTop: "1px",
                            width: "4px",
                            borderRadius: "1px",
                            height: "8px",
                            boxShadow: "0 0 2px rgba(0, 0, 0, .6)",
                            background: "#fff",
                            transform: "translateX(-2px)"
                        }
                    },
                    "vertical": {
                        pointer: {
                            left: "0px",
                            top: -(this.props.hsl.h * 100 / 360) + 100 + "%"
                        }
                    }
                }, {
                    vertical: direction === "vertical"
                });
                return (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("div", {
                    style: styles.hue
                }, (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("div", {
                    className: "hue-" + direction,
                    style: styles.container,
                    ref: function ref(container) {
                        return _this2.container = container;
                    },
                    onMouseDown: this.handleMouseDown,
                    onTouchMove: this.handleChange,
                    onTouchStart: this.handleChange
                }, (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("style", null, "\n            .hue-horizontal {\n              background: linear-gradient(to right, #f00 0%, #ff0 17%, #0f0\n                33%, #0ff 50%, #00f 67%, #f0f 83%, #f00 100%);\n              background: -webkit-linear-gradient(to right, #f00 0%, #ff0\n                17%, #0f0 33%, #0ff 50%, #00f 67%, #f0f 83%, #f00 100%);\n            }\n\n            .hue-vertical {\n              background: linear-gradient(to top, #f00 0%, #ff0 17%, #0f0 33%,\n                #0ff 50%, #00f 67%, #f0f 83%, #f00 100%);\n              background: -webkit-linear-gradient(to top, #f00 0%, #ff0 17%,\n                #0f0 33%, #0ff 50%, #00f 67%, #f0f 83%, #f00 100%);\n            }\n          "), (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("div", {
                    style: styles.pointer
                }, this.props.pointer ? (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement(this.props.pointer, this.props) : (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("div", {
                    style: styles.slider
                }))));
            }
        }
    ]);
    return Hue;
}((0, $bh6RR.PureComponent) || (0, $bh6RR.Component));
var $27b1902952abffb6$export$2e2bcd8739ae039 = $27b1902952abffb6$export$3e22a96a58989a47;



var $bh6RR = parcelRequire("bh6RR");
var $aa40b802dd2fccfc$exports = {};
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $aa40b802dd2fccfc$var$ReactIs, $aa40b802dd2fccfc$var$throwOnDirectAccess;

// By explicitly using `prop-types` you are opting into new production behavior.
// http://fb.me/prop-types-in-prod
$aa40b802dd2fccfc$exports = (parcelRequire("2tbKl"))();



/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */ function $5901b603012da595$var$listCacheClear() {
    this.__data__ = [];
    this.size = 0;
}
var $5901b603012da595$export$2e2bcd8739ae039 = $5901b603012da595$var$listCacheClear;


/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */ function $24a50494b56303fa$var$eq(value, other) {
    return value === other || value !== value && other !== other;
}
var $24a50494b56303fa$export$2e2bcd8739ae039 = $24a50494b56303fa$var$eq;


/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $ece069ed9bfec089$var$assocIndexOf(array, key) {
    var length = array.length;
    while(length--){
        if ((0, $24a50494b56303fa$export$2e2bcd8739ae039)(array[length][0], key)) return length;
    }
    return -1;
}
var $ece069ed9bfec089$export$2e2bcd8739ae039 = $ece069ed9bfec089$var$assocIndexOf;


/** Used for built-in method references. */ var $720e237c00c1b03f$var$arrayProto = Array.prototype;
/** Built-in value references. */ var $720e237c00c1b03f$var$splice = $720e237c00c1b03f$var$arrayProto.splice;
/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $720e237c00c1b03f$var$listCacheDelete(key) {
    var data = this.__data__, index = (0, $ece069ed9bfec089$export$2e2bcd8739ae039)(data, key);
    if (index < 0) return false;
    var lastIndex = data.length - 1;
    if (index == lastIndex) data.pop();
    else $720e237c00c1b03f$var$splice.call(data, index, 1);
    --this.size;
    return true;
}
var $720e237c00c1b03f$export$2e2bcd8739ae039 = $720e237c00c1b03f$var$listCacheDelete;



/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $6f14bcc7444cf375$var$listCacheGet(key) {
    var data = this.__data__, index = (0, $ece069ed9bfec089$export$2e2bcd8739ae039)(data, key);
    return index < 0 ? undefined : data[index][1];
}
var $6f14bcc7444cf375$export$2e2bcd8739ae039 = $6f14bcc7444cf375$var$listCacheGet;



/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $9695617145d17fca$var$listCacheHas(key) {
    return (0, $ece069ed9bfec089$export$2e2bcd8739ae039)(this.__data__, key) > -1;
}
var $9695617145d17fca$export$2e2bcd8739ae039 = $9695617145d17fca$var$listCacheHas;



/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */ function $3631eb7360761131$var$listCacheSet(key, value) {
    var data = this.__data__, index = (0, $ece069ed9bfec089$export$2e2bcd8739ae039)(data, key);
    if (index < 0) {
        ++this.size;
        data.push([
            key,
            value
        ]);
    } else data[index][1] = value;
    return this;
}
var $3631eb7360761131$export$2e2bcd8739ae039 = $3631eb7360761131$var$listCacheSet;


/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $0ec6b653931e70c0$var$ListCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `ListCache`.
$0ec6b653931e70c0$var$ListCache.prototype.clear = (0, $5901b603012da595$export$2e2bcd8739ae039);
$0ec6b653931e70c0$var$ListCache.prototype["delete"] = (0, $720e237c00c1b03f$export$2e2bcd8739ae039);
$0ec6b653931e70c0$var$ListCache.prototype.get = (0, $6f14bcc7444cf375$export$2e2bcd8739ae039);
$0ec6b653931e70c0$var$ListCache.prototype.has = (0, $9695617145d17fca$export$2e2bcd8739ae039);
$0ec6b653931e70c0$var$ListCache.prototype.set = (0, $3631eb7360761131$export$2e2bcd8739ae039);
var $0ec6b653931e70c0$export$2e2bcd8739ae039 = $0ec6b653931e70c0$var$ListCache;



/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */ function $a8da9f1850418a97$var$stackClear() {
    this.__data__ = new (0, $0ec6b653931e70c0$export$2e2bcd8739ae039);
    this.size = 0;
}
var $a8da9f1850418a97$export$2e2bcd8739ae039 = $a8da9f1850418a97$var$stackClear;


/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $fc3063294f0985d4$var$stackDelete(key) {
    var data = this.__data__, result = data["delete"](key);
    this.size = data.size;
    return result;
}
var $fc3063294f0985d4$export$2e2bcd8739ae039 = $fc3063294f0985d4$var$stackDelete;


/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $5d20cedfc2997602$var$stackGet(key) {
    return this.__data__.get(key);
}
var $5d20cedfc2997602$export$2e2bcd8739ae039 = $5d20cedfc2997602$var$stackGet;


/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $507326fb3b1993fe$var$stackHas(key) {
    return this.__data__.has(key);
}
var $507326fb3b1993fe$export$2e2bcd8739ae039 = $507326fb3b1993fe$var$stackHas;




var $6AhZS = parcelRequire("6AhZS");
/** Built-in value references. */ var $0fa9a02f9756f657$var$Symbol = (0, $6AhZS.default).Symbol;
var $0fa9a02f9756f657$export$2e2bcd8739ae039 = $0fa9a02f9756f657$var$Symbol;



/** Used for built-in method references. */ var $b8bd64751e10f60b$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $b8bd64751e10f60b$var$hasOwnProperty = $b8bd64751e10f60b$var$objectProto.hasOwnProperty;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $b8bd64751e10f60b$var$nativeObjectToString = $b8bd64751e10f60b$var$objectProto.toString;
/** Built-in value references. */ var $b8bd64751e10f60b$var$symToStringTag = (0, $0fa9a02f9756f657$export$2e2bcd8739ae039) ? (0, $0fa9a02f9756f657$export$2e2bcd8739ae039).toStringTag : undefined;
/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */ function $b8bd64751e10f60b$var$getRawTag(value) {
    var isOwn = $b8bd64751e10f60b$var$hasOwnProperty.call(value, $b8bd64751e10f60b$var$symToStringTag), tag = value[$b8bd64751e10f60b$var$symToStringTag];
    try {
        value[$b8bd64751e10f60b$var$symToStringTag] = undefined;
        var unmasked = true;
    } catch (e) {}
    var result = $b8bd64751e10f60b$var$nativeObjectToString.call(value);
    if (unmasked) {
        if (isOwn) value[$b8bd64751e10f60b$var$symToStringTag] = tag;
        else delete value[$b8bd64751e10f60b$var$symToStringTag];
    }
    return result;
}
var $b8bd64751e10f60b$export$2e2bcd8739ae039 = $b8bd64751e10f60b$var$getRawTag;


/** Used for built-in method references. */ var $1403d80719b32f26$var$objectProto = Object.prototype;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $1403d80719b32f26$var$nativeObjectToString = $1403d80719b32f26$var$objectProto.toString;
/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */ function $1403d80719b32f26$var$objectToString(value) {
    return $1403d80719b32f26$var$nativeObjectToString.call(value);
}
var $1403d80719b32f26$export$2e2bcd8739ae039 = $1403d80719b32f26$var$objectToString;


/** `Object#toString` result references. */ var $622194736393697a$var$nullTag = "[object Null]", $622194736393697a$var$undefinedTag = "[object Undefined]";
/** Built-in value references. */ var $622194736393697a$var$symToStringTag = (0, $0fa9a02f9756f657$export$2e2bcd8739ae039) ? (0, $0fa9a02f9756f657$export$2e2bcd8739ae039).toStringTag : undefined;
/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ function $622194736393697a$var$baseGetTag(value) {
    if (value == null) return value === undefined ? $622194736393697a$var$undefinedTag : $622194736393697a$var$nullTag;
    return $622194736393697a$var$symToStringTag && $622194736393697a$var$symToStringTag in Object(value) ? (0, $b8bd64751e10f60b$export$2e2bcd8739ae039)(value) : (0, $1403d80719b32f26$export$2e2bcd8739ae039)(value);
}
var $622194736393697a$export$2e2bcd8739ae039 = $622194736393697a$var$baseGetTag;


/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function $1146963f863a9576$var$isObject(value) {
    var type = typeof value;
    return value != null && (type == "object" || type == "function");
}
var $1146963f863a9576$export$2e2bcd8739ae039 = $1146963f863a9576$var$isObject;


/** `Object#toString` result references. */ var $8e0b215b91f51a44$var$asyncTag = "[object AsyncFunction]", $8e0b215b91f51a44$var$funcTag = "[object Function]", $8e0b215b91f51a44$var$genTag = "[object GeneratorFunction]", $8e0b215b91f51a44$var$proxyTag = "[object Proxy]";
/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */ function $8e0b215b91f51a44$var$isFunction(value) {
    if (!(0, $1146963f863a9576$export$2e2bcd8739ae039)(value)) return false;
    // The use of `Object#toString` avoids issues with the `typeof` operator
    // in Safari 9 which returns 'object' for typed arrays and other constructors.
    var tag = (0, $622194736393697a$export$2e2bcd8739ae039)(value);
    return tag == $8e0b215b91f51a44$var$funcTag || tag == $8e0b215b91f51a44$var$genTag || tag == $8e0b215b91f51a44$var$asyncTag || tag == $8e0b215b91f51a44$var$proxyTag;
}
var $8e0b215b91f51a44$export$2e2bcd8739ae039 = $8e0b215b91f51a44$var$isFunction;



var $6AhZS = parcelRequire("6AhZS");
/** Used to detect overreaching core-js shims. */ var $2d5e2fcca347b6df$var$coreJsData = (0, $6AhZS.default)["__core-js_shared__"];
var $2d5e2fcca347b6df$export$2e2bcd8739ae039 = $2d5e2fcca347b6df$var$coreJsData;


/** Used to detect methods masquerading as native. */ var $8b8d1a3043bd607a$var$maskSrcKey = function() {
    var uid = /[^.]+$/.exec((0, $2d5e2fcca347b6df$export$2e2bcd8739ae039) && (0, $2d5e2fcca347b6df$export$2e2bcd8739ae039).keys && (0, $2d5e2fcca347b6df$export$2e2bcd8739ae039).keys.IE_PROTO || "");
    return uid ? "Symbol(src)_1." + uid : "";
}();
/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */ function $8b8d1a3043bd607a$var$isMasked(func) {
    return !!$8b8d1a3043bd607a$var$maskSrcKey && $8b8d1a3043bd607a$var$maskSrcKey in func;
}
var $8b8d1a3043bd607a$export$2e2bcd8739ae039 = $8b8d1a3043bd607a$var$isMasked;



/** Used for built-in method references. */ var $8c7a3bd26fa17d1b$var$funcProto = Function.prototype;
/** Used to resolve the decompiled source of functions. */ var $8c7a3bd26fa17d1b$var$funcToString = $8c7a3bd26fa17d1b$var$funcProto.toString;
/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */ function $8c7a3bd26fa17d1b$var$toSource(func) {
    if (func != null) {
        try {
            return $8c7a3bd26fa17d1b$var$funcToString.call(func);
        } catch (e) {}
        try {
            return func + "";
        } catch (e) {}
    }
    return "";
}
var $8c7a3bd26fa17d1b$export$2e2bcd8739ae039 = $8c7a3bd26fa17d1b$var$toSource;


/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */ var $2f417a79d5f65102$var$reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
/** Used to detect host constructors (Safari). */ var $2f417a79d5f65102$var$reIsHostCtor = /^\[object .+?Constructor\]$/;
/** Used for built-in method references. */ var $2f417a79d5f65102$var$funcProto = Function.prototype, $2f417a79d5f65102$var$objectProto = Object.prototype;
/** Used to resolve the decompiled source of functions. */ var $2f417a79d5f65102$var$funcToString = $2f417a79d5f65102$var$funcProto.toString;
/** Used to check objects for own properties. */ var $2f417a79d5f65102$var$hasOwnProperty = $2f417a79d5f65102$var$objectProto.hasOwnProperty;
/** Used to detect if a method is native. */ var $2f417a79d5f65102$var$reIsNative = RegExp("^" + $2f417a79d5f65102$var$funcToString.call($2f417a79d5f65102$var$hasOwnProperty).replace($2f417a79d5f65102$var$reRegExpChar, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$");
/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */ function $2f417a79d5f65102$var$baseIsNative(value) {
    if (!(0, $1146963f863a9576$export$2e2bcd8739ae039)(value) || (0, $8b8d1a3043bd607a$export$2e2bcd8739ae039)(value)) return false;
    var pattern = (0, $8e0b215b91f51a44$export$2e2bcd8739ae039)(value) ? $2f417a79d5f65102$var$reIsNative : $2f417a79d5f65102$var$reIsHostCtor;
    return pattern.test((0, $8c7a3bd26fa17d1b$export$2e2bcd8739ae039)(value));
}
var $2f417a79d5f65102$export$2e2bcd8739ae039 = $2f417a79d5f65102$var$baseIsNative;


/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */ function $e3e8350a409520b9$var$getValue(object, key) {
    return object == null ? undefined : object[key];
}
var $e3e8350a409520b9$export$2e2bcd8739ae039 = $e3e8350a409520b9$var$getValue;


/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */ function $e5e36fcd795e94d7$var$getNative(object, key) {
    var value = (0, $e3e8350a409520b9$export$2e2bcd8739ae039)(object, key);
    return (0, $2f417a79d5f65102$export$2e2bcd8739ae039)(value) ? value : undefined;
}
var $e5e36fcd795e94d7$export$2e2bcd8739ae039 = $e5e36fcd795e94d7$var$getNative;



var $6AhZS = parcelRequire("6AhZS");
/* Built-in method references that are verified to be native. */ var $277a51f176965052$var$Map = (0, $e5e36fcd795e94d7$export$2e2bcd8739ae039)((0, $6AhZS.default), "Map");
var $277a51f176965052$export$2e2bcd8739ae039 = $277a51f176965052$var$Map;



/* Built-in method references that are verified to be native. */ var $b31b9ce951d45915$var$nativeCreate = (0, $e5e36fcd795e94d7$export$2e2bcd8739ae039)(Object, "create");
var $b31b9ce951d45915$export$2e2bcd8739ae039 = $b31b9ce951d45915$var$nativeCreate;


/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */ function $be9a5cf3e915f078$var$hashClear() {
    this.__data__ = (0, $b31b9ce951d45915$export$2e2bcd8739ae039) ? (0, $b31b9ce951d45915$export$2e2bcd8739ae039)(null) : {};
    this.size = 0;
}
var $be9a5cf3e915f078$export$2e2bcd8739ae039 = $be9a5cf3e915f078$var$hashClear;


/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $df71e396e71e4535$var$hashDelete(key) {
    var result = this.has(key) && delete this.__data__[key];
    this.size -= result ? 1 : 0;
    return result;
}
var $df71e396e71e4535$export$2e2bcd8739ae039 = $df71e396e71e4535$var$hashDelete;



/** Used to stand-in for `undefined` hash values. */ var $1bdeb3b3b807852d$var$HASH_UNDEFINED = "__lodash_hash_undefined__";
/** Used for built-in method references. */ var $1bdeb3b3b807852d$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $1bdeb3b3b807852d$var$hasOwnProperty = $1bdeb3b3b807852d$var$objectProto.hasOwnProperty;
/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $1bdeb3b3b807852d$var$hashGet(key) {
    var data = this.__data__;
    if (0, $b31b9ce951d45915$export$2e2bcd8739ae039) {
        var result = data[key];
        return result === $1bdeb3b3b807852d$var$HASH_UNDEFINED ? undefined : result;
    }
    return $1bdeb3b3b807852d$var$hasOwnProperty.call(data, key) ? data[key] : undefined;
}
var $1bdeb3b3b807852d$export$2e2bcd8739ae039 = $1bdeb3b3b807852d$var$hashGet;



/** Used for built-in method references. */ var $63229fbed401bb0c$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $63229fbed401bb0c$var$hasOwnProperty = $63229fbed401bb0c$var$objectProto.hasOwnProperty;
/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $63229fbed401bb0c$var$hashHas(key) {
    var data = this.__data__;
    return (0, $b31b9ce951d45915$export$2e2bcd8739ae039) ? data[key] !== undefined : $63229fbed401bb0c$var$hasOwnProperty.call(data, key);
}
var $63229fbed401bb0c$export$2e2bcd8739ae039 = $63229fbed401bb0c$var$hashHas;



/** Used to stand-in for `undefined` hash values. */ var $c788e785baf0d991$var$HASH_UNDEFINED = "__lodash_hash_undefined__";
/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */ function $c788e785baf0d991$var$hashSet(key, value) {
    var data = this.__data__;
    this.size += this.has(key) ? 0 : 1;
    data[key] = (0, $b31b9ce951d45915$export$2e2bcd8739ae039) && value === undefined ? $c788e785baf0d991$var$HASH_UNDEFINED : value;
    return this;
}
var $c788e785baf0d991$export$2e2bcd8739ae039 = $c788e785baf0d991$var$hashSet;


/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $338fe90c604e77a6$var$Hash(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `Hash`.
$338fe90c604e77a6$var$Hash.prototype.clear = (0, $be9a5cf3e915f078$export$2e2bcd8739ae039);
$338fe90c604e77a6$var$Hash.prototype["delete"] = (0, $df71e396e71e4535$export$2e2bcd8739ae039);
$338fe90c604e77a6$var$Hash.prototype.get = (0, $1bdeb3b3b807852d$export$2e2bcd8739ae039);
$338fe90c604e77a6$var$Hash.prototype.has = (0, $63229fbed401bb0c$export$2e2bcd8739ae039);
$338fe90c604e77a6$var$Hash.prototype.set = (0, $c788e785baf0d991$export$2e2bcd8739ae039);
var $338fe90c604e77a6$export$2e2bcd8739ae039 = $338fe90c604e77a6$var$Hash;




/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */ function $b10ac3021210b27d$var$mapCacheClear() {
    this.size = 0;
    this.__data__ = {
        "hash": new (0, $338fe90c604e77a6$export$2e2bcd8739ae039),
        "map": new ((0, $277a51f176965052$export$2e2bcd8739ae039) || (0, $0ec6b653931e70c0$export$2e2bcd8739ae039)),
        "string": new (0, $338fe90c604e77a6$export$2e2bcd8739ae039)
    };
}
var $b10ac3021210b27d$export$2e2bcd8739ae039 = $b10ac3021210b27d$var$mapCacheClear;


/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */ function $51c8b4911caf5a5e$var$isKeyable(value) {
    var type = typeof value;
    return type == "string" || type == "number" || type == "symbol" || type == "boolean" ? value !== "__proto__" : value === null;
}
var $51c8b4911caf5a5e$export$2e2bcd8739ae039 = $51c8b4911caf5a5e$var$isKeyable;


/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */ function $b362dbf6ad299a4e$var$getMapData(map, key) {
    var data = map.__data__;
    return (0, $51c8b4911caf5a5e$export$2e2bcd8739ae039)(key) ? data[typeof key == "string" ? "string" : "hash"] : data.map;
}
var $b362dbf6ad299a4e$export$2e2bcd8739ae039 = $b362dbf6ad299a4e$var$getMapData;


/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $ff08a738a3d9692c$var$mapCacheDelete(key) {
    var result = (0, $b362dbf6ad299a4e$export$2e2bcd8739ae039)(this, key)["delete"](key);
    this.size -= result ? 1 : 0;
    return result;
}
var $ff08a738a3d9692c$export$2e2bcd8739ae039 = $ff08a738a3d9692c$var$mapCacheDelete;



/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $77c982c7650c0855$var$mapCacheGet(key) {
    return (0, $b362dbf6ad299a4e$export$2e2bcd8739ae039)(this, key).get(key);
}
var $77c982c7650c0855$export$2e2bcd8739ae039 = $77c982c7650c0855$var$mapCacheGet;



/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $dd687c91ca0fd21b$var$mapCacheHas(key) {
    return (0, $b362dbf6ad299a4e$export$2e2bcd8739ae039)(this, key).has(key);
}
var $dd687c91ca0fd21b$export$2e2bcd8739ae039 = $dd687c91ca0fd21b$var$mapCacheHas;



/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */ function $3e7a0a72446267a7$var$mapCacheSet(key, value) {
    var data = (0, $b362dbf6ad299a4e$export$2e2bcd8739ae039)(this, key), size = data.size;
    data.set(key, value);
    this.size += data.size == size ? 0 : 1;
    return this;
}
var $3e7a0a72446267a7$export$2e2bcd8739ae039 = $3e7a0a72446267a7$var$mapCacheSet;


/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $be493b3f39c647b0$var$MapCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `MapCache`.
$be493b3f39c647b0$var$MapCache.prototype.clear = (0, $b10ac3021210b27d$export$2e2bcd8739ae039);
$be493b3f39c647b0$var$MapCache.prototype["delete"] = (0, $ff08a738a3d9692c$export$2e2bcd8739ae039);
$be493b3f39c647b0$var$MapCache.prototype.get = (0, $77c982c7650c0855$export$2e2bcd8739ae039);
$be493b3f39c647b0$var$MapCache.prototype.has = (0, $dd687c91ca0fd21b$export$2e2bcd8739ae039);
$be493b3f39c647b0$var$MapCache.prototype.set = (0, $3e7a0a72446267a7$export$2e2bcd8739ae039);
var $be493b3f39c647b0$export$2e2bcd8739ae039 = $be493b3f39c647b0$var$MapCache;


/** Used as the size to enable large array optimizations. */ var $62559106803ce443$var$LARGE_ARRAY_SIZE = 200;
/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */ function $62559106803ce443$var$stackSet(key, value) {
    var data = this.__data__;
    if (data instanceof (0, $0ec6b653931e70c0$export$2e2bcd8739ae039)) {
        var pairs = data.__data__;
        if (!(0, $277a51f176965052$export$2e2bcd8739ae039) || pairs.length < $62559106803ce443$var$LARGE_ARRAY_SIZE - 1) {
            pairs.push([
                key,
                value
            ]);
            this.size = ++data.size;
            return this;
        }
        data = this.__data__ = new (0, $be493b3f39c647b0$export$2e2bcd8739ae039)(pairs);
    }
    data.set(key, value);
    this.size = data.size;
    return this;
}
var $62559106803ce443$export$2e2bcd8739ae039 = $62559106803ce443$var$stackSet;


/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $8b088ed672f4e479$var$Stack(entries) {
    var data = this.__data__ = new (0, $0ec6b653931e70c0$export$2e2bcd8739ae039)(entries);
    this.size = data.size;
}
// Add methods to `Stack`.
$8b088ed672f4e479$var$Stack.prototype.clear = (0, $a8da9f1850418a97$export$2e2bcd8739ae039);
$8b088ed672f4e479$var$Stack.prototype["delete"] = (0, $fc3063294f0985d4$export$2e2bcd8739ae039);
$8b088ed672f4e479$var$Stack.prototype.get = (0, $5d20cedfc2997602$export$2e2bcd8739ae039);
$8b088ed672f4e479$var$Stack.prototype.has = (0, $507326fb3b1993fe$export$2e2bcd8739ae039);
$8b088ed672f4e479$var$Stack.prototype.set = (0, $62559106803ce443$export$2e2bcd8739ae039);
var $8b088ed672f4e479$export$2e2bcd8739ae039 = $8b088ed672f4e479$var$Stack;



var $33b74c324685bdc6$var$defineProperty = function() {
    try {
        var func = (0, $e5e36fcd795e94d7$export$2e2bcd8739ae039)(Object, "defineProperty");
        func({}, "", {});
        return func;
    } catch (e) {}
}();
var $33b74c324685bdc6$export$2e2bcd8739ae039 = $33b74c324685bdc6$var$defineProperty;


/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function $1b6a1c4ec76a886d$var$baseAssignValue(object, key, value) {
    if (key == "__proto__" && (0, $33b74c324685bdc6$export$2e2bcd8739ae039)) (0, $33b74c324685bdc6$export$2e2bcd8739ae039)(object, key, {
        "configurable": true,
        "enumerable": true,
        "value": value,
        "writable": true
    });
    else object[key] = value;
}
var $1b6a1c4ec76a886d$export$2e2bcd8739ae039 = $1b6a1c4ec76a886d$var$baseAssignValue;



/**
 * This function is like `assignValue` except that it doesn't assign
 * `undefined` values.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function $fa99eba8d180f636$var$assignMergeValue(object, key, value) {
    if (value !== undefined && !(0, $24a50494b56303fa$export$2e2bcd8739ae039)(object[key], value) || value === undefined && !(key in object)) (0, $1b6a1c4ec76a886d$export$2e2bcd8739ae039)(object, key, value);
}
var $fa99eba8d180f636$export$2e2bcd8739ae039 = $fa99eba8d180f636$var$assignMergeValue;


/**
 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */ function $6fb4502010c86be3$var$createBaseFor(fromRight) {
    return function(object, iteratee, keysFunc) {
        var index = -1, iterable = Object(object), props = keysFunc(object), length = props.length;
        while(length--){
            var key = props[fromRight ? length : ++index];
            if (iteratee(iterable[key], key, iterable) === false) break;
        }
        return object;
    };
}
var $6fb4502010c86be3$export$2e2bcd8739ae039 = $6fb4502010c86be3$var$createBaseFor;


/**
 * The base implementation of `baseForOwn` which iterates over `object`
 * properties returned by `keysFunc` and invokes `iteratee` for each property.
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */ var $746ef0174671518f$var$baseFor = (0, $6fb4502010c86be3$export$2e2bcd8739ae039)();
var $746ef0174671518f$export$2e2bcd8739ae039 = $746ef0174671518f$var$baseFor;




var $bcoTo = parcelRequire("bcoTo");

var $6AhZS = parcelRequire("6AhZS");
/** Built-in value references. */ var $42ccac2ef9780f37$var$Uint8Array = (0, $6AhZS.default).Uint8Array;
var $42ccac2ef9780f37$export$2e2bcd8739ae039 = $42ccac2ef9780f37$var$Uint8Array;


/**
 * Creates a clone of `arrayBuffer`.
 *
 * @private
 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
 * @returns {ArrayBuffer} Returns the cloned array buffer.
 */ function $376f78894f31a267$var$cloneArrayBuffer(arrayBuffer) {
    var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
    new (0, $42ccac2ef9780f37$export$2e2bcd8739ae039)(result).set(new (0, $42ccac2ef9780f37$export$2e2bcd8739ae039)(arrayBuffer));
    return result;
}
var $376f78894f31a267$export$2e2bcd8739ae039 = $376f78894f31a267$var$cloneArrayBuffer;


/**
 * Creates a clone of `typedArray`.
 *
 * @private
 * @param {Object} typedArray The typed array to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned typed array.
 */ function $dab7bb403ffc4337$var$cloneTypedArray(typedArray, isDeep) {
    var buffer = isDeep ? (0, $376f78894f31a267$export$2e2bcd8739ae039)(typedArray.buffer) : typedArray.buffer;
    return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
}
var $dab7bb403ffc4337$export$2e2bcd8739ae039 = $dab7bb403ffc4337$var$cloneTypedArray;


/**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */ function $61900241098abc0a$var$copyArray(source, array) {
    var index = -1, length = source.length;
    array || (array = Array(length));
    while(++index < length)array[index] = source[index];
    return array;
}
var $61900241098abc0a$export$2e2bcd8739ae039 = $61900241098abc0a$var$copyArray;



/** Built-in value references. */ var $c25fbd736b9c0c05$var$objectCreate = Object.create;
/**
 * The base implementation of `_.create` without support for assigning
 * properties to the created object.
 *
 * @private
 * @param {Object} proto The object to inherit from.
 * @returns {Object} Returns the new object.
 */ var $c25fbd736b9c0c05$var$baseCreate = function() {
    function object() {}
    return function(proto) {
        if (!(0, $1146963f863a9576$export$2e2bcd8739ae039)(proto)) return {};
        if ($c25fbd736b9c0c05$var$objectCreate) return $c25fbd736b9c0c05$var$objectCreate(proto);
        object.prototype = proto;
        var result = new object;
        object.prototype = undefined;
        return result;
    };
}();
var $c25fbd736b9c0c05$export$2e2bcd8739ae039 = $c25fbd736b9c0c05$var$baseCreate;


/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */ function $4a2da63f82711215$var$overArg(func, transform) {
    return function(arg) {
        return func(transform(arg));
    };
}
var $4a2da63f82711215$export$2e2bcd8739ae039 = $4a2da63f82711215$var$overArg;


/** Built-in value references. */ var $21886c33f3299694$var$getPrototype = (0, $4a2da63f82711215$export$2e2bcd8739ae039)(Object.getPrototypeOf, Object);
var $21886c33f3299694$export$2e2bcd8739ae039 = $21886c33f3299694$var$getPrototype;


/** Used for built-in method references. */ var $61838f3cfb255cdf$var$objectProto = Object.prototype;
/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */ function $61838f3cfb255cdf$var$isPrototype(value) {
    var Ctor = value && value.constructor, proto = typeof Ctor == "function" && Ctor.prototype || $61838f3cfb255cdf$var$objectProto;
    return value === proto;
}
var $61838f3cfb255cdf$export$2e2bcd8739ae039 = $61838f3cfb255cdf$var$isPrototype;


/**
 * Initializes an object clone.
 *
 * @private
 * @param {Object} object The object to clone.
 * @returns {Object} Returns the initialized clone.
 */ function $30036e4acfc7be83$var$initCloneObject(object) {
    return typeof object.constructor == "function" && !(0, $61838f3cfb255cdf$export$2e2bcd8739ae039)(object) ? (0, $c25fbd736b9c0c05$export$2e2bcd8739ae039)((0, $21886c33f3299694$export$2e2bcd8739ae039)(object)) : {};
}
var $30036e4acfc7be83$export$2e2bcd8739ae039 = $30036e4acfc7be83$var$initCloneObject;



/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function $97d6226034a0ca4f$var$isObjectLike(value) {
    return value != null && typeof value == "object";
}
var $97d6226034a0ca4f$export$2e2bcd8739ae039 = $97d6226034a0ca4f$var$isObjectLike;


/** `Object#toString` result references. */ var $52b602f09e00e5f5$var$argsTag = "[object Arguments]";
/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */ function $52b602f09e00e5f5$var$baseIsArguments(value) {
    return (0, $97d6226034a0ca4f$export$2e2bcd8739ae039)(value) && (0, $622194736393697a$export$2e2bcd8739ae039)(value) == $52b602f09e00e5f5$var$argsTag;
}
var $52b602f09e00e5f5$export$2e2bcd8739ae039 = $52b602f09e00e5f5$var$baseIsArguments;



/** Used for built-in method references. */ var $8be4c6075fd28431$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $8be4c6075fd28431$var$hasOwnProperty = $8be4c6075fd28431$var$objectProto.hasOwnProperty;
/** Built-in value references. */ var $8be4c6075fd28431$var$propertyIsEnumerable = $8be4c6075fd28431$var$objectProto.propertyIsEnumerable;
/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */ var $8be4c6075fd28431$var$isArguments = (0, $52b602f09e00e5f5$export$2e2bcd8739ae039)(function() {
    return arguments;
}()) ? (0, $52b602f09e00e5f5$export$2e2bcd8739ae039) : function(value) {
    return (0, $97d6226034a0ca4f$export$2e2bcd8739ae039)(value) && $8be4c6075fd28431$var$hasOwnProperty.call(value, "callee") && !$8be4c6075fd28431$var$propertyIsEnumerable.call(value, "callee");
};
var $8be4c6075fd28431$export$2e2bcd8739ae039 = $8be4c6075fd28431$var$isArguments;


/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */ var $98f8e0b2d1df3aed$var$isArray = Array.isArray;
var $98f8e0b2d1df3aed$export$2e2bcd8739ae039 = $98f8e0b2d1df3aed$var$isArray;



/** Used as references for various `Number` constants. */ var $6c8a600bb2a3ff82$var$MAX_SAFE_INTEGER = 9007199254740991;
/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */ function $6c8a600bb2a3ff82$var$isLength(value) {
    return typeof value == "number" && value > -1 && value % 1 == 0 && value <= $6c8a600bb2a3ff82$var$MAX_SAFE_INTEGER;
}
var $6c8a600bb2a3ff82$export$2e2bcd8739ae039 = $6c8a600bb2a3ff82$var$isLength;


/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */ function $1f3895d15a1c09ab$var$isArrayLike(value) {
    return value != null && (0, $6c8a600bb2a3ff82$export$2e2bcd8739ae039)(value.length) && !(0, $8e0b215b91f51a44$export$2e2bcd8739ae039)(value);
}
var $1f3895d15a1c09ab$export$2e2bcd8739ae039 = $1f3895d15a1c09ab$var$isArrayLike;



/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */ function $1aa9b056795d593b$var$isArrayLikeObject(value) {
    return (0, $97d6226034a0ca4f$export$2e2bcd8739ae039)(value) && (0, $1f3895d15a1c09ab$export$2e2bcd8739ae039)(value);
}
var $1aa9b056795d593b$export$2e2bcd8739ae039 = $1aa9b056795d593b$var$isArrayLikeObject;



var $h0k3u = parcelRequire("h0k3u");





/** `Object#toString` result references. */ var $aa61311201be6269$var$objectTag = "[object Object]";
/** Used for built-in method references. */ var $aa61311201be6269$var$funcProto = Function.prototype, $aa61311201be6269$var$objectProto = Object.prototype;
/** Used to resolve the decompiled source of functions. */ var $aa61311201be6269$var$funcToString = $aa61311201be6269$var$funcProto.toString;
/** Used to check objects for own properties. */ var $aa61311201be6269$var$hasOwnProperty = $aa61311201be6269$var$objectProto.hasOwnProperty;
/** Used to infer the `Object` constructor. */ var $aa61311201be6269$var$objectCtorString = $aa61311201be6269$var$funcToString.call(Object);
/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */ function $aa61311201be6269$var$isPlainObject(value) {
    if (!(0, $97d6226034a0ca4f$export$2e2bcd8739ae039)(value) || (0, $622194736393697a$export$2e2bcd8739ae039)(value) != $aa61311201be6269$var$objectTag) return false;
    var proto = (0, $21886c33f3299694$export$2e2bcd8739ae039)(value);
    if (proto === null) return true;
    var Ctor = $aa61311201be6269$var$hasOwnProperty.call(proto, "constructor") && proto.constructor;
    return typeof Ctor == "function" && Ctor instanceof Ctor && $aa61311201be6269$var$funcToString.call(Ctor) == $aa61311201be6269$var$objectCtorString;
}
var $aa61311201be6269$export$2e2bcd8739ae039 = $aa61311201be6269$var$isPlainObject;





/** `Object#toString` result references. */ var $91a76151d4364000$var$argsTag = "[object Arguments]", $91a76151d4364000$var$arrayTag = "[object Array]", $91a76151d4364000$var$boolTag = "[object Boolean]", $91a76151d4364000$var$dateTag = "[object Date]", $91a76151d4364000$var$errorTag = "[object Error]", $91a76151d4364000$var$funcTag = "[object Function]", $91a76151d4364000$var$mapTag = "[object Map]", $91a76151d4364000$var$numberTag = "[object Number]", $91a76151d4364000$var$objectTag = "[object Object]", $91a76151d4364000$var$regexpTag = "[object RegExp]", $91a76151d4364000$var$setTag = "[object Set]", $91a76151d4364000$var$stringTag = "[object String]", $91a76151d4364000$var$weakMapTag = "[object WeakMap]";
var $91a76151d4364000$var$arrayBufferTag = "[object ArrayBuffer]", $91a76151d4364000$var$dataViewTag = "[object DataView]", $91a76151d4364000$var$float32Tag = "[object Float32Array]", $91a76151d4364000$var$float64Tag = "[object Float64Array]", $91a76151d4364000$var$int8Tag = "[object Int8Array]", $91a76151d4364000$var$int16Tag = "[object Int16Array]", $91a76151d4364000$var$int32Tag = "[object Int32Array]", $91a76151d4364000$var$uint8Tag = "[object Uint8Array]", $91a76151d4364000$var$uint8ClampedTag = "[object Uint8ClampedArray]", $91a76151d4364000$var$uint16Tag = "[object Uint16Array]", $91a76151d4364000$var$uint32Tag = "[object Uint32Array]";
/** Used to identify `toStringTag` values of typed arrays. */ var $91a76151d4364000$var$typedArrayTags = {};
$91a76151d4364000$var$typedArrayTags[$91a76151d4364000$var$float32Tag] = $91a76151d4364000$var$typedArrayTags[$91a76151d4364000$var$float64Tag] = $91a76151d4364000$var$typedArrayTags[$91a76151d4364000$var$int8Tag] = $91a76151d4364000$var$typedArrayTags[$91a76151d4364000$var$int16Tag] = $91a76151d4364000$var$typedArrayTags[$91a76151d4364000$var$int32Tag] = $91a76151d4364000$var$typedArrayTags[$91a76151d4364000$var$uint8Tag] = $91a76151d4364000$var$typedArrayTags[$91a76151d4364000$var$uint8ClampedTag] = $91a76151d4364000$var$typedArrayTags[$91a76151d4364000$var$uint16Tag] = $91a76151d4364000$var$typedArrayTags[$91a76151d4364000$var$uint32Tag] = true;
$91a76151d4364000$var$typedArrayTags[$91a76151d4364000$var$argsTag] = $91a76151d4364000$var$typedArrayTags[$91a76151d4364000$var$arrayTag] = $91a76151d4364000$var$typedArrayTags[$91a76151d4364000$var$arrayBufferTag] = $91a76151d4364000$var$typedArrayTags[$91a76151d4364000$var$boolTag] = $91a76151d4364000$var$typedArrayTags[$91a76151d4364000$var$dataViewTag] = $91a76151d4364000$var$typedArrayTags[$91a76151d4364000$var$dateTag] = $91a76151d4364000$var$typedArrayTags[$91a76151d4364000$var$errorTag] = $91a76151d4364000$var$typedArrayTags[$91a76151d4364000$var$funcTag] = $91a76151d4364000$var$typedArrayTags[$91a76151d4364000$var$mapTag] = $91a76151d4364000$var$typedArrayTags[$91a76151d4364000$var$numberTag] = $91a76151d4364000$var$typedArrayTags[$91a76151d4364000$var$objectTag] = $91a76151d4364000$var$typedArrayTags[$91a76151d4364000$var$regexpTag] = $91a76151d4364000$var$typedArrayTags[$91a76151d4364000$var$setTag] = $91a76151d4364000$var$typedArrayTags[$91a76151d4364000$var$stringTag] = $91a76151d4364000$var$typedArrayTags[$91a76151d4364000$var$weakMapTag] = false;
/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */ function $91a76151d4364000$var$baseIsTypedArray(value) {
    return (0, $97d6226034a0ca4f$export$2e2bcd8739ae039)(value) && (0, $6c8a600bb2a3ff82$export$2e2bcd8739ae039)(value.length) && !!$91a76151d4364000$var$typedArrayTags[(0, $622194736393697a$export$2e2bcd8739ae039)(value)];
}
var $91a76151d4364000$export$2e2bcd8739ae039 = $91a76151d4364000$var$baseIsTypedArray;


/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */ function $05e9172cfe434229$var$baseUnary(func) {
    return function(value) {
        return func(value);
    };
}
var $05e9172cfe434229$export$2e2bcd8739ae039 = $05e9172cfe434229$var$baseUnary;



var $gLfdj = parcelRequire("gLfdj");
/* Node.js helper references. */ var $5bca4d58ac751b05$var$nodeIsTypedArray = (0, $gLfdj.default) && (0, $gLfdj.default).isTypedArray;
/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */ var $5bca4d58ac751b05$var$isTypedArray = $5bca4d58ac751b05$var$nodeIsTypedArray ? (0, $05e9172cfe434229$export$2e2bcd8739ae039)($5bca4d58ac751b05$var$nodeIsTypedArray) : (0, $91a76151d4364000$export$2e2bcd8739ae039);
var $5bca4d58ac751b05$export$2e2bcd8739ae039 = $5bca4d58ac751b05$var$isTypedArray;


/**
 * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */ function $86d06c5d8259bf39$var$safeGet(object, key) {
    if (key === "constructor" && typeof object[key] === "function") return;
    if (key == "__proto__") return;
    return object[key];
}
var $86d06c5d8259bf39$export$2e2bcd8739ae039 = $86d06c5d8259bf39$var$safeGet;




/** Used for built-in method references. */ var $7171535fac2abf8e$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $7171535fac2abf8e$var$hasOwnProperty = $7171535fac2abf8e$var$objectProto.hasOwnProperty;
/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function $7171535fac2abf8e$var$assignValue(object, key, value) {
    var objValue = object[key];
    if (!($7171535fac2abf8e$var$hasOwnProperty.call(object, key) && (0, $24a50494b56303fa$export$2e2bcd8739ae039)(objValue, value)) || value === undefined && !(key in object)) (0, $1b6a1c4ec76a886d$export$2e2bcd8739ae039)(object, key, value);
}
var $7171535fac2abf8e$export$2e2bcd8739ae039 = $7171535fac2abf8e$var$assignValue;



/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */ function $db0b6e48253ee39d$var$copyObject(source, props, object, customizer) {
    var isNew = !object;
    object || (object = {});
    var index = -1, length = props.length;
    while(++index < length){
        var key = props[index];
        var newValue = customizer ? customizer(object[key], source[key], key, object, source) : undefined;
        if (newValue === undefined) newValue = source[key];
        if (isNew) (0, $1b6a1c4ec76a886d$export$2e2bcd8739ae039)(object, key, newValue);
        else (0, $7171535fac2abf8e$export$2e2bcd8739ae039)(object, key, newValue);
    }
    return object;
}
var $db0b6e48253ee39d$export$2e2bcd8739ae039 = $db0b6e48253ee39d$var$copyObject;


/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */ function $cccc93d07b8d8aae$var$baseTimes(n, iteratee) {
    var index = -1, result = Array(n);
    while(++index < n)result[index] = iteratee(index);
    return result;
}
var $cccc93d07b8d8aae$export$2e2bcd8739ae039 = $cccc93d07b8d8aae$var$baseTimes;





var $h0k3u = parcelRequire("h0k3u");
/** Used as references for various `Number` constants. */ var $9561a998e411883c$var$MAX_SAFE_INTEGER = 9007199254740991;
/** Used to detect unsigned integer values. */ var $9561a998e411883c$var$reIsUint = /^(?:0|[1-9]\d*)$/;
/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */ function $9561a998e411883c$var$isIndex(value, length) {
    var type = typeof value;
    length = length == null ? $9561a998e411883c$var$MAX_SAFE_INTEGER : length;
    return !!length && (type == "number" || type != "symbol" && $9561a998e411883c$var$reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
}
var $9561a998e411883c$export$2e2bcd8739ae039 = $9561a998e411883c$var$isIndex;



/** Used for built-in method references. */ var $de432e29eceb0e20$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $de432e29eceb0e20$var$hasOwnProperty = $de432e29eceb0e20$var$objectProto.hasOwnProperty;
/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */ function $de432e29eceb0e20$var$arrayLikeKeys(value, inherited) {
    var isArr = (0, $98f8e0b2d1df3aed$export$2e2bcd8739ae039)(value), isArg = !isArr && (0, $8be4c6075fd28431$export$2e2bcd8739ae039)(value), isBuff = !isArr && !isArg && (0, $h0k3u.default)(value), isType = !isArr && !isArg && !isBuff && (0, $5bca4d58ac751b05$export$2e2bcd8739ae039)(value), skipIndexes = isArr || isArg || isBuff || isType, result = skipIndexes ? (0, $cccc93d07b8d8aae$export$2e2bcd8739ae039)(value.length, String) : [], length = result.length;
    for(var key in value)if ((inherited || $de432e29eceb0e20$var$hasOwnProperty.call(value, key)) && !(skipIndexes && // Safari 9 has enumerable `arguments.length` in strict mode.
    (key == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
    isBuff && (key == "offset" || key == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    isType && (key == "buffer" || key == "byteLength" || key == "byteOffset") || // Skip index properties.
    (0, $9561a998e411883c$export$2e2bcd8739ae039)(key, length)))) result.push(key);
    return result;
}
var $de432e29eceb0e20$export$2e2bcd8739ae039 = $de432e29eceb0e20$var$arrayLikeKeys;




/**
 * This function is like
 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * except that it includes inherited enumerable properties.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function $54c8d812217bf591$var$nativeKeysIn(object) {
    var result = [];
    if (object != null) for(var key in Object(object))result.push(key);
    return result;
}
var $54c8d812217bf591$export$2e2bcd8739ae039 = $54c8d812217bf591$var$nativeKeysIn;


/** Used for built-in method references. */ var $34e6a65508d052bc$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $34e6a65508d052bc$var$hasOwnProperty = $34e6a65508d052bc$var$objectProto.hasOwnProperty;
/**
 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function $34e6a65508d052bc$var$baseKeysIn(object) {
    if (!(0, $1146963f863a9576$export$2e2bcd8739ae039)(object)) return (0, $54c8d812217bf591$export$2e2bcd8739ae039)(object);
    var isProto = (0, $61838f3cfb255cdf$export$2e2bcd8739ae039)(object), result = [];
    for(var key in object)if (!(key == "constructor" && (isProto || !$34e6a65508d052bc$var$hasOwnProperty.call(object, key)))) result.push(key);
    return result;
}
var $34e6a65508d052bc$export$2e2bcd8739ae039 = $34e6a65508d052bc$var$baseKeysIn;



/**
 * Creates an array of the own and inherited enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keysIn(new Foo);
 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
 */ function $806899b4212b4069$var$keysIn(object) {
    return (0, $1f3895d15a1c09ab$export$2e2bcd8739ae039)(object) ? (0, $de432e29eceb0e20$export$2e2bcd8739ae039)(object, true) : (0, $34e6a65508d052bc$export$2e2bcd8739ae039)(object);
}
var $806899b4212b4069$export$2e2bcd8739ae039 = $806899b4212b4069$var$keysIn;


/**
 * Converts `value` to a plain object flattening inherited enumerable string
 * keyed properties of `value` to own properties of the plain object.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {Object} Returns the converted plain object.
 * @example
 *
 * function Foo() {
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.assign({ 'a': 1 }, new Foo);
 * // => { 'a': 1, 'b': 2 }
 *
 * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
 * // => { 'a': 1, 'b': 2, 'c': 3 }
 */ function $5f8749bb160c6eef$var$toPlainObject(value) {
    return (0, $db0b6e48253ee39d$export$2e2bcd8739ae039)(value, (0, $806899b4212b4069$export$2e2bcd8739ae039)(value));
}
var $5f8749bb160c6eef$export$2e2bcd8739ae039 = $5f8749bb160c6eef$var$toPlainObject;


/**
 * A specialized version of `baseMerge` for arrays and objects which performs
 * deep merges and tracks traversed objects enabling objects with circular
 * references to be merged.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @param {string} key The key of the value to merge.
 * @param {number} srcIndex The index of `source`.
 * @param {Function} mergeFunc The function to merge values.
 * @param {Function} [customizer] The function to customize assigned values.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 */ function $6b8212cf71847a8b$var$baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
    var objValue = (0, $86d06c5d8259bf39$export$2e2bcd8739ae039)(object, key), srcValue = (0, $86d06c5d8259bf39$export$2e2bcd8739ae039)(source, key), stacked = stack.get(srcValue);
    if (stacked) {
        (0, $fa99eba8d180f636$export$2e2bcd8739ae039)(object, key, stacked);
        return;
    }
    var newValue = customizer ? customizer(objValue, srcValue, key + "", object, source, stack) : undefined;
    var isCommon = newValue === undefined;
    if (isCommon) {
        var isArr = (0, $98f8e0b2d1df3aed$export$2e2bcd8739ae039)(srcValue), isBuff = !isArr && (0, $h0k3u.default)(srcValue), isTyped = !isArr && !isBuff && (0, $5bca4d58ac751b05$export$2e2bcd8739ae039)(srcValue);
        newValue = srcValue;
        if (isArr || isBuff || isTyped) {
            if ((0, $98f8e0b2d1df3aed$export$2e2bcd8739ae039)(objValue)) newValue = objValue;
            else if ((0, $1aa9b056795d593b$export$2e2bcd8739ae039)(objValue)) newValue = (0, $61900241098abc0a$export$2e2bcd8739ae039)(objValue);
            else if (isBuff) {
                isCommon = false;
                newValue = (0, $bcoTo.default)(srcValue, true);
            } else if (isTyped) {
                isCommon = false;
                newValue = (0, $dab7bb403ffc4337$export$2e2bcd8739ae039)(srcValue, true);
            } else newValue = [];
        } else if ((0, $aa61311201be6269$export$2e2bcd8739ae039)(srcValue) || (0, $8be4c6075fd28431$export$2e2bcd8739ae039)(srcValue)) {
            newValue = objValue;
            if ((0, $8be4c6075fd28431$export$2e2bcd8739ae039)(objValue)) newValue = (0, $5f8749bb160c6eef$export$2e2bcd8739ae039)(objValue);
            else if (!(0, $1146963f863a9576$export$2e2bcd8739ae039)(objValue) || (0, $8e0b215b91f51a44$export$2e2bcd8739ae039)(objValue)) newValue = (0, $30036e4acfc7be83$export$2e2bcd8739ae039)(srcValue);
        } else isCommon = false;
    }
    if (isCommon) {
        // Recursively merge objects and arrays (susceptible to call stack limits).
        stack.set(srcValue, newValue);
        mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
        stack["delete"](srcValue);
    }
    (0, $fa99eba8d180f636$export$2e2bcd8739ae039)(object, key, newValue);
}
var $6b8212cf71847a8b$export$2e2bcd8739ae039 = $6b8212cf71847a8b$var$baseMergeDeep;





/**
 * The base implementation of `_.merge` without support for multiple sources.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @param {number} srcIndex The index of `source`.
 * @param {Function} [customizer] The function to customize merged values.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 */ function $5104da85b860ad3a$var$baseMerge(object, source, srcIndex, customizer, stack) {
    if (object === source) return;
    (0, $746ef0174671518f$export$2e2bcd8739ae039)(source, function(srcValue, key) {
        stack || (stack = new (0, $8b088ed672f4e479$export$2e2bcd8739ae039));
        if ((0, $1146963f863a9576$export$2e2bcd8739ae039)(srcValue)) (0, $6b8212cf71847a8b$export$2e2bcd8739ae039)(object, source, key, srcIndex, $5104da85b860ad3a$var$baseMerge, customizer, stack);
        else {
            var newValue = customizer ? customizer((0, $86d06c5d8259bf39$export$2e2bcd8739ae039)(object, key), srcValue, key + "", object, source, stack) : undefined;
            if (newValue === undefined) newValue = srcValue;
            (0, $fa99eba8d180f636$export$2e2bcd8739ae039)(object, key, newValue);
        }
    }, (0, $806899b4212b4069$export$2e2bcd8739ae039));
}
var $5104da85b860ad3a$export$2e2bcd8739ae039 = $5104da85b860ad3a$var$baseMerge;


/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */ function $6ee142fec3d715f9$var$identity(value) {
    return value;
}
var $6ee142fec3d715f9$export$2e2bcd8739ae039 = $6ee142fec3d715f9$var$identity;


/**
 * A faster alternative to `Function#apply`, this function invokes `func`
 * with the `this` binding of `thisArg` and the arguments of `args`.
 *
 * @private
 * @param {Function} func The function to invoke.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} args The arguments to invoke `func` with.
 * @returns {*} Returns the result of `func`.
 */ function $f0e18e9971bbc015$var$apply(func, thisArg, args) {
    switch(args.length){
        case 0:
            return func.call(thisArg);
        case 1:
            return func.call(thisArg, args[0]);
        case 2:
            return func.call(thisArg, args[0], args[1]);
        case 3:
            return func.call(thisArg, args[0], args[1], args[2]);
    }
    return func.apply(thisArg, args);
}
var $f0e18e9971bbc015$export$2e2bcd8739ae039 = $f0e18e9971bbc015$var$apply;


/* Built-in method references for those with the same name as other `lodash` methods. */ var $5537d7bd835201e1$var$nativeMax = Math.max;
/**
 * A specialized version of `baseRest` which transforms the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @param {Function} transform The rest array transform.
 * @returns {Function} Returns the new function.
 */ function $5537d7bd835201e1$var$overRest(func, start, transform) {
    start = $5537d7bd835201e1$var$nativeMax(start === undefined ? func.length - 1 : start, 0);
    return function() {
        var args = arguments, index = -1, length = $5537d7bd835201e1$var$nativeMax(args.length - start, 0), array = Array(length);
        while(++index < length)array[index] = args[start + index];
        index = -1;
        var otherArgs = Array(start + 1);
        while(++index < start)otherArgs[index] = args[index];
        otherArgs[start] = transform(array);
        return (0, $f0e18e9971bbc015$export$2e2bcd8739ae039)(func, this, otherArgs);
    };
}
var $5537d7bd835201e1$export$2e2bcd8739ae039 = $5537d7bd835201e1$var$overRest;


/**
 * Creates a function that returns `value`.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {*} value The value to return from the new function.
 * @returns {Function} Returns the new constant function.
 * @example
 *
 * var objects = _.times(2, _.constant({ 'a': 1 }));
 *
 * console.log(objects);
 * // => [{ 'a': 1 }, { 'a': 1 }]
 *
 * console.log(objects[0] === objects[1]);
 * // => true
 */ function $4842e0d71dac1d85$var$constant(value) {
    return function() {
        return value;
    };
}
var $4842e0d71dac1d85$export$2e2bcd8739ae039 = $4842e0d71dac1d85$var$constant;




/**
 * The base implementation of `setToString` without support for hot loop shorting.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */ var $011b65554693b3e5$var$baseSetToString = !(0, $33b74c324685bdc6$export$2e2bcd8739ae039) ? (0, $6ee142fec3d715f9$export$2e2bcd8739ae039) : function(func, string) {
    return (0, $33b74c324685bdc6$export$2e2bcd8739ae039)(func, "toString", {
        "configurable": true,
        "enumerable": false,
        "value": (0, $4842e0d71dac1d85$export$2e2bcd8739ae039)(string),
        "writable": true
    });
};
var $011b65554693b3e5$export$2e2bcd8739ae039 = $011b65554693b3e5$var$baseSetToString;


/** Used to detect hot functions by number of calls within a span of milliseconds. */ var $ea3554b91e11b840$var$HOT_COUNT = 800, $ea3554b91e11b840$var$HOT_SPAN = 16;
/* Built-in method references for those with the same name as other `lodash` methods. */ var $ea3554b91e11b840$var$nativeNow = Date.now;
/**
 * Creates a function that'll short out and invoke `identity` instead
 * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
 * milliseconds.
 *
 * @private
 * @param {Function} func The function to restrict.
 * @returns {Function} Returns the new shortable function.
 */ function $ea3554b91e11b840$var$shortOut(func) {
    var count = 0, lastCalled = 0;
    return function() {
        var stamp = $ea3554b91e11b840$var$nativeNow(), remaining = $ea3554b91e11b840$var$HOT_SPAN - (stamp - lastCalled);
        lastCalled = stamp;
        if (remaining > 0) {
            if (++count >= $ea3554b91e11b840$var$HOT_COUNT) return arguments[0];
        } else count = 0;
        return func.apply(undefined, arguments);
    };
}
var $ea3554b91e11b840$export$2e2bcd8739ae039 = $ea3554b91e11b840$var$shortOut;


/**
 * Sets the `toString` method of `func` to return `string`.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */ var $5c5d62a3151bc71d$var$setToString = (0, $ea3554b91e11b840$export$2e2bcd8739ae039)((0, $011b65554693b3e5$export$2e2bcd8739ae039));
var $5c5d62a3151bc71d$export$2e2bcd8739ae039 = $5c5d62a3151bc71d$var$setToString;


/**
 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @returns {Function} Returns the new function.
 */ function $9a0b969f2d05399f$var$baseRest(func, start) {
    return (0, $5c5d62a3151bc71d$export$2e2bcd8739ae039)((0, $5537d7bd835201e1$export$2e2bcd8739ae039)(func, start, (0, $6ee142fec3d715f9$export$2e2bcd8739ae039)), func + "");
}
var $9a0b969f2d05399f$export$2e2bcd8739ae039 = $9a0b969f2d05399f$var$baseRest;






/**
 * Checks if the given arguments are from an iteratee call.
 *
 * @private
 * @param {*} value The potential iteratee value argument.
 * @param {*} index The potential iteratee index or key argument.
 * @param {*} object The potential iteratee object argument.
 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
 *  else `false`.
 */ function $cfb57577f709055d$var$isIterateeCall(value, index, object) {
    if (!(0, $1146963f863a9576$export$2e2bcd8739ae039)(object)) return false;
    var type = typeof index;
    if (type == "number" ? (0, $1f3895d15a1c09ab$export$2e2bcd8739ae039)(object) && (0, $9561a998e411883c$export$2e2bcd8739ae039)(index, object.length) : type == "string" && index in object) return (0, $24a50494b56303fa$export$2e2bcd8739ae039)(object[index], value);
    return false;
}
var $cfb57577f709055d$export$2e2bcd8739ae039 = $cfb57577f709055d$var$isIterateeCall;


/**
 * Creates a function like `_.assign`.
 *
 * @private
 * @param {Function} assigner The function to assign values.
 * @returns {Function} Returns the new assigner function.
 */ function $ad55adce189a87c6$var$createAssigner(assigner) {
    return (0, $9a0b969f2d05399f$export$2e2bcd8739ae039)(function(object, sources) {
        var index = -1, length = sources.length, customizer = length > 1 ? sources[length - 1] : undefined, guard = length > 2 ? sources[2] : undefined;
        customizer = assigner.length > 3 && typeof customizer == "function" ? (length--, customizer) : undefined;
        if (guard && (0, $cfb57577f709055d$export$2e2bcd8739ae039)(sources[0], sources[1], guard)) {
            customizer = length < 3 ? undefined : customizer;
            length = 1;
        }
        object = Object(object);
        while(++index < length){
            var source = sources[index];
            if (source) assigner(object, source, index, customizer);
        }
        return object;
    });
}
var $ad55adce189a87c6$export$2e2bcd8739ae039 = $ad55adce189a87c6$var$createAssigner;


/**
 * This method is like `_.assign` except that it recursively merges own and
 * inherited enumerable string keyed properties of source objects into the
 * destination object. Source properties that resolve to `undefined` are
 * skipped if a destination value exists. Array and plain object properties
 * are merged recursively. Other objects and value types are overridden by
 * assignment. Source objects are applied from left to right. Subsequent
 * sources overwrite property assignments of previous sources.
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 0.5.0
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} [sources] The source objects.
 * @returns {Object} Returns `object`.
 * @example
 *
 * var object = {
 *   'a': [{ 'b': 2 }, { 'd': 4 }]
 * };
 *
 * var other = {
 *   'a': [{ 'c': 3 }, { 'e': 5 }]
 * };
 *
 * _.merge(object, other);
 * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
 */ var $b3cb9f7788522a6d$var$merge = (0, $ad55adce189a87c6$export$2e2bcd8739ae039)(function(object, source, srcIndex) {
    (0, $5104da85b860ad3a$export$2e2bcd8739ae039)(object, source, srcIndex);
});
var $b3cb9f7788522a6d$export$2e2bcd8739ae039 = $b3cb9f7788522a6d$var$merge;


var $128f9bfb3e23420c$export$5eec0980ed568dae = function Raised(_ref) {
    var zDepth = _ref.zDepth, radius = _ref.radius, background = _ref.background, children = _ref.children, _ref$styles = _ref.styles, passedStyles = _ref$styles === undefined ? {} : _ref$styles;
    var styles = (0, (/*@__PURE__*/$parcel$interopDefault($1e6d325bf7ec7d53$exports)))((0, $b3cb9f7788522a6d$export$2e2bcd8739ae039)({
        "default": {
            wrap: {
                position: "relative",
                display: "inline-block"
            },
            content: {
                position: "relative"
            },
            bg: {
                absolute: "0px 0px 0px 0px",
                boxShadow: "0 " + zDepth + "px " + zDepth * 4 + "px rgba(0,0,0,.24)",
                borderRadius: radius,
                background: background
            }
        },
        "zDepth-0": {
            bg: {
                boxShadow: "none"
            }
        },
        "zDepth-1": {
            bg: {
                boxShadow: "0 2px 10px rgba(0,0,0,.12), 0 2px 5px rgba(0,0,0,.16)"
            }
        },
        "zDepth-2": {
            bg: {
                boxShadow: "0 6px 20px rgba(0,0,0,.19), 0 8px 17px rgba(0,0,0,.2)"
            }
        },
        "zDepth-3": {
            bg: {
                boxShadow: "0 17px 50px rgba(0,0,0,.19), 0 12px 15px rgba(0,0,0,.24)"
            }
        },
        "zDepth-4": {
            bg: {
                boxShadow: "0 25px 55px rgba(0,0,0,.21), 0 16px 28px rgba(0,0,0,.22)"
            }
        },
        "zDepth-5": {
            bg: {
                boxShadow: "0 40px 77px rgba(0,0,0,.22), 0 27px 24px rgba(0,0,0,.2)"
            }
        },
        "square": {
            bg: {
                borderRadius: "0"
            }
        },
        "circle": {
            bg: {
                borderRadius: "50%"
            }
        }
    }, passedStyles), {
        "zDepth-1": zDepth === 1
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("div", {
        style: styles.wrap
    }, (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("div", {
        style: styles.bg
    }), (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("div", {
        style: styles.content
    }, children));
};
$128f9bfb3e23420c$export$5eec0980ed568dae.propTypes = {
    background: (0, (/*@__PURE__*/$parcel$interopDefault($aa40b802dd2fccfc$exports))).string,
    zDepth: (0, (/*@__PURE__*/$parcel$interopDefault($aa40b802dd2fccfc$exports))).oneOf([
        0,
        1,
        2,
        3,
        4,
        5
    ]),
    radius: (0, (/*@__PURE__*/$parcel$interopDefault($aa40b802dd2fccfc$exports))).number,
    styles: (0, (/*@__PURE__*/$parcel$interopDefault($aa40b802dd2fccfc$exports))).object
};
$128f9bfb3e23420c$export$5eec0980ed568dae.defaultProps = {
    background: "#fff",
    zDepth: 1,
    radius: 2,
    styles: {}
};
var $128f9bfb3e23420c$export$2e2bcd8739ae039 = $128f9bfb3e23420c$export$5eec0980ed568dae;



var $bh6RR = parcelRequire("bh6RR");



var $6AhZS = parcelRequire("6AhZS");
/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */ var $8f212f5525d45e4c$var$now = function() {
    return (0, $6AhZS.default).Date.now();
};
var $8f212f5525d45e4c$export$2e2bcd8739ae039 = $8f212f5525d45e4c$var$now;


/** Used to match a single whitespace character. */ var $385bb2fab708c6c5$var$reWhitespace = /\s/;
/**
 * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
 * character of `string`.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {number} Returns the index of the last non-whitespace character.
 */ function $385bb2fab708c6c5$var$trimmedEndIndex(string) {
    var index = string.length;
    while(index-- && $385bb2fab708c6c5$var$reWhitespace.test(string.charAt(index)));
    return index;
}
var $385bb2fab708c6c5$export$2e2bcd8739ae039 = $385bb2fab708c6c5$var$trimmedEndIndex;


/** Used to match leading whitespace. */ var $aa24a8a2cd0ed953$var$reTrimStart = /^\s+/;
/**
 * The base implementation of `_.trim`.
 *
 * @private
 * @param {string} string The string to trim.
 * @returns {string} Returns the trimmed string.
 */ function $aa24a8a2cd0ed953$var$baseTrim(string) {
    return string ? string.slice(0, (0, $385bb2fab708c6c5$export$2e2bcd8739ae039)(string) + 1).replace($aa24a8a2cd0ed953$var$reTrimStart, "") : string;
}
var $aa24a8a2cd0ed953$export$2e2bcd8739ae039 = $aa24a8a2cd0ed953$var$baseTrim;





/** `Object#toString` result references. */ var $32500a1e560de4f0$var$symbolTag = "[object Symbol]";
/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */ function $32500a1e560de4f0$var$isSymbol(value) {
    return typeof value == "symbol" || (0, $97d6226034a0ca4f$export$2e2bcd8739ae039)(value) && (0, $622194736393697a$export$2e2bcd8739ae039)(value) == $32500a1e560de4f0$var$symbolTag;
}
var $32500a1e560de4f0$export$2e2bcd8739ae039 = $32500a1e560de4f0$var$isSymbol;


/** Used as references for various `Number` constants. */ var $eb3eedae94cf47db$var$NAN = 0 / 0;
/** Used to detect bad signed hexadecimal string values. */ var $eb3eedae94cf47db$var$reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
/** Used to detect binary string values. */ var $eb3eedae94cf47db$var$reIsBinary = /^0b[01]+$/i;
/** Used to detect octal string values. */ var $eb3eedae94cf47db$var$reIsOctal = /^0o[0-7]+$/i;
/** Built-in method references without a dependency on `root`. */ var $eb3eedae94cf47db$var$freeParseInt = parseInt;
/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */ function $eb3eedae94cf47db$var$toNumber(value) {
    if (typeof value == "number") return value;
    if ((0, $32500a1e560de4f0$export$2e2bcd8739ae039)(value)) return $eb3eedae94cf47db$var$NAN;
    if ((0, $1146963f863a9576$export$2e2bcd8739ae039)(value)) {
        var other = typeof value.valueOf == "function" ? value.valueOf() : value;
        value = (0, $1146963f863a9576$export$2e2bcd8739ae039)(other) ? other + "" : other;
    }
    if (typeof value != "string") return value === 0 ? value : +value;
    value = (0, $aa24a8a2cd0ed953$export$2e2bcd8739ae039)(value);
    var isBinary = $eb3eedae94cf47db$var$reIsBinary.test(value);
    return isBinary || $eb3eedae94cf47db$var$reIsOctal.test(value) ? $eb3eedae94cf47db$var$freeParseInt(value.slice(2), isBinary ? 2 : 8) : $eb3eedae94cf47db$var$reIsBadHex.test(value) ? $eb3eedae94cf47db$var$NAN : +value;
}
var $eb3eedae94cf47db$export$2e2bcd8739ae039 = $eb3eedae94cf47db$var$toNumber;


/** Error message constants. */ var $2b9c0da2d9bf5406$var$FUNC_ERROR_TEXT = "Expected a function";
/* Built-in method references for those with the same name as other `lodash` methods. */ var $2b9c0da2d9bf5406$var$nativeMax = Math.max, $2b9c0da2d9bf5406$var$nativeMin = Math.min;
/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */ function $2b9c0da2d9bf5406$var$debounce(func, wait, options) {
    var lastArgs, lastThis, maxWait, result, timerId, lastCallTime, lastInvokeTime = 0, leading = false, maxing = false, trailing = true;
    if (typeof func != "function") throw new TypeError($2b9c0da2d9bf5406$var$FUNC_ERROR_TEXT);
    wait = (0, $eb3eedae94cf47db$export$2e2bcd8739ae039)(wait) || 0;
    if ((0, $1146963f863a9576$export$2e2bcd8739ae039)(options)) {
        leading = !!options.leading;
        maxing = "maxWait" in options;
        maxWait = maxing ? $2b9c0da2d9bf5406$var$nativeMax((0, $eb3eedae94cf47db$export$2e2bcd8739ae039)(options.maxWait) || 0, wait) : maxWait;
        trailing = "trailing" in options ? !!options.trailing : trailing;
    }
    function invokeFunc(time) {
        var args = lastArgs, thisArg = lastThis;
        lastArgs = lastThis = undefined;
        lastInvokeTime = time;
        result = func.apply(thisArg, args);
        return result;
    }
    function leadingEdge(time) {
        // Reset any `maxWait` timer.
        lastInvokeTime = time;
        // Start the timer for the trailing edge.
        timerId = setTimeout(timerExpired, wait);
        // Invoke the leading edge.
        return leading ? invokeFunc(time) : result;
    }
    function remainingWait(time) {
        var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime, timeWaiting = wait - timeSinceLastCall;
        return maxing ? $2b9c0da2d9bf5406$var$nativeMin(timeWaiting, maxWait - timeSinceLastInvoke) : timeWaiting;
    }
    function shouldInvoke(time) {
        var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime;
        // Either this is the first call, activity has stopped and we're at the
        // trailing edge, the system time has gone backwards and we're treating
        // it as the trailing edge, or we've hit the `maxWait` limit.
        return lastCallTime === undefined || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
    }
    function timerExpired() {
        var time = (0, $8f212f5525d45e4c$export$2e2bcd8739ae039)();
        if (shouldInvoke(time)) return trailingEdge(time);
        // Restart the timer.
        timerId = setTimeout(timerExpired, remainingWait(time));
    }
    function trailingEdge(time) {
        timerId = undefined;
        // Only invoke if we have `lastArgs` which means `func` has been
        // debounced at least once.
        if (trailing && lastArgs) return invokeFunc(time);
        lastArgs = lastThis = undefined;
        return result;
    }
    function cancel() {
        if (timerId !== undefined) clearTimeout(timerId);
        lastInvokeTime = 0;
        lastArgs = lastCallTime = lastThis = timerId = undefined;
    }
    function flush() {
        return timerId === undefined ? result : trailingEdge((0, $8f212f5525d45e4c$export$2e2bcd8739ae039)());
    }
    function debounced() {
        var time = (0, $8f212f5525d45e4c$export$2e2bcd8739ae039)(), isInvoking = shouldInvoke(time);
        lastArgs = arguments;
        lastThis = this;
        lastCallTime = time;
        if (isInvoking) {
            if (timerId === undefined) return leadingEdge(lastCallTime);
            if (maxing) {
                // Handle invocations in a tight loop.
                clearTimeout(timerId);
                timerId = setTimeout(timerExpired, wait);
                return invokeFunc(lastCallTime);
            }
        }
        if (timerId === undefined) timerId = setTimeout(timerExpired, wait);
        return result;
    }
    debounced.cancel = cancel;
    debounced.flush = flush;
    return debounced;
}
var $2b9c0da2d9bf5406$export$2e2bcd8739ae039 = $2b9c0da2d9bf5406$var$debounce;



/** Error message constants. */ var $211888181db1e468$var$FUNC_ERROR_TEXT = "Expected a function";
/**
 * Creates a throttled function that only invokes `func` at most once per
 * every `wait` milliseconds. The throttled function comes with a `cancel`
 * method to cancel delayed `func` invocations and a `flush` method to
 * immediately invoke them. Provide `options` to indicate whether `func`
 * should be invoked on the leading and/or trailing edge of the `wait`
 * timeout. The `func` is invoked with the last arguments provided to the
 * throttled function. Subsequent calls to the throttled function return the
 * result of the last `func` invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the throttled function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.throttle` and `_.debounce`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to throttle.
 * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=true]
 *  Specify invoking on the leading edge of the timeout.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new throttled function.
 * @example
 *
 * // Avoid excessively updating the position while scrolling.
 * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
 *
 * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
 * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
 * jQuery(element).on('click', throttled);
 *
 * // Cancel the trailing throttled invocation.
 * jQuery(window).on('popstate', throttled.cancel);
 */ function $211888181db1e468$var$throttle(func, wait, options) {
    var leading = true, trailing = true;
    if (typeof func != "function") throw new TypeError($211888181db1e468$var$FUNC_ERROR_TEXT);
    if ((0, $1146963f863a9576$export$2e2bcd8739ae039)(options)) {
        leading = "leading" in options ? !!options.leading : leading;
        trailing = "trailing" in options ? !!options.trailing : trailing;
    }
    return (0, $2b9c0da2d9bf5406$export$2e2bcd8739ae039)(func, wait, {
        "leading": leading,
        "maxWait": wait,
        "trailing": trailing
    });
}
var $211888181db1e468$export$2e2bcd8739ae039 = $211888181db1e468$var$throttle;


var $edcb1c484a45f947$export$a056a977bf6a9a3c = function calculateChange(e, hsl, container) {
    var _container$getBoundin = container.getBoundingClientRect(), containerWidth = _container$getBoundin.width, containerHeight = _container$getBoundin.height;
    var x = typeof e.pageX === "number" ? e.pageX : e.touches[0].pageX;
    var y = typeof e.pageY === "number" ? e.pageY : e.touches[0].pageY;
    var left = x - (container.getBoundingClientRect().left + window.pageXOffset);
    var top = y - (container.getBoundingClientRect().top + window.pageYOffset);
    if (left < 0) left = 0;
    else if (left > containerWidth) left = containerWidth;
    if (top < 0) top = 0;
    else if (top > containerHeight) top = containerHeight;
    var saturation = left / containerWidth;
    var bright = 1 - top / containerHeight;
    return {
        h: hsl.h,
        s: saturation,
        v: bright,
        a: hsl.a,
        source: "hsv"
    };
};


var $5a5024834f3556d9$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();
function $5a5024834f3556d9$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $5a5024834f3556d9$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $5a5024834f3556d9$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var $5a5024834f3556d9$export$c4dbe12ffaee3c8e = function(_ref) {
    $5a5024834f3556d9$var$_inherits(Saturation, _ref);
    function Saturation(props) {
        $5a5024834f3556d9$var$_classCallCheck(this, Saturation);
        var _this = $5a5024834f3556d9$var$_possibleConstructorReturn(this, (Saturation.__proto__ || Object.getPrototypeOf(Saturation)).call(this, props));
        _this.handleChange = function(e) {
            typeof _this.props.onChange === "function" && _this.throttle(_this.props.onChange, $edcb1c484a45f947$export$a056a977bf6a9a3c(e, _this.props.hsl, _this.container), e);
        };
        _this.handleMouseDown = function(e) {
            _this.handleChange(e);
            var renderWindow = _this.getContainerRenderWindow();
            renderWindow.addEventListener("mousemove", _this.handleChange);
            renderWindow.addEventListener("mouseup", _this.handleMouseUp);
        };
        _this.handleMouseUp = function() {
            _this.unbindEventListeners();
        };
        _this.throttle = (0, $211888181db1e468$export$2e2bcd8739ae039)(function(fn, data, e) {
            fn(data, e);
        }, 50);
        return _this;
    }
    $5a5024834f3556d9$var$_createClass(Saturation, [
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                this.throttle.cancel();
                this.unbindEventListeners();
            }
        },
        {
            key: "getContainerRenderWindow",
            value: function getContainerRenderWindow() {
                var container = this.container;
                var renderWindow = window;
                while(!renderWindow.document.contains(container) && renderWindow.parent !== renderWindow)renderWindow = renderWindow.parent;
                return renderWindow;
            }
        },
        {
            key: "unbindEventListeners",
            value: function unbindEventListeners() {
                var renderWindow = this.getContainerRenderWindow();
                renderWindow.removeEventListener("mousemove", this.handleChange);
                renderWindow.removeEventListener("mouseup", this.handleMouseUp);
            }
        },
        {
            key: "render",
            value: function render() {
                var _this2 = this;
                var _ref2 = this.props.style || {}, color = _ref2.color, white = _ref2.white, black = _ref2.black, pointer = _ref2.pointer, circle = _ref2.circle;
                var styles = (0, (/*@__PURE__*/$parcel$interopDefault($1e6d325bf7ec7d53$exports)))({
                    "default": {
                        color: {
                            absolute: "0px 0px 0px 0px",
                            background: "hsl(" + this.props.hsl.h + ",100%, 50%)",
                            borderRadius: this.props.radius
                        },
                        white: {
                            absolute: "0px 0px 0px 0px",
                            borderRadius: this.props.radius
                        },
                        black: {
                            absolute: "0px 0px 0px 0px",
                            boxShadow: this.props.shadow,
                            borderRadius: this.props.radius
                        },
                        pointer: {
                            position: "absolute",
                            top: -(this.props.hsv.v * 100) + 100 + "%",
                            left: this.props.hsv.s * 100 + "%",
                            cursor: "default"
                        },
                        circle: {
                            width: "4px",
                            height: "4px",
                            boxShadow: "0 0 0 1.5px #fff, inset 0 0 1px 1px rgba(0,0,0,.3),\n            0 0 1px 2px rgba(0,0,0,.4)",
                            borderRadius: "50%",
                            cursor: "hand",
                            transform: "translate(-2px, -2px)"
                        }
                    },
                    "custom": {
                        color: color,
                        white: white,
                        black: black,
                        pointer: pointer,
                        circle: circle
                    }
                }, {
                    "custom": !!this.props.style
                });
                return (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("div", {
                    style: styles.color,
                    ref: function ref(container) {
                        return _this2.container = container;
                    },
                    onMouseDown: this.handleMouseDown,
                    onTouchMove: this.handleChange,
                    onTouchStart: this.handleChange
                }, (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("style", null, "\n          .saturation-white {\n            background: -webkit-linear-gradient(to right, #fff, rgba(255,255,255,0));\n            background: linear-gradient(to right, #fff, rgba(255,255,255,0));\n          }\n          .saturation-black {\n            background: -webkit-linear-gradient(to top, #000, rgba(0,0,0,0));\n            background: linear-gradient(to top, #000, rgba(0,0,0,0));\n          }\n        "), (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("div", {
                    style: styles.white,
                    className: "saturation-white"
                }, (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("div", {
                    style: styles.black,
                    className: "saturation-black"
                }), (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("div", {
                    style: styles.pointer
                }, this.props.pointer ? (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement(this.props.pointer, this.props) : (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("div", {
                    style: styles.circle
                }))));
            }
        }
    ]);
    return Saturation;
}((0, $bh6RR.PureComponent) || (0, $bh6RR.Component));
var $5a5024834f3556d9$export$2e2bcd8739ae039 = $5a5024834f3556d9$export$c4dbe12ffaee3c8e;



var $bh6RR = parcelRequire("bh6RR");

/**
 * A specialized version of `_.forEach` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns `array`.
 */ function $4e665cc54a815f7f$var$arrayEach(array, iteratee) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        if (iteratee(array[index], index, array) === false) break;
    }
    return array;
}
var $4e665cc54a815f7f$export$2e2bcd8739ae039 = $4e665cc54a815f7f$var$arrayEach;






/* Built-in method references for those with the same name as other `lodash` methods. */ var $31084c80262f0678$var$nativeKeys = (0, $4a2da63f82711215$export$2e2bcd8739ae039)(Object.keys, Object);
var $31084c80262f0678$export$2e2bcd8739ae039 = $31084c80262f0678$var$nativeKeys;


/** Used for built-in method references. */ var $7322177d0c9e5ec1$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $7322177d0c9e5ec1$var$hasOwnProperty = $7322177d0c9e5ec1$var$objectProto.hasOwnProperty;
/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function $7322177d0c9e5ec1$var$baseKeys(object) {
    if (!(0, $61838f3cfb255cdf$export$2e2bcd8739ae039)(object)) return (0, $31084c80262f0678$export$2e2bcd8739ae039)(object);
    var result = [];
    for(var key in Object(object))if ($7322177d0c9e5ec1$var$hasOwnProperty.call(object, key) && key != "constructor") result.push(key);
    return result;
}
var $7322177d0c9e5ec1$export$2e2bcd8739ae039 = $7322177d0c9e5ec1$var$baseKeys;



/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */ function $0a7e60e3e1b696d0$var$keys(object) {
    return (0, $1f3895d15a1c09ab$export$2e2bcd8739ae039)(object) ? (0, $de432e29eceb0e20$export$2e2bcd8739ae039)(object) : (0, $7322177d0c9e5ec1$export$2e2bcd8739ae039)(object);
}
var $0a7e60e3e1b696d0$export$2e2bcd8739ae039 = $0a7e60e3e1b696d0$var$keys;


/**
 * The base implementation of `_.forOwn` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Object} Returns `object`.
 */ function $b94b4edfe9f93786$var$baseForOwn(object, iteratee) {
    return object && (0, $746ef0174671518f$export$2e2bcd8739ae039)(object, iteratee, (0, $0a7e60e3e1b696d0$export$2e2bcd8739ae039));
}
var $b94b4edfe9f93786$export$2e2bcd8739ae039 = $b94b4edfe9f93786$var$baseForOwn;



/**
 * Creates a `baseEach` or `baseEachRight` function.
 *
 * @private
 * @param {Function} eachFunc The function to iterate over a collection.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */ function $fec5b3f76351e628$var$createBaseEach(eachFunc, fromRight) {
    return function(collection, iteratee) {
        if (collection == null) return collection;
        if (!(0, $1f3895d15a1c09ab$export$2e2bcd8739ae039)(collection)) return eachFunc(collection, iteratee);
        var length = collection.length, index = fromRight ? length : -1, iterable = Object(collection);
        while(fromRight ? index-- : ++index < length){
            if (iteratee(iterable[index], index, iterable) === false) break;
        }
        return collection;
    };
}
var $fec5b3f76351e628$export$2e2bcd8739ae039 = $fec5b3f76351e628$var$createBaseEach;


/**
 * The base implementation of `_.forEach` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array|Object} Returns `collection`.
 */ var $400e71aec81f5fd3$var$baseEach = (0, $fec5b3f76351e628$export$2e2bcd8739ae039)((0, $b94b4edfe9f93786$export$2e2bcd8739ae039));
var $400e71aec81f5fd3$export$2e2bcd8739ae039 = $400e71aec81f5fd3$var$baseEach;



/**
 * Casts `value` to `identity` if it's not a function.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {Function} Returns cast function.
 */ function $4364191aee91c15d$var$castFunction(value) {
    return typeof value == "function" ? value : (0, $6ee142fec3d715f9$export$2e2bcd8739ae039);
}
var $4364191aee91c15d$export$2e2bcd8739ae039 = $4364191aee91c15d$var$castFunction;



/**
 * Iterates over elements of `collection` and invokes `iteratee` for each element.
 * The iteratee is invoked with three arguments: (value, index|key, collection).
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * **Note:** As with other "Collections" methods, objects with a "length"
 * property are iterated like arrays. To avoid this behavior use `_.forIn`
 * or `_.forOwn` for object iteration.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @alias each
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Array|Object} Returns `collection`.
 * @see _.forEachRight
 * @example
 *
 * _.forEach([1, 2], function(value) {
 *   console.log(value);
 * });
 * // => Logs `1` then `2`.
 *
 * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
 *   console.log(key);
 * });
 * // => Logs 'a' then 'b' (iteration order is not guaranteed).
 */ function $beea4689053d6910$var$forEach(collection, iteratee) {
    var func = (0, $98f8e0b2d1df3aed$export$2e2bcd8739ae039)(collection) ? (0, $4e665cc54a815f7f$export$2e2bcd8739ae039) : (0, $400e71aec81f5fd3$export$2e2bcd8739ae039);
    return func(collection, (0, $4364191aee91c15d$export$2e2bcd8739ae039)(iteratee));
}
var $beea4689053d6910$export$2e2bcd8739ae039 = $beea4689053d6910$var$forEach;


var $08cb74b27c7efbe3$exports = {};
// This file is autogenerated. It's used to publish CJS to npm.
(function(global, factory) {
    $08cb74b27c7efbe3$exports = factory();
})($08cb74b27c7efbe3$exports, function() {
    "use strict";
    function _typeof(obj) {
        "@babel/helpers - typeof";
        return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
            return typeof obj;
        } : function(obj) {
            return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
        }, _typeof(obj);
    }
    // https://github.com/bgrins/TinyColor
    // Brian Grinstead, MIT License
    var trimLeft = /^\s+/;
    var trimRight = /\s+$/;
    function tinycolor(color, opts) {
        color = color ? color : "";
        opts = opts || {};
        // If input is already a tinycolor, return itself
        if (color instanceof tinycolor) return color;
        // If we are called as a function, call using new instead
        if (!(this instanceof tinycolor)) return new tinycolor(color, opts);
        var rgb = inputToRGB(color);
        this._originalInput = color, this._r = rgb.r, this._g = rgb.g, this._b = rgb.b, this._a = rgb.a, this._roundA = Math.round(100 * this._a) / 100, this._format = opts.format || rgb.format;
        this._gradientType = opts.gradientType;
        // Don't let the range of [0,255] come back in [0,1].
        // Potentially lose a little bit of precision here, but will fix issues where
        // .5 gets interpreted as half of the total, instead of half of 1
        // If it was supposed to be 128, this was already taken care of by `inputToRgb`
        if (this._r < 1) this._r = Math.round(this._r);
        if (this._g < 1) this._g = Math.round(this._g);
        if (this._b < 1) this._b = Math.round(this._b);
        this._ok = rgb.ok;
    }
    tinycolor.prototype = {
        isDark: function isDark() {
            return this.getBrightness() < 128;
        },
        isLight: function isLight() {
            return !this.isDark();
        },
        isValid: function isValid() {
            return this._ok;
        },
        getOriginalInput: function getOriginalInput() {
            return this._originalInput;
        },
        getFormat: function getFormat() {
            return this._format;
        },
        getAlpha: function getAlpha() {
            return this._a;
        },
        getBrightness: function getBrightness() {
            //http://www.w3.org/TR/AERT#color-contrast
            var rgb = this.toRgb();
            return (rgb.r * 299 + rgb.g * 587 + rgb.b * 114) / 1000;
        },
        getLuminance: function getLuminance() {
            //http://www.w3.org/TR/2008/REC-WCAG20-20081211/#relativeluminancedef
            var rgb = this.toRgb();
            var RsRGB, GsRGB, BsRGB, R, G, B;
            RsRGB = rgb.r / 255;
            GsRGB = rgb.g / 255;
            BsRGB = rgb.b / 255;
            if (RsRGB <= 0.03928) R = RsRGB / 12.92;
            else R = Math.pow((RsRGB + 0.055) / 1.055, 2.4);
            if (GsRGB <= 0.03928) G = GsRGB / 12.92;
            else G = Math.pow((GsRGB + 0.055) / 1.055, 2.4);
            if (BsRGB <= 0.03928) B = BsRGB / 12.92;
            else B = Math.pow((BsRGB + 0.055) / 1.055, 2.4);
            return 0.2126 * R + 0.7152 * G + 0.0722 * B;
        },
        setAlpha: function setAlpha(value) {
            this._a = boundAlpha(value);
            this._roundA = Math.round(100 * this._a) / 100;
            return this;
        },
        toHsv: function toHsv() {
            var hsv = rgbToHsv(this._r, this._g, this._b);
            return {
                h: hsv.h * 360,
                s: hsv.s,
                v: hsv.v,
                a: this._a
            };
        },
        toHsvString: function toHsvString() {
            var hsv = rgbToHsv(this._r, this._g, this._b);
            var h = Math.round(hsv.h * 360), s = Math.round(hsv.s * 100), v = Math.round(hsv.v * 100);
            return this._a == 1 ? "hsv(" + h + ", " + s + "%, " + v + "%)" : "hsva(" + h + ", " + s + "%, " + v + "%, " + this._roundA + ")";
        },
        toHsl: function toHsl() {
            var hsl = rgbToHsl(this._r, this._g, this._b);
            return {
                h: hsl.h * 360,
                s: hsl.s,
                l: hsl.l,
                a: this._a
            };
        },
        toHslString: function toHslString() {
            var hsl = rgbToHsl(this._r, this._g, this._b);
            var h = Math.round(hsl.h * 360), s = Math.round(hsl.s * 100), l = Math.round(hsl.l * 100);
            return this._a == 1 ? "hsl(" + h + ", " + s + "%, " + l + "%)" : "hsla(" + h + ", " + s + "%, " + l + "%, " + this._roundA + ")";
        },
        toHex: function toHex(allow3Char) {
            return rgbToHex(this._r, this._g, this._b, allow3Char);
        },
        toHexString: function toHexString(allow3Char) {
            return "#" + this.toHex(allow3Char);
        },
        toHex8: function toHex8(allow4Char) {
            return rgbaToHex(this._r, this._g, this._b, this._a, allow4Char);
        },
        toHex8String: function toHex8String(allow4Char) {
            return "#" + this.toHex8(allow4Char);
        },
        toRgb: function toRgb() {
            return {
                r: Math.round(this._r),
                g: Math.round(this._g),
                b: Math.round(this._b),
                a: this._a
            };
        },
        toRgbString: function toRgbString() {
            return this._a == 1 ? "rgb(" + Math.round(this._r) + ", " + Math.round(this._g) + ", " + Math.round(this._b) + ")" : "rgba(" + Math.round(this._r) + ", " + Math.round(this._g) + ", " + Math.round(this._b) + ", " + this._roundA + ")";
        },
        toPercentageRgb: function toPercentageRgb() {
            return {
                r: Math.round(bound01(this._r, 255) * 100) + "%",
                g: Math.round(bound01(this._g, 255) * 100) + "%",
                b: Math.round(bound01(this._b, 255) * 100) + "%",
                a: this._a
            };
        },
        toPercentageRgbString: function toPercentageRgbString() {
            return this._a == 1 ? "rgb(" + Math.round(bound01(this._r, 255) * 100) + "%, " + Math.round(bound01(this._g, 255) * 100) + "%, " + Math.round(bound01(this._b, 255) * 100) + "%)" : "rgba(" + Math.round(bound01(this._r, 255) * 100) + "%, " + Math.round(bound01(this._g, 255) * 100) + "%, " + Math.round(bound01(this._b, 255) * 100) + "%, " + this._roundA + ")";
        },
        toName: function toName() {
            if (this._a === 0) return "transparent";
            if (this._a < 1) return false;
            return hexNames[rgbToHex(this._r, this._g, this._b, true)] || false;
        },
        toFilter: function toFilter(secondColor) {
            var hex8String = "#" + rgbaToArgbHex(this._r, this._g, this._b, this._a);
            var secondHex8String = hex8String;
            var gradientType = this._gradientType ? "GradientType = 1, " : "";
            if (secondColor) {
                var s = tinycolor(secondColor);
                secondHex8String = "#" + rgbaToArgbHex(s._r, s._g, s._b, s._a);
            }
            return "progid:DXImageTransform.Microsoft.gradient(" + gradientType + "startColorstr=" + hex8String + ",endColorstr=" + secondHex8String + ")";
        },
        toString: function toString(format) {
            var formatSet = !!format;
            format = format || this._format;
            var formattedString = false;
            var hasAlpha = this._a < 1 && this._a >= 0;
            var needsAlphaFormat = !formatSet && hasAlpha && (format === "hex" || format === "hex6" || format === "hex3" || format === "hex4" || format === "hex8" || format === "name");
            if (needsAlphaFormat) {
                // Special case for "transparent", all other non-alpha formats
                // will return rgba when there is transparency.
                if (format === "name" && this._a === 0) return this.toName();
                return this.toRgbString();
            }
            if (format === "rgb") formattedString = this.toRgbString();
            if (format === "prgb") formattedString = this.toPercentageRgbString();
            if (format === "hex" || format === "hex6") formattedString = this.toHexString();
            if (format === "hex3") formattedString = this.toHexString(true);
            if (format === "hex4") formattedString = this.toHex8String(true);
            if (format === "hex8") formattedString = this.toHex8String();
            if (format === "name") formattedString = this.toName();
            if (format === "hsl") formattedString = this.toHslString();
            if (format === "hsv") formattedString = this.toHsvString();
            return formattedString || this.toHexString();
        },
        clone: function clone() {
            return tinycolor(this.toString());
        },
        _applyModification: function _applyModification(fn, args) {
            var color = fn.apply(null, [
                this
            ].concat([].slice.call(args)));
            this._r = color._r;
            this._g = color._g;
            this._b = color._b;
            this.setAlpha(color._a);
            return this;
        },
        lighten: function lighten() {
            return this._applyModification(_lighten, arguments);
        },
        brighten: function brighten() {
            return this._applyModification(_brighten, arguments);
        },
        darken: function darken() {
            return this._applyModification(_darken, arguments);
        },
        desaturate: function desaturate() {
            return this._applyModification(_desaturate, arguments);
        },
        saturate: function saturate() {
            return this._applyModification(_saturate, arguments);
        },
        greyscale: function greyscale() {
            return this._applyModification(_greyscale, arguments);
        },
        spin: function spin() {
            return this._applyModification(_spin, arguments);
        },
        _applyCombination: function _applyCombination(fn, args) {
            return fn.apply(null, [
                this
            ].concat([].slice.call(args)));
        },
        analogous: function analogous() {
            return this._applyCombination(_analogous, arguments);
        },
        complement: function complement() {
            return this._applyCombination(_complement, arguments);
        },
        monochromatic: function monochromatic() {
            return this._applyCombination(_monochromatic, arguments);
        },
        splitcomplement: function splitcomplement() {
            return this._applyCombination(_splitcomplement, arguments);
        },
        // Disabled until https://github.com/bgrins/TinyColor/issues/254
        // polyad: function (number) {
        //   return this._applyCombination(polyad, [number]);
        // },
        triad: function triad() {
            return this._applyCombination(polyad, [
                3
            ]);
        },
        tetrad: function tetrad() {
            return this._applyCombination(polyad, [
                4
            ]);
        }
    };
    // If input is an object, force 1 into "1.0" to handle ratios properly
    // String input requires "1.0" as input, so 1 will be treated as 1
    tinycolor.fromRatio = function(color, opts) {
        if (_typeof(color) == "object") {
            var newColor = {};
            for(var i in color)if (color.hasOwnProperty(i)) {
                if (i === "a") newColor[i] = color[i];
                else newColor[i] = convertToPercentage(color[i]);
            }
            color = newColor;
        }
        return tinycolor(color, opts);
    };
    // Given a string or object, convert that input to RGB
    // Possible string inputs:
    //
    //     "red"
    //     "#f00" or "f00"
    //     "#ff0000" or "ff0000"
    //     "#ff000000" or "ff000000"
    //     "rgb 255 0 0" or "rgb (255, 0, 0)"
    //     "rgb 1.0 0 0" or "rgb (1, 0, 0)"
    //     "rgba (255, 0, 0, 1)" or "rgba 255, 0, 0, 1"
    //     "rgba (1.0, 0, 0, 1)" or "rgba 1.0, 0, 0, 1"
    //     "hsl(0, 100%, 50%)" or "hsl 0 100% 50%"
    //     "hsla(0, 100%, 50%, 1)" or "hsla 0 100% 50%, 1"
    //     "hsv(0, 100%, 100%)" or "hsv 0 100% 100%"
    //
    function inputToRGB(color) {
        var rgb = {
            r: 0,
            g: 0,
            b: 0
        };
        var a = 1;
        var s = null;
        var v = null;
        var l = null;
        var ok = false;
        var format = false;
        if (typeof color == "string") color = stringInputToObject(color);
        if (_typeof(color) == "object") {
            if (isValidCSSUnit(color.r) && isValidCSSUnit(color.g) && isValidCSSUnit(color.b)) {
                rgb = rgbToRgb(color.r, color.g, color.b);
                ok = true;
                format = String(color.r).substr(-1) === "%" ? "prgb" : "rgb";
            } else if (isValidCSSUnit(color.h) && isValidCSSUnit(color.s) && isValidCSSUnit(color.v)) {
                s = convertToPercentage(color.s);
                v = convertToPercentage(color.v);
                rgb = hsvToRgb(color.h, s, v);
                ok = true;
                format = "hsv";
            } else if (isValidCSSUnit(color.h) && isValidCSSUnit(color.s) && isValidCSSUnit(color.l)) {
                s = convertToPercentage(color.s);
                l = convertToPercentage(color.l);
                rgb = hslToRgb(color.h, s, l);
                ok = true;
                format = "hsl";
            }
            if (color.hasOwnProperty("a")) a = color.a;
        }
        a = boundAlpha(a);
        return {
            ok: ok,
            format: color.format || format,
            r: Math.min(255, Math.max(rgb.r, 0)),
            g: Math.min(255, Math.max(rgb.g, 0)),
            b: Math.min(255, Math.max(rgb.b, 0)),
            a: a
        };
    }
    // Conversion Functions
    // --------------------
    // `rgbToHsl`, `rgbToHsv`, `hslToRgb`, `hsvToRgb` modified from:
    // <http://mjijackson.com/2008/02/rgb-to-hsl-and-rgb-to-hsv-color-model-conversion-algorithms-in-javascript>
    // `rgbToRgb`
    // Handle bounds / percentage checking to conform to CSS color spec
    // <http://www.w3.org/TR/css3-color/>
    // *Assumes:* r, g, b in [0, 255] or [0, 1]
    // *Returns:* { r, g, b } in [0, 255]
    function rgbToRgb(r, g, b) {
        return {
            r: bound01(r, 255) * 255,
            g: bound01(g, 255) * 255,
            b: bound01(b, 255) * 255
        };
    }
    // `rgbToHsl`
    // Converts an RGB color value to HSL.
    // *Assumes:* r, g, and b are contained in [0, 255] or [0, 1]
    // *Returns:* { h, s, l } in [0,1]
    function rgbToHsl(r, g, b) {
        r = bound01(r, 255);
        g = bound01(g, 255);
        b = bound01(b, 255);
        var max = Math.max(r, g, b), min = Math.min(r, g, b);
        var h, s, l = (max + min) / 2;
        if (max == min) h = s = 0; // achromatic
        else {
            var d = max - min;
            s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
            switch(max){
                case r:
                    h = (g - b) / d + (g < b ? 6 : 0);
                    break;
                case g:
                    h = (b - r) / d + 2;
                    break;
                case b:
                    h = (r - g) / d + 4;
                    break;
            }
            h /= 6;
        }
        return {
            h: h,
            s: s,
            l: l
        };
    }
    // `hslToRgb`
    // Converts an HSL color value to RGB.
    // *Assumes:* h is contained in [0, 1] or [0, 360] and s and l are contained [0, 1] or [0, 100]
    // *Returns:* { r, g, b } in the set [0, 255]
    function hslToRgb(h, s, l) {
        var r, g, b;
        h = bound01(h, 360);
        s = bound01(s, 100);
        l = bound01(l, 100);
        function hue2rgb(p, q, t) {
            if (t < 0) t += 1;
            if (t > 1) t -= 1;
            if (t < 1 / 6) return p + (q - p) * 6 * t;
            if (t < 0.5) return q;
            if (t < 2 / 3) return p + (q - p) * (2 / 3 - t) * 6;
            return p;
        }
        if (s === 0) r = g = b = l; // achromatic
        else {
            var q = l < 0.5 ? l * (1 + s) : l + s - l * s;
            var p = 2 * l - q;
            r = hue2rgb(p, q, h + 1 / 3);
            g = hue2rgb(p, q, h);
            b = hue2rgb(p, q, h - 1 / 3);
        }
        return {
            r: r * 255,
            g: g * 255,
            b: b * 255
        };
    }
    // `rgbToHsv`
    // Converts an RGB color value to HSV
    // *Assumes:* r, g, and b are contained in the set [0, 255] or [0, 1]
    // *Returns:* { h, s, v } in [0,1]
    function rgbToHsv(r, g, b) {
        r = bound01(r, 255);
        g = bound01(g, 255);
        b = bound01(b, 255);
        var max = Math.max(r, g, b), min = Math.min(r, g, b);
        var h, s, v = max;
        var d = max - min;
        s = max === 0 ? 0 : d / max;
        if (max == min) h = 0; // achromatic
        else {
            switch(max){
                case r:
                    h = (g - b) / d + (g < b ? 6 : 0);
                    break;
                case g:
                    h = (b - r) / d + 2;
                    break;
                case b:
                    h = (r - g) / d + 4;
                    break;
            }
            h /= 6;
        }
        return {
            h: h,
            s: s,
            v: v
        };
    }
    // `hsvToRgb`
    // Converts an HSV color value to RGB.
    // *Assumes:* h is contained in [0, 1] or [0, 360] and s and v are contained in [0, 1] or [0, 100]
    // *Returns:* { r, g, b } in the set [0, 255]
    function hsvToRgb(h, s, v) {
        h = bound01(h, 360) * 6;
        s = bound01(s, 100);
        v = bound01(v, 100);
        var i = Math.floor(h), f = h - i, p = v * (1 - s), q = v * (1 - f * s), t = v * (1 - (1 - f) * s), mod = i % 6, r = [
            v,
            q,
            p,
            p,
            t,
            v
        ][mod], g = [
            t,
            v,
            v,
            q,
            p,
            p
        ][mod], b = [
            p,
            p,
            t,
            v,
            v,
            q
        ][mod];
        return {
            r: r * 255,
            g: g * 255,
            b: b * 255
        };
    }
    // `rgbToHex`
    // Converts an RGB color to hex
    // Assumes r, g, and b are contained in the set [0, 255]
    // Returns a 3 or 6 character hex
    function rgbToHex(r, g, b, allow3Char) {
        var hex = [
            pad2(Math.round(r).toString(16)),
            pad2(Math.round(g).toString(16)),
            pad2(Math.round(b).toString(16))
        ];
        // Return a 3 character hex if possible
        if (allow3Char && hex[0].charAt(0) == hex[0].charAt(1) && hex[1].charAt(0) == hex[1].charAt(1) && hex[2].charAt(0) == hex[2].charAt(1)) return hex[0].charAt(0) + hex[1].charAt(0) + hex[2].charAt(0);
        return hex.join("");
    }
    // `rgbaToHex`
    // Converts an RGBA color plus alpha transparency to hex
    // Assumes r, g, b are contained in the set [0, 255] and
    // a in [0, 1]. Returns a 4 or 8 character rgba hex
    function rgbaToHex(r, g, b, a, allow4Char) {
        var hex = [
            pad2(Math.round(r).toString(16)),
            pad2(Math.round(g).toString(16)),
            pad2(Math.round(b).toString(16)),
            pad2(convertDecimalToHex(a))
        ];
        // Return a 4 character hex if possible
        if (allow4Char && hex[0].charAt(0) == hex[0].charAt(1) && hex[1].charAt(0) == hex[1].charAt(1) && hex[2].charAt(0) == hex[2].charAt(1) && hex[3].charAt(0) == hex[3].charAt(1)) return hex[0].charAt(0) + hex[1].charAt(0) + hex[2].charAt(0) + hex[3].charAt(0);
        return hex.join("");
    }
    // `rgbaToArgbHex`
    // Converts an RGBA color to an ARGB Hex8 string
    // Rarely used, but required for "toFilter()"
    function rgbaToArgbHex(r, g, b, a) {
        var hex = [
            pad2(convertDecimalToHex(a)),
            pad2(Math.round(r).toString(16)),
            pad2(Math.round(g).toString(16)),
            pad2(Math.round(b).toString(16))
        ];
        return hex.join("");
    }
    // `equals`
    // Can be called with any tinycolor input
    tinycolor.equals = function(color1, color2) {
        if (!color1 || !color2) return false;
        return tinycolor(color1).toRgbString() == tinycolor(color2).toRgbString();
    };
    tinycolor.random = function() {
        return tinycolor.fromRatio({
            r: Math.random(),
            g: Math.random(),
            b: Math.random()
        });
    };
    // Modification Functions
    // ----------------------
    // Thanks to less.js for some of the basics here
    // <https://github.com/cloudhead/less.js/blob/master/lib/less/functions.js>
    function _desaturate(color, amount) {
        amount = amount === 0 ? 0 : amount || 10;
        var hsl = tinycolor(color).toHsl();
        hsl.s -= amount / 100;
        hsl.s = clamp01(hsl.s);
        return tinycolor(hsl);
    }
    function _saturate(color, amount) {
        amount = amount === 0 ? 0 : amount || 10;
        var hsl = tinycolor(color).toHsl();
        hsl.s += amount / 100;
        hsl.s = clamp01(hsl.s);
        return tinycolor(hsl);
    }
    function _greyscale(color) {
        return tinycolor(color).desaturate(100);
    }
    function _lighten(color, amount) {
        amount = amount === 0 ? 0 : amount || 10;
        var hsl = tinycolor(color).toHsl();
        hsl.l += amount / 100;
        hsl.l = clamp01(hsl.l);
        return tinycolor(hsl);
    }
    function _brighten(color, amount) {
        amount = amount === 0 ? 0 : amount || 10;
        var rgb = tinycolor(color).toRgb();
        rgb.r = Math.max(0, Math.min(255, rgb.r - Math.round(255 * -(amount / 100))));
        rgb.g = Math.max(0, Math.min(255, rgb.g - Math.round(255 * -(amount / 100))));
        rgb.b = Math.max(0, Math.min(255, rgb.b - Math.round(255 * -(amount / 100))));
        return tinycolor(rgb);
    }
    function _darken(color, amount) {
        amount = amount === 0 ? 0 : amount || 10;
        var hsl = tinycolor(color).toHsl();
        hsl.l -= amount / 100;
        hsl.l = clamp01(hsl.l);
        return tinycolor(hsl);
    }
    // Spin takes a positive or negative amount within [-360, 360] indicating the change of hue.
    // Values outside of this range will be wrapped into this range.
    function _spin(color, amount) {
        var hsl = tinycolor(color).toHsl();
        var hue = (hsl.h + amount) % 360;
        hsl.h = hue < 0 ? 360 + hue : hue;
        return tinycolor(hsl);
    }
    // Combination Functions
    // ---------------------
    // Thanks to jQuery xColor for some of the ideas behind these
    // <https://github.com/infusion/jQuery-xcolor/blob/master/jquery.xcolor.js>
    function _complement(color) {
        var hsl = tinycolor(color).toHsl();
        hsl.h = (hsl.h + 180) % 360;
        return tinycolor(hsl);
    }
    function polyad(color, number) {
        if (isNaN(number) || number <= 0) throw new Error("Argument to polyad must be a positive number");
        var hsl = tinycolor(color).toHsl();
        var result = [
            tinycolor(color)
        ];
        var step = 360 / number;
        for(var i = 1; i < number; i++)result.push(tinycolor({
            h: (hsl.h + i * step) % 360,
            s: hsl.s,
            l: hsl.l
        }));
        return result;
    }
    function _splitcomplement(color) {
        var hsl = tinycolor(color).toHsl();
        var h = hsl.h;
        return [
            tinycolor(color),
            tinycolor({
                h: (h + 72) % 360,
                s: hsl.s,
                l: hsl.l
            }),
            tinycolor({
                h: (h + 216) % 360,
                s: hsl.s,
                l: hsl.l
            })
        ];
    }
    function _analogous(color, results, slices) {
        results = results || 6;
        slices = slices || 30;
        var hsl = tinycolor(color).toHsl();
        var part = 360 / slices;
        var ret = [
            tinycolor(color)
        ];
        for(hsl.h = (hsl.h - (part * results >> 1) + 720) % 360; --results;){
            hsl.h = (hsl.h + part) % 360;
            ret.push(tinycolor(hsl));
        }
        return ret;
    }
    function _monochromatic(color, results) {
        results = results || 6;
        var hsv = tinycolor(color).toHsv();
        var h = hsv.h, s = hsv.s, v = hsv.v;
        var ret = [];
        var modification = 1 / results;
        while(results--){
            ret.push(tinycolor({
                h: h,
                s: s,
                v: v
            }));
            v = (v + modification) % 1;
        }
        return ret;
    }
    // Utility Functions
    // ---------------------
    tinycolor.mix = function(color1, color2, amount) {
        amount = amount === 0 ? 0 : amount || 50;
        var rgb1 = tinycolor(color1).toRgb();
        var rgb2 = tinycolor(color2).toRgb();
        var p = amount / 100;
        var rgba = {
            r: (rgb2.r - rgb1.r) * p + rgb1.r,
            g: (rgb2.g - rgb1.g) * p + rgb1.g,
            b: (rgb2.b - rgb1.b) * p + rgb1.b,
            a: (rgb2.a - rgb1.a) * p + rgb1.a
        };
        return tinycolor(rgba);
    };
    // Readability Functions
    // ---------------------
    // <http://www.w3.org/TR/2008/REC-WCAG20-20081211/#contrast-ratiodef (WCAG Version 2)
    // `contrast`
    // Analyze the 2 colors and returns the color contrast defined by (WCAG Version 2)
    tinycolor.readability = function(color1, color2) {
        var c1 = tinycolor(color1);
        var c2 = tinycolor(color2);
        return (Math.max(c1.getLuminance(), c2.getLuminance()) + 0.05) / (Math.min(c1.getLuminance(), c2.getLuminance()) + 0.05);
    };
    // `isReadable`
    // Ensure that foreground and background color combinations meet WCAG2 guidelines.
    // The third argument is an optional Object.
    //      the 'level' property states 'AA' or 'AAA' - if missing or invalid, it defaults to 'AA';
    //      the 'size' property states 'large' or 'small' - if missing or invalid, it defaults to 'small'.
    // If the entire object is absent, isReadable defaults to {level:"AA",size:"small"}.
    // *Example*
    //    tinycolor.isReadable("#000", "#111") => false
    //    tinycolor.isReadable("#000", "#111",{level:"AA",size:"large"}) => false
    tinycolor.isReadable = function(color1, color2, wcag2) {
        var readability = tinycolor.readability(color1, color2);
        var wcag2Parms, out;
        out = false;
        wcag2Parms = validateWCAG2Parms(wcag2);
        switch(wcag2Parms.level + wcag2Parms.size){
            case "AAsmall":
            case "AAAlarge":
                out = readability >= 4.5;
                break;
            case "AAlarge":
                out = readability >= 3;
                break;
            case "AAAsmall":
                out = readability >= 7;
                break;
        }
        return out;
    };
    // `mostReadable`
    // Given a base color and a list of possible foreground or background
    // colors for that base, returns the most readable color.
    // Optionally returns Black or White if the most readable color is unreadable.
    // *Example*
    //    tinycolor.mostReadable(tinycolor.mostReadable("#123", ["#124", "#125"],{includeFallbackColors:false}).toHexString(); // "#112255"
    //    tinycolor.mostReadable(tinycolor.mostReadable("#123", ["#124", "#125"],{includeFallbackColors:true}).toHexString();  // "#ffffff"
    //    tinycolor.mostReadable("#a8015a", ["#faf3f3"],{includeFallbackColors:true,level:"AAA",size:"large"}).toHexString(); // "#faf3f3"
    //    tinycolor.mostReadable("#a8015a", ["#faf3f3"],{includeFallbackColors:true,level:"AAA",size:"small"}).toHexString(); // "#ffffff"
    tinycolor.mostReadable = function(baseColor, colorList, args) {
        var bestColor = null;
        var bestScore = 0;
        var readability;
        var includeFallbackColors, level, size;
        args = args || {};
        includeFallbackColors = args.includeFallbackColors;
        level = args.level;
        size = args.size;
        for(var i = 0; i < colorList.length; i++){
            readability = tinycolor.readability(baseColor, colorList[i]);
            if (readability > bestScore) {
                bestScore = readability;
                bestColor = tinycolor(colorList[i]);
            }
        }
        if (tinycolor.isReadable(baseColor, bestColor, {
            level: level,
            size: size
        }) || !includeFallbackColors) return bestColor;
        else {
            args.includeFallbackColors = false;
            return tinycolor.mostReadable(baseColor, [
                "#fff",
                "#000"
            ], args);
        }
    };
    // Big List of Colors
    // ------------------
    // <https://www.w3.org/TR/css-color-4/#named-colors>
    var names = tinycolor.names = {
        aliceblue: "f0f8ff",
        antiquewhite: "faebd7",
        aqua: "0ff",
        aquamarine: "7fffd4",
        azure: "f0ffff",
        beige: "f5f5dc",
        bisque: "ffe4c4",
        black: "000",
        blanchedalmond: "ffebcd",
        blue: "00f",
        blueviolet: "8a2be2",
        brown: "a52a2a",
        burlywood: "deb887",
        burntsienna: "ea7e5d",
        cadetblue: "5f9ea0",
        chartreuse: "7fff00",
        chocolate: "d2691e",
        coral: "ff7f50",
        cornflowerblue: "6495ed",
        cornsilk: "fff8dc",
        crimson: "dc143c",
        cyan: "0ff",
        darkblue: "00008b",
        darkcyan: "008b8b",
        darkgoldenrod: "b8860b",
        darkgray: "a9a9a9",
        darkgreen: "006400",
        darkgrey: "a9a9a9",
        darkkhaki: "bdb76b",
        darkmagenta: "8b008b",
        darkolivegreen: "556b2f",
        darkorange: "ff8c00",
        darkorchid: "9932cc",
        darkred: "8b0000",
        darksalmon: "e9967a",
        darkseagreen: "8fbc8f",
        darkslateblue: "483d8b",
        darkslategray: "2f4f4f",
        darkslategrey: "2f4f4f",
        darkturquoise: "00ced1",
        darkviolet: "9400d3",
        deeppink: "ff1493",
        deepskyblue: "00bfff",
        dimgray: "696969",
        dimgrey: "696969",
        dodgerblue: "1e90ff",
        firebrick: "b22222",
        floralwhite: "fffaf0",
        forestgreen: "228b22",
        fuchsia: "f0f",
        gainsboro: "dcdcdc",
        ghostwhite: "f8f8ff",
        gold: "ffd700",
        goldenrod: "daa520",
        gray: "808080",
        green: "008000",
        greenyellow: "adff2f",
        grey: "808080",
        honeydew: "f0fff0",
        hotpink: "ff69b4",
        indianred: "cd5c5c",
        indigo: "4b0082",
        ivory: "fffff0",
        khaki: "f0e68c",
        lavender: "e6e6fa",
        lavenderblush: "fff0f5",
        lawngreen: "7cfc00",
        lemonchiffon: "fffacd",
        lightblue: "add8e6",
        lightcoral: "f08080",
        lightcyan: "e0ffff",
        lightgoldenrodyellow: "fafad2",
        lightgray: "d3d3d3",
        lightgreen: "90ee90",
        lightgrey: "d3d3d3",
        lightpink: "ffb6c1",
        lightsalmon: "ffa07a",
        lightseagreen: "20b2aa",
        lightskyblue: "87cefa",
        lightslategray: "789",
        lightslategrey: "789",
        lightsteelblue: "b0c4de",
        lightyellow: "ffffe0",
        lime: "0f0",
        limegreen: "32cd32",
        linen: "faf0e6",
        magenta: "f0f",
        maroon: "800000",
        mediumaquamarine: "66cdaa",
        mediumblue: "0000cd",
        mediumorchid: "ba55d3",
        mediumpurple: "9370db",
        mediumseagreen: "3cb371",
        mediumslateblue: "7b68ee",
        mediumspringgreen: "00fa9a",
        mediumturquoise: "48d1cc",
        mediumvioletred: "c71585",
        midnightblue: "191970",
        mintcream: "f5fffa",
        mistyrose: "ffe4e1",
        moccasin: "ffe4b5",
        navajowhite: "ffdead",
        navy: "000080",
        oldlace: "fdf5e6",
        olive: "808000",
        olivedrab: "6b8e23",
        orange: "ffa500",
        orangered: "ff4500",
        orchid: "da70d6",
        palegoldenrod: "eee8aa",
        palegreen: "98fb98",
        paleturquoise: "afeeee",
        palevioletred: "db7093",
        papayawhip: "ffefd5",
        peachpuff: "ffdab9",
        peru: "cd853f",
        pink: "ffc0cb",
        plum: "dda0dd",
        powderblue: "b0e0e6",
        purple: "800080",
        rebeccapurple: "663399",
        red: "f00",
        rosybrown: "bc8f8f",
        royalblue: "4169e1",
        saddlebrown: "8b4513",
        salmon: "fa8072",
        sandybrown: "f4a460",
        seagreen: "2e8b57",
        seashell: "fff5ee",
        sienna: "a0522d",
        silver: "c0c0c0",
        skyblue: "87ceeb",
        slateblue: "6a5acd",
        slategray: "708090",
        slategrey: "708090",
        snow: "fffafa",
        springgreen: "00ff7f",
        steelblue: "4682b4",
        tan: "d2b48c",
        teal: "008080",
        thistle: "d8bfd8",
        tomato: "ff6347",
        turquoise: "40e0d0",
        violet: "ee82ee",
        wheat: "f5deb3",
        white: "fff",
        whitesmoke: "f5f5f5",
        yellow: "ff0",
        yellowgreen: "9acd32"
    };
    // Make it easy to access colors via `hexNames[hex]`
    var hexNames = tinycolor.hexNames = flip(names);
    // Utilities
    // ---------
    // `{ 'name1': 'val1' }` becomes `{ 'val1': 'name1' }`
    function flip(o) {
        var flipped = {};
        for(var i in o)if (o.hasOwnProperty(i)) flipped[o[i]] = i;
        return flipped;
    }
    // Return a valid alpha value [0,1] with all invalid values being set to 1
    function boundAlpha(a) {
        a = parseFloat(a);
        if (isNaN(a) || a < 0 || a > 1) a = 1;
        return a;
    }
    // Take input from [0, n] and return it as [0, 1]
    function bound01(n, max) {
        if (isOnePointZero(n)) n = "100%";
        var processPercent = isPercentage(n);
        n = Math.min(max, Math.max(0, parseFloat(n)));
        // Automatically convert percentage into number
        if (processPercent) n = parseInt(n * max, 10) / 100;
        // Handle floating point rounding errors
        if (Math.abs(n - max) < 0.000001) return 1;
        // Convert into [0, 1] range if it isn't already
        return n % max / parseFloat(max);
    }
    // Force a number between 0 and 1
    function clamp01(val) {
        return Math.min(1, Math.max(0, val));
    }
    // Parse a base-16 hex value into a base-10 integer
    function parseIntFromHex(val) {
        return parseInt(val, 16);
    }
    // Need to handle 1.0 as 100%, since once it is a number, there is no difference between it and 1
    // <http://stackoverflow.com/questions/7422072/javascript-how-to-detect-number-as-a-decimal-including-1-0>
    function isOnePointZero(n) {
        return typeof n == "string" && n.indexOf(".") != -1 && parseFloat(n) === 1;
    }
    // Check to see if string passed in is a percentage
    function isPercentage(n) {
        return typeof n === "string" && n.indexOf("%") != -1;
    }
    // Force a hex value to have 2 characters
    function pad2(c) {
        return c.length == 1 ? "0" + c : "" + c;
    }
    // Replace a decimal with it's percentage value
    function convertToPercentage(n) {
        if (n <= 1) n = n * 100 + "%";
        return n;
    }
    // Converts a decimal to a hex value
    function convertDecimalToHex(d) {
        return Math.round(parseFloat(d) * 255).toString(16);
    }
    // Converts a hex value to a decimal
    function convertHexToDecimal(h) {
        return parseIntFromHex(h) / 255;
    }
    var matchers = function() {
        // <http://www.w3.org/TR/css3-values/#integers>
        var CSS_INTEGER = "[-\\+]?\\d+%?";
        // <http://www.w3.org/TR/css3-values/#number-value>
        var CSS_NUMBER = "[-\\+]?\\d*\\.\\d+%?";
        // Allow positive/negative integer/number.  Don't capture the either/or, just the entire outcome.
        var CSS_UNIT = "(?:" + CSS_NUMBER + ")|(?:" + CSS_INTEGER + ")";
        // Actual matching.
        // Parentheses and commas are optional, but not required.
        // Whitespace can take the place of commas or opening paren
        var PERMISSIVE_MATCH3 = "[\\s|\\(]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")\\s*\\)?";
        var PERMISSIVE_MATCH4 = "[\\s|\\(]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")\\s*\\)?";
        return {
            CSS_UNIT: new RegExp(CSS_UNIT),
            rgb: new RegExp("rgb" + PERMISSIVE_MATCH3),
            rgba: new RegExp("rgba" + PERMISSIVE_MATCH4),
            hsl: new RegExp("hsl" + PERMISSIVE_MATCH3),
            hsla: new RegExp("hsla" + PERMISSIVE_MATCH4),
            hsv: new RegExp("hsv" + PERMISSIVE_MATCH3),
            hsva: new RegExp("hsva" + PERMISSIVE_MATCH4),
            hex3: /^#?([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/,
            hex6: /^#?([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})$/,
            hex4: /^#?([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/,
            hex8: /^#?([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})$/
        };
    }();
    // `isValidCSSUnit`
    // Take in a single string / number and check to see if it looks like a CSS unit
    // (see `matchers` above for definition).
    function isValidCSSUnit(color) {
        return !!matchers.CSS_UNIT.exec(color);
    }
    // `stringInputToObject`
    // Permissive string parsing.  Take in a number of formats, and output an object
    // based on detected format.  Returns `{ r, g, b }` or `{ h, s, l }` or `{ h, s, v}`
    function stringInputToObject(color) {
        color = color.replace(trimLeft, "").replace(trimRight, "").toLowerCase();
        var named = false;
        if (names[color]) {
            color = names[color];
            named = true;
        } else if (color == "transparent") return {
            r: 0,
            g: 0,
            b: 0,
            a: 0,
            format: "name"
        };
        // Try to match string input using regular expressions.
        // Keep most of the number bounding out of this function - don't worry about [0,1] or [0,100] or [0,360]
        // Just return an object and let the conversion functions handle that.
        // This way the result will be the same whether the tinycolor is initialized with string or object.
        var match;
        if (match = matchers.rgb.exec(color)) return {
            r: match[1],
            g: match[2],
            b: match[3]
        };
        if (match = matchers.rgba.exec(color)) return {
            r: match[1],
            g: match[2],
            b: match[3],
            a: match[4]
        };
        if (match = matchers.hsl.exec(color)) return {
            h: match[1],
            s: match[2],
            l: match[3]
        };
        if (match = matchers.hsla.exec(color)) return {
            h: match[1],
            s: match[2],
            l: match[3],
            a: match[4]
        };
        if (match = matchers.hsv.exec(color)) return {
            h: match[1],
            s: match[2],
            v: match[3]
        };
        if (match = matchers.hsva.exec(color)) return {
            h: match[1],
            s: match[2],
            v: match[3],
            a: match[4]
        };
        if (match = matchers.hex8.exec(color)) return {
            r: parseIntFromHex(match[1]),
            g: parseIntFromHex(match[2]),
            b: parseIntFromHex(match[3]),
            a: convertHexToDecimal(match[4]),
            format: named ? "name" : "hex8"
        };
        if (match = matchers.hex6.exec(color)) return {
            r: parseIntFromHex(match[1]),
            g: parseIntFromHex(match[2]),
            b: parseIntFromHex(match[3]),
            format: named ? "name" : "hex"
        };
        if (match = matchers.hex4.exec(color)) return {
            r: parseIntFromHex(match[1] + "" + match[1]),
            g: parseIntFromHex(match[2] + "" + match[2]),
            b: parseIntFromHex(match[3] + "" + match[3]),
            a: convertHexToDecimal(match[4] + "" + match[4]),
            format: named ? "name" : "hex8"
        };
        if (match = matchers.hex3.exec(color)) return {
            r: parseIntFromHex(match[1] + "" + match[1]),
            g: parseIntFromHex(match[2] + "" + match[2]),
            b: parseIntFromHex(match[3] + "" + match[3]),
            format: named ? "name" : "hex"
        };
        return false;
    }
    function validateWCAG2Parms(parms) {
        // return valid WCAG2 parms for isReadable.
        // If input parms are invalid, return {"level":"AA", "size":"small"}
        var level, size;
        parms = parms || {
            level: "AA",
            size: "small"
        };
        level = (parms.level || "AA").toUpperCase();
        size = (parms.size || "small").toLowerCase();
        if (level !== "AA" && level !== "AAA") level = "AA";
        if (size !== "small" && size !== "large") size = "small";
        return {
            level: level,
            size: size
        };
    }
    return tinycolor;
});


var $c667524adaf9821a$export$4837207a530c7f21 = function simpleCheckForValidColor(data) {
    var keysToCheck = [
        "r",
        "g",
        "b",
        "a",
        "h",
        "s",
        "l",
        "v"
    ];
    var checked = 0;
    var passed = 0;
    (0, $beea4689053d6910$export$2e2bcd8739ae039)(keysToCheck, function(letter) {
        if (data[letter]) {
            checked += 1;
            if (!isNaN(data[letter])) passed += 1;
            if (letter === "s" || letter === "l") {
                var percentPatt = /^\d+%$/;
                if (percentPatt.test(data[letter])) passed += 1;
            }
        }
    });
    return checked === passed ? data : false;
};
var $c667524adaf9821a$export$6bed283375899438 = function toState(data, oldHue) {
    var color = data.hex ? (0, (/*@__PURE__*/$parcel$interopDefault($08cb74b27c7efbe3$exports)))(data.hex) : (0, (/*@__PURE__*/$parcel$interopDefault($08cb74b27c7efbe3$exports)))(data);
    var hsl = color.toHsl();
    var hsv = color.toHsv();
    var rgb = color.toRgb();
    var hex = color.toHex();
    if (hsl.s === 0) {
        hsl.h = oldHue || 0;
        hsv.h = oldHue || 0;
    }
    var transparent = hex === "000000" && rgb.a === 0;
    return {
        hsl: hsl,
        hex: transparent ? "transparent" : "#" + hex,
        rgb: rgb,
        hsv: hsv,
        oldHue: data.h || oldHue || hsl.h,
        source: data.source
    };
};
var $c667524adaf9821a$export$944f75ec5697b362 = function isValidHex(hex) {
    if (hex === "transparent") return true;
    // disable hex4 and hex8
    var lh = String(hex).charAt(0) === "#" ? 1 : 0;
    return hex.length !== 4 + lh && hex.length < 7 + lh && (0, (/*@__PURE__*/$parcel$interopDefault($08cb74b27c7efbe3$exports)))(hex).isValid();
};
var $c667524adaf9821a$export$3609eb1d7e55dec = function getContrastingColor(data) {
    if (!data) return "#fff";
    var col = $c667524adaf9821a$export$6bed283375899438(data);
    if (col.hex === "transparent") return "rgba(0,0,0,0.4)";
    var yiq = (col.rgb.r * 299 + col.rgb.g * 587 + col.rgb.b * 114) / 1000;
    return yiq >= 128 ? "#000" : "#fff";
};
var $c667524adaf9821a$export$a90204d1394caf30 = {
    hsl: {
        a: 1,
        h: 0,
        l: 0.5,
        s: 1
    },
    hex: "#ff0000",
    rgb: {
        r: 255,
        g: 0,
        b: 0,
        a: 1
    },
    hsv: {
        h: 0,
        s: 1,
        v: 1,
        a: 1
    }
};
var $c667524adaf9821a$export$e76ec4c5b3cadd73 = function isvalidColorString(string, type) {
    var stringWithoutDegree = string.replace("\xb0", "");
    return (0, (/*@__PURE__*/$parcel$interopDefault($08cb74b27c7efbe3$exports)))(type + " (" + stringWithoutDegree + ")")._ok;
};


var $13e2b01d2fc0abc5$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var $13e2b01d2fc0abc5$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();
function $13e2b01d2fc0abc5$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $13e2b01d2fc0abc5$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $13e2b01d2fc0abc5$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var $13e2b01d2fc0abc5$export$68265aef2e61bec7 = function ColorWrap(Picker) {
    var ColorPicker = function(_ref) {
        $13e2b01d2fc0abc5$var$_inherits(ColorPicker, _ref);
        function ColorPicker(props) {
            $13e2b01d2fc0abc5$var$_classCallCheck(this, ColorPicker);
            var _this = $13e2b01d2fc0abc5$var$_possibleConstructorReturn(this, (ColorPicker.__proto__ || Object.getPrototypeOf(ColorPicker)).call(this));
            _this.handleChange = function(data, event) {
                var isValidColor = $c667524adaf9821a$export$4837207a530c7f21(data);
                if (isValidColor) {
                    var colors = $c667524adaf9821a$export$6bed283375899438(data, data.h || _this.state.oldHue);
                    _this.setState(colors);
                    _this.props.onChangeComplete && _this.debounce(_this.props.onChangeComplete, colors, event);
                    _this.props.onChange && _this.props.onChange(colors, event);
                }
            };
            _this.handleSwatchHover = function(data, event) {
                var isValidColor = $c667524adaf9821a$export$4837207a530c7f21(data);
                if (isValidColor) {
                    var colors = $c667524adaf9821a$export$6bed283375899438(data, data.h || _this.state.oldHue);
                    _this.props.onSwatchHover && _this.props.onSwatchHover(colors, event);
                }
            };
            _this.state = $13e2b01d2fc0abc5$var$_extends({}, $c667524adaf9821a$export$6bed283375899438(props.color, 0));
            _this.debounce = (0, $2b9c0da2d9bf5406$export$2e2bcd8739ae039)(function(fn, data, event) {
                fn(data, event);
            }, 100);
            return _this;
        }
        $13e2b01d2fc0abc5$var$_createClass(ColorPicker, [
            {
                key: "render",
                value: function render() {
                    var optionalEvents = {};
                    if (this.props.onSwatchHover) optionalEvents.onSwatchHover = this.handleSwatchHover;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement(Picker, $13e2b01d2fc0abc5$var$_extends({}, this.props, this.state, {
                        onChange: this.handleChange
                    }, optionalEvents));
                }
            }
        ], [
            {
                key: "getDerivedStateFromProps",
                value: function getDerivedStateFromProps(nextProps, state) {
                    return $13e2b01d2fc0abc5$var$_extends({}, $c667524adaf9821a$export$6bed283375899438(nextProps.color, state.oldHue));
                }
            }
        ]);
        return ColorPicker;
    }((0, $bh6RR.PureComponent) || (0, $bh6RR.Component));
    ColorPicker.propTypes = $13e2b01d2fc0abc5$var$_extends({}, Picker.propTypes);
    ColorPicker.defaultProps = $13e2b01d2fc0abc5$var$_extends({}, Picker.defaultProps, {
        color: {
            h: 250,
            s: 0.50,
            l: 0.20,
            a: 1
        }
    });
    return ColorPicker;
};
var $13e2b01d2fc0abc5$export$2e2bcd8739ae039 = $13e2b01d2fc0abc5$export$68265aef2e61bec7;



var $bh6RR = parcelRequire("bh6RR");


var $bh6RR = parcelRequire("bh6RR");
var $ec7a1fd87680ddd3$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var $ec7a1fd87680ddd3$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();
function $ec7a1fd87680ddd3$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $ec7a1fd87680ddd3$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $ec7a1fd87680ddd3$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var $ec7a1fd87680ddd3$export$185584c64f36588 = function handleFocus(Component) {
    var Span = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "span";
    return function(_React$Component) {
        $ec7a1fd87680ddd3$var$_inherits(Focus, _React$Component);
        function Focus() {
            var _ref;
            var _temp, _this, _ret;
            $ec7a1fd87680ddd3$var$_classCallCheck(this, Focus);
            for(var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            return _ret = (_temp = (_this = $ec7a1fd87680ddd3$var$_possibleConstructorReturn(this, (_ref = Focus.__proto__ || Object.getPrototypeOf(Focus)).call.apply(_ref, [
                this
            ].concat(args))), _this), _this.state = {
                focus: false
            }, _this.handleFocus = function() {
                return _this.setState({
                    focus: true
                });
            }, _this.handleBlur = function() {
                return _this.setState({
                    focus: false
                });
            }, _temp), $ec7a1fd87680ddd3$var$_possibleConstructorReturn(_this, _ret);
        }
        $ec7a1fd87680ddd3$var$_createClass(Focus, [
            {
                key: "render",
                value: function render() {
                    return (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement(Span, {
                        onFocus: this.handleFocus,
                        onBlur: this.handleBlur
                    }, (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement(Component, $ec7a1fd87680ddd3$var$_extends({}, this.props, this.state)));
                }
            }
        ]);
        return Focus;
    }((0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).Component);
};



var $d738ffe146a16d78$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var $d738ffe146a16d78$var$ENTER = 13;
var $d738ffe146a16d78$export$c463048d6131b309 = function Swatch(_ref) {
    var color = _ref.color, style = _ref.style, _ref$onClick = _ref.onClick, onClick = _ref$onClick === undefined ? function() {} : _ref$onClick, onHover = _ref.onHover, _ref$title = _ref.title, title = _ref$title === undefined ? color : _ref$title, children = _ref.children, focus = _ref.focus, _ref$focusStyle = _ref.focusStyle, focusStyle = _ref$focusStyle === undefined ? {} : _ref$focusStyle;
    var transparent = color === "transparent";
    var styles = (0, (/*@__PURE__*/$parcel$interopDefault($1e6d325bf7ec7d53$exports)))({
        default: {
            swatch: $d738ffe146a16d78$var$_extends({
                background: color,
                height: "100%",
                width: "100%",
                cursor: "pointer",
                position: "relative",
                outline: "none"
            }, style, focus ? focusStyle : {})
        }
    });
    var handleClick = function handleClick(e) {
        return onClick(color, e);
    };
    var handleKeyDown = function handleKeyDown(e) {
        return e.keyCode === $d738ffe146a16d78$var$ENTER && onClick(color, e);
    };
    var handleHover = function handleHover(e) {
        return onHover(color, e);
    };
    var optionalEvents = {};
    if (onHover) optionalEvents.onMouseOver = handleHover;
    return (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("div", $d738ffe146a16d78$var$_extends({
        style: styles.swatch,
        onClick: handleClick,
        title: title,
        tabIndex: 0,
        onKeyDown: handleKeyDown
    }, optionalEvents), children, transparent && (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $fb5ac1bea6cb3f9f$export$2e2bcd8739ae039), {
        borderRadius: styles.swatch.borderRadius,
        boxShadow: "inset 0 0 0 1px rgba(0,0,0,0.1)"
    }));
};
var $d738ffe146a16d78$export$2e2bcd8739ae039 = (0, $ec7a1fd87680ddd3$export$185584c64f36588)($d738ffe146a16d78$export$c463048d6131b309);





var $bh6RR = parcelRequire("bh6RR");

var $1bfc42b12f4b60a5$export$5bbd8091d1d0e224 = function AlphaPointer(_ref) {
    var direction = _ref.direction;
    var styles = (0, (/*@__PURE__*/$parcel$interopDefault($1e6d325bf7ec7d53$exports)))({
        "default": {
            picker: {
                width: "18px",
                height: "18px",
                borderRadius: "50%",
                transform: "translate(-9px, -1px)",
                backgroundColor: "rgb(248, 248, 248)",
                boxShadow: "0 1px 4px 0 rgba(0, 0, 0, 0.37)"
            }
        },
        "vertical": {
            picker: {
                transform: "translate(-3px, -9px)"
            }
        }
    }, {
        vertical: direction === "vertical"
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("div", {
        style: styles.picker
    });
};
var $1bfc42b12f4b60a5$export$2e2bcd8739ae039 = $1bfc42b12f4b60a5$export$5bbd8091d1d0e224;


var $f998df7a902930d4$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var $f998df7a902930d4$export$421d2c1bdabf8a68 = function AlphaPicker(_ref) {
    var rgb = _ref.rgb, hsl = _ref.hsl, width = _ref.width, height = _ref.height, onChange = _ref.onChange, direction = _ref.direction, style = _ref.style, renderers = _ref.renderers, pointer = _ref.pointer, _ref$className = _ref.className, className = _ref$className === undefined ? "" : _ref$className;
    var styles = (0, (/*@__PURE__*/$parcel$interopDefault($1e6d325bf7ec7d53$exports)))({
        "default": {
            picker: {
                position: "relative",
                width: width,
                height: height
            },
            alpha: {
                radius: "2px",
                style: style
            }
        }
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("div", {
        style: styles.picker,
        className: "alpha-picker " + className
    }, (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $2b76dc783bc34760$export$2e2bcd8739ae039), $f998df7a902930d4$var$_extends({}, styles.alpha, {
        rgb: rgb,
        hsl: hsl,
        pointer: pointer,
        renderers: renderers,
        onChange: onChange,
        direction: direction
    })));
};
$f998df7a902930d4$export$421d2c1bdabf8a68.defaultProps = {
    width: "316px",
    height: "16px",
    direction: "horizontal",
    pointer: (0, $1bfc42b12f4b60a5$export$2e2bcd8739ae039)
};
var $f998df7a902930d4$export$2e2bcd8739ae039 = (0, $13e2b01d2fc0abc5$export$2e2bcd8739ae039)($f998df7a902930d4$export$421d2c1bdabf8a68);



var $bh6RR = parcelRequire("bh6RR");






var $bh6RR = parcelRequire("bh6RR");

/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */ function $87593c1a2aec5b96$var$arrayMap(array, iteratee) {
    var index = -1, length = array == null ? 0 : array.length, result = Array(length);
    while(++index < length)result[index] = iteratee(array[index], index, array);
    return result;
}
var $87593c1a2aec5b96$export$2e2bcd8739ae039 = $87593c1a2aec5b96$var$arrayMap;





/** Used to stand-in for `undefined` hash values. */ var $dc76ee55e2f64c5d$var$HASH_UNDEFINED = "__lodash_hash_undefined__";
/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */ function $dc76ee55e2f64c5d$var$setCacheAdd(value) {
    this.__data__.set(value, $dc76ee55e2f64c5d$var$HASH_UNDEFINED);
    return this;
}
var $dc76ee55e2f64c5d$export$2e2bcd8739ae039 = $dc76ee55e2f64c5d$var$setCacheAdd;


/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */ function $30d13562b7651b1e$var$setCacheHas(value) {
    return this.__data__.has(value);
}
var $30d13562b7651b1e$export$2e2bcd8739ae039 = $30d13562b7651b1e$var$setCacheHas;


/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */ function $8016247b8b19ed36$var$SetCache(values) {
    var index = -1, length = values == null ? 0 : values.length;
    this.__data__ = new (0, $be493b3f39c647b0$export$2e2bcd8739ae039);
    while(++index < length)this.add(values[index]);
}
// Add methods to `SetCache`.
$8016247b8b19ed36$var$SetCache.prototype.add = $8016247b8b19ed36$var$SetCache.prototype.push = (0, $dc76ee55e2f64c5d$export$2e2bcd8739ae039);
$8016247b8b19ed36$var$SetCache.prototype.has = (0, $30d13562b7651b1e$export$2e2bcd8739ae039);
var $8016247b8b19ed36$export$2e2bcd8739ae039 = $8016247b8b19ed36$var$SetCache;


/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */ function $7c978f93b90a1221$var$arraySome(array, predicate) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        if (predicate(array[index], index, array)) return true;
    }
    return false;
}
var $7c978f93b90a1221$export$2e2bcd8739ae039 = $7c978f93b90a1221$var$arraySome;


/**
 * Checks if a `cache` value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $7169c07814b09d92$var$cacheHas(cache, key) {
    return cache.has(key);
}
var $7169c07814b09d92$export$2e2bcd8739ae039 = $7169c07814b09d92$var$cacheHas;


/** Used to compose bitmasks for value comparisons. */ var $3c8e4a4853c7e3b9$var$COMPARE_PARTIAL_FLAG = 1, $3c8e4a4853c7e3b9$var$COMPARE_UNORDERED_FLAG = 2;
/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */ function $3c8e4a4853c7e3b9$var$equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
    var isPartial = bitmask & $3c8e4a4853c7e3b9$var$COMPARE_PARTIAL_FLAG, arrLength = array.length, othLength = other.length;
    if (arrLength != othLength && !(isPartial && othLength > arrLength)) return false;
    // Check that cyclic values are equal.
    var arrStacked = stack.get(array);
    var othStacked = stack.get(other);
    if (arrStacked && othStacked) return arrStacked == other && othStacked == array;
    var index = -1, result = true, seen = bitmask & $3c8e4a4853c7e3b9$var$COMPARE_UNORDERED_FLAG ? new (0, $8016247b8b19ed36$export$2e2bcd8739ae039) : undefined;
    stack.set(array, other);
    stack.set(other, array);
    // Ignore non-index properties.
    while(++index < arrLength){
        var arrValue = array[index], othValue = other[index];
        if (customizer) var compared = isPartial ? customizer(othValue, arrValue, index, other, array, stack) : customizer(arrValue, othValue, index, array, other, stack);
        if (compared !== undefined) {
            if (compared) continue;
            result = false;
            break;
        }
        // Recursively compare arrays (susceptible to call stack limits).
        if (seen) {
            if (!(0, $7c978f93b90a1221$export$2e2bcd8739ae039)(other, function(othValue, othIndex) {
                if (!(0, $7169c07814b09d92$export$2e2bcd8739ae039)(seen, othIndex) && (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) return seen.push(othIndex);
            })) {
                result = false;
                break;
            }
        } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
            result = false;
            break;
        }
    }
    stack["delete"](array);
    stack["delete"](other);
    return result;
}
var $3c8e4a4853c7e3b9$export$2e2bcd8739ae039 = $3c8e4a4853c7e3b9$var$equalArrays;






/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */ function $545f804c34b2ba9c$var$mapToArray(map) {
    var index = -1, result = Array(map.size);
    map.forEach(function(value, key) {
        result[++index] = [
            key,
            value
        ];
    });
    return result;
}
var $545f804c34b2ba9c$export$2e2bcd8739ae039 = $545f804c34b2ba9c$var$mapToArray;


/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */ function $7a48140124cda72a$var$setToArray(set) {
    var index = -1, result = Array(set.size);
    set.forEach(function(value) {
        result[++index] = value;
    });
    return result;
}
var $7a48140124cda72a$export$2e2bcd8739ae039 = $7a48140124cda72a$var$setToArray;


/** Used to compose bitmasks for value comparisons. */ var $d76a062fa94fb6d7$var$COMPARE_PARTIAL_FLAG = 1, $d76a062fa94fb6d7$var$COMPARE_UNORDERED_FLAG = 2;
/** `Object#toString` result references. */ var $d76a062fa94fb6d7$var$boolTag = "[object Boolean]", $d76a062fa94fb6d7$var$dateTag = "[object Date]", $d76a062fa94fb6d7$var$errorTag = "[object Error]", $d76a062fa94fb6d7$var$mapTag = "[object Map]", $d76a062fa94fb6d7$var$numberTag = "[object Number]", $d76a062fa94fb6d7$var$regexpTag = "[object RegExp]", $d76a062fa94fb6d7$var$setTag = "[object Set]", $d76a062fa94fb6d7$var$stringTag = "[object String]", $d76a062fa94fb6d7$var$symbolTag = "[object Symbol]";
var $d76a062fa94fb6d7$var$arrayBufferTag = "[object ArrayBuffer]", $d76a062fa94fb6d7$var$dataViewTag = "[object DataView]";
/** Used to convert symbols to primitives and strings. */ var $d76a062fa94fb6d7$var$symbolProto = (0, $0fa9a02f9756f657$export$2e2bcd8739ae039) ? (0, $0fa9a02f9756f657$export$2e2bcd8739ae039).prototype : undefined, $d76a062fa94fb6d7$var$symbolValueOf = $d76a062fa94fb6d7$var$symbolProto ? $d76a062fa94fb6d7$var$symbolProto.valueOf : undefined;
/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function $d76a062fa94fb6d7$var$equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
    switch(tag){
        case $d76a062fa94fb6d7$var$dataViewTag:
            if (object.byteLength != other.byteLength || object.byteOffset != other.byteOffset) return false;
            object = object.buffer;
            other = other.buffer;
        case $d76a062fa94fb6d7$var$arrayBufferTag:
            if (object.byteLength != other.byteLength || !equalFunc(new (0, $42ccac2ef9780f37$export$2e2bcd8739ae039)(object), new (0, $42ccac2ef9780f37$export$2e2bcd8739ae039)(other))) return false;
            return true;
        case $d76a062fa94fb6d7$var$boolTag:
        case $d76a062fa94fb6d7$var$dateTag:
        case $d76a062fa94fb6d7$var$numberTag:
            // Coerce booleans to `1` or `0` and dates to milliseconds.
            // Invalid dates are coerced to `NaN`.
            return (0, $24a50494b56303fa$export$2e2bcd8739ae039)(+object, +other);
        case $d76a062fa94fb6d7$var$errorTag:
            return object.name == other.name && object.message == other.message;
        case $d76a062fa94fb6d7$var$regexpTag:
        case $d76a062fa94fb6d7$var$stringTag:
            // Coerce regexes to strings and treat strings, primitives and objects,
            // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
            // for more details.
            return object == other + "";
        case $d76a062fa94fb6d7$var$mapTag:
            var convert = (0, $545f804c34b2ba9c$export$2e2bcd8739ae039);
        case $d76a062fa94fb6d7$var$setTag:
            var isPartial = bitmask & $d76a062fa94fb6d7$var$COMPARE_PARTIAL_FLAG;
            convert || (convert = (0, $7a48140124cda72a$export$2e2bcd8739ae039));
            if (object.size != other.size && !isPartial) return false;
            // Assume cyclic values are equal.
            var stacked = stack.get(object);
            if (stacked) return stacked == other;
            bitmask |= $d76a062fa94fb6d7$var$COMPARE_UNORDERED_FLAG;
            // Recursively compare objects (susceptible to call stack limits).
            stack.set(object, other);
            var result = (0, $3c8e4a4853c7e3b9$export$2e2bcd8739ae039)(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
            stack["delete"](object);
            return result;
        case $d76a062fa94fb6d7$var$symbolTag:
            if ($d76a062fa94fb6d7$var$symbolValueOf) return $d76a062fa94fb6d7$var$symbolValueOf.call(object) == $d76a062fa94fb6d7$var$symbolValueOf.call(other);
    }
    return false;
}
var $d76a062fa94fb6d7$export$2e2bcd8739ae039 = $d76a062fa94fb6d7$var$equalByTag;


/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */ function $683a3b780d4eb41b$var$arrayPush(array, values) {
    var index = -1, length = values.length, offset = array.length;
    while(++index < length)array[offset + index] = values[index];
    return array;
}
var $683a3b780d4eb41b$export$2e2bcd8739ae039 = $683a3b780d4eb41b$var$arrayPush;



/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */ function $e7cb349a473b00eb$var$baseGetAllKeys(object, keysFunc, symbolsFunc) {
    var result = keysFunc(object);
    return (0, $98f8e0b2d1df3aed$export$2e2bcd8739ae039)(object) ? result : (0, $683a3b780d4eb41b$export$2e2bcd8739ae039)(result, symbolsFunc(object));
}
var $e7cb349a473b00eb$export$2e2bcd8739ae039 = $e7cb349a473b00eb$var$baseGetAllKeys;


/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */ function $cbf4db2dc1415291$var$arrayFilter(array, predicate) {
    var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
    while(++index < length){
        var value = array[index];
        if (predicate(value, index, array)) result[resIndex++] = value;
    }
    return result;
}
var $cbf4db2dc1415291$export$2e2bcd8739ae039 = $cbf4db2dc1415291$var$arrayFilter;


/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */ function $0764dfb344313c12$var$stubArray() {
    return [];
}
var $0764dfb344313c12$export$2e2bcd8739ae039 = $0764dfb344313c12$var$stubArray;


/** Used for built-in method references. */ var $5eb480a5a820f908$var$objectProto = Object.prototype;
/** Built-in value references. */ var $5eb480a5a820f908$var$propertyIsEnumerable = $5eb480a5a820f908$var$objectProto.propertyIsEnumerable;
/* Built-in method references for those with the same name as other `lodash` methods. */ var $5eb480a5a820f908$var$nativeGetSymbols = Object.getOwnPropertySymbols;
/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */ var $5eb480a5a820f908$var$getSymbols = !$5eb480a5a820f908$var$nativeGetSymbols ? (0, $0764dfb344313c12$export$2e2bcd8739ae039) : function(object) {
    if (object == null) return [];
    object = Object(object);
    return (0, $cbf4db2dc1415291$export$2e2bcd8739ae039)($5eb480a5a820f908$var$nativeGetSymbols(object), function(symbol) {
        return $5eb480a5a820f908$var$propertyIsEnumerable.call(object, symbol);
    });
};
var $5eb480a5a820f908$export$2e2bcd8739ae039 = $5eb480a5a820f908$var$getSymbols;



/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */ function $c95ddd733823b884$var$getAllKeys(object) {
    return (0, $e7cb349a473b00eb$export$2e2bcd8739ae039)(object, (0, $0a7e60e3e1b696d0$export$2e2bcd8739ae039), (0, $5eb480a5a820f908$export$2e2bcd8739ae039));
}
var $c95ddd733823b884$export$2e2bcd8739ae039 = $c95ddd733823b884$var$getAllKeys;


/** Used to compose bitmasks for value comparisons. */ var $ab6a56a9941fb70d$var$COMPARE_PARTIAL_FLAG = 1;
/** Used for built-in method references. */ var $ab6a56a9941fb70d$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $ab6a56a9941fb70d$var$hasOwnProperty = $ab6a56a9941fb70d$var$objectProto.hasOwnProperty;
/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function $ab6a56a9941fb70d$var$equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
    var isPartial = bitmask & $ab6a56a9941fb70d$var$COMPARE_PARTIAL_FLAG, objProps = (0, $c95ddd733823b884$export$2e2bcd8739ae039)(object), objLength = objProps.length, othProps = (0, $c95ddd733823b884$export$2e2bcd8739ae039)(other), othLength = othProps.length;
    if (objLength != othLength && !isPartial) return false;
    var index = objLength;
    while(index--){
        var key = objProps[index];
        if (!(isPartial ? key in other : $ab6a56a9941fb70d$var$hasOwnProperty.call(other, key))) return false;
    }
    // Check that cyclic values are equal.
    var objStacked = stack.get(object);
    var othStacked = stack.get(other);
    if (objStacked && othStacked) return objStacked == other && othStacked == object;
    var result = true;
    stack.set(object, other);
    stack.set(other, object);
    var skipCtor = isPartial;
    while(++index < objLength){
        key = objProps[index];
        var objValue = object[key], othValue = other[key];
        if (customizer) var compared = isPartial ? customizer(othValue, objValue, key, other, object, stack) : customizer(objValue, othValue, key, object, other, stack);
        // Recursively compare objects (susceptible to call stack limits).
        if (!(compared === undefined ? objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack) : compared)) {
            result = false;
            break;
        }
        skipCtor || (skipCtor = key == "constructor");
    }
    if (result && !skipCtor) {
        var objCtor = object.constructor, othCtor = other.constructor;
        // Non `Object` object instances with different constructors are not equal.
        if (objCtor != othCtor && "constructor" in object && "constructor" in other && !(typeof objCtor == "function" && objCtor instanceof objCtor && typeof othCtor == "function" && othCtor instanceof othCtor)) result = false;
    }
    stack["delete"](object);
    stack["delete"](other);
    return result;
}
var $ab6a56a9941fb70d$export$2e2bcd8739ae039 = $ab6a56a9941fb70d$var$equalObjects;




var $6AhZS = parcelRequire("6AhZS");
/* Built-in method references that are verified to be native. */ var $85215c80e1973d51$var$DataView = (0, $e5e36fcd795e94d7$export$2e2bcd8739ae039)((0, $6AhZS.default), "DataView");
var $85215c80e1973d51$export$2e2bcd8739ae039 = $85215c80e1973d51$var$DataView;





var $6AhZS = parcelRequire("6AhZS");
/* Built-in method references that are verified to be native. */ var $a2eab25dde92b3ad$var$Promise = (0, $e5e36fcd795e94d7$export$2e2bcd8739ae039)((0, $6AhZS.default), "Promise");
var $a2eab25dde92b3ad$export$2e2bcd8739ae039 = $a2eab25dde92b3ad$var$Promise;




var $6AhZS = parcelRequire("6AhZS");
/* Built-in method references that are verified to be native. */ var $c55ee7709f40bf07$var$Set = (0, $e5e36fcd795e94d7$export$2e2bcd8739ae039)((0, $6AhZS.default), "Set");
var $c55ee7709f40bf07$export$2e2bcd8739ae039 = $c55ee7709f40bf07$var$Set;




var $6AhZS = parcelRequire("6AhZS");
/* Built-in method references that are verified to be native. */ var $e105d31ff046e80b$var$WeakMap = (0, $e5e36fcd795e94d7$export$2e2bcd8739ae039)((0, $6AhZS.default), "WeakMap");
var $e105d31ff046e80b$export$2e2bcd8739ae039 = $e105d31ff046e80b$var$WeakMap;




/** `Object#toString` result references. */ var $5ffeb92c4e5cd318$var$mapTag = "[object Map]", $5ffeb92c4e5cd318$var$objectTag = "[object Object]", $5ffeb92c4e5cd318$var$promiseTag = "[object Promise]", $5ffeb92c4e5cd318$var$setTag = "[object Set]", $5ffeb92c4e5cd318$var$weakMapTag = "[object WeakMap]";
var $5ffeb92c4e5cd318$var$dataViewTag = "[object DataView]";
/** Used to detect maps, sets, and weakmaps. */ var $5ffeb92c4e5cd318$var$dataViewCtorString = (0, $8c7a3bd26fa17d1b$export$2e2bcd8739ae039)((0, $85215c80e1973d51$export$2e2bcd8739ae039)), $5ffeb92c4e5cd318$var$mapCtorString = (0, $8c7a3bd26fa17d1b$export$2e2bcd8739ae039)((0, $277a51f176965052$export$2e2bcd8739ae039)), $5ffeb92c4e5cd318$var$promiseCtorString = (0, $8c7a3bd26fa17d1b$export$2e2bcd8739ae039)((0, $a2eab25dde92b3ad$export$2e2bcd8739ae039)), $5ffeb92c4e5cd318$var$setCtorString = (0, $8c7a3bd26fa17d1b$export$2e2bcd8739ae039)((0, $c55ee7709f40bf07$export$2e2bcd8739ae039)), $5ffeb92c4e5cd318$var$weakMapCtorString = (0, $8c7a3bd26fa17d1b$export$2e2bcd8739ae039)((0, $e105d31ff046e80b$export$2e2bcd8739ae039));
/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ var $5ffeb92c4e5cd318$var$getTag = (0, $622194736393697a$export$2e2bcd8739ae039);
// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if ((0, $85215c80e1973d51$export$2e2bcd8739ae039) && $5ffeb92c4e5cd318$var$getTag(new (0, $85215c80e1973d51$export$2e2bcd8739ae039)(new ArrayBuffer(1))) != $5ffeb92c4e5cd318$var$dataViewTag || (0, $277a51f176965052$export$2e2bcd8739ae039) && $5ffeb92c4e5cd318$var$getTag(new (0, $277a51f176965052$export$2e2bcd8739ae039)) != $5ffeb92c4e5cd318$var$mapTag || (0, $a2eab25dde92b3ad$export$2e2bcd8739ae039) && $5ffeb92c4e5cd318$var$getTag((0, $a2eab25dde92b3ad$export$2e2bcd8739ae039).resolve()) != $5ffeb92c4e5cd318$var$promiseTag || (0, $c55ee7709f40bf07$export$2e2bcd8739ae039) && $5ffeb92c4e5cd318$var$getTag(new (0, $c55ee7709f40bf07$export$2e2bcd8739ae039)) != $5ffeb92c4e5cd318$var$setTag || (0, $e105d31ff046e80b$export$2e2bcd8739ae039) && $5ffeb92c4e5cd318$var$getTag(new (0, $e105d31ff046e80b$export$2e2bcd8739ae039)) != $5ffeb92c4e5cd318$var$weakMapTag) $5ffeb92c4e5cd318$var$getTag = function(value) {
    var result = (0, $622194736393697a$export$2e2bcd8739ae039)(value), Ctor = result == $5ffeb92c4e5cd318$var$objectTag ? value.constructor : undefined, ctorString = Ctor ? (0, $8c7a3bd26fa17d1b$export$2e2bcd8739ae039)(Ctor) : "";
    if (ctorString) switch(ctorString){
        case $5ffeb92c4e5cd318$var$dataViewCtorString:
            return $5ffeb92c4e5cd318$var$dataViewTag;
        case $5ffeb92c4e5cd318$var$mapCtorString:
            return $5ffeb92c4e5cd318$var$mapTag;
        case $5ffeb92c4e5cd318$var$promiseCtorString:
            return $5ffeb92c4e5cd318$var$promiseTag;
        case $5ffeb92c4e5cd318$var$setCtorString:
            return $5ffeb92c4e5cd318$var$setTag;
        case $5ffeb92c4e5cd318$var$weakMapCtorString:
            return $5ffeb92c4e5cd318$var$weakMapTag;
    }
    return result;
};
var $5ffeb92c4e5cd318$export$2e2bcd8739ae039 = $5ffeb92c4e5cd318$var$getTag;




var $h0k3u = parcelRequire("h0k3u");

/** Used to compose bitmasks for value comparisons. */ var $1331a822301424af$var$COMPARE_PARTIAL_FLAG = 1;
/** `Object#toString` result references. */ var $1331a822301424af$var$argsTag = "[object Arguments]", $1331a822301424af$var$arrayTag = "[object Array]", $1331a822301424af$var$objectTag = "[object Object]";
/** Used for built-in method references. */ var $1331a822301424af$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $1331a822301424af$var$hasOwnProperty = $1331a822301424af$var$objectProto.hasOwnProperty;
/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function $1331a822301424af$var$baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
    var objIsArr = (0, $98f8e0b2d1df3aed$export$2e2bcd8739ae039)(object), othIsArr = (0, $98f8e0b2d1df3aed$export$2e2bcd8739ae039)(other), objTag = objIsArr ? $1331a822301424af$var$arrayTag : (0, $5ffeb92c4e5cd318$export$2e2bcd8739ae039)(object), othTag = othIsArr ? $1331a822301424af$var$arrayTag : (0, $5ffeb92c4e5cd318$export$2e2bcd8739ae039)(other);
    objTag = objTag == $1331a822301424af$var$argsTag ? $1331a822301424af$var$objectTag : objTag;
    othTag = othTag == $1331a822301424af$var$argsTag ? $1331a822301424af$var$objectTag : othTag;
    var objIsObj = objTag == $1331a822301424af$var$objectTag, othIsObj = othTag == $1331a822301424af$var$objectTag, isSameTag = objTag == othTag;
    if (isSameTag && (0, $h0k3u.default)(object)) {
        if (!(0, $h0k3u.default)(other)) return false;
        objIsArr = true;
        objIsObj = false;
    }
    if (isSameTag && !objIsObj) {
        stack || (stack = new (0, $8b088ed672f4e479$export$2e2bcd8739ae039));
        return objIsArr || (0, $5bca4d58ac751b05$export$2e2bcd8739ae039)(object) ? (0, $3c8e4a4853c7e3b9$export$2e2bcd8739ae039)(object, other, bitmask, customizer, equalFunc, stack) : (0, $d76a062fa94fb6d7$export$2e2bcd8739ae039)(object, other, objTag, bitmask, customizer, equalFunc, stack);
    }
    if (!(bitmask & $1331a822301424af$var$COMPARE_PARTIAL_FLAG)) {
        var objIsWrapped = objIsObj && $1331a822301424af$var$hasOwnProperty.call(object, "__wrapped__"), othIsWrapped = othIsObj && $1331a822301424af$var$hasOwnProperty.call(other, "__wrapped__");
        if (objIsWrapped || othIsWrapped) {
            var objUnwrapped = objIsWrapped ? object.value() : object, othUnwrapped = othIsWrapped ? other.value() : other;
            stack || (stack = new (0, $8b088ed672f4e479$export$2e2bcd8739ae039));
            return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
        }
    }
    if (!isSameTag) return false;
    stack || (stack = new (0, $8b088ed672f4e479$export$2e2bcd8739ae039));
    return (0, $ab6a56a9941fb70d$export$2e2bcd8739ae039)(object, other, bitmask, customizer, equalFunc, stack);
}
var $1331a822301424af$export$2e2bcd8739ae039 = $1331a822301424af$var$baseIsEqualDeep;



/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Unordered comparison
 *  2 - Partial comparison
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */ function $378bb147bd9b5a4b$var$baseIsEqual(value, other, bitmask, customizer, stack) {
    if (value === other) return true;
    if (value == null || other == null || !(0, $97d6226034a0ca4f$export$2e2bcd8739ae039)(value) && !(0, $97d6226034a0ca4f$export$2e2bcd8739ae039)(other)) return value !== value && other !== other;
    return (0, $1331a822301424af$export$2e2bcd8739ae039)(value, other, bitmask, customizer, $378bb147bd9b5a4b$var$baseIsEqual, stack);
}
var $378bb147bd9b5a4b$export$2e2bcd8739ae039 = $378bb147bd9b5a4b$var$baseIsEqual;


/** Used to compose bitmasks for value comparisons. */ var $e20c0202bc25dd80$var$COMPARE_PARTIAL_FLAG = 1, $e20c0202bc25dd80$var$COMPARE_UNORDERED_FLAG = 2;
/**
 * The base implementation of `_.isMatch` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to inspect.
 * @param {Object} source The object of property values to match.
 * @param {Array} matchData The property names, values, and compare flags to match.
 * @param {Function} [customizer] The function to customize comparisons.
 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
 */ function $e20c0202bc25dd80$var$baseIsMatch(object, source, matchData, customizer) {
    var index = matchData.length, length = index, noCustomizer = !customizer;
    if (object == null) return !length;
    object = Object(object);
    while(index--){
        var data = matchData[index];
        if (noCustomizer && data[2] ? data[1] !== object[data[0]] : !(data[0] in object)) return false;
    }
    while(++index < length){
        data = matchData[index];
        var key = data[0], objValue = object[key], srcValue = data[1];
        if (noCustomizer && data[2]) {
            if (objValue === undefined && !(key in object)) return false;
        } else {
            var stack = new (0, $8b088ed672f4e479$export$2e2bcd8739ae039);
            if (customizer) var result = customizer(objValue, srcValue, key, object, source, stack);
            if (!(result === undefined ? (0, $378bb147bd9b5a4b$export$2e2bcd8739ae039)(srcValue, objValue, $e20c0202bc25dd80$var$COMPARE_PARTIAL_FLAG | $e20c0202bc25dd80$var$COMPARE_UNORDERED_FLAG, customizer, stack) : result)) return false;
        }
    }
    return true;
}
var $e20c0202bc25dd80$export$2e2bcd8739ae039 = $e20c0202bc25dd80$var$baseIsMatch;



/**
 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` if suitable for strict
 *  equality comparisons, else `false`.
 */ function $b450c9e17098dddf$var$isStrictComparable(value) {
    return value === value && !(0, $1146963f863a9576$export$2e2bcd8739ae039)(value);
}
var $b450c9e17098dddf$export$2e2bcd8739ae039 = $b450c9e17098dddf$var$isStrictComparable;



/**
 * Gets the property names, values, and compare flags of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the match data of `object`.
 */ function $6baa37008a2ca765$var$getMatchData(object) {
    var result = (0, $0a7e60e3e1b696d0$export$2e2bcd8739ae039)(object), length = result.length;
    while(length--){
        var key = result[length], value = object[key];
        result[length] = [
            key,
            value,
            (0, $b450c9e17098dddf$export$2e2bcd8739ae039)(value)
        ];
    }
    return result;
}
var $6baa37008a2ca765$export$2e2bcd8739ae039 = $6baa37008a2ca765$var$getMatchData;


/**
 * A specialized version of `matchesProperty` for source values suitable
 * for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */ function $f64ec5e30ac071a7$var$matchesStrictComparable(key, srcValue) {
    return function(object) {
        if (object == null) return false;
        return object[key] === srcValue && (srcValue !== undefined || key in Object(object));
    };
}
var $f64ec5e30ac071a7$export$2e2bcd8739ae039 = $f64ec5e30ac071a7$var$matchesStrictComparable;


/**
 * The base implementation of `_.matches` which doesn't clone `source`.
 *
 * @private
 * @param {Object} source The object of property values to match.
 * @returns {Function} Returns the new spec function.
 */ function $100cbc515654a755$var$baseMatches(source) {
    var matchData = (0, $6baa37008a2ca765$export$2e2bcd8739ae039)(source);
    if (matchData.length == 1 && matchData[0][2]) return (0, $f64ec5e30ac071a7$export$2e2bcd8739ae039)(matchData[0][0], matchData[0][1]);
    return function(object) {
        return object === source || (0, $e20c0202bc25dd80$export$2e2bcd8739ae039)(object, source, matchData);
    };
}
var $100cbc515654a755$export$2e2bcd8739ae039 = $100cbc515654a755$var$baseMatches;






/** Used to match property names within property paths. */ var $60c2115adfc4537b$var$reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, $60c2115adfc4537b$var$reIsPlainProp = /^\w*$/;
/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */ function $60c2115adfc4537b$var$isKey(value, object) {
    if ((0, $98f8e0b2d1df3aed$export$2e2bcd8739ae039)(value)) return false;
    var type = typeof value;
    if (type == "number" || type == "symbol" || type == "boolean" || value == null || (0, $32500a1e560de4f0$export$2e2bcd8739ae039)(value)) return true;
    return $60c2115adfc4537b$var$reIsPlainProp.test(value) || !$60c2115adfc4537b$var$reIsDeepProp.test(value) || object != null && value in Object(object);
}
var $60c2115adfc4537b$export$2e2bcd8739ae039 = $60c2115adfc4537b$var$isKey;



/** Error message constants. */ var $364633689371ed49$var$FUNC_ERROR_TEXT = "Expected a function";
/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */ function $364633689371ed49$var$memoize(func, resolver) {
    if (typeof func != "function" || resolver != null && typeof resolver != "function") throw new TypeError($364633689371ed49$var$FUNC_ERROR_TEXT);
    var memoized = function() {
        var args = arguments, key = resolver ? resolver.apply(this, args) : args[0], cache = memoized.cache;
        if (cache.has(key)) return cache.get(key);
        var result = func.apply(this, args);
        memoized.cache = cache.set(key, result) || cache;
        return result;
    };
    memoized.cache = new ($364633689371ed49$var$memoize.Cache || (0, $be493b3f39c647b0$export$2e2bcd8739ae039));
    return memoized;
}
// Expose `MapCache`.
$364633689371ed49$var$memoize.Cache = (0, $be493b3f39c647b0$export$2e2bcd8739ae039);
var $364633689371ed49$export$2e2bcd8739ae039 = $364633689371ed49$var$memoize;


/** Used as the maximum memoize cache size. */ var $57d6f715260ef7ce$var$MAX_MEMOIZE_SIZE = 500;
/**
 * A specialized version of `_.memoize` which clears the memoized function's
 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
 *
 * @private
 * @param {Function} func The function to have its output memoized.
 * @returns {Function} Returns the new memoized function.
 */ function $57d6f715260ef7ce$var$memoizeCapped(func) {
    var result = (0, $364633689371ed49$export$2e2bcd8739ae039)(func, function(key) {
        if (cache.size === $57d6f715260ef7ce$var$MAX_MEMOIZE_SIZE) cache.clear();
        return key;
    });
    var cache = result.cache;
    return result;
}
var $57d6f715260ef7ce$export$2e2bcd8739ae039 = $57d6f715260ef7ce$var$memoizeCapped;


/** Used to match property names within property paths. */ var $8e232e870bfb6095$var$rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
/** Used to match backslashes in property paths. */ var $8e232e870bfb6095$var$reEscapeChar = /\\(\\)?/g;
/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */ var $8e232e870bfb6095$var$stringToPath = (0, $57d6f715260ef7ce$export$2e2bcd8739ae039)(function(string) {
    var result = [];
    if (string.charCodeAt(0) === 46 /* . */ ) result.push("");
    string.replace($8e232e870bfb6095$var$rePropName, function(match, number, quote, subString) {
        result.push(quote ? subString.replace($8e232e870bfb6095$var$reEscapeChar, "$1") : number || match);
    });
    return result;
});
var $8e232e870bfb6095$export$2e2bcd8739ae039 = $8e232e870bfb6095$var$stringToPath;






/** Used as references for various `Number` constants. */ var $0910a19b4de51393$var$INFINITY = 1 / 0;
/** Used to convert symbols to primitives and strings. */ var $0910a19b4de51393$var$symbolProto = (0, $0fa9a02f9756f657$export$2e2bcd8739ae039) ? (0, $0fa9a02f9756f657$export$2e2bcd8739ae039).prototype : undefined, $0910a19b4de51393$var$symbolToString = $0910a19b4de51393$var$symbolProto ? $0910a19b4de51393$var$symbolProto.toString : undefined;
/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */ function $0910a19b4de51393$var$baseToString(value) {
    // Exit early for strings to avoid a performance hit in some environments.
    if (typeof value == "string") return value;
    if ((0, $98f8e0b2d1df3aed$export$2e2bcd8739ae039)(value)) // Recursively convert values (susceptible to call stack limits).
    return (0, $87593c1a2aec5b96$export$2e2bcd8739ae039)(value, $0910a19b4de51393$var$baseToString) + "";
    if ((0, $32500a1e560de4f0$export$2e2bcd8739ae039)(value)) return $0910a19b4de51393$var$symbolToString ? $0910a19b4de51393$var$symbolToString.call(value) : "";
    var result = value + "";
    return result == "0" && 1 / value == -$0910a19b4de51393$var$INFINITY ? "-0" : result;
}
var $0910a19b4de51393$export$2e2bcd8739ae039 = $0910a19b4de51393$var$baseToString;


/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */ function $e7dbb931e76f7087$var$toString(value) {
    return value == null ? "" : (0, $0910a19b4de51393$export$2e2bcd8739ae039)(value);
}
var $e7dbb931e76f7087$export$2e2bcd8739ae039 = $e7dbb931e76f7087$var$toString;


/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {Object} [object] The object to query keys on.
 * @returns {Array} Returns the cast property path array.
 */ function $fedb59fe7bda8dd7$var$castPath(value, object) {
    if ((0, $98f8e0b2d1df3aed$export$2e2bcd8739ae039)(value)) return value;
    return (0, $60c2115adfc4537b$export$2e2bcd8739ae039)(value, object) ? [
        value
    ] : (0, $8e232e870bfb6095$export$2e2bcd8739ae039)((0, $e7dbb931e76f7087$export$2e2bcd8739ae039)(value));
}
var $fedb59fe7bda8dd7$export$2e2bcd8739ae039 = $fedb59fe7bda8dd7$var$castPath;



/** Used as references for various `Number` constants. */ var $0190bb3b3a7b4f9b$var$INFINITY = 1 / 0;
/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */ function $0190bb3b3a7b4f9b$var$toKey(value) {
    if (typeof value == "string" || (0, $32500a1e560de4f0$export$2e2bcd8739ae039)(value)) return value;
    var result = value + "";
    return result == "0" && 1 / value == -$0190bb3b3a7b4f9b$var$INFINITY ? "-0" : result;
}
var $0190bb3b3a7b4f9b$export$2e2bcd8739ae039 = $0190bb3b3a7b4f9b$var$toKey;


/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */ function $6d95999d725df3ee$var$baseGet(object, path) {
    path = (0, $fedb59fe7bda8dd7$export$2e2bcd8739ae039)(path, object);
    var index = 0, length = path.length;
    while(object != null && index < length)object = object[(0, $0190bb3b3a7b4f9b$export$2e2bcd8739ae039)(path[index++])];
    return index && index == length ? object : undefined;
}
var $6d95999d725df3ee$export$2e2bcd8739ae039 = $6d95999d725df3ee$var$baseGet;


/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */ function $9c3fdca929d09a81$var$get(object, path, defaultValue) {
    var result = object == null ? undefined : (0, $6d95999d725df3ee$export$2e2bcd8739ae039)(object, path);
    return result === undefined ? defaultValue : result;
}
var $9c3fdca929d09a81$export$2e2bcd8739ae039 = $9c3fdca929d09a81$var$get;


/**
 * The base implementation of `_.hasIn` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */ function $d8e32567229ad059$var$baseHasIn(object, key) {
    return object != null && key in Object(object);
}
var $d8e32567229ad059$export$2e2bcd8739ae039 = $d8e32567229ad059$var$baseHasIn;








/**
 * Checks if `path` exists on `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @param {Function} hasFunc The function to check properties.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 */ function $3af52b2a73f196b3$var$hasPath(object, path, hasFunc) {
    path = (0, $fedb59fe7bda8dd7$export$2e2bcd8739ae039)(path, object);
    var index = -1, length = path.length, result = false;
    while(++index < length){
        var key = (0, $0190bb3b3a7b4f9b$export$2e2bcd8739ae039)(path[index]);
        if (!(result = object != null && hasFunc(object, key))) break;
        object = object[key];
    }
    if (result || ++index != length) return result;
    length = object == null ? 0 : object.length;
    return !!length && (0, $6c8a600bb2a3ff82$export$2e2bcd8739ae039)(length) && (0, $9561a998e411883c$export$2e2bcd8739ae039)(key, length) && ((0, $98f8e0b2d1df3aed$export$2e2bcd8739ae039)(object) || (0, $8be4c6075fd28431$export$2e2bcd8739ae039)(object));
}
var $3af52b2a73f196b3$export$2e2bcd8739ae039 = $3af52b2a73f196b3$var$hasPath;


/**
 * Checks if `path` is a direct or inherited property of `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.hasIn(object, 'a');
 * // => true
 *
 * _.hasIn(object, 'a.b');
 * // => true
 *
 * _.hasIn(object, ['a', 'b']);
 * // => true
 *
 * _.hasIn(object, 'b');
 * // => false
 */ function $a300848dcf01fd50$var$hasIn(object, path) {
    return object != null && (0, $3af52b2a73f196b3$export$2e2bcd8739ae039)(object, path, (0, $d8e32567229ad059$export$2e2bcd8739ae039));
}
var $a300848dcf01fd50$export$2e2bcd8739ae039 = $a300848dcf01fd50$var$hasIn;






/** Used to compose bitmasks for value comparisons. */ var $23a9dff12ab96f1d$var$COMPARE_PARTIAL_FLAG = 1, $23a9dff12ab96f1d$var$COMPARE_UNORDERED_FLAG = 2;
/**
 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
 *
 * @private
 * @param {string} path The path of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */ function $23a9dff12ab96f1d$var$baseMatchesProperty(path, srcValue) {
    if ((0, $60c2115adfc4537b$export$2e2bcd8739ae039)(path) && (0, $b450c9e17098dddf$export$2e2bcd8739ae039)(srcValue)) return (0, $f64ec5e30ac071a7$export$2e2bcd8739ae039)((0, $0190bb3b3a7b4f9b$export$2e2bcd8739ae039)(path), srcValue);
    return function(object) {
        var objValue = (0, $9c3fdca929d09a81$export$2e2bcd8739ae039)(object, path);
        return objValue === undefined && objValue === srcValue ? (0, $a300848dcf01fd50$export$2e2bcd8739ae039)(object, path) : (0, $378bb147bd9b5a4b$export$2e2bcd8739ae039)(srcValue, objValue, $23a9dff12ab96f1d$var$COMPARE_PARTIAL_FLAG | $23a9dff12ab96f1d$var$COMPARE_UNORDERED_FLAG);
    };
}
var $23a9dff12ab96f1d$export$2e2bcd8739ae039 = $23a9dff12ab96f1d$var$baseMatchesProperty;




/**
 * The base implementation of `_.property` without support for deep paths.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @returns {Function} Returns the new accessor function.
 */ function $3a8a79428b40c3c2$var$baseProperty(key) {
    return function(object) {
        return object == null ? undefined : object[key];
    };
}
var $3a8a79428b40c3c2$export$2e2bcd8739ae039 = $3a8a79428b40c3c2$var$baseProperty;



/**
 * A specialized version of `baseProperty` which supports deep paths.
 *
 * @private
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 */ function $474666629721954e$var$basePropertyDeep(path) {
    return function(object) {
        return (0, $6d95999d725df3ee$export$2e2bcd8739ae039)(object, path);
    };
}
var $474666629721954e$export$2e2bcd8739ae039 = $474666629721954e$var$basePropertyDeep;




/**
 * Creates a function that returns the value at `path` of a given object.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 * @example
 *
 * var objects = [
 *   { 'a': { 'b': 2 } },
 *   { 'a': { 'b': 1 } }
 * ];
 *
 * _.map(objects, _.property('a.b'));
 * // => [2, 1]
 *
 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
 * // => [1, 2]
 */ function $05ccf221698b453b$var$property(path) {
    return (0, $60c2115adfc4537b$export$2e2bcd8739ae039)(path) ? (0, $3a8a79428b40c3c2$export$2e2bcd8739ae039)((0, $0190bb3b3a7b4f9b$export$2e2bcd8739ae039)(path)) : (0, $474666629721954e$export$2e2bcd8739ae039)(path);
}
var $05ccf221698b453b$export$2e2bcd8739ae039 = $05ccf221698b453b$var$property;


/**
 * The base implementation of `_.iteratee`.
 *
 * @private
 * @param {*} [value=_.identity] The value to convert to an iteratee.
 * @returns {Function} Returns the iteratee.
 */ function $992e1b75c443508c$var$baseIteratee(value) {
    // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
    // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
    if (typeof value == "function") return value;
    if (value == null) return 0, $6ee142fec3d715f9$export$2e2bcd8739ae039;
    if (typeof value == "object") return (0, $98f8e0b2d1df3aed$export$2e2bcd8739ae039)(value) ? (0, $23a9dff12ab96f1d$export$2e2bcd8739ae039)(value[0], value[1]) : (0, $100cbc515654a755$export$2e2bcd8739ae039)(value);
    return (0, $05ccf221698b453b$export$2e2bcd8739ae039)(value);
}
var $992e1b75c443508c$export$2e2bcd8739ae039 = $992e1b75c443508c$var$baseIteratee;




/**
 * The base implementation of `_.map` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */ function $d625c83a08191933$var$baseMap(collection, iteratee) {
    var index = -1, result = (0, $1f3895d15a1c09ab$export$2e2bcd8739ae039)(collection) ? Array(collection.length) : [];
    (0, $400e71aec81f5fd3$export$2e2bcd8739ae039)(collection, function(value, key, collection) {
        result[++index] = iteratee(value, key, collection);
    });
    return result;
}
var $d625c83a08191933$export$2e2bcd8739ae039 = $d625c83a08191933$var$baseMap;



/**
 * Creates an array of values by running each element in `collection` thru
 * `iteratee`. The iteratee is invoked with three arguments:
 * (value, index|key, collection).
 *
 * Many lodash methods are guarded to work as iteratees for methods like
 * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
 *
 * The guarded methods are:
 * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
 * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
 * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
 * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 * @example
 *
 * function square(n) {
 *   return n * n;
 * }
 *
 * _.map([4, 8], square);
 * // => [16, 64]
 *
 * _.map({ 'a': 4, 'b': 8 }, square);
 * // => [16, 64] (iteration order is not guaranteed)
 *
 * var users = [
 *   { 'user': 'barney' },
 *   { 'user': 'fred' }
 * ];
 *
 * // The `_.property` iteratee shorthand.
 * _.map(users, 'user');
 * // => ['barney', 'fred']
 */ function $3d887f2aa95d4ff7$var$map(collection, iteratee) {
    var func = (0, $98f8e0b2d1df3aed$export$2e2bcd8739ae039)(collection) ? (0, $87593c1a2aec5b96$export$2e2bcd8739ae039) : (0, $d625c83a08191933$export$2e2bcd8739ae039);
    return func(collection, (0, $992e1b75c443508c$export$2e2bcd8739ae039)(iteratee, 3));
}
var $3d887f2aa95d4ff7$export$2e2bcd8739ae039 = $3d887f2aa95d4ff7$var$map;



var $ed2421d330d8d6d5$export$2ce88c5250e54734 = function BlockSwatches(_ref) {
    var colors = _ref.colors, onClick = _ref.onClick, onSwatchHover = _ref.onSwatchHover;
    var styles = (0, (/*@__PURE__*/$parcel$interopDefault($1e6d325bf7ec7d53$exports)))({
        "default": {
            swatches: {
                marginRight: "-10px"
            },
            swatch: {
                width: "22px",
                height: "22px",
                float: "left",
                marginRight: "10px",
                marginBottom: "10px",
                borderRadius: "4px"
            },
            clear: {
                clear: "both"
            }
        }
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("div", {
        style: styles.swatches
    }, (0, $3d887f2aa95d4ff7$export$2e2bcd8739ae039)(colors, function(c) {
        return (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $d738ffe146a16d78$export$2e2bcd8739ae039), {
            key: c,
            color: c,
            style: styles.swatch,
            onClick: onClick,
            onHover: onSwatchHover,
            focusStyle: {
                boxShadow: "0 0 4px " + c
            }
        });
    }), (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("div", {
        style: styles.clear
    }));
};
var $ed2421d330d8d6d5$export$2e2bcd8739ae039 = $ed2421d330d8d6d5$export$2ce88c5250e54734;


var $63e29efc39bf5571$export$d96a8827a60d6b69 = function Block(_ref) {
    var onChange = _ref.onChange, onSwatchHover = _ref.onSwatchHover, hex = _ref.hex, colors = _ref.colors, width = _ref.width, triangle = _ref.triangle, _ref$styles = _ref.styles, passedStyles = _ref$styles === undefined ? {} : _ref$styles, _ref$className = _ref.className, className = _ref$className === undefined ? "" : _ref$className;
    var transparent = hex === "transparent";
    var handleChange = function handleChange(hexCode, e) {
        $c667524adaf9821a$export$944f75ec5697b362(hexCode) && onChange({
            hex: hexCode,
            source: "hex"
        }, e);
    };
    var styles = (0, (/*@__PURE__*/$parcel$interopDefault($1e6d325bf7ec7d53$exports)))((0, $b3cb9f7788522a6d$export$2e2bcd8739ae039)({
        "default": {
            card: {
                width: width,
                background: "#fff",
                boxShadow: "0 1px rgba(0,0,0,.1)",
                borderRadius: "6px",
                position: "relative"
            },
            head: {
                height: "110px",
                background: hex,
                borderRadius: "6px 6px 0 0",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                position: "relative"
            },
            body: {
                padding: "10px"
            },
            label: {
                fontSize: "18px",
                color: $c667524adaf9821a$export$3609eb1d7e55dec(hex),
                position: "relative"
            },
            triangle: {
                width: "0px",
                height: "0px",
                borderStyle: "solid",
                borderWidth: "0 10px 10px 10px",
                borderColor: "transparent transparent " + hex + " transparent",
                position: "absolute",
                top: "-10px",
                left: "50%",
                marginLeft: "-10px"
            },
            input: {
                width: "100%",
                fontSize: "12px",
                color: "#666",
                border: "0px",
                outline: "none",
                height: "22px",
                boxShadow: "inset 0 0 0 1px #ddd",
                borderRadius: "4px",
                padding: "0 7px",
                boxSizing: "border-box"
            }
        },
        "hide-triangle": {
            triangle: {
                display: "none"
            }
        }
    }, passedStyles), {
        "hide-triangle": triangle === "hide"
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("div", {
        style: styles.card,
        className: "block-picker " + className
    }, (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("div", {
        style: styles.triangle
    }), (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("div", {
        style: styles.head
    }, transparent && (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $fb5ac1bea6cb3f9f$export$2e2bcd8739ae039), {
        borderRadius: "6px 6px 0 0"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("div", {
        style: styles.label
    }, hex)), (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("div", {
        style: styles.body
    }, (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $ed2421d330d8d6d5$export$2e2bcd8739ae039), {
        colors: colors,
        onClick: handleChange,
        onSwatchHover: onSwatchHover
    }), (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $daa8013ee334d911$export$2e2bcd8739ae039), {
        style: {
            input: styles.input
        },
        value: hex,
        onChange: handleChange
    })));
};
$63e29efc39bf5571$export$d96a8827a60d6b69.propTypes = {
    width: (0, (/*@__PURE__*/$parcel$interopDefault($aa40b802dd2fccfc$exports))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($aa40b802dd2fccfc$exports))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($aa40b802dd2fccfc$exports))).number
    ]),
    colors: (0, (/*@__PURE__*/$parcel$interopDefault($aa40b802dd2fccfc$exports))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($aa40b802dd2fccfc$exports))).string),
    triangle: (0, (/*@__PURE__*/$parcel$interopDefault($aa40b802dd2fccfc$exports))).oneOf([
        "top",
        "hide"
    ]),
    styles: (0, (/*@__PURE__*/$parcel$interopDefault($aa40b802dd2fccfc$exports))).object
};
$63e29efc39bf5571$export$d96a8827a60d6b69.defaultProps = {
    width: 170,
    colors: [
        "#D9E3F0",
        "#F47373",
        "#697689",
        "#37D67A",
        "#2CCCE4",
        "#555555",
        "#dce775",
        "#ff8a65",
        "#ba68c8"
    ],
    triangle: "top",
    styles: {}
};
var $63e29efc39bf5571$export$2e2bcd8739ae039 = (0, $13e2b01d2fc0abc5$export$2e2bcd8739ae039)($63e29efc39bf5571$export$d96a8827a60d6b69);



var $bh6RR = parcelRequire("bh6RR");




var $96be8cf58dd824fd$export$a90204d1394caf30 = {
    "50": "#ffebee",
    "100": "#ffcdd2",
    "200": "#ef9a9a",
    "300": "#e57373",
    "400": "#ef5350",
    "500": "#f44336",
    "600": "#e53935",
    "700": "#d32f2f",
    "800": "#c62828",
    "900": "#b71c1c",
    "a100": "#ff8a80",
    "a200": "#ff5252",
    "a400": "#ff1744",
    "a700": "#d50000"
};
var $96be8cf58dd824fd$export$47853bc718611763 = {
    "50": "#fce4ec",
    "100": "#f8bbd0",
    "200": "#f48fb1",
    "300": "#f06292",
    "400": "#ec407a",
    "500": "#e91e63",
    "600": "#d81b60",
    "700": "#c2185b",
    "800": "#ad1457",
    "900": "#880e4f",
    "a100": "#ff80ab",
    "a200": "#ff4081",
    "a400": "#f50057",
    "a700": "#c51162"
};
var $96be8cf58dd824fd$export$e13cce2a2d16a9d4 = {
    "50": "#f3e5f5",
    "100": "#e1bee7",
    "200": "#ce93d8",
    "300": "#ba68c8",
    "400": "#ab47bc",
    "500": "#9c27b0",
    "600": "#8e24aa",
    "700": "#7b1fa2",
    "800": "#6a1b9a",
    "900": "#4a148c",
    "a100": "#ea80fc",
    "a200": "#e040fb",
    "a400": "#d500f9",
    "a700": "#aa00ff"
};
var $96be8cf58dd824fd$export$51ef95b19086af57 = {
    "50": "#ede7f6",
    "100": "#d1c4e9",
    "200": "#b39ddb",
    "300": "#9575cd",
    "400": "#7e57c2",
    "500": "#673ab7",
    "600": "#5e35b1",
    "700": "#512da8",
    "800": "#4527a0",
    "900": "#311b92",
    "a100": "#b388ff",
    "a200": "#7c4dff",
    "a400": "#651fff",
    "a700": "#6200ea"
};
var $96be8cf58dd824fd$export$3e6ccc7b8562d453 = {
    "50": "#e8eaf6",
    "100": "#c5cae9",
    "200": "#9fa8da",
    "300": "#7986cb",
    "400": "#5c6bc0",
    "500": "#3f51b5",
    "600": "#3949ab",
    "700": "#303f9f",
    "800": "#283593",
    "900": "#1a237e",
    "a100": "#8c9eff",
    "a200": "#536dfe",
    "a400": "#3d5afe",
    "a700": "#304ffe"
};
var $96be8cf58dd824fd$export$2aa0182783e7e9de = {
    "50": "#e3f2fd",
    "100": "#bbdefb",
    "200": "#90caf9",
    "300": "#64b5f6",
    "400": "#42a5f5",
    "500": "#2196f3",
    "600": "#1e88e5",
    "700": "#1976d2",
    "800": "#1565c0",
    "900": "#0d47a1",
    "a100": "#82b1ff",
    "a200": "#448aff",
    "a400": "#2979ff",
    "a700": "#2962ff"
};
var $96be8cf58dd824fd$export$7b0d29b70b435c21 = {
    "50": "#e1f5fe",
    "100": "#b3e5fc",
    "200": "#81d4fa",
    "300": "#4fc3f7",
    "400": "#29b6f6",
    "500": "#03a9f4",
    "600": "#039be5",
    "700": "#0288d1",
    "800": "#0277bd",
    "900": "#01579b",
    "a100": "#80d8ff",
    "a200": "#40c4ff",
    "a400": "#00b0ff",
    "a700": "#0091ea"
};
var $96be8cf58dd824fd$export$7474046f446842ee = {
    "50": "#e0f7fa",
    "100": "#b2ebf2",
    "200": "#80deea",
    "300": "#4dd0e1",
    "400": "#26c6da",
    "500": "#00bcd4",
    "600": "#00acc1",
    "700": "#0097a7",
    "800": "#00838f",
    "900": "#006064",
    "a100": "#84ffff",
    "a200": "#18ffff",
    "a400": "#00e5ff",
    "a700": "#00b8d4"
};
var $96be8cf58dd824fd$export$8bf7dff220b82b4a = {
    "50": "#e0f2f1",
    "100": "#b2dfdb",
    "200": "#80cbc4",
    "300": "#4db6ac",
    "400": "#26a69a",
    "500": "#009688",
    "600": "#00897b",
    "700": "#00796b",
    "800": "#00695c",
    "900": "#004d40",
    "a100": "#a7ffeb",
    "a200": "#64ffda",
    "a400": "#1de9b6",
    "a700": "#00bfa5"
};
var $96be8cf58dd824fd$export$955a2ebd2fb142ae = {
    "50": "#e8f5e9",
    "100": "#c8e6c9",
    "200": "#a5d6a7",
    "300": "#81c784",
    "400": "#66bb6a",
    "500": "#4caf50",
    "600": "#43a047",
    "700": "#388e3c",
    "800": "#2e7d32",
    "900": "#1b5e20",
    "a100": "#b9f6ca",
    "a200": "#69f0ae",
    "a400": "#00e676",
    "a700": "#00c853"
};
var $96be8cf58dd824fd$export$559a8c00376dc936 = {
    "50": "#f1f8e9",
    "100": "#dcedc8",
    "200": "#c5e1a5",
    "300": "#aed581",
    "400": "#9ccc65",
    "500": "#8bc34a",
    "600": "#7cb342",
    "700": "#689f38",
    "800": "#558b2f",
    "900": "#33691e",
    "a100": "#ccff90",
    "a200": "#b2ff59",
    "a400": "#76ff03",
    "a700": "#64dd17"
};
var $96be8cf58dd824fd$export$221d31baf2636aad = {
    "50": "#f9fbe7",
    "100": "#f0f4c3",
    "200": "#e6ee9c",
    "300": "#dce775",
    "400": "#d4e157",
    "500": "#cddc39",
    "600": "#c0ca33",
    "700": "#afb42b",
    "800": "#9e9d24",
    "900": "#827717",
    "a100": "#f4ff81",
    "a200": "#eeff41",
    "a400": "#c6ff00",
    "a700": "#aeea00"
};
var $96be8cf58dd824fd$export$594c5a8758200c32 = {
    "50": "#fffde7",
    "100": "#fff9c4",
    "200": "#fff59d",
    "300": "#fff176",
    "400": "#ffee58",
    "500": "#ffeb3b",
    "600": "#fdd835",
    "700": "#fbc02d",
    "800": "#f9a825",
    "900": "#f57f17",
    "a100": "#ffff8d",
    "a200": "#ffff00",
    "a400": "#ffea00",
    "a700": "#ffd600"
};
var $96be8cf58dd824fd$export$7c1ecc66643fdbd6 = {
    "50": "#fff8e1",
    "100": "#ffecb3",
    "200": "#ffe082",
    "300": "#ffd54f",
    "400": "#ffca28",
    "500": "#ffc107",
    "600": "#ffb300",
    "700": "#ffa000",
    "800": "#ff8f00",
    "900": "#ff6f00",
    "a100": "#ffe57f",
    "a200": "#ffd740",
    "a400": "#ffc400",
    "a700": "#ffab00"
};
var $96be8cf58dd824fd$export$ad766f34ace1cafd = {
    "50": "#fff3e0",
    "100": "#ffe0b2",
    "200": "#ffcc80",
    "300": "#ffb74d",
    "400": "#ffa726",
    "500": "#ff9800",
    "600": "#fb8c00",
    "700": "#f57c00",
    "800": "#ef6c00",
    "900": "#e65100",
    "a100": "#ffd180",
    "a200": "#ffab40",
    "a400": "#ff9100",
    "a700": "#ff6d00"
};
var $96be8cf58dd824fd$export$1ceed3dd9ec11704 = {
    "50": "#fbe9e7",
    "100": "#ffccbc",
    "200": "#ffab91",
    "300": "#ff8a65",
    "400": "#ff7043",
    "500": "#ff5722",
    "600": "#f4511e",
    "700": "#e64a19",
    "800": "#d84315",
    "900": "#bf360c",
    "a100": "#ff9e80",
    "a200": "#ff6e40",
    "a400": "#ff3d00",
    "a700": "#dd2c00"
};
var $96be8cf58dd824fd$export$b6e6178d3f565007 = {
    "50": "#efebe9",
    "100": "#d7ccc8",
    "200": "#bcaaa4",
    "300": "#a1887f",
    "400": "#8d6e63",
    "500": "#795548",
    "600": "#6d4c41",
    "700": "#5d4037",
    "800": "#4e342e",
    "900": "#3e2723"
};
var $96be8cf58dd824fd$export$e4c89085febbc618 = {
    "50": "#fafafa",
    "100": "#f5f5f5",
    "200": "#eeeeee",
    "300": "#e0e0e0",
    "400": "#bdbdbd",
    "500": "#9e9e9e",
    "600": "#757575",
    "700": "#616161",
    "800": "#424242",
    "900": "#212121"
};
var $96be8cf58dd824fd$export$7c2da42d08c019c9 = {
    "50": "#eceff1",
    "100": "#cfd8dc",
    "200": "#b0bec5",
    "300": "#90a4ae",
    "400": "#78909c",
    "500": "#607d8b",
    "600": "#546e7a",
    "700": "#455a64",
    "800": "#37474f",
    "900": "#263238"
};
var $96be8cf58dd824fd$export$b413907788b50267 = {
    "primary": "rgba(0, 0, 0, 0.87)",
    "secondary": "rgba(0, 0, 0, 0.54)",
    "disabled": "rgba(0, 0, 0, 0.38)",
    "dividers": "rgba(0, 0, 0, 0.12)"
};
var $96be8cf58dd824fd$export$c962f8177a273028 = {
    "primary": "rgba(255, 255, 255, 1)",
    "secondary": "rgba(255, 255, 255, 0.7)",
    "disabled": "rgba(255, 255, 255, 0.5)",
    "dividers": "rgba(255, 255, 255, 0.12)"
};
var $96be8cf58dd824fd$export$969f6c634341b5cf = {
    "active": "rgba(0, 0, 0, 0.54)",
    "inactive": "rgba(0, 0, 0, 0.38)"
};
var $96be8cf58dd824fd$export$6b4a43519c60f4b1 = {
    "active": "rgba(255, 255, 255, 1)",
    "inactive": "rgba(255, 255, 255, 0.5)"
};
var $96be8cf58dd824fd$export$8fa4e5556fd77a60 = "#ffffff";
var $96be8cf58dd824fd$export$c073df10e766abfa = "#000000";
var $96be8cf58dd824fd$export$2e2bcd8739ae039 = {
    red: $96be8cf58dd824fd$export$a90204d1394caf30,
    pink: $96be8cf58dd824fd$export$47853bc718611763,
    purple: $96be8cf58dd824fd$export$e13cce2a2d16a9d4,
    deepPurple: $96be8cf58dd824fd$export$51ef95b19086af57,
    indigo: $96be8cf58dd824fd$export$3e6ccc7b8562d453,
    blue: $96be8cf58dd824fd$export$2aa0182783e7e9de,
    lightBlue: $96be8cf58dd824fd$export$7b0d29b70b435c21,
    cyan: $96be8cf58dd824fd$export$7474046f446842ee,
    teal: $96be8cf58dd824fd$export$8bf7dff220b82b4a,
    green: $96be8cf58dd824fd$export$955a2ebd2fb142ae,
    lightGreen: $96be8cf58dd824fd$export$559a8c00376dc936,
    lime: $96be8cf58dd824fd$export$221d31baf2636aad,
    yellow: $96be8cf58dd824fd$export$594c5a8758200c32,
    amber: $96be8cf58dd824fd$export$7c1ecc66643fdbd6,
    orange: $96be8cf58dd824fd$export$ad766f34ace1cafd,
    deepOrange: $96be8cf58dd824fd$export$1ceed3dd9ec11704,
    brown: $96be8cf58dd824fd$export$b6e6178d3f565007,
    grey: $96be8cf58dd824fd$export$e4c89085febbc618,
    blueGrey: $96be8cf58dd824fd$export$7c2da42d08c019c9,
    darkText: $96be8cf58dd824fd$export$b413907788b50267,
    lightText: $96be8cf58dd824fd$export$c962f8177a273028,
    darkIcons: $96be8cf58dd824fd$export$969f6c634341b5cf,
    lightIcons: $96be8cf58dd824fd$export$6b4a43519c60f4b1,
    white: $96be8cf58dd824fd$export$8fa4e5556fd77a60,
    black: $96be8cf58dd824fd$export$c073df10e766abfa
};




var $bh6RR = parcelRequire("bh6RR");


var $da170e7e5f538f80$export$945d5c8ebb42b0ff = function CircleSwatch(_ref) {
    var color = _ref.color, onClick = _ref.onClick, onSwatchHover = _ref.onSwatchHover, hover = _ref.hover, active = _ref.active, circleSize = _ref.circleSize, circleSpacing = _ref.circleSpacing;
    var styles = (0, (/*@__PURE__*/$parcel$interopDefault($1e6d325bf7ec7d53$exports)))({
        "default": {
            swatch: {
                width: circleSize,
                height: circleSize,
                marginRight: circleSpacing,
                marginBottom: circleSpacing,
                transform: "scale(1)",
                transition: "100ms transform ease"
            },
            Swatch: {
                borderRadius: "50%",
                background: "transparent",
                boxShadow: "inset 0 0 0 " + (circleSize / 2 + 1) + "px " + color,
                transition: "100ms box-shadow ease"
            }
        },
        "hover": {
            swatch: {
                transform: "scale(1.2)"
            }
        },
        "active": {
            Swatch: {
                boxShadow: "inset 0 0 0 3px " + color
            }
        }
    }, {
        hover: hover,
        active: active
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("div", {
        style: styles.swatch
    }, (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $d738ffe146a16d78$export$2e2bcd8739ae039), {
        style: styles.Swatch,
        color: color,
        onClick: onClick,
        onHover: onSwatchHover,
        focusStyle: {
            boxShadow: styles.Swatch.boxShadow + ", 0 0 5px " + color
        }
    }));
};
$da170e7e5f538f80$export$945d5c8ebb42b0ff.defaultProps = {
    circleSize: 28,
    circleSpacing: 14
};
var $da170e7e5f538f80$export$2e2bcd8739ae039 = (0, $1e6d325bf7ec7d53$exports.handleHover)($da170e7e5f538f80$export$945d5c8ebb42b0ff);


var $5259611e97c445de$export$c89a927ffc67e6fa = function Circle(_ref) {
    var width = _ref.width, onChange = _ref.onChange, onSwatchHover = _ref.onSwatchHover, colors = _ref.colors, hex = _ref.hex, circleSize = _ref.circleSize, _ref$styles = _ref.styles, passedStyles = _ref$styles === undefined ? {} : _ref$styles, circleSpacing = _ref.circleSpacing, _ref$className = _ref.className, className = _ref$className === undefined ? "" : _ref$className;
    var styles = (0, (/*@__PURE__*/$parcel$interopDefault($1e6d325bf7ec7d53$exports)))((0, $b3cb9f7788522a6d$export$2e2bcd8739ae039)({
        "default": {
            card: {
                width: width,
                display: "flex",
                flexWrap: "wrap",
                marginRight: -circleSpacing,
                marginBottom: -circleSpacing
            }
        }
    }, passedStyles));
    var handleChange = function handleChange(hexCode, e) {
        return onChange({
            hex: hexCode,
            source: "hex"
        }, e);
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("div", {
        style: styles.card,
        className: "circle-picker " + className
    }, (0, $3d887f2aa95d4ff7$export$2e2bcd8739ae039)(colors, function(c) {
        return (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $da170e7e5f538f80$export$2e2bcd8739ae039), {
            key: c,
            color: c,
            onClick: handleChange,
            onSwatchHover: onSwatchHover,
            active: hex === c.toLowerCase(),
            circleSize: circleSize,
            circleSpacing: circleSpacing
        });
    }));
};
$5259611e97c445de$export$c89a927ffc67e6fa.propTypes = {
    width: (0, (/*@__PURE__*/$parcel$interopDefault($aa40b802dd2fccfc$exports))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($aa40b802dd2fccfc$exports))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($aa40b802dd2fccfc$exports))).number
    ]),
    circleSize: (0, (/*@__PURE__*/$parcel$interopDefault($aa40b802dd2fccfc$exports))).number,
    circleSpacing: (0, (/*@__PURE__*/$parcel$interopDefault($aa40b802dd2fccfc$exports))).number,
    styles: (0, (/*@__PURE__*/$parcel$interopDefault($aa40b802dd2fccfc$exports))).object
};
$5259611e97c445de$export$c89a927ffc67e6fa.defaultProps = {
    width: 252,
    circleSize: 28,
    circleSpacing: 14,
    colors: [
        $96be8cf58dd824fd$export$a90204d1394caf30["500"],
        $96be8cf58dd824fd$export$47853bc718611763["500"],
        $96be8cf58dd824fd$export$e13cce2a2d16a9d4["500"],
        $96be8cf58dd824fd$export$51ef95b19086af57["500"],
        $96be8cf58dd824fd$export$3e6ccc7b8562d453["500"],
        $96be8cf58dd824fd$export$2aa0182783e7e9de["500"],
        $96be8cf58dd824fd$export$7b0d29b70b435c21["500"],
        $96be8cf58dd824fd$export$7474046f446842ee["500"],
        $96be8cf58dd824fd$export$8bf7dff220b82b4a["500"],
        $96be8cf58dd824fd$export$955a2ebd2fb142ae["500"],
        $96be8cf58dd824fd$export$559a8c00376dc936["500"],
        $96be8cf58dd824fd$export$221d31baf2636aad["500"],
        $96be8cf58dd824fd$export$594c5a8758200c32["500"],
        $96be8cf58dd824fd$export$7c1ecc66643fdbd6["500"],
        $96be8cf58dd824fd$export$ad766f34ace1cafd["500"],
        $96be8cf58dd824fd$export$1ceed3dd9ec11704["500"],
        $96be8cf58dd824fd$export$b6e6178d3f565007["500"],
        $96be8cf58dd824fd$export$7c2da42d08c019c9["500"]
    ],
    styles: {}
};
var $5259611e97c445de$export$2e2bcd8739ae039 = (0, $13e2b01d2fc0abc5$export$2e2bcd8739ae039)($5259611e97c445de$export$c89a927ffc67e6fa);



var $bh6RR = parcelRequire("bh6RR");





var $bh6RR = parcelRequire("bh6RR");


/**
 * Checks if `value` is `undefined`.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
 * @example
 *
 * _.isUndefined(void 0);
 * // => true
 *
 * _.isUndefined(null);
 * // => false
 */ function $db753d70eb880c4b$var$isUndefined(value) {
    return value === undefined;
}
var $db753d70eb880c4b$export$2e2bcd8739ae039 = $db753d70eb880c4b$var$isUndefined;



var $cdfbb8cef963ed41$exports = {};
"use strict";
Object.defineProperty($cdfbb8cef963ed41$exports, "__esModule", {
    value: true
});
var $cdfbb8cef963ed41$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};

var $bh6RR = parcelRequire("bh6RR");
var $cdfbb8cef963ed41$var$_react2 = $cdfbb8cef963ed41$var$_interopRequireDefault($bh6RR);
function $cdfbb8cef963ed41$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $cdfbb8cef963ed41$var$_objectWithoutProperties(obj, keys) {
    var target = {};
    for(var i in obj){
        if (keys.indexOf(i) >= 0) continue;
        if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
        target[i] = obj[i];
    }
    return target;
}
var $cdfbb8cef963ed41$var$DEFAULT_SIZE = 24;
$cdfbb8cef963ed41$exports.default = function(_ref) {
    var _ref$fill = _ref.fill, fill = _ref$fill === undefined ? "currentColor" : _ref$fill, _ref$width = _ref.width, width = _ref$width === undefined ? $cdfbb8cef963ed41$var$DEFAULT_SIZE : _ref$width, _ref$height = _ref.height, height = _ref$height === undefined ? $cdfbb8cef963ed41$var$DEFAULT_SIZE : _ref$height, _ref$style = _ref.style, style = _ref$style === undefined ? {} : _ref$style, props = $cdfbb8cef963ed41$var$_objectWithoutProperties(_ref, [
        "fill",
        "width",
        "height",
        "style"
    ]);
    return $cdfbb8cef963ed41$var$_react2.default.createElement("svg", $cdfbb8cef963ed41$var$_extends({
        viewBox: "0 0 " + $cdfbb8cef963ed41$var$DEFAULT_SIZE + " " + $cdfbb8cef963ed41$var$DEFAULT_SIZE,
        style: $cdfbb8cef963ed41$var$_extends({
            fill: fill,
            width: width,
            height: height
        }, style)
    }, props), $cdfbb8cef963ed41$var$_react2.default.createElement("path", {
        d: "M12,18.17L8.83,15L7.42,16.41L12,21L16.59,16.41L15.17,15M12,5.83L15.17,9L16.58,7.59L12,3L7.41,7.59L8.83,9L12,5.83Z"
    }));
};


var $8935e85d31d021e0$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();
function $8935e85d31d021e0$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $8935e85d31d021e0$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $8935e85d31d021e0$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var $8935e85d31d021e0$export$71685d48a2432635 = function(_React$Component) {
    $8935e85d31d021e0$var$_inherits(ChromeFields, _React$Component);
    function ChromeFields(props) {
        $8935e85d31d021e0$var$_classCallCheck(this, ChromeFields);
        var _this = $8935e85d31d021e0$var$_possibleConstructorReturn(this, (ChromeFields.__proto__ || Object.getPrototypeOf(ChromeFields)).call(this));
        _this.toggleViews = function() {
            if (_this.state.view === "hex") _this.setState({
                view: "rgb"
            });
            else if (_this.state.view === "rgb") _this.setState({
                view: "hsl"
            });
            else if (_this.state.view === "hsl") {
                if (_this.props.hsl.a === 1) _this.setState({
                    view: "hex"
                });
                else _this.setState({
                    view: "rgb"
                });
            }
        };
        _this.handleChange = function(data, e) {
            if (data.hex) $c667524adaf9821a$export$944f75ec5697b362(data.hex) && _this.props.onChange({
                hex: data.hex,
                source: "hex"
            }, e);
            else if (data.r || data.g || data.b) _this.props.onChange({
                r: data.r || _this.props.rgb.r,
                g: data.g || _this.props.rgb.g,
                b: data.b || _this.props.rgb.b,
                source: "rgb"
            }, e);
            else if (data.a) {
                if (data.a < 0) data.a = 0;
                else if (data.a > 1) data.a = 1;
                _this.props.onChange({
                    h: _this.props.hsl.h,
                    s: _this.props.hsl.s,
                    l: _this.props.hsl.l,
                    a: Math.round(data.a * 100) / 100,
                    source: "rgb"
                }, e);
            } else if (data.h || data.s || data.l) {
                // Remove any occurances of '%'.
                if (typeof data.s === "string" && data.s.includes("%")) data.s = data.s.replace("%", "");
                if (typeof data.l === "string" && data.l.includes("%")) data.l = data.l.replace("%", "");
                // We store HSL as a unit interval so we need to override the 1 input to 0.01
                if (data.s == 1) data.s = 0.01;
                else if (data.l == 1) data.l = 0.01;
                _this.props.onChange({
                    h: data.h || _this.props.hsl.h,
                    s: Number(!(0, $db753d70eb880c4b$export$2e2bcd8739ae039)(data.s) ? data.s : _this.props.hsl.s),
                    l: Number(!(0, $db753d70eb880c4b$export$2e2bcd8739ae039)(data.l) ? data.l : _this.props.hsl.l),
                    source: "hsl"
                }, e);
            }
        };
        _this.showHighlight = function(e) {
            e.currentTarget.style.background = "#eee";
        };
        _this.hideHighlight = function(e) {
            e.currentTarget.style.background = "transparent";
        };
        if (props.hsl.a !== 1 && props.view === "hex") _this.state = {
            view: "rgb"
        };
        else _this.state = {
            view: props.view
        };
        return _this;
    }
    $8935e85d31d021e0$var$_createClass(ChromeFields, [
        {
            key: "render",
            value: function render() {
                var _this2 = this;
                var styles = (0, (/*@__PURE__*/$parcel$interopDefault($1e6d325bf7ec7d53$exports)))({
                    "default": {
                        wrap: {
                            paddingTop: "16px",
                            display: "flex"
                        },
                        fields: {
                            flex: "1",
                            display: "flex",
                            marginLeft: "-6px"
                        },
                        field: {
                            paddingLeft: "6px",
                            width: "100%"
                        },
                        alpha: {
                            paddingLeft: "6px",
                            width: "100%"
                        },
                        toggle: {
                            width: "32px",
                            textAlign: "right",
                            position: "relative"
                        },
                        icon: {
                            marginRight: "-4px",
                            marginTop: "12px",
                            cursor: "pointer",
                            position: "relative"
                        },
                        iconHighlight: {
                            position: "absolute",
                            width: "24px",
                            height: "28px",
                            background: "#eee",
                            borderRadius: "4px",
                            top: "10px",
                            left: "12px",
                            display: "none"
                        },
                        input: {
                            fontSize: "11px",
                            color: "#333",
                            width: "100%",
                            borderRadius: "2px",
                            border: "none",
                            boxShadow: "inset 0 0 0 1px #dadada",
                            height: "21px",
                            textAlign: "center"
                        },
                        label: {
                            textTransform: "uppercase",
                            fontSize: "11px",
                            lineHeight: "11px",
                            color: "#969696",
                            textAlign: "center",
                            display: "block",
                            marginTop: "12px"
                        },
                        svg: {
                            fill: "#333",
                            width: "24px",
                            height: "24px",
                            border: "1px transparent solid",
                            borderRadius: "5px"
                        }
                    },
                    "disableAlpha": {
                        alpha: {
                            display: "none"
                        }
                    }
                }, this.props, this.state);
                var fields = void 0;
                if (this.state.view === "hex") fields = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("div", {
                    style: styles.fields,
                    className: "flexbox-fix"
                }, (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("div", {
                    style: styles.field
                }, (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $daa8013ee334d911$export$2e2bcd8739ae039), {
                    style: {
                        input: styles.input,
                        label: styles.label
                    },
                    label: "hex",
                    value: this.props.hex,
                    onChange: this.handleChange
                })));
                else if (this.state.view === "rgb") fields = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("div", {
                    style: styles.fields,
                    className: "flexbox-fix"
                }, (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("div", {
                    style: styles.field
                }, (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $daa8013ee334d911$export$2e2bcd8739ae039), {
                    style: {
                        input: styles.input,
                        label: styles.label
                    },
                    label: "r",
                    value: this.props.rgb.r,
                    onChange: this.handleChange
                })), (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("div", {
                    style: styles.field
                }, (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $daa8013ee334d911$export$2e2bcd8739ae039), {
                    style: {
                        input: styles.input,
                        label: styles.label
                    },
                    label: "g",
                    value: this.props.rgb.g,
                    onChange: this.handleChange
                })), (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("div", {
                    style: styles.field
                }, (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $daa8013ee334d911$export$2e2bcd8739ae039), {
                    style: {
                        input: styles.input,
                        label: styles.label
                    },
                    label: "b",
                    value: this.props.rgb.b,
                    onChange: this.handleChange
                })), (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("div", {
                    style: styles.alpha
                }, (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $daa8013ee334d911$export$2e2bcd8739ae039), {
                    style: {
                        input: styles.input,
                        label: styles.label
                    },
                    label: "a",
                    value: this.props.rgb.a,
                    arrowOffset: 0.01,
                    onChange: this.handleChange
                })));
                else if (this.state.view === "hsl") fields = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("div", {
                    style: styles.fields,
                    className: "flexbox-fix"
                }, (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("div", {
                    style: styles.field
                }, (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $daa8013ee334d911$export$2e2bcd8739ae039), {
                    style: {
                        input: styles.input,
                        label: styles.label
                    },
                    label: "h",
                    value: Math.round(this.props.hsl.h),
                    onChange: this.handleChange
                })), (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("div", {
                    style: styles.field
                }, (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $daa8013ee334d911$export$2e2bcd8739ae039), {
                    style: {
                        input: styles.input,
                        label: styles.label
                    },
                    label: "s",
                    value: Math.round(this.props.hsl.s * 100) + "%",
                    onChange: this.handleChange
                })), (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("div", {
                    style: styles.field
                }, (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $daa8013ee334d911$export$2e2bcd8739ae039), {
                    style: {
                        input: styles.input,
                        label: styles.label
                    },
                    label: "l",
                    value: Math.round(this.props.hsl.l * 100) + "%",
                    onChange: this.handleChange
                })), (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("div", {
                    style: styles.alpha
                }, (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $daa8013ee334d911$export$2e2bcd8739ae039), {
                    style: {
                        input: styles.input,
                        label: styles.label
                    },
                    label: "a",
                    value: this.props.hsl.a,
                    arrowOffset: 0.01,
                    onChange: this.handleChange
                })));
                return (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("div", {
                    style: styles.wrap,
                    className: "flexbox-fix"
                }, fields, (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("div", {
                    style: styles.toggle
                }, (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("div", {
                    style: styles.icon,
                    onClick: this.toggleViews,
                    ref: function ref(icon) {
                        return _this2.icon = icon;
                    }
                }, (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cdfbb8cef963ed41$exports))), {
                    style: styles.svg,
                    onMouseOver: this.showHighlight,
                    onMouseEnter: this.showHighlight,
                    onMouseOut: this.hideHighlight
                }))));
            }
        }
    ], [
        {
            key: "getDerivedStateFromProps",
            value: function getDerivedStateFromProps(nextProps, state) {
                if (nextProps.hsl.a !== 1 && state.view === "hex") return {
                    view: "rgb"
                };
                return null;
            }
        }
    ]);
    return ChromeFields;
}((0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).Component);
$8935e85d31d021e0$export$71685d48a2432635.defaultProps = {
    view: "hex"
};
var $8935e85d31d021e0$export$2e2bcd8739ae039 = $8935e85d31d021e0$export$71685d48a2432635;



var $bh6RR = parcelRequire("bh6RR");

var $281b29e9ad71dd91$export$a632586f9a957100 = function ChromePointer() {
    var styles = (0, (/*@__PURE__*/$parcel$interopDefault($1e6d325bf7ec7d53$exports)))({
        "default": {
            picker: {
                width: "12px",
                height: "12px",
                borderRadius: "6px",
                transform: "translate(-6px, -1px)",
                backgroundColor: "rgb(248, 248, 248)",
                boxShadow: "0 1px 4px 0 rgba(0, 0, 0, 0.37)"
            }
        }
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("div", {
        style: styles.picker
    });
};
var $281b29e9ad71dd91$export$2e2bcd8739ae039 = $281b29e9ad71dd91$export$a632586f9a957100;



var $bh6RR = parcelRequire("bh6RR");

var $7f61e835826e62c3$export$190c1afe887f7ef7 = function ChromePointerCircle() {
    var styles = (0, (/*@__PURE__*/$parcel$interopDefault($1e6d325bf7ec7d53$exports)))({
        "default": {
            picker: {
                width: "12px",
                height: "12px",
                borderRadius: "6px",
                boxShadow: "inset 0 0 0 1px #fff",
                transform: "translate(-6px, -6px)"
            }
        }
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("div", {
        style: styles.picker
    });
};
var $7f61e835826e62c3$export$2e2bcd8739ae039 = $7f61e835826e62c3$export$190c1afe887f7ef7;


var $bfc36375d454a39c$export$31a305e9779b48b4 = function Chrome(_ref) {
    var width = _ref.width, onChange = _ref.onChange, disableAlpha = _ref.disableAlpha, rgb = _ref.rgb, hsl = _ref.hsl, hsv = _ref.hsv, hex = _ref.hex, renderers = _ref.renderers, _ref$styles = _ref.styles, passedStyles = _ref$styles === undefined ? {} : _ref$styles, _ref$className = _ref.className, className = _ref$className === undefined ? "" : _ref$className, defaultView = _ref.defaultView;
    var styles = (0, (/*@__PURE__*/$parcel$interopDefault($1e6d325bf7ec7d53$exports)))((0, $b3cb9f7788522a6d$export$2e2bcd8739ae039)({
        "default": {
            picker: {
                width: width,
                background: "#fff",
                borderRadius: "2px",
                boxShadow: "0 0 2px rgba(0,0,0,.3), 0 4px 8px rgba(0,0,0,.3)",
                boxSizing: "initial",
                fontFamily: "Menlo"
            },
            saturation: {
                width: "100%",
                paddingBottom: "55%",
                position: "relative",
                borderRadius: "2px 2px 0 0",
                overflow: "hidden"
            },
            Saturation: {
                radius: "2px 2px 0 0"
            },
            body: {
                padding: "16px 16px 12px"
            },
            controls: {
                display: "flex"
            },
            color: {
                width: "32px"
            },
            swatch: {
                marginTop: "6px",
                width: "16px",
                height: "16px",
                borderRadius: "8px",
                position: "relative",
                overflow: "hidden"
            },
            active: {
                absolute: "0px 0px 0px 0px",
                borderRadius: "8px",
                boxShadow: "inset 0 0 0 1px rgba(0,0,0,.1)",
                background: "rgba(" + rgb.r + ", " + rgb.g + ", " + rgb.b + ", " + rgb.a + ")",
                zIndex: "2"
            },
            toggles: {
                flex: "1"
            },
            hue: {
                height: "10px",
                position: "relative",
                marginBottom: "8px"
            },
            Hue: {
                radius: "2px"
            },
            alpha: {
                height: "10px",
                position: "relative"
            },
            Alpha: {
                radius: "2px"
            }
        },
        "disableAlpha": {
            color: {
                width: "22px"
            },
            alpha: {
                display: "none"
            },
            hue: {
                marginBottom: "0px"
            },
            swatch: {
                width: "10px",
                height: "10px",
                marginTop: "0px"
            }
        }
    }, passedStyles), {
        disableAlpha: disableAlpha
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("div", {
        style: styles.picker,
        className: "chrome-picker " + className
    }, (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("div", {
        style: styles.saturation
    }, (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $5a5024834f3556d9$export$2e2bcd8739ae039), {
        style: styles.Saturation,
        hsl: hsl,
        hsv: hsv,
        pointer: (0, $7f61e835826e62c3$export$2e2bcd8739ae039),
        onChange: onChange
    })), (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("div", {
        style: styles.body
    }, (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("div", {
        style: styles.controls,
        className: "flexbox-fix"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("div", {
        style: styles.color
    }, (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("div", {
        style: styles.swatch
    }, (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("div", {
        style: styles.active
    }), (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $fb5ac1bea6cb3f9f$export$2e2bcd8739ae039), {
        renderers: renderers
    }))), (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("div", {
        style: styles.toggles
    }, (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("div", {
        style: styles.hue
    }, (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $27b1902952abffb6$export$2e2bcd8739ae039), {
        style: styles.Hue,
        hsl: hsl,
        pointer: (0, $281b29e9ad71dd91$export$2e2bcd8739ae039),
        onChange: onChange
    })), (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("div", {
        style: styles.alpha
    }, (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $2b76dc783bc34760$export$2e2bcd8739ae039), {
        style: styles.Alpha,
        rgb: rgb,
        hsl: hsl,
        pointer: (0, $281b29e9ad71dd91$export$2e2bcd8739ae039),
        renderers: renderers,
        onChange: onChange
    })))), (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $8935e85d31d021e0$export$2e2bcd8739ae039), {
        rgb: rgb,
        hsl: hsl,
        hex: hex,
        view: defaultView,
        onChange: onChange,
        disableAlpha: disableAlpha
    })));
};
$bfc36375d454a39c$export$31a305e9779b48b4.propTypes = {
    width: (0, (/*@__PURE__*/$parcel$interopDefault($aa40b802dd2fccfc$exports))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($aa40b802dd2fccfc$exports))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($aa40b802dd2fccfc$exports))).number
    ]),
    disableAlpha: (0, (/*@__PURE__*/$parcel$interopDefault($aa40b802dd2fccfc$exports))).bool,
    styles: (0, (/*@__PURE__*/$parcel$interopDefault($aa40b802dd2fccfc$exports))).object,
    defaultView: (0, (/*@__PURE__*/$parcel$interopDefault($aa40b802dd2fccfc$exports))).oneOf([
        "hex",
        "rgb",
        "hsl"
    ])
};
$bfc36375d454a39c$export$31a305e9779b48b4.defaultProps = {
    width: 225,
    disableAlpha: false,
    styles: {}
};
var $bfc36375d454a39c$export$2e2bcd8739ae039 = (0, $13e2b01d2fc0abc5$export$2e2bcd8739ae039)($bfc36375d454a39c$export$31a305e9779b48b4);



var $bh6RR = parcelRequire("bh6RR");







var $bh6RR = parcelRequire("bh6RR");



var $e6126a90ee6594b9$export$df654652e5203306 = function CompactColor(_ref) {
    var color = _ref.color, _ref$onClick = _ref.onClick, onClick = _ref$onClick === undefined ? function() {} : _ref$onClick, onSwatchHover = _ref.onSwatchHover, active = _ref.active;
    var styles = (0, (/*@__PURE__*/$parcel$interopDefault($1e6d325bf7ec7d53$exports)))({
        "default": {
            color: {
                background: color,
                width: "15px",
                height: "15px",
                float: "left",
                marginRight: "5px",
                marginBottom: "5px",
                position: "relative",
                cursor: "pointer"
            },
            dot: {
                absolute: "5px 5px 5px 5px",
                background: $c667524adaf9821a$export$3609eb1d7e55dec(color),
                borderRadius: "50%",
                opacity: "0"
            }
        },
        "active": {
            dot: {
                opacity: "1"
            }
        },
        "color-#FFFFFF": {
            color: {
                boxShadow: "inset 0 0 0 1px #ddd"
            },
            dot: {
                background: "#000"
            }
        },
        "transparent": {
            dot: {
                background: "#000"
            }
        }
    }, {
        active: active,
        "color-#FFFFFF": color === "#FFFFFF",
        "transparent": color === "transparent"
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $d738ffe146a16d78$export$2e2bcd8739ae039), {
        style: styles.color,
        color: color,
        onClick: onClick,
        onHover: onSwatchHover,
        focusStyle: {
            boxShadow: "0 0 4px " + color
        }
    }, (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("div", {
        style: styles.dot
    }));
};
var $e6126a90ee6594b9$export$2e2bcd8739ae039 = $e6126a90ee6594b9$export$df654652e5203306;



var $bh6RR = parcelRequire("bh6RR");


var $fb36fb0a8cc67097$export$11cdb14a03223d9c = function CompactFields(_ref) {
    var hex = _ref.hex, rgb = _ref.rgb, onChange = _ref.onChange;
    var styles = (0, (/*@__PURE__*/$parcel$interopDefault($1e6d325bf7ec7d53$exports)))({
        "default": {
            fields: {
                display: "flex",
                paddingBottom: "6px",
                paddingRight: "5px",
                position: "relative"
            },
            active: {
                position: "absolute",
                top: "6px",
                left: "5px",
                height: "9px",
                width: "9px",
                background: hex
            },
            HEXwrap: {
                flex: "6",
                position: "relative"
            },
            HEXinput: {
                width: "80%",
                padding: "0px",
                paddingLeft: "20%",
                border: "none",
                outline: "none",
                background: "none",
                fontSize: "12px",
                color: "#333",
                height: "16px"
            },
            HEXlabel: {
                display: "none"
            },
            RGBwrap: {
                flex: "3",
                position: "relative"
            },
            RGBinput: {
                width: "70%",
                padding: "0px",
                paddingLeft: "30%",
                border: "none",
                outline: "none",
                background: "none",
                fontSize: "12px",
                color: "#333",
                height: "16px"
            },
            RGBlabel: {
                position: "absolute",
                top: "3px",
                left: "0px",
                lineHeight: "16px",
                textTransform: "uppercase",
                fontSize: "12px",
                color: "#999"
            }
        }
    });
    var handleChange = function handleChange(data, e) {
        if (data.r || data.g || data.b) onChange({
            r: data.r || rgb.r,
            g: data.g || rgb.g,
            b: data.b || rgb.b,
            source: "rgb"
        }, e);
        else onChange({
            hex: data.hex,
            source: "hex"
        }, e);
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("div", {
        style: styles.fields,
        className: "flexbox-fix"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("div", {
        style: styles.active
    }), (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $daa8013ee334d911$export$2e2bcd8739ae039), {
        style: {
            wrap: styles.HEXwrap,
            input: styles.HEXinput,
            label: styles.HEXlabel
        },
        label: "hex",
        value: hex,
        onChange: handleChange
    }), (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $daa8013ee334d911$export$2e2bcd8739ae039), {
        style: {
            wrap: styles.RGBwrap,
            input: styles.RGBinput,
            label: styles.RGBlabel
        },
        label: "r",
        value: rgb.r,
        onChange: handleChange
    }), (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $daa8013ee334d911$export$2e2bcd8739ae039), {
        style: {
            wrap: styles.RGBwrap,
            input: styles.RGBinput,
            label: styles.RGBlabel
        },
        label: "g",
        value: rgb.g,
        onChange: handleChange
    }), (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $daa8013ee334d911$export$2e2bcd8739ae039), {
        style: {
            wrap: styles.RGBwrap,
            input: styles.RGBinput,
            label: styles.RGBlabel
        },
        label: "b",
        value: rgb.b,
        onChange: handleChange
    }));
};
var $fb36fb0a8cc67097$export$2e2bcd8739ae039 = $fb36fb0a8cc67097$export$11cdb14a03223d9c;


var $d2ff7b5bd0ecf066$export$6479582a9c9e50ce = function Compact(_ref) {
    var onChange = _ref.onChange, onSwatchHover = _ref.onSwatchHover, colors = _ref.colors, hex = _ref.hex, rgb = _ref.rgb, _ref$styles = _ref.styles, passedStyles = _ref$styles === undefined ? {} : _ref$styles, _ref$className = _ref.className, className = _ref$className === undefined ? "" : _ref$className;
    var styles = (0, (/*@__PURE__*/$parcel$interopDefault($1e6d325bf7ec7d53$exports)))((0, $b3cb9f7788522a6d$export$2e2bcd8739ae039)({
        "default": {
            Compact: {
                background: "#f6f6f6",
                radius: "4px"
            },
            compact: {
                paddingTop: "5px",
                paddingLeft: "5px",
                boxSizing: "initial",
                width: "240px"
            },
            clear: {
                clear: "both"
            }
        }
    }, passedStyles));
    var handleChange = function handleChange(data, e) {
        if (data.hex) $c667524adaf9821a$export$944f75ec5697b362(data.hex) && onChange({
            hex: data.hex,
            source: "hex"
        }, e);
        else onChange(data, e);
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $128f9bfb3e23420c$export$2e2bcd8739ae039), {
        style: styles.Compact,
        styles: passedStyles
    }, (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("div", {
        style: styles.compact,
        className: "compact-picker " + className
    }, (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("div", null, (0, $3d887f2aa95d4ff7$export$2e2bcd8739ae039)(colors, function(c) {
        return (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $e6126a90ee6594b9$export$2e2bcd8739ae039), {
            key: c,
            color: c,
            active: c.toLowerCase() === hex,
            onClick: handleChange,
            onSwatchHover: onSwatchHover
        });
    }), (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("div", {
        style: styles.clear
    })), (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $fb36fb0a8cc67097$export$2e2bcd8739ae039), {
        hex: hex,
        rgb: rgb,
        onChange: handleChange
    })));
};
$d2ff7b5bd0ecf066$export$6479582a9c9e50ce.propTypes = {
    colors: (0, (/*@__PURE__*/$parcel$interopDefault($aa40b802dd2fccfc$exports))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($aa40b802dd2fccfc$exports))).string),
    styles: (0, (/*@__PURE__*/$parcel$interopDefault($aa40b802dd2fccfc$exports))).object
};
$d2ff7b5bd0ecf066$export$6479582a9c9e50ce.defaultProps = {
    colors: [
        "#4D4D4D",
        "#999999",
        "#FFFFFF",
        "#F44E3B",
        "#FE9200",
        "#FCDC00",
        "#DBDF00",
        "#A4DD00",
        "#68CCCA",
        "#73D8FF",
        "#AEA1FF",
        "#FDA1FF",
        "#333333",
        "#808080",
        "#cccccc",
        "#D33115",
        "#E27300",
        "#FCC400",
        "#B0BC00",
        "#68BC00",
        "#16A5A5",
        "#009CE0",
        "#7B64FF",
        "#FA28FF",
        "#000000",
        "#666666",
        "#B3B3B3",
        "#9F0500",
        "#C45100",
        "#FB9E00",
        "#808900",
        "#194D33",
        "#0C797D",
        "#0062B1",
        "#653294",
        "#AB149E"
    ],
    styles: {}
};
var $d2ff7b5bd0ecf066$export$2e2bcd8739ae039 = (0, $13e2b01d2fc0abc5$export$2e2bcd8739ae039)($d2ff7b5bd0ecf066$export$6479582a9c9e50ce);



var $bh6RR = parcelRequire("bh6RR");






var $bh6RR = parcelRequire("bh6RR");


var $dd5c2a1aac82d396$export$d653c538b92bb84f = function GithubSwatch(_ref) {
    var hover = _ref.hover, color = _ref.color, onClick = _ref.onClick, onSwatchHover = _ref.onSwatchHover;
    var hoverSwatch = {
        position: "relative",
        zIndex: "2",
        outline: "2px solid #fff",
        boxShadow: "0 0 5px 2px rgba(0,0,0,0.25)"
    };
    var styles = (0, (/*@__PURE__*/$parcel$interopDefault($1e6d325bf7ec7d53$exports)))({
        "default": {
            swatch: {
                width: "25px",
                height: "25px",
                fontSize: "0"
            }
        },
        "hover": {
            swatch: hoverSwatch
        }
    }, {
        hover: hover
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("div", {
        style: styles.swatch
    }, (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $d738ffe146a16d78$export$2e2bcd8739ae039), {
        color: color,
        onClick: onClick,
        onHover: onSwatchHover,
        focusStyle: hoverSwatch
    }));
};
var $dd5c2a1aac82d396$export$2e2bcd8739ae039 = (0, $1e6d325bf7ec7d53$exports.handleHover)($dd5c2a1aac82d396$export$d653c538b92bb84f);


var $b7da5e1be16379de$export$61d478c2aba5d9a5 = function Github(_ref) {
    var width = _ref.width, colors = _ref.colors, onChange = _ref.onChange, onSwatchHover = _ref.onSwatchHover, triangle = _ref.triangle, _ref$styles = _ref.styles, passedStyles = _ref$styles === undefined ? {} : _ref$styles, _ref$className = _ref.className, className = _ref$className === undefined ? "" : _ref$className;
    var styles = (0, (/*@__PURE__*/$parcel$interopDefault($1e6d325bf7ec7d53$exports)))((0, $b3cb9f7788522a6d$export$2e2bcd8739ae039)({
        "default": {
            card: {
                width: width,
                background: "#fff",
                border: "1px solid rgba(0,0,0,0.2)",
                boxShadow: "0 3px 12px rgba(0,0,0,0.15)",
                borderRadius: "4px",
                position: "relative",
                padding: "5px",
                display: "flex",
                flexWrap: "wrap"
            },
            triangle: {
                position: "absolute",
                border: "7px solid transparent",
                borderBottomColor: "#fff"
            },
            triangleShadow: {
                position: "absolute",
                border: "8px solid transparent",
                borderBottomColor: "rgba(0,0,0,0.15)"
            }
        },
        "hide-triangle": {
            triangle: {
                display: "none"
            },
            triangleShadow: {
                display: "none"
            }
        },
        "top-left-triangle": {
            triangle: {
                top: "-14px",
                left: "10px"
            },
            triangleShadow: {
                top: "-16px",
                left: "9px"
            }
        },
        "top-right-triangle": {
            triangle: {
                top: "-14px",
                right: "10px"
            },
            triangleShadow: {
                top: "-16px",
                right: "9px"
            }
        },
        "bottom-left-triangle": {
            triangle: {
                top: "35px",
                left: "10px",
                transform: "rotate(180deg)"
            },
            triangleShadow: {
                top: "37px",
                left: "9px",
                transform: "rotate(180deg)"
            }
        },
        "bottom-right-triangle": {
            triangle: {
                top: "35px",
                right: "10px",
                transform: "rotate(180deg)"
            },
            triangleShadow: {
                top: "37px",
                right: "9px",
                transform: "rotate(180deg)"
            }
        }
    }, passedStyles), {
        "hide-triangle": triangle === "hide",
        "top-left-triangle": triangle === "top-left",
        "top-right-triangle": triangle === "top-right",
        "bottom-left-triangle": triangle === "bottom-left",
        "bottom-right-triangle": triangle === "bottom-right"
    });
    var handleChange = function handleChange(hex, e) {
        return onChange({
            hex: hex,
            source: "hex"
        }, e);
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("div", {
        style: styles.card,
        className: "github-picker " + className
    }, (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("div", {
        style: styles.triangleShadow
    }), (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("div", {
        style: styles.triangle
    }), (0, $3d887f2aa95d4ff7$export$2e2bcd8739ae039)(colors, function(c) {
        return (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $dd5c2a1aac82d396$export$2e2bcd8739ae039), {
            color: c,
            key: c,
            onClick: handleChange,
            onSwatchHover: onSwatchHover
        });
    }));
};
$b7da5e1be16379de$export$61d478c2aba5d9a5.propTypes = {
    width: (0, (/*@__PURE__*/$parcel$interopDefault($aa40b802dd2fccfc$exports))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($aa40b802dd2fccfc$exports))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($aa40b802dd2fccfc$exports))).number
    ]),
    colors: (0, (/*@__PURE__*/$parcel$interopDefault($aa40b802dd2fccfc$exports))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($aa40b802dd2fccfc$exports))).string),
    triangle: (0, (/*@__PURE__*/$parcel$interopDefault($aa40b802dd2fccfc$exports))).oneOf([
        "hide",
        "top-left",
        "top-right",
        "bottom-left",
        "bottom-right"
    ]),
    styles: (0, (/*@__PURE__*/$parcel$interopDefault($aa40b802dd2fccfc$exports))).object
};
$b7da5e1be16379de$export$61d478c2aba5d9a5.defaultProps = {
    width: 200,
    colors: [
        "#B80000",
        "#DB3E00",
        "#FCCB00",
        "#008B02",
        "#006B76",
        "#1273DE",
        "#004DCF",
        "#5300EB",
        "#EB9694",
        "#FAD0C3",
        "#FEF3BD",
        "#C1E1C5",
        "#BEDADC",
        "#C4DEF6",
        "#BED3F3",
        "#D4C4FB"
    ],
    triangle: "top-left",
    styles: {}
};
var $b7da5e1be16379de$export$2e2bcd8739ae039 = (0, $13e2b01d2fc0abc5$export$2e2bcd8739ae039)($b7da5e1be16379de$export$61d478c2aba5d9a5);



var $bh6RR = parcelRequire("bh6RR");





var $bh6RR = parcelRequire("bh6RR");

var $cc316942adf41c3c$export$9c10b52c64965f67 = function SliderPointer(_ref) {
    var direction = _ref.direction;
    var styles = (0, (/*@__PURE__*/$parcel$interopDefault($1e6d325bf7ec7d53$exports)))({
        "default": {
            picker: {
                width: "18px",
                height: "18px",
                borderRadius: "50%",
                transform: "translate(-9px, -1px)",
                backgroundColor: "rgb(248, 248, 248)",
                boxShadow: "0 1px 4px 0 rgba(0, 0, 0, 0.37)"
            }
        },
        "vertical": {
            picker: {
                transform: "translate(-3px, -9px)"
            }
        }
    }, {
        vertical: direction === "vertical"
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("div", {
        style: styles.picker
    });
};
var $cc316942adf41c3c$export$2e2bcd8739ae039 = $cc316942adf41c3c$export$9c10b52c64965f67;


var $6d310bf32e353de5$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var $6d310bf32e353de5$export$f176087feb20230e = function HuePicker(_ref) {
    var width = _ref.width, height = _ref.height, onChange = _ref.onChange, hsl = _ref.hsl, direction = _ref.direction, pointer = _ref.pointer, _ref$styles = _ref.styles, passedStyles = _ref$styles === undefined ? {} : _ref$styles, _ref$className = _ref.className, className = _ref$className === undefined ? "" : _ref$className;
    var styles = (0, (/*@__PURE__*/$parcel$interopDefault($1e6d325bf7ec7d53$exports)))((0, $b3cb9f7788522a6d$export$2e2bcd8739ae039)({
        "default": {
            picker: {
                position: "relative",
                width: width,
                height: height
            },
            hue: {
                radius: "2px"
            }
        }
    }, passedStyles));
    // Overwrite to provide pure hue color
    var handleChange = function handleChange(data) {
        return onChange({
            a: 1,
            h: data.h,
            l: 0.5,
            s: 1
        });
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("div", {
        style: styles.picker,
        className: "hue-picker " + className
    }, (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $27b1902952abffb6$export$2e2bcd8739ae039), $6d310bf32e353de5$var$_extends({}, styles.hue, {
        hsl: hsl,
        pointer: pointer,
        onChange: handleChange,
        direction: direction
    })));
};
$6d310bf32e353de5$export$f176087feb20230e.propTypes = {
    styles: (0, (/*@__PURE__*/$parcel$interopDefault($aa40b802dd2fccfc$exports))).object
};
$6d310bf32e353de5$export$f176087feb20230e.defaultProps = {
    width: "316px",
    height: "16px",
    direction: "horizontal",
    pointer: (0, $cc316942adf41c3c$export$2e2bcd8739ae039),
    styles: {}
};
var $6d310bf32e353de5$export$2e2bcd8739ae039 = (0, $13e2b01d2fc0abc5$export$2e2bcd8739ae039)($6d310bf32e353de5$export$f176087feb20230e);



var $bh6RR = parcelRequire("bh6RR");




var $ade5ed316ab0ac32$export$a2d8b23205c25948 = function Material(_ref) {
    var onChange = _ref.onChange, hex = _ref.hex, rgb = _ref.rgb, _ref$styles = _ref.styles, passedStyles = _ref$styles === undefined ? {} : _ref$styles, _ref$className = _ref.className, className = _ref$className === undefined ? "" : _ref$className;
    var styles = (0, (/*@__PURE__*/$parcel$interopDefault($1e6d325bf7ec7d53$exports)))((0, $b3cb9f7788522a6d$export$2e2bcd8739ae039)({
        "default": {
            material: {
                width: "98px",
                height: "98px",
                padding: "16px",
                fontFamily: "Roboto"
            },
            HEXwrap: {
                position: "relative"
            },
            HEXinput: {
                width: "100%",
                marginTop: "12px",
                fontSize: "15px",
                color: "#333",
                padding: "0px",
                border: "0px",
                borderBottom: "2px solid " + hex,
                outline: "none",
                height: "30px"
            },
            HEXlabel: {
                position: "absolute",
                top: "0px",
                left: "0px",
                fontSize: "11px",
                color: "#999999",
                textTransform: "capitalize"
            },
            Hex: {
                style: {}
            },
            RGBwrap: {
                position: "relative"
            },
            RGBinput: {
                width: "100%",
                marginTop: "12px",
                fontSize: "15px",
                color: "#333",
                padding: "0px",
                border: "0px",
                borderBottom: "1px solid #eee",
                outline: "none",
                height: "30px"
            },
            RGBlabel: {
                position: "absolute",
                top: "0px",
                left: "0px",
                fontSize: "11px",
                color: "#999999",
                textTransform: "capitalize"
            },
            split: {
                display: "flex",
                marginRight: "-10px",
                paddingTop: "11px"
            },
            third: {
                flex: "1",
                paddingRight: "10px"
            }
        }
    }, passedStyles));
    var handleChange = function handleChange(data, e) {
        if (data.hex) $c667524adaf9821a$export$944f75ec5697b362(data.hex) && onChange({
            hex: data.hex,
            source: "hex"
        }, e);
        else if (data.r || data.g || data.b) onChange({
            r: data.r || rgb.r,
            g: data.g || rgb.g,
            b: data.b || rgb.b,
            source: "rgb"
        }, e);
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $128f9bfb3e23420c$export$2e2bcd8739ae039), {
        styles: passedStyles
    }, (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("div", {
        style: styles.material,
        className: "material-picker " + className
    }, (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $daa8013ee334d911$export$2e2bcd8739ae039), {
        style: {
            wrap: styles.HEXwrap,
            input: styles.HEXinput,
            label: styles.HEXlabel
        },
        label: "hex",
        value: hex,
        onChange: handleChange
    }), (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("div", {
        style: styles.split,
        className: "flexbox-fix"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("div", {
        style: styles.third
    }, (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $daa8013ee334d911$export$2e2bcd8739ae039), {
        style: {
            wrap: styles.RGBwrap,
            input: styles.RGBinput,
            label: styles.RGBlabel
        },
        label: "r",
        value: rgb.r,
        onChange: handleChange
    })), (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("div", {
        style: styles.third
    }, (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $daa8013ee334d911$export$2e2bcd8739ae039), {
        style: {
            wrap: styles.RGBwrap,
            input: styles.RGBinput,
            label: styles.RGBlabel
        },
        label: "g",
        value: rgb.g,
        onChange: handleChange
    })), (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("div", {
        style: styles.third
    }, (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $daa8013ee334d911$export$2e2bcd8739ae039), {
        style: {
            wrap: styles.RGBwrap,
            input: styles.RGBinput,
            label: styles.RGBlabel
        },
        label: "b",
        value: rgb.b,
        onChange: handleChange
    })))));
};
var $ade5ed316ab0ac32$export$2e2bcd8739ae039 = (0, $13e2b01d2fc0abc5$export$2e2bcd8739ae039)($ade5ed316ab0ac32$export$a2d8b23205c25948);



var $bh6RR = parcelRequire("bh6RR");





var $bh6RR = parcelRequire("bh6RR");



var $6e89cc757287015d$export$b1808ee9bfa8f4d0 = function PhotoshopPicker(_ref) {
    var onChange = _ref.onChange, rgb = _ref.rgb, hsv = _ref.hsv, hex = _ref.hex;
    var styles = (0, (/*@__PURE__*/$parcel$interopDefault($1e6d325bf7ec7d53$exports)))({
        "default": {
            fields: {
                paddingTop: "5px",
                paddingBottom: "9px",
                width: "80px",
                position: "relative"
            },
            divider: {
                height: "5px"
            },
            RGBwrap: {
                position: "relative"
            },
            RGBinput: {
                marginLeft: "40%",
                width: "40%",
                height: "18px",
                border: "1px solid #888888",
                boxShadow: "inset 0 1px 1px rgba(0,0,0,.1), 0 1px 0 0 #ECECEC",
                marginBottom: "5px",
                fontSize: "13px",
                paddingLeft: "3px",
                marginRight: "10px"
            },
            RGBlabel: {
                left: "0px",
                top: "0px",
                width: "34px",
                textTransform: "uppercase",
                fontSize: "13px",
                height: "18px",
                lineHeight: "22px",
                position: "absolute"
            },
            HEXwrap: {
                position: "relative"
            },
            HEXinput: {
                marginLeft: "20%",
                width: "80%",
                height: "18px",
                border: "1px solid #888888",
                boxShadow: "inset 0 1px 1px rgba(0,0,0,.1), 0 1px 0 0 #ECECEC",
                marginBottom: "6px",
                fontSize: "13px",
                paddingLeft: "3px"
            },
            HEXlabel: {
                position: "absolute",
                top: "0px",
                left: "0px",
                width: "14px",
                textTransform: "uppercase",
                fontSize: "13px",
                height: "18px",
                lineHeight: "22px"
            },
            fieldSymbols: {
                position: "absolute",
                top: "5px",
                right: "-7px",
                fontSize: "13px"
            },
            symbol: {
                height: "20px",
                lineHeight: "22px",
                paddingBottom: "7px"
            }
        }
    });
    var handleChange = function handleChange(data, e) {
        if (data["#"]) $c667524adaf9821a$export$944f75ec5697b362(data["#"]) && onChange({
            hex: data["#"],
            source: "hex"
        }, e);
        else if (data.r || data.g || data.b) onChange({
            r: data.r || rgb.r,
            g: data.g || rgb.g,
            b: data.b || rgb.b,
            source: "rgb"
        }, e);
        else if (data.h || data.s || data.v) onChange({
            h: data.h || hsv.h,
            s: data.s || hsv.s,
            v: data.v || hsv.v,
            source: "hsv"
        }, e);
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("div", {
        style: styles.fields
    }, (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $daa8013ee334d911$export$2e2bcd8739ae039), {
        style: {
            wrap: styles.RGBwrap,
            input: styles.RGBinput,
            label: styles.RGBlabel
        },
        label: "h",
        value: Math.round(hsv.h),
        onChange: handleChange
    }), (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $daa8013ee334d911$export$2e2bcd8739ae039), {
        style: {
            wrap: styles.RGBwrap,
            input: styles.RGBinput,
            label: styles.RGBlabel
        },
        label: "s",
        value: Math.round(hsv.s * 100),
        onChange: handleChange
    }), (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $daa8013ee334d911$export$2e2bcd8739ae039), {
        style: {
            wrap: styles.RGBwrap,
            input: styles.RGBinput,
            label: styles.RGBlabel
        },
        label: "v",
        value: Math.round(hsv.v * 100),
        onChange: handleChange
    }), (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("div", {
        style: styles.divider
    }), (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $daa8013ee334d911$export$2e2bcd8739ae039), {
        style: {
            wrap: styles.RGBwrap,
            input: styles.RGBinput,
            label: styles.RGBlabel
        },
        label: "r",
        value: rgb.r,
        onChange: handleChange
    }), (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $daa8013ee334d911$export$2e2bcd8739ae039), {
        style: {
            wrap: styles.RGBwrap,
            input: styles.RGBinput,
            label: styles.RGBlabel
        },
        label: "g",
        value: rgb.g,
        onChange: handleChange
    }), (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $daa8013ee334d911$export$2e2bcd8739ae039), {
        style: {
            wrap: styles.RGBwrap,
            input: styles.RGBinput,
            label: styles.RGBlabel
        },
        label: "b",
        value: rgb.b,
        onChange: handleChange
    }), (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("div", {
        style: styles.divider
    }), (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $daa8013ee334d911$export$2e2bcd8739ae039), {
        style: {
            wrap: styles.HEXwrap,
            input: styles.HEXinput,
            label: styles.HEXlabel
        },
        label: "#",
        value: hex.replace("#", ""),
        onChange: handleChange
    }), (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("div", {
        style: styles.fieldSymbols
    }, (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("div", {
        style: styles.symbol
    }, "\xb0"), (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("div", {
        style: styles.symbol
    }, "%"), (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("div", {
        style: styles.symbol
    }, "%")));
};
var $6e89cc757287015d$export$2e2bcd8739ae039 = $6e89cc757287015d$export$b1808ee9bfa8f4d0;



var $bh6RR = parcelRequire("bh6RR");

var $501979f7f37c3499$export$123b96ff8455915 = function PhotoshopPointerCircle(_ref) {
    var hsl = _ref.hsl;
    var styles = (0, (/*@__PURE__*/$parcel$interopDefault($1e6d325bf7ec7d53$exports)))({
        "default": {
            picker: {
                width: "12px",
                height: "12px",
                borderRadius: "6px",
                boxShadow: "inset 0 0 0 1px #fff",
                transform: "translate(-6px, -6px)"
            }
        },
        "black-outline": {
            picker: {
                boxShadow: "inset 0 0 0 1px #000"
            }
        }
    }, {
        "black-outline": hsl.l > 0.5
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("div", {
        style: styles.picker
    });
};
var $501979f7f37c3499$export$2e2bcd8739ae039 = $501979f7f37c3499$export$123b96ff8455915;



var $bh6RR = parcelRequire("bh6RR");

var $f80fb0c63dc32e76$export$123b96ff8455915 = function PhotoshopPointerCircle() {
    var styles = (0, (/*@__PURE__*/$parcel$interopDefault($1e6d325bf7ec7d53$exports)))({
        "default": {
            triangle: {
                width: 0,
                height: 0,
                borderStyle: "solid",
                borderWidth: "4px 0 4px 6px",
                borderColor: "transparent transparent transparent #fff",
                position: "absolute",
                top: "1px",
                left: "1px"
            },
            triangleBorder: {
                width: 0,
                height: 0,
                borderStyle: "solid",
                borderWidth: "5px 0 5px 8px",
                borderColor: "transparent transparent transparent #555"
            },
            left: {
                Extend: "triangleBorder",
                transform: "translate(-13px, -4px)"
            },
            leftInside: {
                Extend: "triangle",
                transform: "translate(-8px, -5px)"
            },
            right: {
                Extend: "triangleBorder",
                transform: "translate(20px, -14px) rotate(180deg)"
            },
            rightInside: {
                Extend: "triangle",
                transform: "translate(-8px, -5px)"
            }
        }
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("div", {
        style: styles.pointer
    }, (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("div", {
        style: styles.left
    }, (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("div", {
        style: styles.leftInside
    })), (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("div", {
        style: styles.right
    }, (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("div", {
        style: styles.rightInside
    })));
};
var $f80fb0c63dc32e76$export$2e2bcd8739ae039 = $f80fb0c63dc32e76$export$123b96ff8455915;



var $bh6RR = parcelRequire("bh6RR");

var $15b7cf15c3851d9d$export$f7d38a0bd3b98717 = function PhotoshopButton(_ref) {
    var onClick = _ref.onClick, label = _ref.label, children = _ref.children, active = _ref.active;
    var styles = (0, (/*@__PURE__*/$parcel$interopDefault($1e6d325bf7ec7d53$exports)))({
        "default": {
            button: {
                backgroundImage: "linear-gradient(-180deg, #FFFFFF 0%, #E6E6E6 100%)",
                border: "1px solid #878787",
                borderRadius: "2px",
                height: "20px",
                boxShadow: "0 1px 0 0 #EAEAEA",
                fontSize: "14px",
                color: "#000",
                lineHeight: "20px",
                textAlign: "center",
                marginBottom: "10px",
                cursor: "pointer"
            }
        },
        "active": {
            button: {
                boxShadow: "0 0 0 1px #878787"
            }
        }
    }, {
        active: active
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("div", {
        style: styles.button,
        onClick: onClick
    }, label || children);
};
var $15b7cf15c3851d9d$export$2e2bcd8739ae039 = $15b7cf15c3851d9d$export$f7d38a0bd3b98717;



var $bh6RR = parcelRequire("bh6RR");

var $cb6a86d7a4a0b5f7$export$ce0d7acd66f46f2b = function PhotoshopPreviews(_ref) {
    var rgb = _ref.rgb, currentColor = _ref.currentColor;
    var styles = (0, (/*@__PURE__*/$parcel$interopDefault($1e6d325bf7ec7d53$exports)))({
        "default": {
            swatches: {
                border: "1px solid #B3B3B3",
                borderBottom: "1px solid #F0F0F0",
                marginBottom: "2px",
                marginTop: "1px"
            },
            new: {
                height: "34px",
                background: "rgb(" + rgb.r + "," + rgb.g + ", " + rgb.b + ")",
                boxShadow: "inset 1px 0 0 #000, inset -1px 0 0 #000, inset 0 1px 0 #000"
            },
            current: {
                height: "34px",
                background: currentColor,
                boxShadow: "inset 1px 0 0 #000, inset -1px 0 0 #000, inset 0 -1px 0 #000"
            },
            label: {
                fontSize: "14px",
                color: "#000",
                textAlign: "center"
            }
        }
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("div", null, (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("div", {
        style: styles.label
    }, "new"), (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("div", {
        style: styles.swatches
    }, (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("div", {
        style: styles.new
    }), (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("div", {
        style: styles.current
    })), (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("div", {
        style: styles.label
    }, "current"));
};
var $cb6a86d7a4a0b5f7$export$2e2bcd8739ae039 = $cb6a86d7a4a0b5f7$export$ce0d7acd66f46f2b;


var $a0ad273e8d644479$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();
function $a0ad273e8d644479$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $a0ad273e8d644479$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $a0ad273e8d644479$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var $a0ad273e8d644479$export$4ed116dea8ad5956 = function(_React$Component) {
    $a0ad273e8d644479$var$_inherits(Photoshop, _React$Component);
    function Photoshop(props) {
        $a0ad273e8d644479$var$_classCallCheck(this, Photoshop);
        var _this = $a0ad273e8d644479$var$_possibleConstructorReturn(this, (Photoshop.__proto__ || Object.getPrototypeOf(Photoshop)).call(this));
        _this.state = {
            currentColor: props.hex
        };
        return _this;
    }
    $a0ad273e8d644479$var$_createClass(Photoshop, [
        {
            key: "render",
            value: function render() {
                var _props = this.props, _props$styles = _props.styles, passedStyles = _props$styles === undefined ? {} : _props$styles, _props$className = _props.className, className = _props$className === undefined ? "" : _props$className;
                var styles = (0, (/*@__PURE__*/$parcel$interopDefault($1e6d325bf7ec7d53$exports)))((0, $b3cb9f7788522a6d$export$2e2bcd8739ae039)({
                    "default": {
                        picker: {
                            background: "#DCDCDC",
                            borderRadius: "4px",
                            boxShadow: "0 0 0 1px rgba(0,0,0,.25), 0 8px 16px rgba(0,0,0,.15)",
                            boxSizing: "initial",
                            width: "513px"
                        },
                        head: {
                            backgroundImage: "linear-gradient(-180deg, #F0F0F0 0%, #D4D4D4 100%)",
                            borderBottom: "1px solid #B1B1B1",
                            boxShadow: "inset 0 1px 0 0 rgba(255,255,255,.2), inset 0 -1px 0 0 rgba(0,0,0,.02)",
                            height: "23px",
                            lineHeight: "24px",
                            borderRadius: "4px 4px 0 0",
                            fontSize: "13px",
                            color: "#4D4D4D",
                            textAlign: "center"
                        },
                        body: {
                            padding: "15px 15px 0",
                            display: "flex"
                        },
                        saturation: {
                            width: "256px",
                            height: "256px",
                            position: "relative",
                            border: "2px solid #B3B3B3",
                            borderBottom: "2px solid #F0F0F0",
                            overflow: "hidden"
                        },
                        hue: {
                            position: "relative",
                            height: "256px",
                            width: "19px",
                            marginLeft: "10px",
                            border: "2px solid #B3B3B3",
                            borderBottom: "2px solid #F0F0F0"
                        },
                        controls: {
                            width: "180px",
                            marginLeft: "10px"
                        },
                        top: {
                            display: "flex"
                        },
                        previews: {
                            width: "60px"
                        },
                        actions: {
                            flex: "1",
                            marginLeft: "20px"
                        }
                    }
                }, passedStyles));
                return (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("div", {
                    style: styles.picker,
                    className: "photoshop-picker " + className
                }, (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("div", {
                    style: styles.head
                }, this.props.header), (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("div", {
                    style: styles.body,
                    className: "flexbox-fix"
                }, (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("div", {
                    style: styles.saturation
                }, (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $5a5024834f3556d9$export$2e2bcd8739ae039), {
                    hsl: this.props.hsl,
                    hsv: this.props.hsv,
                    pointer: (0, $501979f7f37c3499$export$2e2bcd8739ae039),
                    onChange: this.props.onChange
                })), (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("div", {
                    style: styles.hue
                }, (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $27b1902952abffb6$export$2e2bcd8739ae039), {
                    direction: "vertical",
                    hsl: this.props.hsl,
                    pointer: (0, $f80fb0c63dc32e76$export$2e2bcd8739ae039),
                    onChange: this.props.onChange
                })), (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("div", {
                    style: styles.controls
                }, (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("div", {
                    style: styles.top,
                    className: "flexbox-fix"
                }, (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("div", {
                    style: styles.previews
                }, (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $cb6a86d7a4a0b5f7$export$2e2bcd8739ae039), {
                    rgb: this.props.rgb,
                    currentColor: this.state.currentColor
                })), (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("div", {
                    style: styles.actions
                }, (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $15b7cf15c3851d9d$export$2e2bcd8739ae039), {
                    label: "OK",
                    onClick: this.props.onAccept,
                    active: true
                }), (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $15b7cf15c3851d9d$export$2e2bcd8739ae039), {
                    label: "Cancel",
                    onClick: this.props.onCancel
                }), (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $6e89cc757287015d$export$2e2bcd8739ae039), {
                    onChange: this.props.onChange,
                    rgb: this.props.rgb,
                    hsv: this.props.hsv,
                    hex: this.props.hex
                }))))));
            }
        }
    ]);
    return Photoshop;
}((0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).Component);
$a0ad273e8d644479$export$4ed116dea8ad5956.propTypes = {
    header: (0, (/*@__PURE__*/$parcel$interopDefault($aa40b802dd2fccfc$exports))).string,
    styles: (0, (/*@__PURE__*/$parcel$interopDefault($aa40b802dd2fccfc$exports))).object
};
$a0ad273e8d644479$export$4ed116dea8ad5956.defaultProps = {
    header: "Color Picker",
    styles: {}
};
var $a0ad273e8d644479$export$2e2bcd8739ae039 = (0, $13e2b01d2fc0abc5$export$2e2bcd8739ae039)($a0ad273e8d644479$export$4ed116dea8ad5956);



var $bh6RR = parcelRequire("bh6RR");




/* eslint-disable no-param-reassign */ 
var $bh6RR = parcelRequire("bh6RR");



var $d3f7835eaa1c9ec4$export$a9bdb1170868e062 = function SketchFields(_ref) {
    var onChange = _ref.onChange, rgb = _ref.rgb, hsl = _ref.hsl, hex = _ref.hex, disableAlpha = _ref.disableAlpha;
    var styles = (0, (/*@__PURE__*/$parcel$interopDefault($1e6d325bf7ec7d53$exports)))({
        "default": {
            fields: {
                display: "flex",
                paddingTop: "4px"
            },
            single: {
                flex: "1",
                paddingLeft: "6px"
            },
            alpha: {
                flex: "1",
                paddingLeft: "6px"
            },
            double: {
                flex: "2"
            },
            input: {
                width: "80%",
                padding: "4px 10% 3px",
                border: "none",
                boxShadow: "inset 0 0 0 1px #ccc",
                fontSize: "11px"
            },
            label: {
                display: "block",
                textAlign: "center",
                fontSize: "11px",
                color: "#222",
                paddingTop: "3px",
                paddingBottom: "4px",
                textTransform: "capitalize"
            }
        },
        "disableAlpha": {
            alpha: {
                display: "none"
            }
        }
    }, {
        disableAlpha: disableAlpha
    });
    var handleChange = function handleChange(data, e) {
        if (data.hex) $c667524adaf9821a$export$944f75ec5697b362(data.hex) && onChange({
            hex: data.hex,
            source: "hex"
        }, e);
        else if (data.r || data.g || data.b) onChange({
            r: data.r || rgb.r,
            g: data.g || rgb.g,
            b: data.b || rgb.b,
            a: rgb.a,
            source: "rgb"
        }, e);
        else if (data.a) {
            if (data.a < 0) data.a = 0;
            else if (data.a > 100) data.a = 100;
            data.a /= 100;
            onChange({
                h: hsl.h,
                s: hsl.s,
                l: hsl.l,
                a: data.a,
                source: "rgb"
            }, e);
        }
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("div", {
        style: styles.fields,
        className: "flexbox-fix"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("div", {
        style: styles.double
    }, (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $daa8013ee334d911$export$2e2bcd8739ae039), {
        style: {
            input: styles.input,
            label: styles.label
        },
        label: "hex",
        value: hex.replace("#", ""),
        onChange: handleChange
    })), (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("div", {
        style: styles.single
    }, (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $daa8013ee334d911$export$2e2bcd8739ae039), {
        style: {
            input: styles.input,
            label: styles.label
        },
        label: "r",
        value: rgb.r,
        onChange: handleChange,
        dragLabel: "true",
        dragMax: "255"
    })), (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("div", {
        style: styles.single
    }, (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $daa8013ee334d911$export$2e2bcd8739ae039), {
        style: {
            input: styles.input,
            label: styles.label
        },
        label: "g",
        value: rgb.g,
        onChange: handleChange,
        dragLabel: "true",
        dragMax: "255"
    })), (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("div", {
        style: styles.single
    }, (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $daa8013ee334d911$export$2e2bcd8739ae039), {
        style: {
            input: styles.input,
            label: styles.label
        },
        label: "b",
        value: rgb.b,
        onChange: handleChange,
        dragLabel: "true",
        dragMax: "255"
    })), (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("div", {
        style: styles.alpha
    }, (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $daa8013ee334d911$export$2e2bcd8739ae039), {
        style: {
            input: styles.input,
            label: styles.label
        },
        label: "a",
        value: Math.round(rgb.a * 100),
        onChange: handleChange,
        dragLabel: "true",
        dragMax: "100"
    })));
};
var $d3f7835eaa1c9ec4$export$2e2bcd8739ae039 = $d3f7835eaa1c9ec4$export$a9bdb1170868e062;



var $bh6RR = parcelRequire("bh6RR");



var $30a3549f4f86cb0e$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var $30a3549f4f86cb0e$export$cc78acae6744db3b = function SketchPresetColors(_ref) {
    var colors = _ref.colors, _ref$onClick = _ref.onClick, onClick = _ref$onClick === undefined ? function() {} : _ref$onClick, onSwatchHover = _ref.onSwatchHover;
    var styles = (0, (/*@__PURE__*/$parcel$interopDefault($1e6d325bf7ec7d53$exports)))({
        "default": {
            colors: {
                margin: "0 -10px",
                padding: "10px 0 0 10px",
                borderTop: "1px solid #eee",
                display: "flex",
                flexWrap: "wrap",
                position: "relative"
            },
            swatchWrap: {
                width: "16px",
                height: "16px",
                margin: "0 10px 10px 0"
            },
            swatch: {
                borderRadius: "3px",
                boxShadow: "inset 0 0 0 1px rgba(0,0,0,.15)"
            }
        },
        "no-presets": {
            colors: {
                display: "none"
            }
        }
    }, {
        "no-presets": !colors || !colors.length
    });
    var handleClick = function handleClick(hex, e) {
        onClick({
            hex: hex,
            source: "hex"
        }, e);
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("div", {
        style: styles.colors,
        className: "flexbox-fix"
    }, colors.map(function(colorObjOrString) {
        var c = typeof colorObjOrString === "string" ? {
            color: colorObjOrString
        } : colorObjOrString;
        var key = "" + c.color + (c.title || "");
        return (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("div", {
            key: key,
            style: styles.swatchWrap
        }, (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $d738ffe146a16d78$export$2e2bcd8739ae039), $30a3549f4f86cb0e$var$_extends({}, c, {
            style: styles.swatch,
            onClick: handleClick,
            onHover: onSwatchHover,
            focusStyle: {
                boxShadow: "inset 0 0 0 1px rgba(0,0,0,.15), 0 0 4px " + c.color
            }
        })));
    }));
};
$30a3549f4f86cb0e$export$cc78acae6744db3b.propTypes = {
    colors: (0, (/*@__PURE__*/$parcel$interopDefault($aa40b802dd2fccfc$exports))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($aa40b802dd2fccfc$exports))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($aa40b802dd2fccfc$exports))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($aa40b802dd2fccfc$exports))).shape({
            color: (0, (/*@__PURE__*/$parcel$interopDefault($aa40b802dd2fccfc$exports))).string,
            title: (0, (/*@__PURE__*/$parcel$interopDefault($aa40b802dd2fccfc$exports))).string
        })
    ])).isRequired
};
var $30a3549f4f86cb0e$export$2e2bcd8739ae039 = $30a3549f4f86cb0e$export$cc78acae6744db3b;


var $cf21d600ecbcd0e2$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var $cf21d600ecbcd0e2$export$361fce2090be193f = function Sketch(_ref) {
    var width = _ref.width, rgb = _ref.rgb, hex = _ref.hex, hsv = _ref.hsv, hsl = _ref.hsl, onChange = _ref.onChange, onSwatchHover = _ref.onSwatchHover, disableAlpha = _ref.disableAlpha, presetColors = _ref.presetColors, renderers = _ref.renderers, _ref$styles = _ref.styles, passedStyles = _ref$styles === undefined ? {} : _ref$styles, _ref$className = _ref.className, className = _ref$className === undefined ? "" : _ref$className;
    var styles = (0, (/*@__PURE__*/$parcel$interopDefault($1e6d325bf7ec7d53$exports)))((0, $b3cb9f7788522a6d$export$2e2bcd8739ae039)({
        "default": $cf21d600ecbcd0e2$var$_extends({
            picker: {
                width: width,
                padding: "10px 10px 0",
                boxSizing: "initial",
                background: "#fff",
                borderRadius: "4px",
                boxShadow: "0 0 0 1px rgba(0,0,0,.15), 0 8px 16px rgba(0,0,0,.15)"
            },
            saturation: {
                width: "100%",
                paddingBottom: "75%",
                position: "relative",
                overflow: "hidden"
            },
            Saturation: {
                radius: "3px",
                shadow: "inset 0 0 0 1px rgba(0,0,0,.15), inset 0 0 4px rgba(0,0,0,.25)"
            },
            controls: {
                display: "flex"
            },
            sliders: {
                padding: "4px 0",
                flex: "1"
            },
            color: {
                width: "24px",
                height: "24px",
                position: "relative",
                marginTop: "4px",
                marginLeft: "4px",
                borderRadius: "3px"
            },
            activeColor: {
                absolute: "0px 0px 0px 0px",
                borderRadius: "2px",
                background: "rgba(" + rgb.r + "," + rgb.g + "," + rgb.b + "," + rgb.a + ")",
                boxShadow: "inset 0 0 0 1px rgba(0,0,0,.15), inset 0 0 4px rgba(0,0,0,.25)"
            },
            hue: {
                position: "relative",
                height: "10px",
                overflow: "hidden"
            },
            Hue: {
                radius: "2px",
                shadow: "inset 0 0 0 1px rgba(0,0,0,.15), inset 0 0 4px rgba(0,0,0,.25)"
            },
            alpha: {
                position: "relative",
                height: "10px",
                marginTop: "4px",
                overflow: "hidden"
            },
            Alpha: {
                radius: "2px",
                shadow: "inset 0 0 0 1px rgba(0,0,0,.15), inset 0 0 4px rgba(0,0,0,.25)"
            }
        }, passedStyles),
        "disableAlpha": {
            color: {
                height: "10px"
            },
            hue: {
                height: "10px"
            },
            alpha: {
                display: "none"
            }
        }
    }, passedStyles), {
        disableAlpha: disableAlpha
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("div", {
        style: styles.picker,
        className: "sketch-picker " + className
    }, (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("div", {
        style: styles.saturation
    }, (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $5a5024834f3556d9$export$2e2bcd8739ae039), {
        style: styles.Saturation,
        hsl: hsl,
        hsv: hsv,
        onChange: onChange
    })), (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("div", {
        style: styles.controls,
        className: "flexbox-fix"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("div", {
        style: styles.sliders
    }, (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("div", {
        style: styles.hue
    }, (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $27b1902952abffb6$export$2e2bcd8739ae039), {
        style: styles.Hue,
        hsl: hsl,
        onChange: onChange
    })), (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("div", {
        style: styles.alpha
    }, (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $2b76dc783bc34760$export$2e2bcd8739ae039), {
        style: styles.Alpha,
        rgb: rgb,
        hsl: hsl,
        renderers: renderers,
        onChange: onChange
    }))), (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("div", {
        style: styles.color
    }, (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $fb5ac1bea6cb3f9f$export$2e2bcd8739ae039), null), (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("div", {
        style: styles.activeColor
    }))), (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $d3f7835eaa1c9ec4$export$2e2bcd8739ae039), {
        rgb: rgb,
        hsl: hsl,
        hex: hex,
        onChange: onChange,
        disableAlpha: disableAlpha
    }), (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $30a3549f4f86cb0e$export$2e2bcd8739ae039), {
        colors: presetColors,
        onClick: onChange,
        onSwatchHover: onSwatchHover
    }));
};
$cf21d600ecbcd0e2$export$361fce2090be193f.propTypes = {
    disableAlpha: (0, (/*@__PURE__*/$parcel$interopDefault($aa40b802dd2fccfc$exports))).bool,
    width: (0, (/*@__PURE__*/$parcel$interopDefault($aa40b802dd2fccfc$exports))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($aa40b802dd2fccfc$exports))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($aa40b802dd2fccfc$exports))).number
    ]),
    styles: (0, (/*@__PURE__*/$parcel$interopDefault($aa40b802dd2fccfc$exports))).object
};
$cf21d600ecbcd0e2$export$361fce2090be193f.defaultProps = {
    disableAlpha: false,
    width: 200,
    styles: {},
    presetColors: [
        "#D0021B",
        "#F5A623",
        "#F8E71C",
        "#8B572A",
        "#7ED321",
        "#417505",
        "#BD10E0",
        "#9013FE",
        "#4A90E2",
        "#50E3C2",
        "#B8E986",
        "#000000",
        "#4A4A4A",
        "#9B9B9B",
        "#FFFFFF"
    ]
};
var $cf21d600ecbcd0e2$export$2e2bcd8739ae039 = (0, $13e2b01d2fc0abc5$export$2e2bcd8739ae039)($cf21d600ecbcd0e2$export$361fce2090be193f);



var $bh6RR = parcelRequire("bh6RR");





var $bh6RR = parcelRequire("bh6RR");


var $bh6RR = parcelRequire("bh6RR");

var $366840e8d6858fa6$export$5c11afa672411de4 = function SliderSwatch(_ref) {
    var hsl = _ref.hsl, offset = _ref.offset, _ref$onClick = _ref.onClick, onClick = _ref$onClick === undefined ? function() {} : _ref$onClick, active = _ref.active, first = _ref.first, last = _ref.last;
    var styles = (0, (/*@__PURE__*/$parcel$interopDefault($1e6d325bf7ec7d53$exports)))({
        "default": {
            swatch: {
                height: "12px",
                background: "hsl(" + hsl.h + ", 50%, " + offset * 100 + "%)",
                cursor: "pointer"
            }
        },
        "first": {
            swatch: {
                borderRadius: "2px 0 0 2px"
            }
        },
        "last": {
            swatch: {
                borderRadius: "0 2px 2px 0"
            }
        },
        "active": {
            swatch: {
                transform: "scaleY(1.8)",
                borderRadius: "3.6px/2px"
            }
        }
    }, {
        active: active,
        first: first,
        last: last
    });
    var handleClick = function handleClick(e) {
        return onClick({
            h: hsl.h,
            s: 0.5,
            l: offset,
            source: "hsl"
        }, e);
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("div", {
        style: styles.swatch,
        onClick: handleClick
    });
};
var $366840e8d6858fa6$export$2e2bcd8739ae039 = $366840e8d6858fa6$export$5c11afa672411de4;


var $b7d25edcf9352a08$export$48f49e32c66cdd61 = function SliderSwatches(_ref) {
    var onClick = _ref.onClick, hsl = _ref.hsl;
    var styles = (0, (/*@__PURE__*/$parcel$interopDefault($1e6d325bf7ec7d53$exports)))({
        "default": {
            swatches: {
                marginTop: "20px"
            },
            swatch: {
                boxSizing: "border-box",
                width: "20%",
                paddingRight: "1px",
                float: "left"
            },
            clear: {
                clear: "both"
            }
        }
    });
    // Acceptible difference in floating point equality
    var epsilon = 0.1;
    return (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("div", {
        style: styles.swatches
    }, (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("div", {
        style: styles.swatch
    }, (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $366840e8d6858fa6$export$2e2bcd8739ae039), {
        hsl: hsl,
        offset: ".80",
        active: Math.abs(hsl.l - 0.80) < epsilon && Math.abs(hsl.s - 0.50) < epsilon,
        onClick: onClick,
        first: true
    })), (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("div", {
        style: styles.swatch
    }, (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $366840e8d6858fa6$export$2e2bcd8739ae039), {
        hsl: hsl,
        offset: ".65",
        active: Math.abs(hsl.l - 0.65) < epsilon && Math.abs(hsl.s - 0.50) < epsilon,
        onClick: onClick
    })), (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("div", {
        style: styles.swatch
    }, (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $366840e8d6858fa6$export$2e2bcd8739ae039), {
        hsl: hsl,
        offset: ".50",
        active: Math.abs(hsl.l - 0.50) < epsilon && Math.abs(hsl.s - 0.50) < epsilon,
        onClick: onClick
    })), (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("div", {
        style: styles.swatch
    }, (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $366840e8d6858fa6$export$2e2bcd8739ae039), {
        hsl: hsl,
        offset: ".35",
        active: Math.abs(hsl.l - 0.35) < epsilon && Math.abs(hsl.s - 0.50) < epsilon,
        onClick: onClick
    })), (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("div", {
        style: styles.swatch
    }, (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $366840e8d6858fa6$export$2e2bcd8739ae039), {
        hsl: hsl,
        offset: ".20",
        active: Math.abs(hsl.l - 0.20) < epsilon && Math.abs(hsl.s - 0.50) < epsilon,
        onClick: onClick,
        last: true
    })), (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("div", {
        style: styles.clear
    }));
};
var $b7d25edcf9352a08$export$2e2bcd8739ae039 = $b7d25edcf9352a08$export$48f49e32c66cdd61;



var $bh6RR = parcelRequire("bh6RR");

var $44e80cb4fd857550$export$9c10b52c64965f67 = function SliderPointer() {
    var styles = (0, (/*@__PURE__*/$parcel$interopDefault($1e6d325bf7ec7d53$exports)))({
        "default": {
            picker: {
                width: "14px",
                height: "14px",
                borderRadius: "6px",
                transform: "translate(-7px, -1px)",
                backgroundColor: "rgb(248, 248, 248)",
                boxShadow: "0 1px 4px 0 rgba(0, 0, 0, 0.37)"
            }
        }
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("div", {
        style: styles.picker
    });
};
var $44e80cb4fd857550$export$2e2bcd8739ae039 = $44e80cb4fd857550$export$9c10b52c64965f67;


var $c29d88fb3b6c216f$export$472062a354075cee = function Slider(_ref) {
    var hsl = _ref.hsl, onChange = _ref.onChange, pointer = _ref.pointer, _ref$styles = _ref.styles, passedStyles = _ref$styles === undefined ? {} : _ref$styles, _ref$className = _ref.className, className = _ref$className === undefined ? "" : _ref$className;
    var styles = (0, (/*@__PURE__*/$parcel$interopDefault($1e6d325bf7ec7d53$exports)))((0, $b3cb9f7788522a6d$export$2e2bcd8739ae039)({
        "default": {
            hue: {
                height: "12px",
                position: "relative"
            },
            Hue: {
                radius: "2px"
            }
        }
    }, passedStyles));
    return (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("div", {
        style: styles.wrap || {},
        className: "slider-picker " + className
    }, (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("div", {
        style: styles.hue
    }, (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $27b1902952abffb6$export$2e2bcd8739ae039), {
        style: styles.Hue,
        hsl: hsl,
        pointer: pointer,
        onChange: onChange
    })), (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("div", {
        style: styles.swatches
    }, (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $b7d25edcf9352a08$export$2e2bcd8739ae039), {
        hsl: hsl,
        onClick: onChange
    })));
};
$c29d88fb3b6c216f$export$472062a354075cee.propTypes = {
    styles: (0, (/*@__PURE__*/$parcel$interopDefault($aa40b802dd2fccfc$exports))).object
};
$c29d88fb3b6c216f$export$472062a354075cee.defaultProps = {
    pointer: (0, $44e80cb4fd857550$export$2e2bcd8739ae039),
    styles: {}
};
var $c29d88fb3b6c216f$export$2e2bcd8739ae039 = (0, $13e2b01d2fc0abc5$export$2e2bcd8739ae039)($c29d88fb3b6c216f$export$472062a354075cee);



var $bh6RR = parcelRequire("bh6RR");







var $bh6RR = parcelRequire("bh6RR");



var $bh6RR = parcelRequire("bh6RR");



var $4d48ed899b852246$exports = {};
"use strict";
Object.defineProperty($4d48ed899b852246$exports, "__esModule", {
    value: true
});
var $4d48ed899b852246$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};

var $bh6RR = parcelRequire("bh6RR");
var $4d48ed899b852246$var$_react2 = $4d48ed899b852246$var$_interopRequireDefault($bh6RR);
function $4d48ed899b852246$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $4d48ed899b852246$var$_objectWithoutProperties(obj, keys) {
    var target = {};
    for(var i in obj){
        if (keys.indexOf(i) >= 0) continue;
        if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
        target[i] = obj[i];
    }
    return target;
}
var $4d48ed899b852246$var$DEFAULT_SIZE = 24;
$4d48ed899b852246$exports.default = function(_ref) {
    var _ref$fill = _ref.fill, fill = _ref$fill === undefined ? "currentColor" : _ref$fill, _ref$width = _ref.width, width = _ref$width === undefined ? $4d48ed899b852246$var$DEFAULT_SIZE : _ref$width, _ref$height = _ref.height, height = _ref$height === undefined ? $4d48ed899b852246$var$DEFAULT_SIZE : _ref$height, _ref$style = _ref.style, style = _ref$style === undefined ? {} : _ref$style, props = $4d48ed899b852246$var$_objectWithoutProperties(_ref, [
        "fill",
        "width",
        "height",
        "style"
    ]);
    return $4d48ed899b852246$var$_react2.default.createElement("svg", $4d48ed899b852246$var$_extends({
        viewBox: "0 0 " + $4d48ed899b852246$var$DEFAULT_SIZE + " " + $4d48ed899b852246$var$DEFAULT_SIZE,
        style: $4d48ed899b852246$var$_extends({
            fill: fill,
            width: width,
            height: height
        }, style)
    }, props), $4d48ed899b852246$var$_react2.default.createElement("path", {
        d: "M21,7L9,19L3.5,13.5L4.91,12.09L9,16.17L19.59,5.59L21,7Z"
    }));
};


var $7f04aac9f4cedbb7$export$af5303fde6798b43 = function SwatchesColor(_ref) {
    var color = _ref.color, _ref$onClick = _ref.onClick, onClick = _ref$onClick === undefined ? function() {} : _ref$onClick, onSwatchHover = _ref.onSwatchHover, first = _ref.first, last = _ref.last, active = _ref.active;
    var styles = (0, (/*@__PURE__*/$parcel$interopDefault($1e6d325bf7ec7d53$exports)))({
        "default": {
            color: {
                width: "40px",
                height: "24px",
                cursor: "pointer",
                background: color,
                marginBottom: "1px"
            },
            check: {
                color: $c667524adaf9821a$export$3609eb1d7e55dec(color),
                marginLeft: "8px",
                display: "none"
            }
        },
        "first": {
            color: {
                overflow: "hidden",
                borderRadius: "2px 2px 0 0"
            }
        },
        "last": {
            color: {
                overflow: "hidden",
                borderRadius: "0 0 2px 2px"
            }
        },
        "active": {
            check: {
                display: "block"
            }
        },
        "color-#FFFFFF": {
            color: {
                boxShadow: "inset 0 0 0 1px #ddd"
            },
            check: {
                color: "#333"
            }
        },
        "transparent": {
            check: {
                color: "#333"
            }
        }
    }, {
        first: first,
        last: last,
        active: active,
        "color-#FFFFFF": color === "#FFFFFF",
        "transparent": color === "transparent"
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $d738ffe146a16d78$export$2e2bcd8739ae039), {
        color: color,
        style: styles.color,
        onClick: onClick,
        onHover: onSwatchHover,
        focusStyle: {
            boxShadow: "0 0 4px " + color
        }
    }, (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("div", {
        style: styles.check
    }, (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4d48ed899b852246$exports))), null)));
};
var $7f04aac9f4cedbb7$export$2e2bcd8739ae039 = $7f04aac9f4cedbb7$export$af5303fde6798b43;


var $b9da58910545c5d9$export$354a0399ec1ad469 = function SwatchesGroup(_ref) {
    var onClick = _ref.onClick, onSwatchHover = _ref.onSwatchHover, group = _ref.group, active = _ref.active;
    var styles = (0, (/*@__PURE__*/$parcel$interopDefault($1e6d325bf7ec7d53$exports)))({
        "default": {
            group: {
                paddingBottom: "10px",
                width: "40px",
                float: "left",
                marginRight: "10px"
            }
        }
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("div", {
        style: styles.group
    }, (0, $3d887f2aa95d4ff7$export$2e2bcd8739ae039)(group, function(color, i) {
        return (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $7f04aac9f4cedbb7$export$2e2bcd8739ae039), {
            key: color,
            color: color,
            active: color.toLowerCase() === active,
            first: i === 0,
            last: i === group.length - 1,
            onClick: onClick,
            onSwatchHover: onSwatchHover
        });
    }));
};
var $b9da58910545c5d9$export$2e2bcd8739ae039 = $b9da58910545c5d9$export$354a0399ec1ad469;


var $206aa99faaa5137c$export$81ebbfd13e06b049 = function Swatches(_ref) {
    var width = _ref.width, height = _ref.height, onChange = _ref.onChange, onSwatchHover = _ref.onSwatchHover, colors = _ref.colors, hex = _ref.hex, _ref$styles = _ref.styles, passedStyles = _ref$styles === undefined ? {} : _ref$styles, _ref$className = _ref.className, className = _ref$className === undefined ? "" : _ref$className;
    var styles = (0, (/*@__PURE__*/$parcel$interopDefault($1e6d325bf7ec7d53$exports)))((0, $b3cb9f7788522a6d$export$2e2bcd8739ae039)({
        "default": {
            picker: {
                width: width,
                height: height
            },
            overflow: {
                height: height,
                overflowY: "scroll"
            },
            body: {
                padding: "16px 0 6px 16px"
            },
            clear: {
                clear: "both"
            }
        }
    }, passedStyles));
    var handleChange = function handleChange(data, e) {
        return onChange({
            hex: data,
            source: "hex"
        }, e);
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("div", {
        style: styles.picker,
        className: "swatches-picker " + className
    }, (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $128f9bfb3e23420c$export$2e2bcd8739ae039), null, (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("div", {
        style: styles.overflow
    }, (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("div", {
        style: styles.body
    }, (0, $3d887f2aa95d4ff7$export$2e2bcd8739ae039)(colors, function(group) {
        return (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $b9da58910545c5d9$export$2e2bcd8739ae039), {
            key: group.toString(),
            group: group,
            active: hex,
            onClick: handleChange,
            onSwatchHover: onSwatchHover
        });
    }), (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("div", {
        style: styles.clear
    })))));
};
$206aa99faaa5137c$export$81ebbfd13e06b049.propTypes = {
    width: (0, (/*@__PURE__*/$parcel$interopDefault($aa40b802dd2fccfc$exports))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($aa40b802dd2fccfc$exports))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($aa40b802dd2fccfc$exports))).number
    ]),
    height: (0, (/*@__PURE__*/$parcel$interopDefault($aa40b802dd2fccfc$exports))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($aa40b802dd2fccfc$exports))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($aa40b802dd2fccfc$exports))).number
    ]),
    colors: (0, (/*@__PURE__*/$parcel$interopDefault($aa40b802dd2fccfc$exports))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($aa40b802dd2fccfc$exports))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($aa40b802dd2fccfc$exports))).string)),
    styles: (0, (/*@__PURE__*/$parcel$interopDefault($aa40b802dd2fccfc$exports))).object
};
$206aa99faaa5137c$export$81ebbfd13e06b049.defaultProps = {
    width: 320,
    height: 240,
    colors: [
        [
            $96be8cf58dd824fd$export$a90204d1394caf30["900"],
            $96be8cf58dd824fd$export$a90204d1394caf30["700"],
            $96be8cf58dd824fd$export$a90204d1394caf30["500"],
            $96be8cf58dd824fd$export$a90204d1394caf30["300"],
            $96be8cf58dd824fd$export$a90204d1394caf30["100"]
        ],
        [
            $96be8cf58dd824fd$export$47853bc718611763["900"],
            $96be8cf58dd824fd$export$47853bc718611763["700"],
            $96be8cf58dd824fd$export$47853bc718611763["500"],
            $96be8cf58dd824fd$export$47853bc718611763["300"],
            $96be8cf58dd824fd$export$47853bc718611763["100"]
        ],
        [
            $96be8cf58dd824fd$export$e13cce2a2d16a9d4["900"],
            $96be8cf58dd824fd$export$e13cce2a2d16a9d4["700"],
            $96be8cf58dd824fd$export$e13cce2a2d16a9d4["500"],
            $96be8cf58dd824fd$export$e13cce2a2d16a9d4["300"],
            $96be8cf58dd824fd$export$e13cce2a2d16a9d4["100"]
        ],
        [
            $96be8cf58dd824fd$export$51ef95b19086af57["900"],
            $96be8cf58dd824fd$export$51ef95b19086af57["700"],
            $96be8cf58dd824fd$export$51ef95b19086af57["500"],
            $96be8cf58dd824fd$export$51ef95b19086af57["300"],
            $96be8cf58dd824fd$export$51ef95b19086af57["100"]
        ],
        [
            $96be8cf58dd824fd$export$3e6ccc7b8562d453["900"],
            $96be8cf58dd824fd$export$3e6ccc7b8562d453["700"],
            $96be8cf58dd824fd$export$3e6ccc7b8562d453["500"],
            $96be8cf58dd824fd$export$3e6ccc7b8562d453["300"],
            $96be8cf58dd824fd$export$3e6ccc7b8562d453["100"]
        ],
        [
            $96be8cf58dd824fd$export$2aa0182783e7e9de["900"],
            $96be8cf58dd824fd$export$2aa0182783e7e9de["700"],
            $96be8cf58dd824fd$export$2aa0182783e7e9de["500"],
            $96be8cf58dd824fd$export$2aa0182783e7e9de["300"],
            $96be8cf58dd824fd$export$2aa0182783e7e9de["100"]
        ],
        [
            $96be8cf58dd824fd$export$7b0d29b70b435c21["900"],
            $96be8cf58dd824fd$export$7b0d29b70b435c21["700"],
            $96be8cf58dd824fd$export$7b0d29b70b435c21["500"],
            $96be8cf58dd824fd$export$7b0d29b70b435c21["300"],
            $96be8cf58dd824fd$export$7b0d29b70b435c21["100"]
        ],
        [
            $96be8cf58dd824fd$export$7474046f446842ee["900"],
            $96be8cf58dd824fd$export$7474046f446842ee["700"],
            $96be8cf58dd824fd$export$7474046f446842ee["500"],
            $96be8cf58dd824fd$export$7474046f446842ee["300"],
            $96be8cf58dd824fd$export$7474046f446842ee["100"]
        ],
        [
            $96be8cf58dd824fd$export$8bf7dff220b82b4a["900"],
            $96be8cf58dd824fd$export$8bf7dff220b82b4a["700"],
            $96be8cf58dd824fd$export$8bf7dff220b82b4a["500"],
            $96be8cf58dd824fd$export$8bf7dff220b82b4a["300"],
            $96be8cf58dd824fd$export$8bf7dff220b82b4a["100"]
        ],
        [
            "#194D33",
            $96be8cf58dd824fd$export$955a2ebd2fb142ae["700"],
            $96be8cf58dd824fd$export$955a2ebd2fb142ae["500"],
            $96be8cf58dd824fd$export$955a2ebd2fb142ae["300"],
            $96be8cf58dd824fd$export$955a2ebd2fb142ae["100"]
        ],
        [
            $96be8cf58dd824fd$export$559a8c00376dc936["900"],
            $96be8cf58dd824fd$export$559a8c00376dc936["700"],
            $96be8cf58dd824fd$export$559a8c00376dc936["500"],
            $96be8cf58dd824fd$export$559a8c00376dc936["300"],
            $96be8cf58dd824fd$export$559a8c00376dc936["100"]
        ],
        [
            $96be8cf58dd824fd$export$221d31baf2636aad["900"],
            $96be8cf58dd824fd$export$221d31baf2636aad["700"],
            $96be8cf58dd824fd$export$221d31baf2636aad["500"],
            $96be8cf58dd824fd$export$221d31baf2636aad["300"],
            $96be8cf58dd824fd$export$221d31baf2636aad["100"]
        ],
        [
            $96be8cf58dd824fd$export$594c5a8758200c32["900"],
            $96be8cf58dd824fd$export$594c5a8758200c32["700"],
            $96be8cf58dd824fd$export$594c5a8758200c32["500"],
            $96be8cf58dd824fd$export$594c5a8758200c32["300"],
            $96be8cf58dd824fd$export$594c5a8758200c32["100"]
        ],
        [
            $96be8cf58dd824fd$export$7c1ecc66643fdbd6["900"],
            $96be8cf58dd824fd$export$7c1ecc66643fdbd6["700"],
            $96be8cf58dd824fd$export$7c1ecc66643fdbd6["500"],
            $96be8cf58dd824fd$export$7c1ecc66643fdbd6["300"],
            $96be8cf58dd824fd$export$7c1ecc66643fdbd6["100"]
        ],
        [
            $96be8cf58dd824fd$export$ad766f34ace1cafd["900"],
            $96be8cf58dd824fd$export$ad766f34ace1cafd["700"],
            $96be8cf58dd824fd$export$ad766f34ace1cafd["500"],
            $96be8cf58dd824fd$export$ad766f34ace1cafd["300"],
            $96be8cf58dd824fd$export$ad766f34ace1cafd["100"]
        ],
        [
            $96be8cf58dd824fd$export$1ceed3dd9ec11704["900"],
            $96be8cf58dd824fd$export$1ceed3dd9ec11704["700"],
            $96be8cf58dd824fd$export$1ceed3dd9ec11704["500"],
            $96be8cf58dd824fd$export$1ceed3dd9ec11704["300"],
            $96be8cf58dd824fd$export$1ceed3dd9ec11704["100"]
        ],
        [
            $96be8cf58dd824fd$export$b6e6178d3f565007["900"],
            $96be8cf58dd824fd$export$b6e6178d3f565007["700"],
            $96be8cf58dd824fd$export$b6e6178d3f565007["500"],
            $96be8cf58dd824fd$export$b6e6178d3f565007["300"],
            $96be8cf58dd824fd$export$b6e6178d3f565007["100"]
        ],
        [
            $96be8cf58dd824fd$export$7c2da42d08c019c9["900"],
            $96be8cf58dd824fd$export$7c2da42d08c019c9["700"],
            $96be8cf58dd824fd$export$7c2da42d08c019c9["500"],
            $96be8cf58dd824fd$export$7c2da42d08c019c9["300"],
            $96be8cf58dd824fd$export$7c2da42d08c019c9["100"]
        ],
        [
            "#000000",
            "#525252",
            "#969696",
            "#D9D9D9",
            "#FFFFFF"
        ]
    ],
    styles: {}
};
var $206aa99faaa5137c$export$2e2bcd8739ae039 = (0, $13e2b01d2fc0abc5$export$2e2bcd8739ae039)($206aa99faaa5137c$export$81ebbfd13e06b049);



var $bh6RR = parcelRequire("bh6RR");






var $cfdc4f12729020c1$export$9e389cdad32a5b7a = function Twitter(_ref) {
    var onChange = _ref.onChange, onSwatchHover = _ref.onSwatchHover, hex = _ref.hex, colors = _ref.colors, width = _ref.width, triangle = _ref.triangle, _ref$styles = _ref.styles, passedStyles = _ref$styles === undefined ? {} : _ref$styles, _ref$className = _ref.className, className = _ref$className === undefined ? "" : _ref$className;
    var styles = (0, (/*@__PURE__*/$parcel$interopDefault($1e6d325bf7ec7d53$exports)))((0, $b3cb9f7788522a6d$export$2e2bcd8739ae039)({
        "default": {
            card: {
                width: width,
                background: "#fff",
                border: "0 solid rgba(0,0,0,0.25)",
                boxShadow: "0 1px 4px rgba(0,0,0,0.25)",
                borderRadius: "4px",
                position: "relative"
            },
            body: {
                padding: "15px 9px 9px 15px"
            },
            label: {
                fontSize: "18px",
                color: "#fff"
            },
            triangle: {
                width: "0px",
                height: "0px",
                borderStyle: "solid",
                borderWidth: "0 9px 10px 9px",
                borderColor: "transparent transparent #fff transparent",
                position: "absolute"
            },
            triangleShadow: {
                width: "0px",
                height: "0px",
                borderStyle: "solid",
                borderWidth: "0 9px 10px 9px",
                borderColor: "transparent transparent rgba(0,0,0,.1) transparent",
                position: "absolute"
            },
            hash: {
                background: "#F0F0F0",
                height: "30px",
                width: "30px",
                borderRadius: "4px 0 0 4px",
                float: "left",
                color: "#98A1A4",
                display: "flex",
                alignItems: "center",
                justifyContent: "center"
            },
            input: {
                width: "100px",
                fontSize: "14px",
                color: "#666",
                border: "0px",
                outline: "none",
                height: "28px",
                boxShadow: "inset 0 0 0 1px #F0F0F0",
                boxSizing: "content-box",
                borderRadius: "0 4px 4px 0",
                float: "left",
                paddingLeft: "8px"
            },
            swatch: {
                width: "30px",
                height: "30px",
                float: "left",
                borderRadius: "4px",
                margin: "0 6px 6px 0"
            },
            clear: {
                clear: "both"
            }
        },
        "hide-triangle": {
            triangle: {
                display: "none"
            },
            triangleShadow: {
                display: "none"
            }
        },
        "top-left-triangle": {
            triangle: {
                top: "-10px",
                left: "12px"
            },
            triangleShadow: {
                top: "-11px",
                left: "12px"
            }
        },
        "top-right-triangle": {
            triangle: {
                top: "-10px",
                right: "12px"
            },
            triangleShadow: {
                top: "-11px",
                right: "12px"
            }
        }
    }, passedStyles), {
        "hide-triangle": triangle === "hide",
        "top-left-triangle": triangle === "top-left",
        "top-right-triangle": triangle === "top-right"
    });
    var handleChange = function handleChange(hexcode, e) {
        $c667524adaf9821a$export$944f75ec5697b362(hexcode) && onChange({
            hex: hexcode,
            source: "hex"
        }, e);
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("div", {
        style: styles.card,
        className: "twitter-picker " + className
    }, (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("div", {
        style: styles.triangleShadow
    }), (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("div", {
        style: styles.triangle
    }), (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("div", {
        style: styles.body
    }, (0, $3d887f2aa95d4ff7$export$2e2bcd8739ae039)(colors, function(c, i) {
        return (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $d738ffe146a16d78$export$2e2bcd8739ae039), {
            key: i,
            color: c,
            hex: c,
            style: styles.swatch,
            onClick: handleChange,
            onHover: onSwatchHover,
            focusStyle: {
                boxShadow: "0 0 4px " + c
            }
        });
    }), (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("div", {
        style: styles.hash
    }, "#"), (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $daa8013ee334d911$export$2e2bcd8739ae039), {
        label: null,
        style: {
            input: styles.input
        },
        value: hex.replace("#", ""),
        onChange: handleChange
    }), (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("div", {
        style: styles.clear
    })));
};
$cfdc4f12729020c1$export$9e389cdad32a5b7a.propTypes = {
    width: (0, (/*@__PURE__*/$parcel$interopDefault($aa40b802dd2fccfc$exports))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($aa40b802dd2fccfc$exports))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($aa40b802dd2fccfc$exports))).number
    ]),
    triangle: (0, (/*@__PURE__*/$parcel$interopDefault($aa40b802dd2fccfc$exports))).oneOf([
        "hide",
        "top-left",
        "top-right"
    ]),
    colors: (0, (/*@__PURE__*/$parcel$interopDefault($aa40b802dd2fccfc$exports))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($aa40b802dd2fccfc$exports))).string),
    styles: (0, (/*@__PURE__*/$parcel$interopDefault($aa40b802dd2fccfc$exports))).object
};
$cfdc4f12729020c1$export$9e389cdad32a5b7a.defaultProps = {
    width: 276,
    colors: [
        "#FF6900",
        "#FCB900",
        "#7BDCB5",
        "#00D084",
        "#8ED1FC",
        "#0693E3",
        "#ABB8C3",
        "#EB144C",
        "#F78DA7",
        "#9900EF"
    ],
    triangle: "top-left",
    styles: {}
};
var $cfdc4f12729020c1$export$2e2bcd8739ae039 = (0, $13e2b01d2fc0abc5$export$2e2bcd8739ae039)($cfdc4f12729020c1$export$9e389cdad32a5b7a);



var $bh6RR = parcelRequire("bh6RR");





var $bh6RR = parcelRequire("bh6RR");


var $a826665666151b9b$export$a928e0fe8b70765d = function GooglePointerCircle(props) {
    var styles = (0, (/*@__PURE__*/$parcel$interopDefault($1e6d325bf7ec7d53$exports)))({
        "default": {
            picker: {
                width: "20px",
                height: "20px",
                borderRadius: "22px",
                border: "2px #fff solid",
                transform: "translate(-12px, -13px)",
                background: "hsl(" + Math.round(props.hsl.h) + ", " + Math.round(props.hsl.s * 100) + "%, " + Math.round(props.hsl.l * 100) + "%)"
            }
        }
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("div", {
        style: styles.picker
    });
};
$a826665666151b9b$export$a928e0fe8b70765d.propTypes = {
    hsl: (0, (/*@__PURE__*/$parcel$interopDefault($aa40b802dd2fccfc$exports))).shape({
        h: (0, (/*@__PURE__*/$parcel$interopDefault($aa40b802dd2fccfc$exports))).number,
        s: (0, (/*@__PURE__*/$parcel$interopDefault($aa40b802dd2fccfc$exports))).number,
        l: (0, (/*@__PURE__*/$parcel$interopDefault($aa40b802dd2fccfc$exports))).number,
        a: (0, (/*@__PURE__*/$parcel$interopDefault($aa40b802dd2fccfc$exports))).number
    })
};
$a826665666151b9b$export$a928e0fe8b70765d.defaultProps = {
    hsl: {
        a: 1,
        h: 249.94,
        l: 0.2,
        s: 0.50
    }
};
var $a826665666151b9b$export$2e2bcd8739ae039 = $a826665666151b9b$export$a928e0fe8b70765d;



var $bh6RR = parcelRequire("bh6RR");


var $b53cfc656ec8c6d7$export$9de61b9626feed9a = function GooglePointer(props) {
    var styles = (0, (/*@__PURE__*/$parcel$interopDefault($1e6d325bf7ec7d53$exports)))({
        "default": {
            picker: {
                width: "20px",
                height: "20px",
                borderRadius: "22px",
                transform: "translate(-10px, -7px)",
                background: "hsl(" + Math.round(props.hsl.h) + ", 100%, 50%)",
                border: "2px white solid"
            }
        }
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("div", {
        style: styles.picker
    });
};
$b53cfc656ec8c6d7$export$9de61b9626feed9a.propTypes = {
    hsl: (0, (/*@__PURE__*/$parcel$interopDefault($aa40b802dd2fccfc$exports))).shape({
        h: (0, (/*@__PURE__*/$parcel$interopDefault($aa40b802dd2fccfc$exports))).number,
        s: (0, (/*@__PURE__*/$parcel$interopDefault($aa40b802dd2fccfc$exports))).number,
        l: (0, (/*@__PURE__*/$parcel$interopDefault($aa40b802dd2fccfc$exports))).number,
        a: (0, (/*@__PURE__*/$parcel$interopDefault($aa40b802dd2fccfc$exports))).number
    })
};
$b53cfc656ec8c6d7$export$9de61b9626feed9a.defaultProps = {
    hsl: {
        a: 1,
        h: 249.94,
        l: 0.2,
        s: 0.50
    }
};
var $b53cfc656ec8c6d7$export$2e2bcd8739ae039 = $b53cfc656ec8c6d7$export$9de61b9626feed9a;



var $bh6RR = parcelRequire("bh6RR");



var $506cae18d462fe29$export$e50902ed332e5599 = function GoogleFields(_ref) {
    var onChange = _ref.onChange, rgb = _ref.rgb, hsl = _ref.hsl, hex = _ref.hex, hsv = _ref.hsv;
    var handleChange = function handleChange(data, e) {
        if (data.hex) $c667524adaf9821a$export$944f75ec5697b362(data.hex) && onChange({
            hex: data.hex,
            source: "hex"
        }, e);
        else if (data.rgb) {
            var values = data.rgb.split(",");
            $c667524adaf9821a$export$e76ec4c5b3cadd73(data.rgb, "rgb") && onChange({
                r: values[0],
                g: values[1],
                b: values[2],
                a: 1,
                source: "rgb"
            }, e);
        } else if (data.hsv) {
            var _values = data.hsv.split(",");
            if ($c667524adaf9821a$export$e76ec4c5b3cadd73(data.hsv, "hsv")) {
                _values[2] = _values[2].replace("%", "");
                _values[1] = _values[1].replace("%", "");
                _values[0] = _values[0].replace("\xb0", "");
                if (_values[1] == 1) _values[1] = 0.01;
                else if (_values[2] == 1) _values[2] = 0.01;
                onChange({
                    h: Number(_values[0]),
                    s: Number(_values[1]),
                    v: Number(_values[2]),
                    source: "hsv"
                }, e);
            }
        } else if (data.hsl) {
            var _values2 = data.hsl.split(",");
            if ($c667524adaf9821a$export$e76ec4c5b3cadd73(data.hsl, "hsl")) {
                _values2[2] = _values2[2].replace("%", "");
                _values2[1] = _values2[1].replace("%", "");
                _values2[0] = _values2[0].replace("\xb0", "");
                if (hsvValue[1] == 1) hsvValue[1] = 0.01;
                else if (hsvValue[2] == 1) hsvValue[2] = 0.01;
                onChange({
                    h: Number(_values2[0]),
                    s: Number(_values2[1]),
                    v: Number(_values2[2]),
                    source: "hsl"
                }, e);
            }
        }
    };
    var styles = (0, (/*@__PURE__*/$parcel$interopDefault($1e6d325bf7ec7d53$exports)))({
        "default": {
            wrap: {
                display: "flex",
                height: "100px",
                marginTop: "4px"
            },
            fields: {
                width: "100%"
            },
            column: {
                paddingTop: "10px",
                display: "flex",
                justifyContent: "space-between"
            },
            double: {
                padding: "0px 4.4px",
                boxSizing: "border-box"
            },
            input: {
                width: "100%",
                height: "38px",
                boxSizing: "border-box",
                padding: "4px 10% 3px",
                textAlign: "center",
                border: "1px solid #dadce0",
                fontSize: "11px",
                textTransform: "lowercase",
                borderRadius: "5px",
                outline: "none",
                fontFamily: "Roboto,Arial,sans-serif"
            },
            input2: {
                height: "38px",
                width: "100%",
                border: "1px solid #dadce0",
                boxSizing: "border-box",
                fontSize: "11px",
                textTransform: "lowercase",
                borderRadius: "5px",
                outline: "none",
                paddingLeft: "10px",
                fontFamily: "Roboto,Arial,sans-serif"
            },
            label: {
                textAlign: "center",
                fontSize: "12px",
                background: "#fff",
                position: "absolute",
                textTransform: "uppercase",
                color: "#3c4043",
                width: "35px",
                top: "-6px",
                left: "0",
                right: "0",
                marginLeft: "auto",
                marginRight: "auto",
                fontFamily: "Roboto,Arial,sans-serif"
            },
            label2: {
                left: "10px",
                textAlign: "center",
                fontSize: "12px",
                background: "#fff",
                position: "absolute",
                textTransform: "uppercase",
                color: "#3c4043",
                width: "32px",
                top: "-6px",
                fontFamily: "Roboto,Arial,sans-serif"
            },
            single: {
                flexGrow: "1",
                margin: "0px 4.4px"
            }
        }
    });
    var rgbValue = rgb.r + ", " + rgb.g + ", " + rgb.b;
    var hslValue = Math.round(hsl.h) + "\xb0, " + Math.round(hsl.s * 100) + "%, " + Math.round(hsl.l * 100) + "%";
    var hsvValue = Math.round(hsv.h) + "\xb0, " + Math.round(hsv.s * 100) + "%, " + Math.round(hsv.v * 100) + "%";
    return (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("div", {
        style: styles.wrap,
        className: "flexbox-fix"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("div", {
        style: styles.fields
    }, (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("div", {
        style: styles.double
    }, (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $daa8013ee334d911$export$2e2bcd8739ae039), {
        style: {
            input: styles.input,
            label: styles.label
        },
        label: "hex",
        value: hex,
        onChange: handleChange
    })), (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("div", {
        style: styles.column
    }, (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("div", {
        style: styles.single
    }, (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $daa8013ee334d911$export$2e2bcd8739ae039), {
        style: {
            input: styles.input2,
            label: styles.label2
        },
        label: "rgb",
        value: rgbValue,
        onChange: handleChange
    })), (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("div", {
        style: styles.single
    }, (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $daa8013ee334d911$export$2e2bcd8739ae039), {
        style: {
            input: styles.input2,
            label: styles.label2
        },
        label: "hsv",
        value: hsvValue,
        onChange: handleChange
    })), (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("div", {
        style: styles.single
    }, (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $daa8013ee334d911$export$2e2bcd8739ae039), {
        style: {
            input: styles.input2,
            label: styles.label2
        },
        label: "hsl",
        value: hslValue,
        onChange: handleChange
    })))));
};
var $506cae18d462fe29$export$2e2bcd8739ae039 = $506cae18d462fe29$export$e50902ed332e5599;


var $c02edbe0677e4f57$export$347eee6e8bf67997 = function Google(_ref) {
    var width = _ref.width, onChange = _ref.onChange, rgb = _ref.rgb, hsl = _ref.hsl, hsv = _ref.hsv, hex = _ref.hex, header = _ref.header, _ref$styles = _ref.styles, passedStyles = _ref$styles === undefined ? {} : _ref$styles, _ref$className = _ref.className, className = _ref$className === undefined ? "" : _ref$className;
    var styles = (0, (/*@__PURE__*/$parcel$interopDefault($1e6d325bf7ec7d53$exports)))((0, $b3cb9f7788522a6d$export$2e2bcd8739ae039)({
        "default": {
            picker: {
                width: width,
                background: "#fff",
                border: "1px solid #dfe1e5",
                boxSizing: "initial",
                display: "flex",
                flexWrap: "wrap",
                borderRadius: "8px 8px 0px 0px"
            },
            head: {
                height: "57px",
                width: "100%",
                paddingTop: "16px",
                paddingBottom: "16px",
                paddingLeft: "16px",
                fontSize: "20px",
                boxSizing: "border-box",
                fontFamily: "Roboto-Regular,HelveticaNeue,Arial,sans-serif"
            },
            saturation: {
                width: "70%",
                padding: "0px",
                position: "relative",
                overflow: "hidden"
            },
            swatch: {
                width: "30%",
                height: "228px",
                padding: "0px",
                background: "rgba(" + rgb.r + ", " + rgb.g + ", " + rgb.b + ", 1)",
                position: "relative",
                overflow: "hidden"
            },
            body: {
                margin: "auto",
                width: "95%"
            },
            controls: {
                display: "flex",
                boxSizing: "border-box",
                height: "52px",
                paddingTop: "22px"
            },
            color: {
                width: "32px"
            },
            hue: {
                height: "8px",
                position: "relative",
                margin: "0px 16px 0px 16px",
                width: "100%"
            },
            Hue: {
                radius: "2px"
            }
        }
    }, passedStyles));
    return (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("div", {
        style: styles.picker,
        className: "google-picker " + className
    }, (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("div", {
        style: styles.head
    }, header), (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("div", {
        style: styles.swatch
    }), (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("div", {
        style: styles.saturation
    }, (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $5a5024834f3556d9$export$2e2bcd8739ae039), {
        hsl: hsl,
        hsv: hsv,
        pointer: (0, $a826665666151b9b$export$2e2bcd8739ae039),
        onChange: onChange
    })), (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("div", {
        style: styles.body
    }, (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("div", {
        style: styles.controls,
        className: "flexbox-fix"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("div", {
        style: styles.hue
    }, (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $27b1902952abffb6$export$2e2bcd8739ae039), {
        style: styles.Hue,
        hsl: hsl,
        radius: "4px",
        pointer: (0, $b53cfc656ec8c6d7$export$2e2bcd8739ae039),
        onChange: onChange
    }))), (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $506cae18d462fe29$export$2e2bcd8739ae039), {
        rgb: rgb,
        hsl: hsl,
        hex: hex,
        hsv: hsv,
        onChange: onChange
    })));
};
$c02edbe0677e4f57$export$347eee6e8bf67997.propTypes = {
    width: (0, (/*@__PURE__*/$parcel$interopDefault($aa40b802dd2fccfc$exports))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($aa40b802dd2fccfc$exports))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($aa40b802dd2fccfc$exports))).number
    ]),
    styles: (0, (/*@__PURE__*/$parcel$interopDefault($aa40b802dd2fccfc$exports))).object,
    header: (0, (/*@__PURE__*/$parcel$interopDefault($aa40b802dd2fccfc$exports))).string
};
$c02edbe0677e4f57$export$347eee6e8bf67997.defaultProps = {
    width: 652,
    styles: {},
    header: "Color picker"
};
var $c02edbe0677e4f57$export$2e2bcd8739ae039 = (0, $13e2b01d2fc0abc5$export$2e2bcd8739ae039)($c02edbe0677e4f57$export$347eee6e8bf67997);





function $deb955abbaf8897f$export$2e2bcd8739ae039(red, green, blue, alpha) {
    const isPercent = (red + (alpha || "")).toString().includes("%");
    if (typeof red === "string") [red, green, blue, alpha] = red.match(/(0?\.?\d+)%?\b/g).map((component)=>Number(component));
    else if (alpha !== undefined) alpha = Number.parseFloat(alpha);
    if (typeof red !== "number" || typeof green !== "number" || typeof blue !== "number" || red > 255 || green > 255 || blue > 255) throw new TypeError("Expected three numbers below 256");
    if (typeof alpha === "number") {
        if (!isPercent && alpha >= 0 && alpha <= 1) alpha = Math.round(255 * alpha);
        else if (isPercent && alpha >= 0 && alpha <= 100) alpha = Math.round(255 * alpha / 100);
        else throw new TypeError(`Expected alpha value (${alpha}) as a fraction or percentage`);
        alpha = (alpha | 256).toString(16).slice(1); // eslint-disable-line no-mixed-operators
    } else alpha = "";
    // TODO: Remove this ignore comment.
    // eslint-disable-next-line no-mixed-operators
    return (blue | green << 8 | red << 16 | 16777216).toString(16).slice(1) + alpha;
}


var $86521b2041dac6c7$exports = {};
"use strict";
var $41c1050a031e5498$exports = {};
$41c1050a031e5498$exports = function() {
    var selection = document.getSelection();
    if (!selection.rangeCount) return function() {};
    var active = document.activeElement;
    var ranges = [];
    for(var i = 0; i < selection.rangeCount; i++)ranges.push(selection.getRangeAt(i));
    switch(active.tagName.toUpperCase()){
        case "INPUT":
        case "TEXTAREA":
            active.blur();
            break;
        default:
            active = null;
            break;
    }
    selection.removeAllRanges();
    return function() {
        selection.type === "Caret" && selection.removeAllRanges();
        if (!selection.rangeCount) ranges.forEach(function(range) {
            selection.addRange(range);
        });
        active && active.focus();
    };
};


var $86521b2041dac6c7$var$clipboardToIE11Formatting = {
    "text/plain": "Text",
    "text/html": "Url",
    "default": "Text"
};
var $86521b2041dac6c7$var$defaultMessage = "Copy to clipboard: #{key}, Enter";
function $86521b2041dac6c7$var$format(message) {
    var copyKey = (/mac os x/i.test(navigator.userAgent) ? "⌘" : "Ctrl") + "+C";
    return message.replace(/#{\s*key\s*}/g, copyKey);
}
function $86521b2041dac6c7$var$copy(text, options) {
    var debug, message, reselectPrevious, range, selection, mark, success = false;
    if (!options) options = {};
    debug = options.debug || false;
    try {
        reselectPrevious = $41c1050a031e5498$exports();
        range = document.createRange();
        selection = document.getSelection();
        mark = document.createElement("span");
        mark.textContent = text;
        // avoid screen readers from reading out loud the text
        mark.ariaHidden = "true";
        // reset user styles for span element
        mark.style.all = "unset";
        // prevents scrolling to the end of the page
        mark.style.position = "fixed";
        mark.style.top = 0;
        mark.style.clip = "rect(0, 0, 0, 0)";
        // used to preserve spaces and line breaks
        mark.style.whiteSpace = "pre";
        // do not inherit user-select (it may be `none`)
        mark.style.webkitUserSelect = "text";
        mark.style.MozUserSelect = "text";
        mark.style.msUserSelect = "text";
        mark.style.userSelect = "text";
        mark.addEventListener("copy", function(e) {
            e.stopPropagation();
            if (options.format) {
                e.preventDefault();
                if (typeof e.clipboardData === "undefined") {
                    debug && console.warn("unable to use e.clipboardData");
                    debug && console.warn("trying IE specific stuff");
                    window.clipboardData.clearData();
                    var format = $86521b2041dac6c7$var$clipboardToIE11Formatting[options.format] || $86521b2041dac6c7$var$clipboardToIE11Formatting["default"];
                    window.clipboardData.setData(format, text);
                } else {
                    e.clipboardData.clearData();
                    e.clipboardData.setData(options.format, text);
                }
            }
            if (options.onCopy) {
                e.preventDefault();
                options.onCopy(e.clipboardData);
            }
        });
        document.body.appendChild(mark);
        range.selectNodeContents(mark);
        selection.addRange(range);
        var successful = document.execCommand("copy");
        if (!successful) throw new Error("copy command was unsuccessful");
        success = true;
    } catch (err) {
        debug && console.error("unable to copy using execCommand: ", err);
        debug && console.warn("trying IE specific stuff");
        try {
            window.clipboardData.setData(options.format || "text", text);
            options.onCopy && options.onCopy(window.clipboardData);
            success = true;
        } catch (err) {
            debug && console.error("unable to copy using clipboardData: ", err);
            debug && console.error("falling back to prompt");
            message = $86521b2041dac6c7$var$format("message" in options ? options.message : $86521b2041dac6c7$var$defaultMessage);
            window.prompt(message, text);
        }
    } finally{
        if (selection) {
            if (typeof selection.removeRange == "function") selection.removeRange(range);
            else selection.removeAllRanges();
        }
        if (mark) document.body.removeChild(mark);
        reselectPrevious();
    }
    return success;
}
$86521b2041dac6c7$exports = $86521b2041dac6c7$var$copy;


function $1d5571bdb4f0e237$var$_extends() {
    $1d5571bdb4f0e237$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $1d5571bdb4f0e237$var$_extends.apply(this, arguments);
}
function $1d5571bdb4f0e237$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}

var $bh6RR = parcelRequire("bh6RR");
var $067c346c53a4452d$var$e = "colors", $067c346c53a4452d$var$t = "sizes", $067c346c53a4452d$var$r = "space", $067c346c53a4452d$export$22deaee80f3d7c38 = {
    gap: $067c346c53a4452d$var$r,
    gridGap: $067c346c53a4452d$var$r,
    columnGap: $067c346c53a4452d$var$r,
    gridColumnGap: $067c346c53a4452d$var$r,
    rowGap: $067c346c53a4452d$var$r,
    gridRowGap: $067c346c53a4452d$var$r,
    inset: $067c346c53a4452d$var$r,
    insetBlock: $067c346c53a4452d$var$r,
    insetBlockEnd: $067c346c53a4452d$var$r,
    insetBlockStart: $067c346c53a4452d$var$r,
    insetInline: $067c346c53a4452d$var$r,
    insetInlineEnd: $067c346c53a4452d$var$r,
    insetInlineStart: $067c346c53a4452d$var$r,
    margin: $067c346c53a4452d$var$r,
    marginTop: $067c346c53a4452d$var$r,
    marginRight: $067c346c53a4452d$var$r,
    marginBottom: $067c346c53a4452d$var$r,
    marginLeft: $067c346c53a4452d$var$r,
    marginBlock: $067c346c53a4452d$var$r,
    marginBlockEnd: $067c346c53a4452d$var$r,
    marginBlockStart: $067c346c53a4452d$var$r,
    marginInline: $067c346c53a4452d$var$r,
    marginInlineEnd: $067c346c53a4452d$var$r,
    marginInlineStart: $067c346c53a4452d$var$r,
    padding: $067c346c53a4452d$var$r,
    paddingTop: $067c346c53a4452d$var$r,
    paddingRight: $067c346c53a4452d$var$r,
    paddingBottom: $067c346c53a4452d$var$r,
    paddingLeft: $067c346c53a4452d$var$r,
    paddingBlock: $067c346c53a4452d$var$r,
    paddingBlockEnd: $067c346c53a4452d$var$r,
    paddingBlockStart: $067c346c53a4452d$var$r,
    paddingInline: $067c346c53a4452d$var$r,
    paddingInlineEnd: $067c346c53a4452d$var$r,
    paddingInlineStart: $067c346c53a4452d$var$r,
    top: $067c346c53a4452d$var$r,
    right: $067c346c53a4452d$var$r,
    bottom: $067c346c53a4452d$var$r,
    left: $067c346c53a4452d$var$r,
    scrollMargin: $067c346c53a4452d$var$r,
    scrollMarginTop: $067c346c53a4452d$var$r,
    scrollMarginRight: $067c346c53a4452d$var$r,
    scrollMarginBottom: $067c346c53a4452d$var$r,
    scrollMarginLeft: $067c346c53a4452d$var$r,
    scrollMarginX: $067c346c53a4452d$var$r,
    scrollMarginY: $067c346c53a4452d$var$r,
    scrollMarginBlock: $067c346c53a4452d$var$r,
    scrollMarginBlockEnd: $067c346c53a4452d$var$r,
    scrollMarginBlockStart: $067c346c53a4452d$var$r,
    scrollMarginInline: $067c346c53a4452d$var$r,
    scrollMarginInlineEnd: $067c346c53a4452d$var$r,
    scrollMarginInlineStart: $067c346c53a4452d$var$r,
    scrollPadding: $067c346c53a4452d$var$r,
    scrollPaddingTop: $067c346c53a4452d$var$r,
    scrollPaddingRight: $067c346c53a4452d$var$r,
    scrollPaddingBottom: $067c346c53a4452d$var$r,
    scrollPaddingLeft: $067c346c53a4452d$var$r,
    scrollPaddingX: $067c346c53a4452d$var$r,
    scrollPaddingY: $067c346c53a4452d$var$r,
    scrollPaddingBlock: $067c346c53a4452d$var$r,
    scrollPaddingBlockEnd: $067c346c53a4452d$var$r,
    scrollPaddingBlockStart: $067c346c53a4452d$var$r,
    scrollPaddingInline: $067c346c53a4452d$var$r,
    scrollPaddingInlineEnd: $067c346c53a4452d$var$r,
    scrollPaddingInlineStart: $067c346c53a4452d$var$r,
    fontSize: "fontSizes",
    background: $067c346c53a4452d$var$e,
    backgroundColor: $067c346c53a4452d$var$e,
    backgroundImage: $067c346c53a4452d$var$e,
    borderImage: $067c346c53a4452d$var$e,
    border: $067c346c53a4452d$var$e,
    borderBlock: $067c346c53a4452d$var$e,
    borderBlockEnd: $067c346c53a4452d$var$e,
    borderBlockStart: $067c346c53a4452d$var$e,
    borderBottom: $067c346c53a4452d$var$e,
    borderBottomColor: $067c346c53a4452d$var$e,
    borderColor: $067c346c53a4452d$var$e,
    borderInline: $067c346c53a4452d$var$e,
    borderInlineEnd: $067c346c53a4452d$var$e,
    borderInlineStart: $067c346c53a4452d$var$e,
    borderLeft: $067c346c53a4452d$var$e,
    borderLeftColor: $067c346c53a4452d$var$e,
    borderRight: $067c346c53a4452d$var$e,
    borderRightColor: $067c346c53a4452d$var$e,
    borderTop: $067c346c53a4452d$var$e,
    borderTopColor: $067c346c53a4452d$var$e,
    caretColor: $067c346c53a4452d$var$e,
    color: $067c346c53a4452d$var$e,
    columnRuleColor: $067c346c53a4452d$var$e,
    fill: $067c346c53a4452d$var$e,
    outline: $067c346c53a4452d$var$e,
    outlineColor: $067c346c53a4452d$var$e,
    stroke: $067c346c53a4452d$var$e,
    textDecorationColor: $067c346c53a4452d$var$e,
    fontFamily: "fonts",
    fontWeight: "fontWeights",
    lineHeight: "lineHeights",
    letterSpacing: "letterSpacings",
    blockSize: $067c346c53a4452d$var$t,
    minBlockSize: $067c346c53a4452d$var$t,
    maxBlockSize: $067c346c53a4452d$var$t,
    inlineSize: $067c346c53a4452d$var$t,
    minInlineSize: $067c346c53a4452d$var$t,
    maxInlineSize: $067c346c53a4452d$var$t,
    width: $067c346c53a4452d$var$t,
    minWidth: $067c346c53a4452d$var$t,
    maxWidth: $067c346c53a4452d$var$t,
    height: $067c346c53a4452d$var$t,
    minHeight: $067c346c53a4452d$var$t,
    maxHeight: $067c346c53a4452d$var$t,
    flexBasis: $067c346c53a4452d$var$t,
    gridTemplateColumns: $067c346c53a4452d$var$t,
    gridTemplateRows: $067c346c53a4452d$var$t,
    borderWidth: "borderWidths",
    borderTopWidth: "borderWidths",
    borderRightWidth: "borderWidths",
    borderBottomWidth: "borderWidths",
    borderLeftWidth: "borderWidths",
    borderStyle: "borderStyles",
    borderTopStyle: "borderStyles",
    borderRightStyle: "borderStyles",
    borderBottomStyle: "borderStyles",
    borderLeftStyle: "borderStyles",
    borderRadius: "radii",
    borderTopLeftRadius: "radii",
    borderTopRightRadius: "radii",
    borderBottomRightRadius: "radii",
    borderBottomLeftRadius: "radii",
    boxShadow: "shadows",
    textShadow: "shadows",
    transition: "transitions",
    zIndex: "zIndices"
}, $067c346c53a4452d$var$i = (e, t)=>"function" == typeof t ? {
        "()": Function.prototype.toString.call(t)
    } : t, $067c346c53a4452d$var$o = ()=>{
    const e = Object.create(null);
    return (t, r, ...n)=>{
        const o = ((e)=>JSON.stringify(e, $067c346c53a4452d$var$i))(t);
        return o in e ? e[o] : e[o] = r(t, ...n);
    };
}, $067c346c53a4452d$var$l = Symbol.for("sxs.internal"), $067c346c53a4452d$var$s = (e, t)=>Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)), $067c346c53a4452d$var$a = (e)=>{
    for(const t in e)return !0;
    return !1;
}, { hasOwnProperty: $067c346c53a4452d$var$c } = Object.prototype, $067c346c53a4452d$var$d = (e)=>e.includes("-") ? e : e.replace(/[A-Z]/g, (e)=>"-" + e.toLowerCase()), $067c346c53a4452d$var$g = /\s+(?![^()]*\))/, $067c346c53a4452d$var$p = (e)=>(t)=>e(..."string" == typeof t ? String(t).split($067c346c53a4452d$var$g) : [
            t
        ]), $067c346c53a4452d$var$u = {
    appearance: (e)=>({
            WebkitAppearance: e,
            appearance: e
        }),
    backfaceVisibility: (e)=>({
            WebkitBackfaceVisibility: e,
            backfaceVisibility: e
        }),
    backdropFilter: (e)=>({
            WebkitBackdropFilter: e,
            backdropFilter: e
        }),
    backgroundClip: (e)=>({
            WebkitBackgroundClip: e,
            backgroundClip: e
        }),
    boxDecorationBreak: (e)=>({
            WebkitBoxDecorationBreak: e,
            boxDecorationBreak: e
        }),
    clipPath: (e)=>({
            WebkitClipPath: e,
            clipPath: e
        }),
    content: (e)=>({
            content: e.includes('"') || e.includes("'") || /^([A-Za-z]+\([^]*|[^]*-quote|inherit|initial|none|normal|revert|unset)$/.test(e) ? e : `"${e}"`
        }),
    hyphens: (e)=>({
            WebkitHyphens: e,
            hyphens: e
        }),
    maskImage: (e)=>({
            WebkitMaskImage: e,
            maskImage: e
        }),
    maskSize: (e)=>({
            WebkitMaskSize: e,
            maskSize: e
        }),
    tabSize: (e)=>({
            MozTabSize: e,
            tabSize: e
        }),
    textSizeAdjust: (e)=>({
            WebkitTextSizeAdjust: e,
            textSizeAdjust: e
        }),
    userSelect: (e)=>({
            WebkitUserSelect: e,
            userSelect: e
        }),
    marginBlock: $067c346c53a4452d$var$p((e, t)=>({
            marginBlockStart: e,
            marginBlockEnd: t || e
        })),
    marginInline: $067c346c53a4452d$var$p((e, t)=>({
            marginInlineStart: e,
            marginInlineEnd: t || e
        })),
    maxSize: $067c346c53a4452d$var$p((e, t)=>({
            maxBlockSize: e,
            maxInlineSize: t || e
        })),
    minSize: $067c346c53a4452d$var$p((e, t)=>({
            minBlockSize: e,
            minInlineSize: t || e
        })),
    paddingBlock: $067c346c53a4452d$var$p((e, t)=>({
            paddingBlockStart: e,
            paddingBlockEnd: t || e
        })),
    paddingInline: $067c346c53a4452d$var$p((e, t)=>({
            paddingInlineStart: e,
            paddingInlineEnd: t || e
        }))
}, $067c346c53a4452d$var$h = /([\d.]+)([^]*)/, $067c346c53a4452d$var$f = (e, t)=>e.length ? e.reduce((e, r)=>(e.push(...t.map((e)=>e.includes("&") ? e.replace(/&/g, /[ +>|~]/.test(r) && /&.*&/.test(e) ? `:is(${r})` : r) : r + " " + e)), e), []) : t, $067c346c53a4452d$var$m = (e, t)=>e in $067c346c53a4452d$var$b && "string" == typeof t ? t.replace(/^((?:[^]*[^\w-])?)(fit-content|stretch)((?:[^\w-][^]*)?)$/, (t, r, n, i)=>r + ("stretch" === n ? `-moz-available${i};${$067c346c53a4452d$var$d(e)}:${r}-webkit-fill-available` : `-moz-fit-content${i};${$067c346c53a4452d$var$d(e)}:${r}fit-content`) + i) : String(t), $067c346c53a4452d$var$b = {
    blockSize: 1,
    height: 1,
    inlineSize: 1,
    maxBlockSize: 1,
    maxHeight: 1,
    maxInlineSize: 1,
    maxWidth: 1,
    minBlockSize: 1,
    minHeight: 1,
    minInlineSize: 1,
    minWidth: 1,
    width: 1
}, $067c346c53a4452d$var$S = (e)=>e ? e + "-" : "", $067c346c53a4452d$var$k = (e, t, r)=>e.replace(/([+-])?((?:\d+(?:\.\d*)?|\.\d+)(?:[Ee][+-]?\d+)?)?(\$|--)([$\w-]+)/g, (e, n, i, o, l)=>"$" == o == !!i ? e : (n || "--" == o ? "calc(" : "") + "var(--" + ("$" === o ? $067c346c53a4452d$var$S(t) + (l.includes("$") ? "" : $067c346c53a4452d$var$S(r)) + l.replace(/\$/g, "-") : l) + ")" + (n || "--" == o ? "*" + (n || "") + (i || "1") + ")" : "")), $067c346c53a4452d$var$y = /\s*,\s*(?![^()]*\))/, $067c346c53a4452d$var$B = Object.prototype.toString, $067c346c53a4452d$var$$ = (e, t, r, n, i)=>{
    let o, l, s;
    const a = (e, t, r)=>{
        let c, g;
        const p = (e)=>{
            for(c in e){
                const R = 64 === c.charCodeAt(0), z = R && Array.isArray(e[c]) ? e[c] : [
                    e[c]
                ];
                for (g of z){
                    const e = /[A-Z]/.test($ = c) ? $ : $.replace(/-[^]/g, (e)=>e[1].toUpperCase()), z = "object" == typeof g && g && g.toString === $067c346c53a4452d$var$B && (!n.utils[e] || !t.length);
                    if (e in n.utils && !z) {
                        const t = n.utils[e];
                        if (t !== l) {
                            l = t, p(t(g)), l = null;
                            continue;
                        }
                    } else if (e in $067c346c53a4452d$var$u) {
                        const t = $067c346c53a4452d$var$u[e];
                        if (t !== s) {
                            s = t, p(t(g)), s = null;
                            continue;
                        }
                    }
                    if (R && (b = c.slice(1) in n.media ? "@media " + n.media[c.slice(1)] : c, c = b.replace(/\(\s*([\w-]+)\s*(=|<|<=|>|>=)\s*([\w-]+)\s*(?:(<|<=|>|>=)\s*([\w-]+)\s*)?\)/g, (e, t, r, n, i, o)=>{
                        const l = $067c346c53a4452d$var$h.test(t), s = .0625 * (l ? -1 : 1), [a, c] = l ? [
                            n,
                            t
                        ] : [
                            t,
                            n
                        ];
                        return "(" + ("=" === r[0] ? "" : ">" === r[0] === l ? "max-" : "min-") + a + ":" + ("=" !== r[0] && 1 === r.length ? c.replace($067c346c53a4452d$var$h, (e, t, n)=>Number(t) + s * (">" === r ? 1 : -1) + n) : c) + (i ? ") and (" + (">" === i[0] ? "min-" : "max-") + a + ":" + (1 === i.length ? o.replace($067c346c53a4452d$var$h, (e, t, r)=>Number(t) + s * (">" === i ? -1 : 1) + r) : o) : "") + ")";
                    })), z) {
                        const e = R ? r.concat(c) : [
                            ...r
                        ], n = R ? [
                            ...t
                        ] : $067c346c53a4452d$var$f(t, c.split($067c346c53a4452d$var$y));
                        void 0 !== o && i($067c346c53a4452d$var$x(...o)), o = void 0, a(g, n, e);
                    } else void 0 === o && (o = [
                        [],
                        t,
                        r
                    ]), c = R || 36 !== c.charCodeAt(0) ? c : `--${$067c346c53a4452d$var$S(n.prefix)}${c.slice(1).replace(/\$/g, "-")}`, g = z ? g : "number" == typeof g ? g && e in $067c346c53a4452d$var$I ? String(g) + "px" : String(g) : $067c346c53a4452d$var$k($067c346c53a4452d$var$m(e, null == g ? "" : g), n.prefix, n.themeMap[e]), o[0].push(`${R ? `${c} ` : `${$067c346c53a4452d$var$d(c)}:`}${g}`);
                }
            }
            var b, $;
        };
        p(e), void 0 !== o && i($067c346c53a4452d$var$x(...o)), o = void 0;
    };
    a(e, t, r);
}, $067c346c53a4452d$var$x = (e, t, r)=>`${r.map((e)=>`${e}{`).join("")}${t.length ? `${t.join(",")}{` : ""}${e.join(";")}${t.length ? "}" : ""}${Array(r.length ? r.length + 1 : 0).join("}")}`, $067c346c53a4452d$var$I = {
    animationDelay: 1,
    animationDuration: 1,
    backgroundSize: 1,
    blockSize: 1,
    border: 1,
    borderBlock: 1,
    borderBlockEnd: 1,
    borderBlockEndWidth: 1,
    borderBlockStart: 1,
    borderBlockStartWidth: 1,
    borderBlockWidth: 1,
    borderBottom: 1,
    borderBottomLeftRadius: 1,
    borderBottomRightRadius: 1,
    borderBottomWidth: 1,
    borderEndEndRadius: 1,
    borderEndStartRadius: 1,
    borderInlineEnd: 1,
    borderInlineEndWidth: 1,
    borderInlineStart: 1,
    borderInlineStartWidth: 1,
    borderInlineWidth: 1,
    borderLeft: 1,
    borderLeftWidth: 1,
    borderRadius: 1,
    borderRight: 1,
    borderRightWidth: 1,
    borderSpacing: 1,
    borderStartEndRadius: 1,
    borderStartStartRadius: 1,
    borderTop: 1,
    borderTopLeftRadius: 1,
    borderTopRightRadius: 1,
    borderTopWidth: 1,
    borderWidth: 1,
    bottom: 1,
    columnGap: 1,
    columnRule: 1,
    columnRuleWidth: 1,
    columnWidth: 1,
    containIntrinsicSize: 1,
    flexBasis: 1,
    fontSize: 1,
    gap: 1,
    gridAutoColumns: 1,
    gridAutoRows: 1,
    gridTemplateColumns: 1,
    gridTemplateRows: 1,
    height: 1,
    inlineSize: 1,
    inset: 1,
    insetBlock: 1,
    insetBlockEnd: 1,
    insetBlockStart: 1,
    insetInline: 1,
    insetInlineEnd: 1,
    insetInlineStart: 1,
    left: 1,
    letterSpacing: 1,
    margin: 1,
    marginBlock: 1,
    marginBlockEnd: 1,
    marginBlockStart: 1,
    marginBottom: 1,
    marginInline: 1,
    marginInlineEnd: 1,
    marginInlineStart: 1,
    marginLeft: 1,
    marginRight: 1,
    marginTop: 1,
    maxBlockSize: 1,
    maxHeight: 1,
    maxInlineSize: 1,
    maxWidth: 1,
    minBlockSize: 1,
    minHeight: 1,
    minInlineSize: 1,
    minWidth: 1,
    offsetDistance: 1,
    offsetRotate: 1,
    outline: 1,
    outlineOffset: 1,
    outlineWidth: 1,
    overflowClipMargin: 1,
    padding: 1,
    paddingBlock: 1,
    paddingBlockEnd: 1,
    paddingBlockStart: 1,
    paddingBottom: 1,
    paddingInline: 1,
    paddingInlineEnd: 1,
    paddingInlineStart: 1,
    paddingLeft: 1,
    paddingRight: 1,
    paddingTop: 1,
    perspective: 1,
    right: 1,
    rowGap: 1,
    scrollMargin: 1,
    scrollMarginBlock: 1,
    scrollMarginBlockEnd: 1,
    scrollMarginBlockStart: 1,
    scrollMarginBottom: 1,
    scrollMarginInline: 1,
    scrollMarginInlineEnd: 1,
    scrollMarginInlineStart: 1,
    scrollMarginLeft: 1,
    scrollMarginRight: 1,
    scrollMarginTop: 1,
    scrollPadding: 1,
    scrollPaddingBlock: 1,
    scrollPaddingBlockEnd: 1,
    scrollPaddingBlockStart: 1,
    scrollPaddingBottom: 1,
    scrollPaddingInline: 1,
    scrollPaddingInlineEnd: 1,
    scrollPaddingInlineStart: 1,
    scrollPaddingLeft: 1,
    scrollPaddingRight: 1,
    scrollPaddingTop: 1,
    shapeMargin: 1,
    textDecoration: 1,
    textDecorationThickness: 1,
    textIndent: 1,
    textUnderlineOffset: 1,
    top: 1,
    transitionDelay: 1,
    transitionDuration: 1,
    verticalAlign: 1,
    width: 1,
    wordSpacing: 1
}, $067c346c53a4452d$var$R = (e)=>String.fromCharCode(e + (e > 25 ? 39 : 97)), $067c346c53a4452d$var$z = (e)=>((e)=>{
        let t, r = "";
        for(t = Math.abs(e); t > 52; t = t / 52 | 0)r = $067c346c53a4452d$var$R(t % 52) + r;
        return $067c346c53a4452d$var$R(t % 52) + r;
    })(((e, t)=>{
        let r = t.length;
        for(; r;)e = 33 * e ^ t.charCodeAt(--r);
        return e;
    })(5381, JSON.stringify(e)) >>> 0), $067c346c53a4452d$var$W = [
    "themed",
    "global",
    "styled",
    "onevar",
    "resonevar",
    "allvar",
    "inline"
], $067c346c53a4452d$var$j = (e)=>{
    if (e.href && !e.href.startsWith(location.origin)) return !1;
    try {
        return !!e.cssRules;
    } catch (e) {
        return !1;
    }
}, $067c346c53a4452d$var$E = (e)=>{
    let t;
    const r = ()=>{
        const { cssRules: e } = t.sheet;
        return [].map.call(e, (r, n)=>{
            const { cssText: i } = r;
            let o = "";
            if (i.startsWith("--sxs")) return "";
            if (e[n - 1] && (o = e[n - 1].cssText).startsWith("--sxs")) {
                if (!r.cssRules.length) return "";
                for(const e in t.rules)if (t.rules[e].group === r) return `--sxs{--sxs:${[
                    ...t.rules[e].cache
                ].join(" ")}}${i}`;
                return r.cssRules.length ? `${o}${i}` : "";
            }
            return i;
        }).join("");
    }, n = ()=>{
        if (t) {
            const { rules: e, sheet: r } = t;
            if (!r.deleteRule) {
                for(; 3 === Object(Object(r.cssRules)[0]).type;)r.cssRules.splice(0, 1);
                r.cssRules = [];
            }
            for(const t in e)delete e[t];
        }
        const i = Object(e).styleSheets || [];
        for (const e of i)if ($067c346c53a4452d$var$j(e)) {
            for(let i = 0, o = e.cssRules; o[i]; ++i){
                const l = Object(o[i]);
                if (1 !== l.type) continue;
                const s = Object(o[i + 1]);
                if (4 !== s.type) continue;
                ++i;
                const { cssText: a } = l;
                if (!a.startsWith("--sxs")) continue;
                const c = a.slice(14, -3).trim().split(/\s+/), d = $067c346c53a4452d$var$W[c[0]];
                d && (t || (t = {
                    sheet: e,
                    reset: n,
                    rules: {},
                    toString: r
                }), t.rules[d] = {
                    group: s,
                    index: i,
                    cache: new Set(c)
                });
            }
            if (t) break;
        }
        if (!t) {
            const i = (e, t)=>({
                    type: t,
                    cssRules: [],
                    insertRule (e, t) {
                        this.cssRules.splice(t, 0, i(e, {
                            import: 3,
                            undefined: 1
                        }[(e.toLowerCase().match(/^@([a-z]+)/) || [])[1]] || 4));
                    },
                    get cssText () {
                        return "@media{}" === e ? `@media{${[].map.call(this.cssRules, (e)=>e.cssText).join("")}}` : e;
                    }
                });
            t = {
                sheet: e ? (e.head || e).appendChild(document.createElement("style")).sheet : i("", "text/css"),
                rules: {},
                reset: n,
                toString: r
            };
        }
        const { sheet: o, rules: l } = t;
        for(let e = $067c346c53a4452d$var$W.length - 1; e >= 0; --e){
            const t = $067c346c53a4452d$var$W[e];
            if (!l[t]) {
                const r = $067c346c53a4452d$var$W[e + 1], n = l[r] ? l[r].index : o.cssRules.length;
                o.insertRule("@media{}", n), o.insertRule(`--sxs{--sxs:${e}}`, n), l[t] = {
                    group: o.cssRules[n + 1],
                    index: n,
                    cache: new Set([
                        e
                    ])
                };
            }
            $067c346c53a4452d$var$v(l[t]);
        }
    };
    return n(), t;
}, $067c346c53a4452d$var$v = (e)=>{
    const t = e.group;
    let r = t.cssRules.length;
    e.apply = (e)=>{
        try {
            t.insertRule(e, r), ++r;
        } catch (e) {}
    };
}, $067c346c53a4452d$var$T = Symbol(), $067c346c53a4452d$var$w = $067c346c53a4452d$var$o(), $067c346c53a4452d$var$M = (e, t)=>$067c346c53a4452d$var$w(e, ()=>(...r)=>{
            let n = {
                type: null,
                composers: new Set
            };
            for (const t of r)if (null != t) {
                if (t[$067c346c53a4452d$var$l]) {
                    null == n.type && (n.type = t[$067c346c53a4452d$var$l].type);
                    for (const e of t[$067c346c53a4452d$var$l].composers)n.composers.add(e);
                } else t.constructor !== Object || t.$$typeof ? null == n.type && (n.type = t) : n.composers.add($067c346c53a4452d$var$C(t, e));
            }
            return null == n.type && (n.type = "span"), n.composers.size || n.composers.add([
                "PJLV",
                {},
                [],
                [],
                {},
                []
            ]), $067c346c53a4452d$var$P(e, n, t);
        }), $067c346c53a4452d$var$C = ({ variants: e, compoundVariants: t, defaultVariants: r, ...n }, i)=>{
    const o = `${$067c346c53a4452d$var$S(i.prefix)}c-${$067c346c53a4452d$var$z(n)}`, l = [], s = [], d = Object.create(null), g = [];
    for(const e in r)d[e] = String(r[e]);
    if ("object" == typeof e && e) for(const t in e){
        p = d, u = t, $067c346c53a4452d$var$c.call(p, u) || (d[t] = "undefined");
        const r = e[t];
        for(const e in r){
            const n = {
                [t]: String(e)
            };
            "undefined" === String(e) && g.push(t);
            const i = r[e], o = [
                n,
                i,
                !$067c346c53a4452d$var$a(i)
            ];
            l.push(o);
        }
    }
    var p, u;
    if ("object" == typeof t && t) for (const e of t){
        let { css: t, ...r } = e;
        t = "object" == typeof t && t || {};
        for(const e in r)r[e] = String(r[e]);
        const n = [
            r,
            t,
            !$067c346c53a4452d$var$a(t)
        ];
        s.push(n);
    }
    return [
        o,
        n,
        l,
        s,
        d,
        g
    ];
}, $067c346c53a4452d$var$P = (e, t, r)=>{
    const [n, i, o, a] = $067c346c53a4452d$var$L(t.composers), c = "function" == typeof t.type || t.type.$$typeof ? ((e)=>{
        function t() {
            for(let r = 0; r < t[$067c346c53a4452d$var$T].length; r++){
                const [n, i] = t[$067c346c53a4452d$var$T][r];
                e.rules[n].apply(i);
            }
            return t[$067c346c53a4452d$var$T] = [], null;
        }
        return t[$067c346c53a4452d$var$T] = [], t.rules = {}, $067c346c53a4452d$var$W.forEach((e)=>t.rules[e] = {
                apply: (r)=>t[$067c346c53a4452d$var$T].push([
                        e,
                        r
                    ])
            }), t;
    })(r) : null, d = (c || r).rules, g = `.${n}${i.length > 1 ? `:where(.${i.slice(1).join(".")})` : ""}`, p = (l)=>{
        l = "object" == typeof l && l || $067c346c53a4452d$var$A;
        const { css: s, ...p } = l, u = {};
        for(const e in o)if (delete p[e], e in l) {
            let t = l[e];
            "object" == typeof t && t ? u[e] = {
                "@initial": o[e],
                ...t
            } : (t = String(t), u[e] = "undefined" !== t || a.has(e) ? t : o[e]);
        } else u[e] = o[e];
        const h = new Set([
            ...i
        ]);
        for (const [n, i, o, l] of t.composers){
            r.rules.styled.cache.has(n) || (r.rules.styled.cache.add(n), $067c346c53a4452d$var$$(i, [
                `.${n}`
            ], [], e, (e)=>{
                d.styled.apply(e);
            }));
            const t = $067c346c53a4452d$var$O(o, u, e.media), s = $067c346c53a4452d$var$O(l, u, e.media, !0);
            for (const i of t)if (void 0 !== i) for (const [t, o, l] of i){
                const i = `${n}-${$067c346c53a4452d$var$z(o)}-${t}`;
                h.add(i);
                const s = (l ? r.rules.resonevar : r.rules.onevar).cache, a = l ? d.resonevar : d.onevar;
                s.has(i) || (s.add(i), $067c346c53a4452d$var$$(o, [
                    `.${i}`
                ], [], e, (e)=>{
                    a.apply(e);
                }));
            }
            for (const t of s)if (void 0 !== t) for (const [i, o] of t){
                const t = `${n}-${$067c346c53a4452d$var$z(o)}-${i}`;
                h.add(t), r.rules.allvar.cache.has(t) || (r.rules.allvar.cache.add(t), $067c346c53a4452d$var$$(o, [
                    `.${t}`
                ], [], e, (e)=>{
                    d.allvar.apply(e);
                }));
            }
        }
        if ("object" == typeof s && s) {
            const t = `${n}-i${$067c346c53a4452d$var$z(s)}-css`;
            h.add(t), r.rules.inline.cache.has(t) || (r.rules.inline.cache.add(t), $067c346c53a4452d$var$$(s, [
                `.${t}`
            ], [], e, (e)=>{
                d.inline.apply(e);
            }));
        }
        for (const e of String(l.className || "").trim().split(/\s+/))e && h.add(e);
        const f = p.className = [
            ...h
        ].join(" ");
        return {
            type: t.type,
            className: f,
            selector: g,
            props: p,
            toString: ()=>f,
            deferredInjector: c
        };
    };
    return $067c346c53a4452d$var$s(p, {
        className: n,
        selector: g,
        [$067c346c53a4452d$var$l]: t,
        toString: ()=>(r.rules.styled.cache.has(n) || p(), n)
    });
}, $067c346c53a4452d$var$L = (e)=>{
    let t = "";
    const r = [], n = {}, i = [];
    for (const [o, , , , l, s] of e){
        "" === t && (t = o), r.push(o), i.push(...s);
        for(const e in l){
            const t = l[e];
            (void 0 === n[e] || "undefined" !== t || s.includes(t)) && (n[e] = t);
        }
    }
    return [
        t,
        r,
        n,
        new Set(i)
    ];
}, $067c346c53a4452d$var$O = (e, t, r, n)=>{
    const i = [];
    e: for (let [o, l, s] of e){
        if (s) continue;
        let e, a = 0, c = !1;
        for(e in o){
            const n = o[e];
            let i = t[e];
            if (i !== n) {
                if ("object" != typeof i || !i) continue e;
                {
                    let e, t, o = 0;
                    for(const l in i){
                        if (n === String(i[l])) {
                            if ("@initial" !== l) {
                                const e = l.slice(1);
                                (t = t || []).push(e in r ? r[e] : l.replace(/^@media ?/, "")), c = !0;
                            }
                            a += o, e = !0;
                        }
                        ++o;
                    }
                    if (t && t.length && (l = {
                        ["@media " + t.join(", ")]: l
                    }), !e) continue e;
                }
            }
        }
        (i[a] = i[a] || []).push([
            n ? "cv" : `${e}-${o[e]}`,
            l,
            c
        ]);
    }
    return i;
}, $067c346c53a4452d$var$A = {}, $067c346c53a4452d$var$N = $067c346c53a4452d$var$o(), $067c346c53a4452d$var$D = (e, t)=>$067c346c53a4452d$var$N(e, ()=>(...r)=>{
            const n = ()=>{
                for (let n of r){
                    n = "object" == typeof n && n || {};
                    let r = $067c346c53a4452d$var$z(n);
                    if (!t.rules.global.cache.has(r)) {
                        if (t.rules.global.cache.add(r), "@import" in n) {
                            let e = [].indexOf.call(t.sheet.cssRules, t.rules.themed.group) - 1;
                            for (let r of [].concat(n["@import"]))r = r.includes('"') || r.includes("'") ? r : `"${r}"`, t.sheet.insertRule(`@import ${r};`, e++);
                            delete n["@import"];
                        }
                        $067c346c53a4452d$var$$(n, [], [], e, (e)=>{
                            t.rules.global.apply(e);
                        });
                    }
                }
                return "";
            };
            return $067c346c53a4452d$var$s(n, {
                toString: n
            });
        }), $067c346c53a4452d$var$H = $067c346c53a4452d$var$o(), $067c346c53a4452d$var$V = (e, t)=>$067c346c53a4452d$var$H(e, ()=>(r)=>{
            const n = `${$067c346c53a4452d$var$S(e.prefix)}k-${$067c346c53a4452d$var$z(r)}`, i = ()=>{
                if (!t.rules.global.cache.has(n)) {
                    t.rules.global.cache.add(n);
                    const i = [];
                    $067c346c53a4452d$var$$(r, [], [], e, (e)=>i.push(e));
                    const o = `@keyframes ${n}{${i.join("")}}`;
                    t.rules.global.apply(o);
                }
                return n;
            };
            return $067c346c53a4452d$var$s(i, {
                get name () {
                    return i();
                },
                toString: i
            });
        }), $067c346c53a4452d$var$G = class {
    constructor(e, t, r, n){
        this.token = null == e ? "" : String(e), this.value = null == t ? "" : String(t), this.scale = null == r ? "" : String(r), this.prefix = null == n ? "" : String(n);
    }
    get computedValue() {
        return "var(" + this.variable + ")";
    }
    get variable() {
        return "--" + $067c346c53a4452d$var$S(this.prefix) + $067c346c53a4452d$var$S(this.scale) + this.token;
    }
    toString() {
        return this.computedValue;
    }
}, $067c346c53a4452d$var$F = $067c346c53a4452d$var$o(), $067c346c53a4452d$var$J = (e, t)=>$067c346c53a4452d$var$F(e, ()=>(r, n)=>{
            n = "object" == typeof r && r || Object(n);
            const i = `.${r = (r = "string" == typeof r ? r : "") || `${$067c346c53a4452d$var$S(e.prefix)}t-${$067c346c53a4452d$var$z(n)}`}`, o = {}, l = [];
            for(const t in n){
                o[t] = {};
                for(const r in n[t]){
                    const i = `--${$067c346c53a4452d$var$S(e.prefix)}${t}-${r}`, s = $067c346c53a4452d$var$k(String(n[t][r]), e.prefix, t);
                    o[t][r] = new $067c346c53a4452d$var$G(r, s, t, e.prefix), l.push(`${i}:${s}`);
                }
            }
            const s = ()=>{
                if (l.length && !t.rules.themed.cache.has(r)) {
                    t.rules.themed.cache.add(r);
                    const i = `${n === e.theme ? ":root," : ""}.${r}{${l.join(";")}}`;
                    t.rules.themed.apply(i);
                }
                return r;
            };
            return {
                ...o,
                get className () {
                    return s();
                },
                selector: i,
                toString: s
            };
        }), $067c346c53a4452d$var$U = $067c346c53a4452d$var$o();
var $067c346c53a4452d$var$X, $067c346c53a4452d$var$Y = $067c346c53a4452d$var$o(), $067c346c53a4452d$export$3c6706659c99b84e = (e)=>{
    const t = ((e)=>{
        let t = !1;
        const r = $067c346c53a4452d$var$U(e, (e)=>{
            t = !0;
            const r = "prefix" in (e = "object" == typeof e && e || {}) ? String(e.prefix) : "", i = "object" == typeof e.media && e.media || {}, o = "object" == typeof e.root ? e.root || null : globalThis.document || null, l = "object" == typeof e.theme && e.theme || {}, s = {
                prefix: r,
                media: i,
                theme: l,
                themeMap: "object" == typeof e.themeMap && e.themeMap || {
                    ...$067c346c53a4452d$export$22deaee80f3d7c38
                },
                utils: "object" == typeof e.utils && e.utils || {}
            }, a = $067c346c53a4452d$var$E(o), c = {
                css: $067c346c53a4452d$var$M(s, a),
                globalCss: $067c346c53a4452d$var$D(s, a),
                keyframes: $067c346c53a4452d$var$V(s, a),
                createTheme: $067c346c53a4452d$var$J(s, a),
                reset () {
                    a.reset(), c.theme.toString();
                },
                theme: {},
                sheet: a,
                config: s,
                prefix: r,
                getCssText: a.toString,
                toString: a.toString
            };
            return String(c.theme = c.createTheme(l)), c;
        });
        return t || r.reset(), r;
    })(e);
    return t.styled = (({ config: e, sheet: t })=>$067c346c53a4452d$var$Y(e, ()=>{
            const r = $067c346c53a4452d$var$M(e, t);
            return (...e)=>{
                const t = r(...e), n = t[$067c346c53a4452d$var$l].type, i = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).forwardRef((e, r)=>{
                    const i = e && e.as || n, { props: o, deferredInjector: l } = t(e);
                    return delete o.as, o.ref = r, l ? (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).Fragment, null, (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement(i, o), (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement(l, null)) : (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement(i, o);
                });
                return i.className = t.className, i.displayName = `Styled.${n.displayName || n.name || n}`, i.selector = t.selector, i.toString = ()=>t.selector, i[$067c346c53a4452d$var$l] = t[$067c346c53a4452d$var$l], i;
            };
        }))(t), t;
}, $067c346c53a4452d$var$K = ()=>$067c346c53a4452d$var$X || ($067c346c53a4452d$var$X = $067c346c53a4452d$export$3c6706659c99b84e()), $067c346c53a4452d$export$25d302a5b900a763 = (...e)=>$067c346c53a4452d$var$K().createTheme(...e), $067c346c53a4452d$export$db53682eef82cc11 = (...e)=>$067c346c53a4452d$var$K().globalCss(...e), $067c346c53a4452d$export$d25ddfdf17c3ad3e = (...e)=>$067c346c53a4452d$var$K().keyframes(...e), $067c346c53a4452d$export$dbf350e5966cf602 = (...e)=>$067c346c53a4452d$var$K().css(...e), $067c346c53a4452d$export$3817b7a54a07cec7 = (...e)=>$067c346c53a4452d$var$K().styled(...e);
 //# sourceMappingUrl=index.map


// TSDX + stiches doesn't work with import statement and has a bug.
// Solution: (https://github.com/stitchesjs/stitches/issues/833#issuecomment-950707025)
var $1d5571bdb4f0e237$var$createStitches = $067c346c53a4452d$export$3c6706659c99b84e;
/* ----------------------- Values ----------------------- */ var $1d5571bdb4f0e237$var$theme = {
    colors: {
        primary: "#5FA425",
        primary100: "#9FC87C",
        primary200: "#8FBF66",
        primary300: "#7FB651",
        primary400: "#6FAD3B",
        primary500: "#5FA425",
        primary600: "#4C831E",
        primary700: "#396216",
        primary800: "#26420F",
        primary900: "#132107",
        surface: "#fff",
        neutral100: "#f3f3f3",
        neutral200: "#FAFAFA",
        neutral300: "#EAEAEA",
        neutral400: "#999999",
        neutral500: "#888888",
        neutral600: "#666666",
        neutral700: "#444444",
        neutral800: "#333333",
        neutral900: "#111111",
        background: "#fff",
        foreground: "#000",
        success: "#0070F3",
        success100: "#D3E5FF",
        success300: "#3291FF",
        success500: "#0070F3",
        success700: "#0761D1",
        warning: "#F5A623",
        warning100: "#FFEFCF",
        warning300: "#F7B955",
        warning500: "#F5A623",
        warning700: "#AB570A",
        error: "#FF0000",
        error100: "#F7D4D6",
        error300: "#FF3333",
        error500: "#FF0000",
        error700: "#E60000",
        // Only use this color when you are going to use white for both dark and light theme.
        white: "#fff"
    },
    space: {
        2: "2px",
        4: "4px",
        6: "6px",
        8: "8px",
        10: "10px",
        12: "12px",
        16: "16px",
        20: "20px",
        24: "24px",
        28: "28px",
        30: "30px",
        32: "32px"
    },
    fontSizes: {
        10: "10px",
        12: "12px",
        14: "14px",
        16: "16px",
        18: "18px",
        20: "20px",
        24: "24px",
        32: "32px",
        36: "36px",
        40: "40px",
        48: "48px"
    },
    fonts: {},
    fontWeights: {
        400: "400",
        500: "500",
        600: "600",
        700: "700"
    },
    lineHeights: {},
    letterSpacings: {},
    sizes: {
        4: "4px",
        6: "6px",
        8: "8px",
        12: "12px",
        16: "16px",
        20: "20px",
        24: "24px",
        28: "28px",
        32: "32px",
        36: "36px",
        40: "40px",
        48: "48px"
    },
    borderWidths: {},
    borderStyles: {},
    radii: {
        5: "8px",
        10: "12px"
    },
    shadows: {
        s: "0px 3px 5px 3px #f0f2f5, 0px 6px 10px 3px #f0f2f5, 0px 1px 18px 3px #f0f2f5"
    },
    zIndices: {},
    transitions: {}
};
var $1d5571bdb4f0e237$var$media = {
    sm: "(min-width: 640px)",
    md: "(min-width: 768px)",
    lg: "(min-width: 1024px)"
};
var $1d5571bdb4f0e237$var$utils = {
    bc: function bc(value) {
        return {
            backgroundColor: value
        };
    }
};
/* ----------------------- End of Values ----------------------- */ var $1d5571bdb4f0e237$var$typedCreateStiches = $1d5571bdb4f0e237$var$createStitches;
// Note: it seems there is a bug on tsdx and when it compiles the code, it goes through an error
// We can directly check it with `tsc` to see if the error is correct or not.
// We `ignore` it for now, to get safety check on VSCode.
// @ts-ignore
var $1d5571bdb4f0e237$var$_typedCreateStiches = /*#__PURE__*/ $1d5571bdb4f0e237$var$typedCreateStiches({
    media: $1d5571bdb4f0e237$var$media,
    theme: $1d5571bdb4f0e237$var$theme,
    utils: $1d5571bdb4f0e237$var$utils
}), $1d5571bdb4f0e237$export$3817b7a54a07cec7 = $1d5571bdb4f0e237$var$_typedCreateStiches.styled, $1d5571bdb4f0e237$export$dbf350e5966cf602 = $1d5571bdb4f0e237$var$_typedCreateStiches.css, $1d5571bdb4f0e237$export$25d302a5b900a763 = $1d5571bdb4f0e237$var$_typedCreateStiches.createTheme, $1d5571bdb4f0e237$export$d25ddfdf17c3ad3e = $1d5571bdb4f0e237$var$_typedCreateStiches.keyframes, $1d5571bdb4f0e237$export$db53682eef82cc11 = $1d5571bdb4f0e237$var$_typedCreateStiches.globalCss;
var $1d5571bdb4f0e237$export$f30cb9bc4f736419 = /*#__PURE__*/ $1d5571bdb4f0e237$export$25d302a5b900a763({});
var $1d5571bdb4f0e237$export$3e936a8db52a10a0 = /*#__PURE__*/ $1d5571bdb4f0e237$export$25d302a5b900a763({
    colors: {
        surface: "#000",
        neutral900: "#f3f3f3",
        neutral800: "#FAFAFA",
        neutral700: "#EAEAEA",
        neutral600: "#999999",
        neutral500: "#888888",
        neutral400: "#666666",
        neutral300: "#444444",
        neutral200: "#333333",
        neutral100: "#111111",
        foreground: "#fff",
        background: "#000"
    },
    shadows: {
        s: "0px 3px 5px 3px #222, 0px 6px 10px 3px #222, 0px 1px 18px 3px #222"
    }
});
var $1d5571bdb4f0e237$var$_black, $1d5571bdb4f0e237$var$_white, $1d5571bdb4f0e237$var$_black2, $1d5571bdb4f0e237$var$_white2;
var $1d5571bdb4f0e237$var$SvgWithStrokeColor = /*#__PURE__*/ $1d5571bdb4f0e237$export$3817b7a54a07cec7("svg", {
    stroke: "$foreground",
    variants: {
        color: {
            primary: {
                stroke: "$primary"
            },
            error: {
                stroke: "$error"
            },
            warning: {
                stroke: "$warning"
            },
            success: {
                stroke: "$success"
            },
            black: ($1d5571bdb4f0e237$var$_black = {
                $$color: "$colors$foreground"
            }, $1d5571bdb4f0e237$var$_black["." + $1d5571bdb4f0e237$export$3e936a8db52a10a0 + " &"] = {
                $$color: "$colors$background"
            }, $1d5571bdb4f0e237$var$_black.stroke = "$$color", $1d5571bdb4f0e237$var$_black),
            white: ($1d5571bdb4f0e237$var$_white = {
                $$color: "$colors$background"
            }, $1d5571bdb4f0e237$var$_white["." + $1d5571bdb4f0e237$export$3e936a8db52a10a0 + " &"] = {
                $$color: "$colors$foreground"
            }, $1d5571bdb4f0e237$var$_white.stroke = "$$color", $1d5571bdb4f0e237$var$_white)
        },
        disabled: {
            "true": {
                stroke: "$neutral400"
            }
        }
    }
});
var $1d5571bdb4f0e237$var$SvgWithFillColor = /*#__PURE__*/ $1d5571bdb4f0e237$export$3817b7a54a07cec7("svg", {
    fill: "$foreground",
    variants: {
        color: {
            primary: {
                fill: "$primary"
            },
            error: {
                fill: "$error"
            },
            warning: {
                fill: "$warning"
            },
            success: {
                fill: "$success"
            },
            black: ($1d5571bdb4f0e237$var$_black2 = {
                $$color: "$colors$foreground"
            }, $1d5571bdb4f0e237$var$_black2["." + $1d5571bdb4f0e237$export$3e936a8db52a10a0 + " &"] = {
                $$color: "$colors$background"
            }, $1d5571bdb4f0e237$var$_black2.fill = "$$color", $1d5571bdb4f0e237$var$_black2),
            white: ($1d5571bdb4f0e237$var$_white2 = {
                $$color: "$colors$background"
            }, $1d5571bdb4f0e237$var$_white2["." + $1d5571bdb4f0e237$export$3e936a8db52a10a0 + " &"] = {
                $$color: "$colors$foreground"
            }, $1d5571bdb4f0e237$var$_white2.fill = "$$color", $1d5571bdb4f0e237$var$_white2)
        },
        disabled: {
            "true": {
                stroke: "$neutral400"
            }
        }
    }
});
var $1d5571bdb4f0e237$var$_excluded = [
    "size",
    "color"
];
var $1d5571bdb4f0e237$export$e9c58c24610a624c = function DeleteCircleIcon(_ref) {
    var _ref$size = _ref.size, size = _ref$size === void 0 ? 16 : _ref$size, color = _ref.color, props = $1d5571bdb4f0e237$var$_objectWithoutPropertiesLoose(_ref, $1d5571bdb4f0e237$var$_excluded);
    return (0, $bh6RR.createElement)($1d5571bdb4f0e237$var$SvgWithStrokeColor, Object.assign({
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        color: color,
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        className: "_icon"
    }, props), (0, $bh6RR.createElement)("path", {
        d: "M12 22c5.5 0 10-4.5 10-10S17.5 2 12 2 2 6.5 2 12s4.5 10 10 10ZM9.17 14.83l5.66-5.66M14.83 14.83 9.17 9.17",
        strokeWidth: 1.5,
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }));
};
$1d5571bdb4f0e237$export$e9c58c24610a624c.toString = function() {
    return "._icon";
};
var $1d5571bdb4f0e237$var$_excluded$1 = [
    "size",
    "color"
];
var $1d5571bdb4f0e237$export$601a425ffe8f061a = function CheckSquareIcon(_ref) {
    var _ref$size = _ref.size, size = _ref$size === void 0 ? 16 : _ref$size, color = _ref.color, props = $1d5571bdb4f0e237$var$_objectWithoutPropertiesLoose(_ref, $1d5571bdb4f0e237$var$_excluded$1);
    return (0, $bh6RR.createElement)($1d5571bdb4f0e237$var$SvgWithStrokeColor, Object.assign({
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        color: color,
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        className: "_icon"
    }, props), (0, $bh6RR.createElement)("path", {
        d: "M9 22h6c5 0 7-2 7-7V9c0-5-2-7-7-7H9C4 2 2 4 2 9v6c0 5 2 7 7 7Z",
        strokeWidth: 1.5,
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }), (0, $bh6RR.createElement)("path", {
        d: "m7.75 12 2.83 2.83 5.67-5.66",
        strokeWidth: 1.5,
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }));
};
$1d5571bdb4f0e237$export$601a425ffe8f061a.toString = function() {
    return "._icon";
};
var $1d5571bdb4f0e237$var$_excluded$2 = [
    "size",
    "color"
];
var $1d5571bdb4f0e237$export$a6b7c34d56975de0 = function AddIcon(_ref) {
    var _ref$size = _ref.size, size = _ref$size === void 0 ? 16 : _ref$size, color = _ref.color, props = $1d5571bdb4f0e237$var$_objectWithoutPropertiesLoose(_ref, $1d5571bdb4f0e237$var$_excluded$2);
    return (0, $bh6RR.createElement)($1d5571bdb4f0e237$var$SvgWithStrokeColor, Object.assign({
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        color: color,
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        className: "_icon"
    }, props), (0, $bh6RR.createElement)("path", {
        d: "M6 12h12M12 18V6",
        strokeWidth: 1.5,
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }));
};
$1d5571bdb4f0e237$export$a6b7c34d56975de0.toString = function() {
    return "._icon";
};
var $1d5571bdb4f0e237$var$_excluded$3 = [
    "size",
    "color"
];
var $1d5571bdb4f0e237$export$235e99e4cce237dc = function InfoCircleIcon(_ref) {
    var _ref$size = _ref.size, size = _ref$size === void 0 ? 16 : _ref$size, color = _ref.color, props = $1d5571bdb4f0e237$var$_objectWithoutPropertiesLoose(_ref, $1d5571bdb4f0e237$var$_excluded$3);
    return (0, $bh6RR.createElement)($1d5571bdb4f0e237$var$SvgWithFillColor, Object.assign({
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        color: color,
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        className: "_icon"
    }, props), (0, $bh6RR.createElement)("path", {
        d: "M12 22c5.5 0 10-4.5 10-10S17.5 2 12 2 2 6.5 2 12s4.5 10 10 10ZM12 8v5",
        strokeWidth: 2,
        strokeLinecap: "round",
        strokeLinejoin: "round",
        stroke: "#fff"
    }), (0, $bh6RR.createElement)("path", {
        d: "M11.994 16h.01",
        strokeWidth: 2,
        strokeLinecap: "round",
        strokeLinejoin: "round",
        stroke: "#fff"
    }));
};
$1d5571bdb4f0e237$export$235e99e4cce237dc.toString = function() {
    return "._icon";
};
var $1d5571bdb4f0e237$var$_excluded$4 = [
    "size",
    "color"
];
var $1d5571bdb4f0e237$export$fc799f03c173abf1 = function AddCircleIcon(_ref) {
    var _ref$size = _ref.size, size = _ref$size === void 0 ? 16 : _ref$size, color = _ref.color, props = $1d5571bdb4f0e237$var$_objectWithoutPropertiesLoose(_ref, $1d5571bdb4f0e237$var$_excluded$4);
    return (0, $bh6RR.createElement)($1d5571bdb4f0e237$var$SvgWithStrokeColor, Object.assign({
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        color: color,
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        className: "_icon"
    }, props), (0, $bh6RR.createElement)("path", {
        d: "M12 22c5.5 0 10-4.5 10-10S17.5 2 12 2 2 6.5 2 12s4.5 10 10 10ZM8 12h8M12 16V8",
        strokeWidth: 1.5,
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }));
};
$1d5571bdb4f0e237$export$fc799f03c173abf1.toString = function() {
    return "._icon";
};
var $1d5571bdb4f0e237$var$_excluded$5 = [
    "size",
    "color"
];
var $1d5571bdb4f0e237$export$270e2e3af79d1405 = function MinusCircleIcon(_ref) {
    var _ref$size = _ref.size, size = _ref$size === void 0 ? 16 : _ref$size, color = _ref.color, props = $1d5571bdb4f0e237$var$_objectWithoutPropertiesLoose(_ref, $1d5571bdb4f0e237$var$_excluded$5);
    return (0, $bh6RR.createElement)($1d5571bdb4f0e237$var$SvgWithStrokeColor, Object.assign({
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        color: color,
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        className: "_icon"
    }, props), (0, $bh6RR.createElement)("path", {
        d: "M11.92 22c5.5 0 10-4.5 10-10s-4.5-10-10-10-10 4.5-10 10 4.5 10 10 10ZM7.92 12h8",
        strokeWidth: 1.5,
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }));
};
$1d5571bdb4f0e237$export$270e2e3af79d1405.toString = function() {
    return "._icon";
};
var $1d5571bdb4f0e237$var$_excluded$6 = [
    "size",
    "color"
];
var $1d5571bdb4f0e237$export$f6dd727656c97851 = function CheckCircleIcon(_ref) {
    var _ref$size = _ref.size, size = _ref$size === void 0 ? 16 : _ref$size, color = _ref.color, props = $1d5571bdb4f0e237$var$_objectWithoutPropertiesLoose(_ref, $1d5571bdb4f0e237$var$_excluded$6);
    return (0, $bh6RR.createElement)($1d5571bdb4f0e237$var$SvgWithFillColor, Object.assign({
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        color: color,
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        className: "_icon"
    }, props), (0, $bh6RR.createElement)("path", {
        d: "M12 22c5.5 0 10-4.5 10-10S17.5 2 12 2 2 6.5 2 12s4.5 10 10 10Z",
        strokeWidth: 1.5,
        strokeLinecap: "round",
        strokeLinejoin: "round",
        stroke: "#fff"
    }), (0, $bh6RR.createElement)("path", {
        d: "m7.75 12 2.83 2.83 5.67-5.66",
        strokeWidth: 1.5,
        strokeLinecap: "round",
        strokeLinejoin: "round",
        stroke: "#fff"
    }));
};
$1d5571bdb4f0e237$export$f6dd727656c97851.toString = function() {
    return "._icon";
};
var $1d5571bdb4f0e237$var$_excluded$7 = [
    "size",
    "color"
];
var $1d5571bdb4f0e237$export$7dd004358974b05d = function CheckIcon(_ref) {
    var _ref$size = _ref.size, size = _ref$size === void 0 ? 16 : _ref$size, color = _ref.color, props = $1d5571bdb4f0e237$var$_objectWithoutPropertiesLoose(_ref, $1d5571bdb4f0e237$var$_excluded$7);
    return (0, $bh6RR.createElement)($1d5571bdb4f0e237$var$SvgWithFillColor, Object.assign({
        width: size,
        height: size,
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        color: color,
        className: "_icon"
    }, props), (0, $bh6RR.createElement)("path", {
        d: "M11.4669 3.72684C11.7558 3.91574 11.8369 4.30308 11.648 4.59198L7.39799 11.092C7.29783 11.2452 7.13556 11.3467 6.95402 11.3699C6.77247 11.3931 6.58989 11.3355 6.45446 11.2124L3.70446 8.71241C3.44905 8.48022 3.43023 8.08494 3.66242 7.82953C3.89461 7.57412 4.28989 7.55529 4.5453 7.78749L6.75292 9.79441L10.6018 3.90792C10.7907 3.61902 11.178 3.53795 11.4669 3.72684Z",
        fillRule: "evenodd",
        clipRule: "evenodd"
    }));
};
$1d5571bdb4f0e237$export$7dd004358974b05d.toString = function() {
    return "._icon";
};
var $1d5571bdb4f0e237$var$_excluded$8 = [
    "size",
    "color"
];
var $1d5571bdb4f0e237$export$79e71d77d4eb0b38 = function BanIcon(_ref) {
    var _ref$size = _ref.size, size = _ref$size === void 0 ? 16 : _ref$size, color = _ref.color, props = $1d5571bdb4f0e237$var$_objectWithoutPropertiesLoose(_ref, $1d5571bdb4f0e237$var$_excluded$8);
    return (0, $bh6RR.createElement)($1d5571bdb4f0e237$var$SvgWithStrokeColor, Object.assign({
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        color: color,
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        className: "_icon"
    }, props), (0, $bh6RR.createElement)("path", {
        d: "M12 22c5.52 0 10-4.48 10-10S17.52 2 12 2 2 6.48 2 12s4.48 10 10 10ZM18.9 5l-14 14",
        strokeWidth: 1.5,
        strokeMiterlimit: 10,
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }));
};
$1d5571bdb4f0e237$export$79e71d77d4eb0b38.toString = function() {
    return "._icon";
};
var $1d5571bdb4f0e237$var$_excluded$9 = [
    "size",
    "color"
];
var $1d5571bdb4f0e237$export$f7dc499a72baa103 = function WarningIcon(_ref) {
    var _ref$size = _ref.size, size = _ref$size === void 0 ? 16 : _ref$size, color = _ref.color, props = $1d5571bdb4f0e237$var$_objectWithoutPropertiesLoose(_ref, $1d5571bdb4f0e237$var$_excluded$9);
    return (0, $bh6RR.createElement)($1d5571bdb4f0e237$var$SvgWithStrokeColor, Object.assign({
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        color: color,
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        className: "_icon"
    }, props), (0, $bh6RR.createElement)("path", {
        d: "M12 9v5M12 21.41H5.94c-3.47 0-4.92-2.48-3.24-5.51l3.12-5.62L8.76 5c1.78-3.21 4.7-3.21 6.48 0l2.94 5.29 3.12 5.62c1.68 3.03.22 5.51-3.24 5.51H12v-.01Z",
        strokeWidth: 1.5,
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }), (0, $bh6RR.createElement)("path", {
        d: "M11.994 17h.01",
        strokeWidth: 2,
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }));
};
$1d5571bdb4f0e237$export$f7dc499a72baa103.toString = function() {
    return "._icon";
};
var $1d5571bdb4f0e237$var$_excluded$a = [
    "size",
    "color"
];
var $1d5571bdb4f0e237$export$8d345d913bfb227 = function HistoryIcon(_ref) {
    var _ref$size = _ref.size, size = _ref$size === void 0 ? 16 : _ref$size, color = _ref.color, props = $1d5571bdb4f0e237$var$_objectWithoutPropertiesLoose(_ref, $1d5571bdb4f0e237$var$_excluded$a);
    return (0, $bh6RR.createElement)($1d5571bdb4f0e237$var$SvgWithStrokeColor, Object.assign({
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        color: color,
        fill: "none",
        stroke: "currentColor",
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        xmlns: "http://www.w3.org/2000/svg",
        className: "_icon"
    }, props), (0, $bh6RR.createElement)("path", {
        d: "M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"
    }), (0, $bh6RR.createElement)("polyline", {
        points: "14 2 14 8 20 8"
    }), (0, $bh6RR.createElement)("line", {
        x1: "16",
        y1: "13",
        x2: "8",
        y2: "13"
    }), (0, $bh6RR.createElement)("line", {
        x1: "16",
        y1: "17",
        x2: "8",
        y2: "17"
    }), (0, $bh6RR.createElement)("polyline", {
        points: "10 9 9 9 8 9"
    }));
};
$1d5571bdb4f0e237$export$8d345d913bfb227.toString = function() {
    return "._icon";
};
var $1d5571bdb4f0e237$var$_excluded$b = [
    "size",
    "color"
];
var $1d5571bdb4f0e237$export$dc5067efa4cb656a = function GasIcon(_ref) {
    var _ref$size = _ref.size, size = _ref$size === void 0 ? 16 : _ref$size, color = _ref.color, props = $1d5571bdb4f0e237$var$_objectWithoutPropertiesLoose(_ref, $1d5571bdb4f0e237$var$_excluded$b);
    return (0, $bh6RR.createElement)($1d5571bdb4f0e237$var$SvgWithStrokeColor, Object.assign({
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        color: color,
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        className: "_icon"
    }, props), (0, $bh6RR.createElement)("path", {
        d: "M4 22V5c0-2 1.34-3 3-3h8c1.66 0 3 1 3 3v17H4ZM2.5 22h17",
        strokeWidth: 1.5,
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }), (0, $bh6RR.createElement)("path", {
        d: "M8.89 10h4.23c1.04 0 1.89-.5 1.89-1.89V6.88c0-1.39-.85-1.89-1.89-1.89H8.89C7.85 4.99 7 5.49 7 6.88v1.23C7 9.5 7.85 10 8.89 10ZM7 13h3M18 16.01l4.5-.01v-6l-2-1",
        strokeWidth: 1.5,
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }));
};
$1d5571bdb4f0e237$export$dc5067efa4cb656a.toString = function() {
    return "._icon";
};
var $1d5571bdb4f0e237$var$_excluded$c = [
    "size",
    "color"
];
var $1d5571bdb4f0e237$export$ac4e8b8ca2b79f39 = function SettingsIcon(_ref) {
    var _ref$size = _ref.size, size = _ref$size === void 0 ? 16 : _ref$size, color = _ref.color, props = $1d5571bdb4f0e237$var$_objectWithoutPropertiesLoose(_ref, $1d5571bdb4f0e237$var$_excluded$c);
    return (0, $bh6RR.createElement)($1d5571bdb4f0e237$var$SvgWithStrokeColor, Object.assign({
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        color: color,
        stroke: "currentColor",
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        className: "_icon"
    }, props), (0, $bh6RR.createElement)("circle", {
        cx: "12",
        cy: "12",
        r: "3"
    }), (0, $bh6RR.createElement)("path", {
        d: "M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1 0 2.83 2 2 0 0 1-2.83 0l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-2 2 2 2 0 0 1-2-2v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83 0 2 2 0 0 1 0-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1-2-2 2 2 0 0 1 2-2h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 0-2.83 2 2 0 0 1 2.83 0l.06.06a1.65 1.65 0 0 0 1.82.33H9a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 2-2 2 2 0 0 1 2 2v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 0 2 2 0 0 1 0 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 2 2 2 2 0 0 1-2 2h-.09a1.65 1.65 0 0 0-1.51 1z"
    }));
};
$1d5571bdb4f0e237$export$ac4e8b8ca2b79f39.toString = function() {
    return "._icon";
};
var $1d5571bdb4f0e237$var$_excluded$d = [
    "size",
    "color"
];
var $1d5571bdb4f0e237$export$d23329de703dffc4 = function TrashIcon(_ref) {
    var _ref$size = _ref.size, size = _ref$size === void 0 ? 16 : _ref$size, color = _ref.color, props = $1d5571bdb4f0e237$var$_objectWithoutPropertiesLoose(_ref, $1d5571bdb4f0e237$var$_excluded$d);
    return (0, $bh6RR.createElement)($1d5571bdb4f0e237$var$SvgWithStrokeColor, Object.assign({
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        color: color,
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        className: "_icon"
    }, props), (0, $bh6RR.createElement)("path", {
        d: "M21.5 5.98c-3.33-.33-6.68-.5-10.02-.5-1.98 0-3.96.1-5.94.3l-2.04.2M9 4.97l.22-1.31C9.38 2.71 9.5 2 11.19 2h2.62c1.69 0 1.82.75 1.97 1.67l.22 1.3M19.35 9.14l-.65 10.07c-.11 1.57-.2 2.79-2.99 2.79H9.29c-2.79 0-2.88-1.22-2.99-2.79L5.65 9.14M10.83 16.5h3.33M10 12.5h5",
        strokeWidth: 1.5,
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }));
};
$1d5571bdb4f0e237$export$d23329de703dffc4.toString = function() {
    return "._icon";
};
var $1d5571bdb4f0e237$var$_excluded$e = [
    "size",
    "color"
];
var $1d5571bdb4f0e237$export$d0a4efdbfc6d0a33 = function SearchMinusIcon(_ref) {
    var _ref$size = _ref.size, size = _ref$size === void 0 ? 16 : _ref$size, color = _ref.color, props = $1d5571bdb4f0e237$var$_objectWithoutPropertiesLoose(_ref, $1d5571bdb4f0e237$var$_excluded$e);
    return (0, $bh6RR.createElement)($1d5571bdb4f0e237$var$SvgWithStrokeColor, Object.assign({
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        color: color,
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        className: "_icon"
    }, props), (0, $bh6RR.createElement)("path", {
        d: "M9 11.7h5M11.5 21a9.5 9.5 0 1 0 0-19 9.5 9.5 0 0 0 0 19ZM22 22l-2-2",
        strokeWidth: 1.5,
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }));
};
$1d5571bdb4f0e237$export$d0a4efdbfc6d0a33.toString = function() {
    return "._icon";
};
var $1d5571bdb4f0e237$var$_excluded$f = [
    "size",
    "color"
];
var $1d5571bdb4f0e237$export$82eafebb825fc23f = function SearchIcon(_ref) {
    var _ref$size = _ref.size, size = _ref$size === void 0 ? 16 : _ref$size, color = _ref.color, props = $1d5571bdb4f0e237$var$_objectWithoutPropertiesLoose(_ref, $1d5571bdb4f0e237$var$_excluded$f);
    return (0, $bh6RR.createElement)($1d5571bdb4f0e237$var$SvgWithStrokeColor, Object.assign({
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        color: color,
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        className: "_icon"
    }, props), (0, $bh6RR.createElement)("path", {
        d: "M11.5 21a9.5 9.5 0 1 0 0-19 9.5 9.5 0 0 0 0 19ZM22 22l-2-2",
        strokeWidth: 1.5,
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }));
};
$1d5571bdb4f0e237$export$82eafebb825fc23f.toString = function() {
    return "._icon";
};
var $1d5571bdb4f0e237$var$_excluded$g = [
    "size",
    "color"
];
var $1d5571bdb4f0e237$export$f5db305c33b6241b = function AngleRightIcon(_ref) {
    var _ref$size = _ref.size, size = _ref$size === void 0 ? 16 : _ref$size, color = _ref.color, props = $1d5571bdb4f0e237$var$_objectWithoutPropertiesLoose(_ref, $1d5571bdb4f0e237$var$_excluded$g);
    return (0, $bh6RR.createElement)($1d5571bdb4f0e237$var$SvgWithStrokeColor, Object.assign({
        width: size,
        height: size,
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        color: color,
        className: "_icon"
    }, props), (0, $bh6RR.createElement)("path", {
        d: "m8.91 19.92 6.52-6.52c.77-.77.77-2.03 0-2.8L8.91 4.08",
        strokeWidth: 1.5,
        strokeMiterlimit: 10,
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }));
};
$1d5571bdb4f0e237$export$f5db305c33b6241b.toString = function() {
    return "._icon";
};
var $1d5571bdb4f0e237$var$_excluded$h = [
    "size",
    "color"
];
var $1d5571bdb4f0e237$export$60014705184d48db = function AngleUpIcon(_ref) {
    var _ref$size = _ref.size, size = _ref$size === void 0 ? 16 : _ref$size, color = _ref.color, props = $1d5571bdb4f0e237$var$_objectWithoutPropertiesLoose(_ref, $1d5571bdb4f0e237$var$_excluded$h);
    return (0, $bh6RR.createElement)($1d5571bdb4f0e237$var$SvgWithStrokeColor, Object.assign({
        width: size,
        height: size,
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        color: color,
        className: "_icon"
    }, props), (0, $bh6RR.createElement)("path", {
        d: "M19.92 15.05 13.4 8.53c-.77-.77-2.03-.77-2.8 0l-6.52 6.52",
        strokeWidth: 1.5,
        strokeMiterlimit: 10,
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }));
};
$1d5571bdb4f0e237$export$60014705184d48db.toString = function() {
    return "._icon";
};
var $1d5571bdb4f0e237$var$_excluded$i = [
    "size",
    "color"
];
var $1d5571bdb4f0e237$export$e45f9104ca1b1c90 = function AngleDownIcon(_ref) {
    var _ref$size = _ref.size, size = _ref$size === void 0 ? 16 : _ref$size, color = _ref.color, props = $1d5571bdb4f0e237$var$_objectWithoutPropertiesLoose(_ref, $1d5571bdb4f0e237$var$_excluded$i);
    return (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($1d5571bdb4f0e237$var$SvgWithStrokeColor, Object.assign({
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        color: color,
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        className: "_icon"
    }, props), (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("path", {
        d: "m19.92 8.95-6.52 6.52c-.77.77-2.03.77-2.8 0L4.08 8.95",
        strokeWidth: 1.5,
        strokeMiterlimit: 10,
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }));
};
$1d5571bdb4f0e237$export$e45f9104ca1b1c90.toString = function() {
    return "._icon";
};
var $1d5571bdb4f0e237$var$_excluded$j = [
    "size",
    "color"
];
var $1d5571bdb4f0e237$export$3df4a161b319f37a = function AngleLeftIcon(_ref) {
    var _ref$size = _ref.size, size = _ref$size === void 0 ? 16 : _ref$size, color = _ref.color, props = $1d5571bdb4f0e237$var$_objectWithoutPropertiesLoose(_ref, $1d5571bdb4f0e237$var$_excluded$j);
    return (0, $bh6RR.createElement)($1d5571bdb4f0e237$var$SvgWithStrokeColor, Object.assign({
        width: size,
        height: size,
        fill: "none",
        viewBox: "0 0 24 24",
        color: color,
        xmlns: "http://www.w3.org/2000/svg",
        className: "_icon"
    }, props), (0, $bh6RR.createElement)("path", {
        d: "M15 19.92 8.48 13.4c-.77-.77-.77-2.03 0-2.8L15 4.08",
        strokeWidth: 1.5,
        strokeMiterlimit: 10,
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }));
};
$1d5571bdb4f0e237$export$e45f9104ca1b1c90.toString = function() {
    return "._icon";
};
var $1d5571bdb4f0e237$var$_excluded$k = [
    "size",
    "color"
];
var $1d5571bdb4f0e237$export$4e54df4252b4a99c = function DownloadIcon(_ref) {
    var _ref$size = _ref.size, size = _ref$size === void 0 ? 16 : _ref$size, color = _ref.color, props = $1d5571bdb4f0e237$var$_objectWithoutPropertiesLoose(_ref, $1d5571bdb4f0e237$var$_excluded$k);
    return (0, $bh6RR.createElement)($1d5571bdb4f0e237$var$SvgWithStrokeColor, Object.assign({
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        color: color,
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        className: "_icon"
    }, props), (0, $bh6RR.createElement)("path", {
        d: "M16.44 8.9c3.6.31 5.07 2.16 5.07 6.21v.13c0 4.47-1.79 6.26-6.26 6.26H8.74c-4.47 0-6.26-1.79-6.26-6.26v-.13c0-4.02 1.45-5.87 4.99-6.2M12 2v12.88",
        strokeWidth: 1.5,
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }), (0, $bh6RR.createElement)("path", {
        d: "M15.35 12.65 12 16l-3.35-3.35",
        strokeWidth: 1.5,
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }));
};
$1d5571bdb4f0e237$export$4e54df4252b4a99c.toString = function() {
    return "._icon";
};
var $1d5571bdb4f0e237$var$_excluded$l = [
    "color",
    "size"
];
var $1d5571bdb4f0e237$export$b837bd7eac09a33e = /*#__PURE__*/ (0, $bh6RR.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "black" : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? 16 : _ref$size, props = $1d5571bdb4f0e237$var$_objectWithoutPropertiesLoose(_ref, $1d5571bdb4f0e237$var$_excluded$l);
    return (0, $bh6RR.createElement)($1d5571bdb4f0e237$var$SvgWithStrokeColor, Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        color: color,
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: "currentColor",
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        className: "_icon"
    }, props, {
        ref: forwardedRef
    }), (0, $bh6RR.createElement)("polyline", {
        points: "9 18 15 12 9 6"
    }));
});
$1d5571bdb4f0e237$export$b837bd7eac09a33e.toString = function() {
    return "._icon";
};
var $1d5571bdb4f0e237$var$_excluded$m = [
    "size",
    "color"
];
var $1d5571bdb4f0e237$export$9ca09caa9c849d9c = function ArrowRightIcon(_ref) {
    var _ref$size = _ref.size, size = _ref$size === void 0 ? 16 : _ref$size, color = _ref.color, props = $1d5571bdb4f0e237$var$_objectWithoutPropertiesLoose(_ref, $1d5571bdb4f0e237$var$_excluded$m);
    return (0, $bh6RR.createElement)($1d5571bdb4f0e237$var$SvgWithStrokeColor, Object.assign({
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        color: color,
        fill: "none",
        stroke: "currentColor",
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        xmlns: "http://www.w3.org/2000/svg",
        className: "_icon"
    }, props), (0, $bh6RR.createElement)("line", {
        x1: "5",
        y1: "12",
        x2: "19",
        y2: "12"
    }), (0, $bh6RR.createElement)("polyline", {
        points: "12 5 19 12 12 19"
    }));
};
$1d5571bdb4f0e237$export$9ca09caa9c849d9c.toString = function() {
    return "._icon";
};
var $1d5571bdb4f0e237$var$_excluded$n = [
    "size",
    "color"
];
var $1d5571bdb4f0e237$export$7c5334ad76dbc077 = function RetryRightIcon(_ref) {
    var _ref$size = _ref.size, size = _ref$size === void 0 ? 16 : _ref$size, color = _ref.color, props = $1d5571bdb4f0e237$var$_objectWithoutPropertiesLoose(_ref, $1d5571bdb4f0e237$var$_excluded$n);
    return (0, $bh6RR.createElement)($1d5571bdb4f0e237$var$SvgWithStrokeColor, Object.assign({
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        color: color,
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        className: "_icon"
    }, props), (0, $bh6RR.createElement)("path", {
        d: "M14.89 5.08c-.87-.26-1.83-.43-2.89-.43-4.79 0-8.67 3.88-8.67 8.67C3.33 18.12 7.21 22 12 22s8.67-3.88 8.67-8.67c0-1.78-.54-3.44-1.46-4.82M16.13 5.32 13.24 2M16.13 5.32l-3.37 2.46",
        strokeWidth: 1.5,
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }));
};
$1d5571bdb4f0e237$export$7c5334ad76dbc077.toString = function() {
    return "._icon";
};
var $1d5571bdb4f0e237$var$_excluded$o = [
    "size",
    "color"
];
var $1d5571bdb4f0e237$export$72bf90e3797479cc = function RetryLeftIcon(_ref) {
    var _ref$size = _ref.size, size = _ref$size === void 0 ? 16 : _ref$size, color = _ref.color, props = $1d5571bdb4f0e237$var$_objectWithoutPropertiesLoose(_ref, $1d5571bdb4f0e237$var$_excluded$o);
    return (0, $bh6RR.createElement)($1d5571bdb4f0e237$var$SvgWithStrokeColor, Object.assign({
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        color: color,
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        className: "_icon"
    }, props), (0, $bh6RR.createElement)("path", {
        d: "M9.11 5.08c.87-.26 1.83-.43 2.89-.43 4.79 0 8.67 3.88 8.67 8.67s-3.88 8.67-8.67 8.67-8.67-3.88-8.67-8.67c0-1.78.54-3.44 1.46-4.82M7.87 5.32 10.76 2M7.87 5.32l3.37 2.46",
        strokeWidth: 1.5,
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }));
};
$1d5571bdb4f0e237$export$72bf90e3797479cc.toString = function() {
    return "._icon";
};
var $1d5571bdb4f0e237$var$_excluded$p = [
    "size",
    "color"
];
var $1d5571bdb4f0e237$export$53f5bab972e932f7 = function TryAgainIcon(_ref) {
    var _ref$size = _ref.size, size = _ref$size === void 0 ? 16 : _ref$size, color = _ref.color, props = $1d5571bdb4f0e237$var$_objectWithoutPropertiesLoose(_ref, $1d5571bdb4f0e237$var$_excluded$p);
    return (0, $bh6RR.createElement)($1d5571bdb4f0e237$var$SvgWithStrokeColor, Object.assign({
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        color: color,
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        className: "_icon"
    }, props), (0, $bh6RR.createElement)("path", {
        d: "M22 12c0 5.52-4.48 10-10 10s-8.89-5.56-8.89-5.56m0 0h4.52m-4.52 0v5M2 12C2 6.48 6.44 2 12 2c6.67 0 10 5.56 10 5.56m0 0v-5m0 5h-4.44",
        strokeWidth: 1.5,
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }));
};
$1d5571bdb4f0e237$export$53f5bab972e932f7.toString = function() {
    return "._icon";
};
var $1d5571bdb4f0e237$var$_excluded$q = [
    "size",
    "color"
];
var $1d5571bdb4f0e237$export$bb0b1c2acef02dfc = function VerticalSwapIcon(_ref) {
    var _ref$size = _ref.size, size = _ref$size === void 0 ? 16 : _ref$size, color = _ref.color, props = $1d5571bdb4f0e237$var$_objectWithoutPropertiesLoose(_ref, $1d5571bdb4f0e237$var$_excluded$q);
    return (0, $bh6RR.createElement)($1d5571bdb4f0e237$var$SvgWithStrokeColor, Object.assign({
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        color: color,
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        className: "_icon"
    }, props), (0, $bh6RR.createElement)("path", {
        d: "m13.82 6.85 3.04 3.04M13.82 17.15V6.85M10.18 17.15l-3.04-3.04M10.18 6.85v10.3",
        strokeWidth: 1.5,
        strokeMiterlimit: 10,
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }), (0, $bh6RR.createElement)("path", {
        d: "M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10Z",
        strokeWidth: 1.5,
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }));
};
$1d5571bdb4f0e237$export$bb0b1c2acef02dfc.toString = function() {
    return "._icon";
};
var $1d5571bdb4f0e237$var$_excluded$r = [
    "size",
    "color"
];
var $1d5571bdb4f0e237$export$b7faa9400bd570d0 = function HorizontalSwapIcon(_ref) {
    var _ref$size = _ref.size, size = _ref$size === void 0 ? 16 : _ref$size, color = _ref.color, props = $1d5571bdb4f0e237$var$_objectWithoutPropertiesLoose(_ref, $1d5571bdb4f0e237$var$_excluded$r);
    return (0, $bh6RR.createElement)($1d5571bdb4f0e237$var$SvgWithStrokeColor, Object.assign({
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        color: color,
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        className: "_icon"
    }, props), (0, $bh6RR.createElement)("path", {
        d: "m17.15 13.82-3.04 3.04M6.85 13.82h10.3M6.85 10.18l3.04-3.04M17.15 10.18H6.85",
        strokeWidth: 1.5,
        strokeMiterlimit: 10,
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }), (0, $bh6RR.createElement)("path", {
        d: "M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10Z",
        strokeWidth: 1.5,
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }));
};
$1d5571bdb4f0e237$export$b7faa9400bd570d0.toString = function() {
    return "._icon";
};
var $1d5571bdb4f0e237$var$_excluded$s = [
    "color",
    "size"
];
var $1d5571bdb4f0e237$export$5d8f347c5096e1c3 = /*#__PURE__*/ (0, $bh6RR.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "black" : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? 16 : _ref$size, props = $1d5571bdb4f0e237$var$_objectWithoutPropertiesLoose(_ref, $1d5571bdb4f0e237$var$_excluded$s);
    return (0, $bh6RR.createElement)($1d5571bdb4f0e237$var$SvgWithStrokeColor, Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        color: color,
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: "currentColor",
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        className: "_icon"
    }, props, {
        ref: forwardedRef
    }), (0, $bh6RR.createElement)("polyline", {
        points: "23 4 23 10 17 10"
    }), (0, $bh6RR.createElement)("path", {
        d: "M20.49 15a9 9 0 1 1-2.12-9.36L23 10"
    }));
});
$1d5571bdb4f0e237$export$5d8f347c5096e1c3.toString = function() {
    return "._icon";
};
var $1d5571bdb4f0e237$var$_excluded$t = [
    "size",
    "color"
];
var $1d5571bdb4f0e237$export$deff84e7338ee5a5 = function WalletIcon(_ref) {
    var _ref$size = _ref.size, size = _ref$size === void 0 ? 16 : _ref$size, color = _ref.color, props = $1d5571bdb4f0e237$var$_objectWithoutPropertiesLoose(_ref, $1d5571bdb4f0e237$var$_excluded$t);
    return (0, $bh6RR.createElement)($1d5571bdb4f0e237$var$SvgWithFillColor, Object.assign({
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        color: color,
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        className: "_icon"
    }, props), (0, $bh6RR.createElement)("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M4.51 7.205a3.018 3.018 0 0 0-3.01 3.01v6.73a3.018 3.018 0 0 0 3.01 3.01h11.48a3.018 3.018 0 0 0 3.01-3.01v-.44h-1.15c-1.41 0-2.778-1.03-2.907-2.553a2.758 2.758 0 0 1 .816-2.227 2.743 2.743 0 0 1 1.971-.82H19v-.69a3.018 3.018 0 0 0-3.01-3.01H4.51ZM0 10.215a4.518 4.518 0 0 1 4.51-4.51h11.48a4.518 4.518 0 0 1 4.51 4.51v1.44a.75.75 0 0 1-.75.75h-2.02c-.36 0-.675.14-.903.373l-.013.014c-.266.26-.415.63-.377 1.022v.009c.053.635.664 1.182 1.413 1.182h1.9a.75.75 0 0 1 .75.75v1.19a4.518 4.518 0 0 1-4.51 4.51H4.51A4.518 4.518 0 0 1 0 16.945v-6.73Z"
    }), (0, $bh6RR.createElement)("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M12.35 2.655a1.15 1.15 0 0 0-1.554-1.079l-7.94 3A2.098 2.098 0 0 0 1.5 6.547v4.569a.75.75 0 1 1-1.5 0v-4.57c0-1.5.922-2.84 2.325-3.371l7.94-3s-.001 0 0 0c1.732-.657 3.585.629 3.585 2.481v3.8a.75.75 0 0 1-1.5 0v-3.8ZM17.729 12.405c-.36 0-.675.14-.903.373l-.013.014c-.266.26-.415.63-.377 1.022v.009c.053.635.664 1.182 1.413 1.182h1.943a.276.276 0 0 0 .267-.27v-2.06a.276.276 0 0 0-.267-.27h-2.063Zm-1.97-.68a2.743 2.743 0 0 1 1.97-.82h2.107a1.777 1.777 0 0 1 1.723 1.77v2.06a1.777 1.777 0 0 1-1.75 1.77h-1.96c-1.41 0-2.778-1.03-2.907-2.553a2.759 2.759 0 0 1 .816-2.227Z"
    }), (0, $bh6RR.createElement)("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M4.5 10.705a.75.75 0 0 1 .75-.75h7a.75.75 0 0 1 0 1.5h-7a.75.75 0 0 1-.75-.75Z"
    }));
};
$1d5571bdb4f0e237$export$deff84e7338ee5a5.toString = function() {
    return "._icon";
};
var $1d5571bdb4f0e237$var$_excluded$u = [
    "size",
    "color"
];
var $1d5571bdb4f0e237$export$f47a1a76a323ff05 = function AddWalletIcon(_ref) {
    var _ref$size = _ref.size, size = _ref$size === void 0 ? 16 : _ref$size, color = _ref.color, props = $1d5571bdb4f0e237$var$_objectWithoutPropertiesLoose(_ref, $1d5571bdb4f0e237$var$_excluded$u);
    return (0, $bh6RR.createElement)($1d5571bdb4f0e237$var$SvgWithFillColor, Object.assign({
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        color: color,
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        className: "_icon"
    }, props), (0, $bh6RR.createElement)("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M6.569 7.205a3.018 3.018 0 0 0-3.01 3.01v3.076a4.749 4.749 0 0 1 6.5 4.414c0 .808-.206 1.579-.574 2.25h8.564a3.018 3.018 0 0 0 3.01-3.01v-.44h-1.15c-1.41 0-2.778-1.03-2.907-2.553a2.758 2.758 0 0 1 .816-2.227 2.743 2.743 0 0 1 1.97-.82h1.27v-.69a3.018 3.018 0 0 0-3.01-3.01H6.569Zm-4.51 3.01a4.518 4.518 0 0 1 4.51-4.51h11.48a4.518 4.518 0 0 1 4.51 4.51v1.44a.75.75 0 0 1-.75.75h-2.02c-.36 0-.675.14-.903.373l-.014.014c-.266.26-.414.63-.377 1.022l.001.009c.053.635.664 1.182 1.413 1.182h1.9a.75.75 0 0 1 .75.75v1.19a4.518 4.518 0 0 1-4.51 4.51H7.939a.75.75 0 0 1-.482-1.324c.243-.204.457-.457.624-.744l.01-.015a3.17 3.17 0 0 0 .468-1.667 3.249 3.249 0 0 0-5.283-2.533.75.75 0 0 1-1.217-.587v-4.37Z"
    }), (0, $bh6RR.createElement)("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M14.409 2.655a1.15 1.15 0 0 0-1.555-1.078l-7.94 3a2.098 2.098 0 0 0-1.355 1.968v4.57a.75.75 0 0 1-1.5 0v-4.57c0-1.5.921-2.84 2.324-3.371l7.94-3c1.733-.657 3.586.629 3.586 2.481v3.8a.75.75 0 0 1-1.5 0v-3.8ZM19.787 12.405c-.359 0-.674.14-.902.374l-.014.013c-.266.26-.414.63-.377 1.022v.01c.054.634.664 1.181 1.413 1.181h1.943a.276.276 0 0 0 .267-.27v-2.06a.276.276 0 0 0-.267-.27h-2.063Zm-1.97-.68a2.743 2.743 0 0 1 1.97-.82h2.107a1.777 1.777 0 0 1 1.723 1.77v2.06a1.777 1.777 0 0 1-1.75 1.77h-1.96c-1.41 0-2.777-1.03-2.907-2.553a2.759 2.759 0 0 1 .817-2.227Z"
    }), (0, $bh6RR.createElement)("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M6.559 10.705a.75.75 0 0 1 .75-.75h7a.75.75 0 0 1 0 1.5h-7a.75.75 0 0 1-.75-.75ZM5.309 14.455c-.762 0-1.469.267-2.033.717h-.001a3.22 3.22 0 0 0-1.216 2.533c0 .61.17 1.184.468 1.667l.006.01a3.22 3.22 0 0 0 2.776 1.573 3.155 3.155 0 0 0 2.148-.824c.243-.204.457-.457.624-.744l.01-.015a3.17 3.17 0 0 0 .468-1.667 3.249 3.249 0 0 0-3.25-3.25Zm-2.967-.457a4.749 4.749 0 0 1 7.717 3.707c0 .888-.248 1.73-.687 2.446-.25.427-.57.808-.941 1.12a4.656 4.656 0 0 1-3.122 1.184 4.72 4.72 0 0 1-4.062-2.301 4.671 4.671 0 0 1-.688-2.449 4.72 4.72 0 0 1 1.783-3.707Z"
    }), (0, $bh6RR.createElement)("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M3.07 17.685a.75.75 0 0 1 .75-.75H6.8a.75.75 0 0 1 0 1.5H3.82a.75.75 0 0 1-.75-.75Z"
    }), (0, $bh6RR.createElement)("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M5.309 15.475a.75.75 0 0 1 .75.75v2.99a.75.75 0 0 1-1.5 0v-2.99a.75.75 0 0 1 .75-.75Z"
    }));
};
$1d5571bdb4f0e237$export$f47a1a76a323ff05.toString = function() {
    return "._icon";
};
var $1d5571bdb4f0e237$var$_excluded$v = [
    "size",
    "color"
];
var $1d5571bdb4f0e237$export$d730393cd53c0e79 = function DeleteWalletIcon(_ref) {
    var _ref$size = _ref.size, size = _ref$size === void 0 ? 16 : _ref$size, color = _ref.color, props = $1d5571bdb4f0e237$var$_objectWithoutPropertiesLoose(_ref, $1d5571bdb4f0e237$var$_excluded$v);
    return (0, $bh6RR.createElement)($1d5571bdb4f0e237$var$SvgWithFillColor, Object.assign({
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        color: color,
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        className: "_icon"
    }, props), (0, $bh6RR.createElement)("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M6.627 7.205a3.018 3.018 0 0 0-3.01 3.01v3.076a4.749 4.749 0 0 1 6.5 4.414c0 .808-.205 1.579-.573 2.25h8.563a3.018 3.018 0 0 0 3.01-3.01v-.44h-1.15c-1.41 0-2.777-1.03-2.907-2.553a2.759 2.759 0 0 1 .817-2.227 2.743 2.743 0 0 1 1.97-.82h1.27v-.69a3.018 3.018 0 0 0-3.01-3.01H6.627Zm-4.51 3.01a4.518 4.518 0 0 1 4.51-4.51h11.48a4.518 4.518 0 0 1 4.51 4.51v1.44a.75.75 0 0 1-.75.75h-2.02c-.359 0-.675.14-.902.373l-.014.014c-.266.26-.415.63-.377 1.022v.009c.054.635.664 1.182 1.413 1.182h1.9a.75.75 0 0 1 .75.75v1.19a4.518 4.518 0 0 1-4.51 4.51H7.997a.75.75 0 0 1-.482-1.325c.243-.203.457-.456.624-.743l.01-.016a3.17 3.17 0 0 0 .468-1.666 3.249 3.249 0 0 0-5.282-2.533.75.75 0 0 1-1.218-.587v-4.37Z"
    }), (0, $bh6RR.createElement)("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M14.467 2.655a1.15 1.15 0 0 0-1.554-1.079l-7.94 3a2.098 2.098 0 0 0-1.356 1.97v4.569a.75.75 0 1 1-1.5 0v-4.57c0-1.5.922-2.84 2.325-3.371l7.94-3c1.732-.657 3.585.629 3.585 2.481v3.8a.75.75 0 0 1-1.5 0v-3.8ZM19.846 12.405c-.359 0-.675.14-.903.373l-.013.014c-.266.26-.415.63-.377 1.022v.009c.053.635.664 1.182 1.413 1.182h1.943a.276.276 0 0 0 .267-.27v-2.06a.276.276 0 0 0-.267-.27h-2.063Zm-1.97-.68a2.743 2.743 0 0 1 1.97-.82h2.107a1.777 1.777 0 0 1 1.723 1.77v2.06a1.777 1.777 0 0 1-1.75 1.77h-1.96c-1.41 0-2.778-1.03-2.907-2.553a2.759 2.759 0 0 1 .816-2.227Z"
    }), (0, $bh6RR.createElement)("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M6.617 10.705a.75.75 0 0 1 .75-.75h7a.75.75 0 0 1 0 1.5h-7a.75.75 0 0 1-.75-.75ZM5.367 14.455c-.761 0-1.468.267-2.032.717h-.002a3.22 3.22 0 0 0-1.216 2.533c0 .61.17 1.183.469 1.666l.006.01a3.22 3.22 0 0 0 2.775 1.574 3.155 3.155 0 0 0 2.148-.825c.243-.203.457-.456.624-.743l.01-.016a3.17 3.17 0 0 0 .468-1.666 3.249 3.249 0 0 0-3.25-3.25ZM2.4 13.998a4.749 4.749 0 0 1 7.717 3.707 4.67 4.67 0 0 1-.687 2.446c-.25.427-.57.808-.94 1.12a4.655 4.655 0 0 1-3.123 1.184 4.72 4.72 0 0 1-4.061-2.301 4.67 4.67 0 0 1-.689-2.449A4.72 4.72 0 0 1 2.4 13.998Z"
    }), (0, $bh6RR.createElement)("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M3.785 16.106a.75.75 0 0 1 1.06-.003l2.12 2.11a.75.75 0 1 1-1.058 1.064l-2.12-2.11a.75.75 0 0 1-.002-1.061Z"
    }), (0, $bh6RR.createElement)("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M6.948 16.136a.75.75 0 0 1-.002 1.06l-2.12 2.11a.75.75 0 0 1-1.058-1.063l2.12-2.11a.75.75 0 0 1 1.06.003Z"
    }));
};
$1d5571bdb4f0e237$export$d730393cd53c0e79.toString = function() {
    return "._icon";
};
var $1d5571bdb4f0e237$var$_excluded$w = [
    "size",
    "color"
];
var $1d5571bdb4f0e237$export$c19a9a617d6502fd = function CheckWalletIcon(_ref) {
    var _ref$size = _ref.size, size = _ref$size === void 0 ? 16 : _ref$size, color = _ref.color, props = $1d5571bdb4f0e237$var$_objectWithoutPropertiesLoose(_ref, $1d5571bdb4f0e237$var$_excluded$w);
    return (0, $bh6RR.createElement)($1d5571bdb4f0e237$var$SvgWithFillColor, Object.assign({
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        color: color,
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        className: "_icon"
    }, props), (0, $bh6RR.createElement)("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M6.686 7.205a3.018 3.018 0 0 0-3.01 3.01v3.076a4.749 4.749 0 0 1 6.5 4.414c0 .808-.205 1.579-.573 2.25h8.563a3.018 3.018 0 0 0 3.01-3.01v-.44h-1.15c-1.41 0-2.778-1.03-2.907-2.553a2.758 2.758 0 0 1 .816-2.227 2.743 2.743 0 0 1 1.97-.82h1.27v-.69a3.018 3.018 0 0 0-3.01-3.01H6.686Zm-4.51 3.01a4.518 4.518 0 0 1 4.51-4.51h11.48a4.518 4.518 0 0 1 4.51 4.51v1.44a.75.75 0 0 1-.75.75h-2.02c-.36 0-.675.14-.903.373l-.013.014c-.266.26-.415.63-.378 1.022l.001.009c.053.635.664 1.182 1.413 1.182h1.9a.75.75 0 0 1 .75.75v1.19a4.518 4.518 0 0 1-4.51 4.51H8.056a.75.75 0 0 1-.482-1.324c.243-.204.457-.457.624-.744l.01-.015a3.17 3.17 0 0 0 .468-1.667 3.249 3.249 0 0 0-5.283-2.533.75.75 0 0 1-1.217-.587v-4.37Z"
    }), (0, $bh6RR.createElement)("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M14.526 2.655a1.15 1.15 0 0 0-1.554-1.078l-7.94 3a2.098 2.098 0 0 0-1.356 1.968v4.57a.75.75 0 0 1-1.5 0v-4.57c0-1.5.921-2.84 2.324-3.371l7.94-3c1.733-.657 3.586.629 3.586 2.481v3.8a.75.75 0 0 1-1.5 0v-3.8ZM19.905 12.405c-.36 0-.675.14-.903.374l-.014.013c-.265.26-.414.63-.377 1.022l.001.01c.053.634.664 1.181 1.413 1.181h1.942a.276.276 0 0 0 .268-.27v-2.06a.276.276 0 0 0-.268-.27h-2.062Zm-1.971-.68a2.743 2.743 0 0 1 1.97-.82h2.107a1.777 1.777 0 0 1 1.724 1.77v2.06a1.777 1.777 0 0 1-1.75 1.77h-1.96c-1.41 0-2.778-1.03-2.907-2.553a2.758 2.758 0 0 1 .816-2.227Z"
    }), (0, $bh6RR.createElement)("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M6.676 10.705a.75.75 0 0 1 .75-.75h7a.75.75 0 0 1 0 1.5h-7a.75.75 0 0 1-.75-.75ZM5.426 14.455c-.762 0-1.469.267-2.033.717h-.001a3.22 3.22 0 0 0-1.216 2.533c0 .61.17 1.184.468 1.667l.006.01a3.22 3.22 0 0 0 2.776 1.573 3.155 3.155 0 0 0 2.148-.824c.243-.204.457-.457.624-.744l.01-.015a3.17 3.17 0 0 0 .468-1.667 3.249 3.249 0 0 0-3.25-3.25Zm-2.967-.457a4.749 4.749 0 0 1 7.717 3.707c0 .888-.248 1.73-.687 2.446-.25.427-.57.808-.941 1.12a4.656 4.656 0 0 1-3.122 1.184 4.72 4.72 0 0 1-4.062-2.301 4.671 4.671 0 0 1-.688-2.449 4.72 4.72 0 0 1 1.783-3.707Z"
    }), (0, $bh6RR.createElement)("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M7.538 16.215a.75.75 0 0 1-.042 1.06l-2.13 1.97a.75.75 0 0 1-1.04-.02l-.99-.99a.75.75 0 1 1 1.062-1.06l.48.48 1.6-1.48a.75.75 0 0 1 1.06.04Z"
    }));
};
$1d5571bdb4f0e237$export$c19a9a617d6502fd.toString = function() {
    return "._icon";
};
var $1d5571bdb4f0e237$var$_excluded$x = [
    "size",
    "color"
];
var $1d5571bdb4f0e237$export$a26e16e490270092 = function SwapWalletIcon(_ref) {
    var _ref$size = _ref.size, size = _ref$size === void 0 ? 16 : _ref$size, color = _ref.color, props = $1d5571bdb4f0e237$var$_objectWithoutPropertiesLoose(_ref, $1d5571bdb4f0e237$var$_excluded$x);
    return (0, $bh6RR.createElement)($1d5571bdb4f0e237$var$SvgWithFillColor, Object.assign({
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        color: color,
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        className: "_icon"
    }, props), (0, $bh6RR.createElement)("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M5.244 7.205a3.018 3.018 0 0 0-3.01 3.01v1.73a.75.75 0 0 1-1.5 0v-1.73a4.518 4.518 0 0 1 4.51-4.51h11.48a4.518 4.518 0 0 1 4.51 4.51v1.44a.75.75 0 0 1-.75.75h-2.02c-.359 0-.674.14-.902.373l-.014.014c-.266.26-.414.63-.377 1.022v.009c.054.635.664 1.182 1.413 1.182h1.9a.75.75 0 0 1 .75.75v1.19a4.518 4.518 0 0 1-4.51 4.51h-5.48a.75.75 0 0 1 0-1.5h5.48a3.018 3.018 0 0 0 3.01-3.01v-.44h-1.15c-1.41 0-2.777-1.03-2.907-2.553a2.758 2.758 0 0 1 .817-2.227 2.743 2.743 0 0 1 1.97-.82h1.27v-.69a3.018 3.018 0 0 0-3.01-3.01H5.244Z"
    }), (0, $bh6RR.createElement)("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M13.084 2.655a1.15 1.15 0 0 0-1.554-1.078l-7.94 3a2.098 2.098 0 0 0-1.356 1.968v4.57a.75.75 0 0 1-1.5 0v-4.57c0-1.5.922-2.84 2.325-3.371l7.94-3c1.732-.657 3.585.629 3.585 2.481v3.8a.75.75 0 0 1-1.5 0v-3.8ZM18.463 12.405c-.359 0-.675.14-.902.374l-.014.013c-.266.26-.415.63-.377 1.022v.01c.053.634.664 1.181 1.413 1.181h1.943a.276.276 0 0 0 .267-.27v-2.06a.276.276 0 0 0-.267-.27h-2.063Zm-1.97-.68a2.743 2.743 0 0 1 1.97-.82h2.107a1.777 1.777 0 0 1 1.723 1.77v2.06a1.777 1.777 0 0 1-1.75 1.77h-1.96c-1.41 0-2.777-1.03-2.907-2.553a2.758 2.758 0 0 1 .816-2.227Z"
    }), (0, $bh6RR.createElement)("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M5.234 10.705a.75.75 0 0 1 .75-.75h7a.75.75 0 0 1 0 1.5h-7a.75.75 0 0 1-.75-.75ZM1.234 15.205a.75.75 0 0 1 .75-.75h5.34a1.91 1.91 0 0 1 1.91 1.91v1.28a.75.75 0 0 1-1.5 0v-1.28a.41.41 0 0 0-.41-.41h-5.34a.75.75 0 0 1-.75-.75Z"
    }), (0, $bh6RR.createElement)("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M3.735 13.455a.75.75 0 0 1 0 1.06l-.69.69.69.69a.75.75 0 1 1-1.061 1.06l-1.22-1.22a.75.75 0 0 1 0-1.06l1.22-1.22a.75.75 0 0 1 1.06 0ZM1.984 17.296a.75.75 0 0 1 .75.75v1.28c0 .225.185.41.41.41h5.34a.75.75 0 0 1 0 1.5h-5.34a1.91 1.91 0 0 1-1.91-1.91v-1.28a.75.75 0 0 1 .75-.75Z"
    }), (0, $bh6RR.createElement)("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M6.735 18.735a.75.75 0 0 1 1.061 0l1.22 1.22a.75.75 0 0 1 0 1.061l-1.22 1.22a.75.75 0 1 1-1.06-1.06l.689-.69-.69-.69a.75.75 0 0 1 0-1.06Z"
    }));
};
$1d5571bdb4f0e237$export$a26e16e490270092.toString = function() {
    return "._icon";
};
var $1d5571bdb4f0e237$var$_excluded$y = [
    "color",
    "size"
];
var $1d5571bdb4f0e237$export$541a84723b7db0e9 = /*#__PURE__*/ (0, $bh6RR.forwardRef)(function(_ref, forwardedRef) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "black" : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? 16 : _ref$size, props = $1d5571bdb4f0e237$var$_objectWithoutPropertiesLoose(_ref, $1d5571bdb4f0e237$var$_excluded$y);
    return (0, $bh6RR.createElement)($1d5571bdb4f0e237$var$SvgWithStrokeColor, Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        color: color,
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: "currentColor",
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        className: "_icon"
    }, props, {
        ref: forwardedRef
    }), (0, $bh6RR.createElement)("path", {
        d: "M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"
    }), (0, $bh6RR.createElement)("polyline", {
        points: "16 17 21 12 16 7"
    }), (0, $bh6RR.createElement)("line", {
        x1: "21",
        y1: "12",
        x2: "9",
        y2: "12"
    }));
});
$1d5571bdb4f0e237$export$541a84723b7db0e9.toString = function() {
    return "._icon";
};
var $1d5571bdb4f0e237$var$_excluded$z = [
    "size",
    "color"
];
var $1d5571bdb4f0e237$export$814ad7f304620551 = function BagIcon(_ref) {
    var _ref$size = _ref.size, size = _ref$size === void 0 ? 16 : _ref$size, color = _ref.color, props = $1d5571bdb4f0e237$var$_objectWithoutPropertiesLoose(_ref, $1d5571bdb4f0e237$var$_excluded$z);
    return (0, $bh6RR.createElement)($1d5571bdb4f0e237$var$SvgWithStrokeColor, Object.assign({
        width: size,
        height: size,
        viewBox: "0 0 32 32",
        color: color,
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        className: "_icon"
    }, props), (0, $bh6RR.createElement)("g", {
        clipPath: "url(#a)",
        strokeWidth: 1.5
    }, (0, $bh6RR.createElement)("path", {
        d: "M9.333 9.333V4.8a.8.8 0 0 1 .8-.8h11.734a.8.8 0 0 1 .8.8v4.533M13.333 4v5.333M16 4v5.333m9.333 17.334H6.667A2.667 2.667 0 0 1 4 24V12a2.667 2.667 0 0 1 2.667-2.667h18.666A2.667 2.667 0 0 1 28 12v12a2.667 2.667 0 0 1-2.667 2.667Z"
    }), (0, $bh6RR.createElement)("path", {
        d: "M22 18.666a.667.667 0 1 1 0-1.334.667.667 0 0 1 0 1.334Z",
        fill: color,
        strokeLinecap: "round",
        strokeLinejoin: "round"
    })), (0, $bh6RR.createElement)("defs", null, (0, $bh6RR.createElement)("clipPath", {
        id: "a"
    }, (0, $bh6RR.createElement)("path", {
        fill: color,
        d: "M0 0h32v32H0z"
    }))));
};
$1d5571bdb4f0e237$export$814ad7f304620551.toString = function() {
    return "._icon";
};
var $1d5571bdb4f0e237$var$_excluded$A = [
    "size"
];
var $1d5571bdb4f0e237$export$7e95adcf912503e3 = /*#__PURE__*/ (0, $bh6RR.forwardRef)(function(_ref, forwardedRef) {
    var _ref$size = _ref.size, size = _ref$size === void 0 ? 16 : _ref$size, props = $1d5571bdb4f0e237$var$_objectWithoutPropertiesLoose(_ref, $1d5571bdb4f0e237$var$_excluded$A);
    return (0, $bh6RR.createElement)($1d5571bdb4f0e237$var$SvgWithStrokeColor, Object.assign({
        width: size,
        height: size,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        className: "_icon"
    }, props, {
        ref: forwardedRef
    }), (0, $bh6RR.createElement)("circle", {
        cx: 10,
        cy: 10,
        r: 7.25,
        strokeWidth: 1.5
    }), (0, $bh6RR.createElement)("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M10.134 6.6a.6.6 0 0 0-1.2 0v4.27a.6.6 0 0 0 .28.507c.009.01.018.019.029.028l2.59 2.373a.472.472 0 0 0 .753-.109.763.763 0 0 0-.133-.919l-2.319-2.123V6.6Z"
    }));
});
$1d5571bdb4f0e237$export$7e95adcf912503e3.toString = function() {
    return "._icon";
};
var $1d5571bdb4f0e237$export$cae179f078f4b4a4 = /*#__PURE__*/ $1d5571bdb4f0e237$export$3817b7a54a07cec7($1d5571bdb4f0e237$export$a6b7c34d56975de0, {
    transform: "rotate(45deg)",
    cursor: "pointer"
});
$1d5571bdb4f0e237$export$cae179f078f4b4a4.toString = function() {
    return "._icon";
};
var $1d5571bdb4f0e237$var$_excluded$B = [
    "size",
    "color"
];
var $1d5571bdb4f0e237$export$dbbb37665784c5f6 = function SignatureIcon(_ref) {
    var _ref$size = _ref.size, size = _ref$size === void 0 ? 16 : _ref$size, color = _ref.color, props = $1d5571bdb4f0e237$var$_objectWithoutPropertiesLoose(_ref, $1d5571bdb4f0e237$var$_excluded$B);
    return (0, $bh6RR.createElement)($1d5571bdb4f0e237$var$SvgWithFillColor, Object.assign({
        width: size,
        height: size,
        color: color,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 122.88 107.95",
        xmlSpace: "preserve",
        className: "_icon"
    }, props), (0, $bh6RR.createElement)("path", {
        d: "M82.19 0c1.22-.01 2.27.4 3.18 1.27l13.27 12.7c.86.82 1.28 1.91 1.3 3.11.02 1.22-.34 2.33-1.18 3.18l-7.06 7.35L72.09 8.67l6.99-7.28C79.94.5 80.98.02 82.19 0zM20.08 68.29a4.536 4.536 0 1 1 2.67 8.67c-6.98 2.14-11.66 6.28-13.21 10.17-.41 1.04-.55 1.99-.39 2.77.12.59.48 1.13 1.07 1.56 2.55 1.86 8.04 2.34 17.26.1 5.46-1.33 11.31-3.13 16.49-4.73 5.29-1.63 9.91-3.06 13.12-3.66 5.92-1.1 11.83-1.85 16.6-1.61 6.26.31 10.96 2.32 12.57 7.13 1.04 3.11.75 5.81.49 8.23-.09.87-.18 1.68-.14 2.21 0 .02.95-.05 5.53-.41 5.3-.42 10.79-2.51 16.21-4.58 2.78-1.06 5.54-2.11 8.67-3.07 2.4-.73 4.93.63 5.65 3.02.73 2.4-.63 4.93-3.02 5.65-2.43.74-5.24 1.82-8.06 2.89-6.04 2.3-12.14 4.63-18.74 5.15-12.07.95-14.87-2.46-15.3-7.95-.1-1.29.03-2.54.17-3.88.16-1.5.34-3.18-.07-4.39-.18-.54-1.89-.82-4.39-.94-3.99-.2-9.22.48-14.54 1.47-2.65.49-7.05 1.85-12.09 3.41-5.27 1.63-11.22 3.46-17.02 4.87-12.14 2.95-20.21 1.7-24.73-1.6-2.54-1.85-4.05-4.27-4.63-7-.54-2.54-.23-5.28.85-8 2.46-6.14 9.23-12.5 18.98-15.48zm21.19-19.84L53.3 60.02l-14.71 3.95c-.53.1-.74-.11-.65-.6l3.33-14.92zm24.6-33.34 19.59 18.87L58.7 62.23l-23.98 6.43c-.86.17-1.2-.17-1.06-.98l5.43-24.31 26.78-28.26z",
        style: {
            fillRule: "evenodd",
            clipRule: "evenodd"
        }
    }));
};
$1d5571bdb4f0e237$export$dbbb37665784c5f6.toString = function() {
    return "._icon";
};
var $1d5571bdb4f0e237$var$_excluded$C = [
    "size",
    "color"
];
var $1d5571bdb4f0e237$export$51b6cd98f8778f0d = function CopyIcon(_ref) {
    var _ref$size = _ref.size, size = _ref$size === void 0 ? 16 : _ref$size, color = _ref.color, props = $1d5571bdb4f0e237$var$_objectWithoutPropertiesLoose(_ref, $1d5571bdb4f0e237$var$_excluded$C);
    return (0, $bh6RR.createElement)($1d5571bdb4f0e237$var$SvgWithFillColor, Object.assign({
        width: size,
        height: size,
        viewBox: "0 0 64 64",
        color: color,
        xmlns: "http://www.w3.org/2000/svg",
        className: "_icon"
    }, props), (0, $bh6RR.createElement)("g", {
        id: "Text-files"
    }, (0, $bh6RR.createElement)("path", {
        d: "M53.9791489,9.1429005H50.010849c-0.0826988,0-0.1562004,0.0283995-0.2331009,0.0469999V5.0228\n		C49.7777481,2.253,47.4731483,0,44.6398468,0h-34.422596C7.3839517,0,5.0793519,2.253,5.0793519,5.0228v46.8432999\n		c0,2.7697983,2.3045998,5.0228004,5.1378999,5.0228004h6.0367002v2.2678986C16.253952,61.8274002,18.4702511,64,21.1954517,64\n		h32.783699c2.7252007,0,4.9414978-2.1725998,4.9414978-4.8432007V13.9861002\n		C58.9206467,11.3155003,56.7043495,9.1429005,53.9791489,9.1429005z M7.1110516,51.8661003V5.0228\n		c0-1.6487999,1.3938999-2.9909999,3.1062002-2.9909999h34.422596c1.7123032,0,3.1062012,1.3422,3.1062012,2.9909999v46.8432999\n		c0,1.6487999-1.393898,2.9911003-3.1062012,2.9911003h-34.422596C8.5049515,54.8572006,7.1110516,53.5149002,7.1110516,51.8661003z\n		 M56.8888474,59.1567993c0,1.550602-1.3055,2.8115005-2.9096985,2.8115005h-32.783699\n		c-1.6042004,0-2.9097996-1.2608986-2.9097996-2.8115005v-2.2678986h26.3541946\n		c2.8333015,0,5.1379013-2.2530022,5.1379013-5.0228004V11.1275997c0.0769005,0.0186005,0.1504021,0.0469999,0.2331009,0.0469999\n		h3.9682999c1.6041985,0,2.9096985,1.2609005,2.9096985,2.8115005V59.1567993z"
    }), (0, $bh6RR.createElement)("path", {
        d: "M38.6031494,13.2063999H16.253952c-0.5615005,0-1.0159006,0.4542999-1.0159006,1.0158005\n		c0,0.5615997,0.4544001,1.0158997,1.0159006,1.0158997h22.3491974c0.5615005,0,1.0158997-0.4542999,1.0158997-1.0158997\n		C39.6190491,13.6606998,39.16465,13.2063999,38.6031494,13.2063999z"
    }), (0, $bh6RR.createElement)("path", {
        d: "M38.6031494,21.3334007H16.253952c-0.5615005,0-1.0159006,0.4542999-1.0159006,1.0157986\n		c0,0.5615005,0.4544001,1.0159016,1.0159006,1.0159016h22.3491974c0.5615005,0,1.0158997-0.454401,1.0158997-1.0159016\n		C39.6190491,21.7877007,39.16465,21.3334007,38.6031494,21.3334007z"
    }), (0, $bh6RR.createElement)("path", {
        d: "M38.6031494,29.4603004H16.253952c-0.5615005,0-1.0159006,0.4543991-1.0159006,1.0158997\n		s0.4544001,1.0158997,1.0159006,1.0158997h22.3491974c0.5615005,0,1.0158997-0.4543991,1.0158997-1.0158997\n		S39.16465,29.4603004,38.6031494,29.4603004z"
    }), (0, $bh6RR.createElement)("path", {
        d: "M28.4444485,37.5872993H16.253952c-0.5615005,0-1.0159006,0.4543991-1.0159006,1.0158997\n		s0.4544001,1.0158997,1.0159006,1.0158997h12.1904964c0.5615025,0,1.0158005-0.4543991,1.0158005-1.0158997\n		S29.0059509,37.5872993,28.4444485,37.5872993z"
    })));
};
$1d5571bdb4f0e237$export$51b6cd98f8778f0d.toString = function() {
    return "._icon";
};
var $1d5571bdb4f0e237$var$_excluded$D = [
    "children",
    "className",
    "color"
];
var $1d5571bdb4f0e237$var$TypographyContainer = /*#__PURE__*/ $1d5571bdb4f0e237$export$3817b7a54a07cec7("span", {
    margin: 0,
    display: "inline-block",
    variants: {
        variant: {
            h1: {
                fontSize: "$36",
                fontWeight: "$700",
                "@md": {
                    fontSize: "$40"
                },
                "@lg": {
                    fontSize: "$48"
                }
            },
            h2: {
                fontSize: "$32",
                fontWeight: "$700",
                "@md": {
                    fontSize: "$36"
                },
                "@lg": {
                    fontSize: "$40"
                }
            },
            h3: {
                fontSize: "$20",
                fontWeight: "$700",
                "@md": {
                    fontSize: "$24"
                },
                "@lg": {
                    fontSize: "$32"
                }
            },
            h4: {
                fontSize: "$18",
                fontWeight: "$600",
                "@md": {
                    fontSize: "$20"
                },
                "@lg": {
                    fontSize: "$24"
                }
            },
            h5: {
                fontSize: "$16",
                fontWeight: "$600"
            },
            h6: {
                fontSize: "$14",
                fontWeight: "$500",
                "@md": {
                    fontSize: "$16"
                },
                "@lg": {
                    fontSize: "$18"
                }
            },
            title: {
                fontSize: "$14",
                fontWeight: "$500",
                "@md": {
                    fontSize: "$15"
                }
            },
            body1: {
                fontSize: "$14",
                fontWeight: "$400",
                "@md": {
                    fontSize: "$16"
                },
                "@lg": {
                    fontSize: "$18"
                }
            },
            body2: {
                fontSize: "$14",
                fontWeight: "$400"
            },
            body3: {
                fontSize: "$12",
                fontWeight: "$400"
            },
            caption: {
                fontSize: "$10",
                fontWeight: "$400",
                "@lg": {
                    fontSize: "$12"
                }
            }
        },
        align: {
            center: {
                textAlign: "center"
            },
            left: {
                textAlign: "left"
            },
            right: {
                textAlign: "right"
            }
        },
        noWrap: {
            "true": {
                whiteSpace: "nowrap"
            }
        },
        ml: {
            2: {
                marginLeft: "$2"
            },
            4: {
                marginLeft: "$4"
            },
            8: {
                marginLeft: "$8"
            },
            12: {
                marginLeft: "$12"
            }
        },
        mt: {
            2: {
                marginTop: "$2"
            },
            4: {
                marginTop: "$4"
            },
            8: {
                marginTop: "$8"
            },
            12: {
                marginTop: "$12"
            }
        },
        mr: {
            2: {
                marginRight: "$2"
            },
            4: {
                marginRight: "$4"
            },
            8: {
                marginRight: "$8"
            },
            12: {
                marginRight: "$12"
            }
        },
        mb: {
            2: {
                marginBottom: "$2"
            },
            4: {
                marginBottom: "$4"
            },
            8: {
                marginBottom: "$8"
            },
            12: {
                marginBottom: "$12"
            }
        }
    }
});
function $1d5571bdb4f0e237$export$1c6175f3aa4394b7(_ref) {
    var children = _ref.children, className = _ref.className, color = _ref.color, props = $1d5571bdb4f0e237$var$_objectWithoutPropertiesLoose(_ref, $1d5571bdb4f0e237$var$_excluded$D);
    var customCss = color ? {
        color: color.startsWith("$") ? color : "$" + color
    } : {
        color: "$foreground"
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($1d5571bdb4f0e237$var$TypographyContainer, Object.assign({
        className: "_typography _text " + (className || ""),
        css: customCss
    }, props), children);
}
$1d5571bdb4f0e237$export$1c6175f3aa4394b7.toString = function() {
    return "._typography";
};
var $1d5571bdb4f0e237$var$StepLogoContainer = /*#__PURE__*/ $1d5571bdb4f0e237$export$3817b7a54a07cec7("div", {
    position: "relative",
    width: "$28",
    height: "$28",
    variants: {
        direction: {
            vertical: {
                margin: "auto"
            },
            horizontal: {}
        }
    }
});
var $1d5571bdb4f0e237$var$Logo = /*#__PURE__*/ $1d5571bdb4f0e237$export$3817b7a54a07cec7("img", {
    width: "$28",
    height: "$28",
    borderRadius: "50%"
});
var $1d5571bdb4f0e237$var$ChainLogo = /*#__PURE__*/ $1d5571bdb4f0e237$export$3817b7a54a07cec7("div", {
    position: "absolute",
    right: -4,
    bottom: -4,
    width: "$16",
    height: "$16",
    padding: "$2",
    borderRadius: "50%",
    backgroundColor: "$background",
    border: "1px solid $neutral400",
    img: {
        width: "100%",
        display: "block"
    }
});
var $1d5571bdb4f0e237$var$StepContainer = /*#__PURE__*/ $1d5571bdb4f0e237$export$3817b7a54a07cec7("div", {
    display: "flex",
    variants: {
        direction: {
            horizontal: {
                alignItems: "center"
            },
            vertical: {
                flexDirection: "column",
                textAlign: "center",
                justifyContent: "center"
            }
        },
        success: {
            "true": {
                filter: "none"
            },
            "false": {
                filter: "grayscale(100%)"
            }
        }
    }
});
var $1d5571bdb4f0e237$var$Detail = /*#__PURE__*/ $1d5571bdb4f0e237$export$3817b7a54a07cec7("div", {
    variants: {
        pl: {
            "true": {
                paddingLeft: "$4",
                "@lg": {
                    paddingLeft: "$8"
                }
            },
            "false": {
                paddingTop: "$8"
            }
        }
    }
});
var $1d5571bdb4f0e237$var$SubTitle = /*#__PURE__*/ $1d5571bdb4f0e237$export$3817b7a54a07cec7($1d5571bdb4f0e237$export$1c6175f3aa4394b7, {
    color: "$neutral600",
    display: "block",
    paddingLeft: "$8"
});
function $1d5571bdb4f0e237$export$6ff54be27cce4b12(props) {
    var logo = props.logo, chainLogo = props.chainLogo, amount = props.amount, symbol = props.symbol, blockchain = props.blockchain, estimatedAmount = props.estimatedAmount, _props$success = props.success, success = _props$success === void 0 ? true : _props$success, _props$direction = props.direction, direction = _props$direction === void 0 ? "horizontal" : _props$direction;
    return (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($1d5571bdb4f0e237$var$StepContainer, {
        direction: direction,
        success: success
    }, (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($1d5571bdb4f0e237$var$StepLogoContainer, {
        direction: direction
    }, (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($1d5571bdb4f0e237$var$Logo, {
        src: logo,
        alt: symbol
    }), (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($1d5571bdb4f0e237$var$ChainLogo, null, (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("img", {
        src: chainLogo,
        alt: blockchain
    }))), (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($1d5571bdb4f0e237$var$Detail, {
        pl: direction === "horizontal"
    }, amount && (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($1d5571bdb4f0e237$export$1c6175f3aa4394b7, {
        noWrap: true,
        variant: direction === "vertical" ? "body2" : "title"
    }, amount), !amount && estimatedAmount && (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($1d5571bdb4f0e237$export$1c6175f3aa4394b7, {
        noWrap: true,
        variant: direction === "vertical" ? "body2" : "title",
        color: "$neutral600"
    }, estimatedAmount), "\xa0", (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($1d5571bdb4f0e237$export$1c6175f3aa4394b7, {
        variant: direction === "vertical" ? "body2" : "title",
        noWrap: true
    }, symbol), (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($1d5571bdb4f0e237$var$SubTitle, {
        noWrap: true,
        variant: "caption",
        color: "$neutral800"
    }, "on ", blockchain)));
}
var $1d5571bdb4f0e237$var$waveSquares = /*#__PURE__*/ $1d5571bdb4f0e237$export$d25ddfdf17c3ad3e({
    "0%": {
        backgroundPosition: "-468px 0"
    },
    "100%": {
        backgroundPosition: "468px 0"
    }
});
var $1d5571bdb4f0e237$var$SkeletonContainer = /*#__PURE__*/ $1d5571bdb4f0e237$export$3817b7a54a07cec7("div", {
    borderRadius: "$5",
    backgroundColor: "$neutral100",
    background: "linear-gradient(to right, rgba(130, 130, 130, 0.2) 8%, rgba(130, 130, 130, 0.3) 18%, rgba(130, 130, 130, 0.2) 33%)",
    backgroundSize: "800px 100px",
    animation: $1d5571bdb4f0e237$var$waveSquares + " 2s infinite ease-out",
    variants: {
        width: {
            16: {
                width: "$16"
            },
            20: {
                width: "$20"
            },
            24: {
                width: "$24"
            },
            36: {
                width: "$36"
            },
            48: {
                width: "$48"
            }
        },
        height: {
            16: {
                height: "$16"
            },
            20: {
                height: "$20"
            },
            24: {
                height: "$24"
            },
            36: {
                height: "$36"
            },
            48: {
                height: "$48"
            },
            94: {
                height: 94
            }
        }
    }
});
function $1d5571bdb4f0e237$var$Skeleton(_ref) {
    var _ref$width = _ref.width, width = _ref$width === void 0 ? 20 : _ref$width, _ref$height = _ref.height, height = _ref$height === void 0 ? 20 : _ref$height;
    return (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($1d5571bdb4f0e237$var$SkeletonContainer, {
        width: width,
        height: height
    });
}
var $1d5571bdb4f0e237$var$spin = /*#__PURE__*/ $1d5571bdb4f0e237$export$d25ddfdf17c3ad3e({
    "100%": {
        transform: "rotate(360deg)"
    }
});
var $1d5571bdb4f0e237$var$SpinnerContainer = /*#__PURE__*/ $1d5571bdb4f0e237$export$3817b7a54a07cec7("div", {
    borderRadius: "50%",
    position: "relative",
    border: "2px solid $neutral100",
    borderRight: "2px solid",
    animation: $1d5571bdb4f0e237$var$spin + " 1.5s linear infinite",
    margin: "0px $8",
    variants: {
        color: {
            primary: {
                borderRightColor: "$primary"
            },
            error: {
                borderRightColor: "$error"
            },
            warning: {
                borderRightColor: "$warning"
            },
            success: {
                borderRightColor: "$success"
            },
            black: {
                borderRightColor: "$black"
            },
            white: {
                borderRightColor: "$white"
            }
        },
        size: {
            16: {
                width: "$16",
                height: "$16"
            },
            20: {
                width: "$20",
                height: "$20"
            },
            24: {
                width: "$24",
                height: "$24"
            }
        }
    }
});
function $1d5571bdb4f0e237$export$7f7cbe89f1eacd2(_ref) {
    var _ref$size = _ref.size, size = _ref$size === void 0 ? 16 : _ref$size, _ref$color = _ref.color, color = _ref$color === void 0 ? "primary" : _ref$color;
    return (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($1d5571bdb4f0e237$var$SpinnerContainer, {
        size: size,
        color: color
    });
}
var $1d5571bdb4f0e237$var$TooltipTrigger = /*#__PURE__*/ $1d5571bdb4f0e237$export$3817b7a54a07cec7((0, $07f3afa847a16c98$export$41fb9f06171c75f4), {
    border: 0,
    padding: 0,
    backgroundColor: "transparent"
});
var $1d5571bdb4f0e237$var$TooltipContent = /*#__PURE__*/ $1d5571bdb4f0e237$export$3817b7a54a07cec7((0, $07f3afa847a16c98$export$7c6e2c02157bb7d2), {
    borderRadius: "$5",
    padding: "$4 $8",
    fontSize: "$14",
    animationDuration: "400ms",
    animationTimingFunction: "cubic-bezier(0.16, 1, 0.3, 1)",
    willChange: "transform, opacity",
    variants: {
        color: {
            primary: {
                backgroundColor: "$primary",
                color: "$white"
            },
            error: {
                backgroundColor: "$error",
                color: "$white"
            },
            warning: {
                backgroundColor: "$warning",
                color: "$white"
            },
            success: {
                backgroundColor: "$success",
                color: "$white"
            },
            gray: {
                backgroundColor: "$neutral100",
                color: "$black"
            },
            black: {
                backgroundColor: "$black",
                color: "$white"
            },
            white: {
                backgroundColor: "$white",
                color: "$black"
            }
        }
    }
});
var $1d5571bdb4f0e237$var$TooltipArrow = /*#__PURE__*/ $1d5571bdb4f0e237$export$3817b7a54a07cec7((0, $07f3afa847a16c98$export$21b07c8f274aebd5), {
    variants: {
        color: {
            primary: {
                fill: "$primary"
            },
            error: {
                fill: "$error"
            },
            warning: {
                fill: "$warning"
            },
            success: {
                fill: "$success"
            },
            gray: {
                fill: "$neutral100"
            },
            black: {
                fill: "$black"
            },
            white: {
                fill: "$white"
            }
        }
    }
});
var $1d5571bdb4f0e237$var$ChildrenWrapper = /*#__PURE__*/ $1d5571bdb4f0e237$export$3817b7a54a07cec7("div", {
    display: "inline-block"
});
function $1d5571bdb4f0e237$export$28c660c63b792dea(_ref) {
    var children = _ref.children, content = _ref.content, _ref$side = _ref.side, side = _ref$side === void 0 ? "top" : _ref$side, _ref$color = _ref.color, color = _ref$color === void 0 ? "gray" : _ref$color;
    return (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $07f3afa847a16c98$export$2881499e37b75b9a), null, (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $07f3afa847a16c98$export$be92b6f5f03c0fe9), null, (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($1d5571bdb4f0e237$var$TooltipTrigger, {
        asChild: true
    }, (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($1d5571bdb4f0e237$var$ChildrenWrapper, null, children)), (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $07f3afa847a16c98$export$602eac185826482c), null, (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($1d5571bdb4f0e237$var$TooltipContent, {
        color: color,
        side: side,
        sideOffset: 5
    }, content, (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($1d5571bdb4f0e237$var$TooltipArrow, {
        color: color
    })))));
}
var $1d5571bdb4f0e237$export$79a9bb15495f79de = /*#__PURE__*/ $1d5571bdb4f0e237$export$3817b7a54a07cec7("span", {
    width: "10px",
    height: "10px",
    backgroundColor: "$primary",
    borderRadius: "99999px"
});
var $1d5571bdb4f0e237$var$_excluded$E = [
    "size"
];
var $1d5571bdb4f0e237$var$ImageContainer = /*#__PURE__*/ $1d5571bdb4f0e237$export$3817b7a54a07cec7("div", {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    ".image": {
        width: "100%",
        height: "100%",
        objectFit: "contain"
    }
});
function $1d5571bdb4f0e237$export$3e431a229df88919(props) {
    var size = props.size, otherProps = $1d5571bdb4f0e237$var$_objectWithoutPropertiesLoose(props, $1d5571bdb4f0e237$var$_excluded$E);
    return (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($1d5571bdb4f0e237$var$ImageContainer, {
        css: {
            width: size + "px",
            height: size + "px"
        }
    }, (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("img", Object.assign({
        className: "image"
    }, otherProps)));
}
var $1d5571bdb4f0e237$var$Container = /*#__PURE__*/ $1d5571bdb4f0e237$export$3817b7a54a07cec7("div", {
    borderRadius: "$5",
    border: "1px solid $neutral100",
    display: "flex",
    alignItems: "center",
    minHeight: 126,
    justifyContent: "space-between",
    backgroundColor: "$surface"
});
var $1d5571bdb4f0e237$var$ErrorMsg = /*#__PURE__*/ $1d5571bdb4f0e237$export$3817b7a54a07cec7($1d5571bdb4f0e237$export$1c6175f3aa4394b7, {
    color: "$error"
});
var $1d5571bdb4f0e237$var$BestRouteContainer = /*#__PURE__*/ $1d5571bdb4f0e237$export$3817b7a54a07cec7("div", {
    display: "flex",
    alignItems: "center",
    margin: "0 auto",
    overflowX: "auto",
    overflowY: "hidden",
    alignSelf: "stretch",
    padding: "$4",
    "@md": {
        padding: "$8"
    }
});
var $1d5571bdb4f0e237$var$Line = /*#__PURE__*/ $1d5571bdb4f0e237$export$3817b7a54a07cec7("div", {
    height: "0",
    width: "$20",
    border: "1px dashed $foreground",
    borderRadius: "inherit",
    "@lg": {
        width: "$32"
    }
});
var $1d5571bdb4f0e237$var$HR = /*#__PURE__*/ $1d5571bdb4f0e237$export$3817b7a54a07cec7("hr", {
    width: "100%",
    border: "1px solid $neutral400",
    margin: "$8 0"
});
var $1d5571bdb4f0e237$var$RelativeContainer = /*#__PURE__*/ $1d5571bdb4f0e237$export$3817b7a54a07cec7("div", {
    position: "relative"
});
var $1d5571bdb4f0e237$var$Dot = /*#__PURE__*/ $1d5571bdb4f0e237$export$3817b7a54a07cec7("div", {
    width: "$6",
    height: "$6",
    backgroundColor: "$foreground",
    position: "absolute",
    top: "45%",
    right: -5,
    marginLeft: "$8",
    borderRadius: "50%",
    "@md": {
        width: "$8",
        height: "$8",
        right: -8,
        top: "45%"
    }
});
var $1d5571bdb4f0e237$var$ArrowRight = /*#__PURE__*/ $1d5571bdb4f0e237$export$3817b7a54a07cec7("div", {
    width: "0px",
    height: "0px",
    borderTop: "5px solid transparent",
    borderBottom: "5px solid transparent",
    borderLeft: "5px solid $foreground"
});
var $1d5571bdb4f0e237$var$pulse = /*#__PURE__*/ $1d5571bdb4f0e237$export$d25ddfdf17c3ad3e({
    "0%": {
        opacity: 1
    },
    "50%": {
        opacity: 0.3
    },
    "100%": {
        opacity: 1
    }
});
var $1d5571bdb4f0e237$var$GasContainer = /*#__PURE__*/ $1d5571bdb4f0e237$export$3817b7a54a07cec7("div", {
    backgroundColor: "$neutral100",
    borderRadius: "5px",
    margin: "$4",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    padding: "$4",
    "@md": {
        padding: "$8",
        margin: "$8"
    }
});
var $1d5571bdb4f0e237$var$CostContainer = /*#__PURE__*/ $1d5571bdb4f0e237$export$3817b7a54a07cec7("div", {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    variants: {
        warning: {
            "true": {
                animation: $1d5571bdb4f0e237$var$pulse + " 2s ease-in-out infinite"
            }
        }
    }
});
var $1d5571bdb4f0e237$var$TotalFee = /*#__PURE__*/ $1d5571bdb4f0e237$export$3817b7a54a07cec7($1d5571bdb4f0e237$export$1c6175f3aa4394b7, {
    variants: {
        warning: {
            "true": {
                color: "$warning300"
            }
        }
    }
});
var $1d5571bdb4f0e237$var$SkeletonContainer$1 = /*#__PURE__*/ $1d5571bdb4f0e237$export$3817b7a54a07cec7("div", {
    padding: "$4",
    "@md": {
        padding: "$8"
    }
});
var $1d5571bdb4f0e237$var$SwapperContainer = /*#__PURE__*/ $1d5571bdb4f0e237$export$3817b7a54a07cec7("div", {
    display: "flex",
    justifyContent: "center",
    alignItems: "center"
});
function $1d5571bdb4f0e237$export$a78fce96441ecd9c(props) {
    var _data$result;
    var data = props.data, loading = props.loading, error = props.error, totalFee = props.totalFee, feeWarning = props.feeWarning, totalTime = props.totalTime;
    return (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($1d5571bdb4f0e237$var$Container, null, loading ? (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($1d5571bdb4f0e237$var$SkeletonContainer$1, null, (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($1d5571bdb4f0e237$var$Skeleton, {
        width: 48,
        height: 94
    })) : (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($1d5571bdb4f0e237$var$GasContainer, null, (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($1d5571bdb4f0e237$export$28c660c63b792dea, {
        content: "Transaction cost (fee)"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($1d5571bdb4f0e237$var$CostContainer, {
        warning: feeWarning
    }, (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($1d5571bdb4f0e237$export$dc5067efa4cb656a, {
        size: 20,
        color: feeWarning ? "warning" : undefined
    }), (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($1d5571bdb4f0e237$var$TotalFee, {
        mt: 4,
        align: "center",
        variant: "caption",
        warning: feeWarning
    }, error && "-", !!data && "$" + totalFee))), (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($1d5571bdb4f0e237$var$HR, null), (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($1d5571bdb4f0e237$export$28c660c63b792dea, {
        content: "Time estimate"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($1d5571bdb4f0e237$var$CostContainer, {
        warning: feeWarning
    }, (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($1d5571bdb4f0e237$export$7e95adcf912503e3, {
        size: 20
    }), (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($1d5571bdb4f0e237$export$1c6175f3aa4394b7, {
        mt: 4,
        align: "center",
        variant: "caption"
    }, error && "-", !!data && "~" + totalTime + "m")))), (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($1d5571bdb4f0e237$var$BestRouteContainer, null, loading && (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($1d5571bdb4f0e237$export$7f7cbe89f1eacd2, {
        color: "primary"
    }), error && (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($1d5571bdb4f0e237$var$ErrorMsg, {
        variant: "caption"
    }, error), !!data && ((_data$result = data.result) == null ? void 0 : _data$result.swaps.map(function(swap, index) {
        var _data$result2;
        return (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $bh6RR.Fragment), {
            key: index
        }, index === 0 && (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($1d5571bdb4f0e237$var$RelativeContainer, null, (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($1d5571bdb4f0e237$export$6ff54be27cce4b12, {
            direction: "vertical",
            logo: swap.from.logo,
            symbol: swap.from.symbol,
            chainLogo: swap.from.blockchainLogo,
            blockchain: swap.from.blockchain,
            amount: swap.fromAmount
        }), (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($1d5571bdb4f0e237$var$Dot, null)), (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($1d5571bdb4f0e237$var$SwapperContainer, null, (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($1d5571bdb4f0e237$var$Line, null), (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($1d5571bdb4f0e237$export$3e431a229df88919, {
            src: swap.swapperLogo,
            alt: swap.swapperId,
            size: 20
        }), (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($1d5571bdb4f0e237$var$Line, null)), index + 1 === ((_data$result2 = data.result) == null ? void 0 : _data$result2.swaps.length) && (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($1d5571bdb4f0e237$var$ArrowRight, null), (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($1d5571bdb4f0e237$export$6ff54be27cce4b12, {
            direction: "vertical",
            logo: swap.to.logo,
            symbol: swap.to.symbol,
            chainLogo: swap.to.blockchainLogo,
            blockchain: swap.to.blockchain,
            amount: swap.toAmount
        }));
    })), !!data && !(data != null && data.result) && (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($1d5571bdb4f0e237$export$1c6175f3aa4394b7, {
        variant: "body2"
    }, "No routes found")));
}
var $1d5571bdb4f0e237$var$_excluded$F = [
    "children",
    "loading",
    "disabled",
    "prefix",
    "suffix",
    "align",
    "flexContent"
];
var $1d5571bdb4f0e237$var$_ghost, $1d5571bdb4f0e237$var$_css, $1d5571bdb4f0e237$var$_css2, $1d5571bdb4f0e237$var$_css3;
var $1d5571bdb4f0e237$var$ButtonContainer = /*#__PURE__*/ $1d5571bdb4f0e237$export$3817b7a54a07cec7("button", {
    borderRadius: "$5",
    fontSize: "$16",
    fontWeight: "$400",
    cursor: "pointer",
    padding: "0 $12",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    transition: "all 0.35s",
    border: "0",
    "&:active": {
        transform: "scale(0.95)"
    },
    variants: {
        align: {
            start: {
                display: "flex",
                width: "100%"
            },
            grow: {
                display: "flex",
                width: "100%"
            }
        },
        size: {
            compact: {},
            free: {},
            small: {
                height: "$32"
            },
            medium: {
                height: "$40"
            },
            large: {
                height: "$48"
            }
        },
        variant: {
            contained: {
                backgroundColor: "$neutral100",
                color: "$foreground",
                border: 0,
                "&:hover": {
                    backgroundColor: "$neutral200"
                },
                "&:disabled": {
                    background: "$neutral400"
                },
                "&:disabled:hover": {
                    background: "$neutral400",
                    transform: "unset"
                }
            },
            outlined: {
                backgroundColor: "$surface",
                border: 1,
                borderStyle: "solid",
                borderColor: "$neutral400",
                color: "$foreground",
                "&:hover": {
                    borderColor: "$neutral600"
                },
                "&:disabled": {
                    borderColor: "$neutral400",
                    color: "$neutral400"
                }
            },
            ghost: ($1d5571bdb4f0e237$var$_ghost = {
                color: "$foreground",
                "&:hover": {
                    backgroundColor: "$neutral200"
                },
                "&:disabled": {
                    color: "$neutral400"
                },
                background: "transparent",
                border: 0
            }, $1d5571bdb4f0e237$var$_ghost["& " + $1d5571bdb4f0e237$export$1c6175f3aa4394b7] = {
                color: "inherit"
            }, $1d5571bdb4f0e237$var$_ghost)
        },
        fullWidth: {
            "true": {
                width: "100%"
            }
        },
        loading: {
            "true": {}
        },
        type: {
            primary: {},
            error: {},
            warning: {},
            success: {}
        }
    },
    compoundVariants: [
        {
            type: "primary",
            variant: "contained",
            css: {
                background: "$primary",
                color: "$white",
                "&:hover": {
                    background: "$primary700"
                },
                "&:visited": {
                    background: "$primary900"
                },
                "&:focus": {
                    background: "$primary600"
                }
            }
        },
        {
            type: "primary",
            variant: "outlined",
            css: {
                color: "$primary",
                borderColor: "$primary",
                "&:hover": {
                    color: "$primary700",
                    borderColor: "$primary700"
                },
                "&:visited": {
                    color: "$primary900",
                    borderColor: "$primary900"
                },
                "&:focus": {
                    color: "$primary600",
                    borderColor: "$primary600"
                }
            }
        },
        {
            type: "primary",
            variant: "ghost",
            css: {
                color: "$primary",
                "&:hover": {
                    color: "$primary700"
                },
                "&:visited": {
                    color: "$primary900"
                },
                "&:focus": {
                    color: "$primary600"
                }
            }
        },
        {
            type: "error",
            variant: "contained",
            css: ($1d5571bdb4f0e237$var$_css = {
                background: "$error",
                $$color: "$colors$background"
            }, $1d5571bdb4f0e237$var$_css["." + $1d5571bdb4f0e237$export$3e936a8db52a10a0 + " &"] = {
                $$color: "$colors$foreground"
            }, $1d5571bdb4f0e237$var$_css.color = "$$color", $1d5571bdb4f0e237$var$_css["&:hover"] = {
                background: "$error300"
            }, $1d5571bdb4f0e237$var$_css["&:visited"] = {
                background: "$error700"
            }, $1d5571bdb4f0e237$var$_css["&:focus"] = {
                background: "$error700"
            }, $1d5571bdb4f0e237$var$_css)
        },
        {
            type: "error",
            variant: "outlined",
            css: {
                color: "$error",
                borderColor: "$error",
                "&:hover": {
                    color: "$error300",
                    borderColor: "$error300"
                },
                "&:visited": {
                    color: "$error700",
                    borderColor: "$error700"
                },
                "&:focus": {
                    color: "$error700",
                    borderColor: "$error700"
                }
            }
        },
        {
            type: "error",
            variant: "ghost",
            css: {
                color: "$error",
                "&:hover": {
                    color: "$error300"
                },
                "&:visited": {
                    color: "$error700"
                },
                "&:focus": {
                    color: "$error700"
                }
            }
        },
        {
            type: "warning",
            variant: "contained",
            css: ($1d5571bdb4f0e237$var$_css2 = {
                background: "$warning",
                $$color: "$colors$background"
            }, $1d5571bdb4f0e237$var$_css2["." + $1d5571bdb4f0e237$export$3e936a8db52a10a0 + " &"] = {
                $$color: "$colors$foreground"
            }, $1d5571bdb4f0e237$var$_css2.color = "$$color", $1d5571bdb4f0e237$var$_css2["&:hover"] = {
                background: "$warning300"
            }, $1d5571bdb4f0e237$var$_css2["&:visited"] = {
                background: "$warning700"
            }, $1d5571bdb4f0e237$var$_css2["&:focus"] = {
                background: "$warning700"
            }, $1d5571bdb4f0e237$var$_css2)
        },
        {
            type: "warning",
            variant: "outlined",
            css: {
                color: "$warning",
                borderColor: "$warning",
                "&:hover": {
                    color: "$warning300",
                    borderColor: "$warning300"
                },
                "&:visited": {
                    color: "$warning700",
                    borderColor: "$warning700"
                },
                "&:focus": {
                    color: "$warning700",
                    borderColor: "$warning700"
                }
            }
        },
        {
            type: "warning",
            variant: "ghost",
            css: {
                color: "$warning",
                "&:hover": {
                    color: "$warning300"
                },
                "&:visited": {
                    color: "$warning700"
                },
                "&:focus": {
                    color: "$warning700"
                }
            }
        },
        {
            type: "success",
            variant: "contained",
            css: ($1d5571bdb4f0e237$var$_css3 = {
                background: "$success",
                $$color: "$colors$background"
            }, $1d5571bdb4f0e237$var$_css3["." + $1d5571bdb4f0e237$export$3e936a8db52a10a0 + " &"] = {
                $$color: "$colors$foreground"
            }, $1d5571bdb4f0e237$var$_css3.color = "$$color", $1d5571bdb4f0e237$var$_css3["&:hover"] = {
                background: "$success300"
            }, $1d5571bdb4f0e237$var$_css3["&:visited"] = {
                background: "$success700"
            }, $1d5571bdb4f0e237$var$_css3["&:focus"] = {
                background: "$success700"
            }, $1d5571bdb4f0e237$var$_css3)
        },
        {
            type: "success",
            variant: "outlined",
            css: {
                color: "$success",
                borderColor: "$success",
                "&:hover": {
                    color: "$success300",
                    borderColor: "$success300"
                },
                "&:visited": {
                    color: "$success700",
                    borderColor: "$success700"
                },
                "&:focus": {
                    color: "$success700",
                    borderColor: "$success700"
                }
            }
        },
        {
            type: "success",
            variant: "ghost",
            css: {
                color: "$success",
                "&:hover": {
                    color: "$success300"
                },
                "&:visited": {
                    color: "$success700"
                },
                "&:focus": {
                    color: "$success700"
                }
            }
        },
        {
            size: "compact",
            css: {
                padding: "$2 $4",
                fontSize: "$12"
            }
        }
    ],
    defaultVariants: {
        size: "medium",
        variant: "contained"
    }
});
var $1d5571bdb4f0e237$var$Content = /*#__PURE__*/ $1d5571bdb4f0e237$export$3817b7a54a07cec7("div", {
    flex: 1,
    variants: {
        align: {
            start: {
                textAlign: "left"
            },
            grow: {
                textAlign: "center"
            }
        },
        ml: {
            "true": {
                marginLeft: "$8"
            }
        },
        mr: {
            "true": {
                marginRight: "$8"
            }
        },
        flexContent: {
            "true": {
                display: "flex",
                alignItems: "center"
            }
        }
    }
});
function $1d5571bdb4f0e237$export$353f5b6fc5456de1(_ref) {
    var children = _ref.children, loading = _ref.loading, disabled = _ref.disabled, prefix = _ref.prefix, suffix = _ref.suffix, align = _ref.align, flexContent = _ref.flexContent, props = $1d5571bdb4f0e237$var$_objectWithoutPropertiesLoose(_ref, $1d5571bdb4f0e237$var$_excluded$F);
    var isDisabled = loading || disabled;
    return (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($1d5571bdb4f0e237$var$ButtonContainer, Object.assign({
        disabled: isDisabled
    }, props, {
        align: align
    }), prefix, children && (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($1d5571bdb4f0e237$var$Content, {
        align: align,
        ml: !!prefix,
        mr: !!suffix && !loading,
        flexContent: flexContent,
        className: "_text"
    }, children), loading && (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($1d5571bdb4f0e237$export$7f7cbe89f1eacd2, {
        size: 16,
        color: props.type
    }), suffix);
}
var $1d5571bdb4f0e237$var$ListContainer = /*#__PURE__*/ $1d5571bdb4f0e237$export$3817b7a54a07cec7("div", {
    display: "grid",
    gap: ".5rem",
    gridTemplateColumns: " repeat(2, minmax(0, 1fr))",
    alignContent: "baseline",
    width: "100%",
    height: "100%"
});
var $1d5571bdb4f0e237$var$ImageContainer$1 = /*#__PURE__*/ $1d5571bdb4f0e237$export$3817b7a54a07cec7("div", {
    paddingRight: "$4"
});
function $1d5571bdb4f0e237$var$BlockchainsList(props) {
    var list = props.list, onChange = props.onChange, multiSelect = props.multiSelect, selectedList = props.selectedList;
    var _useState = (0, $bh6RR.useState)(props.selected), selected = _useState[0], setSelected = _useState[1];
    var changeSelectedBlockchain = function changeSelectedBlockchain(blockchain) {
        setSelected(blockchain);
        onChange(blockchain);
    };
    var isSelect = function isSelect(name) {
        if (multiSelect && selectedList) return selectedList === "all" || selectedList.findIndex(function(item) {
            return name === item.name;
        }) > -1;
        return name === (selected == null ? void 0 : selected.name);
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($1d5571bdb4f0e237$var$ListContainer, null, list.map(function(blockchain, index) {
        return (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($1d5571bdb4f0e237$export$353f5b6fc5456de1, {
            type: isSelect(blockchain.name) ? "primary" : undefined,
            variant: "outlined",
            size: "large",
            prefix: (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($1d5571bdb4f0e237$var$ImageContainer$1, null, (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($1d5571bdb4f0e237$export$3e431a229df88919, {
                size: 24,
                src: blockchain.logo
            })),
            suffix: isSelect(blockchain.name) ? (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($1d5571bdb4f0e237$export$79a9bb15495f79de, null) : undefined,
            align: "start",
            onClick: changeSelectedBlockchain.bind(null, blockchain),
            key: index
        }, (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($1d5571bdb4f0e237$export$1c6175f3aa4394b7, {
            variant: "body2"
        }, blockchain.displayName));
    }));
}
var $1d5571bdb4f0e237$var$DividerContainer = /*#__PURE__*/ $1d5571bdb4f0e237$export$3817b7a54a07cec7("div", {
    variants: {
        size: {
            4: {
                height: "$4"
            },
            8: {
                height: "$8"
            },
            12: {
                height: "$12"
            },
            16: {
                height: "$16"
            },
            18: {
                height: "$18"
            },
            20: {
                height: "$20"
            },
            24: {
                height: "$24"
            },
            32: {
                height: "$32"
            }
        }
    }
});
function $1d5571bdb4f0e237$export$2e0a83ec2e27ecbb(_ref) {
    var _ref$size = _ref.size, size = _ref$size === void 0 ? 12 : _ref$size;
    return (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($1d5571bdb4f0e237$var$DividerContainer, {
        size: size
    });
}
var $1d5571bdb4f0e237$var$HeaderContainer = /*#__PURE__*/ $1d5571bdb4f0e237$export$3817b7a54a07cec7("div", {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: "$8 0",
    position: "relative"
});
var $1d5571bdb4f0e237$var$BackButton = /*#__PURE__*/ $1d5571bdb4f0e237$export$3817b7a54a07cec7($1d5571bdb4f0e237$export$353f5b6fc5456de1, {
    padding: "$8"
});
function $1d5571bdb4f0e237$export$8b251419efc915eb(props) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($1d5571bdb4f0e237$var$HeaderContainer, null, props.onBack ? (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($1d5571bdb4f0e237$var$BackButton, {
        variant: "ghost",
        size: "small",
        onClick: props.onBack
    }, (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($1d5571bdb4f0e237$export$3df4a161b319f37a, {
        size: 24
    })) : null, props.prefix, (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($1d5571bdb4f0e237$export$1c6175f3aa4394b7, {
        variant: "h4"
    }, props.title), props.suffix || (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("div", null));
}
var $1d5571bdb4f0e237$var$_excluded$G = [
    "label",
    "prefix",
    "suffix",
    "children",
    "size",
    "style"
];
var $1d5571bdb4f0e237$var$InputContainer = /*#__PURE__*/ $1d5571bdb4f0e237$export$3817b7a54a07cec7("div", {
    backgroundColor: "$surface",
    padding: "1px",
    boxSizing: "border-box",
    border: "1px solid $neutral400",
    borderRadius: "$5",
    height: "$48",
    display: "flex",
    flexGrow: 1,
    position: "relative",
    alignItems: "center",
    color: "$foreground",
    overflowX: "hidden",
    transition: "border-color ease .3s",
    "&:focus-within": {
        borderColor: "$success",
        outline: "1px solid $success"
    },
    variants: {
        size: {
            small: {
                "& input": {
                    fontSize: "$14"
                },
                height: "$32"
            },
            medium: {
                "& input": {
                    fontSize: "$15"
                },
                height: "$40"
            },
            large: {
                "& input": {
                    fontSize: "$16"
                },
                height: "$48"
            }
        },
        disabled: {
            "true": {
                backgroundColor: "$neutral100",
                cursor: "not-allowed",
                filter: "grayscale(100%)"
            }
        },
        prefix: {
            "true": {
                paddingLeft: "$16"
            },
            "false": {
                paddingLeft: "$0"
            }
        },
        suffix: {
            "true": {
                paddingRight: "$16"
            },
            "false": {
                paddingRight: "$0"
            }
        }
    },
    defaultVariants: {
        size: "medium"
    }
});
var $1d5571bdb4f0e237$var$Input = /*#__PURE__*/ $1d5571bdb4f0e237$export$3817b7a54a07cec7("input", {
    color: "$foreground",
    paddingLeft: "$16",
    paddingRight: "$16",
    flexGrow: 1,
    width: "100%",
    border: "none",
    borderRadius: "$5",
    outline: "none",
    backgroundColor: "transparent",
    "-webkit-appearance": "none",
    margin: 0,
    "&:disabled": {
        cursor: "not-allowed"
    },
    "&::-webkit-outer-spin-button, &::-webkit-inner-spin-button": {
        "-webkit-appearance": "none",
        margin: 0
    },
    '&[type="number"]': {
        "-moz-appearance": "textfield"
    }
});
var $1d5571bdb4f0e237$var$Label = /*#__PURE__*/ $1d5571bdb4f0e237$export$3817b7a54a07cec7("label", {
    display: "inline-block",
    fontSize: "$14",
    color: "$foreground",
    marginBottom: "$4"
});
var $1d5571bdb4f0e237$export$2c73285ae9390cec = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).forwardRef(function(props, ref) {
    var label = props.label, prefix = props.prefix, suffix = props.suffix, size = props.size, style = props.style, inputAttributes = $1d5571bdb4f0e237$var$_objectWithoutPropertiesLoose(props, $1d5571bdb4f0e237$var$_excluded$G);
    return (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).Fragment, null, label && (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($1d5571bdb4f0e237$var$Label, Object.assign({
        className: "_text"
    }, inputAttributes.id && {
        htmlFor: inputAttributes.id
    }), label), (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($1d5571bdb4f0e237$var$InputContainer, {
        disabled: inputAttributes.disabled,
        prefix: !!prefix,
        suffix: !!suffix,
        size: size,
        style: style,
        className: "_text"
    }, prefix || null, (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($1d5571bdb4f0e237$var$Input, Object.assign({
        className: "_text"
    }, inputAttributes, {
        spellCheck: false,
        ref: ref
    })), suffix || null));
});
var $1d5571bdb4f0e237$var$ContentContainer = /*#__PURE__*/ $1d5571bdb4f0e237$export$3817b7a54a07cec7("div", {
    overflow: "hidden",
    display: "flex",
    flexDirection: "column",
    flex: "1",
    padding: "0 $4"
});
var $1d5571bdb4f0e237$var$TextFieldContainer = /*#__PURE__*/ $1d5571bdb4f0e237$export$3817b7a54a07cec7("div", {
    padding: "1px"
});
function $1d5571bdb4f0e237$export$791bf2dc0030f14c(props) {
    var title = props.title, Footer = props.Footer, TopButton = props.TopButton, onBack = props.onBack, _props$hasHeader = props.hasHeader, hasHeader = _props$hasHeader === void 0 ? true : _props$hasHeader;
    var _useState = (0, $bh6RR.useState)(""), searchedFor = _useState[0], setSearchedFor = _useState[1];
    return (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).Fragment, null, hasHeader && (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($1d5571bdb4f0e237$export$8b251419efc915eb, {
        onBack: onBack,
        title: title || "",
        suffix: TopButton
    }), (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($1d5571bdb4f0e237$var$ContentContainer, null, props.textField && (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($1d5571bdb4f0e237$var$TextFieldContainer, null, (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($1d5571bdb4f0e237$export$2c73285ae9390cec, {
        size: "large",
        prefix: (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($1d5571bdb4f0e237$export$82eafebb825fc23f, {
            size: 24
        }),
        placeholder: props.textFieldPlaceholder,
        onChange: function onChange(event) {
            return setSearchedFor(event.target.value);
        },
        value: searchedFor,
        autoFocus: true
    }), (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($1d5571bdb4f0e237$export$2e0a83ec2e27ecbb, {
        size: 16
    })), props.textField && (props.children == null ? void 0 : props.children(searchedFor)), !props.textField && props.children), Footer);
}
function $1d5571bdb4f0e237$var$containsText(text, searchText) {
    return text.toLowerCase().indexOf(searchText.toLowerCase()) > -1;
}
function $1d5571bdb4f0e237$var$getConciseAddress(address, maxChars, ellipsisLength) {
    if (maxChars === void 0) maxChars = 8;
    if (ellipsisLength === void 0) ellipsisLength = 3;
    if (!address) return null;
    if (address.length < 2 * maxChars + ellipsisLength) return address;
    var start = Math.ceil((address.length - maxChars) / 2);
    var end = address.length - maxChars;
    return "" + address.substr(start, maxChars) + ".".repeat(ellipsisLength) + address.substr(end);
}
function $1d5571bdb4f0e237$var$limitDecimalPlaces(numberString, maxDecimalPlaces) {
    if (maxDecimalPlaces === void 0) maxDecimalPlaces = 4;
    var number = parseFloat(numberString);
    if (isNaN(number)) return numberString; // Return the original string if it's not a valid number
    else {
        var multiplier = Math.pow(10, maxDecimalPlaces);
        var roundedNumber = Math.round(number * multiplier) / multiplier;
        return roundedNumber.toString();
    }
}
var $1d5571bdb4f0e237$var$hexToRgb = function hexToRgb(hex) {
    return function(value) {
        return value.length === 3 ? value.split("").map(function(c) {
            return parseInt(c.repeat(2), 16);
        }) : (value.match(/.{1,2}/g) || []).map(function(v) {
            return parseInt(v, 16);
        });
    }(hex.replace("#", ""));
};
var $1d5571bdb4f0e237$var$isHexTooDark = function isHexTooDark(hexColor) {
    return function(_ref) {
        var r = _ref[0], g = _ref[1], b = _ref[2];
        return 0.2126 * r + 0.7152 * g + 0.0722 * b < 40;
    }($1d5571bdb4f0e237$var$hexToRgb(hexColor));
};
var $1d5571bdb4f0e237$var$isHexTooLight = function isHexTooLight(hexColor) {
    return function(_ref2) {
        var r = _ref2[0], g = _ref2[1], b = _ref2[2];
        return (r * 299 + g * 587 + b * 114) / 1000 > 155;
    }($1d5571bdb4f0e237$var$hexToRgb(hexColor));
};
var $1d5571bdb4f0e237$var$colorShade = function colorShade(col, amt) {
    col = col.replace(/^#/, "");
    if (col.length === 3) col = col[0] + col[0] + col[1] + col[1] + col[2] + col[2];
    var _col$match = col.match(/.{2}/g), r = _col$match[0], g = _col$match[1], b = _col$match[2];
    var _ref3 = [
        parseInt(r, 16) + amt,
        parseInt(g, 16) + amt,
        parseInt(b, 16) + amt
    ];
    r = _ref3[0];
    g = _ref3[1];
    b = _ref3[2];
    r = Math.max(Math.min(255, r), 0).toString(16);
    g = Math.max(Math.min(255, g), 0).toString(16);
    b = Math.max(Math.min(255, b), 0).toString(16);
    var rr = (r.length < 2 ? "0" : "") + r;
    var gg = (g.length < 2 ? "0" : "") + g;
    var bb = (b.length < 2 ? "0" : "") + b;
    return "#" + rr + gg + bb;
};
var $1d5571bdb4f0e237$export$f1509103d5c45ba5 = function generateRangeColors(name, mode, color) {
    var _colors;
    var colors = (_colors = {}, _colors[name] = color, _colors);
    if (color) {
        var c = color;
        if ($1d5571bdb4f0e237$var$isHexTooDark(color) || mode === "dark") for(var i = 1; i < 10; i++){
            var _extends2;
            colors = $1d5571bdb4f0e237$var$_extends({}, colors, (_extends2 = {}, _extends2[name + i * 100] = name === "neutral" ? $1d5571bdb4f0e237$var$colorShade(c, i * 15) : $1d5571bdb4f0e237$var$colorShade(color, i * 5), _extends2));
        }
        if ($1d5571bdb4f0e237$var$isHexTooLight(color) || mode === "light") for(var _i = 1; _i < 10; _i++){
            var _extends3;
            c = $1d5571bdb4f0e237$var$colorShade(c, -(_i * 5));
            colors = $1d5571bdb4f0e237$var$_extends({}, colors, (_extends3 = {}, _extends3[name + _i * 100] = name === "neutral" ? $1d5571bdb4f0e237$var$colorShade(c, -(_i * 5)) : $1d5571bdb4f0e237$var$colorShade(color, -(_i * 5)), _extends3));
        }
    }
    return colors;
};
var $1d5571bdb4f0e237$var$SpacerContainer = /*#__PURE__*/ $1d5571bdb4f0e237$export$3817b7a54a07cec7("div", {
    variants: {
        size: {
            4: {},
            8: {},
            12: {},
            16: {},
            18: {},
            20: {},
            24: {}
        },
        direction: {
            vertical: {},
            horizontal: {}
        }
    },
    compoundVariants: [
        {
            size: 4,
            direction: "horizontal",
            css: {
                width: "$4"
            }
        },
        {
            size: 4,
            direction: "vertical",
            css: {
                height: "$4"
            }
        },
        {
            size: 8,
            direction: "horizontal",
            css: {
                width: "$8"
            }
        },
        {
            size: 8,
            direction: "vertical",
            css: {
                height: "$8"
            }
        },
        {
            size: 12,
            direction: "horizontal",
            css: {
                width: "$12"
            }
        },
        {
            size: 12,
            direction: "vertical",
            css: {
                height: "$12"
            }
        },
        {
            size: 16,
            direction: "horizontal",
            css: {
                width: "$16"
            }
        },
        {
            size: 16,
            direction: "vertical",
            css: {
                height: "$16"
            }
        },
        {
            size: 18,
            direction: "horizontal",
            css: {
                width: "$18"
            }
        },
        {
            size: 18,
            direction: "vertical",
            css: {
                height: "$18"
            }
        },
        {
            size: 20,
            direction: "horizontal",
            css: {
                width: "$20"
            }
        },
        {
            size: 20,
            direction: "vertical",
            css: {
                height: "$20"
            }
        },
        {
            size: 24,
            direction: "horizontal",
            css: {
                width: "$24"
            }
        },
        {
            size: 24,
            direction: "vertical",
            css: {
                height: "$24"
            }
        }
    ]
});
function $1d5571bdb4f0e237$export$d7a54cba636a8cd6(_ref) {
    var _ref$size = _ref.size, size = _ref$size === void 0 ? 12 : _ref$size, _ref$direction = _ref.direction, direction = _ref$direction === void 0 ? "horizontal" : _ref$direction;
    return (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($1d5571bdb4f0e237$var$SpacerContainer, {
        size: size,
        direction: direction
    });
}
var $1d5571bdb4f0e237$var$MainContainer = /*#__PURE__*/ $1d5571bdb4f0e237$export$3817b7a54a07cec7("div", {
    width: "100%",
    padding: "$16",
    borderRadius: "$5",
    backgroundColor: "$neutral100",
    color: "$neutral800",
    ".main": {
        display: "flex",
        alignItems: "center"
    },
    ".footer": {
        paddingTop: "$8"
    },
    "&.hasIcon .footer": {
        paddingLeft: "$32"
    },
    variants: {
        type: {
            primary: {
                color: "$primary200"
            },
            secondary: {
                color: "$foreground"
            },
            success: {
                color: "$success300"
            },
            warning: {
                color: "$warning500"
            },
            error: {
                color: "$error300"
            }
        }
    }
});
function $1d5571bdb4f0e237$export$caec2af78bcc877f(props) {
    var type = props.type, children = props.children, title = props.title;
    var showIcon = [
        "error",
        "success",
        "warning"
    ].includes(type);
    return (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($1d5571bdb4f0e237$var$MainContainer, {
        type: type,
        className: showIcon ? "hasIcon" : ""
    }, (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("div", {
        className: "main"
    }, showIcon && (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).Fragment, null, (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("div", {
        style: {
            width: "32px",
            display: "flex",
            justifyContent: "center",
            alignItems: "center"
        }
    }, type === "success" && (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($1d5571bdb4f0e237$export$f6dd727656c97851, {
        color: type,
        size: 24
    }), type === "warning" && (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($1d5571bdb4f0e237$export$f7dc499a72baa103, {
        color: type,
        size: 24
    }), type === "error" && (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($1d5571bdb4f0e237$export$235e99e4cce237dc, {
        color: type,
        size: 24
    }), (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($1d5571bdb4f0e237$export$d7a54cba636a8cd6, {
        size: 4
    }))), (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("div", {
        style: {
            display: "flex",
            justifyContent: "center",
            alignItems: "start",
            flexDirection: "column",
            width: "100%"
        }
    }, title && (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).Fragment, null, (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($1d5571bdb4f0e237$export$1c6175f3aa4394b7, {
        className: "title",
        variant: "title",
        color: type
    }, title), !!children && (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($1d5571bdb4f0e237$export$d7a54cba636a8cd6, {
        size: 4,
        direction: "vertical"
    })), children)), props.footer ? (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("div", {
        className: "footer"
    }, props.footer) : null);
}
function $1d5571bdb4f0e237$export$30df457ae27d9539() {
    return (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($1d5571bdb4f0e237$export$caec2af78bcc877f, {
        type: "error",
        title: " Error connecting server, please reload the app and try again."
    });
}
function $1d5571bdb4f0e237$var$NotFoundAlert(props) {
    var catergory = props.catergory, searchedFor = props.searchedFor;
    return (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($1d5571bdb4f0e237$export$caec2af78bcc877f, {
        type: "secondary",
        title: catergory + " " + (searchedFor ? "'" + searchedFor + "'" : "") + " not found."
    });
}
function $1d5571bdb4f0e237$var$VirtualizedList(props) {
    var itemCount = props.itemCount, hasNextPage = props.hasNextPage, loadNextPage = props.loadNextPage, Item = props.Item, innerElementType = props.innerElementType, size = props.size;
    var isItemLoaded = function isItemLoaded(index) {
        return !hasNextPage || index < itemCount;
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $745f79e052554264$export$2e2bcd8739ae039), null, function(_ref) {
        var width = _ref.width, height = _ref.height;
        return (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $5c6694274ebe20d5$export$2e2bcd8739ae039), {
            isItemLoaded: isItemLoaded,
            itemCount: hasNextPage ? itemCount + 1 : itemCount,
            loadMoreItems: loadNextPage,
            threshold: 1
        }, function(_ref2) {
            var onItemsRendered = _ref2.onItemsRendered, ref = _ref2.ref;
            return (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $3cc8a1e45b82291d$export$d8ac3b6b20be856e), {
                innerElementType: innerElementType,
                ref: ref,
                itemSize: function itemSize() {
                    return size;
                },
                itemCount: itemCount,
                height: height || 0,
                width: width || 0,
                onItemsRendered: onItemsRendered
            }, function(_ref3) {
                var index = _ref3.index, style = _ref3.style;
                return isItemLoaded(index) ? (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement(Item, {
                    index: index,
                    style: style
                }) : null;
            });
        });
    });
}
var $1d5571bdb4f0e237$var$TokenImageContainer = /*#__PURE__*/ $1d5571bdb4f0e237$export$3817b7a54a07cec7("div", {
    paddingRight: "$16"
});
var $1d5571bdb4f0e237$var$TokenNameContainer = /*#__PURE__*/ $1d5571bdb4f0e237$export$3817b7a54a07cec7("div", {
    display: "flex",
    flexDirection: "column"
});
var $1d5571bdb4f0e237$var$TokenAmountContainer = /*#__PURE__*/ $1d5571bdb4f0e237$export$3817b7a54a07cec7("div", {
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-end"
});
function $1d5571bdb4f0e237$var$TokenItem(props) {
    var _token$balance;
    var token = props.token, style = props.style, onClick = props.onClick, selected = props.selected;
    return (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("div", {
        style: $1d5571bdb4f0e237$var$_extends({
            display: "flex",
            alignItems: "center",
            width: "100%"
        }, style, {
            height: "48px",
            top: parseFloat(style == null ? void 0 : style.top) + 0 + "px",
            padding: "0 4px"
        })
    }, (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($1d5571bdb4f0e237$export$353f5b6fc5456de1, {
        variant: "outlined",
        size: "large",
        align: "start",
        onClick: onClick.bind(null, token),
        type: selected ? "primary" : undefined,
        prefix: (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($1d5571bdb4f0e237$var$TokenImageContainer, null, (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($1d5571bdb4f0e237$export$3e431a229df88919, {
            src: token.image,
            size: 32
        })),
        suffix: ((_token$balance = token.balance) == null ? void 0 : _token$balance.amount) && (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($1d5571bdb4f0e237$var$TokenAmountContainer, null, (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($1d5571bdb4f0e237$export$1c6175f3aa4394b7, {
            variant: "body2"
        }, token.balance.amount), (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($1d5571bdb4f0e237$export$1c6175f3aa4394b7, {
            variant: "caption"
        }, token.balance.usdValue + "$"))
    }, (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($1d5571bdb4f0e237$var$TokenNameContainer, null, (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($1d5571bdb4f0e237$export$1c6175f3aa4394b7, {
        variant: "body1"
    }, token.symbol), (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($1d5571bdb4f0e237$export$1c6175f3aa4394b7, {
        variant: "caption",
        color: "neutral600"
    }, token.name))));
}
var $1d5571bdb4f0e237$var$_excluded$H = [
    "style"
];
var $1d5571bdb4f0e237$var$PAGE_SIZE = 20;
function $1d5571bdb4f0e237$export$24d4785067273813(props) {
    var list = props.list, searchedText = props.searchedText, onChange = props.onChange, multiSelect = props.multiSelect, selectedList = props.selectedList;
    var _useState = (0, $bh6RR.useState)(props.selected), selected = _useState[0], setSelected = _useState[1];
    var changeSelected = function changeSelected(token) {
        setSelected(token);
        onChange(token);
    };
    var isSelected = function isSelected(token) {
        if (multiSelect && selectedList) return selectedList.map(function(item) {
            return item.symbol + item.address;
        }).indexOf(token.symbol + token.address) > -1;
        return (selected == null ? void 0 : selected.symbol) === token.symbol && (selected == null ? void 0 : selected.address) === token.address;
    };
    var _useState2 = (0, $bh6RR.useState)(true), hasNextPage = _useState2[0], setHasNextPage = _useState2[1];
    var _useState3 = (0, $bh6RR.useState)(list), tokens = _useState3[0], setTokens = _useState3[1];
    var loadNextPage = function loadNextPage() {
        setTokens(list.slice(0, tokens.length + $1d5571bdb4f0e237$var$PAGE_SIZE));
    };
    (0, $bh6RR.useEffect)(function() {
        setTokens(list.slice(0, $1d5571bdb4f0e237$var$PAGE_SIZE));
    }, [
        searchedText,
        list
    ]);
    (0, $bh6RR.useEffect)(function() {
        setHasNextPage(list.length > tokens.length);
    }, [
        tokens.length
    ]);
    var innerElementType = (0, $bh6RR.forwardRef)(function(_ref, ref) {
        var style = _ref.style, rest = $1d5571bdb4f0e237$var$_objectWithoutPropertiesLoose(_ref, $1d5571bdb4f0e237$var$_excluded$H);
        return (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("div", Object.assign({
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            ref: ref,
            style: $1d5571bdb4f0e237$var$_extends({}, style, {
                height: parseFloat(style == null ? void 0 : style.height) + 16 + "px"
            })
        }, rest));
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($1d5571bdb4f0e237$var$VirtualizedList, {
        Item: function Item(_ref2) {
            var index = _ref2.index, style = _ref2.style;
            return (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($1d5571bdb4f0e237$var$TokenItem, {
                token: tokens[index],
                style: style,
                onClick: changeSelected,
                selected: isSelected(tokens[index])
            });
        },
        hasNextPage: hasNextPage,
        itemCount: tokens.length,
        loadNextPage: loadNextPage,
        innerElementType: innerElementType,
        size: 56
    });
}
var $1d5571bdb4f0e237$var$LoaderContainer = /*#__PURE__*/ $1d5571bdb4f0e237$export$3817b7a54a07cec7("div", {
    display: "flex",
    justifyContent: "center",
    width: "100%",
    paddingTop: "33%",
    flex: 1
});
var $1d5571bdb4f0e237$var$filterTokens = function filterTokens(list, searchedFor) {
    return list.filter(function(token) {
        return $1d5571bdb4f0e237$var$containsText(token.symbol, searchedFor) || $1d5571bdb4f0e237$var$containsText(token.address || "", searchedFor) || $1d5571bdb4f0e237$var$containsText(token.name || "", searchedFor);
    });
};
function $1d5571bdb4f0e237$export$6f653acab4a8965a(props) {
    var list = props.list, type = props.type, selected = props.selected, hasHeader = props.hasHeader, onChange = props.onChange, onBack = props.onBack, loadingStatus = props.loadingStatus;
    return (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($1d5571bdb4f0e237$export$791bf2dc0030f14c, {
        textField: true,
        hasHeader: hasHeader,
        title: "Select " + type + " token",
        onBack: onBack,
        textFieldPlaceholder: "Search tokens by name"
    }, function(searchedFor) {
        var filteredTokens = $1d5571bdb4f0e237$var$filterTokens(list, searchedFor);
        return loadingStatus === "loading" ? (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($1d5571bdb4f0e237$var$LoaderContainer, null, (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($1d5571bdb4f0e237$export$7f7cbe89f1eacd2, {
            size: 24
        })) : loadingStatus === "failed" ? (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($1d5571bdb4f0e237$export$30df457ae27d9539, null) : filteredTokens.length ? (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($1d5571bdb4f0e237$export$24d4785067273813, {
            searchedText: searchedFor,
            list: filteredTokens,
            selected: selected,
            onChange: onChange
        }) : (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($1d5571bdb4f0e237$var$NotFoundAlert, {
            catergory: "Token",
            searchedFor: searchedFor
        });
    });
}
var $1d5571bdb4f0e237$var$ListContainer$1 = /*#__PURE__*/ $1d5571bdb4f0e237$export$3817b7a54a07cec7("div", {
    overflowY: "auto",
    padding: "0 $4"
});
var $1d5571bdb4f0e237$var$filterBlockchains = function filterBlockchains(list, searchedFor) {
    return list.filter(function(blockchain) {
        return $1d5571bdb4f0e237$var$containsText(blockchain.name, searchedFor) || $1d5571bdb4f0e237$var$containsText(blockchain.displayName, searchedFor);
    });
};
function $1d5571bdb4f0e237$export$fc99270a3593f270(props) {
    var type = props.type, list = props.list, onChange = props.onChange, selected = props.selected, onBack = props.onBack, loadingStatus = props.loadingStatus, hasHeader = props.hasHeader, listContainerStyle = props.listContainerStyle, multiSelect = props.multiSelect, selectedList = props.selectedList;
    return (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($1d5571bdb4f0e237$export$791bf2dc0030f14c, {
        textField: true,
        hasHeader: hasHeader,
        textFieldPlaceholder: "Search blockchains by name",
        title: "Select " + type + " Blockchain",
        onBack: onBack
    }, function(searchedFor) {
        var filteredBlockchains = $1d5571bdb4f0e237$var$filterBlockchains(list, searchedFor);
        return (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).Fragment, null, loadingStatus === "loading" && (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($1d5571bdb4f0e237$var$LoaderContainer, null, (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($1d5571bdb4f0e237$export$7f7cbe89f1eacd2, {
            size: 24
        })), (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($1d5571bdb4f0e237$var$ListContainer$1, {
            style: listContainerStyle,
            key: "1"
        }, loadingStatus === "failed" && (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($1d5571bdb4f0e237$export$30df457ae27d9539, null), loadingStatus === "success" && (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).Fragment, null, filteredBlockchains.length ? (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($1d5571bdb4f0e237$var$BlockchainsList, {
            list: filteredBlockchains,
            selected: selected,
            multiSelect: multiSelect,
            selectedList: selectedList,
            onChange: onChange
        }) : (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($1d5571bdb4f0e237$var$NotFoundAlert, {
            catergory: "Blockchain",
            searchedFor: searchedFor
        }))));
    });
}
var $1d5571bdb4f0e237$var$_excluded$I = [
    "label",
    "id"
];
var $1d5571bdb4f0e237$var$CheckboxContainer = /*#__PURE__*/ $1d5571bdb4f0e237$export$3817b7a54a07cec7("div", {
    display: "flex",
    alignItems: "center"
});
var $1d5571bdb4f0e237$var$CheckboxRoot = /*#__PURE__*/ $1d5571bdb4f0e237$export$3817b7a54a07cec7((0, $25220ff17b40fd53$export$be92b6f5f03c0fe9), {
    borderRadius: "5px",
    width: 20,
    padding: 0,
    height: 20,
    border: "1px solid $foreground",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    marginRight: "$2",
    backgroundColor: "$neutral-100",
    cursor: "pointer"
});
var $1d5571bdb4f0e237$var$Label$1 = /*#__PURE__*/ $1d5571bdb4f0e237$export$3817b7a54a07cec7("label", {
    color: "$foreground",
    fontSize: "$m",
    marginLeft: "$8",
    cursor: "pointer"
});
function $1d5571bdb4f0e237$export$48513f6b9f8ce62d(_ref) {
    var label = _ref.label, id = _ref.id, props = $1d5571bdb4f0e237$var$_objectWithoutPropertiesLoose(_ref, $1d5571bdb4f0e237$var$_excluded$I);
    return (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($1d5571bdb4f0e237$var$CheckboxContainer, null, (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($1d5571bdb4f0e237$var$CheckboxRoot, Object.assign({
        id: id
    }, props), (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $25220ff17b40fd53$export$adb584737d712b70), null, (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($1d5571bdb4f0e237$export$7dd004358974b05d, {
        size: 20
    }))), (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($1d5571bdb4f0e237$var$Label$1, {
        className: "_text",
        htmlFor: id
    }, label));
}
var $1d5571bdb4f0e237$var$ChipCointainer = /*#__PURE__*/ $1d5571bdb4f0e237$export$3817b7a54a07cec7("div", {
    display: "inline-flex",
    justifyContent: "center",
    alignItems: "center",
    borderRadius: "$5",
    padding: "$4 $8",
    height: "32",
    fontSize: "$14",
    cursor: "pointer",
    transition: "all 0.35s",
    color: "$foreground",
    "&:hover": {
        backgroundColor: "$success700",
        color: "$background"
    },
    variants: {
        selected: {
            "true": {
                backgroundColor: "$success",
                color: "$background"
            },
            "false": {
                backgroundColor: "$surface"
            }
        }
    }
});
function $1d5571bdb4f0e237$export$5a7f9a6004988d01(props) {
    var label = props.label, selected = props.selected, prefix = props.prefix, suffix = props.suffix, onClick = props.onClick, style = props.style;
    return (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($1d5571bdb4f0e237$var$ChipCointainer, {
        selected: selected,
        onClick: onClick,
        style: style
    }, prefix || null, label, suffix || null);
}
var $1d5571bdb4f0e237$var$BackDrop = /*#__PURE__*/ $1d5571bdb4f0e237$export$3817b7a54a07cec7("div", {
    position: "fixed",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    top: "0",
    left: "0",
    width: "100vw",
    height: "100vh",
    backgroundColor: "rgba(0,0,0,.1)",
    zIndex: 10
});
var $1d5571bdb4f0e237$var$ModalContainer = /*#__PURE__*/ $1d5571bdb4f0e237$export$3817b7a54a07cec7("div", {
    backgroundColor: "$background",
    borderRadius: "$10",
    padding: "$16 $16",
    display: "flex",
    flexDirection: "column",
    zIndex: 20
});
var $1d5571bdb4f0e237$var$Row = /*#__PURE__*/ $1d5571bdb4f0e237$export$3817b7a54a07cec7("div", {
    display: "flex",
    alignItems: "center"
});
var $1d5571bdb4f0e237$var$ModalHeader = /*#__PURE__*/ $1d5571bdb4f0e237$export$3817b7a54a07cec7("div", {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    position: "relative",
    marginBottom: "$16"
});
function $1d5571bdb4f0e237$export$2b77a92f1a5ad772(props) {
    var title = props.title, content = props.content, open = props.open, onClose = props.onClose, containerStyle = props.containerStyle, action = props.action;
    var handleBackDropClick = function handleBackDropClick(event) {
        if (event.target === event.currentTarget) onClose();
    };
    (0, $bh6RR.useEffect)(function() {
        if (open) document.body.style.overflow = "hidden";
        else document.body.style.overflow = "unset";
    }, [
        open
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).Fragment, null, open && (0, $47cfd4084854a574$exports.createPortal)((0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($1d5571bdb4f0e237$var$BackDrop, {
        onClick: handleBackDropClick
    }, (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($1d5571bdb4f0e237$var$ModalContainer, {
        style: containerStyle
    }, (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($1d5571bdb4f0e237$var$ModalHeader, null, (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($1d5571bdb4f0e237$export$1c6175f3aa4394b7, {
        variant: "h4"
    }, title), (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($1d5571bdb4f0e237$var$Row, null, action, (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($1d5571bdb4f0e237$export$cae179f078f4b4a4, {
        size: 24,
        onClick: onClose
    }))), content)), document.body));
}
var $1d5571bdb4f0e237$export$ba984d729fe7282e;
(function(WalletState) {
    WalletState["NOT_INSTALLED"] = "not installed";
    WalletState["DISCONNECTED"] = "disconnected";
    WalletState["CONNECTING"] = "connecting";
    WalletState["CONNECTED"] = "connected";
})($1d5571bdb4f0e237$export$ba984d729fe7282e || ($1d5571bdb4f0e237$export$ba984d729fe7282e = {}));
var $1d5571bdb4f0e237$var$StateIconContainer = /*#__PURE__*/ $1d5571bdb4f0e237$export$3817b7a54a07cec7("span", {
    display: "flex",
    justifyContent: "center",
    alignItems: "center"
});
var $1d5571bdb4f0e237$var$State = function State(_ref) {
    var walletState = _ref.walletState, installLink = _ref.installLink;
    return (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $bh6RR.Fragment), null, walletState !== $1d5571bdb4f0e237$export$ba984d729fe7282e.DISCONNECTED && (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($1d5571bdb4f0e237$var$StateIconContainer, null, walletState === $1d5571bdb4f0e237$export$ba984d729fe7282e.NOT_INSTALLED && (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("a", {
        href: (0, $341e29ad9d46e7f7$export$fd0008baca2bf83d)(installLink),
        target: "_blank"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($1d5571bdb4f0e237$export$4e54df4252b4a99c, {
        size: 24,
        color: "success"
    })), walletState === $1d5571bdb4f0e237$export$ba984d729fe7282e.CONNECTING && (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($1d5571bdb4f0e237$export$7f7cbe89f1eacd2, null), walletState === $1d5571bdb4f0e237$export$ba984d729fe7282e.CONNECTED && (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($1d5571bdb4f0e237$export$541a84723b7db0e9, null)));
};
var $1d5571bdb4f0e237$var$WalletImageContainer = /*#__PURE__*/ $1d5571bdb4f0e237$export$3817b7a54a07cec7("div", {
    paddingRight: "$12",
    "& img": {
        borderRadius: "50%"
    }
});
var $1d5571bdb4f0e237$var$Text = /*#__PURE__*/ $1d5571bdb4f0e237$export$3817b7a54a07cec7("div", {
    display: "flex",
    flexDirection: "column"
});
var $1d5571bdb4f0e237$var$ExtendedButton = /*#__PURE__*/ $1d5571bdb4f0e237$export$3817b7a54a07cec7($1d5571bdb4f0e237$export$353f5b6fc5456de1, {
    variants: {
        type: {
            primary: {
                outline: "1px solid $primary",
                borderColor: "$primary",
                "&:hover": {
                    borderColor: "$primary"
                }
            }
        }
    }
});
function $1d5571bdb4f0e237$export$bcca3ea514774656(props) {
    var name = props.name, type = props.type, image = props.image, state = props.state, _onClick = props.onClick, installLink = props.installLink;
    return (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($1d5571bdb4f0e237$var$ExtendedButton, {
        type: state === $1d5571bdb4f0e237$export$ba984d729fe7282e.CONNECTED ? "primary" : undefined,
        disabled: state == $1d5571bdb4f0e237$export$ba984d729fe7282e.CONNECTING,
        onClick: function onClick() {
            if (state === $1d5571bdb4f0e237$export$ba984d729fe7282e.NOT_INSTALLED) window.open((0, $341e29ad9d46e7f7$export$fd0008baca2bf83d)(installLink), "_blank");
            else _onClick(type);
        },
        align: "start",
        variant: "outlined",
        size: "large",
        prefix: (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($1d5571bdb4f0e237$var$WalletImageContainer, null, (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($1d5571bdb4f0e237$export$3e431a229df88919, {
            src: image,
            size: 24
        })),
        suffix: (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($1d5571bdb4f0e237$var$State, {
            walletState: state,
            installLink: installLink
        })
    }, (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($1d5571bdb4f0e237$var$Text, null, (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($1d5571bdb4f0e237$export$1c6175f3aa4394b7, {
        variant: "h5",
        noWrap: false
    }, name), state === $1d5571bdb4f0e237$export$ba984d729fe7282e.CONNECTED ? (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($1d5571bdb4f0e237$export$1c6175f3aa4394b7, {
        variant: "caption",
        noWrap: false,
        color: "primary"
    }, "Connected") : null));
}
var $1d5571bdb4f0e237$var$ModalContent = /*#__PURE__*/ $1d5571bdb4f0e237$export$3817b7a54a07cec7("div", {
    display: "grid",
    gap: "$8",
    gridTemplateColumns: "repeat(2, minmax(0, 1fr))"
});
function $1d5571bdb4f0e237$export$716151ac6ec086e5(props) {
    var open = props.open, list = props.list, onSelect = props.onSelect, onClose = props.onClose;
    var Content = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($1d5571bdb4f0e237$var$ModalContent, null, list.map(function(info, index) {
        return (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($1d5571bdb4f0e237$export$bcca3ea514774656, Object.assign({}, info, {
            key: index,
            onClick: onSelect
        }));
    }));
    return (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($1d5571bdb4f0e237$export$2b77a92f1a5ad772, {
        title: "Connect Wallets",
        open: open,
        content: Content,
        onClose: onClose,
        containerStyle: {
            width: "75%",
            maxWidth: "30rem",
            height: "70%"
        }
    });
}
var $1d5571bdb4f0e237$var$StyledSwitchRoot = /*#__PURE__*/ $1d5571bdb4f0e237$export$3817b7a54a07cec7((0, $172ff4f047b7b6ce$export$be92b6f5f03c0fe9), {
    boxSizing: "border-box",
    boxShadow: "none",
    borderStyle: "solid",
    width: "42px",
    height: "22px",
    backgroundColor: "$neutral600",
    borderColor: "$neutral600",
    borderRadius: "99999px",
    position: "relative",
    padding: "0",
    cursor: "pointer",
    '&[data-state="checked"]': {
        backgroundColor: "$success",
        borderColor: "$success"
    },
    "-webkit-tap-highlight-color": "rgba(0, 0, 0, 0)"
});
var $1d5571bdb4f0e237$var$StyledSwitchThumb = /*#__PURE__*/ $1d5571bdb4f0e237$export$3817b7a54a07cec7((0, $172ff4f047b7b6ce$export$6521433ed15a34db), {
    position: "absolute",
    top: "0",
    boxSizing: "border-box",
    display: "block",
    width: "18px",
    height: "18px",
    backgroundColor: "$white",
    transition: " transform 300ms",
    borderRadius: "999999px",
    willChange: "transform",
    '&[data-state="checked"]': {
        transform: "translateX(20px)"
    }
});
function $1d5571bdb4f0e237$export$b5d5cf8927ab7262(props) {
    var checked = props.checked, onChange = props.onChange;
    return (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($1d5571bdb4f0e237$var$StyledSwitchRoot, {
        checked: checked,
        onCheckedChange: onChange
    }, (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($1d5571bdb4f0e237$var$StyledSwitchThumb, null));
}
var $1d5571bdb4f0e237$var$groupLiquiditySources = function groupLiquiditySources(liquiditySources) {
    return {
        bridge: liquiditySources.filter(function(liquiditySource) {
            return liquiditySource.type === "BRIDGE" || liquiditySource.type === "AGGREGATOR";
        }),
        exchange: liquiditySources.filter(function(liquiditySource) {
            return liquiditySource.type === "DEX";
        })
    };
};
var $1d5571bdb4f0e237$var$MainContainer$1 = /*#__PURE__*/ $1d5571bdb4f0e237$export$3817b7a54a07cec7("div", {
    variants: {
        loaded: {
            "true": {
                overflowY: "auto",
                padding: "0 $4"
            }
        }
    }
});
var $1d5571bdb4f0e237$var$LiquiditySourceType = /*#__PURE__*/ $1d5571bdb4f0e237$export$3817b7a54a07cec7("div", {
    position: "sticky",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    top: "0",
    backgroundColor: "$background",
    zIndex: "9999",
    paddingTop: "$8",
    paddingBottom: "$8"
});
var $1d5571bdb4f0e237$var$LiquidityImageContainer = /*#__PURE__*/ $1d5571bdb4f0e237$export$3817b7a54a07cec7("div", {
    paddingRight: "$16"
});
var $1d5571bdb4f0e237$var$LoaderContainer$1 = /*#__PURE__*/ $1d5571bdb4f0e237$export$3817b7a54a07cec7("div", {
    display: "flex",
    justifyContent: "center"
});
function $1d5571bdb4f0e237$var$LiquiditySourceList(props) {
    var list = props.list, onChange = props.onChange, listContainerStyle = props.listContainerStyle, loadingStatus = props.loadingStatus, searchedFor = props.searchedFor;
    var _useState = (0, $bh6RR.useState)(list.filter(function(item) {
        return item.selected;
    })), selected = _useState[0], setSelected = _useState[1];
    var changeLiquiditySources = function changeLiquiditySources(clickedItem) {
        clickedItem.selected = !clickedItem.selected;
        setSelected(function(prevState) {
            if (clickedItem.selected) return [].concat(prevState, [
                clickedItem
            ]);
            return prevState.filter(function(item) {
                return item.title != clickedItem.title;
            });
        });
        onChange(clickedItem);
    };
    var isSelected = function isSelected(liquiditySource) {
        return !!selected.find(function(item) {
            return liquiditySource.title === item.title;
        });
    };
    (0, $bh6RR.useEffect)(function() {
        setSelected(list.filter(function(item) {
            return item.selected;
        }));
    }, [
        list
    ]);
    var sections = $1d5571bdb4f0e237$var$groupLiquiditySources(list);
    var bridges = sections.bridge;
    var exchanges = sections.exchange;
    var totalBridges = bridges.length;
    var totalExchanges = exchanges.length;
    // TODO: This is not performant
    var totalSelectedBridges = bridges.filter(isSelected).length;
    var totalSelectedExchanges = exchanges.filter(isSelected).length;
    return (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($1d5571bdb4f0e237$var$MainContainer$1, {
        style: listContainerStyle,
        loaded: loadingStatus === "success"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("div", null, (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($1d5571bdb4f0e237$var$LiquiditySourceType, null, (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($1d5571bdb4f0e237$export$1c6175f3aa4394b7, {
        variant: "h5"
    }, "Bridges"), (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($1d5571bdb4f0e237$export$1c6175f3aa4394b7, {
        variant: "body1",
        color: "neutral800"
    }, totalSelectedBridges === totalBridges ? totalBridges : totalSelectedBridges + " / " + totalBridges)), (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($1d5571bdb4f0e237$export$d7a54cba636a8cd6, {
        size: 12,
        direction: "vertical"
    }), loadingStatus === "loading" && (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($1d5571bdb4f0e237$var$LoaderContainer$1, null, (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($1d5571bdb4f0e237$export$7f7cbe89f1eacd2, {
        size: 24
    })), loadingStatus === "failed" && (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($1d5571bdb4f0e237$export$30df457ae27d9539, null), loadingStatus === "success" && (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).Fragment, null, totalBridges ? bridges.map(function(liquiditySource, index) {
        return (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($1d5571bdb4f0e237$var$LiquiditySourceItem, {
            liquiditySource: liquiditySource,
            key: index,
            selected: isSelected(liquiditySource),
            onChange: changeLiquiditySources
        });
    }) : (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($1d5571bdb4f0e237$var$NotFoundAlert, {
        catergory: "Bridge",
        searchedFor: searchedFor
    }))), (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("div", null, (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($1d5571bdb4f0e237$var$LiquiditySourceType, null, (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($1d5571bdb4f0e237$export$1c6175f3aa4394b7, {
        variant: "h5"
    }, "Exchanges"), (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($1d5571bdb4f0e237$export$1c6175f3aa4394b7, {
        variant: "body1",
        color: "neutral800"
    }, totalSelectedExchanges === totalExchanges ? totalExchanges : totalSelectedExchanges + " / " + totalExchanges)), (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($1d5571bdb4f0e237$export$d7a54cba636a8cd6, {
        size: 12,
        direction: "vertical"
    }), loadingStatus === "loading" && (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($1d5571bdb4f0e237$var$LoaderContainer$1, null, (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($1d5571bdb4f0e237$export$7f7cbe89f1eacd2, {
        size: 24
    })), loadingStatus === "failed" && (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($1d5571bdb4f0e237$export$30df457ae27d9539, null), loadingStatus == "success" && (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).Fragment, null, totalExchanges ? exchanges.map(function(liquiditySource, index) {
        return (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($1d5571bdb4f0e237$var$LiquiditySourceItem, {
            liquiditySource: liquiditySource,
            key: index,
            selected: isSelected(liquiditySource),
            onChange: changeLiquiditySources
        });
    }) : (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($1d5571bdb4f0e237$var$NotFoundAlert, {
        catergory: "Exchange",
        searchedFor: searchedFor
    }))));
}
var $1d5571bdb4f0e237$var$LiquiditySourceItem = function LiquiditySourceItem(_ref) {
    var liquiditySource = _ref.liquiditySource, selected = _ref.selected, onChange = _ref.onChange;
    return (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($1d5571bdb4f0e237$export$353f5b6fc5456de1, {
        size: "large",
        align: "start",
        variant: "outlined",
        prefix: (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($1d5571bdb4f0e237$var$LiquidityImageContainer, null, (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($1d5571bdb4f0e237$export$3e431a229df88919, {
            src: liquiditySource.logo,
            size: 20
        })),
        suffix: (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($1d5571bdb4f0e237$export$b5d5cf8927ab7262, {
            checked: selected
        }),
        style: {
            marginBottom: "12px"
        },
        onClick: onChange.bind(null, liquiditySource)
    }, (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($1d5571bdb4f0e237$export$1c6175f3aa4394b7, {
        variant: "body1"
    }, liquiditySource.title));
};
var $1d5571bdb4f0e237$var$filterLiquiditySources = function filterLiquiditySources(liquiditySources, searchedFor) {
    return liquiditySources.filter(function(liquiditySource) {
        return $1d5571bdb4f0e237$var$containsText(liquiditySource.title, searchedFor || "");
    });
};
function $1d5571bdb4f0e237$export$614fcb125bb4acc5(props) {
    var list = props.list, onChange = props.onChange, onBack = props.onBack, hasHeader = props.hasHeader, listContainerStyle = props.listContainerStyle, toggleAll = props.toggleAll, loadingStatus = props.loadingStatus;
    return (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($1d5571bdb4f0e237$export$791bf2dc0030f14c, {
        textField: true,
        textFieldPlaceholder: "Search by name",
        title: "Liquidity Sources",
        TopButton: (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($1d5571bdb4f0e237$export$353f5b6fc5456de1, {
            variant: "ghost",
            type: "primary",
            onClick: toggleAll
        }, list.find(function(item) {
            return item.selected;
        }) ? "Deselect all" : "Select all"),
        hasHeader: hasHeader,
        onBack: onBack
    }, function(searchedFor) {
        return (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($1d5571bdb4f0e237$var$LiquiditySourceList, {
            listContainerStyle: listContainerStyle,
            list: $1d5571bdb4f0e237$var$filterLiquiditySources(list, searchedFor),
            onChange: onChange,
            loadingStatus: loadingStatus,
            searchedFor: searchedFor
        });
    });
}
var $1d5571bdb4f0e237$var$Row$1 = /*#__PURE__*/ $1d5571bdb4f0e237$export$3817b7a54a07cec7("div", {
    display: "flex",
    flexWrap: "wrap"
});
var $1d5571bdb4f0e237$var$Circle = /*#__PURE__*/ $1d5571bdb4f0e237$export$3817b7a54a07cec7("div", {
    width: 12,
    height: 12,
    borderRadius: 6,
    border: "1px solid $neutral400",
    position: "absolute",
    top: 12,
    right: 12,
    variants: {
        checked: {
            "true": {
                borderColor: "$success"
            },
            "false": {
                borderColor: "$neutral400"
            }
        }
    }
});
var $1d5571bdb4f0e237$var$SolidCircle = /*#__PURE__*/ $1d5571bdb4f0e237$export$3817b7a54a07cec7("div", {
    width: 6,
    margin: "20% auto",
    height: 6,
    borderRadius: 3,
    variants: {
        checked: {
            "true": {
                backgroundColor: "$success"
            },
            "false": {
                backgroundColor: "$neutral400"
            }
        }
    }
});
var $1d5571bdb4f0e237$var$Container$1 = /*#__PURE__*/ $1d5571bdb4f0e237$export$3817b7a54a07cec7("div", {
    border: "1.5px solid",
    borderRadius: "$5",
    padding: "$12",
    flexBasis: "calc(33.33% - 10px)",
    margin: 5,
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    width: 124,
    height: 92,
    cursor: "pointer",
    position: "relative",
    variants: {
        checked: {
            "true": {
                borderColor: "$success",
                color: "$success"
            },
            "false": {
                borderColor: "$neutral400",
                color: "$neutral400"
            }
        }
    }
});
function $1d5571bdb4f0e237$export$933a707227f480b4(_ref) {
    var _list$find;
    var list = _ref.list, onChange = _ref.onChange;
    var _useState = (0, $bh6RR.useState)(((_list$find = list.find(function(item) {
        return item.selected;
    })) == null ? void 0 : _list$find.walletType) || ""), active = _useState[0], setActive = _useState[1];
    var onClick = function onClick(w) {
        setActive(w.walletType);
        onChange(w);
    };
    (0, $bh6RR.useEffect)(function() {
        var _list$find2;
        setActive(((_list$find2 = list.find(function(item) {
            return item.selected;
        })) == null ? void 0 : _list$find2.walletType) || "");
    }, [
        list
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($1d5571bdb4f0e237$var$Row$1, null, list.map(function(w, index) {
        var checked = active === w.walletType;
        return (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($1d5571bdb4f0e237$var$Container$1, {
            checked: checked,
            onClick: onClick.bind(null, w),
            key: index
        }, (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($1d5571bdb4f0e237$export$3e431a229df88919, {
            src: w.image,
            alt: w.walletType,
            size: 24
        }), (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($1d5571bdb4f0e237$export$1c6175f3aa4394b7, {
            variant: "body2"
        }, w.name), (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($1d5571bdb4f0e237$export$1c6175f3aa4394b7, {
            variant: "caption"
        }, $1d5571bdb4f0e237$var$getConciseAddress(w.address)), (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($1d5571bdb4f0e237$var$Circle, {
            checked: checked
        }, (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($1d5571bdb4f0e237$var$SolidCircle, {
            checked: checked
        })));
    }));
}
var $1d5571bdb4f0e237$var$StyledRoot = /*#__PURE__*/ $1d5571bdb4f0e237$export$3817b7a54a07cec7((0, $a0caedef5e243859$export$be92b6f5f03c0fe9), {
    variants: {
        direction: {
            horizontal: {
                display: "flex",
                flexDirection: "row",
                flexWrap: "wrap"
            },
            vertical: {
                display: "grid",
                gridGap: "$24"
            }
        }
    }
});
var $1d5571bdb4f0e237$var$ItemContainer = /*#__PURE__*/ $1d5571bdb4f0e237$export$3817b7a54a07cec7("div", {
    display: "flex",
    alignItems: "center",
    marginRight: "$8"
});
var $1d5571bdb4f0e237$var$StyledItem = /*#__PURE__*/ $1d5571bdb4f0e237$export$3817b7a54a07cec7((0, $a0caedef5e243859$export$6d08773d2e66f8f2), {
    padding: "0",
    width: "20px",
    height: "20px",
    borderRadius: "100%",
    cursor: "pointer",
    backgroundColor: "$background",
    border: "1px solid $neutral400",
    "&:hover": {
        borderColor: "$neutral600"
    }
});
var $1d5571bdb4f0e237$var$Container$2 = /*#__PURE__*/ $1d5571bdb4f0e237$export$3817b7a54a07cec7("div", {
    display: "flex"
});
var $1d5571bdb4f0e237$var$StyledIndicator = /*#__PURE__*/ $1d5571bdb4f0e237$export$3817b7a54a07cec7((0, $a0caedef5e243859$export$adb584737d712b70), {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: "100%",
    height: "100%",
    position: "relative",
    "&::after": {
        content: "",
        display: "block",
        width: "10px",
        height: "10px",
        borderRadius: "50%",
        backgroundColor: "$success"
    }
});
var $1d5571bdb4f0e237$var$Label$2 = /*#__PURE__*/ $1d5571bdb4f0e237$export$3817b7a54a07cec7("label", {
    paddingLeft: "$8",
    cursor: "pointer",
    color: "$foreground"
});
function $1d5571bdb4f0e237$export$d7b12c4107be0d61(props) {
    var value = props.value, onChange = props.onChange, _props$direction = props.direction, direction = _props$direction === void 0 ? "vertical" : _props$direction, style = props.style;
    return (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($1d5571bdb4f0e237$var$Container$2, null, (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($1d5571bdb4f0e237$var$StyledRoot, {
        onValueChange: onChange,
        value: value,
        direction: direction,
        style: style
    }, props.options.map(function(option, index) {
        return (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($1d5571bdb4f0e237$var$ItemContainer, {
            key: index
        }, (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($1d5571bdb4f0e237$var$StyledItem, {
            value: option.value,
            id: option.value
        }, (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($1d5571bdb4f0e237$var$StyledIndicator, null)), (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($1d5571bdb4f0e237$var$Label$2, {
            className: "_text",
            htmlFor: option.value
        }, (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($1d5571bdb4f0e237$export$1c6175f3aa4394b7, {
            variant: "body2"
        }, option.label)));
    })));
}
var $1d5571bdb4f0e237$var$BaseContainer = /*#__PURE__*/ $1d5571bdb4f0e237$export$3817b7a54a07cec7("div", {
    borderRadius: "$5",
    backgroundColor: "$neutral100",
    padding: "$16"
});
var $1d5571bdb4f0e237$var$Title = /*#__PURE__*/ $1d5571bdb4f0e237$export$3817b7a54a07cec7($1d5571bdb4f0e237$export$1c6175f3aa4394b7, {
    marginBottom: "$16"
});
var $1d5571bdb4f0e237$var$SlippageChipsContainer = /*#__PURE__*/ $1d5571bdb4f0e237$export$3817b7a54a07cec7("div", {
    display: "grid",
    rowGap: "$16",
    gridTemplateColumns: "repeat(auto-fill, 64px)"
});
var $1d5571bdb4f0e237$var$LiquiditySourceContainer = /*#__PURE__*/ $1d5571bdb4f0e237$export$3817b7a54a07cec7($1d5571bdb4f0e237$var$BaseContainer, {
    display: "flex",
    justifyContent: "space-between",
    marginTop: "$16",
    cursor: "pointer"
});
var $1d5571bdb4f0e237$var$InfiniteContainer = /*#__PURE__*/ $1d5571bdb4f0e237$export$3817b7a54a07cec7($1d5571bdb4f0e237$var$BaseContainer, {
    display: "flex",
    justifyContent: "space-between",
    marginTop: "$16"
});
var $1d5571bdb4f0e237$var$StyledAngleRight = /*#__PURE__*/ $1d5571bdb4f0e237$export$3817b7a54a07cec7($1d5571bdb4f0e237$export$f5db305c33b6241b, {
    marginLeft: "$8"
});
var $1d5571bdb4f0e237$var$LiquiditySourceNumber = /*#__PURE__*/ $1d5571bdb4f0e237$export$3817b7a54a07cec7("div", {
    display: "flex",
    alignItems: "center",
    justifyContent: "center"
});
var $1d5571bdb4f0e237$var$ThemesContainer = /*#__PURE__*/ $1d5571bdb4f0e237$export$3817b7a54a07cec7($1d5571bdb4f0e237$var$BaseContainer, {
    marginTop: "$16"
});
var $1d5571bdb4f0e237$var$Head = /*#__PURE__*/ $1d5571bdb4f0e237$export$3817b7a54a07cec7("div", {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    paddingBottom: "$16"
});
function $1d5571bdb4f0e237$export$c72f6eaae7b9adff(props) {
    var slippages = props.slippages, selectedLiquiditySources = props.selectedLiquiditySources, liquiditySources = props.liquiditySources, onSlippageChange = props.onSlippageChange, onLiquiditySourcesClick = props.onLiquiditySourcesClick, onBack = props.onBack, customSlippage = props.customSlippage, onCustomSlippageChange = props.onCustomSlippageChange, maxSlippage = props.maxSlippage, minSlippage = props.minSlippage, selectedTheme = props.selectedTheme, onThemeChange = props.onThemeChange, toggleInfiniteApprove = props.toggleInfiniteApprove, infiniteApprove = props.infiniteApprove, loadingStatus = props.loadingStatus, singleTheme = props.singleTheme;
    var _useState = (0, $bh6RR.useState)(props.selectedSlippage), selectedSlippage = _useState[0], setSelectedSlippage = _useState[1];
    var changeSlippage = function changeSlippage(slippage) {
        setSelectedSlippage(slippage);
        onSlippageChange(slippage);
    };
    var PageContent = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).Fragment, null, (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($1d5571bdb4f0e237$var$BaseContainer, null, (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($1d5571bdb4f0e237$var$Head, null, (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($1d5571bdb4f0e237$export$1c6175f3aa4394b7, {
        variant: "body2"
    }, "Slippage tolerance"), customSlippage ? (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($1d5571bdb4f0e237$export$1c6175f3aa4394b7, {
        variant: "caption",
        color: "error"
    }, customSlippage, "% Custom") : undefined), (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($1d5571bdb4f0e237$var$SlippageChipsContainer, null, slippages.map(function(slippage, index) {
        return (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($1d5571bdb4f0e237$export$5a7f9a6004988d01, {
            key: index,
            onClick: function onClick() {
                if (customSlippage) onCustomSlippageChange(null);
                changeSlippage(slippage);
            },
            selected: !customSlippage && slippage === selectedSlippage,
            label: slippage.toString() + "%",
            style: {
                marginRight: "8px"
            }
        });
    }), (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($1d5571bdb4f0e237$export$2c73285ae9390cec, {
        type: "number",
        value: customSlippage || "",
        onChange: function onChange(event) {
            var parsedValue = parseFloat(event.target.value);
            if (!parsedValue || parsedValue >= minSlippage && parsedValue <= maxSlippage) onCustomSlippageChange(parsedValue);
        },
        suffix: customSlippage && (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($1d5571bdb4f0e237$export$1c6175f3aa4394b7, {
            variant: "body2"
        }, "%"),
        size: "small",
        placeholder: "Custom %",
        style: {
            width: "128px",
            flexGrow: "initial"
        }
    }))), !singleTheme && (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($1d5571bdb4f0e237$var$ThemesContainer, null, (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($1d5571bdb4f0e237$var$Title, {
        variant: "body2"
    }, "Theme"), (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($1d5571bdb4f0e237$export$d7b12c4107be0d61, {
        value: selectedTheme,
        options: [
            {
                value: "dark",
                label: "Dark"
            },
            {
                value: "light",
                label: "Light"
            },
            {
                value: "auto",
                label: "Auto"
            }
        ],
        onChange: function onChange(value) {
            return onThemeChange(value);
        },
        direction: "horizontal",
        style: {
            marginTop: "$24"
        }
    })), (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($1d5571bdb4f0e237$var$InfiniteContainer, null, (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($1d5571bdb4f0e237$export$1c6175f3aa4394b7, {
        variant: "body2"
    }, "Infinite Approval"), (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($1d5571bdb4f0e237$export$b5d5cf8927ab7262, {
        checked: infiniteApprove,
        onChange: toggleInfiniteApprove
    })), (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($1d5571bdb4f0e237$var$LiquiditySourceContainer, null, (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($1d5571bdb4f0e237$export$353f5b6fc5456de1, {
        onClick: onLiquiditySourcesClick,
        align: "start",
        variant: "ghost",
        loading: loadingStatus === "loading",
        suffix: (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($1d5571bdb4f0e237$var$LiquiditySourceNumber, null, loadingStatus === "success" && (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($1d5571bdb4f0e237$export$1c6175f3aa4394b7, {
            variant: "body2",
            color: "neutral800"
        }, liquiditySources.length !== selectedLiquiditySources.length ? selectedLiquiditySources.length + " / " + liquiditySources.length : liquiditySources.length), loadingStatus === "failed" && (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($1d5571bdb4f0e237$export$1c6175f3aa4394b7, {
            variant: "body2",
            color: "$error500"
        }, "Loading failed"), (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($1d5571bdb4f0e237$var$StyledAngleRight, null))
    }, (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($1d5571bdb4f0e237$export$1c6175f3aa4394b7, {
        variant: "body2"
    }, "Liquidity Sources"))));
    return (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($1d5571bdb4f0e237$export$791bf2dc0030f14c, {
        title: "Settings",
        textField: false,
        onBack: onBack
    }, PageContent);
}
var $1d5571bdb4f0e237$var$MainContainer$2 = /*#__PURE__*/ $1d5571bdb4f0e237$export$3817b7a54a07cec7("div", {
    position: "relative",
    display: "flex",
    flexDirection: "column",
    borderRadius: "$10",
    boxShadow: "$s",
    width: "100%",
    minWidth: "375px",
    maxWidth: "512px",
    padding: "$16",
    boxSizing: "border-box",
    backgroundColor: "$background",
    overflow: "hidden",
    "& *": {
        boxSizing: "border-box",
        listStyleType: "none",
        "&::-webkit-scrollbar": {
            width: "$8",
            height: "$8"
        },
        "&::-webkit-scrollbar-thumb": {
            backgroundColor: "$neutral400",
            borderRadius: "$10"
        },
        "&::-webkit-scrollbar-thumb:hover": {
            backgroundColor: "$neutral500"
        },
        "&::-webkit-scrollbar-track": {
            backgroundColor: "$neutral100"
        }
    },
    variants: {
        fixedHeight: {
            "true": {
                height: "595px",
                maxHeight: "595px"
            },
            "false": {
                height: "auto"
            }
        }
    }
});
function $1d5571bdb4f0e237$export$1cb4675b6b89e71c(props) {
    var children = props.children, style = props.style, _props$fixedHeight = props.fixedHeight, fixedHeight = _props$fixedHeight === void 0 ? true : _props$fixedHeight;
    return (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($1d5571bdb4f0e237$var$MainContainer$2, {
        style: style,
        id: "swap-box",
        fixedHeight: fixedHeight
    }, children);
}
var $1d5571bdb4f0e237$var$TokenContainer = /*#__PURE__*/ $1d5571bdb4f0e237$export$3817b7a54a07cec7("div", {
    display: "flex",
    alignItems: "center",
    width: "160px",
    "& .amount": {
        fontWeight: "bold"
    },
    "& .estimated": {
        color: "$neutral600"
    }
});
var $1d5571bdb4f0e237$var$TokenImage = /*#__PURE__*/ $1d5571bdb4f0e237$export$3817b7a54a07cec7("div", {
    position: "relative",
    "img": {
        borderRadius: "50%"
    },
    ".overlay": {
        position: "absolute",
        right: -4,
        bottom: -4,
        width: "$16",
        height: "$16",
        padding: "$2",
        borderRadius: "50%",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        backgroundColor: "$background",
        border: "1px solid $neutral400"
    }
});
function $1d5571bdb4f0e237$var$Token(props) {
    var _props$data = props.data, token = _props$data.token, blockchain = _props$data.blockchain, amount = _props$data.amount, estimatedAmount = _props$data.estimatedAmount;
    return (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($1d5571bdb4f0e237$var$TokenContainer, null, (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($1d5571bdb4f0e237$var$TokenImage, null, (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($1d5571bdb4f0e237$export$3e431a229df88919, {
        src: token.logo,
        alt: "",
        size: 24
    }), (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("div", {
        className: "overlay"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($1d5571bdb4f0e237$export$3e431a229df88919, {
        src: blockchain.logo,
        alt: blockchain.name,
        size: 12
    }))), (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($1d5571bdb4f0e237$export$d7a54cba636a8cd6, {
        size: 8
    }), !!amount && (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("span", {
        className: "amount"
    }, props.data.amount), !amount && estimatedAmount && (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("span", {
        className: "amount estimated"
    }, props.data.estimatedAmount), (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($1d5571bdb4f0e237$export$d7a54cba636a8cd6, {
        size: 4
    }), token.symbol);
}
var $1d5571bdb4f0e237$var$Container$3 = /*#__PURE__*/ $1d5571bdb4f0e237$export$3817b7a54a07cec7("div", {
    position: "relative",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: "$16 0",
    borderBottom: "1px solid $neutral100",
    "& > .info": {
        display: "flex",
        alignItems: "center"
    },
    ".status": {
        textTransform: "uppercase",
        fontWeight: "bold",
        fontSize: "$12"
    },
    "&.failed .status": {
        color: "$error"
    },
    "&.success .status": {
        color: "$success"
    }
});
function $1d5571bdb4f0e237$export$c1f850467f64c627(_ref) {
    var swap = _ref.swap, status = _ref.status, onClick = _ref.onClick;
    var firstStep = swap.steps[0];
    var lastStep = swap.steps[swap.steps.length - 1];
    return (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($1d5571bdb4f0e237$export$353f5b6fc5456de1, {
        variant: "ghost",
        size: "free",
        fullWidth: true,
        onClick: onClick.bind(null, swap.requestId)
    }, (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($1d5571bdb4f0e237$var$Container$3, {
        className: "" + status
    }, (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("div", {
        className: "info"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($1d5571bdb4f0e237$var$Token, {
        data: {
            token: {
                logo: firstStep.fromLogo,
                symbol: firstStep.fromSymbol
            },
            blockchain: {
                logo: firstStep.fromBlockchainLogo || "",
                name: firstStep.fromBlockchain
            },
            amount: $1d5571bdb4f0e237$var$limitDecimalPlaces(swap.inputAmount)
        }
    }), (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($1d5571bdb4f0e237$export$d7a54cba636a8cd6, {
        size: 12
    }), (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($1d5571bdb4f0e237$export$9ca09caa9c849d9c, {
        size: 12
    }), (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($1d5571bdb4f0e237$export$d7a54cba636a8cd6, {
        size: 12
    }), (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($1d5571bdb4f0e237$var$Token, {
        data: {
            token: {
                logo: lastStep.toLogo,
                symbol: lastStep.toSymbol
            },
            blockchain: {
                logo: lastStep.toBlockchainLogo || "",
                name: lastStep.toBlockchain
            },
            amount: $1d5571bdb4f0e237$var$limitDecimalPlaces(lastStep.outputAmount || ""),
            estimatedAmount: $1d5571bdb4f0e237$var$limitDecimalPlaces(lastStep.expectedOutputAmountHumanReadable || "")
        }
    })), (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("div", {
        className: "status"
    }, status === "running" ? (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($1d5571bdb4f0e237$export$7f7cbe89f1eacd2, {
        size: 24,
        color: "primary"
    }) : status)));
}
var $1d5571bdb4f0e237$var$Container$4 = /*#__PURE__*/ $1d5571bdb4f0e237$export$3817b7a54a07cec7("div", {
    position: "relative"
});
var $1d5571bdb4f0e237$var$Color = /*#__PURE__*/ $1d5571bdb4f0e237$export$3817b7a54a07cec7("div", {
    border: "1px solid $neutral100",
    borderRadius: "$5",
    width: "$32",
    height: "$32"
});
var $1d5571bdb4f0e237$var$Cover = /*#__PURE__*/ $1d5571bdb4f0e237$export$3817b7a54a07cec7("div", {
    position: "fixed",
    top: "0px",
    right: "0px",
    bottom: "0px",
    left: "0px"
});
var $1d5571bdb4f0e237$var$Popover = /*#__PURE__*/ $1d5571bdb4f0e237$export$3817b7a54a07cec7("div", {
    position: "absolute",
    zIndex: "2",
    variants: {
        place: {
            top: {
                top: "-241px"
            },
            bottom: {},
            left: {
                top: "-50%",
                left: "-225px"
            },
            right: {
                top: "-50%",
                right: "-225px"
            }
        }
    }
});
var $1d5571bdb4f0e237$var$Label$3 = /*#__PURE__*/ $1d5571bdb4f0e237$export$3817b7a54a07cec7("label", {
    display: "inline-block",
    fontSize: "$14",
    marginBottom: "$4",
    color: "$foreground"
});
function $1d5571bdb4f0e237$export$9feb1bc2e5f1ccb3(_ref) {
    var color = _ref.color, onChangeColor = _ref.onChangeColor, label = _ref.label, place = _ref.place, placeholder = _ref.placeholder;
    var _useState = (0, $bh6RR.useState)(false), displayColorPicker = _useState[0], setDisplayColorPicker = _useState[1];
    return (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($1d5571bdb4f0e237$var$Container$4, null, (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($1d5571bdb4f0e237$var$Label$3, {
        className: "_text"
    }, label), (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($1d5571bdb4f0e237$export$353f5b6fc5456de1, {
        variant: "outlined",
        prefix: (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($1d5571bdb4f0e237$var$Color, {
            style: {
                backgroundColor: color
            }
        }),
        fullWidth: true,
        align: "start",
        size: "large",
        suffix: color && (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("div", {
            onClick: function onClick(e) {
                e.stopPropagation();
                onChangeColor(undefined);
            }
        }, (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($1d5571bdb4f0e237$export$cae179f078f4b4a4, {
            size: 20
        })),
        onClick: function onClick() {
            return setDisplayColorPicker(function(prev) {
                return !prev;
            });
        }
    }, color || placeholder), displayColorPicker && (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($1d5571bdb4f0e237$var$Popover, {
        place: place
    }, (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($1d5571bdb4f0e237$var$Cover, {
        onClick: function onClick() {
            return setDisplayColorPicker(false);
        }
    }), (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, $bfc36375d454a39c$export$2e2bcd8739ae039), {
        color: color,
        onChange: function onChange(c) {
            var color = "#" + (0, $deb955abbaf8897f$export$2e2bcd8739ae039)(c.rgb.r, c.rgb.g, c.rgb.b, c.rgb.a);
            onChangeColor(color);
        }
    })));
}
var $1d5571bdb4f0e237$var$BackDrop$1 = /*#__PURE__*/ $1d5571bdb4f0e237$export$3817b7a54a07cec7("div", {
    position: "absolute",
    top: "0",
    left: "0",
    width: "100%",
    height: "100%",
    zIndex: 9999999,
    backgroundColor: "rgba(0,0,0,.1)",
    borderRadius: "$10"
});
var $1d5571bdb4f0e237$var$DrawerContainer = /*#__PURE__*/ $1d5571bdb4f0e237$export$3817b7a54a07cec7("div", {
    position: "absolute",
    boxShadow: "$s",
    background: "$background",
    padding: "$20",
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    zIndex: 9999999,
    borderRadius: "$10",
    variants: {
        anchor: {
            left: {
                top: 0,
                left: 0,
                height: "100%",
                minWidth: "300px",
                maxWidth: "90%"
            },
            right: {
                top: 0,
                right: 0,
                height: "100%",
                minWidth: "300px",
                maxWidth: "90%"
            },
            bottom: {
                bottom: 0,
                width: "100%",
                maxHeight: "90%"
            },
            top: {
                top: 0,
                width: "100%",
                maxHeight: "90%"
            }
        }
    }
});
var $1d5571bdb4f0e237$var$DrawerHeader = /*#__PURE__*/ $1d5571bdb4f0e237$export$3817b7a54a07cec7("div", {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    position: "relative",
    marginBottom: "$16"
});
var $1d5571bdb4f0e237$var$Body = /*#__PURE__*/ $1d5571bdb4f0e237$export$3817b7a54a07cec7("div", {
    overflowY: "auto",
    height: "100%"
});
var $1d5571bdb4f0e237$var$Footer = /*#__PURE__*/ $1d5571bdb4f0e237$export$3817b7a54a07cec7("footer", {
    width: "100%",
    marginTop: "$28"
});
function $1d5571bdb4f0e237$export$4071300121a182f5(props) {
    var title = props.title, content = props.content, open = props.open, onClose = props.onClose, containerStyle = props.containerStyle, _props$anchor = props.anchor, anchor = _props$anchor === void 0 ? "bottom" : _props$anchor, _props$showClose = props.showClose, showClose = _props$showClose === void 0 ? false : _props$showClose, footer = props.footer, container = props.container;
    var handleBackDropClick = function handleBackDropClick(event) {
        if (event.target === event.currentTarget) onClose();
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).Fragment, null, open && container && (0, $47cfd4084854a574$exports.createPortal)((0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($1d5571bdb4f0e237$var$BackDrop$1, {
        onClick: handleBackDropClick
    }, (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($1d5571bdb4f0e237$var$DrawerContainer, {
        anchor: anchor,
        style: containerStyle
    }, (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($1d5571bdb4f0e237$var$DrawerHeader, null, (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($1d5571bdb4f0e237$export$1c6175f3aa4394b7, {
        variant: "h6"
    }, title), showClose && (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($1d5571bdb4f0e237$export$cae179f078f4b4a4, {
        size: 24,
        onClick: onClose
    })), (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($1d5571bdb4f0e237$var$Body, null, content), (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($1d5571bdb4f0e237$var$Footer, null, footer))), container));
}
var $1d5571bdb4f0e237$var$MainContainer$3 = /*#__PURE__*/ $1d5571bdb4f0e237$export$3817b7a54a07cec7("div", {
    overflowY: "auto"
});
var $1d5571bdb4f0e237$var$Section = /*#__PURE__*/ $1d5571bdb4f0e237$export$3817b7a54a07cec7("div", {
    paddingBottom: "$32",
    marginBottom: "$32",
    borderBottom: "1px solid $neutral400"
});
var $1d5571bdb4f0e237$var$Footer$1 = /*#__PURE__*/ $1d5571bdb4f0e237$export$3817b7a54a07cec7("div", {
    display: "flex",
    alignItems: "center"
});
var $1d5571bdb4f0e237$var$AlertContainer = /*#__PURE__*/ $1d5571bdb4f0e237$export$3817b7a54a07cec7("div", {
    padding: "$16 0"
});
var $1d5571bdb4f0e237$var$ConfirmButton = /*#__PURE__*/ $1d5571bdb4f0e237$export$3817b7a54a07cec7($1d5571bdb4f0e237$export$353f5b6fc5456de1, {
    marginTop: "$16"
});
var $1d5571bdb4f0e237$var$Container$5 = /*#__PURE__*/ $1d5571bdb4f0e237$export$3817b7a54a07cec7("div", {
    paddingBottom: "$24",
    ".title": {
        paddingBottom: "$8",
        display: "flex",
        alignItems: "center"
    },
    ".num": {
        backgroundColor: "$neutral100",
        display: "inline-flex",
        width: "24px",
        height: "24px",
        color: "$neutral800",
        borderRadius: "50%",
        fontSize: "$14",
        border: "1px solid $neutral400",
        justifyContent: "center",
        alignItems: "center"
    }
});
var $1d5571bdb4f0e237$var$Alerts = /*#__PURE__*/ $1d5571bdb4f0e237$export$3817b7a54a07cec7("div", {
    paddingBottom: "$16"
});
function $1d5571bdb4f0e237$export$df8a4ea539efbbbd(props) {
    var onBack = props.onBack, loading = props.loading, onConfirm = props.onConfirm, requiredWallets = props.requiredWallets, selectableWallets = props.selectableWallets, onChange = props.onChange, confirmDisabled = props.confirmDisabled, isExperimentalChain = props.isExperimentalChain, handleConnectChain = props.handleConnectChain, confirmButtonTitle = props.confirmButtonTitle, errors = props.errors, warnings = props.warnings, extraMessages = props.extraMessages;
    return (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($1d5571bdb4f0e237$export$791bf2dc0030f14c, {
        textField: false,
        title: "Confirm Swap",
        onBack: onBack,
        Footer: (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($1d5571bdb4f0e237$var$Footer$1, null, (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($1d5571bdb4f0e237$var$ConfirmButton, {
            fullWidth: true,
            loading: loading,
            type: "primary",
            variant: "contained",
            onClick: onConfirm,
            disabled: confirmDisabled
        }, confirmButtonTitle))
    }, (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($1d5571bdb4f0e237$var$MainContainer$3, null, (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("div", null, extraMessages || null, (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($1d5571bdb4f0e237$var$Alerts, null, errors == null ? void 0 : errors.map(function(error, index) {
        return (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).Fragment, {
            key: index
        }, (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($1d5571bdb4f0e237$export$d7a54cba636a8cd6, {
            direction: "vertical"
        }), (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($1d5571bdb4f0e237$export$caec2af78bcc877f, Object.assign({
            type: "error",
            key: index
        }, typeof error === "string" ? {
            title: error
        } : {
            children: error
        })));
    }), warnings == null ? void 0 : warnings.map(function(warning, index) {
        return (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).Fragment, {
            key: index
        }, (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($1d5571bdb4f0e237$export$d7a54cba636a8cd6, {
            direction: "vertical"
        }), (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($1d5571bdb4f0e237$export$caec2af78bcc877f, Object.assign({
            type: "warning",
            key: index
        }, typeof warning === "string" ? {
            title: warning
        } : {
            children: warning
        })));
    }))), props.previewInputs || props.previewRoutes ? (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($1d5571bdb4f0e237$var$Section, null, props.previewInputs, !!props.previewRoutes ? (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($1d5571bdb4f0e237$export$d7a54cba636a8cd6, {
        size: 16,
        direction: "vertical"
    }) : null, props.previewRoutes) : null, requiredWallets.map(function(wallet, index) {
        var list = selectableWallets.filter(function(w) {
            return wallet === w.chain;
        });
        return (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($1d5571bdb4f0e237$var$Container$5, {
            key: index
        }, (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("div", {
            className: "title"
        }, (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("div", {
            className: "num"
        }, index + 1), (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($1d5571bdb4f0e237$export$d7a54cba636a8cd6, {
            size: 8
        }), (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($1d5571bdb4f0e237$export$1c6175f3aa4394b7, {
            variant: "body2"
        }, "Your ", wallet, " Wallet")), list.length === 0 && (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).Fragment, null, (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($1d5571bdb4f0e237$var$AlertContainer, null, (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($1d5571bdb4f0e237$export$caec2af78bcc877f, {
            type: "error"
        }, "You need to connect a compatible wallet with ", wallet, ".")), (isExperimentalChain == null ? void 0 : isExperimentalChain(wallet)) && (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($1d5571bdb4f0e237$export$353f5b6fc5456de1, {
            variant: "contained",
            type: "primary",
            align: "grow",
            onClick: function onClick() {
                return handleConnectChain == null ? void 0 : handleConnectChain(wallet);
            }
        }, "Add " + wallet + " chain to Cosmos wallets")), list.length != 0 && (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($1d5571bdb4f0e237$export$933a707227f480b4, {
            list: list,
            onChange: onChange
        }));
    })));
}
var $1d5571bdb4f0e237$var$Group = /*#__PURE__*/ $1d5571bdb4f0e237$export$3817b7a54a07cec7("div", {
    ".group-title": {
        textTransform: "uppercase"
    }
});
function $1d5571bdb4f0e237$export$4620f24f3175384(props) {
    var list = props.list, onSwapClick = props.onSwapClick, groupBy = props.groupBy;
    var groups = groupBy ? groupBy(list) : [
        {
            title: "History",
            swaps: list
        }
    ];
    return (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).Fragment, null, groups.filter(function(group) {
        return group.swaps.length > 0;
    }).map(function(group, index) {
        return (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).Fragment, {
            key: index
        }, (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($1d5571bdb4f0e237$var$Group, null, (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($1d5571bdb4f0e237$export$1c6175f3aa4394b7, {
            variant: "body2",
            color: "neutral600",
            className: "group-title"
        }, group.title), group.swaps.map(function(swap) {
            return (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).Fragment, {
                key: swap.requestId
            }, (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($1d5571bdb4f0e237$export$c1f850467f64c627, {
                swap: swap,
                status: swap.status,
                onClick: onSwapClick
            }), (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($1d5571bdb4f0e237$export$2e0a83ec2e27ecbb, {
                size: 12
            }));
        })), (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($1d5571bdb4f0e237$export$2e0a83ec2e27ecbb, {
            size: 24
        }));
    }));
}
var $1d5571bdb4f0e237$var$Container$6 = /*#__PURE__*/ $1d5571bdb4f0e237$export$3817b7a54a07cec7("div", {
    overflowY: "auto"
});
var $1d5571bdb4f0e237$var$filteredHistory = function filteredHistory(list, searchedFor) {
    return list.filter(function(swap) {
        var firstStep = swap.steps[0];
        var lastStep = swap.steps[swap.steps.length - 1];
        return $1d5571bdb4f0e237$var$containsText(firstStep.fromBlockchain, searchedFor) || $1d5571bdb4f0e237$var$containsText(firstStep.fromSymbol, searchedFor) || $1d5571bdb4f0e237$var$containsText(lastStep.toBlockchain, searchedFor) || $1d5571bdb4f0e237$var$containsText(lastStep.toSymbol, searchedFor) || $1d5571bdb4f0e237$var$containsText(swap.requestId, searchedFor);
    });
};
function $1d5571bdb4f0e237$export$84202caead5689ba(props) {
    var _props$list = props.list, list = _props$list === void 0 ? [] : _props$list, onBack = props.onBack, onSwapClick = props.onSwapClick, groupBy = props.groupBy, loading = props.loading;
    return (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($1d5571bdb4f0e237$export$791bf2dc0030f14c, {
        onBack: onBack,
        textField: true,
        textFieldPlaceholder: "Search by blockchain, token or request Id",
        title: "Swaps"
    }, function(searchedFor) {
        var filterSwaps = $1d5571bdb4f0e237$var$filteredHistory(list, searchedFor);
        return (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).Fragment, null, loading && (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($1d5571bdb4f0e237$var$LoaderContainer, null, (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($1d5571bdb4f0e237$export$7f7cbe89f1eacd2, {
            size: 24
        })), (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($1d5571bdb4f0e237$var$Container$6, null, !loading && (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).Fragment, null, filterSwaps.length ? (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($1d5571bdb4f0e237$export$4620f24f3175384, {
            list: filterSwaps,
            onSwapClick: onSwapClick,
            groupBy: groupBy
        }) : (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($1d5571bdb4f0e237$var$NotFoundAlert, {
            catergory: "Swap"
        }))));
    });
}
var $1d5571bdb4f0e237$var$getAlertType = function getAlertType(messageType) {
    if (!messageType || messageType === "info") return "secondary";
    else return messageType;
};
var $1d5571bdb4f0e237$var$DetailedMessage = /*#__PURE__*/ $1d5571bdb4f0e237$export$3817b7a54a07cec7("div", {
    width: "90%",
    overflowWrap: "break-word",
    color: "$error500 !important"
});
var $1d5571bdb4f0e237$var$SuccessText = /*#__PURE__*/ $1d5571bdb4f0e237$export$3817b7a54a07cec7($1d5571bdb4f0e237$export$1c6175f3aa4394b7, {
    color: "$success500 !important"
});
var $1d5571bdb4f0e237$var$SwapMessages = function SwapMessages(props) {
    var shortMessage = props.shortMessage, detailedMessage = props.detailedMessage, currentStepBlockchain = props.currentStepBlockchain, type = props.type, lastConvertedTokenInFailedSwap = props.lastConvertedTokenInFailedSwap;
    var _useState = (0, $bh6RR.useState)(false), expandedMessage = _useState[0], setExpandedMessage = _useState[1];
    var allowedNumberOfChars = detailedMessage["long"] ? 0 : 150;
    var shouldShowMoreDetailsButton = !expandedMessage && detailedMessage.content.length > allowedNumberOfChars;
    return (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($1d5571bdb4f0e237$export$caec2af78bcc877f, Object.assign({
        type: $1d5571bdb4f0e237$var$getAlertType(type),
        title: shortMessage
    }, shouldShowMoreDetailsButton && {
        footer: (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($1d5571bdb4f0e237$export$353f5b6fc5456de1, {
            variant: "outlined",
            type: "primary",
            onClick: setExpandedMessage.bind(null, function(prevState) {
                return !prevState;
            })
        }, "Show more details")
    }, !!props.switchNetwork && {
        footer: (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($1d5571bdb4f0e237$export$353f5b6fc5456de1, {
            variant: "outlined",
            type: "primary",
            onClick: function onClick() {
                (props == null ? void 0 : props.switchNetwork) && props.switchNetwork()["catch"](function() {});
            }
        }, "Change network to ", currentStepBlockchain)
    }), !!detailedMessage.content ? (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($1d5571bdb4f0e237$var$DetailedMessage, null, (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($1d5571bdb4f0e237$export$1c6175f3aa4394b7, {
        variant: "body2"
    }, shouldShowMoreDetailsButton && !expandedMessage ? detailedMessage.content.substring(0, allowedNumberOfChars) + (allowedNumberOfChars > 0 ? "..." : "") : detailedMessage.content)) : null, !!lastConvertedTokenInFailedSwap && (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).Fragment, null, (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("p", null, (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($1d5571bdb4f0e237$export$1c6175f3aa4394b7, {
        variant: "body2"
    }, "Don't worry, your fund is\xa0"), (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($1d5571bdb4f0e237$var$SuccessText, {
        variant: "body2"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("b", null, "Safe"))), (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("p", null, (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($1d5571bdb4f0e237$export$1c6175f3aa4394b7, {
        variant: "body2"
    }, "It is converted to \xa0", (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("u", null, lastConvertedTokenInFailedSwap.outputAmount), "\xa0"), (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($1d5571bdb4f0e237$var$SuccessText, {
        variant: "body2"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("b", null, lastConvertedTokenInFailedSwap.symbol, "\xa0")), (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($1d5571bdb4f0e237$export$1c6175f3aa4394b7, {
        variant: "body2"
    }, "on your\xa0"), (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($1d5571bdb4f0e237$var$SuccessText, {
        variant: "body2"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("b", null, lastConvertedTokenInFailedSwap.blockchain, "\xa0")), (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($1d5571bdb4f0e237$export$1c6175f3aa4394b7, {
        variant: "body2"
    }, "wallet"))));
};
var $1d5571bdb4f0e237$var$_excluded$J = [
    "pendingSwap",
    "onBack",
    "onCopy",
    "isCopied",
    "onCancel",
    "date",
    "onRetry",
    "previewInputs"
];
var $1d5571bdb4f0e237$var$SwapperContainer$1 = /*#__PURE__*/ $1d5571bdb4f0e237$export$3817b7a54a07cec7("div", {
    display: "flex",
    alignItems: "center",
    paddingLeft: "$4",
    variants: {
        created: {
            "true": {
                filter: "grayscale(100%)"
            }
        },
        running: {
            "true": {
                animation: $1d5571bdb4f0e237$var$pulse + " 2s ease-in-out infinite"
            }
        }
    }
});
var $1d5571bdb4f0e237$var$FeeContainer = /*#__PURE__*/ $1d5571bdb4f0e237$export$3817b7a54a07cec7("div", {
    paddingLeft: "$16",
    color: "$neutral800"
});
var $1d5571bdb4f0e237$var$Fee = /*#__PURE__*/ $1d5571bdb4f0e237$export$3817b7a54a07cec7("div", {
    display: "flex",
    alignItems: "center"
});
var $1d5571bdb4f0e237$var$RelativeContainer$1 = /*#__PURE__*/ $1d5571bdb4f0e237$export$3817b7a54a07cec7("div", {
    position: "relative"
});
var $1d5571bdb4f0e237$var$Dot$1 = /*#__PURE__*/ $1d5571bdb4f0e237$export$3817b7a54a07cec7("div", {
    width: "$8",
    height: "$8",
    backgroundColor: "$foreground",
    borderRadius: "4px",
    marginLeft: "11px"
});
var $1d5571bdb4f0e237$var$ArrowDown = /*#__PURE__*/ $1d5571bdb4f0e237$export$3817b7a54a07cec7("div", {
    width: "0px",
    height: "0px",
    borderLeft: "5px solid transparent",
    borderRight: "5px solid transparent",
    borderTop: "5px solid $foreground",
    marginLeft: "$10"
});
var $1d5571bdb4f0e237$var$StyledAnchor = /*#__PURE__*/ $1d5571bdb4f0e237$export$3817b7a54a07cec7("a", {
    color: "$primary",
    fontWeight: "$600"
});
var $1d5571bdb4f0e237$var$SwapInfoContainer = /*#__PURE__*/ $1d5571bdb4f0e237$export$3817b7a54a07cec7("div", {
    display: "flex",
    flexDirection: "column",
    paddingBottom: "$16",
    borderBottom: "1px solid $neutral100"
});
var $1d5571bdb4f0e237$var$InternalDetailsContainer = /*#__PURE__*/ $1d5571bdb4f0e237$export$3817b7a54a07cec7("div", {
    display: "flex",
    ".details": {
        padding: "$8 0"
    }
});
var $1d5571bdb4f0e237$var$InternalDetail = /*#__PURE__*/ $1d5571bdb4f0e237$export$3817b7a54a07cec7("div", {
    display: "flex",
    margin: "$12 0 $12 $20"
});
var $1d5571bdb4f0e237$var$DescriptionContainer = /*#__PURE__*/ $1d5571bdb4f0e237$export$3817b7a54a07cec7("div", {
    display: "flex",
    alignItems: "center"
});
var $1d5571bdb4f0e237$var$Description = /*#__PURE__*/ $1d5571bdb4f0e237$export$3817b7a54a07cec7($1d5571bdb4f0e237$export$1c6175f3aa4394b7, {
    color: "$success",
    paddingLeft: "$4"
});
var $1d5571bdb4f0e237$var$Line$1 = /*#__PURE__*/ $1d5571bdb4f0e237$export$3817b7a54a07cec7("div", {
    width: "0",
    minHeight: "$16",
    marginLeft: "14px",
    border: "1px dashed $foreground",
    borderRadius: "inherit"
});
var $1d5571bdb4f0e237$var$Row$2 = /*#__PURE__*/ $1d5571bdb4f0e237$export$3817b7a54a07cec7("div", {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    fontSize: "$14",
    padding: "$8 0",
    ".name": {
        color: "$neutral600"
    },
    ".value": {
        display: "flex",
        alignItems: "center",
        color: "$neutral800",
        justifyContent: "flex-end"
    },
    ".status": {
        fontWeight: "bold",
        textTransform: "uppercase"
    },
    ".status.failed": {
        color: "$error"
    },
    ".status.success": {
        color: "$success"
    }
});
var $1d5571bdb4f0e237$var$RequestId = /*#__PURE__*/ $1d5571bdb4f0e237$export$3817b7a54a07cec7("div", {
    width: "150px",
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
    "@md": {
        width: "auto"
    }
});
var $1d5571bdb4f0e237$var$ExtraDetails = /*#__PURE__*/ $1d5571bdb4f0e237$export$3817b7a54a07cec7("div", {
    padding: "0",
    color: "$neutral600",
    fontSize: "$10"
});
var $1d5571bdb4f0e237$var$SwapFlowContainer = /*#__PURE__*/ $1d5571bdb4f0e237$export$3817b7a54a07cec7("div", {
    overflowY: "auto",
    padding: "$8 $4 $2 $4"
});
function $1d5571bdb4f0e237$export$7e04c0d63c183294(props) {
    var pendingSwap = props.pendingSwap, onBack = props.onBack, onCopy = props.onCopy, isCopied = props.isCopied, onCancel = props.onCancel, date = props.date, onRetry = props.onRetry, extraMessageProps = $1d5571bdb4f0e237$var$_objectWithoutPropertiesLoose(props, $1d5571bdb4f0e237$var$_excluded$J);
    var _useState = (0, $bh6RR.useState)(false), showDrawer = _useState[0], setShowDrawer = _useState[1];
    return (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($1d5571bdb4f0e237$export$791bf2dc0030f14c, {
        title: "Swap Details",
        textField: false,
        onBack: onBack,
        Footer: (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).Fragment, null, (pendingSwap == null ? void 0 : pendingSwap.status) === "running" && (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($1d5571bdb4f0e237$export$353f5b6fc5456de1, {
            variant: "outlined",
            fullWidth: true,
            type: "error",
            onClick: setShowDrawer.bind(null, true)
        }, "Cancel"), !!onRetry && (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($1d5571bdb4f0e237$export$353f5b6fc5456de1, {
            variant: "contained",
            fullWidth: true,
            type: "primary",
            onClick: onRetry
        }, "Try again"))
    }, (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("div", null, (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($1d5571bdb4f0e237$var$SwapInfoContainer, null, (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($1d5571bdb4f0e237$var$Row$2, null, (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("div", {
        className: "name"
    }, "Request Id:", (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("span", {
        className: "value requestId",
        onClick: onCopy.bind(null, pendingSwap == null ? void 0 : pendingSwap.requestId)
    }, (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($1d5571bdb4f0e237$var$RequestId, null, pendingSwap == null ? void 0 : pendingSwap.requestId), (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($1d5571bdb4f0e237$export$d7a54cba636a8cd6, {
        size: 4
    }), (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($1d5571bdb4f0e237$export$353f5b6fc5456de1, {
        type: "primary",
        variant: "ghost",
        size: "compact"
    }, isCopied ? "Copied!" : "Copy"))), (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("div", {
        className: "name"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("span", {
        className: "value status " + ((pendingSwap == null ? void 0 : pendingSwap.status) || "")
    }, pendingSwap == null ? void 0 : pendingSwap.status, (pendingSwap == null ? void 0 : pendingSwap.status) === "running" && (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($1d5571bdb4f0e237$export$7f7cbe89f1eacd2, {
        size: 16,
        color: "primary"
    })), (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($1d5571bdb4f0e237$var$ExtraDetails, null, date))))), (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($1d5571bdb4f0e237$var$SwapFlowContainer, null, extraMessageProps.shortMessage && (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($1d5571bdb4f0e237$var$SwapMessages, Object.assign({}, extraMessageProps)), (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($1d5571bdb4f0e237$export$2e0a83ec2e27ecbb, {
        size: 16
    }), pendingSwap == null ? void 0 : pendingSwap.steps.map(function(step, index) {
        return (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("div", {
            key: index
        }, index === 0 && (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($1d5571bdb4f0e237$var$RelativeContainer$1, null, (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($1d5571bdb4f0e237$export$6ff54be27cce4b12, {
            logo: step.fromLogo,
            symbol: step.fromSymbol,
            chainLogo: step.fromBlockchainLogo || "",
            blockchain: step.fromBlockchain,
            amount: pendingSwap.inputAmount
        }), (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($1d5571bdb4f0e237$var$Dot$1, null)), (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($1d5571bdb4f0e237$var$Line$1, null), (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($1d5571bdb4f0e237$var$SwapperContainer$1, {
            created: step.status === "created",
            running: ![
                "created",
                "success",
                "failed"
            ].includes(step.status)
        }, (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($1d5571bdb4f0e237$export$3e431a229df88919, {
            src: step.swapperLogo || "",
            alt: step.swapperId,
            size: 20
        }), (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($1d5571bdb4f0e237$var$FeeContainer, null, (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($1d5571bdb4f0e237$export$1c6175f3aa4394b7, {
            variant: "body2"
        }, step.swapperType === "DEX" ? "Swap" : "Bridge", " via", " ", step.swapperId), (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($1d5571bdb4f0e237$var$Fee, null, (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($1d5571bdb4f0e237$export$dc5067efa4cb656a, null), (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($1d5571bdb4f0e237$export$1c6175f3aa4394b7, {
            variant: "body2"
        }, "\xa0 $", step.feeInUsd, " estimated gas fee")))), (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("div", {
            style: {
                display: "flex"
            }
        }, (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($1d5571bdb4f0e237$var$InternalDetailsContainer, null, (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($1d5571bdb4f0e237$var$Line$1, null), (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("div", {
            className: "details"
        }, !!step.explorerUrl && (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("div", null, step.explorerUrl.map(function(item, index) {
            return (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($1d5571bdb4f0e237$var$InternalDetail, {
                key: index
            }, (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($1d5571bdb4f0e237$var$DescriptionContainer, null, (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($1d5571bdb4f0e237$export$2e0a83ec2e27ecbb, {
                size: 4
            }), (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($1d5571bdb4f0e237$export$f6dd727656c97851, {
                color: "primary"
            }), (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($1d5571bdb4f0e237$var$Description, {
                variant: "body2"
            }, (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($1d5571bdb4f0e237$var$StyledAnchor, {
                href: item.url,
                target: "_blank",
                rel: "noreferrer",
                key: index
            }, !item.description ? (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("b", null, "View transaction") : (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("b", null, item.description.substring(0, 1).toUpperCase(), item.description.substring(1), " Tx")))));
        })), step.status === "failed" && (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($1d5571bdb4f0e237$var$InternalDetail, null, (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($1d5571bdb4f0e237$var$DescriptionContainer, null, (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($1d5571bdb4f0e237$export$235e99e4cce237dc, {
            color: "error"
        }), (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($1d5571bdb4f0e237$var$Description, {
            variant: "body2",
            color: "$error500"
        }, "Step failed")))))), index + 1 === pendingSwap.steps.length && (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($1d5571bdb4f0e237$var$ArrowDown, null), (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($1d5571bdb4f0e237$export$6ff54be27cce4b12, {
            logo: step.toLogo,
            symbol: step.toSymbol,
            chainLogo: step.toBlockchainLogo || "",
            blockchain: step.toBlockchain,
            amount: step.outputAmount || "",
            estimatedAmount: step.expectedOutputAmountHumanReadable || "",
            success: step.status === "success"
        }));
    }), (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($1d5571bdb4f0e237$export$2e0a83ec2e27ecbb, {
        size: 32
    })), (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($1d5571bdb4f0e237$export$4071300121a182f5, {
        onClose: setShowDrawer.bind(null, false),
        open: showDrawer,
        showClose: true,
        anchor: "bottom",
        title: "Cancel Progress",
        content: (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($1d5571bdb4f0e237$export$caec2af78bcc877f, {
            type: "warning"
        }, (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($1d5571bdb4f0e237$export$1c6175f3aa4394b7, {
            variant: "body2"
        }, "Warning: Cancel ", (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("u", null, "doesn't revert"), " your transaction if you've already signed and sent a transaction to the blockchain. It only stops next steps from being executed.")),
        footer: (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("div", {
            style: {
                display: "flex",
                justifyContent: "center",
                alignItems: "center"
            }
        }, (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($1d5571bdb4f0e237$export$353f5b6fc5456de1, {
            variant: "contained",
            type: "success",
            onClick: setShowDrawer.bind(null, false)
        }, "Skip"), (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($1d5571bdb4f0e237$export$d7a54cba636a8cd6, {
            size: 16
        }), (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($1d5571bdb4f0e237$export$353f5b6fc5456de1, {
            variant: "contained",
            type: "error",
            onClick: function onClick() {
                onCancel(pendingSwap.requestId);
                setShowDrawer(false);
            }
        }, "Cancel progress")),
        container: document.getElementById("swap-box")
    }));
}
function $1d5571bdb4f0e237$export$b2199c37e85de4a7(resetInterval) {
    var _React$useState = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useState(false), isCopied = _React$useState[0], setCopied = _React$useState[1];
    var handleCopy = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useCallback(function(text) {
        (0, (/*@__PURE__*/$parcel$interopDefault($86521b2041dac6c7$exports)))(text.toString());
        setCopied(true);
    }, []);
    (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useEffect(function() {
        var timeout;
        if (isCopied && resetInterval) timeout = setTimeout(function() {
            return setCopied(false);
        }, resetInterval);
        return function() {
            clearTimeout(timeout);
        };
    }, [
        isCopied,
        resetInterval
    ]);
    return [
        isCopied,
        handleCopy
    ];
}



var $bh6RR = parcelRequire("bh6RR");
/* eslint-disable @typescript-eslint/no-empty-function */ 

var $bh6RR = parcelRequire("bh6RR");
const $b5f7f016a4b1ac5d$export$6554e0e4e82f1b3a = "https://api.rango.exchange/";
const $b5f7f016a4b1ac5d$export$4c0481fa974c14d3 = "c6381a79-2817-4602-83bf-6a641a409e32";


var $229428e7240420de$exports = {};
"use strict";

(function() {
    var buf, bufIdx = 0, hexBytes = [], i;
    // Pre-calculate toString(16) for speed
    for(i = 0; i < 256; i++)hexBytes[i] = (i + 0x100).toString(16).substr(1);
    // Buffer random numbers for speed
    // Reduce memory usage by decreasing this number (min 16)
    // or improve speed by increasing this number (try 16384)
    uuid.BUFFER_SIZE = 4096;
    // Binary uuids
    uuid.bin = uuidBin;
    // Clear buffer
    uuid.clearBuffer = function() {
        buf = null;
        bufIdx = 0;
    };
    // Test for uuid
    uuid.test = function(uuid) {
        if (typeof uuid === "string") return /^[0-9a-f]{8}-[0-9a-f]{4}-4[0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i.test(uuid);
        return false;
    };
    // Node & Browser support
    var crypt0;
    if (typeof crypto !== "undefined") crypt0 = crypto;
    else if (typeof window !== "undefined" && typeof window.msCrypto !== "undefined") crypt0 = window.msCrypto; // IE11
    crypt0 = crypt0 || (parcelRequire("5Io6y"));
    $229428e7240420de$exports = uuid;
    // Use best available PRNG
    // Also expose this so you can override it.
    uuid.randomBytes = function() {
        if (crypt0) {
            if (crypt0.randomBytes) return crypt0.randomBytes;
            if (crypt0.getRandomValues) {
                if (typeof Uint8Array.prototype.slice !== "function") return function(n) {
                    var bytes = new Uint8Array(n);
                    crypt0.getRandomValues(bytes);
                    return Array.from(bytes);
                };
                return function(n) {
                    var bytes = new Uint8Array(n);
                    crypt0.getRandomValues(bytes);
                    return bytes;
                };
            }
        }
        return function(n) {
            var i, r = [];
            for(i = 0; i < n; i++)r.push(Math.floor(Math.random() * 256));
            return r;
        };
    }();
    // Buffer some random bytes for speed
    function randomBytesBuffered(n) {
        if (!buf || bufIdx + n > uuid.BUFFER_SIZE) {
            bufIdx = 0;
            buf = uuid.randomBytes(uuid.BUFFER_SIZE);
        }
        return buf.slice(bufIdx, bufIdx += n);
    }
    // uuid.bin
    function uuidBin() {
        var b = randomBytesBuffered(16);
        b[6] = b[6] & 0x0f | 0x40;
        b[8] = b[8] & 0x3f | 0x80;
        return b;
    }
    // String UUIDv4 (Random)
    function uuid() {
        var b = uuidBin();
        return hexBytes[b[0]] + hexBytes[b[1]] + hexBytes[b[2]] + hexBytes[b[3]] + "-" + hexBytes[b[4]] + hexBytes[b[5]] + "-" + hexBytes[b[6]] + hexBytes[b[7]] + "-" + hexBytes[b[8]] + hexBytes[b[9]] + "-" + hexBytes[b[10]] + hexBytes[b[11]] + hexBytes[b[12]] + hexBytes[b[13]] + hexBytes[b[14]] + hexBytes[b[15]];
    }
})();



"use strict";
function $0ba9ef1fcbf73284$export$2e2bcd8739ae039(fn, thisArg) {
    return function wrap() {
        return fn.apply(thisArg, arguments);
    };
}


"use strict";
// utils is a library of generic helper functions non-specific to axios
const { toString: $0192f04cc5678e59$var$toString } = Object.prototype;
const { getPrototypeOf: $0192f04cc5678e59$var$getPrototypeOf } = Object;
const $0192f04cc5678e59$var$kindOf = ((cache)=>(thing)=>{
        const str = $0192f04cc5678e59$var$toString.call(thing);
        return cache[str] || (cache[str] = str.slice(8, -1).toLowerCase());
    })(Object.create(null));
const $0192f04cc5678e59$var$kindOfTest = (type)=>{
    type = type.toLowerCase();
    return (thing)=>$0192f04cc5678e59$var$kindOf(thing) === type;
};
const $0192f04cc5678e59$var$typeOfTest = (type)=>(thing)=>typeof thing === type;
/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 *
 * @returns {boolean} True if value is an Array, otherwise false
 */ const { isArray: $0192f04cc5678e59$var$isArray } = Array;
/**
 * Determine if a value is undefined
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if the value is undefined, otherwise false
 */ const $0192f04cc5678e59$var$isUndefined = $0192f04cc5678e59$var$typeOfTest("undefined");
/**
 * Determine if a value is a Buffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Buffer, otherwise false
 */ function $0192f04cc5678e59$var$isBuffer(val) {
    return val !== null && !$0192f04cc5678e59$var$isUndefined(val) && val.constructor !== null && !$0192f04cc5678e59$var$isUndefined(val.constructor) && $0192f04cc5678e59$var$isFunction(val.constructor.isBuffer) && val.constructor.isBuffer(val);
}
/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */ const $0192f04cc5678e59$var$isArrayBuffer = $0192f04cc5678e59$var$kindOfTest("ArrayBuffer");
/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */ function $0192f04cc5678e59$var$isArrayBufferView(val) {
    let result;
    if (typeof ArrayBuffer !== "undefined" && ArrayBuffer.isView) result = ArrayBuffer.isView(val);
    else result = val && val.buffer && $0192f04cc5678e59$var$isArrayBuffer(val.buffer);
    return result;
}
/**
 * Determine if a value is a String
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a String, otherwise false
 */ const $0192f04cc5678e59$var$isString = $0192f04cc5678e59$var$typeOfTest("string");
/**
 * Determine if a value is a Function
 *
 * @param {*} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */ const $0192f04cc5678e59$var$isFunction = $0192f04cc5678e59$var$typeOfTest("function");
/**
 * Determine if a value is a Number
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Number, otherwise false
 */ const $0192f04cc5678e59$var$isNumber = $0192f04cc5678e59$var$typeOfTest("number");
/**
 * Determine if a value is an Object
 *
 * @param {*} thing The value to test
 *
 * @returns {boolean} True if value is an Object, otherwise false
 */ const $0192f04cc5678e59$var$isObject = (thing)=>thing !== null && typeof thing === "object";
/**
 * Determine if a value is a Boolean
 *
 * @param {*} thing The value to test
 * @returns {boolean} True if value is a Boolean, otherwise false
 */ const $0192f04cc5678e59$var$isBoolean = (thing)=>thing === true || thing === false;
/**
 * Determine if a value is a plain Object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a plain Object, otherwise false
 */ const $0192f04cc5678e59$var$isPlainObject = (val)=>{
    if ($0192f04cc5678e59$var$kindOf(val) !== "object") return false;
    const prototype = $0192f04cc5678e59$var$getPrototypeOf(val);
    return (prototype === null || prototype === Object.prototype || Object.getPrototypeOf(prototype) === null) && !(Symbol.toStringTag in val) && !(Symbol.iterator in val);
};
/**
 * Determine if a value is a Date
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Date, otherwise false
 */ const $0192f04cc5678e59$var$isDate = $0192f04cc5678e59$var$kindOfTest("Date");
/**
 * Determine if a value is a File
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a File, otherwise false
 */ const $0192f04cc5678e59$var$isFile = $0192f04cc5678e59$var$kindOfTest("File");
/**
 * Determine if a value is a Blob
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Blob, otherwise false
 */ const $0192f04cc5678e59$var$isBlob = $0192f04cc5678e59$var$kindOfTest("Blob");
/**
 * Determine if a value is a FileList
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a File, otherwise false
 */ const $0192f04cc5678e59$var$isFileList = $0192f04cc5678e59$var$kindOfTest("FileList");
/**
 * Determine if a value is a Stream
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Stream, otherwise false
 */ const $0192f04cc5678e59$var$isStream = (val)=>$0192f04cc5678e59$var$isObject(val) && $0192f04cc5678e59$var$isFunction(val.pipe);
/**
 * Determine if a value is a FormData
 *
 * @param {*} thing The value to test
 *
 * @returns {boolean} True if value is an FormData, otherwise false
 */ const $0192f04cc5678e59$var$isFormData = (thing)=>{
    let kind;
    return thing && (typeof FormData === "function" && thing instanceof FormData || $0192f04cc5678e59$var$isFunction(thing.append) && ((kind = $0192f04cc5678e59$var$kindOf(thing)) === "formdata" || // detect form-data instance
    kind === "object" && $0192f04cc5678e59$var$isFunction(thing.toString) && thing.toString() === "[object FormData]"));
};
/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */ const $0192f04cc5678e59$var$isURLSearchParams = $0192f04cc5678e59$var$kindOfTest("URLSearchParams");
/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 *
 * @returns {String} The String freed of excess whitespace
 */ const $0192f04cc5678e59$var$trim = (str)=>str.trim ? str.trim() : str.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, "");
/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 *
 * @param {Boolean} [allOwnKeys = false]
 * @returns {any}
 */ function $0192f04cc5678e59$var$forEach(obj, fn, { allOwnKeys: allOwnKeys = false } = {}) {
    // Don't bother if no value provided
    if (obj === null || typeof obj === "undefined") return;
    let i;
    let l;
    // Force an array if not already something iterable
    if (typeof obj !== "object") /*eslint no-param-reassign:0*/ obj = [
        obj
    ];
    if ($0192f04cc5678e59$var$isArray(obj)) // Iterate over array values
    for(i = 0, l = obj.length; i < l; i++)fn.call(null, obj[i], i, obj);
    else {
        // Iterate over object keys
        const keys = allOwnKeys ? Object.getOwnPropertyNames(obj) : Object.keys(obj);
        const len = keys.length;
        let key;
        for(i = 0; i < len; i++){
            key = keys[i];
            fn.call(null, obj[key], key, obj);
        }
    }
}
function $0192f04cc5678e59$var$findKey(obj, key) {
    key = key.toLowerCase();
    const keys = Object.keys(obj);
    let i = keys.length;
    let _key;
    while(i-- > 0){
        _key = keys[i];
        if (key === _key.toLowerCase()) return _key;
    }
    return null;
}
const $0192f04cc5678e59$var$_global = (()=>{
    /*eslint no-undef:0*/ if (typeof globalThis !== "undefined") return globalThis;
    return typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : $parcel$global;
})();
const $0192f04cc5678e59$var$isContextDefined = (context)=>!$0192f04cc5678e59$var$isUndefined(context) && context !== $0192f04cc5678e59$var$_global;
/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 *
 * @returns {Object} Result of all merge properties
 */ function $0192f04cc5678e59$var$merge() {
    const { caseless: caseless } = $0192f04cc5678e59$var$isContextDefined(this) && this || {};
    const result = {};
    const assignValue = (val, key)=>{
        const targetKey = caseless && $0192f04cc5678e59$var$findKey(result, key) || key;
        if ($0192f04cc5678e59$var$isPlainObject(result[targetKey]) && $0192f04cc5678e59$var$isPlainObject(val)) result[targetKey] = $0192f04cc5678e59$var$merge(result[targetKey], val);
        else if ($0192f04cc5678e59$var$isPlainObject(val)) result[targetKey] = $0192f04cc5678e59$var$merge({}, val);
        else if ($0192f04cc5678e59$var$isArray(val)) result[targetKey] = val.slice();
        else result[targetKey] = val;
    };
    for(let i = 0, l = arguments.length; i < l; i++)arguments[i] && $0192f04cc5678e59$var$forEach(arguments[i], assignValue);
    return result;
}
/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 *
 * @param {Boolean} [allOwnKeys]
 * @returns {Object} The resulting value of object a
 */ const $0192f04cc5678e59$var$extend = (a, b, thisArg, { allOwnKeys: allOwnKeys } = {})=>{
    $0192f04cc5678e59$var$forEach(b, (val, key)=>{
        if (thisArg && $0192f04cc5678e59$var$isFunction(val)) a[key] = (0, $0ba9ef1fcbf73284$export$2e2bcd8739ae039)(val, thisArg);
        else a[key] = val;
    }, {
        allOwnKeys: allOwnKeys
    });
    return a;
};
/**
 * Remove byte order marker. This catches EF BB BF (the UTF-8 BOM)
 *
 * @param {string} content with BOM
 *
 * @returns {string} content value without BOM
 */ const $0192f04cc5678e59$var$stripBOM = (content)=>{
    if (content.charCodeAt(0) === 0xFEFF) content = content.slice(1);
    return content;
};
/**
 * Inherit the prototype methods from one constructor into another
 * @param {function} constructor
 * @param {function} superConstructor
 * @param {object} [props]
 * @param {object} [descriptors]
 *
 * @returns {void}
 */ const $0192f04cc5678e59$var$inherits = (constructor, superConstructor, props, descriptors)=>{
    constructor.prototype = Object.create(superConstructor.prototype, descriptors);
    constructor.prototype.constructor = constructor;
    Object.defineProperty(constructor, "super", {
        value: superConstructor.prototype
    });
    props && Object.assign(constructor.prototype, props);
};
/**
 * Resolve object with deep prototype chain to a flat object
 * @param {Object} sourceObj source object
 * @param {Object} [destObj]
 * @param {Function|Boolean} [filter]
 * @param {Function} [propFilter]
 *
 * @returns {Object}
 */ const $0192f04cc5678e59$var$toFlatObject = (sourceObj, destObj, filter, propFilter)=>{
    let props;
    let i;
    let prop;
    const merged = {};
    destObj = destObj || {};
    // eslint-disable-next-line no-eq-null,eqeqeq
    if (sourceObj == null) return destObj;
    do {
        props = Object.getOwnPropertyNames(sourceObj);
        i = props.length;
        while(i-- > 0){
            prop = props[i];
            if ((!propFilter || propFilter(prop, sourceObj, destObj)) && !merged[prop]) {
                destObj[prop] = sourceObj[prop];
                merged[prop] = true;
            }
        }
        sourceObj = filter !== false && $0192f04cc5678e59$var$getPrototypeOf(sourceObj);
    }while (sourceObj && (!filter || filter(sourceObj, destObj)) && sourceObj !== Object.prototype);
    return destObj;
};
/**
 * Determines whether a string ends with the characters of a specified string
 *
 * @param {String} str
 * @param {String} searchString
 * @param {Number} [position= 0]
 *
 * @returns {boolean}
 */ const $0192f04cc5678e59$var$endsWith = (str, searchString, position)=>{
    str = String(str);
    if (position === undefined || position > str.length) position = str.length;
    position -= searchString.length;
    const lastIndex = str.indexOf(searchString, position);
    return lastIndex !== -1 && lastIndex === position;
};
/**
 * Returns new array from array like object or null if failed
 *
 * @param {*} [thing]
 *
 * @returns {?Array}
 */ const $0192f04cc5678e59$var$toArray = (thing)=>{
    if (!thing) return null;
    if ($0192f04cc5678e59$var$isArray(thing)) return thing;
    let i = thing.length;
    if (!$0192f04cc5678e59$var$isNumber(i)) return null;
    const arr = new Array(i);
    while(i-- > 0)arr[i] = thing[i];
    return arr;
};
/**
 * Checking if the Uint8Array exists and if it does, it returns a function that checks if the
 * thing passed in is an instance of Uint8Array
 *
 * @param {TypedArray}
 *
 * @returns {Array}
 */ // eslint-disable-next-line func-names
const $0192f04cc5678e59$var$isTypedArray = ((TypedArray)=>{
    // eslint-disable-next-line func-names
    return (thing)=>{
        return TypedArray && thing instanceof TypedArray;
    };
})(typeof Uint8Array !== "undefined" && $0192f04cc5678e59$var$getPrototypeOf(Uint8Array));
/**
 * For each entry in the object, call the function with the key and value.
 *
 * @param {Object<any, any>} obj - The object to iterate over.
 * @param {Function} fn - The function to call for each entry.
 *
 * @returns {void}
 */ const $0192f04cc5678e59$var$forEachEntry = (obj, fn)=>{
    const generator = obj && obj[Symbol.iterator];
    const iterator = generator.call(obj);
    let result;
    while((result = iterator.next()) && !result.done){
        const pair = result.value;
        fn.call(obj, pair[0], pair[1]);
    }
};
/**
 * It takes a regular expression and a string, and returns an array of all the matches
 *
 * @param {string} regExp - The regular expression to match against.
 * @param {string} str - The string to search.
 *
 * @returns {Array<boolean>}
 */ const $0192f04cc5678e59$var$matchAll = (regExp, str)=>{
    let matches;
    const arr = [];
    while((matches = regExp.exec(str)) !== null)arr.push(matches);
    return arr;
};
/* Checking if the kindOfTest function returns true when passed an HTMLFormElement. */ const $0192f04cc5678e59$var$isHTMLForm = $0192f04cc5678e59$var$kindOfTest("HTMLFormElement");
const $0192f04cc5678e59$var$toCamelCase = (str)=>{
    return str.toLowerCase().replace(/[-_\s]([a-z\d])(\w*)/g, function replacer(m, p1, p2) {
        return p1.toUpperCase() + p2;
    });
};
/* Creating a function that will check if an object has a property. */ const $0192f04cc5678e59$var$hasOwnProperty = (({ hasOwnProperty: hasOwnProperty })=>(obj, prop)=>hasOwnProperty.call(obj, prop))(Object.prototype);
/**
 * Determine if a value is a RegExp object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a RegExp object, otherwise false
 */ const $0192f04cc5678e59$var$isRegExp = $0192f04cc5678e59$var$kindOfTest("RegExp");
const $0192f04cc5678e59$var$reduceDescriptors = (obj, reducer)=>{
    const descriptors = Object.getOwnPropertyDescriptors(obj);
    const reducedDescriptors = {};
    $0192f04cc5678e59$var$forEach(descriptors, (descriptor, name)=>{
        if (reducer(descriptor, name, obj) !== false) reducedDescriptors[name] = descriptor;
    });
    Object.defineProperties(obj, reducedDescriptors);
};
/**
 * Makes all methods read-only
 * @param {Object} obj
 */ const $0192f04cc5678e59$var$freezeMethods = (obj)=>{
    $0192f04cc5678e59$var$reduceDescriptors(obj, (descriptor, name)=>{
        // skip restricted props in strict mode
        if ($0192f04cc5678e59$var$isFunction(obj) && [
            "arguments",
            "caller",
            "callee"
        ].indexOf(name) !== -1) return false;
        const value = obj[name];
        if (!$0192f04cc5678e59$var$isFunction(value)) return;
        descriptor.enumerable = false;
        if ("writable" in descriptor) {
            descriptor.writable = false;
            return;
        }
        if (!descriptor.set) descriptor.set = ()=>{
            throw Error("Can not rewrite read-only method '" + name + "'");
        };
    });
};
const $0192f04cc5678e59$var$toObjectSet = (arrayOrString, delimiter)=>{
    const obj = {};
    const define = (arr)=>{
        arr.forEach((value)=>{
            obj[value] = true;
        });
    };
    $0192f04cc5678e59$var$isArray(arrayOrString) ? define(arrayOrString) : define(String(arrayOrString).split(delimiter));
    return obj;
};
const $0192f04cc5678e59$var$noop = ()=>{};
const $0192f04cc5678e59$var$toFiniteNumber = (value, defaultValue)=>{
    value = +value;
    return Number.isFinite(value) ? value : defaultValue;
};
const $0192f04cc5678e59$var$ALPHA = "abcdefghijklmnopqrstuvwxyz";
const $0192f04cc5678e59$var$DIGIT = "0123456789";
const $0192f04cc5678e59$var$ALPHABET = {
    DIGIT: $0192f04cc5678e59$var$DIGIT,
    ALPHA: $0192f04cc5678e59$var$ALPHA,
    ALPHA_DIGIT: $0192f04cc5678e59$var$ALPHA + $0192f04cc5678e59$var$ALPHA.toUpperCase() + $0192f04cc5678e59$var$DIGIT
};
const $0192f04cc5678e59$var$generateString = (size = 16, alphabet = $0192f04cc5678e59$var$ALPHABET.ALPHA_DIGIT)=>{
    let str = "";
    const { length: length } = alphabet;
    while(size--)str += alphabet[Math.random() * length | 0];
    return str;
};
/**
 * If the thing is a FormData object, return true, otherwise return false.
 *
 * @param {unknown} thing - The thing to check.
 *
 * @returns {boolean}
 */ function $0192f04cc5678e59$var$isSpecCompliantForm(thing) {
    return !!(thing && $0192f04cc5678e59$var$isFunction(thing.append) && thing[Symbol.toStringTag] === "FormData" && thing[Symbol.iterator]);
}
const $0192f04cc5678e59$var$toJSONObject = (obj)=>{
    const stack = new Array(10);
    const visit = (source, i)=>{
        if ($0192f04cc5678e59$var$isObject(source)) {
            if (stack.indexOf(source) >= 0) return;
            if (!("toJSON" in source)) {
                stack[i] = source;
                const target = $0192f04cc5678e59$var$isArray(source) ? [] : {};
                $0192f04cc5678e59$var$forEach(source, (value, key)=>{
                    const reducedValue = visit(value, i + 1);
                    !$0192f04cc5678e59$var$isUndefined(reducedValue) && (target[key] = reducedValue);
                });
                stack[i] = undefined;
                return target;
            }
        }
        return source;
    };
    return visit(obj, 0);
};
const $0192f04cc5678e59$var$isAsyncFn = $0192f04cc5678e59$var$kindOfTest("AsyncFunction");
const $0192f04cc5678e59$var$isThenable = (thing)=>thing && ($0192f04cc5678e59$var$isObject(thing) || $0192f04cc5678e59$var$isFunction(thing)) && $0192f04cc5678e59$var$isFunction(thing.then) && $0192f04cc5678e59$var$isFunction(thing.catch);
var $0192f04cc5678e59$export$2e2bcd8739ae039 = {
    isArray: $0192f04cc5678e59$var$isArray,
    isArrayBuffer: $0192f04cc5678e59$var$isArrayBuffer,
    isBuffer: $0192f04cc5678e59$var$isBuffer,
    isFormData: $0192f04cc5678e59$var$isFormData,
    isArrayBufferView: $0192f04cc5678e59$var$isArrayBufferView,
    isString: $0192f04cc5678e59$var$isString,
    isNumber: $0192f04cc5678e59$var$isNumber,
    isBoolean: $0192f04cc5678e59$var$isBoolean,
    isObject: $0192f04cc5678e59$var$isObject,
    isPlainObject: $0192f04cc5678e59$var$isPlainObject,
    isUndefined: $0192f04cc5678e59$var$isUndefined,
    isDate: $0192f04cc5678e59$var$isDate,
    isFile: $0192f04cc5678e59$var$isFile,
    isBlob: $0192f04cc5678e59$var$isBlob,
    isRegExp: $0192f04cc5678e59$var$isRegExp,
    isFunction: $0192f04cc5678e59$var$isFunction,
    isStream: $0192f04cc5678e59$var$isStream,
    isURLSearchParams: $0192f04cc5678e59$var$isURLSearchParams,
    isTypedArray: $0192f04cc5678e59$var$isTypedArray,
    isFileList: $0192f04cc5678e59$var$isFileList,
    forEach: $0192f04cc5678e59$var$forEach,
    merge: $0192f04cc5678e59$var$merge,
    extend: $0192f04cc5678e59$var$extend,
    trim: $0192f04cc5678e59$var$trim,
    stripBOM: $0192f04cc5678e59$var$stripBOM,
    inherits: $0192f04cc5678e59$var$inherits,
    toFlatObject: $0192f04cc5678e59$var$toFlatObject,
    kindOf: $0192f04cc5678e59$var$kindOf,
    kindOfTest: $0192f04cc5678e59$var$kindOfTest,
    endsWith: $0192f04cc5678e59$var$endsWith,
    toArray: $0192f04cc5678e59$var$toArray,
    forEachEntry: $0192f04cc5678e59$var$forEachEntry,
    matchAll: $0192f04cc5678e59$var$matchAll,
    isHTMLForm: $0192f04cc5678e59$var$isHTMLForm,
    hasOwnProperty: $0192f04cc5678e59$var$hasOwnProperty,
    hasOwnProp: $0192f04cc5678e59$var$hasOwnProperty,
    reduceDescriptors: $0192f04cc5678e59$var$reduceDescriptors,
    freezeMethods: $0192f04cc5678e59$var$freezeMethods,
    toObjectSet: $0192f04cc5678e59$var$toObjectSet,
    toCamelCase: $0192f04cc5678e59$var$toCamelCase,
    noop: $0192f04cc5678e59$var$noop,
    toFiniteNumber: $0192f04cc5678e59$var$toFiniteNumber,
    findKey: $0192f04cc5678e59$var$findKey,
    global: $0192f04cc5678e59$var$_global,
    isContextDefined: $0192f04cc5678e59$var$isContextDefined,
    ALPHABET: $0192f04cc5678e59$var$ALPHABET,
    generateString: $0192f04cc5678e59$var$generateString,
    isSpecCompliantForm: $0192f04cc5678e59$var$isSpecCompliantForm,
    toJSONObject: $0192f04cc5678e59$var$toJSONObject,
    isAsyncFn: $0192f04cc5678e59$var$isAsyncFn,
    isThenable: $0192f04cc5678e59$var$isThenable
};







"use strict";
/**
 * Create an Error with the specified message, config, error code, request and response.
 *
 * @param {string} message The error message.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [config] The config.
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 *
 * @returns {Error} The created error.
 */ function $6c469c5785e54eea$var$AxiosError(message, code, config, request, response) {
    Error.call(this);
    if (Error.captureStackTrace) Error.captureStackTrace(this, this.constructor);
    else this.stack = new Error().stack;
    this.message = message;
    this.name = "AxiosError";
    code && (this.code = code);
    config && (this.config = config);
    request && (this.request = request);
    response && (this.response = response);
}
(0, $0192f04cc5678e59$export$2e2bcd8739ae039).inherits($6c469c5785e54eea$var$AxiosError, Error, {
    toJSON: function toJSON() {
        return {
            // Standard
            message: this.message,
            name: this.name,
            // Microsoft
            description: this.description,
            number: this.number,
            // Mozilla
            fileName: this.fileName,
            lineNumber: this.lineNumber,
            columnNumber: this.columnNumber,
            stack: this.stack,
            // Axios
            config: (0, $0192f04cc5678e59$export$2e2bcd8739ae039).toJSONObject(this.config),
            code: this.code,
            status: this.response && this.response.status ? this.response.status : null
        };
    }
});
const $6c469c5785e54eea$var$prototype = $6c469c5785e54eea$var$AxiosError.prototype;
const $6c469c5785e54eea$var$descriptors = {};
[
    "ERR_BAD_OPTION_VALUE",
    "ERR_BAD_OPTION",
    "ECONNABORTED",
    "ETIMEDOUT",
    "ERR_NETWORK",
    "ERR_FR_TOO_MANY_REDIRECTS",
    "ERR_DEPRECATED",
    "ERR_BAD_RESPONSE",
    "ERR_BAD_REQUEST",
    "ERR_CANCELED",
    "ERR_NOT_SUPPORT",
    "ERR_INVALID_URL"
].forEach((code)=>{
    $6c469c5785e54eea$var$descriptors[code] = {
        value: code
    };
});
Object.defineProperties($6c469c5785e54eea$var$AxiosError, $6c469c5785e54eea$var$descriptors);
Object.defineProperty($6c469c5785e54eea$var$prototype, "isAxiosError", {
    value: true
});
// eslint-disable-next-line func-names
$6c469c5785e54eea$var$AxiosError.from = (error, code, config, request, response, customProps)=>{
    const axiosError = Object.create($6c469c5785e54eea$var$prototype);
    (0, $0192f04cc5678e59$export$2e2bcd8739ae039).toFlatObject(error, axiosError, function filter(obj) {
        return obj !== Error.prototype;
    }, (prop)=>{
        return prop !== "isAxiosError";
    });
    $6c469c5785e54eea$var$AxiosError.call(axiosError, error.message, code, config, request, response);
    axiosError.cause = error;
    axiosError.name = error.name;
    customProps && Object.assign(axiosError, customProps);
    return axiosError;
};
var $6c469c5785e54eea$export$2e2bcd8739ae039 = $6c469c5785e54eea$var$AxiosError;


// eslint-disable-next-line strict
var $8b08fbd4169f9886$export$2e2bcd8739ae039 = null;



var $ihoyg = parcelRequire("ihoyg");
var $0d4b5a284fe8e195$require$Buffer = $ihoyg.Buffer;
"use strict";
/**
 * Determines if the given thing is a array or js object.
 *
 * @param {string} thing - The object or array to be visited.
 *
 * @returns {boolean}
 */ function $0d4b5a284fe8e195$var$isVisitable(thing) {
    return (0, $0192f04cc5678e59$export$2e2bcd8739ae039).isPlainObject(thing) || (0, $0192f04cc5678e59$export$2e2bcd8739ae039).isArray(thing);
}
/**
 * It removes the brackets from the end of a string
 *
 * @param {string} key - The key of the parameter.
 *
 * @returns {string} the key without the brackets.
 */ function $0d4b5a284fe8e195$var$removeBrackets(key) {
    return (0, $0192f04cc5678e59$export$2e2bcd8739ae039).endsWith(key, "[]") ? key.slice(0, -2) : key;
}
/**
 * It takes a path, a key, and a boolean, and returns a string
 *
 * @param {string} path - The path to the current key.
 * @param {string} key - The key of the current object being iterated over.
 * @param {string} dots - If true, the key will be rendered with dots instead of brackets.
 *
 * @returns {string} The path to the current key.
 */ function $0d4b5a284fe8e195$var$renderKey(path, key, dots) {
    if (!path) return key;
    return path.concat(key).map(function each(token, i) {
        // eslint-disable-next-line no-param-reassign
        token = $0d4b5a284fe8e195$var$removeBrackets(token);
        return !dots && i ? "[" + token + "]" : token;
    }).join(dots ? "." : "");
}
/**
 * If the array is an array and none of its elements are visitable, then it's a flat array.
 *
 * @param {Array<any>} arr - The array to check
 *
 * @returns {boolean}
 */ function $0d4b5a284fe8e195$var$isFlatArray(arr) {
    return (0, $0192f04cc5678e59$export$2e2bcd8739ae039).isArray(arr) && !arr.some($0d4b5a284fe8e195$var$isVisitable);
}
const $0d4b5a284fe8e195$var$predicates = (0, $0192f04cc5678e59$export$2e2bcd8739ae039).toFlatObject((0, $0192f04cc5678e59$export$2e2bcd8739ae039), {}, null, function filter(prop) {
    return /^is[A-Z]/.test(prop);
});
/**
 * Convert a data object to FormData
 *
 * @param {Object} obj
 * @param {?Object} [formData]
 * @param {?Object} [options]
 * @param {Function} [options.visitor]
 * @param {Boolean} [options.metaTokens = true]
 * @param {Boolean} [options.dots = false]
 * @param {?Boolean} [options.indexes = false]
 *
 * @returns {Object}
 **/ /**
 * It converts an object into a FormData object
 *
 * @param {Object<any, any>} obj - The object to convert to form data.
 * @param {string} formData - The FormData object to append to.
 * @param {Object<string, any>} options
 *
 * @returns
 */ function $0d4b5a284fe8e195$var$toFormData(obj, formData, options) {
    if (!(0, $0192f04cc5678e59$export$2e2bcd8739ae039).isObject(obj)) throw new TypeError("target must be an object");
    // eslint-disable-next-line no-param-reassign
    formData = formData || new ((0, $8b08fbd4169f9886$export$2e2bcd8739ae039) || FormData)();
    // eslint-disable-next-line no-param-reassign
    options = (0, $0192f04cc5678e59$export$2e2bcd8739ae039).toFlatObject(options, {
        metaTokens: true,
        dots: false,
        indexes: false
    }, false, function defined(option, source) {
        // eslint-disable-next-line no-eq-null,eqeqeq
        return !(0, $0192f04cc5678e59$export$2e2bcd8739ae039).isUndefined(source[option]);
    });
    const metaTokens = options.metaTokens;
    // eslint-disable-next-line no-use-before-define
    const visitor = options.visitor || defaultVisitor;
    const dots = options.dots;
    const indexes = options.indexes;
    const _Blob = options.Blob || typeof Blob !== "undefined" && Blob;
    const useBlob = _Blob && (0, $0192f04cc5678e59$export$2e2bcd8739ae039).isSpecCompliantForm(formData);
    if (!(0, $0192f04cc5678e59$export$2e2bcd8739ae039).isFunction(visitor)) throw new TypeError("visitor must be a function");
    function convertValue(value) {
        if (value === null) return "";
        if ((0, $0192f04cc5678e59$export$2e2bcd8739ae039).isDate(value)) return value.toISOString();
        if (!useBlob && (0, $0192f04cc5678e59$export$2e2bcd8739ae039).isBlob(value)) throw new (0, $6c469c5785e54eea$export$2e2bcd8739ae039)("Blob is not supported. Use a Buffer instead.");
        if ((0, $0192f04cc5678e59$export$2e2bcd8739ae039).isArrayBuffer(value) || (0, $0192f04cc5678e59$export$2e2bcd8739ae039).isTypedArray(value)) return useBlob && typeof Blob === "function" ? new Blob([
            value
        ]) : $0d4b5a284fe8e195$require$Buffer.from(value);
        return value;
    }
    /**
   * Default visitor.
   *
   * @param {*} value
   * @param {String|Number} key
   * @param {Array<String|Number>} path
   * @this {FormData}
   *
   * @returns {boolean} return true to visit the each prop of the value recursively
   */ function defaultVisitor(value, key, path) {
        let arr = value;
        if (value && !path && typeof value === "object") {
            if ((0, $0192f04cc5678e59$export$2e2bcd8739ae039).endsWith(key, "{}")) {
                // eslint-disable-next-line no-param-reassign
                key = metaTokens ? key : key.slice(0, -2);
                // eslint-disable-next-line no-param-reassign
                value = JSON.stringify(value);
            } else if ((0, $0192f04cc5678e59$export$2e2bcd8739ae039).isArray(value) && $0d4b5a284fe8e195$var$isFlatArray(value) || ((0, $0192f04cc5678e59$export$2e2bcd8739ae039).isFileList(value) || (0, $0192f04cc5678e59$export$2e2bcd8739ae039).endsWith(key, "[]")) && (arr = (0, $0192f04cc5678e59$export$2e2bcd8739ae039).toArray(value))) {
                // eslint-disable-next-line no-param-reassign
                key = $0d4b5a284fe8e195$var$removeBrackets(key);
                arr.forEach(function each(el, index) {
                    !((0, $0192f04cc5678e59$export$2e2bcd8739ae039).isUndefined(el) || el === null) && formData.append(// eslint-disable-next-line no-nested-ternary
                    indexes === true ? $0d4b5a284fe8e195$var$renderKey([
                        key
                    ], index, dots) : indexes === null ? key : key + "[]", convertValue(el));
                });
                return false;
            }
        }
        if ($0d4b5a284fe8e195$var$isVisitable(value)) return true;
        formData.append($0d4b5a284fe8e195$var$renderKey(path, key, dots), convertValue(value));
        return false;
    }
    const stack = [];
    const exposedHelpers = Object.assign($0d4b5a284fe8e195$var$predicates, {
        defaultVisitor: defaultVisitor,
        convertValue: convertValue,
        isVisitable: $0d4b5a284fe8e195$var$isVisitable
    });
    function build(value, path) {
        if ((0, $0192f04cc5678e59$export$2e2bcd8739ae039).isUndefined(value)) return;
        if (stack.indexOf(value) !== -1) throw Error("Circular reference detected in " + path.join("."));
        stack.push(value);
        (0, $0192f04cc5678e59$export$2e2bcd8739ae039).forEach(value, function each(el, key) {
            const result = !((0, $0192f04cc5678e59$export$2e2bcd8739ae039).isUndefined(el) || el === null) && visitor.call(formData, el, (0, $0192f04cc5678e59$export$2e2bcd8739ae039).isString(key) ? key.trim() : key, path, exposedHelpers);
            if (result === true) build(el, path ? path.concat(key) : [
                key
            ]);
        });
        stack.pop();
    }
    if (!(0, $0192f04cc5678e59$export$2e2bcd8739ae039).isObject(obj)) throw new TypeError("data must be an object");
    build(obj);
    return formData;
}
var $0d4b5a284fe8e195$export$2e2bcd8739ae039 = $0d4b5a284fe8e195$var$toFormData;


"use strict";
/**
 * It encodes a string by replacing all characters that are not in the unreserved set with
 * their percent-encoded equivalents
 *
 * @param {string} str - The string to encode.
 *
 * @returns {string} The encoded string.
 */ function $d7f78aab1bc5b33e$var$encode(str) {
    const charMap = {
        "!": "%21",
        "'": "%27",
        "(": "%28",
        ")": "%29",
        "~": "%7E",
        "%20": "+",
        "%00": "\x00"
    };
    return encodeURIComponent(str).replace(/[!'()~]|%20|%00/g, function replacer(match) {
        return charMap[match];
    });
}
/**
 * It takes a params object and converts it to a FormData object
 *
 * @param {Object<string, any>} params - The parameters to be converted to a FormData object.
 * @param {Object<string, any>} options - The options object passed to the Axios constructor.
 *
 * @returns {void}
 */ function $d7f78aab1bc5b33e$var$AxiosURLSearchParams(params, options) {
    this._pairs = [];
    params && (0, $0d4b5a284fe8e195$export$2e2bcd8739ae039)(params, this, options);
}
const $d7f78aab1bc5b33e$var$prototype = $d7f78aab1bc5b33e$var$AxiosURLSearchParams.prototype;
$d7f78aab1bc5b33e$var$prototype.append = function append(name, value) {
    this._pairs.push([
        name,
        value
    ]);
};
$d7f78aab1bc5b33e$var$prototype.toString = function toString(encoder) {
    const _encode = encoder ? function(value) {
        return encoder.call(this, value, $d7f78aab1bc5b33e$var$encode);
    } : $d7f78aab1bc5b33e$var$encode;
    return this._pairs.map(function each(pair) {
        return _encode(pair[0]) + "=" + _encode(pair[1]);
    }, "").join("&");
};
var $d7f78aab1bc5b33e$export$2e2bcd8739ae039 = $d7f78aab1bc5b33e$var$AxiosURLSearchParams;


"use strict";
/**
 * It replaces all instances of the characters `:`, `$`, `,`, `+`, `[`, and `]` with their
 * URI encoded counterparts
 *
 * @param {string} val The value to be encoded.
 *
 * @returns {string} The encoded value.
 */ function $3d0efc7c17e6920d$var$encode(val) {
    return encodeURIComponent(val).replace(/%3A/gi, ":").replace(/%24/g, "$").replace(/%2C/gi, ",").replace(/%20/g, "+").replace(/%5B/gi, "[").replace(/%5D/gi, "]");
}
function $3d0efc7c17e6920d$export$2e2bcd8739ae039(url, params, options) {
    /*eslint no-param-reassign:0*/ if (!params) return url;
    const _encode = options && options.encode || $3d0efc7c17e6920d$var$encode;
    const serializeFn = options && options.serialize;
    let serializedParams;
    if (serializeFn) serializedParams = serializeFn(params, options);
    else serializedParams = (0, $0192f04cc5678e59$export$2e2bcd8739ae039).isURLSearchParams(params) ? params.toString() : new (0, $d7f78aab1bc5b33e$export$2e2bcd8739ae039)(params, options).toString(_encode);
    if (serializedParams) {
        const hashmarkIndex = url.indexOf("#");
        if (hashmarkIndex !== -1) url = url.slice(0, hashmarkIndex);
        url += (url.indexOf("?") === -1 ? "?" : "&") + serializedParams;
    }
    return url;
}



"use strict";
class $a64589aa1f221b38$var$InterceptorManager {
    constructor(){
        this.handlers = [];
    }
    /**
   * Add a new interceptor to the stack
   *
   * @param {Function} fulfilled The function to handle `then` for a `Promise`
   * @param {Function} rejected The function to handle `reject` for a `Promise`
   *
   * @return {Number} An ID used to remove interceptor later
   */ use(fulfilled, rejected, options) {
        this.handlers.push({
            fulfilled: fulfilled,
            rejected: rejected,
            synchronous: options ? options.synchronous : false,
            runWhen: options ? options.runWhen : null
        });
        return this.handlers.length - 1;
    }
    /**
   * Remove an interceptor from the stack
   *
   * @param {Number} id The ID that was returned by `use`
   *
   * @returns {Boolean} `true` if the interceptor was removed, `false` otherwise
   */ eject(id) {
        if (this.handlers[id]) this.handlers[id] = null;
    }
    /**
   * Clear all interceptors from the stack
   *
   * @returns {void}
   */ clear() {
        if (this.handlers) this.handlers = [];
    }
    /**
   * Iterate over all the registered interceptors
   *
   * This method is particularly useful for skipping over any
   * interceptors that may have become `null` calling `eject`.
   *
   * @param {Function} fn The function to call for each interceptor
   *
   * @returns {void}
   */ forEach(fn) {
        (0, $0192f04cc5678e59$export$2e2bcd8739ae039).forEach(this.handlers, function forEachHandler(h) {
            if (h !== null) fn(h);
        });
    }
}
var $a64589aa1f221b38$export$2e2bcd8739ae039 = $a64589aa1f221b38$var$InterceptorManager;





"use strict";
var $1b870b86699c28bd$export$2e2bcd8739ae039 = {
    silentJSONParsing: true,
    forcedJSONParsing: true,
    clarifyTimeoutError: false
};






"use strict";
var $f842df2615a0587a$export$2e2bcd8739ae039 = typeof URLSearchParams !== "undefined" ? URLSearchParams : (0, $d7f78aab1bc5b33e$export$2e2bcd8739ae039);


"use strict";
var $501acf3741764b20$export$2e2bcd8739ae039 = typeof FormData !== "undefined" ? FormData : null;


"use strict";
var $77a99499b781ca7a$export$2e2bcd8739ae039 = typeof Blob !== "undefined" ? Blob : null;


/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 * nativescript
 *  navigator.product -> 'NativeScript' or 'NS'
 *
 * @returns {boolean}
 */ const $be1053aa0e0e49c6$var$isStandardBrowserEnv = (()=>{
    let product;
    if (typeof navigator !== "undefined" && ((product = navigator.product) === "ReactNative" || product === "NativeScript" || product === "NS")) return false;
    return typeof window !== "undefined" && typeof document !== "undefined";
})();
/**
 * Determine if we're running in a standard browser webWorker environment
 *
 * Although the `isStandardBrowserEnv` method indicates that
 * `allows axios to run in a web worker`, the WebWorker will still be
 * filtered out due to its judgment standard
 * `typeof window !== 'undefined' && typeof document !== 'undefined'`.
 * This leads to a problem when axios post `FormData` in webWorker
 */ const $be1053aa0e0e49c6$var$isStandardBrowserWebWorkerEnv = (()=>{
    return typeof WorkerGlobalScope !== "undefined" && // eslint-disable-next-line no-undef
    self instanceof WorkerGlobalScope && typeof self.importScripts === "function";
})();
var $be1053aa0e0e49c6$export$2e2bcd8739ae039 = {
    isBrowser: true,
    classes: {
        URLSearchParams: $f842df2615a0587a$export$2e2bcd8739ae039,
        FormData: $501acf3741764b20$export$2e2bcd8739ae039,
        Blob: $77a99499b781ca7a$export$2e2bcd8739ae039
    },
    isStandardBrowserEnv: $be1053aa0e0e49c6$var$isStandardBrowserEnv,
    isStandardBrowserWebWorkerEnv: $be1053aa0e0e49c6$var$isStandardBrowserWebWorkerEnv,
    protocols: [
        "http",
        "https",
        "file",
        "blob",
        "url",
        "data"
    ]
};


"use strict";
function $06a8e20bd786e4ef$export$2e2bcd8739ae039(data, options) {
    return (0, $0d4b5a284fe8e195$export$2e2bcd8739ae039)(data, new (0, $be1053aa0e0e49c6$export$2e2bcd8739ae039).classes.URLSearchParams(), Object.assign({
        visitor: function(value, key, path, helpers) {
            if ((0, $be1053aa0e0e49c6$export$2e2bcd8739ae039).isNode && (0, $0192f04cc5678e59$export$2e2bcd8739ae039).isBuffer(value)) {
                this.append(key, value.toString("base64"));
                return false;
            }
            return helpers.defaultVisitor.apply(this, arguments);
        }
    }, options));
}




"use strict";
/**
 * It takes a string like `foo[x][y][z]` and returns an array like `['foo', 'x', 'y', 'z']
 *
 * @param {string} name - The name of the property to get.
 *
 * @returns An array of strings.
 */ function $21a975081709563b$var$parsePropPath(name) {
    // foo[x][y][z]
    // foo.x.y.z
    // foo-x-y-z
    // foo x y z
    return (0, $0192f04cc5678e59$export$2e2bcd8739ae039).matchAll(/\w+|\[(\w*)]/g, name).map((match)=>{
        return match[0] === "[]" ? "" : match[1] || match[0];
    });
}
/**
 * Convert an array to an object.
 *
 * @param {Array<any>} arr - The array to convert to an object.
 *
 * @returns An object with the same keys and values as the array.
 */ function $21a975081709563b$var$arrayToObject(arr) {
    const obj = {};
    const keys = Object.keys(arr);
    let i;
    const len = keys.length;
    let key;
    for(i = 0; i < len; i++){
        key = keys[i];
        obj[key] = arr[key];
    }
    return obj;
}
/**
 * It takes a FormData object and returns a JavaScript object
 *
 * @param {string} formData The FormData object to convert to JSON.
 *
 * @returns {Object<string, any> | null} The converted object.
 */ function $21a975081709563b$var$formDataToJSON(formData) {
    function buildPath(path, value, target, index) {
        let name = path[index++];
        const isNumericKey = Number.isFinite(+name);
        const isLast = index >= path.length;
        name = !name && (0, $0192f04cc5678e59$export$2e2bcd8739ae039).isArray(target) ? target.length : name;
        if (isLast) {
            if ((0, $0192f04cc5678e59$export$2e2bcd8739ae039).hasOwnProp(target, name)) target[name] = [
                target[name],
                value
            ];
            else target[name] = value;
            return !isNumericKey;
        }
        if (!target[name] || !(0, $0192f04cc5678e59$export$2e2bcd8739ae039).isObject(target[name])) target[name] = [];
        const result = buildPath(path, value, target[name], index);
        if (result && (0, $0192f04cc5678e59$export$2e2bcd8739ae039).isArray(target[name])) target[name] = $21a975081709563b$var$arrayToObject(target[name]);
        return !isNumericKey;
    }
    if ((0, $0192f04cc5678e59$export$2e2bcd8739ae039).isFormData(formData) && (0, $0192f04cc5678e59$export$2e2bcd8739ae039).isFunction(formData.entries)) {
        const obj = {};
        (0, $0192f04cc5678e59$export$2e2bcd8739ae039).forEachEntry(formData, (name, value)=>{
            buildPath($21a975081709563b$var$parsePropPath(name), value, obj, 0);
        });
        return obj;
    }
    return null;
}
var $21a975081709563b$export$2e2bcd8739ae039 = $21a975081709563b$var$formDataToJSON;


"use strict";
const $5e78738d4ebd95bc$var$DEFAULT_CONTENT_TYPE = {
    "Content-Type": undefined
};
/**
 * It takes a string, tries to parse it, and if it fails, it returns the stringified version
 * of the input
 *
 * @param {any} rawValue - The value to be stringified.
 * @param {Function} parser - A function that parses a string into a JavaScript object.
 * @param {Function} encoder - A function that takes a value and returns a string.
 *
 * @returns {string} A stringified version of the rawValue.
 */ function $5e78738d4ebd95bc$var$stringifySafely(rawValue, parser, encoder) {
    if ((0, $0192f04cc5678e59$export$2e2bcd8739ae039).isString(rawValue)) try {
        (parser || JSON.parse)(rawValue);
        return (0, $0192f04cc5678e59$export$2e2bcd8739ae039).trim(rawValue);
    } catch (e) {
        if (e.name !== "SyntaxError") throw e;
    }
    return (encoder || JSON.stringify)(rawValue);
}
const $5e78738d4ebd95bc$var$defaults = {
    transitional: (0, $1b870b86699c28bd$export$2e2bcd8739ae039),
    adapter: [
        "xhr",
        "http"
    ],
    transformRequest: [
        function transformRequest(data, headers) {
            const contentType = headers.getContentType() || "";
            const hasJSONContentType = contentType.indexOf("application/json") > -1;
            const isObjectPayload = (0, $0192f04cc5678e59$export$2e2bcd8739ae039).isObject(data);
            if (isObjectPayload && (0, $0192f04cc5678e59$export$2e2bcd8739ae039).isHTMLForm(data)) data = new FormData(data);
            const isFormData = (0, $0192f04cc5678e59$export$2e2bcd8739ae039).isFormData(data);
            if (isFormData) {
                if (!hasJSONContentType) return data;
                return hasJSONContentType ? JSON.stringify((0, $21a975081709563b$export$2e2bcd8739ae039)(data)) : data;
            }
            if ((0, $0192f04cc5678e59$export$2e2bcd8739ae039).isArrayBuffer(data) || (0, $0192f04cc5678e59$export$2e2bcd8739ae039).isBuffer(data) || (0, $0192f04cc5678e59$export$2e2bcd8739ae039).isStream(data) || (0, $0192f04cc5678e59$export$2e2bcd8739ae039).isFile(data) || (0, $0192f04cc5678e59$export$2e2bcd8739ae039).isBlob(data)) return data;
            if ((0, $0192f04cc5678e59$export$2e2bcd8739ae039).isArrayBufferView(data)) return data.buffer;
            if ((0, $0192f04cc5678e59$export$2e2bcd8739ae039).isURLSearchParams(data)) {
                headers.setContentType("application/x-www-form-urlencoded;charset=utf-8", false);
                return data.toString();
            }
            let isFileList;
            if (isObjectPayload) {
                if (contentType.indexOf("application/x-www-form-urlencoded") > -1) return (0, $06a8e20bd786e4ef$export$2e2bcd8739ae039)(data, this.formSerializer).toString();
                if ((isFileList = (0, $0192f04cc5678e59$export$2e2bcd8739ae039).isFileList(data)) || contentType.indexOf("multipart/form-data") > -1) {
                    const _FormData = this.env && this.env.FormData;
                    return (0, $0d4b5a284fe8e195$export$2e2bcd8739ae039)(isFileList ? {
                        "files[]": data
                    } : data, _FormData && new _FormData(), this.formSerializer);
                }
            }
            if (isObjectPayload || hasJSONContentType) {
                headers.setContentType("application/json", false);
                return $5e78738d4ebd95bc$var$stringifySafely(data);
            }
            return data;
        }
    ],
    transformResponse: [
        function transformResponse(data) {
            const transitional = this.transitional || $5e78738d4ebd95bc$var$defaults.transitional;
            const forcedJSONParsing = transitional && transitional.forcedJSONParsing;
            const JSONRequested = this.responseType === "json";
            if (data && (0, $0192f04cc5678e59$export$2e2bcd8739ae039).isString(data) && (forcedJSONParsing && !this.responseType || JSONRequested)) {
                const silentJSONParsing = transitional && transitional.silentJSONParsing;
                const strictJSONParsing = !silentJSONParsing && JSONRequested;
                try {
                    return JSON.parse(data);
                } catch (e) {
                    if (strictJSONParsing) {
                        if (e.name === "SyntaxError") throw (0, $6c469c5785e54eea$export$2e2bcd8739ae039).from(e, (0, $6c469c5785e54eea$export$2e2bcd8739ae039).ERR_BAD_RESPONSE, this, null, this.response);
                        throw e;
                    }
                }
            }
            return data;
        }
    ],
    /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */ timeout: 0,
    xsrfCookieName: "XSRF-TOKEN",
    xsrfHeaderName: "X-XSRF-TOKEN",
    maxContentLength: -1,
    maxBodyLength: -1,
    env: {
        FormData: (0, $be1053aa0e0e49c6$export$2e2bcd8739ae039).classes.FormData,
        Blob: (0, $be1053aa0e0e49c6$export$2e2bcd8739ae039).classes.Blob
    },
    validateStatus: function validateStatus(status) {
        return status >= 200 && status < 300;
    },
    headers: {
        common: {
            "Accept": "application/json, text/plain, */*"
        }
    }
};
(0, $0192f04cc5678e59$export$2e2bcd8739ae039).forEach([
    "delete",
    "get",
    "head"
], function forEachMethodNoData(method) {
    $5e78738d4ebd95bc$var$defaults.headers[method] = {};
});
(0, $0192f04cc5678e59$export$2e2bcd8739ae039).forEach([
    "post",
    "put",
    "patch"
], function forEachMethodWithData(method) {
    $5e78738d4ebd95bc$var$defaults.headers[method] = (0, $0192f04cc5678e59$export$2e2bcd8739ae039).merge($5e78738d4ebd95bc$var$DEFAULT_CONTENT_TYPE);
});
var $5e78738d4ebd95bc$export$2e2bcd8739ae039 = $5e78738d4ebd95bc$var$defaults;




"use strict";
// RawAxiosHeaders whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
const $7cc74ec6f080040e$var$ignoreDuplicateOf = (0, $0192f04cc5678e59$export$2e2bcd8739ae039).toObjectSet([
    "age",
    "authorization",
    "content-length",
    "content-type",
    "etag",
    "expires",
    "from",
    "host",
    "if-modified-since",
    "if-unmodified-since",
    "last-modified",
    "location",
    "max-forwards",
    "proxy-authorization",
    "referer",
    "retry-after",
    "user-agent"
]);
var /**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} rawHeaders Headers needing to be parsed
 *
 * @returns {Object} Headers parsed into an object
 */ $7cc74ec6f080040e$export$2e2bcd8739ae039 = (rawHeaders)=>{
    const parsed = {};
    let key;
    let val;
    let i;
    rawHeaders && rawHeaders.split("\n").forEach(function parser(line) {
        i = line.indexOf(":");
        key = line.substring(0, i).trim().toLowerCase();
        val = line.substring(i + 1).trim();
        if (!key || parsed[key] && $7cc74ec6f080040e$var$ignoreDuplicateOf[key]) return;
        if (key === "set-cookie") {
            if (parsed[key]) parsed[key].push(val);
            else parsed[key] = [
                val
            ];
        } else parsed[key] = parsed[key] ? parsed[key] + ", " + val : val;
    });
    return parsed;
};


"use strict";
const $e14bcbc095f9985e$var$$internals = Symbol("internals");
function $e14bcbc095f9985e$var$normalizeHeader(header) {
    return header && String(header).trim().toLowerCase();
}
function $e14bcbc095f9985e$var$normalizeValue(value) {
    if (value === false || value == null) return value;
    return (0, $0192f04cc5678e59$export$2e2bcd8739ae039).isArray(value) ? value.map($e14bcbc095f9985e$var$normalizeValue) : String(value);
}
function $e14bcbc095f9985e$var$parseTokens(str) {
    const tokens = Object.create(null);
    const tokensRE = /([^\s,;=]+)\s*(?:=\s*([^,;]+))?/g;
    let match;
    while(match = tokensRE.exec(str))tokens[match[1]] = match[2];
    return tokens;
}
const $e14bcbc095f9985e$var$isValidHeaderName = (str)=>/^[-_a-zA-Z0-9^`|~,!#$%&'*+.]+$/.test(str.trim());
function $e14bcbc095f9985e$var$matchHeaderValue(context, value, header, filter, isHeaderNameFilter) {
    if ((0, $0192f04cc5678e59$export$2e2bcd8739ae039).isFunction(filter)) return filter.call(this, value, header);
    if (isHeaderNameFilter) value = header;
    if (!(0, $0192f04cc5678e59$export$2e2bcd8739ae039).isString(value)) return;
    if ((0, $0192f04cc5678e59$export$2e2bcd8739ae039).isString(filter)) return value.indexOf(filter) !== -1;
    if ((0, $0192f04cc5678e59$export$2e2bcd8739ae039).isRegExp(filter)) return filter.test(value);
}
function $e14bcbc095f9985e$var$formatHeader(header) {
    return header.trim().toLowerCase().replace(/([a-z\d])(\w*)/g, (w, char, str)=>{
        return char.toUpperCase() + str;
    });
}
function $e14bcbc095f9985e$var$buildAccessors(obj, header) {
    const accessorName = (0, $0192f04cc5678e59$export$2e2bcd8739ae039).toCamelCase(" " + header);
    [
        "get",
        "set",
        "has"
    ].forEach((methodName)=>{
        Object.defineProperty(obj, methodName + accessorName, {
            value: function(arg1, arg2, arg3) {
                return this[methodName].call(this, header, arg1, arg2, arg3);
            },
            configurable: true
        });
    });
}
class $e14bcbc095f9985e$var$AxiosHeaders {
    constructor(headers){
        headers && this.set(headers);
    }
    set(header, valueOrRewrite, rewrite) {
        const self = this;
        function setHeader(_value, _header, _rewrite) {
            const lHeader = $e14bcbc095f9985e$var$normalizeHeader(_header);
            if (!lHeader) throw new Error("header name must be a non-empty string");
            const key = (0, $0192f04cc5678e59$export$2e2bcd8739ae039).findKey(self, lHeader);
            if (!key || self[key] === undefined || _rewrite === true || _rewrite === undefined && self[key] !== false) self[key || _header] = $e14bcbc095f9985e$var$normalizeValue(_value);
        }
        const setHeaders = (headers, _rewrite)=>(0, $0192f04cc5678e59$export$2e2bcd8739ae039).forEach(headers, (_value, _header)=>setHeader(_value, _header, _rewrite));
        if ((0, $0192f04cc5678e59$export$2e2bcd8739ae039).isPlainObject(header) || header instanceof this.constructor) setHeaders(header, valueOrRewrite);
        else if ((0, $0192f04cc5678e59$export$2e2bcd8739ae039).isString(header) && (header = header.trim()) && !$e14bcbc095f9985e$var$isValidHeaderName(header)) setHeaders((0, $7cc74ec6f080040e$export$2e2bcd8739ae039)(header), valueOrRewrite);
        else header != null && setHeader(valueOrRewrite, header, rewrite);
        return this;
    }
    get(header, parser) {
        header = $e14bcbc095f9985e$var$normalizeHeader(header);
        if (header) {
            const key = (0, $0192f04cc5678e59$export$2e2bcd8739ae039).findKey(this, header);
            if (key) {
                const value = this[key];
                if (!parser) return value;
                if (parser === true) return $e14bcbc095f9985e$var$parseTokens(value);
                if ((0, $0192f04cc5678e59$export$2e2bcd8739ae039).isFunction(parser)) return parser.call(this, value, key);
                if ((0, $0192f04cc5678e59$export$2e2bcd8739ae039).isRegExp(parser)) return parser.exec(value);
                throw new TypeError("parser must be boolean|regexp|function");
            }
        }
    }
    has(header, matcher) {
        header = $e14bcbc095f9985e$var$normalizeHeader(header);
        if (header) {
            const key = (0, $0192f04cc5678e59$export$2e2bcd8739ae039).findKey(this, header);
            return !!(key && this[key] !== undefined && (!matcher || $e14bcbc095f9985e$var$matchHeaderValue(this, this[key], key, matcher)));
        }
        return false;
    }
    delete(header, matcher) {
        const self = this;
        let deleted = false;
        function deleteHeader(_header) {
            _header = $e14bcbc095f9985e$var$normalizeHeader(_header);
            if (_header) {
                const key = (0, $0192f04cc5678e59$export$2e2bcd8739ae039).findKey(self, _header);
                if (key && (!matcher || $e14bcbc095f9985e$var$matchHeaderValue(self, self[key], key, matcher))) {
                    delete self[key];
                    deleted = true;
                }
            }
        }
        if ((0, $0192f04cc5678e59$export$2e2bcd8739ae039).isArray(header)) header.forEach(deleteHeader);
        else deleteHeader(header);
        return deleted;
    }
    clear(matcher) {
        const keys = Object.keys(this);
        let i = keys.length;
        let deleted = false;
        while(i--){
            const key = keys[i];
            if (!matcher || $e14bcbc095f9985e$var$matchHeaderValue(this, this[key], key, matcher, true)) {
                delete this[key];
                deleted = true;
            }
        }
        return deleted;
    }
    normalize(format) {
        const self = this;
        const headers = {};
        (0, $0192f04cc5678e59$export$2e2bcd8739ae039).forEach(this, (value, header)=>{
            const key = (0, $0192f04cc5678e59$export$2e2bcd8739ae039).findKey(headers, header);
            if (key) {
                self[key] = $e14bcbc095f9985e$var$normalizeValue(value);
                delete self[header];
                return;
            }
            const normalized = format ? $e14bcbc095f9985e$var$formatHeader(header) : String(header).trim();
            if (normalized !== header) delete self[header];
            self[normalized] = $e14bcbc095f9985e$var$normalizeValue(value);
            headers[normalized] = true;
        });
        return this;
    }
    concat(...targets) {
        return this.constructor.concat(this, ...targets);
    }
    toJSON(asStrings) {
        const obj = Object.create(null);
        (0, $0192f04cc5678e59$export$2e2bcd8739ae039).forEach(this, (value, header)=>{
            value != null && value !== false && (obj[header] = asStrings && (0, $0192f04cc5678e59$export$2e2bcd8739ae039).isArray(value) ? value.join(", ") : value);
        });
        return obj;
    }
    [Symbol.iterator]() {
        return Object.entries(this.toJSON())[Symbol.iterator]();
    }
    toString() {
        return Object.entries(this.toJSON()).map(([header, value])=>header + ": " + value).join("\n");
    }
    get [Symbol.toStringTag]() {
        return "AxiosHeaders";
    }
    static from(thing) {
        return thing instanceof this ? thing : new this(thing);
    }
    static concat(first, ...targets) {
        const computed = new this(first);
        targets.forEach((target)=>computed.set(target));
        return computed;
    }
    static accessor(header) {
        const internals = this[$e14bcbc095f9985e$var$$internals] = this[$e14bcbc095f9985e$var$$internals] = {
            accessors: {}
        };
        const accessors = internals.accessors;
        const prototype = this.prototype;
        function defineAccessor(_header) {
            const lHeader = $e14bcbc095f9985e$var$normalizeHeader(_header);
            if (!accessors[lHeader]) {
                $e14bcbc095f9985e$var$buildAccessors(prototype, _header);
                accessors[lHeader] = true;
            }
        }
        (0, $0192f04cc5678e59$export$2e2bcd8739ae039).isArray(header) ? header.forEach(defineAccessor) : defineAccessor(header);
        return this;
    }
}
$e14bcbc095f9985e$var$AxiosHeaders.accessor([
    "Content-Type",
    "Content-Length",
    "Accept",
    "Accept-Encoding",
    "User-Agent",
    "Authorization"
]);
(0, $0192f04cc5678e59$export$2e2bcd8739ae039).freezeMethods($e14bcbc095f9985e$var$AxiosHeaders.prototype);
(0, $0192f04cc5678e59$export$2e2bcd8739ae039).freezeMethods($e14bcbc095f9985e$var$AxiosHeaders);
var $e14bcbc095f9985e$export$2e2bcd8739ae039 = $e14bcbc095f9985e$var$AxiosHeaders;


"use strict";
function $386e7707ebfe8f00$export$2e2bcd8739ae039(fns, response) {
    const config = this || (0, $5e78738d4ebd95bc$export$2e2bcd8739ae039);
    const context = response || config;
    const headers = (0, $e14bcbc095f9985e$export$2e2bcd8739ae039).from(context.headers);
    let data = context.data;
    (0, $0192f04cc5678e59$export$2e2bcd8739ae039).forEach(fns, function transform(fn) {
        data = fn.call(config, data, headers.normalize(), response ? response.status : undefined);
    });
    headers.normalize();
    return data;
}


"use strict";
function $206f3521bd755a95$export$2e2bcd8739ae039(value) {
    return !!(value && value.__CANCEL__);
}





"use strict";
/**
 * A `CanceledError` is an object that is thrown when an operation is canceled.
 *
 * @param {string=} message The message.
 * @param {Object=} config The config.
 * @param {Object=} request The request.
 *
 * @returns {CanceledError} The created error.
 */ function $24205865f62eb2eb$var$CanceledError(message, config, request) {
    // eslint-disable-next-line no-eq-null,eqeqeq
    (0, $6c469c5785e54eea$export$2e2bcd8739ae039).call(this, message == null ? "canceled" : message, (0, $6c469c5785e54eea$export$2e2bcd8739ae039).ERR_CANCELED, config, request);
    this.name = "CanceledError";
}
(0, $0192f04cc5678e59$export$2e2bcd8739ae039).inherits($24205865f62eb2eb$var$CanceledError, (0, $6c469c5785e54eea$export$2e2bcd8739ae039), {
    __CANCEL__: true
});
var $24205865f62eb2eb$export$2e2bcd8739ae039 = $24205865f62eb2eb$var$CanceledError;







"use strict";
function $c4aa2d1358cf7102$export$2e2bcd8739ae039(resolve, reject, response) {
    const validateStatus = response.config.validateStatus;
    if (!response.status || !validateStatus || validateStatus(response.status)) resolve(response);
    else reject(new (0, $6c469c5785e54eea$export$2e2bcd8739ae039)("Request failed with status code " + response.status, [
        (0, $6c469c5785e54eea$export$2e2bcd8739ae039).ERR_BAD_REQUEST,
        (0, $6c469c5785e54eea$export$2e2bcd8739ae039).ERR_BAD_RESPONSE
    ][Math.floor(response.status / 100) - 4], response.config, response.request, response));
}




"use strict";
var $290d98c1e753543a$export$2e2bcd8739ae039 = (0, $be1053aa0e0e49c6$export$2e2bcd8739ae039).isStandardBrowserEnv ? // Standard browser envs support document.cookie
function standardBrowserEnv() {
    return {
        write: function write(name, value, expires, path, domain, secure) {
            const cookie = [];
            cookie.push(name + "=" + encodeURIComponent(value));
            if ((0, $0192f04cc5678e59$export$2e2bcd8739ae039).isNumber(expires)) cookie.push("expires=" + new Date(expires).toGMTString());
            if ((0, $0192f04cc5678e59$export$2e2bcd8739ae039).isString(path)) cookie.push("path=" + path);
            if ((0, $0192f04cc5678e59$export$2e2bcd8739ae039).isString(domain)) cookie.push("domain=" + domain);
            if (secure === true) cookie.push("secure");
            document.cookie = cookie.join("; ");
        },
        read: function read(name) {
            const match = document.cookie.match(new RegExp("(^|;\\s*)(" + name + ")=([^;]*)"));
            return match ? decodeURIComponent(match[3]) : null;
        },
        remove: function remove(name) {
            this.write(name, "", Date.now() - 86400000);
        }
    };
}() : // Non standard browser env (web workers, react-native) lack needed support.
function nonStandardBrowserEnv() {
    return {
        write: function write() {},
        read: function read() {
            return null;
        },
        remove: function remove() {}
    };
}();



"use strict";
function $9c4df7f0c1d8bc52$export$2e2bcd8739ae039(url) {
    // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
    // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
    // by any combination of letters, digits, plus, period, or hyphen.
    return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(url);
}


"use strict";
function $513fa9a84a975711$export$2e2bcd8739ae039(baseURL, relativeURL) {
    return relativeURL ? baseURL.replace(/\/+$/, "") + "/" + relativeURL.replace(/^\/+/, "") : baseURL;
}


"use strict";
function $a6c753bf26fbf0f9$export$2e2bcd8739ae039(baseURL, requestedURL) {
    if (baseURL && !(0, $9c4df7f0c1d8bc52$export$2e2bcd8739ae039)(requestedURL)) return (0, $513fa9a84a975711$export$2e2bcd8739ae039)(baseURL, requestedURL);
    return requestedURL;
}




"use strict";
var $7bbb18aebf337532$export$2e2bcd8739ae039 = (0, $be1053aa0e0e49c6$export$2e2bcd8739ae039).isStandardBrowserEnv ? // Standard browser envs have full support of the APIs needed to test
// whether the request URL is of the same origin as current location.
function standardBrowserEnv() {
    const msie = /(msie|trident)/i.test(navigator.userAgent);
    const urlParsingNode = document.createElement("a");
    let originURL;
    /**
    * Parse a URL to discover it's components
    *
    * @param {String} url The URL to be parsed
    * @returns {Object}
    */ function resolveURL(url) {
        let href = url;
        if (msie) {
            // IE needs attribute set twice to normalize properties
            urlParsingNode.setAttribute("href", href);
            href = urlParsingNode.href;
        }
        urlParsingNode.setAttribute("href", href);
        // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
        return {
            href: urlParsingNode.href,
            protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, "") : "",
            host: urlParsingNode.host,
            search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, "") : "",
            hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, "") : "",
            hostname: urlParsingNode.hostname,
            port: urlParsingNode.port,
            pathname: urlParsingNode.pathname.charAt(0) === "/" ? urlParsingNode.pathname : "/" + urlParsingNode.pathname
        };
    }
    originURL = resolveURL(window.location.href);
    /**
    * Determine if a URL shares the same origin as the current location
    *
    * @param {String} requestURL The URL to test
    * @returns {boolean} True if URL shares the same origin, otherwise false
    */ return function isURLSameOrigin(requestURL) {
        const parsed = (0, $0192f04cc5678e59$export$2e2bcd8739ae039).isString(requestURL) ? resolveURL(requestURL) : requestURL;
        return parsed.protocol === originURL.protocol && parsed.host === originURL.host;
    };
}() : // Non standard browser envs (web workers, react-native) lack needed support.
function nonStandardBrowserEnv() {
    return function isURLSameOrigin() {
        return true;
    };
}();





"use strict";
function $f4489e27ea06f930$export$2e2bcd8739ae039(url) {
    const match = /^([-+\w]{1,25})(:?\/\/|:)/.exec(url);
    return match && match[1] || "";
}




"use strict";
/**
 * Calculate data maxRate
 * @param {Number} [samplesCount= 10]
 * @param {Number} [min= 1000]
 * @returns {Function}
 */ function $61480bcc0f713d72$var$speedometer(samplesCount, min) {
    samplesCount = samplesCount || 10;
    const bytes = new Array(samplesCount);
    const timestamps = new Array(samplesCount);
    let head = 0;
    let tail = 0;
    let firstSampleTS;
    min = min !== undefined ? min : 1000;
    return function push(chunkLength) {
        const now = Date.now();
        const startedAt = timestamps[tail];
        if (!firstSampleTS) firstSampleTS = now;
        bytes[head] = chunkLength;
        timestamps[head] = now;
        let i = tail;
        let bytesCount = 0;
        while(i !== head){
            bytesCount += bytes[i++];
            i = i % samplesCount;
        }
        head = (head + 1) % samplesCount;
        if (head === tail) tail = (tail + 1) % samplesCount;
        if (now - firstSampleTS < min) return;
        const passed = startedAt && now - startedAt;
        return passed ? Math.round(bytesCount * 1000 / passed) : undefined;
    };
}
var $61480bcc0f713d72$export$2e2bcd8739ae039 = $61480bcc0f713d72$var$speedometer;


"use strict";
function $8fd8c9b637b18098$var$progressEventReducer(listener, isDownloadStream) {
    let bytesNotified = 0;
    const _speedometer = (0, $61480bcc0f713d72$export$2e2bcd8739ae039)(50, 250);
    return (e)=>{
        const loaded = e.loaded;
        const total = e.lengthComputable ? e.total : undefined;
        const progressBytes = loaded - bytesNotified;
        const rate = _speedometer(progressBytes);
        const inRange = loaded <= total;
        bytesNotified = loaded;
        const data = {
            loaded: loaded,
            total: total,
            progress: total ? loaded / total : undefined,
            bytes: progressBytes,
            rate: rate ? rate : undefined,
            estimated: rate && total && inRange ? (total - loaded) / rate : undefined,
            event: e
        };
        data[isDownloadStream ? "download" : "upload"] = true;
        listener(data);
    };
}
const $8fd8c9b637b18098$var$isXHRAdapterSupported = typeof XMLHttpRequest !== "undefined";
var $8fd8c9b637b18098$export$2e2bcd8739ae039 = $8fd8c9b637b18098$var$isXHRAdapterSupported && function(config) {
    return new Promise(function dispatchXhrRequest(resolve, reject) {
        let requestData = config.data;
        const requestHeaders = (0, $e14bcbc095f9985e$export$2e2bcd8739ae039).from(config.headers).normalize();
        const responseType = config.responseType;
        let onCanceled;
        function done() {
            if (config.cancelToken) config.cancelToken.unsubscribe(onCanceled);
            if (config.signal) config.signal.removeEventListener("abort", onCanceled);
        }
        if ((0, $0192f04cc5678e59$export$2e2bcd8739ae039).isFormData(requestData)) {
            if ((0, $be1053aa0e0e49c6$export$2e2bcd8739ae039).isStandardBrowserEnv || (0, $be1053aa0e0e49c6$export$2e2bcd8739ae039).isStandardBrowserWebWorkerEnv) requestHeaders.setContentType(false); // Let the browser set it
            else requestHeaders.setContentType("multipart/form-data;", false); // mobile/desktop app frameworks
        }
        let request = new XMLHttpRequest();
        // HTTP basic authentication
        if (config.auth) {
            const username = config.auth.username || "";
            const password = config.auth.password ? unescape(encodeURIComponent(config.auth.password)) : "";
            requestHeaders.set("Authorization", "Basic " + btoa(username + ":" + password));
        }
        const fullPath = (0, $a6c753bf26fbf0f9$export$2e2bcd8739ae039)(config.baseURL, config.url);
        request.open(config.method.toUpperCase(), (0, $3d0efc7c17e6920d$export$2e2bcd8739ae039)(fullPath, config.params, config.paramsSerializer), true);
        // Set the request timeout in MS
        request.timeout = config.timeout;
        function onloadend() {
            if (!request) return;
            // Prepare the response
            const responseHeaders = (0, $e14bcbc095f9985e$export$2e2bcd8739ae039).from("getAllResponseHeaders" in request && request.getAllResponseHeaders());
            const responseData = !responseType || responseType === "text" || responseType === "json" ? request.responseText : request.response;
            const response = {
                data: responseData,
                status: request.status,
                statusText: request.statusText,
                headers: responseHeaders,
                config: config,
                request: request
            };
            (0, $c4aa2d1358cf7102$export$2e2bcd8739ae039)(function _resolve(value) {
                resolve(value);
                done();
            }, function _reject(err) {
                reject(err);
                done();
            }, response);
            // Clean up request
            request = null;
        }
        if ("onloadend" in request) // Use onloadend if available
        request.onloadend = onloadend;
        else // Listen for ready state to emulate onloadend
        request.onreadystatechange = function handleLoad() {
            if (!request || request.readyState !== 4) return;
            // The request errored out and we didn't get a response, this will be
            // handled by onerror instead
            // With one exception: request that using file: protocol, most browsers
            // will return status as 0 even though it's a successful request
            if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf("file:") === 0)) return;
            // readystate handler is calling before onerror or ontimeout handlers,
            // so we should call onloadend on the next 'tick'
            setTimeout(onloadend);
        };
        // Handle browser request cancellation (as opposed to a manual cancellation)
        request.onabort = function handleAbort() {
            if (!request) return;
            reject(new (0, $6c469c5785e54eea$export$2e2bcd8739ae039)("Request aborted", (0, $6c469c5785e54eea$export$2e2bcd8739ae039).ECONNABORTED, config, request));
            // Clean up request
            request = null;
        };
        // Handle low level network errors
        request.onerror = function handleError() {
            // Real errors are hidden from us by the browser
            // onerror should only fire if it's a network error
            reject(new (0, $6c469c5785e54eea$export$2e2bcd8739ae039)("Network Error", (0, $6c469c5785e54eea$export$2e2bcd8739ae039).ERR_NETWORK, config, request));
            // Clean up request
            request = null;
        };
        // Handle timeout
        request.ontimeout = function handleTimeout() {
            let timeoutErrorMessage = config.timeout ? "timeout of " + config.timeout + "ms exceeded" : "timeout exceeded";
            const transitional = config.transitional || (0, $1b870b86699c28bd$export$2e2bcd8739ae039);
            if (config.timeoutErrorMessage) timeoutErrorMessage = config.timeoutErrorMessage;
            reject(new (0, $6c469c5785e54eea$export$2e2bcd8739ae039)(timeoutErrorMessage, transitional.clarifyTimeoutError ? (0, $6c469c5785e54eea$export$2e2bcd8739ae039).ETIMEDOUT : (0, $6c469c5785e54eea$export$2e2bcd8739ae039).ECONNABORTED, config, request));
            // Clean up request
            request = null;
        };
        // Add xsrf header
        // This is only done if running in a standard browser environment.
        // Specifically not if we're in a web worker, or react-native.
        if ((0, $be1053aa0e0e49c6$export$2e2bcd8739ae039).isStandardBrowserEnv) {
            // Add xsrf header
            const xsrfValue = (config.withCredentials || (0, $7bbb18aebf337532$export$2e2bcd8739ae039)(fullPath)) && config.xsrfCookieName && (0, $290d98c1e753543a$export$2e2bcd8739ae039).read(config.xsrfCookieName);
            if (xsrfValue) requestHeaders.set(config.xsrfHeaderName, xsrfValue);
        }
        // Remove Content-Type if data is undefined
        requestData === undefined && requestHeaders.setContentType(null);
        // Add headers to the request
        if ("setRequestHeader" in request) (0, $0192f04cc5678e59$export$2e2bcd8739ae039).forEach(requestHeaders.toJSON(), function setRequestHeader(val, key) {
            request.setRequestHeader(key, val);
        });
        // Add withCredentials to request if needed
        if (!(0, $0192f04cc5678e59$export$2e2bcd8739ae039).isUndefined(config.withCredentials)) request.withCredentials = !!config.withCredentials;
        // Add responseType to request if needed
        if (responseType && responseType !== "json") request.responseType = config.responseType;
        // Handle progress if needed
        if (typeof config.onDownloadProgress === "function") request.addEventListener("progress", $8fd8c9b637b18098$var$progressEventReducer(config.onDownloadProgress, true));
        // Not all browsers support upload events
        if (typeof config.onUploadProgress === "function" && request.upload) request.upload.addEventListener("progress", $8fd8c9b637b18098$var$progressEventReducer(config.onUploadProgress));
        if (config.cancelToken || config.signal) {
            // Handle cancellation
            // eslint-disable-next-line func-names
            onCanceled = (cancel)=>{
                if (!request) return;
                reject(!cancel || cancel.type ? new (0, $24205865f62eb2eb$export$2e2bcd8739ae039)(null, config, request) : cancel);
                request.abort();
                request = null;
            };
            config.cancelToken && config.cancelToken.subscribe(onCanceled);
            if (config.signal) config.signal.aborted ? onCanceled() : config.signal.addEventListener("abort", onCanceled);
        }
        const protocol = (0, $f4489e27ea06f930$export$2e2bcd8739ae039)(fullPath);
        if (protocol && (0, $be1053aa0e0e49c6$export$2e2bcd8739ae039).protocols.indexOf(protocol) === -1) {
            reject(new (0, $6c469c5785e54eea$export$2e2bcd8739ae039)("Unsupported protocol " + protocol + ":", (0, $6c469c5785e54eea$export$2e2bcd8739ae039).ERR_BAD_REQUEST, config));
            return;
        }
        // Send the request
        request.send(requestData || null);
    });
};



const $16767032eaefc15f$var$knownAdapters = {
    http: (0, $8b08fbd4169f9886$export$2e2bcd8739ae039),
    xhr: (0, $8fd8c9b637b18098$export$2e2bcd8739ae039)
};
(0, $0192f04cc5678e59$export$2e2bcd8739ae039).forEach($16767032eaefc15f$var$knownAdapters, (fn, value)=>{
    if (fn) {
        try {
            Object.defineProperty(fn, "name", {
                value: value
            });
        } catch (e) {
        // eslint-disable-next-line no-empty
        }
        Object.defineProperty(fn, "adapterName", {
            value: value
        });
    }
});
var $16767032eaefc15f$export$2e2bcd8739ae039 = {
    getAdapter: (adapters)=>{
        adapters = (0, $0192f04cc5678e59$export$2e2bcd8739ae039).isArray(adapters) ? adapters : [
            adapters
        ];
        const { length: length } = adapters;
        let nameOrAdapter;
        let adapter;
        for(let i = 0; i < length; i++){
            nameOrAdapter = adapters[i];
            if (adapter = (0, $0192f04cc5678e59$export$2e2bcd8739ae039).isString(nameOrAdapter) ? $16767032eaefc15f$var$knownAdapters[nameOrAdapter.toLowerCase()] : nameOrAdapter) break;
        }
        if (!adapter) {
            if (adapter === false) throw new (0, $6c469c5785e54eea$export$2e2bcd8739ae039)(`Adapter ${nameOrAdapter} is not supported by the environment`, "ERR_NOT_SUPPORT");
            throw new Error((0, $0192f04cc5678e59$export$2e2bcd8739ae039).hasOwnProp($16767032eaefc15f$var$knownAdapters, nameOrAdapter) ? `Adapter '${nameOrAdapter}' is not available in the build` : `Unknown adapter '${nameOrAdapter}'`);
        }
        if (!(0, $0192f04cc5678e59$export$2e2bcd8739ae039).isFunction(adapter)) throw new TypeError("adapter is not a function");
        return adapter;
    },
    adapters: $16767032eaefc15f$var$knownAdapters
};


"use strict";
/**
 * Throws a `CanceledError` if cancellation has been requested.
 *
 * @param {Object} config The config that is to be used for the request
 *
 * @returns {void}
 */ function $b8ffe3fce10e75b2$var$throwIfCancellationRequested(config) {
    if (config.cancelToken) config.cancelToken.throwIfRequested();
    if (config.signal && config.signal.aborted) throw new (0, $24205865f62eb2eb$export$2e2bcd8739ae039)(null, config);
}
function $b8ffe3fce10e75b2$export$2e2bcd8739ae039(config) {
    $b8ffe3fce10e75b2$var$throwIfCancellationRequested(config);
    config.headers = (0, $e14bcbc095f9985e$export$2e2bcd8739ae039).from(config.headers);
    // Transform request data
    config.data = (0, $386e7707ebfe8f00$export$2e2bcd8739ae039).call(config, config.transformRequest);
    if ([
        "post",
        "put",
        "patch"
    ].indexOf(config.method) !== -1) config.headers.setContentType("application/x-www-form-urlencoded", false);
    const adapter = (0, $16767032eaefc15f$export$2e2bcd8739ae039).getAdapter(config.adapter || (0, $5e78738d4ebd95bc$export$2e2bcd8739ae039).adapter);
    return adapter(config).then(function onAdapterResolution(response) {
        $b8ffe3fce10e75b2$var$throwIfCancellationRequested(config);
        // Transform response data
        response.data = (0, $386e7707ebfe8f00$export$2e2bcd8739ae039).call(config, config.transformResponse, response);
        response.headers = (0, $e14bcbc095f9985e$export$2e2bcd8739ae039).from(response.headers);
        return response;
    }, function onAdapterRejection(reason) {
        if (!(0, $206f3521bd755a95$export$2e2bcd8739ae039)(reason)) {
            $b8ffe3fce10e75b2$var$throwIfCancellationRequested(config);
            // Transform response data
            if (reason && reason.response) {
                reason.response.data = (0, $386e7707ebfe8f00$export$2e2bcd8739ae039).call(config, config.transformResponse, reason.response);
                reason.response.headers = (0, $e14bcbc095f9985e$export$2e2bcd8739ae039).from(reason.response.headers);
            }
        }
        return Promise.reject(reason);
    });
}




"use strict";
const $1669c722ee39d1e7$var$headersToObject = (thing)=>thing instanceof (0, $e14bcbc095f9985e$export$2e2bcd8739ae039) ? thing.toJSON() : thing;
function $1669c722ee39d1e7$export$2e2bcd8739ae039(config1, config2) {
    // eslint-disable-next-line no-param-reassign
    config2 = config2 || {};
    const config = {};
    function getMergedValue(target, source, caseless) {
        if ((0, $0192f04cc5678e59$export$2e2bcd8739ae039).isPlainObject(target) && (0, $0192f04cc5678e59$export$2e2bcd8739ae039).isPlainObject(source)) return (0, $0192f04cc5678e59$export$2e2bcd8739ae039).merge.call({
            caseless: caseless
        }, target, source);
        else if ((0, $0192f04cc5678e59$export$2e2bcd8739ae039).isPlainObject(source)) return (0, $0192f04cc5678e59$export$2e2bcd8739ae039).merge({}, source);
        else if ((0, $0192f04cc5678e59$export$2e2bcd8739ae039).isArray(source)) return source.slice();
        return source;
    }
    // eslint-disable-next-line consistent-return
    function mergeDeepProperties(a, b, caseless) {
        if (!(0, $0192f04cc5678e59$export$2e2bcd8739ae039).isUndefined(b)) return getMergedValue(a, b, caseless);
        else if (!(0, $0192f04cc5678e59$export$2e2bcd8739ae039).isUndefined(a)) return getMergedValue(undefined, a, caseless);
    }
    // eslint-disable-next-line consistent-return
    function valueFromConfig2(a, b) {
        if (!(0, $0192f04cc5678e59$export$2e2bcd8739ae039).isUndefined(b)) return getMergedValue(undefined, b);
    }
    // eslint-disable-next-line consistent-return
    function defaultToConfig2(a, b) {
        if (!(0, $0192f04cc5678e59$export$2e2bcd8739ae039).isUndefined(b)) return getMergedValue(undefined, b);
        else if (!(0, $0192f04cc5678e59$export$2e2bcd8739ae039).isUndefined(a)) return getMergedValue(undefined, a);
    }
    // eslint-disable-next-line consistent-return
    function mergeDirectKeys(a, b, prop) {
        if (prop in config2) return getMergedValue(a, b);
        else if (prop in config1) return getMergedValue(undefined, a);
    }
    const mergeMap = {
        url: valueFromConfig2,
        method: valueFromConfig2,
        data: valueFromConfig2,
        baseURL: defaultToConfig2,
        transformRequest: defaultToConfig2,
        transformResponse: defaultToConfig2,
        paramsSerializer: defaultToConfig2,
        timeout: defaultToConfig2,
        timeoutMessage: defaultToConfig2,
        withCredentials: defaultToConfig2,
        adapter: defaultToConfig2,
        responseType: defaultToConfig2,
        xsrfCookieName: defaultToConfig2,
        xsrfHeaderName: defaultToConfig2,
        onUploadProgress: defaultToConfig2,
        onDownloadProgress: defaultToConfig2,
        decompress: defaultToConfig2,
        maxContentLength: defaultToConfig2,
        maxBodyLength: defaultToConfig2,
        beforeRedirect: defaultToConfig2,
        transport: defaultToConfig2,
        httpAgent: defaultToConfig2,
        httpsAgent: defaultToConfig2,
        cancelToken: defaultToConfig2,
        socketPath: defaultToConfig2,
        responseEncoding: defaultToConfig2,
        validateStatus: mergeDirectKeys,
        headers: (a, b)=>mergeDeepProperties($1669c722ee39d1e7$var$headersToObject(a), $1669c722ee39d1e7$var$headersToObject(b), true)
    };
    (0, $0192f04cc5678e59$export$2e2bcd8739ae039).forEach(Object.keys(Object.assign({}, config1, config2)), function computeConfigValue(prop) {
        const merge = mergeMap[prop] || mergeDeepProperties;
        const configValue = merge(config1[prop], config2[prop], prop);
        (0, $0192f04cc5678e59$export$2e2bcd8739ae039).isUndefined(configValue) && merge !== mergeDirectKeys || (config[prop] = configValue);
    });
    return config;
}



const $aee5522ac1636907$export$a4ad2735b021c132 = "1.4.0";



"use strict";
const $9e7f7e8df64ca28d$var$validators = {};
// eslint-disable-next-line func-names
[
    "object",
    "boolean",
    "number",
    "function",
    "string",
    "symbol"
].forEach((type, i)=>{
    $9e7f7e8df64ca28d$var$validators[type] = function validator(thing) {
        return typeof thing === type || "a" + (i < 1 ? "n " : " ") + type;
    };
});
const $9e7f7e8df64ca28d$var$deprecatedWarnings = {};
/**
 * Transitional option validator
 *
 * @param {function|boolean?} validator - set to false if the transitional option has been removed
 * @param {string?} version - deprecated version / removed since version
 * @param {string?} message - some message with additional info
 *
 * @returns {function}
 */ $9e7f7e8df64ca28d$var$validators.transitional = function transitional(validator, version, message) {
    function formatMessage(opt, desc) {
        return "[Axios v" + (0, $aee5522ac1636907$export$a4ad2735b021c132) + "] Transitional option '" + opt + "'" + desc + (message ? ". " + message : "");
    }
    // eslint-disable-next-line func-names
    return (value, opt, opts)=>{
        if (validator === false) throw new (0, $6c469c5785e54eea$export$2e2bcd8739ae039)(formatMessage(opt, " has been removed" + (version ? " in " + version : "")), (0, $6c469c5785e54eea$export$2e2bcd8739ae039).ERR_DEPRECATED);
        if (version && !$9e7f7e8df64ca28d$var$deprecatedWarnings[opt]) {
            $9e7f7e8df64ca28d$var$deprecatedWarnings[opt] = true;
            // eslint-disable-next-line no-console
            console.warn(formatMessage(opt, " has been deprecated since v" + version + " and will be removed in the near future"));
        }
        return validator ? validator(value, opt, opts) : true;
    };
};
/**
 * Assert object's properties type
 *
 * @param {object} options
 * @param {object} schema
 * @param {boolean?} allowUnknown
 *
 * @returns {object}
 */ function $9e7f7e8df64ca28d$var$assertOptions(options, schema, allowUnknown) {
    if (typeof options !== "object") throw new (0, $6c469c5785e54eea$export$2e2bcd8739ae039)("options must be an object", (0, $6c469c5785e54eea$export$2e2bcd8739ae039).ERR_BAD_OPTION_VALUE);
    const keys = Object.keys(options);
    let i = keys.length;
    while(i-- > 0){
        const opt = keys[i];
        const validator = schema[opt];
        if (validator) {
            const value = options[opt];
            const result = value === undefined || validator(value, opt, options);
            if (result !== true) throw new (0, $6c469c5785e54eea$export$2e2bcd8739ae039)("option " + opt + " must be " + result, (0, $6c469c5785e54eea$export$2e2bcd8739ae039).ERR_BAD_OPTION_VALUE);
            continue;
        }
        if (allowUnknown !== true) throw new (0, $6c469c5785e54eea$export$2e2bcd8739ae039)("Unknown option " + opt, (0, $6c469c5785e54eea$export$2e2bcd8739ae039).ERR_BAD_OPTION);
    }
}
var $9e7f7e8df64ca28d$export$2e2bcd8739ae039 = {
    assertOptions: $9e7f7e8df64ca28d$var$assertOptions,
    validators: $9e7f7e8df64ca28d$var$validators
};



"use strict";
const $22a31cf94d7fc7cc$var$validators = (0, $9e7f7e8df64ca28d$export$2e2bcd8739ae039).validators;
/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 *
 * @return {Axios} A new instance of Axios
 */ class $22a31cf94d7fc7cc$var$Axios {
    constructor(instanceConfig){
        this.defaults = instanceConfig;
        this.interceptors = {
            request: new (0, $a64589aa1f221b38$export$2e2bcd8739ae039)(),
            response: new (0, $a64589aa1f221b38$export$2e2bcd8739ae039)()
        };
    }
    /**
   * Dispatch a request
   *
   * @param {String|Object} configOrUrl The config specific for this request (merged with this.defaults)
   * @param {?Object} config
   *
   * @returns {Promise} The Promise to be fulfilled
   */ request(configOrUrl, config) {
        /*eslint no-param-reassign:0*/ // Allow for axios('example/url'[, config]) a la fetch API
        if (typeof configOrUrl === "string") {
            config = config || {};
            config.url = configOrUrl;
        } else config = configOrUrl || {};
        config = (0, $1669c722ee39d1e7$export$2e2bcd8739ae039)(this.defaults, config);
        const { transitional: transitional, paramsSerializer: paramsSerializer, headers: headers } = config;
        if (transitional !== undefined) (0, $9e7f7e8df64ca28d$export$2e2bcd8739ae039).assertOptions(transitional, {
            silentJSONParsing: $22a31cf94d7fc7cc$var$validators.transitional($22a31cf94d7fc7cc$var$validators.boolean),
            forcedJSONParsing: $22a31cf94d7fc7cc$var$validators.transitional($22a31cf94d7fc7cc$var$validators.boolean),
            clarifyTimeoutError: $22a31cf94d7fc7cc$var$validators.transitional($22a31cf94d7fc7cc$var$validators.boolean)
        }, false);
        if (paramsSerializer != null) {
            if ((0, $0192f04cc5678e59$export$2e2bcd8739ae039).isFunction(paramsSerializer)) config.paramsSerializer = {
                serialize: paramsSerializer
            };
            else (0, $9e7f7e8df64ca28d$export$2e2bcd8739ae039).assertOptions(paramsSerializer, {
                encode: $22a31cf94d7fc7cc$var$validators.function,
                serialize: $22a31cf94d7fc7cc$var$validators.function
            }, true);
        }
        // Set config.method
        config.method = (config.method || this.defaults.method || "get").toLowerCase();
        let contextHeaders;
        // Flatten headers
        contextHeaders = headers && (0, $0192f04cc5678e59$export$2e2bcd8739ae039).merge(headers.common, headers[config.method]);
        contextHeaders && (0, $0192f04cc5678e59$export$2e2bcd8739ae039).forEach([
            "delete",
            "get",
            "head",
            "post",
            "put",
            "patch",
            "common"
        ], (method)=>{
            delete headers[method];
        });
        config.headers = (0, $e14bcbc095f9985e$export$2e2bcd8739ae039).concat(contextHeaders, headers);
        // filter out skipped interceptors
        const requestInterceptorChain = [];
        let synchronousRequestInterceptors = true;
        this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
            if (typeof interceptor.runWhen === "function" && interceptor.runWhen(config) === false) return;
            synchronousRequestInterceptors = synchronousRequestInterceptors && interceptor.synchronous;
            requestInterceptorChain.unshift(interceptor.fulfilled, interceptor.rejected);
        });
        const responseInterceptorChain = [];
        this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
            responseInterceptorChain.push(interceptor.fulfilled, interceptor.rejected);
        });
        let promise;
        let i = 0;
        let len;
        if (!synchronousRequestInterceptors) {
            const chain = [
                (0, $b8ffe3fce10e75b2$export$2e2bcd8739ae039).bind(this),
                undefined
            ];
            chain.unshift.apply(chain, requestInterceptorChain);
            chain.push.apply(chain, responseInterceptorChain);
            len = chain.length;
            promise = Promise.resolve(config);
            while(i < len)promise = promise.then(chain[i++], chain[i++]);
            return promise;
        }
        len = requestInterceptorChain.length;
        let newConfig = config;
        i = 0;
        while(i < len){
            const onFulfilled = requestInterceptorChain[i++];
            const onRejected = requestInterceptorChain[i++];
            try {
                newConfig = onFulfilled(newConfig);
            } catch (error) {
                onRejected.call(this, error);
                break;
            }
        }
        try {
            promise = (0, $b8ffe3fce10e75b2$export$2e2bcd8739ae039).call(this, newConfig);
        } catch (error) {
            return Promise.reject(error);
        }
        i = 0;
        len = responseInterceptorChain.length;
        while(i < len)promise = promise.then(responseInterceptorChain[i++], responseInterceptorChain[i++]);
        return promise;
    }
    getUri(config) {
        config = (0, $1669c722ee39d1e7$export$2e2bcd8739ae039)(this.defaults, config);
        const fullPath = (0, $a6c753bf26fbf0f9$export$2e2bcd8739ae039)(config.baseURL, config.url);
        return (0, $3d0efc7c17e6920d$export$2e2bcd8739ae039)(fullPath, config.params, config.paramsSerializer);
    }
}
// Provide aliases for supported request methods
(0, $0192f04cc5678e59$export$2e2bcd8739ae039).forEach([
    "delete",
    "get",
    "head",
    "options"
], function forEachMethodNoData(method) {
    /*eslint func-names:0*/ $22a31cf94d7fc7cc$var$Axios.prototype[method] = function(url, config) {
        return this.request((0, $1669c722ee39d1e7$export$2e2bcd8739ae039)(config || {}, {
            method: method,
            url: url,
            data: (config || {}).data
        }));
    };
});
(0, $0192f04cc5678e59$export$2e2bcd8739ae039).forEach([
    "post",
    "put",
    "patch"
], function forEachMethodWithData(method) {
    /*eslint func-names:0*/ function generateHTTPMethod(isForm) {
        return function httpMethod(url, data, config) {
            return this.request((0, $1669c722ee39d1e7$export$2e2bcd8739ae039)(config || {}, {
                method: method,
                headers: isForm ? {
                    "Content-Type": "multipart/form-data"
                } : {},
                url: url,
                data: data
            }));
        };
    }
    $22a31cf94d7fc7cc$var$Axios.prototype[method] = generateHTTPMethod();
    $22a31cf94d7fc7cc$var$Axios.prototype[method + "Form"] = generateHTTPMethod(true);
});
var $22a31cf94d7fc7cc$export$2e2bcd8739ae039 = $22a31cf94d7fc7cc$var$Axios;







"use strict";
/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @param {Function} executor The executor function.
 *
 * @returns {CancelToken}
 */ class $c075f8e442568655$var$CancelToken {
    constructor(executor){
        if (typeof executor !== "function") throw new TypeError("executor must be a function.");
        let resolvePromise;
        this.promise = new Promise(function promiseExecutor(resolve) {
            resolvePromise = resolve;
        });
        const token = this;
        // eslint-disable-next-line func-names
        this.promise.then((cancel)=>{
            if (!token._listeners) return;
            let i = token._listeners.length;
            while(i-- > 0)token._listeners[i](cancel);
            token._listeners = null;
        });
        // eslint-disable-next-line func-names
        this.promise.then = (onfulfilled)=>{
            let _resolve;
            // eslint-disable-next-line func-names
            const promise = new Promise((resolve)=>{
                token.subscribe(resolve);
                _resolve = resolve;
            }).then(onfulfilled);
            promise.cancel = function reject() {
                token.unsubscribe(_resolve);
            };
            return promise;
        };
        executor(function cancel(message, config, request) {
            if (token.reason) // Cancellation has already been requested
            return;
            token.reason = new (0, $24205865f62eb2eb$export$2e2bcd8739ae039)(message, config, request);
            resolvePromise(token.reason);
        });
    }
    /**
   * Throws a `CanceledError` if cancellation has been requested.
   */ throwIfRequested() {
        if (this.reason) throw this.reason;
    }
    /**
   * Subscribe to the cancel signal
   */ subscribe(listener) {
        if (this.reason) {
            listener(this.reason);
            return;
        }
        if (this._listeners) this._listeners.push(listener);
        else this._listeners = [
            listener
        ];
    }
    /**
   * Unsubscribe from the cancel signal
   */ unsubscribe(listener) {
        if (!this._listeners) return;
        const index = this._listeners.indexOf(listener);
        if (index !== -1) this._listeners.splice(index, 1);
    }
    /**
   * Returns an object that contains a new `CancelToken` and a function that, when called,
   * cancels the `CancelToken`.
   */ static source() {
        let cancel;
        const token = new $c075f8e442568655$var$CancelToken(function executor(c) {
            cancel = c;
        });
        return {
            token: token,
            cancel: cancel
        };
    }
}
var $c075f8e442568655$export$2e2bcd8739ae039 = $c075f8e442568655$var$CancelToken;






"use strict";
function $a5ffb3c874e4163d$export$2e2bcd8739ae039(callback) {
    return function wrap(arr) {
        return callback.apply(null, arr);
    };
}



"use strict";
function $073f0142a75be153$export$2e2bcd8739ae039(payload) {
    return (0, $0192f04cc5678e59$export$2e2bcd8739ae039).isObject(payload) && payload.isAxiosError === true;
}



const $987289c3018f066f$var$HttpStatusCode = {
    Continue: 100,
    SwitchingProtocols: 101,
    Processing: 102,
    EarlyHints: 103,
    Ok: 200,
    Created: 201,
    Accepted: 202,
    NonAuthoritativeInformation: 203,
    NoContent: 204,
    ResetContent: 205,
    PartialContent: 206,
    MultiStatus: 207,
    AlreadyReported: 208,
    ImUsed: 226,
    MultipleChoices: 300,
    MovedPermanently: 301,
    Found: 302,
    SeeOther: 303,
    NotModified: 304,
    UseProxy: 305,
    Unused: 306,
    TemporaryRedirect: 307,
    PermanentRedirect: 308,
    BadRequest: 400,
    Unauthorized: 401,
    PaymentRequired: 402,
    Forbidden: 403,
    NotFound: 404,
    MethodNotAllowed: 405,
    NotAcceptable: 406,
    ProxyAuthenticationRequired: 407,
    RequestTimeout: 408,
    Conflict: 409,
    Gone: 410,
    LengthRequired: 411,
    PreconditionFailed: 412,
    PayloadTooLarge: 413,
    UriTooLong: 414,
    UnsupportedMediaType: 415,
    RangeNotSatisfiable: 416,
    ExpectationFailed: 417,
    ImATeapot: 418,
    MisdirectedRequest: 421,
    UnprocessableEntity: 422,
    Locked: 423,
    FailedDependency: 424,
    TooEarly: 425,
    UpgradeRequired: 426,
    PreconditionRequired: 428,
    TooManyRequests: 429,
    RequestHeaderFieldsTooLarge: 431,
    UnavailableForLegalReasons: 451,
    InternalServerError: 500,
    NotImplemented: 501,
    BadGateway: 502,
    ServiceUnavailable: 503,
    GatewayTimeout: 504,
    HttpVersionNotSupported: 505,
    VariantAlsoNegotiates: 506,
    InsufficientStorage: 507,
    LoopDetected: 508,
    NotExtended: 510,
    NetworkAuthenticationRequired: 511
};
Object.entries($987289c3018f066f$var$HttpStatusCode).forEach(([key, value])=>{
    $987289c3018f066f$var$HttpStatusCode[value] = key;
});
var $987289c3018f066f$export$2e2bcd8739ae039 = $987289c3018f066f$var$HttpStatusCode;


"use strict";
/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 *
 * @returns {Axios} A new instance of Axios
 */ function $de0338a08c4f70b1$var$createInstance(defaultConfig) {
    const context = new (0, $22a31cf94d7fc7cc$export$2e2bcd8739ae039)(defaultConfig);
    const instance = (0, $0ba9ef1fcbf73284$export$2e2bcd8739ae039)((0, $22a31cf94d7fc7cc$export$2e2bcd8739ae039).prototype.request, context);
    // Copy axios.prototype to instance
    (0, $0192f04cc5678e59$export$2e2bcd8739ae039).extend(instance, (0, $22a31cf94d7fc7cc$export$2e2bcd8739ae039).prototype, context, {
        allOwnKeys: true
    });
    // Copy context to instance
    (0, $0192f04cc5678e59$export$2e2bcd8739ae039).extend(instance, context, null, {
        allOwnKeys: true
    });
    // Factory for creating new instances
    instance.create = function create(instanceConfig) {
        return $de0338a08c4f70b1$var$createInstance((0, $1669c722ee39d1e7$export$2e2bcd8739ae039)(defaultConfig, instanceConfig));
    };
    return instance;
}
// Create the default instance to be exported
const $de0338a08c4f70b1$var$axios = $de0338a08c4f70b1$var$createInstance((0, $5e78738d4ebd95bc$export$2e2bcd8739ae039));
// Expose Axios class to allow class inheritance
$de0338a08c4f70b1$var$axios.Axios = (0, $22a31cf94d7fc7cc$export$2e2bcd8739ae039);
// Expose Cancel & CancelToken
$de0338a08c4f70b1$var$axios.CanceledError = (0, $24205865f62eb2eb$export$2e2bcd8739ae039);
$de0338a08c4f70b1$var$axios.CancelToken = (0, $c075f8e442568655$export$2e2bcd8739ae039);
$de0338a08c4f70b1$var$axios.isCancel = (0, $206f3521bd755a95$export$2e2bcd8739ae039);
$de0338a08c4f70b1$var$axios.VERSION = (0, $aee5522ac1636907$export$a4ad2735b021c132);
$de0338a08c4f70b1$var$axios.toFormData = (0, $0d4b5a284fe8e195$export$2e2bcd8739ae039);
// Expose AxiosError class
$de0338a08c4f70b1$var$axios.AxiosError = (0, $6c469c5785e54eea$export$2e2bcd8739ae039);
// alias for CanceledError for backward compatibility
$de0338a08c4f70b1$var$axios.Cancel = $de0338a08c4f70b1$var$axios.CanceledError;
// Expose all/spread
$de0338a08c4f70b1$var$axios.all = function all(promises) {
    return Promise.all(promises);
};
$de0338a08c4f70b1$var$axios.spread = (0, $a5ffb3c874e4163d$export$2e2bcd8739ae039);
// Expose isAxiosError
$de0338a08c4f70b1$var$axios.isAxiosError = (0, $073f0142a75be153$export$2e2bcd8739ae039);
// Expose mergeConfig
$de0338a08c4f70b1$var$axios.mergeConfig = (0, $1669c722ee39d1e7$export$2e2bcd8739ae039);
$de0338a08c4f70b1$var$axios.AxiosHeaders = (0, $e14bcbc095f9985e$export$2e2bcd8739ae039);
$de0338a08c4f70b1$var$axios.formToJSON = (thing)=>(0, $21a975081709563b$export$2e2bcd8739ae039)((0, $0192f04cc5678e59$export$2e2bcd8739ae039).isHTMLForm(thing) ? new FormData(thing) : thing);
$de0338a08c4f70b1$var$axios.HttpStatusCode = (0, $987289c3018f066f$export$2e2bcd8739ae039);
$de0338a08c4f70b1$var$axios.default = $de0338a08c4f70b1$var$axios;
var // this module should only have a default export
$de0338a08c4f70b1$export$2e2bcd8739ae039 = $de0338a08c4f70b1$var$axios;


// This module is intended to unwrap Axios default export as named.
// Keep top-level export same with static properties
// so that it can keep same with es module or cjs
const { Axios: $aae25c2e68c2560e$export$1c00760e9e5a4e95, AxiosError: $aae25c2e68c2560e$export$c1fbed17c2f6a328, CanceledError: $aae25c2e68c2560e$export$1ab0c6b20d94fa14, isCancel: $aae25c2e68c2560e$export$3b22524397b493c6, CancelToken: $aae25c2e68c2560e$export$fd08e3cb425f0d61, VERSION: $aae25c2e68c2560e$export$a4ad2735b021c132, all: $aae25c2e68c2560e$export$84bf76cd7afc7469, Cancel: $aae25c2e68c2560e$export$848c9b7ead0df967, isAxiosError: $aae25c2e68c2560e$export$fbafdbe06a5b5a9a, spread: $aae25c2e68c2560e$export$3ae0fd4797ed47c8, toFormData: $aae25c2e68c2560e$export$10ae0d317ea97f8b, AxiosHeaders: $aae25c2e68c2560e$export$4e7d6ff0f3e6520, HttpStatusCode: $aae25c2e68c2560e$export$a972f69c851492b3, formToJSON: $aae25c2e68c2560e$export$86d7c59254d6a2c9, mergeConfig: $aae25c2e68c2560e$export$7ec1ebcfa9d8bd6a } = (0, $de0338a08c4f70b1$export$2e2bcd8739ae039);


function $d1999c83d031453a$var$_regeneratorRuntime() {
    $d1999c83d031453a$var$_regeneratorRuntime = function() {
        return exports;
    };
    var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, defineProperty = Object.defineProperty || function(obj, key, desc) {
        obj[key] = desc.value;
    }, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";
    function define(obj, key, value) {
        return Object.defineProperty(obj, key, {
            value: value,
            enumerable: !0,
            configurable: !0,
            writable: !0
        }), obj[key];
    }
    try {
        define({}, "");
    } catch (err) {
        define = function(obj, key, value) {
            return obj[key] = value;
        };
    }
    function wrap(innerFn, outerFn, self, tryLocsList) {
        var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []);
        return defineProperty(generator, "_invoke", {
            value: makeInvokeMethod(innerFn, self, context)
        }), generator;
    }
    function tryCatch(fn, obj, arg) {
        try {
            return {
                type: "normal",
                arg: fn.call(obj, arg)
            };
        } catch (err) {
            return {
                type: "throw",
                arg: err
            };
        }
    }
    exports.wrap = wrap;
    var ContinueSentinel = {};
    function Generator() {}
    function GeneratorFunction() {}
    function GeneratorFunctionPrototype() {}
    var IteratorPrototype = {};
    define(IteratorPrototype, iteratorSymbol, function() {
        return this;
    });
    var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([])));
    NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype);
    var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype);
    function defineIteratorMethods(prototype) {
        [
            "next",
            "throw",
            "return"
        ].forEach(function(method) {
            define(prototype, method, function(arg) {
                return this._invoke(method, arg);
            });
        });
    }
    function AsyncIterator(generator, PromiseImpl) {
        function invoke(method, arg, resolve, reject) {
            var record = tryCatch(generator[method], generator, arg);
            if ("throw" !== record.type) {
                var result = record.arg, value = result.value;
                return value && "object" == typeof value && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function(value) {
                    invoke("next", value, resolve, reject);
                }, function(err) {
                    invoke("throw", err, resolve, reject);
                }) : PromiseImpl.resolve(value).then(function(unwrapped) {
                    result.value = unwrapped, resolve(result);
                }, function(error) {
                    return invoke("throw", error, resolve, reject);
                });
            }
            reject(record.arg);
        }
        var previousPromise;
        defineProperty(this, "_invoke", {
            value: function(method, arg) {
                function callInvokeWithMethodAndArg() {
                    return new PromiseImpl(function(resolve, reject) {
                        invoke(method, arg, resolve, reject);
                    });
                }
                return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
            }
        });
    }
    function makeInvokeMethod(innerFn, self, context) {
        var state = "suspendedStart";
        return function(method, arg) {
            if ("executing" === state) throw new Error("Generator is already running");
            if ("completed" === state) {
                if ("throw" === method) throw arg;
                return {
                    value: void 0,
                    done: !0
                };
            }
            for(context.method = method, context.arg = arg;;){
                var delegate = context.delegate;
                if (delegate) {
                    var delegateResult = maybeInvokeDelegate(delegate, context);
                    if (delegateResult) {
                        if (delegateResult === ContinueSentinel) continue;
                        return delegateResult;
                    }
                }
                if ("next" === context.method) context.sent = context._sent = context.arg;
                else if ("throw" === context.method) {
                    if ("suspendedStart" === state) throw state = "completed", context.arg;
                    context.dispatchException(context.arg);
                } else "return" === context.method && context.abrupt("return", context.arg);
                state = "executing";
                var record = tryCatch(innerFn, self, context);
                if ("normal" === record.type) {
                    if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue;
                    return {
                        value: record.arg,
                        done: context.done
                    };
                }
                "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg);
            }
        };
    }
    function maybeInvokeDelegate(delegate, context) {
        var methodName = context.method, method = delegate.iterator[methodName];
        if (undefined === method) return context.delegate = null, "throw" === methodName && delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method) || "return" !== methodName && (context.method = "throw", context.arg = new TypeError("The iterator does not provide a '" + methodName + "' method")), ContinueSentinel;
        var record = tryCatch(method, delegate.iterator, context.arg);
        if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel;
        var info = record.arg;
        return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel);
    }
    function pushTryEntry(locs) {
        var entry = {
            tryLoc: locs[0]
        };
        1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry);
    }
    function resetTryEntry(entry) {
        var record = entry.completion || {};
        record.type = "normal", delete record.arg, entry.completion = record;
    }
    function Context(tryLocsList) {
        this.tryEntries = [
            {
                tryLoc: "root"
            }
        ], tryLocsList.forEach(pushTryEntry, this), this.reset(!0);
    }
    function values(iterable) {
        if (iterable || "" === iterable) {
            var iteratorMethod = iterable[iteratorSymbol];
            if (iteratorMethod) return iteratorMethod.call(iterable);
            if ("function" == typeof iterable.next) return iterable;
            if (!isNaN(iterable.length)) {
                var i = -1, next = function next() {
                    for(; ++i < iterable.length;)if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next;
                    return next.value = undefined, next.done = !0, next;
                };
                return next.next = next;
            }
        }
        throw new TypeError(typeof iterable + " is not iterable");
    }
    return GeneratorFunction.prototype = GeneratorFunctionPrototype, defineProperty(Gp, "constructor", {
        value: GeneratorFunctionPrototype,
        configurable: !0
    }), defineProperty(GeneratorFunctionPrototype, "constructor", {
        value: GeneratorFunction,
        configurable: !0
    }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function(genFun) {
        var ctor = "function" == typeof genFun && genFun.constructor;
        return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name));
    }, exports.mark = function(genFun) {
        return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun;
    }, exports.awrap = function(arg) {
        return {
            __await: arg
        };
    }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function() {
        return this;
    }), exports.AsyncIterator = AsyncIterator, exports.async = function(innerFn, outerFn, self, tryLocsList, PromiseImpl) {
        void 0 === PromiseImpl && (PromiseImpl = Promise);
        var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl);
        return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function(result) {
            return result.done ? result.value : iter.next();
        });
    }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function() {
        return this;
    }), define(Gp, "toString", function() {
        return "[object Generator]";
    }), exports.keys = function(val) {
        var object = Object(val), keys = [];
        for(var key in object)keys.push(key);
        return keys.reverse(), function next() {
            for(; keys.length;){
                var key = keys.pop();
                if (key in object) return next.value = key, next.done = !1, next;
            }
            return next.done = !0, next;
        };
    }, exports.values = values, Context.prototype = {
        constructor: Context,
        reset: function(skipTempReset) {
            if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for(var name in this)"t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined);
        },
        stop: function() {
            this.done = !0;
            var rootRecord = this.tryEntries[0].completion;
            if ("throw" === rootRecord.type) throw rootRecord.arg;
            return this.rval;
        },
        dispatchException: function(exception) {
            if (this.done) throw exception;
            var context = this;
            function handle(loc, caught) {
                return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught;
            }
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i], record = entry.completion;
                if ("root" === entry.tryLoc) return handle("end");
                if (entry.tryLoc <= this.prev) {
                    var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc");
                    if (hasCatch && hasFinally) {
                        if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0);
                        if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
                    } else if (hasCatch) {
                        if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0);
                    } else {
                        if (!hasFinally) throw new Error("try statement without catch or finally");
                        if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
                    }
                }
            }
        },
        abrupt: function(type, arg) {
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i];
                if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) {
                    var finallyEntry = entry;
                    break;
                }
            }
            finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null);
            var record = finallyEntry ? finallyEntry.completion : {};
            return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record);
        },
        complete: function(record, afterLoc) {
            if ("throw" === record.type) throw record.arg;
            return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel;
        },
        finish: function(finallyLoc) {
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i];
                if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel;
            }
        },
        catch: function(tryLoc) {
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i];
                if (entry.tryLoc === tryLoc) {
                    var record = entry.completion;
                    if ("throw" === record.type) {
                        var thrown = record.arg;
                        resetTryEntry(entry);
                    }
                    return thrown;
                }
            }
            throw new Error("illegal catch attempt");
        },
        delegateYield: function(iterable, resultName, nextLoc) {
            return this.delegate = {
                iterator: values(iterable),
                resultName: resultName,
                nextLoc: nextLoc
            }, "next" === this.method && (this.arg = undefined), ContinueSentinel;
        }
    }, exports;
}
function $d1999c83d031453a$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) resolve(value);
    else Promise.resolve(value).then(_next, _throw);
}
function $d1999c83d031453a$var$_asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                $d1999c83d031453a$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                $d1999c83d031453a$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function $d1999c83d031453a$var$_extends() {
    $d1999c83d031453a$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $d1999c83d031453a$var$_extends.apply(this, arguments);
}
function $d1999c83d031453a$export$2852f7fe3195f604(asset) {
    if (!!asset.address) return asset.blockchain + "." + asset.symbol + "--" + asset.address;
    else return asset.blockchain + "." + asset.symbol;
}
var $d1999c83d031453a$export$9d749b8b357dfab2 = function isEvmBlockchain(blockchainMeta) {
    return blockchainMeta.type === "EVM";
};
var $d1999c83d031453a$export$d917e9e8a70036a6 = function isCosmosBlockchain(blockchainMeta) {
    return blockchainMeta.type === "COSMOS";
};
var $d1999c83d031453a$export$ff5a0a65a8982bf2 = function isSolanaBlockchain(blockchainMeta) {
    return blockchainMeta.type === "SOLANA";
};
var $d1999c83d031453a$export$744fa0907a94ca40 = function isTronBlockchain(blockchainMeta) {
    return blockchainMeta.type === "TRON";
};
var $d1999c83d031453a$export$83b5ebc3a9031095 = function isTransferBlockchain(blockchainMeta) {
    return blockchainMeta.type === "TRANSFER";
};
var $d1999c83d031453a$export$80db8fd9e7a31db2 = function isStarknetBlockchain(blockchainMeta) {
    return blockchainMeta.type === "STARKNET";
};
var $d1999c83d031453a$export$9500a92ad5d775aa = function isTonBlockchain(blockchainMeta) {
    return blockchainMeta.type === "TON";
};
var $d1999c83d031453a$export$e2a694e57950e88e = function evmBlockchains(blockchains) {
    return blockchains.filter($d1999c83d031453a$export$9d749b8b357dfab2);
};
var $d1999c83d031453a$export$11a35c42f4dd4832 = function solanaBlockchain(blockchains) {
    return blockchains.filter($d1999c83d031453a$export$ff5a0a65a8982bf2);
};
var $d1999c83d031453a$export$e1f5443c7a926d0f = function starknetBlockchain(blockchains) {
    return blockchains.filter($d1999c83d031453a$export$80db8fd9e7a31db2);
};
var $d1999c83d031453a$export$61a2144ef91f3622 = function tronBlockchain(blockchains) {
    return blockchains.filter($d1999c83d031453a$export$744fa0907a94ca40);
};
var $d1999c83d031453a$export$7a136f0d6bb0d722 = function cosmosBlockchains(blockchains) {
    return blockchains.filter($d1999c83d031453a$export$d917e9e8a70036a6);
};
var $d1999c83d031453a$export$80dff8c560b1e7ce = function transferBlockchains(blockchains) {
    return blockchains.filter($d1999c83d031453a$export$83b5ebc3a9031095);
};
var $d1999c83d031453a$export$e38bf62be0c23ec5 = function tonBlockchain(blockchains) {
    return blockchains.filter($d1999c83d031453a$export$9500a92ad5d775aa);
};
/**
 * Routing Result Type
 *
 */ var $d1999c83d031453a$export$9244fb3192b4c649;
(function(RoutingResultType) {
    RoutingResultType["OK"] = "OK";
    RoutingResultType["HIGH_IMPACT"] = "HIGH_IMPACT";
    RoutingResultType["NO_ROUTE"] = "NO_ROUTE";
    RoutingResultType["INPUT_LIMIT_ISSUE"] = "INPUT_LIMIT_ISSUE";
})($d1999c83d031453a$export$9244fb3192b4c649 || ($d1999c83d031453a$export$9244fb3192b4c649 = {}));
/**
 * The type of transaction
 */ var $d1999c83d031453a$export$d513b00599f845d4;
(function(TransactionType) {
    TransactionType["EVM"] = "EVM";
    TransactionType["TRANSFER"] = "TRANSFER";
    TransactionType["COSMOS"] = "COSMOS";
    TransactionType["SOLANA"] = "SOLANA";
    TransactionType["TRON"] = "TRON";
    TransactionType["STARKNET"] = "STARKNET";
    TransactionType["TON"] = "TON";
})($d1999c83d031453a$export$d513b00599f845d4 || ($d1999c83d031453a$export$d513b00599f845d4 = {}));
/**
 * The type of transaction
 * @deprecated use TransactionType instead
 */ var $d1999c83d031453a$export$d5c0ec10a1bea971;
(function(GenericTransactionType) {
    GenericTransactionType["EVM"] = "EVM";
    GenericTransactionType["TRANSFER"] = "TRANSFER";
    GenericTransactionType["COSMOS"] = "COSMOS";
    GenericTransactionType["SOLANA"] = "SOLANA";
})($d1999c83d031453a$export$d5c0ec10a1bea971 || ($d1999c83d031453a$export$d5c0ec10a1bea971 = {}));
/**
 * The status of transaction in tracking
 */ var $d1999c83d031453a$export$7c391bd3b61d2374;
(function(TransactionStatus) {
    TransactionStatus["FAILED"] = "failed";
    TransactionStatus["RUNNING"] = "running";
    TransactionStatus["SUCCESS"] = "success";
})($d1999c83d031453a$export$7c391bd3b61d2374 || ($d1999c83d031453a$export$7c391bd3b61d2374 = {}));
var $d1999c83d031453a$export$16073528a91c8d2a = function isCosmosTransaction(transaction) {
    return transaction.type === $d1999c83d031453a$export$d513b00599f845d4.COSMOS;
};
var $d1999c83d031453a$export$b1818bc93202fd47 = function isSolanaTransaction(transaction) {
    return transaction.type === $d1999c83d031453a$export$d513b00599f845d4.SOLANA;
};
var $d1999c83d031453a$export$a6e014f972e5c64c = function isTransferTransaction(transaction) {
    return transaction.type === $d1999c83d031453a$export$d513b00599f845d4.TRANSFER;
};
var $d1999c83d031453a$var$TonChainID;
(function(TonChainID) {
    TonChainID["MAINNET"] = "-239";
    TonChainID["TESTNET"] = "-3";
})($d1999c83d031453a$var$TonChainID || ($d1999c83d031453a$var$TonChainID = {}));
var $d1999c83d031453a$export$b9109202fe95a066 = function isEvmTransaction(transaction) {
    return transaction.type === $d1999c83d031453a$export$d513b00599f845d4.EVM;
};
var $d1999c83d031453a$export$a9c5efc643299fb4 = {
    rpc: {
        invalidInput: -32000,
        resourceNotFound: -32001,
        resourceUnavailable: -32002,
        transactionRejected: -32003,
        methodNotSupported: -32004,
        limitExceeded: -32005,
        parse: -32700,
        invalidRequest: -32600,
        methodNotFound: -32601,
        invalidParams: -32602,
        internal: -32603
    },
    provider: {
        userRejectedRequest: 4001,
        unauthorized: 4100,
        unsupportedMethod: 4200,
        disconnected: 4900,
        chainDisconnected: 4901
    }
};
function $d1999c83d031453a$var$sleep(ms) {
    return new Promise(function(resolve) {
        return setTimeout(resolve, ms);
    });
}
function $d1999c83d031453a$var$prepareEvmTransaction(evmTx, isApprove) {
    var gasPrice = !!evmTx.gasPrice && !evmTx.gasPrice.startsWith("0x") ? "0x" + parseInt(evmTx.gasPrice).toString(16) : null;
    var manipulatedTx = $d1999c83d031453a$var$_extends({}, evmTx, {
        gasPrice: gasPrice
    });
    var tx = {};
    if (!!manipulatedTx.from) tx = $d1999c83d031453a$var$_extends({}, tx, {
        from: manipulatedTx.from
    });
    if (isApprove) {
        if (!!manipulatedTx.approveTo) tx = $d1999c83d031453a$var$_extends({}, tx, {
            to: manipulatedTx.approveTo
        });
        if (!!manipulatedTx.approveData) tx = $d1999c83d031453a$var$_extends({}, tx, {
            data: manipulatedTx.approveData
        });
    } else {
        if (!!manipulatedTx.txTo) tx = $d1999c83d031453a$var$_extends({}, tx, {
            to: manipulatedTx.txTo
        });
        if (!!manipulatedTx.txData) tx = $d1999c83d031453a$var$_extends({}, tx, {
            data: manipulatedTx.txData
        });
        if (!!manipulatedTx.value) tx = $d1999c83d031453a$var$_extends({}, tx, {
            value: manipulatedTx.value
        });
        if (!!manipulatedTx.gasLimit) tx = $d1999c83d031453a$var$_extends({}, tx, {
            gasLimit: manipulatedTx.gasLimit
        });
        if (!!manipulatedTx.gasPrice) tx = $d1999c83d031453a$var$_extends({}, tx, {
            gasPrice: manipulatedTx.gasPrice
        });
    }
    return tx;
}
function $d1999c83d031453a$var$checkApprovalSync(_x, _x2, _x3) {
    return $d1999c83d031453a$var$_checkApprovalSync.apply(this, arguments);
}
function $d1999c83d031453a$var$_checkApprovalSync() {
    $d1999c83d031453a$var$_checkApprovalSync = $d1999c83d031453a$var$_asyncToGenerator(/*#__PURE__*/ $d1999c83d031453a$var$_regeneratorRuntime().mark(function _callee3(requestId, txId, rangoClient) {
        var approvalResponse;
        return $d1999c83d031453a$var$_regeneratorRuntime().wrap(function _callee3$(_context3) {
            while(true)switch(_context3.prev = _context3.next){
                case 0:
                    _context3.prev = 1;
                    _context3.next = 4;
                    return rangoClient.isApproved(requestId, txId);
                case 4:
                    approvalResponse = _context3.sent;
                    if (!(approvalResponse != null && approvalResponse.isApproved)) {
                        _context3.next = 7;
                        break;
                    }
                    return _context3.abrupt("return", true);
                case 7:
                    if (!(!(approvalResponse != null && approvalResponse.isApproved) && (approvalResponse == null ? void 0 : approvalResponse.txStatus) === $d1999c83d031453a$export$7c391bd3b61d2374.FAILED)) {
                        _context3.next = 9;
                        break;
                    }
                    return _context3.abrupt("return", false);
                case 9:
                    _context3.next = 14;
                    break;
                case 11:
                    _context3.prev = 11;
                    _context3.t0 = _context3["catch"](1);
                    console.log("ignorinig error", {
                        err: _context3.t0
                    });
                case 14:
                    _context3.next = 16;
                    return $d1999c83d031453a$var$sleep(3000);
                case 16:
                    _context3.next = 0;
                    break;
                case 18:
                case "end":
                    return _context3.stop();
            }
        }, _callee3, null, [
            [
                1,
                11
            ]
        ]);
    }));
    return $d1999c83d031453a$var$_checkApprovalSync.apply(this, arguments);
}
var $d1999c83d031453a$var$checkTransactionStatusSync = /*#__PURE__*/ function() {
    var _ref = /*#__PURE__*/ $d1999c83d031453a$var$_asyncToGenerator(/*#__PURE__*/ $d1999c83d031453a$var$_regeneratorRuntime().mark(function _callee(requestId, txId, rangoClient) {
        var txStatus;
        return $d1999c83d031453a$var$_regeneratorRuntime().wrap(function _callee$(_context) {
            while(true)switch(_context.prev = _context.next){
                case 0:
                    _context.prev = 1;
                    _context.next = 4;
                    return rangoClient.status({
                        requestId: requestId,
                        txId: txId
                    });
                case 4:
                    txStatus = _context.sent;
                    _context.next = 10;
                    break;
                case 7:
                    _context.prev = 7;
                    _context.t0 = _context["catch"](1);
                    console.log("ignorinig error", {
                        err: _context.t0
                    });
                case 10:
                    if (!txStatus) {
                        _context.next = 13;
                        break;
                    }
                    if (!(!!txStatus.status && [
                        $d1999c83d031453a$export$7c391bd3b61d2374.FAILED,
                        $d1999c83d031453a$export$7c391bd3b61d2374.SUCCESS
                    ].includes(txStatus.status))) {
                        _context.next = 13;
                        break;
                    }
                    return _context.abrupt("return", txStatus);
                case 13:
                    _context.next = 15;
                    return $d1999c83d031453a$var$sleep(3000);
                case 15:
                    _context.next = 0;
                    break;
                case 17:
                case "end":
                    return _context.stop();
            }
        }, _callee, null, [
            [
                1,
                7
            ]
        ]);
    }));
    return function checkTransactionStatusSync(_x4, _x5, _x6) {
        return _ref.apply(this, arguments);
    };
}();
var $d1999c83d031453a$var$executeEvmRoute = /*#__PURE__*/ function() {
    var _ref2 = /*#__PURE__*/ $d1999c83d031453a$var$_asyncToGenerator(/*#__PURE__*/ $d1999c83d031453a$var$_regeneratorRuntime().mark(function _callee2(client, signer, route) {
        var tx, requestId, error, resultType, evmTransaction, txChainId, signerChainId, approveTxData, approveTx, isApproved, mainTxData, mainTx, status;
        return $d1999c83d031453a$var$_regeneratorRuntime().wrap(function _callee2$(_context2) {
            while(true)switch(_context2.prev = _context2.next){
                case 0:
                    tx = route.tx, requestId = route.requestId, error = route.error, resultType = route.resultType;
                    if (!(resultType != "OK")) {
                        _context2.next = 3;
                        break;
                    }
                    throw new Error(resultType);
                case 3:
                    if (!(!!error || !tx)) {
                        _context2.next = 5;
                        break;
                    }
                    throw new Error(error || "Error creating the transaction.");
                case 5:
                    if (!((tx == null ? void 0 : tx.type) !== $d1999c83d031453a$export$d513b00599f845d4.EVM)) {
                        _context2.next = 7;
                        break;
                    }
                    throw new Error("Non Evm transactions are not supported yet.");
                case 7:
                    evmTransaction = tx;
                    if (evmTransaction) {
                        _context2.next = 10;
                        break;
                    }
                    throw new Error("Transaction is null. Please try again!");
                case 10:
                    txChainId = parseInt(evmTransaction.blockChain.chainId || "-1");
                    _context2.next = 13;
                    return signer.getChainId();
                case 13:
                    signerChainId = _context2.sent;
                    if (!(signerChainId !== txChainId)) {
                        _context2.next = 16;
                        break;
                    }
                    throw new Error("Signer chainId " + signerChainId + " doesn't match required chainId " + txChainId + ".");
                case 16:
                    if (!(!!evmTransaction.approveTo && !!evmTransaction.approveData)) {
                        _context2.next = 27;
                        break;
                    }
                    approveTxData = $d1999c83d031453a$var$prepareEvmTransaction(evmTransaction, true);
                    _context2.next = 20;
                    return signer.sendTransaction(approveTxData);
                case 20:
                    approveTx = _context2.sent;
                    approveTx.wait();
                    _context2.next = 24;
                    return $d1999c83d031453a$var$checkApprovalSync(requestId, approveTx.hash, client);
                case 24:
                    isApproved = _context2.sent;
                    if (isApproved) {
                        _context2.next = 27;
                        break;
                    }
                    throw new Error("Error in approve transaction.");
                case 27:
                    _context2.next = 29;
                    return signer.getChainId();
                case 29:
                    signerChainId = _context2.sent;
                    if (!(signerChainId !== txChainId)) {
                        _context2.next = 32;
                        break;
                    }
                    throw new Error("Signer chainId " + signerChainId + " doesn't match required chainId " + txChainId + ".");
                case 32:
                    mainTxData = $d1999c83d031453a$var$prepareEvmTransaction(evmTransaction, false);
                    _context2.next = 35;
                    return signer.sendTransaction(mainTxData);
                case 35:
                    mainTx = _context2.sent;
                    mainTx.wait();
                    _context2.next = 39;
                    return $d1999c83d031453a$var$checkTransactionStatusSync(requestId, mainTx.hash, client);
                case 39:
                    status = _context2.sent;
                    if (!(status.status !== $d1999c83d031453a$export$7c391bd3b61d2374.SUCCESS)) {
                        _context2.next = 42;
                        break;
                    }
                    throw new Error("Cross-chain swap failed. " + (status.error || ""));
                case 42:
                    return _context2.abrupt("return", status);
                case 43:
                case "end":
                    return _context2.stop();
            }
        }, _callee2);
    }));
    return function executeEvmRoute(_x7, _x8, _x9) {
        return _ref2.apply(this, arguments);
    };
}();
// eslint-disable-next-line @typescript-eslint/no-explicit-any
var $d1999c83d031453a$var$prettifyError = function prettifyError(error) {
    if (!error) return error;
    if (error.code && (error.code === "ACTION_REJECTED" || error.code === 4001)) return new Error("Transaction Rejected");
    if (error && typeof error.code === "number") {
        if (Object.values($d1999c83d031453a$export$a9c5efc643299fb4.provider).includes(error.code)) return new Error((0, $764ab7ccc627cd55$exports.getMessageFromCode)(error.code));
        if (Object.values($d1999c83d031453a$export$a9c5efc643299fb4.rpc).includes(error.code)) {
            var _error$message, _error$message2, _error$message3;
            if (error.code === $d1999c83d031453a$export$a9c5efc643299fb4.rpc.internal && (_error$message = error.message) != null && _error$message.includes("underpriced")) return new Error("Transaction underpriced");
            if ((_error$message2 = error.message) != null && _error$message2.includes("intrinsic gas too low") || (_error$message3 = error.message) != null && _error$message3.includes("out of gas")) return new Error("This Gas limit is low.");
            return new Error((0, $764ab7ccc627cd55$exports.getMessageFromCode)(error.code));
        }
    }
    if (error.message) return new Error(error.message);
    return error;
};
var $d1999c83d031453a$export$2eb9c0bd2d5b9cf8 = /*#__PURE__*/ function() {
    function RangoClient(apiKey, debug, apiUrl) {
        if (debug === void 0) debug = false;
        this.apiUrl = apiUrl || "https://api.rango.exchange";
        this.apiKey = apiKey;
        try {
            if (typeof window !== "undefined") {
                var deviceId = localStorage.getItem("deviceId");
                if (deviceId) this.deviceId = deviceId;
                else {
                    var generatedId = (0, (/*@__PURE__*/$parcel$interopDefault($229428e7240420de$exports)))();
                    localStorage.setItem("deviceId", generatedId);
                    this.deviceId = generatedId;
                }
            } else this.deviceId = (0, (/*@__PURE__*/$parcel$interopDefault($229428e7240420de$exports)))();
        } catch (e) {
            this.deviceId = (0, (/*@__PURE__*/$parcel$interopDefault($229428e7240420de$exports)))();
        }
        this.httpService = (0, $de0338a08c4f70b1$export$2e2bcd8739ae039).create({
            baseURL: this.apiUrl
        });
        if (debug) {
            this.httpService.interceptors.request.use(function(request) {
                console.log("Starting Request", JSON.stringify(request, null, 2));
                return request;
            });
            this.httpService.interceptors.response.use(function(response) {
                console.log("Response:", JSON.stringify(response, null, 2));
                return response;
            });
        }
    }
    var _proto = RangoClient.prototype;
    _proto.meta = /*#__PURE__*/ function() {
        var _meta = /*#__PURE__*/ $d1999c83d031453a$var$_asyncToGenerator(/*#__PURE__*/ $d1999c83d031453a$var$_regeneratorRuntime().mark(function _callee(metaRequest, options) {
            var _metaRequest$blockcha, _metaRequest$swappers, _metaRequest$swappers2, _metaRequest$transact;
            var params, axiosResponse;
            return $d1999c83d031453a$var$_regeneratorRuntime().wrap(function _callee$(_context) {
                while(true)switch(_context.prev = _context.next){
                    case 0:
                        params = $d1999c83d031453a$var$_extends({}, metaRequest, {
                            blockchains: metaRequest == null || (_metaRequest$blockcha = metaRequest.blockchains) == null ? void 0 : _metaRequest$blockcha.join(),
                            swappers: metaRequest == null || (_metaRequest$swappers = metaRequest.swappers) == null ? void 0 : _metaRequest$swappers.join(),
                            swappersGroups: metaRequest == null || (_metaRequest$swappers2 = metaRequest.swappersGroups) == null ? void 0 : _metaRequest$swappers2.join(),
                            transactionTypes: metaRequest == null || (_metaRequest$transact = metaRequest.transactionTypes) == null ? void 0 : _metaRequest$transact.join()
                        });
                        _context.next = 3;
                        return this.httpService.get("/basic/meta?apiKey=" + this.apiKey, $d1999c83d031453a$var$_extends({
                            params: params
                        }, options));
                    case 3:
                        axiosResponse = _context.sent;
                        return _context.abrupt("return", axiosResponse.data);
                    case 5:
                    case "end":
                        return _context.stop();
                }
            }, _callee, this);
        }));
        function meta(_x, _x2) {
            return _meta.apply(this, arguments);
        }
        return meta;
    }();
    _proto.chains = /*#__PURE__*/ function() {
        var _chains = /*#__PURE__*/ $d1999c83d031453a$var$_asyncToGenerator(/*#__PURE__*/ $d1999c83d031453a$var$_regeneratorRuntime().mark(function _callee2(options) {
            var axiosResponse;
            return $d1999c83d031453a$var$_regeneratorRuntime().wrap(function _callee2$(_context2) {
                while(true)switch(_context2.prev = _context2.next){
                    case 0:
                        _context2.next = 2;
                        return this.httpService.get("/basic/meta/blockchains?apiKey=" + this.apiKey, $d1999c83d031453a$var$_extends({}, options));
                    case 2:
                        axiosResponse = _context2.sent;
                        return _context2.abrupt("return", axiosResponse.data);
                    case 4:
                    case "end":
                        return _context2.stop();
                }
            }, _callee2, this);
        }));
        function chains(_x3) {
            return _chains.apply(this, arguments);
        }
        return chains;
    }();
    _proto.swappers = /*#__PURE__*/ function() {
        var _swappers = /*#__PURE__*/ $d1999c83d031453a$var$_asyncToGenerator(/*#__PURE__*/ $d1999c83d031453a$var$_regeneratorRuntime().mark(function _callee3(options) {
            var axiosResponse;
            return $d1999c83d031453a$var$_regeneratorRuntime().wrap(function _callee3$(_context3) {
                while(true)switch(_context3.prev = _context3.next){
                    case 0:
                        _context3.next = 2;
                        return this.httpService.get("/basic/meta/swappers?apiKey=" + this.apiKey, $d1999c83d031453a$var$_extends({}, options));
                    case 2:
                        axiosResponse = _context3.sent;
                        return _context3.abrupt("return", axiosResponse.data);
                    case 4:
                    case "end":
                        return _context3.stop();
                }
            }, _callee3, this);
        }));
        function swappers(_x4) {
            return _swappers.apply(this, arguments);
        }
        return swappers;
    }();
    _proto.messagingProtocols = /*#__PURE__*/ function() {
        var _messagingProtocols = /*#__PURE__*/ $d1999c83d031453a$var$_asyncToGenerator(/*#__PURE__*/ $d1999c83d031453a$var$_regeneratorRuntime().mark(function _callee4(options) {
            var axiosResponse;
            return $d1999c83d031453a$var$_regeneratorRuntime().wrap(function _callee4$(_context4) {
                while(true)switch(_context4.prev = _context4.next){
                    case 0:
                        _context4.next = 2;
                        return this.httpService.get("/basic/meta/messaging-protocols?apiKey=" + this.apiKey, $d1999c83d031453a$var$_extends({}, options));
                    case 2:
                        axiosResponse = _context4.sent;
                        return _context4.abrupt("return", axiosResponse.data);
                    case 4:
                    case "end":
                        return _context4.stop();
                }
            }, _callee4, this);
        }));
        function messagingProtocols(_x5) {
            return _messagingProtocols.apply(this, arguments);
        }
        return messagingProtocols;
    }();
    _proto.quote = /*#__PURE__*/ function() {
        var _quote = /*#__PURE__*/ $d1999c83d031453a$var$_asyncToGenerator(/*#__PURE__*/ $d1999c83d031453a$var$_regeneratorRuntime().mark(function _callee5(quoteRequest, options) {
            var body, axiosResponse;
            return $d1999c83d031453a$var$_regeneratorRuntime().wrap(function _callee5$(_context5) {
                while(true)switch(_context5.prev = _context5.next){
                    case 0:
                        body = $d1999c83d031453a$var$_extends({}, quoteRequest, {
                            from: $d1999c83d031453a$export$2852f7fe3195f604(quoteRequest.from),
                            to: $d1999c83d031453a$export$2852f7fe3195f604(quoteRequest.to),
                            swappers: !!quoteRequest.swappers && quoteRequest.swappers.length > 0 ? quoteRequest.swappers.join(",") : undefined,
                            swapperGroups: !!quoteRequest.swapperGroups && quoteRequest.swapperGroups.length > 0 ? quoteRequest.swapperGroups.join(",") : undefined,
                            messagingProtocols: !!quoteRequest.messagingProtocols && quoteRequest.messagingProtocols.length > 0 ? quoteRequest.messagingProtocols.join(",") : undefined
                        });
                        _context5.next = 3;
                        return this.httpService.get("/basic/quote?apiKey=" + this.apiKey, $d1999c83d031453a$var$_extends({
                            params: body,
                            headers: {
                                "X-Rango-Id": this.deviceId
                            }
                        }, options));
                    case 3:
                        axiosResponse = _context5.sent;
                        return _context5.abrupt("return", axiosResponse.data);
                    case 5:
                    case "end":
                        return _context5.stop();
                }
            }, _callee5, this);
        }));
        function quote(_x6, _x7) {
            return _quote.apply(this, arguments);
        }
        return quote;
    }();
    _proto.isApproved = /*#__PURE__*/ function() {
        var _isApproved = /*#__PURE__*/ $d1999c83d031453a$var$_asyncToGenerator(/*#__PURE__*/ $d1999c83d031453a$var$_regeneratorRuntime().mark(function _callee6(requestId, txId, options) {
            var axiosResponse;
            return $d1999c83d031453a$var$_regeneratorRuntime().wrap(function _callee6$(_context6) {
                while(true)switch(_context6.prev = _context6.next){
                    case 0:
                        _context6.next = 2;
                        return this.httpService.get("/basic/is-approved?apiKey=" + this.apiKey, $d1999c83d031453a$var$_extends({
                            params: {
                                requestId: requestId,
                                txId: txId
                            },
                            headers: {
                                "X-Rango-Id": this.deviceId
                            }
                        }, options));
                    case 2:
                        axiosResponse = _context6.sent;
                        return _context6.abrupt("return", axiosResponse.data);
                    case 4:
                    case "end":
                        return _context6.stop();
                }
            }, _callee6, this);
        }));
        function isApproved(_x8, _x9, _x10) {
            return _isApproved.apply(this, arguments);
        }
        return isApproved;
    }();
    _proto.status = /*#__PURE__*/ function() {
        var _status = /*#__PURE__*/ $d1999c83d031453a$var$_asyncToGenerator(/*#__PURE__*/ $d1999c83d031453a$var$_regeneratorRuntime().mark(function _callee7(statusRequest, options) {
            var axiosResponse;
            return $d1999c83d031453a$var$_regeneratorRuntime().wrap(function _callee7$(_context7) {
                while(true)switch(_context7.prev = _context7.next){
                    case 0:
                        _context7.next = 2;
                        return this.httpService.get("/basic/status?apiKey=" + this.apiKey, $d1999c83d031453a$var$_extends({
                            params: statusRequest,
                            headers: {
                                "X-Rango-Id": this.deviceId
                            }
                        }, options));
                    case 2:
                        axiosResponse = _context7.sent;
                        return _context7.abrupt("return", axiosResponse.data);
                    case 4:
                    case "end":
                        return _context7.stop();
                }
            }, _callee7, this);
        }));
        function status(_x11, _x12) {
            return _status.apply(this, arguments);
        }
        return status;
    }();
    _proto.swap = /*#__PURE__*/ function() {
        var _swap = /*#__PURE__*/ $d1999c83d031453a$var$_asyncToGenerator(/*#__PURE__*/ $d1999c83d031453a$var$_regeneratorRuntime().mark(function _callee8(swapRequest, options) {
            var body, axiosResponse;
            return $d1999c83d031453a$var$_regeneratorRuntime().wrap(function _callee8$(_context8) {
                while(true)switch(_context8.prev = _context8.next){
                    case 0:
                        body = $d1999c83d031453a$var$_extends({}, swapRequest, {
                            from: $d1999c83d031453a$export$2852f7fe3195f604(swapRequest.from),
                            to: $d1999c83d031453a$export$2852f7fe3195f604(swapRequest.to),
                            referrerAddress: swapRequest.referrerAddress || null,
                            referrerFee: swapRequest.referrerFee || null,
                            disableEstimate: swapRequest.disableEstimate || false,
                            swappers: !!swapRequest.swappers && swapRequest.swappers.length > 0 ? swapRequest.swappers.join(",") : undefined,
                            swapperGroups: !!swapRequest.swapperGroups && swapRequest.swapperGroups.length > 0 ? swapRequest.swapperGroups.join(",") : undefined,
                            messagingProtocols: !!swapRequest.messagingProtocols && swapRequest.messagingProtocols.length > 0 ? swapRequest.messagingProtocols.join(",") : undefined
                        });
                        _context8.next = 3;
                        return this.httpService.get("/basic/swap?apiKey=" + this.apiKey, $d1999c83d031453a$var$_extends({
                            params: body,
                            headers: {
                                "X-Rango-Id": this.deviceId
                            }
                        }, options));
                    case 3:
                        axiosResponse = _context8.sent;
                        return _context8.abrupt("return", axiosResponse.data);
                    case 5:
                    case "end":
                        return _context8.stop();
                }
            }, _callee8, this);
        }));
        function swap(_x13, _x14) {
            return _swap.apply(this, arguments);
        }
        return swap;
    }();
    _proto.reportFailure = /*#__PURE__*/ function() {
        var _reportFailure = /*#__PURE__*/ $d1999c83d031453a$var$_asyncToGenerator(/*#__PURE__*/ $d1999c83d031453a$var$_regeneratorRuntime().mark(function _callee9(requestBody, options) {
            return $d1999c83d031453a$var$_regeneratorRuntime().wrap(function _callee9$(_context9) {
                while(true)switch(_context9.prev = _context9.next){
                    case 0:
                        _context9.next = 2;
                        return this.httpService.post("/basic/report-tx?apiKey=" + this.apiKey, requestBody, $d1999c83d031453a$var$_extends({
                            headers: {
                                "X-Rango-Id": this.deviceId
                            }
                        }, options));
                    case 2:
                    case "end":
                        return _context9.stop();
                }
            }, _callee9, this);
        }));
        function reportFailure(_x15, _x16) {
            return _reportFailure.apply(this, arguments);
        }
        return reportFailure;
    }();
    _proto.balance = /*#__PURE__*/ function() {
        var _balance = /*#__PURE__*/ $d1999c83d031453a$var$_asyncToGenerator(/*#__PURE__*/ $d1999c83d031453a$var$_regeneratorRuntime().mark(function _callee10(walletAddress, options) {
            var axiosResponse;
            return $d1999c83d031453a$var$_regeneratorRuntime().wrap(function _callee10$(_context10) {
                while(true)switch(_context10.prev = _context10.next){
                    case 0:
                        _context10.next = 2;
                        return this.httpService.get("/basic/balance?apiKey=" + this.apiKey, $d1999c83d031453a$var$_extends({
                            params: walletAddress,
                            headers: {
                                "X-Rango-Id": this.deviceId
                            }
                        }, options));
                    case 2:
                        axiosResponse = _context10.sent;
                        return _context10.abrupt("return", axiosResponse.data);
                    case 4:
                    case "end":
                        return _context10.stop();
                }
            }, _callee10, this);
        }));
        function balance(_x17, _x18) {
            return _balance.apply(this, arguments);
        }
        return balance;
    }();
    _proto.executeEvmRoute = /*#__PURE__*/ function() {
        var _executeEvmRoute2 = /*#__PURE__*/ $d1999c83d031453a$var$_asyncToGenerator(/*#__PURE__*/ $d1999c83d031453a$var$_regeneratorRuntime().mark(function _callee11(// eslint-disable-next-line @typescript-eslint/no-explicit-any
        signer, route) {
            var prettifiedError, message;
            return $d1999c83d031453a$var$_regeneratorRuntime().wrap(function _callee11$(_context11) {
                while(true)switch(_context11.prev = _context11.next){
                    case 0:
                        _context11.prev = 0;
                        _context11.next = 3;
                        return $d1999c83d031453a$var$executeEvmRoute(this, signer, route);
                    case 3:
                        return _context11.abrupt("return", _context11.sent);
                    case 6:
                        _context11.prev = 6;
                        _context11.t0 = _context11["catch"](0);
                        prettifiedError = $d1999c83d031453a$var$prettifyError(_context11.t0);
                        try {
                            message = (prettifiedError == null ? void 0 : prettifiedError.message) || "Error executing the route";
                            this.reportFailure({
                                requestId: route.requestId,
                                eventType: "TX_FAIL",
                                reason: message
                            });
                        } catch (err) {
                            console.log({
                                err: err
                            });
                        }
                        throw prettifiedError;
                    case 11:
                    case "end":
                        return _context11.stop();
                }
            }, _callee11, this, [
                [
                    0,
                    6
                ]
            ]);
        }));
        function executeEvmRoute$1(_x19, _x20) {
            return _executeEvmRoute2.apply(this, arguments);
        }
        return executeEvmRoute$1;
    }();
    return RangoClient;
}();


const $9617fc566a5b29a6$export$f3b29532bf2754af = /*#__PURE__*/ (0, $bh6RR.createContext)({
    sdk: new (0, $d1999c83d031453a$export$2eb9c0bd2d5b9cf8)((0, $b5f7f016a4b1ac5d$export$4c0481fa974c14d3), undefined, (0, $b5f7f016a4b1ac5d$export$6554e0e4e82f1b3a)),
    baseUrl: (0, $b5f7f016a4b1ac5d$export$6554e0e4e82f1b3a),
    handleBaseUrlChange: ()=>{},
    rangoApiKey: (0, $b5f7f016a4b1ac5d$export$4c0481fa974c14d3),
    handleRangoApiKeyChange: ()=>{},
    enableCentralizedSwappers: false,
    toggleEnableCentralizedSwappers: ()=>{}
});
const $9617fc566a5b29a6$export$1b17d8c9e4be3776 = ({ children: children })=>{
    const [baseUrl, setBaseUrl] = (0, $bh6RR.useState)((0, $b5f7f016a4b1ac5d$export$6554e0e4e82f1b3a));
    const [rangoApiKey, setRangoApiKey] = (0, $bh6RR.useState)((0, $b5f7f016a4b1ac5d$export$4c0481fa974c14d3));
    const [enableCentralizedSwappers, setEnableCentralizedSwappers] = (0, $bh6RR.useState)(false);
    const rangoClient = (0, $bh6RR.useMemo)(()=>new (0, $d1999c83d031453a$export$2eb9c0bd2d5b9cf8)(rangoApiKey, undefined, baseUrl), [
        baseUrl,
        rangoApiKey
    ]);
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)($9617fc566a5b29a6$export$f3b29532bf2754af.Provider, {
        value: {
            sdk: rangoClient,
            baseUrl: baseUrl,
            handleBaseUrlChange: (baseUrl)=>setBaseUrl(baseUrl),
            rangoApiKey: rangoApiKey,
            handleRangoApiKeyChange: (rangoApiKey)=>setRangoApiKey(rangoApiKey),
            enableCentralizedSwappers: enableCentralizedSwappers,
            toggleEnableCentralizedSwappers: ()=>setEnableCentralizedSwappers((prev)=>!prev)
        },
        children: children
    });
};
function $9617fc566a5b29a6$export$84144ee7888574a() {
    const { sdk: sdk, baseUrl: baseUrl, handleBaseUrlChange: handleBaseUrlChange, rangoApiKey: rangoApiKey, handleRangoApiKeyChange: handleRangoApiKeyChange, enableCentralizedSwappers: enableCentralizedSwappers, toggleEnableCentralizedSwappers: toggleEnableCentralizedSwappers } = (0, $bh6RR.useContext)($9617fc566a5b29a6$export$f3b29532bf2754af);
    return {
        sdk: sdk,
        baseUrl: baseUrl,
        handleBaseUrlChange: handleBaseUrlChange,
        rangoApiKey: rangoApiKey,
        handleRangoApiKeyChange: handleRangoApiKeyChange,
        enableCentralizedSwappers: enableCentralizedSwappers,
        toggleEnableCentralizedSwappers: toggleEnableCentralizedSwappers
    };
}


const $f78672dfe5332b9c$var$BaseURLInput = ()=>{
    const { baseUrl: baseUrl, handleBaseUrlChange: handleBaseUrlChange } = (0, $9617fc566a5b29a6$export$84144ee7888574a)();
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $1d5571bdb4f0e237$export$2c73285ae9390cec), {
        placeholder: "Base URL",
        value: baseUrl,
        onChange: (e)=>handleBaseUrlChange(e.target.value),
        size: "medium",
        style: {
            position: "relative",
            backgroundColor: "$background !important"
        },
        onResize: undefined,
        onResizeCapture: undefined,
        crossOrigin: undefined
    });
};
var $f78672dfe5332b9c$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $bh6RR.memo)($f78672dfe5332b9c$var$BaseURLInput);


var $7daa731229dfa725$export$2e2bcd8739ae039 = (0, $f78672dfe5332b9c$export$2e2bcd8739ae039);






var $bh6RR = parcelRequire("bh6RR");

const $6f698cf2740c8f35$var$APIKeyInput = ()=>{
    const { rangoApiKey: rangoApiKey, handleRangoApiKeyChange: handleRangoApiKeyChange } = (0, $9617fc566a5b29a6$export$84144ee7888574a)();
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $1d5571bdb4f0e237$export$2c73285ae9390cec), {
        placeholder: "API Key",
        value: rangoApiKey,
        onChange: (e)=>handleRangoApiKeyChange(e.target.value),
        size: "medium",
        style: {
            position: "relative",
            backgroundColor: "$background !important"
        },
        onResize: undefined,
        onResizeCapture: undefined,
        crossOrigin: undefined
    });
};
var $6f698cf2740c8f35$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $bh6RR.memo)($6f698cf2740c8f35$var$APIKeyInput);


var $807f1d8dbc170f5a$export$2e2bcd8739ae039 = (0, $6f698cf2740c8f35$export$2e2bcd8739ae039);


/* eslint-disable @typescript-eslint/no-empty-function */ 

var $bh6RR = parcelRequire("bh6RR");

const $664b7508f650ecf0$export$3328447b70582035 = /*#__PURE__*/ (0, $bh6RR.createContext)({
    protocols: [],
    selectedProtocols: [],
    loadingProtocols: true,
    handleSelectedProtocolsChange: ()=>{}
});
const $664b7508f650ecf0$export$a90fea0367980e1 = ({ children: children })=>{
    const [protocols, setProtocols] = (0, $bh6RR.useState)([]);
    const [selectedProtocols, setSelectedProtocols] = (0, $bh6RR.useState)([]);
    const [loadingProtocols, setLoadingProtocols] = (0, $bh6RR.useState)(true);
    const { sdk: sdk } = (0, $9617fc566a5b29a6$export$84144ee7888574a)();
    (0, $bh6RR.useEffect)(()=>{
        sdk.messagingProtocols().then(({ protocols: protocols })=>{
            const protocolsList = protocols.map((p)=>p.id);
            setProtocols(protocolsList);
            setLoadingProtocols(false);
        });
    }, [
        sdk
    ]);
    const handleSelectedProtocolsChange = (0, $bh6RR.useCallback)((protocol)=>{
        if (selectedProtocols.includes(protocol)) setSelectedProtocols((selectedProtocols)=>selectedProtocols.filter((p)=>p !== protocol));
        else setSelectedProtocols((selectedProtocols)=>[
                ...selectedProtocols,
                protocol
            ]);
    }, [
        selectedProtocols,
        setSelectedProtocols
    ]);
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)($664b7508f650ecf0$export$3328447b70582035.Provider, {
        value: {
            protocols: protocols,
            loadingProtocols: loadingProtocols,
            selectedProtocols: selectedProtocols,
            handleSelectedProtocolsChange: handleSelectedProtocolsChange
        },
        children: children
    });
};
function $664b7508f650ecf0$export$ed5191c2f06fff37() {
    const { protocols: protocols, loadingProtocols: loadingProtocols, selectedProtocols: selectedProtocols, handleSelectedProtocolsChange: handleSelectedProtocolsChange } = (0, $bh6RR.useContext)($664b7508f650ecf0$export$3328447b70582035);
    return {
        protocols: protocols,
        loadingProtocols: loadingProtocols,
        selectedProtocols: selectedProtocols,
        handleSelectedProtocolsChange: handleSelectedProtocolsChange
    };
}




var $bh6RR = parcelRequire("bh6RR");

const $4e4f1eb09c7daf7c$export$446a609a1d862b70 = /*#__PURE__*/ (0, $bh6RR.createContext)({
    meta: null,
    metaLoading: true
});
const $4e4f1eb09c7daf7c$export$3d88e5d350ac07d9 = ({ children: children })=>{
    const [meta, setMeta] = (0, $bh6RR.useState)(null);
    const [metaLoading, setMetaLoading] = (0, $bh6RR.useState)(true);
    const { sdk: sdk, enableCentralizedSwappers: enableCentralizedSwappers } = (0, $9617fc566a5b29a6$export$84144ee7888574a)();
    (0, $bh6RR.useEffect)(()=>{
        if (sdk) sdk.meta(enableCentralizedSwappers ? {
            enableCentralizedSwappers: enableCentralizedSwappers
        } : undefined).then((meta)=>{
            setMeta(meta);
            setMetaLoading(false);
        });
    }, [
        sdk,
        enableCentralizedSwappers
    ]);
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)($4e4f1eb09c7daf7c$export$446a609a1d862b70.Provider, {
        value: {
            meta: meta,
            metaLoading: metaLoading
        },
        children: children
    });
};
function $4e4f1eb09c7daf7c$export$3fb9275d3845bd5a() {
    const { meta: meta, metaLoading: metaLoading } = (0, $bh6RR.useContext)($4e4f1eb09c7daf7c$export$446a609a1d862b70);
    return {
        meta: meta,
        metaLoading: metaLoading
    };
}




parcelRequire("bh6RR");

const $4b362bd834908edb$var$MessagingProtocolsModal = ({ open: open, handleClose: handleClose })=>{
    const { protocols: protocols, selectedProtocols: selectedProtocols, handleSelectedProtocolsChange: handleSelectedProtocolsChange } = (0, $664b7508f650ecf0$export$ed5191c2f06fff37)();
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $1d5571bdb4f0e237$export$2b77a92f1a5ad772), {
        open: open,
        onClose: handleClose,
        content: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
            children: protocols.map((protocol, index)=>/*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $d4dab640dcbe486c$exports.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $1d5571bdb4f0e237$export$353f5b6fc5456de1), {
                            variant: "outlined",
                            size: "large",
                            suffix: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $1d5571bdb4f0e237$export$b5d5cf8927ab7262), {
                                checked: selectedProtocols.includes(protocol),
                                onChange: ()=>handleSelectedProtocolsChange(protocol)
                            }),
                            align: "start",
                            children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $1d5571bdb4f0e237$export$1c6175f3aa4394b7), {
                                variant: "body2",
                                children: protocol
                            })
                        }, index),
                        /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $1d5571bdb4f0e237$export$d7a54cba636a8cd6), {
                            size: 16,
                            direction: "vertical"
                        })
                    ]
                }))
        }),
        title: "Messaging Protocols",
        containerStyle: {
            width: "560px",
            height: "auto"
        }
    });
};
var $4b362bd834908edb$export$2e2bcd8739ae039 = $4b362bd834908edb$var$MessagingProtocolsModal;


var $fb56ab8296428c59$export$2e2bcd8739ae039 = (0, $4b362bd834908edb$export$2e2bcd8739ae039);




parcelRequire("bh6RR");

const $8209e93dbc57321d$var$LiquiditySourcesModal = ({ open: open, handleClose: handleClose, disabledLiquiditySources: disabledLiquiditySources, setDisabledLiquiditySources: setDisabledLiquiditySources })=>{
    const { meta: meta } = (0, $4e4f1eb09c7daf7c$export$3fb9275d3845bd5a)();
    if (!meta) return null;
    const uniqueSwappersGroups = [];
    Array.from(new Set(meta.swappers.map((s)=>s.swapperGroup))).map((swapperGroup)=>{
        return meta.swappers.find((s)=>s.swapperGroup === swapperGroup);
    }).find((s)=>{
        if (s) {
            for (const type of s.types)// @ts-ignore
            if (type === "OFF_CHAIN") uniqueSwappersGroups.push({
                title: s.swapperGroup,
                logo: s.logo,
                type: "BRIDGE",
                selected: !disabledLiquiditySources.includes(s.swapperGroup)
            });
            else uniqueSwappersGroups.push({
                title: s.swapperGroup,
                logo: s.logo,
                type: type,
                selected: !disabledLiquiditySources.includes(s.swapperGroup)
            });
        }
    });
    const toggleAllLiquiditySources = ()=>{
        if (meta.swappers.length - disabledLiquiditySources.length === 0) setDisabledLiquiditySources([]);
        else {
            const allSwappers = meta.swappers.map((swapper)=>swapper.swapperGroup);
            setDisabledLiquiditySources(allSwappers);
        }
    };
    const toggleLiquiditySource = (name)=>{
        const result = disabledLiquiditySources.includes(name) ? disabledLiquiditySources.filter((liquiditySource)=>liquiditySource !== name) : disabledLiquiditySources.concat(name);
        setDisabledLiquiditySources(result);
    };
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $1d5571bdb4f0e237$export$2b77a92f1a5ad772), {
        onClose: handleClose,
        open: open,
        action: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $1d5571bdb4f0e237$export$353f5b6fc5456de1), {
            type: "primary",
            variant: "ghost",
            onClick: toggleAllLiquiditySources,
            children: meta.swappers.length - disabledLiquiditySources.length === 0 ? "Select All" : "Clear All"
        }),
        content: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $1d5571bdb4f0e237$export$614fcb125bb4acc5), {
            loadingStatus: "success",
            listContainerStyle: {
                height: "auto",
                paddingBottom: 20
            },
            list: uniqueSwappersGroups,
            hasHeader: false,
            onChange: (liquiditySource)=>toggleLiquiditySource(liquiditySource.title)
        }),
        title: "Liquidity Sources",
        containerStyle: {
            width: "560px",
            height: "625px"
        }
    });
};
var $8209e93dbc57321d$export$2e2bcd8739ae039 = $8209e93dbc57321d$var$LiquiditySourcesModal;


var $dc143425db30361b$export$2e2bcd8739ae039 = (0, $8209e93dbc57321d$export$2e2bcd8739ae039);




var $bh6RR = parcelRequire("bh6RR");


const $fda8594edea4194a$var$ConnectWalletButton = ({ title: title, type: type, setError: setError })=>{
    const { connect: connect, state: state, disconnect: disconnect } = (0, $839aac193bf3ec6e$export$934951b5ed2ebf82)();
    const walletState = state(type);
    const handleClick = ()=>{
        if (!walletState.connected) connect(type).catch((error)=>{
            console.log(error);
            setError(`Error connecting to ${title}. Please check ${title} and try again.`);
        });
        else disconnect(type);
    };
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $1d5571bdb4f0e237$export$353f5b6fc5456de1), {
        variant: "outlined",
        size: "small",
        type: "primary",
        onClick: handleClick,
        loading: walletState.connecting,
        suffix: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $d4dab640dcbe486c$exports.Fragment), {
            children: walletState.connecting ? null : walletState.connected ? "Connected" : walletState.installed ? "Disconnected" : "Not Installed"
        }),
        children: title
    });
};
var $fda8594edea4194a$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $bh6RR.memo)($fda8594edea4194a$var$ConnectWalletButton);


var $de70f7ef5323a11a$export$2e2bcd8739ae039 = (0, $fda8594edea4194a$export$2e2bcd8739ae039);






var $bh6RR = parcelRequire("bh6RR");

var $d76834e42ece13f7$exports = {};

$parcel$export($d76834e42ece13f7$exports, "logger", function () { return $d76834e42ece13f7$export$af88d00dbe7f521; });
$parcel$export($d76834e42ece13f7$exports, "Signer", function () { return $04afbe51d47fcc12$exports.Signer; });
$parcel$export($d76834e42ece13f7$exports, "Wallet", function () { return $cf67a8ebc5cb0c41$exports.Wallet; });
$parcel$export($d76834e42ece13f7$exports, "VoidSigner", function () { return $04afbe51d47fcc12$exports.VoidSigner; });
$parcel$export($d76834e42ece13f7$exports, "getDefaultProvider", function () { return $6b2231007a47a4de$export$4f77a1d3c1ac6642; });
$parcel$export($d76834e42ece13f7$exports, "providers", function () { return $6b2231007a47a4de$exports; });
$parcel$export($d76834e42ece13f7$exports, "BaseContract", function () { return $8f1c51d58e4a2402$exports.BaseContract; });
$parcel$export($d76834e42ece13f7$exports, "Contract", function () { return $8f1c51d58e4a2402$exports.Contract; });
$parcel$export($d76834e42ece13f7$exports, "ContractFactory", function () { return $8f1c51d58e4a2402$exports.ContractFactory; });
$parcel$export($d76834e42ece13f7$exports, "BigNumber", function () { return $a87aa97415e1b917$export$d97aa349ed20696; });
$parcel$export($d76834e42ece13f7$exports, "FixedNumber", function () { return $efb9ddd3e2b20828$export$d4693c66c2213e45; });
$parcel$export($d76834e42ece13f7$exports, "constants", function () { return $c95343869e5b728e$exports; });
$parcel$export($d76834e42ece13f7$exports, "errors", function () { return $5f596c9584f643ae$export$d4e71bc0b80dc0fb; });
$parcel$export($d76834e42ece13f7$exports, "utils", function () { return $71abc16c547c9385$exports; });
$parcel$export($d76834e42ece13f7$exports, "wordlists", function () { return $0c19009e3fcf898f$export$e8e1b4711c2d1939; });
$parcel$export($d76834e42ece13f7$exports, "version", function () { return $67e1b984ae1fe502$export$83d89fbfd8236492; });
$parcel$export($d76834e42ece13f7$exports, "Wordlist", function () { return $1e5d872ea253eb5d$export$4d9531a8ddb0ebca; });
var $8f1c51d58e4a2402$exports = {};

$parcel$export($8f1c51d58e4a2402$exports, "BaseContract", function () { return $8f1c51d58e4a2402$export$304faa4fc17528db; });
$parcel$export($8f1c51d58e4a2402$exports, "Contract", function () { return $8f1c51d58e4a2402$export$8517d80acf00e19a; });
$parcel$export($8f1c51d58e4a2402$exports, "ContractFactory", function () { return $8f1c51d58e4a2402$export$505569a6bf584fd9; });




const $6cb368dce1713386$export$83d89fbfd8236492 = "abi/5.7.0";


"use strict";
const $3c454193c1d90bf8$var$logger = new (0, $5f596c9584f643ae$export$efa9a398d6368992)((0, $6cb368dce1713386$export$83d89fbfd8236492));
function $3c454193c1d90bf8$export$5546b9ec21157cc2(result) {
    // Find the first error (if any)
    const errors = [];
    const checkErrors = function(path, object) {
        if (!Array.isArray(object)) return;
        for(let key in object){
            const childPath = path.slice();
            childPath.push(key);
            try {
                checkErrors(childPath, object[key]);
            } catch (error) {
                errors.push({
                    path: childPath,
                    error: error
                });
            }
        }
    };
    checkErrors([], result);
    return errors;
}
class $3c454193c1d90bf8$export$2c0c39526f8bad46 {
    constructor(name, type, localName, dynamic){
        // @TODO: defineReadOnly these
        this.name = name;
        this.type = type;
        this.localName = localName;
        this.dynamic = dynamic;
    }
    _throwError(message, value) {
        $3c454193c1d90bf8$var$logger.throwArgumentError(message, this.localName, value);
    }
}
class $3c454193c1d90bf8$export$d7a960146e1a269e {
    constructor(wordSize){
        (0, $d2d9b472f7878d5e$exports.defineReadOnly)(this, "wordSize", wordSize || 32);
        this._data = [];
        this._dataLength = 0;
        this._padding = new Uint8Array(wordSize);
    }
    get data() {
        return (0, $06d75ae17ce69367$export$6d4b99629b38754a)(this._data);
    }
    get length() {
        return this._dataLength;
    }
    _writeData(data) {
        this._data.push(data);
        this._dataLength += data.length;
        return data.length;
    }
    appendWriter(writer) {
        return this._writeData((0, $06d75ae17ce69367$export$ee1b3e54f0441b22)(writer._data));
    }
    // Arrayish items; padded on the right to wordSize
    writeBytes(value) {
        let bytes = (0, $06d75ae17ce69367$export$3131421a7d01b4fb)(value);
        const paddingOffset = bytes.length % this.wordSize;
        if (paddingOffset) bytes = (0, $06d75ae17ce69367$export$ee1b3e54f0441b22)([
            bytes,
            this._padding.slice(paddingOffset)
        ]);
        return this._writeData(bytes);
    }
    _getValue(value) {
        let bytes = (0, $06d75ae17ce69367$export$3131421a7d01b4fb)((0, $a87aa97415e1b917$export$d97aa349ed20696).from(value));
        if (bytes.length > this.wordSize) $3c454193c1d90bf8$var$logger.throwError("value out-of-bounds", (0, $5f596c9584f643ae$export$efa9a398d6368992).errors.BUFFER_OVERRUN, {
            length: this.wordSize,
            offset: bytes.length
        });
        if (bytes.length % this.wordSize) bytes = (0, $06d75ae17ce69367$export$ee1b3e54f0441b22)([
            this._padding.slice(bytes.length % this.wordSize),
            bytes
        ]);
        return bytes;
    }
    // BigNumberish items; padded on the left to wordSize
    writeValue(value) {
        return this._writeData(this._getValue(value));
    }
    writeUpdatableValue() {
        const offset = this._data.length;
        this._data.push(this._padding);
        this._dataLength += this.wordSize;
        return (value)=>{
            this._data[offset] = this._getValue(value);
        };
    }
}
class $3c454193c1d90bf8$export$2f7a2f0e90c07dc4 {
    constructor(data, wordSize, coerceFunc, allowLoose){
        (0, $d2d9b472f7878d5e$exports.defineReadOnly)(this, "_data", (0, $06d75ae17ce69367$export$3131421a7d01b4fb)(data));
        (0, $d2d9b472f7878d5e$exports.defineReadOnly)(this, "wordSize", wordSize || 32);
        (0, $d2d9b472f7878d5e$exports.defineReadOnly)(this, "_coerceFunc", coerceFunc);
        (0, $d2d9b472f7878d5e$exports.defineReadOnly)(this, "allowLoose", allowLoose);
        this._offset = 0;
    }
    get data() {
        return (0, $06d75ae17ce69367$export$2b0d6b5fbe698c70)(this._data);
    }
    get consumed() {
        return this._offset;
    }
    // The default Coerce function
    static coerce(name, value) {
        let match = name.match("^u?int([0-9]+)$");
        if (match && parseInt(match[1]) <= 48) value = value.toNumber();
        return value;
    }
    coerce(name, value) {
        if (this._coerceFunc) return this._coerceFunc(name, value);
        return $3c454193c1d90bf8$export$2f7a2f0e90c07dc4.coerce(name, value);
    }
    _peekBytes(offset, length, loose) {
        let alignedLength = Math.ceil(length / this.wordSize) * this.wordSize;
        if (this._offset + alignedLength > this._data.length) {
            if (this.allowLoose && loose && this._offset + length <= this._data.length) alignedLength = length;
            else $3c454193c1d90bf8$var$logger.throwError("data out-of-bounds", (0, $5f596c9584f643ae$export$efa9a398d6368992).errors.BUFFER_OVERRUN, {
                length: this._data.length,
                offset: this._offset + alignedLength
            });
        }
        return this._data.slice(this._offset, this._offset + alignedLength);
    }
    subReader(offset) {
        return new $3c454193c1d90bf8$export$2f7a2f0e90c07dc4(this._data.slice(this._offset + offset), this.wordSize, this._coerceFunc, this.allowLoose);
    }
    readBytes(length, loose) {
        let bytes = this._peekBytes(0, length, !!loose);
        this._offset += bytes.length;
        // @TODO: Make sure the length..end bytes are all 0?
        return bytes.slice(0, length);
    }
    readValue() {
        return (0, $a87aa97415e1b917$export$d97aa349ed20696).from(this.readBytes(this.wordSize));
    }
}















"use strict";
class $fe65aa8688b9b674$export$59dbbded7775bfe7 extends (0, $3c454193c1d90bf8$export$2c0c39526f8bad46) {
    constructor(localName){
        super("address", "address", localName, false);
    }
    defaultValue() {
        return "0x0000000000000000000000000000000000000000";
    }
    encode(writer, value) {
        try {
            value = (0, $5652f239bab101de$export$88411125f012957a)(value);
        } catch (error) {
            this._throwError(error.message, value);
        }
        return writer.writeValue(value);
    }
    decode(reader) {
        return (0, $5652f239bab101de$export$88411125f012957a)((0, $06d75ae17ce69367$export$e9c46a54370b47e8)(reader.readValue().toHexString(), 20));
    }
}






"use strict";
class $91861a031176d8c1$export$87c41d1139a03fa2 extends (0, $3c454193c1d90bf8$export$2c0c39526f8bad46) {
    constructor(coder){
        super(coder.name, coder.type, undefined, coder.dynamic);
        this.coder = coder;
    }
    defaultValue() {
        return this.coder.defaultValue();
    }
    encode(writer, value) {
        return this.coder.encode(writer, value);
    }
    decode(reader) {
        return this.coder.decode(reader);
    }
}


"use strict";
const $8dbf16ede3c8aea2$var$logger = new (0, $5f596c9584f643ae$export$efa9a398d6368992)((0, $6cb368dce1713386$export$83d89fbfd8236492));
function $8dbf16ede3c8aea2$export$2a703dbb0cb35339(writer, coders, values) {
    let arrayValues = null;
    if (Array.isArray(values)) arrayValues = values;
    else if (values && typeof values === "object") {
        let unique = {};
        arrayValues = coders.map((coder)=>{
            const name = coder.localName;
            if (!name) $8dbf16ede3c8aea2$var$logger.throwError("cannot encode object for signature with missing names", (0, $5f596c9584f643ae$export$efa9a398d6368992).errors.INVALID_ARGUMENT, {
                argument: "values",
                coder: coder,
                value: values
            });
            if (unique[name]) $8dbf16ede3c8aea2$var$logger.throwError("cannot encode object for signature with duplicate names", (0, $5f596c9584f643ae$export$efa9a398d6368992).errors.INVALID_ARGUMENT, {
                argument: "values",
                coder: coder,
                value: values
            });
            unique[name] = true;
            return values[name];
        });
    } else $8dbf16ede3c8aea2$var$logger.throwArgumentError("invalid tuple value", "tuple", values);
    if (coders.length !== arrayValues.length) $8dbf16ede3c8aea2$var$logger.throwArgumentError("types/value length mismatch", "tuple", values);
    let staticWriter = new (0, $3c454193c1d90bf8$export$d7a960146e1a269e)(writer.wordSize);
    let dynamicWriter = new (0, $3c454193c1d90bf8$export$d7a960146e1a269e)(writer.wordSize);
    let updateFuncs = [];
    coders.forEach((coder, index)=>{
        let value = arrayValues[index];
        if (coder.dynamic) {
            // Get current dynamic offset (for the future pointer)
            let dynamicOffset = dynamicWriter.length;
            // Encode the dynamic value into the dynamicWriter
            coder.encode(dynamicWriter, value);
            // Prepare to populate the correct offset once we are done
            let updateFunc = staticWriter.writeUpdatableValue();
            updateFuncs.push((baseOffset)=>{
                updateFunc(baseOffset + dynamicOffset);
            });
        } else coder.encode(staticWriter, value);
    });
    // Backfill all the dynamic offsets, now that we know the static length
    updateFuncs.forEach((func)=>{
        func(staticWriter.length);
    });
    let length = writer.appendWriter(staticWriter);
    length += writer.appendWriter(dynamicWriter);
    return length;
}
function $8dbf16ede3c8aea2$export$417857010dc9287f(reader, coders) {
    let values = [];
    // A reader anchored to this base
    let baseReader = reader.subReader(0);
    coders.forEach((coder)=>{
        let value = null;
        if (coder.dynamic) {
            let offset = reader.readValue();
            let offsetReader = baseReader.subReader(offset.toNumber());
            try {
                value = coder.decode(offsetReader);
            } catch (error) {
                // Cannot recover from this
                if (error.code === (0, $5f596c9584f643ae$export$efa9a398d6368992).errors.BUFFER_OVERRUN) throw error;
                value = error;
                value.baseType = coder.name;
                value.name = coder.localName;
                value.type = coder.type;
            }
        } else try {
            value = coder.decode(reader);
        } catch (error) {
            // Cannot recover from this
            if (error.code === (0, $5f596c9584f643ae$export$efa9a398d6368992).errors.BUFFER_OVERRUN) throw error;
            value = error;
            value.baseType = coder.name;
            value.name = coder.localName;
            value.type = coder.type;
        }
        if (value != undefined) values.push(value);
    });
    // We only output named properties for uniquely named coders
    const uniqueNames = coders.reduce((accum, coder)=>{
        const name = coder.localName;
        if (name) {
            if (!accum[name]) accum[name] = 0;
            accum[name]++;
        }
        return accum;
    }, {});
    // Add any named parameters (i.e. tuples)
    coders.forEach((coder, index)=>{
        let name = coder.localName;
        if (!name || uniqueNames[name] !== 1) return;
        if (name === "length") name = "_length";
        if (values[name] != null) return;
        const value = values[index];
        if (value instanceof Error) Object.defineProperty(values, name, {
            enumerable: true,
            get: ()=>{
                throw value;
            }
        });
        else values[name] = value;
    });
    for(let i = 0; i < values.length; i++){
        const value = values[i];
        if (value instanceof Error) Object.defineProperty(values, i, {
            enumerable: true,
            get: ()=>{
                throw value;
            }
        });
    }
    return Object.freeze(values);
}
class $8dbf16ede3c8aea2$export$88bc419d2df11f54 extends (0, $3c454193c1d90bf8$export$2c0c39526f8bad46) {
    constructor(coder, length, localName){
        const type = coder.type + "[" + (length >= 0 ? length : "") + "]";
        const dynamic = length === -1 || coder.dynamic;
        super("array", type, localName, dynamic);
        this.coder = coder;
        this.length = length;
    }
    defaultValue() {
        // Verifies the child coder is valid (even if the array is dynamic or 0-length)
        const defaultChild = this.coder.defaultValue();
        const result = [];
        for(let i = 0; i < this.length; i++)result.push(defaultChild);
        return result;
    }
    encode(writer, value) {
        if (!Array.isArray(value)) this._throwError("expected array value", value);
        let count = this.length;
        if (count === -1) {
            count = value.length;
            writer.writeValue(value.length);
        }
        $8dbf16ede3c8aea2$var$logger.checkArgumentCount(value.length, count, "coder array" + (this.localName ? " " + this.localName : ""));
        let coders = [];
        for(let i = 0; i < value.length; i++)coders.push(this.coder);
        return $8dbf16ede3c8aea2$export$2a703dbb0cb35339(writer, coders, value);
    }
    decode(reader) {
        let count = this.length;
        if (count === -1) {
            count = reader.readValue().toNumber();
            // Check that there is *roughly* enough data to ensure
            // stray random data is not being read as a length. Each
            // slot requires at least 32 bytes for their value (or 32
            // bytes as a link to the data). This could use a much
            // tighter bound, but we are erroring on the side of safety.
            if (count * 32 > reader._data.length) $8dbf16ede3c8aea2$var$logger.throwError("insufficient data length", (0, $5f596c9584f643ae$export$efa9a398d6368992).errors.BUFFER_OVERRUN, {
                length: reader._data.length,
                count: count
            });
        }
        let coders = [];
        for(let i = 0; i < count; i++)coders.push(new (0, $91861a031176d8c1$export$87c41d1139a03fa2)(this.coder));
        return reader.coerce(this.name, $8dbf16ede3c8aea2$export$417857010dc9287f(reader, coders));
    }
}



"use strict";
class $079c5b06dccd461b$export$fe9118d6c093150c extends (0, $3c454193c1d90bf8$export$2c0c39526f8bad46) {
    constructor(localName){
        super("bool", "bool", localName, false);
    }
    defaultValue() {
        return false;
    }
    encode(writer, value) {
        return writer.writeValue(value ? 1 : 0);
    }
    decode(reader) {
        return reader.coerce(this.type, !reader.readValue().isZero());
    }
}




"use strict";
class $fadb8dbc86f3f525$export$db9eadd8df12ad2e extends (0, $3c454193c1d90bf8$export$2c0c39526f8bad46) {
    constructor(type, localName){
        super(type, type, localName, true);
    }
    defaultValue() {
        return "0x";
    }
    encode(writer, value) {
        value = (0, $06d75ae17ce69367$export$3131421a7d01b4fb)(value);
        let length = writer.writeValue(value.length);
        length += writer.writeBytes(value);
        return length;
    }
    decode(reader) {
        return reader.readBytes(reader.readValue().toNumber(), true);
    }
}
class $fadb8dbc86f3f525$export$e5823e9574df18d2 extends $fadb8dbc86f3f525$export$db9eadd8df12ad2e {
    constructor(localName){
        super("bytes", localName);
    }
    decode(reader) {
        return reader.coerce(this.name, (0, $06d75ae17ce69367$export$2b0d6b5fbe698c70)(super.decode(reader)));
    }
}




"use strict";
class $e392fc8f65f4ab4d$export$7dec9db68e6bcf5a extends (0, $3c454193c1d90bf8$export$2c0c39526f8bad46) {
    constructor(size, localName){
        let name = "bytes" + String(size);
        super(name, name, localName, false);
        this.size = size;
    }
    defaultValue() {
        return "0x0000000000000000000000000000000000000000000000000000000000000000".substring(0, 2 + this.size * 2);
    }
    encode(writer, value) {
        let data = (0, $06d75ae17ce69367$export$3131421a7d01b4fb)(value);
        if (data.length !== this.size) this._throwError("incorrect data length", value);
        return writer.writeBytes(data);
    }
    decode(reader) {
        return reader.coerce(this.name, (0, $06d75ae17ce69367$export$2b0d6b5fbe698c70)(reader.readBytes(this.size)));
    }
}



"use strict";
class $30b1de167c06c587$export$70982cadf2d6b4ec extends (0, $3c454193c1d90bf8$export$2c0c39526f8bad46) {
    constructor(localName){
        super("null", "", localName, false);
    }
    defaultValue() {
        return null;
    }
    encode(writer, value) {
        if (value != null) this._throwError("not null", value);
        return writer.writeBytes([]);
    }
    decode(reader) {
        reader.readBytes(0);
        return reader.coerce(this.name, null);
    }
}





"use strict";
class $fdf30bf73ed9cc94$export$b934dc8cfe13938c extends (0, $3c454193c1d90bf8$export$2c0c39526f8bad46) {
    constructor(size, signed, localName){
        const name = (signed ? "int" : "uint") + size * 8;
        super(name, name, localName, false);
        this.size = size;
        this.signed = signed;
    }
    defaultValue() {
        return 0;
    }
    encode(writer, value) {
        let v = (0, $a87aa97415e1b917$export$d97aa349ed20696).from(value);
        // Check bounds are safe for encoding
        let maxUintValue = (0, $9b44019502d48201$export$1b53890de5aabdd0).mask(writer.wordSize * 8);
        if (this.signed) {
            let bounds = maxUintValue.mask(this.size * 8 - 1);
            if (v.gt(bounds) || v.lt(bounds.add((0, $9b44019502d48201$export$9aa05a5866350bcf)).mul((0, $9b44019502d48201$export$c83ef0909a6ddeec)))) this._throwError("value out-of-bounds", value);
        } else if (v.lt((0, $9b44019502d48201$export$aaef8a3eae948f03)) || v.gt(maxUintValue.mask(this.size * 8))) this._throwError("value out-of-bounds", value);
        v = v.toTwos(this.size * 8).mask(this.size * 8);
        if (this.signed) v = v.fromTwos(this.size * 8).toTwos(8 * writer.wordSize);
        return writer.writeValue(v);
    }
    decode(reader) {
        let value = reader.readValue().mask(this.size * 8);
        if (this.signed) value = value.fromTwos(this.size * 8);
        return reader.coerce(this.name, value);
    }
}




"use strict";
class $e1c57c3faeb06af6$export$2d1b854518731426 extends (0, $fadb8dbc86f3f525$export$db9eadd8df12ad2e) {
    constructor(localName){
        super("string", localName);
    }
    defaultValue() {
        return "";
    }
    encode(writer, value) {
        return super.encode(writer, (0, $7bbf1261c840221b$export$8feeb310b4b4752f)(value));
    }
    decode(reader) {
        return (0, $7bbf1261c840221b$export$7643a1dc2c38d5eb)(super.decode(reader));
    }
}




"use strict";
class $6ceedefd2eee321a$export$e9fceba8f110fea6 extends (0, $3c454193c1d90bf8$export$2c0c39526f8bad46) {
    constructor(coders, localName){
        let dynamic = false;
        const types = [];
        coders.forEach((coder)=>{
            if (coder.dynamic) dynamic = true;
            types.push(coder.type);
        });
        const type = "tuple(" + types.join(",") + ")";
        super("tuple", type, localName, dynamic);
        this.coders = coders;
    }
    defaultValue() {
        const values = [];
        this.coders.forEach((coder)=>{
            values.push(coder.defaultValue());
        });
        // We only output named properties for uniquely named coders
        const uniqueNames = this.coders.reduce((accum, coder)=>{
            const name = coder.localName;
            if (name) {
                if (!accum[name]) accum[name] = 0;
                accum[name]++;
            }
            return accum;
        }, {});
        // Add named values
        this.coders.forEach((coder, index)=>{
            let name = coder.localName;
            if (!name || uniqueNames[name] !== 1) return;
            if (name === "length") name = "_length";
            if (values[name] != null) return;
            values[name] = values[index];
        });
        return Object.freeze(values);
    }
    encode(writer, value) {
        return (0, $8dbf16ede3c8aea2$export$2a703dbb0cb35339)(writer, this.coders, value);
    }
    decode(reader) {
        return reader.coerce(this.name, (0, $8dbf16ede3c8aea2$export$417857010dc9287f)(reader, this.coders));
    }
}






"use strict";
const $2cb0f13975c97159$var$logger = new (0, $5f596c9584f643ae$export$efa9a398d6368992)((0, $6cb368dce1713386$export$83d89fbfd8236492));
const $2cb0f13975c97159$var$_constructorGuard = {};
let $2cb0f13975c97159$var$ModifiersBytes = {
    calldata: true,
    memory: true,
    storage: true
};
let $2cb0f13975c97159$var$ModifiersNest = {
    calldata: true,
    memory: true
};
function $2cb0f13975c97159$var$checkModifier(type, name) {
    if (type === "bytes" || type === "string") {
        if ($2cb0f13975c97159$var$ModifiersBytes[name]) return true;
    } else if (type === "address") {
        if (name === "payable") return true;
    } else if (type.indexOf("[") >= 0 || type === "tuple") {
        if ($2cb0f13975c97159$var$ModifiersNest[name]) return true;
    }
    if ($2cb0f13975c97159$var$ModifiersBytes[name] || name === "payable") $2cb0f13975c97159$var$logger.throwArgumentError("invalid modifier", "name", name);
    return false;
}
// @TODO: Make sure that children of an indexed tuple are marked with a null indexed
function $2cb0f13975c97159$var$parseParamType(param, allowIndexed) {
    let originalParam = param;
    function throwError(i) {
        $2cb0f13975c97159$var$logger.throwArgumentError(`unexpected character at position ${i}`, "param", param);
    }
    param = param.replace(/\s/g, " ");
    function newNode(parent) {
        let node = {
            type: "",
            name: "",
            parent: parent,
            state: {
                allowType: true
            }
        };
        if (allowIndexed) node.indexed = false;
        return node;
    }
    let parent = {
        type: "",
        name: "",
        state: {
            allowType: true
        }
    };
    let node = parent;
    for(let i = 0; i < param.length; i++){
        let c = param[i];
        switch(c){
            case "(":
                if (node.state.allowType && node.type === "") node.type = "tuple";
                else if (!node.state.allowParams) throwError(i);
                node.state.allowType = false;
                node.type = $2cb0f13975c97159$var$verifyType(node.type);
                node.components = [
                    newNode(node)
                ];
                node = node.components[0];
                break;
            case ")":
                delete node.state;
                if (node.name === "indexed") {
                    if (!allowIndexed) throwError(i);
                    node.indexed = true;
                    node.name = "";
                }
                if ($2cb0f13975c97159$var$checkModifier(node.type, node.name)) node.name = "";
                node.type = $2cb0f13975c97159$var$verifyType(node.type);
                let child = node;
                node = node.parent;
                if (!node) throwError(i);
                delete child.parent;
                node.state.allowParams = false;
                node.state.allowName = true;
                node.state.allowArray = true;
                break;
            case ",":
                delete node.state;
                if (node.name === "indexed") {
                    if (!allowIndexed) throwError(i);
                    node.indexed = true;
                    node.name = "";
                }
                if ($2cb0f13975c97159$var$checkModifier(node.type, node.name)) node.name = "";
                node.type = $2cb0f13975c97159$var$verifyType(node.type);
                let sibling = newNode(node.parent);
                //{ type: "", name: "", parent: node.parent, state: { allowType: true } };
                node.parent.components.push(sibling);
                delete node.parent;
                node = sibling;
                break;
            // Hit a space...
            case " ":
                // If reading type, the type is done and may read a param or name
                if (node.state.allowType) {
                    if (node.type !== "") {
                        node.type = $2cb0f13975c97159$var$verifyType(node.type);
                        delete node.state.allowType;
                        node.state.allowName = true;
                        node.state.allowParams = true;
                    }
                }
                // If reading name, the name is done
                if (node.state.allowName) {
                    if (node.name !== "") {
                        if (node.name === "indexed") {
                            if (!allowIndexed) throwError(i);
                            if (node.indexed) throwError(i);
                            node.indexed = true;
                            node.name = "";
                        } else if ($2cb0f13975c97159$var$checkModifier(node.type, node.name)) node.name = "";
                        else node.state.allowName = false;
                    }
                }
                break;
            case "[":
                if (!node.state.allowArray) throwError(i);
                node.type += c;
                node.state.allowArray = false;
                node.state.allowName = false;
                node.state.readArray = true;
                break;
            case "]":
                if (!node.state.readArray) throwError(i);
                node.type += c;
                node.state.readArray = false;
                node.state.allowArray = true;
                node.state.allowName = true;
                break;
            default:
                if (node.state.allowType) {
                    node.type += c;
                    node.state.allowParams = true;
                    node.state.allowArray = true;
                } else if (node.state.allowName) {
                    node.name += c;
                    delete node.state.allowArray;
                } else if (node.state.readArray) node.type += c;
                else throwError(i);
        }
    }
    if (node.parent) $2cb0f13975c97159$var$logger.throwArgumentError("unexpected eof", "param", param);
    delete parent.state;
    if (node.name === "indexed") {
        if (!allowIndexed) throwError(originalParam.length - 7);
        if (node.indexed) throwError(originalParam.length - 7);
        node.indexed = true;
        node.name = "";
    } else if ($2cb0f13975c97159$var$checkModifier(node.type, node.name)) node.name = "";
    parent.type = $2cb0f13975c97159$var$verifyType(parent.type);
    return parent;
}
function $2cb0f13975c97159$var$populate(object, params) {
    for(let key in params)(0, $d2d9b472f7878d5e$exports.defineReadOnly)(object, key, params[key]);
}
const $2cb0f13975c97159$export$f010f239efc4d445 = Object.freeze({
    // Bare formatting, as is needed for computing a sighash of an event or function
    sighash: "sighash",
    // Human-Readable with Minimal spacing and without names (compact human-readable)
    minimal: "minimal",
    // Human-Readable with nice spacing, including all names
    full: "full",
    // JSON-format a la Solidity
    json: "json"
});
const $2cb0f13975c97159$var$paramTypeArray = new RegExp(/^(.*)\[([0-9]*)\]$/);
class $2cb0f13975c97159$export$426dc07f493a4c47 {
    constructor(constructorGuard, params){
        if (constructorGuard !== $2cb0f13975c97159$var$_constructorGuard) $2cb0f13975c97159$var$logger.throwError("use fromString", (0, $5f596c9584f643ae$export$efa9a398d6368992).errors.UNSUPPORTED_OPERATION, {
            operation: "new ParamType()"
        });
        $2cb0f13975c97159$var$populate(this, params);
        let match = this.type.match($2cb0f13975c97159$var$paramTypeArray);
        if (match) $2cb0f13975c97159$var$populate(this, {
            arrayLength: parseInt(match[2] || "-1"),
            arrayChildren: $2cb0f13975c97159$export$426dc07f493a4c47.fromObject({
                type: match[1],
                components: this.components
            }),
            baseType: "array"
        });
        else $2cb0f13975c97159$var$populate(this, {
            arrayLength: null,
            arrayChildren: null,
            baseType: this.components != null ? "tuple" : this.type
        });
        this._isParamType = true;
        Object.freeze(this);
    }
    // Format the parameter fragment
    //   - sighash: "(uint256,address)"
    //   - minimal: "tuple(uint256,address) indexed"
    //   - full:    "tuple(uint256 foo, address bar) indexed baz"
    format(format) {
        if (!format) format = $2cb0f13975c97159$export$f010f239efc4d445.sighash;
        if (!$2cb0f13975c97159$export$f010f239efc4d445[format]) $2cb0f13975c97159$var$logger.throwArgumentError("invalid format type", "format", format);
        if (format === $2cb0f13975c97159$export$f010f239efc4d445.json) {
            let result = {
                type: this.baseType === "tuple" ? "tuple" : this.type,
                name: this.name || undefined
            };
            if (typeof this.indexed === "boolean") result.indexed = this.indexed;
            if (this.components) result.components = this.components.map((comp)=>JSON.parse(comp.format(format)));
            return JSON.stringify(result);
        }
        let result = "";
        // Array
        if (this.baseType === "array") {
            result += this.arrayChildren.format(format);
            result += "[" + (this.arrayLength < 0 ? "" : String(this.arrayLength)) + "]";
        } else if (this.baseType === "tuple") {
            if (format !== $2cb0f13975c97159$export$f010f239efc4d445.sighash) result += this.type;
            result += "(" + this.components.map((comp)=>comp.format(format)).join(format === $2cb0f13975c97159$export$f010f239efc4d445.full ? ", " : ",") + ")";
        } else result += this.type;
        if (format !== $2cb0f13975c97159$export$f010f239efc4d445.sighash) {
            if (this.indexed === true) result += " indexed";
            if (format === $2cb0f13975c97159$export$f010f239efc4d445.full && this.name) result += " " + this.name;
        }
        return result;
    }
    static from(value, allowIndexed) {
        if (typeof value === "string") return $2cb0f13975c97159$export$426dc07f493a4c47.fromString(value, allowIndexed);
        return $2cb0f13975c97159$export$426dc07f493a4c47.fromObject(value);
    }
    static fromObject(value) {
        if ($2cb0f13975c97159$export$426dc07f493a4c47.isParamType(value)) return value;
        return new $2cb0f13975c97159$export$426dc07f493a4c47($2cb0f13975c97159$var$_constructorGuard, {
            name: value.name || null,
            type: $2cb0f13975c97159$var$verifyType(value.type),
            indexed: value.indexed == null ? null : !!value.indexed,
            components: value.components ? value.components.map($2cb0f13975c97159$export$426dc07f493a4c47.fromObject) : null
        });
    }
    static fromString(value, allowIndexed) {
        function ParamTypify(node) {
            return $2cb0f13975c97159$export$426dc07f493a4c47.fromObject({
                name: node.name,
                type: node.type,
                indexed: node.indexed,
                components: node.components
            });
        }
        return ParamTypify($2cb0f13975c97159$var$parseParamType(value, !!allowIndexed));
    }
    static isParamType(value) {
        return !!(value != null && value._isParamType);
    }
}
function $2cb0f13975c97159$var$parseParams(value, allowIndex) {
    return $2cb0f13975c97159$var$splitNesting(value).map((param)=>$2cb0f13975c97159$export$426dc07f493a4c47.fromString(param, allowIndex));
}
class $2cb0f13975c97159$export$ffb0004e005737fa {
    constructor(constructorGuard, params){
        if (constructorGuard !== $2cb0f13975c97159$var$_constructorGuard) $2cb0f13975c97159$var$logger.throwError("use a static from method", (0, $5f596c9584f643ae$export$efa9a398d6368992).errors.UNSUPPORTED_OPERATION, {
            operation: "new Fragment()"
        });
        $2cb0f13975c97159$var$populate(this, params);
        this._isFragment = true;
        Object.freeze(this);
    }
    static from(value) {
        if ($2cb0f13975c97159$export$ffb0004e005737fa.isFragment(value)) return value;
        if (typeof value === "string") return $2cb0f13975c97159$export$ffb0004e005737fa.fromString(value);
        return $2cb0f13975c97159$export$ffb0004e005737fa.fromObject(value);
    }
    static fromObject(value) {
        if ($2cb0f13975c97159$export$ffb0004e005737fa.isFragment(value)) return value;
        switch(value.type){
            case "function":
                return $2cb0f13975c97159$export$8d576c928b93668f.fromObject(value);
            case "event":
                return $2cb0f13975c97159$export$958548f08bac2833.fromObject(value);
            case "constructor":
                return $2cb0f13975c97159$export$3ac5c9504f801ea4.fromObject(value);
            case "error":
                return $2cb0f13975c97159$export$2c42c6d543aa9b59.fromObject(value);
            case "fallback":
            case "receive":
                // @TODO: Something? Maybe return a FunctionFragment? A custom DefaultFunctionFragment?
                return null;
        }
        return $2cb0f13975c97159$var$logger.throwArgumentError("invalid fragment object", "value", value);
    }
    static fromString(value) {
        // Make sure the "returns" is surrounded by a space and all whitespace is exactly one space
        value = value.replace(/\s/g, " ");
        value = value.replace(/\(/g, " (").replace(/\)/g, ") ").replace(/\s+/g, " ");
        value = value.trim();
        if (value.split(" ")[0] === "event") return $2cb0f13975c97159$export$958548f08bac2833.fromString(value.substring(5).trim());
        else if (value.split(" ")[0] === "function") return $2cb0f13975c97159$export$8d576c928b93668f.fromString(value.substring(8).trim());
        else if (value.split("(")[0].trim() === "constructor") return $2cb0f13975c97159$export$3ac5c9504f801ea4.fromString(value.trim());
        else if (value.split(" ")[0] === "error") return $2cb0f13975c97159$export$2c42c6d543aa9b59.fromString(value.substring(5).trim());
        return $2cb0f13975c97159$var$logger.throwArgumentError("unsupported fragment", "value", value);
    }
    static isFragment(value) {
        return !!(value && value._isFragment);
    }
}
class $2cb0f13975c97159$export$958548f08bac2833 extends $2cb0f13975c97159$export$ffb0004e005737fa {
    format(format) {
        if (!format) format = $2cb0f13975c97159$export$f010f239efc4d445.sighash;
        if (!$2cb0f13975c97159$export$f010f239efc4d445[format]) $2cb0f13975c97159$var$logger.throwArgumentError("invalid format type", "format", format);
        if (format === $2cb0f13975c97159$export$f010f239efc4d445.json) return JSON.stringify({
            type: "event",
            anonymous: this.anonymous,
            name: this.name,
            inputs: this.inputs.map((input)=>JSON.parse(input.format(format)))
        });
        let result = "";
        if (format !== $2cb0f13975c97159$export$f010f239efc4d445.sighash) result += "event ";
        result += this.name + "(" + this.inputs.map((input)=>input.format(format)).join(format === $2cb0f13975c97159$export$f010f239efc4d445.full ? ", " : ",") + ") ";
        if (format !== $2cb0f13975c97159$export$f010f239efc4d445.sighash) {
            if (this.anonymous) result += "anonymous ";
        }
        return result.trim();
    }
    static from(value) {
        if (typeof value === "string") return $2cb0f13975c97159$export$958548f08bac2833.fromString(value);
        return $2cb0f13975c97159$export$958548f08bac2833.fromObject(value);
    }
    static fromObject(value) {
        if ($2cb0f13975c97159$export$958548f08bac2833.isEventFragment(value)) return value;
        if (value.type !== "event") $2cb0f13975c97159$var$logger.throwArgumentError("invalid event object", "value", value);
        const params = {
            name: $2cb0f13975c97159$var$verifyIdentifier(value.name),
            anonymous: value.anonymous,
            inputs: value.inputs ? value.inputs.map($2cb0f13975c97159$export$426dc07f493a4c47.fromObject) : [],
            type: "event"
        };
        return new $2cb0f13975c97159$export$958548f08bac2833($2cb0f13975c97159$var$_constructorGuard, params);
    }
    static fromString(value) {
        let match = value.match($2cb0f13975c97159$var$regexParen);
        if (!match) $2cb0f13975c97159$var$logger.throwArgumentError("invalid event string", "value", value);
        let anonymous = false;
        match[3].split(" ").forEach((modifier)=>{
            switch(modifier.trim()){
                case "anonymous":
                    anonymous = true;
                    break;
                case "":
                    break;
                default:
                    $2cb0f13975c97159$var$logger.warn("unknown modifier: " + modifier);
            }
        });
        return $2cb0f13975c97159$export$958548f08bac2833.fromObject({
            name: match[1].trim(),
            anonymous: anonymous,
            inputs: $2cb0f13975c97159$var$parseParams(match[2], true),
            type: "event"
        });
    }
    static isEventFragment(value) {
        return value && value._isFragment && value.type === "event";
    }
}
function $2cb0f13975c97159$var$parseGas(value, params) {
    params.gas = null;
    let comps = value.split("@");
    if (comps.length !== 1) {
        if (comps.length > 2) $2cb0f13975c97159$var$logger.throwArgumentError("invalid human-readable ABI signature", "value", value);
        if (!comps[1].match(/^[0-9]+$/)) $2cb0f13975c97159$var$logger.throwArgumentError("invalid human-readable ABI signature gas", "value", value);
        params.gas = (0, $a87aa97415e1b917$export$d97aa349ed20696).from(comps[1]);
        return comps[0];
    }
    return value;
}
function $2cb0f13975c97159$var$parseModifiers(value, params) {
    params.constant = false;
    params.payable = false;
    params.stateMutability = "nonpayable";
    value.split(" ").forEach((modifier)=>{
        switch(modifier.trim()){
            case "constant":
                params.constant = true;
                break;
            case "payable":
                params.payable = true;
                params.stateMutability = "payable";
                break;
            case "nonpayable":
                params.payable = false;
                params.stateMutability = "nonpayable";
                break;
            case "pure":
                params.constant = true;
                params.stateMutability = "pure";
                break;
            case "view":
                params.constant = true;
                params.stateMutability = "view";
                break;
            case "external":
            case "public":
            case "":
                break;
            default:
                console.log("unknown modifier: " + modifier);
        }
    });
}
function $2cb0f13975c97159$var$verifyState(value) {
    let result = {
        constant: false,
        payable: true,
        stateMutability: "payable"
    };
    if (value.stateMutability != null) {
        result.stateMutability = value.stateMutability;
        // Set (and check things are consistent) the constant property
        result.constant = result.stateMutability === "view" || result.stateMutability === "pure";
        if (value.constant != null) {
            if (!!value.constant !== result.constant) $2cb0f13975c97159$var$logger.throwArgumentError("cannot have constant function with mutability " + result.stateMutability, "value", value);
        }
        // Set (and check things are consistent) the payable property
        result.payable = result.stateMutability === "payable";
        if (value.payable != null) {
            if (!!value.payable !== result.payable) $2cb0f13975c97159$var$logger.throwArgumentError("cannot have payable function with mutability " + result.stateMutability, "value", value);
        }
    } else if (value.payable != null) {
        result.payable = !!value.payable;
        // If payable we can assume non-constant; otherwise we can't assume
        if (value.constant == null && !result.payable && value.type !== "constructor") $2cb0f13975c97159$var$logger.throwArgumentError("unable to determine stateMutability", "value", value);
        result.constant = !!value.constant;
        if (result.constant) result.stateMutability = "view";
        else result.stateMutability = result.payable ? "payable" : "nonpayable";
        if (result.payable && result.constant) $2cb0f13975c97159$var$logger.throwArgumentError("cannot have constant payable function", "value", value);
    } else if (value.constant != null) {
        result.constant = !!value.constant;
        result.payable = !result.constant;
        result.stateMutability = result.constant ? "view" : "payable";
    } else if (value.type !== "constructor") $2cb0f13975c97159$var$logger.throwArgumentError("unable to determine stateMutability", "value", value);
    return result;
}
class $2cb0f13975c97159$export$3ac5c9504f801ea4 extends $2cb0f13975c97159$export$ffb0004e005737fa {
    format(format) {
        if (!format) format = $2cb0f13975c97159$export$f010f239efc4d445.sighash;
        if (!$2cb0f13975c97159$export$f010f239efc4d445[format]) $2cb0f13975c97159$var$logger.throwArgumentError("invalid format type", "format", format);
        if (format === $2cb0f13975c97159$export$f010f239efc4d445.json) return JSON.stringify({
            type: "constructor",
            stateMutability: this.stateMutability !== "nonpayable" ? this.stateMutability : undefined,
            payable: this.payable,
            gas: this.gas ? this.gas.toNumber() : undefined,
            inputs: this.inputs.map((input)=>JSON.parse(input.format(format)))
        });
        if (format === $2cb0f13975c97159$export$f010f239efc4d445.sighash) $2cb0f13975c97159$var$logger.throwError("cannot format a constructor for sighash", (0, $5f596c9584f643ae$export$efa9a398d6368992).errors.UNSUPPORTED_OPERATION, {
            operation: "format(sighash)"
        });
        let result = "constructor(" + this.inputs.map((input)=>input.format(format)).join(format === $2cb0f13975c97159$export$f010f239efc4d445.full ? ", " : ",") + ") ";
        if (this.stateMutability && this.stateMutability !== "nonpayable") result += this.stateMutability + " ";
        return result.trim();
    }
    static from(value) {
        if (typeof value === "string") return $2cb0f13975c97159$export$3ac5c9504f801ea4.fromString(value);
        return $2cb0f13975c97159$export$3ac5c9504f801ea4.fromObject(value);
    }
    static fromObject(value) {
        if ($2cb0f13975c97159$export$3ac5c9504f801ea4.isConstructorFragment(value)) return value;
        if (value.type !== "constructor") $2cb0f13975c97159$var$logger.throwArgumentError("invalid constructor object", "value", value);
        let state = $2cb0f13975c97159$var$verifyState(value);
        if (state.constant) $2cb0f13975c97159$var$logger.throwArgumentError("constructor cannot be constant", "value", value);
        const params = {
            name: null,
            type: value.type,
            inputs: value.inputs ? value.inputs.map($2cb0f13975c97159$export$426dc07f493a4c47.fromObject) : [],
            payable: state.payable,
            stateMutability: state.stateMutability,
            gas: value.gas ? (0, $a87aa97415e1b917$export$d97aa349ed20696).from(value.gas) : null
        };
        return new $2cb0f13975c97159$export$3ac5c9504f801ea4($2cb0f13975c97159$var$_constructorGuard, params);
    }
    static fromString(value) {
        let params = {
            type: "constructor"
        };
        value = $2cb0f13975c97159$var$parseGas(value, params);
        let parens = value.match($2cb0f13975c97159$var$regexParen);
        if (!parens || parens[1].trim() !== "constructor") $2cb0f13975c97159$var$logger.throwArgumentError("invalid constructor string", "value", value);
        params.inputs = $2cb0f13975c97159$var$parseParams(parens[2].trim(), false);
        $2cb0f13975c97159$var$parseModifiers(parens[3].trim(), params);
        return $2cb0f13975c97159$export$3ac5c9504f801ea4.fromObject(params);
    }
    static isConstructorFragment(value) {
        return value && value._isFragment && value.type === "constructor";
    }
}
class $2cb0f13975c97159$export$8d576c928b93668f extends $2cb0f13975c97159$export$3ac5c9504f801ea4 {
    format(format) {
        if (!format) format = $2cb0f13975c97159$export$f010f239efc4d445.sighash;
        if (!$2cb0f13975c97159$export$f010f239efc4d445[format]) $2cb0f13975c97159$var$logger.throwArgumentError("invalid format type", "format", format);
        if (format === $2cb0f13975c97159$export$f010f239efc4d445.json) return JSON.stringify({
            type: "function",
            name: this.name,
            constant: this.constant,
            stateMutability: this.stateMutability !== "nonpayable" ? this.stateMutability : undefined,
            payable: this.payable,
            gas: this.gas ? this.gas.toNumber() : undefined,
            inputs: this.inputs.map((input)=>JSON.parse(input.format(format))),
            outputs: this.outputs.map((output)=>JSON.parse(output.format(format)))
        });
        let result = "";
        if (format !== $2cb0f13975c97159$export$f010f239efc4d445.sighash) result += "function ";
        result += this.name + "(" + this.inputs.map((input)=>input.format(format)).join(format === $2cb0f13975c97159$export$f010f239efc4d445.full ? ", " : ",") + ") ";
        if (format !== $2cb0f13975c97159$export$f010f239efc4d445.sighash) {
            if (this.stateMutability) {
                if (this.stateMutability !== "nonpayable") result += this.stateMutability + " ";
            } else if (this.constant) result += "view ";
            if (this.outputs && this.outputs.length) result += "returns (" + this.outputs.map((output)=>output.format(format)).join(", ") + ") ";
            if (this.gas != null) result += "@" + this.gas.toString() + " ";
        }
        return result.trim();
    }
    static from(value) {
        if (typeof value === "string") return $2cb0f13975c97159$export$8d576c928b93668f.fromString(value);
        return $2cb0f13975c97159$export$8d576c928b93668f.fromObject(value);
    }
    static fromObject(value) {
        if ($2cb0f13975c97159$export$8d576c928b93668f.isFunctionFragment(value)) return value;
        if (value.type !== "function") $2cb0f13975c97159$var$logger.throwArgumentError("invalid function object", "value", value);
        let state = $2cb0f13975c97159$var$verifyState(value);
        const params = {
            type: value.type,
            name: $2cb0f13975c97159$var$verifyIdentifier(value.name),
            constant: state.constant,
            inputs: value.inputs ? value.inputs.map($2cb0f13975c97159$export$426dc07f493a4c47.fromObject) : [],
            outputs: value.outputs ? value.outputs.map($2cb0f13975c97159$export$426dc07f493a4c47.fromObject) : [],
            payable: state.payable,
            stateMutability: state.stateMutability,
            gas: value.gas ? (0, $a87aa97415e1b917$export$d97aa349ed20696).from(value.gas) : null
        };
        return new $2cb0f13975c97159$export$8d576c928b93668f($2cb0f13975c97159$var$_constructorGuard, params);
    }
    static fromString(value) {
        let params = {
            type: "function"
        };
        value = $2cb0f13975c97159$var$parseGas(value, params);
        let comps = value.split(" returns ");
        if (comps.length > 2) $2cb0f13975c97159$var$logger.throwArgumentError("invalid function string", "value", value);
        let parens = comps[0].match($2cb0f13975c97159$var$regexParen);
        if (!parens) $2cb0f13975c97159$var$logger.throwArgumentError("invalid function signature", "value", value);
        params.name = parens[1].trim();
        if (params.name) $2cb0f13975c97159$var$verifyIdentifier(params.name);
        params.inputs = $2cb0f13975c97159$var$parseParams(parens[2], false);
        $2cb0f13975c97159$var$parseModifiers(parens[3].trim(), params);
        // We have outputs
        if (comps.length > 1) {
            let returns = comps[1].match($2cb0f13975c97159$var$regexParen);
            if (returns[1].trim() != "" || returns[3].trim() != "") $2cb0f13975c97159$var$logger.throwArgumentError("unexpected tokens", "value", value);
            params.outputs = $2cb0f13975c97159$var$parseParams(returns[2], false);
        } else params.outputs = [];
        return $2cb0f13975c97159$export$8d576c928b93668f.fromObject(params);
    }
    static isFunctionFragment(value) {
        return value && value._isFragment && value.type === "function";
    }
}
//export class StructFragment extends Fragment {
//}
function $2cb0f13975c97159$var$checkForbidden(fragment) {
    const sig = fragment.format();
    if (sig === "Error(string)" || sig === "Panic(uint256)") $2cb0f13975c97159$var$logger.throwArgumentError(`cannot specify user defined ${sig} error`, "fragment", fragment);
    return fragment;
}
class $2cb0f13975c97159$export$2c42c6d543aa9b59 extends $2cb0f13975c97159$export$ffb0004e005737fa {
    format(format) {
        if (!format) format = $2cb0f13975c97159$export$f010f239efc4d445.sighash;
        if (!$2cb0f13975c97159$export$f010f239efc4d445[format]) $2cb0f13975c97159$var$logger.throwArgumentError("invalid format type", "format", format);
        if (format === $2cb0f13975c97159$export$f010f239efc4d445.json) return JSON.stringify({
            type: "error",
            name: this.name,
            inputs: this.inputs.map((input)=>JSON.parse(input.format(format)))
        });
        let result = "";
        if (format !== $2cb0f13975c97159$export$f010f239efc4d445.sighash) result += "error ";
        result += this.name + "(" + this.inputs.map((input)=>input.format(format)).join(format === $2cb0f13975c97159$export$f010f239efc4d445.full ? ", " : ",") + ") ";
        return result.trim();
    }
    static from(value) {
        if (typeof value === "string") return $2cb0f13975c97159$export$2c42c6d543aa9b59.fromString(value);
        return $2cb0f13975c97159$export$2c42c6d543aa9b59.fromObject(value);
    }
    static fromObject(value) {
        if ($2cb0f13975c97159$export$2c42c6d543aa9b59.isErrorFragment(value)) return value;
        if (value.type !== "error") $2cb0f13975c97159$var$logger.throwArgumentError("invalid error object", "value", value);
        const params = {
            type: value.type,
            name: $2cb0f13975c97159$var$verifyIdentifier(value.name),
            inputs: value.inputs ? value.inputs.map($2cb0f13975c97159$export$426dc07f493a4c47.fromObject) : []
        };
        return $2cb0f13975c97159$var$checkForbidden(new $2cb0f13975c97159$export$2c42c6d543aa9b59($2cb0f13975c97159$var$_constructorGuard, params));
    }
    static fromString(value) {
        let params = {
            type: "error"
        };
        let parens = value.match($2cb0f13975c97159$var$regexParen);
        if (!parens) $2cb0f13975c97159$var$logger.throwArgumentError("invalid error signature", "value", value);
        params.name = parens[1].trim();
        if (params.name) $2cb0f13975c97159$var$verifyIdentifier(params.name);
        params.inputs = $2cb0f13975c97159$var$parseParams(parens[2], false);
        return $2cb0f13975c97159$var$checkForbidden($2cb0f13975c97159$export$2c42c6d543aa9b59.fromObject(params));
    }
    static isErrorFragment(value) {
        return value && value._isFragment && value.type === "error";
    }
}
function $2cb0f13975c97159$var$verifyType(type) {
    // These need to be transformed to their full description
    if (type.match(/^uint($|[^1-9])/)) type = "uint256" + type.substring(4);
    else if (type.match(/^int($|[^1-9])/)) type = "int256" + type.substring(3);
    // @TODO: more verification
    return type;
}
// See: https://github.com/ethereum/solidity/blob/1f8f1a3db93a548d0555e3e14cfc55a10e25b60e/docs/grammar/SolidityLexer.g4#L234
const $2cb0f13975c97159$var$regexIdentifier = new RegExp("^[a-zA-Z$_][a-zA-Z0-9$_]*$");
function $2cb0f13975c97159$var$verifyIdentifier(value) {
    if (!value || !value.match($2cb0f13975c97159$var$regexIdentifier)) $2cb0f13975c97159$var$logger.throwArgumentError(`invalid identifier "${value}"`, "value", value);
    return value;
}
const $2cb0f13975c97159$var$regexParen = new RegExp("^([^)(]*)\\((.*)\\)([^)(]*)$");
function $2cb0f13975c97159$var$splitNesting(value) {
    value = value.trim();
    let result = [];
    let accum = "";
    let depth = 0;
    for(let offset = 0; offset < value.length; offset++){
        let c = value[offset];
        if (c === "," && depth === 0) {
            result.push(accum);
            accum = "";
        } else {
            accum += c;
            if (c === "(") depth++;
            else if (c === ")") {
                depth--;
                if (depth === -1) $2cb0f13975c97159$var$logger.throwArgumentError("unbalanced parenthesis", "value", value);
            }
        }
    }
    if (accum) result.push(accum);
    return result;
}


"use strict";
const $420d974aae91c4e0$var$logger = new (0, $5f596c9584f643ae$export$efa9a398d6368992)((0, $6cb368dce1713386$export$83d89fbfd8236492));
const $420d974aae91c4e0$var$paramTypeBytes = new RegExp(/^bytes([0-9]*)$/);
const $420d974aae91c4e0$var$paramTypeNumber = new RegExp(/^(u?int)([0-9]*)$/);
class $420d974aae91c4e0$export$fe041e1a83d3efc6 {
    constructor(coerceFunc){
        (0, $d2d9b472f7878d5e$exports.defineReadOnly)(this, "coerceFunc", coerceFunc || null);
    }
    _getCoder(param) {
        switch(param.baseType){
            case "address":
                return new (0, $fe65aa8688b9b674$export$59dbbded7775bfe7)(param.name);
            case "bool":
                return new (0, $079c5b06dccd461b$export$fe9118d6c093150c)(param.name);
            case "string":
                return new (0, $e1c57c3faeb06af6$export$2d1b854518731426)(param.name);
            case "bytes":
                return new (0, $fadb8dbc86f3f525$export$e5823e9574df18d2)(param.name);
            case "array":
                return new (0, $8dbf16ede3c8aea2$export$88bc419d2df11f54)(this._getCoder(param.arrayChildren), param.arrayLength, param.name);
            case "tuple":
                return new (0, $6ceedefd2eee321a$export$e9fceba8f110fea6)((param.components || []).map((component)=>{
                    return this._getCoder(component);
                }), param.name);
            case "":
                return new (0, $30b1de167c06c587$export$70982cadf2d6b4ec)(param.name);
        }
        // u?int[0-9]*
        let match = param.type.match($420d974aae91c4e0$var$paramTypeNumber);
        if (match) {
            let size = parseInt(match[2] || "256");
            if (size === 0 || size > 256 || size % 8 !== 0) $420d974aae91c4e0$var$logger.throwArgumentError("invalid " + match[1] + " bit length", "param", param);
            return new (0, $fdf30bf73ed9cc94$export$b934dc8cfe13938c)(size / 8, match[1] === "int", param.name);
        }
        // bytes[0-9]+
        match = param.type.match($420d974aae91c4e0$var$paramTypeBytes);
        if (match) {
            let size = parseInt(match[1]);
            if (size === 0 || size > 32) $420d974aae91c4e0$var$logger.throwArgumentError("invalid bytes length", "param", param);
            return new (0, $e392fc8f65f4ab4d$export$7dec9db68e6bcf5a)(size, param.name);
        }
        return $420d974aae91c4e0$var$logger.throwArgumentError("invalid type", "type", param.type);
    }
    _getWordSize() {
        return 32;
    }
    _getReader(data, allowLoose) {
        return new (0, $3c454193c1d90bf8$export$2f7a2f0e90c07dc4)(data, this._getWordSize(), this.coerceFunc, allowLoose);
    }
    _getWriter() {
        return new (0, $3c454193c1d90bf8$export$d7a960146e1a269e)(this._getWordSize());
    }
    getDefaultValue(types) {
        const coders = types.map((type)=>this._getCoder((0, $2cb0f13975c97159$export$426dc07f493a4c47).from(type)));
        const coder = new (0, $6ceedefd2eee321a$export$e9fceba8f110fea6)(coders, "_");
        return coder.defaultValue();
    }
    encode(types, values) {
        if (types.length !== values.length) $420d974aae91c4e0$var$logger.throwError("types/values length mismatch", (0, $5f596c9584f643ae$export$efa9a398d6368992).errors.INVALID_ARGUMENT, {
            count: {
                types: types.length,
                values: values.length
            },
            value: {
                types: types,
                values: values
            }
        });
        const coders = types.map((type)=>this._getCoder((0, $2cb0f13975c97159$export$426dc07f493a4c47).from(type)));
        const coder = new (0, $6ceedefd2eee321a$export$e9fceba8f110fea6)(coders, "_");
        const writer = this._getWriter();
        coder.encode(writer, values);
        return writer.data;
    }
    decode(types, data, loose) {
        const coders = types.map((type)=>this._getCoder((0, $2cb0f13975c97159$export$426dc07f493a4c47).from(type)));
        const coder = new (0, $6ceedefd2eee321a$export$e9fceba8f110fea6)(coders, "_");
        return coder.decode(this._getReader((0, $06d75ae17ce69367$export$3131421a7d01b4fb)(data), loose));
    }
}
const $420d974aae91c4e0$export$51d1cfcdb913adff = new $420d974aae91c4e0$export$fe041e1a83d3efc6();






"use strict";
const $c799c8c071055c8d$var$logger = new (0, $5f596c9584f643ae$export$efa9a398d6368992)((0, $6cb368dce1713386$export$83d89fbfd8236492));
class $c799c8c071055c8d$export$c2ab6499be98b3c5 extends (0, $d2d9b472f7878d5e$exports.Description) {
}
class $c799c8c071055c8d$export$7a3223b0fadb690b extends (0, $d2d9b472f7878d5e$exports.Description) {
}
class $c799c8c071055c8d$export$cfba08fc0e40e2ab extends (0, $d2d9b472f7878d5e$exports.Description) {
}
class $c799c8c071055c8d$export$8ef99100a3c56f8c extends (0, $d2d9b472f7878d5e$exports.Description) {
    static isIndexed(value) {
        return !!(value && value._isIndexed);
    }
}
const $c799c8c071055c8d$var$BuiltinErrors = {
    "0x08c379a0": {
        signature: "Error(string)",
        name: "Error",
        inputs: [
            "string"
        ],
        reason: true
    },
    "0x4e487b71": {
        signature: "Panic(uint256)",
        name: "Panic",
        inputs: [
            "uint256"
        ]
    }
};
function $c799c8c071055c8d$var$wrapAccessError(property, error) {
    const wrap = new Error(`deferred error during ABI decoding triggered accessing ${property}`);
    wrap.error = error;
    return wrap;
}
class $c799c8c071055c8d$export$48cefb51a4e315b2 {
    constructor(fragments){
        let abi = [];
        if (typeof fragments === "string") abi = JSON.parse(fragments);
        else abi = fragments;
        (0, $d2d9b472f7878d5e$exports.defineReadOnly)(this, "fragments", abi.map((fragment)=>{
            return (0, $2cb0f13975c97159$export$ffb0004e005737fa).from(fragment);
        }).filter((fragment)=>fragment != null));
        (0, $d2d9b472f7878d5e$exports.defineReadOnly)(this, "_abiCoder", (0, $d2d9b472f7878d5e$exports.getStatic)(new.target, "getAbiCoder")());
        (0, $d2d9b472f7878d5e$exports.defineReadOnly)(this, "functions", {});
        (0, $d2d9b472f7878d5e$exports.defineReadOnly)(this, "errors", {});
        (0, $d2d9b472f7878d5e$exports.defineReadOnly)(this, "events", {});
        (0, $d2d9b472f7878d5e$exports.defineReadOnly)(this, "structs", {});
        // Add all fragments by their signature
        this.fragments.forEach((fragment)=>{
            let bucket = null;
            switch(fragment.type){
                case "constructor":
                    if (this.deploy) {
                        $c799c8c071055c8d$var$logger.warn("duplicate definition - constructor");
                        return;
                    }
                    //checkNames(fragment, "input", fragment.inputs);
                    (0, $d2d9b472f7878d5e$exports.defineReadOnly)(this, "deploy", fragment);
                    return;
                case "function":
                    //checkNames(fragment, "input", fragment.inputs);
                    //checkNames(fragment, "output", (<FunctionFragment>fragment).outputs);
                    bucket = this.functions;
                    break;
                case "event":
                    //checkNames(fragment, "input", fragment.inputs);
                    bucket = this.events;
                    break;
                case "error":
                    bucket = this.errors;
                    break;
                default:
                    return;
            }
            let signature = fragment.format();
            if (bucket[signature]) {
                $c799c8c071055c8d$var$logger.warn("duplicate definition - " + signature);
                return;
            }
            bucket[signature] = fragment;
        });
        // If we do not have a constructor add a default
        if (!this.deploy) (0, $d2d9b472f7878d5e$exports.defineReadOnly)(this, "deploy", (0, $2cb0f13975c97159$export$3ac5c9504f801ea4).from({
            payable: false,
            type: "constructor"
        }));
        (0, $d2d9b472f7878d5e$exports.defineReadOnly)(this, "_isInterface", true);
    }
    format(format) {
        if (!format) format = (0, $2cb0f13975c97159$export$f010f239efc4d445).full;
        if (format === (0, $2cb0f13975c97159$export$f010f239efc4d445).sighash) $c799c8c071055c8d$var$logger.throwArgumentError("interface does not support formatting sighash", "format", format);
        const abi = this.fragments.map((fragment)=>fragment.format(format));
        // We need to re-bundle the JSON fragments a bit
        if (format === (0, $2cb0f13975c97159$export$f010f239efc4d445).json) return JSON.stringify(abi.map((j)=>JSON.parse(j)));
        return abi;
    }
    // Sub-classes can override these to handle other blockchains
    static getAbiCoder() {
        return 0, $420d974aae91c4e0$export$51d1cfcdb913adff;
    }
    static getAddress(address) {
        return (0, $5652f239bab101de$export$88411125f012957a)(address);
    }
    static getSighash(fragment) {
        return (0, $06d75ae17ce69367$export$15da666eba198c18)((0, $143d6d71aa960133$export$d560c7e4a29451c2)(fragment.format()), 0, 4);
    }
    static getEventTopic(eventFragment) {
        return (0, $143d6d71aa960133$export$d560c7e4a29451c2)(eventFragment.format());
    }
    // Find a function definition by any means necessary (unless it is ambiguous)
    getFunction(nameOrSignatureOrSighash) {
        if ((0, $06d75ae17ce69367$export$b02a40aff8e4ad18)(nameOrSignatureOrSighash)) {
            for(const name in this.functions){
                if (nameOrSignatureOrSighash === this.getSighash(name)) return this.functions[name];
            }
            $c799c8c071055c8d$var$logger.throwArgumentError("no matching function", "sighash", nameOrSignatureOrSighash);
        }
        // It is a bare name, look up the function (will return null if ambiguous)
        if (nameOrSignatureOrSighash.indexOf("(") === -1) {
            const name = nameOrSignatureOrSighash.trim();
            const matching = Object.keys(this.functions).filter((f)=>f.split("(" /* fix:) */ )[0] === name);
            if (matching.length === 0) $c799c8c071055c8d$var$logger.throwArgumentError("no matching function", "name", name);
            else if (matching.length > 1) $c799c8c071055c8d$var$logger.throwArgumentError("multiple matching functions", "name", name);
            return this.functions[matching[0]];
        }
        // Normalize the signature and lookup the function
        const result = this.functions[(0, $2cb0f13975c97159$export$8d576c928b93668f).fromString(nameOrSignatureOrSighash).format()];
        if (!result) $c799c8c071055c8d$var$logger.throwArgumentError("no matching function", "signature", nameOrSignatureOrSighash);
        return result;
    }
    // Find an event definition by any means necessary (unless it is ambiguous)
    getEvent(nameOrSignatureOrTopic) {
        if ((0, $06d75ae17ce69367$export$b02a40aff8e4ad18)(nameOrSignatureOrTopic)) {
            const topichash = nameOrSignatureOrTopic.toLowerCase();
            for(const name in this.events){
                if (topichash === this.getEventTopic(name)) return this.events[name];
            }
            $c799c8c071055c8d$var$logger.throwArgumentError("no matching event", "topichash", topichash);
        }
        // It is a bare name, look up the function (will return null if ambiguous)
        if (nameOrSignatureOrTopic.indexOf("(") === -1) {
            const name = nameOrSignatureOrTopic.trim();
            const matching = Object.keys(this.events).filter((f)=>f.split("(" /* fix:) */ )[0] === name);
            if (matching.length === 0) $c799c8c071055c8d$var$logger.throwArgumentError("no matching event", "name", name);
            else if (matching.length > 1) $c799c8c071055c8d$var$logger.throwArgumentError("multiple matching events", "name", name);
            return this.events[matching[0]];
        }
        // Normalize the signature and lookup the function
        const result = this.events[(0, $2cb0f13975c97159$export$958548f08bac2833).fromString(nameOrSignatureOrTopic).format()];
        if (!result) $c799c8c071055c8d$var$logger.throwArgumentError("no matching event", "signature", nameOrSignatureOrTopic);
        return result;
    }
    // Find a function definition by any means necessary (unless it is ambiguous)
    getError(nameOrSignatureOrSighash) {
        if ((0, $06d75ae17ce69367$export$b02a40aff8e4ad18)(nameOrSignatureOrSighash)) {
            const getSighash = (0, $d2d9b472f7878d5e$exports.getStatic)(this.constructor, "getSighash");
            for(const name in this.errors){
                const error = this.errors[name];
                if (nameOrSignatureOrSighash === getSighash(error)) return this.errors[name];
            }
            $c799c8c071055c8d$var$logger.throwArgumentError("no matching error", "sighash", nameOrSignatureOrSighash);
        }
        // It is a bare name, look up the function (will return null if ambiguous)
        if (nameOrSignatureOrSighash.indexOf("(") === -1) {
            const name = nameOrSignatureOrSighash.trim();
            const matching = Object.keys(this.errors).filter((f)=>f.split("(" /* fix:) */ )[0] === name);
            if (matching.length === 0) $c799c8c071055c8d$var$logger.throwArgumentError("no matching error", "name", name);
            else if (matching.length > 1) $c799c8c071055c8d$var$logger.throwArgumentError("multiple matching errors", "name", name);
            return this.errors[matching[0]];
        }
        // Normalize the signature and lookup the function
        const result = this.errors[(0, $2cb0f13975c97159$export$8d576c928b93668f).fromString(nameOrSignatureOrSighash).format()];
        if (!result) $c799c8c071055c8d$var$logger.throwArgumentError("no matching error", "signature", nameOrSignatureOrSighash);
        return result;
    }
    // Get the sighash (the bytes4 selector) used by Solidity to identify a function
    getSighash(fragment) {
        if (typeof fragment === "string") try {
            fragment = this.getFunction(fragment);
        } catch (error) {
            try {
                fragment = this.getError(fragment);
            } catch (_) {
                throw error;
            }
        }
        return (0, $d2d9b472f7878d5e$exports.getStatic)(this.constructor, "getSighash")(fragment);
    }
    // Get the topic (the bytes32 hash) used by Solidity to identify an event
    getEventTopic(eventFragment) {
        if (typeof eventFragment === "string") eventFragment = this.getEvent(eventFragment);
        return (0, $d2d9b472f7878d5e$exports.getStatic)(this.constructor, "getEventTopic")(eventFragment);
    }
    _decodeParams(params, data) {
        return this._abiCoder.decode(params, data);
    }
    _encodeParams(params, values) {
        return this._abiCoder.encode(params, values);
    }
    encodeDeploy(values) {
        return this._encodeParams(this.deploy.inputs, values || []);
    }
    decodeErrorResult(fragment, data) {
        if (typeof fragment === "string") fragment = this.getError(fragment);
        const bytes = (0, $06d75ae17ce69367$export$3131421a7d01b4fb)(data);
        if ((0, $06d75ae17ce69367$export$2b0d6b5fbe698c70)(bytes.slice(0, 4)) !== this.getSighash(fragment)) $c799c8c071055c8d$var$logger.throwArgumentError(`data signature does not match error ${fragment.name}.`, "data", (0, $06d75ae17ce69367$export$2b0d6b5fbe698c70)(bytes));
        return this._decodeParams(fragment.inputs, bytes.slice(4));
    }
    encodeErrorResult(fragment, values) {
        if (typeof fragment === "string") fragment = this.getError(fragment);
        return (0, $06d75ae17ce69367$export$2b0d6b5fbe698c70)((0, $06d75ae17ce69367$export$ee1b3e54f0441b22)([
            this.getSighash(fragment),
            this._encodeParams(fragment.inputs, values || [])
        ]));
    }
    // Decode the data for a function call (e.g. tx.data)
    decodeFunctionData(functionFragment, data) {
        if (typeof functionFragment === "string") functionFragment = this.getFunction(functionFragment);
        const bytes = (0, $06d75ae17ce69367$export$3131421a7d01b4fb)(data);
        if ((0, $06d75ae17ce69367$export$2b0d6b5fbe698c70)(bytes.slice(0, 4)) !== this.getSighash(functionFragment)) $c799c8c071055c8d$var$logger.throwArgumentError(`data signature does not match function ${functionFragment.name}.`, "data", (0, $06d75ae17ce69367$export$2b0d6b5fbe698c70)(bytes));
        return this._decodeParams(functionFragment.inputs, bytes.slice(4));
    }
    // Encode the data for a function call (e.g. tx.data)
    encodeFunctionData(functionFragment, values) {
        if (typeof functionFragment === "string") functionFragment = this.getFunction(functionFragment);
        return (0, $06d75ae17ce69367$export$2b0d6b5fbe698c70)((0, $06d75ae17ce69367$export$ee1b3e54f0441b22)([
            this.getSighash(functionFragment),
            this._encodeParams(functionFragment.inputs, values || [])
        ]));
    }
    // Decode the result from a function call (e.g. from eth_call)
    decodeFunctionResult(functionFragment, data) {
        if (typeof functionFragment === "string") functionFragment = this.getFunction(functionFragment);
        let bytes = (0, $06d75ae17ce69367$export$3131421a7d01b4fb)(data);
        let reason = null;
        let message = "";
        let errorArgs = null;
        let errorName = null;
        let errorSignature = null;
        switch(bytes.length % this._abiCoder._getWordSize()){
            case 0:
                try {
                    return this._abiCoder.decode(functionFragment.outputs, bytes);
                } catch (error) {}
                break;
            case 4:
                {
                    const selector = (0, $06d75ae17ce69367$export$2b0d6b5fbe698c70)(bytes.slice(0, 4));
                    const builtin = $c799c8c071055c8d$var$BuiltinErrors[selector];
                    if (builtin) {
                        errorArgs = this._abiCoder.decode(builtin.inputs, bytes.slice(4));
                        errorName = builtin.name;
                        errorSignature = builtin.signature;
                        if (builtin.reason) reason = errorArgs[0];
                        if (errorName === "Error") message = `; VM Exception while processing transaction: reverted with reason string ${JSON.stringify(errorArgs[0])}`;
                        else if (errorName === "Panic") message = `; VM Exception while processing transaction: reverted with panic code ${errorArgs[0]}`;
                    } else try {
                        const error = this.getError(selector);
                        errorArgs = this._abiCoder.decode(error.inputs, bytes.slice(4));
                        errorName = error.name;
                        errorSignature = error.format();
                    } catch (error) {}
                    break;
                }
        }
        return $c799c8c071055c8d$var$logger.throwError("call revert exception" + message, (0, $5f596c9584f643ae$export$efa9a398d6368992).errors.CALL_EXCEPTION, {
            method: functionFragment.format(),
            data: (0, $06d75ae17ce69367$export$2b0d6b5fbe698c70)(data),
            errorArgs: errorArgs,
            errorName: errorName,
            errorSignature: errorSignature,
            reason: reason
        });
    }
    // Encode the result for a function call (e.g. for eth_call)
    encodeFunctionResult(functionFragment, values) {
        if (typeof functionFragment === "string") functionFragment = this.getFunction(functionFragment);
        return (0, $06d75ae17ce69367$export$2b0d6b5fbe698c70)(this._abiCoder.encode(functionFragment.outputs, values || []));
    }
    // Create the filter for the event with search criteria (e.g. for eth_filterLog)
    encodeFilterTopics(eventFragment, values) {
        if (typeof eventFragment === "string") eventFragment = this.getEvent(eventFragment);
        if (values.length > eventFragment.inputs.length) $c799c8c071055c8d$var$logger.throwError("too many arguments for " + eventFragment.format(), (0, $5f596c9584f643ae$export$efa9a398d6368992).errors.UNEXPECTED_ARGUMENT, {
            argument: "values",
            value: values
        });
        let topics = [];
        if (!eventFragment.anonymous) topics.push(this.getEventTopic(eventFragment));
        const encodeTopic = (param, value)=>{
            if (param.type === "string") return (0, $143d6d71aa960133$export$d560c7e4a29451c2)(value);
            else if (param.type === "bytes") return (0, $62e3396d458230e9$export$f8151fce47ad1c35)((0, $06d75ae17ce69367$export$2b0d6b5fbe698c70)(value));
            if (param.type === "bool" && typeof value === "boolean") value = value ? "0x01" : "0x00";
            if (param.type.match(/^u?int/)) value = (0, $a87aa97415e1b917$export$d97aa349ed20696).from(value).toHexString();
            // Check addresses are valid
            if (param.type === "address") this._abiCoder.encode([
                "address"
            ], [
                value
            ]);
            return (0, $06d75ae17ce69367$export$e9c46a54370b47e8)((0, $06d75ae17ce69367$export$2b0d6b5fbe698c70)(value), 32);
        };
        values.forEach((value, index)=>{
            let param = eventFragment.inputs[index];
            if (!param.indexed) {
                if (value != null) $c799c8c071055c8d$var$logger.throwArgumentError("cannot filter non-indexed parameters; must be null", "contract." + param.name, value);
                return;
            }
            if (value == null) topics.push(null);
            else if (param.baseType === "array" || param.baseType === "tuple") $c799c8c071055c8d$var$logger.throwArgumentError("filtering with tuples or arrays not supported", "contract." + param.name, value);
            else if (Array.isArray(value)) topics.push(value.map((value)=>encodeTopic(param, value)));
            else topics.push(encodeTopic(param, value));
        });
        // Trim off trailing nulls
        while(topics.length && topics[topics.length - 1] === null)topics.pop();
        return topics;
    }
    encodeEventLog(eventFragment, values) {
        if (typeof eventFragment === "string") eventFragment = this.getEvent(eventFragment);
        const topics = [];
        const dataTypes = [];
        const dataValues = [];
        if (!eventFragment.anonymous) topics.push(this.getEventTopic(eventFragment));
        if (values.length !== eventFragment.inputs.length) $c799c8c071055c8d$var$logger.throwArgumentError("event arguments/values mismatch", "values", values);
        eventFragment.inputs.forEach((param, index)=>{
            const value = values[index];
            if (param.indexed) {
                if (param.type === "string") topics.push((0, $143d6d71aa960133$export$d560c7e4a29451c2)(value));
                else if (param.type === "bytes") topics.push((0, $62e3396d458230e9$export$f8151fce47ad1c35)(value));
                else if (param.baseType === "tuple" || param.baseType === "array") // @TODO
                throw new Error("not implemented");
                else topics.push(this._abiCoder.encode([
                    param.type
                ], [
                    value
                ]));
            } else {
                dataTypes.push(param);
                dataValues.push(value);
            }
        });
        return {
            data: this._abiCoder.encode(dataTypes, dataValues),
            topics: topics
        };
    }
    // Decode a filter for the event and the search criteria
    decodeEventLog(eventFragment, data, topics) {
        if (typeof eventFragment === "string") eventFragment = this.getEvent(eventFragment);
        if (topics != null && !eventFragment.anonymous) {
            let topicHash = this.getEventTopic(eventFragment);
            if (!(0, $06d75ae17ce69367$export$b02a40aff8e4ad18)(topics[0], 32) || topics[0].toLowerCase() !== topicHash) $c799c8c071055c8d$var$logger.throwError("fragment/topic mismatch", (0, $5f596c9584f643ae$export$efa9a398d6368992).errors.INVALID_ARGUMENT, {
                argument: "topics[0]",
                expected: topicHash,
                value: topics[0]
            });
            topics = topics.slice(1);
        }
        let indexed = [];
        let nonIndexed = [];
        let dynamic = [];
        eventFragment.inputs.forEach((param, index)=>{
            if (param.indexed) {
                if (param.type === "string" || param.type === "bytes" || param.baseType === "tuple" || param.baseType === "array") {
                    indexed.push((0, $2cb0f13975c97159$export$426dc07f493a4c47).fromObject({
                        type: "bytes32",
                        name: param.name
                    }));
                    dynamic.push(true);
                } else {
                    indexed.push(param);
                    dynamic.push(false);
                }
            } else {
                nonIndexed.push(param);
                dynamic.push(false);
            }
        });
        let resultIndexed = topics != null ? this._abiCoder.decode(indexed, (0, $06d75ae17ce69367$export$ee1b3e54f0441b22)(topics)) : null;
        let resultNonIndexed = this._abiCoder.decode(nonIndexed, data, true);
        let result = [];
        let nonIndexedIndex = 0, indexedIndex = 0;
        eventFragment.inputs.forEach((param, index)=>{
            if (param.indexed) {
                if (resultIndexed == null) result[index] = new $c799c8c071055c8d$export$8ef99100a3c56f8c({
                    _isIndexed: true,
                    hash: null
                });
                else if (dynamic[index]) result[index] = new $c799c8c071055c8d$export$8ef99100a3c56f8c({
                    _isIndexed: true,
                    hash: resultIndexed[indexedIndex++]
                });
                else try {
                    result[index] = resultIndexed[indexedIndex++];
                } catch (error) {
                    result[index] = error;
                }
            } else try {
                result[index] = resultNonIndexed[nonIndexedIndex++];
            } catch (error) {
                result[index] = error;
            }
            // Add the keyword argument if named and safe
            if (param.name && result[param.name] == null) {
                const value = result[index];
                // Make error named values throw on access
                if (value instanceof Error) Object.defineProperty(result, param.name, {
                    enumerable: true,
                    get: ()=>{
                        throw $c799c8c071055c8d$var$wrapAccessError(`property ${JSON.stringify(param.name)}`, value);
                    }
                });
                else result[param.name] = value;
            }
        });
        // Make all error indexed values throw on access
        for(let i = 0; i < result.length; i++){
            const value = result[i];
            if (value instanceof Error) Object.defineProperty(result, i, {
                enumerable: true,
                get: ()=>{
                    throw $c799c8c071055c8d$var$wrapAccessError(`index ${i}`, value);
                }
            });
        }
        return Object.freeze(result);
    }
    // Given a transaction, find the matching function fragment (if any) and
    // determine all its properties and call parameters
    parseTransaction(tx) {
        let fragment = this.getFunction(tx.data.substring(0, 10).toLowerCase());
        if (!fragment) return null;
        return new $c799c8c071055c8d$export$7a3223b0fadb690b({
            args: this._abiCoder.decode(fragment.inputs, "0x" + tx.data.substring(10)),
            functionFragment: fragment,
            name: fragment.name,
            signature: fragment.format(),
            sighash: this.getSighash(fragment),
            value: (0, $a87aa97415e1b917$export$d97aa349ed20696).from(tx.value || "0")
        });
    }
    // @TODO
    //parseCallResult(data: BytesLike): ??
    // Given an event log, find the matching event fragment (if any) and
    // determine all its properties and values
    parseLog(log) {
        let fragment = this.getEvent(log.topics[0]);
        if (!fragment || fragment.anonymous) return null;
        // @TODO: If anonymous, and the only method, and the input count matches, should we parse?
        //        Probably not, because just because it is the only event in the ABI does
        //        not mean we have the full ABI; maybe just a fragment?
        return new $c799c8c071055c8d$export$c2ab6499be98b3c5({
            eventFragment: fragment,
            name: fragment.name,
            signature: fragment.format(),
            topic: this.getEventTopic(fragment),
            args: this.decodeEventLog(fragment, log.data, log.topics)
        });
    }
    parseError(data) {
        const hexData = (0, $06d75ae17ce69367$export$2b0d6b5fbe698c70)(data);
        let fragment = this.getError(hexData.substring(0, 10).toLowerCase());
        if (!fragment) return null;
        return new $c799c8c071055c8d$export$cfba08fc0e40e2ab({
            args: this._abiCoder.decode(fragment.inputs, "0x" + hexData.substring(10)),
            errorFragment: fragment,
            name: fragment.name,
            signature: fragment.format(),
            sighash: this.getSighash(fragment)
        });
    }
    /*
    static from(value: Array<Fragment | string | JsonAbi> | string | Interface) {
        if (Interface.isInterface(value)) {
            return value;
        }
        if (typeof(value) === "string") {
            return new Interface(JSON.parse(value));
        }
        return new Interface(value);
    }
    */ static isInterface(value) {
        return !!(value && value._isInterface);
    }
}










const $7cae7c27901eb562$export$83d89fbfd8236492 = "contracts/5.7.0";


"use strict";
var $8f1c51d58e4a2402$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
const $8f1c51d58e4a2402$var$logger = new (0, $5f596c9584f643ae$export$efa9a398d6368992)((0, $7cae7c27901eb562$export$83d89fbfd8236492));
///////////////////////////////
const $8f1c51d58e4a2402$var$allowedTransactionKeys = {
    chainId: true,
    data: true,
    from: true,
    gasLimit: true,
    gasPrice: true,
    nonce: true,
    to: true,
    value: true,
    type: true,
    accessList: true,
    maxFeePerGas: true,
    maxPriorityFeePerGas: true,
    customData: true,
    ccipReadEnabled: true
};
function $8f1c51d58e4a2402$var$resolveName(resolver, nameOrPromise) {
    return $8f1c51d58e4a2402$var$__awaiter(this, void 0, void 0, function*() {
        const name = yield nameOrPromise;
        if (typeof name !== "string") $8f1c51d58e4a2402$var$logger.throwArgumentError("invalid address or ENS name", "name", name);
        // If it is already an address, just use it (after adding checksum)
        try {
            return (0, $5652f239bab101de$export$88411125f012957a)(name);
        } catch (error) {}
        if (!resolver) $8f1c51d58e4a2402$var$logger.throwError("a provider or signer is needed to resolve ENS names", (0, $5f596c9584f643ae$export$efa9a398d6368992).errors.UNSUPPORTED_OPERATION, {
            operation: "resolveName"
        });
        const address = yield resolver.resolveName(name);
        if (address == null) $8f1c51d58e4a2402$var$logger.throwArgumentError("resolver or addr is not configured for ENS name", "name", name);
        return address;
    });
}
// Recursively replaces ENS names with promises to resolve the name and resolves all properties
function $8f1c51d58e4a2402$var$resolveAddresses(resolver, value, paramType) {
    return $8f1c51d58e4a2402$var$__awaiter(this, void 0, void 0, function*() {
        if (Array.isArray(paramType)) return yield Promise.all(paramType.map((paramType, index)=>{
            return $8f1c51d58e4a2402$var$resolveAddresses(resolver, Array.isArray(value) ? value[index] : value[paramType.name], paramType);
        }));
        if (paramType.type === "address") return yield $8f1c51d58e4a2402$var$resolveName(resolver, value);
        if (paramType.type === "tuple") return yield $8f1c51d58e4a2402$var$resolveAddresses(resolver, value, paramType.components);
        if (paramType.baseType === "array") {
            if (!Array.isArray(value)) return Promise.reject($8f1c51d58e4a2402$var$logger.makeError("invalid value for array", (0, $5f596c9584f643ae$export$efa9a398d6368992).errors.INVALID_ARGUMENT, {
                argument: "value",
                value: value
            }));
            return yield Promise.all(value.map((v)=>$8f1c51d58e4a2402$var$resolveAddresses(resolver, v, paramType.arrayChildren)));
        }
        return value;
    });
}
function $8f1c51d58e4a2402$var$populateTransaction(contract, fragment, args) {
    return $8f1c51d58e4a2402$var$__awaiter(this, void 0, void 0, function*() {
        // If an extra argument is given, it is overrides
        let overrides = {};
        if (args.length === fragment.inputs.length + 1 && typeof args[args.length - 1] === "object") overrides = (0, $d2d9b472f7878d5e$exports.shallowCopy)(args.pop());
        // Make sure the parameter count matches
        $8f1c51d58e4a2402$var$logger.checkArgumentCount(args.length, fragment.inputs.length, "passed to contract");
        // Populate "from" override (allow promises)
        if (contract.signer) {
            if (overrides.from) // Contracts with a Signer are from the Signer's frame-of-reference;
            // but we allow overriding "from" if it matches the signer
            overrides.from = (0, $d2d9b472f7878d5e$exports.resolveProperties)({
                override: $8f1c51d58e4a2402$var$resolveName(contract.signer, overrides.from),
                signer: contract.signer.getAddress()
            }).then((check)=>$8f1c51d58e4a2402$var$__awaiter(this, void 0, void 0, function*() {
                    if ((0, $5652f239bab101de$export$88411125f012957a)(check.signer) !== check.override) $8f1c51d58e4a2402$var$logger.throwError("Contract with a Signer cannot override from", (0, $5f596c9584f643ae$export$efa9a398d6368992).errors.UNSUPPORTED_OPERATION, {
                        operation: "overrides.from"
                    });
                    return check.override;
                }));
            else overrides.from = contract.signer.getAddress();
        } else if (overrides.from) overrides.from = $8f1c51d58e4a2402$var$resolveName(contract.provider, overrides.from);
        // Wait for all dependencies to be resolved (prefer the signer over the provider)
        const resolved = yield (0, $d2d9b472f7878d5e$exports.resolveProperties)({
            args: $8f1c51d58e4a2402$var$resolveAddresses(contract.signer || contract.provider, args, fragment.inputs),
            address: contract.resolvedAddress,
            overrides: (0, $d2d9b472f7878d5e$exports.resolveProperties)(overrides) || {}
        });
        // The ABI coded transaction
        const data = contract.interface.encodeFunctionData(fragment, resolved.args);
        const tx = {
            data: data,
            to: resolved.address
        };
        // Resolved Overrides
        const ro = resolved.overrides;
        // Populate simple overrides
        if (ro.nonce != null) tx.nonce = (0, $a87aa97415e1b917$export$d97aa349ed20696).from(ro.nonce).toNumber();
        if (ro.gasLimit != null) tx.gasLimit = (0, $a87aa97415e1b917$export$d97aa349ed20696).from(ro.gasLimit);
        if (ro.gasPrice != null) tx.gasPrice = (0, $a87aa97415e1b917$export$d97aa349ed20696).from(ro.gasPrice);
        if (ro.maxFeePerGas != null) tx.maxFeePerGas = (0, $a87aa97415e1b917$export$d97aa349ed20696).from(ro.maxFeePerGas);
        if (ro.maxPriorityFeePerGas != null) tx.maxPriorityFeePerGas = (0, $a87aa97415e1b917$export$d97aa349ed20696).from(ro.maxPriorityFeePerGas);
        if (ro.from != null) tx.from = ro.from;
        if (ro.type != null) tx.type = ro.type;
        if (ro.accessList != null) tx.accessList = (0, $4335107f861a4482$export$6c8662b1600dce2)(ro.accessList);
        // If there was no "gasLimit" override, but the ABI specifies a default, use it
        if (tx.gasLimit == null && fragment.gas != null) {
            // Compute the intrinsic gas cost for this transaction
            // @TODO: This is based on the yellow paper as of Petersburg; this is something
            // we may wish to parameterize in v6 as part of the Network object. Since this
            // is always a non-nil to address, we can ignore G_create, but may wish to add
            // similar logic to the ContractFactory.
            let intrinsic = 21000;
            const bytes = (0, $06d75ae17ce69367$export$3131421a7d01b4fb)(data);
            for(let i = 0; i < bytes.length; i++){
                intrinsic += 4;
                if (bytes[i]) intrinsic += 64;
            }
            tx.gasLimit = (0, $a87aa97415e1b917$export$d97aa349ed20696).from(fragment.gas).add(intrinsic);
        }
        // Populate "value" override
        if (ro.value) {
            const roValue = (0, $a87aa97415e1b917$export$d97aa349ed20696).from(ro.value);
            if (!roValue.isZero() && !fragment.payable) $8f1c51d58e4a2402$var$logger.throwError("non-payable method cannot override value", (0, $5f596c9584f643ae$export$efa9a398d6368992).errors.UNSUPPORTED_OPERATION, {
                operation: "overrides.value",
                value: overrides.value
            });
            tx.value = roValue;
        }
        if (ro.customData) tx.customData = (0, $d2d9b472f7878d5e$exports.shallowCopy)(ro.customData);
        if (ro.ccipReadEnabled) tx.ccipReadEnabled = !!ro.ccipReadEnabled;
        // Remove the overrides
        delete overrides.nonce;
        delete overrides.gasLimit;
        delete overrides.gasPrice;
        delete overrides.from;
        delete overrides.value;
        delete overrides.type;
        delete overrides.accessList;
        delete overrides.maxFeePerGas;
        delete overrides.maxPriorityFeePerGas;
        delete overrides.customData;
        delete overrides.ccipReadEnabled;
        // Make sure there are no stray overrides, which may indicate a
        // typo or using an unsupported key.
        const leftovers = Object.keys(overrides).filter((key)=>overrides[key] != null);
        if (leftovers.length) $8f1c51d58e4a2402$var$logger.throwError(`cannot override ${leftovers.map((l)=>JSON.stringify(l)).join(",")}`, (0, $5f596c9584f643ae$export$efa9a398d6368992).errors.UNSUPPORTED_OPERATION, {
            operation: "overrides",
            overrides: leftovers
        });
        return tx;
    });
}
function $8f1c51d58e4a2402$var$buildPopulate(contract, fragment) {
    return function(...args) {
        return $8f1c51d58e4a2402$var$populateTransaction(contract, fragment, args);
    };
}
function $8f1c51d58e4a2402$var$buildEstimate(contract, fragment) {
    const signerOrProvider = contract.signer || contract.provider;
    return function(...args) {
        return $8f1c51d58e4a2402$var$__awaiter(this, void 0, void 0, function*() {
            if (!signerOrProvider) $8f1c51d58e4a2402$var$logger.throwError("estimate require a provider or signer", (0, $5f596c9584f643ae$export$efa9a398d6368992).errors.UNSUPPORTED_OPERATION, {
                operation: "estimateGas"
            });
            const tx = yield $8f1c51d58e4a2402$var$populateTransaction(contract, fragment, args);
            return yield signerOrProvider.estimateGas(tx);
        });
    };
}
function $8f1c51d58e4a2402$var$addContractWait(contract, tx) {
    const wait = tx.wait.bind(tx);
    tx.wait = (confirmations)=>{
        return wait(confirmations).then((receipt)=>{
            receipt.events = receipt.logs.map((log)=>{
                let event = (0, $d2d9b472f7878d5e$exports.deepCopy)(log);
                let parsed = null;
                try {
                    parsed = contract.interface.parseLog(log);
                } catch (e) {}
                // Successfully parsed the event log; include it
                if (parsed) {
                    event.args = parsed.args;
                    event.decode = (data, topics)=>{
                        return contract.interface.decodeEventLog(parsed.eventFragment, data, topics);
                    };
                    event.event = parsed.name;
                    event.eventSignature = parsed.signature;
                }
                // Useful operations
                event.removeListener = ()=>{
                    return contract.provider;
                };
                event.getBlock = ()=>{
                    return contract.provider.getBlock(receipt.blockHash);
                };
                event.getTransaction = ()=>{
                    return contract.provider.getTransaction(receipt.transactionHash);
                };
                event.getTransactionReceipt = ()=>{
                    return Promise.resolve(receipt);
                };
                return event;
            });
            return receipt;
        });
    };
}
function $8f1c51d58e4a2402$var$buildCall(contract, fragment, collapseSimple) {
    const signerOrProvider = contract.signer || contract.provider;
    return function(...args) {
        return $8f1c51d58e4a2402$var$__awaiter(this, void 0, void 0, function*() {
            // Extract the "blockTag" override if present
            let blockTag = undefined;
            if (args.length === fragment.inputs.length + 1 && typeof args[args.length - 1] === "object") {
                const overrides = (0, $d2d9b472f7878d5e$exports.shallowCopy)(args.pop());
                if (overrides.blockTag != null) blockTag = yield overrides.blockTag;
                delete overrides.blockTag;
                args.push(overrides);
            }
            // If the contract was just deployed, wait until it is mined
            if (contract.deployTransaction != null) yield contract._deployed(blockTag);
            // Call a node and get the result
            const tx = yield $8f1c51d58e4a2402$var$populateTransaction(contract, fragment, args);
            const result = yield signerOrProvider.call(tx, blockTag);
            try {
                let value = contract.interface.decodeFunctionResult(fragment, result);
                if (collapseSimple && fragment.outputs.length === 1) value = value[0];
                return value;
            } catch (error) {
                if (error.code === (0, $5f596c9584f643ae$export$efa9a398d6368992).errors.CALL_EXCEPTION) {
                    error.address = contract.address;
                    error.args = args;
                    error.transaction = tx;
                }
                throw error;
            }
        });
    };
}
function $8f1c51d58e4a2402$var$buildSend(contract, fragment) {
    return function(...args) {
        return $8f1c51d58e4a2402$var$__awaiter(this, void 0, void 0, function*() {
            if (!contract.signer) $8f1c51d58e4a2402$var$logger.throwError("sending a transaction requires a signer", (0, $5f596c9584f643ae$export$efa9a398d6368992).errors.UNSUPPORTED_OPERATION, {
                operation: "sendTransaction"
            });
            // If the contract was just deployed, wait until it is mined
            if (contract.deployTransaction != null) yield contract._deployed();
            const txRequest = yield $8f1c51d58e4a2402$var$populateTransaction(contract, fragment, args);
            const tx = yield contract.signer.sendTransaction(txRequest);
            // Tweak the tx.wait so the receipt has extra properties
            $8f1c51d58e4a2402$var$addContractWait(contract, tx);
            return tx;
        });
    };
}
function $8f1c51d58e4a2402$var$buildDefault(contract, fragment, collapseSimple) {
    if (fragment.constant) return $8f1c51d58e4a2402$var$buildCall(contract, fragment, collapseSimple);
    return $8f1c51d58e4a2402$var$buildSend(contract, fragment);
}
function $8f1c51d58e4a2402$var$getEventTag(filter) {
    if (filter.address && (filter.topics == null || filter.topics.length === 0)) return "*";
    return (filter.address || "*") + "@" + (filter.topics ? filter.topics.map((topic)=>{
        if (Array.isArray(topic)) return topic.join("|");
        return topic;
    }).join(":") : "");
}
class $8f1c51d58e4a2402$var$RunningEvent {
    constructor(tag, filter){
        (0, $d2d9b472f7878d5e$exports.defineReadOnly)(this, "tag", tag);
        (0, $d2d9b472f7878d5e$exports.defineReadOnly)(this, "filter", filter);
        this._listeners = [];
    }
    addListener(listener, once) {
        this._listeners.push({
            listener: listener,
            once: once
        });
    }
    removeListener(listener) {
        let done = false;
        this._listeners = this._listeners.filter((item)=>{
            if (done || item.listener !== listener) return true;
            done = true;
            return false;
        });
    }
    removeAllListeners() {
        this._listeners = [];
    }
    listeners() {
        return this._listeners.map((i)=>i.listener);
    }
    listenerCount() {
        return this._listeners.length;
    }
    run(args) {
        const listenerCount = this.listenerCount();
        this._listeners = this._listeners.filter((item)=>{
            const argsCopy = args.slice();
            // Call the callback in the next event loop
            setTimeout(()=>{
                item.listener.apply(this, argsCopy);
            }, 0);
            // Reschedule it if it not "once"
            return !item.once;
        });
        return listenerCount;
    }
    prepareEvent(event) {}
    // Returns the array that will be applied to an emit
    getEmit(event) {
        return [
            event
        ];
    }
}
class $8f1c51d58e4a2402$var$ErrorRunningEvent extends $8f1c51d58e4a2402$var$RunningEvent {
    constructor(){
        super("error", null);
    }
}
// @TODO Fragment should inherit Wildcard? and just override getEmit?
//       or have a common abstract super class, with enough constructor
//       options to configure both.
// A Fragment Event will populate all the properties that Wildcard
// will, and additionally dereference the arguments when emitting
class $8f1c51d58e4a2402$var$FragmentRunningEvent extends $8f1c51d58e4a2402$var$RunningEvent {
    constructor(address, contractInterface, fragment, topics){
        const filter = {
            address: address
        };
        let topic = contractInterface.getEventTopic(fragment);
        if (topics) {
            if (topic !== topics[0]) $8f1c51d58e4a2402$var$logger.throwArgumentError("topic mismatch", "topics", topics);
            filter.topics = topics.slice();
        } else filter.topics = [
            topic
        ];
        super($8f1c51d58e4a2402$var$getEventTag(filter), filter);
        (0, $d2d9b472f7878d5e$exports.defineReadOnly)(this, "address", address);
        (0, $d2d9b472f7878d5e$exports.defineReadOnly)(this, "interface", contractInterface);
        (0, $d2d9b472f7878d5e$exports.defineReadOnly)(this, "fragment", fragment);
    }
    prepareEvent(event) {
        super.prepareEvent(event);
        event.event = this.fragment.name;
        event.eventSignature = this.fragment.format();
        event.decode = (data, topics)=>{
            return this.interface.decodeEventLog(this.fragment, data, topics);
        };
        try {
            event.args = this.interface.decodeEventLog(this.fragment, event.data, event.topics);
        } catch (error) {
            event.args = null;
            event.decodeError = error;
        }
    }
    getEmit(event) {
        const errors = (0, $3c454193c1d90bf8$export$5546b9ec21157cc2)(event.args);
        if (errors.length) throw errors[0].error;
        const args = (event.args || []).slice();
        args.push(event);
        return args;
    }
}
// A Wildcard Event will attempt to populate:
//  - event            The name of the event name
//  - eventSignature   The full signature of the event
//  - decode           A function to decode data and topics
//  - args             The decoded data and topics
class $8f1c51d58e4a2402$var$WildcardRunningEvent extends $8f1c51d58e4a2402$var$RunningEvent {
    constructor(address, contractInterface){
        super("*", {
            address: address
        });
        (0, $d2d9b472f7878d5e$exports.defineReadOnly)(this, "address", address);
        (0, $d2d9b472f7878d5e$exports.defineReadOnly)(this, "interface", contractInterface);
    }
    prepareEvent(event) {
        super.prepareEvent(event);
        try {
            const parsed = this.interface.parseLog(event);
            event.event = parsed.name;
            event.eventSignature = parsed.signature;
            event.decode = (data, topics)=>{
                return this.interface.decodeEventLog(parsed.eventFragment, data, topics);
            };
            event.args = parsed.args;
        } catch (error) {
        // No matching event
        }
    }
}
class $8f1c51d58e4a2402$export$304faa4fc17528db {
    constructor(addressOrName, contractInterface, signerOrProvider){
        // @TODO: Maybe still check the addressOrName looks like a valid address or name?
        //address = getAddress(address);
        (0, $d2d9b472f7878d5e$exports.defineReadOnly)(this, "interface", (0, $d2d9b472f7878d5e$exports.getStatic)(new.target, "getInterface")(contractInterface));
        if (signerOrProvider == null) {
            (0, $d2d9b472f7878d5e$exports.defineReadOnly)(this, "provider", null);
            (0, $d2d9b472f7878d5e$exports.defineReadOnly)(this, "signer", null);
        } else if ((0, $04afbe51d47fcc12$exports.Signer).isSigner(signerOrProvider)) {
            (0, $d2d9b472f7878d5e$exports.defineReadOnly)(this, "provider", signerOrProvider.provider || null);
            (0, $d2d9b472f7878d5e$exports.defineReadOnly)(this, "signer", signerOrProvider);
        } else if ((0, $9f78b76a8aa61745$exports.Provider).isProvider(signerOrProvider)) {
            (0, $d2d9b472f7878d5e$exports.defineReadOnly)(this, "provider", signerOrProvider);
            (0, $d2d9b472f7878d5e$exports.defineReadOnly)(this, "signer", null);
        } else $8f1c51d58e4a2402$var$logger.throwArgumentError("invalid signer or provider", "signerOrProvider", signerOrProvider);
        (0, $d2d9b472f7878d5e$exports.defineReadOnly)(this, "callStatic", {});
        (0, $d2d9b472f7878d5e$exports.defineReadOnly)(this, "estimateGas", {});
        (0, $d2d9b472f7878d5e$exports.defineReadOnly)(this, "functions", {});
        (0, $d2d9b472f7878d5e$exports.defineReadOnly)(this, "populateTransaction", {});
        (0, $d2d9b472f7878d5e$exports.defineReadOnly)(this, "filters", {});
        {
            const uniqueFilters = {};
            Object.keys(this.interface.events).forEach((eventSignature)=>{
                const event = this.interface.events[eventSignature];
                (0, $d2d9b472f7878d5e$exports.defineReadOnly)(this.filters, eventSignature, (...args)=>{
                    return {
                        address: this.address,
                        topics: this.interface.encodeFilterTopics(event, args)
                    };
                });
                if (!uniqueFilters[event.name]) uniqueFilters[event.name] = [];
                uniqueFilters[event.name].push(eventSignature);
            });
            Object.keys(uniqueFilters).forEach((name)=>{
                const filters = uniqueFilters[name];
                if (filters.length === 1) (0, $d2d9b472f7878d5e$exports.defineReadOnly)(this.filters, name, this.filters[filters[0]]);
                else $8f1c51d58e4a2402$var$logger.warn(`Duplicate definition of ${name} (${filters.join(", ")})`);
            });
        }
        (0, $d2d9b472f7878d5e$exports.defineReadOnly)(this, "_runningEvents", {});
        (0, $d2d9b472f7878d5e$exports.defineReadOnly)(this, "_wrappedEmits", {});
        if (addressOrName == null) $8f1c51d58e4a2402$var$logger.throwArgumentError("invalid contract address or ENS name", "addressOrName", addressOrName);
        (0, $d2d9b472f7878d5e$exports.defineReadOnly)(this, "address", addressOrName);
        if (this.provider) (0, $d2d9b472f7878d5e$exports.defineReadOnly)(this, "resolvedAddress", $8f1c51d58e4a2402$var$resolveName(this.provider, addressOrName));
        else try {
            (0, $d2d9b472f7878d5e$exports.defineReadOnly)(this, "resolvedAddress", Promise.resolve((0, $5652f239bab101de$export$88411125f012957a)(addressOrName)));
        } catch (error) {
            // Without a provider, we cannot use ENS names
            $8f1c51d58e4a2402$var$logger.throwError("provider is required to use ENS name as contract address", (0, $5f596c9584f643ae$export$efa9a398d6368992).errors.UNSUPPORTED_OPERATION, {
                operation: "new Contract"
            });
        }
        // Swallow bad ENS names to prevent Unhandled Exceptions
        this.resolvedAddress.catch((e)=>{});
        const uniqueNames = {};
        const uniqueSignatures = {};
        Object.keys(this.interface.functions).forEach((signature)=>{
            const fragment = this.interface.functions[signature];
            // Check that the signature is unique; if not the ABI generation has
            // not been cleaned or may be incorrectly generated
            if (uniqueSignatures[signature]) {
                $8f1c51d58e4a2402$var$logger.warn(`Duplicate ABI entry for ${JSON.stringify(signature)}`);
                return;
            }
            uniqueSignatures[signature] = true;
            // Track unique names; we only expose bare named functions if they
            // are ambiguous
            {
                const name = fragment.name;
                if (!uniqueNames[`%${name}`]) uniqueNames[`%${name}`] = [];
                uniqueNames[`%${name}`].push(signature);
            }
            if (this[signature] == null) (0, $d2d9b472f7878d5e$exports.defineReadOnly)(this, signature, $8f1c51d58e4a2402$var$buildDefault(this, fragment, true));
            // We do not collapse simple calls on this bucket, which allows
            // frameworks to safely use this without introspection as well as
            // allows decoding error recovery.
            if (this.functions[signature] == null) (0, $d2d9b472f7878d5e$exports.defineReadOnly)(this.functions, signature, $8f1c51d58e4a2402$var$buildDefault(this, fragment, false));
            if (this.callStatic[signature] == null) (0, $d2d9b472f7878d5e$exports.defineReadOnly)(this.callStatic, signature, $8f1c51d58e4a2402$var$buildCall(this, fragment, true));
            if (this.populateTransaction[signature] == null) (0, $d2d9b472f7878d5e$exports.defineReadOnly)(this.populateTransaction, signature, $8f1c51d58e4a2402$var$buildPopulate(this, fragment));
            if (this.estimateGas[signature] == null) (0, $d2d9b472f7878d5e$exports.defineReadOnly)(this.estimateGas, signature, $8f1c51d58e4a2402$var$buildEstimate(this, fragment));
        });
        Object.keys(uniqueNames).forEach((name)=>{
            // Ambiguous names to not get attached as bare names
            const signatures = uniqueNames[name];
            if (signatures.length > 1) return;
            // Strip off the leading "%" used for prototype protection
            name = name.substring(1);
            const signature = signatures[0];
            // If overwriting a member property that is null, swallow the error
            try {
                if (this[name] == null) (0, $d2d9b472f7878d5e$exports.defineReadOnly)(this, name, this[signature]);
            } catch (e) {}
            if (this.functions[name] == null) (0, $d2d9b472f7878d5e$exports.defineReadOnly)(this.functions, name, this.functions[signature]);
            if (this.callStatic[name] == null) (0, $d2d9b472f7878d5e$exports.defineReadOnly)(this.callStatic, name, this.callStatic[signature]);
            if (this.populateTransaction[name] == null) (0, $d2d9b472f7878d5e$exports.defineReadOnly)(this.populateTransaction, name, this.populateTransaction[signature]);
            if (this.estimateGas[name] == null) (0, $d2d9b472f7878d5e$exports.defineReadOnly)(this.estimateGas, name, this.estimateGas[signature]);
        });
    }
    static getContractAddress(transaction) {
        return (0, $5652f239bab101de$export$b7fbffef12272e40)(transaction);
    }
    static getInterface(contractInterface) {
        if ((0, $c799c8c071055c8d$export$48cefb51a4e315b2).isInterface(contractInterface)) return contractInterface;
        return new (0, $c799c8c071055c8d$export$48cefb51a4e315b2)(contractInterface);
    }
    // @TODO: Allow timeout?
    deployed() {
        return this._deployed();
    }
    _deployed(blockTag) {
        if (!this._deployedPromise) {
            // If we were just deployed, we know the transaction we should occur in
            if (this.deployTransaction) this._deployedPromise = this.deployTransaction.wait().then(()=>{
                return this;
            });
            else // @TODO: Once we allow a timeout to be passed in, we will wait
            // up to that many blocks for getCode
            // Otherwise, poll for our code to be deployed
            this._deployedPromise = this.provider.getCode(this.address, blockTag).then((code)=>{
                if (code === "0x") $8f1c51d58e4a2402$var$logger.throwError("contract not deployed", (0, $5f596c9584f643ae$export$efa9a398d6368992).errors.UNSUPPORTED_OPERATION, {
                    contractAddress: this.address,
                    operation: "getDeployed"
                });
                return this;
            });
        }
        return this._deployedPromise;
    }
    // @TODO:
    // estimateFallback(overrides?: TransactionRequest): Promise<BigNumber>
    // @TODO:
    // estimateDeploy(bytecode: string, ...args): Promise<BigNumber>
    fallback(overrides) {
        if (!this.signer) $8f1c51d58e4a2402$var$logger.throwError("sending a transactions require a signer", (0, $5f596c9584f643ae$export$efa9a398d6368992).errors.UNSUPPORTED_OPERATION, {
            operation: "sendTransaction(fallback)"
        });
        const tx = (0, $d2d9b472f7878d5e$exports.shallowCopy)(overrides || {});
        [
            "from",
            "to"
        ].forEach(function(key) {
            if (tx[key] == null) return;
            $8f1c51d58e4a2402$var$logger.throwError("cannot override " + key, (0, $5f596c9584f643ae$export$efa9a398d6368992).errors.UNSUPPORTED_OPERATION, {
                operation: key
            });
        });
        tx.to = this.resolvedAddress;
        return this.deployed().then(()=>{
            return this.signer.sendTransaction(tx);
        });
    }
    // Reconnect to a different signer or provider
    connect(signerOrProvider) {
        if (typeof signerOrProvider === "string") signerOrProvider = new (0, $04afbe51d47fcc12$exports.VoidSigner)(signerOrProvider, this.provider);
        const contract = new this.constructor(this.address, this.interface, signerOrProvider);
        if (this.deployTransaction) (0, $d2d9b472f7878d5e$exports.defineReadOnly)(contract, "deployTransaction", this.deployTransaction);
        return contract;
    }
    // Re-attach to a different on-chain instance of this contract
    attach(addressOrName) {
        return new this.constructor(addressOrName, this.interface, this.signer || this.provider);
    }
    static isIndexed(value) {
        return (0, $c799c8c071055c8d$export$8ef99100a3c56f8c).isIndexed(value);
    }
    _normalizeRunningEvent(runningEvent) {
        // Already have an instance of this event running; we can re-use it
        if (this._runningEvents[runningEvent.tag]) return this._runningEvents[runningEvent.tag];
        return runningEvent;
    }
    _getRunningEvent(eventName) {
        if (typeof eventName === "string") {
            // Listen for "error" events (if your contract has an error event, include
            // the full signature to bypass this special event keyword)
            if (eventName === "error") return this._normalizeRunningEvent(new $8f1c51d58e4a2402$var$ErrorRunningEvent());
            // Listen for any event that is registered
            if (eventName === "event") return this._normalizeRunningEvent(new $8f1c51d58e4a2402$var$RunningEvent("event", null));
            // Listen for any event
            if (eventName === "*") return this._normalizeRunningEvent(new $8f1c51d58e4a2402$var$WildcardRunningEvent(this.address, this.interface));
            // Get the event Fragment (throws if ambiguous/unknown event)
            const fragment = this.interface.getEvent(eventName);
            return this._normalizeRunningEvent(new $8f1c51d58e4a2402$var$FragmentRunningEvent(this.address, this.interface, fragment));
        }
        // We have topics to filter by...
        if (eventName.topics && eventName.topics.length > 0) {
            // Is it a known topichash? (throws if no matching topichash)
            try {
                const topic = eventName.topics[0];
                if (typeof topic !== "string") throw new Error("invalid topic"); // @TODO: May happen for anonymous events
                const fragment = this.interface.getEvent(topic);
                return this._normalizeRunningEvent(new $8f1c51d58e4a2402$var$FragmentRunningEvent(this.address, this.interface, fragment, eventName.topics));
            } catch (error) {}
            // Filter by the unknown topichash
            const filter = {
                address: this.address,
                topics: eventName.topics
            };
            return this._normalizeRunningEvent(new $8f1c51d58e4a2402$var$RunningEvent($8f1c51d58e4a2402$var$getEventTag(filter), filter));
        }
        return this._normalizeRunningEvent(new $8f1c51d58e4a2402$var$WildcardRunningEvent(this.address, this.interface));
    }
    _checkRunningEvents(runningEvent) {
        if (runningEvent.listenerCount() === 0) {
            delete this._runningEvents[runningEvent.tag];
            // If we have a poller for this, remove it
            const emit = this._wrappedEmits[runningEvent.tag];
            if (emit && runningEvent.filter) {
                this.provider.off(runningEvent.filter, emit);
                delete this._wrappedEmits[runningEvent.tag];
            }
        }
    }
    // Subclasses can override this to gracefully recover
    // from parse errors if they wish
    _wrapEvent(runningEvent, log, listener) {
        const event = (0, $d2d9b472f7878d5e$exports.deepCopy)(log);
        event.removeListener = ()=>{
            if (!listener) return;
            runningEvent.removeListener(listener);
            this._checkRunningEvents(runningEvent);
        };
        event.getBlock = ()=>{
            return this.provider.getBlock(log.blockHash);
        };
        event.getTransaction = ()=>{
            return this.provider.getTransaction(log.transactionHash);
        };
        event.getTransactionReceipt = ()=>{
            return this.provider.getTransactionReceipt(log.transactionHash);
        };
        // This may throw if the topics and data mismatch the signature
        runningEvent.prepareEvent(event);
        return event;
    }
    _addEventListener(runningEvent, listener, once) {
        if (!this.provider) $8f1c51d58e4a2402$var$logger.throwError("events require a provider or a signer with a provider", (0, $5f596c9584f643ae$export$efa9a398d6368992).errors.UNSUPPORTED_OPERATION, {
            operation: "once"
        });
        runningEvent.addListener(listener, once);
        // Track this running event and its listeners (may already be there; but no hard in updating)
        this._runningEvents[runningEvent.tag] = runningEvent;
        // If we are not polling the provider, start polling
        if (!this._wrappedEmits[runningEvent.tag]) {
            const wrappedEmit = (log)=>{
                let event = this._wrapEvent(runningEvent, log, listener);
                // Try to emit the result for the parameterized event...
                if (event.decodeError == null) try {
                    const args = runningEvent.getEmit(event);
                    this.emit(runningEvent.filter, ...args);
                } catch (error) {
                    event.decodeError = error.error;
                }
                // Always emit "event" for fragment-base events
                if (runningEvent.filter != null) this.emit("event", event);
                // Emit "error" if there was an error
                if (event.decodeError != null) this.emit("error", event.decodeError, event);
            };
            this._wrappedEmits[runningEvent.tag] = wrappedEmit;
            // Special events, like "error" do not have a filter
            if (runningEvent.filter != null) this.provider.on(runningEvent.filter, wrappedEmit);
        }
    }
    queryFilter(event, fromBlockOrBlockhash, toBlock) {
        const runningEvent = this._getRunningEvent(event);
        const filter = (0, $d2d9b472f7878d5e$exports.shallowCopy)(runningEvent.filter);
        if (typeof fromBlockOrBlockhash === "string" && (0, $06d75ae17ce69367$export$b02a40aff8e4ad18)(fromBlockOrBlockhash, 32)) {
            if (toBlock != null) $8f1c51d58e4a2402$var$logger.throwArgumentError("cannot specify toBlock with blockhash", "toBlock", toBlock);
            filter.blockHash = fromBlockOrBlockhash;
        } else {
            filter.fromBlock = fromBlockOrBlockhash != null ? fromBlockOrBlockhash : 0;
            filter.toBlock = toBlock != null ? toBlock : "latest";
        }
        return this.provider.getLogs(filter).then((logs)=>{
            return logs.map((log)=>this._wrapEvent(runningEvent, log, null));
        });
    }
    on(event, listener) {
        this._addEventListener(this._getRunningEvent(event), listener, false);
        return this;
    }
    once(event, listener) {
        this._addEventListener(this._getRunningEvent(event), listener, true);
        return this;
    }
    emit(eventName, ...args) {
        if (!this.provider) return false;
        const runningEvent = this._getRunningEvent(eventName);
        const result = runningEvent.run(args) > 0;
        // May have drained all the "once" events; check for living events
        this._checkRunningEvents(runningEvent);
        return result;
    }
    listenerCount(eventName) {
        if (!this.provider) return 0;
        if (eventName == null) return Object.keys(this._runningEvents).reduce((accum, key)=>{
            return accum + this._runningEvents[key].listenerCount();
        }, 0);
        return this._getRunningEvent(eventName).listenerCount();
    }
    listeners(eventName) {
        if (!this.provider) return [];
        if (eventName == null) {
            const result = [];
            for(let tag in this._runningEvents)this._runningEvents[tag].listeners().forEach((listener)=>{
                result.push(listener);
            });
            return result;
        }
        return this._getRunningEvent(eventName).listeners();
    }
    removeAllListeners(eventName) {
        if (!this.provider) return this;
        if (eventName == null) {
            for(const tag in this._runningEvents){
                const runningEvent = this._runningEvents[tag];
                runningEvent.removeAllListeners();
                this._checkRunningEvents(runningEvent);
            }
            return this;
        }
        // Delete any listeners
        const runningEvent = this._getRunningEvent(eventName);
        runningEvent.removeAllListeners();
        this._checkRunningEvents(runningEvent);
        return this;
    }
    off(eventName, listener) {
        if (!this.provider) return this;
        const runningEvent = this._getRunningEvent(eventName);
        runningEvent.removeListener(listener);
        this._checkRunningEvents(runningEvent);
        return this;
    }
    removeListener(eventName, listener) {
        return this.off(eventName, listener);
    }
}
class $8f1c51d58e4a2402$export$8517d80acf00e19a extends $8f1c51d58e4a2402$export$304faa4fc17528db {
}
class $8f1c51d58e4a2402$export$505569a6bf584fd9 {
    constructor(contractInterface, bytecode, signer){
        let bytecodeHex = null;
        if (typeof bytecode === "string") bytecodeHex = bytecode;
        else if ((0, $06d75ae17ce69367$export$c6fabfbfd097fc30)(bytecode)) bytecodeHex = (0, $06d75ae17ce69367$export$2b0d6b5fbe698c70)(bytecode);
        else if (bytecode && typeof bytecode.object === "string") // Allow the bytecode object from the Solidity compiler
        bytecodeHex = bytecode.object;
        else // Crash in the next verification step
        bytecodeHex = "!";
        // Make sure it is 0x prefixed
        if (bytecodeHex.substring(0, 2) !== "0x") bytecodeHex = "0x" + bytecodeHex;
        // Make sure the final result is valid bytecode
        if (!(0, $06d75ae17ce69367$export$b02a40aff8e4ad18)(bytecodeHex) || bytecodeHex.length % 2) $8f1c51d58e4a2402$var$logger.throwArgumentError("invalid bytecode", "bytecode", bytecode);
        // If we have a signer, make sure it is valid
        if (signer && !(0, $04afbe51d47fcc12$exports.Signer).isSigner(signer)) $8f1c51d58e4a2402$var$logger.throwArgumentError("invalid signer", "signer", signer);
        (0, $d2d9b472f7878d5e$exports.defineReadOnly)(this, "bytecode", bytecodeHex);
        (0, $d2d9b472f7878d5e$exports.defineReadOnly)(this, "interface", (0, $d2d9b472f7878d5e$exports.getStatic)(new.target, "getInterface")(contractInterface));
        (0, $d2d9b472f7878d5e$exports.defineReadOnly)(this, "signer", signer || null);
    }
    // @TODO: Future; rename to populateTransaction?
    getDeployTransaction(...args) {
        let tx = {};
        // If we have 1 additional argument, we allow transaction overrides
        if (args.length === this.interface.deploy.inputs.length + 1 && typeof args[args.length - 1] === "object") {
            tx = (0, $d2d9b472f7878d5e$exports.shallowCopy)(args.pop());
            for(const key in tx){
                if (!$8f1c51d58e4a2402$var$allowedTransactionKeys[key]) throw new Error("unknown transaction override " + key);
            }
        }
        // Do not allow these to be overridden in a deployment transaction
        [
            "data",
            "from",
            "to"
        ].forEach((key)=>{
            if (tx[key] == null) return;
            $8f1c51d58e4a2402$var$logger.throwError("cannot override " + key, (0, $5f596c9584f643ae$export$efa9a398d6368992).errors.UNSUPPORTED_OPERATION, {
                operation: key
            });
        });
        if (tx.value) {
            const value = (0, $a87aa97415e1b917$export$d97aa349ed20696).from(tx.value);
            if (!value.isZero() && !this.interface.deploy.payable) $8f1c51d58e4a2402$var$logger.throwError("non-payable constructor cannot override value", (0, $5f596c9584f643ae$export$efa9a398d6368992).errors.UNSUPPORTED_OPERATION, {
                operation: "overrides.value",
                value: tx.value
            });
        }
        // Make sure the call matches the constructor signature
        $8f1c51d58e4a2402$var$logger.checkArgumentCount(args.length, this.interface.deploy.inputs.length, " in Contract constructor");
        // Set the data to the bytecode + the encoded constructor arguments
        tx.data = (0, $06d75ae17ce69367$export$2b0d6b5fbe698c70)((0, $06d75ae17ce69367$export$ee1b3e54f0441b22)([
            this.bytecode,
            this.interface.encodeDeploy(args)
        ]));
        return tx;
    }
    deploy(...args) {
        return $8f1c51d58e4a2402$var$__awaiter(this, void 0, void 0, function*() {
            let overrides = {};
            // If 1 extra parameter was passed in, it contains overrides
            if (args.length === this.interface.deploy.inputs.length + 1) overrides = args.pop();
            // Make sure the call matches the constructor signature
            $8f1c51d58e4a2402$var$logger.checkArgumentCount(args.length, this.interface.deploy.inputs.length, " in Contract constructor");
            // Resolve ENS names and promises in the arguments
            const params = yield $8f1c51d58e4a2402$var$resolveAddresses(this.signer, args, this.interface.deploy.inputs);
            params.push(overrides);
            // Get the deployment transaction (with optional overrides)
            const unsignedTx = this.getDeployTransaction(...params);
            // Send the deployment transaction
            const tx = yield this.signer.sendTransaction(unsignedTx);
            const address = (0, $d2d9b472f7878d5e$exports.getStatic)(this.constructor, "getContractAddress")(tx);
            const contract = (0, $d2d9b472f7878d5e$exports.getStatic)(this.constructor, "getContract")(address, this.interface, this.signer);
            // Add the modified wait that wraps events
            $8f1c51d58e4a2402$var$addContractWait(contract, tx);
            (0, $d2d9b472f7878d5e$exports.defineReadOnly)(contract, "deployTransaction", tx);
            return contract;
        });
    }
    attach(address) {
        return this.constructor.getContract(address, this.interface, this.signer);
    }
    connect(signer) {
        return new this.constructor(this.interface, this.bytecode, signer);
    }
    static fromSolidity(compilerOutput, signer) {
        if (compilerOutput == null) $8f1c51d58e4a2402$var$logger.throwError("missing compiler output", (0, $5f596c9584f643ae$export$efa9a398d6368992).errors.MISSING_ARGUMENT, {
            argument: "compilerOutput"
        });
        if (typeof compilerOutput === "string") compilerOutput = JSON.parse(compilerOutput);
        const abi = compilerOutput.abi;
        let bytecode = null;
        if (compilerOutput.bytecode) bytecode = compilerOutput.bytecode;
        else if (compilerOutput.evm && compilerOutput.evm.bytecode) bytecode = compilerOutput.evm.bytecode;
        return new this(abi, bytecode, signer);
    }
    static getInterface(contractInterface) {
        return $8f1c51d58e4a2402$export$8517d80acf00e19a.getInterface(contractInterface);
    }
    static getContractAddress(tx) {
        return (0, $5652f239bab101de$export$b7fbffef12272e40)(tx);
    }
    static getContract(address, contractInterface, signer) {
        return new $8f1c51d58e4a2402$export$8517d80acf00e19a(address, contractInterface, signer);
    }
}






"use strict";
const $efb9ddd3e2b20828$var$logger = new (0, $5f596c9584f643ae$export$efa9a398d6368992)((0, $d6c9c8115f7af803$export$83d89fbfd8236492));
const $efb9ddd3e2b20828$var$_constructorGuard = {};
const $efb9ddd3e2b20828$var$Zero = (0, $a87aa97415e1b917$export$d97aa349ed20696).from(0);
const $efb9ddd3e2b20828$var$NegativeOne = (0, $a87aa97415e1b917$export$d97aa349ed20696).from(-1);
function $efb9ddd3e2b20828$var$throwFault(message, fault, operation, value) {
    const params = {
        fault: fault,
        operation: operation
    };
    if (value !== undefined) params.value = value;
    return $efb9ddd3e2b20828$var$logger.throwError(message, (0, $5f596c9584f643ae$export$efa9a398d6368992).errors.NUMERIC_FAULT, params);
}
// Constant to pull zeros from for multipliers
let $efb9ddd3e2b20828$var$zeros = "0";
while($efb9ddd3e2b20828$var$zeros.length < 256)$efb9ddd3e2b20828$var$zeros += $efb9ddd3e2b20828$var$zeros;
// Returns a string "1" followed by decimal "0"s
function $efb9ddd3e2b20828$var$getMultiplier(decimals) {
    if (typeof decimals !== "number") try {
        decimals = (0, $a87aa97415e1b917$export$d97aa349ed20696).from(decimals).toNumber();
    } catch (e) {}
    if (typeof decimals === "number" && decimals >= 0 && decimals <= 256 && !(decimals % 1)) return "1" + $efb9ddd3e2b20828$var$zeros.substring(0, decimals);
    return $efb9ddd3e2b20828$var$logger.throwArgumentError("invalid decimal size", "decimals", decimals);
}
function $efb9ddd3e2b20828$export$cc011b843b5d69f2(value, decimals) {
    if (decimals == null) decimals = 0;
    const multiplier = $efb9ddd3e2b20828$var$getMultiplier(decimals);
    // Make sure wei is a big number (convert as necessary)
    value = (0, $a87aa97415e1b917$export$d97aa349ed20696).from(value);
    const negative = value.lt($efb9ddd3e2b20828$var$Zero);
    if (negative) value = value.mul($efb9ddd3e2b20828$var$NegativeOne);
    let fraction = value.mod(multiplier).toString();
    while(fraction.length < multiplier.length - 1)fraction = "0" + fraction;
    // Strip training 0
    fraction = fraction.match(/^([0-9]*[1-9]|0)(0*)/)[1];
    const whole = value.div(multiplier).toString();
    if (multiplier.length === 1) value = whole;
    else value = whole + "." + fraction;
    if (negative) value = "-" + value;
    return value;
}
function $efb9ddd3e2b20828$export$1b039987e86d7269(value, decimals) {
    if (decimals == null) decimals = 0;
    const multiplier = $efb9ddd3e2b20828$var$getMultiplier(decimals);
    if (typeof value !== "string" || !value.match(/^-?[0-9.]+$/)) $efb9ddd3e2b20828$var$logger.throwArgumentError("invalid decimal value", "value", value);
    // Is it negative?
    const negative = value.substring(0, 1) === "-";
    if (negative) value = value.substring(1);
    if (value === ".") $efb9ddd3e2b20828$var$logger.throwArgumentError("missing value", "value", value);
    // Split it into a whole and fractional part
    const comps = value.split(".");
    if (comps.length > 2) $efb9ddd3e2b20828$var$logger.throwArgumentError("too many decimal points", "value", value);
    let whole = comps[0], fraction = comps[1];
    if (!whole) whole = "0";
    if (!fraction) fraction = "0";
    // Trim trailing zeros
    while(fraction[fraction.length - 1] === "0")fraction = fraction.substring(0, fraction.length - 1);
    // Check the fraction doesn't exceed our decimals size
    if (fraction.length > multiplier.length - 1) $efb9ddd3e2b20828$var$throwFault("fractional component exceeds decimals", "underflow", "parseFixed");
    // If decimals is 0, we have an empty string for fraction
    if (fraction === "") fraction = "0";
    // Fully pad the string with zeros to get to wei
    while(fraction.length < multiplier.length - 1)fraction += "0";
    const wholeValue = (0, $a87aa97415e1b917$export$d97aa349ed20696).from(whole);
    const fractionValue = (0, $a87aa97415e1b917$export$d97aa349ed20696).from(fraction);
    let wei = wholeValue.mul(multiplier).add(fractionValue);
    if (negative) wei = wei.mul($efb9ddd3e2b20828$var$NegativeOne);
    return wei;
}
class $efb9ddd3e2b20828$export$1f3ec5b8f47ebd4d {
    constructor(constructorGuard, signed, width, decimals){
        if (constructorGuard !== $efb9ddd3e2b20828$var$_constructorGuard) $efb9ddd3e2b20828$var$logger.throwError("cannot use FixedFormat constructor; use FixedFormat.from", (0, $5f596c9584f643ae$export$efa9a398d6368992).errors.UNSUPPORTED_OPERATION, {
            operation: "new FixedFormat"
        });
        this.signed = signed;
        this.width = width;
        this.decimals = decimals;
        this.name = (signed ? "" : "u") + "fixed" + String(width) + "x" + String(decimals);
        this._multiplier = $efb9ddd3e2b20828$var$getMultiplier(decimals);
        Object.freeze(this);
    }
    static from(value) {
        if (value instanceof $efb9ddd3e2b20828$export$1f3ec5b8f47ebd4d) return value;
        if (typeof value === "number") value = `fixed128x${value}`;
        let signed = true;
        let width = 128;
        let decimals = 18;
        if (typeof value === "string") {
            if (value === "fixed") ;
            else if (value === "ufixed") signed = false;
            else {
                const match = value.match(/^(u?)fixed([0-9]+)x([0-9]+)$/);
                if (!match) $efb9ddd3e2b20828$var$logger.throwArgumentError("invalid fixed format", "format", value);
                signed = match[1] !== "u";
                width = parseInt(match[2]);
                decimals = parseInt(match[3]);
            }
        } else if (value) {
            const check = (key, type, defaultValue)=>{
                if (value[key] == null) return defaultValue;
                if (typeof value[key] !== type) $efb9ddd3e2b20828$var$logger.throwArgumentError("invalid fixed format (" + key + " not " + type + ")", "format." + key, value[key]);
                return value[key];
            };
            signed = check("signed", "boolean", signed);
            width = check("width", "number", width);
            decimals = check("decimals", "number", decimals);
        }
        if (width % 8) $efb9ddd3e2b20828$var$logger.throwArgumentError("invalid fixed format width (not byte aligned)", "format.width", width);
        if (decimals > 80) $efb9ddd3e2b20828$var$logger.throwArgumentError("invalid fixed format (decimals too large)", "format.decimals", decimals);
        return new $efb9ddd3e2b20828$export$1f3ec5b8f47ebd4d($efb9ddd3e2b20828$var$_constructorGuard, signed, width, decimals);
    }
}
class $efb9ddd3e2b20828$export$d4693c66c2213e45 {
    constructor(constructorGuard, hex, value, format){
        if (constructorGuard !== $efb9ddd3e2b20828$var$_constructorGuard) $efb9ddd3e2b20828$var$logger.throwError("cannot use FixedNumber constructor; use FixedNumber.from", (0, $5f596c9584f643ae$export$efa9a398d6368992).errors.UNSUPPORTED_OPERATION, {
            operation: "new FixedFormat"
        });
        this.format = format;
        this._hex = hex;
        this._value = value;
        this._isFixedNumber = true;
        Object.freeze(this);
    }
    _checkFormat(other) {
        if (this.format.name !== other.format.name) $efb9ddd3e2b20828$var$logger.throwArgumentError("incompatible format; use fixedNumber.toFormat", "other", other);
    }
    addUnsafe(other) {
        this._checkFormat(other);
        const a = $efb9ddd3e2b20828$export$1b039987e86d7269(this._value, this.format.decimals);
        const b = $efb9ddd3e2b20828$export$1b039987e86d7269(other._value, other.format.decimals);
        return $efb9ddd3e2b20828$export$d4693c66c2213e45.fromValue(a.add(b), this.format.decimals, this.format);
    }
    subUnsafe(other) {
        this._checkFormat(other);
        const a = $efb9ddd3e2b20828$export$1b039987e86d7269(this._value, this.format.decimals);
        const b = $efb9ddd3e2b20828$export$1b039987e86d7269(other._value, other.format.decimals);
        return $efb9ddd3e2b20828$export$d4693c66c2213e45.fromValue(a.sub(b), this.format.decimals, this.format);
    }
    mulUnsafe(other) {
        this._checkFormat(other);
        const a = $efb9ddd3e2b20828$export$1b039987e86d7269(this._value, this.format.decimals);
        const b = $efb9ddd3e2b20828$export$1b039987e86d7269(other._value, other.format.decimals);
        return $efb9ddd3e2b20828$export$d4693c66c2213e45.fromValue(a.mul(b).div(this.format._multiplier), this.format.decimals, this.format);
    }
    divUnsafe(other) {
        this._checkFormat(other);
        const a = $efb9ddd3e2b20828$export$1b039987e86d7269(this._value, this.format.decimals);
        const b = $efb9ddd3e2b20828$export$1b039987e86d7269(other._value, other.format.decimals);
        return $efb9ddd3e2b20828$export$d4693c66c2213e45.fromValue(a.mul(this.format._multiplier).div(b), this.format.decimals, this.format);
    }
    floor() {
        const comps = this.toString().split(".");
        if (comps.length === 1) comps.push("0");
        let result = $efb9ddd3e2b20828$export$d4693c66c2213e45.from(comps[0], this.format);
        const hasFraction = !comps[1].match(/^(0*)$/);
        if (this.isNegative() && hasFraction) result = result.subUnsafe($efb9ddd3e2b20828$var$ONE.toFormat(result.format));
        return result;
    }
    ceiling() {
        const comps = this.toString().split(".");
        if (comps.length === 1) comps.push("0");
        let result = $efb9ddd3e2b20828$export$d4693c66c2213e45.from(comps[0], this.format);
        const hasFraction = !comps[1].match(/^(0*)$/);
        if (!this.isNegative() && hasFraction) result = result.addUnsafe($efb9ddd3e2b20828$var$ONE.toFormat(result.format));
        return result;
    }
    // @TODO: Support other rounding algorithms
    round(decimals) {
        if (decimals == null) decimals = 0;
        // If we are already in range, we're done
        const comps = this.toString().split(".");
        if (comps.length === 1) comps.push("0");
        if (decimals < 0 || decimals > 80 || decimals % 1) $efb9ddd3e2b20828$var$logger.throwArgumentError("invalid decimal count", "decimals", decimals);
        if (comps[1].length <= decimals) return this;
        const factor = $efb9ddd3e2b20828$export$d4693c66c2213e45.from("1" + $efb9ddd3e2b20828$var$zeros.substring(0, decimals), this.format);
        const bump = $efb9ddd3e2b20828$var$BUMP.toFormat(this.format);
        return this.mulUnsafe(factor).addUnsafe(bump).floor().divUnsafe(factor);
    }
    isZero() {
        return this._value === "0.0" || this._value === "0";
    }
    isNegative() {
        return this._value[0] === "-";
    }
    toString() {
        return this._value;
    }
    toHexString(width) {
        if (width == null) return this._hex;
        if (width % 8) $efb9ddd3e2b20828$var$logger.throwArgumentError("invalid byte width", "width", width);
        const hex = (0, $a87aa97415e1b917$export$d97aa349ed20696).from(this._hex).fromTwos(this.format.width).toTwos(width).toHexString();
        return (0, $06d75ae17ce69367$export$e9c46a54370b47e8)(hex, width / 8);
    }
    toUnsafeFloat() {
        return parseFloat(this.toString());
    }
    toFormat(format) {
        return $efb9ddd3e2b20828$export$d4693c66c2213e45.fromString(this._value, format);
    }
    static fromValue(value, decimals, format) {
        // If decimals looks more like a format, and there is no format, shift the parameters
        if (format == null && decimals != null && !(0, $a87aa97415e1b917$export$a3d0a7fa9b65683b)(decimals)) {
            format = decimals;
            decimals = null;
        }
        if (decimals == null) decimals = 0;
        if (format == null) format = "fixed";
        return $efb9ddd3e2b20828$export$d4693c66c2213e45.fromString($efb9ddd3e2b20828$export$cc011b843b5d69f2(value, decimals), $efb9ddd3e2b20828$export$1f3ec5b8f47ebd4d.from(format));
    }
    static fromString(value, format) {
        if (format == null) format = "fixed";
        const fixedFormat = $efb9ddd3e2b20828$export$1f3ec5b8f47ebd4d.from(format);
        const numeric = $efb9ddd3e2b20828$export$1b039987e86d7269(value, fixedFormat.decimals);
        if (!fixedFormat.signed && numeric.lt($efb9ddd3e2b20828$var$Zero)) $efb9ddd3e2b20828$var$throwFault("unsigned value cannot be negative", "overflow", "value", value);
        let hex = null;
        if (fixedFormat.signed) hex = numeric.toTwos(fixedFormat.width).toHexString();
        else {
            hex = numeric.toHexString();
            hex = (0, $06d75ae17ce69367$export$e9c46a54370b47e8)(hex, fixedFormat.width / 8);
        }
        const decimal = $efb9ddd3e2b20828$export$cc011b843b5d69f2(numeric, fixedFormat.decimals);
        return new $efb9ddd3e2b20828$export$d4693c66c2213e45($efb9ddd3e2b20828$var$_constructorGuard, hex, decimal, fixedFormat);
    }
    static fromBytes(value, format) {
        if (format == null) format = "fixed";
        const fixedFormat = $efb9ddd3e2b20828$export$1f3ec5b8f47ebd4d.from(format);
        if ((0, $06d75ae17ce69367$export$3131421a7d01b4fb)(value).length > fixedFormat.width / 8) throw new Error("overflow");
        let numeric = (0, $a87aa97415e1b917$export$d97aa349ed20696).from(value);
        if (fixedFormat.signed) numeric = numeric.fromTwos(fixedFormat.width);
        const hex = numeric.toTwos((fixedFormat.signed ? 0 : 1) + fixedFormat.width).toHexString();
        const decimal = $efb9ddd3e2b20828$export$cc011b843b5d69f2(numeric, fixedFormat.decimals);
        return new $efb9ddd3e2b20828$export$d4693c66c2213e45($efb9ddd3e2b20828$var$_constructorGuard, hex, decimal, fixedFormat);
    }
    static from(value, format) {
        if (typeof value === "string") return $efb9ddd3e2b20828$export$d4693c66c2213e45.fromString(value, format);
        if ((0, $06d75ae17ce69367$export$c6fabfbfd097fc30)(value)) return $efb9ddd3e2b20828$export$d4693c66c2213e45.fromBytes(value, format);
        try {
            return $efb9ddd3e2b20828$export$d4693c66c2213e45.fromValue(value, 0, format);
        } catch (error) {
            // Allow NUMERIC_FAULT to bubble up
            if (error.code !== (0, $5f596c9584f643ae$export$efa9a398d6368992).errors.INVALID_ARGUMENT) throw error;
        }
        return $efb9ddd3e2b20828$var$logger.throwArgumentError("invalid FixedNumber value", "value", value);
    }
    static isFixedNumber(value) {
        return !!(value && value._isFixedNumber);
    }
}
const $efb9ddd3e2b20828$var$ONE = $efb9ddd3e2b20828$export$d4693c66c2213e45.from(1);
const $efb9ddd3e2b20828$var$BUMP = $efb9ddd3e2b20828$export$d4693c66c2213e45.from("0.5");



var $cf67a8ebc5cb0c41$exports = {};

$parcel$export($cf67a8ebc5cb0c41$exports, "Wallet", function () { return $cf67a8ebc5cb0c41$export$bcca3ea514774656; });
$parcel$export($cf67a8ebc5cb0c41$exports, "verifyMessage", function () { return $cf67a8ebc5cb0c41$export$228d0e772cc158cb; });
$parcel$export($cf67a8ebc5cb0c41$exports, "verifyTypedData", function () { return $cf67a8ebc5cb0c41$export$3603b1c1bcd76798; });







const $4fe8b24c78e33d56$export$1ff3fdc4802a2ba6 = "\x19Ethereum Signed Message:\n";
function $4fe8b24c78e33d56$export$d4c241cec96564c1(message) {
    if (typeof message === "string") message = (0, $7bbf1261c840221b$export$8feeb310b4b4752f)(message);
    return (0, $62e3396d458230e9$export$f8151fce47ad1c35)((0, $06d75ae17ce69367$export$ee1b3e54f0441b22)([
        (0, $7bbf1261c840221b$export$8feeb310b4b4752f)($4fe8b24c78e33d56$export$1ff3fdc4802a2ba6),
        (0, $7bbf1261c840221b$export$8feeb310b4b4752f)(String(message.length)),
        message
    ]));
}








"use strict";
function $529cc323d557cae2$export$448fa22aedc9dbca(password, salt, iterations, keylen, hashAlgorithm) {
    password = (0, $06d75ae17ce69367$export$3131421a7d01b4fb)(password);
    salt = (0, $06d75ae17ce69367$export$3131421a7d01b4fb)(salt);
    let hLen;
    let l = 1;
    const DK = new Uint8Array(keylen);
    const block1 = new Uint8Array(salt.length + 4);
    block1.set(salt);
    //salt.copy(block1, 0, 0, salt.length)
    let r;
    let T;
    for(let i = 1; i <= l; i++){
        //block1.writeUInt32BE(i, salt.length)
        block1[salt.length] = i >> 24 & 0xff;
        block1[salt.length + 1] = i >> 16 & 0xff;
        block1[salt.length + 2] = i >> 8 & 0xff;
        block1[salt.length + 3] = i & 0xff;
        //let U = createHmac(password).update(block1).digest();
        let U = (0, $06d75ae17ce69367$export$3131421a7d01b4fb)((0, $ad6b4320c60d6c47$export$967075d2f3b8e7ff)(hashAlgorithm, password, block1));
        if (!hLen) {
            hLen = U.length;
            T = new Uint8Array(hLen);
            l = Math.ceil(keylen / hLen);
            r = keylen - (l - 1) * hLen;
        }
        //U.copy(T, 0, 0, hLen)
        T.set(U);
        for(let j = 1; j < iterations; j++){
            //U = createHmac(password).update(U).digest();
            U = (0, $06d75ae17ce69367$export$3131421a7d01b4fb)((0, $ad6b4320c60d6c47$export$967075d2f3b8e7ff)(hashAlgorithm, password, U));
            for(let k = 0; k < hLen; k++)T[k] ^= U[k];
        }
        const destPos = (i - 1) * hLen;
        const len = i === l ? r : hLen;
        //T.copy(DK, destPos, 0, len)
        DK.set((0, $06d75ae17ce69367$export$3131421a7d01b4fb)(T).slice(0, len), destPos);
    }
    return (0, $06d75ae17ce69367$export$2b0d6b5fbe698c70)(DK);
}









const $b0ba70eb749ee0f3$export$83d89fbfd8236492 = "wordlists/5.7.0";


"use strict";
// This gets overridden by rollup
const $1e5d872ea253eb5d$var$exportWordlist = false;
const $1e5d872ea253eb5d$export$af88d00dbe7f521 = new (0, $5f596c9584f643ae$export$efa9a398d6368992)((0, $b0ba70eb749ee0f3$export$83d89fbfd8236492));
class $1e5d872ea253eb5d$export$4d9531a8ddb0ebca {
    constructor(locale){
        $1e5d872ea253eb5d$export$af88d00dbe7f521.checkAbstract(new.target, $1e5d872ea253eb5d$export$4d9531a8ddb0ebca);
        (0, $d2d9b472f7878d5e$exports.defineReadOnly)(this, "locale", locale);
    }
    // Subclasses may override this
    split(mnemonic) {
        return mnemonic.toLowerCase().split(/ +/g);
    }
    // Subclasses may override this
    join(words) {
        return words.join(" ");
    }
    static check(wordlist) {
        const words = [];
        for(let i = 0; i < 2048; i++){
            const word = wordlist.getWord(i);
            /* istanbul ignore if */ if (i !== wordlist.getWordIndex(word)) return "0x";
            words.push(word);
        }
        return (0, $143d6d71aa960133$export$d560c7e4a29451c2)(words.join("\n") + "\n");
    }
    static register(lang, name) {
        if (!name) name = lang.locale;
        /* istanbul ignore if */ if ($1e5d872ea253eb5d$var$exportWordlist) try {
            const anyGlobal = window;
            if (anyGlobal._ethers && anyGlobal._ethers.wordlists) {
                if (!anyGlobal._ethers.wordlists[name]) (0, $d2d9b472f7878d5e$exports.defineReadOnly)(anyGlobal._ethers.wordlists, name, lang);
            }
        } catch (error) {}
    }
}


"use strict";
const $07616eb0958c2519$var$words = "AbandonAbilityAbleAboutAboveAbsentAbsorbAbstractAbsurdAbuseAccessAccidentAccountAccuseAchieveAcidAcousticAcquireAcrossActActionActorActressActualAdaptAddAddictAddressAdjustAdmitAdultAdvanceAdviceAerobicAffairAffordAfraidAgainAgeAgentAgreeAheadAimAirAirportAisleAlarmAlbumAlcoholAlertAlienAllAlleyAllowAlmostAloneAlphaAlreadyAlsoAlterAlwaysAmateurAmazingAmongAmountAmusedAnalystAnchorAncientAngerAngleAngryAnimalAnkleAnnounceAnnualAnotherAnswerAntennaAntiqueAnxietyAnyApartApologyAppearAppleApproveAprilArchArcticAreaArenaArgueArmArmedArmorArmyAroundArrangeArrestArriveArrowArtArtefactArtistArtworkAskAspectAssaultAssetAssistAssumeAsthmaAthleteAtomAttackAttendAttitudeAttractAuctionAuditAugustAuntAuthorAutoAutumnAverageAvocadoAvoidAwakeAwareAwayAwesomeAwfulAwkwardAxisBabyBachelorBaconBadgeBagBalanceBalconyBallBambooBananaBannerBarBarelyBargainBarrelBaseBasicBasketBattleBeachBeanBeautyBecauseBecomeBeefBeforeBeginBehaveBehindBelieveBelowBeltBenchBenefitBestBetrayBetterBetweenBeyondBicycleBidBikeBindBiologyBirdBirthBitterBlackBladeBlameBlanketBlastBleakBlessBlindBloodBlossomBlouseBlueBlurBlushBoardBoatBodyBoilBombBoneBonusBookBoostBorderBoringBorrowBossBottomBounceBoxBoyBracketBrainBrandBrassBraveBreadBreezeBrickBridgeBriefBrightBringBriskBroccoliBrokenBronzeBroomBrotherBrownBrushBubbleBuddyBudgetBuffaloBuildBulbBulkBulletBundleBunkerBurdenBurgerBurstBusBusinessBusyButterBuyerBuzzCabbageCabinCableCactusCageCakeCallCalmCameraCampCanCanalCancelCandyCannonCanoeCanvasCanyonCapableCapitalCaptainCarCarbonCardCargoCarpetCarryCartCaseCashCasinoCastleCasualCatCatalogCatchCategoryCattleCaughtCauseCautionCaveCeilingCeleryCementCensusCenturyCerealCertainChairChalkChampionChangeChaosChapterChargeChaseChatCheapCheckCheeseChefCherryChestChickenChiefChildChimneyChoiceChooseChronicChuckleChunkChurnCigarCinnamonCircleCitizenCityCivilClaimClapClarifyClawClayCleanClerkCleverClickClientCliffClimbClinicClipClockClogCloseClothCloudClownClubClumpClusterClutchCoachCoastCoconutCodeCoffeeCoilCoinCollectColorColumnCombineComeComfortComicCommonCompanyConcertConductConfirmCongressConnectConsiderControlConvinceCookCoolCopperCopyCoralCoreCornCorrectCostCottonCouchCountryCoupleCourseCousinCoverCoyoteCrackCradleCraftCramCraneCrashCraterCrawlCrazyCreamCreditCreekCrewCricketCrimeCrispCriticCropCrossCrouchCrowdCrucialCruelCruiseCrumbleCrunchCrushCryCrystalCubeCultureCupCupboardCuriousCurrentCurtainCurveCushionCustomCuteCycleDadDamageDampDanceDangerDaringDashDaughterDawnDayDealDebateDebrisDecadeDecemberDecideDeclineDecorateDecreaseDeerDefenseDefineDefyDegreeDelayDeliverDemandDemiseDenialDentistDenyDepartDependDepositDepthDeputyDeriveDescribeDesertDesignDeskDespairDestroyDetailDetectDevelopDeviceDevoteDiagramDialDiamondDiaryDiceDieselDietDifferDigitalDignityDilemmaDinnerDinosaurDirectDirtDisagreeDiscoverDiseaseDishDismissDisorderDisplayDistanceDivertDivideDivorceDizzyDoctorDocumentDogDollDolphinDomainDonateDonkeyDonorDoorDoseDoubleDoveDraftDragonDramaDrasticDrawDreamDressDriftDrillDrinkDripDriveDropDrumDryDuckDumbDuneDuringDustDutchDutyDwarfDynamicEagerEagleEarlyEarnEarthEasilyEastEasyEchoEcologyEconomyEdgeEditEducateEffortEggEightEitherElbowElderElectricElegantElementElephantElevatorEliteElseEmbarkEmbodyEmbraceEmergeEmotionEmployEmpowerEmptyEnableEnactEndEndlessEndorseEnemyEnergyEnforceEngageEngineEnhanceEnjoyEnlistEnoughEnrichEnrollEnsureEnterEntireEntryEnvelopeEpisodeEqualEquipEraEraseErodeErosionErrorEruptEscapeEssayEssenceEstateEternalEthicsEvidenceEvilEvokeEvolveExactExampleExcessExchangeExciteExcludeExcuseExecuteExerciseExhaustExhibitExileExistExitExoticExpandExpectExpireExplainExposeExpressExtendExtraEyeEyebrowFabricFaceFacultyFadeFaintFaithFallFalseFameFamilyFamousFanFancyFantasyFarmFashionFatFatalFatherFatigueFaultFavoriteFeatureFebruaryFederalFeeFeedFeelFemaleFenceFestivalFetchFeverFewFiberFictionFieldFigureFileFilmFilterFinalFindFineFingerFinishFireFirmFirstFiscalFishFitFitnessFixFlagFlameFlashFlatFlavorFleeFlightFlipFloatFlockFloorFlowerFluidFlushFlyFoamFocusFogFoilFoldFollowFoodFootForceForestForgetForkFortuneForumForwardFossilFosterFoundFoxFragileFrameFrequentFreshFriendFringeFrogFrontFrostFrownFrozenFruitFuelFunFunnyFurnaceFuryFutureGadgetGainGalaxyGalleryGameGapGarageGarbageGardenGarlicGarmentGasGaspGateGatherGaugeGazeGeneralGeniusGenreGentleGenuineGestureGhostGiantGiftGiggleGingerGiraffeGirlGiveGladGlanceGlareGlassGlideGlimpseGlobeGloomGloryGloveGlowGlueGoatGoddessGoldGoodGooseGorillaGospelGossipGovernGownGrabGraceGrainGrantGrapeGrassGravityGreatGreenGridGriefGritGroceryGroupGrowGruntGuardGuessGuideGuiltGuitarGunGymHabitHairHalfHammerHamsterHandHappyHarborHardHarshHarvestHatHaveHawkHazardHeadHealthHeartHeavyHedgehogHeightHelloHelmetHelpHenHeroHiddenHighHillHintHipHireHistoryHobbyHockeyHoldHoleHolidayHollowHomeHoneyHoodHopeHornHorrorHorseHospitalHostHotelHourHoverHubHugeHumanHumbleHumorHundredHungryHuntHurdleHurryHurtHusbandHybridIceIconIdeaIdentifyIdleIgnoreIllIllegalIllnessImageImitateImmenseImmuneImpactImposeImproveImpulseInchIncludeIncomeIncreaseIndexIndicateIndoorIndustryInfantInflictInformInhaleInheritInitialInjectInjuryInmateInnerInnocentInputInquiryInsaneInsectInsideInspireInstallIntactInterestIntoInvestInviteInvolveIronIslandIsolateIssueItemIvoryJacketJaguarJarJazzJealousJeansJellyJewelJobJoinJokeJourneyJoyJudgeJuiceJumpJungleJuniorJunkJustKangarooKeenKeepKetchupKeyKickKidKidneyKindKingdomKissKitKitchenKiteKittenKiwiKneeKnifeKnockKnowLabLabelLaborLadderLadyLakeLampLanguageLaptopLargeLaterLatinLaughLaundryLavaLawLawnLawsuitLayerLazyLeaderLeafLearnLeaveLectureLeftLegLegalLegendLeisureLemonLendLengthLensLeopardLessonLetterLevelLiarLibertyLibraryLicenseLifeLiftLightLikeLimbLimitLinkLionLiquidListLittleLiveLizardLoadLoanLobsterLocalLockLogicLonelyLongLoopLotteryLoudLoungeLoveLoyalLuckyLuggageLumberLunarLunchLuxuryLyricsMachineMadMagicMagnetMaidMailMainMajorMakeMammalManManageMandateMangoMansionManualMapleMarbleMarchMarginMarineMarketMarriageMaskMassMasterMatchMaterialMathMatrixMatterMaximumMazeMeadowMeanMeasureMeatMechanicMedalMediaMelodyMeltMemberMemoryMentionMenuMercyMergeMeritMerryMeshMessageMetalMethodMiddleMidnightMilkMillionMimicMindMinimumMinorMinuteMiracleMirrorMiseryMissMistakeMixMixedMixtureMobileModelModifyMomMomentMonitorMonkeyMonsterMonthMoonMoralMoreMorningMosquitoMotherMotionMotorMountainMouseMoveMovieMuchMuffinMuleMultiplyMuscleMuseumMushroomMusicMustMutualMyselfMysteryMythNaiveNameNapkinNarrowNastyNationNatureNearNeckNeedNegativeNeglectNeitherNephewNerveNestNetNetworkNeutralNeverNewsNextNiceNightNobleNoiseNomineeNoodleNormalNorthNoseNotableNoteNothingNoticeNovelNowNuclearNumberNurseNutOakObeyObjectObligeObscureObserveObtainObviousOccurOceanOctoberOdorOffOfferOfficeOftenOilOkayOldOliveOlympicOmitOnceOneOnionOnlineOnlyOpenOperaOpinionOpposeOptionOrangeOrbitOrchardOrderOrdinaryOrganOrientOriginalOrphanOstrichOtherOutdoorOuterOutputOutsideOvalOvenOverOwnOwnerOxygenOysterOzonePactPaddlePagePairPalacePalmPandaPanelPanicPantherPaperParadeParentParkParrotPartyPassPatchPathPatientPatrolPatternPausePavePaymentPeacePeanutPearPeasantPelicanPenPenaltyPencilPeoplePepperPerfectPermitPersonPetPhonePhotoPhrasePhysicalPianoPicnicPicturePiecePigPigeonPillPilotPinkPioneerPipePistolPitchPizzaPlacePlanetPlasticPlatePlayPleasePledgePluckPlugPlungePoemPoetPointPolarPolePolicePondPonyPoolPopularPortionPositionPossiblePostPotatoPotteryPovertyPowderPowerPracticePraisePredictPreferPreparePresentPrettyPreventPricePridePrimaryPrintPriorityPrisonPrivatePrizeProblemProcessProduceProfitProgramProjectPromoteProofPropertyProsperProtectProudProvidePublicPuddingPullPulpPulsePumpkinPunchPupilPuppyPurchasePurityPurposePursePushPutPuzzlePyramidQualityQuantumQuarterQuestionQuickQuitQuizQuoteRabbitRaccoonRaceRackRadarRadioRailRainRaiseRallyRampRanchRandomRangeRapidRareRateRatherRavenRawRazorReadyRealReasonRebelRebuildRecallReceiveRecipeRecordRecycleReduceReflectReformRefuseRegionRegretRegularRejectRelaxReleaseReliefRelyRemainRememberRemindRemoveRenderRenewRentReopenRepairRepeatReplaceReportRequireRescueResembleResistResourceResponseResultRetireRetreatReturnReunionRevealReviewRewardRhythmRibRibbonRiceRichRideRidgeRifleRightRigidRingRiotRippleRiskRitualRivalRiverRoadRoastRobotRobustRocketRomanceRoofRookieRoomRoseRotateRoughRoundRouteRoyalRubberRudeRugRuleRunRunwayRuralSadSaddleSadnessSafeSailSaladSalmonSalonSaltSaluteSameSampleSandSatisfySatoshiSauceSausageSaveSayScaleScanScareScatterSceneSchemeSchoolScienceScissorsScorpionScoutScrapScreenScriptScrubSeaSearchSeasonSeatSecondSecretSectionSecuritySeedSeekSegmentSelectSellSeminarSeniorSenseSentenceSeriesServiceSessionSettleSetupSevenShadowShaftShallowShareShedShellSheriffShieldShiftShineShipShiverShockShoeShootShopShortShoulderShoveShrimpShrugShuffleShySiblingSickSideSiegeSightSignSilentSilkSillySilverSimilarSimpleSinceSingSirenSisterSituateSixSizeSkateSketchSkiSkillSkinSkirtSkullSlabSlamSleepSlenderSliceSlideSlightSlimSloganSlotSlowSlushSmallSmartSmileSmokeSmoothSnackSnakeSnapSniffSnowSoapSoccerSocialSockSodaSoftSolarSoldierSolidSolutionSolveSomeoneSongSoonSorrySortSoulSoundSoupSourceSouthSpaceSpareSpatialSpawnSpeakSpecialSpeedSpellSpendSphereSpiceSpiderSpikeSpinSpiritSplitSpoilSponsorSpoonSportSpotSpraySpreadSpringSpySquareSqueezeSquirrelStableStadiumStaffStageStairsStampStandStartStateStaySteakSteelStemStepStereoStickStillStingStockStomachStoneStoolStoryStoveStrategyStreetStrikeStrongStruggleStudentStuffStumbleStyleSubjectSubmitSubwaySuccessSuchSuddenSufferSugarSuggestSuitSummerSunSunnySunsetSuperSupplySupremeSureSurfaceSurgeSurpriseSurroundSurveySuspectSustainSwallowSwampSwapSwarmSwearSweetSwiftSwimSwingSwitchSwordSymbolSymptomSyrupSystemTableTackleTagTailTalentTalkTankTapeTargetTaskTasteTattooTaxiTeachTeamTellTenTenantTennisTentTermTestTextThankThatThemeThenTheoryThereTheyThingThisThoughtThreeThriveThrowThumbThunderTicketTideTigerTiltTimberTimeTinyTipTiredTissueTitleToastTobaccoTodayToddlerToeTogetherToiletTokenTomatoTomorrowToneTongueTonightToolToothTopTopicToppleTorchTornadoTortoiseTossTotalTouristTowardTowerTownToyTrackTradeTrafficTragicTrainTransferTrapTrashTravelTrayTreatTreeTrendTrialTribeTrickTriggerTrimTripTrophyTroubleTruckTrueTrulyTrumpetTrustTruthTryTubeTuitionTumbleTunaTunnelTurkeyTurnTurtleTwelveTwentyTwiceTwinTwistTwoTypeTypicalUglyUmbrellaUnableUnawareUncleUncoverUnderUndoUnfairUnfoldUnhappyUniformUniqueUnitUniverseUnknownUnlockUntilUnusualUnveilUpdateUpgradeUpholdUponUpperUpsetUrbanUrgeUsageUseUsedUsefulUselessUsualUtilityVacantVacuumVagueValidValleyValveVanVanishVaporVariousVastVaultVehicleVelvetVendorVentureVenueVerbVerifyVersionVeryVesselVeteranViableVibrantViciousVictoryVideoViewVillageVintageViolinVirtualVirusVisaVisitVisualVitalVividVocalVoiceVoidVolcanoVolumeVoteVoyageWageWagonWaitWalkWallWalnutWantWarfareWarmWarriorWashWaspWasteWaterWaveWayWealthWeaponWearWeaselWeatherWebWeddingWeekendWeirdWelcomeWestWetWhaleWhatWheatWheelWhenWhereWhipWhisperWideWidthWifeWildWillWinWindowWineWingWinkWinnerWinterWireWisdomWiseWishWitnessWolfWomanWonderWoodWoolWordWorkWorldWorryWorthWrapWreckWrestleWristWriteWrongYardYearYellowYouYoungYouthZebraZeroZoneZoo";
let $07616eb0958c2519$var$wordlist = null;
function $07616eb0958c2519$var$loadWords(lang) {
    if ($07616eb0958c2519$var$wordlist != null) return;
    $07616eb0958c2519$var$wordlist = $07616eb0958c2519$var$words.replace(/([A-Z])/g, " $1").toLowerCase().substring(1).split(" ");
    // Verify the computed list matches the official list
    /* istanbul ignore if */ if ((0, $1e5d872ea253eb5d$export$4d9531a8ddb0ebca).check(lang) !== "0x3c8acc1e7b08d8e76f9fda015ef48dc8c710a73cb7e0f77b2c18a9b5a7adde60") {
        $07616eb0958c2519$var$wordlist = null;
        throw new Error("BIP39 Wordlist for en (English) FAILED");
    }
}
class $07616eb0958c2519$var$LangEn extends (0, $1e5d872ea253eb5d$export$4d9531a8ddb0ebca) {
    constructor(){
        super("en");
    }
    getWord(index) {
        $07616eb0958c2519$var$loadWords(this);
        return $07616eb0958c2519$var$wordlist[index];
    }
    getWordIndex(word) {
        $07616eb0958c2519$var$loadWords(this);
        return $07616eb0958c2519$var$wordlist.indexOf(word);
    }
}
const $07616eb0958c2519$export$a2c9518710cf1f49 = new $07616eb0958c2519$var$LangEn();
(0, $1e5d872ea253eb5d$export$4d9531a8ddb0ebca).register($07616eb0958c2519$export$a2c9518710cf1f49);


"use strict";
const $0c19009e3fcf898f$export$e8e1b4711c2d1939 = {
    en: (0, $07616eb0958c2519$export$a2c9518710cf1f49)
};



const $6e6602507bcb9673$export$83d89fbfd8236492 = "hdnode/5.7.0";


"use strict";
const $2c3deea0882bd090$var$logger = new (0, $5f596c9584f643ae$export$efa9a398d6368992)((0, $6e6602507bcb9673$export$83d89fbfd8236492));
const $2c3deea0882bd090$var$N = (0, $a87aa97415e1b917$export$d97aa349ed20696).from("0xfffffffffffffffffffffffffffffffebaaedce6af48a03bbfd25e8cd0364141");
// "Bitcoin seed"
const $2c3deea0882bd090$var$MasterSecret = (0, $7bbf1261c840221b$export$8feeb310b4b4752f)("Bitcoin seed");
const $2c3deea0882bd090$var$HardenedBit = 0x80000000;
// Returns a byte with the MSB bits set
function $2c3deea0882bd090$var$getUpperMask(bits) {
    return (1 << bits) - 1 << 8 - bits;
}
// Returns a byte with the LSB bits set
function $2c3deea0882bd090$var$getLowerMask(bits) {
    return (1 << bits) - 1;
}
function $2c3deea0882bd090$var$bytes32(value) {
    return (0, $06d75ae17ce69367$export$e9c46a54370b47e8)((0, $06d75ae17ce69367$export$2b0d6b5fbe698c70)(value), 32);
}
function $2c3deea0882bd090$var$base58check(data) {
    return (0, $4f9292cbf9a48447$export$45a587635c9954b2).encode((0, $06d75ae17ce69367$export$ee1b3e54f0441b22)([
        data,
        (0, $06d75ae17ce69367$export$15da666eba198c18)((0, $ad6b4320c60d6c47$export$bced8d2aada2d1c9)((0, $ad6b4320c60d6c47$export$bced8d2aada2d1c9)(data)), 0, 4)
    ]));
}
function $2c3deea0882bd090$var$getWordlist(wordlist) {
    if (wordlist == null) return (0, $0c19009e3fcf898f$export$e8e1b4711c2d1939)["en"];
    if (typeof wordlist === "string") {
        const words = (0, $0c19009e3fcf898f$export$e8e1b4711c2d1939)[wordlist];
        if (words == null) $2c3deea0882bd090$var$logger.throwArgumentError("unknown locale", "wordlist", wordlist);
        return words;
    }
    return wordlist;
}
const $2c3deea0882bd090$var$_constructorGuard = {};
const $2c3deea0882bd090$export$d48ad89f7e11a603 = "m/44'/60'/0'/0/0";
class $2c3deea0882bd090$export$b68640c53e22b952 {
    /**
     *  This constructor should not be called directly.
     *
     *  Please use:
     *   - fromMnemonic
     *   - fromSeed
     */ constructor(constructorGuard, privateKey, publicKey, parentFingerprint, chainCode, index, depth, mnemonicOrPath){
        /* istanbul ignore if */ if (constructorGuard !== $2c3deea0882bd090$var$_constructorGuard) throw new Error("HDNode constructor cannot be called directly");
        if (privateKey) {
            const signingKey = new (0, $49ebbfa7c2be841e$export$21643ca94aed3e83)(privateKey);
            (0, $d2d9b472f7878d5e$exports.defineReadOnly)(this, "privateKey", signingKey.privateKey);
            (0, $d2d9b472f7878d5e$exports.defineReadOnly)(this, "publicKey", signingKey.compressedPublicKey);
        } else {
            (0, $d2d9b472f7878d5e$exports.defineReadOnly)(this, "privateKey", null);
            (0, $d2d9b472f7878d5e$exports.defineReadOnly)(this, "publicKey", (0, $06d75ae17ce69367$export$2b0d6b5fbe698c70)(publicKey));
        }
        (0, $d2d9b472f7878d5e$exports.defineReadOnly)(this, "parentFingerprint", parentFingerprint);
        (0, $d2d9b472f7878d5e$exports.defineReadOnly)(this, "fingerprint", (0, $06d75ae17ce69367$export$15da666eba198c18)((0, $ad6b4320c60d6c47$export$d1cea0ee4e3f0d3e)((0, $ad6b4320c60d6c47$export$bced8d2aada2d1c9)(this.publicKey)), 0, 4));
        (0, $d2d9b472f7878d5e$exports.defineReadOnly)(this, "address", (0, $4335107f861a4482$export$e67e2732ba9803f9)(this.publicKey));
        (0, $d2d9b472f7878d5e$exports.defineReadOnly)(this, "chainCode", chainCode);
        (0, $d2d9b472f7878d5e$exports.defineReadOnly)(this, "index", index);
        (0, $d2d9b472f7878d5e$exports.defineReadOnly)(this, "depth", depth);
        if (mnemonicOrPath == null) {
            // From a source that does not preserve the path (e.g. extended keys)
            (0, $d2d9b472f7878d5e$exports.defineReadOnly)(this, "mnemonic", null);
            (0, $d2d9b472f7878d5e$exports.defineReadOnly)(this, "path", null);
        } else if (typeof mnemonicOrPath === "string") {
            // From a source that does not preserve the mnemonic (e.g. neutered)
            (0, $d2d9b472f7878d5e$exports.defineReadOnly)(this, "mnemonic", null);
            (0, $d2d9b472f7878d5e$exports.defineReadOnly)(this, "path", mnemonicOrPath);
        } else {
            // From a fully qualified source
            (0, $d2d9b472f7878d5e$exports.defineReadOnly)(this, "mnemonic", mnemonicOrPath);
            (0, $d2d9b472f7878d5e$exports.defineReadOnly)(this, "path", mnemonicOrPath.path);
        }
    }
    get extendedKey() {
        // We only support the mainnet values for now, but if anyone needs
        // testnet values, let me know. I believe current sentiment is that
        // we should always use mainnet, and use BIP-44 to derive the network
        //   - Mainnet: public=0x0488B21E, private=0x0488ADE4
        //   - Testnet: public=0x043587CF, private=0x04358394
        if (this.depth >= 256) throw new Error("Depth too large!");
        return $2c3deea0882bd090$var$base58check((0, $06d75ae17ce69367$export$ee1b3e54f0441b22)([
            this.privateKey != null ? "0x0488ADE4" : "0x0488B21E",
            (0, $06d75ae17ce69367$export$2b0d6b5fbe698c70)(this.depth),
            this.parentFingerprint,
            (0, $06d75ae17ce69367$export$e9c46a54370b47e8)((0, $06d75ae17ce69367$export$2b0d6b5fbe698c70)(this.index), 4),
            this.chainCode,
            this.privateKey != null ? (0, $06d75ae17ce69367$export$ee1b3e54f0441b22)([
                "0x00",
                this.privateKey
            ]) : this.publicKey
        ]));
    }
    neuter() {
        return new $2c3deea0882bd090$export$b68640c53e22b952($2c3deea0882bd090$var$_constructorGuard, null, this.publicKey, this.parentFingerprint, this.chainCode, this.index, this.depth, this.path);
    }
    _derive(index) {
        if (index > 0xffffffff) throw new Error("invalid index - " + String(index));
        // Base path
        let path = this.path;
        if (path) path += "/" + (index & ~$2c3deea0882bd090$var$HardenedBit);
        const data = new Uint8Array(37);
        if (index & $2c3deea0882bd090$var$HardenedBit) {
            if (!this.privateKey) throw new Error("cannot derive child of neutered node");
            // Data = 0x00 || ser_256(k_par)
            data.set((0, $06d75ae17ce69367$export$3131421a7d01b4fb)(this.privateKey), 1);
            // Hardened path
            if (path) path += "'";
        } else // Data = ser_p(point(k_par))
        data.set((0, $06d75ae17ce69367$export$3131421a7d01b4fb)(this.publicKey));
        // Data += ser_32(i)
        for(let i = 24; i >= 0; i -= 8)data[33 + (i >> 3)] = index >> 24 - i & 0xff;
        const I = (0, $06d75ae17ce69367$export$3131421a7d01b4fb)((0, $ad6b4320c60d6c47$export$967075d2f3b8e7ff)((0, $c4af312545dae30d$export$d2a8849cfb277c).sha512, this.chainCode, data));
        const IL = I.slice(0, 32);
        const IR = I.slice(32);
        // The private key
        let ki = null;
        // The public key
        let Ki = null;
        if (this.privateKey) ki = $2c3deea0882bd090$var$bytes32((0, $a87aa97415e1b917$export$d97aa349ed20696).from(IL).add(this.privateKey).mod($2c3deea0882bd090$var$N));
        else {
            const ek = new (0, $49ebbfa7c2be841e$export$21643ca94aed3e83)((0, $06d75ae17ce69367$export$2b0d6b5fbe698c70)(IL));
            Ki = ek._addPoint(this.publicKey);
        }
        let mnemonicOrPath = path;
        const srcMnemonic = this.mnemonic;
        if (srcMnemonic) mnemonicOrPath = Object.freeze({
            phrase: srcMnemonic.phrase,
            path: path,
            locale: srcMnemonic.locale || "en"
        });
        return new $2c3deea0882bd090$export$b68640c53e22b952($2c3deea0882bd090$var$_constructorGuard, ki, Ki, this.fingerprint, $2c3deea0882bd090$var$bytes32(IR), index, this.depth + 1, mnemonicOrPath);
    }
    derivePath(path) {
        const components = path.split("/");
        if (components.length === 0 || components[0] === "m" && this.depth !== 0) throw new Error("invalid path - " + path);
        if (components[0] === "m") components.shift();
        let result = this;
        for(let i = 0; i < components.length; i++){
            const component = components[i];
            if (component.match(/^[0-9]+'$/)) {
                const index = parseInt(component.substring(0, component.length - 1));
                if (index >= $2c3deea0882bd090$var$HardenedBit) throw new Error("invalid path index - " + component);
                result = result._derive($2c3deea0882bd090$var$HardenedBit + index);
            } else if (component.match(/^[0-9]+$/)) {
                const index = parseInt(component);
                if (index >= $2c3deea0882bd090$var$HardenedBit) throw new Error("invalid path index - " + component);
                result = result._derive(index);
            } else throw new Error("invalid path component - " + component);
        }
        return result;
    }
    static _fromSeed(seed, mnemonic) {
        const seedArray = (0, $06d75ae17ce69367$export$3131421a7d01b4fb)(seed);
        if (seedArray.length < 16 || seedArray.length > 64) throw new Error("invalid seed");
        const I = (0, $06d75ae17ce69367$export$3131421a7d01b4fb)((0, $ad6b4320c60d6c47$export$967075d2f3b8e7ff)((0, $c4af312545dae30d$export$d2a8849cfb277c).sha512, $2c3deea0882bd090$var$MasterSecret, seedArray));
        return new $2c3deea0882bd090$export$b68640c53e22b952($2c3deea0882bd090$var$_constructorGuard, $2c3deea0882bd090$var$bytes32(I.slice(0, 32)), null, "0x00000000", $2c3deea0882bd090$var$bytes32(I.slice(32)), 0, 0, mnemonic);
    }
    static fromMnemonic(mnemonic, password, wordlist) {
        // If a locale name was passed in, find the associated wordlist
        wordlist = $2c3deea0882bd090$var$getWordlist(wordlist);
        // Normalize the case and spacing in the mnemonic (throws if the mnemonic is invalid)
        mnemonic = $2c3deea0882bd090$export$4becd65eb23312e6($2c3deea0882bd090$export$135e090d58b310ca(mnemonic, wordlist), wordlist);
        return $2c3deea0882bd090$export$b68640c53e22b952._fromSeed($2c3deea0882bd090$export$3dee74f1204ab09f(mnemonic, password), {
            phrase: mnemonic,
            path: "m",
            locale: wordlist.locale
        });
    }
    static fromSeed(seed) {
        return $2c3deea0882bd090$export$b68640c53e22b952._fromSeed(seed, null);
    }
    static fromExtendedKey(extendedKey) {
        const bytes = (0, $4f9292cbf9a48447$export$45a587635c9954b2).decode(extendedKey);
        if (bytes.length !== 82 || $2c3deea0882bd090$var$base58check(bytes.slice(0, 78)) !== extendedKey) $2c3deea0882bd090$var$logger.throwArgumentError("invalid extended key", "extendedKey", "[REDACTED]");
        const depth = bytes[4];
        const parentFingerprint = (0, $06d75ae17ce69367$export$2b0d6b5fbe698c70)(bytes.slice(5, 9));
        const index = parseInt((0, $06d75ae17ce69367$export$2b0d6b5fbe698c70)(bytes.slice(9, 13)).substring(2), 16);
        const chainCode = (0, $06d75ae17ce69367$export$2b0d6b5fbe698c70)(bytes.slice(13, 45));
        const key = bytes.slice(45, 78);
        switch((0, $06d75ae17ce69367$export$2b0d6b5fbe698c70)(bytes.slice(0, 4))){
            // Public Key
            case "0x0488b21e":
            case "0x043587cf":
                return new $2c3deea0882bd090$export$b68640c53e22b952($2c3deea0882bd090$var$_constructorGuard, null, (0, $06d75ae17ce69367$export$2b0d6b5fbe698c70)(key), parentFingerprint, chainCode, index, depth, null);
            // Private Key
            case "0x0488ade4":
            case "0x04358394 ":
                if (key[0] !== 0) break;
                return new $2c3deea0882bd090$export$b68640c53e22b952($2c3deea0882bd090$var$_constructorGuard, (0, $06d75ae17ce69367$export$2b0d6b5fbe698c70)(key.slice(1)), null, parentFingerprint, chainCode, index, depth, null);
        }
        return $2c3deea0882bd090$var$logger.throwArgumentError("invalid extended key", "extendedKey", "[REDACTED]");
    }
}
function $2c3deea0882bd090$export$3dee74f1204ab09f(mnemonic, password) {
    if (!password) password = "";
    const salt = (0, $7bbf1261c840221b$export$8feeb310b4b4752f)("mnemonic" + password, (0, $7bbf1261c840221b$export$c6986442964129f5).NFKD);
    return (0, $529cc323d557cae2$export$448fa22aedc9dbca)((0, $7bbf1261c840221b$export$8feeb310b4b4752f)(mnemonic, (0, $7bbf1261c840221b$export$c6986442964129f5).NFKD), salt, 2048, 64, "sha512");
}
function $2c3deea0882bd090$export$135e090d58b310ca(mnemonic, wordlist) {
    wordlist = $2c3deea0882bd090$var$getWordlist(wordlist);
    $2c3deea0882bd090$var$logger.checkNormalize();
    const words = wordlist.split(mnemonic);
    if (words.length % 3 !== 0) throw new Error("invalid mnemonic");
    const entropy = (0, $06d75ae17ce69367$export$3131421a7d01b4fb)(new Uint8Array(Math.ceil(11 * words.length / 8)));
    let offset = 0;
    for(let i = 0; i < words.length; i++){
        let index = wordlist.getWordIndex(words[i].normalize("NFKD"));
        if (index === -1) throw new Error("invalid mnemonic");
        for(let bit = 0; bit < 11; bit++){
            if (index & 1 << 10 - bit) entropy[offset >> 3] |= 1 << 7 - offset % 8;
            offset++;
        }
    }
    const entropyBits = 32 * words.length / 3;
    const checksumBits = words.length / 3;
    const checksumMask = $2c3deea0882bd090$var$getUpperMask(checksumBits);
    const checksum = (0, $06d75ae17ce69367$export$3131421a7d01b4fb)((0, $ad6b4320c60d6c47$export$bced8d2aada2d1c9)(entropy.slice(0, entropyBits / 8)))[0] & checksumMask;
    if (checksum !== (entropy[entropy.length - 1] & checksumMask)) throw new Error("invalid checksum");
    return (0, $06d75ae17ce69367$export$2b0d6b5fbe698c70)(entropy.slice(0, entropyBits / 8));
}
function $2c3deea0882bd090$export$4becd65eb23312e6(entropy, wordlist) {
    wordlist = $2c3deea0882bd090$var$getWordlist(wordlist);
    entropy = (0, $06d75ae17ce69367$export$3131421a7d01b4fb)(entropy);
    if (entropy.length % 4 !== 0 || entropy.length < 16 || entropy.length > 32) throw new Error("invalid entropy");
    const indices = [
        0
    ];
    let remainingBits = 11;
    for(let i = 0; i < entropy.length; i++)// Consume the whole byte (with still more to go)
    if (remainingBits > 8) {
        indices[indices.length - 1] <<= 8;
        indices[indices.length - 1] |= entropy[i];
        remainingBits -= 8;
    // This byte will complete an 11-bit index
    } else {
        indices[indices.length - 1] <<= remainingBits;
        indices[indices.length - 1] |= entropy[i] >> 8 - remainingBits;
        // Start the next word
        indices.push(entropy[i] & $2c3deea0882bd090$var$getLowerMask(8 - remainingBits));
        remainingBits += 3;
    }
    // Compute the checksum bits
    const checksumBits = entropy.length / 4;
    const checksum = (0, $06d75ae17ce69367$export$3131421a7d01b4fb)((0, $ad6b4320c60d6c47$export$bced8d2aada2d1c9)(entropy))[0] & $2c3deea0882bd090$var$getUpperMask(checksumBits);
    // Shift the checksum into the word indices
    indices[indices.length - 1] <<= checksumBits;
    indices[indices.length - 1] |= checksum >> 8 - checksumBits;
    return wordlist.join(indices.map((index)=>wordlist.getWord(index)));
}
function $2c3deea0882bd090$export$5eea3393c6119c80(mnemonic, wordlist) {
    try {
        $2c3deea0882bd090$export$135e090d58b310ca(mnemonic, wordlist);
        return true;
    } catch (error) {}
    return false;
}
function $2c3deea0882bd090$export$22b80e4f9eff636d(index) {
    if (typeof index !== "number" || index < 0 || index >= $2c3deea0882bd090$var$HardenedBit || index % 1) $2c3deea0882bd090$var$logger.throwArgumentError("invalid account index", "index", index);
    return `m/44'/60'/${index}'/0/0`;
}






const $b681964b2c6f088d$export$83d89fbfd8236492 = "random/5.7.0";


"use strict";
const $0a998708283ccc39$var$logger = new (0, $5f596c9584f643ae$export$efa9a398d6368992)((0, $b681964b2c6f088d$export$83d89fbfd8236492));
// Debugging line for testing browser lib in node
//const window = { crypto: { getRandomValues: () => { } } };
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/globalThis
function $0a998708283ccc39$var$getGlobal() {
    if (typeof self !== "undefined") return self;
    if (typeof window !== "undefined") return window;
    if (typeof $parcel$global !== "undefined") return $parcel$global;
    throw new Error("unable to locate global object");
}
const $0a998708283ccc39$var$anyGlobal = $0a998708283ccc39$var$getGlobal();
let $0a998708283ccc39$var$crypto = $0a998708283ccc39$var$anyGlobal.crypto || $0a998708283ccc39$var$anyGlobal.msCrypto;
if (!$0a998708283ccc39$var$crypto || !$0a998708283ccc39$var$crypto.getRandomValues) {
    $0a998708283ccc39$var$logger.warn("WARNING: Missing strong random number source");
    $0a998708283ccc39$var$crypto = {
        getRandomValues: function(buffer) {
            return $0a998708283ccc39$var$logger.throwError("no secure random source avaialble", (0, $5f596c9584f643ae$export$efa9a398d6368992).errors.UNSUPPORTED_OPERATION, {
                operation: "crypto.getRandomValues"
            });
        }
    };
}
function $0a998708283ccc39$export$5f828d93ff035aa8(length) {
    if (length <= 0 || length > 1024 || length % 1 || length != length) $0a998708283ccc39$var$logger.throwArgumentError("invalid length", "length", length);
    const result = new Uint8Array(length);
    $0a998708283ccc39$var$crypto.getRandomValues(result);
    return (0, $06d75ae17ce69367$export$3131421a7d01b4fb)(result);
}



var $3218055eb97e4543$exports = {};
"use strict";
(function(root) {
    function checkInt(value) {
        return parseInt(value) === value;
    }
    function checkInts(arrayish) {
        if (!checkInt(arrayish.length)) return false;
        for(var i = 0; i < arrayish.length; i++){
            if (!checkInt(arrayish[i]) || arrayish[i] < 0 || arrayish[i] > 255) return false;
        }
        return true;
    }
    function coerceArray(arg, copy) {
        // ArrayBuffer view
        if (arg.buffer && ArrayBuffer.isView(arg) && arg.name === "Uint8Array") {
            if (copy) {
                if (arg.slice) arg = arg.slice();
                else arg = Array.prototype.slice.call(arg);
            }
            return arg;
        }
        // It's an array; check it is a valid representation of a byte
        if (Array.isArray(arg)) {
            if (!checkInts(arg)) throw new Error("Array contains invalid value: " + arg);
            return new Uint8Array(arg);
        }
        // Something else, but behaves like an array (maybe a Buffer? Arguments?)
        if (checkInt(arg.length) && checkInts(arg)) return new Uint8Array(arg);
        throw new Error("unsupported array-like object");
    }
    function createArray(length) {
        return new Uint8Array(length);
    }
    function copyArray(sourceArray, targetArray, targetStart, sourceStart, sourceEnd) {
        if (sourceStart != null || sourceEnd != null) {
            if (sourceArray.slice) sourceArray = sourceArray.slice(sourceStart, sourceEnd);
            else sourceArray = Array.prototype.slice.call(sourceArray, sourceStart, sourceEnd);
        }
        targetArray.set(sourceArray, targetStart);
    }
    var convertUtf8 = function() {
        function toBytes(text) {
            var result = [], i = 0;
            text = encodeURI(text);
            while(i < text.length){
                var c = text.charCodeAt(i++);
                // if it is a % sign, encode the following 2 bytes as a hex value
                if (c === 37) {
                    result.push(parseInt(text.substr(i, 2), 16));
                    i += 2;
                // otherwise, just the actual byte
                } else result.push(c);
            }
            return coerceArray(result);
        }
        function fromBytes(bytes) {
            var result = [], i = 0;
            while(i < bytes.length){
                var c = bytes[i];
                if (c < 128) {
                    result.push(String.fromCharCode(c));
                    i++;
                } else if (c > 191 && c < 224) {
                    result.push(String.fromCharCode((c & 0x1f) << 6 | bytes[i + 1] & 0x3f));
                    i += 2;
                } else {
                    result.push(String.fromCharCode((c & 0x0f) << 12 | (bytes[i + 1] & 0x3f) << 6 | bytes[i + 2] & 0x3f));
                    i += 3;
                }
            }
            return result.join("");
        }
        return {
            toBytes: toBytes,
            fromBytes: fromBytes
        };
    }();
    var convertHex = function() {
        function toBytes(text) {
            var result = [];
            for(var i = 0; i < text.length; i += 2)result.push(parseInt(text.substr(i, 2), 16));
            return result;
        }
        // http://ixti.net/development/javascript/2011/11/11/base64-encodedecode-of-utf8-in-browser-with-js.html
        var Hex = "0123456789abcdef";
        function fromBytes(bytes) {
            var result = [];
            for(var i = 0; i < bytes.length; i++){
                var v = bytes[i];
                result.push(Hex[(v & 0xf0) >> 4] + Hex[v & 0x0f]);
            }
            return result.join("");
        }
        return {
            toBytes: toBytes,
            fromBytes: fromBytes
        };
    }();
    // Number of rounds by keysize
    var numberOfRounds = {
        16: 10,
        24: 12,
        32: 14
    };
    // Round constant words
    var rcon = [
        0x01,
        0x02,
        0x04,
        0x08,
        0x10,
        0x20,
        0x40,
        0x80,
        0x1b,
        0x36,
        0x6c,
        0xd8,
        0xab,
        0x4d,
        0x9a,
        0x2f,
        0x5e,
        0xbc,
        0x63,
        0xc6,
        0x97,
        0x35,
        0x6a,
        0xd4,
        0xb3,
        0x7d,
        0xfa,
        0xef,
        0xc5,
        0x91
    ];
    // S-box and Inverse S-box (S is for Substitution)
    var S = [
        0x63,
        0x7c,
        0x77,
        0x7b,
        0xf2,
        0x6b,
        0x6f,
        0xc5,
        0x30,
        0x01,
        0x67,
        0x2b,
        0xfe,
        0xd7,
        0xab,
        0x76,
        0xca,
        0x82,
        0xc9,
        0x7d,
        0xfa,
        0x59,
        0x47,
        0xf0,
        0xad,
        0xd4,
        0xa2,
        0xaf,
        0x9c,
        0xa4,
        0x72,
        0xc0,
        0xb7,
        0xfd,
        0x93,
        0x26,
        0x36,
        0x3f,
        0xf7,
        0xcc,
        0x34,
        0xa5,
        0xe5,
        0xf1,
        0x71,
        0xd8,
        0x31,
        0x15,
        0x04,
        0xc7,
        0x23,
        0xc3,
        0x18,
        0x96,
        0x05,
        0x9a,
        0x07,
        0x12,
        0x80,
        0xe2,
        0xeb,
        0x27,
        0xb2,
        0x75,
        0x09,
        0x83,
        0x2c,
        0x1a,
        0x1b,
        0x6e,
        0x5a,
        0xa0,
        0x52,
        0x3b,
        0xd6,
        0xb3,
        0x29,
        0xe3,
        0x2f,
        0x84,
        0x53,
        0xd1,
        0x00,
        0xed,
        0x20,
        0xfc,
        0xb1,
        0x5b,
        0x6a,
        0xcb,
        0xbe,
        0x39,
        0x4a,
        0x4c,
        0x58,
        0xcf,
        0xd0,
        0xef,
        0xaa,
        0xfb,
        0x43,
        0x4d,
        0x33,
        0x85,
        0x45,
        0xf9,
        0x02,
        0x7f,
        0x50,
        0x3c,
        0x9f,
        0xa8,
        0x51,
        0xa3,
        0x40,
        0x8f,
        0x92,
        0x9d,
        0x38,
        0xf5,
        0xbc,
        0xb6,
        0xda,
        0x21,
        0x10,
        0xff,
        0xf3,
        0xd2,
        0xcd,
        0x0c,
        0x13,
        0xec,
        0x5f,
        0x97,
        0x44,
        0x17,
        0xc4,
        0xa7,
        0x7e,
        0x3d,
        0x64,
        0x5d,
        0x19,
        0x73,
        0x60,
        0x81,
        0x4f,
        0xdc,
        0x22,
        0x2a,
        0x90,
        0x88,
        0x46,
        0xee,
        0xb8,
        0x14,
        0xde,
        0x5e,
        0x0b,
        0xdb,
        0xe0,
        0x32,
        0x3a,
        0x0a,
        0x49,
        0x06,
        0x24,
        0x5c,
        0xc2,
        0xd3,
        0xac,
        0x62,
        0x91,
        0x95,
        0xe4,
        0x79,
        0xe7,
        0xc8,
        0x37,
        0x6d,
        0x8d,
        0xd5,
        0x4e,
        0xa9,
        0x6c,
        0x56,
        0xf4,
        0xea,
        0x65,
        0x7a,
        0xae,
        0x08,
        0xba,
        0x78,
        0x25,
        0x2e,
        0x1c,
        0xa6,
        0xb4,
        0xc6,
        0xe8,
        0xdd,
        0x74,
        0x1f,
        0x4b,
        0xbd,
        0x8b,
        0x8a,
        0x70,
        0x3e,
        0xb5,
        0x66,
        0x48,
        0x03,
        0xf6,
        0x0e,
        0x61,
        0x35,
        0x57,
        0xb9,
        0x86,
        0xc1,
        0x1d,
        0x9e,
        0xe1,
        0xf8,
        0x98,
        0x11,
        0x69,
        0xd9,
        0x8e,
        0x94,
        0x9b,
        0x1e,
        0x87,
        0xe9,
        0xce,
        0x55,
        0x28,
        0xdf,
        0x8c,
        0xa1,
        0x89,
        0x0d,
        0xbf,
        0xe6,
        0x42,
        0x68,
        0x41,
        0x99,
        0x2d,
        0x0f,
        0xb0,
        0x54,
        0xbb,
        0x16
    ];
    var Si = [
        0x52,
        0x09,
        0x6a,
        0xd5,
        0x30,
        0x36,
        0xa5,
        0x38,
        0xbf,
        0x40,
        0xa3,
        0x9e,
        0x81,
        0xf3,
        0xd7,
        0xfb,
        0x7c,
        0xe3,
        0x39,
        0x82,
        0x9b,
        0x2f,
        0xff,
        0x87,
        0x34,
        0x8e,
        0x43,
        0x44,
        0xc4,
        0xde,
        0xe9,
        0xcb,
        0x54,
        0x7b,
        0x94,
        0x32,
        0xa6,
        0xc2,
        0x23,
        0x3d,
        0xee,
        0x4c,
        0x95,
        0x0b,
        0x42,
        0xfa,
        0xc3,
        0x4e,
        0x08,
        0x2e,
        0xa1,
        0x66,
        0x28,
        0xd9,
        0x24,
        0xb2,
        0x76,
        0x5b,
        0xa2,
        0x49,
        0x6d,
        0x8b,
        0xd1,
        0x25,
        0x72,
        0xf8,
        0xf6,
        0x64,
        0x86,
        0x68,
        0x98,
        0x16,
        0xd4,
        0xa4,
        0x5c,
        0xcc,
        0x5d,
        0x65,
        0xb6,
        0x92,
        0x6c,
        0x70,
        0x48,
        0x50,
        0xfd,
        0xed,
        0xb9,
        0xda,
        0x5e,
        0x15,
        0x46,
        0x57,
        0xa7,
        0x8d,
        0x9d,
        0x84,
        0x90,
        0xd8,
        0xab,
        0x00,
        0x8c,
        0xbc,
        0xd3,
        0x0a,
        0xf7,
        0xe4,
        0x58,
        0x05,
        0xb8,
        0xb3,
        0x45,
        0x06,
        0xd0,
        0x2c,
        0x1e,
        0x8f,
        0xca,
        0x3f,
        0x0f,
        0x02,
        0xc1,
        0xaf,
        0xbd,
        0x03,
        0x01,
        0x13,
        0x8a,
        0x6b,
        0x3a,
        0x91,
        0x11,
        0x41,
        0x4f,
        0x67,
        0xdc,
        0xea,
        0x97,
        0xf2,
        0xcf,
        0xce,
        0xf0,
        0xb4,
        0xe6,
        0x73,
        0x96,
        0xac,
        0x74,
        0x22,
        0xe7,
        0xad,
        0x35,
        0x85,
        0xe2,
        0xf9,
        0x37,
        0xe8,
        0x1c,
        0x75,
        0xdf,
        0x6e,
        0x47,
        0xf1,
        0x1a,
        0x71,
        0x1d,
        0x29,
        0xc5,
        0x89,
        0x6f,
        0xb7,
        0x62,
        0x0e,
        0xaa,
        0x18,
        0xbe,
        0x1b,
        0xfc,
        0x56,
        0x3e,
        0x4b,
        0xc6,
        0xd2,
        0x79,
        0x20,
        0x9a,
        0xdb,
        0xc0,
        0xfe,
        0x78,
        0xcd,
        0x5a,
        0xf4,
        0x1f,
        0xdd,
        0xa8,
        0x33,
        0x88,
        0x07,
        0xc7,
        0x31,
        0xb1,
        0x12,
        0x10,
        0x59,
        0x27,
        0x80,
        0xec,
        0x5f,
        0x60,
        0x51,
        0x7f,
        0xa9,
        0x19,
        0xb5,
        0x4a,
        0x0d,
        0x2d,
        0xe5,
        0x7a,
        0x9f,
        0x93,
        0xc9,
        0x9c,
        0xef,
        0xa0,
        0xe0,
        0x3b,
        0x4d,
        0xae,
        0x2a,
        0xf5,
        0xb0,
        0xc8,
        0xeb,
        0xbb,
        0x3c,
        0x83,
        0x53,
        0x99,
        0x61,
        0x17,
        0x2b,
        0x04,
        0x7e,
        0xba,
        0x77,
        0xd6,
        0x26,
        0xe1,
        0x69,
        0x14,
        0x63,
        0x55,
        0x21,
        0x0c,
        0x7d
    ];
    // Transformations for encryption
    var T1 = [
        0xc66363a5,
        0xf87c7c84,
        0xee777799,
        0xf67b7b8d,
        0xfff2f20d,
        0xd66b6bbd,
        0xde6f6fb1,
        0x91c5c554,
        0x60303050,
        0x02010103,
        0xce6767a9,
        0x562b2b7d,
        0xe7fefe19,
        0xb5d7d762,
        0x4dababe6,
        0xec76769a,
        0x8fcaca45,
        0x1f82829d,
        0x89c9c940,
        0xfa7d7d87,
        0xeffafa15,
        0xb25959eb,
        0x8e4747c9,
        0xfbf0f00b,
        0x41adadec,
        0xb3d4d467,
        0x5fa2a2fd,
        0x45afafea,
        0x239c9cbf,
        0x53a4a4f7,
        0xe4727296,
        0x9bc0c05b,
        0x75b7b7c2,
        0xe1fdfd1c,
        0x3d9393ae,
        0x4c26266a,
        0x6c36365a,
        0x7e3f3f41,
        0xf5f7f702,
        0x83cccc4f,
        0x6834345c,
        0x51a5a5f4,
        0xd1e5e534,
        0xf9f1f108,
        0xe2717193,
        0xabd8d873,
        0x62313153,
        0x2a15153f,
        0x0804040c,
        0x95c7c752,
        0x46232365,
        0x9dc3c35e,
        0x30181828,
        0x379696a1,
        0x0a05050f,
        0x2f9a9ab5,
        0x0e070709,
        0x24121236,
        0x1b80809b,
        0xdfe2e23d,
        0xcdebeb26,
        0x4e272769,
        0x7fb2b2cd,
        0xea75759f,
        0x1209091b,
        0x1d83839e,
        0x582c2c74,
        0x341a1a2e,
        0x361b1b2d,
        0xdc6e6eb2,
        0xb45a5aee,
        0x5ba0a0fb,
        0xa45252f6,
        0x763b3b4d,
        0xb7d6d661,
        0x7db3b3ce,
        0x5229297b,
        0xdde3e33e,
        0x5e2f2f71,
        0x13848497,
        0xa65353f5,
        0xb9d1d168,
        0x00000000,
        0xc1eded2c,
        0x40202060,
        0xe3fcfc1f,
        0x79b1b1c8,
        0xb65b5bed,
        0xd46a6abe,
        0x8dcbcb46,
        0x67bebed9,
        0x7239394b,
        0x944a4ade,
        0x984c4cd4,
        0xb05858e8,
        0x85cfcf4a,
        0xbbd0d06b,
        0xc5efef2a,
        0x4faaaae5,
        0xedfbfb16,
        0x864343c5,
        0x9a4d4dd7,
        0x66333355,
        0x11858594,
        0x8a4545cf,
        0xe9f9f910,
        0x04020206,
        0xfe7f7f81,
        0xa05050f0,
        0x783c3c44,
        0x259f9fba,
        0x4ba8a8e3,
        0xa25151f3,
        0x5da3a3fe,
        0x804040c0,
        0x058f8f8a,
        0x3f9292ad,
        0x219d9dbc,
        0x70383848,
        0xf1f5f504,
        0x63bcbcdf,
        0x77b6b6c1,
        0xafdada75,
        0x42212163,
        0x20101030,
        0xe5ffff1a,
        0xfdf3f30e,
        0xbfd2d26d,
        0x81cdcd4c,
        0x180c0c14,
        0x26131335,
        0xc3ecec2f,
        0xbe5f5fe1,
        0x359797a2,
        0x884444cc,
        0x2e171739,
        0x93c4c457,
        0x55a7a7f2,
        0xfc7e7e82,
        0x7a3d3d47,
        0xc86464ac,
        0xba5d5de7,
        0x3219192b,
        0xe6737395,
        0xc06060a0,
        0x19818198,
        0x9e4f4fd1,
        0xa3dcdc7f,
        0x44222266,
        0x542a2a7e,
        0x3b9090ab,
        0x0b888883,
        0x8c4646ca,
        0xc7eeee29,
        0x6bb8b8d3,
        0x2814143c,
        0xa7dede79,
        0xbc5e5ee2,
        0x160b0b1d,
        0xaddbdb76,
        0xdbe0e03b,
        0x64323256,
        0x743a3a4e,
        0x140a0a1e,
        0x924949db,
        0x0c06060a,
        0x4824246c,
        0xb85c5ce4,
        0x9fc2c25d,
        0xbdd3d36e,
        0x43acacef,
        0xc46262a6,
        0x399191a8,
        0x319595a4,
        0xd3e4e437,
        0xf279798b,
        0xd5e7e732,
        0x8bc8c843,
        0x6e373759,
        0xda6d6db7,
        0x018d8d8c,
        0xb1d5d564,
        0x9c4e4ed2,
        0x49a9a9e0,
        0xd86c6cb4,
        0xac5656fa,
        0xf3f4f407,
        0xcfeaea25,
        0xca6565af,
        0xf47a7a8e,
        0x47aeaee9,
        0x10080818,
        0x6fbabad5,
        0xf0787888,
        0x4a25256f,
        0x5c2e2e72,
        0x381c1c24,
        0x57a6a6f1,
        0x73b4b4c7,
        0x97c6c651,
        0xcbe8e823,
        0xa1dddd7c,
        0xe874749c,
        0x3e1f1f21,
        0x964b4bdd,
        0x61bdbddc,
        0x0d8b8b86,
        0x0f8a8a85,
        0xe0707090,
        0x7c3e3e42,
        0x71b5b5c4,
        0xcc6666aa,
        0x904848d8,
        0x06030305,
        0xf7f6f601,
        0x1c0e0e12,
        0xc26161a3,
        0x6a35355f,
        0xae5757f9,
        0x69b9b9d0,
        0x17868691,
        0x99c1c158,
        0x3a1d1d27,
        0x279e9eb9,
        0xd9e1e138,
        0xebf8f813,
        0x2b9898b3,
        0x22111133,
        0xd26969bb,
        0xa9d9d970,
        0x078e8e89,
        0x339494a7,
        0x2d9b9bb6,
        0x3c1e1e22,
        0x15878792,
        0xc9e9e920,
        0x87cece49,
        0xaa5555ff,
        0x50282878,
        0xa5dfdf7a,
        0x038c8c8f,
        0x59a1a1f8,
        0x09898980,
        0x1a0d0d17,
        0x65bfbfda,
        0xd7e6e631,
        0x844242c6,
        0xd06868b8,
        0x824141c3,
        0x299999b0,
        0x5a2d2d77,
        0x1e0f0f11,
        0x7bb0b0cb,
        0xa85454fc,
        0x6dbbbbd6,
        0x2c16163a
    ];
    var T2 = [
        0xa5c66363,
        0x84f87c7c,
        0x99ee7777,
        0x8df67b7b,
        0x0dfff2f2,
        0xbdd66b6b,
        0xb1de6f6f,
        0x5491c5c5,
        0x50603030,
        0x03020101,
        0xa9ce6767,
        0x7d562b2b,
        0x19e7fefe,
        0x62b5d7d7,
        0xe64dabab,
        0x9aec7676,
        0x458fcaca,
        0x9d1f8282,
        0x4089c9c9,
        0x87fa7d7d,
        0x15effafa,
        0xebb25959,
        0xc98e4747,
        0x0bfbf0f0,
        0xec41adad,
        0x67b3d4d4,
        0xfd5fa2a2,
        0xea45afaf,
        0xbf239c9c,
        0xf753a4a4,
        0x96e47272,
        0x5b9bc0c0,
        0xc275b7b7,
        0x1ce1fdfd,
        0xae3d9393,
        0x6a4c2626,
        0x5a6c3636,
        0x417e3f3f,
        0x02f5f7f7,
        0x4f83cccc,
        0x5c683434,
        0xf451a5a5,
        0x34d1e5e5,
        0x08f9f1f1,
        0x93e27171,
        0x73abd8d8,
        0x53623131,
        0x3f2a1515,
        0x0c080404,
        0x5295c7c7,
        0x65462323,
        0x5e9dc3c3,
        0x28301818,
        0xa1379696,
        0x0f0a0505,
        0xb52f9a9a,
        0x090e0707,
        0x36241212,
        0x9b1b8080,
        0x3ddfe2e2,
        0x26cdebeb,
        0x694e2727,
        0xcd7fb2b2,
        0x9fea7575,
        0x1b120909,
        0x9e1d8383,
        0x74582c2c,
        0x2e341a1a,
        0x2d361b1b,
        0xb2dc6e6e,
        0xeeb45a5a,
        0xfb5ba0a0,
        0xf6a45252,
        0x4d763b3b,
        0x61b7d6d6,
        0xce7db3b3,
        0x7b522929,
        0x3edde3e3,
        0x715e2f2f,
        0x97138484,
        0xf5a65353,
        0x68b9d1d1,
        0x00000000,
        0x2cc1eded,
        0x60402020,
        0x1fe3fcfc,
        0xc879b1b1,
        0xedb65b5b,
        0xbed46a6a,
        0x468dcbcb,
        0xd967bebe,
        0x4b723939,
        0xde944a4a,
        0xd4984c4c,
        0xe8b05858,
        0x4a85cfcf,
        0x6bbbd0d0,
        0x2ac5efef,
        0xe54faaaa,
        0x16edfbfb,
        0xc5864343,
        0xd79a4d4d,
        0x55663333,
        0x94118585,
        0xcf8a4545,
        0x10e9f9f9,
        0x06040202,
        0x81fe7f7f,
        0xf0a05050,
        0x44783c3c,
        0xba259f9f,
        0xe34ba8a8,
        0xf3a25151,
        0xfe5da3a3,
        0xc0804040,
        0x8a058f8f,
        0xad3f9292,
        0xbc219d9d,
        0x48703838,
        0x04f1f5f5,
        0xdf63bcbc,
        0xc177b6b6,
        0x75afdada,
        0x63422121,
        0x30201010,
        0x1ae5ffff,
        0x0efdf3f3,
        0x6dbfd2d2,
        0x4c81cdcd,
        0x14180c0c,
        0x35261313,
        0x2fc3ecec,
        0xe1be5f5f,
        0xa2359797,
        0xcc884444,
        0x392e1717,
        0x5793c4c4,
        0xf255a7a7,
        0x82fc7e7e,
        0x477a3d3d,
        0xacc86464,
        0xe7ba5d5d,
        0x2b321919,
        0x95e67373,
        0xa0c06060,
        0x98198181,
        0xd19e4f4f,
        0x7fa3dcdc,
        0x66442222,
        0x7e542a2a,
        0xab3b9090,
        0x830b8888,
        0xca8c4646,
        0x29c7eeee,
        0xd36bb8b8,
        0x3c281414,
        0x79a7dede,
        0xe2bc5e5e,
        0x1d160b0b,
        0x76addbdb,
        0x3bdbe0e0,
        0x56643232,
        0x4e743a3a,
        0x1e140a0a,
        0xdb924949,
        0x0a0c0606,
        0x6c482424,
        0xe4b85c5c,
        0x5d9fc2c2,
        0x6ebdd3d3,
        0xef43acac,
        0xa6c46262,
        0xa8399191,
        0xa4319595,
        0x37d3e4e4,
        0x8bf27979,
        0x32d5e7e7,
        0x438bc8c8,
        0x596e3737,
        0xb7da6d6d,
        0x8c018d8d,
        0x64b1d5d5,
        0xd29c4e4e,
        0xe049a9a9,
        0xb4d86c6c,
        0xfaac5656,
        0x07f3f4f4,
        0x25cfeaea,
        0xafca6565,
        0x8ef47a7a,
        0xe947aeae,
        0x18100808,
        0xd56fbaba,
        0x88f07878,
        0x6f4a2525,
        0x725c2e2e,
        0x24381c1c,
        0xf157a6a6,
        0xc773b4b4,
        0x5197c6c6,
        0x23cbe8e8,
        0x7ca1dddd,
        0x9ce87474,
        0x213e1f1f,
        0xdd964b4b,
        0xdc61bdbd,
        0x860d8b8b,
        0x850f8a8a,
        0x90e07070,
        0x427c3e3e,
        0xc471b5b5,
        0xaacc6666,
        0xd8904848,
        0x05060303,
        0x01f7f6f6,
        0x121c0e0e,
        0xa3c26161,
        0x5f6a3535,
        0xf9ae5757,
        0xd069b9b9,
        0x91178686,
        0x5899c1c1,
        0x273a1d1d,
        0xb9279e9e,
        0x38d9e1e1,
        0x13ebf8f8,
        0xb32b9898,
        0x33221111,
        0xbbd26969,
        0x70a9d9d9,
        0x89078e8e,
        0xa7339494,
        0xb62d9b9b,
        0x223c1e1e,
        0x92158787,
        0x20c9e9e9,
        0x4987cece,
        0xffaa5555,
        0x78502828,
        0x7aa5dfdf,
        0x8f038c8c,
        0xf859a1a1,
        0x80098989,
        0x171a0d0d,
        0xda65bfbf,
        0x31d7e6e6,
        0xc6844242,
        0xb8d06868,
        0xc3824141,
        0xb0299999,
        0x775a2d2d,
        0x111e0f0f,
        0xcb7bb0b0,
        0xfca85454,
        0xd66dbbbb,
        0x3a2c1616
    ];
    var T3 = [
        0x63a5c663,
        0x7c84f87c,
        0x7799ee77,
        0x7b8df67b,
        0xf20dfff2,
        0x6bbdd66b,
        0x6fb1de6f,
        0xc55491c5,
        0x30506030,
        0x01030201,
        0x67a9ce67,
        0x2b7d562b,
        0xfe19e7fe,
        0xd762b5d7,
        0xabe64dab,
        0x769aec76,
        0xca458fca,
        0x829d1f82,
        0xc94089c9,
        0x7d87fa7d,
        0xfa15effa,
        0x59ebb259,
        0x47c98e47,
        0xf00bfbf0,
        0xadec41ad,
        0xd467b3d4,
        0xa2fd5fa2,
        0xafea45af,
        0x9cbf239c,
        0xa4f753a4,
        0x7296e472,
        0xc05b9bc0,
        0xb7c275b7,
        0xfd1ce1fd,
        0x93ae3d93,
        0x266a4c26,
        0x365a6c36,
        0x3f417e3f,
        0xf702f5f7,
        0xcc4f83cc,
        0x345c6834,
        0xa5f451a5,
        0xe534d1e5,
        0xf108f9f1,
        0x7193e271,
        0xd873abd8,
        0x31536231,
        0x153f2a15,
        0x040c0804,
        0xc75295c7,
        0x23654623,
        0xc35e9dc3,
        0x18283018,
        0x96a13796,
        0x050f0a05,
        0x9ab52f9a,
        0x07090e07,
        0x12362412,
        0x809b1b80,
        0xe23ddfe2,
        0xeb26cdeb,
        0x27694e27,
        0xb2cd7fb2,
        0x759fea75,
        0x091b1209,
        0x839e1d83,
        0x2c74582c,
        0x1a2e341a,
        0x1b2d361b,
        0x6eb2dc6e,
        0x5aeeb45a,
        0xa0fb5ba0,
        0x52f6a452,
        0x3b4d763b,
        0xd661b7d6,
        0xb3ce7db3,
        0x297b5229,
        0xe33edde3,
        0x2f715e2f,
        0x84971384,
        0x53f5a653,
        0xd168b9d1,
        0x00000000,
        0xed2cc1ed,
        0x20604020,
        0xfc1fe3fc,
        0xb1c879b1,
        0x5bedb65b,
        0x6abed46a,
        0xcb468dcb,
        0xbed967be,
        0x394b7239,
        0x4ade944a,
        0x4cd4984c,
        0x58e8b058,
        0xcf4a85cf,
        0xd06bbbd0,
        0xef2ac5ef,
        0xaae54faa,
        0xfb16edfb,
        0x43c58643,
        0x4dd79a4d,
        0x33556633,
        0x85941185,
        0x45cf8a45,
        0xf910e9f9,
        0x02060402,
        0x7f81fe7f,
        0x50f0a050,
        0x3c44783c,
        0x9fba259f,
        0xa8e34ba8,
        0x51f3a251,
        0xa3fe5da3,
        0x40c08040,
        0x8f8a058f,
        0x92ad3f92,
        0x9dbc219d,
        0x38487038,
        0xf504f1f5,
        0xbcdf63bc,
        0xb6c177b6,
        0xda75afda,
        0x21634221,
        0x10302010,
        0xff1ae5ff,
        0xf30efdf3,
        0xd26dbfd2,
        0xcd4c81cd,
        0x0c14180c,
        0x13352613,
        0xec2fc3ec,
        0x5fe1be5f,
        0x97a23597,
        0x44cc8844,
        0x17392e17,
        0xc45793c4,
        0xa7f255a7,
        0x7e82fc7e,
        0x3d477a3d,
        0x64acc864,
        0x5de7ba5d,
        0x192b3219,
        0x7395e673,
        0x60a0c060,
        0x81981981,
        0x4fd19e4f,
        0xdc7fa3dc,
        0x22664422,
        0x2a7e542a,
        0x90ab3b90,
        0x88830b88,
        0x46ca8c46,
        0xee29c7ee,
        0xb8d36bb8,
        0x143c2814,
        0xde79a7de,
        0x5ee2bc5e,
        0x0b1d160b,
        0xdb76addb,
        0xe03bdbe0,
        0x32566432,
        0x3a4e743a,
        0x0a1e140a,
        0x49db9249,
        0x060a0c06,
        0x246c4824,
        0x5ce4b85c,
        0xc25d9fc2,
        0xd36ebdd3,
        0xacef43ac,
        0x62a6c462,
        0x91a83991,
        0x95a43195,
        0xe437d3e4,
        0x798bf279,
        0xe732d5e7,
        0xc8438bc8,
        0x37596e37,
        0x6db7da6d,
        0x8d8c018d,
        0xd564b1d5,
        0x4ed29c4e,
        0xa9e049a9,
        0x6cb4d86c,
        0x56faac56,
        0xf407f3f4,
        0xea25cfea,
        0x65afca65,
        0x7a8ef47a,
        0xaee947ae,
        0x08181008,
        0xbad56fba,
        0x7888f078,
        0x256f4a25,
        0x2e725c2e,
        0x1c24381c,
        0xa6f157a6,
        0xb4c773b4,
        0xc65197c6,
        0xe823cbe8,
        0xdd7ca1dd,
        0x749ce874,
        0x1f213e1f,
        0x4bdd964b,
        0xbddc61bd,
        0x8b860d8b,
        0x8a850f8a,
        0x7090e070,
        0x3e427c3e,
        0xb5c471b5,
        0x66aacc66,
        0x48d89048,
        0x03050603,
        0xf601f7f6,
        0x0e121c0e,
        0x61a3c261,
        0x355f6a35,
        0x57f9ae57,
        0xb9d069b9,
        0x86911786,
        0xc15899c1,
        0x1d273a1d,
        0x9eb9279e,
        0xe138d9e1,
        0xf813ebf8,
        0x98b32b98,
        0x11332211,
        0x69bbd269,
        0xd970a9d9,
        0x8e89078e,
        0x94a73394,
        0x9bb62d9b,
        0x1e223c1e,
        0x87921587,
        0xe920c9e9,
        0xce4987ce,
        0x55ffaa55,
        0x28785028,
        0xdf7aa5df,
        0x8c8f038c,
        0xa1f859a1,
        0x89800989,
        0x0d171a0d,
        0xbfda65bf,
        0xe631d7e6,
        0x42c68442,
        0x68b8d068,
        0x41c38241,
        0x99b02999,
        0x2d775a2d,
        0x0f111e0f,
        0xb0cb7bb0,
        0x54fca854,
        0xbbd66dbb,
        0x163a2c16
    ];
    var T4 = [
        0x6363a5c6,
        0x7c7c84f8,
        0x777799ee,
        0x7b7b8df6,
        0xf2f20dff,
        0x6b6bbdd6,
        0x6f6fb1de,
        0xc5c55491,
        0x30305060,
        0x01010302,
        0x6767a9ce,
        0x2b2b7d56,
        0xfefe19e7,
        0xd7d762b5,
        0xababe64d,
        0x76769aec,
        0xcaca458f,
        0x82829d1f,
        0xc9c94089,
        0x7d7d87fa,
        0xfafa15ef,
        0x5959ebb2,
        0x4747c98e,
        0xf0f00bfb,
        0xadadec41,
        0xd4d467b3,
        0xa2a2fd5f,
        0xafafea45,
        0x9c9cbf23,
        0xa4a4f753,
        0x727296e4,
        0xc0c05b9b,
        0xb7b7c275,
        0xfdfd1ce1,
        0x9393ae3d,
        0x26266a4c,
        0x36365a6c,
        0x3f3f417e,
        0xf7f702f5,
        0xcccc4f83,
        0x34345c68,
        0xa5a5f451,
        0xe5e534d1,
        0xf1f108f9,
        0x717193e2,
        0xd8d873ab,
        0x31315362,
        0x15153f2a,
        0x04040c08,
        0xc7c75295,
        0x23236546,
        0xc3c35e9d,
        0x18182830,
        0x9696a137,
        0x05050f0a,
        0x9a9ab52f,
        0x0707090e,
        0x12123624,
        0x80809b1b,
        0xe2e23ddf,
        0xebeb26cd,
        0x2727694e,
        0xb2b2cd7f,
        0x75759fea,
        0x09091b12,
        0x83839e1d,
        0x2c2c7458,
        0x1a1a2e34,
        0x1b1b2d36,
        0x6e6eb2dc,
        0x5a5aeeb4,
        0xa0a0fb5b,
        0x5252f6a4,
        0x3b3b4d76,
        0xd6d661b7,
        0xb3b3ce7d,
        0x29297b52,
        0xe3e33edd,
        0x2f2f715e,
        0x84849713,
        0x5353f5a6,
        0xd1d168b9,
        0x00000000,
        0xeded2cc1,
        0x20206040,
        0xfcfc1fe3,
        0xb1b1c879,
        0x5b5bedb6,
        0x6a6abed4,
        0xcbcb468d,
        0xbebed967,
        0x39394b72,
        0x4a4ade94,
        0x4c4cd498,
        0x5858e8b0,
        0xcfcf4a85,
        0xd0d06bbb,
        0xefef2ac5,
        0xaaaae54f,
        0xfbfb16ed,
        0x4343c586,
        0x4d4dd79a,
        0x33335566,
        0x85859411,
        0x4545cf8a,
        0xf9f910e9,
        0x02020604,
        0x7f7f81fe,
        0x5050f0a0,
        0x3c3c4478,
        0x9f9fba25,
        0xa8a8e34b,
        0x5151f3a2,
        0xa3a3fe5d,
        0x4040c080,
        0x8f8f8a05,
        0x9292ad3f,
        0x9d9dbc21,
        0x38384870,
        0xf5f504f1,
        0xbcbcdf63,
        0xb6b6c177,
        0xdada75af,
        0x21216342,
        0x10103020,
        0xffff1ae5,
        0xf3f30efd,
        0xd2d26dbf,
        0xcdcd4c81,
        0x0c0c1418,
        0x13133526,
        0xecec2fc3,
        0x5f5fe1be,
        0x9797a235,
        0x4444cc88,
        0x1717392e,
        0xc4c45793,
        0xa7a7f255,
        0x7e7e82fc,
        0x3d3d477a,
        0x6464acc8,
        0x5d5de7ba,
        0x19192b32,
        0x737395e6,
        0x6060a0c0,
        0x81819819,
        0x4f4fd19e,
        0xdcdc7fa3,
        0x22226644,
        0x2a2a7e54,
        0x9090ab3b,
        0x8888830b,
        0x4646ca8c,
        0xeeee29c7,
        0xb8b8d36b,
        0x14143c28,
        0xdede79a7,
        0x5e5ee2bc,
        0x0b0b1d16,
        0xdbdb76ad,
        0xe0e03bdb,
        0x32325664,
        0x3a3a4e74,
        0x0a0a1e14,
        0x4949db92,
        0x06060a0c,
        0x24246c48,
        0x5c5ce4b8,
        0xc2c25d9f,
        0xd3d36ebd,
        0xacacef43,
        0x6262a6c4,
        0x9191a839,
        0x9595a431,
        0xe4e437d3,
        0x79798bf2,
        0xe7e732d5,
        0xc8c8438b,
        0x3737596e,
        0x6d6db7da,
        0x8d8d8c01,
        0xd5d564b1,
        0x4e4ed29c,
        0xa9a9e049,
        0x6c6cb4d8,
        0x5656faac,
        0xf4f407f3,
        0xeaea25cf,
        0x6565afca,
        0x7a7a8ef4,
        0xaeaee947,
        0x08081810,
        0xbabad56f,
        0x787888f0,
        0x25256f4a,
        0x2e2e725c,
        0x1c1c2438,
        0xa6a6f157,
        0xb4b4c773,
        0xc6c65197,
        0xe8e823cb,
        0xdddd7ca1,
        0x74749ce8,
        0x1f1f213e,
        0x4b4bdd96,
        0xbdbddc61,
        0x8b8b860d,
        0x8a8a850f,
        0x707090e0,
        0x3e3e427c,
        0xb5b5c471,
        0x6666aacc,
        0x4848d890,
        0x03030506,
        0xf6f601f7,
        0x0e0e121c,
        0x6161a3c2,
        0x35355f6a,
        0x5757f9ae,
        0xb9b9d069,
        0x86869117,
        0xc1c15899,
        0x1d1d273a,
        0x9e9eb927,
        0xe1e138d9,
        0xf8f813eb,
        0x9898b32b,
        0x11113322,
        0x6969bbd2,
        0xd9d970a9,
        0x8e8e8907,
        0x9494a733,
        0x9b9bb62d,
        0x1e1e223c,
        0x87879215,
        0xe9e920c9,
        0xcece4987,
        0x5555ffaa,
        0x28287850,
        0xdfdf7aa5,
        0x8c8c8f03,
        0xa1a1f859,
        0x89898009,
        0x0d0d171a,
        0xbfbfda65,
        0xe6e631d7,
        0x4242c684,
        0x6868b8d0,
        0x4141c382,
        0x9999b029,
        0x2d2d775a,
        0x0f0f111e,
        0xb0b0cb7b,
        0x5454fca8,
        0xbbbbd66d,
        0x16163a2c
    ];
    // Transformations for decryption
    var T5 = [
        0x51f4a750,
        0x7e416553,
        0x1a17a4c3,
        0x3a275e96,
        0x3bab6bcb,
        0x1f9d45f1,
        0xacfa58ab,
        0x4be30393,
        0x2030fa55,
        0xad766df6,
        0x88cc7691,
        0xf5024c25,
        0x4fe5d7fc,
        0xc52acbd7,
        0x26354480,
        0xb562a38f,
        0xdeb15a49,
        0x25ba1b67,
        0x45ea0e98,
        0x5dfec0e1,
        0xc32f7502,
        0x814cf012,
        0x8d4697a3,
        0x6bd3f9c6,
        0x038f5fe7,
        0x15929c95,
        0xbf6d7aeb,
        0x955259da,
        0xd4be832d,
        0x587421d3,
        0x49e06929,
        0x8ec9c844,
        0x75c2896a,
        0xf48e7978,
        0x99583e6b,
        0x27b971dd,
        0xbee14fb6,
        0xf088ad17,
        0xc920ac66,
        0x7dce3ab4,
        0x63df4a18,
        0xe51a3182,
        0x97513360,
        0x62537f45,
        0xb16477e0,
        0xbb6bae84,
        0xfe81a01c,
        0xf9082b94,
        0x70486858,
        0x8f45fd19,
        0x94de6c87,
        0x527bf8b7,
        0xab73d323,
        0x724b02e2,
        0xe31f8f57,
        0x6655ab2a,
        0xb2eb2807,
        0x2fb5c203,
        0x86c57b9a,
        0xd33708a5,
        0x302887f2,
        0x23bfa5b2,
        0x02036aba,
        0xed16825c,
        0x8acf1c2b,
        0xa779b492,
        0xf307f2f0,
        0x4e69e2a1,
        0x65daf4cd,
        0x0605bed5,
        0xd134621f,
        0xc4a6fe8a,
        0x342e539d,
        0xa2f355a0,
        0x058ae132,
        0xa4f6eb75,
        0x0b83ec39,
        0x4060efaa,
        0x5e719f06,
        0xbd6e1051,
        0x3e218af9,
        0x96dd063d,
        0xdd3e05ae,
        0x4de6bd46,
        0x91548db5,
        0x71c45d05,
        0x0406d46f,
        0x605015ff,
        0x1998fb24,
        0xd6bde997,
        0x894043cc,
        0x67d99e77,
        0xb0e842bd,
        0x07898b88,
        0xe7195b38,
        0x79c8eedb,
        0xa17c0a47,
        0x7c420fe9,
        0xf8841ec9,
        0x00000000,
        0x09808683,
        0x322bed48,
        0x1e1170ac,
        0x6c5a724e,
        0xfd0efffb,
        0x0f853856,
        0x3daed51e,
        0x362d3927,
        0x0a0fd964,
        0x685ca621,
        0x9b5b54d1,
        0x24362e3a,
        0x0c0a67b1,
        0x9357e70f,
        0xb4ee96d2,
        0x1b9b919e,
        0x80c0c54f,
        0x61dc20a2,
        0x5a774b69,
        0x1c121a16,
        0xe293ba0a,
        0xc0a02ae5,
        0x3c22e043,
        0x121b171d,
        0x0e090d0b,
        0xf28bc7ad,
        0x2db6a8b9,
        0x141ea9c8,
        0x57f11985,
        0xaf75074c,
        0xee99ddbb,
        0xa37f60fd,
        0xf701269f,
        0x5c72f5bc,
        0x44663bc5,
        0x5bfb7e34,
        0x8b432976,
        0xcb23c6dc,
        0xb6edfc68,
        0xb8e4f163,
        0xd731dcca,
        0x42638510,
        0x13972240,
        0x84c61120,
        0x854a247d,
        0xd2bb3df8,
        0xaef93211,
        0xc729a16d,
        0x1d9e2f4b,
        0xdcb230f3,
        0x0d8652ec,
        0x77c1e3d0,
        0x2bb3166c,
        0xa970b999,
        0x119448fa,
        0x47e96422,
        0xa8fc8cc4,
        0xa0f03f1a,
        0x567d2cd8,
        0x223390ef,
        0x87494ec7,
        0xd938d1c1,
        0x8ccaa2fe,
        0x98d40b36,
        0xa6f581cf,
        0xa57ade28,
        0xdab78e26,
        0x3fadbfa4,
        0x2c3a9de4,
        0x5078920d,
        0x6a5fcc9b,
        0x547e4662,
        0xf68d13c2,
        0x90d8b8e8,
        0x2e39f75e,
        0x82c3aff5,
        0x9f5d80be,
        0x69d0937c,
        0x6fd52da9,
        0xcf2512b3,
        0xc8ac993b,
        0x10187da7,
        0xe89c636e,
        0xdb3bbb7b,
        0xcd267809,
        0x6e5918f4,
        0xec9ab701,
        0x834f9aa8,
        0xe6956e65,
        0xaaffe67e,
        0x21bccf08,
        0xef15e8e6,
        0xbae79bd9,
        0x4a6f36ce,
        0xea9f09d4,
        0x29b07cd6,
        0x31a4b2af,
        0x2a3f2331,
        0xc6a59430,
        0x35a266c0,
        0x744ebc37,
        0xfc82caa6,
        0xe090d0b0,
        0x33a7d815,
        0xf104984a,
        0x41ecdaf7,
        0x7fcd500e,
        0x1791f62f,
        0x764dd68d,
        0x43efb04d,
        0xccaa4d54,
        0xe49604df,
        0x9ed1b5e3,
        0x4c6a881b,
        0xc12c1fb8,
        0x4665517f,
        0x9d5eea04,
        0x018c355d,
        0xfa877473,
        0xfb0b412e,
        0xb3671d5a,
        0x92dbd252,
        0xe9105633,
        0x6dd64713,
        0x9ad7618c,
        0x37a10c7a,
        0x59f8148e,
        0xeb133c89,
        0xcea927ee,
        0xb761c935,
        0xe11ce5ed,
        0x7a47b13c,
        0x9cd2df59,
        0x55f2733f,
        0x1814ce79,
        0x73c737bf,
        0x53f7cdea,
        0x5ffdaa5b,
        0xdf3d6f14,
        0x7844db86,
        0xcaaff381,
        0xb968c43e,
        0x3824342c,
        0xc2a3405f,
        0x161dc372,
        0xbce2250c,
        0x283c498b,
        0xff0d9541,
        0x39a80171,
        0x080cb3de,
        0xd8b4e49c,
        0x6456c190,
        0x7bcb8461,
        0xd532b670,
        0x486c5c74,
        0xd0b85742
    ];
    var T6 = [
        0x5051f4a7,
        0x537e4165,
        0xc31a17a4,
        0x963a275e,
        0xcb3bab6b,
        0xf11f9d45,
        0xabacfa58,
        0x934be303,
        0x552030fa,
        0xf6ad766d,
        0x9188cc76,
        0x25f5024c,
        0xfc4fe5d7,
        0xd7c52acb,
        0x80263544,
        0x8fb562a3,
        0x49deb15a,
        0x6725ba1b,
        0x9845ea0e,
        0xe15dfec0,
        0x02c32f75,
        0x12814cf0,
        0xa38d4697,
        0xc66bd3f9,
        0xe7038f5f,
        0x9515929c,
        0xebbf6d7a,
        0xda955259,
        0x2dd4be83,
        0xd3587421,
        0x2949e069,
        0x448ec9c8,
        0x6a75c289,
        0x78f48e79,
        0x6b99583e,
        0xdd27b971,
        0xb6bee14f,
        0x17f088ad,
        0x66c920ac,
        0xb47dce3a,
        0x1863df4a,
        0x82e51a31,
        0x60975133,
        0x4562537f,
        0xe0b16477,
        0x84bb6bae,
        0x1cfe81a0,
        0x94f9082b,
        0x58704868,
        0x198f45fd,
        0x8794de6c,
        0xb7527bf8,
        0x23ab73d3,
        0xe2724b02,
        0x57e31f8f,
        0x2a6655ab,
        0x07b2eb28,
        0x032fb5c2,
        0x9a86c57b,
        0xa5d33708,
        0xf2302887,
        0xb223bfa5,
        0xba02036a,
        0x5ced1682,
        0x2b8acf1c,
        0x92a779b4,
        0xf0f307f2,
        0xa14e69e2,
        0xcd65daf4,
        0xd50605be,
        0x1fd13462,
        0x8ac4a6fe,
        0x9d342e53,
        0xa0a2f355,
        0x32058ae1,
        0x75a4f6eb,
        0x390b83ec,
        0xaa4060ef,
        0x065e719f,
        0x51bd6e10,
        0xf93e218a,
        0x3d96dd06,
        0xaedd3e05,
        0x464de6bd,
        0xb591548d,
        0x0571c45d,
        0x6f0406d4,
        0xff605015,
        0x241998fb,
        0x97d6bde9,
        0xcc894043,
        0x7767d99e,
        0xbdb0e842,
        0x8807898b,
        0x38e7195b,
        0xdb79c8ee,
        0x47a17c0a,
        0xe97c420f,
        0xc9f8841e,
        0x00000000,
        0x83098086,
        0x48322bed,
        0xac1e1170,
        0x4e6c5a72,
        0xfbfd0eff,
        0x560f8538,
        0x1e3daed5,
        0x27362d39,
        0x640a0fd9,
        0x21685ca6,
        0xd19b5b54,
        0x3a24362e,
        0xb10c0a67,
        0x0f9357e7,
        0xd2b4ee96,
        0x9e1b9b91,
        0x4f80c0c5,
        0xa261dc20,
        0x695a774b,
        0x161c121a,
        0x0ae293ba,
        0xe5c0a02a,
        0x433c22e0,
        0x1d121b17,
        0x0b0e090d,
        0xadf28bc7,
        0xb92db6a8,
        0xc8141ea9,
        0x8557f119,
        0x4caf7507,
        0xbbee99dd,
        0xfda37f60,
        0x9ff70126,
        0xbc5c72f5,
        0xc544663b,
        0x345bfb7e,
        0x768b4329,
        0xdccb23c6,
        0x68b6edfc,
        0x63b8e4f1,
        0xcad731dc,
        0x10426385,
        0x40139722,
        0x2084c611,
        0x7d854a24,
        0xf8d2bb3d,
        0x11aef932,
        0x6dc729a1,
        0x4b1d9e2f,
        0xf3dcb230,
        0xec0d8652,
        0xd077c1e3,
        0x6c2bb316,
        0x99a970b9,
        0xfa119448,
        0x2247e964,
        0xc4a8fc8c,
        0x1aa0f03f,
        0xd8567d2c,
        0xef223390,
        0xc787494e,
        0xc1d938d1,
        0xfe8ccaa2,
        0x3698d40b,
        0xcfa6f581,
        0x28a57ade,
        0x26dab78e,
        0xa43fadbf,
        0xe42c3a9d,
        0x0d507892,
        0x9b6a5fcc,
        0x62547e46,
        0xc2f68d13,
        0xe890d8b8,
        0x5e2e39f7,
        0xf582c3af,
        0xbe9f5d80,
        0x7c69d093,
        0xa96fd52d,
        0xb3cf2512,
        0x3bc8ac99,
        0xa710187d,
        0x6ee89c63,
        0x7bdb3bbb,
        0x09cd2678,
        0xf46e5918,
        0x01ec9ab7,
        0xa8834f9a,
        0x65e6956e,
        0x7eaaffe6,
        0x0821bccf,
        0xe6ef15e8,
        0xd9bae79b,
        0xce4a6f36,
        0xd4ea9f09,
        0xd629b07c,
        0xaf31a4b2,
        0x312a3f23,
        0x30c6a594,
        0xc035a266,
        0x37744ebc,
        0xa6fc82ca,
        0xb0e090d0,
        0x1533a7d8,
        0x4af10498,
        0xf741ecda,
        0x0e7fcd50,
        0x2f1791f6,
        0x8d764dd6,
        0x4d43efb0,
        0x54ccaa4d,
        0xdfe49604,
        0xe39ed1b5,
        0x1b4c6a88,
        0xb8c12c1f,
        0x7f466551,
        0x049d5eea,
        0x5d018c35,
        0x73fa8774,
        0x2efb0b41,
        0x5ab3671d,
        0x5292dbd2,
        0x33e91056,
        0x136dd647,
        0x8c9ad761,
        0x7a37a10c,
        0x8e59f814,
        0x89eb133c,
        0xeecea927,
        0x35b761c9,
        0xede11ce5,
        0x3c7a47b1,
        0x599cd2df,
        0x3f55f273,
        0x791814ce,
        0xbf73c737,
        0xea53f7cd,
        0x5b5ffdaa,
        0x14df3d6f,
        0x867844db,
        0x81caaff3,
        0x3eb968c4,
        0x2c382434,
        0x5fc2a340,
        0x72161dc3,
        0x0cbce225,
        0x8b283c49,
        0x41ff0d95,
        0x7139a801,
        0xde080cb3,
        0x9cd8b4e4,
        0x906456c1,
        0x617bcb84,
        0x70d532b6,
        0x74486c5c,
        0x42d0b857
    ];
    var T7 = [
        0xa75051f4,
        0x65537e41,
        0xa4c31a17,
        0x5e963a27,
        0x6bcb3bab,
        0x45f11f9d,
        0x58abacfa,
        0x03934be3,
        0xfa552030,
        0x6df6ad76,
        0x769188cc,
        0x4c25f502,
        0xd7fc4fe5,
        0xcbd7c52a,
        0x44802635,
        0xa38fb562,
        0x5a49deb1,
        0x1b6725ba,
        0x0e9845ea,
        0xc0e15dfe,
        0x7502c32f,
        0xf012814c,
        0x97a38d46,
        0xf9c66bd3,
        0x5fe7038f,
        0x9c951592,
        0x7aebbf6d,
        0x59da9552,
        0x832dd4be,
        0x21d35874,
        0x692949e0,
        0xc8448ec9,
        0x896a75c2,
        0x7978f48e,
        0x3e6b9958,
        0x71dd27b9,
        0x4fb6bee1,
        0xad17f088,
        0xac66c920,
        0x3ab47dce,
        0x4a1863df,
        0x3182e51a,
        0x33609751,
        0x7f456253,
        0x77e0b164,
        0xae84bb6b,
        0xa01cfe81,
        0x2b94f908,
        0x68587048,
        0xfd198f45,
        0x6c8794de,
        0xf8b7527b,
        0xd323ab73,
        0x02e2724b,
        0x8f57e31f,
        0xab2a6655,
        0x2807b2eb,
        0xc2032fb5,
        0x7b9a86c5,
        0x08a5d337,
        0x87f23028,
        0xa5b223bf,
        0x6aba0203,
        0x825ced16,
        0x1c2b8acf,
        0xb492a779,
        0xf2f0f307,
        0xe2a14e69,
        0xf4cd65da,
        0xbed50605,
        0x621fd134,
        0xfe8ac4a6,
        0x539d342e,
        0x55a0a2f3,
        0xe132058a,
        0xeb75a4f6,
        0xec390b83,
        0xefaa4060,
        0x9f065e71,
        0x1051bd6e,
        0x8af93e21,
        0x063d96dd,
        0x05aedd3e,
        0xbd464de6,
        0x8db59154,
        0x5d0571c4,
        0xd46f0406,
        0x15ff6050,
        0xfb241998,
        0xe997d6bd,
        0x43cc8940,
        0x9e7767d9,
        0x42bdb0e8,
        0x8b880789,
        0x5b38e719,
        0xeedb79c8,
        0x0a47a17c,
        0x0fe97c42,
        0x1ec9f884,
        0x00000000,
        0x86830980,
        0xed48322b,
        0x70ac1e11,
        0x724e6c5a,
        0xfffbfd0e,
        0x38560f85,
        0xd51e3dae,
        0x3927362d,
        0xd9640a0f,
        0xa621685c,
        0x54d19b5b,
        0x2e3a2436,
        0x67b10c0a,
        0xe70f9357,
        0x96d2b4ee,
        0x919e1b9b,
        0xc54f80c0,
        0x20a261dc,
        0x4b695a77,
        0x1a161c12,
        0xba0ae293,
        0x2ae5c0a0,
        0xe0433c22,
        0x171d121b,
        0x0d0b0e09,
        0xc7adf28b,
        0xa8b92db6,
        0xa9c8141e,
        0x198557f1,
        0x074caf75,
        0xddbbee99,
        0x60fda37f,
        0x269ff701,
        0xf5bc5c72,
        0x3bc54466,
        0x7e345bfb,
        0x29768b43,
        0xc6dccb23,
        0xfc68b6ed,
        0xf163b8e4,
        0xdccad731,
        0x85104263,
        0x22401397,
        0x112084c6,
        0x247d854a,
        0x3df8d2bb,
        0x3211aef9,
        0xa16dc729,
        0x2f4b1d9e,
        0x30f3dcb2,
        0x52ec0d86,
        0xe3d077c1,
        0x166c2bb3,
        0xb999a970,
        0x48fa1194,
        0x642247e9,
        0x8cc4a8fc,
        0x3f1aa0f0,
        0x2cd8567d,
        0x90ef2233,
        0x4ec78749,
        0xd1c1d938,
        0xa2fe8cca,
        0x0b3698d4,
        0x81cfa6f5,
        0xde28a57a,
        0x8e26dab7,
        0xbfa43fad,
        0x9de42c3a,
        0x920d5078,
        0xcc9b6a5f,
        0x4662547e,
        0x13c2f68d,
        0xb8e890d8,
        0xf75e2e39,
        0xaff582c3,
        0x80be9f5d,
        0x937c69d0,
        0x2da96fd5,
        0x12b3cf25,
        0x993bc8ac,
        0x7da71018,
        0x636ee89c,
        0xbb7bdb3b,
        0x7809cd26,
        0x18f46e59,
        0xb701ec9a,
        0x9aa8834f,
        0x6e65e695,
        0xe67eaaff,
        0xcf0821bc,
        0xe8e6ef15,
        0x9bd9bae7,
        0x36ce4a6f,
        0x09d4ea9f,
        0x7cd629b0,
        0xb2af31a4,
        0x23312a3f,
        0x9430c6a5,
        0x66c035a2,
        0xbc37744e,
        0xcaa6fc82,
        0xd0b0e090,
        0xd81533a7,
        0x984af104,
        0xdaf741ec,
        0x500e7fcd,
        0xf62f1791,
        0xd68d764d,
        0xb04d43ef,
        0x4d54ccaa,
        0x04dfe496,
        0xb5e39ed1,
        0x881b4c6a,
        0x1fb8c12c,
        0x517f4665,
        0xea049d5e,
        0x355d018c,
        0x7473fa87,
        0x412efb0b,
        0x1d5ab367,
        0xd25292db,
        0x5633e910,
        0x47136dd6,
        0x618c9ad7,
        0x0c7a37a1,
        0x148e59f8,
        0x3c89eb13,
        0x27eecea9,
        0xc935b761,
        0xe5ede11c,
        0xb13c7a47,
        0xdf599cd2,
        0x733f55f2,
        0xce791814,
        0x37bf73c7,
        0xcdea53f7,
        0xaa5b5ffd,
        0x6f14df3d,
        0xdb867844,
        0xf381caaf,
        0xc43eb968,
        0x342c3824,
        0x405fc2a3,
        0xc372161d,
        0x250cbce2,
        0x498b283c,
        0x9541ff0d,
        0x017139a8,
        0xb3de080c,
        0xe49cd8b4,
        0xc1906456,
        0x84617bcb,
        0xb670d532,
        0x5c74486c,
        0x5742d0b8
    ];
    var T8 = [
        0xf4a75051,
        0x4165537e,
        0x17a4c31a,
        0x275e963a,
        0xab6bcb3b,
        0x9d45f11f,
        0xfa58abac,
        0xe303934b,
        0x30fa5520,
        0x766df6ad,
        0xcc769188,
        0x024c25f5,
        0xe5d7fc4f,
        0x2acbd7c5,
        0x35448026,
        0x62a38fb5,
        0xb15a49de,
        0xba1b6725,
        0xea0e9845,
        0xfec0e15d,
        0x2f7502c3,
        0x4cf01281,
        0x4697a38d,
        0xd3f9c66b,
        0x8f5fe703,
        0x929c9515,
        0x6d7aebbf,
        0x5259da95,
        0xbe832dd4,
        0x7421d358,
        0xe0692949,
        0xc9c8448e,
        0xc2896a75,
        0x8e7978f4,
        0x583e6b99,
        0xb971dd27,
        0xe14fb6be,
        0x88ad17f0,
        0x20ac66c9,
        0xce3ab47d,
        0xdf4a1863,
        0x1a3182e5,
        0x51336097,
        0x537f4562,
        0x6477e0b1,
        0x6bae84bb,
        0x81a01cfe,
        0x082b94f9,
        0x48685870,
        0x45fd198f,
        0xde6c8794,
        0x7bf8b752,
        0x73d323ab,
        0x4b02e272,
        0x1f8f57e3,
        0x55ab2a66,
        0xeb2807b2,
        0xb5c2032f,
        0xc57b9a86,
        0x3708a5d3,
        0x2887f230,
        0xbfa5b223,
        0x036aba02,
        0x16825ced,
        0xcf1c2b8a,
        0x79b492a7,
        0x07f2f0f3,
        0x69e2a14e,
        0xdaf4cd65,
        0x05bed506,
        0x34621fd1,
        0xa6fe8ac4,
        0x2e539d34,
        0xf355a0a2,
        0x8ae13205,
        0xf6eb75a4,
        0x83ec390b,
        0x60efaa40,
        0x719f065e,
        0x6e1051bd,
        0x218af93e,
        0xdd063d96,
        0x3e05aedd,
        0xe6bd464d,
        0x548db591,
        0xc45d0571,
        0x06d46f04,
        0x5015ff60,
        0x98fb2419,
        0xbde997d6,
        0x4043cc89,
        0xd99e7767,
        0xe842bdb0,
        0x898b8807,
        0x195b38e7,
        0xc8eedb79,
        0x7c0a47a1,
        0x420fe97c,
        0x841ec9f8,
        0x00000000,
        0x80868309,
        0x2bed4832,
        0x1170ac1e,
        0x5a724e6c,
        0x0efffbfd,
        0x8538560f,
        0xaed51e3d,
        0x2d392736,
        0x0fd9640a,
        0x5ca62168,
        0x5b54d19b,
        0x362e3a24,
        0x0a67b10c,
        0x57e70f93,
        0xee96d2b4,
        0x9b919e1b,
        0xc0c54f80,
        0xdc20a261,
        0x774b695a,
        0x121a161c,
        0x93ba0ae2,
        0xa02ae5c0,
        0x22e0433c,
        0x1b171d12,
        0x090d0b0e,
        0x8bc7adf2,
        0xb6a8b92d,
        0x1ea9c814,
        0xf1198557,
        0x75074caf,
        0x99ddbbee,
        0x7f60fda3,
        0x01269ff7,
        0x72f5bc5c,
        0x663bc544,
        0xfb7e345b,
        0x4329768b,
        0x23c6dccb,
        0xedfc68b6,
        0xe4f163b8,
        0x31dccad7,
        0x63851042,
        0x97224013,
        0xc6112084,
        0x4a247d85,
        0xbb3df8d2,
        0xf93211ae,
        0x29a16dc7,
        0x9e2f4b1d,
        0xb230f3dc,
        0x8652ec0d,
        0xc1e3d077,
        0xb3166c2b,
        0x70b999a9,
        0x9448fa11,
        0xe9642247,
        0xfc8cc4a8,
        0xf03f1aa0,
        0x7d2cd856,
        0x3390ef22,
        0x494ec787,
        0x38d1c1d9,
        0xcaa2fe8c,
        0xd40b3698,
        0xf581cfa6,
        0x7ade28a5,
        0xb78e26da,
        0xadbfa43f,
        0x3a9de42c,
        0x78920d50,
        0x5fcc9b6a,
        0x7e466254,
        0x8d13c2f6,
        0xd8b8e890,
        0x39f75e2e,
        0xc3aff582,
        0x5d80be9f,
        0xd0937c69,
        0xd52da96f,
        0x2512b3cf,
        0xac993bc8,
        0x187da710,
        0x9c636ee8,
        0x3bbb7bdb,
        0x267809cd,
        0x5918f46e,
        0x9ab701ec,
        0x4f9aa883,
        0x956e65e6,
        0xffe67eaa,
        0xbccf0821,
        0x15e8e6ef,
        0xe79bd9ba,
        0x6f36ce4a,
        0x9f09d4ea,
        0xb07cd629,
        0xa4b2af31,
        0x3f23312a,
        0xa59430c6,
        0xa266c035,
        0x4ebc3774,
        0x82caa6fc,
        0x90d0b0e0,
        0xa7d81533,
        0x04984af1,
        0xecdaf741,
        0xcd500e7f,
        0x91f62f17,
        0x4dd68d76,
        0xefb04d43,
        0xaa4d54cc,
        0x9604dfe4,
        0xd1b5e39e,
        0x6a881b4c,
        0x2c1fb8c1,
        0x65517f46,
        0x5eea049d,
        0x8c355d01,
        0x877473fa,
        0x0b412efb,
        0x671d5ab3,
        0xdbd25292,
        0x105633e9,
        0xd647136d,
        0xd7618c9a,
        0xa10c7a37,
        0xf8148e59,
        0x133c89eb,
        0xa927eece,
        0x61c935b7,
        0x1ce5ede1,
        0x47b13c7a,
        0xd2df599c,
        0xf2733f55,
        0x14ce7918,
        0xc737bf73,
        0xf7cdea53,
        0xfdaa5b5f,
        0x3d6f14df,
        0x44db8678,
        0xaff381ca,
        0x68c43eb9,
        0x24342c38,
        0xa3405fc2,
        0x1dc37216,
        0xe2250cbc,
        0x3c498b28,
        0x0d9541ff,
        0xa8017139,
        0x0cb3de08,
        0xb4e49cd8,
        0x56c19064,
        0xcb84617b,
        0x32b670d5,
        0x6c5c7448,
        0xb85742d0
    ];
    // Transformations for decryption key expansion
    var U1 = [
        0x00000000,
        0x0e090d0b,
        0x1c121a16,
        0x121b171d,
        0x3824342c,
        0x362d3927,
        0x24362e3a,
        0x2a3f2331,
        0x70486858,
        0x7e416553,
        0x6c5a724e,
        0x62537f45,
        0x486c5c74,
        0x4665517f,
        0x547e4662,
        0x5a774b69,
        0xe090d0b0,
        0xee99ddbb,
        0xfc82caa6,
        0xf28bc7ad,
        0xd8b4e49c,
        0xd6bde997,
        0xc4a6fe8a,
        0xcaaff381,
        0x90d8b8e8,
        0x9ed1b5e3,
        0x8ccaa2fe,
        0x82c3aff5,
        0xa8fc8cc4,
        0xa6f581cf,
        0xb4ee96d2,
        0xbae79bd9,
        0xdb3bbb7b,
        0xd532b670,
        0xc729a16d,
        0xc920ac66,
        0xe31f8f57,
        0xed16825c,
        0xff0d9541,
        0xf104984a,
        0xab73d323,
        0xa57ade28,
        0xb761c935,
        0xb968c43e,
        0x9357e70f,
        0x9d5eea04,
        0x8f45fd19,
        0x814cf012,
        0x3bab6bcb,
        0x35a266c0,
        0x27b971dd,
        0x29b07cd6,
        0x038f5fe7,
        0x0d8652ec,
        0x1f9d45f1,
        0x119448fa,
        0x4be30393,
        0x45ea0e98,
        0x57f11985,
        0x59f8148e,
        0x73c737bf,
        0x7dce3ab4,
        0x6fd52da9,
        0x61dc20a2,
        0xad766df6,
        0xa37f60fd,
        0xb16477e0,
        0xbf6d7aeb,
        0x955259da,
        0x9b5b54d1,
        0x894043cc,
        0x87494ec7,
        0xdd3e05ae,
        0xd33708a5,
        0xc12c1fb8,
        0xcf2512b3,
        0xe51a3182,
        0xeb133c89,
        0xf9082b94,
        0xf701269f,
        0x4de6bd46,
        0x43efb04d,
        0x51f4a750,
        0x5ffdaa5b,
        0x75c2896a,
        0x7bcb8461,
        0x69d0937c,
        0x67d99e77,
        0x3daed51e,
        0x33a7d815,
        0x21bccf08,
        0x2fb5c203,
        0x058ae132,
        0x0b83ec39,
        0x1998fb24,
        0x1791f62f,
        0x764dd68d,
        0x7844db86,
        0x6a5fcc9b,
        0x6456c190,
        0x4e69e2a1,
        0x4060efaa,
        0x527bf8b7,
        0x5c72f5bc,
        0x0605bed5,
        0x080cb3de,
        0x1a17a4c3,
        0x141ea9c8,
        0x3e218af9,
        0x302887f2,
        0x223390ef,
        0x2c3a9de4,
        0x96dd063d,
        0x98d40b36,
        0x8acf1c2b,
        0x84c61120,
        0xaef93211,
        0xa0f03f1a,
        0xb2eb2807,
        0xbce2250c,
        0xe6956e65,
        0xe89c636e,
        0xfa877473,
        0xf48e7978,
        0xdeb15a49,
        0xd0b85742,
        0xc2a3405f,
        0xccaa4d54,
        0x41ecdaf7,
        0x4fe5d7fc,
        0x5dfec0e1,
        0x53f7cdea,
        0x79c8eedb,
        0x77c1e3d0,
        0x65daf4cd,
        0x6bd3f9c6,
        0x31a4b2af,
        0x3fadbfa4,
        0x2db6a8b9,
        0x23bfa5b2,
        0x09808683,
        0x07898b88,
        0x15929c95,
        0x1b9b919e,
        0xa17c0a47,
        0xaf75074c,
        0xbd6e1051,
        0xb3671d5a,
        0x99583e6b,
        0x97513360,
        0x854a247d,
        0x8b432976,
        0xd134621f,
        0xdf3d6f14,
        0xcd267809,
        0xc32f7502,
        0xe9105633,
        0xe7195b38,
        0xf5024c25,
        0xfb0b412e,
        0x9ad7618c,
        0x94de6c87,
        0x86c57b9a,
        0x88cc7691,
        0xa2f355a0,
        0xacfa58ab,
        0xbee14fb6,
        0xb0e842bd,
        0xea9f09d4,
        0xe49604df,
        0xf68d13c2,
        0xf8841ec9,
        0xd2bb3df8,
        0xdcb230f3,
        0xcea927ee,
        0xc0a02ae5,
        0x7a47b13c,
        0x744ebc37,
        0x6655ab2a,
        0x685ca621,
        0x42638510,
        0x4c6a881b,
        0x5e719f06,
        0x5078920d,
        0x0a0fd964,
        0x0406d46f,
        0x161dc372,
        0x1814ce79,
        0x322bed48,
        0x3c22e043,
        0x2e39f75e,
        0x2030fa55,
        0xec9ab701,
        0xe293ba0a,
        0xf088ad17,
        0xfe81a01c,
        0xd4be832d,
        0xdab78e26,
        0xc8ac993b,
        0xc6a59430,
        0x9cd2df59,
        0x92dbd252,
        0x80c0c54f,
        0x8ec9c844,
        0xa4f6eb75,
        0xaaffe67e,
        0xb8e4f163,
        0xb6edfc68,
        0x0c0a67b1,
        0x02036aba,
        0x10187da7,
        0x1e1170ac,
        0x342e539d,
        0x3a275e96,
        0x283c498b,
        0x26354480,
        0x7c420fe9,
        0x724b02e2,
        0x605015ff,
        0x6e5918f4,
        0x44663bc5,
        0x4a6f36ce,
        0x587421d3,
        0x567d2cd8,
        0x37a10c7a,
        0x39a80171,
        0x2bb3166c,
        0x25ba1b67,
        0x0f853856,
        0x018c355d,
        0x13972240,
        0x1d9e2f4b,
        0x47e96422,
        0x49e06929,
        0x5bfb7e34,
        0x55f2733f,
        0x7fcd500e,
        0x71c45d05,
        0x63df4a18,
        0x6dd64713,
        0xd731dcca,
        0xd938d1c1,
        0xcb23c6dc,
        0xc52acbd7,
        0xef15e8e6,
        0xe11ce5ed,
        0xf307f2f0,
        0xfd0efffb,
        0xa779b492,
        0xa970b999,
        0xbb6bae84,
        0xb562a38f,
        0x9f5d80be,
        0x91548db5,
        0x834f9aa8,
        0x8d4697a3
    ];
    var U2 = [
        0x00000000,
        0x0b0e090d,
        0x161c121a,
        0x1d121b17,
        0x2c382434,
        0x27362d39,
        0x3a24362e,
        0x312a3f23,
        0x58704868,
        0x537e4165,
        0x4e6c5a72,
        0x4562537f,
        0x74486c5c,
        0x7f466551,
        0x62547e46,
        0x695a774b,
        0xb0e090d0,
        0xbbee99dd,
        0xa6fc82ca,
        0xadf28bc7,
        0x9cd8b4e4,
        0x97d6bde9,
        0x8ac4a6fe,
        0x81caaff3,
        0xe890d8b8,
        0xe39ed1b5,
        0xfe8ccaa2,
        0xf582c3af,
        0xc4a8fc8c,
        0xcfa6f581,
        0xd2b4ee96,
        0xd9bae79b,
        0x7bdb3bbb,
        0x70d532b6,
        0x6dc729a1,
        0x66c920ac,
        0x57e31f8f,
        0x5ced1682,
        0x41ff0d95,
        0x4af10498,
        0x23ab73d3,
        0x28a57ade,
        0x35b761c9,
        0x3eb968c4,
        0x0f9357e7,
        0x049d5eea,
        0x198f45fd,
        0x12814cf0,
        0xcb3bab6b,
        0xc035a266,
        0xdd27b971,
        0xd629b07c,
        0xe7038f5f,
        0xec0d8652,
        0xf11f9d45,
        0xfa119448,
        0x934be303,
        0x9845ea0e,
        0x8557f119,
        0x8e59f814,
        0xbf73c737,
        0xb47dce3a,
        0xa96fd52d,
        0xa261dc20,
        0xf6ad766d,
        0xfda37f60,
        0xe0b16477,
        0xebbf6d7a,
        0xda955259,
        0xd19b5b54,
        0xcc894043,
        0xc787494e,
        0xaedd3e05,
        0xa5d33708,
        0xb8c12c1f,
        0xb3cf2512,
        0x82e51a31,
        0x89eb133c,
        0x94f9082b,
        0x9ff70126,
        0x464de6bd,
        0x4d43efb0,
        0x5051f4a7,
        0x5b5ffdaa,
        0x6a75c289,
        0x617bcb84,
        0x7c69d093,
        0x7767d99e,
        0x1e3daed5,
        0x1533a7d8,
        0x0821bccf,
        0x032fb5c2,
        0x32058ae1,
        0x390b83ec,
        0x241998fb,
        0x2f1791f6,
        0x8d764dd6,
        0x867844db,
        0x9b6a5fcc,
        0x906456c1,
        0xa14e69e2,
        0xaa4060ef,
        0xb7527bf8,
        0xbc5c72f5,
        0xd50605be,
        0xde080cb3,
        0xc31a17a4,
        0xc8141ea9,
        0xf93e218a,
        0xf2302887,
        0xef223390,
        0xe42c3a9d,
        0x3d96dd06,
        0x3698d40b,
        0x2b8acf1c,
        0x2084c611,
        0x11aef932,
        0x1aa0f03f,
        0x07b2eb28,
        0x0cbce225,
        0x65e6956e,
        0x6ee89c63,
        0x73fa8774,
        0x78f48e79,
        0x49deb15a,
        0x42d0b857,
        0x5fc2a340,
        0x54ccaa4d,
        0xf741ecda,
        0xfc4fe5d7,
        0xe15dfec0,
        0xea53f7cd,
        0xdb79c8ee,
        0xd077c1e3,
        0xcd65daf4,
        0xc66bd3f9,
        0xaf31a4b2,
        0xa43fadbf,
        0xb92db6a8,
        0xb223bfa5,
        0x83098086,
        0x8807898b,
        0x9515929c,
        0x9e1b9b91,
        0x47a17c0a,
        0x4caf7507,
        0x51bd6e10,
        0x5ab3671d,
        0x6b99583e,
        0x60975133,
        0x7d854a24,
        0x768b4329,
        0x1fd13462,
        0x14df3d6f,
        0x09cd2678,
        0x02c32f75,
        0x33e91056,
        0x38e7195b,
        0x25f5024c,
        0x2efb0b41,
        0x8c9ad761,
        0x8794de6c,
        0x9a86c57b,
        0x9188cc76,
        0xa0a2f355,
        0xabacfa58,
        0xb6bee14f,
        0xbdb0e842,
        0xd4ea9f09,
        0xdfe49604,
        0xc2f68d13,
        0xc9f8841e,
        0xf8d2bb3d,
        0xf3dcb230,
        0xeecea927,
        0xe5c0a02a,
        0x3c7a47b1,
        0x37744ebc,
        0x2a6655ab,
        0x21685ca6,
        0x10426385,
        0x1b4c6a88,
        0x065e719f,
        0x0d507892,
        0x640a0fd9,
        0x6f0406d4,
        0x72161dc3,
        0x791814ce,
        0x48322bed,
        0x433c22e0,
        0x5e2e39f7,
        0x552030fa,
        0x01ec9ab7,
        0x0ae293ba,
        0x17f088ad,
        0x1cfe81a0,
        0x2dd4be83,
        0x26dab78e,
        0x3bc8ac99,
        0x30c6a594,
        0x599cd2df,
        0x5292dbd2,
        0x4f80c0c5,
        0x448ec9c8,
        0x75a4f6eb,
        0x7eaaffe6,
        0x63b8e4f1,
        0x68b6edfc,
        0xb10c0a67,
        0xba02036a,
        0xa710187d,
        0xac1e1170,
        0x9d342e53,
        0x963a275e,
        0x8b283c49,
        0x80263544,
        0xe97c420f,
        0xe2724b02,
        0xff605015,
        0xf46e5918,
        0xc544663b,
        0xce4a6f36,
        0xd3587421,
        0xd8567d2c,
        0x7a37a10c,
        0x7139a801,
        0x6c2bb316,
        0x6725ba1b,
        0x560f8538,
        0x5d018c35,
        0x40139722,
        0x4b1d9e2f,
        0x2247e964,
        0x2949e069,
        0x345bfb7e,
        0x3f55f273,
        0x0e7fcd50,
        0x0571c45d,
        0x1863df4a,
        0x136dd647,
        0xcad731dc,
        0xc1d938d1,
        0xdccb23c6,
        0xd7c52acb,
        0xe6ef15e8,
        0xede11ce5,
        0xf0f307f2,
        0xfbfd0eff,
        0x92a779b4,
        0x99a970b9,
        0x84bb6bae,
        0x8fb562a3,
        0xbe9f5d80,
        0xb591548d,
        0xa8834f9a,
        0xa38d4697
    ];
    var U3 = [
        0x00000000,
        0x0d0b0e09,
        0x1a161c12,
        0x171d121b,
        0x342c3824,
        0x3927362d,
        0x2e3a2436,
        0x23312a3f,
        0x68587048,
        0x65537e41,
        0x724e6c5a,
        0x7f456253,
        0x5c74486c,
        0x517f4665,
        0x4662547e,
        0x4b695a77,
        0xd0b0e090,
        0xddbbee99,
        0xcaa6fc82,
        0xc7adf28b,
        0xe49cd8b4,
        0xe997d6bd,
        0xfe8ac4a6,
        0xf381caaf,
        0xb8e890d8,
        0xb5e39ed1,
        0xa2fe8cca,
        0xaff582c3,
        0x8cc4a8fc,
        0x81cfa6f5,
        0x96d2b4ee,
        0x9bd9bae7,
        0xbb7bdb3b,
        0xb670d532,
        0xa16dc729,
        0xac66c920,
        0x8f57e31f,
        0x825ced16,
        0x9541ff0d,
        0x984af104,
        0xd323ab73,
        0xde28a57a,
        0xc935b761,
        0xc43eb968,
        0xe70f9357,
        0xea049d5e,
        0xfd198f45,
        0xf012814c,
        0x6bcb3bab,
        0x66c035a2,
        0x71dd27b9,
        0x7cd629b0,
        0x5fe7038f,
        0x52ec0d86,
        0x45f11f9d,
        0x48fa1194,
        0x03934be3,
        0x0e9845ea,
        0x198557f1,
        0x148e59f8,
        0x37bf73c7,
        0x3ab47dce,
        0x2da96fd5,
        0x20a261dc,
        0x6df6ad76,
        0x60fda37f,
        0x77e0b164,
        0x7aebbf6d,
        0x59da9552,
        0x54d19b5b,
        0x43cc8940,
        0x4ec78749,
        0x05aedd3e,
        0x08a5d337,
        0x1fb8c12c,
        0x12b3cf25,
        0x3182e51a,
        0x3c89eb13,
        0x2b94f908,
        0x269ff701,
        0xbd464de6,
        0xb04d43ef,
        0xa75051f4,
        0xaa5b5ffd,
        0x896a75c2,
        0x84617bcb,
        0x937c69d0,
        0x9e7767d9,
        0xd51e3dae,
        0xd81533a7,
        0xcf0821bc,
        0xc2032fb5,
        0xe132058a,
        0xec390b83,
        0xfb241998,
        0xf62f1791,
        0xd68d764d,
        0xdb867844,
        0xcc9b6a5f,
        0xc1906456,
        0xe2a14e69,
        0xefaa4060,
        0xf8b7527b,
        0xf5bc5c72,
        0xbed50605,
        0xb3de080c,
        0xa4c31a17,
        0xa9c8141e,
        0x8af93e21,
        0x87f23028,
        0x90ef2233,
        0x9de42c3a,
        0x063d96dd,
        0x0b3698d4,
        0x1c2b8acf,
        0x112084c6,
        0x3211aef9,
        0x3f1aa0f0,
        0x2807b2eb,
        0x250cbce2,
        0x6e65e695,
        0x636ee89c,
        0x7473fa87,
        0x7978f48e,
        0x5a49deb1,
        0x5742d0b8,
        0x405fc2a3,
        0x4d54ccaa,
        0xdaf741ec,
        0xd7fc4fe5,
        0xc0e15dfe,
        0xcdea53f7,
        0xeedb79c8,
        0xe3d077c1,
        0xf4cd65da,
        0xf9c66bd3,
        0xb2af31a4,
        0xbfa43fad,
        0xa8b92db6,
        0xa5b223bf,
        0x86830980,
        0x8b880789,
        0x9c951592,
        0x919e1b9b,
        0x0a47a17c,
        0x074caf75,
        0x1051bd6e,
        0x1d5ab367,
        0x3e6b9958,
        0x33609751,
        0x247d854a,
        0x29768b43,
        0x621fd134,
        0x6f14df3d,
        0x7809cd26,
        0x7502c32f,
        0x5633e910,
        0x5b38e719,
        0x4c25f502,
        0x412efb0b,
        0x618c9ad7,
        0x6c8794de,
        0x7b9a86c5,
        0x769188cc,
        0x55a0a2f3,
        0x58abacfa,
        0x4fb6bee1,
        0x42bdb0e8,
        0x09d4ea9f,
        0x04dfe496,
        0x13c2f68d,
        0x1ec9f884,
        0x3df8d2bb,
        0x30f3dcb2,
        0x27eecea9,
        0x2ae5c0a0,
        0xb13c7a47,
        0xbc37744e,
        0xab2a6655,
        0xa621685c,
        0x85104263,
        0x881b4c6a,
        0x9f065e71,
        0x920d5078,
        0xd9640a0f,
        0xd46f0406,
        0xc372161d,
        0xce791814,
        0xed48322b,
        0xe0433c22,
        0xf75e2e39,
        0xfa552030,
        0xb701ec9a,
        0xba0ae293,
        0xad17f088,
        0xa01cfe81,
        0x832dd4be,
        0x8e26dab7,
        0x993bc8ac,
        0x9430c6a5,
        0xdf599cd2,
        0xd25292db,
        0xc54f80c0,
        0xc8448ec9,
        0xeb75a4f6,
        0xe67eaaff,
        0xf163b8e4,
        0xfc68b6ed,
        0x67b10c0a,
        0x6aba0203,
        0x7da71018,
        0x70ac1e11,
        0x539d342e,
        0x5e963a27,
        0x498b283c,
        0x44802635,
        0x0fe97c42,
        0x02e2724b,
        0x15ff6050,
        0x18f46e59,
        0x3bc54466,
        0x36ce4a6f,
        0x21d35874,
        0x2cd8567d,
        0x0c7a37a1,
        0x017139a8,
        0x166c2bb3,
        0x1b6725ba,
        0x38560f85,
        0x355d018c,
        0x22401397,
        0x2f4b1d9e,
        0x642247e9,
        0x692949e0,
        0x7e345bfb,
        0x733f55f2,
        0x500e7fcd,
        0x5d0571c4,
        0x4a1863df,
        0x47136dd6,
        0xdccad731,
        0xd1c1d938,
        0xc6dccb23,
        0xcbd7c52a,
        0xe8e6ef15,
        0xe5ede11c,
        0xf2f0f307,
        0xfffbfd0e,
        0xb492a779,
        0xb999a970,
        0xae84bb6b,
        0xa38fb562,
        0x80be9f5d,
        0x8db59154,
        0x9aa8834f,
        0x97a38d46
    ];
    var U4 = [
        0x00000000,
        0x090d0b0e,
        0x121a161c,
        0x1b171d12,
        0x24342c38,
        0x2d392736,
        0x362e3a24,
        0x3f23312a,
        0x48685870,
        0x4165537e,
        0x5a724e6c,
        0x537f4562,
        0x6c5c7448,
        0x65517f46,
        0x7e466254,
        0x774b695a,
        0x90d0b0e0,
        0x99ddbbee,
        0x82caa6fc,
        0x8bc7adf2,
        0xb4e49cd8,
        0xbde997d6,
        0xa6fe8ac4,
        0xaff381ca,
        0xd8b8e890,
        0xd1b5e39e,
        0xcaa2fe8c,
        0xc3aff582,
        0xfc8cc4a8,
        0xf581cfa6,
        0xee96d2b4,
        0xe79bd9ba,
        0x3bbb7bdb,
        0x32b670d5,
        0x29a16dc7,
        0x20ac66c9,
        0x1f8f57e3,
        0x16825ced,
        0x0d9541ff,
        0x04984af1,
        0x73d323ab,
        0x7ade28a5,
        0x61c935b7,
        0x68c43eb9,
        0x57e70f93,
        0x5eea049d,
        0x45fd198f,
        0x4cf01281,
        0xab6bcb3b,
        0xa266c035,
        0xb971dd27,
        0xb07cd629,
        0x8f5fe703,
        0x8652ec0d,
        0x9d45f11f,
        0x9448fa11,
        0xe303934b,
        0xea0e9845,
        0xf1198557,
        0xf8148e59,
        0xc737bf73,
        0xce3ab47d,
        0xd52da96f,
        0xdc20a261,
        0x766df6ad,
        0x7f60fda3,
        0x6477e0b1,
        0x6d7aebbf,
        0x5259da95,
        0x5b54d19b,
        0x4043cc89,
        0x494ec787,
        0x3e05aedd,
        0x3708a5d3,
        0x2c1fb8c1,
        0x2512b3cf,
        0x1a3182e5,
        0x133c89eb,
        0x082b94f9,
        0x01269ff7,
        0xe6bd464d,
        0xefb04d43,
        0xf4a75051,
        0xfdaa5b5f,
        0xc2896a75,
        0xcb84617b,
        0xd0937c69,
        0xd99e7767,
        0xaed51e3d,
        0xa7d81533,
        0xbccf0821,
        0xb5c2032f,
        0x8ae13205,
        0x83ec390b,
        0x98fb2419,
        0x91f62f17,
        0x4dd68d76,
        0x44db8678,
        0x5fcc9b6a,
        0x56c19064,
        0x69e2a14e,
        0x60efaa40,
        0x7bf8b752,
        0x72f5bc5c,
        0x05bed506,
        0x0cb3de08,
        0x17a4c31a,
        0x1ea9c814,
        0x218af93e,
        0x2887f230,
        0x3390ef22,
        0x3a9de42c,
        0xdd063d96,
        0xd40b3698,
        0xcf1c2b8a,
        0xc6112084,
        0xf93211ae,
        0xf03f1aa0,
        0xeb2807b2,
        0xe2250cbc,
        0x956e65e6,
        0x9c636ee8,
        0x877473fa,
        0x8e7978f4,
        0xb15a49de,
        0xb85742d0,
        0xa3405fc2,
        0xaa4d54cc,
        0xecdaf741,
        0xe5d7fc4f,
        0xfec0e15d,
        0xf7cdea53,
        0xc8eedb79,
        0xc1e3d077,
        0xdaf4cd65,
        0xd3f9c66b,
        0xa4b2af31,
        0xadbfa43f,
        0xb6a8b92d,
        0xbfa5b223,
        0x80868309,
        0x898b8807,
        0x929c9515,
        0x9b919e1b,
        0x7c0a47a1,
        0x75074caf,
        0x6e1051bd,
        0x671d5ab3,
        0x583e6b99,
        0x51336097,
        0x4a247d85,
        0x4329768b,
        0x34621fd1,
        0x3d6f14df,
        0x267809cd,
        0x2f7502c3,
        0x105633e9,
        0x195b38e7,
        0x024c25f5,
        0x0b412efb,
        0xd7618c9a,
        0xde6c8794,
        0xc57b9a86,
        0xcc769188,
        0xf355a0a2,
        0xfa58abac,
        0xe14fb6be,
        0xe842bdb0,
        0x9f09d4ea,
        0x9604dfe4,
        0x8d13c2f6,
        0x841ec9f8,
        0xbb3df8d2,
        0xb230f3dc,
        0xa927eece,
        0xa02ae5c0,
        0x47b13c7a,
        0x4ebc3774,
        0x55ab2a66,
        0x5ca62168,
        0x63851042,
        0x6a881b4c,
        0x719f065e,
        0x78920d50,
        0x0fd9640a,
        0x06d46f04,
        0x1dc37216,
        0x14ce7918,
        0x2bed4832,
        0x22e0433c,
        0x39f75e2e,
        0x30fa5520,
        0x9ab701ec,
        0x93ba0ae2,
        0x88ad17f0,
        0x81a01cfe,
        0xbe832dd4,
        0xb78e26da,
        0xac993bc8,
        0xa59430c6,
        0xd2df599c,
        0xdbd25292,
        0xc0c54f80,
        0xc9c8448e,
        0xf6eb75a4,
        0xffe67eaa,
        0xe4f163b8,
        0xedfc68b6,
        0x0a67b10c,
        0x036aba02,
        0x187da710,
        0x1170ac1e,
        0x2e539d34,
        0x275e963a,
        0x3c498b28,
        0x35448026,
        0x420fe97c,
        0x4b02e272,
        0x5015ff60,
        0x5918f46e,
        0x663bc544,
        0x6f36ce4a,
        0x7421d358,
        0x7d2cd856,
        0xa10c7a37,
        0xa8017139,
        0xb3166c2b,
        0xba1b6725,
        0x8538560f,
        0x8c355d01,
        0x97224013,
        0x9e2f4b1d,
        0xe9642247,
        0xe0692949,
        0xfb7e345b,
        0xf2733f55,
        0xcd500e7f,
        0xc45d0571,
        0xdf4a1863,
        0xd647136d,
        0x31dccad7,
        0x38d1c1d9,
        0x23c6dccb,
        0x2acbd7c5,
        0x15e8e6ef,
        0x1ce5ede1,
        0x07f2f0f3,
        0x0efffbfd,
        0x79b492a7,
        0x70b999a9,
        0x6bae84bb,
        0x62a38fb5,
        0x5d80be9f,
        0x548db591,
        0x4f9aa883,
        0x4697a38d
    ];
    function convertToInt32(bytes) {
        var result = [];
        for(var i = 0; i < bytes.length; i += 4)result.push(bytes[i] << 24 | bytes[i + 1] << 16 | bytes[i + 2] << 8 | bytes[i + 3]);
        return result;
    }
    var AES = function(key) {
        if (!(this instanceof AES)) throw Error("AES must be instanitated with `new`");
        Object.defineProperty(this, "key", {
            value: coerceArray(key, true)
        });
        this._prepare();
    };
    AES.prototype._prepare = function() {
        var rounds = numberOfRounds[this.key.length];
        if (rounds == null) throw new Error("invalid key size (must be 16, 24 or 32 bytes)");
        // encryption round keys
        this._Ke = [];
        // decryption round keys
        this._Kd = [];
        for(var i = 0; i <= rounds; i++){
            this._Ke.push([
                0,
                0,
                0,
                0
            ]);
            this._Kd.push([
                0,
                0,
                0,
                0
            ]);
        }
        var roundKeyCount = (rounds + 1) * 4;
        var KC = this.key.length / 4;
        // convert the key into ints
        var tk = convertToInt32(this.key);
        // copy values into round key arrays
        var index;
        for(var i = 0; i < KC; i++){
            index = i >> 2;
            this._Ke[index][i % 4] = tk[i];
            this._Kd[rounds - index][i % 4] = tk[i];
        }
        // key expansion (fips-197 section 5.2)
        var rconpointer = 0;
        var t = KC, tt;
        while(t < roundKeyCount){
            tt = tk[KC - 1];
            tk[0] ^= S[tt >> 16 & 0xFF] << 24 ^ S[tt >> 8 & 0xFF] << 16 ^ S[tt & 0xFF] << 8 ^ S[tt >> 24 & 0xFF] ^ rcon[rconpointer] << 24;
            rconpointer += 1;
            // key expansion (for non-256 bit)
            if (KC != 8) for(var i = 1; i < KC; i++)tk[i] ^= tk[i - 1];
            else {
                for(var i = 1; i < KC / 2; i++)tk[i] ^= tk[i - 1];
                tt = tk[KC / 2 - 1];
                tk[KC / 2] ^= S[tt & 0xFF] ^ S[tt >> 8 & 0xFF] << 8 ^ S[tt >> 16 & 0xFF] << 16 ^ S[tt >> 24 & 0xFF] << 24;
                for(var i = KC / 2 + 1; i < KC; i++)tk[i] ^= tk[i - 1];
            }
            // copy values into round key arrays
            var i = 0, r, c;
            while(i < KC && t < roundKeyCount){
                r = t >> 2;
                c = t % 4;
                this._Ke[r][c] = tk[i];
                this._Kd[rounds - r][c] = tk[i++];
                t++;
            }
        }
        // inverse-cipher-ify the decryption round key (fips-197 section 5.3)
        for(var r = 1; r < rounds; r++)for(var c = 0; c < 4; c++){
            tt = this._Kd[r][c];
            this._Kd[r][c] = U1[tt >> 24 & 0xFF] ^ U2[tt >> 16 & 0xFF] ^ U3[tt >> 8 & 0xFF] ^ U4[tt & 0xFF];
        }
    };
    AES.prototype.encrypt = function(plaintext) {
        if (plaintext.length != 16) throw new Error("invalid plaintext size (must be 16 bytes)");
        var rounds = this._Ke.length - 1;
        var a = [
            0,
            0,
            0,
            0
        ];
        // convert plaintext to (ints ^ key)
        var t = convertToInt32(plaintext);
        for(var i = 0; i < 4; i++)t[i] ^= this._Ke[0][i];
        // apply round transforms
        for(var r = 1; r < rounds; r++){
            for(var i = 0; i < 4; i++)a[i] = T1[t[i] >> 24 & 0xff] ^ T2[t[(i + 1) % 4] >> 16 & 0xff] ^ T3[t[(i + 2) % 4] >> 8 & 0xff] ^ T4[t[(i + 3) % 4] & 0xff] ^ this._Ke[r][i];
            t = a.slice();
        }
        // the last round is special
        var result = createArray(16), tt;
        for(var i = 0; i < 4; i++){
            tt = this._Ke[rounds][i];
            result[4 * i] = (S[t[i] >> 24 & 0xff] ^ tt >> 24) & 0xff;
            result[4 * i + 1] = (S[t[(i + 1) % 4] >> 16 & 0xff] ^ tt >> 16) & 0xff;
            result[4 * i + 2] = (S[t[(i + 2) % 4] >> 8 & 0xff] ^ tt >> 8) & 0xff;
            result[4 * i + 3] = (S[t[(i + 3) % 4] & 0xff] ^ tt) & 0xff;
        }
        return result;
    };
    AES.prototype.decrypt = function(ciphertext) {
        if (ciphertext.length != 16) throw new Error("invalid ciphertext size (must be 16 bytes)");
        var rounds = this._Kd.length - 1;
        var a = [
            0,
            0,
            0,
            0
        ];
        // convert plaintext to (ints ^ key)
        var t = convertToInt32(ciphertext);
        for(var i = 0; i < 4; i++)t[i] ^= this._Kd[0][i];
        // apply round transforms
        for(var r = 1; r < rounds; r++){
            for(var i = 0; i < 4; i++)a[i] = T5[t[i] >> 24 & 0xff] ^ T6[t[(i + 3) % 4] >> 16 & 0xff] ^ T7[t[(i + 2) % 4] >> 8 & 0xff] ^ T8[t[(i + 1) % 4] & 0xff] ^ this._Kd[r][i];
            t = a.slice();
        }
        // the last round is special
        var result = createArray(16), tt;
        for(var i = 0; i < 4; i++){
            tt = this._Kd[rounds][i];
            result[4 * i] = (Si[t[i] >> 24 & 0xff] ^ tt >> 24) & 0xff;
            result[4 * i + 1] = (Si[t[(i + 3) % 4] >> 16 & 0xff] ^ tt >> 16) & 0xff;
            result[4 * i + 2] = (Si[t[(i + 2) % 4] >> 8 & 0xff] ^ tt >> 8) & 0xff;
            result[4 * i + 3] = (Si[t[(i + 1) % 4] & 0xff] ^ tt) & 0xff;
        }
        return result;
    };
    /**
     *  Mode Of Operation - Electonic Codebook (ECB)
     */ var ModeOfOperationECB = function(key) {
        if (!(this instanceof ModeOfOperationECB)) throw Error("AES must be instanitated with `new`");
        this.description = "Electronic Code Block";
        this.name = "ecb";
        this._aes = new AES(key);
    };
    ModeOfOperationECB.prototype.encrypt = function(plaintext) {
        plaintext = coerceArray(plaintext);
        if (plaintext.length % 16 !== 0) throw new Error("invalid plaintext size (must be multiple of 16 bytes)");
        var ciphertext = createArray(plaintext.length);
        var block = createArray(16);
        for(var i = 0; i < plaintext.length; i += 16){
            copyArray(plaintext, block, 0, i, i + 16);
            block = this._aes.encrypt(block);
            copyArray(block, ciphertext, i);
        }
        return ciphertext;
    };
    ModeOfOperationECB.prototype.decrypt = function(ciphertext) {
        ciphertext = coerceArray(ciphertext);
        if (ciphertext.length % 16 !== 0) throw new Error("invalid ciphertext size (must be multiple of 16 bytes)");
        var plaintext = createArray(ciphertext.length);
        var block = createArray(16);
        for(var i = 0; i < ciphertext.length; i += 16){
            copyArray(ciphertext, block, 0, i, i + 16);
            block = this._aes.decrypt(block);
            copyArray(block, plaintext, i);
        }
        return plaintext;
    };
    /**
     *  Mode Of Operation - Cipher Block Chaining (CBC)
     */ var ModeOfOperationCBC = function(key, iv) {
        if (!(this instanceof ModeOfOperationCBC)) throw Error("AES must be instanitated with `new`");
        this.description = "Cipher Block Chaining";
        this.name = "cbc";
        if (!iv) iv = createArray(16);
        else if (iv.length != 16) throw new Error("invalid initialation vector size (must be 16 bytes)");
        this._lastCipherblock = coerceArray(iv, true);
        this._aes = new AES(key);
    };
    ModeOfOperationCBC.prototype.encrypt = function(plaintext) {
        plaintext = coerceArray(plaintext);
        if (plaintext.length % 16 !== 0) throw new Error("invalid plaintext size (must be multiple of 16 bytes)");
        var ciphertext = createArray(plaintext.length);
        var block = createArray(16);
        for(var i = 0; i < plaintext.length; i += 16){
            copyArray(plaintext, block, 0, i, i + 16);
            for(var j = 0; j < 16; j++)block[j] ^= this._lastCipherblock[j];
            this._lastCipherblock = this._aes.encrypt(block);
            copyArray(this._lastCipherblock, ciphertext, i);
        }
        return ciphertext;
    };
    ModeOfOperationCBC.prototype.decrypt = function(ciphertext) {
        ciphertext = coerceArray(ciphertext);
        if (ciphertext.length % 16 !== 0) throw new Error("invalid ciphertext size (must be multiple of 16 bytes)");
        var plaintext = createArray(ciphertext.length);
        var block = createArray(16);
        for(var i = 0; i < ciphertext.length; i += 16){
            copyArray(ciphertext, block, 0, i, i + 16);
            block = this._aes.decrypt(block);
            for(var j = 0; j < 16; j++)plaintext[i + j] = block[j] ^ this._lastCipherblock[j];
            copyArray(ciphertext, this._lastCipherblock, 0, i, i + 16);
        }
        return plaintext;
    };
    /**
     *  Mode Of Operation - Cipher Feedback (CFB)
     */ var ModeOfOperationCFB = function(key, iv, segmentSize) {
        if (!(this instanceof ModeOfOperationCFB)) throw Error("AES must be instanitated with `new`");
        this.description = "Cipher Feedback";
        this.name = "cfb";
        if (!iv) iv = createArray(16);
        else if (iv.length != 16) throw new Error("invalid initialation vector size (must be 16 size)");
        if (!segmentSize) segmentSize = 1;
        this.segmentSize = segmentSize;
        this._shiftRegister = coerceArray(iv, true);
        this._aes = new AES(key);
    };
    ModeOfOperationCFB.prototype.encrypt = function(plaintext) {
        if (plaintext.length % this.segmentSize != 0) throw new Error("invalid plaintext size (must be segmentSize bytes)");
        var encrypted = coerceArray(plaintext, true);
        var xorSegment;
        for(var i = 0; i < encrypted.length; i += this.segmentSize){
            xorSegment = this._aes.encrypt(this._shiftRegister);
            for(var j = 0; j < this.segmentSize; j++)encrypted[i + j] ^= xorSegment[j];
            // Shift the register
            copyArray(this._shiftRegister, this._shiftRegister, 0, this.segmentSize);
            copyArray(encrypted, this._shiftRegister, 16 - this.segmentSize, i, i + this.segmentSize);
        }
        return encrypted;
    };
    ModeOfOperationCFB.prototype.decrypt = function(ciphertext) {
        if (ciphertext.length % this.segmentSize != 0) throw new Error("invalid ciphertext size (must be segmentSize bytes)");
        var plaintext = coerceArray(ciphertext, true);
        var xorSegment;
        for(var i = 0; i < plaintext.length; i += this.segmentSize){
            xorSegment = this._aes.encrypt(this._shiftRegister);
            for(var j = 0; j < this.segmentSize; j++)plaintext[i + j] ^= xorSegment[j];
            // Shift the register
            copyArray(this._shiftRegister, this._shiftRegister, 0, this.segmentSize);
            copyArray(ciphertext, this._shiftRegister, 16 - this.segmentSize, i, i + this.segmentSize);
        }
        return plaintext;
    };
    /**
     *  Mode Of Operation - Output Feedback (OFB)
     */ var ModeOfOperationOFB = function(key, iv) {
        if (!(this instanceof ModeOfOperationOFB)) throw Error("AES must be instanitated with `new`");
        this.description = "Output Feedback";
        this.name = "ofb";
        if (!iv) iv = createArray(16);
        else if (iv.length != 16) throw new Error("invalid initialation vector size (must be 16 bytes)");
        this._lastPrecipher = coerceArray(iv, true);
        this._lastPrecipherIndex = 16;
        this._aes = new AES(key);
    };
    ModeOfOperationOFB.prototype.encrypt = function(plaintext) {
        var encrypted = coerceArray(plaintext, true);
        for(var i = 0; i < encrypted.length; i++){
            if (this._lastPrecipherIndex === 16) {
                this._lastPrecipher = this._aes.encrypt(this._lastPrecipher);
                this._lastPrecipherIndex = 0;
            }
            encrypted[i] ^= this._lastPrecipher[this._lastPrecipherIndex++];
        }
        return encrypted;
    };
    // Decryption is symetric
    ModeOfOperationOFB.prototype.decrypt = ModeOfOperationOFB.prototype.encrypt;
    /**
     *  Counter object for CTR common mode of operation
     */ var Counter = function(initialValue) {
        if (!(this instanceof Counter)) throw Error("Counter must be instanitated with `new`");
        // We allow 0, but anything false-ish uses the default 1
        if (initialValue !== 0 && !initialValue) initialValue = 1;
        if (typeof initialValue === "number") {
            this._counter = createArray(16);
            this.setValue(initialValue);
        } else this.setBytes(initialValue);
    };
    Counter.prototype.setValue = function(value) {
        if (typeof value !== "number" || parseInt(value) != value) throw new Error("invalid counter value (must be an integer)");
        for(var index = 15; index >= 0; --index){
            this._counter[index] = value % 256;
            value = value >> 8;
        }
    };
    Counter.prototype.setBytes = function(bytes) {
        bytes = coerceArray(bytes, true);
        if (bytes.length != 16) throw new Error("invalid counter bytes size (must be 16 bytes)");
        this._counter = bytes;
    };
    Counter.prototype.increment = function() {
        for(var i = 15; i >= 0; i--)if (this._counter[i] === 255) this._counter[i] = 0;
        else {
            this._counter[i]++;
            break;
        }
    };
    /**
     *  Mode Of Operation - Counter (CTR)
     */ var ModeOfOperationCTR = function(key, counter) {
        if (!(this instanceof ModeOfOperationCTR)) throw Error("AES must be instanitated with `new`");
        this.description = "Counter";
        this.name = "ctr";
        if (!(counter instanceof Counter)) counter = new Counter(counter);
        this._counter = counter;
        this._remainingCounter = null;
        this._remainingCounterIndex = 16;
        this._aes = new AES(key);
    };
    ModeOfOperationCTR.prototype.encrypt = function(plaintext) {
        var encrypted = coerceArray(plaintext, true);
        for(var i = 0; i < encrypted.length; i++){
            if (this._remainingCounterIndex === 16) {
                this._remainingCounter = this._aes.encrypt(this._counter._counter);
                this._remainingCounterIndex = 0;
                this._counter.increment();
            }
            encrypted[i] ^= this._remainingCounter[this._remainingCounterIndex++];
        }
        return encrypted;
    };
    // Decryption is symetric
    ModeOfOperationCTR.prototype.decrypt = ModeOfOperationCTR.prototype.encrypt;
    ///////////////////////
    // Padding
    // See:https://tools.ietf.org/html/rfc2315
    function pkcs7pad(data) {
        data = coerceArray(data, true);
        var padder = 16 - data.length % 16;
        var result = createArray(data.length + padder);
        copyArray(data, result);
        for(var i = data.length; i < result.length; i++)result[i] = padder;
        return result;
    }
    function pkcs7strip(data) {
        data = coerceArray(data, true);
        if (data.length < 16) throw new Error("PKCS#7 invalid length");
        var padder = data[data.length - 1];
        if (padder > 16) throw new Error("PKCS#7 padding byte out of range");
        var length = data.length - padder;
        for(var i = 0; i < padder; i++){
            if (data[length + i] !== padder) throw new Error("PKCS#7 invalid padding byte");
        }
        var result = createArray(length);
        copyArray(data, result, 0, 0, length);
        return result;
    }
    ///////////////////////
    // Exporting
    // The block cipher
    var aesjs = {
        AES: AES,
        Counter: Counter,
        ModeOfOperation: {
            ecb: ModeOfOperationECB,
            cbc: ModeOfOperationCBC,
            cfb: ModeOfOperationCFB,
            ofb: ModeOfOperationOFB,
            ctr: ModeOfOperationCTR
        },
        utils: {
            hex: convertHex,
            utf8: convertUtf8
        },
        padding: {
            pkcs7: {
                pad: pkcs7pad,
                strip: pkcs7strip
            }
        },
        _arrayTest: {
            coerceArray: coerceArray,
            createArray: createArray,
            copyArray: copyArray
        }
    };
    $3218055eb97e4543$exports = aesjs;
})($3218055eb97e4543$exports);









const $86419f3d35c6552e$export$83d89fbfd8236492 = "json-wallets/5.7.0";




"use strict";
function $b1de86b722ca4f68$export$2cde08bde0cfd932(hexString) {
    if (typeof hexString === "string" && hexString.substring(0, 2) !== "0x") hexString = "0x" + hexString;
    return (0, $06d75ae17ce69367$export$3131421a7d01b4fb)(hexString);
}
function $b1de86b722ca4f68$export$67752b99d3bc61c6(value, length) {
    value = String(value);
    while(value.length < length)value = "0" + value;
    return value;
}
function $b1de86b722ca4f68$export$350bd33120f7413e(password) {
    if (typeof password === "string") return (0, $7bbf1261c840221b$export$8feeb310b4b4752f)(password, (0, $7bbf1261c840221b$export$c6986442964129f5).NFKC);
    return (0, $06d75ae17ce69367$export$3131421a7d01b4fb)(password);
}
function $b1de86b722ca4f68$export$5a5c1dbd910e2c32(object, path) {
    let currentChild = object;
    const comps = path.toLowerCase().split("/");
    for(let i = 0; i < comps.length; i++){
        // Search for a child object with a case-insensitive matching key
        let matchingChild = null;
        for(const key in currentChild)if (key.toLowerCase() === comps[i]) {
            matchingChild = currentChild[key];
            break;
        }
        // Didn't find one. :'(
        if (matchingChild === null) return null;
        // Now check this child...
        currentChild = matchingChild;
    }
    return currentChild;
}
function $b1de86b722ca4f68$export$ec7b18ebad55a3a9(randomBytes) {
    const bytes = (0, $06d75ae17ce69367$export$3131421a7d01b4fb)(randomBytes);
    // Section: 4.1.3:
    // - time_hi_and_version[12:16] = 0b0100
    bytes[6] = bytes[6] & 0x0f | 0x40;
    // Section 4.4
    // - clock_seq_hi_and_reserved[6] = 0b0
    // - clock_seq_hi_and_reserved[7] = 0b1
    bytes[8] = bytes[8] & 0x3f | 0x80;
    const value = (0, $06d75ae17ce69367$export$2b0d6b5fbe698c70)(bytes);
    return [
        value.substring(2, 10),
        value.substring(10, 14),
        value.substring(14, 18),
        value.substring(18, 22),
        value.substring(22, 34)
    ].join("-");
}


"use strict";
const $70db0fcce8592167$var$logger = new (0, $5f596c9584f643ae$export$efa9a398d6368992)((0, $86419f3d35c6552e$export$83d89fbfd8236492));
class $70db0fcce8592167$export$93a76d16f88f2b3 extends (0, $d2d9b472f7878d5e$exports.Description) {
    isCrowdsaleAccount(value) {
        return !!(value && value._isCrowdsaleAccount);
    }
}
function $70db0fcce8592167$export$e85a0c9a1067c5d3(json, password) {
    const data = JSON.parse(json);
    password = (0, $b1de86b722ca4f68$export$350bd33120f7413e)(password);
    // Ethereum Address
    const ethaddr = (0, $5652f239bab101de$export$88411125f012957a)((0, $b1de86b722ca4f68$export$5a5c1dbd910e2c32)(data, "ethaddr"));
    // Encrypted Seed
    const encseed = (0, $b1de86b722ca4f68$export$2cde08bde0cfd932)((0, $b1de86b722ca4f68$export$5a5c1dbd910e2c32)(data, "encseed"));
    if (!encseed || encseed.length % 16 !== 0) $70db0fcce8592167$var$logger.throwArgumentError("invalid encseed", "json", json);
    const key = (0, $06d75ae17ce69367$export$3131421a7d01b4fb)((0, $529cc323d557cae2$export$448fa22aedc9dbca)(password, password, 2000, 32, "sha256")).slice(0, 16);
    const iv = encseed.slice(0, 16);
    const encryptedSeed = encseed.slice(16);
    // Decrypt the seed
    const aesCbc = new (0, (/*@__PURE__*/$parcel$interopDefault($3218055eb97e4543$exports))).ModeOfOperation.cbc(key, iv);
    const seed = (0, (/*@__PURE__*/$parcel$interopDefault($3218055eb97e4543$exports))).padding.pkcs7.strip((0, $06d75ae17ce69367$export$3131421a7d01b4fb)(aesCbc.decrypt(encryptedSeed)));
    // This wallet format is weird... Convert the binary encoded hex to a string.
    let seedHex = "";
    for(let i = 0; i < seed.length; i++)seedHex += String.fromCharCode(seed[i]);
    const seedHexBytes = (0, $7bbf1261c840221b$export$8feeb310b4b4752f)(seedHex);
    const privateKey = (0, $62e3396d458230e9$export$f8151fce47ad1c35)(seedHexBytes);
    return new $70db0fcce8592167$export$93a76d16f88f2b3({
        _isCrowdsaleAccount: true,
        address: ethaddr,
        privateKey: privateKey
    });
}



"use strict";
function $26486974307e9818$export$724d6cf6b9fd8578(json) {
    let data = null;
    try {
        data = JSON.parse(json);
    } catch (error) {
        return false;
    }
    return data.encseed && data.ethaddr;
}
function $26486974307e9818$export$67dc926b8e68b2d8(json) {
    let data = null;
    try {
        data = JSON.parse(json);
    } catch (error) {
        return false;
    }
    if (!data.version || parseInt(data.version) !== data.version || parseInt(data.version) !== 3) return false;
    // @TODO: Put more checks to make sure it has kdf, iv and all that good stuff
    return true;
}
function $26486974307e9818$export$9a68ee9f8f3afd38(json) {
    if ($26486974307e9818$export$724d6cf6b9fd8578(json)) try {
        return (0, $5652f239bab101de$export$88411125f012957a)(JSON.parse(json).ethaddr);
    } catch (error) {
        return null;
    }
    if ($26486974307e9818$export$67dc926b8e68b2d8(json)) try {
        return (0, $5652f239bab101de$export$88411125f012957a)(JSON.parse(json).address);
    } catch (error) {
        return null;
    }
    return null;
}


var $be05ce9377ca9978$exports = {};

$parcel$export($be05ce9377ca9978$exports, "decryptSync", function () { return $be05ce9377ca9978$export$9bd2c37889ee5e36; });
$parcel$export($be05ce9377ca9978$exports, "decrypt", function () { return $be05ce9377ca9978$export$e85a0c9a1067c5d3; });
$parcel$export($be05ce9377ca9978$exports, "encrypt", function () { return $be05ce9377ca9978$export$5b0f6292f11d1d18; });

var $4523557239bc64e5$exports = {};
"use strict";
(function(root) {
    const MAX_VALUE = 0x7fffffff;
    // The SHA256 and PBKDF2 implementation are from scrypt-async-js:
    // See: https://github.com/dchest/scrypt-async-js
    function SHA256(m) {
        const K = new Uint32Array([
            0x428a2f98,
            0x71374491,
            0xb5c0fbcf,
            0xe9b5dba5,
            0x3956c25b,
            0x59f111f1,
            0x923f82a4,
            0xab1c5ed5,
            0xd807aa98,
            0x12835b01,
            0x243185be,
            0x550c7dc3,
            0x72be5d74,
            0x80deb1fe,
            0x9bdc06a7,
            0xc19bf174,
            0xe49b69c1,
            0xefbe4786,
            0x0fc19dc6,
            0x240ca1cc,
            0x2de92c6f,
            0x4a7484aa,
            0x5cb0a9dc,
            0x76f988da,
            0x983e5152,
            0xa831c66d,
            0xb00327c8,
            0xbf597fc7,
            0xc6e00bf3,
            0xd5a79147,
            0x06ca6351,
            0x14292967,
            0x27b70a85,
            0x2e1b2138,
            0x4d2c6dfc,
            0x53380d13,
            0x650a7354,
            0x766a0abb,
            0x81c2c92e,
            0x92722c85,
            0xa2bfe8a1,
            0xa81a664b,
            0xc24b8b70,
            0xc76c51a3,
            0xd192e819,
            0xd6990624,
            0xf40e3585,
            0x106aa070,
            0x19a4c116,
            0x1e376c08,
            0x2748774c,
            0x34b0bcb5,
            0x391c0cb3,
            0x4ed8aa4a,
            0x5b9cca4f,
            0x682e6ff3,
            0x748f82ee,
            0x78a5636f,
            0x84c87814,
            0x8cc70208,
            0x90befffa,
            0xa4506ceb,
            0xbef9a3f7,
            0xc67178f2
        ]);
        let h0 = 0x6a09e667, h1 = 0xbb67ae85, h2 = 0x3c6ef372, h3 = 0xa54ff53a;
        let h4 = 0x510e527f, h5 = 0x9b05688c, h6 = 0x1f83d9ab, h7 = 0x5be0cd19;
        const w = new Uint32Array(64);
        function blocks(p) {
            let off = 0, len = p.length;
            while(len >= 64){
                let a = h0, b = h1, c = h2, d = h3, e = h4, f = h5, g = h6, h = h7, u, i, j, t1, t2;
                for(i = 0; i < 16; i++){
                    j = off + i * 4;
                    w[i] = (p[j] & 0xff) << 24 | (p[j + 1] & 0xff) << 16 | (p[j + 2] & 0xff) << 8 | p[j + 3] & 0xff;
                }
                for(i = 16; i < 64; i++){
                    u = w[i - 2];
                    t1 = (u >>> 17 | u << 15) ^ (u >>> 19 | u << 13) ^ u >>> 10;
                    u = w[i - 15];
                    t2 = (u >>> 7 | u << 25) ^ (u >>> 18 | u << 14) ^ u >>> 3;
                    w[i] = (t1 + w[i - 7] | 0) + (t2 + w[i - 16] | 0) | 0;
                }
                for(i = 0; i < 64; i++){
                    t1 = (((e >>> 6 | e << 26) ^ (e >>> 11 | e << 21) ^ (e >>> 25 | e << 7)) + (e & f ^ ~e & g) | 0) + (h + (K[i] + w[i] | 0) | 0) | 0;
                    t2 = ((a >>> 2 | a << 30) ^ (a >>> 13 | a << 19) ^ (a >>> 22 | a << 10)) + (a & b ^ a & c ^ b & c) | 0;
                    h = g;
                    g = f;
                    f = e;
                    e = d + t1 | 0;
                    d = c;
                    c = b;
                    b = a;
                    a = t1 + t2 | 0;
                }
                h0 = h0 + a | 0;
                h1 = h1 + b | 0;
                h2 = h2 + c | 0;
                h3 = h3 + d | 0;
                h4 = h4 + e | 0;
                h5 = h5 + f | 0;
                h6 = h6 + g | 0;
                h7 = h7 + h | 0;
                off += 64;
                len -= 64;
            }
        }
        blocks(m);
        let i, bytesLeft = m.length % 64, bitLenHi = m.length / 0x20000000 | 0, bitLenLo = m.length << 3, numZeros = bytesLeft < 56 ? 56 : 120, p = m.slice(m.length - bytesLeft, m.length);
        p.push(0x80);
        for(i = bytesLeft + 1; i < numZeros; i++)p.push(0);
        p.push(bitLenHi >>> 24 & 0xff);
        p.push(bitLenHi >>> 16 & 0xff);
        p.push(bitLenHi >>> 8 & 0xff);
        p.push(bitLenHi >>> 0 & 0xff);
        p.push(bitLenLo >>> 24 & 0xff);
        p.push(bitLenLo >>> 16 & 0xff);
        p.push(bitLenLo >>> 8 & 0xff);
        p.push(bitLenLo >>> 0 & 0xff);
        blocks(p);
        return [
            h0 >>> 24 & 0xff,
            h0 >>> 16 & 0xff,
            h0 >>> 8 & 0xff,
            h0 >>> 0 & 0xff,
            h1 >>> 24 & 0xff,
            h1 >>> 16 & 0xff,
            h1 >>> 8 & 0xff,
            h1 >>> 0 & 0xff,
            h2 >>> 24 & 0xff,
            h2 >>> 16 & 0xff,
            h2 >>> 8 & 0xff,
            h2 >>> 0 & 0xff,
            h3 >>> 24 & 0xff,
            h3 >>> 16 & 0xff,
            h3 >>> 8 & 0xff,
            h3 >>> 0 & 0xff,
            h4 >>> 24 & 0xff,
            h4 >>> 16 & 0xff,
            h4 >>> 8 & 0xff,
            h4 >>> 0 & 0xff,
            h5 >>> 24 & 0xff,
            h5 >>> 16 & 0xff,
            h5 >>> 8 & 0xff,
            h5 >>> 0 & 0xff,
            h6 >>> 24 & 0xff,
            h6 >>> 16 & 0xff,
            h6 >>> 8 & 0xff,
            h6 >>> 0 & 0xff,
            h7 >>> 24 & 0xff,
            h7 >>> 16 & 0xff,
            h7 >>> 8 & 0xff,
            h7 >>> 0 & 0xff
        ];
    }
    function PBKDF2_HMAC_SHA256_OneIter(password, salt, dkLen) {
        // compress password if it's longer than hash block length
        password = password.length <= 64 ? password : SHA256(password);
        const innerLen = 64 + salt.length + 4;
        const inner = new Array(innerLen);
        const outerKey = new Array(64);
        let i;
        let dk = [];
        // inner = (password ^ ipad) || salt || counter
        for(i = 0; i < 64; i++)inner[i] = 0x36;
        for(i = 0; i < password.length; i++)inner[i] ^= password[i];
        for(i = 0; i < salt.length; i++)inner[64 + i] = salt[i];
        for(i = innerLen - 4; i < innerLen; i++)inner[i] = 0;
        // outerKey = password ^ opad
        for(i = 0; i < 64; i++)outerKey[i] = 0x5c;
        for(i = 0; i < password.length; i++)outerKey[i] ^= password[i];
        // increments counter inside inner
        function incrementCounter() {
            for(let i = innerLen - 1; i >= innerLen - 4; i--){
                inner[i]++;
                if (inner[i] <= 0xff) return;
                inner[i] = 0;
            }
        }
        // output blocks = SHA256(outerKey || SHA256(inner)) ...
        while(dkLen >= 32){
            incrementCounter();
            dk = dk.concat(SHA256(outerKey.concat(SHA256(inner))));
            dkLen -= 32;
        }
        if (dkLen > 0) {
            incrementCounter();
            dk = dk.concat(SHA256(outerKey.concat(SHA256(inner))).slice(0, dkLen));
        }
        return dk;
    }
    // The following is an adaptation of scryptsy
    // See: https://www.npmjs.com/package/scryptsy
    function blockmix_salsa8(BY, Yi, r, x, _X) {
        let i;
        arraycopy(BY, (2 * r - 1) * 16, _X, 0, 16);
        for(i = 0; i < 2 * r; i++){
            blockxor(BY, i * 16, _X, 16);
            salsa20_8(_X, x);
            arraycopy(_X, 0, BY, Yi + i * 16, 16);
        }
        for(i = 0; i < r; i++)arraycopy(BY, Yi + i * 32, BY, i * 16, 16);
        for(i = 0; i < r; i++)arraycopy(BY, Yi + (i * 2 + 1) * 16, BY, (i + r) * 16, 16);
    }
    function R(a, b) {
        return a << b | a >>> 32 - b;
    }
    function salsa20_8(B, x) {
        arraycopy(B, 0, x, 0, 16);
        for(let i = 8; i > 0; i -= 2){
            x[4] ^= R(x[0] + x[12], 7);
            x[8] ^= R(x[4] + x[0], 9);
            x[12] ^= R(x[8] + x[4], 13);
            x[0] ^= R(x[12] + x[8], 18);
            x[9] ^= R(x[5] + x[1], 7);
            x[13] ^= R(x[9] + x[5], 9);
            x[1] ^= R(x[13] + x[9], 13);
            x[5] ^= R(x[1] + x[13], 18);
            x[14] ^= R(x[10] + x[6], 7);
            x[2] ^= R(x[14] + x[10], 9);
            x[6] ^= R(x[2] + x[14], 13);
            x[10] ^= R(x[6] + x[2], 18);
            x[3] ^= R(x[15] + x[11], 7);
            x[7] ^= R(x[3] + x[15], 9);
            x[11] ^= R(x[7] + x[3], 13);
            x[15] ^= R(x[11] + x[7], 18);
            x[1] ^= R(x[0] + x[3], 7);
            x[2] ^= R(x[1] + x[0], 9);
            x[3] ^= R(x[2] + x[1], 13);
            x[0] ^= R(x[3] + x[2], 18);
            x[6] ^= R(x[5] + x[4], 7);
            x[7] ^= R(x[6] + x[5], 9);
            x[4] ^= R(x[7] + x[6], 13);
            x[5] ^= R(x[4] + x[7], 18);
            x[11] ^= R(x[10] + x[9], 7);
            x[8] ^= R(x[11] + x[10], 9);
            x[9] ^= R(x[8] + x[11], 13);
            x[10] ^= R(x[9] + x[8], 18);
            x[12] ^= R(x[15] + x[14], 7);
            x[13] ^= R(x[12] + x[15], 9);
            x[14] ^= R(x[13] + x[12], 13);
            x[15] ^= R(x[14] + x[13], 18);
        }
        for(let i = 0; i < 16; ++i)B[i] += x[i];
    }
    // naive approach... going back to loop unrolling may yield additional performance
    function blockxor(S, Si, D, len) {
        for(let i = 0; i < len; i++)D[i] ^= S[Si + i];
    }
    function arraycopy(src, srcPos, dest, destPos, length) {
        while(length--)dest[destPos++] = src[srcPos++];
    }
    function checkBufferish(o) {
        if (!o || typeof o.length !== "number") return false;
        for(let i = 0; i < o.length; i++){
            const v = o[i];
            if (typeof v !== "number" || v % 1 || v < 0 || v >= 256) return false;
        }
        return true;
    }
    function ensureInteger(value, name) {
        if (typeof value !== "number" || value % 1) throw new Error("invalid " + name);
        return value;
    }
    // N = Cpu cost, r = Memory cost, p = parallelization cost
    // callback(error, progress, key)
    function _scrypt(password, salt, N, r, p, dkLen, callback) {
        N = ensureInteger(N, "N");
        r = ensureInteger(r, "r");
        p = ensureInteger(p, "p");
        dkLen = ensureInteger(dkLen, "dkLen");
        if (N === 0 || (N & N - 1) !== 0) throw new Error("N must be power of 2");
        if (N > MAX_VALUE / 128 / r) throw new Error("N too large");
        if (r > MAX_VALUE / 128 / p) throw new Error("r too large");
        if (!checkBufferish(password)) throw new Error("password must be an array or buffer");
        password = Array.prototype.slice.call(password);
        if (!checkBufferish(salt)) throw new Error("salt must be an array or buffer");
        salt = Array.prototype.slice.call(salt);
        let b = PBKDF2_HMAC_SHA256_OneIter(password, salt, p * 128 * r);
        const B = new Uint32Array(p * 32 * r);
        for(let i = 0; i < B.length; i++){
            const j = i * 4;
            B[i] = (b[j + 3] & 0xff) << 24 | (b[j + 2] & 0xff) << 16 | (b[j + 1] & 0xff) << 8 | (b[j + 0] & 0xff) << 0;
        }
        const XY = new Uint32Array(64 * r);
        const V = new Uint32Array(32 * r * N);
        const Yi = 32 * r;
        // scratch space
        const x = new Uint32Array(16); // salsa20_8
        const _X = new Uint32Array(16); // blockmix_salsa8
        const totalOps = p * N * 2;
        let currentOp = 0;
        let lastPercent10 = null;
        // Set this to true to abandon the scrypt on the next step
        let stop = false;
        // State information
        let state = 0;
        let i0 = 0, i1;
        let Bi;
        // How many blockmix_salsa8 can we do per step?
        const limit = callback ? parseInt(1000 / r) : 0xffffffff;
        // Trick from scrypt-async; if there is a setImmediate shim in place, use it
        const nextTick = typeof setImmediate !== "undefined" ? setImmediate : setTimeout;
        // This is really all I changed; making scryptsy a state machine so we occasionally
        // stop and give other evnts on the evnt loop a chance to run. ~RicMoo
        const incrementalSMix = function() {
            if (stop) return callback(new Error("cancelled"), currentOp / totalOps);
            let steps;
            switch(state){
                case 0:
                    // for (var i = 0; i < p; i++)...
                    Bi = i0 * 32 * r;
                    arraycopy(B, Bi, XY, 0, Yi); // ROMix - 1
                    state = 1; // Move to ROMix 2
                    i1 = 0;
                // Fall through
                case 1:
                    // Run up to 1000 steps of the first inner smix loop
                    steps = N - i1;
                    if (steps > limit) steps = limit;
                    for(let i = 0; i < steps; i++){
                        arraycopy(XY, 0, V, (i1 + i) * Yi, Yi) // ROMix - 3
                        ;
                        blockmix_salsa8(XY, Yi, r, x, _X); // ROMix - 4
                    }
                    // for (var i = 0; i < N; i++)
                    i1 += steps;
                    currentOp += steps;
                    if (callback) {
                        // Call the callback with the progress (optionally stopping us)
                        const percent10 = parseInt(1000 * currentOp / totalOps);
                        if (percent10 !== lastPercent10) {
                            stop = callback(null, currentOp / totalOps);
                            if (stop) break;
                            lastPercent10 = percent10;
                        }
                    }
                    if (i1 < N) break;
                    i1 = 0; // Move to ROMix 6
                    state = 2;
                // Fall through
                case 2:
                    // Run up to 1000 steps of the second inner smix loop
                    steps = N - i1;
                    if (steps > limit) steps = limit;
                    for(let i = 0; i < steps; i++){
                        const offset = (2 * r - 1) * 16; // ROMix - 7
                        const j = XY[offset] & N - 1;
                        blockxor(V, j * Yi, XY, Yi); // ROMix - 8 (inner)
                        blockmix_salsa8(XY, Yi, r, x, _X); // ROMix - 9 (outer)
                    }
                    // for (var i = 0; i < N; i++)...
                    i1 += steps;
                    currentOp += steps;
                    // Call the callback with the progress (optionally stopping us)
                    if (callback) {
                        const percent10 = parseInt(1000 * currentOp / totalOps);
                        if (percent10 !== lastPercent10) {
                            stop = callback(null, currentOp / totalOps);
                            if (stop) break;
                            lastPercent10 = percent10;
                        }
                    }
                    if (i1 < N) break;
                    arraycopy(XY, 0, B, Bi, Yi); // ROMix - 10
                    // for (var i = 0; i < p; i++)...
                    i0++;
                    if (i0 < p) {
                        state = 0;
                        break;
                    }
                    b = [];
                    for(let i = 0; i < B.length; i++){
                        b.push(B[i] >> 0 & 0xff);
                        b.push(B[i] >> 8 & 0xff);
                        b.push(B[i] >> 16 & 0xff);
                        b.push(B[i] >> 24 & 0xff);
                    }
                    const derivedKey = PBKDF2_HMAC_SHA256_OneIter(password, b, dkLen);
                    // Send the result to the callback
                    if (callback) callback(null, 1.0, derivedKey);
                    // Done; don't break (which would reschedule)
                    return derivedKey;
            }
            // Schedule the next steps
            if (callback) nextTick(incrementalSMix);
        };
        // Run the smix state machine until completion
        if (!callback) while(true){
            const derivedKey = incrementalSMix();
            if (derivedKey != undefined) return derivedKey;
        }
        // Bootstrap the async incremental smix
        incrementalSMix();
    }
    const lib = {
        scrypt: function(password, salt, N, r, p, dkLen, progressCallback) {
            return new Promise(function(resolve, reject) {
                let lastProgress = 0;
                if (progressCallback) progressCallback(0);
                _scrypt(password, salt, N, r, p, dkLen, function(error, progress, key) {
                    if (error) reject(error);
                    else if (key) {
                        if (progressCallback && lastProgress !== 1) progressCallback(1);
                        resolve(new Uint8Array(key));
                    } else if (progressCallback && progress !== lastProgress) {
                        lastProgress = progress;
                        return progressCallback(progress);
                    }
                });
            });
        },
        syncScrypt: function(password, salt, N, r, p, dkLen) {
            return new Uint8Array(_scrypt(password, salt, N, r, p, dkLen));
        }
    };
    // node.js
    if (typeof $4523557239bc64e5$exports !== "undefined") $4523557239bc64e5$exports = lib;
    else if (typeof define === "function" && define.amd) define(lib);
    else if (root) {
        // If there was an existing library "scrypt", make sure it is still available
        if (root.scrypt) root._scrypt = root.scrypt;
        root.scrypt = lib;
    }
})($4523557239bc64e5$exports);













"use strict";
var $be05ce9377ca9978$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
const $be05ce9377ca9978$var$logger = new (0, $5f596c9584f643ae$export$efa9a398d6368992)((0, $86419f3d35c6552e$export$83d89fbfd8236492));
// Exported Types
function $be05ce9377ca9978$var$hasMnemonic(value) {
    return value != null && value.mnemonic && value.mnemonic.phrase;
}
class $be05ce9377ca9978$export$cf9dc4fd6dde0315 extends (0, $d2d9b472f7878d5e$exports.Description) {
    isKeystoreAccount(value) {
        return !!(value && value._isKeystoreAccount);
    }
}
function $be05ce9377ca9978$var$_decrypt(data, key, ciphertext) {
    const cipher = (0, $b1de86b722ca4f68$export$5a5c1dbd910e2c32)(data, "crypto/cipher");
    if (cipher === "aes-128-ctr") {
        const iv = (0, $b1de86b722ca4f68$export$2cde08bde0cfd932)((0, $b1de86b722ca4f68$export$5a5c1dbd910e2c32)(data, "crypto/cipherparams/iv"));
        const counter = new (0, (/*@__PURE__*/$parcel$interopDefault($3218055eb97e4543$exports))).Counter(iv);
        const aesCtr = new (0, (/*@__PURE__*/$parcel$interopDefault($3218055eb97e4543$exports))).ModeOfOperation.ctr(key, counter);
        return (0, $06d75ae17ce69367$export$3131421a7d01b4fb)(aesCtr.decrypt(ciphertext));
    }
    return null;
}
function $be05ce9377ca9978$var$_getAccount(data, key) {
    const ciphertext = (0, $b1de86b722ca4f68$export$2cde08bde0cfd932)((0, $b1de86b722ca4f68$export$5a5c1dbd910e2c32)(data, "crypto/ciphertext"));
    const computedMAC = (0, $06d75ae17ce69367$export$2b0d6b5fbe698c70)((0, $62e3396d458230e9$export$f8151fce47ad1c35)((0, $06d75ae17ce69367$export$ee1b3e54f0441b22)([
        key.slice(16, 32),
        ciphertext
    ]))).substring(2);
    if (computedMAC !== (0, $b1de86b722ca4f68$export$5a5c1dbd910e2c32)(data, "crypto/mac").toLowerCase()) throw new Error("invalid password");
    const privateKey = $be05ce9377ca9978$var$_decrypt(data, key.slice(0, 16), ciphertext);
    if (!privateKey) $be05ce9377ca9978$var$logger.throwError("unsupported cipher", (0, $5f596c9584f643ae$export$efa9a398d6368992).errors.UNSUPPORTED_OPERATION, {
        operation: "decrypt"
    });
    const mnemonicKey = key.slice(32, 64);
    const address = (0, $4335107f861a4482$export$e67e2732ba9803f9)(privateKey);
    if (data.address) {
        let check = data.address.toLowerCase();
        if (check.substring(0, 2) !== "0x") check = "0x" + check;
        if ((0, $5652f239bab101de$export$88411125f012957a)(check) !== address) throw new Error("address mismatch");
    }
    const account = {
        _isKeystoreAccount: true,
        address: address,
        privateKey: (0, $06d75ae17ce69367$export$2b0d6b5fbe698c70)(privateKey)
    };
    // Version 0.1 x-ethers metadata must contain an encrypted mnemonic phrase
    if ((0, $b1de86b722ca4f68$export$5a5c1dbd910e2c32)(data, "x-ethers/version") === "0.1") {
        const mnemonicCiphertext = (0, $b1de86b722ca4f68$export$2cde08bde0cfd932)((0, $b1de86b722ca4f68$export$5a5c1dbd910e2c32)(data, "x-ethers/mnemonicCiphertext"));
        const mnemonicIv = (0, $b1de86b722ca4f68$export$2cde08bde0cfd932)((0, $b1de86b722ca4f68$export$5a5c1dbd910e2c32)(data, "x-ethers/mnemonicCounter"));
        const mnemonicCounter = new (0, (/*@__PURE__*/$parcel$interopDefault($3218055eb97e4543$exports))).Counter(mnemonicIv);
        const mnemonicAesCtr = new (0, (/*@__PURE__*/$parcel$interopDefault($3218055eb97e4543$exports))).ModeOfOperation.ctr(mnemonicKey, mnemonicCounter);
        const path = (0, $b1de86b722ca4f68$export$5a5c1dbd910e2c32)(data, "x-ethers/path") || (0, $2c3deea0882bd090$export$d48ad89f7e11a603);
        const locale = (0, $b1de86b722ca4f68$export$5a5c1dbd910e2c32)(data, "x-ethers/locale") || "en";
        const entropy = (0, $06d75ae17ce69367$export$3131421a7d01b4fb)(mnemonicAesCtr.decrypt(mnemonicCiphertext));
        try {
            const mnemonic = (0, $2c3deea0882bd090$export$4becd65eb23312e6)(entropy, locale);
            const node = (0, $2c3deea0882bd090$export$b68640c53e22b952).fromMnemonic(mnemonic, null, locale).derivePath(path);
            if (node.privateKey != account.privateKey) throw new Error("mnemonic mismatch");
            account.mnemonic = node.mnemonic;
        } catch (error) {
            // If we don't have the locale wordlist installed to
            // read this mnemonic, just bail and don't set the
            // mnemonic
            if (error.code !== (0, $5f596c9584f643ae$export$efa9a398d6368992).errors.INVALID_ARGUMENT || error.argument !== "wordlist") throw error;
        }
    }
    return new $be05ce9377ca9978$export$cf9dc4fd6dde0315(account);
}
function $be05ce9377ca9978$var$pbkdf2Sync(passwordBytes, salt, count, dkLen, prfFunc) {
    return (0, $06d75ae17ce69367$export$3131421a7d01b4fb)((0, $529cc323d557cae2$export$448fa22aedc9dbca)(passwordBytes, salt, count, dkLen, prfFunc));
}
function $be05ce9377ca9978$var$pbkdf2(passwordBytes, salt, count, dkLen, prfFunc) {
    return Promise.resolve($be05ce9377ca9978$var$pbkdf2Sync(passwordBytes, salt, count, dkLen, prfFunc));
}
function $be05ce9377ca9978$var$_computeKdfKey(data, password, pbkdf2Func, scryptFunc, progressCallback) {
    const passwordBytes = (0, $b1de86b722ca4f68$export$350bd33120f7413e)(password);
    const kdf = (0, $b1de86b722ca4f68$export$5a5c1dbd910e2c32)(data, "crypto/kdf");
    if (kdf && typeof kdf === "string") {
        const throwError = function(name, value) {
            return $be05ce9377ca9978$var$logger.throwArgumentError("invalid key-derivation function parameters", name, value);
        };
        if (kdf.toLowerCase() === "scrypt") {
            const salt = (0, $b1de86b722ca4f68$export$2cde08bde0cfd932)((0, $b1de86b722ca4f68$export$5a5c1dbd910e2c32)(data, "crypto/kdfparams/salt"));
            const N = parseInt((0, $b1de86b722ca4f68$export$5a5c1dbd910e2c32)(data, "crypto/kdfparams/n"));
            const r = parseInt((0, $b1de86b722ca4f68$export$5a5c1dbd910e2c32)(data, "crypto/kdfparams/r"));
            const p = parseInt((0, $b1de86b722ca4f68$export$5a5c1dbd910e2c32)(data, "crypto/kdfparams/p"));
            // Check for all required parameters
            if (!N || !r || !p) throwError("kdf", kdf);
            // Make sure N is a power of 2
            if ((N & N - 1) !== 0) throwError("N", N);
            const dkLen = parseInt((0, $b1de86b722ca4f68$export$5a5c1dbd910e2c32)(data, "crypto/kdfparams/dklen"));
            if (dkLen !== 32) throwError("dklen", dkLen);
            return scryptFunc(passwordBytes, salt, N, r, p, 64, progressCallback);
        } else if (kdf.toLowerCase() === "pbkdf2") {
            const salt = (0, $b1de86b722ca4f68$export$2cde08bde0cfd932)((0, $b1de86b722ca4f68$export$5a5c1dbd910e2c32)(data, "crypto/kdfparams/salt"));
            let prfFunc = null;
            const prf = (0, $b1de86b722ca4f68$export$5a5c1dbd910e2c32)(data, "crypto/kdfparams/prf");
            if (prf === "hmac-sha256") prfFunc = "sha256";
            else if (prf === "hmac-sha512") prfFunc = "sha512";
            else throwError("prf", prf);
            const count = parseInt((0, $b1de86b722ca4f68$export$5a5c1dbd910e2c32)(data, "crypto/kdfparams/c"));
            const dkLen = parseInt((0, $b1de86b722ca4f68$export$5a5c1dbd910e2c32)(data, "crypto/kdfparams/dklen"));
            if (dkLen !== 32) throwError("dklen", dkLen);
            return pbkdf2Func(passwordBytes, salt, count, dkLen, prfFunc);
        }
    }
    return $be05ce9377ca9978$var$logger.throwArgumentError("unsupported key-derivation function", "kdf", kdf);
}
function $be05ce9377ca9978$export$9bd2c37889ee5e36(json, password) {
    const data = JSON.parse(json);
    const key = $be05ce9377ca9978$var$_computeKdfKey(data, password, $be05ce9377ca9978$var$pbkdf2Sync, (0, (/*@__PURE__*/$parcel$interopDefault($4523557239bc64e5$exports))).syncScrypt);
    return $be05ce9377ca9978$var$_getAccount(data, key);
}
function $be05ce9377ca9978$export$e85a0c9a1067c5d3(json, password, progressCallback) {
    return $be05ce9377ca9978$var$__awaiter(this, void 0, void 0, function*() {
        const data = JSON.parse(json);
        const key = yield $be05ce9377ca9978$var$_computeKdfKey(data, password, $be05ce9377ca9978$var$pbkdf2, (0, (/*@__PURE__*/$parcel$interopDefault($4523557239bc64e5$exports))).scrypt, progressCallback);
        return $be05ce9377ca9978$var$_getAccount(data, key);
    });
}
function $be05ce9377ca9978$export$5b0f6292f11d1d18(account, password, options, progressCallback) {
    try {
        // Check the address matches the private key
        if ((0, $5652f239bab101de$export$88411125f012957a)(account.address) !== (0, $4335107f861a4482$export$e67e2732ba9803f9)(account.privateKey)) throw new Error("address/privateKey mismatch");
        // Check the mnemonic (if any) matches the private key
        if ($be05ce9377ca9978$var$hasMnemonic(account)) {
            const mnemonic = account.mnemonic;
            const node = (0, $2c3deea0882bd090$export$b68640c53e22b952).fromMnemonic(mnemonic.phrase, null, mnemonic.locale).derivePath(mnemonic.path || (0, $2c3deea0882bd090$export$d48ad89f7e11a603));
            if (node.privateKey != account.privateKey) throw new Error("mnemonic mismatch");
        }
    } catch (e) {
        return Promise.reject(e);
    }
    // The options are optional, so adjust the call as needed
    if (typeof options === "function" && !progressCallback) {
        progressCallback = options;
        options = {};
    }
    if (!options) options = {};
    const privateKey = (0, $06d75ae17ce69367$export$3131421a7d01b4fb)(account.privateKey);
    const passwordBytes = (0, $b1de86b722ca4f68$export$350bd33120f7413e)(password);
    let entropy = null;
    let path = null;
    let locale = null;
    if ($be05ce9377ca9978$var$hasMnemonic(account)) {
        const srcMnemonic = account.mnemonic;
        entropy = (0, $06d75ae17ce69367$export$3131421a7d01b4fb)((0, $2c3deea0882bd090$export$135e090d58b310ca)(srcMnemonic.phrase, srcMnemonic.locale || "en"));
        path = srcMnemonic.path || (0, $2c3deea0882bd090$export$d48ad89f7e11a603);
        locale = srcMnemonic.locale || "en";
    }
    let client = options.client;
    if (!client) client = "ethers.js";
    // Check/generate the salt
    let salt = null;
    if (options.salt) salt = (0, $06d75ae17ce69367$export$3131421a7d01b4fb)(options.salt);
    else salt = (0, $0a998708283ccc39$export$5f828d93ff035aa8)(32);
    // Override initialization vector
    let iv = null;
    if (options.iv) {
        iv = (0, $06d75ae17ce69367$export$3131421a7d01b4fb)(options.iv);
        if (iv.length !== 16) throw new Error("invalid iv");
    } else iv = (0, $0a998708283ccc39$export$5f828d93ff035aa8)(16);
    // Override the uuid
    let uuidRandom = null;
    if (options.uuid) {
        uuidRandom = (0, $06d75ae17ce69367$export$3131421a7d01b4fb)(options.uuid);
        if (uuidRandom.length !== 16) throw new Error("invalid uuid");
    } else uuidRandom = (0, $0a998708283ccc39$export$5f828d93ff035aa8)(16);
    // Override the scrypt password-based key derivation function parameters
    let N = 131072, r = 8, p = 1;
    if (options.scrypt) {
        if (options.scrypt.N) N = options.scrypt.N;
        if (options.scrypt.r) r = options.scrypt.r;
        if (options.scrypt.p) p = options.scrypt.p;
    }
    // We take 64 bytes:
    //   - 32 bytes   As normal for the Web3 secret storage (derivedKey, macPrefix)
    //   - 32 bytes   AES key to encrypt mnemonic with (required here to be Ethers Wallet)
    return (0, (/*@__PURE__*/$parcel$interopDefault($4523557239bc64e5$exports))).scrypt(passwordBytes, salt, N, r, p, 64, progressCallback).then((key)=>{
        key = (0, $06d75ae17ce69367$export$3131421a7d01b4fb)(key);
        // This will be used to encrypt the wallet (as per Web3 secret storage)
        const derivedKey = key.slice(0, 16);
        const macPrefix = key.slice(16, 32);
        // This will be used to encrypt the mnemonic phrase (if any)
        const mnemonicKey = key.slice(32, 64);
        // Encrypt the private key
        const counter = new (0, (/*@__PURE__*/$parcel$interopDefault($3218055eb97e4543$exports))).Counter(iv);
        const aesCtr = new (0, (/*@__PURE__*/$parcel$interopDefault($3218055eb97e4543$exports))).ModeOfOperation.ctr(derivedKey, counter);
        const ciphertext = (0, $06d75ae17ce69367$export$3131421a7d01b4fb)(aesCtr.encrypt(privateKey));
        // Compute the message authentication code, used to check the password
        const mac = (0, $62e3396d458230e9$export$f8151fce47ad1c35)((0, $06d75ae17ce69367$export$ee1b3e54f0441b22)([
            macPrefix,
            ciphertext
        ]));
        // See: https://github.com/ethereum/wiki/wiki/Web3-Secret-Storage-Definition
        const data = {
            address: account.address.substring(2).toLowerCase(),
            id: (0, $b1de86b722ca4f68$export$ec7b18ebad55a3a9)(uuidRandom),
            version: 3,
            crypto: {
                cipher: "aes-128-ctr",
                cipherparams: {
                    iv: (0, $06d75ae17ce69367$export$2b0d6b5fbe698c70)(iv).substring(2)
                },
                ciphertext: (0, $06d75ae17ce69367$export$2b0d6b5fbe698c70)(ciphertext).substring(2),
                kdf: "scrypt",
                kdfparams: {
                    salt: (0, $06d75ae17ce69367$export$2b0d6b5fbe698c70)(salt).substring(2),
                    n: N,
                    dklen: 32,
                    p: p,
                    r: r
                },
                mac: mac.substring(2)
            }
        };
        // If we have a mnemonic, encrypt it into the JSON wallet
        if (entropy) {
            const mnemonicIv = (0, $0a998708283ccc39$export$5f828d93ff035aa8)(16);
            const mnemonicCounter = new (0, (/*@__PURE__*/$parcel$interopDefault($3218055eb97e4543$exports))).Counter(mnemonicIv);
            const mnemonicAesCtr = new (0, (/*@__PURE__*/$parcel$interopDefault($3218055eb97e4543$exports))).ModeOfOperation.ctr(mnemonicKey, mnemonicCounter);
            const mnemonicCiphertext = (0, $06d75ae17ce69367$export$3131421a7d01b4fb)(mnemonicAesCtr.encrypt(entropy));
            const now = new Date();
            const timestamp = now.getUTCFullYear() + "-" + (0, $b1de86b722ca4f68$export$67752b99d3bc61c6)(now.getUTCMonth() + 1, 2) + "-" + (0, $b1de86b722ca4f68$export$67752b99d3bc61c6)(now.getUTCDate(), 2) + "T" + (0, $b1de86b722ca4f68$export$67752b99d3bc61c6)(now.getUTCHours(), 2) + "-" + (0, $b1de86b722ca4f68$export$67752b99d3bc61c6)(now.getUTCMinutes(), 2) + "-" + (0, $b1de86b722ca4f68$export$67752b99d3bc61c6)(now.getUTCSeconds(), 2) + ".0Z";
            data["x-ethers"] = {
                client: client,
                gethFilename: "UTC--" + timestamp + "--" + data.address,
                mnemonicCounter: (0, $06d75ae17ce69367$export$2b0d6b5fbe698c70)(mnemonicIv).substring(2),
                mnemonicCiphertext: (0, $06d75ae17ce69367$export$2b0d6b5fbe698c70)(mnemonicCiphertext).substring(2),
                path: path,
                locale: locale,
                version: "0.1"
            };
        }
        return JSON.stringify(data);
    });
}


"use strict";
function $96dc61236f851eb2$export$e74fcde37488267a(json, password, progressCallback) {
    if ((0, $26486974307e9818$export$724d6cf6b9fd8578)(json)) {
        if (progressCallback) progressCallback(0);
        const account = (0, $70db0fcce8592167$export$e85a0c9a1067c5d3)(json, password);
        if (progressCallback) progressCallback(1);
        return Promise.resolve(account);
    }
    if ((0, $26486974307e9818$export$67dc926b8e68b2d8)(json)) return (0, $be05ce9377ca9978$exports.decrypt)(json, password, progressCallback);
    return Promise.reject(new Error("invalid JSON wallet"));
}
function $96dc61236f851eb2$export$7a81c437a678891a(json, password) {
    if ((0, $26486974307e9818$export$724d6cf6b9fd8578)(json)) return (0, $70db0fcce8592167$export$e85a0c9a1067c5d3)(json, password);
    if ((0, $26486974307e9818$export$67dc926b8e68b2d8)(json)) return (0, $be05ce9377ca9978$exports.decryptSync)(json, password);
    throw new Error("invalid JSON wallet");
}




const $582ad2d6c5eed489$export$83d89fbfd8236492 = "wallet/5.7.0";


"use strict";
var $cf67a8ebc5cb0c41$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
const $cf67a8ebc5cb0c41$var$logger = new (0, $5f596c9584f643ae$export$efa9a398d6368992)((0, $582ad2d6c5eed489$export$83d89fbfd8236492));
function $cf67a8ebc5cb0c41$var$isAccount(value) {
    return value != null && (0, $06d75ae17ce69367$export$b02a40aff8e4ad18)(value.privateKey, 32) && value.address != null;
}
function $cf67a8ebc5cb0c41$var$hasMnemonic(value) {
    const mnemonic = value.mnemonic;
    return mnemonic && mnemonic.phrase;
}
class $cf67a8ebc5cb0c41$export$bcca3ea514774656 extends (0, $04afbe51d47fcc12$exports.Signer) {
    constructor(privateKey, provider){
        super();
        if ($cf67a8ebc5cb0c41$var$isAccount(privateKey)) {
            const signingKey = new (0, $49ebbfa7c2be841e$export$21643ca94aed3e83)(privateKey.privateKey);
            (0, $d2d9b472f7878d5e$exports.defineReadOnly)(this, "_signingKey", ()=>signingKey);
            (0, $d2d9b472f7878d5e$exports.defineReadOnly)(this, "address", (0, $4335107f861a4482$export$e67e2732ba9803f9)(this.publicKey));
            if (this.address !== (0, $5652f239bab101de$export$88411125f012957a)(privateKey.address)) $cf67a8ebc5cb0c41$var$logger.throwArgumentError("privateKey/address mismatch", "privateKey", "[REDACTED]");
            if ($cf67a8ebc5cb0c41$var$hasMnemonic(privateKey)) {
                const srcMnemonic = privateKey.mnemonic;
                (0, $d2d9b472f7878d5e$exports.defineReadOnly)(this, "_mnemonic", ()=>({
                        phrase: srcMnemonic.phrase,
                        path: srcMnemonic.path || (0, $2c3deea0882bd090$export$d48ad89f7e11a603),
                        locale: srcMnemonic.locale || "en"
                    }));
                const mnemonic = this.mnemonic;
                const node = (0, $2c3deea0882bd090$export$b68640c53e22b952).fromMnemonic(mnemonic.phrase, null, mnemonic.locale).derivePath(mnemonic.path);
                if ((0, $4335107f861a4482$export$e67e2732ba9803f9)(node.privateKey) !== this.address) $cf67a8ebc5cb0c41$var$logger.throwArgumentError("mnemonic/address mismatch", "privateKey", "[REDACTED]");
            } else (0, $d2d9b472f7878d5e$exports.defineReadOnly)(this, "_mnemonic", ()=>null);
        } else {
            if ((0, $49ebbfa7c2be841e$export$21643ca94aed3e83).isSigningKey(privateKey)) {
                /* istanbul ignore if */ if (privateKey.curve !== "secp256k1") $cf67a8ebc5cb0c41$var$logger.throwArgumentError("unsupported curve; must be secp256k1", "privateKey", "[REDACTED]");
                (0, $d2d9b472f7878d5e$exports.defineReadOnly)(this, "_signingKey", ()=>privateKey);
            } else {
                // A lot of common tools do not prefix private keys with a 0x (see: #1166)
                if (typeof privateKey === "string") {
                    if (privateKey.match(/^[0-9a-f]*$/i) && privateKey.length === 64) privateKey = "0x" + privateKey;
                }
                const signingKey = new (0, $49ebbfa7c2be841e$export$21643ca94aed3e83)(privateKey);
                (0, $d2d9b472f7878d5e$exports.defineReadOnly)(this, "_signingKey", ()=>signingKey);
            }
            (0, $d2d9b472f7878d5e$exports.defineReadOnly)(this, "_mnemonic", ()=>null);
            (0, $d2d9b472f7878d5e$exports.defineReadOnly)(this, "address", (0, $4335107f861a4482$export$e67e2732ba9803f9)(this.publicKey));
        }
        /* istanbul ignore if */ if (provider && !(0, $9f78b76a8aa61745$exports.Provider).isProvider(provider)) $cf67a8ebc5cb0c41$var$logger.throwArgumentError("invalid provider", "provider", provider);
        (0, $d2d9b472f7878d5e$exports.defineReadOnly)(this, "provider", provider || null);
    }
    get mnemonic() {
        return this._mnemonic();
    }
    get privateKey() {
        return this._signingKey().privateKey;
    }
    get publicKey() {
        return this._signingKey().publicKey;
    }
    getAddress() {
        return Promise.resolve(this.address);
    }
    connect(provider) {
        return new $cf67a8ebc5cb0c41$export$bcca3ea514774656(this, provider);
    }
    signTransaction(transaction) {
        return (0, $d2d9b472f7878d5e$exports.resolveProperties)(transaction).then((tx)=>{
            if (tx.from != null) {
                if ((0, $5652f239bab101de$export$88411125f012957a)(tx.from) !== this.address) $cf67a8ebc5cb0c41$var$logger.throwArgumentError("transaction from address mismatch", "transaction.from", transaction.from);
                delete tx.from;
            }
            const signature = this._signingKey().signDigest((0, $62e3396d458230e9$export$f8151fce47ad1c35)((0, $4335107f861a4482$export$dfdc1655ccc5b9cb)(tx)));
            return (0, $4335107f861a4482$export$dfdc1655ccc5b9cb)(tx, signature);
        });
    }
    signMessage(message) {
        return $cf67a8ebc5cb0c41$var$__awaiter(this, void 0, void 0, function*() {
            return (0, $06d75ae17ce69367$export$71bb9d78a59bbe25)(this._signingKey().signDigest((0, $4fe8b24c78e33d56$export$d4c241cec96564c1)(message)));
        });
    }
    _signTypedData(domain, types, value) {
        return $cf67a8ebc5cb0c41$var$__awaiter(this, void 0, void 0, function*() {
            // Populate any ENS names
            const populated = yield (0, $9492f7dcb2320b2f$exports.TypedDataEncoder).resolveNames(domain, types, value, (name)=>{
                if (this.provider == null) $cf67a8ebc5cb0c41$var$logger.throwError("cannot resolve ENS names without a provider", (0, $5f596c9584f643ae$export$efa9a398d6368992).errors.UNSUPPORTED_OPERATION, {
                    operation: "resolveName",
                    value: name
                });
                return this.provider.resolveName(name);
            });
            return (0, $06d75ae17ce69367$export$71bb9d78a59bbe25)(this._signingKey().signDigest((0, $9492f7dcb2320b2f$exports.TypedDataEncoder).hash(populated.domain, types, populated.value)));
        });
    }
    encrypt(password, options, progressCallback) {
        if (typeof options === "function" && !progressCallback) {
            progressCallback = options;
            options = {};
        }
        if (progressCallback && typeof progressCallback !== "function") throw new Error("invalid callback");
        if (!options) options = {};
        return (0, $be05ce9377ca9978$exports.encrypt)(this, password, options, progressCallback);
    }
    /**
     *  Static methods to create Wallet instances.
     */ static createRandom(options) {
        let entropy = (0, $0a998708283ccc39$export$5f828d93ff035aa8)(16);
        if (!options) options = {};
        if (options.extraEntropy) entropy = (0, $06d75ae17ce69367$export$3131421a7d01b4fb)((0, $06d75ae17ce69367$export$15da666eba198c18)((0, $62e3396d458230e9$export$f8151fce47ad1c35)((0, $06d75ae17ce69367$export$ee1b3e54f0441b22)([
            entropy,
            options.extraEntropy
        ])), 0, 16));
        const mnemonic = (0, $2c3deea0882bd090$export$4becd65eb23312e6)(entropy, options.locale);
        return $cf67a8ebc5cb0c41$export$bcca3ea514774656.fromMnemonic(mnemonic, options.path, options.locale);
    }
    static fromEncryptedJson(json, password, progressCallback) {
        return (0, $96dc61236f851eb2$export$e74fcde37488267a)(json, password, progressCallback).then((account)=>{
            return new $cf67a8ebc5cb0c41$export$bcca3ea514774656(account);
        });
    }
    static fromEncryptedJsonSync(json, password) {
        return new $cf67a8ebc5cb0c41$export$bcca3ea514774656((0, $96dc61236f851eb2$export$7a81c437a678891a)(json, password));
    }
    static fromMnemonic(mnemonic, path, wordlist) {
        if (!path) path = (0, $2c3deea0882bd090$export$d48ad89f7e11a603);
        return new $cf67a8ebc5cb0c41$export$bcca3ea514774656((0, $2c3deea0882bd090$export$b68640c53e22b952).fromMnemonic(mnemonic, null, wordlist).derivePath(path));
    }
}
function $cf67a8ebc5cb0c41$export$228d0e772cc158cb(message, signature) {
    return (0, $4335107f861a4482$export$23cc18f96d8510e2)((0, $4fe8b24c78e33d56$export$d4c241cec96564c1)(message), signature);
}
function $cf67a8ebc5cb0c41$export$3603b1c1bcd76798(domain, types, value, signature) {
    return (0, $4335107f861a4482$export$23cc18f96d8510e2)((0, $9492f7dcb2320b2f$exports.TypedDataEncoder).hash(domain, types, value), signature);
}


var $c95343869e5b728e$exports = {};

$parcel$export($c95343869e5b728e$exports, "AddressZero", function () { return $16ad1643f931e329$export$badd13187c087617; });
$parcel$export($c95343869e5b728e$exports, "NegativeOne", function () { return $9b44019502d48201$export$c83ef0909a6ddeec; });
$parcel$export($c95343869e5b728e$exports, "Zero", function () { return $9b44019502d48201$export$aaef8a3eae948f03; });
$parcel$export($c95343869e5b728e$exports, "One", function () { return $9b44019502d48201$export$9aa05a5866350bcf; });
$parcel$export($c95343869e5b728e$exports, "Two", function () { return $9b44019502d48201$export$9276dd97bf62cc8d; });
$parcel$export($c95343869e5b728e$exports, "WeiPerEther", function () { return $9b44019502d48201$export$c8db55bd7405209e; });
$parcel$export($c95343869e5b728e$exports, "MaxUint256", function () { return $9b44019502d48201$export$1b53890de5aabdd0; });
$parcel$export($c95343869e5b728e$exports, "MinInt256", function () { return $9b44019502d48201$export$963c9b9317b80aaf; });
$parcel$export($c95343869e5b728e$exports, "MaxInt256", function () { return $9b44019502d48201$export$6f8dbb07ebe6d738; });
$parcel$export($c95343869e5b728e$exports, "HashZero", function () { return $0c009a6d1ae8a424$export$71c2e4e213dcb7f2; });
$parcel$export($c95343869e5b728e$exports, "EtherSymbol", function () { return $34594a4616895b2a$export$c7e79fcb6f8ac048; });



// NFKC (composed)             // (decomposed)
const $34594a4616895b2a$export$c7e79fcb6f8ac048 = "Ξ"; // "\uD835\uDF63";


"use strict";




var $71abc16c547c9385$exports = {};

$parcel$export($71abc16c547c9385$exports, "AbiCoder", function () { return $420d974aae91c4e0$export$fe041e1a83d3efc6; });
$parcel$export($71abc16c547c9385$exports, "defaultAbiCoder", function () { return $420d974aae91c4e0$export$51d1cfcdb913adff; });
$parcel$export($71abc16c547c9385$exports, "Fragment", function () { return $2cb0f13975c97159$export$ffb0004e005737fa; });
$parcel$export($71abc16c547c9385$exports, "ConstructorFragment", function () { return $2cb0f13975c97159$export$3ac5c9504f801ea4; });
$parcel$export($71abc16c547c9385$exports, "ErrorFragment", function () { return $2cb0f13975c97159$export$2c42c6d543aa9b59; });
$parcel$export($71abc16c547c9385$exports, "EventFragment", function () { return $2cb0f13975c97159$export$958548f08bac2833; });
$parcel$export($71abc16c547c9385$exports, "FunctionFragment", function () { return $2cb0f13975c97159$export$8d576c928b93668f; });
$parcel$export($71abc16c547c9385$exports, "ParamType", function () { return $2cb0f13975c97159$export$426dc07f493a4c47; });
$parcel$export($71abc16c547c9385$exports, "FormatTypes", function () { return $2cb0f13975c97159$export$f010f239efc4d445; });
$parcel$export($71abc16c547c9385$exports, "checkResultErrors", function () { return $3c454193c1d90bf8$export$5546b9ec21157cc2; });
$parcel$export($71abc16c547c9385$exports, "Logger", function () { return $5f596c9584f643ae$export$efa9a398d6368992; });
$parcel$export($71abc16c547c9385$exports, "RLP", function () { return $196d3b44be9fdb46$exports; });
$parcel$export($71abc16c547c9385$exports, "_fetchData", function () { return $1f5b367caa9efc4a$exports._fetchData; });
$parcel$export($71abc16c547c9385$exports, "fetchJson", function () { return $1f5b367caa9efc4a$exports.fetchJson; });
$parcel$export($71abc16c547c9385$exports, "poll", function () { return $1f5b367caa9efc4a$exports.poll; });
$parcel$export($71abc16c547c9385$exports, "checkProperties", function () { return $d2d9b472f7878d5e$exports.checkProperties; });
$parcel$export($71abc16c547c9385$exports, "deepCopy", function () { return $d2d9b472f7878d5e$exports.deepCopy; });
$parcel$export($71abc16c547c9385$exports, "defineReadOnly", function () { return $d2d9b472f7878d5e$exports.defineReadOnly; });
$parcel$export($71abc16c547c9385$exports, "getStatic", function () { return $d2d9b472f7878d5e$exports.getStatic; });
$parcel$export($71abc16c547c9385$exports, "resolveProperties", function () { return $d2d9b472f7878d5e$exports.resolveProperties; });
$parcel$export($71abc16c547c9385$exports, "shallowCopy", function () { return $d2d9b472f7878d5e$exports.shallowCopy; });
$parcel$export($71abc16c547c9385$exports, "arrayify", function () { return $06d75ae17ce69367$export$3131421a7d01b4fb; });
$parcel$export($71abc16c547c9385$exports, "concat", function () { return $06d75ae17ce69367$export$ee1b3e54f0441b22; });
$parcel$export($71abc16c547c9385$exports, "stripZeros", function () { return $06d75ae17ce69367$export$a8f4574d0e56446c; });
$parcel$export($71abc16c547c9385$exports, "zeroPad", function () { return $06d75ae17ce69367$export$3cdc770bf8b2ed3d; });
$parcel$export($71abc16c547c9385$exports, "isBytes", function () { return $06d75ae17ce69367$export$c6fabfbfd097fc30; });
$parcel$export($71abc16c547c9385$exports, "isBytesLike", function () { return $06d75ae17ce69367$export$9a14abb1a440cd5e; });
$parcel$export($71abc16c547c9385$exports, "defaultPath", function () { return $2c3deea0882bd090$export$d48ad89f7e11a603; });
$parcel$export($71abc16c547c9385$exports, "HDNode", function () { return $2c3deea0882bd090$export$b68640c53e22b952; });
$parcel$export($71abc16c547c9385$exports, "SigningKey", function () { return $49ebbfa7c2be841e$export$21643ca94aed3e83; });
$parcel$export($71abc16c547c9385$exports, "Interface", function () { return $c799c8c071055c8d$export$48cefb51a4e315b2; });
$parcel$export($71abc16c547c9385$exports, "LogDescription", function () { return $c799c8c071055c8d$export$c2ab6499be98b3c5; });
$parcel$export($71abc16c547c9385$exports, "TransactionDescription", function () { return $c799c8c071055c8d$export$7a3223b0fadb690b; });
$parcel$export($71abc16c547c9385$exports, "base58", function () { return $4f9292cbf9a48447$export$45a587635c9954b2; });
$parcel$export($71abc16c547c9385$exports, "base64", function () { return $b15ec38487e6fa90$exports; });
$parcel$export($71abc16c547c9385$exports, "hexlify", function () { return $06d75ae17ce69367$export$2b0d6b5fbe698c70; });
$parcel$export($71abc16c547c9385$exports, "isHexString", function () { return $06d75ae17ce69367$export$b02a40aff8e4ad18; });
$parcel$export($71abc16c547c9385$exports, "hexConcat", function () { return $06d75ae17ce69367$export$6d4b99629b38754a; });
$parcel$export($71abc16c547c9385$exports, "hexStripZeros", function () { return $06d75ae17ce69367$export$967bc0082a978949; });
$parcel$export($71abc16c547c9385$exports, "hexValue", function () { return $06d75ae17ce69367$export$6916af760a341dd3; });
$parcel$export($71abc16c547c9385$exports, "hexZeroPad", function () { return $06d75ae17ce69367$export$e9c46a54370b47e8; });
$parcel$export($71abc16c547c9385$exports, "hexDataLength", function () { return $06d75ae17ce69367$export$13882f896d3c0683; });
$parcel$export($71abc16c547c9385$exports, "hexDataSlice", function () { return $06d75ae17ce69367$export$15da666eba198c18; });
$parcel$export($71abc16c547c9385$exports, "nameprep", function () { return $c7fe52ac76e0a919$export$94f0b6f93c619bc; });
$parcel$export($71abc16c547c9385$exports, "_toEscapedUtf8String", function () { return $7bbf1261c840221b$export$a7a0ec15960b9055; });
$parcel$export($71abc16c547c9385$exports, "toUtf8Bytes", function () { return $7bbf1261c840221b$export$8feeb310b4b4752f; });
$parcel$export($71abc16c547c9385$exports, "toUtf8CodePoints", function () { return $7bbf1261c840221b$export$ae470a36a31b28c2; });
$parcel$export($71abc16c547c9385$exports, "toUtf8String", function () { return $7bbf1261c840221b$export$7643a1dc2c38d5eb; });
$parcel$export($71abc16c547c9385$exports, "Utf8ErrorFuncs", function () { return $7bbf1261c840221b$export$c6e2180c5bb5bc05; });
$parcel$export($71abc16c547c9385$exports, "formatBytes32String", function () { return $1cd87b34e852dc8f$export$b97e949c0076e971; });
$parcel$export($71abc16c547c9385$exports, "parseBytes32String", function () { return $1cd87b34e852dc8f$export$49340cb8f3954db8; });
$parcel$export($71abc16c547c9385$exports, "dnsEncode", function () { return $0e4d091b6edb4637$export$6c0a8cdae51cb512; });
$parcel$export($71abc16c547c9385$exports, "hashMessage", function () { return $4fe8b24c78e33d56$export$d4c241cec96564c1; });
$parcel$export($71abc16c547c9385$exports, "namehash", function () { return $0e4d091b6edb4637$export$91d651ee363e1209; });
$parcel$export($71abc16c547c9385$exports, "isValidName", function () { return $0e4d091b6edb4637$export$cce2300886e7ace6; });
$parcel$export($71abc16c547c9385$exports, "id", function () { return $143d6d71aa960133$export$d560c7e4a29451c2; });
$parcel$export($71abc16c547c9385$exports, "_TypedDataEncoder", function () { return $9492f7dcb2320b2f$exports.TypedDataEncoder; });
$parcel$export($71abc16c547c9385$exports, "getAddress", function () { return $5652f239bab101de$export$88411125f012957a; });
$parcel$export($71abc16c547c9385$exports, "getIcapAddress", function () { return $5652f239bab101de$export$962c4ddada9f668f; });
$parcel$export($71abc16c547c9385$exports, "getContractAddress", function () { return $5652f239bab101de$export$b7fbffef12272e40; });
$parcel$export($71abc16c547c9385$exports, "getCreate2Address", function () { return $5652f239bab101de$export$e0b22d96621f73a2; });
$parcel$export($71abc16c547c9385$exports, "isAddress", function () { return $5652f239bab101de$export$977e255126d763d6; });
$parcel$export($71abc16c547c9385$exports, "formatEther", function () { return $7c73e12934bd116b$export$11bc63b4c03ea518; });
$parcel$export($71abc16c547c9385$exports, "parseEther", function () { return $7c73e12934bd116b$export$642c4e67bbdc0bc7; });
$parcel$export($71abc16c547c9385$exports, "formatUnits", function () { return $7c73e12934bd116b$export$bd39b96f71da1885; });
$parcel$export($71abc16c547c9385$exports, "parseUnits", function () { return $7c73e12934bd116b$export$203ae30b4f6490b3; });
$parcel$export($71abc16c547c9385$exports, "commify", function () { return $7c73e12934bd116b$export$de1294767e6ef661; });
$parcel$export($71abc16c547c9385$exports, "computeHmac", function () { return $ad6b4320c60d6c47$export$967075d2f3b8e7ff; });
$parcel$export($71abc16c547c9385$exports, "keccak256", function () { return $62e3396d458230e9$export$f8151fce47ad1c35; });
$parcel$export($71abc16c547c9385$exports, "ripemd160", function () { return $ad6b4320c60d6c47$export$d1cea0ee4e3f0d3e; });
$parcel$export($71abc16c547c9385$exports, "sha256", function () { return $ad6b4320c60d6c47$export$bced8d2aada2d1c9; });
$parcel$export($71abc16c547c9385$exports, "sha512", function () { return $ad6b4320c60d6c47$export$a888d2532e6dc7bb; });
$parcel$export($71abc16c547c9385$exports, "randomBytes", function () { return $0a998708283ccc39$export$5f828d93ff035aa8; });
$parcel$export($71abc16c547c9385$exports, "shuffled", function () { return $7efaf3cc8a62189f$export$e6c7296801b9b341; });
$parcel$export($71abc16c547c9385$exports, "solidityPack", function () { return $8a107881e49b51a3$export$2a703dbb0cb35339; });
$parcel$export($71abc16c547c9385$exports, "solidityKeccak256", function () { return $8a107881e49b51a3$export$f8151fce47ad1c35; });
$parcel$export($71abc16c547c9385$exports, "soliditySha256", function () { return $8a107881e49b51a3$export$bced8d2aada2d1c9; });
$parcel$export($71abc16c547c9385$exports, "splitSignature", function () { return $06d75ae17ce69367$export$7fb170f1e457988f; });
$parcel$export($71abc16c547c9385$exports, "joinSignature", function () { return $06d75ae17ce69367$export$71bb9d78a59bbe25; });
$parcel$export($71abc16c547c9385$exports, "accessListify", function () { return $4335107f861a4482$export$6c8662b1600dce2; });
$parcel$export($71abc16c547c9385$exports, "parseTransaction", function () { return $4335107f861a4482$export$98e6a39c04603d36; });
$parcel$export($71abc16c547c9385$exports, "serializeTransaction", function () { return $4335107f861a4482$export$dfdc1655ccc5b9cb; });
$parcel$export($71abc16c547c9385$exports, "TransactionTypes", function () { return $4335107f861a4482$export$80349e05e0724e11; });
$parcel$export($71abc16c547c9385$exports, "getJsonWalletAddress", function () { return $26486974307e9818$export$9a68ee9f8f3afd38; });
$parcel$export($71abc16c547c9385$exports, "computeAddress", function () { return $4335107f861a4482$export$e67e2732ba9803f9; });
$parcel$export($71abc16c547c9385$exports, "recoverAddress", function () { return $4335107f861a4482$export$23cc18f96d8510e2; });
$parcel$export($71abc16c547c9385$exports, "computePublicKey", function () { return $49ebbfa7c2be841e$export$4a89473d39301224; });
$parcel$export($71abc16c547c9385$exports, "recoverPublicKey", function () { return $49ebbfa7c2be841e$export$952dd09fbe0232b7; });
$parcel$export($71abc16c547c9385$exports, "verifyMessage", function () { return $cf67a8ebc5cb0c41$exports.verifyMessage; });
$parcel$export($71abc16c547c9385$exports, "verifyTypedData", function () { return $cf67a8ebc5cb0c41$exports.verifyTypedData; });
$parcel$export($71abc16c547c9385$exports, "getAccountPath", function () { return $2c3deea0882bd090$export$22b80e4f9eff636d; });
$parcel$export($71abc16c547c9385$exports, "mnemonicToEntropy", function () { return $2c3deea0882bd090$export$135e090d58b310ca; });
$parcel$export($71abc16c547c9385$exports, "entropyToMnemonic", function () { return $2c3deea0882bd090$export$4becd65eb23312e6; });
$parcel$export($71abc16c547c9385$exports, "isValidMnemonic", function () { return $2c3deea0882bd090$export$5eea3393c6119c80; });
$parcel$export($71abc16c547c9385$exports, "mnemonicToSeed", function () { return $2c3deea0882bd090$export$3dee74f1204ab09f; });
$parcel$export($71abc16c547c9385$exports, "SupportedAlgorithm", function () { return $c4af312545dae30d$export$d2a8849cfb277c; });
$parcel$export($71abc16c547c9385$exports, "UnicodeNormalizationForm", function () { return $7bbf1261c840221b$export$c6986442964129f5; });
$parcel$export($71abc16c547c9385$exports, "Utf8ErrorReason", function () { return $7bbf1261c840221b$export$c285fa6ac15ff6a6; });
$parcel$export($71abc16c547c9385$exports, "Indexed", function () { return $c799c8c071055c8d$export$8ef99100a3c56f8c; });


var $b15ec38487e6fa90$exports = {};

$parcel$export($b15ec38487e6fa90$exports, "decode", function () { return $197fdee3ede33bf0$export$2f872c0f2117be69; });
$parcel$export($b15ec38487e6fa90$exports, "encode", function () { return $197fdee3ede33bf0$export$c564cdbbe6da493; });

"use strict";
















const $9308d195935c559a$export$83d89fbfd8236492 = "solidity/5.7.0";


"use strict";
const $8a107881e49b51a3$var$regexBytes = new RegExp("^bytes([0-9]+)$");
const $8a107881e49b51a3$var$regexNumber = new RegExp("^(u?int)([0-9]*)$");
const $8a107881e49b51a3$var$regexArray = new RegExp("^(.*)\\[([0-9]*)\\]$");
const $8a107881e49b51a3$var$Zeros = "0000000000000000000000000000000000000000000000000000000000000000";
const $8a107881e49b51a3$var$logger = new (0, $5f596c9584f643ae$export$efa9a398d6368992)((0, $9308d195935c559a$export$83d89fbfd8236492));
function $8a107881e49b51a3$var$_pack(type, value, isArray) {
    switch(type){
        case "address":
            if (isArray) return (0, $06d75ae17ce69367$export$3cdc770bf8b2ed3d)(value, 32);
            return (0, $06d75ae17ce69367$export$3131421a7d01b4fb)(value);
        case "string":
            return (0, $7bbf1261c840221b$export$8feeb310b4b4752f)(value);
        case "bytes":
            return (0, $06d75ae17ce69367$export$3131421a7d01b4fb)(value);
        case "bool":
            value = value ? "0x01" : "0x00";
            if (isArray) return (0, $06d75ae17ce69367$export$3cdc770bf8b2ed3d)(value, 32);
            return (0, $06d75ae17ce69367$export$3131421a7d01b4fb)(value);
    }
    let match = type.match($8a107881e49b51a3$var$regexNumber);
    if (match) {
        //let signed = (match[1] === "int")
        let size = parseInt(match[2] || "256");
        if (match[2] && String(size) !== match[2] || size % 8 !== 0 || size === 0 || size > 256) $8a107881e49b51a3$var$logger.throwArgumentError("invalid number type", "type", type);
        if (isArray) size = 256;
        value = (0, $a87aa97415e1b917$export$d97aa349ed20696).from(value).toTwos(size);
        return (0, $06d75ae17ce69367$export$3cdc770bf8b2ed3d)(value, size / 8);
    }
    match = type.match($8a107881e49b51a3$var$regexBytes);
    if (match) {
        const size = parseInt(match[1]);
        if (String(size) !== match[1] || size === 0 || size > 32) $8a107881e49b51a3$var$logger.throwArgumentError("invalid bytes type", "type", type);
        if ((0, $06d75ae17ce69367$export$3131421a7d01b4fb)(value).byteLength !== size) $8a107881e49b51a3$var$logger.throwArgumentError(`invalid value for ${type}`, "value", value);
        if (isArray) return (0, $06d75ae17ce69367$export$3131421a7d01b4fb)((value + $8a107881e49b51a3$var$Zeros).substring(0, 66));
        return value;
    }
    match = type.match($8a107881e49b51a3$var$regexArray);
    if (match && Array.isArray(value)) {
        const baseType = match[1];
        const count = parseInt(match[2] || String(value.length));
        if (count != value.length) $8a107881e49b51a3$var$logger.throwArgumentError(`invalid array length for ${type}`, "value", value);
        const result = [];
        value.forEach(function(value) {
            result.push($8a107881e49b51a3$var$_pack(baseType, value, true));
        });
        return (0, $06d75ae17ce69367$export$ee1b3e54f0441b22)(result);
    }
    return $8a107881e49b51a3$var$logger.throwArgumentError("invalid type", "type", type);
}
function $8a107881e49b51a3$export$2a703dbb0cb35339(types, values) {
    if (types.length != values.length) $8a107881e49b51a3$var$logger.throwArgumentError("wrong number of values; expected ${ types.length }", "values", values);
    const tight = [];
    types.forEach(function(type, index) {
        tight.push($8a107881e49b51a3$var$_pack(type, values[index]));
    });
    return (0, $06d75ae17ce69367$export$2b0d6b5fbe698c70)((0, $06d75ae17ce69367$export$ee1b3e54f0441b22)(tight));
}
function $8a107881e49b51a3$export$f8151fce47ad1c35(types, values) {
    return (0, $62e3396d458230e9$export$f8151fce47ad1c35)($8a107881e49b51a3$export$2a703dbb0cb35339(types, values));
}
function $8a107881e49b51a3$export$bced8d2aada2d1c9(types, values) {
    return (0, $ad6b4320c60d6c47$export$bced8d2aada2d1c9)($8a107881e49b51a3$export$2a703dbb0cb35339(types, values));
}









"use strict";
function $1cd87b34e852dc8f$export$b97e949c0076e971(text) {
    // Get the bytes
    const bytes = (0, $7bbf1261c840221b$export$8feeb310b4b4752f)(text);
    // Check we have room for null-termination
    if (bytes.length > 31) throw new Error("bytes32 string must be less than 32 bytes");
    // Zero-pad (implicitly null-terminates)
    return (0, $06d75ae17ce69367$export$2b0d6b5fbe698c70)((0, $06d75ae17ce69367$export$ee1b3e54f0441b22)([
        bytes,
        (0, $0c009a6d1ae8a424$export$71c2e4e213dcb7f2)
    ]).slice(0, 32));
}
function $1cd87b34e852dc8f$export$49340cb8f3954db8(bytes) {
    const data = (0, $06d75ae17ce69367$export$3131421a7d01b4fb)(bytes);
    // Must be 32 bytes with a null-termination
    if (data.length !== 32) throw new Error("invalid bytes32 - not 32 bytes long");
    if (data[31] !== 0) throw new Error("invalid bytes32 string - no null terminator");
    // Find the null termination
    let length = 31;
    while(data[length - 1] === 0)length--;
    // Determine the string value
    return (0, $7bbf1261c840221b$export$7643a1dc2c38d5eb)(data.slice(0, length));
}


"use strict";
function $c7fe52ac76e0a919$var$bytes2(data) {
    if (data.length % 4 !== 0) throw new Error("bad data");
    let result = [];
    for(let i = 0; i < data.length; i += 4)result.push(parseInt(data.substring(i, i + 4), 16));
    return result;
}
function $c7fe52ac76e0a919$var$createTable(data, func) {
    if (!func) func = function(value) {
        return [
            parseInt(value, 16)
        ];
    };
    let lo = 0;
    let result = {};
    data.split(",").forEach((pair)=>{
        let comps = pair.split(":");
        lo += parseInt(comps[0], 16);
        result[lo] = func(comps[1]);
    });
    return result;
}
function $c7fe52ac76e0a919$var$createRangeTable(data) {
    let hi = 0;
    return data.split(",").map((v)=>{
        let comps = v.split("-");
        if (comps.length === 1) comps[1] = "0";
        else if (comps[1] === "") comps[1] = "1";
        let lo = hi + parseInt(comps[0], 16);
        hi = parseInt(comps[1], 16);
        return {
            l: lo,
            h: hi
        };
    });
}
function $c7fe52ac76e0a919$var$matchMap(value, ranges) {
    let lo = 0;
    for(let i = 0; i < ranges.length; i++){
        let range = ranges[i];
        lo += range.l;
        if (value >= lo && value <= lo + range.h && (value - lo) % (range.d || 1) === 0) {
            if (range.e && range.e.indexOf(value - lo) !== -1) continue;
            return range;
        }
    }
    return null;
}
const $c7fe52ac76e0a919$var$Table_A_1_ranges = $c7fe52ac76e0a919$var$createRangeTable("221,13-1b,5f-,40-10,51-f,11-3,3-3,2-2,2-4,8,2,15,2d,28-8,88,48,27-,3-5,11-20,27-,8,28,3-5,12,18,b-a,1c-4,6-16,2-d,2-2,2,1b-4,17-9,8f-,10,f,1f-2,1c-34,33-14e,4,36-,13-,6-2,1a-f,4,9-,3-,17,8,2-2,5-,2,8-,3-,4-8,2-3,3,6-,16-6,2-,7-3,3-,17,8,3,3,3-,2,6-3,3-,4-a,5,2-6,10-b,4,8,2,4,17,8,3,6-,b,4,4-,2-e,2-4,b-10,4,9-,3-,17,8,3-,5-,9-2,3-,4-7,3-3,3,4-3,c-10,3,7-2,4,5-2,3,2,3-2,3-2,4-2,9,4-3,6-2,4,5-8,2-e,d-d,4,9,4,18,b,6-3,8,4,5-6,3-8,3-3,b-11,3,9,4,18,b,6-3,8,4,5-6,3-6,2,3-3,b-11,3,9,4,18,11-3,7-,4,5-8,2-7,3-3,b-11,3,13-2,19,a,2-,8-2,2-3,7,2,9-11,4-b,3b-3,1e-24,3,2-,3,2-,2-5,5,8,4,2,2-,3,e,4-,6,2,7-,b-,3-21,49,23-5,1c-3,9,25,10-,2-2f,23,6,3,8-2,5-5,1b-45,27-9,2a-,2-3,5b-4,45-4,53-5,8,40,2,5-,8,2,5-,28,2,5-,20,2,5-,8,2,5-,8,8,18,20,2,5-,8,28,14-5,1d-22,56-b,277-8,1e-2,52-e,e,8-a,18-8,15-b,e,4,3-b,5e-2,b-15,10,b-5,59-7,2b-555,9d-3,5b-5,17-,7-,27-,7-,9,2,2,2,20-,36,10,f-,7,14-,4,a,54-3,2-6,6-5,9-,1c-10,13-1d,1c-14,3c-,10-6,32-b,240-30,28-18,c-14,a0,115-,3,66-,b-76,5,5-,1d,24,2,5-2,2,8-,35-2,19,f-10,1d-3,311-37f,1b,5a-b,d7-19,d-3,41,57-,68-4,29-3,5f,29-37,2e-2,25-c,2c-2,4e-3,30,78-3,64-,20,19b7-49,51a7-59,48e-2,38-738,2ba5-5b,222f-,3c-94,8-b,6-4,1b,6,2,3,3,6d-20,16e-f,41-,37-7,2e-2,11-f,5-b,18-,b,14,5-3,6,88-,2,bf-2,7-,7-,7-,4-2,8,8-9,8-2ff,20,5-b,1c-b4,27-,27-cbb1,f7-9,28-2,b5-221,56,48,3-,2-,3-,5,d,2,5,3,42,5-,9,8,1d,5,6,2-2,8,153-3,123-3,33-27fd,a6da-5128,21f-5df,3-fffd,3-fffd,3-fffd,3-fffd,3-fffd,3-fffd,3-fffd,3-fffd,3-fffd,3-fffd,3-fffd,3,2-1d,61-ff7d");
// @TODO: Make this relative...
const $c7fe52ac76e0a919$var$Table_B_1_flags = "ad,34f,1806,180b,180c,180d,200b,200c,200d,2060,feff".split(",").map((v)=>parseInt(v, 16));
const $c7fe52ac76e0a919$var$Table_B_2_ranges = [
    {
        h: 25,
        s: 32,
        l: 65
    },
    {
        h: 30,
        s: 32,
        e: [
            23
        ],
        l: 127
    },
    {
        h: 54,
        s: 1,
        e: [
            48
        ],
        l: 64,
        d: 2
    },
    {
        h: 14,
        s: 1,
        l: 57,
        d: 2
    },
    {
        h: 44,
        s: 1,
        l: 17,
        d: 2
    },
    {
        h: 10,
        s: 1,
        e: [
            2,
            6,
            8
        ],
        l: 61,
        d: 2
    },
    {
        h: 16,
        s: 1,
        l: 68,
        d: 2
    },
    {
        h: 84,
        s: 1,
        e: [
            18,
            24,
            66
        ],
        l: 19,
        d: 2
    },
    {
        h: 26,
        s: 32,
        e: [
            17
        ],
        l: 435
    },
    {
        h: 22,
        s: 1,
        l: 71,
        d: 2
    },
    {
        h: 15,
        s: 80,
        l: 40
    },
    {
        h: 31,
        s: 32,
        l: 16
    },
    {
        h: 32,
        s: 1,
        l: 80,
        d: 2
    },
    {
        h: 52,
        s: 1,
        l: 42,
        d: 2
    },
    {
        h: 12,
        s: 1,
        l: 55,
        d: 2
    },
    {
        h: 40,
        s: 1,
        e: [
            38
        ],
        l: 15,
        d: 2
    },
    {
        h: 14,
        s: 1,
        l: 48,
        d: 2
    },
    {
        h: 37,
        s: 48,
        l: 49
    },
    {
        h: 148,
        s: 1,
        l: 6351,
        d: 2
    },
    {
        h: 88,
        s: 1,
        l: 160,
        d: 2
    },
    {
        h: 15,
        s: 16,
        l: 704
    },
    {
        h: 25,
        s: 26,
        l: 854
    },
    {
        h: 25,
        s: 32,
        l: 55915
    },
    {
        h: 37,
        s: 40,
        l: 1247
    },
    {
        h: 25,
        s: -119711,
        l: 53248
    },
    {
        h: 25,
        s: -119763,
        l: 52
    },
    {
        h: 25,
        s: -119815,
        l: 52
    },
    {
        h: 25,
        s: -119867,
        e: [
            1,
            4,
            5,
            7,
            8,
            11,
            12,
            17
        ],
        l: 52
    },
    {
        h: 25,
        s: -119919,
        l: 52
    },
    {
        h: 24,
        s: -119971,
        e: [
            2,
            7,
            8,
            17
        ],
        l: 52
    },
    {
        h: 24,
        s: -120023,
        e: [
            2,
            7,
            13,
            15,
            16,
            17
        ],
        l: 52
    },
    {
        h: 25,
        s: -120075,
        l: 52
    },
    {
        h: 25,
        s: -120127,
        l: 52
    },
    {
        h: 25,
        s: -120179,
        l: 52
    },
    {
        h: 25,
        s: -120231,
        l: 52
    },
    {
        h: 25,
        s: -120283,
        l: 52
    },
    {
        h: 25,
        s: -120335,
        l: 52
    },
    {
        h: 24,
        s: -119543,
        e: [
            17
        ],
        l: 56
    },
    {
        h: 24,
        s: -119601,
        e: [
            17
        ],
        l: 58
    },
    {
        h: 24,
        s: -119659,
        e: [
            17
        ],
        l: 58
    },
    {
        h: 24,
        s: -119717,
        e: [
            17
        ],
        l: 58
    },
    {
        h: 24,
        s: -119775,
        e: [
            17
        ],
        l: 58
    }
];
const $c7fe52ac76e0a919$var$Table_B_2_lut_abs = $c7fe52ac76e0a919$var$createTable("b5:3bc,c3:ff,7:73,2:253,5:254,3:256,1:257,5:259,1:25b,3:260,1:263,2:269,1:268,5:26f,1:272,2:275,7:280,3:283,5:288,3:28a,1:28b,5:292,3f:195,1:1bf,29:19e,125:3b9,8b:3b2,1:3b8,1:3c5,3:3c6,1:3c0,1a:3ba,1:3c1,1:3c3,2:3b8,1:3b5,1bc9:3b9,1c:1f76,1:1f77,f:1f7a,1:1f7b,d:1f78,1:1f79,1:1f7c,1:1f7d,107:63,5:25b,4:68,1:68,1:68,3:69,1:69,1:6c,3:6e,4:70,1:71,1:72,1:72,1:72,7:7a,2:3c9,2:7a,2:6b,1:e5,1:62,1:63,3:65,1:66,2:6d,b:3b3,1:3c0,6:64,1b574:3b8,1a:3c3,20:3b8,1a:3c3,20:3b8,1a:3c3,20:3b8,1a:3c3,20:3b8,1a:3c3");
const $c7fe52ac76e0a919$var$Table_B_2_lut_rel = $c7fe52ac76e0a919$var$createTable("179:1,2:1,2:1,5:1,2:1,a:4f,a:1,8:1,2:1,2:1,3:1,5:1,3:1,4:1,2:1,3:1,4:1,8:2,1:1,2:2,1:1,2:2,27:2,195:26,2:25,1:25,1:25,2:40,2:3f,1:3f,33:1,11:-6,1:-9,1ac7:-3a,6d:-8,1:-8,1:-8,1:-8,1:-8,1:-8,1:-8,1:-8,9:-8,1:-8,1:-8,1:-8,1:-8,1:-8,b:-8,1:-8,1:-8,1:-8,1:-8,1:-8,1:-8,1:-8,9:-8,1:-8,1:-8,1:-8,1:-8,1:-8,1:-8,1:-8,9:-8,1:-8,1:-8,1:-8,1:-8,1:-8,c:-8,2:-8,2:-8,2:-8,9:-8,1:-8,1:-8,1:-8,1:-8,1:-8,1:-8,1:-8,49:-8,1:-8,1:-4a,1:-4a,d:-56,1:-56,1:-56,1:-56,d:-8,1:-8,f:-8,1:-8,3:-7");
const $c7fe52ac76e0a919$var$Table_B_2_complex = $c7fe52ac76e0a919$var$createTable("df:00730073,51:00690307,19:02BC006E,a7:006A030C,18a:002003B9,16:03B903080301,20:03C503080301,1d7:05650582,190f:00680331,1:00740308,1:0077030A,1:0079030A,1:006102BE,b6:03C50313,2:03C503130300,2:03C503130301,2:03C503130342,2a:1F0003B9,1:1F0103B9,1:1F0203B9,1:1F0303B9,1:1F0403B9,1:1F0503B9,1:1F0603B9,1:1F0703B9,1:1F0003B9,1:1F0103B9,1:1F0203B9,1:1F0303B9,1:1F0403B9,1:1F0503B9,1:1F0603B9,1:1F0703B9,1:1F2003B9,1:1F2103B9,1:1F2203B9,1:1F2303B9,1:1F2403B9,1:1F2503B9,1:1F2603B9,1:1F2703B9,1:1F2003B9,1:1F2103B9,1:1F2203B9,1:1F2303B9,1:1F2403B9,1:1F2503B9,1:1F2603B9,1:1F2703B9,1:1F6003B9,1:1F6103B9,1:1F6203B9,1:1F6303B9,1:1F6403B9,1:1F6503B9,1:1F6603B9,1:1F6703B9,1:1F6003B9,1:1F6103B9,1:1F6203B9,1:1F6303B9,1:1F6403B9,1:1F6503B9,1:1F6603B9,1:1F6703B9,3:1F7003B9,1:03B103B9,1:03AC03B9,2:03B10342,1:03B1034203B9,5:03B103B9,6:1F7403B9,1:03B703B9,1:03AE03B9,2:03B70342,1:03B7034203B9,5:03B703B9,6:03B903080300,1:03B903080301,3:03B90342,1:03B903080342,b:03C503080300,1:03C503080301,1:03C10313,2:03C50342,1:03C503080342,b:1F7C03B9,1:03C903B9,1:03CE03B9,2:03C90342,1:03C9034203B9,5:03C903B9,ac:00720073,5b:00B00063,6:00B00066,d:006E006F,a:0073006D,1:00740065006C,1:0074006D,124f:006800700061,2:00610075,2:006F0076,b:00700061,1:006E0061,1:03BC0061,1:006D0061,1:006B0061,1:006B0062,1:006D0062,1:00670062,3:00700066,1:006E0066,1:03BC0066,4:0068007A,1:006B0068007A,1:006D0068007A,1:00670068007A,1:00740068007A,15:00700061,1:006B00700061,1:006D00700061,1:006700700061,8:00700076,1:006E0076,1:03BC0076,1:006D0076,1:006B0076,1:006D0076,1:00700077,1:006E0077,1:03BC0077,1:006D0077,1:006B0077,1:006D0077,1:006B03C9,1:006D03C9,2:00620071,3:00632215006B0067,1:0063006F002E,1:00640062,1:00670079,2:00680070,2:006B006B,1:006B006D,9:00700068,2:00700070006D,1:00700072,2:00730076,1:00770062,c723:00660066,1:00660069,1:0066006C,1:006600660069,1:00660066006C,1:00730074,1:00730074,d:05740576,1:05740565,1:0574056B,1:057E0576,1:0574056D", $c7fe52ac76e0a919$var$bytes2);
const $c7fe52ac76e0a919$var$Table_C_ranges = $c7fe52ac76e0a919$var$createRangeTable("80-20,2a0-,39c,32,f71,18e,7f2-f,19-7,30-4,7-5,f81-b,5,a800-20ff,4d1-1f,110,fa-6,d174-7,2e84-,ffff-,ffff-,ffff-,ffff-,ffff-,ffff-,ffff-,ffff-,ffff-,ffff-,ffff-,ffff-,2,1f-5f,ff7f-20001");
function $c7fe52ac76e0a919$var$flatten(values) {
    return values.reduce((accum, value)=>{
        value.forEach((value)=>{
            accum.push(value);
        });
        return accum;
    }, []);
}
function $c7fe52ac76e0a919$export$d1ae0d802533bef0(codepoint) {
    return !!$c7fe52ac76e0a919$var$matchMap(codepoint, $c7fe52ac76e0a919$var$Table_A_1_ranges);
}
function $c7fe52ac76e0a919$export$9630a1f26a43b76c(codepoint) {
    let range = $c7fe52ac76e0a919$var$matchMap(codepoint, $c7fe52ac76e0a919$var$Table_B_2_ranges);
    if (range) return [
        codepoint + range.s
    ];
    let codes = $c7fe52ac76e0a919$var$Table_B_2_lut_abs[codepoint];
    if (codes) return codes;
    let shift = $c7fe52ac76e0a919$var$Table_B_2_lut_rel[codepoint];
    if (shift) return [
        codepoint + shift[0]
    ];
    let complex = $c7fe52ac76e0a919$var$Table_B_2_complex[codepoint];
    if (complex) return complex;
    return null;
}
function $c7fe52ac76e0a919$export$e07a548cae6d1553(codepoint) {
    return !!$c7fe52ac76e0a919$var$matchMap(codepoint, $c7fe52ac76e0a919$var$Table_C_ranges);
}
function $c7fe52ac76e0a919$export$94f0b6f93c619bc(value) {
    // This allows platforms with incomplete normalize to bypass
    // it for very basic names which the built-in toLowerCase
    // will certainly handle correctly
    if (value.match(/^[a-z0-9-]*$/i) && value.length <= 59) return value.toLowerCase();
    // Get the code points (keeping the current normalization)
    let codes = (0, $7bbf1261c840221b$export$ae470a36a31b28c2)(value);
    codes = $c7fe52ac76e0a919$var$flatten(codes.map((code)=>{
        // Substitute Table B.1 (Maps to Nothing)
        if ($c7fe52ac76e0a919$var$Table_B_1_flags.indexOf(code) >= 0) return [];
        if (code >= 0xfe00 && code <= 0xfe0f) return [];
        // Substitute Table B.2 (Case Folding)
        let codesTableB2 = $c7fe52ac76e0a919$export$9630a1f26a43b76c(code);
        if (codesTableB2) return codesTableB2;
        // No Substitution
        return [
            code
        ];
    }));
    // Normalize using form KC
    codes = (0, $7bbf1261c840221b$export$ae470a36a31b28c2)((0, $7bbf1261c840221b$export$232e1dab03132235)(codes), (0, $7bbf1261c840221b$export$c6986442964129f5).NFKC);
    // Prohibit Tables C.1.2, C.2.2, C.3, C.4, C.5, C.6, C.7, C.8, C.9
    codes.forEach((code)=>{
        if ($c7fe52ac76e0a919$export$e07a548cae6d1553(code)) throw new Error("STRINGPREP_CONTAINS_PROHIBITED");
    });
    // Prohibit Unassigned Code Points (Table A.1)
    codes.forEach((code)=>{
        if ($c7fe52ac76e0a919$export$d1ae0d802533bef0(code)) throw new Error("STRINGPREP_CONTAINS_UNASSIGNED");
    });
    // IDNA extras
    let name = (0, $7bbf1261c840221b$export$232e1dab03132235)(codes);
    // IDNA: 4.2.3.1
    if (name.substring(0, 1) === "-" || name.substring(2, 4) === "--" || name.substring(name.length - 1) === "-") throw new Error("invalid hyphen");
    return name;
}





const $11a50bae04d522a1$export$83d89fbfd8236492 = "units/5.7.0";


"use strict";
const $7c73e12934bd116b$var$logger = new (0, $5f596c9584f643ae$export$efa9a398d6368992)((0, $11a50bae04d522a1$export$83d89fbfd8236492));
const $7c73e12934bd116b$var$names = [
    "wei",
    "kwei",
    "mwei",
    "gwei",
    "szabo",
    "finney",
    "ether"
];
function $7c73e12934bd116b$export$de1294767e6ef661(value) {
    const comps = String(value).split(".");
    if (comps.length > 2 || !comps[0].match(/^-?[0-9]*$/) || comps[1] && !comps[1].match(/^[0-9]*$/) || value === "." || value === "-.") $7c73e12934bd116b$var$logger.throwArgumentError("invalid value", "value", value);
    // Make sure we have at least one whole digit (0 if none)
    let whole = comps[0];
    let negative = "";
    if (whole.substring(0, 1) === "-") {
        negative = "-";
        whole = whole.substring(1);
    }
    // Make sure we have at least 1 whole digit with no leading zeros
    while(whole.substring(0, 1) === "0")whole = whole.substring(1);
    if (whole === "") whole = "0";
    let suffix = "";
    if (comps.length === 2) suffix = "." + (comps[1] || "0");
    while(suffix.length > 2 && suffix[suffix.length - 1] === "0")suffix = suffix.substring(0, suffix.length - 1);
    const formatted = [];
    while(whole.length)if (whole.length <= 3) {
        formatted.unshift(whole);
        break;
    } else {
        const index = whole.length - 3;
        formatted.unshift(whole.substring(index));
        whole = whole.substring(0, index);
    }
    return negative + formatted.join(",") + suffix;
}
function $7c73e12934bd116b$export$bd39b96f71da1885(value, unitName) {
    if (typeof unitName === "string") {
        const index = $7c73e12934bd116b$var$names.indexOf(unitName);
        if (index !== -1) unitName = 3 * index;
    }
    return (0, $efb9ddd3e2b20828$export$cc011b843b5d69f2)(value, unitName != null ? unitName : 18);
}
function $7c73e12934bd116b$export$203ae30b4f6490b3(value, unitName) {
    if (typeof value !== "string") $7c73e12934bd116b$var$logger.throwArgumentError("value must be a string", "value", value);
    if (typeof unitName === "string") {
        const index = $7c73e12934bd116b$var$names.indexOf(unitName);
        if (index !== -1) unitName = 3 * index;
    }
    return (0, $efb9ddd3e2b20828$export$1b039987e86d7269)(value, unitName != null ? unitName : 18);
}
function $7c73e12934bd116b$export$11bc63b4c03ea518(wei) {
    return $7c73e12934bd116b$export$bd39b96f71da1885(wei, 18);
}
function $7c73e12934bd116b$export$642c4e67bbdc0bc7(ether) {
    return $7c73e12934bd116b$export$203ae30b4f6490b3(ether, 18);
}




"use strict";



const $67e1b984ae1fe502$export$83d89fbfd8236492 = "ethers/5.7.2";


"use strict";
const $d76834e42ece13f7$export$af88d00dbe7f521 = new (0, $5f596c9584f643ae$export$efa9a398d6368992)((0, $67e1b984ae1fe502$export$83d89fbfd8236492));


"use strict";
try {
    const anyGlobal = window;
    if (anyGlobal._ethers == null) anyGlobal._ethers = $d76834e42ece13f7$exports;
} catch (error) {}


var $cb01257a10e2963c$exports = {};
(function(globalObject) {
    "use strict";
    /*
 *      bignumber.js v9.1.1
 *      A JavaScript library for arbitrary-precision arithmetic.
 *      https://github.com/MikeMcl/bignumber.js
 *      Copyright (c) 2022 Michael Mclaughlin <M8ch88l@gmail.com>
 *      MIT Licensed.
 *
 *      BigNumber.prototype methods     |  BigNumber methods
 *                                      |
 *      absoluteValue            abs    |  clone
 *      comparedTo                      |  config               set
 *      decimalPlaces            dp     |      DECIMAL_PLACES
 *      dividedBy                div    |      ROUNDING_MODE
 *      dividedToIntegerBy       idiv   |      EXPONENTIAL_AT
 *      exponentiatedBy          pow    |      RANGE
 *      integerValue                    |      CRYPTO
 *      isEqualTo                eq     |      MODULO_MODE
 *      isFinite                        |      POW_PRECISION
 *      isGreaterThan            gt     |      FORMAT
 *      isGreaterThanOrEqualTo   gte    |      ALPHABET
 *      isInteger                       |  isBigNumber
 *      isLessThan               lt     |  maximum              max
 *      isLessThanOrEqualTo      lte    |  minimum              min
 *      isNaN                           |  random
 *      isNegative                      |  sum
 *      isPositive                      |
 *      isZero                          |
 *      minus                           |
 *      modulo                   mod    |
 *      multipliedBy             times  |
 *      negated                         |
 *      plus                            |
 *      precision                sd     |
 *      shiftedBy                       |
 *      squareRoot               sqrt   |
 *      toExponential                   |
 *      toFixed                         |
 *      toFormat                        |
 *      toFraction                      |
 *      toJSON                          |
 *      toNumber                        |
 *      toPrecision                     |
 *      toString                        |
 *      valueOf                         |
 *
 */ var BigNumber, isNumeric = /^-?(?:\d+(?:\.\d*)?|\.\d+)(?:e[+-]?\d+)?$/i, mathceil = Math.ceil, mathfloor = Math.floor, bignumberError = "[BigNumber Error] ", tooManyDigits = bignumberError + "Number primitive has more than 15 significant digits: ", BASE = 1e14, LOG_BASE = 14, MAX_SAFE_INTEGER = 0x1fffffffffffff, // MAX_INT32 = 0x7fffffff,                   // 2^31 - 1
    POWS_TEN = [
        1,
        10,
        100,
        1e3,
        1e4,
        1e5,
        1e6,
        1e7,
        1e8,
        1e9,
        1e10,
        1e11,
        1e12,
        1e13
    ], SQRT_BASE = 1e7, // EDITABLE
    // The limit on the value of DECIMAL_PLACES, TO_EXP_NEG, TO_EXP_POS, MIN_EXP, MAX_EXP, and
    // the arguments to toExponential, toFixed, toFormat, and toPrecision.
    MAX = 1E9; // 0 to MAX_INT32
    /*
   * Create and return a BigNumber constructor.
   */ function clone(configObject) {
        var div, convertBase, parseNumeric, P = BigNumber.prototype = {
            constructor: BigNumber,
            toString: null,
            valueOf: null
        }, ONE = new BigNumber(1), //----------------------------- EDITABLE CONFIG DEFAULTS -------------------------------
        // The default values below must be integers within the inclusive ranges stated.
        // The values can also be changed at run-time using BigNumber.set.
        // The maximum number of decimal places for operations involving division.
        DECIMAL_PLACES = 20, // The rounding mode used when rounding to the above decimal places, and when using
        // toExponential, toFixed, toFormat and toPrecision, and round (default value).
        // UP         0 Away from zero.
        // DOWN       1 Towards zero.
        // CEIL       2 Towards +Infinity.
        // FLOOR      3 Towards -Infinity.
        // HALF_UP    4 Towards nearest neighbour. If equidistant, up.
        // HALF_DOWN  5 Towards nearest neighbour. If equidistant, down.
        // HALF_EVEN  6 Towards nearest neighbour. If equidistant, towards even neighbour.
        // HALF_CEIL  7 Towards nearest neighbour. If equidistant, towards +Infinity.
        // HALF_FLOOR 8 Towards nearest neighbour. If equidistant, towards -Infinity.
        ROUNDING_MODE = 4, // EXPONENTIAL_AT : [TO_EXP_NEG , TO_EXP_POS]
        // The exponent value at and beneath which toString returns exponential notation.
        // Number type: -7
        TO_EXP_NEG = -7, // The exponent value at and above which toString returns exponential notation.
        // Number type: 21
        TO_EXP_POS = 21, // RANGE : [MIN_EXP, MAX_EXP]
        // The minimum exponent value, beneath which underflow to zero occurs.
        // Number type: -324  (5e-324)
        MIN_EXP = -10000000, // The maximum exponent value, above which overflow to Infinity occurs.
        // Number type:  308  (1.7976931348623157e+308)
        // For MAX_EXP > 1e7, e.g. new BigNumber('1e100000000').plus(1) may be slow.
        MAX_EXP = 1e7, // Whether to use cryptographically-secure random number generation, if available.
        CRYPTO = false, // The modulo mode used when calculating the modulus: a mod n.
        // The quotient (q = a / n) is calculated according to the corresponding rounding mode.
        // The remainder (r) is calculated as: r = a - n * q.
        //
        // UP        0 The remainder is positive if the dividend is negative, else is negative.
        // DOWN      1 The remainder has the same sign as the dividend.
        //             This modulo mode is commonly known as 'truncated division' and is
        //             equivalent to (a % n) in JavaScript.
        // FLOOR     3 The remainder has the same sign as the divisor (Python %).
        // HALF_EVEN 6 This modulo mode implements the IEEE 754 remainder function.
        // EUCLID    9 Euclidian division. q = sign(n) * floor(a / abs(n)).
        //             The remainder is always positive.
        //
        // The truncated division, floored division, Euclidian division and IEEE 754 remainder
        // modes are commonly used for the modulus operation.
        // Although the other rounding modes can also be used, they may not give useful results.
        MODULO_MODE = 1, // The maximum number of significant digits of the result of the exponentiatedBy operation.
        // If POW_PRECISION is 0, there will be unlimited significant digits.
        POW_PRECISION = 0, // The format specification used by the BigNumber.prototype.toFormat method.
        FORMAT = {
            prefix: "",
            groupSize: 3,
            secondaryGroupSize: 0,
            groupSeparator: ",",
            decimalSeparator: ".",
            fractionGroupSize: 0,
            fractionGroupSeparator: "\xa0",
            suffix: ""
        }, // The alphabet used for base conversion. It must be at least 2 characters long, with no '+',
        // '-', '.', whitespace, or repeated character.
        // '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ$_'
        ALPHABET = "0123456789abcdefghijklmnopqrstuvwxyz", alphabetHasNormalDecimalDigits = true;
        //------------------------------------------------------------------------------------------
        // CONSTRUCTOR
        /*
     * The BigNumber constructor and exported function.
     * Create and return a new instance of a BigNumber object.
     *
     * v {number|string|BigNumber} A numeric value.
     * [b] {number} The base of v. Integer, 2 to ALPHABET.length inclusive.
     */ function BigNumber(v, b) {
            var alphabet, c, caseChanged, e, i, isNum, len, str, x = this;
            // Enable constructor call without `new`.
            if (!(x instanceof BigNumber)) return new BigNumber(v, b);
            if (b == null) {
                if (v && v._isBigNumber === true) {
                    x.s = v.s;
                    if (!v.c || v.e > MAX_EXP) x.c = x.e = null;
                    else if (v.e < MIN_EXP) x.c = [
                        x.e = 0
                    ];
                    else {
                        x.e = v.e;
                        x.c = v.c.slice();
                    }
                    return;
                }
                if ((isNum = typeof v == "number") && v * 0 == 0) {
                    // Use `1 / n` to handle minus zero also.
                    x.s = 1 / v < 0 ? (v = -v, -1) : 1;
                    // Fast path for integers, where n < 2147483648 (2**31).
                    if (v === ~~v) {
                        for(e = 0, i = v; i >= 10; i /= 10, e++);
                        if (e > MAX_EXP) x.c = x.e = null;
                        else {
                            x.e = e;
                            x.c = [
                                v
                            ];
                        }
                        return;
                    }
                    str = String(v);
                } else {
                    if (!isNumeric.test(str = String(v))) return parseNumeric(x, str, isNum);
                    x.s = str.charCodeAt(0) == 45 ? (str = str.slice(1), -1) : 1;
                }
                // Decimal point?
                if ((e = str.indexOf(".")) > -1) str = str.replace(".", "");
                // Exponential form?
                if ((i = str.search(/e/i)) > 0) {
                    // Determine exponent.
                    if (e < 0) e = i;
                    e += +str.slice(i + 1);
                    str = str.substring(0, i);
                } else if (e < 0) // Integer.
                e = str.length;
            } else {
                // '[BigNumber Error] Base {not a primitive number|not an integer|out of range}: {b}'
                intCheck(b, 2, ALPHABET.length, "Base");
                // Allow exponential notation to be used with base 10 argument, while
                // also rounding to DECIMAL_PLACES as with other bases.
                if (b == 10 && alphabetHasNormalDecimalDigits) {
                    x = new BigNumber(v);
                    return round(x, DECIMAL_PLACES + x.e + 1, ROUNDING_MODE);
                }
                str = String(v);
                if (isNum = typeof v == "number") {
                    // Avoid potential interpretation of Infinity and NaN as base 44+ values.
                    if (v * 0 != 0) return parseNumeric(x, str, isNum, b);
                    x.s = 1 / v < 0 ? (str = str.slice(1), -1) : 1;
                    // '[BigNumber Error] Number primitive has more than 15 significant digits: {n}'
                    if (BigNumber.DEBUG && str.replace(/^0\.0*|\./, "").length > 15) throw Error(tooManyDigits + v);
                } else x.s = str.charCodeAt(0) === 45 ? (str = str.slice(1), -1) : 1;
                alphabet = ALPHABET.slice(0, b);
                e = i = 0;
                // Check that str is a valid base b number.
                // Don't use RegExp, so alphabet can contain special characters.
                for(len = str.length; i < len; i++)if (alphabet.indexOf(c = str.charAt(i)) < 0) {
                    if (c == ".") // If '.' is not the first character and it has not be found before.
                    {
                        if (i > e) {
                            e = len;
                            continue;
                        }
                    } else if (!caseChanged) // Allow e.g. hexadecimal 'FF' as well as 'ff'.
                    {
                        if (str == str.toUpperCase() && (str = str.toLowerCase()) || str == str.toLowerCase() && (str = str.toUpperCase())) {
                            caseChanged = true;
                            i = -1;
                            e = 0;
                            continue;
                        }
                    }
                    return parseNumeric(x, String(v), isNum, b);
                }
                // Prevent later check for length on converted number.
                isNum = false;
                str = convertBase(str, b, 10, x.s);
                // Decimal point?
                if ((e = str.indexOf(".")) > -1) str = str.replace(".", "");
                else e = str.length;
            }
            // Determine leading zeros.
            for(i = 0; str.charCodeAt(i) === 48; i++);
            // Determine trailing zeros.
            for(len = str.length; str.charCodeAt(--len) === 48;);
            if (str = str.slice(i, ++len)) {
                len -= i;
                // '[BigNumber Error] Number primitive has more than 15 significant digits: {n}'
                if (isNum && BigNumber.DEBUG && len > 15 && (v > MAX_SAFE_INTEGER || v !== mathfloor(v))) throw Error(tooManyDigits + x.s * v);
                // Overflow?
                if ((e = e - i - 1) > MAX_EXP) // Infinity.
                x.c = x.e = null;
                else if (e < MIN_EXP) // Zero.
                x.c = [
                    x.e = 0
                ];
                else {
                    x.e = e;
                    x.c = [];
                    // Transform base
                    // e is the base 10 exponent.
                    // i is where to slice str to get the first element of the coefficient array.
                    i = (e + 1) % LOG_BASE;
                    if (e < 0) i += LOG_BASE; // i < 1
                    if (i < len) {
                        if (i) x.c.push(+str.slice(0, i));
                        for(len -= LOG_BASE; i < len;)x.c.push(+str.slice(i, i += LOG_BASE));
                        i = LOG_BASE - (str = str.slice(i)).length;
                    } else i -= len;
                    for(; i--; str += "0");
                    x.c.push(+str);
                }
            } else // Zero.
            x.c = [
                x.e = 0
            ];
        }
        // CONSTRUCTOR PROPERTIES
        BigNumber.clone = clone;
        BigNumber.ROUND_UP = 0;
        BigNumber.ROUND_DOWN = 1;
        BigNumber.ROUND_CEIL = 2;
        BigNumber.ROUND_FLOOR = 3;
        BigNumber.ROUND_HALF_UP = 4;
        BigNumber.ROUND_HALF_DOWN = 5;
        BigNumber.ROUND_HALF_EVEN = 6;
        BigNumber.ROUND_HALF_CEIL = 7;
        BigNumber.ROUND_HALF_FLOOR = 8;
        BigNumber.EUCLID = 9;
        /*
     * Configure infrequently-changing library-wide settings.
     *
     * Accept an object with the following optional properties (if the value of a property is
     * a number, it must be an integer within the inclusive range stated):
     *
     *   DECIMAL_PLACES   {number}           0 to MAX
     *   ROUNDING_MODE    {number}           0 to 8
     *   EXPONENTIAL_AT   {number|number[]}  -MAX to MAX  or  [-MAX to 0, 0 to MAX]
     *   RANGE            {number|number[]}  -MAX to MAX (not zero)  or  [-MAX to -1, 1 to MAX]
     *   CRYPTO           {boolean}          true or false
     *   MODULO_MODE      {number}           0 to 9
     *   POW_PRECISION       {number}           0 to MAX
     *   ALPHABET         {string}           A string of two or more unique characters which does
     *                                       not contain '.'.
     *   FORMAT           {object}           An object with some of the following properties:
     *     prefix                 {string}
     *     groupSize              {number}
     *     secondaryGroupSize     {number}
     *     groupSeparator         {string}
     *     decimalSeparator       {string}
     *     fractionGroupSize      {number}
     *     fractionGroupSeparator {string}
     *     suffix                 {string}
     *
     * (The values assigned to the above FORMAT object properties are not checked for validity.)
     *
     * E.g.
     * BigNumber.config({ DECIMAL_PLACES : 20, ROUNDING_MODE : 4 })
     *
     * Ignore properties/parameters set to null or undefined, except for ALPHABET.
     *
     * Return an object with the properties current values.
     */ BigNumber.config = BigNumber.set = function(obj) {
            var p, v;
            if (obj != null) {
                if (typeof obj == "object") {
                    // DECIMAL_PLACES {number} Integer, 0 to MAX inclusive.
                    // '[BigNumber Error] DECIMAL_PLACES {not a primitive number|not an integer|out of range}: {v}'
                    if (obj.hasOwnProperty(p = "DECIMAL_PLACES")) {
                        v = obj[p];
                        intCheck(v, 0, MAX, p);
                        DECIMAL_PLACES = v;
                    }
                    // ROUNDING_MODE {number} Integer, 0 to 8 inclusive.
                    // '[BigNumber Error] ROUNDING_MODE {not a primitive number|not an integer|out of range}: {v}'
                    if (obj.hasOwnProperty(p = "ROUNDING_MODE")) {
                        v = obj[p];
                        intCheck(v, 0, 8, p);
                        ROUNDING_MODE = v;
                    }
                    // EXPONENTIAL_AT {number|number[]}
                    // Integer, -MAX to MAX inclusive or
                    // [integer -MAX to 0 inclusive, 0 to MAX inclusive].
                    // '[BigNumber Error] EXPONENTIAL_AT {not a primitive number|not an integer|out of range}: {v}'
                    if (obj.hasOwnProperty(p = "EXPONENTIAL_AT")) {
                        v = obj[p];
                        if (v && v.pop) {
                            intCheck(v[0], -MAX, 0, p);
                            intCheck(v[1], 0, MAX, p);
                            TO_EXP_NEG = v[0];
                            TO_EXP_POS = v[1];
                        } else {
                            intCheck(v, -MAX, MAX, p);
                            TO_EXP_NEG = -(TO_EXP_POS = v < 0 ? -v : v);
                        }
                    }
                    // RANGE {number|number[]} Non-zero integer, -MAX to MAX inclusive or
                    // [integer -MAX to -1 inclusive, integer 1 to MAX inclusive].
                    // '[BigNumber Error] RANGE {not a primitive number|not an integer|out of range|cannot be zero}: {v}'
                    if (obj.hasOwnProperty(p = "RANGE")) {
                        v = obj[p];
                        if (v && v.pop) {
                            intCheck(v[0], -MAX, -1, p);
                            intCheck(v[1], 1, MAX, p);
                            MIN_EXP = v[0];
                            MAX_EXP = v[1];
                        } else {
                            intCheck(v, -MAX, MAX, p);
                            if (v) MIN_EXP = -(MAX_EXP = v < 0 ? -v : v);
                            else throw Error(bignumberError + p + " cannot be zero: " + v);
                        }
                    }
                    // CRYPTO {boolean} true or false.
                    // '[BigNumber Error] CRYPTO not true or false: {v}'
                    // '[BigNumber Error] crypto unavailable'
                    if (obj.hasOwnProperty(p = "CRYPTO")) {
                        v = obj[p];
                        if (v === !!v) {
                            if (v) {
                                if (typeof crypto != "undefined" && crypto && (crypto.getRandomValues || crypto.randomBytes)) CRYPTO = v;
                                else {
                                    CRYPTO = !v;
                                    throw Error(bignumberError + "crypto unavailable");
                                }
                            } else CRYPTO = v;
                        } else throw Error(bignumberError + p + " not true or false: " + v);
                    }
                    // MODULO_MODE {number} Integer, 0 to 9 inclusive.
                    // '[BigNumber Error] MODULO_MODE {not a primitive number|not an integer|out of range}: {v}'
                    if (obj.hasOwnProperty(p = "MODULO_MODE")) {
                        v = obj[p];
                        intCheck(v, 0, 9, p);
                        MODULO_MODE = v;
                    }
                    // POW_PRECISION {number} Integer, 0 to MAX inclusive.
                    // '[BigNumber Error] POW_PRECISION {not a primitive number|not an integer|out of range}: {v}'
                    if (obj.hasOwnProperty(p = "POW_PRECISION")) {
                        v = obj[p];
                        intCheck(v, 0, MAX, p);
                        POW_PRECISION = v;
                    }
                    // FORMAT {object}
                    // '[BigNumber Error] FORMAT not an object: {v}'
                    if (obj.hasOwnProperty(p = "FORMAT")) {
                        v = obj[p];
                        if (typeof v == "object") FORMAT = v;
                        else throw Error(bignumberError + p + " not an object: " + v);
                    }
                    // ALPHABET {string}
                    // '[BigNumber Error] ALPHABET invalid: {v}'
                    if (obj.hasOwnProperty(p = "ALPHABET")) {
                        v = obj[p];
                        // Disallow if less than two characters,
                        // or if it contains '+', '-', '.', whitespace, or a repeated character.
                        if (typeof v == "string" && !/^.?$|[+\-.\s]|(.).*\1/.test(v)) {
                            alphabetHasNormalDecimalDigits = v.slice(0, 10) == "0123456789";
                            ALPHABET = v;
                        } else throw Error(bignumberError + p + " invalid: " + v);
                    }
                } else // '[BigNumber Error] Object expected: {v}'
                throw Error(bignumberError + "Object expected: " + obj);
            }
            return {
                DECIMAL_PLACES: DECIMAL_PLACES,
                ROUNDING_MODE: ROUNDING_MODE,
                EXPONENTIAL_AT: [
                    TO_EXP_NEG,
                    TO_EXP_POS
                ],
                RANGE: [
                    MIN_EXP,
                    MAX_EXP
                ],
                CRYPTO: CRYPTO,
                MODULO_MODE: MODULO_MODE,
                POW_PRECISION: POW_PRECISION,
                FORMAT: FORMAT,
                ALPHABET: ALPHABET
            };
        };
        /*
     * Return true if v is a BigNumber instance, otherwise return false.
     *
     * If BigNumber.DEBUG is true, throw if a BigNumber instance is not well-formed.
     *
     * v {any}
     *
     * '[BigNumber Error] Invalid BigNumber: {v}'
     */ BigNumber.isBigNumber = function(v) {
            if (!v || v._isBigNumber !== true) return false;
            if (!BigNumber.DEBUG) return true;
            var i, n, c = v.c, e = v.e, s = v.s;
            out: if (({}).toString.call(c) == "[object Array]") {
                if ((s === 1 || s === -1) && e >= -MAX && e <= MAX && e === mathfloor(e)) {
                    // If the first element is zero, the BigNumber value must be zero.
                    if (c[0] === 0) {
                        if (e === 0 && c.length === 1) return true;
                        break out;
                    }
                    // Calculate number of digits that c[0] should have, based on the exponent.
                    i = (e + 1) % LOG_BASE;
                    if (i < 1) i += LOG_BASE;
                    // Calculate number of digits of c[0].
                    //if (Math.ceil(Math.log(c[0] + 1) / Math.LN10) == i) {
                    if (String(c[0]).length == i) {
                        for(i = 0; i < c.length; i++){
                            n = c[i];
                            if (n < 0 || n >= BASE || n !== mathfloor(n)) break out;
                        }
                        // Last element cannot be zero, unless it is the only element.
                        if (n !== 0) return true;
                    }
                }
            } else if (c === null && e === null && (s === null || s === 1 || s === -1)) return true;
            throw Error(bignumberError + "Invalid BigNumber: " + v);
        };
        /*
     * Return a new BigNumber whose value is the maximum of the arguments.
     *
     * arguments {number|string|BigNumber}
     */ BigNumber.maximum = BigNumber.max = function() {
            return maxOrMin(arguments, P.lt);
        };
        /*
     * Return a new BigNumber whose value is the minimum of the arguments.
     *
     * arguments {number|string|BigNumber}
     */ BigNumber.minimum = BigNumber.min = function() {
            return maxOrMin(arguments, P.gt);
        };
        /*
     * Return a new BigNumber with a random value equal to or greater than 0 and less than 1,
     * and with dp, or DECIMAL_PLACES if dp is omitted, decimal places (or less if trailing
     * zeros are produced).
     *
     * [dp] {number} Decimal places. Integer, 0 to MAX inclusive.
     *
     * '[BigNumber Error] Argument {not a primitive number|not an integer|out of range}: {dp}'
     * '[BigNumber Error] crypto unavailable'
     */ BigNumber.random = function() {
            var pow2_53 = 0x20000000000000;
            // Return a 53 bit integer n, where 0 <= n < 9007199254740992.
            // Check if Math.random() produces more than 32 bits of randomness.
            // If it does, assume at least 53 bits are produced, otherwise assume at least 30 bits.
            // 0x40000000 is 2^30, 0x800000 is 2^23, 0x1fffff is 2^21 - 1.
            var random53bitInt = Math.random() * pow2_53 & 0x1fffff ? function() {
                return mathfloor(Math.random() * pow2_53);
            } : function() {
                return (Math.random() * 0x40000000 | 0) * 0x800000 + (Math.random() * 0x800000 | 0);
            };
            return function(dp) {
                var a, b, e, k, v, i = 0, c = [], rand = new BigNumber(ONE);
                if (dp == null) dp = DECIMAL_PLACES;
                else intCheck(dp, 0, MAX);
                k = mathceil(dp / LOG_BASE);
                if (CRYPTO) {
                    // Browsers supporting crypto.getRandomValues.
                    if (crypto.getRandomValues) {
                        a = crypto.getRandomValues(new Uint32Array(k *= 2));
                        for(; i < k;){
                            // 53 bits:
                            // ((Math.pow(2, 32) - 1) * Math.pow(2, 21)).toString(2)
                            // 11111 11111111 11111111 11111111 11100000 00000000 00000000
                            // ((Math.pow(2, 32) - 1) >>> 11).toString(2)
                            //                                     11111 11111111 11111111
                            // 0x20000 is 2^21.
                            v = a[i] * 0x20000 + (a[i + 1] >>> 11);
                            // Rejection sampling:
                            // 0 <= v < 9007199254740992
                            // Probability that v >= 9e15, is
                            // 7199254740992 / 9007199254740992 ~= 0.0008, i.e. 1 in 1251
                            if (v >= 9e15) {
                                b = crypto.getRandomValues(new Uint32Array(2));
                                a[i] = b[0];
                                a[i + 1] = b[1];
                            } else {
                                // 0 <= v <= 8999999999999999
                                // 0 <= (v % 1e14) <= 99999999999999
                                c.push(v % 1e14);
                                i += 2;
                            }
                        }
                        i = k / 2;
                    // Node.js supporting crypto.randomBytes.
                    } else if (crypto.randomBytes) {
                        // buffer
                        a = crypto.randomBytes(k *= 7);
                        for(; i < k;){
                            // 0x1000000000000 is 2^48, 0x10000000000 is 2^40
                            // 0x100000000 is 2^32, 0x1000000 is 2^24
                            // 11111 11111111 11111111 11111111 11111111 11111111 11111111
                            // 0 <= v < 9007199254740992
                            v = (a[i] & 31) * 0x1000000000000 + a[i + 1] * 0x10000000000 + a[i + 2] * 0x100000000 + a[i + 3] * 0x1000000 + (a[i + 4] << 16) + (a[i + 5] << 8) + a[i + 6];
                            if (v >= 9e15) crypto.randomBytes(7).copy(a, i);
                            else {
                                // 0 <= (v % 1e14) <= 99999999999999
                                c.push(v % 1e14);
                                i += 7;
                            }
                        }
                        i = k / 7;
                    } else {
                        CRYPTO = false;
                        throw Error(bignumberError + "crypto unavailable");
                    }
                }
                // Use Math.random.
                if (!CRYPTO) for(; i < k;){
                    v = random53bitInt();
                    if (v < 9e15) c[i++] = v % 1e14;
                }
                k = c[--i];
                dp %= LOG_BASE;
                // Convert trailing digits to zeros according to dp.
                if (k && dp) {
                    v = POWS_TEN[LOG_BASE - dp];
                    c[i] = mathfloor(k / v) * v;
                }
                // Remove trailing elements which are zero.
                for(; c[i] === 0; c.pop(), i--);
                // Zero?
                if (i < 0) c = [
                    e = 0
                ];
                else {
                    // Remove leading elements which are zero and adjust exponent accordingly.
                    for(e = -1; c[0] === 0; c.splice(0, 1), e -= LOG_BASE);
                    // Count the digits of the first element of c to determine leading zeros, and...
                    for(i = 1, v = c[0]; v >= 10; v /= 10, i++);
                    // adjust the exponent accordingly.
                    if (i < LOG_BASE) e -= LOG_BASE - i;
                }
                rand.e = e;
                rand.c = c;
                return rand;
            };
        }();
        /*
     * Return a BigNumber whose value is the sum of the arguments.
     *
     * arguments {number|string|BigNumber}
     */ BigNumber.sum = function() {
            var i = 1, args = arguments, sum = new BigNumber(args[0]);
            for(; i < args.length;)sum = sum.plus(args[i++]);
            return sum;
        };
        // PRIVATE FUNCTIONS
        // Called by BigNumber and BigNumber.prototype.toString.
        convertBase = function() {
            var decimal = "0123456789";
            /*
       * Convert string of baseIn to an array of numbers of baseOut.
       * Eg. toBaseOut('255', 10, 16) returns [15, 15].
       * Eg. toBaseOut('ff', 16, 10) returns [2, 5, 5].
       */ function toBaseOut(str, baseIn, baseOut, alphabet) {
                var j, arr = [
                    0
                ], arrL, i = 0, len = str.length;
                for(; i < len;){
                    for(arrL = arr.length; arrL--; arr[arrL] *= baseIn);
                    arr[0] += alphabet.indexOf(str.charAt(i++));
                    for(j = 0; j < arr.length; j++)if (arr[j] > baseOut - 1) {
                        if (arr[j + 1] == null) arr[j + 1] = 0;
                        arr[j + 1] += arr[j] / baseOut | 0;
                        arr[j] %= baseOut;
                    }
                }
                return arr.reverse();
            }
            // Convert a numeric string of baseIn to a numeric string of baseOut.
            // If the caller is toString, we are converting from base 10 to baseOut.
            // If the caller is BigNumber, we are converting from baseIn to base 10.
            return function(str, baseIn, baseOut, sign, callerIsToString) {
                var alphabet, d, e, k, r, x, xc, y, i = str.indexOf("."), dp = DECIMAL_PLACES, rm = ROUNDING_MODE;
                // Non-integer.
                if (i >= 0) {
                    k = POW_PRECISION;
                    // Unlimited precision.
                    POW_PRECISION = 0;
                    str = str.replace(".", "");
                    y = new BigNumber(baseIn);
                    x = y.pow(str.length - i);
                    POW_PRECISION = k;
                    // Convert str as if an integer, then restore the fraction part by dividing the
                    // result by its base raised to a power.
                    y.c = toBaseOut(toFixedPoint(coeffToString(x.c), x.e, "0"), 10, baseOut, decimal);
                    y.e = y.c.length;
                }
                // Convert the number as integer.
                xc = toBaseOut(str, baseIn, baseOut, callerIsToString ? (alphabet = ALPHABET, decimal) : (alphabet = decimal, ALPHABET));
                // xc now represents str as an integer and converted to baseOut. e is the exponent.
                e = k = xc.length;
                // Remove trailing zeros.
                for(; xc[--k] == 0; xc.pop());
                // Zero?
                if (!xc[0]) return alphabet.charAt(0);
                // Does str represent an integer? If so, no need for the division.
                if (i < 0) --e;
                else {
                    x.c = xc;
                    x.e = e;
                    // The sign is needed for correct rounding.
                    x.s = sign;
                    x = div(x, y, dp, rm, baseOut);
                    xc = x.c;
                    r = x.r;
                    e = x.e;
                }
                // xc now represents str converted to baseOut.
                // THe index of the rounding digit.
                d = e + dp + 1;
                // The rounding digit: the digit to the right of the digit that may be rounded up.
                i = xc[d];
                // Look at the rounding digits and mode to determine whether to round up.
                k = baseOut / 2;
                r = r || d < 0 || xc[d + 1] != null;
                r = rm < 4 ? (i != null || r) && (rm == 0 || rm == (x.s < 0 ? 3 : 2)) : i > k || i == k && (rm == 4 || r || rm == 6 && xc[d - 1] & 1 || rm == (x.s < 0 ? 8 : 7));
                // If the index of the rounding digit is not greater than zero, or xc represents
                // zero, then the result of the base conversion is zero or, if rounding up, a value
                // such as 0.00001.
                if (d < 1 || !xc[0]) // 1^-dp or 0
                str = r ? toFixedPoint(alphabet.charAt(1), -dp, alphabet.charAt(0)) : alphabet.charAt(0);
                else {
                    // Truncate xc to the required number of decimal places.
                    xc.length = d;
                    // Round up?
                    if (r) // Rounding up may mean the previous digit has to be rounded up and so on.
                    for(--baseOut; ++xc[--d] > baseOut;){
                        xc[d] = 0;
                        if (!d) {
                            ++e;
                            xc = [
                                1
                            ].concat(xc);
                        }
                    }
                    // Determine trailing zeros.
                    for(k = xc.length; !xc[--k];);
                    // E.g. [4, 11, 15] becomes 4bf.
                    for(i = 0, str = ""; i <= k; str += alphabet.charAt(xc[i++]));
                    // Add leading zeros, decimal point and trailing zeros as required.
                    str = toFixedPoint(str, e, alphabet.charAt(0));
                }
                // The caller will add the sign.
                return str;
            };
        }();
        // Perform division in the specified base. Called by div and convertBase.
        div = function() {
            // Assume non-zero x and k.
            function multiply(x, k, base) {
                var m, temp, xlo, xhi, carry = 0, i = x.length, klo = k % SQRT_BASE, khi = k / SQRT_BASE | 0;
                for(x = x.slice(); i--;){
                    xlo = x[i] % SQRT_BASE;
                    xhi = x[i] / SQRT_BASE | 0;
                    m = khi * xlo + xhi * klo;
                    temp = klo * xlo + m % SQRT_BASE * SQRT_BASE + carry;
                    carry = (temp / base | 0) + (m / SQRT_BASE | 0) + khi * xhi;
                    x[i] = temp % base;
                }
                if (carry) x = [
                    carry
                ].concat(x);
                return x;
            }
            function compare(a, b, aL, bL) {
                var i, cmp;
                if (aL != bL) cmp = aL > bL ? 1 : -1;
                else {
                    for(i = cmp = 0; i < aL; i++)if (a[i] != b[i]) {
                        cmp = a[i] > b[i] ? 1 : -1;
                        break;
                    }
                }
                return cmp;
            }
            function subtract(a, b, aL, base) {
                var i = 0;
                // Subtract b from a.
                for(; aL--;){
                    a[aL] -= i;
                    i = a[aL] < b[aL] ? 1 : 0;
                    a[aL] = i * base + a[aL] - b[aL];
                }
                // Remove leading zeros.
                for(; !a[0] && a.length > 1; a.splice(0, 1));
            }
            // x: dividend, y: divisor.
            return function(x, y, dp, rm, base) {
                var cmp, e, i, more, n, prod, prodL, q, qc, rem, remL, rem0, xi, xL, yc0, yL, yz, s = x.s == y.s ? 1 : -1, xc = x.c, yc = y.c;
                // Either NaN, Infinity or 0?
                if (!xc || !xc[0] || !yc || !yc[0]) return new BigNumber(// Return NaN if either NaN, or both Infinity or 0.
                !x.s || !y.s || (xc ? yc && xc[0] == yc[0] : !yc) ? NaN : // Return ±0 if x is ±0 or y is ±Infinity, or return ±Infinity as y is ±0.
                xc && xc[0] == 0 || !yc ? s * 0 : s / 0);
                q = new BigNumber(s);
                qc = q.c = [];
                e = x.e - y.e;
                s = dp + e + 1;
                if (!base) {
                    base = BASE;
                    e = bitFloor(x.e / LOG_BASE) - bitFloor(y.e / LOG_BASE);
                    s = s / LOG_BASE | 0;
                }
                // Result exponent may be one less then the current value of e.
                // The coefficients of the BigNumbers from convertBase may have trailing zeros.
                for(i = 0; yc[i] == (xc[i] || 0); i++);
                if (yc[i] > (xc[i] || 0)) e--;
                if (s < 0) {
                    qc.push(1);
                    more = true;
                } else {
                    xL = xc.length;
                    yL = yc.length;
                    i = 0;
                    s += 2;
                    // Normalise xc and yc so highest order digit of yc is >= base / 2.
                    n = mathfloor(base / (yc[0] + 1));
                    // Not necessary, but to handle odd bases where yc[0] == (base / 2) - 1.
                    // if (n > 1 || n++ == 1 && yc[0] < base / 2) {
                    if (n > 1) {
                        yc = multiply(yc, n, base);
                        xc = multiply(xc, n, base);
                        yL = yc.length;
                        xL = xc.length;
                    }
                    xi = yL;
                    rem = xc.slice(0, yL);
                    remL = rem.length;
                    // Add zeros to make remainder as long as divisor.
                    for(; remL < yL; rem[remL++] = 0);
                    yz = yc.slice();
                    yz = [
                        0
                    ].concat(yz);
                    yc0 = yc[0];
                    if (yc[1] >= base / 2) yc0++;
                    // Not necessary, but to prevent trial digit n > base, when using base 3.
                    // else if (base == 3 && yc0 == 1) yc0 = 1 + 1e-15;
                    do {
                        n = 0;
                        // Compare divisor and remainder.
                        cmp = compare(yc, rem, yL, remL);
                        // If divisor < remainder.
                        if (cmp < 0) {
                            // Calculate trial digit, n.
                            rem0 = rem[0];
                            if (yL != remL) rem0 = rem0 * base + (rem[1] || 0);
                            // n is how many times the divisor goes into the current remainder.
                            n = mathfloor(rem0 / yc0);
                            //  Algorithm:
                            //  product = divisor multiplied by trial digit (n).
                            //  Compare product and remainder.
                            //  If product is greater than remainder:
                            //    Subtract divisor from product, decrement trial digit.
                            //  Subtract product from remainder.
                            //  If product was less than remainder at the last compare:
                            //    Compare new remainder and divisor.
                            //    If remainder is greater than divisor:
                            //      Subtract divisor from remainder, increment trial digit.
                            if (n > 1) {
                                // n may be > base only when base is 3.
                                if (n >= base) n = base - 1;
                                // product = divisor * trial digit.
                                prod = multiply(yc, n, base);
                                prodL = prod.length;
                                remL = rem.length;
                                // Compare product and remainder.
                                // If product > remainder then trial digit n too high.
                                // n is 1 too high about 5% of the time, and is not known to have
                                // ever been more than 1 too high.
                                while(compare(prod, rem, prodL, remL) == 1){
                                    n--;
                                    // Subtract divisor from product.
                                    subtract(prod, yL < prodL ? yz : yc, prodL, base);
                                    prodL = prod.length;
                                    cmp = 1;
                                }
                            } else {
                                // n is 0 or 1, cmp is -1.
                                // If n is 0, there is no need to compare yc and rem again below,
                                // so change cmp to 1 to avoid it.
                                // If n is 1, leave cmp as -1, so yc and rem are compared again.
                                if (n == 0) // divisor < remainder, so n must be at least 1.
                                cmp = n = 1;
                                // product = divisor
                                prod = yc.slice();
                                prodL = prod.length;
                            }
                            if (prodL < remL) prod = [
                                0
                            ].concat(prod);
                            // Subtract product from remainder.
                            subtract(rem, prod, remL, base);
                            remL = rem.length;
                            // If product was < remainder.
                            if (cmp == -1) // Compare divisor and new remainder.
                            // If divisor < new remainder, subtract divisor from remainder.
                            // Trial digit n too low.
                            // n is 1 too low about 5% of the time, and very rarely 2 too low.
                            while(compare(yc, rem, yL, remL) < 1){
                                n++;
                                // Subtract divisor from remainder.
                                subtract(rem, yL < remL ? yz : yc, remL, base);
                                remL = rem.length;
                            }
                        } else if (cmp === 0) {
                            n++;
                            rem = [
                                0
                            ];
                        } // else cmp === 1 and n will be 0
                        // Add the next digit, n, to the result array.
                        qc[i++] = n;
                        // Update the remainder.
                        if (rem[0]) rem[remL++] = xc[xi] || 0;
                        else {
                            rem = [
                                xc[xi]
                            ];
                            remL = 1;
                        }
                    }while ((xi++ < xL || rem[0] != null) && s--);
                    more = rem[0] != null;
                    // Leading zero?
                    if (!qc[0]) qc.splice(0, 1);
                }
                if (base == BASE) {
                    // To calculate q.e, first get the number of digits of qc[0].
                    for(i = 1, s = qc[0]; s >= 10; s /= 10, i++);
                    round(q, dp + (q.e = i + e * LOG_BASE - 1) + 1, rm, more);
                // Caller is convertBase.
                } else {
                    q.e = e;
                    q.r = +more;
                }
                return q;
            };
        }();
        /*
     * Return a string representing the value of BigNumber n in fixed-point or exponential
     * notation rounded to the specified decimal places or significant digits.
     *
     * n: a BigNumber.
     * i: the index of the last digit required (i.e. the digit that may be rounded up).
     * rm: the rounding mode.
     * id: 1 (toExponential) or 2 (toPrecision).
     */ function format(n, i, rm, id) {
            var c0, e, ne, len, str;
            if (rm == null) rm = ROUNDING_MODE;
            else intCheck(rm, 0, 8);
            if (!n.c) return n.toString();
            c0 = n.c[0];
            ne = n.e;
            if (i == null) {
                str = coeffToString(n.c);
                str = id == 1 || id == 2 && (ne <= TO_EXP_NEG || ne >= TO_EXP_POS) ? toExponential(str, ne) : toFixedPoint(str, ne, "0");
            } else {
                n = round(new BigNumber(n), i, rm);
                // n.e may have changed if the value was rounded up.
                e = n.e;
                str = coeffToString(n.c);
                len = str.length;
                // toPrecision returns exponential notation if the number of significant digits
                // specified is less than the number of digits necessary to represent the integer
                // part of the value in fixed-point notation.
                // Exponential notation.
                if (id == 1 || id == 2 && (i <= e || e <= TO_EXP_NEG)) {
                    // Append zeros?
                    for(; len < i; str += "0", len++);
                    str = toExponential(str, e);
                // Fixed-point notation.
                } else {
                    i -= ne;
                    str = toFixedPoint(str, e, "0");
                    // Append zeros?
                    if (e + 1 > len) {
                        if (--i > 0) for(str += "."; i--; str += "0");
                    } else {
                        i += e - len;
                        if (i > 0) {
                            if (e + 1 == len) str += ".";
                            for(; i--; str += "0");
                        }
                    }
                }
            }
            return n.s < 0 && c0 ? "-" + str : str;
        }
        // Handle BigNumber.max and BigNumber.min.
        function maxOrMin(args, method) {
            var n, i = 1, m = new BigNumber(args[0]);
            for(; i < args.length; i++){
                n = new BigNumber(args[i]);
                // If any number is NaN, return NaN.
                if (!n.s) {
                    m = n;
                    break;
                } else if (method.call(m, n)) m = n;
            }
            return m;
        }
        /*
     * Strip trailing zeros, calculate base 10 exponent and check against MIN_EXP and MAX_EXP.
     * Called by minus, plus and times.
     */ function normalise(n, c, e) {
            var i = 1, j = c.length;
            // Remove trailing zeros.
            for(; !c[--j]; c.pop());
            // Calculate the base 10 exponent. First get the number of digits of c[0].
            for(j = c[0]; j >= 10; j /= 10, i++);
            // Overflow?
            if ((e = i + e * LOG_BASE - 1) > MAX_EXP) // Infinity.
            n.c = n.e = null;
            else if (e < MIN_EXP) // Zero.
            n.c = [
                n.e = 0
            ];
            else {
                n.e = e;
                n.c = c;
            }
            return n;
        }
        // Handle values that fail the validity test in BigNumber.
        parseNumeric = function() {
            var basePrefix = /^(-?)0([xbo])(?=\w[\w.]*$)/i, dotAfter = /^([^.]+)\.$/, dotBefore = /^\.([^.]+)$/, isInfinityOrNaN = /^-?(Infinity|NaN)$/, whitespaceOrPlus = /^\s*\+(?=[\w.])|^\s+|\s+$/g;
            return function(x, str, isNum, b) {
                var base, s = isNum ? str : str.replace(whitespaceOrPlus, "");
                // No exception on ±Infinity or NaN.
                if (isInfinityOrNaN.test(s)) x.s = isNaN(s) ? null : s < 0 ? -1 : 1;
                else {
                    if (!isNum) {
                        // basePrefix = /^(-?)0([xbo])(?=\w[\w.]*$)/i
                        s = s.replace(basePrefix, function(m, p1, p2) {
                            base = (p2 = p2.toLowerCase()) == "x" ? 16 : p2 == "b" ? 2 : 8;
                            return !b || b == base ? p1 : m;
                        });
                        if (b) {
                            base = b;
                            // E.g. '1.' to '1', '.1' to '0.1'
                            s = s.replace(dotAfter, "$1").replace(dotBefore, "0.$1");
                        }
                        if (str != s) return new BigNumber(s, base);
                    }
                    // '[BigNumber Error] Not a number: {n}'
                    // '[BigNumber Error] Not a base {b} number: {n}'
                    if (BigNumber.DEBUG) throw Error(bignumberError + "Not a" + (b ? " base " + b : "") + " number: " + str);
                    // NaN
                    x.s = null;
                }
                x.c = x.e = null;
            };
        }();
        /*
     * Round x to sd significant digits using rounding mode rm. Check for over/under-flow.
     * If r is truthy, it is known that there are more digits after the rounding digit.
     */ function round(x, sd, rm, r) {
            var d, i, j, k, n, ni, rd, xc = x.c, pows10 = POWS_TEN;
            // if x is not Infinity or NaN...
            if (xc) {
                // rd is the rounding digit, i.e. the digit after the digit that may be rounded up.
                // n is a base 1e14 number, the value of the element of array x.c containing rd.
                // ni is the index of n within x.c.
                // d is the number of digits of n.
                // i is the index of rd within n including leading zeros.
                // j is the actual index of rd within n (if < 0, rd is a leading zero).
                out: {
                    // Get the number of digits of the first element of xc.
                    for(d = 1, k = xc[0]; k >= 10; k /= 10, d++);
                    i = sd - d;
                    // If the rounding digit is in the first element of xc...
                    if (i < 0) {
                        i += LOG_BASE;
                        j = sd;
                        n = xc[ni = 0];
                        // Get the rounding digit at index j of n.
                        rd = n / pows10[d - j - 1] % 10 | 0;
                    } else {
                        ni = mathceil((i + 1) / LOG_BASE);
                        if (ni >= xc.length) {
                            if (r) {
                                // Needed by sqrt.
                                for(; xc.length <= ni; xc.push(0));
                                n = rd = 0;
                                d = 1;
                                i %= LOG_BASE;
                                j = i - LOG_BASE + 1;
                            } else break out;
                        } else {
                            n = k = xc[ni];
                            // Get the number of digits of n.
                            for(d = 1; k >= 10; k /= 10, d++);
                            // Get the index of rd within n.
                            i %= LOG_BASE;
                            // Get the index of rd within n, adjusted for leading zeros.
                            // The number of leading zeros of n is given by LOG_BASE - d.
                            j = i - LOG_BASE + d;
                            // Get the rounding digit at index j of n.
                            rd = j < 0 ? 0 : n / pows10[d - j - 1] % 10 | 0;
                        }
                    }
                    r = r || sd < 0 || // Are there any non-zero digits after the rounding digit?
                    // The expression  n % pows10[d - j - 1]  returns all digits of n to the right
                    // of the digit at j, e.g. if n is 908714 and j is 2, the expression gives 714.
                    xc[ni + 1] != null || (j < 0 ? n : n % pows10[d - j - 1]);
                    r = rm < 4 ? (rd || r) && (rm == 0 || rm == (x.s < 0 ? 3 : 2)) : rd > 5 || rd == 5 && (rm == 4 || r || rm == 6 && (i > 0 ? j > 0 ? n / pows10[d - j] : 0 : xc[ni - 1]) % 10 & 1 || rm == (x.s < 0 ? 8 : 7));
                    if (sd < 1 || !xc[0]) {
                        xc.length = 0;
                        if (r) {
                            // Convert sd to decimal places.
                            sd -= x.e + 1;
                            // 1, 0.1, 0.01, 0.001, 0.0001 etc.
                            xc[0] = pows10[(LOG_BASE - sd % LOG_BASE) % LOG_BASE];
                            x.e = -sd || 0;
                        } else // Zero.
                        xc[0] = x.e = 0;
                        return x;
                    }
                    // Remove excess digits.
                    if (i == 0) {
                        xc.length = ni;
                        k = 1;
                        ni--;
                    } else {
                        xc.length = ni + 1;
                        k = pows10[LOG_BASE - i];
                        // E.g. 56700 becomes 56000 if 7 is the rounding digit.
                        // j > 0 means i > number of leading zeros of n.
                        xc[ni] = j > 0 ? mathfloor(n / pows10[d - j] % pows10[j]) * k : 0;
                    }
                    // Round up?
                    if (r) {
                        for(;;)// If the digit to be rounded up is in the first element of xc...
                        if (ni == 0) {
                            // i will be the length of xc[0] before k is added.
                            for(i = 1, j = xc[0]; j >= 10; j /= 10, i++);
                            j = xc[0] += k;
                            for(k = 1; j >= 10; j /= 10, k++);
                            // if i != k the length has increased.
                            if (i != k) {
                                x.e++;
                                if (xc[0] == BASE) xc[0] = 1;
                            }
                            break;
                        } else {
                            xc[ni] += k;
                            if (xc[ni] != BASE) break;
                            xc[ni--] = 0;
                            k = 1;
                        }
                    }
                    // Remove trailing zeros.
                    for(i = xc.length; xc[--i] === 0; xc.pop());
                }
                // Overflow? Infinity.
                if (x.e > MAX_EXP) x.c = x.e = null;
                else if (x.e < MIN_EXP) x.c = [
                    x.e = 0
                ];
            }
            return x;
        }
        function valueOf(n) {
            var str, e = n.e;
            if (e === null) return n.toString();
            str = coeffToString(n.c);
            str = e <= TO_EXP_NEG || e >= TO_EXP_POS ? toExponential(str, e) : toFixedPoint(str, e, "0");
            return n.s < 0 ? "-" + str : str;
        }
        // PROTOTYPE/INSTANCE METHODS
        /*
     * Return a new BigNumber whose value is the absolute value of this BigNumber.
     */ P.absoluteValue = P.abs = function() {
            var x = new BigNumber(this);
            if (x.s < 0) x.s = 1;
            return x;
        };
        /*
     * Return
     *   1 if the value of this BigNumber is greater than the value of BigNumber(y, b),
     *   -1 if the value of this BigNumber is less than the value of BigNumber(y, b),
     *   0 if they have the same value,
     *   or null if the value of either is NaN.
     */ P.comparedTo = function(y, b) {
            return compare(this, new BigNumber(y, b));
        };
        /*
     * If dp is undefined or null or true or false, return the number of decimal places of the
     * value of this BigNumber, or null if the value of this BigNumber is ±Infinity or NaN.
     *
     * Otherwise, if dp is a number, return a new BigNumber whose value is the value of this
     * BigNumber rounded to a maximum of dp decimal places using rounding mode rm, or
     * ROUNDING_MODE if rm is omitted.
     *
     * [dp] {number} Decimal places: integer, 0 to MAX inclusive.
     * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
     *
     * '[BigNumber Error] Argument {not a primitive number|not an integer|out of range}: {dp|rm}'
     */ P.decimalPlaces = P.dp = function(dp, rm) {
            var c, n, v, x = this;
            if (dp != null) {
                intCheck(dp, 0, MAX);
                if (rm == null) rm = ROUNDING_MODE;
                else intCheck(rm, 0, 8);
                return round(new BigNumber(x), dp + x.e + 1, rm);
            }
            if (!(c = x.c)) return null;
            n = ((v = c.length - 1) - bitFloor(this.e / LOG_BASE)) * LOG_BASE;
            // Subtract the number of trailing zeros of the last number.
            if (v = c[v]) for(; v % 10 == 0; v /= 10, n--);
            if (n < 0) n = 0;
            return n;
        };
        /*
     *  n / 0 = I
     *  n / N = N
     *  n / I = 0
     *  0 / n = 0
     *  0 / 0 = N
     *  0 / N = N
     *  0 / I = 0
     *  N / n = N
     *  N / 0 = N
     *  N / N = N
     *  N / I = N
     *  I / n = I
     *  I / 0 = I
     *  I / N = N
     *  I / I = N
     *
     * Return a new BigNumber whose value is the value of this BigNumber divided by the value of
     * BigNumber(y, b), rounded according to DECIMAL_PLACES and ROUNDING_MODE.
     */ P.dividedBy = P.div = function(y, b) {
            return div(this, new BigNumber(y, b), DECIMAL_PLACES, ROUNDING_MODE);
        };
        /*
     * Return a new BigNumber whose value is the integer part of dividing the value of this
     * BigNumber by the value of BigNumber(y, b).
     */ P.dividedToIntegerBy = P.idiv = function(y, b) {
            return div(this, new BigNumber(y, b), 0, 1);
        };
        /*
     * Return a BigNumber whose value is the value of this BigNumber exponentiated by n.
     *
     * If m is present, return the result modulo m.
     * If n is negative round according to DECIMAL_PLACES and ROUNDING_MODE.
     * If POW_PRECISION is non-zero and m is not present, round to POW_PRECISION using ROUNDING_MODE.
     *
     * The modular power operation works efficiently when x, n, and m are integers, otherwise it
     * is equivalent to calculating x.exponentiatedBy(n).modulo(m) with a POW_PRECISION of 0.
     *
     * n {number|string|BigNumber} The exponent. An integer.
     * [m] {number|string|BigNumber} The modulus.
     *
     * '[BigNumber Error] Exponent not an integer: {n}'
     */ P.exponentiatedBy = P.pow = function(n, m) {
            var half, isModExp, i, k, more, nIsBig, nIsNeg, nIsOdd, y, x = this;
            n = new BigNumber(n);
            // Allow NaN and ±Infinity, but not other non-integers.
            if (n.c && !n.isInteger()) throw Error(bignumberError + "Exponent not an integer: " + valueOf(n));
            if (m != null) m = new BigNumber(m);
            // Exponent of MAX_SAFE_INTEGER is 15.
            nIsBig = n.e > 14;
            // If x is NaN, ±Infinity, ±0 or ±1, or n is ±Infinity, NaN or ±0.
            if (!x.c || !x.c[0] || x.c[0] == 1 && !x.e && x.c.length == 1 || !n.c || !n.c[0]) {
                // The sign of the result of pow when x is negative depends on the evenness of n.
                // If +n overflows to ±Infinity, the evenness of n would be not be known.
                y = new BigNumber(Math.pow(+valueOf(x), nIsBig ? n.s * (2 - isOdd(n)) : +valueOf(n)));
                return m ? y.mod(m) : y;
            }
            nIsNeg = n.s < 0;
            if (m) {
                // x % m returns NaN if abs(m) is zero, or m is NaN.
                if (m.c ? !m.c[0] : !m.s) return new BigNumber(NaN);
                isModExp = !nIsNeg && x.isInteger() && m.isInteger();
                if (isModExp) x = x.mod(m);
            // Overflow to ±Infinity: >=2**1e10 or >=1.0000024**1e15.
            // Underflow to ±0: <=0.79**1e10 or <=0.9999975**1e15.
            } else if (n.e > 9 && (x.e > 0 || x.e < -1 || (x.e == 0 ? x.c[0] > 1 || nIsBig && x.c[1] >= 24e7 : x.c[0] < 8e13 || nIsBig && x.c[0] <= 9999975e7))) {
                // If x is negative and n is odd, k = -0, else k = 0.
                k = x.s < 0 && isOdd(n) ? -0 : 0;
                // If x >= 1, k = ±Infinity.
                if (x.e > -1) k = 1 / k;
                // If n is negative return ±0, else return ±Infinity.
                return new BigNumber(nIsNeg ? 1 / k : k);
            } else if (POW_PRECISION) // Truncating each coefficient array to a length of k after each multiplication
            // equates to truncating significant digits to POW_PRECISION + [28, 41],
            // i.e. there will be a minimum of 28 guard digits retained.
            k = mathceil(POW_PRECISION / LOG_BASE + 2);
            if (nIsBig) {
                half = new BigNumber(0.5);
                if (nIsNeg) n.s = 1;
                nIsOdd = isOdd(n);
            } else {
                i = Math.abs(+valueOf(n));
                nIsOdd = i % 2;
            }
            y = new BigNumber(ONE);
            // Performs 54 loop iterations for n of 9007199254740991.
            for(;;){
                if (nIsOdd) {
                    y = y.times(x);
                    if (!y.c) break;
                    if (k) {
                        if (y.c.length > k) y.c.length = k;
                    } else if (isModExp) y = y.mod(m); //y = y.minus(div(y, m, 0, MODULO_MODE).times(m));
                }
                if (i) {
                    i = mathfloor(i / 2);
                    if (i === 0) break;
                    nIsOdd = i % 2;
                } else {
                    n = n.times(half);
                    round(n, n.e + 1, 1);
                    if (n.e > 14) nIsOdd = isOdd(n);
                    else {
                        i = +valueOf(n);
                        if (i === 0) break;
                        nIsOdd = i % 2;
                    }
                }
                x = x.times(x);
                if (k) {
                    if (x.c && x.c.length > k) x.c.length = k;
                } else if (isModExp) x = x.mod(m); //x = x.minus(div(x, m, 0, MODULO_MODE).times(m));
            }
            if (isModExp) return y;
            if (nIsNeg) y = ONE.div(y);
            return m ? y.mod(m) : k ? round(y, POW_PRECISION, ROUNDING_MODE, more) : y;
        };
        /*
     * Return a new BigNumber whose value is the value of this BigNumber rounded to an integer
     * using rounding mode rm, or ROUNDING_MODE if rm is omitted.
     *
     * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
     *
     * '[BigNumber Error] Argument {not a primitive number|not an integer|out of range}: {rm}'
     */ P.integerValue = function(rm) {
            var n = new BigNumber(this);
            if (rm == null) rm = ROUNDING_MODE;
            else intCheck(rm, 0, 8);
            return round(n, n.e + 1, rm);
        };
        /*
     * Return true if the value of this BigNumber is equal to the value of BigNumber(y, b),
     * otherwise return false.
     */ P.isEqualTo = P.eq = function(y, b) {
            return compare(this, new BigNumber(y, b)) === 0;
        };
        /*
     * Return true if the value of this BigNumber is a finite number, otherwise return false.
     */ P.isFinite = function() {
            return !!this.c;
        };
        /*
     * Return true if the value of this BigNumber is greater than the value of BigNumber(y, b),
     * otherwise return false.
     */ P.isGreaterThan = P.gt = function(y, b) {
            return compare(this, new BigNumber(y, b)) > 0;
        };
        /*
     * Return true if the value of this BigNumber is greater than or equal to the value of
     * BigNumber(y, b), otherwise return false.
     */ P.isGreaterThanOrEqualTo = P.gte = function(y, b) {
            return (b = compare(this, new BigNumber(y, b))) === 1 || b === 0;
        };
        /*
     * Return true if the value of this BigNumber is an integer, otherwise return false.
     */ P.isInteger = function() {
            return !!this.c && bitFloor(this.e / LOG_BASE) > this.c.length - 2;
        };
        /*
     * Return true if the value of this BigNumber is less than the value of BigNumber(y, b),
     * otherwise return false.
     */ P.isLessThan = P.lt = function(y, b) {
            return compare(this, new BigNumber(y, b)) < 0;
        };
        /*
     * Return true if the value of this BigNumber is less than or equal to the value of
     * BigNumber(y, b), otherwise return false.
     */ P.isLessThanOrEqualTo = P.lte = function(y, b) {
            return (b = compare(this, new BigNumber(y, b))) === -1 || b === 0;
        };
        /*
     * Return true if the value of this BigNumber is NaN, otherwise return false.
     */ P.isNaN = function() {
            return !this.s;
        };
        /*
     * Return true if the value of this BigNumber is negative, otherwise return false.
     */ P.isNegative = function() {
            return this.s < 0;
        };
        /*
     * Return true if the value of this BigNumber is positive, otherwise return false.
     */ P.isPositive = function() {
            return this.s > 0;
        };
        /*
     * Return true if the value of this BigNumber is 0 or -0, otherwise return false.
     */ P.isZero = function() {
            return !!this.c && this.c[0] == 0;
        };
        /*
     *  n - 0 = n
     *  n - N = N
     *  n - I = -I
     *  0 - n = -n
     *  0 - 0 = 0
     *  0 - N = N
     *  0 - I = -I
     *  N - n = N
     *  N - 0 = N
     *  N - N = N
     *  N - I = N
     *  I - n = I
     *  I - 0 = I
     *  I - N = N
     *  I - I = N
     *
     * Return a new BigNumber whose value is the value of this BigNumber minus the value of
     * BigNumber(y, b).
     */ P.minus = function(y, b) {
            var i, j, t, xLTy, x = this, a = x.s;
            y = new BigNumber(y, b);
            b = y.s;
            // Either NaN?
            if (!a || !b) return new BigNumber(NaN);
            // Signs differ?
            if (a != b) {
                y.s = -b;
                return x.plus(y);
            }
            var xe = x.e / LOG_BASE, ye = y.e / LOG_BASE, xc = x.c, yc = y.c;
            if (!xe || !ye) {
                // Either Infinity?
                if (!xc || !yc) return xc ? (y.s = -b, y) : new BigNumber(yc ? x : NaN);
                // Either zero?
                if (!xc[0] || !yc[0]) // Return y if y is non-zero, x if x is non-zero, or zero if both are zero.
                return yc[0] ? (y.s = -b, y) : new BigNumber(xc[0] ? x : // IEEE 754 (2008) 6.3: n - n = -0 when rounding to -Infinity
                ROUNDING_MODE == 3 ? -0 : 0);
            }
            xe = bitFloor(xe);
            ye = bitFloor(ye);
            xc = xc.slice();
            // Determine which is the bigger number.
            if (a = xe - ye) {
                if (xLTy = a < 0) {
                    a = -a;
                    t = xc;
                } else {
                    ye = xe;
                    t = yc;
                }
                t.reverse();
                // Prepend zeros to equalise exponents.
                for(b = a; b--; t.push(0));
                t.reverse();
            } else {
                // Exponents equal. Check digit by digit.
                j = (xLTy = (a = xc.length) < (b = yc.length)) ? a : b;
                for(a = b = 0; b < j; b++)if (xc[b] != yc[b]) {
                    xLTy = xc[b] < yc[b];
                    break;
                }
            }
            // x < y? Point xc to the array of the bigger number.
            if (xLTy) {
                t = xc;
                xc = yc;
                yc = t;
                y.s = -y.s;
            }
            b = (j = yc.length) - (i = xc.length);
            // Append zeros to xc if shorter.
            // No need to add zeros to yc if shorter as subtract only needs to start at yc.length.
            if (b > 0) for(; b--; xc[i++] = 0);
            b = BASE - 1;
            // Subtract yc from xc.
            for(; j > a;){
                if (xc[--j] < yc[j]) {
                    for(i = j; i && !xc[--i]; xc[i] = b);
                    --xc[i];
                    xc[j] += BASE;
                }
                xc[j] -= yc[j];
            }
            // Remove leading zeros and adjust exponent accordingly.
            for(; xc[0] == 0; xc.splice(0, 1), --ye);
            // Zero?
            if (!xc[0]) {
                // Following IEEE 754 (2008) 6.3,
                // n - n = +0  but  n - n = -0  when rounding towards -Infinity.
                y.s = ROUNDING_MODE == 3 ? -1 : 1;
                y.c = [
                    y.e = 0
                ];
                return y;
            }
            // No need to check for Infinity as +x - +y != Infinity && -x - -y != Infinity
            // for finite x and y.
            return normalise(y, xc, ye);
        };
        /*
     *   n % 0 =  N
     *   n % N =  N
     *   n % I =  n
     *   0 % n =  0
     *  -0 % n = -0
     *   0 % 0 =  N
     *   0 % N =  N
     *   0 % I =  0
     *   N % n =  N
     *   N % 0 =  N
     *   N % N =  N
     *   N % I =  N
     *   I % n =  N
     *   I % 0 =  N
     *   I % N =  N
     *   I % I =  N
     *
     * Return a new BigNumber whose value is the value of this BigNumber modulo the value of
     * BigNumber(y, b). The result depends on the value of MODULO_MODE.
     */ P.modulo = P.mod = function(y, b) {
            var q, s, x = this;
            y = new BigNumber(y, b);
            // Return NaN if x is Infinity or NaN, or y is NaN or zero.
            if (!x.c || !y.s || y.c && !y.c[0]) return new BigNumber(NaN);
            else if (!y.c || x.c && !x.c[0]) return new BigNumber(x);
            if (MODULO_MODE == 9) {
                // Euclidian division: q = sign(y) * floor(x / abs(y))
                // r = x - qy    where  0 <= r < abs(y)
                s = y.s;
                y.s = 1;
                q = div(x, y, 0, 3);
                y.s = s;
                q.s *= s;
            } else q = div(x, y, 0, MODULO_MODE);
            y = x.minus(q.times(y));
            // To match JavaScript %, ensure sign of zero is sign of dividend.
            if (!y.c[0] && MODULO_MODE == 1) y.s = x.s;
            return y;
        };
        /*
     *  n * 0 = 0
     *  n * N = N
     *  n * I = I
     *  0 * n = 0
     *  0 * 0 = 0
     *  0 * N = N
     *  0 * I = N
     *  N * n = N
     *  N * 0 = N
     *  N * N = N
     *  N * I = N
     *  I * n = I
     *  I * 0 = N
     *  I * N = N
     *  I * I = I
     *
     * Return a new BigNumber whose value is the value of this BigNumber multiplied by the value
     * of BigNumber(y, b).
     */ P.multipliedBy = P.times = function(y, b) {
            var c, e, i, j, k, m, xcL, xlo, xhi, ycL, ylo, yhi, zc, base, sqrtBase, x = this, xc = x.c, yc = (y = new BigNumber(y, b)).c;
            // Either NaN, ±Infinity or ±0?
            if (!xc || !yc || !xc[0] || !yc[0]) {
                // Return NaN if either is NaN, or one is 0 and the other is Infinity.
                if (!x.s || !y.s || xc && !xc[0] && !yc || yc && !yc[0] && !xc) y.c = y.e = y.s = null;
                else {
                    y.s *= x.s;
                    // Return ±Infinity if either is ±Infinity.
                    if (!xc || !yc) y.c = y.e = null;
                    else {
                        y.c = [
                            0
                        ];
                        y.e = 0;
                    }
                }
                return y;
            }
            e = bitFloor(x.e / LOG_BASE) + bitFloor(y.e / LOG_BASE);
            y.s *= x.s;
            xcL = xc.length;
            ycL = yc.length;
            // Ensure xc points to longer array and xcL to its length.
            if (xcL < ycL) {
                zc = xc;
                xc = yc;
                yc = zc;
                i = xcL;
                xcL = ycL;
                ycL = i;
            }
            // Initialise the result array with zeros.
            for(i = xcL + ycL, zc = []; i--; zc.push(0));
            base = BASE;
            sqrtBase = SQRT_BASE;
            for(i = ycL; --i >= 0;){
                c = 0;
                ylo = yc[i] % sqrtBase;
                yhi = yc[i] / sqrtBase | 0;
                for(k = xcL, j = i + k; j > i;){
                    xlo = xc[--k] % sqrtBase;
                    xhi = xc[k] / sqrtBase | 0;
                    m = yhi * xlo + xhi * ylo;
                    xlo = ylo * xlo + m % sqrtBase * sqrtBase + zc[j] + c;
                    c = (xlo / base | 0) + (m / sqrtBase | 0) + yhi * xhi;
                    zc[j--] = xlo % base;
                }
                zc[j] = c;
            }
            if (c) ++e;
            else zc.splice(0, 1);
            return normalise(y, zc, e);
        };
        /*
     * Return a new BigNumber whose value is the value of this BigNumber negated,
     * i.e. multiplied by -1.
     */ P.negated = function() {
            var x = new BigNumber(this);
            x.s = -x.s || null;
            return x;
        };
        /*
     *  n + 0 = n
     *  n + N = N
     *  n + I = I
     *  0 + n = n
     *  0 + 0 = 0
     *  0 + N = N
     *  0 + I = I
     *  N + n = N
     *  N + 0 = N
     *  N + N = N
     *  N + I = N
     *  I + n = I
     *  I + 0 = I
     *  I + N = N
     *  I + I = I
     *
     * Return a new BigNumber whose value is the value of this BigNumber plus the value of
     * BigNumber(y, b).
     */ P.plus = function(y, b) {
            var t, x = this, a = x.s;
            y = new BigNumber(y, b);
            b = y.s;
            // Either NaN?
            if (!a || !b) return new BigNumber(NaN);
            // Signs differ?
            if (a != b) {
                y.s = -b;
                return x.minus(y);
            }
            var xe = x.e / LOG_BASE, ye = y.e / LOG_BASE, xc = x.c, yc = y.c;
            if (!xe || !ye) {
                // Return ±Infinity if either ±Infinity.
                if (!xc || !yc) return new BigNumber(a / 0);
                // Either zero?
                // Return y if y is non-zero, x if x is non-zero, or zero if both are zero.
                if (!xc[0] || !yc[0]) return yc[0] ? y : new BigNumber(xc[0] ? x : a * 0);
            }
            xe = bitFloor(xe);
            ye = bitFloor(ye);
            xc = xc.slice();
            // Prepend zeros to equalise exponents. Faster to use reverse then do unshifts.
            if (a = xe - ye) {
                if (a > 0) {
                    ye = xe;
                    t = yc;
                } else {
                    a = -a;
                    t = xc;
                }
                t.reverse();
                for(; a--; t.push(0));
                t.reverse();
            }
            a = xc.length;
            b = yc.length;
            // Point xc to the longer array, and b to the shorter length.
            if (a - b < 0) {
                t = yc;
                yc = xc;
                xc = t;
                b = a;
            }
            // Only start adding at yc.length - 1 as the further digits of xc can be ignored.
            for(a = 0; b;){
                a = (xc[--b] = xc[b] + yc[b] + a) / BASE | 0;
                xc[b] = BASE === xc[b] ? 0 : xc[b] % BASE;
            }
            if (a) {
                xc = [
                    a
                ].concat(xc);
                ++ye;
            }
            // No need to check for zero, as +x + +y != 0 && -x + -y != 0
            // ye = MAX_EXP + 1 possible
            return normalise(y, xc, ye);
        };
        /*
     * If sd is undefined or null or true or false, return the number of significant digits of
     * the value of this BigNumber, or null if the value of this BigNumber is ±Infinity or NaN.
     * If sd is true include integer-part trailing zeros in the count.
     *
     * Otherwise, if sd is a number, return a new BigNumber whose value is the value of this
     * BigNumber rounded to a maximum of sd significant digits using rounding mode rm, or
     * ROUNDING_MODE if rm is omitted.
     *
     * sd {number|boolean} number: significant digits: integer, 1 to MAX inclusive.
     *                     boolean: whether to count integer-part trailing zeros: true or false.
     * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
     *
     * '[BigNumber Error] Argument {not a primitive number|not an integer|out of range}: {sd|rm}'
     */ P.precision = P.sd = function(sd, rm) {
            var c, n, v, x = this;
            if (sd != null && sd !== !!sd) {
                intCheck(sd, 1, MAX);
                if (rm == null) rm = ROUNDING_MODE;
                else intCheck(rm, 0, 8);
                return round(new BigNumber(x), sd, rm);
            }
            if (!(c = x.c)) return null;
            v = c.length - 1;
            n = v * LOG_BASE + 1;
            if (v = c[v]) {
                // Subtract the number of trailing zeros of the last element.
                for(; v % 10 == 0; v /= 10, n--);
                // Add the number of digits of the first element.
                for(v = c[0]; v >= 10; v /= 10, n++);
            }
            if (sd && x.e + 1 > n) n = x.e + 1;
            return n;
        };
        /*
     * Return a new BigNumber whose value is the value of this BigNumber shifted by k places
     * (powers of 10). Shift to the right if n > 0, and to the left if n < 0.
     *
     * k {number} Integer, -MAX_SAFE_INTEGER to MAX_SAFE_INTEGER inclusive.
     *
     * '[BigNumber Error] Argument {not a primitive number|not an integer|out of range}: {k}'
     */ P.shiftedBy = function(k) {
            intCheck(k, -MAX_SAFE_INTEGER, MAX_SAFE_INTEGER);
            return this.times("1e" + k);
        };
        /*
     *  sqrt(-n) =  N
     *  sqrt(N) =  N
     *  sqrt(-I) =  N
     *  sqrt(I) =  I
     *  sqrt(0) =  0
     *  sqrt(-0) = -0
     *
     * Return a new BigNumber whose value is the square root of the value of this BigNumber,
     * rounded according to DECIMAL_PLACES and ROUNDING_MODE.
     */ P.squareRoot = P.sqrt = function() {
            var m, n, r, rep, t, x = this, c = x.c, s = x.s, e = x.e, dp = DECIMAL_PLACES + 4, half = new BigNumber("0.5");
            // Negative/NaN/Infinity/zero?
            if (s !== 1 || !c || !c[0]) return new BigNumber(!s || s < 0 && (!c || c[0]) ? NaN : c ? x : 1 / 0);
            // Initial estimate.
            s = Math.sqrt(+valueOf(x));
            // Math.sqrt underflow/overflow?
            // Pass x to Math.sqrt as integer, then adjust the exponent of the result.
            if (s == 0 || s == 1 / 0) {
                n = coeffToString(c);
                if ((n.length + e) % 2 == 0) n += "0";
                s = Math.sqrt(+n);
                e = bitFloor((e + 1) / 2) - (e < 0 || e % 2);
                if (s == 1 / 0) n = "5e" + e;
                else {
                    n = s.toExponential();
                    n = n.slice(0, n.indexOf("e") + 1) + e;
                }
                r = new BigNumber(n);
            } else r = new BigNumber(s + "");
            // Check for zero.
            // r could be zero if MIN_EXP is changed after the this value was created.
            // This would cause a division by zero (x/t) and hence Infinity below, which would cause
            // coeffToString to throw.
            if (r.c[0]) {
                e = r.e;
                s = e + dp;
                if (s < 3) s = 0;
                // Newton-Raphson iteration.
                for(;;){
                    t = r;
                    r = half.times(t.plus(div(x, t, dp, 1)));
                    if (coeffToString(t.c).slice(0, s) === (n = coeffToString(r.c)).slice(0, s)) {
                        // The exponent of r may here be one less than the final result exponent,
                        // e.g 0.0009999 (e-4) --> 0.001 (e-3), so adjust s so the rounding digits
                        // are indexed correctly.
                        if (r.e < e) --s;
                        n = n.slice(s - 3, s + 1);
                        // The 4th rounding digit may be in error by -1 so if the 4 rounding digits
                        // are 9999 or 4999 (i.e. approaching a rounding boundary) continue the
                        // iteration.
                        if (n == "9999" || !rep && n == "4999") {
                            // On the first iteration only, check to see if rounding up gives the
                            // exact result as the nines may infinitely repeat.
                            if (!rep) {
                                round(t, t.e + DECIMAL_PLACES + 2, 0);
                                if (t.times(t).eq(x)) {
                                    r = t;
                                    break;
                                }
                            }
                            dp += 4;
                            s += 4;
                            rep = 1;
                        } else {
                            // If rounding digits are null, 0{0,4} or 50{0,3}, check for exact
                            // result. If not, then there are further digits and m will be truthy.
                            if (!+n || !+n.slice(1) && n.charAt(0) == "5") {
                                // Truncate to the first rounding digit.
                                round(r, r.e + DECIMAL_PLACES + 2, 1);
                                m = !r.times(r).eq(x);
                            }
                            break;
                        }
                    }
                }
            }
            return round(r, r.e + DECIMAL_PLACES + 1, ROUNDING_MODE, m);
        };
        /*
     * Return a string representing the value of this BigNumber in exponential notation and
     * rounded using ROUNDING_MODE to dp fixed decimal places.
     *
     * [dp] {number} Decimal places. Integer, 0 to MAX inclusive.
     * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
     *
     * '[BigNumber Error] Argument {not a primitive number|not an integer|out of range}: {dp|rm}'
     */ P.toExponential = function(dp, rm) {
            if (dp != null) {
                intCheck(dp, 0, MAX);
                dp++;
            }
            return format(this, dp, rm, 1);
        };
        /*
     * Return a string representing the value of this BigNumber in fixed-point notation rounding
     * to dp fixed decimal places using rounding mode rm, or ROUNDING_MODE if rm is omitted.
     *
     * Note: as with JavaScript's number type, (-0).toFixed(0) is '0',
     * but e.g. (-0.00001).toFixed(0) is '-0'.
     *
     * [dp] {number} Decimal places. Integer, 0 to MAX inclusive.
     * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
     *
     * '[BigNumber Error] Argument {not a primitive number|not an integer|out of range}: {dp|rm}'
     */ P.toFixed = function(dp, rm) {
            if (dp != null) {
                intCheck(dp, 0, MAX);
                dp = dp + this.e + 1;
            }
            return format(this, dp, rm);
        };
        /*
     * Return a string representing the value of this BigNumber in fixed-point notation rounded
     * using rm or ROUNDING_MODE to dp decimal places, and formatted according to the properties
     * of the format or FORMAT object (see BigNumber.set).
     *
     * The formatting object may contain some or all of the properties shown below.
     *
     * FORMAT = {
     *   prefix: '',
     *   groupSize: 3,
     *   secondaryGroupSize: 0,
     *   groupSeparator: ',',
     *   decimalSeparator: '.',
     *   fractionGroupSize: 0,
     *   fractionGroupSeparator: '\xA0',      // non-breaking space
     *   suffix: ''
     * };
     *
     * [dp] {number} Decimal places. Integer, 0 to MAX inclusive.
     * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
     * [format] {object} Formatting options. See FORMAT pbject above.
     *
     * '[BigNumber Error] Argument {not a primitive number|not an integer|out of range}: {dp|rm}'
     * '[BigNumber Error] Argument not an object: {format}'
     */ P.toFormat = function(dp, rm, format) {
            var str, x = this;
            if (format == null) {
                if (dp != null && rm && typeof rm == "object") {
                    format = rm;
                    rm = null;
                } else if (dp && typeof dp == "object") {
                    format = dp;
                    dp = rm = null;
                } else format = FORMAT;
            } else if (typeof format != "object") throw Error(bignumberError + "Argument not an object: " + format);
            str = x.toFixed(dp, rm);
            if (x.c) {
                var i, arr = str.split("."), g1 = +format.groupSize, g2 = +format.secondaryGroupSize, groupSeparator = format.groupSeparator || "", intPart = arr[0], fractionPart = arr[1], isNeg = x.s < 0, intDigits = isNeg ? intPart.slice(1) : intPart, len = intDigits.length;
                if (g2) {
                    i = g1;
                    g1 = g2;
                    g2 = i;
                    len -= i;
                }
                if (g1 > 0 && len > 0) {
                    i = len % g1 || g1;
                    intPart = intDigits.substr(0, i);
                    for(; i < len; i += g1)intPart += groupSeparator + intDigits.substr(i, g1);
                    if (g2 > 0) intPart += groupSeparator + intDigits.slice(i);
                    if (isNeg) intPart = "-" + intPart;
                }
                str = fractionPart ? intPart + (format.decimalSeparator || "") + ((g2 = +format.fractionGroupSize) ? fractionPart.replace(new RegExp("\\d{" + g2 + "}\\B", "g"), "$&" + (format.fractionGroupSeparator || "")) : fractionPart) : intPart;
            }
            return (format.prefix || "") + str + (format.suffix || "");
        };
        /*
     * Return an array of two BigNumbers representing the value of this BigNumber as a simple
     * fraction with an integer numerator and an integer denominator.
     * The denominator will be a positive non-zero value less than or equal to the specified
     * maximum denominator. If a maximum denominator is not specified, the denominator will be
     * the lowest value necessary to represent the number exactly.
     *
     * [md] {number|string|BigNumber} Integer >= 1, or Infinity. The maximum denominator.
     *
     * '[BigNumber Error] Argument {not an integer|out of range} : {md}'
     */ P.toFraction = function(md) {
            var d, d0, d1, d2, e, exp, n, n0, n1, q, r, s, x = this, xc = x.c;
            if (md != null) {
                n = new BigNumber(md);
                // Throw if md is less than one or is not an integer, unless it is Infinity.
                if (!n.isInteger() && (n.c || n.s !== 1) || n.lt(ONE)) throw Error(bignumberError + "Argument " + (n.isInteger() ? "out of range: " : "not an integer: ") + valueOf(n));
            }
            if (!xc) return new BigNumber(x);
            d = new BigNumber(ONE);
            n1 = d0 = new BigNumber(ONE);
            d1 = n0 = new BigNumber(ONE);
            s = coeffToString(xc);
            // Determine initial denominator.
            // d is a power of 10 and the minimum max denominator that specifies the value exactly.
            e = d.e = s.length - x.e - 1;
            d.c[0] = POWS_TEN[(exp = e % LOG_BASE) < 0 ? LOG_BASE + exp : exp];
            md = !md || n.comparedTo(d) > 0 ? e > 0 ? d : n1 : n;
            exp = MAX_EXP;
            MAX_EXP = 1 / 0;
            n = new BigNumber(s);
            // n0 = d1 = 0
            n0.c[0] = 0;
            for(;;){
                q = div(n, d, 0, 1);
                d2 = d0.plus(q.times(d1));
                if (d2.comparedTo(md) == 1) break;
                d0 = d1;
                d1 = d2;
                n1 = n0.plus(q.times(d2 = n1));
                n0 = d2;
                d = n.minus(q.times(d2 = d));
                n = d2;
            }
            d2 = div(md.minus(d0), d1, 0, 1);
            n0 = n0.plus(d2.times(n1));
            d0 = d0.plus(d2.times(d1));
            n0.s = n1.s = x.s;
            e = e * 2;
            // Determine which fraction is closer to x, n0/d0 or n1/d1
            r = div(n1, d1, e, ROUNDING_MODE).minus(x).abs().comparedTo(div(n0, d0, e, ROUNDING_MODE).minus(x).abs()) < 1 ? [
                n1,
                d1
            ] : [
                n0,
                d0
            ];
            MAX_EXP = exp;
            return r;
        };
        /*
     * Return the value of this BigNumber converted to a number primitive.
     */ P.toNumber = function() {
            return +valueOf(this);
        };
        /*
     * Return a string representing the value of this BigNumber rounded to sd significant digits
     * using rounding mode rm or ROUNDING_MODE. If sd is less than the number of digits
     * necessary to represent the integer part of the value in fixed-point notation, then use
     * exponential notation.
     *
     * [sd] {number} Significant digits. Integer, 1 to MAX inclusive.
     * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
     *
     * '[BigNumber Error] Argument {not a primitive number|not an integer|out of range}: {sd|rm}'
     */ P.toPrecision = function(sd, rm) {
            if (sd != null) intCheck(sd, 1, MAX);
            return format(this, sd, rm, 2);
        };
        /*
     * Return a string representing the value of this BigNumber in base b, or base 10 if b is
     * omitted. If a base is specified, including base 10, round according to DECIMAL_PLACES and
     * ROUNDING_MODE. If a base is not specified, and this BigNumber has a positive exponent
     * that is equal to or greater than TO_EXP_POS, or a negative exponent equal to or less than
     * TO_EXP_NEG, return exponential notation.
     *
     * [b] {number} Integer, 2 to ALPHABET.length inclusive.
     *
     * '[BigNumber Error] Base {not a primitive number|not an integer|out of range}: {b}'
     */ P.toString = function(b) {
            var str, n = this, s = n.s, e = n.e;
            // Infinity or NaN?
            if (e === null) {
                if (s) {
                    str = "Infinity";
                    if (s < 0) str = "-" + str;
                } else str = "NaN";
            } else {
                if (b == null) str = e <= TO_EXP_NEG || e >= TO_EXP_POS ? toExponential(coeffToString(n.c), e) : toFixedPoint(coeffToString(n.c), e, "0");
                else if (b === 10 && alphabetHasNormalDecimalDigits) {
                    n = round(new BigNumber(n), DECIMAL_PLACES + e + 1, ROUNDING_MODE);
                    str = toFixedPoint(coeffToString(n.c), n.e, "0");
                } else {
                    intCheck(b, 2, ALPHABET.length, "Base");
                    str = convertBase(toFixedPoint(coeffToString(n.c), e, "0"), 10, b, s, true);
                }
                if (s < 0 && n.c[0]) str = "-" + str;
            }
            return str;
        };
        /*
     * Return as toString, but do not accept a base argument, and include the minus sign for
     * negative zero.
     */ P.valueOf = P.toJSON = function() {
            return valueOf(this);
        };
        P._isBigNumber = true;
        if (configObject != null) BigNumber.set(configObject);
        return BigNumber;
    }
    // PRIVATE HELPER FUNCTIONS
    // These functions don't need access to variables,
    // e.g. DECIMAL_PLACES, in the scope of the `clone` function above.
    function bitFloor(n) {
        var i = n | 0;
        return n > 0 || n === i ? i : i - 1;
    }
    // Return a coefficient array as a string of base 10 digits.
    function coeffToString(a) {
        var s, z, i = 1, j = a.length, r = a[0] + "";
        for(; i < j;){
            s = a[i++] + "";
            z = LOG_BASE - s.length;
            for(; z--; s = "0" + s);
            r += s;
        }
        // Determine trailing zeros.
        for(j = r.length; r.charCodeAt(--j) === 48;);
        return r.slice(0, j + 1 || 1);
    }
    // Compare the value of BigNumbers x and y.
    function compare(x, y) {
        var a, b, xc = x.c, yc = y.c, i = x.s, j = y.s, k = x.e, l = y.e;
        // Either NaN?
        if (!i || !j) return null;
        a = xc && !xc[0];
        b = yc && !yc[0];
        // Either zero?
        if (a || b) return a ? b ? 0 : -j : i;
        // Signs differ?
        if (i != j) return i;
        a = i < 0;
        b = k == l;
        // Either Infinity?
        if (!xc || !yc) return b ? 0 : !xc ^ a ? 1 : -1;
        // Compare exponents.
        if (!b) return k > l ^ a ? 1 : -1;
        j = (k = xc.length) < (l = yc.length) ? k : l;
        // Compare digit by digit.
        for(i = 0; i < j; i++)if (xc[i] != yc[i]) return xc[i] > yc[i] ^ a ? 1 : -1;
        // Compare lengths.
        return k == l ? 0 : k > l ^ a ? 1 : -1;
    }
    /*
   * Check that n is a primitive number, an integer, and in range, otherwise throw.
   */ function intCheck(n, min, max, name) {
        if (n < min || n > max || n !== mathfloor(n)) throw Error(bignumberError + (name || "Argument") + (typeof n == "number" ? n < min || n > max ? " out of range: " : " not an integer: " : " not a primitive number: ") + String(n));
    }
    // Assumes finite n.
    function isOdd(n) {
        var k = n.c.length - 1;
        return bitFloor(n.e / LOG_BASE) == k && n.c[k] % 2 != 0;
    }
    function toExponential(str, e) {
        return (str.length > 1 ? str.charAt(0) + "." + str.slice(1) : str) + (e < 0 ? "e" : "e+") + e;
    }
    function toFixedPoint(str, e, z) {
        var len, zs;
        // Negative exponent?
        if (e < 0) {
            // Prepend zeros.
            for(zs = z + "."; ++e; zs += z);
            str = zs + str;
        // Positive exponent
        } else {
            len = str.length;
            // Append zeros.
            if (++e > len) {
                for(zs = z, e -= len; --e; zs += z);
                str += zs;
            } else if (e < len) str = str.slice(0, e) + "." + str.slice(e);
        }
        return str;
    }
    // EXPORT
    BigNumber = clone();
    BigNumber["default"] = BigNumber.BigNumber = BigNumber;
    // AMD.
    if (typeof define == "function" && define.amd) define(function() {
        return BigNumber;
    });
    else if (0, $cb01257a10e2963c$exports) $cb01257a10e2963c$exports = BigNumber;
    else {
        if (!globalObject) globalObject = typeof self != "undefined" && self ? self : window;
        globalObject.BigNumber = BigNumber;
    }
})($cb01257a10e2963c$exports);


function $d526951eb107ee9b$export$e772c8ff12451969(millis) {
    return new Promise((resolve)=>setTimeout(resolve, millis));
}
async function $d526951eb107ee9b$export$23b9643f4224bbcc(requestId, txId, rangoClient) {
    while(true){
        const approvalResponse = await rangoClient.isApproved(requestId, txId);
        if (approvalResponse.isApproved) return true;
        await $d526951eb107ee9b$export$e772c8ff12451969(3000);
    }
}
const $d526951eb107ee9b$export$46b96e2f030b662b = (amount)=>new (0, (/*@__PURE__*/$parcel$interopDefault($cb01257a10e2963c$exports)))(amount.amount).shiftedBy(-amount.decimals).toFixed();
const $d526951eb107ee9b$export$f67be9d9b0e25d7b = (number, minDecimals = null, maxDecimals = null)=>{
    if (number === null) return "";
    if (number === "") return "";
    const n = new (0, (/*@__PURE__*/$parcel$interopDefault($cb01257a10e2963c$exports)))(number);
    const roundingMode = 1;
    let maxI = 1000;
    for(let i = 0; i < 60; i++)if (new (0, (/*@__PURE__*/$parcel$interopDefault($cb01257a10e2963c$exports)))(n.toFixed(i, roundingMode)).eq(n)) {
        maxI = i;
        break;
    }
    if (n.gte(10000)) return n.toFormat(0, roundingMode);
    if (n.gte(1000)) return n.toFormat(Math.min(maxI, Math.min(maxDecimals || 100, Math.max(minDecimals || 0, 1))), roundingMode);
    if (n.gte(100)) return n.toFormat(Math.min(maxI, Math.min(maxDecimals || 100, Math.max(minDecimals || 0, 1))), roundingMode);
    if (n.gte(1)) return n.toFormat(Math.min(maxI, Math.min(maxDecimals || 100, Math.max(minDecimals || 0, 2))), roundingMode);
    if (n.gte(0.01)) return n.toFormat(Math.min(maxI, Math.min(maxDecimals || 100, Math.max(minDecimals || 0, 4))), roundingMode);
    for(let i = minDecimals || 4; i < 17; i++)if (n.gte(Math.pow(10, -i))) return n.toFormat(Math.min(maxI, Math.min(maxDecimals || 100, Math.max(minDecimals || 0, i))), roundingMode);
    if (n.isEqualTo(0)) return "0";
    return n.toFormat(Math.min(maxI, Math.min(maxDecimals || 100, Math.max(minDecimals || 0, 8))), roundingMode);
};
function $d526951eb107ee9b$export$8c4865a287ae7abb(balances, chain, symbol, address) {
    if (balances.length === 0) return null;
    const selectedChainBalances = balances.filter((balance)=>balance.blockChain === chain);
    if (selectedChainBalances.length === 0) return null;
    return selectedChainBalances.map((a)=>a.balances?.find((bl)=>address !== null && bl.asset.address === address || address === null && bl.asset.address === address && bl.asset.symbol === symbol) || null).filter((b)=>b !== null).sort((a, b)=>parseFloat(b?.amount.amount || "0") - parseFloat(a?.amount.amount || "1")).find(()=>true) || null;
}
const $d526951eb107ee9b$export$d3f528dec2c233d6 = (meta)=>{
    const { blockchains: blockchains, tokens: tokens } = meta;
    const defaultFromChain = "BSC";
    const defaultFromTokenAddress = "0x55d398326f99059ff775485246999027b3197955" // usdt in bsc
    ;
    const defaultToChain = "BSC";
    const defaultToTokenAddress = null // native
    ;
    const fromChain = blockchains.find((b)=>b.name === defaultFromChain);
    const toChain = blockchains.find((b)=>b.name === defaultToChain);
    const fromToken = tokens.find((t)=>t.blockchain === defaultFromChain && t.address === defaultFromTokenAddress);
    const toToken = tokens.find((t)=>t.blockchain === defaultToChain && t.address === defaultToTokenAddress);
    return {
        fromChain: fromChain,
        fromToken: fromToken,
        toChain: toChain,
        toToken: toToken
    };
};






var $bh6RR = parcelRequire("bh6RR");



const $7a4c24268b990927$var$Box = (0, $1d5571bdb4f0e237$export$3817b7a54a07cec7)("div", {
    padding: "$16",
    display: "flex",
    flexDirection: "column",
    width: "100%",
    textAlign: "left"
});
const $7a4c24268b990927$var$Container = (0, $1d5571bdb4f0e237$export$3817b7a54a07cec7)("div", {
    boxSizing: "border-box",
    backgroundColor: "$neutrals300",
    borderRadius: "$5",
    padding: "$8",
    display: "flex",
    width: "100%"
});
const $7a4c24268b990927$var$StyledImage = (0, $1d5571bdb4f0e237$export$3817b7a54a07cec7)("img", {
    width: "24px"
});
const $7a4c24268b990927$var$ImagePlaceholder = (0, $1d5571bdb4f0e237$export$3817b7a54a07cec7)("span", {
    width: "24px",
    height: "24px",
    backgroundColor: "$neutrals300",
    borderRadius: "99999px"
});
const $7a4c24268b990927$var$ZERO = new (0, (/*@__PURE__*/$parcel$interopDefault($cb01257a10e2963c$exports)))(0);
function $7a4c24268b990927$export$47d8a00fffa4e400(props) {
    const { type: type, chain: chain, token: token, loading: loading, blockchains: blockchains, tokens: tokens, setToken: setToken, setChain: setChain, amount: amount, setInputAmount: setInputAmount, balances: balances } = props;
    const [modal, setModal] = (0, $bh6RR.useState)({
        open: false,
        isChain: false,
        isToken: false
    });
    const tokenWithSelectedChain = tokens.filter((token)=>token.blockchain === chain?.name);
    const TokensWithBalance = tokenWithSelectedChain.map((token)=>{
        const balance = (0, $d526951eb107ee9b$export$8c4865a287ae7abb)(balances, token.blockchain, token.symbol, token.address);
        const amount = balance ? new (0, (/*@__PURE__*/$parcel$interopDefault($cb01257a10e2963c$exports)))(balance?.amount.amount).shiftedBy(-balance.amount.decimals).toFixed() : $7a4c24268b990927$var$ZERO;
        const tokenAmount = (0, $d526951eb107ee9b$export$f67be9d9b0e25d7b)(new (0, (/*@__PURE__*/$parcel$interopDefault($cb01257a10e2963c$exports)))(amount));
        let tokenUsdValue = "";
        if (token.usdPrice) tokenUsdValue = (0, $d526951eb107ee9b$export$f67be9d9b0e25d7b)(new (0, (/*@__PURE__*/$parcel$interopDefault($cb01257a10e2963c$exports)))(amount).multipliedBy(token.usdPrice));
        return {
            ...token,
            balance: {
                amount: tokenAmount !== "0" ? tokenAmount : "",
                usdValue: tokenUsdValue !== "0" ? tokenUsdValue : "",
                usdValueReal: new (0, (/*@__PURE__*/$parcel$interopDefault($cb01257a10e2963c$exports)))(amount || "0").multipliedBy(token.usdPrice || "0")
            }
        };
    }).toSorted((a, b)=>{
        return b.balance.usdValueReal.toNumber() - a.balance.usdValueReal.toNumber();
    });
    const onClose = ()=>setModal((prev)=>({
                ...prev,
                open: false
            }));
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)($7a4c24268b990927$var$Box, {
        children: [
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                className: "margin-bottom-5",
                children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $1d5571bdb4f0e237$export$1c6175f3aa4394b7), {
                    variant: "body2",
                    children: type
                })
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)($7a4c24268b990927$var$Container, {
                children: [
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $1d5571bdb4f0e237$export$353f5b6fc5456de1), {
                        variant: "outlined",
                        loading: loading,
                        prefix: chain ? /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)($7a4c24268b990927$var$StyledImage, {
                            src: chain.logo
                        }) : /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)($7a4c24268b990927$var$ImagePlaceholder, {}),
                        onClick: ()=>setModal((prev)=>({
                                    open: !prev.open,
                                    isChain: true,
                                    isToken: false
                                })),
                        suffix: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $1d5571bdb4f0e237$export$e45f9104ca1b1c90), {}),
                        align: "start",
                        size: "large",
                        style: {
                            marginRight: ".5rem"
                        },
                        children: chain ? chain.name : "Chain"
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $1d5571bdb4f0e237$export$353f5b6fc5456de1), {
                        variant: "outlined",
                        loading: loading,
                        disabled: !chain,
                        onClick: ()=>setModal((prev)=>({
                                    open: !prev.open,
                                    isChain: false,
                                    isToken: true
                                })),
                        prefix: token ? /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)($7a4c24268b990927$var$StyledImage, {
                            src: token.image
                        }) : /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)($7a4c24268b990927$var$ImagePlaceholder, {}),
                        suffix: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $1d5571bdb4f0e237$export$e45f9104ca1b1c90), {}),
                        size: "large",
                        align: "start",
                        style: {
                            marginRight: ".5rem"
                        },
                        children: token ? token.symbol : "Token"
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $1d5571bdb4f0e237$export$2c73285ae9390cec), {
                        type: "number",
                        onChange: (e)=>setInputAmount && setInputAmount(e.target.value),
                        disabled: type !== "From",
                        size: "large",
                        value: amount,
                        style: {
                            width: "70%",
                            position: "relative",
                            backgroundColor: "$background !important"
                        },
                        onResize: undefined,
                        onResizeCapture: undefined,
                        crossOrigin: undefined
                    })
                ]
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $1d5571bdb4f0e237$export$2b77a92f1a5ad772), {
                open: modal.open,
                onClose: onClose,
                content: modal.isChain ? /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $1d5571bdb4f0e237$export$fc99270a3593f270), {
                    list: blockchains,
                    hasHeader: false,
                    selected: chain,
                    onChange: (chain)=>{
                        setChain(chain);
                        onClose();
                    },
                    loadingStatus: "success",
                    listContainerStyle: {
                        height: "auto",
                        paddingBottom: 20
                    }
                }) : modal.isToken && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $1d5571bdb4f0e237$export$6f653acab4a8965a), {
                    loadingStatus: "success",
                    list: TokensWithBalance,
                    hasHeader: false,
                    onChange: (token)=>{
                        setToken(token);
                        onClose();
                    },
                    selected: token
                }),
                title: `Select ${type === "From" ? "Source" : "Destination"} Network`,
                containerStyle: {
                    width: "560px",
                    height: "625px"
                },
                contentStyle: {
                    overflowY: "hidden"
                }
            })
        ]
    });
}





var $bh6RR = parcelRequire("bh6RR");

function $7c4dd5fbb3e6bc41$export$c2a945e084c93396({ toToken: toToken, quote: quote, txStatus: txStatus }) {
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
        className: "swap-details",
        children: [
            quote && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                className: "green-text",
                children: [
                    quote.route?.swapper && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("img", {
                        src: quote.route?.swapper?.logo,
                        alt: "swapper logo",
                        width: 50
                    }),
                    " ",
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("br", {}),
                    quote.route?.swapper?.title
                ]
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("br", {}),
            quote && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("table", {
                    className: "border-collapse border",
                    style: {
                        overflowWrap: "anywhere"
                    },
                    children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("tbody", {
                        children: [
                            quote && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).Fragment, {
                                children: [
                                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("tr", {
                                        children: [
                                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("td", {
                                                children: "expected output"
                                            }),
                                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("td", {
                                                children: [
                                                    new (0, (/*@__PURE__*/$parcel$interopDefault($cb01257a10e2963c$exports)))(quote?.route?.outputAmount || "0").shiftedBy(-(toToken?.decimals || 0)).toString(),
                                                    " ",
                                                    toToken?.symbol
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("tr", {
                                        children: [
                                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("td", {
                                                children: "time estimate"
                                            }),
                                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("td", {
                                                children: [
                                                    quote.route?.estimatedTimeInSeconds,
                                                    "s"
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }),
                            txStatus && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).Fragment, {
                                children: [
                                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("tr", {
                                        children: [
                                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("td", {
                                                children: "status"
                                            }),
                                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("td", {
                                                children: txStatus.status || (0, $d1999c83d031453a$export$7c391bd3b61d2374).RUNNING
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("tr", {
                                        children: [
                                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("td", {
                                                children: "output"
                                            }),
                                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("td", {
                                                children: [
                                                    new (0, (/*@__PURE__*/$parcel$interopDefault($cb01257a10e2963c$exports)))(txStatus.output?.amount || "0").shiftedBy(-(toToken?.decimals || 0)).toString() || "?",
                                                    " ",
                                                    txStatus.output?.receivedToken?.symbol || "",
                                                    " ",
                                                    txStatus.output?.type || ""
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("tr", {
                                        children: [
                                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("td", {
                                                children: "error?"
                                            }),
                                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("td", {
                                                children: txStatus.error || "--"
                                            })
                                        ]
                                    }),
                                    txStatus.explorerUrl?.map((item, id)=>/*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("tr", {
                                            children: [
                                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("td", {
                                                    children: [
                                                        "explorer url [",
                                                        id,
                                                        "]"
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("td", {
                                                    children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("a", {
                                                        href: item.url,
                                                        target: "_blank",
                                                        children: item.description || "Tx Hash"
                                                    })
                                                })
                                            ]
                                        }, id)),
                                    !!txStatus.bridgeData && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).Fragment, {
                                        children: [
                                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("tr", {
                                                children: [
                                                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("td", {
                                                        children: "srcChainId"
                                                    }),
                                                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("td", {
                                                        children: txStatus.bridgeData.srcChainId
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("tr", {
                                                children: [
                                                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("td", {
                                                        children: "destChainId"
                                                    }),
                                                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("td", {
                                                        children: txStatus.bridgeData.destChainId
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("tr", {
                                                children: [
                                                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("td", {
                                                        children: "srcToken"
                                                    }),
                                                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("td", {
                                                        children: txStatus.bridgeData.srcToken
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("tr", {
                                                children: [
                                                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("td", {
                                                        children: "destToken"
                                                    }),
                                                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("td", {
                                                        children: txStatus.bridgeData.destToken
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("tr", {
                                                children: [
                                                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("td", {
                                                        children: "srcTokenAmt"
                                                    }),
                                                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("td", {
                                                        children: txStatus.bridgeData.srcTokenAmt
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("tr", {
                                                children: [
                                                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("td", {
                                                        children: "destTokenAmt"
                                                    }),
                                                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("td", {
                                                        children: txStatus.bridgeData.destTokenAmt
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("tr", {
                                                children: [
                                                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("td", {
                                                        children: "srcTxHash"
                                                    }),
                                                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("td", {
                                                        children: txStatus.bridgeData.srcTxHash
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("tr", {
                                                children: [
                                                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("td", {
                                                        children: "destTxHash"
                                                    }),
                                                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("td", {
                                                        children: txStatus.bridgeData.destTxHash
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                })
            })
        ]
    });
}









const $3cd59c4de9aae9b3$export$1ae07029cf56eda7 = (chainType)=>{
    if (chainType === (0, $d1999c83d031453a$export$d513b00599f845d4).EVM) return (0, $c7b1ddb572c90b38$export$b80cfa133c9c182d).META_MASK;
    else if (chainType === (0, $d1999c83d031453a$export$d513b00599f845d4).SOLANA) return (0, $c7b1ddb572c90b38$export$b80cfa133c9c182d).PHANTOM;
    else if (chainType === (0, $d1999c83d031453a$export$d513b00599f845d4).COSMOS) return (0, $c7b1ddb572c90b38$export$b80cfa133c9c182d).KEPLR;
    else if (chainType === (0, $d1999c83d031453a$export$d513b00599f845d4).TRANSFER) return (0, $c7b1ddb572c90b38$export$b80cfa133c9c182d).XDEFI;
    else return (0, $c7b1ddb572c90b38$export$b80cfa133c9c182d).TRON_LINK;
};
const $3cd59c4de9aae9b3$export$9533fb4898ec7c78 = (metamaskWalletState)=>{
    return metamaskWalletState.accounts?.[0]?.split(":")?.[1];
};
const $3cd59c4de9aae9b3$export$bfbb5df19a3849be = (phantomWalletState)=>{
    return phantomWalletState.accounts?.[0]?.split(":")?.[1];
};
const $3cd59c4de9aae9b3$export$bade4cfbe10153e7 = (chainName, keplrWalletState)=>{
    if (!chainName) return null;
    return keplrWalletState.accounts?.find((account)=>account.split(":")?.[0] === chainName)?.split(":")?.[1];
};
const $3cd59c4de9aae9b3$export$caf5e2aa75517dd4 = (chainName, xdefiWalletState)=>{
    if (!chainName) return null;
    return xdefiWalletState.accounts?.find((account)=>account.split(":")?.[0] === chainName)?.split(":")?.[1];
};
const $3cd59c4de9aae9b3$export$e2e4d887aee9f8ed = (tronLinkWalletState)=>{
    return tronLinkWalletState.accounts?.[0]?.split(":")?.[1];
};
const $3cd59c4de9aae9b3$export$1e969494be3e8b96 = async (meta, sdk, metamaskWalletState)=>{
    const promises = meta?.blockchains.filter((chain)=>chain.type === (0, $d1999c83d031453a$export$d513b00599f845d4).EVM).map((chain)=>sdk.balance({
            address: $3cd59c4de9aae9b3$export$9533fb4898ec7c78(metamaskWalletState) || "",
            blockchain: chain.name
        })) || [];
    const evmBalances = (await Promise.allSettled(promises)).flatMap((p)=>p.status === "fulfilled" ? p.value.wallets : []);
    return evmBalances;
};
const $3cd59c4de9aae9b3$export$96af114314ce5682 = async (meta, sdk, phantomWalletState)=>{
    const promises = meta?.blockchains.filter((chain)=>chain.type === (0, $d1999c83d031453a$export$d513b00599f845d4).SOLANA).map((chain)=>sdk.balance({
            address: $3cd59c4de9aae9b3$export$bfbb5df19a3849be(phantomWalletState) || "",
            blockchain: chain.name
        })) || [];
    const solanaBalances = (await Promise.allSettled(promises)).flatMap((p)=>p.status === "fulfilled" ? p.value.wallets : []);
    return solanaBalances;
};
const $3cd59c4de9aae9b3$export$4b0e2ddc1e01b276 = async (meta, sdk, keplrWalletState)=>{
    const promises = keplrWalletState.accounts?.map((account)=>sdk.balance({
            address: account?.split(":")?.[1] || "",
            blockchain: account?.split(":")?.[0] || ""
        })) || [];
    const cosmosBalances = (await Promise.allSettled(promises)).flatMap((p)=>p.status === "fulfilled" ? p.value.wallets : []);
    return cosmosBalances;
};
const $3cd59c4de9aae9b3$export$cf821449cb7c6f02 = async (meta, sdk, xdefiWalletState)=>{
    const transferChains = meta.blockchains.filter((blockchain)=>blockchain.type === (0, $d1999c83d031453a$export$d513b00599f845d4).TRANSFER);
    const promises = xdefiWalletState.accounts?.filter((account)=>!!transferChains.find((chain)=>chain.name === account?.split(":")?.[0])).map((account)=>sdk.balance({
            address: account?.split(":")?.[1] || "",
            blockchain: account?.split(":")?.[0] || ""
        })) || [];
    const transferBalances = (await Promise.allSettled(promises)).flatMap((p)=>p.status === "fulfilled" ? p.value.wallets : []);
    return transferBalances;
};
const $3cd59c4de9aae9b3$export$7c0fe06a6f5475b2 = async (meta, sdk, tronLinkWalletState)=>{
    const promises = meta?.blockchains.filter((chain)=>chain.type === (0, $d1999c83d031453a$export$d513b00599f845d4).TRON).map((chain)=>sdk.balance({
            address: $3cd59c4de9aae9b3$export$e2e4d887aee9f8ed(tronLinkWalletState) || "",
            blockchain: chain.name
        })) || [];
    const balances = (await Promise.allSettled(promises)).flatMap((p)=>p.status === "fulfilled" ? p.value.wallets : []);
    return balances;
};


const $d18aa4357aa8e2bd$var$SwapContent = ({ disabledLiquiditySources: disabledLiquiditySources, testMessagePassing: testMessagePassing, error: error, setError: setError })=>{
    const [fromChain, setFromChain] = (0, $bh6RR.useState)(null);
    const [fromToken, setFromToken] = (0, $bh6RR.useState)(null);
    const [toChain, setToChain] = (0, $bh6RR.useState)(null);
    const [toToken, setToToken] = (0, $bh6RR.useState)(null);
    const [inputAmount, setInputAmount] = (0, $bh6RR.useState)("100");
    const [quote, setQuote] = (0, $bh6RR.useState)();
    const [txStatus, setTxStatus] = (0, $bh6RR.useState)(null);
    const [loadingSwap, setLoadingSwap] = (0, $bh6RR.useState)(false);
    const [evmBalances, setEvmBalances] = (0, $bh6RR.useState)([]);
    const [cosmosBalances, setCosmosBalances] = (0, $bh6RR.useState)([]);
    const [solanaBalances, setSolanaBalances] = (0, $bh6RR.useState)([]);
    const [tronBalances, setTronBalances] = (0, $bh6RR.useState)([]);
    const [transferBalances, setTransferBalances] = (0, $bh6RR.useState)([]);
    const [shouldInitiateSwap, setShouldInitiateSwap] = (0, $bh6RR.useState)(false);
    const { sdk: sdk, enableCentralizedSwappers: enableCentralizedSwappers } = (0, $9617fc566a5b29a6$export$84144ee7888574a)();
    const { meta: meta, metaLoading: metaLoading } = (0, $4e4f1eb09c7daf7c$export$3fb9275d3845bd5a)();
    const { selectedProtocols: selectedProtocols } = (0, $664b7508f650ecf0$export$ed5191c2f06fff37)();
    const { state: state, getSigners: getSigners, connect: connect, providers: providers } = (0, $839aac193bf3ec6e$export$934951b5ed2ebf82)();
    const metamaskWalletState = state((0, $c7b1ddb572c90b38$export$b80cfa133c9c182d).META_MASK);
    const keplrWalletState = state((0, $c7b1ddb572c90b38$export$b80cfa133c9c182d).KEPLR);
    const phantomWalletState = state((0, $c7b1ddb572c90b38$export$b80cfa133c9c182d).PHANTOM);
    const tronLinkWalletState = state((0, $c7b1ddb572c90b38$export$b80cfa133c9c182d).TRON_LINK);
    const xdefiWalletState = state((0, $c7b1ddb572c90b38$export$b80cfa133c9c182d).XDEFI);
    (0, $bh6RR.useEffect)(()=>{
        if (meta) {
            const { fromChain: fromChain, fromToken: fromToken, toChain: toChain, toToken: toToken } = (0, $d526951eb107ee9b$export$d3f528dec2c233d6)(meta);
            setFromChain(fromChain || null);
            setToChain(toChain || null);
            setFromToken(fromToken || null);
            setToToken(toToken || null);
        }
    }, [
        meta
    ]);
    (0, $bh6RR.useEffect)(()=>{
        if (metamaskWalletState.connected && metamaskWalletState.accounts && meta) (0, $3cd59c4de9aae9b3$export$1e969494be3e8b96)(meta, sdk, metamaskWalletState).then((evmBalances)=>setEvmBalances(evmBalances));
    }, [
        metamaskWalletState.connected,
        metamaskWalletState.accounts
    ]);
    (0, $bh6RR.useEffect)(()=>{
        if (phantomWalletState.connected && phantomWalletState.accounts && meta) (0, $3cd59c4de9aae9b3$export$96af114314ce5682)(meta, sdk, phantomWalletState).then((solanaBalances)=>setSolanaBalances(solanaBalances));
    }, [
        phantomWalletState.connected,
        phantomWalletState.accounts
    ]);
    (0, $bh6RR.useEffect)(()=>{
        if (keplrWalletState.connected && keplrWalletState.accounts && meta) (0, $3cd59c4de9aae9b3$export$4b0e2ddc1e01b276)(meta, sdk, keplrWalletState).then((cosmosBalances)=>setCosmosBalances(cosmosBalances));
    }, [
        keplrWalletState.connected,
        keplrWalletState.accounts
    ]);
    (0, $bh6RR.useEffect)(()=>{
        if (tronLinkWalletState.connected && tronLinkWalletState.accounts && meta) (0, $3cd59c4de9aae9b3$export$7c0fe06a6f5475b2)(meta, sdk, tronLinkWalletState).then((tronBalances)=>setTronBalances(tronBalances));
    }, [
        tronLinkWalletState.connected,
        tronLinkWalletState.accounts
    ]);
    (0, $bh6RR.useEffect)(()=>{
        if (xdefiWalletState.connected && xdefiWalletState.accounts && meta) (0, $3cd59c4de9aae9b3$export$cf821449cb7c6f02)(meta, sdk, xdefiWalletState).then((transferBalances)=>setTransferBalances(transferBalances));
    }, [
        xdefiWalletState.connected,
        xdefiWalletState.accounts
    ]);
    (0, $bh6RR.useEffect)(()=>{
        if (shouldInitiateSwap) handleSwap();
    }, [
        shouldInitiateSwap
    ]);
    (0, $bh6RR.useEffect)(()=>{
        setFromToken(null);
    }, [
        fromChain
    ]);
    (0, $bh6RR.useEffect)(()=>{
        setToToken(null);
    }, [
        toChain
    ]);
    const handleSwitchFromAndTo = ()=>{
        setFromChain(toChain);
        setFromToken(toToken);
        setToChain(fromChain);
        setToToken(fromToken);
    };
    const getAddressByChain = (chain)=>{
        if (!chain) return null;
        console.log(chain);
        if (chain.type === (0, $d1999c83d031453a$export$d513b00599f845d4).EVM) return (0, $3cd59c4de9aae9b3$export$9533fb4898ec7c78)(metamaskWalletState);
        else if (chain.type === (0, $d1999c83d031453a$export$d513b00599f845d4).SOLANA) return (0, $3cd59c4de9aae9b3$export$bfbb5df19a3849be)(phantomWalletState);
        else if (chain.type === (0, $d1999c83d031453a$export$d513b00599f845d4).COSMOS) return (0, $3cd59c4de9aae9b3$export$bade4cfbe10153e7)(chain.name, keplrWalletState);
        else if (chain.type === (0, $d1999c83d031453a$export$d513b00599f845d4).TRANSFER) return (0, $3cd59c4de9aae9b3$export$caf5e2aa75517dd4)(chain.name, xdefiWalletState);
        else if (chain.type === (0, $d1999c83d031453a$export$d513b00599f845d4).TRON) return (0, $3cd59c4de9aae9b3$export$e2e4d887aee9f8ed)(tronLinkWalletState);
    };
    const tryConnectWallet = async (walletType)=>{
        try {
            await connect(walletType);
            return true;
        } catch (error) {
            console.log(error);
            return false;
        }
    };
    const getWalletFromChainType = (type)=>{
        switch(type){
            case (0, $d1999c83d031453a$export$d513b00599f845d4).EVM:
                return (0, $c7b1ddb572c90b38$export$b80cfa133c9c182d).META_MASK;
            case (0, $d1999c83d031453a$export$d513b00599f845d4).COSMOS:
                return (0, $c7b1ddb572c90b38$export$b80cfa133c9c182d).KEPLR;
            case (0, $d1999c83d031453a$export$d513b00599f845d4).SOLANA:
                return (0, $c7b1ddb572c90b38$export$b80cfa133c9c182d).PHANTOM;
            case (0, $d1999c83d031453a$export$d513b00599f845d4).TRANSFER:
                return (0, $c7b1ddb572c90b38$export$b80cfa133c9c182d).XDEFI;
            case (0, $d1999c83d031453a$export$d513b00599f845d4).TRON:
                return (0, $c7b1ddb572c90b38$export$b80cfa133c9c182d).TRON_LINK;
            default:
                return (0, $c7b1ddb572c90b38$export$b80cfa133c9c182d).META_MASK;
        }
    };
    const checkIsTypeWalletConnected = (type)=>type === (0, $d1999c83d031453a$export$d513b00599f845d4).EVM && metamaskWalletState.connected || type === (0, $d1999c83d031453a$export$d513b00599f845d4).COSMOS && keplrWalletState.connected || type === (0, $d1999c83d031453a$export$d513b00599f845d4).SOLANA && phantomWalletState.connected || type === (0, $d1999c83d031453a$export$d513b00599f845d4).TRANSFER && xdefiWalletState.connected || type === (0, $d1999c83d031453a$export$d513b00599f845d4).TRON && tronLinkWalletState.connected;
    const handleSwap = async ()=>{
        setError("");
        setQuote(null);
        setShouldInitiateSwap(false);
        if (!fromChain) {
            setError(`Please select source blockchain.`);
            return;
        }
        if (!fromToken) {
            setError(`Please select source token.`);
            return;
        }
        if (!toChain) {
            setError(`Please select destination blockchain.`);
            return;
        }
        if (!toToken) {
            setError(`Please select destination token.`);
            return;
        }
        if (!inputAmount) {
            setError("Set input amount");
            return;
        }
        const fromWalletIsConnected = checkIsTypeWalletConnected(fromChain?.type);
        if (!fromWalletIsConnected) {
            const fromWalletType = getWalletFromChainType(fromChain?.type);
            const result = await tryConnectWallet(fromWalletType);
            if (result) setShouldInitiateSwap(true);
            else setError(`Error connecting to ${fromWalletType}. Please check ${fromWalletType} and try again.`);
            return;
        }
        const ToWalletIsConnected = checkIsTypeWalletConnected(toChain?.type);
        if (!ToWalletIsConnected) {
            const toWalletType = getWalletFromChainType(toChain?.type);
            const result = await tryConnectWallet(toWalletType);
            if (result) setShouldInitiateSwap(true);
            else setError(`Error connecting to ${toWalletType}. Please check ${toWalletType} and try again.`);
            return;
        }
        if (fromChain?.type === (0, $d1999c83d031453a$export$d513b00599f845d4).EVM && fromChain?.chainId && parseInt(fromChain.chainId) !== parseInt(providers()[(0, $c7b1ddb572c90b38$export$b80cfa133c9c182d).META_MASK]?.chainId)) try {
            const provider = providers()[(0, $c7b1ddb572c90b38$export$b80cfa133c9c182d).META_MASK];
            await provider.send("wallet_switchEthereumChain", [
                {
                    chainId: `0x${Number(fromChain.chainId).toString(16)}`
                }
            ]);
            setShouldInitiateSwap(true);
            return;
        } catch (e) {
            setError(`Change meta mask network to '${fromChain?.name}'.`);
            return;
        }
        const fromAddress = getAddressByChain(fromChain);
        const toAddress = getAddressByChain(toChain);
        if (!fromAddress) {
            setError(`Could not get from wallet address.`);
            return;
        }
        if (!toAddress) {
            setError(`Could not get to wallet address.`);
            return;
        }
        const from = {
            blockchain: fromToken.blockchain,
            symbol: fromToken.symbol,
            address: fromToken.address
        };
        const to = {
            blockchain: toToken.blockchain,
            symbol: toToken.symbol,
            address: toToken.address
        };
        const amount = new (0, (/*@__PURE__*/$parcel$interopDefault($cb01257a10e2963c$exports)))(inputAmount).shiftedBy(fromToken?.decimals).toString();
        let request = {
            amount: amount,
            from: from,
            to: to,
            swapperGroups: disabledLiquiditySources,
            swappersGroupsExclude: true
        };
        if (testMessagePassing) request = {
            ...request,
            messagingProtocols: selectedProtocols,
            sourceContract: "???",
            destinationContract: "???"
        };
        if (enableCentralizedSwappers) request.enableCentralizedSwappers = true;
        setLoadingSwap(true);
        try {
            const quote = await sdk.quote(request);
            setQuote(quote);
            console.log({
                quoteResponse: quote
            });
            if (!quote || !quote?.route || quote.resultType !== (0, $d1999c83d031453a$export$9244fb3192b4c649).OK) {
                setError(`Invalid quote response: ${quote.resultType}, please try again.`);
                setLoadingSwap(false);
            } else await executeRoute(from, to, fromAddress, toAddress, amount);
        } catch (error) {
            setError(`Error requesting quote: ${error}`);
            setLoadingSwap(false);
        }
    };
    const executeRoute = async (from, to, fromAddress, toAddress, inputAmount)=>{
        if (!fromToken || !toToken || !fromChain || !toChain) return;
        const signer = getSigners((0, $3cd59c4de9aae9b3$export$1ae07029cf56eda7)(fromChain?.type)).getSigner(fromChain?.type);
        let swap = null;
        try {
            let swapRequest = {
                from: from,
                to: to,
                amount: inputAmount,
                fromAddress: fromAddress,
                toAddress: toAddress,
                disableEstimate: false,
                referrerAddress: null,
                referrerFee: null,
                slippage: "1.0",
                swapperGroups: disabledLiquiditySources,
                swappersGroupsExclude: true
            };
            if (enableCentralizedSwappers) swapRequest.enableCentralizedSwappers = true;
            if (testMessagePassing && fromChain.type === (0, $d1999c83d031453a$export$d513b00599f845d4).EVM) {
                const sampleImMessage = (0, $d76834e42ece13f7$exports).utils.defaultAbiCoder.encode([
                    "(address,address)"
                ], [
                    [
                        fromToken.address || "0x0000000000000000000000000000000000000000",
                        toAddress
                    ]
                ]);
                swapRequest = {
                    ...swapRequest,
                    messagingProtocols: selectedProtocols,
                    sourceContract: "???",
                    destinationContract: "???",
                    imMessage: sampleImMessage
                };
            }
            console.log({
                swapRequest: swapRequest
            });
            swap = await sdk.swap(swapRequest);
            console.log({
                swapResponse: swap
            });
            if (!!swap.error || swap.resultType !== (0, $d1999c83d031453a$export$9244fb3192b4c649).OK) {
                setError(`Error swapping, routing result: ${swap.resultType}, error: ${swap.error}`);
                setLoadingSwap(false);
                return;
            }
            if (fromChain.type === (0, $d1999c83d031453a$export$d513b00599f845d4).EVM) {
                const tx = swap.tx;
                if (tx) {
                    // if approve data is not null, it means approve needed, otherwise it's already approved.
                    if (!!tx?.approveData) {
                        // try to approve
                        const result = await signer.signAndSendTx({
                            type: (0, $d1999c83d031453a$export$d513b00599f845d4).EVM,
                            blockChain: tx.blockChain?.name,
                            isApprovalTx: !!tx.approveData,
                            from: tx.from,
                            to: !!tx.approveTo ? tx.approveTo : tx.txTo,
                            data: !!tx.approveData ? tx.approveData : tx.txData,
                            value: tx.value,
                            nonce: null,
                            gasLimit: tx.gasLimit,
                            gasPrice: tx.gasPrice,
                            maxPriorityFeePerGas: tx.maxPriorityFeePerGas,
                            maxFeePerGas: tx.maxFeePerGas
                        }, fromAddress, fromChain.chainId);
                        await (0, $d526951eb107ee9b$export$23b9643f4224bbcc)(swap.requestId, result.hash, sdk);
                        console.log("transaction approved successfully");
                    }
                    const result = await signer.signAndSendTx({
                        type: (0, $d1999c83d031453a$export$d513b00599f845d4).EVM,
                        blockChain: tx.blockChain?.name,
                        isApprovalTx: !!tx.approveData,
                        from: tx.from,
                        to: tx.txTo,
                        data: tx.txData,
                        value: tx.value,
                        nonce: null,
                        gasLimit: tx.gasLimit,
                        gasPrice: tx.gasPrice,
                        maxPriorityFeePerGas: tx.maxPriorityFeePerGas,
                        maxFeePerGas: tx.maxFeePerGas
                    }, fromAddress, fromChain.chainId);
                    const txStatus = await checkTransactionStatusSync(swap.requestId, result.hash, sdk);
                    console.log("transaction finished", {
                        txStatus: txStatus
                    });
                    console.log("bridged data?", txStatus.bridgeData);
                }
            } else {
                const tx = swap.tx;
                const result = await signer.signAndSendTx(tx, fromAddress, fromChain.chainId);
                const txStatus = await checkTransactionStatusSync(swap.requestId, result.hash, sdk);
                console.log("transaction finished", {
                    txStatus: txStatus
                });
                console.log("bridged data?", txStatus.bridgeData);
            }
            setLoadingSwap(false);
        } catch (e) {
            const rawMessage = JSON.stringify(e).substring(0, 90) + "...";
            setLoadingSwap(false);
            setError(rawMessage);
            // report transaction failure to server if something went wrong in client for signing and sending the transaction
            if (!!swap) await sdk.reportFailure({
                data: {
                    message: rawMessage
                },
                eventType: "SEND_TX_FAILED",
                requestId: swap.requestId
            });
        }
    };
    const checkTransactionStatusSync = async (requestId, txHash, rangoClient)=>{
        while(true){
            const txStatus = await rangoClient.status({
                requestId: requestId,
                txId: txHash
            }).catch((error)=>{
                console.log(error);
            });
            if (!!txStatus) {
                setTxStatus(txStatus);
                console.log({
                    txStatus: txStatus
                });
                console.log(txStatus.bridgeData?.destTokenPrice, txStatus.bridgeData?.srcTokenPrice);
                if (!!txStatus.status && [
                    (0, $d1999c83d031453a$export$7c391bd3b61d2374).FAILED,
                    (0, $d1999c83d031453a$export$7c391bd3b61d2374).SUCCESS
                ].includes(txStatus.status)) return txStatus;
            }
            await (0, $d526951eb107ee9b$export$e772c8ff12451969)(3000);
        }
    };
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $d4dab640dcbe486c$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $7a4c24268b990927$export$47d8a00fffa4e400), {
                type: "From",
                chain: fromChain,
                setToken: setFromToken,
                setChain: setFromChain,
                token: fromToken,
                loading: metaLoading,
                setInputAmount: setInputAmount,
                amount: inputAmount,
                balances: [
                    ...evmBalances,
                    ...solanaBalances,
                    ...cosmosBalances,
                    ...tronBalances,
                    ...transferBalances
                ],
                blockchains: meta?.blockchains || [],
                tokens: meta?.tokens || []
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                className: "switch-button-container",
                children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $1d5571bdb4f0e237$export$353f5b6fc5456de1), {
                    variant: "ghost",
                    onClick: handleSwitchFromAndTo,
                    children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $1d5571bdb4f0e237$export$bb0b1c2acef02dfc), {
                        size: 36
                    })
                })
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $7a4c24268b990927$export$47d8a00fffa4e400), {
                chain: toChain,
                balances: [
                    ...evmBalances,
                    ...solanaBalances,
                    ...cosmosBalances,
                    ...tronBalances,
                    ...transferBalances
                ],
                token: toToken,
                setToken: setToToken,
                setChain: setToChain,
                type: "To",
                blockchains: meta?.blockchains || [],
                tokens: meta?.tokens || [],
                loading: metaLoading,
                amount: new (0, (/*@__PURE__*/$parcel$interopDefault($cb01257a10e2963c$exports)))(quote?.route?.outputAmount || "").shiftedBy(-(toToken?.decimals || 0)).toString()
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                className: "swap-details-container",
                children: [
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $7c4dd5fbb3e6bc41$export$c2a945e084c93396), {
                        quote: quote || null,
                        toToken: toToken,
                        txStatus: txStatus
                    }),
                    !!error && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                        className: "error-message",
                        children: error
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("br", {}),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $1d5571bdb4f0e237$export$353f5b6fc5456de1), {
                        style: {
                            width: "92%"
                        },
                        onClick: handleSwap,
                        loading: loadingSwap,
                        type: "primary",
                        children: "Swap"
                    })
                ]
            })
        ]
    });
};
var $d18aa4357aa8e2bd$export$2e2bcd8739ae039 = $d18aa4357aa8e2bd$var$SwapContent;


var $83733624b31e4130$export$2e2bcd8739ae039 = (0, $d18aa4357aa8e2bd$export$2e2bcd8739ae039);



const $16e924f086a574be$export$86fbec116b87613f = ()=>{
    const { meta: meta, metaLoading: metaLoading } = (0, $4e4f1eb09c7daf7c$export$3fb9275d3845bd5a)();
    const { loadingProtocols: loadingProtocols } = (0, $664b7508f650ecf0$export$ed5191c2f06fff37)();
    const [disabledLiquiditySources, setDisabledLiquiditySources] = (0, $bh6RR.useState)([]);
    const [testMessagePassing, setTestMessagePassing] = (0, $bh6RR.useState)(false);
    const [error, setError] = (0, $bh6RR.useState)("");
    const [messagingProtocolsModalOpen, setMessagingProtocolsModalOpen] = (0, $bh6RR.useState)(false);
    const [liquiditySourcesModalOpen, setLiquiditySourcesModalOpen] = (0, $bh6RR.useState)(false);
    const { enableCentralizedSwappers: enableCentralizedSwappers, toggleEnableCentralizedSwappers: toggleEnableCentralizedSwappers } = (0, $9617fc566a5b29a6$export$84144ee7888574a)();
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $839aac193bf3ec6e$export$2881499e37b75b9a), {
        providers: [
            $f5669291906fba67$exports,
            $4ececec3958d7516$exports,
            $8702f288516fd747$exports,
            $1b7a54a36665fb13$exports,
            $bf12e64f553d2fc9$exports
        ],
        allBlockChains: meta?.blockchains || [],
        children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $664b7508f650ecf0$export$a90fea0367980e1), {
            children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("main", {
                className: "container",
                children: [
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                        className: "main-content",
                        children: [
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $7daa731229dfa725$export$2e2bcd8739ae039), {}),
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $1d5571bdb4f0e237$export$d7a54cba636a8cd6), {
                                size: 16,
                                direction: "vertical"
                            }),
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $807f1d8dbc170f5a$export$2e2bcd8739ae039), {}),
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $1d5571bdb4f0e237$export$d7a54cba636a8cd6), {
                                size: 16,
                                direction: "vertical"
                            }),
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                                className: "row",
                                children: [
                                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $1d5571bdb4f0e237$export$353f5b6fc5456de1), {
                                        loading: metaLoading,
                                        variant: "outlined",
                                        type: "primary",
                                        size: "small",
                                        onClick: ()=>setLiquiditySourcesModalOpen(true),
                                        children: "Liquidity Sources"
                                    }),
                                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $1d5571bdb4f0e237$export$d7a54cba636a8cd6), {}),
                                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $1d5571bdb4f0e237$export$353f5b6fc5456de1), {
                                        size: "small",
                                        onClick: ()=>setMessagingProtocolsModalOpen(true),
                                        variant: "outlined",
                                        type: "primary",
                                        loading: loadingProtocols,
                                        children: "Messaging Protocols"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $1d5571bdb4f0e237$export$d7a54cba636a8cd6), {
                                size: 16,
                                direction: "vertical"
                            }),
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                                className: "row",
                                children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $1d5571bdb4f0e237$export$353f5b6fc5456de1), {
                                    variant: "outlined",
                                    size: "small",
                                    type: "primary",
                                    suffix: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $1d5571bdb4f0e237$export$b5d5cf8927ab7262), {
                                        checked: testMessagePassing
                                    }),
                                    onClick: ()=>setTestMessagePassing((prev)=>!prev),
                                    children: "Test Message Passing"
                                })
                            }),
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $1d5571bdb4f0e237$export$d7a54cba636a8cd6), {
                                size: 16,
                                direction: "vertical"
                            }),
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("div", {
                                className: "row",
                                children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $1d5571bdb4f0e237$export$353f5b6fc5456de1), {
                                    variant: "outlined",
                                    size: "small",
                                    type: "primary",
                                    suffix: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $1d5571bdb4f0e237$export$b5d5cf8927ab7262), {
                                        checked: enableCentralizedSwappers
                                    }),
                                    onClick: toggleEnableCentralizedSwappers,
                                    children: "Enabled Central Swappers"
                                })
                            }),
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $1d5571bdb4f0e237$export$d7a54cba636a8cd6), {
                                size: 16,
                                direction: "vertical"
                            }),
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $de70f7ef5323a11a$export$2e2bcd8739ae039), {
                                        title: "Metamask",
                                        type: (0, $c7b1ddb572c90b38$export$b80cfa133c9c182d).META_MASK,
                                        setError: setError
                                    }),
                                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $1d5571bdb4f0e237$export$d7a54cba636a8cd6), {
                                        direction: "vertical"
                                    }),
                                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $de70f7ef5323a11a$export$2e2bcd8739ae039), {
                                        title: "Keplr",
                                        type: (0, $c7b1ddb572c90b38$export$b80cfa133c9c182d).KEPLR,
                                        setError: setError
                                    }),
                                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $1d5571bdb4f0e237$export$d7a54cba636a8cd6), {
                                        direction: "vertical"
                                    }),
                                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $de70f7ef5323a11a$export$2e2bcd8739ae039), {
                                        title: "Phantom",
                                        type: (0, $c7b1ddb572c90b38$export$b80cfa133c9c182d).PHANTOM,
                                        setError: setError
                                    }),
                                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $1d5571bdb4f0e237$export$d7a54cba636a8cd6), {
                                        direction: "vertical"
                                    }),
                                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $de70f7ef5323a11a$export$2e2bcd8739ae039), {
                                        title: "XDefi",
                                        type: (0, $c7b1ddb572c90b38$export$b80cfa133c9c182d).XDEFI,
                                        setError: setError
                                    }),
                                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $1d5571bdb4f0e237$export$d7a54cba636a8cd6), {
                                        direction: "vertical"
                                    }),
                                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $de70f7ef5323a11a$export$2e2bcd8739ae039), {
                                        title: "Tron Link",
                                        type: (0, $c7b1ddb572c90b38$export$b80cfa133c9c182d).TRON_LINK,
                                        setError: setError
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $1d5571bdb4f0e237$export$d7a54cba636a8cd6), {
                                size: 16,
                                direction: "vertical"
                            }),
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $83733624b31e4130$export$2e2bcd8739ae039), {
                                disabledLiquiditySources: disabledLiquiditySources,
                                testMessagePassing: testMessagePassing,
                                error: error,
                                setError: setError
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $fb56ab8296428c59$export$2e2bcd8739ae039), {
                        open: messagingProtocolsModalOpen,
                        handleClose: ()=>setMessagingProtocolsModalOpen(false)
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $dc143425db30361b$export$2e2bcd8739ae039), {
                        open: liquiditySourcesModalOpen,
                        handleClose: ()=>setLiquiditySourcesModalOpen(false),
                        disabledLiquiditySources: disabledLiquiditySources,
                        setDisabledLiquiditySources: setDisabledLiquiditySources
                    })
                ]
            })
        })
    });
};
var $16e924f086a574be$export$2e2bcd8739ae039 = $16e924f086a574be$export$86fbec116b87613f;





(0, (/*@__PURE__*/$parcel$interopDefault($47cfd4084854a574$exports))).render(/*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).StrictMode, {
    children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $9617fc566a5b29a6$export$1b17d8c9e4be3776), {
        children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $4e4f1eb09c7daf7c$export$3d88e5d350ac07d9), {
            children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $664b7508f650ecf0$export$a90fea0367980e1), {
                children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $16e924f086a574be$export$2e2bcd8739ae039), {})
            })
        })
    })
}), document.getElementById("root"));


//# sourceMappingURL=index.f83b21d1.js.map
